(function () {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
function $parcel$extendImportMap(map) {
  Object.assign(parcelRequire.i ??= {}, map);
}

var $parcel$bundleURL;
function $parcel$resolve(url) {
  url = parcelRequire.i?.[url] || url;
  if (!$parcel$bundleURL) {
    try {
      throw new Error();
    } catch (err) {
      var matches = ('' + err.stack).match(
        /(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^)\n]+/g,
      );
      if (matches) {
        $parcel$bundleURL = matches[0];
      } else {
        return $parcel$distDir + url;
      }
    }
  }
  return new URL($parcel$distDir + url, $parcel$bundleURL).toString();
}
var $parcel$distDir = "./";

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire3a11"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire3a11"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("bXSnP", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

var $6tOPT = parcelRequire("6tOPT");

var $dKiQF = parcelRequire("dKiQF");
var $8b5f63c88e782ea3$var$getOwnPropertyDescriptors = Object.getOwnPropertyDescriptors || function getOwnPropertyDescriptors(obj) {
    var keys = Object.keys(obj);
    var descriptors = {};
    for(var i = 0; i < keys.length; i++)descriptors[keys[i]] = Object.getOwnPropertyDescriptor(obj, keys[i]);
    return descriptors;
};
var $8b5f63c88e782ea3$var$formatRegExp = /%[sdj%]/g;
module.exports.format = function(f) {
    if (!$8b5f63c88e782ea3$var$isString(f)) {
        var objects = [];
        for(var i = 0; i < arguments.length; i++)objects.push($8b5f63c88e782ea3$var$inspect(arguments[i]));
        return objects.join(' ');
    }
    var i = 1;
    var args = arguments;
    var len = args.length;
    var str = String(f).replace($8b5f63c88e782ea3$var$formatRegExp, function(x) {
        if (x === '%%') return '%';
        if (i >= len) return x;
        switch(x){
            case '%s':
                return String(args[i++]);
            case '%d':
                return Number(args[i++]);
            case '%j':
                try {
                    return JSON.stringify(args[i++]);
                } catch (_) {
                    return '[Circular]';
                }
            default:
                return x;
        }
    });
    for(var x = args[i]; i < len; x = args[++i])if ($8b5f63c88e782ea3$var$isNull(x) || !$8b5f63c88e782ea3$var$isObject(x)) str += ' ' + x;
    else str += ' ' + $8b5f63c88e782ea3$var$inspect(x);
    return str;
};
// Mark that a method should not be used.
// Returns a modified function which warns once by default.
// If --no-deprecation is set, then it is a no-op.
module.exports.deprecate = function(fn, msg) {
    var warned;
    return function() {
        return module.exports.deprecate(fn, msg).apply(this, arguments);
    };
    function deprecated() {
        if (!warned) {
            if ($dKiQF.throwDeprecation) throw new Error(msg);
            else if ($dKiQF.traceDeprecation) console.trace(msg);
            else console.error(msg);
            warned = true;
        }
        return fn.apply(this, arguments);
    }
};
var $8b5f63c88e782ea3$var$debugs = {};
var $8b5f63c88e782ea3$var$debugEnvRegex = /^$/;
var $8b5f63c88e782ea3$var$debugEnv;
module.exports.debuglog = function(set) {
    set = set.toUpperCase();
    if (!$8b5f63c88e782ea3$var$debugs[set]) {
        if ($8b5f63c88e782ea3$var$debugEnvRegex.test(set)) {
            var pid = $dKiQF.pid;
            $8b5f63c88e782ea3$var$debugs[set] = function() {
                var msg = module.exports.format.apply(module.exports, arguments);
                console.error('%s %d: %s', set, pid, msg);
            };
        } else $8b5f63c88e782ea3$var$debugs[set] = function() {};
    }
    return $8b5f63c88e782ea3$var$debugs[set];
};
/**
 * Echos the value of a value. Trys to print the value out
 * in the best way possible given the different types.
 *
 * @param {Object} obj The object to print out.
 * @param {Object} opts Optional options object that alters the output.
 */ /* legacy: obj, showHidden, depth, colors*/ function $8b5f63c88e782ea3$var$inspect(obj, opts) {
    // default options
    var ctx = {
        seen: [],
        stylize: $8b5f63c88e782ea3$var$stylizeNoColor
    };
    // legacy...
    if (arguments.length >= 3) ctx.depth = arguments[2];
    if (arguments.length >= 4) ctx.colors = arguments[3];
    if ($8b5f63c88e782ea3$var$isBoolean(opts)) // legacy...
    ctx.showHidden = opts;
    else if (opts) // got an "options" object
    module.exports._extend(ctx, opts);
    // set default options
    if ($8b5f63c88e782ea3$var$isUndefined(ctx.showHidden)) ctx.showHidden = false;
    if ($8b5f63c88e782ea3$var$isUndefined(ctx.depth)) ctx.depth = 2;
    if ($8b5f63c88e782ea3$var$isUndefined(ctx.colors)) ctx.colors = false;
    if ($8b5f63c88e782ea3$var$isUndefined(ctx.customInspect)) ctx.customInspect = true;
    if (ctx.colors) ctx.stylize = $8b5f63c88e782ea3$var$stylizeWithColor;
    return $8b5f63c88e782ea3$var$formatValue(ctx, obj, ctx.depth);
}
module.exports.inspect = $8b5f63c88e782ea3$var$inspect;
// http://en.wikipedia.org/wiki/ANSI_escape_code#graphics
$8b5f63c88e782ea3$var$inspect.colors = {
    'bold': [
        1,
        22
    ],
    'italic': [
        3,
        23
    ],
    'underline': [
        4,
        24
    ],
    'inverse': [
        7,
        27
    ],
    'white': [
        37,
        39
    ],
    'grey': [
        90,
        39
    ],
    'black': [
        30,
        39
    ],
    'blue': [
        34,
        39
    ],
    'cyan': [
        36,
        39
    ],
    'green': [
        32,
        39
    ],
    'magenta': [
        35,
        39
    ],
    'red': [
        31,
        39
    ],
    'yellow': [
        33,
        39
    ]
};
// Don't use 'blue' not visible on cmd.exe
$8b5f63c88e782ea3$var$inspect.styles = {
    'special': 'cyan',
    'number': 'yellow',
    'boolean': 'yellow',
    'undefined': 'grey',
    'null': 'bold',
    'string': 'green',
    'date': 'magenta',
    // "name": intentionally not styling
    'regexp': 'red'
};
function $8b5f63c88e782ea3$var$stylizeWithColor(str, styleType) {
    var style = $8b5f63c88e782ea3$var$inspect.styles[styleType];
    if (style) return '\u001b[' + $8b5f63c88e782ea3$var$inspect.colors[style][0] + 'm' + str + '\u001b[' + $8b5f63c88e782ea3$var$inspect.colors[style][1] + 'm';
    else return str;
}
function $8b5f63c88e782ea3$var$stylizeNoColor(str, styleType) {
    return str;
}
function $8b5f63c88e782ea3$var$arrayToHash(array) {
    var hash = {};
    array.forEach(function(val, idx) {
        hash[val] = true;
    });
    return hash;
}
function $8b5f63c88e782ea3$var$formatValue(ctx, value, recurseTimes) {
    // Provide a hook for user-specified inspect functions.
    // Check that value is an object with an inspect function on it
    if (ctx.customInspect && value && $8b5f63c88e782ea3$var$isFunction(value.inspect) && // Filter out the util module, it's inspect function is special
    value.inspect !== module.exports.inspect && // Also filter out any prototype objects using the circular check.
    !(value.constructor && value.constructor.prototype === value)) {
        var ret = value.inspect(recurseTimes, ctx);
        if (!$8b5f63c88e782ea3$var$isString(ret)) ret = $8b5f63c88e782ea3$var$formatValue(ctx, ret, recurseTimes);
        return ret;
    }
    // Primitive types cannot have properties
    var primitive = $8b5f63c88e782ea3$var$formatPrimitive(ctx, value);
    if (primitive) return primitive;
    // Look up the keys of the object.
    var keys = Object.keys(value);
    var visibleKeys = $8b5f63c88e782ea3$var$arrayToHash(keys);
    if (ctx.showHidden) keys = Object.getOwnPropertyNames(value);
    // IE doesn't make error fields non-enumerable
    // http://msdn.microsoft.com/en-us/library/ie/dww52sbt(v=vs.94).aspx
    if ($8b5f63c88e782ea3$var$isError(value) && (keys.indexOf('message') >= 0 || keys.indexOf('description') >= 0)) return $8b5f63c88e782ea3$var$formatError(value);
    // Some type of object without properties can be shortcutted.
    if (keys.length === 0) {
        if ($8b5f63c88e782ea3$var$isFunction(value)) {
            var name = value.name ? ': ' + value.name : '';
            return ctx.stylize('[Function' + name + ']', 'special');
        }
        if ($8b5f63c88e782ea3$var$isRegExp(value)) return ctx.stylize(RegExp.prototype.toString.call(value), 'regexp');
        if ($8b5f63c88e782ea3$var$isDate(value)) return ctx.stylize(Date.prototype.toString.call(value), 'date');
        if ($8b5f63c88e782ea3$var$isError(value)) return $8b5f63c88e782ea3$var$formatError(value);
    }
    var base = '', array = false, braces = [
        '{',
        '}'
    ];
    // Make Array say that they are Array
    if ($8b5f63c88e782ea3$var$isArray(value)) {
        array = true;
        braces = [
            '[',
            ']'
        ];
    }
    // Make functions say that they are functions
    if ($8b5f63c88e782ea3$var$isFunction(value)) {
        var n = value.name ? ': ' + value.name : '';
        base = ' [Function' + n + ']';
    }
    // Make RegExps say that they are RegExps
    if ($8b5f63c88e782ea3$var$isRegExp(value)) base = ' ' + RegExp.prototype.toString.call(value);
    // Make dates with properties first say the date
    if ($8b5f63c88e782ea3$var$isDate(value)) base = ' ' + Date.prototype.toUTCString.call(value);
    // Make error with message first say the error
    if ($8b5f63c88e782ea3$var$isError(value)) base = ' ' + $8b5f63c88e782ea3$var$formatError(value);
    if (keys.length === 0 && (!array || value.length == 0)) return braces[0] + base + braces[1];
    if (recurseTimes < 0) {
        if ($8b5f63c88e782ea3$var$isRegExp(value)) return ctx.stylize(RegExp.prototype.toString.call(value), 'regexp');
        else return ctx.stylize('[Object]', 'special');
    }
    ctx.seen.push(value);
    var output;
    if (array) output = $8b5f63c88e782ea3$var$formatArray(ctx, value, recurseTimes, visibleKeys, keys);
    else output = keys.map(function(key) {
        return $8b5f63c88e782ea3$var$formatProperty(ctx, value, recurseTimes, visibleKeys, key, array);
    });
    ctx.seen.pop();
    return $8b5f63c88e782ea3$var$reduceToSingleString(output, base, braces);
}
function $8b5f63c88e782ea3$var$formatPrimitive(ctx, value) {
    if ($8b5f63c88e782ea3$var$isUndefined(value)) return ctx.stylize('undefined', 'undefined');
    if ($8b5f63c88e782ea3$var$isString(value)) {
        var simple = '\'' + JSON.stringify(value).replace(/^"|"$/g, '').replace(/'/g, "\\'").replace(/\\"/g, '"') + '\'';
        return ctx.stylize(simple, 'string');
    }
    if ($8b5f63c88e782ea3$var$isNumber(value)) return ctx.stylize('' + value, 'number');
    if ($8b5f63c88e782ea3$var$isBoolean(value)) return ctx.stylize('' + value, 'boolean');
    // For some reason typeof null is "object", so special case here.
    if ($8b5f63c88e782ea3$var$isNull(value)) return ctx.stylize('null', 'null');
}
function $8b5f63c88e782ea3$var$formatError(value) {
    return '[' + Error.prototype.toString.call(value) + ']';
}
function $8b5f63c88e782ea3$var$formatArray(ctx, value, recurseTimes, visibleKeys, keys) {
    var output = [];
    for(var i = 0, l = value.length; i < l; ++i)if ($8b5f63c88e782ea3$var$hasOwnProperty(value, String(i))) output.push($8b5f63c88e782ea3$var$formatProperty(ctx, value, recurseTimes, visibleKeys, String(i), true));
    else output.push('');
    keys.forEach(function(key) {
        if (!key.match(/^\d+$/)) output.push($8b5f63c88e782ea3$var$formatProperty(ctx, value, recurseTimes, visibleKeys, key, true));
    });
    return output;
}
function $8b5f63c88e782ea3$var$formatProperty(ctx, value, recurseTimes, visibleKeys, key, array) {
    var name, str, desc;
    desc = Object.getOwnPropertyDescriptor(value, key) || {
        value: value[key]
    };
    if (desc.get) {
        if (desc.set) str = ctx.stylize('[Getter/Setter]', 'special');
        else str = ctx.stylize('[Getter]', 'special');
    } else if (desc.set) str = ctx.stylize('[Setter]', 'special');
    if (!$8b5f63c88e782ea3$var$hasOwnProperty(visibleKeys, key)) name = '[' + key + ']';
    if (!str) {
        if (ctx.seen.indexOf(desc.value) < 0) {
            if ($8b5f63c88e782ea3$var$isNull(recurseTimes)) str = $8b5f63c88e782ea3$var$formatValue(ctx, desc.value, null);
            else str = $8b5f63c88e782ea3$var$formatValue(ctx, desc.value, recurseTimes - 1);
            if (str.indexOf('\n') > -1) {
                if (array) str = str.split('\n').map(function(line) {
                    return '  ' + line;
                }).join('\n').slice(2);
                else str = '\n' + str.split('\n').map(function(line) {
                    return '   ' + line;
                }).join('\n');
            }
        } else str = ctx.stylize('[Circular]', 'special');
    }
    if ($8b5f63c88e782ea3$var$isUndefined(name)) {
        if (array && key.match(/^\d+$/)) return str;
        name = JSON.stringify('' + key);
        if (name.match(/^"([a-zA-Z_][a-zA-Z_0-9]*)"$/)) {
            name = name.slice(1, -1);
            name = ctx.stylize(name, 'name');
        } else {
            name = name.replace(/'/g, "\\'").replace(/\\"/g, '"').replace(/(^"|"$)/g, "'");
            name = ctx.stylize(name, 'string');
        }
    }
    return name + ': ' + str;
}
function $8b5f63c88e782ea3$var$reduceToSingleString(output, base, braces) {
    var numLinesEst = 0;
    var length = output.reduce(function(prev, cur) {
        numLinesEst++;
        if (cur.indexOf('\n') >= 0) numLinesEst++;
        return prev + cur.replace(/\u001b\[\d\d?m/g, '').length + 1;
    }, 0);
    if (length > 60) return braces[0] + (base === '' ? '' : base + '\n ') + ' ' + output.join(',\n  ') + ' ' + braces[1];
    return braces[0] + base + ' ' + output.join(', ') + ' ' + braces[1];
}

// NOTE: These type checking functions intentionally don't use `instanceof`
// because it is fragile and can be easily faked with `Object.create()`.
module.exports.types = (parcelRequire("hL7JQ"));
function $8b5f63c88e782ea3$var$isArray(ar) {
    return Array.isArray(ar);
}
module.exports.isArray = $8b5f63c88e782ea3$var$isArray;
function $8b5f63c88e782ea3$var$isBoolean(arg) {
    return typeof arg === 'boolean';
}
module.exports.isBoolean = $8b5f63c88e782ea3$var$isBoolean;
function $8b5f63c88e782ea3$var$isNull(arg) {
    return arg === null;
}
module.exports.isNull = $8b5f63c88e782ea3$var$isNull;
function $8b5f63c88e782ea3$var$isNullOrUndefined(arg) {
    return arg == null;
}
module.exports.isNullOrUndefined = $8b5f63c88e782ea3$var$isNullOrUndefined;
function $8b5f63c88e782ea3$var$isNumber(arg) {
    return typeof arg === 'number';
}
module.exports.isNumber = $8b5f63c88e782ea3$var$isNumber;
function $8b5f63c88e782ea3$var$isString(arg) {
    return typeof arg === 'string';
}
module.exports.isString = $8b5f63c88e782ea3$var$isString;
function $8b5f63c88e782ea3$var$isSymbol(arg) {
    return (typeof arg === "undefined" ? "undefined" : (0, $6tOPT._)(arg)) === 'symbol';
}
module.exports.isSymbol = $8b5f63c88e782ea3$var$isSymbol;
function $8b5f63c88e782ea3$var$isUndefined(arg) {
    return arg === void 0;
}
module.exports.isUndefined = $8b5f63c88e782ea3$var$isUndefined;
function $8b5f63c88e782ea3$var$isRegExp(re) {
    return $8b5f63c88e782ea3$var$isObject(re) && $8b5f63c88e782ea3$var$objectToString(re) === '[object RegExp]';
}
module.exports.isRegExp = $8b5f63c88e782ea3$var$isRegExp;
module.exports.types.isRegExp = $8b5f63c88e782ea3$var$isRegExp;
function $8b5f63c88e782ea3$var$isObject(arg) {
    return (typeof arg === "undefined" ? "undefined" : (0, $6tOPT._)(arg)) === 'object' && arg !== null;
}
module.exports.isObject = $8b5f63c88e782ea3$var$isObject;
function $8b5f63c88e782ea3$var$isDate(d) {
    return $8b5f63c88e782ea3$var$isObject(d) && $8b5f63c88e782ea3$var$objectToString(d) === '[object Date]';
}
module.exports.isDate = $8b5f63c88e782ea3$var$isDate;
module.exports.types.isDate = $8b5f63c88e782ea3$var$isDate;
function $8b5f63c88e782ea3$var$isError(e) {
    return $8b5f63c88e782ea3$var$isObject(e) && ($8b5f63c88e782ea3$var$objectToString(e) === '[object Error]' || e instanceof Error);
}
module.exports.isError = $8b5f63c88e782ea3$var$isError;
module.exports.types.isNativeError = $8b5f63c88e782ea3$var$isError;
function $8b5f63c88e782ea3$var$isFunction(arg) {
    return typeof arg === 'function';
}
module.exports.isFunction = $8b5f63c88e782ea3$var$isFunction;
function $8b5f63c88e782ea3$var$isPrimitive(arg) {
    return arg === null || typeof arg === 'boolean' || typeof arg === 'number' || typeof arg === 'string' || (typeof arg === "undefined" ? "undefined" : (0, $6tOPT._)(arg)) === 'symbol' || // ES6 symbol
    typeof arg === 'undefined';
}
module.exports.isPrimitive = $8b5f63c88e782ea3$var$isPrimitive;

module.exports.isBuffer = (parcelRequire("doGBD"));
function $8b5f63c88e782ea3$var$objectToString(o) {
    return Object.prototype.toString.call(o);
}
function $8b5f63c88e782ea3$var$pad(n) {
    return n < 10 ? '0' + n.toString(10) : n.toString(10);
}
var $8b5f63c88e782ea3$var$months = [
    'Jan',
    'Feb',
    'Mar',
    'Apr',
    'May',
    'Jun',
    'Jul',
    'Aug',
    'Sep',
    'Oct',
    'Nov',
    'Dec'
];
// 26 Feb 16:19:34
function $8b5f63c88e782ea3$var$timestamp() {
    var d = new Date();
    var time = [
        $8b5f63c88e782ea3$var$pad(d.getHours()),
        $8b5f63c88e782ea3$var$pad(d.getMinutes()),
        $8b5f63c88e782ea3$var$pad(d.getSeconds())
    ].join(':');
    return [
        d.getDate(),
        $8b5f63c88e782ea3$var$months[d.getMonth()],
        time
    ].join(' ');
}
// log is just a thin wrapper to console.log that prepends a timestamp
module.exports.log = function() {
    console.log('%s - %s', $8b5f63c88e782ea3$var$timestamp(), module.exports.format.apply(module.exports, arguments));
};

/**
 * Inherit the prototype methods from one constructor into another.
 *
 * The Function.prototype.inherits from lang.js rewritten as a standalone
 * function (not on Function.prototype). NOTE: If this file is to be loaded
 * during bootstrapping this function needs to be rewritten using some native
 * functions as prototype setup using normal JavaScript does not work as
 * expected during bootstrapping (see mirror.js in r114903).
 *
 * @param {function} ctor Constructor function which needs to inherit the
 *     prototype.
 * @param {function} superCtor Constructor function to inherit prototype from.
 */ module.exports.inherits = (parcelRequire("ACMoe"));
module.exports._extend = function(origin, add) {
    // Don't do anything if add isn't an object
    if (!add || !$8b5f63c88e782ea3$var$isObject(add)) return origin;
    var keys = Object.keys(add);
    var i = keys.length;
    while(i--)origin[keys[i]] = add[keys[i]];
    return origin;
};
function $8b5f63c88e782ea3$var$hasOwnProperty(obj, prop) {
    return Object.prototype.hasOwnProperty.call(obj, prop);
}
var $8b5f63c88e782ea3$var$kCustomPromisifiedSymbol = typeof Symbol !== 'undefined' ? Symbol('util.promisify.custom') : undefined;
module.exports.promisify = function promisify(original) {
    if (typeof original !== 'function') throw new TypeError('The "original" argument must be of type Function');
    if ($8b5f63c88e782ea3$var$kCustomPromisifiedSymbol && original[$8b5f63c88e782ea3$var$kCustomPromisifiedSymbol]) {
        var fn = original[$8b5f63c88e782ea3$var$kCustomPromisifiedSymbol];
        if (typeof fn !== 'function') throw new TypeError('The "util.promisify.custom" argument must be of type Function');
        Object.defineProperty(fn, $8b5f63c88e782ea3$var$kCustomPromisifiedSymbol, {
            value: fn,
            enumerable: false,
            writable: false,
            configurable: true
        });
        return fn;
    }
    function fn() {
        var promiseResolve, promiseReject;
        var promise = new Promise(function(resolve, reject) {
            promiseResolve = resolve;
            promiseReject = reject;
        });
        var args = [];
        for(var i = 0; i < arguments.length; i++)args.push(arguments[i]);
        args.push(function(err, value) {
            if (err) promiseReject(err);
            else promiseResolve(value);
        });
        try {
            original.apply(this, args);
        } catch (err) {
            promiseReject(err);
        }
        return promise;
    }
    Object.setPrototypeOf(fn, Object.getPrototypeOf(original));
    if ($8b5f63c88e782ea3$var$kCustomPromisifiedSymbol) Object.defineProperty(fn, $8b5f63c88e782ea3$var$kCustomPromisifiedSymbol, {
        value: fn,
        enumerable: false,
        writable: false,
        configurable: true
    });
    return Object.defineProperties(fn, $8b5f63c88e782ea3$var$getOwnPropertyDescriptors(original));
};
module.exports.promisify.custom = $8b5f63c88e782ea3$var$kCustomPromisifiedSymbol;
function $8b5f63c88e782ea3$var$callbackifyOnRejected(reason, cb) {
    // `!reason` guard inspired by bluebird (Ref: https://goo.gl/t5IS6M).
    // Because `null` is a special error value in callbacks which means "no error
    // occurred", we error-wrap so the callback consumer can distinguish between
    // "the promise rejected with null" or "the promise fulfilled with undefined".
    if (!reason) {
        var newReason = new Error('Promise was rejected with a falsy value');
        newReason.reason = reason;
        reason = newReason;
    }
    return cb(reason);
}
function $8b5f63c88e782ea3$var$callbackify(original) {
    if (typeof original !== 'function') throw new TypeError('The "original" argument must be of type Function');
    // We DO NOT return the promise as it gives the user a false sense that
    // the promise is actually somehow related to the callback's execution
    // and that the callback throwing will reject the promise.
    function callbackified() {
        var args = [];
        for(var i = 0; i < arguments.length; i++)args.push(arguments[i]);
        var maybeCb = args.pop();
        if (typeof maybeCb !== 'function') throw new TypeError('The last argument must be of type Function');
        var self = this;
        var cb = function cb() {
            return maybeCb.apply(self, arguments);
        };
        // In true node style we process the callback on `nextTick` with all the
        // implications (stack, `uncaughtException`, `async_hooks`)
        original.apply(this, args).then(function(ret) {
            $dKiQF.nextTick(cb.bind(null, null, ret));
        }, function(rej) {
            $dKiQF.nextTick($8b5f63c88e782ea3$var$callbackifyOnRejected.bind(null, rej, cb));
        });
    }
    Object.setPrototypeOf(callbackified, Object.getPrototypeOf(original));
    Object.defineProperties(callbackified, $8b5f63c88e782ea3$var$getOwnPropertyDescriptors(original));
    return callbackified;
}
module.exports.callbackify = $8b5f63c88e782ea3$var$callbackify;

});
parcelRegister("6tOPT", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $4b7ce27f081044e1$export$71511d61b312f219; });
function $4b7ce27f081044e1$export$71511d61b312f219(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}

});

parcelRegister("dKiQF", function(module, exports) {
// shim for using process in browser
var $a01e312b6b6b9e24$var$process = module.exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var $a01e312b6b6b9e24$var$cachedSetTimeout;
var $a01e312b6b6b9e24$var$cachedClearTimeout;
function $a01e312b6b6b9e24$var$defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function $a01e312b6b6b9e24$var$defaultClearTimeout() {
    throw new Error('clearTimeout has not been defined');
}
(function() {
    try {
        if (typeof setTimeout === 'function') $a01e312b6b6b9e24$var$cachedSetTimeout = setTimeout;
        else $a01e312b6b6b9e24$var$cachedSetTimeout = $a01e312b6b6b9e24$var$defaultSetTimout;
    } catch (e) {
        $a01e312b6b6b9e24$var$cachedSetTimeout = $a01e312b6b6b9e24$var$defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') $a01e312b6b6b9e24$var$cachedClearTimeout = clearTimeout;
        else $a01e312b6b6b9e24$var$cachedClearTimeout = $a01e312b6b6b9e24$var$defaultClearTimeout;
    } catch (e) {
        $a01e312b6b6b9e24$var$cachedClearTimeout = $a01e312b6b6b9e24$var$defaultClearTimeout;
    }
})();
function $a01e312b6b6b9e24$var$runTimeout(fun) {
    if ($a01e312b6b6b9e24$var$cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if (($a01e312b6b6b9e24$var$cachedSetTimeout === $a01e312b6b6b9e24$var$defaultSetTimout || !$a01e312b6b6b9e24$var$cachedSetTimeout) && setTimeout) {
        $a01e312b6b6b9e24$var$cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $a01e312b6b6b9e24$var$cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return $a01e312b6b6b9e24$var$cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return $a01e312b6b6b9e24$var$cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function $a01e312b6b6b9e24$var$runClearTimeout(marker) {
    if ($a01e312b6b6b9e24$var$cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if (($a01e312b6b6b9e24$var$cachedClearTimeout === $a01e312b6b6b9e24$var$defaultClearTimeout || !$a01e312b6b6b9e24$var$cachedClearTimeout) && clearTimeout) {
        $a01e312b6b6b9e24$var$cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $a01e312b6b6b9e24$var$cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return $a01e312b6b6b9e24$var$cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return $a01e312b6b6b9e24$var$cachedClearTimeout.call(this, marker);
        }
    }
}
var $a01e312b6b6b9e24$var$queue = [];
var $a01e312b6b6b9e24$var$draining = false;
var $a01e312b6b6b9e24$var$currentQueue;
var $a01e312b6b6b9e24$var$queueIndex = -1;
function $a01e312b6b6b9e24$var$cleanUpNextTick() {
    if (!$a01e312b6b6b9e24$var$draining || !$a01e312b6b6b9e24$var$currentQueue) return;
    $a01e312b6b6b9e24$var$draining = false;
    if ($a01e312b6b6b9e24$var$currentQueue.length) $a01e312b6b6b9e24$var$queue = $a01e312b6b6b9e24$var$currentQueue.concat($a01e312b6b6b9e24$var$queue);
    else $a01e312b6b6b9e24$var$queueIndex = -1;
    if ($a01e312b6b6b9e24$var$queue.length) $a01e312b6b6b9e24$var$drainQueue();
}
function $a01e312b6b6b9e24$var$drainQueue() {
    if ($a01e312b6b6b9e24$var$draining) return;
    var timeout = $a01e312b6b6b9e24$var$runTimeout($a01e312b6b6b9e24$var$cleanUpNextTick);
    $a01e312b6b6b9e24$var$draining = true;
    var len = $a01e312b6b6b9e24$var$queue.length;
    while(len){
        $a01e312b6b6b9e24$var$currentQueue = $a01e312b6b6b9e24$var$queue;
        $a01e312b6b6b9e24$var$queue = [];
        while(++$a01e312b6b6b9e24$var$queueIndex < len)if ($a01e312b6b6b9e24$var$currentQueue) $a01e312b6b6b9e24$var$currentQueue[$a01e312b6b6b9e24$var$queueIndex].run();
        $a01e312b6b6b9e24$var$queueIndex = -1;
        len = $a01e312b6b6b9e24$var$queue.length;
    }
    $a01e312b6b6b9e24$var$currentQueue = null;
    $a01e312b6b6b9e24$var$draining = false;
    $a01e312b6b6b9e24$var$runClearTimeout(timeout);
}
$a01e312b6b6b9e24$var$process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    $a01e312b6b6b9e24$var$queue.push(new $a01e312b6b6b9e24$var$Item(fun, args));
    if ($a01e312b6b6b9e24$var$queue.length === 1 && !$a01e312b6b6b9e24$var$draining) $a01e312b6b6b9e24$var$runTimeout($a01e312b6b6b9e24$var$drainQueue);
};
// v8 likes predictible objects
function $a01e312b6b6b9e24$var$Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
$a01e312b6b6b9e24$var$Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
$a01e312b6b6b9e24$var$process.title = 'browser';
$a01e312b6b6b9e24$var$process.browser = true;
$a01e312b6b6b9e24$var$process.env = {};
$a01e312b6b6b9e24$var$process.argv = [];
$a01e312b6b6b9e24$var$process.version = ''; // empty string to avoid regexp issues
$a01e312b6b6b9e24$var$process.versions = {};
function $a01e312b6b6b9e24$var$noop() {}
$a01e312b6b6b9e24$var$process.on = $a01e312b6b6b9e24$var$noop;
$a01e312b6b6b9e24$var$process.addListener = $a01e312b6b6b9e24$var$noop;
$a01e312b6b6b9e24$var$process.once = $a01e312b6b6b9e24$var$noop;
$a01e312b6b6b9e24$var$process.off = $a01e312b6b6b9e24$var$noop;
$a01e312b6b6b9e24$var$process.removeListener = $a01e312b6b6b9e24$var$noop;
$a01e312b6b6b9e24$var$process.removeAllListeners = $a01e312b6b6b9e24$var$noop;
$a01e312b6b6b9e24$var$process.emit = $a01e312b6b6b9e24$var$noop;
$a01e312b6b6b9e24$var$process.prependListener = $a01e312b6b6b9e24$var$noop;
$a01e312b6b6b9e24$var$process.prependOnceListener = $a01e312b6b6b9e24$var$noop;
$a01e312b6b6b9e24$var$process.listeners = function(name) {
    return [];
};
$a01e312b6b6b9e24$var$process.binding = function(name) {
    throw new Error('process.binding is not supported');
};
$a01e312b6b6b9e24$var$process.cwd = function() {
    return '/';
};
$a01e312b6b6b9e24$var$process.chdir = function(dir) {
    throw new Error('process.chdir is not supported');
};
$a01e312b6b6b9e24$var$process.umask = function() {
    return 0;
};

});

parcelRegister("hL7JQ", function(module, exports) {
// Currently in sync with Node.js lib/internal/util/types.js
// https://github.com/nodejs/node/commit/112cc7c27551254aa2b17098fb774867f05ed0d9

var $6tOPT = parcelRequire("6tOPT");
'use strict';

var $7lQN6 = parcelRequire("7lQN6");

var $34b8v = parcelRequire("34b8v");

var $13YEn = parcelRequire("13YEn");

var $7e2ty = parcelRequire("7e2ty");
function $cedcd427d689e399$var$uncurryThis(f) {
    return f.call.bind(f);
}
var $cedcd427d689e399$var$BigIntSupported = typeof BigInt !== 'undefined';
var $cedcd427d689e399$var$SymbolSupported = typeof Symbol !== 'undefined';
var $cedcd427d689e399$var$ObjectToString = $cedcd427d689e399$var$uncurryThis(Object.prototype.toString);
var $cedcd427d689e399$var$numberValue = $cedcd427d689e399$var$uncurryThis(Number.prototype.valueOf);
var $cedcd427d689e399$var$stringValue = $cedcd427d689e399$var$uncurryThis(String.prototype.valueOf);
var $cedcd427d689e399$var$booleanValue = $cedcd427d689e399$var$uncurryThis(Boolean.prototype.valueOf);
if ($cedcd427d689e399$var$BigIntSupported) var $cedcd427d689e399$var$bigIntValue = $cedcd427d689e399$var$uncurryThis(BigInt.prototype.valueOf);
if ($cedcd427d689e399$var$SymbolSupported) var $cedcd427d689e399$var$symbolValue = $cedcd427d689e399$var$uncurryThis(Symbol.prototype.valueOf);
function $cedcd427d689e399$var$checkBoxedPrimitive(value, prototypeValueOf) {
    if ((typeof value === "undefined" ? "undefined" : (0, $6tOPT._)(value)) !== 'object') return false;
    try {
        prototypeValueOf(value);
        return true;
    } catch (e) {
        return false;
    }
}
module.exports.isArgumentsObject = $7lQN6;
module.exports.isGeneratorFunction = $34b8v;
module.exports.isTypedArray = $7e2ty;
// Taken from here and modified for better browser support
// https://github.com/sindresorhus/p-is-promise/blob/cda35a513bda03f977ad5cde3a079d237e82d7ef/index.js
function $cedcd427d689e399$var$isPromise(input) {
    return typeof Promise !== 'undefined' && input instanceof Promise || input !== null && (typeof input === "undefined" ? "undefined" : (0, $6tOPT._)(input)) === 'object' && typeof input.then === 'function' && typeof input.catch === 'function';
}
module.exports.isPromise = $cedcd427d689e399$var$isPromise;
function $cedcd427d689e399$var$isArrayBufferView(value) {
    if (typeof ArrayBuffer !== 'undefined' && ArrayBuffer.isView) return ArrayBuffer.isView(value);
    return $7e2ty(value) || $cedcd427d689e399$var$isDataView(value);
}
module.exports.isArrayBufferView = $cedcd427d689e399$var$isArrayBufferView;
function $cedcd427d689e399$var$isUint8Array(value) {
    return $13YEn(value) === 'Uint8Array';
}
module.exports.isUint8Array = $cedcd427d689e399$var$isUint8Array;
function $cedcd427d689e399$var$isUint8ClampedArray(value) {
    return $13YEn(value) === 'Uint8ClampedArray';
}
module.exports.isUint8ClampedArray = $cedcd427d689e399$var$isUint8ClampedArray;
function $cedcd427d689e399$var$isUint16Array(value) {
    return $13YEn(value) === 'Uint16Array';
}
module.exports.isUint16Array = $cedcd427d689e399$var$isUint16Array;
function $cedcd427d689e399$var$isUint32Array(value) {
    return $13YEn(value) === 'Uint32Array';
}
module.exports.isUint32Array = $cedcd427d689e399$var$isUint32Array;
function $cedcd427d689e399$var$isInt8Array(value) {
    return $13YEn(value) === 'Int8Array';
}
module.exports.isInt8Array = $cedcd427d689e399$var$isInt8Array;
function $cedcd427d689e399$var$isInt16Array(value) {
    return $13YEn(value) === 'Int16Array';
}
module.exports.isInt16Array = $cedcd427d689e399$var$isInt16Array;
function $cedcd427d689e399$var$isInt32Array(value) {
    return $13YEn(value) === 'Int32Array';
}
module.exports.isInt32Array = $cedcd427d689e399$var$isInt32Array;
function $cedcd427d689e399$var$isFloat32Array(value) {
    return $13YEn(value) === 'Float32Array';
}
module.exports.isFloat32Array = $cedcd427d689e399$var$isFloat32Array;
function $cedcd427d689e399$var$isFloat64Array(value) {
    return $13YEn(value) === 'Float64Array';
}
module.exports.isFloat64Array = $cedcd427d689e399$var$isFloat64Array;
function $cedcd427d689e399$var$isBigInt64Array(value) {
    return $13YEn(value) === 'BigInt64Array';
}
module.exports.isBigInt64Array = $cedcd427d689e399$var$isBigInt64Array;
function $cedcd427d689e399$var$isBigUint64Array(value) {
    return $13YEn(value) === 'BigUint64Array';
}
module.exports.isBigUint64Array = $cedcd427d689e399$var$isBigUint64Array;
function $cedcd427d689e399$var$isMapToString(value) {
    return $cedcd427d689e399$var$ObjectToString(value) === '[object Map]';
}
$cedcd427d689e399$var$isMapToString.working = typeof Map !== 'undefined' && $cedcd427d689e399$var$isMapToString(new Map());
function $cedcd427d689e399$var$isMap(value) {
    if (typeof Map === 'undefined') return false;
    return $cedcd427d689e399$var$isMapToString.working ? $cedcd427d689e399$var$isMapToString(value) : value instanceof Map;
}
module.exports.isMap = $cedcd427d689e399$var$isMap;
function $cedcd427d689e399$var$isSetToString(value) {
    return $cedcd427d689e399$var$ObjectToString(value) === '[object Set]';
}
$cedcd427d689e399$var$isSetToString.working = typeof Set !== 'undefined' && $cedcd427d689e399$var$isSetToString(new Set());
function $cedcd427d689e399$var$isSet(value) {
    if (typeof Set === 'undefined') return false;
    return $cedcd427d689e399$var$isSetToString.working ? $cedcd427d689e399$var$isSetToString(value) : value instanceof Set;
}
module.exports.isSet = $cedcd427d689e399$var$isSet;
function $cedcd427d689e399$var$isWeakMapToString(value) {
    return $cedcd427d689e399$var$ObjectToString(value) === '[object WeakMap]';
}
$cedcd427d689e399$var$isWeakMapToString.working = typeof WeakMap !== 'undefined' && $cedcd427d689e399$var$isWeakMapToString(new WeakMap());
function $cedcd427d689e399$var$isWeakMap(value) {
    if (typeof WeakMap === 'undefined') return false;
    return $cedcd427d689e399$var$isWeakMapToString.working ? $cedcd427d689e399$var$isWeakMapToString(value) : value instanceof WeakMap;
}
module.exports.isWeakMap = $cedcd427d689e399$var$isWeakMap;
function $cedcd427d689e399$var$isWeakSetToString(value) {
    return $cedcd427d689e399$var$ObjectToString(value) === '[object WeakSet]';
}
$cedcd427d689e399$var$isWeakSetToString.working = typeof WeakSet !== 'undefined' && $cedcd427d689e399$var$isWeakSetToString(new WeakSet());
function $cedcd427d689e399$var$isWeakSet(value) {
    return $cedcd427d689e399$var$isWeakSetToString(value);
}
module.exports.isWeakSet = $cedcd427d689e399$var$isWeakSet;
function $cedcd427d689e399$var$isArrayBufferToString(value) {
    return $cedcd427d689e399$var$ObjectToString(value) === '[object ArrayBuffer]';
}
$cedcd427d689e399$var$isArrayBufferToString.working = typeof ArrayBuffer !== 'undefined' && $cedcd427d689e399$var$isArrayBufferToString(new ArrayBuffer());
function $cedcd427d689e399$var$isArrayBuffer(value) {
    if (typeof ArrayBuffer === 'undefined') return false;
    return $cedcd427d689e399$var$isArrayBufferToString.working ? $cedcd427d689e399$var$isArrayBufferToString(value) : value instanceof ArrayBuffer;
}
module.exports.isArrayBuffer = $cedcd427d689e399$var$isArrayBuffer;
function $cedcd427d689e399$var$isDataViewToString(value) {
    return $cedcd427d689e399$var$ObjectToString(value) === '[object DataView]';
}
$cedcd427d689e399$var$isDataViewToString.working = typeof ArrayBuffer !== 'undefined' && typeof DataView !== 'undefined' && $cedcd427d689e399$var$isDataViewToString(new DataView(new ArrayBuffer(1), 0, 1));
function $cedcd427d689e399$var$isDataView(value) {
    if (typeof DataView === 'undefined') return false;
    return $cedcd427d689e399$var$isDataViewToString.working ? $cedcd427d689e399$var$isDataViewToString(value) : value instanceof DataView;
}
module.exports.isDataView = $cedcd427d689e399$var$isDataView;
// Store a copy of SharedArrayBuffer in case it's deleted elsewhere
var $cedcd427d689e399$var$SharedArrayBufferCopy = typeof SharedArrayBuffer !== 'undefined' ? SharedArrayBuffer : undefined;
function $cedcd427d689e399$var$isSharedArrayBufferToString(value) {
    return $cedcd427d689e399$var$ObjectToString(value) === '[object SharedArrayBuffer]';
}
function $cedcd427d689e399$var$isSharedArrayBuffer(value) {
    if (typeof $cedcd427d689e399$var$SharedArrayBufferCopy === 'undefined') return false;
    if (typeof $cedcd427d689e399$var$isSharedArrayBufferToString.working === 'undefined') $cedcd427d689e399$var$isSharedArrayBufferToString.working = $cedcd427d689e399$var$isSharedArrayBufferToString(new $cedcd427d689e399$var$SharedArrayBufferCopy());
    return $cedcd427d689e399$var$isSharedArrayBufferToString.working ? $cedcd427d689e399$var$isSharedArrayBufferToString(value) : value instanceof $cedcd427d689e399$var$SharedArrayBufferCopy;
}
module.exports.isSharedArrayBuffer = $cedcd427d689e399$var$isSharedArrayBuffer;
function $cedcd427d689e399$var$isAsyncFunction(value) {
    return $cedcd427d689e399$var$ObjectToString(value) === '[object AsyncFunction]';
}
module.exports.isAsyncFunction = $cedcd427d689e399$var$isAsyncFunction;
function $cedcd427d689e399$var$isMapIterator(value) {
    return $cedcd427d689e399$var$ObjectToString(value) === '[object Map Iterator]';
}
module.exports.isMapIterator = $cedcd427d689e399$var$isMapIterator;
function $cedcd427d689e399$var$isSetIterator(value) {
    return $cedcd427d689e399$var$ObjectToString(value) === '[object Set Iterator]';
}
module.exports.isSetIterator = $cedcd427d689e399$var$isSetIterator;
function $cedcd427d689e399$var$isGeneratorObject(value) {
    return $cedcd427d689e399$var$ObjectToString(value) === '[object Generator]';
}
module.exports.isGeneratorObject = $cedcd427d689e399$var$isGeneratorObject;
function $cedcd427d689e399$var$isWebAssemblyCompiledModule(value) {
    return $cedcd427d689e399$var$ObjectToString(value) === '[object WebAssembly.Module]';
}
module.exports.isWebAssemblyCompiledModule = $cedcd427d689e399$var$isWebAssemblyCompiledModule;
function $cedcd427d689e399$var$isNumberObject(value) {
    return $cedcd427d689e399$var$checkBoxedPrimitive(value, $cedcd427d689e399$var$numberValue);
}
module.exports.isNumberObject = $cedcd427d689e399$var$isNumberObject;
function $cedcd427d689e399$var$isStringObject(value) {
    return $cedcd427d689e399$var$checkBoxedPrimitive(value, $cedcd427d689e399$var$stringValue);
}
module.exports.isStringObject = $cedcd427d689e399$var$isStringObject;
function $cedcd427d689e399$var$isBooleanObject(value) {
    return $cedcd427d689e399$var$checkBoxedPrimitive(value, $cedcd427d689e399$var$booleanValue);
}
module.exports.isBooleanObject = $cedcd427d689e399$var$isBooleanObject;
function $cedcd427d689e399$var$isBigIntObject(value) {
    return $cedcd427d689e399$var$BigIntSupported && $cedcd427d689e399$var$checkBoxedPrimitive(value, $cedcd427d689e399$var$bigIntValue);
}
module.exports.isBigIntObject = $cedcd427d689e399$var$isBigIntObject;
function $cedcd427d689e399$var$isSymbolObject(value) {
    return $cedcd427d689e399$var$SymbolSupported && $cedcd427d689e399$var$checkBoxedPrimitive(value, $cedcd427d689e399$var$symbolValue);
}
module.exports.isSymbolObject = $cedcd427d689e399$var$isSymbolObject;
function $cedcd427d689e399$var$isBoxedPrimitive(value) {
    return $cedcd427d689e399$var$isNumberObject(value) || $cedcd427d689e399$var$isStringObject(value) || $cedcd427d689e399$var$isBooleanObject(value) || $cedcd427d689e399$var$isBigIntObject(value) || $cedcd427d689e399$var$isSymbolObject(value);
}
module.exports.isBoxedPrimitive = $cedcd427d689e399$var$isBoxedPrimitive;
function $cedcd427d689e399$var$isAnyArrayBuffer(value) {
    return typeof Uint8Array !== 'undefined' && ($cedcd427d689e399$var$isArrayBuffer(value) || $cedcd427d689e399$var$isSharedArrayBuffer(value));
}
module.exports.isAnyArrayBuffer = $cedcd427d689e399$var$isAnyArrayBuffer;
[
    'isProxy',
    'isExternal',
    'isModuleNamespaceObject'
].forEach(function(method) {
    Object.defineProperty(module.exports, method, {
        enumerable: false,
        value: function value() {
            throw new Error(method + ' is not supported in userland');
        }
    });
});

});
parcelRegister("7lQN6", function(module, exports) {

var $6tOPT = parcelRequire("6tOPT");
'use strict';

var $55a371c6a8d2ee16$var$hasToStringTag = (parcelRequire("1dGoe"))();

var $dXv1j = parcelRequire("dXv1j");
var $55a371c6a8d2ee16$var$$toString = $dXv1j('Object.prototype.toString');
/** @type {import('.')} */ var $55a371c6a8d2ee16$var$isStandardArguments = function isArguments(value) {
    if ($55a371c6a8d2ee16$var$hasToStringTag && value && (typeof value === "undefined" ? "undefined" : (0, $6tOPT._)(value)) === 'object' && Symbol.toStringTag in value) return false;
    return $55a371c6a8d2ee16$var$$toString(value) === '[object Arguments]';
};
/** @type {import('.')} */ var $55a371c6a8d2ee16$var$isLegacyArguments = function isArguments(value) {
    if ($55a371c6a8d2ee16$var$isStandardArguments(value)) return true;
    return value !== null && (typeof value === "undefined" ? "undefined" : (0, $6tOPT._)(value)) === 'object' && 'length' in value && typeof value.length === 'number' && value.length >= 0 && $55a371c6a8d2ee16$var$$toString(value) !== '[object Array]' && 'callee' in value && $55a371c6a8d2ee16$var$$toString(value.callee) === '[object Function]';
};
var $55a371c6a8d2ee16$var$supportsStandardArguments = function() {
    return $55a371c6a8d2ee16$var$isStandardArguments(arguments);
}();
// @ts-expect-error TODO make this not error
$55a371c6a8d2ee16$var$isStandardArguments.isLegacyArguments = $55a371c6a8d2ee16$var$isLegacyArguments; // for tests
/** @type {import('.')} */ module.exports = $55a371c6a8d2ee16$var$supportsStandardArguments ? $55a371c6a8d2ee16$var$isStandardArguments : $55a371c6a8d2ee16$var$isLegacyArguments;

});
parcelRegister("1dGoe", function(module, exports) {
'use strict';

var $gOOPP = parcelRequire("gOOPP");
/** @type {import('.')} */ module.exports = function hasToStringTagShams() {
    return $gOOPP() && !!Symbol.toStringTag;
};

});
parcelRegister("gOOPP", function(module, exports) {

var $6tOPT = parcelRequire("6tOPT");
'use strict';
/** @type {import('./shams')} */ /* eslint complexity: [2, 18], max-statements: [2, 33] */ module.exports = function hasSymbols() {
    if (typeof Symbol !== 'function' || typeof Object.getOwnPropertySymbols !== 'function') return false;
    if ((0, $6tOPT._)(Symbol.iterator) === 'symbol') return true;
    /** @type {{ [k in symbol]?: unknown }} */ var obj = {};
    var sym = Symbol('test');
    var symObj = Object(sym);
    if (typeof sym === 'string') return false;
    if (Object.prototype.toString.call(sym) !== '[object Symbol]') return false;
    if (Object.prototype.toString.call(symObj) !== '[object Symbol]') return false;
    // temp disabled per https://github.com/ljharb/object.assign/issues/17
    // if (sym instanceof Symbol) { return false; }
    // temp disabled per https://github.com/WebReflection/get-own-property-symbols/issues/4
    // if (!(symObj instanceof Symbol)) { return false; }
    // if (typeof Symbol.prototype.toString !== 'function') { return false; }
    // if (String(sym) !== Symbol.prototype.toString.call(sym)) { return false; }
    var symVal = 42;
    obj[sym] = symVal;
    for(var _ in obj)return false;
     // eslint-disable-line no-restricted-syntax, no-unreachable-loop
    if (typeof Object.keys === 'function' && Object.keys(obj).length !== 0) return false;
    if (typeof Object.getOwnPropertyNames === 'function' && Object.getOwnPropertyNames(obj).length !== 0) return false;
    var syms = Object.getOwnPropertySymbols(obj);
    if (syms.length !== 1 || syms[0] !== sym) return false;
    if (!Object.prototype.propertyIsEnumerable.call(obj, sym)) return false;
    if (typeof Object.getOwnPropertyDescriptor === 'function') {
        // eslint-disable-next-line no-extra-parens
        var descriptor = /** @type {PropertyDescriptor} */ Object.getOwnPropertyDescriptor(obj, sym);
        if (descriptor.value !== symVal || descriptor.enumerable !== true) return false;
    }
    return true;
};

});


parcelRegister("dXv1j", function(module, exports) {
'use strict';

var $7vv6H = parcelRequire("7vv6H");

var $6Ugwe = parcelRequire("6Ugwe");
/** @type {(thisArg: string, searchString: string, position?: number) => number} */ var $a298d8fdb8e96e35$var$$indexOf = $6Ugwe([
    $7vv6H('%String.prototype.indexOf%')
]);
/** @type {import('.')} */ module.exports = function callBoundIntrinsic(name, allowMissing) {
    /* eslint no-extra-parens: 0 */ var intrinsic = /** @type {(this: unknown, ...args: unknown[]) => unknown} */ $7vv6H(name, !!allowMissing);
    if (typeof intrinsic === 'function' && $a298d8fdb8e96e35$var$$indexOf(name, '.prototype.') > -1) return $6Ugwe(/** @type {const} */ [
        intrinsic
    ]);
    return intrinsic;
};

});
parcelRegister("7vv6H", function(module, exports) {

var $6tOPT = parcelRequire("6tOPT");
'use strict';
var $57738ed9bc168f67$var$_$undefined;

var $drf7U = parcelRequire("drf7U");

var $dB6Ji = parcelRequire("dB6Ji");

var $3ELu3 = parcelRequire("3ELu3");

var $cgYpn = parcelRequire("cgYpn");

var $f5F1E = parcelRequire("f5F1E");

var $ajGBP = parcelRequire("ajGBP");

var $a7MQF = parcelRequire("a7MQF");

var $fXIdI = parcelRequire("fXIdI");

var $3q563 = parcelRequire("3q563");

var $bo4Nl = parcelRequire("bo4Nl");

var $28zc9 = parcelRequire("28zc9");

var $1DkU8 = parcelRequire("1DkU8");

var $3dQAY = parcelRequire("3dQAY");

var $gye47 = parcelRequire("gye47");

var $25yMD = parcelRequire("25yMD");
var $57738ed9bc168f67$var$$Function = Function;
// eslint-disable-next-line consistent-return
var $57738ed9bc168f67$var$getEvalledConstructor = function getEvalledConstructor(expressionSyntax) {
    try {
        return $57738ed9bc168f67$var$$Function('"use strict"; return (' + expressionSyntax + ').constructor;')();
    } catch (e) {}
};

var $bZMCt = parcelRequire("bZMCt");

var $BvYAa = parcelRequire("BvYAa");
var $57738ed9bc168f67$var$throwTypeError = function throwTypeError() {
    throw new $a7MQF();
};
var $57738ed9bc168f67$var$ThrowTypeError = $bZMCt ? function() {
    try {
        // eslint-disable-next-line no-unused-expressions, no-caller, no-restricted-properties
        arguments.callee; // IE 8 does not throw here
        return $57738ed9bc168f67$var$throwTypeError;
    } catch (calleeThrows) {
        try {
            // IE 8 throws on Object.getOwnPropertyDescriptor(arguments, '')
            return $bZMCt(arguments, 'callee').get;
        } catch (gOPDthrows) {
            return $57738ed9bc168f67$var$throwTypeError;
        }
    }
}() : $57738ed9bc168f67$var$throwTypeError;

var $57738ed9bc168f67$var$hasSymbols = (parcelRequire("9JLNj"))();

var $ed2V4 = parcelRequire("ed2V4");

var $b2Gko = parcelRequire("b2Gko");

var $ImQC1 = parcelRequire("ImQC1");

var $yWDnr = parcelRequire("yWDnr");

var $5NtIA = parcelRequire("5NtIA");
var $57738ed9bc168f67$var$needsEval = {};
var $57738ed9bc168f67$var$TypedArray = typeof Uint8Array === 'undefined' || !$ed2V4 ? undefined : $ed2V4(Uint8Array);
var $57738ed9bc168f67$var$INTRINSICS = {
    __proto__: null,
    '%AggregateError%': typeof AggregateError === 'undefined' ? undefined : AggregateError,
    '%Array%': Array,
    '%ArrayBuffer%': typeof ArrayBuffer === 'undefined' ? undefined : ArrayBuffer,
    '%ArrayIteratorPrototype%': $57738ed9bc168f67$var$hasSymbols && $ed2V4 ? $ed2V4([][Symbol.iterator]()) : undefined,
    '%AsyncFromSyncIteratorPrototype%': undefined,
    '%AsyncFunction%': $57738ed9bc168f67$var$needsEval,
    '%AsyncGenerator%': $57738ed9bc168f67$var$needsEval,
    '%AsyncGeneratorFunction%': $57738ed9bc168f67$var$needsEval,
    '%AsyncIteratorPrototype%': $57738ed9bc168f67$var$needsEval,
    '%Atomics%': typeof Atomics === 'undefined' ? undefined : Atomics,
    '%BigInt%': typeof BigInt === 'undefined' ? undefined : BigInt,
    '%BigInt64Array%': typeof BigInt64Array === 'undefined' ? undefined : BigInt64Array,
    '%BigUint64Array%': typeof BigUint64Array === 'undefined' ? undefined : BigUint64Array,
    '%Boolean%': Boolean,
    '%DataView%': typeof DataView === 'undefined' ? undefined : DataView,
    '%Date%': Date,
    '%decodeURI%': decodeURI,
    '%decodeURIComponent%': decodeURIComponent,
    '%encodeURI%': encodeURI,
    '%encodeURIComponent%': encodeURIComponent,
    '%Error%': $dB6Ji,
    '%eval%': eval,
    '%EvalError%': $3ELu3,
    '%Float16Array%': typeof Float16Array === 'undefined' ? undefined : Float16Array,
    '%Float32Array%': typeof Float32Array === 'undefined' ? undefined : Float32Array,
    '%Float64Array%': typeof Float64Array === 'undefined' ? undefined : Float64Array,
    '%FinalizationRegistry%': typeof FinalizationRegistry === 'undefined' ? undefined : FinalizationRegistry,
    '%Function%': $57738ed9bc168f67$var$$Function,
    '%GeneratorFunction%': $57738ed9bc168f67$var$needsEval,
    '%Int8Array%': typeof Int8Array === 'undefined' ? undefined : Int8Array,
    '%Int16Array%': typeof Int16Array === 'undefined' ? undefined : Int16Array,
    '%Int32Array%': typeof Int32Array === 'undefined' ? undefined : Int32Array,
    '%isFinite%': isFinite,
    '%isNaN%': isNaN,
    '%IteratorPrototype%': $57738ed9bc168f67$var$hasSymbols && $ed2V4 ? $ed2V4($ed2V4([][Symbol.iterator]())) : undefined,
    '%JSON%': (typeof JSON === "undefined" ? "undefined" : (0, $6tOPT._)(JSON)) === 'object' ? JSON : undefined,
    '%Map%': typeof Map === 'undefined' ? undefined : Map,
    '%MapIteratorPrototype%': typeof Map === 'undefined' || !$57738ed9bc168f67$var$hasSymbols || !$ed2V4 ? undefined : $ed2V4(new Map()[Symbol.iterator]()),
    '%Math%': Math,
    '%Number%': Number,
    '%Object%': $drf7U,
    '%Object.getOwnPropertyDescriptor%': $bZMCt,
    '%parseFloat%': parseFloat,
    '%parseInt%': parseInt,
    '%Promise%': typeof Promise === 'undefined' ? undefined : Promise,
    '%Proxy%': typeof Proxy === 'undefined' ? undefined : Proxy,
    '%RangeError%': $cgYpn,
    '%ReferenceError%': $f5F1E,
    '%Reflect%': typeof Reflect === 'undefined' ? undefined : Reflect,
    '%RegExp%': RegExp,
    '%Set%': typeof Set === 'undefined' ? undefined : Set,
    '%SetIteratorPrototype%': typeof Set === 'undefined' || !$57738ed9bc168f67$var$hasSymbols || !$ed2V4 ? undefined : $ed2V4(new Set()[Symbol.iterator]()),
    '%SharedArrayBuffer%': typeof SharedArrayBuffer === 'undefined' ? undefined : SharedArrayBuffer,
    '%String%': String,
    '%StringIteratorPrototype%': $57738ed9bc168f67$var$hasSymbols && $ed2V4 ? $ed2V4(''[Symbol.iterator]()) : undefined,
    '%Symbol%': $57738ed9bc168f67$var$hasSymbols ? Symbol : undefined,
    '%SyntaxError%': $ajGBP,
    '%ThrowTypeError%': $57738ed9bc168f67$var$ThrowTypeError,
    '%TypedArray%': $57738ed9bc168f67$var$TypedArray,
    '%TypeError%': $a7MQF,
    '%Uint8Array%': typeof Uint8Array === 'undefined' ? undefined : Uint8Array,
    '%Uint8ClampedArray%': typeof Uint8ClampedArray === 'undefined' ? undefined : Uint8ClampedArray,
    '%Uint16Array%': typeof Uint16Array === 'undefined' ? undefined : Uint16Array,
    '%Uint32Array%': typeof Uint32Array === 'undefined' ? undefined : Uint32Array,
    '%URIError%': $fXIdI,
    '%WeakMap%': typeof WeakMap === 'undefined' ? undefined : WeakMap,
    '%WeakRef%': typeof WeakRef === 'undefined' ? undefined : WeakRef,
    '%WeakSet%': typeof WeakSet === 'undefined' ? undefined : WeakSet,
    '%Function.prototype.call%': $5NtIA,
    '%Function.prototype.apply%': $yWDnr,
    '%Object.defineProperty%': $BvYAa,
    '%Object.getPrototypeOf%': $b2Gko,
    '%Math.abs%': $3q563,
    '%Math.floor%': $bo4Nl,
    '%Math.max%': $28zc9,
    '%Math.min%': $1DkU8,
    '%Math.pow%': $3dQAY,
    '%Math.round%': $gye47,
    '%Math.sign%': $25yMD,
    '%Reflect.getPrototypeOf%': $ImQC1
};
if ($ed2V4) try {
    null.error; // eslint-disable-line no-unused-expressions
} catch (e) {
    // https://github.com/tc39/proposal-shadowrealm/pull/384#issuecomment-1364264229
    var $57738ed9bc168f67$var$errorProto = $ed2V4($ed2V4(e));
    $57738ed9bc168f67$var$INTRINSICS['%Error.prototype%'] = $57738ed9bc168f67$var$errorProto;
}
var $57738ed9bc168f67$var$doEval = function doEval(name) {
    var value;
    if (name === '%AsyncFunction%') value = $57738ed9bc168f67$var$getEvalledConstructor('async function () {}');
    else if (name === '%GeneratorFunction%') value = $57738ed9bc168f67$var$getEvalledConstructor('function* () {}');
    else if (name === '%AsyncGeneratorFunction%') value = $57738ed9bc168f67$var$getEvalledConstructor('async function* () {}');
    else if (name === '%AsyncGenerator%') {
        var fn = doEval('%AsyncGeneratorFunction%');
        if (fn) value = fn.prototype;
    } else if (name === '%AsyncIteratorPrototype%') {
        var gen = doEval('%AsyncGenerator%');
        if (gen && $ed2V4) value = $ed2V4(gen.prototype);
    }
    $57738ed9bc168f67$var$INTRINSICS[name] = value;
    return value;
};
var $57738ed9bc168f67$var$LEGACY_ALIASES = {
    __proto__: null,
    '%ArrayBufferPrototype%': [
        'ArrayBuffer',
        'prototype'
    ],
    '%ArrayPrototype%': [
        'Array',
        'prototype'
    ],
    '%ArrayProto_entries%': [
        'Array',
        'prototype',
        'entries'
    ],
    '%ArrayProto_forEach%': [
        'Array',
        'prototype',
        'forEach'
    ],
    '%ArrayProto_keys%': [
        'Array',
        'prototype',
        'keys'
    ],
    '%ArrayProto_values%': [
        'Array',
        'prototype',
        'values'
    ],
    '%AsyncFunctionPrototype%': [
        'AsyncFunction',
        'prototype'
    ],
    '%AsyncGenerator%': [
        'AsyncGeneratorFunction',
        'prototype'
    ],
    '%AsyncGeneratorPrototype%': [
        'AsyncGeneratorFunction',
        'prototype',
        'prototype'
    ],
    '%BooleanPrototype%': [
        'Boolean',
        'prototype'
    ],
    '%DataViewPrototype%': [
        'DataView',
        'prototype'
    ],
    '%DatePrototype%': [
        'Date',
        'prototype'
    ],
    '%ErrorPrototype%': [
        'Error',
        'prototype'
    ],
    '%EvalErrorPrototype%': [
        'EvalError',
        'prototype'
    ],
    '%Float32ArrayPrototype%': [
        'Float32Array',
        'prototype'
    ],
    '%Float64ArrayPrototype%': [
        'Float64Array',
        'prototype'
    ],
    '%FunctionPrototype%': [
        'Function',
        'prototype'
    ],
    '%Generator%': [
        'GeneratorFunction',
        'prototype'
    ],
    '%GeneratorPrototype%': [
        'GeneratorFunction',
        'prototype',
        'prototype'
    ],
    '%Int8ArrayPrototype%': [
        'Int8Array',
        'prototype'
    ],
    '%Int16ArrayPrototype%': [
        'Int16Array',
        'prototype'
    ],
    '%Int32ArrayPrototype%': [
        'Int32Array',
        'prototype'
    ],
    '%JSONParse%': [
        'JSON',
        'parse'
    ],
    '%JSONStringify%': [
        'JSON',
        'stringify'
    ],
    '%MapPrototype%': [
        'Map',
        'prototype'
    ],
    '%NumberPrototype%': [
        'Number',
        'prototype'
    ],
    '%ObjectPrototype%': [
        'Object',
        'prototype'
    ],
    '%ObjProto_toString%': [
        'Object',
        'prototype',
        'toString'
    ],
    '%ObjProto_valueOf%': [
        'Object',
        'prototype',
        'valueOf'
    ],
    '%PromisePrototype%': [
        'Promise',
        'prototype'
    ],
    '%PromiseProto_then%': [
        'Promise',
        'prototype',
        'then'
    ],
    '%Promise_all%': [
        'Promise',
        'all'
    ],
    '%Promise_reject%': [
        'Promise',
        'reject'
    ],
    '%Promise_resolve%': [
        'Promise',
        'resolve'
    ],
    '%RangeErrorPrototype%': [
        'RangeError',
        'prototype'
    ],
    '%ReferenceErrorPrototype%': [
        'ReferenceError',
        'prototype'
    ],
    '%RegExpPrototype%': [
        'RegExp',
        'prototype'
    ],
    '%SetPrototype%': [
        'Set',
        'prototype'
    ],
    '%SharedArrayBufferPrototype%': [
        'SharedArrayBuffer',
        'prototype'
    ],
    '%StringPrototype%': [
        'String',
        'prototype'
    ],
    '%SymbolPrototype%': [
        'Symbol',
        'prototype'
    ],
    '%SyntaxErrorPrototype%': [
        'SyntaxError',
        'prototype'
    ],
    '%TypedArrayPrototype%': [
        'TypedArray',
        'prototype'
    ],
    '%TypeErrorPrototype%': [
        'TypeError',
        'prototype'
    ],
    '%Uint8ArrayPrototype%': [
        'Uint8Array',
        'prototype'
    ],
    '%Uint8ClampedArrayPrototype%': [
        'Uint8ClampedArray',
        'prototype'
    ],
    '%Uint16ArrayPrototype%': [
        'Uint16Array',
        'prototype'
    ],
    '%Uint32ArrayPrototype%': [
        'Uint32Array',
        'prototype'
    ],
    '%URIErrorPrototype%': [
        'URIError',
        'prototype'
    ],
    '%WeakMapPrototype%': [
        'WeakMap',
        'prototype'
    ],
    '%WeakSetPrototype%': [
        'WeakSet',
        'prototype'
    ]
};

var $3xOTg = parcelRequire("3xOTg");

var $5CEhz = parcelRequire("5CEhz");
var $57738ed9bc168f67$var$$concat = $3xOTg.call($5NtIA, Array.prototype.concat);
var $57738ed9bc168f67$var$$spliceApply = $3xOTg.call($yWDnr, Array.prototype.splice);
var $57738ed9bc168f67$var$$replace = $3xOTg.call($5NtIA, String.prototype.replace);
var $57738ed9bc168f67$var$$strSlice = $3xOTg.call($5NtIA, String.prototype.slice);
var $57738ed9bc168f67$var$$exec = $3xOTg.call($5NtIA, RegExp.prototype.exec);
/* adapted from https://github.com/lodash/lodash/blob/4.17.15/dist/lodash.js#L6735-L6744 */ var $57738ed9bc168f67$var$rePropName = /[^%.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|%$))/g;
var $57738ed9bc168f67$var$reEscapeChar = /\\(\\)?/g; /** Used to match backslashes in property paths. */ 
var $57738ed9bc168f67$var$stringToPath = function stringToPath(string) {
    var first = $57738ed9bc168f67$var$$strSlice(string, 0, 1);
    var last = $57738ed9bc168f67$var$$strSlice(string, -1);
    if (first === '%' && last !== '%') throw new $ajGBP('invalid intrinsic syntax, expected closing `%`');
    else if (last === '%' && first !== '%') throw new $ajGBP('invalid intrinsic syntax, expected opening `%`');
    var result = [];
    $57738ed9bc168f67$var$$replace(string, $57738ed9bc168f67$var$rePropName, function(match, number, quote, subString) {
        result[result.length] = quote ? $57738ed9bc168f67$var$$replace(subString, $57738ed9bc168f67$var$reEscapeChar, '$1') : number || match;
    });
    return result;
};
/* end adaptation */ var $57738ed9bc168f67$var$getBaseIntrinsic = function getBaseIntrinsic(name, allowMissing) {
    var intrinsicName = name;
    var alias;
    if ($5CEhz($57738ed9bc168f67$var$LEGACY_ALIASES, intrinsicName)) {
        alias = $57738ed9bc168f67$var$LEGACY_ALIASES[intrinsicName];
        intrinsicName = '%' + alias[0] + '%';
    }
    if ($5CEhz($57738ed9bc168f67$var$INTRINSICS, intrinsicName)) {
        var value = $57738ed9bc168f67$var$INTRINSICS[intrinsicName];
        if (value === $57738ed9bc168f67$var$needsEval) value = $57738ed9bc168f67$var$doEval(intrinsicName);
        if (typeof value === 'undefined' && !allowMissing) throw new $a7MQF('intrinsic ' + name + ' exists, but is not available. Please file an issue!');
        return {
            alias: alias,
            name: intrinsicName,
            value: value
        };
    }
    throw new $ajGBP('intrinsic ' + name + ' does not exist!');
};
module.exports = function GetIntrinsic(name, allowMissing) {
    if (typeof name !== 'string' || name.length === 0) throw new $a7MQF('intrinsic name must be a non-empty string');
    if (arguments.length > 1 && typeof allowMissing !== 'boolean') throw new $a7MQF('"allowMissing" argument must be a boolean');
    if ($57738ed9bc168f67$var$$exec(/^%?[^%]*%?$/, name) === null) throw new $ajGBP('`%` may not be present anywhere but at the beginning and end of the intrinsic name');
    var parts = $57738ed9bc168f67$var$stringToPath(name);
    var intrinsicBaseName = parts.length > 0 ? parts[0] : '';
    var intrinsic = $57738ed9bc168f67$var$getBaseIntrinsic('%' + intrinsicBaseName + '%', allowMissing);
    var intrinsicRealName = intrinsic.name;
    var value = intrinsic.value;
    var skipFurtherCaching = false;
    var alias = intrinsic.alias;
    if (alias) {
        intrinsicBaseName = alias[0];
        $57738ed9bc168f67$var$$spliceApply(parts, $57738ed9bc168f67$var$$concat([
            0,
            1
        ], alias));
    }
    for(var i = 1, isOwn = true; i < parts.length; i += 1){
        var part = parts[i];
        var first = $57738ed9bc168f67$var$$strSlice(part, 0, 1);
        var last = $57738ed9bc168f67$var$$strSlice(part, -1);
        if ((first === '"' || first === "'" || first === '`' || last === '"' || last === "'" || last === '`') && first !== last) throw new $ajGBP('property names with quotes must have matching quotes');
        if (part === 'constructor' || !isOwn) skipFurtherCaching = true;
        intrinsicBaseName += '.' + part;
        intrinsicRealName = '%' + intrinsicBaseName + '%';
        if ($5CEhz($57738ed9bc168f67$var$INTRINSICS, intrinsicRealName)) value = $57738ed9bc168f67$var$INTRINSICS[intrinsicRealName];
        else if (value != null) {
            if (!(part in value)) {
                if (!allowMissing) throw new $a7MQF('base intrinsic for ' + name + ' exists, but the property is not available.');
                return void 0;
            }
            if ($bZMCt && i + 1 >= parts.length) {
                var desc = $bZMCt(value, part);
                isOwn = !!desc;
                // By convention, when a data property is converted to an accessor
                // property to emulate a data property that does not suffer from
                // the override mistake, that accessor's getter is marked with
                // an `originalValue` property. Here, when we detect this, we
                // uphold the illusion by pretending to see that original data
                // property, i.e., returning the value rather than the getter
                // itself.
                if (isOwn && 'get' in desc && !('originalValue' in desc.get)) value = desc.get;
                else value = value[part];
            } else {
                isOwn = $5CEhz(value, part);
                value = value[part];
            }
            if (isOwn && !skipFurtherCaching) $57738ed9bc168f67$var$INTRINSICS[intrinsicRealName] = value;
        }
    }
    return value;
};

});
parcelRegister("drf7U", function(module, exports) {
'use strict';
/** @type {import('.')} */ module.exports = Object;

});

parcelRegister("dB6Ji", function(module, exports) {
'use strict';
/** @type {import('.')} */ module.exports = Error;

});

parcelRegister("3ELu3", function(module, exports) {
'use strict';
/** @type {import('./eval')} */ module.exports = EvalError;

});

parcelRegister("cgYpn", function(module, exports) {
'use strict';
/** @type {import('./range')} */ module.exports = RangeError;

});

parcelRegister("f5F1E", function(module, exports) {
'use strict';
/** @type {import('./ref')} */ module.exports = ReferenceError;

});

parcelRegister("ajGBP", function(module, exports) {
'use strict';
/** @type {import('./syntax')} */ module.exports = SyntaxError;

});

parcelRegister("a7MQF", function(module, exports) {
'use strict';
/** @type {import('./type')} */ module.exports = TypeError;

});

parcelRegister("fXIdI", function(module, exports) {
'use strict';
/** @type {import('./uri')} */ module.exports = URIError;

});

parcelRegister("3q563", function(module, exports) {
'use strict';
/** @type {import('./abs')} */ module.exports = Math.abs;

});

parcelRegister("bo4Nl", function(module, exports) {
'use strict';
/** @type {import('./floor')} */ module.exports = Math.floor;

});

parcelRegister("28zc9", function(module, exports) {
'use strict';
/** @type {import('./max')} */ module.exports = Math.max;

});

parcelRegister("1DkU8", function(module, exports) {
'use strict';
/** @type {import('./min')} */ module.exports = Math.min;

});

parcelRegister("3dQAY", function(module, exports) {
'use strict';
/** @type {import('./pow')} */ module.exports = Math.pow;

});

parcelRegister("gye47", function(module, exports) {
'use strict';
/** @type {import('./round')} */ module.exports = Math.round;

});

parcelRegister("25yMD", function(module, exports) {
'use strict';

var $98pmU = parcelRequire("98pmU");
/** @type {import('./sign')} */ module.exports = function sign(number) {
    if ($98pmU(number) || number === 0) return number;
    return number < 0 ? -1 : 1;
};

});
parcelRegister("98pmU", function(module, exports) {
'use strict';
/** @type {import('./isNaN')} */ module.exports = Number.isNaN || function isNaN(a) {
    return a !== a;
};

});


parcelRegister("bZMCt", function(module, exports) {
'use strict';

var $gLwH0 = parcelRequire("gLwH0");
var $8bbb1b0b4a943b7a$require$$gOPD = $gLwH0;
if ($8bbb1b0b4a943b7a$require$$gOPD) try {
    $8bbb1b0b4a943b7a$require$$gOPD([], 'length');
} catch (e) {
    // IE 8 has a broken gOPD
    $8bbb1b0b4a943b7a$require$$gOPD = null;
}
module.exports = $8bbb1b0b4a943b7a$require$$gOPD;

});
parcelRegister("gLwH0", function(module, exports) {
'use strict';
/** @type {import('./gOPD')} */ module.exports = Object.getOwnPropertyDescriptor;

});


parcelRegister("BvYAa", function(module, exports) {
'use strict';
/** @type {import('.')} */ var $070c429c2713aa75$var$$defineProperty = Object.defineProperty || false;
if ($070c429c2713aa75$var$$defineProperty) try {
    $070c429c2713aa75$var$$defineProperty({}, 'a', {
        value: 1
    });
} catch (e) {
    // IE 8 has a broken defineProperty
    $070c429c2713aa75$var$$defineProperty = false;
}
module.exports = $070c429c2713aa75$var$$defineProperty;

});

parcelRegister("9JLNj", function(module, exports) {

var $6tOPT = parcelRequire("6tOPT");
'use strict';
var $716d63ff770c4845$var$origSymbol = typeof Symbol !== 'undefined' && Symbol;

var $gOOPP = parcelRequire("gOOPP");
/** @type {import('.')} */ module.exports = function hasNativeSymbols() {
    if (typeof $716d63ff770c4845$var$origSymbol !== 'function') return false;
    if (typeof Symbol !== 'function') return false;
    if ((0, $6tOPT._)($716d63ff770c4845$var$origSymbol('foo')) !== 'symbol') return false;
    if ((0, $6tOPT._)(Symbol('bar')) !== 'symbol') return false;
    return $gOOPP();
};

});

parcelRegister("ed2V4", function(module, exports) {

var $6tOPT = parcelRequire("6tOPT");
'use strict';

var $ImQC1 = parcelRequire("ImQC1");

var $b2Gko = parcelRequire("b2Gko");

var $7vcd7 = parcelRequire("7vcd7");
/** @type {import('.')} */ module.exports = $ImQC1 ? function getProto(O) {
    // @ts-expect-error TS can't narrow inside a closure, for some reason
    return $ImQC1(O);
} : $b2Gko ? function getProto(O) {
    if (!O || (typeof O === "undefined" ? "undefined" : (0, $6tOPT._)(O)) !== 'object' && typeof O !== 'function') throw new TypeError('getProto: not an object');
    // @ts-expect-error TS can't narrow inside a closure, for some reason
    return $b2Gko(O);
} : $7vcd7 ? function getProto(O) {
    // @ts-expect-error TS can't narrow inside a closure, for some reason
    return $7vcd7(O);
} : null;

});
parcelRegister("ImQC1", function(module, exports) {
'use strict';
/** @type {import('./Reflect.getPrototypeOf')} */ module.exports = typeof Reflect !== 'undefined' && Reflect.getPrototypeOf || null;

});

parcelRegister("b2Gko", function(module, exports) {
'use strict';

var $drf7U = parcelRequire("drf7U");
/** @type {import('./Object.getPrototypeOf')} */ module.exports = $drf7U.getPrototypeOf || null;

});

parcelRegister("7vcd7", function(module, exports) {

var $6tOPT = parcelRequire("6tOPT");
'use strict';

var $6Ugwe = parcelRequire("6Ugwe");

var $bZMCt = parcelRequire("bZMCt");
var $5764e66cdf572d14$var$hasProtoAccessor;
try {
    // eslint-disable-next-line no-extra-parens, no-proto
    $5764e66cdf572d14$var$hasProtoAccessor = /** @type {{ __proto__?: typeof Array.prototype }} */ [].__proto__ === Array.prototype;
} catch (e) {
    if (!e || (typeof e === "undefined" ? "undefined" : (0, $6tOPT._)(e)) !== 'object' || !('code' in e) || e.code !== 'ERR_PROTO_ACCESS') throw e;
}
// eslint-disable-next-line no-extra-parens
var $5764e66cdf572d14$var$desc = !!$5764e66cdf572d14$var$hasProtoAccessor && $bZMCt && $bZMCt(Object.prototype, /** @type {keyof typeof Object.prototype} */ '__proto__');
var $5764e66cdf572d14$var$$Object = Object;
var $5764e66cdf572d14$var$$getPrototypeOf = $5764e66cdf572d14$var$$Object.getPrototypeOf;
/** @type {import('./get')} */ module.exports = $5764e66cdf572d14$var$desc && typeof $5764e66cdf572d14$var$desc.get === 'function' ? $6Ugwe([
    $5764e66cdf572d14$var$desc.get
]) : typeof $5764e66cdf572d14$var$$getPrototypeOf === 'function' ? /** @type {import('./get')} */ function getDunder(value) {
    // eslint-disable-next-line eqeqeq
    return $5764e66cdf572d14$var$$getPrototypeOf(value == null ? value : $5764e66cdf572d14$var$$Object(value));
} : false;

});
parcelRegister("6Ugwe", function(module, exports) {
'use strict';

var $3xOTg = parcelRequire("3xOTg");

var $a7MQF = parcelRequire("a7MQF");

var $5NtIA = parcelRequire("5NtIA");

var $iEkv0 = parcelRequire("iEkv0");
/** @type {(args: [Function, thisArg?: unknown, ...args: unknown[]]) => Function} TODO FIXME, find a way to use import('.') */ module.exports = function callBindBasic(args) {
    if (args.length < 1 || typeof args[0] !== 'function') throw new $a7MQF('a function is required');
    return $iEkv0($3xOTg, $5NtIA, args);
};

});
parcelRegister("3xOTg", function(module, exports) {
'use strict';

var $5OgNi = parcelRequire("5OgNi");
module.exports = Function.prototype.bind || $5OgNi;

});
parcelRegister("5OgNi", function(module, exports) {
'use strict';
/* eslint no-invalid-this: 1 */ var $43aea637fc731f27$var$ERROR_MESSAGE = 'Function.prototype.bind called on incompatible ';
var $43aea637fc731f27$var$toStr = Object.prototype.toString;
var $43aea637fc731f27$var$max = Math.max;
var $43aea637fc731f27$var$funcType = '[object Function]';
var $43aea637fc731f27$var$concatty = function concatty(a, b) {
    var arr = [];
    for(var i = 0; i < a.length; i += 1)arr[i] = a[i];
    for(var j = 0; j < b.length; j += 1)arr[j + a.length] = b[j];
    return arr;
};
var $43aea637fc731f27$var$slicy = function slicy(arrLike, offset) {
    var arr = [];
    for(var i = offset || 0, j = 0; i < arrLike.length; i += 1, j += 1)arr[j] = arrLike[i];
    return arr;
};
var $43aea637fc731f27$var$joiny = function joiny(arr, joiner) {
    var str = '';
    for(var i = 0; i < arr.length; i += 1){
        str += arr[i];
        if (i + 1 < arr.length) str += joiner;
    }
    return str;
};
module.exports = function bind(that) {
    var target = this;
    if (typeof target !== 'function' || $43aea637fc731f27$var$toStr.apply(target) !== $43aea637fc731f27$var$funcType) throw new TypeError($43aea637fc731f27$var$ERROR_MESSAGE + target);
    var args = $43aea637fc731f27$var$slicy(arguments, 1);
    var bound;
    var binder = function binder() {
        if (this instanceof bound) {
            var result = target.apply(this, $43aea637fc731f27$var$concatty(args, arguments));
            if (Object(result) === result) return result;
            return this;
        }
        return target.apply(that, $43aea637fc731f27$var$concatty(args, arguments));
    };
    var boundLength = $43aea637fc731f27$var$max(0, target.length - args.length);
    var boundArgs = [];
    for(var i = 0; i < boundLength; i++)boundArgs[i] = '$' + i;
    bound = Function('binder', 'return function (' + $43aea637fc731f27$var$joiny(boundArgs, ',') + '){ return binder.apply(this,arguments); }')(binder);
    if (target.prototype) {
        var Empty = function Empty() {};
        Empty.prototype = target.prototype;
        bound.prototype = new Empty();
        Empty.prototype = null;
    }
    return bound;
};

});


parcelRegister("5NtIA", function(module, exports) {
'use strict';
/** @type {import('./functionCall')} */ module.exports = Function.prototype.call;

});

parcelRegister("iEkv0", function(module, exports) {
'use strict';

var $3xOTg = parcelRequire("3xOTg");

var $yWDnr = parcelRequire("yWDnr");

var $5NtIA = parcelRequire("5NtIA");

var $d7gXN = parcelRequire("d7gXN");
/** @type {import('./actualApply')} */ module.exports = $d7gXN || $3xOTg.call($5NtIA, $yWDnr);

});
parcelRegister("yWDnr", function(module, exports) {
'use strict';
/** @type {import('./functionApply')} */ module.exports = Function.prototype.apply;

});

parcelRegister("d7gXN", function(module, exports) {
'use strict';
/** @type {import('./reflectApply')} */ module.exports = typeof Reflect !== 'undefined' && Reflect && Reflect.apply;

});





parcelRegister("5CEhz", function(module, exports) {
'use strict';
var $417fbf9c7290a60e$var$call = Function.prototype.call;
var $417fbf9c7290a60e$var$$hasOwn = Object.prototype.hasOwnProperty;

var $3xOTg = parcelRequire("3xOTg");
/** @type {import('.')} */ module.exports = $3xOTg.call($417fbf9c7290a60e$var$call, $417fbf9c7290a60e$var$$hasOwn);

});




parcelRegister("34b8v", function(module, exports) {
'use strict';

var $dXv1j = parcelRequire("dXv1j");

var $jq1Qw = parcelRequire("jq1Qw");
var $23ba623c81b457a3$var$isFnRegex = $jq1Qw(/^\s*(?:function)?\*/);

var $23ba623c81b457a3$var$hasToStringTag = (parcelRequire("1dGoe"))();

var $ed2V4 = parcelRequire("ed2V4");
var $23ba623c81b457a3$var$toStr = $dXv1j('Object.prototype.toString');
var $23ba623c81b457a3$var$fnToStr = $dXv1j('Function.prototype.toString');

var $4crRn = parcelRequire("4crRn");
/** @type {import('.')} */ module.exports = function isGeneratorFunction(fn) {
    if (typeof fn !== 'function') return false;
    if ($23ba623c81b457a3$var$isFnRegex($23ba623c81b457a3$var$fnToStr(fn))) return true;
    if (!$23ba623c81b457a3$var$hasToStringTag) {
        var str = $23ba623c81b457a3$var$toStr(fn);
        return str === '[object GeneratorFunction]';
    }
    if (!$ed2V4) return false;
    var GeneratorFunction = $4crRn();
    return GeneratorFunction && $ed2V4(fn) === GeneratorFunction.prototype;
};

});
parcelRegister("jq1Qw", function(module, exports) {
'use strict';

var $dXv1j = parcelRequire("dXv1j");

var $bVvbd = parcelRequire("bVvbd");
var $e231e0a5a29600a5$var$$exec = $dXv1j('RegExp.prototype.exec');

var $a7MQF = parcelRequire("a7MQF");
/** @type {import('.')} */ module.exports = function regexTester(regex) {
    if (!$bVvbd(regex)) throw new $a7MQF('`regex` must be a RegExp');
    return function test(s) {
        return $e231e0a5a29600a5$var$$exec(regex, s) !== null;
    };
};

});
parcelRegister("bVvbd", function(module, exports) {

var $6tOPT = parcelRequire("6tOPT");
'use strict';

var $dXv1j = parcelRequire("dXv1j");

var $8aed3442d464cfec$var$hasToStringTag = (parcelRequire("1dGoe"))();

var $5CEhz = parcelRequire("5CEhz");

var $bZMCt = parcelRequire("bZMCt");
/** @type {import('.')} */ var $8aed3442d464cfec$var$fn;
if ($8aed3442d464cfec$var$hasToStringTag) {
    /** @type {(receiver: ThisParameterType<typeof RegExp.prototype.exec>, ...args: Parameters<typeof RegExp.prototype.exec>) => ReturnType<typeof RegExp.prototype.exec>} */ var $8aed3442d464cfec$var$$exec = $dXv1j('RegExp.prototype.exec');
    /** @type {object} */ var $8aed3442d464cfec$var$isRegexMarker = {};
    var $8aed3442d464cfec$var$throwRegexMarker = function throwRegexMarker() {
        throw $8aed3442d464cfec$var$isRegexMarker;
    };
    /** @type {{ toString(): never, valueOf(): never, [Symbol.toPrimitive]?(): never }} */ var $8aed3442d464cfec$var$badStringifier = {
        toString: $8aed3442d464cfec$var$throwRegexMarker,
        valueOf: $8aed3442d464cfec$var$throwRegexMarker
    };
    if ((0, $6tOPT._)(Symbol.toPrimitive) === 'symbol') $8aed3442d464cfec$var$badStringifier[Symbol.toPrimitive] = $8aed3442d464cfec$var$throwRegexMarker;
    /** @type {import('.')} */ // @ts-expect-error TS can't figure out that the $exec call always throws
    // eslint-disable-next-line consistent-return
    $8aed3442d464cfec$var$fn = function isRegex(value) {
        if (!value || (typeof value === "undefined" ? "undefined" : (0, $6tOPT._)(value)) !== 'object') return false;
        // eslint-disable-next-line no-extra-parens
        var descriptor = /** @type {NonNullable<typeof gOPD>} */ $bZMCt(/** @type {{ lastIndex?: unknown }} */ value, 'lastIndex');
        var hasLastIndexDataProperty = descriptor && $5CEhz(descriptor, 'value');
        if (!hasLastIndexDataProperty) return false;
        try {
            // eslint-disable-next-line no-extra-parens
            $8aed3442d464cfec$var$$exec(value, /** @type {unknown} */ $8aed3442d464cfec$var$badStringifier);
        } catch (e) {
            return e === $8aed3442d464cfec$var$isRegexMarker;
        }
    };
} else {
    /** @type {(receiver: ThisParameterType<typeof Object.prototype.toString>, ...args: Parameters<typeof Object.prototype.toString>) => ReturnType<typeof Object.prototype.toString>} */ var $8aed3442d464cfec$var$$toString = $dXv1j('Object.prototype.toString');
    /** @const @type {'[object RegExp]'} */ var $8aed3442d464cfec$var$regexClass = '[object RegExp]';
    /** @type {import('.')} */ $8aed3442d464cfec$var$fn = function isRegex(value) {
        // In older browsers, typeof regex incorrectly returns 'function'
        if (!value || (typeof value === "undefined" ? "undefined" : (0, $6tOPT._)(value)) !== 'object' && typeof value !== 'function') return false;
        return $8aed3442d464cfec$var$$toString(value) === $8aed3442d464cfec$var$regexClass;
    };
}
module.exports = $8aed3442d464cfec$var$fn;

});


parcelRegister("4crRn", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $6d456cdb8d9354da$export$2e2bcd8739ae039; });

var $7ovUK = parcelRequire("7ovUK");
var /** @type {import('./index.d.mts').default} */ $6d456cdb8d9354da$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($7ovUK)));

});
parcelRegister("7ovUK", function(module, exports) {

var $53nS0 = parcelRequire("53nS0");
'use strict';
// eslint-disable-next-line no-extra-parens, no-empty-function
var $562387cb020ccf71$var$cached = /** @type {GeneratorFunctionConstructor} */ (function cached() {
    return (0, $53nS0._)(this, function(_state) {
        return [
            2
        ];
    });
}).constructor;
/** @type {import('.')} */ module.exports = function() {
    return $562387cb020ccf71$var$cached;
};

});
parcelRegister("53nS0", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $3adfbfa53fb5c0c3$export$71511d61b312f219; });
function $3adfbfa53fb5c0c3$export$71511d61b312f219(thisArg, body) {
    var f, y, t, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype), d = Object.defineProperty;
    return d(g, "next", {
        value: verb(0)
    }), d(g, "throw", {
        value: verb(1)
    }), d(g, "return", {
        value: verb(2)
    }), typeof Symbol === "function" && d(g, Symbol.iterator, {
        value: function() {
            return this;
        }
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}

});




parcelRegister("13YEn", function(module, exports) {

var $6tOPT = parcelRequire("6tOPT");
'use strict';

var $ihf17 = parcelRequire("ihf17");

var $azwJJ = parcelRequire("azwJJ");

var $7cG2s = parcelRequire("7cG2s");

var $dXv1j = parcelRequire("dXv1j");

var $bZMCt = parcelRequire("bZMCt");

var $ed2V4 = parcelRequire("ed2V4");
var $0c651e2217da838b$var$$toString = $dXv1j('Object.prototype.toString');

var $0c651e2217da838b$var$hasToStringTag = (parcelRequire("1dGoe"))();
var $0c651e2217da838b$var$g = typeof globalThis === 'undefined' ? $parcel$global : globalThis;
var $0c651e2217da838b$var$typedArrays = $azwJJ();
var $0c651e2217da838b$var$$slice = $dXv1j('String.prototype.slice');
/** @import { BoundSet, BoundSlice, Cache, Getter } from './types' */ /** @import { TypedArrayName } from '.' */ /** @type {<T = unknown>(array: readonly T[], value: unknown) => number} */ var $0c651e2217da838b$var$$indexOf = $dXv1j('Array.prototype.indexOf', true) || function indexOf(array, value) {
    for(var i = 0; i < array.length; i += 1){
        if (array[i] === value) return i;
    }
    return -1;
};
/** @type {Cache} */ var $0c651e2217da838b$var$cache = {
    __proto__: null
};
if ($0c651e2217da838b$var$hasToStringTag && $bZMCt && $ed2V4) $ihf17($0c651e2217da838b$var$typedArrays, function(typedArray) {
    var arr = new $0c651e2217da838b$var$g[typedArray]();
    if (Symbol.toStringTag in arr && $ed2V4) {
        var proto = $ed2V4(arr);
        // @ts-expect-error TS won't narrow inside a closure
        var descriptor = $bZMCt(proto, Symbol.toStringTag);
        if (!descriptor && proto) {
            var superProto = $ed2V4(proto);
            // @ts-expect-error TS won't narrow inside a closure
            descriptor = $bZMCt(superProto, Symbol.toStringTag);
        }
        if (descriptor && descriptor.get) {
            var bound = $7cG2s(descriptor.get);
            $0c651e2217da838b$var$cache[/** @type {`$${TypedArrayName}`} */ '$' + typedArray] = bound;
        }
    }
});
else $ihf17($0c651e2217da838b$var$typedArrays, function(typedArray) {
    var arr = new $0c651e2217da838b$var$g[typedArray]();
    var fn = arr.slice || arr.set;
    if (fn) {
        var bound = /** @type {BoundSlice | BoundSet} */ // @ts-expect-error TODO FIXME
        $7cG2s(fn);
        $0c651e2217da838b$var$cache[/** @type {`$${TypedArrayName}`} */ '$' + typedArray] = bound;
    }
});
/** @type {(value: object) => false | TypedArrayName} */ function $0c651e2217da838b$var$tryTypedArrays(value) {
    /** @type {ReturnType<typeof tryTypedArrays>} */ var found = false;
    $ihf17(/** @type {Record<`$${TypedArrayName}`, Getter>} */ $0c651e2217da838b$var$cache, /** @param {Getter} getter @param {`$${TypedArrayName}`} typedArray */ function(getter, typedArray) {
        if (!found) try {
            // @ts-expect-error a throw is fine here
            if ('$' + getter(value) === typedArray) found = /** @type {TypedArrayName} */ $0c651e2217da838b$var$$slice(typedArray, 1);
        } catch (e) {}
    });
    return found;
}
/** @type {(value: object) => false | TypedArrayName} */ function $0c651e2217da838b$var$trySlices(value) {
    /** @type {ReturnType<typeof trySlices>} */ var found = false;
    $ihf17(/** @type {Record<`$${TypedArrayName}`, Getter>} */ $0c651e2217da838b$var$cache, /** @param {Getter} getter @param {`$${TypedArrayName}`} name */ function(getter, name) {
        if (!found) try {
            // @ts-expect-error a throw is fine here
            getter(value);
            found = /** @type {TypedArrayName} */ $0c651e2217da838b$var$$slice(name, 1);
        } catch (e) {}
    });
    return found;
}
/** @type {(tag: unknown) => tag is typeof typedArrays[number]} */ function $0c651e2217da838b$var$isTATag(tag) {
    return $0c651e2217da838b$var$$indexOf($0c651e2217da838b$var$typedArrays, tag) > -1;
}
/**
 * @type {import('.')}
 * @param {unknown} value
 */ module.exports = function whichTypedArray(value) {
    if (!value || (typeof value === "undefined" ? "undefined" : (0, $6tOPT._)(value)) !== 'object') return false;
    if (!$0c651e2217da838b$var$hasToStringTag) {
        var tag = $0c651e2217da838b$var$$slice($0c651e2217da838b$var$$toString(value), 8, -1);
        if ($0c651e2217da838b$var$isTATag(tag)) return tag;
        if (tag !== 'Object') return false;
        // node < 0.6 hits here on real Typed Arrays
        return $0c651e2217da838b$var$trySlices(value);
    }
    if (!$bZMCt) return null;
     // unknown engine
    return $0c651e2217da838b$var$tryTypedArrays(value);
};

});
parcelRegister("ihf17", function(module, exports) {
'use strict';

var $4PAoN = parcelRequire("4PAoN");
var $d4e576972fd8fbc5$var$toStr = Object.prototype.toString;
var $d4e576972fd8fbc5$var$hasOwnProperty = Object.prototype.hasOwnProperty;
/** @type {<This, A extends readonly unknown[]>(arr: A, iterator: (this: This | void, value: A[number], index: number, arr: A) => void, receiver: This | undefined) => void} */ var $d4e576972fd8fbc5$var$forEachArray = function forEachArray(array, iterator, receiver) {
    for(var i = 0, len = array.length; i < len; i++)if ($d4e576972fd8fbc5$var$hasOwnProperty.call(array, i)) {
        if (receiver == null) iterator(array[i], i, array);
        else iterator.call(receiver, array[i], i, array);
    }
};
/** @type {<This, S extends string>(string: S, iterator: (this: This | void, value: S[number], index: number, string: S) => void, receiver: This | undefined) => void} */ var $d4e576972fd8fbc5$var$forEachString = function forEachString(string, iterator, receiver) {
    for(var i = 0, len = string.length; i < len; i++)// no such thing as a sparse string.
    if (receiver == null) iterator(string.charAt(i), i, string);
    else iterator.call(receiver, string.charAt(i), i, string);
};
/** @type {<This, O>(obj: O, iterator: (this: This | void, value: O[keyof O], index: keyof O, obj: O) => void, receiver: This | undefined) => void} */ var $d4e576972fd8fbc5$var$forEachObject = function forEachObject(object, iterator, receiver) {
    for(var k in object)if ($d4e576972fd8fbc5$var$hasOwnProperty.call(object, k)) {
        if (receiver == null) iterator(object[k], k, object);
        else iterator.call(receiver, object[k], k, object);
    }
};
/** @type {(x: unknown) => x is readonly unknown[]} */ function $d4e576972fd8fbc5$var$isArray(x) {
    return $d4e576972fd8fbc5$var$toStr.call(x) === '[object Array]';
}
/** @type {import('.')._internal} */ module.exports = function forEach(list, iterator, thisArg) {
    if (!$4PAoN(iterator)) throw new TypeError('iterator must be a function');
    var receiver;
    if (arguments.length >= 3) receiver = thisArg;
    if ($d4e576972fd8fbc5$var$isArray(list)) $d4e576972fd8fbc5$var$forEachArray(list, iterator, receiver);
    else if (typeof list === 'string') $d4e576972fd8fbc5$var$forEachString(list, iterator, receiver);
    else $d4e576972fd8fbc5$var$forEachObject(list, iterator, receiver);
};

});
parcelRegister("4PAoN", function(module, exports) {

var $6tOPT = parcelRequire("6tOPT");
'use strict';
var $384828e7d821948b$var$fnToStr = Function.prototype.toString;
var $384828e7d821948b$var$reflectApply = (typeof Reflect === "undefined" ? "undefined" : (0, $6tOPT._)(Reflect)) === 'object' && Reflect !== null && Reflect.apply;
var $384828e7d821948b$var$badArrayLike;
var $384828e7d821948b$var$isCallableMarker;
if (typeof $384828e7d821948b$var$reflectApply === 'function' && typeof Object.defineProperty === 'function') try {
    $384828e7d821948b$var$badArrayLike = Object.defineProperty({}, 'length', {
        get: function get() {
            throw $384828e7d821948b$var$isCallableMarker;
        }
    });
    $384828e7d821948b$var$isCallableMarker = {};
    // eslint-disable-next-line no-throw-literal
    $384828e7d821948b$var$reflectApply(function() {
        throw 42;
    }, null, $384828e7d821948b$var$badArrayLike);
} catch (_) {
    if (_ !== $384828e7d821948b$var$isCallableMarker) $384828e7d821948b$var$reflectApply = null;
}
else $384828e7d821948b$var$reflectApply = null;
var $384828e7d821948b$var$constructorRegex = /^\s*class\b/;
var $384828e7d821948b$var$isES6ClassFn = function isES6ClassFunction(value) {
    try {
        var fnStr = $384828e7d821948b$var$fnToStr.call(value);
        return $384828e7d821948b$var$constructorRegex.test(fnStr);
    } catch (e) {
        return false; // not a function
    }
};
var $384828e7d821948b$var$tryFunctionObject = function tryFunctionToStr(value) {
    try {
        if ($384828e7d821948b$var$isES6ClassFn(value)) return false;
        $384828e7d821948b$var$fnToStr.call(value);
        return true;
    } catch (e) {
        return false;
    }
};
var $384828e7d821948b$var$toStr = Object.prototype.toString;
var $384828e7d821948b$var$objectClass = '[object Object]';
var $384828e7d821948b$var$fnClass = '[object Function]';
var $384828e7d821948b$var$genClass = '[object GeneratorFunction]';
var $384828e7d821948b$var$ddaClass = '[object HTMLAllCollection]'; // IE 11
var $384828e7d821948b$var$ddaClass2 = '[object HTML document.all class]';
var $384828e7d821948b$var$ddaClass3 = '[object HTMLCollection]'; // IE 9-10
var $384828e7d821948b$var$hasToStringTag = typeof Symbol === 'function' && !!Symbol.toStringTag; // better: use `has-tostringtag`
var $384828e7d821948b$var$isIE68 = !(0 in [
    , 
]); // eslint-disable-line no-sparse-arrays, comma-spacing
var $384828e7d821948b$var$isDDA = function isDocumentDotAll() {
    return false;
};
if ((typeof document === "undefined" ? "undefined" : (0, $6tOPT._)(document)) === 'object') {
    // Firefox 3 canonicalizes DDA to undefined when it's not accessed directly
    var $384828e7d821948b$var$all = document.all;
    if ($384828e7d821948b$var$toStr.call($384828e7d821948b$var$all) === $384828e7d821948b$var$toStr.call(document.all)) $384828e7d821948b$var$isDDA = function isDocumentDotAll(value) {
        /* globals document: false */ // in IE 6-8, typeof document.all is "object" and it's truthy
        if (($384828e7d821948b$var$isIE68 || !value) && (typeof value === 'undefined' || (typeof value === "undefined" ? "undefined" : (0, $6tOPT._)(value)) === 'object')) try {
            var str = $384828e7d821948b$var$toStr.call(value);
            return (str === $384828e7d821948b$var$ddaClass || str === $384828e7d821948b$var$ddaClass2 || str === $384828e7d821948b$var$ddaClass3 // opera 12.16
             || str === $384828e7d821948b$var$objectClass // IE 6-8
            ) && value('') == null; // eslint-disable-line eqeqeq
        } catch (e) {}
        return false;
    };
}
module.exports = $384828e7d821948b$var$reflectApply ? function isCallable(value) {
    if ($384828e7d821948b$var$isDDA(value)) return true;
    if (!value) return false;
    if (typeof value !== 'function' && (typeof value === "undefined" ? "undefined" : (0, $6tOPT._)(value)) !== 'object') return false;
    try {
        $384828e7d821948b$var$reflectApply(value, null, $384828e7d821948b$var$badArrayLike);
    } catch (e) {
        if (e !== $384828e7d821948b$var$isCallableMarker) return false;
    }
    return !$384828e7d821948b$var$isES6ClassFn(value) && $384828e7d821948b$var$tryFunctionObject(value);
} : function isCallable(value) {
    if ($384828e7d821948b$var$isDDA(value)) return true;
    if (!value) return false;
    if (typeof value !== 'function' && (typeof value === "undefined" ? "undefined" : (0, $6tOPT._)(value)) !== 'object') return false;
    if ($384828e7d821948b$var$hasToStringTag) return $384828e7d821948b$var$tryFunctionObject(value);
    if ($384828e7d821948b$var$isES6ClassFn(value)) return false;
    var strClass = $384828e7d821948b$var$toStr.call(value);
    if (strClass !== $384828e7d821948b$var$fnClass && strClass !== $384828e7d821948b$var$genClass && !/^\[object HTML/.test(strClass)) return false;
    return $384828e7d821948b$var$tryFunctionObject(value);
};

});


parcelRegister("azwJJ", function(module, exports) {
'use strict';

var $11iSK = parcelRequire("11iSK");
var $7b269110829b50f1$var$g = typeof globalThis === 'undefined' ? $parcel$global : globalThis;
/** @type {import('.')} */ module.exports = function availableTypedArrays() {
    var /** @type {ReturnType<typeof availableTypedArrays>} */ out = [];
    for(var i = 0; i < $11iSK.length; i++)if (typeof $7b269110829b50f1$var$g[$11iSK[i]] === 'function') // @ts-expect-error
    out[out.length] = $11iSK[i];
    return out;
};

});
parcelRegister("11iSK", function(module, exports) {
'use strict';
/** @type {import('.')} */ module.exports = [
    'Float16Array',
    'Float32Array',
    'Float64Array',
    'Int8Array',
    'Int16Array',
    'Int32Array',
    'Uint8Array',
    'Uint8ClampedArray',
    'Uint16Array',
    'Uint32Array',
    'BigInt64Array',
    'BigUint64Array'
];

});


parcelRegister("7cG2s", function(module, exports) {
'use strict';

var $7oxKR = parcelRequire("7oxKR");

var $BvYAa = parcelRequire("BvYAa");

var $6Ugwe = parcelRequire("6Ugwe");

var $8Exdt = parcelRequire("8Exdt");
module.exports = function callBind(originalFunction) {
    var func = $6Ugwe(arguments);
    var adjustedLength = 1 + originalFunction.length - (arguments.length - 1);
    return $7oxKR(func, adjustedLength > 0 ? adjustedLength : 0, true);
};
if ($BvYAa) $BvYAa(module.exports, 'apply', {
    value: $8Exdt
});
else module.exports.apply = $8Exdt;

});
parcelRegister("7oxKR", function(module, exports) {
'use strict';

var $7vv6H = parcelRequire("7vv6H");

var $iSsfL = parcelRequire("iSsfL");

var $5624f5526d7c56e8$var$hasDescriptors = (parcelRequire("gGCmn"))();

var $bZMCt = parcelRequire("bZMCt");

var $a7MQF = parcelRequire("a7MQF");
var $5624f5526d7c56e8$var$$floor = $7vv6H('%Math.floor%');
/** @type {import('.')} */ module.exports = function setFunctionLength(fn, length) {
    if (typeof fn !== 'function') throw new $a7MQF('`fn` is not a function');
    if (typeof length !== 'number' || length < 0 || length > 0xFFFFFFFF || $5624f5526d7c56e8$var$$floor(length) !== length) throw new $a7MQF('`length` must be a positive 32-bit integer');
    var loose = arguments.length > 2 && !!arguments[2];
    var functionLengthIsConfigurable = true;
    var functionLengthIsWritable = true;
    if ('length' in fn && $bZMCt) {
        var desc = $bZMCt(fn, 'length');
        if (desc && !desc.configurable) functionLengthIsConfigurable = false;
        if (desc && !desc.writable) functionLengthIsWritable = false;
    }
    if (functionLengthIsConfigurable || functionLengthIsWritable || !loose) {
        if ($5624f5526d7c56e8$var$hasDescriptors) $iSsfL(/** @type {Parameters<define>[0]} */ fn, 'length', length, true, true);
        else $iSsfL(/** @type {Parameters<define>[0]} */ fn, 'length', length);
    }
    return fn;
};

});
parcelRegister("iSsfL", function(module, exports) {

var $6tOPT = parcelRequire("6tOPT");
'use strict';

var $BvYAa = parcelRequire("BvYAa");

var $ajGBP = parcelRequire("ajGBP");

var $a7MQF = parcelRequire("a7MQF");

var $bZMCt = parcelRequire("bZMCt");
/** @type {import('.')} */ module.exports = function defineDataProperty(obj, property, value) {
    if (!obj || (typeof obj === "undefined" ? "undefined" : (0, $6tOPT._)(obj)) !== 'object' && typeof obj !== 'function') throw new $a7MQF('`obj` must be an object or a function`');
    if (typeof property !== 'string' && (typeof property === "undefined" ? "undefined" : (0, $6tOPT._)(property)) !== 'symbol') throw new $a7MQF('`property` must be a string or a symbol`');
    if (arguments.length > 3 && typeof arguments[3] !== 'boolean' && arguments[3] !== null) throw new $a7MQF('`nonEnumerable`, if provided, must be a boolean or null');
    if (arguments.length > 4 && typeof arguments[4] !== 'boolean' && arguments[4] !== null) throw new $a7MQF('`nonWritable`, if provided, must be a boolean or null');
    if (arguments.length > 5 && typeof arguments[5] !== 'boolean' && arguments[5] !== null) throw new $a7MQF('`nonConfigurable`, if provided, must be a boolean or null');
    if (arguments.length > 6 && typeof arguments[6] !== 'boolean') throw new $a7MQF('`loose`, if provided, must be a boolean');
    var nonEnumerable = arguments.length > 3 ? arguments[3] : null;
    var nonWritable = arguments.length > 4 ? arguments[4] : null;
    var nonConfigurable = arguments.length > 5 ? arguments[5] : null;
    var loose = arguments.length > 6 ? arguments[6] : false;
    /* @type {false | TypedPropertyDescriptor<unknown>} */ var desc = !!$bZMCt && $bZMCt(obj, property);
    if ($BvYAa) $BvYAa(obj, property, {
        configurable: nonConfigurable === null && desc ? desc.configurable : !nonConfigurable,
        enumerable: nonEnumerable === null && desc ? desc.enumerable : !nonEnumerable,
        value: value,
        writable: nonWritable === null && desc ? desc.writable : !nonWritable
    });
    else if (loose || !nonEnumerable && !nonWritable && !nonConfigurable) // must fall back to [[Set]], and was not explicitly asked to make non-enumerable, non-writable, or non-configurable
    obj[property] = value; // eslint-disable-line no-param-reassign
    else throw new $ajGBP('This environment does not support defining a property as non-configurable, non-writable, or non-enumerable.');
};

});

parcelRegister("gGCmn", function(module, exports) {
'use strict';

var $BvYAa = parcelRequire("BvYAa");
var $c25e531310a5752f$var$hasPropertyDescriptors = function hasPropertyDescriptors() {
    return !!$BvYAa;
};
$c25e531310a5752f$var$hasPropertyDescriptors.hasArrayLengthDefineBug = function hasArrayLengthDefineBug() {
    // node v0.6 has a bug where array lengths can be Set but not Defined
    if (!$BvYAa) return null;
    try {
        return $BvYAa([], 'length', {
            value: 1
        }).length !== 1;
    } catch (e) {
        // In Firefox 4-22, defining length on an array throws an exception.
        return true;
    }
};
module.exports = $c25e531310a5752f$var$hasPropertyDescriptors;

});


parcelRegister("8Exdt", function(module, exports) {
'use strict';

var $3xOTg = parcelRequire("3xOTg");

var $yWDnr = parcelRequire("yWDnr");

var $iEkv0 = parcelRequire("iEkv0");
/** @type {import('./applyBind')} */ module.exports = function applyBind() {
    return $iEkv0($3xOTg, $yWDnr, arguments);
};

});



parcelRegister("7e2ty", function(module, exports) {
'use strict';

var $13YEn = parcelRequire("13YEn");
/** @type {import('.')} */ module.exports = function isTypedArray(value) {
    return !!$13YEn(value);
};

});


parcelRegister("doGBD", function(module, exports) {

var $6tOPT = parcelRequire("6tOPT");
module.exports = function isBuffer(arg) {
    return arg && (typeof arg === "undefined" ? "undefined" : (0, $6tOPT._)(arg)) === 'object' && typeof arg.copy === 'function' && typeof arg.fill === 'function' && typeof arg.readUInt8 === 'function';
};

});

parcelRegister("ACMoe", function(module, exports) {
if (typeof Object.create === 'function') // implementation from standard node.js 'util' module
module.exports = function inherits(ctor, superCtor) {
    if (superCtor) {
        ctor.super_ = superCtor;
        ctor.prototype = Object.create(superCtor.prototype, {
            constructor: {
                value: ctor,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
    }
};
else // old school shim for old browsers
module.exports = function inherits(ctor, superCtor) {
    if (superCtor) {
        ctor.super_ = superCtor;
        var TempCtor = function TempCtor() {};
        TempCtor.prototype = superCtor.prototype;
        ctor.prototype = new TempCtor();
        ctor.prototype.constructor = ctor;
    }
};

});


parcelRegister("7S5PM", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
module.exports = $5bb21a167842f93b$var$Stream;

var $bHhxw = parcelRequire("bHhxw");
var $5bb21a167842f93b$require$EE = $bHhxw.EventEmitter;

var $ACMoe = parcelRequire("ACMoe");
$ACMoe($5bb21a167842f93b$var$Stream, $5bb21a167842f93b$require$EE);

$5bb21a167842f93b$var$Stream.Readable = (parcelRequire("8KOo4"));

$5bb21a167842f93b$var$Stream.Writable = (parcelRequire("1jP7O"));

$5bb21a167842f93b$var$Stream.Duplex = (parcelRequire("5h9D2"));

$5bb21a167842f93b$var$Stream.Transform = (parcelRequire("7zqf0"));

$5bb21a167842f93b$var$Stream.PassThrough = (parcelRequire("lqaNH"));

$5bb21a167842f93b$var$Stream.finished = (parcelRequire("jCHM5"));

$5bb21a167842f93b$var$Stream.pipeline = (parcelRequire("lWAxK"));
// Backwards-compat with node 0.4.x
$5bb21a167842f93b$var$Stream.Stream = $5bb21a167842f93b$var$Stream;
// old-style streams.  Note that the pipe method (the only relevant
// part of this class) is overridden in the Readable class.
function $5bb21a167842f93b$var$Stream() {
    $5bb21a167842f93b$require$EE.call(this);
}
$5bb21a167842f93b$var$Stream.prototype.pipe = function(dest, options) {
    var source = this;
    function ondata(chunk) {
        if (dest.writable) {
            if (false === dest.write(chunk) && source.pause) source.pause();
        }
    }
    source.on('data', ondata);
    function ondrain() {
        if (source.readable && source.resume) source.resume();
    }
    dest.on('drain', ondrain);
    // If the 'end' option is not supplied, dest.end() will be called when
    // source gets the 'end' or 'close' events.  Only dest.end() once.
    if (!dest._isStdio && (!options || options.end !== false)) {
        source.on('end', onend);
        source.on('close', onclose);
    }
    var didOnEnd = false;
    function onend() {
        if (didOnEnd) return;
        didOnEnd = true;
        dest.end();
    }
    function onclose() {
        if (didOnEnd) return;
        didOnEnd = true;
        if (typeof dest.destroy === 'function') dest.destroy();
    }
    // don't leave dangling pipes when there are errors.
    function onerror(er) {
        cleanup();
        if ($5bb21a167842f93b$require$EE.listenerCount(this, 'error') === 0) throw er; // Unhandled stream error in pipe.
    }
    source.on('error', onerror);
    dest.on('error', onerror);
    // remove all the event listeners that were added.
    function cleanup() {
        source.removeListener('data', ondata);
        dest.removeListener('drain', ondrain);
        source.removeListener('end', onend);
        source.removeListener('close', onclose);
        source.removeListener('error', onerror);
        dest.removeListener('error', onerror);
        source.removeListener('end', cleanup);
        source.removeListener('close', cleanup);
        dest.removeListener('close', cleanup);
    }
    source.on('end', cleanup);
    source.on('close', cleanup);
    dest.on('close', cleanup);
    dest.emit('pipe', source);
    // Allow for unix-like usage: A.pipe(B).pipe(C)
    return dest;
};

});
parcelRegister("bHhxw", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

var $6tOPT = parcelRequire("6tOPT");
'use strict';
var $884150d9d84bc083$var$R = (typeof Reflect === "undefined" ? "undefined" : (0, $6tOPT._)(Reflect)) === 'object' ? Reflect : null;
var $884150d9d84bc083$var$ReflectApply = $884150d9d84bc083$var$R && typeof $884150d9d84bc083$var$R.apply === 'function' ? $884150d9d84bc083$var$R.apply : function ReflectApply(target, receiver, args) {
    return Function.prototype.apply.call(target, receiver, args);
};
var $884150d9d84bc083$var$ReflectOwnKeys;
if ($884150d9d84bc083$var$R && typeof $884150d9d84bc083$var$R.ownKeys === 'function') $884150d9d84bc083$var$ReflectOwnKeys = $884150d9d84bc083$var$R.ownKeys;
else if (Object.getOwnPropertySymbols) $884150d9d84bc083$var$ReflectOwnKeys = function ReflectOwnKeys(target) {
    return Object.getOwnPropertyNames(target).concat(Object.getOwnPropertySymbols(target));
};
else $884150d9d84bc083$var$ReflectOwnKeys = function ReflectOwnKeys(target) {
    return Object.getOwnPropertyNames(target);
};
function $884150d9d84bc083$var$ProcessEmitWarning(warning) {
    if (console && console.warn) console.warn(warning);
}
var $884150d9d84bc083$var$NumberIsNaN = Number.isNaN || function NumberIsNaN(value) {
    return value !== value;
};
function $884150d9d84bc083$var$EventEmitter() {
    $884150d9d84bc083$var$EventEmitter.init.call(this);
}
module.exports = $884150d9d84bc083$var$EventEmitter;
module.exports.once = $884150d9d84bc083$var$once;
// Backwards-compat with node 0.10.x
$884150d9d84bc083$var$EventEmitter.EventEmitter = $884150d9d84bc083$var$EventEmitter;
$884150d9d84bc083$var$EventEmitter.prototype._events = undefined;
$884150d9d84bc083$var$EventEmitter.prototype._eventsCount = 0;
$884150d9d84bc083$var$EventEmitter.prototype._maxListeners = undefined;
// By default EventEmitters will print a warning if more than 10 listeners are
// added to it. This is a useful default which helps finding memory leaks.
var $884150d9d84bc083$var$defaultMaxListeners = 10;
function $884150d9d84bc083$var$checkListener(listener) {
    if (typeof listener !== 'function') throw new TypeError('The "listener" argument must be of type Function. Received type ' + (typeof listener === "undefined" ? "undefined" : (0, $6tOPT._)(listener)));
}
Object.defineProperty($884150d9d84bc083$var$EventEmitter, 'defaultMaxListeners', {
    enumerable: true,
    get: function get() {
        return $884150d9d84bc083$var$defaultMaxListeners;
    },
    set: function set(arg) {
        if (typeof arg !== 'number' || arg < 0 || $884150d9d84bc083$var$NumberIsNaN(arg)) throw new RangeError('The value of "defaultMaxListeners" is out of range. It must be a non-negative number. Received ' + arg + '.');
        $884150d9d84bc083$var$defaultMaxListeners = arg;
    }
});
$884150d9d84bc083$var$EventEmitter.init = function() {
    if (this._events === undefined || this._events === Object.getPrototypeOf(this)._events) {
        this._events = Object.create(null);
        this._eventsCount = 0;
    }
    this._maxListeners = this._maxListeners || undefined;
};
// Obviously not all Emitters should be limited to 10. This function allows
// that to be increased. Set to zero for unlimited.
$884150d9d84bc083$var$EventEmitter.prototype.setMaxListeners = function setMaxListeners(n) {
    if (typeof n !== 'number' || n < 0 || $884150d9d84bc083$var$NumberIsNaN(n)) throw new RangeError('The value of "n" is out of range. It must be a non-negative number. Received ' + n + '.');
    this._maxListeners = n;
    return this;
};
function $884150d9d84bc083$var$_getMaxListeners(that) {
    if (that._maxListeners === undefined) return $884150d9d84bc083$var$EventEmitter.defaultMaxListeners;
    return that._maxListeners;
}
$884150d9d84bc083$var$EventEmitter.prototype.getMaxListeners = function getMaxListeners() {
    return $884150d9d84bc083$var$_getMaxListeners(this);
};
$884150d9d84bc083$var$EventEmitter.prototype.emit = function emit(type) {
    var args = [];
    for(var i = 1; i < arguments.length; i++)args.push(arguments[i]);
    var doError = type === 'error';
    var events = this._events;
    if (events !== undefined) doError = doError && events.error === undefined;
    else if (!doError) return false;
    // If there is no 'error' event listener then throw.
    if (doError) {
        var er;
        if (args.length > 0) er = args[0];
        if (er instanceof Error) // Note: The comments on the `throw` lines are intentional, they show
        // up in Node's output if this results in an unhandled exception.
        throw er; // Unhandled 'error' event
        // At least give some kind of context to the user
        var err = new Error('Unhandled error.' + (er ? ' (' + er.message + ')' : ''));
        err.context = er;
        throw err; // Unhandled 'error' event
    }
    var handler = events[type];
    if (handler === undefined) return false;
    if (typeof handler === 'function') $884150d9d84bc083$var$ReflectApply(handler, this, args);
    else {
        var len = handler.length;
        var listeners = $884150d9d84bc083$var$arrayClone(handler, len);
        for(var i = 0; i < len; ++i)$884150d9d84bc083$var$ReflectApply(listeners[i], this, args);
    }
    return true;
};
function $884150d9d84bc083$var$_addListener(target, type, listener, prepend) {
    var m;
    var events;
    var existing;
    $884150d9d84bc083$var$checkListener(listener);
    events = target._events;
    if (events === undefined) {
        events = target._events = Object.create(null);
        target._eventsCount = 0;
    } else {
        // To avoid recursion in the case that type === "newListener"! Before
        // adding it to the listeners, first emit "newListener".
        if (events.newListener !== undefined) {
            target.emit('newListener', type, listener.listener ? listener.listener : listener);
            // Re-assign `events` because a newListener handler could have caused the
            // this._events to be assigned to a new object
            events = target._events;
        }
        existing = events[type];
    }
    if (existing === undefined) {
        // Optimize the case of one listener. Don't need the extra array object.
        existing = events[type] = listener;
        ++target._eventsCount;
    } else {
        if (typeof existing === 'function') // Adding the second element, need to change to array.
        existing = events[type] = prepend ? [
            listener,
            existing
        ] : [
            existing,
            listener
        ];
        else if (prepend) existing.unshift(listener);
        else existing.push(listener);
        // Check for listener leak
        m = $884150d9d84bc083$var$_getMaxListeners(target);
        if (m > 0 && existing.length > m && !existing.warned) {
            existing.warned = true;
            // No error code for this since it is a Warning
            // eslint-disable-next-line no-restricted-syntax
            var w = new Error('Possible EventEmitter memory leak detected. ' + existing.length + ' ' + String(type) + ' listeners ' + 'added. Use emitter.setMaxListeners() to ' + 'increase limit');
            w.name = 'MaxListenersExceededWarning';
            w.emitter = target;
            w.type = type;
            w.count = existing.length;
            $884150d9d84bc083$var$ProcessEmitWarning(w);
        }
    }
    return target;
}
$884150d9d84bc083$var$EventEmitter.prototype.addListener = function addListener(type, listener) {
    return $884150d9d84bc083$var$_addListener(this, type, listener, false);
};
$884150d9d84bc083$var$EventEmitter.prototype.on = $884150d9d84bc083$var$EventEmitter.prototype.addListener;
$884150d9d84bc083$var$EventEmitter.prototype.prependListener = function prependListener(type, listener) {
    return $884150d9d84bc083$var$_addListener(this, type, listener, true);
};
function $884150d9d84bc083$var$onceWrapper() {
    if (!this.fired) {
        this.target.removeListener(this.type, this.wrapFn);
        this.fired = true;
        if (arguments.length === 0) return this.listener.call(this.target);
        return this.listener.apply(this.target, arguments);
    }
}
function $884150d9d84bc083$var$_onceWrap(target, type, listener) {
    var state = {
        fired: false,
        wrapFn: undefined,
        target: target,
        type: type,
        listener: listener
    };
    var wrapped = $884150d9d84bc083$var$onceWrapper.bind(state);
    wrapped.listener = listener;
    state.wrapFn = wrapped;
    return wrapped;
}
$884150d9d84bc083$var$EventEmitter.prototype.once = function once(type, listener) {
    $884150d9d84bc083$var$checkListener(listener);
    this.on(type, $884150d9d84bc083$var$_onceWrap(this, type, listener));
    return this;
};
$884150d9d84bc083$var$EventEmitter.prototype.prependOnceListener = function prependOnceListener(type, listener) {
    $884150d9d84bc083$var$checkListener(listener);
    this.prependListener(type, $884150d9d84bc083$var$_onceWrap(this, type, listener));
    return this;
};
// Emits a 'removeListener' event if and only if the listener was removed.
$884150d9d84bc083$var$EventEmitter.prototype.removeListener = function removeListener(type, listener) {
    var list, events, position, i, originalListener;
    $884150d9d84bc083$var$checkListener(listener);
    events = this._events;
    if (events === undefined) return this;
    list = events[type];
    if (list === undefined) return this;
    if (list === listener || list.listener === listener) {
        if (--this._eventsCount === 0) this._events = Object.create(null);
        else {
            delete events[type];
            if (events.removeListener) this.emit('removeListener', type, list.listener || listener);
        }
    } else if (typeof list !== 'function') {
        position = -1;
        for(i = list.length - 1; i >= 0; i--)if (list[i] === listener || list[i].listener === listener) {
            originalListener = list[i].listener;
            position = i;
            break;
        }
        if (position < 0) return this;
        if (position === 0) list.shift();
        else $884150d9d84bc083$var$spliceOne(list, position);
        if (list.length === 1) events[type] = list[0];
        if (events.removeListener !== undefined) this.emit('removeListener', type, originalListener || listener);
    }
    return this;
};
$884150d9d84bc083$var$EventEmitter.prototype.off = $884150d9d84bc083$var$EventEmitter.prototype.removeListener;
$884150d9d84bc083$var$EventEmitter.prototype.removeAllListeners = function removeAllListeners(type) {
    var listeners, events, i;
    events = this._events;
    if (events === undefined) return this;
    // not listening for removeListener, no need to emit
    if (events.removeListener === undefined) {
        if (arguments.length === 0) {
            this._events = Object.create(null);
            this._eventsCount = 0;
        } else if (events[type] !== undefined) {
            if (--this._eventsCount === 0) this._events = Object.create(null);
            else delete events[type];
        }
        return this;
    }
    // emit removeListener for all listeners on all events
    if (arguments.length === 0) {
        var keys = Object.keys(events);
        var key;
        for(i = 0; i < keys.length; ++i){
            key = keys[i];
            if (key === 'removeListener') continue;
            this.removeAllListeners(key);
        }
        this.removeAllListeners('removeListener');
        this._events = Object.create(null);
        this._eventsCount = 0;
        return this;
    }
    listeners = events[type];
    if (typeof listeners === 'function') this.removeListener(type, listeners);
    else if (listeners !== undefined) // LIFO order
    for(i = listeners.length - 1; i >= 0; i--)this.removeListener(type, listeners[i]);
    return this;
};
function $884150d9d84bc083$var$_listeners(target, type, unwrap) {
    var events = target._events;
    if (events === undefined) return [];
    var evlistener = events[type];
    if (evlistener === undefined) return [];
    if (typeof evlistener === 'function') return unwrap ? [
        evlistener.listener || evlistener
    ] : [
        evlistener
    ];
    return unwrap ? $884150d9d84bc083$var$unwrapListeners(evlistener) : $884150d9d84bc083$var$arrayClone(evlistener, evlistener.length);
}
$884150d9d84bc083$var$EventEmitter.prototype.listeners = function listeners(type) {
    return $884150d9d84bc083$var$_listeners(this, type, true);
};
$884150d9d84bc083$var$EventEmitter.prototype.rawListeners = function rawListeners(type) {
    return $884150d9d84bc083$var$_listeners(this, type, false);
};
$884150d9d84bc083$var$EventEmitter.listenerCount = function(emitter, type) {
    if (typeof emitter.listenerCount === 'function') return emitter.listenerCount(type);
    else return $884150d9d84bc083$var$listenerCount.call(emitter, type);
};
$884150d9d84bc083$var$EventEmitter.prototype.listenerCount = $884150d9d84bc083$var$listenerCount;
function $884150d9d84bc083$var$listenerCount(type) {
    var events = this._events;
    if (events !== undefined) {
        var evlistener = events[type];
        if (typeof evlistener === 'function') return 1;
        else if (evlistener !== undefined) return evlistener.length;
    }
    return 0;
}
$884150d9d84bc083$var$EventEmitter.prototype.eventNames = function eventNames() {
    return this._eventsCount > 0 ? $884150d9d84bc083$var$ReflectOwnKeys(this._events) : [];
};
function $884150d9d84bc083$var$arrayClone(arr, n) {
    var copy = new Array(n);
    for(var i = 0; i < n; ++i)copy[i] = arr[i];
    return copy;
}
function $884150d9d84bc083$var$spliceOne(list, index) {
    for(; index + 1 < list.length; index++)list[index] = list[index + 1];
    list.pop();
}
function $884150d9d84bc083$var$unwrapListeners(arr) {
    var ret = new Array(arr.length);
    for(var i = 0; i < ret.length; ++i)ret[i] = arr[i].listener || arr[i];
    return ret;
}
function $884150d9d84bc083$var$once(emitter, name) {
    return new Promise(function(resolve, reject) {
        function errorListener(err) {
            emitter.removeListener(name, resolver);
            reject(err);
        }
        function resolver() {
            if (typeof emitter.removeListener === 'function') emitter.removeListener('error', errorListener);
            resolve([].slice.call(arguments));
        }
        $884150d9d84bc083$var$eventTargetAgnosticAddListener(emitter, name, resolver, {
            once: true
        });
        if (name !== 'error') $884150d9d84bc083$var$addErrorHandlerIfEventEmitter(emitter, errorListener, {
            once: true
        });
    });
}
function $884150d9d84bc083$var$addErrorHandlerIfEventEmitter(emitter, handler, flags) {
    if (typeof emitter.on === 'function') $884150d9d84bc083$var$eventTargetAgnosticAddListener(emitter, 'error', handler, flags);
}
function $884150d9d84bc083$var$eventTargetAgnosticAddListener(emitter, name, listener, flags) {
    if (typeof emitter.on === 'function') {
        if (flags.once) emitter.once(name, listener);
        else emitter.on(name, listener);
    } else if (typeof emitter.addEventListener === 'function') // EventTarget does not have `error` event semantics like Node
    // EventEmitters, we do not listen for `error` events here.
    emitter.addEventListener(name, function wrapListener(arg) {
        // IE does not have builtin `{ once: true }` support so we
        // have to do it manually.
        if (flags.once) emitter.removeEventListener(name, wrapListener);
        listener(arg);
    });
    else throw new TypeError('The "emitter" argument must be of type EventEmitter. Received type ' + (typeof emitter === "undefined" ? "undefined" : (0, $6tOPT._)(emitter)));
}

});

parcelRegister("8KOo4", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

var $dKiQF = parcelRequire("dKiQF");
'use strict';
module.exports = $65f9b47715ba121b$var$Readable;
/*<replacement>*/ var $65f9b47715ba121b$var$Duplex;
/*</replacement>*/ $65f9b47715ba121b$var$Readable.ReadableState = $65f9b47715ba121b$var$ReadableState;

var $bHhxw = parcelRequire("bHhxw");
var $65f9b47715ba121b$require$EE = $bHhxw.EventEmitter;
var $65f9b47715ba121b$var$EElistenerCount = function EElistenerCount(emitter, type) {
    return emitter.listeners(type).length;
};

var $G78TW = parcelRequire("G78TW");

var $isEGv = parcelRequire("isEGv");
var $65f9b47715ba121b$require$Buffer = $isEGv.Buffer;
var $65f9b47715ba121b$var$OurUint8Array = (typeof $parcel$global !== 'undefined' ? $parcel$global : typeof window !== 'undefined' ? window : typeof self !== 'undefined' ? self : {}).Uint8Array || function() {};
function $65f9b47715ba121b$var$_uint8ArrayToBuffer(chunk) {
    return $65f9b47715ba121b$require$Buffer.from(chunk);
}
function $65f9b47715ba121b$var$_isUint8Array(obj) {
    return $65f9b47715ba121b$require$Buffer.isBuffer(obj) || obj instanceof $65f9b47715ba121b$var$OurUint8Array;
}

var $jfVOB = parcelRequire("jfVOB");
var $65f9b47715ba121b$var$debug;
if ($jfVOB && $jfVOB.debuglog) $65f9b47715ba121b$var$debug = $jfVOB.debuglog('stream');
else $65f9b47715ba121b$var$debug = function debug() {};

var $gXL1L = parcelRequire("gXL1L");

var $cGIaz = parcelRequire("cGIaz");

var $9I6ON = parcelRequire("9I6ON");
var $65f9b47715ba121b$var$getHighWaterMark = $9I6ON.getHighWaterMark;

var $eFrw3 = parcelRequire("eFrw3");
var $65f9b47715ba121b$require$_require$codes = $eFrw3.codes;
var $65f9b47715ba121b$var$ERR_INVALID_ARG_TYPE = $65f9b47715ba121b$require$_require$codes.ERR_INVALID_ARG_TYPE, $65f9b47715ba121b$var$ERR_STREAM_PUSH_AFTER_EOF = $65f9b47715ba121b$require$_require$codes.ERR_STREAM_PUSH_AFTER_EOF, $65f9b47715ba121b$var$ERR_METHOD_NOT_IMPLEMENTED = $65f9b47715ba121b$require$_require$codes.ERR_METHOD_NOT_IMPLEMENTED, $65f9b47715ba121b$var$ERR_STREAM_UNSHIFT_AFTER_END_EVENT = $65f9b47715ba121b$require$_require$codes.ERR_STREAM_UNSHIFT_AFTER_END_EVENT;
// Lazy loaded to improve the startup performance.
var $65f9b47715ba121b$var$StringDecoder;
var $65f9b47715ba121b$var$createReadableStreamAsyncIterator;
var $65f9b47715ba121b$var$from;

(parcelRequire("ACMoe"))($65f9b47715ba121b$var$Readable, $G78TW);
var $65f9b47715ba121b$var$errorOrDestroy = $cGIaz.errorOrDestroy;
var $65f9b47715ba121b$var$kProxyEvents = [
    'error',
    'close',
    'destroy',
    'pause',
    'resume'
];
function $65f9b47715ba121b$var$prependListener(emitter, event, fn) {
    // Sadly this is not cacheable as some libraries bundle their own
    // event emitter implementation with them.
    if (typeof emitter.prependListener === 'function') return emitter.prependListener(event, fn);
    // This is a hack to make sure that our error handler is attached before any
    // userland ones.  NEVER DO THIS. This is here only because this code needs
    // to continue to work with older versions of Node.js that do not include
    // the prependListener() method. The goal is to eventually remove this hack.
    if (!emitter._events || !emitter._events[event]) emitter.on(event, fn);
    else if (Array.isArray(emitter._events[event])) emitter._events[event].unshift(fn);
    else emitter._events[event] = [
        fn,
        emitter._events[event]
    ];
}


function $65f9b47715ba121b$var$ReadableState(options, stream, isDuplex) {
    $65f9b47715ba121b$var$Duplex = $65f9b47715ba121b$var$Duplex || (parcelRequire("5h9D2"));
    options = options || {};
    // Duplex streams are both readable and writable, but share
    // the same options object.
    // However, some cases require setting options to different
    // values for the readable and the writable sides of the duplex stream.
    // These options can be provided separately as readableXXX and writableXXX.
    if (typeof isDuplex !== 'boolean') isDuplex = stream instanceof $65f9b47715ba121b$var$Duplex;
    // object stream flag. Used to make read(n) ignore n and to
    // make all the buffer merging and length checks go away
    this.objectMode = !!options.objectMode;
    if (isDuplex) this.objectMode = this.objectMode || !!options.readableObjectMode;
    // the point at which it stops calling _read() to fill the buffer
    // Note: 0 is a valid value, means "don't call _read preemptively ever"
    this.highWaterMark = $65f9b47715ba121b$var$getHighWaterMark(this, options, 'readableHighWaterMark', isDuplex);
    // A linked list is used to store data chunks instead of an array because the
    // linked list can remove elements from the beginning faster than
    // array.shift()
    this.buffer = new $gXL1L();
    this.length = 0;
    this.pipes = null;
    this.pipesCount = 0;
    this.flowing = null;
    this.ended = false;
    this.endEmitted = false;
    this.reading = false;
    // a flag to be able to tell if the event 'readable'/'data' is emitted
    // immediately, or on a later tick.  We set this to true at first, because
    // any actions that shouldn't happen until "later" should generally also
    // not happen before the first read call.
    this.sync = true;
    // whenever we return null, then we set a flag to say
    // that we're awaiting a 'readable' event emission.
    this.needReadable = false;
    this.emittedReadable = false;
    this.readableListening = false;
    this.resumeScheduled = false;
    this.paused = true;
    // Should close be emitted on destroy. Defaults to true.
    this.emitClose = options.emitClose !== false;
    // Should .destroy() be called after 'end' (and potentially 'finish')
    this.autoDestroy = !!options.autoDestroy;
    // has it been destroyed
    this.destroyed = false;
    // Crypto is kind of old and crusty.  Historically, its default string
    // encoding is 'binary' so we have to make this configurable.
    // Everything else in the universe uses 'utf8', though.
    this.defaultEncoding = options.defaultEncoding || 'utf8';
    // the number of writers that are awaiting a drain event in .pipe()s
    this.awaitDrain = 0;
    // if true, a maybeReadMore has been scheduled
    this.readingMore = false;
    this.decoder = null;
    this.encoding = null;
    if (options.encoding) {
        if (!$65f9b47715ba121b$var$StringDecoder) $65f9b47715ba121b$var$StringDecoder = (parcelRequire("iSHBk")).StringDecoder;
        this.decoder = new $65f9b47715ba121b$var$StringDecoder(options.encoding);
        this.encoding = options.encoding;
    }
}

function $65f9b47715ba121b$var$Readable(options) {
    $65f9b47715ba121b$var$Duplex = $65f9b47715ba121b$var$Duplex || (parcelRequire("5h9D2"));
    if (!(this instanceof $65f9b47715ba121b$var$Readable)) return new $65f9b47715ba121b$var$Readable(options);
    // Checking for a Stream.Duplex instance is faster here instead of inside
    // the ReadableState constructor, at least with V8 6.5
    var isDuplex = this instanceof $65f9b47715ba121b$var$Duplex;
    this._readableState = new $65f9b47715ba121b$var$ReadableState(options, this, isDuplex);
    // legacy
    this.readable = true;
    if (options) {
        if (typeof options.read === 'function') this._read = options.read;
        if (typeof options.destroy === 'function') this._destroy = options.destroy;
    }
    $G78TW.call(this);
}
Object.defineProperty($65f9b47715ba121b$var$Readable.prototype, 'destroyed', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        if (this._readableState === undefined) return false;
        return this._readableState.destroyed;
    },
    set: function set(value) {
        // we ignore the value if the stream
        // has not been initialized yet
        if (!this._readableState) return;
        // backward compatibility, the user is explicitly
        // managing destroyed
        this._readableState.destroyed = value;
    }
});
$65f9b47715ba121b$var$Readable.prototype.destroy = $cGIaz.destroy;
$65f9b47715ba121b$var$Readable.prototype._undestroy = $cGIaz.undestroy;
$65f9b47715ba121b$var$Readable.prototype._destroy = function(err, cb) {
    cb(err);
};
// Manually shove something into the read() buffer.
// This returns true if the highWaterMark has not been hit yet,
// similar to how Writable.write() returns true if you should
// write() some more.
$65f9b47715ba121b$var$Readable.prototype.push = function(chunk, encoding) {
    var state = this._readableState;
    var skipChunkCheck;
    if (!state.objectMode) {
        if (typeof chunk === 'string') {
            encoding = encoding || state.defaultEncoding;
            if (encoding !== state.encoding) {
                chunk = $65f9b47715ba121b$require$Buffer.from(chunk, encoding);
                encoding = '';
            }
            skipChunkCheck = true;
        }
    } else skipChunkCheck = true;
    return $65f9b47715ba121b$var$readableAddChunk(this, chunk, encoding, false, skipChunkCheck);
};
// Unshift should *always* be something directly out of read()
$65f9b47715ba121b$var$Readable.prototype.unshift = function(chunk) {
    return $65f9b47715ba121b$var$readableAddChunk(this, chunk, null, true, false);
};
function $65f9b47715ba121b$var$readableAddChunk(stream, chunk, encoding, addToFront, skipChunkCheck) {
    $65f9b47715ba121b$var$debug('readableAddChunk', chunk);
    var state = stream._readableState;
    if (chunk === null) {
        state.reading = false;
        $65f9b47715ba121b$var$onEofChunk(stream, state);
    } else {
        var er;
        if (!skipChunkCheck) er = $65f9b47715ba121b$var$chunkInvalid(state, chunk);
        if (er) $65f9b47715ba121b$var$errorOrDestroy(stream, er);
        else if (state.objectMode || chunk && chunk.length > 0) {
            if (typeof chunk !== 'string' && !state.objectMode && Object.getPrototypeOf(chunk) !== $65f9b47715ba121b$require$Buffer.prototype) chunk = $65f9b47715ba121b$var$_uint8ArrayToBuffer(chunk);
            if (addToFront) {
                if (state.endEmitted) $65f9b47715ba121b$var$errorOrDestroy(stream, new $65f9b47715ba121b$var$ERR_STREAM_UNSHIFT_AFTER_END_EVENT());
                else $65f9b47715ba121b$var$addChunk(stream, state, chunk, true);
            } else if (state.ended) $65f9b47715ba121b$var$errorOrDestroy(stream, new $65f9b47715ba121b$var$ERR_STREAM_PUSH_AFTER_EOF());
            else if (state.destroyed) return false;
            else {
                state.reading = false;
                if (state.decoder && !encoding) {
                    chunk = state.decoder.write(chunk);
                    if (state.objectMode || chunk.length !== 0) $65f9b47715ba121b$var$addChunk(stream, state, chunk, false);
                    else $65f9b47715ba121b$var$maybeReadMore(stream, state);
                } else $65f9b47715ba121b$var$addChunk(stream, state, chunk, false);
            }
        } else if (!addToFront) {
            state.reading = false;
            $65f9b47715ba121b$var$maybeReadMore(stream, state);
        }
    }
    // We can push more data if we are below the highWaterMark.
    // Also, if we have no data yet, we can stand some more bytes.
    // This is to work around cases where hwm=0, such as the repl.
    return !state.ended && (state.length < state.highWaterMark || state.length === 0);
}
function $65f9b47715ba121b$var$addChunk(stream, state, chunk, addToFront) {
    if (state.flowing && state.length === 0 && !state.sync) {
        state.awaitDrain = 0;
        stream.emit('data', chunk);
    } else {
        // update the buffer info.
        state.length += state.objectMode ? 1 : chunk.length;
        if (addToFront) state.buffer.unshift(chunk);
        else state.buffer.push(chunk);
        if (state.needReadable) $65f9b47715ba121b$var$emitReadable(stream);
    }
    $65f9b47715ba121b$var$maybeReadMore(stream, state);
}
function $65f9b47715ba121b$var$chunkInvalid(state, chunk) {
    var er;
    if (!$65f9b47715ba121b$var$_isUint8Array(chunk) && typeof chunk !== 'string' && chunk !== undefined && !state.objectMode) er = new $65f9b47715ba121b$var$ERR_INVALID_ARG_TYPE('chunk', [
        'string',
        'Buffer',
        'Uint8Array'
    ], chunk);
    return er;
}
$65f9b47715ba121b$var$Readable.prototype.isPaused = function() {
    return this._readableState.flowing === false;
};

// backwards compatibility.
$65f9b47715ba121b$var$Readable.prototype.setEncoding = function(enc) {
    if (!$65f9b47715ba121b$var$StringDecoder) $65f9b47715ba121b$var$StringDecoder = (parcelRequire("iSHBk")).StringDecoder;
    var decoder = new $65f9b47715ba121b$var$StringDecoder(enc);
    this._readableState.decoder = decoder;
    // If setEncoding(null), decoder.encoding equals utf8
    this._readableState.encoding = this._readableState.decoder.encoding;
    // Iterate over current buffer to convert already stored Buffers:
    var p = this._readableState.buffer.head;
    var content = '';
    while(p !== null){
        content += decoder.write(p.data);
        p = p.next;
    }
    this._readableState.buffer.clear();
    if (content !== '') this._readableState.buffer.push(content);
    this._readableState.length = content.length;
    return this;
};
// Don't raise the hwm > 1GB
var $65f9b47715ba121b$var$MAX_HWM = 0x40000000;
function $65f9b47715ba121b$var$computeNewHighWaterMark(n) {
    if (n >= $65f9b47715ba121b$var$MAX_HWM) // TODO(ronag): Throw ERR_VALUE_OUT_OF_RANGE.
    n = $65f9b47715ba121b$var$MAX_HWM;
    else {
        // Get the next highest power of 2 to prevent increasing hwm excessively in
        // tiny amounts
        n--;
        n |= n >>> 1;
        n |= n >>> 2;
        n |= n >>> 4;
        n |= n >>> 8;
        n |= n >>> 16;
        n++;
    }
    return n;
}
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function $65f9b47715ba121b$var$howMuchToRead(n, state) {
    if (n <= 0 || state.length === 0 && state.ended) return 0;
    if (state.objectMode) return 1;
    if (n !== n) {
        // Only flow one buffer at a time
        if (state.flowing && state.length) return state.buffer.head.data.length;
        else return state.length;
    }
    // If we're asking for more than the current hwm, then raise the hwm.
    if (n > state.highWaterMark) state.highWaterMark = $65f9b47715ba121b$var$computeNewHighWaterMark(n);
    if (n <= state.length) return n;
    // Don't have enough
    if (!state.ended) {
        state.needReadable = true;
        return 0;
    }
    return state.length;
}
// you can override either this method, or the async _read(n) below.
$65f9b47715ba121b$var$Readable.prototype.read = function(n) {
    $65f9b47715ba121b$var$debug('read', n);
    n = parseInt(n, 10);
    var state = this._readableState;
    var nOrig = n;
    if (n !== 0) state.emittedReadable = false;
    // if we're doing read(0) to trigger a readable event, but we
    // already have a bunch of data in the buffer, then just trigger
    // the 'readable' event and move on.
    if (n === 0 && state.needReadable && ((state.highWaterMark !== 0 ? state.length >= state.highWaterMark : state.length > 0) || state.ended)) {
        $65f9b47715ba121b$var$debug('read: emitReadable', state.length, state.ended);
        if (state.length === 0 && state.ended) $65f9b47715ba121b$var$endReadable(this);
        else $65f9b47715ba121b$var$emitReadable(this);
        return null;
    }
    n = $65f9b47715ba121b$var$howMuchToRead(n, state);
    // if we've ended, and we're now clear, then finish it up.
    if (n === 0 && state.ended) {
        if (state.length === 0) $65f9b47715ba121b$var$endReadable(this);
        return null;
    }
    // All the actual chunk generation logic needs to be
    // *below* the call to _read.  The reason is that in certain
    // synthetic stream cases, such as passthrough streams, _read
    // may be a completely synchronous operation which may change
    // the state of the read buffer, providing enough data when
    // before there was *not* enough.
    //
    // So, the steps are:
    // 1. Figure out what the state of things will be after we do
    // a read from the buffer.
    //
    // 2. If that resulting state will trigger a _read, then call _read.
    // Note that this may be asynchronous, or synchronous.  Yes, it is
    // deeply ugly to write APIs this way, but that still doesn't mean
    // that the Readable class should behave improperly, as streams are
    // designed to be sync/async agnostic.
    // Take note if the _read call is sync or async (ie, if the read call
    // has returned yet), so that we know whether or not it's safe to emit
    // 'readable' etc.
    //
    // 3. Actually pull the requested chunks out of the buffer and return.
    // if we need a readable event, then we need to do some reading.
    var doRead = state.needReadable;
    $65f9b47715ba121b$var$debug('need readable', doRead);
    // if we currently have less than the highWaterMark, then also read some
    if (state.length === 0 || state.length - n < state.highWaterMark) {
        doRead = true;
        $65f9b47715ba121b$var$debug('length less than watermark', doRead);
    }
    // however, if we've ended, then there's no point, and if we're already
    // reading, then it's unnecessary.
    if (state.ended || state.reading) {
        doRead = false;
        $65f9b47715ba121b$var$debug('reading or ended', doRead);
    } else if (doRead) {
        $65f9b47715ba121b$var$debug('do read');
        state.reading = true;
        state.sync = true;
        // if the length is currently zero, then we *need* a readable event.
        if (state.length === 0) state.needReadable = true;
        // call internal read method
        this._read(state.highWaterMark);
        state.sync = false;
        // If _read pushed data synchronously, then `reading` will be false,
        // and we need to re-evaluate how much data we can return to the user.
        if (!state.reading) n = $65f9b47715ba121b$var$howMuchToRead(nOrig, state);
    }
    var ret;
    if (n > 0) ret = $65f9b47715ba121b$var$fromList(n, state);
    else ret = null;
    if (ret === null) {
        state.needReadable = state.length <= state.highWaterMark;
        n = 0;
    } else {
        state.length -= n;
        state.awaitDrain = 0;
    }
    if (state.length === 0) {
        // If we have nothing in the buffer, then we want to know
        // as soon as we *do* get something into the buffer.
        if (!state.ended) state.needReadable = true;
        // If we tried to read() past the EOF, then emit end on the next tick.
        if (nOrig !== n && state.ended) $65f9b47715ba121b$var$endReadable(this);
    }
    if (ret !== null) this.emit('data', ret);
    return ret;
};
function $65f9b47715ba121b$var$onEofChunk(stream, state) {
    $65f9b47715ba121b$var$debug('onEofChunk');
    if (state.ended) return;
    if (state.decoder) {
        var chunk = state.decoder.end();
        if (chunk && chunk.length) {
            state.buffer.push(chunk);
            state.length += state.objectMode ? 1 : chunk.length;
        }
    }
    state.ended = true;
    if (state.sync) // if we are sync, wait until next tick to emit the data.
    // Otherwise we risk emitting data in the flow()
    // the readable code triggers during a read() call
    $65f9b47715ba121b$var$emitReadable(stream);
    else {
        // emit 'readable' now to make sure it gets picked up.
        state.needReadable = false;
        if (!state.emittedReadable) {
            state.emittedReadable = true;
            $65f9b47715ba121b$var$emitReadable_(stream);
        }
    }
}
// Don't emit readable right away in sync mode, because this can trigger
// another read() call => stack overflow.  This way, it might trigger
// a nextTick recursion warning, but that's not so bad.
function $65f9b47715ba121b$var$emitReadable(stream) {
    var state = stream._readableState;
    $65f9b47715ba121b$var$debug('emitReadable', state.needReadable, state.emittedReadable);
    state.needReadable = false;
    if (!state.emittedReadable) {
        $65f9b47715ba121b$var$debug('emitReadable', state.flowing);
        state.emittedReadable = true;
        $dKiQF.nextTick($65f9b47715ba121b$var$emitReadable_, stream);
    }
}
function $65f9b47715ba121b$var$emitReadable_(stream) {
    var state = stream._readableState;
    $65f9b47715ba121b$var$debug('emitReadable_', state.destroyed, state.length, state.ended);
    if (!state.destroyed && (state.length || state.ended)) {
        stream.emit('readable');
        state.emittedReadable = false;
    }
    // The stream needs another readable event if
    // 1. It is not flowing, as the flow mechanism will take
    //    care of it.
    // 2. It is not ended.
    // 3. It is below the highWaterMark, so we can schedule
    //    another readable later.
    state.needReadable = !state.flowing && !state.ended && state.length <= state.highWaterMark;
    $65f9b47715ba121b$var$flow(stream);
}
// at this point, the user has presumably seen the 'readable' event,
// and called read() to consume some data.  that may have triggered
// in turn another _read(n) call, in which case reading = true if
// it's in progress.
// However, if we're not ended, or reading, and the length < hwm,
// then go ahead and try to read some more preemptively.
function $65f9b47715ba121b$var$maybeReadMore(stream, state) {
    if (!state.readingMore) {
        state.readingMore = true;
        $dKiQF.nextTick($65f9b47715ba121b$var$maybeReadMore_, stream, state);
    }
}
function $65f9b47715ba121b$var$maybeReadMore_(stream, state) {
    // Attempt to read more data if we should.
    //
    // The conditions for reading more data are (one of):
    // - Not enough data buffered (state.length < state.highWaterMark). The loop
    //   is responsible for filling the buffer with enough data if such data
    //   is available. If highWaterMark is 0 and we are not in the flowing mode
    //   we should _not_ attempt to buffer any extra data. We'll get more data
    //   when the stream consumer calls read() instead.
    // - No data in the buffer, and the stream is in flowing mode. In this mode
    //   the loop below is responsible for ensuring read() is called. Failing to
    //   call read here would abort the flow and there's no other mechanism for
    //   continuing the flow if the stream consumer has just subscribed to the
    //   'data' event.
    //
    // In addition to the above conditions to keep reading data, the following
    // conditions prevent the data from being read:
    // - The stream has ended (state.ended).
    // - There is already a pending 'read' operation (state.reading). This is a
    //   case where the the stream has called the implementation defined _read()
    //   method, but they are processing the call asynchronously and have _not_
    //   called push() with new data. In this case we skip performing more
    //   read()s. The execution ends in this method again after the _read() ends
    //   up calling push() with more data.
    while(!state.reading && !state.ended && (state.length < state.highWaterMark || state.flowing && state.length === 0)){
        var len = state.length;
        $65f9b47715ba121b$var$debug('maybeReadMore read 0');
        stream.read(0);
        if (len === state.length) break;
    }
    state.readingMore = false;
}
// abstract method.  to be overridden in specific implementation classes.
// call cb(er, data) where data is <= n in length.
// for virtual (non-string, non-buffer) streams, "length" is somewhat
// arbitrary, and perhaps not very meaningful.
$65f9b47715ba121b$var$Readable.prototype._read = function(n) {
    $65f9b47715ba121b$var$errorOrDestroy(this, new $65f9b47715ba121b$var$ERR_METHOD_NOT_IMPLEMENTED('_read()'));
};
$65f9b47715ba121b$var$Readable.prototype.pipe = function(dest, pipeOpts) {
    var src = this;
    var state = this._readableState;
    switch(state.pipesCount){
        case 0:
            state.pipes = dest;
            break;
        case 1:
            state.pipes = [
                state.pipes,
                dest
            ];
            break;
        default:
            state.pipes.push(dest);
            break;
    }
    state.pipesCount += 1;
    $65f9b47715ba121b$var$debug('pipe count=%d opts=%j', state.pipesCount, pipeOpts);
    var doEnd = (!pipeOpts || pipeOpts.end !== false) && dest !== $dKiQF.stdout && dest !== $dKiQF.stderr;
    var endFn = doEnd ? onend : unpipe;
    if (state.endEmitted) $dKiQF.nextTick(endFn);
    else src.once('end', endFn);
    dest.on('unpipe', onunpipe);
    function onunpipe(readable, unpipeInfo) {
        $65f9b47715ba121b$var$debug('onunpipe');
        if (readable === src) {
            if (unpipeInfo && unpipeInfo.hasUnpiped === false) {
                unpipeInfo.hasUnpiped = true;
                cleanup();
            }
        }
    }
    function onend() {
        $65f9b47715ba121b$var$debug('onend');
        dest.end();
    }
    // when the dest drains, it reduces the awaitDrain counter
    // on the source.  This would be more elegant with a .once()
    // handler in flow(), but adding and removing repeatedly is
    // too slow.
    var ondrain = $65f9b47715ba121b$var$pipeOnDrain(src);
    dest.on('drain', ondrain);
    var cleanedUp = false;
    function cleanup() {
        $65f9b47715ba121b$var$debug('cleanup');
        // cleanup event handlers once the pipe is broken
        dest.removeListener('close', onclose);
        dest.removeListener('finish', onfinish);
        dest.removeListener('drain', ondrain);
        dest.removeListener('error', onerror);
        dest.removeListener('unpipe', onunpipe);
        src.removeListener('end', onend);
        src.removeListener('end', unpipe);
        src.removeListener('data', ondata);
        cleanedUp = true;
        // if the reader is waiting for a drain event from this
        // specific writer, then it would cause it to never start
        // flowing again.
        // So, if this is awaiting a drain, then we just call it now.
        // If we don't know, then assume that we are waiting for one.
        if (state.awaitDrain && (!dest._writableState || dest._writableState.needDrain)) ondrain();
    }
    src.on('data', ondata);
    function ondata(chunk) {
        $65f9b47715ba121b$var$debug('ondata');
        var ret = dest.write(chunk);
        $65f9b47715ba121b$var$debug('dest.write', ret);
        if (ret === false) {
            // If the user unpiped during `dest.write()`, it is possible
            // to get stuck in a permanently paused state if that write
            // also returned false.
            // => Check whether `dest` is still a piping destination.
            if ((state.pipesCount === 1 && state.pipes === dest || state.pipesCount > 1 && $65f9b47715ba121b$var$indexOf(state.pipes, dest) !== -1) && !cleanedUp) {
                $65f9b47715ba121b$var$debug('false write response, pause', state.awaitDrain);
                state.awaitDrain++;
            }
            src.pause();
        }
    }
    // if the dest has an error, then stop piping into it.
    // however, don't suppress the throwing behavior for this.
    function onerror(er) {
        $65f9b47715ba121b$var$debug('onerror', er);
        unpipe();
        dest.removeListener('error', onerror);
        if ($65f9b47715ba121b$var$EElistenerCount(dest, 'error') === 0) $65f9b47715ba121b$var$errorOrDestroy(dest, er);
    }
    // Make sure our error handler is attached before userland ones.
    $65f9b47715ba121b$var$prependListener(dest, 'error', onerror);
    // Both close and finish should trigger unpipe, but only once.
    function onclose() {
        dest.removeListener('finish', onfinish);
        unpipe();
    }
    dest.once('close', onclose);
    function onfinish() {
        $65f9b47715ba121b$var$debug('onfinish');
        dest.removeListener('close', onclose);
        unpipe();
    }
    dest.once('finish', onfinish);
    function unpipe() {
        $65f9b47715ba121b$var$debug('unpipe');
        src.unpipe(dest);
    }
    // tell the dest that it's being piped to
    dest.emit('pipe', src);
    // start the flow if it hasn't been started already.
    if (!state.flowing) {
        $65f9b47715ba121b$var$debug('pipe resume');
        src.resume();
    }
    return dest;
};
function $65f9b47715ba121b$var$pipeOnDrain(src) {
    return function pipeOnDrainFunctionResult() {
        var state = src._readableState;
        $65f9b47715ba121b$var$debug('pipeOnDrain', state.awaitDrain);
        if (state.awaitDrain) state.awaitDrain--;
        if (state.awaitDrain === 0 && $65f9b47715ba121b$var$EElistenerCount(src, 'data')) {
            state.flowing = true;
            $65f9b47715ba121b$var$flow(src);
        }
    };
}
$65f9b47715ba121b$var$Readable.prototype.unpipe = function(dest) {
    var state = this._readableState;
    var unpipeInfo = {
        hasUnpiped: false
    };
    // if we're not piping anywhere, then do nothing.
    if (state.pipesCount === 0) return this;
    // just one destination.  most common case.
    if (state.pipesCount === 1) {
        // passed in one, but it's not the right one.
        if (dest && dest !== state.pipes) return this;
        if (!dest) dest = state.pipes;
        // got a match.
        state.pipes = null;
        state.pipesCount = 0;
        state.flowing = false;
        if (dest) dest.emit('unpipe', this, unpipeInfo);
        return this;
    }
    // slow case. multiple pipe destinations.
    if (!dest) {
        // remove all.
        var dests = state.pipes;
        var len = state.pipesCount;
        state.pipes = null;
        state.pipesCount = 0;
        state.flowing = false;
        for(var i = 0; i < len; i++)dests[i].emit('unpipe', this, {
            hasUnpiped: false
        });
        return this;
    }
    // try to find the right one.
    var index = $65f9b47715ba121b$var$indexOf(state.pipes, dest);
    if (index === -1) return this;
    state.pipes.splice(index, 1);
    state.pipesCount -= 1;
    if (state.pipesCount === 1) state.pipes = state.pipes[0];
    dest.emit('unpipe', this, unpipeInfo);
    return this;
};
// set up data events if they are asked for
// Ensure readable listeners eventually get something
$65f9b47715ba121b$var$Readable.prototype.on = function(ev, fn) {
    var res = $G78TW.prototype.on.call(this, ev, fn);
    var state = this._readableState;
    if (ev === 'data') {
        // update readableListening so that resume() may be a no-op
        // a few lines down. This is needed to support once('readable').
        state.readableListening = this.listenerCount('readable') > 0;
        // Try start flowing on next tick if stream isn't explicitly paused
        if (state.flowing !== false) this.resume();
    } else if (ev === 'readable') {
        if (!state.endEmitted && !state.readableListening) {
            state.readableListening = state.needReadable = true;
            state.flowing = false;
            state.emittedReadable = false;
            $65f9b47715ba121b$var$debug('on readable', state.length, state.reading);
            if (state.length) $65f9b47715ba121b$var$emitReadable(this);
            else if (!state.reading) $dKiQF.nextTick($65f9b47715ba121b$var$nReadingNextTick, this);
        }
    }
    return res;
};
$65f9b47715ba121b$var$Readable.prototype.addListener = $65f9b47715ba121b$var$Readable.prototype.on;
$65f9b47715ba121b$var$Readable.prototype.removeListener = function(ev, fn) {
    var res = $G78TW.prototype.removeListener.call(this, ev, fn);
    if (ev === 'readable') // We need to check if there is someone still listening to
    // readable and reset the state. However this needs to happen
    // after readable has been emitted but before I/O (nextTick) to
    // support once('readable', fn) cycles. This means that calling
    // resume within the same tick will have no
    // effect.
    $dKiQF.nextTick($65f9b47715ba121b$var$updateReadableListening, this);
    return res;
};
$65f9b47715ba121b$var$Readable.prototype.removeAllListeners = function(ev) {
    var res = $G78TW.prototype.removeAllListeners.apply(this, arguments);
    if (ev === 'readable' || ev === undefined) // We need to check if there is someone still listening to
    // readable and reset the state. However this needs to happen
    // after readable has been emitted but before I/O (nextTick) to
    // support once('readable', fn) cycles. This means that calling
    // resume within the same tick will have no
    // effect.
    $dKiQF.nextTick($65f9b47715ba121b$var$updateReadableListening, this);
    return res;
};
function $65f9b47715ba121b$var$updateReadableListening(self1) {
    var state = self1._readableState;
    state.readableListening = self1.listenerCount('readable') > 0;
    if (state.resumeScheduled && !state.paused) // flowing needs to be set to true now, otherwise
    // the upcoming resume will not flow.
    state.flowing = true;
    else if (self1.listenerCount('data') > 0) self1.resume();
}
function $65f9b47715ba121b$var$nReadingNextTick(self1) {
    $65f9b47715ba121b$var$debug('readable nexttick read 0');
    self1.read(0);
}
// pause() and resume() are remnants of the legacy readable stream API
// If the user uses them, then switch into old mode.
$65f9b47715ba121b$var$Readable.prototype.resume = function() {
    var state = this._readableState;
    if (!state.flowing) {
        $65f9b47715ba121b$var$debug('resume');
        // we flow only if there is no one listening
        // for readable, but we still have to call
        // resume()
        state.flowing = !state.readableListening;
        $65f9b47715ba121b$var$resume(this, state);
    }
    state.paused = false;
    return this;
};
function $65f9b47715ba121b$var$resume(stream, state) {
    if (!state.resumeScheduled) {
        state.resumeScheduled = true;
        $dKiQF.nextTick($65f9b47715ba121b$var$resume_, stream, state);
    }
}
function $65f9b47715ba121b$var$resume_(stream, state) {
    $65f9b47715ba121b$var$debug('resume', state.reading);
    if (!state.reading) stream.read(0);
    state.resumeScheduled = false;
    stream.emit('resume');
    $65f9b47715ba121b$var$flow(stream);
    if (state.flowing && !state.reading) stream.read(0);
}
$65f9b47715ba121b$var$Readable.prototype.pause = function() {
    $65f9b47715ba121b$var$debug('call pause flowing=%j', this._readableState.flowing);
    if (this._readableState.flowing !== false) {
        $65f9b47715ba121b$var$debug('pause');
        this._readableState.flowing = false;
        this.emit('pause');
    }
    this._readableState.paused = true;
    return this;
};
function $65f9b47715ba121b$var$flow(stream) {
    var state = stream._readableState;
    $65f9b47715ba121b$var$debug('flow', state.flowing);
    while(state.flowing && stream.read() !== null);
}
// wrap an old-style stream as the async data source.
// This is *not* part of the readable stream interface.
// It is an ugly unfortunate mess of history.
$65f9b47715ba121b$var$Readable.prototype.wrap = function(stream) {
    var _this = this;
    var state = this._readableState;
    var paused = false;
    stream.on('end', function() {
        $65f9b47715ba121b$var$debug('wrapped end');
        if (state.decoder && !state.ended) {
            var chunk = state.decoder.end();
            if (chunk && chunk.length) _this.push(chunk);
        }
        _this.push(null);
    });
    stream.on('data', function(chunk) {
        $65f9b47715ba121b$var$debug('wrapped data');
        if (state.decoder) chunk = state.decoder.write(chunk);
        // don't skip over falsy values in objectMode
        if (state.objectMode && (chunk === null || chunk === undefined)) return;
        else if (!state.objectMode && (!chunk || !chunk.length)) return;
        var ret = _this.push(chunk);
        if (!ret) {
            paused = true;
            stream.pause();
        }
    });
    // proxy all the other methods.
    // important when wrapping filters and duplexes.
    for(var i in stream)if (this[i] === undefined && typeof stream[i] === 'function') this[i] = function methodWrap(method) {
        return function methodWrapReturnFunction() {
            return stream[method].apply(stream, arguments);
        };
    }(i);
    // proxy certain important events.
    for(var n = 0; n < $65f9b47715ba121b$var$kProxyEvents.length; n++)stream.on($65f9b47715ba121b$var$kProxyEvents[n], this.emit.bind(this, $65f9b47715ba121b$var$kProxyEvents[n]));
    // when we try to consume some more bytes, simply unpause the
    // underlying stream.
    this._read = function(n) {
        $65f9b47715ba121b$var$debug('wrapped _read', n);
        if (paused) {
            paused = false;
            stream.resume();
        }
    };
    return this;
};

if (typeof Symbol === 'function') $65f9b47715ba121b$var$Readable.prototype[Symbol.asyncIterator] = function() {
    if ($65f9b47715ba121b$var$createReadableStreamAsyncIterator === undefined) $65f9b47715ba121b$var$createReadableStreamAsyncIterator = (parcelRequire("39wwT"));
    return $65f9b47715ba121b$var$createReadableStreamAsyncIterator(this);
};
Object.defineProperty($65f9b47715ba121b$var$Readable.prototype, 'readableHighWaterMark', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._readableState.highWaterMark;
    }
});
Object.defineProperty($65f9b47715ba121b$var$Readable.prototype, 'readableBuffer', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._readableState && this._readableState.buffer;
    }
});
Object.defineProperty($65f9b47715ba121b$var$Readable.prototype, 'readableFlowing', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._readableState.flowing;
    },
    set: function set(state) {
        if (this._readableState) this._readableState.flowing = state;
    }
});
// exposed for testing purposes only.
$65f9b47715ba121b$var$Readable._fromList = $65f9b47715ba121b$var$fromList;
Object.defineProperty($65f9b47715ba121b$var$Readable.prototype, 'readableLength', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._readableState.length;
    }
});
// Pluck off n bytes from an array of buffers.
// Length is the combined lengths of all the buffers in the list.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function $65f9b47715ba121b$var$fromList(n, state) {
    // nothing buffered
    if (state.length === 0) return null;
    var ret;
    if (state.objectMode) ret = state.buffer.shift();
    else if (!n || n >= state.length) {
        // read it all, truncate the list
        if (state.decoder) ret = state.buffer.join('');
        else if (state.buffer.length === 1) ret = state.buffer.first();
        else ret = state.buffer.concat(state.length);
        state.buffer.clear();
    } else // read part of list
    ret = state.buffer.consume(n, state.decoder);
    return ret;
}
function $65f9b47715ba121b$var$endReadable(stream) {
    var state = stream._readableState;
    $65f9b47715ba121b$var$debug('endReadable', state.endEmitted);
    if (!state.endEmitted) {
        state.ended = true;
        $dKiQF.nextTick($65f9b47715ba121b$var$endReadableNT, state, stream);
    }
}
function $65f9b47715ba121b$var$endReadableNT(state, stream) {
    $65f9b47715ba121b$var$debug('endReadableNT', state.endEmitted, state.length);
    // Check that we didn't get one last unshift.
    if (!state.endEmitted && state.length === 0) {
        state.endEmitted = true;
        stream.readable = false;
        stream.emit('end');
        if (state.autoDestroy) {
            // In case of duplex streams we need a way to detect
            // if the writable side is ready for autoDestroy as well
            var wState = stream._writableState;
            if (!wState || wState.autoDestroy && wState.finished) stream.destroy();
        }
    }
}

if (typeof Symbol === 'function') $65f9b47715ba121b$var$Readable.from = function(iterable, opts) {
    if ($65f9b47715ba121b$var$from === undefined) $65f9b47715ba121b$var$from = (parcelRequire("3G4jw"));
    return $65f9b47715ba121b$var$from($65f9b47715ba121b$var$Readable, iterable, opts);
};
function $65f9b47715ba121b$var$indexOf(xs, x) {
    for(var i = 0, l = xs.length; i < l; i++){
        if (xs[i] === x) return i;
    }
    return -1;
}

});
parcelRegister("G78TW", function(module, exports) {

module.exports = (parcelRequire("bHhxw")).EventEmitter;

});

parcelRegister("isEGv", function(module, exports) {

$parcel$export(module.exports, "Buffer", function () { return $d70a66a6e9945d07$export$a143d493d941bafc; }, function (v) { return $d70a66a6e9945d07$export$a143d493d941bafc = v; });
$parcel$export(module.exports, "SlowBuffer", function () { return $d70a66a6e9945d07$export$e4cf37d7f6fb9e0a; }, function (v) { return $d70a66a6e9945d07$export$e4cf37d7f6fb9e0a = v; });
$parcel$export(module.exports, "INSPECT_MAX_BYTES", function () { return $d70a66a6e9945d07$export$f99ded8fe4b79145; }, function (v) { return $d70a66a6e9945d07$export$f99ded8fe4b79145 = v; });
$parcel$export(module.exports, "kMaxLength", function () { return $d70a66a6e9945d07$export$599f31c3813fae4d; }, function (v) { return $d70a66a6e9945d07$export$599f31c3813fae4d = v; });
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ 
var $fxAKY = parcelRequire("fxAKY");

var $7eXQk = parcelRequire("7eXQk");

var $gApSC = parcelRequire("gApSC");

var $gNq0T = parcelRequire("gNq0T");

var $6tOPT = parcelRequire("6tOPT");
var $d70a66a6e9945d07$export$a143d493d941bafc;
var $d70a66a6e9945d07$export$e4cf37d7f6fb9e0a;
var $d70a66a6e9945d07$export$f99ded8fe4b79145;
var $d70a66a6e9945d07$export$599f31c3813fae4d;
'use strict';

var $4KaL9 = parcelRequire("4KaL9");

var $8o0zE = parcelRequire("8o0zE");
var $d70a66a6e9945d07$var$customInspectSymbol = typeof Symbol === 'function' && typeof Symbol['for'] === 'function' // eslint-disable-line dot-notation
 ? Symbol['for']('nodejs.util.inspect.custom') // eslint-disable-line dot-notation
 : null;
$d70a66a6e9945d07$export$a143d493d941bafc = $d70a66a6e9945d07$var$Buffer;
$d70a66a6e9945d07$export$e4cf37d7f6fb9e0a = $d70a66a6e9945d07$var$SlowBuffer;
$d70a66a6e9945d07$export$f99ded8fe4b79145 = 50;
var $d70a66a6e9945d07$var$K_MAX_LENGTH = 0x7fffffff;
$d70a66a6e9945d07$export$599f31c3813fae4d = $d70a66a6e9945d07$var$K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ $d70a66a6e9945d07$var$Buffer.TYPED_ARRAY_SUPPORT = $d70a66a6e9945d07$var$typedArraySupport();
if (!$d70a66a6e9945d07$var$Buffer.TYPED_ARRAY_SUPPORT && typeof console !== 'undefined' && typeof console.error === 'function') console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function $d70a66a6e9945d07$var$typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        var arr = new Uint8Array(1);
        var proto = {
            foo: function foo() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty($d70a66a6e9945d07$var$Buffer.prototype, 'parent', {
    enumerable: true,
    get: function get() {
        if (!$d70a66a6e9945d07$var$Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty($d70a66a6e9945d07$var$Buffer.prototype, 'offset', {
    enumerable: true,
    get: function get() {
        if (!$d70a66a6e9945d07$var$Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function $d70a66a6e9945d07$var$createBuffer(length) {
    if (length > $d70a66a6e9945d07$var$K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    var buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, $d70a66a6e9945d07$var$Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $d70a66a6e9945d07$var$Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === 'number') {
        if (typeof encodingOrOffset === 'string') throw new TypeError('The "string" argument must be of type string. Received type number');
        return $d70a66a6e9945d07$var$allocUnsafe(arg);
    }
    return $d70a66a6e9945d07$var$from(arg, encodingOrOffset, length);
}
$d70a66a6e9945d07$var$Buffer.poolSize = 8192 // not used by this implementation
;
function $d70a66a6e9945d07$var$from(value, encodingOrOffset, length) {
    if (typeof value === 'string') return $d70a66a6e9945d07$var$fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return $d70a66a6e9945d07$var$fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + (typeof value === "undefined" ? "undefined" : (0, $6tOPT._)(value)));
    if ($d70a66a6e9945d07$var$isInstance(value, ArrayBuffer) || value && $d70a66a6e9945d07$var$isInstance(value.buffer, ArrayBuffer)) return $d70a66a6e9945d07$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== 'undefined' && ($d70a66a6e9945d07$var$isInstance(value, SharedArrayBuffer) || value && $d70a66a6e9945d07$var$isInstance(value.buffer, SharedArrayBuffer))) return $d70a66a6e9945d07$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === 'number') throw new TypeError('The "value" argument must not be of type number. Received type number');
    var valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return $d70a66a6e9945d07$var$Buffer.from(valueOf, encodingOrOffset, length);
    var b = $d70a66a6e9945d07$var$fromObject(value);
    if (b) return b;
    if (typeof Symbol !== 'undefined' && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === 'function') return $d70a66a6e9945d07$var$Buffer.from(value[Symbol.toPrimitive]('string'), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + (typeof value === "undefined" ? "undefined" : (0, $6tOPT._)(value)));
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $d70a66a6e9945d07$var$Buffer.from = function(value, encodingOrOffset, length) {
    return $d70a66a6e9945d07$var$from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf($d70a66a6e9945d07$var$Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf($d70a66a6e9945d07$var$Buffer, Uint8Array);
function $d70a66a6e9945d07$var$assertSize(size) {
    if (typeof size !== 'number') throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function $d70a66a6e9945d07$var$alloc(size, fill, encoding) {
    $d70a66a6e9945d07$var$assertSize(size);
    if (size <= 0) return $d70a66a6e9945d07$var$createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === 'string' ? $d70a66a6e9945d07$var$createBuffer(size).fill(fill, encoding) : $d70a66a6e9945d07$var$createBuffer(size).fill(fill);
    return $d70a66a6e9945d07$var$createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $d70a66a6e9945d07$var$Buffer.alloc = function(size, fill, encoding) {
    return $d70a66a6e9945d07$var$alloc(size, fill, encoding);
};
function $d70a66a6e9945d07$var$allocUnsafe(size) {
    $d70a66a6e9945d07$var$assertSize(size);
    return $d70a66a6e9945d07$var$createBuffer(size < 0 ? 0 : $d70a66a6e9945d07$var$checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $d70a66a6e9945d07$var$Buffer.allocUnsafe = function(size) {
    return $d70a66a6e9945d07$var$allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $d70a66a6e9945d07$var$Buffer.allocUnsafeSlow = function(size) {
    return $d70a66a6e9945d07$var$allocUnsafe(size);
};
function $d70a66a6e9945d07$var$fromString(string, encoding) {
    if (typeof encoding !== 'string' || encoding === '') encoding = 'utf8';
    if (!$d70a66a6e9945d07$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
    var length = $d70a66a6e9945d07$var$byteLength(string, encoding) | 0;
    var buf = $d70a66a6e9945d07$var$createBuffer(length);
    var actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function $d70a66a6e9945d07$var$fromArrayLike(array) {
    var length = array.length < 0 ? 0 : $d70a66a6e9945d07$var$checked(array.length) | 0;
    var buf = $d70a66a6e9945d07$var$createBuffer(length);
    for(var i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function $d70a66a6e9945d07$var$fromArrayView(arrayView) {
    if ($d70a66a6e9945d07$var$isInstance(arrayView, Uint8Array)) {
        var copy = new Uint8Array(arrayView);
        return $d70a66a6e9945d07$var$fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return $d70a66a6e9945d07$var$fromArrayLike(arrayView);
}
function $d70a66a6e9945d07$var$fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    var buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, $d70a66a6e9945d07$var$Buffer.prototype);
    return buf;
}
function $d70a66a6e9945d07$var$fromObject(obj) {
    if ($d70a66a6e9945d07$var$Buffer.isBuffer(obj)) {
        var len = $d70a66a6e9945d07$var$checked(obj.length) | 0;
        var buf = $d70a66a6e9945d07$var$createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== 'number' || $d70a66a6e9945d07$var$numberIsNaN(obj.length)) return $d70a66a6e9945d07$var$createBuffer(0);
        return $d70a66a6e9945d07$var$fromArrayLike(obj);
    }
    if (obj.type === 'Buffer' && Array.isArray(obj.data)) return $d70a66a6e9945d07$var$fromArrayLike(obj.data);
}
function $d70a66a6e9945d07$var$checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $d70a66a6e9945d07$var$K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $d70a66a6e9945d07$var$K_MAX_LENGTH.toString(16) + ' bytes');
    return length | 0;
}
function $d70a66a6e9945d07$var$SlowBuffer(length) {
    if (+length != length) length = 0;
    return $d70a66a6e9945d07$var$Buffer.alloc(+length);
}
$d70a66a6e9945d07$var$Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== $d70a66a6e9945d07$var$Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
$d70a66a6e9945d07$var$Buffer.compare = function compare(a, b) {
    if ($d70a66a6e9945d07$var$isInstance(a, Uint8Array)) a = $d70a66a6e9945d07$var$Buffer.from(a, a.offset, a.byteLength);
    if ($d70a66a6e9945d07$var$isInstance(b, Uint8Array)) b = $d70a66a6e9945d07$var$Buffer.from(b, b.offset, b.byteLength);
    if (!$d70a66a6e9945d07$var$Buffer.isBuffer(a) || !$d70a66a6e9945d07$var$Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    var x = a.length;
    var y = b.length;
    for(var i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$d70a66a6e9945d07$var$Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case 'hex':
        case 'utf8':
        case 'utf-8':
        case 'ascii':
        case 'latin1':
        case 'binary':
        case 'base64':
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return true;
        default:
            return false;
    }
};
$d70a66a6e9945d07$var$Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $d70a66a6e9945d07$var$Buffer.alloc(0);
    var i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    var buffer = $d70a66a6e9945d07$var$Buffer.allocUnsafe(length);
    var pos = 0;
    for(i = 0; i < list.length; ++i){
        var buf = list[i];
        if ($d70a66a6e9945d07$var$isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) {
                if (!$d70a66a6e9945d07$var$Buffer.isBuffer(buf)) buf = $d70a66a6e9945d07$var$Buffer.from(buf);
                buf.copy(buffer, pos);
            } else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!$d70a66a6e9945d07$var$Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $d70a66a6e9945d07$var$byteLength(string, encoding) {
    if ($d70a66a6e9945d07$var$Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || $d70a66a6e9945d07$var$isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== 'string') throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + (typeof string === "undefined" ? "undefined" : (0, $6tOPT._)(string)));
    var len = string.length;
    var mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    var loweredCase = false;
    for(;;)switch(encoding){
        case 'ascii':
        case 'latin1':
        case 'binary':
            return len;
        case 'utf8':
        case 'utf-8':
            return $d70a66a6e9945d07$var$utf8ToBytes(string).length;
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return len * 2;
        case 'hex':
            return len >>> 1;
        case 'base64':
            return $d70a66a6e9945d07$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : $d70a66a6e9945d07$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
}
$d70a66a6e9945d07$var$Buffer.byteLength = $d70a66a6e9945d07$var$byteLength;
function $d70a66a6e9945d07$var$slowToString(encoding, start, end) {
    var loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return '';
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return '';
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return '';
    if (!encoding) encoding = 'utf8';
    while(true)switch(encoding){
        case 'hex':
            return $d70a66a6e9945d07$var$hexSlice(this, start, end);
        case 'utf8':
        case 'utf-8':
            return $d70a66a6e9945d07$var$utf8Slice(this, start, end);
        case 'ascii':
            return $d70a66a6e9945d07$var$asciiSlice(this, start, end);
        case 'latin1':
        case 'binary':
            return $d70a66a6e9945d07$var$latin1Slice(this, start, end);
        case 'base64':
            return $d70a66a6e9945d07$var$base64Slice(this, start, end);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $d70a66a6e9945d07$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = (encoding + '').toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
$d70a66a6e9945d07$var$Buffer.prototype._isBuffer = true;
function $d70a66a6e9945d07$var$swap(b, n, m) {
    var i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$d70a66a6e9945d07$var$Buffer.prototype.swap16 = function swap16() {
    var len = this.length;
    if (len % 2 !== 0) throw new RangeError('Buffer size must be a multiple of 16-bits');
    for(var i = 0; i < len; i += 2)$d70a66a6e9945d07$var$swap(this, i, i + 1);
    return this;
};
$d70a66a6e9945d07$var$Buffer.prototype.swap32 = function swap32() {
    var len = this.length;
    if (len % 4 !== 0) throw new RangeError('Buffer size must be a multiple of 32-bits');
    for(var i = 0; i < len; i += 4){
        $d70a66a6e9945d07$var$swap(this, i, i + 3);
        $d70a66a6e9945d07$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$d70a66a6e9945d07$var$Buffer.prototype.swap64 = function swap64() {
    var len = this.length;
    if (len % 8 !== 0) throw new RangeError('Buffer size must be a multiple of 64-bits');
    for(var i = 0; i < len; i += 8){
        $d70a66a6e9945d07$var$swap(this, i, i + 7);
        $d70a66a6e9945d07$var$swap(this, i + 1, i + 6);
        $d70a66a6e9945d07$var$swap(this, i + 2, i + 5);
        $d70a66a6e9945d07$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$d70a66a6e9945d07$var$Buffer.prototype.toString = function toString() {
    var length = this.length;
    if (length === 0) return '';
    if (arguments.length === 0) return $d70a66a6e9945d07$var$utf8Slice(this, 0, length);
    return $d70a66a6e9945d07$var$slowToString.apply(this, arguments);
};
$d70a66a6e9945d07$var$Buffer.prototype.toLocaleString = $d70a66a6e9945d07$var$Buffer.prototype.toString;
$d70a66a6e9945d07$var$Buffer.prototype.equals = function equals(b) {
    if (!$d70a66a6e9945d07$var$Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer');
    if (this === b) return true;
    return $d70a66a6e9945d07$var$Buffer.compare(this, b) === 0;
};
$d70a66a6e9945d07$var$Buffer.prototype.inspect = function inspect() {
    var str = '';
    var max = $d70a66a6e9945d07$export$f99ded8fe4b79145;
    str = this.toString('hex', 0, max).replace(/(.{2})/g, '$1 ').trim();
    if (this.length > max) str += ' ... ';
    return '<Buffer ' + str + '>';
};
if ($d70a66a6e9945d07$var$customInspectSymbol) $d70a66a6e9945d07$var$Buffer.prototype[$d70a66a6e9945d07$var$customInspectSymbol] = $d70a66a6e9945d07$var$Buffer.prototype.inspect;
$d70a66a6e9945d07$var$Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if ($d70a66a6e9945d07$var$isInstance(target, Uint8Array)) target = $d70a66a6e9945d07$var$Buffer.from(target, target.offset, target.byteLength);
    if (!$d70a66a6e9945d07$var$Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + (typeof target === "undefined" ? "undefined" : (0, $6tOPT._)(target)));
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError('out of range index');
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    var x = thisEnd - thisStart;
    var y = end - start;
    var len = Math.min(x, y);
    var thisCopy = this.slice(thisStart, thisEnd);
    var targetCopy = target.slice(start, end);
    for(var i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $d70a66a6e9945d07$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === 'string') {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if ($d70a66a6e9945d07$var$numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === 'string') val = $d70a66a6e9945d07$var$Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($d70a66a6e9945d07$var$Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $d70a66a6e9945d07$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === 'number') {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === 'function') {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $d70a66a6e9945d07$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError('val must be string, number or Buffer');
}
function $d70a66a6e9945d07$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    var indexSize = 1;
    var arrLength = arr.length;
    var valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === 'ucs2' || encoding === 'ucs-2' || encoding === 'utf16le' || encoding === 'utf-16le') {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    var i;
    if (dir) {
        var foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            var found = true;
            for(var j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$d70a66a6e9945d07$var$Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$d70a66a6e9945d07$var$Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $d70a66a6e9945d07$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$d70a66a6e9945d07$var$Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $d70a66a6e9945d07$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $d70a66a6e9945d07$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    var remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    var strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    var i;
    for(i = 0; i < length; ++i){
        var parsed = parseInt(string.substr(i * 2, 2), 16);
        if ($d70a66a6e9945d07$var$numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $d70a66a6e9945d07$var$utf8Write(buf, string, offset, length) {
    return $d70a66a6e9945d07$var$blitBuffer($d70a66a6e9945d07$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $d70a66a6e9945d07$var$asciiWrite(buf, string, offset, length) {
    return $d70a66a6e9945d07$var$blitBuffer($d70a66a6e9945d07$var$asciiToBytes(string), buf, offset, length);
}
function $d70a66a6e9945d07$var$base64Write(buf, string, offset, length) {
    return $d70a66a6e9945d07$var$blitBuffer($d70a66a6e9945d07$var$base64ToBytes(string), buf, offset, length);
}
function $d70a66a6e9945d07$var$ucs2Write(buf, string, offset, length) {
    return $d70a66a6e9945d07$var$blitBuffer($d70a66a6e9945d07$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$d70a66a6e9945d07$var$Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = 'utf8';
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === 'string') {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = 'utf8';
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error('Buffer.write(string, encoding, offset[, length]) is no longer supported');
    var remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError('Attempt to write outside buffer bounds');
    if (!encoding) encoding = 'utf8';
    var loweredCase = false;
    for(;;)switch(encoding){
        case 'hex':
            return $d70a66a6e9945d07$var$hexWrite(this, string, offset, length);
        case 'utf8':
        case 'utf-8':
            return $d70a66a6e9945d07$var$utf8Write(this, string, offset, length);
        case 'ascii':
        case 'latin1':
        case 'binary':
            return $d70a66a6e9945d07$var$asciiWrite(this, string, offset, length);
        case 'base64':
            // Warning: maxLength not taken into account in base64Write
            return $d70a66a6e9945d07$var$base64Write(this, string, offset, length);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $d70a66a6e9945d07$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
};
$d70a66a6e9945d07$var$Buffer.prototype.toJSON = function toJSON() {
    return {
        type: 'Buffer',
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $d70a66a6e9945d07$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $4KaL9.fromByteArray(buf);
    else return $4KaL9.fromByteArray(buf.slice(start, end));
}
function $d70a66a6e9945d07$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    var res = [];
    var i = start;
    while(i < end){
        var firstByte = buf[i];
        var codePoint = null;
        var bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            var secondByte = void 0, thirdByte = void 0, fourthByte = void 0, tempCodePoint = void 0;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $d70a66a6e9945d07$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
var $d70a66a6e9945d07$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $d70a66a6e9945d07$var$decodeCodePointsArray(codePoints) {
    var len = codePoints.length;
    if (len <= $d70a66a6e9945d07$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    var res = '';
    var i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $d70a66a6e9945d07$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $d70a66a6e9945d07$var$asciiSlice(buf, start, end) {
    var ret = '';
    end = Math.min(buf.length, end);
    for(var i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $d70a66a6e9945d07$var$latin1Slice(buf, start, end) {
    var ret = '';
    end = Math.min(buf.length, end);
    for(var i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $d70a66a6e9945d07$var$hexSlice(buf, start, end) {
    var len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    var out = '';
    for(var i = start; i < end; ++i)out += $d70a66a6e9945d07$var$hexSliceLookupTable[buf[i]];
    return out;
}
function $d70a66a6e9945d07$var$utf16leSlice(buf, start, end) {
    var bytes = buf.slice(start, end);
    var res = '';
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(var i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$d70a66a6e9945d07$var$Buffer.prototype.slice = function slice(start, end) {
    var len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    var newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, $d70a66a6e9945d07$var$Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $d70a66a6e9945d07$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError('offset is not uint');
    if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length');
}
$d70a66a6e9945d07$var$Buffer.prototype.readUintLE = $d70a66a6e9945d07$var$Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $d70a66a6e9945d07$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset];
    var mul = 1;
    var i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$d70a66a6e9945d07$var$Buffer.prototype.readUintBE = $d70a66a6e9945d07$var$Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $d70a66a6e9945d07$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset + --byteLength];
    var mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$d70a66a6e9945d07$var$Buffer.prototype.readUint8 = $d70a66a6e9945d07$var$Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $d70a66a6e9945d07$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$d70a66a6e9945d07$var$Buffer.prototype.readUint16LE = $d70a66a6e9945d07$var$Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $d70a66a6e9945d07$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$d70a66a6e9945d07$var$Buffer.prototype.readUint16BE = $d70a66a6e9945d07$var$Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $d70a66a6e9945d07$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$d70a66a6e9945d07$var$Buffer.prototype.readUint32LE = $d70a66a6e9945d07$var$Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $d70a66a6e9945d07$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$d70a66a6e9945d07$var$Buffer.prototype.readUint32BE = $d70a66a6e9945d07$var$Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $d70a66a6e9945d07$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$d70a66a6e9945d07$var$Buffer.prototype.readBigUInt64LE = $d70a66a6e9945d07$var$defineBigIntMethod(function readBigUInt64LE(offset) {
    offset = offset >>> 0;
    $d70a66a6e9945d07$var$validateNumber(offset, 'offset');
    var first = this[offset];
    var last = this[offset + 7];
    if (first === undefined || last === undefined) $d70a66a6e9945d07$var$boundsError(offset, this.length - 8);
    var lo = first + this[++offset] * 256 + this[++offset] * Math.pow(2, 16) + this[++offset] * Math.pow(2, 24);
    var hi = this[++offset] + this[++offset] * 256 + this[++offset] * Math.pow(2, 16) + last * Math.pow(2, 24);
    return BigInt(lo) + (BigInt(hi) << BigInt(32));
});
$d70a66a6e9945d07$var$Buffer.prototype.readBigUInt64BE = $d70a66a6e9945d07$var$defineBigIntMethod(function readBigUInt64BE(offset) {
    offset = offset >>> 0;
    $d70a66a6e9945d07$var$validateNumber(offset, 'offset');
    var first = this[offset];
    var last = this[offset + 7];
    if (first === undefined || last === undefined) $d70a66a6e9945d07$var$boundsError(offset, this.length - 8);
    var hi = first * Math.pow(2, 24) + this[++offset] * Math.pow(2, 16) + this[++offset] * 256 + this[++offset];
    var lo = this[++offset] * Math.pow(2, 24) + this[++offset] * Math.pow(2, 16) + this[++offset] * 256 + last;
    return (BigInt(hi) << BigInt(32)) + BigInt(lo);
});
$d70a66a6e9945d07$var$Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $d70a66a6e9945d07$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset];
    var mul = 1;
    var i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$d70a66a6e9945d07$var$Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $d70a66a6e9945d07$var$checkOffset(offset, byteLength, this.length);
    var i = byteLength;
    var mul = 1;
    var val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$d70a66a6e9945d07$var$Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $d70a66a6e9945d07$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$d70a66a6e9945d07$var$Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $d70a66a6e9945d07$var$checkOffset(offset, 2, this.length);
    var val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$d70a66a6e9945d07$var$Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $d70a66a6e9945d07$var$checkOffset(offset, 2, this.length);
    var val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$d70a66a6e9945d07$var$Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $d70a66a6e9945d07$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$d70a66a6e9945d07$var$Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $d70a66a6e9945d07$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$d70a66a6e9945d07$var$Buffer.prototype.readBigInt64LE = $d70a66a6e9945d07$var$defineBigIntMethod(function readBigInt64LE(offset) {
    offset = offset >>> 0;
    $d70a66a6e9945d07$var$validateNumber(offset, 'offset');
    var first = this[offset];
    var last = this[offset + 7];
    if (first === undefined || last === undefined) $d70a66a6e9945d07$var$boundsError(offset, this.length - 8);
    var val = this[offset + 4] + this[offset + 5] * 256 + this[offset + 6] * Math.pow(2, 16) + (last << 24 // Overflow
    );
    return (BigInt(val) << BigInt(32)) + BigInt(first + this[++offset] * 256 + this[++offset] * Math.pow(2, 16) + this[++offset] * Math.pow(2, 24));
});
$d70a66a6e9945d07$var$Buffer.prototype.readBigInt64BE = $d70a66a6e9945d07$var$defineBigIntMethod(function readBigInt64BE(offset) {
    offset = offset >>> 0;
    $d70a66a6e9945d07$var$validateNumber(offset, 'offset');
    var first = this[offset];
    var last = this[offset + 7];
    if (first === undefined || last === undefined) $d70a66a6e9945d07$var$boundsError(offset, this.length - 8);
    var val = (first << 24) + // Overflow
    this[++offset] * Math.pow(2, 16) + this[++offset] * 256 + this[++offset];
    return (BigInt(val) << BigInt(32)) + BigInt(this[++offset] * Math.pow(2, 24) + this[++offset] * Math.pow(2, 16) + this[++offset] * 256 + last);
});
$d70a66a6e9945d07$var$Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $d70a66a6e9945d07$var$checkOffset(offset, 4, this.length);
    return $8o0zE.read(this, offset, true, 23, 4);
};
$d70a66a6e9945d07$var$Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $d70a66a6e9945d07$var$checkOffset(offset, 4, this.length);
    return $8o0zE.read(this, offset, false, 23, 4);
};
$d70a66a6e9945d07$var$Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $d70a66a6e9945d07$var$checkOffset(offset, 8, this.length);
    return $8o0zE.read(this, offset, true, 52, 8);
};
$d70a66a6e9945d07$var$Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $d70a66a6e9945d07$var$checkOffset(offset, 8, this.length);
    return $8o0zE.read(this, offset, false, 52, 8);
};
function $d70a66a6e9945d07$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$d70a66a6e9945d07$var$Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
}
$d70a66a6e9945d07$var$Buffer.prototype.writeUintLE = $d70a66a6e9945d07$var$Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        var maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $d70a66a6e9945d07$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    var mul = 1;
    var i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$d70a66a6e9945d07$var$Buffer.prototype.writeUintBE = $d70a66a6e9945d07$var$Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        var maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $d70a66a6e9945d07$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    var i = byteLength - 1;
    var mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$d70a66a6e9945d07$var$Buffer.prototype.writeUint8 = $d70a66a6e9945d07$var$Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $d70a66a6e9945d07$var$checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
$d70a66a6e9945d07$var$Buffer.prototype.writeUint16LE = $d70a66a6e9945d07$var$Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $d70a66a6e9945d07$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$d70a66a6e9945d07$var$Buffer.prototype.writeUint16BE = $d70a66a6e9945d07$var$Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $d70a66a6e9945d07$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$d70a66a6e9945d07$var$Buffer.prototype.writeUint32LE = $d70a66a6e9945d07$var$Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $d70a66a6e9945d07$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
$d70a66a6e9945d07$var$Buffer.prototype.writeUint32BE = $d70a66a6e9945d07$var$Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $d70a66a6e9945d07$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function $d70a66a6e9945d07$var$wrtBigUInt64LE(buf, value, offset, min, max) {
    $d70a66a6e9945d07$var$checkIntBI(value, min, max, buf, offset, 7);
    var lo = Number(value & BigInt(0xffffffff));
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    var hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    return offset;
}
function $d70a66a6e9945d07$var$wrtBigUInt64BE(buf, value, offset, min, max) {
    $d70a66a6e9945d07$var$checkIntBI(value, min, max, buf, offset, 7);
    var lo = Number(value & BigInt(0xffffffff));
    buf[offset + 7] = lo;
    lo = lo >> 8;
    buf[offset + 6] = lo;
    lo = lo >> 8;
    buf[offset + 5] = lo;
    lo = lo >> 8;
    buf[offset + 4] = lo;
    var hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset + 3] = hi;
    hi = hi >> 8;
    buf[offset + 2] = hi;
    hi = hi >> 8;
    buf[offset + 1] = hi;
    hi = hi >> 8;
    buf[offset] = hi;
    return offset + 8;
}
$d70a66a6e9945d07$var$Buffer.prototype.writeBigUInt64LE = $d70a66a6e9945d07$var$defineBigIntMethod(function writeBigUInt64LE(value) {
    var offset = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
    return $d70a66a6e9945d07$var$wrtBigUInt64LE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
$d70a66a6e9945d07$var$Buffer.prototype.writeBigUInt64BE = $d70a66a6e9945d07$var$defineBigIntMethod(function writeBigUInt64BE(value) {
    var offset = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
    return $d70a66a6e9945d07$var$wrtBigUInt64BE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
$d70a66a6e9945d07$var$Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        var limit = Math.pow(2, 8 * byteLength - 1);
        $d70a66a6e9945d07$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    var i = 0;
    var mul = 1;
    var sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$d70a66a6e9945d07$var$Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        var limit = Math.pow(2, 8 * byteLength - 1);
        $d70a66a6e9945d07$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    var i = byteLength - 1;
    var mul = 1;
    var sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$d70a66a6e9945d07$var$Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $d70a66a6e9945d07$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$d70a66a6e9945d07$var$Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $d70a66a6e9945d07$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$d70a66a6e9945d07$var$Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $d70a66a6e9945d07$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$d70a66a6e9945d07$var$Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $d70a66a6e9945d07$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
$d70a66a6e9945d07$var$Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $d70a66a6e9945d07$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
$d70a66a6e9945d07$var$Buffer.prototype.writeBigInt64LE = $d70a66a6e9945d07$var$defineBigIntMethod(function writeBigInt64LE(value) {
    var offset = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
    return $d70a66a6e9945d07$var$wrtBigUInt64LE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
$d70a66a6e9945d07$var$Buffer.prototype.writeBigInt64BE = $d70a66a6e9945d07$var$defineBigIntMethod(function writeBigInt64BE(value) {
    var offset = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
    return $d70a66a6e9945d07$var$wrtBigUInt64BE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
function $d70a66a6e9945d07$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
    if (offset < 0) throw new RangeError('Index out of range');
}
function $d70a66a6e9945d07$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $d70a66a6e9945d07$var$checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    $8o0zE.write(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$d70a66a6e9945d07$var$Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $d70a66a6e9945d07$var$writeFloat(this, value, offset, true, noAssert);
};
$d70a66a6e9945d07$var$Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $d70a66a6e9945d07$var$writeFloat(this, value, offset, false, noAssert);
};
function $d70a66a6e9945d07$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $d70a66a6e9945d07$var$checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    $8o0zE.write(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$d70a66a6e9945d07$var$Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $d70a66a6e9945d07$var$writeDouble(this, value, offset, true, noAssert);
};
$d70a66a6e9945d07$var$Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $d70a66a6e9945d07$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$d70a66a6e9945d07$var$Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!$d70a66a6e9945d07$var$Buffer.isBuffer(target)) throw new TypeError('argument should be a Buffer');
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError('targetStart out of bounds');
    if (start < 0 || start >= this.length) throw new RangeError('Index out of range');
    if (end < 0) throw new RangeError('sourceEnd out of bounds');
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    var len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === 'function') // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$d70a66a6e9945d07$var$Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === 'string') {
        if (typeof start === 'string') {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === 'string') {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== 'string') throw new TypeError('encoding must be a string');
        if (typeof encoding === 'string' && !$d70a66a6e9945d07$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
        if (val.length === 1) {
            var code = val.charCodeAt(0);
            if (encoding === 'utf8' && code < 128 || encoding === 'latin1') // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === 'number') val = val & 255;
    else if (typeof val === 'boolean') val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError('Out of range index');
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    var i;
    if (typeof val === 'number') for(i = start; i < end; ++i)this[i] = val;
    else {
        var bytes = $d70a66a6e9945d07$var$Buffer.isBuffer(val) ? val : $d70a66a6e9945d07$var$Buffer.from(val, encoding);
        var len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// CUSTOM ERRORS
// =============
// Simplified versions from Node, changed for Buffer-only usage
var $d70a66a6e9945d07$var$errors = {};
function $d70a66a6e9945d07$var$E(sym, getMessage, Base) {
    $d70a66a6e9945d07$var$errors[sym] = /*#__PURE__*/ function(Base) {
        (0, $gNq0T._)(NodeError, Base);
        function NodeError() {
            (0, $7eXQk._)(this, NodeError);
            var _this;
            _this = (0, $fxAKY._)(this, NodeError);
            Object.defineProperty(_this, 'message', {
                value: getMessage.apply(_this, arguments),
                writable: true,
                configurable: true
            });
            // Add the error code to the name to include it in the stack trace.
            _this.name = "".concat(_this.name, " [").concat(sym, "]");
            // Access the stack to generate the error message including the error code
            // from the name.
            _this.stack // eslint-disable-line no-unused-expressions
            ;
            // Reset the name to the actual name.
            delete _this.name;
            return _this;
        }
        (0, $gApSC._)(NodeError, [
            {
                key: "code",
                get: function get() {
                    return sym;
                },
                set: function set(value) {
                    Object.defineProperty(this, 'code', {
                        configurable: true,
                        enumerable: true,
                        value: value,
                        writable: true
                    });
                }
            },
            {
                key: "toString",
                value: function toString() {
                    return "".concat(this.name, " [").concat(sym, "]: ").concat(this.message);
                }
            }
        ]);
        return NodeError;
    }(Base);
}
$d70a66a6e9945d07$var$E('ERR_BUFFER_OUT_OF_BOUNDS', function(name) {
    if (name) return "".concat(name, " is outside of buffer bounds");
    return 'Attempt to access memory outside buffer bounds';
}, RangeError);
$d70a66a6e9945d07$var$E('ERR_INVALID_ARG_TYPE', function(name, actual) {
    return 'The "'.concat(name, '" argument must be of type number. Received type ').concat(typeof actual === "undefined" ? "undefined" : (0, $6tOPT._)(actual));
}, TypeError);
$d70a66a6e9945d07$var$E('ERR_OUT_OF_RANGE', function(str, range, input) {
    var msg = 'The value of "'.concat(str, '" is out of range.');
    var received = input;
    if (Number.isInteger(input) && Math.abs(input) > Math.pow(2, 32)) received = $d70a66a6e9945d07$var$addNumericalSeparator(String(input));
    else if ((typeof input === "undefined" ? "undefined" : (0, $6tOPT._)(input)) === 'bigint') {
        received = String(input);
        if (input > Math.pow(BigInt(2), BigInt(32)) || input < -Math.pow(BigInt(2), BigInt(32))) received = $d70a66a6e9945d07$var$addNumericalSeparator(received);
        received += 'n';
    }
    msg += " It must be ".concat(range, ". Received ").concat(received);
    return msg;
}, RangeError);
function $d70a66a6e9945d07$var$addNumericalSeparator(val) {
    var res = '';
    var i = val.length;
    var start = val[0] === '-' ? 1 : 0;
    for(; i >= start + 4; i -= 3)res = "_".concat(val.slice(i - 3, i)).concat(res);
    return "".concat(val.slice(0, i)).concat(res);
}
// CHECK FUNCTIONS
// ===============
function $d70a66a6e9945d07$var$checkBounds(buf, offset, byteLength) {
    $d70a66a6e9945d07$var$validateNumber(offset, 'offset');
    if (buf[offset] === undefined || buf[offset + byteLength] === undefined) $d70a66a6e9945d07$var$boundsError(offset, buf.length - (byteLength + 1));
}
function $d70a66a6e9945d07$var$checkIntBI(value, min, max, buf, offset, byteLength) {
    if (value > max || value < min) {
        var n = (typeof min === "undefined" ? "undefined" : (0, $6tOPT._)(min)) === 'bigint' ? 'n' : '';
        var range;
        if (byteLength > 3) {
            if (min === 0 || min === BigInt(0)) range = ">= 0".concat(n, " and < 2").concat(n, " ** ").concat((byteLength + 1) * 8).concat(n);
            else range = ">= -(2".concat(n, " ** ").concat((byteLength + 1) * 8 - 1).concat(n, ") and < 2 ** ") + "".concat((byteLength + 1) * 8 - 1).concat(n);
        } else range = ">= ".concat(min).concat(n, " and <= ").concat(max).concat(n);
        throw new $d70a66a6e9945d07$var$errors.ERR_OUT_OF_RANGE('value', range, value);
    }
    $d70a66a6e9945d07$var$checkBounds(buf, offset, byteLength);
}
function $d70a66a6e9945d07$var$validateNumber(value, name) {
    if (typeof value !== 'number') throw new $d70a66a6e9945d07$var$errors.ERR_INVALID_ARG_TYPE(name, 'number', value);
}
function $d70a66a6e9945d07$var$boundsError(value, length, type) {
    if (Math.floor(value) !== value) {
        $d70a66a6e9945d07$var$validateNumber(value, type);
        throw new $d70a66a6e9945d07$var$errors.ERR_OUT_OF_RANGE(type || 'offset', 'an integer', value);
    }
    if (length < 0) throw new $d70a66a6e9945d07$var$errors.ERR_BUFFER_OUT_OF_BOUNDS();
    throw new $d70a66a6e9945d07$var$errors.ERR_OUT_OF_RANGE(type || 'offset', ">= ".concat(type ? 1 : 0, " and <= ").concat(length), value);
}
// HELPER FUNCTIONS
// ================
var $d70a66a6e9945d07$var$INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function $d70a66a6e9945d07$var$base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split('=')[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace($d70a66a6e9945d07$var$INVALID_BASE64_RE, '');
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return '';
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + '=';
    return str;
}
function $d70a66a6e9945d07$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    var codePoint;
    var length = string.length;
    var leadSurrogate = null;
    var bytes = [];
    for(var i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error('Invalid code point');
    }
    return bytes;
}
function $d70a66a6e9945d07$var$asciiToBytes(str) {
    var byteArray = [];
    for(var i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $d70a66a6e9945d07$var$utf16leToBytes(str, units) {
    var c, hi, lo;
    var byteArray = [];
    for(var i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $d70a66a6e9945d07$var$base64ToBytes(str) {
    return $4KaL9.toByteArray($d70a66a6e9945d07$var$base64clean(str));
}
function $d70a66a6e9945d07$var$blitBuffer(src, dst, offset, length) {
    var i;
    for(i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function $d70a66a6e9945d07$var$isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function $d70a66a6e9945d07$var$numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
var $d70a66a6e9945d07$var$hexSliceLookupTable = function() {
    var alphabet = '0123456789abcdef';
    var table = new Array(256);
    for(var i = 0; i < 16; ++i){
        var i16 = i * 16;
        for(var j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();
// Return not function with Error if BigInt not supported
function $d70a66a6e9945d07$var$defineBigIntMethod(fn) {
    return typeof BigInt === 'undefined' ? $d70a66a6e9945d07$var$BufferBigIntNotDefined : fn;
}
function $d70a66a6e9945d07$var$BufferBigIntNotDefined() {
    throw new Error('BigInt not supported');
}

});
parcelRegister("fxAKY", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $b50673295b18996e$export$71511d61b312f219; });

var $8rIKe = parcelRequire("8rIKe");

var $axy3d = parcelRequire("axy3d");

var $8rit2 = parcelRequire("8rit2");
function $b50673295b18996e$export$71511d61b312f219(_this, derived, args) {
    // Super
    derived = (0, $8rIKe._)(derived);
    return (0, $8rit2._)(_this, (0, $axy3d._)() ? Reflect.construct(derived, args || [], (0, $8rIKe._)(_this).constructor) : derived.apply(_this, args));
}

});
parcelRegister("8rIKe", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $62638db445ca7b37$export$71511d61b312f219; });
function $62638db445ca7b37$export$71511d61b312f219(o) {
    $62638db445ca7b37$export$71511d61b312f219 = Object.setPrototypeOf ? Object.getPrototypeOf : function getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $62638db445ca7b37$export$71511d61b312f219(o);
}

});

parcelRegister("axy3d", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $7ac76641933b05b9$export$71511d61b312f219; });
function $7ac76641933b05b9$export$71511d61b312f219() {
    // Since Reflect.construct can't be properly polyfilled, some
    // implementations (e.g. core-js@2) don't set the correct internal slots.
    // Those polyfills don't allow us to subclass built-ins, so we need to
    // use our fallback implementation.
    try {
        // If the internal slots aren't set, this throws an error similar to
        //   TypeError: this is not a Boolean object.
        var result = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (_) {}
    return ($7ac76641933b05b9$export$71511d61b312f219 = function() {
        return !!result;
    })();
}

});

parcelRegister("8rit2", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $624f2b98442f96fc$export$71511d61b312f219; });

var $aAmOK = parcelRequire("aAmOK");

var $6tOPT = parcelRequire("6tOPT");
function $624f2b98442f96fc$export$71511d61b312f219(self, call) {
    if (call && ((0, $6tOPT._)(call) === "object" || typeof call === "function")) return call;
    return (0, $aAmOK._)(self);
}

});
parcelRegister("aAmOK", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $7b4ef7430921f6a0$export$71511d61b312f219; });
function $7b4ef7430921f6a0$export$71511d61b312f219(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}

});



parcelRegister("7eXQk", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $545842ca61ee79e9$export$71511d61b312f219; });
function $545842ca61ee79e9$export$71511d61b312f219(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}

});

parcelRegister("gApSC", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $c134155b2f01de8a$export$71511d61b312f219; });
function $c134155b2f01de8a$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $c134155b2f01de8a$export$71511d61b312f219(Constructor, protoProps, staticProps) {
    if (protoProps) $c134155b2f01de8a$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $c134155b2f01de8a$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}

});

parcelRegister("gNq0T", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $c3a566a5a6386f26$export$71511d61b312f219; });

var $fYVK4 = parcelRequire("fYVK4");
function $c3a566a5a6386f26$export$71511d61b312f219(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) (0, $fYVK4._)(subClass, superClass);
}

});
parcelRegister("fYVK4", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $ba293ff6af0a5963$export$71511d61b312f219; });
function $ba293ff6af0a5963$export$71511d61b312f219(o, p) {
    $ba293ff6af0a5963$export$71511d61b312f219 = Object.setPrototypeOf || function setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $ba293ff6af0a5963$export$71511d61b312f219(o, p);
}

});


parcelRegister("4KaL9", function(module, exports) {

$parcel$export(module.exports, "toByteArray", function () { return $3743cde92fe15a85$export$d622b2ad8d90c771; }, function (v) { return $3743cde92fe15a85$export$d622b2ad8d90c771 = v; });
$parcel$export(module.exports, "fromByteArray", function () { return $3743cde92fe15a85$export$6100ba28696e12de; }, function (v) { return $3743cde92fe15a85$export$6100ba28696e12de = v; });
var $3743cde92fe15a85$export$a48f0734ac7c2329;
var $3743cde92fe15a85$export$d622b2ad8d90c771;
var $3743cde92fe15a85$export$6100ba28696e12de;
'use strict';
$3743cde92fe15a85$export$a48f0734ac7c2329 = $3743cde92fe15a85$var$byteLength;
$3743cde92fe15a85$export$d622b2ad8d90c771 = $3743cde92fe15a85$var$toByteArray;
$3743cde92fe15a85$export$6100ba28696e12de = $3743cde92fe15a85$var$fromByteArray;
var $3743cde92fe15a85$var$lookup = [];
var $3743cde92fe15a85$var$revLookup = [];
var $3743cde92fe15a85$var$Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array;
var $3743cde92fe15a85$var$code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
for(var $3743cde92fe15a85$var$i = 0, $3743cde92fe15a85$var$len = $3743cde92fe15a85$var$code.length; $3743cde92fe15a85$var$i < $3743cde92fe15a85$var$len; ++$3743cde92fe15a85$var$i){
    $3743cde92fe15a85$var$lookup[$3743cde92fe15a85$var$i] = $3743cde92fe15a85$var$code[$3743cde92fe15a85$var$i];
    $3743cde92fe15a85$var$revLookup[$3743cde92fe15a85$var$code.charCodeAt($3743cde92fe15a85$var$i)] = $3743cde92fe15a85$var$i;
}
// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
$3743cde92fe15a85$var$revLookup['-'.charCodeAt(0)] = 62;
$3743cde92fe15a85$var$revLookup['_'.charCodeAt(0)] = 63;
function $3743cde92fe15a85$var$getLens(b64) {
    var len = b64.length;
    if (len % 4 > 0) throw new Error('Invalid string. Length must be a multiple of 4');
    // Trim off extra bytes after placeholder bytes are found
    // See: https://github.com/beatgammit/base64-js/issues/42
    var validLen = b64.indexOf('=');
    if (validLen === -1) validLen = len;
    var placeHoldersLen = validLen === len ? 0 : 4 - validLen % 4;
    return [
        validLen,
        placeHoldersLen
    ];
}
// base64 is 4/3 + up to two characters of the original data
function $3743cde92fe15a85$var$byteLength(b64) {
    var lens = $3743cde92fe15a85$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $3743cde92fe15a85$var$_byteLength(b64, validLen, placeHoldersLen) {
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $3743cde92fe15a85$var$toByteArray(b64) {
    var tmp;
    var lens = $3743cde92fe15a85$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    var arr = new $3743cde92fe15a85$var$Arr($3743cde92fe15a85$var$_byteLength(b64, validLen, placeHoldersLen));
    var curByte = 0;
    // if there are placeholders, only get up to the last complete 4 chars
    var len = placeHoldersLen > 0 ? validLen - 4 : validLen;
    var i;
    for(i = 0; i < len; i += 4){
        tmp = $3743cde92fe15a85$var$revLookup[b64.charCodeAt(i)] << 18 | $3743cde92fe15a85$var$revLookup[b64.charCodeAt(i + 1)] << 12 | $3743cde92fe15a85$var$revLookup[b64.charCodeAt(i + 2)] << 6 | $3743cde92fe15a85$var$revLookup[b64.charCodeAt(i + 3)];
        arr[curByte++] = tmp >> 16 & 0xFF;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 2) {
        tmp = $3743cde92fe15a85$var$revLookup[b64.charCodeAt(i)] << 2 | $3743cde92fe15a85$var$revLookup[b64.charCodeAt(i + 1)] >> 4;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 1) {
        tmp = $3743cde92fe15a85$var$revLookup[b64.charCodeAt(i)] << 10 | $3743cde92fe15a85$var$revLookup[b64.charCodeAt(i + 1)] << 4 | $3743cde92fe15a85$var$revLookup[b64.charCodeAt(i + 2)] >> 2;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    return arr;
}
function $3743cde92fe15a85$var$tripletToBase64(num) {
    return $3743cde92fe15a85$var$lookup[num >> 18 & 0x3F] + $3743cde92fe15a85$var$lookup[num >> 12 & 0x3F] + $3743cde92fe15a85$var$lookup[num >> 6 & 0x3F] + $3743cde92fe15a85$var$lookup[num & 0x3F];
}
function $3743cde92fe15a85$var$encodeChunk(uint8, start, end) {
    var tmp;
    var output = [];
    for(var i = start; i < end; i += 3){
        tmp = (uint8[i] << 16 & 0xFF0000) + (uint8[i + 1] << 8 & 0xFF00) + (uint8[i + 2] & 0xFF);
        output.push($3743cde92fe15a85$var$tripletToBase64(tmp));
    }
    return output.join('');
}
function $3743cde92fe15a85$var$fromByteArray(uint8) {
    var tmp;
    var len = uint8.length;
    var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
    ;
    var parts = [];
    var maxChunkLength = 16383 // must be multiple of 3
    ;
    // go through the array every three bytes, we'll deal with trailing stuff later
    for(var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength)parts.push($3743cde92fe15a85$var$encodeChunk(uint8, i, i + maxChunkLength > len2 ? len2 : i + maxChunkLength));
    // pad the end with zeros, but make sure to not forget the extra bytes
    if (extraBytes === 1) {
        tmp = uint8[len - 1];
        parts.push($3743cde92fe15a85$var$lookup[tmp >> 2] + $3743cde92fe15a85$var$lookup[tmp << 4 & 0x3F] + '==');
    } else if (extraBytes === 2) {
        tmp = (uint8[len - 2] << 8) + uint8[len - 1];
        parts.push($3743cde92fe15a85$var$lookup[tmp >> 10] + $3743cde92fe15a85$var$lookup[tmp >> 4 & 0x3F] + $3743cde92fe15a85$var$lookup[tmp << 2 & 0x3F] + '=');
    }
    return parts.join('');
}

});

parcelRegister("8o0zE", function(module, exports) {

$parcel$export(module.exports, "read", function () { return $61b1029694d184ad$export$aafa59e2e03f2942; }, function (v) { return $61b1029694d184ad$export$aafa59e2e03f2942 = v; });
$parcel$export(module.exports, "write", function () { return $61b1029694d184ad$export$68d8715fc104d294; }, function (v) { return $61b1029694d184ad$export$68d8715fc104d294 = v; });
/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */ var $61b1029694d184ad$export$aafa59e2e03f2942;
var $61b1029694d184ad$export$68d8715fc104d294;
$61b1029694d184ad$export$aafa59e2e03f2942 = function(buffer, offset, isLE, mLen, nBytes) {
    var e, m;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var nBits = -7;
    var i = isLE ? nBytes - 1 : 0;
    var d = isLE ? -1 : 1;
    var s = buffer[offset + i];
    i += d;
    e = s & (1 << -nBits) - 1;
    s >>= -nBits;
    nBits += eLen;
    for(; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8);
    m = e & (1 << -nBits) - 1;
    e >>= -nBits;
    nBits += mLen;
    for(; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8);
    if (e === 0) e = 1 - eBias;
    else if (e === eMax) return m ? NaN : (s ? -1 : 1) * Infinity;
    else {
        m = m + Math.pow(2, mLen);
        e = e - eBias;
    }
    return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
};
$61b1029694d184ad$export$68d8715fc104d294 = function(buffer, value, offset, isLE, mLen, nBytes) {
    var e, m, c;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
    var i = isLE ? 0 : nBytes - 1;
    var d = isLE ? 1 : -1;
    var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
    value = Math.abs(value);
    if (isNaN(value) || value === Infinity) {
        m = isNaN(value) ? 1 : 0;
        e = eMax;
    } else {
        e = Math.floor(Math.log(value) / Math.LN2);
        if (value * (c = Math.pow(2, -e)) < 1) {
            e--;
            c *= 2;
        }
        if (e + eBias >= 1) value += rt / c;
        else value += rt * Math.pow(2, 1 - eBias);
        if (value * c >= 2) {
            e++;
            c /= 2;
        }
        if (e + eBias >= eMax) {
            m = 0;
            e = eMax;
        } else if (e + eBias >= 1) {
            m = (value * c - 1) * Math.pow(2, mLen);
            e = e + eBias;
        } else {
            m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
            e = 0;
        }
    }
    for(; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8);
    e = e << mLen | m;
    eLen += mLen;
    for(; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8);
    buffer[offset + i - d] |= s * 128;
};

});


parcelRegister("jfVOB", function(module, exports) {
"use strict";

});

parcelRegister("gXL1L", function(module, exports) {

var $6tOPT = parcelRequire("6tOPT");
'use strict';
function $c596a2b61d97dc50$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $c596a2b61d97dc50$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $c596a2b61d97dc50$var$ownKeys(Object(source), !0).forEach(function(key) {
            $c596a2b61d97dc50$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $c596a2b61d97dc50$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $c596a2b61d97dc50$var$_defineProperty(obj, key, value) {
    key = $c596a2b61d97dc50$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $c596a2b61d97dc50$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $c596a2b61d97dc50$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $c596a2b61d97dc50$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $c596a2b61d97dc50$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $c596a2b61d97dc50$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $c596a2b61d97dc50$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $c596a2b61d97dc50$var$_toPropertyKey(arg) {
    var key = $c596a2b61d97dc50$var$_toPrimitive(arg, "string");
    return (typeof key === "undefined" ? "undefined" : (0, $6tOPT._)(key)) === "symbol" ? key : String(key);
}
function $c596a2b61d97dc50$var$_toPrimitive(input, hint) {
    if ((typeof input === "undefined" ? "undefined" : (0, $6tOPT._)(input)) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ((typeof res === "undefined" ? "undefined" : (0, $6tOPT._)(res)) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}

var $isEGv = parcelRequire("isEGv");
var $c596a2b61d97dc50$var$Buffer = $isEGv.Buffer;

var $jfVOB = parcelRequire("jfVOB");
var $c596a2b61d97dc50$var$inspect = $jfVOB.inspect;
var $c596a2b61d97dc50$var$custom = $c596a2b61d97dc50$var$inspect && $c596a2b61d97dc50$var$inspect.custom || 'inspect';
function $c596a2b61d97dc50$var$copyBuffer(src, target, offset) {
    $c596a2b61d97dc50$var$Buffer.prototype.copy.call(src, target, offset);
}
module.exports = /*#__PURE__*/ function() {
    function BufferList() {
        $c596a2b61d97dc50$var$_classCallCheck(this, BufferList);
        this.head = null;
        this.tail = null;
        this.length = 0;
    }
    $c596a2b61d97dc50$var$_createClass(BufferList, [
        {
            key: "push",
            value: function push(v) {
                var entry = {
                    data: v,
                    next: null
                };
                if (this.length > 0) this.tail.next = entry;
                else this.head = entry;
                this.tail = entry;
                ++this.length;
            }
        },
        {
            key: "unshift",
            value: function unshift(v) {
                var entry = {
                    data: v,
                    next: this.head
                };
                if (this.length === 0) this.tail = entry;
                this.head = entry;
                ++this.length;
            }
        },
        {
            key: "shift",
            value: function shift() {
                if (this.length === 0) return;
                var ret = this.head.data;
                if (this.length === 1) this.head = this.tail = null;
                else this.head = this.head.next;
                --this.length;
                return ret;
            }
        },
        {
            key: "clear",
            value: function clear() {
                this.head = this.tail = null;
                this.length = 0;
            }
        },
        {
            key: "join",
            value: function join(s) {
                if (this.length === 0) return '';
                var p = this.head;
                var ret = '' + p.data;
                while(p = p.next)ret += s + p.data;
                return ret;
            }
        },
        {
            key: "concat",
            value: function concat(n) {
                if (this.length === 0) return $c596a2b61d97dc50$var$Buffer.alloc(0);
                var ret = $c596a2b61d97dc50$var$Buffer.allocUnsafe(n >>> 0);
                var p = this.head;
                var i = 0;
                while(p){
                    $c596a2b61d97dc50$var$copyBuffer(p.data, ret, i);
                    i += p.data.length;
                    p = p.next;
                }
                return ret;
            }
        },
        {
            key: "consume",
            value: function consume(n, hasStrings) {
                var ret;
                if (n < this.head.data.length) {
                    // `slice` is the same for buffers and strings.
                    ret = this.head.data.slice(0, n);
                    this.head.data = this.head.data.slice(n);
                } else if (n === this.head.data.length) // First chunk is a perfect match.
                ret = this.shift();
                else // Result spans more than one buffer.
                ret = hasStrings ? this._getString(n) : this._getBuffer(n);
                return ret;
            }
        },
        {
            key: "first",
            value: function first() {
                return this.head.data;
            }
        },
        {
            key: "_getString",
            value: function _getString(n) {
                var p = this.head;
                var c = 1;
                var ret = p.data;
                n -= ret.length;
                while(p = p.next){
                    var str = p.data;
                    var nb = n > str.length ? str.length : n;
                    if (nb === str.length) ret += str;
                    else ret += str.slice(0, n);
                    n -= nb;
                    if (n === 0) {
                        if (nb === str.length) {
                            ++c;
                            if (p.next) this.head = p.next;
                            else this.head = this.tail = null;
                        } else {
                            this.head = p;
                            p.data = str.slice(nb);
                        }
                        break;
                    }
                    ++c;
                }
                this.length -= c;
                return ret;
            }
        },
        {
            key: "_getBuffer",
            value: function _getBuffer(n) {
                var ret = $c596a2b61d97dc50$var$Buffer.allocUnsafe(n);
                var p = this.head;
                var c = 1;
                p.data.copy(ret);
                n -= p.data.length;
                while(p = p.next){
                    var buf = p.data;
                    var nb = n > buf.length ? buf.length : n;
                    buf.copy(ret, ret.length - n, 0, nb);
                    n -= nb;
                    if (n === 0) {
                        if (nb === buf.length) {
                            ++c;
                            if (p.next) this.head = p.next;
                            else this.head = this.tail = null;
                        } else {
                            this.head = p;
                            p.data = buf.slice(nb);
                        }
                        break;
                    }
                    ++c;
                }
                this.length -= c;
                return ret;
            }
        },
        {
            key: $c596a2b61d97dc50$var$custom,
            value: function value(_, options) {
                return $c596a2b61d97dc50$var$inspect(this, $c596a2b61d97dc50$var$_objectSpread($c596a2b61d97dc50$var$_objectSpread({}, options), {}, {
                    // Only inspect one level.
                    depth: 0,
                    // It should not recurse.
                    customInspect: false
                }));
            }
        }
    ]);
    return BufferList;
}();

});

parcelRegister("cGIaz", function(module, exports) {

var $dKiQF = parcelRequire("dKiQF");
'use strict';
// undocumented cb() API, needed for core, not for public API
function $93cbab692c82293e$var$destroy(err, cb) {
    var _this = this;
    var readableDestroyed = this._readableState && this._readableState.destroyed;
    var writableDestroyed = this._writableState && this._writableState.destroyed;
    if (readableDestroyed || writableDestroyed) {
        if (cb) cb(err);
        else if (err) {
            if (!this._writableState) $dKiQF.nextTick($93cbab692c82293e$var$emitErrorNT, this, err);
            else if (!this._writableState.errorEmitted) {
                this._writableState.errorEmitted = true;
                $dKiQF.nextTick($93cbab692c82293e$var$emitErrorNT, this, err);
            }
        }
        return this;
    }
    // we set destroyed to true before firing error callbacks in order
    // to make it re-entrance safe in case destroy() is called within callbacks
    if (this._readableState) this._readableState.destroyed = true;
    // if this is a duplex stream mark the writable part as destroyed as well
    if (this._writableState) this._writableState.destroyed = true;
    this._destroy(err || null, function(err) {
        if (!cb && err) {
            if (!_this._writableState) $dKiQF.nextTick($93cbab692c82293e$var$emitErrorAndCloseNT, _this, err);
            else if (!_this._writableState.errorEmitted) {
                _this._writableState.errorEmitted = true;
                $dKiQF.nextTick($93cbab692c82293e$var$emitErrorAndCloseNT, _this, err);
            } else $dKiQF.nextTick($93cbab692c82293e$var$emitCloseNT, _this);
        } else if (cb) {
            $dKiQF.nextTick($93cbab692c82293e$var$emitCloseNT, _this);
            cb(err);
        } else $dKiQF.nextTick($93cbab692c82293e$var$emitCloseNT, _this);
    });
    return this;
}
function $93cbab692c82293e$var$emitErrorAndCloseNT(self, err) {
    $93cbab692c82293e$var$emitErrorNT(self, err);
    $93cbab692c82293e$var$emitCloseNT(self);
}
function $93cbab692c82293e$var$emitCloseNT(self) {
    if (self._writableState && !self._writableState.emitClose) return;
    if (self._readableState && !self._readableState.emitClose) return;
    self.emit('close');
}
function $93cbab692c82293e$var$undestroy() {
    if (this._readableState) {
        this._readableState.destroyed = false;
        this._readableState.reading = false;
        this._readableState.ended = false;
        this._readableState.endEmitted = false;
    }
    if (this._writableState) {
        this._writableState.destroyed = false;
        this._writableState.ended = false;
        this._writableState.ending = false;
        this._writableState.finalCalled = false;
        this._writableState.prefinished = false;
        this._writableState.finished = false;
        this._writableState.errorEmitted = false;
    }
}
function $93cbab692c82293e$var$emitErrorNT(self, err) {
    self.emit('error', err);
}
function $93cbab692c82293e$var$errorOrDestroy(stream, err) {
    // We have tests that rely on errors being emitted
    // in the same tick, so changing this is semver major.
    // For now when you opt-in to autoDestroy we allow
    // the error to be emitted nextTick. In a future
    // semver major update we should change the default to this.
    var rState = stream._readableState;
    var wState = stream._writableState;
    if (rState && rState.autoDestroy || wState && wState.autoDestroy) stream.destroy(err);
    else stream.emit('error', err);
}
module.exports = {
    destroy: $93cbab692c82293e$var$destroy,
    undestroy: $93cbab692c82293e$var$undestroy,
    errorOrDestroy: $93cbab692c82293e$var$errorOrDestroy
};

});

parcelRegister("9I6ON", function(module, exports) {
'use strict';

var $711d83116a42e032$var$ERR_INVALID_OPT_VALUE = (parcelRequire("eFrw3")).codes.ERR_INVALID_OPT_VALUE;
function $711d83116a42e032$var$highWaterMarkFrom(options, isDuplex, duplexKey) {
    return options.highWaterMark != null ? options.highWaterMark : isDuplex ? options[duplexKey] : null;
}
function $711d83116a42e032$var$getHighWaterMark(state, options, duplexKey, isDuplex) {
    var hwm = $711d83116a42e032$var$highWaterMarkFrom(options, isDuplex, duplexKey);
    if (hwm != null) {
        if (!(isFinite(hwm) && Math.floor(hwm) === hwm) || hwm < 0) {
            var name = isDuplex ? duplexKey : 'highWaterMark';
            throw new $711d83116a42e032$var$ERR_INVALID_OPT_VALUE(name, hwm);
        }
        return Math.floor(hwm);
    }
    // Default value
    return state.objectMode ? 16 : 16384;
}
module.exports = {
    getHighWaterMark: $711d83116a42e032$var$getHighWaterMark
};

});
parcelRegister("eFrw3", function(module, exports) {

$parcel$export(module.exports, "codes", function () { return $aada3d23ccc0f670$export$e45cb6485273080e; }, function (v) { return $aada3d23ccc0f670$export$e45cb6485273080e = v; });

var $6tOPT = parcelRequire("6tOPT");
var $aada3d23ccc0f670$export$e45cb6485273080e;
'use strict';
function $aada3d23ccc0f670$var$_inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    subClass.__proto__ = superClass;
}
var $aada3d23ccc0f670$var$codes = {};
function $aada3d23ccc0f670$var$createErrorType(code, message, Base) {
    if (!Base) Base = Error;
    function getMessage(arg1, arg2, arg3) {
        if (typeof message === 'string') return message;
        else return message(arg1, arg2, arg3);
    }
    var NodeError = /*#__PURE__*/ function(_Base) {
        $aada3d23ccc0f670$var$_inheritsLoose(NodeError, _Base);
        function NodeError(arg1, arg2, arg3) {
            return _Base.call(this, getMessage(arg1, arg2, arg3)) || this;
        }
        return NodeError;
    }(Base);
    NodeError.prototype.name = Base.name;
    NodeError.prototype.code = code;
    $aada3d23ccc0f670$var$codes[code] = NodeError;
} // https://github.com/nodejs/node/blob/v10.8.0/lib/internal/errors.js
function $aada3d23ccc0f670$var$oneOf(expected, thing) {
    if (Array.isArray(expected)) {
        var len = expected.length;
        expected = expected.map(function(i) {
            return String(i);
        });
        if (len > 2) return "one of ".concat(thing, " ").concat(expected.slice(0, len - 1).join(', '), ", or ") + expected[len - 1];
        else if (len === 2) return "one of ".concat(thing, " ").concat(expected[0], " or ").concat(expected[1]);
        else return "of ".concat(thing, " ").concat(expected[0]);
    } else return "of ".concat(thing, " ").concat(String(expected));
} // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/startsWith
function $aada3d23ccc0f670$var$startsWith(str, search, pos) {
    return str.substr(!pos || pos < 0 ? 0 : +pos, search.length) === search;
} // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/endsWith
function $aada3d23ccc0f670$var$endsWith(str, search, this_len) {
    if (this_len === undefined || this_len > str.length) this_len = str.length;
    return str.substring(this_len - search.length, this_len) === search;
} // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/includes
function $aada3d23ccc0f670$var$includes(str, search, start) {
    if (typeof start !== 'number') start = 0;
    if (start + search.length > str.length) return false;
    else return str.indexOf(search, start) !== -1;
}
$aada3d23ccc0f670$var$createErrorType('ERR_INVALID_OPT_VALUE', function(name, value) {
    return 'The value "' + value + '" is invalid for option "' + name + '"';
}, TypeError);
$aada3d23ccc0f670$var$createErrorType('ERR_INVALID_ARG_TYPE', function(name, expected, actual) {
    // determiner: 'must be' or 'must not be'
    var determiner;
    if (typeof expected === 'string' && $aada3d23ccc0f670$var$startsWith(expected, 'not ')) {
        determiner = 'must not be';
        expected = expected.replace(/^not /, '');
    } else determiner = 'must be';
    var msg;
    if ($aada3d23ccc0f670$var$endsWith(name, ' argument')) // For cases like 'first argument'
    msg = "The ".concat(name, " ").concat(determiner, " ").concat($aada3d23ccc0f670$var$oneOf(expected, 'type'));
    else {
        var type = $aada3d23ccc0f670$var$includes(name, '.') ? 'property' : 'argument';
        msg = "The \"".concat(name, "\" ").concat(type, " ").concat(determiner, " ").concat($aada3d23ccc0f670$var$oneOf(expected, 'type'));
    }
    msg += ". Received type ".concat(typeof actual === "undefined" ? "undefined" : (0, $6tOPT._)(actual));
    return msg;
}, TypeError);
$aada3d23ccc0f670$var$createErrorType('ERR_STREAM_PUSH_AFTER_EOF', 'stream.push() after EOF');
$aada3d23ccc0f670$var$createErrorType('ERR_METHOD_NOT_IMPLEMENTED', function(name) {
    return 'The ' + name + ' method is not implemented';
});
$aada3d23ccc0f670$var$createErrorType('ERR_STREAM_PREMATURE_CLOSE', 'Premature close');
$aada3d23ccc0f670$var$createErrorType('ERR_STREAM_DESTROYED', function(name) {
    return 'Cannot call ' + name + ' after a stream was destroyed';
});
$aada3d23ccc0f670$var$createErrorType('ERR_MULTIPLE_CALLBACK', 'Callback called multiple times');
$aada3d23ccc0f670$var$createErrorType('ERR_STREAM_CANNOT_PIPE', 'Cannot pipe, not readable');
$aada3d23ccc0f670$var$createErrorType('ERR_STREAM_WRITE_AFTER_END', 'write after end');
$aada3d23ccc0f670$var$createErrorType('ERR_STREAM_NULL_VALUES', 'May not write null values to stream', TypeError);
$aada3d23ccc0f670$var$createErrorType('ERR_UNKNOWN_ENCODING', function(arg) {
    return 'Unknown encoding: ' + arg;
}, TypeError);
$aada3d23ccc0f670$var$createErrorType('ERR_STREAM_UNSHIFT_AFTER_END_EVENT', 'stream.unshift() after end event');
$aada3d23ccc0f670$export$e45cb6485273080e = $aada3d23ccc0f670$var$codes;

});


parcelRegister("5h9D2", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a duplex stream is just a stream that is both readable and writable.
// Since JS doesn't have multiple prototypal inheritance, this class
// prototypally inherits from Readable, and then parasitically from
// Writable.

var $dKiQF = parcelRequire("dKiQF");
'use strict';
/*<replacement>*/ var $3d760251cc2f31af$var$objectKeys = Object.keys || function(obj) {
    var keys = [];
    for(var key in obj)keys.push(key);
    return keys;
};
/*</replacement>*/ module.exports = $3d760251cc2f31af$var$Duplex;

var $8KOo4 = parcelRequire("8KOo4");

var $1jP7O = parcelRequire("1jP7O");

(parcelRequire("ACMoe"))($3d760251cc2f31af$var$Duplex, $8KOo4);
// Allow the keys array to be GC'ed.
var $3d760251cc2f31af$var$keys = $3d760251cc2f31af$var$objectKeys($1jP7O.prototype);
for(var $3d760251cc2f31af$var$v = 0; $3d760251cc2f31af$var$v < $3d760251cc2f31af$var$keys.length; $3d760251cc2f31af$var$v++){
    var $3d760251cc2f31af$var$method = $3d760251cc2f31af$var$keys[$3d760251cc2f31af$var$v];
    if (!$3d760251cc2f31af$var$Duplex.prototype[$3d760251cc2f31af$var$method]) $3d760251cc2f31af$var$Duplex.prototype[$3d760251cc2f31af$var$method] = $1jP7O.prototype[$3d760251cc2f31af$var$method];
}
function $3d760251cc2f31af$var$Duplex(options) {
    if (!(this instanceof $3d760251cc2f31af$var$Duplex)) return new $3d760251cc2f31af$var$Duplex(options);
    $8KOo4.call(this, options);
    $1jP7O.call(this, options);
    this.allowHalfOpen = true;
    if (options) {
        if (options.readable === false) this.readable = false;
        if (options.writable === false) this.writable = false;
        if (options.allowHalfOpen === false) {
            this.allowHalfOpen = false;
            this.once('end', $3d760251cc2f31af$var$onend);
        }
    }
}
Object.defineProperty($3d760251cc2f31af$var$Duplex.prototype, 'writableHighWaterMark', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._writableState.highWaterMark;
    }
});
Object.defineProperty($3d760251cc2f31af$var$Duplex.prototype, 'writableBuffer', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._writableState && this._writableState.getBuffer();
    }
});
Object.defineProperty($3d760251cc2f31af$var$Duplex.prototype, 'writableLength', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._writableState.length;
    }
});
// the no-half-open enforcer
function $3d760251cc2f31af$var$onend() {
    // If the writable side ended, then we're ok.
    if (this._writableState.ended) return;
    // no more data can be written.
    // But allow more writes to happen in this tick.
    $dKiQF.nextTick($3d760251cc2f31af$var$onEndNT, this);
}
function $3d760251cc2f31af$var$onEndNT(self) {
    self.end();
}
Object.defineProperty($3d760251cc2f31af$var$Duplex.prototype, 'destroyed', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        if (this._readableState === undefined || this._writableState === undefined) return false;
        return this._readableState.destroyed && this._writableState.destroyed;
    },
    set: function set(value) {
        // we ignore the value if the stream
        // has not been initialized yet
        if (this._readableState === undefined || this._writableState === undefined) return;
        // backward compatibility, the user is explicitly
        // managing destroyed
        this._readableState.destroyed = value;
        this._writableState.destroyed = value;
    }
});

});
parcelRegister("1jP7O", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// A bit simpler than readable streams.
// Implement an async ._write(chunk, encoding, cb), and it'll handle all
// the drain event emission and buffering.

var $dKiQF = parcelRequire("dKiQF");
'use strict';
module.exports = $0f5f392bea975f91$var$Writable;
/* <replacement> */ function $0f5f392bea975f91$var$WriteReq(chunk, encoding, cb) {
    this.chunk = chunk;
    this.encoding = encoding;
    this.callback = cb;
    this.next = null;
}
// It seems a linked list but it is not
// there will be only 2 of these for each stream
function $0f5f392bea975f91$var$CorkedRequest(state) {
    var _this = this;
    this.next = null;
    this.entry = null;
    this.finish = function() {
        $0f5f392bea975f91$var$onCorkedFinish(_this, state);
    };
}
/* </replacement> */ /*<replacement>*/ var $0f5f392bea975f91$var$Duplex;
/*</replacement>*/ $0f5f392bea975f91$var$Writable.WritableState = $0f5f392bea975f91$var$WritableState;

/*<replacement>*/ var $0f5f392bea975f91$var$internalUtil = {
    deprecate: (parcelRequire("fI2xT"))
};

var $G78TW = parcelRequire("G78TW");

var $isEGv = parcelRequire("isEGv");
var $0f5f392bea975f91$require$Buffer = $isEGv.Buffer;
var $0f5f392bea975f91$var$OurUint8Array = (typeof $parcel$global !== 'undefined' ? $parcel$global : typeof window !== 'undefined' ? window : typeof self !== 'undefined' ? self : {}).Uint8Array || function() {};
function $0f5f392bea975f91$var$_uint8ArrayToBuffer(chunk) {
    return $0f5f392bea975f91$require$Buffer.from(chunk);
}
function $0f5f392bea975f91$var$_isUint8Array(obj) {
    return $0f5f392bea975f91$require$Buffer.isBuffer(obj) || obj instanceof $0f5f392bea975f91$var$OurUint8Array;
}

var $cGIaz = parcelRequire("cGIaz");

var $9I6ON = parcelRequire("9I6ON");
var $0f5f392bea975f91$var$getHighWaterMark = $9I6ON.getHighWaterMark;

var $eFrw3 = parcelRequire("eFrw3");
var $0f5f392bea975f91$require$_require$codes = $eFrw3.codes;
var $0f5f392bea975f91$var$ERR_INVALID_ARG_TYPE = $0f5f392bea975f91$require$_require$codes.ERR_INVALID_ARG_TYPE, $0f5f392bea975f91$var$ERR_METHOD_NOT_IMPLEMENTED = $0f5f392bea975f91$require$_require$codes.ERR_METHOD_NOT_IMPLEMENTED, $0f5f392bea975f91$var$ERR_MULTIPLE_CALLBACK = $0f5f392bea975f91$require$_require$codes.ERR_MULTIPLE_CALLBACK, $0f5f392bea975f91$var$ERR_STREAM_CANNOT_PIPE = $0f5f392bea975f91$require$_require$codes.ERR_STREAM_CANNOT_PIPE, $0f5f392bea975f91$var$ERR_STREAM_DESTROYED = $0f5f392bea975f91$require$_require$codes.ERR_STREAM_DESTROYED, $0f5f392bea975f91$var$ERR_STREAM_NULL_VALUES = $0f5f392bea975f91$require$_require$codes.ERR_STREAM_NULL_VALUES, $0f5f392bea975f91$var$ERR_STREAM_WRITE_AFTER_END = $0f5f392bea975f91$require$_require$codes.ERR_STREAM_WRITE_AFTER_END, $0f5f392bea975f91$var$ERR_UNKNOWN_ENCODING = $0f5f392bea975f91$require$_require$codes.ERR_UNKNOWN_ENCODING;
var $0f5f392bea975f91$var$errorOrDestroy = $cGIaz.errorOrDestroy;

(parcelRequire("ACMoe"))($0f5f392bea975f91$var$Writable, $G78TW);
function $0f5f392bea975f91$var$nop() {}

function $0f5f392bea975f91$var$WritableState(options, stream, isDuplex) {
    $0f5f392bea975f91$var$Duplex = $0f5f392bea975f91$var$Duplex || (parcelRequire("5h9D2"));
    options = options || {};
    // Duplex streams are both readable and writable, but share
    // the same options object.
    // However, some cases require setting options to different
    // values for the readable and the writable sides of the duplex stream,
    // e.g. options.readableObjectMode vs. options.writableObjectMode, etc.
    if (typeof isDuplex !== 'boolean') isDuplex = stream instanceof $0f5f392bea975f91$var$Duplex;
    // object stream flag to indicate whether or not this stream
    // contains buffers or objects.
    this.objectMode = !!options.objectMode;
    if (isDuplex) this.objectMode = this.objectMode || !!options.writableObjectMode;
    // the point at which write() starts returning false
    // Note: 0 is a valid value, means that we always return false if
    // the entire buffer is not flushed immediately on write()
    this.highWaterMark = $0f5f392bea975f91$var$getHighWaterMark(this, options, 'writableHighWaterMark', isDuplex);
    // if _final has been called
    this.finalCalled = false;
    // drain event flag.
    this.needDrain = false;
    // at the start of calling end()
    this.ending = false;
    // when end() has been called, and returned
    this.ended = false;
    // when 'finish' is emitted
    this.finished = false;
    // has it been destroyed
    this.destroyed = false;
    // should we decode strings into buffers before passing to _write?
    // this is here so that some node-core streams can optimize string
    // handling at a lower level.
    var noDecode = options.decodeStrings === false;
    this.decodeStrings = !noDecode;
    // Crypto is kind of old and crusty.  Historically, its default string
    // encoding is 'binary' so we have to make this configurable.
    // Everything else in the universe uses 'utf8', though.
    this.defaultEncoding = options.defaultEncoding || 'utf8';
    // not an actual buffer we keep track of, but a measurement
    // of how much we're waiting to get pushed to some underlying
    // socket or file.
    this.length = 0;
    // a flag to see when we're in the middle of a write.
    this.writing = false;
    // when true all writes will be buffered until .uncork() call
    this.corked = 0;
    // a flag to be able to tell if the onwrite cb is called immediately,
    // or on a later tick.  We set this to true at first, because any
    // actions that shouldn't happen until "later" should generally also
    // not happen before the first write call.
    this.sync = true;
    // a flag to know if we're processing previously buffered items, which
    // may call the _write() callback in the same tick, so that we don't
    // end up in an overlapped onwrite situation.
    this.bufferProcessing = false;
    // the callback that's passed to _write(chunk,cb)
    this.onwrite = function(er) {
        $0f5f392bea975f91$var$onwrite(stream, er);
    };
    // the callback that the user supplies to write(chunk,encoding,cb)
    this.writecb = null;
    // the amount that is being written when _write is called.
    this.writelen = 0;
    this.bufferedRequest = null;
    this.lastBufferedRequest = null;
    // number of pending user-supplied write callbacks
    // this must be 0 before 'finish' can be emitted
    this.pendingcb = 0;
    // emit prefinish if the only thing we're waiting for is _write cbs
    // This is relevant for synchronous Transform streams
    this.prefinished = false;
    // True if the error was already emitted and should not be thrown again
    this.errorEmitted = false;
    // Should close be emitted on destroy. Defaults to true.
    this.emitClose = options.emitClose !== false;
    // Should .destroy() be called after 'finish' (and potentially 'end')
    this.autoDestroy = !!options.autoDestroy;
    // count buffered requests
    this.bufferedRequestCount = 0;
    // allocate the first CorkedRequest, there is always
    // one allocated and free to use, and we maintain at most two
    this.corkedRequestsFree = new $0f5f392bea975f91$var$CorkedRequest(this);
}
$0f5f392bea975f91$var$WritableState.prototype.getBuffer = function getBuffer() {
    var current = this.bufferedRequest;
    var out = [];
    while(current){
        out.push(current);
        current = current.next;
    }
    return out;
};
(function() {
    try {
        Object.defineProperty($0f5f392bea975f91$var$WritableState.prototype, 'buffer', {
            get: $0f5f392bea975f91$var$internalUtil.deprecate(function writableStateBufferGetter() {
                return this.getBuffer();
            }, "_writableState.buffer is deprecated. Use _writableState.getBuffer instead.", 'DEP0003')
        });
    } catch (_) {}
})();
// Test _writableState for inheritance to account for Duplex streams,
// whose prototype chain only points to Readable.
var $0f5f392bea975f91$var$realHasInstance;
if (typeof Symbol === 'function' && Symbol.hasInstance && typeof Function.prototype[Symbol.hasInstance] === 'function') {
    $0f5f392bea975f91$var$realHasInstance = Function.prototype[Symbol.hasInstance];
    Object.defineProperty($0f5f392bea975f91$var$Writable, Symbol.hasInstance, {
        value: function value(object) {
            if ($0f5f392bea975f91$var$realHasInstance.call(this, object)) return true;
            if (this !== $0f5f392bea975f91$var$Writable) return false;
            return object && object._writableState instanceof $0f5f392bea975f91$var$WritableState;
        }
    });
} else $0f5f392bea975f91$var$realHasInstance = function realHasInstance(object) {
    return object instanceof this;
};

function $0f5f392bea975f91$var$Writable(options) {
    $0f5f392bea975f91$var$Duplex = $0f5f392bea975f91$var$Duplex || (parcelRequire("5h9D2"));
    // Writable ctor is applied to Duplexes, too.
    // `realHasInstance` is necessary because using plain `instanceof`
    // would return false, as no `_writableState` property is attached.
    // Trying to use the custom `instanceof` for Writable here will also break the
    // Node.js LazyTransform implementation, which has a non-trivial getter for
    // `_writableState` that would lead to infinite recursion.
    // Checking for a Stream.Duplex instance is faster here instead of inside
    // the WritableState constructor, at least with V8 6.5
    var isDuplex = this instanceof $0f5f392bea975f91$var$Duplex;
    if (!isDuplex && !$0f5f392bea975f91$var$realHasInstance.call($0f5f392bea975f91$var$Writable, this)) return new $0f5f392bea975f91$var$Writable(options);
    this._writableState = new $0f5f392bea975f91$var$WritableState(options, this, isDuplex);
    // legacy.
    this.writable = true;
    if (options) {
        if (typeof options.write === 'function') this._write = options.write;
        if (typeof options.writev === 'function') this._writev = options.writev;
        if (typeof options.destroy === 'function') this._destroy = options.destroy;
        if (typeof options.final === 'function') this._final = options.final;
    }
    $G78TW.call(this);
}
// Otherwise people can pipe Writable streams, which is just wrong.
$0f5f392bea975f91$var$Writable.prototype.pipe = function() {
    $0f5f392bea975f91$var$errorOrDestroy(this, new $0f5f392bea975f91$var$ERR_STREAM_CANNOT_PIPE());
};
function $0f5f392bea975f91$var$writeAfterEnd(stream, cb) {
    var er = new $0f5f392bea975f91$var$ERR_STREAM_WRITE_AFTER_END();
    // TODO: defer error events consistently everywhere, not just the cb
    $0f5f392bea975f91$var$errorOrDestroy(stream, er);
    $dKiQF.nextTick(cb, er);
}
// Checks that a user-supplied chunk is valid, especially for the particular
// mode the stream is in. Currently this means that `null` is never accepted
// and undefined/non-string values are only allowed in object mode.
function $0f5f392bea975f91$var$validChunk(stream, state, chunk, cb) {
    var er;
    if (chunk === null) er = new $0f5f392bea975f91$var$ERR_STREAM_NULL_VALUES();
    else if (typeof chunk !== 'string' && !state.objectMode) er = new $0f5f392bea975f91$var$ERR_INVALID_ARG_TYPE('chunk', [
        'string',
        'Buffer'
    ], chunk);
    if (er) {
        $0f5f392bea975f91$var$errorOrDestroy(stream, er);
        $dKiQF.nextTick(cb, er);
        return false;
    }
    return true;
}
$0f5f392bea975f91$var$Writable.prototype.write = function(chunk, encoding, cb) {
    var state = this._writableState;
    var ret = false;
    var isBuf = !state.objectMode && $0f5f392bea975f91$var$_isUint8Array(chunk);
    if (isBuf && !$0f5f392bea975f91$require$Buffer.isBuffer(chunk)) chunk = $0f5f392bea975f91$var$_uint8ArrayToBuffer(chunk);
    if (typeof encoding === 'function') {
        cb = encoding;
        encoding = null;
    }
    if (isBuf) encoding = 'buffer';
    else if (!encoding) encoding = state.defaultEncoding;
    if (typeof cb !== 'function') cb = $0f5f392bea975f91$var$nop;
    if (state.ending) $0f5f392bea975f91$var$writeAfterEnd(this, cb);
    else if (isBuf || $0f5f392bea975f91$var$validChunk(this, state, chunk, cb)) {
        state.pendingcb++;
        ret = $0f5f392bea975f91$var$writeOrBuffer(this, state, isBuf, chunk, encoding, cb);
    }
    return ret;
};
$0f5f392bea975f91$var$Writable.prototype.cork = function() {
    this._writableState.corked++;
};
$0f5f392bea975f91$var$Writable.prototype.uncork = function() {
    var state = this._writableState;
    if (state.corked) {
        state.corked--;
        if (!state.writing && !state.corked && !state.bufferProcessing && state.bufferedRequest) $0f5f392bea975f91$var$clearBuffer(this, state);
    }
};
$0f5f392bea975f91$var$Writable.prototype.setDefaultEncoding = function setDefaultEncoding(encoding) {
    // node::ParseEncoding() requires lower case.
    if (typeof encoding === 'string') encoding = encoding.toLowerCase();
    if (!([
        'hex',
        'utf8',
        'utf-8',
        'ascii',
        'binary',
        'base64',
        'ucs2',
        'ucs-2',
        'utf16le',
        'utf-16le',
        'raw'
    ].indexOf((encoding + '').toLowerCase()) > -1)) throw new $0f5f392bea975f91$var$ERR_UNKNOWN_ENCODING(encoding);
    this._writableState.defaultEncoding = encoding;
    return this;
};
Object.defineProperty($0f5f392bea975f91$var$Writable.prototype, 'writableBuffer', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._writableState && this._writableState.getBuffer();
    }
});
function $0f5f392bea975f91$var$decodeChunk(state, chunk, encoding) {
    if (!state.objectMode && state.decodeStrings !== false && typeof chunk === 'string') chunk = $0f5f392bea975f91$require$Buffer.from(chunk, encoding);
    return chunk;
}
Object.defineProperty($0f5f392bea975f91$var$Writable.prototype, 'writableHighWaterMark', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._writableState.highWaterMark;
    }
});
// if we're already writing something, then just put this
// in the queue, and wait our turn.  Otherwise, call _write
// If we return false, then we need a drain event, so set that flag.
function $0f5f392bea975f91$var$writeOrBuffer(stream, state, isBuf, chunk, encoding, cb) {
    if (!isBuf) {
        var newChunk = $0f5f392bea975f91$var$decodeChunk(state, chunk, encoding);
        if (chunk !== newChunk) {
            isBuf = true;
            encoding = 'buffer';
            chunk = newChunk;
        }
    }
    var len = state.objectMode ? 1 : chunk.length;
    state.length += len;
    var ret = state.length < state.highWaterMark;
    // we must ensure that previous needDrain will not be reset to false.
    if (!ret) state.needDrain = true;
    if (state.writing || state.corked) {
        var last = state.lastBufferedRequest;
        state.lastBufferedRequest = {
            chunk: chunk,
            encoding: encoding,
            isBuf: isBuf,
            callback: cb,
            next: null
        };
        if (last) last.next = state.lastBufferedRequest;
        else state.bufferedRequest = state.lastBufferedRequest;
        state.bufferedRequestCount += 1;
    } else $0f5f392bea975f91$var$doWrite(stream, state, false, len, chunk, encoding, cb);
    return ret;
}
function $0f5f392bea975f91$var$doWrite(stream, state, writev, len, chunk, encoding, cb) {
    state.writelen = len;
    state.writecb = cb;
    state.writing = true;
    state.sync = true;
    if (state.destroyed) state.onwrite(new $0f5f392bea975f91$var$ERR_STREAM_DESTROYED('write'));
    else if (writev) stream._writev(chunk, state.onwrite);
    else stream._write(chunk, encoding, state.onwrite);
    state.sync = false;
}
function $0f5f392bea975f91$var$onwriteError(stream, state, sync, er, cb) {
    --state.pendingcb;
    if (sync) {
        // defer the callback if we are being called synchronously
        // to avoid piling up things on the stack
        $dKiQF.nextTick(cb, er);
        // this can emit finish, and it will always happen
        // after error
        $dKiQF.nextTick($0f5f392bea975f91$var$finishMaybe, stream, state);
        stream._writableState.errorEmitted = true;
        $0f5f392bea975f91$var$errorOrDestroy(stream, er);
    } else {
        // the caller expect this to happen before if
        // it is async
        cb(er);
        stream._writableState.errorEmitted = true;
        $0f5f392bea975f91$var$errorOrDestroy(stream, er);
        // this can emit finish, but finish must
        // always follow error
        $0f5f392bea975f91$var$finishMaybe(stream, state);
    }
}
function $0f5f392bea975f91$var$onwriteStateUpdate(state) {
    state.writing = false;
    state.writecb = null;
    state.length -= state.writelen;
    state.writelen = 0;
}
function $0f5f392bea975f91$var$onwrite(stream, er) {
    var state = stream._writableState;
    var sync = state.sync;
    var cb = state.writecb;
    if (typeof cb !== 'function') throw new $0f5f392bea975f91$var$ERR_MULTIPLE_CALLBACK();
    $0f5f392bea975f91$var$onwriteStateUpdate(state);
    if (er) $0f5f392bea975f91$var$onwriteError(stream, state, sync, er, cb);
    else {
        // Check if we're actually ready to finish, but don't emit yet
        var finished = $0f5f392bea975f91$var$needFinish(state) || stream.destroyed;
        if (!finished && !state.corked && !state.bufferProcessing && state.bufferedRequest) $0f5f392bea975f91$var$clearBuffer(stream, state);
        if (sync) $dKiQF.nextTick($0f5f392bea975f91$var$afterWrite, stream, state, finished, cb);
        else $0f5f392bea975f91$var$afterWrite(stream, state, finished, cb);
    }
}
function $0f5f392bea975f91$var$afterWrite(stream, state, finished, cb) {
    if (!finished) $0f5f392bea975f91$var$onwriteDrain(stream, state);
    state.pendingcb--;
    cb();
    $0f5f392bea975f91$var$finishMaybe(stream, state);
}
// Must force callback to be called on nextTick, so that we don't
// emit 'drain' before the write() consumer gets the 'false' return
// value, and has a chance to attach a 'drain' listener.
function $0f5f392bea975f91$var$onwriteDrain(stream, state) {
    if (state.length === 0 && state.needDrain) {
        state.needDrain = false;
        stream.emit('drain');
    }
}
// if there's something in the buffer waiting, then process it
function $0f5f392bea975f91$var$clearBuffer(stream, state) {
    state.bufferProcessing = true;
    var entry = state.bufferedRequest;
    if (stream._writev && entry && entry.next) {
        // Fast case, write everything using _writev()
        var l = state.bufferedRequestCount;
        var buffer = new Array(l);
        var holder = state.corkedRequestsFree;
        holder.entry = entry;
        var count = 0;
        var allBuffers = true;
        while(entry){
            buffer[count] = entry;
            if (!entry.isBuf) allBuffers = false;
            entry = entry.next;
            count += 1;
        }
        buffer.allBuffers = allBuffers;
        $0f5f392bea975f91$var$doWrite(stream, state, true, state.length, buffer, '', holder.finish);
        // doWrite is almost always async, defer these to save a bit of time
        // as the hot path ends with doWrite
        state.pendingcb++;
        state.lastBufferedRequest = null;
        if (holder.next) {
            state.corkedRequestsFree = holder.next;
            holder.next = null;
        } else state.corkedRequestsFree = new $0f5f392bea975f91$var$CorkedRequest(state);
        state.bufferedRequestCount = 0;
    } else {
        // Slow case, write chunks one-by-one
        while(entry){
            var chunk = entry.chunk;
            var encoding = entry.encoding;
            var cb = entry.callback;
            var len = state.objectMode ? 1 : chunk.length;
            $0f5f392bea975f91$var$doWrite(stream, state, false, len, chunk, encoding, cb);
            entry = entry.next;
            state.bufferedRequestCount--;
            // if we didn't call the onwrite immediately, then
            // it means that we need to wait until it does.
            // also, that means that the chunk and cb are currently
            // being processed, so move the buffer counter past them.
            if (state.writing) break;
        }
        if (entry === null) state.lastBufferedRequest = null;
    }
    state.bufferedRequest = entry;
    state.bufferProcessing = false;
}
$0f5f392bea975f91$var$Writable.prototype._write = function(chunk, encoding, cb) {
    cb(new $0f5f392bea975f91$var$ERR_METHOD_NOT_IMPLEMENTED('_write()'));
};
$0f5f392bea975f91$var$Writable.prototype._writev = null;
$0f5f392bea975f91$var$Writable.prototype.end = function(chunk, encoding, cb) {
    var state = this._writableState;
    if (typeof chunk === 'function') {
        cb = chunk;
        chunk = null;
        encoding = null;
    } else if (typeof encoding === 'function') {
        cb = encoding;
        encoding = null;
    }
    if (chunk !== null && chunk !== undefined) this.write(chunk, encoding);
    // .end() fully uncorks
    if (state.corked) {
        state.corked = 1;
        this.uncork();
    }
    // ignore unnecessary end() calls.
    if (!state.ending) $0f5f392bea975f91$var$endWritable(this, state, cb);
    return this;
};
Object.defineProperty($0f5f392bea975f91$var$Writable.prototype, 'writableLength', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._writableState.length;
    }
});
function $0f5f392bea975f91$var$needFinish(state) {
    return state.ending && state.length === 0 && state.bufferedRequest === null && !state.finished && !state.writing;
}
function $0f5f392bea975f91$var$callFinal(stream, state) {
    stream._final(function(err) {
        state.pendingcb--;
        if (err) $0f5f392bea975f91$var$errorOrDestroy(stream, err);
        state.prefinished = true;
        stream.emit('prefinish');
        $0f5f392bea975f91$var$finishMaybe(stream, state);
    });
}
function $0f5f392bea975f91$var$prefinish(stream, state) {
    if (!state.prefinished && !state.finalCalled) {
        if (typeof stream._final === 'function' && !state.destroyed) {
            state.pendingcb++;
            state.finalCalled = true;
            $dKiQF.nextTick($0f5f392bea975f91$var$callFinal, stream, state);
        } else {
            state.prefinished = true;
            stream.emit('prefinish');
        }
    }
}
function $0f5f392bea975f91$var$finishMaybe(stream, state) {
    var need = $0f5f392bea975f91$var$needFinish(state);
    if (need) {
        $0f5f392bea975f91$var$prefinish(stream, state);
        if (state.pendingcb === 0) {
            state.finished = true;
            stream.emit('finish');
            if (state.autoDestroy) {
                // In case of duplex streams we need a way to detect
                // if the readable side is ready for autoDestroy as well
                var rState = stream._readableState;
                if (!rState || rState.autoDestroy && rState.endEmitted) stream.destroy();
            }
        }
    }
    return need;
}
function $0f5f392bea975f91$var$endWritable(stream, state, cb) {
    state.ending = true;
    $0f5f392bea975f91$var$finishMaybe(stream, state);
    if (cb) {
        if (state.finished) $dKiQF.nextTick(cb);
        else stream.once('finish', cb);
    }
    state.ended = true;
    stream.writable = false;
}
function $0f5f392bea975f91$var$onCorkedFinish(corkReq, state, err) {
    var entry = corkReq.entry;
    corkReq.entry = null;
    while(entry){
        var cb = entry.callback;
        state.pendingcb--;
        cb(err);
        entry = entry.next;
    }
    // reuse the free corkReq.
    state.corkedRequestsFree.next = corkReq;
}
Object.defineProperty($0f5f392bea975f91$var$Writable.prototype, 'destroyed', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        if (this._writableState === undefined) return false;
        return this._writableState.destroyed;
    },
    set: function set(value) {
        // we ignore the value if the stream
        // has not been initialized yet
        if (!this._writableState) return;
        // backward compatibility, the user is explicitly
        // managing destroyed
        this._writableState.destroyed = value;
    }
});
$0f5f392bea975f91$var$Writable.prototype.destroy = $cGIaz.destroy;
$0f5f392bea975f91$var$Writable.prototype._undestroy = $cGIaz.undestroy;
$0f5f392bea975f91$var$Writable.prototype._destroy = function(err, cb) {
    cb(err);
};

});
parcelRegister("fI2xT", function(module, exports) {
/**
 * Module exports.
 */ module.exports = $b6fcf09913bebe8c$var$deprecate;
/**
 * Mark that a method should not be used.
 * Returns a modified function which warns once by default.
 *
 * If `localStorage.noDeprecation = true` is set, then it is a no-op.
 *
 * If `localStorage.throwDeprecation = true` is set, then deprecated functions
 * will throw an Error when invoked.
 *
 * If `localStorage.traceDeprecation = true` is set, then deprecated functions
 * will invoke `console.trace()` instead of `console.error()`.
 *
 * @param {Function} fn - the function to deprecate
 * @param {String} msg - the string to print to the console when `fn` is invoked
 * @returns {Function} a new "deprecated" version of `fn`
 * @api public
 */ function $b6fcf09913bebe8c$var$deprecate(fn, msg) {
    if ($b6fcf09913bebe8c$var$config('noDeprecation')) return fn;
    var warned = false;
    function deprecated() {
        if (!warned) {
            if ($b6fcf09913bebe8c$var$config('throwDeprecation')) throw new Error(msg);
            else if ($b6fcf09913bebe8c$var$config('traceDeprecation')) console.trace(msg);
            else console.warn(msg);
            warned = true;
        }
        return fn.apply(this, arguments);
    }
    return deprecated;
}
/**
 * Checks `localStorage` for boolean values for the given `name`.
 *
 * @param {String} name
 * @returns {Boolean}
 * @api private
 */ function $b6fcf09913bebe8c$var$config(name) {
    // accessing global.localStorage can trigger a DOMException in sandboxed iframes
    try {
        if (!$parcel$global.localStorage) return false;
    } catch (_) {
        return false;
    }
    var val = $parcel$global.localStorage[name];
    if (null == val) return false;
    return String(val).toLowerCase() === 'true';
}

});



parcelRegister("iSHBk", function(module, exports) {

$parcel$export(module.exports, "StringDecoder", function () { return $dbef17621d118de3$export$63a7aa211a91ed69; }, function (v) { return $dbef17621d118de3$export$63a7aa211a91ed69 = v; });
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// StringDecoder provides an interface for efficiently splitting a series of
// buffers into a series of JS strings without breaking apart multi-byte
// characters.
var $dbef17621d118de3$export$63a7aa211a91ed69;
'use strict';

var $5ohfr = parcelRequire("5ohfr");
var $dbef17621d118de3$require$Buffer = $5ohfr.Buffer;
/*</replacement>*/ var $dbef17621d118de3$var$isEncoding = $dbef17621d118de3$require$Buffer.isEncoding || function(encoding) {
    encoding = '' + encoding;
    switch(encoding && encoding.toLowerCase()){
        case 'hex':
        case 'utf8':
        case 'utf-8':
        case 'ascii':
        case 'binary':
        case 'base64':
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
        case 'raw':
            return true;
        default:
            return false;
    }
};
function $dbef17621d118de3$var$_normalizeEncoding(enc) {
    if (!enc) return 'utf8';
    var retried;
    while(true)switch(enc){
        case 'utf8':
        case 'utf-8':
            return 'utf8';
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return 'utf16le';
        case 'latin1':
        case 'binary':
            return 'latin1';
        case 'base64':
        case 'ascii':
        case 'hex':
            return enc;
        default:
            if (retried) return; // undefined
            enc = ('' + enc).toLowerCase();
            retried = true;
    }
}
// Do not cache `Buffer.isEncoding` when checking encoding names as some
// modules monkey-patch it to support additional encodings
function $dbef17621d118de3$var$normalizeEncoding(enc) {
    var nenc = $dbef17621d118de3$var$_normalizeEncoding(enc);
    if (typeof nenc !== 'string' && ($dbef17621d118de3$require$Buffer.isEncoding === $dbef17621d118de3$var$isEncoding || !$dbef17621d118de3$var$isEncoding(enc))) throw new Error('Unknown encoding: ' + enc);
    return nenc || enc;
}
$dbef17621d118de3$export$63a7aa211a91ed69 = $dbef17621d118de3$var$StringDecoder;
function $dbef17621d118de3$var$StringDecoder(encoding) {
    this.encoding = $dbef17621d118de3$var$normalizeEncoding(encoding);
    var nb;
    switch(this.encoding){
        case 'utf16le':
            this.text = $dbef17621d118de3$var$utf16Text;
            this.end = $dbef17621d118de3$var$utf16End;
            nb = 4;
            break;
        case 'utf8':
            this.fillLast = $dbef17621d118de3$var$utf8FillLast;
            nb = 4;
            break;
        case 'base64':
            this.text = $dbef17621d118de3$var$base64Text;
            this.end = $dbef17621d118de3$var$base64End;
            nb = 3;
            break;
        default:
            this.write = $dbef17621d118de3$var$simpleWrite;
            this.end = $dbef17621d118de3$var$simpleEnd;
            return;
    }
    this.lastNeed = 0;
    this.lastTotal = 0;
    this.lastChar = $dbef17621d118de3$require$Buffer.allocUnsafe(nb);
}
$dbef17621d118de3$var$StringDecoder.prototype.write = function(buf) {
    if (buf.length === 0) return '';
    var r;
    var i;
    if (this.lastNeed) {
        r = this.fillLast(buf);
        if (r === undefined) return '';
        i = this.lastNeed;
        this.lastNeed = 0;
    } else i = 0;
    if (i < buf.length) return r ? r + this.text(buf, i) : this.text(buf, i);
    return r || '';
};
$dbef17621d118de3$var$StringDecoder.prototype.end = $dbef17621d118de3$var$utf8End;
// Returns only complete characters in a Buffer
$dbef17621d118de3$var$StringDecoder.prototype.text = $dbef17621d118de3$var$utf8Text;
// Attempts to complete a partial non-UTF-8 character using bytes from a Buffer
$dbef17621d118de3$var$StringDecoder.prototype.fillLast = function(buf) {
    if (this.lastNeed <= buf.length) {
        buf.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, this.lastNeed);
        return this.lastChar.toString(this.encoding, 0, this.lastTotal);
    }
    buf.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, buf.length);
    this.lastNeed -= buf.length;
};
// Checks the type of a UTF-8 byte, whether it's ASCII, a leading byte, or a
// continuation byte. If an invalid byte is detected, -2 is returned.
function $dbef17621d118de3$var$utf8CheckByte(byte) {
    if (byte <= 0x7F) return 0;
    else if (byte >> 5 === 0x06) return 2;
    else if (byte >> 4 === 0x0E) return 3;
    else if (byte >> 3 === 0x1E) return 4;
    return byte >> 6 === 0x02 ? -1 : -2;
}
// Checks at most 3 bytes at the end of a Buffer in order to detect an
// incomplete multi-byte UTF-8 character. The total number of bytes (2, 3, or 4)
// needed to complete the UTF-8 character (if applicable) are returned.
function $dbef17621d118de3$var$utf8CheckIncomplete(self, buf, i) {
    var j = buf.length - 1;
    if (j < i) return 0;
    var nb = $dbef17621d118de3$var$utf8CheckByte(buf[j]);
    if (nb >= 0) {
        if (nb > 0) self.lastNeed = nb - 1;
        return nb;
    }
    if (--j < i || nb === -2) return 0;
    nb = $dbef17621d118de3$var$utf8CheckByte(buf[j]);
    if (nb >= 0) {
        if (nb > 0) self.lastNeed = nb - 2;
        return nb;
    }
    if (--j < i || nb === -2) return 0;
    nb = $dbef17621d118de3$var$utf8CheckByte(buf[j]);
    if (nb >= 0) {
        if (nb > 0) {
            if (nb === 2) nb = 0;
            else self.lastNeed = nb - 3;
        }
        return nb;
    }
    return 0;
}
// Validates as many continuation bytes for a multi-byte UTF-8 character as
// needed or are available. If we see a non-continuation byte where we expect
// one, we "replace" the validated continuation bytes we've seen so far with
// a single UTF-8 replacement character ('\ufffd'), to match v8's UTF-8 decoding
// behavior. The continuation byte check is included three times in the case
// where all of the continuation bytes for a character exist in the same buffer.
// It is also done this way as a slight performance increase instead of using a
// loop.
function $dbef17621d118de3$var$utf8CheckExtraBytes(self, buf, p) {
    if ((buf[0] & 0xC0) !== 0x80) {
        self.lastNeed = 0;
        return '\ufffd';
    }
    if (self.lastNeed > 1 && buf.length > 1) {
        if ((buf[1] & 0xC0) !== 0x80) {
            self.lastNeed = 1;
            return '\ufffd';
        }
        if (self.lastNeed > 2 && buf.length > 2) {
            if ((buf[2] & 0xC0) !== 0x80) {
                self.lastNeed = 2;
                return '\ufffd';
            }
        }
    }
}
// Attempts to complete a multi-byte UTF-8 character using bytes from a Buffer.
function $dbef17621d118de3$var$utf8FillLast(buf) {
    var p = this.lastTotal - this.lastNeed;
    var r = $dbef17621d118de3$var$utf8CheckExtraBytes(this, buf, p);
    if (r !== undefined) return r;
    if (this.lastNeed <= buf.length) {
        buf.copy(this.lastChar, p, 0, this.lastNeed);
        return this.lastChar.toString(this.encoding, 0, this.lastTotal);
    }
    buf.copy(this.lastChar, p, 0, buf.length);
    this.lastNeed -= buf.length;
}
// Returns all complete UTF-8 characters in a Buffer. If the Buffer ended on a
// partial character, the character's bytes are buffered until the required
// number of bytes are available.
function $dbef17621d118de3$var$utf8Text(buf, i) {
    var total = $dbef17621d118de3$var$utf8CheckIncomplete(this, buf, i);
    if (!this.lastNeed) return buf.toString('utf8', i);
    this.lastTotal = total;
    var end = buf.length - (total - this.lastNeed);
    buf.copy(this.lastChar, 0, end);
    return buf.toString('utf8', i, end);
}
// For UTF-8, a replacement character is added when ending on a partial
// character.
function $dbef17621d118de3$var$utf8End(buf) {
    var r = buf && buf.length ? this.write(buf) : '';
    if (this.lastNeed) return r + '\ufffd';
    return r;
}
// UTF-16LE typically needs two bytes per character, but even if we have an even
// number of bytes available, we need to check if we end on a leading/high
// surrogate. In that case, we need to wait for the next two bytes in order to
// decode the last character properly.
function $dbef17621d118de3$var$utf16Text(buf, i) {
    if ((buf.length - i) % 2 === 0) {
        var r = buf.toString('utf16le', i);
        if (r) {
            var c = r.charCodeAt(r.length - 1);
            if (c >= 0xD800 && c <= 0xDBFF) {
                this.lastNeed = 2;
                this.lastTotal = 4;
                this.lastChar[0] = buf[buf.length - 2];
                this.lastChar[1] = buf[buf.length - 1];
                return r.slice(0, -1);
            }
        }
        return r;
    }
    this.lastNeed = 1;
    this.lastTotal = 2;
    this.lastChar[0] = buf[buf.length - 1];
    return buf.toString('utf16le', i, buf.length - 1);
}
// For UTF-16LE we do not explicitly append special replacement characters if we
// end on a partial character, we simply let v8 handle that.
function $dbef17621d118de3$var$utf16End(buf) {
    var r = buf && buf.length ? this.write(buf) : '';
    if (this.lastNeed) {
        var end = this.lastTotal - this.lastNeed;
        return r + this.lastChar.toString('utf16le', 0, end);
    }
    return r;
}
function $dbef17621d118de3$var$base64Text(buf, i) {
    var n = (buf.length - i) % 3;
    if (n === 0) return buf.toString('base64', i);
    this.lastNeed = 3 - n;
    this.lastTotal = 3;
    if (n === 1) this.lastChar[0] = buf[buf.length - 1];
    else {
        this.lastChar[0] = buf[buf.length - 2];
        this.lastChar[1] = buf[buf.length - 1];
    }
    return buf.toString('base64', i, buf.length - n);
}
function $dbef17621d118de3$var$base64End(buf) {
    var r = buf && buf.length ? this.write(buf) : '';
    if (this.lastNeed) return r + this.lastChar.toString('base64', 0, 3 - this.lastNeed);
    return r;
}
// Pass bytes on through for single-byte encodings (e.g. ascii, latin1, hex)
function $dbef17621d118de3$var$simpleWrite(buf) {
    return buf.toString(this.encoding);
}
function $dbef17621d118de3$var$simpleEnd(buf) {
    return buf && buf.length ? this.write(buf) : '';
}

});
parcelRegister("5ohfr", function(module, exports) {
/*! safe-buffer. MIT License. Feross Aboukhadijeh <https://feross.org/opensource> */ /* eslint-disable node/no-deprecated-api */ 
var $isEGv = parcelRequire("isEGv");
var $3ecc92c0c10f1633$var$Buffer = $isEGv.Buffer;
// alternative to using Object.keys for old browsers
function $3ecc92c0c10f1633$var$copyProps(src, dst) {
    for(var key in src)dst[key] = src[key];
}
if ($3ecc92c0c10f1633$var$Buffer.from && $3ecc92c0c10f1633$var$Buffer.alloc && $3ecc92c0c10f1633$var$Buffer.allocUnsafe && $3ecc92c0c10f1633$var$Buffer.allocUnsafeSlow) module.exports = $isEGv;
else {
    // Copy properties from require('buffer')
    $3ecc92c0c10f1633$var$copyProps($isEGv, module.exports);
    module.exports.Buffer = $3ecc92c0c10f1633$var$SafeBuffer;
}
function $3ecc92c0c10f1633$var$SafeBuffer(arg, encodingOrOffset, length) {
    return $3ecc92c0c10f1633$var$Buffer(arg, encodingOrOffset, length);
}
$3ecc92c0c10f1633$var$SafeBuffer.prototype = Object.create($3ecc92c0c10f1633$var$Buffer.prototype);
// Copy static methods from Buffer
$3ecc92c0c10f1633$var$copyProps($3ecc92c0c10f1633$var$Buffer, $3ecc92c0c10f1633$var$SafeBuffer);
$3ecc92c0c10f1633$var$SafeBuffer.from = function(arg, encodingOrOffset, length) {
    if (typeof arg === 'number') throw new TypeError('Argument must not be a number');
    return $3ecc92c0c10f1633$var$Buffer(arg, encodingOrOffset, length);
};
$3ecc92c0c10f1633$var$SafeBuffer.alloc = function(size, fill, encoding) {
    if (typeof size !== 'number') throw new TypeError('Argument must be a number');
    var buf = $3ecc92c0c10f1633$var$Buffer(size);
    if (fill !== undefined) {
        if (typeof encoding === 'string') buf.fill(fill, encoding);
        else buf.fill(fill);
    } else buf.fill(0);
    return buf;
};
$3ecc92c0c10f1633$var$SafeBuffer.allocUnsafe = function(size) {
    if (typeof size !== 'number') throw new TypeError('Argument must be a number');
    return $3ecc92c0c10f1633$var$Buffer(size);
};
$3ecc92c0c10f1633$var$SafeBuffer.allocUnsafeSlow = function(size) {
    if (typeof size !== 'number') throw new TypeError('Argument must be a number');
    return $isEGv.SlowBuffer(size);
};

});


parcelRegister("39wwT", function(module, exports) {

var $6tOPT = parcelRequire("6tOPT");

var $dKiQF = parcelRequire("dKiQF");
'use strict';
var $24bb720cbcb2377b$var$_Object$setPrototypeO;
function $24bb720cbcb2377b$var$_defineProperty(obj, key, value) {
    key = $24bb720cbcb2377b$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $24bb720cbcb2377b$var$_toPropertyKey(arg) {
    var key = $24bb720cbcb2377b$var$_toPrimitive(arg, "string");
    return (typeof key === "undefined" ? "undefined" : (0, $6tOPT._)(key)) === "symbol" ? key : String(key);
}
function $24bb720cbcb2377b$var$_toPrimitive(input, hint) {
    if ((typeof input === "undefined" ? "undefined" : (0, $6tOPT._)(input)) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ((typeof res === "undefined" ? "undefined" : (0, $6tOPT._)(res)) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}

var $jCHM5 = parcelRequire("jCHM5");
var $24bb720cbcb2377b$var$kLastResolve = Symbol('lastResolve');
var $24bb720cbcb2377b$var$kLastReject = Symbol('lastReject');
var $24bb720cbcb2377b$var$kError = Symbol('error');
var $24bb720cbcb2377b$var$kEnded = Symbol('ended');
var $24bb720cbcb2377b$var$kLastPromise = Symbol('lastPromise');
var $24bb720cbcb2377b$var$kHandlePromise = Symbol('handlePromise');
var $24bb720cbcb2377b$var$kStream = Symbol('stream');
function $24bb720cbcb2377b$var$createIterResult(value, done) {
    return {
        value: value,
        done: done
    };
}
function $24bb720cbcb2377b$var$readAndResolve(iter) {
    var resolve = iter[$24bb720cbcb2377b$var$kLastResolve];
    if (resolve !== null) {
        var data = iter[$24bb720cbcb2377b$var$kStream].read();
        // we defer if data is null
        // we can be expecting either 'end' or
        // 'error'
        if (data !== null) {
            iter[$24bb720cbcb2377b$var$kLastPromise] = null;
            iter[$24bb720cbcb2377b$var$kLastResolve] = null;
            iter[$24bb720cbcb2377b$var$kLastReject] = null;
            resolve($24bb720cbcb2377b$var$createIterResult(data, false));
        }
    }
}
function $24bb720cbcb2377b$var$onReadable(iter) {
    // we wait for the next tick, because it might
    // emit an error with process.nextTick
    $dKiQF.nextTick($24bb720cbcb2377b$var$readAndResolve, iter);
}
function $24bb720cbcb2377b$var$wrapForNext(lastPromise, iter) {
    return function(resolve, reject) {
        lastPromise.then(function() {
            if (iter[$24bb720cbcb2377b$var$kEnded]) {
                resolve($24bb720cbcb2377b$var$createIterResult(undefined, true));
                return;
            }
            iter[$24bb720cbcb2377b$var$kHandlePromise](resolve, reject);
        }, reject);
    };
}
var $24bb720cbcb2377b$var$AsyncIteratorPrototype = Object.getPrototypeOf(function() {});
var $24bb720cbcb2377b$var$ReadableStreamAsyncIteratorPrototype = Object.setPrototypeOf(($24bb720cbcb2377b$var$_Object$setPrototypeO = {
    get stream () {
        return this[$24bb720cbcb2377b$var$kStream];
    },
    next: function next() {
        var _this = this;
        // if we have detected an error in the meanwhile
        // reject straight away
        var error = this[$24bb720cbcb2377b$var$kError];
        if (error !== null) return Promise.reject(error);
        if (this[$24bb720cbcb2377b$var$kEnded]) return Promise.resolve($24bb720cbcb2377b$var$createIterResult(undefined, true));
        if (this[$24bb720cbcb2377b$var$kStream].destroyed) // We need to defer via nextTick because if .destroy(err) is
        // called, the error will be emitted via nextTick, and
        // we cannot guarantee that there is no error lingering around
        // waiting to be emitted.
        return new Promise(function(resolve, reject) {
            $dKiQF.nextTick(function() {
                if (_this[$24bb720cbcb2377b$var$kError]) reject(_this[$24bb720cbcb2377b$var$kError]);
                else resolve($24bb720cbcb2377b$var$createIterResult(undefined, true));
            });
        });
        // if we have multiple next() calls
        // we will wait for the previous Promise to finish
        // this logic is optimized to support for await loops,
        // where next() is only called once at a time
        var lastPromise = this[$24bb720cbcb2377b$var$kLastPromise];
        var promise;
        if (lastPromise) promise = new Promise($24bb720cbcb2377b$var$wrapForNext(lastPromise, this));
        else {
            // fast path needed to support multiple this.push()
            // without triggering the next() queue
            var data = this[$24bb720cbcb2377b$var$kStream].read();
            if (data !== null) return Promise.resolve($24bb720cbcb2377b$var$createIterResult(data, false));
            promise = new Promise(this[$24bb720cbcb2377b$var$kHandlePromise]);
        }
        this[$24bb720cbcb2377b$var$kLastPromise] = promise;
        return promise;
    }
}, $24bb720cbcb2377b$var$_defineProperty($24bb720cbcb2377b$var$_Object$setPrototypeO, Symbol.asyncIterator, function() {
    return this;
}), $24bb720cbcb2377b$var$_defineProperty($24bb720cbcb2377b$var$_Object$setPrototypeO, "return", function _return() {
    var _this2 = this;
    // destroy(err, cb) is a private API
    // we can guarantee we have that here, because we control the
    // Readable class this is attached to
    return new Promise(function(resolve, reject) {
        _this2[$24bb720cbcb2377b$var$kStream].destroy(null, function(err) {
            if (err) {
                reject(err);
                return;
            }
            resolve($24bb720cbcb2377b$var$createIterResult(undefined, true));
        });
    });
}), $24bb720cbcb2377b$var$_Object$setPrototypeO), $24bb720cbcb2377b$var$AsyncIteratorPrototype);
var $24bb720cbcb2377b$var$createReadableStreamAsyncIterator = function createReadableStreamAsyncIterator(stream) {
    var _Object$create;
    var iterator = Object.create($24bb720cbcb2377b$var$ReadableStreamAsyncIteratorPrototype, (_Object$create = {}, $24bb720cbcb2377b$var$_defineProperty(_Object$create, $24bb720cbcb2377b$var$kStream, {
        value: stream,
        writable: true
    }), $24bb720cbcb2377b$var$_defineProperty(_Object$create, $24bb720cbcb2377b$var$kLastResolve, {
        value: null,
        writable: true
    }), $24bb720cbcb2377b$var$_defineProperty(_Object$create, $24bb720cbcb2377b$var$kLastReject, {
        value: null,
        writable: true
    }), $24bb720cbcb2377b$var$_defineProperty(_Object$create, $24bb720cbcb2377b$var$kError, {
        value: null,
        writable: true
    }), $24bb720cbcb2377b$var$_defineProperty(_Object$create, $24bb720cbcb2377b$var$kEnded, {
        value: stream._readableState.endEmitted,
        writable: true
    }), $24bb720cbcb2377b$var$_defineProperty(_Object$create, $24bb720cbcb2377b$var$kHandlePromise, {
        value: function value(resolve, reject) {
            var data = iterator[$24bb720cbcb2377b$var$kStream].read();
            if (data) {
                iterator[$24bb720cbcb2377b$var$kLastPromise] = null;
                iterator[$24bb720cbcb2377b$var$kLastResolve] = null;
                iterator[$24bb720cbcb2377b$var$kLastReject] = null;
                resolve($24bb720cbcb2377b$var$createIterResult(data, false));
            } else {
                iterator[$24bb720cbcb2377b$var$kLastResolve] = resolve;
                iterator[$24bb720cbcb2377b$var$kLastReject] = reject;
            }
        },
        writable: true
    }), _Object$create));
    iterator[$24bb720cbcb2377b$var$kLastPromise] = null;
    $jCHM5(stream, function(err) {
        if (err && err.code !== 'ERR_STREAM_PREMATURE_CLOSE') {
            var reject = iterator[$24bb720cbcb2377b$var$kLastReject];
            // reject if we are waiting for data in the Promise
            // returned by next() and store the error
            if (reject !== null) {
                iterator[$24bb720cbcb2377b$var$kLastPromise] = null;
                iterator[$24bb720cbcb2377b$var$kLastResolve] = null;
                iterator[$24bb720cbcb2377b$var$kLastReject] = null;
                reject(err);
            }
            iterator[$24bb720cbcb2377b$var$kError] = err;
            return;
        }
        var resolve = iterator[$24bb720cbcb2377b$var$kLastResolve];
        if (resolve !== null) {
            iterator[$24bb720cbcb2377b$var$kLastPromise] = null;
            iterator[$24bb720cbcb2377b$var$kLastResolve] = null;
            iterator[$24bb720cbcb2377b$var$kLastReject] = null;
            resolve($24bb720cbcb2377b$var$createIterResult(undefined, true));
        }
        iterator[$24bb720cbcb2377b$var$kEnded] = true;
    });
    stream.on('readable', $24bb720cbcb2377b$var$onReadable.bind(null, iterator));
    return iterator;
};
module.exports = $24bb720cbcb2377b$var$createReadableStreamAsyncIterator;

});
parcelRegister("jCHM5", function(module, exports) {
// Ported from https://github.com/mafintosh/end-of-stream with
// permission from the author, Mathias Buus (@mafintosh).
'use strict';

var $e49385abb6561aa1$var$ERR_STREAM_PREMATURE_CLOSE = (parcelRequire("eFrw3")).codes.ERR_STREAM_PREMATURE_CLOSE;
function $e49385abb6561aa1$var$once(callback) {
    var called = false;
    return function() {
        if (called) return;
        called = true;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        callback.apply(this, args);
    };
}
function $e49385abb6561aa1$var$noop() {}
function $e49385abb6561aa1$var$isRequest(stream) {
    return stream.setHeader && typeof stream.abort === 'function';
}
function $e49385abb6561aa1$var$eos(stream, opts, callback) {
    if (typeof opts === 'function') return $e49385abb6561aa1$var$eos(stream, null, opts);
    if (!opts) opts = {};
    callback = $e49385abb6561aa1$var$once(callback || $e49385abb6561aa1$var$noop);
    var readable = opts.readable || opts.readable !== false && stream.readable;
    var writable = opts.writable || opts.writable !== false && stream.writable;
    var onlegacyfinish = function onlegacyfinish() {
        if (!stream.writable) onfinish();
    };
    var writableEnded = stream._writableState && stream._writableState.finished;
    var onfinish = function onfinish() {
        writable = false;
        writableEnded = true;
        if (!readable) callback.call(stream);
    };
    var readableEnded = stream._readableState && stream._readableState.endEmitted;
    var onend = function onend() {
        readable = false;
        readableEnded = true;
        if (!writable) callback.call(stream);
    };
    var onerror = function onerror(err) {
        callback.call(stream, err);
    };
    var onclose = function onclose() {
        var err;
        if (readable && !readableEnded) {
            if (!stream._readableState || !stream._readableState.ended) err = new $e49385abb6561aa1$var$ERR_STREAM_PREMATURE_CLOSE();
            return callback.call(stream, err);
        }
        if (writable && !writableEnded) {
            if (!stream._writableState || !stream._writableState.ended) err = new $e49385abb6561aa1$var$ERR_STREAM_PREMATURE_CLOSE();
            return callback.call(stream, err);
        }
    };
    var onrequest = function onrequest() {
        stream.req.on('finish', onfinish);
    };
    if ($e49385abb6561aa1$var$isRequest(stream)) {
        stream.on('complete', onfinish);
        stream.on('abort', onclose);
        if (stream.req) onrequest();
        else stream.on('request', onrequest);
    } else if (writable && !stream._writableState) {
        // legacy streams
        stream.on('end', onlegacyfinish);
        stream.on('close', onlegacyfinish);
    }
    stream.on('end', onend);
    stream.on('finish', onfinish);
    if (opts.error !== false) stream.on('error', onerror);
    stream.on('close', onclose);
    return function() {
        stream.removeListener('complete', onfinish);
        stream.removeListener('abort', onclose);
        stream.removeListener('request', onrequest);
        if (stream.req) stream.req.removeListener('finish', onfinish);
        stream.removeListener('end', onlegacyfinish);
        stream.removeListener('close', onlegacyfinish);
        stream.removeListener('finish', onfinish);
        stream.removeListener('end', onend);
        stream.removeListener('error', onerror);
        stream.removeListener('close', onclose);
    };
}
module.exports = $e49385abb6561aa1$var$eos;

});


parcelRegister("3G4jw", function(module, exports) {
module.exports = function() {
    throw new Error('Readable.from is not available in the browser');
};

});


parcelRegister("7zqf0", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a transform stream is a readable/writable stream where you do
// something with the data.  Sometimes it's called a "filter",
// but that's not a great name for it, since that implies a thing where
// some bits pass through, and others are simply ignored.  (That would
// be a valid example of a transform, of course.)
//
// While the output is causally related to the input, it's not a
// necessarily symmetric or synchronous transformation.  For example,
// a zlib stream might take multiple plain-text writes(), and then
// emit a single compressed chunk some time in the future.
//
// Here's how this works:
//
// The Transform stream has all the aspects of the readable and writable
// stream classes.  When you write(chunk), that calls _write(chunk,cb)
// internally, and returns false if there's a lot of pending writes
// buffered up.  When you call read(), that calls _read(n) until
// there's enough pending readable data buffered up.
//
// In a transform stream, the written data is placed in a buffer.  When
// _read(n) is called, it transforms the queued up data, calling the
// buffered _write cb's as it consumes chunks.  If consuming a single
// written chunk would result in multiple output chunks, then the first
// outputted bit calls the readcb, and subsequent chunks just go into
// the read buffer, and will cause it to emit 'readable' if necessary.
//
// This way, back-pressure is actually determined by the reading side,
// since _read has to be called to start processing a new chunk.  However,
// a pathological inflate type of transform can cause excessive buffering
// here.  For example, imagine a stream where every byte of input is
// interpreted as an integer from 0-255, and then results in that many
// bytes of output.  Writing the 4 bytes {ff,ff,ff,ff} would result in
// 1kb of data being output.  In this case, you could write a very small
// amount of input, and end up with a very large amount of output.  In
// such a pathological inflating mechanism, there'd be no way to tell
// the system to stop doing the transform.  A single 4MB write could
// cause the system to run out of memory.
//
// However, even in such a pathological case, only a single written chunk
// would be consumed, and then the rest would wait (un-transformed) until
// the results of the previous transformed chunk were consumed.
'use strict';
module.exports = $5830283876657f52$var$Transform;

var $eFrw3 = parcelRequire("eFrw3");
var $5830283876657f52$require$_require$codes = $eFrw3.codes;
var $5830283876657f52$var$ERR_METHOD_NOT_IMPLEMENTED = $5830283876657f52$require$_require$codes.ERR_METHOD_NOT_IMPLEMENTED, $5830283876657f52$var$ERR_MULTIPLE_CALLBACK = $5830283876657f52$require$_require$codes.ERR_MULTIPLE_CALLBACK, $5830283876657f52$var$ERR_TRANSFORM_ALREADY_TRANSFORMING = $5830283876657f52$require$_require$codes.ERR_TRANSFORM_ALREADY_TRANSFORMING, $5830283876657f52$var$ERR_TRANSFORM_WITH_LENGTH_0 = $5830283876657f52$require$_require$codes.ERR_TRANSFORM_WITH_LENGTH_0;

var $5h9D2 = parcelRequire("5h9D2");

(parcelRequire("ACMoe"))($5830283876657f52$var$Transform, $5h9D2);
function $5830283876657f52$var$afterTransform(er, data) {
    var ts = this._transformState;
    ts.transforming = false;
    var cb = ts.writecb;
    if (cb === null) return this.emit('error', new $5830283876657f52$var$ERR_MULTIPLE_CALLBACK());
    ts.writechunk = null;
    ts.writecb = null;
    if (data != null) // single equals check for both `null` and `undefined`
    this.push(data);
    cb(er);
    var rs = this._readableState;
    rs.reading = false;
    if (rs.needReadable || rs.length < rs.highWaterMark) this._read(rs.highWaterMark);
}
function $5830283876657f52$var$Transform(options) {
    if (!(this instanceof $5830283876657f52$var$Transform)) return new $5830283876657f52$var$Transform(options);
    $5h9D2.call(this, options);
    this._transformState = {
        afterTransform: $5830283876657f52$var$afterTransform.bind(this),
        needTransform: false,
        transforming: false,
        writecb: null,
        writechunk: null,
        writeencoding: null
    };
    // start out asking for a readable event once data is transformed.
    this._readableState.needReadable = true;
    // we have implemented the _read method, and done the other things
    // that Readable wants before the first _read call, so unset the
    // sync guard flag.
    this._readableState.sync = false;
    if (options) {
        if (typeof options.transform === 'function') this._transform = options.transform;
        if (typeof options.flush === 'function') this._flush = options.flush;
    }
    // When the writable side finishes, then flush out anything remaining.
    this.on('prefinish', $5830283876657f52$var$prefinish);
}
function $5830283876657f52$var$prefinish() {
    var _this = this;
    if (typeof this._flush === 'function' && !this._readableState.destroyed) this._flush(function(er, data) {
        $5830283876657f52$var$done(_this, er, data);
    });
    else $5830283876657f52$var$done(this, null, null);
}
$5830283876657f52$var$Transform.prototype.push = function(chunk, encoding) {
    this._transformState.needTransform = false;
    return $5h9D2.prototype.push.call(this, chunk, encoding);
};
// This is the part where you do stuff!
// override this function in implementation classes.
// 'chunk' is an input chunk.
//
// Call `push(newChunk)` to pass along transformed output
// to the readable side.  You may call 'push' zero or more times.
//
// Call `cb(err)` when you are done with this chunk.  If you pass
// an error, then that'll put the hurt on the whole operation.  If you
// never call cb(), then you'll never get another chunk.
$5830283876657f52$var$Transform.prototype._transform = function(chunk, encoding, cb) {
    cb(new $5830283876657f52$var$ERR_METHOD_NOT_IMPLEMENTED('_transform()'));
};
$5830283876657f52$var$Transform.prototype._write = function(chunk, encoding, cb) {
    var ts = this._transformState;
    ts.writecb = cb;
    ts.writechunk = chunk;
    ts.writeencoding = encoding;
    if (!ts.transforming) {
        var rs = this._readableState;
        if (ts.needTransform || rs.needReadable || rs.length < rs.highWaterMark) this._read(rs.highWaterMark);
    }
};
// Doesn't matter what the args are here.
// _transform does all the work.
// That we got here means that the readable side wants more data.
$5830283876657f52$var$Transform.prototype._read = function(n) {
    var ts = this._transformState;
    if (ts.writechunk !== null && !ts.transforming) {
        ts.transforming = true;
        this._transform(ts.writechunk, ts.writeencoding, ts.afterTransform);
    } else // mark that we need a transform, so that any data that comes in
    // will get processed, now that we've asked for it.
    ts.needTransform = true;
};
$5830283876657f52$var$Transform.prototype._destroy = function(err, cb) {
    $5h9D2.prototype._destroy.call(this, err, function(err2) {
        cb(err2);
    });
};
function $5830283876657f52$var$done(stream, er, data) {
    if (er) return stream.emit('error', er);
    if (data != null) // single equals check for both `null` and `undefined`
    stream.push(data);
    // TODO(BridgeAR): Write a test for these two error cases
    // if there's nothing in the write buffer, then that means
    // that nothing more will ever be provided
    if (stream._writableState.length) throw new $5830283876657f52$var$ERR_TRANSFORM_WITH_LENGTH_0();
    if (stream._transformState.transforming) throw new $5830283876657f52$var$ERR_TRANSFORM_ALREADY_TRANSFORMING();
    return stream.push(null);
}

});

parcelRegister("lqaNH", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a passthrough stream.
// basically just the most minimal sort of Transform stream.
// Every written chunk gets output as-is.
'use strict';
module.exports = $f98467751784b44d$var$PassThrough;

var $7zqf0 = parcelRequire("7zqf0");

(parcelRequire("ACMoe"))($f98467751784b44d$var$PassThrough, $7zqf0);
function $f98467751784b44d$var$PassThrough(options) {
    if (!(this instanceof $f98467751784b44d$var$PassThrough)) return new $f98467751784b44d$var$PassThrough(options);
    $7zqf0.call(this, options);
}
$f98467751784b44d$var$PassThrough.prototype._transform = function(chunk, encoding, cb) {
    cb(null, chunk);
};

});

parcelRegister("lWAxK", function(module, exports) {
// Ported from https://github.com/mafintosh/pump with
// permission from the author, Mathias Buus (@mafintosh).
'use strict';
var $ff9b5c7ec83a0465$var$eos;
function $ff9b5c7ec83a0465$var$once(callback) {
    var called = false;
    return function() {
        if (called) return;
        called = true;
        callback.apply(void 0, arguments);
    };
}

var $eFrw3 = parcelRequire("eFrw3");
var $ff9b5c7ec83a0465$require$_require$codes = $eFrw3.codes;
var $ff9b5c7ec83a0465$var$ERR_MISSING_ARGS = $ff9b5c7ec83a0465$require$_require$codes.ERR_MISSING_ARGS, $ff9b5c7ec83a0465$var$ERR_STREAM_DESTROYED = $ff9b5c7ec83a0465$require$_require$codes.ERR_STREAM_DESTROYED;
function $ff9b5c7ec83a0465$var$noop(err) {
    // Rethrow the error if it exists to avoid swallowing it
    if (err) throw err;
}
function $ff9b5c7ec83a0465$var$isRequest(stream) {
    return stream.setHeader && typeof stream.abort === 'function';
}

function $ff9b5c7ec83a0465$var$destroyer(stream, reading, writing, callback) {
    callback = $ff9b5c7ec83a0465$var$once(callback);
    var closed = false;
    stream.on('close', function() {
        closed = true;
    });
    if ($ff9b5c7ec83a0465$var$eos === undefined) $ff9b5c7ec83a0465$var$eos = (parcelRequire("jCHM5"));
    $ff9b5c7ec83a0465$var$eos(stream, {
        readable: reading,
        writable: writing
    }, function(err) {
        if (err) return callback(err);
        closed = true;
        callback();
    });
    var destroyed = false;
    return function(err) {
        if (closed) return;
        if (destroyed) return;
        destroyed = true;
        // request.destroy just do .end - .abort is what we want
        if ($ff9b5c7ec83a0465$var$isRequest(stream)) return stream.abort();
        if (typeof stream.destroy === 'function') return stream.destroy();
        callback(err || new $ff9b5c7ec83a0465$var$ERR_STREAM_DESTROYED('pipe'));
    };
}
function $ff9b5c7ec83a0465$var$call(fn) {
    fn();
}
function $ff9b5c7ec83a0465$var$pipe(from, to) {
    return from.pipe(to);
}
function $ff9b5c7ec83a0465$var$popCallback(streams) {
    if (!streams.length) return $ff9b5c7ec83a0465$var$noop;
    if (typeof streams[streams.length - 1] !== 'function') return $ff9b5c7ec83a0465$var$noop;
    return streams.pop();
}
function $ff9b5c7ec83a0465$var$pipeline() {
    for(var _len = arguments.length, streams = new Array(_len), _key = 0; _key < _len; _key++)streams[_key] = arguments[_key];
    var callback = $ff9b5c7ec83a0465$var$popCallback(streams);
    if (Array.isArray(streams[0])) streams = streams[0];
    if (streams.length < 2) throw new $ff9b5c7ec83a0465$var$ERR_MISSING_ARGS('streams');
    var error;
    var destroys = streams.map(function(stream, i) {
        var reading = i < streams.length - 1;
        var writing = i > 0;
        return $ff9b5c7ec83a0465$var$destroyer(stream, reading, writing, function(err) {
            if (!error) error = err;
            if (err) destroys.forEach($ff9b5c7ec83a0465$var$call);
            if (reading) return;
            destroys.forEach($ff9b5c7ec83a0465$var$call);
            callback(error);
        });
    });
    return streams.reduce($ff9b5c7ec83a0465$var$pipe);
}
module.exports = $ff9b5c7ec83a0465$var$pipeline;

});


parcelRegister("9akFT", function(module, exports) {

$parcel$export(module.exports, "isIndexed", function () { return isIndexed; });
$parcel$export(module.exports, "isKeyed", function () { return isKeyed; });
$parcel$export(module.exports, "isAssociative", function () { return isAssociative; });
$parcel$export(module.exports, "isCollection", function () { return isCollection; });
$parcel$export(module.exports, "Collection", function () { return Collection; });
$parcel$export(module.exports, "Seq", function () { return Seq; });
$parcel$export(module.exports, "isRecord", function () { return isRecord; });
$parcel$export(module.exports, "isImmutable", function () { return isImmutable; });
$parcel$export(module.exports, "isOrdered", function () { return isOrdered; });
$parcel$export(module.exports, "isSeq", function () { return isSeq; });
$parcel$export(module.exports, "hash", function () { return hash; });
$parcel$export(module.exports, "Map", function () { return Map; });
$parcel$export(module.exports, "OrderedMap", function () { return OrderedMap; });
$parcel$export(module.exports, "isValueObject", function () { return isValueObject; });
$parcel$export(module.exports, "is", function () { return is; });
$parcel$export(module.exports, "update", function () { return update$1; });
$parcel$export(module.exports, "updateIn", function () { return updateIn; });
$parcel$export(module.exports, "isPlainObject", function () { return isPlainObject; });
$parcel$export(module.exports, "merge", function () { return merge; });
$parcel$export(module.exports, "mergeWith", function () { return mergeWith; });
$parcel$export(module.exports, "mergeDeep", function () { return mergeDeep$1; });
$parcel$export(module.exports, "mergeDeepWith", function () { return mergeDeepWith$1; });
$parcel$export(module.exports, "setIn", function () { return setIn$1; });
$parcel$export(module.exports, "isMap", function () { return isMap; });
$parcel$export(module.exports, "has", function () { return has; });
$parcel$export(module.exports, "get", function () { return get; });
$parcel$export(module.exports, "remove", function () { return remove; });
$parcel$export(module.exports, "set", function () { return set; });
$parcel$export(module.exports, "removeIn", function () { return removeIn; });
$parcel$export(module.exports, "isList", function () { return isList; });
$parcel$export(module.exports, "List", function () { return List; });
$parcel$export(module.exports, "isOrderedMap", function () { return isOrderedMap; });
$parcel$export(module.exports, "isStack", function () { return isStack; });
$parcel$export(module.exports, "Stack", function () { return Stack; });
$parcel$export(module.exports, "Range", function () { return Range; });
$parcel$export(module.exports, "isSet", function () { return isSet; });
$parcel$export(module.exports, "Set", function () { return Set; });
$parcel$export(module.exports, "OrderedSet", function () { return OrderedSet; });
$parcel$export(module.exports, "getIn", function () { return getIn$1; });
$parcel$export(module.exports, "hasIn", function () { return hasIn$1; });
$parcel$export(module.exports, "isOrderedSet", function () { return isOrderedSet; });
$parcel$export(module.exports, "PairSorting", function () { return PairSorting; });
$parcel$export(module.exports, "Record", function () { return Record; });
$parcel$export(module.exports, "Repeat", function () { return Repeat; });
$parcel$export(module.exports, "fromJS", function () { return fromJS; });
$parcel$export(module.exports, "version", function () { return version; });
$parcel$export(module.exports, "Iterable", function () { return Iterable; });
/**
 * @license
 * MIT License
 * 
 * Copyright (c) 2014-present, Lee Byron and other contributors.
 * 
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 * 
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 * 
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */ 
var $6tOPT = parcelRequire("6tOPT");
var IS_INDEXED_SYMBOL = '@@__IMMUTABLE_INDEXED__@@';
/**
 * True if `maybeIndexed` is a Collection.Indexed, or any of its subclasses.
 *
 * ```js
 * import { isIndexed, Map, List, Stack, Set } from 'immutable';
 *
 * isIndexed([]); // false
 * isIndexed({}); // false
 * isIndexed(Map()); // false
 * isIndexed(List()); // true
 * isIndexed(Stack()); // true
 * isIndexed(Set()); // false
 * ```
 */ function isIndexed(maybeIndexed) {
    return Boolean(maybeIndexed && // @ts-expect-error: maybeIndexed is typed as `{}`, need to change in 6.0 to `maybeIndexed && typeof maybeIndexed === 'object' && IS_INDEXED_SYMBOL in maybeIndexed`
    maybeIndexed[IS_INDEXED_SYMBOL]);
}
var IS_KEYED_SYMBOL = '@@__IMMUTABLE_KEYED__@@';
/**
 * True if `maybeKeyed` is a Collection.Keyed, or any of its subclasses.
 *
 * ```js
 * import { isKeyed, Map, List, Stack } from 'immutable';
 *
 * isKeyed([]); // false
 * isKeyed({}); // false
 * isKeyed(Map()); // true
 * isKeyed(List()); // false
 * isKeyed(Stack()); // false
 * ```
 */ function isKeyed(maybeKeyed) {
    return Boolean(maybeKeyed && // @ts-expect-error: maybeKeyed is typed as `{}`, need to change in 6.0 to `maybeKeyed && typeof maybeKeyed === 'object' && IS_KEYED_SYMBOL in maybeKeyed`
    maybeKeyed[IS_KEYED_SYMBOL]);
}
/**
 * True if `maybeAssociative` is either a Keyed or Indexed Collection.
 *
 * ```js
 * import { isAssociative, Map, List, Stack, Set } from 'immutable';
 *
 * isAssociative([]); // false
 * isAssociative({}); // false
 * isAssociative(Map()); // true
 * isAssociative(List()); // true
 * isAssociative(Stack()); // true
 * isAssociative(Set()); // false
 * ```
 */ function isAssociative(maybeAssociative) {
    return isKeyed(maybeAssociative) || isIndexed(maybeAssociative);
}
// Note: value is unchanged to not break immutable-devtools.
var IS_COLLECTION_SYMBOL = '@@__IMMUTABLE_ITERABLE__@@';
/**
 * True if `maybeCollection` is a Collection, or any of its subclasses.
 *
 * ```js
 * import { isCollection, Map, List, Stack } from 'immutable';
 *
 * isCollection([]); // false
 * isCollection({}); // false
 * isCollection(Map()); // true
 * isCollection(List()); // true
 * isCollection(Stack()); // true
 * ```
 */ function isCollection(maybeCollection) {
    return Boolean(maybeCollection && // @ts-expect-error: maybeCollection is typed as `{}`, need to change in 6.0 to `maybeCollection && typeof maybeCollection === 'object' && IS_COLLECTION_SYMBOL in maybeCollection`
    maybeCollection[IS_COLLECTION_SYMBOL]);
}
var Collection = function Collection(value) {
    // eslint-disable-next-line no-constructor-return
    return isCollection(value) ? value : Seq(value);
};
var KeyedCollection = /*@__PURE__*/ function(Collection) {
    function KeyedCollection(value) {
        // eslint-disable-next-line no-constructor-return
        return isKeyed(value) ? value : KeyedSeq(value);
    }
    if (Collection) KeyedCollection.__proto__ = Collection;
    KeyedCollection.prototype = Object.create(Collection && Collection.prototype);
    KeyedCollection.prototype.constructor = KeyedCollection;
    return KeyedCollection;
}(Collection);
var IndexedCollection = /*@__PURE__*/ function(Collection) {
    function IndexedCollection(value) {
        // eslint-disable-next-line no-constructor-return
        return isIndexed(value) ? value : IndexedSeq(value);
    }
    if (Collection) IndexedCollection.__proto__ = Collection;
    IndexedCollection.prototype = Object.create(Collection && Collection.prototype);
    IndexedCollection.prototype.constructor = IndexedCollection;
    return IndexedCollection;
}(Collection);
var SetCollection = /*@__PURE__*/ function(Collection) {
    function SetCollection(value) {
        // eslint-disable-next-line no-constructor-return
        return isCollection(value) && !isAssociative(value) ? value : SetSeq(value);
    }
    if (Collection) SetCollection.__proto__ = Collection;
    SetCollection.prototype = Object.create(Collection && Collection.prototype);
    SetCollection.prototype.constructor = SetCollection;
    return SetCollection;
}(Collection);
Collection.Keyed = KeyedCollection;
Collection.Indexed = IndexedCollection;
Collection.Set = SetCollection;
var ITERATE_KEYS = 0;
var ITERATE_VALUES = 1;
var ITERATE_ENTRIES = 2;
// TODO Symbol is widely available in modern JavaScript environments, clean this
var REAL_ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
var FAUX_ITERATOR_SYMBOL = '@@iterator';
var ITERATOR_SYMBOL = REAL_ITERATOR_SYMBOL || FAUX_ITERATOR_SYMBOL;
// @ts-expect-error: properties are not supported in buble
var Iterator = function Iterator(next) {
    // @ts-expect-error: properties are not supported in buble
    this.next = next;
};
Iterator.prototype.toString = function toString() {
    return '[Iterator]';
};
// @ts-expect-error: static properties are not supported in buble
Iterator.KEYS = ITERATE_KEYS;
// @ts-expect-error: static properties are not supported in buble
Iterator.VALUES = ITERATE_VALUES;
// @ts-expect-error: static properties are not supported in buble
Iterator.ENTRIES = ITERATE_ENTRIES;
// @ts-expect-error: properties are not supported in buble
Iterator.prototype.inspect = Iterator.prototype.toSource = function() {
    return this.toString();
};
// @ts-expect-error don't know how to type this
Iterator.prototype[ITERATOR_SYMBOL] = function() {
    return this;
};
function iteratorValue(type, k, v, iteratorResult) {
    var value = type === ITERATE_KEYS ? k : type === ITERATE_VALUES ? v : [
        k,
        v
    ];
    // eslint-disable-next-line @typescript-eslint/no-unused-expressions -- TODO enable eslint here
    iteratorResult ? iteratorResult.value = value : iteratorResult = {
        // @ts-expect-error ensure value is not undefined
        value: value,
        done: false
    };
    return iteratorResult;
}
function iteratorDone() {
    return {
        value: undefined,
        done: true
    };
}
function hasIterator(maybeIterable) {
    if (Array.isArray(maybeIterable)) // IE11 trick as it does not support `Symbol.iterator`
    return true;
    return !!getIteratorFn(maybeIterable);
}
function isIterator(maybeIterator) {
    return !!(maybeIterator && // @ts-expect-error: maybeIterator is typed as `{}`
    typeof maybeIterator.next === 'function');
}
function getIterator(iterable) {
    var iteratorFn = getIteratorFn(iterable);
    return iteratorFn && iteratorFn.call(iterable);
}
function getIteratorFn(iterable) {
    var iteratorFn = iterable && // @ts-expect-error: maybeIterator is typed as `{}`
    (REAL_ITERATOR_SYMBOL && iterable[REAL_ITERATOR_SYMBOL] || // @ts-expect-error: maybeIterator is typed as `{}`
    iterable[FAUX_ITERATOR_SYMBOL]);
    if (typeof iteratorFn === 'function') return iteratorFn;
}
function isEntriesIterable(maybeIterable) {
    var iteratorFn = getIteratorFn(maybeIterable);
    // @ts-expect-error: maybeIterator is typed as `{}`
    return iteratorFn && iteratorFn === maybeIterable.entries;
}
function isKeysIterable(maybeIterable) {
    var iteratorFn = getIteratorFn(maybeIterable);
    // @ts-expect-error: maybeIterator is typed as `{}`
    return iteratorFn && iteratorFn === maybeIterable.keys;
}
// Used for setting prototype methods that IE8 chokes on.
var DELETE = 'delete';
// Constants describing the size of trie nodes.
var SHIFT = 5; // Resulted in best performance after ______?
var SIZE = 1 << SHIFT;
var MASK = SIZE - 1;
// A consistent shared value representing "not set" which equals nothing other
// than itself, and nothing that could be provided externally.
var NOT_SET = {};
// Boolean references, Rough equivalent of `bool &`.
function MakeRef() {
    return {
        value: false
    };
}
function SetRef(ref) {
    if (ref) ref.value = true;
}
// A function which returns a value representing an "owner" for transient writes
// to tries. The return value will only ever equal itself, and will not equal
// the return of any subsequent call of this function.
function OwnerID() {}
function ensureSize(iter) {
    // @ts-expect-error size should exists on Collection
    if (iter.size === undefined) // @ts-expect-error size should exists on Collection, __iterate does exist on Collection
    iter.size = iter.__iterate(returnTrue);
    // @ts-expect-error size should exists on Collection
    return iter.size;
}
function wrapIndex(iter, index) {
    // This implements "is array index" which the ECMAString spec defines as:
    //
    //     A String property name P is an array index if and only if
    //     ToString(ToUint32(P)) is equal to P and ToUint32(P) is not equal
    //     to 2^32−1.
    //
    // http://www.ecma-international.org/ecma-262/6.0/#sec-array-exotic-objects
    if (typeof index !== 'number') {
        var uint32Index = index >>> 0; // N >>> 0 is shorthand for ToUint32
        if ('' + uint32Index !== index || uint32Index === 4294967295) return NaN;
        index = uint32Index;
    }
    return index < 0 ? ensureSize(iter) + index : index;
}
function returnTrue() {
    return true;
}
function wholeSlice(begin, end, size) {
    return (begin === 0 && !isNeg(begin) || size !== undefined && begin <= -size) && (end === undefined || size !== undefined && end >= size);
}
function resolveBegin(begin, size) {
    return resolveIndex(begin, size, 0);
}
function resolveEnd(end, size) {
    return resolveIndex(end, size, size);
}
function resolveIndex(index, size, defaultIndex) {
    // Sanitize indices using this shorthand for ToInt32(argument)
    // http://www.ecma-international.org/ecma-262/6.0/#sec-toint32
    return index === undefined ? defaultIndex : isNeg(index) ? size === Infinity ? size : Math.max(0, size + index) | 0 : size === undefined || size === index ? index : Math.min(size, index) | 0;
}
function isNeg(value) {
    // Account for -0 which is negative, but not less than 0.
    return value < 0 || value === 0 && 1 / value === -Infinity;
}
var IS_RECORD_SYMBOL = '@@__IMMUTABLE_RECORD__@@';
/**
 * True if `maybeRecord` is a Record.
 */ function isRecord(maybeRecord) {
    return Boolean(maybeRecord && // @ts-expect-error: maybeRecord is typed as `{}`, need to change in 6.0 to `maybeRecord && typeof maybeRecord === 'object' && IS_RECORD_SYMBOL in maybeRecord`
    maybeRecord[IS_RECORD_SYMBOL]);
}
/**
 * True if `maybeImmutable` is an Immutable Collection or Record.
 *
 * Note: Still returns true even if the collections is within a `withMutations()`.
 *
 * ```js
 * import { isImmutable, Map, List, Stack } from 'immutable';
 * isImmutable([]); // false
 * isImmutable({}); // false
 * isImmutable(Map()); // true
 * isImmutable(List()); // true
 * isImmutable(Stack()); // true
 * isImmutable(Map().asMutable()); // true
 * ```
 */ function isImmutable(maybeImmutable) {
    return isCollection(maybeImmutable) || isRecord(maybeImmutable);
}
var IS_ORDERED_SYMBOL = '@@__IMMUTABLE_ORDERED__@@';
function isOrdered(maybeOrdered) {
    return Boolean(maybeOrdered && // @ts-expect-error: maybeOrdered is typed as `{}`, need to change in 6.0 to `maybeOrdered && typeof maybeOrdered === 'object' && IS_ORDERED_SYMBOL in maybeOrdered`
    maybeOrdered[IS_ORDERED_SYMBOL]);
}
var IS_SEQ_SYMBOL = '@@__IMMUTABLE_SEQ__@@';
/**
 * True if `maybeSeq` is a Seq.
 */ function isSeq(maybeSeq) {
    return Boolean(maybeSeq && // @ts-expect-error: maybeSeq is typed as `{}`, need to change in 6.0 to `maybeSeq && typeof maybeSeq === 'object' && MAYBE_SEQ_SYMBOL in maybeSeq`
    maybeSeq[IS_SEQ_SYMBOL]);
}
var hasOwnProperty = Object.prototype.hasOwnProperty;
function isArrayLike(value) {
    if (Array.isArray(value) || typeof value === 'string') return true;
    // @ts-expect-error "Type 'unknown' is not assignable to type 'boolean'" : convert to Boolean
    return value && (typeof value === "undefined" ? "undefined" : (0, $6tOPT._)(value)) === 'object' && // @ts-expect-error check that `'length' in value &&`
    Number.isInteger(value.length) && // @ts-expect-error check that `'length' in value &&`
    value.length >= 0 && // @ts-expect-error check that `'length' in value &&`
    (value.length === 0 ? Object.keys(value).length === 1 : // in the array-like may be found (which could be undefined).
    // @ts-expect-error check that `'length' in value &&`
    value.hasOwnProperty(value.length - 1));
}
var Seq = /*@__PURE__*/ function(Collection) {
    function Seq(value) {
        // eslint-disable-next-line no-constructor-return
        return value === undefined || value === null ? emptySequence() : isImmutable(value) ? value.toSeq() : seqFromValue(value);
    }
    if (Collection) Seq.__proto__ = Collection;
    Seq.prototype = Object.create(Collection && Collection.prototype);
    Seq.prototype.constructor = Seq;
    Seq.prototype.toSeq = function toSeq() {
        return this;
    };
    Seq.prototype.toString = function toString() {
        return this.__toString('Seq {', '}');
    };
    Seq.prototype.cacheResult = function cacheResult() {
        if (!this._cache && this.__iterateUncached) {
            this._cache = this.entrySeq().toArray();
            this.size = this._cache.length;
        }
        return this;
    };
    // abstract __iterateUncached(fn, reverse)
    Seq.prototype.__iterate = function __iterate(fn, reverse) {
        var cache = this._cache;
        if (cache) {
            var size = cache.length;
            var i = 0;
            while(i !== size){
                var entry = cache[reverse ? size - ++i : i++];
                if (fn(entry[1], entry[0], this) === false) break;
            }
            return i;
        }
        return this.__iterateUncached(fn, reverse);
    };
    // abstract __iteratorUncached(type, reverse)
    Seq.prototype.__iterator = function __iterator(type, reverse) {
        var cache = this._cache;
        if (cache) {
            var size = cache.length;
            var i = 0;
            return new Iterator(function() {
                if (i === size) return iteratorDone();
                var entry = cache[reverse ? size - ++i : i++];
                return iteratorValue(type, entry[0], entry[1]);
            });
        }
        return this.__iteratorUncached(type, reverse);
    };
    return Seq;
}(Collection);
var KeyedSeq = /*@__PURE__*/ function(Seq) {
    function KeyedSeq(value) {
        // eslint-disable-next-line no-constructor-return
        return value === undefined || value === null ? emptySequence().toKeyedSeq() : isCollection(value) ? isKeyed(value) ? value.toSeq() : value.fromEntrySeq() : isRecord(value) ? value.toSeq() : keyedSeqFromValue(value);
    }
    if (Seq) KeyedSeq.__proto__ = Seq;
    KeyedSeq.prototype = Object.create(Seq && Seq.prototype);
    KeyedSeq.prototype.constructor = KeyedSeq;
    KeyedSeq.prototype.toKeyedSeq = function toKeyedSeq() {
        return this;
    };
    return KeyedSeq;
}(Seq);
var IndexedSeq = /*@__PURE__*/ function(Seq) {
    function IndexedSeq(value) {
        // eslint-disable-next-line no-constructor-return
        return value === undefined || value === null ? emptySequence() : isCollection(value) ? isKeyed(value) ? value.entrySeq() : value.toIndexedSeq() : isRecord(value) ? value.toSeq().entrySeq() : indexedSeqFromValue(value);
    }
    if (Seq) IndexedSeq.__proto__ = Seq;
    IndexedSeq.prototype = Object.create(Seq && Seq.prototype);
    IndexedSeq.prototype.constructor = IndexedSeq;
    IndexedSeq.of = function of() {
        return IndexedSeq(arguments);
    };
    IndexedSeq.prototype.toIndexedSeq = function toIndexedSeq() {
        return this;
    };
    IndexedSeq.prototype.toString = function toString() {
        return this.__toString('Seq [', ']');
    };
    return IndexedSeq;
}(Seq);
var SetSeq = /*@__PURE__*/ function(Seq) {
    function SetSeq(value) {
        // eslint-disable-next-line no-constructor-return
        return (isCollection(value) && !isAssociative(value) ? value : IndexedSeq(value)).toSetSeq();
    }
    if (Seq) SetSeq.__proto__ = Seq;
    SetSeq.prototype = Object.create(Seq && Seq.prototype);
    SetSeq.prototype.constructor = SetSeq;
    SetSeq.of = function of() {
        return SetSeq(arguments);
    };
    SetSeq.prototype.toSetSeq = function toSetSeq() {
        return this;
    };
    return SetSeq;
}(Seq);
Seq.isSeq = isSeq;
Seq.Keyed = KeyedSeq;
Seq.Set = SetSeq;
Seq.Indexed = IndexedSeq;
Seq.prototype[IS_SEQ_SYMBOL] = true;
// #pragma Root Sequences
var ArraySeq = /*@__PURE__*/ function(IndexedSeq) {
    function ArraySeq(array) {
        this._array = array;
        this.size = array.length;
    }
    if (IndexedSeq) ArraySeq.__proto__ = IndexedSeq;
    ArraySeq.prototype = Object.create(IndexedSeq && IndexedSeq.prototype);
    ArraySeq.prototype.constructor = ArraySeq;
    ArraySeq.prototype.get = function get(index, notSetValue) {
        return this.has(index) ? this._array[wrapIndex(this, index)] : notSetValue;
    };
    ArraySeq.prototype.__iterate = function __iterate(fn, reverse) {
        var array = this._array;
        var size = array.length;
        var i = 0;
        while(i !== size){
            var ii = reverse ? size - ++i : i++;
            if (fn(array[ii], ii, this) === false) break;
        }
        return i;
    };
    ArraySeq.prototype.__iterator = function __iterator(type, reverse) {
        var array = this._array;
        var size = array.length;
        var i = 0;
        return new Iterator(function() {
            if (i === size) return iteratorDone();
            var ii = reverse ? size - ++i : i++;
            return iteratorValue(type, ii, array[ii]);
        });
    };
    return ArraySeq;
}(IndexedSeq);
var ObjectSeq = /*@__PURE__*/ function(KeyedSeq) {
    function ObjectSeq(object) {
        var keys = Object.keys(object).concat(Object.getOwnPropertySymbols ? Object.getOwnPropertySymbols(object) : []);
        this._object = object;
        this._keys = keys;
        this.size = keys.length;
    }
    if (KeyedSeq) ObjectSeq.__proto__ = KeyedSeq;
    ObjectSeq.prototype = Object.create(KeyedSeq && KeyedSeq.prototype);
    ObjectSeq.prototype.constructor = ObjectSeq;
    ObjectSeq.prototype.get = function get(key, notSetValue) {
        if (notSetValue !== undefined && !this.has(key)) return notSetValue;
        return this._object[key];
    };
    ObjectSeq.prototype.has = function has(key) {
        return hasOwnProperty.call(this._object, key);
    };
    ObjectSeq.prototype.__iterate = function __iterate(fn, reverse) {
        var object = this._object;
        var keys = this._keys;
        var size = keys.length;
        var i = 0;
        while(i !== size){
            var key = keys[reverse ? size - ++i : i++];
            if (fn(object[key], key, this) === false) break;
        }
        return i;
    };
    ObjectSeq.prototype.__iterator = function __iterator(type, reverse) {
        var object = this._object;
        var keys = this._keys;
        var size = keys.length;
        var i = 0;
        return new Iterator(function() {
            if (i === size) return iteratorDone();
            var key = keys[reverse ? size - ++i : i++];
            return iteratorValue(type, key, object[key]);
        });
    };
    return ObjectSeq;
}(KeyedSeq);
ObjectSeq.prototype[IS_ORDERED_SYMBOL] = true;
var CollectionSeq = /*@__PURE__*/ function(IndexedSeq) {
    function CollectionSeq(collection) {
        this._collection = collection;
        this.size = collection.length || collection.size;
    }
    if (IndexedSeq) CollectionSeq.__proto__ = IndexedSeq;
    CollectionSeq.prototype = Object.create(IndexedSeq && IndexedSeq.prototype);
    CollectionSeq.prototype.constructor = CollectionSeq;
    CollectionSeq.prototype.__iterateUncached = function __iterateUncached(fn, reverse) {
        if (reverse) return this.cacheResult().__iterate(fn, reverse);
        var collection = this._collection;
        var iterator = getIterator(collection);
        var iterations = 0;
        if (isIterator(iterator)) {
            var step;
            while(!(step = iterator.next()).done){
                if (fn(step.value, iterations++, this) === false) break;
            }
        }
        return iterations;
    };
    CollectionSeq.prototype.__iteratorUncached = function __iteratorUncached(type, reverse) {
        if (reverse) return this.cacheResult().__iterator(type, reverse);
        var collection = this._collection;
        var iterator = getIterator(collection);
        if (!isIterator(iterator)) return new Iterator(iteratorDone);
        var iterations = 0;
        return new Iterator(function() {
            var step = iterator.next();
            return step.done ? step : iteratorValue(type, iterations++, step.value);
        });
    };
    return CollectionSeq;
}(IndexedSeq);
// # pragma Helper functions
var EMPTY_SEQ;
function emptySequence() {
    return EMPTY_SEQ || (EMPTY_SEQ = new ArraySeq([]));
}
function keyedSeqFromValue(value) {
    var seq = maybeIndexedSeqFromValue(value);
    if (seq) return seq.fromEntrySeq();
    if ((typeof value === "undefined" ? "undefined" : (0, $6tOPT._)(value)) === 'object') return new ObjectSeq(value);
    throw new TypeError('Expected Array or collection object of [k, v] entries, or keyed object: ' + value);
}
function indexedSeqFromValue(value) {
    var seq = maybeIndexedSeqFromValue(value);
    if (seq) return seq;
    throw new TypeError('Expected Array or collection object of values: ' + value);
}
function seqFromValue(value) {
    var seq = maybeIndexedSeqFromValue(value);
    if (seq) return isEntriesIterable(value) ? seq.fromEntrySeq() : isKeysIterable(value) ? seq.toSetSeq() : seq;
    if ((typeof value === "undefined" ? "undefined" : (0, $6tOPT._)(value)) === 'object') return new ObjectSeq(value);
    throw new TypeError('Expected Array or collection object of values, or keyed object: ' + value);
}
function maybeIndexedSeqFromValue(value) {
    return isArrayLike(value) ? new ArraySeq(value) : hasIterator(value) ? new CollectionSeq(value) : undefined;
}
function asImmutable() {
    return this.__ensureOwner();
}
function asMutable() {
    return this.__ownerID ? this : this.__ensureOwner(new OwnerID());
}
// TODO remove in v6 as Math.imul is widely available now: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Math/imul
var imul = typeof Math.imul === 'function' && Math.imul(0xffffffff, 2) === -2 ? Math.imul : function imul(a, b) {
    a |= 0; // int
    b |= 0; // int
    var c = a & 0xffff;
    var d = b & 0xffff;
    // Shift by 0 fixes the sign on the high part.
    return c * d + ((a >>> 16) * d + c * (b >>> 16) << 16 >>> 0) | 0; // int
};
// v8 has an optimization for storing 31-bit signed numbers.
// Values which have either 00 or 11 as the high order bits qualify.
// This function drops the highest order bit in a signed number, maintaining
// the sign bit.
function smi(i32) {
    return i32 >>> 1 & 0x40000000 | i32 & 0xbfffffff;
}
var defaultValueOf = Object.prototype.valueOf;
function hash(o) {
    // eslint-disable-next-line eqeqeq
    if (o == null) return hashNullish(o);
    // @ts-expect-error don't care about object beeing typed as `{}` here
    if (typeof o.hashCode === 'function') // Drop any high bits from accidentally long hash codes.
    // @ts-expect-error don't care about object beeing typed as `{}` here
    return smi(o.hashCode(o));
    var v = valueOf(o);
    // eslint-disable-next-line eqeqeq
    if (v == null) return hashNullish(v);
    switch(typeof v === "undefined" ? "undefined" : (0, $6tOPT._)(v)){
        case 'boolean':
            // The hash values for built-in constants are a 1 value for each 5-byte
            // shift region expect for the first, which encodes the value. This
            // reduces the odds of a hash collision for these common values.
            return v ? 0x42108421 : 0x42108420;
        case 'number':
            return hashNumber(v);
        case 'string':
            return v.length > STRING_HASH_CACHE_MIN_STRLEN ? cachedHashString(v) : hashString(v);
        case 'object':
        case 'function':
            return hashJSObj(v);
        case 'symbol':
            return hashSymbol(v);
        default:
            if (typeof v.toString === 'function') return hashString(v.toString());
            throw new Error('Value type ' + (typeof v === "undefined" ? "undefined" : (0, $6tOPT._)(v)) + ' cannot be hashed.');
    }
}
function hashNullish(nullish) {
    return nullish === null ? 0x42108422 : /* undefined */ 0x42108423;
}
// Compress arbitrarily large numbers into smi hashes.
function hashNumber(n) {
    if (n !== n || n === Infinity) return 0;
    var hash = n | 0;
    if (hash !== n) hash ^= n * 0xffffffff;
    while(n > 0xffffffff){
        n /= 0xffffffff;
        hash ^= n;
    }
    return smi(hash);
}
function cachedHashString(string) {
    var hashed = stringHashCache[string];
    if (hashed === undefined) {
        hashed = hashString(string);
        if (STRING_HASH_CACHE_SIZE === STRING_HASH_CACHE_MAX_SIZE) {
            STRING_HASH_CACHE_SIZE = 0;
            stringHashCache = {};
        }
        STRING_HASH_CACHE_SIZE++;
        stringHashCache[string] = hashed;
    }
    return hashed;
}
// http://jsperf.com/hashing-strings
function hashString(string) {
    // This is the hash from JVM
    // The hash code for a string is computed as
    // s[0] * 31 ^ (n - 1) + s[1] * 31 ^ (n - 2) + ... + s[n - 1],
    // where s[i] is the ith character of the string and n is the length of
    // the string. We "mod" the result to make it between 0 (inclusive) and 2^31
    // (exclusive) by dropping high bits.
    var hashed = 0;
    for(var ii = 0; ii < string.length; ii++)hashed = 31 * hashed + string.charCodeAt(ii) | 0;
    return smi(hashed);
}
// Per-process seed for the secondary collision hash. Never exposed nor
// serialized, so the public `hash()` stays deterministic. An odd base in
// [3, 2^20) keeps `base * h` exact as a double (no `Math.imul`).
var COLLISION_HASH_BASE = (Math.random() * 0x100000 | 1) % 0x100000 || 0x9e37;
// Secondary hash to index entries within a `HashCollisionNode`, where every key
// shares the same primary `hash()`. Using a different, seeded base scatters
// crafted collision families (e.g. "Aa"/"BB", which only collide under base 31)
// that an attacker cannot precompute without the seed. It only narrows
// candidates — `is()` still decides equality — so non-string keys can safely
// fall back to the (here constant) primary hash and a linear scan.
function hashCollisionKey(key) {
    if (typeof key !== 'string') return hash(key);
    var hashed = 0;
    for(var ii = 0; ii < key.length; ii++)hashed = COLLISION_HASH_BASE * hashed + key.charCodeAt(ii) | 0;
    return hashed;
}
function hashSymbol(sym) {
    var hashed = symbolMap[sym];
    if (hashed !== undefined) return hashed;
    hashed = nextHash();
    symbolMap[sym] = hashed;
    return hashed;
}
// eslint-disable-next-line @typescript-eslint/no-unsafe-function-type
function hashJSObj(obj) {
    var hashed;
    if (usingWeakMap) {
        // @ts-expect-error weakMap is defined
        hashed = weakMap.get(obj);
        if (hashed !== undefined) return hashed;
    }
    // @ts-expect-error used for old code, will be removed
    hashed = obj[UID_HASH_KEY];
    if (hashed !== undefined) return hashed;
    if (!canDefineProperty) {
        // @ts-expect-error used for old code, will be removed
        hashed = obj.propertyIsEnumerable && obj.propertyIsEnumerable[UID_HASH_KEY];
        if (hashed !== undefined) return hashed;
        hashed = getIENodeHash(obj);
        if (hashed !== undefined) return hashed;
    }
    hashed = nextHash();
    if (usingWeakMap) // @ts-expect-error weakMap is defined
    weakMap.set(obj, hashed);
    else if (isExtensible !== undefined && isExtensible(obj) === false) throw new Error('Non-extensible objects are not allowed as keys.');
    else if (canDefineProperty) Object.defineProperty(obj, UID_HASH_KEY, {
        enumerable: false,
        configurable: false,
        writable: false,
        value: hashed
    });
    else if (obj.propertyIsEnumerable !== undefined && obj.propertyIsEnumerable === obj.constructor.prototype.propertyIsEnumerable) {
        // Since we can't define a non-enumerable property on the object
        // we'll hijack one of the less-used non-enumerable properties to
        // save our hash on it. Since this is a function it will not show up in
        // `JSON.stringify` which is what we want.
        obj.propertyIsEnumerable = function() {
            return this.constructor.prototype.propertyIsEnumerable.apply(this, // eslint-disable-next-line prefer-rest-params
            arguments);
        };
        // @ts-expect-error used for old code, will be removed
        obj.propertyIsEnumerable[UID_HASH_KEY] = hashed;
    // @ts-expect-error used for old code, will be removed
    } else if (obj.nodeType !== undefined) // At this point we couldn't get the IE `uniqueID` to use as a hash
    // and we couldn't use a non-enumerable property to exploit the
    // dontEnum bug so we simply add the `UID_HASH_KEY` on the node
    // itself.
    // @ts-expect-error used for old code, will be removed
    obj[UID_HASH_KEY] = hashed;
    else throw new Error('Unable to set a non-enumerable property on object.');
    return hashed;
}
// Get references to ES5 object methods.
var isExtensible = Object.isExtensible;
// True if Object.defineProperty works as expected. IE8 fails this test.
// TODO remove this as widely available https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/defineProperty
var canDefineProperty = function() {
    try {
        Object.defineProperty({}, '@', {});
        return true;
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    } catch (e) {
        return false;
    }
}();
// IE has a `uniqueID` property on DOM nodes. We can construct the hash from it
// and avoid memory leaks from the IE cloneNode bug.
// TODO remove this method as only used if `canDefineProperty` is false
function getIENodeHash(node) {
    // @ts-expect-error don't care
    if (node && node.nodeType > 0) // @ts-expect-error don't care
    switch(node.nodeType){
        case 1:
            // @ts-expect-error don't care
            return node.uniqueID;
        case 9:
            // @ts-expect-error don't care
            return node.documentElement && node.documentElement.uniqueID;
    }
}
function valueOf(obj) {
    return obj.valueOf !== defaultValueOf && typeof obj.valueOf === 'function' ? obj.valueOf(obj) : obj;
}
function nextHash() {
    var nextHash = ++_objHashUID;
    if (_objHashUID & 0x40000000) _objHashUID = 0;
    return nextHash;
}
// If possible, use a WeakMap.
// TODO using WeakMap should be true everywhere now that WeakMap is widely supported: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/WeakMap
var usingWeakMap = typeof WeakMap === 'function';
var weakMap;
if (usingWeakMap) weakMap = new WeakMap();
var symbolMap = Object.create(null);
var _objHashUID = 0;
// TODO remove string as Symbol is now widely supported: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Symbol
var UID_HASH_KEY = '__immutablehash__';
if (typeof Symbol === 'function') UID_HASH_KEY = Symbol(UID_HASH_KEY);
var STRING_HASH_CACHE_MIN_STRLEN = 16;
var STRING_HASH_CACHE_MAX_SIZE = 255;
var STRING_HASH_CACHE_SIZE = 0;
var stringHashCache = {};
var ToKeyedSequence = /*@__PURE__*/ function(KeyedSeq) {
    function ToKeyedSequence(indexed, useKeys) {
        this._iter = indexed;
        this._useKeys = useKeys;
        this.size = indexed.size;
    }
    if (KeyedSeq) ToKeyedSequence.__proto__ = KeyedSeq;
    ToKeyedSequence.prototype = Object.create(KeyedSeq && KeyedSeq.prototype);
    ToKeyedSequence.prototype.constructor = ToKeyedSequence;
    ToKeyedSequence.prototype.get = function get(key, notSetValue) {
        return this._iter.get(key, notSetValue);
    };
    ToKeyedSequence.prototype.has = function has(key) {
        return this._iter.has(key);
    };
    ToKeyedSequence.prototype.valueSeq = function valueSeq() {
        return this._iter.valueSeq();
    };
    ToKeyedSequence.prototype.reverse = function reverse() {
        var this$1$1 = this;
        var reversedSequence = reverseFactory(this, true);
        if (!this._useKeys) reversedSequence.valueSeq = function() {
            return this$1$1._iter.toSeq().reverse();
        };
        return reversedSequence;
    };
    ToKeyedSequence.prototype.map = function map(mapper, context) {
        var this$1$1 = this;
        var mappedSequence = mapFactory(this, mapper, context);
        if (!this._useKeys) mappedSequence.valueSeq = function() {
            return this$1$1._iter.toSeq().map(mapper, context);
        };
        return mappedSequence;
    };
    ToKeyedSequence.prototype.__iterate = function __iterate(fn, reverse) {
        var this$1$1 = this;
        return this._iter.__iterate(function(v, k) {
            return fn(v, k, this$1$1);
        }, reverse);
    };
    ToKeyedSequence.prototype.__iterator = function __iterator(type, reverse) {
        return this._iter.__iterator(type, reverse);
    };
    return ToKeyedSequence;
}(KeyedSeq);
ToKeyedSequence.prototype[IS_ORDERED_SYMBOL] = true;
var ToIndexedSequence = /*@__PURE__*/ function(IndexedSeq) {
    function ToIndexedSequence(iter) {
        this._iter = iter;
        this.size = iter.size;
    }
    if (IndexedSeq) ToIndexedSequence.__proto__ = IndexedSeq;
    ToIndexedSequence.prototype = Object.create(IndexedSeq && IndexedSeq.prototype);
    ToIndexedSequence.prototype.constructor = ToIndexedSequence;
    ToIndexedSequence.prototype.includes = function includes(value) {
        return this._iter.includes(value);
    };
    ToIndexedSequence.prototype.__iterate = function __iterate(fn, reverse) {
        var this$1$1 = this;
        var i = 0;
        // eslint-disable-next-line @typescript-eslint/no-unused-expressions -- TODO enable eslint here
        reverse && ensureSize(this);
        return this._iter.__iterate(function(v) {
            return fn(v, reverse ? this$1$1.size - ++i : i++, this$1$1);
        }, reverse);
    };
    ToIndexedSequence.prototype.__iterator = function __iterator(type, reverse) {
        var this$1$1 = this;
        var iterator = this._iter.__iterator(ITERATE_VALUES, reverse);
        var i = 0;
        // eslint-disable-next-line @typescript-eslint/no-unused-expressions -- TODO enable eslint here
        reverse && ensureSize(this);
        return new Iterator(function() {
            var step = iterator.next();
            return step.done ? step : iteratorValue(type, reverse ? this$1$1.size - ++i : i++, step.value, step);
        });
    };
    return ToIndexedSequence;
}(IndexedSeq);
var ToSetSequence = /*@__PURE__*/ function(SetSeq) {
    function ToSetSequence(iter) {
        this._iter = iter;
        this.size = iter.size;
    }
    if (SetSeq) ToSetSequence.__proto__ = SetSeq;
    ToSetSequence.prototype = Object.create(SetSeq && SetSeq.prototype);
    ToSetSequence.prototype.constructor = ToSetSequence;
    ToSetSequence.prototype.has = function has(key) {
        return this._iter.includes(key);
    };
    ToSetSequence.prototype.__iterate = function __iterate(fn, reverse) {
        var this$1$1 = this;
        return this._iter.__iterate(function(v) {
            return fn(v, v, this$1$1);
        }, reverse);
    };
    ToSetSequence.prototype.__iterator = function __iterator(type, reverse) {
        var iterator = this._iter.__iterator(ITERATE_VALUES, reverse);
        return new Iterator(function() {
            var step = iterator.next();
            return step.done ? step : iteratorValue(type, step.value, step.value, step);
        });
    };
    return ToSetSequence;
}(SetSeq);
var FromEntriesSequence = /*@__PURE__*/ function(KeyedSeq) {
    function FromEntriesSequence(entries) {
        this._iter = entries;
        this.size = entries.size;
    }
    if (KeyedSeq) FromEntriesSequence.__proto__ = KeyedSeq;
    FromEntriesSequence.prototype = Object.create(KeyedSeq && KeyedSeq.prototype);
    FromEntriesSequence.prototype.constructor = FromEntriesSequence;
    FromEntriesSequence.prototype.entrySeq = function entrySeq() {
        return this._iter.toSeq();
    };
    FromEntriesSequence.prototype.__iterate = function __iterate(fn, reverse) {
        var this$1$1 = this;
        return this._iter.__iterate(function(entry) {
            // Check if entry exists first so array access doesn't throw for holes
            // in the parent iteration.
            if (entry) {
                validateEntry(entry);
                var indexedCollection = isCollection(entry);
                return fn(indexedCollection ? entry.get(1) : entry[1], indexedCollection ? entry.get(0) : entry[0], this$1$1);
            }
        }, reverse);
    };
    FromEntriesSequence.prototype.__iterator = function __iterator(type, reverse) {
        var iterator = this._iter.__iterator(ITERATE_VALUES, reverse);
        return new Iterator(function() {
            while(true){
                var step = iterator.next();
                if (step.done) return step;
                var entry = step.value;
                // Check if entry exists first so array access doesn't throw for holes
                // in the parent iteration.
                if (entry) {
                    validateEntry(entry);
                    var indexedCollection = isCollection(entry);
                    return iteratorValue(type, indexedCollection ? entry.get(0) : entry[0], indexedCollection ? entry.get(1) : entry[1], step);
                }
            }
        });
    };
    return FromEntriesSequence;
}(KeyedSeq);
ToIndexedSequence.prototype.cacheResult = ToKeyedSequence.prototype.cacheResult = ToSetSequence.prototype.cacheResult = FromEntriesSequence.prototype.cacheResult = cacheResultThrough;
function flipFactory(collection) {
    var flipSequence = makeSequence(collection);
    flipSequence._iter = collection;
    flipSequence.size = collection.size;
    flipSequence.flip = function() {
        return collection;
    };
    flipSequence.reverse = function() {
        var reversedSequence = collection.reverse.apply(this); // super.reverse()
        reversedSequence.flip = function() {
            return collection.reverse();
        };
        return reversedSequence;
    };
    flipSequence.has = function(key) {
        return collection.includes(key);
    };
    flipSequence.includes = function(key) {
        return collection.has(key);
    };
    flipSequence.cacheResult = cacheResultThrough;
    flipSequence.__iterateUncached = function(fn, reverse) {
        var this$1$1 = this;
        return collection.__iterate(function(v, k) {
            return fn(k, v, this$1$1) !== false;
        }, reverse);
    };
    flipSequence.__iteratorUncached = function(type, reverse) {
        if (type === ITERATE_ENTRIES) {
            var iterator = collection.__iterator(type, reverse);
            return new Iterator(function() {
                var step = iterator.next();
                if (!step.done) {
                    var k = step.value[0];
                    step.value[0] = step.value[1];
                    step.value[1] = k;
                }
                return step;
            });
        }
        return collection.__iterator(type === ITERATE_VALUES ? ITERATE_KEYS : ITERATE_VALUES, reverse);
    };
    return flipSequence;
}
function mapFactory(collection, mapper, context) {
    var mappedSequence = makeSequence(collection);
    mappedSequence.size = collection.size;
    mappedSequence.has = function(key) {
        return collection.has(key);
    };
    mappedSequence.get = function(key, notSetValue) {
        var v = collection.get(key, NOT_SET);
        return v === NOT_SET ? notSetValue : mapper.call(context, v, key, collection);
    };
    mappedSequence.__iterateUncached = function(fn, reverse) {
        var this$1$1 = this;
        return collection.__iterate(function(v, k, c) {
            return fn(mapper.call(context, v, k, c), k, this$1$1) !== false;
        }, reverse);
    };
    mappedSequence.__iteratorUncached = function(type, reverse) {
        var iterator = collection.__iterator(ITERATE_ENTRIES, reverse);
        return new Iterator(function() {
            var step = iterator.next();
            if (step.done) return step;
            var entry = step.value;
            var key = entry[0];
            return iteratorValue(type, key, mapper.call(context, entry[1], key, collection), step);
        });
    };
    return mappedSequence;
}
function reverseFactory(collection, useKeys) {
    var reversedSequence = makeSequence(collection);
    reversedSequence._iter = collection;
    reversedSequence.size = collection.size;
    reversedSequence.reverse = function() {
        return collection;
    };
    if (collection.flip) reversedSequence.flip = function() {
        var flipSequence = flipFactory(collection);
        flipSequence.reverse = function() {
            return collection.flip();
        };
        return flipSequence;
    };
    reversedSequence.get = function(key, notSetValue) {
        return collection.get(useKeys ? key : -1 - key, notSetValue);
    };
    reversedSequence.has = function(key) {
        return collection.has(useKeys ? key : -1 - key);
    };
    reversedSequence.includes = function(value) {
        return collection.includes(value);
    };
    reversedSequence.cacheResult = cacheResultThrough;
    reversedSequence.__iterate = function(fn, reverse) {
        var this$1$1 = this;
        var i = 0;
        // eslint-disable-next-line @typescript-eslint/no-unused-expressions -- TODO enable eslint here
        reverse && ensureSize(collection);
        return collection.__iterate(function(v, k) {
            return fn(v, useKeys ? k : reverse ? this$1$1.size - ++i : i++, this$1$1);
        }, !reverse);
    };
    reversedSequence.__iterator = function(type, reverse) {
        var i = 0;
        // eslint-disable-next-line @typescript-eslint/no-unused-expressions -- TODO enable eslint here
        reverse && ensureSize(collection);
        var iterator = collection.__iterator(ITERATE_ENTRIES, !reverse);
        return new Iterator(function() {
            var step = iterator.next();
            if (step.done) return step;
            var entry = step.value;
            return iteratorValue(type, // `__iterator` is an arrow function, so `this` is not the reversed
            // sequence here — read `reversedSequence.size` explicitly.
            useKeys ? entry[0] : reverse ? reversedSequence.size - ++i : i++, entry[1], step);
        });
    };
    return reversedSequence;
}
function filterFactory(collection, predicate, context, useKeys) {
    var filterSequence = makeSequence(collection);
    if (useKeys) {
        filterSequence.has = function(key) {
            var v = collection.get(key, NOT_SET);
            return v !== NOT_SET && !!predicate.call(context, v, key, collection);
        };
        filterSequence.get = function(key, notSetValue) {
            var v = collection.get(key, NOT_SET);
            return v !== NOT_SET && predicate.call(context, v, key, collection) ? v : notSetValue;
        };
    }
    filterSequence.__iterateUncached = function(fn, reverse) {
        var this$1$1 = this;
        var iterations = 0;
        collection.__iterate(function(v, k, c) {
            if (predicate.call(context, v, k, c)) {
                iterations++;
                return fn(v, useKeys ? k : iterations - 1, this$1$1);
            }
        }, reverse);
        return iterations;
    };
    filterSequence.__iteratorUncached = function(type, reverse) {
        var iterator = collection.__iterator(ITERATE_ENTRIES, reverse);
        var iterations = 0;
        return new Iterator(function() {
            while(true){
                var step = iterator.next();
                if (step.done) return step;
                var entry = step.value;
                var key = entry[0];
                var value = entry[1];
                if (predicate.call(context, value, key, collection)) return iteratorValue(type, useKeys ? key : iterations++, value, step);
            }
        });
    };
    return filterSequence;
}
function countByFactory(collection, grouper, context) {
    var groups = Map().asMutable();
    collection.__iterate(function(v, k) {
        groups.update(grouper.call(context, v, k, collection), 0, function(a) {
            return a + 1;
        });
    });
    return groups.asImmutable();
}
function groupByFactory(collection, grouper, context) {
    var isKeyedIter = isKeyed(collection);
    var groups = (isOrdered(collection) ? OrderedMap() : Map()).asMutable();
    collection.__iterate(function(v, k) {
        groups.update(grouper.call(context, v, k, collection), function(a) {
            return a = a || [], a.push(isKeyedIter ? [
                k,
                v
            ] : v), a;
        });
    });
    var coerce = collectionClass(collection);
    return groups.map(function(arr) {
        return reify(collection, coerce(arr));
    }).asImmutable();
}
function partitionFactory(collection, predicate, context) {
    var isKeyedIter = isKeyed(collection);
    var groups = [
        [],
        []
    ];
    collection.__iterate(function(v, k) {
        groups[predicate.call(context, v, k, collection) ? 1 : 0].push(isKeyedIter ? [
            k,
            v
        ] : v);
    });
    var coerce = collectionClass(collection);
    return groups.map(function(arr) {
        return reify(collection, coerce(arr));
    });
}
function sliceFactory(collection, begin, end, useKeys) {
    var originalSize = collection.size;
    if (wholeSlice(begin, end, originalSize)) return collection;
    // begin or end can not be resolved if they were provided as negative numbers and
    // this collection's size is unknown. In that case, cache first so there is
    // a known size and these do not resolve to NaN.
    if (typeof originalSize === 'undefined' && (begin < 0 || end < 0)) return sliceFactory(collection.toSeq().cacheResult(), begin, end, useKeys);
    var resolvedBegin = resolveBegin(begin, originalSize);
    var resolvedEnd = resolveEnd(end, originalSize);
    // Note: resolvedEnd is undefined when the original sequence's length is
    // unknown and this slice did not supply an end and should contain all
    // elements after resolvedBegin.
    // In that case, resolvedSize will be NaN and sliceSize will remain undefined.
    var resolvedSize = resolvedEnd - resolvedBegin;
    var sliceSize;
    if (resolvedSize === resolvedSize) sliceSize = resolvedSize < 0 ? 0 : resolvedSize;
    var sliceSeq = makeSequence(collection);
    // If collection.size is undefined, the size of the realized sliceSeq is
    // unknown at this point unless the number of items to slice is 0
    sliceSeq.size = sliceSize === 0 ? sliceSize : collection.size && sliceSize || undefined;
    if (!useKeys && isSeq(collection) && sliceSize >= 0) sliceSeq.get = function(index, notSetValue) {
        index = wrapIndex(this, index);
        return index >= 0 && index < sliceSize ? collection.get(index + resolvedBegin, notSetValue) : notSetValue;
    };
    sliceSeq.__iterateUncached = function(fn, reverse) {
        var this$1$1 = this;
        if (sliceSize === 0) return 0;
        if (reverse) return this.cacheResult().__iterate(fn, reverse);
        var skipped = 0;
        var isSkipping = true;
        var iterations = 0;
        collection.__iterate(function(v, k) {
            if (!(isSkipping && (isSkipping = skipped++ < resolvedBegin))) {
                iterations++;
                return fn(v, useKeys ? k : iterations - 1, this$1$1) !== false && iterations !== sliceSize;
            }
        });
        return iterations;
    };
    sliceSeq.__iteratorUncached = function(type, reverse) {
        if (sliceSize !== 0 && reverse) return this.cacheResult().__iterator(type, reverse);
        // Don't bother instantiating parent iterator if taking 0.
        if (sliceSize === 0) return new Iterator(iteratorDone);
        var iterator = collection.__iterator(type, reverse);
        var skipped = 0;
        var iterations = 0;
        return new Iterator(function() {
            while(skipped++ < resolvedBegin)iterator.next();
            if (++iterations > sliceSize) return iteratorDone();
            var step = iterator.next();
            if (useKeys || type === ITERATE_VALUES || step.done) return step;
            if (type === ITERATE_KEYS) return iteratorValue(type, iterations - 1, undefined, step);
            return iteratorValue(type, iterations - 1, step.value[1], step);
        });
    };
    return sliceSeq;
}
function takeWhileFactory(collection, predicate, context) {
    var takeSequence = makeSequence(collection);
    takeSequence.__iterateUncached = function(fn, reverse) {
        var this$1$1 = this;
        if (reverse) return this.cacheResult().__iterate(fn, reverse);
        var iterations = 0;
        collection.__iterate(function(v, k, c) {
            return predicate.call(context, v, k, c) && ++iterations && fn(v, k, this$1$1);
        });
        return iterations;
    };
    takeSequence.__iteratorUncached = function(type, reverse) {
        var this$1$1 = this;
        if (reverse) return this.cacheResult().__iterator(type, reverse);
        var iterator = collection.__iterator(ITERATE_ENTRIES, reverse);
        var iterating = true;
        return new Iterator(function() {
            if (!iterating) return iteratorDone();
            var step = iterator.next();
            if (step.done) return step;
            var entry = step.value;
            var k = entry[0];
            var v = entry[1];
            if (!predicate.call(context, v, k, this$1$1)) {
                iterating = false;
                return iteratorDone();
            }
            return type === ITERATE_ENTRIES ? step : iteratorValue(type, k, v, step);
        });
    };
    return takeSequence;
}
function skipWhileFactory(collection, predicate, context, useKeys) {
    var skipSequence = makeSequence(collection);
    skipSequence.__iterateUncached = function(fn, reverse) {
        var this$1$1 = this;
        if (reverse) return this.cacheResult().__iterate(fn, reverse);
        var isSkipping = true;
        var iterations = 0;
        collection.__iterate(function(v, k, c) {
            if (!(isSkipping && (isSkipping = predicate.call(context, v, k, c)))) {
                iterations++;
                return fn(v, useKeys ? k : iterations - 1, this$1$1);
            }
        });
        return iterations;
    };
    skipSequence.__iteratorUncached = function(type, reverse) {
        var this$1$1 = this;
        if (reverse) return this.cacheResult().__iterator(type, reverse);
        var iterator = collection.__iterator(ITERATE_ENTRIES, reverse);
        var skipping = true;
        var iterations = 0;
        return new Iterator(function() {
            var step;
            var k;
            var v;
            do {
                step = iterator.next();
                if (step.done) {
                    if (useKeys || type === ITERATE_VALUES) return step;
                    if (type === ITERATE_KEYS) return iteratorValue(type, iterations++, undefined, step);
                    return iteratorValue(type, iterations++, step.value[1], step);
                }
                var entry = step.value;
                k = entry[0];
                v = entry[1];
                // eslint-disable-next-line @typescript-eslint/no-unused-expressions -- TODO enable eslint here
                skipping && (skipping = predicate.call(context, v, k, this$1$1));
            }while (skipping);
            return type === ITERATE_ENTRIES ? step : iteratorValue(type, k, v, step);
        });
    };
    return skipSequence;
}
var ConcatSeq = /*@__PURE__*/ function(Seq) {
    function ConcatSeq(iterables) {
        this._wrappedIterables = iterables.flatMap(function(iterable) {
            if (iterable._wrappedIterables) return iterable._wrappedIterables;
            return [
                iterable
            ];
        });
        this.size = this._wrappedIterables.reduce(function(sum, iterable) {
            if (sum !== undefined) {
                var size = iterable.size;
                if (size !== undefined) return sum + size;
            }
        }, 0);
        this[IS_KEYED_SYMBOL] = this._wrappedIterables[0][IS_KEYED_SYMBOL];
        this[IS_INDEXED_SYMBOL] = this._wrappedIterables[0][IS_INDEXED_SYMBOL];
        this[IS_ORDERED_SYMBOL] = this._wrappedIterables[0][IS_ORDERED_SYMBOL];
    }
    if (Seq) ConcatSeq.__proto__ = Seq;
    ConcatSeq.prototype = Object.create(Seq && Seq.prototype);
    ConcatSeq.prototype.constructor = ConcatSeq;
    ConcatSeq.prototype.__iterateUncached = function __iterateUncached(fn, reverse) {
        if (this._wrappedIterables.length === 0) return;
        if (reverse) return this.cacheResult().__iterate(fn, reverse);
        var iterableIndex = 0;
        var useKeys = isKeyed(this);
        var iteratorType = useKeys ? ITERATE_ENTRIES : ITERATE_VALUES;
        var currentIterator = this._wrappedIterables[iterableIndex].__iterator(iteratorType, reverse);
        var keepGoing = true;
        var index = 0;
        while(keepGoing){
            var next = currentIterator.next();
            while(next.done){
                iterableIndex++;
                if (iterableIndex === this._wrappedIterables.length) return index;
                currentIterator = this._wrappedIterables[iterableIndex].__iterator(iteratorType, reverse);
                next = currentIterator.next();
            }
            var fnResult = useKeys ? fn(next.value[1], next.value[0], this) : fn(next.value, index, this);
            keepGoing = fnResult !== false;
            index++;
        }
        return index;
    };
    ConcatSeq.prototype.__iteratorUncached = function __iteratorUncached(type, reverse) {
        var this$1$1 = this;
        if (this._wrappedIterables.length === 0) return new Iterator(iteratorDone);
        if (reverse) return this.cacheResult().__iterator(type, reverse);
        var iterableIndex = 0;
        var currentIterator = this._wrappedIterables[iterableIndex].__iterator(type, reverse);
        return new Iterator(function() {
            var next = currentIterator.next();
            while(next.done){
                iterableIndex++;
                if (iterableIndex === this$1$1._wrappedIterables.length) return next;
                currentIterator = this$1$1._wrappedIterables[iterableIndex].__iterator(type, reverse);
                next = currentIterator.next();
            }
            return next;
        });
    };
    return ConcatSeq;
}(Seq);
function concatFactory(collection, values) {
    var isKeyedCollection = isKeyed(collection);
    var iters = [
        collection
    ].concat(values).map(function(v) {
        if (!isCollection(v)) v = isKeyedCollection ? keyedSeqFromValue(v) : indexedSeqFromValue(Array.isArray(v) ? v : [
            v
        ]);
        else if (isKeyedCollection) v = KeyedCollection(v);
        return v;
    }).filter(function(v) {
        return v.size !== 0;
    });
    if (iters.length === 0) return collection;
    if (iters.length === 1) {
        var singleton = iters[0];
        if (singleton === collection || isKeyedCollection && isKeyed(singleton) || isIndexed(collection) && isIndexed(singleton)) return singleton;
    }
    return new ConcatSeq(iters);
}
function flattenFactory(collection, depth, useKeys) {
    var flatSequence = makeSequence(collection);
    flatSequence.__iterateUncached = function(fn, reverse) {
        if (reverse) return this.cacheResult().__iterate(fn, reverse);
        var iterations = 0;
        var stopped = false;
        function flatDeep(iter, currentDepth) {
            iter.__iterate(function(v, k) {
                if ((!depth || currentDepth < depth) && isCollection(v)) flatDeep(v, currentDepth + 1);
                else {
                    iterations++;
                    if (fn(v, useKeys ? k : iterations - 1, flatSequence) === false) stopped = true;
                }
                return !stopped;
            }, reverse);
        }
        flatDeep(collection, 0);
        return iterations;
    };
    flatSequence.__iteratorUncached = function(type, reverse) {
        if (reverse) return this.cacheResult().__iterator(type, reverse);
        var iterator = collection.__iterator(type, reverse);
        var stack = [];
        var iterations = 0;
        return new Iterator(function() {
            while(iterator){
                var step = iterator.next();
                if (step.done !== false) {
                    iterator = stack.pop();
                    continue;
                }
                var v = step.value;
                if (type === ITERATE_ENTRIES) v = v[1];
                if ((!depth || stack.length < depth) && isCollection(v)) {
                    stack.push(iterator);
                    iterator = v.__iterator(type, reverse);
                } else return useKeys ? step : iteratorValue(type, iterations++, v, step);
            }
            return iteratorDone();
        });
    };
    return flatSequence;
}
function flatMapFactory(collection, mapper, context) {
    var coerce = collectionClass(collection);
    return collection.toSeq().map(function(v, k) {
        return coerce(mapper.call(context, v, k, collection));
    }).flatten(true);
}
function interposeFactory(collection, separator) {
    var interposedSequence = makeSequence(collection);
    interposedSequence.size = collection.size && collection.size * 2 - 1;
    interposedSequence.__iterateUncached = function(fn, reverse) {
        var this$1$1 = this;
        var iterations = 0;
        collection.__iterate(function(v) {
            return (!iterations || fn(separator, iterations++, this$1$1) !== false) && fn(v, iterations++, this$1$1) !== false;
        }, reverse);
        return iterations;
    };
    interposedSequence.__iteratorUncached = function(type, reverse) {
        var iterator = collection.__iterator(ITERATE_VALUES, reverse);
        var iterations = 0;
        var step;
        return new Iterator(function() {
            if (!step || iterations % 2) {
                step = iterator.next();
                if (step.done) return step;
            }
            return iterations % 2 ? iteratorValue(type, iterations++, separator) : iteratorValue(type, iterations++, step.value, step);
        });
    };
    return interposedSequence;
}
function sortFactory(collection, comparator, mapper) {
    if (!comparator) comparator = defaultComparator;
    var isKeyedCollection = isKeyed(collection);
    var index = 0;
    var entries = collection.toSeq().map(function(v, k) {
        return [
            k,
            v,
            index++,
            mapper ? mapper(v, k, collection) : v
        ];
    }).valueSeq().toArray();
    entries.sort(function(a, b) {
        return comparator(a[3], b[3]) || a[2] - b[2];
    }).forEach(isKeyedCollection ? function(v, i) {
        entries[i].length = 2;
    } : function(v, i) {
        entries[i] = v[1];
    });
    return isKeyedCollection ? KeyedSeq(entries) : isIndexed(collection) ? IndexedSeq(entries) : SetSeq(entries);
}
function maxFactory(collection, comparator, mapper) {
    if (!comparator) comparator = defaultComparator;
    if (mapper) {
        var entry = collection.toSeq().map(function(v, k) {
            return [
                v,
                mapper(v, k, collection)
            ];
        }).reduce(function(a, b) {
            return maxCompare(comparator, a[1], b[1]) ? b : a;
        });
        return entry && entry[0];
    }
    return collection.reduce(function(a, b) {
        return maxCompare(comparator, a, b) ? b : a;
    });
}
function maxCompare(comparator, a, b) {
    var comp = comparator(b, a);
    // b is considered the new max if the comparator declares them equal, but
    // they are not equal and b is in fact a nullish value.
    return comp === 0 && b !== a && (b === undefined || b === null || b !== b) || comp > 0;
}
function zipWithFactory(keyIter, zipper, iters, zipAll) {
    var zipSequence = makeSequence(keyIter);
    var sizes = new ArraySeq(iters).map(function(i) {
        return i.size;
    });
    zipSequence.size = zipAll ? sizes.max() : sizes.min();
    // Note: this a generic base implementation of __iterate in terms of
    // __iterator which may be more generically useful in the future.
    zipSequence.__iterate = function(fn, reverse) {
        /* generic:
    var iterator = this.__iterator(ITERATE_ENTRIES, reverse);
    var step;
    var iterations = 0;
    while (!(step = iterator.next()).done) {
      iterations++;
      if (fn(step.value[1], step.value[0], this) === false) {
        break;
      }
    }
    return iterations;
    */ // indexed:
        var iterator = this.__iterator(ITERATE_VALUES, reverse);
        var step;
        var iterations = 0;
        while(!(step = iterator.next()).done){
            if (fn(step.value, iterations++, this) === false) break;
        }
        return iterations;
    };
    zipSequence.__iteratorUncached = function(type, reverse) {
        var iterators = iters.map(function(i) {
            return i = Collection(i), getIterator(reverse ? i.reverse() : i);
        });
        var iterations = 0;
        var isDone = false;
        return new Iterator(function() {
            var steps;
            if (!isDone) {
                steps = iterators.map(function(i) {
                    return i.next();
                });
                isDone = zipAll ? steps.every(function(s) {
                    return s.done;
                }) : steps.some(function(s) {
                    return s.done;
                });
            }
            if (isDone) return iteratorDone();
            return iteratorValue(type, iterations++, zipper.apply(null, steps.map(function(s) {
                return s.value;
            })));
        });
    };
    return zipSequence;
}
// #pragma Helper Functions
function reify(iter, seq) {
    return iter === seq ? iter : isSeq(iter) ? seq : iter.constructor(seq);
}
function validateEntry(entry) {
    if (entry !== Object(entry)) throw new TypeError('Expected [K, V] tuple: ' + entry);
}
function collectionClass(collection) {
    return isKeyed(collection) ? KeyedCollection : isIndexed(collection) ? IndexedCollection : SetCollection;
}
function makeSequence(collection) {
    return Object.create((isKeyed(collection) ? KeyedSeq : isIndexed(collection) ? IndexedSeq : SetSeq).prototype);
}
function cacheResultThrough() {
    if (this._iter.cacheResult) {
        this._iter.cacheResult();
        this.size = this._iter.size;
        return this;
    }
    return Seq.prototype.cacheResult.call(this);
}
function defaultComparator(a, b) {
    if (a === undefined && b === undefined) return 0;
    if (a === undefined) return 1;
    if (b === undefined) return -1;
    return a > b ? 1 : a < b ? -1 : 0;
}
/**
 * True if `maybeValue` is a JavaScript Object which has *both* `equals()`
 * and `hashCode()` methods.
 *
 * Any two instances of *value objects* can be compared for value equality with
 * `Immutable.is()` and can be used as keys in a `Map` or members in a `Set`.
 */ function isValueObject(maybeValue) {
    return Boolean(maybeValue && // @ts-expect-error: maybeValue is typed as `{}`
    typeof maybeValue.equals === 'function' && // @ts-expect-error: maybeValue is typed as `{}`
    typeof maybeValue.hashCode === 'function');
}
/**
 * An extension of the "same-value" algorithm as [described for use by ES6 Map
 * and Set](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Map#Key_equality)
 *
 * NaN is considered the same as NaN, however -0 and 0 are considered the same
 * value, which is different from the algorithm described by
 * [`Object.is`](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is).
 *
 * This is extended further to allow Objects to describe the values they
 * represent, by way of `valueOf` or `equals` (and `hashCode`).
 *
 * Note: because of this extension, the key equality of Immutable.Map and the
 * value equality of Immutable.Set will differ from ES6 Map and Set.
 *
 * ### Defining custom values
 *
 * The easiest way to describe the value an object represents is by implementing
 * `valueOf`. For example, `Date` represents a value by returning a unix
 * timestamp for `valueOf`:
 *
 *     var date1 = new Date(1234567890000); // Fri Feb 13 2009 ...
 *     var date2 = new Date(1234567890000);
 *     date1.valueOf(); // 1234567890000
 *     assert( date1 !== date2 );
 *     assert( Immutable.is( date1, date2 ) );
 *
 * Note: overriding `valueOf` may have other implications if you use this object
 * where JavaScript expects a primitive, such as implicit string coercion.
 *
 * For more complex types, especially collections, implementing `valueOf` may
 * not be performant. An alternative is to implement `equals` and `hashCode`.
 *
 * `equals` takes another object, presumably of similar type, and returns true
 * if it is equal. Equality is symmetrical, so the same result should be
 * returned if this and the argument are flipped.
 *
 *     assert( a.equals(b) === b.equals(a) );
 *
 * `hashCode` returns a 32bit integer number representing the object which will
 * be used to determine how to store the value object in a Map or Set. You must
 * provide both or neither methods, one must not exist without the other.
 *
 * Also, an important relationship between these methods must be upheld: if two
 * values are equal, they *must* return the same hashCode. If the values are not
 * equal, they might have the same hashCode; this is called a hash collision,
 * and while undesirable for performance reasons, it is acceptable.
 *
 *     if (a.equals(b)) {
 *       assert( a.hashCode() === b.hashCode() );
 *     }
 *
 * All Immutable collections are Value Objects: they implement `equals()`
 * and `hashCode()`.
 */ function is(valueA, valueB) {
    if (valueA === valueB || valueA !== valueA && valueB !== valueB) return true;
    if (!valueA || !valueB) return false;
    if (typeof valueA.valueOf === 'function' && typeof valueB.valueOf === 'function') {
        valueA = valueA.valueOf();
        valueB = valueB.valueOf();
        if (valueA === valueB || valueA !== valueA && valueB !== valueB) return true;
        if (!valueA || !valueB) return false;
    }
    return !!(isValueObject(valueA) && isValueObject(valueB) && valueA.equals(valueB));
}
function update$1(collection, key, notSetValue, updater) {
    return updateIn(// @ts-expect-error Index signature for type string is missing in type V[]
    collection, [
        key
    ], notSetValue, updater);
}
function merge$1() {
    var iters = [], len = arguments.length;
    while(len--)iters[len] = arguments[len];
    return mergeIntoKeyedWith(this, iters);
}
function mergeWith$1(merger) {
    var iters = [], len = arguments.length - 1;
    while(len-- > 0)iters[len] = arguments[len + 1];
    if (typeof merger !== 'function') throw new TypeError('Invalid merger function: ' + merger);
    return mergeIntoKeyedWith(this, iters, merger);
}
function mergeIntoKeyedWith(collection, collections, merger) {
    var iters = [];
    for(var ii = 0; ii < collections.length; ii++){
        var collection$1 = KeyedCollection(collections[ii]);
        if (collection$1.size !== 0) iters.push(collection$1);
    }
    if (iters.length === 0) return collection;
    if (collection.toSeq().size === 0 && !collection.__ownerID && iters.length === 1) return isRecord(collection) ? collection // Record is empty and will not be updated: return the same instance
     : collection.constructor(iters[0]);
    return collection.withMutations(function(collection) {
        var mergeIntoCollection = merger ? function mergeIntoCollection(value, key) {
            update$1(collection, key, NOT_SET, function(oldVal) {
                return oldVal === NOT_SET ? value : merger(oldVal, value, key);
            });
        } : function(value, key) {
            collection.set(key, value);
        };
        for(var ii = 0; ii < iters.length; ii++)iters[ii].forEach(mergeIntoCollection);
    });
}
var toString = Object.prototype.toString;
function isPlainObject(value) {
    // The base prototype's toString deals with Argument objects and native namespaces like Math
    if (!value || (typeof value === "undefined" ? "undefined" : (0, $6tOPT._)(value)) !== 'object' || toString.call(value) !== '[object Object]') return false;
    var proto = Object.getPrototypeOf(value);
    if (proto === null) return true;
    // Iteratively going up the prototype chain is needed for cross-realm environments (differing contexts, iframes, etc)
    var parentProto = proto;
    var nextProto = Object.getPrototypeOf(proto);
    while(nextProto !== null){
        parentProto = nextProto;
        nextProto = Object.getPrototypeOf(parentProto);
    }
    return parentProto === proto;
}
/**
 * Returns true if the value is a potentially-persistent data structure, either
 * provided by Immutable.js or a plain Array or Object.
 */ function isDataStructure(value) {
    return (typeof value === "undefined" ? "undefined" : (0, $6tOPT._)(value)) === 'object' && (isImmutable(value) || Array.isArray(value) || isPlainObject(value));
}
function isProtoKey(key) {
    return typeof key === 'string' && (key === '__proto__' || key === 'constructor');
}
// http://jsperf.com/copy-array-inline
function arrCopy(arr, offset) {
    offset = offset || 0;
    var len = Math.max(0, arr.length - offset);
    var newArr = new Array(len);
    for(var ii = 0; ii < len; ii++)// @ts-expect-error We may want to guard for undefined values with `if (arr[ii + offset] !== undefined`, but ths should not happen by design
    newArr[ii] = arr[ii + offset];
    return newArr;
}
function shallowCopy(from) {
    if (Array.isArray(from)) return arrCopy(from);
    var to = {};
    for(var key in from){
        if (isProtoKey(key)) continue;
        if (hasOwnProperty.call(from, key)) to[key] = from[key];
    }
    return to;
}
function merge(collection) {
    var sources = [], len = arguments.length - 1;
    while(len-- > 0)sources[len] = arguments[len + 1];
    return mergeWithSources(collection, sources);
}
function mergeWith(merger, collection) {
    var sources = [], len = arguments.length - 2;
    while(len-- > 0)sources[len] = arguments[len + 2];
    return mergeWithSources(collection, sources, merger);
}
function mergeDeep$1(collection) {
    var sources = [], len = arguments.length - 1;
    while(len-- > 0)sources[len] = arguments[len + 1];
    return mergeDeepWithSources(collection, sources);
}
function mergeDeepWith$1(merger, collection) {
    var sources = [], len = arguments.length - 2;
    while(len-- > 0)sources[len] = arguments[len + 2];
    return mergeDeepWithSources(collection, sources, merger);
}
function mergeDeepWithSources(collection, sources, merger) {
    return mergeWithSources(collection, sources, deepMergerWith(merger));
}
function mergeWithSources(collection, sources, merger) {
    if (!isDataStructure(collection)) throw new TypeError('Cannot merge into non-data-structure value: ' + collection);
    if (isImmutable(collection)) return typeof merger === 'function' && collection.mergeWith ? collection.mergeWith.apply(collection, [
        merger
    ].concat(sources)) : collection.merge ? collection.merge.apply(collection, sources) : collection.concat.apply(collection, sources);
    var isArray = Array.isArray(collection);
    var merged = collection;
    var Collection = isArray ? IndexedCollection : KeyedCollection;
    var mergeItem = isArray ? function mergeItem(value) {
        // Copy on write
        if (merged === collection) merged = shallowCopy(merged);
        merged.push(value);
    } : function(value, key) {
        if (isProtoKey(key)) return;
        var hasVal = hasOwnProperty.call(merged, key);
        var nextVal = hasVal && merger ? merger(merged[key], value, key) : value;
        if (!hasVal || nextVal !== merged[key]) {
            // Copy on write
            if (merged === collection) merged = shallowCopy(merged);
            merged[key] = nextVal;
        }
    };
    for(var i = 0; i < sources.length; i++)Collection(sources[i]).forEach(mergeItem);
    return merged;
}
function deepMergerWith(merger) {
    function deepMerger(oldValue, newValue, key) {
        return isDataStructure(oldValue) && isDataStructure(newValue) && areMergeable(oldValue, newValue) ? mergeWithSources(oldValue, [
            newValue
        ], deepMerger) : merger ? merger(oldValue, newValue, key) : newValue;
    }
    return deepMerger;
}
/**
 * It's unclear what the desired behavior is for merging two collections that
 * fall into separate categories between keyed, indexed, or set-like, so we only
 * consider them mergeable if they fall into the same category.
 */ function areMergeable(oldDataStructure, newDataStructure) {
    var oldSeq = Seq(oldDataStructure);
    var newSeq = Seq(newDataStructure);
    // This logic assumes that a sequence can only fall into one of the three
    // categories mentioned above (since there's no `isSetLike()` method).
    return isIndexed(oldSeq) === isIndexed(newSeq) && isKeyed(oldSeq) === isKeyed(newSeq);
}
function mergeDeep() {
    var iters = [], len = arguments.length;
    while(len--)iters[len] = arguments[len];
    return mergeDeepWithSources(this, iters);
}
function mergeDeepWith(merger) {
    var iters = [], len = arguments.length - 1;
    while(len-- > 0)iters[len] = arguments[len + 1];
    return mergeDeepWithSources(this, iters, merger);
}
function mergeDeepIn(keyPath) {
    var iters = [], len = arguments.length - 1;
    while(len-- > 0)iters[len] = arguments[len + 1];
    return updateIn(this, keyPath, emptyMap(), function(m) {
        return mergeDeepWithSources(m, iters);
    });
}
function mergeIn(keyPath) {
    var iters = [], len = arguments.length - 1;
    while(len-- > 0)iters[len] = arguments[len + 1];
    return updateIn(this, keyPath, emptyMap(), function(m) {
        return mergeWithSources(m, iters);
    });
}
/**
 * Returns a copy of the collection with the value at the key path set to the
 * provided value.
 *
 * A functional alternative to `collection.setIn(keypath)` which will also
 * work with plain Objects and Arrays.
 */ function setIn$1(collection, keyPath, value) {
    return updateIn(collection, keyPath, NOT_SET, function() {
        return value;
    });
}
function setIn(keyPath, v) {
    return setIn$1(this, keyPath, v);
}
function update(key, notSetValue, updater) {
    return arguments.length === 1 ? key(this) : update$1(this, key, notSetValue, updater);
}
function updateIn$1(keyPath, notSetValue, updater) {
    return updateIn(this, keyPath, notSetValue, updater);
}
function wasAltered() {
    return this.__altered;
}
function withMutations(fn) {
    var mutable = this.asMutable();
    fn(mutable);
    return mutable.wasAltered() ? mutable.__ensureOwner(this.__ownerID) : this;
}
var IS_MAP_SYMBOL = '@@__IMMUTABLE_MAP__@@';
/**
 * True if `maybeMap` is a Map.
 *
 * Also true for OrderedMaps.
 */ function isMap(maybeMap) {
    return Boolean(maybeMap && // @ts-expect-error: maybeMap is typed as `{}`, need to change in 6.0 to `maybeMap && typeof maybeMap === 'object' && IS_MAP_SYMBOL in maybeMap`
    maybeMap[IS_MAP_SYMBOL]);
}
function invariant(condition, error) {
    if (!condition) throw new Error(error);
}
function assertNotInfinite(size) {
    invariant(size !== Infinity, 'Cannot perform this action with an infinite size.');
}
var Map = /*@__PURE__*/ function(KeyedCollection) {
    function Map(value) {
        // eslint-disable-next-line no-constructor-return
        return value === undefined || value === null ? emptyMap() : isMap(value) && !isOrdered(value) ? value : emptyMap().withMutations(function(map) {
            var iter = KeyedCollection(value);
            assertNotInfinite(iter.size);
            iter.forEach(function(v, k) {
                return map.set(k, v);
            });
        });
    }
    if (KeyedCollection) Map.__proto__ = KeyedCollection;
    Map.prototype = Object.create(KeyedCollection && KeyedCollection.prototype);
    Map.prototype.constructor = Map;
    Map.prototype.toString = function toString() {
        return this.__toString('Map {', '}');
    };
    // @pragma Access
    Map.prototype.get = function get(k, notSetValue) {
        return this._root ? this._root.get(0, undefined, k, notSetValue) : notSetValue;
    };
    // @pragma Modification
    Map.prototype.set = function set(k, v) {
        return updateMap(this, k, v);
    };
    Map.prototype.remove = function remove(k) {
        return updateMap(this, k, NOT_SET);
    };
    Map.prototype.deleteAll = function deleteAll(keys) {
        var collection = Collection(keys);
        if (collection.size === 0) return this;
        return this.withMutations(function(map) {
            collection.forEach(function(key) {
                return map.remove(key);
            });
        });
    };
    Map.prototype.clear = function clear() {
        if (this.size === 0) return this;
        if (this.__ownerID) {
            this.size = 0;
            this._root = null;
            this.__hash = undefined;
            this.__altered = true;
            return this;
        }
        return emptyMap();
    };
    // @pragma Composition
    Map.prototype.sort = function sort(comparator) {
        // Late binding
        return OrderedMap(sortFactory(this, comparator));
    };
    Map.prototype.sortBy = function sortBy(mapper, comparator) {
        // Late binding
        return OrderedMap(sortFactory(this, comparator, mapper));
    };
    Map.prototype.map = function map(mapper, context) {
        var this$1$1 = this;
        return this.withMutations(function(map) {
            map.forEach(function(value, key) {
                map.set(key, mapper.call(context, value, key, this$1$1));
            });
        });
    };
    // @pragma Mutability
    Map.prototype.__iterator = function __iterator(type, reverse) {
        return new MapIterator(this, type, reverse);
    };
    Map.prototype.__iterate = function __iterate(fn, reverse) {
        var this$1$1 = this;
        var iterations = 0;
        // eslint-disable-next-line @typescript-eslint/no-unused-expressions -- TODO enable eslint here
        this._root && this._root.iterate(function(entry) {
            iterations++;
            return fn(entry[1], entry[0], this$1$1);
        }, reverse);
        return iterations;
    };
    Map.prototype.__ensureOwner = function __ensureOwner(ownerID) {
        if (ownerID === this.__ownerID) return this;
        if (!ownerID) {
            if (this.size === 0) return emptyMap();
            this.__ownerID = ownerID;
            this.__altered = false;
            return this;
        }
        return makeMap(this.size, this._root, ownerID, this.__hash);
    };
    return Map;
}(KeyedCollection);
Map.isMap = isMap;
var MapPrototype = Map.prototype;
MapPrototype[IS_MAP_SYMBOL] = true;
MapPrototype[DELETE] = MapPrototype.remove;
MapPrototype.removeAll = MapPrototype.deleteAll;
MapPrototype.setIn = setIn;
MapPrototype.removeIn = MapPrototype.deleteIn = deleteIn;
MapPrototype.update = update;
MapPrototype.updateIn = updateIn$1;
MapPrototype.merge = MapPrototype.concat = merge$1;
MapPrototype.mergeWith = mergeWith$1;
MapPrototype.mergeDeep = mergeDeep;
MapPrototype.mergeDeepWith = mergeDeepWith;
MapPrototype.mergeIn = mergeIn;
MapPrototype.mergeDeepIn = mergeDeepIn;
MapPrototype.withMutations = withMutations;
MapPrototype.wasAltered = wasAltered;
MapPrototype.asImmutable = asImmutable;
MapPrototype['@@transducer/init'] = MapPrototype.asMutable = asMutable;
MapPrototype['@@transducer/step'] = function(result, arr) {
    return result.set(arr[0], arr[1]);
};
MapPrototype['@@transducer/result'] = function(obj) {
    return obj.asImmutable();
};
// #pragma Trie Nodes
var ArrayMapNode = function ArrayMapNode(ownerID, entries) {
    this.ownerID = ownerID;
    this.entries = entries;
};
ArrayMapNode.prototype.get = function get(shift, keyHash, key, notSetValue) {
    var entries = this.entries;
    for(var ii = 0, len = entries.length; ii < len; ii++){
        if (is(key, entries[ii][0])) return entries[ii][1];
    }
    return notSetValue;
};
ArrayMapNode.prototype.update = function update(ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
    var removed = value === NOT_SET;
    var entries = this.entries;
    var idx = 0;
    var len = entries.length;
    for(; idx < len; idx++){
        if (is(key, entries[idx][0])) break;
    }
    var exists = idx < len;
    if (exists ? entries[idx][1] === value : removed) return this;
    SetRef(didAlter);
    // eslint-disable-next-line @typescript-eslint/no-unused-expressions -- TODO enable eslint here
    (removed || !exists) && SetRef(didChangeSize);
    if (removed && entries.length === 1) return; // undefined
    if (!exists && !removed && entries.length >= MAX_ARRAY_MAP_SIZE) return createNodes(ownerID, entries, key, value);
    var isEditable = ownerID && ownerID === this.ownerID;
    var newEntries = isEditable ? entries : arrCopy(entries);
    if (exists) {
        if (removed) // eslint-disable-next-line @typescript-eslint/no-unused-expressions -- TODO enable eslint here
        idx === len - 1 ? newEntries.pop() : newEntries[idx] = newEntries.pop();
        else newEntries[idx] = [
            key,
            value
        ];
    } else newEntries.push([
        key,
        value
    ]);
    if (isEditable) {
        this.entries = newEntries;
        return this;
    }
    return new ArrayMapNode(ownerID, newEntries);
};
var BitmapIndexedNode = function BitmapIndexedNode(ownerID, bitmap, nodes) {
    this.ownerID = ownerID;
    this.bitmap = bitmap;
    this.nodes = nodes;
};
BitmapIndexedNode.prototype.get = function get(shift, keyHash, key, notSetValue) {
    if (keyHash === undefined) keyHash = hash(key);
    var bit = 1 << ((shift === 0 ? keyHash : keyHash >>> shift) & MASK);
    var bitmap = this.bitmap;
    return (bitmap & bit) === 0 ? notSetValue : this.nodes[popCount(bitmap & bit - 1)].get(shift + SHIFT, keyHash, key, notSetValue);
};
BitmapIndexedNode.prototype.update = function update(ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
    if (keyHash === undefined) keyHash = hash(key);
    var keyHashFrag = (shift === 0 ? keyHash : keyHash >>> shift) & MASK;
    var bit = 1 << keyHashFrag;
    var bitmap = this.bitmap;
    var exists = (bitmap & bit) !== 0;
    if (!exists && value === NOT_SET) return this;
    var idx = popCount(bitmap & bit - 1);
    var nodes = this.nodes;
    var node = exists ? nodes[idx] : undefined;
    var newNode = updateNode(node, ownerID, shift + SHIFT, keyHash, key, value, didChangeSize, didAlter);
    if (newNode === node) return this;
    if (!exists && newNode && nodes.length >= MAX_BITMAP_INDEXED_SIZE) return expandNodes(ownerID, nodes, bitmap, keyHashFrag, newNode);
    if (exists && !newNode && nodes.length === 2 && isLeafNode(nodes[idx ^ 1])) return nodes[idx ^ 1];
    if (exists && newNode && nodes.length === 1 && isLeafNode(newNode)) return newNode;
    var isEditable = ownerID && ownerID === this.ownerID;
    var newBitmap = exists ? newNode ? bitmap : bitmap ^ bit : bitmap | bit;
    var newNodes = exists ? newNode ? setAt(nodes, idx, newNode, isEditable) : spliceOut(nodes, idx, isEditable) : spliceIn(nodes, idx, newNode, isEditable);
    if (isEditable) {
        this.bitmap = newBitmap;
        this.nodes = newNodes;
        return this;
    }
    return new BitmapIndexedNode(ownerID, newBitmap, newNodes);
};
var HashArrayMapNode = function HashArrayMapNode(ownerID, count, nodes) {
    this.ownerID = ownerID;
    this.count = count;
    this.nodes = nodes;
};
HashArrayMapNode.prototype.get = function get(shift, keyHash, key, notSetValue) {
    if (keyHash === undefined) keyHash = hash(key);
    var idx = (shift === 0 ? keyHash : keyHash >>> shift) & MASK;
    var node = this.nodes[idx];
    return node ? node.get(shift + SHIFT, keyHash, key, notSetValue) : notSetValue;
};
HashArrayMapNode.prototype.update = function update(ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
    if (keyHash === undefined) keyHash = hash(key);
    var idx = (shift === 0 ? keyHash : keyHash >>> shift) & MASK;
    var removed = value === NOT_SET;
    var nodes = this.nodes;
    var node = nodes[idx];
    if (removed && !node) return this;
    var newNode = updateNode(node, ownerID, shift + SHIFT, keyHash, key, value, didChangeSize, didAlter);
    if (newNode === node) return this;
    var newCount = this.count;
    if (!node) newCount++;
    else if (!newNode) {
        newCount--;
        if (newCount < MIN_HASH_ARRAY_MAP_SIZE) return packNodes(ownerID, nodes, newCount, idx);
    }
    var isEditable = ownerID && ownerID === this.ownerID;
    var newNodes = setAt(nodes, idx, newNode, isEditable);
    if (isEditable) {
        this.count = newCount;
        this.nodes = newNodes;
        return this;
    }
    return new HashArrayMapNode(ownerID, newCount, newNodes);
};
/**
 * Trie leaf gathering entries whose keys all share the same 32-bit `hash()`.
 * The trie routes by hash, so colliding keys cannot be separated and land here
 * in a flat `entries` array, disambiguated by `is()`.
 *
 * To guard against hash-flooding DoS (CWE-407), large buckets build a secondary
 * index keyed by a per-process seeded hash (`hashCollisionKey`). `is()` still
 * decides equality, so the index can only ever narrow candidates, never lose a key.
 */ var HashCollisionNode = function HashCollisionNode(ownerID, keyHash, entries) {
    this.ownerID = ownerID;
    this.keyHash = keyHash;
    this.entries = entries;
    // Lazy `{ [secondaryHash]: number[] }`, built only past
    // MIN_HASH_COLLISION_INDEX_SIZE so small buckets keep their linear path.
    this._index = undefined;
};
// Returns the position of `key` in `this.entries`, or -1. Uses the secondary
// index when present; builds it only when `buildIndex` is true (reads and
// transient inserts, where the node is reused so the O(n) build amortizes).
// Persistent inserts already pay an O(n) copy, so a throwaway index is skipped.
HashCollisionNode.prototype._positionOf = function _positionOf(key, buildIndex) {
    var entries = this.entries;
    var index = this._index;
    if (index === undefined && buildIndex && entries.length >= MIN_HASH_COLLISION_INDEX_SIZE) index = this._buildIndex();
    if (index !== undefined) {
        var positions = index[hashCollisionKey(key)];
        if (positions !== undefined) for(var jj = 0; jj < positions.length; jj++){
            var ii = positions[jj];
            if (is(key, entries[ii][0])) return ii;
        }
        return -1;
    }
    for(var ii$1 = 0, len = entries.length; ii$1 < len; ii$1++){
        if (is(key, entries[ii$1][0])) return ii$1;
    }
    return -1;
};
// Builds and memoizes the secondary index. A plain object, not `Map` — which
// in this module resolves to the *Immutable* Map, not the native one.
HashCollisionNode.prototype._buildIndex = function _buildIndex() {
    var index = Object.create(null);
    var entries = this.entries;
    for(var ii = 0, len = entries.length; ii < len; ii++){
        var secondaryHash = hashCollisionKey(entries[ii][0]);
        var positions = index[secondaryHash];
        if (positions !== undefined) positions.push(ii);
        else index[secondaryHash] = [
            ii
        ];
    }
    this._index = index;
    return index;
};
HashCollisionNode.prototype.get = function get(shift, keyHash, key, notSetValue) {
    var idx = this._positionOf(key, true);
    return idx === -1 ? notSetValue : this.entries[idx][1];
};
HashCollisionNode.prototype.update = function update(ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
    if (keyHash === undefined) keyHash = hash(key);
    var removed = value === NOT_SET;
    if (keyHash !== this.keyHash) {
        if (removed) return this;
        SetRef(didAlter);
        SetRef(didChangeSize);
        return mergeIntoNode(this, ownerID, shift, keyHash, [
            key,
            value
        ]);
    }
    var entries = this.entries;
    var len = entries.length;
    var isEditable = ownerID && ownerID === this.ownerID;
    var foundIdx = this._positionOf(key, isEditable);
    var idx = foundIdx === -1 ? len : foundIdx;
    var exists = foundIdx !== -1;
    if (exists ? entries[idx][1] === value : removed) return this;
    SetRef(didAlter);
    // eslint-disable-next-line @typescript-eslint/no-unused-expressions -- TODO enable eslint here
    (removed || !exists) && SetRef(didChangeSize);
    if (removed && len === 2) return new ValueNode(ownerID, this.keyHash, entries[idx ^ 1]);
    var newEntries = isEditable ? entries : arrCopy(entries);
    if (exists) {
        if (removed) {
            // eslint-disable-next-line @typescript-eslint/no-unused-expressions -- TODO enable eslint here
            idx === len - 1 ? newEntries.pop() : newEntries[idx] = newEntries.pop();
            // The swap-pop reshuffles positions; drop the stale index (rebuilt lazily).
            if (isEditable) this._index = undefined;
        } else // Same key, same position: the index stays valid.
        newEntries[idx] = [
            key,
            value
        ];
    } else {
        newEntries.push([
            key,
            value
        ]);
        // Keep the index in sync on the transient insert path. Persistent inserts
        // return a fresh node below whose index rebuilds lazily, so skip them.
        if (isEditable && this._index !== undefined) {
            var secondaryHash = hashCollisionKey(key);
            var positions = this._index[secondaryHash];
            if (positions !== undefined) positions.push(len);
            else this._index[secondaryHash] = [
                len
            ];
        }
    }
    if (isEditable) {
        this.entries = newEntries;
        return this;
    }
    return new HashCollisionNode(ownerID, this.keyHash, newEntries);
};
var ValueNode = function ValueNode(ownerID, keyHash, entry) {
    this.ownerID = ownerID;
    this.keyHash = keyHash;
    this.entry = entry;
};
ValueNode.prototype.get = function get(shift, keyHash, key, notSetValue) {
    return is(key, this.entry[0]) ? this.entry[1] : notSetValue;
};
ValueNode.prototype.update = function update(ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
    var removed = value === NOT_SET;
    var keyMatch = is(key, this.entry[0]);
    if (keyMatch ? value === this.entry[1] : removed) return this;
    SetRef(didAlter);
    if (removed) {
        SetRef(didChangeSize);
        return; // undefined
    }
    if (keyMatch) {
        if (ownerID && ownerID === this.ownerID) {
            this.entry[1] = value;
            return this;
        }
        return new ValueNode(ownerID, this.keyHash, [
            key,
            value
        ]);
    }
    SetRef(didChangeSize);
    return mergeIntoNode(this, ownerID, shift, hash(key), [
        key,
        value
    ]);
};
// #pragma Iterators
ArrayMapNode.prototype.iterate = HashCollisionNode.prototype.iterate = function(fn, reverse) {
    var entries = this.entries;
    for(var ii = 0, maxIndex = entries.length - 1; ii <= maxIndex; ii++){
        if (fn(entries[reverse ? maxIndex - ii : ii]) === false) return false;
    }
};
BitmapIndexedNode.prototype.iterate = HashArrayMapNode.prototype.iterate = function(fn, reverse) {
    var nodes = this.nodes;
    for(var ii = 0, maxIndex = nodes.length - 1; ii <= maxIndex; ii++){
        var node = nodes[reverse ? maxIndex - ii : ii];
        if (node && node.iterate(fn, reverse) === false) return false;
    }
};
// eslint-disable-next-line @typescript-eslint/no-unused-vars
ValueNode.prototype.iterate = function(fn, reverse) {
    return fn(this.entry);
};
var MapIterator = /*@__PURE__*/ function(Iterator) {
    function MapIterator(map, type, reverse) {
        this._type = type;
        this._reverse = reverse;
        this._stack = map._root && mapIteratorFrame(map._root);
    }
    if (Iterator) MapIterator.__proto__ = Iterator;
    MapIterator.prototype = Object.create(Iterator && Iterator.prototype);
    MapIterator.prototype.constructor = MapIterator;
    MapIterator.prototype.next = function next() {
        var type = this._type;
        var stack = this._stack;
        while(stack){
            var node = stack.node;
            var index = stack.index++;
            var maxIndex = void 0;
            if (node.entry) {
                if (index === 0) return mapIteratorValue(type, node.entry);
            } else if (node.entries) {
                maxIndex = node.entries.length - 1;
                if (index <= maxIndex) return mapIteratorValue(type, node.entries[this._reverse ? maxIndex - index : index]);
            } else {
                maxIndex = node.nodes.length - 1;
                if (index <= maxIndex) {
                    var subNode = node.nodes[this._reverse ? maxIndex - index : index];
                    if (subNode) {
                        if (subNode.entry) return mapIteratorValue(type, subNode.entry);
                        stack = this._stack = mapIteratorFrame(subNode, stack);
                    }
                    continue;
                }
            }
            stack = this._stack = this._stack.__prev;
        }
        return iteratorDone();
    };
    return MapIterator;
}(Iterator);
function mapIteratorValue(type, entry) {
    return iteratorValue(type, entry[0], entry[1]);
}
function mapIteratorFrame(node, prev) {
    return {
        node: node,
        index: 0,
        __prev: prev
    };
}
function makeMap(size, root, ownerID, hash) {
    var map = Object.create(MapPrototype);
    map.size = size;
    map._root = root;
    map.__ownerID = ownerID;
    map.__hash = hash;
    map.__altered = false;
    return map;
}
var EMPTY_MAP;
function emptyMap() {
    return EMPTY_MAP || (EMPTY_MAP = makeMap(0));
}
function updateMap(map, k, v) {
    var newRoot;
    var newSize;
    if (!map._root) {
        if (v === NOT_SET) return map;
        newSize = 1;
        newRoot = new ArrayMapNode(map.__ownerID, [
            [
                k,
                v
            ]
        ]);
    } else {
        var didChangeSize = MakeRef();
        var didAlter = MakeRef();
        newRoot = updateNode(map._root, map.__ownerID, 0, undefined, k, v, didChangeSize, didAlter);
        if (!didAlter.value) return map;
        newSize = map.size + (didChangeSize.value ? v === NOT_SET ? -1 : 1 : 0);
    }
    if (map.__ownerID) {
        map.size = newSize;
        map._root = newRoot;
        map.__hash = undefined;
        map.__altered = true;
        return map;
    }
    return newRoot ? makeMap(newSize, newRoot) : emptyMap();
}
function updateNode(node, ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
    if (!node) {
        if (value === NOT_SET) return node;
        SetRef(didAlter);
        SetRef(didChangeSize);
        return new ValueNode(ownerID, keyHash, [
            key,
            value
        ]);
    }
    return node.update(ownerID, shift, keyHash, key, value, didChangeSize, didAlter);
}
function isLeafNode(node) {
    return node.constructor === ValueNode || node.constructor === HashCollisionNode;
}
function mergeIntoNode(node, ownerID, shift, keyHash, entry) {
    if (node.keyHash === keyHash) return new HashCollisionNode(ownerID, keyHash, [
        node.entry,
        entry
    ]);
    var idx1 = (shift === 0 ? node.keyHash : node.keyHash >>> shift) & MASK;
    var idx2 = (shift === 0 ? keyHash : keyHash >>> shift) & MASK;
    var newNode;
    var nodes = idx1 === idx2 ? [
        mergeIntoNode(node, ownerID, shift + SHIFT, keyHash, entry)
    ] : (newNode = new ValueNode(ownerID, keyHash, entry), idx1 < idx2 ? [
        node,
        newNode
    ] : [
        newNode,
        node
    ]);
    return new BitmapIndexedNode(ownerID, 1 << idx1 | 1 << idx2, nodes);
}
function createNodes(ownerID, entries, key, value) {
    if (!ownerID) ownerID = new OwnerID();
    var node = new ValueNode(ownerID, hash(key), [
        key,
        value
    ]);
    for(var ii = 0; ii < entries.length; ii++){
        var entry = entries[ii];
        node = node.update(ownerID, 0, undefined, entry[0], entry[1]);
    }
    return node;
}
function packNodes(ownerID, nodes, count, excluding) {
    var bitmap = 0;
    var packedII = 0;
    var packedNodes = new Array(count);
    for(var ii = 0, bit = 1, len = nodes.length; ii < len; ii++, bit <<= 1){
        var node = nodes[ii];
        if (node !== undefined && ii !== excluding) {
            bitmap |= bit;
            packedNodes[packedII++] = node;
        }
    }
    return new BitmapIndexedNode(ownerID, bitmap, packedNodes);
}
function expandNodes(ownerID, nodes, bitmap, including, node) {
    var count = 0;
    var expandedNodes = new Array(SIZE);
    for(var ii = 0; bitmap !== 0; ii++, bitmap >>>= 1)expandedNodes[ii] = bitmap & 1 ? nodes[count++] : undefined;
    expandedNodes[including] = node;
    return new HashArrayMapNode(ownerID, count + 1, expandedNodes);
}
function popCount(x) {
    x -= x >> 1 & 0x55555555;
    x = (x & 0x33333333) + (x >> 2 & 0x33333333);
    x = x + (x >> 4) & 0x0f0f0f0f;
    x += x >> 8;
    x += x >> 16;
    return x & 0x7f;
}
function setAt(array, idx, val, canEdit) {
    var newArray = canEdit ? array : arrCopy(array);
    newArray[idx] = val;
    return newArray;
}
function spliceIn(array, idx, val, canEdit) {
    var newLen = array.length + 1;
    if (canEdit && idx + 1 === newLen) {
        array[idx] = val;
        return array;
    }
    var newArray = new Array(newLen);
    var after = 0;
    for(var ii = 0; ii < newLen; ii++)if (ii === idx) {
        newArray[ii] = val;
        after = -1;
    } else newArray[ii] = array[ii + after];
    return newArray;
}
function spliceOut(array, idx, canEdit) {
    var newLen = array.length - 1;
    if (canEdit && idx === newLen) {
        array.pop();
        return array;
    }
    var newArray = new Array(newLen);
    var after = 0;
    for(var ii = 0; ii < newLen; ii++){
        if (ii === idx) after = 1;
        newArray[ii] = array[ii + after];
    }
    return newArray;
}
var MAX_ARRAY_MAP_SIZE = SIZE / 4;
var MAX_BITMAP_INDEXED_SIZE = SIZE / 2;
var MIN_HASH_ARRAY_MAP_SIZE = SIZE / 4;
// Above this many colliding entries, a `HashCollisionNode` builds a seeded
// secondary index instead of scanning linearly. Kept small so the rare,
// naturally-occurring collision buckets stay overhead-free, while adversarial
// hash-flooding (thousands of keys sharing one hash) degrades gracefully.
var MIN_HASH_COLLISION_INDEX_SIZE = 16;
function coerceKeyPath(keyPath) {
    if (isArrayLike(keyPath) && typeof keyPath !== 'string') return keyPath;
    if (isOrdered(keyPath)) return keyPath.toArray();
    throw new TypeError('Invalid keyPath: expected Ordered Collection or Array: ' + keyPath);
}
/**
 * Converts a value to a string, adding quotes if a string was provided.
 */ function quoteString(value) {
    try {
        return typeof value === 'string' ? JSON.stringify(value) : String(value);
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    } catch (_ignoreError) {
        return JSON.stringify(value);
    }
}
/**
 * Returns true if the key is defined in the provided collection.
 *
 * A functional alternative to `collection.has(key)` which will also work with
 * plain Objects and Arrays as an alternative for
 * `collection.hasOwnProperty(key)`.
 */ function has(collection, key) {
    return isImmutable(collection) ? collection.has(key) : isDataStructure(collection) && hasOwnProperty.call(collection, key);
}
function get(collection, key, notSetValue) {
    return isImmutable(collection) ? collection.get(key, notSetValue) : !has(collection, key) ? notSetValue : typeof collection.get === 'function' ? collection.get(key) : collection[key];
}
function remove(collection, key) {
    if (!isDataStructure(collection)) throw new TypeError('Cannot update non-data-structure value: ' + collection);
    if (isImmutable(collection)) {
        // @ts-expect-error weird "remove" here,
        if (!collection.remove) throw new TypeError('Cannot update immutable value without .remove() method: ' + collection);
        // @ts-expect-error weird "remove" here,
        return collection.remove(key);
    }
    // @ts-expect-error assert that key is a string, a number or a symbol here
    if (!hasOwnProperty.call(collection, key)) return collection;
    var collectionCopy = shallowCopy(collection);
    if (Array.isArray(collectionCopy)) // @ts-expect-error assert that key is a number here
    collectionCopy.splice(key, 1);
    else // @ts-expect-error assert that key is a string, a number or a symbol here
    delete collectionCopy[key];
    return collectionCopy;
}
function set(collection, key, value) {
    if (isProtoKey(key)) return collection;
    if (!isDataStructure(collection)) throw new TypeError('Cannot update non-data-structure value: ' + collection);
    if (isImmutable(collection)) {
        // @ts-expect-error weird "set" here,
        if (!collection.set) throw new TypeError('Cannot update immutable value without .set() method: ' + collection);
        // @ts-expect-error weird "set" here,
        return collection.set(key, value);
    }
    // @ts-expect-error mix of key and string here. Probably need a more fine type here
    if (hasOwnProperty.call(collection, key) && value === collection[key]) return collection;
    var collectionCopy = shallowCopy(collection);
    // @ts-expect-error mix of key and string here. Probably need a more fine type here
    collectionCopy[key] = value;
    return collectionCopy;
}
function updateIn(collection, keyPath, notSetValue, updater) {
    if (!updater) {
        // handle the fact that `notSetValue` is optional here, in that case `updater` is the updater function
        // @ts-expect-error updater is a function here
        updater = notSetValue;
        notSetValue = undefined;
    }
    var updatedValue = updateInDeeply(isImmutable(collection), // @ts-expect-error type issues with Record and mixed types
    collection, coerceKeyPath(keyPath), 0, notSetValue, updater);
    // @ts-expect-error mixed return type
    return updatedValue === NOT_SET ? notSetValue : updatedValue;
}
function updateInDeeply(inImmutable, existing, keyPath, i, notSetValue, updater) {
    var wasNotSet = existing === NOT_SET;
    if (i === keyPath.length) {
        var existingValue = wasNotSet ? notSetValue : existing;
        // @ts-expect-error mixed type with optional value
        var newValue = updater(existingValue);
        // @ts-expect-error mixed type
        return newValue === existingValue ? existing : newValue;
    }
    if (!wasNotSet && !isDataStructure(existing)) throw new TypeError('Cannot update within non-data-structure value in path [' + Array.from(keyPath).slice(0, i).map(quoteString) + ']: ' + existing);
    var key = keyPath[i];
    var nextExisting = wasNotSet ? NOT_SET : get(existing, key, NOT_SET);
    var nextUpdated = updateInDeeply(nextExisting === NOT_SET ? inImmutable : isImmutable(nextExisting), // @ts-expect-error mixed type
    nextExisting, keyPath, i + 1, notSetValue, updater);
    return nextUpdated === nextExisting ? existing : nextUpdated === NOT_SET ? remove(existing, key) : set(wasNotSet ? inImmutable ? emptyMap() : {} : existing, key, nextUpdated);
}
/**
 * Returns a copy of the collection with the value at the key path removed.
 *
 * A functional alternative to `collection.removeIn(keypath)` which will also
 * work with plain Objects and Arrays.
 */ function removeIn(collection, keyPath) {
    return updateIn(collection, keyPath, function() {
        return NOT_SET;
    });
}
function deleteIn(keyPath) {
    return removeIn(this, keyPath);
}
var IS_LIST_SYMBOL = '@@__IMMUTABLE_LIST__@@';
/**
 * True if `maybeList` is a List.
 */ function isList(maybeList) {
    return Boolean(maybeList && // @ts-expect-error: maybeList is typed as `{}`, need to change in 6.0 to `maybeList && typeof maybeList === 'object' && IS_LIST_SYMBOL in maybeList`
    maybeList[IS_LIST_SYMBOL]);
}
var List = /*@__PURE__*/ function(IndexedCollection) {
    function List(value) {
        var empty = emptyList();
        if (value === undefined || value === null) // eslint-disable-next-line no-constructor-return
        return empty;
        if (isList(value)) // eslint-disable-next-line no-constructor-return
        return value;
        var iter = IndexedCollection(value);
        var size = iter.size;
        if (size === 0) // eslint-disable-next-line no-constructor-return
        return empty;
        assertNotInfinite(size);
        if (size > 0 && size < SIZE) // eslint-disable-next-line no-constructor-return
        return makeList(0, size, SHIFT, undefined, new VNode(iter.toArray()));
        // eslint-disable-next-line no-constructor-return
        return empty.withMutations(function(list) {
            list.setSize(size);
            iter.forEach(function(v, i) {
                return list.set(i, v);
            });
        });
    }
    if (IndexedCollection) List.__proto__ = IndexedCollection;
    List.prototype = Object.create(IndexedCollection && IndexedCollection.prototype);
    List.prototype.constructor = List;
    List.of = function of() {
        return this(arguments);
    };
    List.prototype.toString = function toString() {
        return this.__toString('List [', ']');
    };
    // @pragma Access
    List.prototype.get = function get(index, notSetValue) {
        index = wrapIndex(this, index);
        if (index >= 0 && index < this.size) {
            index += this._origin;
            var node = listNodeFor(this, index);
            return node && node.array[index & MASK];
        }
        return notSetValue;
    };
    // @pragma Modification
    List.prototype.set = function set(index, value) {
        return updateList(this, index, value);
    };
    List.prototype.remove = function remove(index) {
        return !this.has(index) ? this : index === 0 ? this.shift() : index === this.size - 1 ? this.pop() : this.splice(index, 1);
    };
    List.prototype.insert = function insert(index, value) {
        return this.splice(index, 0, value);
    };
    List.prototype.clear = function clear() {
        if (this.size === 0) return this;
        if (this.__ownerID) {
            this.size = this._origin = this._capacity = 0;
            this._level = SHIFT;
            this._root = this._tail = this.__hash = undefined;
            this.__altered = true;
            return this;
        }
        return emptyList();
    };
    List.prototype.push = function push() {
        var values = arguments;
        var oldSize = this.size;
        return this.withMutations(function(list) {
            setListBounds(list, 0, oldSize + values.length);
            for(var ii = 0; ii < values.length; ii++)list.set(oldSize + ii, values[ii]);
        });
    };
    List.prototype.pop = function pop() {
        return setListBounds(this, 0, -1);
    };
    List.prototype.unshift = function unshift() {
        var values = arguments;
        return this.withMutations(function(list) {
            setListBounds(list, -values.length);
            for(var ii = 0; ii < values.length; ii++)list.set(ii, values[ii]);
        });
    };
    List.prototype.shift = function shift() {
        return setListBounds(this, 1);
    };
    List.prototype.shuffle = function shuffle(random) {
        if (random === void 0) random = Math.random;
        return this.withMutations(function(mutable) {
            // implementation of the Fisher-Yates shuffle: https://en.wikipedia.org/wiki/Fisher%E2%80%93Yates_shuffle
            var current = mutable.size;
            var destination;
            var tmp;
            while(current){
                destination = Math.floor(random() * current--);
                tmp = mutable.get(destination);
                mutable.set(destination, mutable.get(current));
                mutable.set(current, tmp);
            }
        });
    };
    // @pragma Composition
    List.prototype.concat = function concat() {
        var arguments$1 = arguments;
        var seqs = [];
        for(var i = 0; i < arguments.length; i++){
            var argument = arguments$1[i];
            var seq = IndexedCollection(typeof argument !== 'string' && hasIterator(argument) ? argument : [
                argument
            ]);
            if (seq.size !== 0) seqs.push(seq);
        }
        if (seqs.length === 0) return this;
        if (this.size === 0 && !this.__ownerID && seqs.length === 1) return this.constructor(seqs[0]);
        return this.withMutations(function(list) {
            seqs.forEach(function(seq) {
                return seq.forEach(function(value) {
                    return list.push(value);
                });
            });
        });
    };
    List.prototype.setSize = function setSize(size) {
        return setListBounds(this, 0, size);
    };
    List.prototype.map = function map(mapper, context) {
        var this$1$1 = this;
        return this.withMutations(function(list) {
            for(var i = 0; i < this$1$1.size; i++)list.set(i, mapper.call(context, list.get(i), i, this$1$1));
        });
    };
    // @pragma Iteration
    List.prototype.slice = function slice(begin, end) {
        var size = this.size;
        if (wholeSlice(begin, end, size)) return this;
        return setListBounds(this, resolveBegin(begin, size), resolveEnd(end, size));
    };
    List.prototype.__iterator = function __iterator(type, reverse) {
        var index = reverse ? this.size : 0;
        var values = iterateList(this, reverse);
        return new Iterator(function() {
            var value = values();
            return value === DONE ? iteratorDone() : iteratorValue(type, reverse ? --index : index++, value);
        });
    };
    List.prototype.__iterate = function __iterate(fn, reverse) {
        var index = reverse ? this.size : 0;
        var values = iterateList(this, reverse);
        var value;
        while((value = values()) !== DONE){
            if (fn(value, reverse ? --index : index++, this) === false) break;
        }
        return index;
    };
    List.prototype.__ensureOwner = function __ensureOwner(ownerID) {
        if (ownerID === this.__ownerID) return this;
        if (!ownerID) {
            if (this.size === 0) return emptyList();
            this.__ownerID = ownerID;
            this.__altered = false;
            return this;
        }
        return makeList(this._origin, this._capacity, this._level, this._root, this._tail, ownerID, this.__hash);
    };
    return List;
}(IndexedCollection);
List.isList = isList;
var ListPrototype = List.prototype;
ListPrototype[IS_LIST_SYMBOL] = true;
ListPrototype[DELETE] = ListPrototype.remove;
ListPrototype.merge = ListPrototype.concat;
ListPrototype.setIn = setIn;
ListPrototype.deleteIn = ListPrototype.removeIn = deleteIn;
ListPrototype.update = update;
ListPrototype.updateIn = updateIn$1;
ListPrototype.mergeIn = mergeIn;
ListPrototype.mergeDeepIn = mergeDeepIn;
ListPrototype.withMutations = withMutations;
ListPrototype.wasAltered = wasAltered;
ListPrototype.asImmutable = asImmutable;
ListPrototype['@@transducer/init'] = ListPrototype.asMutable = asMutable;
ListPrototype['@@transducer/step'] = function(result, arr) {
    return result.push(arr);
};
ListPrototype['@@transducer/result'] = function(obj) {
    return obj.asImmutable();
};
/**
 * A node in the List's 32-wide trie. At inner levels `array` holds child
 * `VNode`s; at the leaf level it holds the List's values. Missing slots are
 * `undefined` array holes.
 *
 * @template T
 */ var VNode = function VNode(array, ownerID) {
    this.array = array;
    this.ownerID = ownerID;
};
// TODO: seems like these methods are very similar
VNode.prototype.removeBefore = function removeBefore(ownerID, level, index) {
    if ((index & (1 << level + SHIFT) - 1) === 0 || this.array.length === 0) return this;
    var originIndex = index >>> level & MASK;
    if (originIndex >= this.array.length) return new VNode([], ownerID);
    var removingFirst = originIndex === 0;
    var newChild;
    if (level > 0) {
        var oldChild = this.array[originIndex];
        newChild = oldChild && oldChild.removeBefore(ownerID, level - SHIFT, index);
        if (newChild === oldChild && removingFirst) return this;
    }
    if (removingFirst && !newChild) return this;
    var editable = editableVNode(this, ownerID);
    if (!removingFirst) for(var ii = 0; ii < originIndex; ii++)editable.array[ii] = undefined;
    if (newChild) editable.array[originIndex] = newChild;
    return editable;
};
VNode.prototype.removeAfter = function removeAfter(ownerID, level, index) {
    if (index === (level ? 1 << level + SHIFT : SIZE) || this.array.length === 0) return this;
    var sizeIndex = index - 1 >>> level & MASK;
    if (sizeIndex >= this.array.length) return this;
    var newChild;
    if (level > 0) {
        var oldChild = this.array[sizeIndex];
        newChild = oldChild && oldChild.removeAfter(ownerID, level - SHIFT, index);
        if (newChild === oldChild && sizeIndex === this.array.length - 1) return this;
    }
    var editable = editableVNode(this, ownerID);
    editable.array.splice(sizeIndex + 1);
    if (newChild) editable.array[sizeIndex] = newChild;
    return editable;
};
var DONE = {};
function iterateList(list, reverse) {
    var left = list._origin;
    var right = list._capacity;
    var tailPos = getTailOffset(right);
    var tail = list._tail;
    return iterateNodeOrLeaf(list._root, list._level, 0);
    function iterateNodeOrLeaf(node, level, offset) {
        return level === 0 ? iterateLeaf(node, offset) : iterateNode(node, level, offset);
    }
    function iterateLeaf(node, offset) {
        var array = offset === tailPos ? tail && tail.array : node && node.array;
        var from = offset > left ? 0 : left - offset;
        var to = right - offset;
        if (to > SIZE) to = SIZE;
        return function() {
            if (from === to) return DONE;
            var idx = reverse ? --to : from++;
            return array && array[idx];
        };
    }
    function iterateNode(node, level, offset) {
        var values;
        var array = node && node.array;
        var from = offset > left ? 0 : left - offset >> level;
        var to = (right - offset >> level) + 1;
        if (to > SIZE) to = SIZE;
        return function() {
            while(true){
                if (values) {
                    var value = values();
                    if (value !== DONE) return value;
                    values = null;
                }
                if (from === to) return DONE;
                var idx = reverse ? --to : from++;
                values = iterateNodeOrLeaf(array && array[idx], level - SHIFT, offset + (idx << level));
            }
        };
    }
}
/**
 * @param {number} origin
 * @param {number} capacity
 * @param {number} level
 * @param {VNode | undefined} [root] The trie root, or `undefined` when every
 *   in-range value lives in the tail (or is a virtual `undefined`).
 * @param {VNode | undefined} [tail]
 * @param {OwnerID} [ownerID]
 * @param {number} [hash]
 */ function makeList(origin, capacity, level, root, tail, ownerID, hash) {
    var list = Object.create(ListPrototype);
    list.size = capacity - origin;
    list._origin = origin;
    list._capacity = capacity;
    list._level = level;
    list._root = root;
    list._tail = tail;
    list.__ownerID = ownerID;
    list.__hash = hash;
    list.__altered = false;
    return list;
}
function emptyList() {
    return makeList(0, 0, SHIFT);
}
function updateList(list, index, value) {
    index = wrapIndex(list, index);
    if (index !== index) return list;
    if (index >= list.size || index < 0) return list.withMutations(function(list) {
        // eslint-disable-next-line @typescript-eslint/no-unused-expressions -- TODO enable eslint here
        index < 0 ? setListBounds(list, index).set(0, value) : setListBounds(list, 0, index + 1).set(index, value);
    });
    index += list._origin;
    var newTail = list._tail;
    var newRoot = list._root;
    var didAlter = MakeRef();
    if (index >= getTailOffset(list._capacity)) newTail = updateVNode(newTail, list.__ownerID, 0, index, value, didAlter);
    else newRoot = updateVNode(newRoot, list.__ownerID, list._level, index, value, didAlter);
    if (!didAlter.value) return list;
    if (list.__ownerID) {
        list._root = newRoot;
        list._tail = newTail;
        list.__hash = undefined;
        list.__altered = true;
        return list;
    }
    return makeList(list._origin, list._capacity, list._level, newRoot, newTail);
}
function updateVNode(node, ownerID, level, index, value, didAlter) {
    var idx = index >>> level & MASK;
    var nodeHas = node && idx < node.array.length;
    if (!nodeHas && value === undefined) return node;
    var newNode;
    if (level > 0) {
        var lowerNode = node && node.array[idx];
        var newLowerNode = updateVNode(lowerNode, ownerID, level - SHIFT, index, value, didAlter);
        if (newLowerNode === lowerNode) return node;
        newNode = editableVNode(node, ownerID);
        newNode.array[idx] = newLowerNode;
        return newNode;
    }
    if (nodeHas && node.array[idx] === value) return node;
    if (didAlter) SetRef(didAlter);
    newNode = editableVNode(node, ownerID);
    if (value === undefined && idx === newNode.array.length - 1) newNode.array.pop();
    else newNode.array[idx] = value;
    return newNode;
}
function editableVNode(node, ownerID) {
    if (ownerID && node && ownerID === node.ownerID) return node;
    return new VNode(node ? node.array.slice() : [], ownerID);
}
/**
 * Returns the leaf `VNode` holding `rawIndex`, or `undefined` when no node is
 * allocated for it (an all-`undefined` region).
 *
 * @param {List} list
 * @param {number} rawIndex
 * @returns {VNode | undefined}
 */ function listNodeFor(list, rawIndex) {
    if (rawIndex >= getTailOffset(list._capacity)) return list._tail;
    if (rawIndex < 1 << list._level + SHIFT) {
        var node = list._root;
        var level = list._level;
        while(node && level > 0){
            node = node.array[rawIndex >>> level & MASK];
            level -= SHIFT;
        }
        return node;
    }
}
/**
 * Validates requested bounds before int32 coercion in setListBounds().
 * Throws when origin/capacity would exceed the trie's safe range.
 */ function validateListBoundsRequest(list, begin, end) {
    var requestedOrigin = list._origin + (begin === undefined ? 0 : begin);
    var requestedCapacity = end === undefined ? list._capacity : end < 0 ? list._capacity + end : list._origin + end;
    // Keep origin/capacity within the trie's safe signed 32-bit range.
    if (Number.isFinite(requestedCapacity) && requestedCapacity > MAX_LIST_SIZE || Number.isFinite(requestedOrigin) && requestedOrigin < -MAX_LIST_SIZE || Number.isFinite(requestedCapacity) && Number.isFinite(requestedOrigin) && requestedCapacity - requestedOrigin > MAX_LIST_SIZE) throw new RangeError('Invalid List size: a List cannot hold more than ' + MAX_LIST_SIZE + ' (2 ** 30) values.');
}
function setListBounds(list, begin, end) {
    // Validate full-precision bounds before int32 coercion.
    validateListBoundsRequest(list, begin, end);
    // Sanitize begin & end using this shorthand for ToInt32(argument)
    // http://www.ecma-international.org/ecma-262/6.0/#sec-toint32
    if (begin !== undefined) begin |= 0;
    if (end !== undefined) end |= 0;
    var owner = list.__ownerID || new OwnerID();
    var oldOrigin = list._origin;
    var oldCapacity = list._capacity;
    var newOrigin = oldOrigin + begin;
    var newCapacity = end === undefined ? oldCapacity : end < 0 ? oldCapacity + end : oldOrigin + end;
    if (newOrigin === oldOrigin && newCapacity === oldCapacity) return list;
    // If it's going to end after it starts, it's empty.
    if (newOrigin >= newCapacity) return list.clear();
    var newLevel = list._level;
    var newRoot = list._root;
    // New origin might need creating a higher root.
    var offsetShift = 0;
    while(newOrigin + offsetShift < 0){
        newRoot = new VNode(newRoot && newRoot.array.length ? [
            undefined,
            newRoot
        ] : [], owner);
        newLevel += SHIFT;
        // Shift origin into non-negative space as trie height grows.
        offsetShift += levelCapacity(newLevel);
    }
    if (offsetShift) {
        newOrigin += offsetShift;
        oldOrigin += offsetShift;
        newCapacity += offsetShift;
        oldCapacity += offsetShift;
    }
    var oldTailOffset = getTailOffset(oldCapacity);
    var newTailOffset = getTailOffset(newCapacity);
    // New size might need creating a higher root.
    while(newTailOffset >= levelCapacity(newLevel + SHIFT)){
        newRoot = new VNode(newRoot && newRoot.array.length ? [
            newRoot
        ] : [], owner);
        newLevel += SHIFT;
    }
    // Locate or create the new tail.
    var oldTail = list._tail;
    var newTail = newTailOffset < oldTailOffset ? listNodeFor(list, newCapacity - 1) : newTailOffset > oldTailOffset ? new VNode([], owner) : oldTail;
    // Merge Tail into tree.
    if (oldTail && newTailOffset > oldTailOffset && newOrigin < oldCapacity && oldTail.array.length) {
        newRoot = editableVNode(newRoot, owner);
        var node = newRoot;
        for(var level = newLevel; level > SHIFT; level -= SHIFT){
            var idx = oldTailOffset >>> level & MASK;
            node = node.array[idx] = editableVNode(node.array[idx], owner);
        }
        node.array[oldTailOffset >>> SHIFT & MASK] = oldTail;
    }
    // If the size has been reduced, there's a chance the tail needs to be trimmed.
    if (newCapacity < oldCapacity) newTail = newTail && newTail.removeAfter(owner, 0, newCapacity);
    // If the new origin is within the tail, then we do not need a root.
    if (newOrigin >= newTailOffset) {
        newOrigin -= newTailOffset;
        newCapacity -= newTailOffset;
        newLevel = SHIFT;
        newRoot = undefined;
        newTail = newTail && newTail.removeBefore(owner, 0, newOrigin);
    // Otherwise, if the root has been trimmed, garbage collect.
    } else if (newOrigin > oldOrigin || newTailOffset < oldTailOffset) {
        offsetShift = 0;
        // Identify the new top root node of the subtree of the old root.
        while(newRoot){
            var beginIndex = newOrigin >>> newLevel & MASK;
            if (beginIndex !== newTailOffset >>> newLevel & MASK) break;
            if (beginIndex) offsetShift += (1 << newLevel) * beginIndex;
            newLevel -= SHIFT;
            newRoot = newRoot.array[beginIndex];
        }
        // Trim the new sides of the new root.
        if (newRoot && newOrigin > oldOrigin) newRoot = newRoot.removeBefore(owner, newLevel, newOrigin - offsetShift);
        if (newRoot && newTailOffset < oldTailOffset) newRoot = newRoot.removeAfter(owner, newLevel, newTailOffset - offsetShift);
        if (offsetShift) {
            newOrigin -= offsetShift;
            newCapacity -= offsetShift;
        }
    }
    if (list.__ownerID) {
        list.size = newCapacity - newOrigin;
        list._origin = newOrigin;
        list._capacity = newCapacity;
        list._level = newLevel;
        list._root = newRoot;
        list._tail = newTail;
        list.__hash = undefined;
        list.__altered = true;
        return list;
    }
    return makeList(newOrigin, newCapacity, newLevel, newRoot, newTail);
}
function getTailOffset(size) {
    return size < SIZE ? 0 : size - 1 >>> SHIFT << SHIFT;
}
// The largest number of values a List can hold. Above this the 32-bit trie math
// in setListBounds() stays in the safe signed 32-bit range.
var MAX_LIST_SIZE = Math.pow(2, 30); // 1073741824
/**
 * Computes 2 ** exp for the trie level-raising loops in setListBounds().
 * Use the cheap bitwise operator shift whenever possible, otherwise fall back to exponentiation.
 * This is necessary because bitwise operators in JavaScript only work on 32-bit signed integers, so for exp >= 31, we need to use exponentiation to avoid overflow.
 */ function levelCapacity(exp) {
    return exp < 31 ? 1 << exp : Math.pow(2, exp);
}
/**
 * True if `maybeOrderedMap` is an OrderedMap.
 */ function isOrderedMap(maybeOrderedMap) {
    return isMap(maybeOrderedMap) && isOrdered(maybeOrderedMap);
}
var OrderedMap = /*@__PURE__*/ function(Map) {
    function OrderedMap(value) {
        // eslint-disable-next-line no-constructor-return
        return value === undefined || value === null ? emptyOrderedMap() : isOrderedMap(value) ? value : emptyOrderedMap().withMutations(function(map) {
            var iter = KeyedCollection(value);
            assertNotInfinite(iter.size);
            iter.forEach(function(v, k) {
                return map.set(k, v);
            });
        });
    }
    if (Map) OrderedMap.__proto__ = Map;
    OrderedMap.prototype = Object.create(Map && Map.prototype);
    OrderedMap.prototype.constructor = OrderedMap;
    OrderedMap.of = function of() {
        return this(arguments);
    };
    OrderedMap.prototype.toString = function toString() {
        return this.__toString('OrderedMap {', '}');
    };
    // @pragma Access
    OrderedMap.prototype.get = function get(k, notSetValue) {
        var index = this._map.get(k);
        return index !== undefined ? this._list.get(index)[1] : notSetValue;
    };
    // @pragma Modification
    OrderedMap.prototype.clear = function clear() {
        if (this.size === 0) return this;
        if (this.__ownerID) {
            this.size = 0;
            this._map.clear();
            this._list.clear();
            this.__altered = true;
            return this;
        }
        return emptyOrderedMap();
    };
    OrderedMap.prototype.set = function set(k, v) {
        return updateOrderedMap(this, k, v);
    };
    OrderedMap.prototype.remove = function remove(k) {
        return updateOrderedMap(this, k, NOT_SET);
    };
    OrderedMap.prototype.__iterate = function __iterate(fn, reverse) {
        var this$1$1 = this;
        return this._list.__iterate(function(entry) {
            return entry && fn(entry[1], entry[0], this$1$1);
        }, reverse);
    };
    OrderedMap.prototype.__iterator = function __iterator(type, reverse) {
        return this._list.fromEntrySeq().__iterator(type, reverse);
    };
    OrderedMap.prototype.__ensureOwner = function __ensureOwner(ownerID) {
        if (ownerID === this.__ownerID) return this;
        var newMap = this._map.__ensureOwner(ownerID);
        var newList = this._list.__ensureOwner(ownerID);
        if (!ownerID) {
            if (this.size === 0) return emptyOrderedMap();
            this.__ownerID = ownerID;
            this.__altered = false;
            this._map = newMap;
            this._list = newList;
            return this;
        }
        return makeOrderedMap(newMap, newList, ownerID, this.__hash);
    };
    return OrderedMap;
}(Map);
OrderedMap.isOrderedMap = isOrderedMap;
OrderedMap.prototype[IS_ORDERED_SYMBOL] = true;
OrderedMap.prototype[DELETE] = OrderedMap.prototype.remove;
function makeOrderedMap(map, list, ownerID, hash) {
    var omap = Object.create(OrderedMap.prototype);
    omap.size = map ? map.size : 0;
    omap._map = map;
    omap._list = list;
    omap.__ownerID = ownerID;
    omap.__hash = hash;
    omap.__altered = false;
    return omap;
}
var EMPTY_ORDERED_MAP;
function emptyOrderedMap() {
    return EMPTY_ORDERED_MAP || (EMPTY_ORDERED_MAP = makeOrderedMap(emptyMap(), emptyList()));
}
function updateOrderedMap(omap, k, v) {
    var map = omap._map;
    var list = omap._list;
    var i = map.get(k);
    var has = i !== undefined;
    var newMap;
    var newList;
    if (v === NOT_SET) {
        // removed
        if (!has) return omap;
        if (list.size >= SIZE && list.size >= map.size * 2) {
            newList = list.filter(function(entry, idx) {
                return entry !== undefined && i !== idx;
            });
            newMap = newList.toKeyedSeq().map(function(entry) {
                return entry[0];
            }).flip().toMap();
            if (omap.__ownerID) newMap.__ownerID = newList.__ownerID = omap.__ownerID;
        } else {
            newMap = map.remove(k);
            newList = i === list.size - 1 ? list.pop() : list.set(i, undefined);
        }
    } else if (has) {
        if (v === list.get(i)[1]) return omap;
        newMap = map;
        newList = list.set(i, [
            k,
            v
        ]);
    } else {
        newMap = map.set(k, list.size);
        newList = list.set(list.size, [
            k,
            v
        ]);
    }
    if (omap.__ownerID) {
        omap.size = newMap.size;
        omap._map = newMap;
        omap._list = newList;
        omap.__hash = undefined;
        omap.__altered = true;
        return omap;
    }
    return makeOrderedMap(newMap, newList);
}
var IS_STACK_SYMBOL = '@@__IMMUTABLE_STACK__@@';
/**
 * True if `maybeStack` is a Stack.
 */ function isStack(maybeStack) {
    return Boolean(maybeStack && // @ts-expect-error: maybeStack is typed as `{}`, need to change in 6.0 to `maybeStack && typeof maybeStack === 'object' && MAYBE_STACK_SYMBOL in maybeStack`
    maybeStack[IS_STACK_SYMBOL]);
}
var Stack = /*@__PURE__*/ function(IndexedCollection) {
    function Stack(value) {
        // eslint-disable-next-line no-constructor-return
        return value === undefined || value === null ? emptyStack() : isStack(value) ? value : emptyStack().pushAll(value);
    }
    if (IndexedCollection) Stack.__proto__ = IndexedCollection;
    Stack.prototype = Object.create(IndexedCollection && IndexedCollection.prototype);
    Stack.prototype.constructor = Stack;
    Stack.of = function of() {
        return this(arguments);
    };
    Stack.prototype.toString = function toString() {
        return this.__toString('Stack [', ']');
    };
    // @pragma Access
    Stack.prototype.get = function get(index, notSetValue) {
        var head = this._head;
        index = wrapIndex(this, index);
        while(head && index--)head = head.next;
        return head ? head.value : notSetValue;
    };
    Stack.prototype.peek = function peek() {
        return this._head && this._head.value;
    };
    // @pragma Modification
    Stack.prototype.push = function push() {
        var arguments$1 = arguments;
        if (arguments.length === 0) return this;
        var newSize = this.size + arguments.length;
        var head = this._head;
        for(var ii = arguments.length - 1; ii >= 0; ii--)head = {
            value: arguments$1[ii],
            next: head
        };
        if (this.__ownerID) {
            this.size = newSize;
            this._head = head;
            this.__hash = undefined;
            this.__altered = true;
            return this;
        }
        return makeStack(newSize, head);
    };
    Stack.prototype.pushAll = function pushAll(iter) {
        iter = IndexedCollection(iter);
        if (iter.size === 0) return this;
        if (this.size === 0 && isStack(iter)) return iter;
        assertNotInfinite(iter.size);
        var newSize = this.size;
        var head = this._head;
        iter.__iterate(function(value) {
            newSize++;
            head = {
                value: value,
                next: head
            };
        }, /* reverse */ true);
        if (this.__ownerID) {
            this.size = newSize;
            this._head = head;
            this.__hash = undefined;
            this.__altered = true;
            return this;
        }
        return makeStack(newSize, head);
    };
    Stack.prototype.pop = function pop() {
        return this.slice(1);
    };
    Stack.prototype.clear = function clear() {
        if (this.size === 0) return this;
        if (this.__ownerID) {
            this.size = 0;
            this._head = undefined;
            this.__hash = undefined;
            this.__altered = true;
            return this;
        }
        return emptyStack();
    };
    Stack.prototype.slice = function slice(begin, end) {
        if (wholeSlice(begin, end, this.size)) return this;
        var resolvedBegin = resolveBegin(begin, this.size);
        var resolvedEnd = resolveEnd(end, this.size);
        if (resolvedEnd !== this.size) // super.slice(begin, end);
        return IndexedCollection.prototype.slice.call(this, begin, end);
        var newSize = this.size - resolvedBegin;
        var head = this._head;
        while(resolvedBegin--)head = head.next;
        if (this.__ownerID) {
            this.size = newSize;
            this._head = head;
            this.__hash = undefined;
            this.__altered = true;
            return this;
        }
        return makeStack(newSize, head);
    };
    // @pragma Mutability
    Stack.prototype.__ensureOwner = function __ensureOwner(ownerID) {
        if (ownerID === this.__ownerID) return this;
        if (!ownerID) {
            if (this.size === 0) return emptyStack();
            this.__ownerID = ownerID;
            this.__altered = false;
            return this;
        }
        return makeStack(this.size, this._head, ownerID, this.__hash);
    };
    // @pragma Iteration
    Stack.prototype.__iterate = function __iterate(fn, reverse) {
        var this$1$1 = this;
        if (reverse) return new ArraySeq(this.toArray()).__iterate(function(v, k) {
            return fn(v, k, this$1$1);
        }, reverse);
        var iterations = 0;
        var node = this._head;
        while(node){
            if (fn(node.value, iterations++, this) === false) break;
            node = node.next;
        }
        return iterations;
    };
    Stack.prototype.__iterator = function __iterator(type, reverse) {
        if (reverse) return new ArraySeq(this.toArray()).__iterator(type, reverse);
        var iterations = 0;
        var node = this._head;
        return new Iterator(function() {
            if (node) {
                var value = node.value;
                node = node.next;
                return iteratorValue(type, iterations++, value);
            }
            return iteratorDone();
        });
    };
    return Stack;
}(IndexedCollection);
Stack.isStack = isStack;
var StackPrototype = Stack.prototype;
StackPrototype[IS_STACK_SYMBOL] = true;
StackPrototype.shift = StackPrototype.pop;
StackPrototype.unshift = StackPrototype.push;
StackPrototype.unshiftAll = StackPrototype.pushAll;
StackPrototype.withMutations = withMutations;
StackPrototype.wasAltered = wasAltered;
StackPrototype.asImmutable = asImmutable;
StackPrototype['@@transducer/init'] = StackPrototype.asMutable = asMutable;
StackPrototype['@@transducer/step'] = function(result, arr) {
    return result.unshift(arr);
};
StackPrototype['@@transducer/result'] = function(obj) {
    return obj.asImmutable();
};
function makeStack(size, head, ownerID, hash) {
    var map = Object.create(StackPrototype);
    map.size = size;
    map._head = head;
    map.__ownerID = ownerID;
    map.__hash = hash;
    map.__altered = false;
    return map;
}
var EMPTY_STACK;
function emptyStack() {
    return EMPTY_STACK || (EMPTY_STACK = makeStack(0));
}
function reduce(collection, reducer, reduction, context, useFirst, reverse) {
    // @ts-expect-error Migrate to CollectionImpl in v6
    assertNotInfinite(collection.size);
    // @ts-expect-error Migrate to CollectionImpl in v6
    collection.__iterate(function(v, k, c) {
        if (useFirst) {
            useFirst = false;
            reduction = v;
        } else // `reduction` has already been seeded here (either with the provided
        // initial value or with the first iterated value), so it is never the
        // `undefined` placeholder — only a `V` or a `R`.
        reduction = reducer.call(context, reduction, v, k, c);
    }, reverse);
    return reduction;
}
function keyMapper(v, k) {
    return k;
}
function entryMapper(v, k) {
    return [
        k,
        v
    ];
}
function not(predicate) {
    return function() {
        var args = [], len = arguments.length;
        while(len--)args[len] = arguments[len];
        return !predicate.apply(this, args);
    };
}
function neg(predicate) {
    return function() {
        var args = [], len = arguments.length;
        while(len--)args[len] = arguments[len];
        return -predicate.apply(this, args);
    };
}
function defaultNegComparator(a, b) {
    return a < b ? 1 : a > b ? -1 : 0;
}
function deepEqual(a, b) {
    if (a === b) return true;
    if (!isCollection(b) || // @ts-expect-error size should exists on Collection
    a.size !== undefined && b.size !== undefined && a.size !== b.size || // @ts-expect-error __hash exists on Collection
    a.__hash !== undefined && // @ts-expect-error __hash exists on Collection
    b.__hash !== undefined && // @ts-expect-error __hash exists on Collection
    a.__hash !== b.__hash || isKeyed(a) !== isKeyed(b) || isIndexed(a) !== isIndexed(b) || // @ts-expect-error Range extends Collection, which implements [Symbol.iterator], so it is valid
    isOrdered(a) !== isOrdered(b)) return false;
    // @ts-expect-error size should exists on Collection
    if (a.size === 0 && b.size === 0) return true;
    var notAssociative = !isAssociative(a);
    // @ts-expect-error Range extends Collection, which implements [Symbol.iterator], so it is valid
    if (isOrdered(a)) {
        var entries = a.entries();
        // @ts-expect-error need to cast as boolean
        return b.every(function(v, k) {
            var entry = entries.next().value;
            return entry && is(entry[1], v) && (notAssociative || is(entry[0], k));
        }) && entries.next().done;
    }
    var flipped = false;
    if (a.size === undefined) {
        // @ts-expect-error size should exists on Collection
        if (b.size === undefined) {
            if (typeof a.cacheResult === 'function') a.cacheResult();
        } else {
            flipped = true;
            var _ = a;
            a = b;
            b = _;
        }
    }
    var allEqual = true;
    var bSize = // @ts-expect-error b is Range | Repeat | Collection<unknown, unknown> as it may have been flipped, and __iterate is valid
    b.__iterate(function(v, k) {
        if (notAssociative ? !a.has(v) : flipped ? !is(v, a.get(k, NOT_SET)) : !is(a.get(k, NOT_SET), v)) {
            allEqual = false;
            return false;
        }
    });
    return allEqual && // @ts-expect-error size should exists on Collection
    a.size === bSize;
}
/**
 * Returns a lazy seq of nums from start (inclusive) to end
 * (exclusive), by step, where start defaults to 0, step to 1, and end to
 * infinity. When start is equal to end, returns empty list.
 */ var Range = /*@__PURE__*/ function(IndexedSeq) {
    function Range(start, end, step) {
        if (step === void 0) step = 1;
        if (!(this instanceof Range)) // eslint-disable-next-line no-constructor-return
        return new Range(start, end, step);
        invariant(step !== 0, 'Cannot step a Range by 0');
        invariant(start !== undefined, 'You must define a start value when using Range');
        invariant(end !== undefined, 'You must define an end value when using Range');
        step = Math.abs(step);
        if (end < start) step = -step;
        this._start = start;
        this._end = end;
        this._step = step;
        this.size = Math.max(0, Math.ceil((end - start) / step - 1) + 1);
        if (this.size === 0) {
            if (EMPTY_RANGE) // eslint-disable-next-line no-constructor-return
            return EMPTY_RANGE;
            // eslint-disable-next-line @typescript-eslint/no-this-alias
            EMPTY_RANGE = this;
        }
    }
    if (IndexedSeq) Range.__proto__ = IndexedSeq;
    Range.prototype = Object.create(IndexedSeq && IndexedSeq.prototype);
    Range.prototype.constructor = Range;
    Range.prototype.toString = function toString() {
        return this.size === 0 ? 'Range []' : "Range [ " + this._start + "..." + this._end + (this._step !== 1 ? ' by ' + this._step : '') + " ]";
    };
    Range.prototype.get = function get(index, notSetValue) {
        return this.has(index) ? this._start + wrapIndex(this, index) * this._step : notSetValue;
    };
    Range.prototype.includes = function includes(searchValue) {
        var possibleIndex = (searchValue - this._start) / this._step;
        return possibleIndex >= 0 && possibleIndex < this.size && possibleIndex === Math.floor(possibleIndex);
    };
    Range.prototype.slice = function slice(begin, end) {
        if (wholeSlice(begin, end, this.size)) return this;
        begin = resolveBegin(begin, this.size);
        end = resolveEnd(end, this.size);
        if (end <= begin) return new Range(0, 0);
        return new Range(this.get(begin, this._end), this.get(end, this._end), this._step);
    };
    Range.prototype.indexOf = function indexOf(searchValue) {
        var offsetValue = searchValue - this._start;
        if (offsetValue % this._step === 0) {
            var index = offsetValue / this._step;
            if (index >= 0 && index < this.size) return index;
        }
        return -1;
    };
    Range.prototype.lastIndexOf = function lastIndexOf(searchValue) {
        return this.indexOf(searchValue);
    };
    Range.prototype.__iterate = function __iterate(fn, reverse) {
        var size = this.size;
        var step = this._step;
        var value = reverse ? this._start + (size - 1) * step : this._start;
        var i = 0;
        while(i !== size){
            if (fn(value, reverse ? size - ++i : i++, this) === false) break;
            value += reverse ? -step : step;
        }
        return i;
    };
    Range.prototype.__iterator = function __iterator(type, reverse) {
        var size = this.size;
        var step = this._step;
        var value = reverse ? this._start + (size - 1) * step : this._start;
        var i = 0;
        return new Iterator(function() {
            if (i === size) return iteratorDone();
            var v = value;
            value += reverse ? -step : step;
            return iteratorValue(type, reverse ? size - ++i : i++, v);
        });
    };
    Range.prototype.equals = function equals(other) {
        return other instanceof Range ? this._start === other._start && this._end === other._end && this._step === other._step : deepEqual(this, other);
    };
    return Range;
}(IndexedSeq);
var EMPTY_RANGE;
var IS_SET_SYMBOL = '@@__IMMUTABLE_SET__@@';
/**
 * True if `maybeSet` is a Set.
 *
 * Also true for OrderedSets.
 */ function isSet(maybeSet) {
    return Boolean(maybeSet && // @ts-expect-error: maybeSet is typed as `{}`,  need to change in 6.0 to `maybeSeq && typeof maybeSet === 'object' && MAYBE_SET_SYMBOL in maybeSet`
    maybeSet[IS_SET_SYMBOL]);
}
var Set = /*@__PURE__*/ function(SetCollection) {
    function Set(value) {
        // eslint-disable-next-line no-constructor-return
        return value === undefined || value === null ? emptySet() : isSet(value) && !isOrdered(value) ? value : emptySet().withMutations(function(set) {
            var iter = SetCollection(value);
            assertNotInfinite(iter.size);
            iter.forEach(function(v) {
                return set.add(v);
            });
        });
    }
    if (SetCollection) Set.__proto__ = SetCollection;
    Set.prototype = Object.create(SetCollection && SetCollection.prototype);
    Set.prototype.constructor = Set;
    Set.of = function of() {
        return this(arguments);
    };
    Set.fromKeys = function fromKeys(value) {
        return this(KeyedCollection(value).keySeq());
    };
    Set.intersect = function intersect(sets) {
        sets = Collection(sets).toArray();
        return sets.length ? SetPrototype.intersect.apply(Set(sets.pop()), sets) : emptySet();
    };
    Set.union = function union(sets) {
        sets = Collection(sets).toArray();
        return sets.length ? SetPrototype.union.apply(Set(sets.pop()), sets) : emptySet();
    };
    Set.prototype.toString = function toString() {
        return this.__toString('Set {', '}');
    };
    // @pragma Access
    Set.prototype.has = function has(value) {
        return this._map.has(value);
    };
    // @pragma Modification
    Set.prototype.add = function add(value) {
        return updateSet(this, this._map.set(value, value));
    };
    Set.prototype.remove = function remove(value) {
        return updateSet(this, this._map.remove(value));
    };
    Set.prototype.clear = function clear() {
        return updateSet(this, this._map.clear());
    };
    // @pragma Composition
    Set.prototype.map = function map(mapper, context) {
        var this$1$1 = this;
        // keep track if the set is altered by the map function
        var didChanges = false;
        var newMap = updateSet(this, this._map.mapEntries(function(ref) {
            var v = ref[1];
            var mapped = mapper.call(context, v, v, this$1$1);
            if (mapped !== v) didChanges = true;
            return [
                mapped,
                mapped
            ];
        }, context));
        return didChanges ? newMap : this;
    };
    Set.prototype.union = function union() {
        var iters = [], len = arguments.length;
        while(len--)iters[len] = arguments[len];
        iters = iters.filter(function(x) {
            return x.size !== 0;
        });
        if (iters.length === 0) return this;
        if (this.size === 0 && !this.__ownerID && iters.length === 1) return this.constructor(iters[0]);
        return this.withMutations(function(set) {
            for(var ii = 0; ii < iters.length; ii++)if (typeof iters[ii] === 'string') set.add(iters[ii]);
            else SetCollection(iters[ii]).forEach(function(value) {
                return set.add(value);
            });
        });
    };
    Set.prototype.intersect = function intersect() {
        var iters = [], len = arguments.length;
        while(len--)iters[len] = arguments[len];
        if (iters.length === 0) return this;
        iters = iters.map(function(iter) {
            return SetCollection(iter);
        });
        var toRemove = [];
        this.forEach(function(value) {
            if (!iters.every(function(iter) {
                return iter.includes(value);
            })) toRemove.push(value);
        });
        return this.withMutations(function(set) {
            toRemove.forEach(function(value) {
                set.remove(value);
            });
        });
    };
    Set.prototype.subtract = function subtract() {
        var iters = [], len = arguments.length;
        while(len--)iters[len] = arguments[len];
        if (iters.length === 0) return this;
        iters = iters.map(function(iter) {
            return SetCollection(iter);
        });
        var toRemove = [];
        this.forEach(function(value) {
            if (iters.some(function(iter) {
                return iter.includes(value);
            })) toRemove.push(value);
        });
        return this.withMutations(function(set) {
            toRemove.forEach(function(value) {
                set.remove(value);
            });
        });
    };
    Set.prototype.sort = function sort(comparator) {
        // Late binding
        return OrderedSet(sortFactory(this, comparator));
    };
    Set.prototype.sortBy = function sortBy(mapper, comparator) {
        // Late binding
        return OrderedSet(sortFactory(this, comparator, mapper));
    };
    Set.prototype.wasAltered = function wasAltered() {
        return this._map.wasAltered();
    };
    Set.prototype.__iterate = function __iterate(fn, reverse) {
        var this$1$1 = this;
        return this._map.__iterate(function(k) {
            return fn(k, k, this$1$1);
        }, reverse);
    };
    Set.prototype.__iterator = function __iterator(type, reverse) {
        return this._map.__iterator(type, reverse);
    };
    Set.prototype.__ensureOwner = function __ensureOwner(ownerID) {
        if (ownerID === this.__ownerID) return this;
        var newMap = this._map.__ensureOwner(ownerID);
        if (!ownerID) {
            if (this.size === 0) return this.__empty();
            this.__ownerID = ownerID;
            this._map = newMap;
            return this;
        }
        return this.__make(newMap, ownerID);
    };
    return Set;
}(SetCollection);
Set.isSet = isSet;
var SetPrototype = Set.prototype;
SetPrototype[IS_SET_SYMBOL] = true;
SetPrototype[DELETE] = SetPrototype.remove;
SetPrototype.merge = SetPrototype.concat = SetPrototype.union;
SetPrototype.withMutations = withMutations;
SetPrototype.asImmutable = asImmutable;
SetPrototype['@@transducer/init'] = SetPrototype.asMutable = asMutable;
SetPrototype['@@transducer/step'] = function(result, arr) {
    return result.add(arr);
};
SetPrototype['@@transducer/result'] = function(obj) {
    return obj.asImmutable();
};
SetPrototype.__empty = emptySet;
SetPrototype.__make = makeSet;
function updateSet(set, newMap) {
    if (set.__ownerID) {
        set.size = newMap.size;
        set._map = newMap;
        return set;
    }
    return newMap === set._map ? set : newMap.size === 0 ? set.__empty() : set.__make(newMap);
}
function makeSet(map, ownerID) {
    var set = Object.create(SetPrototype);
    set.size = map ? map.size : 0;
    set._map = map;
    set.__ownerID = ownerID;
    return set;
}
var EMPTY_SET;
function emptySet() {
    return EMPTY_SET || (EMPTY_SET = makeSet(emptyMap()));
}
/**
 * Returns the value at the provided key path starting at the provided
 * collection, or notSetValue if the key path is not defined.
 *
 * A functional alternative to `collection.getIn(keypath)` which will also
 * work with plain Objects and Arrays.
 */ function getIn$1(collection, searchKeyPath, notSetValue) {
    var keyPath = coerceKeyPath(searchKeyPath);
    var i = 0;
    while(i !== keyPath.length){
        // @ts-expect-error keyPath[i++] can not be undefined by design
        collection = get(collection, keyPath[i++], NOT_SET);
        if (collection === NOT_SET) return notSetValue;
    }
    return collection;
}
function getIn(searchKeyPath, notSetValue) {
    return getIn$1(this, searchKeyPath, notSetValue);
}
/**
 * Returns true if the key path is defined in the provided collection.
 *
 * A functional alternative to `collection.hasIn(keypath)` which will also
 * work with plain Objects and Arrays.
 */ function hasIn$1(collection, keyPath) {
    return getIn$1(collection, keyPath, NOT_SET) !== NOT_SET;
}
function hasIn(searchKeyPath) {
    return hasIn$1(this, searchKeyPath);
}
function toObject() {
    assertNotInfinite(this.size);
    var object = {};
    this.__iterate(function(v, k) {
        if (isProtoKey(k)) return;
        object[k] = v;
    });
    return object;
}
function toJS(value) {
    if (!value || (typeof value === "undefined" ? "undefined" : (0, $6tOPT._)(value)) !== 'object') return value;
    if (!isCollection(value)) {
        if (!isDataStructure(value)) return value;
        // @ts-expect-error until Seq has been migrated to TypeScript
        value = Seq(value);
    }
    if (isKeyed(value)) {
        var result$1 = {};
        // @ts-expect-error `__iterate` exists on all Keyed collections but method is not defined in the type
        value.__iterate(function(v, k) {
            if (isProtoKey(k)) return;
            result$1[k] = toJS(v);
        });
        return result$1;
    }
    var result = [];
    // @ts-expect-error value "should" be a non-keyed collection, but we may need to assert for stricter types
    value.__iterate(function(v) {
        result.push(toJS(v));
    });
    return result;
}
function hashCollection(collection) {
    // @ts-expect-error Migrate to CollectionImpl in v6
    if (collection.size === Infinity) return 0;
    var ordered = isOrdered(collection);
    var keyed = isKeyed(collection);
    var h = ordered ? 1 : 0;
    // @ts-expect-error Migrate to CollectionImpl in v6
    collection.__iterate(keyed ? ordered ? function(v, k) {
        h = 31 * h + hashMerge(hash(v), hash(k)) | 0;
    } : function(v, k) {
        h = h + hashMerge(hash(v), hash(k)) | 0;
    } : ordered ? function(v) {
        h = 31 * h + hash(v) | 0;
    } : function(v) {
        h = h + hash(v) | 0;
    });
    // @ts-expect-error Migrate to CollectionImpl in v6
    return murmurHashOfSize(collection.size, h);
}
function murmurHashOfSize(size, h) {
    h = imul(h, 0xcc9e2d51);
    h = imul(h << 15 | h >>> -15, 0x1b873593);
    h = imul(h << 13 | h >>> -13, 5);
    h = (h + 0xe6546b64 | 0) ^ size;
    h = imul(h ^ h >>> 16, 0x85ebca6b);
    h = imul(h ^ h >>> 13, 0xc2b2ae35);
    h = smi(h ^ h >>> 16);
    return h;
}
function hashMerge(a, b) {
    return a ^ b + 0x9e3779b9 + (a << 6) + (a >> 2) | 0; // int
}
/**
 * Contributes additional methods to a constructor
 */ function mixin(ctor, // eslint-disable-next-line @typescript-eslint/no-unsafe-function-type
methods) {
    var keyCopier = function keyCopier(key) {
        // @ts-expect-error how to handle symbol ?
        ctor.prototype[key] = methods[key];
    };
    Object.keys(methods).forEach(keyCopier);
    // eslint-disable-next-line @typescript-eslint/no-unused-expressions -- TODO enable eslint here
    Object.getOwnPropertySymbols && Object.getOwnPropertySymbols(methods).forEach(keyCopier);
    return ctor;
}
Collection.Iterator = Iterator;
mixin(Collection, {
    // ### Conversion to other types
    toArray: function toArray() {
        assertNotInfinite(this.size);
        var array = new Array(this.size || 0);
        var useTuples = isKeyed(this);
        var i = 0;
        this.__iterate(function(v, k) {
            // Keyed collections produce an array of tuples.
            array[i++] = useTuples ? [
                k,
                v
            ] : v;
        });
        return array;
    },
    toIndexedSeq: function toIndexedSeq() {
        return new ToIndexedSequence(this);
    },
    toJS: function toJS$1() {
        return toJS(this);
    },
    toKeyedSeq: function toKeyedSeq() {
        return new ToKeyedSequence(this, true);
    },
    toMap: function toMap() {
        // Use Late Binding here to solve the circular dependency.
        return Map(this.toKeyedSeq());
    },
    toObject: toObject,
    toOrderedMap: function toOrderedMap() {
        // Use Late Binding here to solve the circular dependency.
        return OrderedMap(this.toKeyedSeq());
    },
    toOrderedSet: function toOrderedSet() {
        // Use Late Binding here to solve the circular dependency.
        return OrderedSet(isKeyed(this) ? this.valueSeq() : this);
    },
    toSet: function toSet() {
        // Use Late Binding here to solve the circular dependency.
        return Set(isKeyed(this) ? this.valueSeq() : this);
    },
    toSetSeq: function toSetSeq() {
        return new ToSetSequence(this);
    },
    toSeq: function toSeq() {
        return isIndexed(this) ? this.toIndexedSeq() : isKeyed(this) ? this.toKeyedSeq() : this.toSetSeq();
    },
    toStack: function toStack() {
        // Use Late Binding here to solve the circular dependency.
        return Stack(isKeyed(this) ? this.valueSeq() : this);
    },
    toList: function toList() {
        // Use Late Binding here to solve the circular dependency.
        return List(isKeyed(this) ? this.valueSeq() : this);
    },
    // ### Common JavaScript methods and properties
    toString: function toString() {
        return '[Collection]';
    },
    __toString: function __toString(head, tail) {
        if (this.size === 0) return head + tail;
        return head + ' ' + this.toSeq().map(this.__toStringMapper).join(', ') + ' ' + tail;
    },
    // ### ES6 Collection methods (ES6 Array and Map)
    concat: function concat() {
        var values = [], len = arguments.length;
        while(len--)values[len] = arguments[len];
        return reify(this, concatFactory(this, values));
    },
    includes: function includes(searchValue) {
        return this.some(function(value) {
            return is(value, searchValue);
        });
    },
    entries: function entries() {
        return this.__iterator(ITERATE_ENTRIES);
    },
    every: function every(predicate, context) {
        assertNotInfinite(this.size);
        var returnValue = true;
        this.__iterate(function(v, k, c) {
            if (!predicate.call(context, v, k, c)) {
                returnValue = false;
                return false;
            }
        });
        return returnValue;
    },
    filter: function filter(predicate, context) {
        return reify(this, filterFactory(this, predicate, context, true));
    },
    partition: function partition(predicate, context) {
        return partitionFactory(this, predicate, context);
    },
    find: function find(predicate, context, notSetValue) {
        var entry = this.findEntry(predicate, context);
        return entry ? entry[1] : notSetValue;
    },
    forEach: function forEach(sideEffect, context) {
        assertNotInfinite(this.size);
        return this.__iterate(context ? sideEffect.bind(context) : sideEffect);
    },
    join: function join(separator) {
        assertNotInfinite(this.size);
        separator = separator !== undefined ? '' + separator : ',';
        var joined = '';
        var isFirst = true;
        this.__iterate(function(v) {
            // eslint-disable-next-line @typescript-eslint/no-unused-expressions -- TODO enable eslint here
            isFirst ? isFirst = false : joined += separator;
            joined += v !== null && v !== undefined ? v.toString() : '';
        });
        return joined;
    },
    keys: function keys() {
        return this.__iterator(ITERATE_KEYS);
    },
    map: function map(mapper, context) {
        return reify(this, mapFactory(this, mapper, context));
    },
    reduce: function reduce$1(reducer, initialReduction, context) {
        return reduce(this, reducer, initialReduction, context, arguments.length < 2, false);
    },
    reduceRight: function reduceRight(reducer, initialReduction, context) {
        return reduce(this, reducer, initialReduction, context, arguments.length < 2, true);
    },
    reverse: function reverse() {
        return reify(this, reverseFactory(this, true));
    },
    slice: function slice(begin, end) {
        return reify(this, sliceFactory(this, begin, end, true));
    },
    some: function some(predicate, context) {
        assertNotInfinite(this.size);
        var returnValue = false;
        this.__iterate(function(v, k, c) {
            if (predicate.call(context, v, k, c)) {
                returnValue = true;
                return false;
            }
        });
        return returnValue;
    },
    sort: function sort(comparator) {
        return reify(this, sortFactory(this, comparator));
    },
    values: function values() {
        return this.__iterator(ITERATE_VALUES);
    },
    // ### More sequential methods
    butLast: function butLast() {
        return this.slice(0, -1);
    },
    isEmpty: function isEmpty() {
        return this.size !== undefined ? this.size === 0 : !this.some(function() {
            return true;
        });
    },
    count: function count(predicate, context) {
        return ensureSize(predicate ? this.toSeq().filter(predicate, context) : this);
    },
    countBy: function countBy(grouper, context) {
        return countByFactory(this, grouper, context);
    },
    equals: function equals(other) {
        return deepEqual(this, other);
    },
    entrySeq: function entrySeq() {
        // eslint-disable-next-line @typescript-eslint/no-this-alias
        var collection = this;
        if (collection._cache) // We cache as an entries array, so we can just return the cache!
        return new ArraySeq(collection._cache);
        var entriesSequence = collection.toSeq().map(entryMapper).toIndexedSeq();
        entriesSequence.fromEntrySeq = function() {
            return collection.toSeq();
        };
        return entriesSequence;
    },
    filterNot: function filterNot(predicate, context) {
        return this.filter(not(predicate), context);
    },
    findEntry: function findEntry(predicate, context, notSetValue) {
        var found = notSetValue;
        this.__iterate(function(v, k, c) {
            if (predicate.call(context, v, k, c)) {
                found = [
                    k,
                    v
                ];
                return false;
            }
        });
        return found;
    },
    findKey: function findKey(predicate, context) {
        var entry = this.findEntry(predicate, context);
        return entry && entry[0];
    },
    findLast: function findLast(predicate, context, notSetValue) {
        return this.toKeyedSeq().reverse().find(predicate, context, notSetValue);
    },
    findLastEntry: function findLastEntry(predicate, context, notSetValue) {
        return this.toKeyedSeq().reverse().findEntry(predicate, context, notSetValue);
    },
    findLastKey: function findLastKey(predicate, context) {
        return this.toKeyedSeq().reverse().findKey(predicate, context);
    },
    first: function first(notSetValue) {
        return this.find(returnTrue, null, notSetValue);
    },
    flatMap: function flatMap(mapper, context) {
        return reify(this, flatMapFactory(this, mapper, context));
    },
    flatten: function flatten(depth) {
        return reify(this, flattenFactory(this, depth, true));
    },
    fromEntrySeq: function fromEntrySeq() {
        return new FromEntriesSequence(this);
    },
    get: function get(searchKey, notSetValue) {
        return this.find(function(_, key) {
            return is(key, searchKey);
        }, undefined, notSetValue);
    },
    getIn: getIn,
    groupBy: function groupBy(grouper, context) {
        return groupByFactory(this, grouper, context);
    },
    has: function has(searchKey) {
        return this.get(searchKey, NOT_SET) !== NOT_SET;
    },
    hasIn: hasIn,
    isSubset: function isSubset(iter) {
        iter = typeof iter.includes === 'function' ? iter : Collection(iter);
        return this.every(function(value) {
            return iter.includes(value);
        });
    },
    isSuperset: function isSuperset(iter) {
        iter = typeof iter.isSubset === 'function' ? iter : Collection(iter);
        return iter.isSubset(this);
    },
    keyOf: function keyOf(searchValue) {
        return this.findKey(function(value) {
            return is(value, searchValue);
        });
    },
    keySeq: function keySeq() {
        return this.toSeq().map(keyMapper).toIndexedSeq();
    },
    last: function last(notSetValue) {
        return this.toSeq().reverse().first(notSetValue);
    },
    lastKeyOf: function lastKeyOf(searchValue) {
        return this.toKeyedSeq().reverse().keyOf(searchValue);
    },
    max: function max(comparator) {
        return maxFactory(this, comparator);
    },
    maxBy: function maxBy(mapper, comparator) {
        return maxFactory(this, comparator, mapper);
    },
    min: function min(comparator) {
        return maxFactory(this, comparator ? neg(comparator) : defaultNegComparator);
    },
    minBy: function minBy(mapper, comparator) {
        return maxFactory(this, comparator ? neg(comparator) : defaultNegComparator, mapper);
    },
    rest: function rest() {
        return this.slice(1);
    },
    skip: function skip(amount) {
        return amount === 0 ? this : this.slice(Math.max(0, amount));
    },
    skipLast: function skipLast(amount) {
        return amount === 0 ? this : this.slice(0, -Math.max(0, amount));
    },
    skipWhile: function skipWhile(predicate, context) {
        return reify(this, skipWhileFactory(this, predicate, context, true));
    },
    skipUntil: function skipUntil(predicate, context) {
        return this.skipWhile(not(predicate), context);
    },
    sortBy: function sortBy(mapper, comparator) {
        return reify(this, sortFactory(this, comparator, mapper));
    },
    take: function take(amount) {
        return this.slice(0, Math.max(0, amount));
    },
    takeLast: function takeLast(amount) {
        return this.slice(-Math.max(0, amount));
    },
    takeWhile: function takeWhile(predicate, context) {
        return reify(this, takeWhileFactory(this, predicate, context));
    },
    takeUntil: function takeUntil(predicate, context) {
        return this.takeWhile(not(predicate), context);
    },
    update: function update(fn) {
        return fn(this);
    },
    valueSeq: function valueSeq() {
        return this.toIndexedSeq();
    },
    // ### Hashable Object
    hashCode: function hashCode() {
        return this.__hash || (this.__hash = hashCollection(this));
    }
});
var CollectionPrototype = Collection.prototype;
CollectionPrototype[IS_COLLECTION_SYMBOL] = true;
CollectionPrototype[ITERATOR_SYMBOL] = CollectionPrototype.values;
CollectionPrototype.toJSON = CollectionPrototype.toArray;
CollectionPrototype.__toStringMapper = quoteString;
CollectionPrototype.inspect = CollectionPrototype.toSource = function() {
    return this.toString();
};
CollectionPrototype.chain = CollectionPrototype.flatMap;
CollectionPrototype.contains = CollectionPrototype.includes;
mixin(KeyedCollection, {
    // ### More sequential methods
    flip: function flip() {
        return reify(this, flipFactory(this));
    },
    mapEntries: function mapEntries(mapper, context) {
        var this$1$1 = this;
        var iterations = 0;
        return reify(this, this.toSeq().map(function(v, k) {
            return mapper.call(context, [
                k,
                v
            ], iterations++, this$1$1);
        }).fromEntrySeq());
    },
    mapKeys: function mapKeys(mapper, context) {
        var this$1$1 = this;
        return reify(this, this.toSeq().flip().map(function(k, v) {
            return mapper.call(context, k, v, this$1$1);
        }).flip());
    }
});
var KeyedCollectionPrototype = KeyedCollection.prototype;
KeyedCollectionPrototype[IS_KEYED_SYMBOL] = true;
KeyedCollectionPrototype[ITERATOR_SYMBOL] = CollectionPrototype.entries;
KeyedCollectionPrototype.toJSON = toObject;
KeyedCollectionPrototype.__toStringMapper = function(v, k) {
    return quoteString(k) + ': ' + quoteString(v);
};
mixin(IndexedCollection, {
    // ### Conversion to other types
    toKeyedSeq: function toKeyedSeq() {
        return new ToKeyedSequence(this, false);
    },
    // ### ES6 Collection methods (ES6 Array and Map)
    filter: function filter(predicate, context) {
        return reify(this, filterFactory(this, predicate, context, false));
    },
    findIndex: function findIndex(predicate, context) {
        var entry = this.findEntry(predicate, context);
        return entry ? entry[0] : -1;
    },
    indexOf: function indexOf(searchValue) {
        var key = this.keyOf(searchValue);
        return key === undefined ? -1 : key;
    },
    lastIndexOf: function lastIndexOf(searchValue) {
        var key = this.lastKeyOf(searchValue);
        return key === undefined ? -1 : key;
    },
    reverse: function reverse() {
        return reify(this, reverseFactory(this, false));
    },
    slice: function slice(begin, end) {
        return reify(this, sliceFactory(this, begin, end, false));
    },
    splice: function splice(index, removeNum /*, ...values*/ ) {
        var numArgs = arguments.length;
        removeNum = Math.max(removeNum || 0, 0);
        if (numArgs === 0 || numArgs === 2 && !removeNum) return this;
        // If index is negative, it should resolve relative to the size of the
        // collection. However size may be expensive to compute if not cached, so
        // only call count() if the number is in fact negative.
        index = resolveBegin(index, index < 0 ? this.count() : this.size);
        var spliced = this.slice(0, index);
        return reify(this, numArgs === 1 ? spliced : spliced.concat(arrCopy(arguments, 2), this.slice(index + removeNum)));
    },
    // ### More collection methods
    findLastIndex: function findLastIndex(predicate, context) {
        var entry = this.findLastEntry(predicate, context);
        return entry ? entry[0] : -1;
    },
    first: function first(notSetValue) {
        return this.get(0, notSetValue);
    },
    flatten: function flatten(depth) {
        return reify(this, flattenFactory(this, depth, false));
    },
    get: function get(index, notSetValue) {
        index = wrapIndex(this, index);
        return index < 0 || this.size === Infinity || this.size !== undefined && index > this.size ? notSetValue : this.find(function(_, key) {
            return key === index;
        }, undefined, notSetValue);
    },
    has: function has(index) {
        index = wrapIndex(this, index);
        return index >= 0 && (this.size !== undefined ? this.size === Infinity || index < this.size : this.find(function(_, key) {
            return key === index;
        }, undefined, NOT_SET) !== NOT_SET);
    },
    interpose: function interpose(separator) {
        return reify(this, interposeFactory(this, separator));
    },
    interleave: function interleave() {
        var collections = [
            this
        ].concat(arrCopy(arguments));
        var zipped = zipWithFactory(this.toSeq(), IndexedSeq.of, collections);
        var interleaved = zipped.flatten(true);
        if (zipped.size) interleaved.size = zipped.size * collections.length;
        return reify(this, interleaved);
    },
    keySeq: function keySeq() {
        return Range(0, this.size);
    },
    last: function last(notSetValue) {
        return this.get(-1, notSetValue);
    },
    skipWhile: function skipWhile(predicate, context) {
        return reify(this, skipWhileFactory(this, predicate, context, false));
    },
    zip: function zip() {
        var collections = [
            this
        ].concat(arrCopy(arguments));
        return reify(this, zipWithFactory(this, defaultZipper, collections));
    },
    zipAll: function zipAll() {
        var collections = [
            this
        ].concat(arrCopy(arguments));
        return reify(this, zipWithFactory(this, defaultZipper, collections, true));
    },
    zipWith: function zipWith(zipper /*, ...collections */ ) {
        var collections = arrCopy(arguments);
        collections[0] = this;
        return reify(this, zipWithFactory(this, zipper, collections));
    }
});
var IndexedCollectionPrototype = IndexedCollection.prototype;
IndexedCollectionPrototype[IS_INDEXED_SYMBOL] = true;
IndexedCollectionPrototype[IS_ORDERED_SYMBOL] = true;
mixin(SetCollection, {
    // ### ES6 Collection methods (ES6 Array and Map)
    get: function get(value, notSetValue) {
        return this.has(value) ? value : notSetValue;
    },
    includes: function includes(value) {
        return this.has(value);
    },
    // ### More sequential methods
    keySeq: function keySeq() {
        return this.valueSeq();
    }
});
var SetCollectionPrototype = SetCollection.prototype;
SetCollectionPrototype.has = CollectionPrototype.includes;
SetCollectionPrototype.contains = SetCollectionPrototype.includes;
SetCollectionPrototype.keys = SetCollectionPrototype.values;
// Mixin subclasses
mixin(KeyedSeq, KeyedCollectionPrototype);
mixin(IndexedSeq, IndexedCollectionPrototype);
mixin(SetSeq, SetCollectionPrototype);
// #pragma Helper functions
function defaultZipper() {
    return arrCopy(arguments);
}
/**
 * True if `maybeOrderedSet` is an OrderedSet.
 */ function isOrderedSet(maybeOrderedSet) {
    return isSet(maybeOrderedSet) && isOrdered(maybeOrderedSet);
}
var OrderedSet = /*@__PURE__*/ function(Set) {
    function OrderedSet(value) {
        // eslint-disable-next-line no-constructor-return
        return value === undefined || value === null ? emptyOrderedSet() : isOrderedSet(value) ? value : emptyOrderedSet().withMutations(function(set) {
            var iter = SetCollection(value);
            assertNotInfinite(iter.size);
            iter.forEach(function(v) {
                return set.add(v);
            });
        });
    }
    if (Set) OrderedSet.__proto__ = Set;
    OrderedSet.prototype = Object.create(Set && Set.prototype);
    OrderedSet.prototype.constructor = OrderedSet;
    OrderedSet.of = function of() {
        return this(arguments);
    };
    OrderedSet.fromKeys = function fromKeys(value) {
        return this(KeyedCollection(value).keySeq());
    };
    OrderedSet.prototype.toString = function toString() {
        return this.__toString('OrderedSet {', '}');
    };
    return OrderedSet;
}(Set);
OrderedSet.isOrderedSet = isOrderedSet;
var OrderedSetPrototype = OrderedSet.prototype;
OrderedSetPrototype[IS_ORDERED_SYMBOL] = true;
OrderedSetPrototype.zip = IndexedCollectionPrototype.zip;
OrderedSetPrototype.zipWith = IndexedCollectionPrototype.zipWith;
OrderedSetPrototype.zipAll = IndexedCollectionPrototype.zipAll;
OrderedSetPrototype.__empty = emptyOrderedSet;
OrderedSetPrototype.__make = makeOrderedSet;
function makeOrderedSet(map, ownerID) {
    var set = Object.create(OrderedSetPrototype);
    set.size = map ? map.size : 0;
    set._map = map;
    set.__ownerID = ownerID;
    return set;
}
var EMPTY_ORDERED_SET;
function emptyOrderedSet() {
    return EMPTY_ORDERED_SET || (EMPTY_ORDERED_SET = makeOrderedSet(emptyOrderedMap()));
}
/**
 * Describes which item in a pair should be placed first when sorting
 */ var PairSorting = {
    LeftThenRight: -1,
    RightThenLeft: 1
};
function throwOnInvalidDefaultValues(defaultValues) {
    if (isRecord(defaultValues)) throw new Error('Can not call `Record` with an immutable Record as default values. Use a plain javascript object instead.');
    if (isImmutable(defaultValues)) throw new Error('Can not call `Record` with an immutable Collection as default values. Use a plain javascript object instead.');
    if (defaultValues === null || (typeof defaultValues === "undefined" ? "undefined" : (0, $6tOPT._)(defaultValues)) !== 'object') throw new Error('Can not call `Record` with a non-object as default values. Use a plain javascript object instead.');
}
var Record = function Record(defaultValues, name) {
    var hasInitialized;
    throwOnInvalidDefaultValues(defaultValues);
    var RecordType = function Record(values) {
        var this$1$1 = this;
        if (values instanceof RecordType) return values;
        if (!(this instanceof RecordType)) return new RecordType(values);
        if (!hasInitialized) {
            hasInitialized = true;
            var keys = Object.keys(defaultValues);
            var indices = RecordTypePrototype._indices = {};
            // Deprecated: left to attempt not to break any external code which
            // relies on a ._name property existing on record instances.
            // Use Record.getDescriptiveName() instead
            RecordTypePrototype._name = name;
            RecordTypePrototype._keys = keys;
            RecordTypePrototype._defaultValues = defaultValues;
            for(var i = 0; i < keys.length; i++){
                var propName = keys[i];
                indices[propName] = i;
                if (RecordTypePrototype[propName]) /* eslint-disable no-console */ // eslint-disable-next-line @typescript-eslint/no-unused-expressions -- TODO enable eslint here
                (typeof console === "undefined" ? "undefined" : (0, $6tOPT._)(console)) === 'object' && console.warn && console.warn('Cannot define ' + recordName(this) + ' with property "' + propName + '" since that property name is part of the Record API.');
                else setProp(RecordTypePrototype, propName);
            }
        }
        this.__ownerID = undefined;
        this._values = List().withMutations(function(l) {
            l.setSize(this$1$1._keys.length);
            KeyedCollection(values).forEach(function(v, k) {
                l.set(this$1$1._indices[k], v === this$1$1._defaultValues[k] ? undefined : v);
            });
        });
        return this;
    };
    var RecordTypePrototype = RecordType.prototype = Object.create(RecordPrototype);
    RecordTypePrototype.constructor = RecordType;
    if (name) RecordType.displayName = name;
    // eslint-disable-next-line no-constructor-return
    return RecordType;
};
Record.prototype.toString = function toString() {
    var str = recordName(this) + ' { ';
    var keys = this._keys;
    var k;
    for(var i = 0, l = keys.length; i !== l; i++){
        k = keys[i];
        str += (i ? ', ' : '') + k + ': ' + quoteString(this.get(k));
    }
    return str + ' }';
};
Record.prototype.equals = function equals(other) {
    return this === other || isRecord(other) && recordSeq(this).equals(recordSeq(other));
};
Record.prototype.hashCode = function hashCode() {
    return recordSeq(this).hashCode();
};
// @pragma Access
Record.prototype.has = function has(k) {
    return this._indices.hasOwnProperty(k);
};
Record.prototype.get = function get(k, notSetValue) {
    if (!this.has(k)) return notSetValue;
    var index = this._indices[k];
    var value = this._values.get(index);
    return value === undefined ? this._defaultValues[k] : value;
};
// @pragma Modification
Record.prototype.set = function set(k, v) {
    if (this.has(k)) {
        var newValues = this._values.set(this._indices[k], v === this._defaultValues[k] ? undefined : v);
        if (newValues !== this._values && !this.__ownerID) return makeRecord(this, newValues);
    }
    return this;
};
Record.prototype.remove = function remove(k) {
    return this.set(k);
};
Record.prototype.clear = function clear() {
    var newValues = this._values.clear().setSize(this._keys.length);
    return this.__ownerID ? this : makeRecord(this, newValues);
};
Record.prototype.wasAltered = function wasAltered() {
    return this._values.wasAltered();
};
Record.prototype.toSeq = function toSeq() {
    return recordSeq(this);
};
Record.prototype.toJS = function toJS$1() {
    return toJS(this);
};
Record.prototype.entries = function entries() {
    return this.__iterator(ITERATE_ENTRIES);
};
Record.prototype.__iterator = function __iterator(type, reverse) {
    return recordSeq(this).__iterator(type, reverse);
};
Record.prototype.__iterate = function __iterate(fn, reverse) {
    return recordSeq(this).__iterate(fn, reverse);
};
Record.prototype.__ensureOwner = function __ensureOwner(ownerID) {
    if (ownerID === this.__ownerID) return this;
    var newValues = this._values.__ensureOwner(ownerID);
    if (!ownerID) {
        this.__ownerID = ownerID;
        this._values = newValues;
        return this;
    }
    return makeRecord(this, newValues, ownerID);
};
Record.isRecord = isRecord;
Record.getDescriptiveName = recordName;
var RecordPrototype = Record.prototype;
RecordPrototype[IS_RECORD_SYMBOL] = true;
RecordPrototype[DELETE] = RecordPrototype.remove;
RecordPrototype.deleteIn = RecordPrototype.removeIn = deleteIn;
RecordPrototype.getIn = getIn;
RecordPrototype.hasIn = CollectionPrototype.hasIn;
RecordPrototype.merge = merge$1;
RecordPrototype.mergeWith = mergeWith$1;
RecordPrototype.mergeIn = mergeIn;
RecordPrototype.mergeDeep = mergeDeep;
RecordPrototype.mergeDeepWith = mergeDeepWith;
RecordPrototype.mergeDeepIn = mergeDeepIn;
RecordPrototype.setIn = setIn;
RecordPrototype.update = update;
RecordPrototype.updateIn = updateIn$1;
RecordPrototype.withMutations = withMutations;
RecordPrototype.asMutable = asMutable;
RecordPrototype.asImmutable = asImmutable;
RecordPrototype[ITERATOR_SYMBOL] = RecordPrototype.entries;
RecordPrototype.toJSON = RecordPrototype.toObject = CollectionPrototype.toObject;
RecordPrototype.inspect = RecordPrototype.toSource = function() {
    return this.toString();
};
function makeRecord(likeRecord, values, ownerID) {
    var record = Object.create(Object.getPrototypeOf(likeRecord));
    record._values = values;
    record.__ownerID = ownerID;
    return record;
}
function recordName(record) {
    return record.constructor.displayName || record.constructor.name || 'Record';
}
function recordSeq(record) {
    return keyedSeqFromValue(record._keys.map(function(k) {
        return [
            k,
            record.get(k)
        ];
    }));
}
function setProp(prototype, name) {
    try {
        Object.defineProperty(prototype, name, {
            get: function get() {
                return this.get(name);
            },
            set: function set(value) {
                invariant(this.__ownerID, 'Cannot set on an immutable record.');
                this.set(name, value);
            }
        });
    // eslint-disable-next-line @typescript-eslint/no-unused-vars -- TODO enable eslint here
    } catch (error) {
    // Object.defineProperty failed. Probably IE8.
    }
}
/**
 * Returns a lazy Seq of `value` repeated `times` times. When `times` is
 * undefined, returns an infinite sequence of `value`.
 */ var Repeat = /*@__PURE__*/ function(IndexedSeq) {
    function Repeat(value, times) {
        if (!(this instanceof Repeat)) // eslint-disable-next-line no-constructor-return
        return new Repeat(value, times);
        this._value = value;
        this.size = times === undefined ? Infinity : Math.max(0, times);
        if (this.size === 0) {
            if (EMPTY_REPEAT) // eslint-disable-next-line no-constructor-return
            return EMPTY_REPEAT;
            // eslint-disable-next-line @typescript-eslint/no-this-alias
            EMPTY_REPEAT = this;
        }
    }
    if (IndexedSeq) Repeat.__proto__ = IndexedSeq;
    Repeat.prototype = Object.create(IndexedSeq && IndexedSeq.prototype);
    Repeat.prototype.constructor = Repeat;
    Repeat.prototype.toString = function toString() {
        if (this.size === 0) return 'Repeat []';
        return 'Repeat [ ' + this._value + ' ' + this.size + ' times ]';
    };
    Repeat.prototype.get = function get(index, notSetValue) {
        return this.has(index) ? this._value : notSetValue;
    };
    Repeat.prototype.includes = function includes(searchValue) {
        return is(this._value, searchValue);
    };
    Repeat.prototype.slice = function slice(begin, end) {
        var size = this.size;
        return wholeSlice(begin, end, size) ? this : new Repeat(this._value, resolveEnd(end, size) - resolveBegin(begin, size));
    };
    Repeat.prototype.reverse = function reverse() {
        return this;
    };
    Repeat.prototype.indexOf = function indexOf(searchValue) {
        if (this.size !== 0 && is(this._value, searchValue)) return 0;
        return -1;
    };
    Repeat.prototype.lastIndexOf = function lastIndexOf(searchValue) {
        if (this.size !== 0 && is(this._value, searchValue)) return this.size - 1;
        return -1;
    };
    Repeat.prototype.__iterate = function __iterate(fn, reverse) {
        var size = this.size;
        var i = 0;
        while(i !== size){
            if (fn(this._value, reverse ? size - ++i : i++, this) === false) break;
        }
        return i;
    };
    Repeat.prototype.__iterator = function __iterator(type, reverse) {
        var this$1$1 = this;
        var size = this.size;
        var i = 0;
        return new Iterator(function() {
            return i === size ? iteratorDone() : iteratorValue(type, reverse ? size - ++i : i++, this$1$1._value);
        });
    };
    Repeat.prototype.equals = function equals(other) {
        return other instanceof Repeat ? is(this._value, other._value) : deepEqual(this, other);
    };
    return Repeat;
}(IndexedSeq);
var EMPTY_REPEAT;
function fromJS(value, converter) {
    return fromJSWith([], converter || defaultConverter, value, '', converter && converter.length > 2 ? [] : undefined, {
        '': value
    });
}
function fromJSWith(stack, converter, value, key, keyPath, parentValue) {
    if (typeof value !== 'string' && !isImmutable(value) && (isArrayLike(value) || hasIterator(value) || isPlainObject(value))) {
        if (~stack.indexOf(value)) throw new TypeError('Cannot convert circular structure to Immutable');
        stack.push(value);
        // eslint-disable-next-line @typescript-eslint/no-unused-expressions -- TODO enable eslint here
        keyPath && key !== '' && keyPath.push(key);
        var converted = converter.call(parentValue, key, Seq(value).map(function(v, k) {
            return fromJSWith(stack, converter, v, k, keyPath, value);
        }), keyPath && keyPath.slice());
        stack.pop();
        // eslint-disable-next-line @typescript-eslint/no-unused-expressions -- TODO enable eslint here
        keyPath && keyPath.pop();
        return converted;
    }
    return value;
}
function defaultConverter(k, v) {
    // Effectively the opposite of "Collection.toSeq()"
    return isIndexed(v) ? v.toList() : isKeyed(v) ? v.toMap() : v.toSet();
}
var version = "5.1.9";
/* eslint-disable import/order */ // Note: Iterable is deprecated
var Iterable = Collection;

});

var $eb131adf5cc938a0$exports = {};
$parcel$extendImportMap({
    "fLnzD": "icons.c5b0f01c.svg"
});

function $cd69311d8f42aefb$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) resolve(value);
    else Promise.resolve(value).then(_next, _throw);
}
function $cd69311d8f42aefb$export$71511d61b312f219(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                $cd69311d8f42aefb$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                $cd69311d8f42aefb$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}



var $53nS0 = parcelRequire("53nS0");
'use strict';
'use strict';
var $244155c096ef4c14$exports = {};

var $6tOPT = parcelRequire("6tOPT");
'use strict';
var $27350b6a9e85aed1$exports = {};

var $6tOPT = parcelRequire("6tOPT");
'use strict';
var $27350b6a9e85aed1$var$check = function check(it) {
    return it && it.Math === Math && it;
};
// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
$27350b6a9e85aed1$exports = // eslint-disable-next-line es/no-global-this -- safe
$27350b6a9e85aed1$var$check((typeof globalThis === "undefined" ? "undefined" : (0, $6tOPT._)(globalThis)) == 'object' && globalThis) || $27350b6a9e85aed1$var$check((typeof window === "undefined" ? "undefined" : (0, $6tOPT._)(window)) == 'object' && window) || // eslint-disable-next-line no-restricted-globals -- safe
$27350b6a9e85aed1$var$check((typeof self === "undefined" ? "undefined" : (0, $6tOPT._)(self)) == 'object' && self) || $27350b6a9e85aed1$var$check((typeof $parcel$global === "undefined" ? "undefined" : (0, $6tOPT._)($parcel$global)) == 'object' && $parcel$global) || $27350b6a9e85aed1$var$check((0, $6tOPT._)(undefined) == 'object' && undefined) || // eslint-disable-next-line no-new-func -- fallback
function() {
    return this;
}() || Function('return this')();


var $70871da05e9d21bf$exports = {};

$parcel$export($70871da05e9d21bf$exports, "f", function () { return $70871da05e9d21bf$export$2d1720544b23b823; }, function (v) { return $70871da05e9d21bf$export$2d1720544b23b823 = v; });
// `Object.getOwnPropertyDescriptor` method
// https://tc39.es/ecma262/#sec-object.getownpropertydescriptor
var $70871da05e9d21bf$export$2d1720544b23b823;
'use strict';
var $b9f536d3284d7921$exports = {};
'use strict';
var $ddd8e9441ae136f2$exports = {};
'use strict';
$ddd8e9441ae136f2$exports = function(exec) {
    try {
        return !!exec();
    } catch (error) {
        return true;
    }
};


// Detect IE8's incomplete defineProperty implementation
$b9f536d3284d7921$exports = !$ddd8e9441ae136f2$exports(function() {
    // eslint-disable-next-line es/no-object-defineproperty -- required for testing
    return Object.defineProperty({}, 1, {
        get: function get() {
            return 7;
        }
    })[1] !== 7;
});


var $59bf80837927ca02$exports = {};
'use strict';
var $37d783b2348274b4$exports = {};
'use strict';

$37d783b2348274b4$exports = !$ddd8e9441ae136f2$exports(function() {
    // eslint-disable-next-line es/no-function-prototype-bind -- safe
    var test = (function() {}).bind();
    // eslint-disable-next-line no-prototype-builtins -- safe
    return typeof test != 'function' || test.hasOwnProperty('prototype');
});


var $59bf80837927ca02$var$call = Function.prototype.call;
// eslint-disable-next-line es/no-function-prototype-bind -- safe
$59bf80837927ca02$exports = $37d783b2348274b4$exports ? $59bf80837927ca02$var$call.bind($59bf80837927ca02$var$call) : function() {
    return $59bf80837927ca02$var$call.apply($59bf80837927ca02$var$call, arguments);
};


var $246f5b02cd4c126c$exports = {};

$parcel$export($246f5b02cd4c126c$exports, "f", function () { return $246f5b02cd4c126c$export$2d1720544b23b823; }, function (v) { return $246f5b02cd4c126c$export$2d1720544b23b823 = v; });
// `Object.prototype.propertyIsEnumerable` method implementation
// https://tc39.es/ecma262/#sec-object.prototype.propertyisenumerable
var $246f5b02cd4c126c$export$2d1720544b23b823;
'use strict';
var $246f5b02cd4c126c$var$$propertyIsEnumerable = {}.propertyIsEnumerable;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $246f5b02cd4c126c$var$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
// Nashorn ~ JDK8 bug
var $246f5b02cd4c126c$var$NASHORN_BUG = $246f5b02cd4c126c$var$getOwnPropertyDescriptor && !$246f5b02cd4c126c$var$$propertyIsEnumerable.call({
    1: 2
}, 1);
$246f5b02cd4c126c$export$2d1720544b23b823 = $246f5b02cd4c126c$var$NASHORN_BUG ? function propertyIsEnumerable(V) {
    var descriptor = $246f5b02cd4c126c$var$getOwnPropertyDescriptor(this, V);
    return !!descriptor && descriptor.enumerable;
} : $246f5b02cd4c126c$var$$propertyIsEnumerable;


var $27c455d39660edb8$exports = {};
'use strict';
$27c455d39660edb8$exports = function(bitmap, value) {
    return {
        enumerable: !(bitmap & 1),
        configurable: !(bitmap & 2),
        writable: !(bitmap & 4),
        value: value
    };
};


var $59a8f2f00edbf5a1$exports = {};
'use strict';
var $7a4c0b5af5b2bbd3$exports = {};
'use strict';
var $c224a7eda28c33b3$exports = {};
'use strict';

var $c224a7eda28c33b3$var$FunctionPrototype = Function.prototype;
var $c224a7eda28c33b3$var$call = $c224a7eda28c33b3$var$FunctionPrototype.call;
// eslint-disable-next-line es/no-function-prototype-bind -- safe
var $c224a7eda28c33b3$var$uncurryThisWithBind = $37d783b2348274b4$exports && $c224a7eda28c33b3$var$FunctionPrototype.bind.bind($c224a7eda28c33b3$var$call, $c224a7eda28c33b3$var$call);
$c224a7eda28c33b3$exports = $37d783b2348274b4$exports ? $c224a7eda28c33b3$var$uncurryThisWithBind : function(fn) {
    return function() {
        return $c224a7eda28c33b3$var$call.apply(fn, arguments);
    };
};



var $5a266b01e7970e30$exports = {};
'use strict';

var $5a266b01e7970e30$var$toString = $c224a7eda28c33b3$exports({}.toString);
var $5a266b01e7970e30$var$stringSlice = $c224a7eda28c33b3$exports(''.slice);
$5a266b01e7970e30$exports = function(it) {
    return $5a266b01e7970e30$var$stringSlice($5a266b01e7970e30$var$toString(it), 8, -1);
};


var $7a4c0b5af5b2bbd3$var$$Object = Object;
var $7a4c0b5af5b2bbd3$var$split = $c224a7eda28c33b3$exports(''.split);
// fallback for non-array-like ES3 and non-enumerable old V8 strings
$7a4c0b5af5b2bbd3$exports = $ddd8e9441ae136f2$exports(function() {
    // throws an error in rhino, see https://github.com/mozilla/rhino/issues/346
    // eslint-disable-next-line no-prototype-builtins -- safe
    return !$7a4c0b5af5b2bbd3$var$$Object('z').propertyIsEnumerable(0);
}) ? function(it) {
    return $5a266b01e7970e30$exports(it) === 'String' ? $7a4c0b5af5b2bbd3$var$split(it, '') : $7a4c0b5af5b2bbd3$var$$Object(it);
} : $7a4c0b5af5b2bbd3$var$$Object;


var $0f70b7357550422e$exports = {};
'use strict';
var $da08ff0243e53f27$exports = {};
'use strict';
// we can't use just `it == null` since of `document.all` special case
// https://tc39.es/ecma262/#sec-IsHTMLDDA-internal-slot-aec
$da08ff0243e53f27$exports = function(it) {
    return it === null || it === undefined;
};


var $0f70b7357550422e$var$$TypeError = TypeError;
// `RequireObjectCoercible` abstract operation
// https://tc39.es/ecma262/#sec-requireobjectcoercible
$0f70b7357550422e$exports = function(it) {
    if ($da08ff0243e53f27$exports(it)) throw new $0f70b7357550422e$var$$TypeError("Can't call method on " + it);
    return it;
};


$59a8f2f00edbf5a1$exports = function(it) {
    return $7a4c0b5af5b2bbd3$exports($0f70b7357550422e$exports(it));
};


var $d9a9cf8e89852c56$exports = {};
'use strict';
var $5502f9db3352ad96$exports = {};
'use strict';

var $4d7f82f6c4645870$exports = {};

var $6tOPT = parcelRequire("6tOPT");
'use strict';
var $7c165f740ca92c53$exports = {};

var $6tOPT = parcelRequire("6tOPT");
'use strict';
// https://tc39.es/ecma262/#sec-IsHTMLDDA-internal-slot
var $7c165f740ca92c53$var$documentAll = (typeof document === "undefined" ? "undefined" : (0, $6tOPT._)(document)) == 'object' && document.all;
// `IsCallable` abstract operation
// https://tc39.es/ecma262/#sec-iscallable
// eslint-disable-next-line unicorn/no-typeof-undefined -- required for testing
$7c165f740ca92c53$exports = typeof $7c165f740ca92c53$var$documentAll == 'undefined' && $7c165f740ca92c53$var$documentAll !== undefined ? function(argument) {
    return typeof argument == 'function' || argument === $7c165f740ca92c53$var$documentAll;
} : function(argument) {
    return typeof argument == 'function';
};


$4d7f82f6c4645870$exports = function(it) {
    return (typeof it === "undefined" ? "undefined" : (0, $6tOPT._)(it)) == 'object' ? it !== null : $7c165f740ca92c53$exports(it);
};


var $3b5b0fa19aea9b5a$exports = {};

var $6tOPT = parcelRequire("6tOPT");
'use strict';
var $e8972ff3cf85d361$exports = {};
'use strict';


var $e8972ff3cf85d361$var$aFunction = function aFunction(argument) {
    return $7c165f740ca92c53$exports(argument) ? argument : undefined;
};
$e8972ff3cf85d361$exports = function(namespace, method) {
    return arguments.length < 2 ? $e8972ff3cf85d361$var$aFunction($27350b6a9e85aed1$exports[namespace]) : $27350b6a9e85aed1$exports[namespace] && $27350b6a9e85aed1$exports[namespace][method];
};



var $5c91390ffea610b9$exports = {};
'use strict';

$5c91390ffea610b9$exports = $c224a7eda28c33b3$exports({}.isPrototypeOf);


var $b448f8dc4fdabc22$exports = {};

var $6tOPT = parcelRequire("6tOPT");
'use strict';
var $532a34ca390758bf$exports = {};
'use strict';
var $af93164be802bd69$exports = {};
'use strict';

var $ef443fb3091f223d$exports = {};
'use strict';

var $ef443fb3091f223d$var$navigator = $27350b6a9e85aed1$exports.navigator;
var $ef443fb3091f223d$var$userAgent = $ef443fb3091f223d$var$navigator && $ef443fb3091f223d$var$navigator.userAgent;
$ef443fb3091f223d$exports = $ef443fb3091f223d$var$userAgent ? String($ef443fb3091f223d$var$userAgent) : '';


var $af93164be802bd69$var$process = $27350b6a9e85aed1$exports.process;
var $af93164be802bd69$var$Deno = $27350b6a9e85aed1$exports.Deno;
var $af93164be802bd69$var$versions = $af93164be802bd69$var$process && $af93164be802bd69$var$process.versions || $af93164be802bd69$var$Deno && $af93164be802bd69$var$Deno.version;
var $af93164be802bd69$var$v8 = $af93164be802bd69$var$versions && $af93164be802bd69$var$versions.v8;
var $af93164be802bd69$var$match, $af93164be802bd69$var$version;
if ($af93164be802bd69$var$v8) {
    $af93164be802bd69$var$match = $af93164be802bd69$var$v8.split('.');
    // in old Chrome, versions of V8 isn't V8 = Chrome / 10
    // but their correct versions are not interesting for us
    $af93164be802bd69$var$version = $af93164be802bd69$var$match[0] > 0 && $af93164be802bd69$var$match[0] < 4 ? 1 : +($af93164be802bd69$var$match[0] + $af93164be802bd69$var$match[1]);
}
// BrowserFS NodeJS `process` polyfill incorrectly set `.v8` to `0.0`
// so check `userAgent` even if `.v8` exists, but 0
if (!$af93164be802bd69$var$version && $ef443fb3091f223d$exports) {
    $af93164be802bd69$var$match = $ef443fb3091f223d$exports.match(/Edge\/(\d+)/);
    if (!$af93164be802bd69$var$match || $af93164be802bd69$var$match[1] >= 74) {
        $af93164be802bd69$var$match = $ef443fb3091f223d$exports.match(/Chrome\/(\d+)/);
        if ($af93164be802bd69$var$match) $af93164be802bd69$var$version = +$af93164be802bd69$var$match[1];
    }
}
$af93164be802bd69$exports = $af93164be802bd69$var$version;




var $532a34ca390758bf$var$$String = $27350b6a9e85aed1$exports.String;
// eslint-disable-next-line es/no-object-getownpropertysymbols -- required for testing
$532a34ca390758bf$exports = !!Object.getOwnPropertySymbols && !$ddd8e9441ae136f2$exports(function() {
    var symbol = Symbol('symbol detection');
    // Chrome 38 Symbol has incorrect toString conversion
    // `get-own-property-symbols` polyfill symbols converted to object are not Symbol instances
    // nb: Do not call `String` directly to avoid this being optimized out to `symbol+''` which will,
    // of course, fail.
    return !$532a34ca390758bf$var$$String(symbol) || !(Object(symbol) instanceof Symbol) || // Chrome 38-40 symbols are not inherited from DOM collections prototypes to instances
    !Symbol.sham && $af93164be802bd69$exports && $af93164be802bd69$exports < 41;
});


$b448f8dc4fdabc22$exports = $532a34ca390758bf$exports && !Symbol.sham && (0, $6tOPT._)(Symbol.iterator) == 'symbol';


var $3b5b0fa19aea9b5a$var$$Object = Object;
$3b5b0fa19aea9b5a$exports = $b448f8dc4fdabc22$exports ? function(it) {
    return (typeof it === "undefined" ? "undefined" : (0, $6tOPT._)(it)) == 'symbol';
} : function(it) {
    var $Symbol = $e8972ff3cf85d361$exports('Symbol');
    return $7c165f740ca92c53$exports($Symbol) && $5c91390ffea610b9$exports($Symbol.prototype, $3b5b0fa19aea9b5a$var$$Object(it));
};


var $354ab2c23276ac4c$exports = {};
'use strict';
var $082fcaa0a091ee30$exports = {};
'use strict';

var $287fd49afd1ee632$exports = {};
'use strict';
var $287fd49afd1ee632$var$$String = String;
$287fd49afd1ee632$exports = function(argument) {
    try {
        return $287fd49afd1ee632$var$$String(argument);
    } catch (error) {
        return 'Object';
    }
};


var $082fcaa0a091ee30$var$$TypeError = TypeError;
// `Assert: IsCallable(argument) is true`
$082fcaa0a091ee30$exports = function(argument) {
    if ($7c165f740ca92c53$exports(argument)) return argument;
    throw new $082fcaa0a091ee30$var$$TypeError($287fd49afd1ee632$exports(argument) + ' is not a function');
};



// `GetMethod` abstract operation
// https://tc39.es/ecma262/#sec-getmethod
$354ab2c23276ac4c$exports = function(V, P) {
    var func = V[P];
    return $da08ff0243e53f27$exports(func) ? undefined : $082fcaa0a091ee30$exports(func);
};


var $57ba5c286733c9e5$exports = {};
'use strict';



var $57ba5c286733c9e5$var$$TypeError = TypeError;
// `OrdinaryToPrimitive` abstract operation
// https://tc39.es/ecma262/#sec-ordinarytoprimitive
$57ba5c286733c9e5$exports = function(input, pref) {
    var fn, val;
    if (pref === 'string' && $7c165f740ca92c53$exports(fn = input.toString) && !$4d7f82f6c4645870$exports(val = $59bf80837927ca02$exports(fn, input))) return val;
    if ($7c165f740ca92c53$exports(fn = input.valueOf) && !$4d7f82f6c4645870$exports(val = $59bf80837927ca02$exports(fn, input))) return val;
    if (pref !== 'string' && $7c165f740ca92c53$exports(fn = input.toString) && !$4d7f82f6c4645870$exports(val = $59bf80837927ca02$exports(fn, input))) return val;
    throw new $57ba5c286733c9e5$var$$TypeError("Can't convert object to primitive value");
};


var $8555fb22f74da29f$exports = {};
'use strict';

var $bf195d0f48f561ca$exports = {};
'use strict';
var $4f1daee27a8334f9$exports = {};
'use strict';
var $a4b83f418a8da28e$exports = {};
'use strict';
$a4b83f418a8da28e$exports = false;



var $4fd4b495a0b4f0da$exports = {};
'use strict';

// eslint-disable-next-line es/no-object-defineproperty -- safe
var $4fd4b495a0b4f0da$var$defineProperty = Object.defineProperty;
$4fd4b495a0b4f0da$exports = function(key, value) {
    try {
        $4fd4b495a0b4f0da$var$defineProperty($27350b6a9e85aed1$exports, key, {
            value: value,
            configurable: true,
            writable: true
        });
    } catch (error) {
        $27350b6a9e85aed1$exports[key] = value;
    }
    return value;
};


var $4f1daee27a8334f9$var$SHARED = '__core-js_shared__';
var $4f1daee27a8334f9$var$store = $4f1daee27a8334f9$exports = $27350b6a9e85aed1$exports[$4f1daee27a8334f9$var$SHARED] || $4fd4b495a0b4f0da$exports($4f1daee27a8334f9$var$SHARED, {});
($4f1daee27a8334f9$var$store.versions || ($4f1daee27a8334f9$var$store.versions = [])).push({
    version: '3.49.0',
    mode: $a4b83f418a8da28e$exports ? 'pure' : 'global',
    copyright: "\xa9 2013\u20132025 Denis Pushkarev (zloirock.ru), 2025\u20132026 CoreJS Company (core-js.io). All rights reserved.",
    license: 'https://github.com/zloirock/core-js/blob/v3.49.0/LICENSE',
    source: 'https://github.com/zloirock/core-js'
});


$bf195d0f48f561ca$exports = function(key, value) {
    return $4f1daee27a8334f9$exports[key] || ($4f1daee27a8334f9$exports[key] = value || {});
};


var $8bbc2bccc0a29296$exports = {};
'use strict';

var $ad1d9797f1e27af5$exports = {};
'use strict';

var $ad1d9797f1e27af5$var$$Object = Object;
// `ToObject` abstract operation
// https://tc39.es/ecma262/#sec-toobject
$ad1d9797f1e27af5$exports = function(argument) {
    return $ad1d9797f1e27af5$var$$Object($0f70b7357550422e$exports(argument));
};


var $8bbc2bccc0a29296$var$hasOwnProperty = $c224a7eda28c33b3$exports({}.hasOwnProperty);
// `HasOwnProperty` abstract operation
// https://tc39.es/ecma262/#sec-hasownproperty
// eslint-disable-next-line es/no-object-hasown -- safe
$8bbc2bccc0a29296$exports = Object.hasOwn || function hasOwn(it, key) {
    return $8bbc2bccc0a29296$var$hasOwnProperty($ad1d9797f1e27af5$exports(it), key);
};


var $bf14b42fd1d1c367$exports = {};
'use strict';

var $bf14b42fd1d1c367$var$id = 0;
var $bf14b42fd1d1c367$var$postfix = Math.random();
var $bf14b42fd1d1c367$var$toString = $c224a7eda28c33b3$exports(1.1.toString);
$bf14b42fd1d1c367$exports = function(key) {
    return 'Symbol(' + (key === undefined ? '' : key) + ')_' + $bf14b42fd1d1c367$var$toString(++$bf14b42fd1d1c367$var$id + $bf14b42fd1d1c367$var$postfix, 36);
};




var $8555fb22f74da29f$var$Symbol = $27350b6a9e85aed1$exports.Symbol;
var $8555fb22f74da29f$var$WellKnownSymbolsStore = $bf195d0f48f561ca$exports('wks');
var $8555fb22f74da29f$var$createWellKnownSymbol = $b448f8dc4fdabc22$exports ? $8555fb22f74da29f$var$Symbol['for'] || $8555fb22f74da29f$var$Symbol : $8555fb22f74da29f$var$Symbol && $8555fb22f74da29f$var$Symbol.withoutSetter || $bf14b42fd1d1c367$exports;
$8555fb22f74da29f$exports = function(name) {
    if (!$8bbc2bccc0a29296$exports($8555fb22f74da29f$var$WellKnownSymbolsStore, name)) $8555fb22f74da29f$var$WellKnownSymbolsStore[name] = $532a34ca390758bf$exports && $8bbc2bccc0a29296$exports($8555fb22f74da29f$var$Symbol, name) ? $8555fb22f74da29f$var$Symbol[name] : $8555fb22f74da29f$var$createWellKnownSymbol('Symbol.' + name);
    return $8555fb22f74da29f$var$WellKnownSymbolsStore[name];
};


var $5502f9db3352ad96$var$$TypeError = TypeError;
var $5502f9db3352ad96$var$TO_PRIMITIVE = $8555fb22f74da29f$exports('toPrimitive');
// `ToPrimitive` abstract operation
// https://tc39.es/ecma262/#sec-toprimitive
$5502f9db3352ad96$exports = function(input, pref) {
    if (!$4d7f82f6c4645870$exports(input) || $3b5b0fa19aea9b5a$exports(input)) return input;
    var exoticToPrim = $354ab2c23276ac4c$exports(input, $5502f9db3352ad96$var$TO_PRIMITIVE);
    var result;
    if (exoticToPrim) {
        if (pref === undefined) pref = 'default';
        result = $59bf80837927ca02$exports(exoticToPrim, input, pref);
        if (!$4d7f82f6c4645870$exports(result) || $3b5b0fa19aea9b5a$exports(result)) return result;
        throw new $5502f9db3352ad96$var$$TypeError("Can't convert object to primitive value");
    }
    if (pref === undefined) pref = 'number';
    return $57ba5c286733c9e5$exports(input, pref);
};



// `ToPropertyKey` abstract operation
// https://tc39.es/ecma262/#sec-topropertykey
$d9a9cf8e89852c56$exports = function(argument) {
    var key = $5502f9db3352ad96$exports(argument, 'string');
    return $3b5b0fa19aea9b5a$exports(key) ? key : key + '';
};



var $777cd87b12a608b2$exports = {};
'use strict';


var $9615a1abb0018505$exports = {};
'use strict';


var $9615a1abb0018505$var$document = $27350b6a9e85aed1$exports.document;
// typeof document.createElement is 'object' in old IE
var $9615a1abb0018505$var$EXISTS = $4d7f82f6c4645870$exports($9615a1abb0018505$var$document) && $4d7f82f6c4645870$exports($9615a1abb0018505$var$document.createElement);
$9615a1abb0018505$exports = function(it) {
    return $9615a1abb0018505$var$EXISTS ? $9615a1abb0018505$var$document.createElement(it) : {};
};


// Thanks to IE8 for its funny defineProperty
$777cd87b12a608b2$exports = !$b9f536d3284d7921$exports && !$ddd8e9441ae136f2$exports(function() {
    // eslint-disable-next-line es/no-object-defineproperty -- required for testing
    return Object.defineProperty($9615a1abb0018505$exports('div'), 'a', {
        get: function get() {
            return 7;
        }
    }).a !== 7;
});


// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $70871da05e9d21bf$var$$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
$70871da05e9d21bf$export$2d1720544b23b823 = $b9f536d3284d7921$exports ? $70871da05e9d21bf$var$$getOwnPropertyDescriptor : function getOwnPropertyDescriptor(O, P) {
    O = $59a8f2f00edbf5a1$exports(O);
    P = $d9a9cf8e89852c56$exports(P);
    if ($777cd87b12a608b2$exports) try {
        return $70871da05e9d21bf$var$$getOwnPropertyDescriptor(O, P);
    } catch (error) {}
    if ($8bbc2bccc0a29296$exports(O, P)) return $27c455d39660edb8$exports(!$59bf80837927ca02$exports($246f5b02cd4c126c$export$2d1720544b23b823, O, P), O[P]);
};


var $244155c096ef4c14$require$getOwnPropertyDescriptor = $70871da05e9d21bf$export$2d1720544b23b823;
var $b390530569770271$exports = {};
'use strict';

var $6f9fc35f567fa5b6$exports = {};

$parcel$export($6f9fc35f567fa5b6$exports, "f", function () { return $6f9fc35f567fa5b6$export$2d1720544b23b823; }, function (v) { return $6f9fc35f567fa5b6$export$2d1720544b23b823 = v; });
// `Object.defineProperty` method
// https://tc39.es/ecma262/#sec-object.defineproperty
var $6f9fc35f567fa5b6$export$2d1720544b23b823;
'use strict';


var $57b39386d98b1237$exports = {};
'use strict';


// V8 ~ Chrome 36-
// https://bugs.chromium.org/p/v8/issues/detail?id=3334
$57b39386d98b1237$exports = $b9f536d3284d7921$exports && $ddd8e9441ae136f2$exports(function() {
    // eslint-disable-next-line es/no-object-defineproperty -- required for testing
    return Object.defineProperty(function() {}, 'prototype', {
        value: 42,
        writable: false
    }).prototype !== 42;
});


var $7d9b9f0a2a7e34a2$exports = {};
'use strict';

var $7d9b9f0a2a7e34a2$var$$String = String;
var $7d9b9f0a2a7e34a2$var$$TypeError = TypeError;
// `Assert: Type(argument) is Object`
$7d9b9f0a2a7e34a2$exports = function(argument) {
    if ($4d7f82f6c4645870$exports(argument)) return argument;
    throw new $7d9b9f0a2a7e34a2$var$$TypeError($7d9b9f0a2a7e34a2$var$$String(argument) + ' is not an object');
};



var $6f9fc35f567fa5b6$var$$TypeError = TypeError;
// eslint-disable-next-line es/no-object-defineproperty -- safe
var $6f9fc35f567fa5b6$var$$defineProperty = Object.defineProperty;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $6f9fc35f567fa5b6$var$$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var $6f9fc35f567fa5b6$var$ENUMERABLE = 'enumerable';
var $6f9fc35f567fa5b6$var$CONFIGURABLE = 'configurable';
var $6f9fc35f567fa5b6$var$WRITABLE = 'writable';
$6f9fc35f567fa5b6$export$2d1720544b23b823 = $b9f536d3284d7921$exports ? $57b39386d98b1237$exports ? function defineProperty(O, P, Attributes) {
    $7d9b9f0a2a7e34a2$exports(O);
    P = $d9a9cf8e89852c56$exports(P);
    $7d9b9f0a2a7e34a2$exports(Attributes);
    if (typeof O === 'function' && P === 'prototype' && 'value' in Attributes && $6f9fc35f567fa5b6$var$WRITABLE in Attributes && !Attributes[$6f9fc35f567fa5b6$var$WRITABLE]) {
        var current = $6f9fc35f567fa5b6$var$$getOwnPropertyDescriptor(O, P);
        if (current && current[$6f9fc35f567fa5b6$var$WRITABLE]) {
            O[P] = Attributes.value;
            Attributes = {
                configurable: $6f9fc35f567fa5b6$var$CONFIGURABLE in Attributes ? Attributes[$6f9fc35f567fa5b6$var$CONFIGURABLE] : current[$6f9fc35f567fa5b6$var$CONFIGURABLE],
                enumerable: $6f9fc35f567fa5b6$var$ENUMERABLE in Attributes ? Attributes[$6f9fc35f567fa5b6$var$ENUMERABLE] : current[$6f9fc35f567fa5b6$var$ENUMERABLE],
                writable: false
            };
        }
    }
    return $6f9fc35f567fa5b6$var$$defineProperty(O, P, Attributes);
} : $6f9fc35f567fa5b6$var$$defineProperty : function defineProperty(O, P, Attributes) {
    $7d9b9f0a2a7e34a2$exports(O);
    P = $d9a9cf8e89852c56$exports(P);
    $7d9b9f0a2a7e34a2$exports(Attributes);
    if ($777cd87b12a608b2$exports) try {
        return $6f9fc35f567fa5b6$var$$defineProperty(O, P, Attributes);
    } catch (error) {}
    if ('get' in Attributes || 'set' in Attributes) throw new $6f9fc35f567fa5b6$var$$TypeError('Accessors not supported');
    if ('value' in Attributes) O[P] = Attributes.value;
    return O;
};



$b390530569770271$exports = $b9f536d3284d7921$exports ? function(object, key, value) {
    return $6f9fc35f567fa5b6$export$2d1720544b23b823(object, key, $27c455d39660edb8$exports(1, value));
} : function(object, key, value) {
    object[key] = value;
    return object;
};


var $73c8864ae5df5c4d$exports = {};
'use strict';


var $fef26419665138ba$exports = {};
'use strict';





var $464881364ad3f936$exports = {};
'use strict';


var $464881364ad3f936$var$FunctionPrototype = Function.prototype;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $464881364ad3f936$var$getDescriptor = $b9f536d3284d7921$exports && Object.getOwnPropertyDescriptor;
var $464881364ad3f936$var$EXISTS = $8bbc2bccc0a29296$exports($464881364ad3f936$var$FunctionPrototype, 'name');
// additional protection from minified / mangled / dropped function names
var $464881364ad3f936$var$PROPER = $464881364ad3f936$var$EXISTS && (function something() {}).name === 'something';
var $464881364ad3f936$var$CONFIGURABLE = $464881364ad3f936$var$EXISTS && (!$b9f536d3284d7921$exports || $b9f536d3284d7921$exports && $464881364ad3f936$var$getDescriptor($464881364ad3f936$var$FunctionPrototype, 'name').configurable);
$464881364ad3f936$exports = {
    EXISTS: $464881364ad3f936$var$EXISTS,
    PROPER: $464881364ad3f936$var$PROPER,
    CONFIGURABLE: $464881364ad3f936$var$CONFIGURABLE
};


var $fef26419665138ba$require$CONFIGURABLE_FUNCTION_NAME = $464881364ad3f936$exports.CONFIGURABLE;
var $fe8e93358f2825b5$exports = {};
'use strict';



var $fe8e93358f2825b5$var$functionToString = $c224a7eda28c33b3$exports(Function.toString);
// this helper broken in `core-js@3.4.1-3.4.4`, so we can't use `shared` helper
if (!$7c165f740ca92c53$exports($4f1daee27a8334f9$exports.inspectSource)) $4f1daee27a8334f9$exports.inspectSource = function(it) {
    return $fe8e93358f2825b5$var$functionToString(it);
};
$fe8e93358f2825b5$exports = $4f1daee27a8334f9$exports.inspectSource;


var $fcfe8b5396fbe91a$exports = {};
'use strict';
var $1593c91d91aeea67$exports = {};
'use strict';


var $1593c91d91aeea67$var$WeakMap = $27350b6a9e85aed1$exports.WeakMap;
$1593c91d91aeea67$exports = $7c165f740ca92c53$exports($1593c91d91aeea67$var$WeakMap) && /native code/.test(String($1593c91d91aeea67$var$WeakMap));







var $f2e10c313ac02773$exports = {};
'use strict';


var $f2e10c313ac02773$var$keys = $bf195d0f48f561ca$exports('keys');
$f2e10c313ac02773$exports = function(key) {
    return $f2e10c313ac02773$var$keys[key] || ($f2e10c313ac02773$var$keys[key] = $bf14b42fd1d1c367$exports(key));
};


var $91deb02321ce445c$exports = {};
'use strict';
$91deb02321ce445c$exports = {};


var $fcfe8b5396fbe91a$var$OBJECT_ALREADY_INITIALIZED = 'Object already initialized';
var $fcfe8b5396fbe91a$var$TypeError = $27350b6a9e85aed1$exports.TypeError;
var $fcfe8b5396fbe91a$var$WeakMap = $27350b6a9e85aed1$exports.WeakMap;
var $fcfe8b5396fbe91a$var$set, $fcfe8b5396fbe91a$var$get, $fcfe8b5396fbe91a$var$has;
var $fcfe8b5396fbe91a$var$enforce = function enforce(it) {
    return $fcfe8b5396fbe91a$var$has(it) ? $fcfe8b5396fbe91a$var$get(it) : $fcfe8b5396fbe91a$var$set(it, {});
};
var $fcfe8b5396fbe91a$var$getterFor = function getterFor(TYPE) {
    return function(it) {
        var state;
        if (!$4d7f82f6c4645870$exports(it) || (state = $fcfe8b5396fbe91a$var$get(it)).type !== TYPE) throw new $fcfe8b5396fbe91a$var$TypeError('Incompatible receiver, ' + TYPE + ' required');
        return state;
    };
};
if ($1593c91d91aeea67$exports || $4f1daee27a8334f9$exports.state) {
    var $fcfe8b5396fbe91a$var$store = $4f1daee27a8334f9$exports.state || ($4f1daee27a8334f9$exports.state = new $fcfe8b5396fbe91a$var$WeakMap());
    /* eslint-disable no-self-assign -- prototype methods protection */ $fcfe8b5396fbe91a$var$store.get = $fcfe8b5396fbe91a$var$store.get;
    $fcfe8b5396fbe91a$var$store.has = $fcfe8b5396fbe91a$var$store.has;
    $fcfe8b5396fbe91a$var$store.set = $fcfe8b5396fbe91a$var$store.set;
    /* eslint-enable no-self-assign -- prototype methods protection */ $fcfe8b5396fbe91a$var$set = function set(it, metadata) {
        if ($fcfe8b5396fbe91a$var$store.has(it)) throw new $fcfe8b5396fbe91a$var$TypeError($fcfe8b5396fbe91a$var$OBJECT_ALREADY_INITIALIZED);
        metadata.facade = it;
        $fcfe8b5396fbe91a$var$store.set(it, metadata);
        return metadata;
    };
    $fcfe8b5396fbe91a$var$get = function get(it) {
        return $fcfe8b5396fbe91a$var$store.get(it) || {};
    };
    $fcfe8b5396fbe91a$var$has = function has(it) {
        return $fcfe8b5396fbe91a$var$store.has(it);
    };
} else {
    var $fcfe8b5396fbe91a$var$STATE = $f2e10c313ac02773$exports('state');
    $91deb02321ce445c$exports[$fcfe8b5396fbe91a$var$STATE] = true;
    $fcfe8b5396fbe91a$var$set = function set(it, metadata) {
        if ($8bbc2bccc0a29296$exports(it, $fcfe8b5396fbe91a$var$STATE)) throw new $fcfe8b5396fbe91a$var$TypeError($fcfe8b5396fbe91a$var$OBJECT_ALREADY_INITIALIZED);
        metadata.facade = it;
        $b390530569770271$exports(it, $fcfe8b5396fbe91a$var$STATE, metadata);
        return metadata;
    };
    $fcfe8b5396fbe91a$var$get = function get(it) {
        return $8bbc2bccc0a29296$exports(it, $fcfe8b5396fbe91a$var$STATE) ? it[$fcfe8b5396fbe91a$var$STATE] : {};
    };
    $fcfe8b5396fbe91a$var$has = function has(it) {
        return $8bbc2bccc0a29296$exports(it, $fcfe8b5396fbe91a$var$STATE);
    };
}
$fcfe8b5396fbe91a$exports = {
    set: $fcfe8b5396fbe91a$var$set,
    get: $fcfe8b5396fbe91a$var$get,
    has: $fcfe8b5396fbe91a$var$has,
    enforce: $fcfe8b5396fbe91a$var$enforce,
    getterFor: $fcfe8b5396fbe91a$var$getterFor
};


var $fef26419665138ba$var$enforceInternalState = $fcfe8b5396fbe91a$exports.enforce;
var $fef26419665138ba$var$getInternalState = $fcfe8b5396fbe91a$exports.get;
var $fef26419665138ba$var$$String = String;
// eslint-disable-next-line es/no-object-defineproperty -- safe
var $fef26419665138ba$var$defineProperty = Object.defineProperty;
var $fef26419665138ba$var$stringSlice = $c224a7eda28c33b3$exports(''.slice);
var $fef26419665138ba$var$replace = $c224a7eda28c33b3$exports(''.replace);
var $fef26419665138ba$var$join = $c224a7eda28c33b3$exports([].join);
var $fef26419665138ba$var$CONFIGURABLE_LENGTH = $b9f536d3284d7921$exports && !$ddd8e9441ae136f2$exports(function() {
    return $fef26419665138ba$var$defineProperty(function() {}, 'length', {
        value: 8
    }).length !== 8;
});
var $fef26419665138ba$var$TEMPLATE = String(String).split('String');
var $fef26419665138ba$var$makeBuiltIn = $fef26419665138ba$exports = function makeBuiltIn(value, name, options) {
    if ($fef26419665138ba$var$stringSlice($fef26419665138ba$var$$String(name), 0, 7) === 'Symbol(') name = '[' + $fef26419665138ba$var$replace($fef26419665138ba$var$$String(name), /^Symbol\(([^)]*)\).*$/, '$1') + ']';
    if (options && options.getter) name = 'get ' + name;
    if (options && options.setter) name = 'set ' + name;
    if (!$8bbc2bccc0a29296$exports(value, 'name') || $fef26419665138ba$require$CONFIGURABLE_FUNCTION_NAME && value.name !== name) {
        if ($b9f536d3284d7921$exports) $fef26419665138ba$var$defineProperty(value, 'name', {
            value: name,
            configurable: true
        });
        else value.name = name;
    }
    if ($fef26419665138ba$var$CONFIGURABLE_LENGTH && options && $8bbc2bccc0a29296$exports(options, 'arity') && value.length !== options.arity) $fef26419665138ba$var$defineProperty(value, 'length', {
        value: options.arity
    });
    try {
        if (options && $8bbc2bccc0a29296$exports(options, 'constructor') && options.constructor) {
            if ($b9f536d3284d7921$exports) $fef26419665138ba$var$defineProperty(value, 'prototype', {
                writable: false
            });
        } else if (value.prototype) value.prototype = undefined;
    } catch (error) {}
    var state = $fef26419665138ba$var$enforceInternalState(value);
    if (!$8bbc2bccc0a29296$exports(state, 'source')) state.source = $fef26419665138ba$var$join($fef26419665138ba$var$TEMPLATE, typeof name == 'string' ? name : '');
    return value;
};
// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
// eslint-disable-next-line no-extend-native -- required
Function.prototype.toString = $fef26419665138ba$var$makeBuiltIn(function toString() {
    return $7c165f740ca92c53$exports(this) && $fef26419665138ba$var$getInternalState(this).source || $fe8e93358f2825b5$exports(this);
}, 'toString');



$73c8864ae5df5c4d$exports = function(O, key, value, options) {
    if (!options) options = {};
    var simple = options.enumerable;
    var name = options.name !== undefined ? options.name : key;
    if ($7c165f740ca92c53$exports(value)) $fef26419665138ba$exports(value, name, options);
    if (options.global) {
        if (simple) O[key] = value;
        else $4fd4b495a0b4f0da$exports(key, value);
    } else {
        try {
            if (!options.unsafe) delete O[key];
            else if (O[key]) simple = true;
        } catch (error) {}
        if (simple) O[key] = value;
        else $6f9fc35f567fa5b6$export$2d1720544b23b823(O, key, {
            value: value,
            enumerable: false,
            configurable: !options.nonConfigurable,
            writable: !options.nonWritable
        });
    }
    return O;
};



var $9a17c1c56e0da0fc$exports = {};
'use strict';

var $f90a310de5bd21d5$exports = {};
'use strict';


var $8b92903d5cdf859e$exports = {};

$parcel$export($8b92903d5cdf859e$exports, "f", function () { return $8b92903d5cdf859e$export$2d1720544b23b823; }, function (v) { return $8b92903d5cdf859e$export$2d1720544b23b823 = v; });
// `Object.getOwnPropertyNames` method
// https://tc39.es/ecma262/#sec-object.getownpropertynames
// eslint-disable-next-line es/no-object-getownpropertynames -- safe
var $8b92903d5cdf859e$export$2d1720544b23b823;
'use strict';
var $c4cd79fc1e12f67e$exports = {};
'use strict';



var $71c0092aac59bdd8$exports = {};
'use strict';

var $32c589906f6ca696$exports = {};
'use strict';
var $a8fecfd456e884de$exports = {};
'use strict';
var $87cc8b195947efa6$exports = {};
'use strict';
var $87cc8b195947efa6$var$ceil = Math.ceil;
var $87cc8b195947efa6$var$floor = Math.floor;
// `Math.trunc` method
// https://tc39.es/ecma262/#sec-math.trunc
// eslint-disable-next-line es/no-math-trunc -- safe
$87cc8b195947efa6$exports = Math.trunc || function trunc(x) {
    var n = +x;
    return (n > 0 ? $87cc8b195947efa6$var$floor : $87cc8b195947efa6$var$ceil)(n);
};


// `ToIntegerOrInfinity` abstract operation
// https://tc39.es/ecma262/#sec-tointegerorinfinity
$a8fecfd456e884de$exports = function(argument) {
    var number = +argument;
    // eslint-disable-next-line no-self-compare -- NaN check
    return number !== number || number === 0 ? 0 : $87cc8b195947efa6$exports(number);
};


var $32c589906f6ca696$var$max = Math.max;
var $32c589906f6ca696$var$min = Math.min;
// Helper for a popular repeating case of the spec:
// Let integer be ? ToInteger(index).
// If integer < 0, let result be max((length + integer), 0); else let result be min(integer, length).
$32c589906f6ca696$exports = function(index, length) {
    var integer = $a8fecfd456e884de$exports(index);
    return integer < 0 ? $32c589906f6ca696$var$max(integer + length, 0) : $32c589906f6ca696$var$min(integer, length);
};


var $dfe69c9cb1d4aa6b$exports = {};
'use strict';
var $aa75059f0a5ef94e$exports = {};
'use strict';

var $aa75059f0a5ef94e$var$min = Math.min;
// `ToLength` abstract operation
// https://tc39.es/ecma262/#sec-tolength
$aa75059f0a5ef94e$exports = function(argument) {
    var len = $a8fecfd456e884de$exports(argument);
    return len > 0 ? $aa75059f0a5ef94e$var$min(len, 0x1FFFFFFFFFFFFF) : 0; // 2 ** 53 - 1 == 9007199254740991
};


// `LengthOfArrayLike` abstract operation
// https://tc39.es/ecma262/#sec-lengthofarraylike
$dfe69c9cb1d4aa6b$exports = function(obj) {
    return $aa75059f0a5ef94e$exports(obj.length);
};


// `Array.prototype.{ indexOf, includes }` methods implementation
var $71c0092aac59bdd8$var$createMethod = function createMethod(IS_INCLUDES) {
    return function($this, el, fromIndex) {
        var O = $59a8f2f00edbf5a1$exports($this);
        var length = $dfe69c9cb1d4aa6b$exports(O);
        if (length === 0) return !IS_INCLUDES && -1;
        var index = $32c589906f6ca696$exports(fromIndex, length);
        var value;
        // Array#includes uses SameValueZero equality algorithm
        // eslint-disable-next-line no-self-compare -- NaN check
        if (IS_INCLUDES && el !== el) while(length > index){
            value = O[index++];
            // eslint-disable-next-line no-self-compare -- NaN check
            if (value !== value) return true;
        // Array#indexOf ignores holes, Array#includes - not
        }
        else for(; length > index; index++){
            if ((IS_INCLUDES || index in O) && O[index] === el) return IS_INCLUDES || index || 0;
        }
        return !IS_INCLUDES && -1;
    };
};
$71c0092aac59bdd8$exports = {
    // `Array.prototype.includes` method
    // https://tc39.es/ecma262/#sec-array.prototype.includes
    includes: $71c0092aac59bdd8$var$createMethod(true),
    // `Array.prototype.indexOf` method
    // https://tc39.es/ecma262/#sec-array.prototype.indexof
    indexOf: $71c0092aac59bdd8$var$createMethod(false)
};


var $c4cd79fc1e12f67e$require$indexOf = $71c0092aac59bdd8$exports.indexOf;

var $c4cd79fc1e12f67e$var$push = $c224a7eda28c33b3$exports([].push);
$c4cd79fc1e12f67e$exports = function(object, names) {
    var O = $59a8f2f00edbf5a1$exports(object);
    var i = 0;
    var result = [];
    var key;
    for(key in O)!$8bbc2bccc0a29296$exports($91deb02321ce445c$exports, key) && $8bbc2bccc0a29296$exports(O, key) && $c4cd79fc1e12f67e$var$push(result, key);
    // Don't enum bug & hidden keys
    while(names.length > i)if ($8bbc2bccc0a29296$exports(O, key = names[i++])) ~$c4cd79fc1e12f67e$require$indexOf(result, key) || $c4cd79fc1e12f67e$var$push(result, key);
    return result;
};


var $172a5d3741987f18$exports = {};
'use strict';
// IE8- don't enum bug keys
$172a5d3741987f18$exports = [
    'constructor',
    'hasOwnProperty',
    'isPrototypeOf',
    'propertyIsEnumerable',
    'toLocaleString',
    'toString',
    'valueOf'
];


var $8b92903d5cdf859e$var$hiddenKeys = $172a5d3741987f18$exports.concat('length', 'prototype');
$8b92903d5cdf859e$export$2d1720544b23b823 = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
    return $c4cd79fc1e12f67e$exports(O, $8b92903d5cdf859e$var$hiddenKeys);
};


var $f459638151f85e39$exports = {};

$parcel$export($f459638151f85e39$exports, "f", function () { return $f459638151f85e39$export$2d1720544b23b823; }, function (v) { return $f459638151f85e39$export$2d1720544b23b823 = v; });
// eslint-disable-next-line es/no-object-getownpropertysymbols -- safe
var $f459638151f85e39$export$2d1720544b23b823;
'use strict';
$f459638151f85e39$export$2d1720544b23b823 = Object.getOwnPropertySymbols;



var $f90a310de5bd21d5$var$concat = $c224a7eda28c33b3$exports([].concat);
// all object keys, includes non-enumerable and symbols
$f90a310de5bd21d5$exports = $e8972ff3cf85d361$exports('Reflect', 'ownKeys') || function ownKeys(it) {
    var keys = $8b92903d5cdf859e$export$2d1720544b23b823($7d9b9f0a2a7e34a2$exports(it));
    var getOwnPropertySymbols = $f459638151f85e39$export$2d1720544b23b823;
    return getOwnPropertySymbols ? $f90a310de5bd21d5$var$concat(keys, getOwnPropertySymbols(it)) : keys;
};




$9a17c1c56e0da0fc$exports = function(target, source, exceptions) {
    var keys = $f90a310de5bd21d5$exports(source);
    var defineProperty = $6f9fc35f567fa5b6$export$2d1720544b23b823;
    var getOwnPropertyDescriptor = $70871da05e9d21bf$export$2d1720544b23b823;
    for(var i = 0; i < keys.length; i++){
        var key = keys[i];
        if (!$8bbc2bccc0a29296$exports(target, key) && !(exceptions && $8bbc2bccc0a29296$exports(exceptions, key))) defineProperty(target, key, getOwnPropertyDescriptor(source, key));
    }
};


var $0ae261ce45c3c073$exports = {};
'use strict';


var $0ae261ce45c3c073$var$replacement = /#|\.prototype\./;
var $0ae261ce45c3c073$var$isForced = function isForced(feature, detection) {
    var value = $0ae261ce45c3c073$var$data[$0ae261ce45c3c073$var$normalize(feature)];
    return value === $0ae261ce45c3c073$var$POLYFILL ? true : value === $0ae261ce45c3c073$var$NATIVE ? false : $7c165f740ca92c53$exports(detection) ? $ddd8e9441ae136f2$exports(detection) : !!detection;
};
var $0ae261ce45c3c073$var$normalize = $0ae261ce45c3c073$var$isForced.normalize = function normalize(string) {
    return String(string).replace($0ae261ce45c3c073$var$replacement, '.').toLowerCase();
};
var $0ae261ce45c3c073$var$data = $0ae261ce45c3c073$var$isForced.data = {};
var $0ae261ce45c3c073$var$NATIVE = $0ae261ce45c3c073$var$isForced.NATIVE = 'N';
var $0ae261ce45c3c073$var$POLYFILL = $0ae261ce45c3c073$var$isForced.POLYFILL = 'P';
$0ae261ce45c3c073$exports = $0ae261ce45c3c073$var$isForced;


/*
  options.target         - name of the target object
  options.global         - target is the global object
  options.stat           - export as static methods of target
  options.proto          - export as prototype methods of target
  options.real           - real prototype method for the `pure` version
  options.forced         - export even if the native feature is available
  options.bind           - bind methods to the target, required for the `pure` version
  options.wrap           - wrap constructors to preventing global pollution, required for the `pure` version
  options.unsafe         - use the simple assignment of property instead of delete + defineProperty
  options.sham           - add a flag to not completely full polyfills
  options.enumerable     - export as enumerable property
  options.dontCallGetSet - prevent calling a getter on target
  options.name           - the .name of the function if it does not match the key
*/ $244155c096ef4c14$exports = function(options, source) {
    var TARGET = options.target;
    var GLOBAL = options.global;
    var STATIC = options.stat;
    var FORCED, target, key, targetProperty, sourceProperty, descriptor;
    if (GLOBAL) target = $27350b6a9e85aed1$exports;
    else if (STATIC) target = $27350b6a9e85aed1$exports[TARGET] || $4fd4b495a0b4f0da$exports(TARGET, {});
    else target = $27350b6a9e85aed1$exports[TARGET] && $27350b6a9e85aed1$exports[TARGET].prototype;
    if (target) for(key in source){
        sourceProperty = source[key];
        if (options.dontCallGetSet) {
            descriptor = $244155c096ef4c14$require$getOwnPropertyDescriptor(target, key);
            targetProperty = descriptor && descriptor.value;
        } else targetProperty = target[key];
        FORCED = $0ae261ce45c3c073$exports(GLOBAL ? key : TARGET + (STATIC ? '.' : '#') + key, options.forced);
        // contained in target
        if (!FORCED && targetProperty !== undefined) {
            if ((typeof sourceProperty === "undefined" ? "undefined" : (0, $6tOPT._)(sourceProperty)) == (typeof targetProperty === "undefined" ? "undefined" : (0, $6tOPT._)(targetProperty))) continue;
            $9a17c1c56e0da0fc$exports(sourceProperty, targetProperty);
        }
        // add a flag to not completely full polyfills
        if (options.sham || targetProperty && targetProperty.sham) $b390530569770271$exports(sourceProperty, 'sham', true);
        $73c8864ae5df5c4d$exports(target, key, sourceProperty, options);
    }
};














var $7c610b7ee22557b5$exports = {};
'use strict';
var $b720974ac29b37e2$exports = {};
'use strict';
var $9b82848ada619f8e$exports = {};
'use strict';

var $9b82848ada619f8e$var$TO_STRING_TAG = $8555fb22f74da29f$exports('toStringTag');
var $9b82848ada619f8e$var$test = {};
// eslint-disable-next-line unicorn/no-immediate-mutation -- ES3 syntax limitation
$9b82848ada619f8e$var$test[$9b82848ada619f8e$var$TO_STRING_TAG] = 'z';
$9b82848ada619f8e$exports = String($9b82848ada619f8e$var$test) === '[object z]';





var $b720974ac29b37e2$var$TO_STRING_TAG = $8555fb22f74da29f$exports('toStringTag');
var $b720974ac29b37e2$var$$Object = Object;
// ES3 wrong here
var $b720974ac29b37e2$var$CORRECT_ARGUMENTS = $5a266b01e7970e30$exports(function() {
    return arguments;
}()) === 'Arguments';
// fallback for IE11 Script Access Denied error
var $b720974ac29b37e2$var$tryGet = function tryGet(it, key) {
    try {
        return it[key];
    } catch (error) {}
};
// getting tag from ES6+ `Object.prototype.toString`
$b720974ac29b37e2$exports = $9b82848ada619f8e$exports ? $5a266b01e7970e30$exports : function(it) {
    var O, tag, result;
    return it === undefined ? 'Undefined' : it === null ? 'Null' : typeof (tag = $b720974ac29b37e2$var$tryGet(O = $b720974ac29b37e2$var$$Object(it), $b720974ac29b37e2$var$TO_STRING_TAG)) == 'string' ? tag : $b720974ac29b37e2$var$CORRECT_ARGUMENTS ? $5a266b01e7970e30$exports(O) : (result = $5a266b01e7970e30$exports(O)) === 'Object' && $7c165f740ca92c53$exports(O.callee) ? 'Arguments' : result;
};


var $7c610b7ee22557b5$var$$String = String;
$7c610b7ee22557b5$exports = function(argument) {
    if ($b720974ac29b37e2$exports(argument) === 'Symbol') throw new TypeError('Cannot convert a Symbol value to a string');
    return $7c610b7ee22557b5$var$$String(argument);
};



var $491a5d5aa2efe6ec$exports = {};
'use strict';

var $f6e3282a041903a4$exports = {};

$parcel$export($f6e3282a041903a4$exports, "f", function () { return $f6e3282a041903a4$export$2d1720544b23b823; }, function (v) { return $f6e3282a041903a4$export$2d1720544b23b823 = v; });
// `Object.defineProperties` method
// https://tc39.es/ecma262/#sec-object.defineproperties
// eslint-disable-next-line es/no-object-defineproperties -- safe
var $f6e3282a041903a4$export$2d1720544b23b823;
'use strict';





var $ed3a442fad5fbe57$exports = {};
'use strict';


// `Object.keys` method
// https://tc39.es/ecma262/#sec-object.keys
// eslint-disable-next-line es/no-object-keys -- safe
$ed3a442fad5fbe57$exports = Object.keys || function keys(O) {
    return $c4cd79fc1e12f67e$exports(O, $172a5d3741987f18$exports);
};


$f6e3282a041903a4$export$2d1720544b23b823 = $b9f536d3284d7921$exports && !$57b39386d98b1237$exports ? Object.defineProperties : function defineProperties(O, Properties) {
    $7d9b9f0a2a7e34a2$exports(O);
    var props = $59a8f2f00edbf5a1$exports(Properties);
    var keys = $ed3a442fad5fbe57$exports(Properties);
    var length = keys.length;
    var index = 0;
    var key;
    while(length > index)$6f9fc35f567fa5b6$export$2d1720544b23b823(O, key = keys[index++], props[key]);
    return O;
};




var $42f7da397525bafb$exports = {};
'use strict';

$42f7da397525bafb$exports = $e8972ff3cf85d361$exports('document', 'documentElement');




var $491a5d5aa2efe6ec$var$GT = '>';
var $491a5d5aa2efe6ec$var$LT = '<';
var $491a5d5aa2efe6ec$var$PROTOTYPE = 'prototype';
var $491a5d5aa2efe6ec$var$SCRIPT = 'script';
var $491a5d5aa2efe6ec$var$IE_PROTO = $f2e10c313ac02773$exports('IE_PROTO');
var $491a5d5aa2efe6ec$var$EmptyConstructor = function EmptyConstructor() {};
var $491a5d5aa2efe6ec$var$scriptTag = function scriptTag(content) {
    return $491a5d5aa2efe6ec$var$LT + $491a5d5aa2efe6ec$var$SCRIPT + $491a5d5aa2efe6ec$var$GT + content + $491a5d5aa2efe6ec$var$LT + '/' + $491a5d5aa2efe6ec$var$SCRIPT + $491a5d5aa2efe6ec$var$GT;
};
// Create object with fake `null` prototype: use ActiveX Object with cleared prototype
var $491a5d5aa2efe6ec$var$NullProtoObjectViaActiveX = function NullProtoObjectViaActiveX(activeXDocument) {
    activeXDocument.write($491a5d5aa2efe6ec$var$scriptTag(''));
    activeXDocument.close();
    var temp = activeXDocument.parentWindow.Object;
    // eslint-disable-next-line no-useless-assignment -- avoid memory leak
    activeXDocument = null;
    return temp;
};
// Create object with fake `null` prototype: use iframe Object with cleared prototype
var $491a5d5aa2efe6ec$var$NullProtoObjectViaIFrame = function NullProtoObjectViaIFrame() {
    // Thrash, waste and sodomy: IE GC bug
    var iframe = $9615a1abb0018505$exports('iframe');
    var JS = 'java' + $491a5d5aa2efe6ec$var$SCRIPT + ':';
    var iframeDocument;
    iframe.style.display = 'none';
    $42f7da397525bafb$exports.appendChild(iframe);
    // https://github.com/zloirock/core-js/issues/475
    iframe.src = String(JS);
    iframeDocument = iframe.contentWindow.document;
    iframeDocument.open();
    iframeDocument.write($491a5d5aa2efe6ec$var$scriptTag('document.F=Object'));
    iframeDocument.close();
    return iframeDocument.F;
};
// Check for document.domain and active x support
// No need to use active x approach when document.domain is not set
// see https://github.com/es-shims/es5-shim/issues/150
// variation of https://github.com/kitcambridge/es5-shim/commit/4f738ac066346
// avoid IE GC bug
var $491a5d5aa2efe6ec$var$activeXDocument;
var $491a5d5aa2efe6ec$var$NullProtoObject = function NullProtoObject1() {
    try {
        $491a5d5aa2efe6ec$var$activeXDocument = new ActiveXObject('htmlfile');
    } catch (error) {}
    $491a5d5aa2efe6ec$var$NullProtoObject = typeof document != 'undefined' ? document.domain && $491a5d5aa2efe6ec$var$activeXDocument ? $491a5d5aa2efe6ec$var$NullProtoObjectViaActiveX($491a5d5aa2efe6ec$var$activeXDocument) // old IE
     : $491a5d5aa2efe6ec$var$NullProtoObjectViaIFrame() : $491a5d5aa2efe6ec$var$NullProtoObjectViaActiveX($491a5d5aa2efe6ec$var$activeXDocument); // WSH
    var length = $172a5d3741987f18$exports.length;
    while(length--)delete $491a5d5aa2efe6ec$var$NullProtoObject[$491a5d5aa2efe6ec$var$PROTOTYPE][$172a5d3741987f18$exports[length]];
    return $491a5d5aa2efe6ec$var$NullProtoObject();
};
$91deb02321ce445c$exports[$491a5d5aa2efe6ec$var$IE_PROTO] = true;
// `Object.create` method
// https://tc39.es/ecma262/#sec-object.create
// eslint-disable-next-line es/no-object-create -- safe
$491a5d5aa2efe6ec$exports = Object.create || function create(O, Properties) {
    var result;
    if (O !== null) {
        $491a5d5aa2efe6ec$var$EmptyConstructor[$491a5d5aa2efe6ec$var$PROTOTYPE] = $7d9b9f0a2a7e34a2$exports(O);
        result = new $491a5d5aa2efe6ec$var$EmptyConstructor();
        $491a5d5aa2efe6ec$var$EmptyConstructor[$491a5d5aa2efe6ec$var$PROTOTYPE] = null;
        // add "__proto__" for Object.getPrototypeOf polyfill
        result[$491a5d5aa2efe6ec$var$IE_PROTO] = O;
    } else result = $491a5d5aa2efe6ec$var$NullProtoObject();
    return Properties === undefined ? result : $f6e3282a041903a4$export$2d1720544b23b823(result, Properties);
};




var $96008a693f58af2b$exports = {};

$parcel$export($96008a693f58af2b$exports, "f", function () { return $96008a693f58af2b$export$2d1720544b23b823; }, function (v) { return $96008a693f58af2b$export$2d1720544b23b823 = v; });

var $6tOPT = parcelRequire("6tOPT");
// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
var $96008a693f58af2b$export$2d1720544b23b823;
'use strict';



var $96008a693f58af2b$require$$getOwnPropertyNames = $8b92903d5cdf859e$export$2d1720544b23b823;
var $2dd14968e62d6eb1$exports = {};
'use strict';

$2dd14968e62d6eb1$exports = $c224a7eda28c33b3$exports([].slice);


var $96008a693f58af2b$var$windowNames = (typeof window === "undefined" ? "undefined" : (0, $6tOPT._)(window)) == 'object' && window && Object.getOwnPropertyNames ? Object.getOwnPropertyNames(window) : [];
var $96008a693f58af2b$var$getWindowNames = function getWindowNames(it) {
    try {
        return $96008a693f58af2b$require$$getOwnPropertyNames(it);
    } catch (error) {
        return $2dd14968e62d6eb1$exports($96008a693f58af2b$var$windowNames);
    }
};
$96008a693f58af2b$export$2d1720544b23b823 = function getOwnPropertyNames(it) {
    return $96008a693f58af2b$var$windowNames && $5a266b01e7970e30$exports(it) === 'Window' ? $96008a693f58af2b$var$getWindowNames(it) : $96008a693f58af2b$require$$getOwnPropertyNames($59a8f2f00edbf5a1$exports(it));
};








var $71a985fce44d8187$exports = {};
'use strict';


$71a985fce44d8187$exports = function(target, name, descriptor) {
    if (descriptor.get) $fef26419665138ba$exports(descriptor.get, name, {
        getter: true
    });
    if (descriptor.set) $fef26419665138ba$exports(descriptor.set, name, {
        setter: true
    });
    return $6f9fc35f567fa5b6$export$2d1720544b23b823(target, name, descriptor);
};







var $bde54fcf696f6645$exports = {};

$parcel$export($bde54fcf696f6645$exports, "f", function () { return $bde54fcf696f6645$export$2d1720544b23b823; }, function (v) { return $bde54fcf696f6645$export$2d1720544b23b823 = v; });
var $bde54fcf696f6645$export$2d1720544b23b823;
'use strict';

$bde54fcf696f6645$export$2d1720544b23b823 = $8555fb22f74da29f$exports;


var $a8630b65c875dcc7$exports = {};
'use strict';
var $d2336b2aa2640a45$exports = {};
'use strict';

$d2336b2aa2640a45$exports = $27350b6a9e85aed1$exports;





var $a8630b65c875dcc7$require$defineProperty = $6f9fc35f567fa5b6$export$2d1720544b23b823;
$a8630b65c875dcc7$exports = function(NAME) {
    var Symbol = $d2336b2aa2640a45$exports.Symbol || ($d2336b2aa2640a45$exports.Symbol = {});
    if (!$8bbc2bccc0a29296$exports(Symbol, NAME)) $a8630b65c875dcc7$require$defineProperty(Symbol, NAME, {
        value: $bde54fcf696f6645$export$2d1720544b23b823(NAME)
    });
};


var $af024b297d3b01cc$exports = {};
'use strict';




$af024b297d3b01cc$exports = function() {
    var Symbol = $e8972ff3cf85d361$exports('Symbol');
    var SymbolPrototype = Symbol && Symbol.prototype;
    var valueOf = SymbolPrototype && SymbolPrototype.valueOf;
    var TO_PRIMITIVE = $8555fb22f74da29f$exports('toPrimitive');
    if (SymbolPrototype && !SymbolPrototype[TO_PRIMITIVE]) // `Symbol.prototype[@@toPrimitive]` method
    // https://tc39.es/ecma262/#sec-symbol.prototype-@@toprimitive
    // eslint-disable-next-line no-unused-vars -- required for .length
    $73c8864ae5df5c4d$exports(SymbolPrototype, TO_PRIMITIVE, function(hint) {
        return $59bf80837927ca02$exports(valueOf, this);
    }, {
        arity: 1
    });
};


var $54a3ba2fb7b04ac0$exports = {};
'use strict';

var $54a3ba2fb7b04ac0$require$defineProperty = $6f9fc35f567fa5b6$export$2d1720544b23b823;


var $54a3ba2fb7b04ac0$var$TO_STRING_TAG = $8555fb22f74da29f$exports('toStringTag');
$54a3ba2fb7b04ac0$exports = function(target, TAG, STATIC) {
    if (target && !STATIC) target = target.prototype;
    if (target && !$8bbc2bccc0a29296$exports(target, $54a3ba2fb7b04ac0$var$TO_STRING_TAG)) $54a3ba2fb7b04ac0$require$defineProperty(target, $54a3ba2fb7b04ac0$var$TO_STRING_TAG, {
        configurable: true,
        value: TAG
    });
};



var $549edc5c9a026f8b$exports = {};
'use strict';
var $8a0b7edcb386df4b$exports = {};
'use strict';
var $262d820f61605b50$exports = {};
'use strict';


$262d820f61605b50$exports = function(fn) {
    // Nashorn bug:
    //   https://github.com/zloirock/core-js/issues/1128
    //   https://github.com/zloirock/core-js/issues/1130
    if ($5a266b01e7970e30$exports(fn) === 'Function') return $c224a7eda28c33b3$exports(fn);
};




var $8a0b7edcb386df4b$var$bind = $262d820f61605b50$exports($262d820f61605b50$exports.bind);
// optional / simple context binding
$8a0b7edcb386df4b$exports = function(fn, that) {
    $082fcaa0a091ee30$exports(fn);
    return that === undefined ? fn : $37d783b2348274b4$exports ? $8a0b7edcb386df4b$var$bind(fn, that) : function() {
        return fn.apply(that, arguments);
    };
};





var $9dd5766bb20abe7e$exports = {};
'use strict';
var $8d150acfd15898bb$exports = {};
'use strict';
var $b95992045c940cb8$exports = {};
'use strict';

// `IsArray` abstract operation
// https://tc39.es/ecma262/#sec-isarray
// eslint-disable-next-line es/no-array-isarray -- safe
$b95992045c940cb8$exports = Array.isArray || function isArray(argument) {
    return $5a266b01e7970e30$exports(argument) === 'Array';
};


var $db2ba5677c412211$exports = {};
'use strict';






var $db2ba5677c412211$var$noop = function noop() {};
var $db2ba5677c412211$var$construct = $e8972ff3cf85d361$exports('Reflect', 'construct');
var $db2ba5677c412211$var$constructorRegExp = /^\s*(?:class|function)\b/;
var $db2ba5677c412211$var$exec = $c224a7eda28c33b3$exports($db2ba5677c412211$var$constructorRegExp.exec);
var $db2ba5677c412211$var$INCORRECT_TO_STRING = !$db2ba5677c412211$var$constructorRegExp.test($db2ba5677c412211$var$noop);
var $db2ba5677c412211$var$isConstructorModern = function isConstructor(argument) {
    if (!$7c165f740ca92c53$exports(argument)) return false;
    try {
        $db2ba5677c412211$var$construct($db2ba5677c412211$var$noop, [], argument);
        return true;
    } catch (error) {
        return false;
    }
};
var $db2ba5677c412211$var$isConstructorLegacy = function isConstructor(argument) {
    if (!$7c165f740ca92c53$exports(argument)) return false;
    switch($b720974ac29b37e2$exports(argument)){
        case 'AsyncFunction':
        case 'GeneratorFunction':
        case 'AsyncGeneratorFunction':
            return false;
    }
    try {
        // we can't check .prototype since constructors produced by .bind haven't it
        // `Function#toString` throws on some built-it function in some legacy engines
        // (for example, `DOMQuad` and similar in FF41-)
        return $db2ba5677c412211$var$INCORRECT_TO_STRING || !!$db2ba5677c412211$var$exec($db2ba5677c412211$var$constructorRegExp, $fe8e93358f2825b5$exports(argument));
    } catch (error) {
        return true;
    }
};
$db2ba5677c412211$var$isConstructorLegacy.sham = true;
// `IsConstructor` abstract operation
// https://tc39.es/ecma262/#sec-isconstructor
$db2ba5677c412211$exports = !$db2ba5677c412211$var$construct || $ddd8e9441ae136f2$exports(function() {
    var called;
    return $db2ba5677c412211$var$isConstructorModern($db2ba5677c412211$var$isConstructorModern.call) || !$db2ba5677c412211$var$isConstructorModern(Object) || !$db2ba5677c412211$var$isConstructorModern(function() {
        called = true;
    }) || called;
}) ? $db2ba5677c412211$var$isConstructorLegacy : $db2ba5677c412211$var$isConstructorModern;




var $8d150acfd15898bb$var$SPECIES = $8555fb22f74da29f$exports('species');
var $8d150acfd15898bb$var$$Array = Array;
// a part of `ArraySpeciesCreate` abstract operation
// https://tc39.es/ecma262/#sec-arrayspeciescreate
$8d150acfd15898bb$exports = function(originalArray) {
    var C;
    if ($b95992045c940cb8$exports(originalArray)) {
        C = originalArray.constructor;
        // cross-realm fallback
        if ($db2ba5677c412211$exports(C) && (C === $8d150acfd15898bb$var$$Array || $b95992045c940cb8$exports(C.prototype))) C = undefined;
        else if ($4d7f82f6c4645870$exports(C)) {
            C = C[$8d150acfd15898bb$var$SPECIES];
            if (C === null) C = undefined;
        }
    }
    return C === undefined ? $8d150acfd15898bb$var$$Array : C;
};


// `ArraySpeciesCreate` abstract operation
// https://tc39.es/ecma262/#sec-arrayspeciescreate
$9dd5766bb20abe7e$exports = function(originalArray, length) {
    return new ($8d150acfd15898bb$exports(originalArray))(length === 0 ? 0 : length);
};


var $7e31aa0800ea6c75$exports = {};
'use strict';



$7e31aa0800ea6c75$exports = function(object, key, value) {
    if ($b9f536d3284d7921$exports) $6f9fc35f567fa5b6$export$2d1720544b23b823(object, key, $27c455d39660edb8$exports(0, value));
    else object[key] = value;
};


// `Array.prototype.{ forEach, map, filter, some, every, find, findIndex, filterReject }` methods implementation
var $549edc5c9a026f8b$var$createMethod = function createMethod(TYPE) {
    var IS_MAP = TYPE === 1;
    var IS_FILTER = TYPE === 2;
    var IS_SOME = TYPE === 3;
    var IS_EVERY = TYPE === 4;
    var IS_FIND_INDEX = TYPE === 6;
    var IS_FILTER_REJECT = TYPE === 7;
    var NO_HOLES = TYPE === 5 || IS_FIND_INDEX;
    return function($this, callbackfn, that) {
        var O = $ad1d9797f1e27af5$exports($this);
        var self = $7a4c0b5af5b2bbd3$exports(O);
        var length = $dfe69c9cb1d4aa6b$exports(self);
        var boundFunction = $8a0b7edcb386df4b$exports(callbackfn, that);
        var index = 0;
        var resIndex = 0;
        var target = IS_MAP ? $9dd5766bb20abe7e$exports($this, length) : IS_FILTER || IS_FILTER_REJECT ? $9dd5766bb20abe7e$exports($this, 0) : undefined;
        var value, result;
        for(; length > index; index++)if (NO_HOLES || index in self) {
            value = self[index];
            result = boundFunction(value, index, O);
            if (TYPE) {
                if (IS_MAP) $7e31aa0800ea6c75$exports(target, index, result); // map
                else if (result) switch(TYPE){
                    case 3:
                        return true; // some
                    case 5:
                        return value; // find
                    case 6:
                        return index; // findIndex
                    case 2:
                        $7e31aa0800ea6c75$exports(target, resIndex++, value); // filter
                }
                else switch(TYPE){
                    case 4:
                        return false; // every
                    case 7:
                        $7e31aa0800ea6c75$exports(target, resIndex++, value); // filterReject
                }
            }
        }
        return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : target;
    };
};
$549edc5c9a026f8b$exports = {
    // `Array.prototype.forEach` method
    // https://tc39.es/ecma262/#sec-array.prototype.foreach
    forEach: $549edc5c9a026f8b$var$createMethod(0),
    // `Array.prototype.map` method
    // https://tc39.es/ecma262/#sec-array.prototype.map
    map: $549edc5c9a026f8b$var$createMethod(1),
    // `Array.prototype.filter` method
    // https://tc39.es/ecma262/#sec-array.prototype.filter
    filter: $549edc5c9a026f8b$var$createMethod(2),
    // `Array.prototype.some` method
    // https://tc39.es/ecma262/#sec-array.prototype.some
    some: $549edc5c9a026f8b$var$createMethod(3),
    // `Array.prototype.every` method
    // https://tc39.es/ecma262/#sec-array.prototype.every
    every: $549edc5c9a026f8b$var$createMethod(4),
    // `Array.prototype.find` method
    // https://tc39.es/ecma262/#sec-array.prototype.find
    find: $549edc5c9a026f8b$var$createMethod(5),
    // `Array.prototype.findIndex` method
    // https://tc39.es/ecma262/#sec-array.prototype.findIndex
    findIndex: $549edc5c9a026f8b$var$createMethod(6),
    // `Array.prototype.filterReject` method
    // https://github.com/tc39/proposal-array-filtering
    filterReject: $549edc5c9a026f8b$var$createMethod(7)
};


var $e501a92b62fe2f9e$require$$forEach = $549edc5c9a026f8b$exports.forEach;
var $e501a92b62fe2f9e$var$HIDDEN = $f2e10c313ac02773$exports('hidden');
var $e501a92b62fe2f9e$var$SYMBOL = 'Symbol';
var $e501a92b62fe2f9e$var$PROTOTYPE = 'prototype';
var $e501a92b62fe2f9e$var$setInternalState = $fcfe8b5396fbe91a$exports.set;
var $e501a92b62fe2f9e$var$getInternalState = $fcfe8b5396fbe91a$exports.getterFor($e501a92b62fe2f9e$var$SYMBOL);
var $e501a92b62fe2f9e$var$ObjectPrototype = Object[$e501a92b62fe2f9e$var$PROTOTYPE];
var $e501a92b62fe2f9e$var$$Symbol = $27350b6a9e85aed1$exports.Symbol;
var $e501a92b62fe2f9e$var$SymbolPrototype = $e501a92b62fe2f9e$var$$Symbol && $e501a92b62fe2f9e$var$$Symbol[$e501a92b62fe2f9e$var$PROTOTYPE];
var $e501a92b62fe2f9e$var$RangeError = $27350b6a9e85aed1$exports.RangeError;
var $e501a92b62fe2f9e$var$TypeError = $27350b6a9e85aed1$exports.TypeError;
var $e501a92b62fe2f9e$var$QObject = $27350b6a9e85aed1$exports.QObject;
var $e501a92b62fe2f9e$var$nativeGetOwnPropertyDescriptor = $70871da05e9d21bf$export$2d1720544b23b823;
var $e501a92b62fe2f9e$var$nativeDefineProperty = $6f9fc35f567fa5b6$export$2d1720544b23b823;
var $e501a92b62fe2f9e$var$nativeGetOwnPropertyNames = $96008a693f58af2b$export$2d1720544b23b823;
var $e501a92b62fe2f9e$var$nativePropertyIsEnumerable = $246f5b02cd4c126c$export$2d1720544b23b823;
var $e501a92b62fe2f9e$var$push = $c224a7eda28c33b3$exports([].push);
var $e501a92b62fe2f9e$var$AllSymbols = $bf195d0f48f561ca$exports('symbols');
var $e501a92b62fe2f9e$var$ObjectPrototypeSymbols = $bf195d0f48f561ca$exports('op-symbols');
var $e501a92b62fe2f9e$var$WellKnownSymbolsStore = $bf195d0f48f561ca$exports('wks');
// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
var $e501a92b62fe2f9e$var$USE_SETTER = !$e501a92b62fe2f9e$var$QObject || !$e501a92b62fe2f9e$var$QObject[$e501a92b62fe2f9e$var$PROTOTYPE] || !$e501a92b62fe2f9e$var$QObject[$e501a92b62fe2f9e$var$PROTOTYPE].findChild;
// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
var $e501a92b62fe2f9e$var$fallbackDefineProperty = function fallbackDefineProperty(O, P, Attributes) {
    var ObjectPrototypeDescriptor = $e501a92b62fe2f9e$var$nativeGetOwnPropertyDescriptor($e501a92b62fe2f9e$var$ObjectPrototype, P);
    if (ObjectPrototypeDescriptor) delete $e501a92b62fe2f9e$var$ObjectPrototype[P];
    $e501a92b62fe2f9e$var$nativeDefineProperty(O, P, Attributes);
    if (ObjectPrototypeDescriptor && O !== $e501a92b62fe2f9e$var$ObjectPrototype) $e501a92b62fe2f9e$var$nativeDefineProperty($e501a92b62fe2f9e$var$ObjectPrototype, P, ObjectPrototypeDescriptor);
    return O;
};
var $e501a92b62fe2f9e$var$setSymbolDescriptor = $b9f536d3284d7921$exports && $ddd8e9441ae136f2$exports(function() {
    return $491a5d5aa2efe6ec$exports($e501a92b62fe2f9e$var$nativeDefineProperty({}, 'a', {
        get: function get() {
            return $e501a92b62fe2f9e$var$nativeDefineProperty(this, 'a', {
                value: 7
            }).a;
        }
    })).a !== 7;
}) ? $e501a92b62fe2f9e$var$fallbackDefineProperty : $e501a92b62fe2f9e$var$nativeDefineProperty;
var $e501a92b62fe2f9e$var$wrap = function wrap(tag, description) {
    var symbol = $e501a92b62fe2f9e$var$AllSymbols[tag] = $491a5d5aa2efe6ec$exports($e501a92b62fe2f9e$var$SymbolPrototype);
    $e501a92b62fe2f9e$var$setInternalState(symbol, {
        type: $e501a92b62fe2f9e$var$SYMBOL,
        tag: tag,
        description: description
    });
    if (!$b9f536d3284d7921$exports) symbol.description = description;
    return symbol;
};
var $e501a92b62fe2f9e$var$$defineProperty = function defineProperty(O, P, Attributes) {
    if (O === $e501a92b62fe2f9e$var$ObjectPrototype) $e501a92b62fe2f9e$var$$defineProperty($e501a92b62fe2f9e$var$ObjectPrototypeSymbols, P, Attributes);
    $7d9b9f0a2a7e34a2$exports(O);
    var key = $d9a9cf8e89852c56$exports(P);
    $7d9b9f0a2a7e34a2$exports(Attributes);
    if ($8bbc2bccc0a29296$exports($e501a92b62fe2f9e$var$AllSymbols, key)) {
        // first definition - default non-enumerable; redefinition - preserve existing state
        if (!('enumerable' in Attributes) ? !$8bbc2bccc0a29296$exports(O, key) || $8bbc2bccc0a29296$exports(O, $e501a92b62fe2f9e$var$HIDDEN) && O[$e501a92b62fe2f9e$var$HIDDEN][key] : !Attributes.enumerable) {
            if (!$8bbc2bccc0a29296$exports(O, $e501a92b62fe2f9e$var$HIDDEN)) $e501a92b62fe2f9e$var$nativeDefineProperty(O, $e501a92b62fe2f9e$var$HIDDEN, $27c455d39660edb8$exports(1, $491a5d5aa2efe6ec$exports(null)));
            O[$e501a92b62fe2f9e$var$HIDDEN][key] = true;
        } else {
            if ($8bbc2bccc0a29296$exports(O, $e501a92b62fe2f9e$var$HIDDEN) && O[$e501a92b62fe2f9e$var$HIDDEN][key]) O[$e501a92b62fe2f9e$var$HIDDEN][key] = false;
            Attributes = $491a5d5aa2efe6ec$exports(Attributes, {
                enumerable: $27c455d39660edb8$exports(0, false)
            });
        }
        return $e501a92b62fe2f9e$var$setSymbolDescriptor(O, key, Attributes);
    }
    return $e501a92b62fe2f9e$var$nativeDefineProperty(O, key, Attributes);
};
var $e501a92b62fe2f9e$var$$defineProperties = function defineProperties(O, Properties) {
    $7d9b9f0a2a7e34a2$exports(O);
    var properties = $59a8f2f00edbf5a1$exports(Properties);
    var keys = $ed3a442fad5fbe57$exports(properties).concat($e501a92b62fe2f9e$var$$getOwnPropertySymbols(properties));
    $e501a92b62fe2f9e$require$$forEach(keys, function(key) {
        if (!$b9f536d3284d7921$exports || $59bf80837927ca02$exports($e501a92b62fe2f9e$var$$propertyIsEnumerable, properties, key)) $e501a92b62fe2f9e$var$$defineProperty(O, key, properties[key]);
    });
    return O;
};
var $e501a92b62fe2f9e$var$$create = function create(O, Properties) {
    return Properties === undefined ? $491a5d5aa2efe6ec$exports(O) : $e501a92b62fe2f9e$var$$defineProperties($491a5d5aa2efe6ec$exports(O), Properties);
};
var $e501a92b62fe2f9e$var$$propertyIsEnumerable = function propertyIsEnumerable(V) {
    var P = $d9a9cf8e89852c56$exports(V);
    var enumerable = $59bf80837927ca02$exports($e501a92b62fe2f9e$var$nativePropertyIsEnumerable, this, P);
    if (this === $e501a92b62fe2f9e$var$ObjectPrototype && $8bbc2bccc0a29296$exports($e501a92b62fe2f9e$var$AllSymbols, P) && !$8bbc2bccc0a29296$exports($e501a92b62fe2f9e$var$ObjectPrototypeSymbols, P)) return false;
    return enumerable || !$8bbc2bccc0a29296$exports(this, P) || !$8bbc2bccc0a29296$exports($e501a92b62fe2f9e$var$AllSymbols, P) || $8bbc2bccc0a29296$exports(this, $e501a92b62fe2f9e$var$HIDDEN) && this[$e501a92b62fe2f9e$var$HIDDEN][P] ? enumerable : true;
};
var $e501a92b62fe2f9e$var$$getOwnPropertyDescriptor = function getOwnPropertyDescriptor(O, P) {
    var it = $59a8f2f00edbf5a1$exports(O);
    var key = $d9a9cf8e89852c56$exports(P);
    if (it === $e501a92b62fe2f9e$var$ObjectPrototype && $8bbc2bccc0a29296$exports($e501a92b62fe2f9e$var$AllSymbols, key) && !$8bbc2bccc0a29296$exports($e501a92b62fe2f9e$var$ObjectPrototypeSymbols, key)) return;
    var descriptor = $e501a92b62fe2f9e$var$nativeGetOwnPropertyDescriptor(it, key);
    if (descriptor && $8bbc2bccc0a29296$exports($e501a92b62fe2f9e$var$AllSymbols, key) && !($8bbc2bccc0a29296$exports(it, $e501a92b62fe2f9e$var$HIDDEN) && it[$e501a92b62fe2f9e$var$HIDDEN][key])) descriptor.enumerable = true;
    return descriptor;
};
var $e501a92b62fe2f9e$var$$getOwnPropertyNames = function getOwnPropertyNames(O) {
    var names = $e501a92b62fe2f9e$var$nativeGetOwnPropertyNames($59a8f2f00edbf5a1$exports(O));
    var result = [];
    $e501a92b62fe2f9e$require$$forEach(names, function(key) {
        if (!$8bbc2bccc0a29296$exports($e501a92b62fe2f9e$var$AllSymbols, key) && !$8bbc2bccc0a29296$exports($91deb02321ce445c$exports, key)) $e501a92b62fe2f9e$var$push(result, key);
    });
    return result;
};
var $e501a92b62fe2f9e$var$$getOwnPropertySymbols = function $getOwnPropertySymbols(O) {
    var IS_OBJECT_PROTOTYPE = O === $e501a92b62fe2f9e$var$ObjectPrototype;
    var names = $e501a92b62fe2f9e$var$nativeGetOwnPropertyNames(IS_OBJECT_PROTOTYPE ? $e501a92b62fe2f9e$var$ObjectPrototypeSymbols : $59a8f2f00edbf5a1$exports(O));
    var result = [];
    $e501a92b62fe2f9e$require$$forEach(names, function(key) {
        if ($8bbc2bccc0a29296$exports($e501a92b62fe2f9e$var$AllSymbols, key) && (!IS_OBJECT_PROTOTYPE || $8bbc2bccc0a29296$exports($e501a92b62fe2f9e$var$ObjectPrototype, key))) $e501a92b62fe2f9e$var$push(result, $e501a92b62fe2f9e$var$AllSymbols[key]);
    });
    return result;
};
// `Symbol` constructor
// https://tc39.es/ecma262/#sec-symbol-constructor
if (!$532a34ca390758bf$exports) {
    $e501a92b62fe2f9e$var$$Symbol = function Symbol() {
        if ($5c91390ffea610b9$exports($e501a92b62fe2f9e$var$SymbolPrototype, this)) throw new $e501a92b62fe2f9e$var$TypeError('Symbol is not a constructor');
        var description = !arguments.length || arguments[0] === undefined ? undefined : $7c610b7ee22557b5$exports(arguments[0]);
        var tag = $bf14b42fd1d1c367$exports(description);
        var setter = function setter1(value) {
            var $this = this === undefined ? $27350b6a9e85aed1$exports : this;
            if ($this === $e501a92b62fe2f9e$var$ObjectPrototype) $59bf80837927ca02$exports(setter, $e501a92b62fe2f9e$var$ObjectPrototypeSymbols, value);
            if ($8bbc2bccc0a29296$exports($this, $e501a92b62fe2f9e$var$HIDDEN) && $8bbc2bccc0a29296$exports($this[$e501a92b62fe2f9e$var$HIDDEN], tag)) $this[$e501a92b62fe2f9e$var$HIDDEN][tag] = false;
            var descriptor = $27c455d39660edb8$exports(1, value);
            try {
                $e501a92b62fe2f9e$var$setSymbolDescriptor($this, tag, descriptor);
            } catch (error) {
                if (!(error instanceof $e501a92b62fe2f9e$var$RangeError)) throw error;
                $e501a92b62fe2f9e$var$fallbackDefineProperty($this, tag, descriptor);
            }
        };
        if ($b9f536d3284d7921$exports && $e501a92b62fe2f9e$var$USE_SETTER) $e501a92b62fe2f9e$var$setSymbolDescriptor($e501a92b62fe2f9e$var$ObjectPrototype, tag, {
            configurable: true,
            set: setter
        });
        return $e501a92b62fe2f9e$var$wrap(tag, description);
    };
    $e501a92b62fe2f9e$var$SymbolPrototype = $e501a92b62fe2f9e$var$$Symbol[$e501a92b62fe2f9e$var$PROTOTYPE];
    $73c8864ae5df5c4d$exports($e501a92b62fe2f9e$var$SymbolPrototype, 'toString', function toString() {
        return $e501a92b62fe2f9e$var$getInternalState(this).tag;
    });
    $73c8864ae5df5c4d$exports($e501a92b62fe2f9e$var$$Symbol, 'withoutSetter', function(description) {
        return $e501a92b62fe2f9e$var$wrap($bf14b42fd1d1c367$exports(description), description);
    });
    $246f5b02cd4c126c$exports.f = $e501a92b62fe2f9e$var$$propertyIsEnumerable;
    $6f9fc35f567fa5b6$exports.f = $e501a92b62fe2f9e$var$$defineProperty;
    $f6e3282a041903a4$exports.f = $e501a92b62fe2f9e$var$$defineProperties;
    $70871da05e9d21bf$exports.f = $e501a92b62fe2f9e$var$$getOwnPropertyDescriptor;
    $8b92903d5cdf859e$exports.f = $96008a693f58af2b$exports.f = $e501a92b62fe2f9e$var$$getOwnPropertyNames;
    $f459638151f85e39$exports.f = $e501a92b62fe2f9e$var$$getOwnPropertySymbols;
    $bde54fcf696f6645$exports.f = function(name) {
        return $e501a92b62fe2f9e$var$wrap($8555fb22f74da29f$exports(name), name);
    };
    if ($b9f536d3284d7921$exports) {
        // https://tc39.es/ecma262/#sec-symbol.prototype.description
        $71a985fce44d8187$exports($e501a92b62fe2f9e$var$SymbolPrototype, 'description', {
            configurable: true,
            get: function description() {
                return $e501a92b62fe2f9e$var$getInternalState(this).description;
            }
        });
        if (!$a4b83f418a8da28e$exports) $73c8864ae5df5c4d$exports($e501a92b62fe2f9e$var$ObjectPrototype, 'propertyIsEnumerable', $e501a92b62fe2f9e$var$$propertyIsEnumerable, {
            unsafe: true
        });
    }
}
$244155c096ef4c14$exports({
    global: true,
    constructor: true,
    wrap: true,
    forced: !$532a34ca390758bf$exports,
    sham: !$532a34ca390758bf$exports
}, {
    Symbol: $e501a92b62fe2f9e$var$$Symbol
});
$e501a92b62fe2f9e$require$$forEach($ed3a442fad5fbe57$exports($e501a92b62fe2f9e$var$WellKnownSymbolsStore), function(name) {
    $a8630b65c875dcc7$exports(name);
});
$244155c096ef4c14$exports({
    target: $e501a92b62fe2f9e$var$SYMBOL,
    stat: true,
    forced: !$532a34ca390758bf$exports
}, {
    useSetter: function useSetter() {
        $e501a92b62fe2f9e$var$USE_SETTER = true;
    },
    useSimple: function useSimple() {
        $e501a92b62fe2f9e$var$USE_SETTER = false;
    }
});
$244155c096ef4c14$exports({
    target: 'Object',
    stat: true,
    forced: !$532a34ca390758bf$exports,
    sham: !$b9f536d3284d7921$exports
}, {
    // `Object.create` method
    // https://tc39.es/ecma262/#sec-object.create
    create: $e501a92b62fe2f9e$var$$create,
    // `Object.defineProperty` method
    // https://tc39.es/ecma262/#sec-object.defineproperty
    defineProperty: $e501a92b62fe2f9e$var$$defineProperty,
    // `Object.defineProperties` method
    // https://tc39.es/ecma262/#sec-object.defineproperties
    defineProperties: $e501a92b62fe2f9e$var$$defineProperties,
    // `Object.getOwnPropertyDescriptor` method
    // https://tc39.es/ecma262/#sec-object.getownpropertydescriptors
    getOwnPropertyDescriptor: $e501a92b62fe2f9e$var$$getOwnPropertyDescriptor
});
$244155c096ef4c14$exports({
    target: 'Object',
    stat: true,
    forced: !$532a34ca390758bf$exports
}, {
    // `Object.getOwnPropertyNames` method
    // https://tc39.es/ecma262/#sec-object.getownpropertynames
    getOwnPropertyNames: $e501a92b62fe2f9e$var$$getOwnPropertyNames
});
// `Symbol.prototype[@@toPrimitive]` method
// https://tc39.es/ecma262/#sec-symbol.prototype-@@toprimitive
$af024b297d3b01cc$exports();
// `Symbol.prototype[@@toStringTag]` property
// https://tc39.es/ecma262/#sec-symbol.prototype-@@tostringtag
$54a3ba2fb7b04ac0$exports($e501a92b62fe2f9e$var$$Symbol, $e501a92b62fe2f9e$var$SYMBOL);
$91deb02321ce445c$exports[$e501a92b62fe2f9e$var$HIDDEN] = true;


'use strict';





var $f17a09090aa727b4$exports = {};
'use strict';

/* eslint-disable es/no-symbol -- safe */ $f17a09090aa727b4$exports = $532a34ca390758bf$exports && !!Symbol['for'] && !!Symbol.keyFor;


var $663ce2061ed4eff6$var$StringToSymbolRegistry = $bf195d0f48f561ca$exports('string-to-symbol-registry');
var $663ce2061ed4eff6$var$SymbolToStringRegistry = $bf195d0f48f561ca$exports('symbol-to-string-registry');
// `Symbol.for` method
// https://tc39.es/ecma262/#sec-symbol.for
$244155c096ef4c14$exports({
    target: 'Symbol',
    stat: true,
    forced: !$f17a09090aa727b4$exports
}, {
    'for': function(key) {
        var string = $7c610b7ee22557b5$exports(key);
        if ($8bbc2bccc0a29296$exports($663ce2061ed4eff6$var$StringToSymbolRegistry, string)) return $663ce2061ed4eff6$var$StringToSymbolRegistry[string];
        var symbol = $e8972ff3cf85d361$exports('Symbol')(string);
        $663ce2061ed4eff6$var$StringToSymbolRegistry[string] = symbol;
        $663ce2061ed4eff6$var$SymbolToStringRegistry[symbol] = string;
        return symbol;
    }
});


'use strict';






var $a0f0968709371853$var$SymbolToStringRegistry = $bf195d0f48f561ca$exports('symbol-to-string-registry');
// `Symbol.keyFor` method
// https://tc39.es/ecma262/#sec-symbol.keyfor
$244155c096ef4c14$exports({
    target: 'Symbol',
    stat: true,
    forced: !$f17a09090aa727b4$exports
}, {
    keyFor: function keyFor(sym) {
        if (!$3b5b0fa19aea9b5a$exports(sym)) throw new TypeError($287fd49afd1ee632$exports(sym) + ' is not a symbol');
        if ($8bbc2bccc0a29296$exports($a0f0968709371853$var$SymbolToStringRegistry, sym)) return $a0f0968709371853$var$SymbolToStringRegistry[sym];
    }
});


'use strict';


var $eb64554a295b6978$exports = {};

var $6tOPT = parcelRequire("6tOPT");
'use strict';

var $eb64554a295b6978$var$FunctionPrototype = Function.prototype;
var $eb64554a295b6978$var$apply = $eb64554a295b6978$var$FunctionPrototype.apply;
var $eb64554a295b6978$var$call = $eb64554a295b6978$var$FunctionPrototype.call;
// eslint-disable-next-line es/no-function-prototype-bind, es/no-reflect -- safe
$eb64554a295b6978$exports = (typeof Reflect === "undefined" ? "undefined" : (0, $6tOPT._)(Reflect)) == 'object' && Reflect.apply || ($37d783b2348274b4$exports ? $eb64554a295b6978$var$call.bind($eb64554a295b6978$var$apply) : function() {
    return $eb64554a295b6978$var$call.apply($eb64554a295b6978$var$apply, arguments);
});







var $0aef214f278ac871$exports = {};
'use strict';


var $0aef214f278ac871$require$getInternalState = $fcfe8b5396fbe91a$exports.get;
$0aef214f278ac871$exports = function isRawJSON(O) {
    if (!$4d7f82f6c4645870$exports(O)) return false;
    var state = $0aef214f278ac871$require$getInternalState(O);
    return !!state && state.type === 'RawJSON';
};






var $61ca18d77a26d673$exports = {};
'use strict';


var $61ca18d77a26d673$var$$SyntaxError = SyntaxError;
var $61ca18d77a26d673$var$$parseInt = parseInt;
var $61ca18d77a26d673$var$fromCharCode = String.fromCharCode;
var $61ca18d77a26d673$var$at = $c224a7eda28c33b3$exports(''.charAt);
var $61ca18d77a26d673$var$slice = $c224a7eda28c33b3$exports(''.slice);
var $61ca18d77a26d673$var$exec = $c224a7eda28c33b3$exports(/./.exec);
var $61ca18d77a26d673$var$codePoints = {
    '\\"': '"',
    '\\\\': '\\',
    '\\/': '/',
    '\\b': '\b',
    '\\f': '\f',
    '\\n': '\n',
    '\\r': '\r',
    '\\t': '\t'
};
var $61ca18d77a26d673$var$IS_4_HEX_DIGITS = /^[\da-f]{4}$/i;
// eslint-disable-next-line regexp/no-control-character -- safe
var $61ca18d77a26d673$var$IS_C0_CONTROL_CODE = /^[\u0000-\u001F]$/;
$61ca18d77a26d673$exports = function(source, i) {
    var unterminated = true;
    var value = '';
    while(i < source.length){
        var chr = $61ca18d77a26d673$var$at(source, i);
        if (chr === '\\') {
            var twoChars = $61ca18d77a26d673$var$slice(source, i, i + 2);
            if ($8bbc2bccc0a29296$exports($61ca18d77a26d673$var$codePoints, twoChars)) {
                value += $61ca18d77a26d673$var$codePoints[twoChars];
                i += 2;
            } else if (twoChars === '\\u') {
                i += 2;
                var fourHexDigits = $61ca18d77a26d673$var$slice(source, i, i + 4);
                if (!$61ca18d77a26d673$var$exec($61ca18d77a26d673$var$IS_4_HEX_DIGITS, fourHexDigits)) throw new $61ca18d77a26d673$var$$SyntaxError('Bad Unicode escape at: ' + i);
                value += $61ca18d77a26d673$var$fromCharCode($61ca18d77a26d673$var$$parseInt(fourHexDigits, 16));
                i += 4;
            } else throw new $61ca18d77a26d673$var$$SyntaxError('Unknown escape sequence: "' + twoChars + '"');
        } else if (chr === '"') {
            unterminated = false;
            i++;
            break;
        } else {
            if ($61ca18d77a26d673$var$exec($61ca18d77a26d673$var$IS_C0_CONTROL_CODE, chr)) throw new $61ca18d77a26d673$var$$SyntaxError('Bad control character in string literal at: ' + i);
            value += chr;
            i++;
        }
    }
    if (unterminated) throw new $61ca18d77a26d673$var$$SyntaxError('Unterminated string at: ' + i);
    return {
        value: value,
        end: i
    };
};




var $7527c42b1b23ea3f$exports = {};
'use strict';

$7527c42b1b23ea3f$exports = !$ddd8e9441ae136f2$exports(function() {
    var unsafeInt = '9007199254740993';
    // eslint-disable-next-line es/no-json-rawjson -- feature detection
    var raw = JSON.rawJSON(unsafeInt);
    // eslint-disable-next-line es/no-json-israwjson -- feature detection
    return !JSON.isRawJSON(raw) || JSON.stringify(raw) !== unsafeInt;
});


var $8f3ce3fedff46efe$var$$String = String;
var $8f3ce3fedff46efe$var$$stringify = $e8972ff3cf85d361$exports('JSON', 'stringify');
var $8f3ce3fedff46efe$var$exec = $c224a7eda28c33b3$exports(/./.exec);
var $8f3ce3fedff46efe$var$charAt = $c224a7eda28c33b3$exports(''.charAt);
var $8f3ce3fedff46efe$var$charCodeAt = $c224a7eda28c33b3$exports(''.charCodeAt);
var $8f3ce3fedff46efe$var$replace = $c224a7eda28c33b3$exports(''.replace);
var $8f3ce3fedff46efe$var$slice = $c224a7eda28c33b3$exports(''.slice);
var $8f3ce3fedff46efe$var$push = $c224a7eda28c33b3$exports([].push);
var $8f3ce3fedff46efe$var$numberToString = $c224a7eda28c33b3$exports(1.1.toString);
var $8f3ce3fedff46efe$var$surrogates = /[\uD800-\uDFFF]/g;
var $8f3ce3fedff46efe$var$leadingSurrogates = /^[\uD800-\uDBFF]$/;
var $8f3ce3fedff46efe$var$trailingSurrogates = /^[\uDC00-\uDFFF]$/;
var $8f3ce3fedff46efe$var$MARK = $bf14b42fd1d1c367$exports();
var $8f3ce3fedff46efe$var$MARK_LENGTH = $8f3ce3fedff46efe$var$MARK.length;
var $8f3ce3fedff46efe$var$WRONG_SYMBOLS_CONVERSION = !$532a34ca390758bf$exports || $ddd8e9441ae136f2$exports(function() {
    var symbol = $e8972ff3cf85d361$exports('Symbol')('stringify detection');
    // MS Edge converts symbol values to JSON as {}
    return $8f3ce3fedff46efe$var$$stringify([
        symbol
    ]) !== '[null]' || $8f3ce3fedff46efe$var$$stringify({
        a: symbol
    }) !== '{}' || $8f3ce3fedff46efe$var$$stringify(Object(symbol)) !== '{}';
});
// https://github.com/tc39/proposal-well-formed-stringify
var $8f3ce3fedff46efe$var$ILL_FORMED_UNICODE = $ddd8e9441ae136f2$exports(function() {
    return $8f3ce3fedff46efe$var$$stringify('\uDF06\uD834') !== '"\\udf06\\ud834"' || $8f3ce3fedff46efe$var$$stringify('\uDEAD') !== '"\\udead"';
});
var $8f3ce3fedff46efe$var$stringifyWithProperSymbolsConversion = $8f3ce3fedff46efe$var$WRONG_SYMBOLS_CONVERSION ? function stringifyWithProperSymbolsConversion(it, replacer) {
    var args = $2dd14968e62d6eb1$exports(arguments);
    var $replacer = $8f3ce3fedff46efe$var$getReplacerFunction(replacer);
    if (!$7c165f740ca92c53$exports($replacer) && (it === undefined || $3b5b0fa19aea9b5a$exports(it))) return; // IE8 returns string on undefined
    args[1] = function(key, value) {
        // some old implementations (like WebKit) could pass numbers as keys
        if ($7c165f740ca92c53$exports($replacer)) value = $59bf80837927ca02$exports($replacer, this, $8f3ce3fedff46efe$var$$String(key), value);
        if (!$3b5b0fa19aea9b5a$exports(value)) return value;
    };
    return $eb64554a295b6978$exports($8f3ce3fedff46efe$var$$stringify, null, args);
} : $8f3ce3fedff46efe$var$$stringify;
var $8f3ce3fedff46efe$var$fixIllFormedJSON = function fixIllFormedJSON(match, offset, string) {
    var prev = $8f3ce3fedff46efe$var$charAt(string, offset - 1);
    var next = $8f3ce3fedff46efe$var$charAt(string, offset + 1);
    if ($8f3ce3fedff46efe$var$exec($8f3ce3fedff46efe$var$leadingSurrogates, match) && !$8f3ce3fedff46efe$var$exec($8f3ce3fedff46efe$var$trailingSurrogates, next) || $8f3ce3fedff46efe$var$exec($8f3ce3fedff46efe$var$trailingSurrogates, match) && !$8f3ce3fedff46efe$var$exec($8f3ce3fedff46efe$var$leadingSurrogates, prev)) return '\\u' + $8f3ce3fedff46efe$var$numberToString($8f3ce3fedff46efe$var$charCodeAt(match, 0), 16);
    return match;
};
var $8f3ce3fedff46efe$var$getReplacerFunction = function getReplacerFunction(replacer) {
    if ($7c165f740ca92c53$exports(replacer)) return replacer;
    if (!$b95992045c940cb8$exports(replacer)) return;
    var rawLength = replacer.length;
    var keys = [];
    for(var i = 0; i < rawLength; i++){
        var element = replacer[i];
        if (typeof element == 'string') $8f3ce3fedff46efe$var$push(keys, element);
        else if (typeof element == 'number' || $5a266b01e7970e30$exports(element) === 'Number' || $5a266b01e7970e30$exports(element) === 'String') $8f3ce3fedff46efe$var$push(keys, $7c610b7ee22557b5$exports(element));
    }
    var keysLength = keys.length;
    var root = true;
    return function(key, value) {
        if (root) {
            root = false;
            return value;
        }
        if ($b95992045c940cb8$exports(this)) return value;
        for(var j = 0; j < keysLength; j++)if (keys[j] === key) return value;
    };
};
// `JSON.stringify` method
// https://tc39.es/ecma262/#sec-json.stringify
// https://github.com/tc39/proposal-json-parse-with-source
if ($8f3ce3fedff46efe$var$$stringify) $244155c096ef4c14$exports({
    target: 'JSON',
    stat: true,
    arity: 3,
    forced: $8f3ce3fedff46efe$var$WRONG_SYMBOLS_CONVERSION || $8f3ce3fedff46efe$var$ILL_FORMED_UNICODE || !$7527c42b1b23ea3f$exports
}, {
    stringify: function stringify(text, replacer, space) {
        var replacerFunction = $8f3ce3fedff46efe$var$getReplacerFunction(replacer);
        var rawStrings = [];
        var json = $8f3ce3fedff46efe$var$stringifyWithProperSymbolsConversion(text, function(key, value) {
            // some old implementations (like WebKit) could pass numbers as keys
            var v = $7c165f740ca92c53$exports(replacerFunction) ? $59bf80837927ca02$exports(replacerFunction, this, $8f3ce3fedff46efe$var$$String(key), value) : value;
            return !$7527c42b1b23ea3f$exports && $0aef214f278ac871$exports(v) ? $8f3ce3fedff46efe$var$MARK + ($8f3ce3fedff46efe$var$push(rawStrings, v.rawJSON) - 1) : v;
        }, space);
        if (typeof json != 'string') return json;
        if ($8f3ce3fedff46efe$var$ILL_FORMED_UNICODE) json = $8f3ce3fedff46efe$var$replace(json, $8f3ce3fedff46efe$var$surrogates, $8f3ce3fedff46efe$var$fixIllFormedJSON);
        if ($7527c42b1b23ea3f$exports) return json;
        var result = '';
        var length = json.length;
        for(var i = 0; i < length; i++){
            var chr = $8f3ce3fedff46efe$var$charAt(json, i);
            if (chr === '"') {
                var end = $61ca18d77a26d673$exports(json, ++i).end - 1;
                var string = $8f3ce3fedff46efe$var$slice(json, i, end);
                result += $8f3ce3fedff46efe$var$slice(string, 0, $8f3ce3fedff46efe$var$MARK_LENGTH) === $8f3ce3fedff46efe$var$MARK ? rawStrings[$8f3ce3fedff46efe$var$slice(string, $8f3ce3fedff46efe$var$MARK_LENGTH)] : '"' + string + '"';
                i = end;
            } else result += chr;
        }
        return result;
    }
});


'use strict';





// V8 ~ Chrome 38 and 39 `Object.getOwnPropertySymbols` fails on primitives
// https://bugs.chromium.org/p/v8/issues/detail?id=3443
var $69954fb6b7651b26$var$FORCED = !$532a34ca390758bf$exports || $ddd8e9441ae136f2$exports(function() {
    $f459638151f85e39$export$2d1720544b23b823(1);
});
// `Object.getOwnPropertySymbols` method
// https://tc39.es/ecma262/#sec-object.getownpropertysymbols
$244155c096ef4c14$exports({
    target: 'Object',
    stat: true,
    forced: $69954fb6b7651b26$var$FORCED
}, {
    getOwnPropertySymbols: function getOwnPropertySymbols(it) {
        var $getOwnPropertySymbols = $f459638151f85e39$export$2d1720544b23b823;
        return $getOwnPropertySymbols ? $getOwnPropertySymbols($ad1d9797f1e27af5$exports(it)) : [];
    }
});




// `Symbol.prototype.description` getter
// https://tc39.es/ecma262/#sec-symbol.prototype.description
'use strict';











var $2d0adf91689d00fb$var$NativeSymbol = $27350b6a9e85aed1$exports.Symbol;
var $2d0adf91689d00fb$var$SymbolPrototype = $2d0adf91689d00fb$var$NativeSymbol && $2d0adf91689d00fb$var$NativeSymbol.prototype;
if ($b9f536d3284d7921$exports && $7c165f740ca92c53$exports($2d0adf91689d00fb$var$NativeSymbol) && (!('description' in $2d0adf91689d00fb$var$SymbolPrototype) || // Safari 12 bug
$2d0adf91689d00fb$var$NativeSymbol().description !== undefined)) {
    var $2d0adf91689d00fb$var$EmptyStringDescriptionStore = {};
    // wrap Symbol constructor for correct work with undefined description
    var $2d0adf91689d00fb$var$SymbolWrapper = function Symbol() {
        var description = arguments.length < 1 || arguments[0] === undefined ? undefined : $7c610b7ee22557b5$exports(arguments[0]);
        var result = $5c91390ffea610b9$exports($2d0adf91689d00fb$var$SymbolPrototype, this) ? new $2d0adf91689d00fb$var$NativeSymbol(description) : description === undefined ? $2d0adf91689d00fb$var$NativeSymbol() : $2d0adf91689d00fb$var$NativeSymbol(description);
        if (description === '') $2d0adf91689d00fb$var$EmptyStringDescriptionStore[result] = true;
        return result;
    };
    $9a17c1c56e0da0fc$exports($2d0adf91689d00fb$var$SymbolWrapper, $2d0adf91689d00fb$var$NativeSymbol);
    // wrap Symbol.for for correct handling of empty string descriptions
    var $2d0adf91689d00fb$var$nativeFor = $2d0adf91689d00fb$var$SymbolWrapper['for'];
    $2d0adf91689d00fb$var$SymbolWrapper['for'] = ({
        'for': function(key) {
            var stringKey = $7c610b7ee22557b5$exports(key);
            var symbol = $59bf80837927ca02$exports($2d0adf91689d00fb$var$nativeFor, this, stringKey);
            if (stringKey === '') $2d0adf91689d00fb$var$EmptyStringDescriptionStore[symbol] = true;
            return symbol;
        }
    })['for'];
    $2d0adf91689d00fb$var$SymbolWrapper.prototype = $2d0adf91689d00fb$var$SymbolPrototype;
    $2d0adf91689d00fb$var$SymbolPrototype.constructor = $2d0adf91689d00fb$var$SymbolWrapper;
    var $2d0adf91689d00fb$var$NATIVE_SYMBOL = String($2d0adf91689d00fb$var$NativeSymbol('description detection')) === 'Symbol(description detection)';
    var $2d0adf91689d00fb$var$thisSymbolValue = $c224a7eda28c33b3$exports($2d0adf91689d00fb$var$SymbolPrototype.valueOf);
    var $2d0adf91689d00fb$var$symbolDescriptiveString = $c224a7eda28c33b3$exports($2d0adf91689d00fb$var$SymbolPrototype.toString);
    var $2d0adf91689d00fb$var$regexp = /^Symbol\((.*)\)[^)]+$/;
    var $2d0adf91689d00fb$var$replace = $c224a7eda28c33b3$exports(''.replace);
    var $2d0adf91689d00fb$var$stringSlice = $c224a7eda28c33b3$exports(''.slice);
    $71a985fce44d8187$exports($2d0adf91689d00fb$var$SymbolPrototype, 'description', {
        configurable: true,
        get: function description() {
            var symbol = $2d0adf91689d00fb$var$thisSymbolValue(this);
            if ($8bbc2bccc0a29296$exports($2d0adf91689d00fb$var$EmptyStringDescriptionStore, symbol)) return '';
            var string = $2d0adf91689d00fb$var$symbolDescriptiveString(symbol);
            var desc = $2d0adf91689d00fb$var$NATIVE_SYMBOL ? $2d0adf91689d00fb$var$stringSlice(string, 7, -1) : $2d0adf91689d00fb$var$replace(string, $2d0adf91689d00fb$var$regexp, '$1');
            return desc === '' ? undefined : desc;
        }
    });
    $244155c096ef4c14$exports({
        global: true,
        constructor: true,
        forced: true
    }, {
        Symbol: $2d0adf91689d00fb$var$SymbolWrapper
    });
}


'use strict';

// `Symbol.asyncIterator` well-known symbol
// https://tc39.es/ecma262/#sec-symbol.asynciterator
$a8630b65c875dcc7$exports('asyncIterator');


'use strict';

// `Symbol.hasInstance` well-known symbol
// https://tc39.es/ecma262/#sec-symbol.hasinstance
$a8630b65c875dcc7$exports('hasInstance');


'use strict';

// `Symbol.isConcatSpreadable` well-known symbol
// https://tc39.es/ecma262/#sec-symbol.isconcatspreadable
$a8630b65c875dcc7$exports('isConcatSpreadable');


'use strict';

// `Symbol.iterator` well-known symbol
// https://tc39.es/ecma262/#sec-symbol.iterator
$a8630b65c875dcc7$exports('iterator');


'use strict';

// `Symbol.match` well-known symbol
// https://tc39.es/ecma262/#sec-symbol.match
$a8630b65c875dcc7$exports('match');


'use strict';

// `Symbol.replace` well-known symbol
// https://tc39.es/ecma262/#sec-symbol.replace
$a8630b65c875dcc7$exports('replace');


'use strict';

// `Symbol.search` well-known symbol
// https://tc39.es/ecma262/#sec-symbol.search
$a8630b65c875dcc7$exports('search');


'use strict';

// `Symbol.species` well-known symbol
// https://tc39.es/ecma262/#sec-symbol.species
$a8630b65c875dcc7$exports('species');


'use strict';

// `Symbol.split` well-known symbol
// https://tc39.es/ecma262/#sec-symbol.split
$a8630b65c875dcc7$exports('split');


'use strict';


// `Symbol.toPrimitive` well-known symbol
// https://tc39.es/ecma262/#sec-symbol.toprimitive
$a8630b65c875dcc7$exports('toPrimitive');
// `Symbol.prototype[@@toPrimitive]` method
// https://tc39.es/ecma262/#sec-symbol.prototype-@@toprimitive
$af024b297d3b01cc$exports();


'use strict';



// `Symbol.toStringTag` well-known symbol
// https://tc39.es/ecma262/#sec-symbol.tostringtag
$a8630b65c875dcc7$exports('toStringTag');
// `Symbol.prototype[@@toStringTag]` property
// https://tc39.es/ecma262/#sec-symbol.prototype-@@tostringtag
$54a3ba2fb7b04ac0$exports($e8972ff3cf85d361$exports('Symbol'), 'Symbol');


'use strict';

// `Symbol.unscopables` well-known symbol
// https://tc39.es/ecma262/#sec-symbol.unscopables
$a8630b65c875dcc7$exports('unscopables');


'use strict';






var $4cb5f05ebd848a3e$exports = {};
'use strict';
var $4cb5f05ebd848a3e$var$$TypeError = TypeError;
var $4cb5f05ebd848a3e$var$MAX_SAFE_INTEGER = 0x1FFFFFFFFFFFFF; // 2 ** 53 - 1 == 9007199254740991
$4cb5f05ebd848a3e$exports = function(it) {
    if (it > $4cb5f05ebd848a3e$var$MAX_SAFE_INTEGER) throw new $4cb5f05ebd848a3e$var$$TypeError('Maximum allowed index exceeded');
    return it;
};



var $e408ebc9418a57d6$exports = {};
'use strict';


var $e408ebc9418a57d6$var$$TypeError = TypeError;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $e408ebc9418a57d6$var$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
// Safari < 13 does not throw an error in this case
var $e408ebc9418a57d6$var$SILENT_ON_NON_WRITABLE_LENGTH_SET = $b9f536d3284d7921$exports && !function() {
    // makes no sense without proper strict mode support
    if (this !== undefined) return true;
    try {
        // eslint-disable-next-line es/no-object-defineproperty -- safe
        Object.defineProperty([], 'length', {
            writable: false
        }).length = 1;
    } catch (error) {
        return error instanceof TypeError;
    }
}();
$e408ebc9418a57d6$exports = $e408ebc9418a57d6$var$SILENT_ON_NON_WRITABLE_LENGTH_SET ? function(O, length) {
    if ($b95992045c940cb8$exports(O) && !$e408ebc9418a57d6$var$getOwnPropertyDescriptor(O, 'length').writable) throw new $e408ebc9418a57d6$var$$TypeError('Cannot set read only .length');
    return O.length = length;
} : function(O, length) {
    return O.length = length;
};



var $1e431e80cab7671b$exports = {};
'use strict';



var $1e431e80cab7671b$var$SPECIES = $8555fb22f74da29f$exports('species');
$1e431e80cab7671b$exports = function(METHOD_NAME) {
    // We can't use this feature detection in V8 since it causes
    // deoptimization and serious performance degradation
    // https://github.com/zloirock/core-js/issues/677
    return $af93164be802bd69$exports >= 51 || !$ddd8e9441ae136f2$exports(function() {
        var array = [];
        var constructor = array.constructor = {};
        constructor[$1e431e80cab7671b$var$SPECIES] = function() {
            return {
                foo: 1
            };
        };
        return array[METHOD_NAME](Boolean).foo !== 1;
    });
};




var $398d18e9bfb4a333$var$IS_CONCAT_SPREADABLE = $8555fb22f74da29f$exports('isConcatSpreadable');
// We can't use this feature detection in V8 since it causes
// deoptimization and serious performance degradation
// https://github.com/zloirock/core-js/issues/679
var $398d18e9bfb4a333$var$IS_CONCAT_SPREADABLE_SUPPORT = $af93164be802bd69$exports >= 51 || !$ddd8e9441ae136f2$exports(function() {
    var array = [];
    array[$398d18e9bfb4a333$var$IS_CONCAT_SPREADABLE] = false;
    return array.concat()[0] !== array;
});
var $398d18e9bfb4a333$var$isConcatSpreadable = function isConcatSpreadable(O) {
    if (!$4d7f82f6c4645870$exports(O)) return false;
    var spreadable = O[$398d18e9bfb4a333$var$IS_CONCAT_SPREADABLE];
    return spreadable !== undefined ? !!spreadable : $b95992045c940cb8$exports(O);
};
var $398d18e9bfb4a333$var$FORCED = !$398d18e9bfb4a333$var$IS_CONCAT_SPREADABLE_SUPPORT || !$1e431e80cab7671b$exports('concat');
// `Array.prototype.concat` method
// https://tc39.es/ecma262/#sec-array.prototype.concat
// with adding support of @@isConcatSpreadable and @@species
$244155c096ef4c14$exports({
    target: 'Array',
    proto: true,
    arity: 1,
    forced: $398d18e9bfb4a333$var$FORCED
}, {
    // eslint-disable-next-line no-unused-vars -- required for `.length`
    concat: function concat(arg) {
        var O = $ad1d9797f1e27af5$exports(this);
        var A = $9dd5766bb20abe7e$exports(O, 0);
        var n = 0;
        var i, k, length, len, E;
        for(i = -1, length = arguments.length; i < length; i++){
            E = i === -1 ? O : arguments[i];
            if ($398d18e9bfb4a333$var$isConcatSpreadable(E)) {
                len = $dfe69c9cb1d4aa6b$exports(E);
                $4cb5f05ebd848a3e$exports(n + len);
                for(k = 0; k < len; k++, n++)if (k in E) $7e31aa0800ea6c75$exports(A, n, E[k]);
            } else {
                $4cb5f05ebd848a3e$exports(n + 1);
                $7e31aa0800ea6c75$exports(A, n++, E);
            }
        }
        $e408ebc9418a57d6$exports(A, n);
        return A;
    }
});


'use strict';

var $f6b6df437e185c59$exports = {};
'use strict';



var $525d0704a99182b6$exports = {};
'use strict';

var $525d0704a99182b6$var$$TypeError = TypeError;
$525d0704a99182b6$exports = function(O, P) {
    if (!delete O[P]) throw new $525d0704a99182b6$var$$TypeError('Cannot delete property ' + $287fd49afd1ee632$exports(P) + ' of ' + $287fd49afd1ee632$exports(O));
};


var $f6b6df437e185c59$var$min = Math.min;
// `Array.prototype.copyWithin` method implementation
// https://tc39.es/ecma262/#sec-array.prototype.copywithin
// eslint-disable-next-line es/no-array-prototype-copywithin -- safe
$f6b6df437e185c59$exports = [].copyWithin || function copyWithin(target /* = 0 */ , start /* = 0, end = @length */ ) {
    var O = $ad1d9797f1e27af5$exports(this);
    var len = $dfe69c9cb1d4aa6b$exports(O);
    var to = $32c589906f6ca696$exports(target, len);
    var from = $32c589906f6ca696$exports(start, len);
    var end = arguments.length > 2 ? arguments[2] : undefined;
    var count = $f6b6df437e185c59$var$min((end === undefined ? len : $32c589906f6ca696$exports(end, len)) - from, len - to);
    var inc = 1;
    if (from < to && to < from + count) {
        inc = -1;
        from += count - 1;
        to += count - 1;
    }
    while(count-- > 0){
        if (from in O) O[to] = O[from];
        else $525d0704a99182b6$exports(O, to);
        to += inc;
        from += inc;
    }
    return O;
};


var $98d262ec833f9221$exports = {};
'use strict';



var $98d262ec833f9221$require$defineProperty = $6f9fc35f567fa5b6$export$2d1720544b23b823;
var $98d262ec833f9221$var$UNSCOPABLES = $8555fb22f74da29f$exports('unscopables');
var $98d262ec833f9221$var$ArrayPrototype = Array.prototype;
// Array.prototype[@@unscopables]
// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
if ($98d262ec833f9221$var$ArrayPrototype[$98d262ec833f9221$var$UNSCOPABLES] === undefined) $98d262ec833f9221$require$defineProperty($98d262ec833f9221$var$ArrayPrototype, $98d262ec833f9221$var$UNSCOPABLES, {
    configurable: true,
    value: $491a5d5aa2efe6ec$exports(null)
});
// add a key to Array.prototype[@@unscopables]
$98d262ec833f9221$exports = function(key) {
    $98d262ec833f9221$var$ArrayPrototype[$98d262ec833f9221$var$UNSCOPABLES][key] = true;
};


// `Array.prototype.copyWithin` method
// https://tc39.es/ecma262/#sec-array.prototype.copywithin
$244155c096ef4c14$exports({
    target: 'Array',
    proto: true
}, {
    copyWithin: $f6b6df437e185c59$exports
});
// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
$98d262ec833f9221$exports('copyWithin');


'use strict';

var $635ab17dab618628$exports = {};
'use strict';



// `Array.prototype.fill` method implementation
// https://tc39.es/ecma262/#sec-array.prototype.fill
$635ab17dab618628$exports = function fill(value /* , start = 0, end = @length */ ) {
    var O = $ad1d9797f1e27af5$exports(this);
    var length = $dfe69c9cb1d4aa6b$exports(O);
    var argumentsLength = arguments.length;
    var index = $32c589906f6ca696$exports(argumentsLength > 1 ? arguments[1] : undefined, length);
    var end = argumentsLength > 2 ? arguments[2] : undefined;
    var endPos = end === undefined ? length : $32c589906f6ca696$exports(end, length);
    while(endPos > index)O[index++] = value;
    return O;
};



// `Array.prototype.fill` method
// https://tc39.es/ecma262/#sec-array.prototype.fill
$244155c096ef4c14$exports({
    target: 'Array',
    proto: true
}, {
    fill: $635ab17dab618628$exports
});
// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
$98d262ec833f9221$exports('fill');


'use strict';


var $a306d21aaf9318e1$require$$filter = $549edc5c9a026f8b$exports.filter;

var $a306d21aaf9318e1$var$HAS_SPECIES_SUPPORT = $1e431e80cab7671b$exports('filter');
// `Array.prototype.filter` method
// https://tc39.es/ecma262/#sec-array.prototype.filter
// with adding support of @@species
$244155c096ef4c14$exports({
    target: 'Array',
    proto: true,
    forced: !$a306d21aaf9318e1$var$HAS_SPECIES_SUPPORT
}, {
    filter: function filter(callbackfn /* , thisArg */ ) {
        return $a306d21aaf9318e1$require$$filter(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
    }
});


'use strict';


var $6a5bea4f64790c53$require$$find = $549edc5c9a026f8b$exports.find;

var $6a5bea4f64790c53$var$FIND = 'find';
var $6a5bea4f64790c53$var$SKIPS_HOLES = true;
// Shouldn't skip holes
// eslint-disable-next-line es/no-array-prototype-find -- testing
if ($6a5bea4f64790c53$var$FIND in []) Array(1)[$6a5bea4f64790c53$var$FIND](function() {
    $6a5bea4f64790c53$var$SKIPS_HOLES = false;
});
// `Array.prototype.find` method
// https://tc39.es/ecma262/#sec-array.prototype.find
$244155c096ef4c14$exports({
    target: 'Array',
    proto: true,
    forced: $6a5bea4f64790c53$var$SKIPS_HOLES
}, {
    find: function find(callbackfn /* , that = undefined */ ) {
        return $6a5bea4f64790c53$require$$find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
    }
});
// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
$98d262ec833f9221$exports($6a5bea4f64790c53$var$FIND);


'use strict';


var $3d7c928c872330a3$require$$findIndex = $549edc5c9a026f8b$exports.findIndex;

var $3d7c928c872330a3$var$FIND_INDEX = 'findIndex';
var $3d7c928c872330a3$var$SKIPS_HOLES = true;
// Shouldn't skip holes
// eslint-disable-next-line es/no-array-prototype-findindex -- testing
if ($3d7c928c872330a3$var$FIND_INDEX in []) Array(1)[$3d7c928c872330a3$var$FIND_INDEX](function() {
    $3d7c928c872330a3$var$SKIPS_HOLES = false;
});
// `Array.prototype.findIndex` method
// https://tc39.es/ecma262/#sec-array.prototype.findindex
$244155c096ef4c14$exports({
    target: 'Array',
    proto: true,
    forced: $3d7c928c872330a3$var$SKIPS_HOLES
}, {
    findIndex: function findIndex(callbackfn /* , that = undefined */ ) {
        return $3d7c928c872330a3$require$$findIndex(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
    }
});
// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
$98d262ec833f9221$exports($3d7c928c872330a3$var$FIND_INDEX);


'use strict';

var $c0dd813a9e93ed9f$exports = {};
'use strict';





// `FlattenIntoArray` abstract operation
// https://tc39.es/ecma262/#sec-flattenintoarray
var $c0dd813a9e93ed9f$var$flattenIntoArray = function flattenIntoArray1(target, original, source, sourceLen, start, depth, mapper, thisArg) {
    var targetIndex = start;
    var sourceIndex = 0;
    var mapFn = mapper ? $8a0b7edcb386df4b$exports(mapper, thisArg) : false;
    var element, elementLen;
    while(sourceIndex < sourceLen){
        if (sourceIndex in source) {
            element = mapFn ? mapFn(source[sourceIndex], sourceIndex, original) : source[sourceIndex];
            if (depth > 0 && $b95992045c940cb8$exports(element)) {
                elementLen = $dfe69c9cb1d4aa6b$exports(element);
                targetIndex = $c0dd813a9e93ed9f$var$flattenIntoArray(target, original, element, elementLen, targetIndex, depth - 1) - 1;
            } else {
                $4cb5f05ebd848a3e$exports(targetIndex + 1);
                $7e31aa0800ea6c75$exports(target, targetIndex, element);
            }
            targetIndex++;
        }
        sourceIndex++;
    }
    return targetIndex;
};
$c0dd813a9e93ed9f$exports = $c0dd813a9e93ed9f$var$flattenIntoArray;






// `Array.prototype.flat` method
// https://tc39.es/ecma262/#sec-array.prototype.flat
$244155c096ef4c14$exports({
    target: 'Array',
    proto: true
}, {
    flat: function flat() {
        var depthArg = arguments.length ? arguments[0] : undefined;
        var O = $ad1d9797f1e27af5$exports(this);
        var sourceLen = $dfe69c9cb1d4aa6b$exports(O);
        var depthNum = depthArg === undefined ? 1 : $a8fecfd456e884de$exports(depthArg);
        var A = $9dd5766bb20abe7e$exports(O, 0);
        $c0dd813a9e93ed9f$exports(A, O, O, sourceLen, 0, depthNum);
        return A;
    }
});


'use strict';






// `Array.prototype.flatMap` method
// https://tc39.es/ecma262/#sec-array.prototype.flatmap
$244155c096ef4c14$exports({
    target: 'Array',
    proto: true
}, {
    flatMap: function flatMap(callbackfn /* , thisArg */ ) {
        var O = $ad1d9797f1e27af5$exports(this);
        var sourceLen = $dfe69c9cb1d4aa6b$exports(O);
        var A;
        $082fcaa0a091ee30$exports(callbackfn);
        A = $9dd5766bb20abe7e$exports(O, 0);
        $c0dd813a9e93ed9f$exports(A, O, O, sourceLen, 0, 1, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
        return A;
    }
});


'use strict';

var $9173555772c6cd7a$exports = {};
'use strict';



var $b8e218b2f0858dda$exports = {};
'use strict';

var $e1b3d4ae7339c252$exports = {};
'use strict';



$e1b3d4ae7339c252$exports = function(iterator, kind, value) {
    var innerResult, innerError;
    $7d9b9f0a2a7e34a2$exports(iterator);
    try {
        innerResult = $354ab2c23276ac4c$exports(iterator, 'return');
        if (!innerResult) {
            if (kind === 'throw') throw value;
            return value;
        }
        innerResult = $59bf80837927ca02$exports(innerResult, iterator);
    } catch (error) {
        innerError = true;
        innerResult = error;
    }
    if (kind === 'throw') throw value;
    if (innerError) throw innerResult;
    $7d9b9f0a2a7e34a2$exports(innerResult);
    return value;
};


// call something on iterator step with safe closing on error
$b8e218b2f0858dda$exports = function(iterator, fn, value, ENTRIES) {
    try {
        return ENTRIES ? fn($7d9b9f0a2a7e34a2$exports(value)[0], value[1]) : fn(value);
    } catch (error) {
        $e1b3d4ae7339c252$exports(iterator, 'throw', error);
    }
};


var $6403e03a78aa5d48$exports = {};
'use strict';

var $a779fed72cdcf179$exports = {};
'use strict';
$a779fed72cdcf179$exports = {};


var $6403e03a78aa5d48$var$ITERATOR = $8555fb22f74da29f$exports('iterator');
var $6403e03a78aa5d48$var$ArrayPrototype = Array.prototype;
// check on default Array iterator
$6403e03a78aa5d48$exports = function(it) {
    return it !== undefined && ($a779fed72cdcf179$exports.Array === it || $6403e03a78aa5d48$var$ArrayPrototype[$6403e03a78aa5d48$var$ITERATOR] === it);
};






var $76e56b966649496d$exports = {};
'use strict';




var $72368fb318b24c5c$exports = {};
'use strict';





var $72368fb318b24c5c$var$ITERATOR = $8555fb22f74da29f$exports('iterator');
$72368fb318b24c5c$exports = function(it) {
    if (!$da08ff0243e53f27$exports(it)) return $354ab2c23276ac4c$exports(it, $72368fb318b24c5c$var$ITERATOR) || $354ab2c23276ac4c$exports(it, '@@iterator') || $a779fed72cdcf179$exports[$b720974ac29b37e2$exports(it)];
};


var $76e56b966649496d$var$$TypeError = TypeError;
$76e56b966649496d$exports = function(argument, usingIterator) {
    var iteratorMethod = arguments.length < 2 ? $72368fb318b24c5c$exports(argument) : usingIterator;
    if ($082fcaa0a091ee30$exports(iteratorMethod)) return $7d9b9f0a2a7e34a2$exports($59bf80837927ca02$exports(iteratorMethod, argument));
    throw new $76e56b966649496d$var$$TypeError($287fd49afd1ee632$exports(argument) + ' is not iterable');
};




var $9173555772c6cd7a$var$$Array = Array;
// `Array.from` method implementation
// https://tc39.es/ecma262/#sec-array.from
$9173555772c6cd7a$exports = function from(arrayLike /* , mapfn = undefined, thisArg = undefined */ ) {
    var IS_CONSTRUCTOR = $db2ba5677c412211$exports(this);
    var argumentsLength = arguments.length;
    var mapfn = argumentsLength > 1 ? arguments[1] : undefined;
    var mapping = mapfn !== undefined;
    if (mapping) mapfn = $8a0b7edcb386df4b$exports(mapfn, argumentsLength > 2 ? arguments[2] : undefined);
    var O = $ad1d9797f1e27af5$exports(arrayLike);
    var iteratorMethod = $72368fb318b24c5c$exports(O);
    var index = 0;
    var length, result, step, iterator, next, value;
    // if the target is not iterable or it's an array with the default iterator - use a simple case
    if (iteratorMethod && !(this === $9173555772c6cd7a$var$$Array && $6403e03a78aa5d48$exports(iteratorMethod))) {
        result = IS_CONSTRUCTOR ? new this() : [];
        iterator = $76e56b966649496d$exports(O, iteratorMethod);
        next = iterator.next;
        for(; !(step = $59bf80837927ca02$exports(next, iterator)).done; index++){
            value = mapping ? $b8e218b2f0858dda$exports(iterator, mapfn, [
                step.value,
                index
            ], true) : step.value;
            try {
                $7e31aa0800ea6c75$exports(result, index, value);
            } catch (error) {
                $e1b3d4ae7339c252$exports(iterator, 'throw', error);
            }
        }
    } else {
        length = $dfe69c9cb1d4aa6b$exports(O);
        result = IS_CONSTRUCTOR ? new this(length) : $9173555772c6cd7a$var$$Array(length);
        for(; length > index; index++){
            value = mapping ? mapfn(O[index], index) : O[index];
            $7e31aa0800ea6c75$exports(result, index, value);
        }
    }
    $e408ebc9418a57d6$exports(result, index);
    return result;
};


var $d1cf75d632965c8c$exports = {};
'use strict';

var $d1cf75d632965c8c$var$ITERATOR = $8555fb22f74da29f$exports('iterator');
var $d1cf75d632965c8c$var$SAFE_CLOSING = false;
try {
    var $d1cf75d632965c8c$var$called = 0;
    var $d1cf75d632965c8c$var$iteratorWithReturn = {
        next: function next() {
            return {
                done: !!$d1cf75d632965c8c$var$called++
            };
        },
        'return': function() {
            $d1cf75d632965c8c$var$SAFE_CLOSING = true;
        }
    };
    // eslint-disable-next-line unicorn/no-immediate-mutation -- ES3 syntax limitation
    $d1cf75d632965c8c$var$iteratorWithReturn[$d1cf75d632965c8c$var$ITERATOR] = function() {
        return this;
    };
    // eslint-disable-next-line es/no-array-from, no-throw-literal -- required for testing
    Array.from($d1cf75d632965c8c$var$iteratorWithReturn, function() {
        throw 2;
    });
} catch (error) {}
$d1cf75d632965c8c$exports = function(exec, SKIP_CLOSING) {
    try {
        if (!SKIP_CLOSING && !$d1cf75d632965c8c$var$SAFE_CLOSING) return false;
    } catch (error) {
        return false;
    } // workaround of old WebKit + `eval` bug
    var ITERATION_SUPPORT = false;
    try {
        var object = {};
        // eslint-disable-next-line unicorn/no-immediate-mutation -- ES3 syntax limitation
        object[$d1cf75d632965c8c$var$ITERATOR] = function() {
            return {
                next: function next() {
                    return {
                        done: ITERATION_SUPPORT = true
                    };
                }
            };
        };
        exec(object);
    } catch (error) {}
    return ITERATION_SUPPORT;
};


var $119e96dd9066f70a$var$INCORRECT_ITERATION = !$d1cf75d632965c8c$exports(function(iterable) {
    // eslint-disable-next-line es/no-array-from -- required for testing
    Array.from(iterable);
});
// `Array.from` method
// https://tc39.es/ecma262/#sec-array.from
$244155c096ef4c14$exports({
    target: 'Array',
    stat: true,
    forced: $119e96dd9066f70a$var$INCORRECT_ITERATION
}, {
    from: $9173555772c6cd7a$exports
});


'use strict';


var $48e0d9ff1b9195be$require$$includes = $71c0092aac59bdd8$exports.includes;


// FF99+ bug
var $48e0d9ff1b9195be$var$BROKEN_ON_SPARSE = $ddd8e9441ae136f2$exports(function() {
    // eslint-disable-next-line es/no-array-prototype-includes -- detection
    return !Array(1).includes();
});
// Safari 26.4- bug
var $48e0d9ff1b9195be$var$BROKEN_ON_SPARSE_WITH_FROM_INDEX = $ddd8e9441ae136f2$exports(function() {
    // eslint-disable-next-line no-sparse-arrays, es/no-array-prototype-includes -- detection
    return [
        ,
        1
    ].includes(undefined, 1);
});
// `Array.prototype.includes` method
// https://tc39.es/ecma262/#sec-array.prototype.includes
$244155c096ef4c14$exports({
    target: 'Array',
    proto: true,
    forced: $48e0d9ff1b9195be$var$BROKEN_ON_SPARSE || $48e0d9ff1b9195be$var$BROKEN_ON_SPARSE_WITH_FROM_INDEX
}, {
    includes: function includes(el /* , fromIndex = 0 */ ) {
        return $48e0d9ff1b9195be$require$$includes(this, el, arguments.length > 1 ? arguments[1] : undefined);
    }
});
// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
$98d262ec833f9221$exports('includes');


var $a6770789dc15a9c7$exports = {};
'use strict';





var $a6770789dc15a9c7$require$defineProperty = $6f9fc35f567fa5b6$export$2d1720544b23b823;
var $f183cb308a74bc45$exports = {};
'use strict';





var $8067e66a49ca6349$exports = {};
'use strict';
var $e39e4f6b33201bf5$exports = {};
'use strict';




var $5f455f1b83f2c610$exports = {};
'use strict';




var $1e9a79416b0401f6$exports = {};
'use strict';

$1e9a79416b0401f6$exports = !$ddd8e9441ae136f2$exports(function() {
    function F() {}
    F.prototype.constructor = null;
    // eslint-disable-next-line es/no-object-getprototypeof -- required for testing
    return Object.getPrototypeOf(new F()) !== F.prototype;
});


var $5f455f1b83f2c610$var$IE_PROTO = $f2e10c313ac02773$exports('IE_PROTO');
var $5f455f1b83f2c610$var$$Object = Object;
var $5f455f1b83f2c610$var$ObjectPrototype = $5f455f1b83f2c610$var$$Object.prototype;
// `Object.getPrototypeOf` method
// https://tc39.es/ecma262/#sec-object.getprototypeof
// eslint-disable-next-line es/no-object-getprototypeof -- safe
$5f455f1b83f2c610$exports = $1e9a79416b0401f6$exports ? $5f455f1b83f2c610$var$$Object.getPrototypeOf : function(O) {
    var object = $ad1d9797f1e27af5$exports(O);
    if ($8bbc2bccc0a29296$exports(object, $5f455f1b83f2c610$var$IE_PROTO)) return object[$5f455f1b83f2c610$var$IE_PROTO];
    var constructor = object.constructor;
    if ($7c165f740ca92c53$exports(constructor) && object instanceof constructor) return constructor.prototype;
    return object instanceof $5f455f1b83f2c610$var$$Object ? $5f455f1b83f2c610$var$ObjectPrototype : null;
};





var $e39e4f6b33201bf5$var$ITERATOR = $8555fb22f74da29f$exports('iterator');
var $e39e4f6b33201bf5$var$BUGGY_SAFARI_ITERATORS = false;
// `%IteratorPrototype%` object
// https://tc39.es/ecma262/#sec-%iteratorprototype%-object
var $e39e4f6b33201bf5$var$IteratorPrototype, $e39e4f6b33201bf5$var$PrototypeOfArrayIteratorPrototype, $e39e4f6b33201bf5$var$arrayIterator;
/* eslint-disable es/no-array-prototype-keys -- safe */ if ([].keys) {
    $e39e4f6b33201bf5$var$arrayIterator = [].keys();
    // Safari 8 has buggy iterators w/o `next`
    if (!('next' in $e39e4f6b33201bf5$var$arrayIterator)) $e39e4f6b33201bf5$var$BUGGY_SAFARI_ITERATORS = true;
    else {
        $e39e4f6b33201bf5$var$PrototypeOfArrayIteratorPrototype = $5f455f1b83f2c610$exports($5f455f1b83f2c610$exports($e39e4f6b33201bf5$var$arrayIterator));
        if ($e39e4f6b33201bf5$var$PrototypeOfArrayIteratorPrototype !== Object.prototype) $e39e4f6b33201bf5$var$IteratorPrototype = $e39e4f6b33201bf5$var$PrototypeOfArrayIteratorPrototype;
    }
}
var $e39e4f6b33201bf5$var$NEW_ITERATOR_PROTOTYPE = !$4d7f82f6c4645870$exports($e39e4f6b33201bf5$var$IteratorPrototype) || $ddd8e9441ae136f2$exports(function() {
    var test = {};
    // FF44- legacy iterators case
    return $e39e4f6b33201bf5$var$IteratorPrototype[$e39e4f6b33201bf5$var$ITERATOR].call(test) !== test;
});
if ($e39e4f6b33201bf5$var$NEW_ITERATOR_PROTOTYPE) $e39e4f6b33201bf5$var$IteratorPrototype = {};
else if ($a4b83f418a8da28e$exports) $e39e4f6b33201bf5$var$IteratorPrototype = $491a5d5aa2efe6ec$exports($e39e4f6b33201bf5$var$IteratorPrototype);
// `%IteratorPrototype%[@@iterator]()` method
// https://tc39.es/ecma262/#sec-%iteratorprototype%-@@iterator
if (!$7c165f740ca92c53$exports($e39e4f6b33201bf5$var$IteratorPrototype[$e39e4f6b33201bf5$var$ITERATOR])) $73c8864ae5df5c4d$exports($e39e4f6b33201bf5$var$IteratorPrototype, $e39e4f6b33201bf5$var$ITERATOR, function() {
    return this;
});
$e39e4f6b33201bf5$exports = {
    IteratorPrototype: $e39e4f6b33201bf5$var$IteratorPrototype,
    BUGGY_SAFARI_ITERATORS: $e39e4f6b33201bf5$var$BUGGY_SAFARI_ITERATORS
};


var $8067e66a49ca6349$require$IteratorPrototype = $e39e4f6b33201bf5$exports.IteratorPrototype;




var $8067e66a49ca6349$var$returnThis = function returnThis() {
    return this;
};
$8067e66a49ca6349$exports = function(IteratorConstructor, NAME, next, ENUMERABLE_NEXT) {
    var TO_STRING_TAG = NAME + ' Iterator';
    IteratorConstructor.prototype = $491a5d5aa2efe6ec$exports($8067e66a49ca6349$require$IteratorPrototype, {
        next: $27c455d39660edb8$exports(+!ENUMERABLE_NEXT, next)
    });
    $54a3ba2fb7b04ac0$exports(IteratorConstructor, TO_STRING_TAG, false, true);
    $a779fed72cdcf179$exports[TO_STRING_TAG] = $8067e66a49ca6349$var$returnThis;
    return IteratorConstructor;
};



var $7c99bf1a4ca8c337$exports = {};
'use strict';
var $bea5901a2cc99f2c$exports = {};
'use strict';


$bea5901a2cc99f2c$exports = function(object, key, method) {
    try {
        // eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
        return $c224a7eda28c33b3$exports($082fcaa0a091ee30$exports(Object.getOwnPropertyDescriptor(object, key)[method]));
    } catch (error) {}
};




var $b69919998c60f16d$exports = {};
'use strict';
var $1debffc2be7ae50e$exports = {};
'use strict';

$1debffc2be7ae50e$exports = function(argument) {
    return $4d7f82f6c4645870$exports(argument) || argument === null;
};


var $b69919998c60f16d$var$$String = String;
var $b69919998c60f16d$var$$TypeError = TypeError;
$b69919998c60f16d$exports = function(argument) {
    if ($1debffc2be7ae50e$exports(argument)) return argument;
    throw new $b69919998c60f16d$var$$TypeError("Can't set " + $b69919998c60f16d$var$$String(argument) + ' as a prototype');
};


// `Object.setPrototypeOf` method
// https://tc39.es/ecma262/#sec-object.setprototypeof
// Works with __proto__ only. Old v8 can't work with null proto objects.
// eslint-disable-next-line es/no-object-setprototypeof -- safe
$7c99bf1a4ca8c337$exports = Object.setPrototypeOf || ('__proto__' in {} ? function() {
    var CORRECT_SETTER = false;
    var test = {};
    var setter;
    try {
        setter = $bea5901a2cc99f2c$exports(Object.prototype, '__proto__', 'set');
        setter(test, []);
        CORRECT_SETTER = test instanceof Array;
    } catch (error) {}
    return function setPrototypeOf(O, proto) {
        $0f70b7357550422e$exports(O);
        $b69919998c60f16d$exports(proto);
        if (!$4d7f82f6c4645870$exports(O)) return O;
        if (CORRECT_SETTER) setter(O, proto);
        else O.__proto__ = proto;
        return O;
    };
}() : undefined);








var $f183cb308a74bc45$var$PROPER_FUNCTION_NAME = $464881364ad3f936$exports.PROPER;
var $f183cb308a74bc45$var$CONFIGURABLE_FUNCTION_NAME = $464881364ad3f936$exports.CONFIGURABLE;
var $f183cb308a74bc45$var$IteratorPrototype = $e39e4f6b33201bf5$exports.IteratorPrototype;
var $f183cb308a74bc45$var$BUGGY_SAFARI_ITERATORS = $e39e4f6b33201bf5$exports.BUGGY_SAFARI_ITERATORS;
var $f183cb308a74bc45$var$ITERATOR = $8555fb22f74da29f$exports('iterator');
var $f183cb308a74bc45$var$KEYS = 'keys';
var $f183cb308a74bc45$var$VALUES = 'values';
var $f183cb308a74bc45$var$ENTRIES = 'entries';
var $f183cb308a74bc45$var$returnThis = function returnThis() {
    return this;
};
$f183cb308a74bc45$exports = function(Iterable, NAME, IteratorConstructor, next, DEFAULT, IS_SET, FORCED) {
    $8067e66a49ca6349$exports(IteratorConstructor, NAME, next);
    var getIterationMethod = function getIterationMethod(KIND) {
        if (KIND === DEFAULT && defaultIterator) return defaultIterator;
        if (!$f183cb308a74bc45$var$BUGGY_SAFARI_ITERATORS && KIND && KIND in IterablePrototype) return IterablePrototype[KIND];
        switch(KIND){
            case $f183cb308a74bc45$var$KEYS:
                return function keys() {
                    return new IteratorConstructor(this, KIND);
                };
            case $f183cb308a74bc45$var$VALUES:
                return function values() {
                    return new IteratorConstructor(this, KIND);
                };
            case $f183cb308a74bc45$var$ENTRIES:
                return function entries() {
                    return new IteratorConstructor(this, KIND);
                };
        }
        return function() {
            return new IteratorConstructor(this);
        };
    };
    var TO_STRING_TAG = NAME + ' Iterator';
    var INCORRECT_VALUES_NAME = false;
    var IterablePrototype = Iterable.prototype;
    var nativeIterator = IterablePrototype[$f183cb308a74bc45$var$ITERATOR] || IterablePrototype['@@iterator'] || DEFAULT && IterablePrototype[DEFAULT];
    var defaultIterator = !$f183cb308a74bc45$var$BUGGY_SAFARI_ITERATORS && nativeIterator || getIterationMethod(DEFAULT);
    var anyNativeIterator = NAME === 'Array' ? IterablePrototype.entries || nativeIterator : nativeIterator;
    var CurrentIteratorPrototype, methods, KEY;
    // fix native
    if (anyNativeIterator) {
        CurrentIteratorPrototype = $5f455f1b83f2c610$exports(anyNativeIterator.call(new Iterable()));
        if (CurrentIteratorPrototype !== Object.prototype && CurrentIteratorPrototype.next) {
            if (!$a4b83f418a8da28e$exports && $5f455f1b83f2c610$exports(CurrentIteratorPrototype) !== $f183cb308a74bc45$var$IteratorPrototype) {
                if ($7c99bf1a4ca8c337$exports) $7c99bf1a4ca8c337$exports(CurrentIteratorPrototype, $f183cb308a74bc45$var$IteratorPrototype);
                else if (!$7c165f740ca92c53$exports(CurrentIteratorPrototype[$f183cb308a74bc45$var$ITERATOR])) $73c8864ae5df5c4d$exports(CurrentIteratorPrototype, $f183cb308a74bc45$var$ITERATOR, $f183cb308a74bc45$var$returnThis);
            }
            // Set @@toStringTag to native iterators
            $54a3ba2fb7b04ac0$exports(CurrentIteratorPrototype, TO_STRING_TAG, true, true);
            if ($a4b83f418a8da28e$exports) $a779fed72cdcf179$exports[TO_STRING_TAG] = $f183cb308a74bc45$var$returnThis;
        }
    }
    // fix Array.prototype.{ values, @@iterator }.name in V8 / FF
    if ($f183cb308a74bc45$var$PROPER_FUNCTION_NAME && DEFAULT === $f183cb308a74bc45$var$VALUES && nativeIterator && nativeIterator.name !== $f183cb308a74bc45$var$VALUES) {
        if (!$a4b83f418a8da28e$exports && $f183cb308a74bc45$var$CONFIGURABLE_FUNCTION_NAME) $b390530569770271$exports(IterablePrototype, 'name', $f183cb308a74bc45$var$VALUES);
        else {
            INCORRECT_VALUES_NAME = true;
            defaultIterator = function values() {
                return $59bf80837927ca02$exports(nativeIterator, this);
            };
        }
    }
    // export additional methods
    if (DEFAULT) {
        methods = {
            values: getIterationMethod($f183cb308a74bc45$var$VALUES),
            keys: IS_SET ? defaultIterator : getIterationMethod($f183cb308a74bc45$var$KEYS),
            entries: getIterationMethod($f183cb308a74bc45$var$ENTRIES)
        };
        if (FORCED) {
            for(KEY in methods)if ($f183cb308a74bc45$var$BUGGY_SAFARI_ITERATORS || INCORRECT_VALUES_NAME || !(KEY in IterablePrototype)) $73c8864ae5df5c4d$exports(IterablePrototype, KEY, methods[KEY]);
        } else $244155c096ef4c14$exports({
            target: NAME,
            proto: true,
            forced: $f183cb308a74bc45$var$BUGGY_SAFARI_ITERATORS || INCORRECT_VALUES_NAME
        }, methods);
    }
    // define iterator
    if ((!$a4b83f418a8da28e$exports || FORCED) && IterablePrototype[$f183cb308a74bc45$var$ITERATOR] !== defaultIterator) $73c8864ae5df5c4d$exports(IterablePrototype, $f183cb308a74bc45$var$ITERATOR, defaultIterator, {
        name: DEFAULT
    });
    $a779fed72cdcf179$exports[NAME] = defaultIterator;
    return methods;
};


var $71995534a6c57f64$exports = {};
'use strict';
// `CreateIterResultObject` abstract operation
// https://tc39.es/ecma262/#sec-createiterresultobject
$71995534a6c57f64$exports = function(value, done) {
    return {
        value: value,
        done: done
    };
};




var $a6770789dc15a9c7$var$ARRAY_ITERATOR = 'Array Iterator';
var $a6770789dc15a9c7$var$setInternalState = $fcfe8b5396fbe91a$exports.set;
var $a6770789dc15a9c7$var$getInternalState = $fcfe8b5396fbe91a$exports.getterFor($a6770789dc15a9c7$var$ARRAY_ITERATOR);
// `Array.prototype.entries` method
// https://tc39.es/ecma262/#sec-array.prototype.entries
// `Array.prototype.keys` method
// https://tc39.es/ecma262/#sec-array.prototype.keys
// `Array.prototype.values` method
// https://tc39.es/ecma262/#sec-array.prototype.values
// `Array.prototype[@@iterator]` method
// https://tc39.es/ecma262/#sec-array.prototype-@@iterator
// `CreateArrayIterator` internal method
// https://tc39.es/ecma262/#sec-createarrayiterator
$a6770789dc15a9c7$exports = $f183cb308a74bc45$exports(Array, 'Array', function(iterated, kind) {
    $a6770789dc15a9c7$var$setInternalState(this, {
        type: $a6770789dc15a9c7$var$ARRAY_ITERATOR,
        target: $59a8f2f00edbf5a1$exports(iterated),
        index: 0,
        kind: kind // kind
    });
// `%ArrayIteratorPrototype%.next` method
// https://tc39.es/ecma262/#sec-%arrayiteratorprototype%.next
}, function() {
    var state = $a6770789dc15a9c7$var$getInternalState(this);
    var target = state.target;
    var index = state.index++;
    if (!target || index >= target.length) {
        state.target = null;
        return $71995534a6c57f64$exports(undefined, true);
    }
    switch(state.kind){
        case 'keys':
            return $71995534a6c57f64$exports(index, false);
        case 'values':
            return $71995534a6c57f64$exports(target[index], false);
    }
    return $71995534a6c57f64$exports([
        index,
        target[index]
    ], false);
}, 'values');
// argumentsList[@@iterator] is %ArrayProto_values%
// https://tc39.es/ecma262/#sec-createunmappedargumentsobject
// https://tc39.es/ecma262/#sec-createmappedargumentsobject
var $a6770789dc15a9c7$var$values = $a779fed72cdcf179$exports.Arguments = $a779fed72cdcf179$exports.Array;
// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
$98d262ec833f9221$exports('keys');
$98d262ec833f9221$exports('values');
$98d262ec833f9221$exports('entries');
// V8 ~ Chrome 45- bug
if (!$a4b83f418a8da28e$exports && $b9f536d3284d7921$exports && $a6770789dc15a9c7$var$values.name !== 'values') try {
    $a6770789dc15a9c7$require$defineProperty($a6770789dc15a9c7$var$values, 'name', {
        value: 'values'
    });
} catch (error) {}


'use strict';




var $e6cb878020bcaa14$exports = {};
'use strict';

$e6cb878020bcaa14$exports = function(METHOD_NAME, argument) {
    var method = [][METHOD_NAME];
    return !!method && $ddd8e9441ae136f2$exports(function() {
        // eslint-disable-next-line no-useless-call -- required for testing
        method.call(null, argument || function() {
            return 1;
        }, 1);
    });
};


var $b0353101516b2866$var$nativeJoin = $c224a7eda28c33b3$exports([].join);
var $b0353101516b2866$var$ES3_STRINGS = $7a4c0b5af5b2bbd3$exports !== Object;
var $b0353101516b2866$var$FORCED = $b0353101516b2866$var$ES3_STRINGS || !$e6cb878020bcaa14$exports('join', ',');
// `Array.prototype.join` method
// https://tc39.es/ecma262/#sec-array.prototype.join
$244155c096ef4c14$exports({
    target: 'Array',
    proto: true,
    forced: $b0353101516b2866$var$FORCED
}, {
    join: function join(separator) {
        return $b0353101516b2866$var$nativeJoin($59a8f2f00edbf5a1$exports(this), separator === undefined ? ',' : separator);
    }
});


'use strict';


var $ddfb697017ef00ee$require$$map = $549edc5c9a026f8b$exports.map;

var $ddfb697017ef00ee$var$HAS_SPECIES_SUPPORT = $1e431e80cab7671b$exports('map');
// `Array.prototype.map` method
// https://tc39.es/ecma262/#sec-array.prototype.map
// with adding support of @@species
$244155c096ef4c14$exports({
    target: 'Array',
    proto: true,
    forced: !$ddfb697017ef00ee$var$HAS_SPECIES_SUPPORT
}, {
    map: function map(callbackfn /* , thisArg */ ) {
        return $ddfb697017ef00ee$require$$map(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
    }
});


'use strict';





var $84e544aa67a56230$var$$Array = Array;
var $84e544aa67a56230$var$ISNT_GENERIC = $ddd8e9441ae136f2$exports(function() {
    function F() {}
    // eslint-disable-next-line es/no-array-of -- safe
    return !($84e544aa67a56230$var$$Array.of.call(F) instanceof F);
});
// `Array.of` method
// https://tc39.es/ecma262/#sec-array.of
// WebKit Array.of isn't generic
$244155c096ef4c14$exports({
    target: 'Array',
    stat: true,
    forced: $84e544aa67a56230$var$ISNT_GENERIC
}, {
    of: function of() {
        var index = 0;
        var argumentsLength = arguments.length;
        var result = new ($db2ba5677c412211$exports(this) ? this : $84e544aa67a56230$var$$Array)(argumentsLength);
        while(argumentsLength > index)$7e31aa0800ea6c75$exports(result, index, arguments[index++]);
        $e408ebc9418a57d6$exports(result, argumentsLength);
        return result;
    }
});


'use strict';












var $18e668cd98e6dcfd$var$HAS_SPECIES_SUPPORT = $1e431e80cab7671b$exports('slice');
var $18e668cd98e6dcfd$var$SPECIES = $8555fb22f74da29f$exports('species');
var $18e668cd98e6dcfd$var$$Array = Array;
var $18e668cd98e6dcfd$var$max = Math.max;
// `Array.prototype.slice` method
// https://tc39.es/ecma262/#sec-array.prototype.slice
// fallback for not array-like ES3 strings and DOM objects
$244155c096ef4c14$exports({
    target: 'Array',
    proto: true,
    forced: !$18e668cd98e6dcfd$var$HAS_SPECIES_SUPPORT
}, {
    slice: function slice(start, end) {
        var O = $59a8f2f00edbf5a1$exports(this);
        var length = $dfe69c9cb1d4aa6b$exports(O);
        var k = $32c589906f6ca696$exports(start, length);
        var fin = $32c589906f6ca696$exports(end === undefined ? length : end, length);
        // inline `ArraySpeciesCreate` for usage native `Array#slice` where it's possible
        var Constructor, result, n;
        if ($b95992045c940cb8$exports(O)) {
            Constructor = O.constructor;
            // cross-realm fallback
            if ($db2ba5677c412211$exports(Constructor) && (Constructor === $18e668cd98e6dcfd$var$$Array || $b95992045c940cb8$exports(Constructor.prototype))) Constructor = undefined;
            else if ($4d7f82f6c4645870$exports(Constructor)) {
                Constructor = Constructor[$18e668cd98e6dcfd$var$SPECIES];
                if (Constructor === null) Constructor = undefined;
            }
            if (Constructor === $18e668cd98e6dcfd$var$$Array || Constructor === undefined) return $2dd14968e62d6eb1$exports(O, k, fin);
        }
        result = new (Constructor === undefined ? $18e668cd98e6dcfd$var$$Array : Constructor)($18e668cd98e6dcfd$var$max(fin - k, 0));
        for(n = 0; k < fin; k++, n++)if (k in O) $7e31aa0800ea6c75$exports(result, n, O[k]);
        $e408ebc9418a57d6$exports(result, n);
        return result;
    }
});


'use strict';








var $a4ee3cc522d386c7$exports = {};
'use strict';

var $a4ee3cc522d386c7$var$floor = Math.floor;
var $a4ee3cc522d386c7$var$sort = function sort1(array, comparefn) {
    var length = array.length;
    if (length < 8) {
        // insertion sort
        var i = 1;
        var element, j;
        while(i < length){
            j = i;
            element = array[i];
            while(j && comparefn(array[j - 1], element) > 0)array[j] = array[--j];
            if (j !== i++) array[j] = element;
        }
    } else {
        // merge sort
        var middle = $a4ee3cc522d386c7$var$floor(length / 2);
        var left = $a4ee3cc522d386c7$var$sort($2dd14968e62d6eb1$exports(array, 0, middle), comparefn);
        var right = $a4ee3cc522d386c7$var$sort($2dd14968e62d6eb1$exports(array, middle), comparefn);
        var llength = left.length;
        var rlength = right.length;
        var lindex = 0;
        var rindex = 0;
        while(lindex < llength || rindex < rlength)array[lindex + rindex] = lindex < llength && rindex < rlength ? comparefn(left[lindex], right[rindex]) <= 0 ? left[lindex++] : right[rindex++] : lindex < llength ? left[lindex++] : right[rindex++];
    }
    return array;
};
$a4ee3cc522d386c7$exports = $a4ee3cc522d386c7$var$sort;



var $13fa928c416d68a2$exports = {};
'use strict';

var $13fa928c416d68a2$var$firefox = $ef443fb3091f223d$exports.match(/firefox\/(\d+)/i);
$13fa928c416d68a2$exports = !!$13fa928c416d68a2$var$firefox && +$13fa928c416d68a2$var$firefox[1];


var $393ad2f8b955ad37$exports = {};
'use strict';

$393ad2f8b955ad37$exports = /MSIE|Trident/.test($ef443fb3091f223d$exports);



var $a8d4456c1aa6edf5$exports = {};
'use strict';

var $a8d4456c1aa6edf5$var$webkit = $ef443fb3091f223d$exports.match(/AppleWebKit\/(\d+)\./);
$a8d4456c1aa6edf5$exports = !!$a8d4456c1aa6edf5$var$webkit && +$a8d4456c1aa6edf5$var$webkit[1];


var $e72a8b6b1a5cef7d$var$test = [];
var $e72a8b6b1a5cef7d$var$nativeSort = $c224a7eda28c33b3$exports($e72a8b6b1a5cef7d$var$test.sort);
var $e72a8b6b1a5cef7d$var$push = $c224a7eda28c33b3$exports($e72a8b6b1a5cef7d$var$test.push);
// IE8-
var $e72a8b6b1a5cef7d$var$FAILS_ON_UNDEFINED = $ddd8e9441ae136f2$exports(function() {
    $e72a8b6b1a5cef7d$var$test.sort(undefined);
});
// V8 bug
var $e72a8b6b1a5cef7d$var$FAILS_ON_NULL = $ddd8e9441ae136f2$exports(function() {
    $e72a8b6b1a5cef7d$var$test.sort(null);
});
// Old WebKit
var $e72a8b6b1a5cef7d$var$STRICT_METHOD = $e6cb878020bcaa14$exports('sort');
var $e72a8b6b1a5cef7d$var$STABLE_SORT = !$ddd8e9441ae136f2$exports(function() {
    // feature detection can be too slow, so check engines versions
    if ($af93164be802bd69$exports) return $af93164be802bd69$exports < 70;
    if ($13fa928c416d68a2$exports && $13fa928c416d68a2$exports > 3) return;
    if ($393ad2f8b955ad37$exports) return true;
    if ($a8d4456c1aa6edf5$exports) return $a8d4456c1aa6edf5$exports < 603;
    var result = '';
    var code, chr, value, index;
    // generate an array with more 512 elements (Chakra and old V8 fails only in this case)
    for(code = 65; code < 76; code++){
        chr = String.fromCharCode(code);
        switch(code){
            case 66:
            case 69:
            case 70:
            case 72:
                value = 3;
                break;
            case 68:
            case 71:
                value = 4;
                break;
            default:
                value = 2;
        }
        for(index = 0; index < 47; index++)$e72a8b6b1a5cef7d$var$test.push({
            k: chr + index,
            v: value
        });
    }
    $e72a8b6b1a5cef7d$var$test.sort(function(a, b) {
        return b.v - a.v;
    });
    for(index = 0; index < $e72a8b6b1a5cef7d$var$test.length; index++){
        chr = $e72a8b6b1a5cef7d$var$test[index].k.charAt(0);
        if (result.charAt(result.length - 1) !== chr) result += chr;
    }
    return result !== 'DGBEFHACIJK';
});
var $e72a8b6b1a5cef7d$var$FORCED = $e72a8b6b1a5cef7d$var$FAILS_ON_UNDEFINED || !$e72a8b6b1a5cef7d$var$FAILS_ON_NULL || !$e72a8b6b1a5cef7d$var$STRICT_METHOD || !$e72a8b6b1a5cef7d$var$STABLE_SORT;
var $e72a8b6b1a5cef7d$var$getSortCompare = function getSortCompare(comparefn) {
    return function(x, y) {
        if (y === undefined) return -1;
        if (x === undefined) return 1;
        if (comparefn !== undefined) return +comparefn(x, y) || 0;
        var xString = $7c610b7ee22557b5$exports(x);
        var yString = $7c610b7ee22557b5$exports(y);
        return xString === yString ? 0 : xString > yString ? 1 : -1;
    };
};
// `Array.prototype.sort` method
// https://tc39.es/ecma262/#sec-array.prototype.sort
$244155c096ef4c14$exports({
    target: 'Array',
    proto: true,
    forced: $e72a8b6b1a5cef7d$var$FORCED
}, {
    sort: function sort(comparefn) {
        if (comparefn !== undefined) $082fcaa0a091ee30$exports(comparefn);
        var array = $ad1d9797f1e27af5$exports(this);
        if ($e72a8b6b1a5cef7d$var$STABLE_SORT) return comparefn === undefined ? $e72a8b6b1a5cef7d$var$nativeSort(array) : $e72a8b6b1a5cef7d$var$nativeSort(array, comparefn);
        var items = [];
        var arrayLength = $dfe69c9cb1d4aa6b$exports(array);
        var itemsLength, index;
        for(index = 0; index < arrayLength; index++)if (index in array) $e72a8b6b1a5cef7d$var$push(items, array[index]);
        $a4ee3cc522d386c7$exports(items, $e72a8b6b1a5cef7d$var$getSortCompare(comparefn));
        itemsLength = $dfe69c9cb1d4aa6b$exports(items);
        index = 0;
        while(index < itemsLength)array[index] = items[index++];
        while(index < arrayLength)$525d0704a99182b6$exports(array, index++);
        return array;
    }
});


'use strict';
var $2eb70ff7aa9594a1$exports = {};
'use strict';




var $2eb70ff7aa9594a1$var$SPECIES = $8555fb22f74da29f$exports('species');
$2eb70ff7aa9594a1$exports = function(CONSTRUCTOR_NAME) {
    var Constructor = $e8972ff3cf85d361$exports(CONSTRUCTOR_NAME);
    if ($b9f536d3284d7921$exports && Constructor && !Constructor[$2eb70ff7aa9594a1$var$SPECIES]) $71a985fce44d8187$exports(Constructor, $2eb70ff7aa9594a1$var$SPECIES, {
        configurable: true,
        get: function get() {
            return this;
        }
    });
};


// `Array[@@species]` getter
// https://tc39.es/ecma262/#sec-get-array-@@species
$2eb70ff7aa9594a1$exports('Array');


'use strict';











var $ea7d59fccb31b3bf$var$HAS_SPECIES_SUPPORT = $1e431e80cab7671b$exports('splice');
var $ea7d59fccb31b3bf$var$max = Math.max;
var $ea7d59fccb31b3bf$var$min = Math.min;
// `Array.prototype.splice` method
// https://tc39.es/ecma262/#sec-array.prototype.splice
// with adding support of @@species
$244155c096ef4c14$exports({
    target: 'Array',
    proto: true,
    forced: !$ea7d59fccb31b3bf$var$HAS_SPECIES_SUPPORT
}, {
    splice: function splice(start, deleteCount /* , ...items */ ) {
        var O = $ad1d9797f1e27af5$exports(this);
        var len = $dfe69c9cb1d4aa6b$exports(O);
        var actualStart = $32c589906f6ca696$exports(start, len);
        var argumentsLength = arguments.length;
        var insertCount, actualDeleteCount, A, k, from, to;
        if (argumentsLength === 0) insertCount = actualDeleteCount = 0;
        else if (argumentsLength === 1) {
            insertCount = 0;
            actualDeleteCount = len - actualStart;
        } else {
            insertCount = argumentsLength - 2;
            actualDeleteCount = $ea7d59fccb31b3bf$var$min($ea7d59fccb31b3bf$var$max($a8fecfd456e884de$exports(deleteCount), 0), len - actualStart);
        }
        $4cb5f05ebd848a3e$exports(len + insertCount - actualDeleteCount);
        A = $9dd5766bb20abe7e$exports(O, actualDeleteCount);
        for(k = 0; k < actualDeleteCount; k++){
            from = actualStart + k;
            if (from in O) $7e31aa0800ea6c75$exports(A, k, O[from]);
        }
        $e408ebc9418a57d6$exports(A, actualDeleteCount);
        if (insertCount < actualDeleteCount) {
            for(k = actualStart; k < len - actualDeleteCount; k++){
                from = k + actualDeleteCount;
                to = k + insertCount;
                if (from in O) O[to] = O[from];
                else $525d0704a99182b6$exports(O, to);
            }
            for(k = len; k > len - actualDeleteCount + insertCount; k--)$525d0704a99182b6$exports(O, k - 1);
        } else if (insertCount > actualDeleteCount) for(k = len - actualDeleteCount; k > actualStart; k--){
            from = k + actualDeleteCount - 1;
            to = k + insertCount - 1;
            if (from in O) O[to] = O[from];
            else $525d0704a99182b6$exports(O, to);
        }
        for(k = 0; k < insertCount; k++)O[k + actualStart] = arguments[k + 2];
        $e408ebc9418a57d6$exports(O, len - actualDeleteCount + insertCount);
        return A;
    }
});


'use strict';

// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
$98d262ec833f9221$exports('flat');


'use strict';

// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
$98d262ec833f9221$exports('flatMap');


'use strict';


var $e48fe9c4d5e5f9fa$exports = {};
'use strict';



var $be80dd6d37683baf$exports = {};
'use strict';
// eslint-disable-next-line es/no-typed-arrays -- safe
$be80dd6d37683baf$exports = typeof ArrayBuffer != 'undefined' && typeof DataView != 'undefined';





var $260286081d4ac307$exports = {};
'use strict';

$260286081d4ac307$exports = function(target, src, options) {
    for(var key in src)$73c8864ae5df5c4d$exports(target, key, src[key], options);
    return target;
};



var $93a46accb3e7c173$exports = {};
'use strict';

var $93a46accb3e7c173$var$$TypeError = TypeError;
$93a46accb3e7c173$exports = function(it, Prototype) {
    if ($5c91390ffea610b9$exports(Prototype, it)) return it;
    throw new $93a46accb3e7c173$var$$TypeError('Incorrect invocation');
};



var $31c8128d403d84d3$exports = {};
'use strict';


var $31c8128d403d84d3$var$$RangeError = RangeError;
// `ToIndex` abstract operation
// https://tc39.es/ecma262/#sec-toindex
$31c8128d403d84d3$exports = function(it) {
    if (it === undefined) return 0;
    var number = $a8fecfd456e884de$exports(it);
    var length = $aa75059f0a5ef94e$exports(number);
    if (number !== length) throw new $31c8128d403d84d3$var$$RangeError('Wrong length or index');
    return length;
};


var $e912d92303683117$exports = {};
'use strict';
var $ab74bdb5f2edb86b$exports = {};
'use strict';
var $2b5bb9984048f8cd$exports = {};
'use strict';
// `Math.sign` method implementation
// https://tc39.es/ecma262/#sec-math.sign
// eslint-disable-next-line es/no-math-sign -- safe
$2b5bb9984048f8cd$exports = Math.sign || function sign(x) {
    var n = +x;
    // eslint-disable-next-line no-self-compare -- NaN check
    return n === 0 || n !== n ? n : n < 0 ? -1 : 1;
};


var $1c3a299e8c927035$exports = {};
'use strict';
var $1c3a299e8c927035$var$EPSILON = 2.220446049250313e-16; // Number.EPSILON
var $1c3a299e8c927035$var$INVERSE_EPSILON = 1 / $1c3a299e8c927035$var$EPSILON;
$1c3a299e8c927035$exports = function(n) {
    return n + $1c3a299e8c927035$var$INVERSE_EPSILON - $1c3a299e8c927035$var$INVERSE_EPSILON;
};


var $ab74bdb5f2edb86b$var$abs = Math.abs;
var $ab74bdb5f2edb86b$var$EPSILON = 2.220446049250313e-16; // Number.EPSILON
$ab74bdb5f2edb86b$exports = function(x, FLOAT_EPSILON, FLOAT_MAX_VALUE, FLOAT_MIN_VALUE) {
    var n = +x;
    var absolute = $ab74bdb5f2edb86b$var$abs(n);
    var s = $2b5bb9984048f8cd$exports(n);
    if (absolute < FLOAT_MIN_VALUE) return s * $1c3a299e8c927035$exports(absolute / FLOAT_MIN_VALUE / FLOAT_EPSILON) * FLOAT_MIN_VALUE * FLOAT_EPSILON;
    var a = (1 + FLOAT_EPSILON / $ab74bdb5f2edb86b$var$EPSILON) * absolute;
    var result = a - (a - absolute);
    // eslint-disable-next-line no-self-compare -- NaN check
    if (result > FLOAT_MAX_VALUE || result !== result) return s * Infinity;
    return s * result;
};


var $e912d92303683117$var$FLOAT32_EPSILON = 1.1920928955078125e-7; // 2 ** -23;
var $e912d92303683117$var$FLOAT32_MAX_VALUE = 3.4028234663852886e+38; // 2 ** 128 - 2 ** 104
var $e912d92303683117$var$FLOAT32_MIN_VALUE = 1.1754943508222875e-38; // 2 ** -126;
// `Math.fround` method implementation
// https://tc39.es/ecma262/#sec-math.fround
// eslint-disable-next-line es/no-math-fround -- safe
$e912d92303683117$exports = Math.fround || function fround(x) {
    return $ab74bdb5f2edb86b$exports(x, $e912d92303683117$var$FLOAT32_EPSILON, $e912d92303683117$var$FLOAT32_MAX_VALUE, $e912d92303683117$var$FLOAT32_MIN_VALUE);
};


var $24230a1e60baa9e3$exports = {};
'use strict';
// IEEE754 conversions based on https://github.com/feross/ieee754
var $24230a1e60baa9e3$var$$Array = Array;
var $24230a1e60baa9e3$var$abs = Math.abs;
var $24230a1e60baa9e3$var$pow = Math.pow;
var $24230a1e60baa9e3$var$floor = Math.floor;
var $24230a1e60baa9e3$var$log = Math.log;
var $24230a1e60baa9e3$var$LN2 = Math.LN2;
var $24230a1e60baa9e3$var$pack = function pack(number, mantissaLength, bytes) {
    var buffer = $24230a1e60baa9e3$var$$Array(bytes);
    var exponentLength = bytes * 8 - mantissaLength - 1;
    var eMax = (1 << exponentLength) - 1;
    var eBias = eMax >> 1;
    var rt = mantissaLength === 23 ? $24230a1e60baa9e3$var$pow(2, -24) - $24230a1e60baa9e3$var$pow(2, -77) : 0;
    var sign = number < 0 || number === 0 && 1 / number < 0 ? 1 : 0;
    var index = 0;
    var exponent, mantissa, c;
    number = $24230a1e60baa9e3$var$abs(number);
    // eslint-disable-next-line no-self-compare -- NaN check
    if (number !== number || number === Infinity) {
        // eslint-disable-next-line no-self-compare -- NaN check
        mantissa = number !== number ? 1 : 0;
        exponent = eMax;
    } else {
        exponent = $24230a1e60baa9e3$var$floor($24230a1e60baa9e3$var$log(number) / $24230a1e60baa9e3$var$LN2);
        c = $24230a1e60baa9e3$var$pow(2, -exponent);
        if (number * c < 1) {
            exponent--;
            c *= 2;
        }
        if (exponent + eBias >= 1) number += rt / c;
        else number += rt * $24230a1e60baa9e3$var$pow(2, 1 - eBias);
        if (number * c >= 2) {
            exponent++;
            c /= 2;
        }
        if (exponent + eBias >= eMax) {
            mantissa = 0;
            exponent = eMax;
        } else if (exponent + eBias >= 1) {
            mantissa = (number * c - 1) * $24230a1e60baa9e3$var$pow(2, mantissaLength);
            exponent += eBias;
        } else {
            mantissa = number * $24230a1e60baa9e3$var$pow(2, eBias - 1) * $24230a1e60baa9e3$var$pow(2, mantissaLength);
            exponent = 0;
        }
    }
    while(mantissaLength >= 8){
        buffer[index++] = mantissa & 255;
        mantissa /= 256;
        mantissaLength -= 8;
    }
    exponent = exponent << mantissaLength | mantissa;
    exponentLength += mantissaLength;
    while(exponentLength > 0){
        buffer[index++] = exponent & 255;
        exponent /= 256;
        exponentLength -= 8;
    }
    buffer[index - 1] |= sign * 128;
    return buffer;
};
var $24230a1e60baa9e3$var$unpack = function unpack(buffer, mantissaLength) {
    var bytes = buffer.length;
    var exponentLength = bytes * 8 - mantissaLength - 1;
    var eMax = (1 << exponentLength) - 1;
    var eBias = eMax >> 1;
    var nBits = exponentLength - 7;
    var index = bytes - 1;
    var sign = buffer[index--];
    var exponent = sign & 127;
    var mantissa;
    sign >>= 7;
    while(nBits > 0){
        exponent = exponent * 256 + buffer[index--];
        nBits -= 8;
    }
    mantissa = exponent & (1 << -nBits) - 1;
    exponent >>= -nBits;
    nBits += mantissaLength;
    while(nBits > 0){
        mantissa = mantissa * 256 + buffer[index--];
        nBits -= 8;
    }
    if (exponent === 0) exponent = 1 - eBias;
    else if (exponent === eMax) return mantissa ? NaN : sign ? -Infinity : Infinity;
    else {
        mantissa += $24230a1e60baa9e3$var$pow(2, mantissaLength);
        exponent -= eBias;
    }
    return (sign ? -1 : 1) * mantissa * $24230a1e60baa9e3$var$pow(2, exponent - mantissaLength);
};
$24230a1e60baa9e3$exports = {
    pack: $24230a1e60baa9e3$var$pack,
    unpack: $24230a1e60baa9e3$var$unpack
};






var $834423bfd6526b45$exports = {};
'use strict';



// makes subclassing work correct for wrapped built-ins
$834423bfd6526b45$exports = function($this, dummy, Wrapper) {
    var NewTarget, NewTargetPrototype;
    if (// it can work only with native `setPrototypeOf`
    $7c99bf1a4ca8c337$exports && // we haven't completely correct pre-ES6 way for getting `new.target`, so use this
    $7c165f740ca92c53$exports(NewTarget = dummy.constructor) && NewTarget !== Wrapper && $4d7f82f6c4645870$exports(NewTargetPrototype = NewTarget.prototype) && NewTargetPrototype !== Wrapper.prototype) $7c99bf1a4ca8c337$exports($this, NewTargetPrototype);
    return $this;
};





var $e48fe9c4d5e5f9fa$var$PROPER_FUNCTION_NAME = $464881364ad3f936$exports.PROPER;
var $e48fe9c4d5e5f9fa$var$CONFIGURABLE_FUNCTION_NAME = $464881364ad3f936$exports.CONFIGURABLE;
var $e48fe9c4d5e5f9fa$var$ARRAY_BUFFER = 'ArrayBuffer';
var $e48fe9c4d5e5f9fa$var$DATA_VIEW = 'DataView';
var $e48fe9c4d5e5f9fa$var$PROTOTYPE = 'prototype';
var $e48fe9c4d5e5f9fa$var$WRONG_LENGTH = 'Wrong length';
var $e48fe9c4d5e5f9fa$var$WRONG_INDEX = 'Wrong index';
var $e48fe9c4d5e5f9fa$var$getInternalArrayBufferState = $fcfe8b5396fbe91a$exports.getterFor($e48fe9c4d5e5f9fa$var$ARRAY_BUFFER);
var $e48fe9c4d5e5f9fa$var$getInternalDataViewState = $fcfe8b5396fbe91a$exports.getterFor($e48fe9c4d5e5f9fa$var$DATA_VIEW);
var $e48fe9c4d5e5f9fa$var$setInternalState = $fcfe8b5396fbe91a$exports.set;
var $e48fe9c4d5e5f9fa$var$NativeArrayBuffer = $27350b6a9e85aed1$exports[$e48fe9c4d5e5f9fa$var$ARRAY_BUFFER];
var $e48fe9c4d5e5f9fa$var$$ArrayBuffer = $e48fe9c4d5e5f9fa$var$NativeArrayBuffer;
var $e48fe9c4d5e5f9fa$var$ArrayBufferPrototype = $e48fe9c4d5e5f9fa$var$$ArrayBuffer && $e48fe9c4d5e5f9fa$var$$ArrayBuffer[$e48fe9c4d5e5f9fa$var$PROTOTYPE];
var $e48fe9c4d5e5f9fa$var$$DataView = $27350b6a9e85aed1$exports[$e48fe9c4d5e5f9fa$var$DATA_VIEW];
var $e48fe9c4d5e5f9fa$var$DataViewPrototype = $e48fe9c4d5e5f9fa$var$$DataView && $e48fe9c4d5e5f9fa$var$$DataView[$e48fe9c4d5e5f9fa$var$PROTOTYPE];
var $e48fe9c4d5e5f9fa$var$ObjectPrototype = Object.prototype;
var $e48fe9c4d5e5f9fa$var$Array = $27350b6a9e85aed1$exports.Array;
var $e48fe9c4d5e5f9fa$var$RangeError = $27350b6a9e85aed1$exports.RangeError;
var $e48fe9c4d5e5f9fa$var$fill = $c224a7eda28c33b3$exports($635ab17dab618628$exports);
var $e48fe9c4d5e5f9fa$var$reverse = $c224a7eda28c33b3$exports([].reverse);
var $e48fe9c4d5e5f9fa$var$packIEEE754 = $24230a1e60baa9e3$exports.pack;
var $e48fe9c4d5e5f9fa$var$unpackIEEE754 = $24230a1e60baa9e3$exports.unpack;
var $e48fe9c4d5e5f9fa$var$packInt8 = function packInt8(number) {
    return [
        number & 0xFF
    ];
};
var $e48fe9c4d5e5f9fa$var$packInt16 = function packInt16(number) {
    return [
        number & 0xFF,
        number >> 8 & 0xFF
    ];
};
var $e48fe9c4d5e5f9fa$var$packInt32 = function packInt32(number) {
    return [
        number & 0xFF,
        number >> 8 & 0xFF,
        number >> 16 & 0xFF,
        number >> 24 & 0xFF
    ];
};
var $e48fe9c4d5e5f9fa$var$unpackInt32 = function unpackInt32(buffer) {
    return buffer[3] << 24 | buffer[2] << 16 | buffer[1] << 8 | buffer[0];
};
var $e48fe9c4d5e5f9fa$var$packFloat32 = function packFloat32(number) {
    return $e48fe9c4d5e5f9fa$var$packIEEE754($e912d92303683117$exports(number), 23, 4);
};
var $e48fe9c4d5e5f9fa$var$packFloat64 = function packFloat64(number) {
    return $e48fe9c4d5e5f9fa$var$packIEEE754(number, 52, 8);
};
var $e48fe9c4d5e5f9fa$var$addGetter = function addGetter(Constructor, key, getInternalState) {
    $71a985fce44d8187$exports(Constructor[$e48fe9c4d5e5f9fa$var$PROTOTYPE], key, {
        configurable: true,
        get: function get() {
            return getInternalState(this)[key];
        }
    });
};
var $e48fe9c4d5e5f9fa$var$get = function get(view, count, index, isLittleEndian) {
    var store = $e48fe9c4d5e5f9fa$var$getInternalDataViewState(view);
    var intIndex = $31c8128d403d84d3$exports(index);
    var boolIsLittleEndian = !!isLittleEndian;
    if (intIndex + count > store.byteLength) throw new $e48fe9c4d5e5f9fa$var$RangeError($e48fe9c4d5e5f9fa$var$WRONG_INDEX);
    var bytes = store.bytes;
    var start = intIndex + store.byteOffset;
    var pack = $2dd14968e62d6eb1$exports(bytes, start, start + count);
    return boolIsLittleEndian ? pack : $e48fe9c4d5e5f9fa$var$reverse(pack);
};
var $e48fe9c4d5e5f9fa$var$set = function set(view, count, index, conversion, value, isLittleEndian) {
    var store = $e48fe9c4d5e5f9fa$var$getInternalDataViewState(view);
    var intIndex = $31c8128d403d84d3$exports(index);
    var pack = conversion(+value);
    var boolIsLittleEndian = !!isLittleEndian;
    if (intIndex + count > store.byteLength) throw new $e48fe9c4d5e5f9fa$var$RangeError($e48fe9c4d5e5f9fa$var$WRONG_INDEX);
    var bytes = store.bytes;
    var start = intIndex + store.byteOffset;
    for(var i = 0; i < count; i++)bytes[start + i] = pack[boolIsLittleEndian ? i : count - i - 1];
};
if (!$be80dd6d37683baf$exports) {
    $e48fe9c4d5e5f9fa$var$$ArrayBuffer = function ArrayBuffer(length) {
        $93a46accb3e7c173$exports(this, $e48fe9c4d5e5f9fa$var$ArrayBufferPrototype);
        var byteLength = $31c8128d403d84d3$exports(length);
        $e48fe9c4d5e5f9fa$var$setInternalState(this, {
            type: $e48fe9c4d5e5f9fa$var$ARRAY_BUFFER,
            bytes: $e48fe9c4d5e5f9fa$var$fill($e48fe9c4d5e5f9fa$var$Array(byteLength), 0),
            byteLength: byteLength
        });
        if (!$b9f536d3284d7921$exports) {
            this.byteLength = byteLength;
            this.detached = false;
        }
    };
    $e48fe9c4d5e5f9fa$var$ArrayBufferPrototype = $e48fe9c4d5e5f9fa$var$$ArrayBuffer[$e48fe9c4d5e5f9fa$var$PROTOTYPE];
    $e48fe9c4d5e5f9fa$var$$DataView = function DataView(buffer, byteOffset, byteLength) {
        $93a46accb3e7c173$exports(this, $e48fe9c4d5e5f9fa$var$DataViewPrototype);
        $93a46accb3e7c173$exports(buffer, $e48fe9c4d5e5f9fa$var$ArrayBufferPrototype);
        var bufferState = $e48fe9c4d5e5f9fa$var$getInternalArrayBufferState(buffer);
        var bufferLength = bufferState.byteLength;
        var offset = $a8fecfd456e884de$exports(byteOffset);
        if (offset < 0 || offset > bufferLength) throw new $e48fe9c4d5e5f9fa$var$RangeError('Wrong offset');
        byteLength = byteLength === undefined ? bufferLength - offset : $31c8128d403d84d3$exports(byteLength);
        if (offset + byteLength > bufferLength) throw new $e48fe9c4d5e5f9fa$var$RangeError($e48fe9c4d5e5f9fa$var$WRONG_LENGTH);
        $e48fe9c4d5e5f9fa$var$setInternalState(this, {
            type: $e48fe9c4d5e5f9fa$var$DATA_VIEW,
            buffer: buffer,
            byteLength: byteLength,
            byteOffset: offset,
            bytes: bufferState.bytes
        });
        if (!$b9f536d3284d7921$exports) {
            this.buffer = buffer;
            this.byteLength = byteLength;
            this.byteOffset = offset;
        }
    };
    $e48fe9c4d5e5f9fa$var$DataViewPrototype = $e48fe9c4d5e5f9fa$var$$DataView[$e48fe9c4d5e5f9fa$var$PROTOTYPE];
    if ($b9f536d3284d7921$exports) {
        $e48fe9c4d5e5f9fa$var$addGetter($e48fe9c4d5e5f9fa$var$$ArrayBuffer, 'byteLength', $e48fe9c4d5e5f9fa$var$getInternalArrayBufferState);
        $e48fe9c4d5e5f9fa$var$addGetter($e48fe9c4d5e5f9fa$var$$DataView, 'buffer', $e48fe9c4d5e5f9fa$var$getInternalDataViewState);
        $e48fe9c4d5e5f9fa$var$addGetter($e48fe9c4d5e5f9fa$var$$DataView, 'byteLength', $e48fe9c4d5e5f9fa$var$getInternalDataViewState);
        $e48fe9c4d5e5f9fa$var$addGetter($e48fe9c4d5e5f9fa$var$$DataView, 'byteOffset', $e48fe9c4d5e5f9fa$var$getInternalDataViewState);
    }
    $260286081d4ac307$exports($e48fe9c4d5e5f9fa$var$DataViewPrototype, {
        getInt8: function getInt8(byteOffset) {
            return $e48fe9c4d5e5f9fa$var$get(this, 1, byteOffset)[0] << 24 >> 24;
        },
        getUint8: function getUint8(byteOffset) {
            return $e48fe9c4d5e5f9fa$var$get(this, 1, byteOffset)[0];
        },
        getInt16: function getInt16(byteOffset /* , littleEndian */ ) {
            var bytes = $e48fe9c4d5e5f9fa$var$get(this, 2, byteOffset, arguments.length > 1 ? arguments[1] : false);
            return (bytes[1] << 8 | bytes[0]) << 16 >> 16;
        },
        getUint16: function getUint16(byteOffset /* , littleEndian */ ) {
            var bytes = $e48fe9c4d5e5f9fa$var$get(this, 2, byteOffset, arguments.length > 1 ? arguments[1] : false);
            return bytes[1] << 8 | bytes[0];
        },
        getInt32: function getInt32(byteOffset /* , littleEndian */ ) {
            return $e48fe9c4d5e5f9fa$var$unpackInt32($e48fe9c4d5e5f9fa$var$get(this, 4, byteOffset, arguments.length > 1 ? arguments[1] : false));
        },
        getUint32: function getUint32(byteOffset /* , littleEndian */ ) {
            return $e48fe9c4d5e5f9fa$var$unpackInt32($e48fe9c4d5e5f9fa$var$get(this, 4, byteOffset, arguments.length > 1 ? arguments[1] : false)) >>> 0;
        },
        getFloat32: function getFloat32(byteOffset /* , littleEndian */ ) {
            return $e48fe9c4d5e5f9fa$var$unpackIEEE754($e48fe9c4d5e5f9fa$var$get(this, 4, byteOffset, arguments.length > 1 ? arguments[1] : false), 23);
        },
        getFloat64: function getFloat64(byteOffset /* , littleEndian */ ) {
            return $e48fe9c4d5e5f9fa$var$unpackIEEE754($e48fe9c4d5e5f9fa$var$get(this, 8, byteOffset, arguments.length > 1 ? arguments[1] : false), 52);
        },
        setInt8: function setInt8(byteOffset, value) {
            $e48fe9c4d5e5f9fa$var$set(this, 1, byteOffset, $e48fe9c4d5e5f9fa$var$packInt8, value);
        },
        setUint8: function setUint8(byteOffset, value) {
            $e48fe9c4d5e5f9fa$var$set(this, 1, byteOffset, $e48fe9c4d5e5f9fa$var$packInt8, value);
        },
        setInt16: function setInt16(byteOffset, value /* , littleEndian */ ) {
            $e48fe9c4d5e5f9fa$var$set(this, 2, byteOffset, $e48fe9c4d5e5f9fa$var$packInt16, value, arguments.length > 2 ? arguments[2] : false);
        },
        setUint16: function setUint16(byteOffset, value /* , littleEndian */ ) {
            $e48fe9c4d5e5f9fa$var$set(this, 2, byteOffset, $e48fe9c4d5e5f9fa$var$packInt16, value, arguments.length > 2 ? arguments[2] : false);
        },
        setInt32: function setInt32(byteOffset, value /* , littleEndian */ ) {
            $e48fe9c4d5e5f9fa$var$set(this, 4, byteOffset, $e48fe9c4d5e5f9fa$var$packInt32, value, arguments.length > 2 ? arguments[2] : false);
        },
        setUint32: function setUint32(byteOffset, value /* , littleEndian */ ) {
            $e48fe9c4d5e5f9fa$var$set(this, 4, byteOffset, $e48fe9c4d5e5f9fa$var$packInt32, value, arguments.length > 2 ? arguments[2] : false);
        },
        setFloat32: function setFloat32(byteOffset, value /* , littleEndian */ ) {
            $e48fe9c4d5e5f9fa$var$set(this, 4, byteOffset, $e48fe9c4d5e5f9fa$var$packFloat32, value, arguments.length > 2 ? arguments[2] : false);
        },
        setFloat64: function setFloat64(byteOffset, value /* , littleEndian */ ) {
            $e48fe9c4d5e5f9fa$var$set(this, 8, byteOffset, $e48fe9c4d5e5f9fa$var$packFloat64, value, arguments.length > 2 ? arguments[2] : false);
        }
    });
} else {
    var $e48fe9c4d5e5f9fa$var$INCORRECT_ARRAY_BUFFER_NAME = $e48fe9c4d5e5f9fa$var$PROPER_FUNCTION_NAME && $e48fe9c4d5e5f9fa$var$NativeArrayBuffer.name !== $e48fe9c4d5e5f9fa$var$ARRAY_BUFFER;
    /* eslint-disable no-new, sonarjs/inconsistent-function-call -- required for testing */ if (!$ddd8e9441ae136f2$exports(function() {
        $e48fe9c4d5e5f9fa$var$NativeArrayBuffer(1);
    }) || !$ddd8e9441ae136f2$exports(function() {
        new $e48fe9c4d5e5f9fa$var$NativeArrayBuffer(-1);
    }) || $ddd8e9441ae136f2$exports(function() {
        new $e48fe9c4d5e5f9fa$var$NativeArrayBuffer();
        new $e48fe9c4d5e5f9fa$var$NativeArrayBuffer(1.5);
        new $e48fe9c4d5e5f9fa$var$NativeArrayBuffer(NaN);
        return $e48fe9c4d5e5f9fa$var$NativeArrayBuffer.length !== 1 || $e48fe9c4d5e5f9fa$var$INCORRECT_ARRAY_BUFFER_NAME && !$e48fe9c4d5e5f9fa$var$CONFIGURABLE_FUNCTION_NAME;
    })) {
        /* eslint-enable no-new, sonarjs/inconsistent-function-call -- required for testing */ $e48fe9c4d5e5f9fa$var$$ArrayBuffer = function ArrayBuffer(length) {
            $93a46accb3e7c173$exports(this, $e48fe9c4d5e5f9fa$var$ArrayBufferPrototype);
            return $834423bfd6526b45$exports(new $e48fe9c4d5e5f9fa$var$NativeArrayBuffer($31c8128d403d84d3$exports(length)), this, $e48fe9c4d5e5f9fa$var$$ArrayBuffer);
        };
        $e48fe9c4d5e5f9fa$var$$ArrayBuffer[$e48fe9c4d5e5f9fa$var$PROTOTYPE] = $e48fe9c4d5e5f9fa$var$ArrayBufferPrototype;
        $e48fe9c4d5e5f9fa$var$ArrayBufferPrototype.constructor = $e48fe9c4d5e5f9fa$var$$ArrayBuffer;
        $9a17c1c56e0da0fc$exports($e48fe9c4d5e5f9fa$var$$ArrayBuffer, $e48fe9c4d5e5f9fa$var$NativeArrayBuffer);
    } else if ($e48fe9c4d5e5f9fa$var$INCORRECT_ARRAY_BUFFER_NAME && $e48fe9c4d5e5f9fa$var$CONFIGURABLE_FUNCTION_NAME) $b390530569770271$exports($e48fe9c4d5e5f9fa$var$NativeArrayBuffer, 'name', $e48fe9c4d5e5f9fa$var$ARRAY_BUFFER);
    // WebKit bug - the same parent prototype for typed arrays and data view
    if ($7c99bf1a4ca8c337$exports && $5f455f1b83f2c610$exports($e48fe9c4d5e5f9fa$var$DataViewPrototype) !== $e48fe9c4d5e5f9fa$var$ObjectPrototype) $7c99bf1a4ca8c337$exports($e48fe9c4d5e5f9fa$var$DataViewPrototype, $e48fe9c4d5e5f9fa$var$ObjectPrototype);
    // iOS Safari 7.x bug
    var $e48fe9c4d5e5f9fa$var$testView = new $e48fe9c4d5e5f9fa$var$$DataView(new $e48fe9c4d5e5f9fa$var$$ArrayBuffer(2));
    var $e48fe9c4d5e5f9fa$var$$setInt8 = $c224a7eda28c33b3$exports($e48fe9c4d5e5f9fa$var$DataViewPrototype.setInt8);
    $e48fe9c4d5e5f9fa$var$testView.setInt8(0, 2147483648);
    $e48fe9c4d5e5f9fa$var$testView.setInt8(1, 2147483649);
    if ($e48fe9c4d5e5f9fa$var$testView.getInt8(0) || !$e48fe9c4d5e5f9fa$var$testView.getInt8(1)) $260286081d4ac307$exports($e48fe9c4d5e5f9fa$var$DataViewPrototype, {
        setInt8: function setInt8(byteOffset, value) {
            $e48fe9c4d5e5f9fa$var$$setInt8(this, byteOffset, value << 24 >> 24);
        },
        setUint8: function setUint8(byteOffset, value) {
            $e48fe9c4d5e5f9fa$var$$setInt8(this, byteOffset, value << 24 >> 24);
        }
    }, {
        unsafe: true
    });
}
$54a3ba2fb7b04ac0$exports($e48fe9c4d5e5f9fa$var$$ArrayBuffer, $e48fe9c4d5e5f9fa$var$ARRAY_BUFFER);
$54a3ba2fb7b04ac0$exports($e48fe9c4d5e5f9fa$var$$DataView, $e48fe9c4d5e5f9fa$var$DATA_VIEW);
$e48fe9c4d5e5f9fa$exports = {
    ArrayBuffer: $e48fe9c4d5e5f9fa$var$$ArrayBuffer,
    DataView: $e48fe9c4d5e5f9fa$var$$DataView
};



var $c2f9bed85e06f1f1$var$ARRAY_BUFFER = 'ArrayBuffer';
var $c2f9bed85e06f1f1$var$ArrayBuffer = $e48fe9c4d5e5f9fa$exports[$c2f9bed85e06f1f1$var$ARRAY_BUFFER];
var $c2f9bed85e06f1f1$var$NativeArrayBuffer = $27350b6a9e85aed1$exports[$c2f9bed85e06f1f1$var$ARRAY_BUFFER];
// `ArrayBuffer` constructor
// https://tc39.es/ecma262/#sec-arraybuffer-constructor
$244155c096ef4c14$exports({
    global: true,
    constructor: true,
    forced: $c2f9bed85e06f1f1$var$NativeArrayBuffer !== $c2f9bed85e06f1f1$var$ArrayBuffer
}, {
    ArrayBuffer: $c2f9bed85e06f1f1$var$ArrayBuffer
});
$2eb70ff7aa9594a1$exports($c2f9bed85e06f1f1$var$ARRAY_BUFFER);


'use strict';


var $041940e2a53c0daa$exports = {};
'use strict';


var $041940e2a53c0daa$var$$TypeError = TypeError;
// `Date.prototype[@@toPrimitive](hint)` method implementation
// https://tc39.es/ecma262/#sec-date.prototype-@@toprimitive
$041940e2a53c0daa$exports = function(hint) {
    $7d9b9f0a2a7e34a2$exports(this);
    if (hint === 'string' || hint === 'default') hint = 'string';
    else if (hint !== 'number') throw new $041940e2a53c0daa$var$$TypeError('Incorrect hint');
    return $57ba5c286733c9e5$exports(this, hint);
};



var $933611313adae86e$var$TO_PRIMITIVE = $8555fb22f74da29f$exports('toPrimitive');
var $933611313adae86e$var$DatePrototype = Date.prototype;
// `Date.prototype[@@toPrimitive]` method
// https://tc39.es/ecma262/#sec-date.prototype-@@toprimitive
if (!$8bbc2bccc0a29296$exports($933611313adae86e$var$DatePrototype, $933611313adae86e$var$TO_PRIMITIVE)) $73c8864ae5df5c4d$exports($933611313adae86e$var$DatePrototype, $933611313adae86e$var$TO_PRIMITIVE, $041940e2a53c0daa$exports);


'use strict';






var $14db4e85055fdeb4$var$HAS_INSTANCE = $8555fb22f74da29f$exports('hasInstance');
var $14db4e85055fdeb4$var$FunctionPrototype = Function.prototype;
// `Function.prototype[@@hasInstance]` method
// https://tc39.es/ecma262/#sec-function.prototype-@@hasinstance
if (!($14db4e85055fdeb4$var$HAS_INSTANCE in $14db4e85055fdeb4$var$FunctionPrototype)) $6f9fc35f567fa5b6$export$2d1720544b23b823($14db4e85055fdeb4$var$FunctionPrototype, $14db4e85055fdeb4$var$HAS_INSTANCE, {
    value: $fef26419665138ba$exports(function(O) {
        if (!$7c165f740ca92c53$exports(this) || !$4d7f82f6c4645870$exports(O)) return false;
        var P = this.prototype;
        return $4d7f82f6c4645870$exports(P) ? $5c91390ffea610b9$exports(P, O) : O instanceof this;
    }, $14db4e85055fdeb4$var$HAS_INSTANCE)
});


'use strict';


var $d3f02bf6e96b13a9$require$FUNCTION_NAME_EXISTS = $464881364ad3f936$exports.EXISTS;


var $d3f02bf6e96b13a9$var$FunctionPrototype = Function.prototype;
var $d3f02bf6e96b13a9$var$functionToString = $c224a7eda28c33b3$exports($d3f02bf6e96b13a9$var$FunctionPrototype.toString);
var $d3f02bf6e96b13a9$var$nameRE = /function\b(?:\s|\/\*[\S\s]*?\*\/|\/\/[^\n\r]*[\n\r]+)*([^\s(/]*)/;
var $d3f02bf6e96b13a9$var$regExpExec = $c224a7eda28c33b3$exports($d3f02bf6e96b13a9$var$nameRE.exec);
var $d3f02bf6e96b13a9$var$NAME = 'name';
// Function instances `.name` property
// https://tc39.es/ecma262/#sec-function-instances-name
if ($b9f536d3284d7921$exports && !$d3f02bf6e96b13a9$require$FUNCTION_NAME_EXISTS) $71a985fce44d8187$exports($d3f02bf6e96b13a9$var$FunctionPrototype, $d3f02bf6e96b13a9$var$NAME, {
    configurable: true,
    get: function get() {
        try {
            return $d3f02bf6e96b13a9$var$regExpExec($d3f02bf6e96b13a9$var$nameRE, $d3f02bf6e96b13a9$var$functionToString(this))[1];
        } catch (error) {
            return '';
        }
    }
});


'use strict';


// JSON[@@toStringTag] property
// https://tc39.es/ecma262/#sec-json-@@tostringtag
$54a3ba2fb7b04ac0$exports($27350b6a9e85aed1$exports.JSON, 'JSON', true);


'use strict';
'use strict';
var $3f909713a27e049c$exports = {};
'use strict';





var $d263db769eb8b264$exports = {};

var $6tOPT = parcelRequire("6tOPT");
'use strict';






var $d263db769eb8b264$require$defineProperty = $6f9fc35f567fa5b6$export$2d1720544b23b823;


var $77d1f8899c709e1b$exports = {};
'use strict';



var $cc3b767a98af1ec0$exports = {};
'use strict';

$cc3b767a98af1ec0$exports = $ddd8e9441ae136f2$exports(function() {
    if (typeof ArrayBuffer == 'function') {
        var buffer = new ArrayBuffer(8);
        // eslint-disable-next-line es/no-object-isextensible, es/no-object-defineproperty -- safe
        if (Object.isExtensible(buffer)) Object.defineProperty(buffer, 'a', {
            value: 8
        });
    }
});


// eslint-disable-next-line es/no-object-isextensible -- safe
var $77d1f8899c709e1b$var$$isExtensible = Object.isExtensible;
var $77d1f8899c709e1b$var$FAILS_ON_PRIMITIVES = $ddd8e9441ae136f2$exports(function() {
    $77d1f8899c709e1b$var$$isExtensible(1);
});
// `Object.isExtensible` method
// https://tc39.es/ecma262/#sec-object.isextensible
$77d1f8899c709e1b$exports = $77d1f8899c709e1b$var$FAILS_ON_PRIMITIVES || $cc3b767a98af1ec0$exports ? function isExtensible(it) {
    if (!$4d7f82f6c4645870$exports(it)) return false;
    if ($cc3b767a98af1ec0$exports && $5a266b01e7970e30$exports(it) === 'ArrayBuffer') return false;
    return $77d1f8899c709e1b$var$$isExtensible ? $77d1f8899c709e1b$var$$isExtensible(it) : true;
} : $77d1f8899c709e1b$var$$isExtensible;



var $323042bd7ad218cd$exports = {};
'use strict';

$323042bd7ad218cd$exports = !$ddd8e9441ae136f2$exports(function() {
    // eslint-disable-next-line es/no-object-isextensible, es/no-object-preventextensions -- required for testing
    return Object.isExtensible(Object.preventExtensions({}));
});


var $d263db769eb8b264$var$REQUIRED = false;
var $d263db769eb8b264$var$METADATA = $bf14b42fd1d1c367$exports('meta');
var $d263db769eb8b264$var$id = 0;
var $d263db769eb8b264$var$setMetadata = function setMetadata(it) {
    $d263db769eb8b264$require$defineProperty(it, $d263db769eb8b264$var$METADATA, {
        value: {
            objectID: 'O' + $d263db769eb8b264$var$id++,
            weakData: {} // weak collections IDs
        }
    });
};
var $d263db769eb8b264$var$fastKey = function fastKey(it, create) {
    // return a primitive with prefix
    if (!$4d7f82f6c4645870$exports(it)) return (typeof it === "undefined" ? "undefined" : (0, $6tOPT._)(it)) == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
    if (!$8bbc2bccc0a29296$exports(it, $d263db769eb8b264$var$METADATA)) {
        // can't set metadata to uncaught frozen object
        if (!$77d1f8899c709e1b$exports(it)) return 'F';
        // not necessary to add metadata
        if (!create) return 'E';
        // add missing metadata
        $d263db769eb8b264$var$setMetadata(it);
    // return object ID
    }
    return it[$d263db769eb8b264$var$METADATA].objectID;
};
var $d263db769eb8b264$var$getWeakData = function getWeakData(it, create) {
    if (!$8bbc2bccc0a29296$exports(it, $d263db769eb8b264$var$METADATA)) {
        // can't set metadata to uncaught frozen object
        if (!$77d1f8899c709e1b$exports(it)) return true;
        // not necessary to add metadata
        if (!create) return false;
        // add missing metadata
        $d263db769eb8b264$var$setMetadata(it);
    // return the store of weak collections IDs
    }
    return it[$d263db769eb8b264$var$METADATA].weakData;
};
// add metadata on freeze-family methods calling
var $d263db769eb8b264$var$onFreeze = function onFreeze(it) {
    if ($323042bd7ad218cd$exports && $d263db769eb8b264$var$REQUIRED && $77d1f8899c709e1b$exports(it) && !$8bbc2bccc0a29296$exports(it, $d263db769eb8b264$var$METADATA)) $d263db769eb8b264$var$setMetadata(it);
    return it;
};
var $d263db769eb8b264$var$enable = function enable() {
    $d263db769eb8b264$var$meta.enable = function() {};
    $d263db769eb8b264$var$REQUIRED = true;
    var getOwnPropertyNames = $8b92903d5cdf859e$export$2d1720544b23b823;
    var splice = $c224a7eda28c33b3$exports([].splice);
    var test = {};
    // eslint-disable-next-line unicorn/no-immediate-mutation -- ES3 syntax limitation
    test[$d263db769eb8b264$var$METADATA] = 1;
    // prevent exposing of metadata key
    if (getOwnPropertyNames(test).length) {
        $8b92903d5cdf859e$exports.f = function(it) {
            var result = getOwnPropertyNames(it);
            for(var i = 0, length = result.length; i < length; i++)if (result[i] === $d263db769eb8b264$var$METADATA) {
                splice(result, i, 1);
                break;
            }
            return result;
        };
        $244155c096ef4c14$exports({
            target: 'Object',
            stat: true,
            forced: true
        }, {
            getOwnPropertyNames: $96008a693f58af2b$export$2d1720544b23b823
        });
    }
};
var $d263db769eb8b264$var$meta = $d263db769eb8b264$exports = {
    enable: $d263db769eb8b264$var$enable,
    fastKey: $d263db769eb8b264$var$fastKey,
    getWeakData: $d263db769eb8b264$var$getWeakData,
    onFreeze: $d263db769eb8b264$var$onFreeze
};
$91deb02321ce445c$exports[$d263db769eb8b264$var$METADATA] = true;


var $ec8a9e5ef0653b51$exports = {};

var $6tOPT = parcelRequire("6tOPT");
'use strict';










var $ec8a9e5ef0653b51$var$$TypeError = TypeError;
var $ec8a9e5ef0653b51$var$Result = function Result(stopped, result) {
    this.stopped = stopped;
    this.result = result;
};
var $ec8a9e5ef0653b51$var$ResultPrototype = $ec8a9e5ef0653b51$var$Result.prototype;
$ec8a9e5ef0653b51$exports = function(iterable, unboundFunction, options) {
    var that = options && options.that;
    var AS_ENTRIES = !!(options && options.AS_ENTRIES);
    var IS_RECORD = !!(options && options.IS_RECORD);
    var IS_ITERATOR = !!(options && options.IS_ITERATOR);
    var INTERRUPTED = !!(options && options.INTERRUPTED);
    var fn = $8a0b7edcb386df4b$exports(unboundFunction, that);
    var iterator, iterFn, index, length, result, next, step;
    var stop = function stop(condition) {
        var $iterator = iterator;
        iterator = undefined;
        if ($iterator) $e1b3d4ae7339c252$exports($iterator, 'normal');
        return new $ec8a9e5ef0653b51$var$Result(true, condition);
    };
    var callFn = function callFn(value) {
        if (AS_ENTRIES) {
            $7d9b9f0a2a7e34a2$exports(value);
            return INTERRUPTED ? fn(value[0], value[1], stop) : fn(value[0], value[1]);
        }
        return INTERRUPTED ? fn(value, stop) : fn(value);
    };
    if (IS_RECORD) iterator = iterable.iterator;
    else if (IS_ITERATOR) iterator = iterable;
    else {
        iterFn = $72368fb318b24c5c$exports(iterable);
        if (!iterFn) throw new $ec8a9e5ef0653b51$var$$TypeError($287fd49afd1ee632$exports(iterable) + ' is not iterable');
        // optimisation for array iterators
        if ($6403e03a78aa5d48$exports(iterFn)) {
            for(index = 0, length = $dfe69c9cb1d4aa6b$exports(iterable); length > index; index++){
                result = callFn(iterable[index]);
                if (result && $5c91390ffea610b9$exports($ec8a9e5ef0653b51$var$ResultPrototype, result)) return result;
            }
            return new $ec8a9e5ef0653b51$var$Result(false);
        }
        iterator = $76e56b966649496d$exports(iterable, iterFn);
    }
    next = IS_RECORD ? iterable.next : iterator.next;
    while(!(step = $59bf80837927ca02$exports(next, iterator)).done){
        // `IteratorValue` errors should propagate without closing the iterator
        var value = step.value;
        try {
            result = callFn(value);
        } catch (error) {
            if (iterator) $e1b3d4ae7339c252$exports(iterator, 'throw', error);
            else throw error;
        }
        if ((typeof result === "undefined" ? "undefined" : (0, $6tOPT._)(result)) == 'object' && result && $5c91390ffea610b9$exports($ec8a9e5ef0653b51$var$ResultPrototype, result)) return result;
    }
    return new $ec8a9e5ef0653b51$var$Result(false);
};










$3f909713a27e049c$exports = function(CONSTRUCTOR_NAME, wrapper, common) {
    var IS_MAP = CONSTRUCTOR_NAME.indexOf('Map') !== -1;
    var IS_WEAK = CONSTRUCTOR_NAME.indexOf('Weak') !== -1;
    var ADDER = IS_MAP ? 'set' : 'add';
    var NativeConstructor = $27350b6a9e85aed1$exports[CONSTRUCTOR_NAME];
    var NativePrototype = NativeConstructor && NativeConstructor.prototype;
    var Constructor = NativeConstructor;
    var exported = {};
    var fixMethod = function fixMethod(KEY) {
        var uncurriedNativeMethod = $c224a7eda28c33b3$exports(NativePrototype[KEY]);
        $73c8864ae5df5c4d$exports(NativePrototype, KEY, KEY === 'add' ? function add(value) {
            uncurriedNativeMethod(this, value === 0 ? 0 : value);
            return this;
        } : KEY === 'delete' ? function(key) {
            return IS_WEAK && !$4d7f82f6c4645870$exports(key) ? false : uncurriedNativeMethod(this, key === 0 ? 0 : key);
        } : KEY === 'get' ? function get(key) {
            return IS_WEAK && !$4d7f82f6c4645870$exports(key) ? undefined : uncurriedNativeMethod(this, key === 0 ? 0 : key);
        } : KEY === 'has' ? function has(key) {
            return IS_WEAK && !$4d7f82f6c4645870$exports(key) ? false : uncurriedNativeMethod(this, key === 0 ? 0 : key);
        } : function set(key, value) {
            uncurriedNativeMethod(this, key === 0 ? 0 : key, value);
            return this;
        });
    };
    var REPLACE = $0ae261ce45c3c073$exports(CONSTRUCTOR_NAME, !$7c165f740ca92c53$exports(NativeConstructor) || !(IS_WEAK || NativePrototype.forEach && !$ddd8e9441ae136f2$exports(function() {
        new NativeConstructor().entries().next();
    })));
    if (REPLACE) {
        // create collection constructor
        Constructor = common.getConstructor(wrapper, CONSTRUCTOR_NAME, IS_MAP, ADDER);
        $d263db769eb8b264$exports.enable();
    } else if ($0ae261ce45c3c073$exports(CONSTRUCTOR_NAME, true)) {
        var instance = new Constructor();
        // early implementations not supports chaining
        var HASNT_CHAINING = instance[ADDER](IS_WEAK ? {} : -0, 1) !== instance;
        // V8 ~ Chromium 40- weak-collections throws on primitives, but should return false
        var THROWS_ON_PRIMITIVES = $ddd8e9441ae136f2$exports(function() {
            instance.has(1);
        });
        // most early implementations doesn't supports iterables, most modern - not close it correctly
        // eslint-disable-next-line no-new -- required for testing
        var ACCEPT_ITERABLES = $d1cf75d632965c8c$exports(function(iterable) {
            new NativeConstructor(iterable);
        });
        // for early implementations -0 and +0 not the same
        var BUGGY_ZERO = !IS_WEAK && $ddd8e9441ae136f2$exports(function() {
            // V8 ~ Chromium 42- fails only with 5+ elements
            var $instance = new NativeConstructor();
            var index = 5;
            while(index--)$instance[ADDER](index, index);
            return !$instance.has(-0);
        });
        if (!ACCEPT_ITERABLES) {
            Constructor = wrapper(function(dummy, iterable) {
                $93a46accb3e7c173$exports(dummy, NativePrototype);
                var that = $834423bfd6526b45$exports(new NativeConstructor(), dummy, Constructor);
                if (!$da08ff0243e53f27$exports(iterable)) $ec8a9e5ef0653b51$exports(iterable, that[ADDER], {
                    that: that,
                    AS_ENTRIES: IS_MAP
                });
                return that;
            });
            Constructor.prototype = NativePrototype;
            NativePrototype.constructor = Constructor;
        }
        if (THROWS_ON_PRIMITIVES || BUGGY_ZERO) {
            fixMethod('delete');
            fixMethod('has');
            IS_MAP && fixMethod('get');
        }
        if (BUGGY_ZERO || HASNT_CHAINING) fixMethod(ADDER);
        // weak collections should not contains .clear method
        if (IS_WEAK && NativePrototype.clear) delete NativePrototype.clear;
    }
    exported[CONSTRUCTOR_NAME] = Constructor;
    $244155c096ef4c14$exports({
        global: true,
        constructor: true,
        forced: Constructor !== NativeConstructor
    }, exported);
    $54a3ba2fb7b04ac0$exports(Constructor, CONSTRUCTOR_NAME);
    if (!IS_WEAK) common.setStrong(Constructor, CONSTRUCTOR_NAME, IS_MAP);
    return Constructor;
};


var $57adf11f0ab2f6f5$exports = {};
'use strict';












var $57adf11f0ab2f6f5$require$fastKey = $d263db769eb8b264$exports.fastKey;

var $57adf11f0ab2f6f5$var$setInternalState = $fcfe8b5396fbe91a$exports.set;
var $57adf11f0ab2f6f5$var$internalStateGetterFor = $fcfe8b5396fbe91a$exports.getterFor;
$57adf11f0ab2f6f5$exports = {
    getConstructor: function getConstructor(wrapper, CONSTRUCTOR_NAME, IS_MAP, ADDER) {
        var Constructor = wrapper(function(that, iterable) {
            $93a46accb3e7c173$exports(that, Prototype);
            $57adf11f0ab2f6f5$var$setInternalState(that, {
                type: CONSTRUCTOR_NAME,
                index: $491a5d5aa2efe6ec$exports(null),
                first: null,
                last: null,
                size: 0
            });
            if (!$b9f536d3284d7921$exports) that.size = 0;
            if (!$da08ff0243e53f27$exports(iterable)) $ec8a9e5ef0653b51$exports(iterable, that[ADDER], {
                that: that,
                AS_ENTRIES: IS_MAP
            });
        });
        var Prototype = Constructor.prototype;
        var getInternalState = $57adf11f0ab2f6f5$var$internalStateGetterFor(CONSTRUCTOR_NAME);
        var define = function define(that, key, value) {
            var state = getInternalState(that);
            var entry = getEntry(that, key);
            var previous, index;
            // change existing entry
            if (entry) entry.value = value;
            else {
                state.last = entry = {
                    index: index = $57adf11f0ab2f6f5$require$fastKey(key, true),
                    key: key,
                    value: value,
                    previous: previous = state.last,
                    next: null,
                    removed: false
                };
                if (!state.first) state.first = entry;
                if (previous) previous.next = entry;
                if ($b9f536d3284d7921$exports) state.size++;
                else that.size++;
                // add to index
                if (index !== 'F') state.index[index] = entry;
            }
            return that;
        };
        var getEntry = function getEntry(that, key) {
            var state = getInternalState(that);
            // fast case
            var index = $57adf11f0ab2f6f5$require$fastKey(key);
            var entry;
            if (index !== 'F') return state.index[index];
            // frozen object case
            for(entry = state.first; entry; entry = entry.next){
                if (entry.key === key) return entry;
            }
        };
        $260286081d4ac307$exports(Prototype, {
            // `{ Map, Set }.prototype.clear()` methods
            // https://tc39.es/ecma262/#sec-map.prototype.clear
            // https://tc39.es/ecma262/#sec-set.prototype.clear
            clear: function clear() {
                var that = this;
                var state = getInternalState(that);
                var entry = state.first;
                while(entry){
                    entry.removed = true;
                    if (entry.previous) entry.previous = entry.previous.next = null;
                    entry = entry.next;
                }
                state.first = state.last = null;
                state.index = $491a5d5aa2efe6ec$exports(null);
                if ($b9f536d3284d7921$exports) state.size = 0;
                else that.size = 0;
            },
            // `{ Map, Set }.prototype.delete(key)` methods
            // https://tc39.es/ecma262/#sec-map.prototype.delete
            // https://tc39.es/ecma262/#sec-set.prototype.delete
            'delete': function(key) {
                var that = this;
                var state = getInternalState(that);
                var entry = getEntry(that, key);
                if (entry) {
                    var next = entry.next;
                    var prev = entry.previous;
                    delete state.index[entry.index];
                    entry.removed = true;
                    if (prev) prev.next = next;
                    if (next) next.previous = prev;
                    if (state.first === entry) state.first = next;
                    if (state.last === entry) state.last = prev;
                    if ($b9f536d3284d7921$exports) state.size--;
                    else that.size--;
                }
                return !!entry;
            },
            // `{ Map, Set }.prototype.forEach(callbackfn, thisArg = undefined)` methods
            // https://tc39.es/ecma262/#sec-map.prototype.foreach
            // https://tc39.es/ecma262/#sec-set.prototype.foreach
            forEach: function forEach(callbackfn /* , that = undefined */ ) {
                var state = getInternalState(this);
                var boundFunction = $8a0b7edcb386df4b$exports(callbackfn, arguments.length > 1 ? arguments[1] : undefined);
                var entry;
                while(entry = entry ? entry.next : state.first){
                    boundFunction(entry.value, entry.key, this);
                    // revert to the last existing entry
                    while(entry && entry.removed)entry = entry.previous;
                }
            },
            // `{ Map, Set}.prototype.has(key)` methods
            // https://tc39.es/ecma262/#sec-map.prototype.has
            // https://tc39.es/ecma262/#sec-set.prototype.has
            has: function has(key) {
                return !!getEntry(this, key);
            }
        });
        $260286081d4ac307$exports(Prototype, IS_MAP ? {
            // `Map.prototype.get(key)` method
            // https://tc39.es/ecma262/#sec-map.prototype.get
            get: function get(key) {
                var entry = getEntry(this, key);
                return entry && entry.value;
            },
            // `Map.prototype.set(key, value)` method
            // https://tc39.es/ecma262/#sec-map.prototype.set
            set: function set(key, value) {
                return define(this, key === 0 ? 0 : key, value);
            }
        } : {
            // `Set.prototype.add(value)` method
            // https://tc39.es/ecma262/#sec-set.prototype.add
            add: function add(value) {
                return define(this, value = value === 0 ? 0 : value, value);
            }
        });
        if ($b9f536d3284d7921$exports) $71a985fce44d8187$exports(Prototype, 'size', {
            configurable: true,
            get: function get() {
                return getInternalState(this).size;
            }
        });
        return Constructor;
    },
    setStrong: function setStrong(Constructor, CONSTRUCTOR_NAME, IS_MAP) {
        var ITERATOR_NAME = CONSTRUCTOR_NAME + ' Iterator';
        var getInternalCollectionState = $57adf11f0ab2f6f5$var$internalStateGetterFor(CONSTRUCTOR_NAME);
        var getInternalIteratorState = $57adf11f0ab2f6f5$var$internalStateGetterFor(ITERATOR_NAME);
        // `{ Map, Set }.prototype.{ keys, values, entries, @@iterator }()` methods
        // https://tc39.es/ecma262/#sec-map.prototype.entries
        // https://tc39.es/ecma262/#sec-map.prototype.keys
        // https://tc39.es/ecma262/#sec-map.prototype.values
        // https://tc39.es/ecma262/#sec-map.prototype-@@iterator
        // https://tc39.es/ecma262/#sec-set.prototype.entries
        // https://tc39.es/ecma262/#sec-set.prototype.keys
        // https://tc39.es/ecma262/#sec-set.prototype.values
        // https://tc39.es/ecma262/#sec-set.prototype-@@iterator
        $f183cb308a74bc45$exports(Constructor, CONSTRUCTOR_NAME, function(iterated, kind) {
            $57adf11f0ab2f6f5$var$setInternalState(this, {
                type: ITERATOR_NAME,
                target: iterated,
                state: getInternalCollectionState(iterated),
                kind: kind,
                last: null
            });
        }, function() {
            var state = getInternalIteratorState(this);
            var kind = state.kind;
            var entry = state.last;
            // revert to the last existing entry
            while(entry && entry.removed)entry = entry.previous;
            // get next entry
            if (!state.target || !(state.last = entry = entry ? entry.next : state.state.first)) {
                // or finish the iteration
                state.target = null;
                return $71995534a6c57f64$exports(undefined, true);
            }
            // return step by kind
            if (kind === 'keys') return $71995534a6c57f64$exports(entry.key, false);
            if (kind === 'values') return $71995534a6c57f64$exports(entry.value, false);
            return $71995534a6c57f64$exports([
                entry.key,
                entry.value
            ], false);
        }, IS_MAP ? 'entries' : 'values', !IS_MAP, true);
        // `{ Map, Set }.prototype[@@species]` accessors
        // https://tc39.es/ecma262/#sec-get-map-@@species
        // https://tc39.es/ecma262/#sec-get-set-@@species
        $2eb70ff7aa9594a1$exports(CONSTRUCTOR_NAME);
    }
};


// `Map` constructor
// https://tc39.es/ecma262/#sec-map-objects
$3f909713a27e049c$exports('Map', function(init) {
    return function Map() {
        return init(this, arguments.length ? arguments[0] : undefined);
    };
}, $57adf11f0ab2f6f5$exports);




'use strict';

var $863bbb14f699fd5b$exports = {};
'use strict';
var $863bbb14f699fd5b$var$log = Math.log;
// `Math.log1p` method implementation
// https://tc39.es/ecma262/#sec-math.log1p
// eslint-disable-next-line es/no-math-log1p -- safe
$863bbb14f699fd5b$exports = Math.log1p || function log1p(x) {
    var n = +x;
    return n > -0.00000001 && n < 1e-8 ? n - n * n / 2 : $863bbb14f699fd5b$var$log(1 + n);
};


// eslint-disable-next-line es/no-math-acosh -- required for testing
var $3eea95e2e7e5d6fd$var$$acosh = Math.acosh;
var $3eea95e2e7e5d6fd$var$log = Math.log;
var $3eea95e2e7e5d6fd$var$sqrt = Math.sqrt;
var $3eea95e2e7e5d6fd$var$LN2 = Math.LN2;
var $3eea95e2e7e5d6fd$var$FORCED = !$3eea95e2e7e5d6fd$var$$acosh || Math.floor($3eea95e2e7e5d6fd$var$$acosh(Number.MAX_VALUE)) !== 710 || $3eea95e2e7e5d6fd$var$$acosh(Infinity) !== Infinity;
// `Math.acosh` method
// https://tc39.es/ecma262/#sec-math.acosh
$244155c096ef4c14$exports({
    target: 'Math',
    stat: true,
    forced: $3eea95e2e7e5d6fd$var$FORCED
}, {
    acosh: function acosh(x) {
        var n = +x;
        return n < 1 ? NaN : n > 94906265.62425156 ? $3eea95e2e7e5d6fd$var$log(n) + $3eea95e2e7e5d6fd$var$LN2 : $863bbb14f699fd5b$exports(n - 1 + $3eea95e2e7e5d6fd$var$sqrt(n - 1) * $3eea95e2e7e5d6fd$var$sqrt(n + 1));
    }
});


'use strict';

// eslint-disable-next-line es/no-math-asinh -- required for testing
var $ced9255f71da5a73$var$$asinh = Math.asinh;
var $ced9255f71da5a73$var$log = Math.log;
var $ced9255f71da5a73$var$sqrt = Math.sqrt;
var $ced9255f71da5a73$var$LN2 = Math.LN2;
// sqrt(2 ** 53) - prevent n * n overflow
var $ced9255f71da5a73$var$SQRT_2_POW_53 = 94906265.62425156;
function $ced9255f71da5a73$var$asinh(x) {
    var n = +x;
    return !isFinite(n) || n === 0 ? n : n < 0 ? -$ced9255f71da5a73$var$asinh(-n) : n > $ced9255f71da5a73$var$SQRT_2_POW_53 ? $ced9255f71da5a73$var$log(n) + $ced9255f71da5a73$var$LN2 : $ced9255f71da5a73$var$log(n + $ced9255f71da5a73$var$sqrt(n * n + 1));
}
var $ced9255f71da5a73$var$FORCED = !($ced9255f71da5a73$var$$asinh && 1 / $ced9255f71da5a73$var$$asinh(0) > 0);
// `Math.asinh` method
// https://tc39.es/ecma262/#sec-math.asinh
// Tor Browser bug: Math.asinh(0) -> -0
$244155c096ef4c14$exports({
    target: 'Math',
    stat: true,
    forced: $ced9255f71da5a73$var$FORCED
}, {
    asinh: $ced9255f71da5a73$var$asinh
});


'use strict';


// eslint-disable-next-line es/no-math-atanh -- required for testing
var $06515d804505c14c$var$$atanh = Math.atanh;
var $06515d804505c14c$var$FORCED = !($06515d804505c14c$var$$atanh && 1 / $06515d804505c14c$var$$atanh(-0) < 0);
// `Math.atanh` method
// https://tc39.es/ecma262/#sec-math.atanh
// Tor Browser bug: Math.atanh(-0) -> 0
$244155c096ef4c14$exports({
    target: 'Math',
    stat: true,
    forced: $06515d804505c14c$var$FORCED
}, {
    atanh: function atanh(x) {
        var n = +x;
        return n === 0 ? n : $863bbb14f699fd5b$exports(2 * n / (1 - n)) / 2;
    }
});


'use strict';


var $e7ebb1449afe6d00$var$abs = Math.abs;
var $e7ebb1449afe6d00$var$pow = Math.pow;
// `Math.cbrt` method
// https://tc39.es/ecma262/#sec-math.cbrt
$244155c096ef4c14$exports({
    target: 'Math',
    stat: true
}, {
    cbrt: function cbrt(x) {
        var n = +x;
        return $2b5bb9984048f8cd$exports(n) * $e7ebb1449afe6d00$var$pow($e7ebb1449afe6d00$var$abs(n), 1 / 3);
    }
});


'use strict';

var $7777cdb2dce9a306$var$floor = Math.floor;
var $7777cdb2dce9a306$var$log = Math.log;
var $7777cdb2dce9a306$var$LOG2E = Math.LOG2E;
// `Math.clz32` method
// https://tc39.es/ecma262/#sec-math.clz32
$244155c096ef4c14$exports({
    target: 'Math',
    stat: true
}, {
    clz32: function clz32(x) {
        var n = x >>> 0;
        return n ? 31 - $7777cdb2dce9a306$var$floor($7777cdb2dce9a306$var$log(n + 0.5) * $7777cdb2dce9a306$var$LOG2E) : 32;
    }
});


'use strict';

var $f94521778cfc2abb$exports = {};
'use strict';
// eslint-disable-next-line es/no-math-expm1 -- safe
var $f94521778cfc2abb$var$$expm1 = Math.expm1;
var $f94521778cfc2abb$var$exp = Math.exp;
// `Math.expm1` method implementation
// https://tc39.es/ecma262/#sec-math.expm1
$f94521778cfc2abb$exports = !$f94521778cfc2abb$var$$expm1 || $f94521778cfc2abb$var$$expm1(10) > 22025.465794806719 || $f94521778cfc2abb$var$$expm1(10) < 22025.4657948067165168 || $f94521778cfc2abb$var$$expm1(-0.00000000000000002) !== -0.00000000000000002 ? function expm1(x) {
    var n = +x;
    return n === 0 ? n : n > -0.000001 && n < 1e-6 ? n + n * n / 2 : $f94521778cfc2abb$var$exp(n) - 1;
} : $f94521778cfc2abb$var$$expm1;


// eslint-disable-next-line es/no-math-cosh -- required for testing
var $86fbefef09c94efe$var$$cosh = Math.cosh;
var $86fbefef09c94efe$var$abs = Math.abs;
var $86fbefef09c94efe$var$E = Math.E;
var $86fbefef09c94efe$var$FORCED = !$86fbefef09c94efe$var$$cosh || $86fbefef09c94efe$var$$cosh(710) === Infinity;
// `Math.cosh` method
// https://tc39.es/ecma262/#sec-math.cosh
$244155c096ef4c14$exports({
    target: 'Math',
    stat: true,
    forced: $86fbefef09c94efe$var$FORCED
}, {
    cosh: function cosh(x) {
        var t = $f94521778cfc2abb$exports($86fbefef09c94efe$var$abs(x) - 1) + 1;
        return (t + 1 / (t * $86fbefef09c94efe$var$E * $86fbefef09c94efe$var$E)) * ($86fbefef09c94efe$var$E / 2);
    }
});


'use strict';


// `Math.expm1` method
// https://tc39.es/ecma262/#sec-math.expm1
// eslint-disable-next-line es/no-math-expm1 -- required for testing
$244155c096ef4c14$exports({
    target: 'Math',
    stat: true,
    forced: $f94521778cfc2abb$exports !== Math.expm1
}, {
    expm1: $f94521778cfc2abb$exports
});


'use strict';


// `Math.fround` method
// https://tc39.es/ecma262/#sec-math.fround
$244155c096ef4c14$exports({
    target: 'Math',
    stat: true
}, {
    fround: $e912d92303683117$exports
});


'use strict';

// eslint-disable-next-line es/no-math-hypot -- required for testing
var $af72ac492859b202$var$$hypot = Math.hypot;
var $af72ac492859b202$var$abs = Math.abs;
var $af72ac492859b202$var$sqrt = Math.sqrt;
// Chrome 77 bug
// https://bugs.chromium.org/p/v8/issues/detail?id=9546
var $af72ac492859b202$var$FORCED = !!$af72ac492859b202$var$$hypot && $af72ac492859b202$var$$hypot(Infinity, NaN) !== Infinity;
// `Math.hypot` method
// https://tc39.es/ecma262/#sec-math.hypot
$244155c096ef4c14$exports({
    target: 'Math',
    stat: true,
    arity: 2,
    forced: $af72ac492859b202$var$FORCED
}, {
    // eslint-disable-next-line no-unused-vars -- required for `.length`
    hypot: function hypot(value1, value2) {
        var sum = 0;
        var i = 0;
        var aLen = arguments.length;
        var larg = 0;
        var arg, div;
        while(i < aLen){
            arg = $af72ac492859b202$var$abs(arguments[i++]);
            if (larg < arg) {
                div = larg / arg;
                sum = sum * div * div + 1;
                larg = arg;
            } else if (arg > 0) {
                div = arg / larg;
                sum += div * div;
            } else sum += arg;
        }
        return larg === Infinity ? Infinity : larg * $af72ac492859b202$var$sqrt(sum);
    }
});


'use strict';


// eslint-disable-next-line es/no-math-imul -- required for testing
var $8c245cf0abd89048$var$$imul = Math.imul;
var $8c245cf0abd89048$var$FORCED = $ddd8e9441ae136f2$exports(function() {
    return $8c245cf0abd89048$var$$imul(0xFFFFFFFF, 5) !== -5 || $8c245cf0abd89048$var$$imul.length !== 2;
});
// `Math.imul` method
// https://tc39.es/ecma262/#sec-math.imul
// some WebKit versions fails with big numbers, some has wrong arity
$244155c096ef4c14$exports({
    target: 'Math',
    stat: true,
    forced: $8c245cf0abd89048$var$FORCED
}, {
    imul: function imul(x, y) {
        var UINT16 = 0xFFFF;
        var xn = +x;
        var yn = +y;
        var xl = UINT16 & xn;
        var yl = UINT16 & yn;
        return 0 | xl * yl + ((UINT16 & xn >>> 16) * yl + xl * (UINT16 & yn >>> 16) << 16 >>> 0);
    }
});


'use strict';

var $4427c3968c2e5405$exports = {};
'use strict';
var $4427c3968c2e5405$var$log = Math.log;
var $4427c3968c2e5405$var$LOG10E = Math.LOG10E;
// eslint-disable-next-line es/no-math-log10 -- safe
$4427c3968c2e5405$exports = Math.log10 || function log10(x) {
    return $4427c3968c2e5405$var$log(x) * $4427c3968c2e5405$var$LOG10E;
};


// `Math.log10` method
// https://tc39.es/ecma262/#sec-math.log10
$244155c096ef4c14$exports({
    target: 'Math',
    stat: true
}, {
    log10: $4427c3968c2e5405$exports
});


'use strict';


// `Math.log1p` method
// https://tc39.es/ecma262/#sec-math.log1p
$244155c096ef4c14$exports({
    target: 'Math',
    stat: true
}, {
    log1p: $863bbb14f699fd5b$exports
});


'use strict';

var $2180e827e2d80cbb$exports = {};
'use strict';
var $2180e827e2d80cbb$var$log = Math.log;
var $2180e827e2d80cbb$var$LN2 = Math.LN2;
// `Math.log2` method
// https://tc39.es/ecma262/#sec-math.log2
// eslint-disable-next-line es/no-math-log2 -- safe
$2180e827e2d80cbb$exports = Math.log2 || function log2(x) {
    return $2180e827e2d80cbb$var$log(x) / $2180e827e2d80cbb$var$LN2;
};


// `Math.log2` method
// https://tc39.es/ecma262/#sec-math.log2
$244155c096ef4c14$exports({
    target: 'Math',
    stat: true
}, {
    log2: $2180e827e2d80cbb$exports
});


'use strict';


// `Math.sign` method
// https://tc39.es/ecma262/#sec-math.sign
$244155c096ef4c14$exports({
    target: 'Math',
    stat: true
}, {
    sign: $2b5bb9984048f8cd$exports
});


'use strict';



var $a88e6b320666a3e0$var$abs = Math.abs;
var $a88e6b320666a3e0$var$exp = Math.exp;
var $a88e6b320666a3e0$var$E = Math.E;
var $a88e6b320666a3e0$var$FORCED = $ddd8e9441ae136f2$exports(function() {
    // eslint-disable-next-line es/no-math-sinh -- required for testing
    return Math.sinh(-0.00000000000000002) !== -0.00000000000000002;
});
// `Math.sinh` method
// https://tc39.es/ecma262/#sec-math.sinh
// V8 near Chromium 38 has a problem with very small numbers
$244155c096ef4c14$exports({
    target: 'Math',
    stat: true,
    forced: $a88e6b320666a3e0$var$FORCED
}, {
    sinh: function sinh(x) {
        var n = +x;
        return $a88e6b320666a3e0$var$abs(n) < 1 ? ($f94521778cfc2abb$exports(n) - $f94521778cfc2abb$exports(-n)) / 2 : ($a88e6b320666a3e0$var$exp(n - 1) - $a88e6b320666a3e0$var$exp(-n - 1)) * ($a88e6b320666a3e0$var$E / 2);
    }
});


'use strict';


var $fbc0b7e417357f5f$var$exp = Math.exp;
// `Math.tanh` method
// https://tc39.es/ecma262/#sec-math.tanh
$244155c096ef4c14$exports({
    target: 'Math',
    stat: true
}, {
    tanh: function tanh(x) {
        var n = +x;
        var a = $f94521778cfc2abb$exports(n);
        var b = $f94521778cfc2abb$exports(-n);
        return a === Infinity ? 1 : b === Infinity ? -1 : (a - b) / ($fbc0b7e417357f5f$var$exp(n) + $fbc0b7e417357f5f$var$exp(-n));
    }
});


'use strict';

// Math[@@toStringTag] property
// https://tc39.es/ecma262/#sec-math-@@tostringtag
$54a3ba2fb7b04ac0$exports(Math, 'Math', true);


'use strict';


// `Math.trunc` method
// https://tc39.es/ecma262/#sec-math.trunc
$244155c096ef4c14$exports({
    target: 'Math',
    stat: true
}, {
    trunc: $87cc8b195947efa6$exports
});



var $6tOPT = parcelRequire("6tOPT");
'use strict';














var $748dffb0cbadf17d$require$getOwnPropertyNames = $8b92903d5cdf859e$export$2d1720544b23b823;

var $748dffb0cbadf17d$require$getOwnPropertyDescriptor = $70871da05e9d21bf$export$2d1720544b23b823;

var $748dffb0cbadf17d$require$defineProperty = $6f9fc35f567fa5b6$export$2d1720544b23b823;
var $bc26196547d84cd2$exports = {};
'use strict';

// `thisNumberValue` abstract operation
// https://tc39.es/ecma262/#sec-thisnumbervalue
$bc26196547d84cd2$exports = $c224a7eda28c33b3$exports(1.1.valueOf);


var $6f212a89e981fb90$exports = {};
'use strict';



var $1976bf5e6cb48c41$exports = {};
'use strict';
// a string of all valid unicode whitespaces
$1976bf5e6cb48c41$exports = "	\n\v\f\r \xa0\u1680\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF";


var $6f212a89e981fb90$var$replace = $c224a7eda28c33b3$exports(''.replace);
var $6f212a89e981fb90$var$ltrim = RegExp('^[' + $1976bf5e6cb48c41$exports + ']+');
var $6f212a89e981fb90$var$rtrim = RegExp('(^|[^' + $1976bf5e6cb48c41$exports + '])[' + $1976bf5e6cb48c41$exports + ']+$');
// `String.prototype.{ trim, trimStart, trimEnd, trimLeft, trimRight }` methods implementation
var $6f212a89e981fb90$var$createMethod = function createMethod(TYPE) {
    return function($this) {
        var string = $7c610b7ee22557b5$exports($0f70b7357550422e$exports($this));
        if (TYPE & 1) string = $6f212a89e981fb90$var$replace(string, $6f212a89e981fb90$var$ltrim, '');
        if (TYPE & 2) string = $6f212a89e981fb90$var$replace(string, $6f212a89e981fb90$var$rtrim, '$1');
        return string;
    };
};
$6f212a89e981fb90$exports = {
    // `String.prototype.{ trimLeft, trimStart }` methods
    // https://tc39.es/ecma262/#sec-string.prototype.trimstart
    start: $6f212a89e981fb90$var$createMethod(1),
    // `String.prototype.{ trimRight, trimEnd }` methods
    // https://tc39.es/ecma262/#sec-string.prototype.trimend
    end: $6f212a89e981fb90$var$createMethod(2),
    // `String.prototype.trim` method
    // https://tc39.es/ecma262/#sec-string.prototype.trim
    trim: $6f212a89e981fb90$var$createMethod(3)
};


var $748dffb0cbadf17d$require$trim = $6f212a89e981fb90$exports.trim;
var $748dffb0cbadf17d$var$NUMBER = 'Number';
var $748dffb0cbadf17d$var$NativeNumber = $27350b6a9e85aed1$exports[$748dffb0cbadf17d$var$NUMBER];
var $748dffb0cbadf17d$var$PureNumberNamespace = $d2336b2aa2640a45$exports[$748dffb0cbadf17d$var$NUMBER];
var $748dffb0cbadf17d$var$NumberPrototype = $748dffb0cbadf17d$var$NativeNumber.prototype;
var $748dffb0cbadf17d$var$TypeError = $27350b6a9e85aed1$exports.TypeError;
var $748dffb0cbadf17d$var$stringSlice = $c224a7eda28c33b3$exports(''.slice);
var $748dffb0cbadf17d$var$charCodeAt = $c224a7eda28c33b3$exports(''.charCodeAt);
// `ToNumeric` abstract operation
// https://tc39.es/ecma262/#sec-tonumeric
var $748dffb0cbadf17d$var$toNumeric = function toNumeric(value) {
    var primValue = $5502f9db3352ad96$exports(value, 'number');
    return (typeof primValue === "undefined" ? "undefined" : (0, $6tOPT._)(primValue)) == 'bigint' ? primValue : $748dffb0cbadf17d$var$toNumber(primValue);
};
// `ToNumber` abstract operation
// https://tc39.es/ecma262/#sec-tonumber
var $748dffb0cbadf17d$var$toNumber = function toNumber(argument) {
    var it = $5502f9db3352ad96$exports(argument, 'number');
    var first, third, radix, maxCode, digits, length, index, code;
    if ($3b5b0fa19aea9b5a$exports(it)) throw new $748dffb0cbadf17d$var$TypeError('Cannot convert a Symbol value to a number');
    if (typeof it == 'string' && it.length > 2) {
        it = $748dffb0cbadf17d$require$trim(it);
        first = $748dffb0cbadf17d$var$charCodeAt(it, 0);
        if (first === 43 || first === 45) {
            third = $748dffb0cbadf17d$var$charCodeAt(it, 2);
            if (third === 88 || third === 120) return NaN; // Number('+0x1') should be NaN, old V8 fix
        } else if (first === 48) {
            switch($748dffb0cbadf17d$var$charCodeAt(it, 1)){
                // fast equal of /^0b[01]+$/i
                case 66:
                case 98:
                    radix = 2;
                    maxCode = 49;
                    break;
                // fast equal of /^0o[0-7]+$/i
                case 79:
                case 111:
                    radix = 8;
                    maxCode = 55;
                    break;
                default:
                    return +it;
            }
            digits = $748dffb0cbadf17d$var$stringSlice(it, 2);
            length = digits.length;
            for(index = 0; index < length; index++){
                code = $748dffb0cbadf17d$var$charCodeAt(digits, index);
                // parseInt parses a string to a first unavailable symbol
                // but ToNumber should return NaN if a string contains unavailable symbols
                if (code < 48 || code > maxCode) return NaN;
            }
            return parseInt(digits, radix);
        }
    }
    return +it;
};
var $748dffb0cbadf17d$var$FORCED = $0ae261ce45c3c073$exports($748dffb0cbadf17d$var$NUMBER, !$748dffb0cbadf17d$var$NativeNumber(' 0o1') || !$748dffb0cbadf17d$var$NativeNumber('0b1') || $748dffb0cbadf17d$var$NativeNumber('+0x1'));
var $748dffb0cbadf17d$var$calledWithNew = function calledWithNew(dummy) {
    // includes check on 1..constructor(foo) case
    return $5c91390ffea610b9$exports($748dffb0cbadf17d$var$NumberPrototype, dummy) && $ddd8e9441ae136f2$exports(function() {
        $bc26196547d84cd2$exports(dummy);
    });
};
// `Number` constructor
// https://tc39.es/ecma262/#sec-number-constructor
var $748dffb0cbadf17d$var$NumberWrapper = function Number(value) {
    var n = arguments.length < 1 ? 0 : $748dffb0cbadf17d$var$NativeNumber($748dffb0cbadf17d$var$toNumeric(value));
    return $748dffb0cbadf17d$var$calledWithNew(this) ? $834423bfd6526b45$exports(Object(n), this, $748dffb0cbadf17d$var$NumberWrapper) : n;
};
$748dffb0cbadf17d$var$NumberWrapper.prototype = $748dffb0cbadf17d$var$NumberPrototype;
if ($748dffb0cbadf17d$var$FORCED && !$a4b83f418a8da28e$exports) $748dffb0cbadf17d$var$NumberPrototype.constructor = $748dffb0cbadf17d$var$NumberWrapper;
$244155c096ef4c14$exports({
    global: true,
    constructor: true,
    wrap: true,
    forced: $748dffb0cbadf17d$var$FORCED
}, {
    Number: $748dffb0cbadf17d$var$NumberWrapper
});
// Use `internal/copy-constructor-properties` helper in `core-js@4`
var $748dffb0cbadf17d$var$copyConstructorProperties = function copyConstructorProperties(target, source) {
    for(var keys = $b9f536d3284d7921$exports ? $748dffb0cbadf17d$require$getOwnPropertyNames(source) : // ES3:
    "MAX_VALUE,MIN_VALUE,NaN,NEGATIVE_INFINITY,POSITIVE_INFINITY,EPSILON,MAX_SAFE_INTEGER,MIN_SAFE_INTEGER,isFinite,isInteger,isNaN,isSafeInteger,parseFloat,parseInt,fromString,range".split(','), j = 0, key; keys.length > j; j++)if ($8bbc2bccc0a29296$exports(source, key = keys[j]) && !$8bbc2bccc0a29296$exports(target, key)) $748dffb0cbadf17d$require$defineProperty(target, key, $748dffb0cbadf17d$require$getOwnPropertyDescriptor(source, key));
};
if ($a4b83f418a8da28e$exports && $748dffb0cbadf17d$var$PureNumberNamespace) $748dffb0cbadf17d$var$copyConstructorProperties($d2336b2aa2640a45$exports[$748dffb0cbadf17d$var$NUMBER], $748dffb0cbadf17d$var$PureNumberNamespace);
if ($748dffb0cbadf17d$var$FORCED || $a4b83f418a8da28e$exports) $748dffb0cbadf17d$var$copyConstructorProperties($d2336b2aa2640a45$exports[$748dffb0cbadf17d$var$NUMBER], $748dffb0cbadf17d$var$NativeNumber);


'use strict';

// `Number.EPSILON` constant
// https://tc39.es/ecma262/#sec-number.epsilon
$244155c096ef4c14$exports({
    target: 'Number',
    stat: true,
    nonConfigurable: true,
    nonWritable: true
}, {
    EPSILON: Math.pow(2, -52)
});


'use strict';

var $410b326fa56a974d$exports = {};
'use strict';

var $410b326fa56a974d$var$globalIsFinite = $27350b6a9e85aed1$exports.isFinite;
// `Number.isFinite` method
// https://tc39.es/ecma262/#sec-number.isfinite
// eslint-disable-next-line es/no-number-isfinite -- safe
$410b326fa56a974d$exports = Number.isFinite || function isFinite(it) {
    return typeof it == 'number' && $410b326fa56a974d$var$globalIsFinite(it);
};


// `Number.isFinite` method
// https://tc39.es/ecma262/#sec-number.isfinite
$244155c096ef4c14$exports({
    target: 'Number',
    stat: true
}, {
    isFinite: $410b326fa56a974d$exports
});


'use strict';

var $344929e29a2a0e48$exports = {};
'use strict';

var $344929e29a2a0e48$var$floor = Math.floor;
// `IsIntegralNumber` abstract operation
// https://tc39.es/ecma262/#sec-isintegralnumber
// eslint-disable-next-line es/no-number-isinteger -- safe
$344929e29a2a0e48$exports = Number.isInteger || function isInteger(it) {
    return !$4d7f82f6c4645870$exports(it) && isFinite(it) && $344929e29a2a0e48$var$floor(it) === it;
};


// `Number.isInteger` method
// https://tc39.es/ecma262/#sec-number.isinteger
$244155c096ef4c14$exports({
    target: 'Number',
    stat: true
}, {
    isInteger: $344929e29a2a0e48$exports
});


'use strict';

// `Number.isNaN` method
// https://tc39.es/ecma262/#sec-number.isnan
$244155c096ef4c14$exports({
    target: 'Number',
    stat: true
}, {
    isNaN: function isNaN(number) {
        // eslint-disable-next-line no-self-compare -- NaN check
        return number !== number;
    }
});


'use strict';


var $80ee83e356cf0e0f$var$abs = Math.abs;
// `Number.isSafeInteger` method
// https://tc39.es/ecma262/#sec-number.issafeinteger
$244155c096ef4c14$exports({
    target: 'Number',
    stat: true
}, {
    isSafeInteger: function isSafeInteger(number) {
        return $344929e29a2a0e48$exports(number) && $80ee83e356cf0e0f$var$abs(number) <= 0x1FFFFFFFFFFFFF;
    }
});


'use strict';

// `Number.MAX_SAFE_INTEGER` constant
// https://tc39.es/ecma262/#sec-number.max_safe_integer
$244155c096ef4c14$exports({
    target: 'Number',
    stat: true,
    nonConfigurable: true,
    nonWritable: true
}, {
    MAX_SAFE_INTEGER: 0x1FFFFFFFFFFFFF
});


'use strict';

// `Number.MIN_SAFE_INTEGER` constant
// https://tc39.es/ecma262/#sec-number.min_safe_integer
$244155c096ef4c14$exports({
    target: 'Number',
    stat: true,
    nonConfigurable: true,
    nonWritable: true
}, {
    MIN_SAFE_INTEGER: -9007199254740991
});


'use strict';

var $e9e7d655b9c08e37$exports = {};
'use strict';





var $e9e7d655b9c08e37$require$trim = $6f212a89e981fb90$exports.trim;

var $e9e7d655b9c08e37$var$charAt = $c224a7eda28c33b3$exports(''.charAt);
var $e9e7d655b9c08e37$var$$parseFloat = $27350b6a9e85aed1$exports.parseFloat;
var $e9e7d655b9c08e37$var$Symbol = $27350b6a9e85aed1$exports.Symbol;
var $e9e7d655b9c08e37$var$ITERATOR = $e9e7d655b9c08e37$var$Symbol && $e9e7d655b9c08e37$var$Symbol.iterator;
var $e9e7d655b9c08e37$var$FORCED = 1 / $e9e7d655b9c08e37$var$$parseFloat($1976bf5e6cb48c41$exports + '-0') !== -Infinity || $e9e7d655b9c08e37$var$ITERATOR && !$ddd8e9441ae136f2$exports(function() {
    $e9e7d655b9c08e37$var$$parseFloat(Object($e9e7d655b9c08e37$var$ITERATOR));
});
// `parseFloat` method
// https://tc39.es/ecma262/#sec-parsefloat-string
$e9e7d655b9c08e37$exports = $e9e7d655b9c08e37$var$FORCED ? function parseFloat(string) {
    var trimmedString = $e9e7d655b9c08e37$require$trim($7c610b7ee22557b5$exports(string));
    var result = $e9e7d655b9c08e37$var$$parseFloat(trimmedString);
    return result === 0 && $e9e7d655b9c08e37$var$charAt(trimmedString, 0) === '-' ? -0 : result;
} : $e9e7d655b9c08e37$var$$parseFloat;


// `Number.parseFloat` method
// https://tc39.es/ecma262/#sec-number.parseFloat
// eslint-disable-next-line es/no-number-parsefloat -- required for testing
$244155c096ef4c14$exports({
    target: 'Number',
    stat: true,
    forced: Number.parseFloat !== $e9e7d655b9c08e37$exports
}, {
    parseFloat: $e9e7d655b9c08e37$exports
});


'use strict';

var $364a4cb263f5cc99$exports = {};
'use strict';





var $364a4cb263f5cc99$require$trim = $6f212a89e981fb90$exports.trim;

var $364a4cb263f5cc99$var$$parseInt = $27350b6a9e85aed1$exports.parseInt;
var $364a4cb263f5cc99$var$Symbol = $27350b6a9e85aed1$exports.Symbol;
var $364a4cb263f5cc99$var$ITERATOR = $364a4cb263f5cc99$var$Symbol && $364a4cb263f5cc99$var$Symbol.iterator;
var $364a4cb263f5cc99$var$hex = /^[+-]?0x/i;
var $364a4cb263f5cc99$var$exec = $c224a7eda28c33b3$exports($364a4cb263f5cc99$var$hex.exec);
var $364a4cb263f5cc99$var$FORCED = $364a4cb263f5cc99$var$$parseInt($1976bf5e6cb48c41$exports + '08') !== 8 || $364a4cb263f5cc99$var$$parseInt($1976bf5e6cb48c41$exports + '0x16') !== 22 || $364a4cb263f5cc99$var$ITERATOR && !$ddd8e9441ae136f2$exports(function() {
    $364a4cb263f5cc99$var$$parseInt(Object($364a4cb263f5cc99$var$ITERATOR));
});
// `parseInt` method
// https://tc39.es/ecma262/#sec-parseint-string-radix
$364a4cb263f5cc99$exports = $364a4cb263f5cc99$var$FORCED ? function parseInt(string, radix) {
    var S = $364a4cb263f5cc99$require$trim($7c610b7ee22557b5$exports(string));
    return $364a4cb263f5cc99$var$$parseInt(S, radix >>> 0 || ($364a4cb263f5cc99$var$exec($364a4cb263f5cc99$var$hex, S) ? 16 : 10));
} : $364a4cb263f5cc99$var$$parseInt;


// `Number.parseInt` method
// https://tc39.es/ecma262/#sec-number.parseint
// eslint-disable-next-line es/no-number-parseint -- required for testing
$244155c096ef4c14$exports({
    target: 'Number',
    stat: true,
    forced: Number.parseInt !== $364a4cb263f5cc99$exports
}, {
    parseInt: $364a4cb263f5cc99$exports
});


'use strict';




var $c8485ab0b4677db4$exports = {};
'use strict';



var $c8485ab0b4677db4$var$$RangeError = RangeError;
var $c8485ab0b4677db4$var$floor = Math.floor;
// `String.prototype.repeat` method implementation
// https://tc39.es/ecma262/#sec-string.prototype.repeat
$c8485ab0b4677db4$exports = function repeat(count) {
    var str = $7c610b7ee22557b5$exports($0f70b7357550422e$exports(this));
    var result = '';
    var n = $a8fecfd456e884de$exports(count);
    if (n < 0 || n === Infinity) throw new $c8485ab0b4677db4$var$$RangeError('Wrong number of repetitions');
    for(; n > 0; (n = $c8485ab0b4677db4$var$floor(n / 2)) && (str += str))if (n % 2) result += str;
    return result;
};



var $19d170cd2e5e99c9$var$$RangeError = RangeError;
var $19d170cd2e5e99c9$var$$String = String;
var $19d170cd2e5e99c9$var$floor = Math.floor;
var $19d170cd2e5e99c9$var$repeat = $c224a7eda28c33b3$exports($c8485ab0b4677db4$exports);
var $19d170cd2e5e99c9$var$stringSlice = $c224a7eda28c33b3$exports(''.slice);
var $19d170cd2e5e99c9$var$nativeToFixed = $c224a7eda28c33b3$exports(1.1.toFixed);
var $19d170cd2e5e99c9$var$pow = function pow1(x, n, acc) {
    return n === 0 ? acc : n % 2 === 1 ? $19d170cd2e5e99c9$var$pow(x, n - 1, acc * x) : $19d170cd2e5e99c9$var$pow(x * x, n / 2, acc);
};
var $19d170cd2e5e99c9$var$log = function log(x) {
    var n = 0;
    var x2 = x;
    while(x2 >= 4096){
        n += 12;
        x2 /= 4096;
    }
    while(x2 >= 2){
        n += 1;
        x2 /= 2;
    }
    return n;
};
var $19d170cd2e5e99c9$var$multiply = function multiply(data, n, c) {
    var index = -1;
    var c2 = c;
    while(++index < 6){
        c2 += n * data[index];
        data[index] = c2 % 1e7;
        c2 = $19d170cd2e5e99c9$var$floor(c2 / 1e7);
    }
};
var $19d170cd2e5e99c9$var$divide = function divide(data, n) {
    var index = 6;
    var c = 0;
    while(--index >= 0){
        c += data[index];
        data[index] = $19d170cd2e5e99c9$var$floor(c / n);
        c = c % n * 1e7;
    }
};
var $19d170cd2e5e99c9$var$dataToString = function dataToString(data) {
    var index = 6;
    var s = '';
    while(--index >= 0)if (s !== '' || index === 0 || data[index] !== 0) {
        var t = $19d170cd2e5e99c9$var$$String(data[index]);
        s = s === '' ? t : s + $19d170cd2e5e99c9$var$repeat('0', 7 - t.length) + t;
    }
    return s;
};
var $19d170cd2e5e99c9$var$FORCED = $ddd8e9441ae136f2$exports(function() {
    return $19d170cd2e5e99c9$var$nativeToFixed(0.00008, 3) !== '0.000' || $19d170cd2e5e99c9$var$nativeToFixed(0.9, 0) !== '1' || $19d170cd2e5e99c9$var$nativeToFixed(1.255, 2) !== '1.25' || $19d170cd2e5e99c9$var$nativeToFixed(1000000000000000128.0, 0) !== '1000000000000000128';
}) || !$ddd8e9441ae136f2$exports(function() {
    // V8 ~ Android 4.3-
    $19d170cd2e5e99c9$var$nativeToFixed({});
});
// `Number.prototype.toFixed` method
// https://tc39.es/ecma262/#sec-number.prototype.tofixed
$244155c096ef4c14$exports({
    target: 'Number',
    proto: true,
    forced: $19d170cd2e5e99c9$var$FORCED
}, {
    toFixed: function toFixed(fractionDigits) {
        var number = $bc26196547d84cd2$exports(this);
        var fractDigits = $a8fecfd456e884de$exports(fractionDigits);
        var data = [
            0,
            0,
            0,
            0,
            0,
            0
        ];
        var sign = '';
        var result = '0';
        var e, z, j, k;
        // TODO: ES2018 increased the maximum number of fraction digits to 100, need to improve the implementation
        if (fractDigits < 0 || fractDigits > 20) throw new $19d170cd2e5e99c9$var$$RangeError('Incorrect fraction digits');
        // eslint-disable-next-line no-self-compare -- NaN check
        if (number !== number) return 'NaN';
        if (number <= -1000000000000000000000 || number >= 1e21) return $19d170cd2e5e99c9$var$$String(number);
        if (number < 0) {
            sign = '-';
            number = -number;
        }
        if (number > 1e-21) {
            e = $19d170cd2e5e99c9$var$log(number * $19d170cd2e5e99c9$var$pow(2, 69, 1)) - 69;
            z = e < 0 ? number * $19d170cd2e5e99c9$var$pow(2, -e, 1) : number / $19d170cd2e5e99c9$var$pow(2, e, 1);
            z *= 0x10000000000000;
            e = 52 - e;
            if (e > 0) {
                $19d170cd2e5e99c9$var$multiply(data, 0, z);
                j = fractDigits;
                while(j >= 7){
                    $19d170cd2e5e99c9$var$multiply(data, 1e7, 0);
                    j -= 7;
                }
                $19d170cd2e5e99c9$var$multiply(data, $19d170cd2e5e99c9$var$pow(10, j, 1), 0);
                j = e - 1;
                while(j >= 23){
                    $19d170cd2e5e99c9$var$divide(data, 8388608);
                    j -= 23;
                }
                $19d170cd2e5e99c9$var$divide(data, 1 << j);
                $19d170cd2e5e99c9$var$multiply(data, 1, 1);
                $19d170cd2e5e99c9$var$divide(data, 2);
                result = $19d170cd2e5e99c9$var$dataToString(data);
            } else {
                $19d170cd2e5e99c9$var$multiply(data, 0, z);
                $19d170cd2e5e99c9$var$multiply(data, 1 << -e, 0);
                result = $19d170cd2e5e99c9$var$dataToString(data) + $19d170cd2e5e99c9$var$repeat('0', fractDigits);
            }
        }
        if (fractDigits > 0) {
            k = result.length;
            result = sign + (k <= fractDigits ? '0.' + $19d170cd2e5e99c9$var$repeat('0', fractDigits - k) + result : $19d170cd2e5e99c9$var$stringSlice(result, 0, k - fractDigits) + '.' + $19d170cd2e5e99c9$var$stringSlice(result, k - fractDigits));
        } else result = sign + result;
        return result;
    }
});


'use strict';

var $c4a7f9a76fc3d051$exports = {};
'use strict';









// eslint-disable-next-line es/no-object-assign -- safe
var $c4a7f9a76fc3d051$var$$assign = Object.assign;
// eslint-disable-next-line es/no-object-defineproperty -- required for testing
var $c4a7f9a76fc3d051$var$defineProperty = Object.defineProperty;
var $c4a7f9a76fc3d051$var$concat = $c224a7eda28c33b3$exports([].concat);
// `Object.assign` method
// https://tc39.es/ecma262/#sec-object.assign
$c4a7f9a76fc3d051$exports = !$c4a7f9a76fc3d051$var$$assign || $ddd8e9441ae136f2$exports(function() {
    // should have correct order of operations (Edge bug)
    if ($b9f536d3284d7921$exports && $c4a7f9a76fc3d051$var$$assign({
        b: 1
    }, $c4a7f9a76fc3d051$var$$assign($c4a7f9a76fc3d051$var$defineProperty({}, 'a', {
        enumerable: true,
        get: function get() {
            $c4a7f9a76fc3d051$var$defineProperty(this, 'b', {
                value: 3,
                enumerable: false
            });
        }
    }), {
        b: 2
    })).b !== 1) return true;
    // should work with symbols and should have deterministic property order (V8 bug)
    var A = {};
    var B = {};
    // eslint-disable-next-line es/no-symbol -- safe
    var symbol = Symbol('assign detection');
    var alphabet = 'abcdefghijklmnopqrst';
    A[symbol] = 7;
    // eslint-disable-next-line es/no-array-prototype-foreach -- safe
    alphabet.split('').forEach(function(chr) {
        B[chr] = chr;
    });
    return $c4a7f9a76fc3d051$var$$assign({}, A)[symbol] !== 7 || $ed3a442fad5fbe57$exports($c4a7f9a76fc3d051$var$$assign({}, B)).join('') !== alphabet;
}) ? function assign(target, source) {
    var T = $ad1d9797f1e27af5$exports(target);
    var argumentsLength = arguments.length;
    var index = 1;
    var getOwnPropertySymbols = $f459638151f85e39$export$2d1720544b23b823;
    var propertyIsEnumerable = $246f5b02cd4c126c$export$2d1720544b23b823;
    while(argumentsLength > index){
        var S = $7a4c0b5af5b2bbd3$exports(arguments[index++]);
        var keys = getOwnPropertySymbols ? $c4a7f9a76fc3d051$var$concat($ed3a442fad5fbe57$exports(S), getOwnPropertySymbols(S)) : $ed3a442fad5fbe57$exports(S);
        var length = keys.length;
        var j = 0;
        var key;
        while(length > j){
            key = keys[j++];
            if (!$b9f536d3284d7921$exports || $59bf80837927ca02$exports(propertyIsEnumerable, S, key)) T[key] = S[key];
        }
    }
    return T;
} : $c4a7f9a76fc3d051$var$$assign;


// `Object.assign` method
// https://tc39.es/ecma262/#sec-object.assign
// eslint-disable-next-line es/no-object-assign -- required for testing
$244155c096ef4c14$exports({
    target: 'Object',
    stat: true,
    arity: 2,
    forced: Object.assign !== $c4a7f9a76fc3d051$exports
}, {
    assign: $c4a7f9a76fc3d051$exports
});


'use strict';


var $f5a75fa531277ab6$exports = {};
'use strict';




// Forced replacement object prototype accessors methods
$f5a75fa531277ab6$exports = $a4b83f418a8da28e$exports || !$ddd8e9441ae136f2$exports(function() {
    // This feature detection crashes old WebKit
    // https://github.com/zloirock/core-js/issues/232
    if ($a8d4456c1aa6edf5$exports && $a8d4456c1aa6edf5$exports < 535) return;
    var key = Math.random();
    // In FF throws only define methods
    __defineSetter__.call(null, key, function() {});
    delete $27350b6a9e85aed1$exports[key];
});





// `Object.prototype.__defineGetter__` method
// https://tc39.es/ecma262/#sec-object.prototype.__defineGetter__
if ($b9f536d3284d7921$exports) $244155c096ef4c14$exports({
    target: 'Object',
    proto: true,
    forced: $f5a75fa531277ab6$exports
}, {
    __defineGetter__: function __defineGetter__(P, getter) {
        $6f9fc35f567fa5b6$export$2d1720544b23b823($ad1d9797f1e27af5$exports(this), P, {
            get: $082fcaa0a091ee30$exports(getter),
            enumerable: true,
            configurable: true
        });
    }
});


'use strict';






// `Object.prototype.__defineSetter__` method
// https://tc39.es/ecma262/#sec-object.prototype.__defineSetter__
if ($b9f536d3284d7921$exports) $244155c096ef4c14$exports({
    target: 'Object',
    proto: true,
    forced: $f5a75fa531277ab6$exports
}, {
    __defineSetter__: function __defineSetter__(P, setter) {
        $6f9fc35f567fa5b6$export$2d1720544b23b823($ad1d9797f1e27af5$exports(this), P, {
            set: $082fcaa0a091ee30$exports(setter),
            enumerable: true,
            configurable: true
        });
    }
});


'use strict';

var $309da03ee3e3b3f3$exports = {};
'use strict';







var $309da03ee3e3b3f3$require$$propertyIsEnumerable = $246f5b02cd4c126c$export$2d1720544b23b823;
var $309da03ee3e3b3f3$var$propertyIsEnumerable = $c224a7eda28c33b3$exports($309da03ee3e3b3f3$require$$propertyIsEnumerable);
var $309da03ee3e3b3f3$var$push = $c224a7eda28c33b3$exports([].push);
// in some IE versions, `propertyIsEnumerable` returns incorrect result on integer keys
// of `null` prototype objects
var $309da03ee3e3b3f3$var$IE_BUG = $b9f536d3284d7921$exports && $ddd8e9441ae136f2$exports(function() {
    // eslint-disable-next-line es/no-object-create -- safe
    var O = Object.create(null);
    O[2] = 2;
    return !$309da03ee3e3b3f3$var$propertyIsEnumerable(O, 2);
});
// `Object.{ entries, values }` methods implementation
var $309da03ee3e3b3f3$var$createMethod = function createMethod(TO_ENTRIES) {
    return function(it) {
        var O = $59a8f2f00edbf5a1$exports(it);
        var keys = $ed3a442fad5fbe57$exports(O);
        var IE_WORKAROUND = $309da03ee3e3b3f3$var$IE_BUG && $5f455f1b83f2c610$exports(O) === null;
        var length = keys.length;
        var i = 0;
        var result = [];
        var key;
        while(length > i){
            key = keys[i++];
            if (!$b9f536d3284d7921$exports || (IE_WORKAROUND ? key in O : $309da03ee3e3b3f3$var$propertyIsEnumerable(O, key))) $309da03ee3e3b3f3$var$push(result, TO_ENTRIES ? [
                key,
                O[key]
            ] : O[key]);
        }
        return result;
    };
};
$309da03ee3e3b3f3$exports = {
    // `Object.entries` method
    // https://tc39.es/ecma262/#sec-object.entries
    entries: $309da03ee3e3b3f3$var$createMethod(true),
    // `Object.values` method
    // https://tc39.es/ecma262/#sec-object.values
    values: $309da03ee3e3b3f3$var$createMethod(false)
};


var $a57ff4bf21a62375$require$$entries = $309da03ee3e3b3f3$exports.entries;
// `Object.entries` method
// https://tc39.es/ecma262/#sec-object.entries
$244155c096ef4c14$exports({
    target: 'Object',
    stat: true
}, {
    entries: function entries(O) {
        return $a57ff4bf21a62375$require$$entries(O);
    }
});


'use strict';





var $d7897cab1d93bc7f$require$onFreeze = $d263db769eb8b264$exports.onFreeze;
// eslint-disable-next-line es/no-object-freeze -- safe
var $d7897cab1d93bc7f$var$$freeze = Object.freeze;
var $d7897cab1d93bc7f$var$FAILS_ON_PRIMITIVES = $ddd8e9441ae136f2$exports(function() {
    $d7897cab1d93bc7f$var$$freeze(1);
});
// `Object.freeze` method
// https://tc39.es/ecma262/#sec-object.freeze
$244155c096ef4c14$exports({
    target: 'Object',
    stat: true,
    forced: $d7897cab1d93bc7f$var$FAILS_ON_PRIMITIVES,
    sham: !$323042bd7ad218cd$exports
}, {
    freeze: function freeze(it) {
        return $d7897cab1d93bc7f$var$$freeze && $4d7f82f6c4645870$exports(it) ? $d7897cab1d93bc7f$var$$freeze($d7897cab1d93bc7f$require$onFreeze(it)) : it;
    }
});


'use strict';



// `Object.fromEntries` method
// https://tc39.es/ecma262/#sec-object.fromentries
$244155c096ef4c14$exports({
    target: 'Object',
    stat: true
}, {
    fromEntries: function fromEntries(iterable) {
        var obj = {};
        $ec8a9e5ef0653b51$exports(iterable, function(k, v) {
            $7e31aa0800ea6c75$exports(obj, k, v);
        }, {
            AS_ENTRIES: true
        });
        return obj;
    }
});


'use strict';




var $080184df6277e53d$require$nativeGetOwnPropertyDescriptor = $70871da05e9d21bf$export$2d1720544b23b823;

var $080184df6277e53d$var$FORCED = !$b9f536d3284d7921$exports || $ddd8e9441ae136f2$exports(function() {
    $080184df6277e53d$require$nativeGetOwnPropertyDescriptor(1);
});
// `Object.getOwnPropertyDescriptor` method
// https://tc39.es/ecma262/#sec-object.getownpropertydescriptor
$244155c096ef4c14$exports({
    target: 'Object',
    stat: true,
    forced: $080184df6277e53d$var$FORCED,
    sham: !$b9f536d3284d7921$exports
}, {
    getOwnPropertyDescriptor: function getOwnPropertyDescriptor(it, key) {
        return $080184df6277e53d$require$nativeGetOwnPropertyDescriptor($59a8f2f00edbf5a1$exports(it), key);
    }
});


'use strict';






// `Object.getOwnPropertyDescriptors` method
// https://tc39.es/ecma262/#sec-object.getownpropertydescriptors
$244155c096ef4c14$exports({
    target: 'Object',
    stat: true,
    sham: !$b9f536d3284d7921$exports
}, {
    getOwnPropertyDescriptors: function getOwnPropertyDescriptors(object) {
        var O = $59a8f2f00edbf5a1$exports(object);
        var getOwnPropertyDescriptor = $70871da05e9d21bf$export$2d1720544b23b823;
        var keys = $f90a310de5bd21d5$exports(O);
        var result = {};
        var index = 0;
        var key, descriptor;
        while(keys.length > index){
            descriptor = getOwnPropertyDescriptor(O, key = keys[index++]);
            if (descriptor !== undefined) $7e31aa0800ea6c75$exports(result, key, descriptor);
        }
        return result;
    }
});


'use strict';



var $020de04bc383d23b$require$getOwnPropertyNames = $96008a693f58af2b$export$2d1720544b23b823;
// eslint-disable-next-line es/no-object-getownpropertynames -- required for testing
var $020de04bc383d23b$var$FAILS_ON_PRIMITIVES = $ddd8e9441ae136f2$exports(function() {
    return !Object.getOwnPropertyNames(1);
});
// `Object.getOwnPropertyNames` method
// https://tc39.es/ecma262/#sec-object.getownpropertynames
$244155c096ef4c14$exports({
    target: 'Object',
    stat: true,
    forced: $020de04bc383d23b$var$FAILS_ON_PRIMITIVES
}, {
    getOwnPropertyNames: $020de04bc383d23b$require$getOwnPropertyNames
});


'use strict';





var $5c612e815d70351d$var$FAILS_ON_PRIMITIVES = $ddd8e9441ae136f2$exports(function() {
    $5f455f1b83f2c610$exports(1);
});
// `Object.getPrototypeOf` method
// https://tc39.es/ecma262/#sec-object.getprototypeof
$244155c096ef4c14$exports({
    target: 'Object',
    stat: true,
    forced: $5c612e815d70351d$var$FAILS_ON_PRIMITIVES,
    sham: !$1e9a79416b0401f6$exports
}, {
    getPrototypeOf: function getPrototypeOf(it) {
        return $5f455f1b83f2c610$exports($ad1d9797f1e27af5$exports(it));
    }
});


'use strict';

var $bbb65a846df46ee6$exports = {};
'use strict';
// `SameValue` abstract operation
// https://tc39.es/ecma262/#sec-samevalue
// eslint-disable-next-line es/no-object-is -- safe
$bbb65a846df46ee6$exports = Object.is || function is(x, y) {
    // eslint-disable-next-line no-self-compare -- NaN check
    return x === y ? x !== 0 || 1 / x === 1 / y : x !== x && y !== y;
};


// `Object.is` method
// https://tc39.es/ecma262/#sec-object.is
$244155c096ef4c14$exports({
    target: 'Object',
    stat: true
}, {
    is: $bbb65a846df46ee6$exports
});


'use strict';


// `Object.isExtensible` method
// https://tc39.es/ecma262/#sec-object.isextensible
// eslint-disable-next-line es/no-object-isextensible -- safe
$244155c096ef4c14$exports({
    target: 'Object',
    stat: true,
    forced: Object.isExtensible !== $77d1f8899c709e1b$exports
}, {
    isExtensible: $77d1f8899c709e1b$exports
});


'use strict';





// eslint-disable-next-line es/no-object-isfrozen -- safe
var $9153b137bb3db34a$var$$isFrozen = Object.isFrozen;
var $9153b137bb3db34a$var$FORCED = $cc3b767a98af1ec0$exports || $ddd8e9441ae136f2$exports(function() {
    $9153b137bb3db34a$var$$isFrozen(1);
});
// `Object.isFrozen` method
// https://tc39.es/ecma262/#sec-object.isfrozen
$244155c096ef4c14$exports({
    target: 'Object',
    stat: true,
    forced: $9153b137bb3db34a$var$FORCED
}, {
    isFrozen: function isFrozen(it) {
        if (!$4d7f82f6c4645870$exports(it)) return true;
        if ($cc3b767a98af1ec0$exports && $5a266b01e7970e30$exports(it) === 'ArrayBuffer') return true;
        return $9153b137bb3db34a$var$$isFrozen ? $9153b137bb3db34a$var$$isFrozen(it) : false;
    }
});


'use strict';





// eslint-disable-next-line es/no-object-issealed -- safe
var $6024bf9f584e9874$var$$isSealed = Object.isSealed;
var $6024bf9f584e9874$var$FORCED = $cc3b767a98af1ec0$exports || $ddd8e9441ae136f2$exports(function() {
    $6024bf9f584e9874$var$$isSealed(1);
});
// `Object.isSealed` method
// https://tc39.es/ecma262/#sec-object.issealed
$244155c096ef4c14$exports({
    target: 'Object',
    stat: true,
    forced: $6024bf9f584e9874$var$FORCED
}, {
    isSealed: function isSealed(it) {
        if (!$4d7f82f6c4645870$exports(it)) return true;
        if ($cc3b767a98af1ec0$exports && $5a266b01e7970e30$exports(it) === 'ArrayBuffer') return true;
        return $6024bf9f584e9874$var$$isSealed ? $6024bf9f584e9874$var$$isSealed(it) : false;
    }
});


'use strict';




var $eceb0f0eda41fb41$var$FAILS_ON_PRIMITIVES = $ddd8e9441ae136f2$exports(function() {
    $ed3a442fad5fbe57$exports(1);
});
// `Object.keys` method
// https://tc39.es/ecma262/#sec-object.keys
$244155c096ef4c14$exports({
    target: 'Object',
    stat: true,
    forced: $eceb0f0eda41fb41$var$FAILS_ON_PRIMITIVES
}, {
    keys: function keys(it) {
        return $ed3a442fad5fbe57$exports($ad1d9797f1e27af5$exports(it));
    }
});


'use strict';







var $365b94d83f325651$require$getOwnPropertyDescriptor = $70871da05e9d21bf$export$2d1720544b23b823;
// `Object.prototype.__lookupGetter__` method
// https://tc39.es/ecma262/#sec-object.prototype.__lookupGetter__
if ($b9f536d3284d7921$exports) $244155c096ef4c14$exports({
    target: 'Object',
    proto: true,
    forced: $f5a75fa531277ab6$exports
}, {
    __lookupGetter__: function __lookupGetter__(P) {
        var O = $ad1d9797f1e27af5$exports(this);
        var key = $d9a9cf8e89852c56$exports(P);
        var desc;
        do {
            if (desc = $365b94d83f325651$require$getOwnPropertyDescriptor(O, key)) return desc.get;
        }while (O = $5f455f1b83f2c610$exports(O));
    }
});


'use strict';







var $8e2bc47099513f3e$require$getOwnPropertyDescriptor = $70871da05e9d21bf$export$2d1720544b23b823;
// `Object.prototype.__lookupSetter__` method
// https://tc39.es/ecma262/#sec-object.prototype.__lookupSetter__
if ($b9f536d3284d7921$exports) $244155c096ef4c14$exports({
    target: 'Object',
    proto: true,
    forced: $f5a75fa531277ab6$exports
}, {
    __lookupSetter__: function __lookupSetter__(P) {
        var O = $ad1d9797f1e27af5$exports(this);
        var key = $d9a9cf8e89852c56$exports(P);
        var desc;
        do {
            if (desc = $8e2bc47099513f3e$require$getOwnPropertyDescriptor(O, key)) return desc.set;
        }while (O = $5f455f1b83f2c610$exports(O));
    }
});


'use strict';



var $0bfc02dc652fe4dd$require$onFreeze = $d263db769eb8b264$exports.onFreeze;


// eslint-disable-next-line es/no-object-preventextensions -- safe
var $0bfc02dc652fe4dd$var$$preventExtensions = Object.preventExtensions;
var $0bfc02dc652fe4dd$var$FAILS_ON_PRIMITIVES = $ddd8e9441ae136f2$exports(function() {
    $0bfc02dc652fe4dd$var$$preventExtensions(1);
});
// `Object.preventExtensions` method
// https://tc39.es/ecma262/#sec-object.preventextensions
$244155c096ef4c14$exports({
    target: 'Object',
    stat: true,
    forced: $0bfc02dc652fe4dd$var$FAILS_ON_PRIMITIVES,
    sham: !$323042bd7ad218cd$exports
}, {
    preventExtensions: function preventExtensions(it) {
        return $0bfc02dc652fe4dd$var$$preventExtensions && $4d7f82f6c4645870$exports(it) ? $0bfc02dc652fe4dd$var$$preventExtensions($0bfc02dc652fe4dd$require$onFreeze(it)) : it;
    }
});


'use strict';



var $6e30ff16e01e6c25$require$onFreeze = $d263db769eb8b264$exports.onFreeze;


// eslint-disable-next-line es/no-object-seal -- safe
var $6e30ff16e01e6c25$var$$seal = Object.seal;
var $6e30ff16e01e6c25$var$FAILS_ON_PRIMITIVES = $ddd8e9441ae136f2$exports(function() {
    $6e30ff16e01e6c25$var$$seal(1);
});
// `Object.seal` method
// https://tc39.es/ecma262/#sec-object.seal
$244155c096ef4c14$exports({
    target: 'Object',
    stat: true,
    forced: $6e30ff16e01e6c25$var$FAILS_ON_PRIMITIVES,
    sham: !$323042bd7ad218cd$exports
}, {
    seal: function seal(it) {
        return $6e30ff16e01e6c25$var$$seal && $4d7f82f6c4645870$exports(it) ? $6e30ff16e01e6c25$var$$seal($6e30ff16e01e6c25$require$onFreeze(it)) : it;
    }
});


'use strict';


var $939c564b8dfe0f15$exports = {};
'use strict';


// `Object.prototype.toString` method implementation
// https://tc39.es/ecma262/#sec-object.prototype.tostring
$939c564b8dfe0f15$exports = $9b82848ada619f8e$exports ? ({}).toString : function toString() {
    return '[object ' + $b720974ac29b37e2$exports(this) + ']';
};


// `Object.prototype.toString` method
// https://tc39.es/ecma262/#sec-object.prototype.tostring
if (!$9b82848ada619f8e$exports) $73c8864ae5df5c4d$exports(Object.prototype, 'toString', $939c564b8dfe0f15$exports, {
    unsafe: true
});


'use strict';


var $4d4f3440e305374c$require$$values = $309da03ee3e3b3f3$exports.values;
// `Object.values` method
// https://tc39.es/ecma262/#sec-object.values
$244155c096ef4c14$exports({
    target: 'Object',
    stat: true
}, {
    values: function values(O) {
        return $4d4f3440e305374c$require$$values(O);
    }
});


'use strict';
'use strict';


var $6579047f4a45e476$exports = {};
'use strict';
var $2ae0d98a4d3e65de$exports = {};

var $6tOPT = parcelRequire("6tOPT");
'use strict';



var $2ae0d98a4d3e65de$var$userAgentStartsWith = function userAgentStartsWith(string) {
    return $ef443fb3091f223d$exports.slice(0, string.length) === string;
};
$2ae0d98a4d3e65de$exports = function() {
    if ($2ae0d98a4d3e65de$var$userAgentStartsWith('Bun/')) return 'BUN';
    if ($2ae0d98a4d3e65de$var$userAgentStartsWith('Cloudflare-Workers')) return 'CLOUDFLARE';
    if ($2ae0d98a4d3e65de$var$userAgentStartsWith('Deno/')) return 'DENO';
    if ($2ae0d98a4d3e65de$var$userAgentStartsWith('Node.js/')) return 'NODE';
    if ($27350b6a9e85aed1$exports.Bun && typeof Bun.version == 'string') return 'BUN';
    if ($27350b6a9e85aed1$exports.Deno && (0, $6tOPT._)(Deno.version) == 'object') return 'DENO';
    if ($5a266b01e7970e30$exports($27350b6a9e85aed1$exports.process) === 'process') return 'NODE';
    if ($27350b6a9e85aed1$exports.window && $27350b6a9e85aed1$exports.document) return 'BROWSER';
    return 'REST';
}();


$6579047f4a45e476$exports = $2ae0d98a4d3e65de$exports === 'NODE';













var $530f9e30acde7c4a$exports = {};
'use strict';

var $2208800311a8332a$exports = {};
'use strict';


var $2208800311a8332a$var$$TypeError = TypeError;
// `Assert: IsConstructor(argument) is true`
$2208800311a8332a$exports = function(argument) {
    if ($db2ba5677c412211$exports(argument)) return argument;
    throw new $2208800311a8332a$var$$TypeError($287fd49afd1ee632$exports(argument) + ' is not a constructor');
};




var $530f9e30acde7c4a$var$SPECIES = $8555fb22f74da29f$exports('species');
// `SpeciesConstructor` abstract operation
// https://tc39.es/ecma262/#sec-speciesconstructor
$530f9e30acde7c4a$exports = function(O, defaultConstructor) {
    var C = $7d9b9f0a2a7e34a2$exports(O).constructor;
    var S;
    return C === undefined || $da08ff0243e53f27$exports(S = $7d9b9f0a2a7e34a2$exports(C)[$530f9e30acde7c4a$var$SPECIES]) ? defaultConstructor : $2208800311a8332a$exports(S);
};


var $fa9149d3a968f56a$exports = {};
'use strict';









var $01603bd6f8ce1d57$exports = {};
'use strict';
var $01603bd6f8ce1d57$var$$TypeError = TypeError;
$01603bd6f8ce1d57$exports = function(passed, required) {
    if (passed < required) throw new $01603bd6f8ce1d57$var$$TypeError('Not enough arguments');
    return passed;
};


var $3eeaa9b2e6edfe87$exports = {};
'use strict';

$3eeaa9b2e6edfe87$exports = /ipad|iphone|ipod/i.test($ef443fb3091f223d$exports) && /applewebkit/i.test($ef443fb3091f223d$exports);



var $fa9149d3a968f56a$var$set = $27350b6a9e85aed1$exports.setImmediate;
var $fa9149d3a968f56a$var$clear = $27350b6a9e85aed1$exports.clearImmediate;
var $fa9149d3a968f56a$var$process = $27350b6a9e85aed1$exports.process;
var $fa9149d3a968f56a$var$Dispatch = $27350b6a9e85aed1$exports.Dispatch;
var $fa9149d3a968f56a$var$Function = $27350b6a9e85aed1$exports.Function;
var $fa9149d3a968f56a$var$MessageChannel = $27350b6a9e85aed1$exports.MessageChannel;
var $fa9149d3a968f56a$var$String = $27350b6a9e85aed1$exports.String;
var $fa9149d3a968f56a$var$counter = 0;
var $fa9149d3a968f56a$var$queue = {};
var $fa9149d3a968f56a$var$ONREADYSTATECHANGE = 'onreadystatechange';
var $fa9149d3a968f56a$var$$location, $fa9149d3a968f56a$var$defer, $fa9149d3a968f56a$var$channel, $fa9149d3a968f56a$var$port;
$ddd8e9441ae136f2$exports(function() {
    // Deno throws a ReferenceError on `location` access without `--location` flag
    $fa9149d3a968f56a$var$$location = $27350b6a9e85aed1$exports.location;
});
var $fa9149d3a968f56a$var$run = function run(id) {
    if ($8bbc2bccc0a29296$exports($fa9149d3a968f56a$var$queue, id)) {
        var fn = $fa9149d3a968f56a$var$queue[id];
        delete $fa9149d3a968f56a$var$queue[id];
        fn();
    }
};
var $fa9149d3a968f56a$var$runner = function runner(id) {
    return function() {
        $fa9149d3a968f56a$var$run(id);
    };
};
var $fa9149d3a968f56a$var$eventListener = function eventListener(event) {
    $fa9149d3a968f56a$var$run(event.data);
};
var $fa9149d3a968f56a$var$globalPostMessageDefer = function globalPostMessageDefer(id) {
    // old engines have not location.origin
    $27350b6a9e85aed1$exports.postMessage($fa9149d3a968f56a$var$String(id), $fa9149d3a968f56a$var$$location.protocol + '//' + $fa9149d3a968f56a$var$$location.host);
};
// Node.js 0.9+ & IE10+ has setImmediate, otherwise:
if (!$fa9149d3a968f56a$var$set || !$fa9149d3a968f56a$var$clear) {
    $fa9149d3a968f56a$var$set = function setImmediate(handler) {
        $01603bd6f8ce1d57$exports(arguments.length, 1);
        var fn = $7c165f740ca92c53$exports(handler) ? handler : $fa9149d3a968f56a$var$Function(handler);
        var args = $2dd14968e62d6eb1$exports(arguments, 1);
        $fa9149d3a968f56a$var$queue[++$fa9149d3a968f56a$var$counter] = function() {
            $eb64554a295b6978$exports(fn, undefined, args);
        };
        $fa9149d3a968f56a$var$defer($fa9149d3a968f56a$var$counter);
        return $fa9149d3a968f56a$var$counter;
    };
    $fa9149d3a968f56a$var$clear = function clearImmediate(id) {
        delete $fa9149d3a968f56a$var$queue[id];
    };
    // Node.js 0.8-
    if ($6579047f4a45e476$exports) $fa9149d3a968f56a$var$defer = function defer(id) {
        $fa9149d3a968f56a$var$process.nextTick($fa9149d3a968f56a$var$runner(id));
    };
    else if ($fa9149d3a968f56a$var$Dispatch && $fa9149d3a968f56a$var$Dispatch.now) $fa9149d3a968f56a$var$defer = function defer(id) {
        $fa9149d3a968f56a$var$Dispatch.now($fa9149d3a968f56a$var$runner(id));
    };
    else if ($fa9149d3a968f56a$var$MessageChannel && !$3eeaa9b2e6edfe87$exports) {
        $fa9149d3a968f56a$var$channel = new $fa9149d3a968f56a$var$MessageChannel();
        $fa9149d3a968f56a$var$port = $fa9149d3a968f56a$var$channel.port2;
        $fa9149d3a968f56a$var$channel.port1.onmessage = $fa9149d3a968f56a$var$eventListener;
        $fa9149d3a968f56a$var$defer = $8a0b7edcb386df4b$exports($fa9149d3a968f56a$var$port.postMessage, $fa9149d3a968f56a$var$port);
    // Browsers with postMessage, skip WebWorkers
    // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
    } else if ($27350b6a9e85aed1$exports.addEventListener && $7c165f740ca92c53$exports($27350b6a9e85aed1$exports.postMessage) && !$27350b6a9e85aed1$exports.importScripts && $fa9149d3a968f56a$var$$location && $fa9149d3a968f56a$var$$location.protocol !== 'file:' && !$ddd8e9441ae136f2$exports($fa9149d3a968f56a$var$globalPostMessageDefer)) {
        $fa9149d3a968f56a$var$defer = $fa9149d3a968f56a$var$globalPostMessageDefer;
        $27350b6a9e85aed1$exports.addEventListener('message', $fa9149d3a968f56a$var$eventListener, false);
    // IE8-
    } else if ($fa9149d3a968f56a$var$ONREADYSTATECHANGE in $9615a1abb0018505$exports('script')) $fa9149d3a968f56a$var$defer = function defer(id) {
        $42f7da397525bafb$exports.appendChild($9615a1abb0018505$exports('script'))[$fa9149d3a968f56a$var$ONREADYSTATECHANGE] = function() {
            $42f7da397525bafb$exports.removeChild(this);
            $fa9149d3a968f56a$var$run(id);
        };
    };
    else $fa9149d3a968f56a$var$defer = function defer(id) {
        setTimeout($fa9149d3a968f56a$var$runner(id), 0);
    };
}
$fa9149d3a968f56a$exports = {
    set: $fa9149d3a968f56a$var$set,
    clear: $fa9149d3a968f56a$var$clear
};


var $2517639fe7937dbe$require$task = $fa9149d3a968f56a$exports.set;
var $4bcf5809c5bd6af8$exports = {};
'use strict';

var $e77683fca65d592a$exports = {};
'use strict';


// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $e77683fca65d592a$var$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
// Avoid NodeJS experimental warning
$e77683fca65d592a$exports = function(name) {
    if (!$b9f536d3284d7921$exports) return $27350b6a9e85aed1$exports[name];
    var descriptor = $e77683fca65d592a$var$getOwnPropertyDescriptor($27350b6a9e85aed1$exports, name);
    return descriptor && descriptor.value;
};




var $4bcf5809c5bd6af8$require$macrotask = $fa9149d3a968f56a$exports.set;
var $df416945a22f3cd5$exports = {};
'use strict';
var $df416945a22f3cd5$var$Queue = function Queue() {
    this.head = null;
    this.tail = null;
};
$df416945a22f3cd5$var$Queue.prototype = {
    add: function add(item) {
        var entry = {
            item: item,
            next: null
        };
        var tail = this.tail;
        if (tail) tail.next = entry;
        else this.head = entry;
        this.tail = entry;
    },
    get: function get() {
        var entry = this.head;
        if (entry) {
            var next = this.head = entry.next;
            if (next === null) this.tail = null;
            return entry.item;
        }
    }
};
$df416945a22f3cd5$exports = $df416945a22f3cd5$var$Queue;



var $0b1a36d1c8819b5f$exports = {};
'use strict';

$0b1a36d1c8819b5f$exports = /ipad|iphone|ipod/i.test($ef443fb3091f223d$exports) && typeof Pebble != 'undefined';


var $07ebbcc5eadc6484$exports = {};
'use strict';

$07ebbcc5eadc6484$exports = /web0s(?!.*chrome)/i.test($ef443fb3091f223d$exports);



var $4bcf5809c5bd6af8$var$MutationObserver = $27350b6a9e85aed1$exports.MutationObserver || $27350b6a9e85aed1$exports.WebKitMutationObserver;
var $4bcf5809c5bd6af8$var$document = $27350b6a9e85aed1$exports.document;
var $4bcf5809c5bd6af8$var$process = $27350b6a9e85aed1$exports.process;
var $4bcf5809c5bd6af8$var$Promise = $27350b6a9e85aed1$exports.Promise;
var $4bcf5809c5bd6af8$var$microtask = $e77683fca65d592a$exports('queueMicrotask');
var $4bcf5809c5bd6af8$var$notify, $4bcf5809c5bd6af8$var$toggle, $4bcf5809c5bd6af8$var$node, $4bcf5809c5bd6af8$var$promise, $4bcf5809c5bd6af8$var$then;
// modern engines have queueMicrotask method
if (!$4bcf5809c5bd6af8$var$microtask) {
    var $4bcf5809c5bd6af8$var$queue = new $df416945a22f3cd5$exports();
    var $4bcf5809c5bd6af8$var$flush = function flush() {
        var parent, fn;
        if ($6579047f4a45e476$exports && (parent = $4bcf5809c5bd6af8$var$process.domain)) parent.exit();
        while(fn = $4bcf5809c5bd6af8$var$queue.get())try {
            fn();
        } catch (error) {
            if ($4bcf5809c5bd6af8$var$queue.head) $4bcf5809c5bd6af8$var$notify();
            throw error;
        }
        if (parent) parent.enter();
    };
    // browsers with MutationObserver, except iOS - https://github.com/zloirock/core-js/issues/339
    // also except WebOS Webkit https://github.com/zloirock/core-js/issues/898
    if (!$3eeaa9b2e6edfe87$exports && !$6579047f4a45e476$exports && !$07ebbcc5eadc6484$exports && $4bcf5809c5bd6af8$var$MutationObserver && $4bcf5809c5bd6af8$var$document) {
        $4bcf5809c5bd6af8$var$toggle = true;
        $4bcf5809c5bd6af8$var$node = $4bcf5809c5bd6af8$var$document.createTextNode('');
        new $4bcf5809c5bd6af8$var$MutationObserver($4bcf5809c5bd6af8$var$flush).observe($4bcf5809c5bd6af8$var$node, {
            characterData: true
        });
        $4bcf5809c5bd6af8$var$notify = function notify() {
            $4bcf5809c5bd6af8$var$node.data = $4bcf5809c5bd6af8$var$toggle = !$4bcf5809c5bd6af8$var$toggle;
        };
    // environments with maybe non-completely correct, but existent Promise
    } else if (!$0b1a36d1c8819b5f$exports && $4bcf5809c5bd6af8$var$Promise && $4bcf5809c5bd6af8$var$Promise.resolve) {
        // Promise.resolve without an argument throws an error in LG WebOS 2
        $4bcf5809c5bd6af8$var$promise = $4bcf5809c5bd6af8$var$Promise.resolve(undefined);
        // workaround of WebKit ~ iOS Safari 10.1 bug
        $4bcf5809c5bd6af8$var$promise.constructor = $4bcf5809c5bd6af8$var$Promise;
        $4bcf5809c5bd6af8$var$then = $8a0b7edcb386df4b$exports($4bcf5809c5bd6af8$var$promise.then, $4bcf5809c5bd6af8$var$promise);
        $4bcf5809c5bd6af8$var$notify = function notify() {
            $4bcf5809c5bd6af8$var$then($4bcf5809c5bd6af8$var$flush);
        };
    // Node.js without promises
    } else if ($6579047f4a45e476$exports) $4bcf5809c5bd6af8$var$notify = function notify() {
        $4bcf5809c5bd6af8$var$process.nextTick($4bcf5809c5bd6af8$var$flush);
    };
    else {
        // `webpack` dev server bug on IE global methods - use bind(fn, global)
        $4bcf5809c5bd6af8$require$macrotask = $8a0b7edcb386df4b$exports($4bcf5809c5bd6af8$require$macrotask, $27350b6a9e85aed1$exports);
        $4bcf5809c5bd6af8$var$notify = function notify() {
            $4bcf5809c5bd6af8$require$macrotask($4bcf5809c5bd6af8$var$flush);
        };
    }
    $4bcf5809c5bd6af8$var$microtask = function microtask(fn) {
        if (!$4bcf5809c5bd6af8$var$queue.head) $4bcf5809c5bd6af8$var$notify();
        $4bcf5809c5bd6af8$var$queue.add(fn);
    };
}
$4bcf5809c5bd6af8$exports = $4bcf5809c5bd6af8$var$microtask;


var $d128dd970bda954e$exports = {};
'use strict';
$d128dd970bda954e$exports = function(a, b) {
    try {
        // eslint-disable-next-line no-console -- safe
        arguments.length === 1 ? console.error(a) : console.error(a, b);
    } catch (error) {}
};


var $9218597321bed915$exports = {};
'use strict';
$9218597321bed915$exports = function(exec) {
    try {
        return {
            error: false,
            value: exec()
        };
    } catch (error) {
        return {
            error: true,
            value: error
        };
    }
};




var $6cfa87e8b8fcfae8$exports = {};
'use strict';

$6cfa87e8b8fcfae8$exports = $27350b6a9e85aed1$exports.Promise;


var $ba7078e301a2ff3f$exports = {};
'use strict';









var $ba7078e301a2ff3f$var$NativePromisePrototype = $6cfa87e8b8fcfae8$exports && $6cfa87e8b8fcfae8$exports.prototype;
var $ba7078e301a2ff3f$var$SPECIES = $8555fb22f74da29f$exports('species');
var $ba7078e301a2ff3f$var$SUBCLASSING = false;
var $ba7078e301a2ff3f$var$NATIVE_PROMISE_REJECTION_EVENT = $7c165f740ca92c53$exports($27350b6a9e85aed1$exports.PromiseRejectionEvent);
var $ba7078e301a2ff3f$var$FORCED_PROMISE_CONSTRUCTOR = $0ae261ce45c3c073$exports('Promise', function() {
    var PROMISE_CONSTRUCTOR_SOURCE = $fe8e93358f2825b5$exports($6cfa87e8b8fcfae8$exports);
    var GLOBAL_CORE_JS_PROMISE = PROMISE_CONSTRUCTOR_SOURCE !== String($6cfa87e8b8fcfae8$exports);
    // V8 6.6 (Node 10 and Chrome 66) have a bug with resolving custom thenables
    // https://bugs.chromium.org/p/chromium/issues/detail?id=830565
    // We can't detect it synchronously, so just check versions
    if (!GLOBAL_CORE_JS_PROMISE && $af93164be802bd69$exports === 66) return true;
    // We need Promise#{ catch, finally } in the pure version for preventing prototype pollution
    if ($a4b83f418a8da28e$exports && !($ba7078e301a2ff3f$var$NativePromisePrototype['catch'] && $ba7078e301a2ff3f$var$NativePromisePrototype['finally'])) return true;
    // We can't use @@species feature detection in V8 since it causes
    // deoptimization and performance degradation
    // https://github.com/zloirock/core-js/issues/679
    if (!$af93164be802bd69$exports || $af93164be802bd69$exports < 51 || !/native code/.test(PROMISE_CONSTRUCTOR_SOURCE)) {
        // Detect correctness of subclassing with @@species support
        var promise = new $6cfa87e8b8fcfae8$exports(function(resolve) {
            resolve(1);
        });
        var FakePromise = function FakePromise(exec) {
            exec(function() {}, function() {});
        };
        var constructor = promise.constructor = {};
        constructor[$ba7078e301a2ff3f$var$SPECIES] = FakePromise;
        $ba7078e301a2ff3f$var$SUBCLASSING = promise.then(function() {}) instanceof FakePromise;
        if (!$ba7078e301a2ff3f$var$SUBCLASSING) return true;
    // Unhandled rejections tracking support, NodeJS Promise without it fails @@species test
    }
    return !GLOBAL_CORE_JS_PROMISE && ($2ae0d98a4d3e65de$exports === 'BROWSER' || $2ae0d98a4d3e65de$exports === 'DENO') && !$ba7078e301a2ff3f$var$NATIVE_PROMISE_REJECTION_EVENT;
});
$ba7078e301a2ff3f$exports = {
    CONSTRUCTOR: $ba7078e301a2ff3f$var$FORCED_PROMISE_CONSTRUCTOR,
    REJECTION_EVENT: $ba7078e301a2ff3f$var$NATIVE_PROMISE_REJECTION_EVENT,
    SUBCLASSING: $ba7078e301a2ff3f$var$SUBCLASSING
};


var $883973452f6e32b5$exports = {};

$parcel$export($883973452f6e32b5$exports, "f", function () { return $883973452f6e32b5$export$2d1720544b23b823; }, function (v) { return $883973452f6e32b5$export$2d1720544b23b823 = v; });
// `NewPromiseCapability` abstract operation
// https://tc39.es/ecma262/#sec-newpromisecapability
var $883973452f6e32b5$export$2d1720544b23b823;
'use strict';

var $883973452f6e32b5$var$$TypeError = TypeError;
var $883973452f6e32b5$var$PromiseCapability = function PromiseCapability(C) {
    var resolve, reject;
    this.promise = new C(function($$resolve, $$reject) {
        if (resolve !== undefined || reject !== undefined) throw new $883973452f6e32b5$var$$TypeError('Bad Promise constructor');
        resolve = $$resolve;
        reject = $$reject;
    });
    this.resolve = $082fcaa0a091ee30$exports(resolve);
    this.reject = $082fcaa0a091ee30$exports(reject);
};
$883973452f6e32b5$export$2d1720544b23b823 = function(C) {
    return new $883973452f6e32b5$var$PromiseCapability(C);
};


var $2517639fe7937dbe$var$PROMISE = 'Promise';
var $2517639fe7937dbe$var$FORCED_PROMISE_CONSTRUCTOR = $ba7078e301a2ff3f$exports.CONSTRUCTOR;
var $2517639fe7937dbe$var$NATIVE_PROMISE_REJECTION_EVENT = $ba7078e301a2ff3f$exports.REJECTION_EVENT;
var $2517639fe7937dbe$var$NATIVE_PROMISE_SUBCLASSING = $ba7078e301a2ff3f$exports.SUBCLASSING;
var $2517639fe7937dbe$var$getInternalPromiseState = $fcfe8b5396fbe91a$exports.getterFor($2517639fe7937dbe$var$PROMISE);
var $2517639fe7937dbe$var$setInternalState = $fcfe8b5396fbe91a$exports.set;
var $2517639fe7937dbe$var$NativePromisePrototype = $6cfa87e8b8fcfae8$exports && $6cfa87e8b8fcfae8$exports.prototype;
var $2517639fe7937dbe$var$PromiseConstructor = $6cfa87e8b8fcfae8$exports;
var $2517639fe7937dbe$var$PromisePrototype = $2517639fe7937dbe$var$NativePromisePrototype;
var $2517639fe7937dbe$var$TypeError = $27350b6a9e85aed1$exports.TypeError;
var $2517639fe7937dbe$var$document = $27350b6a9e85aed1$exports.document;
var $2517639fe7937dbe$var$process = $27350b6a9e85aed1$exports.process;
var $2517639fe7937dbe$var$newPromiseCapability = $883973452f6e32b5$export$2d1720544b23b823;
var $2517639fe7937dbe$var$newGenericPromiseCapability = $2517639fe7937dbe$var$newPromiseCapability;
var $2517639fe7937dbe$var$DISPATCH_EVENT = !!($2517639fe7937dbe$var$document && $2517639fe7937dbe$var$document.createEvent && $27350b6a9e85aed1$exports.dispatchEvent);
var $2517639fe7937dbe$var$UNHANDLED_REJECTION = 'unhandledrejection';
var $2517639fe7937dbe$var$REJECTION_HANDLED = 'rejectionhandled';
var $2517639fe7937dbe$var$PENDING = 0;
var $2517639fe7937dbe$var$FULFILLED = 1;
var $2517639fe7937dbe$var$REJECTED = 2;
var $2517639fe7937dbe$var$HANDLED = 1;
var $2517639fe7937dbe$var$UNHANDLED = 2;
var $2517639fe7937dbe$var$Internal, $2517639fe7937dbe$var$OwnPromiseCapability, $2517639fe7937dbe$var$PromiseWrapper, $2517639fe7937dbe$var$nativeThen;
// helpers
var $2517639fe7937dbe$var$isThenable = function isThenable(it) {
    var then;
    return $4d7f82f6c4645870$exports(it) && $7c165f740ca92c53$exports(then = it.then) ? then : false;
};
var $2517639fe7937dbe$var$callReaction = function callReaction(reaction, state) {
    var value = state.value;
    var ok = state.state === $2517639fe7937dbe$var$FULFILLED;
    var handler = ok ? reaction.ok : reaction.fail;
    var resolve = reaction.resolve;
    var reject = reaction.reject;
    var domain = reaction.domain;
    var result, then, exited;
    try {
        if (handler) {
            if (!ok) {
                if (state.rejection === $2517639fe7937dbe$var$UNHANDLED) $2517639fe7937dbe$var$onHandleUnhandled(state);
                state.rejection = $2517639fe7937dbe$var$HANDLED;
            }
            if (handler === true) result = value;
            else {
                if (domain) domain.enter();
                result = handler(value); // can throw
                if (domain) {
                    domain.exit();
                    exited = true;
                }
            }
            if (result === reaction.promise) reject(new $2517639fe7937dbe$var$TypeError('Promise-chain cycle'));
            else if (then = $2517639fe7937dbe$var$isThenable(result)) $59bf80837927ca02$exports(then, result, resolve, reject);
            else resolve(result);
        } else reject(value);
    } catch (error) {
        if (domain && !exited) domain.exit();
        reject(error);
    }
};
var $2517639fe7937dbe$var$notify = function notify(state, isReject) {
    if (state.notified) return;
    state.notified = true;
    $4bcf5809c5bd6af8$exports(function() {
        var reactions = state.reactions;
        var reaction;
        while(reaction = reactions.get())$2517639fe7937dbe$var$callReaction(reaction, state);
        state.notified = false;
        if (isReject && !state.rejection) $2517639fe7937dbe$var$onUnhandled(state);
    });
};
var $2517639fe7937dbe$var$dispatchEvent = function dispatchEvent(name, promise, reason) {
    var event, handler;
    if ($2517639fe7937dbe$var$DISPATCH_EVENT) {
        event = $2517639fe7937dbe$var$document.createEvent('Event');
        event.promise = promise;
        event.reason = reason;
        event.initEvent(name, false, true);
        $27350b6a9e85aed1$exports.dispatchEvent(event);
    } else event = {
        promise: promise,
        reason: reason
    };
    if (!$2517639fe7937dbe$var$NATIVE_PROMISE_REJECTION_EVENT && (handler = $27350b6a9e85aed1$exports['on' + name])) handler(event);
    else if (name === $2517639fe7937dbe$var$UNHANDLED_REJECTION) $d128dd970bda954e$exports('Unhandled promise rejection', reason);
};
var $2517639fe7937dbe$var$onUnhandled = function onUnhandled(state) {
    $59bf80837927ca02$exports($2517639fe7937dbe$require$task, $27350b6a9e85aed1$exports, function() {
        var promise = state.facade;
        var value = state.value;
        var IS_UNHANDLED = $2517639fe7937dbe$var$isUnhandled(state);
        var result;
        if (IS_UNHANDLED) {
            result = $9218597321bed915$exports(function() {
                if ($6579047f4a45e476$exports) $2517639fe7937dbe$var$process.emit('unhandledRejection', value, promise);
                else $2517639fe7937dbe$var$dispatchEvent($2517639fe7937dbe$var$UNHANDLED_REJECTION, promise, value);
            });
            // Browsers should not trigger `rejectionHandled` event if it was handled here, NodeJS - should
            state.rejection = $6579047f4a45e476$exports || $2517639fe7937dbe$var$isUnhandled(state) ? $2517639fe7937dbe$var$UNHANDLED : $2517639fe7937dbe$var$HANDLED;
            if (result.error) throw result.value;
        }
    });
};
var $2517639fe7937dbe$var$isUnhandled = function isUnhandled(state) {
    return state.rejection !== $2517639fe7937dbe$var$HANDLED && !state.parent;
};
var $2517639fe7937dbe$var$onHandleUnhandled = function onHandleUnhandled(state) {
    $59bf80837927ca02$exports($2517639fe7937dbe$require$task, $27350b6a9e85aed1$exports, function() {
        var promise = state.facade;
        if ($6579047f4a45e476$exports) $2517639fe7937dbe$var$process.emit('rejectionHandled', promise);
        else $2517639fe7937dbe$var$dispatchEvent($2517639fe7937dbe$var$REJECTION_HANDLED, promise, state.value);
    });
};
var $2517639fe7937dbe$var$bind = function bind(fn, state, unwrap) {
    return function(value) {
        fn(state, value, unwrap);
    };
};
var $2517639fe7937dbe$var$internalReject = function internalReject(state, value, unwrap) {
    if (state.done) return;
    state.done = true;
    if (unwrap) state = unwrap;
    state.value = value;
    state.state = $2517639fe7937dbe$var$REJECTED;
    $2517639fe7937dbe$var$notify(state, true);
};
var $2517639fe7937dbe$var$internalResolve = function internalResolve1(state, value, unwrap) {
    if (state.done) return;
    state.done = true;
    if (unwrap) state = unwrap;
    try {
        if (state.facade === value) throw new $2517639fe7937dbe$var$TypeError("Promise can't be resolved itself");
        var then = $2517639fe7937dbe$var$isThenable(value);
        if (then) $4bcf5809c5bd6af8$exports(function() {
            var wrapper = {
                done: false
            };
            try {
                $59bf80837927ca02$exports(then, value, $2517639fe7937dbe$var$bind($2517639fe7937dbe$var$internalResolve, wrapper, state), $2517639fe7937dbe$var$bind($2517639fe7937dbe$var$internalReject, wrapper, state));
            } catch (error) {
                $2517639fe7937dbe$var$internalReject(wrapper, error, state);
            }
        });
        else {
            state.value = value;
            state.state = $2517639fe7937dbe$var$FULFILLED;
            $2517639fe7937dbe$var$notify(state, false);
        }
    } catch (error) {
        $2517639fe7937dbe$var$internalReject({
            done: false
        }, error, state);
    }
};
// constructor polyfill
if ($2517639fe7937dbe$var$FORCED_PROMISE_CONSTRUCTOR) {
    // 25.4.3.1 Promise(executor)
    $2517639fe7937dbe$var$PromiseConstructor = function Promise(executor) {
        $93a46accb3e7c173$exports(this, $2517639fe7937dbe$var$PromisePrototype);
        $082fcaa0a091ee30$exports(executor);
        $59bf80837927ca02$exports($2517639fe7937dbe$var$Internal, this);
        var state = $2517639fe7937dbe$var$getInternalPromiseState(this);
        try {
            executor($2517639fe7937dbe$var$bind($2517639fe7937dbe$var$internalResolve, state), $2517639fe7937dbe$var$bind($2517639fe7937dbe$var$internalReject, state));
        } catch (error) {
            $2517639fe7937dbe$var$internalReject(state, error);
        }
    };
    $2517639fe7937dbe$var$PromisePrototype = $2517639fe7937dbe$var$PromiseConstructor.prototype;
    // eslint-disable-next-line no-unused-vars -- required for `.length`
    $2517639fe7937dbe$var$Internal = function Promise(executor) {
        $2517639fe7937dbe$var$setInternalState(this, {
            type: $2517639fe7937dbe$var$PROMISE,
            done: false,
            notified: false,
            parent: false,
            reactions: new $df416945a22f3cd5$exports(),
            rejection: false,
            state: $2517639fe7937dbe$var$PENDING,
            value: null
        });
    };
    // `Promise.prototype.then` method
    // https://tc39.es/ecma262/#sec-promise.prototype.then
    $2517639fe7937dbe$var$Internal.prototype = $73c8864ae5df5c4d$exports($2517639fe7937dbe$var$PromisePrototype, 'then', function then(onFulfilled, onRejected) {
        var state = $2517639fe7937dbe$var$getInternalPromiseState(this);
        var reaction = $2517639fe7937dbe$var$newPromiseCapability($530f9e30acde7c4a$exports(this, $2517639fe7937dbe$var$PromiseConstructor));
        state.parent = true;
        reaction.ok = $7c165f740ca92c53$exports(onFulfilled) ? onFulfilled : true;
        reaction.fail = $7c165f740ca92c53$exports(onRejected) && onRejected;
        reaction.domain = $6579047f4a45e476$exports ? $2517639fe7937dbe$var$process.domain : undefined;
        if (state.state === $2517639fe7937dbe$var$PENDING) state.reactions.add(reaction);
        else $4bcf5809c5bd6af8$exports(function() {
            $2517639fe7937dbe$var$callReaction(reaction, state);
        });
        return reaction.promise;
    });
    $2517639fe7937dbe$var$OwnPromiseCapability = function OwnPromiseCapability() {
        var promise = new $2517639fe7937dbe$var$Internal();
        var state = $2517639fe7937dbe$var$getInternalPromiseState(promise);
        this.promise = promise;
        this.resolve = $2517639fe7937dbe$var$bind($2517639fe7937dbe$var$internalResolve, state);
        this.reject = $2517639fe7937dbe$var$bind($2517639fe7937dbe$var$internalReject, state);
    };
    $883973452f6e32b5$exports.f = $2517639fe7937dbe$var$newPromiseCapability = function newPromiseCapability(C) {
        return C === $2517639fe7937dbe$var$PromiseConstructor || C === $2517639fe7937dbe$var$PromiseWrapper ? new $2517639fe7937dbe$var$OwnPromiseCapability(C) : $2517639fe7937dbe$var$newGenericPromiseCapability(C);
    };
    if (!$a4b83f418a8da28e$exports && $7c165f740ca92c53$exports($6cfa87e8b8fcfae8$exports) && $2517639fe7937dbe$var$NativePromisePrototype !== Object.prototype) {
        $2517639fe7937dbe$var$nativeThen = $2517639fe7937dbe$var$NativePromisePrototype.then;
        if (!$2517639fe7937dbe$var$NATIVE_PROMISE_SUBCLASSING) // make `Promise#then` return a polyfilled `Promise` for native promise-based APIs
        $73c8864ae5df5c4d$exports($2517639fe7937dbe$var$NativePromisePrototype, 'then', function then(onFulfilled, onRejected) {
            var that = this;
            return new $2517639fe7937dbe$var$PromiseConstructor(function(resolve, reject) {
                $59bf80837927ca02$exports($2517639fe7937dbe$var$nativeThen, that, resolve, reject);
            }).then(onFulfilled, onRejected);
        // https://github.com/zloirock/core-js/issues/640
        }, {
            unsafe: true
        });
        // make `.constructor === Promise` work for native promise-based APIs
        try {
            delete $2517639fe7937dbe$var$NativePromisePrototype.constructor;
        } catch (error) {}
        // make `instanceof Promise` work for native promise-based APIs
        if ($7c99bf1a4ca8c337$exports) $7c99bf1a4ca8c337$exports($2517639fe7937dbe$var$NativePromisePrototype, $2517639fe7937dbe$var$PromisePrototype);
    }
}
// `Promise` constructor
// https://tc39.es/ecma262/#sec-promise-executor
$244155c096ef4c14$exports({
    global: true,
    constructor: true,
    wrap: true,
    forced: $2517639fe7937dbe$var$FORCED_PROMISE_CONSTRUCTOR
}, {
    Promise: $2517639fe7937dbe$var$PromiseConstructor
});
$2517639fe7937dbe$var$PromiseWrapper = $d2336b2aa2640a45$exports.Promise;
$54a3ba2fb7b04ac0$exports($2517639fe7937dbe$var$PromiseConstructor, $2517639fe7937dbe$var$PROMISE, false, true);
$2eb70ff7aa9594a1$exports($2517639fe7937dbe$var$PROMISE);


'use strict';






var $d4e84a9fce7c06f3$exports = {};
'use strict';



var $d4e84a9fce7c06f3$require$FORCED_PROMISE_CONSTRUCTOR = $ba7078e301a2ff3f$exports.CONSTRUCTOR;
$d4e84a9fce7c06f3$exports = $d4e84a9fce7c06f3$require$FORCED_PROMISE_CONSTRUCTOR || !$d1cf75d632965c8c$exports(function(iterable) {
    $6cfa87e8b8fcfae8$exports.all(iterable).then(undefined, function() {});
});


// `Promise.all` method
// https://tc39.es/ecma262/#sec-promise.all
$244155c096ef4c14$exports({
    target: 'Promise',
    stat: true,
    forced: $d4e84a9fce7c06f3$exports
}, {
    all: function all(iterable) {
        var C = this;
        var capability = $883973452f6e32b5$export$2d1720544b23b823(C);
        var resolve = capability.resolve;
        var reject = capability.reject;
        var result = $9218597321bed915$exports(function() {
            var $promiseResolve = $082fcaa0a091ee30$exports(C.resolve);
            var values = [];
            var counter = 0;
            var remaining = 1;
            $ec8a9e5ef0653b51$exports(iterable, function(promise) {
                var index = counter++;
                var alreadyCalled = false;
                remaining++;
                $59bf80837927ca02$exports($promiseResolve, C, promise).then(function(value) {
                    if (alreadyCalled) return;
                    alreadyCalled = true;
                    values[index] = value;
                    --remaining || resolve(values);
                }, reject);
            });
            --remaining || resolve(values);
        });
        if (result.error) reject(result.value);
        return capability.promise;
    }
});


'use strict';



var $de9f9cc03b82cbce$require$FORCED_PROMISE_CONSTRUCTOR = $ba7078e301a2ff3f$exports.CONSTRUCTOR;




var $de9f9cc03b82cbce$var$NativePromisePrototype = $6cfa87e8b8fcfae8$exports && $6cfa87e8b8fcfae8$exports.prototype;
// `Promise.prototype.catch` method
// https://tc39.es/ecma262/#sec-promise.prototype.catch
$244155c096ef4c14$exports({
    target: 'Promise',
    proto: true,
    forced: $de9f9cc03b82cbce$require$FORCED_PROMISE_CONSTRUCTOR,
    real: true
}, {
    'catch': function(onRejected) {
        return this.then(undefined, onRejected);
    }
});
// makes sure that native promise-based APIs `Promise#catch` properly works with patched `Promise#then`
if (!$a4b83f418a8da28e$exports && $7c165f740ca92c53$exports($6cfa87e8b8fcfae8$exports)) {
    var $de9f9cc03b82cbce$var$method = $e8972ff3cf85d361$exports('Promise').prototype['catch'];
    if ($de9f9cc03b82cbce$var$NativePromisePrototype['catch'] !== $de9f9cc03b82cbce$var$method) $73c8864ae5df5c4d$exports($de9f9cc03b82cbce$var$NativePromisePrototype, 'catch', $de9f9cc03b82cbce$var$method, {
        unsafe: true
    });
}


'use strict';







// `Promise.race` method
// https://tc39.es/ecma262/#sec-promise.race
$244155c096ef4c14$exports({
    target: 'Promise',
    stat: true,
    forced: $d4e84a9fce7c06f3$exports
}, {
    race: function race(iterable) {
        var C = this;
        var capability = $883973452f6e32b5$export$2d1720544b23b823(C);
        var reject = capability.reject;
        var result = $9218597321bed915$exports(function() {
            var $promiseResolve = $082fcaa0a091ee30$exports(C.resolve);
            $ec8a9e5ef0653b51$exports(iterable, function(promise) {
                $59bf80837927ca02$exports($promiseResolve, C, promise).then(capability.resolve, reject);
            });
        });
        if (result.error) reject(result.value);
        return capability.promise;
    }
});


'use strict';



var $23e1240316986a61$require$FORCED_PROMISE_CONSTRUCTOR = $ba7078e301a2ff3f$exports.CONSTRUCTOR;
// `Promise.reject` method
// https://tc39.es/ecma262/#sec-promise.reject
$244155c096ef4c14$exports({
    target: 'Promise',
    stat: true,
    forced: $23e1240316986a61$require$FORCED_PROMISE_CONSTRUCTOR
}, {
    reject: function reject(r) {
        var capability = $883973452f6e32b5$export$2d1720544b23b823(this);
        var capabilityReject = capability.reject;
        capabilityReject(r);
        return capability.promise;
    }
});


'use strict';





var $cc6e50a1782a1b36$require$FORCED_PROMISE_CONSTRUCTOR = $ba7078e301a2ff3f$exports.CONSTRUCTOR;
var $e63d2b5181229eeb$exports = {};
'use strict';



$e63d2b5181229eeb$exports = function(C, x) {
    $7d9b9f0a2a7e34a2$exports(C);
    if ($4d7f82f6c4645870$exports(x) && x.constructor === C) return x;
    var promiseCapability = $883973452f6e32b5$export$2d1720544b23b823(C);
    var resolve = promiseCapability.resolve;
    resolve(x);
    return promiseCapability.promise;
};


var $cc6e50a1782a1b36$var$PromiseConstructorWrapper = $e8972ff3cf85d361$exports('Promise');
var $cc6e50a1782a1b36$var$CHECK_WRAPPER = $a4b83f418a8da28e$exports && !$cc6e50a1782a1b36$require$FORCED_PROMISE_CONSTRUCTOR;
// `Promise.resolve` method
// https://tc39.es/ecma262/#sec-promise.resolve
$244155c096ef4c14$exports({
    target: 'Promise',
    stat: true,
    forced: $a4b83f418a8da28e$exports || $cc6e50a1782a1b36$require$FORCED_PROMISE_CONSTRUCTOR
}, {
    resolve: function resolve(x) {
        return $e63d2b5181229eeb$exports($cc6e50a1782a1b36$var$CHECK_WRAPPER && this === $cc6e50a1782a1b36$var$PromiseConstructorWrapper ? $6cfa87e8b8fcfae8$exports : this, x);
    }
});




'use strict';









var $af2442c928e4d18d$var$NativePromisePrototype = $6cfa87e8b8fcfae8$exports && $6cfa87e8b8fcfae8$exports.prototype;
// Safari bug https://bugs.webkit.org/show_bug.cgi?id=200829
var $af2442c928e4d18d$var$NON_GENERIC = !!$6cfa87e8b8fcfae8$exports && $ddd8e9441ae136f2$exports(function() {
    // eslint-disable-next-line unicorn/no-thenable -- required for testing
    $af2442c928e4d18d$var$NativePromisePrototype['finally'].call({
        then: function then() {}
    }, function() {});
});
// `Promise.prototype.finally` method
// https://tc39.es/ecma262/#sec-promise.prototype.finally
$244155c096ef4c14$exports({
    target: 'Promise',
    proto: true,
    real: true,
    forced: $af2442c928e4d18d$var$NON_GENERIC
}, {
    'finally': function(onFinally) {
        var C = $530f9e30acde7c4a$exports(this, $e8972ff3cf85d361$exports('Promise'));
        var isFunction = $7c165f740ca92c53$exports(onFinally);
        return this.then(isFunction ? function(x) {
            return $e63d2b5181229eeb$exports(C, onFinally()).then(function() {
                return x;
            });
        } : onFinally, isFunction ? function(e) {
            return $e63d2b5181229eeb$exports(C, onFinally()).then(function() {
                throw e;
            });
        } : onFinally);
    }
});
// makes sure that native promise-based APIs `Promise#finally` properly works with patched `Promise#then`
if (!$a4b83f418a8da28e$exports && $7c165f740ca92c53$exports($6cfa87e8b8fcfae8$exports)) {
    var $af2442c928e4d18d$var$method = $e8972ff3cf85d361$exports('Promise').prototype['finally'];
    if ($af2442c928e4d18d$var$NativePromisePrototype['finally'] !== $af2442c928e4d18d$var$method) $73c8864ae5df5c4d$exports($af2442c928e4d18d$var$NativePromisePrototype, 'finally', $af2442c928e4d18d$var$method, {
        unsafe: true
    });
}


'use strict';





// MS Edge argumentsList argument is optional
var $383013185f305088$var$OPTIONAL_ARGUMENTS_LIST = !$ddd8e9441ae136f2$exports(function() {
    // eslint-disable-next-line es/no-reflect -- required for testing
    Reflect.apply(function() {});
});
// `Reflect.apply` method
// https://tc39.es/ecma262/#sec-reflect.apply
$244155c096ef4c14$exports({
    target: 'Reflect',
    stat: true,
    forced: $383013185f305088$var$OPTIONAL_ARGUMENTS_LIST
}, {
    apply: function apply(target, thisArgument, argumentsList) {
        return $eb64554a295b6978$exports($082fcaa0a091ee30$exports(target), thisArgument, $7d9b9f0a2a7e34a2$exports(argumentsList));
    }
});


'use strict';



var $b9ad28de9e835c5c$exports = {};
'use strict';






var $b9ad28de9e835c5c$var$$Function = Function;
var $b9ad28de9e835c5c$var$concat = $c224a7eda28c33b3$exports([].concat);
var $b9ad28de9e835c5c$var$join = $c224a7eda28c33b3$exports([].join);
var $b9ad28de9e835c5c$var$factories = {};
var $b9ad28de9e835c5c$var$construct = function construct(C, argsLength, args) {
    if (!$8bbc2bccc0a29296$exports($b9ad28de9e835c5c$var$factories, argsLength)) {
        var list = [];
        var i = 0;
        for(; i < argsLength; i++)list[i] = 'a[' + i + ']';
        $b9ad28de9e835c5c$var$factories[argsLength] = $b9ad28de9e835c5c$var$$Function('C,a', 'return new C(' + $b9ad28de9e835c5c$var$join(list, ',') + ')');
    }
    return $b9ad28de9e835c5c$var$factories[argsLength](C, args);
};
// `Function.prototype.bind` method implementation
// https://tc39.es/ecma262/#sec-function.prototype.bind
// eslint-disable-next-line es/no-function-prototype-bind -- detection
$b9ad28de9e835c5c$exports = $37d783b2348274b4$exports ? $b9ad28de9e835c5c$var$$Function.bind : function bind(that /* , ...args */ ) {
    var F = $082fcaa0a091ee30$exports(this);
    var Prototype = F.prototype;
    var partArgs = $2dd14968e62d6eb1$exports(arguments, 1);
    var boundFunction = function bound() {
        var args = $b9ad28de9e835c5c$var$concat(partArgs, $2dd14968e62d6eb1$exports(arguments));
        return this instanceof boundFunction ? $b9ad28de9e835c5c$var$construct(F, args.length, args) : F.apply(that, args);
    };
    if ($4d7f82f6c4645870$exports(Prototype)) boundFunction.prototype = Prototype;
    return boundFunction;
};







var $d701e62acdafe68b$var$nativeConstruct = $e8972ff3cf85d361$exports('Reflect', 'construct');
var $d701e62acdafe68b$var$ObjectPrototype = Object.prototype;
var $d701e62acdafe68b$var$push = [].push;
// `Reflect.construct` method
// https://tc39.es/ecma262/#sec-reflect.construct
// MS Edge supports only 2 arguments and argumentsList argument is optional
// FF Nightly sets third argument as `new.target`, but does not create `this` from it
var $d701e62acdafe68b$var$NEW_TARGET_BUG = $ddd8e9441ae136f2$exports(function() {
    function F() {}
    return !($d701e62acdafe68b$var$nativeConstruct(function() {}, [], F) instanceof F);
});
var $d701e62acdafe68b$var$ARGS_BUG = !$ddd8e9441ae136f2$exports(function() {
    $d701e62acdafe68b$var$nativeConstruct(function() {});
});
var $d701e62acdafe68b$var$FORCED = $d701e62acdafe68b$var$NEW_TARGET_BUG || $d701e62acdafe68b$var$ARGS_BUG;
$244155c096ef4c14$exports({
    target: 'Reflect',
    stat: true,
    forced: $d701e62acdafe68b$var$FORCED,
    sham: $d701e62acdafe68b$var$FORCED
}, {
    construct: function construct(Target, args /* , newTarget */ ) {
        $2208800311a8332a$exports(Target);
        var newTarget = arguments.length < 3 ? Target : $2208800311a8332a$exports(arguments[2]);
        $7d9b9f0a2a7e34a2$exports(args);
        if ($d701e62acdafe68b$var$ARGS_BUG && !$d701e62acdafe68b$var$NEW_TARGET_BUG) return $d701e62acdafe68b$var$nativeConstruct(Target, args, newTarget);
        if (Target === newTarget) {
            // w/o altered newTarget, optimization for 0-4 arguments
            switch(args.length){
                case 0:
                    return new Target();
                case 1:
                    return new Target(args[0]);
                case 2:
                    return new Target(args[0], args[1]);
                case 3:
                    return new Target(args[0], args[1], args[2]);
                case 4:
                    return new Target(args[0], args[1], args[2], args[3]);
            }
            // w/o altered newTarget, lot of arguments case
            var $args = [
                null
            ];
            $eb64554a295b6978$exports($d701e62acdafe68b$var$push, $args, args);
            return new ($eb64554a295b6978$exports($b9ad28de9e835c5c$exports, Target, $args))();
        }
        // with altered newTarget, not support built-in constructors
        var proto = newTarget.prototype;
        var instance = $491a5d5aa2efe6ec$exports($4d7f82f6c4645870$exports(proto) ? proto : $d701e62acdafe68b$var$ObjectPrototype);
        var result = $eb64554a295b6978$exports(Target, instance, args);
        return $4d7f82f6c4645870$exports(result) ? result : instance;
    }
});


'use strict';







var $089617c0b88f2346$var$$TypeError = TypeError;
// MS Edge has broken Reflect.defineProperty - throwing instead of returning false
var $089617c0b88f2346$var$ERROR_INSTEAD_OF_FALSE = $ddd8e9441ae136f2$exports(function() {
    // eslint-disable-next-line es/no-reflect -- required for testing
    Reflect.defineProperty($6f9fc35f567fa5b6$export$2d1720544b23b823({}, 1, {
        value: 1
    }), 1, {
        value: 2
    });
});
// `Reflect.defineProperty` method
// https://tc39.es/ecma262/#sec-reflect.defineproperty
$244155c096ef4c14$exports({
    target: 'Reflect',
    stat: true,
    forced: $089617c0b88f2346$var$ERROR_INSTEAD_OF_FALSE,
    sham: !$b9f536d3284d7921$exports
}, {
    defineProperty: function defineProperty(target, propertyKey, attributes) {
        $7d9b9f0a2a7e34a2$exports(target);
        var key = $d9a9cf8e89852c56$exports(propertyKey);
        var get, set;
        $7d9b9f0a2a7e34a2$exports(attributes);
        // propagate `ToPropertyDescriptor` errors instead of catching them
        if (('get' in attributes || 'set' in attributes) && ('get' in attributes && !$7c165f740ca92c53$exports(get = attributes.get) && get !== undefined || 'set' in attributes && !$7c165f740ca92c53$exports(set = attributes.set) && set !== undefined || 'value' in attributes || 'writable' in attributes)) throw new $089617c0b88f2346$var$$TypeError('Invalid property descriptor');
        try {
            $6f9fc35f567fa5b6$export$2d1720544b23b823(target, key, attributes);
            return true;
        } catch (error) {
            return false;
        }
    }
});


'use strict';



var $0bc5c17b54c099b7$require$getOwnPropertyDescriptor = $70871da05e9d21bf$export$2d1720544b23b823;

// `Reflect.deleteProperty` method
// https://tc39.es/ecma262/#sec-reflect.deleteproperty
$244155c096ef4c14$exports({
    target: 'Reflect',
    stat: true
}, {
    deleteProperty: function deleteProperty(target, propertyKey) {
        $7d9b9f0a2a7e34a2$exports(target);
        var key = $d9a9cf8e89852c56$exports(propertyKey);
        var descriptor = $0bc5c17b54c099b7$require$getOwnPropertyDescriptor(target, key);
        return descriptor && !descriptor.configurable ? false : delete target[key];
    }
});


'use strict';




var $37a1234200724e55$exports = {};
'use strict';

$37a1234200724e55$exports = function(descriptor) {
    return descriptor !== undefined && ($8bbc2bccc0a29296$exports(descriptor, 'value') || $8bbc2bccc0a29296$exports(descriptor, 'writable'));
};





// `Reflect.get` method
// https://tc39.es/ecma262/#sec-reflect.get
var $1a9c6efd0efb2bbf$var$$get = function $get1(target, propertyKey, receiver) {
    if ($7d9b9f0a2a7e34a2$exports(target) === receiver) return target[propertyKey];
    var descriptor = $70871da05e9d21bf$export$2d1720544b23b823(target, propertyKey);
    if (descriptor) return $37a1234200724e55$exports(descriptor) ? descriptor.value : descriptor.get === undefined ? undefined : $59bf80837927ca02$exports(descriptor.get, receiver);
    var prototype = $5f455f1b83f2c610$exports(target);
    if ($4d7f82f6c4645870$exports(prototype)) return $1a9c6efd0efb2bbf$var$$get(prototype, propertyKey, receiver);
};
$244155c096ef4c14$exports({
    target: 'Reflect',
    stat: true
}, {
    get: function get(target, propertyKey /* , receiver */ ) {
        return $1a9c6efd0efb2bbf$var$$get($7d9b9f0a2a7e34a2$exports(target), $d9a9cf8e89852c56$exports(propertyKey), arguments.length < 3 ? target : arguments[2]);
    }
});


'use strict';




// `Reflect.getOwnPropertyDescriptor` method
// https://tc39.es/ecma262/#sec-reflect.getownpropertydescriptor
$244155c096ef4c14$exports({
    target: 'Reflect',
    stat: true,
    sham: !$b9f536d3284d7921$exports
}, {
    getOwnPropertyDescriptor: function getOwnPropertyDescriptor(target, propertyKey) {
        return $70871da05e9d21bf$export$2d1720544b23b823($7d9b9f0a2a7e34a2$exports(target), propertyKey);
    }
});


'use strict';




// `Reflect.getPrototypeOf` method
// https://tc39.es/ecma262/#sec-reflect.getprototypeof
$244155c096ef4c14$exports({
    target: 'Reflect',
    stat: true,
    sham: !$1e9a79416b0401f6$exports
}, {
    getPrototypeOf: function getPrototypeOf(target) {
        return $5f455f1b83f2c610$exports($7d9b9f0a2a7e34a2$exports(target));
    }
});


'use strict';

// `Reflect.has` method
// https://tc39.es/ecma262/#sec-reflect.has
$244155c096ef4c14$exports({
    target: 'Reflect',
    stat: true
}, {
    has: function has(target, propertyKey) {
        return propertyKey in target;
    }
});


'use strict';



// `Reflect.isExtensible` method
// https://tc39.es/ecma262/#sec-reflect.isextensible
$244155c096ef4c14$exports({
    target: 'Reflect',
    stat: true
}, {
    isExtensible: function isExtensible(target) {
        $7d9b9f0a2a7e34a2$exports(target);
        return $77d1f8899c709e1b$exports(target);
    }
});


'use strict';


// `Reflect.ownKeys` method
// https://tc39.es/ecma262/#sec-reflect.ownkeys
$244155c096ef4c14$exports({
    target: 'Reflect',
    stat: true
}, {
    ownKeys: $f90a310de5bd21d5$exports
});


'use strict';




// `Reflect.preventExtensions` method
// https://tc39.es/ecma262/#sec-reflect.preventextensions
$244155c096ef4c14$exports({
    target: 'Reflect',
    stat: true,
    sham: !$323042bd7ad218cd$exports
}, {
    preventExtensions: function preventExtensions(target) {
        $7d9b9f0a2a7e34a2$exports(target);
        try {
            var objectPreventExtensions = $e8972ff3cf85d361$exports('Object', 'preventExtensions');
            if (objectPreventExtensions) objectPreventExtensions(target);
            return true;
        } catch (error) {
            return false;
        }
    }
});


'use strict';











// `Reflect.set` method
// https://tc39.es/ecma262/#sec-reflect.set
var $bcf3455ea884f6c2$var$$set = function $set1(target, propertyKey, V, receiver) {
    var ownDescriptor = $70871da05e9d21bf$export$2d1720544b23b823($7d9b9f0a2a7e34a2$exports(target), propertyKey);
    var existingDescriptor, prototype, setter;
    if (!ownDescriptor) {
        if ($4d7f82f6c4645870$exports(prototype = $5f455f1b83f2c610$exports(target))) return $bcf3455ea884f6c2$var$$set(prototype, propertyKey, V, receiver);
        ownDescriptor = $27c455d39660edb8$exports(0);
    }
    if ($37a1234200724e55$exports(ownDescriptor)) {
        if (ownDescriptor.writable === false || !$4d7f82f6c4645870$exports(receiver)) return false;
        if (existingDescriptor = $70871da05e9d21bf$export$2d1720544b23b823(receiver, propertyKey)) {
            if (!$37a1234200724e55$exports(existingDescriptor) || existingDescriptor.writable === false) return false;
            $6f9fc35f567fa5b6$export$2d1720544b23b823(receiver, propertyKey, {
                value: V
            });
        } else try {
            $6f9fc35f567fa5b6$export$2d1720544b23b823(receiver, propertyKey, $27c455d39660edb8$exports(0, V));
        } catch (error) {
            return false;
        }
    } else {
        setter = ownDescriptor.set;
        if (setter === undefined) return false;
        $59bf80837927ca02$exports(setter, receiver, V);
    }
    return true;
};
// MS Edge 17-18 Reflect.set allows setting the property to object
// with non-writable property on the prototype
var $bcf3455ea884f6c2$var$MS_EDGE_BUG = $ddd8e9441ae136f2$exports(function() {
    var Constructor = function Constructor() {};
    var object = $6f9fc35f567fa5b6$export$2d1720544b23b823(new Constructor(), 'a', {
        configurable: true
    });
    // eslint-disable-next-line es/no-reflect -- required for testing
    return Reflect.set(Constructor.prototype, 'a', 1, object) !== false;
});
$244155c096ef4c14$exports({
    target: 'Reflect',
    stat: true,
    forced: $bcf3455ea884f6c2$var$MS_EDGE_BUG
}, {
    set: function set(target, propertyKey, V /* , receiver */ ) {
        return $bcf3455ea884f6c2$var$$set($7d9b9f0a2a7e34a2$exports(target), $d9a9cf8e89852c56$exports(propertyKey), V, arguments.length < 4 ? target : arguments[3]);
    }
});


'use strict';




// `Reflect.setPrototypeOf` method
// https://tc39.es/ecma262/#sec-reflect.setprototypeof
if ($7c99bf1a4ca8c337$exports) $244155c096ef4c14$exports({
    target: 'Reflect',
    stat: true
}, {
    setPrototypeOf: function setPrototypeOf(target, proto) {
        $7d9b9f0a2a7e34a2$exports(target);
        $b69919998c60f16d$exports(proto);
        try {
            $7c99bf1a4ca8c337$exports(target, proto);
            return true;
        } catch (error) {
            return false;
        }
    }
});


'use strict';








var $db32490e032e76bb$require$getOwnPropertyNames = $8b92903d5cdf859e$export$2d1720544b23b823;

var $6589e3318847d9df$exports = {};
'use strict';



var $6589e3318847d9df$var$MATCH = $8555fb22f74da29f$exports('match');
// `IsRegExp` abstract operation
// https://tc39.es/ecma262/#sec-isregexp
$6589e3318847d9df$exports = function(it) {
    var isRegExp;
    return $4d7f82f6c4645870$exports(it) && ((isRegExp = it[$6589e3318847d9df$var$MATCH]) !== undefined ? !!isRegExp : $5a266b01e7970e30$exports(it) === 'RegExp');
};



var $7429fd641fff63d4$exports = {};
'use strict';



var $7c168e28f8227963$exports = {};
'use strict';


// babel-minify and Closure Compiler transpiles RegExp('.', 'd') -> /./d and it causes SyntaxError
var $7c168e28f8227963$var$RegExp = $27350b6a9e85aed1$exports.RegExp;
var $7c168e28f8227963$var$FLAGS_GETTER_IS_CORRECT = !$ddd8e9441ae136f2$exports(function() {
    var INDICES_SUPPORT = true;
    try {
        $7c168e28f8227963$var$RegExp('.', 'd');
    } catch (error) {
        INDICES_SUPPORT = false;
    }
    var O = {};
    // modern V8 bug
    var calls = '';
    var expected = INDICES_SUPPORT ? 'dgimsy' : 'gimsy';
    var addGetter = function addGetter(key, chr) {
        // eslint-disable-next-line es/no-object-defineproperty -- safe
        Object.defineProperty(O, key, {
            get: function get() {
                calls += chr;
                return true;
            }
        });
    };
    var pairs = {
        dotAll: 's',
        global: 'g',
        ignoreCase: 'i',
        multiline: 'm',
        sticky: 'y'
    };
    if (INDICES_SUPPORT) pairs.hasIndices = 'd';
    for(var key in pairs)addGetter(key, pairs[key]);
    // eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
    var result = Object.getOwnPropertyDescriptor($7c168e28f8227963$var$RegExp.prototype, 'flags').get.call(O);
    return result !== expected || calls !== expected;
});
$7c168e28f8227963$exports = {
    correct: $7c168e28f8227963$var$FLAGS_GETTER_IS_CORRECT
};


var $a814d9bd91cc8bb0$exports = {};
'use strict';

// `RegExp.prototype.flags` getter implementation
// https://tc39.es/ecma262/#sec-get-regexp.prototype.flags
$a814d9bd91cc8bb0$exports = function() {
    var that = $7d9b9f0a2a7e34a2$exports(this);
    var result = '';
    if (that.hasIndices) result += 'd';
    if (that.global) result += 'g';
    if (that.ignoreCase) result += 'i';
    if (that.multiline) result += 'm';
    if (that.dotAll) result += 's';
    if (that.unicode) result += 'u';
    if (that.unicodeSets) result += 'v';
    if (that.sticky) result += 'y';
    return result;
};


var $7429fd641fff63d4$var$RegExpPrototype = RegExp.prototype;
$7429fd641fff63d4$exports = $7c168e28f8227963$exports.correct ? function(it) {
    return it.flags;
} : function(it) {
    return !$7c168e28f8227963$exports.correct && $5c91390ffea610b9$exports($7429fd641fff63d4$var$RegExpPrototype, it) && !$8bbc2bccc0a29296$exports(it, 'flags') ? $59bf80837927ca02$exports($a814d9bd91cc8bb0$exports, it) : it.flags;
};


var $67a817e7885ccc52$exports = {};
'use strict';


// babel-minify and Closure Compiler transpiles RegExp('a', 'y') -> /a/y and it causes SyntaxError
var $67a817e7885ccc52$var$$RegExp = $27350b6a9e85aed1$exports.RegExp;
var $67a817e7885ccc52$var$UNSUPPORTED_Y = $ddd8e9441ae136f2$exports(function() {
    var re = $67a817e7885ccc52$var$$RegExp('a', 'y');
    re.lastIndex = 2;
    return re.exec('abcd') !== null;
});
// UC Browser bug
// https://github.com/zloirock/core-js/issues/1008
var $67a817e7885ccc52$var$MISSED_STICKY = $67a817e7885ccc52$var$UNSUPPORTED_Y || $ddd8e9441ae136f2$exports(function() {
    return !$67a817e7885ccc52$var$$RegExp('a', 'y').sticky;
});
var $67a817e7885ccc52$var$BROKEN_CARET = $67a817e7885ccc52$var$UNSUPPORTED_Y || $ddd8e9441ae136f2$exports(function() {
    // https://bugzilla.mozilla.org/show_bug.cgi?id=773687
    var re = $67a817e7885ccc52$var$$RegExp('^r', 'gy');
    re.lastIndex = 2;
    return re.exec('str') !== null;
});
$67a817e7885ccc52$exports = {
    BROKEN_CARET: $67a817e7885ccc52$var$BROKEN_CARET,
    MISSED_STICKY: $67a817e7885ccc52$var$MISSED_STICKY,
    UNSUPPORTED_Y: $67a817e7885ccc52$var$UNSUPPORTED_Y
};


var $1894edece163f08d$exports = {};
'use strict';

var $1894edece163f08d$require$defineProperty = $6f9fc35f567fa5b6$export$2d1720544b23b823;
$1894edece163f08d$exports = function(Target, Source, key) {
    key in Target || $1894edece163f08d$require$defineProperty(Target, key, {
        configurable: true,
        get: function get() {
            return Source[key];
        },
        set: function set(it) {
            Source[key] = it;
        }
    });
};






var $db32490e032e76bb$require$enforceInternalState = $fcfe8b5396fbe91a$exports.enforce;


var $ba9a82a714b7e70e$exports = {};
'use strict';


// babel-minify and Closure Compiler transpiles RegExp('.', 's') -> /./s and it causes SyntaxError
var $ba9a82a714b7e70e$var$$RegExp = $27350b6a9e85aed1$exports.RegExp;
$ba9a82a714b7e70e$exports = $ddd8e9441ae136f2$exports(function() {
    var re = $ba9a82a714b7e70e$var$$RegExp('.', 's');
    return !(re.dotAll && re.test('\n') && re.flags === 's');
});


var $0227b2d5472f748e$exports = {};
'use strict';


// babel-minify and Closure Compiler transpiles RegExp('(?<a>b)', 'g') -> /(?<a>b)/g and it causes SyntaxError
var $0227b2d5472f748e$var$$RegExp = $27350b6a9e85aed1$exports.RegExp;
$0227b2d5472f748e$exports = $ddd8e9441ae136f2$exports(function() {
    var re = $0227b2d5472f748e$var$$RegExp('(?<a>b)', 'g');
    return re.exec('b').groups.a !== 'b' || 'b'.replace(re, '$<a>c') !== 'bc';
});


var $db32490e032e76bb$var$MATCH = $8555fb22f74da29f$exports('match');
var $db32490e032e76bb$var$NativeRegExp = $27350b6a9e85aed1$exports.RegExp;
var $db32490e032e76bb$var$RegExpPrototype = $db32490e032e76bb$var$NativeRegExp.prototype;
var $db32490e032e76bb$var$SyntaxError = $27350b6a9e85aed1$exports.SyntaxError;
var $db32490e032e76bb$var$exec = $c224a7eda28c33b3$exports($db32490e032e76bb$var$RegExpPrototype.exec);
var $db32490e032e76bb$var$charAt = $c224a7eda28c33b3$exports(''.charAt);
var $db32490e032e76bb$var$replace = $c224a7eda28c33b3$exports(''.replace);
var $db32490e032e76bb$var$stringIndexOf = $c224a7eda28c33b3$exports(''.indexOf);
var $db32490e032e76bb$var$stringSlice = $c224a7eda28c33b3$exports(''.slice);
// TODO: Use only proper RegExpIdentifierName
var $db32490e032e76bb$var$IS_NCG = /^\?<[^\s\d!#%&*+<=>@^][^\s!#%&*+<=>@^]*>/;
var $db32490e032e76bb$var$re1 = /a/g;
var $db32490e032e76bb$var$re2 = /a/g;
// "new" should create a new object, old webkit bug
var $db32490e032e76bb$var$CORRECT_NEW = new $db32490e032e76bb$var$NativeRegExp($db32490e032e76bb$var$re1) !== $db32490e032e76bb$var$re1;
var $db32490e032e76bb$var$MISSED_STICKY = $67a817e7885ccc52$exports.MISSED_STICKY;
var $db32490e032e76bb$var$UNSUPPORTED_Y = $67a817e7885ccc52$exports.UNSUPPORTED_Y;
var $db32490e032e76bb$var$BASE_FORCED = $b9f536d3284d7921$exports && (!$db32490e032e76bb$var$CORRECT_NEW || $db32490e032e76bb$var$MISSED_STICKY || $ba9a82a714b7e70e$exports || $0227b2d5472f748e$exports || $ddd8e9441ae136f2$exports(function() {
    $db32490e032e76bb$var$re2[$db32490e032e76bb$var$MATCH] = false;
    // RegExp constructor can alter flags and IsRegExp works correct with @@match
    // eslint-disable-next-line sonarjs/inconsistent-function-call -- required for testing
    return $db32490e032e76bb$var$NativeRegExp($db32490e032e76bb$var$re1) !== $db32490e032e76bb$var$re1 || $db32490e032e76bb$var$NativeRegExp($db32490e032e76bb$var$re2) === $db32490e032e76bb$var$re2 || String($db32490e032e76bb$var$NativeRegExp($db32490e032e76bb$var$re1, 'i')) !== '/a/i';
}));
var $db32490e032e76bb$var$handleDotAll = function handleDotAll(string) {
    var length = string.length;
    var index = 0;
    var result = '';
    var brackets = false;
    var chr;
    for(; index < length; index++){
        chr = $db32490e032e76bb$var$charAt(string, index);
        if (chr === '\\') {
            result += chr + $db32490e032e76bb$var$charAt(string, ++index);
            continue;
        }
        if (!brackets && chr === '.') result += '[\\s\\S]';
        else {
            if (chr === '[') brackets = true;
            else if (chr === ']') brackets = false;
            result += chr;
        }
    }
    return result;
};
var $db32490e032e76bb$var$handleNCG = function handleNCG(string) {
    var length = string.length;
    var index = 0;
    var result = '';
    var named = [];
    var names = $491a5d5aa2efe6ec$exports(null);
    var brackets = false;
    var ncg = false;
    var groupid = 0;
    var groupname = '';
    var chr;
    for(; index < length; index++){
        chr = $db32490e032e76bb$var$charAt(string, index);
        if (chr === '\\') {
            chr += $db32490e032e76bb$var$charAt(string, ++index);
            // use `\x5c` for escaped backslash to avoid corruption by `\k<name>` to `\N` replacement below
            if (!ncg && $db32490e032e76bb$var$charAt(chr, 1) === '\\') {
                result += '\\x5c';
                continue;
            }
        } else if (chr === ']') brackets = false;
        else if (!brackets) switch(true){
            case chr === '[':
                brackets = true;
                break;
            case chr === '(':
                result += chr;
                if ($db32490e032e76bb$var$exec($db32490e032e76bb$var$IS_NCG, $db32490e032e76bb$var$stringSlice(string, index + 1))) {
                    index += 2;
                    ncg = true;
                    groupid++;
                } else if ($db32490e032e76bb$var$charAt(string, index + 1) !== '?') groupid++;
                continue;
            case chr === '>' && ncg:
                if (groupname === '' || $8bbc2bccc0a29296$exports(names, groupname)) throw new $db32490e032e76bb$var$SyntaxError('Invalid capture group name');
                names[groupname] = true;
                named[named.length] = [
                    groupname,
                    groupid
                ];
                ncg = false;
                groupname = '';
                continue;
        }
        if (ncg) groupname += chr;
        else result += chr;
    }
    // convert `\k<name>` backreferences to numbered backreferences
    for(var ni = 0; ni < named.length; ni++){
        var backref = '\\k<' + named[ni][0] + '>';
        var numRef = '\\' + named[ni][1];
        while($db32490e032e76bb$var$stringIndexOf(result, backref) > -1)result = $db32490e032e76bb$var$replace(result, backref, numRef);
    }
    return [
        result,
        named
    ];
};
// `RegExp` constructor
// https://tc39.es/ecma262/#sec-regexp-constructor
if ($0ae261ce45c3c073$exports('RegExp', $db32490e032e76bb$var$BASE_FORCED)) {
    var $db32490e032e76bb$var$RegExpWrapper = function RegExp(pattern, flags) {
        var thisIsRegExp = $5c91390ffea610b9$exports($db32490e032e76bb$var$RegExpPrototype, this);
        var patternIsRegExp = $6589e3318847d9df$exports(pattern);
        var flagsAreUndefined = flags === undefined;
        var groups = [];
        var rawPattern = pattern;
        var rawFlags, dotAll, sticky, handled, result, state;
        if (!thisIsRegExp && patternIsRegExp && flagsAreUndefined && pattern.constructor === $db32490e032e76bb$var$RegExpWrapper) return pattern;
        if (patternIsRegExp || $5c91390ffea610b9$exports($db32490e032e76bb$var$RegExpPrototype, pattern)) {
            pattern = pattern.source;
            if (flagsAreUndefined) flags = $7429fd641fff63d4$exports(rawPattern);
        }
        pattern = pattern === undefined ? '' : $7c610b7ee22557b5$exports(pattern);
        flags = flags === undefined ? '' : $7c610b7ee22557b5$exports(flags);
        rawPattern = pattern;
        if ($ba9a82a714b7e70e$exports && 'dotAll' in $db32490e032e76bb$var$re1) {
            dotAll = !!flags && $db32490e032e76bb$var$stringIndexOf(flags, 's') > -1;
            if (dotAll) flags = $db32490e032e76bb$var$replace(flags, /s/g, '');
        }
        rawFlags = flags;
        if ($db32490e032e76bb$var$MISSED_STICKY && 'sticky' in $db32490e032e76bb$var$re1) {
            sticky = !!flags && $db32490e032e76bb$var$stringIndexOf(flags, 'y') > -1;
            if (sticky && $db32490e032e76bb$var$UNSUPPORTED_Y) flags = $db32490e032e76bb$var$replace(flags, /y/g, '');
        }
        if ($0227b2d5472f748e$exports) {
            handled = $db32490e032e76bb$var$handleNCG(pattern);
            pattern = handled[0];
            groups = handled[1];
        }
        result = $834423bfd6526b45$exports($db32490e032e76bb$var$NativeRegExp(pattern, flags), thisIsRegExp ? this : $db32490e032e76bb$var$RegExpPrototype, $db32490e032e76bb$var$RegExpWrapper);
        if (dotAll || sticky || groups.length) {
            state = $db32490e032e76bb$require$enforceInternalState(result);
            if (dotAll) {
                state.dotAll = true;
                state.raw = $db32490e032e76bb$var$RegExpWrapper($db32490e032e76bb$var$handleDotAll(pattern), rawFlags);
            }
            if (sticky) state.sticky = true;
            if (groups.length) state.groups = groups;
        }
        if (pattern !== rawPattern) try {
            // fails in old engines, but we have no alternatives for unsupported regex syntax
            $b390530569770271$exports(result, 'source', rawPattern === '' ? '(?:)' : rawPattern);
        } catch (error) {}
        return result;
    };
    for(var $db32490e032e76bb$var$keys = $db32490e032e76bb$require$getOwnPropertyNames($db32490e032e76bb$var$NativeRegExp), $db32490e032e76bb$var$index = 0; $db32490e032e76bb$var$keys.length > $db32490e032e76bb$var$index;)$1894edece163f08d$exports($db32490e032e76bb$var$RegExpWrapper, $db32490e032e76bb$var$NativeRegExp, $db32490e032e76bb$var$keys[$db32490e032e76bb$var$index++]);
    $db32490e032e76bb$var$RegExpPrototype.constructor = $db32490e032e76bb$var$RegExpWrapper;
    $db32490e032e76bb$var$RegExpWrapper.prototype = $db32490e032e76bb$var$RegExpPrototype;
    $73c8864ae5df5c4d$exports($27350b6a9e85aed1$exports, 'RegExp', $db32490e032e76bb$var$RegExpWrapper, {
        constructor: true
    });
}
// https://tc39.es/ecma262/#sec-get-regexp-@@species
$2eb70ff7aa9594a1$exports('RegExp');


'use strict';

var $b0438fec261dae9a$exports = {};
'use strict';








var $b0438fec261dae9a$require$getInternalState = $fcfe8b5396fbe91a$exports.get;


var $b0438fec261dae9a$var$nativeReplace = $bf195d0f48f561ca$exports('native-string-replace', String.prototype.replace);
var $b0438fec261dae9a$var$nativeExec = RegExp.prototype.exec;
var $b0438fec261dae9a$var$patchedExec = $b0438fec261dae9a$var$nativeExec;
var $b0438fec261dae9a$var$charAt = $c224a7eda28c33b3$exports(''.charAt);
var $b0438fec261dae9a$var$indexOf = $c224a7eda28c33b3$exports(''.indexOf);
var $b0438fec261dae9a$var$replace = $c224a7eda28c33b3$exports(''.replace);
var $b0438fec261dae9a$var$stringSlice = $c224a7eda28c33b3$exports(''.slice);
var $b0438fec261dae9a$var$UPDATES_LAST_INDEX_WRONG = function() {
    var re1 = /a/;
    var re2 = /b*/g;
    $59bf80837927ca02$exports($b0438fec261dae9a$var$nativeExec, re1, 'a');
    $59bf80837927ca02$exports($b0438fec261dae9a$var$nativeExec, re2, 'a');
    return re1.lastIndex !== 0 || re2.lastIndex !== 0;
}();
var $b0438fec261dae9a$var$UNSUPPORTED_Y = $67a817e7885ccc52$exports.BROKEN_CARET;
// nonparticipating capturing group, copied from es5-shim's String#split patch.
var $b0438fec261dae9a$var$NPCG_INCLUDED = /()??/.exec('')[1] !== undefined;
var $b0438fec261dae9a$var$PATCH = $b0438fec261dae9a$var$UPDATES_LAST_INDEX_WRONG || $b0438fec261dae9a$var$NPCG_INCLUDED || $b0438fec261dae9a$var$UNSUPPORTED_Y || $ba9a82a714b7e70e$exports || $0227b2d5472f748e$exports;
var $b0438fec261dae9a$var$setGroups = function setGroups(re, groups) {
    var object = re.groups = $491a5d5aa2efe6ec$exports(null);
    for(var i = 0; i < groups.length; i++){
        var group = groups[i];
        object[group[0]] = re[group[1]];
    }
};
if ($b0438fec261dae9a$var$PATCH) $b0438fec261dae9a$var$patchedExec = function exec(string) {
    var re = this;
    var state = $b0438fec261dae9a$require$getInternalState(re);
    var str = $7c610b7ee22557b5$exports(string);
    var raw = state.raw;
    var result, reCopy, lastIndex;
    if (raw) {
        raw.lastIndex = re.lastIndex;
        result = $59bf80837927ca02$exports($b0438fec261dae9a$var$patchedExec, raw, str);
        re.lastIndex = raw.lastIndex;
        if (result && state.groups) $b0438fec261dae9a$var$setGroups(result, state.groups);
        return result;
    }
    var groups = state.groups;
    var sticky = $b0438fec261dae9a$var$UNSUPPORTED_Y && re.sticky;
    var flags = $59bf80837927ca02$exports($a814d9bd91cc8bb0$exports, re);
    var source = re.source;
    var charsAdded = 0;
    var strCopy = str;
    if (sticky) {
        flags = $b0438fec261dae9a$var$replace(flags, 'y', '');
        if ($b0438fec261dae9a$var$indexOf(flags, 'g') === -1) flags += 'g';
        strCopy = $b0438fec261dae9a$var$stringSlice(str, re.lastIndex);
        // Support anchored sticky behavior.
        var prevChar = re.lastIndex > 0 && $b0438fec261dae9a$var$charAt(str, re.lastIndex - 1);
        if (re.lastIndex > 0 && (!re.multiline || re.multiline && prevChar !== '\n' && prevChar !== '\r' && prevChar !== '\u2028' && prevChar !== '\u2029')) {
            source = '(?: (?:' + source + '))';
            strCopy = ' ' + strCopy;
            charsAdded++;
        }
        // ^(? + rx + ) is needed, in combination with some str slicing, to
        // simulate the 'y' flag.
        reCopy = new RegExp('^(?:' + source + ')', flags);
    }
    if ($b0438fec261dae9a$var$NPCG_INCLUDED) reCopy = new RegExp('^' + source + '$(?!\\s)', flags);
    if ($b0438fec261dae9a$var$UPDATES_LAST_INDEX_WRONG) lastIndex = re.lastIndex;
    var match = $59bf80837927ca02$exports($b0438fec261dae9a$var$nativeExec, sticky ? reCopy : re, strCopy);
    if (sticky) {
        if (match) {
            match.input = str;
            match[0] = $b0438fec261dae9a$var$stringSlice(match[0], charsAdded);
            match.index = re.lastIndex;
            re.lastIndex += match[0].length;
        } else re.lastIndex = 0;
    } else if ($b0438fec261dae9a$var$UPDATES_LAST_INDEX_WRONG && match) re.lastIndex = re.global ? match.index + match[0].length : lastIndex;
    if ($b0438fec261dae9a$var$NPCG_INCLUDED && match && match.length > 1) // Fix browsers whose `exec` methods don't consistently return `undefined`
    // for NPCG, like IE8. NOTE: This doesn't work for /(.?)?/
    $59bf80837927ca02$exports($b0438fec261dae9a$var$nativeReplace, match[0], reCopy, function() {
        for(var i = 1; i < arguments.length - 2; i++)if (arguments[i] === undefined) match[i] = undefined;
    });
    if (match && groups) $b0438fec261dae9a$var$setGroups(match, groups);
    return match;
};
$b0438fec261dae9a$exports = $b0438fec261dae9a$var$patchedExec;


// `RegExp.prototype.exec` method
// https://tc39.es/ecma262/#sec-regexp.prototype.exec
$244155c096ef4c14$exports({
    target: 'RegExp',
    proto: true,
    forced: /./.exec !== $b0438fec261dae9a$exports
}, {
    exec: $b0438fec261dae9a$exports
});


'use strict';




// `RegExp.prototype.flags` getter
// https://tc39.es/ecma262/#sec-get-regexp.prototype.flags
if ($b9f536d3284d7921$exports && !$7c168e28f8227963$exports.correct) {
    $71a985fce44d8187$exports(RegExp.prototype, 'flags', {
        configurable: true,
        get: $a814d9bd91cc8bb0$exports
    });
    $7c168e28f8227963$exports.correct = true;
}


'use strict';

var $db8c7f748f719aae$require$PROPER_FUNCTION_NAME = $464881364ad3f936$exports.PROPER;





var $db8c7f748f719aae$var$TO_STRING = 'toString';
var $db8c7f748f719aae$var$RegExpPrototype = RegExp.prototype;
var $db8c7f748f719aae$var$nativeToString = $db8c7f748f719aae$var$RegExpPrototype[$db8c7f748f719aae$var$TO_STRING];
var $db8c7f748f719aae$var$NOT_GENERIC = $ddd8e9441ae136f2$exports(function() {
    return $db8c7f748f719aae$var$nativeToString.call({
        source: 'a',
        flags: 'b'
    }) !== '/a/b';
});
// FF44- RegExp#toString has a wrong name
var $db8c7f748f719aae$var$INCORRECT_NAME = $db8c7f748f719aae$require$PROPER_FUNCTION_NAME && $db8c7f748f719aae$var$nativeToString.name !== $db8c7f748f719aae$var$TO_STRING;
// `RegExp.prototype.toString` method
// https://tc39.es/ecma262/#sec-regexp.prototype.tostring
if ($db8c7f748f719aae$var$NOT_GENERIC || $db8c7f748f719aae$var$INCORRECT_NAME) $73c8864ae5df5c4d$exports($db8c7f748f719aae$var$RegExpPrototype, $db8c7f748f719aae$var$TO_STRING, function toString() {
    var R = $7d9b9f0a2a7e34a2$exports(this);
    var pattern = $7c610b7ee22557b5$exports(R.source);
    var flags = $7c610b7ee22557b5$exports($7429fd641fff63d4$exports(R));
    return '/' + pattern + '/' + flags;
}, {
    unsafe: true
});


'use strict';
'use strict';


// `Set` constructor
// https://tc39.es/ecma262/#sec-set-objects
$3f909713a27e049c$exports('Set', function(init) {
    return function Set() {
        return init(this, arguments.length ? arguments[0] : undefined);
    };
}, $57adf11f0ab2f6f5$exports);




'use strict';

var $91efe475d764b646$exports = {};
'use strict';




var $91efe475d764b646$var$charAt = $c224a7eda28c33b3$exports(''.charAt);
var $91efe475d764b646$var$charCodeAt = $c224a7eda28c33b3$exports(''.charCodeAt);
var $91efe475d764b646$var$stringSlice = $c224a7eda28c33b3$exports(''.slice);
var $91efe475d764b646$var$createMethod = function createMethod(CONVERT_TO_STRING) {
    return function($this, pos) {
        var S = $7c610b7ee22557b5$exports($0f70b7357550422e$exports($this));
        var position = $a8fecfd456e884de$exports(pos);
        var size = S.length;
        var first, second;
        if (position < 0 || position >= size) return CONVERT_TO_STRING ? '' : undefined;
        first = $91efe475d764b646$var$charCodeAt(S, position);
        return first < 0xD800 || first > 0xDBFF || position + 1 === size || (second = $91efe475d764b646$var$charCodeAt(S, position + 1)) < 0xDC00 || second > 0xDFFF ? CONVERT_TO_STRING ? $91efe475d764b646$var$charAt(S, position) : first : CONVERT_TO_STRING ? $91efe475d764b646$var$stringSlice(S, position, position + 2) : (first - 0xD800 << 10) + (second - 0xDC00) + 0x10000;
    };
};
$91efe475d764b646$exports = {
    // `String.prototype.codePointAt` method
    // https://tc39.es/ecma262/#sec-string.prototype.codepointat
    codeAt: $91efe475d764b646$var$createMethod(false),
    // `String.prototype.at` method
    // https://github.com/mathiasbynens/String.prototype.at
    charAt: $91efe475d764b646$var$createMethod(true)
};


var $2ed61434e66314e1$require$codeAt = $91efe475d764b646$exports.codeAt;
// `String.prototype.codePointAt` method
// https://tc39.es/ecma262/#sec-string.prototype.codepointat
$244155c096ef4c14$exports({
    target: 'String',
    proto: true
}, {
    codePointAt: function codePointAt(pos) {
        return $2ed61434e66314e1$require$codeAt(this, pos);
    }
});


'use strict';



var $d1ce430b6575a061$require$getOwnPropertyDescriptor = $70871da05e9d21bf$export$2d1720544b23b823;


var $fc314b8f4d28fbe8$exports = {};
'use strict';

var $fc314b8f4d28fbe8$var$$TypeError = TypeError;
$fc314b8f4d28fbe8$exports = function(it) {
    if ($6589e3318847d9df$exports(it)) throw new $fc314b8f4d28fbe8$var$$TypeError("The method doesn't accept regular expressions");
    return it;
};



var $8b6c1cccf4e3f30c$exports = {};
'use strict';

var $8b6c1cccf4e3f30c$var$MATCH = $8555fb22f74da29f$exports('match');
$8b6c1cccf4e3f30c$exports = function(METHOD_NAME) {
    var regexp = /./;
    try {
        '/./'[METHOD_NAME](regexp);
    } catch (error1) {
        try {
            regexp[$8b6c1cccf4e3f30c$var$MATCH] = false;
            return '/./'[METHOD_NAME](regexp);
        } catch (error2) {}
    }
    return false;
};



var $d1ce430b6575a061$var$slice = $262d820f61605b50$exports(''.slice);
var $d1ce430b6575a061$var$min = Math.min;
var $d1ce430b6575a061$var$CORRECT_IS_REGEXP_LOGIC = $8b6c1cccf4e3f30c$exports('endsWith');
// https://github.com/zloirock/core-js/pull/702
var $d1ce430b6575a061$var$MDN_POLYFILL_BUG = !$a4b83f418a8da28e$exports && !$d1ce430b6575a061$var$CORRECT_IS_REGEXP_LOGIC && !!function() {
    var descriptor = $d1ce430b6575a061$require$getOwnPropertyDescriptor(String.prototype, 'endsWith');
    return descriptor && !descriptor.writable;
}();
// `String.prototype.endsWith` method
// https://tc39.es/ecma262/#sec-string.prototype.endswith
$244155c096ef4c14$exports({
    target: 'String',
    proto: true,
    forced: !$d1ce430b6575a061$var$MDN_POLYFILL_BUG && !$d1ce430b6575a061$var$CORRECT_IS_REGEXP_LOGIC
}, {
    endsWith: function endsWith(searchString /* , endPosition = @length */ ) {
        var that = $7c610b7ee22557b5$exports($0f70b7357550422e$exports(this));
        $fc314b8f4d28fbe8$exports(searchString);
        var search = $7c610b7ee22557b5$exports(searchString);
        var endPosition = arguments.length > 1 ? arguments[1] : undefined;
        var len = that.length;
        var end = endPosition === undefined ? len : $d1ce430b6575a061$var$min($aa75059f0a5ef94e$exports(endPosition), len);
        return $d1ce430b6575a061$var$slice(that, end - search.length, end) === search;
    }
});


'use strict';



var $546d45630c2fe9d4$var$$RangeError = RangeError;
var $546d45630c2fe9d4$var$fromCharCode = String.fromCharCode;
// eslint-disable-next-line es/no-string-fromcodepoint -- required for testing
var $546d45630c2fe9d4$var$$fromCodePoint = String.fromCodePoint;
var $546d45630c2fe9d4$var$join = $c224a7eda28c33b3$exports([].join);
// length should be 1, old FF problem
var $546d45630c2fe9d4$var$INCORRECT_LENGTH = !!$546d45630c2fe9d4$var$$fromCodePoint && $546d45630c2fe9d4$var$$fromCodePoint.length !== 1;
// `String.fromCodePoint` method
// https://tc39.es/ecma262/#sec-string.fromcodepoint
$244155c096ef4c14$exports({
    target: 'String',
    stat: true,
    arity: 1,
    forced: $546d45630c2fe9d4$var$INCORRECT_LENGTH
}, {
    // eslint-disable-next-line no-unused-vars -- required for `.length`
    fromCodePoint: function fromCodePoint(x) {
        var elements = [];
        var length = arguments.length;
        var i = 0;
        var code;
        while(length > i){
            code = +arguments[i];
            if ($32c589906f6ca696$exports(code, 0x10FFFF) !== code) throw new $546d45630c2fe9d4$var$$RangeError(code + ' is not a valid code point');
            elements[i++] = code < 0x10000 ? $546d45630c2fe9d4$var$fromCharCode(code) : $546d45630c2fe9d4$var$fromCharCode(((code -= 0x10000) >> 10) + 0xD800, code % 0x400 + 0xDC00);
        }
        return $546d45630c2fe9d4$var$join(elements, '');
    }
});


'use strict';






var $c10d4f3e88a99e49$var$stringIndexOf = $c224a7eda28c33b3$exports(''.indexOf);
// `String.prototype.includes` method
// https://tc39.es/ecma262/#sec-string.prototype.includes
$244155c096ef4c14$exports({
    target: 'String',
    proto: true,
    forced: !$8b6c1cccf4e3f30c$exports('includes')
}, {
    includes: function includes(searchString /* , position = 0 */ ) {
        return !!~$c10d4f3e88a99e49$var$stringIndexOf($7c610b7ee22557b5$exports($0f70b7357550422e$exports(this)), $7c610b7ee22557b5$exports($fc314b8f4d28fbe8$exports(searchString)), arguments.length > 1 ? arguments[1] : undefined);
    }
});


'use strict';

var $f1b90e44f3e6101d$require$charAt = $91efe475d764b646$exports.charAt;




var $f1b90e44f3e6101d$var$STRING_ITERATOR = 'String Iterator';
var $f1b90e44f3e6101d$var$setInternalState = $fcfe8b5396fbe91a$exports.set;
var $f1b90e44f3e6101d$var$getInternalState = $fcfe8b5396fbe91a$exports.getterFor($f1b90e44f3e6101d$var$STRING_ITERATOR);
// `String.prototype[@@iterator]` method
// https://tc39.es/ecma262/#sec-string.prototype-@@iterator
$f183cb308a74bc45$exports(String, 'String', function(iterated) {
    $f1b90e44f3e6101d$var$setInternalState(this, {
        type: $f1b90e44f3e6101d$var$STRING_ITERATOR,
        string: $7c610b7ee22557b5$exports(iterated),
        index: 0
    });
// `%StringIteratorPrototype%.next` method
// https://tc39.es/ecma262/#sec-%stringiteratorprototype%.next
}, function next() {
    var state = $f1b90e44f3e6101d$var$getInternalState(this);
    var string = state.string;
    var index = state.index;
    var point;
    if (index >= string.length) return $71995534a6c57f64$exports(undefined, true);
    point = $f1b90e44f3e6101d$require$charAt(string, index);
    state.index += point.length;
    return $71995534a6c57f64$exports(point, false);
});


'use strict';


var $eae4ec2a80defd01$exports = {};
'use strict';







var $eae4ec2a80defd01$var$SPECIES = $8555fb22f74da29f$exports('species');
var $eae4ec2a80defd01$var$RegExpPrototype = RegExp.prototype;
$eae4ec2a80defd01$exports = function(KEY, exec, FORCED, SHAM) {
    var SYMBOL = $8555fb22f74da29f$exports(KEY);
    var DELEGATES_TO_SYMBOL = !$ddd8e9441ae136f2$exports(function() {
        // String methods call symbol-named RegExp methods
        var O = {};
        // eslint-disable-next-line unicorn/no-immediate-mutation -- ES3 syntax limitation
        O[SYMBOL] = function() {
            return 7;
        };
        return ''[KEY](O) !== 7;
    });
    var DELEGATES_TO_EXEC = DELEGATES_TO_SYMBOL && !$ddd8e9441ae136f2$exports(function() {
        // Symbol-named RegExp methods call .exec
        var execCalled = false;
        var re = /a/;
        if (KEY === 'split') {
            // We can't use real regex here since it causes deoptimization
            // and serious performance degradation in V8
            // https://github.com/zloirock/core-js/issues/306
            // RegExp[@@split] doesn't call the regex's exec method, but first creates
            // a new one. We need to return the patched regex when creating the new one.
            var constructor = {};
            // eslint-disable-next-line unicorn/no-immediate-mutation -- ES3 syntax limitation
            constructor[$eae4ec2a80defd01$var$SPECIES] = function() {
                return re;
            };
            re = {
                constructor: constructor,
                flags: ''
            };
            // eslint-disable-next-line unicorn/no-immediate-mutation -- ES3 syntax limitation
            re[SYMBOL] = /./[SYMBOL];
        }
        re.exec = function() {
            execCalled = true;
            return null;
        };
        re[SYMBOL]('');
        return !execCalled;
    });
    if (!DELEGATES_TO_SYMBOL || !DELEGATES_TO_EXEC || FORCED) {
        var nativeRegExpMethod = /./[SYMBOL];
        var methods = exec(SYMBOL, ''[KEY], function(nativeMethod, regexp, str, arg2, forceStringMethod) {
            var $exec = regexp.exec;
            if ($exec === $b0438fec261dae9a$exports || $exec === $eae4ec2a80defd01$var$RegExpPrototype.exec) {
                if (DELEGATES_TO_SYMBOL && !forceStringMethod) // The native String method already delegates to @@method (this
                // polyfilled function), leasing to infinite recursion.
                // We avoid it by directly calling the native @@method method.
                return {
                    done: true,
                    value: $59bf80837927ca02$exports(nativeRegExpMethod, regexp, str, arg2)
                };
                return {
                    done: true,
                    value: $59bf80837927ca02$exports(nativeMethod, str, regexp, arg2)
                };
            }
            return {
                done: false
            };
        });
        $73c8864ae5df5c4d$exports(String.prototype, KEY, methods[0]);
        $73c8864ae5df5c4d$exports($eae4ec2a80defd01$var$RegExpPrototype, SYMBOL, methods[1]);
    }
    if (SHAM) $b390530569770271$exports($eae4ec2a80defd01$var$RegExpPrototype[SYMBOL], 'sham', true);
};








var $683491d94e8d43d1$exports = {};
'use strict';

var $683491d94e8d43d1$require$charAt = $91efe475d764b646$exports.charAt;
// `AdvanceStringIndex` abstract operation
// https://tc39.es/ecma262/#sec-advancestringindex
$683491d94e8d43d1$exports = function(S, index, unicode) {
    return index + (unicode ? $683491d94e8d43d1$require$charAt(S, index).length || 1 : 1);
};



var $40c1c4b3f20bbb0f$exports = {};
'use strict';





var $40c1c4b3f20bbb0f$var$$TypeError = TypeError;
// `RegExpExec` abstract operation
// https://tc39.es/ecma262/#sec-regexpexec
$40c1c4b3f20bbb0f$exports = function(R, S) {
    var exec = R.exec;
    if ($7c165f740ca92c53$exports(exec)) {
        var result = $59bf80837927ca02$exports(exec, R, S);
        if (result !== null) $7d9b9f0a2a7e34a2$exports(result);
        return result;
    }
    if ($5a266b01e7970e30$exports(R) === 'RegExp') return $59bf80837927ca02$exports($b0438fec261dae9a$exports, R, S);
    throw new $40c1c4b3f20bbb0f$var$$TypeError('RegExp#exec called on incompatible receiver');
};


var $22dbdb2879a7305e$var$stringIndexOf = $c224a7eda28c33b3$exports(''.indexOf);
// @@match logic
$eae4ec2a80defd01$exports('match', function(MATCH, nativeMatch, maybeCallNative) {
    return [
        // `String.prototype.match` method
        // https://tc39.es/ecma262/#sec-string.prototype.match
        function match(regexp) {
            var O = $0f70b7357550422e$exports(this);
            var matcher = $4d7f82f6c4645870$exports(regexp) ? $354ab2c23276ac4c$exports(regexp, MATCH) : undefined;
            return matcher ? $59bf80837927ca02$exports(matcher, regexp, O) : new RegExp(regexp)[MATCH]($7c610b7ee22557b5$exports(O));
        },
        // `RegExp.prototype[@@match]` method
        // https://tc39.es/ecma262/#sec-regexp.prototype-@@match
        function(string) {
            var rx = $7d9b9f0a2a7e34a2$exports(this);
            var S = $7c610b7ee22557b5$exports(string);
            var res = maybeCallNative(nativeMatch, rx, S);
            if (res.done) return res.value;
            var flags = $7c610b7ee22557b5$exports($7429fd641fff63d4$exports(rx));
            if (!~$22dbdb2879a7305e$var$stringIndexOf(flags, 'g')) return $40c1c4b3f20bbb0f$exports(rx, S);
            var fullUnicode = !!~$22dbdb2879a7305e$var$stringIndexOf(flags, 'u') || !!~$22dbdb2879a7305e$var$stringIndexOf(flags, 'v');
            rx.lastIndex = 0;
            var A = [];
            var n = 0;
            var result;
            while((result = $40c1c4b3f20bbb0f$exports(rx, S)) !== null){
                var matchStr = $7c610b7ee22557b5$exports(result[0]);
                A[n] = matchStr;
                if (matchStr === '') rx.lastIndex = $683491d94e8d43d1$exports(S, $aa75059f0a5ef94e$exports(rx.lastIndex), fullUnicode);
                n++;
            }
            return n === 0 ? null : A;
        }
    ];
});


'use strict';

var $f68b0bd4ea376456$exports = {};
'use strict';





var $f68b0bd4ea376456$var$repeat = $c224a7eda28c33b3$exports($c8485ab0b4677db4$exports);
var $f68b0bd4ea376456$var$stringSlice = $c224a7eda28c33b3$exports(''.slice);
var $f68b0bd4ea376456$var$ceil = Math.ceil;
// `String.prototype.{ padStart, padEnd }` methods implementation
var $f68b0bd4ea376456$var$createMethod = function createMethod(IS_END) {
    return function($this, maxLength, fillString) {
        var S = $7c610b7ee22557b5$exports($0f70b7357550422e$exports($this));
        var intMaxLength = $aa75059f0a5ef94e$exports(maxLength);
        var stringLength = S.length;
        if (intMaxLength <= stringLength) return S;
        var fillStr = fillString === undefined ? ' ' : $7c610b7ee22557b5$exports(fillString);
        var fillLen, stringFiller;
        if (fillStr === '') return S;
        fillLen = intMaxLength - stringLength;
        stringFiller = $f68b0bd4ea376456$var$repeat(fillStr, $f68b0bd4ea376456$var$ceil(fillLen / fillStr.length));
        if (stringFiller.length > fillLen) stringFiller = $f68b0bd4ea376456$var$stringSlice(stringFiller, 0, fillLen);
        return IS_END ? S + stringFiller : stringFiller + S;
    };
};
$f68b0bd4ea376456$exports = {
    // `String.prototype.padStart` method
    // https://tc39.es/ecma262/#sec-string.prototype.padstart
    start: $f68b0bd4ea376456$var$createMethod(false),
    // `String.prototype.padEnd` method
    // https://tc39.es/ecma262/#sec-string.prototype.padend
    end: $f68b0bd4ea376456$var$createMethod(true)
};


var $a24f9416997fc751$require$$padEnd = $f68b0bd4ea376456$exports.end;
var $3508e8a4d94a7f6a$exports = {};
'use strict';

$3508e8a4d94a7f6a$exports = /Version\/10(?:\.\d+){1,2}(?: [\w./]+)?(?: Mobile\/\w+)? Safari\//.test($ef443fb3091f223d$exports);


// `String.prototype.padEnd` method
// https://tc39.es/ecma262/#sec-string.prototype.padend
$244155c096ef4c14$exports({
    target: 'String',
    proto: true,
    forced: $3508e8a4d94a7f6a$exports
}, {
    padEnd: function padEnd(maxLength /* , fillString = ' ' */ ) {
        return $a24f9416997fc751$require$$padEnd(this, maxLength, arguments.length > 1 ? arguments[1] : undefined);
    }
});


'use strict';


var $0e6bb329c12c959c$require$$padStart = $f68b0bd4ea376456$exports.start;

// `String.prototype.padStart` method
// https://tc39.es/ecma262/#sec-string.prototype.padstart
$244155c096ef4c14$exports({
    target: 'String',
    proto: true,
    forced: $3508e8a4d94a7f6a$exports
}, {
    padStart: function padStart(maxLength /* , fillString = ' ' */ ) {
        return $0e6bb329c12c959c$require$$padStart(this, maxLength, arguments.length > 1 ? arguments[1] : undefined);
    }
});


'use strict';






var $6ec78757be244001$var$push = $c224a7eda28c33b3$exports([].push);
var $6ec78757be244001$var$join = $c224a7eda28c33b3$exports([].join);
// `String.raw` method
// https://tc39.es/ecma262/#sec-string.raw
$244155c096ef4c14$exports({
    target: 'String',
    stat: true
}, {
    raw: function raw(template) {
        var rawTemplate = $59a8f2f00edbf5a1$exports($ad1d9797f1e27af5$exports(template).raw);
        var literalSegments = $dfe69c9cb1d4aa6b$exports(rawTemplate);
        if (!literalSegments) return '';
        var argumentsLength = arguments.length;
        var elements = [];
        var i = 0;
        while(true){
            $6ec78757be244001$var$push(elements, $7c610b7ee22557b5$exports(rawTemplate[i++]));
            if (i === literalSegments) return $6ec78757be244001$var$join(elements, '');
            if (i < argumentsLength) $6ec78757be244001$var$push(elements, $7c610b7ee22557b5$exports(arguments[i]));
        }
    }
});


'use strict';


// `String.prototype.repeat` method
// https://tc39.es/ecma262/#sec-string.prototype.repeat
$244155c096ef4c14$exports({
    target: 'String',
    proto: true
}, {
    repeat: $c8485ab0b4677db4$exports
});


'use strict';














var $11e8530f20639fca$exports = {};
'use strict';


var $11e8530f20639fca$var$floor = Math.floor;
var $11e8530f20639fca$var$charAt = $c224a7eda28c33b3$exports(''.charAt);
var $11e8530f20639fca$var$replace = $c224a7eda28c33b3$exports(''.replace);
var $11e8530f20639fca$var$stringSlice = $c224a7eda28c33b3$exports(''.slice);
// eslint-disable-next-line redos/no-vulnerable -- safe
var $11e8530f20639fca$var$SUBSTITUTION_SYMBOLS = /\$([$&'`]|\d{1,2}|<[^>]*>)/g;
var $11e8530f20639fca$var$SUBSTITUTION_SYMBOLS_NO_NAMED = /\$([$&'`]|\d{1,2})/g;
// `GetSubstitution` abstract operation
// https://tc39.es/ecma262/#sec-getsubstitution
$11e8530f20639fca$exports = function(matched, str, position, captures, namedCaptures, replacement) {
    var tailPos = position + matched.length;
    var m = captures.length;
    var symbols = $11e8530f20639fca$var$SUBSTITUTION_SYMBOLS_NO_NAMED;
    if (namedCaptures !== undefined) {
        namedCaptures = $ad1d9797f1e27af5$exports(namedCaptures);
        symbols = $11e8530f20639fca$var$SUBSTITUTION_SYMBOLS;
    }
    return $11e8530f20639fca$var$replace(replacement, symbols, function(match, ch) {
        var capture;
        switch($11e8530f20639fca$var$charAt(ch, 0)){
            case '$':
                return '$';
            case '&':
                return matched;
            case '`':
                return $11e8530f20639fca$var$stringSlice(str, 0, position);
            case "'":
                return $11e8530f20639fca$var$stringSlice(str, tailPos);
            case '<':
                capture = namedCaptures[$11e8530f20639fca$var$stringSlice(ch, 1, -1)];
                break;
            default:
                var n = +ch;
                if (n === 0) return match;
                if (n > m) {
                    var f = $11e8530f20639fca$var$floor(n / 10);
                    if (f === 0) return match;
                    if (f <= m) return captures[f - 1] === undefined ? $11e8530f20639fca$var$charAt(ch, 1) : captures[f - 1] + $11e8530f20639fca$var$charAt(ch, 1);
                    return match;
                }
                capture = captures[n - 1];
        }
        return capture === undefined ? '' : capture;
    });
};





var $fb756e149f167e6f$var$REPLACE = $8555fb22f74da29f$exports('replace');
var $fb756e149f167e6f$var$max = Math.max;
var $fb756e149f167e6f$var$min = Math.min;
var $fb756e149f167e6f$var$concat = $c224a7eda28c33b3$exports([].concat);
var $fb756e149f167e6f$var$push = $c224a7eda28c33b3$exports([].push);
var $fb756e149f167e6f$var$stringIndexOf = $c224a7eda28c33b3$exports(''.indexOf);
var $fb756e149f167e6f$var$stringSlice = $c224a7eda28c33b3$exports(''.slice);
var $fb756e149f167e6f$var$maybeToString = function maybeToString(it) {
    return it === undefined ? it : String(it);
};
// IE <= 11 replaces $0 with the whole match, as if it was $&
// https://stackoverflow.com/questions/6024666/getting-ie-to-replace-a-regex-with-the-literal-string-0
var $fb756e149f167e6f$var$REPLACE_KEEPS_$0 = function() {
    // eslint-disable-next-line regexp/prefer-escape-replacement-dollar-char -- required for testing
    return 'a'.replace(/./, '$0') === '$0';
}();
// Safari <= 13.0.3(?) substitutes nth capture where n>m with an empty string
var $fb756e149f167e6f$var$REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE = function() {
    if (/./[$fb756e149f167e6f$var$REPLACE]) return /./[$fb756e149f167e6f$var$REPLACE]('a', '$0') === '';
    return false;
}();
var $fb756e149f167e6f$var$REPLACE_SUPPORTS_NAMED_GROUPS = !$ddd8e9441ae136f2$exports(function() {
    var re = /./;
    re.exec = function() {
        var result = [];
        result.groups = {
            a: '7'
        };
        return result;
    };
    // eslint-disable-next-line regexp/no-useless-dollar-replacements -- false positive
    return ''.replace(re, '$<a>') !== '7';
});
// @@replace logic
$eae4ec2a80defd01$exports('replace', function(_, nativeReplace, maybeCallNative) {
    var UNSAFE_SUBSTITUTE = $fb756e149f167e6f$var$REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE ? '$' : '$0';
    return [
        // `String.prototype.replace` method
        // https://tc39.es/ecma262/#sec-string.prototype.replace
        function replace(searchValue, replaceValue) {
            var O = $0f70b7357550422e$exports(this);
            var replacer = $4d7f82f6c4645870$exports(searchValue) ? $354ab2c23276ac4c$exports(searchValue, $fb756e149f167e6f$var$REPLACE) : undefined;
            return replacer ? $59bf80837927ca02$exports(replacer, searchValue, O, replaceValue) : $59bf80837927ca02$exports(nativeReplace, $7c610b7ee22557b5$exports(O), searchValue, replaceValue);
        },
        // `RegExp.prototype[@@replace]` method
        // https://tc39.es/ecma262/#sec-regexp.prototype-@@replace
        function(string, replaceValue) {
            var rx = $7d9b9f0a2a7e34a2$exports(this);
            var S = $7c610b7ee22557b5$exports(string);
            var functionalReplace = $7c165f740ca92c53$exports(replaceValue);
            if (!functionalReplace) replaceValue = $7c610b7ee22557b5$exports(replaceValue);
            var flags = $7c610b7ee22557b5$exports($7429fd641fff63d4$exports(rx));
            if (typeof replaceValue == 'string' && !~$fb756e149f167e6f$var$stringIndexOf(replaceValue, UNSAFE_SUBSTITUTE) && !~$fb756e149f167e6f$var$stringIndexOf(replaceValue, '$<') && !~$fb756e149f167e6f$var$stringIndexOf(flags, 'y')) {
                var res = maybeCallNative(nativeReplace, rx, S, replaceValue);
                if (res.done) return res.value;
            }
            var global = !!~$fb756e149f167e6f$var$stringIndexOf(flags, 'g');
            var fullUnicode;
            if (global) {
                fullUnicode = !!~$fb756e149f167e6f$var$stringIndexOf(flags, 'u') || !!~$fb756e149f167e6f$var$stringIndexOf(flags, 'v');
                rx.lastIndex = 0;
            }
            var results = [];
            var result;
            while(true){
                result = $40c1c4b3f20bbb0f$exports(rx, S);
                if (result === null) break;
                $fb756e149f167e6f$var$push(results, result);
                if (!global) break;
                var matchStr = $7c610b7ee22557b5$exports(result[0]);
                if (matchStr === '') rx.lastIndex = $683491d94e8d43d1$exports(S, $aa75059f0a5ef94e$exports(rx.lastIndex), fullUnicode);
            }
            var accumulatedResult = '';
            var nextSourcePosition = 0;
            for(var i = 0; i < results.length; i++){
                result = results[i];
                var matched = $7c610b7ee22557b5$exports(result[0]);
                var position = $fb756e149f167e6f$var$max($fb756e149f167e6f$var$min($a8fecfd456e884de$exports(result.index), S.length), 0);
                var captures = [];
                var replacement;
                // NOTE: This is equivalent to
                //   captures = result.slice(1).map(maybeToString)
                // but for some reason `nativeSlice.call(result, 1, result.length)` (called in
                // the slice polyfill when slicing native arrays) "doesn't work" in safari 9 and
                // causes a crash (https://pastebin.com/N21QzeQA) when trying to debug it.
                for(var j = 1; j < result.length; j++)$fb756e149f167e6f$var$push(captures, $fb756e149f167e6f$var$maybeToString(result[j]));
                var namedCaptures = result.groups;
                if (functionalReplace) {
                    var replacerArgs = $fb756e149f167e6f$var$concat([
                        matched
                    ], captures, position, S);
                    if (namedCaptures !== undefined) $fb756e149f167e6f$var$push(replacerArgs, namedCaptures);
                    replacement = $7c610b7ee22557b5$exports($eb64554a295b6978$exports(replaceValue, undefined, replacerArgs));
                } else replacement = $11e8530f20639fca$exports(matched, S, position, captures, namedCaptures, replaceValue);
                if (position >= nextSourcePosition) {
                    accumulatedResult += $fb756e149f167e6f$var$stringSlice(S, nextSourcePosition, position) + replacement;
                    nextSourcePosition = position + matched.length;
                }
            }
            return accumulatedResult + $fb756e149f167e6f$var$stringSlice(S, nextSourcePosition);
        }
    ];
}, !$fb756e149f167e6f$var$REPLACE_SUPPORTS_NAMED_GROUPS || !$fb756e149f167e6f$var$REPLACE_KEEPS_$0 || $fb756e149f167e6f$var$REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE);


'use strict';









// @@search logic
$eae4ec2a80defd01$exports('search', function(SEARCH, nativeSearch, maybeCallNative) {
    return [
        // `String.prototype.search` method
        // https://tc39.es/ecma262/#sec-string.prototype.search
        function search(regexp) {
            var O = $0f70b7357550422e$exports(this);
            var searcher = $4d7f82f6c4645870$exports(regexp) ? $354ab2c23276ac4c$exports(regexp, SEARCH) : undefined;
            return searcher ? $59bf80837927ca02$exports(searcher, regexp, O) : new RegExp(regexp)[SEARCH]($7c610b7ee22557b5$exports(O));
        },
        // `RegExp.prototype[@@search]` method
        // https://tc39.es/ecma262/#sec-regexp.prototype-@@search
        function(string) {
            var rx = $7d9b9f0a2a7e34a2$exports(this);
            var S = $7c610b7ee22557b5$exports(string);
            var res = maybeCallNative(nativeSearch, rx, S);
            if (res.done) return res.value;
            var previousLastIndex = rx.lastIndex;
            if (!$bbb65a846df46ee6$exports(previousLastIndex, 0)) rx.lastIndex = 0;
            var result = $40c1c4b3f20bbb0f$exports(rx, S);
            if (!$bbb65a846df46ee6$exports(rx.lastIndex, previousLastIndex)) rx.lastIndex = previousLastIndex;
            return result === null ? -1 : result.index;
        }
    ];
});


'use strict';















var $14b70a1855809224$var$UNSUPPORTED_Y = $67a817e7885ccc52$exports.UNSUPPORTED_Y;
var $14b70a1855809224$var$MAX_UINT32 = 0xFFFFFFFF;
var $14b70a1855809224$var$min = Math.min;
var $14b70a1855809224$var$push = $c224a7eda28c33b3$exports([].push);
var $14b70a1855809224$var$stringSlice = $c224a7eda28c33b3$exports(''.slice);
var $14b70a1855809224$var$stringIndexOf = $c224a7eda28c33b3$exports(''.indexOf);
// Chrome 51 has a buggy "split" implementation when RegExp#exec !== nativeExec
// Weex JS has frozen built-in prototypes, so use try / catch wrapper
var $14b70a1855809224$var$SPLIT_WORKS_WITH_OVERWRITTEN_EXEC = !$ddd8e9441ae136f2$exports(function() {
    // eslint-disable-next-line regexp/no-empty-group -- required for testing
    var re = /(?:)/;
    var originalExec = re.exec;
    re.exec = function() {
        return originalExec.apply(this, arguments);
    };
    var result = 'ab'.split(re);
    return result.length !== 2 || result[0] !== 'a' || result[1] !== 'b';
});
var $14b70a1855809224$var$BUGGY = 'abbc'.split(/(b)*/)[1] === 'c' || // eslint-disable-next-line regexp/no-empty-group -- required for testing
'test'.split(/(?:)/, -1).length !== 4 || 'ab'.split(/(?:ab)*/).length !== 2 || '.'.split(/(.?)(.?)/).length !== 4 || // eslint-disable-next-line regexp/no-empty-capturing-group, regexp/no-empty-group -- required for testing
'.'.split(/()()/).length > 1 || ''.split(/.?/).length;
// @@split logic
$eae4ec2a80defd01$exports('split', function(SPLIT, nativeSplit, maybeCallNative) {
    var internalSplit = '0'.split(undefined, 0).length ? function internalSplit(separator, limit) {
        return separator === undefined && limit === 0 ? [] : $59bf80837927ca02$exports(nativeSplit, this, separator, limit);
    } : nativeSplit;
    return [
        // `String.prototype.split` method
        // https://tc39.es/ecma262/#sec-string.prototype.split
        function split(separator, limit) {
            var O = $0f70b7357550422e$exports(this);
            var splitter = $4d7f82f6c4645870$exports(separator) ? $354ab2c23276ac4c$exports(separator, SPLIT) : undefined;
            return splitter ? $59bf80837927ca02$exports(splitter, separator, O, limit) : $59bf80837927ca02$exports(internalSplit, $7c610b7ee22557b5$exports(O), separator, limit);
        },
        // `RegExp.prototype[@@split]` method
        // https://tc39.es/ecma262/#sec-regexp.prototype-@@split
        //
        // NOTE: This cannot be properly polyfilled in engines that don't support
        // the 'y' flag.
        function(string, limit) {
            var rx = $7d9b9f0a2a7e34a2$exports(this);
            var S = $7c610b7ee22557b5$exports(string);
            if (!$14b70a1855809224$var$BUGGY) {
                var res = maybeCallNative(internalSplit, rx, S, limit, internalSplit !== nativeSplit);
                if (res.done) return res.value;
            }
            var C = $530f9e30acde7c4a$exports(rx, RegExp);
            var flags = $7c610b7ee22557b5$exports($7429fd641fff63d4$exports(rx));
            var unicodeMatching = !!~$14b70a1855809224$var$stringIndexOf(flags, 'u') || !!~$14b70a1855809224$var$stringIndexOf(flags, 'v');
            if ($14b70a1855809224$var$UNSUPPORTED_Y) {
                if (!~$14b70a1855809224$var$stringIndexOf(flags, 'g')) flags += 'g';
            } else if (!~$14b70a1855809224$var$stringIndexOf(flags, 'y')) flags += 'y';
            // ^(? + rx + ) is needed, in combination with some S slicing, to
            // simulate the 'y' flag.
            var splitter = new C($14b70a1855809224$var$UNSUPPORTED_Y ? '^(?:' + rx.source + ')' : rx, flags);
            var lim = limit === undefined ? $14b70a1855809224$var$MAX_UINT32 : limit >>> 0;
            if (lim === 0) return [];
            if (S.length === 0) return $40c1c4b3f20bbb0f$exports(splitter, S) === null ? [
                S
            ] : [];
            var p = 0;
            var q = 0;
            var A = [];
            while(q < S.length){
                splitter.lastIndex = $14b70a1855809224$var$UNSUPPORTED_Y ? 0 : q;
                var z = $40c1c4b3f20bbb0f$exports(splitter, $14b70a1855809224$var$UNSUPPORTED_Y ? $14b70a1855809224$var$stringSlice(S, q) : S);
                var e;
                if (z === null || (e = $14b70a1855809224$var$min($aa75059f0a5ef94e$exports(splitter.lastIndex + ($14b70a1855809224$var$UNSUPPORTED_Y ? q : 0)), S.length)) === p) q = $683491d94e8d43d1$exports(S, q, unicodeMatching);
                else {
                    $14b70a1855809224$var$push(A, $14b70a1855809224$var$stringSlice(S, p, q));
                    if (A.length === lim) return A;
                    for(var i = 1; i <= z.length - 1; i++){
                        $14b70a1855809224$var$push(A, z[i]);
                        if (A.length === lim) return A;
                    }
                    q = p = e;
                }
            }
            $14b70a1855809224$var$push(A, $14b70a1855809224$var$stringSlice(S, p));
            return A;
        }
    ];
}, $14b70a1855809224$var$BUGGY || !$14b70a1855809224$var$SPLIT_WORKS_WITH_OVERWRITTEN_EXEC, $14b70a1855809224$var$UNSUPPORTED_Y);


'use strict';



var $d0fc70c2ab9405a9$require$getOwnPropertyDescriptor = $70871da05e9d21bf$export$2d1720544b23b823;






var $d0fc70c2ab9405a9$var$stringSlice = $262d820f61605b50$exports(''.slice);
var $d0fc70c2ab9405a9$var$min = Math.min;
var $d0fc70c2ab9405a9$var$CORRECT_IS_REGEXP_LOGIC = $8b6c1cccf4e3f30c$exports('startsWith');
// https://github.com/zloirock/core-js/pull/702
var $d0fc70c2ab9405a9$var$MDN_POLYFILL_BUG = !$a4b83f418a8da28e$exports && !$d0fc70c2ab9405a9$var$CORRECT_IS_REGEXP_LOGIC && !!function() {
    var descriptor = $d0fc70c2ab9405a9$require$getOwnPropertyDescriptor(String.prototype, 'startsWith');
    return descriptor && !descriptor.writable;
}();
// `String.prototype.startsWith` method
// https://tc39.es/ecma262/#sec-string.prototype.startswith
$244155c096ef4c14$exports({
    target: 'String',
    proto: true,
    forced: !$d0fc70c2ab9405a9$var$MDN_POLYFILL_BUG && !$d0fc70c2ab9405a9$var$CORRECT_IS_REGEXP_LOGIC
}, {
    startsWith: function startsWith(searchString /* , position = 0 */ ) {
        var that = $7c610b7ee22557b5$exports($0f70b7357550422e$exports(this));
        $fc314b8f4d28fbe8$exports(searchString);
        var search = $7c610b7ee22557b5$exports(searchString);
        var index = $aa75059f0a5ef94e$exports($d0fc70c2ab9405a9$var$min(arguments.length > 1 ? arguments[1] : undefined, that.length));
        return $d0fc70c2ab9405a9$var$stringSlice(that, index, index + search.length) === search;
    }
});


'use strict';


var $890207a2fb37af17$require$$trim = $6f212a89e981fb90$exports.trim;
var $79699b9fe028d3c2$exports = {};
'use strict';

var $79699b9fe028d3c2$require$PROPER_FUNCTION_NAME = $464881364ad3f936$exports.PROPER;


var $79699b9fe028d3c2$var$non = '\u200B\u0085\u180E';
// check that a method works with the correct list
// of whitespaces and has a correct name
$79699b9fe028d3c2$exports = function(METHOD_NAME) {
    return $ddd8e9441ae136f2$exports(function() {
        return !!$1976bf5e6cb48c41$exports[METHOD_NAME]() || $79699b9fe028d3c2$var$non[METHOD_NAME]() !== $79699b9fe028d3c2$var$non || $79699b9fe028d3c2$require$PROPER_FUNCTION_NAME && $1976bf5e6cb48c41$exports[METHOD_NAME].name !== METHOD_NAME;
    });
};


// `String.prototype.trim` method
// https://tc39.es/ecma262/#sec-string.prototype.trim
$244155c096ef4c14$exports({
    target: 'String',
    proto: true,
    forced: $79699b9fe028d3c2$exports('trim')
}, {
    trim: function trim() {
        return $890207a2fb37af17$require$$trim(this);
    }
});


'use strict';
'use strict';

var $cb0b9db33bbf1a3a$exports = {};
'use strict';

var $cb0b9db33bbf1a3a$require$$trimEnd = $6f212a89e981fb90$exports.end;

// `String.prototype.{ trimEnd, trimRight }` method
// https://tc39.es/ecma262/#sec-string.prototype.trimend
// https://tc39.es/ecma262/#String.prototype.trimright
$cb0b9db33bbf1a3a$exports = $79699b9fe028d3c2$exports('trimEnd') ? function trimEnd() {
    return $cb0b9db33bbf1a3a$require$$trimEnd(this);
// eslint-disable-next-line es/no-string-prototype-trimstart-trimend -- safe
} : ''.trimEnd;


// `String.prototype.trimRight` method
// https://tc39.es/ecma262/#sec-string.prototype.trimend
// eslint-disable-next-line es/no-string-prototype-trimleft-trimright -- safe
$244155c096ef4c14$exports({
    target: 'String',
    proto: true,
    name: 'trimEnd',
    forced: ''.trimRight !== $cb0b9db33bbf1a3a$exports
}, {
    trimRight: $cb0b9db33bbf1a3a$exports
});




// `String.prototype.trimEnd` method
// https://tc39.es/ecma262/#sec-string.prototype.trimend
// eslint-disable-next-line es/no-string-prototype-trimstart-trimend -- safe
$244155c096ef4c14$exports({
    target: 'String',
    proto: true,
    name: 'trimEnd',
    forced: ''.trimEnd !== $cb0b9db33bbf1a3a$exports
}, {
    trimEnd: $cb0b9db33bbf1a3a$exports
});


'use strict';
'use strict';

var $c4ba1e9e5760dbcc$exports = {};
'use strict';

var $c4ba1e9e5760dbcc$require$$trimStart = $6f212a89e981fb90$exports.start;

// `String.prototype.{ trimStart, trimLeft }` method
// https://tc39.es/ecma262/#sec-string.prototype.trimstart
// https://tc39.es/ecma262/#String.prototype.trimleft
$c4ba1e9e5760dbcc$exports = $79699b9fe028d3c2$exports('trimStart') ? function trimStart() {
    return $c4ba1e9e5760dbcc$require$$trimStart(this);
// eslint-disable-next-line es/no-string-prototype-trimstart-trimend -- safe
} : ''.trimStart;


// `String.prototype.trimLeft` method
// https://tc39.es/ecma262/#sec-string.prototype.trimleft
// eslint-disable-next-line es/no-string-prototype-trimleft-trimright -- safe
$244155c096ef4c14$exports({
    target: 'String',
    proto: true,
    name: 'trimStart',
    forced: ''.trimLeft !== $c4ba1e9e5760dbcc$exports
}, {
    trimLeft: $c4ba1e9e5760dbcc$exports
});




// `String.prototype.trimStart` method
// https://tc39.es/ecma262/#sec-string.prototype.trimstart
// eslint-disable-next-line es/no-string-prototype-trimstart-trimend -- safe
$244155c096ef4c14$exports({
    target: 'String',
    proto: true,
    name: 'trimStart',
    forced: ''.trimStart !== $c4ba1e9e5760dbcc$exports
}, {
    trimStart: $c4ba1e9e5760dbcc$exports
});


'use strict';

var $16eddf2cc8c34f79$exports = {};
'use strict';



var $16eddf2cc8c34f79$var$quot = /"/g;
var $16eddf2cc8c34f79$var$replace = $c224a7eda28c33b3$exports(''.replace);
// `CreateHTML` abstract operation
// https://tc39.es/ecma262/#sec-createhtml
$16eddf2cc8c34f79$exports = function(string, tag, attribute, value) {
    var S = $7c610b7ee22557b5$exports($0f70b7357550422e$exports(string));
    var p1 = '<' + tag;
    if (attribute !== '') p1 += ' ' + attribute + '="' + $16eddf2cc8c34f79$var$replace($7c610b7ee22557b5$exports(value), $16eddf2cc8c34f79$var$quot, '&quot;') + '"';
    return p1 + '>' + S + '</' + tag + '>';
};


var $f238c24a67a543d2$exports = {};
'use strict';

// check the existence of a method, lowercase
// of a tag and escaping quotes in arguments
$f238c24a67a543d2$exports = function(METHOD_NAME) {
    return $ddd8e9441ae136f2$exports(function() {
        var test = ''[METHOD_NAME]('"');
        return test !== test.toLowerCase() || test.split('"').length > 3;
    });
};


// `String.prototype.anchor` method
// https://tc39.es/ecma262/#sec-string.prototype.anchor
$244155c096ef4c14$exports({
    target: 'String',
    proto: true,
    forced: $f238c24a67a543d2$exports('anchor')
}, {
    anchor: function anchor(name) {
        return $16eddf2cc8c34f79$exports(this, 'a', 'name', name);
    }
});


'use strict';



// `String.prototype.big` method
// https://tc39.es/ecma262/#sec-string.prototype.big
$244155c096ef4c14$exports({
    target: 'String',
    proto: true,
    forced: $f238c24a67a543d2$exports('big')
}, {
    big: function big() {
        return $16eddf2cc8c34f79$exports(this, 'big', '', '');
    }
});


'use strict';



// `String.prototype.blink` method
// https://tc39.es/ecma262/#sec-string.prototype.blink
$244155c096ef4c14$exports({
    target: 'String',
    proto: true,
    forced: $f238c24a67a543d2$exports('blink')
}, {
    blink: function blink() {
        return $16eddf2cc8c34f79$exports(this, 'blink', '', '');
    }
});


'use strict';



// `String.prototype.bold` method
// https://tc39.es/ecma262/#sec-string.prototype.bold
$244155c096ef4c14$exports({
    target: 'String',
    proto: true,
    forced: $f238c24a67a543d2$exports('bold')
}, {
    bold: function bold() {
        return $16eddf2cc8c34f79$exports(this, 'b', '', '');
    }
});


'use strict';



// `String.prototype.fixed` method
// https://tc39.es/ecma262/#sec-string.prototype.fixed
$244155c096ef4c14$exports({
    target: 'String',
    proto: true,
    forced: $f238c24a67a543d2$exports('fixed')
}, {
    fixed: function fixed() {
        return $16eddf2cc8c34f79$exports(this, 'tt', '', '');
    }
});


'use strict';



// `String.prototype.fontcolor` method
// https://tc39.es/ecma262/#sec-string.prototype.fontcolor
$244155c096ef4c14$exports({
    target: 'String',
    proto: true,
    forced: $f238c24a67a543d2$exports('fontcolor')
}, {
    fontcolor: function fontcolor(color) {
        return $16eddf2cc8c34f79$exports(this, 'font', 'color', color);
    }
});


'use strict';



// `String.prototype.fontsize` method
// https://tc39.es/ecma262/#sec-string.prototype.fontsize
$244155c096ef4c14$exports({
    target: 'String',
    proto: true,
    forced: $f238c24a67a543d2$exports('fontsize')
}, {
    fontsize: function fontsize(size) {
        return $16eddf2cc8c34f79$exports(this, 'font', 'size', size);
    }
});


'use strict';



// `String.prototype.italics` method
// https://tc39.es/ecma262/#sec-string.prototype.italics
$244155c096ef4c14$exports({
    target: 'String',
    proto: true,
    forced: $f238c24a67a543d2$exports('italics')
}, {
    italics: function italics() {
        return $16eddf2cc8c34f79$exports(this, 'i', '', '');
    }
});


'use strict';



// `String.prototype.link` method
// https://tc39.es/ecma262/#sec-string.prototype.link
$244155c096ef4c14$exports({
    target: 'String',
    proto: true,
    forced: $f238c24a67a543d2$exports('link')
}, {
    link: function link(url) {
        return $16eddf2cc8c34f79$exports(this, 'a', 'href', url);
    }
});


'use strict';



// `String.prototype.small` method
// https://tc39.es/ecma262/#sec-string.prototype.small
$244155c096ef4c14$exports({
    target: 'String',
    proto: true,
    forced: $f238c24a67a543d2$exports('small')
}, {
    small: function small() {
        return $16eddf2cc8c34f79$exports(this, 'small', '', '');
    }
});


'use strict';



// `String.prototype.strike` method
// https://tc39.es/ecma262/#sec-string.prototype.strike
$244155c096ef4c14$exports({
    target: 'String',
    proto: true,
    forced: $f238c24a67a543d2$exports('strike')
}, {
    strike: function strike() {
        return $16eddf2cc8c34f79$exports(this, 'strike', '', '');
    }
});


'use strict';



// `String.prototype.sub` method
// https://tc39.es/ecma262/#sec-string.prototype.sub
$244155c096ef4c14$exports({
    target: 'String',
    proto: true,
    forced: $f238c24a67a543d2$exports('sub')
}, {
    sub: function sub() {
        return $16eddf2cc8c34f79$exports(this, 'sub', '', '');
    }
});


'use strict';



// `String.prototype.sup` method
// https://tc39.es/ecma262/#sec-string.prototype.sup
$244155c096ef4c14$exports({
    target: 'String',
    proto: true,
    forced: $f238c24a67a543d2$exports('sup')
}, {
    sup: function sup() {
        return $16eddf2cc8c34f79$exports(this, 'sup', '', '');
    }
});


'use strict';
var $d6cc0dd7c3c2a806$exports = {};
'use strict';




var $2c4512e9190dc2eb$exports = {};
'use strict';



var $677553e4d642bc36$exports = {};
'use strict';

















var $677553e4d642bc36$var$enforceInternalState = $fcfe8b5396fbe91a$exports.enforce;
var $677553e4d642bc36$var$getInternalState = $fcfe8b5396fbe91a$exports.get;
var $677553e4d642bc36$var$Int8Array = $27350b6a9e85aed1$exports.Int8Array;
var $677553e4d642bc36$var$Int8ArrayPrototype = $677553e4d642bc36$var$Int8Array && $677553e4d642bc36$var$Int8Array.prototype;
var $677553e4d642bc36$var$Uint8ClampedArray = $27350b6a9e85aed1$exports.Uint8ClampedArray;
var $677553e4d642bc36$var$Uint8ClampedArrayPrototype = $677553e4d642bc36$var$Uint8ClampedArray && $677553e4d642bc36$var$Uint8ClampedArray.prototype;
var $677553e4d642bc36$var$TypedArray = $677553e4d642bc36$var$Int8Array && $5f455f1b83f2c610$exports($677553e4d642bc36$var$Int8Array);
var $677553e4d642bc36$var$TypedArrayPrototype = $677553e4d642bc36$var$Int8ArrayPrototype && $5f455f1b83f2c610$exports($677553e4d642bc36$var$Int8ArrayPrototype);
var $677553e4d642bc36$var$ObjectPrototype = Object.prototype;
var $677553e4d642bc36$var$TypeError = $27350b6a9e85aed1$exports.TypeError;
var $677553e4d642bc36$var$TO_STRING_TAG = $8555fb22f74da29f$exports('toStringTag');
var $677553e4d642bc36$var$TYPED_ARRAY_TAG = $bf14b42fd1d1c367$exports('TYPED_ARRAY_TAG');
var $677553e4d642bc36$var$TYPED_ARRAY_CONSTRUCTOR = 'TypedArrayConstructor';
// Fixing native typed arrays in Opera Presto crashes the browser, see #595
var $677553e4d642bc36$var$NATIVE_ARRAY_BUFFER_VIEWS = $be80dd6d37683baf$exports && !!$7c99bf1a4ca8c337$exports && $b720974ac29b37e2$exports($27350b6a9e85aed1$exports.opera) !== 'Opera';
var $677553e4d642bc36$var$TYPED_ARRAY_TAG_REQUIRED = false;
var $677553e4d642bc36$var$NAME, $677553e4d642bc36$var$Constructor, $677553e4d642bc36$var$Prototype;
var $677553e4d642bc36$var$TypedArrayConstructorsList = {
    Int8Array: 1,
    Uint8Array: 1,
    Uint8ClampedArray: 1,
    Int16Array: 2,
    Uint16Array: 2,
    Int32Array: 4,
    Uint32Array: 4,
    Float32Array: 4,
    Float64Array: 8
};
var $677553e4d642bc36$var$BigIntArrayConstructorsList = {
    BigInt64Array: 8,
    BigUint64Array: 8
};
var $677553e4d642bc36$var$isView = function isView(it) {
    if (!$4d7f82f6c4645870$exports(it)) return false;
    var klass = $b720974ac29b37e2$exports(it);
    return klass === 'DataView' || $8bbc2bccc0a29296$exports($677553e4d642bc36$var$TypedArrayConstructorsList, klass) || $8bbc2bccc0a29296$exports($677553e4d642bc36$var$BigIntArrayConstructorsList, klass);
};
var $677553e4d642bc36$var$getTypedArrayConstructor = function getTypedArrayConstructor1(it) {
    var proto = $5f455f1b83f2c610$exports(it);
    if (!$4d7f82f6c4645870$exports(proto)) return;
    var state = $677553e4d642bc36$var$getInternalState(proto);
    return state && $8bbc2bccc0a29296$exports(state, $677553e4d642bc36$var$TYPED_ARRAY_CONSTRUCTOR) ? state[$677553e4d642bc36$var$TYPED_ARRAY_CONSTRUCTOR] : $677553e4d642bc36$var$getTypedArrayConstructor(proto);
};
var $677553e4d642bc36$var$isTypedArray = function isTypedArray(it) {
    if (!$4d7f82f6c4645870$exports(it)) return false;
    var klass = $b720974ac29b37e2$exports(it);
    return $8bbc2bccc0a29296$exports($677553e4d642bc36$var$TypedArrayConstructorsList, klass) || $8bbc2bccc0a29296$exports($677553e4d642bc36$var$BigIntArrayConstructorsList, klass);
};
var $677553e4d642bc36$var$aTypedArray = function aTypedArray(it) {
    if ($677553e4d642bc36$var$isTypedArray(it)) return it;
    throw new $677553e4d642bc36$var$TypeError('Target is not a typed array');
};
var $677553e4d642bc36$var$aTypedArrayConstructor = function aTypedArrayConstructor(C) {
    if ($7c165f740ca92c53$exports(C) && (!$7c99bf1a4ca8c337$exports || $5c91390ffea610b9$exports($677553e4d642bc36$var$TypedArray, C))) return C;
    throw new $677553e4d642bc36$var$TypeError($287fd49afd1ee632$exports(C) + ' is not a typed array constructor');
};
var $677553e4d642bc36$var$exportTypedArrayMethod = function exportTypedArrayMethod(KEY, property, forced, options) {
    if (!$b9f536d3284d7921$exports) return;
    if (forced) for(var ARRAY in $677553e4d642bc36$var$TypedArrayConstructorsList){
        var TypedArrayConstructor = $27350b6a9e85aed1$exports[ARRAY];
        if (TypedArrayConstructor && $8bbc2bccc0a29296$exports(TypedArrayConstructor.prototype, KEY)) try {
            delete TypedArrayConstructor.prototype[KEY];
        } catch (error) {
            // old WebKit bug - some methods are non-configurable
            try {
                TypedArrayConstructor.prototype[KEY] = property;
            } catch (error2) {}
        }
    }
    if (!$677553e4d642bc36$var$TypedArrayPrototype[KEY] || forced) $73c8864ae5df5c4d$exports($677553e4d642bc36$var$TypedArrayPrototype, KEY, forced ? property : $677553e4d642bc36$var$NATIVE_ARRAY_BUFFER_VIEWS && $677553e4d642bc36$var$Int8ArrayPrototype[KEY] || property, options);
};
var $677553e4d642bc36$var$exportTypedArrayStaticMethod = function exportTypedArrayStaticMethod(KEY, property, forced) {
    var ARRAY, TypedArrayConstructor;
    if (!$b9f536d3284d7921$exports) return;
    if ($7c99bf1a4ca8c337$exports) {
        if (forced) for(ARRAY in $677553e4d642bc36$var$TypedArrayConstructorsList){
            TypedArrayConstructor = $27350b6a9e85aed1$exports[ARRAY];
            if (TypedArrayConstructor && $8bbc2bccc0a29296$exports(TypedArrayConstructor, KEY)) try {
                delete TypedArrayConstructor[KEY];
            } catch (error) {}
        }
        if (!$677553e4d642bc36$var$TypedArray[KEY] || forced) // V8 ~ Chrome 49-50 `%TypedArray%` methods are non-writable non-configurable
        try {
            return $73c8864ae5df5c4d$exports($677553e4d642bc36$var$TypedArray, KEY, forced ? property : $677553e4d642bc36$var$NATIVE_ARRAY_BUFFER_VIEWS && $677553e4d642bc36$var$TypedArray[KEY] || property);
        } catch (error) {}
        else return;
    }
    for(ARRAY in $677553e4d642bc36$var$TypedArrayConstructorsList){
        TypedArrayConstructor = $27350b6a9e85aed1$exports[ARRAY];
        if (TypedArrayConstructor && (!TypedArrayConstructor[KEY] || forced)) $73c8864ae5df5c4d$exports(TypedArrayConstructor, KEY, property);
    }
};
for($677553e4d642bc36$var$NAME in $677553e4d642bc36$var$TypedArrayConstructorsList){
    $677553e4d642bc36$var$Constructor = $27350b6a9e85aed1$exports[$677553e4d642bc36$var$NAME];
    $677553e4d642bc36$var$Prototype = $677553e4d642bc36$var$Constructor && $677553e4d642bc36$var$Constructor.prototype;
    if ($677553e4d642bc36$var$Prototype) $677553e4d642bc36$var$enforceInternalState($677553e4d642bc36$var$Prototype)[$677553e4d642bc36$var$TYPED_ARRAY_CONSTRUCTOR] = $677553e4d642bc36$var$Constructor;
    else $677553e4d642bc36$var$NATIVE_ARRAY_BUFFER_VIEWS = false;
}
for($677553e4d642bc36$var$NAME in $677553e4d642bc36$var$BigIntArrayConstructorsList){
    $677553e4d642bc36$var$Constructor = $27350b6a9e85aed1$exports[$677553e4d642bc36$var$NAME];
    $677553e4d642bc36$var$Prototype = $677553e4d642bc36$var$Constructor && $677553e4d642bc36$var$Constructor.prototype;
    if ($677553e4d642bc36$var$Prototype) $677553e4d642bc36$var$enforceInternalState($677553e4d642bc36$var$Prototype)[$677553e4d642bc36$var$TYPED_ARRAY_CONSTRUCTOR] = $677553e4d642bc36$var$Constructor;
}
// WebKit bug - typed arrays constructors prototype is Object.prototype
if (!$677553e4d642bc36$var$NATIVE_ARRAY_BUFFER_VIEWS || !$7c165f740ca92c53$exports($677553e4d642bc36$var$TypedArray) || $677553e4d642bc36$var$TypedArray === Function.prototype) {
    // eslint-disable-next-line no-shadow -- safe
    $677553e4d642bc36$var$TypedArray = function TypedArray() {
        throw new $677553e4d642bc36$var$TypeError('Incorrect invocation');
    };
    if ($677553e4d642bc36$var$NATIVE_ARRAY_BUFFER_VIEWS) {
        for($677553e4d642bc36$var$NAME in $677553e4d642bc36$var$TypedArrayConstructorsList)if ($27350b6a9e85aed1$exports[$677553e4d642bc36$var$NAME]) $7c99bf1a4ca8c337$exports($27350b6a9e85aed1$exports[$677553e4d642bc36$var$NAME], $677553e4d642bc36$var$TypedArray);
    }
}
if (!$677553e4d642bc36$var$NATIVE_ARRAY_BUFFER_VIEWS || !$677553e4d642bc36$var$TypedArrayPrototype || $677553e4d642bc36$var$TypedArrayPrototype === $677553e4d642bc36$var$ObjectPrototype) {
    $677553e4d642bc36$var$TypedArrayPrototype = $677553e4d642bc36$var$TypedArray.prototype;
    if ($677553e4d642bc36$var$NATIVE_ARRAY_BUFFER_VIEWS) {
        for($677553e4d642bc36$var$NAME in $677553e4d642bc36$var$TypedArrayConstructorsList)if ($27350b6a9e85aed1$exports[$677553e4d642bc36$var$NAME]) $7c99bf1a4ca8c337$exports($27350b6a9e85aed1$exports[$677553e4d642bc36$var$NAME].prototype, $677553e4d642bc36$var$TypedArrayPrototype);
    }
}
// WebKit bug - one more object in Uint8ClampedArray prototype chain
if ($677553e4d642bc36$var$NATIVE_ARRAY_BUFFER_VIEWS && $5f455f1b83f2c610$exports($677553e4d642bc36$var$Uint8ClampedArrayPrototype) !== $677553e4d642bc36$var$TypedArrayPrototype) $7c99bf1a4ca8c337$exports($677553e4d642bc36$var$Uint8ClampedArrayPrototype, $677553e4d642bc36$var$TypedArrayPrototype);
if ($b9f536d3284d7921$exports && !$8bbc2bccc0a29296$exports($677553e4d642bc36$var$TypedArrayPrototype, $677553e4d642bc36$var$TO_STRING_TAG)) {
    $677553e4d642bc36$var$TYPED_ARRAY_TAG_REQUIRED = true;
    $71a985fce44d8187$exports($677553e4d642bc36$var$TypedArrayPrototype, $677553e4d642bc36$var$TO_STRING_TAG, {
        configurable: true,
        get: function get() {
            return $4d7f82f6c4645870$exports(this) ? this[$677553e4d642bc36$var$TYPED_ARRAY_TAG] : undefined;
        }
    });
    for($677553e4d642bc36$var$NAME in $677553e4d642bc36$var$TypedArrayConstructorsList)if ($27350b6a9e85aed1$exports[$677553e4d642bc36$var$NAME]) $b390530569770271$exports($27350b6a9e85aed1$exports[$677553e4d642bc36$var$NAME].prototype, $677553e4d642bc36$var$TYPED_ARRAY_TAG, $677553e4d642bc36$var$NAME);
}
$677553e4d642bc36$exports = {
    NATIVE_ARRAY_BUFFER_VIEWS: $677553e4d642bc36$var$NATIVE_ARRAY_BUFFER_VIEWS,
    TYPED_ARRAY_TAG: $677553e4d642bc36$var$TYPED_ARRAY_TAG_REQUIRED && $677553e4d642bc36$var$TYPED_ARRAY_TAG,
    aTypedArray: $677553e4d642bc36$var$aTypedArray,
    aTypedArrayConstructor: $677553e4d642bc36$var$aTypedArrayConstructor,
    exportTypedArrayMethod: $677553e4d642bc36$var$exportTypedArrayMethod,
    exportTypedArrayStaticMethod: $677553e4d642bc36$var$exportTypedArrayStaticMethod,
    getTypedArrayConstructor: $677553e4d642bc36$var$getTypedArrayConstructor,
    isView: $677553e4d642bc36$var$isView,
    isTypedArray: $677553e4d642bc36$var$isTypedArray,
    TypedArray: $677553e4d642bc36$var$TypedArray,
    TypedArrayPrototype: $677553e4d642bc36$var$TypedArrayPrototype
};


var $2c4512e9190dc2eb$require$NATIVE_ARRAY_BUFFER_VIEWS = $677553e4d642bc36$exports.NATIVE_ARRAY_BUFFER_VIEWS;
var $2c4512e9190dc2eb$var$ArrayBuffer = $27350b6a9e85aed1$exports.ArrayBuffer;
var $2c4512e9190dc2eb$var$Int8Array = $27350b6a9e85aed1$exports.Int8Array;
$2c4512e9190dc2eb$exports = !$2c4512e9190dc2eb$require$NATIVE_ARRAY_BUFFER_VIEWS || !$ddd8e9441ae136f2$exports(function() {
    $2c4512e9190dc2eb$var$Int8Array(1);
}) || !$ddd8e9441ae136f2$exports(function() {
    new $2c4512e9190dc2eb$var$Int8Array(-1);
}) || !$d1cf75d632965c8c$exports(function(iterable) {
    new $2c4512e9190dc2eb$var$Int8Array();
    new $2c4512e9190dc2eb$var$Int8Array(null);
    new $2c4512e9190dc2eb$var$Int8Array(1.5);
    new $2c4512e9190dc2eb$var$Int8Array(iterable);
}, true) || $ddd8e9441ae136f2$exports(function() {
    // Safari (11+) bug - a reason why even Safari 13 should load a typed array polyfill
    return new $2c4512e9190dc2eb$var$Int8Array(new $2c4512e9190dc2eb$var$ArrayBuffer(2), 1, undefined).length !== 1;
});









var $31106545a50ae7f9$exports = {};
'use strict';
var $9480edb60f92d438$exports = {};
'use strict';

var $9480edb60f92d438$var$$RangeError = RangeError;
$9480edb60f92d438$exports = function(it) {
    var result = $a8fecfd456e884de$exports(it);
    if (result < 0) throw new $9480edb60f92d438$var$$RangeError("The argument can't be less than 0");
    return result;
};


var $31106545a50ae7f9$var$$RangeError = RangeError;
$31106545a50ae7f9$exports = function(it, BYTES) {
    var offset = $9480edb60f92d438$exports(it);
    if (offset % BYTES) throw new $31106545a50ae7f9$var$$RangeError('Wrong offset');
    return offset;
};


var $22f5f5737107a0fa$exports = {};
'use strict';
var $22f5f5737107a0fa$var$floor = Math.floor;
// https://tc39.es/ecma262/#sec-touint8clamp
$22f5f5737107a0fa$exports = function(it) {
    var number = +it;
    // eslint-disable-next-line no-self-compare -- NaN check
    if (number !== number || number <= 0) return 0;
    if (number >= 0xFF) return 0xFF;
    var f = $22f5f5737107a0fa$var$floor(number);
    if (f + 0.5 < number) return f + 1;
    if (number < f + 0.5) return f;
    // round-half-to-even (banker's rounding)
    return f % 2 === 0 ? f : f + 1;
};











var $d6cc0dd7c3c2a806$require$getOwnPropertyNames = $8b92903d5cdf859e$export$2d1720544b23b823;
var $68be5f055821695d$exports = {};
'use strict';









var $e0621e1e2640257b$exports = {};
'use strict';

$e0621e1e2640257b$exports = function(it) {
    var klass = $b720974ac29b37e2$exports(it);
    return klass === 'BigInt64Array' || klass === 'BigUint64Array';
};



var $68be5f055821695d$require$aTypedArrayConstructor = $677553e4d642bc36$exports.aTypedArrayConstructor;
var $40a3824366711b65$exports = {};
'use strict';

var $40a3824366711b65$var$$TypeError = TypeError;
// `ToBigInt` abstract operation
// https://tc39.es/ecma262/#sec-tobigint
$40a3824366711b65$exports = function(argument) {
    var prim = $5502f9db3352ad96$exports(argument, 'number');
    if (typeof prim == 'number') throw new $40a3824366711b65$var$$TypeError("Can't convert number to bigint");
    // eslint-disable-next-line es/no-bigint -- safe
    return BigInt(prim);
};


$68be5f055821695d$exports = function from(source /* , mapfn, thisArg */ ) {
    var C = $2208800311a8332a$exports(this);
    var argumentsLength = arguments.length;
    var mapfn = argumentsLength > 1 ? arguments[1] : undefined;
    var mapping = mapfn !== undefined;
    if (mapping) $082fcaa0a091ee30$exports(mapfn);
    var O = $ad1d9797f1e27af5$exports(source);
    var iteratorMethod = $72368fb318b24c5c$exports(O);
    var i, length, result, thisIsBigIntArray, value, step, iterator, next;
    if (iteratorMethod && !$6403e03a78aa5d48$exports(iteratorMethod)) {
        iterator = $76e56b966649496d$exports(O, iteratorMethod);
        next = iterator.next;
        O = [];
        while(!(step = $59bf80837927ca02$exports(next, iterator)).done)O.push(step.value);
    }
    if (mapping && argumentsLength > 2) mapfn = $8a0b7edcb386df4b$exports(mapfn, arguments[2]);
    length = $dfe69c9cb1d4aa6b$exports(O);
    result = new ($68be5f055821695d$require$aTypedArrayConstructor(C))(length);
    thisIsBigIntArray = $e0621e1e2640257b$exports(result);
    for(i = 0; length > i; i++){
        value = mapping ? mapfn(O[i], i) : O[i];
        // FF30- typed arrays doesn't properly convert objects to typed array values
        result[i] = thisIsBigIntArray ? $40a3824366711b65$exports(value) : +value;
    }
    return result;
};



var $d6cc0dd7c3c2a806$require$forEach = $549edc5c9a026f8b$exports.forEach;




var $96d146c1e2e2f6fc$exports = {};
'use strict';

$96d146c1e2e2f6fc$exports = function(Constructor, list, $length) {
    var index = 0;
    var length = arguments.length > 2 ? $length : $dfe69c9cb1d4aa6b$exports(list);
    var result = new Constructor(length);
    while(length > index)result[index] = list[index++];
    return result;
};




var $d6cc0dd7c3c2a806$var$getInternalState = $fcfe8b5396fbe91a$exports.get;
var $d6cc0dd7c3c2a806$var$setInternalState = $fcfe8b5396fbe91a$exports.set;
var $d6cc0dd7c3c2a806$var$enforceInternalState = $fcfe8b5396fbe91a$exports.enforce;
var $d6cc0dd7c3c2a806$var$nativeDefineProperty = $6f9fc35f567fa5b6$export$2d1720544b23b823;
var $d6cc0dd7c3c2a806$var$nativeGetOwnPropertyDescriptor = $70871da05e9d21bf$export$2d1720544b23b823;
var $d6cc0dd7c3c2a806$var$RangeError = $27350b6a9e85aed1$exports.RangeError;
var $d6cc0dd7c3c2a806$var$ArrayBuffer = $e48fe9c4d5e5f9fa$exports.ArrayBuffer;
var $d6cc0dd7c3c2a806$var$ArrayBufferPrototype = $d6cc0dd7c3c2a806$var$ArrayBuffer.prototype;
var $d6cc0dd7c3c2a806$var$DataView = $e48fe9c4d5e5f9fa$exports.DataView;
var $d6cc0dd7c3c2a806$var$NATIVE_ARRAY_BUFFER_VIEWS = $677553e4d642bc36$exports.NATIVE_ARRAY_BUFFER_VIEWS;
var $d6cc0dd7c3c2a806$var$TYPED_ARRAY_TAG = $677553e4d642bc36$exports.TYPED_ARRAY_TAG;
var $d6cc0dd7c3c2a806$var$TypedArray = $677553e4d642bc36$exports.TypedArray;
var $d6cc0dd7c3c2a806$var$TypedArrayPrototype = $677553e4d642bc36$exports.TypedArrayPrototype;
var $d6cc0dd7c3c2a806$var$isTypedArray = $677553e4d642bc36$exports.isTypedArray;
var $d6cc0dd7c3c2a806$var$BYTES_PER_ELEMENT = 'BYTES_PER_ELEMENT';
var $d6cc0dd7c3c2a806$var$WRONG_LENGTH = 'Wrong length';
var $d6cc0dd7c3c2a806$var$addGetter = function addGetter(it, key) {
    $71a985fce44d8187$exports(it, key, {
        configurable: true,
        get: function get() {
            return $d6cc0dd7c3c2a806$var$getInternalState(this)[key];
        }
    });
};
var $d6cc0dd7c3c2a806$var$isArrayBuffer = function isArrayBuffer(it) {
    var klass;
    return $5c91390ffea610b9$exports($d6cc0dd7c3c2a806$var$ArrayBufferPrototype, it) || (klass = $b720974ac29b37e2$exports(it)) === 'ArrayBuffer' || klass === 'SharedArrayBuffer';
};
var $d6cc0dd7c3c2a806$var$isTypedArrayIndex = function isTypedArrayIndex(target, key) {
    return $d6cc0dd7c3c2a806$var$isTypedArray(target) && !$3b5b0fa19aea9b5a$exports(key) && key in target && $344929e29a2a0e48$exports(+key) && key >= 0;
};
var $d6cc0dd7c3c2a806$var$wrappedGetOwnPropertyDescriptor = function getOwnPropertyDescriptor(target, key) {
    key = $d9a9cf8e89852c56$exports(key);
    return $d6cc0dd7c3c2a806$var$isTypedArrayIndex(target, key) ? $27c455d39660edb8$exports(2, target[key]) : $d6cc0dd7c3c2a806$var$nativeGetOwnPropertyDescriptor(target, key);
};
var $d6cc0dd7c3c2a806$var$wrappedDefineProperty = function defineProperty(target, key, descriptor) {
    key = $d9a9cf8e89852c56$exports(key);
    if ($d6cc0dd7c3c2a806$var$isTypedArrayIndex(target, key) && $4d7f82f6c4645870$exports(descriptor) && $8bbc2bccc0a29296$exports(descriptor, 'value') && !$8bbc2bccc0a29296$exports(descriptor, 'get') && !$8bbc2bccc0a29296$exports(descriptor, 'set') && !descriptor.configurable && (!$8bbc2bccc0a29296$exports(descriptor, 'writable') || descriptor.writable) && (!$8bbc2bccc0a29296$exports(descriptor, 'enumerable') || descriptor.enumerable)) {
        target[key] = descriptor.value;
        return target;
    }
    return $d6cc0dd7c3c2a806$var$nativeDefineProperty(target, key, descriptor);
};
if ($b9f536d3284d7921$exports) {
    if (!$d6cc0dd7c3c2a806$var$NATIVE_ARRAY_BUFFER_VIEWS) {
        $70871da05e9d21bf$exports.f = $d6cc0dd7c3c2a806$var$wrappedGetOwnPropertyDescriptor;
        $6f9fc35f567fa5b6$exports.f = $d6cc0dd7c3c2a806$var$wrappedDefineProperty;
        $d6cc0dd7c3c2a806$var$addGetter($d6cc0dd7c3c2a806$var$TypedArrayPrototype, 'buffer');
        $d6cc0dd7c3c2a806$var$addGetter($d6cc0dd7c3c2a806$var$TypedArrayPrototype, 'byteOffset');
        $d6cc0dd7c3c2a806$var$addGetter($d6cc0dd7c3c2a806$var$TypedArrayPrototype, 'byteLength');
        $d6cc0dd7c3c2a806$var$addGetter($d6cc0dd7c3c2a806$var$TypedArrayPrototype, 'length');
    }
    $244155c096ef4c14$exports({
        target: 'Object',
        stat: true,
        forced: !$d6cc0dd7c3c2a806$var$NATIVE_ARRAY_BUFFER_VIEWS
    }, {
        getOwnPropertyDescriptor: $d6cc0dd7c3c2a806$var$wrappedGetOwnPropertyDescriptor,
        defineProperty: $d6cc0dd7c3c2a806$var$wrappedDefineProperty
    });
    $d6cc0dd7c3c2a806$exports = function(TYPE, wrapper, CLAMPED) {
        var BYTES = TYPE.match(/\d+/)[0] / 8;
        var CONSTRUCTOR_NAME = TYPE + (CLAMPED ? 'Clamped' : '') + 'Array';
        var GETTER = 'get' + TYPE;
        var SETTER = 'set' + TYPE;
        var NativeTypedArrayConstructor = $27350b6a9e85aed1$exports[CONSTRUCTOR_NAME];
        var TypedArrayConstructor = NativeTypedArrayConstructor;
        var TypedArrayConstructorPrototype = TypedArrayConstructor && TypedArrayConstructor.prototype;
        var exported = {};
        var getter = function getter(that, index) {
            var data = $d6cc0dd7c3c2a806$var$getInternalState(that);
            return data.view[GETTER](index * BYTES + data.byteOffset, true);
        };
        var setter = function setter(that, index, value) {
            var data = $d6cc0dd7c3c2a806$var$getInternalState(that);
            data.view[SETTER](index * BYTES + data.byteOffset, CLAMPED ? $22f5f5737107a0fa$exports(value) : value, true);
        };
        var addElement = function addElement(that, index) {
            $d6cc0dd7c3c2a806$var$nativeDefineProperty(that, index, {
                get: function get() {
                    return getter(this, index);
                },
                set: function set(value) {
                    return setter(this, index, value);
                },
                enumerable: true
            });
        };
        if (!$d6cc0dd7c3c2a806$var$NATIVE_ARRAY_BUFFER_VIEWS) {
            TypedArrayConstructor = wrapper(function(that, data, offset, $length) {
                $93a46accb3e7c173$exports(that, TypedArrayConstructorPrototype);
                var index = 0;
                var byteOffset = 0;
                var buffer, byteLength, length;
                if (!$4d7f82f6c4645870$exports(data)) {
                    length = $31c8128d403d84d3$exports(data);
                    byteLength = length * BYTES;
                    buffer = new $d6cc0dd7c3c2a806$var$ArrayBuffer(byteLength);
                } else if ($d6cc0dd7c3c2a806$var$isArrayBuffer(data)) {
                    buffer = data;
                    byteOffset = $31106545a50ae7f9$exports(offset, BYTES);
                    var $len = data.byteLength;
                    if ($length === undefined) {
                        if ($len % BYTES) throw new $d6cc0dd7c3c2a806$var$RangeError($d6cc0dd7c3c2a806$var$WRONG_LENGTH);
                        byteLength = $len - byteOffset;
                        if (byteLength < 0) throw new $d6cc0dd7c3c2a806$var$RangeError($d6cc0dd7c3c2a806$var$WRONG_LENGTH);
                    } else {
                        byteLength = $31c8128d403d84d3$exports($length) * BYTES;
                        if (byteLength + byteOffset > $len) throw new $d6cc0dd7c3c2a806$var$RangeError($d6cc0dd7c3c2a806$var$WRONG_LENGTH);
                    }
                    length = byteLength / BYTES;
                } else if ($d6cc0dd7c3c2a806$var$isTypedArray(data)) return $96d146c1e2e2f6fc$exports(TypedArrayConstructor, data);
                else return $59bf80837927ca02$exports($68be5f055821695d$exports, TypedArrayConstructor, data);
                $d6cc0dd7c3c2a806$var$setInternalState(that, {
                    buffer: buffer,
                    byteOffset: byteOffset,
                    byteLength: byteLength,
                    length: length,
                    view: new $d6cc0dd7c3c2a806$var$DataView(buffer)
                });
                while(index < length)addElement(that, index++);
            });
            if ($7c99bf1a4ca8c337$exports) $7c99bf1a4ca8c337$exports(TypedArrayConstructor, $d6cc0dd7c3c2a806$var$TypedArray);
            TypedArrayConstructorPrototype = TypedArrayConstructor.prototype = $491a5d5aa2efe6ec$exports($d6cc0dd7c3c2a806$var$TypedArrayPrototype);
        } else if ($2c4512e9190dc2eb$exports) {
            TypedArrayConstructor = wrapper(function(dummy, data, typedArrayOffset, $length) {
                $93a46accb3e7c173$exports(dummy, TypedArrayConstructorPrototype);
                return $834423bfd6526b45$exports(function() {
                    if (!$4d7f82f6c4645870$exports(data)) return new NativeTypedArrayConstructor($31c8128d403d84d3$exports(data));
                    if ($d6cc0dd7c3c2a806$var$isArrayBuffer(data)) return $length !== undefined ? new NativeTypedArrayConstructor(data, $31106545a50ae7f9$exports(typedArrayOffset, BYTES), $length) : typedArrayOffset !== undefined ? new NativeTypedArrayConstructor(data, $31106545a50ae7f9$exports(typedArrayOffset, BYTES)) : new NativeTypedArrayConstructor(data);
                    if ($d6cc0dd7c3c2a806$var$isTypedArray(data)) return $96d146c1e2e2f6fc$exports(TypedArrayConstructor, data);
                    return $59bf80837927ca02$exports($68be5f055821695d$exports, TypedArrayConstructor, data);
                }(), dummy, TypedArrayConstructor);
            });
            if ($7c99bf1a4ca8c337$exports) $7c99bf1a4ca8c337$exports(TypedArrayConstructor, $d6cc0dd7c3c2a806$var$TypedArray);
            $d6cc0dd7c3c2a806$require$forEach($d6cc0dd7c3c2a806$require$getOwnPropertyNames(NativeTypedArrayConstructor), function(key) {
                if (!(key in TypedArrayConstructor)) $b390530569770271$exports(TypedArrayConstructor, key, NativeTypedArrayConstructor[key]);
            });
            TypedArrayConstructor.prototype = TypedArrayConstructorPrototype;
        }
        if (TypedArrayConstructorPrototype.constructor !== TypedArrayConstructor) $b390530569770271$exports(TypedArrayConstructorPrototype, 'constructor', TypedArrayConstructor);
        $d6cc0dd7c3c2a806$var$enforceInternalState(TypedArrayConstructorPrototype).TypedArrayConstructor = TypedArrayConstructor;
        if ($d6cc0dd7c3c2a806$var$TYPED_ARRAY_TAG) $b390530569770271$exports(TypedArrayConstructorPrototype, $d6cc0dd7c3c2a806$var$TYPED_ARRAY_TAG, CONSTRUCTOR_NAME);
        var FORCED = TypedArrayConstructor !== NativeTypedArrayConstructor;
        exported[CONSTRUCTOR_NAME] = TypedArrayConstructor;
        $244155c096ef4c14$exports({
            global: true,
            constructor: true,
            forced: FORCED,
            sham: !$d6cc0dd7c3c2a806$var$NATIVE_ARRAY_BUFFER_VIEWS
        }, exported);
        if (!($d6cc0dd7c3c2a806$var$BYTES_PER_ELEMENT in TypedArrayConstructor)) $b390530569770271$exports(TypedArrayConstructor, $d6cc0dd7c3c2a806$var$BYTES_PER_ELEMENT, BYTES);
        if (!($d6cc0dd7c3c2a806$var$BYTES_PER_ELEMENT in TypedArrayConstructorPrototype)) $b390530569770271$exports(TypedArrayConstructorPrototype, $d6cc0dd7c3c2a806$var$BYTES_PER_ELEMENT, BYTES);
        $2eb70ff7aa9594a1$exports(CONSTRUCTOR_NAME);
    };
} else $d6cc0dd7c3c2a806$exports = function() {};


// `Float32Array` constructor
// https://tc39.es/ecma262/#sec-typedarray-objects
$d6cc0dd7c3c2a806$exports('Float32', function(init) {
    return function Float32Array(data, byteOffset, length) {
        return init(this, data, byteOffset, length);
    };
});


'use strict';

// `Float64Array` constructor
// https://tc39.es/ecma262/#sec-typedarray-objects
$d6cc0dd7c3c2a806$exports('Float64', function(init) {
    return function Float64Array(data, byteOffset, length) {
        return init(this, data, byteOffset, length);
    };
});


'use strict';

// `Int8Array` constructor
// https://tc39.es/ecma262/#sec-typedarray-objects
$d6cc0dd7c3c2a806$exports('Int8', function(init) {
    return function Int8Array(data, byteOffset, length) {
        return init(this, data, byteOffset, length);
    };
});


'use strict';

// `Int16Array` constructor
// https://tc39.es/ecma262/#sec-typedarray-objects
$d6cc0dd7c3c2a806$exports('Int16', function(init) {
    return function Int16Array(data, byteOffset, length) {
        return init(this, data, byteOffset, length);
    };
});


'use strict';

// `Int32Array` constructor
// https://tc39.es/ecma262/#sec-typedarray-objects
$d6cc0dd7c3c2a806$exports('Int32', function(init) {
    return function Int32Array(data, byteOffset, length) {
        return init(this, data, byteOffset, length);
    };
});


'use strict';

// `Uint8Array` constructor
// https://tc39.es/ecma262/#sec-typedarray-objects
$d6cc0dd7c3c2a806$exports('Uint8', function(init) {
    return function Uint8Array(data, byteOffset, length) {
        return init(this, data, byteOffset, length);
    };
});


'use strict';

// `Uint8ClampedArray` constructor
// https://tc39.es/ecma262/#sec-typedarray-objects
$d6cc0dd7c3c2a806$exports('Uint8', function(init) {
    return function Uint8ClampedArray(data, byteOffset, length) {
        return init(this, data, byteOffset, length);
    };
}, true);


'use strict';

// `Uint16Array` constructor
// https://tc39.es/ecma262/#sec-typedarray-objects
$d6cc0dd7c3c2a806$exports('Uint16', function(init) {
    return function Uint16Array(data, byteOffset, length) {
        return init(this, data, byteOffset, length);
    };
});


'use strict';

// `Uint32Array` constructor
// https://tc39.es/ecma262/#sec-typedarray-objects
$d6cc0dd7c3c2a806$exports('Uint32', function(init) {
    return function Uint32Array(data, byteOffset, length) {
        return init(this, data, byteOffset, length);
    };
});


'use strict';



var $4dd87ba81abca04a$var$u$ArrayCopyWithin = $c224a7eda28c33b3$exports($f6b6df437e185c59$exports);
var $4dd87ba81abca04a$var$aTypedArray = $677553e4d642bc36$exports.aTypedArray;
var $4dd87ba81abca04a$var$exportTypedArrayMethod = $677553e4d642bc36$exports.exportTypedArrayMethod;
// `%TypedArray%.prototype.copyWithin` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.copywithin
$4dd87ba81abca04a$var$exportTypedArrayMethod('copyWithin', function copyWithin(target, start /* , end */ ) {
    return $4dd87ba81abca04a$var$u$ArrayCopyWithin($4dd87ba81abca04a$var$aTypedArray(this), target, start, arguments.length > 2 ? arguments[2] : undefined);
});


'use strict';


var $108df0be2048f2b5$require$$every = $549edc5c9a026f8b$exports.every;
var $108df0be2048f2b5$var$aTypedArray = $677553e4d642bc36$exports.aTypedArray;
var $108df0be2048f2b5$var$exportTypedArrayMethod = $677553e4d642bc36$exports.exportTypedArrayMethod;
// `%TypedArray%.prototype.every` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.every
$108df0be2048f2b5$var$exportTypedArrayMethod('every', function every(callbackfn /* , thisArg */ ) {
    return $108df0be2048f2b5$require$$every($108df0be2048f2b5$var$aTypedArray(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
});


'use strict';







var $6b6eded66a24beae$var$aTypedArray = $677553e4d642bc36$exports.aTypedArray;
var $6b6eded66a24beae$var$exportTypedArrayMethod = $677553e4d642bc36$exports.exportTypedArrayMethod;
var $6b6eded66a24beae$var$slice = $c224a7eda28c33b3$exports(''.slice);
// V8 ~ Chrome < 59, Safari < 14.1, FF < 55, Edge <=18
var $6b6eded66a24beae$var$CONVERSION_BUG = $ddd8e9441ae136f2$exports(function() {
    var count = 0;
    // eslint-disable-next-line es/no-typed-arrays -- safe
    new Int8Array(2).fill({
        valueOf: function valueOf() {
            return count++;
        }
    });
    return count !== 1;
});
// `%TypedArray%.prototype.fill` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.fill
$6b6eded66a24beae$var$exportTypedArrayMethod('fill', function fill(value /* , start, end */ ) {
    var length = arguments.length;
    $6b6eded66a24beae$var$aTypedArray(this);
    var actualValue = $6b6eded66a24beae$var$slice($b720974ac29b37e2$exports(this), 0, 3) === 'Big' ? $40a3824366711b65$exports(value) : +value;
    return $59bf80837927ca02$exports($635ab17dab618628$exports, this, actualValue, length > 1 ? arguments[1] : undefined, length > 2 ? arguments[2] : undefined);
}, $6b6eded66a24beae$var$CONVERSION_BUG);


'use strict';


var $edf81db4378bef1d$require$$filter = $549edc5c9a026f8b$exports.filter;
var $67f797a01ba0cd02$exports = {};
'use strict';


var $67f797a01ba0cd02$require$getTypedArrayConstructor = $677553e4d642bc36$exports.getTypedArrayConstructor;
$67f797a01ba0cd02$exports = function(instance, list) {
    return $96d146c1e2e2f6fc$exports($67f797a01ba0cd02$require$getTypedArrayConstructor(instance), list);
};


var $edf81db4378bef1d$var$aTypedArray = $677553e4d642bc36$exports.aTypedArray;
var $edf81db4378bef1d$var$exportTypedArrayMethod = $677553e4d642bc36$exports.exportTypedArrayMethod;
// `%TypedArray%.prototype.filter` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.filter
$edf81db4378bef1d$var$exportTypedArrayMethod('filter', function filter(callbackfn /* , thisArg */ ) {
    var list = $edf81db4378bef1d$require$$filter($edf81db4378bef1d$var$aTypedArray(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
    return $67f797a01ba0cd02$exports(this, list);
});


'use strict';


var $56e11448f15c3471$require$$find = $549edc5c9a026f8b$exports.find;
var $56e11448f15c3471$var$aTypedArray = $677553e4d642bc36$exports.aTypedArray;
var $56e11448f15c3471$var$exportTypedArrayMethod = $677553e4d642bc36$exports.exportTypedArrayMethod;
// `%TypedArray%.prototype.find` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.find
$56e11448f15c3471$var$exportTypedArrayMethod('find', function find(predicate /* , thisArg */ ) {
    return $56e11448f15c3471$require$$find($56e11448f15c3471$var$aTypedArray(this), predicate, arguments.length > 1 ? arguments[1] : undefined);
});


'use strict';


var $be569ef9229b2520$require$$findIndex = $549edc5c9a026f8b$exports.findIndex;
var $be569ef9229b2520$var$aTypedArray = $677553e4d642bc36$exports.aTypedArray;
var $be569ef9229b2520$var$exportTypedArrayMethod = $677553e4d642bc36$exports.exportTypedArrayMethod;
// `%TypedArray%.prototype.findIndex` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.findindex
$be569ef9229b2520$var$exportTypedArrayMethod('findIndex', function findIndex(predicate /* , thisArg */ ) {
    return $be569ef9229b2520$require$$findIndex($be569ef9229b2520$var$aTypedArray(this), predicate, arguments.length > 1 ? arguments[1] : undefined);
});


'use strict';


var $e47ed383bca8c9b4$require$$forEach = $549edc5c9a026f8b$exports.forEach;
var $e47ed383bca8c9b4$var$aTypedArray = $677553e4d642bc36$exports.aTypedArray;
var $e47ed383bca8c9b4$var$exportTypedArrayMethod = $677553e4d642bc36$exports.exportTypedArrayMethod;
// `%TypedArray%.prototype.forEach` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.foreach
$e47ed383bca8c9b4$var$exportTypedArrayMethod('forEach', function forEach(callbackfn /* , thisArg */ ) {
    $e47ed383bca8c9b4$require$$forEach($e47ed383bca8c9b4$var$aTypedArray(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
});


'use strict';


var $27b6f06a2ecc340a$require$exportTypedArrayStaticMethod = $677553e4d642bc36$exports.exportTypedArrayStaticMethod;

// `%TypedArray%.from` method
// https://tc39.es/ecma262/#sec-%typedarray%.from
$27b6f06a2ecc340a$require$exportTypedArrayStaticMethod('from', $68be5f055821695d$exports, $2c4512e9190dc2eb$exports);


'use strict';


var $eb45b6b8928b2a3c$require$$includes = $71c0092aac59bdd8$exports.includes;
var $eb45b6b8928b2a3c$var$aTypedArray = $677553e4d642bc36$exports.aTypedArray;
var $eb45b6b8928b2a3c$var$exportTypedArrayMethod = $677553e4d642bc36$exports.exportTypedArrayMethod;
// `%TypedArray%.prototype.includes` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.includes
$eb45b6b8928b2a3c$var$exportTypedArrayMethod('includes', function includes(searchElement /* , fromIndex */ ) {
    return $eb45b6b8928b2a3c$require$$includes($eb45b6b8928b2a3c$var$aTypedArray(this), searchElement, arguments.length > 1 ? arguments[1] : undefined);
});


'use strict';


var $86cf8b7fc3ef0a4c$require$$indexOf = $71c0092aac59bdd8$exports.indexOf;
var $86cf8b7fc3ef0a4c$var$aTypedArray = $677553e4d642bc36$exports.aTypedArray;
var $86cf8b7fc3ef0a4c$var$exportTypedArrayMethod = $677553e4d642bc36$exports.exportTypedArrayMethod;
// `%TypedArray%.prototype.indexOf` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.indexof
$86cf8b7fc3ef0a4c$var$exportTypedArrayMethod('indexOf', function indexOf(searchElement /* , fromIndex */ ) {
    return $86cf8b7fc3ef0a4c$require$$indexOf($86cf8b7fc3ef0a4c$var$aTypedArray(this), searchElement, arguments.length > 1 ? arguments[1] : undefined);
});


'use strict';






var $3dc23917e4c0f6dd$var$ITERATOR = $8555fb22f74da29f$exports('iterator');
var $3dc23917e4c0f6dd$var$Uint8Array = $27350b6a9e85aed1$exports.Uint8Array;
var $3dc23917e4c0f6dd$var$arrayValues = $c224a7eda28c33b3$exports($a6770789dc15a9c7$exports.values);
var $3dc23917e4c0f6dd$var$arrayKeys = $c224a7eda28c33b3$exports($a6770789dc15a9c7$exports.keys);
var $3dc23917e4c0f6dd$var$arrayEntries = $c224a7eda28c33b3$exports($a6770789dc15a9c7$exports.entries);
var $3dc23917e4c0f6dd$var$aTypedArray = $677553e4d642bc36$exports.aTypedArray;
var $3dc23917e4c0f6dd$var$exportTypedArrayMethod = $677553e4d642bc36$exports.exportTypedArrayMethod;
var $3dc23917e4c0f6dd$var$TypedArrayPrototype = $3dc23917e4c0f6dd$var$Uint8Array && $3dc23917e4c0f6dd$var$Uint8Array.prototype;
var $3dc23917e4c0f6dd$var$GENERIC = !$ddd8e9441ae136f2$exports(function() {
    $3dc23917e4c0f6dd$var$TypedArrayPrototype[$3dc23917e4c0f6dd$var$ITERATOR].call([
        1
    ]);
});
var $3dc23917e4c0f6dd$var$ITERATOR_IS_VALUES = !!$3dc23917e4c0f6dd$var$TypedArrayPrototype && $3dc23917e4c0f6dd$var$TypedArrayPrototype.values && $3dc23917e4c0f6dd$var$TypedArrayPrototype[$3dc23917e4c0f6dd$var$ITERATOR] === $3dc23917e4c0f6dd$var$TypedArrayPrototype.values && $3dc23917e4c0f6dd$var$TypedArrayPrototype.values.name === 'values';
var $3dc23917e4c0f6dd$var$typedArrayValues = function values() {
    return $3dc23917e4c0f6dd$var$arrayValues($3dc23917e4c0f6dd$var$aTypedArray(this));
};
// `%TypedArray%.prototype.entries` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.entries
$3dc23917e4c0f6dd$var$exportTypedArrayMethod('entries', function entries() {
    return $3dc23917e4c0f6dd$var$arrayEntries($3dc23917e4c0f6dd$var$aTypedArray(this));
}, $3dc23917e4c0f6dd$var$GENERIC);
// `%TypedArray%.prototype.keys` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.keys
$3dc23917e4c0f6dd$var$exportTypedArrayMethod('keys', function keys() {
    return $3dc23917e4c0f6dd$var$arrayKeys($3dc23917e4c0f6dd$var$aTypedArray(this));
}, $3dc23917e4c0f6dd$var$GENERIC);
// `%TypedArray%.prototype.values` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.values
$3dc23917e4c0f6dd$var$exportTypedArrayMethod('values', $3dc23917e4c0f6dd$var$typedArrayValues, $3dc23917e4c0f6dd$var$GENERIC || !$3dc23917e4c0f6dd$var$ITERATOR_IS_VALUES, {
    name: 'values'
});
// `%TypedArray%.prototype[@@iterator]` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype-@@iterator
$3dc23917e4c0f6dd$var$exportTypedArrayMethod($3dc23917e4c0f6dd$var$ITERATOR, $3dc23917e4c0f6dd$var$typedArrayValues, $3dc23917e4c0f6dd$var$GENERIC || !$3dc23917e4c0f6dd$var$ITERATOR_IS_VALUES, {
    name: 'values'
});


'use strict';


var $e082d02af94eacc6$var$aTypedArray = $677553e4d642bc36$exports.aTypedArray;
var $e082d02af94eacc6$var$exportTypedArrayMethod = $677553e4d642bc36$exports.exportTypedArrayMethod;
var $e082d02af94eacc6$var$$join = $c224a7eda28c33b3$exports([].join);
// `%TypedArray%.prototype.join` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.join
$e082d02af94eacc6$var$exportTypedArrayMethod('join', function join(separator) {
    return $e082d02af94eacc6$var$$join($e082d02af94eacc6$var$aTypedArray(this), separator);
});


'use strict';


var $47bb45b075fd3aa7$exports = {};
'use strict';





var $47bb45b075fd3aa7$var$min = Math.min;
var $47bb45b075fd3aa7$var$$lastIndexOf = [].lastIndexOf;
var $47bb45b075fd3aa7$var$NEGATIVE_ZERO = !!$47bb45b075fd3aa7$var$$lastIndexOf && 1 / [
    1
].lastIndexOf(1, -0) < 0;
var $47bb45b075fd3aa7$var$STRICT_METHOD = $e6cb878020bcaa14$exports('lastIndexOf');
var $47bb45b075fd3aa7$var$FORCED = $47bb45b075fd3aa7$var$NEGATIVE_ZERO || !$47bb45b075fd3aa7$var$STRICT_METHOD;
// `Array.prototype.lastIndexOf` method implementation
// https://tc39.es/ecma262/#sec-array.prototype.lastindexof
$47bb45b075fd3aa7$exports = $47bb45b075fd3aa7$var$FORCED ? function lastIndexOf(searchElement /* , fromIndex = @[*-1] */ ) {
    // convert -0 to +0
    if ($47bb45b075fd3aa7$var$NEGATIVE_ZERO) return $eb64554a295b6978$exports($47bb45b075fd3aa7$var$$lastIndexOf, this, arguments) || 0;
    var O = $59a8f2f00edbf5a1$exports(this);
    var length = $dfe69c9cb1d4aa6b$exports(O);
    if (length === 0) return -1;
    var index = length - 1;
    if (arguments.length > 1) index = $47bb45b075fd3aa7$var$min(index, $a8fecfd456e884de$exports(arguments[1]));
    if (index < 0) index = length + index;
    for(; index >= 0; index--)if (index in O && O[index] === searchElement) return index || 0;
    return -1;
} : $47bb45b075fd3aa7$var$$lastIndexOf;


var $a799047498556f9c$var$aTypedArray = $677553e4d642bc36$exports.aTypedArray;
var $a799047498556f9c$var$exportTypedArrayMethod = $677553e4d642bc36$exports.exportTypedArrayMethod;
// `%TypedArray%.prototype.lastIndexOf` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.lastindexof
$a799047498556f9c$var$exportTypedArrayMethod('lastIndexOf', function lastIndexOf(searchElement /* , fromIndex */ ) {
    var length = arguments.length;
    return $eb64554a295b6978$exports($47bb45b075fd3aa7$exports, $a799047498556f9c$var$aTypedArray(this), length > 1 ? [
        searchElement,
        arguments[1]
    ] : [
        searchElement
    ]);
});


'use strict';


var $02c2cc5997136153$require$$map = $549edc5c9a026f8b$exports.map;

var $02c2cc5997136153$var$aTypedArray = $677553e4d642bc36$exports.aTypedArray;
var $02c2cc5997136153$var$exportTypedArrayMethod = $677553e4d642bc36$exports.exportTypedArrayMethod;
// `%TypedArray%.prototype.map` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.map
$02c2cc5997136153$var$exportTypedArrayMethod('map', function map(mapfn /* , thisArg */ ) {
    var list = $02c2cc5997136153$require$$map($02c2cc5997136153$var$aTypedArray(this), mapfn, arguments.length > 1 ? arguments[1] : undefined);
    return $67f797a01ba0cd02$exports(this, list);
});


'use strict';


var $ead9c005840bf78c$var$aTypedArrayConstructor = $677553e4d642bc36$exports.aTypedArrayConstructor;
var $ead9c005840bf78c$var$exportTypedArrayStaticMethod = $677553e4d642bc36$exports.exportTypedArrayStaticMethod;
// `%TypedArray%.of` method
// https://tc39.es/ecma262/#sec-%typedarray%.of
$ead9c005840bf78c$var$exportTypedArrayStaticMethod('of', function of() {
    var index = 0;
    var length = arguments.length;
    var result = new ($ead9c005840bf78c$var$aTypedArrayConstructor(this))(length);
    while(length > index)result[index] = arguments[index++];
    return result;
}, $2c4512e9190dc2eb$exports);


'use strict';

var $e87213004562bd9c$exports = {};
'use strict';




var $e87213004562bd9c$var$$TypeError = TypeError;
var $e87213004562bd9c$var$REDUCE_EMPTY = 'Reduce of empty array with no initial value';
// `Array.prototype.{ reduce, reduceRight }` methods implementation
var $e87213004562bd9c$var$createMethod = function createMethod(IS_RIGHT) {
    return function(that, callbackfn, argumentsLength, memo) {
        var O = $ad1d9797f1e27af5$exports(that);
        var self = $7a4c0b5af5b2bbd3$exports(O);
        var length = $dfe69c9cb1d4aa6b$exports(O);
        $082fcaa0a091ee30$exports(callbackfn);
        if (length === 0 && argumentsLength < 2) throw new $e87213004562bd9c$var$$TypeError($e87213004562bd9c$var$REDUCE_EMPTY);
        var index = IS_RIGHT ? length - 1 : 0;
        var i = IS_RIGHT ? -1 : 1;
        if (argumentsLength < 2) while(true){
            if (index in self) {
                memo = self[index];
                index += i;
                break;
            }
            index += i;
            if (IS_RIGHT ? index < 0 : length <= index) throw new $e87213004562bd9c$var$$TypeError($e87213004562bd9c$var$REDUCE_EMPTY);
        }
        for(; IS_RIGHT ? index >= 0 : length > index; index += i)if (index in self) memo = callbackfn(memo, self[index], index, O);
        return memo;
    };
};
$e87213004562bd9c$exports = {
    // `Array.prototype.reduce` method
    // https://tc39.es/ecma262/#sec-array.prototype.reduce
    left: $e87213004562bd9c$var$createMethod(false),
    // `Array.prototype.reduceRight` method
    // https://tc39.es/ecma262/#sec-array.prototype.reduceright
    right: $e87213004562bd9c$var$createMethod(true)
};


var $eea4f3551f2a89eb$require$$reduce = $e87213004562bd9c$exports.left;
var $eea4f3551f2a89eb$var$aTypedArray = $677553e4d642bc36$exports.aTypedArray;
var $eea4f3551f2a89eb$var$exportTypedArrayMethod = $677553e4d642bc36$exports.exportTypedArrayMethod;
// `%TypedArray%.prototype.reduce` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.reduce
$eea4f3551f2a89eb$var$exportTypedArrayMethod('reduce', function reduce(callbackfn /* , initialValue */ ) {
    var length = arguments.length;
    return $eea4f3551f2a89eb$require$$reduce($eea4f3551f2a89eb$var$aTypedArray(this), callbackfn, length, length > 1 ? arguments[1] : undefined);
});


'use strict';


var $e354e87469bf1b8a$require$$reduceRight = $e87213004562bd9c$exports.right;
var $e354e87469bf1b8a$var$aTypedArray = $677553e4d642bc36$exports.aTypedArray;
var $e354e87469bf1b8a$var$exportTypedArrayMethod = $677553e4d642bc36$exports.exportTypedArrayMethod;
// `%TypedArray%.prototype.reduceRight` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.reduceright
$e354e87469bf1b8a$var$exportTypedArrayMethod('reduceRight', function reduceRight(callbackfn /* , initialValue */ ) {
    var length = arguments.length;
    return $e354e87469bf1b8a$require$$reduceRight($e354e87469bf1b8a$var$aTypedArray(this), callbackfn, length, length > 1 ? arguments[1] : undefined);
});


'use strict';

var $93cb99caa7b6e3f5$var$aTypedArray = $677553e4d642bc36$exports.aTypedArray;
var $93cb99caa7b6e3f5$var$exportTypedArrayMethod = $677553e4d642bc36$exports.exportTypedArrayMethod;
var $93cb99caa7b6e3f5$var$floor = Math.floor;
// `%TypedArray%.prototype.reverse` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.reverse
$93cb99caa7b6e3f5$var$exportTypedArrayMethod('reverse', function reverse() {
    var that = this;
    var length = $93cb99caa7b6e3f5$var$aTypedArray(that).length;
    var middle = $93cb99caa7b6e3f5$var$floor(length / 2);
    var index = 0;
    var value;
    while(index < middle){
        value = that[index];
        that[index++] = that[--length];
        that[length] = value;
    }
    return that;
});


'use strict';







var $6ba9c334a931281b$var$RangeError = $27350b6a9e85aed1$exports.RangeError;
var $6ba9c334a931281b$var$Int8Array = $27350b6a9e85aed1$exports.Int8Array;
var $6ba9c334a931281b$var$Int8ArrayPrototype = $6ba9c334a931281b$var$Int8Array && $6ba9c334a931281b$var$Int8Array.prototype;
var $6ba9c334a931281b$var$$set = $6ba9c334a931281b$var$Int8ArrayPrototype && $6ba9c334a931281b$var$Int8ArrayPrototype.set;
var $6ba9c334a931281b$var$aTypedArray = $677553e4d642bc36$exports.aTypedArray;
var $6ba9c334a931281b$var$exportTypedArrayMethod = $677553e4d642bc36$exports.exportTypedArrayMethod;
var $6ba9c334a931281b$var$WORKS_WITH_OBJECTS_AND_GENERIC_ON_TYPED_ARRAYS = !$ddd8e9441ae136f2$exports(function() {
    // eslint-disable-next-line es/no-typed-arrays -- required for testing
    var array = new Uint8ClampedArray(2);
    $59bf80837927ca02$exports($6ba9c334a931281b$var$$set, array, {
        length: 1,
        0: 3
    }, 1);
    return array[1] !== 3;
});
// https://bugs.chromium.org/p/v8/issues/detail?id=11294 and other
var $6ba9c334a931281b$var$TO_OBJECT_BUG = $6ba9c334a931281b$var$WORKS_WITH_OBJECTS_AND_GENERIC_ON_TYPED_ARRAYS && $677553e4d642bc36$exports.NATIVE_ARRAY_BUFFER_VIEWS && $ddd8e9441ae136f2$exports(function() {
    var array = new $6ba9c334a931281b$var$Int8Array(2);
    array.set(1);
    array.set('2', 1);
    return array[0] !== 0 || array[1] !== 2;
});
// `%TypedArray%.prototype.set` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.set
$6ba9c334a931281b$var$exportTypedArrayMethod('set', function set(arrayLike /* , offset */ ) {
    $6ba9c334a931281b$var$aTypedArray(this);
    var offset = $31106545a50ae7f9$exports(arguments.length > 1 ? arguments[1] : undefined, 1);
    var src = $ad1d9797f1e27af5$exports(arrayLike);
    if ($6ba9c334a931281b$var$WORKS_WITH_OBJECTS_AND_GENERIC_ON_TYPED_ARRAYS) return $59bf80837927ca02$exports($6ba9c334a931281b$var$$set, this, src, offset);
    var length = this.length;
    var len = $dfe69c9cb1d4aa6b$exports(src);
    var index = 0;
    if (len + offset > length) throw new $6ba9c334a931281b$var$RangeError('Wrong length');
    while(index < len)this[offset + index] = src[index++];
}, !$6ba9c334a931281b$var$WORKS_WITH_OBJECTS_AND_GENERIC_ON_TYPED_ARRAYS || $6ba9c334a931281b$var$TO_OBJECT_BUG);


'use strict';



var $5ff6086a3a98965a$var$aTypedArray = $677553e4d642bc36$exports.aTypedArray;
var $5ff6086a3a98965a$var$getTypedArrayConstructor = $677553e4d642bc36$exports.getTypedArrayConstructor;
var $5ff6086a3a98965a$var$exportTypedArrayMethod = $677553e4d642bc36$exports.exportTypedArrayMethod;
var $5ff6086a3a98965a$var$FORCED = $ddd8e9441ae136f2$exports(function() {
    // eslint-disable-next-line es/no-typed-arrays -- required for testing
    new Int8Array(1).slice();
});
// `%TypedArray%.prototype.slice` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.slice
$5ff6086a3a98965a$var$exportTypedArrayMethod('slice', function slice(start, end) {
    var list = $2dd14968e62d6eb1$exports($5ff6086a3a98965a$var$aTypedArray(this), start, end);
    var C = $5ff6086a3a98965a$var$getTypedArrayConstructor(this);
    var index = 0;
    var length = list.length;
    var result = new C(length);
    while(length > index)result[index] = list[index++];
    return result;
}, $5ff6086a3a98965a$var$FORCED);


'use strict';


var $faed55e3a901b89f$require$$some = $549edc5c9a026f8b$exports.some;
var $faed55e3a901b89f$var$aTypedArray = $677553e4d642bc36$exports.aTypedArray;
var $faed55e3a901b89f$var$exportTypedArrayMethod = $677553e4d642bc36$exports.exportTypedArrayMethod;
// `%TypedArray%.prototype.some` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.some
$faed55e3a901b89f$var$exportTypedArrayMethod('some', function some(callbackfn /* , thisArg */ ) {
    return $faed55e3a901b89f$require$$some($faed55e3a901b89f$var$aTypedArray(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
});


'use strict';










var $efdcb18f74d13097$var$aTypedArray = $677553e4d642bc36$exports.aTypedArray;
var $efdcb18f74d13097$var$exportTypedArrayMethod = $677553e4d642bc36$exports.exportTypedArrayMethod;
var $efdcb18f74d13097$var$Uint16Array = $27350b6a9e85aed1$exports.Uint16Array;
var $efdcb18f74d13097$var$nativeSort = $efdcb18f74d13097$var$Uint16Array && $262d820f61605b50$exports($efdcb18f74d13097$var$Uint16Array.prototype.sort);
// WebKit
var $efdcb18f74d13097$var$ACCEPT_INCORRECT_ARGUMENTS = !!$efdcb18f74d13097$var$nativeSort && !($ddd8e9441ae136f2$exports(function() {
    $efdcb18f74d13097$var$nativeSort(new $efdcb18f74d13097$var$Uint16Array(2), null);
}) && $ddd8e9441ae136f2$exports(function() {
    $efdcb18f74d13097$var$nativeSort(new $efdcb18f74d13097$var$Uint16Array(2), {});
}));
var $efdcb18f74d13097$var$STABLE_SORT = !!$efdcb18f74d13097$var$nativeSort && !$ddd8e9441ae136f2$exports(function() {
    // feature detection can be too slow, so check engines versions
    if ($af93164be802bd69$exports) return $af93164be802bd69$exports < 74;
    if ($13fa928c416d68a2$exports) return $13fa928c416d68a2$exports < 67;
    if ($393ad2f8b955ad37$exports) return true;
    if ($a8d4456c1aa6edf5$exports) return $a8d4456c1aa6edf5$exports < 602;
    var array = new $efdcb18f74d13097$var$Uint16Array(516);
    var expected = Array(516);
    var index, mod;
    for(index = 0; index < 516; index++){
        mod = index % 4;
        array[index] = 515 - index;
        expected[index] = index - 2 * mod + 3;
    }
    $efdcb18f74d13097$var$nativeSort(array, function(a, b) {
        return (a / 4 | 0) - (b / 4 | 0);
    });
    for(index = 0; index < 516; index++){
        if (array[index] !== expected[index]) return true;
    }
});
var $efdcb18f74d13097$var$getSortCompare = function getSortCompare(comparefn) {
    return function(x, y) {
        if (comparefn !== undefined) return +comparefn(x, y) || 0;
        // eslint-disable-next-line no-self-compare -- NaN check
        if (y !== y) return x !== x ? 0 : -1;
        // eslint-disable-next-line no-self-compare -- NaN check
        if (x !== x) return 1;
        if (x === 0 && y === 0) return 1 / x > 0 ? 1 / y > 0 ? 0 : 1 : 1 / y > 0 ? -1 : 0;
        return x > y ? 1 : x < y ? -1 : 0;
    };
};
// `%TypedArray%.prototype.sort` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.sort
$efdcb18f74d13097$var$exportTypedArrayMethod('sort', function sort(comparefn) {
    if (comparefn !== undefined) $082fcaa0a091ee30$exports(comparefn);
    if ($efdcb18f74d13097$var$STABLE_SORT) return $efdcb18f74d13097$var$nativeSort(this, comparefn);
    return $a4ee3cc522d386c7$exports($efdcb18f74d13097$var$aTypedArray(this), $efdcb18f74d13097$var$getSortCompare(comparefn));
}, !$efdcb18f74d13097$var$STABLE_SORT || $efdcb18f74d13097$var$ACCEPT_INCORRECT_ARGUMENTS);


'use strict';



var $a9a7733bce5002e2$var$aTypedArray = $677553e4d642bc36$exports.aTypedArray;
var $a9a7733bce5002e2$var$getTypedArrayConstructor = $677553e4d642bc36$exports.getTypedArrayConstructor;
var $a9a7733bce5002e2$var$exportTypedArrayMethod = $677553e4d642bc36$exports.exportTypedArrayMethod;
// `%TypedArray%.prototype.subarray` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.subarray
$a9a7733bce5002e2$var$exportTypedArrayMethod('subarray', function subarray(begin, end) {
    var O = $a9a7733bce5002e2$var$aTypedArray(this);
    var length = O.length;
    var beginIndex = $32c589906f6ca696$exports(begin, length);
    var C = $a9a7733bce5002e2$var$getTypedArrayConstructor(O);
    return new C(O.buffer, O.byteOffset + beginIndex * O.BYTES_PER_ELEMENT, $aa75059f0a5ef94e$exports((end === undefined ? length : $32c589906f6ca696$exports(end, length)) - beginIndex));
});


'use strict';





var $25942cc769137444$var$Int8Array = $27350b6a9e85aed1$exports.Int8Array;
var $25942cc769137444$var$aTypedArray = $677553e4d642bc36$exports.aTypedArray;
var $25942cc769137444$var$exportTypedArrayMethod = $677553e4d642bc36$exports.exportTypedArrayMethod;
var $25942cc769137444$var$$toLocaleString = [].toLocaleString;
// iOS Safari 6.x fails here
var $25942cc769137444$var$TO_LOCALE_STRING_BUG = !!$25942cc769137444$var$Int8Array && $ddd8e9441ae136f2$exports(function() {
    $25942cc769137444$var$$toLocaleString.call(new $25942cc769137444$var$Int8Array(1));
});
var $25942cc769137444$var$FORCED = $ddd8e9441ae136f2$exports(function() {
    return [
        1,
        2
    ].toLocaleString() !== new $25942cc769137444$var$Int8Array([
        1,
        2
    ]).toLocaleString();
}) || !$ddd8e9441ae136f2$exports(function() {
    $25942cc769137444$var$Int8Array.prototype.toLocaleString.call([
        1,
        2
    ]);
});
// `%TypedArray%.prototype.toLocaleString` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.tolocalestring
$25942cc769137444$var$exportTypedArrayMethod('toLocaleString', function toLocaleString() {
    return $eb64554a295b6978$exports($25942cc769137444$var$$toLocaleString, $25942cc769137444$var$TO_LOCALE_STRING_BUG ? $2dd14968e62d6eb1$exports($25942cc769137444$var$aTypedArray(this)) : $25942cc769137444$var$aTypedArray(this), $2dd14968e62d6eb1$exports(arguments));
}, $25942cc769137444$var$FORCED);


'use strict';

var $344ac66874a76428$require$exportTypedArrayMethod = $677553e4d642bc36$exports.exportTypedArrayMethod;



var $344ac66874a76428$var$Uint8Array = $27350b6a9e85aed1$exports.Uint8Array;
var $344ac66874a76428$var$Uint8ArrayPrototype = $344ac66874a76428$var$Uint8Array && $344ac66874a76428$var$Uint8Array.prototype || {};
var $344ac66874a76428$var$arrayToString = [].toString;
var $344ac66874a76428$var$join = $c224a7eda28c33b3$exports([].join);
if ($ddd8e9441ae136f2$exports(function() {
    $344ac66874a76428$var$arrayToString.call({});
})) $344ac66874a76428$var$arrayToString = function toString() {
    return $344ac66874a76428$var$join(this);
};
var $344ac66874a76428$var$IS_NOT_ARRAY_METHOD = $344ac66874a76428$var$Uint8ArrayPrototype.toString !== $344ac66874a76428$var$arrayToString;
// `%TypedArray%.prototype.toString` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.tostring
$344ac66874a76428$require$exportTypedArrayMethod('toString', $344ac66874a76428$var$arrayToString, $344ac66874a76428$var$IS_NOT_ARRAY_METHOD);


'use strict';
'use strict';






var $0ff231ab50d5d224$exports = {};
'use strict';



var $0ff231ab50d5d224$require$getWeakData = $d263db769eb8b264$exports.getWeakData;








var $0ff231ab50d5d224$var$setInternalState = $fcfe8b5396fbe91a$exports.set;
var $0ff231ab50d5d224$var$internalStateGetterFor = $fcfe8b5396fbe91a$exports.getterFor;
var $0ff231ab50d5d224$var$find = $549edc5c9a026f8b$exports.find;
var $0ff231ab50d5d224$var$findIndex = $549edc5c9a026f8b$exports.findIndex;
var $0ff231ab50d5d224$var$splice = $c224a7eda28c33b3$exports([].splice);
var $0ff231ab50d5d224$var$id = 0;
// fallback for uncaught frozen keys
var $0ff231ab50d5d224$var$uncaughtFrozenStore = function uncaughtFrozenStore(state) {
    return state.frozen || (state.frozen = new $0ff231ab50d5d224$var$UncaughtFrozenStore());
};
var $0ff231ab50d5d224$var$UncaughtFrozenStore = function UncaughtFrozenStore() {
    this.entries = [];
};
var $0ff231ab50d5d224$var$findUncaughtFrozen = function findUncaughtFrozen(store, key) {
    return $0ff231ab50d5d224$var$find(store.entries, function(it) {
        return it[0] === key;
    });
};
$0ff231ab50d5d224$var$UncaughtFrozenStore.prototype = {
    get: function get(key) {
        var entry = $0ff231ab50d5d224$var$findUncaughtFrozen(this, key);
        if (entry) return entry[1];
    },
    has: function has(key) {
        return !!$0ff231ab50d5d224$var$findUncaughtFrozen(this, key);
    },
    set: function set(key, value) {
        var entry = $0ff231ab50d5d224$var$findUncaughtFrozen(this, key);
        if (entry) entry[1] = value;
        else this.entries.push([
            key,
            value
        ]);
    },
    'delete': function(key) {
        var index = $0ff231ab50d5d224$var$findIndex(this.entries, function(it) {
            return it[0] === key;
        });
        if (~index) $0ff231ab50d5d224$var$splice(this.entries, index, 1);
        return !!~index;
    }
};
$0ff231ab50d5d224$exports = {
    getConstructor: function getConstructor(wrapper, CONSTRUCTOR_NAME, IS_MAP, ADDER) {
        var Constructor = wrapper(function(that, iterable) {
            $93a46accb3e7c173$exports(that, Prototype);
            $0ff231ab50d5d224$var$setInternalState(that, {
                type: CONSTRUCTOR_NAME,
                id: $0ff231ab50d5d224$var$id++,
                frozen: null
            });
            if (!$da08ff0243e53f27$exports(iterable)) $ec8a9e5ef0653b51$exports(iterable, that[ADDER], {
                that: that,
                AS_ENTRIES: IS_MAP
            });
        });
        var Prototype = Constructor.prototype;
        var getInternalState = $0ff231ab50d5d224$var$internalStateGetterFor(CONSTRUCTOR_NAME);
        var define = function define(that, key, value) {
            var state = getInternalState(that);
            var data = $0ff231ab50d5d224$require$getWeakData($7d9b9f0a2a7e34a2$exports(key), true);
            if (data === true) $0ff231ab50d5d224$var$uncaughtFrozenStore(state).set(key, value);
            else data[state.id] = value;
            return that;
        };
        $260286081d4ac307$exports(Prototype, {
            // `{ WeakMap, WeakSet }.prototype.delete(key)` methods
            // https://tc39.es/ecma262/#sec-weakmap.prototype.delete
            // https://tc39.es/ecma262/#sec-weakset.prototype.delete
            'delete': function(key) {
                var state = getInternalState(this);
                if (!$4d7f82f6c4645870$exports(key)) return false;
                var data = $0ff231ab50d5d224$require$getWeakData(key);
                if (data === true) return $0ff231ab50d5d224$var$uncaughtFrozenStore(state)['delete'](key);
                return data && $8bbc2bccc0a29296$exports(data, state.id) && delete data[state.id];
            },
            // `{ WeakMap, WeakSet }.prototype.has(key)` methods
            // https://tc39.es/ecma262/#sec-weakmap.prototype.has
            // https://tc39.es/ecma262/#sec-weakset.prototype.has
            has: function has(key) {
                var state = getInternalState(this);
                if (!$4d7f82f6c4645870$exports(key)) return false;
                var data = $0ff231ab50d5d224$require$getWeakData(key);
                if (data === true) return $0ff231ab50d5d224$var$uncaughtFrozenStore(state).has(key);
                return data && $8bbc2bccc0a29296$exports(data, state.id);
            }
        });
        $260286081d4ac307$exports(Prototype, IS_MAP ? {
            // `WeakMap.prototype.get(key)` method
            // https://tc39.es/ecma262/#sec-weakmap.prototype.get
            get: function get(key) {
                var state = getInternalState(this);
                if ($4d7f82f6c4645870$exports(key)) {
                    var data = $0ff231ab50d5d224$require$getWeakData(key);
                    if (data === true) return $0ff231ab50d5d224$var$uncaughtFrozenStore(state).get(key);
                    if (data) return data[state.id];
                }
            },
            // `WeakMap.prototype.set(key, value)` method
            // https://tc39.es/ecma262/#sec-weakmap.prototype.set
            set: function set(key, value) {
                return define(this, key, value);
            }
        } : {
            // `WeakSet.prototype.add(value)` method
            // https://tc39.es/ecma262/#sec-weakset.prototype.add
            add: function add(value) {
                return define(this, value, true);
            }
        });
        return Constructor;
    }
};




var $47dbf7c4d38f0774$require$enforceInternalState = $fcfe8b5396fbe91a$exports.enforce;


var $47dbf7c4d38f0774$var$$Object = Object;
// eslint-disable-next-line es/no-array-isarray -- safe
var $47dbf7c4d38f0774$var$isArray = Array.isArray;
// eslint-disable-next-line es/no-object-isextensible -- safe
var $47dbf7c4d38f0774$var$isExtensible = $47dbf7c4d38f0774$var$$Object.isExtensible;
// eslint-disable-next-line es/no-object-isfrozen -- safe
var $47dbf7c4d38f0774$var$isFrozen = $47dbf7c4d38f0774$var$$Object.isFrozen;
// eslint-disable-next-line es/no-object-issealed -- safe
var $47dbf7c4d38f0774$var$isSealed = $47dbf7c4d38f0774$var$$Object.isSealed;
// eslint-disable-next-line es/no-object-freeze -- safe
var $47dbf7c4d38f0774$var$freeze = $47dbf7c4d38f0774$var$$Object.freeze;
// eslint-disable-next-line es/no-object-seal -- safe
var $47dbf7c4d38f0774$var$seal = $47dbf7c4d38f0774$var$$Object.seal;
var $47dbf7c4d38f0774$var$IS_IE11 = !$27350b6a9e85aed1$exports.ActiveXObject && 'ActiveXObject' in $27350b6a9e85aed1$exports;
var $47dbf7c4d38f0774$var$InternalWeakMap;
var $47dbf7c4d38f0774$var$wrapper = function wrapper(init) {
    return function WeakMap() {
        return init(this, arguments.length ? arguments[0] : undefined);
    };
};
// `WeakMap` constructor
// https://tc39.es/ecma262/#sec-weakmap-constructor
var $47dbf7c4d38f0774$var$$WeakMap = $3f909713a27e049c$exports('WeakMap', $47dbf7c4d38f0774$var$wrapper, $0ff231ab50d5d224$exports);
var $47dbf7c4d38f0774$var$WeakMapPrototype = $47dbf7c4d38f0774$var$$WeakMap.prototype;
var $47dbf7c4d38f0774$var$nativeSet = $c224a7eda28c33b3$exports($47dbf7c4d38f0774$var$WeakMapPrototype.set);
// Chakra Edge bug: adding frozen arrays to WeakMap unfreeze them
var $47dbf7c4d38f0774$var$hasMSEdgeFreezingBug = function hasMSEdgeFreezingBug() {
    return $323042bd7ad218cd$exports && $ddd8e9441ae136f2$exports(function() {
        var frozenArray = $47dbf7c4d38f0774$var$freeze([]);
        $47dbf7c4d38f0774$var$nativeSet(new $47dbf7c4d38f0774$var$$WeakMap(), frozenArray, 1);
        return !$47dbf7c4d38f0774$var$isFrozen(frozenArray);
    });
};
// IE11 WeakMap frozen keys fix
// We can't use feature detection because it crash some old IE builds
// https://github.com/zloirock/core-js/issues/485
if ($1593c91d91aeea67$exports) {
    if ($47dbf7c4d38f0774$var$IS_IE11) {
        $47dbf7c4d38f0774$var$InternalWeakMap = $0ff231ab50d5d224$exports.getConstructor($47dbf7c4d38f0774$var$wrapper, 'WeakMap', true);
        $d263db769eb8b264$exports.enable();
        var $47dbf7c4d38f0774$var$nativeDelete = $c224a7eda28c33b3$exports($47dbf7c4d38f0774$var$WeakMapPrototype['delete']);
        var $47dbf7c4d38f0774$var$nativeHas = $c224a7eda28c33b3$exports($47dbf7c4d38f0774$var$WeakMapPrototype.has);
        var $47dbf7c4d38f0774$var$nativeGet = $c224a7eda28c33b3$exports($47dbf7c4d38f0774$var$WeakMapPrototype.get);
        $260286081d4ac307$exports($47dbf7c4d38f0774$var$WeakMapPrototype, {
            'delete': function(key) {
                if ($4d7f82f6c4645870$exports(key) && !$47dbf7c4d38f0774$var$isExtensible(key)) {
                    var state = $47dbf7c4d38f0774$require$enforceInternalState(this);
                    if (!state.frozen) state.frozen = new $47dbf7c4d38f0774$var$InternalWeakMap();
                    return $47dbf7c4d38f0774$var$nativeDelete(this, key) || state.frozen['delete'](key);
                }
                return $47dbf7c4d38f0774$var$nativeDelete(this, key);
            },
            has: function has(key) {
                if ($4d7f82f6c4645870$exports(key) && !$47dbf7c4d38f0774$var$isExtensible(key)) {
                    var state = $47dbf7c4d38f0774$require$enforceInternalState(this);
                    if (!state.frozen) state.frozen = new $47dbf7c4d38f0774$var$InternalWeakMap();
                    return $47dbf7c4d38f0774$var$nativeHas(this, key) || state.frozen.has(key);
                }
                return $47dbf7c4d38f0774$var$nativeHas(this, key);
            },
            get: function get(key) {
                if ($4d7f82f6c4645870$exports(key) && !$47dbf7c4d38f0774$var$isExtensible(key)) {
                    var state = $47dbf7c4d38f0774$require$enforceInternalState(this);
                    if (!state.frozen) state.frozen = new $47dbf7c4d38f0774$var$InternalWeakMap();
                    return $47dbf7c4d38f0774$var$nativeHas(this, key) ? $47dbf7c4d38f0774$var$nativeGet(this, key) : state.frozen.get(key);
                }
                return $47dbf7c4d38f0774$var$nativeGet(this, key);
            },
            set: function set(key, value) {
                if ($4d7f82f6c4645870$exports(key) && !$47dbf7c4d38f0774$var$isExtensible(key)) {
                    var state = $47dbf7c4d38f0774$require$enforceInternalState(this);
                    if (!state.frozen) state.frozen = new $47dbf7c4d38f0774$var$InternalWeakMap();
                    $47dbf7c4d38f0774$var$nativeHas(this, key) ? $47dbf7c4d38f0774$var$nativeSet(this, key, value) : state.frozen.set(key, value);
                } else $47dbf7c4d38f0774$var$nativeSet(this, key, value);
                return this;
            }
        });
    // Chakra Edge frozen keys fix
    } else if ($47dbf7c4d38f0774$var$hasMSEdgeFreezingBug()) $260286081d4ac307$exports($47dbf7c4d38f0774$var$WeakMapPrototype, {
        set: function set(key, value) {
            var arrayIntegrityLevel;
            if ($47dbf7c4d38f0774$var$isArray(key)) {
                if ($47dbf7c4d38f0774$var$isFrozen(key)) arrayIntegrityLevel = $47dbf7c4d38f0774$var$freeze;
                else if ($47dbf7c4d38f0774$var$isSealed(key)) arrayIntegrityLevel = $47dbf7c4d38f0774$var$seal;
            }
            $47dbf7c4d38f0774$var$nativeSet(this, key, value);
            if (arrayIntegrityLevel) arrayIntegrityLevel(key);
            return this;
        }
    });
}




'use strict';
'use strict';


// `WeakSet` constructor
// https://tc39.es/ecma262/#sec-weakset-constructor
$3f909713a27e049c$exports('WeakSet', function(init) {
    return function WeakSet() {
        return init(this, arguments.length ? arguments[0] : undefined);
    };
}, $0ff231ab50d5d224$exports);




'use strict';

var $0a1f1e9e280a5767$exports = {};
'use strict';
// iterable DOM collections
// flag - `iterable` interface - 'entries', 'keys', 'values', 'forEach' methods
$0a1f1e9e280a5767$exports = {
    CSSRuleList: 0,
    CSSStyleDeclaration: 0,
    CSSValueList: 0,
    ClientRectList: 0,
    DOMRectList: 0,
    DOMStringList: 0,
    DOMTokenList: 1,
    DataTransferItemList: 0,
    FileList: 0,
    HTMLAllCollection: 0,
    HTMLCollection: 0,
    HTMLFormElement: 0,
    HTMLSelectElement: 0,
    MediaList: 0,
    MimeTypeArray: 0,
    NamedNodeMap: 0,
    NodeList: 1,
    PaintRequestList: 0,
    Plugin: 0,
    PluginArray: 0,
    SVGLengthList: 0,
    SVGNumberList: 0,
    SVGPathSegList: 0,
    SVGPointList: 0,
    SVGStringList: 0,
    SVGTransformList: 0,
    SourceBufferList: 0,
    StyleSheetList: 0,
    TextTrackCueList: 0,
    TextTrackList: 0,
    TouchList: 0
};


var $5f2731af16bfb886$exports = {};
'use strict';

var $5f2731af16bfb886$var$classList = $9615a1abb0018505$exports('span').classList;
var $5f2731af16bfb886$var$DOMTokenListPrototype = $5f2731af16bfb886$var$classList && $5f2731af16bfb886$var$classList.constructor && $5f2731af16bfb886$var$classList.constructor.prototype;
$5f2731af16bfb886$exports = $5f2731af16bfb886$var$DOMTokenListPrototype === Object.prototype ? undefined : $5f2731af16bfb886$var$DOMTokenListPrototype;


var $5479721fbd3fb114$exports = {};
'use strict';

var $5479721fbd3fb114$require$$forEach = $549edc5c9a026f8b$exports.forEach;

var $5479721fbd3fb114$var$STRICT_METHOD = $e6cb878020bcaa14$exports('forEach');
// `Array.prototype.forEach` method implementation
// https://tc39.es/ecma262/#sec-array.prototype.foreach
$5479721fbd3fb114$exports = !$5479721fbd3fb114$var$STRICT_METHOD ? function forEach(callbackfn /* , thisArg */ ) {
    return $5479721fbd3fb114$require$$forEach(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
// eslint-disable-next-line es/no-array-prototype-foreach -- safe
} : [].forEach;



var $93705eec0383a616$var$handlePrototype = function handlePrototype(CollectionPrototype) {
    // some Chrome versions have non-configurable methods on DOMTokenList
    if (CollectionPrototype && CollectionPrototype.forEach !== $5479721fbd3fb114$exports) try {
        $b390530569770271$exports(CollectionPrototype, 'forEach', $5479721fbd3fb114$exports);
    } catch (error) {
        CollectionPrototype.forEach = $5479721fbd3fb114$exports;
    }
};
for(var $93705eec0383a616$var$COLLECTION_NAME in $0a1f1e9e280a5767$exports)if ($0a1f1e9e280a5767$exports[$93705eec0383a616$var$COLLECTION_NAME]) $93705eec0383a616$var$handlePrototype($27350b6a9e85aed1$exports[$93705eec0383a616$var$COLLECTION_NAME] && $27350b6a9e85aed1$exports[$93705eec0383a616$var$COLLECTION_NAME].prototype);
$93705eec0383a616$var$handlePrototype($5f2731af16bfb886$exports);


'use strict';







var $663f7fd033d26834$var$ITERATOR = $8555fb22f74da29f$exports('iterator');
var $663f7fd033d26834$var$ArrayValues = $a6770789dc15a9c7$exports.values;
var $663f7fd033d26834$var$handlePrototype = function handlePrototype(CollectionPrototype, COLLECTION_NAME) {
    if (CollectionPrototype) {
        // some Chrome versions have non-configurable methods on DOMTokenList
        if (CollectionPrototype[$663f7fd033d26834$var$ITERATOR] !== $663f7fd033d26834$var$ArrayValues) try {
            $b390530569770271$exports(CollectionPrototype, $663f7fd033d26834$var$ITERATOR, $663f7fd033d26834$var$ArrayValues);
        } catch (error) {
            CollectionPrototype[$663f7fd033d26834$var$ITERATOR] = $663f7fd033d26834$var$ArrayValues;
        }
        $54a3ba2fb7b04ac0$exports(CollectionPrototype, COLLECTION_NAME, true);
        if ($0a1f1e9e280a5767$exports[COLLECTION_NAME]) for(var METHOD_NAME in $a6770789dc15a9c7$exports){
            // some Chrome versions have non-configurable methods on DOMTokenList
            if (CollectionPrototype[METHOD_NAME] !== $a6770789dc15a9c7$exports[METHOD_NAME]) try {
                $b390530569770271$exports(CollectionPrototype, METHOD_NAME, $a6770789dc15a9c7$exports[METHOD_NAME]);
            } catch (error) {
                CollectionPrototype[METHOD_NAME] = $a6770789dc15a9c7$exports[METHOD_NAME];
            }
        }
    }
};
for(var $663f7fd033d26834$var$COLLECTION_NAME in $0a1f1e9e280a5767$exports)$663f7fd033d26834$var$handlePrototype($27350b6a9e85aed1$exports[$663f7fd033d26834$var$COLLECTION_NAME] && $27350b6a9e85aed1$exports[$663f7fd033d26834$var$COLLECTION_NAME].prototype, $663f7fd033d26834$var$COLLECTION_NAME);
$663f7fd033d26834$var$handlePrototype($5f2731af16bfb886$exports, 'DOMTokenList');


'use strict';
'use strict';



var $7532c5e244f36b13$require$clearImmediate = $fa9149d3a968f56a$exports.clear;
// `clearImmediate` method
// http://w3c.github.io/setImmediate/#si-clearImmediate
$244155c096ef4c14$exports({
    global: true,
    bind: true,
    enumerable: true,
    forced: $27350b6a9e85aed1$exports.clearImmediate !== $7532c5e244f36b13$require$clearImmediate
}, {
    clearImmediate: $7532c5e244f36b13$require$clearImmediate
});


'use strict';



var $c14cae43da7259b9$require$setTask = $fa9149d3a968f56a$exports.set;
var $25d656463c2e01bf$exports = {};
'use strict';







var $25d656463c2e01bf$var$Function = $27350b6a9e85aed1$exports.Function;
// dirty IE9- and Bun 0.3.0- checks
var $25d656463c2e01bf$var$WRAP = /MSIE .\./.test($ef443fb3091f223d$exports) || $2ae0d98a4d3e65de$exports === 'BUN' && function() {
    var version = $27350b6a9e85aed1$exports.Bun.version.split('.');
    return version.length < 3 || version[0] === '0' && (version[1] < 3 || version[1] === '3' && version[2] === '0');
}();
// IE9- / Bun 0.3.0- setTimeout / setInterval / setImmediate additional parameters fix
// https://html.spec.whatwg.org/multipage/timers-and-user-prompts.html#timers
// https://github.com/oven-sh/bun/issues/1633
$25d656463c2e01bf$exports = function(scheduler, hasTimeArg) {
    var firstParamIndex = hasTimeArg ? 2 : 1;
    return $25d656463c2e01bf$var$WRAP ? function(handler, timeout /* , ...arguments */ ) {
        var boundArgs = $01603bd6f8ce1d57$exports(arguments.length, 1) > firstParamIndex;
        var fn = $7c165f740ca92c53$exports(handler) ? handler : $25d656463c2e01bf$var$Function(handler);
        var params = boundArgs ? $2dd14968e62d6eb1$exports(arguments, firstParamIndex) : [];
        var callback = boundArgs ? function callback() {
            $eb64554a295b6978$exports(fn, this, params);
        } : fn;
        return hasTimeArg ? scheduler(callback, timeout) : scheduler(callback);
    } : scheduler;
};


// https://github.com/oven-sh/bun/issues/1633
var $c14cae43da7259b9$var$setImmediate = $27350b6a9e85aed1$exports.setImmediate ? $25d656463c2e01bf$exports($c14cae43da7259b9$require$setTask, false) : $c14cae43da7259b9$require$setTask;
// `setImmediate` method
// http://w3c.github.io/setImmediate/#si-setImmediate
$244155c096ef4c14$exports({
    global: true,
    bind: true,
    enumerable: true,
    forced: $27350b6a9e85aed1$exports.setImmediate !== $c14cae43da7259b9$var$setImmediate
}, {
    setImmediate: $c14cae43da7259b9$var$setImmediate
});




'use strict';







// Bun ~ 1.0.30 bug
// https://github.com/oven-sh/bun/issues/9249
var $9c9c29c771e125d4$var$WRONG_ARITY = $ddd8e9441ae136f2$exports(function() {
    // getOwnPropertyDescriptor for prevent experimental warning in Node 11
    // eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
    return $b9f536d3284d7921$exports && Object.getOwnPropertyDescriptor($27350b6a9e85aed1$exports, 'queueMicrotask').value.length !== 1;
});
// `queueMicrotask` method
// https://html.spec.whatwg.org/multipage/timers-and-user-prompts.html#dom-queuemicrotask
$244155c096ef4c14$exports({
    global: true,
    enumerable: true,
    dontCallGetSet: true,
    forced: $9c9c29c771e125d4$var$WRONG_ARITY
}, {
    queueMicrotask: function queueMicrotask(fn) {
        $01603bd6f8ce1d57$exports(arguments.length, 1);
        $4bcf5809c5bd6af8$exports($082fcaa0a091ee30$exports(fn));
    }
});


'use strict';

var $6tOPT = parcelRequire("6tOPT");
'use strict';



var $2bd41c46b7be4aca$exports = {};
'use strict';




var $2bd41c46b7be4aca$var$ITERATOR = $8555fb22f74da29f$exports('iterator');
$2bd41c46b7be4aca$exports = !$ddd8e9441ae136f2$exports(function() {
    // eslint-disable-next-line unicorn/relative-url-style -- required for testing
    var url = new URL('b?a=1&b=2&c=3', 'https://a');
    var params = url.searchParams;
    var params2 = new URLSearchParams('a=1&a=2&b=3');
    var result = '';
    url.pathname = 'c%20d';
    params.forEach(function(value, key) {
        params['delete']('b');
        result += key + value;
    });
    params2['delete']('a', 2);
    // `undefined` case is a Chromium 117 bug
    // https://bugs.chromium.org/p/v8/issues/detail?id=14222
    params2['delete']('b', undefined);
    return $a4b83f418a8da28e$exports && (!url.toJSON || !params2.has('a', 1) || params2.has('a', 2) || !params2.has('a', undefined) || params2.has('b')) || !params.size && ($a4b83f418a8da28e$exports || !$b9f536d3284d7921$exports) || !params.sort || url.href !== 'https://a/c%20d?a=1&c=3' || params.get('c') !== '3' || String(new URLSearchParams('?a=1')) !== 'a=1' || !params[$2bd41c46b7be4aca$var$ITERATOR] || new URL('https://a@b').username !== 'a' || new URLSearchParams(new URLSearchParams('a=b')).get('a') !== 'b' || new URL("https://\u0442\u0435\u0441\u0442").host !== 'xn--e1aybc' || new URL("https://a#\u0431").hash !== '#%D0%B1' || result !== 'a1c3' || new URL('https://x', undefined).host !== 'x';
});













var $b7cb89a1c4679e8f$require$codeAt = $91efe475d764b646$exports.codeAt;
var $8b7ca93e668b00da$exports = {};
'use strict';

var $8b7ca93e668b00da$var$maxInt = 2147483647; // aka. 0x7FFFFFFF or 2^31-1
var $8b7ca93e668b00da$var$base = 36;
var $8b7ca93e668b00da$var$tMin = 1;
var $8b7ca93e668b00da$var$tMax = 26;
var $8b7ca93e668b00da$var$skew = 38;
var $8b7ca93e668b00da$var$damp = 700;
var $8b7ca93e668b00da$var$initialBias = 72;
var $8b7ca93e668b00da$var$initialN = 128; // 0x80
var $8b7ca93e668b00da$var$delimiter = '-'; // '\x2D'
var $8b7ca93e668b00da$var$regexNonASCII = /[^\0-\u007E]/; // non-ASCII chars
var $8b7ca93e668b00da$var$regexSeparators = /[.\u3002\uFF0E\uFF61]/g; // RFC 3490 separators
var $8b7ca93e668b00da$var$OVERFLOW_ERROR = 'Overflow: input needs wider integers to process';
var $8b7ca93e668b00da$var$baseMinusTMin = $8b7ca93e668b00da$var$base - $8b7ca93e668b00da$var$tMin;
var $8b7ca93e668b00da$var$$RangeError = RangeError;
var $8b7ca93e668b00da$var$exec = $c224a7eda28c33b3$exports($8b7ca93e668b00da$var$regexSeparators.exec);
var $8b7ca93e668b00da$var$floor = Math.floor;
var $8b7ca93e668b00da$var$fromCharCode = String.fromCharCode;
var $8b7ca93e668b00da$var$charCodeAt = $c224a7eda28c33b3$exports(''.charCodeAt);
var $8b7ca93e668b00da$var$join = $c224a7eda28c33b3$exports([].join);
var $8b7ca93e668b00da$var$push = $c224a7eda28c33b3$exports([].push);
var $8b7ca93e668b00da$var$replace = $c224a7eda28c33b3$exports(''.replace);
var $8b7ca93e668b00da$var$split = $c224a7eda28c33b3$exports(''.split);
var $8b7ca93e668b00da$var$toLowerCase = $c224a7eda28c33b3$exports(''.toLowerCase);
/**
 * Creates an array containing the numeric code points of each Unicode
 * character in the string. While JavaScript uses UCS-2 internally,
 * this function will convert a pair of surrogate halves (each of which
 * UCS-2 exposes as separate characters) into a single code point,
 * matching UTF-16.
 */ var $8b7ca93e668b00da$var$ucs2decode = function ucs2decode(string) {
    var output = [];
    var counter = 0;
    var length = string.length;
    while(counter < length){
        var value = $8b7ca93e668b00da$var$charCodeAt(string, counter++);
        if (value >= 0xD800 && value <= 0xDBFF && counter < length) {
            // It's a high surrogate, and there is a next character.
            var extra = $8b7ca93e668b00da$var$charCodeAt(string, counter++);
            if ((extra & 0xFC00) === 0xDC00) $8b7ca93e668b00da$var$push(output, ((value & 0x3FF) << 10) + (extra & 0x3FF) + 0x10000);
            else {
                // It's an unmatched surrogate; only append this code unit, in case the
                // next code unit is the high surrogate of a surrogate pair.
                $8b7ca93e668b00da$var$push(output, value);
                counter--;
            }
        } else $8b7ca93e668b00da$var$push(output, value);
    }
    return output;
};
/**
 * Converts a digit/integer into a basic code point.
 */ var $8b7ca93e668b00da$var$digitToBasic = function digitToBasic(digit) {
    //  0..25 map to ASCII a..z or A..Z
    // 26..35 map to ASCII 0..9
    return digit + 22 + 75 * (digit < 26);
};
/**
 * Bias adaptation function as per section 3.4 of RFC 3492.
 * https://tools.ietf.org/html/rfc3492#section-3.4
 */ var $8b7ca93e668b00da$var$adapt = function adapt(delta, numPoints, firstTime) {
    var k = 0;
    delta = firstTime ? $8b7ca93e668b00da$var$floor(delta / $8b7ca93e668b00da$var$damp) : delta >> 1;
    delta += $8b7ca93e668b00da$var$floor(delta / numPoints);
    while(delta > $8b7ca93e668b00da$var$baseMinusTMin * $8b7ca93e668b00da$var$tMax >> 1){
        delta = $8b7ca93e668b00da$var$floor(delta / $8b7ca93e668b00da$var$baseMinusTMin);
        k += $8b7ca93e668b00da$var$base;
    }
    return $8b7ca93e668b00da$var$floor(k + ($8b7ca93e668b00da$var$baseMinusTMin + 1) * delta / (delta + $8b7ca93e668b00da$var$skew));
};
/**
 * Converts a string of Unicode symbols (e.g. a domain name label) to a
 * Punycode string of ASCII-only symbols.
 */ var $8b7ca93e668b00da$var$encode = function encode(input) {
    var output = [];
    // Convert the input in UCS-2 to an array of Unicode code points.
    input = $8b7ca93e668b00da$var$ucs2decode(input);
    // Cache the length.
    var inputLength = input.length;
    // Initialize the state.
    var n = $8b7ca93e668b00da$var$initialN;
    var delta = 0;
    var bias = $8b7ca93e668b00da$var$initialBias;
    var i, currentValue;
    // Handle the basic code points.
    for(i = 0; i < input.length; i++){
        currentValue = input[i];
        if (currentValue < 0x80) $8b7ca93e668b00da$var$push(output, $8b7ca93e668b00da$var$fromCharCode(currentValue));
    }
    var basicLength = output.length; // number of basic code points.
    var handledCPCount = basicLength; // number of code points that have been handled;
    // Finish the basic string with a delimiter unless it's empty.
    if (basicLength) $8b7ca93e668b00da$var$push(output, $8b7ca93e668b00da$var$delimiter);
    // Main encoding loop:
    while(handledCPCount < inputLength){
        // All non-basic code points < n have been handled already. Find the next larger one:
        var m = $8b7ca93e668b00da$var$maxInt;
        for(i = 0; i < input.length; i++){
            currentValue = input[i];
            if (currentValue >= n && currentValue < m) m = currentValue;
        }
        // Increase `delta` enough to advance the decoder's <n,i> state to <m,0>, but guard against overflow.
        var handledCPCountPlusOne = handledCPCount + 1;
        if (m - n > $8b7ca93e668b00da$var$floor(($8b7ca93e668b00da$var$maxInt - delta) / handledCPCountPlusOne)) throw new $8b7ca93e668b00da$var$$RangeError($8b7ca93e668b00da$var$OVERFLOW_ERROR);
        delta += (m - n) * handledCPCountPlusOne;
        n = m;
        for(i = 0; i < input.length; i++){
            currentValue = input[i];
            if (currentValue < n && ++delta > $8b7ca93e668b00da$var$maxInt) throw new $8b7ca93e668b00da$var$$RangeError($8b7ca93e668b00da$var$OVERFLOW_ERROR);
            if (currentValue === n) {
                // Represent delta as a generalized variable-length integer.
                var q = delta;
                var k = $8b7ca93e668b00da$var$base;
                while(true){
                    var t = k <= bias ? $8b7ca93e668b00da$var$tMin : k >= bias + $8b7ca93e668b00da$var$tMax ? $8b7ca93e668b00da$var$tMax : k - bias;
                    if (q < t) break;
                    var qMinusT = q - t;
                    var baseMinusT = $8b7ca93e668b00da$var$base - t;
                    $8b7ca93e668b00da$var$push(output, $8b7ca93e668b00da$var$fromCharCode($8b7ca93e668b00da$var$digitToBasic(t + qMinusT % baseMinusT)));
                    q = $8b7ca93e668b00da$var$floor(qMinusT / baseMinusT);
                    k += $8b7ca93e668b00da$var$base;
                }
                $8b7ca93e668b00da$var$push(output, $8b7ca93e668b00da$var$fromCharCode($8b7ca93e668b00da$var$digitToBasic(q)));
                bias = $8b7ca93e668b00da$var$adapt(delta, handledCPCountPlusOne, handledCPCount === basicLength);
                delta = 0;
                handledCPCount++;
            }
        }
        delta++;
        n++;
    }
    return $8b7ca93e668b00da$var$join(output, '');
};
$8b7ca93e668b00da$exports = function(input) {
    var encoded = [];
    var labels = $8b7ca93e668b00da$var$split($8b7ca93e668b00da$var$replace($8b7ca93e668b00da$var$toLowerCase(input), $8b7ca93e668b00da$var$regexSeparators, '\u002E'), '.');
    var i, label;
    for(i = 0; i < labels.length; i++){
        label = labels[i];
        $8b7ca93e668b00da$var$push(encoded, $8b7ca93e668b00da$var$exec($8b7ca93e668b00da$var$regexNonASCII, label) ? 'xn--' + $8b7ca93e668b00da$var$encode(label) : label);
    }
    return $8b7ca93e668b00da$var$join(encoded, '.');
};





var $c76c0e398d4b3bea$exports = {};
'use strict';
































var $c76c0e398d4b3bea$var$ITERATOR = $8555fb22f74da29f$exports('iterator');
var $c76c0e398d4b3bea$var$URL_SEARCH_PARAMS = 'URLSearchParams';
var $c76c0e398d4b3bea$var$URL_SEARCH_PARAMS_ITERATOR = $c76c0e398d4b3bea$var$URL_SEARCH_PARAMS + 'Iterator';
var $c76c0e398d4b3bea$var$setInternalState = $fcfe8b5396fbe91a$exports.set;
var $c76c0e398d4b3bea$var$getInternalParamsState = $fcfe8b5396fbe91a$exports.getterFor($c76c0e398d4b3bea$var$URL_SEARCH_PARAMS);
var $c76c0e398d4b3bea$var$getInternalIteratorState = $fcfe8b5396fbe91a$exports.getterFor($c76c0e398d4b3bea$var$URL_SEARCH_PARAMS_ITERATOR);
var $c76c0e398d4b3bea$var$nativeFetch = $e77683fca65d592a$exports('fetch');
var $c76c0e398d4b3bea$var$NativeRequest = $e77683fca65d592a$exports('Request');
var $c76c0e398d4b3bea$var$Headers = $e77683fca65d592a$exports('Headers');
var $c76c0e398d4b3bea$var$RequestPrototype = $c76c0e398d4b3bea$var$NativeRequest && $c76c0e398d4b3bea$var$NativeRequest.prototype;
var $c76c0e398d4b3bea$var$HeadersPrototype = $c76c0e398d4b3bea$var$Headers && $c76c0e398d4b3bea$var$Headers.prototype;
var $c76c0e398d4b3bea$var$TypeError = $27350b6a9e85aed1$exports.TypeError;
var $c76c0e398d4b3bea$var$encodeURIComponent = $27350b6a9e85aed1$exports.encodeURIComponent;
var $c76c0e398d4b3bea$var$fromCharCode = String.fromCharCode;
var $c76c0e398d4b3bea$var$fromCodePoint = $e8972ff3cf85d361$exports('String', 'fromCodePoint');
var $c76c0e398d4b3bea$var$$parseInt = parseInt;
var $c76c0e398d4b3bea$var$charAt = $c224a7eda28c33b3$exports(''.charAt);
var $c76c0e398d4b3bea$var$join = $c224a7eda28c33b3$exports([].join);
var $c76c0e398d4b3bea$var$push = $c224a7eda28c33b3$exports([].push);
var $c76c0e398d4b3bea$var$replace = $c224a7eda28c33b3$exports(''.replace);
var $c76c0e398d4b3bea$var$shift = $c224a7eda28c33b3$exports([].shift);
var $c76c0e398d4b3bea$var$splice = $c224a7eda28c33b3$exports([].splice);
var $c76c0e398d4b3bea$var$split = $c224a7eda28c33b3$exports(''.split);
var $c76c0e398d4b3bea$var$stringSlice = $c224a7eda28c33b3$exports(''.slice);
var $c76c0e398d4b3bea$var$exec = $c224a7eda28c33b3$exports(/./.exec);
var $c76c0e398d4b3bea$var$plus = /\+/g;
var $c76c0e398d4b3bea$var$FALLBACK_REPLACER = '\uFFFD';
var $c76c0e398d4b3bea$var$VALID_HEX = /^[0-9a-f]+$/i;
var $c76c0e398d4b3bea$var$parseHexOctet = function parseHexOctet(string, start) {
    var substr = $c76c0e398d4b3bea$var$stringSlice(string, start, start + 2);
    if (!$c76c0e398d4b3bea$var$exec($c76c0e398d4b3bea$var$VALID_HEX, substr)) return NaN;
    return $c76c0e398d4b3bea$var$$parseInt(substr, 16);
};
var $c76c0e398d4b3bea$var$getLeadingOnes = function getLeadingOnes(octet) {
    var count = 0;
    for(var mask = 0x80; mask > 0 && (octet & mask) !== 0; mask >>= 1)count++;
    return count;
};
var $c76c0e398d4b3bea$var$utf8Decode = function utf8Decode(octets) {
    var codePoint = null;
    var length = octets.length;
    switch(length){
        case 1:
            codePoint = octets[0];
            break;
        case 2:
            codePoint = (octets[0] & 0x1F) << 6 | octets[1] & 0x3F;
            break;
        case 3:
            codePoint = (octets[0] & 0x0F) << 12 | (octets[1] & 0x3F) << 6 | octets[2] & 0x3F;
            break;
        case 4:
            codePoint = (octets[0] & 0x07) << 18 | (octets[1] & 0x3F) << 12 | (octets[2] & 0x3F) << 6 | octets[3] & 0x3F;
            break;
    }
    // reject surrogates, overlong encodings, and out-of-range codepoints
    if (codePoint === null || codePoint > 0x10FFFF || codePoint >= 0xD800 && codePoint <= 0xDFFF || codePoint < (length > 3 ? 0x10000 : length > 2 ? 0x800 : length > 1 ? 0x80 : 0)) return null;
    return codePoint;
};
/* eslint-disable max-statements, max-depth -- ok */ var $c76c0e398d4b3bea$var$decode = function decode(input) {
    input = $c76c0e398d4b3bea$var$replace(input, $c76c0e398d4b3bea$var$plus, ' ');
    var length = input.length;
    var result = '';
    var i = 0;
    while(i < length){
        var decodedChar = $c76c0e398d4b3bea$var$charAt(input, i);
        if (decodedChar === '%') {
            if ($c76c0e398d4b3bea$var$charAt(input, i + 1) === '%' || i + 3 > length) {
                result += '%';
                i++;
                continue;
            }
            var octet = $c76c0e398d4b3bea$var$parseHexOctet(input, i + 1);
            // eslint-disable-next-line no-self-compare -- NaN check
            if (octet !== octet) {
                result += decodedChar;
                i++;
                continue;
            }
            i += 2;
            var byteSequenceLength = $c76c0e398d4b3bea$var$getLeadingOnes(octet);
            if (byteSequenceLength === 0) decodedChar = $c76c0e398d4b3bea$var$fromCharCode(octet);
            else {
                if (byteSequenceLength === 1 || byteSequenceLength > 4) {
                    result += $c76c0e398d4b3bea$var$FALLBACK_REPLACER;
                    i++;
                    continue;
                }
                var octets = [
                    octet
                ];
                var sequenceIndex = 1;
                while(sequenceIndex < byteSequenceLength){
                    i++;
                    if (i + 3 > length || $c76c0e398d4b3bea$var$charAt(input, i) !== '%') break;
                    var nextByte = $c76c0e398d4b3bea$var$parseHexOctet(input, i + 1);
                    // eslint-disable-next-line no-self-compare -- NaN check
                    if (nextByte !== nextByte || nextByte > 191 || nextByte < 128) break;
                    // https://encoding.spec.whatwg.org/#utf-8-decoder - position-specific byte ranges
                    if (sequenceIndex === 1) {
                        if (octet === 0xE0 && nextByte < 0xA0) break;
                        if (octet === 0xED && nextByte > 0x9F) break;
                        if (octet === 0xF0 && nextByte < 0x90) break;
                        if (octet === 0xF4 && nextByte > 0x8F) break;
                    }
                    $c76c0e398d4b3bea$var$push(octets, nextByte);
                    i += 2;
                    sequenceIndex++;
                }
                if (octets.length !== byteSequenceLength) {
                    result += $c76c0e398d4b3bea$var$FALLBACK_REPLACER;
                    continue;
                }
                var codePoint = $c76c0e398d4b3bea$var$utf8Decode(octets);
                if (codePoint === null) {
                    for(var replacement = 0; replacement < byteSequenceLength; replacement++)result += $c76c0e398d4b3bea$var$FALLBACK_REPLACER;
                    i++;
                    continue;
                } else decodedChar = $c76c0e398d4b3bea$var$fromCodePoint(codePoint);
            }
        }
        result += decodedChar;
        i++;
    }
    return result;
};
/* eslint-enable max-statements, max-depth -- ok */ var $c76c0e398d4b3bea$var$find = /[!'()~]|%20/g;
var $c76c0e398d4b3bea$var$replacements = {
    '!': '%21',
    "'": '%27',
    '(': '%28',
    ')': '%29',
    '~': '%7E',
    '%20': '+'
};
var $c76c0e398d4b3bea$var$replacer = function replacer(match) {
    return $c76c0e398d4b3bea$var$replacements[match];
};
var $c76c0e398d4b3bea$var$serialize = function serialize(it) {
    return $c76c0e398d4b3bea$var$replace($c76c0e398d4b3bea$var$encodeURIComponent(it), $c76c0e398d4b3bea$var$find, $c76c0e398d4b3bea$var$replacer);
};
var $c76c0e398d4b3bea$var$URLSearchParamsIterator = $8067e66a49ca6349$exports(function Iterator(params, kind) {
    $c76c0e398d4b3bea$var$setInternalState(this, {
        type: $c76c0e398d4b3bea$var$URL_SEARCH_PARAMS_ITERATOR,
        target: $c76c0e398d4b3bea$var$getInternalParamsState(params).entries,
        index: 0,
        kind: kind
    });
}, $c76c0e398d4b3bea$var$URL_SEARCH_PARAMS, function next() {
    var state = $c76c0e398d4b3bea$var$getInternalIteratorState(this);
    var target = state.target;
    var index = state.index++;
    if (!target || index >= target.length) {
        state.target = null;
        return $71995534a6c57f64$exports(undefined, true);
    }
    var entry = target[index];
    switch(state.kind){
        case 'keys':
            return $71995534a6c57f64$exports(entry.key, false);
        case 'values':
            return $71995534a6c57f64$exports(entry.value, false);
    }
    return $71995534a6c57f64$exports([
        entry.key,
        entry.value
    ], false);
}, true);
var $c76c0e398d4b3bea$var$URLSearchParamsState = function URLSearchParamsState(init) {
    this.entries = [];
    this.url = null;
    if (init !== undefined) {
        if ($4d7f82f6c4645870$exports(init)) this.parseObject(init);
        else this.parseQuery(typeof init == 'string' ? $c76c0e398d4b3bea$var$charAt(init, 0) === '?' ? $c76c0e398d4b3bea$var$stringSlice(init, 1) : init : $7c610b7ee22557b5$exports(init));
    }
};
$c76c0e398d4b3bea$var$URLSearchParamsState.prototype = {
    type: $c76c0e398d4b3bea$var$URL_SEARCH_PARAMS,
    bindURL: function bindURL(url) {
        this.url = url;
        this.update();
    },
    parseObject: function parseObject(object) {
        var entries = this.entries;
        var iteratorMethod = $72368fb318b24c5c$exports(object);
        var iterator, next, step, entryIterator, entryNext, first, second;
        if (iteratorMethod) {
            iterator = $76e56b966649496d$exports(object, iteratorMethod);
            next = iterator.next;
            while(!(step = $59bf80837927ca02$exports(next, iterator)).done){
                entryIterator = $76e56b966649496d$exports($7d9b9f0a2a7e34a2$exports(step.value));
                entryNext = entryIterator.next;
                if ((first = $59bf80837927ca02$exports(entryNext, entryIterator)).done || (second = $59bf80837927ca02$exports(entryNext, entryIterator)).done || !$59bf80837927ca02$exports(entryNext, entryIterator).done) throw new $c76c0e398d4b3bea$var$TypeError('Expected sequence with length 2');
                $c76c0e398d4b3bea$var$push(entries, {
                    key: $7c610b7ee22557b5$exports(first.value),
                    value: $7c610b7ee22557b5$exports(second.value)
                });
            }
        } else for(var key in object)if ($8bbc2bccc0a29296$exports(object, key)) $c76c0e398d4b3bea$var$push(entries, {
            key: key,
            value: $7c610b7ee22557b5$exports(object[key])
        });
    },
    parseQuery: function parseQuery(query) {
        if (query) {
            var entries = this.entries;
            var attributes = $c76c0e398d4b3bea$var$split(query, '&');
            var index = 0;
            var attribute, entry;
            while(index < attributes.length){
                attribute = attributes[index++];
                if (attribute.length) {
                    entry = $c76c0e398d4b3bea$var$split(attribute, '=');
                    $c76c0e398d4b3bea$var$push(entries, {
                        key: $c76c0e398d4b3bea$var$decode($c76c0e398d4b3bea$var$shift(entry)),
                        value: $c76c0e398d4b3bea$var$decode($c76c0e398d4b3bea$var$join(entry, '='))
                    });
                }
            }
        }
    },
    serialize: function serialize1() {
        var entries = this.entries;
        var result = [];
        var index = 0;
        var entry;
        while(index < entries.length){
            entry = entries[index++];
            $c76c0e398d4b3bea$var$push(result, $c76c0e398d4b3bea$var$serialize(entry.key) + '=' + $c76c0e398d4b3bea$var$serialize(entry.value));
        }
        return $c76c0e398d4b3bea$var$join(result, '&');
    },
    update: function update() {
        this.entries.length = 0;
        this.parseQuery(this.url.query);
    },
    updateURL: function updateURL() {
        if (this.url) this.url.update();
    }
};
// `URLSearchParams` constructor
// https://url.spec.whatwg.org/#interface-urlsearchparams
var $c76c0e398d4b3bea$var$URLSearchParamsConstructor = function URLSearchParams() {
    $93a46accb3e7c173$exports(this, $c76c0e398d4b3bea$var$URLSearchParamsPrototype);
    var init = arguments.length > 0 ? arguments[0] : undefined;
    var state = $c76c0e398d4b3bea$var$setInternalState(this, new $c76c0e398d4b3bea$var$URLSearchParamsState(init));
    if (!$b9f536d3284d7921$exports) this.size = state.entries.length;
};
var $c76c0e398d4b3bea$var$URLSearchParamsPrototype = $c76c0e398d4b3bea$var$URLSearchParamsConstructor.prototype;
$260286081d4ac307$exports($c76c0e398d4b3bea$var$URLSearchParamsPrototype, {
    // `URLSearchParams.prototype.append` method
    // https://url.spec.whatwg.org/#dom-urlsearchparams-append
    append: function append(name, value) {
        var state = $c76c0e398d4b3bea$var$getInternalParamsState(this);
        $01603bd6f8ce1d57$exports(arguments.length, 2);
        $c76c0e398d4b3bea$var$push(state.entries, {
            key: $7c610b7ee22557b5$exports(name),
            value: $7c610b7ee22557b5$exports(value)
        });
        if (!$b9f536d3284d7921$exports) this.size++;
        state.updateURL();
    },
    // `URLSearchParams.prototype.delete` method
    // https://url.spec.whatwg.org/#dom-urlsearchparams-delete
    'delete': function(name /* , value */ ) {
        var state = $c76c0e398d4b3bea$var$getInternalParamsState(this);
        var length = $01603bd6f8ce1d57$exports(arguments.length, 1);
        var entries = state.entries;
        var key = $7c610b7ee22557b5$exports(name);
        var $value = length < 2 ? undefined : arguments[1];
        var value = $value === undefined ? $value : $7c610b7ee22557b5$exports($value);
        var index = 0;
        while(index < entries.length){
            var entry = entries[index];
            if (entry.key === key && (value === undefined || entry.value === value)) $c76c0e398d4b3bea$var$splice(entries, index, 1);
            else index++;
        }
        if (!$b9f536d3284d7921$exports) this.size = entries.length;
        state.updateURL();
    },
    // `URLSearchParams.prototype.get` method
    // https://url.spec.whatwg.org/#dom-urlsearchparams-get
    get: function get(name) {
        var entries = $c76c0e398d4b3bea$var$getInternalParamsState(this).entries;
        $01603bd6f8ce1d57$exports(arguments.length, 1);
        var key = $7c610b7ee22557b5$exports(name);
        var index = 0;
        for(; index < entries.length; index++){
            if (entries[index].key === key) return entries[index].value;
        }
        return null;
    },
    // `URLSearchParams.prototype.getAll` method
    // https://url.spec.whatwg.org/#dom-urlsearchparams-getall
    getAll: function getAll(name) {
        var entries = $c76c0e398d4b3bea$var$getInternalParamsState(this).entries;
        $01603bd6f8ce1d57$exports(arguments.length, 1);
        var key = $7c610b7ee22557b5$exports(name);
        var result = [];
        var index = 0;
        for(; index < entries.length; index++)if (entries[index].key === key) $c76c0e398d4b3bea$var$push(result, entries[index].value);
        return result;
    },
    // `URLSearchParams.prototype.has` method
    // https://url.spec.whatwg.org/#dom-urlsearchparams-has
    has: function has(name /* , value */ ) {
        var entries = $c76c0e398d4b3bea$var$getInternalParamsState(this).entries;
        var length = $01603bd6f8ce1d57$exports(arguments.length, 1);
        var key = $7c610b7ee22557b5$exports(name);
        var $value = length < 2 ? undefined : arguments[1];
        var value = $value === undefined ? $value : $7c610b7ee22557b5$exports($value);
        var index = 0;
        while(index < entries.length){
            var entry = entries[index++];
            if (entry.key === key && (value === undefined || entry.value === value)) return true;
        }
        return false;
    },
    // `URLSearchParams.prototype.set` method
    // https://url.spec.whatwg.org/#dom-urlsearchparams-set
    set: function set(name, value) {
        var state = $c76c0e398d4b3bea$var$getInternalParamsState(this);
        $01603bd6f8ce1d57$exports(arguments.length, 2);
        var entries = state.entries;
        var found = false;
        var key = $7c610b7ee22557b5$exports(name);
        var val = $7c610b7ee22557b5$exports(value);
        var index = 0;
        var entry;
        for(; index < entries.length; index++){
            entry = entries[index];
            if (entry.key === key) {
                if (found) $c76c0e398d4b3bea$var$splice(entries, index--, 1);
                else {
                    found = true;
                    entry.value = val;
                }
            }
        }
        if (!found) $c76c0e398d4b3bea$var$push(entries, {
            key: key,
            value: val
        });
        if (!$b9f536d3284d7921$exports) this.size = entries.length;
        state.updateURL();
    },
    // `URLSearchParams.prototype.sort` method
    // https://url.spec.whatwg.org/#dom-urlsearchparams-sort
    sort: function sort() {
        var state = $c76c0e398d4b3bea$var$getInternalParamsState(this);
        $a4ee3cc522d386c7$exports(state.entries, function(a, b) {
            return a.key > b.key ? 1 : -1;
        });
        state.updateURL();
    },
    // `URLSearchParams.prototype.forEach` method
    forEach: function forEach(callback /* , thisArg */ ) {
        var entries = $c76c0e398d4b3bea$var$getInternalParamsState(this).entries;
        var boundFunction = $8a0b7edcb386df4b$exports(callback, arguments.length > 1 ? arguments[1] : undefined);
        var index = 0;
        var entry;
        while(index < entries.length){
            entry = entries[index++];
            boundFunction(entry.value, entry.key, this);
        }
    },
    // `URLSearchParams.prototype.keys` method
    keys: function keys() {
        return new $c76c0e398d4b3bea$var$URLSearchParamsIterator(this, 'keys');
    },
    // `URLSearchParams.prototype.values` method
    values: function values() {
        return new $c76c0e398d4b3bea$var$URLSearchParamsIterator(this, 'values');
    },
    // `URLSearchParams.prototype.entries` method
    entries: function entries() {
        return new $c76c0e398d4b3bea$var$URLSearchParamsIterator(this, 'entries');
    }
}, {
    enumerable: true
});
// `URLSearchParams.prototype[@@iterator]` method
$73c8864ae5df5c4d$exports($c76c0e398d4b3bea$var$URLSearchParamsPrototype, $c76c0e398d4b3bea$var$ITERATOR, $c76c0e398d4b3bea$var$URLSearchParamsPrototype.entries, {
    name: 'entries'
});
// `URLSearchParams.prototype.toString` method
// https://url.spec.whatwg.org/#urlsearchparams-stringification-behavior
$73c8864ae5df5c4d$exports($c76c0e398d4b3bea$var$URLSearchParamsPrototype, 'toString', function toString() {
    return $c76c0e398d4b3bea$var$getInternalParamsState(this).serialize();
}, {
    enumerable: true
});
// `URLSearchParams.prototype.size` getter
// https://url.spec.whatwg.org/#dom-urlsearchparams-size
if ($b9f536d3284d7921$exports) $71a985fce44d8187$exports($c76c0e398d4b3bea$var$URLSearchParamsPrototype, 'size', {
    get: function size() {
        return $c76c0e398d4b3bea$var$getInternalParamsState(this).entries.length;
    },
    configurable: true,
    enumerable: true
});
$54a3ba2fb7b04ac0$exports($c76c0e398d4b3bea$var$URLSearchParamsConstructor, $c76c0e398d4b3bea$var$URL_SEARCH_PARAMS);
$244155c096ef4c14$exports({
    global: true,
    constructor: true,
    forced: !$2bd41c46b7be4aca$exports
}, {
    URLSearchParams: $c76c0e398d4b3bea$var$URLSearchParamsConstructor
});
// Wrap `fetch` and `Request` for correct work with polyfilled `URLSearchParams`
if (!$2bd41c46b7be4aca$exports && $7c165f740ca92c53$exports($c76c0e398d4b3bea$var$Headers)) {
    var $c76c0e398d4b3bea$var$headersHas = $c224a7eda28c33b3$exports($c76c0e398d4b3bea$var$HeadersPrototype.has);
    var $c76c0e398d4b3bea$var$headersSet = $c224a7eda28c33b3$exports($c76c0e398d4b3bea$var$HeadersPrototype.set);
    var $c76c0e398d4b3bea$var$wrapRequestOptions = function wrapRequestOptions(init) {
        if ($4d7f82f6c4645870$exports(init)) {
            var body = init.body;
            var headers;
            if ($b720974ac29b37e2$exports(body) === $c76c0e398d4b3bea$var$URL_SEARCH_PARAMS) {
                headers = init.headers ? new $c76c0e398d4b3bea$var$Headers(init.headers) : new $c76c0e398d4b3bea$var$Headers();
                if (!$c76c0e398d4b3bea$var$headersHas(headers, 'content-type')) $c76c0e398d4b3bea$var$headersSet(headers, 'content-type', 'application/x-www-form-urlencoded;charset=UTF-8');
                return $491a5d5aa2efe6ec$exports(init, {
                    body: $27c455d39660edb8$exports(0, $7c610b7ee22557b5$exports(body)),
                    headers: $27c455d39660edb8$exports(0, headers)
                });
            }
        }
        return init;
    };
    if ($7c165f740ca92c53$exports($c76c0e398d4b3bea$var$nativeFetch)) $244155c096ef4c14$exports({
        global: true,
        enumerable: true,
        dontCallGetSet: true,
        forced: true
    }, {
        fetch: function fetch(input /* , init */ ) {
            return $c76c0e398d4b3bea$var$nativeFetch(input, arguments.length > 1 ? $c76c0e398d4b3bea$var$wrapRequestOptions(arguments[1]) : {});
        }
    });
    if ($7c165f740ca92c53$exports($c76c0e398d4b3bea$var$NativeRequest)) {
        var $c76c0e398d4b3bea$var$RequestConstructor = function Request(input /* , init */ ) {
            $93a46accb3e7c173$exports(this, $c76c0e398d4b3bea$var$RequestPrototype);
            return new $c76c0e398d4b3bea$var$NativeRequest(input, arguments.length > 1 ? $c76c0e398d4b3bea$var$wrapRequestOptions(arguments[1]) : {});
        };
        $c76c0e398d4b3bea$var$RequestPrototype.constructor = $c76c0e398d4b3bea$var$RequestConstructor;
        $c76c0e398d4b3bea$var$RequestConstructor.prototype = $c76c0e398d4b3bea$var$RequestPrototype;
        $244155c096ef4c14$exports({
            global: true,
            constructor: true,
            dontCallGetSet: true,
            forced: true
        }, {
            Request: $c76c0e398d4b3bea$var$RequestConstructor
        });
    }
}
$c76c0e398d4b3bea$exports = {
    URLSearchParams: $c76c0e398d4b3bea$var$URLSearchParamsConstructor,
    getState: $c76c0e398d4b3bea$var$getInternalParamsState
};



var $b7cb89a1c4679e8f$var$setInternalState = $fcfe8b5396fbe91a$exports.set;
var $b7cb89a1c4679e8f$var$getInternalURLState = $fcfe8b5396fbe91a$exports.getterFor('URL');
var $b7cb89a1c4679e8f$var$URLSearchParams = $c76c0e398d4b3bea$exports.URLSearchParams;
var $b7cb89a1c4679e8f$var$getInternalSearchParamsState = $c76c0e398d4b3bea$exports.getState;
var $b7cb89a1c4679e8f$var$NativeURL = $27350b6a9e85aed1$exports.URL;
var $b7cb89a1c4679e8f$var$TypeError = $27350b6a9e85aed1$exports.TypeError;
var $b7cb89a1c4679e8f$var$encodeURIComponent = $27350b6a9e85aed1$exports.encodeURIComponent;
var $b7cb89a1c4679e8f$var$parseInt = $27350b6a9e85aed1$exports.parseInt;
var $b7cb89a1c4679e8f$var$floor = Math.floor;
var $b7cb89a1c4679e8f$var$pow = Math.pow;
var $b7cb89a1c4679e8f$var$charAt = $c224a7eda28c33b3$exports(''.charAt);
var $b7cb89a1c4679e8f$var$exec = $c224a7eda28c33b3$exports(/./.exec);
var $b7cb89a1c4679e8f$var$join = $c224a7eda28c33b3$exports([].join);
var $b7cb89a1c4679e8f$var$numberToString = $c224a7eda28c33b3$exports(1.1.toString);
var $b7cb89a1c4679e8f$var$pop = $c224a7eda28c33b3$exports([].pop);
var $b7cb89a1c4679e8f$var$push = $c224a7eda28c33b3$exports([].push);
var $b7cb89a1c4679e8f$var$replace = $c224a7eda28c33b3$exports(''.replace);
var $b7cb89a1c4679e8f$var$shift = $c224a7eda28c33b3$exports([].shift);
var $b7cb89a1c4679e8f$var$split = $c224a7eda28c33b3$exports(''.split);
var $b7cb89a1c4679e8f$var$stringSlice = $c224a7eda28c33b3$exports(''.slice);
var $b7cb89a1c4679e8f$var$toLowerCase = $c224a7eda28c33b3$exports(''.toLowerCase);
var $b7cb89a1c4679e8f$var$unshift = $c224a7eda28c33b3$exports([].unshift);
var $b7cb89a1c4679e8f$var$INVALID_AUTHORITY = 'Invalid authority';
var $b7cb89a1c4679e8f$var$INVALID_SCHEME = 'Invalid scheme';
var $b7cb89a1c4679e8f$var$INVALID_HOST = 'Invalid host';
var $b7cb89a1c4679e8f$var$INVALID_PORT = 'Invalid port';
var $b7cb89a1c4679e8f$var$ALPHA = /[a-z]/i;
var $b7cb89a1c4679e8f$var$ALPHANUMERIC_PLUS_MINUS_DOT = /[\d+\-.a-z]/i;
var $b7cb89a1c4679e8f$var$DIGIT = /\d/;
var $b7cb89a1c4679e8f$var$HEX_START = /^0x/i;
var $b7cb89a1c4679e8f$var$OCT = /^[0-7]+$/;
var $b7cb89a1c4679e8f$var$DEC = /^\d+$/;
var $b7cb89a1c4679e8f$var$HEX = /^[\da-f]+$/i;
/* eslint-disable regexp/no-control-character -- safe */ var $b7cb89a1c4679e8f$var$FORBIDDEN_HOST_CODE_POINT = /[\0\t\n\r #%/:<>?@[\\\]^|]/;
var $b7cb89a1c4679e8f$var$FORBIDDEN_HOST_CODE_POINT_EXCLUDING_PERCENT = /[\0\t\n\r #/:<>?@[\\\]^|]/;
var $b7cb89a1c4679e8f$var$LEADING_C0_CONTROL_OR_SPACE = /^[\u0000-\u0020]+/;
var $b7cb89a1c4679e8f$var$TRAILING_C0_CONTROL_OR_SPACE = /(^|[^\u0000-\u0020])[\u0000-\u0020]+$/;
var $b7cb89a1c4679e8f$var$TAB_AND_NEW_LINE = /[\t\n\r]/g;
/* eslint-enable regexp/no-control-character -- safe */ // eslint-disable-next-line no-unassigned-vars -- expected `undefined` value
var $b7cb89a1c4679e8f$var$EOF;
// https://url.spec.whatwg.org/#ends-in-a-number-checker
var $b7cb89a1c4679e8f$var$endsInNumber = function endsInNumber(input) {
    var parts = $b7cb89a1c4679e8f$var$split(input, '.');
    var last, hexPart;
    if (parts[parts.length - 1] === '') {
        if (parts.length === 1) return false;
        parts.length--;
    }
    last = parts[parts.length - 1];
    if ($b7cb89a1c4679e8f$var$exec($b7cb89a1c4679e8f$var$DEC, last)) return true;
    if ($b7cb89a1c4679e8f$var$exec($b7cb89a1c4679e8f$var$HEX_START, last)) {
        hexPart = $b7cb89a1c4679e8f$var$stringSlice(last, 2);
        return hexPart === '' || !!$b7cb89a1c4679e8f$var$exec($b7cb89a1c4679e8f$var$HEX, hexPart);
    }
    return false;
};
// https://url.spec.whatwg.org/#concept-ipv4-parser
var $b7cb89a1c4679e8f$var$parseIPv4 = function parseIPv4(input) {
    var parts = $b7cb89a1c4679e8f$var$split(input, '.');
    var partsLength, numbers, index, part, radix, number, ipv4;
    if (parts.length && parts[parts.length - 1] === '') parts.length--;
    partsLength = parts.length;
    if (partsLength > 4) return null;
    numbers = [];
    for(index = 0; index < partsLength; index++){
        part = parts[index];
        if (part === '') return null;
        radix = 10;
        if (part.length > 1 && $b7cb89a1c4679e8f$var$charAt(part, 0) === '0') {
            radix = $b7cb89a1c4679e8f$var$exec($b7cb89a1c4679e8f$var$HEX_START, part) ? 16 : 8;
            part = $b7cb89a1c4679e8f$var$stringSlice(part, radix === 8 ? 1 : 2);
        }
        if (part === '') number = 0;
        else {
            if (!$b7cb89a1c4679e8f$var$exec(radix === 10 ? $b7cb89a1c4679e8f$var$DEC : radix === 8 ? $b7cb89a1c4679e8f$var$OCT : $b7cb89a1c4679e8f$var$HEX, part)) return null;
            number = $b7cb89a1c4679e8f$var$parseInt(part, radix);
        }
        $b7cb89a1c4679e8f$var$push(numbers, number);
    }
    for(index = 0; index < partsLength; index++){
        number = numbers[index];
        if (index === partsLength - 1) {
            if (number >= $b7cb89a1c4679e8f$var$pow(256, 5 - partsLength)) return null;
        } else if (number > 255) return null;
    }
    ipv4 = $b7cb89a1c4679e8f$var$pop(numbers);
    for(index = 0; index < numbers.length; index++)ipv4 += numbers[index] * $b7cb89a1c4679e8f$var$pow(256, 3 - index);
    return ipv4;
};
// https://url.spec.whatwg.org/#concept-ipv6-parser
// eslint-disable-next-line max-statements -- TODO
var $b7cb89a1c4679e8f$var$parseIPv6 = function parseIPv6(input) {
    var address = [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
    ];
    var pieceIndex = 0;
    var compress = null;
    var pointer = 0;
    var value, length, numbersSeen, ipv4Piece, number, swaps, swap;
    var chr = function chr() {
        return $b7cb89a1c4679e8f$var$charAt(input, pointer);
    };
    if (chr() === ':') {
        if ($b7cb89a1c4679e8f$var$charAt(input, 1) !== ':') return;
        pointer += 2;
        pieceIndex++;
        compress = pieceIndex;
    }
    while(chr()){
        if (pieceIndex === 8) return;
        if (chr() === ':') {
            if (compress !== null) return;
            pointer++;
            pieceIndex++;
            compress = pieceIndex;
            continue;
        }
        value = length = 0;
        while(length < 4 && $b7cb89a1c4679e8f$var$exec($b7cb89a1c4679e8f$var$HEX, chr())){
            value = value * 16 + $b7cb89a1c4679e8f$var$parseInt(chr(), 16);
            pointer++;
            length++;
        }
        if (chr() === '.') {
            if (length === 0) return;
            pointer -= length;
            if (pieceIndex > 6) return;
            numbersSeen = 0;
            while(chr()){
                ipv4Piece = null;
                if (numbersSeen > 0) {
                    if (chr() === '.' && numbersSeen < 4) pointer++;
                    else return;
                }
                if (!$b7cb89a1c4679e8f$var$exec($b7cb89a1c4679e8f$var$DIGIT, chr())) return;
                while($b7cb89a1c4679e8f$var$exec($b7cb89a1c4679e8f$var$DIGIT, chr())){
                    number = $b7cb89a1c4679e8f$var$parseInt(chr(), 10);
                    if (ipv4Piece === null) ipv4Piece = number;
                    else if (ipv4Piece === 0) return;
                    else ipv4Piece = ipv4Piece * 10 + number;
                    if (ipv4Piece > 255) return;
                    pointer++;
                }
                address[pieceIndex] = address[pieceIndex] * 256 + ipv4Piece;
                numbersSeen++;
                if (numbersSeen === 2 || numbersSeen === 4) pieceIndex++;
            }
            if (numbersSeen !== 4) return;
            break;
        } else if (chr() === ':') {
            pointer++;
            if (!chr()) return;
        } else if (chr()) return;
        address[pieceIndex++] = value;
    }
    if (compress !== null) {
        swaps = pieceIndex - compress;
        pieceIndex = 7;
        while(pieceIndex !== 0 && swaps > 0){
            swap = address[pieceIndex];
            address[pieceIndex--] = address[compress + swaps - 1];
            address[compress + --swaps] = swap;
        }
    } else if (pieceIndex !== 8) return;
    return address;
};
var $b7cb89a1c4679e8f$var$findLongestZeroSequence = function findLongestZeroSequence(ipv6) {
    var maxIndex = null;
    var maxLength = 1;
    var currStart = null;
    var currLength = 0;
    var index = 0;
    for(; index < 8; index++)if (ipv6[index] !== 0) {
        if (currLength > maxLength) {
            maxIndex = currStart;
            maxLength = currLength;
        }
        currStart = null;
        currLength = 0;
    } else {
        if (currStart === null) currStart = index;
        ++currLength;
    }
    return currLength > maxLength ? currStart : maxIndex;
};
// https://url.spec.whatwg.org/#host-serializing
var $b7cb89a1c4679e8f$var$serializeHost = function serializeHost(host) {
    var result, index, compress, ignore0;
    // ipv4
    if (typeof host == 'number') {
        result = [];
        for(index = 0; index < 4; index++){
            $b7cb89a1c4679e8f$var$unshift(result, host % 256);
            host = $b7cb89a1c4679e8f$var$floor(host / 256);
        }
        return $b7cb89a1c4679e8f$var$join(result, '.');
    }
    // ipv6
    if ((typeof host === "undefined" ? "undefined" : (0, $6tOPT._)(host)) == 'object') {
        result = '';
        compress = $b7cb89a1c4679e8f$var$findLongestZeroSequence(host);
        for(index = 0; index < 8; index++){
            if (ignore0 && host[index] === 0) continue;
            if (ignore0) ignore0 = false;
            if (compress === index) {
                result += index ? ':' : '::';
                ignore0 = true;
            } else {
                result += $b7cb89a1c4679e8f$var$numberToString(host[index], 16);
                if (index < 7) result += ':';
            }
        }
        return '[' + result + ']';
    }
    return host;
};
var $b7cb89a1c4679e8f$var$C0ControlPercentEncodeSet = {};
var $b7cb89a1c4679e8f$var$queryPercentEncodeSet = $c4a7f9a76fc3d051$exports({}, $b7cb89a1c4679e8f$var$C0ControlPercentEncodeSet, {
    ' ': 1,
    '"': 1,
    '#': 1,
    '<': 1,
    '>': 1
});
var $b7cb89a1c4679e8f$var$specialQueryPercentEncodeSet = $c4a7f9a76fc3d051$exports({}, $b7cb89a1c4679e8f$var$queryPercentEncodeSet, {
    "'": 1
});
var $b7cb89a1c4679e8f$var$fragmentPercentEncodeSet = $c4a7f9a76fc3d051$exports({}, $b7cb89a1c4679e8f$var$C0ControlPercentEncodeSet, {
    ' ': 1,
    '"': 1,
    '<': 1,
    '>': 1,
    '`': 1
});
var $b7cb89a1c4679e8f$var$pathPercentEncodeSet = $c4a7f9a76fc3d051$exports({}, $b7cb89a1c4679e8f$var$fragmentPercentEncodeSet, {
    '#': 1,
    '?': 1,
    '{': 1,
    '}': 1,
    '^': 1
});
var $b7cb89a1c4679e8f$var$userinfoPercentEncodeSet = $c4a7f9a76fc3d051$exports({}, $b7cb89a1c4679e8f$var$pathPercentEncodeSet, {
    '/': 1,
    ':': 1,
    ';': 1,
    '=': 1,
    '@': 1,
    '[': 1,
    '\\': 1,
    ']': 1,
    '^': 1,
    '|': 1
});
var $b7cb89a1c4679e8f$var$percentEncode = function percentEncode(chr, set) {
    var code = $b7cb89a1c4679e8f$require$codeAt(chr, 0);
    // encodeURIComponent does not encode ', which is in the special-query percent-encode set
    return code >= 0x20 && code < 0x7F && !$8bbc2bccc0a29296$exports(set, chr) ? chr : chr === "'" && $8bbc2bccc0a29296$exports(set, chr) ? '%27' : $b7cb89a1c4679e8f$var$encodeURIComponent(chr);
};
// https://url.spec.whatwg.org/#special-scheme
var $b7cb89a1c4679e8f$var$specialSchemes = {
    ftp: 21,
    file: null,
    http: 80,
    https: 443,
    ws: 80,
    wss: 443
};
// https://url.spec.whatwg.org/#windows-drive-letter
var $b7cb89a1c4679e8f$var$isWindowsDriveLetter = function isWindowsDriveLetter(string, normalized) {
    var second;
    return string.length === 2 && $b7cb89a1c4679e8f$var$exec($b7cb89a1c4679e8f$var$ALPHA, $b7cb89a1c4679e8f$var$charAt(string, 0)) && ((second = $b7cb89a1c4679e8f$var$charAt(string, 1)) === ':' || !normalized && second === '|');
};
// https://url.spec.whatwg.org/#start-with-a-windows-drive-letter
var $b7cb89a1c4679e8f$var$startsWithWindowsDriveLetter = function startsWithWindowsDriveLetter(string) {
    var third;
    return string.length > 1 && $b7cb89a1c4679e8f$var$isWindowsDriveLetter($b7cb89a1c4679e8f$var$stringSlice(string, 0, 2)) && (string.length === 2 || (third = $b7cb89a1c4679e8f$var$charAt(string, 2)) === '/' || third === '\\' || third === '?' || third === '#');
};
// https://url.spec.whatwg.org/#single-dot-path-segment
var $b7cb89a1c4679e8f$var$isSingleDot = function isSingleDot(segment) {
    return segment === '.' || $b7cb89a1c4679e8f$var$toLowerCase(segment) === '%2e';
};
// https://url.spec.whatwg.org/#double-dot-path-segment
var $b7cb89a1c4679e8f$var$isDoubleDot = function isDoubleDot(segment) {
    segment = $b7cb89a1c4679e8f$var$toLowerCase(segment);
    return segment === '..' || segment === '%2e.' || segment === '.%2e' || segment === '%2e%2e';
};
// States:
var $b7cb89a1c4679e8f$var$SCHEME_START = {};
var $b7cb89a1c4679e8f$var$SCHEME = {};
var $b7cb89a1c4679e8f$var$NO_SCHEME = {};
var $b7cb89a1c4679e8f$var$SPECIAL_RELATIVE_OR_AUTHORITY = {};
var $b7cb89a1c4679e8f$var$PATH_OR_AUTHORITY = {};
var $b7cb89a1c4679e8f$var$RELATIVE = {};
var $b7cb89a1c4679e8f$var$RELATIVE_SLASH = {};
var $b7cb89a1c4679e8f$var$SPECIAL_AUTHORITY_SLASHES = {};
var $b7cb89a1c4679e8f$var$SPECIAL_AUTHORITY_IGNORE_SLASHES = {};
var $b7cb89a1c4679e8f$var$AUTHORITY = {};
var $b7cb89a1c4679e8f$var$HOST = {};
var $b7cb89a1c4679e8f$var$HOSTNAME = {};
var $b7cb89a1c4679e8f$var$PORT = {};
var $b7cb89a1c4679e8f$var$FILE = {};
var $b7cb89a1c4679e8f$var$FILE_SLASH = {};
var $b7cb89a1c4679e8f$var$FILE_HOST = {};
var $b7cb89a1c4679e8f$var$PATH_START = {};
var $b7cb89a1c4679e8f$var$PATH = {};
var $b7cb89a1c4679e8f$var$CANNOT_BE_A_BASE_URL_PATH = {};
var $b7cb89a1c4679e8f$var$QUERY = {};
var $b7cb89a1c4679e8f$var$FRAGMENT = {};
var $b7cb89a1c4679e8f$var$URLState = function URLState1(url, isBase, base) {
    var urlString = $7c610b7ee22557b5$exports(url);
    var baseState, failure, searchParams;
    if (isBase) {
        failure = this.parse(urlString);
        if (failure) throw new $b7cb89a1c4679e8f$var$TypeError(failure);
        this.searchParams = null;
    } else {
        if (base !== undefined) baseState = new $b7cb89a1c4679e8f$var$URLState(base, true);
        failure = this.parse(urlString, null, baseState);
        if (failure) throw new $b7cb89a1c4679e8f$var$TypeError(failure);
        searchParams = $b7cb89a1c4679e8f$var$getInternalSearchParamsState(new $b7cb89a1c4679e8f$var$URLSearchParams());
        searchParams.bindURL(this);
        this.searchParams = searchParams;
    }
};
$b7cb89a1c4679e8f$var$URLState.prototype = {
    type: 'URL',
    // https://url.spec.whatwg.org/#url-parsing
    // eslint-disable-next-line max-statements -- TODO
    parse: function parse(input, stateOverride, base) {
        var url = this;
        var state = stateOverride || $b7cb89a1c4679e8f$var$SCHEME_START;
        var pointer = 0;
        var buffer = '';
        var seenAt = false;
        var seenBracket = false;
        var seenPasswordToken = false;
        var codePoints, chr, bufferCodePoints, failure;
        input = $7c610b7ee22557b5$exports(input);
        if (!stateOverride) {
            url.scheme = '';
            url.username = '';
            url.password = '';
            url.host = null;
            url.port = null;
            url.path = [];
            url.query = null;
            url.fragment = null;
            url.cannotBeABaseURL = false;
            input = $b7cb89a1c4679e8f$var$replace(input, $b7cb89a1c4679e8f$var$LEADING_C0_CONTROL_OR_SPACE, '');
            input = $b7cb89a1c4679e8f$var$replace(input, $b7cb89a1c4679e8f$var$TRAILING_C0_CONTROL_OR_SPACE, '$1');
        }
        input = $b7cb89a1c4679e8f$var$replace(input, $b7cb89a1c4679e8f$var$TAB_AND_NEW_LINE, '');
        codePoints = $9173555772c6cd7a$exports(input);
        while(pointer <= codePoints.length){
            chr = codePoints[pointer];
            switch(state){
                case $b7cb89a1c4679e8f$var$SCHEME_START:
                    if (chr && $b7cb89a1c4679e8f$var$exec($b7cb89a1c4679e8f$var$ALPHA, chr)) {
                        buffer += $b7cb89a1c4679e8f$var$toLowerCase(chr);
                        state = $b7cb89a1c4679e8f$var$SCHEME;
                    } else if (!stateOverride) {
                        state = $b7cb89a1c4679e8f$var$NO_SCHEME;
                        continue;
                    } else return $b7cb89a1c4679e8f$var$INVALID_SCHEME;
                    break;
                case $b7cb89a1c4679e8f$var$SCHEME:
                    if (chr && $b7cb89a1c4679e8f$var$exec($b7cb89a1c4679e8f$var$ALPHANUMERIC_PLUS_MINUS_DOT, chr)) buffer += $b7cb89a1c4679e8f$var$toLowerCase(chr);
                    else if (chr === ':') {
                        if (stateOverride && (url.isSpecial() !== $8bbc2bccc0a29296$exports($b7cb89a1c4679e8f$var$specialSchemes, buffer) || buffer === 'file' && (url.includesCredentials() || url.port !== null) || url.scheme === 'file' && url.host === '')) return;
                        url.scheme = buffer;
                        if (stateOverride) {
                            if (url.isSpecial() && $b7cb89a1c4679e8f$var$specialSchemes[url.scheme] === url.port) url.port = null;
                            return;
                        }
                        buffer = '';
                        if (url.scheme === 'file') state = $b7cb89a1c4679e8f$var$FILE;
                        else if (url.isSpecial() && base && base.scheme === url.scheme) state = $b7cb89a1c4679e8f$var$SPECIAL_RELATIVE_OR_AUTHORITY;
                        else if (url.isSpecial()) state = $b7cb89a1c4679e8f$var$SPECIAL_AUTHORITY_SLASHES;
                        else if (codePoints[pointer + 1] === '/') {
                            state = $b7cb89a1c4679e8f$var$PATH_OR_AUTHORITY;
                            pointer++;
                        } else {
                            url.cannotBeABaseURL = true;
                            $b7cb89a1c4679e8f$var$push(url.path, '');
                            state = $b7cb89a1c4679e8f$var$CANNOT_BE_A_BASE_URL_PATH;
                        }
                    } else if (!stateOverride) {
                        buffer = '';
                        state = $b7cb89a1c4679e8f$var$NO_SCHEME;
                        pointer = 0;
                        continue;
                    } else return $b7cb89a1c4679e8f$var$INVALID_SCHEME;
                    break;
                case $b7cb89a1c4679e8f$var$NO_SCHEME:
                    if (!base || base.cannotBeABaseURL && chr !== '#') return $b7cb89a1c4679e8f$var$INVALID_SCHEME;
                    if (base.cannotBeABaseURL && chr === '#') {
                        url.scheme = base.scheme;
                        url.path = $2dd14968e62d6eb1$exports(base.path);
                        url.query = base.query;
                        url.fragment = '';
                        url.cannotBeABaseURL = true;
                        state = $b7cb89a1c4679e8f$var$FRAGMENT;
                        break;
                    }
                    state = base.scheme === 'file' ? $b7cb89a1c4679e8f$var$FILE : $b7cb89a1c4679e8f$var$RELATIVE;
                    continue;
                case $b7cb89a1c4679e8f$var$SPECIAL_RELATIVE_OR_AUTHORITY:
                    if (chr === '/' && codePoints[pointer + 1] === '/') {
                        state = $b7cb89a1c4679e8f$var$SPECIAL_AUTHORITY_IGNORE_SLASHES;
                        pointer++;
                    } else {
                        state = $b7cb89a1c4679e8f$var$RELATIVE;
                        continue;
                    }
                    break;
                case $b7cb89a1c4679e8f$var$PATH_OR_AUTHORITY:
                    if (chr === '/') {
                        state = $b7cb89a1c4679e8f$var$AUTHORITY;
                        break;
                    } else {
                        state = $b7cb89a1c4679e8f$var$PATH;
                        continue;
                    }
                case $b7cb89a1c4679e8f$var$RELATIVE:
                    url.scheme = base.scheme;
                    if (chr === $b7cb89a1c4679e8f$var$EOF) {
                        url.username = base.username;
                        url.password = base.password;
                        url.host = base.host;
                        url.port = base.port;
                        url.path = $2dd14968e62d6eb1$exports(base.path);
                        url.query = base.query;
                    } else if (chr === '/' || chr === '\\' && url.isSpecial()) state = $b7cb89a1c4679e8f$var$RELATIVE_SLASH;
                    else if (chr === '?') {
                        url.username = base.username;
                        url.password = base.password;
                        url.host = base.host;
                        url.port = base.port;
                        url.path = $2dd14968e62d6eb1$exports(base.path);
                        url.query = '';
                        state = $b7cb89a1c4679e8f$var$QUERY;
                    } else if (chr === '#') {
                        url.username = base.username;
                        url.password = base.password;
                        url.host = base.host;
                        url.port = base.port;
                        url.path = $2dd14968e62d6eb1$exports(base.path);
                        url.query = base.query;
                        url.fragment = '';
                        state = $b7cb89a1c4679e8f$var$FRAGMENT;
                    } else {
                        url.username = base.username;
                        url.password = base.password;
                        url.host = base.host;
                        url.port = base.port;
                        url.path = $2dd14968e62d6eb1$exports(base.path);
                        if (url.path.length) url.path.length--;
                        state = $b7cb89a1c4679e8f$var$PATH;
                        continue;
                    }
                    break;
                case $b7cb89a1c4679e8f$var$RELATIVE_SLASH:
                    if (url.isSpecial() && (chr === '/' || chr === '\\')) state = $b7cb89a1c4679e8f$var$SPECIAL_AUTHORITY_IGNORE_SLASHES;
                    else if (chr === '/') state = $b7cb89a1c4679e8f$var$AUTHORITY;
                    else {
                        url.username = base.username;
                        url.password = base.password;
                        url.host = base.host;
                        url.port = base.port;
                        state = $b7cb89a1c4679e8f$var$PATH;
                        continue;
                    }
                    break;
                case $b7cb89a1c4679e8f$var$SPECIAL_AUTHORITY_SLASHES:
                    state = $b7cb89a1c4679e8f$var$SPECIAL_AUTHORITY_IGNORE_SLASHES;
                    if (chr !== '/' || codePoints[pointer + 1] !== '/') continue;
                    pointer++;
                    break;
                case $b7cb89a1c4679e8f$var$SPECIAL_AUTHORITY_IGNORE_SLASHES:
                    if (chr !== '/' && chr !== '\\') {
                        state = $b7cb89a1c4679e8f$var$AUTHORITY;
                        continue;
                    }
                    break;
                case $b7cb89a1c4679e8f$var$AUTHORITY:
                    if (chr === '@') {
                        if (seenAt) buffer = '%40' + buffer;
                        seenAt = true;
                        bufferCodePoints = $9173555772c6cd7a$exports(buffer);
                        for(var i = 0; i < bufferCodePoints.length; i++){
                            var codePoint = bufferCodePoints[i];
                            if (codePoint === ':' && !seenPasswordToken) {
                                seenPasswordToken = true;
                                continue;
                            }
                            var encodedCodePoints = $b7cb89a1c4679e8f$var$percentEncode(codePoint, $b7cb89a1c4679e8f$var$userinfoPercentEncodeSet);
                            if (seenPasswordToken) url.password += encodedCodePoints;
                            else url.username += encodedCodePoints;
                        }
                        buffer = '';
                    } else if (chr === $b7cb89a1c4679e8f$var$EOF || chr === '/' || chr === '?' || chr === '#' || chr === '\\' && url.isSpecial()) {
                        if (seenAt && buffer === '') return $b7cb89a1c4679e8f$var$INVALID_AUTHORITY;
                        pointer -= $9173555772c6cd7a$exports(buffer).length + 1;
                        buffer = '';
                        state = $b7cb89a1c4679e8f$var$HOST;
                    } else buffer += chr;
                    break;
                case $b7cb89a1c4679e8f$var$HOST:
                case $b7cb89a1c4679e8f$var$HOSTNAME:
                    if (stateOverride && url.scheme === 'file') {
                        state = $b7cb89a1c4679e8f$var$FILE_HOST;
                        continue;
                    } else if (chr === ':' && !seenBracket) {
                        if (buffer === '') return $b7cb89a1c4679e8f$var$INVALID_HOST;
                        if (stateOverride === $b7cb89a1c4679e8f$var$HOSTNAME) return;
                        failure = url.parseHost(buffer);
                        if (failure) return failure;
                        buffer = '';
                        state = $b7cb89a1c4679e8f$var$PORT;
                    } else if (chr === $b7cb89a1c4679e8f$var$EOF || chr === '/' || chr === '?' || chr === '#' || chr === '\\' && url.isSpecial()) {
                        if (url.isSpecial() && buffer === '') return $b7cb89a1c4679e8f$var$INVALID_HOST;
                        if (stateOverride && buffer === '' && (url.includesCredentials() || url.port !== null)) return;
                        failure = url.parseHost(buffer);
                        if (failure) return failure;
                        buffer = '';
                        state = $b7cb89a1c4679e8f$var$PATH_START;
                        if (stateOverride) return;
                        continue;
                    } else {
                        if (chr === '[') seenBracket = true;
                        else if (chr === ']') seenBracket = false;
                        buffer += chr;
                    }
                    break;
                case $b7cb89a1c4679e8f$var$PORT:
                    if ($b7cb89a1c4679e8f$var$exec($b7cb89a1c4679e8f$var$DIGIT, chr)) buffer += chr;
                    else if (chr === $b7cb89a1c4679e8f$var$EOF || chr === '/' || chr === '?' || chr === '#' || chr === '\\' && url.isSpecial() || stateOverride) {
                        if (buffer !== '') {
                            var port = $b7cb89a1c4679e8f$var$parseInt(buffer, 10);
                            if (port > 0xFFFF) return $b7cb89a1c4679e8f$var$INVALID_PORT;
                            url.port = url.isSpecial() && port === $b7cb89a1c4679e8f$var$specialSchemes[url.scheme] ? null : port;
                            buffer = '';
                        }
                        if (stateOverride) return;
                        state = $b7cb89a1c4679e8f$var$PATH_START;
                        continue;
                    } else return $b7cb89a1c4679e8f$var$INVALID_PORT;
                    break;
                case $b7cb89a1c4679e8f$var$FILE:
                    url.scheme = 'file';
                    url.host = '';
                    if (chr === '/' || chr === '\\') state = $b7cb89a1c4679e8f$var$FILE_SLASH;
                    else if (base && base.scheme === 'file') switch(chr){
                        case $b7cb89a1c4679e8f$var$EOF:
                            url.host = base.host;
                            url.path = $2dd14968e62d6eb1$exports(base.path);
                            url.query = base.query;
                            break;
                        case '?':
                            url.host = base.host;
                            url.path = $2dd14968e62d6eb1$exports(base.path);
                            url.query = '';
                            state = $b7cb89a1c4679e8f$var$QUERY;
                            break;
                        case '#':
                            url.host = base.host;
                            url.path = $2dd14968e62d6eb1$exports(base.path);
                            url.query = base.query;
                            url.fragment = '';
                            state = $b7cb89a1c4679e8f$var$FRAGMENT;
                            break;
                        default:
                            url.host = base.host;
                            if (!$b7cb89a1c4679e8f$var$startsWithWindowsDriveLetter($b7cb89a1c4679e8f$var$join($2dd14968e62d6eb1$exports(codePoints, pointer), ''))) {
                                url.path = $2dd14968e62d6eb1$exports(base.path);
                                url.shortenPath();
                            }
                            state = $b7cb89a1c4679e8f$var$PATH;
                            continue;
                    }
                    else {
                        state = $b7cb89a1c4679e8f$var$PATH;
                        continue;
                    }
                    break;
                case $b7cb89a1c4679e8f$var$FILE_SLASH:
                    if (chr === '/' || chr === '\\') {
                        state = $b7cb89a1c4679e8f$var$FILE_HOST;
                        break;
                    }
                    if (base && base.scheme === 'file') {
                        url.host = base.host;
                        if (!$b7cb89a1c4679e8f$var$startsWithWindowsDriveLetter($b7cb89a1c4679e8f$var$join($2dd14968e62d6eb1$exports(codePoints, pointer), '')) && $b7cb89a1c4679e8f$var$isWindowsDriveLetter(base.path[0], true)) $b7cb89a1c4679e8f$var$push(url.path, base.path[0]);
                    }
                    state = $b7cb89a1c4679e8f$var$PATH;
                    continue;
                case $b7cb89a1c4679e8f$var$FILE_HOST:
                    if (chr === $b7cb89a1c4679e8f$var$EOF || chr === '/' || chr === '\\' || chr === '?' || chr === '#') {
                        if (!stateOverride && $b7cb89a1c4679e8f$var$isWindowsDriveLetter(buffer)) state = $b7cb89a1c4679e8f$var$PATH;
                        else if (buffer === '') {
                            url.host = '';
                            if (stateOverride) return;
                            state = $b7cb89a1c4679e8f$var$PATH_START;
                        } else {
                            failure = url.parseHost(buffer);
                            if (failure) return failure;
                            if (url.host === 'localhost') url.host = '';
                            if (stateOverride) return;
                            buffer = '';
                            state = $b7cb89a1c4679e8f$var$PATH_START;
                        }
                        continue;
                    } else buffer += chr;
                    break;
                case $b7cb89a1c4679e8f$var$PATH_START:
                    if (url.isSpecial()) {
                        state = $b7cb89a1c4679e8f$var$PATH;
                        if (chr !== '/' && chr !== '\\') continue;
                    } else if (!stateOverride && chr === '?') {
                        url.query = '';
                        state = $b7cb89a1c4679e8f$var$QUERY;
                    } else if (!stateOverride && chr === '#') {
                        url.fragment = '';
                        state = $b7cb89a1c4679e8f$var$FRAGMENT;
                    } else if (chr !== $b7cb89a1c4679e8f$var$EOF) {
                        state = $b7cb89a1c4679e8f$var$PATH;
                        if (chr !== '/') continue;
                    }
                    break;
                case $b7cb89a1c4679e8f$var$PATH:
                    if (chr === $b7cb89a1c4679e8f$var$EOF || chr === '/' || chr === '\\' && url.isSpecial() || !stateOverride && (chr === '?' || chr === '#')) {
                        if ($b7cb89a1c4679e8f$var$isDoubleDot(buffer)) {
                            url.shortenPath();
                            if (chr !== '/' && !(chr === '\\' && url.isSpecial())) $b7cb89a1c4679e8f$var$push(url.path, '');
                        } else if ($b7cb89a1c4679e8f$var$isSingleDot(buffer)) {
                            if (chr !== '/' && !(chr === '\\' && url.isSpecial())) $b7cb89a1c4679e8f$var$push(url.path, '');
                        } else {
                            if (url.scheme === 'file' && !url.path.length && $b7cb89a1c4679e8f$var$isWindowsDriveLetter(buffer)) {
                                if (url.host !== null && url.host !== '') url.host = '';
                                buffer = $b7cb89a1c4679e8f$var$charAt(buffer, 0) + ':'; // normalize windows drive letter
                            }
                            $b7cb89a1c4679e8f$var$push(url.path, buffer);
                        }
                        buffer = '';
                        if (url.scheme === 'file' && (chr === $b7cb89a1c4679e8f$var$EOF || chr === '?' || chr === '#')) while(url.path.length > 1 && url.path[0] === '')$b7cb89a1c4679e8f$var$shift(url.path);
                        if (chr === '?') {
                            url.query = '';
                            state = $b7cb89a1c4679e8f$var$QUERY;
                        } else if (chr === '#') {
                            url.fragment = '';
                            state = $b7cb89a1c4679e8f$var$FRAGMENT;
                        }
                    } else buffer += $b7cb89a1c4679e8f$var$percentEncode(chr, $b7cb89a1c4679e8f$var$pathPercentEncodeSet);
                    break;
                case $b7cb89a1c4679e8f$var$CANNOT_BE_A_BASE_URL_PATH:
                    if (chr === '?') {
                        url.query = '';
                        state = $b7cb89a1c4679e8f$var$QUERY;
                    } else if (chr === '#') {
                        url.fragment = '';
                        state = $b7cb89a1c4679e8f$var$FRAGMENT;
                    } else if (chr !== $b7cb89a1c4679e8f$var$EOF) url.path[0] += $b7cb89a1c4679e8f$var$percentEncode(chr, $b7cb89a1c4679e8f$var$C0ControlPercentEncodeSet);
                    break;
                case $b7cb89a1c4679e8f$var$QUERY:
                    if (!stateOverride && chr === '#') {
                        url.fragment = '';
                        state = $b7cb89a1c4679e8f$var$FRAGMENT;
                    } else if (chr !== $b7cb89a1c4679e8f$var$EOF) url.query += $b7cb89a1c4679e8f$var$percentEncode(chr, url.isSpecial() ? $b7cb89a1c4679e8f$var$specialQueryPercentEncodeSet : $b7cb89a1c4679e8f$var$queryPercentEncodeSet);
                    break;
                case $b7cb89a1c4679e8f$var$FRAGMENT:
                    if (chr !== $b7cb89a1c4679e8f$var$EOF) url.fragment += $b7cb89a1c4679e8f$var$percentEncode(chr, $b7cb89a1c4679e8f$var$fragmentPercentEncodeSet);
                    break;
            }
            pointer++;
        }
    },
    // https://url.spec.whatwg.org/#host-parsing
    parseHost: function parseHost(input) {
        var result, codePoints, index;
        if ($b7cb89a1c4679e8f$var$charAt(input, 0) === '[') {
            if ($b7cb89a1c4679e8f$var$charAt(input, input.length - 1) !== ']') return $b7cb89a1c4679e8f$var$INVALID_HOST;
            result = $b7cb89a1c4679e8f$var$parseIPv6($b7cb89a1c4679e8f$var$stringSlice(input, 1, -1));
            if (!result) return $b7cb89a1c4679e8f$var$INVALID_HOST;
            this.host = result;
        // opaque host
        } else if (!this.isSpecial()) {
            if ($b7cb89a1c4679e8f$var$exec($b7cb89a1c4679e8f$var$FORBIDDEN_HOST_CODE_POINT_EXCLUDING_PERCENT, input)) return $b7cb89a1c4679e8f$var$INVALID_HOST;
            result = '';
            codePoints = $9173555772c6cd7a$exports(input);
            for(index = 0; index < codePoints.length; index++)result += $b7cb89a1c4679e8f$var$percentEncode(codePoints[index], $b7cb89a1c4679e8f$var$C0ControlPercentEncodeSet);
            this.host = result;
        } else {
            input = $8b7ca93e668b00da$exports(input);
            if ($b7cb89a1c4679e8f$var$exec($b7cb89a1c4679e8f$var$FORBIDDEN_HOST_CODE_POINT, input)) return $b7cb89a1c4679e8f$var$INVALID_HOST;
            if ($b7cb89a1c4679e8f$var$endsInNumber(input)) {
                result = $b7cb89a1c4679e8f$var$parseIPv4(input);
                if (result === null) return $b7cb89a1c4679e8f$var$INVALID_HOST;
                this.host = result;
            } else this.host = input;
        }
    },
    // https://url.spec.whatwg.org/#cannot-have-a-username-password-port
    cannotHaveUsernamePasswordPort: function cannotHaveUsernamePasswordPort() {
        return this.host === null || this.host === '' || this.cannotBeABaseURL || this.scheme === 'file';
    },
    // https://url.spec.whatwg.org/#include-credentials
    includesCredentials: function includesCredentials() {
        return this.username !== '' || this.password !== '';
    },
    // https://url.spec.whatwg.org/#is-special
    isSpecial: function isSpecial() {
        return $8bbc2bccc0a29296$exports($b7cb89a1c4679e8f$var$specialSchemes, this.scheme);
    },
    // https://url.spec.whatwg.org/#shorten-a-urls-path
    shortenPath: function shortenPath() {
        var path = this.path;
        var pathSize = path.length;
        if (pathSize && (this.scheme !== 'file' || pathSize !== 1 || !$b7cb89a1c4679e8f$var$isWindowsDriveLetter(path[0], true))) path.length--;
    },
    // https://url.spec.whatwg.org/#concept-url-serializer
    serialize: function serialize() {
        var url = this;
        var scheme = url.scheme;
        var username = url.username;
        var password = url.password;
        var host = url.host;
        var port = url.port;
        var path = url.path;
        var query = url.query;
        var fragment = url.fragment;
        var output = scheme + ':';
        if (host !== null) {
            output += '//';
            if (url.includesCredentials()) output += username + (password ? ':' + password : '') + '@';
            output += $b7cb89a1c4679e8f$var$serializeHost(host);
            if (port !== null) output += ':' + port;
        } else if (scheme === 'file') output += '//';
        if (host === null && !url.cannotBeABaseURL && path.length > 1 && path[0] === '') output += '/.';
        output += url.cannotBeABaseURL ? path[0] : path.length ? '/' + $b7cb89a1c4679e8f$var$join(path, '/') : '';
        if (query !== null) output += '?' + query;
        if (fragment !== null) output += '#' + fragment;
        return output;
    },
    // https://url.spec.whatwg.org/#dom-url-href
    setHref: function setHref(href) {
        var failure = this.parse(href);
        if (failure) throw new $b7cb89a1c4679e8f$var$TypeError(failure);
        this.searchParams.update();
    },
    // https://url.spec.whatwg.org/#dom-url-origin
    getOrigin: function getOrigin() {
        var scheme = this.scheme;
        var port = this.port;
        if (scheme === 'blob') try {
            return new $b7cb89a1c4679e8f$var$URLConstructor(this.path[0]).origin;
        } catch (error) {
            return 'null';
        }
        if (scheme === 'file' || !this.isSpecial()) return 'null';
        return scheme + '://' + $b7cb89a1c4679e8f$var$serializeHost(this.host) + (port !== null ? ':' + port : '');
    },
    // https://url.spec.whatwg.org/#dom-url-protocol
    getProtocol: function getProtocol() {
        return this.scheme + ':';
    },
    setProtocol: function setProtocol(protocol) {
        this.parse($7c610b7ee22557b5$exports(protocol) + ':', $b7cb89a1c4679e8f$var$SCHEME_START);
    },
    // https://url.spec.whatwg.org/#dom-url-username
    getUsername: function getUsername() {
        return this.username;
    },
    setUsername: function setUsername(username) {
        var codePoints = $9173555772c6cd7a$exports($7c610b7ee22557b5$exports(username));
        if (this.cannotHaveUsernamePasswordPort()) return;
        this.username = '';
        for(var i = 0; i < codePoints.length; i++)this.username += $b7cb89a1c4679e8f$var$percentEncode(codePoints[i], $b7cb89a1c4679e8f$var$userinfoPercentEncodeSet);
    },
    // https://url.spec.whatwg.org/#dom-url-password
    getPassword: function getPassword() {
        return this.password;
    },
    setPassword: function setPassword(password) {
        var codePoints = $9173555772c6cd7a$exports($7c610b7ee22557b5$exports(password));
        if (this.cannotHaveUsernamePasswordPort()) return;
        this.password = '';
        for(var i = 0; i < codePoints.length; i++)this.password += $b7cb89a1c4679e8f$var$percentEncode(codePoints[i], $b7cb89a1c4679e8f$var$userinfoPercentEncodeSet);
    },
    // https://url.spec.whatwg.org/#dom-url-host
    getHost: function getHost() {
        var host = this.host;
        var port = this.port;
        return host === null ? '' : port === null ? $b7cb89a1c4679e8f$var$serializeHost(host) : $b7cb89a1c4679e8f$var$serializeHost(host) + ':' + port;
    },
    setHost: function setHost(host) {
        if (this.cannotBeABaseURL) return;
        this.parse(host, $b7cb89a1c4679e8f$var$HOST);
    },
    // https://url.spec.whatwg.org/#dom-url-hostname
    getHostname: function getHostname() {
        var host = this.host;
        return host === null ? '' : $b7cb89a1c4679e8f$var$serializeHost(host);
    },
    setHostname: function setHostname(hostname) {
        if (this.cannotBeABaseURL) return;
        this.parse(hostname, $b7cb89a1c4679e8f$var$HOSTNAME);
    },
    // https://url.spec.whatwg.org/#dom-url-port
    getPort: function getPort() {
        var port = this.port;
        return port === null ? '' : $7c610b7ee22557b5$exports(port);
    },
    setPort: function setPort(port) {
        if (this.cannotHaveUsernamePasswordPort()) return;
        port = $7c610b7ee22557b5$exports(port);
        if (port === '') this.port = null;
        else this.parse(port, $b7cb89a1c4679e8f$var$PORT);
    },
    // https://url.spec.whatwg.org/#dom-url-pathname
    getPathname: function getPathname() {
        var path = this.path;
        return this.cannotBeABaseURL ? path[0] : path.length ? '/' + $b7cb89a1c4679e8f$var$join(path, '/') : '';
    },
    setPathname: function setPathname(pathname) {
        if (this.cannotBeABaseURL) return;
        this.path = [];
        this.parse(pathname, $b7cb89a1c4679e8f$var$PATH_START);
    },
    // https://url.spec.whatwg.org/#dom-url-search
    getSearch: function getSearch() {
        var query = this.query;
        return query ? '?' + query : '';
    },
    setSearch: function setSearch(search) {
        search = $7c610b7ee22557b5$exports(search);
        if (search === '') this.query = null;
        else {
            if ($b7cb89a1c4679e8f$var$charAt(search, 0) === '?') search = $b7cb89a1c4679e8f$var$stringSlice(search, 1);
            this.query = '';
            this.parse(search, $b7cb89a1c4679e8f$var$QUERY);
        }
        this.searchParams.update();
    },
    // https://url.spec.whatwg.org/#dom-url-searchparams
    getSearchParams: function getSearchParams() {
        return this.searchParams.facade;
    },
    // https://url.spec.whatwg.org/#dom-url-hash
    getHash: function getHash() {
        var fragment = this.fragment;
        return fragment ? '#' + fragment : '';
    },
    setHash: function setHash(hash) {
        hash = $7c610b7ee22557b5$exports(hash);
        if (hash === '') {
            this.fragment = null;
            return;
        }
        if ($b7cb89a1c4679e8f$var$charAt(hash, 0) === '#') hash = $b7cb89a1c4679e8f$var$stringSlice(hash, 1);
        this.fragment = '';
        this.parse(hash, $b7cb89a1c4679e8f$var$FRAGMENT);
    },
    update: function update() {
        this.query = this.searchParams.serialize() || null;
    }
};
// `URL` constructor
// https://url.spec.whatwg.org/#url-class
var $b7cb89a1c4679e8f$var$URLConstructor = function URL(url /* , base */ ) {
    var that = $93a46accb3e7c173$exports(this, $b7cb89a1c4679e8f$var$URLPrototype);
    var base = $01603bd6f8ce1d57$exports(arguments.length, 1) > 1 ? arguments[1] : undefined;
    var state = $b7cb89a1c4679e8f$var$setInternalState(that, new $b7cb89a1c4679e8f$var$URLState(url, false, base));
    if (!$b9f536d3284d7921$exports) {
        that.href = state.serialize();
        that.origin = state.getOrigin();
        that.protocol = state.getProtocol();
        that.username = state.getUsername();
        that.password = state.getPassword();
        that.host = state.getHost();
        that.hostname = state.getHostname();
        that.port = state.getPort();
        that.pathname = state.getPathname();
        that.search = state.getSearch();
        that.searchParams = state.getSearchParams();
        that.hash = state.getHash();
    }
};
var $b7cb89a1c4679e8f$var$URLPrototype = $b7cb89a1c4679e8f$var$URLConstructor.prototype;
var $b7cb89a1c4679e8f$var$accessorDescriptor = function accessorDescriptor(getter, setter) {
    return {
        get: function get() {
            return $b7cb89a1c4679e8f$var$getInternalURLState(this)[getter]();
        },
        set: setter && function(value) {
            return $b7cb89a1c4679e8f$var$getInternalURLState(this)[setter](value);
        },
        configurable: true,
        enumerable: true
    };
};
if ($b9f536d3284d7921$exports) {
    // `URL.prototype.href` accessors pair
    // https://url.spec.whatwg.org/#dom-url-href
    $71a985fce44d8187$exports($b7cb89a1c4679e8f$var$URLPrototype, 'href', $b7cb89a1c4679e8f$var$accessorDescriptor('serialize', 'setHref'));
    // `URL.prototype.origin` getter
    // https://url.spec.whatwg.org/#dom-url-origin
    $71a985fce44d8187$exports($b7cb89a1c4679e8f$var$URLPrototype, 'origin', $b7cb89a1c4679e8f$var$accessorDescriptor('getOrigin'));
    // `URL.prototype.protocol` accessors pair
    // https://url.spec.whatwg.org/#dom-url-protocol
    $71a985fce44d8187$exports($b7cb89a1c4679e8f$var$URLPrototype, 'protocol', $b7cb89a1c4679e8f$var$accessorDescriptor('getProtocol', 'setProtocol'));
    // `URL.prototype.username` accessors pair
    // https://url.spec.whatwg.org/#dom-url-username
    $71a985fce44d8187$exports($b7cb89a1c4679e8f$var$URLPrototype, 'username', $b7cb89a1c4679e8f$var$accessorDescriptor('getUsername', 'setUsername'));
    // `URL.prototype.password` accessors pair
    // https://url.spec.whatwg.org/#dom-url-password
    $71a985fce44d8187$exports($b7cb89a1c4679e8f$var$URLPrototype, 'password', $b7cb89a1c4679e8f$var$accessorDescriptor('getPassword', 'setPassword'));
    // `URL.prototype.host` accessors pair
    // https://url.spec.whatwg.org/#dom-url-host
    $71a985fce44d8187$exports($b7cb89a1c4679e8f$var$URLPrototype, 'host', $b7cb89a1c4679e8f$var$accessorDescriptor('getHost', 'setHost'));
    // `URL.prototype.hostname` accessors pair
    // https://url.spec.whatwg.org/#dom-url-hostname
    $71a985fce44d8187$exports($b7cb89a1c4679e8f$var$URLPrototype, 'hostname', $b7cb89a1c4679e8f$var$accessorDescriptor('getHostname', 'setHostname'));
    // `URL.prototype.port` accessors pair
    // https://url.spec.whatwg.org/#dom-url-port
    $71a985fce44d8187$exports($b7cb89a1c4679e8f$var$URLPrototype, 'port', $b7cb89a1c4679e8f$var$accessorDescriptor('getPort', 'setPort'));
    // `URL.prototype.pathname` accessors pair
    // https://url.spec.whatwg.org/#dom-url-pathname
    $71a985fce44d8187$exports($b7cb89a1c4679e8f$var$URLPrototype, 'pathname', $b7cb89a1c4679e8f$var$accessorDescriptor('getPathname', 'setPathname'));
    // `URL.prototype.search` accessors pair
    // https://url.spec.whatwg.org/#dom-url-search
    $71a985fce44d8187$exports($b7cb89a1c4679e8f$var$URLPrototype, 'search', $b7cb89a1c4679e8f$var$accessorDescriptor('getSearch', 'setSearch'));
    // `URL.prototype.searchParams` getter
    // https://url.spec.whatwg.org/#dom-url-searchparams
    $71a985fce44d8187$exports($b7cb89a1c4679e8f$var$URLPrototype, 'searchParams', $b7cb89a1c4679e8f$var$accessorDescriptor('getSearchParams'));
    // `URL.prototype.hash` accessors pair
    // https://url.spec.whatwg.org/#dom-url-hash
    $71a985fce44d8187$exports($b7cb89a1c4679e8f$var$URLPrototype, 'hash', $b7cb89a1c4679e8f$var$accessorDescriptor('getHash', 'setHash'));
}
// `URL.prototype.toJSON` method
// https://url.spec.whatwg.org/#dom-url-tojson
$73c8864ae5df5c4d$exports($b7cb89a1c4679e8f$var$URLPrototype, 'toJSON', function toJSON() {
    return $b7cb89a1c4679e8f$var$getInternalURLState(this).serialize();
}, {
    enumerable: true
});
// `URL.prototype.toString` method
// https://url.spec.whatwg.org/#URL-stringification-behavior
$73c8864ae5df5c4d$exports($b7cb89a1c4679e8f$var$URLPrototype, 'toString', function toString() {
    return $b7cb89a1c4679e8f$var$getInternalURLState(this).serialize();
}, {
    enumerable: true
});
if ($b7cb89a1c4679e8f$var$NativeURL) {
    var $b7cb89a1c4679e8f$var$nativeCreateObjectURL = $b7cb89a1c4679e8f$var$NativeURL.createObjectURL;
    var $b7cb89a1c4679e8f$var$nativeRevokeObjectURL = $b7cb89a1c4679e8f$var$NativeURL.revokeObjectURL;
    // `URL.createObjectURL` method
    // https://developer.mozilla.org/en-US/docs/Web/API/URL/createObjectURL
    if ($b7cb89a1c4679e8f$var$nativeCreateObjectURL) $73c8864ae5df5c4d$exports($b7cb89a1c4679e8f$var$URLConstructor, 'createObjectURL', $8a0b7edcb386df4b$exports($b7cb89a1c4679e8f$var$nativeCreateObjectURL, $b7cb89a1c4679e8f$var$NativeURL));
    // `URL.revokeObjectURL` method
    // https://developer.mozilla.org/en-US/docs/Web/API/URL/revokeObjectURL
    if ($b7cb89a1c4679e8f$var$nativeRevokeObjectURL) $73c8864ae5df5c4d$exports($b7cb89a1c4679e8f$var$URLConstructor, 'revokeObjectURL', $8a0b7edcb386df4b$exports($b7cb89a1c4679e8f$var$nativeRevokeObjectURL, $b7cb89a1c4679e8f$var$NativeURL));
}
$54a3ba2fb7b04ac0$exports($b7cb89a1c4679e8f$var$URLConstructor, 'URL');
$244155c096ef4c14$exports({
    global: true,
    constructor: true,
    forced: !$2bd41c46b7be4aca$exports,
    sham: !$b9f536d3284d7921$exports
}, {
    URL: $b7cb89a1c4679e8f$var$URLConstructor
});




'use strict';


// `URL.prototype.toJSON` method
// https://url.spec.whatwg.org/#dom-url-tojson
$244155c096ef4c14$exports({
    target: 'URL',
    proto: true,
    enumerable: true
}, {
    toJSON: function toJSON() {
        return $59bf80837927ca02$exports(URL.prototype.toString, this);
    }
});


'use strict';



var $63a495bae404d720$exports = {};
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 
var $6tOPT = parcelRequire("6tOPT");
var $63a495bae404d720$var$runtime = function(exports) {
    "use strict";
    var Op = Object.prototype;
    var hasOwn = Op.hasOwnProperty;
    var defineProperty = Object.defineProperty || function(obj, key, desc) {
        obj[key] = desc.value;
    };
    var undefined; // More compressible than void 0.
    var $Symbol = typeof Symbol === "function" ? Symbol : {};
    var iteratorSymbol = $Symbol.iterator || "@@iterator";
    var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
    var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";
    function define(obj, key, value) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
        return obj[key];
    }
    try {
        // IE 8 has a broken Object.defineProperty that only works on DOM objects.
        define({}, "");
    } catch (err) {
        define = function define(obj, key, value) {
            return obj[key] = value;
        };
    }
    function wrap(innerFn, outerFn, self, tryLocsList) {
        // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
        var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
        var generator = Object.create(protoGenerator.prototype);
        var context = new Context(tryLocsList || []);
        // The ._invoke method unifies the implementations of the .next,
        // .throw, and .return methods.
        defineProperty(generator, "_invoke", {
            value: makeInvokeMethod(innerFn, self, context)
        });
        return generator;
    }
    exports.wrap = wrap;
    // Try/catch helper to minimize deoptimizations. Returns a completion
    // record like context.tryEntries[i].completion. This interface could
    // have been (and was previously) designed to take a closure to be
    // invoked without arguments, but in all the cases we care about we
    // already have an existing method we want to call, so there's no need
    // to create a new function object. We can even get away with assuming
    // the method takes exactly one argument, since that happens to be true
    // in every case, so we don't have to touch the arguments object. The
    // only additional allocation required is the completion record, which
    // has a stable shape and so hopefully should be cheap to allocate.
    function tryCatch(fn, obj, arg) {
        try {
            return {
                type: "normal",
                arg: fn.call(obj, arg)
            };
        } catch (err) {
            return {
                type: "throw",
                arg: err
            };
        }
    }
    var GenStateSuspendedStart = "suspendedStart";
    var GenStateSuspendedYield = "suspendedYield";
    var GenStateExecuting = "executing";
    var GenStateCompleted = "completed";
    // Returning this object from the innerFn has the same effect as
    // breaking out of the dispatch switch statement.
    var ContinueSentinel = {};
    // Dummy constructor functions that we use as the .constructor and
    // .constructor.prototype properties for functions that return Generator
    // objects. For full spec compliance, you may wish to configure your
    // minifier not to mangle the names of these two functions.
    function Generator() {}
    function GeneratorFunction() {}
    function GeneratorFunctionPrototype() {}
    // This is a polyfill for %IteratorPrototype% for environments that
    // don't natively support it.
    var IteratorPrototype = {};
    define(IteratorPrototype, iteratorSymbol, function() {
        return this;
    });
    var getProto = Object.getPrototypeOf;
    var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
    if (NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) // This environment has a native %IteratorPrototype%; use it instead
    // of the polyfill.
    IteratorPrototype = NativeIteratorPrototype;
    var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype);
    GeneratorFunction.prototype = GeneratorFunctionPrototype;
    defineProperty(Gp, "constructor", {
        value: GeneratorFunctionPrototype,
        configurable: true
    });
    defineProperty(GeneratorFunctionPrototype, "constructor", {
        value: GeneratorFunction,
        configurable: true
    });
    GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction");
    // Helper for defining the .next, .throw, and .return methods of the
    // Iterator interface in terms of a single ._invoke method.
    function defineIteratorMethods(prototype) {
        [
            "next",
            "throw",
            "return"
        ].forEach(function(method) {
            define(prototype, method, function(arg) {
                return this._invoke(method, arg);
            });
        });
    }
    exports.isGeneratorFunction = function(genFun) {
        var ctor = typeof genFun === "function" && genFun.constructor;
        return ctor ? ctor === GeneratorFunction || // For the native GeneratorFunction constructor, the best we can
        // do is to check its .name property.
        (ctor.displayName || ctor.name) === "GeneratorFunction" : false;
    };
    exports.mark = function(genFun) {
        if (Object.setPrototypeOf) Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
        else {
            genFun.__proto__ = GeneratorFunctionPrototype;
            define(genFun, toStringTagSymbol, "GeneratorFunction");
        }
        genFun.prototype = Object.create(Gp);
        return genFun;
    };
    // Within the body of any async function, `await x` is transformed to
    // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
    // `hasOwn.call(value, "__await")` to determine if the yielded value is
    // meant to be awaited.
    exports.awrap = function(arg) {
        return {
            __await: arg
        };
    };
    function AsyncIterator(generator, PromiseImpl) {
        function invoke(method, arg, resolve, reject) {
            var record = tryCatch(generator[method], generator, arg);
            if (record.type === "throw") reject(record.arg);
            else {
                var result = record.arg;
                var value = result.value;
                if (value && (typeof value === "undefined" ? "undefined" : (0, $6tOPT._)(value)) === "object" && hasOwn.call(value, "__await")) return PromiseImpl.resolve(value.__await).then(function(value) {
                    invoke("next", value, resolve, reject);
                }, function(err) {
                    invoke("throw", err, resolve, reject);
                });
                return PromiseImpl.resolve(value).then(function(unwrapped) {
                    // When a yielded Promise is resolved, its final value becomes
                    // the .value of the Promise<{value,done}> result for the
                    // current iteration.
                    result.value = unwrapped;
                    resolve(result);
                }, function(error) {
                    // If a rejected Promise was yielded, throw the rejection back
                    // into the async generator function so it can be handled there.
                    return invoke("throw", error, resolve, reject);
                });
            }
        }
        var previousPromise;
        function enqueue(method, arg) {
            function callInvokeWithMethodAndArg() {
                return new PromiseImpl(function(resolve, reject) {
                    invoke(method, arg, resolve, reject);
                });
            }
            return previousPromise = // If enqueue has been called before, then we want to wait until
            // all previous Promises have been resolved before calling invoke,
            // so that results are always delivered in the correct order. If
            // enqueue has not been called before, then it is important to
            // call invoke immediately, without waiting on a callback to fire,
            // so that the async generator function has the opportunity to do
            // any necessary setup in a predictable way. This predictability
            // is why the Promise constructor synchronously invokes its
            // executor callback, and why async functions synchronously
            // execute code before the first await. Since we implement simple
            // async functions in terms of async generators, it is especially
            // important to get this right, even though it requires care.
            previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, // Avoid propagating failures to Promises returned by later
            // invocations of the iterator.
            callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
        }
        // Define the unified helper method that is used to implement .next,
        // .throw, and .return (see defineIteratorMethods).
        defineProperty(this, "_invoke", {
            value: enqueue
        });
    }
    defineIteratorMethods(AsyncIterator.prototype);
    define(AsyncIterator.prototype, asyncIteratorSymbol, function() {
        return this;
    });
    exports.AsyncIterator = AsyncIterator;
    // Note that simple async functions are implemented on top of
    // AsyncIterator objects; they just return a Promise for the value of
    // the final result produced by the iterator.
    exports.async = function(innerFn, outerFn, self, tryLocsList, PromiseImpl) {
        if (PromiseImpl === void 0) PromiseImpl = Promise;
        var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl);
        return exports.isGeneratorFunction(outerFn) ? iter // If outerFn is a generator, return the full iterator.
         : iter.next().then(function(result) {
            return result.done ? result.value : iter.next();
        });
    };
    function makeInvokeMethod(innerFn, self, context) {
        var state = GenStateSuspendedStart;
        return function invoke(method, arg) {
            if (state === GenStateExecuting) throw new Error("Generator is already running");
            if (state === GenStateCompleted) {
                if (method === "throw") throw arg;
                // Be forgiving, per GeneratorResume behavior specified since ES2015:
                // ES2015 spec, step 3: https://262.ecma-international.org/6.0/#sec-generatorresume
                // Latest spec, step 2: https://tc39.es/ecma262/#sec-generatorresume
                return doneResult();
            }
            context.method = method;
            context.arg = arg;
            while(true){
                var delegate = context.delegate;
                if (delegate) {
                    var delegateResult = maybeInvokeDelegate(delegate, context);
                    if (delegateResult) {
                        if (delegateResult === ContinueSentinel) continue;
                        return delegateResult;
                    }
                }
                if (context.method === "next") // Setting context._sent for legacy support of Babel's
                // function.sent implementation.
                context.sent = context._sent = context.arg;
                else if (context.method === "throw") {
                    if (state === GenStateSuspendedStart) {
                        state = GenStateCompleted;
                        throw context.arg;
                    }
                    context.dispatchException(context.arg);
                } else if (context.method === "return") context.abrupt("return", context.arg);
                state = GenStateExecuting;
                var record = tryCatch(innerFn, self, context);
                if (record.type === "normal") {
                    // If an exception is thrown from innerFn, we leave state ===
                    // GenStateExecuting and loop back for another invocation.
                    state = context.done ? GenStateCompleted : GenStateSuspendedYield;
                    if (record.arg === ContinueSentinel) continue;
                    return {
                        value: record.arg,
                        done: context.done
                    };
                } else if (record.type === "throw") {
                    state = GenStateCompleted;
                    // Dispatch the exception by looping back around to the
                    // context.dispatchException(context.arg) call above.
                    context.method = "throw";
                    context.arg = record.arg;
                }
            }
        };
    }
    // Call delegate.iterator[context.method](context.arg) and handle the
    // result, either by returning a { value, done } result from the
    // delegate iterator, or by modifying context.method and context.arg,
    // setting context.delegate to null, and returning the ContinueSentinel.
    function maybeInvokeDelegate(delegate, context) {
        var methodName = context.method;
        var method = delegate.iterator[methodName];
        if (method === undefined) {
            // A .throw or .return when the delegate iterator has no .throw
            // method, or a missing .next method, always terminate the
            // yield* loop.
            context.delegate = null;
            // Note: ["return"] must be used for ES3 parsing compatibility.
            if (methodName === "throw" && delegate.iterator["return"]) {
                // If the delegate iterator has a return method, give it a
                // chance to clean up.
                context.method = "return";
                context.arg = undefined;
                maybeInvokeDelegate(delegate, context);
                if (context.method === "throw") // If maybeInvokeDelegate(context) changed context.method from
                // "return" to "throw", let that override the TypeError below.
                return ContinueSentinel;
            }
            if (methodName !== "return") {
                context.method = "throw";
                context.arg = new TypeError("The iterator does not provide a '" + methodName + "' method");
            }
            return ContinueSentinel;
        }
        var record = tryCatch(method, delegate.iterator, context.arg);
        if (record.type === "throw") {
            context.method = "throw";
            context.arg = record.arg;
            context.delegate = null;
            return ContinueSentinel;
        }
        var info = record.arg;
        if (!info) {
            context.method = "throw";
            context.arg = new TypeError("iterator result is not an object");
            context.delegate = null;
            return ContinueSentinel;
        }
        if (info.done) {
            // Assign the result of the finished delegate to the temporary
            // variable specified by delegate.resultName (see delegateYield).
            context[delegate.resultName] = info.value;
            // Resume execution at the desired location (see delegateYield).
            context.next = delegate.nextLoc;
            // If context.method was "throw" but the delegate handled the
            // exception, let the outer generator proceed normally. If
            // context.method was "next", forget context.arg since it has been
            // "consumed" by the delegate iterator. If context.method was
            // "return", allow the original .return call to continue in the
            // outer generator.
            if (context.method !== "return") {
                context.method = "next";
                context.arg = undefined;
            }
        } else // Re-yield the result returned by the delegate method.
        return info;
        // The delegate iterator is finished, so forget it and continue with
        // the outer generator.
        context.delegate = null;
        return ContinueSentinel;
    }
    // Define Generator.prototype.{next,throw,return} in terms of the
    // unified ._invoke helper method.
    defineIteratorMethods(Gp);
    define(Gp, toStringTagSymbol, "Generator");
    // A Generator should always return itself as the iterator object when the
    // @@iterator function is called on it. Some browsers' implementations of the
    // iterator prototype chain incorrectly implement this, causing the Generator
    // object to not be returned from this call. This ensures that doesn't happen.
    // See https://github.com/facebook/regenerator/issues/274 for more details.
    define(Gp, iteratorSymbol, function() {
        return this;
    });
    define(Gp, "toString", function() {
        return "[object Generator]";
    });
    function pushTryEntry(locs) {
        var entry = {
            tryLoc: locs[0]
        };
        if (1 in locs) entry.catchLoc = locs[1];
        if (2 in locs) {
            entry.finallyLoc = locs[2];
            entry.afterLoc = locs[3];
        }
        this.tryEntries.push(entry);
    }
    function resetTryEntry(entry) {
        var record = entry.completion || {};
        record.type = "normal";
        delete record.arg;
        entry.completion = record;
    }
    function Context(tryLocsList) {
        // The root entry object (effectively a try statement without a catch
        // or a finally block) gives us a place to store values thrown from
        // locations where there is no enclosing try statement.
        this.tryEntries = [
            {
                tryLoc: "root"
            }
        ];
        tryLocsList.forEach(pushTryEntry, this);
        this.reset(true);
    }
    exports.keys = function(val) {
        var object = Object(val);
        var keys = [];
        for(var key in object)keys.push(key);
        keys.reverse();
        // Rather than returning an object with a next method, we keep
        // things simple and return the next function itself.
        return function next() {
            while(keys.length){
                var key = keys.pop();
                if (key in object) {
                    next.value = key;
                    next.done = false;
                    return next;
                }
            }
            // To avoid creating an additional object, we just hang the .value
            // and .done properties off the next function object itself. This
            // also ensures that the minifier will not anonymize the function.
            next.done = true;
            return next;
        };
    };
    function values(iterable) {
        if (iterable != null) {
            var iteratorMethod = iterable[iteratorSymbol];
            if (iteratorMethod) return iteratorMethod.call(iterable);
            if (typeof iterable.next === "function") return iterable;
            if (!isNaN(iterable.length)) {
                var i = -1, next = function next() {
                    while(++i < iterable.length)if (hasOwn.call(iterable, i)) {
                        next.value = iterable[i];
                        next.done = false;
                        return next;
                    }
                    next.value = undefined;
                    next.done = true;
                    return next;
                };
                return next.next = next;
            }
        }
        throw new TypeError((typeof iterable === "undefined" ? "undefined" : (0, $6tOPT._)(iterable)) + " is not iterable");
    }
    exports.values = values;
    function doneResult() {
        return {
            value: undefined,
            done: true
        };
    }
    Context.prototype = {
        constructor: Context,
        reset: function reset(skipTempReset) {
            this.prev = 0;
            this.next = 0;
            // Resetting context._sent for legacy support of Babel's
            // function.sent implementation.
            this.sent = this._sent = undefined;
            this.done = false;
            this.delegate = null;
            this.method = "next";
            this.arg = undefined;
            this.tryEntries.forEach(resetTryEntry);
            if (!skipTempReset) {
                for(var name in this)// Not sure about the optimal order of these conditions:
                if (name.charAt(0) === "t" && hasOwn.call(this, name) && !isNaN(+name.slice(1))) this[name] = undefined;
            }
        },
        stop: function stop() {
            this.done = true;
            var rootEntry = this.tryEntries[0];
            var rootRecord = rootEntry.completion;
            if (rootRecord.type === "throw") throw rootRecord.arg;
            return this.rval;
        },
        dispatchException: function dispatchException(exception) {
            if (this.done) throw exception;
            var context = this;
            function handle(loc, caught) {
                record.type = "throw";
                record.arg = exception;
                context.next = loc;
                if (caught) {
                    // If the dispatched exception was caught by a catch block,
                    // then let that catch block handle the exception normally.
                    context.method = "next";
                    context.arg = undefined;
                }
                return !!caught;
            }
            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                var entry = this.tryEntries[i];
                var record = entry.completion;
                if (entry.tryLoc === "root") // Exception thrown outside of any try block that could handle
                // it, so set the completion value of the entire function to
                // throw the exception.
                return handle("end");
                if (entry.tryLoc <= this.prev) {
                    var hasCatch = hasOwn.call(entry, "catchLoc");
                    var hasFinally = hasOwn.call(entry, "finallyLoc");
                    if (hasCatch && hasFinally) {
                        if (this.prev < entry.catchLoc) return handle(entry.catchLoc, true);
                        else if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
                    } else if (hasCatch) {
                        if (this.prev < entry.catchLoc) return handle(entry.catchLoc, true);
                    } else if (hasFinally) {
                        if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
                    } else throw new Error("try statement without catch or finally");
                }
            }
        },
        abrupt: function abrupt(type, arg) {
            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                var entry = this.tryEntries[i];
                if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) {
                    var finallyEntry = entry;
                    break;
                }
            }
            if (finallyEntry && (type === "break" || type === "continue") && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc) // Ignore the finally entry if control is not jumping to a
            // location outside the try/catch block.
            finallyEntry = null;
            var record = finallyEntry ? finallyEntry.completion : {};
            record.type = type;
            record.arg = arg;
            if (finallyEntry) {
                this.method = "next";
                this.next = finallyEntry.finallyLoc;
                return ContinueSentinel;
            }
            return this.complete(record);
        },
        complete: function complete(record, afterLoc) {
            if (record.type === "throw") throw record.arg;
            if (record.type === "break" || record.type === "continue") this.next = record.arg;
            else if (record.type === "return") {
                this.rval = this.arg = record.arg;
                this.method = "return";
                this.next = "end";
            } else if (record.type === "normal" && afterLoc) this.next = afterLoc;
            return ContinueSentinel;
        },
        finish: function finish(finallyLoc) {
            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                var entry = this.tryEntries[i];
                if (entry.finallyLoc === finallyLoc) {
                    this.complete(entry.completion, entry.afterLoc);
                    resetTryEntry(entry);
                    return ContinueSentinel;
                }
            }
        },
        "catch": function(tryLoc) {
            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                var entry = this.tryEntries[i];
                if (entry.tryLoc === tryLoc) {
                    var record = entry.completion;
                    if (record.type === "throw") {
                        var thrown = record.arg;
                        resetTryEntry(entry);
                    }
                    return thrown;
                }
            }
            // The context.catch method must only be called with a location
            // argument that corresponds to a known catch block.
            throw new Error("illegal catch attempt");
        },
        delegateYield: function delegateYield(iterable, resultName, nextLoc) {
            this.delegate = {
                iterator: values(iterable),
                resultName: resultName,
                nextLoc: nextLoc
            };
            if (this.method === "next") // Deliberately forget the last sent value so that we don't
            // accidentally pass it on to the delegate.
            this.arg = undefined;
            return ContinueSentinel;
        }
    };
    // Regardless of whether this script is executing as a CommonJS module
    // or not, return the runtime object so that we can declare the variable
    // regeneratorRuntime in the outer scope, which allows this module to be
    // injected easily by `bin/regenerator --include-runtime script.js`.
    return exports;
}(// If this script is executing as a CommonJS module, use module.exports
// as the regeneratorRuntime namespace. Otherwise create a new empty
// object. Either way, the resulting object will be used to initialize
// the regeneratorRuntime variable at the top of this file.
(0, $63a495bae404d720$exports));
try {
    regeneratorRuntime = $63a495bae404d720$var$runtime;
} catch (accidentalStrictMode) {
    // This module should not be running in strict mode, so the above
    // assignment should always work unless something is misconfigured. Just
    // in case runtime.js accidentally runs in strict mode, in modern engines
    // we can explicitly access globalThis. In older engines we can escape
    // strict mode using a global Function call. This could conceivably fail
    // if a Content Security Policy forbids using Function, but in that case
    // the proper solution is to fix the accidental strict mode problem. If
    // you've misconfigured your bundler to force strict mode and applied a
    // CSP to forbid Function, and you're not willing to fix either of those
    // problems, please detail your unique predicament in a GitHub issue.
    if ((typeof globalThis === "undefined" ? "undefined" : (0, $6tOPT._)(globalThis)) === "object") globalThis.regeneratorRuntime = $63a495bae404d720$var$runtime;
    else Function("r", "regeneratorRuntime = r")($63a495bae404d720$var$runtime);
}



function $c9996135bbccb03d$export$71511d61b312f219(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}


function $1d5a8ca6a8456cf0$export$71511d61b312f219(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
            return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
        ownKeys.forEach(function(key) {
            (0, $c9996135bbccb03d$export$71511d61b312f219)(target, key, source[key]);
        });
    }
    return target;
}


function $15eaa7ce1be6bade$export$71511d61b312f219(arr) {
    if (Array.isArray(arr)) return arr;
}


function $07fcd79808091a28$export$71511d61b312f219(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}


function $6ef89a5461a96200$export$71511d61b312f219() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}


function $f808f7f48970a742$export$71511d61b312f219(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}


function $9012c66a03f3d991$export$71511d61b312f219(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return (0, $f808f7f48970a742$export$71511d61b312f219)(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return (0, $f808f7f48970a742$export$71511d61b312f219)(o, minLen);
}


function $f9342d8e326b10da$export$71511d61b312f219(arr, i) {
    return (0, $15eaa7ce1be6bade$export$71511d61b312f219)(arr) || (0, $07fcd79808091a28$export$71511d61b312f219)(arr, i) || (0, $9012c66a03f3d991$export$71511d61b312f219)(arr, i) || (0, $6ef89a5461a96200$export$71511d61b312f219)();
}



var $53nS0 = parcelRequire("53nS0");

var $d5aa1367302a9087$export$923ea8233b386e99 = 'https://forkify-api.jonas.io/api/v2/recipes/';
var $d5aa1367302a9087$export$196440f71ed9f601 = 10;
var $d5aa1367302a9087$export$5feaddb1377b7f5e = 10;
var $d5aa1367302a9087$export$7167c830cefcb6b5 = 'bb277c7f-7236-42a8-8ce9-3a7d4a52373a';
var $d5aa1367302a9087$export$3ce8858248d89a69 = 2.5;




var $53nS0 = parcelRequire("53nS0");


var $8a80cc190987196a$var$timeout = function timeout(s) {
    return new Promise(function(_, reject) {
        setTimeout(function() {
            reject(new Error("Request took too long! Timeout after ".concat(s, " seconds")));
        }, s * 1000);
    });
};
var $8a80cc190987196a$export$2b3ff41fecbef7c8 = function AJAX(url, uploadData) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $cd69311d8f42aefb$export$71511d61b312f219)(function() {
        var fetchPro, res, data, err;
        return (0, $53nS0._)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        3,
                        ,
                        4
                    ]);
                    fetchPro = uploadData ? fetch(url, {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json'
                        },
                        body: JSON.stringify(uploadData)
                    }) : fetch(url);
                    return [
                        4,
                        Promise.race([
                            fetchPro,
                            $8a80cc190987196a$var$timeout((0, $d5aa1367302a9087$export$196440f71ed9f601))
                        ])
                    ];
                case 1:
                    res = _state.sent();
                    return [
                        4,
                        res.json()
                    ];
                case 2:
                    data = _state.sent();
                    if (!res.ok) throw new Error("".concat(data.message, " (").concat(res.status, ")"));
                    return [
                        2,
                        data
                    ];
                case 3:
                    err = _state.sent();
                    throw err;
                case 4:
                    return [
                        2
                    ];
            }
        });
    })();
}; /*
export const getJSON = async function (url) {
  try {
    const fetchPro = fetch(url);
    const res = await Promise.race([fetchPro, timeout(TIMEOUT_SEC)]);
    const data = await res.json();

    if (!res.ok) throw new Error(`${data.message} (${res.status})`);
    return data;
  } catch (err) {
    throw err;
  }
};

export const sendJSON = async function (url, uploadData) {
  try {
    const fetchPro = fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(uploadData),
    });
    const res = await Promise.race([fetchPro, timeout(TIMEOUT_SEC)]);
    const data = await res.json();

    if (!res.ok) throw new Error(`${data.message} (${res.status})`);
    return data;
  } catch (err) {
    throw err;
  }
};
*/ 



var $fxAKY = parcelRequire("fxAKY");

var $7eXQk = parcelRequire("7eXQk");

var $gApSC = parcelRequire("gApSC");


var $gNq0T = parcelRequire("gNq0T");
var $66dabfc31483eda1$exports = {};
$66dabfc31483eda1$exports = $parcel$resolve("fLnzD");


/*
fraction.js
A Javascript fraction library.

Copyright (c) 2009  Erik Garrison <erik@hypervolu.me>

Permission is hereby granted, free of charge, to any person obtaining a copy
of this software and associated documentation files (the "Software"), to deal
in the Software without restriction, including without limitation the rights
to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
copies of the Software, and to permit persons to whom the Software is
furnished to do so, subject to the following conditions:

The above copyright notice and this permission notice shall be included in
all copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
THE SOFTWARE.

*/ /* Fractions */ /* 
 *
 * Fraction objects are comprised of a numerator and a denomenator.  These
 * values can be accessed at fraction.numerator and fraction.denomenator.
 *
 * Fractions are always returned and stored in lowest-form normalized format.
 * This is accomplished via Fraction.normalize.
 *
 * The following mathematical operations on fractions are supported:
 *
 * Fraction.equals
 * Fraction.add
 * Fraction.subtract
 * Fraction.multiply
 * Fraction.divide
 *
 * These operations accept both numbers and fraction objects.  (Best results
 * are guaranteed when the input is a fraction object.)  They all return a new
 * Fraction object.
 *
 * Usage:
 *
 * TODO
 *
 */ /*
 * The Fraction constructor takes one of:
 *   an explicit numerator (integer) and denominator (integer),
 *   a string representation of the fraction (string),
 *   or a floating-point number (float)
 *
 * These initialization methods are provided for convenience.  Because of
 * rounding issues the best results will be given when the fraction is
 * constructed from an explicit integer numerator and denomenator, and not a
 * decimal number.
 *
 *
 * e.g. new Fraction(1, 2) --> 1/2
 *      new Fraction('1/2') --> 1/2
 *      new Fraction('2 3/4') --> 11/4  (prints as 2 3/4)
 *
 */ var $cfa244152796a46f$export$b336c2702c498be5;
var $cfa244152796a46f$var$Fraction = function Fraction1(numerator, denominator) {
    /* double argument invocation */ if (typeof numerator !== 'undefined' && denominator) {
        if (typeof numerator === 'number' && typeof denominator === 'number') {
            this.numerator = numerator;
            this.denominator = denominator;
        } else if (typeof numerator === 'string' && typeof denominator === 'string') {
            // what are they?
            // hmm....
            // assume they are ints?
            this.numerator = parseInt(numerator);
            this.denominator = parseInt(denominator);
        }
    /* single-argument invocation */ } else if (typeof denominator === 'undefined') {
        var num = numerator; // swap variable names for legibility
        if (typeof num === 'number') {
            this.numerator = num;
            this.denominator = 1;
        } else if (typeof num === 'string') {
            var a, b; // hold the first and second part of the fraction, e.g. a = '1' and b = '2/3' in 1 2/3
            // or a = '2/3' and b = undefined if we are just passed a single-part number
            var arr = num.split(' ');
            if (arr[0]) a = arr[0];
            if (arr[1]) b = arr[1];
            /* compound fraction e.g. 'A B/C' */ //  if a is an integer ...
            if (a % 1 === 0 && b && b.match('/')) return new $cfa244152796a46f$var$Fraction(a).add(new $cfa244152796a46f$var$Fraction(b));
            else if (a && !b) {
                /* simple fraction e.g. 'A/B' */ if (typeof a === 'string' && a.match('/')) {
                    // it's not a whole number... it's actually a fraction without a whole part written
                    var f = a.split('/');
                    this.numerator = f[0];
                    this.denominator = f[1];
                /* string floating point */ } else if (typeof a === 'string' && a.match('\.')) return new $cfa244152796a46f$var$Fraction(parseFloat(a));
                else {
                    this.numerator = parseInt(a);
                    this.denominator = 1;
                }
            } else return undefined; // could not parse
        }
    }
    this.normalize();
};
$cfa244152796a46f$var$Fraction.prototype.clone = function() {
    return new $cfa244152796a46f$var$Fraction(this.numerator, this.denominator);
};
/* pretty-printer, converts fractions into whole numbers and fractions */ $cfa244152796a46f$var$Fraction.prototype.toString = function() {
    if (this.denominator === 'NaN') return 'NaN';
    var wholepart = this.numerator / this.denominator > 0 ? Math.floor(this.numerator / this.denominator) : Math.ceil(this.numerator / this.denominator);
    var numerator = this.numerator % this.denominator;
    var denominator = this.denominator;
    var result = [];
    if (wholepart != 0) result.push(wholepart);
    if (numerator != 0) result.push((wholepart === 0 ? numerator : Math.abs(numerator)) + '/' + denominator);
    return result.length > 0 ? result.join(' ') : 0;
};
/* destructively rescale the fraction by some integral factor */ $cfa244152796a46f$var$Fraction.prototype.rescale = function(factor) {
    this.numerator *= factor;
    this.denominator *= factor;
    return this;
};
$cfa244152796a46f$var$Fraction.prototype.add = function(b) {
    var a = this.clone();
    if (b instanceof $cfa244152796a46f$var$Fraction) b = b.clone();
    else b = new $cfa244152796a46f$var$Fraction(b);
    td = a.denominator;
    a.rescale(b.denominator);
    b.rescale(td);
    a.numerator += b.numerator;
    return a.normalize();
};
$cfa244152796a46f$var$Fraction.prototype.subtract = function(b) {
    var a = this.clone();
    if (b instanceof $cfa244152796a46f$var$Fraction) b = b.clone(); // we scale our argument destructively, so clone
    else b = new $cfa244152796a46f$var$Fraction(b);
    td = a.denominator;
    a.rescale(b.denominator);
    b.rescale(td);
    a.numerator -= b.numerator;
    return a.normalize();
};
$cfa244152796a46f$var$Fraction.prototype.multiply = function(b) {
    var a = this.clone();
    if (b instanceof $cfa244152796a46f$var$Fraction) {
        a.numerator *= b.numerator;
        a.denominator *= b.denominator;
    } else if (typeof b === 'number') a.numerator *= b;
    else return a.multiply(new $cfa244152796a46f$var$Fraction(b));
    return a.normalize();
};
$cfa244152796a46f$var$Fraction.prototype.divide = function(b) {
    var a = this.clone();
    if (b instanceof $cfa244152796a46f$var$Fraction) {
        a.numerator *= b.denominator;
        a.denominator *= b.numerator;
    } else if (typeof b === 'number') a.denominator *= b;
    else return a.divide(new $cfa244152796a46f$var$Fraction(b));
    return a.normalize();
};
$cfa244152796a46f$var$Fraction.prototype.equals = function(b) {
    if (!(b instanceof $cfa244152796a46f$var$Fraction)) b = new $cfa244152796a46f$var$Fraction(b);
    // fractions that are equal should have equal normalized forms
    var a = this.clone().normalize();
    var b = b.clone().normalize();
    return a.numerator === b.numerator && a.denominator === b.denominator;
};
/* Utility functions */ /* Destructively normalize the fraction to its smallest representation. 
 * e.g. 4/16 -> 1/4, 14/28 -> 1/2, etc.
 * This is called after all math ops.
 */ $cfa244152796a46f$var$Fraction.prototype.normalize = function() {
    var isFloat = function isFloat(n) {
        return typeof n === 'number' && (n > 0 && n % 1 > 0 && n % 1 < 1 || n < 0 && n % -1 < 0 && n % -1 > -1);
    };
    var roundToPlaces = function roundToPlaces(n, places) {
        if (!places) return Math.round(n);
        else {
            var scalar = Math.pow(10, places);
            return Math.round(n * scalar) / scalar;
        }
    };
    return function() {
        // XXX hackish.  Is there a better way to address this issue?
        //
        /* first check if we have decimals, and if we do eliminate them
         * multiply by the 10 ^ number of decimal places in the number
         * round the number to nine decimal places
         * to avoid js floating point funnies
         */ if (isFloat(this.denominator)) {
            var rounded = roundToPlaces(this.denominator, 9);
            var scaleup = Math.pow(10, rounded.toString().split('.')[1].length);
            this.denominator = Math.round(this.denominator * scaleup); // this !!! should be a whole number
            //this.numerator *= scaleup;
            this.numerator *= scaleup;
        }
        if (isFloat(this.numerator)) {
            var rounded = roundToPlaces(this.numerator, 9);
            var scaleup = Math.pow(10, rounded.toString().split('.')[1].length);
            this.numerator = Math.round(this.numerator * scaleup); // this !!! should be a whole number
            //this.numerator *= scaleup;
            this.denominator *= scaleup;
        }
        var gcf = $cfa244152796a46f$var$Fraction.gcf(this.numerator, this.denominator);
        this.numerator /= gcf;
        this.denominator /= gcf;
        if (this.numerator < 0 && this.denominator < 0 || this.numerator > 0 && this.denominator < 0) {
            this.numerator *= -1;
            this.denominator *= -1;
        }
        return this;
    };
}();
/* Takes two numbers and returns their greatest common factor.
 */ $cfa244152796a46f$var$Fraction.gcf = function(a, b) {
    var common_factors = [];
    var fa = $cfa244152796a46f$var$Fraction.primeFactors(a);
    var fb = $cfa244152796a46f$var$Fraction.primeFactors(b);
    // for each factor in fa
    // if it's also in fb
    // put it into the common factors
    fa.forEach(function(factor) {
        var i = fb.indexOf(factor);
        if (i >= 0) {
            common_factors.push(factor);
            fb.splice(i, 1); // remove from fb
        }
    });
    if (common_factors.length === 0) return 1;
    var gcf = function() {
        var r = common_factors[0];
        var i;
        for(i = 1; i < common_factors.length; i++)r = r * common_factors[i];
        return r;
    }();
    return gcf;
};
// Adapted from: 
// http://www.btinternet.com/~se16/js/factor.htm
$cfa244152796a46f$var$Fraction.primeFactors = function(n) {
    var num = Math.abs(n);
    var factors = [];
    var _factor = 2; // first potential prime factor
    while(_factor * _factor <= num)if (num % _factor === 0) {
        factors.push(_factor); // so keep it
        num = num / _factor; // and divide our search point by it
    } else _factor++; // and increment
    if (num != 1) factors.push(num); //    so it too should be recorded
    return factors; // Return the prime factors
};
$cfa244152796a46f$export$b336c2702c498be5 = $cfa244152796a46f$var$Fraction;



var $7eXQk = parcelRequire("7eXQk");

var $gApSC = parcelRequire("gApSC");


var $f88bdd13c53e4d92$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    "use strict";
    function View() {
        (0, $7eXQk._)(this, View);
        (0, $c9996135bbccb03d$export$71511d61b312f219)(this, "_data", void 0);
    }
    (0, $gApSC._)(View, [
        {
            key: "render",
            value: function render(data) {
                var render = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true;
                if (!data || Array.isArray(data) && data.length === 0) return this.renderError();
                this._data = data;
                var markup = this._generateMarkup();
                if (!render) return markup;
                this._clear();
                this._parentElement.insertAdjacentHTML('afterbegin', markup);
            }
        },
        {
            key: "update",
            value: function update(data) {
                this._data = data;
                var newMarkup = this._generateMarkup();
                var newDOM = document.createRange().createContextualFragment(newMarkup);
                var newElements = Array.from(newDOM.querySelectorAll('*'));
                var currElements = Array.from(this._parentElement.querySelectorAll('*'));
                // console.log(newElements, currElements);
                newElements.forEach(function(newEl, i) {
                    var _newEl_firstChild_nodeValue, _newEl_firstChild;
                    var curEl = currElements[i];
                    // console.log(curEl, newEl.isEqualNode(curEl));
                    if (!newEl.isEqualNode(curEl) && ((_newEl_firstChild = newEl.firstChild) === null || _newEl_firstChild === void 0 ? void 0 : (_newEl_firstChild_nodeValue = _newEl_firstChild.nodeValue) === null || _newEl_firstChild_nodeValue === void 0 ? void 0 : _newEl_firstChild_nodeValue.trim()) !== '') curEl.textContent = newEl.textContent;
                    if (!newEl.isEqualNode(curEl)) Array.from(newEl.attributes).forEach(function(attr) {
                        return curEl.setAttribute(attr.name, attr.value);
                    });
                });
            }
        },
        {
            key: "renderSpinner",
            value: function renderSpinner() {
                var markup = '\n           <div class="spinner">\n              <svg>\n                <use href="'.concat((0, (/*@__PURE__*/$parcel$interopDefault($66dabfc31483eda1$exports))), '#icon-loader"></use>\n              </svg>\n            </div>\n      ');
                this._clear();
                this._parentElement.insertAdjacentHTML('afterbegin', markup);
            }
        },
        {
            key: "renderError",
            value: function renderError() {
                var message = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : this._errorMessage;
                var markup = '\n       <div class="error">\n              <div>\n                <svg>\n                  <use href="src/img/'.concat((0, (/*@__PURE__*/$parcel$interopDefault($66dabfc31483eda1$exports))), '#icon-alert-triangle"></use>\n                </svg>\n              </div>\n              <p>').concat(message, "</p>\n            </div>\n      ");
                this._clear();
                this._parentElement.insertAdjacentHTML('afterbegin', markup);
            }
        },
        {
            key: "renderMessage",
            value: function renderMessage() {
                var message = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : this._message;
                var markup = '\n      <div class="message">\n            <div>\n              <svg>\n                <use href="src/img/'.concat((0, (/*@__PURE__*/$parcel$interopDefault($66dabfc31483eda1$exports))), '#icon-smile"></use>\n              </svg>\n            </div>\n            <p>').concat(message, "</p>\n      ");
                this._clear();
                this._parentElement.insertAdjacentHTML('afterbegin', markup);
            }
        },
        {
            key: "_clear",
            value: function _clear() {
                this._parentElement.innerHTML = '';
            }
        }
    ]);
    return View;
}();


var $314872282fb75f8b$var$RecipeView = /*#__PURE__*/ function(View) {
    "use strict";
    (0, $gNq0T._)(RecipeView, View);
    function RecipeView() {
        (0, $7eXQk._)(this, RecipeView);
        var _this;
        _this = (0, $fxAKY._)(this, RecipeView, arguments), (0, $c9996135bbccb03d$export$71511d61b312f219)(_this, "_parentElement", document.querySelector('.recipe')), (0, $c9996135bbccb03d$export$71511d61b312f219)(_this, "_errorMessage", 'We could not find that recipe, please try another one'), (0, $c9996135bbccb03d$export$71511d61b312f219)(_this, "_message", '');
        return _this;
    }
    (0, $gApSC._)(RecipeView, [
        {
            key: "addHandlerRender",
            value: function addHandlerRender(handler) {
                [
                    'hashchange',
                    'load'
                ].forEach(function(ev) {
                    return window.addEventListener(ev, handler);
                });
            }
        },
        {
            key: "addHandlerUpdateServings",
            value: function addHandlerUpdateServings(handler) {
                this._parentElement.addEventListener('click', function(e) {
                    var btn = e.target.closest('.btn--update-servings');
                    if (!btn) return;
                    var updateTo = btn.dataset.updateTo;
                    if (+updateTo > 0) handler(+updateTo);
                });
            }
        },
        {
            key: "addHandlerAddBookmark",
            value: function addHandlerAddBookmark(handler) {
                this._parentElement.addEventListener('click', function(e) {
                    var btn = e.target.closest('.btn--bookmark');
                    if (!btn) return;
                    handler();
                });
            }
        },
        {
            key: "_generateMarkup",
            value: function _generateMarkup() {
                return '\n     <figure class="recipe__fig">\n          <img src="'.concat(this._data.image, '" alt="').concat(this._data.title, '" class="recipe__img" />\n          <h1 class="recipe__title">\n            <span>').concat(this._data.title, '</span>\n          </h1>\n        </figure>\n\n        <div class="recipe__details">\n          <div class="recipe__info">\n            <svg class="recipe__info-icon">\n              <use href="').concat((0, (/*@__PURE__*/$parcel$interopDefault($66dabfc31483eda1$exports))), '.svg#icon-clock"></use>\n            </svg>\n            <span class="recipe__info-data recipe__info-data--minutes">').concat(this._data.cookingTime, '</span>\n            <span class="recipe__info-text">minutes</span>\n          </div>\n          <div class="recipe__info">\n            <svg class="recipe__info-icon">\n              <use href="').concat((0, (/*@__PURE__*/$parcel$interopDefault($66dabfc31483eda1$exports))), '.svg#icon-users"></use>\n            </svg>\n            <span class="recipe__info-data recipe__info-data--people">').concat(this._data.servings, '</span>\n            <span class="recipe__info-text">servings</span>\n\n            <div class="recipe__info-buttons">\n              <button class="btn--tiny btn--update-servings" data-update-to="').concat(this._data.servings - 1, '">\n                <svg>\n                  <use href="').concat((0, (/*@__PURE__*/$parcel$interopDefault($66dabfc31483eda1$exports))), '#icon-minus-circle"></use>\n                </svg>\n              </button>\n              <button class="btn--tiny btn--update-servings" data-update-to="').concat(this._data.servings + 1, '">\n                <svg>\n                  <use href="').concat((0, (/*@__PURE__*/$parcel$interopDefault($66dabfc31483eda1$exports))), '#icon-plus-circle"></use>\n                </svg>\n              </button>\n            </div>\n          </div>\n\n          <div class="recipe__user-generated ').concat(this._data.key ? '' : 'hidden', '">\n            <svg>\n              <use href="').concat((0, (/*@__PURE__*/$parcel$interopDefault($66dabfc31483eda1$exports))), '#icon-user"></use>\n            </svg>\n          </div>\n          <button class="btn--round btn--bookmark">\n            <svg class="">\n              <use href="').concat((0, (/*@__PURE__*/$parcel$interopDefault($66dabfc31483eda1$exports))), "#icon-bookmark").concat(this._data.bookmarked ? '-fill' : '', '"></use>\n            </svg>\n          </button>\n        </div>\n\n        <div class="recipe__ingredients">\n          <h2 class="heading--2">Recipe ingredients</h2>\n          <ul class="recipe__ingredient-list">\n          ').concat(this._data.ingredients.map(function(ing) {
                    return '\n            <li class="recipe__ingredient">\n              <svg class="recipe__icon">\n                <use href="'.concat((0, (/*@__PURE__*/$parcel$interopDefault($66dabfc31483eda1$exports))), '.svg#icon-check"></use>\n              </svg>\n              <div class="recipe__quantity">').concat(ing.quantity ? new (0, $cfa244152796a46f$export$b336c2702c498be5)(ing.quantity).toString() : '', '</div>\n              <div class="recipe__description">\n                <span class="recipe__unit">').concat(ing.unit, "</span>\n                ").concat(ing.description, "\n              </div>\n            </li>\n\n            ");
                }).join(''), '\n            \n\n            \n          </ul>\n        </div>\n\n        <div class="recipe__directions">\n          <h2 class="heading--2">How to cook it</h2>\n          <p class="recipe__directions-text">\n            This recipe was carefully designed and tested by\n            <span class="recipe__publisher">').concat(this._data.publisher, '</span>. Please check out\n            directions at their website.\n          </p>\n          <a\n            class="btn--small recipe__btn"\n            href="').concat(this._data.sourceUrl, '"\n            target="_blank"\n          >\n            <span>Directions</span>\n            <svg class="search__icon">\n              <use href="').concat((0, (/*@__PURE__*/$parcel$interopDefault($66dabfc31483eda1$exports))), '#icon-arrow-right"></use>\n            </svg>\n          </a>\n        </div>\n    ');
            }
        }
    ]);
    return RecipeView;
}((0, $f88bdd13c53e4d92$export$2e2bcd8739ae039));
var $314872282fb75f8b$export$2e2bcd8739ae039 = new $314872282fb75f8b$var$RecipeView();


var $c4cbf66e0afbbdbf$export$ca000e230c0caa3e = {
    recipe: {},
    search: {
        query: '',
        results: [],
        page: 1,
        resultsPerPage: (0, $d5aa1367302a9087$export$5feaddb1377b7f5e)
    },
    bookmarks: []
};
var $c4cbf66e0afbbdbf$var$createRecipeObject = function createRecipeObject(data) {
    var recipe = data.data.recipe;
    return (0, $1d5a8ca6a8456cf0$export$71511d61b312f219)({
        id: recipe.id,
        title: recipe.title,
        publisher: recipe.publisher,
        sourceUrl: recipe.source_url,
        image: recipe.image_url,
        servings: recipe.servings,
        cookingTime: recipe.cooking_time,
        ingredients: recipe.ingredients
    }, recipe.key && {
        key: recipe.key
    });
};
var $c4cbf66e0afbbdbf$export$b96725c7a035d60b = function loadRecipe(id) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $cd69311d8f42aefb$export$71511d61b312f219)(function() {
        var data, err;
        return (0, $53nS0._)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        2,
                        ,
                        3
                    ]);
                    return [
                        4,
                        (0, $8a80cc190987196a$export$2b3ff41fecbef7c8)("".concat((0, $d5aa1367302a9087$export$923ea8233b386e99)).concat(id, "?key=").concat((0, $d5aa1367302a9087$export$7167c830cefcb6b5)))
                    ];
                case 1:
                    data = _state.sent();
                    $c4cbf66e0afbbdbf$export$ca000e230c0caa3e.recipe = $c4cbf66e0afbbdbf$var$createRecipeObject(data);
                    if ($c4cbf66e0afbbdbf$export$ca000e230c0caa3e.bookmarks.some(function(bookmark) {
                        return bookmark.id === id;
                    })) $c4cbf66e0afbbdbf$export$ca000e230c0caa3e.recipe.bookmarked = true;
                    else $c4cbf66e0afbbdbf$export$ca000e230c0caa3e.recipe.bookmarked = false;
                    return [
                        3,
                        3
                    ];
                case 2:
                    err = _state.sent();
                    console.error("".concat(err, "!!!"));
                    throw err;
                case 3:
                    return [
                        2
                    ];
            }
        });
    })();
};
var $c4cbf66e0afbbdbf$export$202b8e5cb363a0c4 = function loadSearchResults(query) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $cd69311d8f42aefb$export$71511d61b312f219)(function() {
        var data, err;
        return (0, $53nS0._)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        2,
                        ,
                        3
                    ]);
                    $c4cbf66e0afbbdbf$export$ca000e230c0caa3e.search.query = query;
                    return [
                        4,
                        (0, $8a80cc190987196a$export$2b3ff41fecbef7c8)("".concat((0, $d5aa1367302a9087$export$923ea8233b386e99), "?search=").concat(query, "&key=").concat((0, $d5aa1367302a9087$export$7167c830cefcb6b5)))
                    ];
                case 1:
                    data = _state.sent();
                    $c4cbf66e0afbbdbf$export$ca000e230c0caa3e.search.results = data.data.recipes.map(function(rec) {
                        return (0, $1d5a8ca6a8456cf0$export$71511d61b312f219)({
                            id: rec.id,
                            title: rec.title,
                            publisher: rec.publisher,
                            image: rec.image_url
                        }, rec.key && {
                            key: rec.key
                        });
                    });
                    $c4cbf66e0afbbdbf$export$ca000e230c0caa3e.search.page = 1;
                    return [
                        3,
                        3
                    ];
                case 2:
                    err = _state.sent();
                    console.error("".concat(err, " !!"));
                    throw err;
                case 3:
                    return [
                        2
                    ];
            }
        });
    })();
};
var $c4cbf66e0afbbdbf$export$8d7f79465139ab72 = function getSearchResultsPage() {
    var page = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : $c4cbf66e0afbbdbf$export$ca000e230c0caa3e.search.page;
    $c4cbf66e0afbbdbf$export$ca000e230c0caa3e.search.page = page;
    var start = (page - 1) * $c4cbf66e0afbbdbf$export$ca000e230c0caa3e.search.resultsPerPage; // 0;
    var end = page * $c4cbf66e0afbbdbf$export$ca000e230c0caa3e.search.resultsPerPage; // 9;
    return $c4cbf66e0afbbdbf$export$ca000e230c0caa3e.search.results.slice(start, end);
};
var $c4cbf66e0afbbdbf$export$5e23f4642ecad5ea = function updateServings(newServings) {
    $c4cbf66e0afbbdbf$export$ca000e230c0caa3e.recipe.ingredients.forEach(function(ing) {
        ing.quantity = ing.quantity * newServings / $c4cbf66e0afbbdbf$export$ca000e230c0caa3e.recipe.servings;
    });
    $c4cbf66e0afbbdbf$export$ca000e230c0caa3e.recipe.servings = newServings;
};
var $c4cbf66e0afbbdbf$var$persistBookmarks = function persistBookmarks() {
    localStorage.setItem('bookmarks', JSON.stringify($c4cbf66e0afbbdbf$export$ca000e230c0caa3e.bookmarks));
};
var $c4cbf66e0afbbdbf$export$72009cc673d27d80 = function addBookmark(recipe) {
    // Add bookmark
    $c4cbf66e0afbbdbf$export$ca000e230c0caa3e.bookmarks.push(recipe);
    // Mark current recipe as bookmark
    if (recipe.id === $c4cbf66e0afbbdbf$export$ca000e230c0caa3e.recipe.id) $c4cbf66e0afbbdbf$export$ca000e230c0caa3e.recipe.bookmarked = true;
    $c4cbf66e0afbbdbf$var$persistBookmarks();
};
var $c4cbf66e0afbbdbf$export$136048bcb9946c75 = function deleteBookmark(id) {
    // delete bookmark
    var index = $c4cbf66e0afbbdbf$export$ca000e230c0caa3e.bookmarks.findIndex(function(el) {
        return el.id === id;
    });
    $c4cbf66e0afbbdbf$export$ca000e230c0caa3e.bookmarks.splice(index, 1);
    // mark current recipe as NOT bookmarked
    if (id === $c4cbf66e0afbbdbf$export$ca000e230c0caa3e.recipe.id) $c4cbf66e0afbbdbf$export$ca000e230c0caa3e.recipe.bookmarked = false;
    $c4cbf66e0afbbdbf$var$persistBookmarks();
};
var $c4cbf66e0afbbdbf$var$init = function init() {
    var storage = localStorage.getItem('bookmarks');
    if (storage) $c4cbf66e0afbbdbf$export$ca000e230c0caa3e.bookmarks = JSON.parse(storage);
};
$c4cbf66e0afbbdbf$var$init();
var $c4cbf66e0afbbdbf$export$d660c2254e74960d = function uploadRecipe(newRecipe) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $cd69311d8f42aefb$export$71511d61b312f219)(function() {
        var ingredients, recipe, data, err;
        return (0, $53nS0._)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        2,
                        ,
                        3
                    ]);
                    ingredients = Object.entries(newRecipe).filter(function(entry) {
                        return entry[0].startsWith('ingredient') && entry[1] !== '';
                    }).map(function(ing) {
                        var ingArr = ing[1].split(',').map(function(el) {
                            return el.trim();
                        });
                        if (ingArr.length !== 3) throw new Error('Wrong ingredient format! Please use the correct format');
                        var _ingArr = (0, $f9342d8e326b10da$export$71511d61b312f219)(ingArr, 3), quantity = _ingArr[0], unit = _ingArr[1], description = _ingArr[2];
                        return {
                            quantity: quantity ? +quantity : null,
                            unit: unit,
                            description: description
                        };
                    });
                    recipe = {
                        title: newRecipe.title,
                        source_url: newRecipe.sourceUrl,
                        image_url: newRecipe.image,
                        publisher: newRecipe.publisher,
                        cooking_time: +newRecipe.cookingTime,
                        servings: +newRecipe.servings,
                        ingredients: ingredients
                    };
                    return [
                        4,
                        (0, $8a80cc190987196a$export$2b3ff41fecbef7c8)("".concat((0, $d5aa1367302a9087$export$923ea8233b386e99), "?key=").concat((0, $d5aa1367302a9087$export$7167c830cefcb6b5)), recipe)
                    ];
                case 1:
                    data = _state.sent();
                    $c4cbf66e0afbbdbf$export$ca000e230c0caa3e.recipe = $c4cbf66e0afbbdbf$var$createRecipeObject(data);
                    $c4cbf66e0afbbdbf$export$72009cc673d27d80($c4cbf66e0afbbdbf$export$ca000e230c0caa3e.recipe);
                    return [
                        3,
                        3
                    ];
                case 2:
                    err = _state.sent();
                    throw err;
                case 3:
                    return [
                        2
                    ];
            }
        });
    })();
};





var $7eXQk = parcelRequire("7eXQk");
function $39bb9dff0f4a5ef7$export$71511d61b312f219(receiver, privateSet, fn) {
    if (!privateSet.has(receiver)) throw new TypeError("attempted to get private field on non-instance");
    return fn;
}


function $ce8d391f47f21819$export$71511d61b312f219(obj, privateCollection) {
    if (privateCollection.has(obj)) throw new TypeError("Cannot initialize the same private elements twice on an object");
}


function $f2e1006900f71193$export$71511d61b312f219(obj, privateSet) {
    (0, $ce8d391f47f21819$export$71511d61b312f219)(obj, privateSet);
    privateSet.add(obj);
}



var $gApSC = parcelRequire("gApSC");

var $be4fa4ce989111a8$var$_clearInput = /*#__PURE__*/ new WeakSet();
var $be4fa4ce989111a8$var$SearchView = /*#__PURE__*/ function() {
    "use strict";
    function SearchView() {
        (0, $7eXQk._)(this, SearchView);
        (0, $f2e1006900f71193$export$71511d61b312f219)(this, $be4fa4ce989111a8$var$_clearInput);
        (0, $c9996135bbccb03d$export$71511d61b312f219)(this, "_parentElement", document.querySelector('.search'));
    }
    (0, $gApSC._)(SearchView, [
        {
            key: "getQuery",
            value: function getQuery() {
                var query = this._parentElement.querySelector('.search__field').value;
                (0, $39bb9dff0f4a5ef7$export$71511d61b312f219)(this, $be4fa4ce989111a8$var$_clearInput, $be4fa4ce989111a8$var$clearInput).call(this);
                return query;
            }
        },
        {
            key: "addHandlerSearch",
            value: function addHandlerSearch(handler) {
                this._parentElement.addEventListener('submit', function(e) {
                    e.preventDefault();
                    handler();
                });
            }
        }
    ]);
    return SearchView;
}();
function $be4fa4ce989111a8$var$clearInput() {
    this._parentElement.querySelector('.search__field').value = '';
}
var $be4fa4ce989111a8$export$2e2bcd8739ae039 = new $be4fa4ce989111a8$var$SearchView();



var $fxAKY = parcelRequire("fxAKY");

var $7eXQk = parcelRequire("7eXQk");

var $gApSC = parcelRequire("gApSC");


var $gNq0T = parcelRequire("gNq0T");



var $fxAKY = parcelRequire("fxAKY");

var $7eXQk = parcelRequire("7eXQk");

var $gApSC = parcelRequire("gApSC");


var $gNq0T = parcelRequire("gNq0T");


var $1cd84c5b489c601d$var$PreviewView = /*#__PURE__*/ function(View) {
    "use strict";
    (0, $gNq0T._)(PreviewView, View);
    function PreviewView() {
        (0, $7eXQk._)(this, PreviewView);
        var _this;
        _this = (0, $fxAKY._)(this, PreviewView, arguments), (0, $c9996135bbccb03d$export$71511d61b312f219)(_this, "_parentElement", '');
        return _this;
    }
    (0, $gApSC._)(PreviewView, [
        {
            key: "_generateMarkup",
            value: function _generateMarkup() {
                var id = window.location.hash.slice(1);
                return '\n    <li class="preview">\n            <a class="preview__link '.concat(this._data.id === id ? 'preview__link--active' : '', '" href="#').concat(this._data.id, '">\n              <figure class="preview__fig">\n                <img src="').concat(this._data.image, '" alt="').concat(this._data.title, '" />\n              </figure>\n              <div class="preview__data">\n                <h4 class="preview__title">').concat(this._data.title, '</h4>\n                <p class="preview__publisher">').concat(this._data.publisher, '</p>\n                <div class="preview__user-generated ').concat(this._data.key ? '' : 'hidden', '">\n                  <svg>\n                    <use href="').concat((0, (/*@__PURE__*/$parcel$interopDefault($66dabfc31483eda1$exports))), '#icon-user"></use>\n                  </svg>\n                </div>\n              </div>\n            </a>\n          </li>\n    ');
            }
        }
    ]);
    return PreviewView;
}((0, $f88bdd13c53e4d92$export$2e2bcd8739ae039));
var $1cd84c5b489c601d$export$2e2bcd8739ae039 = new $1cd84c5b489c601d$var$PreviewView();


var $eda26cd6e857af67$var$ResultsView = /*#__PURE__*/ function(View) {
    "use strict";
    (0, $gNq0T._)(ResultsView, View);
    function ResultsView() {
        (0, $7eXQk._)(this, ResultsView);
        var _this;
        _this = (0, $fxAKY._)(this, ResultsView, arguments), (0, $c9996135bbccb03d$export$71511d61b312f219)(_this, "_parentElement", document.querySelector('.results')), (0, $c9996135bbccb03d$export$71511d61b312f219)(_this, "_errorMessage", 'No recipes found for your query. Please try again'), (0, $c9996135bbccb03d$export$71511d61b312f219)(_this, "_message", '');
        return _this;
    }
    (0, $gApSC._)(ResultsView, [
        {
            key: "_generateMarkup",
            value: function _generateMarkup() {
                return this._data.map(function(result) {
                    return (0, $1cd84c5b489c601d$export$2e2bcd8739ae039).render(result, false);
                }).join('');
            }
        }
    ]);
    return ResultsView;
}((0, $f88bdd13c53e4d92$export$2e2bcd8739ae039));
var $eda26cd6e857af67$export$2e2bcd8739ae039 = new $eda26cd6e857af67$var$ResultsView();



var $fxAKY = parcelRequire("fxAKY");

var $7eXQk = parcelRequire("7eXQk");

var $gApSC = parcelRequire("gApSC");


var $gNq0T = parcelRequire("gNq0T");



var $f6ed18c4b51ad575$var$BookmarksView = /*#__PURE__*/ function(View) {
    "use strict";
    (0, $gNq0T._)(BookmarksView, View);
    function BookmarksView() {
        (0, $7eXQk._)(this, BookmarksView);
        var _this;
        _this = (0, $fxAKY._)(this, BookmarksView, arguments), (0, $c9996135bbccb03d$export$71511d61b312f219)(_this, "_parentElement", document.querySelector('.bookmarks__list')), (0, $c9996135bbccb03d$export$71511d61b312f219)(_this, "_errorMessage", 'No bookmarks yet. Find a nice recipe and bookmark it'), (0, $c9996135bbccb03d$export$71511d61b312f219)(_this, "_message", '');
        return _this;
    }
    (0, $gApSC._)(BookmarksView, [
        {
            key: "addHandlerRender",
            value: function addHandlerRender(handler) {
                window.addEventListener('load', handler);
            }
        },
        {
            key: "_generateMarkup",
            value: function _generateMarkup() {
                return this._data.map(function(bookmark) {
                    return (0, $1cd84c5b489c601d$export$2e2bcd8739ae039).render(bookmark, false);
                }).join('');
            }
        }
    ]);
    return BookmarksView;
}((0, $f88bdd13c53e4d92$export$2e2bcd8739ae039));
var $f6ed18c4b51ad575$export$2e2bcd8739ae039 = new $f6ed18c4b51ad575$var$BookmarksView();



var $fxAKY = parcelRequire("fxAKY");

var $7eXQk = parcelRequire("7eXQk");

var $gApSC = parcelRequire("gApSC");


var $gNq0T = parcelRequire("gNq0T");
var $02d54c1a72d95c0f$exports = {};
// Because of vitejs/vite#12340, there's no way to reliably detect whether we're
// running as a (possibly bundled/polyfilled) ESM module or as a CommonJS
// module. In order to work everywhere, we have to provide the load function via
// a side channel on the global object. We write it as a stack so that multiple
// cli_pkg packages can depend on one another without clobbering their exports.


var $6tOPT = parcelRequire("6tOPT");
var $9987c0d19ce1ef19$var$__dirname = "node_modules/sass";
var $9987c0d19ce1ef19$var$__filename = "node_modules/sass/sass.dart.js";

var $isEGv = parcelRequire("isEGv");
var $9987c0d19ce1ef19$require$Buffer = $isEGv.Buffer;

var $dKiQF = parcelRequire("dKiQF");
if (!globalThis._cliPkgExports) globalThis._cliPkgExports = [];
var $9987c0d19ce1ef19$var$_cliPkgExports = {};
globalThis._cliPkgExports.push($9987c0d19ce1ef19$var$_cliPkgExports);
$9987c0d19ce1ef19$var$_cliPkgExports.load = function(_cliPkgRequires, _cliPkgExportParam) {
    var dartNodeIsActuallyNode = false;
    // make sure to keep this as 'var'
    // we don't want block scoping
    var self = dartNodeIsActuallyNode ? Object.create(globalThis) : globalThis;
    self.scheduleImmediate = typeof setImmediate !== "undefined" ? function(cb) {
        setImmediate(cb);
    } : function(cb) {
        setTimeout(cb, 0);
    };
    self.require = undefined;
    self.exports = _cliPkgExportParam || $9987c0d19ce1ef19$var$_cliPkgExports;
    if (typeof $9987c0d19ce1ef19$var$__dirname !== "undefined") self.__dirname = $9987c0d19ce1ef19$var$__dirname;
    if (typeof $9987c0d19ce1ef19$var$__filename !== "undefined") self.__filename = $9987c0d19ce1ef19$var$__filename;
    if (typeof $9987c0d19ce1ef19$require$Buffer !== "undefined") self.Buffer = $9987c0d19ce1ef19$require$Buffer;
    // if we're running in a browser, Dart supports most of this out of box
    // make sure we only run these in Node.js environment
    if (dartNodeIsActuallyNode) {
        // This line is to:
        // 1) Prevent Webpack from bundling.
        // 2) In Webpack on Node.js, make sure we're using the native Node.js require, which is available via __non_webpack_require__
        // https://github.com/mbullington/node_preamble.dart/issues/18#issuecomment-527305561
        var url = ("undefined" !== typeof __webpack_require__ ? __non_webpack_require__ : undefined)("url");
        // Setting `self.location=` in Electron throws a `TypeError`, so we define it
        // as a property instead to be safe.
        Object.defineProperty(self, "location", {
            value: {
                get href () {
                    if (url.pathToFileURL) return url.pathToFileURL($dKiQF.cwd()).href + "/";
                    else // This isn't really a correct transformation, but it's the best we have
                    // for versions of Node <10.12.0 which introduced `url.pathToFileURL()`.
                    // For example, it will fail for paths that contain characters that need
                    // to be escaped in URLs.
                    return "file://" + function() {
                        var cwd = $dKiQF.cwd();
                        if ($dKiQF.platform != "win32") return cwd;
                        return "/" + cwd.replace(/\\/g, "/");
                    }() + "/";
                }
            }
        });
        (function() {
            function computeCurrentScript() {
                try {
                    throw new Error();
                } catch (e) {
                    var stack = e.stack;
                    var re = new RegExp("^ *at [^(]*\\((.*):[0-9]*:[0-9]*\\)$", "mg");
                    var lastMatch = null;
                    do {
                        var match = re.exec(stack);
                        if (match != null) lastMatch = match;
                    }while (match != null);
                    return lastMatch[1];
                }
            }
            // Setting `self.document=` isn't known to throw an error anywhere like
            // `self.location=` does on Electron, but it's better to be future-proof
            // just in case..
            var cachedCurrentScript = null;
            Object.defineProperty(self, "document", {
                value: {
                    get currentScript () {
                        if (cachedCurrentScript == null) cachedCurrentScript = {
                            src: computeCurrentScript()
                        };
                        return cachedCurrentScript;
                    }
                }
            });
        })();
        self.dartDeferredLibraryLoader = function(uri, successCallback, errorCallback) {
            try {
                load(uri);
                successCallback();
            } catch (error) {
                errorCallback(error);
            }
        };
    }
    Object.defineProperty(self, 'parcel_watcher', {
        get: _cliPkgRequires.parcel_watcher
    });
    self.immutable = _cliPkgRequires.immutable;
    self.chokidar = _cliPkgRequires.chokidar;
    self.readline = _cliPkgRequires.readline;
    self.fs = _cliPkgRequires.fs;
    self.nodeModule = _cliPkgRequires.nodeModule;
    self.stream = _cliPkgRequires.stream;
    self.util = _cliPkgRequires.util;
    // Generated by dart2js (, trust primitives, omit checks, lax runtime type, csp, intern-composite-values), the Dart to JavaScript compiler version: 3.12.2.
    // The code supports the following hooks:
    // dartPrint(message):
    //    if this function is defined it is called instead of the Dart [print]
    //    method.
    //
    // dartMainRunner(main, args):
    //    if this function is defined, the Dart [main] method will not be invoked
    //    directly. Instead, a closure that will invoke [main], and its arguments
    //    [args] is passed to [dartMainRunner].
    //
    // dartDeferredLibraryLoader(uri, successCallback, errorCallback, loadId, loadPriority):
    //    if this function is defined, it will be called when a deferred library
    //    is loaded. It should load and eval the javascript of `uri`, and call
    //    successCallback. If it fails to do so, it should call errorCallback with
    //    an error. The loadId argument is the deferred import that resulted in
    //    this uri being loaded. The loadPriority argument is an arbitrary argument
    //    string forwarded from the 'dart2js:load-priority' pragma option.
    // dartDeferredLibraryMultiLoader(uris, successCallback, errorCallback, loadId, loadPriority):
    //    if this function is defined, it will be called when a deferred library
    //    is loaded. It should load and eval the javascript of every URI in `uris`,
    //    and call successCallback. If it fails to do so, it should call
    //    errorCallback with an error. The loadId argument is the deferred import
    //    that resulted in this uri being loaded. The loadPriority argument is an
    //    arbitrary argument string forwarded from the 'dart2js:load-priority'
    //    pragma option.
    //
    // dartCallInstrumentation(id, qualifiedName):
    //    if this function is defined, it will be called at each entry of a
    //    method or constructor. Used only when compiling programs with
    //    --experiment-call-instrumentation.
    (function dartProgram() {
        function copyProperties(from, to) {
            var keys = Object.keys(from);
            for(var i = 0; i < keys.length; i++){
                var key = keys[i];
                to[key] = from[key];
            }
        }
        function mixinPropertiesHard(from, to) {
            var keys = Object.keys(from);
            for(var i = 0; i < keys.length; i++){
                var key = keys[i];
                if (!to.hasOwnProperty(key)) to[key] = from[key];
            }
        }
        function mixinPropertiesEasy(from, to) {
            Object.assign(to, from);
        }
        var supportsDirectProtoAccess = function() {
            var cls = function cls() {};
            cls.prototype = {
                p: {}
            };
            var object = new cls();
            if (!(Object.getPrototypeOf(object) && Object.getPrototypeOf(object).p === cls.prototype.p)) return false;
            try {
                if (typeof navigator != "undefined" && typeof navigator.userAgent == "string" && navigator.userAgent.indexOf("Chrome/") >= 0) return true;
                if (typeof version == "function" && version.length == 0) {
                    var v = version();
                    if (/^\d+\.\d+\.\d+\.\d+$/.test(v)) return true;
                }
            } catch (_) {}
            return false;
        }();
        function inherit(cls, sup) {
            cls.prototype.constructor = cls;
            cls.prototype["$is" + cls.name] = cls;
            if (sup != null) {
                if (supportsDirectProtoAccess) {
                    Object.setPrototypeOf(cls.prototype, sup.prototype);
                    return;
                }
                var clsPrototype = Object.create(sup.prototype);
                copyProperties(cls.prototype, clsPrototype);
                cls.prototype = clsPrototype;
            }
        }
        function inheritMany(sup, classes) {
            for(var i = 0; i < classes.length; i++)inherit(classes[i], sup);
        }
        function mixinEasy(cls, mixin) {
            mixinPropertiesEasy(mixin.prototype, cls.prototype);
            cls.prototype.constructor = cls;
        }
        function mixinHard(cls, mixin) {
            mixinPropertiesHard(mixin.prototype, cls.prototype);
            cls.prototype.constructor = cls;
        }
        function lazy(holder, name, getterName, initializer) {
            var uninitializedSentinel = holder;
            holder[name] = uninitializedSentinel;
            holder[getterName] = function() {
                if (holder[name] === uninitializedSentinel) holder[name] = initializer();
                holder[getterName] = function() {
                    return this[name];
                };
                return holder[name];
            };
        }
        function lazyFinal(holder, name, getterName, initializer) {
            var uninitializedSentinel = holder;
            holder[name] = uninitializedSentinel;
            holder[getterName] = function() {
                if (holder[name] === uninitializedSentinel) {
                    var value = initializer();
                    if (holder[name] !== uninitializedSentinel) A.throwLateFieldADI(name);
                    holder[name] = value;
                }
                var finalValue = holder[name];
                holder[getterName] = function() {
                    return finalValue;
                };
                return finalValue;
            };
        }
        function makeConstList(list, rti) {
            if (rti != null) A._setArrayType(list, rti);
            list.$flags = 7;
            return list;
        }
        function convertToFastObject(properties) {
            function t() {}
            t.prototype = properties;
            new t();
            return properties;
        }
        function convertAllToFastObject(arrayOfObjects) {
            for(var i = 0; i < arrayOfObjects.length; ++i)convertToFastObject(arrayOfObjects[i]);
        }
        var functionCounter = 0;
        function instanceTearOffGetter(isIntercepted, parameters) {
            var cache = null;
            return isIntercepted ? function(receiver) {
                if (cache === null) cache = A.closureFromTearOff(parameters);
                return new cache(receiver, this);
            } : function() {
                if (cache === null) cache = A.closureFromTearOff(parameters);
                return new cache(this, null);
            };
        }
        function staticTearOffGetter(parameters) {
            var cache = null;
            return function() {
                if (cache === null) cache = A.closureFromTearOff(parameters).prototype;
                return cache;
            };
        }
        var typesOffset = 0;
        function tearOffParameters(container, isStatic, isIntercepted, requiredParameterCount, optionalParameterDefaultValues, callNames, funsOrNames, funType, applyIndex, needsDirectAccess) {
            if (typeof funType == "number") funType += typesOffset;
            return {
                co: container,
                iS: isStatic,
                iI: isIntercepted,
                rC: requiredParameterCount,
                dV: optionalParameterDefaultValues,
                cs: callNames,
                fs: funsOrNames,
                fT: funType,
                aI: applyIndex || 0,
                nDA: needsDirectAccess
            };
        }
        function installStaticTearOff(holder, getterName, requiredParameterCount, optionalParameterDefaultValues, callNames, funsOrNames, funType, applyIndex) {
            var parameters = tearOffParameters(holder, true, false, requiredParameterCount, optionalParameterDefaultValues, callNames, funsOrNames, funType, applyIndex, false);
            var getterFunction = staticTearOffGetter(parameters);
            holder[getterName] = getterFunction;
        }
        function installInstanceTearOff(prototype, getterName, isIntercepted, requiredParameterCount, optionalParameterDefaultValues, callNames, funsOrNames, funType, applyIndex, needsDirectAccess) {
            isIntercepted = !!isIntercepted;
            var parameters = tearOffParameters(prototype, false, isIntercepted, requiredParameterCount, optionalParameterDefaultValues, callNames, funsOrNames, funType, applyIndex, !!needsDirectAccess);
            var getterFunction = instanceTearOffGetter(isIntercepted, parameters);
            prototype[getterName] = getterFunction;
        }
        function setOrUpdateInterceptorsByTag(newTags) {
            var tags = init.interceptorsByTag;
            if (!tags) {
                init.interceptorsByTag = newTags;
                return;
            }
            copyProperties(newTags, tags);
        }
        function setOrUpdateLeafTags(newTags) {
            var tags = init.leafTags;
            if (!tags) {
                init.leafTags = newTags;
                return;
            }
            copyProperties(newTags, tags);
        }
        function updateTypes(newTypes) {
            var types = init.types;
            var length = types.length;
            types.push.apply(types, newTypes);
            return length;
        }
        function updateHolder(holder, newHolder) {
            copyProperties(newHolder, holder);
            return holder;
        }
        var hunkHelpers = function() {
            var mkInstance = function mkInstance(isIntercepted, requiredParameterCount, optionalParameterDefaultValues, callNames, applyIndex) {
                return function(container, getterName, name, funType) {
                    return installInstanceTearOff(container, getterName, isIntercepted, requiredParameterCount, optionalParameterDefaultValues, callNames, [
                        name
                    ], funType, applyIndex, false);
                };
            }, mkStatic = function mkStatic(requiredParameterCount, optionalParameterDefaultValues, callNames, applyIndex) {
                return function(container, getterName, name, funType) {
                    return installStaticTearOff(container, getterName, requiredParameterCount, optionalParameterDefaultValues, callNames, [
                        name
                    ], funType, applyIndex);
                };
            };
            return {
                inherit: inherit,
                inheritMany: inheritMany,
                mixin: mixinEasy,
                mixinHard: mixinHard,
                installStaticTearOff: installStaticTearOff,
                installInstanceTearOff: installInstanceTearOff,
                _instance_0u: mkInstance(0, 0, null, [
                    "call$0"
                ], 0),
                _instance_1u: mkInstance(0, 1, null, [
                    "call$1"
                ], 0),
                _instance_2u: mkInstance(0, 2, null, [
                    "call$2"
                ], 0),
                _instance_0i: mkInstance(1, 0, null, [
                    "call$0"
                ], 0),
                _instance_1i: mkInstance(1, 1, null, [
                    "call$1"
                ], 0),
                _instance_2i: mkInstance(1, 2, null, [
                    "call$2"
                ], 0),
                _static_0: mkStatic(0, null, [
                    "call$0"
                ], 0),
                _static_1: mkStatic(1, null, [
                    "call$1"
                ], 0),
                _static_2: mkStatic(2, null, [
                    "call$2"
                ], 0),
                makeConstList: makeConstList,
                lazy: lazy,
                lazyFinal: lazyFinal,
                updateHolder: updateHolder,
                convertToFastObject: convertToFastObject,
                updateTypes: updateTypes,
                setOrUpdateInterceptorsByTag: setOrUpdateInterceptorsByTag,
                setOrUpdateLeafTags: setOrUpdateLeafTags
            };
        }();
        function initializeDeferredHunk(hunk) {
            typesOffset = init.types.length;
            hunk(hunkHelpers, init, holders, $);
        }
        var J = {
            makeDispatchRecord: function(interceptor, proto, extension, indexability) {
                return {
                    i: interceptor,
                    p: proto,
                    e: extension,
                    x: indexability
                };
            },
            getNativeInterceptor: function(object) {
                var proto, objectProto, $constructor, interceptor, t1, record = object[init.dispatchPropertyName];
                if (record == null) {
                    if ($.initNativeDispatchFlag == null) {
                        A.initNativeDispatch();
                        record = object[init.dispatchPropertyName];
                    }
                }
                if (record != null) {
                    proto = record.p;
                    if (false === proto) return record.i;
                    if (true === proto) return object;
                    objectProto = Object.getPrototypeOf(object);
                    if (proto === objectProto) return record.i;
                    if (record.e === objectProto) throw A.wrapException(A.UnimplementedError$("Return interceptor for " + A.S(proto(object, record))));
                }
                $constructor = object.constructor;
                if ($constructor == null) interceptor = null;
                else {
                    t1 = $._JS_INTEROP_INTERCEPTOR_TAG;
                    if (t1 == null) t1 = $._JS_INTEROP_INTERCEPTOR_TAG = init.getIsolateTag("_$dart_js");
                    interceptor = $constructor[t1];
                }
                if (interceptor != null) return interceptor;
                interceptor = A.lookupAndCacheInterceptor(object);
                if (interceptor != null) return interceptor;
                if (typeof object == "function") return B.JavaScriptFunction_methods;
                proto = Object.getPrototypeOf(object);
                if (proto == null) return B.PlainJavaScriptObject_methods;
                if (proto === Object.prototype) return B.PlainJavaScriptObject_methods;
                if (typeof $constructor == "function") {
                    t1 = $._JS_INTEROP_INTERCEPTOR_TAG;
                    if (t1 == null) t1 = $._JS_INTEROP_INTERCEPTOR_TAG = init.getIsolateTag("_$dart_js");
                    Object.defineProperty($constructor, t1, {
                        value: B.UnknownJavaScriptObject_methods,
                        enumerable: false,
                        writable: true,
                        configurable: true
                    });
                    return B.UnknownJavaScriptObject_methods;
                }
                return B.UnknownJavaScriptObject_methods;
            },
            JSArray_JSArray$fixed: function($length, $E) {
                if ($length < 0 || $length > 4294967295) throw A.wrapException(A.RangeError$range($length, 0, 4294967295, "length", null));
                return J.JSArray_JSArray$markFixed(new Array($length), $E);
            },
            JSArray_JSArray$allocateFixed: function($length, $E) {
                if ($length > 4294967295) throw A.wrapException(A.RangeError$range($length, 0, 4294967295, "length", null));
                return J.JSArray_JSArray$markFixed(new Array($length), $E);
            },
            JSArray_JSArray$growable: function($length, $E) {
                if ($length < 0) throw A.wrapException(A.ArgumentError$("Length must be a non-negative integer: " + $length, null));
                return A._setArrayType(new Array($length), $E._eval$1("JSArray<0>"));
            },
            JSArray_JSArray$allocateGrowable: function($length, $E) {
                if ($length < 0) throw A.wrapException(A.ArgumentError$("Length must be a non-negative integer: " + $length, null));
                return A._setArrayType(new Array($length), $E._eval$1("JSArray<0>"));
            },
            JSArray_JSArray$markFixed: function(allocation, $E) {
                var t1 = A._setArrayType(allocation, $E._eval$1("JSArray<0>"));
                t1.$flags = 1;
                return t1;
            },
            JSArray__compareAny: function(a, b) {
                return J.compareTo$1$ns(a, b);
            },
            JSString__isWhitespace: function(codeUnit) {
                if (codeUnit < 256) switch(codeUnit){
                    case 9:
                    case 10:
                    case 11:
                    case 12:
                    case 13:
                    case 32:
                    case 133:
                    case 160:
                        return true;
                    default:
                        return false;
                }
                switch(codeUnit){
                    case 5760:
                    case 8192:
                    case 8193:
                    case 8194:
                    case 8195:
                    case 8196:
                    case 8197:
                    case 8198:
                    case 8199:
                    case 8200:
                    case 8201:
                    case 8202:
                    case 8232:
                    case 8233:
                    case 8239:
                    case 8287:
                    case 12288:
                    case 65279:
                        return true;
                    default:
                        return false;
                }
            },
            JSString__skipLeadingWhitespace: function(string, index) {
                var t1, codeUnit;
                for(t1 = string.length; index < t1;){
                    codeUnit = string.charCodeAt(index);
                    if (codeUnit !== 32 && codeUnit !== 13 && !J.JSString__isWhitespace(codeUnit)) break;
                    ++index;
                }
                return index;
            },
            JSString__skipTrailingWhitespace: function(string, index) {
                var index0, codeUnit;
                for(; index > 0; index = index0){
                    index0 = index - 1;
                    codeUnit = string.charCodeAt(index0);
                    if (codeUnit !== 32 && codeUnit !== 13 && !J.JSString__isWhitespace(codeUnit)) break;
                }
                return index;
            },
            getInterceptor$: function(receiver) {
                if (typeof receiver == "number") {
                    if (Math.floor(receiver) == receiver) return J.JSInt.prototype;
                    return J.JSNumNotInt.prototype;
                }
                if (typeof receiver == "string") return J.JSString.prototype;
                if (receiver == null) return J.JSNull.prototype;
                if (typeof receiver == "boolean") return J.JSBool.prototype;
                if (Array.isArray(receiver)) return J.JSArray.prototype;
                if ((typeof receiver === "undefined" ? "undefined" : (0, $6tOPT._)(receiver)) != "object") {
                    if (typeof receiver == "function") return J.JavaScriptFunction.prototype;
                    if ((typeof receiver === "undefined" ? "undefined" : (0, $6tOPT._)(receiver)) == "symbol") return J.JavaScriptSymbol.prototype;
                    if ((typeof receiver === "undefined" ? "undefined" : (0, $6tOPT._)(receiver)) == "bigint") return J.JavaScriptBigInt.prototype;
                    return receiver;
                }
                if (receiver instanceof A.Object) return receiver;
                return J.getNativeInterceptor(receiver);
            },
            getInterceptor$ansx: function(receiver) {
                if (typeof receiver == "number") return J.JSNumber.prototype;
                if (typeof receiver == "string") return J.JSString.prototype;
                if (receiver == null) return receiver;
                if (Array.isArray(receiver)) return J.JSArray.prototype;
                if ((typeof receiver === "undefined" ? "undefined" : (0, $6tOPT._)(receiver)) != "object") {
                    if (typeof receiver == "function") return J.JavaScriptFunction.prototype;
                    if ((typeof receiver === "undefined" ? "undefined" : (0, $6tOPT._)(receiver)) == "symbol") return J.JavaScriptSymbol.prototype;
                    if ((typeof receiver === "undefined" ? "undefined" : (0, $6tOPT._)(receiver)) == "bigint") return J.JavaScriptBigInt.prototype;
                    return receiver;
                }
                if (receiver instanceof A.Object) return receiver;
                return J.getNativeInterceptor(receiver);
            },
            getInterceptor$asx: function(receiver) {
                if (typeof receiver == "string") return J.JSString.prototype;
                if (receiver == null) return receiver;
                if (Array.isArray(receiver)) return J.JSArray.prototype;
                if ((typeof receiver === "undefined" ? "undefined" : (0, $6tOPT._)(receiver)) != "object") {
                    if (typeof receiver == "function") return J.JavaScriptFunction.prototype;
                    if ((typeof receiver === "undefined" ? "undefined" : (0, $6tOPT._)(receiver)) == "symbol") return J.JavaScriptSymbol.prototype;
                    if ((typeof receiver === "undefined" ? "undefined" : (0, $6tOPT._)(receiver)) == "bigint") return J.JavaScriptBigInt.prototype;
                    return receiver;
                }
                if (receiver instanceof A.Object) return receiver;
                return J.getNativeInterceptor(receiver);
            },
            getInterceptor$ax: function(receiver) {
                if (receiver == null) return receiver;
                if (Array.isArray(receiver)) return J.JSArray.prototype;
                if ((typeof receiver === "undefined" ? "undefined" : (0, $6tOPT._)(receiver)) != "object") {
                    if (typeof receiver == "function") return J.JavaScriptFunction.prototype;
                    if ((typeof receiver === "undefined" ? "undefined" : (0, $6tOPT._)(receiver)) == "symbol") return J.JavaScriptSymbol.prototype;
                    if ((typeof receiver === "undefined" ? "undefined" : (0, $6tOPT._)(receiver)) == "bigint") return J.JavaScriptBigInt.prototype;
                    return receiver;
                }
                if (receiver instanceof A.Object) return receiver;
                return J.getNativeInterceptor(receiver);
            },
            getInterceptor$in: function(receiver) {
                if (typeof receiver == "number") {
                    if (Math.floor(receiver) == receiver) return J.JSInt.prototype;
                    return J.JSNumNotInt.prototype;
                }
                if (receiver == null) return receiver;
                if (!(receiver instanceof A.Object)) return J.UnknownJavaScriptObject.prototype;
                return receiver;
            },
            getInterceptor$ns: function(receiver) {
                if (typeof receiver == "number") return J.JSNumber.prototype;
                if (typeof receiver == "string") return J.JSString.prototype;
                if (receiver == null) return receiver;
                if (!(receiver instanceof A.Object)) return J.UnknownJavaScriptObject.prototype;
                return receiver;
            },
            getInterceptor$s: function(receiver) {
                if (typeof receiver == "string") return J.JSString.prototype;
                if (receiver == null) return receiver;
                if (!(receiver instanceof A.Object)) return J.UnknownJavaScriptObject.prototype;
                return receiver;
            },
            getInterceptor$x: function(receiver) {
                if (receiver == null) return receiver;
                if ((typeof receiver === "undefined" ? "undefined" : (0, $6tOPT._)(receiver)) != "object") {
                    if (typeof receiver == "function") return J.JavaScriptFunction.prototype;
                    if ((typeof receiver === "undefined" ? "undefined" : (0, $6tOPT._)(receiver)) == "symbol") return J.JavaScriptSymbol.prototype;
                    if ((typeof receiver === "undefined" ? "undefined" : (0, $6tOPT._)(receiver)) == "bigint") return J.JavaScriptBigInt.prototype;
                    return receiver;
                }
                if (receiver instanceof A.Object) return receiver;
                return J.getNativeInterceptor(receiver);
            },
            getInterceptor$z: function(receiver) {
                if (receiver == null) return receiver;
                if (!(receiver instanceof A.Object)) return J.UnknownJavaScriptObject.prototype;
                return receiver;
            },
            set$AsyncCompiler$x: function(receiver, value) {
                return J.getInterceptor$x(receiver).set$AsyncCompiler(receiver, value);
            },
            set$CalculationInterpolation$x: function(receiver, value) {
                return J.getInterceptor$x(receiver).set$CalculationInterpolation(receiver, value);
            },
            set$CalculationOperation$x: function(receiver, value) {
                return J.getInterceptor$x(receiver).set$CalculationOperation(receiver, value);
            },
            set$Compiler$x: function(receiver, value) {
                return J.getInterceptor$x(receiver).set$Compiler(receiver, value);
            },
            set$Exception$x: function(receiver, value) {
                return J.getInterceptor$x(receiver).set$Exception(receiver, value);
            },
            set$FALSE$x: function(receiver, value) {
                return J.getInterceptor$x(receiver).set$FALSE(receiver, value);
            },
            set$Logger$x: function(receiver, value) {
                return J.getInterceptor$x(receiver).set$Logger(receiver, value);
            },
            set$NULL$x: function(receiver, value) {
                return J.getInterceptor$x(receiver).set$NULL(receiver, value);
            },
            set$NodePackageImporter$x: function(receiver, value) {
                return J.getInterceptor$x(receiver).set$NodePackageImporter(receiver, value);
            },
            set$SassArgumentList$x: function(receiver, value) {
                return J.getInterceptor$x(receiver).set$SassArgumentList(receiver, value);
            },
            set$SassBoolean$x: function(receiver, value) {
                return J.getInterceptor$x(receiver).set$SassBoolean(receiver, value);
            },
            set$SassCalculation$x: function(receiver, value) {
                return J.getInterceptor$x(receiver).set$SassCalculation(receiver, value);
            },
            set$SassColor$x: function(receiver, value) {
                return J.getInterceptor$x(receiver).set$SassColor(receiver, value);
            },
            set$SassFunction$x: function(receiver, value) {
                return J.getInterceptor$x(receiver).set$SassFunction(receiver, value);
            },
            set$SassList$x: function(receiver, value) {
                return J.getInterceptor$x(receiver).set$SassList(receiver, value);
            },
            set$SassMap$x: function(receiver, value) {
                return J.getInterceptor$x(receiver).set$SassMap(receiver, value);
            },
            set$SassMixin$x: function(receiver, value) {
                return J.getInterceptor$x(receiver).set$SassMixin(receiver, value);
            },
            set$SassNumber$x: function(receiver, value) {
                return J.getInterceptor$x(receiver).set$SassNumber(receiver, value);
            },
            set$SassString$x: function(receiver, value) {
                return J.getInterceptor$x(receiver).set$SassString(receiver, value);
            },
            set$TRUE$x: function(receiver, value) {
                return J.getInterceptor$x(receiver).set$TRUE(receiver, value);
            },
            set$Value$x: function(receiver, value) {
                return J.getInterceptor$x(receiver).set$Value(receiver, value);
            },
            set$Version$x: function(receiver, value) {
                return J.getInterceptor$x(receiver).set$Version(receiver, value);
            },
            set$cli_pkg_main_0_$x: function(receiver, value) {
                return J.getInterceptor$x(receiver).set$cli_pkg_main_0_(receiver, value);
            },
            set$compile$x: function(receiver, value) {
                return J.getInterceptor$x(receiver).set$compile(receiver, value);
            },
            set$compileAsync$x: function(receiver, value) {
                return J.getInterceptor$x(receiver).set$compileAsync(receiver, value);
            },
            set$compileString$x: function(receiver, value) {
                return J.getInterceptor$x(receiver).set$compileString(receiver, value);
            },
            set$compileStringAsync$x: function(receiver, value) {
                return J.getInterceptor$x(receiver).set$compileStringAsync(receiver, value);
            },
            set$context$x: function(receiver, value) {
                return J.getInterceptor$x(receiver).set$context(receiver, value);
            },
            set$dartValue$x: function(receiver, value) {
                return J.getInterceptor$x(receiver).set$dartValue(receiver, value);
            },
            set$deprecations$x: function(receiver, value) {
                return J.getInterceptor$x(receiver).set$deprecations(receiver, value);
            },
            set$exitCode$x: function(receiver, value) {
                return J.getInterceptor$x(receiver).set$exitCode(receiver, value);
            },
            set$info$x: function(receiver, value) {
                return J.getInterceptor$x(receiver).set$info(receiver, value);
            },
            set$initAsyncCompiler$x: function(receiver, value) {
                return J.getInterceptor$x(receiver).set$initAsyncCompiler(receiver, value);
            },
            set$initCompiler$x: function(receiver, value) {
                return J.getInterceptor$x(receiver).set$initCompiler(receiver, value);
            },
            set$length$asx: function(receiver, value) {
                return J.getInterceptor$asx(receiver).set$length(receiver, value);
            },
            set$loadParserExports_$x: function(receiver, value) {
                return J.getInterceptor$x(receiver).set$loadParserExports_(receiver, value);
            },
            set$render$x: function(receiver, value) {
                return J.getInterceptor$x(receiver).set$render(receiver, value);
            },
            set$renderSync$x: function(receiver, value) {
                return J.getInterceptor$x(receiver).set$renderSync(receiver, value);
            },
            set$sassFalse$x: function(receiver, value) {
                return J.getInterceptor$x(receiver).set$sassFalse(receiver, value);
            },
            set$sassNull$x: function(receiver, value) {
                return J.getInterceptor$x(receiver).set$sassNull(receiver, value);
            },
            set$sassTrue$x: function(receiver, value) {
                return J.getInterceptor$x(receiver).set$sassTrue(receiver, value);
            },
            set$types$x: function(receiver, value) {
                return J.getInterceptor$x(receiver).set$types(receiver, value);
            },
            get$$prototype$x: function(receiver) {
                return J.getInterceptor$x(receiver).get$$prototype(receiver);
            },
            get$_dartException$x: function(receiver) {
                return J.getInterceptor$x(receiver).get$_dartException(receiver);
            },
            get$alertAscii$x: function(receiver) {
                return J.getInterceptor$x(receiver).get$alertAscii(receiver);
            },
            get$alertColor$x: function(receiver) {
                return J.getInterceptor$x(receiver).get$alertColor(receiver);
            },
            get$argv$x: function(receiver) {
                return J.getInterceptor$x(receiver).get$argv(receiver);
            },
            get$brackets$x: function(receiver) {
                return J.getInterceptor$x(receiver).get$brackets(receiver);
            },
            get$charset$x: function(receiver) {
                return J.getInterceptor$x(receiver).get$charset(receiver);
            },
            get$code$x: function(receiver) {
                return J.getInterceptor$x(receiver).get$code(receiver);
            },
            get$current$x: function(receiver) {
                return J.getInterceptor$x(receiver).get$current(receiver);
            },
            get$dartValue$x: function(receiver) {
                return J.getInterceptor$x(receiver).get$dartValue(receiver);
            },
            get$debug$x: function(receiver) {
                return J.getInterceptor$x(receiver).get$debug(receiver);
            },
            get$denominatorUnits$x: function(receiver) {
                return J.getInterceptor$x(receiver).get$denominatorUnits(receiver);
            },
            get$env$x: function(receiver) {
                return J.getInterceptor$x(receiver).get$env(receiver);
            },
            get$exitCode$x: function(receiver) {
                return J.getInterceptor$x(receiver).get$exitCode(receiver);
            },
            get$fatalDeprecations$x: function(receiver) {
                return J.getInterceptor$x(receiver).get$fatalDeprecations(receiver);
            },
            get$fiber$x: function(receiver) {
                return J.getInterceptor$x(receiver).get$fiber(receiver);
            },
            get$file$x: function(receiver) {
                return J.getInterceptor$x(receiver).get$file(receiver);
            },
            get$filename$x: function(receiver) {
                return J.getInterceptor$x(receiver).get$filename(receiver);
            },
            get$first$ax: function(receiver) {
                return J.getInterceptor$ax(receiver).get$first(receiver);
            },
            get$functions$x: function(receiver) {
                return J.getInterceptor$x(receiver).get$functions(receiver);
            },
            get$futureDeprecations$x: function(receiver) {
                return J.getInterceptor$x(receiver).get$futureDeprecations(receiver);
            },
            get$hashCode$: function(receiver) {
                return J.getInterceptor$(receiver).get$hashCode(receiver);
            },
            get$id$x: function(receiver) {
                return J.getInterceptor$x(receiver).get$id(receiver);
            },
            get$importer$x: function(receiver) {
                return J.getInterceptor$x(receiver).get$importer(receiver);
            },
            get$importers$x: function(receiver) {
                return J.getInterceptor$x(receiver).get$importers(receiver);
            },
            get$isEmpty$asx: function(receiver) {
                return J.getInterceptor$asx(receiver).get$isEmpty(receiver);
            },
            get$isNotEmpty$asx: function(receiver) {
                return J.getInterceptor$asx(receiver).get$isNotEmpty(receiver);
            },
            get$isTTY$x: function(receiver) {
                return J.getInterceptor$x(receiver).get$isTTY(receiver);
            },
            get$iterator$ax: function(receiver) {
                return J.getInterceptor$ax(receiver).get$iterator(receiver);
            },
            get$last$ax: function(receiver) {
                return J.getInterceptor$ax(receiver).get$last(receiver);
            },
            get$length$asx: function(receiver) {
                return J.getInterceptor$asx(receiver).get$length(receiver);
            },
            get$loadPaths$x: function(receiver) {
                return J.getInterceptor$x(receiver).get$loadPaths(receiver);
            },
            get$logger$x: function(receiver) {
                return J.getInterceptor$x(receiver).get$logger(receiver);
            },
            get$message$x: function(receiver) {
                return J.getInterceptor$x(receiver).get$message(receiver);
            },
            get$method$x: function(receiver) {
                return J.getInterceptor$x(receiver).get$method(receiver);
            },
            get$mtime$x: function(receiver) {
                return J.getInterceptor$x(receiver).get$mtime(receiver);
            },
            get$name$x: function(receiver) {
                return J.getInterceptor$x(receiver).get$name(receiver);
            },
            get$numeratorUnits$x: function(receiver) {
                return J.getInterceptor$x(receiver).get$numeratorUnits(receiver);
            },
            get$options$x: function(receiver) {
                return J.getInterceptor$x(receiver).get$options(receiver);
            },
            get$parent$z: function(receiver) {
                return J.getInterceptor$z(receiver).get$parent(receiver);
            },
            get$path$x: function(receiver) {
                return J.getInterceptor$x(receiver).get$path(receiver);
            },
            get$platform$x: function(receiver) {
                return J.getInterceptor$x(receiver).get$platform(receiver);
            },
            get$quietDeps$x: function(receiver) {
                return J.getInterceptor$x(receiver).get$quietDeps(receiver);
            },
            get$quotes$x: function(receiver) {
                return J.getInterceptor$x(receiver).get$quotes(receiver);
            },
            get$realpathSync$x: function(receiver) {
                return J.getInterceptor$x(receiver).get$realpathSync(receiver);
            },
            get$release$x: function(receiver) {
                return J.getInterceptor$x(receiver).get$release(receiver);
            },
            get$reversed$ax: function(receiver) {
                return J.getInterceptor$ax(receiver).get$reversed(receiver);
            },
            get$runtimeType$: function(receiver) {
                return J.getInterceptor$(receiver).get$runtimeType(receiver);
            },
            get$separator$x: function(receiver) {
                return J.getInterceptor$x(receiver).get$separator(receiver);
            },
            get$sign$in: function(receiver) {
                if (typeof receiver === "number") return receiver > 0 ? 1 : receiver < 0 ? -1 : receiver;
                return J.getInterceptor$in(receiver).get$sign(receiver);
            },
            get$silenceDeprecations$x: function(receiver) {
                return J.getInterceptor$x(receiver).get$silenceDeprecations(receiver);
            },
            get$single$ax: function(receiver) {
                return J.getInterceptor$ax(receiver).get$single(receiver);
            },
            get$sourceMap$x: function(receiver) {
                return J.getInterceptor$x(receiver).get$sourceMap(receiver);
            },
            get$sourceMapIncludeSources$x: function(receiver) {
                return J.getInterceptor$x(receiver).get$sourceMapIncludeSources(receiver);
            },
            get$space$x: function(receiver) {
                return J.getInterceptor$x(receiver).get$space(receiver);
            },
            get$span$x: function(receiver) {
                return J.getInterceptor$x(receiver).get$span(receiver);
            },
            get$stderr$x: function(receiver) {
                return J.getInterceptor$x(receiver).get$stderr(receiver);
            },
            get$stdout$x: function(receiver) {
                return J.getInterceptor$x(receiver).get$stdout(receiver);
            },
            get$style$x: function(receiver) {
                return J.getInterceptor$x(receiver).get$style(receiver);
            },
            get$syntax$x: function(receiver) {
                return J.getInterceptor$x(receiver).get$syntax(receiver);
            },
            get$trace$z: function(receiver) {
                return J.getInterceptor$z(receiver).get$trace(receiver);
            },
            get$url$x: function(receiver) {
                return J.getInterceptor$x(receiver).get$url(receiver);
            },
            get$verbose$x: function(receiver) {
                return J.getInterceptor$x(receiver).get$verbose(receiver);
            },
            get$warn$x: function(receiver) {
                return J.getInterceptor$x(receiver).get$warn(receiver);
            },
            get$weight$x: function(receiver) {
                return J.getInterceptor$x(receiver).get$weight(receiver);
            },
            $add$ansx: function(receiver, a0) {
                if (typeof receiver == "number" && typeof a0 == "number") return receiver + a0;
                return J.getInterceptor$ansx(receiver).$add(receiver, a0);
            },
            $eq$: function(receiver, a0) {
                if (receiver == null) return a0 == null;
                if ((typeof receiver === "undefined" ? "undefined" : (0, $6tOPT._)(receiver)) != "object") return a0 != null && receiver === a0;
                return J.getInterceptor$(receiver).$eq(receiver, a0);
            },
            $index$asx: function(receiver, a0) {
                if (typeof a0 === "number") {
                    if (Array.isArray(receiver) || typeof receiver == "string" || A.isJsIndexable(receiver, receiver[init.dispatchPropertyName])) {
                        if (a0 >>> 0 === a0 && a0 < receiver.length) return receiver[a0];
                    }
                }
                return J.getInterceptor$asx(receiver).$index(receiver, a0);
            },
            $indexSet$ax: function(receiver, a0, a1) {
                if (typeof a0 === "number") {
                    if ((Array.isArray(receiver) || A.isJsIndexable(receiver, receiver[init.dispatchPropertyName])) && !(receiver.$flags & 2) && a0 >>> 0 === a0 && a0 < receiver.length) return receiver[a0] = a1;
                }
                return J.getInterceptor$ax(receiver).$indexSet(receiver, a0, a1);
            },
            $set$2$x: function(receiver, a0, a1) {
                return J.getInterceptor$x(receiver).$set$2(receiver, a0, a1);
            },
            add$1$ax: function(receiver, a0) {
                return J.getInterceptor$ax(receiver).add$1(receiver, a0);
            },
            addAll$1$ax: function(receiver, a0) {
                return J.getInterceptor$ax(receiver).addAll$1(receiver, a0);
            },
            allMatches$1$s: function(receiver, a0) {
                return J.getInterceptor$s(receiver).allMatches$1(receiver, a0);
            },
            allMatches$2$s: function(receiver, a0, a1) {
                return J.getInterceptor$s(receiver).allMatches$2(receiver, a0, a1);
            },
            any$1$ax: function(receiver, a0) {
                return J.getInterceptor$ax(receiver).any$1(receiver, a0);
            },
            apply$2$x: function(receiver, a0, a1) {
                return J.getInterceptor$x(receiver).apply$2(receiver, a0, a1);
            },
            asImmutable$0$x: function(receiver) {
                return J.getInterceptor$x(receiver).asImmutable$0(receiver);
            },
            asMutable$0$x: function(receiver) {
                return J.getInterceptor$x(receiver).asMutable$0(receiver);
            },
            canonicalize$4$baseImporter$baseUrl$forImport$x: function(receiver, a0, a1, a2, a3) {
                return J.getInterceptor$x(receiver).canonicalize$4$baseImporter$baseUrl$forImport(receiver, a0, a1, a2, a3);
            },
            cast$1$0$ax: function(receiver, $T1) {
                return J.getInterceptor$ax(receiver).cast$1$0(receiver, $T1);
            },
            close$0$x: function(receiver) {
                return J.getInterceptor$x(receiver).close$0(receiver);
            },
            codeUnitAt$1$s: function(receiver, a0) {
                return J.getInterceptor$s(receiver).codeUnitAt$1(receiver, a0);
            },
            compareTo$1$ns: function(receiver, a0) {
                return J.getInterceptor$ns(receiver).compareTo$1(receiver, a0);
            },
            contains$1$asx: function(receiver, a0) {
                return J.getInterceptor$asx(receiver).contains$1(receiver, a0);
            },
            createInterface$1$x: function(receiver, a0) {
                return J.getInterceptor$x(receiver).createInterface$1(receiver, a0);
            },
            createRequire$1$x: function(receiver, a0) {
                return J.getInterceptor$x(receiver).createRequire$1(receiver, a0);
            },
            elementAt$1$ax: function(receiver, a0) {
                return J.getInterceptor$ax(receiver).elementAt$1(receiver, a0);
            },
            error$1$x: function(receiver, a0) {
                return J.getInterceptor$x(receiver).error$1(receiver, a0);
            },
            every$1$ax: function(receiver, a0) {
                return J.getInterceptor$ax(receiver).every$1(receiver, a0);
            },
            existsSync$1$x: function(receiver, a0) {
                return J.getInterceptor$x(receiver).existsSync$1(receiver, a0);
            },
            expand$1$1$ax: function(receiver, a0, $T1) {
                return J.getInterceptor$ax(receiver).expand$1$1(receiver, a0, $T1);
            },
            fillRange$3$ax: function(receiver, a0, a1, a2) {
                return J.getInterceptor$ax(receiver).fillRange$3(receiver, a0, a1, a2);
            },
            fold$2$ax: function(receiver, a0, a1) {
                return J.getInterceptor$ax(receiver).fold$2(receiver, a0, a1);
            },
            forEach$1$ax: function(receiver, a0) {
                return J.getInterceptor$ax(receiver).forEach$1(receiver, a0);
            },
            getRange$2$ax: function(receiver, a0, a1) {
                return J.getInterceptor$ax(receiver).getRange$2(receiver, a0, a1);
            },
            getTime$0$x: function(receiver) {
                return J.getInterceptor$x(receiver).getTime$0(receiver);
            },
            isDirectory$0$x: function(receiver) {
                return J.getInterceptor$x(receiver).isDirectory$0(receiver);
            },
            isFile$0$x: function(receiver) {
                return J.getInterceptor$x(receiver).isFile$0(receiver);
            },
            isSymbolicLink$0$x: function(receiver) {
                return J.getInterceptor$x(receiver).isSymbolicLink$0(receiver);
            },
            join$1$ax: function(receiver, a0) {
                return J.getInterceptor$ax(receiver).join$1(receiver, a0);
            },
            log$1$x: function(receiver, a0) {
                return J.getInterceptor$x(receiver).log$1(receiver, a0);
            },
            lstatSync$1$x: function(receiver, a0) {
                return J.getInterceptor$x(receiver).lstatSync$1(receiver, a0);
            },
            map$1$1$ax: function(receiver, a0, $T1) {
                return J.getInterceptor$ax(receiver).map$1$1(receiver, a0, $T1);
            },
            matchAsPrefix$2$s: function(receiver, a0, a1) {
                return J.getInterceptor$s(receiver).matchAsPrefix$2(receiver, a0, a1);
            },
            mkdirSync$1$x: function(receiver, a0) {
                return J.getInterceptor$x(receiver).mkdirSync$1(receiver, a0);
            },
            native$1$x: function(receiver, a0) {
                return J.getInterceptor$x(receiver).native$1(receiver, a0);
            },
            noSuchMethod$1$: function(receiver, a0) {
                return J.getInterceptor$(receiver).noSuchMethod$1(receiver, a0);
            },
            on$2$x: function(receiver, a0, a1) {
                return J.getInterceptor$x(receiver).on$2(receiver, a0, a1);
            },
            parse$0$z: function(receiver) {
                return J.getInterceptor$z(receiver).parse$0(receiver);
            },
            readFileSync$2$x: function(receiver, a0, a1) {
                return J.getInterceptor$x(receiver).readFileSync$2(receiver, a0, a1);
            },
            readdirSync$1$x: function(receiver, a0) {
                return J.getInterceptor$x(receiver).readdirSync$1(receiver, a0);
            },
            removeRange$2$ax: function(receiver, a0, a1) {
                return J.getInterceptor$ax(receiver).removeRange$2(receiver, a0, a1);
            },
            replaceFirst$2$s: function(receiver, a0, a1) {
                return J.getInterceptor$s(receiver).replaceFirst$2(receiver, a0, a1);
            },
            resolve$1$x: function(receiver, a0) {
                return J.getInterceptor$x(receiver).resolve$1(receiver, a0);
            },
            run$0$x: function(receiver) {
                return J.getInterceptor$x(receiver).run$0(receiver);
            },
            run$1$x: function(receiver, a0) {
                return J.getInterceptor$x(receiver).run$1(receiver, a0);
            },
            setRange$4$ax: function(receiver, a0, a1, a2, a3) {
                return J.getInterceptor$ax(receiver).setRange$4(receiver, a0, a1, a2, a3);
            },
            skip$1$ax: function(receiver, a0) {
                return J.getInterceptor$ax(receiver).skip$1(receiver, a0);
            },
            sort$1$ax: function(receiver, a0) {
                return J.getInterceptor$ax(receiver).sort$1(receiver, a0);
            },
            startsWith$1$s: function(receiver, a0) {
                return J.getInterceptor$s(receiver).startsWith$1(receiver, a0);
            },
            statSync$1$x: function(receiver, a0) {
                return J.getInterceptor$x(receiver).statSync$1(receiver, a0);
            },
            sublist$1$ax: function(receiver, a0) {
                return J.getInterceptor$ax(receiver).sublist$1(receiver, a0);
            },
            substring$2$s: function(receiver, a0, a1) {
                return J.getInterceptor$s(receiver).substring$2(receiver, a0, a1);
            },
            take$1$ax: function(receiver, a0) {
                return J.getInterceptor$ax(receiver).take$1(receiver, a0);
            },
            then$1$2$onError$x: function(receiver, a0, a1, $T1) {
                return J.getInterceptor$x(receiver).then$1$2$onError(receiver, a0, a1, $T1);
            },
            then$2$x: function(receiver, a0, a1) {
                return J.getInterceptor$x(receiver).then$2(receiver, a0, a1);
            },
            toArray$0$x: function(receiver) {
                return J.getInterceptor$x(receiver).toArray$0(receiver);
            },
            toList$0$ax: function(receiver) {
                return J.getInterceptor$ax(receiver).toList$0(receiver);
            },
            toString$0$: function(receiver) {
                return J.getInterceptor$(receiver).toString$0(receiver);
            },
            toString$1$color$: function(receiver, a0) {
                return J.getInterceptor$(receiver).toString$1$color(receiver, a0);
            },
            trim$0$s: function(receiver) {
                return J.getInterceptor$s(receiver).trim$0(receiver);
            },
            unlinkSync$1$x: function(receiver, a0) {
                return J.getInterceptor$x(receiver).unlinkSync$1(receiver, a0);
            },
            visitAtRootRule$1$x: function(receiver, a0) {
                return J.getInterceptor$x(receiver).visitAtRootRule$1(receiver, a0);
            },
            visitAtRule$1$x: function(receiver, a0) {
                return J.getInterceptor$x(receiver).visitAtRule$1(receiver, a0);
            },
            visitAttributeSelector$1$x: function(receiver, a0) {
                return J.getInterceptor$x(receiver).visitAttributeSelector$1(receiver, a0);
            },
            visitBinaryOperationExpression$1$x: function(receiver, a0) {
                return J.getInterceptor$x(receiver).visitBinaryOperationExpression$1(receiver, a0);
            },
            visitBooleanExpression$1$x: function(receiver, a0) {
                return J.getInterceptor$x(receiver).visitBooleanExpression$1(receiver, a0);
            },
            visitClassSelector$1$x: function(receiver, a0) {
                return J.getInterceptor$x(receiver).visitClassSelector$1(receiver, a0);
            },
            visitColorExpression$1$x: function(receiver, a0) {
                return J.getInterceptor$x(receiver).visitColorExpression$1(receiver, a0);
            },
            visitContentBlock$1$x: function(receiver, a0) {
                return J.getInterceptor$x(receiver).visitContentBlock$1(receiver, a0);
            },
            visitContentRule$1$x: function(receiver, a0) {
                return J.getInterceptor$x(receiver).visitContentRule$1(receiver, a0);
            },
            visitDebugRule$1$x: function(receiver, a0) {
                return J.getInterceptor$x(receiver).visitDebugRule$1(receiver, a0);
            },
            visitDeclaration$1$x: function(receiver, a0) {
                return J.getInterceptor$x(receiver).visitDeclaration$1(receiver, a0);
            },
            visitEachRule$1$x: function(receiver, a0) {
                return J.getInterceptor$x(receiver).visitEachRule$1(receiver, a0);
            },
            visitErrorRule$1$x: function(receiver, a0) {
                return J.getInterceptor$x(receiver).visitErrorRule$1(receiver, a0);
            },
            visitExtendRule$1$x: function(receiver, a0) {
                return J.getInterceptor$x(receiver).visitExtendRule$1(receiver, a0);
            },
            visitForRule$1$x: function(receiver, a0) {
                return J.getInterceptor$x(receiver).visitForRule$1(receiver, a0);
            },
            visitForwardRule$1$x: function(receiver, a0) {
                return J.getInterceptor$x(receiver).visitForwardRule$1(receiver, a0);
            },
            visitFunctionExpression$1$x: function(receiver, a0) {
                return J.getInterceptor$x(receiver).visitFunctionExpression$1(receiver, a0);
            },
            visitFunctionRule$1$x: function(receiver, a0) {
                return J.getInterceptor$x(receiver).visitFunctionRule$1(receiver, a0);
            },
            visitIDSelector$1$x: function(receiver, a0) {
                return J.getInterceptor$x(receiver).visitIDSelector$1(receiver, a0);
            },
            visitIfConditionFunction$1$x: function(receiver, a0) {
                return J.getInterceptor$x(receiver).visitIfConditionFunction$1(receiver, a0);
            },
            visitIfConditionNegation$1$x: function(receiver, a0) {
                return J.getInterceptor$x(receiver).visitIfConditionNegation$1(receiver, a0);
            },
            visitIfConditionOperation$1$x: function(receiver, a0) {
                return J.getInterceptor$x(receiver).visitIfConditionOperation$1(receiver, a0);
            },
            visitIfConditionParenthesized$1$x: function(receiver, a0) {
                return J.getInterceptor$x(receiver).visitIfConditionParenthesized$1(receiver, a0);
            },
            visitIfConditionRaw$1$x: function(receiver, a0) {
                return J.getInterceptor$x(receiver).visitIfConditionRaw$1(receiver, a0);
            },
            visitIfConditionSass$1$x: function(receiver, a0) {
                return J.getInterceptor$x(receiver).visitIfConditionSass$1(receiver, a0);
            },
            visitIfExpression$1$x: function(receiver, a0) {
                return J.getInterceptor$x(receiver).visitIfExpression$1(receiver, a0);
            },
            visitIfRule$1$x: function(receiver, a0) {
                return J.getInterceptor$x(receiver).visitIfRule$1(receiver, a0);
            },
            visitImportRule$1$x: function(receiver, a0) {
                return J.getInterceptor$x(receiver).visitImportRule$1(receiver, a0);
            },
            visitIncludeRule$1$x: function(receiver, a0) {
                return J.getInterceptor$x(receiver).visitIncludeRule$1(receiver, a0);
            },
            visitInterpolatedFunctionExpression$1$x: function(receiver, a0) {
                return J.getInterceptor$x(receiver).visitInterpolatedFunctionExpression$1(receiver, a0);
            },
            visitLegacyIfExpression$1$x: function(receiver, a0) {
                return J.getInterceptor$x(receiver).visitLegacyIfExpression$1(receiver, a0);
            },
            visitListExpression$1$x: function(receiver, a0) {
                return J.getInterceptor$x(receiver).visitListExpression$1(receiver, a0);
            },
            visitLoudComment$1$x: function(receiver, a0) {
                return J.getInterceptor$x(receiver).visitLoudComment$1(receiver, a0);
            },
            visitMapExpression$1$x: function(receiver, a0) {
                return J.getInterceptor$x(receiver).visitMapExpression$1(receiver, a0);
            },
            visitMediaRule$1$x: function(receiver, a0) {
                return J.getInterceptor$x(receiver).visitMediaRule$1(receiver, a0);
            },
            visitMixinRule$1$x: function(receiver, a0) {
                return J.getInterceptor$x(receiver).visitMixinRule$1(receiver, a0);
            },
            visitNullExpression$1$x: function(receiver, a0) {
                return J.getInterceptor$x(receiver).visitNullExpression$1(receiver, a0);
            },
            visitNumberExpression$1$x: function(receiver, a0) {
                return J.getInterceptor$x(receiver).visitNumberExpression$1(receiver, a0);
            },
            visitParentSelector$1$x: function(receiver, a0) {
                return J.getInterceptor$x(receiver).visitParentSelector$1(receiver, a0);
            },
            visitParenthesizedExpression$1$x: function(receiver, a0) {
                return J.getInterceptor$x(receiver).visitParenthesizedExpression$1(receiver, a0);
            },
            visitPlaceholderSelector$1$x: function(receiver, a0) {
                return J.getInterceptor$x(receiver).visitPlaceholderSelector$1(receiver, a0);
            },
            visitPseudoSelector$1$x: function(receiver, a0) {
                return J.getInterceptor$x(receiver).visitPseudoSelector$1(receiver, a0);
            },
            visitReturnRule$1$x: function(receiver, a0) {
                return J.getInterceptor$x(receiver).visitReturnRule$1(receiver, a0);
            },
            visitSelectorExpression$1$x: function(receiver, a0) {
                return J.getInterceptor$x(receiver).visitSelectorExpression$1(receiver, a0);
            },
            visitSilentComment$1$x: function(receiver, a0) {
                return J.getInterceptor$x(receiver).visitSilentComment$1(receiver, a0);
            },
            visitStringExpression$1$x: function(receiver, a0) {
                return J.getInterceptor$x(receiver).visitStringExpression$1(receiver, a0);
            },
            visitStyleRule$1$x: function(receiver, a0) {
                return J.getInterceptor$x(receiver).visitStyleRule$1(receiver, a0);
            },
            visitStylesheet$1$x: function(receiver, a0) {
                return J.getInterceptor$x(receiver).visitStylesheet$1(receiver, a0);
            },
            visitSupportsExpression$1$x: function(receiver, a0) {
                return J.getInterceptor$x(receiver).visitSupportsExpression$1(receiver, a0);
            },
            visitSupportsRule$1$x: function(receiver, a0) {
                return J.getInterceptor$x(receiver).visitSupportsRule$1(receiver, a0);
            },
            visitTypeSelector$1$x: function(receiver, a0) {
                return J.getInterceptor$x(receiver).visitTypeSelector$1(receiver, a0);
            },
            visitUnaryOperationExpression$1$x: function(receiver, a0) {
                return J.getInterceptor$x(receiver).visitUnaryOperationExpression$1(receiver, a0);
            },
            visitUniversalSelector$1$x: function(receiver, a0) {
                return J.getInterceptor$x(receiver).visitUniversalSelector$1(receiver, a0);
            },
            visitUseRule$1$x: function(receiver, a0) {
                return J.getInterceptor$x(receiver).visitUseRule$1(receiver, a0);
            },
            visitValueExpression$1$x: function(receiver, a0) {
                return J.getInterceptor$x(receiver).visitValueExpression$1(receiver, a0);
            },
            visitVariableDeclaration$1$x: function(receiver, a0) {
                return J.getInterceptor$x(receiver).visitVariableDeclaration$1(receiver, a0);
            },
            visitVariableExpression$1$x: function(receiver, a0) {
                return J.getInterceptor$x(receiver).visitVariableExpression$1(receiver, a0);
            },
            visitWarnRule$1$x: function(receiver, a0) {
                return J.getInterceptor$x(receiver).visitWarnRule$1(receiver, a0);
            },
            visitWhileRule$1$x: function(receiver, a0) {
                return J.getInterceptor$x(receiver).visitWhileRule$1(receiver, a0);
            },
            watch$2$x: function(receiver, a0, a1) {
                return J.getInterceptor$x(receiver).watch$2(receiver, a0, a1);
            },
            where$1$ax: function(receiver, a0) {
                return J.getInterceptor$ax(receiver).where$1(receiver, a0);
            },
            write$1$x: function(receiver, a0) {
                return J.getInterceptor$x(receiver).write$1(receiver, a0);
            },
            writeFileSync$2$x: function(receiver, a0, a1) {
                return J.getInterceptor$x(receiver).writeFileSync$2(receiver, a0, a1);
            },
            yield$0$x: function(receiver) {
                return J.getInterceptor$x(receiver).yield$0(receiver);
            },
            Interceptor: function Interceptor() {},
            JSBool: function JSBool() {},
            JSNull: function JSNull() {},
            JavaScriptObject: function JavaScriptObject() {},
            LegacyJavaScriptObject: function LegacyJavaScriptObject() {},
            PlainJavaScriptObject: function PlainJavaScriptObject() {},
            UnknownJavaScriptObject: function UnknownJavaScriptObject() {},
            JavaScriptFunction: function JavaScriptFunction() {},
            JavaScriptBigInt: function JavaScriptBigInt() {},
            JavaScriptSymbol: function JavaScriptSymbol() {},
            JSArray: function JSArray(t0) {
                this.$ti = t0;
            },
            JSArraySafeToStringHook: function JSArraySafeToStringHook() {},
            JSUnmodifiableArray: function JSUnmodifiableArray(t0) {
                this.$ti = t0;
            },
            ArrayIterator: function ArrayIterator(t0, t1, t2) {
                var _ = this;
                _._iterable = t0;
                _._length = t1;
                _._index = 0;
                _._current = null;
                _.$ti = t2;
            },
            JSNumber: function JSNumber() {},
            JSInt: function JSInt() {},
            JSNumNotInt: function JSNumNotInt() {},
            JSString: function JSString() {}
        }, A = {
            JS_CONST: function JS_CONST() {},
            CastIterable_CastIterable: function(source, $S, $T) {
                if (type$.EfficientLengthIterable_dynamic._is(source)) return new A._EfficientLengthCastIterable(source, $S._eval$1("@<0>")._bind$1($T)._eval$1("_EfficientLengthCastIterable<1,2>"));
                return new A.CastIterable(source, $S._eval$1("@<0>")._bind$1($T)._eval$1("CastIterable<1,2>"));
            },
            LateError$fieldADI: function(fieldName) {
                return new A.LateError("Field '" + fieldName + "' has been assigned during initialization.");
            },
            LateError$fieldNI: function(fieldName) {
                return new A.LateError("Field '" + fieldName + "' has not been initialized.");
            },
            LateError$localNI: function(localName) {
                return new A.LateError("Local '" + localName + "' has not been initialized.");
            },
            LateError$fieldAI: function(fieldName) {
                return new A.LateError("Field '" + fieldName + "' has already been initialized.");
            },
            hexDigitValue: function(char) {
                var letter, digit = char ^ 48;
                if (digit <= 9) return digit;
                letter = char | 32;
                if (97 <= letter && letter <= 102) return letter - 87;
                return -1;
            },
            SystemHash_combine: function(hash, value) {
                hash = hash + value & 536870911;
                hash = hash + ((hash & 524287) << 10) & 536870911;
                return hash ^ hash >>> 6;
            },
            SystemHash_finish: function(hash) {
                hash = hash + ((hash & 67108863) << 3) & 536870911;
                hash ^= hash >>> 11;
                return hash + ((hash & 16383) << 15) & 536870911;
            },
            checkNotNullable: function(value, $name, $T) {
                return value;
            },
            isToStringVisiting: function(object) {
                var t1, i;
                for(t1 = $._toStringVisiting.length, i = 0; i < t1; ++i)if (object === $._toStringVisiting[i]) return true;
                return false;
            },
            SubListIterable$: function(_iterable, _start, _endOrLength, $E) {
                A.RangeError_checkNotNegative(_start, "start");
                if (_endOrLength != null) {
                    A.RangeError_checkNotNegative(_endOrLength, "end");
                    if (_start > _endOrLength) A.throwExpression(A.RangeError$range(_start, 0, _endOrLength, "start", null));
                }
                return new A.SubListIterable(_iterable, _start, _endOrLength, $E._eval$1("SubListIterable<0>"));
            },
            MappedIterable_MappedIterable: function(iterable, $function, $S, $T) {
                if (type$.EfficientLengthIterable_dynamic._is(iterable)) return new A.EfficientLengthMappedIterable(iterable, $function, $S._eval$1("@<0>")._bind$1($T)._eval$1("EfficientLengthMappedIterable<1,2>"));
                return new A.MappedIterable(iterable, $function, $S._eval$1("@<0>")._bind$1($T)._eval$1("MappedIterable<1,2>"));
            },
            TakeIterable_TakeIterable: function(iterable, takeCount, $E) {
                var _s9_ = "takeCount";
                A.ArgumentError_checkNotNull(takeCount, _s9_);
                A.RangeError_checkNotNegative(takeCount, _s9_);
                if (type$.EfficientLengthIterable_dynamic._is(iterable)) return new A.EfficientLengthTakeIterable(iterable, takeCount, $E._eval$1("EfficientLengthTakeIterable<0>"));
                return new A.TakeIterable(iterable, takeCount, $E._eval$1("TakeIterable<0>"));
            },
            SkipIterable_SkipIterable: function(iterable, count, $E) {
                var _s5_ = "count";
                if (type$.EfficientLengthIterable_dynamic._is(iterable)) {
                    A.ArgumentError_checkNotNull(count, _s5_);
                    A.RangeError_checkNotNegative(count, _s5_);
                    return new A.EfficientLengthSkipIterable(iterable, count, $E._eval$1("EfficientLengthSkipIterable<0>"));
                }
                A.ArgumentError_checkNotNull(count, _s5_);
                A.RangeError_checkNotNegative(count, _s5_);
                return new A.SkipIterable(iterable, count, $E._eval$1("SkipIterable<0>"));
            },
            FollowedByIterable_FollowedByIterable$firstEfficient: function(first, second, $E) {
                if (type$.EfficientLengthIterable_dynamic._is(second)) return new A.EfficientLengthFollowedByIterable(first, second, $E._eval$1("EfficientLengthFollowedByIterable<0>"));
                return new A.FollowedByIterable(first, second, $E._eval$1("FollowedByIterable<0>"));
            },
            IterableElementError_noElement: function() {
                return new A.StateError("No element");
            },
            IterableElementError_tooMany: function() {
                return new A.StateError("Too many elements");
            },
            IterableElementError_tooFew: function() {
                return new A.StateError("Too few elements");
            },
            Sort__doSort: function(a, left, right, compare) {
                if (right - left <= 32) A.Sort__insertionSort(a, left, right, compare);
                else A.Sort__dualPivotQuicksort(a, left, right, compare);
            },
            Sort__insertionSort: function(a, left, right, compare) {
                var i, t1, el, j, j0;
                for(i = left + 1, t1 = J.getInterceptor$asx(a); i <= right; ++i){
                    el = t1.$index(a, i);
                    j = i;
                    for(;;){
                        if (!(j > left && compare.call$2(t1.$index(a, j - 1), el) > 0)) break;
                        j0 = j - 1;
                        t1.$indexSet(a, j, t1.$index(a, j0));
                        j = j0;
                    }
                    t1.$indexSet(a, j, el);
                }
            },
            Sort__dualPivotQuicksort: function(a, left, right, compare) {
                var t0, less, great, pivots_are_equal, k, ak, comp, great0, less0, t2, sixth = B.JSInt_methods._tdivFast$1(right - left + 1, 6), index1 = left + sixth, index5 = right - sixth, index3 = B.JSInt_methods._tdivFast$1(left + right, 2), index2 = index3 - sixth, index4 = index3 + sixth, t1 = J.getInterceptor$asx(a), el1 = t1.$index(a, index1), el2 = t1.$index(a, index2), el3 = t1.$index(a, index3), el4 = t1.$index(a, index4), el5 = t1.$index(a, index5);
                if (compare.call$2(el1, el2) > 0) {
                    t0 = el2;
                    el2 = el1;
                    el1 = t0;
                }
                if (compare.call$2(el4, el5) > 0) {
                    t0 = el5;
                    el5 = el4;
                    el4 = t0;
                }
                if (compare.call$2(el1, el3) > 0) {
                    t0 = el3;
                    el3 = el1;
                    el1 = t0;
                }
                if (compare.call$2(el2, el3) > 0) {
                    t0 = el3;
                    el3 = el2;
                    el2 = t0;
                }
                if (compare.call$2(el1, el4) > 0) {
                    t0 = el4;
                    el4 = el1;
                    el1 = t0;
                }
                if (compare.call$2(el3, el4) > 0) {
                    t0 = el4;
                    el4 = el3;
                    el3 = t0;
                }
                if (compare.call$2(el2, el5) > 0) {
                    t0 = el5;
                    el5 = el2;
                    el2 = t0;
                }
                if (compare.call$2(el2, el3) > 0) {
                    t0 = el3;
                    el3 = el2;
                    el2 = t0;
                }
                if (compare.call$2(el4, el5) > 0) {
                    t0 = el5;
                    el5 = el4;
                    el4 = t0;
                }
                t1.$indexSet(a, index1, el1);
                t1.$indexSet(a, index3, el3);
                t1.$indexSet(a, index5, el5);
                t1.$indexSet(a, index2, t1.$index(a, left));
                t1.$indexSet(a, index4, t1.$index(a, right));
                less = left + 1;
                great = right - 1;
                pivots_are_equal = J.$eq$(compare.call$2(el2, el4), 0);
                if (pivots_are_equal) for(k = less; k <= great; ++k){
                    ak = t1.$index(a, k);
                    comp = compare.call$2(ak, el2);
                    if (comp === 0) continue;
                    if (comp < 0) {
                        if (k !== less) {
                            t1.$indexSet(a, k, t1.$index(a, less));
                            t1.$indexSet(a, less, ak);
                        }
                        ++less;
                    } else for(;;){
                        comp = compare.call$2(t1.$index(a, great), el2);
                        if (comp > 0) {
                            --great;
                            continue;
                        } else {
                            great0 = great - 1;
                            if (comp < 0) {
                                t1.$indexSet(a, k, t1.$index(a, less));
                                less0 = less + 1;
                                t1.$indexSet(a, less, t1.$index(a, great));
                                t1.$indexSet(a, great, ak);
                                great = great0;
                                less = less0;
                                break;
                            } else {
                                t1.$indexSet(a, k, t1.$index(a, great));
                                t1.$indexSet(a, great, ak);
                                great = great0;
                                break;
                            }
                        }
                    }
                }
                else for(k = less; k <= great; ++k){
                    ak = t1.$index(a, k);
                    if (compare.call$2(ak, el2) < 0) {
                        if (k !== less) {
                            t1.$indexSet(a, k, t1.$index(a, less));
                            t1.$indexSet(a, less, ak);
                        }
                        ++less;
                    } else if (compare.call$2(ak, el4) > 0) for(;;)if (compare.call$2(t1.$index(a, great), el4) > 0) {
                        --great;
                        if (great < k) break;
                        continue;
                    } else {
                        great0 = great - 1;
                        if (compare.call$2(t1.$index(a, great), el2) < 0) {
                            t1.$indexSet(a, k, t1.$index(a, less));
                            less0 = less + 1;
                            t1.$indexSet(a, less, t1.$index(a, great));
                            t1.$indexSet(a, great, ak);
                            less = less0;
                        } else {
                            t1.$indexSet(a, k, t1.$index(a, great));
                            t1.$indexSet(a, great, ak);
                        }
                        great = great0;
                        break;
                    }
                }
                t2 = less - 1;
                t1.$indexSet(a, left, t1.$index(a, t2));
                t1.$indexSet(a, t2, el2);
                t2 = great + 1;
                t1.$indexSet(a, right, t1.$index(a, t2));
                t1.$indexSet(a, t2, el4);
                A.Sort__doSort(a, left, less - 2, compare);
                A.Sort__doSort(a, great + 2, right, compare);
                if (pivots_are_equal) return;
                if (less < index1 && great > index5) {
                    while(J.$eq$(compare.call$2(t1.$index(a, less), el2), 0))++less;
                    while(J.$eq$(compare.call$2(t1.$index(a, great), el4), 0))--great;
                    for(k = less; k <= great; ++k){
                        ak = t1.$index(a, k);
                        if (compare.call$2(ak, el2) === 0) {
                            if (k !== less) {
                                t1.$indexSet(a, k, t1.$index(a, less));
                                t1.$indexSet(a, less, ak);
                            }
                            ++less;
                        } else if (compare.call$2(ak, el4) === 0) for(;;)if (compare.call$2(t1.$index(a, great), el4) === 0) {
                            --great;
                            if (great < k) break;
                            continue;
                        } else {
                            great0 = great - 1;
                            if (compare.call$2(t1.$index(a, great), el2) < 0) {
                                t1.$indexSet(a, k, t1.$index(a, less));
                                less0 = less + 1;
                                t1.$indexSet(a, less, t1.$index(a, great));
                                t1.$indexSet(a, great, ak);
                                less = less0;
                            } else {
                                t1.$indexSet(a, k, t1.$index(a, great));
                                t1.$indexSet(a, great, ak);
                            }
                            great = great0;
                            break;
                        }
                    }
                    A.Sort__doSort(a, less, great, compare);
                } else A.Sort__doSort(a, less, great, compare);
            },
            _CastIterableBase: function _CastIterableBase() {},
            CastIterator: function CastIterator(t0, t1) {
                this._source = t0;
                this.$ti = t1;
            },
            CastIterable: function CastIterable(t0, t1) {
                this._source = t0;
                this.$ti = t1;
            },
            _EfficientLengthCastIterable: function _EfficientLengthCastIterable(t0, t1) {
                this._source = t0;
                this.$ti = t1;
            },
            _CastListBase: function _CastListBase() {},
            _CastListBase_sort_closure: function _CastListBase_sort_closure(t0, t1) {
                this.$this = t0;
                this.compare = t1;
            },
            CastList: function CastList(t0, t1) {
                this._source = t0;
                this.$ti = t1;
            },
            CastSet: function CastSet(t0, t1, t2) {
                this._source = t0;
                this._emptySet = t1;
                this.$ti = t2;
            },
            CastMap: function CastMap(t0, t1) {
                this._source = t0;
                this.$ti = t1;
            },
            CastMap_forEach_closure: function CastMap_forEach_closure(t0, t1) {
                this.$this = t0;
                this.f = t1;
            },
            CastMap_entries_closure: function CastMap_entries_closure(t0) {
                this.$this = t0;
            },
            LateError: function LateError(t0) {
                this._message = t0;
            },
            CodeUnits: function CodeUnits(t0) {
                this._string = t0;
            },
            nullFuture_closure: function nullFuture_closure() {},
            SentinelValue: function SentinelValue() {},
            EfficientLengthIterable: function EfficientLengthIterable() {},
            ListIterable: function ListIterable() {},
            SubListIterable: function SubListIterable(t0, t1, t2, t3) {
                var _ = this;
                _.__internal$_iterable = t0;
                _._start = t1;
                _._endOrLength = t2;
                _.$ti = t3;
            },
            ListIterator: function ListIterator(t0, t1, t2) {
                var _ = this;
                _.__internal$_iterable = t0;
                _.__internal$_length = t1;
                _.__internal$_index = 0;
                _.__internal$_current = null;
                _.$ti = t2;
            },
            MappedIterable: function MappedIterable(t0, t1, t2) {
                this.__internal$_iterable = t0;
                this._f = t1;
                this.$ti = t2;
            },
            EfficientLengthMappedIterable: function EfficientLengthMappedIterable(t0, t1, t2) {
                this.__internal$_iterable = t0;
                this._f = t1;
                this.$ti = t2;
            },
            MappedIterator: function MappedIterator(t0, t1, t2) {
                var _ = this;
                _.__internal$_current = null;
                _._iterator = t0;
                _._f = t1;
                _.$ti = t2;
            },
            MappedListIterable: function MappedListIterable(t0, t1, t2) {
                this._source = t0;
                this._f = t1;
                this.$ti = t2;
            },
            WhereIterable: function WhereIterable(t0, t1, t2) {
                this.__internal$_iterable = t0;
                this._f = t1;
                this.$ti = t2;
            },
            WhereIterator: function WhereIterator(t0, t1) {
                this._iterator = t0;
                this._f = t1;
            },
            ExpandIterable: function ExpandIterable(t0, t1, t2) {
                this.__internal$_iterable = t0;
                this._f = t1;
                this.$ti = t2;
            },
            ExpandIterator: function ExpandIterator(t0, t1, t2, t3) {
                var _ = this;
                _._iterator = t0;
                _._f = t1;
                _._currentExpansion = t2;
                _.__internal$_current = null;
                _.$ti = t3;
            },
            TakeIterable: function TakeIterable(t0, t1, t2) {
                this.__internal$_iterable = t0;
                this._takeCount = t1;
                this.$ti = t2;
            },
            EfficientLengthTakeIterable: function EfficientLengthTakeIterable(t0, t1, t2) {
                this.__internal$_iterable = t0;
                this._takeCount = t1;
                this.$ti = t2;
            },
            TakeIterator: function TakeIterator(t0, t1, t2) {
                this._iterator = t0;
                this._remaining = t1;
                this.$ti = t2;
            },
            SkipIterable: function SkipIterable(t0, t1, t2) {
                this.__internal$_iterable = t0;
                this._skipCount = t1;
                this.$ti = t2;
            },
            EfficientLengthSkipIterable: function EfficientLengthSkipIterable(t0, t1, t2) {
                this.__internal$_iterable = t0;
                this._skipCount = t1;
                this.$ti = t2;
            },
            SkipIterator: function SkipIterator(t0, t1) {
                this._iterator = t0;
                this._skipCount = t1;
            },
            SkipWhileIterable: function SkipWhileIterable(t0, t1, t2) {
                this.__internal$_iterable = t0;
                this._f = t1;
                this.$ti = t2;
            },
            SkipWhileIterator: function SkipWhileIterator(t0, t1) {
                this._iterator = t0;
                this._f = t1;
                this._hasSkipped = false;
            },
            EmptyIterable: function EmptyIterable(t0) {
                this.$ti = t0;
            },
            EmptyIterator: function EmptyIterator() {},
            FollowedByIterable: function FollowedByIterable(t0, t1, t2) {
                this.__internal$_first = t0;
                this._second = t1;
                this.$ti = t2;
            },
            EfficientLengthFollowedByIterable: function EfficientLengthFollowedByIterable(t0, t1, t2) {
                this.__internal$_first = t0;
                this._second = t1;
                this.$ti = t2;
            },
            FollowedByIterator: function FollowedByIterator(t0, t1) {
                this._currentIterator = t0;
                this._nextIterable = t1;
            },
            WhereTypeIterable: function WhereTypeIterable(t0, t1) {
                this._source = t0;
                this.$ti = t1;
            },
            WhereTypeIterator: function WhereTypeIterator(t0, t1) {
                this._source = t0;
                this.$ti = t1;
            },
            NonNullsIterable: function NonNullsIterable(t0, t1) {
                this._source = t0;
                this.$ti = t1;
            },
            NonNullsIterator: function NonNullsIterator(t0) {
                this._source = t0;
                this.__internal$_current = null;
            },
            FixedLengthListMixin: function FixedLengthListMixin() {},
            UnmodifiableListMixin: function UnmodifiableListMixin() {},
            UnmodifiableListBase: function UnmodifiableListBase() {},
            ReversedListIterable: function ReversedListIterable(t0, t1) {
                this._source = t0;
                this.$ti = t1;
            },
            Symbol: function Symbol1(t0) {
                this.__internal$_name = t0;
            },
            __CastListBase__CastIterableBase_ListMixin: function __CastListBase__CastIterableBase_ListMixin() {},
            ConstantMap_ConstantMap$from: function(other, $K, $V) {
                var allStrings, k, object, index, index0, map, keys = A.List_List$from(other.get$keys(other), true, $K), t1 = keys.length, _i = 0;
                for(;;){
                    if (!(_i < t1)) {
                        allStrings = true;
                        break;
                    }
                    k = keys[_i];
                    if (typeof k != "string" || "__proto__" === k) {
                        allStrings = false;
                        break;
                    }
                    ++_i;
                }
                if (allStrings) {
                    object = {};
                    for(index = 0, _i = 0; _i < keys.length; keys.length === t1 || (0, A.throwConcurrentModificationError)(keys), ++_i, index = index0){
                        k = keys[_i];
                        other.$index(0, k);
                        index0 = index + 1;
                        object[k] = index;
                    }
                    map = new A.ConstantStringMap(object, A.List_List$from(other.get$values(other), true, $V), $K._eval$1("@<0>")._bind$1($V)._eval$1("ConstantStringMap<1,2>"));
                    map.$keys = keys;
                    return map;
                }
                return new A.ConstantMapView(A.LinkedHashMap_LinkedHashMap$from(other, $K, $V), $K._eval$1("@<0>")._bind$1($V)._eval$1("ConstantMapView<1,2>"));
            },
            ConstantMap__throwUnmodifiable: function() {
                throw A.wrapException(A.UnsupportedError$("Cannot modify unmodifiable Map"));
            },
            ConstantSet__throwUnmodifiable: function() {
                throw A.wrapException(A.UnsupportedError$("Cannot modify constant Set"));
            },
            instantiate1: function(f, $T1) {
                var t1 = new A.Instantiation1(f, $T1._eval$1("Instantiation1<0>"));
                t1.Instantiation$1(f);
                return t1;
            },
            unminifyOrTag: function(rawClassName) {
                var preserved = init.mangledGlobalNames[rawClassName];
                if (preserved != null) return preserved;
                return rawClassName;
            },
            isJsIndexable: function(object, record) {
                var result;
                if (record != null) {
                    result = record.x;
                    if (result != null) return result;
                }
                return type$.JavaScriptIndexingBehavior_dynamic._is(object);
            },
            S: function(value) {
                var result;
                if (typeof value == "string") return value;
                if (typeof value == "number") {
                    if (value !== 0) return "" + value;
                } else if (true === value) return "true";
                else if (false === value) return "false";
                else if (value == null) return "null";
                result = J.toString$0$(value);
                return result;
            },
            JSInvocationMirror$: function(_memberName, _internalName, _kind, _arguments, _namedArgumentNames, _typeArgumentCount) {
                return new A.JSInvocationMirror(_memberName, _kind, _arguments, _namedArgumentNames, _typeArgumentCount);
            },
            Primitives_objectHashCode: function(object) {
                var hash, property = $.Primitives__identityHashCodeProperty;
                if (property == null) property = $.Primitives__identityHashCodeProperty = Symbol("identityHashCode");
                hash = object[property];
                if (hash == null) {
                    hash = Math.random() * 0x3fffffff | 0;
                    object[property] = hash;
                }
                return hash;
            },
            Primitives_parseInt: function(source, radix) {
                var decimalMatch, maxCharCode, digitsPart, t1, i, _null = null, match = /^\s*[+-]?((0x[a-f0-9]+)|(\d+)|([a-z0-9]+))\s*$/i.exec(source);
                if (match == null) return _null;
                decimalMatch = match[3];
                if (radix == null) {
                    if (decimalMatch != null) return parseInt(source, 10);
                    if (match[2] != null) return parseInt(source, 16);
                    return _null;
                }
                if (radix < 2 || radix > 36) throw A.wrapException(A.RangeError$range(radix, 2, 36, "radix", _null));
                if (radix === 10 && decimalMatch != null) return parseInt(source, 10);
                if (radix < 10 || decimalMatch == null) {
                    maxCharCode = radix <= 10 ? 47 + radix : 86 + radix;
                    digitsPart = match[1];
                    for(t1 = digitsPart.length, i = 0; i < t1; ++i)if ((digitsPart.charCodeAt(i) | 32) > maxCharCode) return _null;
                }
                return parseInt(source, radix);
            },
            Primitives_parseDouble: function(source) {
                var result, trimmed;
                if (!/^\s*[+-]?(?:Infinity|NaN|(?:\.\d+|\d+(?:\.\d*)?)(?:[eE][+-]?\d+)?)\s*$/.test(source)) return null;
                result = parseFloat(source);
                if (isNaN(result)) {
                    trimmed = B.JSString_methods.trim$0(source);
                    if (trimmed === "NaN" || trimmed === "+NaN" || trimmed === "-NaN") return result;
                    return null;
                }
                return result;
            },
            Primitives_objectTypeName: function(object) {
                var interceptor, dispatchName, $constructor, constructorName;
                if (object instanceof A.Object) return A._rtiToString(A.instanceType(object), null);
                interceptor = J.getInterceptor$(object);
                if (interceptor === B.Interceptor_methods || interceptor === B.JavaScriptObject_methods || type$.UnknownJavaScriptObject._is(object)) {
                    dispatchName = B.C_JS_CONST(object);
                    if (dispatchName !== "Object" && dispatchName !== "") return dispatchName;
                    $constructor = object.constructor;
                    if (typeof $constructor == "function") {
                        constructorName = $constructor.name;
                        if (typeof constructorName == "string" && constructorName !== "Object" && constructorName !== "") return constructorName;
                    }
                }
                return A._rtiToString(A.instanceType(object), null);
            },
            Primitives_safeToString: function(object) {
                var hooks, i, hookResult;
                if (object == null || typeof object == "number" || A._isBool(object)) return J.toString$0$(object);
                if (typeof object == "string") return JSON.stringify(object);
                if (object instanceof A.Closure) return object.toString$0(0);
                if (object instanceof A._Record) return object._toString$1(true);
                hooks = $.$get$_safeToStringHooks();
                for(i = 0; i < 1; ++i){
                    hookResult = hooks[i].tryFormat$1(object);
                    if (hookResult != null) return hookResult;
                }
                return "Instance of '" + A.Primitives_objectTypeName(object) + "'";
            },
            Primitives_currentUri: function() {
                if (!!self.location) return self.location.href;
                return null;
            },
            Primitives__fromCharCodeApply: function(array) {
                var result, i, i0, chunkEnd, end = array.length;
                if (end <= 500) return String.fromCharCode.apply(null, array);
                for(result = "", i = 0; i < end; i = i0){
                    i0 = i + 500;
                    chunkEnd = i0 < end ? i0 : end;
                    result += String.fromCharCode.apply(null, array.slice(i, chunkEnd));
                }
                return result;
            },
            Primitives_stringFromCodePoints: function(codePoints) {
                var t1, _i, i, a = A._setArrayType([], type$.JSArray_int);
                for(t1 = codePoints.length, _i = 0; _i < codePoints.length; codePoints.length === t1 || (0, A.throwConcurrentModificationError)(codePoints), ++_i){
                    i = codePoints[_i];
                    if (!A._isInt(i)) throw A.wrapException(A.argumentErrorValue(i));
                    if (i <= 65535) a.push(i);
                    else if (i <= 1114111) {
                        a.push(55296 + (B.JSInt_methods._shrOtherPositive$1(i - 65536, 10) & 1023));
                        a.push(56320 + (i & 1023));
                    } else throw A.wrapException(A.argumentErrorValue(i));
                }
                return A.Primitives__fromCharCodeApply(a);
            },
            Primitives_stringFromCharCodes: function(charCodes) {
                var t1, _i, i;
                for(t1 = charCodes.length, _i = 0; _i < t1; ++_i){
                    i = charCodes[_i];
                    if (!A._isInt(i)) throw A.wrapException(A.argumentErrorValue(i));
                    if (i < 0) throw A.wrapException(A.argumentErrorValue(i));
                    if (i > 65535) return A.Primitives_stringFromCodePoints(charCodes);
                }
                return A.Primitives__fromCharCodeApply(charCodes);
            },
            Primitives_stringFromNativeUint8List: function(charCodes, start, end) {
                var i, result, i0, chunkEnd;
                if (end <= 500 && start === 0 && end === charCodes.length) return String.fromCharCode.apply(null, charCodes);
                for(i = start, result = ""; i < end; i = i0){
                    i0 = i + 500;
                    chunkEnd = i0 < end ? i0 : end;
                    result += String.fromCharCode.apply(null, charCodes.subarray(i, chunkEnd));
                }
                return result;
            },
            Primitives_stringFromCharCode: function(charCode) {
                var bits;
                if (0 <= charCode) {
                    if (charCode <= 65535) return String.fromCharCode(charCode);
                    if (charCode <= 1114111) {
                        bits = charCode - 65536;
                        return String.fromCharCode((B.JSInt_methods._shrOtherPositive$1(bits, 10) | 55296) >>> 0, bits & 1023 | 56320);
                    }
                }
                throw A.wrapException(A.RangeError$range(charCode, 0, 1114111, null, null));
            },
            Primitives_lazyAsJsDate: function(receiver) {
                if (receiver.date === void 0) receiver.date = new Date(receiver._value);
                return receiver.date;
            },
            Primitives_getYear: function(receiver) {
                var t1 = A.Primitives_lazyAsJsDate(receiver).getFullYear() + 0;
                return t1;
            },
            Primitives_getMonth: function(receiver) {
                var t1 = A.Primitives_lazyAsJsDate(receiver).getMonth() + 1;
                return t1;
            },
            Primitives_getDay: function(receiver) {
                var t1 = A.Primitives_lazyAsJsDate(receiver).getDate() + 0;
                return t1;
            },
            Primitives_getHours: function(receiver) {
                var t1 = A.Primitives_lazyAsJsDate(receiver).getHours() + 0;
                return t1;
            },
            Primitives_getMinutes: function(receiver) {
                var t1 = A.Primitives_lazyAsJsDate(receiver).getMinutes() + 0;
                return t1;
            },
            Primitives_getSeconds: function(receiver) {
                var t1 = A.Primitives_lazyAsJsDate(receiver).getSeconds() + 0;
                return t1;
            },
            Primitives_getMilliseconds: function(receiver) {
                var t1 = A.Primitives_lazyAsJsDate(receiver).getMilliseconds() + 0;
                return t1;
            },
            Primitives_functionNoSuchMethod: function($function, positionalArguments, namedArguments) {
                var $arguments, namedArgumentList, t1 = {};
                t1.argumentCount = 0;
                $arguments = [];
                namedArgumentList = [];
                t1.argumentCount = positionalArguments.length;
                B.JSArray_methods.addAll$1($arguments, positionalArguments);
                t1.names = "";
                if (namedArguments != null && namedArguments.__js_helper$_length !== 0) namedArguments.forEach$1(0, new A.Primitives_functionNoSuchMethod_closure(t1, namedArgumentList, $arguments));
                return J.noSuchMethod$1$($function, new A.JSInvocationMirror(B.Symbol_call, 0, $arguments, namedArgumentList, 0));
            },
            Primitives_applyFunction: function($function, positionalArguments, namedArguments) {
                var t1, argumentCount, jsStub;
                if (Array.isArray(positionalArguments)) t1 = namedArguments == null || namedArguments.__js_helper$_length === 0;
                else t1 = false;
                if (t1) {
                    argumentCount = positionalArguments.length;
                    if (argumentCount === 0) {
                        if (!!$function.call$0) return $function.call$0();
                    } else if (argumentCount === 1) {
                        if (!!$function.call$1) return $function.call$1(positionalArguments[0]);
                    } else if (argumentCount === 2) {
                        if (!!$function.call$2) return $function.call$2(positionalArguments[0], positionalArguments[1]);
                    } else if (argumentCount === 3) {
                        if (!!$function.call$3) return $function.call$3(positionalArguments[0], positionalArguments[1], positionalArguments[2]);
                    } else if (argumentCount === 4) {
                        if (!!$function.call$4) return $function.call$4(positionalArguments[0], positionalArguments[1], positionalArguments[2], positionalArguments[3]);
                    } else if (argumentCount === 5) {
                        if (!!$function.call$5) return $function.call$5(positionalArguments[0], positionalArguments[1], positionalArguments[2], positionalArguments[3], positionalArguments[4]);
                    }
                    jsStub = $function["call$" + argumentCount];
                    if (jsStub != null) return jsStub.apply($function, positionalArguments);
                }
                return A.Primitives__generalApplyFunction($function, positionalArguments, namedArguments);
            },
            Primitives__generalApplyFunction: function($function, positionalArguments, namedArguments) {
                var $arguments, argumentCount, requiredParameterCount, defaultValuesClosure, t1, defaultValues, interceptor, jsFunction, maxArguments, missingDefaults, keys, _i, defaultValue, used, t2;
                if (Array.isArray(positionalArguments)) $arguments = positionalArguments;
                else $arguments = A.List_List$_of(positionalArguments, type$.dynamic);
                argumentCount = $arguments.length;
                requiredParameterCount = $function.$requiredArgCount;
                if (argumentCount < requiredParameterCount) return A.Primitives_functionNoSuchMethod($function, $arguments, namedArguments);
                defaultValuesClosure = $function.$defaultValues;
                t1 = defaultValuesClosure == null;
                defaultValues = !t1 ? defaultValuesClosure() : null;
                interceptor = J.getInterceptor$($function);
                jsFunction = interceptor["call*"];
                if (typeof jsFunction == "string") jsFunction = interceptor[jsFunction];
                if (t1) {
                    if (namedArguments != null && namedArguments.__js_helper$_length !== 0) return A.Primitives_functionNoSuchMethod($function, $arguments, namedArguments);
                    if (argumentCount === requiredParameterCount) return jsFunction.apply($function, $arguments);
                    return A.Primitives_functionNoSuchMethod($function, $arguments, namedArguments);
                }
                if (Array.isArray(defaultValues)) {
                    if (namedArguments != null && namedArguments.__js_helper$_length !== 0) return A.Primitives_functionNoSuchMethod($function, $arguments, namedArguments);
                    maxArguments = requiredParameterCount + defaultValues.length;
                    if (argumentCount > maxArguments) return A.Primitives_functionNoSuchMethod($function, $arguments, null);
                    if (argumentCount < maxArguments) {
                        missingDefaults = defaultValues.slice(argumentCount - requiredParameterCount);
                        if ($arguments === positionalArguments) $arguments = A.List_List$_of($arguments, type$.dynamic);
                        B.JSArray_methods.addAll$1($arguments, missingDefaults);
                    }
                    return jsFunction.apply($function, $arguments);
                } else {
                    if (argumentCount > requiredParameterCount) return A.Primitives_functionNoSuchMethod($function, $arguments, namedArguments);
                    if ($arguments === positionalArguments) $arguments = A.List_List$_of($arguments, type$.dynamic);
                    keys = Object.keys(defaultValues);
                    if (namedArguments == null) for(t1 = keys.length, _i = 0; _i < keys.length; keys.length === t1 || (0, A.throwConcurrentModificationError)(keys), ++_i){
                        defaultValue = defaultValues[keys[_i]];
                        if (B.C__Required === defaultValue) return A.Primitives_functionNoSuchMethod($function, $arguments, namedArguments);
                        B.JSArray_methods.add$1($arguments, defaultValue);
                    }
                    else {
                        for(t1 = keys.length, used = 0, _i = 0; _i < keys.length; keys.length === t1 || (0, A.throwConcurrentModificationError)(keys), ++_i){
                            t2 = keys[_i];
                            if (namedArguments.containsKey$1(t2)) {
                                ++used;
                                B.JSArray_methods.add$1($arguments, namedArguments.$index(0, t2));
                            } else {
                                defaultValue = defaultValues[t2];
                                if (B.C__Required === defaultValue) return A.Primitives_functionNoSuchMethod($function, $arguments, namedArguments);
                                B.JSArray_methods.add$1($arguments, defaultValue);
                            }
                        }
                        if (used !== namedArguments.__js_helper$_length) return A.Primitives_functionNoSuchMethod($function, $arguments, namedArguments);
                    }
                    return jsFunction.apply($function, $arguments);
                }
            },
            Primitives_extractStackTrace: function(error) {
                var jsError = error.$thrownJsError;
                if (jsError == null) return null;
                return A.getTraceFromException(jsError);
            },
            Primitives_trySetStackTrace: function(error, stackTrace) {
                var jsError;
                if (error.$thrownJsError == null) {
                    jsError = new Error();
                    A.initializeExceptionWrapper(error, jsError);
                    error.$thrownJsError = jsError;
                    jsError.stack = stackTrace.toString$0(0);
                }
            },
            diagnoseIndexError: function(indexable, index) {
                var $length, _s5_ = "index";
                if (!A._isInt(index)) return new A.ArgumentError(true, index, _s5_, null);
                $length = J.get$length$asx(indexable);
                if (index < 0 || index >= $length) return A.IndexError$withLength(index, $length, indexable, null, _s5_);
                return A.RangeError$value(index, _s5_, null);
            },
            diagnoseRangeError: function(start, end, $length) {
                if (start < 0 || start > $length) return A.RangeError$range(start, 0, $length, "start", null);
                if (end != null) {
                    if (end < start || end > $length) return A.RangeError$range(end, start, $length, "end", null);
                }
                return new A.ArgumentError(true, end, "end", null);
            },
            argumentErrorValue: function(object) {
                return new A.ArgumentError(true, object, null, null);
            },
            wrapException: function(ex) {
                return A.initializeExceptionWrapper(ex, new Error());
            },
            initializeExceptionWrapper: function(ex, wrapper) {
                var t1;
                if (ex == null) ex = new A.TypeError();
                wrapper.dartException = ex;
                t1 = A.toStringWrapper;
                if ("defineProperty" in Object) {
                    Object.defineProperty(wrapper, "message", {
                        get: t1
                    });
                    wrapper.name = "";
                } else wrapper.toString = t1;
                return wrapper;
            },
            toStringWrapper: function() {
                return J.toString$0$(this.dartException);
            },
            throwExpression: function(ex, wrapper) {
                throw A.initializeExceptionWrapper(ex, wrapper == null ? new Error() : wrapper);
            },
            throwUnsupportedOperation: function(o, operation, verb) {
                var wrapper;
                if (operation == null) operation = 0;
                if (verb == null) verb = 0;
                wrapper = Error();
                A.throwExpression(A._diagnoseUnsupportedOperation(o, operation, verb), wrapper);
            },
            _diagnoseUnsupportedOperation: function(o, encodedOperation, encodedVerb) {
                var operation, table, tableLength, index, verb, object, flags, article, adjective;
                if (typeof encodedOperation == "string") operation = encodedOperation;
                else {
                    table = "[]=;add;removeWhere;retainWhere;removeRange;setRange;setInt8;setInt16;setInt32;setUint8;setUint16;setUint32;setFloat32;setFloat64".split(";");
                    tableLength = table.length;
                    index = encodedOperation;
                    if (index > tableLength) {
                        encodedVerb = index / tableLength | 0;
                        index %= tableLength;
                    }
                    operation = table[index];
                }
                verb = typeof encodedVerb == "string" ? encodedVerb : "modify;remove from;add to".split(";")[encodedVerb];
                object = type$.List_dynamic._is(o) ? "list" : "ByteData";
                flags = o.$flags | 0;
                article = "a ";
                if ((flags & 4) !== 0) adjective = "constant ";
                else if ((flags & 2) !== 0) {
                    adjective = "unmodifiable ";
                    article = "an ";
                } else adjective = (flags & 1) !== 0 ? "fixed-length " : "";
                return new A.UnsupportedError("'" + operation + "': Cannot " + verb + " " + article + adjective + object);
            },
            throwConcurrentModificationError: function(collection) {
                throw A.wrapException(A.ConcurrentModificationError$(collection));
            },
            TypeErrorDecoder_extractPattern: function(message) {
                var match, $arguments, argumentsExpr, expr, method, receiver;
                message = A.quoteStringForRegExp(message.replace(String({}), "$receiver$"));
                match = message.match(/\\\$[a-zA-Z]+\\\$/g);
                if (match == null) match = A._setArrayType([], type$.JSArray_String);
                $arguments = match.indexOf("\\$arguments\\$");
                argumentsExpr = match.indexOf("\\$argumentsExpr\\$");
                expr = match.indexOf("\\$expr\\$");
                method = match.indexOf("\\$method\\$");
                receiver = match.indexOf("\\$receiver\\$");
                return new A.TypeErrorDecoder(message.replace(new RegExp("\\\\\\$arguments\\\\\\$", "g"), "((?:x|[^x])*)").replace(new RegExp("\\\\\\$argumentsExpr\\\\\\$", "g"), "((?:x|[^x])*)").replace(new RegExp("\\\\\\$expr\\\\\\$", "g"), "((?:x|[^x])*)").replace(new RegExp("\\\\\\$method\\\\\\$", "g"), "((?:x|[^x])*)").replace(new RegExp("\\\\\\$receiver\\\\\\$", "g"), "((?:x|[^x])*)"), $arguments, argumentsExpr, expr, method, receiver);
            },
            TypeErrorDecoder_provokeCallErrorOn: function(expression) {
                return function($expr$) {
                    var $argumentsExpr$ = "$arguments$";
                    try {
                        $expr$.$method$($argumentsExpr$);
                    } catch (e) {
                        return e.message;
                    }
                }(expression);
            },
            TypeErrorDecoder_provokePropertyErrorOn: function(expression) {
                return function($expr$) {
                    try {
                        $expr$.$method$;
                    } catch (e) {
                        return e.message;
                    }
                }(expression);
            },
            JsNoSuchMethodError$: function(_message, match) {
                var t1 = match == null, t2 = t1 ? null : match.method;
                return new A.JsNoSuchMethodError(_message, t2, t1 ? null : match.receiver);
            },
            unwrapException: function(ex) {
                if (ex == null) return new A.NullThrownFromJavaScriptException(ex);
                if (ex instanceof A.ExceptionAndStackTrace) return A.saveStackTrace(ex, ex.dartException);
                if ((typeof ex === "undefined" ? "undefined" : (0, $6tOPT._)(ex)) !== "object") return ex;
                if ("dartException" in ex) return A.saveStackTrace(ex, ex.dartException);
                return A._unwrapNonDartException(ex);
            },
            saveStackTrace: function(ex, error) {
                if (type$.Error._is(error)) {
                    if (error.$thrownJsError == null) error.$thrownJsError = ex;
                }
                return error;
            },
            _unwrapNonDartException: function(ex) {
                var message, number, ieErrorCode, nsme, notClosure, nullCall, nullLiteralCall, undefCall, undefLiteralCall, nullProperty, undefProperty, undefLiteralProperty, match;
                if (!("message" in ex)) return ex;
                message = ex.message;
                if ("number" in ex && typeof ex.number == "number") {
                    number = ex.number;
                    ieErrorCode = number & 65535;
                    if ((B.JSInt_methods._shrOtherPositive$1(number, 16) & 8191) === 10) switch(ieErrorCode){
                        case 438:
                            return A.saveStackTrace(ex, A.JsNoSuchMethodError$(A.S(message) + " (Error " + ieErrorCode + ")", null));
                        case 445:
                        case 5007:
                            A.S(message);
                            return A.saveStackTrace(ex, new A.NullError());
                    }
                }
                if (ex instanceof TypeError) {
                    nsme = $.$get$TypeErrorDecoder_noSuchMethodPattern();
                    notClosure = $.$get$TypeErrorDecoder_notClosurePattern();
                    nullCall = $.$get$TypeErrorDecoder_nullCallPattern();
                    nullLiteralCall = $.$get$TypeErrorDecoder_nullLiteralCallPattern();
                    undefCall = $.$get$TypeErrorDecoder_undefinedCallPattern();
                    undefLiteralCall = $.$get$TypeErrorDecoder_undefinedLiteralCallPattern();
                    nullProperty = $.$get$TypeErrorDecoder_nullPropertyPattern();
                    $.$get$TypeErrorDecoder_nullLiteralPropertyPattern();
                    undefProperty = $.$get$TypeErrorDecoder_undefinedPropertyPattern();
                    undefLiteralProperty = $.$get$TypeErrorDecoder_undefinedLiteralPropertyPattern();
                    match = nsme.matchTypeError$1(message);
                    if (match != null) return A.saveStackTrace(ex, A.JsNoSuchMethodError$(message, match));
                    else {
                        match = notClosure.matchTypeError$1(message);
                        if (match != null) {
                            match.method = "call";
                            return A.saveStackTrace(ex, A.JsNoSuchMethodError$(message, match));
                        } else if (nullCall.matchTypeError$1(message) != null || nullLiteralCall.matchTypeError$1(message) != null || undefCall.matchTypeError$1(message) != null || undefLiteralCall.matchTypeError$1(message) != null || nullProperty.matchTypeError$1(message) != null || nullLiteralCall.matchTypeError$1(message) != null || undefProperty.matchTypeError$1(message) != null || undefLiteralProperty.matchTypeError$1(message) != null) return A.saveStackTrace(ex, new A.NullError());
                    }
                    return A.saveStackTrace(ex, new A.UnknownJsTypeError(typeof message == "string" ? message : ""));
                }
                if (ex instanceof RangeError) {
                    if (typeof message == "string" && message.indexOf("call stack") !== -1) return new A.StackOverflowError();
                    message = function(ex) {
                        try {
                            return String(ex);
                        } catch (e) {}
                        return null;
                    }(ex);
                    return A.saveStackTrace(ex, new A.ArgumentError(false, null, null, typeof message == "string" ? message.replace(/^RangeError:\s*/, "") : message));
                }
                if (typeof InternalError == "function" && ex instanceof InternalError) {
                    if (typeof message == "string" && message === "too much recursion") return new A.StackOverflowError();
                }
                return ex;
            },
            getTraceFromException: function(exception) {
                var trace;
                if (exception instanceof A.ExceptionAndStackTrace) return exception.stackTrace;
                if (exception == null) return new A._StackTrace(exception);
                trace = exception.$cachedTrace;
                if (trace != null) return trace;
                trace = new A._StackTrace(exception);
                if ((typeof exception === "undefined" ? "undefined" : (0, $6tOPT._)(exception)) === "object") exception.$cachedTrace = trace;
                return trace;
            },
            objectHashCode: function(object) {
                if (object == null) return J.get$hashCode$(object);
                if ((typeof object === "undefined" ? "undefined" : (0, $6tOPT._)(object)) == "object") return A.Primitives_objectHashCode(object);
                return J.get$hashCode$(object);
            },
            constantHashCode: function(key) {
                if (typeof key == "number") return B.JSNumber_methods.get$hashCode(key);
                if (key instanceof A._Type) return A.Primitives_objectHashCode(key);
                if (key instanceof A._Record) return key.get$hashCode(key);
                if (key instanceof A.Symbol) return key.get$hashCode(0);
                return A.objectHashCode(key);
            },
            fillLiteralMap: function(keyValuePairs, result) {
                var index, index0, index1, $length = keyValuePairs.length;
                for(index = 0; index < $length; index = index1){
                    index0 = index + 1;
                    index1 = index0 + 1;
                    result.$indexSet(0, keyValuePairs[index], keyValuePairs[index0]);
                }
                return result;
            },
            fillLiteralSet: function(values, result) {
                var index, $length = values.length;
                for(index = 0; index < $length; ++index)result.add$1(0, values[index]);
                return result;
            },
            _invokeClosure: function(closure, numberOfArguments, arg1, arg2, arg3, arg4) {
                switch(numberOfArguments){
                    case 0:
                        return closure.call$0();
                    case 1:
                        return closure.call$1(arg1);
                    case 2:
                        return closure.call$2(arg1, arg2);
                    case 3:
                        return closure.call$3(arg1, arg2, arg3);
                    case 4:
                        return closure.call$4(arg1, arg2, arg3, arg4);
                }
                throw A.wrapException(new A._Exception("Unsupported number of arguments for wrapped closure"));
            },
            convertDartClosureToJS: function(closure, arity) {
                var $function;
                if (closure == null) return null;
                $function = closure.$identity;
                if (!!$function) return $function;
                $function = A.convertDartClosureToJSUncached(closure, arity);
                closure.$identity = $function;
                return $function;
            },
            convertDartClosureToJSUncached: function(closure, arity) {
                var entry;
                switch(arity){
                    case 0:
                        entry = closure.call$0;
                        break;
                    case 1:
                        entry = closure.call$1;
                        break;
                    case 2:
                        entry = closure.call$2;
                        break;
                    case 3:
                        entry = closure.call$3;
                        break;
                    case 4:
                        entry = closure.call$4;
                        break;
                    default:
                        entry = null;
                }
                if (entry != null) return entry.bind(closure);
                return function(closure, arity, invoke) {
                    return function(a1, a2, a3, a4) {
                        return invoke(closure, arity, a1, a2, a3, a4);
                    };
                }(closure, arity, A._invokeClosure);
            },
            Closure_fromTearOff: function(parameters) {
                var $prototype, $constructor, t2, trampoline, applyTrampoline, i, stub, stub0, stubName, stubCallName, container = parameters.co, isStatic = parameters.iS, isIntercepted = parameters.iI, needsDirectAccess = parameters.nDA, applyTrampolineIndex = parameters.aI, funsOrNames = parameters.fs, callNames = parameters.cs, $name = funsOrNames[0], callName = callNames[0], $function = container[$name], t1 = parameters.fT;
                t1.toString;
                $prototype = isStatic ? Object.create(new A.StaticClosure().constructor.prototype) : Object.create(new A.BoundClosure(null, null).constructor.prototype);
                $prototype.$initialize = $prototype.constructor;
                $constructor = isStatic ? function static_tear_off() {
                    this.$initialize();
                } : function tear_off(a, b) {
                    this.$initialize(a, b);
                };
                $prototype.constructor = $constructor;
                $constructor.prototype = $prototype;
                $prototype.$_name = $name;
                $prototype.$_target = $function;
                t2 = !isStatic;
                if (t2) trampoline = A.Closure_forwardCallTo($name, $function, isIntercepted, needsDirectAccess);
                else {
                    $prototype.$static_name = $name;
                    trampoline = $function;
                }
                $prototype.$signature = A.Closure__computeSignatureFunction(t1, isStatic, isIntercepted);
                $prototype[callName] = trampoline;
                for(applyTrampoline = trampoline, i = 1; i < funsOrNames.length; ++i){
                    stub = funsOrNames[i];
                    if (typeof stub == "string") {
                        stub0 = container[stub];
                        stubName = stub;
                        stub = stub0;
                    } else stubName = "";
                    stubCallName = callNames[i];
                    if (stubCallName != null) {
                        if (t2) stub = A.Closure_forwardCallTo(stubName, stub, isIntercepted, needsDirectAccess);
                        $prototype[stubCallName] = stub;
                    }
                    if (i === applyTrampolineIndex) applyTrampoline = stub;
                }
                $prototype["call*"] = applyTrampoline;
                $prototype.$requiredArgCount = parameters.rC;
                $prototype.$defaultValues = parameters.dV;
                return $constructor;
            },
            Closure__computeSignatureFunction: function(functionType, isStatic, isIntercepted) {
                if (typeof functionType == "number") return functionType;
                if (typeof functionType == "string") {
                    if (isStatic) throw A.wrapException("Cannot compute signature for static tearoff.");
                    return function(recipe, evalOnReceiver) {
                        return function() {
                            return evalOnReceiver(this, recipe);
                        };
                    }(functionType, A.BoundClosure_evalRecipe);
                }
                throw A.wrapException("Error in functionType of tearoff");
            },
            Closure_cspForwardCall: function(arity, needsDirectAccess, stubName, $function) {
                var getReceiver = A.BoundClosure_receiverOf;
                switch(needsDirectAccess ? -1 : arity){
                    case 0:
                        return function(entry, receiverOf) {
                            return function() {
                                return receiverOf(this)[entry]();
                            };
                        }(stubName, getReceiver);
                    case 1:
                        return function(entry, receiverOf) {
                            return function(a) {
                                return receiverOf(this)[entry](a);
                            };
                        }(stubName, getReceiver);
                    case 2:
                        return function(entry, receiverOf) {
                            return function(a, b) {
                                return receiverOf(this)[entry](a, b);
                            };
                        }(stubName, getReceiver);
                    case 3:
                        return function(entry, receiverOf) {
                            return function(a, b, c) {
                                return receiverOf(this)[entry](a, b, c);
                            };
                        }(stubName, getReceiver);
                    case 4:
                        return function(entry, receiverOf) {
                            return function(a, b, c, d) {
                                return receiverOf(this)[entry](a, b, c, d);
                            };
                        }(stubName, getReceiver);
                    case 5:
                        return function(entry, receiverOf) {
                            return function(a, b, c, d, e) {
                                return receiverOf(this)[entry](a, b, c, d, e);
                            };
                        }(stubName, getReceiver);
                    default:
                        return function(f, receiverOf) {
                            return function() {
                                return f.apply(receiverOf(this), arguments);
                            };
                        }($function, getReceiver);
                }
            },
            Closure_forwardCallTo: function(stubName, $function, isIntercepted, needsDirectAccess) {
                if (isIntercepted) return A.Closure_forwardInterceptedCallTo(stubName, $function, needsDirectAccess);
                return A.Closure_cspForwardCall($function.length, needsDirectAccess, stubName, $function);
            },
            Closure_cspForwardInterceptedCall: function(arity, needsDirectAccess, stubName, $function) {
                var getReceiver = A.BoundClosure_receiverOf, getInterceptor = A.BoundClosure_interceptorOf;
                switch(needsDirectAccess ? -1 : arity){
                    case 0:
                        throw A.wrapException(new A.RuntimeError("Intercepted function with no arguments."));
                    case 1:
                        return function(entry, interceptorOf, receiverOf) {
                            return function() {
                                return interceptorOf(this)[entry](receiverOf(this));
                            };
                        }(stubName, getInterceptor, getReceiver);
                    case 2:
                        return function(entry, interceptorOf, receiverOf) {
                            return function(a) {
                                return interceptorOf(this)[entry](receiverOf(this), a);
                            };
                        }(stubName, getInterceptor, getReceiver);
                    case 3:
                        return function(entry, interceptorOf, receiverOf) {
                            return function(a, b) {
                                return interceptorOf(this)[entry](receiverOf(this), a, b);
                            };
                        }(stubName, getInterceptor, getReceiver);
                    case 4:
                        return function(entry, interceptorOf, receiverOf) {
                            return function(a, b, c) {
                                return interceptorOf(this)[entry](receiverOf(this), a, b, c);
                            };
                        }(stubName, getInterceptor, getReceiver);
                    case 5:
                        return function(entry, interceptorOf, receiverOf) {
                            return function(a, b, c, d) {
                                return interceptorOf(this)[entry](receiverOf(this), a, b, c, d);
                            };
                        }(stubName, getInterceptor, getReceiver);
                    case 6:
                        return function(entry, interceptorOf, receiverOf) {
                            return function(a, b, c, d, e) {
                                return interceptorOf(this)[entry](receiverOf(this), a, b, c, d, e);
                            };
                        }(stubName, getInterceptor, getReceiver);
                    default:
                        return function(f, interceptorOf, receiverOf) {
                            return function() {
                                var a = [
                                    receiverOf(this)
                                ];
                                Array.prototype.push.apply(a, arguments);
                                return f.apply(interceptorOf(this), a);
                            };
                        }($function, getInterceptor, getReceiver);
                }
            },
            Closure_forwardInterceptedCallTo: function(stubName, $function, needsDirectAccess) {
                var arity, t1;
                if ($.BoundClosure__interceptorFieldNameCache == null) $.BoundClosure__interceptorFieldNameCache = A.BoundClosure__computeFieldNamed("interceptor");
                if ($.BoundClosure__receiverFieldNameCache == null) $.BoundClosure__receiverFieldNameCache = A.BoundClosure__computeFieldNamed("receiver");
                arity = $function.length;
                t1 = A.Closure_cspForwardInterceptedCall(arity, needsDirectAccess, stubName, $function);
                return t1;
            },
            closureFromTearOff: function(parameters) {
                return A.Closure_fromTearOff(parameters);
            },
            BoundClosure_evalRecipe: function(closure, recipe) {
                return A._Universe_evalInEnvironment(init.typeUniverse, A.instanceType(closure._receiver), recipe);
            },
            BoundClosure_receiverOf: function(closure) {
                return closure._receiver;
            },
            BoundClosure_interceptorOf: function(closure) {
                return closure._interceptor;
            },
            BoundClosure__computeFieldNamed: function(fieldName) {
                var names, i, $name, template = new A.BoundClosure("receiver", "interceptor"), t1 = Object.getOwnPropertyNames(template);
                t1.$flags = 1;
                names = t1;
                for(t1 = names.length, i = 0; i < t1; ++i){
                    $name = names[i];
                    if (template[$name] === fieldName) return $name;
                }
                throw A.wrapException(A.ArgumentError$("Field name " + fieldName + " not found.", null));
            },
            getIsolateAffinityTag: function($name) {
                return init.getIsolateTag($name);
            },
            defineProperty: function(obj, property, value) {
                Object.defineProperty(obj, property, {
                    value: value,
                    enumerable: false,
                    writable: true,
                    configurable: true
                });
            },
            lookupAndCacheInterceptor: function(obj) {
                var interceptor, interceptorClass, altTag, mark, t1, tag = $.getTagFunction.call$1(obj), record = $.dispatchRecordsForInstanceTags[tag];
                if (record != null) {
                    Object.defineProperty(obj, init.dispatchPropertyName, {
                        value: record,
                        enumerable: false,
                        writable: true,
                        configurable: true
                    });
                    return record.i;
                }
                interceptor = $.interceptorsForUncacheableTags[tag];
                if (interceptor != null) return interceptor;
                interceptorClass = init.interceptorsByTag[tag];
                if (interceptorClass == null) {
                    altTag = $.alternateTagFunction.call$2(obj, tag);
                    if (altTag != null) {
                        record = $.dispatchRecordsForInstanceTags[altTag];
                        if (record != null) {
                            Object.defineProperty(obj, init.dispatchPropertyName, {
                                value: record,
                                enumerable: false,
                                writable: true,
                                configurable: true
                            });
                            return record.i;
                        }
                        interceptor = $.interceptorsForUncacheableTags[altTag];
                        if (interceptor != null) return interceptor;
                        interceptorClass = init.interceptorsByTag[altTag];
                        tag = altTag;
                    }
                }
                if (interceptorClass == null) return null;
                interceptor = interceptorClass.prototype;
                mark = tag[0];
                if (mark === "!") {
                    record = A.makeLeafDispatchRecord(interceptor);
                    $.dispatchRecordsForInstanceTags[tag] = record;
                    Object.defineProperty(obj, init.dispatchPropertyName, {
                        value: record,
                        enumerable: false,
                        writable: true,
                        configurable: true
                    });
                    return record.i;
                }
                if (mark === "~") {
                    $.interceptorsForUncacheableTags[tag] = interceptor;
                    return interceptor;
                }
                if (mark === "-") {
                    t1 = A.makeLeafDispatchRecord(interceptor);
                    Object.defineProperty(Object.getPrototypeOf(obj), init.dispatchPropertyName, {
                        value: t1,
                        enumerable: false,
                        writable: true,
                        configurable: true
                    });
                    return t1.i;
                }
                if (mark === "+") return A.patchInteriorProto(obj, interceptor);
                if (mark === "*") throw A.wrapException(A.UnimplementedError$(tag));
                if (init.leafTags[tag] === true) {
                    t1 = A.makeLeafDispatchRecord(interceptor);
                    Object.defineProperty(Object.getPrototypeOf(obj), init.dispatchPropertyName, {
                        value: t1,
                        enumerable: false,
                        writable: true,
                        configurable: true
                    });
                    return t1.i;
                } else return A.patchInteriorProto(obj, interceptor);
            },
            patchInteriorProto: function(obj, interceptor) {
                var proto = Object.getPrototypeOf(obj);
                Object.defineProperty(proto, init.dispatchPropertyName, {
                    value: J.makeDispatchRecord(interceptor, proto, null, null),
                    enumerable: false,
                    writable: true,
                    configurable: true
                });
                return interceptor;
            },
            makeLeafDispatchRecord: function(interceptor) {
                return J.makeDispatchRecord(interceptor, false, null, !!interceptor.$isJavaScriptIndexingBehavior);
            },
            makeDefaultDispatchRecord: function(tag, interceptorClass, proto) {
                var interceptor = interceptorClass.prototype;
                if (init.leafTags[tag] === true) return A.makeLeafDispatchRecord(interceptor);
                else return J.makeDispatchRecord(interceptor, proto, null, null);
            },
            initNativeDispatch: function() {
                if (true === $.initNativeDispatchFlag) return;
                $.initNativeDispatchFlag = true;
                A.initNativeDispatchContinue();
            },
            initNativeDispatchContinue: function() {
                var map, tags, fun, i, tag, proto, record, interceptorClass;
                $.dispatchRecordsForInstanceTags = Object.create(null);
                $.interceptorsForUncacheableTags = Object.create(null);
                A.initHooks();
                map = init.interceptorsByTag;
                tags = Object.getOwnPropertyNames(map);
                if (typeof window != "undefined") {
                    window;
                    fun = function fun() {};
                    for(i = 0; i < tags.length; ++i){
                        tag = tags[i];
                        proto = $.prototypeForTagFunction.call$1(tag);
                        if (proto != null) {
                            record = A.makeDefaultDispatchRecord(tag, map[tag], proto);
                            if (record != null) {
                                Object.defineProperty(proto, init.dispatchPropertyName, {
                                    value: record,
                                    enumerable: false,
                                    writable: true,
                                    configurable: true
                                });
                                fun.prototype = proto;
                            }
                        }
                    }
                }
                for(i = 0; i < tags.length; ++i){
                    tag = tags[i];
                    if (/^[A-Za-z_]/.test(tag)) {
                        interceptorClass = map[tag];
                        map["!" + tag] = interceptorClass;
                        map["~" + tag] = interceptorClass;
                        map["-" + tag] = interceptorClass;
                        map["+" + tag] = interceptorClass;
                        map["*" + tag] = interceptorClass;
                    }
                }
            },
            initHooks: function() {
                var transformers, i, transformer, getTag, getUnknownTag, prototypeForTag, hooks = B.C_JS_CONST0();
                hooks = A.applyHooksTransformer(B.C_JS_CONST1, A.applyHooksTransformer(B.C_JS_CONST2, A.applyHooksTransformer(B.C_JS_CONST3, A.applyHooksTransformer(B.C_JS_CONST3, A.applyHooksTransformer(B.C_JS_CONST4, A.applyHooksTransformer(B.C_JS_CONST5, A.applyHooksTransformer(B.C_JS_CONST6(B.C_JS_CONST), hooks)))))));
                if (typeof dartNativeDispatchHooksTransformer != "undefined") {
                    transformers = dartNativeDispatchHooksTransformer;
                    if (typeof transformers == "function") transformers = [
                        transformers
                    ];
                    if (Array.isArray(transformers)) for(i = 0; i < transformers.length; ++i){
                        transformer = transformers[i];
                        if (typeof transformer == "function") hooks = transformer(hooks) || hooks;
                    }
                }
                getTag = hooks.getTag;
                getUnknownTag = hooks.getUnknownTag;
                prototypeForTag = hooks.prototypeForTag;
                $.getTagFunction = new A.initHooks_closure(getTag);
                $.alternateTagFunction = new A.initHooks_closure0(getUnknownTag);
                $.prototypeForTagFunction = new A.initHooks_closure1(prototypeForTag);
            },
            applyHooksTransformer: function(transformer, hooks) {
                return transformer(hooks) || hooks;
            },
            _RecordN__equalValues: function(a, b) {
                var i;
                for(i = 0; i < a.length; ++i)if (!J.$eq$(a[i], b[i])) return false;
                return true;
            },
            createRecordTypePredicate: function(shape, fieldRtis) {
                var $length = fieldRtis.length, $function = init.rttc["" + $length + ";" + shape];
                if ($function == null) return null;
                if ($length === 0) return $function;
                if ($length === $function.length) return $function.apply(null, fieldRtis);
                return $function(fieldRtis);
            },
            JSSyntaxRegExp_makeNative: function(source, multiLine, caseSensitive, unicode, dotAll, extraFlags) {
                var m = multiLine ? "m" : "", i = caseSensitive ? "" : "i", u = unicode ? "u" : "", s = dotAll ? "s" : "", regexp = function(source, modifiers) {
                    try {
                        return new RegExp(source, modifiers);
                    } catch (e) {
                        return e;
                    }
                }(source, m + i + u + s + extraFlags);
                if (regexp instanceof RegExp) return regexp;
                throw A.wrapException(A.FormatException$("Illegal RegExp pattern (" + String(regexp) + ")", source, null));
            },
            stringContainsUnchecked: function(receiver, other, startIndex) {
                var t1;
                if (typeof other == "string") return receiver.indexOf(other, startIndex) >= 0;
                else if (other instanceof A.JSSyntaxRegExp) {
                    t1 = B.JSString_methods.substring$1(receiver, startIndex);
                    return other._nativeRegExp.test(t1);
                } else return !J.allMatches$1$s(other, B.JSString_methods.substring$1(receiver, startIndex)).get$isEmpty(0);
            },
            escapeReplacement: function(replacement) {
                if (replacement.indexOf("$", 0) >= 0) return replacement.replace(/\$/g, "$$$$");
                return replacement;
            },
            stringReplaceFirstRE: function(receiver, regexp, replacement, startIndex) {
                var match = regexp._execGlobal$2(receiver, startIndex);
                if (match == null) return receiver;
                return A.stringReplaceRangeUnchecked(receiver, match._match.index, match.get$end(0), replacement);
            },
            quoteStringForRegExp: function(string) {
                if (/[[\]{}()*+?.\\^$|]/.test(string)) return string.replace(/[[\]{}()*+?.\\^$|]/g, "\\$&");
                return string;
            },
            stringReplaceAllUnchecked: function(receiver, pattern, replacement) {
                var nativeRegexp;
                if (typeof pattern == "string") return A.stringReplaceAllUncheckedString(receiver, pattern, replacement);
                if (pattern instanceof A.JSSyntaxRegExp) {
                    nativeRegexp = pattern.get$_nativeGlobalVersion();
                    nativeRegexp.lastIndex = 0;
                    return receiver.replace(nativeRegexp, A.escapeReplacement(replacement));
                }
                return A.stringReplaceAllGeneral(receiver, pattern, replacement);
            },
            stringReplaceAllGeneral: function(receiver, pattern, replacement) {
                var t1, startIndex, t2, match;
                for(t1 = J.allMatches$1$s(pattern, receiver), t1 = t1.get$iterator(t1), startIndex = 0, t2 = ""; t1.moveNext$0();){
                    match = t1.get$current(t1);
                    t2 = t2 + receiver.substring(startIndex, match.get$start(match)) + replacement;
                    startIndex = match.get$end(match);
                }
                t1 = t2 + receiver.substring(startIndex);
                return t1.charCodeAt(0) == 0 ? t1 : t1;
            },
            stringReplaceAllUncheckedString: function(receiver, pattern, replacement) {
                var $length, t1, i;
                if (pattern === "") {
                    if (receiver === "") return replacement;
                    $length = receiver.length;
                    for(t1 = replacement, i = 0; i < $length; ++i)t1 = t1 + receiver[i] + replacement;
                    return t1.charCodeAt(0) == 0 ? t1 : t1;
                }
                if (receiver.indexOf(pattern, 0) < 0) return receiver;
                if (receiver.length < 500 || replacement.indexOf("$", 0) >= 0) return receiver.split(pattern).join(replacement);
                return receiver.replace(new RegExp(A.quoteStringForRegExp(pattern), "g"), A.escapeReplacement(replacement));
            },
            stringReplaceFirstUnchecked: function(receiver, pattern, replacement, startIndex) {
                var index, t1, matches, match;
                if (typeof pattern == "string") {
                    index = receiver.indexOf(pattern, startIndex);
                    if (index < 0) return receiver;
                    return A.stringReplaceRangeUnchecked(receiver, index, index + pattern.length, replacement);
                }
                if (pattern instanceof A.JSSyntaxRegExp) return startIndex === 0 ? receiver.replace(pattern._nativeRegExp, A.escapeReplacement(replacement)) : A.stringReplaceFirstRE(receiver, pattern, replacement, startIndex);
                t1 = J.allMatches$2$s(pattern, receiver, startIndex);
                matches = t1.get$iterator(t1);
                if (!matches.moveNext$0()) return receiver;
                match = matches.get$current(matches);
                return B.JSString_methods.replaceRange$3(receiver, match.get$start(match), match.get$end(match), replacement);
            },
            stringReplaceRangeUnchecked: function(receiver, start, end, replacement) {
                return receiver.substring(0, start) + replacement + receiver.substring(end);
            },
            _Record_1: function _Record_1(t0) {
                this._0 = t0;
            },
            _Record_2: function _Record_2(t0, t1) {
                this._0 = t0;
                this._1 = t1;
            },
            _Record_2_forImport: function _Record_2_forImport(t0, t1) {
                this._0 = t0;
                this._1 = t1;
            },
            _Record_2_imports_modules: function _Record_2_imports_modules(t0, t1) {
                this._0 = t0;
                this._1 = t1;
            },
            _Record_2_loadedUrls_stylesheet: function _Record_2_loadedUrls_stylesheet(t0, t1) {
                this._0 = t0;
                this._1 = t1;
            },
            _Record_2_sourceMap: function _Record_2_sourceMap(t0, t1) {
                this._0 = t0;
                this._1 = t1;
            },
            _Record_3: function _Record_3(t0, t1, t2) {
                this._0 = t0;
                this._1 = t1;
                this._2 = t2;
            },
            _Record_3_deprecation_message_span: function _Record_3_deprecation_message_span(t0, t1, t2) {
                this._0 = t0;
                this._1 = t1;
                this._2 = t2;
            },
            _Record_3_forImport: function _Record_3_forImport(t0, t1, t2) {
                this._0 = t0;
                this._1 = t1;
                this._2 = t2;
            },
            _Record_3_importer_isDependency: function _Record_3_importer_isDependency(t0, t1, t2) {
                this._0 = t0;
                this._1 = t1;
                this._2 = t2;
            },
            _Record_3_originalUrl: function _Record_3_originalUrl(t0, t1, t2) {
                this._0 = t0;
                this._1 = t1;
                this._2 = t2;
            },
            _Record_5_named_namedNodes_positional_positionalNodes_separator: function _Record_5_named_namedNodes_positional_positionalNodes_separator(t0) {
                this._values = t0;
            },
            ConstantMapView: function ConstantMapView(t0, t1) {
                this._map = t0;
                this.$ti = t1;
            },
            ConstantMap: function ConstantMap() {},
            ConstantStringMap: function ConstantStringMap(t0, t1, t2) {
                this._jsIndex = t0;
                this._values = t1;
                this.$ti = t2;
            },
            _KeysOrValues: function _KeysOrValues(t0, t1) {
                this._elements = t0;
                this.$ti = t1;
            },
            _KeysOrValuesOrElementsIterator: function _KeysOrValuesOrElementsIterator(t0, t1, t2) {
                var _ = this;
                _._elements = t0;
                _.__js_helper$_length = t1;
                _.__js_helper$_index = 0;
                _.__js_helper$_current = null;
                _.$ti = t2;
            },
            ConstantSet: function ConstantSet() {},
            ConstantStringSet: function ConstantStringSet(t0, t1, t2) {
                this._jsIndex = t0;
                this.__js_helper$_length = t1;
                this.$ti = t2;
            },
            GeneralConstantSet: function GeneralConstantSet(t0, t1) {
                this._elements = t0;
                this.$ti = t1;
            },
            Instantiation: function Instantiation() {},
            Instantiation1: function Instantiation1(t0, t1) {
                this._genericClosure = t0;
                this.$ti = t1;
            },
            JSInvocationMirror: function JSInvocationMirror(t0, t1, t2, t3, t4) {
                var _ = this;
                _.__js_helper$_memberName = t0;
                _.__js_helper$_kind = t1;
                _._arguments = t2;
                _._namedArgumentNames = t3;
                _._typeArgumentCount = t4;
            },
            Primitives_functionNoSuchMethod_closure: function Primitives_functionNoSuchMethod_closure(t0, t1, t2) {
                this._box_0 = t0;
                this.namedArgumentList = t1;
                this.$arguments = t2;
            },
            SafeToStringHook: function SafeToStringHook() {},
            TypeErrorDecoder: function TypeErrorDecoder(t0, t1, t2, t3, t4, t5) {
                var _ = this;
                _._pattern = t0;
                _._arguments = t1;
                _._argumentsExpr = t2;
                _._expr = t3;
                _._method = t4;
                _._receiver = t5;
            },
            NullError: function NullError() {},
            JsNoSuchMethodError: function JsNoSuchMethodError(t0, t1, t2) {
                this.__js_helper$_message = t0;
                this._method = t1;
                this._receiver = t2;
            },
            UnknownJsTypeError: function UnknownJsTypeError(t0) {
                this.__js_helper$_message = t0;
            },
            NullThrownFromJavaScriptException: function NullThrownFromJavaScriptException(t0) {
                this._irritant = t0;
            },
            ExceptionAndStackTrace: function ExceptionAndStackTrace(t0, t1) {
                this.dartException = t0;
                this.stackTrace = t1;
            },
            _StackTrace: function _StackTrace(t0) {
                this._exception = t0;
                this._trace = null;
            },
            Closure: function Closure() {},
            Closure0Args: function Closure0Args() {},
            Closure2Args: function Closure2Args() {},
            TearOffClosure: function TearOffClosure() {},
            StaticClosure: function StaticClosure() {},
            BoundClosure: function BoundClosure(t0, t1) {
                this._receiver = t0;
                this._interceptor = t1;
            },
            RuntimeError: function RuntimeError(t0) {
                this.message = t0;
            },
            _Required: function _Required() {},
            JsLinkedHashMap: function JsLinkedHashMap(t0) {
                var _ = this;
                _.__js_helper$_length = 0;
                _._last = _._first = _.__js_helper$_rest = _._nums = _._strings = null;
                _._modifications = 0;
                _.$ti = t0;
            },
            JsLinkedHashMap_addAll_closure: function JsLinkedHashMap_addAll_closure(t0) {
                this.$this = t0;
            },
            LinkedHashMapCell: function LinkedHashMapCell(t0, t1) {
                var _ = this;
                _.hashMapCellKey = t0;
                _.hashMapCellValue = t1;
                _._previous = _._next = null;
            },
            LinkedHashMapKeysIterable: function LinkedHashMapKeysIterable(t0, t1) {
                this.__js_helper$_map = t0;
                this.$ti = t1;
            },
            LinkedHashMapKeyIterator: function LinkedHashMapKeyIterator(t0, t1, t2) {
                var _ = this;
                _.__js_helper$_map = t0;
                _._modifications = t1;
                _._cell = t2;
                _.__js_helper$_current = null;
            },
            LinkedHashMapValuesIterable: function LinkedHashMapValuesIterable(t0, t1) {
                this.__js_helper$_map = t0;
                this.$ti = t1;
            },
            LinkedHashMapValueIterator: function LinkedHashMapValueIterator(t0, t1, t2) {
                var _ = this;
                _.__js_helper$_map = t0;
                _._modifications = t1;
                _._cell = t2;
                _.__js_helper$_current = null;
            },
            LinkedHashMapEntriesIterable: function LinkedHashMapEntriesIterable(t0, t1) {
                this.__js_helper$_map = t0;
                this.$ti = t1;
            },
            LinkedHashMapEntryIterator: function LinkedHashMapEntryIterator(t0, t1, t2, t3) {
                var _ = this;
                _.__js_helper$_map = t0;
                _._modifications = t1;
                _._cell = t2;
                _.__js_helper$_current = null;
                _.$ti = t3;
            },
            JsIdentityLinkedHashMap: function JsIdentityLinkedHashMap(t0) {
                var _ = this;
                _.__js_helper$_length = 0;
                _._last = _._first = _.__js_helper$_rest = _._nums = _._strings = null;
                _._modifications = 0;
                _.$ti = t0;
            },
            JsConstantLinkedHashMap: function JsConstantLinkedHashMap(t0) {
                var _ = this;
                _.__js_helper$_length = 0;
                _._last = _._first = _.__js_helper$_rest = _._nums = _._strings = null;
                _._modifications = 0;
                _.$ti = t0;
            },
            initHooks_closure: function initHooks_closure(t0) {
                this.getTag = t0;
            },
            initHooks_closure0: function initHooks_closure0(t0) {
                this.getUnknownTag = t0;
            },
            initHooks_closure1: function initHooks_closure1(t0) {
                this.prototypeForTag = t0;
            },
            _Record: function _Record() {},
            _Record2: function _Record2() {},
            _Record1: function _Record1() {},
            _Record3: function _Record3() {},
            _RecordN: function _RecordN() {},
            JSSyntaxRegExp: function JSSyntaxRegExp(t0, t1) {
                var _ = this;
                _.pattern = t0;
                _._nativeRegExp = t1;
                _._hasCapturesCache = _._nativeAnchoredRegExp = _._nativeGlobalRegExp = null;
            },
            _MatchImplementation: function _MatchImplementation(t0) {
                this._match = t0;
            },
            _AllMatchesIterable: function _AllMatchesIterable(t0, t1, t2) {
                this._re = t0;
                this.__js_helper$_string = t1;
                this.__js_helper$_start = t2;
            },
            _AllMatchesIterator: function _AllMatchesIterator(t0, t1, t2) {
                var _ = this;
                _._regExp = t0;
                _.__js_helper$_string = t1;
                _._nextIndex = t2;
                _.__js_helper$_current = null;
            },
            StringMatch: function StringMatch(t0, t1) {
                this.start = t0;
                this.pattern = t1;
            },
            _StringAllMatchesIterable: function _StringAllMatchesIterable(t0, t1, t2) {
                this._input = t0;
                this._pattern = t1;
                this.__js_helper$_index = t2;
            },
            _StringAllMatchesIterator: function _StringAllMatchesIterator(t0, t1, t2) {
                var _ = this;
                _._input = t0;
                _._pattern = t1;
                _.__js_helper$_index = t2;
                _.__js_helper$_current = null;
            },
            throwLateFieldADI: function(fieldName) {
                throw A.initializeExceptionWrapper(A.LateError$fieldADI(fieldName), new Error());
            },
            throwUnnamedLateFieldNI: function() {
                throw A.initializeExceptionWrapper(A.LateError$fieldNI(""), new Error());
            },
            throwUnnamedLateFieldAI: function() {
                throw A.initializeExceptionWrapper(A.LateError$fieldAI(""), new Error());
            },
            throwUnnamedLateFieldADI: function() {
                throw A.initializeExceptionWrapper(A.LateError$fieldADI(""), new Error());
            },
            _Cell$: function() {
                var t1 = new A._Cell();
                return t1.__late_helper$_value = t1;
            },
            _Cell: function _Cell() {
                this.__late_helper$_value = null;
            },
            _ensureNativeList: function(list) {
                return list;
            },
            NativeFloat64List_NativeFloat64List$fromList: function(elements) {
                return new Float64Array(A._ensureNativeList(elements));
            },
            NativeInt8List__create1: function(arg) {
                return new Int8Array(arg);
            },
            NativeUint8List_NativeUint8List: function($length) {
                return new Uint8Array($length);
            },
            _checkValidIndex: function(index, list, $length) {
                if (index >>> 0 !== index || index >= $length) throw A.wrapException(A.diagnoseIndexError(list, index));
            },
            _checkValidRange: function(start, end, $length) {
                var t1;
                if (!(start >>> 0 !== start)) {
                    if (end == null) t1 = start > $length;
                    else t1 = end >>> 0 !== end || start > end || end > $length;
                } else t1 = true;
                if (t1) throw A.wrapException(A.diagnoseRangeError(start, end, $length));
                if (end == null) return $length;
                return end;
            },
            NativeByteBuffer: function NativeByteBuffer() {},
            NativeTypedData: function NativeTypedData() {},
            NativeByteData: function NativeByteData() {},
            NativeTypedArray: function NativeTypedArray() {},
            NativeTypedArrayOfDouble: function NativeTypedArrayOfDouble() {},
            NativeTypedArrayOfInt: function NativeTypedArrayOfInt() {},
            NativeFloat32List: function NativeFloat32List() {},
            NativeFloat64List: function NativeFloat64List() {},
            NativeInt16List: function NativeInt16List() {},
            NativeInt32List: function NativeInt32List() {},
            NativeInt8List: function NativeInt8List() {},
            NativeUint16List: function NativeUint16List() {},
            NativeUint32List: function NativeUint32List() {},
            NativeUint8ClampedList: function NativeUint8ClampedList() {},
            NativeUint8List: function NativeUint8List() {},
            _NativeTypedArrayOfDouble_NativeTypedArray_ListMixin: function _NativeTypedArrayOfDouble_NativeTypedArray_ListMixin() {},
            _NativeTypedArrayOfDouble_NativeTypedArray_ListMixin_FixedLengthListMixin: function _NativeTypedArrayOfDouble_NativeTypedArray_ListMixin_FixedLengthListMixin() {},
            _NativeTypedArrayOfInt_NativeTypedArray_ListMixin: function _NativeTypedArrayOfInt_NativeTypedArray_ListMixin() {},
            _NativeTypedArrayOfInt_NativeTypedArray_ListMixin_FixedLengthListMixin: function _NativeTypedArrayOfInt_NativeTypedArray_ListMixin_FixedLengthListMixin() {},
            Rti__getFutureFromFutureOr: function(universe, rti) {
                var future = rti._precomputed1;
                return future == null ? rti._precomputed1 = A._Universe__lookupInterfaceRti(universe, "Future", [
                    rti._primary
                ]) : future;
            },
            Rti__isUnionOfFunctionType: function(rti) {
                var kind = rti._kind;
                if (kind === 6 || kind === 7) return A.Rti__isUnionOfFunctionType(rti._primary);
                return kind === 11 || kind === 12;
            },
            Rti__getCanonicalRecipe: function(rti) {
                return rti._canonicalRecipe;
            },
            pairwiseIsTest: function(fieldRtis, values) {
                var i, $length = values.length;
                for(i = 0; i < $length; ++i)if (!fieldRtis[i]._is(values[i])) return false;
                return true;
            },
            findType: function(recipe) {
                return A._Universe_eval(init.typeUniverse, recipe, false);
            },
            instantiatedGenericFunctionType: function(genericFunctionRti, instantiationRti) {
                var t1, cache, key, probe, rti;
                if (genericFunctionRti == null) return null;
                t1 = instantiationRti._rest;
                cache = genericFunctionRti._bindCache;
                if (cache == null) cache = genericFunctionRti._bindCache = new Map();
                key = instantiationRti._canonicalRecipe;
                probe = cache.get(key);
                if (probe != null) return probe;
                rti = A._substitute(init.typeUniverse, genericFunctionRti._primary, t1, 0);
                cache.set(key, rti);
                return rti;
            },
            _substitute: function(universe, rti, typeArguments, depth) {
                var baseType, substitutedBaseType, interfaceTypeArguments, substitutedInterfaceTypeArguments, base, substitutedBase, $arguments, substitutedArguments, t1, fields, substitutedFields, returnType, substitutedReturnType, functionParameters, substitutedFunctionParameters, bounds, substitutedBounds, index, argument, kind = rti._kind;
                switch(kind){
                    case 5:
                    case 1:
                    case 2:
                    case 3:
                    case 4:
                        return rti;
                    case 6:
                        baseType = rti._primary;
                        substitutedBaseType = A._substitute(universe, baseType, typeArguments, depth);
                        if (substitutedBaseType === baseType) return rti;
                        return A._Universe__lookupQuestionRti(universe, substitutedBaseType, true);
                    case 7:
                        baseType = rti._primary;
                        substitutedBaseType = A._substitute(universe, baseType, typeArguments, depth);
                        if (substitutedBaseType === baseType) return rti;
                        return A._Universe__lookupFutureOrRti(universe, substitutedBaseType, true);
                    case 8:
                        interfaceTypeArguments = rti._rest;
                        substitutedInterfaceTypeArguments = A._substituteArray(universe, interfaceTypeArguments, typeArguments, depth);
                        if (substitutedInterfaceTypeArguments === interfaceTypeArguments) return rti;
                        return A._Universe__lookupInterfaceRti(universe, rti._primary, substitutedInterfaceTypeArguments);
                    case 9:
                        base = rti._primary;
                        substitutedBase = A._substitute(universe, base, typeArguments, depth);
                        $arguments = rti._rest;
                        substitutedArguments = A._substituteArray(universe, $arguments, typeArguments, depth);
                        if (substitutedBase === base && substitutedArguments === $arguments) return rti;
                        return A._Universe__lookupBindingRti(universe, substitutedBase, substitutedArguments);
                    case 10:
                        t1 = rti._primary;
                        fields = rti._rest;
                        substitutedFields = A._substituteArray(universe, fields, typeArguments, depth);
                        if (substitutedFields === fields) return rti;
                        return A._Universe__lookupRecordRti(universe, t1, substitutedFields);
                    case 11:
                        returnType = rti._primary;
                        substitutedReturnType = A._substitute(universe, returnType, typeArguments, depth);
                        functionParameters = rti._rest;
                        substitutedFunctionParameters = A._substituteFunctionParameters(universe, functionParameters, typeArguments, depth);
                        if (substitutedReturnType === returnType && substitutedFunctionParameters === functionParameters) return rti;
                        return A._Universe__lookupFunctionRti(universe, substitutedReturnType, substitutedFunctionParameters);
                    case 12:
                        bounds = rti._rest;
                        depth += bounds.length;
                        substitutedBounds = A._substituteArray(universe, bounds, typeArguments, depth);
                        base = rti._primary;
                        substitutedBase = A._substitute(universe, base, typeArguments, depth);
                        if (substitutedBounds === bounds && substitutedBase === base) return rti;
                        return A._Universe__lookupGenericFunctionRti(universe, substitutedBase, substitutedBounds, true);
                    case 13:
                        index = rti._primary;
                        if (index < depth) return rti;
                        argument = typeArguments[index - depth];
                        if (argument == null) return rti;
                        return argument;
                    default:
                        throw A.wrapException(A.AssertionError$("Attempted to substitute unexpected RTI kind " + kind));
                }
            },
            _substituteArray: function(universe, rtiArray, typeArguments, depth) {
                var changed, i, rti, substitutedRti, $length = rtiArray.length, result = A._Utils_newArrayOrEmpty($length);
                for(changed = false, i = 0; i < $length; ++i){
                    rti = rtiArray[i];
                    substitutedRti = A._substitute(universe, rti, typeArguments, depth);
                    if (substitutedRti !== rti) changed = true;
                    result[i] = substitutedRti;
                }
                return changed ? result : rtiArray;
            },
            _substituteNamed: function(universe, namedArray, typeArguments, depth) {
                var changed, i, t1, t2, rti, substitutedRti, $length = namedArray.length, result = A._Utils_newArrayOrEmpty($length);
                for(changed = false, i = 0; i < $length; i += 3){
                    t1 = namedArray[i];
                    t2 = namedArray[i + 1];
                    rti = namedArray[i + 2];
                    substitutedRti = A._substitute(universe, rti, typeArguments, depth);
                    if (substitutedRti !== rti) changed = true;
                    result.splice(i, 3, t1, t2, substitutedRti);
                }
                return changed ? result : namedArray;
            },
            _substituteFunctionParameters: function(universe, functionParameters, typeArguments, depth) {
                var result, requiredPositional = functionParameters._requiredPositional, substitutedRequiredPositional = A._substituteArray(universe, requiredPositional, typeArguments, depth), optionalPositional = functionParameters._optionalPositional, substitutedOptionalPositional = A._substituteArray(universe, optionalPositional, typeArguments, depth), named = functionParameters._named, substitutedNamed = A._substituteNamed(universe, named, typeArguments, depth);
                if (substitutedRequiredPositional === requiredPositional && substitutedOptionalPositional === optionalPositional && substitutedNamed === named) return functionParameters;
                result = new A._FunctionParameters();
                result._requiredPositional = substitutedRequiredPositional;
                result._optionalPositional = substitutedOptionalPositional;
                result._named = substitutedNamed;
                return result;
            },
            _setArrayType: function(target, rti) {
                target[init.arrayRti] = rti;
                return target;
            },
            closureFunctionType: function(closure) {
                var signature = closure.$signature;
                if (signature != null) {
                    if (typeof signature == "number") return A.getTypeFromTypesTable(signature);
                    return closure.$signature();
                }
                return null;
            },
            instanceOrFunctionType: function(object, testRti) {
                var rti;
                if (A.Rti__isUnionOfFunctionType(testRti)) {
                    if (object instanceof A.Closure) {
                        rti = A.closureFunctionType(object);
                        if (rti != null) return rti;
                    }
                }
                return A.instanceType(object);
            },
            instanceType: function(object) {
                if (object instanceof A.Object) return A._instanceType(object);
                if (Array.isArray(object)) return A._arrayInstanceType(object);
                return A._instanceTypeFromConstructor(J.getInterceptor$(object));
            },
            _arrayInstanceType: function(object) {
                var rti = object[init.arrayRti], defaultRti = type$.JSArray_dynamic;
                if (rti == null) return defaultRti;
                if (rti.constructor !== defaultRti.constructor) return defaultRti;
                return rti;
            },
            _instanceType: function(object) {
                var rti = object.$ti;
                return rti != null ? rti : A._instanceTypeFromConstructor(object);
            },
            _instanceTypeFromConstructor: function(instance) {
                var $constructor = instance.constructor, probe = $constructor.$ccache;
                if (probe != null) return probe;
                return A._instanceTypeFromConstructorMiss(instance, $constructor);
            },
            _instanceTypeFromConstructorMiss: function(instance, $constructor) {
                var effectiveConstructor = instance instanceof A.Closure ? Object.getPrototypeOf(Object.getPrototypeOf(instance)).constructor : $constructor, rti = A._Universe_findErasedType(init.typeUniverse, effectiveConstructor.name);
                $constructor.$ccache = rti;
                return rti;
            },
            getTypeFromTypesTable: function(index) {
                var rti, table = init.types, type = table[index];
                if (typeof type == "string") {
                    rti = A._Universe_eval(init.typeUniverse, type, false);
                    table[index] = rti;
                    return rti;
                }
                return type;
            },
            getRuntimeTypeOfDartObject: function(object) {
                return A.createRuntimeType(A._instanceType(object));
            },
            getRuntimeTypeOfClosure: function(closure) {
                var rti = A.closureFunctionType(closure);
                return A.createRuntimeType(rti == null ? A.instanceType(closure) : rti);
            },
            _structuralTypeOf: function(object) {
                var functionRti;
                if (object instanceof A._Record) return A.evaluateRtiForRecord(object.$recipe, object._getFieldValues$0());
                functionRti = object instanceof A.Closure ? A.closureFunctionType(object) : null;
                if (functionRti != null) return functionRti;
                if (type$.TrustedGetRuntimeType._is(object)) return J.get$runtimeType$(object)._rti;
                if (Array.isArray(object)) return A._arrayInstanceType(object);
                return A.instanceType(object);
            },
            createRuntimeType: function(rti) {
                var t1 = rti._cachedRuntimeType;
                return t1 == null ? rti._cachedRuntimeType = new A._Type(rti) : t1;
            },
            evaluateRtiForRecord: function(recordRecipe, valuesList) {
                var bindings, i, values = valuesList, $length = values.length;
                if ($length === 0) return type$.Record_0;
                bindings = A._Universe_evalInEnvironment(init.typeUniverse, A._structuralTypeOf(values[0]), "@<0>");
                for(i = 1; i < $length; ++i)bindings = A._Universe_bind(init.typeUniverse, bindings, A._structuralTypeOf(values[i]));
                return A._Universe_evalInEnvironment(init.typeUniverse, bindings, recordRecipe);
            },
            typeLiteral: function(recipe) {
                return A.createRuntimeType(A._Universe_eval(init.typeUniverse, recipe, false));
            },
            _installSpecializedIsTest: function(object) {
                var testRti = this;
                testRti._is = A._specializedIsTest(testRti);
                return testRti._is(object);
            },
            _specializedIsTest: function(testRti) {
                var kind, simpleIsFn, $name, predicate;
                if (testRti === type$.Object) return A._isObject;
                if (A.isTopType(testRti)) return A._isTop;
                kind = testRti._kind;
                if (kind === 6) return A._generalNullableIsTestImplementation;
                if (kind === 1) return A._isNever;
                if (kind === 7) return A._isFutureOr;
                simpleIsFn = A._simpleSpecializedIsTest(testRti);
                if (simpleIsFn != null) return simpleIsFn;
                if (kind === 8) {
                    $name = testRti._primary;
                    if (testRti._rest.every(A.isTopType)) {
                        testRti._specializedTestResource = "$is" + $name;
                        if ($name === "List") return A._isListTestViaProperty;
                        if (testRti === type$.JSObject) return A._isJSObject;
                        return A._isTestViaProperty;
                    }
                } else if (kind === 10) {
                    predicate = A.createRecordTypePredicate(testRti._primary, testRti._rest);
                    return predicate == null ? A._isNever : predicate;
                }
                return A._generalIsTestImplementation;
            },
            _simpleSpecializedIsTest: function(testRti) {
                if (testRti._kind === 8) {
                    if (testRti === type$.int) return A._isInt;
                    if (testRti === type$.double || testRti === type$.num) return A._isNum;
                    if (testRti === type$.String) return A._isString;
                    if (testRti === type$.bool) return A._isBool;
                }
                return null;
            },
            _installSpecializedAsCheck: function(object) {
                var testRti = this, asFn = A._generalAsCheckImplementation;
                if (A.isTopType(testRti)) asFn = A._asTop;
                else if (testRti === type$.Object) asFn = A._asObject;
                else if (A.isNullable(testRti)) {
                    asFn = A._generalNullableAsCheckImplementation;
                    if (testRti === type$.nullable_int) asFn = A._asIntQ;
                    else if (testRti === type$.nullable_String) asFn = A._asStringQ;
                    else if (testRti === type$.nullable_bool) asFn = A._asBoolQ;
                    else if (testRti === type$.nullable_num) asFn = A._asNumQ;
                    else if (testRti === type$.nullable_double) asFn = A._asDoubleQ;
                    else if (testRti === type$.nullable_JSObject) asFn = A._asJSObjectQ;
                } else if (testRti === type$.int) asFn = A._asInt;
                else if (testRti === type$.String) asFn = A._asString;
                else if (testRti === type$.bool) asFn = A._asBool;
                else if (testRti === type$.num) asFn = A._asNum;
                else if (testRti === type$.double) asFn = A._asDouble;
                else if (testRti === type$.JSObject) asFn = A._asJSObject;
                testRti._as = asFn;
                return testRti._as(object);
            },
            _generalIsTestImplementation: function(object) {
                var testRti = this;
                if (object == null) return A.isNullable(testRti);
                return A.isSubtype(init.typeUniverse, A.instanceOrFunctionType(object, testRti), testRti);
            },
            _generalNullableIsTestImplementation: function(object) {
                if (object == null) return true;
                return this._primary._is(object);
            },
            _isTestViaProperty: function(object) {
                var tag, testRti = this;
                if (object == null) return A.isNullable(testRti);
                tag = testRti._specializedTestResource;
                if (object instanceof A.Object) return !!object[tag];
                return !!J.getInterceptor$(object)[tag];
            },
            _isListTestViaProperty: function(object) {
                var tag, testRti = this;
                if (object == null) return A.isNullable(testRti);
                if ((typeof object === "undefined" ? "undefined" : (0, $6tOPT._)(object)) != "object") return false;
                if (Array.isArray(object)) return true;
                tag = testRti._specializedTestResource;
                if (object instanceof A.Object) return !!object[tag];
                return !!J.getInterceptor$(object)[tag];
            },
            _isJSObject: function(object) {
                var t1 = this;
                if (object == null) return false;
                if ((typeof object === "undefined" ? "undefined" : (0, $6tOPT._)(object)) == "object") {
                    if (object instanceof A.Object) return !!object[t1._specializedTestResource];
                    return true;
                }
                if (typeof object == "function") return true;
                return false;
            },
            _isJSObjectStandalone: function(object) {
                if ((typeof object === "undefined" ? "undefined" : (0, $6tOPT._)(object)) == "object") {
                    if (object instanceof A.Object) return type$.JSObject._is(object);
                    return true;
                }
                if (typeof object == "function") return true;
                return false;
            },
            _generalAsCheckImplementation: function(object) {
                var testRti = this;
                if (object == null) {
                    if (A.isNullable(testRti)) return object;
                } else if (testRti._is(object)) return object;
                throw A.initializeExceptionWrapper(A._errorForAsCheck(object, testRti), new Error());
            },
            _generalNullableAsCheckImplementation: function(object) {
                var testRti = this;
                if (object == null || testRti._is(object)) return object;
                throw A.initializeExceptionWrapper(A._errorForAsCheck(object, testRti), new Error());
            },
            _errorForAsCheck: function(object, testRti) {
                return new A._TypeError("TypeError: " + A._Error_compose(object, A._rtiToString(testRti, null)));
            },
            _Error_compose: function(object, checkedTypeDescription) {
                return A.Error_safeToString(object) + ": type '" + A._rtiToString(A._structuralTypeOf(object), null) + "' is not a subtype of type '" + checkedTypeDescription + "'";
            },
            _TypeError__TypeError$forType: function(object, type) {
                return new A._TypeError("TypeError: " + A._Error_compose(object, type));
            },
            _isFutureOr: function(object) {
                var testRti = this;
                return testRti._primary._is(object) || A.Rti__getFutureFromFutureOr(init.typeUniverse, testRti)._is(object);
            },
            _isObject: function(object) {
                return object != null;
            },
            _asObject: function(object) {
                if (object != null) return object;
                throw A.initializeExceptionWrapper(A._TypeError__TypeError$forType(object, "Object"), new Error());
            },
            _isTop: function(object) {
                return true;
            },
            _asTop: function(object) {
                return object;
            },
            _isNever: function(object) {
                return false;
            },
            _isBool: function(object) {
                return true === object || false === object;
            },
            _asBool: function(object) {
                if (true === object) return true;
                if (false === object) return false;
                throw A.initializeExceptionWrapper(A._TypeError__TypeError$forType(object, "bool"), new Error());
            },
            _asBoolQ: function(object) {
                if (true === object) return true;
                if (false === object) return false;
                if (object == null) return object;
                throw A.initializeExceptionWrapper(A._TypeError__TypeError$forType(object, "bool?"), new Error());
            },
            _asDouble: function(object) {
                if (typeof object == "number") return object;
                throw A.initializeExceptionWrapper(A._TypeError__TypeError$forType(object, "double"), new Error());
            },
            _asDoubleQ: function(object) {
                if (typeof object == "number") return object;
                if (object == null) return object;
                throw A.initializeExceptionWrapper(A._TypeError__TypeError$forType(object, "double?"), new Error());
            },
            _isInt: function(object) {
                return typeof object == "number" && Math.floor(object) === object;
            },
            _asInt: function(object) {
                if (typeof object == "number" && Math.floor(object) === object) return object;
                throw A.initializeExceptionWrapper(A._TypeError__TypeError$forType(object, "int"), new Error());
            },
            _asIntQ: function(object) {
                if (typeof object == "number" && Math.floor(object) === object) return object;
                if (object == null) return object;
                throw A.initializeExceptionWrapper(A._TypeError__TypeError$forType(object, "int?"), new Error());
            },
            _isNum: function(object) {
                return typeof object == "number";
            },
            _asNum: function(object) {
                if (typeof object == "number") return object;
                throw A.initializeExceptionWrapper(A._TypeError__TypeError$forType(object, "num"), new Error());
            },
            _asNumQ: function(object) {
                if (typeof object == "number") return object;
                if (object == null) return object;
                throw A.initializeExceptionWrapper(A._TypeError__TypeError$forType(object, "num?"), new Error());
            },
            _isString: function(object) {
                return typeof object == "string";
            },
            _asString: function(object) {
                if (typeof object == "string") return object;
                throw A.initializeExceptionWrapper(A._TypeError__TypeError$forType(object, "String"), new Error());
            },
            _asStringQ: function(object) {
                if (typeof object == "string") return object;
                if (object == null) return object;
                throw A.initializeExceptionWrapper(A._TypeError__TypeError$forType(object, "String?"), new Error());
            },
            _asJSObject: function(object) {
                if (A._isJSObjectStandalone(object)) return object;
                throw A.initializeExceptionWrapper(A._TypeError__TypeError$forType(object, "JSObject"), new Error());
            },
            _asJSObjectQ: function(object) {
                if (object == null) return object;
                if (A._isJSObjectStandalone(object)) return object;
                throw A.initializeExceptionWrapper(A._TypeError__TypeError$forType(object, "JSObject?"), new Error());
            },
            _rtiArrayToString: function(array, genericContext) {
                var s, sep, i;
                for(s = "", sep = "", i = 0; i < array.length; ++i, sep = ", ")s += sep + A._rtiToString(array[i], genericContext);
                return s;
            },
            _recordRtiToString: function(recordType, genericContext) {
                var fieldCount, names, namesIndex, s, comma, i, partialShape = recordType._primary, fields = recordType._rest;
                if ("" === partialShape) return "(" + A._rtiArrayToString(fields, genericContext) + ")";
                fieldCount = fields.length;
                names = partialShape.split(",");
                namesIndex = names.length - fieldCount;
                for(s = "(", comma = "", i = 0; i < fieldCount; ++i, comma = ", "){
                    s += comma;
                    if (namesIndex === 0) s += "{";
                    s += A._rtiToString(fields[i], genericContext);
                    if (namesIndex >= 0) s += " " + names[namesIndex];
                    ++namesIndex;
                }
                return s + "})";
            },
            _functionRtiToString: function(functionType, genericContext, bounds) {
                var boundsLength, offset, i, t1, typeParametersText, typeSep, boundRti, kind, parameters, requiredPositional, requiredPositionalLength, optionalPositional, optionalPositionalLength, named, namedLength, returnTypeText, argumentsText, sep, _s2_ = ", ", outerContextLength = null;
                if (bounds != null) {
                    boundsLength = bounds.length;
                    if (genericContext == null) genericContext = A._setArrayType([], type$.JSArray_String);
                    else outerContextLength = genericContext.length;
                    offset = genericContext.length;
                    for(i = boundsLength; i > 0; --i)genericContext.push("T" + (offset + i));
                    for(t1 = type$.nullable_Object, typeParametersText = "<", typeSep = "", i = 0; i < boundsLength; ++i, typeSep = _s2_){
                        typeParametersText = typeParametersText + typeSep + genericContext[genericContext.length - 1 - i];
                        boundRti = bounds[i];
                        kind = boundRti._kind;
                        if (!(kind === 2 || kind === 3 || kind === 4 || kind === 5 || boundRti === t1)) typeParametersText += " extends " + A._rtiToString(boundRti, genericContext);
                    }
                    typeParametersText += ">";
                } else typeParametersText = "";
                t1 = functionType._primary;
                parameters = functionType._rest;
                requiredPositional = parameters._requiredPositional;
                requiredPositionalLength = requiredPositional.length;
                optionalPositional = parameters._optionalPositional;
                optionalPositionalLength = optionalPositional.length;
                named = parameters._named;
                namedLength = named.length;
                returnTypeText = A._rtiToString(t1, genericContext);
                for(argumentsText = "", sep = "", i = 0; i < requiredPositionalLength; ++i, sep = _s2_)argumentsText += sep + A._rtiToString(requiredPositional[i], genericContext);
                if (optionalPositionalLength > 0) {
                    argumentsText += sep + "[";
                    for(sep = "", i = 0; i < optionalPositionalLength; ++i, sep = _s2_)argumentsText += sep + A._rtiToString(optionalPositional[i], genericContext);
                    argumentsText += "]";
                }
                if (namedLength > 0) {
                    argumentsText += sep + "{";
                    for(sep = "", i = 0; i < namedLength; i += 3, sep = _s2_){
                        argumentsText += sep;
                        if (named[i + 1]) argumentsText += "required ";
                        argumentsText += A._rtiToString(named[i + 2], genericContext) + " " + named[i];
                    }
                    argumentsText += "}";
                }
                if (outerContextLength != null) {
                    genericContext.toString;
                    genericContext.length = outerContextLength;
                }
                return typeParametersText + "(" + argumentsText + ") => " + returnTypeText;
            },
            _rtiToString: function(rti, genericContext) {
                var questionArgument, s, argumentKind, $name, $arguments, t1, kind = rti._kind;
                if (kind === 5) return "erased";
                if (kind === 2) return "dynamic";
                if (kind === 3) return "void";
                if (kind === 1) return "Never";
                if (kind === 4) return "any";
                if (kind === 6) {
                    questionArgument = rti._primary;
                    s = A._rtiToString(questionArgument, genericContext);
                    argumentKind = questionArgument._kind;
                    return (argumentKind === 11 || argumentKind === 12 ? "(" + s + ")" : s) + "?";
                }
                if (kind === 7) return "FutureOr<" + A._rtiToString(rti._primary, genericContext) + ">";
                if (kind === 8) {
                    $name = A._unminifyOrTag(rti._primary);
                    $arguments = rti._rest;
                    return $arguments.length > 0 ? $name + ("<" + A._rtiArrayToString($arguments, genericContext) + ">") : $name;
                }
                if (kind === 10) return A._recordRtiToString(rti, genericContext);
                if (kind === 11) return A._functionRtiToString(rti, genericContext, null);
                if (kind === 12) return A._functionRtiToString(rti._primary, genericContext, rti._rest);
                if (kind === 13) {
                    t1 = rti._primary;
                    return genericContext[genericContext.length - 1 - t1];
                }
                return "?";
            },
            _unminifyOrTag: function(rawClassName) {
                var preserved = init.mangledGlobalNames[rawClassName];
                if (preserved != null) return preserved;
                return rawClassName;
            },
            _Universe_findRule: function(universe, targetType) {
                var rule = universe.tR[targetType];
                while(typeof rule == "string")rule = universe.tR[rule];
                return rule;
            },
            _Universe_findErasedType: function(universe, cls) {
                var $length, erased, $arguments, i, $interface, metadata = universe.eT, probe = metadata[cls];
                if (probe == null) return A._Universe_eval(universe, cls, false);
                else if (typeof probe == "number") {
                    $length = probe;
                    erased = A._Universe__lookupTerminalRti(universe, 5, "#");
                    $arguments = A._Utils_newArrayOrEmpty($length);
                    for(i = 0; i < $length; ++i)$arguments[i] = erased;
                    $interface = A._Universe__lookupInterfaceRti(universe, cls, $arguments);
                    metadata[cls] = $interface;
                    return $interface;
                } else return probe;
            },
            _Universe_addRules: function(universe, rules) {
                return A._Utils_objectAssign(universe.tR, rules);
            },
            _Universe_addErasedTypes: function(universe, types) {
                return A._Utils_objectAssign(universe.eT, types);
            },
            _Universe_eval: function(universe, recipe, normalize) {
                var rti, cache = universe.eC, probe = cache.get(recipe);
                if (probe != null) return probe;
                rti = A._Parser_parse(A._Parser_create(universe, null, recipe, false));
                cache.set(recipe, rti);
                return rti;
            },
            _Universe_evalInEnvironment: function(universe, environment, recipe) {
                var probe, rti, cache = environment._evalCache;
                if (cache == null) cache = environment._evalCache = new Map();
                probe = cache.get(recipe);
                if (probe != null) return probe;
                rti = A._Parser_parse(A._Parser_create(universe, environment, recipe, true));
                cache.set(recipe, rti);
                return rti;
            },
            _Universe_bind: function(universe, environment, argumentsRti) {
                var argumentsRecipe, probe, rti, cache = environment._bindCache;
                if (cache == null) cache = environment._bindCache = new Map();
                argumentsRecipe = argumentsRti._canonicalRecipe;
                probe = cache.get(argumentsRecipe);
                if (probe != null) return probe;
                rti = A._Universe__lookupBindingRti(universe, environment, argumentsRti._kind === 9 ? argumentsRti._rest : [
                    argumentsRti
                ]);
                cache.set(argumentsRecipe, rti);
                return rti;
            },
            _Universe__installTypeTests: function(universe, rti) {
                rti._as = A._installSpecializedAsCheck;
                rti._is = A._installSpecializedIsTest;
                return rti;
            },
            _Universe__lookupTerminalRti: function(universe, kind, key) {
                var rti, t1, probe = universe.eC.get(key);
                if (probe != null) return probe;
                rti = new A.Rti(null, null);
                rti._kind = kind;
                rti._canonicalRecipe = key;
                t1 = A._Universe__installTypeTests(universe, rti);
                universe.eC.set(key, t1);
                return t1;
            },
            _Universe__lookupQuestionRti: function(universe, baseType, normalize) {
                var t1, key = baseType._canonicalRecipe + "?", probe = universe.eC.get(key);
                if (probe != null) return probe;
                t1 = A._Universe__createQuestionRti(universe, baseType, key, normalize);
                universe.eC.set(key, t1);
                return t1;
            },
            _Universe__createQuestionRti: function(universe, baseType, key, normalize) {
                var baseKind, t1, rti;
                if (normalize) {
                    baseKind = baseType._kind;
                    t1 = true;
                    if (!A.isTopType(baseType)) {
                        if (!(baseType === type$.Null || baseType === type$.JSNull)) {
                            if (baseKind !== 6) t1 = baseKind === 7 && A.isNullable(baseType._primary);
                        }
                    }
                    if (t1) return baseType;
                    else if (baseKind === 1) return type$.Null;
                }
                rti = new A.Rti(null, null);
                rti._kind = 6;
                rti._primary = baseType;
                rti._canonicalRecipe = key;
                return A._Universe__installTypeTests(universe, rti);
            },
            _Universe__lookupFutureOrRti: function(universe, baseType, normalize) {
                var t1, key = baseType._canonicalRecipe + "/", probe = universe.eC.get(key);
                if (probe != null) return probe;
                t1 = A._Universe__createFutureOrRti(universe, baseType, key, normalize);
                universe.eC.set(key, t1);
                return t1;
            },
            _Universe__createFutureOrRti: function(universe, baseType, key, normalize) {
                var t1, rti;
                if (normalize) {
                    t1 = baseType._kind;
                    if (A.isTopType(baseType) || baseType === type$.Object) return baseType;
                    else if (t1 === 1) return A._Universe__lookupInterfaceRti(universe, "Future", [
                        baseType
                    ]);
                    else if (baseType === type$.Null || baseType === type$.JSNull) return type$.nullable_Future_Null;
                }
                rti = new A.Rti(null, null);
                rti._kind = 7;
                rti._primary = baseType;
                rti._canonicalRecipe = key;
                return A._Universe__installTypeTests(universe, rti);
            },
            _Universe__lookupGenericFunctionParameterRti: function(universe, index) {
                var rti, t1, key = "" + index + "^", probe = universe.eC.get(key);
                if (probe != null) return probe;
                rti = new A.Rti(null, null);
                rti._kind = 13;
                rti._primary = index;
                rti._canonicalRecipe = key;
                t1 = A._Universe__installTypeTests(universe, rti);
                universe.eC.set(key, t1);
                return t1;
            },
            _Universe__canonicalRecipeJoin: function($arguments) {
                var s, sep, i, $length = $arguments.length;
                for(s = "", sep = "", i = 0; i < $length; ++i, sep = ",")s += sep + $arguments[i]._canonicalRecipe;
                return s;
            },
            _Universe__canonicalRecipeJoinNamed: function($arguments) {
                var s, sep, i, t1, nameSep, $length = $arguments.length;
                for(s = "", sep = "", i = 0; i < $length; i += 3, sep = ","){
                    t1 = $arguments[i];
                    nameSep = $arguments[i + 1] ? "!" : ":";
                    s += sep + t1 + nameSep + $arguments[i + 2]._canonicalRecipe;
                }
                return s;
            },
            _Universe__lookupInterfaceRti: function(universe, $name, $arguments) {
                var probe, rti, t1, s = $name;
                if ($arguments.length > 0) s += "<" + A._Universe__canonicalRecipeJoin($arguments) + ">";
                probe = universe.eC.get(s);
                if (probe != null) return probe;
                rti = new A.Rti(null, null);
                rti._kind = 8;
                rti._primary = $name;
                rti._rest = $arguments;
                if ($arguments.length > 0) rti._precomputed1 = $arguments[0];
                rti._canonicalRecipe = s;
                t1 = A._Universe__installTypeTests(universe, rti);
                universe.eC.set(s, t1);
                return t1;
            },
            _Universe__lookupBindingRti: function(universe, base, $arguments) {
                var newBase, newArguments, key, probe, rti, t1;
                if (base._kind === 9) {
                    newBase = base._primary;
                    newArguments = base._rest.concat($arguments);
                } else {
                    newArguments = $arguments;
                    newBase = base;
                }
                key = newBase._canonicalRecipe + (";<" + A._Universe__canonicalRecipeJoin(newArguments) + ">");
                probe = universe.eC.get(key);
                if (probe != null) return probe;
                rti = new A.Rti(null, null);
                rti._kind = 9;
                rti._primary = newBase;
                rti._rest = newArguments;
                rti._canonicalRecipe = key;
                t1 = A._Universe__installTypeTests(universe, rti);
                universe.eC.set(key, t1);
                return t1;
            },
            _Universe__lookupRecordRti: function(universe, partialShapeTag, fields) {
                var rti, t1, key = "+" + (partialShapeTag + "(" + A._Universe__canonicalRecipeJoin(fields) + ")"), probe = universe.eC.get(key);
                if (probe != null) return probe;
                rti = new A.Rti(null, null);
                rti._kind = 10;
                rti._primary = partialShapeTag;
                rti._rest = fields;
                rti._canonicalRecipe = key;
                t1 = A._Universe__installTypeTests(universe, rti);
                universe.eC.set(key, t1);
                return t1;
            },
            _Universe__lookupFunctionRti: function(universe, returnType, parameters) {
                var sep, key, probe, rti, t1, s = returnType._canonicalRecipe, requiredPositional = parameters._requiredPositional, requiredPositionalLength = requiredPositional.length, optionalPositional = parameters._optionalPositional, optionalPositionalLength = optionalPositional.length, named = parameters._named, namedLength = named.length, recipe = "(" + A._Universe__canonicalRecipeJoin(requiredPositional);
                if (optionalPositionalLength > 0) {
                    sep = requiredPositionalLength > 0 ? "," : "";
                    recipe += sep + "[" + A._Universe__canonicalRecipeJoin(optionalPositional) + "]";
                }
                if (namedLength > 0) {
                    sep = requiredPositionalLength > 0 ? "," : "";
                    recipe += sep + "{" + A._Universe__canonicalRecipeJoinNamed(named) + "}";
                }
                key = s + (recipe + ")");
                probe = universe.eC.get(key);
                if (probe != null) return probe;
                rti = new A.Rti(null, null);
                rti._kind = 11;
                rti._primary = returnType;
                rti._rest = parameters;
                rti._canonicalRecipe = key;
                t1 = A._Universe__installTypeTests(universe, rti);
                universe.eC.set(key, t1);
                return t1;
            },
            _Universe__lookupGenericFunctionRti: function(universe, baseFunctionType, bounds, normalize) {
                var t1, key = baseFunctionType._canonicalRecipe + ("<" + A._Universe__canonicalRecipeJoin(bounds) + ">"), probe = universe.eC.get(key);
                if (probe != null) return probe;
                t1 = A._Universe__createGenericFunctionRti(universe, baseFunctionType, bounds, key, normalize);
                universe.eC.set(key, t1);
                return t1;
            },
            _Universe__createGenericFunctionRti: function(universe, baseFunctionType, bounds, key, normalize) {
                var $length, typeArguments, count, i, bound, substitutedBase, substitutedBounds, rti;
                if (normalize) {
                    $length = bounds.length;
                    typeArguments = A._Utils_newArrayOrEmpty($length);
                    for(count = 0, i = 0; i < $length; ++i){
                        bound = bounds[i];
                        if (bound._kind === 1) {
                            typeArguments[i] = bound;
                            ++count;
                        }
                    }
                    if (count > 0) {
                        substitutedBase = A._substitute(universe, baseFunctionType, typeArguments, 0);
                        substitutedBounds = A._substituteArray(universe, bounds, typeArguments, 0);
                        return A._Universe__lookupGenericFunctionRti(universe, substitutedBase, substitutedBounds, bounds !== substitutedBounds);
                    }
                }
                rti = new A.Rti(null, null);
                rti._kind = 12;
                rti._primary = baseFunctionType;
                rti._rest = bounds;
                rti._canonicalRecipe = key;
                return A._Universe__installTypeTests(universe, rti);
            },
            _Parser_create: function(universe, environment, recipe, normalize) {
                return {
                    u: universe,
                    e: environment,
                    r: recipe,
                    s: [],
                    p: 0,
                    n: normalize
                };
            },
            _Parser_parse: function(parser) {
                var t1, i, ch, u, array, end, item, source = parser.r, stack = parser.s;
                for(t1 = source.length, i = 0; i < t1;){
                    ch = source.charCodeAt(i);
                    if (ch >= 48 && ch <= 57) i = A._Parser_handleDigit(i + 1, ch, source, stack);
                    else if ((((ch | 32) >>> 0) - 97 & 65535) < 26 || ch === 95 || ch === 36 || ch === 124) i = A._Parser_handleIdentifier(parser, i, source, stack, false);
                    else if (ch === 46) i = A._Parser_handleIdentifier(parser, i, source, stack, true);
                    else {
                        ++i;
                        switch(ch){
                            case 44:
                                break;
                            case 58:
                                stack.push(false);
                                break;
                            case 33:
                                stack.push(true);
                                break;
                            case 59:
                                stack.push(A._Parser_toType(parser.u, parser.e, stack.pop()));
                                break;
                            case 94:
                                stack.push(A._Universe__lookupGenericFunctionParameterRti(parser.u, stack.pop()));
                                break;
                            case 35:
                                stack.push(A._Universe__lookupTerminalRti(parser.u, 5, "#"));
                                break;
                            case 64:
                                stack.push(A._Universe__lookupTerminalRti(parser.u, 2, "@"));
                                break;
                            case 126:
                                stack.push(A._Universe__lookupTerminalRti(parser.u, 3, "~"));
                                break;
                            case 60:
                                stack.push(parser.p);
                                parser.p = stack.length;
                                break;
                            case 62:
                                A._Parser_handleTypeArguments(parser, stack);
                                break;
                            case 38:
                                A._Parser_handleExtendedOperations(parser, stack);
                                break;
                            case 63:
                                u = parser.u;
                                stack.push(A._Universe__lookupQuestionRti(u, A._Parser_toType(u, parser.e, stack.pop()), parser.n));
                                break;
                            case 47:
                                u = parser.u;
                                stack.push(A._Universe__lookupFutureOrRti(u, A._Parser_toType(u, parser.e, stack.pop()), parser.n));
                                break;
                            case 40:
                                stack.push(-3);
                                stack.push(parser.p);
                                parser.p = stack.length;
                                break;
                            case 41:
                                A._Parser_handleArguments(parser, stack);
                                break;
                            case 91:
                                stack.push(parser.p);
                                parser.p = stack.length;
                                break;
                            case 93:
                                array = stack.splice(parser.p);
                                A._Parser_toTypes(parser.u, parser.e, array);
                                parser.p = stack.pop();
                                stack.push(array);
                                stack.push(-1);
                                break;
                            case 123:
                                stack.push(parser.p);
                                parser.p = stack.length;
                                break;
                            case 125:
                                array = stack.splice(parser.p);
                                A._Parser_toTypesNamed(parser.u, parser.e, array);
                                parser.p = stack.pop();
                                stack.push(array);
                                stack.push(-2);
                                break;
                            case 43:
                                end = source.indexOf("(", i);
                                stack.push(source.substring(i, end));
                                stack.push(-4);
                                stack.push(parser.p);
                                parser.p = stack.length;
                                i = end + 1;
                                break;
                            default:
                                throw "Bad character " + ch;
                        }
                    }
                }
                item = stack.pop();
                return A._Parser_toType(parser.u, parser.e, item);
            },
            _Parser_handleDigit: function(i, digit, source, stack) {
                var t1, ch, value = digit - 48;
                for(t1 = source.length; i < t1; ++i){
                    ch = source.charCodeAt(i);
                    if (!(ch >= 48 && ch <= 57)) break;
                    value = value * 10 + (ch - 48);
                }
                stack.push(value);
                return i;
            },
            _Parser_handleIdentifier: function(parser, start, source, stack, hasPeriod) {
                var t1, ch, t2, string, environment, recipe, i = start + 1;
                for(t1 = source.length; i < t1; ++i){
                    ch = source.charCodeAt(i);
                    if (ch === 46) {
                        if (hasPeriod) break;
                        hasPeriod = true;
                    } else {
                        if (!((((ch | 32) >>> 0) - 97 & 65535) < 26 || ch === 95 || ch === 36 || ch === 124)) t2 = ch >= 48 && ch <= 57;
                        else t2 = true;
                        if (!t2) break;
                    }
                }
                string = source.substring(start, i);
                if (hasPeriod) {
                    t1 = parser.u;
                    environment = parser.e;
                    if (environment._kind === 9) environment = environment._primary;
                    recipe = A._Universe_findRule(t1, environment._primary)[string];
                    if (recipe == null) A.throwExpression('No "' + string + '" in "' + A.Rti__getCanonicalRecipe(environment) + '"');
                    stack.push(A._Universe_evalInEnvironment(t1, environment, recipe));
                } else stack.push(string);
                return i;
            },
            _Parser_handleTypeArguments: function(parser, stack) {
                var base, universe = parser.u, $arguments = A._Parser_collectArray(parser, stack), head = stack.pop();
                if (typeof head == "string") stack.push(A._Universe__lookupInterfaceRti(universe, head, $arguments));
                else {
                    base = A._Parser_toType(universe, parser.e, head);
                    switch(base._kind){
                        case 11:
                            stack.push(A._Universe__lookupGenericFunctionRti(universe, base, $arguments, parser.n));
                            break;
                        default:
                            stack.push(A._Universe__lookupBindingRti(universe, base, $arguments));
                            break;
                    }
                }
            },
            _Parser_handleArguments: function(parser, stack) {
                var requiredPositional, returnType, parameters, universe = parser.u, head = stack.pop(), optionalPositional = null, named = null;
                if (typeof head == "number") switch(head){
                    case -1:
                        optionalPositional = stack.pop();
                        break;
                    case -2:
                        named = stack.pop();
                        break;
                    default:
                        stack.push(head);
                        break;
                }
                else stack.push(head);
                requiredPositional = A._Parser_collectArray(parser, stack);
                head = stack.pop();
                switch(head){
                    case -3:
                        head = stack.pop();
                        if (optionalPositional == null) optionalPositional = universe.sEA;
                        if (named == null) named = universe.sEA;
                        returnType = A._Parser_toType(universe, parser.e, head);
                        parameters = new A._FunctionParameters();
                        parameters._requiredPositional = requiredPositional;
                        parameters._optionalPositional = optionalPositional;
                        parameters._named = named;
                        stack.push(A._Universe__lookupFunctionRti(universe, returnType, parameters));
                        return;
                    case -4:
                        stack.push(A._Universe__lookupRecordRti(universe, stack.pop(), requiredPositional));
                        return;
                    default:
                        throw A.wrapException(A.AssertionError$("Unexpected state under `()`: " + A.S(head)));
                }
            },
            _Parser_handleExtendedOperations: function(parser, stack) {
                var $top = stack.pop();
                if (0 === $top) {
                    stack.push(A._Universe__lookupTerminalRti(parser.u, 1, "0&"));
                    return;
                }
                if (1 === $top) {
                    stack.push(A._Universe__lookupTerminalRti(parser.u, 4, "1&"));
                    return;
                }
                throw A.wrapException(A.AssertionError$("Unexpected extended operation " + A.S($top)));
            },
            _Parser_collectArray: function(parser, stack) {
                var array = stack.splice(parser.p);
                A._Parser_toTypes(parser.u, parser.e, array);
                parser.p = stack.pop();
                return array;
            },
            _Parser_toType: function(universe, environment, item) {
                if (typeof item == "string") return A._Universe__lookupInterfaceRti(universe, item, universe.sEA);
                else if (typeof item == "number") {
                    environment.toString;
                    return A._Parser_indexToType(universe, environment, item);
                } else return item;
            },
            _Parser_toTypes: function(universe, environment, items) {
                var i, $length = items.length;
                for(i = 0; i < $length; ++i)items[i] = A._Parser_toType(universe, environment, items[i]);
            },
            _Parser_toTypesNamed: function(universe, environment, items) {
                var i, $length = items.length;
                for(i = 2; i < $length; i += 3)items[i] = A._Parser_toType(universe, environment, items[i]);
            },
            _Parser_indexToType: function(universe, environment, index) {
                var typeArguments, len, kind = environment._kind;
                if (kind === 9) {
                    if (index === 0) return environment._primary;
                    typeArguments = environment._rest;
                    len = typeArguments.length;
                    if (index <= len) return typeArguments[index - 1];
                    index -= len;
                    environment = environment._primary;
                    kind = environment._kind;
                } else if (index === 0) return environment;
                if (kind !== 8) throw A.wrapException(A.AssertionError$("Indexed base must be an interface type"));
                typeArguments = environment._rest;
                if (index <= typeArguments.length) return typeArguments[index - 1];
                throw A.wrapException(A.AssertionError$("Bad index " + index + " for " + environment.toString$0(0)));
            },
            isSubtype: function(universe, s, t) {
                var result, sCache = s._isSubtypeCache;
                if (sCache == null) sCache = s._isSubtypeCache = new Map();
                result = sCache.get(t);
                if (result == null) {
                    result = A._isSubtype(universe, s, null, t, null);
                    sCache.set(t, result);
                }
                return result;
            },
            _isSubtype: function(universe, s, sEnv, t, tEnv) {
                var sKind, leftTypeVariable, tKind, t1, t2, sBounds, tBounds, sLength, i, sBound, tBound;
                if (s === t) return true;
                if (A.isTopType(t)) return true;
                sKind = s._kind;
                if (sKind === 4) return true;
                if (A.isTopType(s)) return false;
                if (s._kind === 1) return true;
                leftTypeVariable = sKind === 13;
                if (leftTypeVariable) {
                    if (A._isSubtype(universe, sEnv[s._primary], sEnv, t, tEnv)) return true;
                }
                tKind = t._kind;
                t1 = type$.Null;
                if (s === t1 || s === type$.JSNull) {
                    if (tKind === 7) return A._isSubtype(universe, s, sEnv, t._primary, tEnv);
                    return t === t1 || t === type$.JSNull || tKind === 6;
                }
                if (t === type$.Object) {
                    if (sKind === 7) return A._isSubtype(universe, s._primary, sEnv, t, tEnv);
                    return sKind !== 6;
                }
                if (sKind === 7) {
                    if (!A._isSubtype(universe, s._primary, sEnv, t, tEnv)) return false;
                    return A._isSubtype(universe, A.Rti__getFutureFromFutureOr(universe, s), sEnv, t, tEnv);
                }
                if (sKind === 6) return A._isSubtype(universe, t1, sEnv, t, tEnv) && A._isSubtype(universe, s._primary, sEnv, t, tEnv);
                if (tKind === 7) {
                    if (A._isSubtype(universe, s, sEnv, t._primary, tEnv)) return true;
                    return A._isSubtype(universe, s, sEnv, A.Rti__getFutureFromFutureOr(universe, t), tEnv);
                }
                if (tKind === 6) return A._isSubtype(universe, s, sEnv, t1, tEnv) || A._isSubtype(universe, s, sEnv, t._primary, tEnv);
                if (leftTypeVariable) return false;
                t1 = sKind !== 11;
                if ((!t1 || sKind === 12) && t === type$.Function) return true;
                t2 = sKind === 10;
                if (t2 && t === type$.Record) return true;
                if (tKind === 12) {
                    if (s === type$.JavaScriptFunction) return true;
                    if (sKind !== 12) return false;
                    sBounds = s._rest;
                    tBounds = t._rest;
                    sLength = sBounds.length;
                    if (sLength !== tBounds.length) return false;
                    sEnv = sEnv == null ? sBounds : sBounds.concat(sEnv);
                    tEnv = tEnv == null ? tBounds : tBounds.concat(tEnv);
                    for(i = 0; i < sLength; ++i){
                        sBound = sBounds[i];
                        tBound = tBounds[i];
                        if (!A._isSubtype(universe, sBound, sEnv, tBound, tEnv) || !A._isSubtype(universe, tBound, tEnv, sBound, sEnv)) return false;
                    }
                    return A._isFunctionSubtype(universe, s._primary, sEnv, t._primary, tEnv);
                }
                if (tKind === 11) {
                    if (s === type$.JavaScriptFunction) return true;
                    if (t1) return false;
                    return A._isFunctionSubtype(universe, s, sEnv, t, tEnv);
                }
                if (sKind === 8) {
                    if (tKind !== 8) return false;
                    return A._isInterfaceSubtype(universe, s, sEnv, t, tEnv);
                }
                if (t2 && tKind === 10) return A._isRecordSubtype(universe, s, sEnv, t, tEnv);
                return false;
            },
            _isFunctionSubtype: function(universe, s, sEnv, t, tEnv) {
                var sParameters, tParameters, sRequiredPositional, tRequiredPositional, sRequiredPositionalLength, tRequiredPositionalLength, requiredPositionalDelta, sOptionalPositional, tOptionalPositional, sOptionalPositionalLength, tOptionalPositionalLength, i, t1, sNamed, tNamed, sNamedLength, tNamedLength, sIndex, tIndex, tName, sName, sIsRequired;
                if (!A._isSubtype(universe, s._primary, sEnv, t._primary, tEnv)) return false;
                sParameters = s._rest;
                tParameters = t._rest;
                sRequiredPositional = sParameters._requiredPositional;
                tRequiredPositional = tParameters._requiredPositional;
                sRequiredPositionalLength = sRequiredPositional.length;
                tRequiredPositionalLength = tRequiredPositional.length;
                if (sRequiredPositionalLength > tRequiredPositionalLength) return false;
                requiredPositionalDelta = tRequiredPositionalLength - sRequiredPositionalLength;
                sOptionalPositional = sParameters._optionalPositional;
                tOptionalPositional = tParameters._optionalPositional;
                sOptionalPositionalLength = sOptionalPositional.length;
                tOptionalPositionalLength = tOptionalPositional.length;
                if (sRequiredPositionalLength + sOptionalPositionalLength < tRequiredPositionalLength + tOptionalPositionalLength) return false;
                for(i = 0; i < sRequiredPositionalLength; ++i){
                    t1 = sRequiredPositional[i];
                    if (!A._isSubtype(universe, tRequiredPositional[i], tEnv, t1, sEnv)) return false;
                }
                for(i = 0; i < requiredPositionalDelta; ++i){
                    t1 = sOptionalPositional[i];
                    if (!A._isSubtype(universe, tRequiredPositional[sRequiredPositionalLength + i], tEnv, t1, sEnv)) return false;
                }
                for(i = 0; i < tOptionalPositionalLength; ++i){
                    t1 = sOptionalPositional[requiredPositionalDelta + i];
                    if (!A._isSubtype(universe, tOptionalPositional[i], tEnv, t1, sEnv)) return false;
                }
                sNamed = sParameters._named;
                tNamed = tParameters._named;
                sNamedLength = sNamed.length;
                tNamedLength = tNamed.length;
                for(sIndex = 0, tIndex = 0; tIndex < tNamedLength; tIndex += 3){
                    tName = tNamed[tIndex];
                    for(;;){
                        if (sIndex >= sNamedLength) return false;
                        sName = sNamed[sIndex];
                        sIndex += 3;
                        if (tName < sName) return false;
                        sIsRequired = sNamed[sIndex - 2];
                        if (sName < tName) {
                            if (sIsRequired) return false;
                            continue;
                        }
                        t1 = tNamed[tIndex + 1];
                        if (sIsRequired && !t1) return false;
                        t1 = sNamed[sIndex - 1];
                        if (!A._isSubtype(universe, tNamed[tIndex + 2], tEnv, t1, sEnv)) return false;
                        break;
                    }
                }
                while(sIndex < sNamedLength){
                    if (sNamed[sIndex + 1]) return false;
                    sIndex += 3;
                }
                return true;
            },
            _isInterfaceSubtype: function(universe, s, sEnv, t, tEnv) {
                var rule, recipes, $length, supertypeArgs, i, sName = s._primary, tName = t._primary;
                while(sName !== tName){
                    rule = universe.tR[sName];
                    if (rule == null) return false;
                    if (typeof rule == "string") {
                        sName = rule;
                        continue;
                    }
                    recipes = rule[tName];
                    if (recipes == null) return false;
                    $length = recipes.length;
                    supertypeArgs = $length > 0 ? new Array($length) : init.typeUniverse.sEA;
                    for(i = 0; i < $length; ++i)supertypeArgs[i] = A._Universe_evalInEnvironment(universe, s, recipes[i]);
                    return A._areArgumentsSubtypes(universe, supertypeArgs, null, sEnv, t._rest, tEnv);
                }
                return A._areArgumentsSubtypes(universe, s._rest, null, sEnv, t._rest, tEnv);
            },
            _areArgumentsSubtypes: function(universe, sArgs, sVariances, sEnv, tArgs, tEnv) {
                var i, $length = sArgs.length;
                for(i = 0; i < $length; ++i)if (!A._isSubtype(universe, sArgs[i], sEnv, tArgs[i], tEnv)) return false;
                return true;
            },
            _isRecordSubtype: function(universe, s, sEnv, t, tEnv) {
                var i, sFields = s._rest, tFields = t._rest, sCount = sFields.length;
                if (sCount !== tFields.length) return false;
                if (s._primary !== t._primary) return false;
                for(i = 0; i < sCount; ++i)if (!A._isSubtype(universe, sFields[i], sEnv, tFields[i], tEnv)) return false;
                return true;
            },
            isNullable: function(t) {
                var kind = t._kind, t1 = true;
                if (!(t === type$.Null || t === type$.JSNull)) {
                    if (!A.isTopType(t)) {
                        if (kind !== 6) t1 = kind === 7 && A.isNullable(t._primary);
                    }
                }
                return t1;
            },
            isTopType: function(t) {
                var kind = t._kind;
                return kind === 2 || kind === 3 || kind === 4 || kind === 5 || t === type$.nullable_Object;
            },
            _Utils_objectAssign: function(o, other) {
                var i, key, keys = Object.keys(other), $length = keys.length;
                for(i = 0; i < $length; ++i){
                    key = keys[i];
                    o[key] = other[key];
                }
            },
            _Utils_newArrayOrEmpty: function($length) {
                return $length > 0 ? new Array($length) : init.typeUniverse.sEA;
            },
            Rti: function Rti(t0, t1) {
                var _ = this;
                _._as = t0;
                _._is = t1;
                _._cachedRuntimeType = _._specializedTestResource = _._isSubtypeCache = _._precomputed1 = null;
                _._kind = 0;
                _._canonicalRecipe = _._bindCache = _._evalCache = _._rest = _._primary = null;
            },
            _FunctionParameters: function _FunctionParameters() {
                this._named = this._optionalPositional = this._requiredPositional = null;
            },
            _Type: function _Type(t0) {
                this._rti = t0;
            },
            _Error: function _Error() {},
            _TypeError: function _TypeError(t0) {
                this.__rti$_message = t0;
            },
            _AsyncRun__initializeScheduleImmediate: function() {
                var t1, div, span;
                if (self.scheduleImmediate != null) return A.async__AsyncRun__scheduleImmediateJsOverride$closure();
                if (self.MutationObserver != null && self.document != null) {
                    t1 = {};
                    div = self.document.createElement("div");
                    span = self.document.createElement("span");
                    t1.storedCallback = null;
                    new self.MutationObserver(A.convertDartClosureToJS(new A._AsyncRun__initializeScheduleImmediate_internalCallback(t1), 1)).observe(div, {
                        childList: true
                    });
                    return new A._AsyncRun__initializeScheduleImmediate_closure(t1, div, span);
                } else if (self.setImmediate != null) return A.async__AsyncRun__scheduleImmediateWithSetImmediate$closure();
                return A.async__AsyncRun__scheduleImmediateWithTimer$closure();
            },
            _AsyncRun__scheduleImmediateJsOverride: function(callback) {
                self.scheduleImmediate(A.convertDartClosureToJS(new A._AsyncRun__scheduleImmediateJsOverride_internalCallback(callback), 0));
            },
            _AsyncRun__scheduleImmediateWithSetImmediate: function(callback) {
                self.setImmediate(A.convertDartClosureToJS(new A._AsyncRun__scheduleImmediateWithSetImmediate_internalCallback(callback), 0));
            },
            _AsyncRun__scheduleImmediateWithTimer: function(callback) {
                A.Timer__createTimer(B.Duration_0, callback);
            },
            Timer__createTimer: function(duration, callback) {
                var milliseconds = B.JSInt_methods._tdivFast$1(duration._duration, 1000);
                return A._TimerImpl$(milliseconds < 0 ? 0 : milliseconds, callback);
            },
            _TimerImpl$: function(milliseconds, callback) {
                var t1 = new A._TimerImpl(true);
                t1._TimerImpl$2(milliseconds, callback);
                return t1;
            },
            _TimerImpl$periodic: function(milliseconds, callback) {
                var t1 = new A._TimerImpl(false);
                t1._TimerImpl$periodic$2(milliseconds, callback);
                return t1;
            },
            _makeAsyncAwaitCompleter: function($T) {
                return new A._AsyncAwaitCompleter(new A._Future($.Zone__current, $T._eval$1("_Future<0>")), $T._eval$1("_AsyncAwaitCompleter<0>"));
            },
            _asyncStartSync: function(bodyFunction, completer) {
                bodyFunction.call$2(0, null);
                completer.isSync = true;
                return completer._future;
            },
            _asyncAwait: function(object, bodyFunction) {
                A._awaitOnObject(object, bodyFunction);
            },
            _asyncReturn: function(object, completer) {
                completer.complete$1(object);
            },
            _asyncRethrow: function(object, completer) {
                completer.completeError$2(A.unwrapException(object), A.getTraceFromException(object));
            },
            _awaitOnObject: function(object, bodyFunction) {
                var t1, future, thenCallback = new A._awaitOnObject_closure(bodyFunction), errorCallback = new A._awaitOnObject_closure0(bodyFunction);
                if (object instanceof A._Future) object._thenAwait$1$2(thenCallback, errorCallback, type$.dynamic);
                else {
                    t1 = type$.dynamic;
                    if (object instanceof A._Future) object.then$1$2$onError(0, thenCallback, errorCallback, t1);
                    else {
                        future = new A._Future($.Zone__current, type$._Future_dynamic);
                        future._state = 8;
                        future._resultOrListeners = object;
                        future._thenAwait$1$2(thenCallback, errorCallback, t1);
                    }
                }
            },
            _wrapJsFunctionForAsync: function($function) {
                var $protected = function(fn, ERROR) {
                    return function(errorCode, result) {
                        while(true)try {
                            fn(errorCode, result);
                            break;
                        } catch (error) {
                            result = error;
                            errorCode = ERROR;
                        }
                    };
                }($function, 1);
                return $.Zone__current.registerBinaryCallback$3$1(new A._wrapJsFunctionForAsync_closure($protected), type$.void, type$.int, type$.dynamic);
            },
            _SyncStarIterator__terminatedBody: function(_1, _2, _3) {
                return 0;
            },
            AsyncError_defaultStackTrace: function(error) {
                var stackTrace;
                if (type$.Error._is(error)) {
                    stackTrace = error.get$stackTrace();
                    if (stackTrace != null) return stackTrace;
                }
                return B._StringStackTrace_OdL;
            },
            Future_Future$value: function(value, $T) {
                var t1;
                $T._as(value);
                t1 = new A._Future($.Zone__current, $T._eval$1("_Future<0>"));
                t1._asyncComplete$1(value);
                return t1;
            },
            Future_wait: function(futures, eagerError, $T) {
                var handleError, future, pos, e, s, t1, t2, _$exception, t3, t4, _box_0 = {}, cleanUp = null, _future = new A._Future($.Zone__current, $T._eval$1("_Future<List<0>>"));
                _box_0.values = null;
                _box_0.remaining = 0;
                _box_0.stackTrace = _box_0.error = null;
                handleError = new A.Future_wait_handleError(_box_0, cleanUp, eagerError, _future);
                try {
                    for(t1 = J.get$iterator$ax(futures), t2 = type$.Null; t1.moveNext$0();){
                        future = t1.get$current(t1);
                        pos = _box_0.remaining;
                        J.then$1$2$onError$x(future, new A.Future_wait_closure(_box_0, pos, _future, $T, cleanUp, eagerError), handleError, t2);
                        ++_box_0.remaining;
                    }
                    t1 = _box_0.remaining;
                    if (t1 === 0) {
                        t1 = _future;
                        t1._completeWithValue$1(A._setArrayType([], $T._eval$1("JSArray<0>")));
                        return t1;
                    }
                    _box_0.values = A.List_List$filled(t1, null, false, $T._eval$1("0?"));
                } catch (exception) {
                    e = A.unwrapException(exception);
                    s = A.getTraceFromException(exception);
                    if (_box_0.remaining === 0 || eagerError) {
                        t1 = _future;
                        t2 = e;
                        t3 = s;
                        t4 = A._interceptError(t2, t3);
                        if (t4 == null) t2 = new A.AsyncError(t2, t3 == null ? A.AsyncError_defaultStackTrace(t2) : t3);
                        else t2 = t4;
                        t1._asyncCompleteErrorObject$1(t2);
                        return t1;
                    } else {
                        _box_0.error = e;
                        _box_0.stackTrace = s;
                    }
                }
                return _future;
            },
            _interceptError: function(error, stackTrace) {
                var replacement, t1, t2, zone = $.Zone__current;
                if (zone === B.C__RootZone) return null;
                replacement = zone.errorCallback$2(error, stackTrace);
                if (replacement == null) return null;
                t1 = replacement.error;
                t2 = replacement.stackTrace;
                if (type$.Error._is(t1)) A.Primitives_trySetStackTrace(t1, t2);
                return replacement;
            },
            _interceptUserError: function(error, stackTrace) {
                var replacement;
                if ($.Zone__current !== B.C__RootZone) {
                    replacement = A._interceptError(error, stackTrace);
                    if (replacement != null) return replacement;
                }
                if (stackTrace == null) {
                    if (type$.Error._is(error)) {
                        stackTrace = error.get$stackTrace();
                        if (stackTrace == null) {
                            A.Primitives_trySetStackTrace(error, B._StringStackTrace_OdL);
                            stackTrace = B._StringStackTrace_OdL;
                        }
                    } else stackTrace = B._StringStackTrace_OdL;
                } else if (type$.Error._is(error)) A.Primitives_trySetStackTrace(error, stackTrace);
                return new A.AsyncError(error, stackTrace);
            },
            _Future$zoneValue: function(value, _zone, $T) {
                var t1 = new A._Future(_zone, $T._eval$1("_Future<0>"));
                t1._state = 8;
                t1._resultOrListeners = value;
                return t1;
            },
            _Future$value: function(value, $T) {
                var t1 = new A._Future($.Zone__current, $T._eval$1("_Future<0>"));
                t1._state = 8;
                t1._resultOrListeners = value;
                return t1;
            },
            _Future__chainCoreFuture: function(source, target, sync) {
                var t2, ignoreError, listeners, _box_0 = {}, t1 = _box_0.source = source;
                while(t2 = t1._state, (t2 & 4) !== 0){
                    t1 = t1._resultOrListeners;
                    _box_0.source = t1;
                }
                if (t1 === target) {
                    t2 = A.StackTrace_current();
                    target._asyncCompleteErrorObject$1(new A.AsyncError(new A.ArgumentError(true, t1, null, "Cannot complete a future with itself"), t2));
                    return;
                }
                ignoreError = target._state & 1;
                t2 = t1._state = t2 | ignoreError;
                if ((t2 & 24) === 0) {
                    listeners = target._resultOrListeners;
                    target._state = target._state & 1 | 4;
                    target._resultOrListeners = t1;
                    t1._prependListeners$1(listeners);
                    return;
                }
                if (!sync) {
                    if (target._resultOrListeners == null) t1 = (t2 & 16) === 0 || ignoreError !== 0;
                    else t1 = false;
                } else t1 = true;
                if (t1) {
                    listeners = target._removeListeners$0();
                    target._cloneResult$1(_box_0.source);
                    A._Future__propagateToListeners(target, listeners);
                    return;
                }
                target._state ^= 2;
                target._zone.scheduleMicrotask$1(new A._Future__chainCoreFuture_closure(_box_0, target));
            },
            _Future__propagateToListeners: function(source, listeners) {
                var _box_0, t2, t3, hasError, nextListener, nextListener0, sourceResult, t4, zone, oldZone, result, current, _box_1 = {}, t1 = _box_1.source = source;
                for(;;){
                    _box_0 = {};
                    t2 = t1._state;
                    t3 = (t2 & 16) === 0;
                    hasError = !t3;
                    if (listeners == null) {
                        if (hasError && (t2 & 1) === 0) {
                            t2 = t1._resultOrListeners;
                            t1._zone.handleUncaughtError$2(t2.error, t2.stackTrace);
                        }
                        return;
                    }
                    _box_0.listener = listeners;
                    nextListener = listeners._nextListener;
                    for(t1 = listeners; nextListener != null; t1 = nextListener, nextListener = nextListener0){
                        t1._nextListener = null;
                        A._Future__propagateToListeners(_box_1.source, t1);
                        _box_0.listener = nextListener;
                        nextListener0 = nextListener._nextListener;
                    }
                    t2 = _box_1.source;
                    sourceResult = t2._resultOrListeners;
                    _box_0.listenerHasError = hasError;
                    _box_0.listenerValueOrError = sourceResult;
                    if (t3) {
                        t4 = t1.state;
                        t4 = (t4 & 1) !== 0 || (t4 & 15) === 8;
                    } else t4 = true;
                    if (t4) {
                        zone = t1.result._zone;
                        if (hasError) {
                            t1 = t2._zone;
                            t1 = !(t1 === zone || t1.get$errorZone() === zone.get$errorZone());
                        } else t1 = false;
                        if (t1) {
                            t1 = _box_1.source;
                            t2 = t1._resultOrListeners;
                            t1._zone.handleUncaughtError$2(t2.error, t2.stackTrace);
                            return;
                        }
                        oldZone = $.Zone__current;
                        if (oldZone !== zone) $.Zone__current = zone;
                        else oldZone = null;
                        t1 = _box_0.listener.state;
                        if ((t1 & 15) === 8) new A._Future__propagateToListeners_handleWhenCompleteCallback(_box_0, _box_1, hasError).call$0();
                        else if (t3) {
                            if ((t1 & 1) !== 0) new A._Future__propagateToListeners_handleValueCallback(_box_0, sourceResult).call$0();
                        } else if ((t1 & 2) !== 0) new A._Future__propagateToListeners_handleError(_box_1, _box_0).call$0();
                        if (oldZone != null) $.Zone__current = oldZone;
                        t1 = _box_0.listenerValueOrError;
                        if (t1 instanceof A._Future) {
                            t2 = _box_0.listener.$ti;
                            t2 = t2._eval$1("Future<2>")._is(t1) || !t2._rest[1]._is(t1);
                        } else t2 = false;
                        if (t2) {
                            result = _box_0.listener.result;
                            if ((t1._state & 24) !== 0) {
                                current = result._resultOrListeners;
                                result._resultOrListeners = null;
                                listeners = result._reverseListeners$1(current);
                                result._state = t1._state & 30 | result._state & 1;
                                result._resultOrListeners = t1._resultOrListeners;
                                _box_1.source = t1;
                                continue;
                            } else A._Future__chainCoreFuture(t1, result, true);
                            return;
                        }
                    }
                    result = _box_0.listener.result;
                    current = result._resultOrListeners;
                    result._resultOrListeners = null;
                    listeners = result._reverseListeners$1(current);
                    t1 = _box_0.listenerHasError;
                    t2 = _box_0.listenerValueOrError;
                    if (!t1) {
                        result._state = 8;
                        result._resultOrListeners = t2;
                    } else {
                        result._state = result._state & 1 | 16;
                        result._resultOrListeners = t2;
                    }
                    _box_1.source = result;
                    t1 = result;
                }
            },
            _registerErrorHandler: function(errorHandler, zone) {
                if (type$.dynamic_Function_Object_StackTrace._is(errorHandler)) return zone.registerBinaryCallback$3$1(errorHandler, type$.dynamic, type$.Object, type$.StackTrace);
                if (type$.dynamic_Function_Object._is(errorHandler)) return zone.registerUnaryCallback$2$1(errorHandler, type$.dynamic, type$.Object);
                throw A.wrapException(A.ArgumentError$value(errorHandler, "onError", string$.Error_));
            },
            _microtaskLoop: function() {
                var entry, next;
                for(entry = $._nextCallback; entry != null; entry = $._nextCallback){
                    $._lastPriorityCallback = null;
                    next = entry.next;
                    $._nextCallback = next;
                    if (next == null) $._lastCallback = null;
                    entry.callback.call$0();
                }
            },
            _startMicrotaskLoop: function() {
                $._isInCallbackLoop = true;
                try {
                    A._microtaskLoop();
                } finally{
                    $._lastPriorityCallback = null;
                    $._isInCallbackLoop = false;
                    if ($._nextCallback != null) $.$get$_AsyncRun__scheduleImmediateClosure().call$1(A.async___startMicrotaskLoop$closure());
                }
            },
            _scheduleAsyncCallback: function(callback) {
                var newEntry = new A._AsyncCallbackEntry(callback), lastCallback = $._lastCallback;
                if (lastCallback == null) {
                    $._nextCallback = $._lastCallback = newEntry;
                    if (!$._isInCallbackLoop) $.$get$_AsyncRun__scheduleImmediateClosure().call$1(A.async___startMicrotaskLoop$closure());
                } else $._lastCallback = lastCallback.next = newEntry;
            },
            _schedulePriorityAsyncCallback: function(callback) {
                var entry, lastPriorityCallback, next, t1 = $._nextCallback;
                if (t1 == null) {
                    A._scheduleAsyncCallback(callback);
                    $._lastPriorityCallback = $._lastCallback;
                    return;
                }
                entry = new A._AsyncCallbackEntry(callback);
                lastPriorityCallback = $._lastPriorityCallback;
                if (lastPriorityCallback == null) {
                    entry.next = t1;
                    $._nextCallback = $._lastPriorityCallback = entry;
                } else {
                    next = lastPriorityCallback.next;
                    entry.next = next;
                    $._lastPriorityCallback = lastPriorityCallback.next = entry;
                    if (next == null) $._lastCallback = entry;
                }
            },
            scheduleMicrotask: function(callback) {
                var t1, _null = null, currentZone = $.Zone__current;
                if (B.C__RootZone === currentZone) {
                    A._rootScheduleMicrotask(_null, _null, B.C__RootZone, callback);
                    return;
                }
                if (B.C__RootZone === currentZone.get$_scheduleMicrotask().zone) t1 = B.C__RootZone.get$errorZone() === currentZone.get$errorZone();
                else t1 = false;
                if (t1) {
                    A._rootScheduleMicrotask(_null, _null, currentZone, currentZone.registerCallback$1$1(callback, type$.void));
                    return;
                }
                t1 = $.Zone__current;
                t1.scheduleMicrotask$1(t1.bindCallbackGuarded$1(callback));
            },
            Stream_Stream$fromFuture: function(future, $T) {
                var _null = null, t1 = $T._eval$1("_SyncStreamController<0>"), controller = new A._SyncStreamController(_null, _null, _null, _null, t1);
                future.then$1$2$onError(0, new A.Stream_Stream$fromFuture_closure(controller, $T), new A.Stream_Stream$fromFuture_closure0(controller), type$.Null);
                return new A._ControllerStream(controller, t1._eval$1("_ControllerStream<1>"));
            },
            StreamIterator_StreamIterator: function(stream) {
                return new A._StreamIterator(A.checkNotNullable(stream, "stream", type$.Object));
            },
            StreamController_StreamController: function(onCancel, onListen, onPause, onResume, sync, $T) {
                return sync ? new A._SyncStreamController(onListen, onPause, onResume, onCancel, $T._eval$1("_SyncStreamController<0>")) : new A._AsyncStreamController(onListen, onPause, onResume, onCancel, $T._eval$1("_AsyncStreamController<0>"));
            },
            _runGuarded: function(notificationHandler) {
                var e, s, _$exception;
                if (notificationHandler == null) return;
                try {
                    notificationHandler.call$0();
                } catch (exception) {
                    e = A.unwrapException(exception);
                    s = A.getTraceFromException(exception);
                    $.Zone__current.handleUncaughtError$2(e, s);
                }
            },
            _ControllerSubscription$: function(_controller, onData, onError, onDone, cancelOnError, $T) {
                var t1 = $.Zone__current, t2 = cancelOnError ? 1 : 0, t3 = onError != null ? 32 : 0, t4 = A._BufferingStreamSubscription__registerDataHandler(t1, onData, $T), t5 = A._BufferingStreamSubscription__registerErrorHandler(t1, onError), t6 = onDone == null ? A.async___nullDoneHandler$closure() : onDone;
                return new A._ControllerSubscription(_controller, t4, t5, t1.registerCallback$1$1(t6, type$.void), t1, t2 | t3, $T._eval$1("_ControllerSubscription<0>"));
            },
            _AddStreamState_makeErrorHandler: function(controller) {
                return new A._AddStreamState_makeErrorHandler_closure(controller);
            },
            _BufferingStreamSubscription__registerDataHandler: function(zone, handleData, $T) {
                var t1 = handleData == null ? A.async___nullDataHandler$closure() : handleData;
                return zone.registerUnaryCallback$2$1(t1, type$.void, $T);
            },
            _BufferingStreamSubscription__registerErrorHandler: function(zone, handleError) {
                if (handleError == null) handleError = A.async___nullErrorHandler$closure();
                if (type$.void_Function_Object_StackTrace._is(handleError)) return zone.registerBinaryCallback$3$1(handleError, type$.dynamic, type$.Object, type$.StackTrace);
                if (type$.void_Function_Object._is(handleError)) return zone.registerUnaryCallback$2$1(handleError, type$.dynamic, type$.Object);
                throw A.wrapException(A.ArgumentError$("handleError callback must take either an Object (the error), or both an Object (the error) and a StackTrace.", null));
            },
            _nullDataHandler: function(value) {},
            _nullErrorHandler: function(error, stackTrace) {
                $.Zone__current.handleUncaughtError$2(error, stackTrace);
            },
            _nullDoneHandler: function() {},
            Timer_Timer: function(duration, callback) {
                var t1 = $.Zone__current;
                if (t1 === B.C__RootZone) return t1.createTimer$2(duration, callback);
                return t1.createTimer$2(duration, t1.bindCallbackGuarded$1(callback));
            },
            runZoned: function(body, zoneValues, $R) {
                return A._runZoned(body, zoneValues, null, $R);
            },
            _runZoned: function(body, zoneValues, specification, $R) {
                return $.Zone__current.fork$2$specification$zoneValues(specification, zoneValues).run$1$1(0, body, $R);
            },
            _rootHandleUncaughtError: function($self, $parent, zone, error, stackTrace) {
                A._rootHandleError(error, stackTrace);
            },
            _rootHandleError: function(error, stackTrace) {
                A._schedulePriorityAsyncCallback(new A._rootHandleError_closure(error, stackTrace));
            },
            _rootRun: function($self, $parent, zone, f) {
                var old, t1 = $.Zone__current;
                if (t1 === zone) return f.call$0();
                $.Zone__current = zone;
                old = t1;
                try {
                    t1 = f.call$0();
                    return t1;
                } finally{
                    $.Zone__current = old;
                }
            },
            _rootRunUnary: function($self, $parent, zone, f, arg) {
                var old, t1 = $.Zone__current;
                if (t1 === zone) return f.call$1(arg);
                $.Zone__current = zone;
                old = t1;
                try {
                    t1 = f.call$1(arg);
                    return t1;
                } finally{
                    $.Zone__current = old;
                }
            },
            _rootRunBinary: function($self, $parent, zone, f, arg1, arg2) {
                var old, t1 = $.Zone__current;
                if (t1 === zone) return f.call$2(arg1, arg2);
                $.Zone__current = zone;
                old = t1;
                try {
                    t1 = f.call$2(arg1, arg2);
                    return t1;
                } finally{
                    $.Zone__current = old;
                }
            },
            _rootRegisterCallback: function($self, $parent, zone, f) {
                return f;
            },
            _rootRegisterUnaryCallback: function($self, $parent, zone, f) {
                return f;
            },
            _rootRegisterBinaryCallback: function($self, $parent, zone, f) {
                return f;
            },
            _rootErrorCallback: function($self, $parent, zone, error, stackTrace) {
                return null;
            },
            _rootScheduleMicrotask: function($self, $parent, zone, f) {
                var t1, t2;
                if (B.C__RootZone !== zone) {
                    t1 = B.C__RootZone.get$errorZone();
                    t2 = zone.get$errorZone();
                    f = t1 !== t2 ? zone.bindCallbackGuarded$1(f) : zone.bindCallback$1$1(f, type$.void);
                }
                A._scheduleAsyncCallback(f);
            },
            _rootCreateTimer: function($self, $parent, zone, duration, callback) {
                return A.Timer__createTimer(duration, B.C__RootZone !== zone ? zone.bindCallback$1$1(callback, type$.void) : callback);
            },
            _rootCreatePeriodicTimer: function($self, $parent, zone, duration, callback) {
                var milliseconds;
                if (B.C__RootZone !== zone) callback = zone.bindUnaryCallback$2$1(callback, type$.void, type$.Timer);
                milliseconds = B.JSInt_methods._tdivFast$1(duration._duration, 1000);
                return A._TimerImpl$periodic(milliseconds < 0 ? 0 : milliseconds, callback);
            },
            _rootPrint: function($self, $parent, zone, line) {
                A.printString(line);
            },
            _printToZone0: function(line) {
                $.Zone__current.print$1(line);
            },
            _rootFork: function($self, $parent, zone, specification, zoneValues) {
                var valueMap, t1, handleUncaughtError;
                $._printToZone = A.async___printToZone$closure();
                if (specification == null) specification = B._ZoneSpecification_Ipa;
                if (zoneValues == null) valueMap = zone.get$_async$_map();
                else {
                    t1 = type$.nullable_Object;
                    valueMap = A.HashMap_HashMap$from(zoneValues, t1, t1);
                }
                t1 = new A._CustomZone(zone.get$_run(), zone.get$_runUnary(), zone.get$_runBinary(), zone.get$_registerCallback(), zone.get$_registerUnaryCallback(), zone.get$_registerBinaryCallback(), zone.get$_errorCallback(), zone.get$_scheduleMicrotask(), zone.get$_createTimer(), zone.get$_createPeriodicTimer(), zone.get$_print(), zone.get$_fork(), zone.get$_handleUncaughtError(), zone, valueMap);
                handleUncaughtError = specification.handleUncaughtError;
                if (handleUncaughtError != null) t1._handleUncaughtError = new A._ZoneFunction(t1, handleUncaughtError);
                return t1;
            },
            _AsyncRun__initializeScheduleImmediate_internalCallback: function _AsyncRun__initializeScheduleImmediate_internalCallback(t0) {
                this._box_0 = t0;
            },
            _AsyncRun__initializeScheduleImmediate_closure: function _AsyncRun__initializeScheduleImmediate_closure(t0, t1, t2) {
                this._box_0 = t0;
                this.div = t1;
                this.span = t2;
            },
            _AsyncRun__scheduleImmediateJsOverride_internalCallback: function _AsyncRun__scheduleImmediateJsOverride_internalCallback(t0) {
                this.callback = t0;
            },
            _AsyncRun__scheduleImmediateWithSetImmediate_internalCallback: function _AsyncRun__scheduleImmediateWithSetImmediate_internalCallback(t0) {
                this.callback = t0;
            },
            _TimerImpl: function _TimerImpl(t0) {
                this._once = t0;
                this._handle = null;
                this._tick = 0;
            },
            _TimerImpl_internalCallback: function _TimerImpl_internalCallback(t0, t1) {
                this.$this = t0;
                this.callback = t1;
            },
            _TimerImpl$periodic_closure: function _TimerImpl$periodic_closure(t0, t1, t2, t3) {
                var _ = this;
                _.$this = t0;
                _.milliseconds = t1;
                _.start = t2;
                _.callback = t3;
            },
            _AsyncAwaitCompleter: function _AsyncAwaitCompleter(t0, t1) {
                this._future = t0;
                this.isSync = false;
                this.$ti = t1;
            },
            _awaitOnObject_closure: function _awaitOnObject_closure(t0) {
                this.bodyFunction = t0;
            },
            _awaitOnObject_closure0: function _awaitOnObject_closure0(t0) {
                this.bodyFunction = t0;
            },
            _wrapJsFunctionForAsync_closure: function _wrapJsFunctionForAsync_closure(t0) {
                this.$protected = t0;
            },
            _SyncStarIterator: function _SyncStarIterator(t0) {
                var _ = this;
                _._body = t0;
                _._suspendedBodies = _._nestedIterator = _._datum = _._async$_current = null;
            },
            _SyncStarIterable: function _SyncStarIterable(t0, t1) {
                this._outerHelper = t0;
                this.$ti = t1;
            },
            AsyncError: function AsyncError(t0, t1) {
                this.error = t0;
                this.stackTrace = t1;
            },
            Future_wait_handleError: function Future_wait_handleError(t0, t1, t2, t3) {
                var _ = this;
                _._box_0 = t0;
                _.cleanUp = t1;
                _.eagerError = t2;
                _._future = t3;
            },
            Future_wait_closure: function Future_wait_closure(t0, t1, t2, t3, t4, t5) {
                var _ = this;
                _._box_0 = t0;
                _.pos = t1;
                _._future = t2;
                _.T = t3;
                _.cleanUp = t4;
                _.eagerError = t5;
            },
            _Completer: function _Completer() {},
            _AsyncCompleter: function _AsyncCompleter(t0, t1) {
                this.future = t0;
                this.$ti = t1;
            },
            _SyncCompleter: function _SyncCompleter(t0, t1) {
                this.future = t0;
                this.$ti = t1;
            },
            _FutureListener: function _FutureListener(t0, t1, t2, t3, t4) {
                var _ = this;
                _._nextListener = null;
                _.result = t0;
                _.state = t1;
                _.callback = t2;
                _.errorCallback = t3;
                _.$ti = t4;
            },
            _Future: function _Future(t0, t1) {
                var _ = this;
                _._state = 0;
                _._zone = t0;
                _._resultOrListeners = null;
                _.$ti = t1;
            },
            _Future__addListener_closure: function _Future__addListener_closure(t0, t1) {
                this.$this = t0;
                this.listener = t1;
            },
            _Future__prependListeners_closure: function _Future__prependListeners_closure(t0, t1) {
                this._box_0 = t0;
                this.$this = t1;
            },
            _Future__chainCoreFuture_closure: function _Future__chainCoreFuture_closure(t0, t1) {
                this._box_0 = t0;
                this.target = t1;
            },
            _Future__asyncCompleteWithValue_closure: function _Future__asyncCompleteWithValue_closure(t0, t1) {
                this.$this = t0;
                this.value = t1;
            },
            _Future__asyncCompleteErrorObject_closure: function _Future__asyncCompleteErrorObject_closure(t0, t1) {
                this.$this = t0;
                this.error = t1;
            },
            _Future__propagateToListeners_handleWhenCompleteCallback: function _Future__propagateToListeners_handleWhenCompleteCallback(t0, t1, t2) {
                this._box_0 = t0;
                this._box_1 = t1;
                this.hasError = t2;
            },
            _Future__propagateToListeners_handleWhenCompleteCallback_closure: function _Future__propagateToListeners_handleWhenCompleteCallback_closure(t0, t1) {
                this.joinedResult = t0;
                this.originalSource = t1;
            },
            _Future__propagateToListeners_handleWhenCompleteCallback_closure0: function _Future__propagateToListeners_handleWhenCompleteCallback_closure0(t0) {
                this.joinedResult = t0;
            },
            _Future__propagateToListeners_handleValueCallback: function _Future__propagateToListeners_handleValueCallback(t0, t1) {
                this._box_0 = t0;
                this.sourceResult = t1;
            },
            _Future__propagateToListeners_handleError: function _Future__propagateToListeners_handleError(t0, t1) {
                this._box_1 = t0;
                this._box_0 = t1;
            },
            _AsyncCallbackEntry: function _AsyncCallbackEntry(t0) {
                this.callback = t0;
                this.next = null;
            },
            Stream: function Stream() {},
            Stream_Stream$fromFuture_closure: function Stream_Stream$fromFuture_closure(t0, t1) {
                this.controller = t0;
                this.T = t1;
            },
            Stream_Stream$fromFuture_closure0: function Stream_Stream$fromFuture_closure0(t0) {
                this.controller = t0;
            },
            Stream_length_closure: function Stream_length_closure(t0, t1) {
                this._box_0 = t0;
                this.$this = t1;
            },
            Stream_length_closure0: function Stream_length_closure0(t0, t1) {
                this._box_0 = t0;
                this.future = t1;
            },
            _StreamController: function _StreamController() {},
            _StreamController__subscribe_closure: function _StreamController__subscribe_closure(t0) {
                this.$this = t0;
            },
            _StreamController__recordCancel_complete: function _StreamController__recordCancel_complete(t0) {
                this.$this = t0;
            },
            _SyncStreamControllerDispatch: function _SyncStreamControllerDispatch() {},
            _AsyncStreamControllerDispatch: function _AsyncStreamControllerDispatch() {},
            _AsyncStreamController: function _AsyncStreamController(t0, t1, t2, t3, t4) {
                var _ = this;
                _._varData = null;
                _._state = 0;
                _._doneFuture = null;
                _.onListen = t0;
                _.onPause = t1;
                _.onResume = t2;
                _.onCancel = t3;
                _.$ti = t4;
            },
            _SyncStreamController: function _SyncStreamController(t0, t1, t2, t3, t4) {
                var _ = this;
                _._varData = null;
                _._state = 0;
                _._doneFuture = null;
                _.onListen = t0;
                _.onPause = t1;
                _.onResume = t2;
                _.onCancel = t3;
                _.$ti = t4;
            },
            _ControllerStream: function _ControllerStream(t0, t1) {
                this._controller = t0;
                this.$ti = t1;
            },
            _ControllerSubscription: function _ControllerSubscription(t0, t1, t2, t3, t4, t5, t6) {
                var _ = this;
                _._controller = t0;
                _._onData = t1;
                _._onError = t2;
                _._onDone = t3;
                _._zone = t4;
                _._state = t5;
                _._pending = _._cancelFuture = null;
                _.$ti = t6;
            },
            _AddStreamState: function _AddStreamState() {},
            _AddStreamState_makeErrorHandler_closure: function _AddStreamState_makeErrorHandler_closure(t0) {
                this.controller = t0;
            },
            _AddStreamState_cancel_closure: function _AddStreamState_cancel_closure(t0) {
                this.$this = t0;
            },
            _StreamControllerAddStreamState: function _StreamControllerAddStreamState(t0, t1, t2) {
                this._varData = t0;
                this.addStreamFuture = t1;
                this.addSubscription = t2;
            },
            _BufferingStreamSubscription: function _BufferingStreamSubscription() {},
            _BufferingStreamSubscription__sendError_sendError: function _BufferingStreamSubscription__sendError_sendError(t0, t1, t2) {
                this.$this = t0;
                this.error = t1;
                this.stackTrace = t2;
            },
            _BufferingStreamSubscription__sendDone_sendDone: function _BufferingStreamSubscription__sendDone_sendDone(t0) {
                this.$this = t0;
            },
            _StreamImpl: function _StreamImpl() {},
            _DelayedEvent: function _DelayedEvent() {},
            _DelayedData: function _DelayedData(t0) {
                this.value = t0;
                this.next = null;
            },
            _DelayedError: function _DelayedError(t0, t1) {
                this.error = t0;
                this.stackTrace = t1;
                this.next = null;
            },
            _DelayedDone: function _DelayedDone() {},
            _PendingEvents: function _PendingEvents() {
                this._state = 0;
                this.lastPendingEvent = this.firstPendingEvent = null;
            },
            _PendingEvents_schedule_closure: function _PendingEvents_schedule_closure(t0, t1) {
                this.$this = t0;
                this.dispatch = t1;
            },
            _StreamIterator: function _StreamIterator(t0) {
                this._subscription = null;
                this._stateData = t0;
                this._async$_hasValue = false;
            },
            _ForwardingStream: function _ForwardingStream() {},
            _ForwardingStreamSubscription: function _ForwardingStreamSubscription(t0, t1, t2, t3, t4, t5, t6) {
                var _ = this;
                _._stream = t0;
                _._subscription = null;
                _._onData = t1;
                _._onError = t2;
                _._onDone = t3;
                _._zone = t4;
                _._state = t5;
                _._pending = _._cancelFuture = null;
                _.$ti = t6;
            },
            _MapStream: function _MapStream(t0, t1, t2) {
                this._transform = t0;
                this._async$_source = t1;
                this.$ti = t2;
            },
            _ZoneFunction: function _ZoneFunction(t0, t1) {
                this.zone = t0;
                this.$function = t1;
            },
            _Zone: function _Zone() {},
            _CustomZone: function _CustomZone(t0, t1, t2, t3, t4, t5, t6, t7, t8, t9, t10, t11, t12, t13, t14) {
                var _ = this;
                _._run = t0;
                _._runUnary = t1;
                _._runBinary = t2;
                _._registerCallback = t3;
                _._registerUnaryCallback = t4;
                _._registerBinaryCallback = t5;
                _._errorCallback = t6;
                _._scheduleMicrotask = t7;
                _._createTimer = t8;
                _._createPeriodicTimer = t9;
                _._print = t10;
                _._fork = t11;
                _._handleUncaughtError = t12;
                _._delegateCache = null;
                _.parent = t13;
                _._async$_map = t14;
            },
            _CustomZone_bindCallback_closure: function _CustomZone_bindCallback_closure(t0, t1, t2) {
                this.$this = t0;
                this.registered = t1;
                this.R = t2;
            },
            _CustomZone_bindUnaryCallback_closure: function _CustomZone_bindUnaryCallback_closure(t0, t1, t2, t3) {
                var _ = this;
                _.$this = t0;
                _.registered = t1;
                _.T = t2;
                _.R = t3;
            },
            _CustomZone_bindCallbackGuarded_closure: function _CustomZone_bindCallbackGuarded_closure(t0, t1) {
                this.$this = t0;
                this.registered = t1;
            },
            _RootZone: function _RootZone() {},
            _RootZone_bindCallback_closure: function _RootZone_bindCallback_closure(t0, t1, t2) {
                this.$this = t0;
                this.f = t1;
                this.R = t2;
            },
            _RootZone_bindUnaryCallback_closure: function _RootZone_bindUnaryCallback_closure(t0, t1, t2, t3) {
                var _ = this;
                _.$this = t0;
                _.f = t1;
                _.T = t2;
                _.R = t3;
            },
            _RootZone_bindCallbackGuarded_closure: function _RootZone_bindCallbackGuarded_closure(t0, t1) {
                this.$this = t0;
                this.f = t1;
            },
            _ZoneDelegate: function _ZoneDelegate(t0) {
                this._delegationTarget = t0;
            },
            _rootHandleError_closure: function _rootHandleError_closure(t0, t1) {
                this.error = t0;
                this.stackTrace = t1;
            },
            _ZoneSpecification: function _ZoneSpecification(t0, t1, t2, t3, t4, t5, t6, t7, t8, t9, t10, t11, t12) {
                var _ = this;
                _.handleUncaughtError = t0;
                _.run = t1;
                _.runUnary = t2;
                _.runBinary = t3;
                _.registerCallback = t4;
                _.registerUnaryCallback = t5;
                _.registerBinaryCallback = t6;
                _.errorCallback = t7;
                _.scheduleMicrotask = t8;
                _.createTimer = t9;
                _.createPeriodicTimer = t10;
                _.print = t11;
                _.fork = t12;
            },
            HashMap_HashMap: function($K, $V) {
                return new A._HashMap($K._eval$1("@<0>")._bind$1($V)._eval$1("_HashMap<1,2>"));
            },
            _HashMap__getTableEntry: function(table, key) {
                var entry = table[key];
                return entry === table ? null : entry;
            },
            _HashMap__setTableEntry: function(table, key, value) {
                if (value == null) table[key] = table;
                else table[key] = value;
            },
            _HashMap__newHashTable: function() {
                var table = Object.create(null);
                A._HashMap__setTableEntry(table, "<non-identifier-key>", table);
                delete table["<non-identifier-key>"];
                return table;
            },
            LinkedHashMap_LinkedHashMap: function(equals, hashCode, isValidKey, $K, $V) {
                if (isValidKey == null) {
                    if (hashCode == null) {
                        if (equals == null) return new A.JsLinkedHashMap($K._eval$1("@<0>")._bind$1($V)._eval$1("JsLinkedHashMap<1,2>"));
                        hashCode = A.collection___defaultHashCode$closure();
                    } else {
                        if (A.core__identityHashCode$closure() === hashCode && A.core__identical$closure() === equals) return new A.JsIdentityLinkedHashMap($K._eval$1("@<0>")._bind$1($V)._eval$1("JsIdentityLinkedHashMap<1,2>"));
                        if (equals == null) equals = A.collection___defaultEquals$closure();
                    }
                } else {
                    if (hashCode == null) hashCode = A.collection___defaultHashCode$closure();
                    if (equals == null) equals = A.collection___defaultEquals$closure();
                }
                return A._LinkedCustomHashMap$(equals, hashCode, isValidKey, $K, $V);
            },
            LinkedHashMap_LinkedHashMap$_literal: function(keyValuePairs, $K, $V) {
                return A.fillLiteralMap(keyValuePairs, new A.JsLinkedHashMap($K._eval$1("@<0>")._bind$1($V)._eval$1("JsLinkedHashMap<1,2>")));
            },
            LinkedHashMap_LinkedHashMap$_empty: function($K, $V) {
                return new A.JsLinkedHashMap($K._eval$1("@<0>")._bind$1($V)._eval$1("JsLinkedHashMap<1,2>"));
            },
            _LinkedCustomHashMap$: function(_equals, _hashCode, validKey, $K, $V) {
                var t1 = validKey != null ? validKey : new A._LinkedCustomHashMap_closure($K);
                return new A._LinkedCustomHashMap(_equals, _hashCode, t1, $K._eval$1("@<0>")._bind$1($V)._eval$1("_LinkedCustomHashMap<1,2>"));
            },
            LinkedHashSet_LinkedHashSet: function($E) {
                return new A._LinkedHashSet($E._eval$1("_LinkedHashSet<0>"));
            },
            LinkedHashSet_LinkedHashSet$_empty: function($E) {
                return new A._LinkedHashSet($E._eval$1("_LinkedHashSet<0>"));
            },
            LinkedHashSet_LinkedHashSet$_literal: function(values, $E) {
                return A.fillLiteralSet(values, new A._LinkedHashSet($E._eval$1("_LinkedHashSet<0>")));
            },
            _LinkedHashSet__newHashTable: function() {
                var table = Object.create(null);
                table["<non-identifier-key>"] = table;
                delete table["<non-identifier-key>"];
                return table;
            },
            _LinkedHashSetIterator$: function(_set, _modifications, $E) {
                var t1 = new A._LinkedHashSetIterator(_set, _modifications, $E._eval$1("_LinkedHashSetIterator<0>"));
                t1._collection$_cell = _set._collection$_first;
                return t1;
            },
            UnmodifiableListView$: function(source, $E) {
                return new A.UnmodifiableListView(source, $E._eval$1("UnmodifiableListView<0>"));
            },
            _defaultEquals: function(a, b) {
                return J.$eq$(a, b);
            },
            _defaultHashCode: function(a) {
                return J.get$hashCode$(a);
            },
            HashMap_HashMap$from: function(other, $K, $V) {
                var result = A.HashMap_HashMap($K, $V);
                other.forEach$1(0, new A.HashMap_HashMap$from_closure(result, $K, $V));
                return result;
            },
            IterableExtensions_get_firstOrNull: function(_this) {
                var t2, t1 = A._arrayInstanceType(_this), iterator = new J.ArrayIterator(_this, _this.length, t1._eval$1("ArrayIterator<1>"));
                if (iterator.moveNext$0()) {
                    t2 = iterator._current;
                    return t2 == null ? t1._precomputed1._as(t2) : t2;
                }
                return null;
            },
            LinkedHashMap_LinkedHashMap$from: function(other, $K, $V) {
                var result = A.LinkedHashMap_LinkedHashMap(null, null, null, $K, $V);
                other.forEach$1(0, new A.LinkedHashMap_LinkedHashMap$from_closure(result, $K, $V));
                return result;
            },
            LinkedHashMap_LinkedHashMap$of: function(other, $K, $V) {
                var t1 = A.LinkedHashMap_LinkedHashMap(null, null, null, $K, $V);
                t1.addAll$1(0, other);
                return t1;
            },
            LinkedHashSet_LinkedHashSet$from: function(elements, $E) {
                var t1, _i, result = A.LinkedHashSet_LinkedHashSet($E);
                for(t1 = elements.length, _i = 0; _i < elements.length; elements.length === t1 || (0, A.throwConcurrentModificationError)(elements), ++_i)result.add$1(0, $E._as(elements[_i]));
                return result;
            },
            LinkedHashSet_LinkedHashSet$of: function(elements, $E) {
                var t1 = A.LinkedHashSet_LinkedHashSet($E);
                t1.addAll$1(0, elements);
                return t1;
            },
            ListBase__compareAny: function(a, b) {
                var t1 = type$.Comparable_dynamic;
                return J.compareTo$1$ns(t1._as(a), t1._as(b));
            },
            MapBase_mapToString: function(m) {
                var result, t1;
                if (A.isToStringVisiting(m)) return "{...}";
                result = new A.StringBuffer("");
                try {
                    t1 = {};
                    $._toStringVisiting.push(m);
                    result._contents += "{";
                    t1.first = true;
                    m.forEach$1(0, new A.MapBase_mapToString_closure(t1, result));
                    result._contents += "}";
                } finally{
                    $._toStringVisiting.pop();
                }
                t1 = result._contents;
                return t1.charCodeAt(0) == 0 ? t1 : t1;
            },
            MapBase__fillMapWithIterables: function(map, keys, values) {
                var keyIterator = keys.get$iterator(keys), valueIterator = values.get$iterator(values), hasNextKey = keyIterator.moveNext$0(), hasNextValue = valueIterator.moveNext$0();
                for(;;){
                    if (!(hasNextKey && hasNextValue)) break;
                    map.$indexSet(0, keyIterator.get$current(keyIterator), valueIterator.get$current(valueIterator));
                    hasNextKey = keyIterator.moveNext$0();
                    hasNextValue = valueIterator.moveNext$0();
                }
                if (hasNextKey || hasNextValue) throw A.wrapException(A.ArgumentError$("Iterables do not have same length.", null));
            },
            ListQueue$: function($E) {
                return new A.ListQueue(A.List_List$filled(A.ListQueue__calculateCapacity(null), null, false, $E._eval$1("0?")), $E._eval$1("ListQueue<0>"));
            },
            ListQueue__calculateCapacity: function(initialCapacity) {
                return 8;
            },
            ListQueue__nextPowerOf2: function(number) {
                var nextNumber;
                number = (number << 1 >>> 0) - 1;
                for(;; number = nextNumber){
                    nextNumber = (number & number - 1) >>> 0;
                    if (nextNumber === 0) return number;
                }
            },
            _ListQueueIterator$: function(queue, $E) {
                return new A._ListQueueIterator(queue, queue._tail, queue._modificationCount, queue._head, $E._eval$1("_ListQueueIterator<0>"));
            },
            _UnmodifiableSetMixin__throwUnmodifiable: function() {
                throw A.wrapException(A.UnsupportedError$("Cannot change an unmodifiable set"));
            },
            _HashMap: function _HashMap(t0) {
                var _ = this;
                _._collection$_length = 0;
                _._collection$_keys = _._collection$_rest = _._collection$_nums = _._collection$_strings = null;
                _.$ti = t0;
            },
            _HashMap_values_closure: function _HashMap_values_closure(t0) {
                this.$this = t0;
            },
            _HashMap_addAll_closure: function _HashMap_addAll_closure(t0) {
                this.$this = t0;
            },
            _IdentityHashMap: function _IdentityHashMap(t0) {
                var _ = this;
                _._collection$_length = 0;
                _._collection$_keys = _._collection$_rest = _._collection$_nums = _._collection$_strings = null;
                _.$ti = t0;
            },
            _HashMapKeyIterable: function _HashMapKeyIterable(t0, t1) {
                this._map = t0;
                this.$ti = t1;
            },
            _HashMapKeyIterator: function _HashMapKeyIterator(t0, t1, t2) {
                var _ = this;
                _._map = t0;
                _._collection$_keys = t1;
                _._offset = 0;
                _._collection$_current = null;
                _.$ti = t2;
            },
            _LinkedCustomHashMap: function _LinkedCustomHashMap(t0, t1, t2, t3) {
                var _ = this;
                _._equals = t0;
                _._hashCode = t1;
                _._validKey = t2;
                _.__js_helper$_length = 0;
                _._last = _._first = _.__js_helper$_rest = _._nums = _._strings = null;
                _._modifications = 0;
                _.$ti = t3;
            },
            _LinkedCustomHashMap_closure: function _LinkedCustomHashMap_closure(t0) {
                this.K = t0;
            },
            _LinkedHashSet: function _LinkedHashSet(t0) {
                var _ = this;
                _._collection$_length = 0;
                _._collection$_last = _._collection$_first = _._collection$_rest = _._collection$_nums = _._collection$_strings = null;
                _._collection$_modifications = 0;
                _.$ti = t0;
            },
            _LinkedIdentityHashSet: function _LinkedIdentityHashSet(t0) {
                var _ = this;
                _._collection$_length = 0;
                _._collection$_last = _._collection$_first = _._collection$_rest = _._collection$_nums = _._collection$_strings = null;
                _._collection$_modifications = 0;
                _.$ti = t0;
            },
            _LinkedHashSetCell: function _LinkedHashSetCell(t0) {
                this._element = t0;
                this._collection$_previous = this._collection$_next = null;
            },
            _LinkedHashSetIterator: function _LinkedHashSetIterator(t0, t1, t2) {
                var _ = this;
                _._set = t0;
                _._collection$_modifications = t1;
                _._collection$_current = _._collection$_cell = null;
                _.$ti = t2;
            },
            UnmodifiableListView: function UnmodifiableListView(t0, t1) {
                this._collection$_source = t0;
                this.$ti = t1;
            },
            HashMap_HashMap$from_closure: function HashMap_HashMap$from_closure(t0, t1, t2) {
                this.result = t0;
                this.K = t1;
                this.V = t2;
            },
            LinkedHashMap_LinkedHashMap$from_closure: function LinkedHashMap_LinkedHashMap$from_closure(t0, t1, t2) {
                this.result = t0;
                this.K = t1;
                this.V = t2;
            },
            ListBase: function ListBase() {},
            MapBase: function MapBase() {},
            MapBase_addAll_closure: function MapBase_addAll_closure(t0) {
                this.$this = t0;
            },
            MapBase_entries_closure: function MapBase_entries_closure(t0) {
                this.$this = t0;
            },
            MapBase_mapToString_closure: function MapBase_mapToString_closure(t0, t1) {
                this._box_0 = t0;
                this.result = t1;
            },
            UnmodifiableMapBase: function UnmodifiableMapBase() {},
            _MapBaseValueIterable: function _MapBaseValueIterable(t0, t1) {
                this._map = t0;
                this.$ti = t1;
            },
            _MapBaseValueIterator: function _MapBaseValueIterator(t0, t1, t2) {
                var _ = this;
                _._collection$_keys = t0;
                _._map = t1;
                _._collection$_current = null;
                _.$ti = t2;
            },
            _UnmodifiableMapMixin: function _UnmodifiableMapMixin() {},
            MapView: function MapView() {},
            UnmodifiableMapView: function UnmodifiableMapView(t0, t1) {
                this._map = t0;
                this.$ti = t1;
            },
            ListQueue: function ListQueue(t0, t1) {
                var _ = this;
                _._table = t0;
                _._modificationCount = _._tail = _._head = 0;
                _.$ti = t1;
            },
            _ListQueueIterator: function _ListQueueIterator(t0, t1, t2, t3, t4) {
                var _ = this;
                _._queue = t0;
                _._collection$_end = t1;
                _._modificationCount = t2;
                _._collection$_position = t3;
                _._collection$_current = null;
                _.$ti = t4;
            },
            SetBase: function SetBase() {},
            _SetBase: function _SetBase() {},
            _UnmodifiableSetMixin: function _UnmodifiableSetMixin() {},
            UnmodifiableSetView: function UnmodifiableSetView(t0, t1) {
                this._collection$_source = t0;
                this.$ti = t1;
            },
            _UnmodifiableMapView_MapView__UnmodifiableMapMixin: function _UnmodifiableMapView_MapView__UnmodifiableMapMixin() {},
            _UnmodifiableSetView_SetBase__UnmodifiableSetMixin: function _UnmodifiableSetView_SetBase__UnmodifiableSetMixin() {},
            _parseJson: function(source, reviver) {
                var e, _$exception, t1, parsed = null;
                try {
                    parsed = JSON.parse(source);
                } catch (exception) {
                    e = A.unwrapException(exception);
                    t1 = A.FormatException$(String(e), null, null);
                    throw A.wrapException(t1);
                }
                t1 = A._convertJsonToDartLazy(parsed);
                return t1;
            },
            _convertJsonToDartLazy: function(object) {
                var i;
                if (object == null) return null;
                if ((typeof object === "undefined" ? "undefined" : (0, $6tOPT._)(object)) != "object") return object;
                if (!Array.isArray(object)) return new A._JsonMap(object, Object.create(null));
                for(i = 0; i < object.length; ++i)object[i] = A._convertJsonToDartLazy(object[i]);
                return object;
            },
            _Utf8Decoder__makeNativeUint8List: function(codeUnits, start, end) {
                var bytes, t1, i, b, $length = end - start;
                if ($length <= 4096) bytes = $.$get$_Utf8Decoder__reusableBuffer();
                else bytes = new Uint8Array($length);
                for(t1 = J.getInterceptor$asx(codeUnits), i = 0; i < $length; ++i){
                    b = t1.$index(codeUnits, start + i);
                    if ((b & 255) !== b) b = 255;
                    bytes[i] = b;
                }
                return bytes;
            },
            _Utf8Decoder__convertInterceptedUint8List: function(allowMalformed, codeUnits, start, end) {
                var decoder = allowMalformed ? $.$get$_Utf8Decoder__decoderNonfatal() : $.$get$_Utf8Decoder__decoder();
                if (decoder == null) return null;
                if (0 === start && end === codeUnits.length) return A._Utf8Decoder__useTextDecoder(decoder, codeUnits);
                return A._Utf8Decoder__useTextDecoder(decoder, codeUnits.subarray(start, end));
            },
            _Utf8Decoder__useTextDecoder: function(decoder, codeUnits) {
                var t1, exception;
                try {
                    t1 = decoder.decode(codeUnits);
                    return t1;
                } catch (exception) {}
                return null;
            },
            Base64Codec__checkPadding: function(source, sourceIndex, sourceEnd, firstPadding, paddingCount, $length) {
                if (B.JSInt_methods.$mod($length, 4) !== 0) throw A.wrapException(A.FormatException$("Invalid base64 padding, padded length must be multiple of four, is " + $length, source, sourceEnd));
                if (firstPadding + paddingCount !== $length) throw A.wrapException(A.FormatException$("Invalid base64 padding, '=' not at the end", source, sourceIndex));
                if (paddingCount > 2) throw A.wrapException(A.FormatException$("Invalid base64 padding, more than two '=' characters", source, sourceIndex));
            },
            _Base64Encoder_encodeChunk: function(alphabet, bytes, start, end, isLast, output, outputIndex, state) {
                var t1, t2, i, byteOr, byte, outputIndex0, outputIndex1, bits = state >>> 2, expectedChars = 3 - (state & 3);
                for(t1 = J.getInterceptor$asx(bytes), t2 = output.$flags | 0, i = start, byteOr = 0; i < end; ++i){
                    byte = t1.$index(bytes, i);
                    byteOr = (byteOr | byte) >>> 0;
                    bits = (bits << 8 | byte) & 16777215;
                    --expectedChars;
                    if (expectedChars === 0) {
                        outputIndex0 = outputIndex + 1;
                        t2 & 2 && A.throwUnsupportedOperation(output);
                        output[outputIndex] = alphabet.charCodeAt(bits >>> 18 & 63);
                        outputIndex = outputIndex0 + 1;
                        output[outputIndex0] = alphabet.charCodeAt(bits >>> 12 & 63);
                        outputIndex0 = outputIndex + 1;
                        output[outputIndex] = alphabet.charCodeAt(bits >>> 6 & 63);
                        outputIndex = outputIndex0 + 1;
                        output[outputIndex0] = alphabet.charCodeAt(bits & 63);
                        bits = 0;
                        expectedChars = 3;
                    }
                }
                if (byteOr >= 0 && byteOr <= 255) {
                    if (isLast && expectedChars < 3) {
                        outputIndex0 = outputIndex + 1;
                        outputIndex1 = outputIndex0 + 1;
                        if (3 - expectedChars === 1) {
                            t2 & 2 && A.throwUnsupportedOperation(output);
                            output[outputIndex] = alphabet.charCodeAt(bits >>> 2 & 63);
                            output[outputIndex0] = alphabet.charCodeAt(bits << 4 & 63);
                            output[outputIndex1] = 61;
                            output[outputIndex1 + 1] = 61;
                        } else {
                            t2 & 2 && A.throwUnsupportedOperation(output);
                            output[outputIndex] = alphabet.charCodeAt(bits >>> 10 & 63);
                            output[outputIndex0] = alphabet.charCodeAt(bits >>> 4 & 63);
                            output[outputIndex1] = alphabet.charCodeAt(bits << 2 & 63);
                            output[outputIndex1 + 1] = 61;
                        }
                        return 0;
                    }
                    return (bits << 2 | 3 - expectedChars) >>> 0;
                }
                for(i = start; i < end;){
                    byte = t1.$index(bytes, i);
                    if (byte < 0 || byte > 255) break;
                    ++i;
                }
                throw A.wrapException(A.ArgumentError$value(bytes, "Not a byte value at index " + i + ": 0x" + B.JSInt_methods.toRadixString$1(t1.$index(bytes, i), 16), null));
            },
            JsonUnsupportedObjectError$: function(unsupportedObject, cause, partialResult) {
                return new A.JsonUnsupportedObjectError(unsupportedObject, cause);
            },
            _defaultToEncodable: function(object) {
                return object.toJson$0();
            },
            _JsonStringStringifier$: function(_sink, _toEncodable) {
                return new A._JsonStringStringifier(_sink, [], A.convert___defaultToEncodable$closure());
            },
            _JsonStringStringifier_stringify: function(object, toEncodable, indent) {
                var t1, output = new A.StringBuffer(""), stringifier = A._JsonStringStringifier$(output, toEncodable);
                stringifier.writeObject$1(object);
                t1 = output._contents;
                return t1.charCodeAt(0) == 0 ? t1 : t1;
            },
            _Utf8Decoder_errorDescription: function(state) {
                switch(state){
                    case 65:
                        return "Missing extension byte";
                    case 67:
                        return "Unexpected extension byte";
                    case 69:
                        return "Invalid UTF-8 byte";
                    case 71:
                        return "Overlong encoding";
                    case 73:
                        return "Out of unicode range";
                    case 75:
                        return "Encoded surrogate";
                    case 77:
                        return "Unfinished UTF-8 octet sequence";
                    default:
                        return "";
                }
            },
            _JsonMap: function _JsonMap(t0, t1) {
                this._original = t0;
                this._processed = t1;
                this._data = null;
            },
            _JsonMap_values_closure: function _JsonMap_values_closure(t0) {
                this.$this = t0;
            },
            _JsonMap_addAll_closure: function _JsonMap_addAll_closure(t0) {
                this.$this = t0;
            },
            _JsonMapKeyIterable: function _JsonMapKeyIterable(t0) {
                this._convert$_parent = t0;
            },
            _Utf8Decoder__decoder_closure: function _Utf8Decoder__decoder_closure() {},
            _Utf8Decoder__decoderNonfatal_closure: function _Utf8Decoder__decoderNonfatal_closure() {},
            AsciiCodec: function AsciiCodec() {},
            _UnicodeSubsetEncoder: function _UnicodeSubsetEncoder() {},
            AsciiEncoder: function AsciiEncoder(t0) {
                this._subsetMask = t0;
            },
            Base64Codec: function Base64Codec() {},
            Base64Encoder: function Base64Encoder() {},
            _Base64Encoder: function _Base64Encoder(t0) {
                this._convert$_state = 0;
                this._alphabet = t0;
            },
            _Base64EncoderSink: function _Base64EncoderSink() {},
            _Utf8Base64EncoderSink: function _Utf8Base64EncoderSink(t0, t1) {
                this._sink = t0;
                this._encoder = t1;
            },
            ByteConversionSink: function ByteConversionSink() {},
            Codec: function Codec() {},
            Converter: function Converter() {},
            Encoding: function Encoding() {},
            JsonUnsupportedObjectError: function JsonUnsupportedObjectError(t0, t1) {
                this.unsupportedObject = t0;
                this.cause = t1;
            },
            JsonCyclicError: function JsonCyclicError(t0, t1) {
                this.unsupportedObject = t0;
                this.cause = t1;
            },
            JsonCodec: function JsonCodec() {},
            JsonEncoder: function JsonEncoder(t0) {
                this._toEncodable = t0;
            },
            JsonDecoder: function JsonDecoder(t0) {
                this._reviver = t0;
            },
            _JsonStringifier: function _JsonStringifier() {},
            _JsonStringifier_writeMap_closure: function _JsonStringifier_writeMap_closure(t0, t1) {
                this._box_0 = t0;
                this.keyValueList = t1;
            },
            _JsonStringStringifier: function _JsonStringStringifier(t0, t1, t2) {
                this._sink = t0;
                this._seen = t1;
                this._toEncodable = t2;
            },
            StringConversionSink: function StringConversionSink() {},
            _StringSinkConversionSink: function _StringSinkConversionSink(t0) {
                this._stringSink = t0;
            },
            _StringCallbackSink: function _StringCallbackSink(t0, t1) {
                this._convert$_callback = t0;
                this._stringSink = t1;
            },
            _Utf8StringSinkAdapter: function _Utf8StringSinkAdapter(t0, t1, t2) {
                this._decoder = t0;
                this._sink = t1;
                this._stringSink = t2;
            },
            Utf8Codec: function Utf8Codec() {},
            Utf8Encoder: function Utf8Encoder() {},
            _Utf8Encoder: function _Utf8Encoder(t0) {
                this._bufferIndex = 0;
                this._buffer = t0;
            },
            Utf8Decoder: function Utf8Decoder(t0) {
                this._allowMalformed = t0;
            },
            _Utf8Decoder: function _Utf8Decoder(t0) {
                this.allowMalformed = t0;
                this._convert$_state = 16;
                this._charOrIndex = 0;
            },
            identityHashCode: function(object) {
                return A.objectHashCode(object);
            },
            Function_apply: function($function, positionalArguments) {
                return A.Primitives_applyFunction($function, positionalArguments, null);
            },
            Expando$: function() {
                return new A.Expando(new WeakMap());
            },
            Expando__checkType: function(object) {
                if (A._isBool(object) || typeof object == "number" || typeof object == "string" || object instanceof A._Record) A.Expando__badExpandoKey(object);
            },
            Expando__badExpandoKey: function(object) {
                throw A.wrapException(A.ArgumentError$value(object, "object", "Expandos are not allowed on strings, numbers, bools, records or null"));
            },
            int_parse: function(source, radix) {
                var value = A.Primitives_parseInt(source, radix);
                if (value != null) return value;
                throw A.wrapException(A.FormatException$(source, null, null));
            },
            double_parse: function(source) {
                var value = A.Primitives_parseDouble(source);
                if (value != null) return value;
                throw A.wrapException(A.FormatException$("Invalid double", source, null));
            },
            Error__throw: function(error, stackTrace) {
                error = A.initializeExceptionWrapper(error, new Error());
                error.stack = stackTrace.toString$0(0);
                throw error;
            },
            List_List$filled: function($length, fill, growable, $E) {
                var i, result = growable ? J.JSArray_JSArray$growable($length, $E) : J.JSArray_JSArray$fixed($length, $E);
                if ($length !== 0 && fill != null) for(i = 0; i < result.length; ++i)result[i] = fill;
                return result;
            },
            List_List$from: function(elements, growable, $E) {
                var t1, list = A._setArrayType([], $E._eval$1("JSArray<0>"));
                for(t1 = J.get$iterator$ax(elements); t1.moveNext$0();)list.push(t1.get$current(t1));
                if (growable) return list;
                list.$flags = 1;
                return list;
            },
            List_List$of: function(elements, growable, $E) {
                var t1;
                if (growable) t1 = A.List_List$_of(elements, $E);
                else {
                    t1 = A.List_List$_of(elements, $E);
                    t1.$flags = 1;
                    t1;
                }
                return t1;
            },
            List_List$_of: function(elements, $E) {
                var list, t1;
                if (Array.isArray(elements)) return A._setArrayType(elements.slice(0), $E._eval$1("JSArray<0>"));
                list = A._setArrayType([], $E._eval$1("JSArray<0>"));
                for(t1 = J.get$iterator$ax(elements); t1.moveNext$0();)list.push(t1.get$current(t1));
                return list;
            },
            List_List$unmodifiable: function(elements, $E) {
                var result = A.List_List$from(elements, false, $E);
                result.$flags = 3;
                return result;
            },
            String_String$fromCharCodes: function(charCodes, start, end) {
                var t1, t2, maxLength, array, len;
                A.RangeError_checkNotNegative(start, "start");
                t1 = end == null;
                t2 = !t1;
                if (t2) {
                    maxLength = end - start;
                    if (maxLength < 0) throw A.wrapException(A.RangeError$range(end, start, null, "end", null));
                    if (maxLength === 0) return "";
                }
                if (Array.isArray(charCodes)) {
                    array = charCodes;
                    len = array.length;
                    if (t1) end = len;
                    return A.Primitives_stringFromCharCodes(start > 0 || end < len ? array.slice(start, end) : array);
                }
                if (type$.NativeUint8List._is(charCodes)) return A.String__stringFromUint8List(charCodes, start, end);
                if (t2) charCodes = J.take$1$ax(charCodes, end);
                if (start > 0) charCodes = J.skip$1$ax(charCodes, start);
                t1 = A.List_List$_of(charCodes, type$.int);
                return A.Primitives_stringFromCharCodes(t1);
            },
            String_String$fromCharCode: function(charCode) {
                return A.Primitives_stringFromCharCode(charCode);
            },
            String__stringFromUint8List: function(charCodes, start, endOrNull) {
                var len = charCodes.length;
                if (start >= len) return "";
                return A.Primitives_stringFromNativeUint8List(charCodes, start, endOrNull == null || endOrNull > len ? len : endOrNull);
            },
            RegExp_RegExp: function(source, multiLine) {
                return new A.JSSyntaxRegExp(source, A.JSSyntaxRegExp_makeNative(source, multiLine, true, false, false, ""));
            },
            identical: function(a, b) {
                return a == null ? b == null : a === b;
            },
            StringBuffer__writeAll: function(string, objects, separator) {
                var iterator = J.get$iterator$ax(objects);
                if (!iterator.moveNext$0()) return string;
                if (separator.length === 0) do string += A.S(iterator.get$current(iterator));
                while (iterator.moveNext$0());
                else {
                    string += A.S(iterator.get$current(iterator));
                    while(iterator.moveNext$0())string = string + separator + A.S(iterator.get$current(iterator));
                }
                return string;
            },
            NoSuchMethodError_NoSuchMethodError$withInvocation: function(receiver, invocation) {
                return new A.NoSuchMethodError(receiver, invocation.get$memberName(), invocation.get$positionalArguments(), invocation.get$namedArguments());
            },
            Uri_base: function() {
                var cachedUri, uri, current = A.Primitives_currentUri();
                if (current == null) throw A.wrapException(A.UnsupportedError$("'Uri.base' is not supported"));
                cachedUri = $.Uri__cachedBaseUri;
                if (cachedUri != null && current === $.Uri__cachedBaseString) return cachedUri;
                uri = A.Uri_parse(current);
                $.Uri__cachedBaseUri = uri;
                $.Uri__cachedBaseString = current;
                return uri;
            },
            _Uri__uriEncode: function(canonicalMask, text, encoding, spaceToPlus) {
                var t1, bytes, i, t2, byte, _s16_ = "0123456789ABCDEF";
                if (encoding === B.C_Utf8Codec) {
                    t1 = $.$get$_Uri__needsNoEncoding();
                    t1 = t1._nativeRegExp.test(text);
                } else t1 = false;
                if (t1) return text;
                bytes = B.C_Utf8Encoder.convert$1(text);
                for(t1 = bytes.length, i = 0, t2 = ""; i < t1; ++i){
                    byte = bytes[i];
                    if (byte < 128 && (string$.x00_____.charCodeAt(byte) & canonicalMask) !== 0) t2 += A.Primitives_stringFromCharCode(byte);
                    else t2 = spaceToPlus && byte === 32 ? t2 + "+" : t2 + "%" + _s16_[byte >>> 4 & 15] + _s16_[byte & 15];
                }
                return t2.charCodeAt(0) == 0 ? t2 : t2;
            },
            StackTrace_current: function() {
                return A.getTraceFromException(new Error());
            },
            DateTime$fromMillisecondsSinceEpoch: function(millisecondsSinceEpoch) {
                if (millisecondsSinceEpoch < -8640000000000000 || millisecondsSinceEpoch > 864e13) A.throwExpression(A.RangeError$range(millisecondsSinceEpoch, -8640000000000000, 864e13, "millisecondsSinceEpoch", null));
                A.checkNotNullable(false, "isUtc", type$.bool);
                return new A.DateTime(millisecondsSinceEpoch, 0, false);
            },
            DateTime__validate: function(millisecondsSinceEpoch, microsecond, isUtc) {
                var _s11_ = "microsecond";
                if (microsecond > 999) throw A.wrapException(A.RangeError$range(microsecond, 0, 999, _s11_, null));
                if (millisecondsSinceEpoch < -8640000000000000 || millisecondsSinceEpoch > 864e13) throw A.wrapException(A.RangeError$range(millisecondsSinceEpoch, -8640000000000000, 864e13, "millisecondsSinceEpoch", null));
                if (millisecondsSinceEpoch === 864e13 && microsecond !== 0) throw A.wrapException(A.ArgumentError$value(microsecond, _s11_, "Time including microseconds is outside valid range"));
                A.checkNotNullable(false, "isUtc", type$.bool);
                return millisecondsSinceEpoch;
            },
            DateTime__fourDigits: function(n) {
                var absN = Math.abs(n), sign = n < 0 ? "-" : "";
                if (absN >= 1000) return "" + n;
                if (absN >= 100) return sign + "0" + absN;
                if (absN >= 10) return sign + "00" + absN;
                return sign + "000" + absN;
            },
            DateTime__threeDigits: function(n) {
                if (n >= 100) return "" + n;
                if (n >= 10) return "0" + n;
                return "00" + n;
            },
            DateTime__twoDigits: function(n) {
                if (n >= 10) return "" + n;
                return "0" + n;
            },
            Duration$: function(microseconds, milliseconds) {
                return new A.Duration(microseconds + 1000 * milliseconds);
            },
            EnumByName_byName: function(_this, $name) {
                var _i, value;
                for(_i = 0; _i < 4; ++_i){
                    value = _this[_i];
                    if (value._name === $name) return value;
                }
                throw A.wrapException(A.ArgumentError$value($name, "name", "No enum value with that name"));
            },
            Error_safeToString: function(object) {
                if (typeof object == "number" || A._isBool(object) || object == null) return J.toString$0$(object);
                if (typeof object == "string") return JSON.stringify(object);
                return A.Primitives_safeToString(object);
            },
            Error_throwWithStackTrace: function(error, stackTrace) {
                A.checkNotNullable(error, "error", type$.Object);
                A.checkNotNullable(stackTrace, "stackTrace", type$.StackTrace);
                A.Error__throw(error, stackTrace);
            },
            AssertionError$: function(message) {
                return new A.AssertionError(message);
            },
            ArgumentError$: function(message, $name) {
                return new A.ArgumentError(false, null, $name, message);
            },
            ArgumentError$value: function(value, $name, message) {
                return new A.ArgumentError(true, value, $name, message);
            },
            ArgumentError_checkNotNull: function(argument, $name) {
                return argument;
            },
            RangeError$: function(message) {
                var _null = null;
                return new A.RangeError(_null, _null, false, _null, _null, message);
            },
            RangeError$value: function(value, $name, message) {
                return new A.RangeError(null, null, true, value, $name, message == null ? "Value not in range" : message);
            },
            RangeError$range: function(invalidValue, minValue, maxValue, $name, message) {
                return new A.RangeError(minValue, maxValue, true, invalidValue, $name, message == null ? "Invalid value" : message);
            },
            RangeError_checkValueInInterval: function(value, minValue, maxValue, $name) {
                if (value < minValue || value > maxValue) throw A.wrapException(A.RangeError$range(value, minValue, maxValue, $name, null));
                return value;
            },
            RangeError_checkValidRange: function(start, end, $length) {
                if (0 > start || start > $length) throw A.wrapException(A.RangeError$range(start, 0, $length, "start", null));
                if (end != null) {
                    if (start > end || end > $length) throw A.wrapException(A.RangeError$range(end, start, $length, "end", null));
                    return end;
                }
                return $length;
            },
            RangeError_checkNotNegative: function(value, $name) {
                if (value < 0) throw A.wrapException(A.RangeError$range(value, 0, null, $name, null));
                return value;
            },
            IndexError$withLength: function(invalidValue, $length, indexable, message, $name) {
                return new A.IndexError($length, true, invalidValue, $name, "Index out of range");
            },
            IndexError_check: function(index, $length, indexable, message, $name) {
                if (0 > index || index >= $length) throw A.wrapException(A.IndexError$withLength(index, $length, indexable, message, $name == null ? "index" : $name));
                return index;
            },
            UnsupportedError$: function(message) {
                return new A.UnsupportedError(message);
            },
            UnimplementedError$: function(message) {
                return new A.UnimplementedError(message);
            },
            StateError$: function(message) {
                return new A.StateError(message);
            },
            ConcurrentModificationError$: function(modifiedObject) {
                return new A.ConcurrentModificationError(modifiedObject);
            },
            FormatException$: function(message, source, offset) {
                return new A.FormatException(message, source, offset);
            },
            Iterable_Iterable$generate: function(count, generator, $E) {
                if (count <= 0) return new A.EmptyIterable($E._eval$1("EmptyIterable<0>"));
                return new A._GeneratorIterable(count, generator, $E._eval$1("_GeneratorIterable<0>"));
            },
            Iterable_iterableToShortString: function(iterable, leftDelimiter, rightDelimiter) {
                var parts, t1;
                if (A.isToStringVisiting(iterable)) {
                    if (leftDelimiter === "(" && rightDelimiter === ")") return "(...)";
                    return leftDelimiter + "..." + rightDelimiter;
                }
                parts = A._setArrayType([], type$.JSArray_String);
                $._toStringVisiting.push(iterable);
                try {
                    A._iterablePartsToStrings(iterable, parts);
                } finally{
                    $._toStringVisiting.pop();
                }
                t1 = A.StringBuffer__writeAll(leftDelimiter, parts, ", ") + rightDelimiter;
                return t1.charCodeAt(0) == 0 ? t1 : t1;
            },
            Iterable_iterableToFullString: function(iterable, leftDelimiter, rightDelimiter) {
                var buffer, t1;
                if (A.isToStringVisiting(iterable)) return leftDelimiter + "..." + rightDelimiter;
                buffer = new A.StringBuffer(leftDelimiter);
                $._toStringVisiting.push(iterable);
                try {
                    t1 = buffer;
                    t1._contents = A.StringBuffer__writeAll(t1._contents, iterable, ", ");
                } finally{
                    $._toStringVisiting.pop();
                }
                buffer._contents += rightDelimiter;
                t1 = buffer._contents;
                return t1.charCodeAt(0) == 0 ? t1 : t1;
            },
            _iterablePartsToStrings: function(iterable, parts) {
                var next, ultimateString, penultimateString, penultimate, ultimate, ultimate0, elision, it = iterable.get$iterator(iterable), $length = 0, count = 0;
                for(;;){
                    if (!($length < 80 || count < 3)) break;
                    if (!it.moveNext$0()) return;
                    next = A.S(it.get$current(it));
                    parts.push(next);
                    $length += next.length + 2;
                    ++count;
                }
                if (!it.moveNext$0()) {
                    if (count <= 5) return;
                    ultimateString = parts.pop();
                    penultimateString = parts.pop();
                } else {
                    penultimate = it.get$current(it);
                    ++count;
                    if (!it.moveNext$0()) {
                        if (count <= 4) {
                            parts.push(A.S(penultimate));
                            return;
                        }
                        ultimateString = A.S(penultimate);
                        penultimateString = parts.pop();
                        $length += ultimateString.length + 2;
                    } else {
                        ultimate = it.get$current(it);
                        ++count;
                        for(; it.moveNext$0(); penultimate = ultimate, ultimate = ultimate0){
                            ultimate0 = it.get$current(it);
                            ++count;
                            if (count > 100) {
                                for(;;){
                                    if (!($length > 75 && count > 3)) break;
                                    $length -= parts.pop().length + 2;
                                    --count;
                                }
                                parts.push("...");
                                return;
                            }
                        }
                        penultimateString = A.S(penultimate);
                        ultimateString = A.S(ultimate);
                        $length += ultimateString.length + penultimateString.length + 4;
                    }
                }
                if (count > parts.length + 2) {
                    $length += 5;
                    elision = "...";
                } else elision = null;
                for(;;){
                    if (!($length > 80 && parts.length > 3)) break;
                    $length -= parts.pop().length + 2;
                    if (elision == null) {
                        $length += 5;
                        elision = "...";
                    }
                }
                if (elision != null) parts.push(elision);
                parts.push(penultimateString);
                parts.push(ultimateString);
            },
            Map_castFrom: function(source, $K, $V, $K2, $V2) {
                return new A.CastMap(source, $K._eval$1("@<0>")._bind$1($V)._bind$1($K2)._bind$1($V2)._eval$1("CastMap<1,2,3,4>"));
            },
            Object_hash: function(object1, object2, object3, object4) {
                var t1;
                if (B.C_SentinelValue === object3) {
                    t1 = J.get$hashCode$(object1);
                    object2 = J.get$hashCode$(object2);
                    return A.SystemHash_finish(A.SystemHash_combine(A.SystemHash_combine($.$get$_hashSeed(), t1), object2));
                }
                if (B.C_SentinelValue === object4) {
                    t1 = J.get$hashCode$(object1);
                    object2 = J.get$hashCode$(object2);
                    object3 = J.get$hashCode$(object3);
                    return A.SystemHash_finish(A.SystemHash_combine(A.SystemHash_combine(A.SystemHash_combine($.$get$_hashSeed(), t1), object2), object3));
                }
                t1 = J.get$hashCode$(object1);
                object2 = J.get$hashCode$(object2);
                object3 = J.get$hashCode$(object3);
                object4 = J.get$hashCode$(object4);
                object4 = A.SystemHash_finish(A.SystemHash_combine(A.SystemHash_combine(A.SystemHash_combine(A.SystemHash_combine($.$get$_hashSeed(), t1), object2), object3), object4));
                return object4;
            },
            Object_hashAll: function(objects) {
                var t1, _i, hash = $.$get$_hashSeed();
                for(t1 = objects.length, _i = 0; _i < objects.length; objects.length === t1 || (0, A.throwConcurrentModificationError)(objects), ++_i)hash = A.SystemHash_combine(hash, J.get$hashCode$(objects[_i]));
                return A.SystemHash_finish(hash);
            },
            print: function(object) {
                var line = A.S(object), toZone = $._printToZone;
                if (toZone == null) A.printString(line);
                else toZone.call$1(line);
            },
            Set_Set$unmodifiable: function(elements, $E) {
                return new A.UnmodifiableSetView(A.LinkedHashSet_LinkedHashSet$of(elements, $E), $E._eval$1("UnmodifiableSetView<0>"));
            },
            Set_castFrom: function(source, newSet, $S, $T) {
                return new A.CastSet(source, newSet, $S._eval$1("@<0>")._bind$1($T)._eval$1("CastSet<1,2>"));
            },
            _combineSurrogatePair: function(start, end) {
                return 65536 + ((start & 1023) << 10) + (end & 1023);
            },
            Uri_Uri$dataFromString: function($content, encoding, mimeType) {
                var encodingName, t1, buffer = new A.StringBuffer(""), indices = A._setArrayType([
                    -1
                ], type$.JSArray_int);
                if (encoding == null) encodingName = null;
                else encodingName = "utf-8";
                if (encoding == null) encoding = B.C_AsciiCodec;
                A.UriData__writeUri(mimeType, encodingName, null, buffer, indices);
                indices.push(buffer._contents.length);
                buffer._contents += ",";
                A.UriData__uriEncodeBytes(256, encoding.encode$1($content), buffer);
                t1 = buffer._contents;
                return new A.UriData(t1.charCodeAt(0) == 0 ? t1 : t1, indices, null).get$uri();
            },
            Uri_parse: function(uri) {
                var delta, indices, schemeEnd, hostStart, portStart, pathStart, queryStart, fragmentStart, isSimple, scheme, t1, t2, schemeAuth, queryStart0, pathStart0, port, userInfoStart, userInfo, host, portNumber, path, query, _null = null, end = uri.length;
                if (end >= 5) {
                    delta = ((uri.charCodeAt(4) ^ 58) * 3 | uri.charCodeAt(0) ^ 100 | uri.charCodeAt(1) ^ 97 | uri.charCodeAt(2) ^ 116 | uri.charCodeAt(3) ^ 97) >>> 0;
                    if (delta === 0) return A.UriData__parse(uri, 5, _null).get$uri();
                    else if (delta === 32) return A.UriData__parse(B.JSString_methods.substring$2(uri, 5, end), 0, _null).get$uri();
                }
                indices = A.List_List$filled(8, 0, false, type$.int);
                indices[0] = 0;
                indices[1] = -1;
                indices[2] = -1;
                indices[7] = -1;
                indices[3] = 0;
                indices[4] = 0;
                indices[5] = end;
                indices[6] = end;
                if (A._scan(uri, 0, end, 0, indices) >= 14) indices[7] = end;
                schemeEnd = indices[1];
                if (schemeEnd >= 0) {
                    if (A._scan(uri, 0, schemeEnd, 20, indices) === 20) indices[7] = schemeEnd;
                }
                hostStart = indices[2] + 1;
                portStart = indices[3];
                pathStart = indices[4];
                queryStart = indices[5];
                fragmentStart = indices[6];
                if (fragmentStart < queryStart) queryStart = fragmentStart;
                if (pathStart < hostStart) pathStart = queryStart;
                else if (pathStart <= schemeEnd) pathStart = schemeEnd + 1;
                if (portStart < hostStart) portStart = pathStart;
                isSimple = indices[7] < 0;
                scheme = _null;
                if (isSimple) {
                    isSimple = false;
                    if (!(hostStart > schemeEnd + 3)) {
                        t1 = portStart > 0;
                        if (!(t1 && portStart + 1 === pathStart)) {
                            if (!B.JSString_methods.startsWith$2(uri, "\\", pathStart)) {
                                if (hostStart > 0) t2 = B.JSString_methods.startsWith$2(uri, "\\", hostStart - 1) || B.JSString_methods.startsWith$2(uri, "\\", hostStart - 2);
                                else t2 = false;
                            } else t2 = true;
                            if (!t2) {
                                if (!(queryStart < end && queryStart === pathStart + 2 && B.JSString_methods.startsWith$2(uri, "..", pathStart))) t2 = queryStart > pathStart + 2 && B.JSString_methods.startsWith$2(uri, "/..", queryStart - 3);
                                else t2 = true;
                                if (!t2) {
                                    if (schemeEnd === 4) {
                                        if (B.JSString_methods.startsWith$2(uri, "file", 0)) {
                                            if (hostStart <= 0) {
                                                if (!B.JSString_methods.startsWith$2(uri, "/", pathStart)) {
                                                    schemeAuth = "file:///";
                                                    delta = 3;
                                                } else {
                                                    schemeAuth = "file://";
                                                    delta = 2;
                                                }
                                                uri = schemeAuth + B.JSString_methods.substring$2(uri, pathStart, end);
                                                queryStart += delta;
                                                fragmentStart += delta;
                                                end = uri.length;
                                                hostStart = 7;
                                                portStart = 7;
                                                pathStart = 7;
                                            } else if (pathStart === queryStart) {
                                                ++fragmentStart;
                                                queryStart0 = queryStart + 1;
                                                uri = B.JSString_methods.replaceRange$3(uri, pathStart, queryStart, "/");
                                                ++end;
                                                queryStart = queryStart0;
                                            }
                                            scheme = "file";
                                        } else if (B.JSString_methods.startsWith$2(uri, "http", 0)) {
                                            if (t1 && portStart + 3 === pathStart && B.JSString_methods.startsWith$2(uri, "80", portStart + 1)) {
                                                fragmentStart -= 3;
                                                pathStart0 = pathStart - 3;
                                                queryStart -= 3;
                                                uri = B.JSString_methods.replaceRange$3(uri, portStart, pathStart, "");
                                                end -= 3;
                                                pathStart = pathStart0;
                                            }
                                            scheme = "http";
                                        }
                                    } else if (schemeEnd === 5 && B.JSString_methods.startsWith$2(uri, "https", 0)) {
                                        if (t1 && portStart + 4 === pathStart && B.JSString_methods.startsWith$2(uri, "443", portStart + 1)) {
                                            fragmentStart -= 4;
                                            pathStart0 = pathStart - 4;
                                            queryStart -= 4;
                                            uri = B.JSString_methods.replaceRange$3(uri, portStart, pathStart, "");
                                            end -= 3;
                                            pathStart = pathStart0;
                                        }
                                        scheme = "https";
                                    }
                                }
                                isSimple = !t2;
                            }
                        }
                    }
                }
                if (isSimple) return new A._SimpleUri(end < uri.length ? B.JSString_methods.substring$2(uri, 0, end) : uri, schemeEnd, hostStart, portStart, pathStart, queryStart, fragmentStart, scheme);
                if (scheme == null) {
                    if (schemeEnd > 0) scheme = A._Uri__makeScheme(uri, 0, schemeEnd);
                    else {
                        if (schemeEnd === 0) A._Uri__fail(uri, 0, "Invalid empty scheme");
                        scheme = "";
                    }
                }
                port = _null;
                if (hostStart > 0) {
                    userInfoStart = schemeEnd + 3;
                    userInfo = userInfoStart < hostStart ? A._Uri__makeUserInfo(uri, userInfoStart, hostStart - 1) : "";
                    host = A._Uri__makeHost(uri, hostStart, portStart, false);
                    t1 = portStart + 1;
                    if (t1 < pathStart) {
                        portNumber = A.Primitives_parseInt(B.JSString_methods.substring$2(uri, t1, pathStart), _null);
                        port = A._Uri__makePort(portNumber == null ? A.throwExpression(A.FormatException$("Invalid port", uri, t1)) : portNumber, scheme);
                    }
                } else {
                    host = _null;
                    userInfo = "";
                }
                path = A._Uri__makePath(uri, pathStart, queryStart, _null, scheme, host != null);
                query = queryStart < fragmentStart ? A._Uri__makeQuery(uri, queryStart + 1, fragmentStart, _null) : _null;
                return A._Uri$_internal(scheme, userInfo, host, port, path, query, fragmentStart < end ? A._Uri__makeFragment(uri, fragmentStart + 1, end) : _null);
            },
            Uri_decodeComponent: function(encodedComponent) {
                return A._Uri__uriDecode(encodedComponent, 0, encodedComponent.length, B.C_Utf8Codec, false);
            },
            Uri__ipv4FormatError: function(msg, source, position) {
                throw A.wrapException(A.FormatException$("Illegal IPv4 address, " + msg, source, position));
            },
            Uri__parseIPv4Address: function(host, start, end, target, targetOffset) {
                var t1, octetStart, cursor, octetIndex, octetValue, char, digit, octetIndex0, _s17_ = "invalid character";
                for(t1 = target.$flags | 0, octetStart = start, cursor = octetStart, octetIndex = 0, octetValue = 0;;){
                    char = cursor >= end ? 0 : host.charCodeAt(cursor);
                    digit = char ^ 48;
                    if (digit <= 9) {
                        if (octetValue !== 0 || cursor === octetStart) {
                            octetValue = octetValue * 10 + digit;
                            if (octetValue <= 255) {
                                ++cursor;
                                continue;
                            }
                            A.Uri__ipv4FormatError("each part must be in the range 0..255", host, octetStart);
                        }
                        A.Uri__ipv4FormatError("parts must not have leading zeros", host, octetStart);
                    }
                    if (cursor === octetStart) {
                        if (cursor === end) break;
                        A.Uri__ipv4FormatError(_s17_, host, cursor);
                    }
                    octetIndex0 = octetIndex + 1;
                    t1 & 2 && A.throwUnsupportedOperation(target);
                    target[targetOffset + octetIndex] = octetValue;
                    if (char === 46) {
                        if (octetIndex0 < 4) {
                            ++cursor;
                            octetIndex = octetIndex0;
                            octetStart = cursor;
                            octetValue = 0;
                            continue;
                        }
                        break;
                    }
                    if (cursor === end) {
                        if (octetIndex0 === 4) return;
                        break;
                    }
                    A.Uri__ipv4FormatError(_s17_, host, cursor);
                    octetIndex = octetIndex0;
                }
                A.Uri__ipv4FormatError("IPv4 address should contain exactly 4 parts", host, cursor);
            },
            Uri__validateIPvAddress: function(host, start, end) {
                var error;
                if (start === end) throw A.wrapException(A.FormatException$("Empty IP address", host, start));
                if (host.charCodeAt(start) === 118) {
                    error = A.Uri__validateIPvFutureAddress(host, start, end);
                    if (error != null) throw A.wrapException(error);
                    return false;
                }
                A.Uri_parseIPv6Address(host, start, end);
                return true;
            },
            Uri__validateIPvFutureAddress: function(host, start, end) {
                var cursor, cursor0, char, ucChar, _s38_ = "Missing hex-digit in IPvFuture address";
                ++start;
                for(cursor = start;; cursor = cursor0){
                    if (cursor < end) {
                        cursor0 = cursor + 1;
                        char = host.charCodeAt(cursor);
                        if ((char ^ 48) <= 9) continue;
                        ucChar = char | 32;
                        if (ucChar >= 97 && ucChar <= 102) continue;
                        if (char === 46) {
                            if (cursor0 - 1 === start) return new A.FormatException(_s38_, host, cursor0);
                            cursor = cursor0;
                            break;
                        }
                        return new A.FormatException("Unexpected character", host, cursor0 - 1);
                    }
                    if (cursor - 1 === start) return new A.FormatException(_s38_, host, cursor);
                    return new A.FormatException("Missing '.' in IPvFuture address", host, cursor);
                }
                if (cursor === end) return new A.FormatException("Missing address in IPvFuture address, host, cursor", null, null);
                for(;;){
                    if ((string$.x00_____.charCodeAt(host.charCodeAt(cursor)) & 16) !== 0) {
                        ++cursor;
                        if (cursor < end) continue;
                        return null;
                    }
                    return new A.FormatException("Invalid IPvFuture address character", host, cursor);
                }
            },
            Uri_parseIPv6Address: function(host, start, end) {
                var result, wildcardAt, partCount, cursor, partStart, hexValue, decValue, char, _0_0, decValue0, hexDigit, _1_0, t1, partCount0, partAfterWildcard, partsAfterWildcard, positionAfterWildcard, newPositionAfterWildcard, _s39_ = "an address must contain at most 8 parts", error = new A.Uri_parseIPv6Address_error(host);
                if (end - start < 2) error.call$2("address is too short", null);
                result = new Uint8Array(16);
                wildcardAt = -1;
                partCount = 0;
                if (host.charCodeAt(start) === 58) {
                    if (host.charCodeAt(start + 1) === 58) {
                        cursor = start + 2;
                        partStart = cursor;
                        wildcardAt = 0;
                        partCount = 1;
                    } else {
                        error.call$2("invalid start colon", start);
                        cursor = start;
                        partStart = cursor;
                    }
                } else {
                    cursor = start;
                    partStart = cursor;
                }
                for(hexValue = 0, decValue = true;;){
                    char = cursor >= end ? 0 : host.charCodeAt(cursor);
                    $label0$0: {
                        _0_0 = char ^ 48;
                        decValue0 = false;
                        if (_0_0 <= 9) hexDigit = _0_0;
                        else {
                            _1_0 = char | 32;
                            if (_1_0 >= 97 && _1_0 <= 102) hexDigit = _1_0 - 87;
                            else break $label0$0;
                            decValue = decValue0;
                        }
                        if (cursor < partStart + 4) {
                            hexValue = hexValue * 16 + hexDigit;
                            ++cursor;
                            continue;
                        }
                        error.call$2("an IPv6 part can contain a maximum of 4 hex digits", partStart);
                    }
                    if (cursor > partStart) {
                        if (char === 46) {
                            if (decValue) {
                                if (partCount <= 6) {
                                    A.Uri__parseIPv4Address(host, partStart, end, result, partCount * 2);
                                    partCount += 2;
                                    cursor = end;
                                    break;
                                }
                                error.call$2(_s39_, partStart);
                            }
                            break;
                        }
                        t1 = partCount * 2;
                        result[t1] = B.JSInt_methods._shrOtherPositive$1(hexValue, 8);
                        result[t1 + 1] = hexValue & 255;
                        ++partCount;
                        if (char === 58) {
                            if (partCount < 8) {
                                ++cursor;
                                partStart = cursor;
                                hexValue = 0;
                                decValue = true;
                                continue;
                            }
                            error.call$2(_s39_, cursor);
                        }
                        break;
                    }
                    if (char === 58) {
                        if (wildcardAt < 0) {
                            partCount0 = partCount + 1;
                            ++cursor;
                            wildcardAt = partCount;
                            partCount = partCount0;
                            partStart = cursor;
                            continue;
                        }
                        error.call$2("only one wildcard `::` is allowed", cursor);
                    }
                    if (wildcardAt !== partCount - 1) error.call$2("missing part", cursor);
                    break;
                }
                if (cursor < end) error.call$2("invalid character", cursor);
                if (partCount < 8) {
                    if (wildcardAt < 0) error.call$2("an address without a wildcard must contain exactly 8 parts", end);
                    partAfterWildcard = wildcardAt + 1;
                    partsAfterWildcard = partCount - partAfterWildcard;
                    if (partsAfterWildcard > 0) {
                        positionAfterWildcard = partAfterWildcard * 2;
                        newPositionAfterWildcard = 16 - partsAfterWildcard * 2;
                        B.NativeUint8List_methods.setRange$4(result, newPositionAfterWildcard, 16, result, positionAfterWildcard);
                        B.NativeUint8List_methods.fillRange$3(result, positionAfterWildcard, newPositionAfterWildcard, 0);
                    }
                }
                return result;
            },
            _Uri$_internal: function(scheme, _userInfo, _host, _port, path, _query, _fragment) {
                return new A._Uri(scheme, _userInfo, _host, _port, path, _query, _fragment);
            },
            _Uri__Uri: function(host, path, pathSegments, scheme) {
                var userInfo, query, fragment, port, isFile, t1, hasAuthority, t2, _null = null;
                scheme = scheme == null ? "" : A._Uri__makeScheme(scheme, 0, scheme.length);
                userInfo = A._Uri__makeUserInfo(_null, 0, 0);
                host = A._Uri__makeHost(host, 0, host == null ? 0 : host.length, false);
                query = A._Uri__makeQuery(_null, 0, 0, _null);
                fragment = A._Uri__makeFragment(_null, 0, 0);
                port = A._Uri__makePort(_null, scheme);
                isFile = scheme === "file";
                if (host == null) t1 = userInfo.length !== 0 || port != null || isFile;
                else t1 = false;
                if (t1) host = "";
                t1 = host == null;
                hasAuthority = !t1;
                path = A._Uri__makePath(path, 0, path == null ? 0 : path.length, pathSegments, scheme, hasAuthority);
                t2 = scheme.length === 0;
                if (t2 && t1 && !B.JSString_methods.startsWith$1(path, "/")) path = A._Uri__normalizeRelativePath(path, !t2 || hasAuthority);
                else path = A._Uri__removeDotSegments(path);
                return A._Uri$_internal(scheme, userInfo, t1 && B.JSString_methods.startsWith$1(path, "//") ? "" : host, port, path, query, fragment);
            },
            _Uri__defaultPort: function(scheme) {
                if (scheme === "http") return 80;
                if (scheme === "https") return 443;
                return 0;
            },
            _Uri__fail: function(uri, index, message) {
                throw A.wrapException(A.FormatException$(message, uri, index));
            },
            _Uri__Uri$file: function(path, windows) {
                return windows ? A._Uri__makeWindowsFileUrl(path, false) : A._Uri__makeFileUri(path, false);
            },
            _Uri__checkNonWindowsPathReservedCharacters: function(segments, argumentError) {
                var t1, _i, segment;
                for(t1 = segments.length, _i = 0; _i < t1; ++_i){
                    segment = segments[_i];
                    if (A.stringContainsUnchecked(segment, "/", 0)) {
                        t1 = A.UnsupportedError$("Illegal path character " + segment);
                        throw A.wrapException(t1);
                    }
                }
            },
            _Uri__checkWindowsPathReservedCharacters: function(segments, argumentError, firstSegment) {
                var t1, t2, t3, t4;
                for(t1 = A.SubListIterable$(segments, firstSegment, null, A._arrayInstanceType(segments)._precomputed1), t2 = t1.$ti, t1 = new A.ListIterator(t1, t1.get$length(0), t2._eval$1("ListIterator<ListIterable.E>")), t2 = t2._eval$1("ListIterable.E"); t1.moveNext$0();){
                    t3 = t1.__internal$_current;
                    if (t3 == null) t3 = t2._as(t3);
                    t4 = A.RegExp_RegExp('["*/:<>?\\\\|]', false);
                    if (A.stringContainsUnchecked(t3, t4, 0)) {
                        if (argumentError) throw A.wrapException(A.ArgumentError$("Illegal character in path", null));
                        else throw A.wrapException(A.UnsupportedError$("Illegal character in path: " + t3));
                    }
                }
            },
            _Uri__checkWindowsDriveLetter: function(charCode, argumentError) {
                var t1, _s21_ = "Illegal drive letter ";
                if (!(65 <= charCode && charCode <= 90)) t1 = 97 <= charCode && charCode <= 122;
                else t1 = true;
                if (t1) return;
                if (argumentError) throw A.wrapException(A.ArgumentError$(_s21_ + A.String_String$fromCharCode(charCode), null));
                else throw A.wrapException(A.UnsupportedError$(_s21_ + A.String_String$fromCharCode(charCode)));
            },
            _Uri__makeFileUri: function(path, slashTerminated) {
                var _null = null, segments = A._setArrayType(path.split("/"), type$.JSArray_String);
                if (B.JSString_methods.startsWith$1(path, "/")) return A._Uri__Uri(_null, _null, segments, "file");
                else return A._Uri__Uri(_null, _null, segments, _null);
            },
            _Uri__makeWindowsFileUrl: function(path, slashTerminated) {
                var t1, pathSegments, pathStart, hostPart, _s1_ = "\\", _null = null, _s4_ = "file";
                if (B.JSString_methods.startsWith$1(path, "\\\\?\\")) {
                    if (B.JSString_methods.startsWith$2(path, "UNC\\", 4)) path = B.JSString_methods.replaceRange$3(path, 0, 7, _s1_);
                    else {
                        path = B.JSString_methods.substring$1(path, 4);
                        if (path.length < 3 || path.charCodeAt(1) !== 58 || path.charCodeAt(2) !== 92) throw A.wrapException(A.ArgumentError$value(path, "path", "Windows paths with \\\\?\\ prefix must be absolute"));
                    }
                } else path = A.stringReplaceAllUnchecked(path, "/", _s1_);
                t1 = path.length;
                if (t1 > 1 && path.charCodeAt(1) === 58) {
                    A._Uri__checkWindowsDriveLetter(path.charCodeAt(0), true);
                    if (t1 === 2 || path.charCodeAt(2) !== 92) throw A.wrapException(A.ArgumentError$value(path, "path", "Windows paths with drive letter must be absolute"));
                    pathSegments = A._setArrayType(path.split(_s1_), type$.JSArray_String);
                    A._Uri__checkWindowsPathReservedCharacters(pathSegments, true, 1);
                    return A._Uri__Uri(_null, _null, pathSegments, _s4_);
                }
                if (B.JSString_methods.startsWith$1(path, _s1_)) {
                    if (B.JSString_methods.startsWith$2(path, _s1_, 1)) {
                        pathStart = B.JSString_methods.indexOf$2(path, _s1_, 2);
                        t1 = pathStart < 0;
                        hostPart = t1 ? B.JSString_methods.substring$1(path, 2) : B.JSString_methods.substring$2(path, 2, pathStart);
                        pathSegments = A._setArrayType((t1 ? "" : B.JSString_methods.substring$1(path, pathStart + 1)).split(_s1_), type$.JSArray_String);
                        A._Uri__checkWindowsPathReservedCharacters(pathSegments, true, 0);
                        return A._Uri__Uri(hostPart, _null, pathSegments, _s4_);
                    } else {
                        pathSegments = A._setArrayType(path.split(_s1_), type$.JSArray_String);
                        A._Uri__checkWindowsPathReservedCharacters(pathSegments, true, 0);
                        return A._Uri__Uri(_null, _null, pathSegments, _s4_);
                    }
                } else {
                    pathSegments = A._setArrayType(path.split(_s1_), type$.JSArray_String);
                    A._Uri__checkWindowsPathReservedCharacters(pathSegments, true, 0);
                    return A._Uri__Uri(_null, _null, pathSegments, _null);
                }
            },
            _Uri__makePort: function(port, scheme) {
                if (port != null && port === A._Uri__defaultPort(scheme)) return null;
                return port;
            },
            _Uri__makeHost: function(host, start, end, strictIPv6) {
                var index, t1, zoneID, index0, zoneIDstart, isIPv6, hostChars, i;
                if (host == null) return null;
                if (start === end) return "";
                if (host.charCodeAt(start) === 91) {
                    index = end - 1;
                    if (host.charCodeAt(index) !== 93) A._Uri__fail(host, start, "Missing end `]` to match `[` in host");
                    t1 = start + 1;
                    zoneID = "";
                    if (host.charCodeAt(t1) !== 118) {
                        index0 = A._Uri__checkZoneID(host, t1, index);
                        if (index0 < index) {
                            zoneIDstart = index0 + 1;
                            zoneID = A._Uri__normalizeZoneID(host, B.JSString_methods.startsWith$2(host, "25", zoneIDstart) ? index0 + 3 : zoneIDstart, index, "%25");
                        }
                        index = index0;
                    }
                    isIPv6 = A.Uri__validateIPvAddress(host, t1, index);
                    hostChars = B.JSString_methods.substring$2(host, t1, index);
                    return "[" + (isIPv6 ? hostChars.toLowerCase() : hostChars) + zoneID + "]";
                }
                for(i = start; i < end; ++i)if (host.charCodeAt(i) === 58) {
                    index = B.JSString_methods.indexOf$2(host, "%", start);
                    index = index >= start && index < end ? index : end;
                    if (index < end) {
                        zoneIDstart = index + 1;
                        zoneID = A._Uri__normalizeZoneID(host, B.JSString_methods.startsWith$2(host, "25", zoneIDstart) ? index + 3 : zoneIDstart, end, "%25");
                    } else zoneID = "";
                    A.Uri_parseIPv6Address(host, start, index);
                    return "[" + B.JSString_methods.substring$2(host, start, index) + zoneID + "]";
                }
                return A._Uri__normalizeRegName(host, start, end);
            },
            _Uri__checkZoneID: function(host, start, end) {
                var index = B.JSString_methods.indexOf$2(host, "%", start);
                return index >= start && index < end ? index : end;
            },
            _Uri__normalizeZoneID: function(host, start, end, prefix) {
                var index, sectionStart, isNormalized, char, replacement, t1, t2, sourceLength, tail, slice, buffer = prefix !== "" ? new A.StringBuffer(prefix) : null;
                for(index = start, sectionStart = index, isNormalized = true; index < end;){
                    char = host.charCodeAt(index);
                    if (char === 37) {
                        replacement = A._Uri__normalizeEscape(host, index, true);
                        t1 = replacement == null;
                        if (t1 && isNormalized) {
                            index += 3;
                            continue;
                        }
                        if (buffer == null) buffer = new A.StringBuffer("");
                        t2 = buffer._contents += B.JSString_methods.substring$2(host, sectionStart, index);
                        if (t1) replacement = B.JSString_methods.substring$2(host, index, index + 3);
                        else if (replacement === "%") A._Uri__fail(host, index, "ZoneID should not contain % anymore");
                        buffer._contents = t2 + replacement;
                        index += 3;
                        sectionStart = index;
                        isNormalized = true;
                    } else if (char < 127 && (string$.x00_____.charCodeAt(char) & 1) !== 0) {
                        if (isNormalized && 65 <= char && 90 >= char) {
                            if (buffer == null) buffer = new A.StringBuffer("");
                            if (sectionStart < index) {
                                buffer._contents += B.JSString_methods.substring$2(host, sectionStart, index);
                                sectionStart = index;
                            }
                            isNormalized = false;
                        }
                        ++index;
                    } else {
                        sourceLength = 1;
                        if ((char & 64512) === 55296 && index + 1 < end) {
                            tail = host.charCodeAt(index + 1);
                            if ((tail & 64512) === 56320) {
                                char = 65536 + ((char & 1023) << 10) + (tail & 1023);
                                sourceLength = 2;
                            }
                        }
                        slice = B.JSString_methods.substring$2(host, sectionStart, index);
                        if (buffer == null) {
                            buffer = new A.StringBuffer("");
                            t1 = buffer;
                        } else t1 = buffer;
                        t1._contents += slice;
                        t2 = A._Uri__escapeChar(char);
                        t1._contents += t2;
                        index += sourceLength;
                        sectionStart = index;
                    }
                }
                if (buffer == null) return B.JSString_methods.substring$2(host, start, end);
                if (sectionStart < end) {
                    slice = B.JSString_methods.substring$2(host, sectionStart, end);
                    buffer._contents += slice;
                }
                t1 = buffer._contents;
                return t1.charCodeAt(0) == 0 ? t1 : t1;
            },
            _Uri__normalizeRegName: function(host, start, end) {
                var index, sectionStart, buffer, isNormalized, char, replacement, t1, slice, t2, sourceLength, tail, _s128_ = string$.x00_____;
                for(index = start, sectionStart = index, buffer = null, isNormalized = true; index < end;){
                    char = host.charCodeAt(index);
                    if (char === 37) {
                        replacement = A._Uri__normalizeEscape(host, index, true);
                        t1 = replacement == null;
                        if (t1 && isNormalized) {
                            index += 3;
                            continue;
                        }
                        if (buffer == null) buffer = new A.StringBuffer("");
                        slice = B.JSString_methods.substring$2(host, sectionStart, index);
                        if (!isNormalized) slice = slice.toLowerCase();
                        t2 = buffer._contents += slice;
                        sourceLength = 3;
                        if (t1) replacement = B.JSString_methods.substring$2(host, index, index + 3);
                        else if (replacement === "%") {
                            replacement = "%25";
                            sourceLength = 1;
                        }
                        buffer._contents = t2 + replacement;
                        index += sourceLength;
                        sectionStart = index;
                        isNormalized = true;
                    } else if (char < 127 && (_s128_.charCodeAt(char) & 32) !== 0) {
                        if (isNormalized && 65 <= char && 90 >= char) {
                            if (buffer == null) buffer = new A.StringBuffer("");
                            if (sectionStart < index) {
                                buffer._contents += B.JSString_methods.substring$2(host, sectionStart, index);
                                sectionStart = index;
                            }
                            isNormalized = false;
                        }
                        ++index;
                    } else if (char <= 93 && (_s128_.charCodeAt(char) & 1024) !== 0) A._Uri__fail(host, index, "Invalid character");
                    else {
                        sourceLength = 1;
                        if ((char & 64512) === 55296 && index + 1 < end) {
                            tail = host.charCodeAt(index + 1);
                            if ((tail & 64512) === 56320) {
                                char = 65536 + ((char & 1023) << 10) + (tail & 1023);
                                sourceLength = 2;
                            }
                        }
                        slice = B.JSString_methods.substring$2(host, sectionStart, index);
                        if (!isNormalized) slice = slice.toLowerCase();
                        if (buffer == null) {
                            buffer = new A.StringBuffer("");
                            t1 = buffer;
                        } else t1 = buffer;
                        t1._contents += slice;
                        t2 = A._Uri__escapeChar(char);
                        t1._contents += t2;
                        index += sourceLength;
                        sectionStart = index;
                    }
                }
                if (buffer == null) return B.JSString_methods.substring$2(host, start, end);
                if (sectionStart < end) {
                    slice = B.JSString_methods.substring$2(host, sectionStart, end);
                    if (!isNormalized) slice = slice.toLowerCase();
                    buffer._contents += slice;
                }
                t1 = buffer._contents;
                return t1.charCodeAt(0) == 0 ? t1 : t1;
            },
            _Uri__makeScheme: function(scheme, start, end) {
                var i, containsUpperCase, codeUnit;
                if (start === end) return "";
                if (!A._Uri__isAlphabeticCharacter(scheme.charCodeAt(start))) A._Uri__fail(scheme, start, "Scheme not starting with alphabetic character");
                for(i = start, containsUpperCase = false; i < end; ++i){
                    codeUnit = scheme.charCodeAt(i);
                    if (!(codeUnit < 128 && (string$.x00_____.charCodeAt(codeUnit) & 8) !== 0)) A._Uri__fail(scheme, i, "Illegal scheme character");
                    if (65 <= codeUnit && codeUnit <= 90) containsUpperCase = true;
                }
                scheme = B.JSString_methods.substring$2(scheme, start, end);
                return A._Uri__canonicalizeScheme(containsUpperCase ? scheme.toLowerCase() : scheme);
            },
            _Uri__canonicalizeScheme: function(scheme) {
                if (scheme === "http") return "http";
                if (scheme === "file") return "file";
                if (scheme === "https") return "https";
                if (scheme === "package") return "package";
                return scheme;
            },
            _Uri__makeUserInfo: function(userInfo, start, end) {
                if (userInfo == null) return "";
                return A._Uri__normalizeOrSubstring(userInfo, start, end, 16, false, false);
            },
            _Uri__makePath: function(path, start, end, pathSegments, scheme, hasAuthority) {
                var result, isFile = scheme === "file", ensureLeadingSlash = isFile || hasAuthority;
                if (path == null) {
                    if (pathSegments == null) return isFile ? "/" : "";
                    result = new A.MappedListIterable(pathSegments, new A._Uri__makePath_closure(), A._arrayInstanceType(pathSegments)._eval$1("MappedListIterable<1,String>")).join$1(0, "/");
                } else if (pathSegments != null) throw A.wrapException(A.ArgumentError$("Both path and pathSegments specified", null));
                else result = A._Uri__normalizeOrSubstring(path, start, end, 128, true, true);
                if (result.length === 0) {
                    if (isFile) return "/";
                } else if (ensureLeadingSlash && !B.JSString_methods.startsWith$1(result, "/")) result = "/" + result;
                return A._Uri__normalizePath(result, scheme, hasAuthority);
            },
            _Uri__normalizePath: function(path, scheme, hasAuthority) {
                var t1 = scheme.length === 0;
                if (t1 && !hasAuthority && !B.JSString_methods.startsWith$1(path, "/") && !B.JSString_methods.startsWith$1(path, "\\")) return A._Uri__normalizeRelativePath(path, !t1 || hasAuthority);
                return A._Uri__removeDotSegments(path);
            },
            _Uri__makeQuery: function(query, start, end, queryParameters) {
                if (query != null) return A._Uri__normalizeOrSubstring(query, start, end, 256, true, false);
                return null;
            },
            _Uri__makeFragment: function(fragment, start, end) {
                if (fragment == null) return null;
                return A._Uri__normalizeOrSubstring(fragment, start, end, 256, true, false);
            },
            _Uri__normalizeEscape: function(source, index, lowerCase) {
                var firstDigit, secondDigit, firstDigitValue, secondDigitValue, value, t1 = index + 2;
                if (t1 >= source.length) return "%";
                firstDigit = source.charCodeAt(index + 1);
                secondDigit = source.charCodeAt(t1);
                firstDigitValue = A.hexDigitValue(firstDigit);
                secondDigitValue = A.hexDigitValue(secondDigit);
                if (firstDigitValue < 0 || secondDigitValue < 0) return "%";
                value = firstDigitValue * 16 + secondDigitValue;
                if (value < 127 && (string$.x00_____.charCodeAt(value) & 1) !== 0) return A.Primitives_stringFromCharCode(lowerCase && 65 <= value && 90 >= value ? (value | 32) >>> 0 : value);
                if (firstDigit >= 97 || secondDigit >= 97) return B.JSString_methods.substring$2(source, index, index + 3).toUpperCase();
                return null;
            },
            _Uri__escapeChar: function(char) {
                var codeUnits, flag, encodedBytes, index, byte, _s16_ = "0123456789ABCDEF";
                if (char <= 127) {
                    codeUnits = new Uint8Array(3);
                    codeUnits[0] = 37;
                    codeUnits[1] = _s16_.charCodeAt(char >>> 4);
                    codeUnits[2] = _s16_.charCodeAt(char & 15);
                } else {
                    if (char > 2047) {
                        if (char > 65535) {
                            flag = 240;
                            encodedBytes = 4;
                        } else {
                            flag = 224;
                            encodedBytes = 3;
                        }
                    } else {
                        flag = 192;
                        encodedBytes = 2;
                    }
                    codeUnits = new Uint8Array(3 * encodedBytes);
                    for(index = 0; --encodedBytes, encodedBytes >= 0; flag = 128){
                        byte = B.JSInt_methods._shrReceiverPositive$1(char, 6 * encodedBytes) & 63 | flag;
                        codeUnits[index] = 37;
                        codeUnits[index + 1] = _s16_.charCodeAt(byte >>> 4);
                        codeUnits[index + 2] = _s16_.charCodeAt(byte & 15);
                        index += 3;
                    }
                }
                return A.String_String$fromCharCodes(codeUnits, 0, null);
            },
            _Uri__normalizeOrSubstring: function(component, start, end, charMask, escapeDelimiters, replaceBackslash) {
                var t1 = A._Uri__normalize(component, start, end, charMask, escapeDelimiters, replaceBackslash);
                return t1 == null ? B.JSString_methods.substring$2(component, start, end) : t1;
            },
            _Uri__normalize: function(component, start, end, charMask, escapeDelimiters, replaceBackslash) {
                var t1, index, sectionStart, buffer, char, sourceLength, replacement, t2, tail, _null = null, _s128_ = string$.x00_____;
                for(t1 = !escapeDelimiters, index = start, sectionStart = index, buffer = _null; index < end;){
                    char = component.charCodeAt(index);
                    if (char < 127 && (_s128_.charCodeAt(char) & charMask) !== 0) ++index;
                    else {
                        sourceLength = 1;
                        if (char === 37) {
                            replacement = A._Uri__normalizeEscape(component, index, false);
                            if (replacement == null) {
                                index += 3;
                                continue;
                            }
                            if ("%" === replacement) replacement = "%25";
                            else sourceLength = 3;
                        } else if (char === 92 && replaceBackslash) replacement = "/";
                        else if (t1 && char <= 93 && (_s128_.charCodeAt(char) & 1024) !== 0) {
                            A._Uri__fail(component, index, "Invalid character");
                            sourceLength = _null;
                            replacement = sourceLength;
                        } else {
                            if ((char & 64512) === 55296) {
                                t2 = index + 1;
                                if (t2 < end) {
                                    tail = component.charCodeAt(t2);
                                    if ((tail & 64512) === 56320) {
                                        char = 65536 + ((char & 1023) << 10) + (tail & 1023);
                                        sourceLength = 2;
                                    }
                                }
                            }
                            replacement = A._Uri__escapeChar(char);
                        }
                        if (buffer == null) {
                            buffer = new A.StringBuffer("");
                            t2 = buffer;
                        } else t2 = buffer;
                        t2._contents = (t2._contents += B.JSString_methods.substring$2(component, sectionStart, index)) + replacement;
                        index += sourceLength;
                        sectionStart = index;
                    }
                }
                if (buffer == null) return _null;
                if (sectionStart < end) {
                    t1 = B.JSString_methods.substring$2(component, sectionStart, end);
                    buffer._contents += t1;
                }
                t1 = buffer._contents;
                return t1.charCodeAt(0) == 0 ? t1 : t1;
            },
            _Uri__mayContainDotSegments: function(path) {
                if (B.JSString_methods.startsWith$1(path, ".")) return true;
                return B.JSString_methods.indexOf$1(path, "/.") !== -1;
            },
            _Uri__removeDotSegments: function(path) {
                var output, t1, t2, appendSlash, _i, segment;
                if (!A._Uri__mayContainDotSegments(path)) return path;
                output = A._setArrayType([], type$.JSArray_String);
                for(t1 = path.split("/"), t2 = t1.length, appendSlash = false, _i = 0; _i < t2; ++_i){
                    segment = t1[_i];
                    if (segment === "..") {
                        if (output.length !== 0) {
                            output.pop();
                            if (output.length === 0) output.push("");
                        }
                        appendSlash = true;
                    } else {
                        appendSlash = "." === segment;
                        if (!appendSlash) output.push(segment);
                    }
                }
                if (appendSlash) output.push("");
                return B.JSArray_methods.join$1(output, "/");
            },
            _Uri__normalizeRelativePath: function(path, allowScheme) {
                var output, t1, t2, appendSlash, _i, segment;
                if (!A._Uri__mayContainDotSegments(path)) return !allowScheme ? A._Uri__escapeScheme(path) : path;
                output = A._setArrayType([], type$.JSArray_String);
                for(t1 = path.split("/"), t2 = t1.length, appendSlash = false, _i = 0; _i < t2; ++_i){
                    segment = t1[_i];
                    if (".." === segment) {
                        if (output.length !== 0 && B.JSArray_methods.get$last(output) !== "..") output.pop();
                        else output.push("..");
                        appendSlash = true;
                    } else {
                        appendSlash = "." === segment;
                        if (!appendSlash) output.push(segment.length === 0 && output.length === 0 ? "./" : segment);
                    }
                }
                if (output.length === 0) return "./";
                if (appendSlash) output.push("");
                if (!allowScheme) output[0] = A._Uri__escapeScheme(output[0]);
                return B.JSArray_methods.join$1(output, "/");
            },
            _Uri__escapeScheme: function(path) {
                var i, char, t1 = path.length;
                if (t1 >= 2 && A._Uri__isAlphabeticCharacter(path.charCodeAt(0))) for(i = 1; i < t1; ++i){
                    char = path.charCodeAt(i);
                    if (char === 58) return B.JSString_methods.substring$2(path, 0, i) + "%3A" + B.JSString_methods.substring$1(path, i + 1);
                    if (char > 127 || (string$.x00_____.charCodeAt(char) & 8) === 0) break;
                }
                return path;
            },
            _Uri__packageNameEnd: function(uri, path) {
                if (uri.isScheme$1("package") && uri._host == null) return A._skipPackageNameChars(path, 0, path.length);
                return -1;
            },
            _Uri__toWindowsFilePath: function(uri) {
                var t2, hasDriveLetter, host, segments = uri.get$pathSegments(), t1 = segments.length;
                if (t1 > 0) {
                    t2 = segments[0];
                    hasDriveLetter = t2.length === 2 && t2.charCodeAt(1) === 58;
                } else hasDriveLetter = false;
                if (hasDriveLetter) {
                    A._Uri__checkWindowsDriveLetter(segments[0].charCodeAt(0), false);
                    A._Uri__checkWindowsPathReservedCharacters(segments, false, 1);
                } else A._Uri__checkWindowsPathReservedCharacters(segments, false, 0);
                t2 = uri.get$hasAbsolutePath() && !hasDriveLetter ? "\\" : "";
                if (uri.get$hasAuthority()) {
                    host = uri.get$host();
                    if (host.length !== 0) t2 = t2 + "\\" + host + "\\";
                }
                t2 = A.StringBuffer__writeAll(t2, segments, "\\");
                t1 = hasDriveLetter && t1 === 1 ? t2 + "\\" : t2;
                return t1.charCodeAt(0) == 0 ? t1 : t1;
            },
            _Uri__hexCharPairToByte: function(s, pos) {
                var byte, i, charCode;
                for(byte = 0, i = 0; i < 2; ++i){
                    charCode = s.charCodeAt(pos + i);
                    if (48 <= charCode && charCode <= 57) byte = byte * 16 + charCode - 48;
                    else {
                        charCode |= 32;
                        if (97 <= charCode && charCode <= 102) byte = byte * 16 + charCode - 87;
                        else throw A.wrapException(A.ArgumentError$("Invalid URL encoding", null));
                    }
                }
                return byte;
            },
            _Uri__uriDecode: function(text, start, end, encoding, plusToSpace) {
                var simple, codeUnit, t1, bytes, i = start;
                for(;;){
                    if (!(i < end)) {
                        simple = true;
                        break;
                    }
                    codeUnit = text.charCodeAt(i);
                    if (codeUnit <= 127) t1 = codeUnit === 37;
                    else t1 = true;
                    if (t1) {
                        simple = false;
                        break;
                    }
                    ++i;
                }
                if (simple) {
                    if (B.C_Utf8Codec === encoding) return B.JSString_methods.substring$2(text, start, end);
                    else bytes = new A.CodeUnits(B.JSString_methods.substring$2(text, start, end));
                } else {
                    bytes = A._setArrayType([], type$.JSArray_int);
                    for(t1 = text.length, i = start; i < end; ++i){
                        codeUnit = text.charCodeAt(i);
                        if (codeUnit > 127) throw A.wrapException(A.ArgumentError$("Illegal percent encoding in URI", null));
                        if (codeUnit === 37) {
                            if (i + 3 > t1) throw A.wrapException(A.ArgumentError$("Truncated URI", null));
                            bytes.push(A._Uri__hexCharPairToByte(text, i + 1));
                            i += 2;
                        } else bytes.push(codeUnit);
                    }
                }
                return B.Utf8Decoder_false.convert$1(bytes);
            },
            _Uri__isAlphabeticCharacter: function(codeUnit) {
                var lowerCase = codeUnit | 32;
                return 97 <= lowerCase && lowerCase <= 122;
            },
            UriData__writeUri: function(mimeType, charsetName, parameters, buffer, indices) {
                var t1, slashIndex;
                if (mimeType != null) t1 = 10 === mimeType.length && A._caseInsensitiveCompareStart("text/plain", mimeType, 0) >= 0;
                else t1 = true;
                if (t1) mimeType = "";
                if (mimeType.length === 0 || mimeType === "application/octet-stream") t1 = buffer._contents += mimeType;
                else {
                    slashIndex = A.UriData__validateMimeType(mimeType);
                    if (slashIndex < 0) throw A.wrapException(A.ArgumentError$value(mimeType, "mimeType", "Invalid MIME type"));
                    t1 = A._Uri__uriEncode(512, B.JSString_methods.substring$2(mimeType, 0, slashIndex), B.C_Utf8Codec, false);
                    buffer._contents = (buffer._contents += t1) + "/";
                    t1 = A._Uri__uriEncode(512, B.JSString_methods.substring$1(mimeType, slashIndex + 1), B.C_Utf8Codec, false);
                    t1 = buffer._contents += t1;
                }
                if (charsetName != null) {
                    indices.push(t1.length);
                    indices.push(buffer._contents.length + 8);
                    buffer._contents += ";charset=";
                    t1 = A._Uri__uriEncode(512, charsetName, B.C_Utf8Codec, false);
                    buffer._contents += t1;
                }
            },
            UriData__validateMimeType: function(mimeType) {
                var t1, slashIndex, i;
                for(t1 = mimeType.length, slashIndex = -1, i = 0; i < t1; ++i){
                    if (mimeType.charCodeAt(i) !== 47) continue;
                    if (slashIndex < 0) {
                        slashIndex = i;
                        continue;
                    }
                    return -1;
                }
                return slashIndex;
            },
            UriData__parse: function(text, start, sourceUri) {
                var t1, i, slashIndex, char, equalsIndex, lastSeparator, t2, data, _s17_ = "Invalid MIME type", indices = A._setArrayType([
                    start - 1
                ], type$.JSArray_int);
                for(t1 = text.length, i = start, slashIndex = -1, char = null; i < t1; ++i){
                    char = text.charCodeAt(i);
                    if (char === 44 || char === 59) break;
                    if (char === 47) {
                        if (slashIndex < 0) {
                            slashIndex = i;
                            continue;
                        }
                        throw A.wrapException(A.FormatException$(_s17_, text, i));
                    }
                }
                if (slashIndex < 0 && i > start) throw A.wrapException(A.FormatException$(_s17_, text, i));
                while(char !== 44){
                    indices.push(i);
                    ++i;
                    for(equalsIndex = -1; i < t1; ++i){
                        char = text.charCodeAt(i);
                        if (char === 61) {
                            if (equalsIndex < 0) equalsIndex = i;
                        } else if (char === 59 || char === 44) break;
                    }
                    if (equalsIndex >= 0) indices.push(equalsIndex);
                    else {
                        lastSeparator = B.JSArray_methods.get$last(indices);
                        if (char !== 44 || i !== lastSeparator + 7 || !B.JSString_methods.startsWith$2(text, "base64", lastSeparator + 1)) throw A.wrapException(A.FormatException$("Expecting '='", text, i));
                        break;
                    }
                }
                indices.push(i);
                t2 = i + 1;
                if ((indices.length & 1) === 1) text = B.C_Base64Codec.normalize$3(text, t2, t1);
                else {
                    data = A._Uri__normalize(text, t2, t1, 256, true, false);
                    if (data != null) text = B.JSString_methods.replaceRange$3(text, t2, t1, data);
                }
                return new A.UriData(text, indices, sourceUri);
            },
            UriData__uriEncodeBytes: function(canonicalMask, bytes, buffer) {
                var t1, byteOr, i, byte, t2, _s16_ = "0123456789ABCDEF";
                for(t1 = bytes.length, byteOr = 0, i = 0; i < t1; ++i){
                    byte = bytes[i];
                    byteOr |= byte;
                    if (byte < 128 && (string$.x00_____.charCodeAt(byte) & canonicalMask) !== 0) {
                        t2 = A.Primitives_stringFromCharCode(byte);
                        buffer._contents += t2;
                    } else {
                        t2 = A.Primitives_stringFromCharCode(37);
                        buffer._contents += t2;
                        t2 = A.Primitives_stringFromCharCode(_s16_.charCodeAt(byte >>> 4));
                        buffer._contents += t2;
                        t2 = A.Primitives_stringFromCharCode(_s16_.charCodeAt(byte & 15));
                        buffer._contents += t2;
                    }
                }
                if ((byteOr & 4294967040) !== 0) for(i = 0; i < t1; ++i){
                    byte = bytes[i];
                    if (byte > 255) throw A.wrapException(A.ArgumentError$value(byte, "non-byte value", null));
                }
            },
            _scan: function(uri, start, end, state, indices) {
                var i, char, transition;
                for(i = start; i < end; ++i){
                    char = uri.charCodeAt(i) ^ 96;
                    if (char > 95) char = 31;
                    transition = '\xe1\x01\x01\x01\x01\x01\x01\x01\x01\x01\x01\x01\x01\x01\x01\x01\x01\x01\x01\x01\x01\x01\x01\x01\x01\x01\x01\xe1\xe1\xe1\x01\xe1\xe1\x01\x01\x01\x01\x01\x01\x01\x01\x01\x01\x01\x01\x01\x01\x01\x01\x01\x01\x01\x01\x01\x01\x01\x01\x01\x01\xe1\xe3\xe1\xe1\x01\xe1\x01\xe1\xcd\x01\xe1\x01\x01\x01\x01\x01\x01\x01\x01\x0e\x03\x01\x01\x01\x01\x01\x01\x01\x01\x01\x01"\x01\xe1\x01\xe1\xac\xe1\x01\x01\x01\x01\x01\x01\x01\x01\x01\x01\x01\x01\x01\x01\x01\x01\x01\x01\x01\x01\x01\x01\x01\x01\x01\x01\xe1\xe1\xe1\x01\xe1\xe1\x01\x01\x01\x01\x01\x01\x01\x01\x01\x01\x01\x01\x01\x01\x01\x01\x01\x01\x01\x01\x01\x01\x01\x01\x01\x01\xe1\xea\xe1\xe1\x01\xe1\x01\xe1\xcd\x01\xe1\x01\x01\x01\x01\x01\x01\x01\x01\x01\n\x01\x01\x01\x01\x01\x01\x01\x01\x01\x01"\x01\xe1\x01\xe1\xac\xeb\x8b\x8b\x8b\x8b\x8b\x8b\x8b\x8b\x8b\x8b\x8b\x8b\x8b\x8b\x8b\x8b\x8b\x8b\x8b\x8b\x8b\x8b\x8b\x8b\x8b\x8b\xeb\xeb\xeb\x8b\xeb\xeb\x8b\x8b\x8b\x8b\x8b\x8b\x8b\x8b\x8b\x8b\x8b\x8b\x8b\x8b\x8b\x8b\x8b\x8b\x8b\x8b\x8b\x8b\x8b\x8b\x8b\x8b\xeb\x83\xeb\xeb\x8b\xeb\x8b\xeb\xcd\x8b\xeb\x8b\x8b\x8b\x8b\x8b\x8b\x8b\x8b\x92\x83\x8b\x8b\x8b\x8b\x8b\x8b\x8b\x8b\x8b\x8b\xeb\x8b\xeb\x8b\xeb\xac\xeb\v\v\v\v\v\v\v\v\v\v\v\v\v\v\v\v\v\v\v\v\v\v\v\v\v\v\xeb\xeb\xeb\v\xeb\xeb\v\v\v\v\v\v\v\v\v\v\v\v\v\v\v\v\v\v\v\v\v\v\v\v\v\v\xebD\xeb\xeb\v\xeb\v\xeb\xcd\v\xeb\v\v\v\v\v\v\v\v\x12D\v\v\v\v\v\v\v\v\v\v\xeb\v\xeb\v\xeb\xac\xe5\x05\x05\x05\x05\x05\x05\x05\x05\x05\x05\x05\x05\x05\x05\x05\x05\x05\x05\x05\x05\x05\x05\x05\x05\x05\x05\xe5\xe5\xe5\x05\xe5D\xe5\xe5\xe5\xe5\xe5\xe5\xe5\xe5\xe5\xe5\xe5\xe5\xe5\xe5\xe5\xe5\xe5\xe5\xe5\xe5\xe5\xe5\xe5\xe5\xe5\xe5\xe8\x8a\xe5\xe5\x05\xe5\x05\xe5\xcd\x05\xe5\x05\x05\x05\x05\x05\x05\x05\x05\x05\x8a\x05\x05\x05\x05\x05\x05\x05\x05\x05\x05f\x05\xe5\x05\xe5\xac\xe5\x05\x05\x05\x05\x05\x05\x05\x05\x05\x05\x05\x05\x05\x05\x05\x05\x05\x05\x05\x05\x05\x05\x05\x05\x05\x05\xe5\xe5\xe5\x05\xe5D\xe5\xe5\xe5\xe5\xe5\xe5\xe5\xe5\xe5\xe5\xe5\xe5\xe5\xe5\xe5\xe5\xe5\xe5\xe5\xe5\xe5\xe5\xe5\xe5\xe5\xe5\xe5\x8a\xe5\xe5\x05\xe5\x05\xe5\xcd\x05\xe5\x05\x05\x05\x05\x05\x05\x05\x05\x05\x8a\x05\x05\x05\x05\x05\x05\x05\x05\x05\x05f\x05\xe5\x05\xe5\xac\xe7\xe7\xe7\xe7\xe7\xe7\xe7\xe7\xe7\xe7\xe7\xe7\xe7\xe7\xe7\xe7\xe7\xe7\xe7\xe7\xe7\xe7\xe7\xe7\xe7\xe7\xe7\xe7\xe7\xe7\xe7\xe7D\xe7\xe7\xe7\xe7\xe7\xe7\xe7\xe7\xe7\xe7\xe7\xe7\xe7\xe7\xe7\xe7\xe7\xe7\xe7\xe7\xe7\xe7\xe7\xe7\xe7\xe7\xe7\x8a\xe7\xe7\xe7\xe7\xe7\xe7\xcd\xe7\xe7\xe7\xe7\xe7\xe7\xe7\xe7\xe7\xe7\xe7\x8a\xe7\x07\x07\x07\x07\x07\x07\x07\x07\x07\xe7\xe7\xe7\xe7\xe7\xac\xe7\xe7\xe7\xe7\xe7\xe7\xe7\xe7\xe7\xe7\xe7\xe7\xe7\xe7\xe7\xe7\xe7\xe7\xe7\xe7\xe7\xe7\xe7\xe7\xe7\xe7\xe7\xe7\xe7\xe7\xe7\xe7D\xe7\xe7\xe7\xe7\xe7\xe7\xe7\xe7\xe7\xe7\xe7\xe7\xe7\xe7\xe7\xe7\xe7\xe7\xe7\xe7\xe7\xe7\xe7\xe7\xe7\xe7\xe7\x8a\xe7\xe7\xe7\xe7\xe7\xe7\xcd\xe7\xe7\xe7\xe7\xe7\xe7\xe7\xe7\xe7\xe7\xe7\x8a\x07\x07\x07\x07\x07\x07\x07\x07\x07\x07\xe7\xe7\xe7\xe7\xe7\xac\b\b\b\b\b\b\b\b\b\b\b\b\b\b\b\b\b\b\b\b\b\b\b\b\b\b\b\b\b\b\b\b\b\b\b\b\b\b\b\b\b\b\b\b\b\b\b\b\b\b\b\b\b\b\b\b\b\b\b\b\b\x05\b\b\b\b\b\b\b\b\b\b\b\b\b\b\b\b\b\b\b\b\b\b\b\b\b\b\b\b\b\b\b\b\b\b\xeb\v\v\v\v\v\v\v\v\v\v\v\v\v\v\v\v\v\v\v\v\v\v\v\v\v\v\xeb\xeb\xeb\v\xeb\xeb\v\v\v\v\v\v\v\v\v\v\v\v\v\v\v\v\v\v\v\v\v\v\v\v\v\v\xeb\xea\xeb\xeb\v\xeb\v\xeb\xcd\v\xeb\v\v\v\v\v\v\v\v\x10\xea\v\v\v\v\v\v\v\v\v\v\xeb\v\xeb\v\xeb\xac\xeb\v\v\v\v\v\v\v\v\v\v\v\v\v\v\v\v\v\v\v\v\v\v\v\v\v\v\xeb\xeb\xeb\v\xeb\xeb\v\v\v\v\v\v\v\v\v\v\v\v\v\v\v\v\v\v\v\v\v\v\v\v\v\v\xeb\xea\xeb\xeb\v\xeb\v\xeb\xcd\v\xeb\v\v\v\v\v\v\v\v\x12\n\v\v\v\v\v\v\v\v\v\v\xeb\v\xeb\v\xeb\xac\xeb\v\v\v\v\v\v\v\v\v\v\v\v\v\v\v\v\v\v\v\v\v\v\v\v\v\v\xeb\xeb\xeb\v\xeb\xeb\v\v\v\v\v\v\v\v\v\v\v\v\v\v\v\v\v\v\v\v\v\v\v\v\v\v\xeb\xea\xeb\xeb\v\xeb\v\xeb\xcd\v\xeb\v\v\v\v\v\v\v\v\v\n\v\v\v\v\v\v\v\v\v\v\xeb\v\xeb\v\xeb\xac\xec\f\f\f\f\f\f\f\f\f\f\f\f\f\f\f\f\f\f\f\f\f\f\f\f\f\f\xec\xec\xec\f\xec\xec\f\f\f\f\f\f\f\f\f\f\f\f\f\f\f\f\f\f\f\f\f\f\f\f\f\f\xec\xec\xec\xec\f\xec\f\xec\xcd\f\xec\f\f\f\f\f\f\f\f\f\xec\f\f\f\f\f\f\f\f\f\f\xec\f\xec\f\xec\f\xed\r\r\r\r\r\r\r\r\r\r\r\r\r\r\r\r\r\r\r\r\r\r\r\r\r\r\xed\xed\xed\r\xed\xed\r\r\r\r\r\r\r\r\r\r\r\r\r\r\r\r\r\r\r\r\r\r\r\r\r\r\xed\xed\xed\xed\r\xed\r\xed\xed\r\xed\r\r\r\r\r\r\r\r\r\xed\r\r\r\r\r\r\r\r\r\r\xed\r\xed\r\xed\r\xe1\x01\x01\x01\x01\x01\x01\x01\x01\x01\x01\x01\x01\x01\x01\x01\x01\x01\x01\x01\x01\x01\x01\x01\x01\x01\x01\xe1\xe1\xe1\x01\xe1\xe1\x01\x01\x01\x01\x01\x01\x01\x01\x01\x01\x01\x01\x01\x01\x01\x01\x01\x01\x01\x01\x01\x01\x01\x01\x01\x01\xe1\xea\xe1\xe1\x01\xe1\x01\xe1\xcd\x01\xe1\x01\x01\x01\x01\x01\x01\x01\x01\x0f\xea\x01\x01\x01\x01\x01\x01\x01\x01\x01\x01"\x01\xe1\x01\xe1\xac\xe1\x01\x01\x01\x01\x01\x01\x01\x01\x01\x01\x01\x01\x01\x01\x01\x01\x01\x01\x01\x01\x01\x01\x01\x01\x01\x01\xe1\xe1\xe1\x01\xe1\xe1\x01\x01\x01\x01\x01\x01\x01\x01\x01\x01\x01\x01\x01\x01\x01\x01\x01\x01\x01\x01\x01\x01\x01\x01\x01\x01\xe1\xe9\xe1\xe1\x01\xe1\x01\xe1\xcd\x01\xe1\x01\x01\x01\x01\x01\x01\x01\x01\x01\t\x01\x01\x01\x01\x01\x01\x01\x01\x01\x01"\x01\xe1\x01\xe1\xac\xeb\v\v\v\v\v\v\v\v\v\v\v\v\v\v\v\v\v\v\v\v\v\v\v\v\v\v\xeb\xeb\xeb\v\xeb\xeb\v\v\v\v\v\v\v\v\v\v\v\v\v\v\v\v\v\v\v\v\v\v\v\v\v\v\xeb\xea\xeb\xeb\v\xeb\v\xeb\xcd\v\xeb\v\v\v\v\v\v\v\v\x11\xea\v\v\v\v\v\v\v\v\v\v\xeb\v\xeb\v\xeb\xac\xeb\v\v\v\v\v\v\v\v\v\v\v\v\v\v\v\v\v\v\v\v\v\v\v\v\v\v\xeb\xeb\xeb\v\xeb\xeb\v\v\v\v\v\v\v\v\v\v\v\v\v\v\v\v\v\v\v\v\v\v\v\v\v\v\xeb\xe9\xeb\xeb\v\xeb\v\xeb\xcd\v\xeb\v\v\v\v\v\v\v\v\v\t\v\v\v\v\v\v\v\v\v\v\xeb\v\xeb\v\xeb\xac\xeb\v\v\v\v\v\v\v\v\v\v\v\v\v\v\v\v\v\v\v\v\v\v\v\v\v\v\xeb\xeb\xeb\v\xeb\xeb\v\v\v\v\v\v\v\v\v\v\v\v\v\v\v\v\v\v\v\v\v\v\v\v\v\v\xeb\xea\xeb\xeb\v\xeb\v\xeb\xcd\v\xeb\v\v\v\v\v\v\v\v\x13\xea\v\v\v\v\v\v\v\v\v\v\xeb\v\xeb\v\xeb\xac\xeb\v\v\v\v\v\v\v\v\v\v\v\v\v\v\v\v\v\v\v\v\v\v\v\v\v\v\xeb\xeb\xeb\v\xeb\xeb\v\v\v\v\v\v\v\v\v\v\v\v\v\v\v\v\v\v\v\v\v\v\v\v\v\v\xeb\xea\xeb\xeb\v\xeb\v\xeb\xcd\v\xeb\v\v\v\v\v\v\v\v\v\xea\v\v\v\v\v\v\v\v\v\v\xeb\v\xeb\v\xeb\xac\xf5\x15\x15\x15\x15\x15\x15\x15\x15\x15\x15\x15\x15\x15\x15\x15\x15\x15\x15\x15\x15\x15\x15\x15\x15\x15\x15\xf5\xf5\xf5\xf5\xf5\xf5\xf5\xf5\xf5\xf5\xf5\xf5\xf5\xf5\xf5\xf5\xf5\xf5\xf5\xf5\xf5\xf5\xf5\xf5\xf5\xf5\xf5\xf5\xf5\xf5\xf5\xf5\xf5\xf5\xf5\xf5\xf5\xf5\xf5\xf5\xf5\xf5\xf5\xf5\xf5\xf5\xf5\xf5\xf5\xf5\xf5\xf5\xf5\xf5\xf5\xf5\xf5\xf5\xf5\xf5\xf5\xf5\xf5\xf5\xf5\xf5\xf5\xf5\xf5\xf5\x15\x15\x15\x15\x15\x15\x15\x15\x15\x15\x15\x15\x15\x15\x15\x15\x15\x15\x15\x15\x15\x15\x15\x15\x15\x15\xf5\xf5\xf5\xf5\xf5\xf5\xf5\xf5\xf5\xf5\xf5\xf5\xf5\xf5\xf5\xf5\xf5\xf5\xf5\xf5\xf5\xf5\xf5\xf5\xf5\xf5\xf5\xf5\xf5\xf5\xf5\xf5\xf5\xf5\xf5\xf5\xf5\xf5\xf5\xf5\xf5\xf5\xf5\xf5\xf5\xf5\xf5\xf5\x15\xf5\x15\x15\xf5\x15\x15\x15\x15\x15\x15\x15\x15\x15\x15\xf5\xf5\xf5\xf5\xf5\xf5'.charCodeAt(state * 96 + char);
                    state = transition & 31;
                    indices[transition >>> 5] = i;
                }
                return state;
            },
            _SimpleUri__packageNameEnd: function(uri) {
                if (uri._schemeEnd === 7 && B.JSString_methods.startsWith$1(uri._uri, "package") && uri._hostStart <= 0) return A._skipPackageNameChars(uri._uri, uri._pathStart, uri._queryStart);
                return -1;
            },
            _skipPackageNameChars: function(source, start, end) {
                var i, dots, char;
                for(i = start, dots = 0; i < end; ++i){
                    char = source.charCodeAt(i);
                    if (char === 47) return dots !== 0 ? i : -1;
                    if (char === 37 || char === 58) return -1;
                    dots |= char ^ 46;
                }
                return -1;
            },
            _caseInsensitiveCompareStart: function(prefix, string, start) {
                var t1, result, i, stringChar, delta, lowerChar;
                for(t1 = prefix.length, result = 0, i = 0; i < t1; ++i){
                    stringChar = string.charCodeAt(start + i);
                    delta = prefix.charCodeAt(i) ^ stringChar;
                    if (delta !== 0) {
                        if (delta === 32) {
                            lowerChar = stringChar | delta;
                            if (97 <= lowerChar && lowerChar <= 122) {
                                result = 32;
                                continue;
                            }
                        }
                        return -1;
                    }
                }
                return result;
            },
            NoSuchMethodError_toString_closure: function NoSuchMethodError_toString_closure(t0, t1) {
                this._box_0 = t0;
                this.sb = t1;
            },
            DateTime: function DateTime(t0, t1, t2) {
                this._value = t0;
                this._microsecond = t1;
                this.isUtc = t2;
            },
            Duration: function Duration(t0) {
                this._duration = t0;
            },
            _Enum: function _Enum() {},
            Error: function Error1() {},
            AssertionError: function AssertionError(t0) {
                this.message = t0;
            },
            TypeError: function TypeError1() {},
            ArgumentError: function ArgumentError(t0, t1, t2, t3) {
                var _ = this;
                _._hasValue = t0;
                _.invalidValue = t1;
                _.name = t2;
                _.message = t3;
            },
            RangeError: function RangeError1(t0, t1, t2, t3, t4, t5) {
                var _ = this;
                _.start = t0;
                _.end = t1;
                _._hasValue = t2;
                _.invalidValue = t3;
                _.name = t4;
                _.message = t5;
            },
            IndexError: function IndexError(t0, t1, t2, t3, t4) {
                var _ = this;
                _.length = t0;
                _._hasValue = t1;
                _.invalidValue = t2;
                _.name = t3;
                _.message = t4;
            },
            NoSuchMethodError: function NoSuchMethodError(t0, t1, t2, t3) {
                var _ = this;
                _._core$_receiver = t0;
                _._memberName = t1;
                _._core$_arguments = t2;
                _._namedArguments = t3;
            },
            UnsupportedError: function UnsupportedError(t0) {
                this.message = t0;
            },
            UnimplementedError: function UnimplementedError(t0) {
                this.message = t0;
            },
            StateError: function StateError(t0) {
                this.message = t0;
            },
            ConcurrentModificationError: function ConcurrentModificationError(t0) {
                this.modifiedObject = t0;
            },
            OutOfMemoryError: function OutOfMemoryError() {},
            StackOverflowError: function StackOverflowError() {},
            _Exception: function _Exception(t0) {
                this.message = t0;
            },
            FormatException: function FormatException(t0, t1, t2) {
                this.message = t0;
                this.source = t1;
                this.offset = t2;
            },
            Iterable: function Iterable() {},
            _GeneratorIterable: function _GeneratorIterable(t0, t1, t2) {
                this.length = t0;
                this._generator = t1;
                this.$ti = t2;
            },
            MapEntry: function MapEntry(t0, t1, t2) {
                this.key = t0;
                this.value = t1;
                this.$ti = t2;
            },
            Null: function Null() {},
            Object: function Object1() {},
            _StringStackTrace: function _StringStackTrace(t0) {
                this._stackTrace = t0;
            },
            Runes: function Runes(t0) {
                this.string = t0;
            },
            RuneIterator: function RuneIterator(t0) {
                var _ = this;
                _.string = t0;
                _._nextPosition = _._position = 0;
                _._currentCodePoint = -1;
            },
            StringBuffer: function StringBuffer(t0) {
                this._contents = t0;
            },
            Uri_parseIPv6Address_error: function Uri_parseIPv6Address_error(t0) {
                this.host = t0;
            },
            _Uri: function _Uri(t0, t1, t2, t3, t4, t5, t6) {
                var _ = this;
                _.scheme = t0;
                _._userInfo = t1;
                _._host = t2;
                _._port = t3;
                _.path = t4;
                _._query = t5;
                _._fragment = t6;
                _.___Uri_hashCode_FI = _.___Uri_pathSegments_FI = _.___Uri__text_FI = $;
            },
            _Uri__makePath_closure: function _Uri__makePath_closure() {},
            UriData: function UriData(t0, t1, t2) {
                this._text = t0;
                this._separatorIndices = t1;
                this._uriCache = t2;
            },
            _SimpleUri: function _SimpleUri(t0, t1, t2, t3, t4, t5, t6, t7) {
                var _ = this;
                _._uri = t0;
                _._schemeEnd = t1;
                _._hostStart = t2;
                _._portStart = t3;
                _._pathStart = t4;
                _._queryStart = t5;
                _._fragmentStart = t6;
                _._schemeCache = t7;
                _._hashCodeCache = null;
            },
            _DataUri: function _DataUri(t0, t1, t2, t3, t4, t5, t6) {
                var _ = this;
                _.scheme = t0;
                _._userInfo = t1;
                _._host = t2;
                _._port = t3;
                _.path = t4;
                _._query = t5;
                _._fragment = t6;
                _.___Uri_hashCode_FI = _.___Uri_pathSegments_FI = _.___Uri__text_FI = $;
            },
            Expando: function Expando(t0) {
                this._jsWeakMap = t0;
            },
            NullRejectionException: function NullRejectionException(t0) {
                this.isUndefined = t0;
            },
            _convertDartFunctionFast: function(f) {
                var ret, existing = f.$dart_jsFunction;
                if (existing != null) return existing;
                ret = function(_call, f) {
                    return function() {
                        return _call(f, Array.prototype.slice.apply(arguments));
                    };
                }(A._callDartFunctionFast, f);
                ret[$.$get$DART_CLOSURE_PROPERTY_NAME()] = f;
                f.$dart_jsFunction = ret;
                return ret;
            },
            _convertDartFunctionFastCaptureThis: function(f) {
                var ret, existing = f._$dart_jsFunctionCaptureThis;
                if (existing != null) return existing;
                ret = function(_call, f) {
                    return function() {
                        return _call(f, this, Array.prototype.slice.apply(arguments));
                    };
                }(A._callDartFunctionFastCaptureThis, f);
                ret[$.$get$DART_CLOSURE_PROPERTY_NAME()] = f;
                f._$dart_jsFunctionCaptureThis = ret;
                return ret;
            },
            _callDartFunctionFast: function(callback, $arguments) {
                return A.Function_apply(callback, $arguments);
            },
            _callDartFunctionFastCaptureThis: function(callback, $self, $arguments) {
                var t1 = [
                    $self
                ];
                B.JSArray_methods.addAll$1(t1, $arguments);
                return A.Function_apply(callback, t1);
            },
            allowInterop: function(f) {
                if (typeof f == "function") return f;
                else return A._convertDartFunctionFast(f);
            },
            allowInteropCaptureThis: function(f) {
                if (typeof f == "function") throw A.wrapException(A.ArgumentError$("Function is already a JS function so cannot capture this.", null));
                else return A._convertDartFunctionFastCaptureThis(f);
            },
            _callDartFunctionFast2: function(callback, arg1, arg2, $length) {
                if ($length >= 2) return callback.call$2(arg1, arg2);
                if ($length === 1) return callback.call$1(arg1);
                return callback.call$0();
            },
            _noJsifyRequired: function(o) {
                return o == null || A._isBool(o) || typeof o == "number" || typeof o == "string" || type$.Int8List._is(o) || type$.Uint8List._is(o) || type$.Uint8ClampedList._is(o) || type$.Int16List._is(o) || type$.Uint16List._is(o) || type$.Int32List._is(o) || type$.Uint32List._is(o) || type$.Float32List._is(o) || type$.Float64List._is(o) || type$.ByteBuffer._is(o) || type$.ByteData._is(o);
            },
            jsify: function(object) {
                if (A._noJsifyRequired(object)) return object;
                return new A.jsify__convert(new A._IdentityHashMap(type$._IdentityHashMap_of_nullable_Object_and_nullable_Object)).call$1(object);
            },
            _callMethodUnchecked0: function(o, method) {
                return o[method]();
            },
            callConstructor: function(constr, $arguments) {
                var args, factoryFunction;
                if ($arguments instanceof Array) switch($arguments.length){
                    case 0:
                        return new constr();
                    case 1:
                        return new constr($arguments[0]);
                    case 2:
                        return new constr($arguments[0], $arguments[1]);
                    case 3:
                        return new constr($arguments[0], $arguments[1], $arguments[2]);
                    case 4:
                        return new constr($arguments[0], $arguments[1], $arguments[2], $arguments[3]);
                }
                args = [
                    null
                ];
                B.JSArray_methods.addAll$1(args, $arguments);
                factoryFunction = constr.bind.apply(constr, args);
                String(factoryFunction);
                return new factoryFunction();
            },
            promiseToFuture: function(jsPromise, $T) {
                var t1 = new A._Future($.Zone__current, $T._eval$1("_Future<0>")), completer = new A._AsyncCompleter(t1, $T._eval$1("_AsyncCompleter<0>"));
                jsPromise.then(A.convertDartClosureToJS(new A.promiseToFuture_closure(completer), 1), A.convertDartClosureToJS(new A.promiseToFuture_closure0(completer), 1));
                return t1;
            },
            jsify__convert: function jsify__convert(t0) {
                this._convertedObjects = t0;
            },
            promiseToFuture_closure: function promiseToFuture_closure(t0) {
                this.completer = t0;
            },
            promiseToFuture_closure0: function promiseToFuture_closure0(t0) {
                this.completer = t0;
            },
            max: function(a, b) {
                return Math.max(a, b);
            },
            pow: function(x, exponent) {
                return Math.pow(x, exponent);
            },
            Random_Random: function() {
                return B.C__JSRandom;
            },
            _JSRandom: function _JSRandom() {},
            ArgParser: function ArgParser(t0, t1, t2, t3, t4, t5, t6) {
                var _ = this;
                _._arg_parser$_options = t0;
                _._aliases = t1;
                _.options = t2;
                _.commands = t3;
                _._optionsAndSeparators = t4;
                _.allowTrailingOptions = t5;
                _.usageLineLength = t6;
            },
            ArgParser__addOption_closure: function ArgParser__addOption_closure(t0) {
                this.$this = t0;
            },
            ArgParserException$: function(message, commands, argumentName, source, offset) {
                return new A.ArgParserException(commands == null ? B.List_empty : A.List_List$unmodifiable(commands, type$.String), argumentName, message, source, offset);
            },
            ArgParserException: function ArgParserException(t0, t1, t2, t3, t4) {
                var _ = this;
                _.commands = t0;
                _.argumentName = t1;
                _.message = t2;
                _.source = t3;
                _.offset = t4;
            },
            ArgResults: function ArgResults(t0, t1, t2, t3) {
                var _ = this;
                _._parser = t0;
                _._parsed = t1;
                _.name = t2;
                _.rest = t3;
            },
            Option: function Option(t0, t1, t2, t3, t4, t5, t6, t7, t8, t9, t10, t11, t12, t13) {
                var _ = this;
                _.name = t0;
                _.abbr = t1;
                _.help = t2;
                _.valueHelp = t3;
                _.allowed = t4;
                _.allowedHelp = t5;
                _.defaultsTo = t6;
                _.negatable = t7;
                _.hideNegatedUsage = t8;
                _.callback = t9;
                _.type = t10;
                _.splitCommas = t11;
                _.mandatory = t12;
                _.hide = t13;
            },
            OptionType: function OptionType(t0) {
                this.name = t0;
            },
            Parser$: function(_commandName, _grammar, _args, _parent, rest) {
                var t1 = A._setArrayType([], type$.JSArray_String);
                if (rest != null) B.JSArray_methods.addAll$1(t1, rest);
                return new A.Parser0(_commandName, _parent, _grammar, _args, t1, A.LinkedHashMap_LinkedHashMap$_empty(type$.String, type$.dynamic));
            },
            _isLetterOrDigit: function(codeUnit) {
                var t1 = true;
                if (!(codeUnit >= 65 && codeUnit <= 90)) {
                    if (!(codeUnit >= 97 && codeUnit <= 122)) t1 = codeUnit >= 48 && codeUnit <= 57;
                }
                return t1;
            },
            Parser0: function Parser0(t0, t1, t2, t3, t4, t5) {
                var _ = this;
                _._commandName = t0;
                _._parser$_parent = t1;
                _._grammar = t2;
                _._args = t3;
                _._parser$_rest = t4;
                _._results = t5;
            },
            Parser_parse_closure: function Parser_parse_closure(t0) {
                this.$this = t0;
            },
            Parser__setOption_closure: function Parser__setOption_closure() {},
            _Usage: function _Usage(t0, t1, t2) {
                var _ = this;
                _._usage$_optionsAndSeparators = t0;
                _._usage$_buffer = t1;
                _._currentColumn = 0;
                _.___Usage__columnWidths_FI = $;
                _._newlinesNeeded = 0;
                _.lineLength = t2;
            },
            _Usage__writeOption_closure: function _Usage__writeOption_closure() {},
            _Usage__buildAllowedList_closure: function _Usage__buildAllowedList_closure(t0) {
                this.option = t0;
            },
            FutureGroup: function FutureGroup(t0, t1, t2) {
                var _ = this;
                _._future_group$_pending = 0;
                _._future_group$_closed = false;
                _._future_group$_completer = t0;
                _._future_group$_values = t1;
                _.$ti = t2;
            },
            FutureGroup_add_closure: function FutureGroup_add_closure(t0, t1) {
                this.$this = t0;
                this.index = t1;
            },
            FutureGroup_add_closure0: function FutureGroup_add_closure0(t0) {
                this.$this = t0;
            },
            ErrorResult: function ErrorResult(t0, t1) {
                this.error = t0;
                this.stackTrace = t1;
            },
            ValueResult: function ValueResult(t0, t1) {
                this.value = t0;
                this.$ti = t1;
            },
            StreamCompleter: function StreamCompleter(t0, t1) {
                this._stream_completer$_stream = t0;
                this.$ti = t1;
            },
            _CompleterStream: function _CompleterStream(t0) {
                this._sourceStream = this._stream_completer$_controller = null;
                this.$ti = t0;
            },
            StreamGroup: function StreamGroup(t0, t1, t2) {
                var _ = this;
                _.__StreamGroup__controller_A = $;
                _._closed = false;
                _._stream_group$_state = t0;
                _._subscriptions = t1;
                _.$ti = t2;
            },
            StreamGroup_add_closure: function StreamGroup_add_closure() {},
            StreamGroup_add_closure0: function StreamGroup_add_closure0(t0, t1) {
                this.$this = t0;
                this.stream = t1;
            },
            StreamGroup__onListen_closure: function StreamGroup__onListen_closure() {},
            StreamGroup__onCancel_closure: function StreamGroup__onCancel_closure(t0) {
                this.$this = t0;
            },
            StreamGroup__listenToStream_closure: function StreamGroup__listenToStream_closure(t0, t1) {
                this.$this = t0;
                this.stream = t1;
            },
            _StreamGroupState: function _StreamGroupState(t0) {
                this.name = t0;
            },
            StreamQueue: function StreamQueue(t0, t1, t2, t3) {
                var _ = this;
                _._stream_queue$_source = t0;
                _._stream_queue$_subscription = null;
                _._isDone = false;
                _._eventsReceived = 0;
                _._eventQueue = t1;
                _._requestQueue = t2;
                _.$ti = t3;
            },
            StreamQueue__ensureListening_closure: function StreamQueue__ensureListening_closure(t0) {
                this.$this = t0;
            },
            StreamQueue__ensureListening_closure1: function StreamQueue__ensureListening_closure1(t0) {
                this.$this = t0;
            },
            StreamQueue__ensureListening_closure0: function StreamQueue__ensureListening_closure0(t0) {
                this.$this = t0;
            },
            _NextRequest: function _NextRequest(t0, t1) {
                this._completer = t0;
                this.$ti = t1;
            },
            isNodeJs: function() {
                var t1 = self.process;
                if (t1 == null) t1 = null;
                else {
                    t1 = J.get$release$x(t1);
                    t1 = t1 == null ? null : J.get$name$x(t1);
                }
                return J.$eq$(t1, "node");
            },
            isBrowser: function() {
                return !A.isNodeJs() && self.document != null && typeof self.document.querySelector == "function";
            },
            wrapJSExceptions: function(callback) {
                var error, error0, error1, error2, t1, _$exception;
                if (!$.$get$_isStrictMode()) return callback.call$0();
                try {
                    t1 = callback.call$0();
                    return t1;
                } catch (exception) {
                    t1 = A.unwrapException(exception);
                    if (typeof t1 == "string") {
                        error = t1;
                        throw A.wrapException(error);
                    } else if (A._isBool(t1)) {
                        error0 = t1;
                        throw A.wrapException(error0);
                    } else if (typeof t1 == "number") {
                        error1 = t1;
                        throw A.wrapException(error1);
                    } else {
                        error2 = t1;
                        if ((typeof error2 === "undefined" ? "undefined" : (0, $6tOPT._)(error2)) == "symbol" || (typeof error2 === "undefined" ? "undefined" : (0, $6tOPT._)(error2)) == "bigint" || error2 == null) throw A.wrapException(A._callMethodUnchecked0(error2, "toString"));
                        throw exception;
                    }
                }
            },
            _isStrictMode_closure: function _isStrictMode_closure() {},
            Repl: function Repl(t0, t1, t2, t3) {
                var _ = this;
                _.prompt = t0;
                _.continuation = t1;
                _.validator = t2;
                _.__Repl__adapter_A = $;
                _.history = t3;
            },
            alwaysValid_closure: function alwaysValid_closure() {},
            ReplAdapter: function ReplAdapter(t0) {
                this.repl = t0;
                this.rl = null;
            },
            ReplAdapter_runAsync_closure: function ReplAdapter_runAsync_closure(t0, t1, t2, t3) {
                var _ = this;
                _._box_0 = t0;
                _.$this = t1;
                _.rl = t2;
                _.runController = t3;
            },
            ReplAdapter_runAsync__closure: function ReplAdapter_runAsync__closure(t0) {
                this.lineController = t0;
            },
            Stdin: function Stdin() {},
            Stdout: function Stdout() {},
            ReadlineModule: function ReadlineModule() {},
            ReadlineOptions: function ReadlineOptions() {},
            ReadlineInterface: function ReadlineInterface() {},
            EmptyUnmodifiableSet: function EmptyUnmodifiableSet(t0) {
                this.$ti = t0;
            },
            _EmptyUnmodifiableSet_IterableBase_UnmodifiableSetMixin: function _EmptyUnmodifiableSet_IterableBase_UnmodifiableSetMixin() {},
            DefaultEquality: function DefaultEquality() {},
            IterableEquality: function IterableEquality() {},
            ListEquality: function ListEquality() {},
            _MapEntry: function _MapEntry(t0, t1, t2) {
                this.equality = t0;
                this.key = t1;
                this.value = t2;
            },
            MapEquality: function MapEquality(t0) {
                this.$ti = t0;
            },
            QueueList$: function(initialCapacity, $E) {
                return new A.QueueList(A.List_List$filled(A.QueueList__computeInitialCapacity(initialCapacity), null, false, $E._eval$1("0?")), 0, 0, $E._eval$1("QueueList<0>"));
            },
            QueueList_QueueList$from: function(source, $E) {
                var $length, queue, t1;
                if (type$.List_dynamic._is(source)) {
                    $length = J.get$length$asx(source);
                    queue = A.QueueList$($length + 1, $E);
                    J.setRange$4$ax(queue._queue_list$_table, 0, $length, source, 0);
                    queue._queue_list$_tail = $length;
                    return queue;
                } else {
                    t1 = A.QueueList$(null, $E);
                    t1.addAll$1(0, source);
                    return t1;
                }
            },
            QueueList__computeInitialCapacity: function(initialCapacity) {
                if (initialCapacity == null || initialCapacity < 8) return 8;
                ++initialCapacity;
                if ((initialCapacity & initialCapacity - 1) >>> 0 === 0) return initialCapacity;
                return A.QueueList__nextPowerOf2(initialCapacity);
            },
            QueueList__nextPowerOf2: function(number) {
                var nextNumber;
                number = (number << 1 >>> 0) - 1;
                for(;; number = nextNumber){
                    nextNumber = (number & number - 1) >>> 0;
                    if (nextNumber === 0) return number;
                }
            },
            QueueList: function QueueList(t0, t1, t2, t3) {
                var _ = this;
                _._queue_list$_table = t0;
                _._queue_list$_head = t1;
                _._queue_list$_tail = t2;
                _.$ti = t3;
            },
            _CastQueueList: function _CastQueueList(t0, t1, t2, t3, t4) {
                var _ = this;
                _._queue_list$_delegate = t0;
                _._queue_list$_table = t1;
                _._queue_list$_head = t2;
                _._queue_list$_tail = t3;
                _.$ti = t4;
            },
            _QueueList_Object_ListMixin: function _QueueList_Object_ListMixin() {},
            UnionSet: function UnionSet(t0, t1) {
                this._sets = t0;
                this.$ti = t1;
            },
            UnionSet__iterable_closure: function UnionSet__iterable_closure(t0) {
                this.$this = t0;
            },
            UnionSet_contains_closure: function UnionSet_contains_closure(t0, t1) {
                this.$this = t0;
                this.element = t1;
            },
            _UnionSet_SetBase_UnmodifiableSetMixin: function _UnionSet_SetBase_UnmodifiableSetMixin() {},
            UnmodifiableSetMixin__throw: function() {
                throw A.wrapException(A.UnsupportedError$("Cannot modify an unmodifiable Set"));
            },
            UnmodifiableSetView0: function UnmodifiableSetView0(t0, t1) {
                this._base = t0;
                this.$ti = t1;
            },
            UnmodifiableSetMixin: function UnmodifiableSetMixin() {},
            _UnmodifiableSetView_DelegatingSet_UnmodifiableSetMixin: function _UnmodifiableSetView_DelegatingSet_UnmodifiableSetMixin() {},
            _DelegatingIterableBase: function _DelegatingIterableBase() {},
            DelegatingSet: function DelegatingSet(t0, t1) {
                this._base = t0;
                this.$ti = t1;
            },
            MapKeySet: function MapKeySet(t0, t1) {
                this._baseMap = t0;
                this.$ti = t1;
            },
            MapKeySet_difference_closure: function MapKeySet_difference_closure(t0, t1) {
                this.$this = t0;
                this.other = t1;
            },
            _MapKeySet__DelegatingIterableBase_UnmodifiableSetMixin: function _MapKeySet__DelegatingIterableBase_UnmodifiableSetMixin() {},
            BufferModule: function BufferModule() {},
            BufferConstants: function BufferConstants() {},
            Buffer: function Buffer() {},
            ConsoleModule: function ConsoleModule() {},
            Console: function Console() {},
            EventEmitter: function EventEmitter() {},
            fs: function() {
                var t1 = $._fs;
                return t1 == null ? $._fs = self.fs : t1;
            },
            FS: function FS() {},
            FSConstants: function FSConstants() {},
            Realpath: function Realpath() {},
            RealpathSync: function RealpathSync() {},
            FSWatcher: function FSWatcher() {},
            ReadStream: function ReadStream() {},
            ReadStreamOptions: function ReadStreamOptions() {},
            WriteStream: function WriteStream() {},
            WriteStreamOptions: function WriteStreamOptions() {},
            FileOptions: function FileOptions() {},
            StatOptions: function StatOptions() {},
            MkdirOptions: function MkdirOptions() {},
            RmdirOptions: function RmdirOptions() {},
            WatchOptions: function WatchOptions() {},
            WatchFileOptions: function WatchFileOptions() {},
            Stats: function Stats() {},
            Promise: function Promise() {},
            Date: function Date1() {},
            JsError: function JsError() {},
            Atomics: function Atomics() {},
            Modules: function Modules() {},
            Module: function Module() {},
            Net: function Net() {},
            Socket: function Socket() {},
            NetAddress: function NetAddress() {},
            NetServer: function NetServer() {},
            NodeJsError: function NodeJsError() {},
            JsAssertionError: function JsAssertionError() {},
            JsRangeError: function JsRangeError() {},
            JsReferenceError: function JsReferenceError() {},
            JsSyntaxError: function JsSyntaxError() {},
            JsTypeError: function JsTypeError() {},
            JsSystemError: function JsSystemError() {},
            Process: function Process() {},
            CPUUsage: function CPUUsage() {},
            Release: function Release() {},
            StreamModule: function StreamModule() {},
            Readable: function Readable() {},
            Writable: function Writable() {},
            Duplex: function Duplex() {},
            Transform: function Transform() {},
            WritableOptions: function WritableOptions() {},
            ReadableOptions: function ReadableOptions() {},
            Immediate: function Immediate() {},
            Timeout: function Timeout() {},
            TTY: function TTY() {},
            TTYReadStream: function TTYReadStream() {},
            TTYWriteStream: function TTYWriteStream() {},
            jsify0: function(dartObject) {
                if (A._isBasicType(dartObject)) return dartObject;
                return A.jsify(dartObject);
            },
            _isBasicType: function(value) {
                return false;
            },
            promiseToFuture0: function(promise, $T) {
                var t1 = new A._Future($.Zone__current, $T._eval$1("_Future<0>")), completer = new A._SyncCompleter(t1, $T._eval$1("_SyncCompleter<0>"));
                J.then$2$x(promise, A.allowInterop(new A.promiseToFuture_closure1(completer)), A.allowInterop(new A.promiseToFuture_closure2(completer)));
                return t1;
            },
            futureToPromise: function(future, $T) {
                return new self.Promise(A.allowInterop(new A.futureToPromise_closure(future, $T)));
            },
            Util: function Util() {},
            promiseToFuture_closure1: function promiseToFuture_closure1(t0) {
                this.completer = t0;
            },
            promiseToFuture_closure2: function promiseToFuture_closure2(t0) {
                this.completer = t0;
            },
            futureToPromise_closure: function futureToPromise_closure(t0, t1) {
                this.future = t0;
                this.T = t1;
            },
            futureToPromise__closure: function futureToPromise__closure(t0, t1) {
                this.resolve = t0;
                this.T = t1;
            },
            Context_Context: function(style) {
                return new A.Context(style, ".");
            },
            _parseUri: function(uri) {
                if (typeof uri == "string") return A.Uri_parse(uri);
                if (type$.Uri._is(uri)) return uri;
                throw A.wrapException(A.ArgumentError$value(uri, "uri", "Value must be a String or a Uri"));
            },
            _validateArgList: function(method, args) {
                var numArgs, i, numArgs0, message, t1, t2, t3, t4;
                for(numArgs = args.length, i = 1; i < numArgs; ++i){
                    if (args[i] == null || args[i - 1] != null) continue;
                    for(; numArgs >= 1; numArgs = numArgs0){
                        numArgs0 = numArgs - 1;
                        if (args[numArgs0] != null) break;
                    }
                    message = new A.StringBuffer("");
                    t1 = method + "(";
                    message._contents = t1;
                    t2 = A._arrayInstanceType(args);
                    t3 = t2._eval$1("SubListIterable<1>");
                    t4 = new A.SubListIterable(args, 0, numArgs, t3);
                    t4.SubListIterable$3(args, 0, numArgs, t2._precomputed1);
                    t3 = t1 + new A.MappedListIterable(t4, new A._validateArgList_closure(), t3._eval$1("MappedListIterable<ListIterable.E,String>")).join$1(0, ", ");
                    message._contents = t3;
                    message._contents = t3 + ("): part " + (i - 1) + " was null, but part " + i + " was not.");
                    throw A.wrapException(A.ArgumentError$(message.toString$0(0), null));
                }
            },
            Context: function Context(t0, t1) {
                this.style = t0;
                this._context$_current = t1;
            },
            Context_joinAll_closure: function Context_joinAll_closure() {},
            Context_split_closure: function Context_split_closure() {},
            _validateArgList_closure: function _validateArgList_closure() {},
            _PathDirection: function _PathDirection(t0) {
                this.name = t0;
            },
            _PathRelation: function _PathRelation(t0) {
                this.name = t0;
            },
            InternalStyle: function InternalStyle() {},
            ParsedPath_ParsedPath$parse: function(path, style) {
                var t1, parts, separators, start, i, root = style.getRoot$1(path), isRootRelative = style.isRootRelative$1(path);
                if (root != null) path = B.JSString_methods.substring$1(path, root.length);
                t1 = type$.JSArray_String;
                parts = A._setArrayType([], t1);
                separators = A._setArrayType([], t1);
                t1 = path.length;
                if (t1 !== 0 && style.isSeparator$1(path.charCodeAt(0))) {
                    separators.push(path[0]);
                    start = 1;
                } else {
                    separators.push("");
                    start = 0;
                }
                for(i = start; i < t1; ++i)if (style.isSeparator$1(path.charCodeAt(i))) {
                    parts.push(B.JSString_methods.substring$2(path, start, i));
                    separators.push(path[i]);
                    start = i + 1;
                }
                if (start < t1) {
                    parts.push(B.JSString_methods.substring$1(path, start));
                    separators.push("");
                }
                return new A.ParsedPath(style, root, isRootRelative, parts, separators);
            },
            ParsedPath: function ParsedPath(t0, t1, t2, t3, t4) {
                var _ = this;
                _.style = t0;
                _.root = t1;
                _.isRootRelative = t2;
                _.parts = t3;
                _.separators = t4;
            },
            ParsedPath__splitExtension_closure: function ParsedPath__splitExtension_closure() {},
            ParsedPath__splitExtension_closure0: function ParsedPath__splitExtension_closure0() {},
            PathException$: function(message) {
                return new A.PathException(message);
            },
            PathException: function PathException(t0) {
                this.message = t0;
            },
            PathMap__create: function(context, $V) {
                var t1 = {};
                t1.context = context;
                t1.context = $.$get$context();
                return A.LinkedHashMap_LinkedHashMap(new A.PathMap__create_closure(t1), new A.PathMap__create_closure0(t1), new A.PathMap__create_closure1(), type$.nullable_String, $V);
            },
            PathMap: function PathMap(t0, t1) {
                this._map = t0;
                this.$ti = t1;
            },
            PathMap__create_closure: function PathMap__create_closure(t0) {
                this._box_0 = t0;
            },
            PathMap__create_closure0: function PathMap__create_closure0(t0) {
                this._box_0 = t0;
            },
            PathMap__create_closure1: function PathMap__create_closure1() {},
            Style__getPlatformStyle: function() {
                if (A.Uri_base().get$scheme() !== "file") return $.$get$Style_url();
                var t1 = A.Uri_base();
                if (!B.JSString_methods.endsWith$1(t1.get$path(t1), "/")) return $.$get$Style_url();
                if (A._Uri__Uri(null, "a/b", null, null).toFilePath$0() === "a\\b") return $.$get$Style_windows();
                return $.$get$Style_posix();
            },
            Style: function Style() {},
            PosixStyle: function PosixStyle(t0, t1, t2) {
                this.separatorPattern = t0;
                this.needsSeparatorPattern = t1;
                this.rootPattern = t2;
            },
            UrlStyle: function UrlStyle(t0, t1, t2, t3) {
                var _ = this;
                _.separatorPattern = t0;
                _.needsSeparatorPattern = t1;
                _.rootPattern = t2;
                _.relativeRootPattern = t3;
            },
            WindowsStyle: function WindowsStyle(t0, t1, t2, t3) {
                var _ = this;
                _.separatorPattern = t0;
                _.needsSeparatorPattern = t1;
                _.rootPattern = t2;
                _.relativeRootPattern = t3;
            },
            WindowsStyle_absolutePathToUri_closure: function WindowsStyle_absolutePathToUri_closure() {},
            Version$_: function(major, minor, patch, preRelease, build, _text) {
                var t1 = preRelease == null || preRelease.length === 0 ? A._setArrayType([], type$.JSArray_Object) : A.Version__splitParts(preRelease), t2 = build == null || build.length === 0 ? A._setArrayType([], type$.JSArray_Object) : A.Version__splitParts(build);
                if (major < 0) A.throwExpression(A.ArgumentError$("Major version must be non-negative.", null));
                if (minor < 0) A.throwExpression(A.ArgumentError$("Minor version must be non-negative.", null));
                if (patch < 0) A.throwExpression(A.ArgumentError$("Patch version must be non-negative.", null));
                return new A.Version(major, minor, patch, t1, t2, _text);
            },
            Version_Version: function(major, minor, patch, pre) {
                var text = "" + major + "." + minor + "." + patch;
                if (pre != null) text += "-" + pre;
                return A.Version$_(major, minor, patch, pre, null, text);
            },
            Version___parse_tearOff: function(text) {
                return A.Version_Version$parse(text);
            },
            Version_Version$parse: function(text) {
                var major, minor, patch, preRelease, build, t1, _$exception, _null = null, _s17_ = 'Could not parse "', match = $.$get$completeVersion().firstMatch$1(text);
                if (match == null) throw A.wrapException(A.FormatException$(_s17_ + text + '".', _null, _null));
                try {
                    t1 = match._match[1];
                    t1.toString;
                    major = A.int_parse(t1, _null);
                    t1 = match._match[2];
                    t1.toString;
                    minor = A.int_parse(t1, _null);
                    t1 = match._match[3];
                    t1.toString;
                    patch = A.int_parse(t1, _null);
                    preRelease = match._match[5];
                    build = match._match[8];
                    t1 = A.Version$_(major, minor, patch, preRelease, build, text);
                    return t1;
                } catch (exception) {
                    if (type$.FormatException._is(A.unwrapException(exception))) throw A.wrapException(A.FormatException$(_s17_ + text + '".', _null, _null));
                    else throw exception;
                }
            },
            Version__splitParts: function(text) {
                var t1 = type$.MappedListIterable_String_Object;
                t1 = A.List_List$_of(new A.MappedListIterable(A._setArrayType(text.split("."), type$.JSArray_String), new A.Version__splitParts_closure(), t1), t1._eval$1("ListIterable.E"));
                return t1;
            },
            Version: function Version(t0, t1, t2, t3, t4, t5) {
                var _ = this;
                _.major = t0;
                _.minor = t1;
                _.patch = t2;
                _.preRelease = t3;
                _.build = t4;
                _._version$_text = t5;
            },
            Version__splitParts_closure: function Version__splitParts_closure() {},
            VersionRange_VersionRange: function(includeMax, max) {
                return new A.VersionRange(null, max, false, true);
            },
            VersionRange: function VersionRange(t0, t1, t2, t3) {
                var _ = this;
                _.min = t0;
                _.max = t1;
                _.includeMin = t2;
                _.includeMax = t3;
            },
            CssMediaQuery$type: function(type, conditions, modifier) {
                return new A.CssMediaQuery(modifier, type, true, conditions == null ? B.List_empty : A.List_List$unmodifiable(conditions, type$.String));
            },
            CssMediaQuery$condition: function(conditions, conjunction) {
                var t1 = A.List_List$unmodifiable(conditions, type$.String);
                if (t1.length > 1 && conjunction == null) A.throwExpression(A.ArgumentError$(string$.If_con, null));
                return new A.CssMediaQuery(null, null, conjunction !== false, t1);
            },
            CssMediaQuery: function CssMediaQuery(t0, t1, t2, t3) {
                var _ = this;
                _.modifier = t0;
                _.type = t1;
                _.conjunction = t2;
                _.conditions = t3;
            },
            _SingletonCssMediaQueryMergeResult: function _SingletonCssMediaQueryMergeResult(t0, t1) {
                this.index = t0;
                this._name = t1;
            },
            MediaQuerySuccessfulMergeResult: function MediaQuerySuccessfulMergeResult(t0) {
                this.query = t0;
            },
            ModifiableCssAtRule$: function($name, span, childless, value) {
                var t1 = A._setArrayType([], type$.JSArray_ModifiableCssNode);
                return new A.ModifiableCssAtRule($name, value, childless, span, new A.UnmodifiableListView(t1, type$.UnmodifiableListView_ModifiableCssNode), t1);
            },
            ModifiableCssAtRule: function ModifiableCssAtRule(t0, t1, t2, t3, t4, t5) {
                var _ = this;
                _.name = t0;
                _.value = t1;
                _.isChildless = t2;
                _.span = t3;
                _.children = t4;
                _._children = t5;
                _._indexInParent = _._parent = null;
                _.isGroupEnd = false;
            },
            ModifiableCssComment: function ModifiableCssComment(t0, t1) {
                var _ = this;
                _.text = t0;
                _.span = t1;
                _._indexInParent = _._parent = null;
                _.isGroupEnd = false;
            },
            ModifiableCssDeclaration$: function($name, value, span, parsedAsSassScript, valueSpanForMap) {
                var t2, t1 = valueSpanForMap == null ? value.span : valueSpanForMap;
                if (!parsedAsSassScript) {
                    t2 = value.value;
                    if (!(t2 instanceof A.SassString)) A.throwExpression(A.ArgumentError$(string$.If_par + value.toString$0(0) + "` of type " + A.getRuntimeTypeOfDartObject(t2).toString$0(0) + ").", null));
                }
                return new A.ModifiableCssDeclaration($name, value, parsedAsSassScript, t1, span);
            },
            ModifiableCssDeclaration: function ModifiableCssDeclaration(t0, t1, t2, t3, t4) {
                var _ = this;
                _.name = t0;
                _.value = t1;
                _.parsedAsSassScript = t2;
                _.valueSpanForMap = t3;
                _.span = t4;
                _._indexInParent = _._parent = null;
                _.isGroupEnd = false;
            },
            ModifiableCssImport: function ModifiableCssImport(t0, t1, t2) {
                var _ = this;
                _.url = t0;
                _.modifiers = t1;
                _.span = t2;
                _._indexInParent = _._parent = null;
                _.isGroupEnd = false;
            },
            ModifiableCssKeyframeBlock$: function(selector, span) {
                var t1 = A._setArrayType([], type$.JSArray_ModifiableCssNode);
                return new A.ModifiableCssKeyframeBlock(selector, span, new A.UnmodifiableListView(t1, type$.UnmodifiableListView_ModifiableCssNode), t1);
            },
            ModifiableCssKeyframeBlock: function ModifiableCssKeyframeBlock(t0, t1, t2, t3) {
                var _ = this;
                _.selector = t0;
                _.span = t1;
                _.children = t2;
                _._children = t3;
                _._indexInParent = _._parent = null;
                _.isGroupEnd = false;
            },
            ModifiableCssMediaRule$: function(queries, span) {
                var t1 = A.List_List$unmodifiable(queries, type$.CssMediaQuery), t2 = A._setArrayType([], type$.JSArray_ModifiableCssNode);
                if (J.get$isEmpty$asx(queries)) A.throwExpression(A.ArgumentError$value(queries, "queries", "may not be empty."));
                return new A.ModifiableCssMediaRule(t1, span, new A.UnmodifiableListView(t2, type$.UnmodifiableListView_ModifiableCssNode), t2);
            },
            ModifiableCssMediaRule: function ModifiableCssMediaRule(t0, t1, t2, t3) {
                var _ = this;
                _.queries = t0;
                _.span = t1;
                _.children = t2;
                _._children = t3;
                _._indexInParent = _._parent = null;
                _.isGroupEnd = false;
            },
            ModifiableCssNode: function ModifiableCssNode() {},
            ModifiableCssNode_hasFollowingSibling_closure: function ModifiableCssNode_hasFollowingSibling_closure() {},
            ModifiableCssParentNode: function ModifiableCssParentNode() {},
            ModifiableCssStyleRule$: function(_selector, span, fromPlainCss, originalSelector) {
                var t1 = A._setArrayType([], type$.JSArray_ModifiableCssNode);
                return new A.ModifiableCssStyleRule(_selector, originalSelector, span, fromPlainCss, new A.UnmodifiableListView(t1, type$.UnmodifiableListView_ModifiableCssNode), t1);
            },
            ModifiableCssStyleRule: function ModifiableCssStyleRule(t0, t1, t2, t3, t4, t5) {
                var _ = this;
                _._style_rule$_selector = t0;
                _.originalSelector = t1;
                _.span = t2;
                _.fromPlainCss = t3;
                _.children = t4;
                _._children = t5;
                _._indexInParent = _._parent = null;
                _.isGroupEnd = false;
            },
            ModifiableCssStylesheet$: function(span) {
                var t1 = A._setArrayType([], type$.JSArray_ModifiableCssNode);
                return new A.ModifiableCssStylesheet(span, new A.UnmodifiableListView(t1, type$.UnmodifiableListView_ModifiableCssNode), t1);
            },
            ModifiableCssStylesheet: function ModifiableCssStylesheet(t0, t1, t2) {
                var _ = this;
                _.span = t0;
                _.children = t1;
                _._children = t2;
                _._indexInParent = _._parent = null;
                _.isGroupEnd = false;
            },
            ModifiableCssSupportsRule$: function(condition, span) {
                var t1 = A._setArrayType([], type$.JSArray_ModifiableCssNode);
                return new A.ModifiableCssSupportsRule(condition, span, new A.UnmodifiableListView(t1, type$.UnmodifiableListView_ModifiableCssNode), t1);
            },
            ModifiableCssSupportsRule: function ModifiableCssSupportsRule(t0, t1, t2, t3) {
                var _ = this;
                _.condition = t0;
                _.span = t1;
                _.children = t2;
                _._children = t3;
                _._indexInParent = _._parent = null;
                _.isGroupEnd = false;
            },
            CssNode: function CssNode() {},
            CssParentNode: function CssParentNode() {},
            _IsInvisibleVisitor: function _IsInvisibleVisitor(t0, t1) {
                this.includeBogus = t0;
                this.includeComments = t1;
            },
            __IsInvisibleVisitor_Object_EveryCssVisitor: function __IsInvisibleVisitor_Object_EveryCssVisitor() {},
            CssStylesheet: function CssStylesheet(t0, t1) {
                this.children = t0;
                this.span = t1;
            },
            CssValue: function CssValue(t0, t1, t2) {
                this.value = t0;
                this.span = t1;
                this.$ti = t2;
            },
            _FakeAstNode: function _FakeAstNode(t0) {
                this._callback = t0;
            },
            ArgumentList$: function(positional, named, namedSpans, span, keywordRest, rest) {
                var t1 = type$.Expression, t2 = type$.String;
                return new A.ArgumentList(A.List_List$unmodifiable(positional, t1), A.ConstantMap_ConstantMap$from(named, t2, t1), A.ConstantMap_ConstantMap$from(namedSpans, t2, type$.FileSpan), rest, keywordRest, span);
            },
            ArgumentList$empty: function(span) {
                return new A.ArgumentList(B.List_empty9, B.Map_empty4, B.Map_empty5, null, null, span);
            },
            ArgumentList: function ArgumentList(t0, t1, t2, t3, t4, t5) {
                var _ = this;
                _.positional = t0;
                _.named = t1;
                _.namedSpans = t2;
                _.rest = t3;
                _.keywordRest = t4;
                _.span = t5;
            },
            AtRootQuery: function AtRootQuery(t0, t1, t2, t3) {
                var _ = this;
                _.include = t0;
                _.names = t1;
                _._all = t2;
                _._at_root_query$_rule = t3;
            },
            BooleanOperator: function BooleanOperator(t0, t1) {
                this.index = t0;
                this._name = t1;
            },
            ConfiguredVariable: function ConfiguredVariable(t0, t1, t2, t3) {
                var _ = this;
                _.name = t0;
                _.expression = t1;
                _.isGuarded = t2;
                _.span = t3;
            },
            Expression: function Expression() {},
            BinaryOperationExpression: function BinaryOperationExpression(t0, t1, t2, t3) {
                var _ = this;
                _.operator = t0;
                _.left = t1;
                _.right = t2;
                _.allowsSlash = t3;
            },
            BinaryOperator: function BinaryOperator(t0, t1, t2, t3, t4, t5) {
                var _ = this;
                _.name = t0;
                _.operator = t1;
                _.precedence = t2;
                _.isAssociative = t3;
                _.index = t4;
                _._name = t5;
            },
            BooleanExpression: function BooleanExpression(t0, t1) {
                this.value = t0;
                this.span = t1;
            },
            ColorExpression: function ColorExpression(t0, t1) {
                this.value = t0;
                this.span = t1;
            },
            FunctionExpression: function FunctionExpression(t0, t1, t2, t3, t4) {
                var _ = this;
                _.namespace = t0;
                _.name = t1;
                _.originalName = t2;
                _.$arguments = t3;
                _.span = t4;
            },
            IfConditionOperation$: function(expressions, op) {
                var t1 = A.List_List$unmodifiable(expressions, type$.IfConditionExpression);
                if (t1.length < 2) A.throwExpression(A.ArgumentError$value(t1, "expressions", "must have length >= 2"));
                return new A.IfConditionOperation(t1, op);
            },
            IfExpression: function IfExpression(t0, t1) {
                this.branches = t0;
                this.span = t1;
            },
            IfConditionExpression: function IfConditionExpression() {},
            IfConditionParenthesized: function IfConditionParenthesized(t0, t1) {
                this.expression = t0;
                this.span = t1;
            },
            IfConditionNegation: function IfConditionNegation(t0, t1) {
                this.expression = t0;
                this.span = t1;
            },
            IfConditionOperation: function IfConditionOperation(t0, t1) {
                this.expressions = t0;
                this.op = t1;
            },
            IfConditionOperation_toInterpolation_closure: function IfConditionOperation_toInterpolation_closure(t0) {
                this.$this = t0;
            },
            IfConditionFunction: function IfConditionFunction(t0, t1, t2) {
                this.name = t0;
                this.$arguments = t1;
                this.span = t2;
            },
            IfConditionSass: function IfConditionSass(t0, t1) {
                this.expression = t0;
                this.span = t1;
            },
            IfConditionRaw: function IfConditionRaw(t0) {
                this.text = t0;
            },
            InterpolatedFunctionExpression: function InterpolatedFunctionExpression(t0, t1, t2) {
                this.name = t0;
                this.$arguments = t1;
                this.span = t2;
            },
            LegacyIfExpression: function LegacyIfExpression(t0, t1) {
                this.$arguments = t0;
                this.span = t1;
            },
            ListExpression: function ListExpression(t0, t1, t2, t3) {
                var _ = this;
                _.contents = t0;
                _.separator = t1;
                _.hasBrackets = t2;
                _.span = t3;
            },
            ListExpression_toString_closure: function ListExpression_toString_closure(t0) {
                this.$this = t0;
            },
            MapExpression: function MapExpression(t0, t1) {
                this.pairs = t0;
                this.span = t1;
            },
            NullExpression: function NullExpression(t0) {
                this.span = t0;
            },
            NumberExpression: function NumberExpression(t0, t1, t2) {
                this.value = t0;
                this.unit = t1;
                this.span = t2;
            },
            ParenthesizedExpression: function ParenthesizedExpression(t0, t1) {
                this.expression = t0;
                this.span = t1;
            },
            SelectorExpression: function SelectorExpression(t0) {
                this.span = t0;
            },
            StringExpression_quoteText: function(text) {
                var quote = A.StringExpression__bestQuote(A._setArrayType([
                    text
                ], type$.JSArray_String)), buffer = new A.StringBuffer(""), t1 = A.Primitives_stringFromCharCode(quote);
                buffer._contents = t1;
                A.StringExpression__quoteInnerText(text, quote, buffer, true);
                t1 = buffer._contents += t1;
                return t1.charCodeAt(0) == 0 ? t1 : t1;
            },
            StringExpression__quoteInnerText: function(text, quote, buffer, $static) {
                var t1, t2, i, _1_0, _0_0, t3, t4, t5, t0;
                for(t1 = text.length, t2 = t1 - 1, i = 0; i < t1; ++i){
                    _1_0 = text.charCodeAt(i);
                    if (_1_0 === 10 || _1_0 === 13 || _1_0 === 12) {
                        buffer.writeCharCode$1(92);
                        buffer.writeCharCode$1(97);
                        if (i !== t2) {
                            _0_0 = text.charCodeAt(i + 1);
                            t3 = true;
                            if (!(_0_0 === 32 || _0_0 === 9 || _0_0 === 10 || _0_0 === 13 || _0_0 === 12)) {
                                if (!(_0_0 >= 48 && _0_0 <= 57)) {
                                    if (!(_0_0 >= 97 && _0_0 <= 102)) t3 = _0_0 >= 65 && _0_0 <= 70;
                                }
                            }
                            if (t3) buffer.writeCharCode$1(32);
                        }
                        continue;
                    }
                    t3 = 92 === _1_0;
                    if (t3) t4 = _1_0;
                    else t4 = null;
                    if (!t3) {
                        t3 = false;
                        t5 = _1_0 === quote;
                        if (t5) t4 = _1_0;
                        if (!t5) {
                            if (35 === _1_0) {
                                if ($static) {
                                    if (i < t2) {
                                        t3 = text.charCodeAt(i + 1) === 123;
                                        if (t3) t4 = _1_0;
                                        t0 = t4;
                                        t4 = t3;
                                        t3 = t0;
                                    } else {
                                        t0 = t4;
                                        t4 = t3;
                                        t3 = t0;
                                    }
                                } else {
                                    t0 = t4;
                                    t4 = t3;
                                    t3 = t0;
                                }
                            } else {
                                t0 = t4;
                                t4 = t3;
                                t3 = t0;
                            }
                        } else {
                            t3 = t4;
                            t4 = true;
                        }
                    } else {
                        t3 = t4;
                        t4 = true;
                    }
                    if (t4) {
                        buffer.writeCharCode$1(92);
                        buffer.writeCharCode$1(t3);
                        continue;
                    }
                    buffer.writeCharCode$1(_1_0);
                }
            },
            StringExpression__bestQuote: function(strings) {
                var t1, t2, t3, containsDoubleQuote, t4, t5;
                for(t1 = J.get$iterator$ax(strings), t2 = type$.CodeUnits, t3 = t2._eval$1("ListIterator<ListBase.E>"), t2 = t2._eval$1("ListBase.E"), containsDoubleQuote = false; t1.moveNext$0();)for(t4 = new A.CodeUnits(t1.get$current(t1)), t4 = new A.ListIterator(t4, t4.get$length(0), t3); t4.moveNext$0();){
                    t5 = t4.__internal$_current;
                    if (t5 == null) t5 = t2._as(t5);
                    if (t5 === 39) return 34;
                    if (t5 === 34) containsDoubleQuote = true;
                }
                return containsDoubleQuote ? 39 : 34;
            },
            StringExpression: function StringExpression(t0, t1) {
                this.text = t0;
                this.hasQuotes = t1;
            },
            SupportsExpression: function SupportsExpression(t0) {
                this.condition = t0;
            },
            UnaryOperationExpression: function UnaryOperationExpression(t0, t1, t2) {
                this.operator = t0;
                this.operand = t1;
                this.span = t2;
            },
            UnaryOperator: function UnaryOperator(t0, t1, t2, t3) {
                var _ = this;
                _.name = t0;
                _.operator = t1;
                _.index = t2;
                _._name = t3;
            },
            ValueExpression: function ValueExpression(t0, t1) {
                this.value = t0;
                this.span = t1;
            },
            VariableExpression: function VariableExpression(t0, t1, t2) {
                this.namespace = t0;
                this.name = t1;
                this.span = t2;
            },
            DynamicImport: function DynamicImport(t0, t1) {
                this.urlString = t0;
                this.span = t1;
            },
            StaticImport: function StaticImport(t0, t1, t2) {
                this.url = t0;
                this.modifiers = t1;
                this.span = t2;
            },
            Interpolation$: function(contents, spans, span) {
                var t1 = new A.Interpolation(A.List_List$unmodifiable(contents, type$.Object), A.List_List$unmodifiable(spans, type$.nullable_FileSpan), span);
                t1.Interpolation$3(contents, spans, span);
                return t1;
            },
            Interpolation: function Interpolation(t0, t1, t2) {
                this.contents = t0;
                this.spans = t1;
                this.span = t2;
            },
            Interpolation_toString_closure: function Interpolation_toString_closure() {},
            Parameter: function Parameter(t0, t1, t2) {
                this.name = t0;
                this.defaultValue = t1;
                this.span = t2;
            },
            ParameterList_ParameterList$parse: function(contents, url) {
                return A.ScssParser$(contents, false, url).parseParameterList$0();
            },
            ParameterList: function ParameterList(t0, t1, t2) {
                this.parameters = t0;
                this.restParameter = t1;
                this.span = t2;
            },
            ParameterList_verify_closure: function ParameterList_verify_closure() {},
            ParameterList_verify_closure0: function ParameterList_verify_closure0() {},
            Statement: function Statement() {},
            AtRootRule$: function(children, span, query) {
                var t1 = A.List_List$unmodifiable(children, type$.Statement), t2 = B.JSArray_methods.any$1(t1, new A.ParentStatement_closure());
                return new A.AtRootRule(query, span, t1, t2);
            },
            AtRootRule: function AtRootRule(t0, t1, t2, t3) {
                var _ = this;
                _.query = t0;
                _.span = t1;
                _.children = t2;
                _.hasDeclarations = t3;
            },
            AtRule$: function($name, span, children, value) {
                var t1 = children == null ? null : A.List_List$unmodifiable(children, type$.Statement), t2 = t1 == null ? null : B.JSArray_methods.any$1(t1, new A.ParentStatement_closure());
                return new A.AtRule($name, value, span, t1, t2 === true);
            },
            AtRule: function AtRule(t0, t1, t2, t3, t4) {
                var _ = this;
                _.name = t0;
                _.value = t1;
                _.span = t2;
                _.children = t3;
                _.hasDeclarations = t4;
            },
            CallableDeclaration: function CallableDeclaration() {},
            ContentBlock$: function(parameters, children, span) {
                var _s8_ = "@content", t1 = A.stringReplaceAllUnchecked(_s8_, "_", "-"), t2 = A.List_List$unmodifiable(children, type$.Statement), t3 = B.JSArray_methods.any$1(t2, new A.ParentStatement_closure());
                return new A.ContentBlock(t1, _s8_, parameters, span, t2, t3);
            },
            ContentBlock: function ContentBlock(t0, t1, t2, t3, t4, t5) {
                var _ = this;
                _.name = t0;
                _.originalName = t1;
                _.parameters = t2;
                _.span = t3;
                _.children = t4;
                _.hasDeclarations = t5;
            },
            ContentRule: function ContentRule(t0, t1) {
                this.$arguments = t0;
                this.span = t1;
            },
            DebugRule: function DebugRule(t0, t1) {
                this.expression = t0;
                this.span = t1;
            },
            Declaration$: function($name, value, span) {
                return new A.Declaration($name, value, span, true, null, false);
            },
            Declaration$notSassScript: function($name, value, span) {
                return new A.Declaration($name, value, span, false, null, false);
            },
            Declaration$nested: function($name, children, span, value) {
                var t1 = A.List_List$unmodifiable(children, type$.Statement), t2 = B.JSArray_methods.any$1(t1, new A.ParentStatement_closure());
                return new A.Declaration($name, value, span, true, t1, t2);
            },
            Declaration: function Declaration(t0, t1, t2, t3, t4, t5) {
                var _ = this;
                _.name = t0;
                _.value = t1;
                _.span = t2;
                _.parsedAsSassScript = t3;
                _.children = t4;
                _.hasDeclarations = t5;
            },
            EachRule$: function(variables, list, children, span) {
                var t1 = A.List_List$unmodifiable(variables, type$.String), t2 = A.List_List$unmodifiable(children, type$.Statement), t3 = B.JSArray_methods.any$1(t2, new A.ParentStatement_closure());
                return new A.EachRule(t1, list, span, t2, t3);
            },
            EachRule: function EachRule(t0, t1, t2, t3, t4) {
                var _ = this;
                _.variables = t0;
                _.list = t1;
                _.span = t2;
                _.children = t3;
                _.hasDeclarations = t4;
            },
            EachRule_toString_closure: function EachRule_toString_closure() {},
            ErrorRule: function ErrorRule(t0, t1) {
                this.expression = t0;
                this.span = t1;
            },
            ExtendRule: function ExtendRule(t0, t1, t2) {
                this.selector = t0;
                this.isOptional = t1;
                this.span = t2;
            },
            ForRule$: function(variable, from, to, children, span, exclusive) {
                var t1 = A.List_List$unmodifiable(children, type$.Statement), t2 = B.JSArray_methods.any$1(t1, new A.ParentStatement_closure());
                return new A.ForRule(variable, from, to, exclusive, span, t1, t2);
            },
            ForRule: function ForRule(t0, t1, t2, t3, t4, t5, t6) {
                var _ = this;
                _.variable = t0;
                _.from = t1;
                _.to = t2;
                _.isExclusive = t3;
                _.span = t4;
                _.children = t5;
                _.hasDeclarations = t6;
            },
            ForwardRule: function ForwardRule(t0, t1, t2, t3, t4, t5, t6, t7) {
                var _ = this;
                _.url = t0;
                _.shownMixinsAndFunctions = t1;
                _.shownVariables = t2;
                _.hiddenMixinsAndFunctions = t3;
                _.hiddenVariables = t4;
                _.prefix = t5;
                _.configuration = t6;
                _.span = t7;
            },
            FunctionRule$: function($name, parameters, children, span, comment) {
                var t1 = A.stringReplaceAllUnchecked($name, "_", "-"), t2 = A.List_List$unmodifiable(children, type$.Statement), t3 = B.JSArray_methods.any$1(t2, new A.ParentStatement_closure());
                return new A.FunctionRule(t1, $name, parameters, span, t2, t3);
            },
            FunctionRule: function FunctionRule(t0, t1, t2, t3, t4, t5) {
                var _ = this;
                _.name = t0;
                _.originalName = t1;
                _.parameters = t2;
                _.span = t3;
                _.children = t4;
                _.hasDeclarations = t5;
            },
            IfClause$: function(expression, children) {
                var t1 = A.List_List$unmodifiable(children, type$.Statement);
                return new A.IfClause(expression, t1, B.JSArray_methods.any$1(t1, new A.IfRuleClause$__closure()));
            },
            ElseClause$: function(children) {
                var t1 = A.List_List$unmodifiable(children, type$.Statement);
                return new A.ElseClause(t1, B.JSArray_methods.any$1(t1, new A.IfRuleClause$__closure()));
            },
            IfRule: function IfRule(t0, t1, t2) {
                this.clauses = t0;
                this.lastClause = t1;
                this.span = t2;
            },
            IfRule_toString_closure: function IfRule_toString_closure() {},
            IfRuleClause: function IfRuleClause() {},
            IfRuleClause$__closure: function IfRuleClause$__closure() {},
            IfRuleClause$___closure: function IfRuleClause$___closure() {},
            IfClause: function IfClause(t0, t1, t2) {
                this.expression = t0;
                this.children = t1;
                this.hasDeclarations = t2;
            },
            ElseClause: function ElseClause(t0, t1) {
                this.children = t0;
                this.hasDeclarations = t1;
            },
            ImportRule: function ImportRule(t0, t1) {
                this.imports = t0;
                this.span = t1;
            },
            IncludeRule: function IncludeRule(t0, t1, t2, t3, t4, t5) {
                var _ = this;
                _.namespace = t0;
                _.name = t1;
                _.originalName = t2;
                _.$arguments = t3;
                _.content = t4;
                _.span = t5;
            },
            LoudComment: function LoudComment(t0) {
                this.text = t0;
            },
            MediaRule$: function(query, children, span) {
                var t1 = A.List_List$unmodifiable(children, type$.Statement), t2 = B.JSArray_methods.any$1(t1, new A.ParentStatement_closure());
                return new A.MediaRule(query, span, t1, t2);
            },
            MediaRule: function MediaRule(t0, t1, t2, t3) {
                var _ = this;
                _.query = t0;
                _.span = t1;
                _.children = t2;
                _.hasDeclarations = t3;
            },
            MixinRule$: function($name, parameters, children, span, comment) {
                var t1 = A.stringReplaceAllUnchecked($name, "_", "-"), t2 = A.List_List$unmodifiable(children, type$.Statement), t3 = B.JSArray_methods.any$1(t2, new A.ParentStatement_closure());
                return new A.MixinRule(t1, $name, parameters, span, t2, t3);
            },
            MixinRule: function MixinRule(t0, t1, t2, t3, t4, t5) {
                var _ = this;
                _.__MixinRule_hasContent_FI = $;
                _.name = t0;
                _.originalName = t1;
                _.parameters = t2;
                _.span = t3;
                _.children = t4;
                _.hasDeclarations = t5;
            },
            _HasContentVisitor: function _HasContentVisitor() {},
            __HasContentVisitor_Object_StatementSearchVisitor: function __HasContentVisitor_Object_StatementSearchVisitor() {},
            ParentStatement: function ParentStatement() {},
            ParentStatement_closure: function ParentStatement_closure() {},
            ParentStatement__closure: function ParentStatement__closure() {},
            ReturnRule: function ReturnRule(t0, t1) {
                this.expression = t0;
                this.span = t1;
            },
            SilentComment: function SilentComment(t0, t1) {
                this.text = t0;
                this.span = t1;
            },
            StyleRule$: function(selector, children, span) {
                var t1 = A.List_List$unmodifiable(children, type$.Statement), t2 = B.JSArray_methods.any$1(t1, new A.ParentStatement_closure());
                return new A.StyleRule(selector, null, span, t1, t2);
            },
            StyleRule: function StyleRule(t0, t1, t2, t3, t4) {
                var _ = this;
                _.selector = t0;
                _.parsedSelector = t1;
                _.span = t2;
                _.children = t3;
                _.hasDeclarations = t4;
            },
            Stylesheet$: function(children, span) {
                var t1 = A._setArrayType([], type$.JSArray_Record_3_nullable_Deprecation_deprecation_and_String_message_and_FileSpan_span), t2 = A._setArrayType([], type$.JSArray_UseRule), t3 = A._setArrayType([], type$.JSArray_ForwardRule), t4 = A.List_List$unmodifiable(children, type$.Statement), t5 = B.JSArray_methods.any$1(t4, new A.ParentStatement_closure());
                t2 = new A.Stylesheet(span, false, t2, t3, new A.UnmodifiableListView(t1, type$.UnmodifiableListView_Record_3_nullable_Deprecation_deprecation_and_String_message_and_FileSpan_span), B.Map_empty5, t4, t5);
                t2.Stylesheet$internal$5$globalVariables$plainCss(children, span, t1, null, false);
                return t2;
            },
            Stylesheet$internal: function(children, span, parseTimeWarnings, globalVariables, plainCss) {
                var t1 = A._setArrayType([], type$.JSArray_UseRule), t2 = A._setArrayType([], type$.JSArray_ForwardRule), t3 = globalVariables == null ? B.Map_empty5 : A.ConstantMap_ConstantMap$from(globalVariables, type$.String, type$.FileSpan), t4 = A.List_List$unmodifiable(children, type$.Statement), t5 = B.JSArray_methods.any$1(t4, new A.ParentStatement_closure());
                t1 = new A.Stylesheet(span, plainCss, t1, t2, new A.UnmodifiableListView(parseTimeWarnings, type$.UnmodifiableListView_Record_3_nullable_Deprecation_deprecation_and_String_message_and_FileSpan_span), t3, t4, t5);
                t1.Stylesheet$internal$5$globalVariables$plainCss(children, span, parseTimeWarnings, globalVariables, plainCss);
                return t1;
            },
            Stylesheet_Stylesheet$parse: function(contents, syntax, parseSelectors, url) {
                var error, stackTrace, url0, t1, _$exception, t2;
                try {
                    switch(syntax.index){
                        case 1:
                            t1 = new A.SassParser(false, A.LinkedHashMap_LinkedHashMap$_empty(type$.String, type$.FileSpan), A._setArrayType([], type$.JSArray_Record_3_nullable_Deprecation_deprecation_and_String_message_and_FileSpan_span), A.SpanScanner$(contents, url), null).parse$0(0);
                            return t1;
                        case 0:
                            t1 = A.ScssParser$(contents, false, url).parse$0(0);
                            return t1;
                        case 2:
                            t1 = new A.CssParser(false, A.LinkedHashMap_LinkedHashMap$_empty(type$.String, type$.FileSpan), A._setArrayType([], type$.JSArray_Record_3_nullable_Deprecation_deprecation_and_String_message_and_FileSpan_span), A.SpanScanner$(contents, url), null).parse$0(0);
                            return t1;
                    }
                } catch (exception) {
                    t1 = A.unwrapException(exception);
                    if (t1 instanceof A.SassException) {
                        error = t1;
                        stackTrace = A.getTraceFromException(exception);
                        t1 = error;
                        t2 = J.getInterceptor$x(t1);
                        t1 = A.SourceSpanException.prototype.get$span.call(t2, t1);
                        url0 = t1.get$sourceUrl(t1);
                        if (url0 == null || url0.toString$0(0) === "stdin") throw exception;
                        t1 = type$.Uri;
                        throw A.wrapException(A.throwWithTrace(error.withLoadedUrls$1(A.Set_Set$unmodifiable(A.LinkedHashSet_LinkedHashSet$_literal([
                            url0
                        ], t1), t1)), error, stackTrace));
                    } else throw exception;
                }
            },
            Stylesheet: function Stylesheet(t0, t1, t2, t3, t4, t5, t6, t7) {
                var _ = this;
                _.span = t0;
                _.plainCss = t1;
                _._uses = t2;
                _._forwards = t3;
                _.parseTimeWarnings = t4;
                _.globalVariables = t5;
                _.children = t6;
                _.hasDeclarations = t7;
            },
            SupportsRule$: function(condition, children, span) {
                var t1 = A.List_List$unmodifiable(children, type$.Statement), t2 = B.JSArray_methods.any$1(t1, new A.ParentStatement_closure());
                return new A.SupportsRule(condition, span, t1, t2);
            },
            SupportsRule: function SupportsRule(t0, t1, t2, t3) {
                var _ = this;
                _.condition = t0;
                _.span = t1;
                _.children = t2;
                _.hasDeclarations = t3;
            },
            UseRule: function UseRule(t0, t1, t2, t3) {
                var _ = this;
                _.url = t0;
                _.namespace = t1;
                _.configuration = t2;
                _.span = t3;
            },
            VariableDeclaration$: function($name, expression, span, comment, global, guarded, namespace) {
                if (namespace != null && global) A.throwExpression(A.ArgumentError$(string$.Other_, null));
                return new A.VariableDeclaration(namespace, $name, expression, guarded, global, span);
            },
            VariableDeclaration: function VariableDeclaration(t0, t1, t2, t3, t4, t5) {
                var _ = this;
                _.namespace = t0;
                _.name = t1;
                _.expression = t2;
                _.isGuarded = t3;
                _.isGlobal = t4;
                _.span = t5;
            },
            WarnRule: function WarnRule(t0, t1) {
                this.expression = t0;
                this.span = t1;
            },
            WhileRule$: function(condition, children, span) {
                var t1 = A.List_List$unmodifiable(children, type$.Statement), t2 = B.JSArray_methods.any$1(t1, new A.ParentStatement_closure());
                return new A.WhileRule(condition, span, t1, t2);
            },
            WhileRule: function WhileRule(t0, t1, t2, t3) {
                var _ = this;
                _.condition = t0;
                _.span = t1;
                _.children = t2;
                _.hasDeclarations = t3;
            },
            SupportsAnything: function SupportsAnything(t0, t1) {
                this.contents = t0;
                this.span = t1;
            },
            SupportsDeclaration: function SupportsDeclaration(t0, t1, t2) {
                this.name = t0;
                this.value = t1;
                this.span = t2;
            },
            SupportsFunction: function SupportsFunction(t0, t1, t2) {
                this.name = t0;
                this.$arguments = t1;
                this.span = t2;
            },
            SupportsInterpolation: function SupportsInterpolation(t0, t1) {
                this.expression = t0;
                this.span = t1;
            },
            SupportsNegation: function SupportsNegation(t0, t1) {
                this.condition = t0;
                this.span = t1;
            },
            SupportsOperation: function SupportsOperation(t0, t1, t2, t3) {
                var _ = this;
                _.left = t0;
                _.right = t1;
                _.operator = t2;
                _.span = t3;
            },
            Selector: function Selector() {},
            _IsInvisibleVisitor0: function _IsInvisibleVisitor0(t0) {
                this.includeBogus = t0;
            },
            _IsBogusVisitor: function _IsBogusVisitor(t0) {
                this.includeLeadingCombinator = t0;
            },
            _IsBogusVisitor_visitComplexSelector_closure: function _IsBogusVisitor_visitComplexSelector_closure(t0) {
                this.$this = t0;
            },
            _IsUselessVisitor: function _IsUselessVisitor() {},
            _IsUselessVisitor_visitComplexSelector_closure: function _IsUselessVisitor_visitComplexSelector_closure(t0) {
                this.$this = t0;
            },
            _ContainsParentSelectorVisitor: function _ContainsParentSelectorVisitor() {},
            __ContainsParentSelectorVisitor_Object_AnySelectorVisitor: function __ContainsParentSelectorVisitor_Object_AnySelectorVisitor() {},
            __IsBogusVisitor_Object_AnySelectorVisitor: function __IsBogusVisitor_Object_AnySelectorVisitor() {},
            __IsInvisibleVisitor_Object_AnySelectorVisitor: function __IsInvisibleVisitor_Object_AnySelectorVisitor() {},
            __IsUselessVisitor_Object_AnySelectorVisitor: function __IsUselessVisitor_Object_AnySelectorVisitor() {},
            AttributeSelector: function AttributeSelector(t0, t1, t2, t3, t4) {
                var _ = this;
                _.name = t0;
                _.op = t1;
                _.value = t2;
                _.modifier = t3;
                _.span = t4;
            },
            AttributeOperator: function AttributeOperator(t0, t1, t2) {
                this._attribute$_text = t0;
                this.index = t1;
                this._name = t2;
            },
            ClassSelector: function ClassSelector(t0, t1) {
                this.name = t0;
                this.span = t1;
            },
            Combinator: function Combinator(t0, t1, t2) {
                this._combinator$_text = t0;
                this.index = t1;
                this._name = t2;
            },
            ComplexSelector$: function(leadingCombinators, components, span, lineBreak) {
                var t1 = A.List_List$unmodifiable(leadingCombinators, type$.CssValue_Combinator), t2 = A.List_List$unmodifiable(components, type$.ComplexSelectorComponent);
                if (t1.length === 0 && t2.length === 0) A.throwExpression(A.ArgumentError$(string$.leadin, null));
                return new A.ComplexSelector(t1, t2, lineBreak, span);
            },
            ComplexSelector: function ComplexSelector(t0, t1, t2, t3) {
                var _ = this;
                _.leadingCombinators = t0;
                _.components = t1;
                _.lineBreak = t2;
                _.__ComplexSelector_specificity_FI = $;
                _.span = t3;
            },
            ComplexSelector_specificity_closure: function ComplexSelector_specificity_closure() {},
            ComplexSelectorComponent: function ComplexSelectorComponent(t0, t1, t2) {
                this.selector = t0;
                this.combinators = t1;
                this.span = t2;
            },
            ComplexSelectorComponent_toString_closure: function ComplexSelectorComponent_toString_closure() {},
            CompoundSelector$: function(components, span) {
                var t1 = A.List_List$unmodifiable(components, type$.SimpleSelector);
                if (t1.length === 0) A.throwExpression(A.ArgumentError$("components may not be empty.", null));
                return new A.CompoundSelector(t1, span);
            },
            CompoundSelector: function CompoundSelector(t0, t1) {
                var _ = this;
                _.components = t0;
                _.__CompoundSelector_hasComplicatedSuperselectorSemantics_FI = _.__CompoundSelector_specificity_FI = $;
                _.span = t1;
            },
            CompoundSelector_specificity_closure: function CompoundSelector_specificity_closure() {},
            CompoundSelector_hasComplicatedSuperselectorSemantics_closure: function CompoundSelector_hasComplicatedSuperselectorSemantics_closure() {},
            IDSelector: function IDSelector(t0, t1) {
                this.name = t0;
                this.span = t1;
            },
            IDSelector_unify_closure: function IDSelector_unify_closure(t0) {
                this.$this = t0;
            },
            SelectorList$: function(components, span) {
                var t1 = A.List_List$unmodifiable(components, type$.ComplexSelector);
                if (t1.length === 0) A.throwExpression(A.ArgumentError$("components may not be empty.", null));
                return new A.SelectorList(t1, span);
            },
            SelectorList_SelectorList$parse: function(contents, allowParent, interpolationMap, logger, plainCss) {
                return A.SelectorParser$(contents, allowParent, interpolationMap, logger, plainCss, null).parse$0(0);
            },
            SelectorList: function SelectorList(t0, t1) {
                this.components = t0;
                this.span = t1;
            },
            SelectorList_asSassList_closure: function SelectorList_asSassList_closure() {},
            SelectorList_nestWithin_closure: function SelectorList_nestWithin_closure(t0, t1, t2, t3) {
                var _ = this;
                _.$this = t0;
                _.preserveParentSelectors = t1;
                _.implicitParent = t2;
                _.parent = t3;
            },
            SelectorList_nestWithin__closure: function SelectorList_nestWithin__closure(t0) {
                this.complex = t0;
            },
            SelectorList_nestWithin__closure0: function SelectorList_nestWithin__closure0(t0) {
                this.complex = t0;
            },
            SelectorList__nestWithinCompound_closure: function SelectorList__nestWithinCompound_closure() {},
            SelectorList__nestWithinCompound_closure0: function SelectorList__nestWithinCompound_closure0(t0) {
                this.parent = t0;
            },
            SelectorList__nestWithinCompound_closure1: function SelectorList__nestWithinCompound_closure1(t0, t1, t2) {
                this.parentSelector = t0;
                this.resolvedSimples = t1;
                this.component = t2;
            },
            SelectorList_withAdditionalCombinators_closure: function SelectorList_withAdditionalCombinators_closure(t0) {
                this.combinators = t0;
            },
            _ParentSelectorVisitor: function _ParentSelectorVisitor() {},
            __ParentSelectorVisitor_Object_SelectorSearchVisitor: function __ParentSelectorVisitor_Object_SelectorSearchVisitor() {},
            ParentSelector: function ParentSelector(t0, t1) {
                this.suffix = t0;
                this.span = t1;
            },
            PlaceholderSelector: function PlaceholderSelector(t0, t1) {
                this.name = t0;
                this.span = t1;
            },
            PseudoSelector$: function($name, span, argument, element, selector) {
                var t1 = !element, t2 = t1 && !A.PseudoSelector__isFakePseudoElement($name);
                return new A.PseudoSelector($name, A.unvendor($name), t2, t1, argument, selector, span);
            },
            PseudoSelector__isFakePseudoElement: function($name) {
                switch($name.charCodeAt(0)){
                    case 97:
                    case 65:
                        return A.equalsIgnoreCase($name, "after");
                    case 98:
                    case 66:
                        return A.equalsIgnoreCase($name, "before");
                    case 102:
                    case 70:
                        return A.equalsIgnoreCase($name, "first-line") || A.equalsIgnoreCase($name, "first-letter");
                    default:
                        return false;
                }
            },
            PseudoSelector: function PseudoSelector(t0, t1, t2, t3, t4, t5, t6) {
                var _ = this;
                _.name = t0;
                _.normalizedName = t1;
                _.isClass = t2;
                _.isSyntacticClass = t3;
                _.argument = t4;
                _.selector = t5;
                _.__PseudoSelector_specificity_FI = $;
                _.span = t6;
            },
            PseudoSelector_specificity_closure: function PseudoSelector_specificity_closure(t0) {
                this.$this = t0;
            },
            PseudoSelector_specificity__closure: function PseudoSelector_specificity__closure() {},
            PseudoSelector_specificity__closure0: function PseudoSelector_specificity__closure0() {},
            PseudoSelector_unify_closure: function PseudoSelector_unify_closure() {},
            QualifiedName: function QualifiedName(t0, t1) {
                this.name = t0;
                this.namespace = t1;
            },
            SimpleSelector: function SimpleSelector() {},
            SimpleSelector_isSuperselector_closure: function SimpleSelector_isSuperselector_closure(t0) {
                this.$this = t0;
            },
            SimpleSelector_isSuperselector__closure: function SimpleSelector_isSuperselector__closure(t0) {
                this.$this = t0;
            },
            TypeSelector: function TypeSelector(t0, t1) {
                this.name = t0;
                this.span = t1;
            },
            UniversalSelector: function UniversalSelector(t0, t1) {
                this.namespace = t0;
                this.span = t1;
            },
            compileAsync: function(path, charset, fatalDeprecations, futureDeprecations, importCache, logger, quietDeps, silenceDeprecations, sourceMap, style, syntax, verbose) {
                var $async$goto = 0, $async$completer = A._makeAsyncAwaitCompleter(type$.CompileResult), $async$returnValue, t3, t4, t0, stylesheet, result, t1, t2;
                var $async$compileAsync = A._wrapJsFunctionForAsync(function($async$errorCode, $async$result) {
                    if ($async$errorCode === 1) return A._asyncRethrow($async$result, $async$completer);
                    for(;;)switch($async$goto){
                        case 0:
                            // Function start
                            t1 = type$.Deprecation;
                            t2 = A.LinkedHashSet_LinkedHashSet$_empty(t1);
                            t2.addAll$1(0, silenceDeprecations);
                            t3 = A.LinkedHashSet_LinkedHashSet$_empty(t1);
                            t3.addAll$1(0, fatalDeprecations);
                            t4 = A.LinkedHashSet_LinkedHashSet$_empty(t1);
                            t4.addAll$1(0, futureDeprecations);
                            logger = new A.DeprecationProcessingLogger(A.LinkedHashMap_LinkedHashMap$_empty(t1, type$.int), logger, t2, t3, t4, !verbose);
                            logger.validate$0();
                            t1 = syntax === A.Syntax_forPath(path);
                            $async$goto = t1 ? 3 : 5;
                            break;
                        case 3:
                            // then
                            t1 = $.$get$FilesystemImporter_cwd();
                            t2 = A.isNodeJs() ? self.process : null;
                            if (!J.$eq$(t2 == null ? null : J.get$platform$x(t2), "win32")) {
                                t2 = A.isNodeJs() ? self.process : null;
                                t2 = J.$eq$(t2 == null ? null : J.get$platform$x(t2), "darwin");
                            } else t2 = true;
                            if (t2) {
                                t2 = A.absolute(path, null, null, null, null, null, null, null, null, null, null, null, null, null, null);
                                t3 = $.$get$context();
                                t2 = A._realCasePath(t3.normalize$1(t2));
                            } else {
                                t2 = $.$get$context();
                                t3 = t2.canonicalize$1(0, path);
                                t0 = t3;
                                t3 = t2;
                                t2 = t0;
                            }
                            $async$goto = 6;
                            return A._asyncAwait(importCache.importCanonical$3$originalUrl(t1, t3.toUri$1(t2), t3.toUri$1(path)), $async$compileAsync);
                        case 6:
                            // returning from await.
                            t3 = $async$result;
                            t3.toString;
                            stylesheet = t3;
                            // goto join
                            $async$goto = 4;
                            break;
                        case 5:
                            // else
                            t1 = A.readFile(path);
                            stylesheet = A.Stylesheet_Stylesheet$parse(t1, syntax, false, $.$get$context().toUri$1(path));
                        case 4:
                            // join
                            $async$goto = 7;
                            return A._asyncAwait(A._compileStylesheet0(stylesheet, logger, importCache, null, $.$get$FilesystemImporter_cwd(), null, style, true, null, null, quietDeps, sourceMap, charset), $async$compileAsync);
                        case 7:
                            // returning from await.
                            result = $async$result;
                            logger.summarize$1$js(false);
                            $async$returnValue = result;
                            // goto return
                            $async$goto = 1;
                            break;
                        case 1:
                            // return
                            return A._asyncReturn($async$returnValue, $async$completer);
                    }
                });
                return A._asyncStartSync($async$compileAsync, $async$completer);
            },
            compileStringAsync: function(source, charset, fatalDeprecations, futureDeprecations, importCache, importer, logger, quietDeps, silenceDeprecations, sourceMap, style, syntax, verbose) {
                var $async$goto = 0, $async$completer = A._makeAsyncAwaitCompleter(type$.CompileResult), $async$returnValue, t3, t4, stylesheet, _0_0, result, t1, t2;
                var $async$compileStringAsync = A._wrapJsFunctionForAsync(function($async$errorCode, $async$result) {
                    if ($async$errorCode === 1) return A._asyncRethrow($async$result, $async$completer);
                    for(;;)switch($async$goto){
                        case 0:
                            // Function start
                            t1 = type$.Deprecation;
                            t2 = A.LinkedHashSet_LinkedHashSet$_empty(t1);
                            t2.addAll$1(0, silenceDeprecations);
                            t3 = A.LinkedHashSet_LinkedHashSet$_empty(t1);
                            t3.addAll$1(0, fatalDeprecations);
                            t4 = A.LinkedHashSet_LinkedHashSet$_empty(t1);
                            t4.addAll$1(0, futureDeprecations);
                            logger = new A.DeprecationProcessingLogger(A.LinkedHashMap_LinkedHashMap$_empty(t1, type$.int), logger, t2, t3, t4, !verbose);
                            logger.validate$0();
                            stylesheet = A.Stylesheet_Stylesheet$parse(source, syntax, false, null);
                            t1 = stylesheet.span;
                            _0_0 = t1.get$sourceUrl(t1);
                            if (type$.Uri._is(_0_0)) t2 = "" === _0_0.get$scheme();
                            else t2 = false;
                            if (t2) A.WarnForDeprecation_warnForDeprecation(logger, B.Deprecation_r8S, "Passing a relative `url` argument (" + A.S(t1.get$sourceUrl(t1)) + string$.x29x20to_cm, null, null);
                            $async$goto = 3;
                            return A._asyncAwait(A._compileStylesheet0(stylesheet, logger, importCache, null, importer, null, style, true, null, null, quietDeps, sourceMap, charset), $async$compileStringAsync);
                        case 3:
                            // returning from await.
                            result = $async$result;
                            logger.summarize$1$js(false);
                            $async$returnValue = result;
                            // goto return
                            $async$goto = 1;
                            break;
                        case 1:
                            // return
                            return A._asyncReturn($async$returnValue, $async$completer);
                    }
                });
                return A._asyncStartSync($async$compileStringAsync, $async$completer);
            },
            _compileStylesheet0: function(stylesheet, logger, importCache, nodeImporter, importer, functions, style, useSpaces, indentWidth, lineFeed, quietDeps, sourceMap, charset) {
                var $async$goto = 0, $async$completer = A._makeAsyncAwaitCompleter(type$.CompileResult), $async$returnValue, serializeResult, resultSourceMap, $async$temp1;
                var $async$_compileStylesheet0 = A._wrapJsFunctionForAsync(function($async$errorCode, $async$result) {
                    if ($async$errorCode === 1) return A._asyncRethrow($async$result, $async$completer);
                    for(;;)switch($async$goto){
                        case 0:
                            // Function start
                            $async$temp1 = A;
                            $async$goto = 3;
                            return A._asyncAwait(A._EvaluateVisitor$0(functions, importCache, logger, nodeImporter, quietDeps, sourceMap).run$2(0, importer, stylesheet), $async$_compileStylesheet0);
                        case 3:
                            // returning from await.
                            serializeResult = $async$temp1.serialize($async$result._1, charset, indentWidth, false, lineFeed, logger, sourceMap, style, true);
                            resultSourceMap = serializeResult._1;
                            if (resultSourceMap != null) A.mapInPlace(resultSourceMap.urls, new A._compileStylesheet_closure0(stylesheet, importCache));
                            $async$returnValue = new A.CompileResult(serializeResult);
                            // goto return
                            $async$goto = 1;
                            break;
                        case 1:
                            // return
                            return A._asyncReturn($async$returnValue, $async$completer);
                    }
                });
                return A._asyncStartSync($async$_compileStylesheet0, $async$completer);
            },
            _compileStylesheet_closure0: function _compileStylesheet_closure0(t0, t1) {
                this.stylesheet = t0;
                this.importCache = t1;
            },
            AsyncEnvironment$: function() {
                var t1 = type$.String, t2 = type$.Module_AsyncCallable, t3 = type$.AstNode, t4 = type$.int, t5 = type$.AsyncCallable, t6 = type$.JSArray_Map_String_AsyncCallable;
                return new A.AsyncEnvironment(A.LinkedHashMap_LinkedHashMap$_empty(t1, t2), A.LinkedHashMap_LinkedHashMap$_empty(t1, t3), A.LinkedHashMap_LinkedHashMap$_empty(t2, t3), A.LinkedHashMap_LinkedHashMap$_empty(t2, t3), null, null, A._setArrayType([], type$.JSArray_Module_AsyncCallable), A._setArrayType([
                    A.LinkedHashMap_LinkedHashMap$_empty(t1, type$.Value)
                ], type$.JSArray_Map_String_Value), A._setArrayType([
                    A.LinkedHashMap_LinkedHashMap$_empty(t1, t3)
                ], type$.JSArray_Map_String_AstNode), A.LinkedHashMap_LinkedHashMap$_empty(t1, t4), A._setArrayType([
                    A.LinkedHashMap_LinkedHashMap$_empty(t1, t5)
                ], t6), A.LinkedHashMap_LinkedHashMap$_empty(t1, t4), A._setArrayType([
                    A.LinkedHashMap_LinkedHashMap$_empty(t1, t5)
                ], t6), A.LinkedHashMap_LinkedHashMap$_empty(t1, t4), null, A.LinkedHashSet_LinkedHashSet$_empty(t1));
            },
            AsyncEnvironment$_: function(_modules, _namespaceNodes, _globalModules, _importedModules, _forwardedModules, _nestedForwardedModules, _allModules, _variables, _variableNodes, _functions, _mixins, _content, _configurableVariables) {
                var t1 = type$.String, t2 = type$.int;
                return new A.AsyncEnvironment(_modules, _namespaceNodes, _globalModules, _importedModules, _forwardedModules, _nestedForwardedModules, _allModules, _variables, _variableNodes, A.LinkedHashMap_LinkedHashMap$_empty(t1, t2), _functions, A.LinkedHashMap_LinkedHashMap$_empty(t1, t2), _mixins, A.LinkedHashMap_LinkedHashMap$_empty(t1, t2), _content, _configurableVariables);
            },
            _EnvironmentModule__EnvironmentModule0: function(environment, css, preModuleComments, extensionStore, forwarded) {
                var t1, t2, t3, t4, t5, t6, module, result, t7;
                if (forwarded == null) forwarded = B.Set_empty3;
                t1 = type$.dynamic;
                t1 = A.LinkedHashMap_LinkedHashMap$_empty(t1, t1);
                for(t2 = type$.Module_AsyncCallable, t3 = type$.List_CssComment, t4 = A.MapExtensions_get_pairs(preModuleComments, t2, t3), t4 = t4.get$iterator(t4), t5 = type$.CssComment; t4.moveNext$0();){
                    t6 = t4.get$current(t4);
                    module = t6._0;
                    result = A.List_List$from(t6._1, false, t5);
                    result.$flags = 3;
                    t1.$indexSet(0, module, result);
                }
                t1 = A.ConstantMap_ConstantMap$from(t1, t2, t3);
                t2 = A._EnvironmentModule__makeModulesByVariable0(forwarded);
                t3 = A._EnvironmentModule__memberMap0(B.JSArray_methods.get$first(environment._async_environment$_variables), forwarded.map$1$1(0, new A._EnvironmentModule__EnvironmentModule_closure5(), type$.Map_String_Value), type$.Value);
                t4 = A._EnvironmentModule__memberMap0(B.JSArray_methods.get$first(environment._async_environment$_variableNodes), forwarded.map$1$1(0, new A._EnvironmentModule__EnvironmentModule_closure6(), type$.Map_String_AstNode), type$.AstNode);
                t5 = type$.Map_String_AsyncCallable;
                t6 = type$.AsyncCallable;
                t7 = A._EnvironmentModule__memberMap0(B.JSArray_methods.get$first(environment._async_environment$_functions), forwarded.map$1$1(0, new A._EnvironmentModule__EnvironmentModule_closure7(), t5), t6);
                t6 = A._EnvironmentModule__memberMap0(B.JSArray_methods.get$first(environment._async_environment$_mixins), forwarded.map$1$1(0, new A._EnvironmentModule__EnvironmentModule_closure8(), t5), t6);
                t5 = J.get$isNotEmpty$asx(css.get$children(css)) || preModuleComments.get$isNotEmpty(preModuleComments) || B.JSArray_methods.any$1(environment._async_environment$_allModules, new A._EnvironmentModule__EnvironmentModule_closure9());
                return A._EnvironmentModule$_0(environment, css, t1, extensionStore, t2, t3, t4, t7, t6, t5, !extensionStore.get$isEmpty(extensionStore) || B.JSArray_methods.any$1(environment._async_environment$_allModules, new A._EnvironmentModule__EnvironmentModule_closure10()));
            },
            _EnvironmentModule__makeModulesByVariable0: function(forwarded) {
                var modulesByVariable, t1, t2, t3, t4, t5;
                if (forwarded.get$isEmpty(forwarded)) return B.Map_empty8;
                modulesByVariable = A.LinkedHashMap_LinkedHashMap$_empty(type$.String, type$.Module_AsyncCallable);
                for(t1 = forwarded.get$iterator(forwarded); t1.moveNext$0();){
                    t2 = t1.get$current(t1);
                    if (t2 instanceof A._EnvironmentModule0) {
                        for(t3 = t2._async_environment$_modulesByVariable, t3 = t3.get$values(t3), t3 = t3.get$iterator(t3); t3.moveNext$0();){
                            t4 = t3.get$current(t3);
                            t5 = t4.get$variables();
                            A.setAll(modulesByVariable, t5.get$keys(t5), t4);
                        }
                        t3 = B.JSArray_methods.get$first(t2._async_environment$_environment._async_environment$_variables);
                        A.setAll(modulesByVariable, t3.get$keys(t3), t2);
                    } else {
                        t3 = t2.get$variables();
                        A.setAll(modulesByVariable, t3.get$keys(t3), t2);
                    }
                }
                return modulesByVariable;
            },
            _EnvironmentModule__memberMap0: function(localMap, otherMaps, $V) {
                var t1, t2, t3;
                localMap = new A.PublicMemberMapView(localMap, $V._eval$1("PublicMemberMapView<0>"));
                if (otherMaps.get$isEmpty(otherMaps)) return localMap;
                t1 = A._setArrayType([], $V._eval$1("JSArray<Map<String,0>>"));
                for(t2 = otherMaps.get$iterator(otherMaps); t2.moveNext$0();){
                    t3 = t2.get$current(t2);
                    if (t3.get$isNotEmpty(t3)) t1.push(t3);
                }
                t1.push(localMap);
                if (t1.length === 1) return localMap;
                return A.MergedMapView$(t1, type$.String, $V);
            },
            _EnvironmentModule$_0: function(_environment, css, preModuleComments, extensionStore, _modulesByVariable, variables, variableNodes, functions, mixins, transitivelyContainsCss, transitivelyContainsExtensions) {
                return new A._EnvironmentModule0(_environment._async_environment$_allModules, variables, variableNodes, functions, mixins, extensionStore, css, preModuleComments, transitivelyContainsCss, transitivelyContainsExtensions, _environment, _modulesByVariable);
            },
            AsyncEnvironment: function AsyncEnvironment(t0, t1, t2, t3, t4, t5, t6, t7, t8, t9, t10, t11, t12, t13, t14, t15) {
                var _ = this;
                _._async_environment$_modules = t0;
                _._async_environment$_namespaceNodes = t1;
                _._async_environment$_globalModules = t2;
                _._async_environment$_importedModules = t3;
                _._async_environment$_forwardedModules = t4;
                _._async_environment$_nestedForwardedModules = t5;
                _._async_environment$_allModules = t6;
                _._async_environment$_variables = t7;
                _._async_environment$_variableNodes = t8;
                _._async_environment$_variableIndices = t9;
                _._async_environment$_functions = t10;
                _._async_environment$_functionIndices = t11;
                _._async_environment$_mixins = t12;
                _._async_environment$_mixinIndices = t13;
                _._async_environment$_content = t14;
                _._async_environment$_configurableVariables = t15;
                _._async_environment$_inMixin = false;
                _._async_environment$_inSemiGlobalScope = true;
                _._async_environment$_lastVariableIndex = _._async_environment$_lastVariableName = null;
            },
            AsyncEnvironment__getVariableFromGlobalModule_closure: function AsyncEnvironment__getVariableFromGlobalModule_closure(t0) {
                this.name = t0;
            },
            AsyncEnvironment_setVariable_closure: function AsyncEnvironment_setVariable_closure(t0, t1) {
                this.$this = t0;
                this.name = t1;
            },
            AsyncEnvironment_setVariable_closure0: function AsyncEnvironment_setVariable_closure0(t0) {
                this.name = t0;
            },
            AsyncEnvironment_setVariable_closure1: function AsyncEnvironment_setVariable_closure1(t0, t1) {
                this.$this = t0;
                this.name = t1;
            },
            AsyncEnvironment__getFunctionFromGlobalModule_closure: function AsyncEnvironment__getFunctionFromGlobalModule_closure(t0) {
                this.name = t0;
            },
            AsyncEnvironment__getMixinFromGlobalModule_closure: function AsyncEnvironment__getMixinFromGlobalModule_closure(t0) {
                this.name = t0;
            },
            AsyncEnvironment_toModule_closure: function AsyncEnvironment_toModule_closure() {},
            AsyncEnvironment_toDummyModule_closure: function AsyncEnvironment_toDummyModule_closure() {},
            _EnvironmentModule0: function _EnvironmentModule0(t0, t1, t2, t3, t4, t5, t6, t7, t8, t9, t10, t11) {
                var _ = this;
                _.upstream = t0;
                _.variables = t1;
                _.variableNodes = t2;
                _.functions = t3;
                _.mixins = t4;
                _.extensionStore = t5;
                _.css = t6;
                _.preModuleComments = t7;
                _.transitivelyContainsCss = t8;
                _.transitivelyContainsExtensions = t9;
                _._async_environment$_environment = t10;
                _._async_environment$_modulesByVariable = t11;
            },
            _EnvironmentModule__EnvironmentModule_closure5: function _EnvironmentModule__EnvironmentModule_closure5() {},
            _EnvironmentModule__EnvironmentModule_closure6: function _EnvironmentModule__EnvironmentModule_closure6() {},
            _EnvironmentModule__EnvironmentModule_closure7: function _EnvironmentModule__EnvironmentModule_closure7() {},
            _EnvironmentModule__EnvironmentModule_closure8: function _EnvironmentModule__EnvironmentModule_closure8() {},
            _EnvironmentModule__EnvironmentModule_closure9: function _EnvironmentModule__EnvironmentModule_closure9() {},
            _EnvironmentModule__EnvironmentModule_closure10: function _EnvironmentModule__EnvironmentModule_closure10() {},
            _EnvironmentModule_couldHaveBeenConfigured_closure0: function _EnvironmentModule_couldHaveBeenConfigured_closure0(t0) {
                this.variables = t0;
            },
            AsyncImportCache__toImporters: function(importers, loadPaths, packageConfig) {
                var t1, t2, t3, t4, _i, path, _null = null, sassPath = A.getEnvironmentVariable("SASS_PATH");
                if (A.isBrowser()) {
                    t1 = A._setArrayType([], type$.JSArray_AsyncImporter_2);
                    B.JSArray_methods.addAll$1(t1, importers);
                    return t1;
                }
                t1 = A._setArrayType([], type$.JSArray_AsyncImporter_2);
                B.JSArray_methods.addAll$1(t1, importers);
                for(t2 = J.get$iterator$ax(loadPaths); t2.moveNext$0();){
                    t3 = t2.get$current(t2);
                    t1.push(new A.FilesystemImporter($.$get$context().absolute$15(t3, _null, _null, _null, _null, _null, _null, _null, _null, _null, _null, _null, _null, _null, _null), false));
                }
                if (sassPath != null) {
                    t2 = A.isNodeJs() ? self.process : _null;
                    t3 = sassPath.split(J.$eq$(t2 == null ? _null : J.get$platform$x(t2), "win32") ? ";" : ":");
                    t4 = t3.length;
                    _i = 0;
                    for(; _i < t4; ++_i){
                        path = t3[_i];
                        t1.push(new A.FilesystemImporter($.$get$context().absolute$15(path, _null, _null, _null, _null, _null, _null, _null, _null, _null, _null, _null, _null, _null, _null), false));
                    }
                }
                return t1;
            },
            AsyncImportCache: function AsyncImportCache(t0, t1, t2, t3, t4, t5, t6) {
                var _ = this;
                _._async_import_cache$_importers = t0;
                _._async_import_cache$_canonicalizeCache = t1;
                _._async_import_cache$_perImporterCanonicalizeCache = t2;
                _._async_import_cache$_nonCanonicalRelativeUrls = t3;
                _._async_import_cache$_importCache = t4;
                _._async_import_cache$_resultsCache = t5;
                _._async_import_cache$_loadTimes = t6;
            },
            AsyncImportCache_canonicalize_closure: function AsyncImportCache_canonicalize_closure(t0, t1, t2, t3, t4, t5, t6) {
                var _ = this;
                _.$this = t0;
                _.baseImporter = t1;
                _.resolvedUrl = t2;
                _.baseUrl = t3;
                _.forImport = t4;
                _.key = t5;
                _.url = t6;
            },
            AsyncImportCache__canonicalize_closure: function AsyncImportCache__canonicalize_closure(t0, t1) {
                this.importer = t0;
                this.url = t1;
            },
            AsyncImportCache_importCanonical_closure: function AsyncImportCache_importCanonical_closure(t0, t1, t2, t3) {
                var _ = this;
                _.$this = t0;
                _.importer = t1;
                _.canonicalUrl = t2;
                _.originalUrl = t3;
            },
            AsyncImportCache_humanize_closure: function AsyncImportCache_humanize_closure(t0) {
                this.canonicalUrl = t0;
            },
            AsyncImportCache_humanize_closure0: function AsyncImportCache_humanize_closure0() {},
            AsyncImportCache_humanize_closure1: function AsyncImportCache_humanize_closure1() {},
            AsyncImportCache_humanize_closure2: function AsyncImportCache_humanize_closure2(t0) {
                this.canonicalUrl = t0;
            },
            AsyncBuiltInCallable$mixin: function($name, parameters, callback, acceptsContent, url) {
                return new A.AsyncBuiltInCallable($name, A.ScssParser$("@mixin " + $name + "(" + parameters + ") {", false, url).parseParameterList$0(), new A.AsyncBuiltInCallable$mixin_closure(callback), false);
            },
            AsyncBuiltInCallable: function AsyncBuiltInCallable(t0, t1, t2, t3) {
                var _ = this;
                _.name = t0;
                _._parameters = t1;
                _._async_built_in$_callback = t2;
                _.acceptsContent = t3;
            },
            AsyncBuiltInCallable$mixin_closure: function AsyncBuiltInCallable$mixin_closure(t0) {
                this.callback = t0;
            },
            AsyncBuiltInCallable_withDeprecationWarning_closure: function AsyncBuiltInCallable_withDeprecationWarning_closure(t0, t1, t2) {
                this.$this = t0;
                this.module = t1;
                this.newName = t2;
            },
            BuiltInCallable$function: function($name, parameters, callback, url) {
                return new A.BuiltInCallable($name, A._setArrayType([
                    new A._Record_2(A.ScssParser$("@function " + $name + "(" + parameters + ") {", false, url).parseParameterList$0(), callback)
                ], type$.JSArray_Record_2_ParameterList_and_Value_Function_List_Value), false);
            },
            BuiltInCallable$mixin: function($name, parameters, callback, acceptsContent, url) {
                return new A.BuiltInCallable($name, A._setArrayType([
                    new A._Record_2(A.ScssParser$("@mixin " + $name + "(" + parameters + ") {", false, url).parseParameterList$0(), new A.BuiltInCallable$mixin_closure(callback))
                ], type$.JSArray_Record_2_ParameterList_and_Value_Function_List_Value), acceptsContent);
            },
            BuiltInCallable$overloadedFunction: function($name, overloads) {
                var t2, t3, t4, t5, t6, t7, args, callback, t1 = A._setArrayType([], type$.JSArray_Record_2_ParameterList_and_Value_Function_List_Value);
                for(t2 = type$.String, t3 = A.MapExtensions_get_pairs(overloads, t2, type$.Value_Function_List_Value), t3 = t3.get$iterator(t3), t4 = "@function " + $name + "(", t5 = type$.FileSpan, t6 = type$.JSArray_Record_3_nullable_Deprecation_deprecation_and_String_message_and_FileSpan_span; t3.moveNext$0();){
                    t7 = t3.get$current(t3);
                    args = t7._0;
                    callback = t7._1;
                    t1.push(new A._Record_2(new A.ScssParser(false, A.LinkedHashMap_LinkedHashMap$_empty(t2, t5), A._setArrayType([], t6), A.SpanScanner$(t4 + args + ") {", null), null).parseParameterList$0(), callback));
                }
                return new A.BuiltInCallable($name, t1, false);
            },
            BuiltInCallable: function BuiltInCallable(t0, t1, t2) {
                this.name = t0;
                this._overloads = t1;
                this.acceptsContent = t2;
            },
            BuiltInCallable$mixin_closure: function BuiltInCallable$mixin_closure(t0) {
                this.callback = t0;
            },
            BuiltInCallable_withDeprecationWarning_closure: function BuiltInCallable_withDeprecationWarning_closure(t0, t1, t2, t3) {
                var _ = this;
                _._box_0 = t0;
                _.$this = t1;
                _.module = t2;
                _.newName = t3;
            },
            PlainCssCallable: function PlainCssCallable(t0) {
                this.name = t0;
            },
            UserDefinedCallable: function UserDefinedCallable(t0, t1, t2, t3) {
                var _ = this;
                _.declaration = t0;
                _.environment = t1;
                _.inDependency = t2;
                _.$ti = t3;
            },
            _compileStylesheet: function(stylesheet, logger, importCache, nodeImporter, importer, functions, style, useSpaces, indentWidth, lineFeed, quietDeps, sourceMap, charset) {
                var serializeResult = A.serialize(A._EvaluateVisitor$(functions, importCache, logger, nodeImporter, quietDeps, sourceMap).run$2(0, importer, stylesheet)._1, charset, indentWidth, false, lineFeed, logger, sourceMap, style, true), resultSourceMap = serializeResult._1;
                if (resultSourceMap != null) A.mapInPlace(resultSourceMap.urls, new A._compileStylesheet_closure(stylesheet, importCache));
                return new A.CompileResult(serializeResult);
            },
            _compileStylesheet_closure: function _compileStylesheet_closure(t0, t1) {
                this.stylesheet = t0;
                this.importCache = t1;
            },
            CompileResult: function CompileResult(t0) {
                this._serialize = t0;
            },
            Configuration: function Configuration(t0, t1) {
                this._configuration$_values = t0;
                this.__originalConfiguration = t1;
            },
            ExplicitConfiguration: function ExplicitConfiguration(t0, t1, t2) {
                this.nodeWithSpan = t0;
                this._configuration$_values = t1;
                this.__originalConfiguration = t2;
            },
            ConfiguredValue: function ConfiguredValue(t0, t1, t2) {
                this.value = t0;
                this.configurationSpan = t1;
                this.assignmentNode = t2;
            },
            Deprecation_fromId: function(id) {
                return A.IterableExtension_firstWhereOrNull(B.List_bLL, new A.Deprecation_fromId_closure(id));
            },
            Deprecation_forVersion: function(version1) {
                var t2, _i, deprecation, $self, t3, t1 = A.LinkedHashSet_LinkedHashSet$_empty(type$.Deprecation);
                for(t2 = A.VersionRange_VersionRange(true, version1).get$allows(), _i = 0; _i < 31; ++_i){
                    deprecation = B.List_bLL[_i];
                    $self = deprecation._deprecatedIn;
                    t3 = $self == null ? null : A.Version___parse_tearOff($self);
                    t3 = t3 == null ? null : t2.call$1(t3);
                    if (t3 == null ? false : t3) {
                        $self = deprecation._obsoleteIn;
                        if ($self == null) t3 = null;
                        else t3 = A.Version___parse_tearOff($self);
                        t3 = t3 == null;
                    } else t3 = false;
                    if (t3) t1.add$1(0, deprecation);
                }
                return t1;
            },
            Deprecation: function Deprecation(t0, t1, t2, t3, t4) {
                var _ = this;
                _.id = t0;
                _._deprecatedIn = t1;
                _._obsoleteIn = t2;
                _.index = t3;
                _._name = t4;
            },
            Deprecation_fromId_closure: function Deprecation_fromId_closure(t0) {
                this.id = t0;
            },
            Environment$: function() {
                var t1 = type$.String, t2 = type$.Module_Callable, t3 = type$.AstNode, t4 = type$.int, t5 = type$.Callable, t6 = type$.JSArray_Map_String_Callable;
                return new A.Environment(A.LinkedHashMap_LinkedHashMap$_empty(t1, t2), A.LinkedHashMap_LinkedHashMap$_empty(t1, t3), A.LinkedHashMap_LinkedHashMap$_empty(t2, t3), A.LinkedHashMap_LinkedHashMap$_empty(t2, t3), null, null, A._setArrayType([], type$.JSArray_Module_Callable), A._setArrayType([
                    A.LinkedHashMap_LinkedHashMap$_empty(t1, type$.Value)
                ], type$.JSArray_Map_String_Value), A._setArrayType([
                    A.LinkedHashMap_LinkedHashMap$_empty(t1, t3)
                ], type$.JSArray_Map_String_AstNode), A.LinkedHashMap_LinkedHashMap$_empty(t1, t4), A._setArrayType([
                    A.LinkedHashMap_LinkedHashMap$_empty(t1, t5)
                ], t6), A.LinkedHashMap_LinkedHashMap$_empty(t1, t4), A._setArrayType([
                    A.LinkedHashMap_LinkedHashMap$_empty(t1, t5)
                ], t6), A.LinkedHashMap_LinkedHashMap$_empty(t1, t4), null, A.LinkedHashSet_LinkedHashSet$_empty(t1));
            },
            Environment$_: function(_modules, _namespaceNodes, _globalModules, _importedModules, _forwardedModules, _nestedForwardedModules, _allModules, _variables, _variableNodes, _functions, _mixins, _content, _configurableVariables) {
                var t1 = type$.String, t2 = type$.int;
                return new A.Environment(_modules, _namespaceNodes, _globalModules, _importedModules, _forwardedModules, _nestedForwardedModules, _allModules, _variables, _variableNodes, A.LinkedHashMap_LinkedHashMap$_empty(t1, t2), _functions, A.LinkedHashMap_LinkedHashMap$_empty(t1, t2), _mixins, A.LinkedHashMap_LinkedHashMap$_empty(t1, t2), _content, _configurableVariables);
            },
            _EnvironmentModule__EnvironmentModule: function(environment, css, preModuleComments, extensionStore, forwarded) {
                var t1, t2, t3, t4, t5, t6, module, result, t7;
                if (forwarded == null) forwarded = B.Set_empty0;
                t1 = type$.dynamic;
                t1 = A.LinkedHashMap_LinkedHashMap$_empty(t1, t1);
                for(t2 = type$.Module_Callable, t3 = type$.List_CssComment, t4 = A.MapExtensions_get_pairs(preModuleComments, t2, t3), t4 = t4.get$iterator(t4), t5 = type$.CssComment; t4.moveNext$0();){
                    t6 = t4.get$current(t4);
                    module = t6._0;
                    result = A.List_List$from(t6._1, false, t5);
                    result.$flags = 3;
                    t1.$indexSet(0, module, result);
                }
                t1 = A.ConstantMap_ConstantMap$from(t1, t2, t3);
                t2 = A._EnvironmentModule__makeModulesByVariable(forwarded);
                t3 = A._EnvironmentModule__memberMap(B.JSArray_methods.get$first(environment._variables), forwarded.map$1$1(0, new A._EnvironmentModule__EnvironmentModule_closure(), type$.Map_String_Value), type$.Value);
                t4 = A._EnvironmentModule__memberMap(B.JSArray_methods.get$first(environment._variableNodes), forwarded.map$1$1(0, new A._EnvironmentModule__EnvironmentModule_closure0(), type$.Map_String_AstNode), type$.AstNode);
                t5 = type$.Map_String_Callable;
                t6 = type$.Callable;
                t7 = A._EnvironmentModule__memberMap(B.JSArray_methods.get$first(environment._functions), forwarded.map$1$1(0, new A._EnvironmentModule__EnvironmentModule_closure1(), t5), t6);
                t6 = A._EnvironmentModule__memberMap(B.JSArray_methods.get$first(environment._mixins), forwarded.map$1$1(0, new A._EnvironmentModule__EnvironmentModule_closure2(), t5), t6);
                t5 = J.get$isNotEmpty$asx(css.get$children(css)) || preModuleComments.get$isNotEmpty(preModuleComments) || B.JSArray_methods.any$1(environment._allModules, new A._EnvironmentModule__EnvironmentModule_closure3());
                return A._EnvironmentModule$_(environment, css, t1, extensionStore, t2, t3, t4, t7, t6, t5, !extensionStore.get$isEmpty(extensionStore) || B.JSArray_methods.any$1(environment._allModules, new A._EnvironmentModule__EnvironmentModule_closure4()));
            },
            _EnvironmentModule__makeModulesByVariable: function(forwarded) {
                var modulesByVariable, t1, t2, t3, t4, t5;
                if (forwarded.get$isEmpty(forwarded)) return B.Map_empty0;
                modulesByVariable = A.LinkedHashMap_LinkedHashMap$_empty(type$.String, type$.Module_Callable);
                for(t1 = forwarded.get$iterator(forwarded); t1.moveNext$0();){
                    t2 = t1.get$current(t1);
                    if (t2 instanceof A._EnvironmentModule) {
                        for(t3 = t2._modulesByVariable, t3 = t3.get$values(t3), t3 = t3.get$iterator(t3); t3.moveNext$0();){
                            t4 = t3.get$current(t3);
                            t5 = t4.get$variables();
                            A.setAll(modulesByVariable, t5.get$keys(t5), t4);
                        }
                        t3 = B.JSArray_methods.get$first(t2._environment$_environment._variables);
                        A.setAll(modulesByVariable, t3.get$keys(t3), t2);
                    } else {
                        t3 = t2.get$variables();
                        A.setAll(modulesByVariable, t3.get$keys(t3), t2);
                    }
                }
                return modulesByVariable;
            },
            _EnvironmentModule__memberMap: function(localMap, otherMaps, $V) {
                var t1, t2, t3;
                localMap = new A.PublicMemberMapView(localMap, $V._eval$1("PublicMemberMapView<0>"));
                if (otherMaps.get$isEmpty(otherMaps)) return localMap;
                t1 = A._setArrayType([], $V._eval$1("JSArray<Map<String,0>>"));
                for(t2 = otherMaps.get$iterator(otherMaps); t2.moveNext$0();){
                    t3 = t2.get$current(t2);
                    if (t3.get$isNotEmpty(t3)) t1.push(t3);
                }
                t1.push(localMap);
                if (t1.length === 1) return localMap;
                return A.MergedMapView$(t1, type$.String, $V);
            },
            _EnvironmentModule$_: function(_environment, css, preModuleComments, extensionStore, _modulesByVariable, variables, variableNodes, functions, mixins, transitivelyContainsCss, transitivelyContainsExtensions) {
                return new A._EnvironmentModule(_environment._allModules, variables, variableNodes, functions, mixins, extensionStore, css, preModuleComments, transitivelyContainsCss, transitivelyContainsExtensions, _environment, _modulesByVariable);
            },
            Environment: function Environment(t0, t1, t2, t3, t4, t5, t6, t7, t8, t9, t10, t11, t12, t13, t14, t15) {
                var _ = this;
                _._environment$_modules = t0;
                _._namespaceNodes = t1;
                _._globalModules = t2;
                _._importedModules = t3;
                _._forwardedModules = t4;
                _._nestedForwardedModules = t5;
                _._allModules = t6;
                _._variables = t7;
                _._variableNodes = t8;
                _._variableIndices = t9;
                _._functions = t10;
                _._functionIndices = t11;
                _._mixins = t12;
                _._mixinIndices = t13;
                _._content = t14;
                _._configurableVariables = t15;
                _._inMixin = false;
                _._inSemiGlobalScope = true;
                _._lastVariableIndex = _._lastVariableName = null;
            },
            Environment__getVariableFromGlobalModule_closure: function Environment__getVariableFromGlobalModule_closure(t0) {
                this.name = t0;
            },
            Environment_setVariable_closure: function Environment_setVariable_closure(t0, t1) {
                this.$this = t0;
                this.name = t1;
            },
            Environment_setVariable_closure0: function Environment_setVariable_closure0(t0) {
                this.name = t0;
            },
            Environment_setVariable_closure1: function Environment_setVariable_closure1(t0, t1) {
                this.$this = t0;
                this.name = t1;
            },
            Environment__getFunctionFromGlobalModule_closure: function Environment__getFunctionFromGlobalModule_closure(t0) {
                this.name = t0;
            },
            Environment__getMixinFromGlobalModule_closure: function Environment__getMixinFromGlobalModule_closure(t0) {
                this.name = t0;
            },
            Environment_toModule_closure: function Environment_toModule_closure() {},
            Environment_toDummyModule_closure: function Environment_toDummyModule_closure() {},
            _EnvironmentModule: function _EnvironmentModule(t0, t1, t2, t3, t4, t5, t6, t7, t8, t9, t10, t11) {
                var _ = this;
                _.upstream = t0;
                _.variables = t1;
                _.variableNodes = t2;
                _.functions = t3;
                _.mixins = t4;
                _.extensionStore = t5;
                _.css = t6;
                _.preModuleComments = t7;
                _.transitivelyContainsCss = t8;
                _.transitivelyContainsExtensions = t9;
                _._environment$_environment = t10;
                _._modulesByVariable = t11;
            },
            _EnvironmentModule__EnvironmentModule_closure: function _EnvironmentModule__EnvironmentModule_closure() {},
            _EnvironmentModule__EnvironmentModule_closure0: function _EnvironmentModule__EnvironmentModule_closure0() {},
            _EnvironmentModule__EnvironmentModule_closure1: function _EnvironmentModule__EnvironmentModule_closure1() {},
            _EnvironmentModule__EnvironmentModule_closure2: function _EnvironmentModule__EnvironmentModule_closure2() {},
            _EnvironmentModule__EnvironmentModule_closure3: function _EnvironmentModule__EnvironmentModule_closure3() {},
            _EnvironmentModule__EnvironmentModule_closure4: function _EnvironmentModule__EnvironmentModule_closure4() {},
            _EnvironmentModule_couldHaveBeenConfigured_closure: function _EnvironmentModule_couldHaveBeenConfigured_closure(t0) {
                this.variables = t0;
            },
            EvaluationContext_currentOrNull: function() {
                var t1, _0_0 = $.Zone__current.$index(0, B.Symbol__evaluationContext);
                $label0$0: {
                    if (_0_0 instanceof A.EvaluationContext) {
                        t1 = _0_0;
                        break $label0$0;
                    }
                    t1 = null;
                    break $label0$0;
                }
                return t1;
            },
            warn: function(message) {
                var t1, _null = null, _0_0 = A.EvaluationContext_currentOrNull();
                $label0$0: {
                    if (_0_0 != null) {
                        t1 = _0_0.warn$2(0, message, _null);
                        break $label0$0;
                    }
                    B.C_DefaultLogger.internalWarn$4$deprecation$span$trace(message, _null, _null, _null);
                    t1 = _null;
                    break $label0$0;
                }
                return t1;
            },
            warnForDeprecation: function(message, deprecation) {
                var t1, _0_0 = A.EvaluationContext_currentOrNull();
                $label0$0: {
                    if (_0_0 != null) {
                        t1 = _0_0.warn$2(0, message, deprecation);
                        break $label0$0;
                    }
                    t1 = A.WarnForDeprecation_warnForDeprecation(B.C_DefaultLogger, deprecation, message, null, null);
                    break $label0$0;
                }
                return t1;
            },
            EvaluationContext: function EvaluationContext() {},
            _EvaluationContextLogger: function _EvaluationContextLogger(t0) {
                this._evaluation_context$_context = t0;
            },
            SassException$: function(message, span, loadedUrls) {
                return new A.SassException(loadedUrls == null ? B.Set_empty : A.Set_Set$unmodifiable(loadedUrls, type$.Uri), message, span);
            },
            MultiSpanSassException$: function(message, span, primaryLabel, secondarySpans, loadedUrls) {
                var t1 = A.ConstantMap_ConstantMap$from(secondarySpans, type$.FileSpan, type$.String);
                return new A.MultiSpanSassException(primaryLabel, t1, loadedUrls == null ? B.Set_empty : A.Set_Set$unmodifiable(loadedUrls, type$.Uri), message, span);
            },
            SassRuntimeException$: function(message, span, trace, loadedUrls) {
                return new A.SassRuntimeException(trace, loadedUrls == null ? B.Set_empty : A.Set_Set$unmodifiable(loadedUrls, type$.Uri), message, span);
            },
            MultiSpanSassRuntimeException$: function(message, span, primaryLabel, secondarySpans, trace, loadedUrls) {
                var t1 = A.ConstantMap_ConstantMap$from(secondarySpans, type$.FileSpan, type$.String);
                return new A.MultiSpanSassRuntimeException(trace, primaryLabel, t1, loadedUrls == null ? B.Set_empty : A.Set_Set$unmodifiable(loadedUrls, type$.Uri), message, span);
            },
            SassFormatException$: function(message, span, loadedUrls) {
                return new A.SassFormatException(loadedUrls == null ? B.Set_empty : A.Set_Set$unmodifiable(loadedUrls, type$.Uri), message, span);
            },
            MultiSpanSassFormatException$: function(message, span, primaryLabel, secondarySpans, loadedUrls) {
                var t1 = A.ConstantMap_ConstantMap$from(secondarySpans, type$.FileSpan, type$.String);
                return new A.MultiSpanSassFormatException(primaryLabel, t1, loadedUrls == null ? B.Set_empty : A.Set_Set$unmodifiable(loadedUrls, type$.Uri), message, span);
            },
            SassScriptException$: function(message, argumentName) {
                return new A.SassScriptException(argumentName == null ? message : "$" + argumentName + ": " + message);
            },
            MultiSpanSassScriptException$: function(message, primaryLabel, secondarySpans) {
                var t1 = A.ConstantMap_ConstantMap$from(secondarySpans, type$.FileSpan, type$.String);
                return new A.MultiSpanSassScriptException(primaryLabel, t1, message);
            },
            SassException: function SassException(t0, t1, t2) {
                this.loadedUrls = t0;
                this._span_exception$_message = t1;
                this._span = t2;
            },
            MultiSpanSassException: function MultiSpanSassException(t0, t1, t2, t3, t4) {
                var _ = this;
                _.primaryLabel = t0;
                _.secondarySpans = t1;
                _.loadedUrls = t2;
                _._span_exception$_message = t3;
                _._span = t4;
            },
            SassRuntimeException: function SassRuntimeException(t0, t1, t2, t3) {
                var _ = this;
                _.trace = t0;
                _.loadedUrls = t1;
                _._span_exception$_message = t2;
                _._span = t3;
            },
            MultiSpanSassRuntimeException: function MultiSpanSassRuntimeException(t0, t1, t2, t3, t4, t5) {
                var _ = this;
                _.trace = t0;
                _.primaryLabel = t1;
                _.secondarySpans = t2;
                _.loadedUrls = t3;
                _._span_exception$_message = t4;
                _._span = t5;
            },
            SassFormatException: function SassFormatException(t0, t1, t2) {
                this.loadedUrls = t0;
                this._span_exception$_message = t1;
                this._span = t2;
            },
            MultiSpanSassFormatException: function MultiSpanSassFormatException(t0, t1, t2, t3, t4) {
                var _ = this;
                _.primaryLabel = t0;
                _.secondarySpans = t1;
                _.loadedUrls = t2;
                _._span_exception$_message = t3;
                _._span = t4;
            },
            SassScriptException: function SassScriptException(t0) {
                this.message = t0;
            },
            MultiSpanSassScriptException: function MultiSpanSassScriptException(t0, t1, t2) {
                this.primaryLabel = t0;
                this.secondarySpans = t1;
                this.message = t2;
            },
            compileStylesheet: function(options, graph, source, destination, ifModified) {
                return A.compileStylesheet$body(options, graph, source, destination, ifModified);
            },
            compileStylesheet$body: function(options, graph, source, destination, ifModified) {
                var $async$goto = 0, $async$completer = A._makeAsyncAwaitCompleter(type$.nullable_Record_3_int_and_String_and_nullable_String), $async$returnValue, $async$handler = 2, $async$errorStack = [], error, stackTrace, message, error0, stackTrace0, path, message0, exception, t1, $async$exception;
                var $async$compileStylesheet = A._wrapJsFunctionForAsync(function($async$errorCode, $async$result) {
                    if ($async$errorCode === 1) {
                        $async$errorStack.push($async$result);
                        $async$goto = $async$handler;
                    }
                    for(;;)switch($async$goto){
                        case 0:
                            // Function start
                            $async$handler = 4;
                            $async$goto = 7;
                            return A._asyncAwait(A._compileStylesheetWithoutErrorHandling(options, graph, source, destination, ifModified), $async$compileStylesheet);
                        case 7:
                            // returning from await.
                            $async$handler = 2;
                            // goto after finally
                            $async$goto = 6;
                            break;
                        case 4:
                            // catch
                            $async$handler = 3;
                            $async$exception = $async$errorStack.pop();
                            t1 = A.unwrapException($async$exception);
                            if (t1 instanceof A.SassException) {
                                error = t1;
                                stackTrace = A.getTraceFromException($async$exception);
                                if (destination != null && !options.get$emitErrorCss()) A._tryDelete(destination);
                                message = J.toString$1$color$(error, options.get$color());
                                if (A._asBool(options._options.$index(0, "trace"))) {
                                    t1 = A.getTrace(error);
                                    if (t1 == null) t1 = stackTrace;
                                } else t1 = null;
                                $async$returnValue = A._getErrorWithStackTrace(65, message, t1);
                                // goto return
                                $async$goto = 1;
                                break;
                            } else if (t1 instanceof A.FileSystemException) {
                                error0 = t1;
                                stackTrace0 = A.getTraceFromException($async$exception);
                                path = error0.path;
                                message0 = path == null ? error0.message : "Error reading " + $.$get$context().relative$2$from(path, null) + ": " + error0.message + ".";
                                if (A._asBool(options._options.$index(0, "trace"))) {
                                    t1 = A.getTrace(error0);
                                    if (t1 == null) t1 = stackTrace0;
                                } else t1 = null;
                                $async$returnValue = A._getErrorWithStackTrace(66, message0, t1);
                                // goto return
                                $async$goto = 1;
                                break;
                            } else throw $async$exception;
                            // goto after finally
                            $async$goto = 6;
                            break;
                        case 3:
                            // uncaught
                            // goto rethrow
                            $async$goto = 2;
                            break;
                        case 6:
                            // after finally
                            $async$returnValue = null;
                            // goto return
                            $async$goto = 1;
                            break;
                        case 1:
                            // return
                            return A._asyncReturn($async$returnValue, $async$completer);
                        case 2:
                            // rethrow
                            return A._asyncRethrow($async$errorStack.at(-1), $async$completer);
                    }
                });
                return A._asyncStartSync($async$compileStylesheet, $async$completer);
            },
            _compileStylesheetWithoutErrorHandling: function(options, graph, source, destination, ifModified) {
                return A._compileStylesheetWithoutErrorHandling$body(options, graph, source, destination, ifModified);
            },
            _compileStylesheetWithoutErrorHandling$body: function(options, graph, source, destination, ifModified) {
                var $async$goto = 0, $async$completer = A._makeAsyncAwaitCompleter(type$.void), $async$returnValue, $async$handler = 2, $async$errorStack = [], syntax, result, importCache, error, t1, exception, t2, t3, t4, t5, t6, t7, t8, t9, t10, result0, t11, t12, t13, t14, logger, stylesheet, _0_0, t0, css, buffer, sourceName, destinationName, nowStr, timestamp, importer, $async$exception;
                var $async$_compileStylesheetWithoutErrorHandling = A._wrapJsFunctionForAsync(function($async$errorCode, $async$result) {
                    if ($async$errorCode === 1) {
                        $async$errorStack.push($async$result);
                        $async$goto = $async$handler;
                    }
                    for(;;)switch($async$goto){
                        case 0:
                            // Function start
                            importer = $.$get$FilesystemImporter_cwd();
                            if (ifModified) try {
                                t1 = false;
                                if (source != null) {
                                    if (destination != null) {
                                        t1 = A.absolute(source, null, null, null, null, null, null, null, null, null, null, null, null, null, null);
                                        t1 = !graph.modifiedSince$3($.$get$context().toUri$1(t1), A.modificationTime(destination), importer);
                                    }
                                }
                                if (t1) {
                                    // goto return
                                    $async$goto = 1;
                                    break;
                                }
                            } catch (exception) {
                                if (!(A.unwrapException(exception) instanceof A.FileSystemException)) throw exception;
                            }
                            syntax = null;
                            if (A._asBoolQ(options._ifParsed$1("indented")) === true) syntax = B.Syntax_Sass_1_sass;
                            else if (source != null) syntax = A.Syntax_forPath(source);
                            else syntax = B.Syntax_SCSS_0_scss;
                            result = null;
                            $async$handler = 4;
                            t1 = options._options;
                            $async$goto = A._asBool(t1.$index(0, "async")) ? 7 : 9;
                            break;
                        case 7:
                            // then
                            t2 = type$.nullable_Record_3_AsyncImporter_and_Uri_and_Uri_originalUrl;
                            t3 = type$.Record_3_AsyncImporter_and_Uri_and_bool_forImport;
                            t4 = type$.Uri;
                            importCache = new A.AsyncImportCache(A.AsyncImportCache__toImporters(options.get$pkgImporters(), type$.List_String._as(t1.$index(0, "load-path")), null), A.LinkedHashMap_LinkedHashMap$_empty(type$.Record_2_Uri_and_bool_forImport, t2), A.LinkedHashMap_LinkedHashMap$_empty(t3, t2), A.LinkedHashMap_LinkedHashMap$_empty(t3, t4), A.LinkedHashMap_LinkedHashMap$_empty(t4, type$.nullable_Stylesheet), A.LinkedHashMap_LinkedHashMap$_empty(t4, type$.ImporterResult), A.LinkedHashMap_LinkedHashMap$_empty(t4, type$.DateTime));
                            $async$goto = source == null ? 10 : 12;
                            break;
                        case 10:
                            // then
                            $async$goto = 13;
                            return A._asyncAwait(A.readStdin(), $async$_compileStylesheetWithoutErrorHandling);
                        case 13:
                            // returning from await.
                            t2 = $async$result;
                            t3 = syntax;
                            t4 = A._asBool(t1.$index(0, "quiet")) ? $.$get$Logger_quiet() : new A.StderrLogger(options.get$color());
                            t5 = $.$get$FilesystemImporter_cwd();
                            t6 = J.$eq$(t1.$index(0, "style"), "compressed") ? B.OutputStyle_1 : B.OutputStyle_0;
                            t7 = A._asBool(t1.$index(0, "quiet-deps"));
                            t8 = A._asBool(t1.$index(0, "verbose"));
                            t9 = options.get$emitSourceMap();
                            t1 = A._asBool(t1.$index(0, "charset"));
                            t10 = options.get$silenceDeprecations(0);
                            $async$goto = 14;
                            return A._asyncAwait(A.compileStringAsync(t2, t1, options.get$fatalDeprecations(0), options.get$futureDeprecations(0), importCache, t5, t4, t7, t10, t9, t6, t3, t8), $async$_compileStylesheetWithoutErrorHandling);
                        case 14:
                            // returning from await.
                            result0 = $async$result;
                            // goto join
                            $async$goto = 11;
                            break;
                        case 12:
                            // else
                            t2 = syntax;
                            t3 = A._asBool(t1.$index(0, "quiet")) ? $.$get$Logger_quiet() : new A.StderrLogger(options.get$color());
                            t4 = J.$eq$(t1.$index(0, "style"), "compressed") ? B.OutputStyle_1 : B.OutputStyle_0;
                            t5 = A._asBool(t1.$index(0, "quiet-deps"));
                            t6 = A._asBool(t1.$index(0, "verbose"));
                            t7 = options.get$emitSourceMap();
                            t1 = A._asBool(t1.$index(0, "charset"));
                            t8 = options.get$silenceDeprecations(0);
                            $async$goto = 15;
                            return A._asyncAwait(A.compileAsync(source, t1, options.get$fatalDeprecations(0), options.get$futureDeprecations(0), importCache, t3, t5, t8, t7, t4, t2, t6), $async$_compileStylesheetWithoutErrorHandling);
                        case 15:
                            // returning from await.
                            result0 = $async$result;
                        case 11:
                            // join
                            result = result0;
                            // goto join
                            $async$goto = 8;
                            break;
                        case 9:
                            // else
                            graph.reloadAllModified$0();
                            $async$goto = source == null ? 16 : 18;
                            break;
                        case 16:
                            // then
                            $async$goto = 19;
                            return A._asyncAwait(A.readStdin(), $async$_compileStylesheetWithoutErrorHandling);
                        case 19:
                            // returning from await.
                            t2 = $async$result;
                            t3 = syntax;
                            t4 = A._asBool(t1.$index(0, "quiet")) ? $.$get$Logger_quiet() : new A.StderrLogger(options.get$color());
                            t5 = $.$get$FilesystemImporter_cwd();
                            t6 = J.$eq$(t1.$index(0, "style"), "compressed") ? B.OutputStyle_1 : B.OutputStyle_0;
                            t7 = A._asBool(t1.$index(0, "quiet-deps"));
                            t8 = A._asBool(t1.$index(0, "verbose"));
                            t9 = options.get$emitSourceMap();
                            t1 = A._asBool(t1.$index(0, "charset"));
                            t10 = options.get$silenceDeprecations(0);
                            t11 = options.get$fatalDeprecations(0);
                            t12 = options.get$futureDeprecations(0);
                            t13 = type$.Deprecation;
                            t14 = A.LinkedHashSet_LinkedHashSet$_empty(t13);
                            t14.addAll$1(0, t10);
                            t10 = A.LinkedHashSet_LinkedHashSet$_empty(t13);
                            t10.addAll$1(0, t11);
                            t11 = A.LinkedHashSet_LinkedHashSet$_empty(t13);
                            t11.addAll$1(0, t12);
                            logger = new A.DeprecationProcessingLogger(A.LinkedHashMap_LinkedHashMap$_empty(t13, type$.int), t4, t14, t10, t11, !t8);
                            logger.validate$0();
                            stylesheet = A.Stylesheet_Stylesheet$parse(t2, t3 == null ? B.Syntax_SCSS_0_scss : t3, false, null);
                            t2 = stylesheet.span;
                            _0_0 = t2.get$sourceUrl(t2);
                            if (type$.Uri._is(_0_0)) t3 = "" === _0_0.get$scheme();
                            else t3 = false;
                            if (t3) A.WarnForDeprecation_warnForDeprecation(logger, B.Deprecation_r8S, "Passing a relative `url` argument (" + A.S(t2.get$sourceUrl(t2)) + string$.x29x20to_cm, null, null);
                            result0 = A._compileStylesheet(stylesheet, logger, graph.importCache, null, t5, null, t6, true, null, null, t7, t9, t1);
                            logger.summarize$1$js(false);
                            // goto join
                            $async$goto = 17;
                            break;
                        case 18:
                            // else
                            t2 = syntax;
                            t3 = A._asBool(t1.$index(0, "quiet")) ? $.$get$Logger_quiet() : new A.StderrLogger(options.get$color());
                            importCache = graph.importCache;
                            t4 = J.$eq$(t1.$index(0, "style"), "compressed") ? B.OutputStyle_1 : B.OutputStyle_0;
                            t5 = A._asBool(t1.$index(0, "quiet-deps"));
                            t6 = A._asBool(t1.$index(0, "verbose"));
                            t7 = options.get$emitSourceMap();
                            t1 = A._asBool(t1.$index(0, "charset"));
                            t8 = options.get$silenceDeprecations(0);
                            t9 = options.get$fatalDeprecations(0);
                            t10 = options.get$futureDeprecations(0);
                            t11 = type$.Deprecation;
                            t12 = A.LinkedHashSet_LinkedHashSet$_empty(t11);
                            t12.addAll$1(0, t8);
                            t8 = A.LinkedHashSet_LinkedHashSet$_empty(t11);
                            t8.addAll$1(0, t9);
                            t9 = A.LinkedHashSet_LinkedHashSet$_empty(t11);
                            t9.addAll$1(0, t10);
                            logger = new A.DeprecationProcessingLogger(A.LinkedHashMap_LinkedHashMap$_empty(t11, type$.int), t3, t12, t8, t9, !t6);
                            logger.validate$0();
                            t3 = t2 == null || t2 === A.Syntax_forPath(source);
                            if (t3) {
                                t2 = $.$get$FilesystemImporter_cwd();
                                t3 = A.isNodeJs() ? self.process : null;
                                if (!J.$eq$(t3 == null ? null : J.get$platform$x(t3), "win32")) {
                                    t3 = A.isNodeJs() ? self.process : null;
                                    t3 = J.$eq$(t3 == null ? null : J.get$platform$x(t3), "darwin");
                                } else t3 = true;
                                if (t3) {
                                    t3 = A.absolute(source, null, null, null, null, null, null, null, null, null, null, null, null, null, null);
                                    t6 = $.$get$context();
                                    t3 = A._realCasePath(t6.normalize$1(t3));
                                } else {
                                    t3 = $.$get$context();
                                    t6 = t3.canonicalize$1(0, source);
                                    t0 = t6;
                                    t6 = t3;
                                    t3 = t0;
                                }
                                t6 = importCache.importCanonical$3$originalUrl(t2, t6.toUri$1(t3), t6.toUri$1(source));
                                t6.toString;
                                stylesheet = t6;
                            } else {
                                t3 = A.readFile(source);
                                if (t2 == null) t2 = A.Syntax_forPath(source);
                                stylesheet = A.Stylesheet_Stylesheet$parse(t3, t2, false, $.$get$context().toUri$1(source));
                            }
                            result0 = A._compileStylesheet(stylesheet, logger, importCache, null, $.$get$FilesystemImporter_cwd(), null, t4, true, null, null, t5, t7, t1);
                            logger.summarize$1$js(false);
                        case 17:
                            // join
                            result = result0;
                        case 8:
                            // join
                            $async$handler = 2;
                            // goto after finally
                            $async$goto = 6;
                            break;
                        case 4:
                            // catch
                            $async$handler = 3;
                            $async$exception = $async$errorStack.pop();
                            t1 = A.unwrapException($async$exception);
                            if (t1 instanceof A.SassException) {
                                error = t1;
                                if (options.get$emitErrorCss()) {
                                    if (destination == null) A.print(error.toCssString$0());
                                    else {
                                        A.ensureDir($.$get$context().dirname$1(destination));
                                        A.writeFile(destination, error.toCssString$0() + "\n");
                                    }
                                }
                                throw $async$exception;
                            } else throw $async$exception;
                            // goto after finally
                            $async$goto = 6;
                            break;
                        case 3:
                            // uncaught
                            // goto rethrow
                            $async$goto = 2;
                            break;
                        case 6:
                            // after finally
                            css = result._serialize._0 + A._writeSourceMap(options, result._serialize._1, destination);
                            if (destination == null) {
                                if (css.length !== 0) A.print(css);
                            } else {
                                A.ensureDir($.$get$context().dirname$1(destination));
                                A.writeFile(destination, css + "\n");
                            }
                            t1 = options._options;
                            if (!A._asBool(t1.$index(0, "quiet"))) t1 = !A._asBool(t1.$index(0, "update")) && !A._asBool(t1.$index(0, "watch"));
                            else t1 = true;
                            if (t1) {
                                // goto return
                                $async$goto = 1;
                                break;
                            }
                            buffer = new A.StringBuffer("");
                            if (source == null) sourceName = "stdin";
                            else {
                                t1 = $.$get$context();
                                sourceName = t1.prettyUri$1(t1.toUri$1(source));
                            }
                            destination.toString;
                            t1 = $.$get$context();
                            destinationName = t1.prettyUri$1(t1.toUri$1(destination));
                            nowStr = new A.DateTime(Date.now(), 0, false).toString$0(0);
                            timestamp = B.JSString_methods.substring$2(nowStr, 0, nowStr.length - 7);
                            t1 = options.get$color() ? buffer._contents = "\x1b[90m" : "";
                            t1 = buffer._contents = t1 + ("[" + timestamp + "] ");
                            if (options.get$color()) t1 = buffer._contents = t1 + "\x1b[32m";
                            t1 = buffer._contents = t1 + ("Compiled " + sourceName + " to " + destinationName + ".");
                            if (options.get$color()) t1 = buffer._contents = t1 + "\x1b[0m";
                            t2 = A.isNodeJs() ? self.process : null;
                            if (t2 != null) {
                                t1 = J.get$stdout$x(t2);
                                J.write$1$x(t1, buffer.toString$0(0) + "\n");
                            } else {
                                t2 = self.console;
                                J.log$1$x(t2, t1.charCodeAt(0) == 0 ? t1 : t1);
                            }
                        case 1:
                            // return
                            return A._asyncReturn($async$returnValue, $async$completer);
                        case 2:
                            // rethrow
                            return A._asyncRethrow($async$errorStack.at(-1), $async$completer);
                    }
                });
                return A._asyncStartSync($async$_compileStylesheetWithoutErrorHandling, $async$completer);
            },
            _writeSourceMap: function(options, sourceMap, destination) {
                var t1, sourceMapText, url, sourceMapPath, t2, escapedUrl;
                if (sourceMap == null) return "";
                if (destination != null) {
                    t1 = $.$get$context();
                    sourceMap.targetUrl = t1.toUri$1(A.ParsedPath_ParsedPath$parse(destination, t1.style).get$basename()).toString$0(0);
                }
                A.mapInPlace(sourceMap.urls, new A._writeSourceMap_closure(options, destination));
                t1 = options._options;
                sourceMapText = B.C_JsonCodec.encode$2$toEncodable(sourceMap.toJson$1$includeSourceContents(A._asBool(t1.$index(0, "embed-sources"))), null);
                if (A._asBool(t1.$index(0, "embed-source-map"))) url = A.Uri_Uri$dataFromString(sourceMapText, B.C_Utf8Codec, "application/json");
                else {
                    destination.toString;
                    sourceMapPath = destination + ".map";
                    t2 = $.$get$context();
                    A.ensureDir(t2.dirname$1(sourceMapPath));
                    A.writeFile(sourceMapPath, sourceMapText);
                    url = t2.toUri$1(t2.relative$2$from(sourceMapPath, t2.dirname$1(destination)));
                }
                t2 = url.toString$0(0);
                escapedUrl = A.stringReplaceAllUnchecked(t2, "*/", "%2A/");
                t1 = (J.$eq$(t1.$index(0, "style"), "compressed") ? B.OutputStyle_1 : B.OutputStyle_0) === B.OutputStyle_1 ? "" : "\n\n";
                return t1 + ("/*# sourceMappingURL=" + escapedUrl + " */");
            },
            _tryDelete: function(path) {
                var _$exception;
                try {
                    A.deleteFile(path);
                } catch (exception) {
                    if (!(A.unwrapException(exception) instanceof A.FileSystemException)) throw exception;
                }
            },
            _getErrorWithStackTrace: function(exitCode, error, stackTrace) {
                return new A._Record_3(exitCode, error, stackTrace != null ? B.JSString_methods.trimRight$0(A.Trace_Trace$from(stackTrace).get$terse().toString$0(0)) : null);
            },
            _writeSourceMap_closure: function _writeSourceMap_closure(t0, t1) {
                this.options = t0;
                this.destination = t1;
            },
            ExecutableOptions__separator: function(text) {
                var t1 = $.$get$ExecutableOptions__separatorBar(), t2 = B.JSString_methods.$mul(t1, 3), t3 = A.hasTerminal() ? "\x1b[1m" : "", t4 = A.hasTerminal() ? "\x1b[0m" : "";
                return t2 + " " + t3 + text + t4 + " " + B.JSString_methods.$mul(t1, 35 - text.length);
            },
            ExecutableOptions__fail: function(message) {
                return A.throwExpression(A.UsageException$(message));
            },
            ExecutableOptions_ExecutableOptions$parse: function(args) {
                var options, error, t1, t2, _$exception;
                try {
                    t1 = $.$get$ExecutableOptions__parser();
                    t2 = A.ListQueue$(type$.String);
                    t2.addAll$1(0, args);
                    t2 = A.Parser$(null, t1, t2, null, null).parse$0(0);
                    if (t2.wasParsed$1("poll") && !A._asBool(t2.$index(0, "watch"))) A.ExecutableOptions__fail("--poll may not be passed without --watch.");
                    options = new A.ExecutableOptions(t2);
                    if (A._asBool(options._options.$index(0, "help"))) A.ExecutableOptions__fail("Compile Sass to CSS.");
                    return options;
                } catch (exception) {
                    t1 = A.unwrapException(exception);
                    if (type$.FormatException._is(t1)) {
                        error = t1;
                        A.ExecutableOptions__fail(J.get$message$x(error));
                    } else throw exception;
                }
            },
            UsageException$: function(message) {
                return new A.UsageException(message);
            },
            ExecutableOptions: function ExecutableOptions(t0) {
                var _ = this;
                _._options = t0;
                _.__ExecutableOptions_interactive_FI = $;
                _._sourcesToDestinations = null;
                _.__ExecutableOptions__sourceDirectoriesToDestinations_F = $;
                _._fatalDeprecations = null;
            },
            ExecutableOptions__parser_closure: function ExecutableOptions__parser_closure() {},
            ExecutableOptions_interactive_closure: function ExecutableOptions_interactive_closure(t0) {
                this.$this = t0;
            },
            ExecutableOptions_emitErrorCss_closure: function ExecutableOptions_emitErrorCss_closure() {},
            ExecutableOptions_fatalDeprecations_closure: function ExecutableOptions_fatalDeprecations_closure(t0) {
                this.$this = t0;
            },
            UsageException: function UsageException(t0) {
                this.message = t0;
            },
            repl: function(options) {
                return A.repl$body(options);
            },
            repl$body: function(options) {
                var $async$goto = 0, $async$completer = A._makeAsyncAwaitCompleter(type$.void), $async$handler = 1, $async$errorStack = [], $async$next = [], repl, trackingLogger, warn, evaluator, line, node, warnings, _1_0, node0, warnings0, _2_0, node1, warnings1, _3_0, error, stackTrace, logger, t4, t5, t6, t7, t8, t9, line0, toZone, exception, t1, t2, t3, repl0;
                var $async$repl = A._wrapJsFunctionForAsync(function($async$errorCode, $async$result) {
                    if ($async$errorCode === 1) {
                        $async$errorStack.push($async$result);
                        $async$goto = $async$handler;
                    }
                    for(;;)switch($async$goto){
                        case 0:
                            // Function start
                            t1 = A._setArrayType([], type$.JSArray_String);
                            t2 = B.JSString_methods.$mul(" ", 3);
                            t3 = $.$get$alwaysValid();
                            repl0 = new A.Repl(">> ", t2, t3, t1);
                            repl0.__Repl__adapter_A = new A.ReplAdapter(repl0);
                            repl = repl0;
                            t1 = options._options;
                            trackingLogger = new A.TrackingLogger(A._asBool(t1.$index(0, "quiet")) ? $.$get$Logger_quiet() : new A.StderrLogger(options.get$color()));
                            logger = new A.DeprecationProcessingLogger(A.LinkedHashMap_LinkedHashMap$_empty(type$.Deprecation, type$.int), trackingLogger, options.get$silenceDeprecations(0), options.get$fatalDeprecations(0), options.get$futureDeprecations(0), !A._asBool(t1.$index(0, "verbose")));
                            logger.validate$0();
                            warn = new A.repl_warn(logger);
                            t2 = $.$get$FilesystemImporter_cwd();
                            evaluator = new A.Evaluator(A._EvaluateVisitor$(null, A.ImportCache$(options.get$pkgImporters(), type$.List_String._as(t1.$index(0, "load-path"))), logger, null, false, false), t2);
                            t2 = repl.__Repl__adapter_A;
                            t2 === $ && A.throwUnnamedLateFieldNI();
                            t2 = new A._StreamIterator(A.checkNotNullable(t2.runAsync$0(), "stream", type$.Object));
                            $async$handler = 2;
                            t1 = type$.String, t3 = type$.FileSpan, t4 = type$.JSArray_Record_3_nullable_Deprecation_deprecation_and_String_message_and_FileSpan_span, t5 = type$.Expression;
                        case 5:
                            // for condition
                            $async$goto = 7;
                            return A._asyncAwait(t2.moveNext$0(), $async$repl);
                        case 7:
                            // returning from await.
                            if (!$async$result) {
                                // goto after for
                                $async$goto = 6;
                                break;
                            }
                            line = t2.get$current(0);
                            if (J.trim$0$s(line).length === 0) {
                                // goto for condition
                                $async$goto = 5;
                                break;
                            }
                            try {
                                if (J.startsWith$1$s(line, "@")) {
                                    node = null;
                                    warnings = null;
                                    _1_0 = new A.ScssParser(false, A.LinkedHashMap_LinkedHashMap$_empty(t1, t3), A._setArrayType([], t4), A.SpanScanner$(line, null), null).parseUseRule$0();
                                    node = _1_0._0;
                                    warnings = _1_0._1;
                                    J.forEach$1$ax(warnings, warn);
                                    t6 = evaluator;
                                    t7 = node;
                                    t6._visitor.runStatement$2(t6._importer, t7);
                                    // goto for condition
                                    $async$goto = 5;
                                    break;
                                }
                                if (new A.Parser(A.SpanScanner$(line, null), null)._isVariableDeclarationLike$0()) {
                                    node0 = null;
                                    warnings0 = null;
                                    _2_0 = new A.ScssParser(false, A.LinkedHashMap_LinkedHashMap$_empty(t1, t3), A._setArrayType([], t4), A.SpanScanner$(line, null), null).parseVariableDeclaration$0();
                                    node0 = _2_0._0;
                                    warnings0 = _2_0._1;
                                    J.forEach$1$ax(warnings0, warn);
                                    t6 = evaluator;
                                    t7 = node0;
                                    t6._visitor.runStatement$2(t6._importer, t7);
                                    t7 = evaluator;
                                    t6 = node0.name;
                                    t8 = node0.span;
                                    t9 = node0.namespace;
                                    line0 = t7._visitor.runExpression$2(t7._importer, new A.VariableExpression(t9, t6, t8)).toString$0(0);
                                    toZone = $._printToZone;
                                    if (toZone == null) A.printString(line0);
                                    else toZone.call$1(line0);
                                } else {
                                    node1 = null;
                                    warnings1 = null;
                                    t6 = A._setArrayType([], t4);
                                    t7 = new A.ScssParser(false, A.LinkedHashMap_LinkedHashMap$_empty(t1, t3), t6, A.SpanScanner$(line, null), null);
                                    _3_0 = new A._Record_2(t7._parseSingleProduction$1$1(t7.get$_expression(), t5), t6);
                                    node1 = _3_0._0;
                                    warnings1 = _3_0._1;
                                    J.forEach$1$ax(warnings1, warn);
                                    t6 = evaluator;
                                    t7 = node1;
                                    line0 = t6._visitor.runExpression$2(t6._importer, t7).toString$0(0);
                                    toZone = $._printToZone;
                                    if (toZone == null) A.printString(line0);
                                    else toZone.call$1(line0);
                                }
                            } catch (exception) {
                                t6 = A.unwrapException(exception);
                                if (t6 instanceof A.SassException) {
                                    error = t6;
                                    stackTrace = A.getTraceFromException(exception);
                                    t6 = error;
                                    t7 = typeof t6 != "string";
                                    if (!t7 || typeof t6 == "number" || A._isBool(t6)) t6 = null;
                                    else {
                                        t8 = $.$get$_traces();
                                        if (A._isBool(t6) || typeof t6 == "number" || !t7 || t6 instanceof A._Record) A.Expando__badExpandoKey(t6);
                                        t6 = t8._jsWeakMap.get(t6);
                                    }
                                    if (t6 == null) t6 = stackTrace;
                                    A._logError(error, t6, line, repl, options, trackingLogger);
                                } else throw exception;
                            }
                            // goto for condition
                            $async$goto = 5;
                            break;
                        case 6:
                            // after for
                            $async$next.push(4);
                            // goto finally
                            $async$goto = 3;
                            break;
                        case 2:
                            // uncaught
                            $async$next = [
                                1
                            ];
                        case 3:
                            // finally
                            $async$handler = 1;
                            $async$goto = 8;
                            return A._asyncAwait(t2.cancel$0(), $async$repl);
                        case 8:
                            // returning from await.
                            // goto the next finally handler
                            $async$goto = $async$next.pop();
                            break;
                        case 4:
                            // after finally
                            // implicit return
                            return A._asyncReturn(null, $async$completer);
                        case 1:
                            // rethrow
                            return A._asyncRethrow($async$errorStack.at(-1), $async$completer);
                    }
                });
                return A._asyncStartSync($async$repl, $async$completer);
            },
            _logError: function(error, stackTrace, line, repl, options, logger) {
                var t2, spacesBeforeError, t3, t1 = A.SourceSpanException.prototype.get$span.call(error, 0);
                if (t1.get$sourceUrl(t1) == null) {
                    if (!A._asBool(options._options.$index(0, "quiet"))) t1 = logger._emittedDebug || logger._emittedWarning;
                    else t1 = false;
                } else t1 = true;
                if (t1) {
                    A.print(error.toString$1$color(0, options.get$color()));
                    return;
                }
                t1 = options.get$color() ? "\x1b[31m" : "";
                t2 = A.SourceSpanException.prototype.get$span.call(error, 0);
                t2 = t2.get$start(t2);
                spacesBeforeError = repl.prompt.length + t2.file.getColumn$1(t2.offset);
                if (options.get$color()) {
                    t2 = A.SourceSpanException.prototype.get$span.call(error, 0);
                    t2 = t2.get$start(t2);
                    t2 = t2.file.getColumn$1(t2.offset) < line.length;
                } else t2 = false;
                if (t2) t1 = t1 + ("\x1b[1F\x1b[" + spacesBeforeError + "C") + (A.SourceSpanException.prototype.get$span.call(error, 0).get$text() + "\n");
                t2 = B.JSString_methods.$mul(" ", spacesBeforeError);
                t3 = A.SourceSpanException.prototype.get$span.call(error, 0);
                t3 = t1 + t2 + (B.JSString_methods.$mul("^", Math.max(1, t3.get$length(t3))) + "\n");
                t1 = options.get$color() ? t3 + "\x1b[0m" : t3;
                t1 += "Error: " + error._span_exception$_message + "\n";
                if (A._asBool(options._options.$index(0, "trace"))) t1 += A.Trace_Trace$from(stackTrace).get$terse().toString$0(0);
                A.print(B.JSString_methods.trimRight$0(t1.charCodeAt(0) == 0 ? t1 : t1));
            },
            repl_warn: function repl_warn(t0) {
                this.logger = t0;
            },
            watch: function(options, graph) {
                var $async$goto = 0, $async$completer = A._makeAsyncAwaitCompleter(type$.void), $async$returnValue, t1, t2, t3, t4, t5, t6, dirWatcher, sourcesToDestinations, t7, t8, t0;
                var $async$watch = A._wrapJsFunctionForAsync(function($async$errorCode, $async$result) {
                    if ($async$errorCode === 1) return A._asyncRethrow($async$result, $async$completer);
                    for(;;)switch($async$goto){
                        case 0:
                            // Function start
                            options._ensureSources$0();
                            t1 = options.__ExecutableOptions__sourceDirectoriesToDestinations_F;
                            t1 === $ && A.throwUnnamedLateFieldNI();
                            t2 = type$.String;
                            t1 = t1.cast$2$0(0, t2, t2);
                            t1 = A.List_List$_of(t1.get$keys(t1), t2);
                            for(options._ensureSources$0(), t3 = options._sourcesToDestinations.cast$2$0(0, t2, t2), t3 = t3.get$keys(t3), t3 = t3.get$iterator(t3); t3.moveNext$0();){
                                t4 = t3.get$current(t3);
                                t1.push($.$get$context().dirname$1(t4));
                            }
                            t3 = options._options;
                            B.JSArray_methods.addAll$1(t1, type$.List_String._as(t3.$index(0, "load-path")));
                            t4 = A._asBool(t3.$index(0, "poll"));
                            t5 = type$.Stream_WatchEvent;
                            t6 = A.PathMap__create(null, t5);
                            t5 = new A.StreamGroup(B._StreamGroupState_dormant, A.LinkedHashMap_LinkedHashMap$_empty(t5, type$.nullable_StreamSubscription_WatchEvent), type$.StreamGroup_WatchEvent);
                            t5.__StreamGroup__controller_A = A.StreamController_StreamController(t5.get$_onCancel(), t5.get$_onListen(), t5.get$_onPause(), t5.get$_onResume(), true, type$.WatchEvent);
                            dirWatcher = new A.MultiDirWatcher(new A.PathMap(t6, type$.PathMap_Stream_WatchEvent), t5, t4);
                            $async$goto = 3;
                            return A._asyncAwait(A.Future_wait(new A.MappedListIterable(t1, new A.watch_closure(dirWatcher), A._arrayInstanceType(t1)._eval$1("MappedListIterable<1,Future<~>>")), false, type$.void), $async$watch);
                        case 3:
                            // returning from await.
                            options._ensureSources$0();
                            sourcesToDestinations = options._sourcesToDestinations.cast$2$0(0, t2, t2);
                            for(t1 = sourcesToDestinations.get$keys(sourcesToDestinations), t1 = t1.get$iterator(t1); t1.moveNext$0();){
                                t4 = t1.get$current(t1);
                                t6 = $.$get$FilesystemImporter_cwd();
                                t7 = self.process;
                                if (t7 == null) t7 = null;
                                else {
                                    t7 = J.get$release$x(t7);
                                    t7 = t7 == null ? null : J.get$name$x(t7);
                                }
                                t7 = J.$eq$(t7, "node") ? self.process : null;
                                if (!J.$eq$(t7 == null ? null : J.get$platform$x(t7), "win32")) {
                                    t7 = self.process;
                                    if (t7 == null) t7 = null;
                                    else {
                                        t7 = J.get$release$x(t7);
                                        t7 = t7 == null ? null : J.get$name$x(t7);
                                    }
                                    t7 = J.$eq$(t7, "node") ? self.process : null;
                                    t7 = J.$eq$(t7 == null ? null : J.get$platform$x(t7), "darwin");
                                } else t7 = true;
                                if (t7) {
                                    t7 = $.$get$context();
                                    t8 = A._realCasePath(t7.normalize$1(t7.absolute$15(t4, null, null, null, null, null, null, null, null, null, null, null, null, null, null)));
                                    t0 = t8;
                                    t8 = t7;
                                    t7 = t0;
                                } else {
                                    t7 = $.$get$context();
                                    t8 = t7.canonicalize$1(0, t4);
                                    t0 = t8;
                                    t8 = t7;
                                    t7 = t0;
                                }
                                graph.addCanonical$4$recanonicalize(t6, t8.toUri$1(t7), t8.toUri$1(t4), false);
                            }
                            $async$goto = 4;
                            return A._asyncAwait(A.compileStylesheets(options, graph, sourcesToDestinations, true), $async$watch);
                        case 4:
                            // returning from await.
                            if (!$async$result && A._asBool(t3.$index(0, "stop-on-error"))) {
                                t1 = t5.__StreamGroup__controller_A;
                                new A._ControllerStream(t1, A._instanceType(t1)._eval$1("_ControllerStream<1>")).listen$1(0, null).cancel$0();
                                // goto return
                                $async$goto = 1;
                                break;
                            }
                            A.print("Sass is watching for changes. Press Ctrl-C to stop.\n");
                            $async$goto = 5;
                            return A._asyncAwait(new A._Watcher(options, graph, A.LinkedHashMap_LinkedHashMap$_empty(t2, t2)).watch$1(0, dirWatcher), $async$watch);
                        case 5:
                        // returning from await.
                        case 1:
                            // return
                            return A._asyncReturn($async$returnValue, $async$completer);
                    }
                });
                return A._asyncStartSync($async$watch, $async$completer);
            },
            watch_closure: function watch_closure(t0) {
                this.dirWatcher = t0;
            },
            _Watcher: function _Watcher(t0, t1, t2) {
                this._watch$_options = t0;
                this._graph = t1;
                this._toRecompile = t2;
            },
            _Watcher__debounceEvents_closure: function _Watcher__debounceEvents_closure() {},
            EmptyExtensionStore: function EmptyExtensionStore() {},
            Extension: function Extension(t0, t1, t2, t3, t4) {
                var _ = this;
                _.extender = t0;
                _.target = t1;
                _.mediaContext = t2;
                _.isOptional = t3;
                _.span = t4;
            },
            Extender: function Extender(t0, t1) {
                this.selector = t0;
                this.isOriginal = t1;
                this._extension = null;
            },
            ExtensionStore__extendOrReplace: function(selector, source, targets, mode, span) {
                var t1, t2, t3, t4, t5, t6, t7, t8, _i, complex, compound, t9, t10, t11, _i0, simple, t12, _i1, t13, t14, extender = A.ExtensionStore$_mode(mode);
                if (!selector.accept$1(B._IsInvisibleVisitor_true)) extender._originals.addAll$1(0, selector.components);
                for(t1 = targets.components, t2 = t1.length, t3 = source.components, t4 = t3.length, t5 = type$.ComplexSelector, t6 = type$.Extension, t7 = type$.SimpleSelector, t8 = type$.Map_ComplexSelector_Extension, _i = 0; _i < t2; ++_i){
                    complex = t1[_i];
                    compound = complex.get$singleCompound();
                    if (compound == null) throw A.wrapException(A.SassScriptException$("Can't extend complex selector " + complex.toString$0(0) + ".", null));
                    t9 = A.LinkedHashMap_LinkedHashMap$_empty(t7, t8);
                    for(t10 = compound.components, t11 = t10.length, _i0 = 0; _i0 < t11; ++_i0){
                        simple = t10[_i0];
                        t12 = A.LinkedHashMap_LinkedHashMap$_empty(t5, t6);
                        for(_i1 = 0; _i1 < t4; ++_i1){
                            complex = t3[_i1];
                            complex.get$specificity();
                            t13 = new A.Extender(complex, false);
                            t14 = new A.Extension(t13, simple, null, true, span);
                            t13._extension = t14;
                            t12.$indexSet(0, complex, t14);
                        }
                        t9.$indexSet(0, simple, t12);
                    }
                    selector = extender._extendList$2(selector, t9);
                }
                return selector;
            },
            ExtensionStore$: function() {
                var t1 = type$.SimpleSelector;
                return new A.ExtensionStore(A.LinkedHashMap_LinkedHashMap$_empty(t1, type$.Set_ModifiableBox_SelectorList), A.LinkedHashMap_LinkedHashMap$_empty(t1, type$.Map_ComplexSelector_Extension), A.LinkedHashMap_LinkedHashMap$_empty(t1, type$.List_Extension), A.LinkedHashMap_LinkedHashMap$_empty(type$.ModifiableBox_SelectorList, type$.List_CssMediaQuery), new A.JsIdentityLinkedHashMap(type$.JsIdentityLinkedHashMap_SimpleSelector_int), new A._LinkedIdentityHashSet(type$._LinkedIdentityHashSet_ComplexSelector), B.ExtendMode_normal_0_normal);
            },
            ExtensionStore$_mode: function(_mode) {
                var t1 = type$.SimpleSelector;
                return new A.ExtensionStore(A.LinkedHashMap_LinkedHashMap$_empty(t1, type$.Set_ModifiableBox_SelectorList), A.LinkedHashMap_LinkedHashMap$_empty(t1, type$.Map_ComplexSelector_Extension), A.LinkedHashMap_LinkedHashMap$_empty(t1, type$.List_Extension), A.LinkedHashMap_LinkedHashMap$_empty(type$.ModifiableBox_SelectorList, type$.List_CssMediaQuery), new A.JsIdentityLinkedHashMap(type$.JsIdentityLinkedHashMap_SimpleSelector_int), new A._LinkedIdentityHashSet(type$._LinkedIdentityHashSet_ComplexSelector), _mode);
            },
            ExtensionStore: function ExtensionStore(t0, t1, t2, t3, t4, t5, t6) {
                var _ = this;
                _._selectors = t0;
                _._extensions = t1;
                _._extensionsByExtender = t2;
                _._mediaContexts = t3;
                _._sourceSpecificity = t4;
                _._originals = t5;
                _._mode = t6;
            },
            ExtensionStore_extensionsWhereTarget_closure: function ExtensionStore_extensionsWhereTarget_closure() {},
            ExtensionStore__registerSelector_closure: function ExtensionStore__registerSelector_closure() {},
            ExtensionStore_addExtension_closure: function ExtensionStore_addExtension_closure() {},
            ExtensionStore_addExtension_closure0: function ExtensionStore_addExtension_closure0() {},
            ExtensionStore_addExtension_closure1: function ExtensionStore_addExtension_closure1(t0) {
                this.complex = t0;
            },
            ExtensionStore__extendExistingExtensions_closure: function ExtensionStore__extendExistingExtensions_closure() {},
            ExtensionStore__extendExistingExtensions_closure0: function ExtensionStore__extendExistingExtensions_closure0() {},
            ExtensionStore_addExtensions_closure: function ExtensionStore_addExtensions_closure() {},
            ExtensionStore__extendComplex_closure: function ExtensionStore__extendComplex_closure(t0, t1, t2) {
                this._box_0 = t0;
                this.$this = t1;
                this.complex = t2;
            },
            ExtensionStore__extendComplex__closure: function ExtensionStore__extendComplex__closure(t0, t1, t2) {
                this._box_0 = t0;
                this.$this = t1;
                this.complex = t2;
            },
            ExtensionStore__extendCompound_closure: function ExtensionStore__extendCompound_closure() {},
            ExtensionStore__extendCompound_closure0: function ExtensionStore__extendCompound_closure0() {},
            ExtensionStore__extendCompound_closure1: function ExtensionStore__extendCompound_closure1(t0) {
                this.original = t0;
            },
            ExtensionStore__extendSimple_withoutPseudo: function ExtensionStore__extendSimple_withoutPseudo(t0, t1, t2) {
                this.$this = t0;
                this.extensions = t1;
                this.targetsUsed = t2;
            },
            ExtensionStore__extendSimple_closure: function ExtensionStore__extendSimple_closure(t0, t1) {
                this.$this = t0;
                this.withoutPseudo = t1;
            },
            ExtensionStore__extendSimple_closure0: function ExtensionStore__extendSimple_closure0() {},
            ExtensionStore__extendPseudo_closure: function ExtensionStore__extendPseudo_closure() {},
            ExtensionStore__extendPseudo_closure0: function ExtensionStore__extendPseudo_closure0() {},
            ExtensionStore__extendPseudo_closure1: function ExtensionStore__extendPseudo_closure1() {},
            ExtensionStore__extendPseudo_closure2: function ExtensionStore__extendPseudo_closure2(t0) {
                this.pseudo = t0;
            },
            ExtensionStore__extendPseudo_closure3: function ExtensionStore__extendPseudo_closure3(t0, t1) {
                this.pseudo = t0;
                this.selector = t1;
            },
            ExtensionStore__trim_closure: function ExtensionStore__trim_closure(t0, t1) {
                this._box_0 = t0;
                this.complex1 = t1;
            },
            ExtensionStore__trim_closure0: function ExtensionStore__trim_closure0(t0, t1) {
                this._box_0 = t0;
                this.complex1 = t1;
            },
            ExtensionStore_clone_closure: function ExtensionStore_clone_closure(t0, t1, t2, t3, t4) {
                var _ = this;
                _.$this = t0;
                _.newSelectors = t1;
                _.newBoxes = t2;
                _.oldToNewSelectors = t3;
                _.newMediaContexts = t4;
            },
            ExtensionStore_clone__closure: function ExtensionStore_clone__closure(t0) {
                this.selector = t0;
            },
            unifyComplex: function(complexes, span) {
                var t2, trailingCombinator, leadingCombinator, unifiedBase, t3, t4, _0_6_isSet, _0_6, t5, newLeadingCombinator, base, _1_1, newTrailingCombinator, unifiedBase0, t6, t7, t8, _null = null, t1 = J.getInterceptor$asx(complexes);
                if (t1.get$length(complexes) === 1) return complexes;
                for(t2 = t1.get$iterator(complexes), trailingCombinator = _null, leadingCombinator = trailingCombinator, unifiedBase = leadingCombinator; t2.moveNext$0();){
                    t3 = t2.get$current(t2);
                    if (t3.accept$1(B.C__IsUselessVisitor)) return _null;
                    t4 = t3.components;
                    _0_6_isSet = t4.length === 1;
                    if (_0_6_isSet) {
                        _0_6 = t3.leadingCombinators;
                        t5 = _0_6.length === 1;
                    } else {
                        _0_6 = _null;
                        t5 = false;
                    }
                    if (t5) {
                        newLeadingCombinator = (_0_6_isSet ? _0_6 : t3.leadingCombinators)[0];
                        if (leadingCombinator == null) leadingCombinator = newLeadingCombinator;
                        else if (!(leadingCombinator.$ti._is(newLeadingCombinator) && J.$eq$(newLeadingCombinator.value, leadingCombinator.value))) return _null;
                    }
                    base = B.JSArray_methods.get$last(t4);
                    _1_1 = base.combinators;
                    if (_1_1.length === 1) {
                        newTrailingCombinator = _1_1[0];
                        if (trailingCombinator != null) t3 = !(trailingCombinator.$ti._is(newTrailingCombinator) && J.$eq$(newTrailingCombinator.value, trailingCombinator.value));
                        else t3 = false;
                        if (t3) return _null;
                        trailingCombinator = newTrailingCombinator;
                    }
                    unifiedBase0 = base.selector;
                    if (unifiedBase == null) unifiedBase = unifiedBase0;
                    else {
                        unifiedBase = A.unifyCompound(unifiedBase, unifiedBase0);
                        if (unifiedBase == null) return _null;
                    }
                }
                t2 = type$.JSArray_ComplexSelector;
                t3 = A._setArrayType([], t2);
                for(t4 = t1.get$iterator(complexes); t4.moveNext$0();){
                    t5 = t4.get$current(t4);
                    t6 = t5.components;
                    t7 = t6.length;
                    if (t7 > 1) {
                        t8 = t5.leadingCombinators;
                        t3.push(A.ComplexSelector$(t8, B.JSArray_methods.take$1(t6, t7 - 1), t5.span, t5.lineBreak));
                    }
                }
                t4 = leadingCombinator == null ? B.List_empty0 : A._setArrayType([
                    leadingCombinator
                ], type$.JSArray_CssValue_Combinator);
                unifiedBase.toString;
                t5 = trailingCombinator == null ? B.List_empty0 : A._setArrayType([
                    trailingCombinator
                ], type$.JSArray_CssValue_Combinator);
                base = A.ComplexSelector$(t4, A._setArrayType([
                    new A.ComplexSelectorComponent(unifiedBase, A.List_List$unmodifiable(t5, type$.CssValue_Combinator), span)
                ], type$.JSArray_ComplexSelectorComponent), span, t1.any$1(complexes, new A.unifyComplex_closure()));
                if (t3.length === 0) t1 = A._setArrayType([
                    base
                ], t2);
                else {
                    t1 = A.List_List$_of(A.IterableExtension_get_exceptLast(t3), type$.ComplexSelector);
                    t1.push(B.JSArray_methods.get$last(t3).concatenate$2(base, span));
                }
                return A.weave(t1, span, false);
            },
            unifyCompound: function(compound1, compound2) {
                var t1, t2, pseudoElementFound, _i, simple, unified, result = compound1.components, pseudoResult = A._setArrayType([], type$.JSArray_SimpleSelector);
                for(t1 = compound2.components, t2 = t1.length, pseudoElementFound = false, _i = 0; _i < t2; ++_i){
                    simple = t1[_i];
                    if (pseudoElementFound && simple instanceof A.PseudoSelector) {
                        unified = simple.unify$1(pseudoResult);
                        if (unified == null) return null;
                        pseudoResult = unified;
                    } else {
                        pseudoElementFound = B.JSBool_methods.$or(pseudoElementFound, simple instanceof A.PseudoSelector && !simple.isClass);
                        unified = simple.unify$1(result);
                        if (unified == null) return null;
                        result = unified;
                    }
                }
                t1 = A.List_List$_of(result, type$.SimpleSelector);
                B.JSArray_methods.addAll$1(t1, pseudoResult);
                return A.CompoundSelector$(t1, compound1.span);
            },
            unifyUniversalAndElement: function(selector1, selector2) {
                var namespace, $name, t1, _0_0 = A._namespaceAndName(selector1, "selector1"), namespace1 = _0_0._0, name1 = _0_0._1, _1_0 = A._namespaceAndName(selector2, "selector2"), namespace2 = _1_0._0, name2 = _1_0._1;
                if (namespace1 == namespace2 || namespace2 === "*") namespace = namespace1;
                else {
                    if (namespace1 !== "*") return null;
                    namespace = namespace2;
                }
                if (name1 == name2 || name2 == null) $name = name1;
                else {
                    if (!(name1 == null || name1 === "*")) return null;
                    $name = name2;
                }
                t1 = selector1.span;
                return $name == null ? new A.UniversalSelector(namespace, t1) : new A.TypeSelector(new A.QualifiedName($name, namespace), t1);
            },
            _namespaceAndName: function(selector, $name) {
                var t1, _0_4;
                $label0$0: {
                    if (selector instanceof A.UniversalSelector) {
                        t1 = new A._Record_2(selector.namespace, null);
                        break $label0$0;
                    }
                    if (selector instanceof A.TypeSelector) {
                        _0_4 = selector.name;
                        t1 = new A._Record_2(_0_4.namespace, _0_4.name);
                        break $label0$0;
                    }
                    t1 = A.throwExpression(A.ArgumentError$value(selector, $name, string$.must_b));
                }
                return t1;
            },
            weave: function(complexes, span, forceLineBreak) {
                var complex, t2, prefixes, t3, t4, t5, t6, i, t7, t8, _i, t9, t10, _i0, parentPrefix, t11, t12, t1 = J.getInterceptor$asx(complexes);
                if (t1.get$length(complexes) === 1) {
                    complex = t1.$index(complexes, 0);
                    if (!forceLineBreak || complex.lineBreak) return complexes;
                    return A._setArrayType([
                        A.ComplexSelector$(complex.leadingCombinators, complex.components, complex.span, true)
                    ], type$.JSArray_ComplexSelector);
                }
                t2 = type$.JSArray_ComplexSelector;
                prefixes = A._setArrayType([
                    t1.get$first(complexes)
                ], t2);
                for(t1 = t1.skip$1(complexes, 1), t3 = t1.$ti, t1 = new A.ListIterator(t1, t1.get$length(0), t3._eval$1("ListIterator<ListIterable.E>")), t4 = type$.ComplexSelectorComponent, t3 = t3._eval$1("ListIterable.E"); t1.moveNext$0();){
                    t5 = t1.__internal$_current;
                    if (t5 == null) t5 = t3._as(t5);
                    t6 = t5.components;
                    if (t6.length === 1) {
                        for(i = 0; i < prefixes.length; ++i)prefixes[i] = prefixes[i].concatenate$3$forceLineBreak(t5, span, forceLineBreak);
                        continue;
                    }
                    t7 = A._setArrayType([], t2);
                    for(t8 = prefixes.length, _i = 0; _i < prefixes.length; prefixes.length === t8 || (0, A.throwConcurrentModificationError)(prefixes), ++_i){
                        t9 = A._weaveParents(prefixes[_i], t5, span);
                        if (t9 == null) t9 = B.List_empty1;
                        t10 = t9.length;
                        _i0 = 0;
                        for(; _i0 < t9.length; t9.length === t10 || (0, A.throwConcurrentModificationError)(t9), ++_i0){
                            parentPrefix = t9[_i0];
                            t11 = B.JSArray_methods.get$last(t6);
                            t12 = A.List_List$_of(parentPrefix.components, t4);
                            t12.push(t11);
                            t11 = parentPrefix.lineBreak || forceLineBreak;
                            t7.push(A.ComplexSelector$(parentPrefix.leadingCombinators, t12, span, t11));
                        }
                    }
                    prefixes = t7;
                }
                return prefixes;
            },
            _weaveParents: function(prefix, base, span) {
                var t1, queue1, queue2, trailingCombinators, _0_1, _0_3, _0_3_isSet, rootish2, t2, rootish1, _0_30, rootish, t3, t0, rootish_case_1, groups1, groups2, lcs, choices, t4, _i, group, t5, t6, t7, _i0, chunk, t8, t9, _null = null, leadingCombinators = A._mergeLeadingCombinators(prefix.leadingCombinators, base.leadingCombinators);
                if (leadingCombinators == null) return _null;
                t1 = type$.ComplexSelectorComponent;
                queue1 = A.QueueList_QueueList$from(prefix.components, t1);
                queue2 = A.QueueList_QueueList$from(A.IterableExtension_get_exceptLast(base.components), t1);
                trailingCombinators = A._mergeTrailingCombinators(queue1, queue2, span, _null);
                if (trailingCombinators == null) return _null;
                $label0$0: {
                    _0_1 = A._firstIfRootish(queue1);
                    _0_3 = A._firstIfRootish(queue2);
                    _0_3_isSet = _0_1 != null;
                    rootish2 = _null;
                    t2 = false;
                    if (_0_3_isSet) {
                        t2 = _0_3 != null;
                        if (t2) rootish2 = _0_3;
                        rootish1 = _0_1;
                        _0_30 = _0_3;
                    } else {
                        rootish1 = _null;
                        _0_30 = rootish1;
                    }
                    if (t2) {
                        rootish = A.unifyCompound(rootish1.selector, rootish2.selector);
                        if (rootish == null) return _null;
                        t1 = rootish1.combinators;
                        t2 = rootish1.span;
                        t3 = type$.CssValue_Combinator;
                        queue1.addFirst$1(new A.ComplexSelectorComponent(rootish, A.List_List$unmodifiable(t1, t3), t2));
                        queue2.addFirst$1(new A.ComplexSelectorComponent(rootish, A.List_List$unmodifiable(rootish2.combinators, t3), t2));
                        break $label0$0;
                    }
                    t2 = _null;
                    t3 = false;
                    if (_0_1 != null) {
                        if (_0_3_isSet) t2 = _0_30;
                        else {
                            t2 = _0_3;
                            _0_30 = t2;
                            _0_3_isSet = true;
                        }
                        t2 = t2 == null;
                        t3 = t2 ? _0_1 : _null;
                        t0 = t3;
                        t3 = t2;
                        t2 = t0;
                    }
                    if (!t3) {
                        if (_0_1 == null) {
                            if (_0_3_isSet) t3 = _0_30;
                            else {
                                t3 = _0_3;
                                _0_30 = t3;
                                _0_3_isSet = true;
                            }
                            t3 = t3 != null;
                            if (t3) {
                                rootish_case_1 = _0_3_isSet ? _0_30 : _0_3;
                                if (rootish_case_1 == null) rootish_case_1 = t1._as(rootish_case_1);
                                t1 = rootish_case_1;
                            } else t1 = t2;
                            t2 = t3;
                        } else {
                            t1 = t2;
                            t2 = false;
                        }
                    } else {
                        t1 = t2;
                        t2 = true;
                    }
                    if (t2) {
                        queue1.addFirst$1(t1);
                        queue2.addFirst$1(t1);
                    }
                }
                groups1 = A._groupSelectors(queue1);
                groups2 = A._groupSelectors(queue2);
                t1 = type$.List_ComplexSelectorComponent;
                lcs = A.longestCommonSubsequence(groups2, groups1, new A._weaveParents_closure(span), t1);
                choices = A._setArrayType([], type$.JSArray_List_Iterable_ComplexSelectorComponent);
                for(t2 = lcs.length, t3 = type$.JSArray_Iterable_ComplexSelectorComponent, t4 = type$.JSArray_ComplexSelectorComponent, _i = 0; _i < lcs.length; lcs.length === t2 || (0, A.throwConcurrentModificationError)(lcs), ++_i){
                    group = lcs[_i];
                    t5 = A._setArrayType([], t3);
                    for(t6 = A._chunks(groups1, groups2, new A._weaveParents_closure0(group), t1), t7 = t6.length, _i0 = 0; _i0 < t6.length; t6.length === t7 || (0, A.throwConcurrentModificationError)(t6), ++_i0){
                        chunk = t6[_i0];
                        t8 = A._setArrayType([], t4);
                        for(t9 = B.JSArray_methods.get$iterator(chunk); t9.moveNext$0();)B.JSArray_methods.addAll$1(t8, t9.get$current(0));
                        t5.push(t8);
                    }
                    choices.push(t5);
                    choices.push(A._setArrayType([
                        group
                    ], t3));
                    groups1.removeFirst$0();
                    groups2.removeFirst$0();
                }
                t2 = A._setArrayType([], t3);
                for(t1 = A._chunks(groups1, groups2, new A._weaveParents_closure1(), t1), t3 = t1.length, _i = 0; _i < t1.length; t1.length === t3 || (0, A.throwConcurrentModificationError)(t1), ++_i){
                    chunk = t1[_i];
                    t5 = A._setArrayType([], t4);
                    for(t6 = B.JSArray_methods.get$iterator(chunk); t6.moveNext$0();)B.JSArray_methods.addAll$1(t5, t6.get$current(0));
                    t2.push(t5);
                }
                choices.push(t2);
                B.JSArray_methods.addAll$1(choices, trailingCombinators);
                t1 = A._setArrayType([], type$.JSArray_ComplexSelector);
                for(t2 = J.get$iterator$ax(A.paths(new A.WhereIterable(choices, new A._weaveParents_closure2(), type$.WhereIterable_List_Iterable_ComplexSelectorComponent), type$.Iterable_ComplexSelectorComponent)), t3 = !prefix.lineBreak, t5 = base.lineBreak; t2.moveNext$0();){
                    t6 = t2.get$current(t2);
                    t7 = A._setArrayType([], t4);
                    for(t6 = J.get$iterator$ax(t6); t6.moveNext$0();)B.JSArray_methods.addAll$1(t7, t6.get$current(t6));
                    t1.push(A.ComplexSelector$(leadingCombinators, t7, span, !t3 || t5));
                }
                return t1;
            },
            _firstIfRootish: function(queue) {
                var first, t1, t2, _i, simple, t3;
                if (queue.get$length(0) >= 1) {
                    first = queue.$index(0, 0);
                    for(t1 = first.selector.components, t2 = t1.length, _i = 0; _i < t2; ++_i){
                        simple = t1[_i];
                        t3 = false;
                        if (simple instanceof A.PseudoSelector) {
                            if (simple.isClass) t3 = $._rootishPseudoClasses.contains$1(0, simple.normalizedName);
                        }
                        if (t3) {
                            queue.removeFirst$0();
                            return first;
                        }
                    }
                }
                return null;
            },
            _mergeLeadingCombinators: function(combinators1, combinators2) {
                var t1, _0_7, t2, _0_11_isSet, _0_11, combinators, _null = null;
                $label0$0: {
                    t1 = _null;
                    _0_7 = _null;
                    _0_7 = combinators1.length;
                    t2 = _0_7;
                    t2 = t2 > 1;
                    _0_11_isSet = !t2;
                    _0_11 = _null;
                    if (_0_11_isSet) {
                        _0_11 = combinators2.length;
                        t2 = _0_11;
                        t2 = t2 > 1;
                    } else t2 = true;
                    if (t2) break $label0$0;
                    t2 = _0_7 <= 0;
                    if (t2) combinators = combinators2;
                    else combinators = t1;
                    t1 = t2;
                    if (!t1) {
                        t1 = false;
                        if (_0_11_isSet) t1 = _0_11;
                        else {
                            _0_11 = combinators2.length;
                            t1 = _0_11;
                        }
                        t1 = t1 <= 0;
                        combinators = combinators1;
                    } else t1 = true;
                    if (t1) {
                        t1 = combinators;
                        break $label0$0;
                    }
                    t1 = B.C_ListEquality.equals$2(0, combinators1, combinators2) ? combinators1 : _null;
                    break $label0$0;
                }
                return t1;
            },
            _mergeTrailingCombinators: function(components1, components2, span, result) {
                var _0_1, t1, _1_1, t2, t3, _4_1, _4_3, _4_5, _4_4, _4_5_isSet, _4_4_isSet, component1, component2, t4, t5, choices, _2_0, _4_9, _4_6, _4_6_isSet, _4_7, _4_7_isSet, followingComponents, nextComponents, _4_9_isSet, _4_10_isSet, _4_10, next, following, _3_0, _4_4_isSet0, siblingComponents_case_0, siblingComponents_case_1, t6, combinator2, unified, t7, combinatorComponents_case_0, descendantComponents_case_0, t0, combinator_case_1, descendantComponents_case_1, combinatorComponents_case_1, _null = null;
                if (result == null) result = A.QueueList$(_null, type$.List_List_ComplexSelectorComponent);
                $label0$0: {
                    _0_1 = components1.get$length(0);
                    if (_0_1 >= 1) {
                        t1 = components1.$index(0, _0_1 - 1).combinators;
                        break $label0$0;
                    }
                    t1 = B.List_empty0;
                    break $label0$0;
                }
                $label1$1: {
                    _1_1 = components2.get$length(0);
                    if (_1_1 >= 1) {
                        t2 = components2.$index(0, _1_1 - 1).combinators;
                        break $label1$1;
                    }
                    t2 = B.List_empty0;
                    break $label1$1;
                }
                t3 = t1.length;
                if (t3 === 0 && t2.length === 0) return result;
                if (t3 > 1 || t2.length > 1) return _null;
                $label2$2: {
                    t3 = A.IterableExtension_get_firstOrNull(t1);
                    t3 = t3 == null ? _null : t3.value;
                    t2 = A.IterableExtension_get_firstOrNull(t2);
                    t2 = [
                        t3,
                        t2 == null ? _null : t2.value,
                        components1,
                        components2
                    ];
                    _4_1 = t2[0];
                    _4_3 = B.Combinator_98W === _4_1;
                    t3 = _4_3;
                    _4_5 = _null;
                    _4_4 = _null;
                    if (t3) {
                        _4_4 = t2[1];
                        _4_5 = B.Combinator_98W === _4_4;
                        t3 = _4_5;
                        _4_5_isSet = true;
                        _4_4_isSet = true;
                    } else {
                        _4_5_isSet = false;
                        _4_4_isSet = false;
                        t3 = false;
                    }
                    if (t3) {
                        component1 = components1.removeLast$0(0);
                        component2 = components2.removeLast$0(0);
                        t2 = component1.selector;
                        t3 = component2.selector;
                        if (A.compoundIsSuperselector(t2, t3, _null)) result.addFirst$1(A._setArrayType([
                            A._setArrayType([
                                component2
                            ], type$.JSArray_ComplexSelectorComponent)
                        ], type$.JSArray_List_ComplexSelectorComponent));
                        else {
                            t4 = type$.JSArray_ComplexSelectorComponent;
                            t5 = type$.JSArray_List_ComplexSelectorComponent;
                            if (A.compoundIsSuperselector(t3, t2, _null)) result.addFirst$1(A._setArrayType([
                                A._setArrayType([
                                    component1
                                ], t4)
                            ], t5));
                            else {
                                choices = A._setArrayType([
                                    A._setArrayType([
                                        component1,
                                        component2
                                    ], t4),
                                    A._setArrayType([
                                        component2,
                                        component1
                                    ], t4)
                                ], t5);
                                _2_0 = A.unifyCompound(t2, t3);
                                if (_2_0 != null) choices.push(A._setArrayType([
                                    new A.ComplexSelectorComponent(_2_0, A.List_List$unmodifiable(A._setArrayType([
                                        B.JSArray_methods.get$first(t1)
                                    ], type$.JSArray_CssValue_Combinator), type$.CssValue_Combinator), span)
                                ], t4));
                                result.addFirst$1(choices);
                            }
                        }
                        break $label2$2;
                    }
                    _4_9 = _null;
                    _4_6 = _null;
                    _4_6_isSet = false;
                    _4_7 = _null;
                    _4_7_isSet = false;
                    followingComponents = _null;
                    nextComponents = _null;
                    t3 = false;
                    if (_4_3) {
                        if (_4_4_isSet) t4 = _4_4;
                        else {
                            _4_4 = t2[1];
                            t4 = _4_4;
                            _4_4_isSet = true;
                        }
                        _4_9 = B.Combinator_sHB === t4;
                        t4 = _4_9;
                        if (t4) {
                            _4_6 = t2[2];
                            _4_7 = t2[3];
                            nextComponents = _4_7;
                            followingComponents = _4_6;
                            _4_6_isSet = true;
                            _4_7_isSet = true;
                            t3 = true;
                        }
                        _4_9_isSet = true;
                    } else _4_9_isSet = false;
                    _4_10_isSet = !t3;
                    _4_10 = _null;
                    t3 = true;
                    if (_4_10_isSet) {
                        _4_10 = B.Combinator_sHB === _4_1;
                        t4 = _4_10;
                        if (t4) {
                            if (_4_5_isSet) t4 = _4_5;
                            else {
                                if (_4_4_isSet) t4 = _4_4;
                                else {
                                    _4_4 = t2[1];
                                    t4 = _4_4;
                                    _4_4_isSet = true;
                                }
                                _4_5 = B.Combinator_98W === t4;
                                t4 = _4_5;
                                _4_5_isSet = true;
                            }
                            if (t4) {
                                if (_4_6_isSet) nextComponents = _4_6;
                                else {
                                    _4_6 = t2[2];
                                    nextComponents = _4_6;
                                    _4_6_isSet = true;
                                }
                                if (_4_7_isSet) followingComponents = _4_7;
                                else {
                                    _4_7 = t2[3];
                                    followingComponents = _4_7;
                                    _4_7_isSet = true;
                                }
                            } else t3 = false;
                        } else t3 = false;
                    }
                    if (t3) {
                        next = nextComponents.removeLast$0(0);
                        following = followingComponents.removeLast$0(0);
                        t1 = following.selector;
                        t2 = next.selector;
                        t3 = type$.JSArray_ComplexSelectorComponent;
                        t4 = type$.JSArray_List_ComplexSelectorComponent;
                        if (A.compoundIsSuperselector(t1, t2, _null)) result.addFirst$1(A._setArrayType([
                            A._setArrayType([
                                next
                            ], t3)
                        ], t4));
                        else {
                            t4 = A._setArrayType([
                                A._setArrayType([
                                    following,
                                    next
                                ], t3)
                            ], t4);
                            _3_0 = A.unifyCompound(t1, t2);
                            if (_3_0 != null) t4.push(A._setArrayType([
                                new A.ComplexSelectorComponent(_3_0, A.List_List$unmodifiable(next.combinators, type$.CssValue_Combinator), span)
                            ], t3));
                            result.addFirst$1(t4);
                        }
                        break $label2$2;
                    }
                    t3 = _null;
                    t4 = false;
                    if (B.Combinator_iUF === _4_1) {
                        _4_4_isSet0 = true;
                        if (_4_9_isSet) t5 = _4_9;
                        else {
                            if (_4_4_isSet) t5 = _4_4;
                            else {
                                _4_4 = t2[1];
                                t5 = _4_4;
                                _4_4_isSet = _4_4_isSet0;
                            }
                            _4_9 = B.Combinator_sHB === t5;
                            t5 = _4_9;
                        }
                        if (!t5) {
                            if (_4_5_isSet) t5 = _4_5;
                            else {
                                if (_4_4_isSet) t5 = _4_4;
                                else {
                                    _4_4 = t2[1];
                                    t5 = _4_4;
                                    _4_4_isSet = _4_4_isSet0;
                                }
                                _4_5 = B.Combinator_98W === t5;
                                t5 = _4_5;
                            }
                        } else t5 = true;
                        if (t5) {
                            if (_4_7_isSet) siblingComponents_case_0 = _4_7;
                            else {
                                _4_7 = t2[3];
                                siblingComponents_case_0 = _4_7;
                                _4_7_isSet = true;
                            }
                            t3 = siblingComponents_case_0;
                            t4 = true;
                        }
                    }
                    if (!t4) {
                        if (_4_10_isSet) t4 = _4_10;
                        else {
                            _4_10 = B.Combinator_sHB === _4_1;
                            t4 = _4_10;
                        }
                        if (!t4) t4 = _4_3;
                        else t4 = true;
                        if (t4) {
                            if (_4_4_isSet) t4 = _4_4;
                            else {
                                _4_4 = t2[1];
                                t4 = _4_4;
                                _4_4_isSet = true;
                            }
                            t4 = B.Combinator_iUF === t4;
                            if (t4) {
                                if (_4_6_isSet) siblingComponents_case_1 = _4_6;
                                else {
                                    _4_6 = t2[2];
                                    siblingComponents_case_1 = _4_6;
                                    _4_6_isSet = true;
                                }
                                t3 = siblingComponents_case_1;
                            }
                        } else t4 = false;
                    } else t4 = true;
                    if (t4) {
                        result.addFirst$1(A._setArrayType([
                            A._setArrayType([
                                t3.removeLast$0(0)
                            ], type$.JSArray_ComplexSelectorComponent)
                        ], type$.JSArray_List_ComplexSelectorComponent));
                        break $label2$2;
                    }
                    t3 = _4_1 == null;
                    t4 = !t3;
                    t5 = false;
                    if (t4) {
                        _4_4_isSet0 = true;
                        if (_4_4_isSet) t6 = _4_4;
                        else {
                            _4_4 = t2[1];
                            t6 = _4_4;
                            _4_4_isSet = _4_4_isSet0;
                        }
                        if (t6 != null) {
                            if (_4_4_isSet) combinator2 = _4_4;
                            else {
                                _4_4 = t2[1];
                                combinator2 = _4_4;
                                _4_4_isSet = _4_4_isSet0;
                            }
                            t5 = _4_1 === (combinator2 == null ? type$.Combinator._as(combinator2) : combinator2);
                        }
                    }
                    if (t5) {
                        unified = A.unifyCompound(components1.removeLast$0(0).selector, components2.removeLast$0(0).selector);
                        if (unified == null) return _null;
                        result.addFirst$1(A._setArrayType([
                            A._setArrayType([
                                new A.ComplexSelectorComponent(unified, A.List_List$unmodifiable(A._setArrayType([
                                    B.JSArray_methods.get$first(t1)
                                ], type$.JSArray_CssValue_Combinator), type$.CssValue_Combinator), span)
                            ], type$.JSArray_ComplexSelectorComponent)
                        ], type$.JSArray_List_ComplexSelectorComponent));
                        break $label2$2;
                    }
                    t1 = _null;
                    t5 = _null;
                    t6 = _null;
                    t7 = false;
                    if (t4) {
                        if (_4_4_isSet) t4 = _4_4;
                        else {
                            _4_4 = t2[1];
                            t4 = _4_4;
                            _4_4_isSet = true;
                        }
                        t4 = t4 == null;
                        if (t4) {
                            if (_4_6_isSet) combinatorComponents_case_0 = _4_6;
                            else {
                                _4_6 = t2[2];
                                combinatorComponents_case_0 = _4_6;
                                _4_6_isSet = true;
                            }
                            if (_4_7_isSet) descendantComponents_case_0 = _4_7;
                            else {
                                _4_7 = t2[3];
                                descendantComponents_case_0 = _4_7;
                                _4_7_isSet = true;
                            }
                            t1 = descendantComponents_case_0;
                            t6 = t1;
                            t1 = _4_1;
                            t5 = combinatorComponents_case_0;
                        }
                        t0 = t6;
                        t6 = t4;
                        t4 = t5;
                        t5 = t0;
                    } else {
                        t4 = t5;
                        t5 = t6;
                        t6 = t7;
                    }
                    if (!t6) {
                        if (t3) {
                            if (_4_4_isSet) t3 = _4_4;
                            else {
                                _4_4 = t2[1];
                                t3 = _4_4;
                                _4_4_isSet = true;
                            }
                            t3 = t3 != null;
                            if (t3) {
                                combinator_case_1 = _4_4_isSet ? _4_4 : t2[1];
                                if (combinator_case_1 == null) combinator_case_1 = type$.Combinator._as(combinator_case_1);
                                descendantComponents_case_1 = _4_6_isSet ? _4_6 : t2[2];
                                combinatorComponents_case_1 = _4_7_isSet ? _4_7 : t2[3];
                                t1 = combinatorComponents_case_1;
                                t2 = descendantComponents_case_1;
                                t4 = t2;
                                t2 = t1;
                                t1 = combinator_case_1;
                            } else {
                                t2 = t4;
                                t4 = t5;
                            }
                            t0 = t4;
                            t4 = t3;
                            t3 = t0;
                        } else {
                            t3 = t5;
                            t2 = t4;
                            t4 = false;
                        }
                    } else {
                        t3 = t5;
                        t2 = t4;
                        t4 = true;
                    }
                    if (t4) {
                        if (t1 === B.Combinator_iUF) {
                            t1 = A.IterableExtension_get_lastOrNull(t3);
                            t1 = t1 == null ? _null : A.compoundIsSuperselector(t1.selector, t2.get$last(t2).selector, _null);
                            t1 = t1 === true;
                        } else t1 = false;
                        if (t1) t3.removeLast$0(0);
                        result.addFirst$1(A._setArrayType([
                            A._setArrayType([
                                t2.removeLast$0(0)
                            ], type$.JSArray_ComplexSelectorComponent)
                        ], type$.JSArray_List_ComplexSelectorComponent));
                        break $label2$2;
                    }
                    return _null;
                }
                return A._mergeTrailingCombinators(components1, components2, span, result);
            },
            _mustUnify: function(complex1, complex2) {
                var t2, t3, t4, t1 = A.LinkedHashSet_LinkedHashSet$_empty(type$.SimpleSelector);
                for(t2 = J.get$iterator$ax(complex1); t2.moveNext$0();)for(t3 = B.JSArray_methods.get$iterator(t2.get$current(t2).selector.components), t4 = new A.WhereIterator(t3, A.functions___isUnique$closure()); t4.moveNext$0();)t1.add$1(0, t3.get$current(0));
                if (t1._collection$_length === 0) return false;
                return J.any$1$ax(complex2, new A._mustUnify_closure(t1));
            },
            _isUnique: function(simple) {
                var t1;
                if (!(simple instanceof A.IDSelector)) t1 = simple instanceof A.PseudoSelector && !simple.isClass;
                else t1 = true;
                return t1;
            },
            _chunks: function(queue1, queue2, done, $T) {
                var chunk2, _0_4, _0_7, _0_5, _0_7_isSet, _0_5_isSet, chunk, t2, _null = null, t1 = $T._eval$1("JSArray<0>"), chunk1 = A._setArrayType([], t1);
                while(!done.call$1(queue1))chunk1.push(queue1.removeFirst$0());
                chunk2 = A._setArrayType([], t1);
                while(!done.call$1(queue2))chunk2.push(queue2.removeFirst$0());
                $label0$0: {
                    _0_4 = chunk1.length <= 0;
                    t1 = _0_4;
                    _0_7 = _null;
                    if (t1) {
                        _0_7 = chunk2.length <= 0;
                        t1 = _0_7;
                        _0_5 = chunk2;
                        _0_7_isSet = true;
                        _0_5_isSet = true;
                    } else {
                        _0_5 = _null;
                        _0_7_isSet = false;
                        _0_5_isSet = false;
                        t1 = false;
                    }
                    if (t1) {
                        t1 = A._setArrayType([], $T._eval$1("JSArray<List<0>>"));
                        break $label0$0;
                    }
                    if (_0_4) {
                        if (_0_5_isSet) chunk = _0_5;
                        else {
                            chunk = chunk2;
                            _0_5 = chunk;
                            _0_5_isSet = true;
                        }
                        t1 = true;
                    } else {
                        chunk = _null;
                        t1 = false;
                    }
                    if (!t1) {
                        if (_0_7_isSet) t1 = _0_7;
                        else {
                            _0_7 = (_0_5_isSet ? _0_5 : chunk2).length <= 0;
                            t1 = _0_7;
                        }
                        chunk = chunk1;
                    } else t1 = true;
                    if (t1) {
                        t1 = A._setArrayType([
                            chunk
                        ], $T._eval$1("JSArray<List<0>>"));
                        break $label0$0;
                    }
                    t1 = A.List_List$_of(chunk1, $T);
                    B.JSArray_methods.addAll$1(t1, chunk2);
                    t2 = A.List_List$_of(chunk2, $T);
                    B.JSArray_methods.addAll$1(t2, chunk1);
                    t1 = A._setArrayType([
                        t1,
                        t2
                    ], $T._eval$1("JSArray<List<0>>"));
                    break $label0$0;
                }
                return t1;
            },
            paths: function(choices, $T) {
                return J.fold$2$ax(choices, A._setArrayType([
                    A._setArrayType([], $T._eval$1("JSArray<0>"))
                ], $T._eval$1("JSArray<List<0>>")), new A.paths_closure($T));
            },
            _groupSelectors: function(complex) {
                var t2, t3, t4, groups = A.QueueList$(null, type$.List_ComplexSelectorComponent), t1 = type$.JSArray_ComplexSelectorComponent, group = A._setArrayType([], t1);
                for(t2 = complex.$ti, t3 = new A.ListIterator(complex, complex.get$length(0), t2._eval$1("ListIterator<ListBase.E>")), t2 = t2._eval$1("ListBase.E"); t3.moveNext$0();){
                    t4 = t3.__internal$_current;
                    if (t4 == null) t4 = t2._as(t4);
                    group.push(t4);
                    if (t4.combinators.length === 0) {
                        groups._queue_list$_add$1(group);
                        group = A._setArrayType([], t1);
                    }
                }
                if (group.length !== 0) groups._queue_list$_add$1(group);
                return groups;
            },
            listIsSuperselector: function(list1, list2) {
                return B.JSArray_methods.every$1(list2, new A.listIsSuperselector_closure(list1));
            },
            _complexIsParentSuperselector: function(complex1, complex2) {
                var t1, base, t2;
                if (J.get$length$asx(complex1) > J.get$length$asx(complex2)) return false;
                t1 = $.$get$bogusSpan();
                base = new A.ComplexSelectorComponent(A.CompoundSelector$(A._setArrayType([
                    new A.PlaceholderSelector("<temp>", t1)
                ], type$.JSArray_SimpleSelector), t1), A.List_List$unmodifiable(B.List_empty0, type$.CssValue_Combinator), t1);
                t1 = type$.ComplexSelectorComponent;
                t2 = A.List_List$_of(complex1, t1);
                t2.push(base);
                t1 = A.List_List$_of(complex2, t1);
                t1.push(base);
                return A.complexIsSuperselector(t2, t1);
            },
            complexIsSuperselector: function(complex1, complex2) {
                var t1, t2, previousCombinator, i1, i2, remaining1, remaining2, component1, t3, t4, endOfSubselector, component2, t5, combinator1, _null = null;
                if (B.JSArray_methods.get$last(complex1).combinators.length !== 0) return false;
                if (B.JSArray_methods.get$last(complex2).combinators.length !== 0) return false;
                for(t1 = A._arrayInstanceType(complex2), t2 = t1._precomputed1, t1 = t1._eval$1("SubListIterable<1>"), previousCombinator = _null, i1 = 0, i2 = 0;; previousCombinator = combinator1){
                    remaining1 = complex1.length - i1;
                    remaining2 = complex2.length - i2;
                    if (remaining1 === 0 || remaining2 === 0) return false;
                    if (remaining1 > remaining2) return false;
                    component1 = complex1[i1];
                    t3 = component1.combinators;
                    if (t3.length > 1) return false;
                    if (remaining1 === 1) {
                        if (B.JSArray_methods.any$1(complex2, new A.complexIsSuperselector_closure())) return false;
                        else {
                            t1 = component1.selector;
                            t2 = B.JSArray_methods.get$last(complex2);
                            t3 = t1.get$hasComplicatedSuperselectorSemantics() ? B.JSArray_methods.sublist$2(complex2, i2, complex2.length - 1) : _null;
                            return A.compoundIsSuperselector(t1, t2.selector, t3);
                        }
                    }
                    for(t4 = component1.selector, endOfSubselector = i2;;){
                        component2 = complex2[endOfSubselector];
                        if (component2.combinators.length > 1) return false;
                        t5 = t4.get$hasComplicatedSuperselectorSemantics() ? B.JSArray_methods.sublist$2(complex2, i2, endOfSubselector) : _null;
                        if (A.compoundIsSuperselector(t4, component2.selector, t5)) break;
                        ++endOfSubselector;
                        if (endOfSubselector === complex2.length - 1) return false;
                    }
                    t4 = new A.SubListIterable(complex2, 0, endOfSubselector, t1);
                    t4.SubListIterable$3(complex2, 0, endOfSubselector, t2);
                    if (!A._compatibleWithPreviousCombinator(previousCombinator, t4.skip$1(0, i2))) return false;
                    component2 = complex2[endOfSubselector];
                    combinator1 = A.IterableExtension_get_firstOrNull(t3);
                    if (!A._isSupercombinator(combinator1, A.IterableExtension_get_firstOrNull(component2.combinators))) return false;
                    ++i1;
                    i2 = endOfSubselector + 1;
                    if (complex1.length - i1 === 1) {
                        t3 = combinator1 == null;
                        if ((t3 ? _null : combinator1.value) === B.Combinator_98W) {
                            t3 = complex2.length - 1;
                            t4 = new A.SubListIterable(complex2, 0, t3, t1);
                            t4.SubListIterable$3(complex2, 0, t3, t2);
                            if (!t4.skip$1(0, i2).every$1(0, new A.complexIsSuperselector_closure0(combinator1))) return false;
                        } else if (!t3) {
                            if (complex2.length - i2 > 1) return false;
                        }
                    }
                }
            },
            _compatibleWithPreviousCombinator: function(previous, parents) {
                if (parents.get$isEmpty(parents)) return true;
                if (previous == null) return true;
                if (previous.value !== B.Combinator_98W) return false;
                return parents.every$1(0, new A._compatibleWithPreviousCombinator_closure());
            },
            _isSupercombinator: function(combinator1, combinator2) {
                var t2, t3, t1 = true;
                if (!J.$eq$(combinator1, combinator2)) {
                    t2 = combinator1 == null;
                    if (t2) t3 = (combinator2 == null ? null : combinator2.value) === B.Combinator_iUF;
                    else t3 = false;
                    if (!t3) {
                        if ((t2 ? null : combinator1.value) === B.Combinator_98W) t1 = (combinator2 == null ? null : combinator2.value) === B.Combinator_sHB;
                        else t1 = false;
                    }
                }
                return t1;
            },
            compoundIsSuperselector: function(compound1, compound2, parents) {
                var t1, _0_1, _0_5, _0_5_isSet, _0_50, index1, pseudo2, index2, t2, pseudo1, t3, t4, t5, _i, simple1, _null = null;
                if (!compound1.get$hasComplicatedSuperselectorSemantics() && !compound2.get$hasComplicatedSuperselectorSemantics()) {
                    t1 = compound1.components;
                    if (t1.length > compound2.components.length) return false;
                    return B.JSArray_methods.every$1(t1, new A.compoundIsSuperselector_closure(compound2));
                }
                _0_1 = A._findPseudoElementIndexed(compound1);
                _0_5 = A._findPseudoElementIndexed(compound2);
                t1 = type$.Record_2_nullable_Object_and_nullable_Object;
                _0_5_isSet = t1._is(_0_1);
                _0_50 = _null;
                index1 = _null;
                pseudo2 = _null;
                index2 = _null;
                t2 = false;
                if (_0_5_isSet) {
                    pseudo1 = _0_1._0;
                    index1 = _0_1._1;
                    t1 = t1._is(_0_5);
                    if (t1) {
                        pseudo2 = _0_5._0;
                        index2 = _0_5._1;
                    }
                    _0_50 = _0_5;
                } else {
                    t1 = t2;
                    pseudo1 = _null;
                }
                if (t1) {
                    if (pseudo1.isSuperselector$1(pseudo2)) {
                        t1 = compound1.components;
                        t2 = type$.int;
                        t3 = A._arrayInstanceType(t1)._precomputed1;
                        t4 = compound2.components;
                        t5 = A._arrayInstanceType(t4)._precomputed1;
                        t1 = A._compoundComponentsIsSuperselector(A.SubListIterable$(t1, 0, A.checkNotNullable(index1, "count", t2), t3), A.SubListIterable$(t4, 0, A.checkNotNullable(index2, "count", t2), t5), parents) && A._compoundComponentsIsSuperselector(A.SubListIterable$(t1, index1 + 1, _null, t3), A.SubListIterable$(t4, index2 + 1, _null, t5), parents);
                    } else t1 = false;
                    return t1;
                }
                if (_0_1 == null) t1 = (_0_5_isSet ? _0_50 : _0_5) != null;
                else t1 = true;
                if (t1) return false;
                for(t1 = compound1.components, t2 = t1.length, t3 = compound2.components, _i = 0; _i < t2; ++_i){
                    simple1 = t1[_i];
                    if (simple1 instanceof A.PseudoSelector) t4 = simple1.selector != null;
                    else t4 = false;
                    if (t4) {
                        if (!A._selectorPseudoIsSuperselector(simple1, compound2, parents)) return false;
                    } else if (!B.JSArray_methods.any$1(t3, simple1.get$isSuperselector())) return false;
                }
                return true;
            },
            _findPseudoElementIndexed: function(compound) {
                var t1, t2, i, simple;
                for(t1 = compound.components, t2 = t1.length, i = 0; i < t2; ++i){
                    simple = t1[i];
                    if (simple instanceof A.PseudoSelector && !simple.isClass) return new A._Record_2(simple, i);
                }
                return null;
            },
            _compoundComponentsIsSuperselector: function(compound1, compound2, parents) {
                var t1;
                if (compound1.get$length(0) === 0) return true;
                if (compound2.get$length(0) === 0) compound2 = A._setArrayType([
                    new A.UniversalSelector("*", $.$get$bogusSpan())
                ], type$.JSArray_SimpleSelector);
                t1 = $.$get$bogusSpan();
                return A.compoundIsSuperselector(A.CompoundSelector$(compound1, t1), A.CompoundSelector$(compound2, t1), parents);
            },
            _selectorPseudoIsSuperselector: function(pseudo1, compound2, parents) {
                var selector1 = pseudo1.selector;
                if (selector1 == null) throw A.wrapException(A.ArgumentError$("Selector " + pseudo1.toString$0(0) + " must have a selector argument.", null));
                switch(pseudo1.normalizedName){
                    case "is":
                    case "matches":
                    case "any":
                    case "where":
                        return A._selectorPseudoArgs(compound2, pseudo1.name, true).any$1(0, new A._selectorPseudoIsSuperselector_closure(selector1)) || B.JSArray_methods.any$1(selector1.components, new A._selectorPseudoIsSuperselector_closure0(parents, compound2));
                    case "has":
                    case "host":
                    case "host-context":
                        return A._selectorPseudoArgs(compound2, pseudo1.name, true).any$1(0, new A._selectorPseudoIsSuperselector_closure1(selector1));
                    case "slotted":
                        return A._selectorPseudoArgs(compound2, pseudo1.name, false).any$1(0, new A._selectorPseudoIsSuperselector_closure2(selector1));
                    case "not":
                        return B.JSArray_methods.every$1(selector1.components, new A._selectorPseudoIsSuperselector_closure3(compound2, pseudo1));
                    case "current":
                        return A._selectorPseudoArgs(compound2, pseudo1.name, true).any$1(0, new A._selectorPseudoIsSuperselector_closure4(selector1));
                    case "nth-child":
                    case "nth-last-child":
                        return B.JSArray_methods.any$1(compound2.components, new A._selectorPseudoIsSuperselector_closure5(pseudo1, selector1));
                    default:
                        throw A.wrapException("unreachable");
                }
            },
            _selectorPseudoArgs: function(compound, $name, isClass) {
                var t1 = type$.WhereTypeIterable_PseudoSelector;
                return new A.NonNullsIterable(new A.MappedIterable(new A.WhereIterable(new A.WhereTypeIterable(compound.components, t1), new A._selectorPseudoArgs_closure(isClass, $name), t1._eval$1("WhereIterable<Iterable.E>")), new A._selectorPseudoArgs_closure0(), t1._eval$1("MappedIterable<Iterable.E,SelectorList?>")), type$.NonNullsIterable_SelectorList);
            },
            unifyComplex_closure: function unifyComplex_closure() {},
            _weaveParents_closure: function _weaveParents_closure(t0) {
                this.span = t0;
            },
            _weaveParents_closure0: function _weaveParents_closure0(t0) {
                this.group = t0;
            },
            _weaveParents_closure1: function _weaveParents_closure1() {},
            _weaveParents_closure2: function _weaveParents_closure2() {},
            _mustUnify_closure: function _mustUnify_closure(t0) {
                this.uniqueSelectors = t0;
            },
            _mustUnify__closure: function _mustUnify__closure(t0) {
                this.uniqueSelectors = t0;
            },
            paths_closure: function paths_closure(t0) {
                this.T = t0;
            },
            paths__closure: function paths__closure(t0, t1) {
                this.paths = t0;
                this.T = t1;
            },
            paths___closure: function paths___closure(t0, t1) {
                this.option = t0;
                this.T = t1;
            },
            listIsSuperselector_closure: function listIsSuperselector_closure(t0) {
                this.list1 = t0;
            },
            listIsSuperselector__closure: function listIsSuperselector__closure(t0) {
                this.complex1 = t0;
            },
            complexIsSuperselector_closure: function complexIsSuperselector_closure() {},
            complexIsSuperselector_closure0: function complexIsSuperselector_closure0(t0) {
                this.combinator1 = t0;
            },
            _compatibleWithPreviousCombinator_closure: function _compatibleWithPreviousCombinator_closure() {},
            compoundIsSuperselector_closure: function compoundIsSuperselector_closure(t0) {
                this.compound2 = t0;
            },
            _selectorPseudoIsSuperselector_closure: function _selectorPseudoIsSuperselector_closure(t0) {
                this.selector1 = t0;
            },
            _selectorPseudoIsSuperselector_closure0: function _selectorPseudoIsSuperselector_closure0(t0, t1) {
                this.parents = t0;
                this.compound2 = t1;
            },
            _selectorPseudoIsSuperselector_closure1: function _selectorPseudoIsSuperselector_closure1(t0) {
                this.selector1 = t0;
            },
            _selectorPseudoIsSuperselector_closure2: function _selectorPseudoIsSuperselector_closure2(t0) {
                this.selector1 = t0;
            },
            _selectorPseudoIsSuperselector_closure3: function _selectorPseudoIsSuperselector_closure3(t0, t1) {
                this.compound2 = t0;
                this.pseudo1 = t1;
            },
            _selectorPseudoIsSuperselector__closure: function _selectorPseudoIsSuperselector__closure(t0, t1) {
                this.complex = t0;
                this.pseudo1 = t1;
            },
            _selectorPseudoIsSuperselector___closure: function _selectorPseudoIsSuperselector___closure(t0) {
                this.simple2 = t0;
            },
            _selectorPseudoIsSuperselector___closure0: function _selectorPseudoIsSuperselector___closure0(t0) {
                this.simple2 = t0;
            },
            _selectorPseudoIsSuperselector_closure4: function _selectorPseudoIsSuperselector_closure4(t0) {
                this.selector1 = t0;
            },
            _selectorPseudoIsSuperselector_closure5: function _selectorPseudoIsSuperselector_closure5(t0, t1) {
                this.pseudo1 = t0;
                this.selector1 = t1;
            },
            _selectorPseudoArgs_closure: function _selectorPseudoArgs_closure(t0, t1) {
                this.isClass = t0;
                this.name = t1;
            },
            _selectorPseudoArgs_closure0: function _selectorPseudoArgs_closure0() {},
            MergedExtension_merge: function(left, right) {
                var t2, t3, t4, t1 = left.extender.selector;
                if (!t1.$eq(0, right.extender.selector) || !left.target.$eq(0, right.target)) throw A.wrapException(A.ArgumentError$(left.toString$0(0) + " and " + right.toString$0(0) + " aren't the same extension.", null));
                t2 = left.mediaContext;
                t3 = t2 == null;
                if (!t3) {
                    t4 = right.mediaContext;
                    t4 = t4 != null && !B.C_ListEquality.equals$2(0, t2, t4);
                } else t4 = false;
                if (t4) throw A.wrapException(A.SassException$("From " + left.span.message$1(0, "") + string$.x0aYou_m, right.span, null));
                if (right.isOptional && right.mediaContext == null) return left;
                if (left.isOptional && t3) return right;
                if (t3) t2 = right.mediaContext;
                t1.get$specificity();
                t1 = new A.Extender(t1, false);
                return t1._extension = new A.MergedExtension(left, right, t1, left.target, t2, true, left.span);
            },
            MergedExtension: function MergedExtension(t0, t1, t2, t3, t4, t5, t6) {
                var _ = this;
                _.left = t0;
                _.right = t1;
                _.extender = t2;
                _.target = t3;
                _.mediaContext = t4;
                _.isOptional = t5;
                _.span = t6;
            },
            ExtendMode: function ExtendMode(t0, t1, t2) {
                this.name = t0;
                this.index = t1;
                this._name = t2;
            },
            globalFunctions_closure: function globalFunctions_closure() {},
            _invert: function($arguments, global) {
                var t2, color, rgb, channel2, space, weight, inSpace, t3, _1_9, channel0, channel1, t4, _s6_ = "weight", _s5_ = "space", t1 = J.getInterceptor$asx($arguments), weightNumber = t1.$index($arguments, 1).assertNumber$1(_s6_);
                if (!(t1.$index($arguments, 0) instanceof A.SassNumber)) t2 = global && t1.$index($arguments, 0).get$isSpecialNumber();
                else t2 = true;
                if (t2) {
                    if (weightNumber._number$_value !== 100 || !weightNumber.hasUnit$1("%")) throw A.wrapException(string$.Only_oa);
                    return A._functionString("invert", t1.take$1($arguments, 1));
                }
                color = t1.$index($arguments, 0).assertColor$1("color");
                if (t1.$index($arguments, 2).$eq(0, B.C__SassNull)) {
                    t1 = color._space;
                    if (!t1.get$isLegacyInternal()) throw A.wrapException(A.SassScriptException$(string$.To_usei + color.toString$0(0) + ", you must provide a $space.", "color"));
                    A._checkPercent(weightNumber, _s6_);
                    rgb = color.toSpace$1(B.RgbColorSpace_i0P);
                    channel2 = B.LinearChannel_vJ3;
                    return A._mixLegacy(A.SassColor_SassColor$rgbInternal(A._invertChannel(rgb, B.LinearChannel_qXC, rgb.channel0OrNull), A._invertChannel(rgb, B.LinearChannel_Z5r, rgb.channel1OrNull), A._invertChannel(rgb, channel2, rgb.channel2OrNull), color.alphaOrNull, null), color, weightNumber).toSpace$1(t1);
                }
                t1 = t1.$index($arguments, 2).assertString$1(_s5_);
                t1.assertUnquoted$1(_s5_);
                space = A.ColorSpace_fromName(t1._string$_text, _s5_);
                weight = weightNumber.valueInRangeWithUnit$4(0, 100, _s6_, "%") / 100;
                if (A.fuzzyEquals(weight, 0)) return color;
                inSpace = color.toSpace$1(space);
                $label0$0: {
                    if (B.HwbColorSpace_guQ === space) {
                        t1 = A._invertChannel(inSpace, space._channels[0], inSpace.channel0OrNull);
                        t2 = inSpace.alphaOrNull;
                        if (t2 == null) t2 = 0;
                        t2 = A.SassColor_SassColor$hwb(t1, inSpace.channel2OrNull, inSpace.channel1OrNull, t2);
                        t1 = t2;
                        break $label0$0;
                    }
                    if (B.HslColorSpace_JQ2 === space || B.LchColorSpace_Bpv === space || B.OklchColorSpace_9Gj === space) {
                        t1 = space._channels;
                        t2 = A._invertChannel(inSpace, t1[0], inSpace.channel0OrNull);
                        t1 = A._invertChannel(inSpace, t1[2], inSpace.channel2OrNull);
                        t3 = inSpace.alphaOrNull;
                        if (t3 == null) t3 = 0;
                        t3 = A.SassColor_SassColor$forSpaceInternal(space, t2, inSpace.channel1OrNull, t1, t3);
                        t1 = t3;
                        break $label0$0;
                    }
                    _1_9 = space._channels;
                    channel0 = _1_9[0];
                    channel1 = _1_9[1];
                    channel2 = _1_9[2];
                    t1 = A._invertChannel(inSpace, channel0, inSpace.channel0OrNull);
                    t2 = A._invertChannel(inSpace, channel1, inSpace.channel1OrNull);
                    t3 = A._invertChannel(inSpace, channel2, inSpace.channel2OrNull);
                    t4 = inSpace.alphaOrNull;
                    t1 = A.SassColor_SassColor$forSpaceInternal(space, t1, t2, t3, t4 == null ? 0 : t4);
                    break $label0$0;
                }
                return A.fuzzyEquals(weight, 1) ? t1.toSpace$2$legacyMissing(color._space, false) : color.interpolate$4$legacyMissing$weight(t1, A.InterpolationMethod$(space, null), false, 1 - weight);
            },
            _invertChannel: function(color, channel, value) {
                var _0_2_isSet, _0_2, t1;
                if (value == null) A._missingChannelError(color, channel.name);
                $label0$0: {
                    _0_2_isSet = channel instanceof A.LinearChannel;
                    _0_2 = null;
                    if (_0_2_isSet) {
                        _0_2 = channel.min;
                        t1 = _0_2;
                        t1 = t1 < 0;
                    } else t1 = false;
                    if (t1) {
                        t1 = -value;
                        break $label0$0;
                    }
                    if (_0_2_isSet) t1 = 0 === _0_2;
                    else t1 = false;
                    if (t1) {
                        t1 = channel.max - value;
                        break $label0$0;
                    }
                    if (channel.isPolarAngle) {
                        t1 = B.JSNumber_methods.$mod(value + 180, 360);
                        break $label0$0;
                    }
                    t1 = A.throwExpression(A.UnsupportedError$("Unknown channel " + channel.toString$0(0) + "."));
                }
                return t1;
            },
            _grayscale: function(colorArg) {
                var hsl, t2, oklch, color = colorArg.assertColor$1("color"), t1 = color._space;
                if (t1.get$isLegacyInternal()) {
                    hsl = color.toSpace$1(B.HslColorSpace_JQ2);
                    t2 = hsl.alphaOrNull;
                    if (t2 == null) t2 = 0;
                    return A.SassColor_SassColor$hsl(hsl.channel0OrNull, 0, hsl.channel2OrNull, t2).toSpace$2$legacyMissing(t1, false);
                } else {
                    oklch = color.toSpace$1(B.OklchColorSpace_9Gj);
                    t2 = oklch.alphaOrNull;
                    if (t2 == null) t2 = 0;
                    return A.SassColor_SassColor$forSpaceInternal(B.OklchColorSpace_9Gj, oklch.channel0OrNull, 0, oklch.channel2OrNull, t2).toSpace$1(t1);
                }
            },
            _updateComponents: function($arguments, adjust, change, scale) {
                var t2, t3, keywords, originalColor, spaceKeyword, alphaArg, color, channelArgs, channelInfo, t4, value, channelIndex, result, i, alphaNumber, _null = null, _s5_ = "space", t1 = J.getInterceptor$asx($arguments), argumentList = type$.SassArgumentList._as(t1.$index($arguments, 1));
                if (argumentList._list$_contents.length !== 0) throw A.wrapException(A.SassScriptException$(string$.Only_op, _null));
                argumentList._wereKeywordsAccessed = true;
                t2 = type$.String;
                t3 = type$.Value;
                keywords = A.LinkedHashMap_LinkedHashMap$of(argumentList._keywords, t2, t3);
                originalColor = t1.$index($arguments, 0).assertColor$1("color");
                t1 = keywords.remove$1(0, _s5_);
                spaceKeyword = t1 == null ? _null : t1.assertString$1(_s5_);
                if (spaceKeyword == null) spaceKeyword = _null;
                else spaceKeyword.assertUnquoted$1(_s5_);
                alphaArg = keywords.remove$1(0, "alpha");
                t1 = spaceKeyword == null;
                if (t1 && originalColor._space.get$isLegacyInternal() && keywords.__js_helper$_length !== 0) {
                    t1 = A.NullableExtension_andThen(A._sniffLegacyColorSpace(keywords), new A._updateComponents_closure(originalColor));
                    color = t1 == null ? originalColor : t1;
                } else color = A._colorInSpace(originalColor, t1 ? B.C__SassNull : spaceKeyword, true);
                channelArgs = A.List_List$filled(color.get$channels().length, _null, false, type$.nullable_Value);
                t1 = color._space;
                channelInfo = t1._channels;
                for(t2 = A.MapExtensions_get_pairs(keywords, t2, t3), t2 = t2.get$iterator(t2); t2.moveNext$0();){
                    t3 = {};
                    t4 = t2.get$current(t2);
                    t3.name = null;
                    t3.name = t4._0;
                    value = t4._1;
                    channelIndex = B.JSArray_methods.indexWhere$1(channelInfo, new A._updateComponents_closure0(t3));
                    if (channelIndex === -1) throw A.wrapException(A.SassScriptException$("Color space " + t1.toString$0(0) + " doesn't have a channel with this name.", t3.name));
                    channelArgs[channelIndex] = value;
                }
                if (change) result = A._changeColor(color, channelArgs, alphaArg);
                else {
                    t2 = A._setArrayType([], type$.JSArray_nullable_SassNumber);
                    for(i = 0; i < 3; ++i){
                        t3 = channelArgs[i];
                        t2.push(t3 == null ? _null : t3.assertNumber$1(channelInfo[i].name));
                    }
                    alphaNumber = alphaArg == null ? _null : alphaArg.assertNumber$1("alpha");
                    result = scale ? A.SassColor_SassColor$forSpaceInternal(t1, A._scaleChannel(color, channelInfo[0], color.channel0OrNull, t2[0]), A._scaleChannel(color, channelInfo[1], color.channel1OrNull, t2[1]), A._scaleChannel(color, channelInfo[2], color.channel2OrNull, t2[2]), A._scaleChannel(color, B.LinearChannel_XL8, color.alphaOrNull, alphaNumber)) : A._adjustColor(color, t2, alphaNumber);
                }
                return result.toSpace$2$legacyMissing(originalColor._space, false);
            },
            _changeColor: function(color, channelArgs, alphaArg) {
                var t4, _s5_ = "alpha", t1 = A._channelForChange(channelArgs[0], color, 0), t2 = A._channelForChange(channelArgs[1], color, 1), t3 = A._channelForChange(channelArgs[2], color, 2);
                $label0$0: {
                    if (alphaArg == null) {
                        t4 = color.alphaOrNull;
                        if (t4 == null) t4 = 0;
                        break $label0$0;
                    }
                    t4 = A._isNone(alphaArg);
                    if (t4) {
                        t4 = null;
                        break $label0$0;
                    }
                    t4 = alphaArg instanceof A.SassNumber;
                    if (t4 && !alphaArg.get$hasUnits()) {
                        t4 = alphaArg.valueInRange$3(0, 1, _s5_);
                        break $label0$0;
                    }
                    if (t4 && alphaArg.hasUnit$1("%")) {
                        t4 = alphaArg.valueInRangeWithUnit$4(0, 100, _s5_, "%") / 100;
                        break $label0$0;
                    }
                    if (t4) {
                        t4 = new A._changeColor_closure(alphaArg).call$0();
                        break $label0$0;
                    }
                    t4 = A.throwExpression(A.SassScriptException$(alphaArg.toString$0(0) + ' is not a number or unquoted "none".', _s5_));
                }
                return A._colorFromChannels(color._space, t1, t2, t3, t4, false, false);
            },
            _channelForChange: function(channelArg, color, channel) {
                var _0_0, t1, t2;
                if (channelArg == null) {
                    _0_0 = color.get$channelsOrNull()[channel];
                    $label0$0: {
                        if (_0_0 != null) {
                            t1 = color._space;
                            t2 = A.SassNumber_SassNumber(_0_0, (t1 === B.HslColorSpace_JQ2 || t1 === B.HwbColorSpace_guQ) && channel > 0 ? "%" : null);
                            t1 = t2;
                            break $label0$0;
                        }
                        t1 = null;
                        break $label0$0;
                    }
                    return t1;
                }
                if (A._isNone(channelArg)) return null;
                if (channelArg instanceof A.SassNumber) return channelArg;
                throw A.wrapException(A.SassScriptException$(channelArg.toString$0(0) + ' is not a number or unquoted "none".', color._space._channels[channel].name));
            },
            _scaleChannel: function(color, channel, oldValue, factorArg) {
                var t1, factor;
                if (factorArg == null) return oldValue;
                if (!(channel instanceof A.LinearChannel)) throw A.wrapException(A.SassScriptException$("Channel isn't scalable.", channel.name));
                if (oldValue == null) A._missingChannelError(color, channel.name);
                t1 = channel.name;
                factorArg.assertUnit$2("%", t1);
                factor = factorArg.valueInRangeWithUnit$4(-100, 100, t1, "%") / 100;
                $label0$0: {
                    if (0 === factor) {
                        t1 = oldValue;
                        break $label0$0;
                    }
                    if (factor > 0) {
                        t1 = channel.max;
                        t1 = oldValue >= t1 ? oldValue : oldValue + (t1 - oldValue) * factor;
                        break $label0$0;
                    }
                    t1 = channel.min;
                    t1 = oldValue <= t1 ? oldValue : oldValue + (oldValue - t1) * factor;
                    break $label0$0;
                }
                return t1;
            },
            _adjustColor: function(color, channelArgs, alphaArg) {
                var t1 = color._space, t2 = t1._channels;
                return A.SassColor_SassColor$forSpaceInternal(t1, A._adjustChannel(color, t2[0], color.channel0OrNull, channelArgs[0]), A._adjustChannel(color, t2[1], color.channel1OrNull, channelArgs[1]), A._adjustChannel(color, t2[2], color.channel2OrNull, channelArgs[2]), A.NullableExtension_andThen(A._adjustChannel(color, B.LinearChannel_XL8, color.alphaOrNull, alphaArg), new A._adjustColor_closure()));
            },
            _adjustChannel: function(color, channel, oldValue, adjustmentArg) {
                var _0_1, _0_3, t1, _0_6_isSet, _0_6, _0_6_isSet0, t2, _0_11, result, min, max, _null = null;
                if (adjustmentArg == null) return oldValue;
                if (oldValue == null) A._missingChannelError(color, channel.name);
                $label0$0: {
                    _0_1 = color._space;
                    _0_3 = B.HslColorSpace_JQ2 === _0_1;
                    t1 = _0_3;
                    if (!t1) _0_6_isSet = B.HwbColorSpace_guQ === _0_1;
                    else _0_6_isSet = true;
                    if (_0_6_isSet) {
                        t1 = channel.isPolarAngle;
                        _0_6 = channel;
                    } else {
                        _0_6 = _null;
                        t1 = false;
                    }
                    if (t1) {
                        adjustmentArg = A.SassNumber_SassNumber(A._angleValue(adjustmentArg, "hue"), _null);
                        break $label0$0;
                    }
                    t1 = false;
                    if (_0_3) {
                        _0_6_isSet0 = true;
                        if (_0_6_isSet) t2 = _0_6;
                        else {
                            t2 = channel;
                            _0_6_isSet = _0_6_isSet0;
                            _0_6 = t2;
                        }
                        if (t2 instanceof A.LinearChannel) {
                            if (_0_6_isSet) t1 = _0_6;
                            else {
                                t1 = channel;
                                _0_6_isSet = _0_6_isSet0;
                                _0_6 = t1;
                            }
                            _0_11 = type$.LinearChannel._as(t1).name;
                            t1 = _0_11;
                            if ("saturation" !== t1) t1 = "lightness" === _0_11;
                            else t1 = true;
                        }
                    }
                    if (t1) {
                        A._checkPercent(adjustmentArg, channel.name);
                        adjustmentArg = A.SassNumber_SassNumber(adjustmentArg._number$_value, "%");
                        break $label0$0;
                    }
                    if (B.LinearChannel_XL8 === (_0_6_isSet ? _0_6 : channel) && adjustmentArg.get$hasUnits()) {
                        A.warnForDeprecation("$alpha: Passing a number with unit " + adjustmentArg.get$unitString() + string$.x20is_de + adjustmentArg.unitSuggestion$1("alpha") + string$.x0a_Morex3af, B.Deprecation_7TE);
                        adjustmentArg = A.SassNumber_SassNumber(adjustmentArg._number$_value, _null);
                    }
                }
                t1 = A._channelFromValue(channel, adjustmentArg, false);
                t1.toString;
                result = oldValue + t1;
                $label1$1: {
                    t1 = channel instanceof A.LinearChannel;
                    min = _null;
                    t2 = false;
                    if (t1) {
                        if (channel.lowerClamped) {
                            min = channel.min;
                            t2 = result < min;
                        }
                    }
                    if (t2) {
                        t1 = oldValue < min ? Math.max(oldValue, result) : min;
                        break $label1$1;
                    }
                    max = _null;
                    t2 = false;
                    if (t1) {
                        if (channel.upperClamped) {
                            max = channel.max;
                            t1 = result > max;
                        } else t1 = t2;
                    } else t1 = t2;
                    if (t1) {
                        t1 = oldValue > max ? Math.min(oldValue, result) : max;
                        break $label1$1;
                    }
                    t1 = result;
                    break $label1$1;
                }
                return t1;
            },
            _sniffLegacyColorSpace: function(keywords) {
                var t1, t2;
                for(t1 = new A.LinkedHashMapKeyIterator(keywords, keywords._modifications, keywords._first); t1.moveNext$0();){
                    t2 = t1.__js_helper$_current;
                    if ("red" === t2 || "green" === t2 || "blue" === t2) return B.RgbColorSpace_i0P;
                    if ("saturation" === t2 || "lightness" === t2) return B.HslColorSpace_JQ2;
                    if ("whiteness" === t2 || "blackness" === t2) return B.HwbColorSpace_guQ;
                }
                return keywords.containsKey$1("hue") ? B.HslColorSpace_JQ2 : null;
            },
            _functionString: function($name, $arguments) {
                return new A.SassString($name + "(" + J.map$1$1$ax($arguments, new A._functionString_closure(), type$.String).join$1(0, ", ") + ")", false);
            },
            _removedColorFunction: function($name, argument, negative) {
                return A.BuiltInCallable$function($name, "$color, $amount", new A._removedColorFunction_closure($name, argument, negative), "sass:color");
            },
            _rgb: function($name, $arguments) {
                var t3, t4, t1 = J.getInterceptor$asx($arguments), alpha = t1.get$length($arguments) > 3 ? t1.$index($arguments, 3) : null, t2 = true;
                if (!t1.$index($arguments, 0).get$isSpecialNumber()) {
                    if (!t1.$index($arguments, 1).get$isSpecialNumber()) {
                        if (!t1.$index($arguments, 2).get$isSpecialNumber()) {
                            t2 = alpha == null ? null : alpha.get$isSpecialNumber();
                            t2 = t2 === true;
                        }
                    }
                }
                if (t2) return A._functionString($name, $arguments);
                t2 = t1.$index($arguments, 0).assertNumber$1("red");
                t3 = t1.$index($arguments, 1).assertNumber$1("green");
                t1 = t1.$index($arguments, 2).assertNumber$1("blue");
                t4 = A.NullableExtension_andThen(alpha, new A._rgb_closure());
                return A._colorFromChannels(B.RgbColorSpace_i0P, t2, t3, t1, t4 == null ? 1 : t4, true, true);
            },
            _rgbTwoArg: function($name, $arguments) {
                var t2, color, t1 = J.getInterceptor$asx($arguments), first = t1.$index($arguments, 0), second = t1.$index($arguments, 1);
                if (!first.get$isSpecialVariable()) t2 = !(first instanceof A.SassColor) && second.get$isSpecialVariable();
                else t2 = true;
                if (t2) return A._functionString($name, $arguments);
                color = first.assertColor$1("color");
                if (!color._space.get$isLegacyInternal()) throw A.wrapException(A.SassScriptException$("Expected " + color.toString$0(0) + string$.x20to_be_ + color.toString$0(0) + ", $alpha: " + second.toString$0(0) + ")", $name));
                color.assertLegacy$1("color");
                color = color.toSpace$1(B.RgbColorSpace_i0P);
                if (second.get$isSpecialNumber()) return A._functionString($name, A._setArrayType([
                    A.SassNumber_SassNumber(color.channel$1(0, "red"), null),
                    A.SassNumber_SassNumber(color.channel$1(0, "green"), null),
                    A.SassNumber_SassNumber(color.channel$1(0, "blue"), null),
                    t1.$index($arguments, 1)
                ], type$.JSArray_Value));
                t1 = A._percentageOrUnitless(t1.$index($arguments, 1).assertNumber$1("alpha"), 1, "alpha");
                return color.changeAlpha$1(isNaN(t1) ? 0 : B.JSNumber_methods.clamp$2(t1, 0, 1));
            },
            _hsl: function($name, $arguments) {
                var t3, t4, t1 = J.getInterceptor$asx($arguments), alpha = t1.get$length($arguments) > 3 ? t1.$index($arguments, 3) : null, t2 = true;
                if (!t1.$index($arguments, 0).get$isSpecialNumber()) {
                    if (!t1.$index($arguments, 1).get$isSpecialNumber()) {
                        if (!t1.$index($arguments, 2).get$isSpecialNumber()) {
                            t2 = alpha == null ? null : alpha.get$isSpecialNumber();
                            t2 = t2 === true;
                        }
                    }
                }
                if (t2) return A._functionString($name, $arguments);
                t2 = t1.$index($arguments, 0).assertNumber$1("hue");
                t3 = t1.$index($arguments, 1).assertNumber$1("saturation");
                t1 = t1.$index($arguments, 2).assertNumber$1("lightness");
                t4 = A.NullableExtension_andThen(alpha, new A._hsl_closure());
                return A._colorFromChannels(B.HslColorSpace_JQ2, t2, t3, t1, t4 == null ? 1 : t4, true, false);
            },
            _angleValue: function(angleValue, $name) {
                var angle = angleValue.assertNumber$1($name);
                if (angle.compatibleWithUnit$1("deg")) return angle.coerceValueToUnit$1("deg");
                A.warnForDeprecation("$" + $name + ": Passing a unit other than deg (" + angle.toString$0(0) + string$.x29x20is_d_ + angle.unitSuggestion$1($name) + string$.x0a_See_, B.Deprecation_7TE);
                return angle._number$_value;
            },
            _checkPercent: function(number, $name) {
                if (number.hasUnit$1("%")) return;
                A.warnForDeprecation("$" + $name + ": Passing a number without unit % (" + number.toString$0(0) + string$.x29x20is_d_ + number.unitSuggestion$2($name, "%") + string$.x0a_Morex3af, B.Deprecation_7TE);
            },
            _percentageOrUnitless: function(number, max, $name) {
                var value;
                if (!number.get$hasUnits()) value = number._number$_value;
                else if (number.hasUnit$1("%")) value = max * number._number$_value / 100;
                else throw A.wrapException(A.SassScriptException$("Expected " + number.toString$0(0) + ' to have unit "%" or no units.', $name));
                return value;
            },
            _mixLegacy: function(color1, color2, weight) {
                var t2, alphaDistance, weight1, weight2, t3, t4, t5, t6, t7, t8, rgb1 = color1.toSpace$1(B.RgbColorSpace_i0P), rgb2 = color2.toSpace$1(B.RgbColorSpace_i0P), weightScale = weight.valueInRange$3(0, 100, "weight") / 100, normalizedWeight = weightScale * 2 - 1, t1 = color1.alphaOrNull;
                if (t1 == null) t1 = 0;
                t2 = color2.alphaOrNull;
                alphaDistance = t1 - (t2 == null ? 0 : t2);
                t1 = normalizedWeight * alphaDistance;
                weight1 = ((t1 === -1 ? normalizedWeight : (normalizedWeight + alphaDistance) / (1 + t1)) + 1) / 2;
                weight2 = 1 - weight1;
                t1 = rgb1.channel0OrNull;
                if (t1 == null) t1 = 0;
                t2 = rgb2.channel0OrNull;
                if (t2 == null) t2 = 0;
                t3 = rgb1.channel1OrNull;
                if (t3 == null) t3 = 0;
                t4 = rgb2.channel1OrNull;
                if (t4 == null) t4 = 0;
                t5 = rgb1.channel2OrNull;
                if (t5 == null) t5 = 0;
                t6 = rgb2.channel2OrNull;
                if (t6 == null) t6 = 0;
                t7 = rgb1.alphaOrNull;
                if (t7 == null) t7 = 0;
                t8 = rgb2.alphaOrNull;
                if (t8 == null) t8 = 0;
                return A.SassColor_SassColor$rgbInternal(t1 * weight1 + t2 * weight2, t3 * weight1 + t4 * weight2, t5 * weight1 + t6 * weight2, t7 * weightScale + t8 * (1 - weightScale), null);
            },
            _opacify: function($name, $arguments) {
                var result, t1 = J.getInterceptor$asx($arguments), color = t1.$index($arguments, 0).assertColor$1("color"), amount = t1.$index($arguments, 1).assertNumber$1("amount");
                if (!color._space.get$isLegacyInternal()) throw A.wrapException(A.SassScriptException$($name + string$.x28__is_oa, null));
                t1 = color.alphaOrNull;
                if (t1 == null) t1 = 0;
                t1 += amount.valueInRangeWithUnit$4(0, 1, "amount", "");
                result = color.changeAlpha$1(isNaN(t1) ? 0 : B.JSNumber_methods.clamp$2(t1, 0, 1));
                A.warnForDeprecation($name + "() is deprecated. " + A._suggestScaleAndAdjust(color, amount._number$_value, "alpha") + string$.x0a_Morex3ac, B.Deprecation_zUK);
                return result;
            },
            _transparentize: function($name, $arguments) {
                var result, t1 = J.getInterceptor$asx($arguments), color = t1.$index($arguments, 0).assertColor$1("color"), amount = t1.$index($arguments, 1).assertNumber$1("amount");
                if (!color._space.get$isLegacyInternal()) throw A.wrapException(A.SassScriptException$($name + string$.x28__is_oa, null));
                t1 = color.alphaOrNull;
                if (t1 == null) t1 = 0;
                t1 -= amount.valueInRangeWithUnit$4(0, 1, "amount", "");
                result = color.changeAlpha$1(isNaN(t1) ? 0 : B.JSNumber_methods.clamp$2(t1, 0, 1));
                A.warnForDeprecation($name + "() is deprecated. " + A._suggestScaleAndAdjust(color, -amount._number$_value, "alpha") + string$.x0a_Morex3ac, B.Deprecation_zUK);
                return result;
            },
            _colorInSpace: function(colorUntyped, spaceUntyped, legacyMissing) {
                var t1, _s5_ = "space", color = colorUntyped.assertColor$1("color");
                if (spaceUntyped.$eq(0, B.C__SassNull)) return color;
                t1 = spaceUntyped.assertString$1(_s5_);
                t1.assertUnquoted$1(_s5_);
                return color.toSpace$2$legacyMissing(A.ColorSpace_fromName(t1._string$_text, _s5_), legacyMissing);
            },
            _parseChannels: function(functionName, input, $name, space) {
                var parsedSlash, components, alphaValue, _2_0, _2_1, _2_5, t1, t2, _2_6, _2_6_isSet, channels, first, rest, componentList, spaceName, i, channel, channelName, t3, t4, _null = null;
                if (input.get$isSpecialVariable()) return A._functionString(functionName, A._setArrayType([
                    input
                ], type$.JSArray_Value));
                parsedSlash = A._parseSlashChannels(input, $name);
                if (parsedSlash == null) return A._functionString(functionName, A._setArrayType([
                    input
                ], type$.JSArray_Value));
                components = parsedSlash._0;
                alphaValue = parsedSlash._1;
                $label0$0: {
                    _2_0 = components.assertCommonListStyle$2$allowSlash($name, false);
                    _2_1 = _2_0.length;
                    if (_2_1 <= 0) throw A.wrapException(A.SassScriptException$("Color component list may not be empty.", $name));
                    _2_5 = _2_1 >= 1;
                    t1 = _2_5;
                    t2 = false;
                    if (t1) {
                        _2_6 = _2_0[0];
                        if (_2_6 instanceof A.SassString) {
                            type$.SassString._as(_2_6);
                            t1 = !_2_6._hasQuotes && _2_6._string$_text.toLowerCase() === "from";
                        } else t1 = t2;
                        _2_6_isSet = true;
                    } else {
                        t1 = t2;
                        _2_6 = _null;
                        _2_6_isSet = false;
                    }
                    if (t1) return A._functionString(functionName, A._setArrayType([
                        input
                    ], type$.JSArray_Value));
                    t1 = components.get$isSpecialVariable();
                    if (t1) {
                        channels = A._setArrayType([
                            components
                        ], type$.JSArray_Value);
                        break $label0$0;
                    }
                    channels = _null;
                    if (_2_5) {
                        first = _2_6_isSet ? _2_6 : _2_0[0];
                        rest = B.JSArray_methods.sublist$1(_2_0, 1);
                        componentList = _2_0;
                        t1 = true;
                    } else {
                        componentList = channels;
                        rest = componentList;
                        first = _null;
                        t1 = false;
                    }
                    if (t1) {
                        if (space == null) {
                            spaceName = first.assertString$1($name);
                            spaceName.assertUnquoted$1($name);
                            space = spaceName.get$isSpecialVariable() ? _null : A.ColorSpace_fromName(spaceName._string$_text, $name);
                            if (B.RgbColorSpace_i0P === space || B.HslColorSpace_JQ2 === space || B.HwbColorSpace_guQ === space || B.LabColorSpace_2nT === space || B.LchColorSpace_Bpv === space || B.OklabColorSpace_540 === space || B.OklchColorSpace_9Gj === space) throw A.wrapException(A.SassScriptException$(string$.The_co + A.S(space) + ". Use the " + A.S(space) + "() function instead.", $name));
                            channels = rest;
                        } else channels = componentList;
                        for(i = 0; i < channels.length; ++i){
                            channel = channels[i];
                            t1 = false;
                            if (!channel.get$isSpecialNumber()) {
                                if (!(channel instanceof A.SassNumber)) t1 = !(channel instanceof A.SassString && !channel._hasQuotes && channel._string$_text.toLowerCase() === "none");
                            }
                            if (t1) {
                                t1 = _null;
                                if (space == null) channelName = t1;
                                else {
                                    t2 = space._channels;
                                    t2 = i < 3 ? t2[i] : _null;
                                    if (!(t2 == null)) t1 = new A._parseChannels_closure().call$1(t2.name);
                                    channelName = t1;
                                }
                                if (channelName == null) channelName = "channel " + (i + 1);
                                throw A.wrapException(A.SassScriptException$("Expected " + channelName + " to be a number, was " + channel.toString$0(0) + ".", $name));
                            }
                        }
                        break $label0$0;
                    }
                    throw A.wrapException("unreachable");
                }
                t1 = alphaValue == null;
                t2 = t1 ? _null : alphaValue.get$isSpecialNumber();
                if (t2 === true) {
                    if (channels.length === 3 && B.Set_9FDyj.contains$1(0, space)) {
                        t1 = A.List_List$_of(channels, type$.Value);
                        alphaValue.toString;
                        t1.push(alphaValue);
                        t1 = A._functionString(functionName, t1);
                    } else t1 = A._functionString(functionName, A._setArrayType([
                        input
                    ], type$.JSArray_Value));
                    return t1;
                }
                $label1$1: {
                    if (t1) {
                        t2 = 1;
                        break $label1$1;
                    }
                    if (alphaValue instanceof A.SassString && !alphaValue._hasQuotes && "none" === alphaValue._string$_text) {
                        t2 = _null;
                        break $label1$1;
                    }
                    t2 = A._percentageOrUnitless(alphaValue.assertNumber$1($name), 1, "alpha");
                    t2 = isNaN(t2) ? 0 : B.JSNumber_methods.clamp$2(t2, 0, 1);
                    break $label1$1;
                }
                if (space == null) return A._functionString(functionName, A._setArrayType([
                    input
                ], type$.JSArray_Value));
                if (B.JSArray_methods.any$1(channels, new A._parseChannels_closure0())) {
                    if (channels.length === 3 && B.Set_9FDyj.contains$1(0, space)) {
                        t2 = A.List_List$_of(channels, type$.Value);
                        if (!t1) t2.push(alphaValue);
                        t1 = A._functionString(functionName, t2);
                    } else t1 = A._functionString(functionName, A._setArrayType([
                        input
                    ], type$.JSArray_Value));
                    return t1;
                }
                if (channels.length !== 3) throw A.wrapException(A.SassScriptException$("The " + space.toString$0(0) + " color space has 3 channels but " + input.toString$0(0) + " has " + channels.length + ".", $name));
                t1 = channels[0];
                t1 = t1 instanceof A.SassNumber ? t1 : _null;
                t3 = channels[1];
                t3 = t3 instanceof A.SassNumber ? t3 : _null;
                t4 = channels[2];
                t4 = t4 instanceof A.SassNumber ? t4 : _null;
                return A._colorFromChannels(space, t1, t3, t4, t2, true, space === B.RgbColorSpace_i0P);
            },
            _parseSlashChannels: function(input, $name) {
                var _1_1, alphaValue, t1, components, _1_7, _1_8, _1_9, initial, t2, _1_8_isSet, _1_9_isSet, _0_0, _0_1, channel3, alpha, _1_16, _1_16_isSet, _1_9_isSet0, t3, _null = null, _1_0 = input.assertCommonListStyle$2$allowSlash($name, true);
                $label0$0: {
                    _1_1 = _1_0.length;
                    alphaValue = _null;
                    t1 = false;
                    if (_1_1 === 2) {
                        components = _1_0[0];
                        alphaValue = _1_0[1];
                        t1 = input.get$separator(input) === B.ListSeparator_Lul;
                    } else components = _null;
                    if (t1) {
                        t1 = new A._Record_2(components, alphaValue);
                        break $label0$0;
                    }
                    t1 = input.get$separator(input);
                    if (t1 === B.ListSeparator_Lul) {
                        t1 = _1_0.length;
                        A.throwExpression(A.SassScriptException$(string$.Only_2 + t1 + " " + A.pluralize("was", t1, "were") + " passed.", $name));
                    }
                    _1_7 = _1_1 >= 1;
                    t1 = _1_7;
                    _1_8 = _null;
                    _1_9 = _null;
                    initial = _null;
                    t2 = false;
                    if (t1) {
                        _1_8 = B.JSArray_methods.sublist$2(_1_0, 0, _1_1 - 1);
                        initial = _1_8;
                        _1_9 = _1_0[_1_1 - 1];
                        t1 = _1_9;
                        if (t1 instanceof A.SassString) {
                            type$.SassString._as(_1_9);
                            t1 = !_1_9._hasQuotes;
                        } else t1 = t2;
                        _1_8_isSet = true;
                        _1_9_isSet = true;
                    } else {
                        t1 = t2;
                        _1_8_isSet = false;
                        _1_9_isSet = false;
                    }
                    if (t1) {
                        if (_1_9_isSet) t1 = _1_9;
                        else {
                            _1_9 = _1_0[_1_1 - 1];
                            t1 = _1_9;
                        }
                        _0_0 = type$.SassString._as(t1)._string$_text.split("/");
                        $label1$1: {
                            _0_1 = _0_0.length;
                            if (_0_1 === 1) {
                                t1 = new A._Record_2(input, _null);
                                break $label1$1;
                            }
                            if (_0_1 === 2) {
                                channel3 = _0_0[0];
                                alpha = _0_0[1];
                                t1 = A.List_List$_of(initial, type$.Value);
                                t1.push(A._parseNumberOrString(channel3));
                                t1 = new A._Record_2(A.SassList$(t1, B.ListSeparator_SrV, false), A._parseNumberOrString(alpha));
                                break $label1$1;
                            }
                            t1 = _null;
                            break $label1$1;
                        }
                        break $label0$0;
                    }
                    _1_16 = _null;
                    _1_16_isSet = false;
                    t1 = false;
                    if (_1_7) {
                        _1_9_isSet0 = true;
                        if (_1_8_isSet) initial = _1_8;
                        else {
                            _1_8 = B.JSArray_methods.sublist$2(_1_0, 0, _1_1 - 1);
                            initial = _1_8;
                        }
                        if (_1_9_isSet) t2 = _1_9;
                        else {
                            _1_9 = _1_0[_1_1 - 1];
                            t2 = _1_9;
                            _1_9_isSet = _1_9_isSet0;
                        }
                        _1_16_isSet = t2 instanceof A.SassNumber;
                        if (_1_16_isSet) {
                            if (_1_9_isSet) t1 = _1_9;
                            else {
                                _1_9 = _1_0[_1_1 - 1];
                                t1 = _1_9;
                                _1_9_isSet = _1_9_isSet0;
                            }
                            _1_16 = type$.SassNumber._as(t1).asSlash;
                            t1 = _1_16;
                            t1 = type$.Record_2_nullable_Object_and_nullable_Object._is(t1);
                        }
                    } else initial = _null;
                    if (t1) {
                        if (_1_16_isSet) t1 = _1_16;
                        else {
                            if (_1_9_isSet) t1 = _1_9;
                            else {
                                _1_9 = _1_0[_1_1 - 1];
                                t1 = _1_9;
                                _1_9_isSet = true;
                            }
                            _1_16 = type$.SassNumber._as(t1).asSlash;
                            t1 = _1_16;
                            _1_16_isSet = true;
                        }
                        if (t1 == null) t1 = type$.Record_2_nullable_Object_and_nullable_Object._as(t1);
                        if (_1_16_isSet) t2 = _1_16;
                        else {
                            if (_1_9_isSet) t2 = _1_9;
                            else {
                                _1_9 = _1_0[_1_1 - 1];
                                t2 = _1_9;
                            }
                            _1_16 = type$.SassNumber._as(t2).asSlash;
                            t2 = _1_16;
                        }
                        if (t2 == null) t2 = type$.Record_2_nullable_Object_and_nullable_Object._as(t2);
                        t3 = A.List_List$_of(initial, type$.Value);
                        t3.push(t1._0);
                        t1 = new A._Record_2(A.SassList$(t3, B.ListSeparator_SrV, false), t2._1);
                        break $label0$0;
                    }
                    t1 = new A._Record_2(input, _null);
                    break $label0$0;
                }
                return t1;
            },
            _parseNumberOrString: function(text) {
                var t1, expression, _$exception;
                try {
                    t1 = A.ScssParser$(text, false, null);
                    expression = t1._parseSingleProduction$1$1(t1.get$_number(), type$.NumberExpression);
                    t1 = A.SassNumber_SassNumber(expression.value, expression.unit);
                    return t1;
                } catch (exception) {
                    if (type$.SassFormatException._is(A.unwrapException(exception))) return new A.SassString(text, false);
                    else throw exception;
                }
            },
            _colorFromChannels: function(space, channel0, channel1, channel2, alpha, clamp, fromRgbFunction) {
                var t1, t2, whiteness, blackness, t3;
                switch(space){
                    case B.HslColorSpace_JQ2:
                        if (channel1 != null) A._checkPercent(channel1, "saturation");
                        if (channel2 != null) A._checkPercent(channel2, "lightness");
                        t1 = space._channels;
                        return A.SassColor_SassColor$hsl(A.NullableExtension_andThen(channel0, new A._colorFromChannels_closure()), A._channelFromValue(t1[1], A._forcePercent(channel1), clamp), A._channelFromValue(t1[2], A._forcePercent(channel2), clamp), alpha);
                    case B.HwbColorSpace_guQ:
                        t1 = channel1 == null;
                        if (!t1) channel1.assertUnit$2("%", "whiteness");
                        t2 = channel2 == null;
                        if (!t2) channel2.assertUnit$2("%", "blackness");
                        whiteness = t1 ? null : channel1._number$_value;
                        blackness = t2 ? null : channel2._number$_value;
                        if (whiteness != null && blackness != null && whiteness + blackness > 100) {
                            t1 = whiteness + blackness;
                            whiteness = whiteness / t1 * 100;
                            blackness = blackness / t1 * 100;
                        }
                        return A.SassColor_SassColor$hwb(A.NullableExtension_andThen(channel0, new A._colorFromChannels_closure0()), whiteness, blackness, alpha);
                    case B.RgbColorSpace_i0P:
                        t1 = space._channels;
                        t2 = A._channelFromValue(t1[0], channel0, clamp);
                        t3 = A._channelFromValue(t1[1], channel1, clamp);
                        t1 = A._channelFromValue(t1[2], channel2, clamp);
                        return A.SassColor_SassColor$rgbInternal(t2, t3, t1, alpha, fromRgbFunction ? B.C__ColorFormatEnum : null);
                    default:
                        t1 = space._channels;
                        return A.SassColor_SassColor$forSpaceInternal(space, A._channelFromValue(t1[0], channel0, clamp), A._channelFromValue(t1[1], channel1, clamp), A._channelFromValue(t1[2], channel2, clamp), alpha);
                }
            },
            _forcePercent: function(number) {
                var t1, _0_3;
                $label0$0: {
                    if (number == null) {
                        t1 = null;
                        break $label0$0;
                    }
                    _0_3 = number.get$numeratorUnits(number);
                    if (_0_3.length === 1) t1 = "%" === _0_3[0] && number.get$denominatorUnits(number).length <= 0;
                    else t1 = false;
                    if (t1) {
                        t1 = number;
                        break $label0$0;
                    }
                    t1 = A.SassNumber_SassNumber(number._number$_value, "%");
                    break $label0$0;
                }
                return t1;
            },
            _channelFromValue: function(channel, value, clamp) {
                return A.NullableExtension_andThen(value, new A._channelFromValue_closure(channel, clamp));
            },
            _isNone: function(value) {
                return value instanceof A.SassString && !value._hasQuotes && value._string$_text.toLowerCase() === "none";
            },
            _channelFunction: function($name, space, getter, global, unit) {
                return A.BuiltInCallable$function($name, "$color", new A._channelFunction_closure(getter, unit, global, $name, space), "sass:color");
            },
            _suggestScaleAndAdjust: function(original, adjustment, channelName) {
                var t2, oldValue, newValue, factor, t3, suggestion, channel = channelName === "alpha" ? B.LinearChannel_XL8 : type$.LinearChannel._as(B.JSArray_methods.firstWhere$1(B.List_oAL, new A._suggestScaleAndAdjust_closure(channelName))), t1 = channel === B.LinearChannel_XL8;
                if (t1) {
                    t2 = original.alphaOrNull;
                    oldValue = t2 == null ? 0 : t2;
                } else oldValue = original.toSpace$1(B.HslColorSpace_JQ2).channel$1(0, channelName);
                newValue = oldValue + adjustment;
                if (adjustment !== 0) {
                    factor = A._Cell$();
                    t2 = channel.max;
                    if (newValue > t2) factor.__late_helper$_value = 1;
                    else {
                        t3 = channel.min;
                        if (newValue < t3) factor.__late_helper$_value = -1;
                        else if (adjustment > 0) factor.__late_helper$_value = adjustment / (t2 - oldValue);
                        else factor.__late_helper$_value = (newValue - oldValue) / (oldValue - t3);
                    }
                    suggestion = "Suggestion" + ("s:\n\ncolor.scale($color, $" + channelName + ": " + A.serializeValue(A.SassNumber_SassNumber(factor._readLocal$0() * 100, "%"), false, true) + ")\n");
                } else suggestion = "Suggestion:\n\n";
                return suggestion + ("color.adjust($color, $" + channelName + ": " + A.serializeValue(A.SassNumber_SassNumber(adjustment, t1 ? null : "%"), false, true) + ")");
            },
            _missingChannelError: function(color, channel) {
                return A.throwExpression(A.SassScriptException$(string$.Becaus + color.toCssString$0() + ").", channel));
            },
            _channelName: function(value) {
                var t1 = value.assertString$1("channel");
                t1.assertQuoted$1("channel");
                return t1._string$_text;
            },
            _function5: function($name, $arguments, callback) {
                return A.BuiltInCallable$function($name, $arguments, callback, "sass:color");
            },
            global_closure0: function global_closure0() {},
            global_closure1: function global_closure1() {},
            global_closure2: function global_closure2() {},
            global_closure3: function global_closure3() {},
            global_closure4: function global_closure4() {},
            global_closure5: function global_closure5() {},
            global_closure6: function global_closure6() {},
            global_closure7: function global_closure7() {},
            global_closure8: function global_closure8() {},
            global_closure9: function global_closure9() {},
            global_closure10: function global_closure10() {},
            global_closure11: function global_closure11() {},
            global_closure12: function global_closure12() {},
            global_closure13: function global_closure13() {},
            global_closure14: function global_closure14() {},
            global_closure15: function global_closure15() {},
            global_closure16: function global_closure16() {},
            global_closure17: function global_closure17() {},
            global_closure18: function global_closure18() {},
            global_closure19: function global_closure19() {},
            global_closure20: function global_closure20() {},
            global_closure21: function global_closure21() {},
            global_closure22: function global_closure22() {},
            global_closure23: function global_closure23() {},
            global_closure24: function global_closure24() {},
            global_closure25: function global_closure25() {},
            global_closure26: function global_closure26() {},
            global_closure27: function global_closure27() {},
            global_closure28: function global_closure28() {},
            global_closure29: function global_closure29() {},
            global_closure30: function global_closure30() {},
            global_closure31: function global_closure31() {},
            global_closure32: function global_closure32() {},
            global_closure33: function global_closure33() {},
            global_closure34: function global_closure34() {},
            global_closure35: function global_closure35() {},
            global__closure: function global__closure() {},
            global_closure36: function global_closure36() {},
            global_closure37: function global_closure37() {},
            global_closure38: function global_closure38() {},
            global_closure39: function global_closure39() {},
            global_closure40: function global_closure40() {},
            global_closure41: function global_closure41() {},
            global_closure42: function global_closure42() {},
            module_closure1: function module_closure1() {},
            module_closure2: function module_closure2() {},
            module_closure3: function module_closure3() {},
            module_closure4: function module_closure4() {},
            module_closure5: function module_closure5() {},
            module_closure6: function module_closure6() {},
            module_closure7: function module_closure7() {},
            module_closure8: function module_closure8() {},
            module_closure9: function module_closure9() {},
            module_closure10: function module_closure10() {},
            module_closure11: function module_closure11() {},
            module_closure12: function module_closure12() {},
            module_closure13: function module_closure13() {},
            module_closure14: function module_closure14() {},
            module__closure2: function module__closure2() {},
            module_closure15: function module_closure15() {},
            module_closure16: function module_closure16() {},
            module_closure17: function module_closure17() {},
            module_closure18: function module_closure18() {},
            module_closure19: function module_closure19() {},
            module_closure20: function module_closure20() {},
            module_closure21: function module_closure21() {},
            module_closure22: function module_closure22() {},
            module__closure1: function module__closure1(t0) {
                this.channelName = t0;
            },
            module_closure23: function module_closure23() {},
            module_closure_toXyzNoMissing: function module_closure_toXyzNoMissing() {},
            module_closure24: function module_closure24() {},
            _mix_closure: function _mix_closure() {},
            _complement_closure: function _complement_closure() {},
            _adjust_closure: function _adjust_closure() {},
            _scale_closure: function _scale_closure() {},
            _change_closure: function _change_closure() {},
            _ieHexStr_closure: function _ieHexStr_closure() {},
            _ieHexStr_closure_hexString: function _ieHexStr_closure_hexString() {},
            _updateComponents_closure: function _updateComponents_closure(t0) {
                this.originalColor = t0;
            },
            _updateComponents_closure0: function _updateComponents_closure0(t0) {
                this._box_0 = t0;
            },
            _changeColor_closure: function _changeColor_closure(t0) {
                this.alphaArg = t0;
            },
            _adjustColor_closure: function _adjustColor_closure() {},
            _functionString_closure: function _functionString_closure() {},
            _removedColorFunction_closure: function _removedColorFunction_closure(t0, t1, t2) {
                this.name = t0;
                this.argument = t1;
                this.negative = t2;
            },
            _rgb_closure: function _rgb_closure() {},
            _hsl_closure: function _hsl_closure() {},
            _parseChannels_closure: function _parseChannels_closure() {},
            _parseChannels_closure0: function _parseChannels_closure0() {},
            _colorFromChannels_closure: function _colorFromChannels_closure() {},
            _colorFromChannels_closure0: function _colorFromChannels_closure0() {},
            _channelFromValue_closure: function _channelFromValue_closure(t0, t1) {
                this.channel = t0;
                this.clamp = t1;
            },
            _channelFunction_closure: function _channelFunction_closure(t0, t1, t2, t3, t4) {
                var _ = this;
                _.getter = t0;
                _.unit = t1;
                _.global = t2;
                _.name = t3;
                _.space = t4;
            },
            _suggestScaleAndAdjust_closure: function _suggestScaleAndAdjust_closure(t0) {
                this.channelName = t0;
            },
            _function4: function($name, $arguments, callback) {
                return A.BuiltInCallable$function($name, $arguments, callback, "sass:list");
            },
            _length_closure0: function _length_closure0() {},
            _nth_closure: function _nth_closure() {},
            _setNth_closure: function _setNth_closure() {},
            _join_closure: function _join_closure() {},
            _append_closure0: function _append_closure0() {},
            _zip_closure: function _zip_closure() {},
            _zip__closure: function _zip__closure() {},
            _zip__closure0: function _zip__closure0(t0) {
                this._box_0 = t0;
            },
            _zip__closure1: function _zip__closure1(t0) {
                this._box_0 = t0;
            },
            _index_closure0: function _index_closure0() {},
            _separator_closure: function _separator_closure() {},
            _isBracketed_closure: function _isBracketed_closure() {},
            _slash_closure: function _slash_closure() {},
            _modify: function(map, keys, modify, addNesting) {
                var keyIterator = J.get$iterator$ax(keys);
                return keyIterator.moveNext$0() ? new A._modify_modifyNestedMap(keyIterator, modify, addNesting).call$1(map) : modify.call$1(map);
            },
            _deepMergeImpl: function(map1, map2) {
                var t2, t3, result, t4, key, value, _1_1, _1_3, _1_3_isSet, resultMap, _1_30, valueMap, merged, t1 = map1._map$_contents;
                if (t1.get$isEmpty(t1)) return map2;
                t2 = map2._map$_contents;
                if (t2.get$isEmpty(t2)) return map1;
                t3 = type$.Value;
                result = A.LinkedHashMap_LinkedHashMap$of(t1, t3, t3);
                for(t1 = A.MapExtensions_get_pairs(t2, t3, t3), t1 = t1.get$iterator(t1), t2 = type$.SassMap; t1.moveNext$0();){
                    t4 = t1.get$current(t1);
                    key = t4._0;
                    value = t4._1;
                    t4 = result.$index(0, key);
                    _1_1 = t4 == null ? null : t4.tryMap$0();
                    _1_3 = value.tryMap$0();
                    _1_3_isSet = _1_1 != null;
                    t4 = false;
                    if (_1_3_isSet) {
                        t4 = _1_3 != null;
                        resultMap = _1_1;
                        _1_30 = _1_3;
                    } else {
                        _1_30 = null;
                        resultMap = null;
                    }
                    if (t4) {
                        valueMap = _1_3_isSet ? _1_30 : _1_3;
                        merged = A._deepMergeImpl(resultMap, valueMap == null ? t2._as(valueMap) : valueMap);
                        if (merged === resultMap) continue;
                        result.$indexSet(0, key, merged);
                    } else result.$indexSet(0, key, value);
                }
                return new A.SassMap(A.ConstantMap_ConstantMap$from(result, t3, t3));
            },
            _function3: function($name, $arguments, callback) {
                return A.BuiltInCallable$function($name, $arguments, callback, "sass:map");
            },
            _get_closure: function _get_closure() {},
            _set_closure: function _set_closure() {},
            _set__closure0: function _set__closure0(t0) {
                this.$arguments = t0;
            },
            _set_closure0: function _set_closure0() {},
            _set__closure: function _set__closure(t0) {
                this._box_0 = t0;
            },
            _merge_closure: function _merge_closure() {},
            _merge_closure0: function _merge_closure0() {},
            _merge__closure: function _merge__closure(t0) {
                this.map2 = t0;
            },
            _deepMerge_closure: function _deepMerge_closure() {},
            _deepRemove_closure: function _deepRemove_closure() {},
            _deepRemove__closure: function _deepRemove__closure(t0) {
                this.keys = t0;
            },
            _remove_closure: function _remove_closure() {},
            _remove_closure0: function _remove_closure0() {},
            _keys_closure: function _keys_closure() {},
            _values_closure: function _values_closure() {},
            _hasKey_closure: function _hasKey_closure() {},
            _modify_modifyNestedMap: function _modify_modifyNestedMap(t0, t1, t2) {
                this.keyIterator = t0;
                this.modify = t1;
                this.addNesting = t2;
            },
            _singleArgumentMathFunc: function($name, mathFunc) {
                return A.BuiltInCallable$function($name, "$number", new A._singleArgumentMathFunc_closure(mathFunc), "sass:math");
            },
            _numberFunction: function($name, transform) {
                return A.BuiltInCallable$function($name, "$number", new A._numberFunction_closure(transform), "sass:math");
            },
            _function2: function($name, $arguments, callback) {
                return A.BuiltInCallable$function($name, $arguments, callback, "sass:math");
            },
            global_closure: function global_closure() {},
            module_closure0: function module_closure0() {},
            _ceil_closure: function _ceil_closure() {},
            _clamp_closure: function _clamp_closure() {},
            _floor_closure: function _floor_closure() {},
            _max_closure: function _max_closure() {},
            _min_closure: function _min_closure() {},
            _round_closure: function _round_closure() {},
            _hypot_closure: function _hypot_closure() {},
            _hypot__closure: function _hypot__closure() {},
            _log_closure: function _log_closure() {},
            _pow_closure: function _pow_closure() {},
            _atan2_closure: function _atan2_closure() {},
            _compatible_closure: function _compatible_closure() {},
            _isUnitless_closure: function _isUnitless_closure() {},
            _unit_closure: function _unit_closure() {},
            _percentage_closure: function _percentage_closure() {},
            _randomFunction_closure: function _randomFunction_closure() {},
            _div_closure: function _div_closure() {},
            _singleArgumentMathFunc_closure: function _singleArgumentMathFunc_closure(t0) {
                this.mathFunc = t0;
            },
            _numberFunction_closure: function _numberFunction_closure(t0) {
                this.transform = t0;
            },
            _function: function($name, $arguments, callback) {
                return A.BuiltInCallable$function($name, $arguments, callback, "sass:meta");
            },
            _shared_closure: function _shared_closure() {},
            _shared_closure0: function _shared_closure0() {},
            _shared_closure1: function _shared_closure1() {},
            _shared_closure2: function _shared_closure2() {},
            moduleFunctions_closure: function moduleFunctions_closure() {},
            moduleFunctions_closure0: function moduleFunctions_closure0() {},
            moduleFunctions__closure: function moduleFunctions__closure() {},
            moduleFunctions_closure1: function moduleFunctions_closure1() {},
            _prependParent: function(compound) {
                var _0_3, _0_4, t2, t3, rest, t1 = A.EvaluationContext_currentOrNull(), span = (t1 == null ? A.throwExpression(A.StateError$(string$.No_Sass)) : t1).get$currentCallableSpan(), _0_0 = compound.components;
                $label0$0: {
                    _0_3 = _0_0.length >= 1;
                    if (_0_3) {
                        _0_4 = _0_0[0];
                        t1 = _0_4 instanceof A.UniversalSelector;
                    } else {
                        _0_4 = null;
                        t1 = false;
                    }
                    t2 = null;
                    if (t1) {
                        t1 = t2;
                        break $label0$0;
                    }
                    t1 = false;
                    if (_0_3) {
                        t3 = _0_4;
                        if (t3 instanceof A.TypeSelector) {
                            t1 = _0_4;
                            t1 = type$.TypeSelector._as(t1).name.namespace != null;
                        }
                    }
                    if (t1) {
                        t1 = t2;
                        break $label0$0;
                    }
                    if (_0_3) {
                        t1 = _0_4;
                        t1 = t1 instanceof A.TypeSelector;
                    } else t1 = false;
                    if (t1) {
                        t1 = _0_3 ? _0_4 : _0_0[0];
                        type$.TypeSelector._as(t1);
                        rest = B.JSArray_methods.sublist$1(_0_0, 1);
                        t1 = A._setArrayType([
                            new A.ParentSelector(t1.name.name, span)
                        ], type$.JSArray_SimpleSelector);
                        B.JSArray_methods.addAll$1(t1, rest);
                        t1 = A.CompoundSelector$(t1, span);
                        break $label0$0;
                    }
                    t1 = A._setArrayType([
                        new A.ParentSelector(null, span)
                    ], type$.JSArray_SimpleSelector);
                    B.JSArray_methods.addAll$1(t1, _0_0);
                    t1 = A.CompoundSelector$(t1, span);
                    break $label0$0;
                }
                return t1;
            },
            _function1: function($name, $arguments, callback) {
                return A.BuiltInCallable$function($name, $arguments, callback, "sass:selector");
            },
            _nest_closure: function _nest_closure() {},
            _nest__closure: function _nest__closure() {},
            _nest__closure0: function _nest__closure0() {},
            _append_closure: function _append_closure() {},
            _append__closure: function _append__closure() {},
            _append__closure0: function _append__closure0(t0) {
                this.span = t0;
            },
            _append___closure: function _append___closure(t0, t1) {
                this.parent = t0;
                this.span = t1;
            },
            _extend_closure: function _extend_closure() {},
            _replace_closure: function _replace_closure() {},
            _unify_closure: function _unify_closure() {},
            _isSuperselector_closure: function _isSuperselector_closure() {},
            _simpleSelectors_closure: function _simpleSelectors_closure() {},
            _simpleSelectors__closure: function _simpleSelectors__closure() {},
            _parse_closure: function _parse_closure() {},
            _codepointForIndex: function(index, lengthInCodepoints, allowNegative) {
                var result;
                if (index === 0) return 0;
                if (index > 0) return Math.min(index - 1, lengthInCodepoints);
                result = lengthInCodepoints + index;
                if (result < 0 && !allowNegative) return 0;
                return result;
            },
            _function0: function($name, $arguments, callback) {
                return A.BuiltInCallable$function($name, $arguments, callback, "sass:string");
            },
            module_closure: function module_closure() {},
            module__closure: function module__closure(t0) {
                this.string = t0;
            },
            module__closure0: function module__closure0(t0) {
                this.string = t0;
            },
            _unquote_closure: function _unquote_closure() {},
            _quote_closure: function _quote_closure() {},
            _length_closure: function _length_closure() {},
            _insert_closure: function _insert_closure() {},
            _index_closure: function _index_closure() {},
            _slice_closure: function _slice_closure() {},
            _toUpperCase_closure: function _toUpperCase_closure() {},
            _toLowerCase_closure: function _toLowerCase_closure() {},
            _uniqueId_closure: function _uniqueId_closure() {},
            ImportCache$: function(importers, loadPaths) {
                var t1 = type$.nullable_Record_3_Importer_and_Uri_and_Uri_originalUrl, t2 = type$.Record_3_Importer_and_Uri_and_bool_forImport, t3 = type$.Uri;
                return new A.ImportCache(A.ImportCache__toImporters(importers, loadPaths, null), A.LinkedHashMap_LinkedHashMap$_empty(type$.Record_2_Uri_and_bool_forImport, t1), A.LinkedHashMap_LinkedHashMap$_empty(t2, t1), A.LinkedHashMap_LinkedHashMap$_empty(t2, t3), A.LinkedHashMap_LinkedHashMap$_empty(t3, type$.nullable_Stylesheet), A.LinkedHashMap_LinkedHashMap$_empty(t3, type$.ImporterResult), A.LinkedHashMap_LinkedHashMap$_empty(t3, type$.DateTime));
            },
            ImportCache__toImporters: function(importers, loadPaths, packageConfig) {
                var t1, t2, t3, t4, _i, path, _null = null, sassPath = A.getEnvironmentVariable("SASS_PATH");
                if (A.isBrowser()) {
                    t1 = A._setArrayType([], type$.JSArray_Importer);
                    B.JSArray_methods.addAll$1(t1, importers);
                    return t1;
                }
                t1 = A._setArrayType([], type$.JSArray_Importer);
                B.JSArray_methods.addAll$1(t1, importers);
                for(t2 = J.get$iterator$ax(loadPaths); t2.moveNext$0();){
                    t3 = t2.get$current(t2);
                    t1.push(new A.FilesystemImporter($.$get$context().absolute$15(t3, _null, _null, _null, _null, _null, _null, _null, _null, _null, _null, _null, _null, _null, _null), false));
                }
                if (sassPath != null) {
                    t2 = A.isNodeJs() ? self.process : _null;
                    t3 = sassPath.split(J.$eq$(t2 == null ? _null : J.get$platform$x(t2), "win32") ? ";" : ":");
                    t4 = t3.length;
                    _i = 0;
                    for(; _i < t4; ++_i){
                        path = t3[_i];
                        t1.push(new A.FilesystemImporter($.$get$context().absolute$15(path, _null, _null, _null, _null, _null, _null, _null, _null, _null, _null, _null, _null, _null, _null), false));
                    }
                }
                return t1;
            },
            ImportCache: function ImportCache(t0, t1, t2, t3, t4, t5, t6) {
                var _ = this;
                _._importers = t0;
                _._canonicalizeCache = t1;
                _._perImporterCanonicalizeCache = t2;
                _._nonCanonicalRelativeUrls = t3;
                _._importCache = t4;
                _._resultsCache = t5;
                _._loadTimes = t6;
            },
            ImportCache_canonicalize_closure: function ImportCache_canonicalize_closure(t0, t1, t2, t3, t4, t5, t6) {
                var _ = this;
                _.$this = t0;
                _.baseImporter = t1;
                _.resolvedUrl = t2;
                _.baseUrl = t3;
                _.forImport = t4;
                _.key = t5;
                _.url = t6;
            },
            ImportCache__canonicalize_closure: function ImportCache__canonicalize_closure(t0, t1) {
                this.importer = t0;
                this.url = t1;
            },
            ImportCache_importCanonical_closure: function ImportCache_importCanonical_closure(t0, t1, t2, t3) {
                var _ = this;
                _.$this = t0;
                _.importer = t1;
                _.canonicalUrl = t2;
                _.originalUrl = t3;
            },
            ImportCache_humanize_closure: function ImportCache_humanize_closure(t0) {
                this.canonicalUrl = t0;
            },
            ImportCache_humanize_closure0: function ImportCache_humanize_closure0() {},
            ImportCache_humanize_closure1: function ImportCache_humanize_closure1() {},
            ImportCache_humanize_closure2: function ImportCache_humanize_closure2(t0) {
                this.canonicalUrl = t0;
            },
            Importer: function Importer() {},
            AsyncImporter: function AsyncImporter() {},
            CanonicalizeContext: function CanonicalizeContext(t0, t1) {
                this._fromImport = t0;
                this._containingUrl = t1;
                this._wasContainingUrlAccessed = false;
            },
            FilesystemImporter: function FilesystemImporter(t0, t1) {
                this._loadPath = t0;
                this._loadPathDeprecated = t1;
            },
            FilesystemImporter_canonicalize_closure: function FilesystemImporter_canonicalize_closure() {},
            NoOpImporter: function NoOpImporter() {},
            NodePackageImporter: function NodePackageImporter() {
                this.__NodePackageImporter__entryPointDirectory_F = $;
            },
            NodePackageImporter__nodePackageExportsResolve_closure: function NodePackageImporter__nodePackageExportsResolve_closure() {},
            NodePackageImporter__nodePackageExportsResolve_closure0: function NodePackageImporter__nodePackageExportsResolve_closure0() {},
            NodePackageImporter__nodePackageExportsResolve_closure1: function NodePackageImporter__nodePackageExportsResolve_closure1() {},
            NodePackageImporter__nodePackageExportsResolve_closure2: function NodePackageImporter__nodePackageExportsResolve_closure2(t0, t1, t2) {
                this.$this = t0;
                this.exports = t1;
                this.packageRoot = t2;
            },
            NodePackageImporter__nodePackageExportsResolve__closure: function NodePackageImporter__nodePackageExportsResolve__closure(t0, t1, t2) {
                this.$this = t0;
                this.variant = t1;
                this.packageRoot = t2;
            },
            NodePackageImporter__nodePackageExportsResolve__closure0: function NodePackageImporter__nodePackageExportsResolve__closure0() {},
            NodePackageImporter__getMainExport_closure: function NodePackageImporter__getMainExport_closure() {},
            ImporterResult: function ImporterResult(t0, t1, t2) {
                this.contents = t0;
                this._sourceMapUrl = t1;
                this.syntax = t2;
            },
            fromImport: function() {
                var t1 = type$.nullable_CanonicalizeContext._as($.Zone__current.$index(0, B.Symbol__canonicalizeContext));
                t1 = t1 == null ? null : t1._fromImport;
                return t1 === true;
            },
            canonicalizeContext: function() {
                var t1, _0_0 = $.Zone__current.$index(0, B.Symbol__canonicalizeContext);
                $label0$0: {
                    if (_0_0 == null) A.throwExpression(A.StateError$(string$.canoni));
                    if (_0_0 instanceof A.CanonicalizeContext) {
                        t1 = _0_0;
                        break $label0$0;
                    }
                    t1 = A.throwExpression(A.StateError$(string$.Unexpe + A.S(_0_0) + "."));
                }
                return t1;
            },
            resolveImportPath: function(path) {
                var t1, extension = A.ParsedPath_ParsedPath$parse(path, $.$get$context().style)._splitExtension$1(1)[1];
                if (extension === ".sass" || extension === ".scss" || extension === ".css") {
                    t1 = A.fromImport() ? new A.resolveImportPath_closure(path, extension).call$0() : null;
                    return t1 == null ? A._exactlyOne(A._tryPath(path)) : t1;
                }
                t1 = A.fromImport() ? new A.resolveImportPath_closure0(path).call$0() : null;
                if (t1 == null) t1 = A._exactlyOne(A._tryPathWithExtensions(path));
                return t1 == null ? A._tryPathAsDirectory(path) : t1;
            },
            _tryPathWithExtensions: function(path) {
                var result = A._tryPath(path + ".sass");
                B.JSArray_methods.addAll$1(result, A._tryPath(path + ".scss"));
                return result.length !== 0 ? result : A._tryPath(path + ".css");
            },
            _tryPath: function(path) {
                var t1 = $.$get$context(), partial = A.join(t1.dirname$1(path), "_" + A.ParsedPath_ParsedPath$parse(path, t1.style).get$basename(), null);
                t1 = A._setArrayType([], type$.JSArray_String);
                if (A.fileExists(partial)) t1.push(partial);
                if (A.fileExists(path)) t1.push(path);
                return t1;
            },
            _tryPathAsDirectory: function(path) {
                var t1;
                if (!A.dirExists(path)) return null;
                t1 = A.fromImport() ? new A._tryPathAsDirectory_closure(path).call$0() : null;
                return t1 == null ? A._exactlyOne(A._tryPathWithExtensions(A.join(path, "index", null))) : t1;
            },
            _exactlyOne: function(paths) {
                var _0_1, t1, path;
                $label0$0: {
                    _0_1 = paths.length;
                    if (_0_1 <= 0) {
                        t1 = null;
                        break $label0$0;
                    }
                    if (_0_1 === 1) {
                        path = paths[0];
                        t1 = path;
                        break $label0$0;
                    }
                    t1 = A.throwExpression(string$.It_s_n + B.JSArray_methods.map$1$1(paths, new A._exactlyOne_closure(), type$.String).join$1(0, "\n"));
                }
                return t1;
            },
            resolveImportPath_closure: function resolveImportPath_closure(t0, t1) {
                this.path = t0;
                this.extension = t1;
            },
            resolveImportPath_closure0: function resolveImportPath_closure0(t0) {
                this.path = t0;
            },
            _tryPathAsDirectory_closure: function _tryPathAsDirectory_closure(t0) {
                this.path = t0;
            },
            _exactlyOne_closure: function _exactlyOne_closure() {},
            InterpolationBuffer: function InterpolationBuffer(t0, t1, t2) {
                this._interpolation_buffer$_text = t0;
                this._interpolation_buffer$_contents = t1;
                this._spans = t2;
            },
            InterpolationMap$: function(_interpolation, targetOffsets) {
                var t1 = A.List_List$unmodifiable(targetOffsets, type$.int), t2 = _interpolation.contents.length, expectedLocations = Math.max(0, t2 - 1);
                if (t1.length !== expectedLocations) A.throwExpression(A.ArgumentError$("InterpolationMap must have " + A.S(expectedLocations) + " targetOffsets if the interpolation has " + t2 + " components.", null));
                return new A.InterpolationMap(_interpolation, t1);
            },
            InterpolationMap: function InterpolationMap(t0, t1) {
                this._interpolation = t0;
                this._targetOffsets = t1;
            },
            InterpolationMap_mapException_closure: function InterpolationMap_mapException_closure() {},
            _realCasePath: function(path) {
                var prefix, _null = null, t1 = A.isNodeJs() ? self.process : _null;
                if (!J.$eq$(t1 == null ? _null : J.get$platform$x(t1), "win32")) {
                    t1 = A.isNodeJs() ? self.process : _null;
                    t1 = J.$eq$(t1 == null ? _null : J.get$platform$x(t1), "darwin");
                } else t1 = true;
                if (!t1) return path;
                t1 = A.isNodeJs() ? self.process : _null;
                if (J.$eq$(t1 == null ? _null : J.get$platform$x(t1), "win32")) {
                    prefix = B.JSString_methods.substring$2(path, 0, $.$get$context().style.rootLength$1(path));
                    t1 = prefix.length;
                    if (t1 !== 0 && A.CharacterExtension_get_isAlphabetic(prefix.charCodeAt(0))) path = prefix.toUpperCase() + B.JSString_methods.substring$1(path, t1);
                }
                return new A._realCasePath_helper().call$1(path);
            },
            _realCasePath_helper: function _realCasePath_helper() {},
            _realCasePath_helper_closure: function _realCasePath_helper_closure(t0, t1, t2, t3) {
                var _ = this;
                _.path = t0;
                _.realPath = t1;
                _.helper = t2;
                _.dirname = t3;
            },
            _realCasePath_helper__closure: function _realCasePath_helper__closure(t0) {
                this.basename = t0;
            },
            printError: function(message) {
                var t2, t1 = A.isNodeJs() ? self.process : null;
                if (t1 != null) {
                    t1 = J.get$stderr$x(t1);
                    J.write$1$x(t1, A.S(message == null ? "" : message) + "\n");
                } else {
                    t1 = self.console;
                    t2 = message == null ? null : J.toString$0$(message);
                    J.error$1$x(t1, t2 == null ? "" : t2);
                }
            },
            readFile: function(path) {
                var contents, sourceFile, t1, i;
                if (!A.isNodeJs()) throw A.wrapException(A.UnsupportedError$("readFile() is only supported on Node.js"));
                contents = A._asString(A._readFile(path, "utf8"));
                if (!B.JSString_methods.contains$1(contents, "\ufffd")) return contents;
                sourceFile = A.SourceFile$fromString(contents, $.$get$context().toUri$1(path));
                for(t1 = contents.length, i = 0; i < t1; ++i){
                    if (contents.charCodeAt(i) !== 65533) continue;
                    throw A.wrapException(A.SassException$("Invalid UTF-8.", A.FileLocation$_(sourceFile, i).pointSpan$0(), null));
                }
                return contents;
            },
            _readFile: function(path, encoding) {
                return A._systemErrorToFileSystemException(new A._readFile_closure(path, encoding));
            },
            writeFile: function(path, contents) {
                if (!A.isNodeJs()) throw A.wrapException(A.UnsupportedError$("writeFile() is only supported on Node.js"));
                return A._systemErrorToFileSystemException(new A.writeFile_closure(path, contents));
            },
            deleteFile: function(path) {
                if (!A.isNodeJs()) throw A.wrapException(A.UnsupportedError$("deleteFile() is only supported on Node.js"));
                return A._systemErrorToFileSystemException(new A.deleteFile_closure(path));
            },
            readStdin: function() {
                return A.readStdin$body();
            },
            readStdin$body: function() {
                var $async$goto = 0, $async$completer = A._makeAsyncAwaitCompleter(type$.String), $async$returnValue, t3, completer, sink, t1, t2;
                var $async$readStdin = A._wrapJsFunctionForAsync(function($async$errorCode, $async$result) {
                    if ($async$errorCode === 1) return A._asyncRethrow($async$result, $async$completer);
                    for(;;)switch($async$goto){
                        case 0:
                            // Function start
                            t1 = {};
                            t2 = A.isNodeJs() ? self.process : null;
                            if (t2 == null) throw A.wrapException(A.UnsupportedError$("readStdin() is only supported on Node.js"));
                            t3 = new A._Future($.Zone__current, type$._Future_String);
                            completer = new A._AsyncCompleter(t3, type$._AsyncCompleter_String);
                            t1.contents = null;
                            sink = new A._StringCallbackSink(new A.readStdin_closure(t1, completer), new A.StringBuffer("")).asUtf8Sink$1(false);
                            t1 = J.getInterceptor$x(t2);
                            J.on$2$x(t1.get$stdin(t2), "data", A.allowInterop(new A.readStdin_closure0(sink)));
                            J.on$2$x(t1.get$stdin(t2), "end", A.allowInterop(new A.readStdin_closure1(sink)));
                            J.on$2$x(t1.get$stdin(t2), "error", A.allowInterop(new A.readStdin_closure2(completer)));
                            $async$returnValue = t3;
                            // goto return
                            $async$goto = 1;
                            break;
                        case 1:
                            // return
                            return A._asyncReturn($async$returnValue, $async$completer);
                    }
                });
                return A._asyncStartSync($async$readStdin, $async$completer);
            },
            fileExists: function(path) {
                if (!A.isNodeJs()) throw A.wrapException(A.UnsupportedError$(string$.fileEx));
                return A._systemErrorToFileSystemException(new A.fileExists_closure(path));
            },
            dirExists: function(path) {
                if (!A.isNodeJs()) throw A.wrapException(A.UnsupportedError$("dirExists() is only supported on Node.js"));
                return A._systemErrorToFileSystemException(new A.dirExists_closure(path));
            },
            linkExists: function(path) {
                if (!A.isNodeJs()) throw A.wrapException(A.UnsupportedError$(string$.linkEx));
                return A._systemErrorToFileSystemException(new A.linkExists_closure(path));
            },
            ensureDir: function(path) {
                if (!A.isNodeJs()) throw A.wrapException(A.UnsupportedError$("ensureDir() is only supported on Node.js"));
                return A._systemErrorToFileSystemException(new A.ensureDir_closure(path));
            },
            listDir: function(path, recursive) {
                if (!A.isNodeJs()) throw A.wrapException(A.UnsupportedError$("listDir() is only supported on Node.js"));
                return A._systemErrorToFileSystemException(new A.listDir_closure(recursive, path));
            },
            realpath: function(path) {
                if (!A.isNodeJs()) throw A.wrapException(A.UnsupportedError$("listDir() is only supported on Node.js"));
                return A._systemErrorToFileSystemException(new A.realpath_closure(path));
            },
            modificationTime: function(path) {
                if (!A.isNodeJs()) throw A.wrapException(A.UnsupportedError$("modificationTime() is only supported on Node.js"));
                return A._systemErrorToFileSystemException(new A.modificationTime_closure(path));
            },
            getEnvironmentVariable: function($name) {
                var t1 = A.isNodeJs() ? self.process : null, env = t1 == null ? null : J.get$env$x(t1);
                if (env == null) t1 = null;
                else t1 = A._asStringQ(env[$name]);
                return t1;
            },
            _systemErrorToFileSystemException: function(callback) {
                var error, t1, _$exception, t2;
                try {
                    t1 = callback.call$0();
                    return t1;
                } catch (exception) {
                    error = A.unwrapException(exception);
                    if (!type$.JsSystemError._is(error)) throw exception;
                    t1 = error;
                    t2 = J.getInterceptor$x(t1);
                    throw A.wrapException(new A.FileSystemException(J.substring$2$s(t2.get$message(t1), (A.S(t2.get$code(t1)) + ": ").length, J.get$length$asx(t2.get$message(t1)) - (", " + A.S(t2.get$syscall(t1)) + " '" + A.S(t2.get$path(t1)) + "'").length), J.get$path$x(error)));
                }
            },
            hasTerminal: function() {
                var t1 = A.isNodeJs() ? self.process : null;
                return J.$eq$(t1 == null ? null : J.get$isTTY$x(J.get$stdout$x(t1)), true);
            },
            isWindows: function() {
                var t1 = A.isNodeJs() ? self.process : null;
                return J.$eq$(t1 == null ? null : J.get$platform$x(t1), "win32");
            },
            watchDir: function(path, poll) {
                return A.watchDir$body(path, poll);
            },
            watchDir$body: function(path, poll) {
                var $async$goto = 0, $async$completer = A._makeAsyncAwaitCompleter(type$.Stream_WatchEvent), $async$returnValue, _0_0, t2, parcel, controller, watcher, t3, t1, $async$temp1, $async$temp2, $async$temp3;
                var $async$watchDir = A._wrapJsFunctionForAsync(function($async$errorCode, $async$result) {
                    if ($async$errorCode === 1) return A._asyncRethrow($async$result, $async$completer);
                    for(;;)switch($async$goto){
                        case 0:
                            // Function start
                            t1 = {};
                            if (!A.isNodeJs()) throw A.wrapException(A.UnsupportedError$("watchDir() is only supported on Node.js"));
                            t1.controller = null;
                            _0_0 = init.G.parcel_watcher;
                            if (_0_0 != null) {
                                t2 = !poll;
                                parcel = _0_0;
                            } else {
                                parcel = null;
                                t2 = false;
                            }
                            $async$goto = t2 ? 3 : 5;
                            break;
                        case 3:
                            // then
                            $async$temp1 = t1;
                            $async$temp2 = A;
                            $async$temp3 = A;
                            $async$goto = 6;
                            return A._asyncAwait(A.ParcelWatcher_subscribe(parcel, path, new A.watchDir_closure0(t1)), $async$watchDir);
                        case 6:
                            // returning from await.
                            controller = $async$temp1.controller = $async$temp2.StreamController_StreamController(new $async$temp3.watchDir_closure($async$result), null, null, null, false, type$.WatchEvent);
                            $async$returnValue = new A._ControllerStream(controller, A._instanceType(controller)._eval$1("_ControllerStream<1>"));
                            // goto return
                            $async$goto = 1;
                            break;
                        case 5:
                            // else
                            watcher = J.watch$2$x(self.chokidar, path, {
                                usePolling: poll
                            });
                            t2 = J.getInterceptor$x(watcher);
                            t2.on$2(watcher, "add", A.allowInterop(new A.watchDir_closure1(t1)));
                            t2.on$2(watcher, "change", A.allowInterop(new A.watchDir_closure2(t1)));
                            t2.on$2(watcher, "unlink", A.allowInterop(new A.watchDir_closure3(t1)));
                            t2.on$2(watcher, "error", A.allowInterop(new A.watchDir_closure4(t1)));
                            t3 = new A._Future($.Zone__current, type$._Future_Stream_WatchEvent);
                            t2.on$2(watcher, "ready", A.allowInterop(new A.watchDir_closure5(t1, watcher, new A._AsyncCompleter(t3, type$._AsyncCompleter_Stream_WatchEvent))));
                            $async$returnValue = t3;
                            // goto return
                            $async$goto = 1;
                            break;
                        case 4:
                        // join
                        case 1:
                            // return
                            return A._asyncReturn($async$returnValue, $async$completer);
                    }
                });
                return A._asyncStartSync($async$watchDir, $async$completer);
            },
            FileSystemException: function FileSystemException(t0, t1) {
                this.message = t0;
                this.path = t1;
            },
            _readFile_closure: function _readFile_closure(t0, t1) {
                this.path = t0;
                this.encoding = t1;
            },
            writeFile_closure: function writeFile_closure(t0, t1) {
                this.path = t0;
                this.contents = t1;
            },
            deleteFile_closure: function deleteFile_closure(t0) {
                this.path = t0;
            },
            readStdin_closure: function readStdin_closure(t0, t1) {
                this._box_0 = t0;
                this.completer = t1;
            },
            readStdin_closure0: function readStdin_closure0(t0) {
                this.sink = t0;
            },
            readStdin_closure1: function readStdin_closure1(t0) {
                this.sink = t0;
            },
            readStdin_closure2: function readStdin_closure2(t0) {
                this.completer = t0;
            },
            fileExists_closure: function fileExists_closure(t0) {
                this.path = t0;
            },
            dirExists_closure: function dirExists_closure(t0) {
                this.path = t0;
            },
            linkExists_closure: function linkExists_closure(t0) {
                this.path = t0;
            },
            ensureDir_closure: function ensureDir_closure(t0) {
                this.path = t0;
            },
            listDir_closure: function listDir_closure(t0, t1) {
                this.recursive = t0;
                this.path = t1;
            },
            listDir__closure: function listDir__closure(t0) {
                this.path = t0;
            },
            listDir__closure0: function listDir__closure0() {},
            listDir_closure_list: function listDir_closure_list() {},
            listDir__list_closure: function listDir__list_closure(t0, t1) {
                this.parent = t0;
                this.list = t1;
            },
            realpath_closure: function realpath_closure(t0) {
                this.path = t0;
            },
            modificationTime_closure: function modificationTime_closure(t0) {
                this.path = t0;
            },
            watchDir_closure0: function watchDir_closure0(t0) {
                this._box_0 = t0;
            },
            watchDir_closure: function watchDir_closure(t0) {
                this.subscription = t0;
            },
            watchDir_closure1: function watchDir_closure1(t0) {
                this._box_0 = t0;
            },
            watchDir_closure2: function watchDir_closure2(t0) {
                this._box_0 = t0;
            },
            watchDir_closure3: function watchDir_closure3(t0) {
                this._box_0 = t0;
            },
            watchDir_closure4: function watchDir_closure4(t0) {
                this._box_0 = t0;
            },
            watchDir_closure5: function watchDir_closure5(t0, t1, t2) {
                this._box_0 = t0;
                this.watcher = t1;
                this.completer = t2;
            },
            watchDir__closure: function watchDir__closure(t0) {
                this.watcher = t0;
            },
            JSArray0: function JSArray0() {},
            Chokidar: function Chokidar() {},
            ChokidarOptions: function ChokidarOptions() {},
            ChokidarWatcher: function ChokidarWatcher() {},
            JSFunction: function JSFunction() {},
            ImmutableList: function ImmutableList() {},
            ImmutableMap: function ImmutableMap() {},
            NodeImporterResult: function NodeImporterResult() {},
            RenderContext: function RenderContext() {},
            RenderContextOptions: function RenderContextOptions() {},
            RenderContextResult: function RenderContextResult() {},
            RenderContextResultStats: function RenderContextResultStats() {},
            JSModule: function JSModule() {},
            JSModuleRequire: function JSModuleRequire() {},
            ParcelWatcher_subscribe: function(_this, path, callback) {
                var result, t1 = new A.ParcelWatcher_subscribe_closure(callback);
                if (typeof t1 == "function") A.throwExpression(A.ArgumentError$("Attempting to rewrap a JS function.", null));
                result = function(_call, f) {
                    return function(arg1, arg2) {
                        return _call(f, arg1, arg2, arguments.length);
                    };
                }(A._callDartFunctionFast2, t1);
                result[$.$get$DART_CLOSURE_DART_JSINTEROP_PROPERTY_NAME()] = t1;
                return A.promiseToFuture(_this.subscribe(path, result), type$.JSObject);
            },
            ParcelWatcher_subscribe_closure: function ParcelWatcher_subscribe_closure(t0) {
                this.callback = t0;
            },
            JSClass: function JSClass() {},
            JSUrl: function JSUrl() {},
            jsThrow0: function(error) {
                return type$.Never._as($.$get$_jsThrow0().call$1(error));
            },
            _PropertyDescriptor: function _PropertyDescriptor() {},
            _RequireMain: function _RequireMain() {},
            WarnForDeprecation_warnForDeprecation: function(_this, deprecation, message, span, trace) {
                _this.internalWarn$4$deprecation$span$trace(message, deprecation, span, trace);
            },
            LoggerWithDeprecationType: function LoggerWithDeprecationType() {},
            _QuietLogger: function _QuietLogger() {},
            DefaultLogger: function DefaultLogger() {},
            DeprecationProcessingLogger: function DeprecationProcessingLogger(t0, t1, t2, t3, t4, t5) {
                var _ = this;
                _._warningCounts = t0;
                _._inner = t1;
                _.silenceDeprecations = t2;
                _.fatalDeprecations = t3;
                _.futureDeprecations = t4;
                _.limitRepetition = t5;
            },
            DeprecationProcessingLogger_summarize_closure: function DeprecationProcessingLogger_summarize_closure() {},
            DeprecationProcessingLogger_summarize_closure0: function DeprecationProcessingLogger_summarize_closure0() {},
            StderrLogger: function StderrLogger(t0) {
                this.color = t0;
            },
            TrackingLogger: function TrackingLogger(t0) {
                this._tracking$_logger = t0;
                this._emittedDebug = this._emittedWarning = false;
            },
            BuiltInModule$: function($name, functions, mixins, variables, $T) {
                var t1 = A._Uri__Uri(null, $name, null, "sass"), t2 = A.BuiltInModule__callableMap(functions, $T), t3 = A.BuiltInModule__callableMap(mixins, $T), t4 = variables == null ? B.Map_empty6 : new A.UnmodifiableMapView(variables, type$.UnmodifiableMapView_String_Value);
                return new A.BuiltInModule(t1, t2, t3, t4, $T._eval$1("BuiltInModule<0>"));
            },
            BuiltInModule__callableMap: function(callables, $T) {
                var t2, _i, callable, t1 = type$.String;
                if (callables == null) t1 = A.LinkedHashMap_LinkedHashMap$_empty(t1, $T);
                else {
                    t1 = A.LinkedHashMap_LinkedHashMap$_empty(t1, $T);
                    for(t2 = callables.length, _i = 0; _i < callables.length; callables.length === t2 || (0, A.throwConcurrentModificationError)(callables), ++_i){
                        callable = callables[_i];
                        t1.$indexSet(0, callable.get$name(callable), callable);
                    }
                    t1 = new A.UnmodifiableMapView(t1, type$.$env_1_1_String._bind$1($T)._eval$1("UnmodifiableMapView<1,2>"));
                }
                return new A.UnmodifiableMapView(t1, type$.$env_1_1_String._bind$1($T)._eval$1("UnmodifiableMapView<1,2>"));
            },
            BuiltInModule: function BuiltInModule(t0, t1, t2, t3, t4) {
                var _ = this;
                _.url = t0;
                _.functions = t1;
                _.mixins = t2;
                _.variables = t3;
                _.$ti = t4;
            },
            ForwardedModuleView_ifNecessary: function(inner, rule, $T) {
                var t2, t1 = false;
                if (rule.prefix == null) {
                    if (rule.shownMixinsAndFunctions == null) {
                        if (rule.shownVariables == null) {
                            t2 = rule.hiddenMixinsAndFunctions;
                            t2 = t2 == null ? null : t2._base.get$isEmpty(0);
                            if (t2 === true) {
                                t1 = rule.hiddenVariables;
                                t1 = t1 == null ? null : t1._base.get$isEmpty(0);
                                t1 = t1 === true;
                            }
                        }
                    }
                }
                if (t1) return inner;
                else return A.ForwardedModuleView$(inner, rule, $T);
            },
            ForwardedModuleView$: function(_inner, _rule, $T) {
                var t1 = _rule.prefix, t2 = _rule.shownVariables, t3 = _rule.hiddenVariables, t4 = _rule.shownMixinsAndFunctions, t5 = _rule.hiddenMixinsAndFunctions;
                return new A.ForwardedModuleView(_inner, _rule, A.ForwardedModuleView__forwardedMap(_inner.get$variables(), t1, t2, t3, type$.Value), A.ForwardedModuleView__forwardedMap(_inner.get$variableNodes(), t1, t2, t3, type$.AstNode), A.ForwardedModuleView__forwardedMap(_inner.get$functions(_inner), t1, t4, t5, $T), A.ForwardedModuleView__forwardedMap(_inner.get$mixins(), t1, t4, t5, $T), $T._eval$1("ForwardedModuleView<0>"));
            },
            ForwardedModuleView__forwardedMap: function(map, prefix, safelist, blocklist, $V) {
                var t1 = prefix == null, t2 = false;
                if (t1) {
                    if (safelist == null) t2 = blocklist == null || blocklist._base.get$isEmpty(0);
                }
                if (t2) return map;
                if (!t1) map = new A.PrefixedMapView(map, prefix, $V._eval$1("PrefixedMapView<0>"));
                if (safelist != null) map = new A.LimitedMapView(map, safelist._base.intersection$1(new A.MapKeySet(map, type$.MapKeySet_nullable_Object)), type$.$env_1_1_String._bind$1($V)._eval$1("LimitedMapView<1,2>"));
                else if (blocklist != null && blocklist._base.get$isNotEmpty(0)) map = A.LimitedMapView$blocklist(map, blocklist, type$.String, $V);
                return map;
            },
            ForwardedModuleView: function ForwardedModuleView(t0, t1, t2, t3, t4, t5, t6) {
                var _ = this;
                _._forwarded_view$_inner = t0;
                _._rule = t1;
                _.variables = t2;
                _.variableNodes = t3;
                _.functions = t4;
                _.mixins = t5;
                _.$ti = t6;
            },
            ShadowedModuleView_ifNecessary: function(inner, functions, mixins, variables, $T) {
                return A.ShadowedModuleView__needsBlocklist(inner.get$variables(), variables) || A.ShadowedModuleView__needsBlocklist(inner.get$functions(inner), functions) || A.ShadowedModuleView__needsBlocklist(inner.get$mixins(), mixins) ? new A.ShadowedModuleView(inner, A.ShadowedModuleView__shadowedMap(inner.get$variables(), variables, type$.Value), A.ShadowedModuleView__shadowedMap(inner.get$variableNodes(), variables, type$.AstNode), A.ShadowedModuleView__shadowedMap(inner.get$functions(inner), functions, $T), A.ShadowedModuleView__shadowedMap(inner.get$mixins(), mixins, $T), $T._eval$1("ShadowedModuleView<0>")) : null;
            },
            ShadowedModuleView__shadowedMap: function(map, blocklist, $V) {
                var t1 = A.ShadowedModuleView__needsBlocklist(map, blocklist);
                return !t1 ? map : A.LimitedMapView$blocklist(map, blocklist, type$.String, $V);
            },
            ShadowedModuleView__needsBlocklist: function(map, blocklist) {
                return map.get$isNotEmpty(map) && blocklist.any$1(0, map.get$containsKey());
            },
            ShadowedModuleView: function ShadowedModuleView(t0, t1, t2, t3, t4, t5) {
                var _ = this;
                _._shadowed_view$_inner = t0;
                _.variables = t1;
                _.variableNodes = t2;
                _.functions = t3;
                _.mixins = t4;
                _.$ti = t5;
            },
            AtRootQueryParser: function AtRootQueryParser(t0, t1) {
                this.scanner = t0;
                this._interpolationMap = t1;
            },
            AtRootQueryParser_parse_closure: function AtRootQueryParser_parse_closure(t0) {
                this.$this = t0;
            },
            _disallowedFunctionNames_closure: function _disallowedFunctionNames_closure() {},
            CssParser: function CssParser(t0, t1, t2, t3, t4) {
                var _ = this;
                _._stylesheet$_parseSelectors = t0;
                _._isUseAllowed = true;
                _._inExpression = _._inParentheses = _._inStyleRule = _._inPlainCssFunction = _._stylesheet$_inUnknownAtRule = _._inControlDirective = _._inContentBlock = _._stylesheet$_inMixin = false;
                _._globalVariables = t1;
                _.warnings = t2;
                _.lastSilentComment = null;
                _.scanner = t3;
                _._interpolationMap = t4;
            },
            KeyframeSelectorParser: function KeyframeSelectorParser(t0, t1) {
                this.scanner = t0;
                this._interpolationMap = t1;
            },
            KeyframeSelectorParser_parse_closure: function KeyframeSelectorParser_parse_closure(t0) {
                this.$this = t0;
            },
            MediaQueryParser: function MediaQueryParser(t0, t1) {
                this.scanner = t0;
                this._interpolationMap = t1;
            },
            MediaQueryParser_parse_closure: function MediaQueryParser_parse_closure(t0) {
                this.$this = t0;
            },
            Parser_isIdentifier: function(text) {
                var _$exception;
                try {
                    new A.Parser(A.SpanScanner$(text, null), null)._parseIdentifier$0();
                    return true;
                } catch (exception) {
                    if (type$.SassFormatException._is(A.unwrapException(exception))) return false;
                    else throw exception;
                }
            },
            Parser: function Parser(t0, t1) {
                this.scanner = t0;
                this._interpolationMap = t1;
            },
            Parser__parseIdentifier_closure: function Parser__parseIdentifier_closure(t0) {
                this.$this = t0;
            },
            Parser_escape_closure: function Parser_escape_closure() {},
            Parser_scanIdentChar_matches: function Parser_scanIdentChar_matches(t0, t1) {
                this.caseSensitive = t0;
                this.char = t1;
            },
            Parser_spanFrom_closure: function Parser_spanFrom_closure(t0, t1) {
                this.$this = t0;
                this.span = t1;
            },
            Parser_spanFromPosition_closure: function Parser_spanFromPosition_closure(t0, t1) {
                this.$this = t0;
                this.span = t1;
            },
            SassParser: function SassParser(t0, t1, t2, t3, t4) {
                var _ = this;
                _._currentIndentation = 0;
                _._spaces = _._nextIndentationEnd = _._nextIndentation = null;
                _._stylesheet$_parseSelectors = t0;
                _._isUseAllowed = true;
                _._inExpression = _._inParentheses = _._inStyleRule = _._inPlainCssFunction = _._stylesheet$_inUnknownAtRule = _._inControlDirective = _._inContentBlock = _._stylesheet$_inMixin = false;
                _._globalVariables = t1;
                _.warnings = t2;
                _.lastSilentComment = null;
                _.scanner = t3;
                _._interpolationMap = t4;
            },
            SassParser_styleRuleSelector_closure: function SassParser_styleRuleSelector_closure() {},
            SassParser_children_closure: function SassParser_children_closure(t0, t1, t2) {
                this.$this = t0;
                this.child = t1;
                this.children = t2;
            },
            SassParser__peekIndentation_closure: function SassParser__peekIndentation_closure() {},
            SassParser__peekIndentation_closure0: function SassParser__peekIndentation_closure0() {},
            SassParser__tryTrailingSemicolon_closure: function SassParser__tryTrailingSemicolon_closure() {},
            ScssParser$: function(contents, parseSelectors, url) {
                return new A.ScssParser(false, A.LinkedHashMap_LinkedHashMap$_empty(type$.String, type$.FileSpan), A._setArrayType([], type$.JSArray_Record_3_nullable_Deprecation_deprecation_and_String_message_and_FileSpan_span), A.SpanScanner$(contents, url), null);
            },
            ScssParser: function ScssParser(t0, t1, t2, t3, t4) {
                var _ = this;
                _._stylesheet$_parseSelectors = t0;
                _._isUseAllowed = true;
                _._inExpression = _._inParentheses = _._inStyleRule = _._inPlainCssFunction = _._stylesheet$_inUnknownAtRule = _._inControlDirective = _._inContentBlock = _._stylesheet$_inMixin = false;
                _._globalVariables = t1;
                _.warnings = t2;
                _.lastSilentComment = null;
                _.scanner = t3;
                _._interpolationMap = t4;
            },
            SelectorParser$: function(contents, allowParent, interpolationMap, logger, plainCss, url) {
                return new A.SelectorParser(allowParent, plainCss, logger, A.SpanScanner$(contents, url), interpolationMap);
            },
            SelectorParser: function SelectorParser(t0, t1, t2, t3, t4) {
                var _ = this;
                _._allowParent = t0;
                _._plainCss = t1;
                _._selector$_logger = t2;
                _.scanner = t3;
                _._interpolationMap = t4;
            },
            SelectorParser_parse_closure: function SelectorParser_parse_closure(t0) {
                this.$this = t0;
            },
            SelectorParser_parseCompoundSelector_closure: function SelectorParser_parseCompoundSelector_closure(t0) {
                this.$this = t0;
            },
            StylesheetParser: function StylesheetParser() {},
            StylesheetParser_parse_closure: function StylesheetParser_parse_closure(t0) {
                this.$this = t0;
            },
            StylesheetParser_parse__closure: function StylesheetParser_parse__closure(t0) {
                this.$this = t0;
            },
            StylesheetParser_parseParameterList_closure: function StylesheetParser_parseParameterList_closure(t0) {
                this.$this = t0;
            },
            StylesheetParser_parseVariableDeclaration_closure: function StylesheetParser_parseVariableDeclaration_closure(t0) {
                this.$this = t0;
            },
            StylesheetParser_parseUseRule_closure: function StylesheetParser_parseUseRule_closure(t0) {
                this.$this = t0;
            },
            StylesheetParser__parseSingleProduction_closure: function StylesheetParser__parseSingleProduction_closure(t0, t1, t2) {
                this.$this = t0;
                this.production = t1;
                this.T = t2;
            },
            StylesheetParser__statement_closure: function StylesheetParser__statement_closure(t0) {
                this.$this = t0;
            },
            StylesheetParser_variableDeclarationWithoutNamespace_closure: function StylesheetParser_variableDeclarationWithoutNamespace_closure(t0, t1) {
                this.$this = t0;
                this.start = t1;
            },
            StylesheetParser_variableDeclarationWithoutNamespace_closure0: function StylesheetParser_variableDeclarationWithoutNamespace_closure0(t0) {
                this.declaration = t0;
            },
            StylesheetParser__declarationOrBuffer_closure: function StylesheetParser__declarationOrBuffer_closure(t0) {
                this.$this = t0;
            },
            StylesheetParser__declarationOrBuffer_closure0: function StylesheetParser__declarationOrBuffer_closure0(t0) {
                this.$this = t0;
            },
            StylesheetParser__declarationOrBuffer_closure1: function StylesheetParser__declarationOrBuffer_closure1() {},
            StylesheetParser__declarationOrBuffer_closure2: function StylesheetParser__declarationOrBuffer_closure2(t0) {
                this.$this = t0;
            },
            StylesheetParser__styleRule_closure: function StylesheetParser__styleRule_closure(t0, t1, t2) {
                this._box_0 = t0;
                this.$this = t1;
                this.start = t2;
            },
            StylesheetParser__withStyleRuleChildren_closure: function StylesheetParser__withStyleRuleChildren_closure(t0, t1, t2, t3, t4) {
                var _ = this;
                _.$this = t0;
                _.nodeWithSpan = t1;
                _.wasInStyleRule = t2;
                _.create = t3;
                _.T = t4;
            },
            StylesheetParser__propertyOrVariableDeclaration_closure: function StylesheetParser__propertyOrVariableDeclaration_closure(t0) {
                this.$this = t0;
            },
            StylesheetParser__tryDeclarationChildren_closure: function StylesheetParser__tryDeclarationChildren_closure(t0, t1) {
                this.name = t0;
                this.value = t1;
            },
            StylesheetParser__atRootRule_closure: function StylesheetParser__atRootRule_closure(t0) {
                this.query = t0;
            },
            StylesheetParser__atRootRule_closure0: function StylesheetParser__atRootRule_closure0() {},
            StylesheetParser__eachRule_closure: function StylesheetParser__eachRule_closure(t0, t1, t2, t3) {
                var _ = this;
                _.$this = t0;
                _.wasInControlDirective = t1;
                _.variables = t2;
                _.list = t3;
            },
            StylesheetParser__functionRule_closure: function StylesheetParser__functionRule_closure(t0, t1, t2) {
                this.name = t0;
                this.parameters = t1;
                this.precedingComment = t2;
            },
            StylesheetParser__forRule_closure: function StylesheetParser__forRule_closure(t0, t1) {
                this._box_0 = t0;
                this.$this = t1;
            },
            StylesheetParser__forRule_closure0: function StylesheetParser__forRule_closure0(t0, t1, t2, t3, t4, t5) {
                var _ = this;
                _._box_0 = t0;
                _.$this = t1;
                _.wasInControlDirective = t2;
                _.variable = t3;
                _.from = t4;
                _.to = t5;
            },
            StylesheetParser__memberList_closure: function StylesheetParser__memberList_closure(t0, t1, t2) {
                this.$this = t0;
                this.variables = t1;
                this.identifiers = t2;
            },
            StylesheetParser__includeRule_closure: function StylesheetParser__includeRule_closure(t0) {
                this.contentParameters_ = t0;
            },
            StylesheetParser_mediaRule_closure: function StylesheetParser_mediaRule_closure(t0) {
                this.query = t0;
            },
            StylesheetParser__mixinRule_closure: function StylesheetParser__mixinRule_closure(t0, t1, t2, t3) {
                var _ = this;
                _.$this = t0;
                _.name = t1;
                _.parameters = t2;
                _.precedingComment = t3;
            },
            StylesheetParser_mozDocumentRule_closure: function StylesheetParser_mozDocumentRule_closure(t0) {
                this.$this = t0;
            },
            StylesheetParser_mozDocumentRule_closure0: function StylesheetParser_mozDocumentRule_closure0(t0, t1, t2, t3) {
                var _ = this;
                _._box_0 = t0;
                _.$this = t1;
                _.name = t2;
                _.value = t3;
            },
            StylesheetParser_supportsRule_closure: function StylesheetParser_supportsRule_closure(t0) {
                this.condition = t0;
            },
            StylesheetParser__whileRule_closure: function StylesheetParser__whileRule_closure(t0, t1, t2) {
                this.$this = t0;
                this.wasInControlDirective = t1;
                this.condition = t2;
            },
            StylesheetParser_unknownAtRule_closure: function StylesheetParser_unknownAtRule_closure(t0, t1) {
                this._box_0 = t0;
                this.name = t1;
            },
            StylesheetParser__expression_resetState: function StylesheetParser__expression_resetState(t0, t1, t2) {
                this._box_0 = t0;
                this.$this = t1;
                this.start = t2;
            },
            StylesheetParser__expression_resolveOneOperation: function StylesheetParser__expression_resolveOneOperation(t0, t1) {
                this._box_0 = t0;
                this.$this = t1;
            },
            StylesheetParser__expression_resolveOperations: function StylesheetParser__expression_resolveOperations(t0, t1) {
                this._box_0 = t0;
                this.resolveOneOperation = t1;
            },
            StylesheetParser__expression_addSingleExpression: function StylesheetParser__expression_addSingleExpression(t0, t1, t2, t3) {
                var _ = this;
                _._box_0 = t0;
                _.$this = t1;
                _.resetState = t2;
                _.resolveOperations = t3;
            },
            StylesheetParser__expression_addOperator: function StylesheetParser__expression_addOperator(t0, t1, t2, t3) {
                var _ = this;
                _._box_0 = t0;
                _.$this = t1;
                _.resolveOneOperation = t2;
                _.addSingleExpression = t3;
            },
            StylesheetParser__expression_resolveSpaceExpressions: function StylesheetParser__expression_resolveSpaceExpressions(t0, t1, t2) {
                this._box_0 = t0;
                this.$this = t1;
                this.resolveOperations = t2;
            },
            StylesheetParser_expressionUntilComma_closure: function StylesheetParser_expressionUntilComma_closure(t0) {
                this.$this = t0;
            },
            StylesheetParser__isHexColor_closure: function StylesheetParser__isHexColor_closure() {},
            StylesheetParser__unicodeRange_closure: function StylesheetParser__unicodeRange_closure() {},
            StylesheetParser__unicodeRange_closure0: function StylesheetParser__unicodeRange_closure0() {},
            StylesheetParser_interpolatedStringToken_closure: function StylesheetParser_interpolatedStringToken_closure(t0) {
                this.$this = t0;
            },
            StylesheetParser_namespacedExpression_closure: function StylesheetParser_namespacedExpression_closure(t0, t1) {
                this.$this = t0;
                this.start = t1;
            },
            StylesheetParser_trySpecialFunction_closure: function StylesheetParser_trySpecialFunction_closure() {},
            StylesheetParser__interpolatedDeclarationValue_closure: function StylesheetParser__interpolatedDeclarationValue_closure(t0) {
                this.$this = t0;
            },
            StylesheetParser__expressionUntilComparison_closure: function StylesheetParser__expressionUntilComparison_closure(t0) {
                this.$this = t0;
            },
            StylesheetParser__publicIdentifier_closure: function StylesheetParser__publicIdentifier_closure(t0, t1) {
                this.$this = t0;
                this.start = t1;
            },
            StylesheetNode$_: function(_stylesheet, importer, canonicalUrl, allUpstream) {
                var t1 = new A.StylesheetNode(_stylesheet, importer, canonicalUrl, allUpstream._1, allUpstream._0, A.LinkedHashSet_LinkedHashSet$_empty(type$.StylesheetNode));
                t1.StylesheetNode$_$4(_stylesheet, importer, canonicalUrl, allUpstream);
                return t1;
            },
            StylesheetGraph: function StylesheetGraph(t0, t1, t2) {
                this._nodes = t0;
                this.importCache = t1;
                this._transitiveModificationTimes = t2;
            },
            StylesheetGraph_modifiedSince_transitiveModificationTime: function StylesheetGraph_modifiedSince_transitiveModificationTime(t0, t1) {
                this.$this = t0;
                this.seenNodes = t1;
            },
            StylesheetGraph_modifiedSince_transitiveModificationTime_closure: function StylesheetGraph_modifiedSince_transitiveModificationTime_closure(t0, t1, t2) {
                this.node = t0;
                this.seenNodes = t1;
                this.transitiveModificationTime = t2;
            },
            StylesheetGraph__add_closure: function StylesheetGraph__add_closure(t0, t1, t2, t3) {
                var _ = this;
                _.$this = t0;
                _.url = t1;
                _.baseImporter = t2;
                _.baseUrl = t3;
            },
            StylesheetGraph_addCanonical_closure: function StylesheetGraph_addCanonical_closure(t0, t1, t2, t3) {
                var _ = this;
                _.$this = t0;
                _.importer = t1;
                _.canonicalUrl = t2;
                _.originalUrl = t3;
            },
            StylesheetGraph_reload_closure: function StylesheetGraph_reload_closure(t0, t1, t2) {
                this.$this = t0;
                this.node = t1;
                this.canonicalUrl = t2;
            },
            StylesheetGraph__nodeFor_closure: function StylesheetGraph__nodeFor_closure(t0, t1, t2, t3, t4) {
                var _ = this;
                _.$this = t0;
                _.url = t1;
                _.baseImporter = t2;
                _.baseUrl = t3;
                _.forImport = t4;
            },
            StylesheetGraph__nodeFor_closure0: function StylesheetGraph__nodeFor_closure0(t0, t1) {
                this._box_0 = t0;
                this.$this = t1;
            },
            StylesheetNode: function StylesheetNode(t0, t1, t2, t3, t4, t5) {
                var _ = this;
                _._stylesheet = t0;
                _.importer = t1;
                _.canonicalUrl = t2;
                _._upstream = t3;
                _._upstreamImports = t4;
                _._downstream = t5;
            },
            Syntax_forPath: function(path) {
                var t1, _0_0 = A.ParsedPath_ParsedPath$parse(path, $.$get$context().style)._splitExtension$1(1)[1];
                $label0$0: {
                    if (".sass" === _0_0) {
                        t1 = B.Syntax_Sass_1_sass;
                        break $label0$0;
                    }
                    if (".css" === _0_0) {
                        t1 = B.Syntax_CSS_2_css;
                        break $label0$0;
                    }
                    t1 = B.Syntax_SCSS_0_scss;
                    break $label0$0;
                }
                return t1;
            },
            Syntax: function Syntax(t0, t1, t2) {
                this._syntax$_name = t0;
                this.index = t1;
                this._name = t2;
            },
            Box: function Box(t0, t1) {
                this._box$_inner = t0;
                this.$ti = t1;
            },
            ModifiableBox: function ModifiableBox(t0, t1) {
                this.value = t0;
                this.$ti = t1;
            },
            LazyFileSpan: function LazyFileSpan(t0) {
                this._builder = t0;
                this._lazy_file_span$_span = null;
            },
            LimitedMapView$blocklist: function(_map, blocklist, $K, $V) {
                var t2, key, t1 = A.LinkedHashSet_LinkedHashSet$_empty($K);
                for(t2 = _map.get$keys(_map), t2 = t2.get$iterator(t2); t2.moveNext$0();){
                    key = t2.get$current(t2);
                    if (!blocklist.contains$1(0, key)) t1.add$1(0, key);
                }
                return new A.LimitedMapView(_map, t1, $K._eval$1("@<0>")._bind$1($V)._eval$1("LimitedMapView<1,2>"));
            },
            LimitedMapView: function LimitedMapView(t0, t1, t2) {
                this._limited_map_view$_map = t0;
                this._limited_map_view$_keys = t1;
                this.$ti = t2;
            },
            MapExtensions_get_pairs: function(_this, $K, $V) {
                var t1 = _this.get$entries(_this);
                return t1.map$1$1(t1, new A.MapExtensions_get_pairs_closure($K, $V), $K._eval$1("@<0>")._bind$1($V)._eval$1("+(1,2)"));
            },
            MapExtensions_get_pairs_closure: function MapExtensions_get_pairs_closure(t0, t1) {
                this.K = t0;
                this.V = t1;
            },
            MergedMapView$: function(maps, $K, $V) {
                var t1 = $K._eval$1("@<0>")._bind$1($V);
                t1 = new A.MergedMapView(A.LinkedHashMap_LinkedHashMap$_empty($K, t1._eval$1("Map<1,2>")), t1._eval$1("MergedMapView<1,2>"));
                t1.MergedMapView$1(maps, $K, $V);
                return t1;
            },
            MergedMapView: function MergedMapView(t0, t1) {
                this._mapsByKey = t0;
                this.$ti = t1;
            },
            MultiDirWatcher: function MultiDirWatcher(t0, t1, t2) {
                this._watchers = t0;
                this._group = t1;
                this._poll = t2;
            },
            MultiSpan: function MultiSpan(t0, t1, t2) {
                this._multi_span$_primary = t0;
                this.primaryLabel = t1;
                this.secondarySpans = t2;
            },
            NoSourceMapBuffer: function NoSourceMapBuffer(t0) {
                this._no_source_map_buffer$_buffer = t0;
            },
            PrefixedMapView: function PrefixedMapView(t0, t1, t2) {
                this._prefixed_map_view$_map = t0;
                this._prefix = t1;
                this.$ti = t2;
            },
            _PrefixedKeys: function _PrefixedKeys(t0) {
                this._view = t0;
            },
            _PrefixedKeys_iterator_closure: function _PrefixedKeys_iterator_closure(t0) {
                this.$this = t0;
            },
            PublicMemberMapView: function PublicMemberMapView(t0, t1) {
                this._public_member_map_view$_inner = t0;
                this.$ti = t1;
            },
            SourceMapBuffer: function SourceMapBuffer(t0, t1) {
                var _ = this;
                _._source_map_buffer$_buffer = t0;
                _._entries = t1;
                _._column = _._line = 0;
                _._inSpan = false;
            },
            SourceMapBuffer_buildSourceMap_closure: function SourceMapBuffer_buildSourceMap_closure(t0, t1) {
                this._box_0 = t0;
                this.prefixLength = t1;
            },
            UnprefixedMapView: function UnprefixedMapView(t0, t1, t2) {
                this._unprefixed_map_view$_map = t0;
                this._unprefixed_map_view$_prefix = t1;
                this.$ti = t2;
            },
            _UnprefixedKeys: function _UnprefixedKeys(t0) {
                this._unprefixed_map_view$_view = t0;
            },
            _UnprefixedKeys_iterator_closure: function _UnprefixedKeys_iterator_closure(t0) {
                this.$this = t0;
            },
            _UnprefixedKeys_iterator_closure0: function _UnprefixedKeys_iterator_closure0(t0) {
                this.$this = t0;
            },
            toSentence: function(iter, conjunction) {
                if (iter.get$length(iter) === 1) return J.toString$0$(iter.get$first(iter));
                return A.IterableExtension_get_exceptLast(iter).join$1(0, ", ") + (" " + conjunction + " " + A.S(iter.get$last(iter)));
            },
            indent: function(string, indentation) {
                return new A.MappedListIterable(A._setArrayType(string.split("\n"), type$.JSArray_String), new A.indent_closure(indentation), type$.MappedListIterable_String_String).join$1(0, "\n");
            },
            pluralize: function($name, number, plural) {
                if (number === 1) return $name;
                if (plural != null) return plural;
                return $name + "s";
            },
            trimAscii: function(string, excludeEscape) {
                var t1, start = A._firstNonWhitespace(string);
                if (start == null) t1 = "";
                else {
                    t1 = A._lastNonWhitespace(string, true);
                    t1.toString;
                    t1 = B.JSString_methods.substring$2(string, start, t1 + 1);
                }
                return t1;
            },
            trimAsciiRight: function(string, excludeEscape) {
                var end = A._lastNonWhitespace(string, excludeEscape);
                return end == null ? "" : B.JSString_methods.substring$2(string, 0, end + 1);
            },
            _firstNonWhitespace: function(string) {
                var t1, i, t2;
                for(t1 = string.length, i = 0; i < t1; ++i){
                    t2 = string.charCodeAt(i);
                    if (!(t2 === 32 || t2 === 9 || t2 === 10 || t2 === 13 || t2 === 12)) return i;
                }
                return null;
            },
            _lastNonWhitespace: function(string, excludeEscape) {
                var i, i0, codeUnit;
                for(i = string.length - 1, i0 = i; i0 >= 0; --i0){
                    codeUnit = string.charCodeAt(i0);
                    if (!(codeUnit === 32 || codeUnit === 9 || codeUnit === 10 || codeUnit === 13 || codeUnit === 12)) {
                        if (excludeEscape && i0 !== 0 && i0 !== i && codeUnit === 92) return i0 + 1;
                        else return i0;
                    }
                }
                return null;
            },
            isPublic: function(member) {
                var start = member.charCodeAt(0);
                return start !== 45 && start !== 95;
            },
            flattenVertically: function(iterable, $T) {
                var result, t1 = iterable.$ti._eval$1("@<ListIterable.E>")._bind$1($T._eval$1("QueueList<0>"))._eval$1("MappedListIterable<1,2>"), queues = A.List_List$_of(new A.MappedListIterable(iterable, new A.flattenVertically_closure($T), t1), t1._eval$1("ListIterable.E"));
                if (queues.length === 1) return B.JSArray_methods.get$first(queues);
                result = A._setArrayType([], $T._eval$1("JSArray<0>"));
                while(queues.length !== 0){
                    queues.$flags & 1 && A.throwUnsupportedOperation(queues, 16);
                    B.JSArray_methods._removeWhere$2(queues, new A.flattenVertically_closure0(result, $T), true);
                }
                return result;
            },
            codepointIndexToCodeUnitIndex: function(string, codepointIndex) {
                var codeUnitIndex, i, codeUnitIndex0;
                for(codeUnitIndex = 0, i = 0; i < codepointIndex; ++i){
                    codeUnitIndex0 = codeUnitIndex + 1;
                    codeUnitIndex = string.charCodeAt(codeUnitIndex) >>> 10 === 54 ? codeUnitIndex0 + 1 : codeUnitIndex0;
                }
                return codeUnitIndex;
            },
            codeUnitIndexToCodepointIndex: function(string, codeUnitIndex) {
                var codepointIndex, i;
                for(codepointIndex = 0, i = 0; i < codeUnitIndex; i = (string.charCodeAt(i) >>> 10 === 54 ? i + 1 : i) + 1)++codepointIndex;
                return codepointIndex;
            },
            frameForSpan: function(span, member, url) {
                var t2, t3, t1 = url == null ? span.get$sourceUrl(span) : url;
                if (t1 == null) t1 = $.$get$_noSourceUrl();
                t2 = span.get$start(span);
                t2 = t2.file.getLine$1(t2.offset);
                t3 = span.get$start(span);
                return new A.Frame(t1, t2 + 1, t3.file.getColumn$1(t3.offset) + 1, member);
            },
            declarationName: function(span) {
                var text = span.get$text();
                return A.trimAsciiRight(B.JSString_methods.substring$2(text, 0, B.JSString_methods.indexOf$1(text, ":")), false);
            },
            unvendor: function($name) {
                var i, t1 = $name.length;
                if (t1 < 2) return $name;
                if ($name.charCodeAt(0) !== 45) return $name;
                if ($name.charCodeAt(1) === 45) return $name;
                for(i = 2; i < t1; ++i)if ($name.charCodeAt(i) === 45) return B.JSString_methods.substring$1($name, i + 1);
                return $name;
            },
            equalsIgnoreCase: function(string1, string2) {
                var t1, i;
                if (string1 === string2) return true;
                if (string1 == null) return false;
                t1 = string1.length;
                if (t1 !== string2.length) return false;
                for(i = 0; i < t1; ++i)if (!A.characterEqualsIgnoreCase(string1.charCodeAt(i), string2.charCodeAt(i))) return false;
                return true;
            },
            startsWithIgnoreCase: function(string, prefix) {
                var i, t1 = prefix.length;
                if (string.length < t1) return false;
                for(i = 0; i < t1; ++i)if (!A.characterEqualsIgnoreCase(string.charCodeAt(i), prefix.charCodeAt(i))) return false;
                return true;
            },
            mapInPlace: function(list, $function) {
                var i;
                for(i = 0; i < list.length; ++i)list[i] = $function.call$1(list[i]);
            },
            longestCommonSubsequence: function(list1, list2, select, $T) {
                var t1, _i, selections, i, i0, j, selection, j0, _length = list1.get$length(0) + 1, lengths = J.JSArray_JSArray$allocateFixed(_length, type$.List_int);
                for(t1 = type$.int, _i = 0; _i < _length; ++_i)lengths[_i] = A.List_List$filled(((list2._queue_list$_tail - list2._queue_list$_head & J.get$length$asx(list2._queue_list$_table) - 1) >>> 0) + 1, 0, false, t1);
                _length = list1.get$length(0);
                selections = J.JSArray_JSArray$allocateFixed(_length, $T._eval$1("List<0?>"));
                for(t1 = $T._eval$1("0?"), _i = 0; _i < _length; ++_i)selections[_i] = A.List_List$filled((list2._queue_list$_tail - list2._queue_list$_head & J.get$length$asx(list2._queue_list$_table) - 1) >>> 0, null, false, t1);
                for(i = 0; i < (list1._queue_list$_tail - list1._queue_list$_head & J.get$length$asx(list1._queue_list$_table) - 1) >>> 0; i = i0)for(i0 = i + 1, j = 0; j < (list2._queue_list$_tail - list2._queue_list$_head & J.get$length$asx(list2._queue_list$_table) - 1) >>> 0; j = j0){
                    selection = select.call$2(list1.$index(0, i), list2.$index(0, j));
                    selections[i][j] = selection;
                    t1 = lengths[i0];
                    j0 = j + 1;
                    t1[j0] = selection == null ? Math.max(t1[j], lengths[i][j0]) : lengths[i][j] + 1;
                }
                return new A.longestCommonSubsequence_backtrack(selections, lengths, $T).call$2(list1.get$length(0) - 1, list2.get$length(0) - 1);
            },
            removeFirstWhere: function(list, test, orElse) {
                var i;
                for(i = 0; i < list.length; ++i){
                    if (!test.call$1(list[i])) continue;
                    B.JSArray_methods.removeAt$1(list, i);
                    return;
                }
                orElse.call$0();
            },
            mapAddAll2: function(destination, source, $K1, $K2, $V) {
                source.forEach$1(0, new A.mapAddAll2_closure(destination, $K1, $K2, $V));
            },
            setAll: function(map, keys, value) {
                var t1;
                for(t1 = keys.get$iterator(keys); t1.moveNext$0();)map.$indexSet(0, t1.get$current(t1), value);
            },
            rotateSlice: function(list, start, end) {
                var i, next, element = list.$index(0, end - 1);
                for(i = start; i < end; ++i, element = next){
                    next = list.$index(0, i);
                    list.$indexSet(0, i, element);
                }
            },
            mapAsync: function(iterable, callback, $E, $F) {
                return A.mapAsync$body(iterable, callback, $E, $F, $F._eval$1("Iterable<0>"));
            },
            mapAsync$body: function(iterable, callback, $E, $F, $async$type) {
                var $async$goto = 0, $async$completer = A._makeAsyncAwaitCompleter($async$type), $async$returnValue, t2, _i, t1, $async$temp1;
                var $async$mapAsync = A._wrapJsFunctionForAsync(function($async$errorCode, $async$result) {
                    if ($async$errorCode === 1) return A._asyncRethrow($async$result, $async$completer);
                    for(;;)switch($async$goto){
                        case 0:
                            // Function start
                            t1 = A._setArrayType([], $F._eval$1("JSArray<0>"));
                            t2 = iterable.length, _i = 0;
                        case 3:
                            // for condition
                            if (!(_i < t2)) {
                                // goto after for
                                $async$goto = 5;
                                break;
                            }
                            $async$temp1 = t1;
                            $async$goto = 6;
                            return A._asyncAwait(callback.call$1(iterable[_i]), $async$mapAsync);
                        case 6:
                            // returning from await.
                            $async$temp1.push($async$result);
                        case 4:
                            // for update
                            ++_i;
                            // goto for condition
                            $async$goto = 3;
                            break;
                        case 5:
                            // after for
                            $async$returnValue = t1;
                            // goto return
                            $async$goto = 1;
                            break;
                        case 1:
                            // return
                            return A._asyncReturn($async$returnValue, $async$completer);
                    }
                });
                return A._asyncStartSync($async$mapAsync, $async$completer);
            },
            putIfAbsentAsync: function(map, key, ifAbsent, $K, $V) {
                return A.putIfAbsentAsync$body(map, key, ifAbsent, $K, $V, $V);
            },
            putIfAbsentAsync$body: function(map, key, ifAbsent, $K, $V, $async$type) {
                var $async$goto = 0, $async$completer = A._makeAsyncAwaitCompleter($async$type), $async$returnValue, t1, value;
                var $async$putIfAbsentAsync = A._wrapJsFunctionForAsync(function($async$errorCode, $async$result) {
                    if ($async$errorCode === 1) return A._asyncRethrow($async$result, $async$completer);
                    for(;;)switch($async$goto){
                        case 0:
                            // Function start
                            if (map.containsKey$1(key)) {
                                t1 = map.$index(0, key);
                                $async$returnValue = t1 == null ? $V._as(t1) : t1;
                                // goto return
                                $async$goto = 1;
                                break;
                            }
                            $async$goto = 3;
                            return A._asyncAwait(ifAbsent.call$0(), $async$putIfAbsentAsync);
                        case 3:
                            // returning from await.
                            value = $async$result;
                            map.$indexSet(0, key, value);
                            $async$returnValue = value;
                            // goto return
                            $async$goto = 1;
                            break;
                        case 1:
                            // return
                            return A._asyncReturn($async$returnValue, $async$completer);
                    }
                });
                return A._asyncStartSync($async$putIfAbsentAsync, $async$completer);
            },
            copyMapOfMap: function(map, $K1, $K2, $V) {
                var t3, key, child, t1 = $K2._eval$1("@<0>")._bind$1($V)._eval$1("Map<1,2>"), t2 = A.LinkedHashMap_LinkedHashMap$_empty($K1, t1);
                for(t1 = A.MapExtensions_get_pairs(map, $K1, t1), t1 = t1.get$iterator(t1); t1.moveNext$0();){
                    t3 = t1.get$current(t1);
                    key = t3._0;
                    child = t3._1;
                    t3 = A.LinkedHashMap_LinkedHashMap(null, null, null, $K2, $V);
                    t3.addAll$1(0, child);
                    t2.$indexSet(0, key, t3);
                }
                return t2;
            },
            copyMapOfList: function(map, $K, $E) {
                var t3, t1 = $E._eval$1("List<0>"), t2 = A.LinkedHashMap_LinkedHashMap$_empty($K, t1);
                for(t1 = A.MapExtensions_get_pairs(map, $K, t1), t1 = t1.get$iterator(t1); t1.moveNext$0();){
                    t3 = t1.get$current(t1);
                    t2.$indexSet(0, t3._0, J.toList$0$ax(t3._1));
                }
                return t2;
            },
            consumeEscapedCharacter: function(scanner) {
                var _1_0, value, i, next, t1;
                scanner.expectChar$1(92);
                _1_0 = scanner.peekChar$0();
                if (_1_0 == null) return 65533;
                if (_1_0 === 10 || _1_0 === 13 || _1_0 === 12) scanner.error$1(0, "Expected escape sequence.");
                if (A.CharacterExtension_get_isHex(_1_0)) {
                    for(value = 0, i = 0; i < 6; ++i){
                        next = scanner.peekChar$0();
                        if (next != null) {
                            t1 = true;
                            if (!(next >= 48 && next <= 57)) {
                                if (!(next >= 97 && next <= 102)) t1 = next >= 65 && next <= 70;
                            }
                            t1 = !t1;
                        } else t1 = true;
                        if (t1) break;
                        value = (value << 4 >>> 0) + A.asHex(scanner.readChar$0());
                    }
                    t1 = scanner.peekChar$0();
                    if (t1 === 32 || t1 === 9 || t1 === 10 || t1 === 13 || t1 === 12) scanner.readChar$0();
                    $label0$1: {
                        if (0 !== value) t1 = value >= 55296 && value <= 57343 || value >= 1114111;
                        else t1 = true;
                        if (t1) {
                            t1 = 65533;
                            break $label0$1;
                        }
                        t1 = value;
                        break $label0$1;
                    }
                    return t1;
                }
                return scanner.readChar$0();
            },
            throwWithTrace: function(error, originalError, trace) {
                var t1 = A.getTrace(originalError);
                A.attachTrace(error, t1 == null ? trace : t1);
                throw A.wrapException(error);
            },
            attachTrace: function(error, trace) {
                var t1;
                if (trace.toString$0(0).length === 0) return;
                t1 = $.$get$_traces();
                A.Expando__checkType(error);
                if (t1._jsWeakMap.get(error) == null) t1.$indexSet(0, error, trace);
            },
            getTrace: function(error) {
                var t1;
                if (typeof error == "string" || typeof error == "number" || A._isBool(error)) t1 = null;
                else {
                    t1 = $.$get$_traces();
                    A.Expando__checkType(error);
                    t1 = t1._jsWeakMap.get(error);
                }
                return t1;
            },
            indent_closure: function indent_closure(t0) {
                this.indentation = t0;
            },
            flattenVertically_closure: function flattenVertically_closure(t0) {
                this.T = t0;
            },
            flattenVertically_closure0: function flattenVertically_closure0(t0, t1) {
                this.result = t0;
                this.T = t1;
            },
            longestCommonSubsequence_backtrack: function longestCommonSubsequence_backtrack(t0, t1, t2) {
                this.selections = t0;
                this.lengths = t1;
                this.T = t2;
            },
            mapAddAll2_closure: function mapAddAll2_closure(t0, t1, t2, t3) {
                var _ = this;
                _.destination = t0;
                _.K1 = t1;
                _.K2 = t2;
                _.V = t3;
            },
            SassApiValue_assertSelector: function(_this, allowParent, $name) {
                var error, stackTrace, t1, _$exception, string = _this._selectorString$1($name);
                try {
                    t1 = A.EvaluationContext_currentOrNull();
                    if (t1 == null) t1 = A.throwExpression(A.StateError$(string$.No_Sass));
                    t1 = A.SelectorList_SelectorList$parse(string, allowParent, null, new A._EvaluationContextLogger(t1), false);
                    return t1;
                } catch (exception) {
                    t1 = A.unwrapException(exception);
                    if (type$.SassFormatException._is(t1)) {
                        error = t1;
                        stackTrace = A.getTraceFromException(exception);
                        t1 = B.JSString_methods.replaceFirst$2(J.toString$0$(error), "Error: ", "");
                        A.throwWithTrace(new A.SassScriptException($name == null ? t1 : "$" + $name + ": " + t1), error, stackTrace);
                    } else throw exception;
                }
            },
            SassApiValue_assertCompoundSelector: function(_this, $name) {
                var error, stackTrace, t1, _$exception, allowParent = false, string = _this._selectorString$1($name);
                try {
                    t1 = A.EvaluationContext_currentOrNull();
                    if (t1 == null) t1 = A.throwExpression(A.StateError$(string$.No_Sass));
                    t1 = A.SelectorParser$(string, allowParent, null, new A._EvaluationContextLogger(t1), false, null).parseCompoundSelector$0();
                    return t1;
                } catch (exception) {
                    t1 = A.unwrapException(exception);
                    if (type$.SassFormatException._is(t1)) {
                        error = t1;
                        stackTrace = A.getTraceFromException(exception);
                        t1 = B.JSString_methods.replaceFirst$2(J.toString$0$(error), "Error: ", "");
                        A.throwWithTrace(new A.SassScriptException("$" + $name + ": " + t1), error, stackTrace);
                    } else throw exception;
                }
            },
            Value: function Value() {},
            SassArgumentList$: function(contents, keywords, separator) {
                var t1 = type$.Value;
                t1 = new A.SassArgumentList(A.ConstantMap_ConstantMap$from(keywords, type$.String, t1), A.List_List$unmodifiable(contents, t1), separator, false);
                t1.SassList$3$brackets(contents, separator, false);
                return t1;
            },
            SassArgumentList: function SassArgumentList(t0, t1, t2, t3) {
                var _ = this;
                _._keywords = t0;
                _._wereKeywordsAccessed = false;
                _._list$_contents = t1;
                _._separator = t2;
                _._hasBrackets = t3;
            },
            SassBoolean: function SassBoolean(t0) {
                this.value = t0;
            },
            SassCalculation_calc: function(argument) {
                var t1, _0_0 = A.SassCalculation__simplify(argument);
                $label0$0: {
                    if (_0_0 instanceof A.SassNumber) {
                        t1 = _0_0;
                        break $label0$0;
                    }
                    if (_0_0 instanceof A.SassCalculation) {
                        t1 = _0_0;
                        break $label0$0;
                    }
                    t1 = new A.SassCalculation("calc", A.List_List$unmodifiable([
                        _0_0
                    ], type$.Object));
                    break $label0$0;
                }
                return t1;
            },
            SassCalculation_min: function($arguments) {
                var minimum, _i, arg, t2, args = A.List_List$unmodifiable(new A.MappedListIterable($arguments, A.calculation_SassCalculation__simplify$closure(), A._arrayInstanceType($arguments)._eval$1("MappedListIterable<1,@>")), type$.Object), t1 = args.length;
                if (t1 === 0) throw A.wrapException(A.ArgumentError$("min() must have at least one argument.", null));
                for(minimum = null, _i = 0; _i < t1; ++_i){
                    arg = args[_i];
                    if (arg instanceof A.SassNumber) t2 = minimum != null && !minimum.isComparableTo$1(arg);
                    else t2 = true;
                    if (t2) {
                        minimum = null;
                        break;
                    } else if (minimum == null || minimum.greaterThan$1(arg).value) minimum = arg;
                }
                if (minimum != null) return minimum;
                A.SassCalculation__verifyCompatibleNumbers(args);
                return new A.SassCalculation("min", args);
            },
            SassCalculation_max: function($arguments) {
                var maximum, _i, arg, t2, args = A.List_List$unmodifiable(new A.MappedListIterable($arguments, A.calculation_SassCalculation__simplify$closure(), A._arrayInstanceType($arguments)._eval$1("MappedListIterable<1,@>")), type$.Object), t1 = args.length;
                if (t1 === 0) throw A.wrapException(A.ArgumentError$("max() must have at least one argument.", null));
                for(maximum = null, _i = 0; _i < t1; ++_i){
                    arg = args[_i];
                    if (arg instanceof A.SassNumber) t2 = maximum != null && !maximum.isComparableTo$1(arg);
                    else t2 = true;
                    if (t2) {
                        maximum = null;
                        break;
                    } else if (maximum == null || maximum.lessThan$1(arg).value) maximum = arg;
                }
                if (maximum != null) return maximum;
                A.SassCalculation__verifyCompatibleNumbers(args);
                return new A.SassCalculation("max", args);
            },
            SassCalculation_hypot: function($arguments) {
                var first, subtotal, i, number, value, t2, args = A.List_List$unmodifiable(new A.MappedListIterable($arguments, A.calculation_SassCalculation__simplify$closure(), A._arrayInstanceType($arguments)._eval$1("MappedListIterable<1,@>")), type$.Object), t1 = args.length;
                if (t1 === 0) throw A.wrapException(A.ArgumentError$("hypot() must have at least one argument.", null));
                A.SassCalculation__verifyCompatibleNumbers(args);
                first = B.JSArray_methods.get$first(args);
                if (!(first instanceof A.SassNumber) || first.hasUnit$1("%")) return new A.SassCalculation("hypot", args);
                for(subtotal = 0, i = 0; i < t1;){
                    number = args[i];
                    if (!(number instanceof A.SassNumber) || !number.hasCompatibleUnits$1(first)) return new A.SassCalculation("hypot", args);
                    ++i;
                    value = number.convertValueToMatch$3(first, "numbers[" + i + "]", "numbers[1]");
                    subtotal += value * value;
                }
                t1 = Math.sqrt(subtotal);
                t2 = first.get$numeratorUnits(first);
                return A.SassNumber_SassNumber$withUnits(t1, first.get$denominatorUnits(first), t2);
            },
            SassCalculation_abs: function(argument) {
                argument = A.SassCalculation__simplify(argument);
                if (!(argument instanceof A.SassNumber)) return new A.SassCalculation("abs", A._setArrayType([
                    argument
                ], type$.JSArray_Object));
                if (argument.hasUnit$1("%")) A.warnForDeprecation(string$.Passinp + argument.toString$0(0) + ")\nTo emit a CSS abs() now: abs(#{" + argument.toString$0(0) + string$.x7dx29_Mor, B.Deprecation_Usi);
                return A.SassNumber_SassNumber(Math.abs(argument._number$_value), null).coerceToMatch$1(argument);
            },
            SassCalculation_exp: function(argument) {
                argument = A.SassCalculation__simplify(argument);
                if (!(argument instanceof A.SassNumber)) return new A.SassCalculation("exp", A._setArrayType([
                    argument
                ], type$.JSArray_Object));
                argument.assertNoUnits$0();
                return A.pow0(A.SassNumber_SassNumber(2.718281828459045, null), argument);
            },
            SassCalculation_sign: function(argument) {
                var t1, _0_2, t2, arg;
                argument = A.SassCalculation__simplify(argument);
                $label0$0: {
                    t1 = argument instanceof A.SassNumber;
                    if (t1) {
                        _0_2 = argument._number$_value;
                        if (!isNaN(_0_2)) t2 = 0 === _0_2;
                        else t2 = true;
                    } else t2 = false;
                    if (t2) {
                        t1 = argument;
                        break $label0$0;
                    }
                    if (t1) {
                        t1 = !argument.hasUnit$1("%");
                        arg = argument;
                    } else {
                        arg = null;
                        t1 = false;
                    }
                    if (t1) {
                        t1 = A.SassNumber_SassNumber(J.get$sign$in(arg._number$_value), null).coerceToMatch$1(argument);
                        break $label0$0;
                    }
                    t1 = new A.SassCalculation("sign", A._setArrayType([
                        argument
                    ], type$.JSArray_Object));
                    break $label0$0;
                }
                return t1;
            },
            SassCalculation_clamp: function(min, value, max) {
                var t1, args;
                if (value == null && max != null) throw A.wrapException(A.ArgumentError$("If value is null, max must also be null.", null));
                min = A.SassCalculation__simplify(min);
                value = A.NullableExtension_andThen(value, A.calculation_SassCalculation__simplify$closure());
                max = A.NullableExtension_andThen(max, A.calculation_SassCalculation__simplify$closure());
                if (min instanceof A.SassNumber && value instanceof A.SassNumber && max instanceof A.SassNumber && min.hasCompatibleUnits$1(value) && min.hasCompatibleUnits$1(max)) {
                    if (value.lessThanOrEquals$1(min).value) return min;
                    if (value.greaterThanOrEquals$1(max).value) return max;
                    return value;
                }
                t1 = [
                    min
                ];
                if (value != null) t1.push(value);
                if (max != null) t1.push(max);
                args = A.List_List$unmodifiable(t1, type$.Object);
                A.SassCalculation__verifyCompatibleNumbers(args);
                A.SassCalculation__verifyLength(args, 3);
                return new A.SassCalculation("clamp", args);
            },
            SassCalculation_pow: function(base, exponent) {
                var t1 = A._setArrayType([
                    base
                ], type$.JSArray_Object);
                if (exponent != null) t1.push(exponent);
                A.SassCalculation__verifyLength(t1, 2);
                base = A.SassCalculation__simplify(base);
                exponent = A.NullableExtension_andThen(exponent, A.calculation_SassCalculation__simplify$closure());
                if (!(base instanceof A.SassNumber) || !(exponent instanceof A.SassNumber)) return new A.SassCalculation("pow", t1);
                base.assertNoUnits$0();
                exponent.assertNoUnits$0();
                return A.pow0(base, exponent);
            },
            SassCalculation_log: function(number, base) {
                var t1, t2;
                number = A.SassCalculation__simplify(number);
                base = A.NullableExtension_andThen(base, A.calculation_SassCalculation__simplify$closure());
                t1 = A._setArrayType([
                    number
                ], type$.JSArray_Object);
                t2 = base != null;
                if (t2) t1.push(base);
                if (number instanceof A.SassNumber) t2 = t2 && !(base instanceof A.SassNumber);
                else t2 = true;
                if (t2) return new A.SassCalculation("log", t1);
                number.assertNoUnits$0();
                if (base instanceof A.SassNumber) {
                    base.assertNoUnits$0();
                    return A.log(number, base);
                }
                return A.log(number, null);
            },
            SassCalculation_atan2: function(y, x) {
                var t1;
                y = A.SassCalculation__simplify(y);
                x = A.NullableExtension_andThen(x, A.calculation_SassCalculation__simplify$closure());
                t1 = A._setArrayType([
                    y
                ], type$.JSArray_Object);
                if (x != null) t1.push(x);
                A.SassCalculation__verifyLength(t1, 2);
                A.SassCalculation__verifyCompatibleNumbers(t1);
                if (!(y instanceof A.SassNumber) || !(x instanceof A.SassNumber) || y.hasUnit$1("%") || x.hasUnit$1("%") || !y.hasCompatibleUnits$1(x)) return new A.SassCalculation("atan2", t1);
                return A.SassNumber_SassNumber$withUnits(Math.atan2(y._number$_value, x.convertValueToMatch$3(y, "x", "y")) * 57.29577951308232, null, A._setArrayType([
                    "deg"
                ], type$.JSArray_String));
            },
            SassCalculation_rem: function(dividend, modulus) {
                var t1, result;
                dividend = A.SassCalculation__simplify(dividend);
                modulus = A.NullableExtension_andThen(modulus, A.calculation_SassCalculation__simplify$closure());
                t1 = A._setArrayType([
                    dividend
                ], type$.JSArray_Object);
                if (modulus != null) t1.push(modulus);
                A.SassCalculation__verifyLength(t1, 2);
                A.SassCalculation__verifyCompatibleNumbers(t1);
                if (!(dividend instanceof A.SassNumber) || !(modulus instanceof A.SassNumber) || !dividend.hasCompatibleUnits$1(modulus)) return new A.SassCalculation("rem", t1);
                result = dividend.modulo$1(modulus);
                t1 = modulus._number$_value;
                if (A.DoubleWithSignedZero_get_signIncludingZero(t1) !== A.DoubleWithSignedZero_get_signIncludingZero(dividend._number$_value)) {
                    if (t1 == 1 / 0 || t1 == -1 / 0) return dividend;
                    if (result._number$_value === 0) return result.unaryMinus$0();
                    return result.minus$1(modulus);
                }
                return result;
            },
            SassCalculation_mod: function(dividend, modulus) {
                var t1;
                dividend = A.SassCalculation__simplify(dividend);
                modulus = A.NullableExtension_andThen(modulus, A.calculation_SassCalculation__simplify$closure());
                t1 = A._setArrayType([
                    dividend
                ], type$.JSArray_Object);
                if (modulus != null) t1.push(modulus);
                A.SassCalculation__verifyLength(t1, 2);
                A.SassCalculation__verifyCompatibleNumbers(t1);
                if (!(dividend instanceof A.SassNumber) || !(modulus instanceof A.SassNumber) || !dividend.hasCompatibleUnits$1(modulus)) return new A.SassCalculation("mod", t1);
                return dividend.modulo$1(modulus);
            },
            SassCalculation_roundInternal: function(strategyOrNumber, numberOrStep, step, inLegacySassFunction, span, warn) {
                var _0_8_isSet, t2, _0_6_isSet, _0_6_isSet0, _0_14_isSet, _0_14, _0_12, _0_16, _0_18, _0_18_isSet, _0_20, _0_20_isSet, strategy, _0_9_isSet0, _0_16_isSet, t3, t4, _0_12_isSet, _0_12_isSet0, rest, _null = null, _s5_ = "round", _0_1 = A.SassCalculation__simplify(strategyOrNumber), _0_6 = A.NullableExtension_andThen(numberOrStep, A.calculation_SassCalculation__simplify$closure()), _0_9 = A.NullableExtension_andThen(step, A.calculation_SassCalculation__simplify$closure()), _0_8 = _null, _0_60 = _null, _0_10 = _null, _0_10_isSet = false, _0_90 = _null, _0_9_isSet = false, number = _null, t1 = false;
                if (_0_1 instanceof A.SassNumber) {
                    _0_8_isSet = !_0_1.get$hasUnits();
                    if (_0_8_isSet) {
                        _0_8 = _0_6 == null;
                        t2 = _0_8;
                        if (t2) {
                            _0_10 = _0_9 == null;
                            t1 = _0_10;
                            _0_90 = _0_9;
                            _0_10_isSet = true;
                            _0_9_isSet = true;
                        }
                        _0_60 = _0_6;
                        number = _0_1;
                    }
                    _0_6_isSet = _0_8_isSet;
                } else {
                    _0_8_isSet = false;
                    _0_6_isSet = false;
                }
                if (t1) return A.SassNumber_SassNumber(B.JSNumber_methods.round$0(number._number$_value), _null);
                t1 = false;
                if (_0_1 instanceof A.SassNumber) {
                    if (_0_8_isSet) t2 = _0_8;
                    else {
                        if (_0_6_isSet) t2 = _0_60;
                        else {
                            t2 = _0_6;
                            _0_60 = t2;
                            _0_6_isSet = true;
                        }
                        _0_8 = t2 == null;
                        t2 = _0_8;
                        _0_8_isSet = true;
                    }
                    if (t2) {
                        if (_0_10_isSet) t1 = _0_10;
                        else {
                            if (_0_9_isSet) t1 = _0_90;
                            else {
                                t1 = _0_9;
                                _0_90 = t1;
                                _0_9_isSet = true;
                            }
                            _0_10 = t1 == null;
                            t1 = _0_10;
                            _0_10_isSet = true;
                        }
                        t1 = t1 && inLegacySassFunction != null;
                    }
                    number = _0_1;
                } else number = _null;
                if (t1) {
                    warn.call$2(string$.In_fut, B.Deprecation_WW3);
                    t1 = B.JSNumber_methods.round$0(number._number$_value);
                    t2 = number.get$numeratorUnits(number);
                    return A.SassNumber_SassNumber$withUnits(t1, number.get$denominatorUnits(number), t2);
                }
                step = _null;
                t1 = false;
                if (_0_1 instanceof A.SassNumber) {
                    _0_6_isSet0 = true;
                    if (_0_6_isSet) t2 = _0_60;
                    else {
                        t2 = _0_6;
                        _0_6_isSet = _0_6_isSet0;
                        _0_60 = t2;
                    }
                    if (t2 instanceof A.SassNumber) {
                        if (_0_6_isSet) t2 = _0_60;
                        else {
                            t2 = _0_6;
                            _0_6_isSet = _0_6_isSet0;
                            _0_60 = t2;
                        }
                        type$.SassNumber._as(t2);
                        if (_0_10_isSet) t1 = _0_10;
                        else {
                            if (_0_9_isSet) t1 = _0_90;
                            else {
                                t1 = _0_9;
                                _0_90 = t1;
                                _0_9_isSet = true;
                            }
                            _0_10 = t1 == null;
                            t1 = _0_10;
                            _0_10_isSet = true;
                        }
                        t1 = t1 && !_0_1.hasCompatibleUnits$1(t2);
                        step = t2;
                    }
                    number = _0_1;
                } else number = _null;
                if (t1) {
                    t1 = type$.JSArray_Object;
                    A.SassCalculation__verifyCompatibleNumbers(A._setArrayType([
                        number,
                        step
                    ], t1));
                    return new A.SassCalculation(_s5_, A._setArrayType([
                        number,
                        step
                    ], t1));
                }
                step = _null;
                t1 = false;
                if (_0_1 instanceof A.SassNumber) {
                    _0_6_isSet0 = true;
                    if (_0_6_isSet) t2 = _0_60;
                    else {
                        t2 = _0_6;
                        _0_6_isSet = _0_6_isSet0;
                        _0_60 = t2;
                    }
                    if (t2 instanceof A.SassNumber) {
                        if (_0_6_isSet) t2 = _0_60;
                        else {
                            t2 = _0_6;
                            _0_6_isSet = _0_6_isSet0;
                            _0_60 = t2;
                        }
                        type$.SassNumber._as(t2);
                        if (_0_10_isSet) t1 = _0_10;
                        else {
                            if (_0_9_isSet) t1 = _0_90;
                            else {
                                t1 = _0_9;
                                _0_90 = t1;
                                _0_9_isSet = true;
                            }
                            _0_10 = t1 == null;
                            t1 = _0_10;
                            _0_10_isSet = true;
                        }
                        step = t2;
                    }
                    number = _0_1;
                } else number = _null;
                if (t1) {
                    A.SassCalculation__verifyCompatibleNumbers(A._setArrayType([
                        number,
                        step
                    ], type$.JSArray_Object));
                    return A.SassCalculation__roundWithStep("nearest", number, step);
                }
                _0_14_isSet = _0_1 instanceof A.SassString;
                _0_14 = _null;
                _0_12 = _null;
                _0_16 = _null;
                _0_18 = _null;
                _0_18_isSet = false;
                _0_20 = _null;
                _0_20_isSet = false;
                strategy = _null;
                number = _null;
                step = _null;
                t1 = false;
                if (_0_14_isSet) {
                    _0_6_isSet0 = true;
                    _0_9_isSet0 = true;
                    _0_12 = _0_1._string$_text;
                    t2 = _0_12;
                    _0_14 = "nearest" === t2;
                    t2 = _0_14;
                    _0_16_isSet = !t2;
                    t2 = true;
                    if (_0_16_isSet) {
                        _0_16 = "up" === _0_12;
                        t3 = _0_16;
                        _0_18_isSet = !t3;
                        if (_0_18_isSet) {
                            _0_18 = "down" === _0_12;
                            t3 = _0_18;
                            _0_20_isSet = !t3;
                            if (_0_20_isSet) {
                                _0_20 = "to-zero" === _0_12;
                                t2 = _0_20;
                            }
                        }
                    }
                    if (t2) {
                        if (_0_6_isSet) t2 = _0_60;
                        else {
                            t2 = _0_6;
                            _0_6_isSet = _0_6_isSet0;
                            _0_60 = t2;
                        }
                        if (t2 instanceof A.SassNumber) {
                            if (_0_6_isSet) t2 = _0_60;
                            else {
                                t2 = _0_6;
                                _0_6_isSet = _0_6_isSet0;
                                _0_60 = t2;
                            }
                            t3 = type$.SassNumber;
                            t3._as(t2);
                            if (_0_9_isSet) t4 = _0_90;
                            else {
                                t4 = _0_9;
                                _0_9_isSet = _0_9_isSet0;
                                _0_90 = t4;
                            }
                            if (t4 instanceof A.SassNumber) {
                                if (_0_9_isSet) t1 = _0_90;
                                else {
                                    t1 = _0_9;
                                    _0_9_isSet = _0_9_isSet0;
                                    _0_90 = t1;
                                }
                                t3._as(t1);
                                t3 = !t2.hasCompatibleUnits$1(t1);
                                step = t1;
                                t1 = t3;
                            }
                            number = t2;
                        }
                        strategy = _0_1;
                    }
                } else _0_16_isSet = false;
                if (t1) {
                    t1 = type$.JSArray_Object;
                    A.SassCalculation__verifyCompatibleNumbers(A._setArrayType([
                        number,
                        step
                    ], t1));
                    return new A.SassCalculation(_s5_, A._setArrayType([
                        strategy,
                        number,
                        step
                    ], t1));
                }
                strategy = _null;
                number = _null;
                step = _null;
                t1 = false;
                if (_0_1 instanceof A.SassString) {
                    _0_6_isSet0 = true;
                    _0_9_isSet0 = true;
                    _0_12_isSet = true;
                    if (_0_14_isSet) {
                        t2 = _0_14;
                        _0_12_isSet0 = _0_14_isSet;
                    } else {
                        _0_12 = _0_1._string$_text;
                        t2 = _0_12;
                        _0_14 = "nearest" === t2;
                        t2 = _0_14;
                        _0_12_isSet0 = _0_12_isSet;
                        _0_14_isSet = true;
                    }
                    t3 = true;
                    if (!t2) {
                        if (_0_16_isSet) t2 = _0_16;
                        else {
                            if (_0_12_isSet0) t2 = _0_12;
                            else {
                                _0_12 = _0_1._string$_text;
                                t2 = _0_12;
                                _0_12_isSet0 = _0_12_isSet;
                            }
                            _0_16 = "up" === t2;
                            t2 = _0_16;
                            _0_16_isSet = true;
                        }
                        if (!t2) {
                            if (_0_18_isSet) t2 = _0_18;
                            else {
                                if (_0_12_isSet0) t2 = _0_12;
                                else {
                                    _0_12 = _0_1._string$_text;
                                    t2 = _0_12;
                                    _0_12_isSet0 = _0_12_isSet;
                                }
                                _0_18 = "down" === t2;
                                t2 = _0_18;
                                _0_18_isSet = true;
                            }
                            if (!t2) {
                                if (_0_20_isSet) {
                                    t2 = _0_20;
                                    _0_12_isSet = _0_12_isSet0;
                                } else {
                                    if (_0_12_isSet0) {
                                        t2 = _0_12;
                                        _0_12_isSet = _0_12_isSet0;
                                    } else {
                                        _0_12 = _0_1._string$_text;
                                        t2 = _0_12;
                                    }
                                    _0_20 = "to-zero" === t2;
                                    t2 = _0_20;
                                    _0_20_isSet = true;
                                }
                            } else {
                                t2 = t3;
                                _0_12_isSet = _0_12_isSet0;
                            }
                        } else {
                            t2 = t3;
                            _0_12_isSet = _0_12_isSet0;
                        }
                    } else {
                        t2 = t3;
                        _0_12_isSet = _0_12_isSet0;
                    }
                    if (t2) {
                        if (_0_6_isSet) t2 = _0_60;
                        else {
                            t2 = _0_6;
                            _0_6_isSet = _0_6_isSet0;
                            _0_60 = t2;
                        }
                        if (t2 instanceof A.SassNumber) {
                            if (_0_6_isSet) t2 = _0_60;
                            else {
                                t2 = _0_6;
                                _0_6_isSet = _0_6_isSet0;
                                _0_60 = t2;
                            }
                            t3 = type$.SassNumber;
                            t3._as(t2);
                            if (_0_9_isSet) t1 = _0_90;
                            else {
                                t1 = _0_9;
                                _0_9_isSet = _0_9_isSet0;
                                _0_90 = t1;
                            }
                            t1 = t1 instanceof A.SassNumber;
                            if (t1) {
                                if (_0_9_isSet) t4 = _0_90;
                                else {
                                    t4 = _0_9;
                                    _0_9_isSet = _0_9_isSet0;
                                    _0_90 = t4;
                                }
                                t3._as(t4);
                                step = t4;
                            }
                            number = t2;
                        }
                        strategy = _0_1;
                    }
                } else _0_12_isSet = _0_14_isSet;
                if (t1) {
                    A.SassCalculation__verifyCompatibleNumbers(A._setArrayType([
                        number,
                        step
                    ], type$.JSArray_Object));
                    return A.SassCalculation__roundWithStep(strategy._string$_text, number, step);
                }
                strategy = _null;
                rest = _null;
                t1 = false;
                if (_0_1 instanceof A.SassString) {
                    _0_6_isSet0 = true;
                    _0_12_isSet0 = true;
                    if (_0_14_isSet) t2 = _0_14;
                    else {
                        if (_0_12_isSet) t2 = _0_12;
                        else {
                            _0_12 = _0_1._string$_text;
                            t2 = _0_12;
                            _0_12_isSet = _0_12_isSet0;
                        }
                        _0_14 = "nearest" === t2;
                        t2 = _0_14;
                        _0_14_isSet = true;
                    }
                    t3 = true;
                    if (!t2) {
                        if (_0_16_isSet) t2 = _0_16;
                        else {
                            if (_0_12_isSet) t2 = _0_12;
                            else {
                                _0_12 = _0_1._string$_text;
                                t2 = _0_12;
                                _0_12_isSet = _0_12_isSet0;
                            }
                            _0_16 = "up" === t2;
                            t2 = _0_16;
                            _0_16_isSet = true;
                        }
                        if (!t2) {
                            if (_0_18_isSet) t2 = _0_18;
                            else {
                                if (_0_12_isSet) t2 = _0_12;
                                else {
                                    _0_12 = _0_1._string$_text;
                                    t2 = _0_12;
                                    _0_12_isSet = _0_12_isSet0;
                                }
                                _0_18 = "down" === t2;
                                t2 = _0_18;
                                _0_18_isSet = true;
                            }
                            if (!t2) {
                                if (_0_20_isSet) t2 = _0_20;
                                else {
                                    if (_0_12_isSet) t2 = _0_12;
                                    else {
                                        _0_12 = _0_1._string$_text;
                                        t2 = _0_12;
                                        _0_12_isSet = _0_12_isSet0;
                                    }
                                    _0_20 = "to-zero" === t2;
                                    t2 = _0_20;
                                    _0_20_isSet = true;
                                }
                            } else t2 = t3;
                        } else t2 = t3;
                    } else t2 = t3;
                    if (t2) {
                        if (_0_6_isSet) t2 = _0_60;
                        else {
                            t2 = _0_6;
                            _0_6_isSet = _0_6_isSet0;
                            _0_60 = t2;
                        }
                        if (t2 instanceof A.SassString) {
                            if (_0_6_isSet) t2 = _0_60;
                            else {
                                t2 = _0_6;
                                _0_6_isSet = _0_6_isSet0;
                                _0_60 = t2;
                            }
                            type$.SassString._as(t2);
                            if (_0_10_isSet) t1 = _0_10;
                            else {
                                if (_0_9_isSet) t1 = _0_90;
                                else {
                                    t1 = _0_9;
                                    _0_90 = t1;
                                    _0_9_isSet = true;
                                }
                                _0_10 = t1 == null;
                                t1 = _0_10;
                                _0_10_isSet = true;
                            }
                            rest = t2;
                        }
                        strategy = _0_1;
                    }
                }
                if (t1) return new A.SassCalculation(_s5_, A._setArrayType([
                    strategy,
                    rest
                ], type$.JSArray_Object));
                t1 = false;
                if (_0_1 instanceof A.SassString) {
                    _0_12_isSet0 = true;
                    if (_0_14_isSet) t2 = _0_14;
                    else {
                        if (_0_12_isSet) t2 = _0_12;
                        else {
                            _0_12 = _0_1._string$_text;
                            t2 = _0_12;
                            _0_12_isSet = _0_12_isSet0;
                        }
                        _0_14 = "nearest" === t2;
                        t2 = _0_14;
                        _0_14_isSet = true;
                    }
                    t3 = true;
                    if (!t2) {
                        if (_0_16_isSet) t2 = _0_16;
                        else {
                            if (_0_12_isSet) t2 = _0_12;
                            else {
                                _0_12 = _0_1._string$_text;
                                t2 = _0_12;
                                _0_12_isSet = _0_12_isSet0;
                            }
                            _0_16 = "up" === t2;
                            t2 = _0_16;
                            _0_16_isSet = true;
                        }
                        if (!t2) {
                            if (_0_18_isSet) t2 = _0_18;
                            else {
                                if (_0_12_isSet) t2 = _0_12;
                                else {
                                    _0_12 = _0_1._string$_text;
                                    t2 = _0_12;
                                    _0_12_isSet = _0_12_isSet0;
                                }
                                _0_18 = "down" === t2;
                                t2 = _0_18;
                                _0_18_isSet = true;
                            }
                            if (!t2) {
                                if (_0_20_isSet) t2 = _0_20;
                                else {
                                    if (_0_12_isSet) t2 = _0_12;
                                    else {
                                        _0_12 = _0_1._string$_text;
                                        t2 = _0_12;
                                        _0_12_isSet = _0_12_isSet0;
                                    }
                                    _0_20 = "to-zero" === t2;
                                    t2 = _0_20;
                                    _0_20_isSet = true;
                                }
                            } else t2 = t3;
                        } else t2 = t3;
                    } else t2 = t3;
                    if (t2) {
                        if (_0_6_isSet) t2 = _0_60;
                        else {
                            t2 = _0_6;
                            _0_60 = t2;
                            _0_6_isSet = true;
                        }
                        if (t2 != null) {
                            if (_0_10_isSet) t1 = _0_10;
                            else {
                                if (_0_9_isSet) t1 = _0_90;
                                else {
                                    t1 = _0_9;
                                    _0_90 = t1;
                                    _0_9_isSet = true;
                                }
                                _0_10 = t1 == null;
                                t1 = _0_10;
                                _0_10_isSet = true;
                            }
                        }
                    }
                }
                if (t1) throw A.wrapException(A.SassScriptException$(string$.If_str, _null));
                t1 = false;
                if (_0_1 instanceof A.SassString) {
                    _0_12_isSet0 = true;
                    if (_0_14_isSet) t2 = _0_14;
                    else {
                        if (_0_12_isSet) t2 = _0_12;
                        else {
                            _0_12 = _0_1._string$_text;
                            t2 = _0_12;
                            _0_12_isSet = _0_12_isSet0;
                        }
                        _0_14 = "nearest" === t2;
                        t2 = _0_14;
                        _0_14_isSet = true;
                    }
                    t3 = true;
                    if (!t2) {
                        if (_0_16_isSet) t2 = _0_16;
                        else {
                            if (_0_12_isSet) t2 = _0_12;
                            else {
                                _0_12 = _0_1._string$_text;
                                t2 = _0_12;
                                _0_12_isSet = _0_12_isSet0;
                            }
                            _0_16 = "up" === t2;
                            t2 = _0_16;
                            _0_16_isSet = true;
                        }
                        if (!t2) {
                            if (_0_18_isSet) t2 = _0_18;
                            else {
                                if (_0_12_isSet) t2 = _0_12;
                                else {
                                    _0_12 = _0_1._string$_text;
                                    t2 = _0_12;
                                    _0_12_isSet = _0_12_isSet0;
                                }
                                _0_18 = "down" === t2;
                                t2 = _0_18;
                                _0_18_isSet = true;
                            }
                            if (!t2) {
                                if (_0_20_isSet) t2 = _0_20;
                                else {
                                    if (_0_12_isSet) t2 = _0_12;
                                    else {
                                        _0_12 = _0_1._string$_text;
                                        t2 = _0_12;
                                        _0_12_isSet = _0_12_isSet0;
                                    }
                                    _0_20 = "to-zero" === t2;
                                    t2 = _0_20;
                                    _0_20_isSet = true;
                                }
                            } else t2 = t3;
                        } else t2 = t3;
                    } else t2 = t3;
                    if (t2) {
                        if (_0_8_isSet) t2 = _0_8;
                        else {
                            if (_0_6_isSet) t2 = _0_60;
                            else {
                                t2 = _0_6;
                                _0_60 = t2;
                                _0_6_isSet = true;
                            }
                            _0_8 = t2 == null;
                            t2 = _0_8;
                            _0_8_isSet = true;
                        }
                        if (t2) {
                            if (_0_10_isSet) t1 = _0_10;
                            else {
                                if (_0_9_isSet) t1 = _0_90;
                                else {
                                    t1 = _0_9;
                                    _0_90 = t1;
                                    _0_9_isSet = true;
                                }
                                _0_10 = t1 == null;
                                t1 = _0_10;
                                _0_10_isSet = true;
                            }
                        }
                    }
                }
                if (t1) throw A.wrapException(A.SassScriptException$(string$.Number, _null));
                t1 = false;
                if (_0_8_isSet) t2 = _0_8;
                else {
                    if (_0_6_isSet) t2 = _0_60;
                    else {
                        t2 = _0_6;
                        _0_60 = t2;
                        _0_6_isSet = true;
                    }
                    _0_8 = t2 == null;
                    t2 = _0_8;
                }
                if (t2) {
                    if (_0_10_isSet) t1 = _0_10;
                    else {
                        if (_0_9_isSet) t1 = _0_90;
                        else {
                            t1 = _0_9;
                            _0_90 = t1;
                            _0_9_isSet = true;
                        }
                        _0_10 = t1 == null;
                        t1 = _0_10;
                        _0_10_isSet = true;
                    }
                }
                if (t1) return new A.SassCalculation(_s5_, A._setArrayType([
                    _0_1
                ], type$.JSArray_Object));
                step = _null;
                t1 = false;
                _0_6_isSet0 = true;
                if (_0_6_isSet) t2 = _0_60;
                else {
                    t2 = _0_6;
                    _0_6_isSet = _0_6_isSet0;
                    _0_60 = t2;
                }
                if (t2 != null) {
                    if (_0_6_isSet) step = _0_60;
                    else {
                        step = _0_6;
                        _0_6_isSet = _0_6_isSet0;
                        _0_60 = step;
                    }
                    if (step == null) step = A._asObject(step);
                    if (_0_10_isSet) t1 = _0_10;
                    else {
                        if (_0_9_isSet) t1 = _0_90;
                        else {
                            t1 = _0_9;
                            _0_90 = t1;
                            _0_9_isSet = true;
                        }
                        _0_10 = t1 == null;
                        t1 = _0_10;
                    }
                }
                if (t1) return new A.SassCalculation(_s5_, A._setArrayType([
                    _0_1,
                    step
                ], type$.JSArray_Object));
                if (_0_1 instanceof A.SassString) {
                    t1 = true;
                    if (_0_14_isSet) t2 = _0_14;
                    else {
                        if (_0_12_isSet) t2 = _0_12;
                        else {
                            _0_12 = _0_1._string$_text;
                            t2 = _0_12;
                            _0_12_isSet = true;
                        }
                        _0_14 = "nearest" === t2;
                        t2 = _0_14;
                    }
                    if (!t2) {
                        if (_0_16_isSet) t2 = _0_16;
                        else {
                            if (_0_12_isSet) t2 = _0_12;
                            else {
                                _0_12 = _0_1._string$_text;
                                t2 = _0_12;
                                _0_12_isSet = true;
                            }
                            _0_16 = "up" === t2;
                            t2 = _0_16;
                        }
                        if (!t2) {
                            if (_0_18_isSet) t2 = _0_18;
                            else {
                                if (_0_12_isSet) t2 = _0_12;
                                else {
                                    _0_12 = _0_1._string$_text;
                                    t2 = _0_12;
                                    _0_12_isSet = true;
                                }
                                _0_18 = "down" === t2;
                                t2 = _0_18;
                            }
                            if (!t2) {
                                if (_0_20_isSet) t1 = _0_20;
                                else {
                                    if (_0_12_isSet) t1 = _0_12;
                                    else {
                                        _0_12 = _0_1._string$_text;
                                        t1 = _0_12;
                                    }
                                    _0_20 = "to-zero" === t1;
                                    t1 = _0_20;
                                }
                            }
                        }
                    }
                } else t1 = false;
                if (!t1) {
                    if (_0_1 instanceof A.SassString) t1 = _0_1.get$isSpecialVariable();
                    else t1 = false;
                } else t1 = true;
                number = _null;
                step = _null;
                t2 = false;
                if (t1) {
                    _0_6_isSet0 = true;
                    _0_9_isSet0 = true;
                    type$.SassString._as(_0_1);
                    if (_0_6_isSet) t1 = _0_60;
                    else {
                        t1 = _0_6;
                        _0_6_isSet = _0_6_isSet0;
                        _0_60 = t1;
                    }
                    if (t1 != null) {
                        if (_0_6_isSet) number = _0_60;
                        else {
                            number = _0_6;
                            _0_6_isSet = _0_6_isSet0;
                            _0_60 = number;
                        }
                        if (number == null) number = A._asObject(number);
                        if (_0_9_isSet) t1 = _0_90;
                        else {
                            t1 = _0_9;
                            _0_9_isSet = _0_9_isSet0;
                            _0_90 = t1;
                        }
                        t1 = t1 != null;
                        if (t1) {
                            if (_0_9_isSet) step = _0_90;
                            else {
                                step = _0_9;
                                _0_9_isSet = _0_9_isSet0;
                                _0_90 = step;
                            }
                            if (step == null) step = A._asObject(step);
                        }
                    } else t1 = t2;
                    strategy = _0_1;
                } else {
                    t1 = t2;
                    strategy = _null;
                }
                if (t1) return new A.SassCalculation(_s5_, A._setArrayType([
                    strategy,
                    number,
                    step
                ], type$.JSArray_Object));
                t1 = false;
                if ((_0_6_isSet ? _0_60 : _0_6) != null) t1 = (_0_9_isSet ? _0_90 : _0_9) != null;
                if (t1) throw A.wrapException(A.SassScriptException$(A.S(strategyOrNumber) + string$.x20must_b, _null));
                t1 = A.SassScriptException$("Invalid parameters.", _null);
                throw A.wrapException(t1);
            },
            SassCalculation_calcSize: function(basis, value) {
                var t1 = type$.JSArray_Object, t2 = A._setArrayType([
                    basis
                ], t1);
                if (value != null) t2.push(value);
                A.SassCalculation__verifyLength(t2, 2);
                basis = A.SassCalculation__simplify(basis);
                value = A.NullableExtension_andThen(value, A.calculation_SassCalculation__simplify$closure());
                t1 = A._setArrayType([
                    basis
                ], t1);
                if (value != null) t1.push(value);
                return new A.SassCalculation("calc-size", t1);
            },
            SassCalculation_operateInternal: function(operator, left, right, inLegacySassFunction, simplify, warn) {
                var compatible, t1;
                if (!simplify) return new A.CalculationOperation(operator, left, right);
                left = A.SassCalculation__simplify(left);
                right = A.SassCalculation__simplify(right);
                if (B.CalculationOperator_dpX === operator || B.CalculationOperator_KrC === operator) {
                    if (left instanceof A.SassNumber && right instanceof A.SassNumber) {
                        compatible = left.hasCompatibleUnits$1(right);
                        if (!compatible && inLegacySassFunction != null && left.isComparableTo$1(right)) {
                            warn.call$2("In future versions of Sass, " + inLegacySassFunction + "() will be interpreted as the CSS " + inLegacySassFunction + string$.x28__cal + inLegacySassFunction + string$.x28__ins, B.Deprecation_WW3);
                            compatible = true;
                        }
                        if (compatible) return operator === B.CalculationOperator_dpX ? left.plus$1(right) : left.minus$1(right);
                    }
                    A.SassCalculation__verifyCompatibleNumbers(A._setArrayType([
                        left,
                        right
                    ], type$.JSArray_Object));
                    if (right instanceof A.SassNumber) {
                        t1 = right._number$_value;
                        t1 = t1 < 0 && !A.fuzzyEquals(t1, 0);
                    } else t1 = false;
                    if (t1) {
                        right = right.times$1(A.SassNumber_SassNumber(-1, null));
                        operator = operator === B.CalculationOperator_dpX ? B.CalculationOperator_KrC : B.CalculationOperator_dpX;
                    }
                    return new A.CalculationOperation(operator, left, right);
                } else if (left instanceof A.SassNumber && right instanceof A.SassNumber) return operator === B.CalculationOperator_LPB ? left.times$1(right) : left.dividedBy$1(right);
                else return new A.CalculationOperation(operator, left, right);
            },
            SassCalculation__roundWithStep: function(strategy, number, step) {
                var _0_2, t1, _0_6, _0_8_isSet, _0_8, _0_9, _0_9_isSet, _0_11, _0_13, stepWithNumberUnit, t2, _null = null;
                if (!A.LinkedHashSet_LinkedHashSet$_literal([
                    "nearest",
                    "up",
                    "down",
                    "to-zero"
                ], type$.String).contains$1(0, strategy)) throw A.wrapException(A.ArgumentError$(strategy + string$.x20must_b, _null));
                _0_2 = number._number$_value;
                if (_0_2 == 1 / 0 || _0_2 == -1 / 0) {
                    t1 = step._number$_value;
                    t1 = t1 == 1 / 0 || t1 == -1 / 0;
                } else t1 = false;
                if (!t1) {
                    t1 = step._number$_value;
                    t1 = t1 === 0 || isNaN(_0_2) || isNaN(t1);
                } else t1 = true;
                if (t1) {
                    t1 = number.get$numeratorUnits(number);
                    return A.SassNumber_SassNumber$withUnits(0 / 0, number.get$denominatorUnits(number), t1);
                }
                if (_0_2 == 1 / 0 || _0_2 == -1 / 0) return number;
                t1 = step._number$_value;
                if (t1 == 1 / 0 || t1 == -1 / 0) {
                    $label0$0: {
                        if (0 === _0_2) {
                            t1 = number;
                            break $label0$0;
                        }
                        _0_6 = "nearest" === strategy;
                        t1 = _0_6;
                        _0_8_isSet = !t1;
                        _0_8 = _null;
                        if (_0_8_isSet) {
                            _0_8 = "to-zero" === strategy;
                            t1 = _0_8;
                        } else t1 = true;
                        _0_9 = _null;
                        if (t1) {
                            _0_9 = _0_2 > 0;
                            t1 = _0_9;
                            _0_9_isSet = true;
                        } else {
                            _0_9_isSet = false;
                            t1 = false;
                        }
                        if (t1) {
                            t1 = number.get$numeratorUnits(number);
                            t1 = A.SassNumber_SassNumber$withUnits(0, number.get$denominatorUnits(number), t1);
                            break $label0$0;
                        }
                        if (!_0_6) {
                            if (_0_8_isSet) t1 = _0_8;
                            else {
                                _0_8 = "to-zero" === strategy;
                                t1 = _0_8;
                            }
                        } else t1 = true;
                        if (t1) {
                            t1 = number.get$numeratorUnits(number);
                            t1 = A.SassNumber_SassNumber$withUnits(-0, number.get$denominatorUnits(number), t1);
                            break $label0$0;
                        }
                        _0_11 = "up" === strategy;
                        t1 = _0_11;
                        if (t1) {
                            if (_0_9_isSet) t1 = _0_9;
                            else {
                                _0_9 = _0_2 > 0;
                                t1 = _0_9;
                            }
                        } else t1 = false;
                        if (t1) {
                            t1 = number.get$numeratorUnits(number);
                            t1 = A.SassNumber_SassNumber$withUnits(1 / 0, number.get$denominatorUnits(number), t1);
                            break $label0$0;
                        }
                        if (_0_11) {
                            t1 = number.get$numeratorUnits(number);
                            t1 = A.SassNumber_SassNumber$withUnits(-0, number.get$denominatorUnits(number), t1);
                            break $label0$0;
                        }
                        _0_13 = "down" === strategy;
                        t1 = _0_13;
                        if (t1) t1 = _0_2 < 0;
                        else t1 = false;
                        if (t1) {
                            t1 = number.get$numeratorUnits(number);
                            t1 = A.SassNumber_SassNumber$withUnits(-1 / 0, number.get$denominatorUnits(number), t1);
                            break $label0$0;
                        }
                        if (_0_13) {
                            t1 = number.get$numeratorUnits(number);
                            t1 = A.SassNumber_SassNumber$withUnits(0, number.get$denominatorUnits(number), t1);
                            break $label0$0;
                        }
                        t1 = A.throwExpression(A.UnsupportedError$("Invalid argument: " + strategy + "."));
                    }
                    return t1;
                }
                stepWithNumberUnit = step.convertValueToMatch$1(number);
                $label1$1: {
                    if ("nearest" === strategy) {
                        t1 = B.JSNumber_methods.round$0(_0_2 / stepWithNumberUnit);
                        t2 = number.get$numeratorUnits(number);
                        t2 = A.SassNumber_SassNumber$withUnits(t1 * stepWithNumberUnit, number.get$denominatorUnits(number), t2);
                        t1 = t2;
                        break $label1$1;
                    }
                    if ("up" === strategy) {
                        t2 = _0_2 / stepWithNumberUnit;
                        t1 = t1 < 0 ? B.JSNumber_methods.floor$0(t2) : B.JSNumber_methods.ceil$0(t2);
                        t2 = number.get$numeratorUnits(number);
                        t2 = A.SassNumber_SassNumber$withUnits(t1 * stepWithNumberUnit, number.get$denominatorUnits(number), t2);
                        t1 = t2;
                        break $label1$1;
                    }
                    if ("down" === strategy) {
                        t2 = _0_2 / stepWithNumberUnit;
                        t1 = t1 < 0 ? B.JSNumber_methods.ceil$0(t2) : B.JSNumber_methods.floor$0(t2);
                        t2 = number.get$numeratorUnits(number);
                        t2 = A.SassNumber_SassNumber$withUnits(t1 * stepWithNumberUnit, number.get$denominatorUnits(number), t2);
                        t1 = t2;
                        break $label1$1;
                    }
                    if ("to-zero" === strategy) {
                        t1 = _0_2 / stepWithNumberUnit;
                        if (_0_2 < 0) {
                            t1 = B.JSNumber_methods.ceil$0(t1);
                            t2 = number.get$numeratorUnits(number);
                            t2 = A.SassNumber_SassNumber$withUnits(t1 * stepWithNumberUnit, number.get$denominatorUnits(number), t2);
                            t1 = t2;
                        } else {
                            t1 = B.JSNumber_methods.floor$0(t1);
                            t2 = number.get$numeratorUnits(number);
                            t2 = A.SassNumber_SassNumber$withUnits(t1 * stepWithNumberUnit, number.get$denominatorUnits(number), t2);
                            t1 = t2;
                        }
                        break $label1$1;
                    }
                    t1 = number.get$numeratorUnits(number);
                    t1 = A.SassNumber_SassNumber$withUnits(0 / 0, number.get$denominatorUnits(number), t1);
                    break $label1$1;
                }
                return t1;
            },
            SassCalculation__simplify: function(arg) {
                var t1, t2, _0_11_isSet, _0_15, _0_12, _0_16_isSet, text, _0_11, t3, _0_16, _0_12_isSet, _0_15_isSet, value, _null = null, _s32_ = " can't be used in a calculation.";
                $label0$0: {
                    if (arg instanceof A.SassNumber || arg instanceof A.CalculationOperation) {
                        t1 = arg;
                        break $label0$0;
                    }
                    t1 = arg instanceof A.SassString;
                    t2 = _null;
                    if (t1 && !arg._hasQuotes) {
                        t1 = arg;
                        break $label0$0;
                    }
                    if (t1) A.throwExpression(A.SassScriptException$("Quoted string " + arg.toString$0(0) + _s32_, _null));
                    _0_11_isSet = arg instanceof A.SassCalculation;
                    _0_15 = _null;
                    _0_12 = _null;
                    _0_16_isSet = false;
                    text = _null;
                    t1 = false;
                    if (_0_11_isSet) {
                        _0_11 = "calc" === arg.name;
                        if (_0_11) {
                            _0_12 = arg.$arguments;
                            _0_15 = _0_12.length === 1;
                            t3 = _0_15;
                            if (t3) {
                                _0_16 = _0_12[0];
                                t2 = _0_16;
                                if (t2 instanceof A.SassString) {
                                    type$.SassString._as(_0_16);
                                    if (!_0_16._hasQuotes) {
                                        text = _0_16._string$_text;
                                        t1 = A.SassCalculation__needsParentheses(text);
                                    }
                                }
                                _0_16_isSet = true;
                            } else _0_16 = t2;
                        } else _0_16 = t2;
                        _0_12_isSet = _0_11;
                        _0_15_isSet = _0_12_isSet;
                    } else {
                        _0_16 = t2;
                        _0_11 = _null;
                        _0_15_isSet = false;
                        _0_12_isSet = false;
                    }
                    if (t1) {
                        t1 = new A.SassString("(" + A.S(text) + ")", false);
                        break $label0$0;
                    }
                    t1 = false;
                    if (_0_11_isSet) {
                        if (_0_11) {
                            if (_0_15_isSet) t1 = _0_15;
                            else {
                                if (_0_12_isSet) t1 = _0_12;
                                else {
                                    _0_12 = arg.$arguments;
                                    t1 = _0_12;
                                    _0_12_isSet = true;
                                }
                                _0_15 = t1.length === 1;
                                t1 = _0_15;
                            }
                        }
                    }
                    if (t1) {
                        if (_0_16_isSet) value = _0_16;
                        else {
                            _0_16 = (_0_12_isSet ? _0_12 : arg.$arguments)[0];
                            value = _0_16;
                        }
                        t1 = value;
                        break $label0$0;
                    }
                    if (_0_11_isSet) {
                        t1 = arg;
                        break $label0$0;
                    }
                    if (arg instanceof A.Value) A.throwExpression(A.SassScriptException$("Value " + arg.toString$0(0) + _s32_, _null));
                    t1 = A.throwExpression(A.ArgumentError$("Unexpected calculation argument " + A.S(arg) + ".", _null));
                }
                return t1;
            },
            SassCalculation__needsParentheses: function(text) {
                var t1, couldBeVar, second, third, fourth, i, t2, first = text.charCodeAt(0);
                if (first === 32 || first === 9 || first === 10 || first === 13 || first === 12 || first === 47 || first === 42) return true;
                t1 = text.length;
                couldBeVar = t1 >= 4 && A.characterEqualsIgnoreCase(first, 118);
                if (t1 < 2) return false;
                second = text.charCodeAt(1);
                if (second === 32 || second === 9 || second === 10 || second === 13 || second === 12 || second === 47 || second === 42) return true;
                couldBeVar = couldBeVar && A.characterEqualsIgnoreCase(second, 97);
                if (t1 < 3) return false;
                third = text.charCodeAt(2);
                if (third === 32 || third === 9 || third === 10 || third === 13 || third === 12 || third === 47 || third === 42) return true;
                couldBeVar = couldBeVar && A.characterEqualsIgnoreCase(third, 114);
                if (t1 < 4) return false;
                fourth = text.charCodeAt(3);
                if (couldBeVar && fourth === 40) return true;
                if (fourth === 32 || fourth === 9 || fourth === 10 || fourth === 13 || fourth === 12 || fourth === 47 || fourth === 42) return true;
                for(i = 4; i < t1; ++i){
                    t2 = text.charCodeAt(i);
                    if (t2 === 32 || t2 === 9 || t2 === 10 || t2 === 13 || t2 === 12 || t2 === 47 || t2 === 42) return true;
                }
                return false;
            },
            SassCalculation__verifyCompatibleNumbers: function(args) {
                var t1, _i, t2, arg, i, number1, j, number2;
                for(t1 = args.length, _i = 0; t2 = args.length, _i < t2; args.length === t1 || (0, A.throwConcurrentModificationError)(args), ++_i){
                    arg = args[_i];
                    if (arg instanceof A.SassNumber && arg.get$hasComplexUnits()) throw A.wrapException(A.SassScriptException$("Number " + arg.toString$0(0) + " isn't compatible with CSS calculations.", null));
                }
                for(t1 = t2, i = 0; i < t1 - 1; ++i){
                    number1 = args[i];
                    if (!(number1 instanceof A.SassNumber)) continue;
                    for(j = i + 1; t1 = args.length, j < t1; ++j){
                        number2 = args[j];
                        if (!(number2 instanceof A.SassNumber)) continue;
                        if (number1.hasPossiblyCompatibleUnits$1(number2)) continue;
                        throw A.wrapException(A.SassScriptException$(number1.toString$0(0) + " and " + number2.toString$0(0) + " are incompatible.", null));
                    }
                }
            },
            SassCalculation__verifyLength: function(args, expectedLength) {
                var t1;
                if (args.length === expectedLength) return;
                if (B.JSArray_methods.any$1(args, new A.SassCalculation__verifyLength_closure())) return;
                t1 = args.length;
                throw A.wrapException(A.SassScriptException$("" + expectedLength + " arguments required, but only " + t1 + " " + A.pluralize("was", t1, "were") + " passed.", null));
            },
            SassCalculation__singleArgument: function($name, argument, mathFunc, forbidUnits) {
                argument = A.SassCalculation__simplify(argument);
                if (!(argument instanceof A.SassNumber)) return new A.SassCalculation($name, A._setArrayType([
                    argument
                ], type$.JSArray_Object));
                if (forbidUnits) argument.assertNoUnits$0();
                return mathFunc.call$1(argument);
            },
            SassCalculation: function SassCalculation(t0, t1) {
                this.name = t0;
                this.$arguments = t1;
            },
            SassCalculation__verifyLength_closure: function SassCalculation__verifyLength_closure() {},
            CalculationOperation: function CalculationOperation(t0, t1, t2) {
                this._operator = t0;
                this._left = t1;
                this._right = t2;
            },
            CalculationOperator: function CalculationOperator(t0, t1, t2, t3, t4) {
                var _ = this;
                _.name = t0;
                _.operator = t1;
                _.precedence = t2;
                _.index = t3;
                _._name = t4;
            },
            SassColor_SassColor$rgb: function(red, green, blue, alpha) {
                return A.SassColor_SassColor$rgbInternal(red, green, blue, alpha, null);
            },
            SassColor_SassColor$rgbInternal: function(red, green, blue, alpha, format) {
                var _null = null, t1 = red == null ? _null : red, t2 = green == null ? _null : green, t3 = blue == null ? _null : blue;
                return A.SassColor$_forSpace(B.RgbColorSpace_i0P, t1, t2, t3, alpha == null ? _null : alpha, format);
            },
            SassColor_SassColor$hsl: function(hue, saturation, lightness, alpha) {
                var _null = null, t1 = hue == null ? _null : hue, t2 = saturation == null ? _null : saturation, t3 = lightness == null ? _null : lightness;
                return A.SassColor_SassColor$forSpaceInternal(B.HslColorSpace_JQ2, t1, t2, t3, alpha == null ? _null : alpha);
            },
            SassColor_SassColor$hwb: function(hue, whiteness, blackness, alpha) {
                var _null = null, t1 = hue == null ? _null : hue, t2 = whiteness == null ? _null : whiteness, t3 = blackness == null ? _null : blackness;
                return A.SassColor_SassColor$forSpaceInternal(B.HwbColorSpace_guQ, t1, t2, t3, alpha == null ? _null : alpha);
            },
            SassColor_SassColor$forSpaceInternal: function(space, channel0, channel1, channel2, alpha) {
                var t1, t2, _null = null;
                $label0$0: {
                    if (B.HslColorSpace_JQ2 === space) {
                        t1 = channel1 == null;
                        t2 = A.SassColor__normalizeHue(channel0, !t1 && channel1 < 0 && !A.fuzzyEquals(channel1, 0));
                        t2 = A.SassColor$_forSpace(space, t2, t1 ? _null : Math.abs(channel1), channel2, alpha, _null);
                        t1 = t2;
                        break $label0$0;
                    }
                    if (B.HwbColorSpace_guQ === space) {
                        t1 = A.SassColor$_forSpace(space, A.SassColor__normalizeHue(channel0, false), channel1, channel2, alpha, _null);
                        break $label0$0;
                    }
                    if (B.LchColorSpace_Bpv === space || B.OklchColorSpace_9Gj === space) {
                        t1 = channel1 == null;
                        t2 = t1 ? _null : Math.abs(channel1);
                        t2 = A.SassColor$_forSpace(space, channel0, t2, A.SassColor__normalizeHue(channel2, !t1 && channel1 < 0 && !A.fuzzyEquals(channel1, 0)), alpha, _null);
                        t1 = t2;
                        break $label0$0;
                    }
                    t1 = A.SassColor$_forSpace(space, channel0, channel1, channel2, alpha, _null);
                    break $label0$0;
                }
                return t1;
            },
            SassColor$_forSpace: function(_space, channel0OrNull, channel1OrNull, channel2OrNull, alpha, format) {
                return new A.SassColor(_space, channel0OrNull, channel1OrNull, channel2OrNull, format, A.NullableExtension_andThen(alpha, new A.SassColor$_forSpace_closure()));
            },
            SassColor__normalizeHue: function(hue, invert) {
                var t1, t2;
                if (hue == null) return hue;
                t1 = B.JSNumber_methods.$mod(hue, 360);
                t2 = invert ? 180 : 0;
                return B.JSNumber_methods.$mod(t1 + 360 + t2, 360);
            },
            SassColor: function SassColor(t0, t1, t2, t3, t4, t5) {
                var _ = this;
                _._space = t0;
                _.channel0OrNull = t1;
                _.channel1OrNull = t2;
                _.channel2OrNull = t3;
                _.format = t4;
                _.alphaOrNull = t5;
            },
            SassColor$_forSpace_closure: function SassColor$_forSpace_closure() {},
            _ColorFormatEnum: function _ColorFormatEnum() {},
            SpanColorFormat: function SpanColorFormat(t0) {
                this._color$_span = t0;
            },
            ColorChannel: function ColorChannel(t0, t1, t2) {
                this.name = t0;
                this.isPolarAngle = t1;
                this.associatedUnit = t2;
            },
            LinearChannel: function LinearChannel(t0, t1, t2, t3, t4, t5, t6, t7) {
                var _ = this;
                _.min = t0;
                _.max = t1;
                _.requiresPercent = t2;
                _.lowerClamped = t3;
                _.upperClamped = t4;
                _.name = t5;
                _.isPolarAngle = t6;
                _.associatedUnit = t7;
            },
            GamutMapMethod_GamutMapMethod$fromName: function($name) {
                var t1;
                $label0$0: {
                    if ("clip" === $name) {
                        t1 = B.ClipGamutMap_clip;
                        break $label0$0;
                    }
                    if ("local-minde" === $name) {
                        t1 = B.LocalMindeGamutMap_A2x;
                        break $label0$0;
                    }
                    t1 = A.throwExpression(A.SassScriptException$('Unknown gamut map method "' + $name + '".', null));
                }
                return t1;
            },
            GamutMapMethod: function GamutMapMethod() {},
            ClipGamutMap: function ClipGamutMap(t0) {
                this.name = t0;
            },
            LocalMindeGamutMap: function LocalMindeGamutMap(t0) {
                this.name = t0;
            },
            InterpolationMethod$: function(space, hue) {
                var t1;
                if (space.get$isPolarInternal()) t1 = hue == null ? B.HueInterpolationMethod_0 : hue;
                else t1 = null;
                if (!space.get$isPolarInternal() && hue != null) A.throwExpression(A.ArgumentError$(string$.Hue_in + space.toString$0(0) + ".", null));
                return new A.InterpolationMethod(space, t1);
            },
            InterpolationMethod_InterpolationMethod$fromValue: function(value, $name) {
                var t1, space, hueMethod, list = value.assertCommonListStyle$2$allowSlash($name, false);
                if (list.length === 0) throw A.wrapException(A.SassScriptException$(string$.Expecta, $name));
                t1 = B.JSArray_methods.get$first(list).assertString$1($name);
                t1.assertUnquoted$1($name);
                space = A.ColorSpace_fromName(t1._string$_text, $name);
                if (list.length === 1) return A.InterpolationMethod$(space, null);
                hueMethod = A.HueInterpolationMethod_HueInterpolationMethod$_fromValue(list[1], $name);
                if (list.length === 2) throw A.wrapException(A.SassScriptException$('Expected unquoted string "hue" after ' + value.toString$0(0) + ".", $name));
                else {
                    t1 = list[2].assertString$1($name);
                    t1.assertUnquoted$1($name);
                    if (t1._string$_text.toLowerCase() !== "hue") throw A.wrapException(A.SassScriptException$(string$.Expectu + value.toString$0(0) + ", was " + list[2].toString$0(0) + ".", $name));
                    else if (list.length > 3) throw A.wrapException(A.SassScriptException$('Expected nothing after "hue" in ' + value.toString$0(0) + ".", $name));
                    else if (!space.get$isPolarInternal()) throw A.wrapException(A.SassScriptException$('Hue interpolation method "' + hueMethod.toString$0(0) + string$.x20hue__ + space.toString$0(0) + ".", $name));
                }
                return A.InterpolationMethod$(space, hueMethod);
            },
            HueInterpolationMethod_HueInterpolationMethod$_fromValue: function(value, $name) {
                var _0_0, t1 = value.assertString$1($name);
                t1.assertUnquoted$0();
                _0_0 = t1._string$_text.toLowerCase();
                $label0$0: {
                    if ("shorter" === _0_0) {
                        t1 = B.HueInterpolationMethod_0;
                        break $label0$0;
                    }
                    if ("longer" === _0_0) {
                        t1 = B.HueInterpolationMethod_1;
                        break $label0$0;
                    }
                    if ("increasing" === _0_0) {
                        t1 = B.HueInterpolationMethod_2;
                        break $label0$0;
                    }
                    if ("decreasing" === _0_0) {
                        t1 = B.HueInterpolationMethod_3;
                        break $label0$0;
                    }
                    t1 = A.throwExpression(A.SassScriptException$("Unknown hue interpolation method " + value.toString$0(0) + ".", $name));
                }
                return t1;
            },
            InterpolationMethod: function InterpolationMethod(t0, t1) {
                this.space = t0;
                this.hue = t1;
            },
            HueInterpolationMethod: function HueInterpolationMethod(t0, t1) {
                this.index = t0;
                this._name = t1;
            },
            ColorSpace_fromName: function($name, argumentName) {
                var t1, _0_0 = $name.toLowerCase();
                $label0$0: {
                    if ("rgb" === _0_0) {
                        t1 = B.RgbColorSpace_i0P;
                        break $label0$0;
                    }
                    if ("hwb" === _0_0) {
                        t1 = B.HwbColorSpace_guQ;
                        break $label0$0;
                    }
                    if ("hsl" === _0_0) {
                        t1 = B.HslColorSpace_JQ2;
                        break $label0$0;
                    }
                    if ("srgb" === _0_0) {
                        t1 = B.SrgbColorSpace_thf;
                        break $label0$0;
                    }
                    if ("srgb-linear" === _0_0) {
                        t1 = B.SrgbLinearColorSpace_kUj;
                        break $label0$0;
                    }
                    if ("display-p3" === _0_0) {
                        t1 = B.DisplayP3ColorSpace_MmT;
                        break $label0$0;
                    }
                    if ("display-p3-linear" === _0_0) {
                        t1 = B.DisplayP3LinearColorSpace_PrP;
                        break $label0$0;
                    }
                    if ("a98-rgb" === _0_0) {
                        t1 = B.A98RgbColorSpace_lf2;
                        break $label0$0;
                    }
                    if ("prophoto-rgb" === _0_0) {
                        t1 = B.ProphotoRgbColorSpace_BDz;
                        break $label0$0;
                    }
                    if ("rec2020" === _0_0) {
                        t1 = B.Rec2020ColorSpace_6oo;
                        break $label0$0;
                    }
                    if ("xyz" === _0_0 || "xyz-d65" === _0_0) {
                        t1 = B.XyzD65ColorSpace_WiJ;
                        break $label0$0;
                    }
                    if ("xyz-d50" === _0_0) {
                        t1 = B.XyzD50ColorSpace_2OB;
                        break $label0$0;
                    }
                    if ("lab" === _0_0) {
                        t1 = B.LabColorSpace_2nT;
                        break $label0$0;
                    }
                    if ("lch" === _0_0) {
                        t1 = B.LchColorSpace_Bpv;
                        break $label0$0;
                    }
                    if ("oklab" === _0_0) {
                        t1 = B.OklabColorSpace_540;
                        break $label0$0;
                    }
                    if ("oklch" === _0_0) {
                        t1 = B.OklchColorSpace_9Gj;
                        break $label0$0;
                    }
                    t1 = A.throwExpression(A.SassScriptException$('Unknown color space "' + $name + '".', argumentName));
                }
                return t1;
            },
            ColorSpace: function ColorSpace() {},
            A98RgbColorSpace: function A98RgbColorSpace(t0, t1) {
                this.name = t0;
                this._channels = t1;
            },
            DisplayP3ColorSpace: function DisplayP3ColorSpace(t0, t1) {
                this.name = t0;
                this._channels = t1;
            },
            DisplayP3LinearColorSpace: function DisplayP3LinearColorSpace(t0, t1) {
                this.name = t0;
                this._channels = t1;
            },
            HslColorSpace: function HslColorSpace(t0, t1) {
                this.name = t0;
                this._channels = t1;
            },
            HwbColorSpace: function HwbColorSpace(t0, t1) {
                this.name = t0;
                this._channels = t1;
            },
            HwbColorSpace_convert_toRgb: function HwbColorSpace_convert_toRgb(t0, t1) {
                this._box_0 = t0;
                this.factor = t1;
            },
            LabColorSpace: function LabColorSpace(t0, t1) {
                this.name = t0;
                this._channels = t1;
            },
            LchColorSpace: function LchColorSpace(t0, t1) {
                this.name = t0;
                this._channels = t1;
            },
            LmsColorSpace: function LmsColorSpace(t0, t1) {
                this.name = t0;
                this._channels = t1;
            },
            OklabColorSpace: function OklabColorSpace(t0, t1) {
                this.name = t0;
                this._channels = t1;
            },
            OklchColorSpace: function OklchColorSpace(t0, t1) {
                this.name = t0;
                this._channels = t1;
            },
            ProphotoRgbColorSpace: function ProphotoRgbColorSpace(t0, t1) {
                this.name = t0;
                this._channels = t1;
            },
            Rec2020ColorSpace: function Rec2020ColorSpace(t0, t1) {
                this.name = t0;
                this._channels = t1;
            },
            RgbColorSpace: function RgbColorSpace(t0, t1) {
                this.name = t0;
                this._channels = t1;
            },
            SrgbColorSpace: function SrgbColorSpace(t0, t1) {
                this.name = t0;
                this._channels = t1;
            },
            SrgbLinearColorSpace: function SrgbLinearColorSpace(t0, t1) {
                this.name = t0;
                this._channels = t1;
            },
            XyzD50ColorSpace: function XyzD50ColorSpace(t0, t1) {
                this.name = t0;
                this._channels = t1;
            },
            XyzD65ColorSpace: function XyzD65ColorSpace(t0, t1) {
                this.name = t0;
                this._channels = t1;
            },
            SassFunction: function SassFunction(t0, t1) {
                this.callable = t0;
                this._function$_compileContext = t1;
            },
            SassList$: function(contents, _separator, brackets) {
                var t1 = new A.SassList(A.List_List$unmodifiable(contents, type$.Value), _separator, brackets);
                t1.SassList$3$brackets(contents, _separator, brackets);
                return t1;
            },
            SassList: function SassList(t0, t1, t2) {
                this._list$_contents = t0;
                this._separator = t1;
                this._hasBrackets = t2;
            },
            SassList_isBlank_closure: function SassList_isBlank_closure() {},
            ListSeparator: function ListSeparator(t0, t1, t2, t3) {
                var _ = this;
                _._list$_name = t0;
                _.separator = t1;
                _.index = t2;
                _._name = t3;
            },
            SassMap: function SassMap(t0) {
                this._map$_contents = t0;
            },
            SassMixin: function SassMixin(t0, t1) {
                this.callable = t0;
                this._mixin$_compileContext = t1;
            },
            _SassNull: function _SassNull() {},
            conversionFactor: function(unit1, unit2) {
                var _0_0;
                if (unit1 === unit2) return 1;
                _0_0 = B.Map_NtHoP.$index(0, unit1);
                if (_0_0 != null) return _0_0.$index(0, unit2);
                return null;
            },
            SassNumber_SassNumber: function(value, unit) {
                return unit == null ? new A.UnitlessSassNumber(value, null) : new A.SingleUnitSassNumber(unit, value, null);
            },
            SassNumber_SassNumber$withUnits: function(value, denominatorUnits, numeratorUnits) {
                var t1, _0_8, _0_10, _0_10_isSet, _0_7, _0_8_isSet, _0_7_isSet, unit, _0_7_isSet0, t2, numerators, denominators, unsimplifiedDenominators, valueDouble, _i, denominator, simplifiedAway, i, factor, _1_2, _1_7_isSet, _1_7, _null = null, _0_6 = _null, _0_4 = _null;
                _0_4 = numeratorUnits.length;
                t1 = _0_4;
                _0_6 = t1 <= 0;
                t1 = _0_6;
                _0_8 = _null;
                _0_10 = _null;
                if (t1) {
                    _0_8 = denominatorUnits == null;
                    t1 = _0_8;
                    _0_10_isSet = !t1;
                    if (_0_10_isSet) {
                        _0_10 = (denominatorUnits == null ? type$.List_String._as(denominatorUnits) : denominatorUnits).length <= 0;
                        t1 = _0_10;
                    } else t1 = true;
                    _0_7 = denominatorUnits;
                    _0_8_isSet = true;
                    _0_7_isSet = true;
                } else {
                    _0_7 = _null;
                    _0_8_isSet = false;
                    _0_7_isSet = false;
                    _0_10_isSet = false;
                    t1 = false;
                }
                if (t1) return new A.UnitlessSassNumber(value, _null);
                unit = _null;
                t1 = false;
                _0_7_isSet0 = true;
                t2 = _0_4;
                if (t2 === 1) {
                    unit = numeratorUnits[0];
                    if (_0_8_isSet) t1 = _0_8;
                    else {
                        if (_0_7_isSet) t1 = _0_7;
                        else {
                            t1 = denominatorUnits;
                            _0_7_isSet = _0_7_isSet0;
                            _0_7 = t1;
                        }
                        _0_8 = t1 == null;
                        t1 = _0_8;
                        _0_8_isSet = true;
                    }
                    if (!t1) {
                        if (_0_10_isSet) t1 = _0_10;
                        else {
                            if (_0_7_isSet) t1 = _0_7;
                            else {
                                t1 = denominatorUnits;
                                _0_7_isSet = _0_7_isSet0;
                                _0_7 = t1;
                            }
                            _0_10 = (t1 == null ? type$.List_String._as(t1) : t1).length <= 0;
                            t1 = _0_10;
                            _0_10_isSet = true;
                        }
                    } else t1 = true;
                }
                if (t1) return new A.SingleUnitSassNumber(unit, value, _null);
                t1 = false;
                _0_7_isSet0 = true;
                if (_0_8_isSet) t1 = _0_8;
                else {
                    if (_0_7_isSet) t1 = _0_7;
                    else {
                        t1 = denominatorUnits;
                        _0_7_isSet = _0_7_isSet0;
                        _0_7 = t1;
                    }
                    _0_8 = t1 == null;
                    t1 = _0_8;
                }
                if (!t1) {
                    if (_0_10_isSet) t1 = _0_10;
                    else {
                        if (_0_7_isSet) t1 = _0_7;
                        else {
                            t1 = denominatorUnits;
                            _0_7_isSet = _0_7_isSet0;
                            _0_7 = t1;
                        }
                        _0_10 = (t1 == null ? type$.List_String._as(t1) : t1).length <= 0;
                        t1 = _0_10;
                    }
                } else t1 = true;
                numerators = numeratorUnits;
                if (t1) return new A.ComplexSassNumber(A.List_List$unmodifiable(numerators, type$.String), B.List_empty, value, _null);
                t1 = _0_6;
                denominators = _null;
                if (t1) {
                    if (_0_7_isSet) t1 = _0_7;
                    else {
                        t1 = denominatorUnits;
                        _0_7 = t1;
                        _0_7_isSet = true;
                    }
                    t1 = t1 != null;
                    if (t1) {
                        denominators = _0_7_isSet ? _0_7 : denominatorUnits;
                        if (denominators == null) denominators = type$.List_String._as(denominators);
                    }
                } else t1 = false;
                if (t1) return new A.ComplexSassNumber(B.List_empty, A.List_List$unmodifiable(denominators, type$.String), value, _null);
                numerators = A._setArrayType(numeratorUnits.slice(0), A._arrayInstanceType(numeratorUnits));
                unsimplifiedDenominators = A._setArrayType(denominatorUnits.slice(0), A.instanceType(denominatorUnits));
                denominators = A._setArrayType([], type$.JSArray_String);
                for(t1 = unsimplifiedDenominators.length, valueDouble = value, _i = 0; _i < unsimplifiedDenominators.length; unsimplifiedDenominators.length === t1 || (0, A.throwConcurrentModificationError)(unsimplifiedDenominators), ++_i){
                    denominator = unsimplifiedDenominators[_i];
                    i = 0;
                    for(;;){
                        if (!(i < numerators.length)) {
                            simplifiedAway = false;
                            break;
                        }
                        c$0: {
                            factor = A.conversionFactor(denominator, numerators[i]);
                            if (factor == null) break c$0;
                            valueDouble *= factor;
                            B.JSArray_methods.removeAt$1(numerators, i);
                            simplifiedAway = true;
                            break;
                        }
                        ++i;
                    }
                    if (!simplifiedAway) denominators.push(denominator);
                }
                $label0$1: {
                    _1_2 = numerators.length;
                    t1 = _1_2;
                    _1_7_isSet = t1 <= 0;
                    if (_1_7_isSet) {
                        _1_7 = denominators.length <= 0;
                        t1 = _1_7;
                    } else {
                        _1_7 = _null;
                        t1 = false;
                    }
                    if (t1) {
                        t1 = new A.UnitlessSassNumber(valueDouble, _null);
                        break $label0$1;
                    }
                    t1 = false;
                    if (_1_2 === 1) {
                        unit = numerators[0];
                        t1 = _1_7_isSet ? _1_7 : denominators.length <= 0;
                    } else unit = _null;
                    if (t1) {
                        t1 = new A.SingleUnitSassNumber(unit, valueDouble, _null);
                        break $label0$1;
                    }
                    t1 = type$.String;
                    t1 = new A.ComplexSassNumber(A.List_List$unmodifiable(numerators, t1), A.List_List$unmodifiable(denominators, t1), valueDouble, _null);
                    break $label0$1;
                }
                return t1;
            },
            SassNumber: function SassNumber() {},
            SassNumber__coerceOrConvertValue_compatibilityException: function SassNumber__coerceOrConvertValue_compatibilityException(t0, t1, t2, t3, t4, t5, t6) {
                var _ = this;
                _.$this = t0;
                _.other = t1;
                _.otherName = t2;
                _.otherHasUnits = t3;
                _.name = t4;
                _.newNumerators = t5;
                _.newDenominators = t6;
            },
            SassNumber__coerceOrConvertValue_closure: function SassNumber__coerceOrConvertValue_closure(t0, t1) {
                this._box_0 = t0;
                this.newNumerator = t1;
            },
            SassNumber__coerceOrConvertValue_closure0: function SassNumber__coerceOrConvertValue_closure0(t0) {
                this.compatibilityException = t0;
            },
            SassNumber__coerceOrConvertValue_closure1: function SassNumber__coerceOrConvertValue_closure1(t0, t1) {
                this._box_0 = t0;
                this.newDenominator = t1;
            },
            SassNumber__coerceOrConvertValue_closure2: function SassNumber__coerceOrConvertValue_closure2(t0) {
                this.compatibilityException = t0;
            },
            SassNumber_plus_closure: function SassNumber_plus_closure() {},
            SassNumber_minus_closure: function SassNumber_minus_closure() {},
            SassNumber_multiplyUnits_closure: function SassNumber_multiplyUnits_closure(t0, t1) {
                this._box_0 = t0;
                this.numerator = t1;
            },
            SassNumber_multiplyUnits_closure0: function SassNumber_multiplyUnits_closure0(t0, t1) {
                this.newNumerators = t0;
                this.numerator = t1;
            },
            SassNumber_multiplyUnits_closure1: function SassNumber_multiplyUnits_closure1(t0, t1) {
                this._box_0 = t0;
                this.numerator = t1;
            },
            SassNumber_multiplyUnits_closure2: function SassNumber_multiplyUnits_closure2(t0, t1) {
                this.newNumerators = t0;
                this.numerator = t1;
            },
            SassNumber__areAnyConvertible_closure: function SassNumber__areAnyConvertible_closure(t0) {
                this.units2 = t0;
            },
            SassNumber__canonicalizeUnitList_closure: function SassNumber__canonicalizeUnitList_closure() {},
            SassNumber__canonicalMultiplier_closure: function SassNumber__canonicalMultiplier_closure(t0) {
                this.$this = t0;
            },
            SassNumber_unitSuggestion_closure: function SassNumber_unitSuggestion_closure() {},
            SassNumber_unitSuggestion_closure0: function SassNumber_unitSuggestion_closure0() {},
            ComplexSassNumber: function ComplexSassNumber(t0, t1, t2, t3) {
                var _ = this;
                _._numeratorUnits = t0;
                _._denominatorUnits = t1;
                _._number$_value = t2;
                _.hashCache = null;
                _.asSlash = t3;
            },
            SingleUnitSassNumber: function SingleUnitSassNumber(t0, t1, t2) {
                var _ = this;
                _._unit = t0;
                _._number$_value = t1;
                _.hashCache = null;
                _.asSlash = t2;
            },
            SingleUnitSassNumber__coerceToUnit_closure: function SingleUnitSassNumber__coerceToUnit_closure(t0, t1) {
                this.$this = t0;
                this.unit = t1;
            },
            SingleUnitSassNumber__coerceValueToUnit_closure: function SingleUnitSassNumber__coerceValueToUnit_closure(t0) {
                this.$this = t0;
            },
            SingleUnitSassNumber_multiplyUnits_closure: function SingleUnitSassNumber_multiplyUnits_closure(t0, t1) {
                this._box_0 = t0;
                this.$this = t1;
            },
            SingleUnitSassNumber_multiplyUnits_closure0: function SingleUnitSassNumber_multiplyUnits_closure0(t0, t1) {
                this._box_0 = t0;
                this.$this = t1;
            },
            UnitlessSassNumber: function UnitlessSassNumber(t0, t1) {
                this._number$_value = t0;
                this.hashCache = null;
                this.asSlash = t1;
            },
            SassString$: function(_text, quotes) {
                return new A.SassString(_text, quotes);
            },
            SassString: function SassString(t0, t1) {
                var _ = this;
                _._string$_text = t0;
                _._hasQuotes = t1;
                _.__SassString__sassLength_FI = $;
                _._hashCache = null;
            },
            AnySelectorVisitor: function AnySelectorVisitor() {},
            AnySelectorVisitor_visitComplexSelector_closure: function AnySelectorVisitor_visitComplexSelector_closure(t0) {
                this.$this = t0;
            },
            AnySelectorVisitor_visitCompoundSelector_closure: function AnySelectorVisitor_visitCompoundSelector_closure(t0) {
                this.$this = t0;
            },
            _EvaluateVisitor$0: function(functions, importCache, logger, nodeImporter, quietDeps, sourceMap) {
                var t1 = type$.Uri, t2 = type$.Module_AsyncCallable, t3 = A._setArrayType([], type$.JSArray_Record_2_String_and_AstNode);
                t1 = new A._EvaluateVisitor0(importCache, nodeImporter, A.LinkedHashMap_LinkedHashMap$_empty(type$.String, type$.AsyncCallable), A.LinkedHashMap_LinkedHashMap$_empty(t1, t2), A.LinkedHashMap_LinkedHashMap$_empty(t1, t2), A.LinkedHashMap_LinkedHashMap$_empty(t1, type$.Configuration), A.LinkedHashMap_LinkedHashMap$_empty(t1, type$.AstNode), logger, A.LinkedHashSet_LinkedHashSet$_empty(type$.Record_2_String_and_SourceSpan), quietDeps, sourceMap, new A.Object(), A.AsyncEnvironment$(), A.LinkedHashSet_LinkedHashSet$_empty(t1), A.LinkedHashMap_LinkedHashMap$_empty(t1, type$.nullable_AstNode), t3, B.Configuration_Map_empty_null);
                t1._EvaluateVisitor$6$functions$importCache$logger$nodeImporter$quietDeps$sourceMap0(functions, importCache, logger, nodeImporter, quietDeps, sourceMap);
                return t1;
            },
            _EvaluateVisitor0: function _EvaluateVisitor0(t0, t1, t2, t3, t4, t5, t6, t7, t8, t9, t10, t11, t12, t13, t14, t15, t16) {
                var _ = this;
                _._async_evaluate$_importCache = t0;
                _._async_evaluate$_nodeImporter = t1;
                _._async_evaluate$_builtInFunctions = t2;
                _._async_evaluate$_builtInModules = t3;
                _._async_evaluate$_modules = t4;
                _._async_evaluate$_moduleConfigurations = t5;
                _._async_evaluate$_moduleNodes = t6;
                _._async_evaluate$_logger = t7;
                _._async_evaluate$_warningsEmitted = t8;
                _._async_evaluate$_quietDeps = t9;
                _._async_evaluate$_sourceMap = t10;
                _._async_evaluate$_compileContext = t11;
                _._async_evaluate$_environment = t12;
                _._async_evaluate$_declarationName = _._async_evaluate$__parent = _._async_evaluate$_mediaQuerySources = _._async_evaluate$_mediaQueries = _._async_evaluate$_styleRuleIgnoringAtRoot = null;
                _._async_evaluate$_member = "root stylesheet";
                _._async_evaluate$_importSpan = _._async_evaluate$_callableNode = null;
                _._async_evaluate$_inSupportsDeclaration = _._async_evaluate$_inKeyframes = _._async_evaluate$_atRootExcludingStyleRule = _._async_evaluate$_inUnknownAtRule = _._async_evaluate$_inFunction = false;
                _._async_evaluate$_loadedUrls = t13;
                _._async_evaluate$_activeModules = t14;
                _._async_evaluate$_stack = t15;
                _._async_evaluate$_importer = null;
                _._async_evaluate$_inDependency = false;
                _._async_evaluate$__extensionStore = _._async_evaluate$_preModuleComments = _._async_evaluate$_outOfOrderImports = _._async_evaluate$__endOfImports = _._async_evaluate$__root = _._async_evaluate$__stylesheet = null;
                _._async_evaluate$_configuration = t16;
            },
            _EvaluateVisitor_closure12: function _EvaluateVisitor_closure12(t0) {
                this.$this = t0;
            },
            _EvaluateVisitor_closure13: function _EvaluateVisitor_closure13(t0) {
                this.$this = t0;
            },
            _EvaluateVisitor_closure14: function _EvaluateVisitor_closure14(t0) {
                this.$this = t0;
            },
            _EvaluateVisitor_closure15: function _EvaluateVisitor_closure15(t0) {
                this.$this = t0;
            },
            _EvaluateVisitor_closure16: function _EvaluateVisitor_closure16(t0) {
                this.$this = t0;
            },
            _EvaluateVisitor_closure17: function _EvaluateVisitor_closure17(t0) {
                this.$this = t0;
            },
            _EvaluateVisitor_closure18: function _EvaluateVisitor_closure18(t0) {
                this.$this = t0;
            },
            _EvaluateVisitor_closure19: function _EvaluateVisitor_closure19(t0) {
                this.$this = t0;
            },
            _EvaluateVisitor_closure20: function _EvaluateVisitor_closure20(t0) {
                this.$this = t0;
            },
            _EvaluateVisitor__closure6: function _EvaluateVisitor__closure6(t0, t1, t2) {
                this.$this = t0;
                this.name = t1;
                this.module = t2;
            },
            _EvaluateVisitor_closure21: function _EvaluateVisitor_closure21(t0) {
                this.$this = t0;
            },
            _EvaluateVisitor__closure5: function _EvaluateVisitor__closure5(t0, t1, t2) {
                this.$this = t0;
                this.name = t1;
                this.module = t2;
            },
            _EvaluateVisitor_closure22: function _EvaluateVisitor_closure22(t0) {
                this.$this = t0;
            },
            _EvaluateVisitor_closure23: function _EvaluateVisitor_closure23(t0) {
                this.$this = t0;
            },
            _EvaluateVisitor__closure3: function _EvaluateVisitor__closure3(t0, t1, t2, t3) {
                var _ = this;
                _._box_0 = t0;
                _.values = t1;
                _.span = t2;
                _.callableNode = t3;
            },
            _EvaluateVisitor__closure4: function _EvaluateVisitor__closure4(t0) {
                this.$this = t0;
            },
            _EvaluateVisitor_closure24: function _EvaluateVisitor_closure24(t0) {
                this.$this = t0;
            },
            _EvaluateVisitor_run_closure0: function _EvaluateVisitor_run_closure0(t0, t1, t2) {
                this.$this = t0;
                this.node = t1;
                this.importer = t2;
            },
            _EvaluateVisitor_run__closure0: function _EvaluateVisitor_run__closure0(t0, t1, t2) {
                this.$this = t0;
                this.importer = t1;
                this.node = t2;
            },
            _EvaluateVisitor__loadModule_closure1: function _EvaluateVisitor__loadModule_closure1(t0, t1) {
                this._box_0 = t0;
                this.callback = t1;
            },
            _EvaluateVisitor__loadModule_closure2: function _EvaluateVisitor__loadModule_closure2(t0, t1, t2, t3, t4, t5, t6) {
                var _ = this;
                _.$this = t0;
                _.url = t1;
                _.nodeWithSpan = t2;
                _.baseUrl = t3;
                _.namesInErrors = t4;
                _.configuration = t5;
                _.callback = t6;
            },
            _EvaluateVisitor__loadModule__closure1: function _EvaluateVisitor__loadModule__closure1(t0, t1) {
                this.$this = t0;
                this.message = t1;
            },
            _EvaluateVisitor__loadModule__closure2: function _EvaluateVisitor__loadModule__closure2(t0, t1, t2) {
                this._box_1 = t0;
                this.callback = t1;
                this.firstLoad = t2;
            },
            _EvaluateVisitor__execute_closure0: function _EvaluateVisitor__execute_closure0(t0, t1, t2, t3, t4, t5, t6) {
                var _ = this;
                _.$this = t0;
                _.importer = t1;
                _.stylesheet = t2;
                _.extensionStore = t3;
                _.configuration = t4;
                _.css = t5;
                _.preModuleComments = t6;
            },
            _EvaluateVisitor__combineCss_closure1: function _EvaluateVisitor__combineCss_closure1() {},
            _EvaluateVisitor__combineCss_closure2: function _EvaluateVisitor__combineCss_closure2(t0) {
                this.selectors = t0;
            },
            _EvaluateVisitor__combineCss_visitModule0: function _EvaluateVisitor__combineCss_visitModule0(t0, t1, t2, t3, t4, t5) {
                var _ = this;
                _.$this = t0;
                _.seen = t1;
                _.clone = t2;
                _.css = t3;
                _.imports = t4;
                _.sorted = t5;
            },
            _EvaluateVisitor__extendModules_closure1: function _EvaluateVisitor__extendModules_closure1(t0) {
                this.originalSelectors = t0;
            },
            _EvaluateVisitor__extendModules_closure2: function _EvaluateVisitor__extendModules_closure2() {},
            _EvaluateVisitor_visitAtRootRule_closure1: function _EvaluateVisitor_visitAtRootRule_closure1(t0, t1) {
                this.$this = t0;
                this.node = t1;
            },
            _EvaluateVisitor_visitAtRootRule_closure2: function _EvaluateVisitor_visitAtRootRule_closure2(t0, t1) {
                this.$this = t0;
                this.node = t1;
            },
            _EvaluateVisitor__scopeForAtRoot_closure5: function _EvaluateVisitor__scopeForAtRoot_closure5(t0, t1, t2) {
                this.$this = t0;
                this.newParent = t1;
                this.node = t2;
            },
            _EvaluateVisitor__scopeForAtRoot_closure6: function _EvaluateVisitor__scopeForAtRoot_closure6(t0, t1) {
                this.$this = t0;
                this.innerScope = t1;
            },
            _EvaluateVisitor__scopeForAtRoot_closure7: function _EvaluateVisitor__scopeForAtRoot_closure7(t0, t1) {
                this.$this = t0;
                this.innerScope = t1;
            },
            _EvaluateVisitor__scopeForAtRoot__closure0: function _EvaluateVisitor__scopeForAtRoot__closure0(t0, t1) {
                this.innerScope = t0;
                this.callback = t1;
            },
            _EvaluateVisitor__scopeForAtRoot_closure8: function _EvaluateVisitor__scopeForAtRoot_closure8(t0, t1) {
                this.$this = t0;
                this.innerScope = t1;
            },
            _EvaluateVisitor__scopeForAtRoot_closure9: function _EvaluateVisitor__scopeForAtRoot_closure9() {},
            _EvaluateVisitor__scopeForAtRoot_closure10: function _EvaluateVisitor__scopeForAtRoot_closure10(t0, t1) {
                this.$this = t0;
                this.innerScope = t1;
            },
            _EvaluateVisitor_visitContentRule_closure0: function _EvaluateVisitor_visitContentRule_closure0(t0, t1) {
                this.$this = t0;
                this.content = t1;
            },
            _EvaluateVisitor_visitDeclaration_closure0: function _EvaluateVisitor_visitDeclaration_closure0(t0, t1) {
                this._box_0 = t0;
                this.$this = t1;
            },
            _EvaluateVisitor_visitEachRule_closure2: function _EvaluateVisitor_visitEachRule_closure2(t0, t1, t2) {
                this._box_0 = t0;
                this.$this = t1;
                this.nodeWithSpan = t2;
            },
            _EvaluateVisitor_visitEachRule_closure3: function _EvaluateVisitor_visitEachRule_closure3(t0, t1, t2) {
                this._box_1 = t0;
                this.$this = t1;
                this.nodeWithSpan = t2;
            },
            _EvaluateVisitor_visitEachRule_closure4: function _EvaluateVisitor_visitEachRule_closure4(t0, t1, t2, t3) {
                var _ = this;
                _.$this = t0;
                _.list = t1;
                _.setVariables = t2;
                _.node = t3;
            },
            _EvaluateVisitor_visitEachRule__closure0: function _EvaluateVisitor_visitEachRule__closure0(t0, t1, t2) {
                this.$this = t0;
                this.setVariables = t1;
                this.node = t2;
            },
            _EvaluateVisitor_visitEachRule___closure0: function _EvaluateVisitor_visitEachRule___closure0(t0) {
                this.$this = t0;
            },
            _EvaluateVisitor_visitAtRule_closure3: function _EvaluateVisitor_visitAtRule_closure3(t0) {
                this.$this = t0;
            },
            _EvaluateVisitor_visitAtRule_closure4: function _EvaluateVisitor_visitAtRule_closure4(t0, t1) {
                this.$this = t0;
                this.children = t1;
            },
            _EvaluateVisitor_visitAtRule_closure5: function _EvaluateVisitor_visitAtRule_closure5(t0, t1, t2) {
                this.$this = t0;
                this.name = t1;
                this.children = t2;
            },
            _EvaluateVisitor_visitAtRule__closure0: function _EvaluateVisitor_visitAtRule__closure0(t0, t1) {
                this.$this = t0;
                this.children = t1;
            },
            _EvaluateVisitor_visitAtRule_closure6: function _EvaluateVisitor_visitAtRule_closure6() {},
            _EvaluateVisitor_visitForRule_closure4: function _EvaluateVisitor_visitForRule_closure4(t0, t1) {
                this.$this = t0;
                this.node = t1;
            },
            _EvaluateVisitor_visitForRule_closure5: function _EvaluateVisitor_visitForRule_closure5(t0, t1) {
                this.$this = t0;
                this.node = t1;
            },
            _EvaluateVisitor_visitForRule_closure6: function _EvaluateVisitor_visitForRule_closure6(t0) {
                this.fromNumber = t0;
            },
            _EvaluateVisitor_visitForRule_closure7: function _EvaluateVisitor_visitForRule_closure7(t0, t1) {
                this.toNumber = t0;
                this.fromNumber = t1;
            },
            _EvaluateVisitor_visitForRule_closure8: function _EvaluateVisitor_visitForRule_closure8(t0, t1, t2, t3, t4, t5) {
                var _ = this;
                _._box_0 = t0;
                _.$this = t1;
                _.node = t2;
                _.from = t3;
                _.direction = t4;
                _.fromNumber = t5;
            },
            _EvaluateVisitor_visitForRule__closure0: function _EvaluateVisitor_visitForRule__closure0(t0) {
                this.$this = t0;
            },
            _EvaluateVisitor_visitForwardRule_closure1: function _EvaluateVisitor_visitForwardRule_closure1(t0, t1) {
                this.$this = t0;
                this.node = t1;
            },
            _EvaluateVisitor_visitForwardRule_closure2: function _EvaluateVisitor_visitForwardRule_closure2(t0, t1) {
                this.$this = t0;
                this.node = t1;
            },
            _EvaluateVisitor__registerCommentsForModule_closure0: function _EvaluateVisitor__registerCommentsForModule_closure0() {},
            _EvaluateVisitor_visitIfRule_closure0: function _EvaluateVisitor_visitIfRule_closure0(t0) {
                this.$this = t0;
            },
            _EvaluateVisitor_visitIfRule__closure0: function _EvaluateVisitor_visitIfRule__closure0(t0, t1) {
                this.$this = t0;
                this.clause = t1;
            },
            _EvaluateVisitor_visitIfRule___closure0: function _EvaluateVisitor_visitIfRule___closure0(t0) {
                this.$this = t0;
            },
            _EvaluateVisitor__visitDynamicImport_closure0: function _EvaluateVisitor__visitDynamicImport_closure0(t0, t1) {
                this.$this = t0;
                this.$import = t1;
            },
            _EvaluateVisitor__visitDynamicImport__closure3: function _EvaluateVisitor__visitDynamicImport__closure3(t0) {
                this.$this = t0;
            },
            _EvaluateVisitor__visitDynamicImport__closure4: function _EvaluateVisitor__visitDynamicImport__closure4() {},
            _EvaluateVisitor__visitDynamicImport__closure5: function _EvaluateVisitor__visitDynamicImport__closure5() {},
            _EvaluateVisitor__visitDynamicImport__closure6: function _EvaluateVisitor__visitDynamicImport__closure6(t0, t1, t2, t3, t4) {
                var _ = this;
                _._box_0 = t0;
                _.$this = t1;
                _.loadsUserDefinedModules = t2;
                _.environment = t3;
                _.children = t4;
            },
            _EvaluateVisitor__applyMixin_closure1: function _EvaluateVisitor__applyMixin_closure1(t0, t1, t2, t3) {
                var _ = this;
                _.$this = t0;
                _.$arguments = t1;
                _.mixin = t2;
                _.nodeWithSpanWithoutContent = t3;
            },
            _EvaluateVisitor__applyMixin__closure2: function _EvaluateVisitor__applyMixin__closure2(t0, t1, t2, t3) {
                var _ = this;
                _.$this = t0;
                _.$arguments = t1;
                _.mixin = t2;
                _.nodeWithSpanWithoutContent = t3;
            },
            _EvaluateVisitor__applyMixin_closure2: function _EvaluateVisitor__applyMixin_closure2(t0, t1, t2, t3) {
                var _ = this;
                _.$this = t0;
                _.contentCallable = t1;
                _.mixin = t2;
                _.nodeWithSpanWithoutContent = t3;
            },
            _EvaluateVisitor__applyMixin__closure1: function _EvaluateVisitor__applyMixin__closure1(t0, t1, t2) {
                this.$this = t0;
                this.mixin = t1;
                this.nodeWithSpanWithoutContent = t2;
            },
            _EvaluateVisitor__applyMixin___closure0: function _EvaluateVisitor__applyMixin___closure0(t0, t1, t2) {
                this.$this = t0;
                this.mixin = t1;
                this.nodeWithSpanWithoutContent = t2;
            },
            _EvaluateVisitor__applyMixin____closure0: function _EvaluateVisitor__applyMixin____closure0(t0, t1) {
                this.$this = t0;
                this.statement = t1;
            },
            _EvaluateVisitor_visitIncludeRule_closure2: function _EvaluateVisitor_visitIncludeRule_closure2(t0, t1) {
                this.$this = t0;
                this.node = t1;
            },
            _EvaluateVisitor_visitIncludeRule_closure3: function _EvaluateVisitor_visitIncludeRule_closure3(t0) {
                this.$this = t0;
            },
            _EvaluateVisitor_visitIncludeRule_closure4: function _EvaluateVisitor_visitIncludeRule_closure4(t0) {
                this.node = t0;
            },
            _EvaluateVisitor_visitMediaRule_closure3: function _EvaluateVisitor_visitMediaRule_closure3(t0, t1) {
                this.$this = t0;
                this.node = t1;
            },
            _EvaluateVisitor_visitMediaRule_closure4: function _EvaluateVisitor_visitMediaRule_closure4(t0, t1) {
                this.$this = t0;
                this.queries = t1;
            },
            _EvaluateVisitor_visitMediaRule_closure5: function _EvaluateVisitor_visitMediaRule_closure5(t0, t1, t2, t3, t4) {
                var _ = this;
                _.$this = t0;
                _.mergedQueries = t1;
                _.queries = t2;
                _.mergedSources = t3;
                _.node = t4;
            },
            _EvaluateVisitor_visitMediaRule__closure0: function _EvaluateVisitor_visitMediaRule__closure0(t0, t1) {
                this.$this = t0;
                this.node = t1;
            },
            _EvaluateVisitor_visitMediaRule___closure0: function _EvaluateVisitor_visitMediaRule___closure0(t0, t1) {
                this.$this = t0;
                this.node = t1;
            },
            _EvaluateVisitor_visitMediaRule_closure6: function _EvaluateVisitor_visitMediaRule_closure6(t0) {
                this.mergedSources = t0;
            },
            _EvaluateVisitor_visitStyleRule_closure3: function _EvaluateVisitor_visitStyleRule_closure3(t0, t1) {
                this.$this = t0;
                this.node = t1;
            },
            _EvaluateVisitor_visitStyleRule_closure4: function _EvaluateVisitor_visitStyleRule_closure4() {},
            _EvaluateVisitor_visitStyleRule_closure6: function _EvaluateVisitor_visitStyleRule_closure6(t0, t1, t2) {
                this.$this = t0;
                this.rule = t1;
                this.node = t2;
            },
            _EvaluateVisitor_visitStyleRule__closure0: function _EvaluateVisitor_visitStyleRule__closure0(t0, t1) {
                this.$this = t0;
                this.node = t1;
            },
            _EvaluateVisitor_visitStyleRule_closure5: function _EvaluateVisitor_visitStyleRule_closure5() {},
            _EvaluateVisitor__warnForBogusCombinators_closure0: function _EvaluateVisitor__warnForBogusCombinators_closure0() {},
            _EvaluateVisitor_visitSupportsRule_closure2: function _EvaluateVisitor_visitSupportsRule_closure2(t0, t1) {
                this.$this = t0;
                this.node = t1;
            },
            _EvaluateVisitor_visitSupportsRule_closure3: function _EvaluateVisitor_visitSupportsRule_closure3(t0, t1) {
                this.$this = t0;
                this.node = t1;
            },
            _EvaluateVisitor_visitSupportsRule__closure0: function _EvaluateVisitor_visitSupportsRule__closure0(t0, t1) {
                this.$this = t0;
                this.node = t1;
            },
            _EvaluateVisitor_visitSupportsRule_closure4: function _EvaluateVisitor_visitSupportsRule_closure4() {},
            _EvaluateVisitor__visitSupportsCondition_closure0: function _EvaluateVisitor__visitSupportsCondition_closure0(t0, t1) {
                this._box_0 = t0;
                this.$this = t1;
            },
            _EvaluateVisitor_visitVariableDeclaration_closure2: function _EvaluateVisitor_visitVariableDeclaration_closure2(t0, t1, t2) {
                this._box_0 = t0;
                this.$this = t1;
                this.node = t2;
            },
            _EvaluateVisitor_visitVariableDeclaration_closure3: function _EvaluateVisitor_visitVariableDeclaration_closure3(t0, t1) {
                this.$this = t0;
                this.node = t1;
            },
            _EvaluateVisitor_visitVariableDeclaration_closure4: function _EvaluateVisitor_visitVariableDeclaration_closure4(t0, t1, t2) {
                this.$this = t0;
                this.node = t1;
                this.value = t2;
            },
            _EvaluateVisitor_visitUseRule_closure0: function _EvaluateVisitor_visitUseRule_closure0(t0, t1) {
                this.$this = t0;
                this.node = t1;
            },
            _EvaluateVisitor_visitWarnRule_closure0: function _EvaluateVisitor_visitWarnRule_closure0(t0, t1) {
                this.$this = t0;
                this.node = t1;
            },
            _EvaluateVisitor_visitWhileRule_closure0: function _EvaluateVisitor_visitWhileRule_closure0(t0, t1) {
                this.$this = t0;
                this.node = t1;
            },
            _EvaluateVisitor_visitWhileRule__closure0: function _EvaluateVisitor_visitWhileRule__closure0(t0) {
                this.$this = t0;
            },
            _EvaluateVisitor_visitBinaryOperationExpression_closure0: function _EvaluateVisitor_visitBinaryOperationExpression_closure0(t0, t1) {
                this.$this = t0;
                this.node = t1;
            },
            _EvaluateVisitor__slash_recommendation0: function _EvaluateVisitor__slash_recommendation0() {},
            _EvaluateVisitor_visitVariableExpression_closure0: function _EvaluateVisitor_visitVariableExpression_closure0(t0, t1) {
                this.$this = t0;
                this.node = t1;
            },
            _EvaluateVisitor_visitUnaryOperationExpression_closure0: function _EvaluateVisitor_visitUnaryOperationExpression_closure0(t0, t1) {
                this.node = t0;
                this.operand = t1;
            },
            _EvaluateVisitor_visitIfExpression_closure0: function _EvaluateVisitor_visitIfExpression_closure0() {},
            _EvaluateVisitor_visitIfConditionOperation_closure0: function _EvaluateVisitor_visitIfConditionOperation_closure0() {},
            _EvaluateVisitor_visitListExpression_closure0: function _EvaluateVisitor_visitListExpression_closure0(t0) {
                this.$this = t0;
            },
            _EvaluateVisitor_visitFunctionExpression_closure2: function _EvaluateVisitor_visitFunctionExpression_closure2(t0, t1) {
                this.$this = t0;
                this.node = t1;
            },
            _EvaluateVisitor_visitFunctionExpression_closure3: function _EvaluateVisitor_visitFunctionExpression_closure3() {},
            _EvaluateVisitor_visitFunctionExpression_closure4: function _EvaluateVisitor_visitFunctionExpression_closure4(t0, t1, t2) {
                this._box_0 = t0;
                this.$this = t1;
                this.node = t2;
            },
            _EvaluateVisitor__visitCalculation_closure0: function _EvaluateVisitor__visitCalculation_closure0(t0, t1) {
                this.$this = t0;
                this.node = t1;
            },
            _EvaluateVisitor__checkCalculationArguments_check0: function _EvaluateVisitor__checkCalculationArguments_check0(t0, t1) {
                this.$this = t0;
                this.node = t1;
            },
            _EvaluateVisitor__visitCalculationExpression_closure0: function _EvaluateVisitor__visitCalculationExpression_closure0(t0, t1, t2, t3) {
                var _ = this;
                _._box_0 = t0;
                _.$this = t1;
                _.node = t2;
                _.inLegacySassFunction = t3;
            },
            _EvaluateVisitor__visitCalculationExpression__closure0: function _EvaluateVisitor__visitCalculationExpression__closure0(t0, t1) {
                this.$this = t0;
                this.node = t1;
            },
            _EvaluateVisitor_visitInterpolatedFunctionExpression_closure0: function _EvaluateVisitor_visitInterpolatedFunctionExpression_closure0(t0, t1, t2) {
                this.$this = t0;
                this.node = t1;
                this.$function = t2;
            },
            _EvaluateVisitor__runUserDefinedCallable_closure0: function _EvaluateVisitor__runUserDefinedCallable_closure0(t0, t1, t2, t3, t4, t5) {
                var _ = this;
                _.$this = t0;
                _.callable = t1;
                _.evaluated = t2;
                _.nodeWithSpan = t3;
                _.run = t4;
                _.V = t5;
            },
            _EvaluateVisitor__runUserDefinedCallable__closure0: function _EvaluateVisitor__runUserDefinedCallable__closure0(t0, t1, t2, t3, t4, t5) {
                var _ = this;
                _.$this = t0;
                _.evaluated = t1;
                _.callable = t2;
                _.nodeWithSpan = t3;
                _.run = t4;
                _.V = t5;
            },
            _EvaluateVisitor__runUserDefinedCallable___closure0: function _EvaluateVisitor__runUserDefinedCallable___closure0(t0, t1, t2, t3, t4, t5) {
                var _ = this;
                _.$this = t0;
                _.evaluated = t1;
                _.callable = t2;
                _.nodeWithSpan = t3;
                _.run = t4;
                _.V = t5;
            },
            _EvaluateVisitor__runUserDefinedCallable____closure0: function _EvaluateVisitor__runUserDefinedCallable____closure0() {},
            _EvaluateVisitor__runFunctionCallable_closure0: function _EvaluateVisitor__runFunctionCallable_closure0(t0, t1) {
                this.$this = t0;
                this.callable = t1;
            },
            _EvaluateVisitor__runBuiltInCallable_closure2: function _EvaluateVisitor__runBuiltInCallable_closure2(t0, t1, t2) {
                this._box_0 = t0;
                this.evaluated = t1;
                this.namedSet = t2;
            },
            _EvaluateVisitor__runBuiltInCallable_closure3: function _EvaluateVisitor__runBuiltInCallable_closure3(t0, t1) {
                this._box_0 = t0;
                this.evaluated = t1;
            },
            _EvaluateVisitor__runBuiltInCallable_closure4: function _EvaluateVisitor__runBuiltInCallable_closure4() {},
            _EvaluateVisitor__evaluateArguments_closure3: function _EvaluateVisitor__evaluateArguments_closure3() {},
            _EvaluateVisitor__evaluateArguments_closure4: function _EvaluateVisitor__evaluateArguments_closure4(t0, t1) {
                this.$this = t0;
                this.restNodeForSpan = t1;
            },
            _EvaluateVisitor__evaluateArguments_closure5: function _EvaluateVisitor__evaluateArguments_closure5(t0, t1, t2, t3) {
                var _ = this;
                _.$this = t0;
                _.named = t1;
                _.restNodeForSpan = t2;
                _.namedNodes = t3;
            },
            _EvaluateVisitor__evaluateArguments_closure6: function _EvaluateVisitor__evaluateArguments_closure6() {},
            _EvaluateVisitor__evaluateMacroArguments_closure3: function _EvaluateVisitor__evaluateMacroArguments_closure3(t0) {
                this.restArgs = t0;
            },
            _EvaluateVisitor__evaluateMacroArguments_closure4: function _EvaluateVisitor__evaluateMacroArguments_closure4(t0, t1, t2) {
                this.$this = t0;
                this.restNodeForSpan = t1;
                this.restArgs = t2;
            },
            _EvaluateVisitor__evaluateMacroArguments_closure5: function _EvaluateVisitor__evaluateMacroArguments_closure5(t0, t1, t2, t3) {
                var _ = this;
                _.$this = t0;
                _.named = t1;
                _.restNodeForSpan = t2;
                _.restArgs = t3;
            },
            _EvaluateVisitor__evaluateMacroArguments_closure6: function _EvaluateVisitor__evaluateMacroArguments_closure6(t0, t1, t2) {
                this.$this = t0;
                this.keywordRestNodeForSpan = t1;
                this.keywordRestArgs = t2;
            },
            _EvaluateVisitor__addRestMap_closure0: function _EvaluateVisitor__addRestMap_closure0(t0, t1, t2, t3, t4, t5) {
                var _ = this;
                _.$this = t0;
                _.values = t1;
                _.convert = t2;
                _.expressionNode = t3;
                _.map = t4;
                _.nodeWithSpan = t5;
            },
            _EvaluateVisitor__verifyArguments_closure0: function _EvaluateVisitor__verifyArguments_closure0(t0, t1, t2) {
                this.parameters = t0;
                this.positional = t1;
                this.named = t2;
            },
            _EvaluateVisitor_visitCssAtRule_closure2: function _EvaluateVisitor_visitCssAtRule_closure2(t0, t1) {
                this.$this = t0;
                this.node = t1;
            },
            _EvaluateVisitor_visitCssAtRule_closure3: function _EvaluateVisitor_visitCssAtRule_closure3(t0, t1) {
                this.$this = t0;
                this.node = t1;
            },
            _EvaluateVisitor_visitCssAtRule_closure4: function _EvaluateVisitor_visitCssAtRule_closure4() {},
            _EvaluateVisitor_visitCssKeyframeBlock_closure1: function _EvaluateVisitor_visitCssKeyframeBlock_closure1(t0, t1) {
                this.$this = t0;
                this.node = t1;
            },
            _EvaluateVisitor_visitCssKeyframeBlock_closure2: function _EvaluateVisitor_visitCssKeyframeBlock_closure2() {},
            _EvaluateVisitor_visitCssMediaRule_closure3: function _EvaluateVisitor_visitCssMediaRule_closure3(t0, t1) {
                this.$this = t0;
                this.node = t1;
            },
            _EvaluateVisitor_visitCssMediaRule_closure4: function _EvaluateVisitor_visitCssMediaRule_closure4(t0, t1) {
                this.$this = t0;
                this.node = t1;
            },
            _EvaluateVisitor_visitCssMediaRule_closure5: function _EvaluateVisitor_visitCssMediaRule_closure5(t0, t1, t2, t3) {
                var _ = this;
                _.$this = t0;
                _.mergedQueries = t1;
                _.node = t2;
                _.mergedSources = t3;
            },
            _EvaluateVisitor_visitCssMediaRule__closure0: function _EvaluateVisitor_visitCssMediaRule__closure0(t0, t1) {
                this.$this = t0;
                this.node = t1;
            },
            _EvaluateVisitor_visitCssMediaRule___closure0: function _EvaluateVisitor_visitCssMediaRule___closure0(t0, t1) {
                this.$this = t0;
                this.node = t1;
            },
            _EvaluateVisitor_visitCssMediaRule_closure6: function _EvaluateVisitor_visitCssMediaRule_closure6(t0) {
                this.mergedSources = t0;
            },
            _EvaluateVisitor_visitCssStyleRule_closure2: function _EvaluateVisitor_visitCssStyleRule_closure2(t0, t1, t2) {
                this.$this = t0;
                this.rule = t1;
                this.node = t2;
            },
            _EvaluateVisitor_visitCssStyleRule__closure0: function _EvaluateVisitor_visitCssStyleRule__closure0(t0, t1) {
                this.$this = t0;
                this.node = t1;
            },
            _EvaluateVisitor_visitCssStyleRule_closure1: function _EvaluateVisitor_visitCssStyleRule_closure1() {},
            _EvaluateVisitor_visitCssSupportsRule_closure2: function _EvaluateVisitor_visitCssSupportsRule_closure2(t0, t1) {
                this.$this = t0;
                this.node = t1;
            },
            _EvaluateVisitor_visitCssSupportsRule_closure3: function _EvaluateVisitor_visitCssSupportsRule_closure3(t0, t1) {
                this.$this = t0;
                this.node = t1;
            },
            _EvaluateVisitor_visitCssSupportsRule__closure0: function _EvaluateVisitor_visitCssSupportsRule__closure0(t0, t1) {
                this.$this = t0;
                this.node = t1;
            },
            _EvaluateVisitor_visitCssSupportsRule_closure4: function _EvaluateVisitor_visitCssSupportsRule_closure4() {},
            _EvaluateVisitor__performInterpolationHelper_closure0: function _EvaluateVisitor__performInterpolationHelper_closure0(t0) {
                this.interpolation = t0;
            },
            _EvaluateVisitor__serialize_closure0: function _EvaluateVisitor__serialize_closure0(t0, t1) {
                this.value = t0;
                this.quote = t1;
            },
            _EvaluateVisitor__expressionNode_closure0: function _EvaluateVisitor__expressionNode_closure0(t0, t1) {
                this.$this = t0;
                this.expression = t1;
            },
            _EvaluateVisitor__withoutSlash_recommendation0: function _EvaluateVisitor__withoutSlash_recommendation0() {},
            _EvaluateVisitor__stackFrame_closure0: function _EvaluateVisitor__stackFrame_closure0(t0) {
                this.$this = t0;
            },
            _ImportedCssVisitor0: function _ImportedCssVisitor0(t0) {
                this._async_evaluate$_visitor = t0;
            },
            _ImportedCssVisitor_visitCssAtRule_closure0: function _ImportedCssVisitor_visitCssAtRule_closure0() {},
            _ImportedCssVisitor_visitCssMediaRule_closure0: function _ImportedCssVisitor_visitCssMediaRule_closure0(t0) {
                this.hasBeenMerged = t0;
            },
            _ImportedCssVisitor_visitCssStyleRule_closure0: function _ImportedCssVisitor_visitCssStyleRule_closure0() {},
            _ImportedCssVisitor_visitCssSupportsRule_closure0: function _ImportedCssVisitor_visitCssSupportsRule_closure0() {},
            _EvaluationContext0: function _EvaluationContext0(t0, t1) {
                this._async_evaluate$_visitor = t0;
                this._async_evaluate$_defaultWarnNodeWithSpan = t1;
            },
            cloneCssStylesheet: function(stylesheet, extensionStore) {
                var _0_0 = extensionStore.clone$0();
                return new A._Record_2(new A._CloneCssVisitor(_0_0._1)._visitChildren$2(A.ModifiableCssStylesheet$(stylesheet.get$span(stylesheet)), stylesheet), _0_0._0);
            },
            _CloneCssVisitor: function _CloneCssVisitor(t0) {
                this._oldToNewSelectors = t0;
            },
            _EvaluateVisitor$: function(functions, importCache, logger, nodeImporter, quietDeps, sourceMap) {
                var t1 = type$.Uri, t2 = type$.Module_Callable, t3 = A._setArrayType([], type$.JSArray_Record_2_String_and_AstNode);
                t1 = new A._EvaluateVisitor(importCache, nodeImporter, A.LinkedHashMap_LinkedHashMap$_empty(type$.String, type$.Callable), A.LinkedHashMap_LinkedHashMap$_empty(t1, t2), A.LinkedHashMap_LinkedHashMap$_empty(t1, t2), A.LinkedHashMap_LinkedHashMap$_empty(t1, type$.Configuration), A.LinkedHashMap_LinkedHashMap$_empty(t1, type$.AstNode), logger, A.LinkedHashSet_LinkedHashSet$_empty(type$.Record_2_String_and_SourceSpan), quietDeps, sourceMap, new A.Object(), A.Environment$(), A.LinkedHashSet_LinkedHashSet$_empty(t1), A.LinkedHashMap_LinkedHashMap$_empty(t1, type$.nullable_AstNode), t3, B.Configuration_Map_empty_null);
                t1._EvaluateVisitor$6$functions$importCache$logger$nodeImporter$quietDeps$sourceMap(functions, importCache, logger, nodeImporter, quietDeps, sourceMap);
                return t1;
            },
            Evaluator: function Evaluator(t0, t1) {
                this._visitor = t0;
                this._importer = t1;
            },
            _EvaluateVisitor: function _EvaluateVisitor(t0, t1, t2, t3, t4, t5, t6, t7, t8, t9, t10, t11, t12, t13, t14, t15, t16) {
                var _ = this;
                _._evaluate$_importCache = t0;
                _._evaluate$_nodeImporter = t1;
                _._builtInFunctions = t2;
                _._builtInModules = t3;
                _._modules = t4;
                _._moduleConfigurations = t5;
                _._moduleNodes = t6;
                _._logger = t7;
                _._warningsEmitted = t8;
                _._quietDeps = t9;
                _._sourceMap = t10;
                _._compileContext = t11;
                _._environment = t12;
                _._declarationName = _.__parent = _._mediaQuerySources = _._mediaQueries = _._styleRuleIgnoringAtRoot = null;
                _._member = "root stylesheet";
                _._importSpan = _._callableNode = null;
                _._inSupportsDeclaration = _._inKeyframes = _._atRootExcludingStyleRule = _._inUnknownAtRule = _._inFunction = false;
                _._loadedUrls = t13;
                _._activeModules = t14;
                _._stack = t15;
                _._importer = null;
                _._inDependency = false;
                _.__extensionStore = _._preModuleComments = _._outOfOrderImports = _.__endOfImports = _.__root = _.__stylesheet = null;
                _._configuration = t16;
            },
            _EvaluateVisitor_closure: function _EvaluateVisitor_closure(t0) {
                this.$this = t0;
            },
            _EvaluateVisitor_closure0: function _EvaluateVisitor_closure0(t0) {
                this.$this = t0;
            },
            _EvaluateVisitor_closure1: function _EvaluateVisitor_closure1(t0) {
                this.$this = t0;
            },
            _EvaluateVisitor_closure2: function _EvaluateVisitor_closure2(t0) {
                this.$this = t0;
            },
            _EvaluateVisitor_closure3: function _EvaluateVisitor_closure3(t0) {
                this.$this = t0;
            },
            _EvaluateVisitor_closure4: function _EvaluateVisitor_closure4(t0) {
                this.$this = t0;
            },
            _EvaluateVisitor_closure5: function _EvaluateVisitor_closure5(t0) {
                this.$this = t0;
            },
            _EvaluateVisitor_closure6: function _EvaluateVisitor_closure6(t0) {
                this.$this = t0;
            },
            _EvaluateVisitor_closure7: function _EvaluateVisitor_closure7(t0) {
                this.$this = t0;
            },
            _EvaluateVisitor__closure2: function _EvaluateVisitor__closure2(t0, t1, t2) {
                this.$this = t0;
                this.name = t1;
                this.module = t2;
            },
            _EvaluateVisitor_closure8: function _EvaluateVisitor_closure8(t0) {
                this.$this = t0;
            },
            _EvaluateVisitor__closure1: function _EvaluateVisitor__closure1(t0, t1, t2) {
                this.$this = t0;
                this.name = t1;
                this.module = t2;
            },
            _EvaluateVisitor_closure9: function _EvaluateVisitor_closure9(t0) {
                this.$this = t0;
            },
            _EvaluateVisitor_closure10: function _EvaluateVisitor_closure10(t0) {
                this.$this = t0;
            },
            _EvaluateVisitor__closure: function _EvaluateVisitor__closure(t0, t1, t2, t3) {
                var _ = this;
                _._box_0 = t0;
                _.values = t1;
                _.span = t2;
                _.callableNode = t3;
            },
            _EvaluateVisitor__closure0: function _EvaluateVisitor__closure0(t0) {
                this.$this = t0;
            },
            _EvaluateVisitor_closure11: function _EvaluateVisitor_closure11(t0) {
                this.$this = t0;
            },
            _EvaluateVisitor_run_closure: function _EvaluateVisitor_run_closure(t0, t1, t2) {
                this.$this = t0;
                this.node = t1;
                this.importer = t2;
            },
            _EvaluateVisitor_run__closure: function _EvaluateVisitor_run__closure(t0, t1, t2) {
                this.$this = t0;
                this.importer = t1;
                this.node = t2;
            },
            _EvaluateVisitor_runExpression_closure: function _EvaluateVisitor_runExpression_closure(t0, t1, t2) {
                this.$this = t0;
                this.importer = t1;
                this.expression = t2;
            },
            _EvaluateVisitor_runExpression__closure: function _EvaluateVisitor_runExpression__closure(t0, t1) {
                this.$this = t0;
                this.expression = t1;
            },
            _EvaluateVisitor_runExpression___closure: function _EvaluateVisitor_runExpression___closure(t0, t1) {
                this.$this = t0;
                this.expression = t1;
            },
            _EvaluateVisitor_runStatement_closure: function _EvaluateVisitor_runStatement_closure(t0, t1, t2) {
                this.$this = t0;
                this.importer = t1;
                this.statement = t2;
            },
            _EvaluateVisitor_runStatement__closure: function _EvaluateVisitor_runStatement__closure(t0, t1) {
                this.$this = t0;
                this.statement = t1;
            },
            _EvaluateVisitor_runStatement___closure: function _EvaluateVisitor_runStatement___closure(t0, t1) {
                this.$this = t0;
                this.statement = t1;
            },
            _EvaluateVisitor__loadModule_closure: function _EvaluateVisitor__loadModule_closure(t0, t1) {
                this._box_0 = t0;
                this.callback = t1;
            },
            _EvaluateVisitor__loadModule_closure0: function _EvaluateVisitor__loadModule_closure0(t0, t1, t2, t3, t4, t5, t6) {
                var _ = this;
                _.$this = t0;
                _.url = t1;
                _.nodeWithSpan = t2;
                _.baseUrl = t3;
                _.namesInErrors = t4;
                _.configuration = t5;
                _.callback = t6;
            },
            _EvaluateVisitor__loadModule__closure: function _EvaluateVisitor__loadModule__closure(t0, t1) {
                this.$this = t0;
                this.message = t1;
            },
            _EvaluateVisitor__loadModule__closure0: function _EvaluateVisitor__loadModule__closure0(t0, t1, t2) {
                this._box_1 = t0;
                this.callback = t1;
                this.firstLoad = t2;
            },
            _EvaluateVisitor__execute_closure: function _EvaluateVisitor__execute_closure(t0, t1, t2, t3, t4, t5, t6) {
                var _ = this;
                _.$this = t0;
                _.importer = t1;
                _.stylesheet = t2;
                _.extensionStore = t3;
                _.configuration = t4;
                _.css = t5;
                _.preModuleComments = t6;
            },
            _EvaluateVisitor__combineCss_closure: function _EvaluateVisitor__combineCss_closure() {},
            _EvaluateVisitor__combineCss_closure0: function _EvaluateVisitor__combineCss_closure0(t0) {
                this.selectors = t0;
            },
            _EvaluateVisitor__combineCss_visitModule: function _EvaluateVisitor__combineCss_visitModule(t0, t1, t2, t3, t4, t5) {
                var _ = this;
                _.$this = t0;
                _.seen = t1;
                _.clone = t2;
                _.css = t3;
                _.imports = t4;
                _.sorted = t5;
            },
            _EvaluateVisitor__extendModules_closure: function _EvaluateVisitor__extendModules_closure(t0) {
                this.originalSelectors = t0;
            },
            _EvaluateVisitor__extendModules_closure0: function _EvaluateVisitor__extendModules_closure0() {},
            _EvaluateVisitor_visitAtRootRule_closure: function _EvaluateVisitor_visitAtRootRule_closure(t0, t1) {
                this.$this = t0;
                this.node = t1;
            },
            _EvaluateVisitor_visitAtRootRule_closure0: function _EvaluateVisitor_visitAtRootRule_closure0(t0, t1) {
                this.$this = t0;
                this.node = t1;
            },
            _EvaluateVisitor__scopeForAtRoot_closure: function _EvaluateVisitor__scopeForAtRoot_closure(t0, t1, t2) {
                this.$this = t0;
                this.newParent = t1;
                this.node = t2;
            },
            _EvaluateVisitor__scopeForAtRoot_closure0: function _EvaluateVisitor__scopeForAtRoot_closure0(t0, t1) {
                this.$this = t0;
                this.innerScope = t1;
            },
            _EvaluateVisitor__scopeForAtRoot_closure1: function _EvaluateVisitor__scopeForAtRoot_closure1(t0, t1) {
                this.$this = t0;
                this.innerScope = t1;
            },
            _EvaluateVisitor__scopeForAtRoot__closure: function _EvaluateVisitor__scopeForAtRoot__closure(t0, t1) {
                this.innerScope = t0;
                this.callback = t1;
            },
            _EvaluateVisitor__scopeForAtRoot_closure2: function _EvaluateVisitor__scopeForAtRoot_closure2(t0, t1) {
                this.$this = t0;
                this.innerScope = t1;
            },
            _EvaluateVisitor__scopeForAtRoot_closure3: function _EvaluateVisitor__scopeForAtRoot_closure3() {},
            _EvaluateVisitor__scopeForAtRoot_closure4: function _EvaluateVisitor__scopeForAtRoot_closure4(t0, t1) {
                this.$this = t0;
                this.innerScope = t1;
            },
            _EvaluateVisitor_visitContentRule_closure: function _EvaluateVisitor_visitContentRule_closure(t0, t1) {
                this.$this = t0;
                this.content = t1;
            },
            _EvaluateVisitor_visitDeclaration_closure: function _EvaluateVisitor_visitDeclaration_closure(t0, t1) {
                this._box_0 = t0;
                this.$this = t1;
            },
            _EvaluateVisitor_visitEachRule_closure: function _EvaluateVisitor_visitEachRule_closure(t0, t1, t2) {
                this._box_0 = t0;
                this.$this = t1;
                this.nodeWithSpan = t2;
            },
            _EvaluateVisitor_visitEachRule_closure0: function _EvaluateVisitor_visitEachRule_closure0(t0, t1, t2) {
                this._box_1 = t0;
                this.$this = t1;
                this.nodeWithSpan = t2;
            },
            _EvaluateVisitor_visitEachRule_closure1: function _EvaluateVisitor_visitEachRule_closure1(t0, t1, t2, t3) {
                var _ = this;
                _.$this = t0;
                _.list = t1;
                _.setVariables = t2;
                _.node = t3;
            },
            _EvaluateVisitor_visitEachRule__closure: function _EvaluateVisitor_visitEachRule__closure(t0, t1, t2) {
                this.$this = t0;
                this.setVariables = t1;
                this.node = t2;
            },
            _EvaluateVisitor_visitEachRule___closure: function _EvaluateVisitor_visitEachRule___closure(t0) {
                this.$this = t0;
            },
            _EvaluateVisitor_visitAtRule_closure: function _EvaluateVisitor_visitAtRule_closure(t0) {
                this.$this = t0;
            },
            _EvaluateVisitor_visitAtRule_closure0: function _EvaluateVisitor_visitAtRule_closure0(t0, t1) {
                this.$this = t0;
                this.children = t1;
            },
            _EvaluateVisitor_visitAtRule_closure1: function _EvaluateVisitor_visitAtRule_closure1(t0, t1, t2) {
                this.$this = t0;
                this.name = t1;
                this.children = t2;
            },
            _EvaluateVisitor_visitAtRule__closure: function _EvaluateVisitor_visitAtRule__closure(t0, t1) {
                this.$this = t0;
                this.children = t1;
            },
            _EvaluateVisitor_visitAtRule_closure2: function _EvaluateVisitor_visitAtRule_closure2() {},
            _EvaluateVisitor_visitForRule_closure: function _EvaluateVisitor_visitForRule_closure(t0, t1) {
                this.$this = t0;
                this.node = t1;
            },
            _EvaluateVisitor_visitForRule_closure0: function _EvaluateVisitor_visitForRule_closure0(t0, t1) {
                this.$this = t0;
                this.node = t1;
            },
            _EvaluateVisitor_visitForRule_closure1: function _EvaluateVisitor_visitForRule_closure1(t0) {
                this.fromNumber = t0;
            },
            _EvaluateVisitor_visitForRule_closure2: function _EvaluateVisitor_visitForRule_closure2(t0, t1) {
                this.toNumber = t0;
                this.fromNumber = t1;
            },
            _EvaluateVisitor_visitForRule_closure3: function _EvaluateVisitor_visitForRule_closure3(t0, t1, t2, t3, t4, t5) {
                var _ = this;
                _._box_0 = t0;
                _.$this = t1;
                _.node = t2;
                _.from = t3;
                _.direction = t4;
                _.fromNumber = t5;
            },
            _EvaluateVisitor_visitForRule__closure: function _EvaluateVisitor_visitForRule__closure(t0) {
                this.$this = t0;
            },
            _EvaluateVisitor_visitForwardRule_closure: function _EvaluateVisitor_visitForwardRule_closure(t0, t1) {
                this.$this = t0;
                this.node = t1;
            },
            _EvaluateVisitor_visitForwardRule_closure0: function _EvaluateVisitor_visitForwardRule_closure0(t0, t1) {
                this.$this = t0;
                this.node = t1;
            },
            _EvaluateVisitor__registerCommentsForModule_closure: function _EvaluateVisitor__registerCommentsForModule_closure() {},
            _EvaluateVisitor_visitIfRule_closure: function _EvaluateVisitor_visitIfRule_closure(t0) {
                this.$this = t0;
            },
            _EvaluateVisitor_visitIfRule__closure: function _EvaluateVisitor_visitIfRule__closure(t0, t1) {
                this.$this = t0;
                this.clause = t1;
            },
            _EvaluateVisitor_visitIfRule___closure: function _EvaluateVisitor_visitIfRule___closure(t0) {
                this.$this = t0;
            },
            _EvaluateVisitor__visitDynamicImport_closure: function _EvaluateVisitor__visitDynamicImport_closure(t0, t1) {
                this.$this = t0;
                this.$import = t1;
            },
            _EvaluateVisitor__visitDynamicImport__closure: function _EvaluateVisitor__visitDynamicImport__closure(t0) {
                this.$this = t0;
            },
            _EvaluateVisitor__visitDynamicImport__closure0: function _EvaluateVisitor__visitDynamicImport__closure0() {},
            _EvaluateVisitor__visitDynamicImport__closure1: function _EvaluateVisitor__visitDynamicImport__closure1() {},
            _EvaluateVisitor__visitDynamicImport__closure2: function _EvaluateVisitor__visitDynamicImport__closure2(t0, t1, t2, t3, t4) {
                var _ = this;
                _._box_0 = t0;
                _.$this = t1;
                _.loadsUserDefinedModules = t2;
                _.environment = t3;
                _.children = t4;
            },
            _EvaluateVisitor__applyMixin_closure: function _EvaluateVisitor__applyMixin_closure(t0, t1, t2, t3) {
                var _ = this;
                _.$this = t0;
                _.$arguments = t1;
                _.mixin = t2;
                _.nodeWithSpanWithoutContent = t3;
            },
            _EvaluateVisitor__applyMixin__closure0: function _EvaluateVisitor__applyMixin__closure0(t0, t1, t2, t3) {
                var _ = this;
                _.$this = t0;
                _.$arguments = t1;
                _.mixin = t2;
                _.nodeWithSpanWithoutContent = t3;
            },
            _EvaluateVisitor__applyMixin_closure0: function _EvaluateVisitor__applyMixin_closure0(t0, t1, t2, t3) {
                var _ = this;
                _.$this = t0;
                _.contentCallable = t1;
                _.mixin = t2;
                _.nodeWithSpanWithoutContent = t3;
            },
            _EvaluateVisitor__applyMixin__closure: function _EvaluateVisitor__applyMixin__closure(t0, t1, t2) {
                this.$this = t0;
                this.mixin = t1;
                this.nodeWithSpanWithoutContent = t2;
            },
            _EvaluateVisitor__applyMixin___closure: function _EvaluateVisitor__applyMixin___closure(t0, t1, t2) {
                this.$this = t0;
                this.mixin = t1;
                this.nodeWithSpanWithoutContent = t2;
            },
            _EvaluateVisitor__applyMixin____closure: function _EvaluateVisitor__applyMixin____closure(t0, t1) {
                this.$this = t0;
                this.statement = t1;
            },
            _EvaluateVisitor_visitIncludeRule_closure: function _EvaluateVisitor_visitIncludeRule_closure(t0, t1) {
                this.$this = t0;
                this.node = t1;
            },
            _EvaluateVisitor_visitIncludeRule_closure0: function _EvaluateVisitor_visitIncludeRule_closure0(t0) {
                this.$this = t0;
            },
            _EvaluateVisitor_visitIncludeRule_closure1: function _EvaluateVisitor_visitIncludeRule_closure1(t0) {
                this.node = t0;
            },
            _EvaluateVisitor_visitMediaRule_closure: function _EvaluateVisitor_visitMediaRule_closure(t0, t1) {
                this.$this = t0;
                this.node = t1;
            },
            _EvaluateVisitor_visitMediaRule_closure0: function _EvaluateVisitor_visitMediaRule_closure0(t0, t1) {
                this.$this = t0;
                this.queries = t1;
            },
            _EvaluateVisitor_visitMediaRule_closure1: function _EvaluateVisitor_visitMediaRule_closure1(t0, t1, t2, t3, t4) {
                var _ = this;
                _.$this = t0;
                _.mergedQueries = t1;
                _.queries = t2;
                _.mergedSources = t3;
                _.node = t4;
            },
            _EvaluateVisitor_visitMediaRule__closure: function _EvaluateVisitor_visitMediaRule__closure(t0, t1) {
                this.$this = t0;
                this.node = t1;
            },
            _EvaluateVisitor_visitMediaRule___closure: function _EvaluateVisitor_visitMediaRule___closure(t0, t1) {
                this.$this = t0;
                this.node = t1;
            },
            _EvaluateVisitor_visitMediaRule_closure2: function _EvaluateVisitor_visitMediaRule_closure2(t0) {
                this.mergedSources = t0;
            },
            _EvaluateVisitor_visitStyleRule_closure: function _EvaluateVisitor_visitStyleRule_closure(t0, t1) {
                this.$this = t0;
                this.node = t1;
            },
            _EvaluateVisitor_visitStyleRule_closure0: function _EvaluateVisitor_visitStyleRule_closure0() {},
            _EvaluateVisitor_visitStyleRule_closure2: function _EvaluateVisitor_visitStyleRule_closure2(t0, t1, t2) {
                this.$this = t0;
                this.rule = t1;
                this.node = t2;
            },
            _EvaluateVisitor_visitStyleRule__closure: function _EvaluateVisitor_visitStyleRule__closure(t0, t1) {
                this.$this = t0;
                this.node = t1;
            },
            _EvaluateVisitor_visitStyleRule_closure1: function _EvaluateVisitor_visitStyleRule_closure1() {},
            _EvaluateVisitor__warnForBogusCombinators_closure: function _EvaluateVisitor__warnForBogusCombinators_closure() {},
            _EvaluateVisitor_visitSupportsRule_closure: function _EvaluateVisitor_visitSupportsRule_closure(t0, t1) {
                this.$this = t0;
                this.node = t1;
            },
            _EvaluateVisitor_visitSupportsRule_closure0: function _EvaluateVisitor_visitSupportsRule_closure0(t0, t1) {
                this.$this = t0;
                this.node = t1;
            },
            _EvaluateVisitor_visitSupportsRule__closure: function _EvaluateVisitor_visitSupportsRule__closure(t0, t1) {
                this.$this = t0;
                this.node = t1;
            },
            _EvaluateVisitor_visitSupportsRule_closure1: function _EvaluateVisitor_visitSupportsRule_closure1() {},
            _EvaluateVisitor__visitSupportsCondition_closure: function _EvaluateVisitor__visitSupportsCondition_closure(t0, t1) {
                this._box_0 = t0;
                this.$this = t1;
            },
            _EvaluateVisitor_visitVariableDeclaration_closure: function _EvaluateVisitor_visitVariableDeclaration_closure(t0, t1, t2) {
                this._box_0 = t0;
                this.$this = t1;
                this.node = t2;
            },
            _EvaluateVisitor_visitVariableDeclaration_closure0: function _EvaluateVisitor_visitVariableDeclaration_closure0(t0, t1) {
                this.$this = t0;
                this.node = t1;
            },
            _EvaluateVisitor_visitVariableDeclaration_closure1: function _EvaluateVisitor_visitVariableDeclaration_closure1(t0, t1, t2) {
                this.$this = t0;
                this.node = t1;
                this.value = t2;
            },
            _EvaluateVisitor_visitUseRule_closure: function _EvaluateVisitor_visitUseRule_closure(t0, t1) {
                this.$this = t0;
                this.node = t1;
            },
            _EvaluateVisitor_visitWarnRule_closure: function _EvaluateVisitor_visitWarnRule_closure(t0, t1) {
                this.$this = t0;
                this.node = t1;
            },
            _EvaluateVisitor_visitWhileRule_closure: function _EvaluateVisitor_visitWhileRule_closure(t0, t1) {
                this.$this = t0;
                this.node = t1;
            },
            _EvaluateVisitor_visitWhileRule__closure: function _EvaluateVisitor_visitWhileRule__closure(t0) {
                this.$this = t0;
            },
            _EvaluateVisitor_visitBinaryOperationExpression_closure: function _EvaluateVisitor_visitBinaryOperationExpression_closure(t0, t1) {
                this.$this = t0;
                this.node = t1;
            },
            _EvaluateVisitor__slash_recommendation: function _EvaluateVisitor__slash_recommendation() {},
            _EvaluateVisitor_visitVariableExpression_closure: function _EvaluateVisitor_visitVariableExpression_closure(t0, t1) {
                this.$this = t0;
                this.node = t1;
            },
            _EvaluateVisitor_visitUnaryOperationExpression_closure: function _EvaluateVisitor_visitUnaryOperationExpression_closure(t0, t1) {
                this.node = t0;
                this.operand = t1;
            },
            _EvaluateVisitor_visitIfExpression_closure: function _EvaluateVisitor_visitIfExpression_closure() {},
            _EvaluateVisitor_visitIfConditionOperation_closure: function _EvaluateVisitor_visitIfConditionOperation_closure() {},
            _EvaluateVisitor_visitListExpression_closure: function _EvaluateVisitor_visitListExpression_closure(t0) {
                this.$this = t0;
            },
            _EvaluateVisitor_visitFunctionExpression_closure: function _EvaluateVisitor_visitFunctionExpression_closure(t0, t1) {
                this.$this = t0;
                this.node = t1;
            },
            _EvaluateVisitor_visitFunctionExpression_closure0: function _EvaluateVisitor_visitFunctionExpression_closure0() {},
            _EvaluateVisitor_visitFunctionExpression_closure1: function _EvaluateVisitor_visitFunctionExpression_closure1(t0, t1, t2) {
                this._box_0 = t0;
                this.$this = t1;
                this.node = t2;
            },
            _EvaluateVisitor__visitCalculation_closure: function _EvaluateVisitor__visitCalculation_closure(t0, t1) {
                this.$this = t0;
                this.node = t1;
            },
            _EvaluateVisitor__checkCalculationArguments_check: function _EvaluateVisitor__checkCalculationArguments_check(t0, t1) {
                this.$this = t0;
                this.node = t1;
            },
            _EvaluateVisitor__visitCalculationExpression_closure: function _EvaluateVisitor__visitCalculationExpression_closure(t0, t1, t2, t3) {
                var _ = this;
                _._box_0 = t0;
                _.$this = t1;
                _.node = t2;
                _.inLegacySassFunction = t3;
            },
            _EvaluateVisitor__visitCalculationExpression__closure: function _EvaluateVisitor__visitCalculationExpression__closure(t0, t1) {
                this.$this = t0;
                this.node = t1;
            },
            _EvaluateVisitor_visitInterpolatedFunctionExpression_closure: function _EvaluateVisitor_visitInterpolatedFunctionExpression_closure(t0, t1, t2) {
                this.$this = t0;
                this.node = t1;
                this.$function = t2;
            },
            _EvaluateVisitor__runUserDefinedCallable_closure: function _EvaluateVisitor__runUserDefinedCallable_closure(t0, t1, t2, t3, t4, t5) {
                var _ = this;
                _.$this = t0;
                _.callable = t1;
                _.evaluated = t2;
                _.nodeWithSpan = t3;
                _.run = t4;
                _.V = t5;
            },
            _EvaluateVisitor__runUserDefinedCallable__closure: function _EvaluateVisitor__runUserDefinedCallable__closure(t0, t1, t2, t3, t4, t5) {
                var _ = this;
                _.$this = t0;
                _.evaluated = t1;
                _.callable = t2;
                _.nodeWithSpan = t3;
                _.run = t4;
                _.V = t5;
            },
            _EvaluateVisitor__runUserDefinedCallable___closure: function _EvaluateVisitor__runUserDefinedCallable___closure(t0, t1, t2, t3, t4, t5) {
                var _ = this;
                _.$this = t0;
                _.evaluated = t1;
                _.callable = t2;
                _.nodeWithSpan = t3;
                _.run = t4;
                _.V = t5;
            },
            _EvaluateVisitor__runUserDefinedCallable____closure: function _EvaluateVisitor__runUserDefinedCallable____closure() {},
            _EvaluateVisitor__runFunctionCallable_closure: function _EvaluateVisitor__runFunctionCallable_closure(t0, t1) {
                this.$this = t0;
                this.callable = t1;
            },
            _EvaluateVisitor__runBuiltInCallable_closure: function _EvaluateVisitor__runBuiltInCallable_closure(t0, t1, t2) {
                this._box_0 = t0;
                this.evaluated = t1;
                this.namedSet = t2;
            },
            _EvaluateVisitor__runBuiltInCallable_closure0: function _EvaluateVisitor__runBuiltInCallable_closure0(t0, t1) {
                this._box_0 = t0;
                this.evaluated = t1;
            },
            _EvaluateVisitor__runBuiltInCallable_closure1: function _EvaluateVisitor__runBuiltInCallable_closure1() {},
            _EvaluateVisitor__evaluateArguments_closure: function _EvaluateVisitor__evaluateArguments_closure() {},
            _EvaluateVisitor__evaluateArguments_closure0: function _EvaluateVisitor__evaluateArguments_closure0(t0, t1) {
                this.$this = t0;
                this.restNodeForSpan = t1;
            },
            _EvaluateVisitor__evaluateArguments_closure1: function _EvaluateVisitor__evaluateArguments_closure1(t0, t1, t2, t3) {
                var _ = this;
                _.$this = t0;
                _.named = t1;
                _.restNodeForSpan = t2;
                _.namedNodes = t3;
            },
            _EvaluateVisitor__evaluateArguments_closure2: function _EvaluateVisitor__evaluateArguments_closure2() {},
            _EvaluateVisitor__evaluateMacroArguments_closure: function _EvaluateVisitor__evaluateMacroArguments_closure(t0) {
                this.restArgs = t0;
            },
            _EvaluateVisitor__evaluateMacroArguments_closure0: function _EvaluateVisitor__evaluateMacroArguments_closure0(t0, t1, t2) {
                this.$this = t0;
                this.restNodeForSpan = t1;
                this.restArgs = t2;
            },
            _EvaluateVisitor__evaluateMacroArguments_closure1: function _EvaluateVisitor__evaluateMacroArguments_closure1(t0, t1, t2, t3) {
                var _ = this;
                _.$this = t0;
                _.named = t1;
                _.restNodeForSpan = t2;
                _.restArgs = t3;
            },
            _EvaluateVisitor__evaluateMacroArguments_closure2: function _EvaluateVisitor__evaluateMacroArguments_closure2(t0, t1, t2) {
                this.$this = t0;
                this.keywordRestNodeForSpan = t1;
                this.keywordRestArgs = t2;
            },
            _EvaluateVisitor__addRestMap_closure: function _EvaluateVisitor__addRestMap_closure(t0, t1, t2, t3, t4, t5) {
                var _ = this;
                _.$this = t0;
                _.values = t1;
                _.convert = t2;
                _.expressionNode = t3;
                _.map = t4;
                _.nodeWithSpan = t5;
            },
            _EvaluateVisitor__verifyArguments_closure: function _EvaluateVisitor__verifyArguments_closure(t0, t1, t2) {
                this.parameters = t0;
                this.positional = t1;
                this.named = t2;
            },
            _EvaluateVisitor_visitCssAtRule_closure: function _EvaluateVisitor_visitCssAtRule_closure(t0, t1) {
                this.$this = t0;
                this.node = t1;
            },
            _EvaluateVisitor_visitCssAtRule_closure0: function _EvaluateVisitor_visitCssAtRule_closure0(t0, t1) {
                this.$this = t0;
                this.node = t1;
            },
            _EvaluateVisitor_visitCssAtRule_closure1: function _EvaluateVisitor_visitCssAtRule_closure1() {},
            _EvaluateVisitor_visitCssKeyframeBlock_closure: function _EvaluateVisitor_visitCssKeyframeBlock_closure(t0, t1) {
                this.$this = t0;
                this.node = t1;
            },
            _EvaluateVisitor_visitCssKeyframeBlock_closure0: function _EvaluateVisitor_visitCssKeyframeBlock_closure0() {},
            _EvaluateVisitor_visitCssMediaRule_closure: function _EvaluateVisitor_visitCssMediaRule_closure(t0, t1) {
                this.$this = t0;
                this.node = t1;
            },
            _EvaluateVisitor_visitCssMediaRule_closure0: function _EvaluateVisitor_visitCssMediaRule_closure0(t0, t1) {
                this.$this = t0;
                this.node = t1;
            },
            _EvaluateVisitor_visitCssMediaRule_closure1: function _EvaluateVisitor_visitCssMediaRule_closure1(t0, t1, t2, t3) {
                var _ = this;
                _.$this = t0;
                _.mergedQueries = t1;
                _.node = t2;
                _.mergedSources = t3;
            },
            _EvaluateVisitor_visitCssMediaRule__closure: function _EvaluateVisitor_visitCssMediaRule__closure(t0, t1) {
                this.$this = t0;
                this.node = t1;
            },
            _EvaluateVisitor_visitCssMediaRule___closure: function _EvaluateVisitor_visitCssMediaRule___closure(t0, t1) {
                this.$this = t0;
                this.node = t1;
            },
            _EvaluateVisitor_visitCssMediaRule_closure2: function _EvaluateVisitor_visitCssMediaRule_closure2(t0) {
                this.mergedSources = t0;
            },
            _EvaluateVisitor_visitCssStyleRule_closure0: function _EvaluateVisitor_visitCssStyleRule_closure0(t0, t1, t2) {
                this.$this = t0;
                this.rule = t1;
                this.node = t2;
            },
            _EvaluateVisitor_visitCssStyleRule__closure: function _EvaluateVisitor_visitCssStyleRule__closure(t0, t1) {
                this.$this = t0;
                this.node = t1;
            },
            _EvaluateVisitor_visitCssStyleRule_closure: function _EvaluateVisitor_visitCssStyleRule_closure() {},
            _EvaluateVisitor_visitCssSupportsRule_closure: function _EvaluateVisitor_visitCssSupportsRule_closure(t0, t1) {
                this.$this = t0;
                this.node = t1;
            },
            _EvaluateVisitor_visitCssSupportsRule_closure0: function _EvaluateVisitor_visitCssSupportsRule_closure0(t0, t1) {
                this.$this = t0;
                this.node = t1;
            },
            _EvaluateVisitor_visitCssSupportsRule__closure: function _EvaluateVisitor_visitCssSupportsRule__closure(t0, t1) {
                this.$this = t0;
                this.node = t1;
            },
            _EvaluateVisitor_visitCssSupportsRule_closure1: function _EvaluateVisitor_visitCssSupportsRule_closure1() {},
            _EvaluateVisitor__performInterpolationHelper_closure: function _EvaluateVisitor__performInterpolationHelper_closure(t0) {
                this.interpolation = t0;
            },
            _EvaluateVisitor__serialize_closure: function _EvaluateVisitor__serialize_closure(t0, t1) {
                this.value = t0;
                this.quote = t1;
            },
            _EvaluateVisitor__expressionNode_closure: function _EvaluateVisitor__expressionNode_closure(t0, t1) {
                this.$this = t0;
                this.expression = t1;
            },
            _EvaluateVisitor__withoutSlash_recommendation: function _EvaluateVisitor__withoutSlash_recommendation() {},
            _EvaluateVisitor__stackFrame_closure: function _EvaluateVisitor__stackFrame_closure(t0) {
                this.$this = t0;
            },
            _ImportedCssVisitor: function _ImportedCssVisitor(t0) {
                this._visitor = t0;
            },
            _ImportedCssVisitor_visitCssAtRule_closure: function _ImportedCssVisitor_visitCssAtRule_closure() {},
            _ImportedCssVisitor_visitCssMediaRule_closure: function _ImportedCssVisitor_visitCssMediaRule_closure(t0) {
                this.hasBeenMerged = t0;
            },
            _ImportedCssVisitor_visitCssStyleRule_closure: function _ImportedCssVisitor_visitCssStyleRule_closure() {},
            _ImportedCssVisitor_visitCssSupportsRule_closure: function _ImportedCssVisitor_visitCssSupportsRule_closure() {},
            _EvaluationContext: function _EvaluationContext(t0, t1) {
                this._visitor = t0;
                this._defaultWarnNodeWithSpan = t1;
            },
            EveryCssVisitor: function EveryCssVisitor() {},
            EveryCssVisitor_visitCssAtRule_closure: function EveryCssVisitor_visitCssAtRule_closure(t0) {
                this.$this = t0;
            },
            EveryCssVisitor_visitCssKeyframeBlock_closure: function EveryCssVisitor_visitCssKeyframeBlock_closure(t0) {
                this.$this = t0;
            },
            EveryCssVisitor_visitCssMediaRule_closure: function EveryCssVisitor_visitCssMediaRule_closure(t0) {
                this.$this = t0;
            },
            EveryCssVisitor_visitCssStyleRule_closure: function EveryCssVisitor_visitCssStyleRule_closure(t0) {
                this.$this = t0;
            },
            EveryCssVisitor_visitCssStylesheet_closure: function EveryCssVisitor_visitCssStylesheet_closure(t0) {
                this.$this = t0;
            },
            EveryCssVisitor_visitCssSupportsRule_closure: function EveryCssVisitor_visitCssSupportsRule_closure(t0) {
                this.$this = t0;
            },
            expressionToCalc: function(expression) {
                var t1 = A.ArgumentList$(A._setArrayType([
                    B.C__MakeExpressionCalculationSafe.visitBinaryOperationExpression$1(0, expression)
                ], type$.JSArray_Expression), B.Map_empty4, B.Map_empty5, expression.get$span(0), null, null), t2 = expression.get$span(0);
                return new A.FunctionExpression(null, A.stringReplaceAllUnchecked("calc", "_", "-"), "calc", t1, t2);
            },
            _MakeExpressionCalculationSafe: function _MakeExpressionCalculationSafe() {},
            __MakeExpressionCalculationSafe_Object_ReplaceExpressionVisitor: function __MakeExpressionCalculationSafe_Object_ReplaceExpressionVisitor() {},
            _FindDependenciesVisitor: function _FindDependenciesVisitor(t0, t1, t2, t3, t4) {
                var _ = this;
                _._find_dependencies$_uses = t0;
                _._find_dependencies$_forwards = t1;
                _._metaLoadCss = t2;
                _._imports = t3;
                _._metaNamespaces = t4;
            },
            __FindDependenciesVisitor_Object_RecursiveStatementVisitor: function __FindDependenciesVisitor_Object_RecursiveStatementVisitor() {},
            IsCalculationSafeVisitor: function IsCalculationSafeVisitor() {},
            IsCalculationSafeVisitor_visitListExpression_closure: function IsCalculationSafeVisitor_visitListExpression_closure(t0) {
                this.$this = t0;
            },
            IsPlainCssVisitor: function IsPlainCssVisitor(t0) {
                this._allowInterpolation = t0;
            },
            IsPlainCssVisitor_visitIfExpression_closure: function IsPlainCssVisitor_visitIfExpression_closure(t0) {
                this.$this = t0;
            },
            IsPlainCssVisitor_visitListExpression_closure: function IsPlainCssVisitor_visitListExpression_closure(t0) {
                this.$this = t0;
            },
            IsPlainCssVisitor_visitIfConditionOperation_closure: function IsPlainCssVisitor_visitIfConditionOperation_closure(t0) {
                this.$this = t0;
            },
            IsPlainCssVisitor__visitArgumentList_closure: function IsPlainCssVisitor__visitArgumentList_closure(t0) {
                this.$this = t0;
            },
            RecursiveStatementVisitor: function RecursiveStatementVisitor() {},
            ReplaceExpressionVisitor: function ReplaceExpressionVisitor() {},
            ReplaceExpressionVisitor_visitListExpression_closure: function ReplaceExpressionVisitor_visitListExpression_closure(t0) {
                this.$this = t0;
            },
            ReplaceExpressionVisitor_visitIfConditionOperation_closure: function ReplaceExpressionVisitor_visitIfConditionOperation_closure(t0) {
                this.$this = t0;
            },
            ReplaceExpressionVisitor_visitArgumentList_closure: function ReplaceExpressionVisitor_visitArgumentList_closure(t0) {
                this.$this = t0;
            },
            ReplaceExpressionVisitor_visitInterpolation_closure: function ReplaceExpressionVisitor_visitInterpolation_closure(t0) {
                this.$this = t0;
            },
            SelectorSearchVisitor: function SelectorSearchVisitor() {},
            SelectorSearchVisitor_visitComplexSelector_closure: function SelectorSearchVisitor_visitComplexSelector_closure(t0) {
                this.$this = t0;
            },
            SelectorSearchVisitor_visitCompoundSelector_closure: function SelectorSearchVisitor_visitCompoundSelector_closure(t0) {
                this.$this = t0;
            },
            serialize: function(node, charset, indentWidth, inspect, lineFeed, logger, sourceMap, style, useSpaces) {
                var t1, css, t2, prefix, visitor = A._SerializeVisitor$(2, inspect, lineFeed, logger, true, sourceMap, style, true);
                node.accept$1(visitor);
                t1 = visitor._serialize$_buffer;
                css = t1.toString$0(0);
                if (charset) {
                    t2 = new A.CodeUnits(css);
                    t2 = t2.any$1(t2, new A.serialize_closure());
                } else t2 = false;
                if (t2) prefix = style === B.OutputStyle_1 ? "\ufeff" : '@charset "UTF-8";\n';
                else prefix = "";
                t1 = sourceMap ? t1.buildSourceMap$1$prefix(prefix) : null;
                return new A._Record_2_sourceMap(prefix + css, t1);
            },
            serializeValue: function(value, inspect, quote) {
                var _null = null, visitor = A._SerializeVisitor$(_null, inspect, _null, _null, quote, false, _null, true);
                value.accept$1(visitor);
                return visitor._serialize$_buffer.toString$0(0);
            },
            serializeSelector: function(selector, inspect) {
                var _null = null, visitor = A._SerializeVisitor$(_null, true, _null, _null, true, false, _null, true);
                selector.accept$1(visitor);
                return visitor._serialize$_buffer.toString$0(0);
            },
            _SerializeVisitor$: function(indentWidth, inspect, lineFeed, logger, quote, sourceMap, style, useSpaces) {
                var t1 = sourceMap ? new A.SourceMapBuffer(new A.StringBuffer(""), A._setArrayType([], type$.JSArray_Entry)) : new A.NoSourceMapBuffer(new A.StringBuffer("")), t2 = style == null ? B.OutputStyle_0 : style, t3 = indentWidth == null ? 2 : indentWidth;
                A.RangeError_checkValueInInterval(t3, 0, 10, "indentWidth");
                return new A._SerializeVisitor(t1, t2, inspect, quote, 32, t3, B.LineFeed_2_lf);
            },
            serialize_closure: function serialize_closure() {},
            _SerializeVisitor: function _SerializeVisitor(t0, t1, t2, t3, t4, t5, t6) {
                var _ = this;
                _._serialize$_buffer = t0;
                _._indentation = 0;
                _._style = t1;
                _._inspect = t2;
                _._quote = t3;
                _._indentCharacter = t4;
                _._indentWidth = t5;
                _._serialize$_lineFeed = t6;
            },
            _SerializeVisitor_visitCssComment_closure: function _SerializeVisitor_visitCssComment_closure(t0, t1) {
                this.$this = t0;
                this.node = t1;
            },
            _SerializeVisitor_visitCssAtRule_closure: function _SerializeVisitor_visitCssAtRule_closure(t0, t1) {
                this.$this = t0;
                this.node = t1;
            },
            _SerializeVisitor_visitCssMediaRule_closure: function _SerializeVisitor_visitCssMediaRule_closure(t0, t1) {
                this.$this = t0;
                this.node = t1;
            },
            _SerializeVisitor_visitCssImport_closure: function _SerializeVisitor_visitCssImport_closure(t0, t1) {
                this.$this = t0;
                this.node = t1;
            },
            _SerializeVisitor_visitCssImport__closure: function _SerializeVisitor_visitCssImport__closure(t0, t1) {
                this.$this = t0;
                this.node = t1;
            },
            _SerializeVisitor_visitCssKeyframeBlock_closure: function _SerializeVisitor_visitCssKeyframeBlock_closure(t0, t1) {
                this.$this = t0;
                this.node = t1;
            },
            _SerializeVisitor_visitCssStyleRule_closure: function _SerializeVisitor_visitCssStyleRule_closure(t0, t1) {
                this.$this = t0;
                this.node = t1;
            },
            _SerializeVisitor_visitCssSupportsRule_closure: function _SerializeVisitor_visitCssSupportsRule_closure(t0, t1) {
                this.$this = t0;
                this.node = t1;
            },
            _SerializeVisitor_visitCssDeclaration_closure: function _SerializeVisitor_visitCssDeclaration_closure(t0, t1) {
                this.$this = t0;
                this.node = t1;
            },
            _SerializeVisitor_visitCssDeclaration_closure0: function _SerializeVisitor_visitCssDeclaration_closure0(t0, t1) {
                this.$this = t0;
                this.node = t1;
            },
            _SerializeVisitor_visitList_closure: function _SerializeVisitor_visitList_closure() {},
            _SerializeVisitor_visitList_closure0: function _SerializeVisitor_visitList_closure0(t0, t1) {
                this.$this = t0;
                this.value = t1;
            },
            _SerializeVisitor_visitList_closure1: function _SerializeVisitor_visitList_closure1(t0) {
                this.$this = t0;
            },
            _SerializeVisitor_visitMap_closure: function _SerializeVisitor_visitMap_closure(t0) {
                this.$this = t0;
            },
            _SerializeVisitor_visitSelectorList_closure: function _SerializeVisitor_visitSelectorList_closure() {},
            _SerializeVisitor__write_closure: function _SerializeVisitor__write_closure(t0, t1) {
                this.$this = t0;
                this.value = t1;
            },
            _SerializeVisitor__visitChildren_closure: function _SerializeVisitor__visitChildren_closure(t0, t1) {
                this.$this = t0;
                this.child = t1;
            },
            _SerializeVisitor__visitChildren_closure0: function _SerializeVisitor__visitChildren_closure0(t0, t1) {
                this.$this = t0;
                this.child = t1;
            },
            OutputStyle: function OutputStyle(t0, t1) {
                this.index = t0;
                this._name = t1;
            },
            LineFeed: function LineFeed(t0, t1) {
                this.index = t0;
                this._name = t1;
            },
            StatementSearchVisitor: function StatementSearchVisitor() {},
            StatementSearchVisitor_visitIfRule_closure: function StatementSearchVisitor_visitIfRule_closure(t0) {
                this.$this = t0;
            },
            StatementSearchVisitor_visitIfRule__closure0: function StatementSearchVisitor_visitIfRule__closure0(t0) {
                this.$this = t0;
            },
            StatementSearchVisitor_visitIfRule_closure0: function StatementSearchVisitor_visitIfRule_closure0(t0) {
                this.$this = t0;
            },
            StatementSearchVisitor_visitIfRule__closure: function StatementSearchVisitor_visitIfRule__closure(t0) {
                this.$this = t0;
            },
            StatementSearchVisitor_visitChildren_closure: function StatementSearchVisitor_visitChildren_closure(t0) {
                this.$this = t0;
            },
            Entry: function Entry(t0, t1, t2) {
                this.source = t0;
                this.target = t1;
                this.identifierName = t2;
            },
            SingleMapping_SingleMapping$fromEntries: function(entries) {
                var lines, t1, t2, urls, names, files, targetEntries, t3, lineNum, _i, sourceEntry, t4, t5, sourceUrl, t6, urlId, sourceEntries = J.toList$0$ax(entries);
                B.JSArray_methods.sort$0(sourceEntries);
                lines = A._setArrayType([], type$.JSArray_TargetLineEntry);
                t1 = type$.String;
                t2 = type$.int;
                urls = A.LinkedHashMap_LinkedHashMap$_empty(t1, t2);
                names = A.LinkedHashMap_LinkedHashMap$_empty(t1, t2);
                files = A.LinkedHashMap_LinkedHashMap$_empty(t2, type$.SourceFile);
                targetEntries = A._Cell$();
                for(t2 = sourceEntries.length, t3 = type$.JSArray_TargetEntry, lineNum = null, _i = 0; _i < sourceEntries.length; sourceEntries.length === t2 || (0, A.throwConcurrentModificationError)(sourceEntries), ++_i){
                    sourceEntry = sourceEntries[_i];
                    if (lineNum == null || sourceEntry.target.line > lineNum) {
                        lineNum = sourceEntry.target.line;
                        t4 = A._setArrayType([], t3);
                        targetEntries.__late_helper$_value = t4;
                        lines.push(new A.TargetLineEntry(lineNum, t4));
                    }
                    t4 = sourceEntry.source;
                    t5 = t4.file;
                    sourceUrl = t5.url;
                    t6 = sourceUrl == null ? "" : sourceUrl.toString$0(0);
                    urlId = urls.putIfAbsent$2(t6, new A.SingleMapping_SingleMapping$fromEntries_closure(urls));
                    files.putIfAbsent$2(urlId, new A.SingleMapping_SingleMapping$fromEntries_closure0(sourceEntry));
                    t6 = targetEntries.__late_helper$_value;
                    if (t6 === targetEntries) A.throwExpression(A.LateError$localNI(""));
                    t4 = t4.offset;
                    J.add$1$ax(t6, new A.TargetEntry(sourceEntry.target.column, urlId, t5.getLine$1(t4), t5.getColumn$1(t4), null));
                }
                t2 = urls.$ti;
                t3 = t2._eval$1("LinkedHashMapValuesIterable<2>");
                t3 = A.MappedIterable_MappedIterable(new A.LinkedHashMapValuesIterable(urls, t3), new A.SingleMapping_SingleMapping$fromEntries_closure1(files), t3._eval$1("Iterable.E"), type$.nullable_SourceFile);
                t3 = A.List_List$_of(t3, A._instanceType(t3)._eval$1("Iterable.E"));
                t2 = t2._eval$1("LinkedHashMapKeysIterable<1>");
                t2 = A.List_List$_of(new A.LinkedHashMapKeysIterable(urls, t2), t2._eval$1("Iterable.E"));
                t4 = names.$ti._eval$1("LinkedHashMapKeysIterable<1>");
                t4 = A.List_List$_of(new A.LinkedHashMapKeysIterable(names, t4), t4._eval$1("Iterable.E"));
                return new A.SingleMapping(t2, t4, t3, lines, null, A.LinkedHashMap_LinkedHashMap$_empty(t1, type$.dynamic));
            },
            Mapping: function Mapping() {},
            SingleMapping: function SingleMapping(t0, t1, t2, t3, t4, t5) {
                var _ = this;
                _.urls = t0;
                _.names = t1;
                _.files = t2;
                _.lines = t3;
                _.targetUrl = t4;
                _.sourceRoot = null;
                _.extensions = t5;
            },
            SingleMapping_SingleMapping$fromEntries_closure: function SingleMapping_SingleMapping$fromEntries_closure(t0) {
                this.urls = t0;
            },
            SingleMapping_SingleMapping$fromEntries_closure0: function SingleMapping_SingleMapping$fromEntries_closure0(t0) {
                this.sourceEntry = t0;
            },
            SingleMapping_SingleMapping$fromEntries_closure1: function SingleMapping_SingleMapping$fromEntries_closure1(t0) {
                this.files = t0;
            },
            SingleMapping_toJson_closure: function SingleMapping_toJson_closure() {},
            SingleMapping_toJson_closure0: function SingleMapping_toJson_closure0(t0) {
                this.result = t0;
            },
            TargetLineEntry: function TargetLineEntry(t0, t1) {
                this.line = t0;
                this.entries = t1;
            },
            TargetEntry: function TargetEntry(t0, t1, t2, t3, t4) {
                var _ = this;
                _.column = t0;
                _.sourceUrlId = t1;
                _.sourceLine = t2;
                _.sourceColumn = t3;
                _.sourceNameId = t4;
            },
            SourceFile$fromString: function(text, url) {
                var t1 = new A.CodeUnits(text), t2 = A._setArrayType([
                    0
                ], type$.JSArray_int), t3 = typeof url == "string" ? A.Uri_parse(url) : type$.nullable_Uri._as(url), t4 = t1.get$length(0);
                t2 = new A.SourceFile(t3, t2, new Uint32Array(t4));
                t2.SourceFile$_fromList$2$url(t1, url);
                return t2;
            },
            SourceFile$decoded: function(decodedChars, url) {
                var t1 = A._setArrayType(decodedChars.slice(0), A._arrayInstanceType(decodedChars)), t2 = A._setArrayType([
                    0
                ], type$.JSArray_int), t3 = typeof url == "string" ? A.Uri_parse(url) : type$.nullable_Uri._as(url), t4 = t1.length;
                t2 = new A.SourceFile(t3, t2, new Uint32Array(t4));
                t2.SourceFile$_fromList$2$url(t1, url);
                return t2;
            },
            FileLocation$_: function(file, offset) {
                if (offset < 0) A.throwExpression(A.RangeError$("Offset may not be negative, was " + offset + "."));
                else if (offset > file._decodedChars.length) A.throwExpression(A.RangeError$("Offset " + offset + string$.x20must_n + file.get$length(0) + "."));
                return new A.FileLocation(file, offset);
            },
            _FileSpan$: function(file, _start, _end) {
                if (_end < _start) A.throwExpression(A.ArgumentError$("End " + _end + " must come after start " + _start + ".", null));
                else if (_end > file._decodedChars.length) A.throwExpression(A.RangeError$("End " + _end + string$.x20must_n + file.get$length(0) + "."));
                else if (_start < 0) A.throwExpression(A.RangeError$("Start may not be negative, was " + _start + "."));
                return new A._FileSpan(file, _start, _end);
            },
            FileSpanExtension_subspan: function(_this, start, end) {
                var t1, startOffset, t2;
                A.RangeError_checkValidRange(start, end, _this.get$length(_this));
                if (start === 0) t1 = end == null || end === _this.get$length(_this);
                else t1 = false;
                if (t1) return _this;
                startOffset = _this.get$start(_this).offset;
                t1 = _this.get$file(_this);
                t2 = end == null ? _this.get$end(_this).offset : startOffset + end;
                return t1.span$2(0, startOffset + start, t2);
            },
            SourceFile: function SourceFile(t0, t1, t2) {
                var _ = this;
                _.url = t0;
                _._lineStarts = t1;
                _._decodedChars = t2;
                _._cachedLine = null;
            },
            FileLocation: function FileLocation(t0, t1) {
                this.file = t0;
                this.offset = t1;
            },
            _FileSpan: function _FileSpan(t0, t1, t2) {
                this.file = t0;
                this._file$_start = t1;
                this._end = t2;
            },
            Highlighter$: function(span, color) {
                var t1 = A.Highlighter__collateLines(A._setArrayType([
                    A._Highlight$(span, null, true)
                ], type$.JSArray__Highlight)), t2 = new A.Highlighter_closure(color).call$0(), t3 = B.JSInt_methods.toString$0(B.JSArray_methods.get$last(t1).number + 1), t4 = A.Highlighter__contiguous(t1) ? 0 : 3, t5 = A._arrayInstanceType(t1);
                return new A.Highlighter(t1, t2, null, 1 + Math.max(t3.length, t4), new A.MappedListIterable(t1, new A.Highlighter$__closure(), t5._eval$1("MappedListIterable<1,int>")).reduce$1(0, B.CONSTANT), !A.isAllTheSame(new A.MappedListIterable(t1, new A.Highlighter$__closure0(), t5._eval$1("MappedListIterable<1,Object?>"))), new A.StringBuffer(""));
            },
            Highlighter$multiple: function(primarySpan, primaryLabel, secondarySpans, color, primaryColor, secondaryColor) {
                var t2, t3, t4, t5, t6, t1 = A._setArrayType([
                    A._Highlight$(primarySpan, primaryLabel, true)
                ], type$.JSArray__Highlight);
                for(t2 = secondarySpans.get$entries(secondarySpans), t2 = t2.get$iterator(t2); t2.moveNext$0();){
                    t3 = t2.get$current(t2);
                    t1.push(A._Highlight$(t3.key, t3.value, false));
                }
                t1 = A.Highlighter__collateLines(t1);
                if (color) t2 = primaryColor == null ? "\x1b[31m" : primaryColor;
                else t2 = null;
                if (color) t3 = "\x1b[34m";
                else t3 = null;
                t4 = B.JSInt_methods.toString$0(B.JSArray_methods.get$last(t1).number + 1);
                t5 = A.Highlighter__contiguous(t1) ? 0 : 3;
                t6 = A._arrayInstanceType(t1);
                return new A.Highlighter(t1, t2, t3, 1 + Math.max(t4.length, t5), new A.MappedListIterable(t1, new A.Highlighter$__closure(), t6._eval$1("MappedListIterable<1,int>")).reduce$1(0, B.CONSTANT), !A.isAllTheSame(new A.MappedListIterable(t1, new A.Highlighter$__closure0(), t6._eval$1("MappedListIterable<1,Object?>"))), new A.StringBuffer(""));
            },
            Highlighter__contiguous: function(lines) {
                var i, thisLine, nextLine;
                for(i = 0; i < lines.length - 1;){
                    thisLine = lines[i];
                    ++i;
                    nextLine = lines[i];
                    if (thisLine.number + 1 !== nextLine.number && J.$eq$(thisLine.url, nextLine.url)) return false;
                }
                return true;
            },
            Highlighter__collateLines: function(highlights) {
                var t1, t2, highlightsByUrl = A.groupBy(highlights, new A.Highlighter__collateLines_closure(), type$._Highlight, type$.Object);
                for(t1 = new A.LinkedHashMapValueIterator(highlightsByUrl, highlightsByUrl._modifications, highlightsByUrl._first); t1.moveNext$0();)J.sort$1$ax(t1.__js_helper$_current, new A.Highlighter__collateLines_closure0());
                t1 = A._instanceType(highlightsByUrl)._eval$1("LinkedHashMapEntriesIterable<1,2>");
                t2 = t1._eval$1("ExpandIterable<Iterable.E,_Line>");
                t1 = A.List_List$_of(new A.ExpandIterable(new A.LinkedHashMapEntriesIterable(highlightsByUrl, t1), new A.Highlighter__collateLines_closure1(), t2), t2._eval$1("Iterable.E"));
                return t1;
            },
            _Highlight$: function(span, label, primary) {
                var t2, t1 = new A._Highlight_closure(span).call$0();
                if (label == null) t2 = null;
                else t2 = A.stringReplaceAllUnchecked(label, "\r\n", "\n");
                return new A._Highlight(t1, primary, t2);
            },
            _Highlight__normalizeNewlines: function(span) {
                var endOffset, t1, i, t2, t3, t4, text = span.get$text();
                if (!B.JSString_methods.contains$1(text, "\r\n")) return span;
                endOffset = span.get$end(span).get$offset();
                for(t1 = text.length - 1, i = 0; i < t1; ++i)if (text.charCodeAt(i) === 13 && text.charCodeAt(i + 1) === 10) --endOffset;
                t1 = span.get$start(span);
                t2 = span.get$sourceUrl(span);
                t3 = span.get$end(span).get$line();
                t2 = A.SourceLocation$(endOffset, span.get$end(span).get$column(), t3, t2);
                t3 = A.stringReplaceAllUnchecked(text, "\r\n", "\n");
                t4 = span.get$context(span);
                return A.SourceSpanWithContext$(t1, t2, t3, A.stringReplaceAllUnchecked(t4, "\r\n", "\n"));
            },
            _Highlight__normalizeTrailingNewline: function(span) {
                var context, text, start, end, t1, t2, t3;
                if (!B.JSString_methods.endsWith$1(span.get$context(span), "\n")) return span;
                if (B.JSString_methods.endsWith$1(span.get$text(), "\n\n")) return span;
                context = B.JSString_methods.substring$2(span.get$context(span), 0, span.get$context(span).length - 1);
                text = span.get$text();
                start = span.get$start(span);
                end = span.get$end(span);
                if (B.JSString_methods.endsWith$1(span.get$text(), "\n")) {
                    t1 = A.findLineStart(span.get$context(span), span.get$text(), span.get$start(span).get$column());
                    t1.toString;
                    t1 = t1 + span.get$start(span).get$column() + span.get$length(span) === span.get$context(span).length;
                } else t1 = false;
                if (t1) {
                    text = B.JSString_methods.substring$2(span.get$text(), 0, span.get$text().length - 1);
                    if (text.length === 0) end = start;
                    else {
                        t1 = span.get$end(span).get$offset();
                        t2 = span.get$sourceUrl(span);
                        t3 = span.get$end(span).get$line();
                        end = A.SourceLocation$(t1 - 1, A._Highlight__lastLineLength(context), t3 - 1, t2);
                        start = span.get$start(span).get$offset() === span.get$end(span).get$offset() ? end : span.get$start(span);
                    }
                }
                return A.SourceSpanWithContext$(start, end, text, context);
            },
            _Highlight__normalizeEndOfLine: function(span) {
                var text, t1, t2, t3, t4;
                if (span.get$end(span).get$column() !== 0) return span;
                if (span.get$end(span).get$line() === span.get$start(span).get$line()) return span;
                text = B.JSString_methods.substring$2(span.get$text(), 0, span.get$text().length - 1);
                t1 = span.get$start(span);
                t2 = span.get$end(span).get$offset();
                t3 = span.get$sourceUrl(span);
                t4 = span.get$end(span).get$line();
                t3 = A.SourceLocation$(t2 - 1, text.length - B.JSString_methods.lastIndexOf$1(text, "\n") - 1, t4 - 1, t3);
                return A.SourceSpanWithContext$(t1, t3, text, B.JSString_methods.endsWith$1(span.get$context(span), "\n") ? B.JSString_methods.substring$2(span.get$context(span), 0, span.get$context(span).length - 1) : span.get$context(span));
            },
            _Highlight__lastLineLength: function(text) {
                var t1 = text.length;
                if (t1 === 0) return 0;
                else if (text.charCodeAt(t1 - 1) === 10) return t1 === 1 ? 0 : t1 - B.JSString_methods.lastIndexOf$2(text, "\n", t1 - 2) - 1;
                else return t1 - B.JSString_methods.lastIndexOf$1(text, "\n") - 1;
            },
            Highlighter: function Highlighter(t0, t1, t2, t3, t4, t5, t6) {
                var _ = this;
                _._lines = t0;
                _._primaryColor = t1;
                _._secondaryColor = t2;
                _._paddingBeforeSidebar = t3;
                _._maxMultilineSpans = t4;
                _._multipleFiles = t5;
                _._highlighter$_buffer = t6;
            },
            Highlighter_closure: function Highlighter_closure(t0) {
                this.color = t0;
            },
            Highlighter$__closure: function Highlighter$__closure() {},
            Highlighter$___closure: function Highlighter$___closure() {},
            Highlighter$__closure0: function Highlighter$__closure0() {},
            Highlighter__collateLines_closure: function Highlighter__collateLines_closure() {},
            Highlighter__collateLines_closure0: function Highlighter__collateLines_closure0() {},
            Highlighter__collateLines_closure1: function Highlighter__collateLines_closure1() {},
            Highlighter__collateLines__closure: function Highlighter__collateLines__closure(t0) {
                this.line = t0;
            },
            Highlighter_highlight_closure: function Highlighter_highlight_closure() {},
            Highlighter__writeFileStart_closure: function Highlighter__writeFileStart_closure(t0) {
                this.$this = t0;
            },
            Highlighter__writeMultilineHighlights_closure: function Highlighter__writeMultilineHighlights_closure(t0, t1, t2) {
                this.$this = t0;
                this.startLine = t1;
                this.line = t2;
            },
            Highlighter__writeMultilineHighlights_closure0: function Highlighter__writeMultilineHighlights_closure0(t0, t1) {
                this.$this = t0;
                this.highlight = t1;
            },
            Highlighter__writeMultilineHighlights_closure1: function Highlighter__writeMultilineHighlights_closure1(t0) {
                this.$this = t0;
            },
            Highlighter__writeMultilineHighlights_closure2: function Highlighter__writeMultilineHighlights_closure2(t0, t1, t2, t3, t4, t5, t6) {
                var _ = this;
                _._box_0 = t0;
                _.$this = t1;
                _.current = t2;
                _.startLine = t3;
                _.line = t4;
                _.highlight = t5;
                _.endLine = t6;
            },
            Highlighter__writeMultilineHighlights__closure: function Highlighter__writeMultilineHighlights__closure(t0, t1) {
                this._box_0 = t0;
                this.$this = t1;
            },
            Highlighter__writeMultilineHighlights__closure0: function Highlighter__writeMultilineHighlights__closure0(t0, t1) {
                this.$this = t0;
                this.vertical = t1;
            },
            Highlighter__writeHighlightedText_closure: function Highlighter__writeHighlightedText_closure(t0, t1, t2, t3) {
                var _ = this;
                _.$this = t0;
                _.text = t1;
                _.startColumn = t2;
                _.endColumn = t3;
            },
            Highlighter__writeIndicator_closure: function Highlighter__writeIndicator_closure(t0, t1, t2) {
                this.$this = t0;
                this.line = t1;
                this.highlight = t2;
            },
            Highlighter__writeIndicator_closure0: function Highlighter__writeIndicator_closure0(t0, t1, t2) {
                this.$this = t0;
                this.line = t1;
                this.highlight = t2;
            },
            Highlighter__writeIndicator_closure1: function Highlighter__writeIndicator_closure1(t0, t1, t2, t3) {
                var _ = this;
                _.$this = t0;
                _.coversWholeLine = t1;
                _.line = t2;
                _.highlight = t3;
            },
            Highlighter__writeLabel_closure: function Highlighter__writeLabel_closure(t0, t1) {
                this.$this = t0;
                this.lines = t1;
            },
            Highlighter__writeLabel_closure0: function Highlighter__writeLabel_closure0(t0, t1) {
                this.$this = t0;
                this.text = t1;
            },
            Highlighter__writeSidebar_closure: function Highlighter__writeSidebar_closure(t0, t1, t2) {
                this._box_0 = t0;
                this.$this = t1;
                this.end = t2;
            },
            _Highlight: function _Highlight(t0, t1, t2) {
                this.span = t0;
                this.isPrimary = t1;
                this.label = t2;
            },
            _Highlight_closure: function _Highlight_closure(t0) {
                this.span = t0;
            },
            _Line: function _Line(t0, t1, t2, t3) {
                var _ = this;
                _.text = t0;
                _.number = t1;
                _.url = t2;
                _.highlights = t3;
            },
            SourceLocation$: function(offset, column, line, sourceUrl) {
                if (offset < 0) A.throwExpression(A.RangeError$("Offset may not be negative, was " + offset + "."));
                else if (line < 0) A.throwExpression(A.RangeError$("Line may not be negative, was " + line + "."));
                else if (column < 0) A.throwExpression(A.RangeError$("Column may not be negative, was " + column + "."));
                return new A.SourceLocation(sourceUrl, offset, line, column);
            },
            SourceLocation: function SourceLocation(t0, t1, t2, t3) {
                var _ = this;
                _.sourceUrl = t0;
                _.offset = t1;
                _.line = t2;
                _.column = t3;
            },
            SourceLocationMixin: function SourceLocationMixin() {},
            SourceSpanExtension_messageMultiple: function(_this, message, label, secondarySpans, color, primaryColor, secondaryColor) {
                var t2, t3, t1 = _this.get$start(_this);
                t1 = t1.file.getLine$1(t1.offset);
                t2 = _this.get$start(_this);
                t2 = "line " + (t1 + 1) + ", column " + (t2.file.getColumn$1(t2.offset) + 1);
                if (_this.get$sourceUrl(_this) != null) {
                    t1 = _this.get$sourceUrl(_this);
                    t3 = $.$get$context();
                    t1.toString;
                    t1 = t2 + (" of " + t3.prettyUri$1(t1));
                } else t1 = t2;
                t1 = t1 + (": " + message + "\n") + A.Highlighter$multiple(_this, label, secondarySpans, color, primaryColor, secondaryColor).highlight$0();
                return t1.charCodeAt(0) == 0 ? t1 : t1;
            },
            SourceSpanBase: function SourceSpanBase() {},
            MultiSourceSpanFormatException$: function(message, span, primaryLabel, secondarySpans, source) {
                return new A.MultiSourceSpanFormatException(source, primaryLabel, A.ConstantMap_ConstantMap$from(secondarySpans, type$.SourceSpan, type$.String), message, span);
            },
            SourceSpanException: function SourceSpanException() {},
            SourceSpanFormatException: function SourceSpanFormatException(t0, t1, t2) {
                this.source = t0;
                this._span_exception$_message = t1;
                this._span = t2;
            },
            MultiSourceSpanException: function MultiSourceSpanException() {},
            MultiSourceSpanFormatException: function MultiSourceSpanFormatException(t0, t1, t2, t3, t4) {
                var _ = this;
                _.source = t0;
                _.primaryLabel = t1;
                _.secondarySpans = t2;
                _._span_exception$_message = t3;
                _._span = t4;
            },
            SourceSpanMixin: function SourceSpanMixin() {},
            SourceSpanWithContext$: function(start, end, text, _context) {
                var t1 = new A.SourceSpanWithContext(_context, start, end, text);
                t1.SourceSpanBase$3(start, end, text);
                if (!B.JSString_methods.contains$1(_context, text)) A.throwExpression(A.ArgumentError$('The context line "' + _context + '" must contain "' + text + '".', null));
                if (A.findLineStart(_context, text, start.get$column()) == null) A.throwExpression(A.ArgumentError$('The span text "' + text + '" must start at column ' + (start.get$column() + 1) + ' in a line within "' + _context + '".', null));
                return t1;
            },
            SourceSpanWithContext: function SourceSpanWithContext(t0, t1, t2, t3) {
                var _ = this;
                _._context = t0;
                _.start = t1;
                _.end = t2;
                _.text = t3;
            },
            Chain_Chain$parse: function(chain) {
                var t1, t2, _s51_ = string$.x3d_____;
                if (chain.length === 0) return new A.Chain(A.List_List$unmodifiable(A._setArrayType([], type$.JSArray_Trace), type$.Trace));
                t1 = $.$get$vmChainGap();
                if (B.JSString_methods.contains$1(chain, t1)) {
                    t1 = B.JSString_methods.split$1(chain, t1);
                    t2 = A._arrayInstanceType(t1);
                    return new A.Chain(A.List_List$unmodifiable(new A.MappedIterable(new A.WhereIterable(t1, new A.Chain_Chain$parse_closure(), t2._eval$1("WhereIterable<1>")), A.trace_Trace___parseVM_tearOff$closure(), t2._eval$1("MappedIterable<1,Trace>")), type$.Trace));
                }
                if (!B.JSString_methods.contains$1(chain, _s51_)) return new A.Chain(A.List_List$unmodifiable(A._setArrayType([
                    A.Trace_Trace$parse(chain)
                ], type$.JSArray_Trace), type$.Trace));
                return new A.Chain(A.List_List$unmodifiable(new A.MappedListIterable(A._setArrayType(chain.split(_s51_), type$.JSArray_String), A.trace_Trace___parseFriendly_tearOff$closure(), type$.MappedListIterable_String_Trace), type$.Trace));
            },
            Chain: function Chain(t0) {
                this.traces = t0;
            },
            Chain_Chain$parse_closure: function Chain_Chain$parse_closure() {},
            Chain_toTrace_closure: function Chain_toTrace_closure() {},
            Chain_toString_closure0: function Chain_toString_closure0() {},
            Chain_toString__closure0: function Chain_toString__closure0() {},
            Chain_toString_closure: function Chain_toString_closure(t0) {
                this.longest = t0;
            },
            Chain_toString__closure: function Chain_toString__closure(t0) {
                this.longest = t0;
            },
            Frame___parseVM_tearOff: function(frame) {
                return A.Frame_Frame$parseVM(frame);
            },
            Frame_Frame$parseVM: function(frame) {
                return A.Frame__catchFormatException(frame, new A.Frame_Frame$parseVM_closure(frame));
            },
            Frame___parseV8_tearOff: function(frame) {
                return A.Frame_Frame$parseV8(frame);
            },
            Frame_Frame$parseV8: function(frame) {
                return A.Frame__catchFormatException(frame, new A.Frame_Frame$parseV8_closure(frame));
            },
            Frame_Frame$_parseFirefoxEval: function(frame) {
                return A.Frame__catchFormatException(frame, new A.Frame_Frame$_parseFirefoxEval_closure(frame));
            },
            Frame___parseFirefox_tearOff: function(frame) {
                return A.Frame_Frame$parseFirefox(frame);
            },
            Frame_Frame$parseFirefox: function(frame) {
                return A.Frame__catchFormatException(frame, new A.Frame_Frame$parseFirefox_closure(frame));
            },
            Frame___parseFriendly_tearOff: function(frame) {
                return A.Frame_Frame$parseFriendly(frame);
            },
            Frame_Frame$parseFriendly: function(frame) {
                return A.Frame__catchFormatException(frame, new A.Frame_Frame$parseFriendly_closure(frame));
            },
            Frame__uriOrPathToUri: function(uriOrPath) {
                if (B.JSString_methods.contains$1(uriOrPath, $.$get$Frame__uriRegExp())) return A.Uri_parse(uriOrPath);
                else if (B.JSString_methods.contains$1(uriOrPath, $.$get$Frame__windowsRegExp())) return A._Uri__Uri$file(uriOrPath, true);
                else if (B.JSString_methods.startsWith$1(uriOrPath, "/")) return A._Uri__Uri$file(uriOrPath, false);
                if (B.JSString_methods.contains$1(uriOrPath, "\\")) return $.$get$windows().toUri$1(uriOrPath);
                return A.Uri_parse(uriOrPath);
            },
            Frame__catchFormatException: function(text, body) {
                var t1, _$exception;
                try {
                    t1 = body.call$0();
                    return t1;
                } catch (exception) {
                    if (type$.FormatException._is(A.unwrapException(exception))) return new A.UnparsedFrame(A._Uri__Uri(null, "unparsed", null, null), text);
                    else throw exception;
                }
            },
            Frame: function Frame(t0, t1, t2, t3) {
                var _ = this;
                _.uri = t0;
                _.line = t1;
                _.column = t2;
                _.member = t3;
            },
            Frame_Frame$parseVM_closure: function Frame_Frame$parseVM_closure(t0) {
                this.frame = t0;
            },
            Frame_Frame$parseV8_closure: function Frame_Frame$parseV8_closure(t0) {
                this.frame = t0;
            },
            Frame_Frame$parseV8_closure_parseJsLocation: function Frame_Frame$parseV8_closure_parseJsLocation(t0) {
                this.frame = t0;
            },
            Frame_Frame$_parseFirefoxEval_closure: function Frame_Frame$_parseFirefoxEval_closure(t0) {
                this.frame = t0;
            },
            Frame_Frame$parseFirefox_closure: function Frame_Frame$parseFirefox_closure(t0) {
                this.frame = t0;
            },
            Frame_Frame$parseFriendly_closure: function Frame_Frame$parseFriendly_closure(t0) {
                this.frame = t0;
            },
            LazyTrace: function LazyTrace(t0) {
                this._thunk = t0;
                this.__LazyTrace__trace_FI = $;
            },
            LazyTrace_terse_closure: function LazyTrace_terse_closure(t0) {
                this.$this = t0;
            },
            Trace_Trace$from: function(trace) {
                if (type$.Trace._is(trace)) return trace;
                if (trace instanceof A.Chain) return trace.toTrace$0();
                return new A.LazyTrace(new A.Trace_Trace$from_closure(trace));
            },
            Trace_Trace$parse: function(trace) {
                var error, t1, _$exception;
                try {
                    if (trace.length === 0) {
                        t1 = A.Trace$(A._setArrayType([], type$.JSArray_Frame), null);
                        return t1;
                    }
                    if (B.JSString_methods.contains$1(trace, $.$get$_v8Trace())) {
                        t1 = A.Trace$parseV8(trace);
                        return t1;
                    }
                    if (B.JSString_methods.contains$1(trace, "\tat ")) {
                        t1 = A.Trace$parseJSCore(trace);
                        return t1;
                    }
                    if (B.JSString_methods.contains$1(trace, $.$get$_firefoxSafariTrace()) || B.JSString_methods.contains$1(trace, $.$get$_firefoxEvalTrace())) {
                        t1 = A.Trace$parseFirefox(trace);
                        return t1;
                    }
                    if (B.JSString_methods.contains$1(trace, string$.x3d_____)) {
                        t1 = A.Chain_Chain$parse(trace).toTrace$0();
                        return t1;
                    }
                    if (B.JSString_methods.contains$1(trace, $.$get$_friendlyTrace())) {
                        t1 = A.Trace$parseFriendly(trace);
                        return t1;
                    }
                    t1 = A.Trace$parseVM(trace);
                    return t1;
                } catch (exception) {
                    t1 = A.unwrapException(exception);
                    if (type$.FormatException._is(t1)) {
                        error = t1;
                        throw A.wrapException(A.FormatException$(J.get$message$x(error) + "\nStack trace:\n" + trace, null, null));
                    } else throw exception;
                }
            },
            Trace___parseVM_tearOff: function(trace) {
                return A.Trace$parseVM(trace);
            },
            Trace$parseVM: function(trace) {
                var t1 = A.List_List$unmodifiable(A.Trace__parseVM(trace), type$.Frame);
                return new A.Trace(t1, new A._StringStackTrace(trace));
            },
            Trace__parseVM: function(trace) {
                var $frames, t1 = B.JSString_methods.trim$0(trace), t2 = $.$get$vmChainGap(), t3 = type$.WhereIterable_String, lines = new A.WhereIterable(A._setArrayType(A.stringReplaceAllUnchecked(t1, t2, "").split("\n"), type$.JSArray_String), new A.Trace__parseVM_closure(), t3);
                if (!lines.get$iterator(0).moveNext$0()) return A._setArrayType([], type$.JSArray_Frame);
                t1 = A.TakeIterable_TakeIterable(lines, lines.get$length(0) - 1, t3._eval$1("Iterable.E"));
                t1 = A.MappedIterable_MappedIterable(t1, A.frame_Frame___parseVM_tearOff$closure(), A._instanceType(t1)._eval$1("Iterable.E"), type$.Frame);
                $frames = A.List_List$_of(t1, A._instanceType(t1)._eval$1("Iterable.E"));
                if (!B.JSString_methods.endsWith$1(lines.get$last(0), ".da")) $frames.push(A.Frame_Frame$parseVM(lines.get$last(0)));
                return $frames;
            },
            Trace$parseV8: function(trace) {
                var t1 = A.SubListIterable$(A._setArrayType(trace.split("\n"), type$.JSArray_String), 1, null, type$.String).super$Iterable$skipWhile(0, new A.Trace$parseV8_closure()), t2 = type$.Frame;
                t2 = A.List_List$unmodifiable(A.MappedIterable_MappedIterable(t1, A.frame_Frame___parseV8_tearOff$closure(), t1.$ti._eval$1("Iterable.E"), t2), t2);
                return new A.Trace(t2, new A._StringStackTrace(trace));
            },
            Trace$parseJSCore: function(trace) {
                var t1 = A.List_List$unmodifiable(new A.MappedIterable(new A.WhereIterable(A._setArrayType(trace.split("\n"), type$.JSArray_String), new A.Trace$parseJSCore_closure(), type$.WhereIterable_String), A.frame_Frame___parseV8_tearOff$closure(), type$.MappedIterable_String_Frame), type$.Frame);
                return new A.Trace(t1, new A._StringStackTrace(trace));
            },
            Trace$parseFirefox: function(trace) {
                var t1 = A.List_List$unmodifiable(new A.MappedIterable(new A.WhereIterable(A._setArrayType(B.JSString_methods.trim$0(trace).split("\n"), type$.JSArray_String), new A.Trace$parseFirefox_closure(), type$.WhereIterable_String), A.frame_Frame___parseFirefox_tearOff$closure(), type$.MappedIterable_String_Frame), type$.Frame);
                return new A.Trace(t1, new A._StringStackTrace(trace));
            },
            Trace___parseFriendly_tearOff: function(trace) {
                return A.Trace$parseFriendly(trace);
            },
            Trace$parseFriendly: function(trace) {
                var t1 = trace.length === 0 ? A._setArrayType([], type$.JSArray_Frame) : new A.MappedIterable(new A.WhereIterable(A._setArrayType(B.JSString_methods.trim$0(trace).split("\n"), type$.JSArray_String), new A.Trace$parseFriendly_closure(), type$.WhereIterable_String), A.frame_Frame___parseFriendly_tearOff$closure(), type$.MappedIterable_String_Frame);
                t1 = A.List_List$unmodifiable(t1, type$.Frame);
                return new A.Trace(t1, new A._StringStackTrace(trace));
            },
            Trace$: function($frames, original) {
                var t1 = A.List_List$unmodifiable($frames, type$.Frame);
                return new A.Trace(t1, new A._StringStackTrace(original == null ? "" : original));
            },
            Trace: function Trace(t0, t1) {
                this.frames = t0;
                this.original = t1;
            },
            Trace_Trace$from_closure: function Trace_Trace$from_closure(t0) {
                this.trace = t0;
            },
            Trace__parseVM_closure: function Trace__parseVM_closure() {},
            Trace$parseV8_closure: function Trace$parseV8_closure() {},
            Trace$parseJSCore_closure: function Trace$parseJSCore_closure() {},
            Trace$parseFirefox_closure: function Trace$parseFirefox_closure() {},
            Trace$parseFriendly_closure: function Trace$parseFriendly_closure() {},
            Trace_terse_closure: function Trace_terse_closure() {},
            Trace_foldFrames_closure: function Trace_foldFrames_closure(t0) {
                this.oldPredicate = t0;
            },
            Trace_foldFrames_closure0: function Trace_foldFrames_closure0(t0) {
                this._box_0 = t0;
            },
            Trace_toString_closure0: function Trace_toString_closure0() {},
            Trace_toString_closure: function Trace_toString_closure(t0) {
                this.longest = t0;
            },
            UnparsedFrame: function UnparsedFrame(t0, t1) {
                this.uri = t0;
                this.member = t1;
            },
            TransformByHandlers_transformByHandlers: function(_this, onData, onDone, $S, $T) {
                var _null = null, t1 = {}, controller = A.StreamController_StreamController(_null, _null, _null, _null, true, $T);
                t1.subscription = null;
                controller.onListen = new A.TransformByHandlers_transformByHandlers_closure(t1, _this, onData, controller, A.instantiate1(A.from_handlers__TransformByHandlers__defaultHandleError$closure(), $T), onDone, $S);
                return controller.get$stream();
            },
            TransformByHandlers__defaultHandleError: function(error, stackTrace, sink) {
                sink.addError$2(error, stackTrace);
            },
            TransformByHandlers_transformByHandlers_closure: function TransformByHandlers_transformByHandlers_closure(t0, t1, t2, t3, t4, t5, t6) {
                var _ = this;
                _._box_1 = t0;
                _._this = t1;
                _.onData = t2;
                _.controller = t3;
                _.handleError = t4;
                _.handleDone = t5;
                _.S = t6;
            },
            TransformByHandlers_transformByHandlers__closure: function TransformByHandlers_transformByHandlers__closure(t0, t1, t2) {
                this.onData = t0;
                this.controller = t1;
                this.S = t2;
            },
            TransformByHandlers_transformByHandlers__closure1: function TransformByHandlers_transformByHandlers__closure1(t0, t1) {
                this.handleError = t0;
                this.controller = t1;
            },
            TransformByHandlers_transformByHandlers__closure0: function TransformByHandlers_transformByHandlers__closure0(t0, t1, t2) {
                this._box_0 = t0;
                this.handleDone = t1;
                this.controller = t2;
            },
            TransformByHandlers_transformByHandlers__closure2: function TransformByHandlers_transformByHandlers__closure2(t0, t1) {
                this._box_1 = t0;
                this._box_0 = t1;
            },
            RateLimit__debounceAggregate: function(_this, duration, collect, leading, trailing, $T, $S) {
                var t1 = {};
                t1.soFar = t1.timer = null;
                t1.emittedLatestAsLeading = t1.shouldClose = t1.hasPending = false;
                return A.TransformByHandlers_transformByHandlers(_this, new A.RateLimit__debounceAggregate_closure(t1, $S, collect, false, duration, true, $T), new A.RateLimit__debounceAggregate_closure0(t1, true, $S), $T, $S);
            },
            _collect: function($event, soFar, $T) {
                var t1 = soFar == null ? A._setArrayType([], $T._eval$1("JSArray<0>")) : soFar;
                J.add$1$ax(t1, $event);
                return t1;
            },
            RateLimit__debounceAggregate_closure: function RateLimit__debounceAggregate_closure(t0, t1, t2, t3, t4, t5, t6) {
                var _ = this;
                _._box_0 = t0;
                _.S = t1;
                _.collect = t2;
                _.leading = t3;
                _.duration = t4;
                _.trailing = t5;
                _.T = t6;
            },
            RateLimit__debounceAggregate_closure_emit: function RateLimit__debounceAggregate_closure_emit(t0, t1, t2) {
                this._box_0 = t0;
                this.sink = t1;
                this.S = t2;
            },
            RateLimit__debounceAggregate__closure: function RateLimit__debounceAggregate__closure(t0, t1, t2, t3) {
                var _ = this;
                _._box_0 = t0;
                _.trailing = t1;
                _.emit = t2;
                _.sink = t3;
            },
            RateLimit__debounceAggregate_closure0: function RateLimit__debounceAggregate_closure0(t0, t1, t2) {
                this._box_0 = t0;
                this.trailing = t1;
                this.S = t2;
            },
            StringScannerException$: function(message, span, source) {
                return new A.StringScannerException(source, message, span);
            },
            StringScannerException: function StringScannerException(t0, t1, t2) {
                this.source = t0;
                this._span_exception$_message = t1;
                this._span = t2;
            },
            LineScanner$: function(string) {
                return new A.LineScanner(null, string);
            },
            LineScanner: function LineScanner(t0, t1) {
                var _ = this;
                _._line_scanner$_column = _._line_scanner$_line = 0;
                _.sourceUrl = t0;
                _.string = t1;
                _._string_scanner$_position = 0;
                _._lastMatchPosition = _._lastMatch = null;
            },
            SpanScanner$: function(string, sourceUrl) {
                var t2, t1 = A.SourceFile$fromString(string, sourceUrl);
                if (sourceUrl == null) t2 = null;
                else t2 = typeof sourceUrl == "string" ? A.Uri_parse(sourceUrl) : type$.Uri._as(sourceUrl);
                return new A.SpanScanner(t1, t2, string);
            },
            SpanScanner: function SpanScanner(t0, t1, t2) {
                var _ = this;
                _._sourceFile = t0;
                _.sourceUrl = t1;
                _.string = t2;
                _._string_scanner$_position = 0;
                _._lastMatchPosition = _._lastMatch = null;
            },
            _SpanScannerState: function _SpanScannerState(t0, t1) {
                this._scanner = t0;
                this.position = t1;
            },
            StringScanner$: function(string, position, sourceUrl) {
                var t1;
                if (sourceUrl == null) t1 = null;
                else t1 = typeof sourceUrl == "string" ? A.Uri_parse(sourceUrl) : type$.Uri._as(sourceUrl);
                return new A.StringScanner(t1, string);
            },
            StringScanner: function StringScanner(t0, t1) {
                var _ = this;
                _.sourceUrl = t0;
                _.string = t1;
                _._string_scanner$_position = 0;
                _._lastMatchPosition = _._lastMatch = null;
            },
            AsciiGlyphSet: function AsciiGlyphSet() {},
            UnicodeGlyphSet: function UnicodeGlyphSet() {},
            WatchEvent: function WatchEvent(t0, t1) {
                this.type = t0;
                this.path = t1;
            },
            ChangeType: function ChangeType(t0) {
                this._watch_event$_name = t0;
            },
            A98RgbColorSpace0: function A98RgbColorSpace0(t0, t1) {
                this.name = t0;
                this._space$_channels = t1;
            },
            AnySelectorVisitor0: function AnySelectorVisitor0() {},
            AnySelectorVisitor_visitComplexSelector_closure0: function AnySelectorVisitor_visitComplexSelector_closure0(t0) {
                this.$this = t0;
            },
            AnySelectorVisitor_visitCompoundSelector_closure0: function AnySelectorVisitor_visitCompoundSelector_closure0(t0) {
                this.$this = t0;
            },
            SupportsAnything0: function SupportsAnything0(t0, t1) {
                this.contents = t0;
                this.span = t1;
            },
            ArgumentList$0: function(positional, named, namedSpans, span, keywordRest, rest) {
                var t1 = type$.Expression_2, t2 = type$.String;
                return new A.ArgumentList0(A.List_List$unmodifiable(positional, t1), A.ConstantMap_ConstantMap$from(named, t2, t1), A.ConstantMap_ConstantMap$from(namedSpans, t2, type$.FileSpan), rest, keywordRest, span);
            },
            ArgumentList$empty0: function(span) {
                return new A.ArgumentList0(B.List_empty24, B.Map_empty14, B.Map_empty5, null, null, span);
            },
            ArgumentList0: function ArgumentList0(t0, t1, t2, t3, t4, t5) {
                var _ = this;
                _.positional = t0;
                _.named = t1;
                _.namedSpans = t2;
                _.rest = t3;
                _.keywordRest = t4;
                _.span = t5;
            },
            argumentListClass_closure: function argumentListClass_closure() {},
            argumentListClass__closure: function argumentListClass__closure() {},
            argumentListClass__closure0: function argumentListClass__closure0() {},
            SassArgumentList$0: function(contents, keywords, separator) {
                var t1 = type$.Value_2;
                t1 = new A.SassArgumentList0(A.ConstantMap_ConstantMap$from(keywords, type$.String, t1), A.List_List$unmodifiable(contents, t1), separator, false);
                t1.SassList$3$brackets0(contents, separator, false);
                return t1;
            },
            SassArgumentList0: function SassArgumentList0(t0, t1, t2, t3) {
                var _ = this;
                _._argument_list$_keywords = t0;
                _._argument_list$_wereKeywordsAccessed = false;
                _._list1$_contents = t1;
                _._list1$_separator = t2;
                _._list1$_hasBrackets = t3;
            },
            JSArray1: function JSArray1() {},
            AsyncImporter0: function AsyncImporter0() {},
            JSToDartAsyncImporter: function JSToDartAsyncImporter(t0, t1, t2) {
                this._async0$_canonicalize = t0;
                this._load = t1;
                this._nonCanonicalSchemes = t2;
            },
            JSToDartAsyncImporter_canonicalize_closure: function JSToDartAsyncImporter_canonicalize_closure(t0, t1) {
                this.$this = t0;
                this.url = t1;
            },
            JSToDartAsyncImporter_load_closure: function JSToDartAsyncImporter_load_closure(t0, t1) {
                this.$this = t0;
                this.url = t1;
            },
            AsyncBuiltInCallable$mixin0: function($name, parameters, callback, acceptsContent, url) {
                return new A.AsyncBuiltInCallable0($name, A.ScssParser$0("@mixin " + $name + "(" + parameters + ") {", false, url).parseParameterList$0(), new A.AsyncBuiltInCallable$mixin_closure0(callback), false);
            },
            AsyncBuiltInCallable0: function AsyncBuiltInCallable0(t0, t1, t2, t3) {
                var _ = this;
                _.name = t0;
                _._async_built_in0$_parameters = t1;
                _._async_built_in0$_callback = t2;
                _.acceptsContent = t3;
            },
            AsyncBuiltInCallable$mixin_closure0: function AsyncBuiltInCallable$mixin_closure0(t0) {
                this.callback = t0;
            },
            AsyncBuiltInCallable_withDeprecationWarning_closure0: function AsyncBuiltInCallable_withDeprecationWarning_closure0(t0, t1, t2) {
                this.$this = t0;
                this.module = t1;
                this.newName = t2;
            },
            compileAsync0: function(path, charset, fatalDeprecations, functions, futureDeprecations, importCache, indentWidth, lineFeed, logger, nodeImporter, quietDeps, silenceDeprecations, sourceMap, style, syntax, useSpaces, verbose) {
                var $async$goto = 0, $async$completer = A._makeAsyncAwaitCompleter(type$.CompileResult_2), $async$returnValue, t3, t4, t0, stylesheet, result, t1, t2;
                var $async$compileAsync0 = A._wrapJsFunctionForAsync(function($async$errorCode, $async$result) {
                    if ($async$errorCode === 1) return A._asyncRethrow($async$result, $async$completer);
                    for(;;)switch($async$goto){
                        case 0:
                            // Function start
                            t1 = type$.Deprecation_3;
                            t2 = A.LinkedHashSet_LinkedHashSet$_empty(t1);
                            if (silenceDeprecations != null) t2.addAll$1(0, silenceDeprecations);
                            t3 = A.LinkedHashSet_LinkedHashSet$_empty(t1);
                            if (fatalDeprecations != null) t3.addAll$1(0, fatalDeprecations);
                            t4 = A.LinkedHashSet_LinkedHashSet$_empty(t1);
                            if (futureDeprecations != null) t4.addAll$1(0, futureDeprecations);
                            logger = new A.DeprecationProcessingLogger0(A.LinkedHashMap_LinkedHashMap$_empty(t1, type$.int), logger, t2, t3, t4, !verbose);
                            logger.validate$0();
                            t1 = nodeImporter == null;
                            if (t1) t2 = syntax == null || syntax === A.Syntax_forPath0(path);
                            else t2 = false;
                            $async$goto = t2 ? 3 : 5;
                            break;
                        case 3:
                            // then
                            if (importCache == null) importCache = A.AsyncImportCache$none();
                            t2 = $.$get$FilesystemImporter_cwd0();
                            t3 = A.isNodeJs() ? self.process : null;
                            if (!J.$eq$(t3 == null ? null : J.get$platform$x(t3), "win32")) {
                                t3 = A.isNodeJs() ? self.process : null;
                                t3 = J.$eq$(t3 == null ? null : J.get$platform$x(t3), "darwin");
                            } else t3 = true;
                            if (t3) {
                                t3 = A.absolute(path, null, null, null, null, null, null, null, null, null, null, null, null, null, null);
                                t4 = $.$get$context();
                                t3 = A._realCasePath0(t4.normalize$1(t3));
                            } else {
                                t3 = $.$get$context();
                                t4 = t3.canonicalize$1(0, path);
                                t0 = t4;
                                t4 = t3;
                                t3 = t0;
                            }
                            $async$goto = 6;
                            return A._asyncAwait(importCache.importCanonical$3$originalUrl(t2, t4.toUri$1(t3), t4.toUri$1(path)), $async$compileAsync0);
                        case 6:
                            // returning from await.
                            t4 = $async$result;
                            t4.toString;
                            stylesheet = t4;
                            // goto join
                            $async$goto = 4;
                            break;
                        case 5:
                            // else
                            t2 = A.readFile0(path);
                            t3 = syntax == null ? A.Syntax_forPath0(path) : syntax;
                            stylesheet = A.Stylesheet_Stylesheet$parse0(t2, t3, false, $.$get$context().toUri$1(path));
                        case 4:
                            // join
                            $async$goto = 7;
                            return A._asyncAwait(A._compileStylesheet2(stylesheet, logger, importCache, nodeImporter, $.$get$FilesystemImporter_cwd0(), functions, style, useSpaces, indentWidth, lineFeed, quietDeps, sourceMap, charset), $async$compileAsync0);
                        case 7:
                            // returning from await.
                            result = $async$result;
                            logger.summarize$1$js(!t1);
                            $async$returnValue = result;
                            // goto return
                            $async$goto = 1;
                            break;
                        case 1:
                            // return
                            return A._asyncReturn($async$returnValue, $async$completer);
                    }
                });
                return A._asyncStartSync($async$compileAsync0, $async$completer);
            },
            compileStringAsync0: function(source, charset, fatalDeprecations, functions, futureDeprecations, importCache, importer, indentWidth, lineFeed, logger, nodeImporter, quietDeps, silenceDeprecations, sourceMap, style, syntax, url, useSpaces, verbose) {
                var $async$goto = 0, $async$completer = A._makeAsyncAwaitCompleter(type$.CompileResult_2), $async$returnValue, t3, t4, stylesheet, _0_0, result, t1, t2;
                var $async$compileStringAsync0 = A._wrapJsFunctionForAsync(function($async$errorCode, $async$result) {
                    if ($async$errorCode === 1) return A._asyncRethrow($async$result, $async$completer);
                    for(;;)switch($async$goto){
                        case 0:
                            // Function start
                            t1 = type$.Deprecation_3;
                            t2 = A.LinkedHashSet_LinkedHashSet$_empty(t1);
                            if (silenceDeprecations != null) t2.addAll$1(0, silenceDeprecations);
                            t3 = A.LinkedHashSet_LinkedHashSet$_empty(t1);
                            if (fatalDeprecations != null) t3.addAll$1(0, fatalDeprecations);
                            t4 = A.LinkedHashSet_LinkedHashSet$_empty(t1);
                            if (futureDeprecations != null) t4.addAll$1(0, futureDeprecations);
                            logger = new A.DeprecationProcessingLogger0(A.LinkedHashMap_LinkedHashMap$_empty(t1, type$.int), logger, t2, t3, t4, !verbose);
                            logger.validate$0();
                            stylesheet = A.Stylesheet_Stylesheet$parse0(source, syntax == null ? B.Syntax_SCSS_0_scss0 : syntax, false, url);
                            t1 = stylesheet.span;
                            _0_0 = t1.get$sourceUrl(t1);
                            if (type$.Uri._is(_0_0) && "" === _0_0.get$scheme() && nodeImporter == null) A.WarnForDeprecation_warnForDeprecation0(logger, B.Deprecation_y9Y, "Passing a relative `url` argument (" + A.S(t1.get$sourceUrl(t1)) + string$.x29x20to_cm, null, null);
                            if (importer == null) t1 = A.isBrowser() ? new A.NoOpImporter0() : $.$get$FilesystemImporter_cwd0();
                            else t1 = importer;
                            $async$goto = 3;
                            return A._asyncAwait(A._compileStylesheet2(stylesheet, logger, importCache, nodeImporter, t1, functions, style, useSpaces, indentWidth, lineFeed, quietDeps, sourceMap, charset), $async$compileStringAsync0);
                        case 3:
                            // returning from await.
                            result = $async$result;
                            logger.summarize$1$js(nodeImporter != null);
                            $async$returnValue = result;
                            // goto return
                            $async$goto = 1;
                            break;
                        case 1:
                            // return
                            return A._asyncReturn($async$returnValue, $async$completer);
                    }
                });
                return A._asyncStartSync($async$compileStringAsync0, $async$completer);
            },
            _compileStylesheet2: function(stylesheet, logger, importCache, nodeImporter, importer, functions, style, useSpaces, indentWidth, lineFeed, quietDeps, sourceMap, charset) {
                var $async$goto = 0, $async$completer = A._makeAsyncAwaitCompleter(type$.CompileResult_2), $async$returnValue, evaluateResult, serializeResult, resultSourceMap;
                var $async$_compileStylesheet2 = A._wrapJsFunctionForAsync(function($async$errorCode, $async$result) {
                    if ($async$errorCode === 1) return A._asyncRethrow($async$result, $async$completer);
                    for(;;)switch($async$goto){
                        case 0:
                            // Function start
                            if (nodeImporter != null) A.WarnForDeprecation_warnForDeprecation0(logger, B.Deprecation_PGp, string$.The_le, null, null);
                            $async$goto = 3;
                            return A._asyncAwait(A._EvaluateVisitor$2(functions, importCache, logger, nodeImporter, quietDeps, sourceMap).run$2(0, importer, stylesheet), $async$_compileStylesheet2);
                        case 3:
                            // returning from await.
                            evaluateResult = $async$result;
                            serializeResult = A.serialize0(evaluateResult._1, charset, indentWidth, false, lineFeed, logger, sourceMap, style, useSpaces);
                            resultSourceMap = serializeResult._1;
                            if (resultSourceMap != null && importCache != null) A.mapInPlace0(resultSourceMap.urls, new A._compileStylesheet_closure2(stylesheet, importCache));
                            $async$returnValue = new A.CompileResult0(evaluateResult, serializeResult);
                            // goto return
                            $async$goto = 1;
                            break;
                        case 1:
                            // return
                            return A._asyncReturn($async$returnValue, $async$completer);
                    }
                });
                return A._asyncStartSync($async$_compileStylesheet2, $async$completer);
            },
            _compileStylesheet_closure2: function _compileStylesheet_closure2(t0, t1) {
                this.stylesheet = t0;
                this.importCache = t1;
            },
            AsyncEnvironment$0: function() {
                var t1 = type$.String, t2 = type$.Module_AsyncCallable_2, t3 = type$.AstNode_2, t4 = type$.int, t5 = type$.AsyncCallable_2, t6 = type$.JSArray_Map_String_AsyncCallable_2;
                return new A.AsyncEnvironment0(A.LinkedHashMap_LinkedHashMap$_empty(t1, t2), A.LinkedHashMap_LinkedHashMap$_empty(t1, t3), A.LinkedHashMap_LinkedHashMap$_empty(t2, t3), A.LinkedHashMap_LinkedHashMap$_empty(t2, t3), null, null, A._setArrayType([], type$.JSArray_Module_AsyncCallable_2), A._setArrayType([
                    A.LinkedHashMap_LinkedHashMap$_empty(t1, type$.Value_2)
                ], type$.JSArray_Map_String_Value_2), A._setArrayType([
                    A.LinkedHashMap_LinkedHashMap$_empty(t1, t3)
                ], type$.JSArray_Map_String_AstNode_2), A.LinkedHashMap_LinkedHashMap$_empty(t1, t4), A._setArrayType([
                    A.LinkedHashMap_LinkedHashMap$_empty(t1, t5)
                ], t6), A.LinkedHashMap_LinkedHashMap$_empty(t1, t4), A._setArrayType([
                    A.LinkedHashMap_LinkedHashMap$_empty(t1, t5)
                ], t6), A.LinkedHashMap_LinkedHashMap$_empty(t1, t4), null, A.LinkedHashSet_LinkedHashSet$_empty(t1));
            },
            AsyncEnvironment$_0: function(_modules, _namespaceNodes, _globalModules, _importedModules, _forwardedModules, _nestedForwardedModules, _allModules, _variables, _variableNodes, _functions, _mixins, _content, _configurableVariables) {
                var t1 = type$.String, t2 = type$.int;
                return new A.AsyncEnvironment0(_modules, _namespaceNodes, _globalModules, _importedModules, _forwardedModules, _nestedForwardedModules, _allModules, _variables, _variableNodes, A.LinkedHashMap_LinkedHashMap$_empty(t1, t2), _functions, A.LinkedHashMap_LinkedHashMap$_empty(t1, t2), _mixins, A.LinkedHashMap_LinkedHashMap$_empty(t1, t2), _content, _configurableVariables);
            },
            _EnvironmentModule__EnvironmentModule2: function(environment, css, preModuleComments, extensionStore, forwarded) {
                var t1, t2, t3, t4, t5, t6, module, result, t7;
                if (forwarded == null) forwarded = B.Set_empty7;
                t1 = type$.dynamic;
                t1 = A.LinkedHashMap_LinkedHashMap$_empty(t1, t1);
                for(t2 = type$.Module_AsyncCallable_2, t3 = type$.List_CssComment_2, t4 = A.MapExtensions_get_pairs0(preModuleComments, t2, t3), t4 = t4.get$iterator(t4), t5 = type$.CssComment_2; t4.moveNext$0();){
                    t6 = t4.get$current(t4);
                    module = t6._0;
                    result = A.List_List$from(t6._1, false, t5);
                    result.$flags = 3;
                    t1.$indexSet(0, module, result);
                }
                t1 = A.ConstantMap_ConstantMap$from(t1, t2, t3);
                t2 = A._EnvironmentModule__makeModulesByVariable2(forwarded);
                t3 = A._EnvironmentModule__memberMap2(B.JSArray_methods.get$first(environment._async_environment0$_variables), forwarded.map$1$1(0, new A._EnvironmentModule__EnvironmentModule_closure17(), type$.Map_String_Value_2), type$.Value_2);
                t4 = A._EnvironmentModule__memberMap2(B.JSArray_methods.get$first(environment._async_environment0$_variableNodes), forwarded.map$1$1(0, new A._EnvironmentModule__EnvironmentModule_closure18(), type$.Map_String_AstNode_2), type$.AstNode_2);
                t5 = type$.Map_String_AsyncCallable_2;
                t6 = type$.AsyncCallable_2;
                t7 = A._EnvironmentModule__memberMap2(B.JSArray_methods.get$first(environment._async_environment0$_functions), forwarded.map$1$1(0, new A._EnvironmentModule__EnvironmentModule_closure19(), t5), t6);
                t6 = A._EnvironmentModule__memberMap2(B.JSArray_methods.get$first(environment._async_environment0$_mixins), forwarded.map$1$1(0, new A._EnvironmentModule__EnvironmentModule_closure20(), t5), t6);
                t5 = J.get$isNotEmpty$asx(css.get$children(css)) || preModuleComments.get$isNotEmpty(preModuleComments) || B.JSArray_methods.any$1(environment._async_environment0$_allModules, new A._EnvironmentModule__EnvironmentModule_closure21());
                return A._EnvironmentModule$_2(environment, css, t1, extensionStore, t2, t3, t4, t7, t6, t5, !extensionStore.get$isEmpty(extensionStore) || B.JSArray_methods.any$1(environment._async_environment0$_allModules, new A._EnvironmentModule__EnvironmentModule_closure22()));
            },
            _EnvironmentModule__makeModulesByVariable2: function(forwarded) {
                var modulesByVariable, t1, t2, t3, t4, t5;
                if (forwarded.get$isEmpty(forwarded)) return B.Map_empty17;
                modulesByVariable = A.LinkedHashMap_LinkedHashMap$_empty(type$.String, type$.Module_AsyncCallable_2);
                for(t1 = forwarded.get$iterator(forwarded); t1.moveNext$0();){
                    t2 = t1.get$current(t1);
                    if (t2 instanceof A._EnvironmentModule2) {
                        for(t3 = t2._async_environment0$_modulesByVariable, t3 = t3.get$values(t3), t3 = t3.get$iterator(t3); t3.moveNext$0();){
                            t4 = t3.get$current(t3);
                            t5 = t4.get$variables();
                            A.setAll0(modulesByVariable, t5.get$keys(t5), t4);
                        }
                        t3 = B.JSArray_methods.get$first(t2._async_environment0$_environment._async_environment0$_variables);
                        A.setAll0(modulesByVariable, t3.get$keys(t3), t2);
                    } else {
                        t3 = t2.get$variables();
                        A.setAll0(modulesByVariable, t3.get$keys(t3), t2);
                    }
                }
                return modulesByVariable;
            },
            _EnvironmentModule__memberMap2: function(localMap, otherMaps, $V) {
                var t1, t2, t3;
                localMap = new A.PublicMemberMapView0(localMap, $V._eval$1("PublicMemberMapView0<0>"));
                if (otherMaps.get$isEmpty(otherMaps)) return localMap;
                t1 = A._setArrayType([], $V._eval$1("JSArray<Map<String,0>>"));
                for(t2 = otherMaps.get$iterator(otherMaps); t2.moveNext$0();){
                    t3 = t2.get$current(t2);
                    if (t3.get$isNotEmpty(t3)) t1.push(t3);
                }
                t1.push(localMap);
                if (t1.length === 1) return localMap;
                return A.MergedMapView$0(t1, type$.String, $V);
            },
            _EnvironmentModule$_2: function(_environment, css, preModuleComments, extensionStore, _modulesByVariable, variables, variableNodes, functions, mixins, transitivelyContainsCss, transitivelyContainsExtensions) {
                return new A._EnvironmentModule2(_environment._async_environment0$_allModules, variables, variableNodes, functions, mixins, extensionStore, css, preModuleComments, transitivelyContainsCss, transitivelyContainsExtensions, _environment, _modulesByVariable);
            },
            AsyncEnvironment0: function AsyncEnvironment0(t0, t1, t2, t3, t4, t5, t6, t7, t8, t9, t10, t11, t12, t13, t14, t15) {
                var _ = this;
                _._async_environment0$_modules = t0;
                _._async_environment0$_namespaceNodes = t1;
                _._async_environment0$_globalModules = t2;
                _._async_environment0$_importedModules = t3;
                _._async_environment0$_forwardedModules = t4;
                _._async_environment0$_nestedForwardedModules = t5;
                _._async_environment0$_allModules = t6;
                _._async_environment0$_variables = t7;
                _._async_environment0$_variableNodes = t8;
                _._async_environment0$_variableIndices = t9;
                _._async_environment0$_functions = t10;
                _._async_environment0$_functionIndices = t11;
                _._async_environment0$_mixins = t12;
                _._async_environment0$_mixinIndices = t13;
                _._async_environment0$_content = t14;
                _._async_environment0$_configurableVariables = t15;
                _._async_environment0$_inMixin = false;
                _._async_environment0$_inSemiGlobalScope = true;
                _._async_environment0$_lastVariableIndex = _._async_environment0$_lastVariableName = null;
            },
            AsyncEnvironment__getVariableFromGlobalModule_closure0: function AsyncEnvironment__getVariableFromGlobalModule_closure0(t0) {
                this.name = t0;
            },
            AsyncEnvironment_setVariable_closure2: function AsyncEnvironment_setVariable_closure2(t0, t1) {
                this.$this = t0;
                this.name = t1;
            },
            AsyncEnvironment_setVariable_closure3: function AsyncEnvironment_setVariable_closure3(t0) {
                this.name = t0;
            },
            AsyncEnvironment_setVariable_closure4: function AsyncEnvironment_setVariable_closure4(t0, t1) {
                this.$this = t0;
                this.name = t1;
            },
            AsyncEnvironment__getFunctionFromGlobalModule_closure0: function AsyncEnvironment__getFunctionFromGlobalModule_closure0(t0) {
                this.name = t0;
            },
            AsyncEnvironment__getMixinFromGlobalModule_closure0: function AsyncEnvironment__getMixinFromGlobalModule_closure0(t0) {
                this.name = t0;
            },
            AsyncEnvironment_toModule_closure0: function AsyncEnvironment_toModule_closure0() {},
            AsyncEnvironment_toDummyModule_closure0: function AsyncEnvironment_toDummyModule_closure0() {},
            _EnvironmentModule2: function _EnvironmentModule2(t0, t1, t2, t3, t4, t5, t6, t7, t8, t9, t10, t11) {
                var _ = this;
                _.upstream = t0;
                _.variables = t1;
                _.variableNodes = t2;
                _.functions = t3;
                _.mixins = t4;
                _.extensionStore = t5;
                _.css = t6;
                _.preModuleComments = t7;
                _.transitivelyContainsCss = t8;
                _.transitivelyContainsExtensions = t9;
                _._async_environment0$_environment = t10;
                _._async_environment0$_modulesByVariable = t11;
            },
            _EnvironmentModule__EnvironmentModule_closure17: function _EnvironmentModule__EnvironmentModule_closure17() {},
            _EnvironmentModule__EnvironmentModule_closure18: function _EnvironmentModule__EnvironmentModule_closure18() {},
            _EnvironmentModule__EnvironmentModule_closure19: function _EnvironmentModule__EnvironmentModule_closure19() {},
            _EnvironmentModule__EnvironmentModule_closure20: function _EnvironmentModule__EnvironmentModule_closure20() {},
            _EnvironmentModule__EnvironmentModule_closure21: function _EnvironmentModule__EnvironmentModule_closure21() {},
            _EnvironmentModule__EnvironmentModule_closure22: function _EnvironmentModule__EnvironmentModule_closure22() {},
            _EnvironmentModule_couldHaveBeenConfigured_closure2: function _EnvironmentModule_couldHaveBeenConfigured_closure2(t0) {
                this.variables = t0;
            },
            _EvaluateVisitor$2: function(functions, importCache, logger, nodeImporter, quietDeps, sourceMap) {
                var t4, t1 = type$.Uri, t2 = type$.Module_AsyncCallable_2, t3 = A._setArrayType([], type$.JSArray_Record_2_String_and_AstNode_2);
                if (importCache == null) t4 = nodeImporter == null ? A.AsyncImportCache$none() : null;
                else t4 = importCache;
                t1 = new A._EvaluateVisitor2(t4, nodeImporter, A.LinkedHashMap_LinkedHashMap$_empty(type$.String, type$.AsyncCallable_2), A.LinkedHashMap_LinkedHashMap$_empty(t1, t2), A.LinkedHashMap_LinkedHashMap$_empty(t1, t2), A.LinkedHashMap_LinkedHashMap$_empty(t1, type$.Configuration_2), A.LinkedHashMap_LinkedHashMap$_empty(t1, type$.AstNode_2), logger, A.LinkedHashSet_LinkedHashSet$_empty(type$.Record_2_String_and_SourceSpan), quietDeps, sourceMap, new A.Object(), A.AsyncEnvironment$0(), A.LinkedHashSet_LinkedHashSet$_empty(t1), A.LinkedHashMap_LinkedHashMap$_empty(t1, type$.nullable_AstNode_2), t3, B.Configuration_Map_empty_null0);
                t1._EvaluateVisitor$6$functions$importCache$logger$nodeImporter$quietDeps$sourceMap2(functions, importCache, logger, nodeImporter, quietDeps, sourceMap);
                return t1;
            },
            _EvaluateVisitor2: function _EvaluateVisitor2(t0, t1, t2, t3, t4, t5, t6, t7, t8, t9, t10, t11, t12, t13, t14, t15, t16) {
                var _ = this;
                _._async_evaluate0$_importCache = t0;
                _._async_evaluate0$_nodeImporter = t1;
                _._async_evaluate0$_builtInFunctions = t2;
                _._async_evaluate0$_builtInModules = t3;
                _._async_evaluate0$_modules = t4;
                _._async_evaluate0$_moduleConfigurations = t5;
                _._async_evaluate0$_moduleNodes = t6;
                _._async_evaluate0$_logger = t7;
                _._async_evaluate0$_warningsEmitted = t8;
                _._async_evaluate0$_quietDeps = t9;
                _._async_evaluate0$_sourceMap = t10;
                _._async_evaluate0$_compileContext = t11;
                _._async_evaluate0$_environment = t12;
                _._async_evaluate0$_declarationName = _._async_evaluate0$__parent = _._async_evaluate0$_mediaQuerySources = _._async_evaluate0$_mediaQueries = _._async_evaluate0$_styleRuleIgnoringAtRoot = null;
                _._async_evaluate0$_member = "root stylesheet";
                _._async_evaluate0$_importSpan = _._async_evaluate0$_callableNode = null;
                _._async_evaluate0$_inSupportsDeclaration = _._async_evaluate0$_inKeyframes = _._async_evaluate0$_atRootExcludingStyleRule = _._async_evaluate0$_inUnknownAtRule = _._async_evaluate0$_inFunction = false;
                _._async_evaluate0$_loadedUrls = t13;
                _._async_evaluate0$_activeModules = t14;
                _._async_evaluate0$_stack = t15;
                _._async_evaluate0$_importer = null;
                _._async_evaluate0$_inDependency = false;
                _._async_evaluate0$__extensionStore = _._async_evaluate0$_preModuleComments = _._async_evaluate0$_outOfOrderImports = _._async_evaluate0$__endOfImports = _._async_evaluate0$__root = _._async_evaluate0$__stylesheet = null;
                _._async_evaluate0$_configuration = t16;
            },
            _EvaluateVisitor_closure38: function _EvaluateVisitor_closure38(t0) {
                this.$this = t0;
            },
            _EvaluateVisitor_closure39: function _EvaluateVisitor_closure39(t0) {
                this.$this = t0;
            },
            _EvaluateVisitor_closure40: function _EvaluateVisitor_closure40(t0) {
                this.$this = t0;
            },
            _EvaluateVisitor_closure41: function _EvaluateVisitor_closure41(t0) {
                this.$this = t0;
            },
            _EvaluateVisitor_closure42: function _EvaluateVisitor_closure42(t0) {
                this.$this = t0;
            },
            _EvaluateVisitor_closure43: function _EvaluateVisitor_closure43(t0) {
                this.$this = t0;
            },
            _EvaluateVisitor_closure44: function _EvaluateVisitor_closure44(t0) {
                this.$this = t0;
            },
            _EvaluateVisitor_closure45: function _EvaluateVisitor_closure45(t0) {
                this.$this = t0;
            },
            _EvaluateVisitor_closure46: function _EvaluateVisitor_closure46(t0) {
                this.$this = t0;
            },
            _EvaluateVisitor__closure14: function _EvaluateVisitor__closure14(t0, t1, t2) {
                this.$this = t0;
                this.name = t1;
                this.module = t2;
            },
            _EvaluateVisitor_closure47: function _EvaluateVisitor_closure47(t0) {
                this.$this = t0;
            },
            _EvaluateVisitor__closure13: function _EvaluateVisitor__closure13(t0, t1, t2) {
                this.$this = t0;
                this.name = t1;
                this.module = t2;
            },
            _EvaluateVisitor_closure48: function _EvaluateVisitor_closure48(t0) {
                this.$this = t0;
            },
            _EvaluateVisitor_closure49: function _EvaluateVisitor_closure49(t0) {
                this.$this = t0;
            },
            _EvaluateVisitor__closure11: function _EvaluateVisitor__closure11(t0, t1, t2, t3) {
                var _ = this;
                _._box_0 = t0;
                _.values = t1;
                _.span = t2;
                _.callableNode = t3;
            },
            _EvaluateVisitor__closure12: function _EvaluateVisitor__closure12(t0) {
                this.$this = t0;
            },
            _EvaluateVisitor_closure50: function _EvaluateVisitor_closure50(t0) {
                this.$this = t0;
            },
            _EvaluateVisitor_run_closure2: function _EvaluateVisitor_run_closure2(t0, t1, t2) {
                this.$this = t0;
                this.node = t1;
                this.importer = t2;
            },
            _EvaluateVisitor_run__closure2: function _EvaluateVisitor_run__closure2(t0, t1, t2) {
                this.$this = t0;
                this.importer = t1;
                this.node = t2;
            },
            _EvaluateVisitor__loadModule_closure5: function _EvaluateVisitor__loadModule_closure5(t0, t1) {
                this._box_0 = t0;
                this.callback = t1;
            },
            _EvaluateVisitor__loadModule_closure6: function _EvaluateVisitor__loadModule_closure6(t0, t1, t2, t3, t4, t5, t6) {
                var _ = this;
                _.$this = t0;
                _.url = t1;
                _.nodeWithSpan = t2;
                _.baseUrl = t3;
                _.namesInErrors = t4;
                _.configuration = t5;
                _.callback = t6;
            },
            _EvaluateVisitor__loadModule__closure5: function _EvaluateVisitor__loadModule__closure5(t0, t1) {
                this.$this = t0;
                this.message = t1;
            },
            _EvaluateVisitor__loadModule__closure6: function _EvaluateVisitor__loadModule__closure6(t0, t1, t2) {
                this._box_1 = t0;
                this.callback = t1;
                this.firstLoad = t2;
            },
            _EvaluateVisitor__execute_closure2: function _EvaluateVisitor__execute_closure2(t0, t1, t2, t3, t4, t5, t6) {
                var _ = this;
                _.$this = t0;
                _.importer = t1;
                _.stylesheet = t2;
                _.extensionStore = t3;
                _.configuration = t4;
                _.css = t5;
                _.preModuleComments = t6;
            },
            _EvaluateVisitor__combineCss_closure5: function _EvaluateVisitor__combineCss_closure5() {},
            _EvaluateVisitor__combineCss_closure6: function _EvaluateVisitor__combineCss_closure6(t0) {
                this.selectors = t0;
            },
            _EvaluateVisitor__combineCss_visitModule2: function _EvaluateVisitor__combineCss_visitModule2(t0, t1, t2, t3, t4, t5) {
                var _ = this;
                _.$this = t0;
                _.seen = t1;
                _.clone = t2;
                _.css = t3;
                _.imports = t4;
                _.sorted = t5;
            },
            _EvaluateVisitor__extendModules_closure5: function _EvaluateVisitor__extendModules_closure5(t0) {
                this.originalSelectors = t0;
            },
            _EvaluateVisitor__extendModules_closure6: function _EvaluateVisitor__extendModules_closure6() {},
            _EvaluateVisitor_visitAtRootRule_closure5: function _EvaluateVisitor_visitAtRootRule_closure5(t0, t1) {
                this.$this = t0;
                this.node = t1;
            },
            _EvaluateVisitor_visitAtRootRule_closure6: function _EvaluateVisitor_visitAtRootRule_closure6(t0, t1) {
                this.$this = t0;
                this.node = t1;
            },
            _EvaluateVisitor__scopeForAtRoot_closure17: function _EvaluateVisitor__scopeForAtRoot_closure17(t0, t1, t2) {
                this.$this = t0;
                this.newParent = t1;
                this.node = t2;
            },
            _EvaluateVisitor__scopeForAtRoot_closure18: function _EvaluateVisitor__scopeForAtRoot_closure18(t0, t1) {
                this.$this = t0;
                this.innerScope = t1;
            },
            _EvaluateVisitor__scopeForAtRoot_closure19: function _EvaluateVisitor__scopeForAtRoot_closure19(t0, t1) {
                this.$this = t0;
                this.innerScope = t1;
            },
            _EvaluateVisitor__scopeForAtRoot__closure2: function _EvaluateVisitor__scopeForAtRoot__closure2(t0, t1) {
                this.innerScope = t0;
                this.callback = t1;
            },
            _EvaluateVisitor__scopeForAtRoot_closure20: function _EvaluateVisitor__scopeForAtRoot_closure20(t0, t1) {
                this.$this = t0;
                this.innerScope = t1;
            },
            _EvaluateVisitor__scopeForAtRoot_closure21: function _EvaluateVisitor__scopeForAtRoot_closure21() {},
            _EvaluateVisitor__scopeForAtRoot_closure22: function _EvaluateVisitor__scopeForAtRoot_closure22(t0, t1) {
                this.$this = t0;
                this.innerScope = t1;
            },
            _EvaluateVisitor_visitContentRule_closure2: function _EvaluateVisitor_visitContentRule_closure2(t0, t1) {
                this.$this = t0;
                this.content = t1;
            },
            _EvaluateVisitor_visitDeclaration_closure2: function _EvaluateVisitor_visitDeclaration_closure2(t0, t1) {
                this._box_0 = t0;
                this.$this = t1;
            },
            _EvaluateVisitor_visitEachRule_closure8: function _EvaluateVisitor_visitEachRule_closure8(t0, t1, t2) {
                this._box_0 = t0;
                this.$this = t1;
                this.nodeWithSpan = t2;
            },
            _EvaluateVisitor_visitEachRule_closure9: function _EvaluateVisitor_visitEachRule_closure9(t0, t1, t2) {
                this._box_1 = t0;
                this.$this = t1;
                this.nodeWithSpan = t2;
            },
            _EvaluateVisitor_visitEachRule_closure10: function _EvaluateVisitor_visitEachRule_closure10(t0, t1, t2, t3) {
                var _ = this;
                _.$this = t0;
                _.list = t1;
                _.setVariables = t2;
                _.node = t3;
            },
            _EvaluateVisitor_visitEachRule__closure2: function _EvaluateVisitor_visitEachRule__closure2(t0, t1, t2) {
                this.$this = t0;
                this.setVariables = t1;
                this.node = t2;
            },
            _EvaluateVisitor_visitEachRule___closure2: function _EvaluateVisitor_visitEachRule___closure2(t0) {
                this.$this = t0;
            },
            _EvaluateVisitor_visitAtRule_closure11: function _EvaluateVisitor_visitAtRule_closure11(t0) {
                this.$this = t0;
            },
            _EvaluateVisitor_visitAtRule_closure12: function _EvaluateVisitor_visitAtRule_closure12(t0, t1) {
                this.$this = t0;
                this.children = t1;
            },
            _EvaluateVisitor_visitAtRule_closure13: function _EvaluateVisitor_visitAtRule_closure13(t0, t1, t2) {
                this.$this = t0;
                this.name = t1;
                this.children = t2;
            },
            _EvaluateVisitor_visitAtRule__closure2: function _EvaluateVisitor_visitAtRule__closure2(t0, t1) {
                this.$this = t0;
                this.children = t1;
            },
            _EvaluateVisitor_visitAtRule_closure14: function _EvaluateVisitor_visitAtRule_closure14() {},
            _EvaluateVisitor_visitForRule_closure14: function _EvaluateVisitor_visitForRule_closure14(t0, t1) {
                this.$this = t0;
                this.node = t1;
            },
            _EvaluateVisitor_visitForRule_closure15: function _EvaluateVisitor_visitForRule_closure15(t0, t1) {
                this.$this = t0;
                this.node = t1;
            },
            _EvaluateVisitor_visitForRule_closure16: function _EvaluateVisitor_visitForRule_closure16(t0) {
                this.fromNumber = t0;
            },
            _EvaluateVisitor_visitForRule_closure17: function _EvaluateVisitor_visitForRule_closure17(t0, t1) {
                this.toNumber = t0;
                this.fromNumber = t1;
            },
            _EvaluateVisitor_visitForRule_closure18: function _EvaluateVisitor_visitForRule_closure18(t0, t1, t2, t3, t4, t5) {
                var _ = this;
                _._box_0 = t0;
                _.$this = t1;
                _.node = t2;
                _.from = t3;
                _.direction = t4;
                _.fromNumber = t5;
            },
            _EvaluateVisitor_visitForRule__closure2: function _EvaluateVisitor_visitForRule__closure2(t0) {
                this.$this = t0;
            },
            _EvaluateVisitor_visitForwardRule_closure5: function _EvaluateVisitor_visitForwardRule_closure5(t0, t1) {
                this.$this = t0;
                this.node = t1;
            },
            _EvaluateVisitor_visitForwardRule_closure6: function _EvaluateVisitor_visitForwardRule_closure6(t0, t1) {
                this.$this = t0;
                this.node = t1;
            },
            _EvaluateVisitor__registerCommentsForModule_closure2: function _EvaluateVisitor__registerCommentsForModule_closure2() {},
            _EvaluateVisitor_visitIfRule_closure2: function _EvaluateVisitor_visitIfRule_closure2(t0) {
                this.$this = t0;
            },
            _EvaluateVisitor_visitIfRule__closure2: function _EvaluateVisitor_visitIfRule__closure2(t0, t1) {
                this.$this = t0;
                this.clause = t1;
            },
            _EvaluateVisitor_visitIfRule___closure2: function _EvaluateVisitor_visitIfRule___closure2(t0) {
                this.$this = t0;
            },
            _EvaluateVisitor__visitDynamicImport_closure2: function _EvaluateVisitor__visitDynamicImport_closure2(t0, t1) {
                this.$this = t0;
                this.$import = t1;
            },
            _EvaluateVisitor__visitDynamicImport__closure11: function _EvaluateVisitor__visitDynamicImport__closure11(t0) {
                this.$this = t0;
            },
            _EvaluateVisitor__visitDynamicImport__closure12: function _EvaluateVisitor__visitDynamicImport__closure12() {},
            _EvaluateVisitor__visitDynamicImport__closure13: function _EvaluateVisitor__visitDynamicImport__closure13() {},
            _EvaluateVisitor__visitDynamicImport__closure14: function _EvaluateVisitor__visitDynamicImport__closure14(t0, t1, t2, t3, t4) {
                var _ = this;
                _._box_0 = t0;
                _.$this = t1;
                _.loadsUserDefinedModules = t2;
                _.environment = t3;
                _.children = t4;
            },
            _EvaluateVisitor__applyMixin_closure5: function _EvaluateVisitor__applyMixin_closure5(t0, t1, t2, t3) {
                var _ = this;
                _.$this = t0;
                _.$arguments = t1;
                _.mixin = t2;
                _.nodeWithSpanWithoutContent = t3;
            },
            _EvaluateVisitor__applyMixin__closure6: function _EvaluateVisitor__applyMixin__closure6(t0, t1, t2, t3) {
                var _ = this;
                _.$this = t0;
                _.$arguments = t1;
                _.mixin = t2;
                _.nodeWithSpanWithoutContent = t3;
            },
            _EvaluateVisitor__applyMixin_closure6: function _EvaluateVisitor__applyMixin_closure6(t0, t1, t2, t3) {
                var _ = this;
                _.$this = t0;
                _.contentCallable = t1;
                _.mixin = t2;
                _.nodeWithSpanWithoutContent = t3;
            },
            _EvaluateVisitor__applyMixin__closure5: function _EvaluateVisitor__applyMixin__closure5(t0, t1, t2) {
                this.$this = t0;
                this.mixin = t1;
                this.nodeWithSpanWithoutContent = t2;
            },
            _EvaluateVisitor__applyMixin___closure2: function _EvaluateVisitor__applyMixin___closure2(t0, t1, t2) {
                this.$this = t0;
                this.mixin = t1;
                this.nodeWithSpanWithoutContent = t2;
            },
            _EvaluateVisitor__applyMixin____closure2: function _EvaluateVisitor__applyMixin____closure2(t0, t1) {
                this.$this = t0;
                this.statement = t1;
            },
            _EvaluateVisitor_visitIncludeRule_closure8: function _EvaluateVisitor_visitIncludeRule_closure8(t0, t1) {
                this.$this = t0;
                this.node = t1;
            },
            _EvaluateVisitor_visitIncludeRule_closure9: function _EvaluateVisitor_visitIncludeRule_closure9(t0) {
                this.$this = t0;
            },
            _EvaluateVisitor_visitIncludeRule_closure10: function _EvaluateVisitor_visitIncludeRule_closure10(t0) {
                this.node = t0;
            },
            _EvaluateVisitor_visitMediaRule_closure11: function _EvaluateVisitor_visitMediaRule_closure11(t0, t1) {
                this.$this = t0;
                this.node = t1;
            },
            _EvaluateVisitor_visitMediaRule_closure12: function _EvaluateVisitor_visitMediaRule_closure12(t0, t1) {
                this.$this = t0;
                this.queries = t1;
            },
            _EvaluateVisitor_visitMediaRule_closure13: function _EvaluateVisitor_visitMediaRule_closure13(t0, t1, t2, t3, t4) {
                var _ = this;
                _.$this = t0;
                _.mergedQueries = t1;
                _.queries = t2;
                _.mergedSources = t3;
                _.node = t4;
            },
            _EvaluateVisitor_visitMediaRule__closure2: function _EvaluateVisitor_visitMediaRule__closure2(t0, t1) {
                this.$this = t0;
                this.node = t1;
            },
            _EvaluateVisitor_visitMediaRule___closure2: function _EvaluateVisitor_visitMediaRule___closure2(t0, t1) {
                this.$this = t0;
                this.node = t1;
            },
            _EvaluateVisitor_visitMediaRule_closure14: function _EvaluateVisitor_visitMediaRule_closure14(t0) {
                this.mergedSources = t0;
            },
            _EvaluateVisitor_visitStyleRule_closure11: function _EvaluateVisitor_visitStyleRule_closure11(t0, t1) {
                this.$this = t0;
                this.node = t1;
            },
            _EvaluateVisitor_visitStyleRule_closure12: function _EvaluateVisitor_visitStyleRule_closure12() {},
            _EvaluateVisitor_visitStyleRule_closure14: function _EvaluateVisitor_visitStyleRule_closure14(t0, t1, t2) {
                this.$this = t0;
                this.rule = t1;
                this.node = t2;
            },
            _EvaluateVisitor_visitStyleRule__closure2: function _EvaluateVisitor_visitStyleRule__closure2(t0, t1) {
                this.$this = t0;
                this.node = t1;
            },
            _EvaluateVisitor_visitStyleRule_closure13: function _EvaluateVisitor_visitStyleRule_closure13() {},
            _EvaluateVisitor__warnForBogusCombinators_closure2: function _EvaluateVisitor__warnForBogusCombinators_closure2() {},
            _EvaluateVisitor_visitSupportsRule_closure8: function _EvaluateVisitor_visitSupportsRule_closure8(t0, t1) {
                this.$this = t0;
                this.node = t1;
            },
            _EvaluateVisitor_visitSupportsRule_closure9: function _EvaluateVisitor_visitSupportsRule_closure9(t0, t1) {
                this.$this = t0;
                this.node = t1;
            },
            _EvaluateVisitor_visitSupportsRule__closure2: function _EvaluateVisitor_visitSupportsRule__closure2(t0, t1) {
                this.$this = t0;
                this.node = t1;
            },
            _EvaluateVisitor_visitSupportsRule_closure10: function _EvaluateVisitor_visitSupportsRule_closure10() {},
            _EvaluateVisitor__visitSupportsCondition_closure2: function _EvaluateVisitor__visitSupportsCondition_closure2(t0, t1) {
                this._box_0 = t0;
                this.$this = t1;
            },
            _EvaluateVisitor_visitVariableDeclaration_closure8: function _EvaluateVisitor_visitVariableDeclaration_closure8(t0, t1, t2) {
                this._box_0 = t0;
                this.$this = t1;
                this.node = t2;
            },
            _EvaluateVisitor_visitVariableDeclaration_closure9: function _EvaluateVisitor_visitVariableDeclaration_closure9(t0, t1) {
                this.$this = t0;
                this.node = t1;
            },
            _EvaluateVisitor_visitVariableDeclaration_closure10: function _EvaluateVisitor_visitVariableDeclaration_closure10(t0, t1, t2) {
                this.$this = t0;
                this.node = t1;
                this.value = t2;
            },
            _EvaluateVisitor_visitUseRule_closure2: function _EvaluateVisitor_visitUseRule_closure2(t0, t1) {
                this.$this = t0;
                this.node = t1;
            },
            _EvaluateVisitor_visitWarnRule_closure2: function _EvaluateVisitor_visitWarnRule_closure2(t0, t1) {
                this.$this = t0;
                this.node = t1;
            },
            _EvaluateVisitor_visitWhileRule_closure2: function _EvaluateVisitor_visitWhileRule_closure2(t0, t1) {
                this.$this = t0;
                this.node = t1;
            },
            _EvaluateVisitor_visitWhileRule__closure2: function _EvaluateVisitor_visitWhileRule__closure2(t0) {
                this.$this = t0;
            },
            _EvaluateVisitor_visitBinaryOperationExpression_closure2: function _EvaluateVisitor_visitBinaryOperationExpression_closure2(t0, t1) {
                this.$this = t0;
                this.node = t1;
            },
            _EvaluateVisitor__slash_recommendation2: function _EvaluateVisitor__slash_recommendation2() {},
            _EvaluateVisitor_visitVariableExpression_closure2: function _EvaluateVisitor_visitVariableExpression_closure2(t0, t1) {
                this.$this = t0;
                this.node = t1;
            },
            _EvaluateVisitor_visitUnaryOperationExpression_closure2: function _EvaluateVisitor_visitUnaryOperationExpression_closure2(t0, t1) {
                this.node = t0;
                this.operand = t1;
            },
            _EvaluateVisitor_visitIfExpression_closure2: function _EvaluateVisitor_visitIfExpression_closure2() {},
            _EvaluateVisitor_visitIfConditionOperation_closure2: function _EvaluateVisitor_visitIfConditionOperation_closure2() {},
            _EvaluateVisitor_visitListExpression_closure2: function _EvaluateVisitor_visitListExpression_closure2(t0) {
                this.$this = t0;
            },
            _EvaluateVisitor_visitFunctionExpression_closure8: function _EvaluateVisitor_visitFunctionExpression_closure8(t0, t1) {
                this.$this = t0;
                this.node = t1;
            },
            _EvaluateVisitor_visitFunctionExpression_closure9: function _EvaluateVisitor_visitFunctionExpression_closure9() {},
            _EvaluateVisitor_visitFunctionExpression_closure10: function _EvaluateVisitor_visitFunctionExpression_closure10(t0, t1, t2) {
                this._box_0 = t0;
                this.$this = t1;
                this.node = t2;
            },
            _EvaluateVisitor__visitCalculation_closure2: function _EvaluateVisitor__visitCalculation_closure2(t0, t1) {
                this.$this = t0;
                this.node = t1;
            },
            _EvaluateVisitor__checkCalculationArguments_check2: function _EvaluateVisitor__checkCalculationArguments_check2(t0, t1) {
                this.$this = t0;
                this.node = t1;
            },
            _EvaluateVisitor__visitCalculationExpression_closure2: function _EvaluateVisitor__visitCalculationExpression_closure2(t0, t1, t2, t3) {
                var _ = this;
                _._box_0 = t0;
                _.$this = t1;
                _.node = t2;
                _.inLegacySassFunction = t3;
            },
            _EvaluateVisitor__visitCalculationExpression__closure2: function _EvaluateVisitor__visitCalculationExpression__closure2(t0, t1) {
                this.$this = t0;
                this.node = t1;
            },
            _EvaluateVisitor_visitInterpolatedFunctionExpression_closure2: function _EvaluateVisitor_visitInterpolatedFunctionExpression_closure2(t0, t1, t2) {
                this.$this = t0;
                this.node = t1;
                this.$function = t2;
            },
            _EvaluateVisitor__runUserDefinedCallable_closure2: function _EvaluateVisitor__runUserDefinedCallable_closure2(t0, t1, t2, t3, t4, t5) {
                var _ = this;
                _.$this = t0;
                _.callable = t1;
                _.evaluated = t2;
                _.nodeWithSpan = t3;
                _.run = t4;
                _.V = t5;
            },
            _EvaluateVisitor__runUserDefinedCallable__closure2: function _EvaluateVisitor__runUserDefinedCallable__closure2(t0, t1, t2, t3, t4, t5) {
                var _ = this;
                _.$this = t0;
                _.evaluated = t1;
                _.callable = t2;
                _.nodeWithSpan = t3;
                _.run = t4;
                _.V = t5;
            },
            _EvaluateVisitor__runUserDefinedCallable___closure2: function _EvaluateVisitor__runUserDefinedCallable___closure2(t0, t1, t2, t3, t4, t5) {
                var _ = this;
                _.$this = t0;
                _.evaluated = t1;
                _.callable = t2;
                _.nodeWithSpan = t3;
                _.run = t4;
                _.V = t5;
            },
            _EvaluateVisitor__runUserDefinedCallable____closure2: function _EvaluateVisitor__runUserDefinedCallable____closure2() {},
            _EvaluateVisitor__runFunctionCallable_closure2: function _EvaluateVisitor__runFunctionCallable_closure2(t0, t1) {
                this.$this = t0;
                this.callable = t1;
            },
            _EvaluateVisitor__runBuiltInCallable_closure8: function _EvaluateVisitor__runBuiltInCallable_closure8(t0, t1, t2) {
                this._box_0 = t0;
                this.evaluated = t1;
                this.namedSet = t2;
            },
            _EvaluateVisitor__runBuiltInCallable_closure9: function _EvaluateVisitor__runBuiltInCallable_closure9(t0, t1) {
                this._box_0 = t0;
                this.evaluated = t1;
            },
            _EvaluateVisitor__runBuiltInCallable_closure10: function _EvaluateVisitor__runBuiltInCallable_closure10() {},
            _EvaluateVisitor__evaluateArguments_closure11: function _EvaluateVisitor__evaluateArguments_closure11() {},
            _EvaluateVisitor__evaluateArguments_closure12: function _EvaluateVisitor__evaluateArguments_closure12(t0, t1) {
                this.$this = t0;
                this.restNodeForSpan = t1;
            },
            _EvaluateVisitor__evaluateArguments_closure13: function _EvaluateVisitor__evaluateArguments_closure13(t0, t1, t2, t3) {
                var _ = this;
                _.$this = t0;
                _.named = t1;
                _.restNodeForSpan = t2;
                _.namedNodes = t3;
            },
            _EvaluateVisitor__evaluateArguments_closure14: function _EvaluateVisitor__evaluateArguments_closure14() {},
            _EvaluateVisitor__evaluateMacroArguments_closure11: function _EvaluateVisitor__evaluateMacroArguments_closure11(t0) {
                this.restArgs = t0;
            },
            _EvaluateVisitor__evaluateMacroArguments_closure12: function _EvaluateVisitor__evaluateMacroArguments_closure12(t0, t1, t2) {
                this.$this = t0;
                this.restNodeForSpan = t1;
                this.restArgs = t2;
            },
            _EvaluateVisitor__evaluateMacroArguments_closure13: function _EvaluateVisitor__evaluateMacroArguments_closure13(t0, t1, t2, t3) {
                var _ = this;
                _.$this = t0;
                _.named = t1;
                _.restNodeForSpan = t2;
                _.restArgs = t3;
            },
            _EvaluateVisitor__evaluateMacroArguments_closure14: function _EvaluateVisitor__evaluateMacroArguments_closure14(t0, t1, t2) {
                this.$this = t0;
                this.keywordRestNodeForSpan = t1;
                this.keywordRestArgs = t2;
            },
            _EvaluateVisitor__addRestMap_closure2: function _EvaluateVisitor__addRestMap_closure2(t0, t1, t2, t3, t4, t5) {
                var _ = this;
                _.$this = t0;
                _.values = t1;
                _.convert = t2;
                _.expressionNode = t3;
                _.map = t4;
                _.nodeWithSpan = t5;
            },
            _EvaluateVisitor__verifyArguments_closure2: function _EvaluateVisitor__verifyArguments_closure2(t0, t1, t2) {
                this.parameters = t0;
                this.positional = t1;
                this.named = t2;
            },
            _EvaluateVisitor_visitCssAtRule_closure8: function _EvaluateVisitor_visitCssAtRule_closure8(t0, t1) {
                this.$this = t0;
                this.node = t1;
            },
            _EvaluateVisitor_visitCssAtRule_closure9: function _EvaluateVisitor_visitCssAtRule_closure9(t0, t1) {
                this.$this = t0;
                this.node = t1;
            },
            _EvaluateVisitor_visitCssAtRule_closure10: function _EvaluateVisitor_visitCssAtRule_closure10() {},
            _EvaluateVisitor_visitCssKeyframeBlock_closure5: function _EvaluateVisitor_visitCssKeyframeBlock_closure5(t0, t1) {
                this.$this = t0;
                this.node = t1;
            },
            _EvaluateVisitor_visitCssKeyframeBlock_closure6: function _EvaluateVisitor_visitCssKeyframeBlock_closure6() {},
            _EvaluateVisitor_visitCssMediaRule_closure11: function _EvaluateVisitor_visitCssMediaRule_closure11(t0, t1) {
                this.$this = t0;
                this.node = t1;
            },
            _EvaluateVisitor_visitCssMediaRule_closure12: function _EvaluateVisitor_visitCssMediaRule_closure12(t0, t1) {
                this.$this = t0;
                this.node = t1;
            },
            _EvaluateVisitor_visitCssMediaRule_closure13: function _EvaluateVisitor_visitCssMediaRule_closure13(t0, t1, t2, t3) {
                var _ = this;
                _.$this = t0;
                _.mergedQueries = t1;
                _.node = t2;
                _.mergedSources = t3;
            },
            _EvaluateVisitor_visitCssMediaRule__closure2: function _EvaluateVisitor_visitCssMediaRule__closure2(t0, t1) {
                this.$this = t0;
                this.node = t1;
            },
            _EvaluateVisitor_visitCssMediaRule___closure2: function _EvaluateVisitor_visitCssMediaRule___closure2(t0, t1) {
                this.$this = t0;
                this.node = t1;
            },
            _EvaluateVisitor_visitCssMediaRule_closure14: function _EvaluateVisitor_visitCssMediaRule_closure14(t0) {
                this.mergedSources = t0;
            },
            _EvaluateVisitor_visitCssStyleRule_closure6: function _EvaluateVisitor_visitCssStyleRule_closure6(t0, t1, t2) {
                this.$this = t0;
                this.rule = t1;
                this.node = t2;
            },
            _EvaluateVisitor_visitCssStyleRule__closure2: function _EvaluateVisitor_visitCssStyleRule__closure2(t0, t1) {
                this.$this = t0;
                this.node = t1;
            },
            _EvaluateVisitor_visitCssStyleRule_closure5: function _EvaluateVisitor_visitCssStyleRule_closure5() {},
            _EvaluateVisitor_visitCssSupportsRule_closure8: function _EvaluateVisitor_visitCssSupportsRule_closure8(t0, t1) {
                this.$this = t0;
                this.node = t1;
            },
            _EvaluateVisitor_visitCssSupportsRule_closure9: function _EvaluateVisitor_visitCssSupportsRule_closure9(t0, t1) {
                this.$this = t0;
                this.node = t1;
            },
            _EvaluateVisitor_visitCssSupportsRule__closure2: function _EvaluateVisitor_visitCssSupportsRule__closure2(t0, t1) {
                this.$this = t0;
                this.node = t1;
            },
            _EvaluateVisitor_visitCssSupportsRule_closure10: function _EvaluateVisitor_visitCssSupportsRule_closure10() {},
            _EvaluateVisitor__performInterpolationHelper_closure2: function _EvaluateVisitor__performInterpolationHelper_closure2(t0) {
                this.interpolation = t0;
            },
            _EvaluateVisitor__serialize_closure2: function _EvaluateVisitor__serialize_closure2(t0, t1) {
                this.value = t0;
                this.quote = t1;
            },
            _EvaluateVisitor__expressionNode_closure2: function _EvaluateVisitor__expressionNode_closure2(t0, t1) {
                this.$this = t0;
                this.expression = t1;
            },
            _EvaluateVisitor__withoutSlash_recommendation2: function _EvaluateVisitor__withoutSlash_recommendation2() {},
            _EvaluateVisitor__stackFrame_closure2: function _EvaluateVisitor__stackFrame_closure2(t0) {
                this.$this = t0;
            },
            _ImportedCssVisitor2: function _ImportedCssVisitor2(t0) {
                this._async_evaluate0$_visitor = t0;
            },
            _ImportedCssVisitor_visitCssAtRule_closure2: function _ImportedCssVisitor_visitCssAtRule_closure2() {},
            _ImportedCssVisitor_visitCssMediaRule_closure2: function _ImportedCssVisitor_visitCssMediaRule_closure2(t0) {
                this.hasBeenMerged = t0;
            },
            _ImportedCssVisitor_visitCssStyleRule_closure2: function _ImportedCssVisitor_visitCssStyleRule_closure2() {},
            _ImportedCssVisitor_visitCssSupportsRule_closure2: function _ImportedCssVisitor_visitCssSupportsRule_closure2() {},
            _EvaluationContext2: function _EvaluationContext2(t0, t1) {
                this._async_evaluate0$_visitor = t0;
                this._async_evaluate0$_defaultWarnNodeWithSpan = t1;
            },
            JSToDartAsyncFileImporter: function JSToDartAsyncFileImporter(t0) {
                this._findFileUrl = t0;
            },
            JSToDartAsyncFileImporter_canonicalize_closure: function JSToDartAsyncFileImporter_canonicalize_closure(t0, t1) {
                this.$this = t0;
                this.url = t1;
            },
            AsyncImportCache$: function(importers, loadPaths, packageConfig) {
                var t1 = type$.nullable_Record_3_AsyncImporter_and_Uri_and_Uri_originalUrl_2, t2 = type$.Record_3_AsyncImporter_and_Uri_and_bool_forImport_2, t3 = type$.Uri;
                return new A.AsyncImportCache0(A.AsyncImportCache__toImporters0(importers, loadPaths, packageConfig), A.LinkedHashMap_LinkedHashMap$_empty(type$.Record_2_Uri_and_bool_forImport, t1), A.LinkedHashMap_LinkedHashMap$_empty(t2, t1), A.LinkedHashMap_LinkedHashMap$_empty(t2, t3), A.LinkedHashMap_LinkedHashMap$_empty(t3, type$.nullable_Stylesheet_2), A.LinkedHashMap_LinkedHashMap$_empty(t3, type$.ImporterResult_2), A.LinkedHashMap_LinkedHashMap$_empty(t3, type$.DateTime));
            },
            AsyncImportCache$none: function() {
                var t1 = type$.nullable_Record_3_AsyncImporter_and_Uri_and_Uri_originalUrl_2, t2 = type$.Record_3_AsyncImporter_and_Uri_and_bool_forImport_2, t3 = type$.Uri;
                return new A.AsyncImportCache0(B.List_empty31, A.LinkedHashMap_LinkedHashMap$_empty(type$.Record_2_Uri_and_bool_forImport, t1), A.LinkedHashMap_LinkedHashMap$_empty(t2, t1), A.LinkedHashMap_LinkedHashMap$_empty(t2, t3), A.LinkedHashMap_LinkedHashMap$_empty(t3, type$.nullable_Stylesheet_2), A.LinkedHashMap_LinkedHashMap$_empty(t3, type$.ImporterResult_2), A.LinkedHashMap_LinkedHashMap$_empty(t3, type$.DateTime));
            },
            AsyncImportCache__toImporters0: function(importers, loadPaths, packageConfig) {
                var t1, t2, t3, t4, _i, path, _null = null, sassPath = A.getEnvironmentVariable0("SASS_PATH");
                if (A.isBrowser()) {
                    t1 = A._setArrayType([], type$.JSArray_AsyncImporter);
                    if (importers != null) B.JSArray_methods.addAll$1(t1, importers);
                    return t1;
                }
                t1 = A._setArrayType([], type$.JSArray_AsyncImporter);
                if (importers != null) B.JSArray_methods.addAll$1(t1, importers);
                if (loadPaths != null) for(t2 = J.get$iterator$ax(loadPaths); t2.moveNext$0();){
                    t3 = t2.get$current(t2);
                    t1.push(new A.FilesystemImporter0($.$get$context().absolute$15(t3, _null, _null, _null, _null, _null, _null, _null, _null, _null, _null, _null, _null, _null, _null), false));
                }
                if (sassPath != null) {
                    t2 = A.isNodeJs() ? self.process : _null;
                    t3 = sassPath.split(J.$eq$(t2 == null ? _null : J.get$platform$x(t2), "win32") ? ";" : ":");
                    t4 = t3.length;
                    _i = 0;
                    for(; _i < t4; ++_i){
                        path = t3[_i];
                        t1.push(new A.FilesystemImporter0($.$get$context().absolute$15(path, _null, _null, _null, _null, _null, _null, _null, _null, _null, _null, _null, _null, _null, _null), false));
                    }
                }
                return t1;
            },
            AsyncImportCache0: function AsyncImportCache0(t0, t1, t2, t3, t4, t5, t6) {
                var _ = this;
                _._async_import_cache0$_importers = t0;
                _._async_import_cache0$_canonicalizeCache = t1;
                _._async_import_cache0$_perImporterCanonicalizeCache = t2;
                _._async_import_cache0$_nonCanonicalRelativeUrls = t3;
                _._async_import_cache0$_importCache = t4;
                _._async_import_cache0$_resultsCache = t5;
                _._async_import_cache0$_loadTimes = t6;
            },
            AsyncImportCache_canonicalize_closure0: function AsyncImportCache_canonicalize_closure0(t0, t1, t2, t3, t4, t5, t6) {
                var _ = this;
                _.$this = t0;
                _.baseImporter = t1;
                _.resolvedUrl = t2;
                _.baseUrl = t3;
                _.forImport = t4;
                _.key = t5;
                _.url = t6;
            },
            AsyncImportCache__canonicalize_closure0: function AsyncImportCache__canonicalize_closure0(t0, t1) {
                this.importer = t0;
                this.url = t1;
            },
            AsyncImportCache_importCanonical_closure0: function AsyncImportCache_importCanonical_closure0(t0, t1, t2, t3) {
                var _ = this;
                _.$this = t0;
                _.importer = t1;
                _.canonicalUrl = t2;
                _.originalUrl = t3;
            },
            AsyncImportCache_humanize_closure3: function AsyncImportCache_humanize_closure3(t0) {
                this.canonicalUrl = t0;
            },
            AsyncImportCache_humanize_closure4: function AsyncImportCache_humanize_closure4() {},
            AsyncImportCache_humanize_closure5: function AsyncImportCache_humanize_closure5() {},
            AsyncImportCache_humanize_closure6: function AsyncImportCache_humanize_closure6(t0) {
                this.canonicalUrl = t0;
            },
            AtRootQueryParser0: function AtRootQueryParser0(t0, t1) {
                this.scanner = t0;
                this._parser1$_interpolationMap = t1;
            },
            AtRootQueryParser_parse_closure0: function AtRootQueryParser_parse_closure0(t0) {
                this.$this = t0;
            },
            AtRootQuery0: function AtRootQuery0(t0, t1, t2, t3) {
                var _ = this;
                _.include = t0;
                _.names = t1;
                _._at_root_query0$_all = t2;
                _._at_root_query0$_rule = t3;
            },
            AtRootRule$0: function(children, span, query) {
                var t1 = A.List_List$unmodifiable(children, type$.Statement_2), t2 = B.JSArray_methods.any$1(t1, new A.ParentStatement_closure0());
                return new A.AtRootRule0(query, span, t1, t2);
            },
            AtRootRule0: function AtRootRule0(t0, t1, t2, t3) {
                var _ = this;
                _.query = t0;
                _.span = t1;
                _.children = t2;
                _.hasDeclarations = t3;
            },
            ModifiableCssAtRule$0: function($name, span, childless, value) {
                var t1 = A._setArrayType([], type$.JSArray_ModifiableCssNode_2);
                return new A.ModifiableCssAtRule0($name, value, childless, span, new A.UnmodifiableListView(t1, type$.UnmodifiableListView_ModifiableCssNode_2), t1);
            },
            ModifiableCssAtRule0: function ModifiableCssAtRule0(t0, t1, t2, t3, t4, t5) {
                var _ = this;
                _.name = t0;
                _.value = t1;
                _.isChildless = t2;
                _.span = t3;
                _.children = t4;
                _._node$_children = t5;
                _._node$_indexInParent = _._node$_parent = null;
                _.isGroupEnd = false;
            },
            AtRule$0: function($name, span, children, value) {
                var t1 = children == null ? null : A.List_List$unmodifiable(children, type$.Statement_2), t2 = t1 == null ? null : B.JSArray_methods.any$1(t1, new A.ParentStatement_closure0());
                return new A.AtRule0($name, value, span, t1, t2 === true);
            },
            AtRule0: function AtRule0(t0, t1, t2, t3, t4) {
                var _ = this;
                _.name = t0;
                _.value = t1;
                _.span = t2;
                _.children = t3;
                _.hasDeclarations = t4;
            },
            InterpolatedAttributeSelector: function InterpolatedAttributeSelector(t0, t1, t2, t3, t4) {
                var _ = this;
                _.name = t0;
                _.op = t1;
                _.value = t2;
                _.modifier = t3;
                _.span = t4;
            },
            AttributeSelector0: function AttributeSelector0(t0, t1, t2, t3, t4) {
                var _ = this;
                _.name = t0;
                _.op = t1;
                _.value = t2;
                _.modifier = t3;
                _.span = t4;
            },
            AttributeOperator0: function AttributeOperator0(t0, t1, t2) {
                this._attribute0$_text = t0;
                this.index = t1;
                this._name = t2;
            },
            BinaryOperationExpression0: function BinaryOperationExpression0(t0, t1, t2, t3) {
                var _ = this;
                _.operator = t0;
                _.left = t1;
                _.right = t2;
                _.allowsSlash = t3;
            },
            BinaryOperator0: function BinaryOperator0(t0, t1, t2, t3, t4, t5) {
                var _ = this;
                _.name = t0;
                _.operator = t1;
                _.precedence = t2;
                _.isAssociative = t3;
                _.index = t4;
                _._name = t5;
            },
            BooleanExpression0: function BooleanExpression0(t0, t1) {
                this.value = t0;
                this.span = t1;
            },
            booleanClass_closure: function booleanClass_closure() {},
            booleanClass__closure: function booleanClass__closure() {},
            legacyBooleanClass_closure: function legacyBooleanClass_closure() {},
            legacyBooleanClass__closure: function legacyBooleanClass__closure() {},
            legacyBooleanClass__closure0: function legacyBooleanClass__closure0() {},
            SassBoolean0: function SassBoolean0(t0) {
                this.value = t0;
            },
            BooleanOperator0: function BooleanOperator0(t0, t1) {
                this.index = t0;
                this._name = t1;
            },
            Box0: function Box0(t0, t1) {
                this._box0$_inner = t0;
                this.$ti = t1;
            },
            ModifiableBox0: function ModifiableBox0(t0, t1) {
                this.value = t0;
                this.$ti = t1;
            },
            BuiltInCallable$function0: function($name, parameters, callback, url) {
                return new A.BuiltInCallable0($name, A._setArrayType([
                    new A._Record_2(A.ScssParser$0("@function " + $name + "(" + parameters + ") {", false, url).parseParameterList$0(), callback)
                ], type$.JSArray_Record_2_ParameterList_and_Value_Function_List_Value_2), false);
            },
            BuiltInCallable$mixin0: function($name, parameters, callback, acceptsContent, url) {
                return new A.BuiltInCallable0($name, A._setArrayType([
                    new A._Record_2(A.ScssParser$0("@mixin " + $name + "(" + parameters + ") {", false, url).parseParameterList$0(), new A.BuiltInCallable$mixin_closure0(callback))
                ], type$.JSArray_Record_2_ParameterList_and_Value_Function_List_Value_2), acceptsContent);
            },
            BuiltInCallable$overloadedFunction0: function($name, overloads) {
                var t2, t3, t4, t5, t6, t7, args, callback, t1 = A._setArrayType([], type$.JSArray_Record_2_ParameterList_and_Value_Function_List_Value_2);
                for(t2 = type$.String, t3 = A.MapExtensions_get_pairs0(overloads, t2, type$.Value_Function_List_Value_2), t3 = t3.get$iterator(t3), t4 = "@function " + $name + "(", t5 = type$.FileSpan, t6 = type$.JSArray_Record_3_nullable_Deprecation_deprecation_and_String_message_and_FileSpan_span_2; t3.moveNext$0();){
                    t7 = t3.get$current(t3);
                    args = t7._0;
                    callback = t7._1;
                    t1.push(new A._Record_2(new A.ScssParser0(false, A.LinkedHashMap_LinkedHashMap$_empty(t2, t5), A._setArrayType([], t6), A.SpanScanner$(t4 + args + ") {", null), null).parseParameterList$0(), callback));
                }
                return new A.BuiltInCallable0($name, t1, false);
            },
            BuiltInCallable0: function BuiltInCallable0(t0, t1, t2) {
                this.name = t0;
                this._built_in$_overloads = t1;
                this.acceptsContent = t2;
            },
            BuiltInCallable$mixin_closure0: function BuiltInCallable$mixin_closure0(t0) {
                this.callback = t0;
            },
            BuiltInCallable_withDeprecationWarning_closure0: function BuiltInCallable_withDeprecationWarning_closure0(t0, t1, t2, t3) {
                var _ = this;
                _._box_0 = t0;
                _.$this = t1;
                _.module = t2;
                _.newName = t3;
            },
            BuiltInModule$0: function($name, functions, mixins, variables, $T) {
                var t1 = A._Uri__Uri(null, $name, null, "sass"), t2 = A.BuiltInModule__callableMap0(functions, $T), t3 = A.BuiltInModule__callableMap0(mixins, $T), t4 = variables == null ? B.Map_empty15 : new A.UnmodifiableMapView(variables, type$.UnmodifiableMapView_String_Value_2);
                return new A.BuiltInModule0(t1, t2, t3, t4, $T._eval$1("BuiltInModule0<0>"));
            },
            BuiltInModule__callableMap0: function(callables, $T) {
                var t2, _i, callable, t1 = type$.String;
                if (callables == null) t1 = A.LinkedHashMap_LinkedHashMap$_empty(t1, $T);
                else {
                    t1 = A.LinkedHashMap_LinkedHashMap$_empty(t1, $T);
                    for(t2 = callables.length, _i = 0; _i < callables.length; callables.length === t2 || (0, A.throwConcurrentModificationError)(callables), ++_i){
                        callable = callables[_i];
                        t1.$indexSet(0, callable.get$name(callable), callable);
                    }
                    t1 = new A.UnmodifiableMapView(t1, type$.$env_1_1_String._bind$1($T)._eval$1("UnmodifiableMapView<1,2>"));
                }
                return new A.UnmodifiableMapView(t1, type$.$env_1_1_String._bind$1($T)._eval$1("UnmodifiableMapView<1,2>"));
            },
            BuiltInModule0: function BuiltInModule0(t0, t1, t2, t3, t4) {
                var _ = this;
                _.url = t0;
                _.functions = t1;
                _.mixins = t2;
                _.variables = t3;
                _.$ti = t4;
            },
            _assertCalculationValue: function(arg) {
                var t1;
                $label0$0: {
                    if (!(arg instanceof A.SassNumber0)) t1 = arg instanceof A.SassString0 && !arg._string0$_hasQuotes || arg instanceof A.SassCalculation0 || arg instanceof A.CalculationOperation0 || arg instanceof A.CalculationInterpolation;
                    else t1 = true;
                    if (t1) {
                        t1 = null;
                        break $label0$0;
                    }
                    t1 = A.jsThrow0(new self.Error("Argument `" + A.S(arg) + "` must be one of SassNumber, unquoted SassString, SassCalculation, CalculationOperation, CalculationInterpolation"));
                }
                return t1;
            },
            _isValidClampArg: function(arg) {
                var t1;
                $label0$0: {
                    if (!(arg instanceof A.CalculationInterpolation)) t1 = arg instanceof A.SassString0 && !arg._string0$_hasQuotes;
                    else t1 = true;
                    break $label0$0;
                }
                return t1;
            },
            calculationClass_closure: function calculationClass_closure() {},
            calculationClass__closure: function calculationClass__closure() {},
            calculationClass__closure0: function calculationClass__closure0() {},
            calculationClass__closure1: function calculationClass__closure1() {},
            calculationClass__closure2: function calculationClass__closure2() {},
            calculationClass__closure3: function calculationClass__closure3() {},
            calculationClass__closure4: function calculationClass__closure4() {},
            calculationClass__closure5: function calculationClass__closure5() {},
            calculationOperationClass_closure: function calculationOperationClass_closure() {},
            calculationOperationClass__closure: function calculationOperationClass__closure() {},
            calculationOperationClass___closure: function calculationOperationClass___closure(t0) {
                this.strOperator = t0;
            },
            calculationOperationClass__closure0: function calculationOperationClass__closure0() {},
            calculationOperationClass__closure1: function calculationOperationClass__closure1() {},
            calculationOperationClass__closure2: function calculationOperationClass__closure2() {},
            calculationOperationClass__closure3: function calculationOperationClass__closure3() {},
            calculationOperationClass__closure4: function calculationOperationClass__closure4() {},
            calculationInterpolationClass_closure: function calculationInterpolationClass_closure() {},
            calculationInterpolationClass__closure: function calculationInterpolationClass__closure() {},
            calculationInterpolationClass__closure0: function calculationInterpolationClass__closure0() {},
            calculationInterpolationClass__closure1: function calculationInterpolationClass__closure1() {},
            calculationInterpolationClass__closure2: function calculationInterpolationClass__closure2() {},
            SassCalculation_calc0: function(argument) {
                var t1, _0_0 = A.SassCalculation__simplify0(argument);
                $label0$0: {
                    if (_0_0 instanceof A.SassNumber0) {
                        t1 = _0_0;
                        break $label0$0;
                    }
                    if (_0_0 instanceof A.SassCalculation0) {
                        t1 = _0_0;
                        break $label0$0;
                    }
                    t1 = new A.SassCalculation0("calc", A.List_List$unmodifiable([
                        _0_0
                    ], type$.Object));
                    break $label0$0;
                }
                return t1;
            },
            SassCalculation_min0: function($arguments) {
                var minimum, _i, arg, t2, args = A.List_List$unmodifiable(new A.MappedListIterable($arguments, A.calculation0_SassCalculation__simplify$closure(), A._arrayInstanceType($arguments)._eval$1("MappedListIterable<1,@>")), type$.Object), t1 = args.length;
                if (t1 === 0) throw A.wrapException(A.ArgumentError$("min() must have at least one argument.", null));
                for(minimum = null, _i = 0; _i < t1; ++_i){
                    arg = args[_i];
                    if (arg instanceof A.SassNumber0) t2 = minimum != null && !minimum.isComparableTo$1(arg);
                    else t2 = true;
                    if (t2) {
                        minimum = null;
                        break;
                    } else if (minimum == null || minimum.greaterThan$1(arg).value) minimum = arg;
                }
                if (minimum != null) return minimum;
                A.SassCalculation__verifyCompatibleNumbers0(args);
                return new A.SassCalculation0("min", args);
            },
            SassCalculation_max0: function($arguments) {
                var maximum, _i, arg, t2, args = A.List_List$unmodifiable(new A.MappedListIterable($arguments, A.calculation0_SassCalculation__simplify$closure(), A._arrayInstanceType($arguments)._eval$1("MappedListIterable<1,@>")), type$.Object), t1 = args.length;
                if (t1 === 0) throw A.wrapException(A.ArgumentError$("max() must have at least one argument.", null));
                for(maximum = null, _i = 0; _i < t1; ++_i){
                    arg = args[_i];
                    if (arg instanceof A.SassNumber0) t2 = maximum != null && !maximum.isComparableTo$1(arg);
                    else t2 = true;
                    if (t2) {
                        maximum = null;
                        break;
                    } else if (maximum == null || maximum.lessThan$1(arg).value) maximum = arg;
                }
                if (maximum != null) return maximum;
                A.SassCalculation__verifyCompatibleNumbers0(args);
                return new A.SassCalculation0("max", args);
            },
            SassCalculation_hypot0: function($arguments) {
                var first, subtotal, i, number, value, t2, args = A.List_List$unmodifiable(new A.MappedListIterable($arguments, A.calculation0_SassCalculation__simplify$closure(), A._arrayInstanceType($arguments)._eval$1("MappedListIterable<1,@>")), type$.Object), t1 = args.length;
                if (t1 === 0) throw A.wrapException(A.ArgumentError$("hypot() must have at least one argument.", null));
                A.SassCalculation__verifyCompatibleNumbers0(args);
                first = B.JSArray_methods.get$first(args);
                if (!(first instanceof A.SassNumber0) || first.hasUnit$1("%")) return new A.SassCalculation0("hypot", args);
                for(subtotal = 0, i = 0; i < t1;){
                    number = args[i];
                    if (!(number instanceof A.SassNumber0) || !number.hasCompatibleUnits$1(first)) return new A.SassCalculation0("hypot", args);
                    ++i;
                    value = number.convertValueToMatch$3(first, "numbers[" + i + "]", "numbers[1]");
                    subtotal += value * value;
                }
                t1 = Math.sqrt(subtotal);
                t2 = first.get$numeratorUnits(first);
                return A.SassNumber_SassNumber$withUnits0(t1, first.get$denominatorUnits(first), t2);
            },
            SassCalculation_abs0: function(argument) {
                argument = A.SassCalculation__simplify0(argument);
                if (!(argument instanceof A.SassNumber0)) return new A.SassCalculation0("abs", A._setArrayType([
                    argument
                ], type$.JSArray_Object));
                if (argument.hasUnit$1("%")) A.warnForDeprecation0(string$.Passinp + argument.toString$0(0) + ")\nTo emit a CSS abs() now: abs(#{" + argument.toString$0(0) + string$.x7dx29_Mor, B.Deprecation_w3M);
                return A.SassNumber_SassNumber0(Math.abs(argument._number1$_value), null).coerceToMatch$1(argument);
            },
            SassCalculation_exp0: function(argument) {
                argument = A.SassCalculation__simplify0(argument);
                if (!(argument instanceof A.SassNumber0)) return new A.SassCalculation0("exp", A._setArrayType([
                    argument
                ], type$.JSArray_Object));
                argument.assertNoUnits$0();
                return A.pow1(A.SassNumber_SassNumber0(2.718281828459045, null), argument);
            },
            SassCalculation_sign0: function(argument) {
                var t1, _0_2, t2, arg;
                argument = A.SassCalculation__simplify0(argument);
                $label0$0: {
                    t1 = argument instanceof A.SassNumber0;
                    if (t1) {
                        _0_2 = argument._number1$_value;
                        if (!isNaN(_0_2)) t2 = 0 === _0_2;
                        else t2 = true;
                    } else t2 = false;
                    if (t2) {
                        t1 = argument;
                        break $label0$0;
                    }
                    if (t1) {
                        t1 = !argument.hasUnit$1("%");
                        arg = argument;
                    } else {
                        arg = null;
                        t1 = false;
                    }
                    if (t1) {
                        t1 = A.SassNumber_SassNumber0(J.get$sign$in(arg._number1$_value), null).coerceToMatch$1(argument);
                        break $label0$0;
                    }
                    t1 = new A.SassCalculation0("sign", A._setArrayType([
                        argument
                    ], type$.JSArray_Object));
                    break $label0$0;
                }
                return t1;
            },
            SassCalculation_clamp0: function(min, value, max) {
                var t1, args;
                if (value == null && max != null) throw A.wrapException(A.ArgumentError$("If value is null, max must also be null.", null));
                min = A.SassCalculation__simplify0(min);
                value = A.NullableExtension_andThen0(value, A.calculation0_SassCalculation__simplify$closure());
                max = A.NullableExtension_andThen0(max, A.calculation0_SassCalculation__simplify$closure());
                if (min instanceof A.SassNumber0 && value instanceof A.SassNumber0 && max instanceof A.SassNumber0 && min.hasCompatibleUnits$1(value) && min.hasCompatibleUnits$1(max)) {
                    if (value.lessThanOrEquals$1(min).value) return min;
                    if (value.greaterThanOrEquals$1(max).value) return max;
                    return value;
                }
                t1 = [
                    min
                ];
                if (value != null) t1.push(value);
                if (max != null) t1.push(max);
                args = A.List_List$unmodifiable(t1, type$.Object);
                A.SassCalculation__verifyCompatibleNumbers0(args);
                A.SassCalculation__verifyLength0(args, 3);
                return new A.SassCalculation0("clamp", args);
            },
            SassCalculation_pow0: function(base, exponent) {
                var t1 = A._setArrayType([
                    base
                ], type$.JSArray_Object);
                if (exponent != null) t1.push(exponent);
                A.SassCalculation__verifyLength0(t1, 2);
                base = A.SassCalculation__simplify0(base);
                exponent = A.NullableExtension_andThen0(exponent, A.calculation0_SassCalculation__simplify$closure());
                if (!(base instanceof A.SassNumber0) || !(exponent instanceof A.SassNumber0)) return new A.SassCalculation0("pow", t1);
                base.assertNoUnits$0();
                exponent.assertNoUnits$0();
                return A.pow1(base, exponent);
            },
            SassCalculation_log0: function(number, base) {
                var t1, t2;
                number = A.SassCalculation__simplify0(number);
                base = A.NullableExtension_andThen0(base, A.calculation0_SassCalculation__simplify$closure());
                t1 = A._setArrayType([
                    number
                ], type$.JSArray_Object);
                t2 = base != null;
                if (t2) t1.push(base);
                if (number instanceof A.SassNumber0) t2 = t2 && !(base instanceof A.SassNumber0);
                else t2 = true;
                if (t2) return new A.SassCalculation0("log", t1);
                number.assertNoUnits$0();
                if (base instanceof A.SassNumber0) {
                    base.assertNoUnits$0();
                    return A.log0(number, base);
                }
                return A.log0(number, null);
            },
            SassCalculation_atan20: function(y, x) {
                var t1;
                y = A.SassCalculation__simplify0(y);
                x = A.NullableExtension_andThen0(x, A.calculation0_SassCalculation__simplify$closure());
                t1 = A._setArrayType([
                    y
                ], type$.JSArray_Object);
                if (x != null) t1.push(x);
                A.SassCalculation__verifyLength0(t1, 2);
                A.SassCalculation__verifyCompatibleNumbers0(t1);
                if (!(y instanceof A.SassNumber0) || !(x instanceof A.SassNumber0) || y.hasUnit$1("%") || x.hasUnit$1("%") || !y.hasCompatibleUnits$1(x)) return new A.SassCalculation0("atan2", t1);
                return A.SassNumber_SassNumber$withUnits0(Math.atan2(y._number1$_value, x.convertValueToMatch$3(y, "x", "y")) * 57.29577951308232, null, A._setArrayType([
                    "deg"
                ], type$.JSArray_String));
            },
            SassCalculation_rem0: function(dividend, modulus) {
                var t1, result;
                dividend = A.SassCalculation__simplify0(dividend);
                modulus = A.NullableExtension_andThen0(modulus, A.calculation0_SassCalculation__simplify$closure());
                t1 = A._setArrayType([
                    dividend
                ], type$.JSArray_Object);
                if (modulus != null) t1.push(modulus);
                A.SassCalculation__verifyLength0(t1, 2);
                A.SassCalculation__verifyCompatibleNumbers0(t1);
                if (!(dividend instanceof A.SassNumber0) || !(modulus instanceof A.SassNumber0) || !dividend.hasCompatibleUnits$1(modulus)) return new A.SassCalculation0("rem", t1);
                result = dividend.modulo$1(modulus);
                t1 = modulus._number1$_value;
                if (A.DoubleWithSignedZero_get_signIncludingZero0(t1) !== A.DoubleWithSignedZero_get_signIncludingZero0(dividend._number1$_value)) {
                    if (t1 == 1 / 0 || t1 == -1 / 0) return dividend;
                    if (result._number1$_value === 0) return result.unaryMinus$0();
                    return result.minus$1(modulus);
                }
                return result;
            },
            SassCalculation_mod0: function(dividend, modulus) {
                var t1;
                dividend = A.SassCalculation__simplify0(dividend);
                modulus = A.NullableExtension_andThen0(modulus, A.calculation0_SassCalculation__simplify$closure());
                t1 = A._setArrayType([
                    dividend
                ], type$.JSArray_Object);
                if (modulus != null) t1.push(modulus);
                A.SassCalculation__verifyLength0(t1, 2);
                A.SassCalculation__verifyCompatibleNumbers0(t1);
                if (!(dividend instanceof A.SassNumber0) || !(modulus instanceof A.SassNumber0) || !dividend.hasCompatibleUnits$1(modulus)) return new A.SassCalculation0("mod", t1);
                return dividend.modulo$1(modulus);
            },
            SassCalculation_roundInternal0: function(strategyOrNumber, numberOrStep, step, inLegacySassFunction, span, warn) {
                var _0_8_isSet, t2, _0_6_isSet, _0_6_isSet0, _0_14_isSet, _0_14, _0_12, _0_16, _0_18, _0_18_isSet, _0_20, _0_20_isSet, strategy, _0_9_isSet0, _0_16_isSet, t3, t4, _0_12_isSet, _0_12_isSet0, rest, _null = null, _s5_ = "round", _0_1 = A.SassCalculation__simplify0(strategyOrNumber), _0_6 = A.NullableExtension_andThen0(numberOrStep, A.calculation0_SassCalculation__simplify$closure()), _0_9 = A.NullableExtension_andThen0(step, A.calculation0_SassCalculation__simplify$closure()), _0_8 = _null, _0_60 = _null, _0_10 = _null, _0_10_isSet = false, _0_90 = _null, _0_9_isSet = false, number = _null, t1 = false;
                if (_0_1 instanceof A.SassNumber0) {
                    _0_8_isSet = !_0_1.get$hasUnits();
                    if (_0_8_isSet) {
                        _0_8 = _0_6 == null;
                        t2 = _0_8;
                        if (t2) {
                            _0_10 = _0_9 == null;
                            t1 = _0_10;
                            _0_90 = _0_9;
                            _0_10_isSet = true;
                            _0_9_isSet = true;
                        }
                        _0_60 = _0_6;
                        number = _0_1;
                    }
                    _0_6_isSet = _0_8_isSet;
                } else {
                    _0_8_isSet = false;
                    _0_6_isSet = false;
                }
                if (t1) return A.SassNumber_SassNumber0(B.JSNumber_methods.round$0(number._number1$_value), _null);
                t1 = false;
                if (_0_1 instanceof A.SassNumber0) {
                    if (_0_8_isSet) t2 = _0_8;
                    else {
                        if (_0_6_isSet) t2 = _0_60;
                        else {
                            t2 = _0_6;
                            _0_60 = t2;
                            _0_6_isSet = true;
                        }
                        _0_8 = t2 == null;
                        t2 = _0_8;
                        _0_8_isSet = true;
                    }
                    if (t2) {
                        if (_0_10_isSet) t1 = _0_10;
                        else {
                            if (_0_9_isSet) t1 = _0_90;
                            else {
                                t1 = _0_9;
                                _0_90 = t1;
                                _0_9_isSet = true;
                            }
                            _0_10 = t1 == null;
                            t1 = _0_10;
                            _0_10_isSet = true;
                        }
                        t1 = t1 && inLegacySassFunction != null;
                    }
                    number = _0_1;
                } else number = _null;
                if (t1) {
                    warn.call$2(string$.In_fut, B.Deprecation_SGB);
                    t1 = B.JSNumber_methods.round$0(number._number1$_value);
                    t2 = number.get$numeratorUnits(number);
                    return A.SassNumber_SassNumber$withUnits0(t1, number.get$denominatorUnits(number), t2);
                }
                step = _null;
                t1 = false;
                if (_0_1 instanceof A.SassNumber0) {
                    _0_6_isSet0 = true;
                    if (_0_6_isSet) t2 = _0_60;
                    else {
                        t2 = _0_6;
                        _0_6_isSet = _0_6_isSet0;
                        _0_60 = t2;
                    }
                    if (t2 instanceof A.SassNumber0) {
                        if (_0_6_isSet) t2 = _0_60;
                        else {
                            t2 = _0_6;
                            _0_6_isSet = _0_6_isSet0;
                            _0_60 = t2;
                        }
                        type$.SassNumber_2._as(t2);
                        if (_0_10_isSet) t1 = _0_10;
                        else {
                            if (_0_9_isSet) t1 = _0_90;
                            else {
                                t1 = _0_9;
                                _0_90 = t1;
                                _0_9_isSet = true;
                            }
                            _0_10 = t1 == null;
                            t1 = _0_10;
                            _0_10_isSet = true;
                        }
                        t1 = t1 && !_0_1.hasCompatibleUnits$1(t2);
                        step = t2;
                    }
                    number = _0_1;
                } else number = _null;
                if (t1) {
                    t1 = type$.JSArray_Object;
                    A.SassCalculation__verifyCompatibleNumbers0(A._setArrayType([
                        number,
                        step
                    ], t1));
                    return new A.SassCalculation0(_s5_, A._setArrayType([
                        number,
                        step
                    ], t1));
                }
                step = _null;
                t1 = false;
                if (_0_1 instanceof A.SassNumber0) {
                    _0_6_isSet0 = true;
                    if (_0_6_isSet) t2 = _0_60;
                    else {
                        t2 = _0_6;
                        _0_6_isSet = _0_6_isSet0;
                        _0_60 = t2;
                    }
                    if (t2 instanceof A.SassNumber0) {
                        if (_0_6_isSet) t2 = _0_60;
                        else {
                            t2 = _0_6;
                            _0_6_isSet = _0_6_isSet0;
                            _0_60 = t2;
                        }
                        type$.SassNumber_2._as(t2);
                        if (_0_10_isSet) t1 = _0_10;
                        else {
                            if (_0_9_isSet) t1 = _0_90;
                            else {
                                t1 = _0_9;
                                _0_90 = t1;
                                _0_9_isSet = true;
                            }
                            _0_10 = t1 == null;
                            t1 = _0_10;
                            _0_10_isSet = true;
                        }
                        step = t2;
                    }
                    number = _0_1;
                } else number = _null;
                if (t1) {
                    A.SassCalculation__verifyCompatibleNumbers0(A._setArrayType([
                        number,
                        step
                    ], type$.JSArray_Object));
                    return A.SassCalculation__roundWithStep0("nearest", number, step);
                }
                _0_14_isSet = _0_1 instanceof A.SassString0;
                _0_14 = _null;
                _0_12 = _null;
                _0_16 = _null;
                _0_18 = _null;
                _0_18_isSet = false;
                _0_20 = _null;
                _0_20_isSet = false;
                strategy = _null;
                number = _null;
                step = _null;
                t1 = false;
                if (_0_14_isSet) {
                    _0_6_isSet0 = true;
                    _0_9_isSet0 = true;
                    _0_12 = _0_1._string0$_text;
                    t2 = _0_12;
                    _0_14 = "nearest" === t2;
                    t2 = _0_14;
                    _0_16_isSet = !t2;
                    t2 = true;
                    if (_0_16_isSet) {
                        _0_16 = "up" === _0_12;
                        t3 = _0_16;
                        _0_18_isSet = !t3;
                        if (_0_18_isSet) {
                            _0_18 = "down" === _0_12;
                            t3 = _0_18;
                            _0_20_isSet = !t3;
                            if (_0_20_isSet) {
                                _0_20 = "to-zero" === _0_12;
                                t2 = _0_20;
                            }
                        }
                    }
                    if (t2) {
                        if (_0_6_isSet) t2 = _0_60;
                        else {
                            t2 = _0_6;
                            _0_6_isSet = _0_6_isSet0;
                            _0_60 = t2;
                        }
                        if (t2 instanceof A.SassNumber0) {
                            if (_0_6_isSet) t2 = _0_60;
                            else {
                                t2 = _0_6;
                                _0_6_isSet = _0_6_isSet0;
                                _0_60 = t2;
                            }
                            t3 = type$.SassNumber_2;
                            t3._as(t2);
                            if (_0_9_isSet) t4 = _0_90;
                            else {
                                t4 = _0_9;
                                _0_9_isSet = _0_9_isSet0;
                                _0_90 = t4;
                            }
                            if (t4 instanceof A.SassNumber0) {
                                if (_0_9_isSet) t1 = _0_90;
                                else {
                                    t1 = _0_9;
                                    _0_9_isSet = _0_9_isSet0;
                                    _0_90 = t1;
                                }
                                t3._as(t1);
                                t3 = !t2.hasCompatibleUnits$1(t1);
                                step = t1;
                                t1 = t3;
                            }
                            number = t2;
                        }
                        strategy = _0_1;
                    }
                } else _0_16_isSet = false;
                if (t1) {
                    t1 = type$.JSArray_Object;
                    A.SassCalculation__verifyCompatibleNumbers0(A._setArrayType([
                        number,
                        step
                    ], t1));
                    return new A.SassCalculation0(_s5_, A._setArrayType([
                        strategy,
                        number,
                        step
                    ], t1));
                }
                strategy = _null;
                number = _null;
                step = _null;
                t1 = false;
                if (_0_1 instanceof A.SassString0) {
                    _0_6_isSet0 = true;
                    _0_9_isSet0 = true;
                    _0_12_isSet = true;
                    if (_0_14_isSet) {
                        t2 = _0_14;
                        _0_12_isSet0 = _0_14_isSet;
                    } else {
                        _0_12 = _0_1._string0$_text;
                        t2 = _0_12;
                        _0_14 = "nearest" === t2;
                        t2 = _0_14;
                        _0_12_isSet0 = _0_12_isSet;
                        _0_14_isSet = true;
                    }
                    t3 = true;
                    if (!t2) {
                        if (_0_16_isSet) t2 = _0_16;
                        else {
                            if (_0_12_isSet0) t2 = _0_12;
                            else {
                                _0_12 = _0_1._string0$_text;
                                t2 = _0_12;
                                _0_12_isSet0 = _0_12_isSet;
                            }
                            _0_16 = "up" === t2;
                            t2 = _0_16;
                            _0_16_isSet = true;
                        }
                        if (!t2) {
                            if (_0_18_isSet) t2 = _0_18;
                            else {
                                if (_0_12_isSet0) t2 = _0_12;
                                else {
                                    _0_12 = _0_1._string0$_text;
                                    t2 = _0_12;
                                    _0_12_isSet0 = _0_12_isSet;
                                }
                                _0_18 = "down" === t2;
                                t2 = _0_18;
                                _0_18_isSet = true;
                            }
                            if (!t2) {
                                if (_0_20_isSet) {
                                    t2 = _0_20;
                                    _0_12_isSet = _0_12_isSet0;
                                } else {
                                    if (_0_12_isSet0) {
                                        t2 = _0_12;
                                        _0_12_isSet = _0_12_isSet0;
                                    } else {
                                        _0_12 = _0_1._string0$_text;
                                        t2 = _0_12;
                                    }
                                    _0_20 = "to-zero" === t2;
                                    t2 = _0_20;
                                    _0_20_isSet = true;
                                }
                            } else {
                                t2 = t3;
                                _0_12_isSet = _0_12_isSet0;
                            }
                        } else {
                            t2 = t3;
                            _0_12_isSet = _0_12_isSet0;
                        }
                    } else {
                        t2 = t3;
                        _0_12_isSet = _0_12_isSet0;
                    }
                    if (t2) {
                        if (_0_6_isSet) t2 = _0_60;
                        else {
                            t2 = _0_6;
                            _0_6_isSet = _0_6_isSet0;
                            _0_60 = t2;
                        }
                        if (t2 instanceof A.SassNumber0) {
                            if (_0_6_isSet) t2 = _0_60;
                            else {
                                t2 = _0_6;
                                _0_6_isSet = _0_6_isSet0;
                                _0_60 = t2;
                            }
                            t3 = type$.SassNumber_2;
                            t3._as(t2);
                            if (_0_9_isSet) t1 = _0_90;
                            else {
                                t1 = _0_9;
                                _0_9_isSet = _0_9_isSet0;
                                _0_90 = t1;
                            }
                            t1 = t1 instanceof A.SassNumber0;
                            if (t1) {
                                if (_0_9_isSet) t4 = _0_90;
                                else {
                                    t4 = _0_9;
                                    _0_9_isSet = _0_9_isSet0;
                                    _0_90 = t4;
                                }
                                t3._as(t4);
                                step = t4;
                            }
                            number = t2;
                        }
                        strategy = _0_1;
                    }
                } else _0_12_isSet = _0_14_isSet;
                if (t1) {
                    A.SassCalculation__verifyCompatibleNumbers0(A._setArrayType([
                        number,
                        step
                    ], type$.JSArray_Object));
                    return A.SassCalculation__roundWithStep0(strategy._string0$_text, number, step);
                }
                strategy = _null;
                rest = _null;
                t1 = false;
                if (_0_1 instanceof A.SassString0) {
                    _0_6_isSet0 = true;
                    _0_12_isSet0 = true;
                    if (_0_14_isSet) t2 = _0_14;
                    else {
                        if (_0_12_isSet) t2 = _0_12;
                        else {
                            _0_12 = _0_1._string0$_text;
                            t2 = _0_12;
                            _0_12_isSet = _0_12_isSet0;
                        }
                        _0_14 = "nearest" === t2;
                        t2 = _0_14;
                        _0_14_isSet = true;
                    }
                    t3 = true;
                    if (!t2) {
                        if (_0_16_isSet) t2 = _0_16;
                        else {
                            if (_0_12_isSet) t2 = _0_12;
                            else {
                                _0_12 = _0_1._string0$_text;
                                t2 = _0_12;
                                _0_12_isSet = _0_12_isSet0;
                            }
                            _0_16 = "up" === t2;
                            t2 = _0_16;
                            _0_16_isSet = true;
                        }
                        if (!t2) {
                            if (_0_18_isSet) t2 = _0_18;
                            else {
                                if (_0_12_isSet) t2 = _0_12;
                                else {
                                    _0_12 = _0_1._string0$_text;
                                    t2 = _0_12;
                                    _0_12_isSet = _0_12_isSet0;
                                }
                                _0_18 = "down" === t2;
                                t2 = _0_18;
                                _0_18_isSet = true;
                            }
                            if (!t2) {
                                if (_0_20_isSet) t2 = _0_20;
                                else {
                                    if (_0_12_isSet) t2 = _0_12;
                                    else {
                                        _0_12 = _0_1._string0$_text;
                                        t2 = _0_12;
                                        _0_12_isSet = _0_12_isSet0;
                                    }
                                    _0_20 = "to-zero" === t2;
                                    t2 = _0_20;
                                    _0_20_isSet = true;
                                }
                            } else t2 = t3;
                        } else t2 = t3;
                    } else t2 = t3;
                    if (t2) {
                        if (_0_6_isSet) t2 = _0_60;
                        else {
                            t2 = _0_6;
                            _0_6_isSet = _0_6_isSet0;
                            _0_60 = t2;
                        }
                        if (t2 instanceof A.SassString0) {
                            if (_0_6_isSet) t2 = _0_60;
                            else {
                                t2 = _0_6;
                                _0_6_isSet = _0_6_isSet0;
                                _0_60 = t2;
                            }
                            type$.SassString_2._as(t2);
                            if (_0_10_isSet) t1 = _0_10;
                            else {
                                if (_0_9_isSet) t1 = _0_90;
                                else {
                                    t1 = _0_9;
                                    _0_90 = t1;
                                    _0_9_isSet = true;
                                }
                                _0_10 = t1 == null;
                                t1 = _0_10;
                                _0_10_isSet = true;
                            }
                            rest = t2;
                        }
                        strategy = _0_1;
                    }
                }
                if (t1) return new A.SassCalculation0(_s5_, A._setArrayType([
                    strategy,
                    rest
                ], type$.JSArray_Object));
                t1 = false;
                if (_0_1 instanceof A.SassString0) {
                    _0_12_isSet0 = true;
                    if (_0_14_isSet) t2 = _0_14;
                    else {
                        if (_0_12_isSet) t2 = _0_12;
                        else {
                            _0_12 = _0_1._string0$_text;
                            t2 = _0_12;
                            _0_12_isSet = _0_12_isSet0;
                        }
                        _0_14 = "nearest" === t2;
                        t2 = _0_14;
                        _0_14_isSet = true;
                    }
                    t3 = true;
                    if (!t2) {
                        if (_0_16_isSet) t2 = _0_16;
                        else {
                            if (_0_12_isSet) t2 = _0_12;
                            else {
                                _0_12 = _0_1._string0$_text;
                                t2 = _0_12;
                                _0_12_isSet = _0_12_isSet0;
                            }
                            _0_16 = "up" === t2;
                            t2 = _0_16;
                            _0_16_isSet = true;
                        }
                        if (!t2) {
                            if (_0_18_isSet) t2 = _0_18;
                            else {
                                if (_0_12_isSet) t2 = _0_12;
                                else {
                                    _0_12 = _0_1._string0$_text;
                                    t2 = _0_12;
                                    _0_12_isSet = _0_12_isSet0;
                                }
                                _0_18 = "down" === t2;
                                t2 = _0_18;
                                _0_18_isSet = true;
                            }
                            if (!t2) {
                                if (_0_20_isSet) t2 = _0_20;
                                else {
                                    if (_0_12_isSet) t2 = _0_12;
                                    else {
                                        _0_12 = _0_1._string0$_text;
                                        t2 = _0_12;
                                        _0_12_isSet = _0_12_isSet0;
                                    }
                                    _0_20 = "to-zero" === t2;
                                    t2 = _0_20;
                                    _0_20_isSet = true;
                                }
                            } else t2 = t3;
                        } else t2 = t3;
                    } else t2 = t3;
                    if (t2) {
                        if (_0_6_isSet) t2 = _0_60;
                        else {
                            t2 = _0_6;
                            _0_60 = t2;
                            _0_6_isSet = true;
                        }
                        if (t2 != null) {
                            if (_0_10_isSet) t1 = _0_10;
                            else {
                                if (_0_9_isSet) t1 = _0_90;
                                else {
                                    t1 = _0_9;
                                    _0_90 = t1;
                                    _0_9_isSet = true;
                                }
                                _0_10 = t1 == null;
                                t1 = _0_10;
                                _0_10_isSet = true;
                            }
                        }
                    }
                }
                if (t1) throw A.wrapException(A.SassScriptException$0(string$.If_str, _null));
                t1 = false;
                if (_0_1 instanceof A.SassString0) {
                    _0_12_isSet0 = true;
                    if (_0_14_isSet) t2 = _0_14;
                    else {
                        if (_0_12_isSet) t2 = _0_12;
                        else {
                            _0_12 = _0_1._string0$_text;
                            t2 = _0_12;
                            _0_12_isSet = _0_12_isSet0;
                        }
                        _0_14 = "nearest" === t2;
                        t2 = _0_14;
                        _0_14_isSet = true;
                    }
                    t3 = true;
                    if (!t2) {
                        if (_0_16_isSet) t2 = _0_16;
                        else {
                            if (_0_12_isSet) t2 = _0_12;
                            else {
                                _0_12 = _0_1._string0$_text;
                                t2 = _0_12;
                                _0_12_isSet = _0_12_isSet0;
                            }
                            _0_16 = "up" === t2;
                            t2 = _0_16;
                            _0_16_isSet = true;
                        }
                        if (!t2) {
                            if (_0_18_isSet) t2 = _0_18;
                            else {
                                if (_0_12_isSet) t2 = _0_12;
                                else {
                                    _0_12 = _0_1._string0$_text;
                                    t2 = _0_12;
                                    _0_12_isSet = _0_12_isSet0;
                                }
                                _0_18 = "down" === t2;
                                t2 = _0_18;
                                _0_18_isSet = true;
                            }
                            if (!t2) {
                                if (_0_20_isSet) t2 = _0_20;
                                else {
                                    if (_0_12_isSet) t2 = _0_12;
                                    else {
                                        _0_12 = _0_1._string0$_text;
                                        t2 = _0_12;
                                        _0_12_isSet = _0_12_isSet0;
                                    }
                                    _0_20 = "to-zero" === t2;
                                    t2 = _0_20;
                                    _0_20_isSet = true;
                                }
                            } else t2 = t3;
                        } else t2 = t3;
                    } else t2 = t3;
                    if (t2) {
                        if (_0_8_isSet) t2 = _0_8;
                        else {
                            if (_0_6_isSet) t2 = _0_60;
                            else {
                                t2 = _0_6;
                                _0_60 = t2;
                                _0_6_isSet = true;
                            }
                            _0_8 = t2 == null;
                            t2 = _0_8;
                            _0_8_isSet = true;
                        }
                        if (t2) {
                            if (_0_10_isSet) t1 = _0_10;
                            else {
                                if (_0_9_isSet) t1 = _0_90;
                                else {
                                    t1 = _0_9;
                                    _0_90 = t1;
                                    _0_9_isSet = true;
                                }
                                _0_10 = t1 == null;
                                t1 = _0_10;
                                _0_10_isSet = true;
                            }
                        }
                    }
                }
                if (t1) throw A.wrapException(A.SassScriptException$0(string$.Number, _null));
                t1 = false;
                if (_0_8_isSet) t2 = _0_8;
                else {
                    if (_0_6_isSet) t2 = _0_60;
                    else {
                        t2 = _0_6;
                        _0_60 = t2;
                        _0_6_isSet = true;
                    }
                    _0_8 = t2 == null;
                    t2 = _0_8;
                }
                if (t2) {
                    if (_0_10_isSet) t1 = _0_10;
                    else {
                        if (_0_9_isSet) t1 = _0_90;
                        else {
                            t1 = _0_9;
                            _0_90 = t1;
                            _0_9_isSet = true;
                        }
                        _0_10 = t1 == null;
                        t1 = _0_10;
                        _0_10_isSet = true;
                    }
                }
                if (t1) return new A.SassCalculation0(_s5_, A._setArrayType([
                    _0_1
                ], type$.JSArray_Object));
                step = _null;
                t1 = false;
                _0_6_isSet0 = true;
                if (_0_6_isSet) t2 = _0_60;
                else {
                    t2 = _0_6;
                    _0_6_isSet = _0_6_isSet0;
                    _0_60 = t2;
                }
                if (t2 != null) {
                    if (_0_6_isSet) step = _0_60;
                    else {
                        step = _0_6;
                        _0_6_isSet = _0_6_isSet0;
                        _0_60 = step;
                    }
                    if (step == null) step = A._asObject(step);
                    if (_0_10_isSet) t1 = _0_10;
                    else {
                        if (_0_9_isSet) t1 = _0_90;
                        else {
                            t1 = _0_9;
                            _0_90 = t1;
                            _0_9_isSet = true;
                        }
                        _0_10 = t1 == null;
                        t1 = _0_10;
                    }
                }
                if (t1) return new A.SassCalculation0(_s5_, A._setArrayType([
                    _0_1,
                    step
                ], type$.JSArray_Object));
                if (_0_1 instanceof A.SassString0) {
                    t1 = true;
                    if (_0_14_isSet) t2 = _0_14;
                    else {
                        if (_0_12_isSet) t2 = _0_12;
                        else {
                            _0_12 = _0_1._string0$_text;
                            t2 = _0_12;
                            _0_12_isSet = true;
                        }
                        _0_14 = "nearest" === t2;
                        t2 = _0_14;
                    }
                    if (!t2) {
                        if (_0_16_isSet) t2 = _0_16;
                        else {
                            if (_0_12_isSet) t2 = _0_12;
                            else {
                                _0_12 = _0_1._string0$_text;
                                t2 = _0_12;
                                _0_12_isSet = true;
                            }
                            _0_16 = "up" === t2;
                            t2 = _0_16;
                        }
                        if (!t2) {
                            if (_0_18_isSet) t2 = _0_18;
                            else {
                                if (_0_12_isSet) t2 = _0_12;
                                else {
                                    _0_12 = _0_1._string0$_text;
                                    t2 = _0_12;
                                    _0_12_isSet = true;
                                }
                                _0_18 = "down" === t2;
                                t2 = _0_18;
                            }
                            if (!t2) {
                                if (_0_20_isSet) t1 = _0_20;
                                else {
                                    if (_0_12_isSet) t1 = _0_12;
                                    else {
                                        _0_12 = _0_1._string0$_text;
                                        t1 = _0_12;
                                    }
                                    _0_20 = "to-zero" === t1;
                                    t1 = _0_20;
                                }
                            }
                        }
                    }
                } else t1 = false;
                if (!t1) {
                    if (_0_1 instanceof A.SassString0) t1 = _0_1.get$isSpecialVariable();
                    else t1 = false;
                } else t1 = true;
                number = _null;
                step = _null;
                t2 = false;
                if (t1) {
                    _0_6_isSet0 = true;
                    _0_9_isSet0 = true;
                    type$.SassString_2._as(_0_1);
                    if (_0_6_isSet) t1 = _0_60;
                    else {
                        t1 = _0_6;
                        _0_6_isSet = _0_6_isSet0;
                        _0_60 = t1;
                    }
                    if (t1 != null) {
                        if (_0_6_isSet) number = _0_60;
                        else {
                            number = _0_6;
                            _0_6_isSet = _0_6_isSet0;
                            _0_60 = number;
                        }
                        if (number == null) number = A._asObject(number);
                        if (_0_9_isSet) t1 = _0_90;
                        else {
                            t1 = _0_9;
                            _0_9_isSet = _0_9_isSet0;
                            _0_90 = t1;
                        }
                        t1 = t1 != null;
                        if (t1) {
                            if (_0_9_isSet) step = _0_90;
                            else {
                                step = _0_9;
                                _0_9_isSet = _0_9_isSet0;
                                _0_90 = step;
                            }
                            if (step == null) step = A._asObject(step);
                        }
                    } else t1 = t2;
                    strategy = _0_1;
                } else {
                    t1 = t2;
                    strategy = _null;
                }
                if (t1) return new A.SassCalculation0(_s5_, A._setArrayType([
                    strategy,
                    number,
                    step
                ], type$.JSArray_Object));
                t1 = false;
                if ((_0_6_isSet ? _0_60 : _0_6) != null) t1 = (_0_9_isSet ? _0_90 : _0_9) != null;
                if (t1) throw A.wrapException(A.SassScriptException$0(A.S(strategyOrNumber) + string$.x20must_b, _null));
                t1 = A.SassScriptException$0("Invalid parameters.", _null);
                throw A.wrapException(t1);
            },
            SassCalculation_calcSize0: function(basis, value) {
                var t1 = type$.JSArray_Object, t2 = A._setArrayType([
                    basis
                ], t1);
                if (value != null) t2.push(value);
                A.SassCalculation__verifyLength0(t2, 2);
                basis = A.SassCalculation__simplify0(basis);
                value = A.NullableExtension_andThen0(value, A.calculation0_SassCalculation__simplify$closure());
                t1 = A._setArrayType([
                    basis
                ], t1);
                if (value != null) t1.push(value);
                return new A.SassCalculation0("calc-size", t1);
            },
            SassCalculation_operateInternal0: function(operator, left, right, inLegacySassFunction, simplify, warn) {
                var compatible, t1;
                if (!simplify) return new A.CalculationOperation0(operator, left, right);
                left = A.SassCalculation__simplify0(left);
                right = A.SassCalculation__simplify0(right);
                if (B.CalculationOperator_dpX0 === operator || B.CalculationOperator_KrC0 === operator) {
                    if (left instanceof A.SassNumber0 && right instanceof A.SassNumber0) {
                        compatible = left.hasCompatibleUnits$1(right);
                        if (!compatible && inLegacySassFunction != null && left.isComparableTo$1(right)) {
                            warn.call$2("In future versions of Sass, " + inLegacySassFunction + "() will be interpreted as the CSS " + inLegacySassFunction + string$.x28__cal + inLegacySassFunction + string$.x28__ins, B.Deprecation_SGB);
                            compatible = true;
                        }
                        if (compatible) return operator === B.CalculationOperator_dpX0 ? left.plus$1(right) : left.minus$1(right);
                    }
                    A.SassCalculation__verifyCompatibleNumbers0(A._setArrayType([
                        left,
                        right
                    ], type$.JSArray_Object));
                    if (right instanceof A.SassNumber0) {
                        t1 = right._number1$_value;
                        t1 = t1 < 0 && !A.fuzzyEquals0(t1, 0);
                    } else t1 = false;
                    if (t1) {
                        right = right.times$1(A.SassNumber_SassNumber0(-1, null));
                        operator = operator === B.CalculationOperator_dpX0 ? B.CalculationOperator_KrC0 : B.CalculationOperator_dpX0;
                    }
                    return new A.CalculationOperation0(operator, left, right);
                } else if (left instanceof A.SassNumber0 && right instanceof A.SassNumber0) return operator === B.CalculationOperator_LPB0 ? left.times$1(right) : left.dividedBy$1(right);
                else return new A.CalculationOperation0(operator, left, right);
            },
            SassCalculation__roundWithStep0: function(strategy, number, step) {
                var _0_2, t1, _0_6, _0_8_isSet, _0_8, _0_9, _0_9_isSet, _0_11, _0_13, stepWithNumberUnit, t2, _null = null;
                if (!A.LinkedHashSet_LinkedHashSet$_literal([
                    "nearest",
                    "up",
                    "down",
                    "to-zero"
                ], type$.String).contains$1(0, strategy)) throw A.wrapException(A.ArgumentError$(strategy + string$.x20must_b, _null));
                _0_2 = number._number1$_value;
                if (_0_2 == 1 / 0 || _0_2 == -1 / 0) {
                    t1 = step._number1$_value;
                    t1 = t1 == 1 / 0 || t1 == -1 / 0;
                } else t1 = false;
                if (!t1) {
                    t1 = step._number1$_value;
                    t1 = t1 === 0 || isNaN(_0_2) || isNaN(t1);
                } else t1 = true;
                if (t1) {
                    t1 = number.get$numeratorUnits(number);
                    return A.SassNumber_SassNumber$withUnits0(0 / 0, number.get$denominatorUnits(number), t1);
                }
                if (_0_2 == 1 / 0 || _0_2 == -1 / 0) return number;
                t1 = step._number1$_value;
                if (t1 == 1 / 0 || t1 == -1 / 0) {
                    $label0$0: {
                        if (0 === _0_2) {
                            t1 = number;
                            break $label0$0;
                        }
                        _0_6 = "nearest" === strategy;
                        t1 = _0_6;
                        _0_8_isSet = !t1;
                        _0_8 = _null;
                        if (_0_8_isSet) {
                            _0_8 = "to-zero" === strategy;
                            t1 = _0_8;
                        } else t1 = true;
                        _0_9 = _null;
                        if (t1) {
                            _0_9 = _0_2 > 0;
                            t1 = _0_9;
                            _0_9_isSet = true;
                        } else {
                            _0_9_isSet = false;
                            t1 = false;
                        }
                        if (t1) {
                            t1 = number.get$numeratorUnits(number);
                            t1 = A.SassNumber_SassNumber$withUnits0(0, number.get$denominatorUnits(number), t1);
                            break $label0$0;
                        }
                        if (!_0_6) {
                            if (_0_8_isSet) t1 = _0_8;
                            else {
                                _0_8 = "to-zero" === strategy;
                                t1 = _0_8;
                            }
                        } else t1 = true;
                        if (t1) {
                            t1 = number.get$numeratorUnits(number);
                            t1 = A.SassNumber_SassNumber$withUnits0(-0, number.get$denominatorUnits(number), t1);
                            break $label0$0;
                        }
                        _0_11 = "up" === strategy;
                        t1 = _0_11;
                        if (t1) {
                            if (_0_9_isSet) t1 = _0_9;
                            else {
                                _0_9 = _0_2 > 0;
                                t1 = _0_9;
                            }
                        } else t1 = false;
                        if (t1) {
                            t1 = number.get$numeratorUnits(number);
                            t1 = A.SassNumber_SassNumber$withUnits0(1 / 0, number.get$denominatorUnits(number), t1);
                            break $label0$0;
                        }
                        if (_0_11) {
                            t1 = number.get$numeratorUnits(number);
                            t1 = A.SassNumber_SassNumber$withUnits0(-0, number.get$denominatorUnits(number), t1);
                            break $label0$0;
                        }
                        _0_13 = "down" === strategy;
                        t1 = _0_13;
                        if (t1) t1 = _0_2 < 0;
                        else t1 = false;
                        if (t1) {
                            t1 = number.get$numeratorUnits(number);
                            t1 = A.SassNumber_SassNumber$withUnits0(-1 / 0, number.get$denominatorUnits(number), t1);
                            break $label0$0;
                        }
                        if (_0_13) {
                            t1 = number.get$numeratorUnits(number);
                            t1 = A.SassNumber_SassNumber$withUnits0(0, number.get$denominatorUnits(number), t1);
                            break $label0$0;
                        }
                        t1 = A.throwExpression(A.UnsupportedError$("Invalid argument: " + strategy + "."));
                    }
                    return t1;
                }
                stepWithNumberUnit = step.convertValueToMatch$1(number);
                $label1$1: {
                    if ("nearest" === strategy) {
                        t1 = B.JSNumber_methods.round$0(_0_2 / stepWithNumberUnit);
                        t2 = number.get$numeratorUnits(number);
                        t2 = A.SassNumber_SassNumber$withUnits0(t1 * stepWithNumberUnit, number.get$denominatorUnits(number), t2);
                        t1 = t2;
                        break $label1$1;
                    }
                    if ("up" === strategy) {
                        t2 = _0_2 / stepWithNumberUnit;
                        t1 = t1 < 0 ? B.JSNumber_methods.floor$0(t2) : B.JSNumber_methods.ceil$0(t2);
                        t2 = number.get$numeratorUnits(number);
                        t2 = A.SassNumber_SassNumber$withUnits0(t1 * stepWithNumberUnit, number.get$denominatorUnits(number), t2);
                        t1 = t2;
                        break $label1$1;
                    }
                    if ("down" === strategy) {
                        t2 = _0_2 / stepWithNumberUnit;
                        t1 = t1 < 0 ? B.JSNumber_methods.ceil$0(t2) : B.JSNumber_methods.floor$0(t2);
                        t2 = number.get$numeratorUnits(number);
                        t2 = A.SassNumber_SassNumber$withUnits0(t1 * stepWithNumberUnit, number.get$denominatorUnits(number), t2);
                        t1 = t2;
                        break $label1$1;
                    }
                    if ("to-zero" === strategy) {
                        t1 = _0_2 / stepWithNumberUnit;
                        if (_0_2 < 0) {
                            t1 = B.JSNumber_methods.ceil$0(t1);
                            t2 = number.get$numeratorUnits(number);
                            t2 = A.SassNumber_SassNumber$withUnits0(t1 * stepWithNumberUnit, number.get$denominatorUnits(number), t2);
                            t1 = t2;
                        } else {
                            t1 = B.JSNumber_methods.floor$0(t1);
                            t2 = number.get$numeratorUnits(number);
                            t2 = A.SassNumber_SassNumber$withUnits0(t1 * stepWithNumberUnit, number.get$denominatorUnits(number), t2);
                            t1 = t2;
                        }
                        break $label1$1;
                    }
                    t1 = number.get$numeratorUnits(number);
                    t1 = A.SassNumber_SassNumber$withUnits0(0 / 0, number.get$denominatorUnits(number), t1);
                    break $label1$1;
                }
                return t1;
            },
            SassCalculation__simplify0: function(arg) {
                var t1, t2, _0_11_isSet, _0_15, _0_12, _0_16_isSet, text, _0_11, t3, _0_16, _0_12_isSet, _0_15_isSet, value, _null = null, _s32_ = " can't be used in a calculation.";
                $label0$0: {
                    if (arg instanceof A.SassNumber0 || arg instanceof A.CalculationOperation0) {
                        t1 = arg;
                        break $label0$0;
                    }
                    if (arg instanceof A.CalculationInterpolation) {
                        t1 = new A.SassString0("(" + arg._calculation0$_value + ")", false);
                        break $label0$0;
                    }
                    t1 = arg instanceof A.SassString0;
                    t2 = _null;
                    if (t1 && !arg._string0$_hasQuotes) {
                        t1 = arg;
                        break $label0$0;
                    }
                    if (t1) A.throwExpression(A.SassScriptException$0("Quoted string " + arg.toString$0(0) + _s32_, _null));
                    _0_11_isSet = arg instanceof A.SassCalculation0;
                    _0_15 = _null;
                    _0_12 = _null;
                    _0_16_isSet = false;
                    text = _null;
                    t1 = false;
                    if (_0_11_isSet) {
                        _0_11 = "calc" === arg.name;
                        if (_0_11) {
                            _0_12 = arg.$arguments;
                            _0_15 = _0_12.length === 1;
                            t3 = _0_15;
                            if (t3) {
                                _0_16 = _0_12[0];
                                t2 = _0_16;
                                if (t2 instanceof A.SassString0) {
                                    type$.SassString_2._as(_0_16);
                                    if (!_0_16._string0$_hasQuotes) {
                                        text = _0_16._string0$_text;
                                        t1 = A.SassCalculation__needsParentheses0(text);
                                    }
                                }
                                _0_16_isSet = true;
                            } else _0_16 = t2;
                        } else _0_16 = t2;
                        _0_12_isSet = _0_11;
                        _0_15_isSet = _0_12_isSet;
                    } else {
                        _0_16 = t2;
                        _0_11 = _null;
                        _0_15_isSet = false;
                        _0_12_isSet = false;
                    }
                    if (t1) {
                        t1 = new A.SassString0("(" + A.S(text) + ")", false);
                        break $label0$0;
                    }
                    t1 = false;
                    if (_0_11_isSet) {
                        if (_0_11) {
                            if (_0_15_isSet) t1 = _0_15;
                            else {
                                if (_0_12_isSet) t1 = _0_12;
                                else {
                                    _0_12 = arg.$arguments;
                                    t1 = _0_12;
                                    _0_12_isSet = true;
                                }
                                _0_15 = t1.length === 1;
                                t1 = _0_15;
                            }
                        }
                    }
                    if (t1) {
                        if (_0_16_isSet) value = _0_16;
                        else {
                            _0_16 = (_0_12_isSet ? _0_12 : arg.$arguments)[0];
                            value = _0_16;
                        }
                        t1 = value;
                        break $label0$0;
                    }
                    if (_0_11_isSet) {
                        t1 = arg;
                        break $label0$0;
                    }
                    if (arg instanceof A.Value0) A.throwExpression(A.SassScriptException$0("Value " + arg.toString$0(0) + _s32_, _null));
                    t1 = A.throwExpression(A.ArgumentError$("Unexpected calculation argument " + A.S(arg) + ".", _null));
                }
                return t1;
            },
            SassCalculation__needsParentheses0: function(text) {
                var t1, couldBeVar, second, third, fourth, i, t2, first = text.charCodeAt(0);
                if (first === 32 || first === 9 || first === 10 || first === 13 || first === 12 || first === 47 || first === 42) return true;
                t1 = text.length;
                couldBeVar = t1 >= 4 && A.characterEqualsIgnoreCase0(first, 118);
                if (t1 < 2) return false;
                second = text.charCodeAt(1);
                if (second === 32 || second === 9 || second === 10 || second === 13 || second === 12 || second === 47 || second === 42) return true;
                couldBeVar = couldBeVar && A.characterEqualsIgnoreCase0(second, 97);
                if (t1 < 3) return false;
                third = text.charCodeAt(2);
                if (third === 32 || third === 9 || third === 10 || third === 13 || third === 12 || third === 47 || third === 42) return true;
                couldBeVar = couldBeVar && A.characterEqualsIgnoreCase0(third, 114);
                if (t1 < 4) return false;
                fourth = text.charCodeAt(3);
                if (couldBeVar && fourth === 40) return true;
                if (fourth === 32 || fourth === 9 || fourth === 10 || fourth === 13 || fourth === 12 || fourth === 47 || fourth === 42) return true;
                for(i = 4; i < t1; ++i){
                    t2 = text.charCodeAt(i);
                    if (t2 === 32 || t2 === 9 || t2 === 10 || t2 === 13 || t2 === 12 || t2 === 47 || t2 === 42) return true;
                }
                return false;
            },
            SassCalculation__verifyCompatibleNumbers0: function(args) {
                var t1, _i, t2, arg, i, number1, j, number2;
                for(t1 = args.length, _i = 0; t2 = args.length, _i < t2; args.length === t1 || (0, A.throwConcurrentModificationError)(args), ++_i){
                    arg = args[_i];
                    if (arg instanceof A.SassNumber0 && arg.get$hasComplexUnits()) throw A.wrapException(A.SassScriptException$0("Number " + arg.toString$0(0) + " isn't compatible with CSS calculations.", null));
                }
                for(t1 = t2, i = 0; i < t1 - 1; ++i){
                    number1 = args[i];
                    if (!(number1 instanceof A.SassNumber0)) continue;
                    for(j = i + 1; t1 = args.length, j < t1; ++j){
                        number2 = args[j];
                        if (!(number2 instanceof A.SassNumber0)) continue;
                        if (number1.hasPossiblyCompatibleUnits$1(number2)) continue;
                        throw A.wrapException(A.SassScriptException$0(number1.toString$0(0) + " and " + number2.toString$0(0) + " are incompatible.", null));
                    }
                }
            },
            SassCalculation__verifyLength0: function(args, expectedLength) {
                var t1;
                if (args.length === expectedLength) return;
                if (B.JSArray_methods.any$1(args, new A.SassCalculation__verifyLength_closure0())) return;
                t1 = args.length;
                throw A.wrapException(A.SassScriptException$0("" + expectedLength + " arguments required, but only " + t1 + " " + A.pluralize0("was", t1, "were") + " passed.", null));
            },
            SassCalculation__singleArgument0: function($name, argument, mathFunc, forbidUnits) {
                argument = A.SassCalculation__simplify0(argument);
                if (!(argument instanceof A.SassNumber0)) return new A.SassCalculation0($name, A._setArrayType([
                    argument
                ], type$.JSArray_Object));
                if (forbidUnits) argument.assertNoUnits$0();
                return mathFunc.call$1(argument);
            },
            SassCalculation0: function SassCalculation0(t0, t1) {
                this.name = t0;
                this.$arguments = t1;
            },
            SassCalculation__verifyLength_closure0: function SassCalculation__verifyLength_closure0() {},
            CalculationOperation0: function CalculationOperation0(t0, t1, t2) {
                this._calculation0$_operator = t0;
                this._calculation0$_left = t1;
                this._calculation0$_right = t2;
            },
            CalculationOperator0: function CalculationOperator0(t0, t1, t2, t3, t4) {
                var _ = this;
                _.name = t0;
                _.operator = t1;
                _.precedence = t2;
                _.index = t3;
                _._name = t4;
            },
            CalculationInterpolation: function CalculationInterpolation(t0) {
                this._calculation0$_value = t0;
            },
            CallableDeclaration0: function CallableDeclaration0() {},
            updateCanonicalizeContextPrototype: function() {
                var t1 = type$.JSClass._as(new A.CanonicalizeContext0(false, null).constructor);
                A.LinkedHashMap_LinkedHashMap$_literal([
                    "fromImport",
                    new A.updateCanonicalizeContextPrototype_closure(),
                    "containingUrl",
                    new A.updateCanonicalizeContextPrototype_closure0()
                ], type$.String, type$.Function).forEach$1(0, A.JSClassExtension_get_defineGetter(t1));
                return null;
            },
            updateCanonicalizeContextPrototype_closure: function updateCanonicalizeContextPrototype_closure() {},
            updateCanonicalizeContextPrototype_closure0: function updateCanonicalizeContextPrototype_closure0() {},
            CanonicalizeContext0: function CanonicalizeContext0(t0, t1) {
                this._canonicalize_context$_fromImport = t0;
                this._canonicalize_context$_containingUrl = t1;
                this._canonicalize_context$_wasContainingUrlAccessed = false;
            },
            ColorChannel0: function ColorChannel0(t0, t1, t2) {
                this.name = t0;
                this.isPolarAngle = t1;
                this.associatedUnit = t2;
            },
            LinearChannel0: function LinearChannel0(t0, t1, t2, t3, t4, t5, t6, t7) {
                var _ = this;
                _.min = t0;
                _.max = t1;
                _.requiresPercent = t2;
                _.lowerClamped = t3;
                _.upperClamped = t4;
                _.name = t5;
                _.isPolarAngle = t6;
                _.associatedUnit = t7;
            },
            Chokidar0: function Chokidar0() {},
            ChokidarOptions0: function ChokidarOptions0() {},
            ChokidarWatcher0: function ChokidarWatcher0() {},
            InterpolatedClassSelector: function InterpolatedClassSelector(t0) {
                this.name = t0;
            },
            ClassSelector0: function ClassSelector0(t0, t1) {
                this.name = t0;
                this.span = t1;
            },
            ClipGamutMap0: function ClipGamutMap0(t0) {
                this.name = t0;
            },
            cloneCssStylesheet0: function(stylesheet, extensionStore) {
                var _0_0 = extensionStore.clone$0();
                return new A._Record_2(new A._CloneCssVisitor0(_0_0._1)._clone_css$_visitChildren$2(A.ModifiableCssStylesheet$0(stylesheet.get$span(stylesheet)), stylesheet), _0_0._0);
            },
            _CloneCssVisitor0: function _CloneCssVisitor0(t0) {
                this._clone_css$_oldToNewSelectors = t0;
            },
            ColorExpression0: function ColorExpression0(t0, t1) {
                this.value = t0;
                this.span = t1;
            },
            _invert0: function($arguments, global) {
                var t2, color, rgb, channel2, space, weight, inSpace, t3, _1_9, channel0, channel1, t4, _s6_ = "weight", _s5_ = "space", t1 = J.getInterceptor$asx($arguments), weightNumber = t1.$index($arguments, 1).assertNumber$1(_s6_);
                if (!(t1.$index($arguments, 0) instanceof A.SassNumber0)) t2 = global && t1.$index($arguments, 0).get$isSpecialNumber();
                else t2 = true;
                if (t2) {
                    if (weightNumber._number1$_value !== 100 || !weightNumber.hasUnit$1("%")) throw A.wrapException(string$.Only_oa);
                    return A._functionString0("invert", t1.take$1($arguments, 1));
                }
                color = t1.$index($arguments, 0).assertColor$1("color");
                if (t1.$index($arguments, 2).$eq(0, B.C__SassNull0)) {
                    t1 = color._color0$_space;
                    if (!t1.get$isLegacyInternal()) throw A.wrapException(A.SassScriptException$0(string$.To_usei + color.toString$0(0) + ", you must provide a $space.", "color"));
                    A._checkPercent0(weightNumber, _s6_);
                    rgb = color.toSpace$1(B.RgbColorSpace_i0P0);
                    channel2 = B.LinearChannel_vJ30;
                    return A._mixLegacy0(A.SassColor_SassColor$rgbInternal0(A._invertChannel0(rgb, B.LinearChannel_qXC0, rgb.channel0OrNull), A._invertChannel0(rgb, B.LinearChannel_Z5r0, rgb.channel1OrNull), A._invertChannel0(rgb, channel2, rgb.channel2OrNull), color.alphaOrNull, null), color, weightNumber).toSpace$1(t1);
                }
                t1 = t1.$index($arguments, 2).assertString$1(_s5_);
                t1.assertUnquoted$1(_s5_);
                space = A.ColorSpace_fromName0(t1._string0$_text, _s5_);
                weight = weightNumber.valueInRangeWithUnit$4(0, 100, _s6_, "%") / 100;
                if (A.fuzzyEquals0(weight, 0)) return color;
                inSpace = color.toSpace$1(space);
                $label0$0: {
                    if (B.HwbColorSpace_guQ0 === space) {
                        t1 = A._invertChannel0(inSpace, space._space$_channels[0], inSpace.channel0OrNull);
                        t2 = inSpace.alphaOrNull;
                        if (t2 == null) t2 = 0;
                        t2 = A.SassColor_SassColor$hwb0(t1, inSpace.channel2OrNull, inSpace.channel1OrNull, t2);
                        t1 = t2;
                        break $label0$0;
                    }
                    if (B.HslColorSpace_JQ20 === space || B.LchColorSpace_Bpv0 === space || B.OklchColorSpace_9Gj0 === space) {
                        t1 = space._space$_channels;
                        t2 = A._invertChannel0(inSpace, t1[0], inSpace.channel0OrNull);
                        t1 = A._invertChannel0(inSpace, t1[2], inSpace.channel2OrNull);
                        t3 = inSpace.alphaOrNull;
                        if (t3 == null) t3 = 0;
                        t3 = A.SassColor_SassColor$forSpaceInternal0(space, t2, inSpace.channel1OrNull, t1, t3);
                        t1 = t3;
                        break $label0$0;
                    }
                    _1_9 = space._space$_channels;
                    channel0 = _1_9[0];
                    channel1 = _1_9[1];
                    channel2 = _1_9[2];
                    t1 = A._invertChannel0(inSpace, channel0, inSpace.channel0OrNull);
                    t2 = A._invertChannel0(inSpace, channel1, inSpace.channel1OrNull);
                    t3 = A._invertChannel0(inSpace, channel2, inSpace.channel2OrNull);
                    t4 = inSpace.alphaOrNull;
                    t1 = A.SassColor_SassColor$forSpaceInternal0(space, t1, t2, t3, t4 == null ? 0 : t4);
                    break $label0$0;
                }
                return A.fuzzyEquals0(weight, 1) ? t1.toSpace$2$legacyMissing(color._color0$_space, false) : color.interpolate$4$legacyMissing$weight(t1, A.InterpolationMethod$0(space, null), false, 1 - weight);
            },
            _invertChannel0: function(color, channel, value) {
                var _0_2_isSet, _0_2, t1;
                if (value == null) A._missingChannelError0(color, channel.name);
                $label0$0: {
                    _0_2_isSet = channel instanceof A.LinearChannel0;
                    _0_2 = null;
                    if (_0_2_isSet) {
                        _0_2 = channel.min;
                        t1 = _0_2;
                        t1 = t1 < 0;
                    } else t1 = false;
                    if (t1) {
                        t1 = -value;
                        break $label0$0;
                    }
                    if (_0_2_isSet) t1 = 0 === _0_2;
                    else t1 = false;
                    if (t1) {
                        t1 = channel.max - value;
                        break $label0$0;
                    }
                    if (channel.isPolarAngle) {
                        t1 = B.JSNumber_methods.$mod(value + 180, 360);
                        break $label0$0;
                    }
                    t1 = A.throwExpression(A.UnsupportedError$("Unknown channel " + channel.toString$0(0) + "."));
                }
                return t1;
            },
            _grayscale0: function(colorArg) {
                var hsl, t2, oklch, color = colorArg.assertColor$1("color"), t1 = color._color0$_space;
                if (t1.get$isLegacyInternal()) {
                    hsl = color.toSpace$1(B.HslColorSpace_JQ20);
                    t2 = hsl.alphaOrNull;
                    if (t2 == null) t2 = 0;
                    return A.SassColor_SassColor$hsl0(hsl.channel0OrNull, 0, hsl.channel2OrNull, t2).toSpace$2$legacyMissing(t1, false);
                } else {
                    oklch = color.toSpace$1(B.OklchColorSpace_9Gj0);
                    t2 = oklch.alphaOrNull;
                    if (t2 == null) t2 = 0;
                    return A.SassColor_SassColor$forSpaceInternal0(B.OklchColorSpace_9Gj0, oklch.channel0OrNull, 0, oklch.channel2OrNull, t2).toSpace$1(t1);
                }
            },
            _updateComponents0: function($arguments, adjust, change, scale) {
                var t2, t3, keywords, originalColor, spaceKeyword, alphaArg, color, channelArgs, channelInfo, t4, value, channelIndex, result, i, alphaNumber, _null = null, _s5_ = "space", t1 = J.getInterceptor$asx($arguments), argumentList = type$.SassArgumentList_2._as(t1.$index($arguments, 1));
                if (argumentList._list1$_contents.length !== 0) throw A.wrapException(A.SassScriptException$0(string$.Only_op, _null));
                argumentList._argument_list$_wereKeywordsAccessed = true;
                t2 = type$.String;
                t3 = type$.Value_2;
                keywords = A.LinkedHashMap_LinkedHashMap$of(argumentList._argument_list$_keywords, t2, t3);
                originalColor = t1.$index($arguments, 0).assertColor$1("color");
                t1 = keywords.remove$1(0, _s5_);
                spaceKeyword = t1 == null ? _null : t1.assertString$1(_s5_);
                if (spaceKeyword == null) spaceKeyword = _null;
                else spaceKeyword.assertUnquoted$1(_s5_);
                alphaArg = keywords.remove$1(0, "alpha");
                t1 = spaceKeyword == null;
                if (t1 && originalColor._color0$_space.get$isLegacyInternal() && keywords.__js_helper$_length !== 0) {
                    t1 = A.NullableExtension_andThen0(A._sniffLegacyColorSpace0(keywords), new A._updateComponents_closure1(originalColor));
                    color = t1 == null ? originalColor : t1;
                } else color = A._colorInSpace0(originalColor, t1 ? B.C__SassNull0 : spaceKeyword, true);
                channelArgs = A.List_List$filled(color.get$channels().length, _null, false, type$.nullable_Value_2);
                t1 = color._color0$_space;
                channelInfo = t1._space$_channels;
                for(t2 = A.MapExtensions_get_pairs0(keywords, t2, t3), t2 = t2.get$iterator(t2); t2.moveNext$0();){
                    t3 = {};
                    t4 = t2.get$current(t2);
                    t3.name = null;
                    t3.name = t4._0;
                    value = t4._1;
                    channelIndex = B.JSArray_methods.indexWhere$1(channelInfo, new A._updateComponents_closure2(t3));
                    if (channelIndex === -1) throw A.wrapException(A.SassScriptException$0("Color space " + t1.toString$0(0) + " doesn't have a channel with this name.", t3.name));
                    channelArgs[channelIndex] = value;
                }
                if (change) result = A._changeColor0(color, channelArgs, alphaArg);
                else {
                    t2 = A._setArrayType([], type$.JSArray_nullable_SassNumber_2);
                    for(i = 0; i < 3; ++i){
                        t3 = channelArgs[i];
                        t2.push(t3 == null ? _null : t3.assertNumber$1(channelInfo[i].name));
                    }
                    alphaNumber = alphaArg == null ? _null : alphaArg.assertNumber$1("alpha");
                    result = scale ? A.SassColor_SassColor$forSpaceInternal0(t1, A._scaleChannel0(color, channelInfo[0], color.channel0OrNull, t2[0]), A._scaleChannel0(color, channelInfo[1], color.channel1OrNull, t2[1]), A._scaleChannel0(color, channelInfo[2], color.channel2OrNull, t2[2]), A._scaleChannel0(color, B.LinearChannel_XL80, color.alphaOrNull, alphaNumber)) : A._adjustColor0(color, t2, alphaNumber);
                }
                return result.toSpace$2$legacyMissing(originalColor._color0$_space, false);
            },
            _changeColor0: function(color, channelArgs, alphaArg) {
                var t4, _s5_ = "alpha", t1 = A._channelForChange0(channelArgs[0], color, 0), t2 = A._channelForChange0(channelArgs[1], color, 1), t3 = A._channelForChange0(channelArgs[2], color, 2);
                $label0$0: {
                    if (alphaArg == null) {
                        t4 = color.alphaOrNull;
                        if (t4 == null) t4 = 0;
                        break $label0$0;
                    }
                    t4 = A._isNone0(alphaArg);
                    if (t4) {
                        t4 = null;
                        break $label0$0;
                    }
                    t4 = alphaArg instanceof A.SassNumber0;
                    if (t4 && !alphaArg.get$hasUnits()) {
                        t4 = alphaArg.valueInRange$3(0, 1, _s5_);
                        break $label0$0;
                    }
                    if (t4 && alphaArg.hasUnit$1("%")) {
                        t4 = alphaArg.valueInRangeWithUnit$4(0, 100, _s5_, "%") / 100;
                        break $label0$0;
                    }
                    if (t4) {
                        t4 = new A._changeColor_closure0(alphaArg).call$0();
                        break $label0$0;
                    }
                    t4 = A.throwExpression(A.SassScriptException$0(alphaArg.toString$0(0) + ' is not a number or unquoted "none".', _s5_));
                }
                return A._colorFromChannels0(color._color0$_space, t1, t2, t3, t4, false, false);
            },
            _channelForChange0: function(channelArg, color, channel) {
                var _0_0, t1, t2;
                if (channelArg == null) {
                    _0_0 = color.get$channelsOrNull()[channel];
                    $label0$0: {
                        if (_0_0 != null) {
                            t1 = color._color0$_space;
                            t2 = A.SassNumber_SassNumber0(_0_0, (t1 === B.HslColorSpace_JQ20 || t1 === B.HwbColorSpace_guQ0) && channel > 0 ? "%" : null);
                            t1 = t2;
                            break $label0$0;
                        }
                        t1 = null;
                        break $label0$0;
                    }
                    return t1;
                }
                if (A._isNone0(channelArg)) return null;
                if (channelArg instanceof A.SassNumber0) return channelArg;
                throw A.wrapException(A.SassScriptException$0(channelArg.toString$0(0) + ' is not a number or unquoted "none".', color._color0$_space._space$_channels[channel].name));
            },
            _scaleChannel0: function(color, channel, oldValue, factorArg) {
                var t1, factor;
                if (factorArg == null) return oldValue;
                if (!(channel instanceof A.LinearChannel0)) throw A.wrapException(A.SassScriptException$0("Channel isn't scalable.", channel.name));
                if (oldValue == null) A._missingChannelError0(color, channel.name);
                t1 = channel.name;
                factorArg.assertUnit$2("%", t1);
                factor = factorArg.valueInRangeWithUnit$4(-100, 100, t1, "%") / 100;
                $label0$0: {
                    if (0 === factor) {
                        t1 = oldValue;
                        break $label0$0;
                    }
                    if (factor > 0) {
                        t1 = channel.max;
                        t1 = oldValue >= t1 ? oldValue : oldValue + (t1 - oldValue) * factor;
                        break $label0$0;
                    }
                    t1 = channel.min;
                    t1 = oldValue <= t1 ? oldValue : oldValue + (oldValue - t1) * factor;
                    break $label0$0;
                }
                return t1;
            },
            _adjustColor0: function(color, channelArgs, alphaArg) {
                var t1 = color._color0$_space, t2 = t1._space$_channels;
                return A.SassColor_SassColor$forSpaceInternal0(t1, A._adjustChannel0(color, t2[0], color.channel0OrNull, channelArgs[0]), A._adjustChannel0(color, t2[1], color.channel1OrNull, channelArgs[1]), A._adjustChannel0(color, t2[2], color.channel2OrNull, channelArgs[2]), A.NullableExtension_andThen0(A._adjustChannel0(color, B.LinearChannel_XL80, color.alphaOrNull, alphaArg), new A._adjustColor_closure0()));
            },
            _adjustChannel0: function(color, channel, oldValue, adjustmentArg) {
                var _0_1, _0_3, t1, _0_6_isSet, _0_6, _0_6_isSet0, t2, _0_11, result, min, max, _null = null;
                if (adjustmentArg == null) return oldValue;
                if (oldValue == null) A._missingChannelError0(color, channel.name);
                $label0$0: {
                    _0_1 = color._color0$_space;
                    _0_3 = B.HslColorSpace_JQ20 === _0_1;
                    t1 = _0_3;
                    if (!t1) _0_6_isSet = B.HwbColorSpace_guQ0 === _0_1;
                    else _0_6_isSet = true;
                    if (_0_6_isSet) {
                        t1 = channel.isPolarAngle;
                        _0_6 = channel;
                    } else {
                        _0_6 = _null;
                        t1 = false;
                    }
                    if (t1) {
                        adjustmentArg = A.SassNumber_SassNumber0(A._angleValue0(adjustmentArg, "hue"), _null);
                        break $label0$0;
                    }
                    t1 = false;
                    if (_0_3) {
                        _0_6_isSet0 = true;
                        if (_0_6_isSet) t2 = _0_6;
                        else {
                            t2 = channel;
                            _0_6_isSet = _0_6_isSet0;
                            _0_6 = t2;
                        }
                        if (t2 instanceof A.LinearChannel0) {
                            if (_0_6_isSet) t1 = _0_6;
                            else {
                                t1 = channel;
                                _0_6_isSet = _0_6_isSet0;
                                _0_6 = t1;
                            }
                            _0_11 = type$.LinearChannel_2._as(t1).name;
                            t1 = _0_11;
                            if ("saturation" !== t1) t1 = "lightness" === _0_11;
                            else t1 = true;
                        }
                    }
                    if (t1) {
                        A._checkPercent0(adjustmentArg, channel.name);
                        adjustmentArg = A.SassNumber_SassNumber0(adjustmentArg._number1$_value, "%");
                        break $label0$0;
                    }
                    if (B.LinearChannel_XL80 === (_0_6_isSet ? _0_6 : channel) && adjustmentArg.get$hasUnits()) {
                        A.warnForDeprecation0("$alpha: Passing a number with unit " + adjustmentArg.get$unitString() + string$.x20is_de + adjustmentArg.unitSuggestion$1("alpha") + string$.x0a_Morex3af, B.Deprecation_PHd);
                        adjustmentArg = A.SassNumber_SassNumber0(adjustmentArg._number1$_value, _null);
                    }
                }
                t1 = A._channelFromValue0(channel, adjustmentArg, false);
                t1.toString;
                result = oldValue + t1;
                $label1$1: {
                    t1 = channel instanceof A.LinearChannel0;
                    min = _null;
                    t2 = false;
                    if (t1) {
                        if (channel.lowerClamped) {
                            min = channel.min;
                            t2 = result < min;
                        }
                    }
                    if (t2) {
                        t1 = oldValue < min ? Math.max(oldValue, result) : min;
                        break $label1$1;
                    }
                    max = _null;
                    t2 = false;
                    if (t1) {
                        if (channel.upperClamped) {
                            max = channel.max;
                            t1 = result > max;
                        } else t1 = t2;
                    } else t1 = t2;
                    if (t1) {
                        t1 = oldValue > max ? Math.min(oldValue, result) : max;
                        break $label1$1;
                    }
                    t1 = result;
                    break $label1$1;
                }
                return t1;
            },
            _sniffLegacyColorSpace0: function(keywords) {
                var t1, t2;
                for(t1 = new A.LinkedHashMapKeyIterator(keywords, keywords._modifications, keywords._first); t1.moveNext$0();){
                    t2 = t1.__js_helper$_current;
                    if ("red" === t2 || "green" === t2 || "blue" === t2) return B.RgbColorSpace_i0P0;
                    if ("saturation" === t2 || "lightness" === t2) return B.HslColorSpace_JQ20;
                    if ("whiteness" === t2 || "blackness" === t2) return B.HwbColorSpace_guQ0;
                }
                return keywords.containsKey$1("hue") ? B.HslColorSpace_JQ20 : null;
            },
            _functionString0: function($name, $arguments) {
                return new A.SassString0($name + "(" + J.map$1$1$ax($arguments, new A._functionString_closure0(), type$.String).join$1(0, ", ") + ")", false);
            },
            _removedColorFunction0: function($name, argument, negative) {
                return A.BuiltInCallable$function0($name, "$color, $amount", new A._removedColorFunction_closure0($name, argument, negative), "sass:color");
            },
            _rgb0: function($name, $arguments) {
                var t3, t4, t1 = J.getInterceptor$asx($arguments), alpha = t1.get$length($arguments) > 3 ? t1.$index($arguments, 3) : null, t2 = true;
                if (!t1.$index($arguments, 0).get$isSpecialNumber()) {
                    if (!t1.$index($arguments, 1).get$isSpecialNumber()) {
                        if (!t1.$index($arguments, 2).get$isSpecialNumber()) {
                            t2 = alpha == null ? null : alpha.get$isSpecialNumber();
                            t2 = t2 === true;
                        }
                    }
                }
                if (t2) return A._functionString0($name, $arguments);
                t2 = t1.$index($arguments, 0).assertNumber$1("red");
                t3 = t1.$index($arguments, 1).assertNumber$1("green");
                t1 = t1.$index($arguments, 2).assertNumber$1("blue");
                t4 = A.NullableExtension_andThen0(alpha, new A._rgb_closure0());
                return A._colorFromChannels0(B.RgbColorSpace_i0P0, t2, t3, t1, t4 == null ? 1 : t4, true, true);
            },
            _rgbTwoArg0: function($name, $arguments) {
                var t2, color, t1 = J.getInterceptor$asx($arguments), first = t1.$index($arguments, 0), second = t1.$index($arguments, 1);
                if (!first.get$isSpecialVariable()) t2 = !(first instanceof A.SassColor0) && second.get$isSpecialVariable();
                else t2 = true;
                if (t2) return A._functionString0($name, $arguments);
                color = first.assertColor$1("color");
                if (!color._color0$_space.get$isLegacyInternal()) throw A.wrapException(A.SassScriptException$0("Expected " + color.toString$0(0) + string$.x20to_be_ + color.toString$0(0) + ", $alpha: " + second.toString$0(0) + ")", $name));
                color.assertLegacy$1("color");
                color = color.toSpace$1(B.RgbColorSpace_i0P0);
                if (second.get$isSpecialNumber()) return A._functionString0($name, A._setArrayType([
                    A.SassNumber_SassNumber0(color.channel$1(0, "red"), null),
                    A.SassNumber_SassNumber0(color.channel$1(0, "green"), null),
                    A.SassNumber_SassNumber0(color.channel$1(0, "blue"), null),
                    t1.$index($arguments, 1)
                ], type$.JSArray_Value_2));
                t1 = A._percentageOrUnitless0(t1.$index($arguments, 1).assertNumber$1("alpha"), 1, "alpha");
                return color.changeAlpha$1(isNaN(t1) ? 0 : B.JSNumber_methods.clamp$2(t1, 0, 1));
            },
            _hsl0: function($name, $arguments) {
                var t3, t4, t1 = J.getInterceptor$asx($arguments), alpha = t1.get$length($arguments) > 3 ? t1.$index($arguments, 3) : null, t2 = true;
                if (!t1.$index($arguments, 0).get$isSpecialNumber()) {
                    if (!t1.$index($arguments, 1).get$isSpecialNumber()) {
                        if (!t1.$index($arguments, 2).get$isSpecialNumber()) {
                            t2 = alpha == null ? null : alpha.get$isSpecialNumber();
                            t2 = t2 === true;
                        }
                    }
                }
                if (t2) return A._functionString0($name, $arguments);
                t2 = t1.$index($arguments, 0).assertNumber$1("hue");
                t3 = t1.$index($arguments, 1).assertNumber$1("saturation");
                t1 = t1.$index($arguments, 2).assertNumber$1("lightness");
                t4 = A.NullableExtension_andThen0(alpha, new A._hsl_closure0());
                return A._colorFromChannels0(B.HslColorSpace_JQ20, t2, t3, t1, t4 == null ? 1 : t4, true, false);
            },
            _angleValue0: function(angleValue, $name) {
                var angle = angleValue.assertNumber$1($name);
                if (angle.compatibleWithUnit$1("deg")) return angle.coerceValueToUnit$1("deg");
                A.warnForDeprecation0("$" + $name + ": Passing a unit other than deg (" + angle.toString$0(0) + string$.x29x20is_d_ + angle.unitSuggestion$1($name) + string$.x0a_See_, B.Deprecation_PHd);
                return angle._number1$_value;
            },
            _checkPercent0: function(number, $name) {
                if (number.hasUnit$1("%")) return;
                A.warnForDeprecation0("$" + $name + ": Passing a number without unit % (" + number.toString$0(0) + string$.x29x20is_d_ + number.unitSuggestion$2($name, "%") + string$.x0a_Morex3af, B.Deprecation_PHd);
            },
            _percentageOrUnitless0: function(number, max, $name) {
                var value;
                if (!number.get$hasUnits()) value = number._number1$_value;
                else if (number.hasUnit$1("%")) value = max * number._number1$_value / 100;
                else throw A.wrapException(A.SassScriptException$0("Expected " + number.toString$0(0) + ' to have unit "%" or no units.', $name));
                return value;
            },
            _mixLegacy0: function(color1, color2, weight) {
                var t2, alphaDistance, weight1, weight2, t3, t4, t5, t6, t7, t8, rgb1 = color1.toSpace$1(B.RgbColorSpace_i0P0), rgb2 = color2.toSpace$1(B.RgbColorSpace_i0P0), weightScale = weight.valueInRange$3(0, 100, "weight") / 100, normalizedWeight = weightScale * 2 - 1, t1 = color1.alphaOrNull;
                if (t1 == null) t1 = 0;
                t2 = color2.alphaOrNull;
                alphaDistance = t1 - (t2 == null ? 0 : t2);
                t1 = normalizedWeight * alphaDistance;
                weight1 = ((t1 === -1 ? normalizedWeight : (normalizedWeight + alphaDistance) / (1 + t1)) + 1) / 2;
                weight2 = 1 - weight1;
                t1 = rgb1.channel0OrNull;
                if (t1 == null) t1 = 0;
                t2 = rgb2.channel0OrNull;
                if (t2 == null) t2 = 0;
                t3 = rgb1.channel1OrNull;
                if (t3 == null) t3 = 0;
                t4 = rgb2.channel1OrNull;
                if (t4 == null) t4 = 0;
                t5 = rgb1.channel2OrNull;
                if (t5 == null) t5 = 0;
                t6 = rgb2.channel2OrNull;
                if (t6 == null) t6 = 0;
                t7 = rgb1.alphaOrNull;
                if (t7 == null) t7 = 0;
                t8 = rgb2.alphaOrNull;
                if (t8 == null) t8 = 0;
                return A.SassColor_SassColor$rgbInternal0(t1 * weight1 + t2 * weight2, t3 * weight1 + t4 * weight2, t5 * weight1 + t6 * weight2, t7 * weightScale + t8 * (1 - weightScale), null);
            },
            _opacify0: function($name, $arguments) {
                var result, t1 = J.getInterceptor$asx($arguments), color = t1.$index($arguments, 0).assertColor$1("color"), amount = t1.$index($arguments, 1).assertNumber$1("amount");
                if (!color._color0$_space.get$isLegacyInternal()) throw A.wrapException(A.SassScriptException$0($name + string$.x28__is_oa, null));
                t1 = color.alphaOrNull;
                if (t1 == null) t1 = 0;
                t1 += amount.valueInRangeWithUnit$4(0, 1, "amount", "");
                result = color.changeAlpha$1(isNaN(t1) ? 0 : B.JSNumber_methods.clamp$2(t1, 0, 1));
                A.warnForDeprecation0($name + "() is deprecated. " + A._suggestScaleAndAdjust0(color, amount._number1$_value, "alpha") + string$.x0a_Morex3ac, B.Deprecation_hJG);
                return result;
            },
            _transparentize0: function($name, $arguments) {
                var result, t1 = J.getInterceptor$asx($arguments), color = t1.$index($arguments, 0).assertColor$1("color"), amount = t1.$index($arguments, 1).assertNumber$1("amount");
                if (!color._color0$_space.get$isLegacyInternal()) throw A.wrapException(A.SassScriptException$0($name + string$.x28__is_oa, null));
                t1 = color.alphaOrNull;
                if (t1 == null) t1 = 0;
                t1 -= amount.valueInRangeWithUnit$4(0, 1, "amount", "");
                result = color.changeAlpha$1(isNaN(t1) ? 0 : B.JSNumber_methods.clamp$2(t1, 0, 1));
                A.warnForDeprecation0($name + "() is deprecated. " + A._suggestScaleAndAdjust0(color, -amount._number1$_value, "alpha") + string$.x0a_Morex3ac, B.Deprecation_hJG);
                return result;
            },
            _colorInSpace0: function(colorUntyped, spaceUntyped, legacyMissing) {
                var t1, _s5_ = "space", color = colorUntyped.assertColor$1("color");
                if (spaceUntyped.$eq(0, B.C__SassNull0)) return color;
                t1 = spaceUntyped.assertString$1(_s5_);
                t1.assertUnquoted$1(_s5_);
                return color.toSpace$2$legacyMissing(A.ColorSpace_fromName0(t1._string0$_text, _s5_), legacyMissing);
            },
            _parseChannels0: function(functionName, input, $name, space) {
                var parsedSlash, components, alphaValue, _2_0, _2_1, _2_5, t1, t2, _2_6, _2_6_isSet, channels, first, rest, componentList, spaceName, i, channel, channelName, t3, t4, _null = null;
                if (input.get$isSpecialVariable()) return A._functionString0(functionName, A._setArrayType([
                    input
                ], type$.JSArray_Value_2));
                parsedSlash = A._parseSlashChannels0(input, $name);
                if (parsedSlash == null) return A._functionString0(functionName, A._setArrayType([
                    input
                ], type$.JSArray_Value_2));
                components = parsedSlash._0;
                alphaValue = parsedSlash._1;
                $label0$0: {
                    _2_0 = components.assertCommonListStyle$2$allowSlash($name, false);
                    _2_1 = _2_0.length;
                    if (_2_1 <= 0) throw A.wrapException(A.SassScriptException$0("Color component list may not be empty.", $name));
                    _2_5 = _2_1 >= 1;
                    t1 = _2_5;
                    t2 = false;
                    if (t1) {
                        _2_6 = _2_0[0];
                        if (_2_6 instanceof A.SassString0) {
                            type$.SassString_2._as(_2_6);
                            t1 = !_2_6._string0$_hasQuotes && _2_6._string0$_text.toLowerCase() === "from";
                        } else t1 = t2;
                        _2_6_isSet = true;
                    } else {
                        t1 = t2;
                        _2_6 = _null;
                        _2_6_isSet = false;
                    }
                    if (t1) return A._functionString0(functionName, A._setArrayType([
                        input
                    ], type$.JSArray_Value_2));
                    t1 = components.get$isSpecialVariable();
                    if (t1) {
                        channels = A._setArrayType([
                            components
                        ], type$.JSArray_Value_2);
                        break $label0$0;
                    }
                    channels = _null;
                    if (_2_5) {
                        first = _2_6_isSet ? _2_6 : _2_0[0];
                        rest = B.JSArray_methods.sublist$1(_2_0, 1);
                        componentList = _2_0;
                        t1 = true;
                    } else {
                        componentList = channels;
                        rest = componentList;
                        first = _null;
                        t1 = false;
                    }
                    if (t1) {
                        if (space == null) {
                            spaceName = first.assertString$1($name);
                            spaceName.assertUnquoted$1($name);
                            space = spaceName.get$isSpecialVariable() ? _null : A.ColorSpace_fromName0(spaceName._string0$_text, $name);
                            if (B.RgbColorSpace_i0P0 === space || B.HslColorSpace_JQ20 === space || B.HwbColorSpace_guQ0 === space || B.LabColorSpace_2nT0 === space || B.LchColorSpace_Bpv0 === space || B.OklabColorSpace_5400 === space || B.OklchColorSpace_9Gj0 === space) throw A.wrapException(A.SassScriptException$0(string$.The_co + A.S(space) + ". Use the " + A.S(space) + "() function instead.", $name));
                            channels = rest;
                        } else channels = componentList;
                        for(i = 0; i < channels.length; ++i){
                            channel = channels[i];
                            t1 = false;
                            if (!channel.get$isSpecialNumber()) {
                                if (!(channel instanceof A.SassNumber0)) t1 = !(channel instanceof A.SassString0 && !channel._string0$_hasQuotes && channel._string0$_text.toLowerCase() === "none");
                            }
                            if (t1) {
                                t1 = _null;
                                if (space == null) channelName = t1;
                                else {
                                    t2 = space._space$_channels;
                                    t2 = i < 3 ? t2[i] : _null;
                                    if (!(t2 == null)) t1 = new A._parseChannels_closure1().call$1(t2.name);
                                    channelName = t1;
                                }
                                if (channelName == null) channelName = "channel " + (i + 1);
                                throw A.wrapException(A.SassScriptException$0("Expected " + channelName + " to be a number, was " + channel.toString$0(0) + ".", $name));
                            }
                        }
                        break $label0$0;
                    }
                    throw A.wrapException("unreachable");
                }
                t1 = alphaValue == null;
                t2 = t1 ? _null : alphaValue.get$isSpecialNumber();
                if (t2 === true) {
                    if (channels.length === 3 && B.Set_9FDyj0.contains$1(0, space)) {
                        t1 = A.List_List$_of(channels, type$.Value_2);
                        alphaValue.toString;
                        t1.push(alphaValue);
                        t1 = A._functionString0(functionName, t1);
                    } else t1 = A._functionString0(functionName, A._setArrayType([
                        input
                    ], type$.JSArray_Value_2));
                    return t1;
                }
                $label1$1: {
                    if (t1) {
                        t2 = 1;
                        break $label1$1;
                    }
                    if (alphaValue instanceof A.SassString0 && !alphaValue._string0$_hasQuotes && "none" === alphaValue._string0$_text) {
                        t2 = _null;
                        break $label1$1;
                    }
                    t2 = A._percentageOrUnitless0(alphaValue.assertNumber$1($name), 1, "alpha");
                    t2 = isNaN(t2) ? 0 : B.JSNumber_methods.clamp$2(t2, 0, 1);
                    break $label1$1;
                }
                if (space == null) return A._functionString0(functionName, A._setArrayType([
                    input
                ], type$.JSArray_Value_2));
                if (B.JSArray_methods.any$1(channels, new A._parseChannels_closure2())) {
                    if (channels.length === 3 && B.Set_9FDyj0.contains$1(0, space)) {
                        t2 = A.List_List$_of(channels, type$.Value_2);
                        if (!t1) t2.push(alphaValue);
                        t1 = A._functionString0(functionName, t2);
                    } else t1 = A._functionString0(functionName, A._setArrayType([
                        input
                    ], type$.JSArray_Value_2));
                    return t1;
                }
                if (channels.length !== 3) throw A.wrapException(A.SassScriptException$0("The " + space.toString$0(0) + " color space has 3 channels but " + input.toString$0(0) + " has " + channels.length + ".", $name));
                t1 = channels[0];
                t1 = t1 instanceof A.SassNumber0 ? t1 : _null;
                t3 = channels[1];
                t3 = t3 instanceof A.SassNumber0 ? t3 : _null;
                t4 = channels[2];
                t4 = t4 instanceof A.SassNumber0 ? t4 : _null;
                return A._colorFromChannels0(space, t1, t3, t4, t2, true, space === B.RgbColorSpace_i0P0);
            },
            _parseSlashChannels0: function(input, $name) {
                var _1_1, alphaValue, t1, components, _1_7, _1_8, _1_9, initial, t2, _1_8_isSet, _1_9_isSet, _0_0, _0_1, channel3, alpha, _1_16, _1_16_isSet, _1_9_isSet0, t3, _null = null, _1_0 = input.assertCommonListStyle$2$allowSlash($name, true);
                $label0$0: {
                    _1_1 = _1_0.length;
                    alphaValue = _null;
                    t1 = false;
                    if (_1_1 === 2) {
                        components = _1_0[0];
                        alphaValue = _1_0[1];
                        t1 = input.get$separator(input) === B.ListSeparator_Lul0;
                    } else components = _null;
                    if (t1) {
                        t1 = new A._Record_2(components, alphaValue);
                        break $label0$0;
                    }
                    t1 = input.get$separator(input);
                    if (t1 === B.ListSeparator_Lul0) {
                        t1 = _1_0.length;
                        A.throwExpression(A.SassScriptException$0(string$.Only_2 + t1 + " " + A.pluralize0("was", t1, "were") + " passed.", $name));
                    }
                    _1_7 = _1_1 >= 1;
                    t1 = _1_7;
                    _1_8 = _null;
                    _1_9 = _null;
                    initial = _null;
                    t2 = false;
                    if (t1) {
                        _1_8 = B.JSArray_methods.sublist$2(_1_0, 0, _1_1 - 1);
                        initial = _1_8;
                        _1_9 = _1_0[_1_1 - 1];
                        t1 = _1_9;
                        if (t1 instanceof A.SassString0) {
                            type$.SassString_2._as(_1_9);
                            t1 = !_1_9._string0$_hasQuotes;
                        } else t1 = t2;
                        _1_8_isSet = true;
                        _1_9_isSet = true;
                    } else {
                        t1 = t2;
                        _1_8_isSet = false;
                        _1_9_isSet = false;
                    }
                    if (t1) {
                        if (_1_9_isSet) t1 = _1_9;
                        else {
                            _1_9 = _1_0[_1_1 - 1];
                            t1 = _1_9;
                        }
                        _0_0 = type$.SassString_2._as(t1)._string0$_text.split("/");
                        $label1$1: {
                            _0_1 = _0_0.length;
                            if (_0_1 === 1) {
                                t1 = new A._Record_2(input, _null);
                                break $label1$1;
                            }
                            if (_0_1 === 2) {
                                channel3 = _0_0[0];
                                alpha = _0_0[1];
                                t1 = A.List_List$_of(initial, type$.Value_2);
                                t1.push(A._parseNumberOrString0(channel3));
                                t1 = new A._Record_2(A.SassList$0(t1, B.ListSeparator_SrV0, false), A._parseNumberOrString0(alpha));
                                break $label1$1;
                            }
                            t1 = _null;
                            break $label1$1;
                        }
                        break $label0$0;
                    }
                    _1_16 = _null;
                    _1_16_isSet = false;
                    t1 = false;
                    if (_1_7) {
                        _1_9_isSet0 = true;
                        if (_1_8_isSet) initial = _1_8;
                        else {
                            _1_8 = B.JSArray_methods.sublist$2(_1_0, 0, _1_1 - 1);
                            initial = _1_8;
                        }
                        if (_1_9_isSet) t2 = _1_9;
                        else {
                            _1_9 = _1_0[_1_1 - 1];
                            t2 = _1_9;
                            _1_9_isSet = _1_9_isSet0;
                        }
                        _1_16_isSet = t2 instanceof A.SassNumber0;
                        if (_1_16_isSet) {
                            if (_1_9_isSet) t1 = _1_9;
                            else {
                                _1_9 = _1_0[_1_1 - 1];
                                t1 = _1_9;
                                _1_9_isSet = _1_9_isSet0;
                            }
                            _1_16 = type$.SassNumber_2._as(t1).asSlash;
                            t1 = _1_16;
                            t1 = type$.Record_2_nullable_Object_and_nullable_Object._is(t1);
                        }
                    } else initial = _null;
                    if (t1) {
                        if (_1_16_isSet) t1 = _1_16;
                        else {
                            if (_1_9_isSet) t1 = _1_9;
                            else {
                                _1_9 = _1_0[_1_1 - 1];
                                t1 = _1_9;
                                _1_9_isSet = true;
                            }
                            _1_16 = type$.SassNumber_2._as(t1).asSlash;
                            t1 = _1_16;
                            _1_16_isSet = true;
                        }
                        if (t1 == null) t1 = type$.Record_2_nullable_Object_and_nullable_Object._as(t1);
                        if (_1_16_isSet) t2 = _1_16;
                        else {
                            if (_1_9_isSet) t2 = _1_9;
                            else {
                                _1_9 = _1_0[_1_1 - 1];
                                t2 = _1_9;
                            }
                            _1_16 = type$.SassNumber_2._as(t2).asSlash;
                            t2 = _1_16;
                        }
                        if (t2 == null) t2 = type$.Record_2_nullable_Object_and_nullable_Object._as(t2);
                        t3 = A.List_List$_of(initial, type$.Value_2);
                        t3.push(t1._0);
                        t1 = new A._Record_2(A.SassList$0(t3, B.ListSeparator_SrV0, false), t2._1);
                        break $label0$0;
                    }
                    t1 = new A._Record_2(input, _null);
                    break $label0$0;
                }
                return t1;
            },
            _parseNumberOrString0: function(text) {
                var t1, expression, _$exception;
                try {
                    t1 = A.ScssParser$0(text, false, null);
                    expression = t1._stylesheet0$_parseSingleProduction$1$1(t1.get$_stylesheet0$_number(), type$.NumberExpression_2);
                    t1 = A.SassNumber_SassNumber0(expression.value, expression.unit);
                    return t1;
                } catch (exception) {
                    if (type$.SassFormatException_2._is(A.unwrapException(exception))) return new A.SassString0(text, false);
                    else throw exception;
                }
            },
            _colorFromChannels0: function(space, channel0, channel1, channel2, alpha, clamp, fromRgbFunction) {
                var t1, t2, whiteness, blackness, t3;
                switch(space){
                    case B.HslColorSpace_JQ20:
                        if (channel1 != null) A._checkPercent0(channel1, "saturation");
                        if (channel2 != null) A._checkPercent0(channel2, "lightness");
                        t1 = space._space$_channels;
                        return A.SassColor_SassColor$hsl0(A.NullableExtension_andThen0(channel0, new A._colorFromChannels_closure1()), A._channelFromValue0(t1[1], A._forcePercent0(channel1), clamp), A._channelFromValue0(t1[2], A._forcePercent0(channel2), clamp), alpha);
                    case B.HwbColorSpace_guQ0:
                        t1 = channel1 == null;
                        if (!t1) channel1.assertUnit$2("%", "whiteness");
                        t2 = channel2 == null;
                        if (!t2) channel2.assertUnit$2("%", "blackness");
                        whiteness = t1 ? null : channel1._number1$_value;
                        blackness = t2 ? null : channel2._number1$_value;
                        if (whiteness != null && blackness != null && whiteness + blackness > 100) {
                            t1 = whiteness + blackness;
                            whiteness = whiteness / t1 * 100;
                            blackness = blackness / t1 * 100;
                        }
                        return A.SassColor_SassColor$hwb0(A.NullableExtension_andThen0(channel0, new A._colorFromChannels_closure2()), whiteness, blackness, alpha);
                    case B.RgbColorSpace_i0P0:
                        t1 = space._space$_channels;
                        t2 = A._channelFromValue0(t1[0], channel0, clamp);
                        t3 = A._channelFromValue0(t1[1], channel1, clamp);
                        t1 = A._channelFromValue0(t1[2], channel2, clamp);
                        return A.SassColor_SassColor$rgbInternal0(t2, t3, t1, alpha, fromRgbFunction ? B.C__ColorFormatEnum0 : null);
                    default:
                        t1 = space._space$_channels;
                        return A.SassColor_SassColor$forSpaceInternal0(space, A._channelFromValue0(t1[0], channel0, clamp), A._channelFromValue0(t1[1], channel1, clamp), A._channelFromValue0(t1[2], channel2, clamp), alpha);
                }
            },
            _forcePercent0: function(number) {
                var t1, _0_3;
                $label0$0: {
                    if (number == null) {
                        t1 = null;
                        break $label0$0;
                    }
                    _0_3 = number.get$numeratorUnits(number);
                    if (_0_3.length === 1) t1 = "%" === _0_3[0] && number.get$denominatorUnits(number).length <= 0;
                    else t1 = false;
                    if (t1) {
                        t1 = number;
                        break $label0$0;
                    }
                    t1 = A.SassNumber_SassNumber0(number._number1$_value, "%");
                    break $label0$0;
                }
                return t1;
            },
            _channelFromValue0: function(channel, value, clamp) {
                return A.NullableExtension_andThen0(value, new A._channelFromValue_closure0(channel, clamp));
            },
            _isNone0: function(value) {
                return value instanceof A.SassString0 && !value._string0$_hasQuotes && value._string0$_text.toLowerCase() === "none";
            },
            _channelFunction0: function($name, space, getter, global, unit) {
                return A.BuiltInCallable$function0($name, "$color", new A._channelFunction_closure0(getter, unit, global, $name, space), "sass:color");
            },
            _suggestScaleAndAdjust0: function(original, adjustment, channelName) {
                var t2, oldValue, newValue, factor, t3, suggestion, channel = channelName === "alpha" ? B.LinearChannel_XL80 : type$.LinearChannel_2._as(B.JSArray_methods.firstWhere$1(B.List_oAL0, new A._suggestScaleAndAdjust_closure0(channelName))), t1 = channel === B.LinearChannel_XL80;
                if (t1) {
                    t2 = original.alphaOrNull;
                    oldValue = t2 == null ? 0 : t2;
                } else oldValue = original.toSpace$1(B.HslColorSpace_JQ20).channel$1(0, channelName);
                newValue = oldValue + adjustment;
                if (adjustment !== 0) {
                    factor = A._Cell$();
                    t2 = channel.max;
                    if (newValue > t2) factor.__late_helper$_value = 1;
                    else {
                        t3 = channel.min;
                        if (newValue < t3) factor.__late_helper$_value = -1;
                        else if (adjustment > 0) factor.__late_helper$_value = adjustment / (t2 - oldValue);
                        else factor.__late_helper$_value = (newValue - oldValue) / (oldValue - t3);
                    }
                    suggestion = "Suggestion" + ("s:\n\ncolor.scale($color, $" + channelName + ": " + A.serializeValue0(A.SassNumber_SassNumber0(factor._readLocal$0() * 100, "%"), false, true) + ")\n");
                } else suggestion = "Suggestion:\n\n";
                return suggestion + ("color.adjust($color, $" + channelName + ": " + A.serializeValue0(A.SassNumber_SassNumber0(adjustment, t1 ? null : "%"), false, true) + ")");
            },
            _missingChannelError0: function(color, channel) {
                return A.throwExpression(A.SassScriptException$0(string$.Becaus + color.toCssString$0() + ").", channel));
            },
            _channelName0: function(value) {
                var t1 = value.assertString$1("channel");
                t1.assertQuoted$1("channel");
                return t1._string0$_text;
            },
            _function12: function($name, $arguments, callback) {
                return A.BuiltInCallable$function0($name, $arguments, callback, "sass:color");
            },
            global_closure44: function global_closure44() {},
            global_closure45: function global_closure45() {},
            global_closure46: function global_closure46() {},
            global_closure47: function global_closure47() {},
            global_closure48: function global_closure48() {},
            global_closure49: function global_closure49() {},
            global_closure50: function global_closure50() {},
            global_closure51: function global_closure51() {},
            global_closure52: function global_closure52() {},
            global_closure53: function global_closure53() {},
            global_closure54: function global_closure54() {},
            global_closure55: function global_closure55() {},
            global_closure56: function global_closure56() {},
            global_closure57: function global_closure57() {},
            global_closure58: function global_closure58() {},
            global_closure59: function global_closure59() {},
            global_closure60: function global_closure60() {},
            global_closure61: function global_closure61() {},
            global_closure62: function global_closure62() {},
            global_closure63: function global_closure63() {},
            global_closure64: function global_closure64() {},
            global_closure65: function global_closure65() {},
            global_closure66: function global_closure66() {},
            global_closure67: function global_closure67() {},
            global_closure68: function global_closure68() {},
            global_closure69: function global_closure69() {},
            global_closure70: function global_closure70() {},
            global_closure71: function global_closure71() {},
            global_closure72: function global_closure72() {},
            global_closure73: function global_closure73() {},
            global_closure74: function global_closure74() {},
            global_closure75: function global_closure75() {},
            global_closure76: function global_closure76() {},
            global_closure77: function global_closure77() {},
            global_closure78: function global_closure78() {},
            global_closure79: function global_closure79() {},
            global__closure0: function global__closure0() {},
            global_closure80: function global_closure80() {},
            global_closure81: function global_closure81() {},
            global_closure82: function global_closure82() {},
            global_closure83: function global_closure83() {},
            global_closure84: function global_closure84() {},
            global_closure85: function global_closure85() {},
            global_closure86: function global_closure86() {},
            module_closure27: function module_closure27() {},
            module_closure28: function module_closure28() {},
            module_closure29: function module_closure29() {},
            module_closure30: function module_closure30() {},
            module_closure31: function module_closure31() {},
            module_closure32: function module_closure32() {},
            module_closure33: function module_closure33() {},
            module_closure34: function module_closure34() {},
            module_closure35: function module_closure35() {},
            module_closure36: function module_closure36() {},
            module_closure37: function module_closure37() {},
            module_closure38: function module_closure38() {},
            module_closure39: function module_closure39() {},
            module_closure40: function module_closure40() {},
            module__closure6: function module__closure6() {},
            module_closure41: function module_closure41() {},
            module_closure42: function module_closure42() {},
            module_closure43: function module_closure43() {},
            module_closure44: function module_closure44() {},
            module_closure45: function module_closure45() {},
            module_closure46: function module_closure46() {},
            module_closure47: function module_closure47() {},
            module_closure48: function module_closure48() {},
            module__closure5: function module__closure5(t0) {
                this.channelName = t0;
            },
            module_closure49: function module_closure49() {},
            module_closure_toXyzNoMissing0: function module_closure_toXyzNoMissing0() {},
            module_closure50: function module_closure50() {},
            _mix_closure0: function _mix_closure0() {},
            _complement_closure0: function _complement_closure0() {},
            _adjust_closure0: function _adjust_closure0() {},
            _scale_closure0: function _scale_closure0() {},
            _change_closure0: function _change_closure0() {},
            _ieHexStr_closure0: function _ieHexStr_closure0() {},
            _ieHexStr_closure_hexString0: function _ieHexStr_closure_hexString0() {},
            _updateComponents_closure1: function _updateComponents_closure1(t0) {
                this.originalColor = t0;
            },
            _updateComponents_closure2: function _updateComponents_closure2(t0) {
                this._box_0 = t0;
            },
            _changeColor_closure0: function _changeColor_closure0(t0) {
                this.alphaArg = t0;
            },
            _adjustColor_closure0: function _adjustColor_closure0() {},
            _functionString_closure0: function _functionString_closure0() {},
            _removedColorFunction_closure0: function _removedColorFunction_closure0(t0, t1, t2) {
                this.name = t0;
                this.argument = t1;
                this.negative = t2;
            },
            _rgb_closure0: function _rgb_closure0() {},
            _hsl_closure0: function _hsl_closure0() {},
            _parseChannels_closure1: function _parseChannels_closure1() {},
            _parseChannels_closure2: function _parseChannels_closure2() {},
            _colorFromChannels_closure1: function _colorFromChannels_closure1() {},
            _colorFromChannels_closure2: function _colorFromChannels_closure2() {},
            _channelFromValue_closure0: function _channelFromValue_closure0(t0, t1) {
                this.channel = t0;
                this.clamp = t1;
            },
            _channelFunction_closure0: function _channelFunction_closure0(t0, t1, t2, t3, t4) {
                var _ = this;
                _.getter = t0;
                _.unit = t1;
                _.global = t2;
                _.name = t3;
                _.space = t4;
            },
            _suggestScaleAndAdjust_closure0: function _suggestScaleAndAdjust_closure0(t0) {
                this.channelName = t0;
            },
            _constructionSpace: function(options) {
                var t1 = J.getInterceptor$x(options);
                if (t1.get$space(options) != null) {
                    t1 = t1.get$space(options);
                    t1.toString;
                    return A.ColorSpace_fromName0(t1, null);
                }
                if (t1.get$red(options) != null) return B.RgbColorSpace_i0P0;
                if (t1.get$saturation(options) != null) return B.HslColorSpace_JQ20;
                if (t1.get$whiteness(options) != null) return B.HwbColorSpace_guQ0;
                throw A.wrapException("No color space found");
            },
            _toSpace: function($self, space) {
                return $self.toSpace$1(A.ColorSpace_fromName0(space == null ? $self._color0$_space.name : space, null));
            },
            _checkNullAlphaDeprecation: function(options) {
                var t1 = J.getInterceptor$x(options), t2 = t1.get$alpha(options);
                if (!A._asBool($.$get$_isUndefined().call$1(t2)) && t1.get$alpha(options) == null && t1.get$space(options) == null) A.warnForDeprecationFromApi(string$.Passin_, B.Deprecation_ox0);
            },
            colorClass_closure: function colorClass_closure() {},
            colorClass__closure: function colorClass__closure() {},
            colorClass__closure0: function colorClass__closure0() {},
            colorClass__closure1: function colorClass__closure1() {},
            colorClass__closure2: function colorClass__closure2() {},
            colorClass__closure3: function colorClass__closure3() {},
            colorClass__closure4: function colorClass__closure4() {},
            colorClass__closure5: function colorClass__closure5() {},
            colorClass__closure6: function colorClass__closure6() {},
            colorClass__closure7: function colorClass__closure7() {},
            colorClass__closure8: function colorClass__closure8() {},
            colorClass___closure: function colorClass___closure(t0) {
                this.key = t0;
            },
            colorClass__closure_changedValue: function colorClass__closure_changedValue(t0, t1) {
                this.color = t0;
                this.options = t1;
            },
            colorClass__closure9: function colorClass__closure9() {},
            colorClass__closure10: function colorClass__closure10() {},
            colorClass__closure11: function colorClass__closure11() {},
            colorClass__closure12: function colorClass__closure12() {},
            colorClass__closure13: function colorClass__closure13() {},
            colorClass__closure14: function colorClass__closure14() {},
            colorClass__closure15: function colorClass__closure15() {},
            colorClass__closure16: function colorClass__closure16() {},
            colorClass__closure17: function colorClass__closure17() {},
            colorClass__closure18: function colorClass__closure18() {},
            colorClass__closure19: function colorClass__closure19() {},
            colorClass__closure20: function colorClass__closure20() {},
            colorClass__closure21: function colorClass__closure21() {},
            colorClass__closure22: function colorClass__closure22() {},
            _Channels: function _Channels() {},
            _ConstructionOptions: function _ConstructionOptions() {},
            _ChannelOptions: function _ChannelOptions() {},
            _ToGamutOptions: function _ToGamutOptions() {},
            _InterpolationOptions: function _InterpolationOptions() {},
            _NodeSassColor: function _NodeSassColor() {},
            legacyColorClass_closure: function legacyColorClass_closure() {},
            legacyColorClass__closure: function legacyColorClass__closure() {},
            legacyColorClass_closure0: function legacyColorClass_closure0() {},
            legacyColorClass_closure1: function legacyColorClass_closure1() {},
            legacyColorClass_closure2: function legacyColorClass_closure2() {},
            legacyColorClass_closure3: function legacyColorClass_closure3() {},
            legacyColorClass_closure4: function legacyColorClass_closure4() {},
            legacyColorClass_closure5: function legacyColorClass_closure5() {},
            legacyColorClass_closure6: function legacyColorClass_closure6() {},
            legacyColorClass_closure7: function legacyColorClass_closure7() {},
            SassColor_SassColor$rgb0: function(red, green, blue, alpha) {
                return A.SassColor_SassColor$rgbInternal0(red, green, blue, alpha, null);
            },
            SassColor_SassColor$rgbInternal0: function(red, green, blue, alpha, format) {
                var _null = null, t1 = red == null ? _null : red, t2 = green == null ? _null : green, t3 = blue == null ? _null : blue;
                return A.SassColor$_forSpace0(B.RgbColorSpace_i0P0, t1, t2, t3, alpha == null ? _null : alpha, format);
            },
            SassColor_SassColor$hsl0: function(hue, saturation, lightness, alpha) {
                var _null = null, t1 = hue == null ? _null : hue, t2 = saturation == null ? _null : saturation, t3 = lightness == null ? _null : lightness;
                return A.SassColor_SassColor$forSpaceInternal0(B.HslColorSpace_JQ20, t1, t2, t3, alpha == null ? _null : alpha);
            },
            SassColor_SassColor$hwb0: function(hue, whiteness, blackness, alpha) {
                var _null = null, t1 = hue == null ? _null : hue, t2 = whiteness == null ? _null : whiteness, t3 = blackness == null ? _null : blackness;
                return A.SassColor_SassColor$forSpaceInternal0(B.HwbColorSpace_guQ0, t1, t2, t3, alpha == null ? _null : alpha);
            },
            SassColor_SassColor$forSpaceInternal0: function(space, channel0, channel1, channel2, alpha) {
                var t1, t2, _null = null;
                $label0$0: {
                    if (B.HslColorSpace_JQ20 === space) {
                        t1 = channel1 == null;
                        t2 = A.SassColor__normalizeHue0(channel0, !t1 && channel1 < 0 && !A.fuzzyEquals0(channel1, 0));
                        t2 = A.SassColor$_forSpace0(space, t2, t1 ? _null : Math.abs(channel1), channel2, alpha, _null);
                        t1 = t2;
                        break $label0$0;
                    }
                    if (B.HwbColorSpace_guQ0 === space) {
                        t1 = A.SassColor$_forSpace0(space, A.SassColor__normalizeHue0(channel0, false), channel1, channel2, alpha, _null);
                        break $label0$0;
                    }
                    if (B.LchColorSpace_Bpv0 === space || B.OklchColorSpace_9Gj0 === space) {
                        t1 = channel1 == null;
                        t2 = t1 ? _null : Math.abs(channel1);
                        t2 = A.SassColor$_forSpace0(space, channel0, t2, A.SassColor__normalizeHue0(channel2, !t1 && channel1 < 0 && !A.fuzzyEquals0(channel1, 0)), alpha, _null);
                        t1 = t2;
                        break $label0$0;
                    }
                    t1 = A.SassColor$_forSpace0(space, channel0, channel1, channel2, alpha, _null);
                    break $label0$0;
                }
                return t1;
            },
            SassColor$_forSpace0: function(_space, channel0OrNull, channel1OrNull, channel2OrNull, alpha, format) {
                return new A.SassColor0(_space, channel0OrNull, channel1OrNull, channel2OrNull, format, A.NullableExtension_andThen0(alpha, new A.SassColor$_forSpace_closure0()));
            },
            SassColor__normalizeHue0: function(hue, invert) {
                var t1, t2;
                if (hue == null) return hue;
                t1 = B.JSNumber_methods.$mod(hue, 360);
                t2 = invert ? 180 : 0;
                return B.JSNumber_methods.$mod(t1 + 360 + t2, 360);
            },
            SassColor0: function SassColor0(t0, t1, t2, t3, t4, t5) {
                var _ = this;
                _._color0$_space = t0;
                _.channel0OrNull = t1;
                _.channel1OrNull = t2;
                _.channel2OrNull = t3;
                _.format = t4;
                _.alphaOrNull = t5;
            },
            SassColor$_forSpace_closure0: function SassColor$_forSpace_closure0() {},
            _ColorFormatEnum0: function _ColorFormatEnum0() {},
            SpanColorFormat0: function SpanColorFormat0(t0) {
                this._color0$_span = t0;
            },
            Combinator0: function Combinator0(t0, t1, t2) {
                this._combinator0$_text = t0;
                this.index = t1;
                this._name = t2;
            },
            ModifiableCssComment0: function ModifiableCssComment0(t0, t1) {
                var _ = this;
                _.text = t0;
                _.span = t1;
                _._node$_indexInParent = _._node$_parent = null;
                _.isGroupEnd = false;
            },
            compile0: function(path, options) {
                var color, ascii, logger, result, error, stackTrace, t1, color0, ascii0, t2, t3, t4, t5, t6, t7, t8, t9, t10, t11, t12, _$exception, _null = null;
                if (!A.isNodeJs()) A.jsThrow(new self.Error("The compile() method is only available in Node.js."));
                t1 = options == null;
                color0 = t1 ? _null : J.get$alertColor$x(options);
                if (color0 == null) color0 = A.hasTerminal0() || A.isBrowser();
                color = color0;
                ascii0 = t1 ? _null : J.get$alertAscii$x(options);
                ascii = ascii0 == null ? $._glyphs === B.C_AsciiGlyphSet : ascii0;
                t2 = t1 ? _null : J.get$logger$x(options);
                t3 = ascii;
                if (t3 == null) t3 = $._glyphs === B.C_AsciiGlyphSet;
                logger = new A.JSToDartLogger(t2, new A.StderrLogger0(color), t3);
                try {
                    t2 = t1 ? _null : J.get$loadPaths$x(options);
                    t3 = t1 ? _null : J.get$quietDeps$x(options);
                    if (t3 == null) t3 = false;
                    t4 = A._parseOutputStyle0(t1 ? _null : J.get$style$x(options));
                    t5 = t1 ? _null : J.get$verbose$x(options);
                    if (t5 == null) t5 = false;
                    t6 = t1 ? _null : J.get$charset$x(options);
                    if (t6 == null) t6 = true;
                    t7 = t1 ? _null : J.get$sourceMap$x(options);
                    if (t7 == null) t7 = false;
                    if (t1) t8 = _null;
                    else {
                        t8 = J.get$importers$x(options);
                        t8 = t8 == null ? _null : J.map$1$1$ax(t8, A.compile___parseImporter$closure(), type$.Importer);
                    }
                    t9 = A._parseFunctions0(t1 ? _null : J.get$functions$x(options), false);
                    t10 = t1 ? _null : J.get$fatalDeprecations$x(options);
                    t10 = A.parseDeprecations(logger, t10, true);
                    t11 = t1 ? _null : J.get$silenceDeprecations$x(options);
                    t11 = A.parseDeprecations(logger, t11, false);
                    t12 = t1 ? _null : J.get$futureDeprecations$x(options);
                    result = A.compile(path, t6, t10, new A.CastList(t9, A._arrayInstanceType(t9)._eval$1("CastList<1,Callable>")), A.parseDeprecations(logger, t12, false), A.ImportCache$0(t8, t2, _null), _null, _null, logger, _null, t3, t11, t7, t4, _null, true, t5);
                    t1 = t1 ? _null : J.get$sourceMapIncludeSources$x(options);
                    if (t1 == null) t1 = false;
                    t1 = A._convertResult(result, t1);
                    return t1;
                } catch (exception) {
                    t1 = A.unwrapException(exception);
                    if (t1 instanceof A.SassException0) {
                        error = t1;
                        stackTrace = A.getTraceFromException(exception);
                        A.throwNodeException(error, ascii, color, stackTrace);
                    } else throw exception;
                }
            },
            compileString0: function(text, options) {
                var color, ascii, logger, result, error, stackTrace, ascii0, t2, t3, t4, t5, t6, t7, t8, t9, t10, t11, t12, t13, t14, t15, _$exception, _null = null, t1 = options == null, color0 = t1 ? _null : J.get$alertColor$x(options);
                if (color0 == null) color0 = A.hasTerminal0() || A.isBrowser();
                color = color0;
                ascii0 = t1 ? _null : J.get$alertAscii$x(options);
                ascii = ascii0 == null ? $._glyphs === B.C_AsciiGlyphSet : ascii0;
                t2 = t1 ? _null : J.get$logger$x(options);
                t3 = ascii;
                if (t3 == null) t3 = $._glyphs === B.C_AsciiGlyphSet;
                logger = new A.JSToDartLogger(t2, new A.StderrLogger0(color), t3);
                try {
                    t2 = A.parseSyntax(t1 ? _null : J.get$syntax$x(options));
                    t3 = t1 ? _null : A.NullableExtension_andThen0(J.get$url$x(options), A.utils3__jsToDartUrl$closure());
                    t4 = t1 ? _null : J.get$loadPaths$x(options);
                    t5 = t1 ? _null : J.get$quietDeps$x(options);
                    if (t5 == null) t5 = false;
                    t6 = A._parseOutputStyle0(t1 ? _null : J.get$style$x(options));
                    t7 = t1 ? _null : J.get$verbose$x(options);
                    if (t7 == null) t7 = false;
                    t8 = t1 ? _null : J.get$charset$x(options);
                    if (t8 == null) t8 = true;
                    t9 = t1 ? _null : J.get$sourceMap$x(options);
                    if (t9 == null) t9 = false;
                    if (t1) t10 = _null;
                    else {
                        t10 = J.get$importers$x(options);
                        t10 = t10 == null ? _null : J.map$1$1$ax(t10, A.compile___parseImporter$closure(), type$.Importer);
                    }
                    t11 = t1 ? _null : A.NullableExtension_andThen0(J.get$importer$x(options), A.compile___parseImporter$closure());
                    if (t11 == null) t11 = (t1 ? _null : J.get$url$x(options)) == null ? new A.NoOpImporter0() : _null;
                    t12 = A._parseFunctions0(t1 ? _null : J.get$functions$x(options), false);
                    t13 = t1 ? _null : J.get$fatalDeprecations$x(options);
                    t13 = A.parseDeprecations(logger, t13, true);
                    t14 = t1 ? _null : J.get$silenceDeprecations$x(options);
                    t14 = A.parseDeprecations(logger, t14, false);
                    t15 = t1 ? _null : J.get$futureDeprecations$x(options);
                    result = A.compileString(text, t8, t13, new A.CastList(t12, A._arrayInstanceType(t12)._eval$1("CastList<1,Callable>")), A.parseDeprecations(logger, t15, false), A.ImportCache$0(t10, t4, _null), t11, _null, _null, logger, _null, t5, t14, t9, t6, t2, t3, true, t7);
                    t1 = t1 ? _null : J.get$sourceMapIncludeSources$x(options);
                    if (t1 == null) t1 = false;
                    t1 = A._convertResult(result, t1);
                    return t1;
                } catch (exception) {
                    t1 = A.unwrapException(exception);
                    if (t1 instanceof A.SassException0) {
                        error = t1;
                        stackTrace = A.getTraceFromException(exception);
                        A.throwNodeException(error, ascii, color, stackTrace);
                    } else throw exception;
                }
            },
            compileAsync1: function(path, options) {
                var t1, color, ascii;
                if (!A.isNodeJs()) A.jsThrow(new self.Error("The compileAsync() method is only available in Node.js."));
                t1 = options == null;
                color = t1 ? null : J.get$alertColor$x(options);
                if (color == null) color = A.hasTerminal0() || A.isBrowser();
                ascii = t1 ? null : J.get$alertAscii$x(options);
                if (ascii == null) ascii = $._glyphs === B.C_AsciiGlyphSet;
                t1 = t1 ? null : J.get$logger$x(options);
                return A._wrapAsyncSassExceptions(A.futureToPromise0(new A.compileAsync_closure(path, color, options, new A.JSToDartLogger(t1, new A.StderrLogger0(color), ascii)).call$0()), ascii, color);
            },
            compileStringAsync1: function(text, options) {
                var ascii, t1 = options == null, color = t1 ? null : J.get$alertColor$x(options);
                if (color == null) color = A.hasTerminal0() || A.isBrowser();
                ascii = t1 ? null : J.get$alertAscii$x(options);
                if (ascii == null) ascii = $._glyphs === B.C_AsciiGlyphSet;
                t1 = t1 ? null : J.get$logger$x(options);
                return A._wrapAsyncSassExceptions(A.futureToPromise0(new A.compileStringAsync_closure(text, options, color, new A.JSToDartLogger(t1, new A.StderrLogger0(color), ascii)).call$0()), ascii, color);
            },
            _convertResult: function(result, includeSourceContents) {
                var loadedUrls, t1 = result._compile_result$_serialize, t2 = t1._1, sourceMap = t2 == null ? null : t2.toJson$1$includeSourceContents(includeSourceContents);
                if (type$.Map_dynamic_dynamic._is(sourceMap) && !sourceMap.containsKey$1("sources")) sourceMap.$indexSet(0, "sources", A._setArrayType([], type$.JSArray_String));
                loadedUrls = A.toJSArray(result._evaluate._0.map$1$1(0, A.utils3__dartToJSUrl$closure(), type$.nullable_Object));
                t1 = t1._0;
                return sourceMap == null ? {
                    css: t1,
                    loadedUrls: loadedUrls
                } : {
                    css: t1,
                    sourceMap: A.jsify0(sourceMap),
                    loadedUrls: loadedUrls
                };
            },
            _wrapAsyncSassExceptions: function(promise, ascii, color) {
                return J.then$2$x(promise, null, A.allowInterop(new A._wrapAsyncSassExceptions_closure(color, ascii)));
            },
            _parseOutputStyle0: function(style) {
                var t1;
                $label0$0: {
                    if (style == null || "expanded" === style) {
                        t1 = B.OutputStyle_00;
                        break $label0$0;
                    }
                    if ("compressed" === style) {
                        t1 = B.OutputStyle_10;
                        break $label0$0;
                    }
                    t1 = A.jsThrow(new self.Error('Unknown output style "' + style + '".'));
                }
                return t1;
            },
            _parseAsyncImporter: function(importer) {
                var t1, canonicalize, load1, _0_0;
                if (importer instanceof A.NodePackageImporter0) return importer;
                if (importer == null) A.jsThrow(new self.Error("Importers may not be null."));
                type$.JSImporter._as(importer);
                t1 = J.getInterceptor$x(importer);
                canonicalize = t1.get$canonicalize(importer);
                load1 = t1.get$load(importer);
                _0_0 = t1.get$findFileUrl(importer);
                if (_0_0 != null) {
                    if (canonicalize != null || load1 != null) A.jsThrow(new self.Error(string$.An_impa));
                    else return new A.JSToDartAsyncFileImporter(_0_0);
                } else if (canonicalize == null || load1 == null) A.jsThrow(new self.Error(string$.An_impu));
                else {
                    t1 = A._normalizeNonCanonicalSchemes(t1.get$nonCanonicalScheme(importer));
                    t1 = t1 == null ? B.Set_empty1 : A.Set_Set$unmodifiable(t1, type$.String);
                    t1.forEach$1(0, A.utils4__validateUrlScheme$closure());
                    return new A.JSToDartAsyncImporter(canonicalize, load1, t1);
                }
            },
            _parseImporter0: function(importer) {
                var t1, canonicalize, load1, _0_0;
                if (importer instanceof A.NodePackageImporter0) return importer;
                if (importer == null) A.jsThrow(new self.Error("Importers may not be null."));
                type$.JSImporter._as(importer);
                t1 = J.getInterceptor$x(importer);
                canonicalize = t1.get$canonicalize(importer);
                load1 = t1.get$load(importer);
                _0_0 = t1.get$findFileUrl(importer);
                if (_0_0 != null) {
                    if (canonicalize != null || load1 != null) A.jsThrow(new self.Error(string$.An_impa));
                    else return new A.JSToDartFileImporter(_0_0);
                } else if (canonicalize == null || load1 == null) A.jsThrow(new self.Error(string$.An_impu));
                else {
                    t1 = A._normalizeNonCanonicalSchemes(t1.get$nonCanonicalScheme(importer));
                    t1 = t1 == null ? B.Set_empty1 : A.Set_Set$unmodifiable(t1, type$.String);
                    t1.forEach$1(0, A.utils4__validateUrlScheme$closure());
                    return new A.JSToDartImporter(canonicalize, load1, t1);
                }
            },
            _normalizeNonCanonicalSchemes: function(schemes) {
                var t1;
                $label0$0: {
                    if (typeof schemes == "string") {
                        t1 = A._setArrayType([
                            schemes
                        ], type$.JSArray_String);
                        break $label0$0;
                    }
                    if (type$.List_dynamic._is(schemes)) {
                        t1 = J.cast$1$0$ax(schemes, type$.String);
                        break $label0$0;
                    }
                    if (schemes == null) {
                        t1 = null;
                        break $label0$0;
                    }
                    t1 = A.jsThrow(new self.Error('nonCanonicalScheme must be a string or list of strings, was "' + A.S(schemes) + '"'));
                }
                return t1;
            },
            _simplifyValue: function(value) {
                var _0_1, t1, t2, _0_4, _0_3, _0_7, _0_5, _0_40, _0_8, _0_8_isSet, _0_7_isSet, _0_5_isSet, _0_4_isSet, first, _0_10, min, _null = null;
                $label1$1: {
                    if (value instanceof A.SassCalculation0) {
                        _0_1 = value.name;
                        t1 = value.$arguments;
                        t2 = A._arrayInstanceType(t1)._eval$1("MappedListIterable<1,Object>");
                        _0_4 = A.List_List$_of(new A.MappedListIterable(t1, A.compile___simplifyCalcArg$closure(), t2), t2._eval$1("ListIterable.E"));
                        $label0$0: {
                            _0_3 = "calc" === _0_1;
                            t1 = _0_3;
                            _0_7 = _null;
                            _0_5 = _null;
                            _0_40 = _null;
                            _0_8 = _null;
                            _0_8_isSet = false;
                            t2 = false;
                            if (t1) {
                                _0_5 = _0_4.length;
                                t1 = _0_5;
                                _0_7 = t1 === 1;
                                t1 = _0_7;
                                _0_40 = _0_4;
                                if (t1) {
                                    _0_8 = _0_40[0];
                                    t1 = _0_8;
                                    t1 = t1 instanceof A.Value0;
                                    _0_8_isSet = true;
                                } else t1 = t2;
                                _0_7_isSet = true;
                                _0_5_isSet = true;
                                _0_4_isSet = true;
                            } else {
                                t1 = t2;
                                _0_7_isSet = false;
                                _0_5_isSet = false;
                                _0_4_isSet = false;
                            }
                            if (t1) {
                                if (_0_8_isSet) t1 = _0_8;
                                else {
                                    _0_8 = (_0_4_isSet ? _0_40 : _0_4)[0];
                                    t1 = _0_8;
                                }
                                type$.Value_2._as(t1);
                                break $label0$0;
                            }
                            if (_0_3) {
                                if (_0_7_isSet) t1 = _0_7;
                                else {
                                    if (_0_5_isSet) t1 = _0_5;
                                    else {
                                        if (_0_4_isSet) t1 = _0_40;
                                        else {
                                            t1 = _0_4;
                                            _0_40 = t1;
                                            _0_4_isSet = true;
                                        }
                                        _0_5 = t1.length;
                                        t1 = _0_5;
                                        _0_5_isSet = true;
                                    }
                                    _0_7 = t1 === 1;
                                    t1 = _0_7;
                                }
                            } else t1 = false;
                            if (t1) {
                                if (_0_8_isSet) first = _0_8;
                                else {
                                    _0_8 = (_0_4_isSet ? _0_40 : _0_4)[0];
                                    first = _0_8;
                                }
                                t1 = A.SassCalculation_calc0(first);
                                break $label0$0;
                            }
                            if (_0_3) A.throwExpression(A.ArgumentError$("calc() requires exactly one argument.", _null));
                            _0_10 = "clamp" === _0_1;
                            t1 = _0_10;
                            if (t1) {
                                if (_0_5_isSet) t1 = _0_5;
                                else {
                                    if (_0_4_isSet) t1 = _0_40;
                                    else {
                                        t1 = _0_4;
                                        _0_40 = t1;
                                        _0_4_isSet = true;
                                    }
                                    _0_5 = t1.length;
                                    t1 = _0_5;
                                }
                                t1 = t1 === 3;
                            } else t1 = false;
                            if (t1) {
                                if (_0_8_isSet) min = _0_8;
                                else {
                                    if (_0_4_isSet) t1 = _0_40;
                                    else {
                                        t1 = _0_4;
                                        _0_40 = t1;
                                        _0_4_isSet = true;
                                    }
                                    _0_8 = t1[0];
                                    min = _0_8;
                                }
                                if (_0_4_isSet) t1 = _0_40;
                                else {
                                    t1 = _0_4;
                                    _0_40 = t1;
                                    _0_4_isSet = true;
                                }
                                value = t1[1];
                                t1 = A.SassCalculation_clamp0(min, value, (_0_4_isSet ? _0_40 : _0_4)[2]);
                                break $label0$0;
                            }
                            if (_0_10) A.throwExpression(A.ArgumentError$("clamp() requires exactly 3 arguments.", _null));
                            if ("min" === _0_1) {
                                t1 = A.SassCalculation_min0(_0_4_isSet ? _0_40 : _0_4);
                                break $label0$0;
                            }
                            if ("max" === _0_1) {
                                t1 = A.SassCalculation_max0(_0_4_isSet ? _0_40 : _0_4);
                                break $label0$0;
                            }
                            t1 = A.throwExpression(A.ArgumentError$('"' + _0_1 + '" is not a recognized calculation type.', _null));
                        }
                        break $label1$1;
                    }
                    t1 = value;
                    break $label1$1;
                }
                return t1;
            },
            _simplifyCalcArg: function(value) {
                var t1;
                $label0$0: {
                    if (value instanceof A.SassCalculation0) {
                        t1 = A._simplifyValue(value);
                        break $label0$0;
                    }
                    if (value instanceof A.CalculationOperation0) {
                        t1 = A.SassCalculation_operateInternal0(value._calculation0$_operator, A._simplifyCalcArg(value._calculation0$_left), A._simplifyCalcArg(value._calculation0$_right), null, true, null);
                        break $label0$0;
                    }
                    t1 = value;
                    break $label0$0;
                }
                return t1;
            },
            _parseFunctions0: function(functions, asynch) {
                var result;
                if (functions == null) return B.List_empty29;
                result = A._setArrayType([], type$.JSArray_AsyncCallable_2);
                A.jsForEach(functions, new A._parseFunctions_closure0(asynch, result));
                return result;
            },
            compileAsync_closure: function compileAsync_closure(t0, t1, t2, t3) {
                var _ = this;
                _.path = t0;
                _.color = t1;
                _.options = t2;
                _.logger = t3;
            },
            compileAsync__closure: function compileAsync__closure() {},
            compileStringAsync_closure: function compileStringAsync_closure(t0, t1, t2, t3) {
                var _ = this;
                _.text = t0;
                _.options = t1;
                _.color = t2;
                _.logger = t3;
            },
            compileStringAsync__closure: function compileStringAsync__closure() {},
            compileStringAsync__closure0: function compileStringAsync__closure0() {},
            _wrapAsyncSassExceptions_closure: function _wrapAsyncSassExceptions_closure(t0, t1) {
                this.color = t0;
                this.ascii = t1;
            },
            _parseFunctions_closure0: function _parseFunctions_closure0(t0, t1) {
                this.asynch = t0;
                this.result = t1;
            },
            _parseFunctions__closure2: function _parseFunctions__closure2(t0, t1) {
                this.callback = t0;
                this.callable = t1;
            },
            _parseFunctions___closure6: function _parseFunctions___closure6(t0, t1) {
                this.callback = t0;
                this.$arguments = t1;
            },
            _parseFunctions__closure3: function _parseFunctions__closure3(t0, t1) {
                this.callback = t0;
                this.callable = t1;
            },
            _parseFunctions___closure5: function _parseFunctions___closure5(t0, t1) {
                this.callback = t0;
                this.$arguments = t1;
            },
            nodePackageImporterClass_closure: function nodePackageImporterClass_closure() {},
            nodePackageImporterClass__closure: function nodePackageImporterClass__closure() {},
            compile: function(path, charset, fatalDeprecations, functions, futureDeprecations, importCache, indentWidth, lineFeed, logger, nodeImporter, quietDeps, silenceDeprecations, sourceMap, style, syntax, useSpaces, verbose) {
                var t3, t4, t0, stylesheet, result, _null = null, t1 = type$.Deprecation_3, t2 = A.LinkedHashSet_LinkedHashSet$_empty(t1);
                if (silenceDeprecations != null) t2.addAll$1(0, silenceDeprecations);
                t3 = A.LinkedHashSet_LinkedHashSet$_empty(t1);
                if (fatalDeprecations != null) t3.addAll$1(0, fatalDeprecations);
                t4 = A.LinkedHashSet_LinkedHashSet$_empty(t1);
                if (futureDeprecations != null) t4.addAll$1(0, futureDeprecations);
                logger = new A.DeprecationProcessingLogger0(A.LinkedHashMap_LinkedHashMap$_empty(t1, type$.int), logger, t2, t3, t4, !verbose);
                logger.validate$0();
                t1 = nodeImporter == null;
                if (t1) t2 = syntax == null || syntax === A.Syntax_forPath0(path);
                else t2 = false;
                if (t2) {
                    if (importCache == null) importCache = A.ImportCache$none();
                    t2 = $.$get$FilesystemImporter_cwd0();
                    t3 = A.isNodeJs() ? self.process : _null;
                    if (!J.$eq$(t3 == null ? _null : J.get$platform$x(t3), "win32")) {
                        t3 = A.isNodeJs() ? self.process : _null;
                        t3 = J.$eq$(t3 == null ? _null : J.get$platform$x(t3), "darwin");
                    } else t3 = true;
                    if (t3) {
                        t3 = A.absolute(path, _null, _null, _null, _null, _null, _null, _null, _null, _null, _null, _null, _null, _null, _null);
                        t4 = $.$get$context();
                        t3 = A._realCasePath0(t4.normalize$1(t3));
                    } else {
                        t3 = $.$get$context();
                        t4 = t3.canonicalize$1(0, path);
                        t0 = t4;
                        t4 = t3;
                        t3 = t0;
                    }
                    t4 = importCache.importCanonical$3$originalUrl(t2, t4.toUri$1(t3), t4.toUri$1(path));
                    t4.toString;
                    stylesheet = t4;
                } else {
                    t2 = A.readFile0(path);
                    t3 = syntax == null ? A.Syntax_forPath0(path) : syntax;
                    stylesheet = A.Stylesheet_Stylesheet$parse0(t2, t3, false, $.$get$context().toUri$1(path));
                }
                result = A._compileStylesheet1(stylesheet, logger, importCache, nodeImporter, $.$get$FilesystemImporter_cwd0(), functions, style, useSpaces, indentWidth, lineFeed, quietDeps, sourceMap, charset);
                logger.summarize$1$js(!t1);
                return result;
            },
            compileString: function(source, charset, fatalDeprecations, functions, futureDeprecations, importCache, importer, indentWidth, lineFeed, logger, nodeImporter, quietDeps, silenceDeprecations, sourceMap, style, syntax, url, useSpaces, verbose) {
                var t3, t4, stylesheet, _0_0, result, t1 = type$.Deprecation_3, t2 = A.LinkedHashSet_LinkedHashSet$_empty(t1);
                if (silenceDeprecations != null) t2.addAll$1(0, silenceDeprecations);
                t3 = A.LinkedHashSet_LinkedHashSet$_empty(t1);
                if (fatalDeprecations != null) t3.addAll$1(0, fatalDeprecations);
                t4 = A.LinkedHashSet_LinkedHashSet$_empty(t1);
                if (futureDeprecations != null) t4.addAll$1(0, futureDeprecations);
                logger = new A.DeprecationProcessingLogger0(A.LinkedHashMap_LinkedHashMap$_empty(t1, type$.int), logger, t2, t3, t4, !verbose);
                logger.validate$0();
                stylesheet = A.Stylesheet_Stylesheet$parse0(source, syntax == null ? B.Syntax_SCSS_0_scss0 : syntax, false, url);
                t1 = stylesheet.span;
                _0_0 = t1.get$sourceUrl(t1);
                if (type$.Uri._is(_0_0) && "" === _0_0.get$scheme() && nodeImporter == null) A.WarnForDeprecation_warnForDeprecation0(logger, B.Deprecation_y9Y, "Passing a relative `url` argument (" + A.S(t1.get$sourceUrl(t1)) + string$.x29x20to_cm, null, null);
                if (importer == null) t1 = A.isBrowser() ? new A.NoOpImporter0() : $.$get$FilesystemImporter_cwd0();
                else t1 = importer;
                result = A._compileStylesheet1(stylesheet, logger, importCache, nodeImporter, t1, functions, style, useSpaces, indentWidth, lineFeed, quietDeps, sourceMap, charset);
                logger.summarize$1$js(nodeImporter != null);
                return result;
            },
            _compileStylesheet1: function(stylesheet, logger, importCache, nodeImporter, importer, functions, style, useSpaces, indentWidth, lineFeed, quietDeps, sourceMap, charset) {
                var evaluateResult, serializeResult, resultSourceMap;
                if (nodeImporter != null) A.WarnForDeprecation_warnForDeprecation0(logger, B.Deprecation_PGp, string$.The_le, null, null);
                evaluateResult = A._EvaluateVisitor$1(functions, importCache, logger, nodeImporter, quietDeps, sourceMap).run$2(0, importer, stylesheet);
                serializeResult = A.serialize0(evaluateResult._1, charset, indentWidth, false, lineFeed, logger, sourceMap, style, useSpaces);
                resultSourceMap = serializeResult._1;
                if (resultSourceMap != null && importCache != null) A.mapInPlace0(resultSourceMap.urls, new A._compileStylesheet_closure1(stylesheet, importCache));
                return new A.CompileResult0(evaluateResult, serializeResult);
            },
            _compileStylesheet_closure1: function _compileStylesheet_closure1(t0, t1) {
                this.stylesheet = t0;
                this.importCache = t1;
            },
            CompileOptions: function CompileOptions() {},
            CompileStringOptions: function CompileStringOptions() {},
            NodeCompileResult: function NodeCompileResult() {},
            CompileResult0: function CompileResult0(t0, t1) {
                this._evaluate = t0;
                this._compile_result$_serialize = t1;
            },
            initCompiler: function() {
                return new A.Compiler();
            },
            initAsyncCompiler: function() {
                return A.futureToPromise0(new A.initAsyncCompiler_closure().call$0());
            },
            Compiler: function Compiler() {
                this._disposed = false;
            },
            AsyncCompiler: function AsyncCompiler(t0) {
                this.compilations = t0;
                this._disposed = false;
            },
            AsyncCompiler_addCompilation_closure: function AsyncCompiler_addCompilation_closure() {},
            compilerClass_closure: function compilerClass_closure() {},
            compilerClass__closure: function compilerClass__closure() {},
            compilerClass__closure0: function compilerClass__closure0() {},
            compilerClass__closure1: function compilerClass__closure1() {},
            compilerClass__closure2: function compilerClass__closure2() {},
            asyncCompilerClass_closure: function asyncCompilerClass_closure() {},
            asyncCompilerClass__closure: function asyncCompilerClass__closure() {},
            asyncCompilerClass__closure0: function asyncCompilerClass__closure0() {},
            asyncCompilerClass__closure1: function asyncCompilerClass__closure1() {},
            asyncCompilerClass__closure2: function asyncCompilerClass__closure2() {},
            asyncCompilerClass___closure: function asyncCompilerClass___closure(t0) {
                this.self = t0;
            },
            initAsyncCompiler_closure: function initAsyncCompiler_closure() {},
            InterpolatedComplexSelector$: function(components, span, leadingCombinator) {
                var t1 = A.List_List$unmodifiable(components, type$.InterpolatedComplexSelectorComponent);
                if (leadingCombinator == null && t1.length === 0) A.throwExpression(A.ArgumentError$("components may not be empty if leadingCombinator is null.", null));
                return new A.InterpolatedComplexSelector(leadingCombinator, t1, span);
            },
            InterpolatedComplexSelector: function InterpolatedComplexSelector(t0, t1, t2) {
                this.leadingCombinator = t0;
                this.components = t1;
                this.span = t2;
            },
            ComplexSassNumber0: function ComplexSassNumber0(t0, t1, t2, t3) {
                var _ = this;
                _._complex0$_numeratorUnits = t0;
                _._complex0$_denominatorUnits = t1;
                _._number1$_value = t2;
                _.hashCache = null;
                _.asSlash = t3;
            },
            ComplexSelector$0: function(leadingCombinators, components, span, lineBreak) {
                var t1 = A.List_List$unmodifiable(leadingCombinators, type$.CssValue_Combinator_2), t2 = A.List_List$unmodifiable(components, type$.ComplexSelectorComponent_2);
                if (t1.length === 0 && t2.length === 0) A.throwExpression(A.ArgumentError$(string$.leadin, null));
                return new A.ComplexSelector0(t1, t2, lineBreak, span);
            },
            ComplexSelector0: function ComplexSelector0(t0, t1, t2, t3) {
                var _ = this;
                _.leadingCombinators = t0;
                _.components = t1;
                _.lineBreak = t2;
                _._complex$__ComplexSelector_specificity_FI = $;
                _.span = t3;
            },
            ComplexSelector_specificity_closure0: function ComplexSelector_specificity_closure0() {},
            InterpolatedComplexSelectorComponent: function InterpolatedComplexSelectorComponent(t0, t1, t2) {
                this.selector = t0;
                this.combinator = t1;
                this.span = t2;
            },
            ComplexSelectorComponent0: function ComplexSelectorComponent0(t0, t1, t2) {
                this.selector = t0;
                this.combinators = t1;
                this.span = t2;
            },
            ComplexSelectorComponent_toString_closure0: function ComplexSelectorComponent_toString_closure0() {},
            InterpolatedCompoundSelector$: function(components) {
                var t1 = A.List_List$unmodifiable(components, type$.InterpolatedSimpleSelector);
                if (t1.length === 0) A.throwExpression(A.ArgumentError$("components may not be empty.", null));
                return new A.InterpolatedCompoundSelector(t1);
            },
            InterpolatedCompoundSelector: function InterpolatedCompoundSelector(t0) {
                this.components = t0;
            },
            CompoundSelector$0: function(components, span) {
                var t1 = A.List_List$unmodifiable(components, type$.SimpleSelector_2);
                if (t1.length === 0) A.throwExpression(A.ArgumentError$("components may not be empty.", null));
                return new A.CompoundSelector0(t1, span);
            },
            CompoundSelector0: function CompoundSelector0(t0, t1) {
                var _ = this;
                _.components = t0;
                _._compound$__CompoundSelector_hasComplicatedSuperselectorSemantics_FI = _._compound$__CompoundSelector_specificity_FI = $;
                _.span = t1;
            },
            CompoundSelector_specificity_closure0: function CompoundSelector_specificity_closure0() {},
            CompoundSelector_hasComplicatedSuperselectorSemantics_closure0: function CompoundSelector_hasComplicatedSuperselectorSemantics_closure0() {},
            Configuration0: function Configuration0(t0, t1) {
                this._configuration0$_values = t0;
                this._configuration0$__originalConfiguration = t1;
            },
            ExplicitConfiguration0: function ExplicitConfiguration0(t0, t1, t2) {
                this.nodeWithSpan = t0;
                this._configuration0$_values = t1;
                this._configuration0$__originalConfiguration = t2;
            },
            ConfiguredValue0: function ConfiguredValue0(t0, t1, t2) {
                this.value = t0;
                this.configurationSpan = t1;
                this.assignmentNode = t2;
            },
            ConfiguredVariable0: function ConfiguredVariable0(t0, t1, t2, t3) {
                var _ = this;
                _.name = t0;
                _.expression = t1;
                _.isGuarded = t2;
                _.span = t3;
            },
            ContentBlock$0: function(parameters, children, span) {
                var _s8_ = "@content", t1 = A.stringReplaceAllUnchecked(_s8_, "_", "-"), t2 = A.List_List$unmodifiable(children, type$.Statement_2), t3 = B.JSArray_methods.any$1(t2, new A.ParentStatement_closure0());
                return new A.ContentBlock0(t1, _s8_, parameters, span, t2, t3);
            },
            ContentBlock0: function ContentBlock0(t0, t1, t2, t3, t4, t5) {
                var _ = this;
                _.name = t0;
                _.originalName = t1;
                _.parameters = t2;
                _.span = t3;
                _.children = t4;
                _.hasDeclarations = t5;
            },
            ContentRule0: function ContentRule0(t0, t1) {
                this.$arguments = t0;
                this.span = t1;
            },
            _disallowedFunctionNames_closure0: function _disallowedFunctionNames_closure0() {},
            CssParser0: function CssParser0(t0, t1, t2, t3, t4) {
                var _ = this;
                _._parseSelectors = t0;
                _._stylesheet0$_isUseAllowed = true;
                _._stylesheet0$_inExpression = _._stylesheet0$_inParentheses = _._stylesheet0$_inStyleRule = _._stylesheet0$_inPlainCssFunction = _._stylesheet0$_inUnknownAtRule = _._stylesheet0$_inControlDirective = _._stylesheet0$_inContentBlock = _._stylesheet0$_inMixin = false;
                _._stylesheet0$_globalVariables = t1;
                _.warnings = t2;
                _.lastSilentComment = null;
                _.scanner = t3;
                _._parser1$_interpolationMap = t4;
            },
            DebugRule0: function DebugRule0(t0, t1) {
                this.expression = t0;
                this.span = t1;
            },
            ModifiableCssDeclaration$0: function($name, value, span, parsedAsSassScript, valueSpanForMap) {
                var t2, t1 = valueSpanForMap == null ? value.span : valueSpanForMap;
                if (!parsedAsSassScript) {
                    t2 = value.value;
                    if (!(t2 instanceof A.SassString0)) A.throwExpression(A.ArgumentError$(string$.If_par + value.toString$0(0) + "` of type " + A.getRuntimeTypeOfDartObject(t2).toString$0(0) + ").", null));
                }
                return new A.ModifiableCssDeclaration0($name, value, parsedAsSassScript, t1, span);
            },
            ModifiableCssDeclaration0: function ModifiableCssDeclaration0(t0, t1, t2, t3, t4) {
                var _ = this;
                _.name = t0;
                _.value = t1;
                _.parsedAsSassScript = t2;
                _.valueSpanForMap = t3;
                _.span = t4;
                _._node$_indexInParent = _._node$_parent = null;
                _.isGroupEnd = false;
            },
            Declaration$0: function($name, value, span) {
                return new A.Declaration0($name, value, span, true, null, false);
            },
            Declaration$notSassScript0: function($name, value, span) {
                return new A.Declaration0($name, value, span, false, null, false);
            },
            Declaration$nested0: function($name, children, span, value) {
                var t1 = A.List_List$unmodifiable(children, type$.Statement_2), t2 = B.JSArray_methods.any$1(t1, new A.ParentStatement_closure0());
                return new A.Declaration0($name, value, span, true, t1, t2);
            },
            Declaration0: function Declaration0(t0, t1, t2, t3, t4, t5) {
                var _ = this;
                _.name = t0;
                _.value = t1;
                _.span = t2;
                _.parsedAsSassScript = t3;
                _.children = t4;
                _.hasDeclarations = t5;
            },
            SupportsDeclaration0: function SupportsDeclaration0(t0, t1, t2) {
                this.name = t0;
                this.value = t1;
                this.span = t2;
            },
            DefaultLogger0: function DefaultLogger0() {},
            Deprecation_fromId0: function(id) {
                return A.IterableExtension_firstWhereOrNull(B.List_JA2, new A.Deprecation_fromId_closure0(id));
            },
            Deprecation_forVersion0: function(version1) {
                var t2, _i, deprecation, $self, t3, t1 = A.LinkedHashSet_LinkedHashSet$_empty(type$.Deprecation_3);
                for(t2 = A.VersionRange_VersionRange(true, version1).get$allows(), _i = 0; _i < 31; ++_i){
                    deprecation = B.List_JA2[_i];
                    $self = deprecation._deprecation$_deprecatedIn;
                    t3 = $self == null ? null : A.Version___parse_tearOff($self);
                    t3 = t3 == null ? null : t2.call$1(t3);
                    if (t3 == null ? false : t3) {
                        $self = deprecation._deprecation$_obsoleteIn;
                        if ($self == null) t3 = null;
                        else t3 = A.Version___parse_tearOff($self);
                        t3 = t3 == null;
                    } else t3 = false;
                    if (t3) t1.add$1(0, deprecation);
                }
                return t1;
            },
            Deprecation0: function Deprecation0(t0, t1, t2, t3, t4, t5) {
                var _ = this;
                _.id = t0;
                _._deprecation$_deprecatedIn = t1;
                _.description = t2;
                _._deprecation$_obsoleteIn = t3;
                _.index = t4;
                _._name = t5;
            },
            Deprecation_fromId_closure0: function Deprecation_fromId_closure0(t0) {
                this.id = t0;
            },
            DeprecationProcessingLogger0: function DeprecationProcessingLogger0(t0, t1, t2, t3, t4, t5) {
                var _ = this;
                _._deprecation_processing$_warningCounts = t0;
                _._deprecation_processing$_inner = t1;
                _.silenceDeprecations = t2;
                _.fatalDeprecations = t3;
                _.futureDeprecations = t4;
                _.limitRepetition = t5;
            },
            DeprecationProcessingLogger_summarize_closure1: function DeprecationProcessingLogger_summarize_closure1() {},
            DeprecationProcessingLogger_summarize_closure2: function DeprecationProcessingLogger_summarize_closure2() {},
            parseDeprecations: function(logger, deprecations, supportVersions) {
                if (deprecations == null) return null;
                return new A.parseDeprecations_closure(deprecations, logger, supportVersions).call$0();
            },
            Deprecation1: function Deprecation1() {},
            deprecations_closure: function deprecations_closure(t0) {
                this.deprecation = t0;
            },
            parseDeprecations_closure: function parseDeprecations_closure(t0, t1, t2) {
                this.deprecations = t0;
                this.logger = t1;
                this.supportVersions = t2;
            },
            versionClass_closure: function versionClass_closure() {},
            versionClass__closure: function versionClass__closure() {},
            versionClass__closure0: function versionClass__closure0() {},
            DisplayP3ColorSpace0: function DisplayP3ColorSpace0(t0, t1) {
                this.name = t0;
                this._space$_channels = t1;
            },
            DisplayP3LinearColorSpace0: function DisplayP3LinearColorSpace0(t0, t1) {
                this.name = t0;
                this._space$_channels = t1;
            },
            DynamicImport0: function DynamicImport0(t0, t1) {
                this.urlString = t0;
                this.span = t1;
            },
            EachRule$0: function(variables, list, children, span) {
                var t1 = A.List_List$unmodifiable(variables, type$.String), t2 = A.List_List$unmodifiable(children, type$.Statement_2), t3 = B.JSArray_methods.any$1(t2, new A.ParentStatement_closure0());
                return new A.EachRule0(t1, list, span, t2, t3);
            },
            EachRule0: function EachRule0(t0, t1, t2, t3, t4) {
                var _ = this;
                _.variables = t0;
                _.list = t1;
                _.span = t2;
                _.children = t3;
                _.hasDeclarations = t4;
            },
            EachRule_toString_closure0: function EachRule_toString_closure0() {},
            EmptyExtensionStore0: function EmptyExtensionStore0() {},
            Environment$0: function() {
                var t1 = type$.String, t2 = type$.Module_Callable_2, t3 = type$.AstNode_2, t4 = type$.int, t5 = type$.Callable_2, t6 = type$.JSArray_Map_String_Callable_2;
                return new A.Environment0(A.LinkedHashMap_LinkedHashMap$_empty(t1, t2), A.LinkedHashMap_LinkedHashMap$_empty(t1, t3), A.LinkedHashMap_LinkedHashMap$_empty(t2, t3), A.LinkedHashMap_LinkedHashMap$_empty(t2, t3), null, null, A._setArrayType([], type$.JSArray_Module_Callable_2), A._setArrayType([
                    A.LinkedHashMap_LinkedHashMap$_empty(t1, type$.Value_2)
                ], type$.JSArray_Map_String_Value_2), A._setArrayType([
                    A.LinkedHashMap_LinkedHashMap$_empty(t1, t3)
                ], type$.JSArray_Map_String_AstNode_2), A.LinkedHashMap_LinkedHashMap$_empty(t1, t4), A._setArrayType([
                    A.LinkedHashMap_LinkedHashMap$_empty(t1, t5)
                ], t6), A.LinkedHashMap_LinkedHashMap$_empty(t1, t4), A._setArrayType([
                    A.LinkedHashMap_LinkedHashMap$_empty(t1, t5)
                ], t6), A.LinkedHashMap_LinkedHashMap$_empty(t1, t4), null, A.LinkedHashSet_LinkedHashSet$_empty(t1));
            },
            Environment$_0: function(_modules, _namespaceNodes, _globalModules, _importedModules, _forwardedModules, _nestedForwardedModules, _allModules, _variables, _variableNodes, _functions, _mixins, _content, _configurableVariables) {
                var t1 = type$.String, t2 = type$.int;
                return new A.Environment0(_modules, _namespaceNodes, _globalModules, _importedModules, _forwardedModules, _nestedForwardedModules, _allModules, _variables, _variableNodes, A.LinkedHashMap_LinkedHashMap$_empty(t1, t2), _functions, A.LinkedHashMap_LinkedHashMap$_empty(t1, t2), _mixins, A.LinkedHashMap_LinkedHashMap$_empty(t1, t2), _content, _configurableVariables);
            },
            _EnvironmentModule__EnvironmentModule1: function(environment, css, preModuleComments, extensionStore, forwarded) {
                var t1, t2, t3, t4, t5, t6, module, result, t7;
                if (forwarded == null) forwarded = B.Set_empty5;
                t1 = type$.dynamic;
                t1 = A.LinkedHashMap_LinkedHashMap$_empty(t1, t1);
                for(t2 = type$.Module_Callable_2, t3 = type$.List_CssComment_2, t4 = A.MapExtensions_get_pairs0(preModuleComments, t2, t3), t4 = t4.get$iterator(t4), t5 = type$.CssComment_2; t4.moveNext$0();){
                    t6 = t4.get$current(t4);
                    module = t6._0;
                    result = A.List_List$from(t6._1, false, t5);
                    result.$flags = 3;
                    t1.$indexSet(0, module, result);
                }
                t1 = A.ConstantMap_ConstantMap$from(t1, t2, t3);
                t2 = A._EnvironmentModule__makeModulesByVariable1(forwarded);
                t3 = A._EnvironmentModule__memberMap1(B.JSArray_methods.get$first(environment._environment0$_variables), forwarded.map$1$1(0, new A._EnvironmentModule__EnvironmentModule_closure11(), type$.Map_String_Value_2), type$.Value_2);
                t4 = A._EnvironmentModule__memberMap1(B.JSArray_methods.get$first(environment._environment0$_variableNodes), forwarded.map$1$1(0, new A._EnvironmentModule__EnvironmentModule_closure12(), type$.Map_String_AstNode_2), type$.AstNode_2);
                t5 = type$.Map_String_Callable_2;
                t6 = type$.Callable_2;
                t7 = A._EnvironmentModule__memberMap1(B.JSArray_methods.get$first(environment._environment0$_functions), forwarded.map$1$1(0, new A._EnvironmentModule__EnvironmentModule_closure13(), t5), t6);
                t6 = A._EnvironmentModule__memberMap1(B.JSArray_methods.get$first(environment._environment0$_mixins), forwarded.map$1$1(0, new A._EnvironmentModule__EnvironmentModule_closure14(), t5), t6);
                t5 = J.get$isNotEmpty$asx(css.get$children(css)) || preModuleComments.get$isNotEmpty(preModuleComments) || B.JSArray_methods.any$1(environment._environment0$_allModules, new A._EnvironmentModule__EnvironmentModule_closure15());
                return A._EnvironmentModule$_1(environment, css, t1, extensionStore, t2, t3, t4, t7, t6, t5, !extensionStore.get$isEmpty(extensionStore) || B.JSArray_methods.any$1(environment._environment0$_allModules, new A._EnvironmentModule__EnvironmentModule_closure16()));
            },
            _EnvironmentModule__makeModulesByVariable1: function(forwarded) {
                var modulesByVariable, t1, t2, t3, t4, t5;
                if (forwarded.get$isEmpty(forwarded)) return B.Map_empty11;
                modulesByVariable = A.LinkedHashMap_LinkedHashMap$_empty(type$.String, type$.Module_Callable_2);
                for(t1 = forwarded.get$iterator(forwarded); t1.moveNext$0();){
                    t2 = t1.get$current(t1);
                    if (t2 instanceof A._EnvironmentModule1) {
                        for(t3 = t2._environment0$_modulesByVariable, t3 = t3.get$values(t3), t3 = t3.get$iterator(t3); t3.moveNext$0();){
                            t4 = t3.get$current(t3);
                            t5 = t4.get$variables();
                            A.setAll0(modulesByVariable, t5.get$keys(t5), t4);
                        }
                        t3 = B.JSArray_methods.get$first(t2._environment0$_environment._environment0$_variables);
                        A.setAll0(modulesByVariable, t3.get$keys(t3), t2);
                    } else {
                        t3 = t2.get$variables();
                        A.setAll0(modulesByVariable, t3.get$keys(t3), t2);
                    }
                }
                return modulesByVariable;
            },
            _EnvironmentModule__memberMap1: function(localMap, otherMaps, $V) {
                var t1, t2, t3;
                localMap = new A.PublicMemberMapView0(localMap, $V._eval$1("PublicMemberMapView0<0>"));
                if (otherMaps.get$isEmpty(otherMaps)) return localMap;
                t1 = A._setArrayType([], $V._eval$1("JSArray<Map<String,0>>"));
                for(t2 = otherMaps.get$iterator(otherMaps); t2.moveNext$0();){
                    t3 = t2.get$current(t2);
                    if (t3.get$isNotEmpty(t3)) t1.push(t3);
                }
                t1.push(localMap);
                if (t1.length === 1) return localMap;
                return A.MergedMapView$0(t1, type$.String, $V);
            },
            _EnvironmentModule$_1: function(_environment, css, preModuleComments, extensionStore, _modulesByVariable, variables, variableNodes, functions, mixins, transitivelyContainsCss, transitivelyContainsExtensions) {
                return new A._EnvironmentModule1(_environment._environment0$_allModules, variables, variableNodes, functions, mixins, extensionStore, css, preModuleComments, transitivelyContainsCss, transitivelyContainsExtensions, _environment, _modulesByVariable);
            },
            Environment0: function Environment0(t0, t1, t2, t3, t4, t5, t6, t7, t8, t9, t10, t11, t12, t13, t14, t15) {
                var _ = this;
                _._environment0$_modules = t0;
                _._environment0$_namespaceNodes = t1;
                _._environment0$_globalModules = t2;
                _._environment0$_importedModules = t3;
                _._environment0$_forwardedModules = t4;
                _._environment0$_nestedForwardedModules = t5;
                _._environment0$_allModules = t6;
                _._environment0$_variables = t7;
                _._environment0$_variableNodes = t8;
                _._environment0$_variableIndices = t9;
                _._environment0$_functions = t10;
                _._environment0$_functionIndices = t11;
                _._environment0$_mixins = t12;
                _._environment0$_mixinIndices = t13;
                _._environment0$_content = t14;
                _._environment0$_configurableVariables = t15;
                _._environment0$_inMixin = false;
                _._environment0$_inSemiGlobalScope = true;
                _._environment0$_lastVariableIndex = _._environment0$_lastVariableName = null;
            },
            Environment__getVariableFromGlobalModule_closure0: function Environment__getVariableFromGlobalModule_closure0(t0) {
                this.name = t0;
            },
            Environment_setVariable_closure2: function Environment_setVariable_closure2(t0, t1) {
                this.$this = t0;
                this.name = t1;
            },
            Environment_setVariable_closure3: function Environment_setVariable_closure3(t0) {
                this.name = t0;
            },
            Environment_setVariable_closure4: function Environment_setVariable_closure4(t0, t1) {
                this.$this = t0;
                this.name = t1;
            },
            Environment__getFunctionFromGlobalModule_closure0: function Environment__getFunctionFromGlobalModule_closure0(t0) {
                this.name = t0;
            },
            Environment__getMixinFromGlobalModule_closure0: function Environment__getMixinFromGlobalModule_closure0(t0) {
                this.name = t0;
            },
            Environment_toModule_closure0: function Environment_toModule_closure0() {},
            Environment_toDummyModule_closure0: function Environment_toDummyModule_closure0() {},
            _EnvironmentModule1: function _EnvironmentModule1(t0, t1, t2, t3, t4, t5, t6, t7, t8, t9, t10, t11) {
                var _ = this;
                _.upstream = t0;
                _.variables = t1;
                _.variableNodes = t2;
                _.functions = t3;
                _.mixins = t4;
                _.extensionStore = t5;
                _.css = t6;
                _.preModuleComments = t7;
                _.transitivelyContainsCss = t8;
                _.transitivelyContainsExtensions = t9;
                _._environment0$_environment = t10;
                _._environment0$_modulesByVariable = t11;
            },
            _EnvironmentModule__EnvironmentModule_closure11: function _EnvironmentModule__EnvironmentModule_closure11() {},
            _EnvironmentModule__EnvironmentModule_closure12: function _EnvironmentModule__EnvironmentModule_closure12() {},
            _EnvironmentModule__EnvironmentModule_closure13: function _EnvironmentModule__EnvironmentModule_closure13() {},
            _EnvironmentModule__EnvironmentModule_closure14: function _EnvironmentModule__EnvironmentModule_closure14() {},
            _EnvironmentModule__EnvironmentModule_closure15: function _EnvironmentModule__EnvironmentModule_closure15() {},
            _EnvironmentModule__EnvironmentModule_closure16: function _EnvironmentModule__EnvironmentModule_closure16() {},
            _EnvironmentModule_couldHaveBeenConfigured_closure1: function _EnvironmentModule_couldHaveBeenConfigured_closure1(t0) {
                this.variables = t0;
            },
            ErrorRule0: function ErrorRule0(t0, t1) {
                this.expression = t0;
                this.span = t1;
            },
            _EvaluateVisitor$1: function(functions, importCache, logger, nodeImporter, quietDeps, sourceMap) {
                var t4, t1 = type$.Uri, t2 = type$.Module_Callable_2, t3 = A._setArrayType([], type$.JSArray_Record_2_String_and_AstNode_2);
                if (importCache == null) t4 = nodeImporter == null ? A.ImportCache$none() : null;
                else t4 = importCache;
                t1 = new A._EvaluateVisitor1(t4, nodeImporter, A.LinkedHashMap_LinkedHashMap$_empty(type$.String, type$.Callable_2), A.LinkedHashMap_LinkedHashMap$_empty(t1, t2), A.LinkedHashMap_LinkedHashMap$_empty(t1, t2), A.LinkedHashMap_LinkedHashMap$_empty(t1, type$.Configuration_2), A.LinkedHashMap_LinkedHashMap$_empty(t1, type$.AstNode_2), logger, A.LinkedHashSet_LinkedHashSet$_empty(type$.Record_2_String_and_SourceSpan), quietDeps, sourceMap, new A.Object(), A.Environment$0(), A.LinkedHashSet_LinkedHashSet$_empty(t1), A.LinkedHashMap_LinkedHashMap$_empty(t1, type$.nullable_AstNode_2), t3, B.Configuration_Map_empty_null0);
                t1._EvaluateVisitor$6$functions$importCache$logger$nodeImporter$quietDeps$sourceMap1(functions, importCache, logger, nodeImporter, quietDeps, sourceMap);
                return t1;
            },
            _EvaluateVisitor1: function _EvaluateVisitor1(t0, t1, t2, t3, t4, t5, t6, t7, t8, t9, t10, t11, t12, t13, t14, t15, t16) {
                var _ = this;
                _._evaluate0$_importCache = t0;
                _._nodeImporter = t1;
                _._evaluate0$_builtInFunctions = t2;
                _._evaluate0$_builtInModules = t3;
                _._evaluate0$_modules = t4;
                _._evaluate0$_moduleConfigurations = t5;
                _._evaluate0$_moduleNodes = t6;
                _._evaluate0$_logger = t7;
                _._evaluate0$_warningsEmitted = t8;
                _._evaluate0$_quietDeps = t9;
                _._evaluate0$_sourceMap = t10;
                _._evaluate0$_compileContext = t11;
                _._evaluate0$_environment = t12;
                _._evaluate0$_declarationName = _._evaluate0$__parent = _._evaluate0$_mediaQuerySources = _._evaluate0$_mediaQueries = _._evaluate0$_styleRuleIgnoringAtRoot = null;
                _._evaluate0$_member = "root stylesheet";
                _._evaluate0$_importSpan = _._evaluate0$_callableNode = null;
                _._evaluate0$_inSupportsDeclaration = _._evaluate0$_inKeyframes = _._evaluate0$_atRootExcludingStyleRule = _._evaluate0$_inUnknownAtRule = _._evaluate0$_inFunction = false;
                _._evaluate0$_loadedUrls = t13;
                _._evaluate0$_activeModules = t14;
                _._evaluate0$_stack = t15;
                _._evaluate0$_importer = null;
                _._evaluate0$_inDependency = false;
                _._evaluate0$__extensionStore = _._evaluate0$_preModuleComments = _._evaluate0$_outOfOrderImports = _._evaluate0$__endOfImports = _._evaluate0$__root = _._evaluate0$__stylesheet = null;
                _._evaluate0$_configuration = t16;
            },
            _EvaluateVisitor_closure25: function _EvaluateVisitor_closure25(t0) {
                this.$this = t0;
            },
            _EvaluateVisitor_closure26: function _EvaluateVisitor_closure26(t0) {
                this.$this = t0;
            },
            _EvaluateVisitor_closure27: function _EvaluateVisitor_closure27(t0) {
                this.$this = t0;
            },
            _EvaluateVisitor_closure28: function _EvaluateVisitor_closure28(t0) {
                this.$this = t0;
            },
            _EvaluateVisitor_closure29: function _EvaluateVisitor_closure29(t0) {
                this.$this = t0;
            },
            _EvaluateVisitor_closure30: function _EvaluateVisitor_closure30(t0) {
                this.$this = t0;
            },
            _EvaluateVisitor_closure31: function _EvaluateVisitor_closure31(t0) {
                this.$this = t0;
            },
            _EvaluateVisitor_closure32: function _EvaluateVisitor_closure32(t0) {
                this.$this = t0;
            },
            _EvaluateVisitor_closure33: function _EvaluateVisitor_closure33(t0) {
                this.$this = t0;
            },
            _EvaluateVisitor__closure10: function _EvaluateVisitor__closure10(t0, t1, t2) {
                this.$this = t0;
                this.name = t1;
                this.module = t2;
            },
            _EvaluateVisitor_closure34: function _EvaluateVisitor_closure34(t0) {
                this.$this = t0;
            },
            _EvaluateVisitor__closure9: function _EvaluateVisitor__closure9(t0, t1, t2) {
                this.$this = t0;
                this.name = t1;
                this.module = t2;
            },
            _EvaluateVisitor_closure35: function _EvaluateVisitor_closure35(t0) {
                this.$this = t0;
            },
            _EvaluateVisitor_closure36: function _EvaluateVisitor_closure36(t0) {
                this.$this = t0;
            },
            _EvaluateVisitor__closure7: function _EvaluateVisitor__closure7(t0, t1, t2, t3) {
                var _ = this;
                _._box_0 = t0;
                _.values = t1;
                _.span = t2;
                _.callableNode = t3;
            },
            _EvaluateVisitor__closure8: function _EvaluateVisitor__closure8(t0) {
                this.$this = t0;
            },
            _EvaluateVisitor_closure37: function _EvaluateVisitor_closure37(t0) {
                this.$this = t0;
            },
            _EvaluateVisitor_run_closure1: function _EvaluateVisitor_run_closure1(t0, t1, t2) {
                this.$this = t0;
                this.node = t1;
                this.importer = t2;
            },
            _EvaluateVisitor_run__closure1: function _EvaluateVisitor_run__closure1(t0, t1, t2) {
                this.$this = t0;
                this.importer = t1;
                this.node = t2;
            },
            _EvaluateVisitor__loadModule_closure3: function _EvaluateVisitor__loadModule_closure3(t0, t1) {
                this._box_0 = t0;
                this.callback = t1;
            },
            _EvaluateVisitor__loadModule_closure4: function _EvaluateVisitor__loadModule_closure4(t0, t1, t2, t3, t4, t5, t6) {
                var _ = this;
                _.$this = t0;
                _.url = t1;
                _.nodeWithSpan = t2;
                _.baseUrl = t3;
                _.namesInErrors = t4;
                _.configuration = t5;
                _.callback = t6;
            },
            _EvaluateVisitor__loadModule__closure3: function _EvaluateVisitor__loadModule__closure3(t0, t1) {
                this.$this = t0;
                this.message = t1;
            },
            _EvaluateVisitor__loadModule__closure4: function _EvaluateVisitor__loadModule__closure4(t0, t1, t2) {
                this._box_1 = t0;
                this.callback = t1;
                this.firstLoad = t2;
            },
            _EvaluateVisitor__execute_closure1: function _EvaluateVisitor__execute_closure1(t0, t1, t2, t3, t4, t5, t6) {
                var _ = this;
                _.$this = t0;
                _.importer = t1;
                _.stylesheet = t2;
                _.extensionStore = t3;
                _.configuration = t4;
                _.css = t5;
                _.preModuleComments = t6;
            },
            _EvaluateVisitor__combineCss_closure3: function _EvaluateVisitor__combineCss_closure3() {},
            _EvaluateVisitor__combineCss_closure4: function _EvaluateVisitor__combineCss_closure4(t0) {
                this.selectors = t0;
            },
            _EvaluateVisitor__combineCss_visitModule1: function _EvaluateVisitor__combineCss_visitModule1(t0, t1, t2, t3, t4, t5) {
                var _ = this;
                _.$this = t0;
                _.seen = t1;
                _.clone = t2;
                _.css = t3;
                _.imports = t4;
                _.sorted = t5;
            },
            _EvaluateVisitor__extendModules_closure3: function _EvaluateVisitor__extendModules_closure3(t0) {
                this.originalSelectors = t0;
            },
            _EvaluateVisitor__extendModules_closure4: function _EvaluateVisitor__extendModules_closure4() {},
            _EvaluateVisitor_visitAtRootRule_closure3: function _EvaluateVisitor_visitAtRootRule_closure3(t0, t1) {
                this.$this = t0;
                this.node = t1;
            },
            _EvaluateVisitor_visitAtRootRule_closure4: function _EvaluateVisitor_visitAtRootRule_closure4(t0, t1) {
                this.$this = t0;
                this.node = t1;
            },
            _EvaluateVisitor__scopeForAtRoot_closure11: function _EvaluateVisitor__scopeForAtRoot_closure11(t0, t1, t2) {
                this.$this = t0;
                this.newParent = t1;
                this.node = t2;
            },
            _EvaluateVisitor__scopeForAtRoot_closure12: function _EvaluateVisitor__scopeForAtRoot_closure12(t0, t1) {
                this.$this = t0;
                this.innerScope = t1;
            },
            _EvaluateVisitor__scopeForAtRoot_closure13: function _EvaluateVisitor__scopeForAtRoot_closure13(t0, t1) {
                this.$this = t0;
                this.innerScope = t1;
            },
            _EvaluateVisitor__scopeForAtRoot__closure1: function _EvaluateVisitor__scopeForAtRoot__closure1(t0, t1) {
                this.innerScope = t0;
                this.callback = t1;
            },
            _EvaluateVisitor__scopeForAtRoot_closure14: function _EvaluateVisitor__scopeForAtRoot_closure14(t0, t1) {
                this.$this = t0;
                this.innerScope = t1;
            },
            _EvaluateVisitor__scopeForAtRoot_closure15: function _EvaluateVisitor__scopeForAtRoot_closure15() {},
            _EvaluateVisitor__scopeForAtRoot_closure16: function _EvaluateVisitor__scopeForAtRoot_closure16(t0, t1) {
                this.$this = t0;
                this.innerScope = t1;
            },
            _EvaluateVisitor_visitContentRule_closure1: function _EvaluateVisitor_visitContentRule_closure1(t0, t1) {
                this.$this = t0;
                this.content = t1;
            },
            _EvaluateVisitor_visitDeclaration_closure1: function _EvaluateVisitor_visitDeclaration_closure1(t0, t1) {
                this._box_0 = t0;
                this.$this = t1;
            },
            _EvaluateVisitor_visitEachRule_closure5: function _EvaluateVisitor_visitEachRule_closure5(t0, t1, t2) {
                this._box_0 = t0;
                this.$this = t1;
                this.nodeWithSpan = t2;
            },
            _EvaluateVisitor_visitEachRule_closure6: function _EvaluateVisitor_visitEachRule_closure6(t0, t1, t2) {
                this._box_1 = t0;
                this.$this = t1;
                this.nodeWithSpan = t2;
            },
            _EvaluateVisitor_visitEachRule_closure7: function _EvaluateVisitor_visitEachRule_closure7(t0, t1, t2, t3) {
                var _ = this;
                _.$this = t0;
                _.list = t1;
                _.setVariables = t2;
                _.node = t3;
            },
            _EvaluateVisitor_visitEachRule__closure1: function _EvaluateVisitor_visitEachRule__closure1(t0, t1, t2) {
                this.$this = t0;
                this.setVariables = t1;
                this.node = t2;
            },
            _EvaluateVisitor_visitEachRule___closure1: function _EvaluateVisitor_visitEachRule___closure1(t0) {
                this.$this = t0;
            },
            _EvaluateVisitor_visitAtRule_closure7: function _EvaluateVisitor_visitAtRule_closure7(t0) {
                this.$this = t0;
            },
            _EvaluateVisitor_visitAtRule_closure8: function _EvaluateVisitor_visitAtRule_closure8(t0, t1) {
                this.$this = t0;
                this.children = t1;
            },
            _EvaluateVisitor_visitAtRule_closure9: function _EvaluateVisitor_visitAtRule_closure9(t0, t1, t2) {
                this.$this = t0;
                this.name = t1;
                this.children = t2;
            },
            _EvaluateVisitor_visitAtRule__closure1: function _EvaluateVisitor_visitAtRule__closure1(t0, t1) {
                this.$this = t0;
                this.children = t1;
            },
            _EvaluateVisitor_visitAtRule_closure10: function _EvaluateVisitor_visitAtRule_closure10() {},
            _EvaluateVisitor_visitForRule_closure9: function _EvaluateVisitor_visitForRule_closure9(t0, t1) {
                this.$this = t0;
                this.node = t1;
            },
            _EvaluateVisitor_visitForRule_closure10: function _EvaluateVisitor_visitForRule_closure10(t0, t1) {
                this.$this = t0;
                this.node = t1;
            },
            _EvaluateVisitor_visitForRule_closure11: function _EvaluateVisitor_visitForRule_closure11(t0) {
                this.fromNumber = t0;
            },
            _EvaluateVisitor_visitForRule_closure12: function _EvaluateVisitor_visitForRule_closure12(t0, t1) {
                this.toNumber = t0;
                this.fromNumber = t1;
            },
            _EvaluateVisitor_visitForRule_closure13: function _EvaluateVisitor_visitForRule_closure13(t0, t1, t2, t3, t4, t5) {
                var _ = this;
                _._box_0 = t0;
                _.$this = t1;
                _.node = t2;
                _.from = t3;
                _.direction = t4;
                _.fromNumber = t5;
            },
            _EvaluateVisitor_visitForRule__closure1: function _EvaluateVisitor_visitForRule__closure1(t0) {
                this.$this = t0;
            },
            _EvaluateVisitor_visitForwardRule_closure3: function _EvaluateVisitor_visitForwardRule_closure3(t0, t1) {
                this.$this = t0;
                this.node = t1;
            },
            _EvaluateVisitor_visitForwardRule_closure4: function _EvaluateVisitor_visitForwardRule_closure4(t0, t1) {
                this.$this = t0;
                this.node = t1;
            },
            _EvaluateVisitor__registerCommentsForModule_closure1: function _EvaluateVisitor__registerCommentsForModule_closure1() {},
            _EvaluateVisitor_visitIfRule_closure1: function _EvaluateVisitor_visitIfRule_closure1(t0) {
                this.$this = t0;
            },
            _EvaluateVisitor_visitIfRule__closure1: function _EvaluateVisitor_visitIfRule__closure1(t0, t1) {
                this.$this = t0;
                this.clause = t1;
            },
            _EvaluateVisitor_visitIfRule___closure1: function _EvaluateVisitor_visitIfRule___closure1(t0) {
                this.$this = t0;
            },
            _EvaluateVisitor__visitDynamicImport_closure1: function _EvaluateVisitor__visitDynamicImport_closure1(t0, t1) {
                this.$this = t0;
                this.$import = t1;
            },
            _EvaluateVisitor__visitDynamicImport__closure7: function _EvaluateVisitor__visitDynamicImport__closure7(t0) {
                this.$this = t0;
            },
            _EvaluateVisitor__visitDynamicImport__closure8: function _EvaluateVisitor__visitDynamicImport__closure8() {},
            _EvaluateVisitor__visitDynamicImport__closure9: function _EvaluateVisitor__visitDynamicImport__closure9() {},
            _EvaluateVisitor__visitDynamicImport__closure10: function _EvaluateVisitor__visitDynamicImport__closure10(t0, t1, t2, t3, t4) {
                var _ = this;
                _._box_0 = t0;
                _.$this = t1;
                _.loadsUserDefinedModules = t2;
                _.environment = t3;
                _.children = t4;
            },
            _EvaluateVisitor__applyMixin_closure3: function _EvaluateVisitor__applyMixin_closure3(t0, t1, t2, t3) {
                var _ = this;
                _.$this = t0;
                _.$arguments = t1;
                _.mixin = t2;
                _.nodeWithSpanWithoutContent = t3;
            },
            _EvaluateVisitor__applyMixin__closure4: function _EvaluateVisitor__applyMixin__closure4(t0, t1, t2, t3) {
                var _ = this;
                _.$this = t0;
                _.$arguments = t1;
                _.mixin = t2;
                _.nodeWithSpanWithoutContent = t3;
            },
            _EvaluateVisitor__applyMixin_closure4: function _EvaluateVisitor__applyMixin_closure4(t0, t1, t2, t3) {
                var _ = this;
                _.$this = t0;
                _.contentCallable = t1;
                _.mixin = t2;
                _.nodeWithSpanWithoutContent = t3;
            },
            _EvaluateVisitor__applyMixin__closure3: function _EvaluateVisitor__applyMixin__closure3(t0, t1, t2) {
                this.$this = t0;
                this.mixin = t1;
                this.nodeWithSpanWithoutContent = t2;
            },
            _EvaluateVisitor__applyMixin___closure1: function _EvaluateVisitor__applyMixin___closure1(t0, t1, t2) {
                this.$this = t0;
                this.mixin = t1;
                this.nodeWithSpanWithoutContent = t2;
            },
            _EvaluateVisitor__applyMixin____closure1: function _EvaluateVisitor__applyMixin____closure1(t0, t1) {
                this.$this = t0;
                this.statement = t1;
            },
            _EvaluateVisitor_visitIncludeRule_closure5: function _EvaluateVisitor_visitIncludeRule_closure5(t0, t1) {
                this.$this = t0;
                this.node = t1;
            },
            _EvaluateVisitor_visitIncludeRule_closure6: function _EvaluateVisitor_visitIncludeRule_closure6(t0) {
                this.$this = t0;
            },
            _EvaluateVisitor_visitIncludeRule_closure7: function _EvaluateVisitor_visitIncludeRule_closure7(t0) {
                this.node = t0;
            },
            _EvaluateVisitor_visitMediaRule_closure7: function _EvaluateVisitor_visitMediaRule_closure7(t0, t1) {
                this.$this = t0;
                this.node = t1;
            },
            _EvaluateVisitor_visitMediaRule_closure8: function _EvaluateVisitor_visitMediaRule_closure8(t0, t1) {
                this.$this = t0;
                this.queries = t1;
            },
            _EvaluateVisitor_visitMediaRule_closure9: function _EvaluateVisitor_visitMediaRule_closure9(t0, t1, t2, t3, t4) {
                var _ = this;
                _.$this = t0;
                _.mergedQueries = t1;
                _.queries = t2;
                _.mergedSources = t3;
                _.node = t4;
            },
            _EvaluateVisitor_visitMediaRule__closure1: function _EvaluateVisitor_visitMediaRule__closure1(t0, t1) {
                this.$this = t0;
                this.node = t1;
            },
            _EvaluateVisitor_visitMediaRule___closure1: function _EvaluateVisitor_visitMediaRule___closure1(t0, t1) {
                this.$this = t0;
                this.node = t1;
            },
            _EvaluateVisitor_visitMediaRule_closure10: function _EvaluateVisitor_visitMediaRule_closure10(t0) {
                this.mergedSources = t0;
            },
            _EvaluateVisitor_visitStyleRule_closure7: function _EvaluateVisitor_visitStyleRule_closure7(t0, t1) {
                this.$this = t0;
                this.node = t1;
            },
            _EvaluateVisitor_visitStyleRule_closure8: function _EvaluateVisitor_visitStyleRule_closure8() {},
            _EvaluateVisitor_visitStyleRule_closure10: function _EvaluateVisitor_visitStyleRule_closure10(t0, t1, t2) {
                this.$this = t0;
                this.rule = t1;
                this.node = t2;
            },
            _EvaluateVisitor_visitStyleRule__closure1: function _EvaluateVisitor_visitStyleRule__closure1(t0, t1) {
                this.$this = t0;
                this.node = t1;
            },
            _EvaluateVisitor_visitStyleRule_closure9: function _EvaluateVisitor_visitStyleRule_closure9() {},
            _EvaluateVisitor__warnForBogusCombinators_closure1: function _EvaluateVisitor__warnForBogusCombinators_closure1() {},
            _EvaluateVisitor_visitSupportsRule_closure5: function _EvaluateVisitor_visitSupportsRule_closure5(t0, t1) {
                this.$this = t0;
                this.node = t1;
            },
            _EvaluateVisitor_visitSupportsRule_closure6: function _EvaluateVisitor_visitSupportsRule_closure6(t0, t1) {
                this.$this = t0;
                this.node = t1;
            },
            _EvaluateVisitor_visitSupportsRule__closure1: function _EvaluateVisitor_visitSupportsRule__closure1(t0, t1) {
                this.$this = t0;
                this.node = t1;
            },
            _EvaluateVisitor_visitSupportsRule_closure7: function _EvaluateVisitor_visitSupportsRule_closure7() {},
            _EvaluateVisitor__visitSupportsCondition_closure1: function _EvaluateVisitor__visitSupportsCondition_closure1(t0, t1) {
                this._box_0 = t0;
                this.$this = t1;
            },
            _EvaluateVisitor_visitVariableDeclaration_closure5: function _EvaluateVisitor_visitVariableDeclaration_closure5(t0, t1, t2) {
                this._box_0 = t0;
                this.$this = t1;
                this.node = t2;
            },
            _EvaluateVisitor_visitVariableDeclaration_closure6: function _EvaluateVisitor_visitVariableDeclaration_closure6(t0, t1) {
                this.$this = t0;
                this.node = t1;
            },
            _EvaluateVisitor_visitVariableDeclaration_closure7: function _EvaluateVisitor_visitVariableDeclaration_closure7(t0, t1, t2) {
                this.$this = t0;
                this.node = t1;
                this.value = t2;
            },
            _EvaluateVisitor_visitUseRule_closure1: function _EvaluateVisitor_visitUseRule_closure1(t0, t1) {
                this.$this = t0;
                this.node = t1;
            },
            _EvaluateVisitor_visitWarnRule_closure1: function _EvaluateVisitor_visitWarnRule_closure1(t0, t1) {
                this.$this = t0;
                this.node = t1;
            },
            _EvaluateVisitor_visitWhileRule_closure1: function _EvaluateVisitor_visitWhileRule_closure1(t0, t1) {
                this.$this = t0;
                this.node = t1;
            },
            _EvaluateVisitor_visitWhileRule__closure1: function _EvaluateVisitor_visitWhileRule__closure1(t0) {
                this.$this = t0;
            },
            _EvaluateVisitor_visitBinaryOperationExpression_closure1: function _EvaluateVisitor_visitBinaryOperationExpression_closure1(t0, t1) {
                this.$this = t0;
                this.node = t1;
            },
            _EvaluateVisitor__slash_recommendation1: function _EvaluateVisitor__slash_recommendation1() {},
            _EvaluateVisitor_visitVariableExpression_closure1: function _EvaluateVisitor_visitVariableExpression_closure1(t0, t1) {
                this.$this = t0;
                this.node = t1;
            },
            _EvaluateVisitor_visitUnaryOperationExpression_closure1: function _EvaluateVisitor_visitUnaryOperationExpression_closure1(t0, t1) {
                this.node = t0;
                this.operand = t1;
            },
            _EvaluateVisitor_visitIfExpression_closure1: function _EvaluateVisitor_visitIfExpression_closure1() {},
            _EvaluateVisitor_visitIfConditionOperation_closure1: function _EvaluateVisitor_visitIfConditionOperation_closure1() {},
            _EvaluateVisitor_visitListExpression_closure1: function _EvaluateVisitor_visitListExpression_closure1(t0) {
                this.$this = t0;
            },
            _EvaluateVisitor_visitFunctionExpression_closure5: function _EvaluateVisitor_visitFunctionExpression_closure5(t0, t1) {
                this.$this = t0;
                this.node = t1;
            },
            _EvaluateVisitor_visitFunctionExpression_closure6: function _EvaluateVisitor_visitFunctionExpression_closure6() {},
            _EvaluateVisitor_visitFunctionExpression_closure7: function _EvaluateVisitor_visitFunctionExpression_closure7(t0, t1, t2) {
                this._box_0 = t0;
                this.$this = t1;
                this.node = t2;
            },
            _EvaluateVisitor__visitCalculation_closure1: function _EvaluateVisitor__visitCalculation_closure1(t0, t1) {
                this.$this = t0;
                this.node = t1;
            },
            _EvaluateVisitor__checkCalculationArguments_check1: function _EvaluateVisitor__checkCalculationArguments_check1(t0, t1) {
                this.$this = t0;
                this.node = t1;
            },
            _EvaluateVisitor__visitCalculationExpression_closure1: function _EvaluateVisitor__visitCalculationExpression_closure1(t0, t1, t2, t3) {
                var _ = this;
                _._box_0 = t0;
                _.$this = t1;
                _.node = t2;
                _.inLegacySassFunction = t3;
            },
            _EvaluateVisitor__visitCalculationExpression__closure1: function _EvaluateVisitor__visitCalculationExpression__closure1(t0, t1) {
                this.$this = t0;
                this.node = t1;
            },
            _EvaluateVisitor_visitInterpolatedFunctionExpression_closure1: function _EvaluateVisitor_visitInterpolatedFunctionExpression_closure1(t0, t1, t2) {
                this.$this = t0;
                this.node = t1;
                this.$function = t2;
            },
            _EvaluateVisitor__runUserDefinedCallable_closure1: function _EvaluateVisitor__runUserDefinedCallable_closure1(t0, t1, t2, t3, t4, t5) {
                var _ = this;
                _.$this = t0;
                _.callable = t1;
                _.evaluated = t2;
                _.nodeWithSpan = t3;
                _.run = t4;
                _.V = t5;
            },
            _EvaluateVisitor__runUserDefinedCallable__closure1: function _EvaluateVisitor__runUserDefinedCallable__closure1(t0, t1, t2, t3, t4, t5) {
                var _ = this;
                _.$this = t0;
                _.evaluated = t1;
                _.callable = t2;
                _.nodeWithSpan = t3;
                _.run = t4;
                _.V = t5;
            },
            _EvaluateVisitor__runUserDefinedCallable___closure1: function _EvaluateVisitor__runUserDefinedCallable___closure1(t0, t1, t2, t3, t4, t5) {
                var _ = this;
                _.$this = t0;
                _.evaluated = t1;
                _.callable = t2;
                _.nodeWithSpan = t3;
                _.run = t4;
                _.V = t5;
            },
            _EvaluateVisitor__runUserDefinedCallable____closure1: function _EvaluateVisitor__runUserDefinedCallable____closure1() {},
            _EvaluateVisitor__runFunctionCallable_closure1: function _EvaluateVisitor__runFunctionCallable_closure1(t0, t1) {
                this.$this = t0;
                this.callable = t1;
            },
            _EvaluateVisitor__runBuiltInCallable_closure5: function _EvaluateVisitor__runBuiltInCallable_closure5(t0, t1, t2) {
                this._box_0 = t0;
                this.evaluated = t1;
                this.namedSet = t2;
            },
            _EvaluateVisitor__runBuiltInCallable_closure6: function _EvaluateVisitor__runBuiltInCallable_closure6(t0, t1) {
                this._box_0 = t0;
                this.evaluated = t1;
            },
            _EvaluateVisitor__runBuiltInCallable_closure7: function _EvaluateVisitor__runBuiltInCallable_closure7() {},
            _EvaluateVisitor__evaluateArguments_closure7: function _EvaluateVisitor__evaluateArguments_closure7() {},
            _EvaluateVisitor__evaluateArguments_closure8: function _EvaluateVisitor__evaluateArguments_closure8(t0, t1) {
                this.$this = t0;
                this.restNodeForSpan = t1;
            },
            _EvaluateVisitor__evaluateArguments_closure9: function _EvaluateVisitor__evaluateArguments_closure9(t0, t1, t2, t3) {
                var _ = this;
                _.$this = t0;
                _.named = t1;
                _.restNodeForSpan = t2;
                _.namedNodes = t3;
            },
            _EvaluateVisitor__evaluateArguments_closure10: function _EvaluateVisitor__evaluateArguments_closure10() {},
            _EvaluateVisitor__evaluateMacroArguments_closure7: function _EvaluateVisitor__evaluateMacroArguments_closure7(t0) {
                this.restArgs = t0;
            },
            _EvaluateVisitor__evaluateMacroArguments_closure8: function _EvaluateVisitor__evaluateMacroArguments_closure8(t0, t1, t2) {
                this.$this = t0;
                this.restNodeForSpan = t1;
                this.restArgs = t2;
            },
            _EvaluateVisitor__evaluateMacroArguments_closure9: function _EvaluateVisitor__evaluateMacroArguments_closure9(t0, t1, t2, t3) {
                var _ = this;
                _.$this = t0;
                _.named = t1;
                _.restNodeForSpan = t2;
                _.restArgs = t3;
            },
            _EvaluateVisitor__evaluateMacroArguments_closure10: function _EvaluateVisitor__evaluateMacroArguments_closure10(t0, t1, t2) {
                this.$this = t0;
                this.keywordRestNodeForSpan = t1;
                this.keywordRestArgs = t2;
            },
            _EvaluateVisitor__addRestMap_closure1: function _EvaluateVisitor__addRestMap_closure1(t0, t1, t2, t3, t4, t5) {
                var _ = this;
                _.$this = t0;
                _.values = t1;
                _.convert = t2;
                _.expressionNode = t3;
                _.map = t4;
                _.nodeWithSpan = t5;
            },
            _EvaluateVisitor__verifyArguments_closure1: function _EvaluateVisitor__verifyArguments_closure1(t0, t1, t2) {
                this.parameters = t0;
                this.positional = t1;
                this.named = t2;
            },
            _EvaluateVisitor_visitCssAtRule_closure5: function _EvaluateVisitor_visitCssAtRule_closure5(t0, t1) {
                this.$this = t0;
                this.node = t1;
            },
            _EvaluateVisitor_visitCssAtRule_closure6: function _EvaluateVisitor_visitCssAtRule_closure6(t0, t1) {
                this.$this = t0;
                this.node = t1;
            },
            _EvaluateVisitor_visitCssAtRule_closure7: function _EvaluateVisitor_visitCssAtRule_closure7() {},
            _EvaluateVisitor_visitCssKeyframeBlock_closure3: function _EvaluateVisitor_visitCssKeyframeBlock_closure3(t0, t1) {
                this.$this = t0;
                this.node = t1;
            },
            _EvaluateVisitor_visitCssKeyframeBlock_closure4: function _EvaluateVisitor_visitCssKeyframeBlock_closure4() {},
            _EvaluateVisitor_visitCssMediaRule_closure7: function _EvaluateVisitor_visitCssMediaRule_closure7(t0, t1) {
                this.$this = t0;
                this.node = t1;
            },
            _EvaluateVisitor_visitCssMediaRule_closure8: function _EvaluateVisitor_visitCssMediaRule_closure8(t0, t1) {
                this.$this = t0;
                this.node = t1;
            },
            _EvaluateVisitor_visitCssMediaRule_closure9: function _EvaluateVisitor_visitCssMediaRule_closure9(t0, t1, t2, t3) {
                var _ = this;
                _.$this = t0;
                _.mergedQueries = t1;
                _.node = t2;
                _.mergedSources = t3;
            },
            _EvaluateVisitor_visitCssMediaRule__closure1: function _EvaluateVisitor_visitCssMediaRule__closure1(t0, t1) {
                this.$this = t0;
                this.node = t1;
            },
            _EvaluateVisitor_visitCssMediaRule___closure1: function _EvaluateVisitor_visitCssMediaRule___closure1(t0, t1) {
                this.$this = t0;
                this.node = t1;
            },
            _EvaluateVisitor_visitCssMediaRule_closure10: function _EvaluateVisitor_visitCssMediaRule_closure10(t0) {
                this.mergedSources = t0;
            },
            _EvaluateVisitor_visitCssStyleRule_closure4: function _EvaluateVisitor_visitCssStyleRule_closure4(t0, t1, t2) {
                this.$this = t0;
                this.rule = t1;
                this.node = t2;
            },
            _EvaluateVisitor_visitCssStyleRule__closure1: function _EvaluateVisitor_visitCssStyleRule__closure1(t0, t1) {
                this.$this = t0;
                this.node = t1;
            },
            _EvaluateVisitor_visitCssStyleRule_closure3: function _EvaluateVisitor_visitCssStyleRule_closure3() {},
            _EvaluateVisitor_visitCssSupportsRule_closure5: function _EvaluateVisitor_visitCssSupportsRule_closure5(t0, t1) {
                this.$this = t0;
                this.node = t1;
            },
            _EvaluateVisitor_visitCssSupportsRule_closure6: function _EvaluateVisitor_visitCssSupportsRule_closure6(t0, t1) {
                this.$this = t0;
                this.node = t1;
            },
            _EvaluateVisitor_visitCssSupportsRule__closure1: function _EvaluateVisitor_visitCssSupportsRule__closure1(t0, t1) {
                this.$this = t0;
                this.node = t1;
            },
            _EvaluateVisitor_visitCssSupportsRule_closure7: function _EvaluateVisitor_visitCssSupportsRule_closure7() {},
            _EvaluateVisitor__performInterpolationHelper_closure1: function _EvaluateVisitor__performInterpolationHelper_closure1(t0) {
                this.interpolation = t0;
            },
            _EvaluateVisitor__serialize_closure1: function _EvaluateVisitor__serialize_closure1(t0, t1) {
                this.value = t0;
                this.quote = t1;
            },
            _EvaluateVisitor__expressionNode_closure1: function _EvaluateVisitor__expressionNode_closure1(t0, t1) {
                this.$this = t0;
                this.expression = t1;
            },
            _EvaluateVisitor__withoutSlash_recommendation1: function _EvaluateVisitor__withoutSlash_recommendation1() {},
            _EvaluateVisitor__stackFrame_closure1: function _EvaluateVisitor__stackFrame_closure1(t0) {
                this.$this = t0;
            },
            _ImportedCssVisitor1: function _ImportedCssVisitor1(t0) {
                this._evaluate0$_visitor = t0;
            },
            _ImportedCssVisitor_visitCssAtRule_closure1: function _ImportedCssVisitor_visitCssAtRule_closure1() {},
            _ImportedCssVisitor_visitCssMediaRule_closure1: function _ImportedCssVisitor_visitCssMediaRule_closure1(t0) {
                this.hasBeenMerged = t0;
            },
            _ImportedCssVisitor_visitCssStyleRule_closure1: function _ImportedCssVisitor_visitCssStyleRule_closure1() {},
            _ImportedCssVisitor_visitCssSupportsRule_closure1: function _ImportedCssVisitor_visitCssSupportsRule_closure1() {},
            _EvaluationContext1: function _EvaluationContext1(t0, t1) {
                this._evaluate0$_visitor = t0;
                this._evaluate0$_defaultWarnNodeWithSpan = t1;
            },
            EvaluationContext_currentOrNull0: function() {
                var t1, _0_0 = $.Zone__current.$index(0, B.Symbol__evaluationContext);
                $label0$0: {
                    if (_0_0 instanceof A.EvaluationContext0) {
                        t1 = _0_0;
                        break $label0$0;
                    }
                    t1 = null;
                    break $label0$0;
                }
                return t1;
            },
            EvaluationContext__currentOrNull: function() {
                var _0_0 = $.Zone__current.$index(0, B.Symbol__evaluationContext);
                if (_0_0 instanceof A.EvaluationContext0) return _0_0;
                else return null;
            },
            warn0: function(message) {
                var t1, _null = null, _0_0 = A.EvaluationContext_currentOrNull0();
                $label0$0: {
                    if (_0_0 != null) {
                        t1 = _0_0.warn$2(0, message, _null);
                        break $label0$0;
                    }
                    B.C_DefaultLogger0.internalWarn$4$deprecation$span$trace(message, _null, _null, _null);
                    t1 = _null;
                    break $label0$0;
                }
                return t1;
            },
            warnForDeprecation0: function(message, deprecation) {
                var t1, _0_0 = A.EvaluationContext_currentOrNull0();
                $label0$0: {
                    if (_0_0 != null) {
                        t1 = _0_0.warn$2(0, message, deprecation);
                        break $label0$0;
                    }
                    t1 = A.WarnForDeprecation_warnForDeprecation0(B.C_DefaultLogger0, deprecation, message, null, null);
                    break $label0$0;
                }
                return t1;
            },
            warnForDeprecationFromApi: function(message, deprecation) {
                var _0_0 = A.EvaluationContext__currentOrNull();
                if (_0_0 != null) _0_0.warn$2(0, message, deprecation);
                else A.WarnForDeprecation_warnForDeprecation0(B.C_DefaultLogger0, deprecation, message, null, null);
            },
            EvaluationContext0: function EvaluationContext0() {},
            _EvaluationContextLogger0: function _EvaluationContextLogger0(t0) {
                this._evaluation_context0$_context = t0;
            },
            EveryCssVisitor0: function EveryCssVisitor0() {},
            EveryCssVisitor_visitCssAtRule_closure0: function EveryCssVisitor_visitCssAtRule_closure0(t0) {
                this.$this = t0;
            },
            EveryCssVisitor_visitCssKeyframeBlock_closure0: function EveryCssVisitor_visitCssKeyframeBlock_closure0(t0) {
                this.$this = t0;
            },
            EveryCssVisitor_visitCssMediaRule_closure0: function EveryCssVisitor_visitCssMediaRule_closure0(t0) {
                this.$this = t0;
            },
            EveryCssVisitor_visitCssStyleRule_closure0: function EveryCssVisitor_visitCssStyleRule_closure0(t0) {
                this.$this = t0;
            },
            EveryCssVisitor_visitCssStylesheet_closure0: function EveryCssVisitor_visitCssStylesheet_closure0(t0) {
                this.$this = t0;
            },
            EveryCssVisitor_visitCssSupportsRule_closure0: function EveryCssVisitor_visitCssSupportsRule_closure0(t0) {
                this.$this = t0;
            },
            throwNodeException: function(exception, ascii, color, trace) {
                var wasAscii, jsException, t1, trace0;
                trace;
                wasAscii = $._glyphs === B.C_AsciiGlyphSet;
                $._glyphs = ascii ? B.C_AsciiGlyphSet : B.C_UnicodeGlyphSet;
                try {
                    t1 = A.callConstructor($.$get$exceptionClass(), [
                        exception,
                        B.JSString_methods.replaceFirst$2(exception.toString$1$color(0, color), "Error: ", "")
                    ]);
                    jsException = type$._NodeException._as(t1);
                    trace0 = A.getTrace0(exception);
                    trace = trace0 == null ? trace : trace0;
                    if (trace != null) A.attachJsStack(jsException, trace);
                    A.jsThrow(jsException);
                } finally{
                    $._glyphs = wasAscii ? B.C_AsciiGlyphSet : B.C_UnicodeGlyphSet;
                }
            },
            _NodeException: function _NodeException() {},
            exceptionClass_closure: function exceptionClass_closure() {},
            exceptionClass__closure: function exceptionClass__closure() {},
            exceptionClass__closure0: function exceptionClass__closure0() {},
            exceptionClass__closure1: function exceptionClass__closure1() {},
            SassException$0: function(message, span, loadedUrls) {
                return new A.SassException0(loadedUrls == null ? B.Set_empty : A.Set_Set$unmodifiable(loadedUrls, type$.Uri), message, span);
            },
            MultiSpanSassException$0: function(message, span, primaryLabel, secondarySpans, loadedUrls) {
                var t1 = A.ConstantMap_ConstantMap$from(secondarySpans, type$.FileSpan, type$.String);
                return new A.MultiSpanSassException0(primaryLabel, t1, loadedUrls == null ? B.Set_empty : A.Set_Set$unmodifiable(loadedUrls, type$.Uri), message, span);
            },
            SassRuntimeException$0: function(message, span, trace, loadedUrls) {
                return new A.SassRuntimeException0(trace, loadedUrls == null ? B.Set_empty : A.Set_Set$unmodifiable(loadedUrls, type$.Uri), message, span);
            },
            MultiSpanSassRuntimeException$0: function(message, span, primaryLabel, secondarySpans, trace, loadedUrls) {
                var t1 = A.ConstantMap_ConstantMap$from(secondarySpans, type$.FileSpan, type$.String);
                return new A.MultiSpanSassRuntimeException0(trace, primaryLabel, t1, loadedUrls == null ? B.Set_empty : A.Set_Set$unmodifiable(loadedUrls, type$.Uri), message, span);
            },
            SassFormatException$0: function(message, span, loadedUrls) {
                return new A.SassFormatException0(loadedUrls == null ? B.Set_empty : A.Set_Set$unmodifiable(loadedUrls, type$.Uri), message, span);
            },
            MultiSpanSassFormatException$0: function(message, span, primaryLabel, secondarySpans, loadedUrls) {
                var t1 = A.ConstantMap_ConstantMap$from(secondarySpans, type$.FileSpan, type$.String);
                return new A.MultiSpanSassFormatException0(primaryLabel, t1, loadedUrls == null ? B.Set_empty : A.Set_Set$unmodifiable(loadedUrls, type$.Uri), message, span);
            },
            SassScriptException$0: function(message, argumentName) {
                return new A.SassScriptException0(argumentName == null ? message : "$" + argumentName + ": " + message);
            },
            MultiSpanSassScriptException$0: function(message, primaryLabel, secondarySpans) {
                var t1 = A.ConstantMap_ConstantMap$from(secondarySpans, type$.FileSpan, type$.String);
                return new A.MultiSpanSassScriptException0(primaryLabel, t1, message);
            },
            SassException0: function SassException0(t0, t1, t2) {
                this.loadedUrls = t0;
                this._span_exception$_message = t1;
                this._span = t2;
            },
            MultiSpanSassException0: function MultiSpanSassException0(t0, t1, t2, t3, t4) {
                var _ = this;
                _.primaryLabel = t0;
                _.secondarySpans = t1;
                _.loadedUrls = t2;
                _._span_exception$_message = t3;
                _._span = t4;
            },
            SassRuntimeException0: function SassRuntimeException0(t0, t1, t2, t3) {
                var _ = this;
                _.trace = t0;
                _.loadedUrls = t1;
                _._span_exception$_message = t2;
                _._span = t3;
            },
            MultiSpanSassRuntimeException0: function MultiSpanSassRuntimeException0(t0, t1, t2, t3, t4, t5) {
                var _ = this;
                _.trace = t0;
                _.primaryLabel = t1;
                _.secondarySpans = t2;
                _.loadedUrls = t3;
                _._span_exception$_message = t4;
                _._span = t5;
            },
            SassFormatException0: function SassFormatException0(t0, t1, t2) {
                this.loadedUrls = t0;
                this._span_exception$_message = t1;
                this._span = t2;
            },
            MultiSpanSassFormatException0: function MultiSpanSassFormatException0(t0, t1, t2, t3, t4) {
                var _ = this;
                _.primaryLabel = t0;
                _.secondarySpans = t1;
                _.loadedUrls = t2;
                _._span_exception$_message = t3;
                _._span = t4;
            },
            SassScriptException0: function SassScriptException0(t0) {
                this.message = t0;
            },
            MultiSpanSassScriptException0: function MultiSpanSassScriptException0(t0, t1, t2) {
                this.primaryLabel = t0;
                this.secondarySpans = t1;
                this.message = t2;
            },
            Exports: function Exports() {},
            LoggerNamespace: function LoggerNamespace() {},
            Expression0: function Expression0() {},
            JSExpressionVisitor: function JSExpressionVisitor(t0) {
                this._expression$_inner = t0;
            },
            JSExpressionVisitorObject: function JSExpressionVisitorObject() {},
            expressionToCalc0: function(expression) {
                var t1 = A.ArgumentList$0(A._setArrayType([
                    B.C__MakeExpressionCalculationSafe0.visitBinaryOperationExpression$1(0, expression)
                ], type$.JSArray_Expression_2), B.Map_empty14, B.Map_empty5, expression.get$span(0), null, null), t2 = expression.get$span(0);
                return new A.FunctionExpression0(null, A.stringReplaceAllUnchecked("calc", "_", "-"), "calc", t1, t2);
            },
            _MakeExpressionCalculationSafe0: function _MakeExpressionCalculationSafe0() {},
            __MakeExpressionCalculationSafe_Object_ReplaceExpressionVisitor0: function __MakeExpressionCalculationSafe_Object_ReplaceExpressionVisitor0() {},
            ExtendRule0: function ExtendRule0(t0, t1, t2) {
                this.selector = t0;
                this.isOptional = t1;
                this.span = t2;
            },
            Extension0: function Extension0(t0, t1, t2, t3, t4) {
                var _ = this;
                _.extender = t0;
                _.target = t1;
                _.mediaContext = t2;
                _.isOptional = t3;
                _.span = t4;
            },
            Extender0: function Extender0(t0, t1) {
                this.selector = t0;
                this.isOriginal = t1;
                this._extension$_extension = null;
            },
            ExtensionStore__extendOrReplace0: function(selector, source, targets, mode, span) {
                var t1, t2, t3, t4, t5, t6, t7, t8, _i, complex, compound, t9, t10, t11, _i0, simple, t12, _i1, t13, t14, extender = A.ExtensionStore$_mode0(mode);
                if (!selector.accept$1(B._IsInvisibleVisitor_true0)) extender._extension_store$_originals.addAll$1(0, selector.components);
                for(t1 = targets.components, t2 = t1.length, t3 = source.components, t4 = t3.length, t5 = type$.ComplexSelector_2, t6 = type$.Extension_2, t7 = type$.SimpleSelector_2, t8 = type$.Map_ComplexSelector_Extension_2, _i = 0; _i < t2; ++_i){
                    complex = t1[_i];
                    compound = complex.get$singleCompound();
                    if (compound == null) throw A.wrapException(A.SassScriptException$0("Can't extend complex selector " + complex.toString$0(0) + ".", null));
                    t9 = A.LinkedHashMap_LinkedHashMap$_empty(t7, t8);
                    for(t10 = compound.components, t11 = t10.length, _i0 = 0; _i0 < t11; ++_i0){
                        simple = t10[_i0];
                        t12 = A.LinkedHashMap_LinkedHashMap$_empty(t5, t6);
                        for(_i1 = 0; _i1 < t4; ++_i1){
                            complex = t3[_i1];
                            complex.get$specificity();
                            t13 = new A.Extender0(complex, false);
                            t14 = new A.Extension0(t13, simple, null, true, span);
                            t13._extension$_extension = t14;
                            t12.$indexSet(0, complex, t14);
                        }
                        t9.$indexSet(0, simple, t12);
                    }
                    selector = extender._extension_store$_extendList$2(selector, t9);
                }
                return selector;
            },
            ExtensionStore$0: function() {
                var t1 = type$.SimpleSelector_2;
                return new A.ExtensionStore0(A.LinkedHashMap_LinkedHashMap$_empty(t1, type$.Set_ModifiableBox_SelectorList_2), A.LinkedHashMap_LinkedHashMap$_empty(t1, type$.Map_ComplexSelector_Extension_2), A.LinkedHashMap_LinkedHashMap$_empty(t1, type$.List_Extension_2), A.LinkedHashMap_LinkedHashMap$_empty(type$.ModifiableBox_SelectorList_2, type$.List_CssMediaQuery_2), new A.JsIdentityLinkedHashMap(type$.JsIdentityLinkedHashMap_SimpleSelector_int_2), new A._LinkedIdentityHashSet(type$._LinkedIdentityHashSet_ComplexSelector_2), B.ExtendMode_normal_0_normal0);
            },
            ExtensionStore$_mode0: function(_mode) {
                var t1 = type$.SimpleSelector_2;
                return new A.ExtensionStore0(A.LinkedHashMap_LinkedHashMap$_empty(t1, type$.Set_ModifiableBox_SelectorList_2), A.LinkedHashMap_LinkedHashMap$_empty(t1, type$.Map_ComplexSelector_Extension_2), A.LinkedHashMap_LinkedHashMap$_empty(t1, type$.List_Extension_2), A.LinkedHashMap_LinkedHashMap$_empty(type$.ModifiableBox_SelectorList_2, type$.List_CssMediaQuery_2), new A.JsIdentityLinkedHashMap(type$.JsIdentityLinkedHashMap_SimpleSelector_int_2), new A._LinkedIdentityHashSet(type$._LinkedIdentityHashSet_ComplexSelector_2), _mode);
            },
            ExtensionStore0: function ExtensionStore0(t0, t1, t2, t3, t4, t5, t6) {
                var _ = this;
                _._extension_store$_selectors = t0;
                _._extension_store$_extensions = t1;
                _._extension_store$_extensionsByExtender = t2;
                _._extension_store$_mediaContexts = t3;
                _._extension_store$_sourceSpecificity = t4;
                _._extension_store$_originals = t5;
                _._extension_store$_mode = t6;
            },
            ExtensionStore_extensionsWhereTarget_closure0: function ExtensionStore_extensionsWhereTarget_closure0() {},
            ExtensionStore__registerSelector_closure0: function ExtensionStore__registerSelector_closure0() {},
            ExtensionStore_addExtension_closure2: function ExtensionStore_addExtension_closure2() {},
            ExtensionStore_addExtension_closure3: function ExtensionStore_addExtension_closure3() {},
            ExtensionStore_addExtension_closure4: function ExtensionStore_addExtension_closure4(t0) {
                this.complex = t0;
            },
            ExtensionStore__extendExistingExtensions_closure1: function ExtensionStore__extendExistingExtensions_closure1() {},
            ExtensionStore__extendExistingExtensions_closure2: function ExtensionStore__extendExistingExtensions_closure2() {},
            ExtensionStore_addExtensions_closure0: function ExtensionStore_addExtensions_closure0() {},
            ExtensionStore__extendComplex_closure0: function ExtensionStore__extendComplex_closure0(t0, t1, t2) {
                this._box_0 = t0;
                this.$this = t1;
                this.complex = t2;
            },
            ExtensionStore__extendComplex__closure0: function ExtensionStore__extendComplex__closure0(t0, t1, t2) {
                this._box_0 = t0;
                this.$this = t1;
                this.complex = t2;
            },
            ExtensionStore__extendCompound_closure2: function ExtensionStore__extendCompound_closure2() {},
            ExtensionStore__extendCompound_closure3: function ExtensionStore__extendCompound_closure3() {},
            ExtensionStore__extendCompound_closure4: function ExtensionStore__extendCompound_closure4(t0) {
                this.original = t0;
            },
            ExtensionStore__extendSimple_withoutPseudo0: function ExtensionStore__extendSimple_withoutPseudo0(t0, t1, t2) {
                this.$this = t0;
                this.extensions = t1;
                this.targetsUsed = t2;
            },
            ExtensionStore__extendSimple_closure1: function ExtensionStore__extendSimple_closure1(t0, t1) {
                this.$this = t0;
                this.withoutPseudo = t1;
            },
            ExtensionStore__extendSimple_closure2: function ExtensionStore__extendSimple_closure2() {},
            ExtensionStore__extendPseudo_closure4: function ExtensionStore__extendPseudo_closure4() {},
            ExtensionStore__extendPseudo_closure5: function ExtensionStore__extendPseudo_closure5() {},
            ExtensionStore__extendPseudo_closure6: function ExtensionStore__extendPseudo_closure6() {},
            ExtensionStore__extendPseudo_closure7: function ExtensionStore__extendPseudo_closure7(t0) {
                this.pseudo = t0;
            },
            ExtensionStore__extendPseudo_closure8: function ExtensionStore__extendPseudo_closure8(t0, t1) {
                this.pseudo = t0;
                this.selector = t1;
            },
            ExtensionStore__trim_closure1: function ExtensionStore__trim_closure1(t0, t1) {
                this._box_0 = t0;
                this.complex1 = t1;
            },
            ExtensionStore__trim_closure2: function ExtensionStore__trim_closure2(t0, t1) {
                this._box_0 = t0;
                this.complex1 = t1;
            },
            ExtensionStore_clone_closure0: function ExtensionStore_clone_closure0(t0, t1, t2, t3, t4) {
                var _ = this;
                _.$this = t0;
                _.newSelectors = t1;
                _.newBoxes = t2;
                _.oldToNewSelectors = t3;
                _.newMediaContexts = t4;
            },
            ExtensionStore_clone__closure0: function ExtensionStore_clone__closure0(t0) {
                this.selector = t0;
            },
            FiberClass: function FiberClass() {},
            Fiber: function Fiber() {},
            JSToDartFileImporter: function JSToDartFileImporter(t0) {
                this._file0$_findFileUrl = t0;
            },
            JSToDartFileImporter_canonicalize_closure: function JSToDartFileImporter_canonicalize_closure(t0, t1) {
                this.$this = t0;
                this.url = t1;
            },
            FilesystemImporter0: function FilesystemImporter0(t0, t1) {
                this._filesystem$_loadPath = t0;
                this._filesystem$_loadPathDeprecated = t1;
            },
            FilesystemImporter_canonicalize_closure0: function FilesystemImporter_canonicalize_closure0() {},
            ForRule$0: function(variable, from, to, children, span, exclusive) {
                var t1 = A.List_List$unmodifiable(children, type$.Statement_2), t2 = B.JSArray_methods.any$1(t1, new A.ParentStatement_closure0());
                return new A.ForRule0(variable, from, to, exclusive, span, t1, t2);
            },
            ForRule0: function ForRule0(t0, t1, t2, t3, t4, t5, t6) {
                var _ = this;
                _.variable = t0;
                _.from = t1;
                _.to = t2;
                _.isExclusive = t3;
                _.span = t4;
                _.children = t5;
                _.hasDeclarations = t6;
            },
            ForwardRule0: function ForwardRule0(t0, t1, t2, t3, t4, t5, t6, t7) {
                var _ = this;
                _.url = t0;
                _.shownMixinsAndFunctions = t1;
                _.shownVariables = t2;
                _.hiddenMixinsAndFunctions = t3;
                _.hiddenVariables = t4;
                _.prefix = t5;
                _.configuration = t6;
                _.span = t7;
            },
            ForwardedModuleView_ifNecessary0: function(inner, rule, $T) {
                var t2, t1 = false;
                if (rule.prefix == null) {
                    if (rule.shownMixinsAndFunctions == null) {
                        if (rule.shownVariables == null) {
                            t2 = rule.hiddenMixinsAndFunctions;
                            t2 = t2 == null ? null : t2._base.get$isEmpty(0);
                            if (t2 === true) {
                                t1 = rule.hiddenVariables;
                                t1 = t1 == null ? null : t1._base.get$isEmpty(0);
                                t1 = t1 === true;
                            }
                        }
                    }
                }
                if (t1) return inner;
                else return A.ForwardedModuleView$0(inner, rule, $T);
            },
            ForwardedModuleView$0: function(_inner, _rule, $T) {
                var t1 = _rule.prefix, t2 = _rule.shownVariables, t3 = _rule.hiddenVariables, t4 = _rule.shownMixinsAndFunctions, t5 = _rule.hiddenMixinsAndFunctions;
                return new A.ForwardedModuleView0(_inner, _rule, A.ForwardedModuleView__forwardedMap0(_inner.get$variables(), t1, t2, t3, type$.Value_2), A.ForwardedModuleView__forwardedMap0(_inner.get$variableNodes(), t1, t2, t3, type$.AstNode_2), A.ForwardedModuleView__forwardedMap0(_inner.get$functions(_inner), t1, t4, t5, $T), A.ForwardedModuleView__forwardedMap0(_inner.get$mixins(), t1, t4, t5, $T), $T._eval$1("ForwardedModuleView0<0>"));
            },
            ForwardedModuleView__forwardedMap0: function(map, prefix, safelist, blocklist, $V) {
                var t1 = prefix == null, t2 = false;
                if (t1) {
                    if (safelist == null) t2 = blocklist == null || blocklist._base.get$isEmpty(0);
                }
                if (t2) return map;
                if (!t1) map = new A.PrefixedMapView0(map, prefix, $V._eval$1("PrefixedMapView0<0>"));
                if (safelist != null) map = new A.LimitedMapView0(map, safelist._base.intersection$1(new A.MapKeySet(map, type$.MapKeySet_nullable_Object)), type$.$env_1_1_String._bind$1($V)._eval$1("LimitedMapView0<1,2>"));
                else if (blocklist != null && blocklist._base.get$isNotEmpty(0)) map = A.LimitedMapView$blocklist0(map, blocklist, type$.String, $V);
                return map;
            },
            ForwardedModuleView0: function ForwardedModuleView0(t0, t1, t2, t3, t4, t5, t6) {
                var _ = this;
                _._forwarded_view0$_inner = t0;
                _._forwarded_view0$_rule = t1;
                _.variables = t2;
                _.variableNodes = t3;
                _.functions = t4;
                _.mixins = t5;
                _.$ti = t6;
            },
            FunctionExpression0: function FunctionExpression0(t0, t1, t2, t3, t4) {
                var _ = this;
                _.namespace = t0;
                _.name = t1;
                _.originalName = t2;
                _.$arguments = t3;
                _.span = t4;
            },
            JSFunction0: function JSFunction0() {},
            SupportsFunction0: function SupportsFunction0(t0, t1, t2) {
                this.name = t0;
                this.$arguments = t1;
                this.span = t2;
            },
            functionClass_closure: function functionClass_closure() {},
            functionClass__closure: function functionClass__closure() {},
            functionClass__closure0: function functionClass__closure0() {},
            SassFunction0: function SassFunction0(t0, t1) {
                this.callable = t0;
                this._function0$_compileContext = t1;
            },
            FunctionRule$0: function($name, parameters, children, span, comment) {
                var t1 = A.stringReplaceAllUnchecked($name, "_", "-"), t2 = A.List_List$unmodifiable(children, type$.Statement_2), t3 = B.JSArray_methods.any$1(t2, new A.ParentStatement_closure0());
                return new A.FunctionRule0(t1, $name, parameters, span, t2, t3);
            },
            FunctionRule0: function FunctionRule0(t0, t1, t2, t3, t4, t5) {
                var _ = this;
                _.name = t0;
                _.originalName = t1;
                _.parameters = t2;
                _.span = t3;
                _.children = t4;
                _.hasDeclarations = t5;
            },
            unifyComplex0: function(complexes, span) {
                var t2, trailingCombinator, leadingCombinator, unifiedBase, t3, t4, _0_6_isSet, _0_6, t5, newLeadingCombinator, base, _1_1, newTrailingCombinator, unifiedBase0, t6, t7, t8, _null = null, t1 = J.getInterceptor$asx(complexes);
                if (t1.get$length(complexes) === 1) return complexes;
                for(t2 = t1.get$iterator(complexes), trailingCombinator = _null, leadingCombinator = trailingCombinator, unifiedBase = leadingCombinator; t2.moveNext$0();){
                    t3 = t2.get$current(t2);
                    if (t3.accept$1(B.C__IsUselessVisitor0)) return _null;
                    t4 = t3.components;
                    _0_6_isSet = t4.length === 1;
                    if (_0_6_isSet) {
                        _0_6 = t3.leadingCombinators;
                        t5 = _0_6.length === 1;
                    } else {
                        _0_6 = _null;
                        t5 = false;
                    }
                    if (t5) {
                        newLeadingCombinator = (_0_6_isSet ? _0_6 : t3.leadingCombinators)[0];
                        if (leadingCombinator == null) leadingCombinator = newLeadingCombinator;
                        else if (!(leadingCombinator.$ti._is(newLeadingCombinator) && J.$eq$(newLeadingCombinator.value, leadingCombinator.value))) return _null;
                    }
                    base = B.JSArray_methods.get$last(t4);
                    _1_1 = base.combinators;
                    if (_1_1.length === 1) {
                        newTrailingCombinator = _1_1[0];
                        if (trailingCombinator != null) t3 = !(trailingCombinator.$ti._is(newTrailingCombinator) && J.$eq$(newTrailingCombinator.value, trailingCombinator.value));
                        else t3 = false;
                        if (t3) return _null;
                        trailingCombinator = newTrailingCombinator;
                    }
                    unifiedBase0 = base.selector;
                    if (unifiedBase == null) unifiedBase = unifiedBase0;
                    else {
                        unifiedBase = A.unifyCompound0(unifiedBase, unifiedBase0);
                        if (unifiedBase == null) return _null;
                    }
                }
                t2 = type$.JSArray_ComplexSelector_2;
                t3 = A._setArrayType([], t2);
                for(t4 = t1.get$iterator(complexes); t4.moveNext$0();){
                    t5 = t4.get$current(t4);
                    t6 = t5.components;
                    t7 = t6.length;
                    if (t7 > 1) {
                        t8 = t5.leadingCombinators;
                        t3.push(A.ComplexSelector$0(t8, B.JSArray_methods.take$1(t6, t7 - 1), t5.span, t5.lineBreak));
                    }
                }
                t4 = leadingCombinator == null ? B.List_empty17 : A._setArrayType([
                    leadingCombinator
                ], type$.JSArray_CssValue_Combinator_2);
                unifiedBase.toString;
                t5 = trailingCombinator == null ? B.List_empty17 : A._setArrayType([
                    trailingCombinator
                ], type$.JSArray_CssValue_Combinator_2);
                base = A.ComplexSelector$0(t4, A._setArrayType([
                    new A.ComplexSelectorComponent0(unifiedBase, A.List_List$unmodifiable(t5, type$.CssValue_Combinator_2), span)
                ], type$.JSArray_ComplexSelectorComponent_2), span, t1.any$1(complexes, new A.unifyComplex_closure0()));
                if (t3.length === 0) t1 = A._setArrayType([
                    base
                ], t2);
                else {
                    t1 = A.List_List$_of(A.IterableExtension_get_exceptLast0(t3), type$.ComplexSelector_2);
                    t1.push(B.JSArray_methods.get$last(t3).concatenate$2(base, span));
                }
                return A.weave0(t1, span, false);
            },
            unifyCompound0: function(compound1, compound2) {
                var t1, t2, pseudoElementFound, _i, simple, unified, result = compound1.components, pseudoResult = A._setArrayType([], type$.JSArray_SimpleSelector_2);
                for(t1 = compound2.components, t2 = t1.length, pseudoElementFound = false, _i = 0; _i < t2; ++_i){
                    simple = t1[_i];
                    if (pseudoElementFound && simple instanceof A.PseudoSelector0) {
                        unified = simple.unify$1(pseudoResult);
                        if (unified == null) return null;
                        pseudoResult = unified;
                    } else {
                        pseudoElementFound = B.JSBool_methods.$or(pseudoElementFound, simple instanceof A.PseudoSelector0 && !simple.isClass);
                        unified = simple.unify$1(result);
                        if (unified == null) return null;
                        result = unified;
                    }
                }
                t1 = A.List_List$_of(result, type$.SimpleSelector_2);
                B.JSArray_methods.addAll$1(t1, pseudoResult);
                return A.CompoundSelector$0(t1, compound1.span);
            },
            unifyUniversalAndElement0: function(selector1, selector2) {
                var namespace, $name, t1, _0_0 = A._namespaceAndName0(selector1, "selector1"), namespace1 = _0_0._0, name1 = _0_0._1, _1_0 = A._namespaceAndName0(selector2, "selector2"), namespace2 = _1_0._0, name2 = _1_0._1;
                if (namespace1 == namespace2 || namespace2 === "*") namespace = namespace1;
                else {
                    if (namespace1 !== "*") return null;
                    namespace = namespace2;
                }
                if (name1 == name2 || name2 == null) $name = name1;
                else {
                    if (!(name1 == null || name1 === "*")) return null;
                    $name = name2;
                }
                t1 = selector1.span;
                return $name == null ? new A.UniversalSelector0(namespace, t1) : new A.TypeSelector0(new A.QualifiedName0($name, namespace), t1);
            },
            _namespaceAndName0: function(selector, $name) {
                var t1, _0_4;
                $label0$0: {
                    if (selector instanceof A.UniversalSelector0) {
                        t1 = new A._Record_2(selector.namespace, null);
                        break $label0$0;
                    }
                    if (selector instanceof A.TypeSelector0) {
                        _0_4 = selector.name;
                        t1 = new A._Record_2(_0_4.namespace, _0_4.name);
                        break $label0$0;
                    }
                    t1 = A.throwExpression(A.ArgumentError$value(selector, $name, string$.must_b));
                }
                return t1;
            },
            weave0: function(complexes, span, forceLineBreak) {
                var complex, t2, prefixes, t3, t4, t5, t6, i, t7, t8, _i, t9, t10, _i0, parentPrefix, t11, t12, t1 = J.getInterceptor$asx(complexes);
                if (t1.get$length(complexes) === 1) {
                    complex = t1.$index(complexes, 0);
                    if (!forceLineBreak || complex.lineBreak) return complexes;
                    return A._setArrayType([
                        A.ComplexSelector$0(complex.leadingCombinators, complex.components, complex.span, true)
                    ], type$.JSArray_ComplexSelector_2);
                }
                t2 = type$.JSArray_ComplexSelector_2;
                prefixes = A._setArrayType([
                    t1.get$first(complexes)
                ], t2);
                for(t1 = t1.skip$1(complexes, 1), t3 = t1.$ti, t1 = new A.ListIterator(t1, t1.get$length(0), t3._eval$1("ListIterator<ListIterable.E>")), t4 = type$.ComplexSelectorComponent_2, t3 = t3._eval$1("ListIterable.E"); t1.moveNext$0();){
                    t5 = t1.__internal$_current;
                    if (t5 == null) t5 = t3._as(t5);
                    t6 = t5.components;
                    if (t6.length === 1) {
                        for(i = 0; i < prefixes.length; ++i)prefixes[i] = prefixes[i].concatenate$3$forceLineBreak(t5, span, forceLineBreak);
                        continue;
                    }
                    t7 = A._setArrayType([], t2);
                    for(t8 = prefixes.length, _i = 0; _i < prefixes.length; prefixes.length === t8 || (0, A.throwConcurrentModificationError)(prefixes), ++_i){
                        t9 = A._weaveParents0(prefixes[_i], t5, span);
                        if (t9 == null) t9 = B.List_empty18;
                        t10 = t9.length;
                        _i0 = 0;
                        for(; _i0 < t9.length; t9.length === t10 || (0, A.throwConcurrentModificationError)(t9), ++_i0){
                            parentPrefix = t9[_i0];
                            t11 = B.JSArray_methods.get$last(t6);
                            t12 = A.List_List$_of(parentPrefix.components, t4);
                            t12.push(t11);
                            t11 = parentPrefix.lineBreak || forceLineBreak;
                            t7.push(A.ComplexSelector$0(parentPrefix.leadingCombinators, t12, span, t11));
                        }
                    }
                    prefixes = t7;
                }
                return prefixes;
            },
            _weaveParents0: function(prefix, base, span) {
                var t1, queue1, queue2, trailingCombinators, _0_1, _0_3, _0_3_isSet, rootish2, t2, rootish1, _0_30, rootish, t3, t0, rootish_case_1, groups1, groups2, lcs, choices, t4, _i, group, t5, t6, t7, _i0, chunk, t8, t9, _null = null, leadingCombinators = A._mergeLeadingCombinators0(prefix.leadingCombinators, base.leadingCombinators);
                if (leadingCombinators == null) return _null;
                t1 = type$.ComplexSelectorComponent_2;
                queue1 = A.QueueList_QueueList$from(prefix.components, t1);
                queue2 = A.QueueList_QueueList$from(A.IterableExtension_get_exceptLast0(base.components), t1);
                trailingCombinators = A._mergeTrailingCombinators0(queue1, queue2, span, _null);
                if (trailingCombinators == null) return _null;
                $label0$0: {
                    _0_1 = A._firstIfRootish0(queue1);
                    _0_3 = A._firstIfRootish0(queue2);
                    _0_3_isSet = _0_1 != null;
                    rootish2 = _null;
                    t2 = false;
                    if (_0_3_isSet) {
                        t2 = _0_3 != null;
                        if (t2) rootish2 = _0_3;
                        rootish1 = _0_1;
                        _0_30 = _0_3;
                    } else {
                        rootish1 = _null;
                        _0_30 = rootish1;
                    }
                    if (t2) {
                        rootish = A.unifyCompound0(rootish1.selector, rootish2.selector);
                        if (rootish == null) return _null;
                        t1 = rootish1.combinators;
                        t2 = rootish1.span;
                        t3 = type$.CssValue_Combinator_2;
                        queue1.addFirst$1(new A.ComplexSelectorComponent0(rootish, A.List_List$unmodifiable(t1, t3), t2));
                        queue2.addFirst$1(new A.ComplexSelectorComponent0(rootish, A.List_List$unmodifiable(rootish2.combinators, t3), t2));
                        break $label0$0;
                    }
                    t2 = _null;
                    t3 = false;
                    if (_0_1 != null) {
                        if (_0_3_isSet) t2 = _0_30;
                        else {
                            t2 = _0_3;
                            _0_30 = t2;
                            _0_3_isSet = true;
                        }
                        t2 = t2 == null;
                        t3 = t2 ? _0_1 : _null;
                        t0 = t3;
                        t3 = t2;
                        t2 = t0;
                    }
                    if (!t3) {
                        if (_0_1 == null) {
                            if (_0_3_isSet) t3 = _0_30;
                            else {
                                t3 = _0_3;
                                _0_30 = t3;
                                _0_3_isSet = true;
                            }
                            t3 = t3 != null;
                            if (t3) {
                                rootish_case_1 = _0_3_isSet ? _0_30 : _0_3;
                                if (rootish_case_1 == null) rootish_case_1 = t1._as(rootish_case_1);
                                t1 = rootish_case_1;
                            } else t1 = t2;
                            t2 = t3;
                        } else {
                            t1 = t2;
                            t2 = false;
                        }
                    } else {
                        t1 = t2;
                        t2 = true;
                    }
                    if (t2) {
                        queue1.addFirst$1(t1);
                        queue2.addFirst$1(t1);
                    }
                }
                groups1 = A._groupSelectors0(queue1);
                groups2 = A._groupSelectors0(queue2);
                t1 = type$.List_ComplexSelectorComponent_2;
                lcs = A.longestCommonSubsequence0(groups2, groups1, new A._weaveParents_closure3(span), t1);
                choices = A._setArrayType([], type$.JSArray_List_Iterable_ComplexSelectorComponent_2);
                for(t2 = lcs.length, t3 = type$.JSArray_Iterable_ComplexSelectorComponent_2, t4 = type$.JSArray_ComplexSelectorComponent_2, _i = 0; _i < lcs.length; lcs.length === t2 || (0, A.throwConcurrentModificationError)(lcs), ++_i){
                    group = lcs[_i];
                    t5 = A._setArrayType([], t3);
                    for(t6 = A._chunks0(groups1, groups2, new A._weaveParents_closure4(group), t1), t7 = t6.length, _i0 = 0; _i0 < t6.length; t6.length === t7 || (0, A.throwConcurrentModificationError)(t6), ++_i0){
                        chunk = t6[_i0];
                        t8 = A._setArrayType([], t4);
                        for(t9 = B.JSArray_methods.get$iterator(chunk); t9.moveNext$0();)B.JSArray_methods.addAll$1(t8, t9.get$current(0));
                        t5.push(t8);
                    }
                    choices.push(t5);
                    choices.push(A._setArrayType([
                        group
                    ], t3));
                    groups1.removeFirst$0();
                    groups2.removeFirst$0();
                }
                t2 = A._setArrayType([], t3);
                for(t1 = A._chunks0(groups1, groups2, new A._weaveParents_closure5(), t1), t3 = t1.length, _i = 0; _i < t1.length; t1.length === t3 || (0, A.throwConcurrentModificationError)(t1), ++_i){
                    chunk = t1[_i];
                    t5 = A._setArrayType([], t4);
                    for(t6 = B.JSArray_methods.get$iterator(chunk); t6.moveNext$0();)B.JSArray_methods.addAll$1(t5, t6.get$current(0));
                    t2.push(t5);
                }
                choices.push(t2);
                B.JSArray_methods.addAll$1(choices, trailingCombinators);
                t1 = A._setArrayType([], type$.JSArray_ComplexSelector_2);
                for(t2 = J.get$iterator$ax(A.paths0(new A.WhereIterable(choices, new A._weaveParents_closure6(), type$.WhereIterable_List_Iterable_ComplexSelectorComponent_2), type$.Iterable_ComplexSelectorComponent_2)), t3 = !prefix.lineBreak, t5 = base.lineBreak; t2.moveNext$0();){
                    t6 = t2.get$current(t2);
                    t7 = A._setArrayType([], t4);
                    for(t6 = J.get$iterator$ax(t6); t6.moveNext$0();)B.JSArray_methods.addAll$1(t7, t6.get$current(t6));
                    t1.push(A.ComplexSelector$0(leadingCombinators, t7, span, !t3 || t5));
                }
                return t1;
            },
            _firstIfRootish0: function(queue) {
                var first, t1, t2, _i, simple, t3;
                if (queue.get$length(0) >= 1) {
                    first = queue.$index(0, 0);
                    for(t1 = first.selector.components, t2 = t1.length, _i = 0; _i < t2; ++_i){
                        simple = t1[_i];
                        t3 = false;
                        if (simple instanceof A.PseudoSelector0) {
                            if (simple.isClass) t3 = $._rootishPseudoClasses0.contains$1(0, simple.normalizedName);
                        }
                        if (t3) {
                            queue.removeFirst$0();
                            return first;
                        }
                    }
                }
                return null;
            },
            _mergeLeadingCombinators0: function(combinators1, combinators2) {
                var t1, _0_7, t2, _0_11_isSet, _0_11, combinators, _null = null;
                $label0$0: {
                    t1 = _null;
                    _0_7 = _null;
                    _0_7 = combinators1.length;
                    t2 = _0_7;
                    t2 = t2 > 1;
                    _0_11_isSet = !t2;
                    _0_11 = _null;
                    if (_0_11_isSet) {
                        _0_11 = combinators2.length;
                        t2 = _0_11;
                        t2 = t2 > 1;
                    } else t2 = true;
                    if (t2) break $label0$0;
                    t2 = _0_7 <= 0;
                    if (t2) combinators = combinators2;
                    else combinators = t1;
                    t1 = t2;
                    if (!t1) {
                        t1 = false;
                        if (_0_11_isSet) t1 = _0_11;
                        else {
                            _0_11 = combinators2.length;
                            t1 = _0_11;
                        }
                        t1 = t1 <= 0;
                        combinators = combinators1;
                    } else t1 = true;
                    if (t1) {
                        t1 = combinators;
                        break $label0$0;
                    }
                    t1 = B.C_ListEquality.equals$2(0, combinators1, combinators2) ? combinators1 : _null;
                    break $label0$0;
                }
                return t1;
            },
            _mergeTrailingCombinators0: function(components1, components2, span, result) {
                var _0_1, t1, _1_1, t2, t3, _4_1, _4_3, _4_5, _4_4, _4_5_isSet, _4_4_isSet, component1, component2, t4, t5, choices, _2_0, _4_9, _4_6, _4_6_isSet, _4_7, _4_7_isSet, followingComponents, nextComponents, _4_9_isSet, _4_10_isSet, _4_10, next, following, _3_0, _4_4_isSet0, siblingComponents_case_0, siblingComponents_case_1, t6, combinator2, unified, t7, combinatorComponents_case_0, descendantComponents_case_0, t0, combinator_case_1, descendantComponents_case_1, combinatorComponents_case_1, _null = null;
                if (result == null) result = A.QueueList$(_null, type$.List_List_ComplexSelectorComponent_2);
                $label0$0: {
                    _0_1 = components1.get$length(0);
                    if (_0_1 >= 1) {
                        t1 = components1.$index(0, _0_1 - 1).combinators;
                        break $label0$0;
                    }
                    t1 = B.List_empty17;
                    break $label0$0;
                }
                $label1$1: {
                    _1_1 = components2.get$length(0);
                    if (_1_1 >= 1) {
                        t2 = components2.$index(0, _1_1 - 1).combinators;
                        break $label1$1;
                    }
                    t2 = B.List_empty17;
                    break $label1$1;
                }
                t3 = t1.length;
                if (t3 === 0 && t2.length === 0) return result;
                if (t3 > 1 || t2.length > 1) return _null;
                $label2$2: {
                    t3 = A.IterableExtension_get_firstOrNull(t1);
                    t3 = t3 == null ? _null : t3.value;
                    t2 = A.IterableExtension_get_firstOrNull(t2);
                    t2 = [
                        t3,
                        t2 == null ? _null : t2.value,
                        components1,
                        components2
                    ];
                    _4_1 = t2[0];
                    _4_3 = B.Combinator_98W0 === _4_1;
                    t3 = _4_3;
                    _4_5 = _null;
                    _4_4 = _null;
                    if (t3) {
                        _4_4 = t2[1];
                        _4_5 = B.Combinator_98W0 === _4_4;
                        t3 = _4_5;
                        _4_5_isSet = true;
                        _4_4_isSet = true;
                    } else {
                        _4_5_isSet = false;
                        _4_4_isSet = false;
                        t3 = false;
                    }
                    if (t3) {
                        component1 = components1.removeLast$0(0);
                        component2 = components2.removeLast$0(0);
                        t2 = component1.selector;
                        t3 = component2.selector;
                        if (A.compoundIsSuperselector0(t2, t3, _null)) result.addFirst$1(A._setArrayType([
                            A._setArrayType([
                                component2
                            ], type$.JSArray_ComplexSelectorComponent_2)
                        ], type$.JSArray_List_ComplexSelectorComponent_2));
                        else {
                            t4 = type$.JSArray_ComplexSelectorComponent_2;
                            t5 = type$.JSArray_List_ComplexSelectorComponent_2;
                            if (A.compoundIsSuperselector0(t3, t2, _null)) result.addFirst$1(A._setArrayType([
                                A._setArrayType([
                                    component1
                                ], t4)
                            ], t5));
                            else {
                                choices = A._setArrayType([
                                    A._setArrayType([
                                        component1,
                                        component2
                                    ], t4),
                                    A._setArrayType([
                                        component2,
                                        component1
                                    ], t4)
                                ], t5);
                                _2_0 = A.unifyCompound0(t2, t3);
                                if (_2_0 != null) choices.push(A._setArrayType([
                                    new A.ComplexSelectorComponent0(_2_0, A.List_List$unmodifiable(A._setArrayType([
                                        B.JSArray_methods.get$first(t1)
                                    ], type$.JSArray_CssValue_Combinator_2), type$.CssValue_Combinator_2), span)
                                ], t4));
                                result.addFirst$1(choices);
                            }
                        }
                        break $label2$2;
                    }
                    _4_9 = _null;
                    _4_6 = _null;
                    _4_6_isSet = false;
                    _4_7 = _null;
                    _4_7_isSet = false;
                    followingComponents = _null;
                    nextComponents = _null;
                    t3 = false;
                    if (_4_3) {
                        if (_4_4_isSet) t4 = _4_4;
                        else {
                            _4_4 = t2[1];
                            t4 = _4_4;
                            _4_4_isSet = true;
                        }
                        _4_9 = B.Combinator_sHB0 === t4;
                        t4 = _4_9;
                        if (t4) {
                            _4_6 = t2[2];
                            _4_7 = t2[3];
                            nextComponents = _4_7;
                            followingComponents = _4_6;
                            _4_6_isSet = true;
                            _4_7_isSet = true;
                            t3 = true;
                        }
                        _4_9_isSet = true;
                    } else _4_9_isSet = false;
                    _4_10_isSet = !t3;
                    _4_10 = _null;
                    t3 = true;
                    if (_4_10_isSet) {
                        _4_10 = B.Combinator_sHB0 === _4_1;
                        t4 = _4_10;
                        if (t4) {
                            if (_4_5_isSet) t4 = _4_5;
                            else {
                                if (_4_4_isSet) t4 = _4_4;
                                else {
                                    _4_4 = t2[1];
                                    t4 = _4_4;
                                    _4_4_isSet = true;
                                }
                                _4_5 = B.Combinator_98W0 === t4;
                                t4 = _4_5;
                                _4_5_isSet = true;
                            }
                            if (t4) {
                                if (_4_6_isSet) nextComponents = _4_6;
                                else {
                                    _4_6 = t2[2];
                                    nextComponents = _4_6;
                                    _4_6_isSet = true;
                                }
                                if (_4_7_isSet) followingComponents = _4_7;
                                else {
                                    _4_7 = t2[3];
                                    followingComponents = _4_7;
                                    _4_7_isSet = true;
                                }
                            } else t3 = false;
                        } else t3 = false;
                    }
                    if (t3) {
                        next = nextComponents.removeLast$0(0);
                        following = followingComponents.removeLast$0(0);
                        t1 = following.selector;
                        t2 = next.selector;
                        t3 = type$.JSArray_ComplexSelectorComponent_2;
                        t4 = type$.JSArray_List_ComplexSelectorComponent_2;
                        if (A.compoundIsSuperselector0(t1, t2, _null)) result.addFirst$1(A._setArrayType([
                            A._setArrayType([
                                next
                            ], t3)
                        ], t4));
                        else {
                            t4 = A._setArrayType([
                                A._setArrayType([
                                    following,
                                    next
                                ], t3)
                            ], t4);
                            _3_0 = A.unifyCompound0(t1, t2);
                            if (_3_0 != null) t4.push(A._setArrayType([
                                new A.ComplexSelectorComponent0(_3_0, A.List_List$unmodifiable(next.combinators, type$.CssValue_Combinator_2), span)
                            ], t3));
                            result.addFirst$1(t4);
                        }
                        break $label2$2;
                    }
                    t3 = _null;
                    t4 = false;
                    if (B.Combinator_iUF0 === _4_1) {
                        _4_4_isSet0 = true;
                        if (_4_9_isSet) t5 = _4_9;
                        else {
                            if (_4_4_isSet) t5 = _4_4;
                            else {
                                _4_4 = t2[1];
                                t5 = _4_4;
                                _4_4_isSet = _4_4_isSet0;
                            }
                            _4_9 = B.Combinator_sHB0 === t5;
                            t5 = _4_9;
                        }
                        if (!t5) {
                            if (_4_5_isSet) t5 = _4_5;
                            else {
                                if (_4_4_isSet) t5 = _4_4;
                                else {
                                    _4_4 = t2[1];
                                    t5 = _4_4;
                                    _4_4_isSet = _4_4_isSet0;
                                }
                                _4_5 = B.Combinator_98W0 === t5;
                                t5 = _4_5;
                            }
                        } else t5 = true;
                        if (t5) {
                            if (_4_7_isSet) siblingComponents_case_0 = _4_7;
                            else {
                                _4_7 = t2[3];
                                siblingComponents_case_0 = _4_7;
                                _4_7_isSet = true;
                            }
                            t3 = siblingComponents_case_0;
                            t4 = true;
                        }
                    }
                    if (!t4) {
                        if (_4_10_isSet) t4 = _4_10;
                        else {
                            _4_10 = B.Combinator_sHB0 === _4_1;
                            t4 = _4_10;
                        }
                        if (!t4) t4 = _4_3;
                        else t4 = true;
                        if (t4) {
                            if (_4_4_isSet) t4 = _4_4;
                            else {
                                _4_4 = t2[1];
                                t4 = _4_4;
                                _4_4_isSet = true;
                            }
                            t4 = B.Combinator_iUF0 === t4;
                            if (t4) {
                                if (_4_6_isSet) siblingComponents_case_1 = _4_6;
                                else {
                                    _4_6 = t2[2];
                                    siblingComponents_case_1 = _4_6;
                                    _4_6_isSet = true;
                                }
                                t3 = siblingComponents_case_1;
                            }
                        } else t4 = false;
                    } else t4 = true;
                    if (t4) {
                        result.addFirst$1(A._setArrayType([
                            A._setArrayType([
                                t3.removeLast$0(0)
                            ], type$.JSArray_ComplexSelectorComponent_2)
                        ], type$.JSArray_List_ComplexSelectorComponent_2));
                        break $label2$2;
                    }
                    t3 = _4_1 == null;
                    t4 = !t3;
                    t5 = false;
                    if (t4) {
                        _4_4_isSet0 = true;
                        if (_4_4_isSet) t6 = _4_4;
                        else {
                            _4_4 = t2[1];
                            t6 = _4_4;
                            _4_4_isSet = _4_4_isSet0;
                        }
                        if (t6 != null) {
                            if (_4_4_isSet) combinator2 = _4_4;
                            else {
                                _4_4 = t2[1];
                                combinator2 = _4_4;
                                _4_4_isSet = _4_4_isSet0;
                            }
                            t5 = _4_1 === (combinator2 == null ? type$.Combinator_2._as(combinator2) : combinator2);
                        }
                    }
                    if (t5) {
                        unified = A.unifyCompound0(components1.removeLast$0(0).selector, components2.removeLast$0(0).selector);
                        if (unified == null) return _null;
                        result.addFirst$1(A._setArrayType([
                            A._setArrayType([
                                new A.ComplexSelectorComponent0(unified, A.List_List$unmodifiable(A._setArrayType([
                                    B.JSArray_methods.get$first(t1)
                                ], type$.JSArray_CssValue_Combinator_2), type$.CssValue_Combinator_2), span)
                            ], type$.JSArray_ComplexSelectorComponent_2)
                        ], type$.JSArray_List_ComplexSelectorComponent_2));
                        break $label2$2;
                    }
                    t1 = _null;
                    t5 = _null;
                    t6 = _null;
                    t7 = false;
                    if (t4) {
                        if (_4_4_isSet) t4 = _4_4;
                        else {
                            _4_4 = t2[1];
                            t4 = _4_4;
                            _4_4_isSet = true;
                        }
                        t4 = t4 == null;
                        if (t4) {
                            if (_4_6_isSet) combinatorComponents_case_0 = _4_6;
                            else {
                                _4_6 = t2[2];
                                combinatorComponents_case_0 = _4_6;
                                _4_6_isSet = true;
                            }
                            if (_4_7_isSet) descendantComponents_case_0 = _4_7;
                            else {
                                _4_7 = t2[3];
                                descendantComponents_case_0 = _4_7;
                                _4_7_isSet = true;
                            }
                            t1 = descendantComponents_case_0;
                            t6 = t1;
                            t1 = _4_1;
                            t5 = combinatorComponents_case_0;
                        }
                        t0 = t6;
                        t6 = t4;
                        t4 = t5;
                        t5 = t0;
                    } else {
                        t4 = t5;
                        t5 = t6;
                        t6 = t7;
                    }
                    if (!t6) {
                        if (t3) {
                            if (_4_4_isSet) t3 = _4_4;
                            else {
                                _4_4 = t2[1];
                                t3 = _4_4;
                                _4_4_isSet = true;
                            }
                            t3 = t3 != null;
                            if (t3) {
                                combinator_case_1 = _4_4_isSet ? _4_4 : t2[1];
                                if (combinator_case_1 == null) combinator_case_1 = type$.Combinator_2._as(combinator_case_1);
                                descendantComponents_case_1 = _4_6_isSet ? _4_6 : t2[2];
                                combinatorComponents_case_1 = _4_7_isSet ? _4_7 : t2[3];
                                t1 = combinatorComponents_case_1;
                                t2 = descendantComponents_case_1;
                                t4 = t2;
                                t2 = t1;
                                t1 = combinator_case_1;
                            } else {
                                t2 = t4;
                                t4 = t5;
                            }
                            t0 = t4;
                            t4 = t3;
                            t3 = t0;
                        } else {
                            t3 = t5;
                            t2 = t4;
                            t4 = false;
                        }
                    } else {
                        t3 = t5;
                        t2 = t4;
                        t4 = true;
                    }
                    if (t4) {
                        if (t1 === B.Combinator_iUF0) {
                            t1 = A.IterableExtension_get_lastOrNull(t3);
                            t1 = t1 == null ? _null : A.compoundIsSuperselector0(t1.selector, t2.get$last(t2).selector, _null);
                            t1 = t1 === true;
                        } else t1 = false;
                        if (t1) t3.removeLast$0(0);
                        result.addFirst$1(A._setArrayType([
                            A._setArrayType([
                                t2.removeLast$0(0)
                            ], type$.JSArray_ComplexSelectorComponent_2)
                        ], type$.JSArray_List_ComplexSelectorComponent_2));
                        break $label2$2;
                    }
                    return _null;
                }
                return A._mergeTrailingCombinators0(components1, components2, span, result);
            },
            _mustUnify0: function(complex1, complex2) {
                var t2, t3, t4, t1 = A.LinkedHashSet_LinkedHashSet$_empty(type$.SimpleSelector_2);
                for(t2 = J.get$iterator$ax(complex1); t2.moveNext$0();)for(t3 = B.JSArray_methods.get$iterator(t2.get$current(t2).selector.components), t4 = new A.WhereIterator(t3, A.functions0___isUnique$closure()); t4.moveNext$0();)t1.add$1(0, t3.get$current(0));
                if (t1._collection$_length === 0) return false;
                return J.any$1$ax(complex2, new A._mustUnify_closure0(t1));
            },
            _isUnique0: function(simple) {
                var t1;
                if (!(simple instanceof A.IDSelector0)) t1 = simple instanceof A.PseudoSelector0 && !simple.isClass;
                else t1 = true;
                return t1;
            },
            _chunks0: function(queue1, queue2, done, $T) {
                var chunk2, _0_4, _0_7, _0_5, _0_7_isSet, _0_5_isSet, chunk, t2, _null = null, t1 = $T._eval$1("JSArray<0>"), chunk1 = A._setArrayType([], t1);
                while(!done.call$1(queue1))chunk1.push(queue1.removeFirst$0());
                chunk2 = A._setArrayType([], t1);
                while(!done.call$1(queue2))chunk2.push(queue2.removeFirst$0());
                $label0$0: {
                    _0_4 = chunk1.length <= 0;
                    t1 = _0_4;
                    _0_7 = _null;
                    if (t1) {
                        _0_7 = chunk2.length <= 0;
                        t1 = _0_7;
                        _0_5 = chunk2;
                        _0_7_isSet = true;
                        _0_5_isSet = true;
                    } else {
                        _0_5 = _null;
                        _0_7_isSet = false;
                        _0_5_isSet = false;
                        t1 = false;
                    }
                    if (t1) {
                        t1 = A._setArrayType([], $T._eval$1("JSArray<List<0>>"));
                        break $label0$0;
                    }
                    if (_0_4) {
                        if (_0_5_isSet) chunk = _0_5;
                        else {
                            chunk = chunk2;
                            _0_5 = chunk;
                            _0_5_isSet = true;
                        }
                        t1 = true;
                    } else {
                        chunk = _null;
                        t1 = false;
                    }
                    if (!t1) {
                        if (_0_7_isSet) t1 = _0_7;
                        else {
                            _0_7 = (_0_5_isSet ? _0_5 : chunk2).length <= 0;
                            t1 = _0_7;
                        }
                        chunk = chunk1;
                    } else t1 = true;
                    if (t1) {
                        t1 = A._setArrayType([
                            chunk
                        ], $T._eval$1("JSArray<List<0>>"));
                        break $label0$0;
                    }
                    t1 = A.List_List$_of(chunk1, $T);
                    B.JSArray_methods.addAll$1(t1, chunk2);
                    t2 = A.List_List$_of(chunk2, $T);
                    B.JSArray_methods.addAll$1(t2, chunk1);
                    t1 = A._setArrayType([
                        t1,
                        t2
                    ], $T._eval$1("JSArray<List<0>>"));
                    break $label0$0;
                }
                return t1;
            },
            paths0: function(choices, $T) {
                return J.fold$2$ax(choices, A._setArrayType([
                    A._setArrayType([], $T._eval$1("JSArray<0>"))
                ], $T._eval$1("JSArray<List<0>>")), new A.paths_closure0($T));
            },
            _groupSelectors0: function(complex) {
                var t2, t3, t4, groups = A.QueueList$(null, type$.List_ComplexSelectorComponent_2), t1 = type$.JSArray_ComplexSelectorComponent_2, group = A._setArrayType([], t1);
                for(t2 = complex.$ti, t3 = new A.ListIterator(complex, complex.get$length(0), t2._eval$1("ListIterator<ListBase.E>")), t2 = t2._eval$1("ListBase.E"); t3.moveNext$0();){
                    t4 = t3.__internal$_current;
                    if (t4 == null) t4 = t2._as(t4);
                    group.push(t4);
                    if (t4.combinators.length === 0) {
                        groups._queue_list$_add$1(group);
                        group = A._setArrayType([], t1);
                    }
                }
                if (group.length !== 0) groups._queue_list$_add$1(group);
                return groups;
            },
            listIsSuperselector0: function(list1, list2) {
                return B.JSArray_methods.every$1(list2, new A.listIsSuperselector_closure0(list1));
            },
            _complexIsParentSuperselector0: function(complex1, complex2) {
                var t1, base, t2;
                if (J.get$length$asx(complex1) > J.get$length$asx(complex2)) return false;
                t1 = $.$get$bogusSpan0();
                base = new A.ComplexSelectorComponent0(A.CompoundSelector$0(A._setArrayType([
                    new A.PlaceholderSelector0("<temp>", t1)
                ], type$.JSArray_SimpleSelector_2), t1), A.List_List$unmodifiable(B.List_empty17, type$.CssValue_Combinator_2), t1);
                t1 = type$.ComplexSelectorComponent_2;
                t2 = A.List_List$_of(complex1, t1);
                t2.push(base);
                t1 = A.List_List$_of(complex2, t1);
                t1.push(base);
                return A.complexIsSuperselector0(t2, t1);
            },
            complexIsSuperselector0: function(complex1, complex2) {
                var t1, t2, previousCombinator, i1, i2, remaining1, remaining2, component1, t3, t4, endOfSubselector, component2, t5, combinator1, _null = null;
                if (B.JSArray_methods.get$last(complex1).combinators.length !== 0) return false;
                if (B.JSArray_methods.get$last(complex2).combinators.length !== 0) return false;
                for(t1 = A._arrayInstanceType(complex2), t2 = t1._precomputed1, t1 = t1._eval$1("SubListIterable<1>"), previousCombinator = _null, i1 = 0, i2 = 0;; previousCombinator = combinator1){
                    remaining1 = complex1.length - i1;
                    remaining2 = complex2.length - i2;
                    if (remaining1 === 0 || remaining2 === 0) return false;
                    if (remaining1 > remaining2) return false;
                    component1 = complex1[i1];
                    t3 = component1.combinators;
                    if (t3.length > 1) return false;
                    if (remaining1 === 1) {
                        if (B.JSArray_methods.any$1(complex2, new A.complexIsSuperselector_closure1())) return false;
                        else {
                            t1 = component1.selector;
                            t2 = B.JSArray_methods.get$last(complex2);
                            t3 = t1.get$hasComplicatedSuperselectorSemantics() ? B.JSArray_methods.sublist$2(complex2, i2, complex2.length - 1) : _null;
                            return A.compoundIsSuperselector0(t1, t2.selector, t3);
                        }
                    }
                    for(t4 = component1.selector, endOfSubselector = i2;;){
                        component2 = complex2[endOfSubselector];
                        if (component2.combinators.length > 1) return false;
                        t5 = t4.get$hasComplicatedSuperselectorSemantics() ? B.JSArray_methods.sublist$2(complex2, i2, endOfSubselector) : _null;
                        if (A.compoundIsSuperselector0(t4, component2.selector, t5)) break;
                        ++endOfSubselector;
                        if (endOfSubselector === complex2.length - 1) return false;
                    }
                    t4 = new A.SubListIterable(complex2, 0, endOfSubselector, t1);
                    t4.SubListIterable$3(complex2, 0, endOfSubselector, t2);
                    if (!A._compatibleWithPreviousCombinator0(previousCombinator, t4.skip$1(0, i2))) return false;
                    component2 = complex2[endOfSubselector];
                    combinator1 = A.IterableExtension_get_firstOrNull(t3);
                    if (!A._isSupercombinator0(combinator1, A.IterableExtension_get_firstOrNull(component2.combinators))) return false;
                    ++i1;
                    i2 = endOfSubselector + 1;
                    if (complex1.length - i1 === 1) {
                        t3 = combinator1 == null;
                        if ((t3 ? _null : combinator1.value) === B.Combinator_98W0) {
                            t3 = complex2.length - 1;
                            t4 = new A.SubListIterable(complex2, 0, t3, t1);
                            t4.SubListIterable$3(complex2, 0, t3, t2);
                            if (!t4.skip$1(0, i2).every$1(0, new A.complexIsSuperselector_closure2(combinator1))) return false;
                        } else if (!t3) {
                            if (complex2.length - i2 > 1) return false;
                        }
                    }
                }
            },
            _compatibleWithPreviousCombinator0: function(previous, parents) {
                if (parents.get$isEmpty(parents)) return true;
                if (previous == null) return true;
                if (previous.value !== B.Combinator_98W0) return false;
                return parents.every$1(0, new A._compatibleWithPreviousCombinator_closure0());
            },
            _isSupercombinator0: function(combinator1, combinator2) {
                var t2, t3, t1 = true;
                if (!J.$eq$(combinator1, combinator2)) {
                    t2 = combinator1 == null;
                    if (t2) t3 = (combinator2 == null ? null : combinator2.value) === B.Combinator_iUF0;
                    else t3 = false;
                    if (!t3) {
                        if ((t2 ? null : combinator1.value) === B.Combinator_98W0) t1 = (combinator2 == null ? null : combinator2.value) === B.Combinator_sHB0;
                        else t1 = false;
                    }
                }
                return t1;
            },
            compoundIsSuperselector0: function(compound1, compound2, parents) {
                var t1, _0_1, _0_5, _0_5_isSet, _0_50, index1, pseudo2, index2, t2, pseudo1, t3, t4, t5, _i, simple1, _null = null;
                if (!compound1.get$hasComplicatedSuperselectorSemantics() && !compound2.get$hasComplicatedSuperselectorSemantics()) {
                    t1 = compound1.components;
                    if (t1.length > compound2.components.length) return false;
                    return B.JSArray_methods.every$1(t1, new A.compoundIsSuperselector_closure0(compound2));
                }
                _0_1 = A._findPseudoElementIndexed0(compound1);
                _0_5 = A._findPseudoElementIndexed0(compound2);
                t1 = type$.Record_2_nullable_Object_and_nullable_Object;
                _0_5_isSet = t1._is(_0_1);
                _0_50 = _null;
                index1 = _null;
                pseudo2 = _null;
                index2 = _null;
                t2 = false;
                if (_0_5_isSet) {
                    pseudo1 = _0_1._0;
                    index1 = _0_1._1;
                    t1 = t1._is(_0_5);
                    if (t1) {
                        pseudo2 = _0_5._0;
                        index2 = _0_5._1;
                    }
                    _0_50 = _0_5;
                } else {
                    t1 = t2;
                    pseudo1 = _null;
                }
                if (t1) {
                    if (pseudo1.isSuperselector$1(pseudo2)) {
                        t1 = compound1.components;
                        t2 = type$.int;
                        t3 = A._arrayInstanceType(t1)._precomputed1;
                        t4 = compound2.components;
                        t5 = A._arrayInstanceType(t4)._precomputed1;
                        t1 = A._compoundComponentsIsSuperselector0(A.SubListIterable$(t1, 0, A.checkNotNullable(index1, "count", t2), t3), A.SubListIterable$(t4, 0, A.checkNotNullable(index2, "count", t2), t5), parents) && A._compoundComponentsIsSuperselector0(A.SubListIterable$(t1, index1 + 1, _null, t3), A.SubListIterable$(t4, index2 + 1, _null, t5), parents);
                    } else t1 = false;
                    return t1;
                }
                if (_0_1 == null) t1 = (_0_5_isSet ? _0_50 : _0_5) != null;
                else t1 = true;
                if (t1) return false;
                for(t1 = compound1.components, t2 = t1.length, t3 = compound2.components, _i = 0; _i < t2; ++_i){
                    simple1 = t1[_i];
                    if (simple1 instanceof A.PseudoSelector0) t4 = simple1.selector != null;
                    else t4 = false;
                    if (t4) {
                        if (!A._selectorPseudoIsSuperselector0(simple1, compound2, parents)) return false;
                    } else if (!B.JSArray_methods.any$1(t3, simple1.get$isSuperselector())) return false;
                }
                return true;
            },
            _findPseudoElementIndexed0: function(compound) {
                var t1, t2, i, simple;
                for(t1 = compound.components, t2 = t1.length, i = 0; i < t2; ++i){
                    simple = t1[i];
                    if (simple instanceof A.PseudoSelector0 && !simple.isClass) return new A._Record_2(simple, i);
                }
                return null;
            },
            _compoundComponentsIsSuperselector0: function(compound1, compound2, parents) {
                var t1;
                if (compound1.get$length(0) === 0) return true;
                if (compound2.get$length(0) === 0) compound2 = A._setArrayType([
                    new A.UniversalSelector0("*", $.$get$bogusSpan0())
                ], type$.JSArray_SimpleSelector_2);
                t1 = $.$get$bogusSpan0();
                return A.compoundIsSuperselector0(A.CompoundSelector$0(compound1, t1), A.CompoundSelector$0(compound2, t1), parents);
            },
            _selectorPseudoIsSuperselector0: function(pseudo1, compound2, parents) {
                var selector1 = pseudo1.selector;
                if (selector1 == null) throw A.wrapException(A.ArgumentError$("Selector " + pseudo1.toString$0(0) + " must have a selector argument.", null));
                switch(pseudo1.normalizedName){
                    case "is":
                    case "matches":
                    case "any":
                    case "where":
                        return A._selectorPseudoArgs0(compound2, pseudo1.name, true).any$1(0, new A._selectorPseudoIsSuperselector_closure6(selector1)) || B.JSArray_methods.any$1(selector1.components, new A._selectorPseudoIsSuperselector_closure7(parents, compound2));
                    case "has":
                    case "host":
                    case "host-context":
                        return A._selectorPseudoArgs0(compound2, pseudo1.name, true).any$1(0, new A._selectorPseudoIsSuperselector_closure8(selector1));
                    case "slotted":
                        return A._selectorPseudoArgs0(compound2, pseudo1.name, false).any$1(0, new A._selectorPseudoIsSuperselector_closure9(selector1));
                    case "not":
                        return B.JSArray_methods.every$1(selector1.components, new A._selectorPseudoIsSuperselector_closure10(compound2, pseudo1));
                    case "current":
                        return A._selectorPseudoArgs0(compound2, pseudo1.name, true).any$1(0, new A._selectorPseudoIsSuperselector_closure11(selector1));
                    case "nth-child":
                    case "nth-last-child":
                        return B.JSArray_methods.any$1(compound2.components, new A._selectorPseudoIsSuperselector_closure12(pseudo1, selector1));
                    default:
                        throw A.wrapException("unreachable");
                }
            },
            _selectorPseudoArgs0: function(compound, $name, isClass) {
                var t1 = type$.WhereTypeIterable_PseudoSelector_2;
                return new A.NonNullsIterable(new A.MappedIterable(new A.WhereIterable(new A.WhereTypeIterable(compound.components, t1), new A._selectorPseudoArgs_closure1(isClass, $name), t1._eval$1("WhereIterable<Iterable.E>")), new A._selectorPseudoArgs_closure2(), t1._eval$1("MappedIterable<Iterable.E,SelectorList0?>")), type$.NonNullsIterable_SelectorList_2);
            },
            unifyComplex_closure0: function unifyComplex_closure0() {},
            _weaveParents_closure3: function _weaveParents_closure3(t0) {
                this.span = t0;
            },
            _weaveParents_closure4: function _weaveParents_closure4(t0) {
                this.group = t0;
            },
            _weaveParents_closure5: function _weaveParents_closure5() {},
            _weaveParents_closure6: function _weaveParents_closure6() {},
            _mustUnify_closure0: function _mustUnify_closure0(t0) {
                this.uniqueSelectors = t0;
            },
            _mustUnify__closure0: function _mustUnify__closure0(t0) {
                this.uniqueSelectors = t0;
            },
            paths_closure0: function paths_closure0(t0) {
                this.T = t0;
            },
            paths__closure0: function paths__closure0(t0, t1) {
                this.paths = t0;
                this.T = t1;
            },
            paths___closure0: function paths___closure0(t0, t1) {
                this.option = t0;
                this.T = t1;
            },
            listIsSuperselector_closure0: function listIsSuperselector_closure0(t0) {
                this.list1 = t0;
            },
            listIsSuperselector__closure0: function listIsSuperselector__closure0(t0) {
                this.complex1 = t0;
            },
            complexIsSuperselector_closure1: function complexIsSuperselector_closure1() {},
            complexIsSuperselector_closure2: function complexIsSuperselector_closure2(t0) {
                this.combinator1 = t0;
            },
            _compatibleWithPreviousCombinator_closure0: function _compatibleWithPreviousCombinator_closure0() {},
            compoundIsSuperselector_closure0: function compoundIsSuperselector_closure0(t0) {
                this.compound2 = t0;
            },
            _selectorPseudoIsSuperselector_closure6: function _selectorPseudoIsSuperselector_closure6(t0) {
                this.selector1 = t0;
            },
            _selectorPseudoIsSuperselector_closure7: function _selectorPseudoIsSuperselector_closure7(t0, t1) {
                this.parents = t0;
                this.compound2 = t1;
            },
            _selectorPseudoIsSuperselector_closure8: function _selectorPseudoIsSuperselector_closure8(t0) {
                this.selector1 = t0;
            },
            _selectorPseudoIsSuperselector_closure9: function _selectorPseudoIsSuperselector_closure9(t0) {
                this.selector1 = t0;
            },
            _selectorPseudoIsSuperselector_closure10: function _selectorPseudoIsSuperselector_closure10(t0, t1) {
                this.compound2 = t0;
                this.pseudo1 = t1;
            },
            _selectorPseudoIsSuperselector__closure0: function _selectorPseudoIsSuperselector__closure0(t0, t1) {
                this.complex = t0;
                this.pseudo1 = t1;
            },
            _selectorPseudoIsSuperselector___closure1: function _selectorPseudoIsSuperselector___closure1(t0) {
                this.simple2 = t0;
            },
            _selectorPseudoIsSuperselector___closure2: function _selectorPseudoIsSuperselector___closure2(t0) {
                this.simple2 = t0;
            },
            _selectorPseudoIsSuperselector_closure11: function _selectorPseudoIsSuperselector_closure11(t0) {
                this.selector1 = t0;
            },
            _selectorPseudoIsSuperselector_closure12: function _selectorPseudoIsSuperselector_closure12(t0, t1) {
                this.pseudo1 = t0;
                this.selector1 = t1;
            },
            _selectorPseudoArgs_closure1: function _selectorPseudoArgs_closure1(t0, t1) {
                this.isClass = t0;
                this.name = t1;
            },
            _selectorPseudoArgs_closure2: function _selectorPseudoArgs_closure2() {},
            globalFunctions_closure0: function globalFunctions_closure0() {},
            GamutMapMethod_GamutMapMethod$fromName0: function($name) {
                var t1;
                $label0$0: {
                    if ("clip" === $name) {
                        t1 = B.ClipGamutMap_clip0;
                        break $label0$0;
                    }
                    if ("local-minde" === $name) {
                        t1 = B.LocalMindeGamutMap_A2x0;
                        break $label0$0;
                    }
                    t1 = A.throwExpression(A.SassScriptException$0('Unknown gamut map method "' + $name + '".', null));
                }
                return t1;
            },
            GamutMapMethod0: function GamutMapMethod0() {},
            HslColorSpace0: function HslColorSpace0(t0, t1) {
                this.name = t0;
                this._space$_channels = t1;
            },
            HwbColorSpace0: function HwbColorSpace0(t0, t1) {
                this.name = t0;
                this._space$_channels = t1;
            },
            HwbColorSpace_convert_toRgb0: function HwbColorSpace_convert_toRgb0(t0, t1) {
                this._box_0 = t0;
                this.factor = t1;
            },
            InterpolatedIDSelector: function InterpolatedIDSelector(t0) {
                this.name = t0;
            },
            IDSelector0: function IDSelector0(t0, t1) {
                this.name = t0;
                this.span = t1;
            },
            IDSelector_unify_closure0: function IDSelector_unify_closure0(t0) {
                this.$this = t0;
            },
            IfConditionOperation$0: function(expressions, op) {
                var t1 = A.List_List$unmodifiable(expressions, type$.IfConditionExpression_2);
                if (t1.length < 2) A.throwExpression(A.ArgumentError$value(t1, "expressions", "must have length >= 2"));
                return new A.IfConditionOperation0(t1, op);
            },
            IfExpression0: function IfExpression0(t0, t1) {
                this.branches = t0;
                this.span = t1;
            },
            IfConditionExpression0: function IfConditionExpression0() {},
            IfConditionParenthesized0: function IfConditionParenthesized0(t0, t1) {
                this.expression = t0;
                this.span = t1;
            },
            IfConditionNegation0: function IfConditionNegation0(t0, t1) {
                this.expression = t0;
                this.span = t1;
            },
            IfConditionOperation0: function IfConditionOperation0(t0, t1) {
                this.expressions = t0;
                this.op = t1;
            },
            IfConditionOperation_toInterpolation_closure0: function IfConditionOperation_toInterpolation_closure0(t0) {
                this.$this = t0;
            },
            IfConditionFunction0: function IfConditionFunction0(t0, t1, t2) {
                this.name = t0;
                this.$arguments = t1;
                this.span = t2;
            },
            IfConditionSass0: function IfConditionSass0(t0, t1) {
                this.expression = t0;
                this.span = t1;
            },
            IfConditionRaw0: function IfConditionRaw0(t0) {
                this.text = t0;
            },
            JSIfConditionExpressionVisitor: function JSIfConditionExpressionVisitor(t0) {
                this._if_condition_expression$_inner = t0;
            },
            JSIfConditionExpressionVisitorObject: function JSIfConditionExpressionVisitorObject() {},
            IfClause$0: function(expression, children) {
                var t1 = A.List_List$unmodifiable(children, type$.Statement_2);
                return new A.IfClause0(expression, t1, B.JSArray_methods.any$1(t1, new A.IfRuleClause$__closure0()));
            },
            ElseClause$0: function(children) {
                var t1 = A.List_List$unmodifiable(children, type$.Statement_2);
                return new A.ElseClause0(t1, B.JSArray_methods.any$1(t1, new A.IfRuleClause$__closure0()));
            },
            IfRule0: function IfRule0(t0, t1, t2) {
                this.clauses = t0;
                this.lastClause = t1;
                this.span = t2;
            },
            IfRule_toString_closure0: function IfRule_toString_closure0() {},
            IfRuleClause0: function IfRuleClause0() {},
            IfRuleClause$__closure0: function IfRuleClause$__closure0() {},
            IfRuleClause$___closure0: function IfRuleClause$___closure0() {},
            IfClause0: function IfClause0(t0, t1, t2) {
                this.expression = t0;
                this.children = t1;
                this.hasDeclarations = t2;
            },
            ElseClause0: function ElseClause0(t0, t1) {
                this.children = t0;
                this.hasDeclarations = t1;
            },
            jsToDartList: function(list) {
                return self.immutable.isOrderedMap(list) ? J.toArray$0$x(type$.ImmutableList._as(list)) : type$.List_dynamic._as(list);
            },
            dartMapToImmutableMap: function(dartMap) {
                var t1, t2, immutableMap = J.asMutable$0$x(new self.immutable.OrderedMap());
                for(t1 = A.MapExtensions_get_pairs0(dartMap, type$.Object, type$.nullable_Object), t1 = t1.get$iterator(t1); t1.moveNext$0();){
                    t2 = t1.get$current(t1);
                    immutableMap = J.$set$2$x(immutableMap, t2._0, t2._1);
                }
                return J.asImmutable$0$x(immutableMap);
            },
            immutableMapToDartMap: function(immutableMap) {
                var dartMap = A.LinkedHashMap_LinkedHashMap$_empty(type$.Object, type$.nullable_Object);
                J.forEach$1$ax(immutableMap, A.allowInterop(new A.immutableMapToDartMap_closure(dartMap)));
                return dartMap;
            },
            ImmutableList0: function ImmutableList0() {},
            ImmutableMap0: function ImmutableMap0() {},
            immutableMapToDartMap_closure: function immutableMapToDartMap_closure(t0) {
                this.dartMap = t0;
            },
            NodeImporter__addSassPath: function(includePaths) {
                return new A._SyncStarIterable(A.NodeImporter__addSassPath$body(includePaths), type$._SyncStarIterable_String);
            },
            NodeImporter__addSassPath$body: function($async$includePaths) {
                return function() {
                    var includePaths = $async$includePaths;
                    var $async$goto = 0, $async$handler = 2, $async$errorStack = [], sassPath, t1;
                    return function $async$NodeImporter__addSassPath($async$iterator, $async$errorCode, $async$result) {
                        if ($async$errorCode === 1) {
                            $async$errorStack.push($async$result);
                            $async$goto = $async$handler;
                        }
                        for(;;)switch($async$goto){
                            case 0:
                                // Function start
                                $async$goto = 3;
                                return $async$iterator._yieldStar$1(includePaths);
                            case 3:
                                // after yield
                                sassPath = A.getEnvironmentVariable0("SASS_PATH");
                                if (sassPath == null) {
                                    // goto return
                                    $async$goto = 1;
                                    break;
                                }
                                t1 = A.isNodeJs() ? self.process : null;
                                $async$goto = 4;
                                return $async$iterator._yieldStar$1(A._setArrayType(sassPath.split(J.$eq$(t1 == null ? null : J.get$platform$x(t1), "win32") ? ";" : ":"), type$.JSArray_String));
                            case 4:
                            // after yield
                            case 1:
                                // return
                                return 0;
                            case 2:
                                // rethrow
                                return $async$iterator._datum = $async$errorStack.at(-1), 3;
                        }
                    };
                };
            },
            NodeImporter: function NodeImporter(t0, t1, t2) {
                this._implementation$_options = t0;
                this._includePaths = t1;
                this._implementation$_importers = t2;
            },
            NodeImporter_load_closure: function NodeImporter_load_closure(t0, t1, t2, t3, t4) {
                var _ = this;
                _.$this = t0;
                _.importer = t1;
                _.forImport = t2;
                _.url = t3;
                _.previousString = t4;
            },
            NodeImporter__tryPath_closure: function NodeImporter__tryPath_closure(t0) {
                this.path = t0;
            },
            NodeImporter__tryPath_closure0: function NodeImporter__tryPath_closure0() {},
            NodeImporter__callImporterAsync_closure: function NodeImporter__callImporterAsync_closure(t0, t1, t2, t3, t4, t5) {
                var _ = this;
                _.$this = t0;
                _.importer = t1;
                _.forImport = t2;
                _.url = t3;
                _.previousString = t4;
                _.completer = t5;
            },
            ModifiableCssImport0: function ModifiableCssImport0(t0, t1, t2) {
                var _ = this;
                _.url = t0;
                _.modifiers = t1;
                _.span = t2;
                _._node$_indexInParent = _._node$_parent = null;
                _.isGroupEnd = false;
            },
            ImportCache$0: function(importers, loadPaths, packageConfig) {
                var t1 = type$.nullable_Record_3_Importer_and_Uri_and_Uri_originalUrl_2, t2 = type$.Record_3_Importer_and_Uri_and_bool_forImport_2, t3 = type$.Uri;
                return new A.ImportCache0(A.ImportCache__toImporters0(importers, loadPaths, packageConfig), A.LinkedHashMap_LinkedHashMap$_empty(type$.Record_2_Uri_and_bool_forImport, t1), A.LinkedHashMap_LinkedHashMap$_empty(t2, t1), A.LinkedHashMap_LinkedHashMap$_empty(t2, t3), A.LinkedHashMap_LinkedHashMap$_empty(t3, type$.nullable_Stylesheet_2), A.LinkedHashMap_LinkedHashMap$_empty(t3, type$.ImporterResult_2), A.LinkedHashMap_LinkedHashMap$_empty(t3, type$.DateTime));
            },
            ImportCache$none: function() {
                var t1 = type$.nullable_Record_3_Importer_and_Uri_and_Uri_originalUrl_2, t2 = type$.Record_3_Importer_and_Uri_and_bool_forImport_2, t3 = type$.Uri;
                return new A.ImportCache0(B.List_empty28, A.LinkedHashMap_LinkedHashMap$_empty(type$.Record_2_Uri_and_bool_forImport, t1), A.LinkedHashMap_LinkedHashMap$_empty(t2, t1), A.LinkedHashMap_LinkedHashMap$_empty(t2, t3), A.LinkedHashMap_LinkedHashMap$_empty(t3, type$.nullable_Stylesheet_2), A.LinkedHashMap_LinkedHashMap$_empty(t3, type$.ImporterResult_2), A.LinkedHashMap_LinkedHashMap$_empty(t3, type$.DateTime));
            },
            ImportCache__toImporters0: function(importers, loadPaths, packageConfig) {
                var t1, t2, t3, t4, _i, path, _null = null, sassPath = A.getEnvironmentVariable0("SASS_PATH");
                if (A.isBrowser()) {
                    t1 = A._setArrayType([], type$.JSArray_Importer_2);
                    if (importers != null) B.JSArray_methods.addAll$1(t1, importers);
                    return t1;
                }
                t1 = A._setArrayType([], type$.JSArray_Importer_2);
                if (importers != null) B.JSArray_methods.addAll$1(t1, importers);
                if (loadPaths != null) for(t2 = J.get$iterator$ax(loadPaths); t2.moveNext$0();){
                    t3 = t2.get$current(t2);
                    t1.push(new A.FilesystemImporter0($.$get$context().absolute$15(t3, _null, _null, _null, _null, _null, _null, _null, _null, _null, _null, _null, _null, _null, _null), false));
                }
                if (sassPath != null) {
                    t2 = A.isNodeJs() ? self.process : _null;
                    t3 = sassPath.split(J.$eq$(t2 == null ? _null : J.get$platform$x(t2), "win32") ? ";" : ":");
                    t4 = t3.length;
                    _i = 0;
                    for(; _i < t4; ++_i){
                        path = t3[_i];
                        t1.push(new A.FilesystemImporter0($.$get$context().absolute$15(path, _null, _null, _null, _null, _null, _null, _null, _null, _null, _null, _null, _null, _null, _null), false));
                    }
                }
                return t1;
            },
            ImportCache0: function ImportCache0(t0, t1, t2, t3, t4, t5, t6) {
                var _ = this;
                _._import_cache$_importers = t0;
                _._import_cache$_canonicalizeCache = t1;
                _._import_cache$_perImporterCanonicalizeCache = t2;
                _._import_cache$_nonCanonicalRelativeUrls = t3;
                _._import_cache$_importCache = t4;
                _._import_cache$_resultsCache = t5;
                _._import_cache$_loadTimes = t6;
            },
            ImportCache_canonicalize_closure0: function ImportCache_canonicalize_closure0(t0, t1, t2, t3, t4, t5, t6) {
                var _ = this;
                _.$this = t0;
                _.baseImporter = t1;
                _.resolvedUrl = t2;
                _.baseUrl = t3;
                _.forImport = t4;
                _.key = t5;
                _.url = t6;
            },
            ImportCache__canonicalize_closure0: function ImportCache__canonicalize_closure0(t0, t1) {
                this.importer = t0;
                this.url = t1;
            },
            ImportCache_importCanonical_closure0: function ImportCache_importCanonical_closure0(t0, t1, t2, t3) {
                var _ = this;
                _.$this = t0;
                _.importer = t1;
                _.canonicalUrl = t2;
                _.originalUrl = t3;
            },
            ImportCache_humanize_closure3: function ImportCache_humanize_closure3(t0) {
                this.canonicalUrl = t0;
            },
            ImportCache_humanize_closure4: function ImportCache_humanize_closure4() {},
            ImportCache_humanize_closure5: function ImportCache_humanize_closure5() {},
            ImportCache_humanize_closure6: function ImportCache_humanize_closure6(t0) {
                this.canonicalUrl = t0;
            },
            ImportRule0: function ImportRule0(t0, t1) {
                this.imports = t0;
                this.span = t1;
            },
            JSImporter: function JSImporter() {},
            JSImporterResult: function JSImporterResult() {},
            Importer0: function Importer0() {},
            NodeImporterResult0: function NodeImporterResult0() {},
            IncludeRule0: function IncludeRule0(t0, t1, t2, t3, t4, t5) {
                var _ = this;
                _.namespace = t0;
                _.name = t1;
                _.originalName = t2;
                _.$arguments = t3;
                _.content = t4;
                _.span = t5;
            },
            InterpolatedFunctionExpression0: function InterpolatedFunctionExpression0(t0, t1, t2) {
                this.name = t0;
                this.$arguments = t1;
                this.span = t2;
            },
            InterpolatedSelector: function InterpolatedSelector() {},
            Interpolation$0: function(contents, spans, span) {
                var t1 = new A.Interpolation0(A.List_List$unmodifiable(contents, type$.Object), A.List_List$unmodifiable(spans, type$.nullable_FileSpan), span);
                t1.Interpolation$30(contents, spans, span);
                return t1;
            },
            Interpolation0: function Interpolation0(t0, t1, t2) {
                this.contents = t0;
                this.spans = t1;
                this.span = t2;
            },
            Interpolation_toString_closure0: function Interpolation_toString_closure0() {},
            SupportsInterpolation0: function SupportsInterpolation0(t0, t1) {
                this.expression = t0;
                this.span = t1;
            },
            InterpolationBuffer0: function InterpolationBuffer0(t0, t1, t2) {
                this._interpolation_buffer0$_text = t0;
                this._interpolation_buffer0$_contents = t1;
                this._interpolation_buffer0$_spans = t2;
            },
            InterpolationMap$0: function(_interpolation, targetOffsets) {
                var t1 = A.List_List$unmodifiable(targetOffsets, type$.int), t2 = _interpolation.contents.length, expectedLocations = Math.max(0, t2 - 1);
                if (t1.length !== expectedLocations) A.throwExpression(A.ArgumentError$("InterpolationMap must have " + A.S(expectedLocations) + " targetOffsets if the interpolation has " + t2 + " components.", null));
                return new A.InterpolationMap0(_interpolation, t1);
            },
            InterpolationMap0: function InterpolationMap0(t0, t1) {
                this._interpolation_map$_interpolation = t0;
                this._interpolation_map$_targetOffsets = t1;
            },
            InterpolationMap_mapException_closure0: function InterpolationMap_mapException_closure0() {},
            InterpolationMethod$0: function(space, hue) {
                var t1;
                if (space.get$isPolarInternal()) t1 = hue == null ? B.HueInterpolationMethod_00 : hue;
                else t1 = null;
                if (!space.get$isPolarInternal() && hue != null) A.throwExpression(A.ArgumentError$(string$.Hue_in + space.toString$0(0) + ".", null));
                return new A.InterpolationMethod0(space, t1);
            },
            InterpolationMethod_InterpolationMethod$fromValue0: function(value, $name) {
                var t1, space, hueMethod, list = value.assertCommonListStyle$2$allowSlash($name, false);
                if (list.length === 0) throw A.wrapException(A.SassScriptException$0(string$.Expecta, $name));
                t1 = B.JSArray_methods.get$first(list).assertString$1($name);
                t1.assertUnquoted$1($name);
                space = A.ColorSpace_fromName0(t1._string0$_text, $name);
                if (list.length === 1) return A.InterpolationMethod$0(space, null);
                hueMethod = A.HueInterpolationMethod_HueInterpolationMethod$_fromValue0(list[1], $name);
                if (list.length === 2) throw A.wrapException(A.SassScriptException$0('Expected unquoted string "hue" after ' + value.toString$0(0) + ".", $name));
                else {
                    t1 = list[2].assertString$1($name);
                    t1.assertUnquoted$1($name);
                    if (t1._string0$_text.toLowerCase() !== "hue") throw A.wrapException(A.SassScriptException$0(string$.Expectu + value.toString$0(0) + ", was " + list[2].toString$0(0) + ".", $name));
                    else if (list.length > 3) throw A.wrapException(A.SassScriptException$0('Expected nothing after "hue" in ' + value.toString$0(0) + ".", $name));
                    else if (!space.get$isPolarInternal()) throw A.wrapException(A.SassScriptException$0('Hue interpolation method "' + hueMethod.toString$0(0) + string$.x20hue__ + space.toString$0(0) + ".", $name));
                }
                return A.InterpolationMethod$0(space, hueMethod);
            },
            HueInterpolationMethod_HueInterpolationMethod$_fromValue0: function(value, $name) {
                var _0_0, t1 = value.assertString$1($name);
                t1.assertUnquoted$0();
                _0_0 = t1._string0$_text.toLowerCase();
                $label0$0: {
                    if ("shorter" === _0_0) {
                        t1 = B.HueInterpolationMethod_00;
                        break $label0$0;
                    }
                    if ("longer" === _0_0) {
                        t1 = B.HueInterpolationMethod_10;
                        break $label0$0;
                    }
                    if ("increasing" === _0_0) {
                        t1 = B.HueInterpolationMethod_20;
                        break $label0$0;
                    }
                    if ("decreasing" === _0_0) {
                        t1 = B.HueInterpolationMethod_30;
                        break $label0$0;
                    }
                    t1 = A.throwExpression(A.SassScriptException$0("Unknown hue interpolation method " + value.toString$0(0) + ".", $name));
                }
                return t1;
            },
            InterpolationMethod0: function InterpolationMethod0(t0, t1) {
                this.space = t0;
                this.hue = t1;
            },
            HueInterpolationMethod0: function HueInterpolationMethod0(t0, t1) {
                this.index = t0;
                this._name = t1;
            },
            _realCasePath0: function(path) {
                var prefix, _null = null, t1 = A.isNodeJs() ? self.process : _null;
                if (!J.$eq$(t1 == null ? _null : J.get$platform$x(t1), "win32")) {
                    t1 = A.isNodeJs() ? self.process : _null;
                    t1 = J.$eq$(t1 == null ? _null : J.get$platform$x(t1), "darwin");
                } else t1 = true;
                if (!t1) return path;
                t1 = A.isNodeJs() ? self.process : _null;
                if (J.$eq$(t1 == null ? _null : J.get$platform$x(t1), "win32")) {
                    prefix = B.JSString_methods.substring$2(path, 0, $.$get$context().style.rootLength$1(path));
                    t1 = prefix.length;
                    if (t1 !== 0 && A.CharacterExtension_get_isAlphabetic0(prefix.charCodeAt(0))) path = prefix.toUpperCase() + B.JSString_methods.substring$1(path, t1);
                }
                return new A._realCasePath_helper0().call$1(path);
            },
            _realCasePath_helper0: function _realCasePath_helper0() {},
            _realCasePath_helper_closure0: function _realCasePath_helper_closure0(t0, t1, t2, t3) {
                var _ = this;
                _.path = t0;
                _.realPath = t1;
                _.helper = t2;
                _.dirname = t3;
            },
            _realCasePath_helper__closure0: function _realCasePath_helper__closure0(t0) {
                this.basename = t0;
            },
            IsCalculationSafeVisitor0: function IsCalculationSafeVisitor0() {},
            IsCalculationSafeVisitor_visitListExpression_closure0: function IsCalculationSafeVisitor_visitListExpression_closure0(t0) {
                this.$this = t0;
            },
            IsPlainCssVisitor0: function IsPlainCssVisitor0(t0) {
                this._is_plain_css$_allowInterpolation = t0;
            },
            IsPlainCssVisitor_visitIfExpression_closure0: function IsPlainCssVisitor_visitIfExpression_closure0(t0) {
                this.$this = t0;
            },
            IsPlainCssVisitor_visitListExpression_closure0: function IsPlainCssVisitor_visitListExpression_closure0(t0) {
                this.$this = t0;
            },
            IsPlainCssVisitor_visitIfConditionOperation_closure0: function IsPlainCssVisitor_visitIfConditionOperation_closure0(t0) {
                this.$this = t0;
            },
            IsPlainCssVisitor__visitArgumentList_closure0: function IsPlainCssVisitor__visitArgumentList_closure0(t0) {
                this.$this = t0;
            },
            printError0: function(message) {
                var t2, t1 = A.isNodeJs() ? self.process : null;
                if (t1 != null) {
                    t1 = J.get$stderr$x(t1);
                    J.write$1$x(t1, A.S(message) + "\n");
                } else {
                    t1 = self.console;
                    t2 = J.toString$0$(message);
                    J.error$1$x(t1, t2);
                }
            },
            readFile0: function(path) {
                var contents, sourceFile, t1, i;
                if (!A.isNodeJs()) throw A.wrapException(A.UnsupportedError$("readFile() is only supported on Node.js"));
                contents = A._asString(A._readFile0(path, "utf8"));
                if (!B.JSString_methods.contains$1(contents, "\ufffd")) return contents;
                sourceFile = A.SourceFile$fromString(contents, $.$get$context().toUri$1(path));
                for(t1 = contents.length, i = 0; i < t1; ++i){
                    if (contents.charCodeAt(i) !== 65533) continue;
                    throw A.wrapException(A.SassException$0("Invalid UTF-8.", A.FileLocation$_(sourceFile, i).pointSpan$0(), null));
                }
                return contents;
            },
            _readFile0: function(path, encoding) {
                return A._systemErrorToFileSystemException0(new A._readFile_closure0(path, encoding));
            },
            fileExists0: function(path) {
                if (!A.isNodeJs()) throw A.wrapException(A.UnsupportedError$(string$.fileEx));
                return A._systemErrorToFileSystemException0(new A.fileExists_closure0(path));
            },
            dirExists0: function(path) {
                if (!A.isNodeJs()) throw A.wrapException(A.UnsupportedError$("dirExists() is only supported on Node.js"));
                return A._systemErrorToFileSystemException0(new A.dirExists_closure0(path));
            },
            linkExists0: function(path) {
                if (!A.isNodeJs()) throw A.wrapException(A.UnsupportedError$(string$.linkEx));
                return A._systemErrorToFileSystemException0(new A.linkExists_closure0(path));
            },
            listDir0: function(path) {
                if (!A.isNodeJs()) throw A.wrapException(A.UnsupportedError$("listDir() is only supported on Node.js"));
                return A._systemErrorToFileSystemException0(new A.listDir_closure0(false, path));
            },
            realpath0: function(path) {
                if (!A.isNodeJs()) throw A.wrapException(A.UnsupportedError$("listDir() is only supported on Node.js"));
                return A._systemErrorToFileSystemException0(new A.realpath_closure0(path));
            },
            getEnvironmentVariable0: function($name) {
                var t1 = A.isNodeJs() ? self.process : null, env = t1 == null ? null : J.get$env$x(t1);
                if (env == null) t1 = null;
                else t1 = A._asStringQ(env[$name]);
                return t1;
            },
            _systemErrorToFileSystemException0: function(callback) {
                var error, t1, _$exception, t2;
                try {
                    t1 = callback.call$0();
                    return t1;
                } catch (exception) {
                    error = A.unwrapException(exception);
                    if (!type$.JsSystemError._is(error)) throw exception;
                    t1 = error;
                    t2 = J.getInterceptor$x(t1);
                    throw A.wrapException(new A.FileSystemException0(J.substring$2$s(t2.get$message(t1), (A.S(t2.get$code(t1)) + ": ").length, J.get$length$asx(t2.get$message(t1)) - (", " + A.S(t2.get$syscall(t1)) + " '" + A.S(t2.get$path(t1)) + "'").length), J.get$path$x(error)));
                }
            },
            hasTerminal0: function() {
                var t1 = A.isNodeJs() ? self.process : null;
                return J.$eq$(t1 == null ? null : J.get$isTTY$x(J.get$stdout$x(t1)), true);
            },
            FileSystemException0: function FileSystemException0(t0, t1) {
                this.message = t0;
                this.path = t1;
            },
            _readFile_closure0: function _readFile_closure0(t0, t1) {
                this.path = t0;
                this.encoding = t1;
            },
            fileExists_closure0: function fileExists_closure0(t0) {
                this.path = t0;
            },
            dirExists_closure0: function dirExists_closure0(t0) {
                this.path = t0;
            },
            linkExists_closure0: function linkExists_closure0(t0) {
                this.path = t0;
            },
            listDir_closure0: function listDir_closure0(t0, t1) {
                this.recursive = t0;
                this.path = t1;
            },
            listDir__closure1: function listDir__closure1(t0) {
                this.path = t0;
            },
            listDir__closure2: function listDir__closure2() {},
            listDir_closure_list0: function listDir_closure_list0() {},
            listDir__list_closure0: function listDir__list_closure0(t0, t1) {
                this.parent = t0;
                this.list = t1;
            },
            realpath_closure0: function realpath_closure0(t0) {
                this.path = t0;
            },
            main: function() {
                J.set$compile$x(self.exports, A.allowInteropNamed("sass.compile", A.compile__compile$closure()));
                J.set$compileString$x(self.exports, A.allowInteropNamed("sass.compileString", A.compile__compileString$closure()));
                J.set$compileAsync$x(self.exports, A.allowInteropNamed("sass.compileAsync", A.compile__compileAsync$closure()));
                J.set$compileStringAsync$x(self.exports, A.allowInteropNamed("sass.compileStringAsync", A.compile__compileStringAsync$closure()));
                J.set$initCompiler$x(self.exports, A.allowInteropNamed("sass.initCompiler", A.compiler__initCompiler$closure()));
                J.set$initAsyncCompiler$x(self.exports, A.allowInteropNamed("sass.initAsyncCompiler", A.compiler__initAsyncCompiler$closure()));
                J.set$Compiler$x(self.exports, $.$get$compilerClass());
                J.set$AsyncCompiler$x(self.exports, $.$get$asyncCompilerClass());
                J.set$Value$x(self.exports, $.$get$valueClass());
                J.set$SassBoolean$x(self.exports, $.$get$booleanClass());
                J.set$SassArgumentList$x(self.exports, $.$get$argumentListClass());
                J.set$SassCalculation$x(self.exports, $.$get$calculationClass());
                J.set$CalculationOperation$x(self.exports, $.$get$calculationOperationClass());
                J.set$CalculationInterpolation$x(self.exports, $.$get$calculationInterpolationClass());
                J.set$SassColor$x(self.exports, $.$get$colorClass());
                J.set$SassFunction$x(self.exports, $.$get$functionClass());
                J.set$SassMixin$x(self.exports, $.$get$mixinClass());
                J.set$SassList$x(self.exports, $.$get$listClass());
                J.set$SassMap$x(self.exports, $.$get$mapClass());
                J.set$SassNumber$x(self.exports, $.$get$numberClass());
                J.set$SassString$x(self.exports, $.$get$stringClass());
                J.set$sassNull$x(self.exports, B.C__SassNull0);
                J.set$sassTrue$x(self.exports, B.SassBoolean_true0);
                J.set$sassFalse$x(self.exports, B.SassBoolean_false0);
                J.set$Exception$x(self.exports, $.$get$exceptionClass());
                J.set$Logger$x(self.exports, {
                    silent: {
                        warn: A.allowInteropNamed("sass.Logger.silent.warn", new A.main_closure()),
                        debug: A.allowInteropNamed("sass.Logger.silent.debug", new A.main_closure0())
                    }
                });
                J.set$NodePackageImporter$x(self.exports, $.$get$nodePackageImporterClass());
                J.set$deprecations$x(self.exports, A.jsify($.$get$deprecations()));
                J.set$Version$x(self.exports, $.$get$versionClass());
                J.set$loadParserExports_$x(self.exports, A.allowInterop(A.parser0__loadParserExports$closure()));
                J.set$info$x(self.exports, "dart-sass\t1.101.0\t(Sass Compiler)\t[Dart]\ndart2js\t3.12.2\t(Dart Compiler)\t[Dart]");
                A.updateCanonicalizeContextPrototype();
                A.updateSourceSpanPrototype();
                J.set$render$x(self.exports, A.allowInteropNamed("sass.render", A.legacy__render$closure()));
                J.set$renderSync$x(self.exports, A.allowInteropNamed("sass.renderSync", A.legacy__renderSync$closure()));
                J.set$types$x(self.exports, {
                    Boolean: $.$get$legacyBooleanClass(),
                    Color: $.$get$legacyColorClass(),
                    List: $.$get$legacyListClass(),
                    Map: $.$get$legacyMapClass(),
                    Null: $.$get$legacyNullClass(),
                    Number: $.$get$legacyNumberClass(),
                    String: $.$get$legacyStringClass(),
                    Error: self.Error
                });
                J.set$NULL$x(self.exports, B.C__SassNull0);
                J.set$TRUE$x(self.exports, B.SassBoolean_true0);
                J.set$FALSE$x(self.exports, B.SassBoolean_false0);
            },
            main_closure: function main_closure() {},
            main_closure0: function main_closure0() {},
            JSToDartLogger: function JSToDartLogger(t0, t1, t2) {
                this._node = t0;
                this._fallback = t1;
                this._ascii = t2;
            },
            JSToDartLogger_internalWarn_closure: function JSToDartLogger_internalWarn_closure(t0, t1, t2, t3, t4) {
                var _ = this;
                _.$this = t0;
                _.message = t1;
                _.span = t2;
                _.trace = t3;
                _.deprecation = t4;
            },
            JSToDartLogger_debug_closure: function JSToDartLogger_debug_closure(t0, t1, t2) {
                this.$this = t0;
                this.message = t1;
                this.span = t2;
            },
            ModifiableCssKeyframeBlock$0: function(selector, span) {
                var t1 = A._setArrayType([], type$.JSArray_ModifiableCssNode_2);
                return new A.ModifiableCssKeyframeBlock0(selector, span, new A.UnmodifiableListView(t1, type$.UnmodifiableListView_ModifiableCssNode_2), t1);
            },
            ModifiableCssKeyframeBlock0: function ModifiableCssKeyframeBlock0(t0, t1, t2, t3) {
                var _ = this;
                _.selector = t0;
                _.span = t1;
                _.children = t2;
                _._node$_children = t3;
                _._node$_indexInParent = _._node$_parent = null;
                _.isGroupEnd = false;
            },
            KeyframeSelectorParser0: function KeyframeSelectorParser0(t0, t1) {
                this.scanner = t0;
                this._parser1$_interpolationMap = t1;
            },
            KeyframeSelectorParser_parse_closure0: function KeyframeSelectorParser_parse_closure0(t0) {
                this.$this = t0;
            },
            LabColorSpace0: function LabColorSpace0(t0, t1) {
                this.name = t0;
                this._space$_channels = t1;
            },
            LazyFileSpan0: function LazyFileSpan0(t0) {
                this._lazy_file_span0$_builder = t0;
                this._lazy_file_span0$_span = null;
            },
            LchColorSpace0: function LchColorSpace0(t0, t1) {
                this.name = t0;
                this._space$_channels = t1;
            },
            render: function(options, callback) {
                var _0_0;
                if (!A.isNodeJs()) A.jsThrow(new self.Error("The render() method is only available in Node.js."));
                _0_0 = J.get$fiber$x(options);
                if (_0_0 != null) J.run$0$x(_0_0.call$1(A.allowInterop(new A.render_closure(callback, options))));
                else A._renderAsync(options).then$1$2$onError(0, new A.render_closure0(callback), new A.render_closure1(callback), type$.Null);
            },
            _renderAsync: function(options) {
                var $async$goto = 0, $async$completer = A._makeAsyncAwaitCompleter(type$.RenderResult), $async$returnValue, t4, t5, t6, t7, t8, t9, t10, t11, t12, t13, t14, t15, result, start, t1, file, t2, t3, logger, _0_0;
                var $async$_renderAsync = A._wrapJsFunctionForAsync(function($async$errorCode, $async$result) {
                    if ($async$errorCode === 1) return A._asyncRethrow($async$result, $async$completer);
                    for(;;)switch($async$goto){
                        case 0:
                            // Function start
                            start = new A.DateTime(Date.now(), 0, false);
                            t1 = J.getInterceptor$x(options);
                            file = A.NullableExtension_andThen0(t1.get$file(options), A.path__absolute$closure());
                            t2 = t1.get$logger(options);
                            t3 = $._glyphs;
                            logger = new A.JSToDartLogger(t2, B.C_DefaultLogger0, t3 === B.C_AsciiGlyphSet);
                            _0_0 = t1.get$data(options);
                            $async$goto = _0_0 != null ? 3 : 5;
                            break;
                        case 3:
                            // then
                            t2 = A._parseImporter(options, start);
                            t3 = A._parsePackageImportersAsync(options, start);
                            t4 = A._parseFunctions(options, start, true);
                            t5 = t1.get$indentedSyntax(options);
                            t5 = !J.$eq$(t5, false) && t5 != null ? B.Syntax_Sass_1_sass0 : null;
                            t6 = A._parseOutputStyle(t1.get$outputStyle(options));
                            t7 = J.$eq$(t1.get$indentType(options), "tab");
                            t8 = A._parseIndentWidth(t1.get$indentWidth(options));
                            t9 = A._parseLineFeed(t1.get$linefeed(options));
                            t10 = file == null ? "stdin" : $.$get$context().toUri$1(file).toString$0(0);
                            t11 = t1.get$quietDeps(options);
                            if (t11 == null) t11 = false;
                            t12 = A.parseDeprecations(logger, t1.get$fatalDeprecations(options), true);
                            t13 = A.parseDeprecations(logger, t1.get$futureDeprecations(options), false);
                            t14 = A.parseDeprecations(logger, t1.get$silenceDeprecations(options), false);
                            t15 = t1.get$verbose(options);
                            if (t15 == null) t15 = false;
                            t1 = t1.get$charset(options);
                            if (t1 == null) t1 = true;
                            $async$goto = 6;
                            return A._asyncAwait(A.compileStringAsync0(_0_0, t1, t12, t4, t13, t3, null, t8, t9, logger, t2, t11, t14, A._enableSourceMaps(options), t6, t5, t10, !t7, t15), $async$_renderAsync);
                        case 6:
                            // returning from await.
                            result = $async$result;
                            // goto join
                            $async$goto = 4;
                            break;
                        case 5:
                            // else
                            $async$goto = file != null ? 7 : 9;
                            break;
                        case 7:
                            // then
                            t2 = A._parseImporter(options, start);
                            t3 = A._parsePackageImportersAsync(options, start);
                            t4 = A._parseFunctions(options, start, true);
                            t5 = t1.get$indentedSyntax(options);
                            t5 = !J.$eq$(t5, false) && t5 != null ? B.Syntax_Sass_1_sass0 : null;
                            t6 = A._parseOutputStyle(t1.get$outputStyle(options));
                            t7 = J.$eq$(t1.get$indentType(options), "tab");
                            t8 = A._parseIndentWidth(t1.get$indentWidth(options));
                            t9 = A._parseLineFeed(t1.get$linefeed(options));
                            t10 = t1.get$quietDeps(options);
                            if (t10 == null) t10 = false;
                            t11 = A.parseDeprecations(logger, t1.get$fatalDeprecations(options), true);
                            t12 = A.parseDeprecations(logger, t1.get$futureDeprecations(options), false);
                            t13 = A.parseDeprecations(logger, t1.get$silenceDeprecations(options), false);
                            t14 = t1.get$verbose(options);
                            if (t14 == null) t14 = false;
                            t1 = t1.get$charset(options);
                            if (t1 == null) t1 = true;
                            $async$goto = 10;
                            return A._asyncAwait(A.compileAsync0(file, t1, t11, t4, t12, t3, t8, t9, logger, t2, t10, t13, A._enableSourceMaps(options), t6, t5, !t7, t14), $async$_renderAsync);
                        case 10:
                            // returning from await.
                            result = $async$result;
                            // goto join
                            $async$goto = 8;
                            break;
                        case 9:
                            // else
                            throw A.wrapException(A.ArgumentError$(string$.Either, null));
                        case 8:
                        // join
                        case 4:
                            // join
                            $async$returnValue = A._newRenderResult(options, result, start);
                            // goto return
                            $async$goto = 1;
                            break;
                        case 1:
                            // return
                            return A._asyncReturn($async$returnValue, $async$completer);
                    }
                });
                return A._asyncStartSync($async$_renderAsync, $async$completer);
            },
            renderSync: function(options) {
                var start, result, file, logger, _0_0, data, error, stackTrace, error0, stackTrace0, t1, t2, t3, t4, t5, t6, t7, t8, t9, t10, t11, t12, t13, t14, t15, t16, _$exception, _null = null;
                if (!A.isNodeJs()) A.jsThrow(new self.Error("The renderSync() method is only available in Node.js."));
                try {
                    start = new A.DateTime(Date.now(), 0, false);
                    result = null;
                    t1 = J.getInterceptor$x(options);
                    file = A.NullableExtension_andThen0(t1.get$file(options), A.path__absolute$closure());
                    t2 = t1.get$logger(options);
                    t3 = $._glyphs;
                    logger = new A.JSToDartLogger(t2, B.C_DefaultLogger0, t3 === B.C_AsciiGlyphSet);
                    _0_0 = t1.get$data(options);
                    data = null;
                    if (_0_0 != null) {
                        data = _0_0;
                        t2 = data;
                        t3 = A._parseImporter(options, start);
                        t4 = A._parsePackageImporters(options, start);
                        t5 = A._parseFunctions(options, start, false);
                        t6 = t1.get$indentedSyntax(options);
                        t6 = !J.$eq$(t6, false) && t6 != null ? B.Syntax_Sass_1_sass0 : _null;
                        t7 = A._parseOutputStyle(t1.get$outputStyle(options));
                        t8 = J.$eq$(t1.get$indentType(options), "tab");
                        t9 = A._parseIndentWidth(t1.get$indentWidth(options));
                        t10 = A._parseLineFeed(t1.get$linefeed(options));
                        t11 = file == null ? "stdin" : $.$get$context().toUri$1(file).toString$0(0);
                        t12 = t1.get$quietDeps(options);
                        if (t12 == null) t12 = false;
                        t13 = A.parseDeprecations(logger, t1.get$fatalDeprecations(options), true);
                        t14 = A.parseDeprecations(logger, t1.get$futureDeprecations(options), false);
                        t15 = A.parseDeprecations(logger, t1.get$silenceDeprecations(options), false);
                        t16 = t1.get$verbose(options);
                        if (t16 == null) t16 = false;
                        t1 = t1.get$charset(options);
                        if (t1 == null) t1 = true;
                        result = A.compileString(t2, t1, t13, new A.CastList(t5, A._arrayInstanceType(t5)._eval$1("CastList<1,Callable>")), t14, t4, _null, t9, t10, logger, t3, t12, t15, A._enableSourceMaps(options), t7, t6, t11, !t8, t16);
                    } else if (file != null) {
                        t2 = A._parseImporter(options, start);
                        t3 = A._parsePackageImporters(options, start);
                        t4 = A._parseFunctions(options, start, false);
                        t5 = t1.get$indentedSyntax(options);
                        t5 = !J.$eq$(t5, false) && t5 != null ? B.Syntax_Sass_1_sass0 : _null;
                        t6 = A._parseOutputStyle(t1.get$outputStyle(options));
                        t7 = J.$eq$(t1.get$indentType(options), "tab");
                        t8 = A._parseIndentWidth(t1.get$indentWidth(options));
                        t9 = A._parseLineFeed(t1.get$linefeed(options));
                        t10 = t1.get$quietDeps(options);
                        if (t10 == null) t10 = false;
                        t11 = A.parseDeprecations(logger, t1.get$fatalDeprecations(options), true);
                        t12 = A.parseDeprecations(logger, t1.get$futureDeprecations(options), false);
                        t13 = A.parseDeprecations(logger, t1.get$silenceDeprecations(options), false);
                        t14 = t1.get$verbose(options);
                        if (t14 == null) t14 = false;
                        t1 = t1.get$charset(options);
                        if (t1 == null) t1 = true;
                        result = A.compile(file, t1, t11, new A.CastList(t4, A._arrayInstanceType(t4)._eval$1("CastList<1,Callable>")), t12, t3, t8, t9, logger, t2, t10, t13, A._enableSourceMaps(options), t6, t5, !t7, t14);
                    } else {
                        t1 = A.ArgumentError$(string$.Either, _null);
                        throw A.wrapException(t1);
                    }
                    t1 = A._newRenderResult(options, result, start);
                    return t1;
                } catch (exception) {
                    t1 = A.unwrapException(exception);
                    if (t1 instanceof A.SassException0) {
                        error = t1;
                        stackTrace = A.getTraceFromException(exception);
                        A.jsThrow(A._wrapException(error, stackTrace));
                    } else {
                        error0 = t1;
                        stackTrace0 = A.getTraceFromException(exception);
                        t1 = J.toString$0$(error0);
                        t2 = A.getTrace0(error0);
                        A.jsThrow(A._newRenderError(t1, t2 == null ? stackTrace0 : t2, _null, _null, _null, 3));
                    }
                }
            },
            _wrapException: function(exception, stackTrace) {
                var t2, t3, t4, t5, t1 = A.SourceSpanException.prototype.get$span.call(exception, 0), _0_0 = t1.get$sourceUrl(t1);
                $label0$0: {
                    if (_0_0 == null) {
                        t1 = "stdin";
                        break $label0$0;
                    }
                    if ("file" === _0_0.get$scheme()) {
                        t1 = $.$get$context().style.pathFromUri$1(A._parseUri(_0_0));
                        break $label0$0;
                    }
                    t1 = _0_0.toString$0(0);
                    break $label0$0;
                }
                t2 = B.JSString_methods.replaceFirst$2(exception.toString$0(0), "Error: ", "");
                t3 = A.getTrace0(exception);
                if (t3 == null) t3 = stackTrace;
                t4 = A.SourceSpanException.prototype.get$span.call(exception, 0);
                t4 = t4.get$start(t4);
                t4 = t4.file.getLine$1(t4.offset);
                t5 = A.SourceSpanException.prototype.get$span.call(exception, 0);
                t5 = t5.get$start(t5);
                return A._newRenderError(t2, t3, t5.file.getColumn$1(t5.offset) + 1, t1, t4 + 1, 1);
            },
            _parseFunctions: function(options, start, asynch) {
                var result, functions = J.get$functions$x(options);
                if (functions == null) return B.List_empty29;
                result = A._setArrayType([], type$.JSArray_AsyncCallable_2);
                A.jsForEach(functions, new A._parseFunctions_closure(options, start, result, asynch));
                return result;
            },
            _parseImporter: function(options, start) {
                var t2, t3, contextOptions, _1_0, t4, importers, t1 = J.getInterceptor$x(options), _0_0 = t1.get$importer(options);
                $label0$0: {
                    if (_0_0 == null) {
                        t2 = A._setArrayType([], type$.JSArray_JSFunction);
                        break $label0$0;
                    }
                    if (type$.List_dynamic._is(_0_0)) {
                        t2 = J.cast$1$0$ax(_0_0, type$.JSFunction);
                        break $label0$0;
                    }
                    t2 = A._setArrayType([
                        type$.JSFunction._as(_0_0)
                    ], type$.JSArray_JSFunction);
                    break $label0$0;
                }
                t3 = J.getInterceptor$asx(t2);
                contextOptions = t3.get$isNotEmpty(t2) ? A._contextOptions(options, start) : new A.Object();
                _1_0 = t1.get$fiber(options);
                t4 = {};
                t4.fiber = null;
                if (_1_0 != null) {
                    t4.fiber = _1_0;
                    t2 = t3.map$1$1(t2, new A._parseImporter_closure(t4), type$.JSFunction);
                    importers = A.List_List$_of(t2, t2.$ti._eval$1("ListIterable.E"));
                } else importers = t2;
                t1 = t1.get$includePaths(options);
                if (t1 == null) t1 = [];
                t2 = type$.String;
                return new A.NodeImporter(contextOptions, A.List_List$unmodifiable(A.NodeImporter__addSassPath(A.List_List$from(t1, true, t2)), t2), A.List_List$unmodifiable(J.cast$1$0$ax(importers, type$.dynamic), type$.JSFunction));
            },
            _parsePackageImportersAsync: function(options, start) {
                var t2, t3, t4, t1 = J.getInterceptor$x(options);
                if (t1.get$pkgImporter(options) instanceof A.NodePackageImporter0) {
                    t1 = t1.get$pkgImporter(options);
                    t1.toString;
                    t2 = type$.nullable_Record_3_AsyncImporter_and_Uri_and_Uri_originalUrl_2;
                    t3 = type$.Record_3_AsyncImporter_and_Uri_and_bool_forImport_2;
                    t4 = type$.Uri;
                    return new A.AsyncImportCache0(A.List_List$unmodifiable(A._setArrayType([
                        t1
                    ], type$.JSArray_AsyncImporter), type$.AsyncImporter), A.LinkedHashMap_LinkedHashMap$_empty(type$.Record_2_Uri_and_bool_forImport, t2), A.LinkedHashMap_LinkedHashMap$_empty(t3, t2), A.LinkedHashMap_LinkedHashMap$_empty(t3, t4), A.LinkedHashMap_LinkedHashMap$_empty(t4, type$.nullable_Stylesheet_2), A.LinkedHashMap_LinkedHashMap$_empty(t4, type$.ImporterResult_2), A.LinkedHashMap_LinkedHashMap$_empty(t4, type$.DateTime));
                }
                return null;
            },
            _parsePackageImporters: function(options, start) {
                var t2, t3, t4, t1 = J.getInterceptor$x(options);
                if (t1.get$pkgImporter(options) instanceof A.NodePackageImporter0) {
                    t1 = t1.get$pkgImporter(options);
                    t1.toString;
                    t2 = type$.nullable_Record_3_Importer_and_Uri_and_Uri_originalUrl_2;
                    t3 = type$.Record_3_Importer_and_Uri_and_bool_forImport_2;
                    t4 = type$.Uri;
                    return new A.ImportCache0(A.List_List$unmodifiable(A._setArrayType([
                        t1
                    ], type$.JSArray_Importer_2), type$.Importer), A.LinkedHashMap_LinkedHashMap$_empty(type$.Record_2_Uri_and_bool_forImport, t2), A.LinkedHashMap_LinkedHashMap$_empty(t3, t2), A.LinkedHashMap_LinkedHashMap$_empty(t3, t4), A.LinkedHashMap_LinkedHashMap$_empty(t4, type$.nullable_Stylesheet_2), A.LinkedHashMap_LinkedHashMap$_empty(t4, type$.ImporterResult_2), A.LinkedHashMap_LinkedHashMap$_empty(t4, type$.DateTime));
                }
                return null;
            },
            _contextOptions: function(options, start) {
                var includePaths, t3, t4, t5, t6, t7, t1 = J.getInterceptor$x(options), t2 = t1.get$includePaths(options);
                if (t2 == null) t2 = [];
                includePaths = A.List_List$from(t2, true, type$.String);
                t2 = t1.get$file(options);
                t3 = t1.get$data(options);
                t4 = A._setArrayType([
                    A.current()
                ], type$.JSArray_String);
                B.JSArray_methods.addAll$1(t4, includePaths);
                t5 = A.isNodeJs() ? self.process : null;
                t4 = B.JSArray_methods.join$1(t4, J.$eq$(t5 == null ? null : J.get$platform$x(t5), "win32") ? ";" : ":");
                t5 = J.$eq$(t1.get$indentType(options), "tab") ? 1 : 0;
                t6 = A._parseIndentWidth(t1.get$indentWidth(options));
                if (t6 == null) t6 = 2;
                t7 = A._parseLineFeed(t1.get$linefeed(options));
                t1 = t1.get$file(options);
                if (t1 == null) t1 = "data";
                return {
                    file: t2,
                    data: t3,
                    includePaths: t4,
                    precision: 10,
                    style: 1,
                    indentType: t5,
                    indentWidth: t6,
                    linefeed: t7.text,
                    result: {
                        stats: {
                            start: start._value,
                            entry: t1
                        }
                    }
                };
            },
            _parseOutputStyle: function(style) {
                var t1;
                $label0$0: {
                    if (style == null || "expanded" === style) {
                        t1 = B.OutputStyle_00;
                        break $label0$0;
                    }
                    if ("compressed" === style) {
                        t1 = B.OutputStyle_10;
                        break $label0$0;
                    }
                    t1 = A.jsThrow(new self.Error('Unknown output style "' + style + '".'));
                }
                return t1;
            },
            _parseIndentWidth: function(width) {
                var t1;
                $label0$0: {
                    if (width == null) {
                        t1 = null;
                        break $label0$0;
                    }
                    if (A._isInt(width)) {
                        t1 = width;
                        break $label0$0;
                    }
                    t1 = A.int_parse(J.toString$0$(width), null);
                    break $label0$0;
                }
                return t1;
            },
            _parseLineFeed: function(str) {
                var t1;
                $label0$0: {
                    if ("cr" === str) {
                        t1 = B.LineFeed_3HY;
                        break $label0$0;
                    }
                    if ("crlf" === str) {
                        t1 = B.LineFeed_aqi;
                        break $label0$0;
                    }
                    if ("lfcr" === str) {
                        t1 = B.LineFeed_Kui;
                        break $label0$0;
                    }
                    t1 = B.LineFeed_oJz;
                    break $label0$0;
                }
                return t1;
            },
            _newRenderResult: function(options, result, start) {
                var t3, sourceMapOption, sourceMapPath, t4, sourceMapDir, outFile, t5, _0_0, t6, sourceMapDirUrl, i, source, t7, buffer, indices, url, t8, _null = null, t1 = Date.now(), t2 = result._compile_result$_serialize, css = t2._0, sourceMapBytes = self.undefined;
                if (A._enableSourceMaps(options)) {
                    t3 = J.getInterceptor$x(options);
                    sourceMapOption = t3.get$sourceMap(options);
                    if (typeof sourceMapOption == "string") sourceMapPath = sourceMapOption;
                    else {
                        t4 = t3.get$outFile(options);
                        t4.toString;
                        sourceMapPath = J.$add$ansx(t4, ".map");
                    }
                    t4 = $.$get$context();
                    sourceMapDir = t4.dirname$1(sourceMapPath);
                    t2 = t2._1;
                    t2.toString;
                    t2.sourceRoot = t3.get$sourceMapRoot(options);
                    outFile = t3.get$outFile(options);
                    t5 = outFile == null;
                    if (t5) {
                        _0_0 = t3.get$file(options);
                        $label0$0: {
                            if (_0_0 != null) {
                                t6 = t4.toUri$1(t4.withoutExtension$1(_0_0) + ".css").toString$0(0);
                                break $label0$0;
                            }
                            t6 = t2.targetUrl = "stdin.css";
                            break $label0$0;
                        }
                        t2.targetUrl = t6;
                    } else t2.targetUrl = t4.toUri$1(t4.relative$2$from(outFile, sourceMapDir)).toString$0(0);
                    sourceMapDirUrl = t4.toUri$1(sourceMapDir).toString$0(0);
                    for(t4 = t2.urls, i = 0; i < t4.length; ++i){
                        source = t4[i];
                        if (source === "stdin") continue;
                        t6 = $.$get$url();
                        t7 = t6.style;
                        if (t7.rootLength$1(source) <= 0 || t7.isRootRelative$1(source)) continue;
                        t4[i] = t6.relative$2$from(source, sourceMapDirUrl);
                    }
                    t4 = t3.get$sourceMapContents(options);
                    sourceMapBytes = self.Buffer.from(B.C_JsonCodec.encode$2$toEncodable(t2.toJson$1$includeSourceContents(!J.$eq$(t4, false) && t4 != null), _null), "utf8");
                    t2 = t3.get$omitSourceMapUrl(options);
                    if (!(!J.$eq$(t2, false) && t2 != null)) {
                        t2 = t3.get$sourceMapEmbed(options);
                        if (!J.$eq$(t2, false) && t2 != null) {
                            buffer = new A.StringBuffer("");
                            indices = A._setArrayType([
                                -1
                            ], type$.JSArray_int);
                            A.UriData__writeUri("application/json", _null, _null, buffer, indices);
                            indices.push(buffer._contents.length);
                            indices.push((buffer._contents += ";base64,").length - 1);
                            t2 = B.C_Base64Encoder.startChunkedConversion$1(new A._StringSinkConversionSink(buffer));
                            t3 = sourceMapBytes.length;
                            A.RangeError_checkValidRange(0, t3, t3);
                            t2._convert$_add$4(sourceMapBytes, 0, t3, true);
                            t2 = buffer._contents;
                            url = new A.UriData(t2.charCodeAt(0) == 0 ? t2 : t2, indices, _null).get$uri();
                        } else {
                            if (t5) t2 = sourceMapPath;
                            else {
                                t2 = $.$get$context();
                                t2 = t2.relative$2$from(sourceMapPath, t2.dirname$1(outFile));
                            }
                            url = $.$get$context().toUri$1(t2);
                        }
                        t2 = url.toString$0(0);
                        css += "\n\n/*# sourceMappingURL=" + A.stringReplaceAllUnchecked(t2, "*/", "%2A/") + " */";
                    }
                }
                t2 = self.Buffer.from(css, "utf8");
                t3 = J.get$file$x(options);
                if (t3 == null) t3 = "data";
                t4 = start._value;
                t5 = B.JSInt_methods._tdivFast$1(A.Duration$(0 - start._microsecond, t1 - t4)._duration, 1000);
                t6 = A._setArrayType([], type$.JSArray_String);
                for(t7 = result._evaluate._0, t7 = t7.get$iterator(t7); t7.moveNext$0();){
                    t8 = t7.get$current(t7);
                    t6.push(t8.get$scheme() === "file" ? $.$get$context().style.pathFromUri$1(A._parseUri(t8)) : t8.toString$0(0));
                }
                return {
                    css: t2,
                    map: sourceMapBytes,
                    stats: {
                        entry: t3,
                        start: t4,
                        end: t1,
                        duration: t5,
                        includedFiles: t6
                    }
                };
            },
            _enableSourceMaps: function(options) {
                var t2, t1 = J.getInterceptor$x(options);
                if (typeof t1.get$sourceMap(options) != "string") {
                    t2 = t1.get$sourceMap(options);
                    t1 = !J.$eq$(t2, false) && t2 != null && t1.get$outFile(options) != null;
                } else t1 = true;
                return t1;
            },
            _newRenderError: function(message, stackTrace, column, file, line, $status) {
                var error = new self.Error(message);
                error.formatted = "Error: " + message;
                if (line != null) error.line = line;
                if (column != null) error.column = column;
                if (file != null) error.file = file;
                error.status = $status;
                A.attachJsStack(error, stackTrace);
                return error;
            },
            render_closure: function render_closure(t0, t1) {
                this.callback = t0;
                this.options = t1;
            },
            render_closure0: function render_closure0(t0) {
                this.callback = t0;
            },
            render_closure1: function render_closure1(t0) {
                this.callback = t0;
            },
            _parseFunctions_closure: function _parseFunctions_closure(t0, t1, t2, t3) {
                var _ = this;
                _.options = t0;
                _.start = t1;
                _.result = t2;
                _.asynch = t3;
            },
            _parseFunctions__closure: function _parseFunctions__closure(t0, t1, t2) {
                this._box_0 = t0;
                this.callback = t1;
                this.context = t2;
            },
            _parseFunctions___closure2: function _parseFunctions___closure2(t0) {
                this.currentFiber = t0;
            },
            _parseFunctions____closure: function _parseFunctions____closure(t0, t1) {
                this.currentFiber = t0;
                this.result = t1;
            },
            _parseFunctions___closure3: function _parseFunctions___closure3(t0, t1, t2) {
                this.callback = t0;
                this.context = t1;
                this.jsArguments = t2;
            },
            _parseFunctions___closure4: function _parseFunctions___closure4(t0) {
                this._box_0 = t0;
            },
            _parseFunctions__closure0: function _parseFunctions__closure0(t0, t1) {
                this.callback = t0;
                this.context = t1;
            },
            _parseFunctions___closure1: function _parseFunctions___closure1(t0, t1, t2) {
                this.callback = t0;
                this.context = t1;
                this.$arguments = t2;
            },
            _parseFunctions__closure1: function _parseFunctions__closure1(t0, t1) {
                this.callback = t0;
                this.context = t1;
            },
            _parseFunctions___closure: function _parseFunctions___closure(t0) {
                this.completer = t0;
            },
            _parseFunctions___closure0: function _parseFunctions___closure0(t0, t1, t2) {
                this.callback = t0;
                this.context = t1;
                this.jsArguments = t2;
            },
            _parseImporter_closure: function _parseImporter_closure(t0) {
                this._box_0 = t0;
            },
            _parseImporter__closure: function _parseImporter__closure(t0, t1) {
                this._box_0 = t0;
                this.importer = t1;
            },
            _parseImporter___closure: function _parseImporter___closure(t0) {
                this.currentFiber = t0;
            },
            _parseImporter____closure: function _parseImporter____closure(t0, t1) {
                this.currentFiber = t0;
                this.result = t1;
            },
            _parseImporter___closure0: function _parseImporter___closure0(t0) {
                this._box_0 = t0;
            },
            LegacyIfExpression0: function LegacyIfExpression0(t0, t1) {
                this.$arguments = t0;
                this.span = t1;
            },
            LimitedMapView$blocklist0: function(_map, blocklist, $K, $V) {
                var t2, key, t1 = A.LinkedHashSet_LinkedHashSet$_empty($K);
                for(t2 = _map.get$keys(_map), t2 = t2.get$iterator(t2); t2.moveNext$0();){
                    key = t2.get$current(t2);
                    if (!blocklist.contains$1(0, key)) t1.add$1(0, key);
                }
                return new A.LimitedMapView0(_map, t1, $K._eval$1("@<0>")._bind$1($V)._eval$1("LimitedMapView0<1,2>"));
            },
            LimitedMapView0: function LimitedMapView0(t0, t1, t2) {
                this._limited_map_view0$_map = t0;
                this._limited_map_view0$_keys = t1;
                this.$ti = t2;
            },
            ListExpression0: function ListExpression0(t0, t1, t2, t3) {
                var _ = this;
                _.contents = t0;
                _.separator = t1;
                _.hasBrackets = t2;
                _.span = t3;
            },
            ListExpression_toString_closure0: function ListExpression_toString_closure0(t0) {
                this.$this = t0;
            },
            _function11: function($name, $arguments, callback) {
                return A.BuiltInCallable$function0($name, $arguments, callback, "sass:list");
            },
            _length_closure2: function _length_closure2() {},
            _nth_closure0: function _nth_closure0() {},
            _setNth_closure0: function _setNth_closure0() {},
            _join_closure0: function _join_closure0() {},
            _append_closure2: function _append_closure2() {},
            _zip_closure0: function _zip_closure0() {},
            _zip__closure2: function _zip__closure2() {},
            _zip__closure3: function _zip__closure3(t0) {
                this._box_0 = t0;
            },
            _zip__closure4: function _zip__closure4(t0) {
                this._box_0 = t0;
            },
            _index_closure2: function _index_closure2() {},
            _separator_closure0: function _separator_closure0() {},
            _isBracketed_closure0: function _isBracketed_closure0() {},
            _slash_closure0: function _slash_closure0() {},
            InterpolatedSelectorList$: function(components) {
                var t1 = A.List_List$unmodifiable(components, type$.InterpolatedComplexSelector);
                if (t1.length === 0) A.throwExpression(A.ArgumentError$("components may not be empty.", null));
                return new A.InterpolatedSelectorList(t1);
            },
            InterpolatedSelectorList: function InterpolatedSelectorList(t0) {
                this.components = t0;
            },
            SelectorList$0: function(components, span) {
                var t1 = A.List_List$unmodifiable(components, type$.ComplexSelector_2);
                if (t1.length === 0) A.throwExpression(A.ArgumentError$("components may not be empty.", null));
                return new A.SelectorList0(t1, span);
            },
            SelectorList_SelectorList$parse0: function(contents, allowParent, interpolationMap, logger, plainCss) {
                return A.SelectorParser$0(contents, allowParent, interpolationMap, logger, plainCss, null).parse$0(0);
            },
            SelectorList0: function SelectorList0(t0, t1) {
                this.components = t0;
                this.span = t1;
            },
            SelectorList_asSassList_closure0: function SelectorList_asSassList_closure0() {},
            SelectorList_nestWithin_closure0: function SelectorList_nestWithin_closure0(t0, t1, t2, t3) {
                var _ = this;
                _.$this = t0;
                _.preserveParentSelectors = t1;
                _.implicitParent = t2;
                _.parent = t3;
            },
            SelectorList_nestWithin__closure1: function SelectorList_nestWithin__closure1(t0) {
                this.complex = t0;
            },
            SelectorList_nestWithin__closure2: function SelectorList_nestWithin__closure2(t0) {
                this.complex = t0;
            },
            SelectorList__nestWithinCompound_closure2: function SelectorList__nestWithinCompound_closure2() {},
            SelectorList__nestWithinCompound_closure3: function SelectorList__nestWithinCompound_closure3(t0) {
                this.parent = t0;
            },
            SelectorList__nestWithinCompound_closure4: function SelectorList__nestWithinCompound_closure4(t0, t1, t2) {
                this.parentSelector = t0;
                this.resolvedSimples = t1;
                this.component = t2;
            },
            SelectorList_withAdditionalCombinators_closure0: function SelectorList_withAdditionalCombinators_closure0(t0) {
                this.combinators = t0;
            },
            _ParentSelectorVisitor0: function _ParentSelectorVisitor0() {},
            __ParentSelectorVisitor_Object_SelectorSearchVisitor0: function __ParentSelectorVisitor_Object_SelectorSearchVisitor0() {},
            listClass_closure: function listClass_closure() {},
            listClass__closure: function listClass__closure() {},
            listClass__closure0: function listClass__closure0() {},
            _ConstructorOptions: function _ConstructorOptions() {},
            _NodeSassList: function _NodeSassList() {},
            legacyListClass_closure: function legacyListClass_closure() {},
            legacyListClass__closure: function legacyListClass__closure() {},
            legacyListClass_closure0: function legacyListClass_closure0() {},
            legacyListClass_closure1: function legacyListClass_closure1() {},
            legacyListClass_closure2: function legacyListClass_closure2() {},
            legacyListClass_closure3: function legacyListClass_closure3() {},
            legacyListClass_closure4: function legacyListClass_closure4() {},
            SassList$0: function(contents, _separator, brackets) {
                var t1 = new A.SassList0(A.List_List$unmodifiable(contents, type$.Value_2), _separator, brackets);
                t1.SassList$3$brackets0(contents, _separator, brackets);
                return t1;
            },
            SassList0: function SassList0(t0, t1, t2) {
                this._list1$_contents = t0;
                this._list1$_separator = t1;
                this._list1$_hasBrackets = t2;
            },
            SassList_isBlank_closure0: function SassList_isBlank_closure0() {},
            ListSeparator0: function ListSeparator0(t0, t1, t2, t3) {
                var _ = this;
                _._list1$_name = t0;
                _.separator = t1;
                _.index = t2;
                _._name = t3;
            },
            LmsColorSpace0: function LmsColorSpace0(t0, t1) {
                this.name = t0;
                this._space$_channels = t1;
            },
            LocalMindeGamutMap0: function LocalMindeGamutMap0(t0) {
                this.name = t0;
            },
            JSLogger: function JSLogger() {},
            WarnOptions: function WarnOptions() {},
            DebugOptions: function DebugOptions() {},
            WarnForDeprecation_warnForDeprecation0: function(_this, deprecation, message, span, trace) {
                _this.internalWarn$4$deprecation$span$trace(message, deprecation, span, trace);
            },
            LoggerWithDeprecationType0: function LoggerWithDeprecationType0() {},
            LoudComment0: function LoudComment0(t0) {
                this.text = t0;
            },
            MapExpression0: function MapExpression0(t0, t1) {
                this.pairs = t0;
                this.span = t1;
            },
            _modify0: function(map, keys, modify, addNesting) {
                var keyIterator = J.get$iterator$ax(keys);
                return keyIterator.moveNext$0() ? new A._modify_modifyNestedMap0(keyIterator, modify, addNesting).call$1(map) : modify.call$1(map);
            },
            _deepMergeImpl0: function(map1, map2) {
                var t2, t3, result, t4, key, value, _1_1, _1_3, _1_3_isSet, resultMap, _1_30, valueMap, merged, t1 = map1._map0$_contents;
                if (t1.get$isEmpty(t1)) return map2;
                t2 = map2._map0$_contents;
                if (t2.get$isEmpty(t2)) return map1;
                t3 = type$.Value_2;
                result = A.LinkedHashMap_LinkedHashMap$of(t1, t3, t3);
                for(t1 = A.MapExtensions_get_pairs0(t2, t3, t3), t1 = t1.get$iterator(t1), t2 = type$.SassMap_2; t1.moveNext$0();){
                    t4 = t1.get$current(t1);
                    key = t4._0;
                    value = t4._1;
                    t4 = result.$index(0, key);
                    _1_1 = t4 == null ? null : t4.tryMap$0();
                    _1_3 = value.tryMap$0();
                    _1_3_isSet = _1_1 != null;
                    t4 = false;
                    if (_1_3_isSet) {
                        t4 = _1_3 != null;
                        resultMap = _1_1;
                        _1_30 = _1_3;
                    } else {
                        _1_30 = null;
                        resultMap = null;
                    }
                    if (t4) {
                        valueMap = _1_3_isSet ? _1_30 : _1_3;
                        merged = A._deepMergeImpl0(resultMap, valueMap == null ? t2._as(valueMap) : valueMap);
                        if (merged === resultMap) continue;
                        result.$indexSet(0, key, merged);
                    } else result.$indexSet(0, key, value);
                }
                return new A.SassMap0(A.ConstantMap_ConstantMap$from(result, t3, t3));
            },
            _function10: function($name, $arguments, callback) {
                return A.BuiltInCallable$function0($name, $arguments, callback, "sass:map");
            },
            _get_closure0: function _get_closure0() {},
            _set_closure1: function _set_closure1() {},
            _set__closure2: function _set__closure2(t0) {
                this.$arguments = t0;
            },
            _set_closure2: function _set_closure2() {},
            _set__closure1: function _set__closure1(t0) {
                this._box_0 = t0;
            },
            _merge_closure1: function _merge_closure1() {},
            _merge_closure2: function _merge_closure2() {},
            _merge__closure0: function _merge__closure0(t0) {
                this.map2 = t0;
            },
            _deepMerge_closure0: function _deepMerge_closure0() {},
            _deepRemove_closure0: function _deepRemove_closure0() {},
            _deepRemove__closure0: function _deepRemove__closure0(t0) {
                this.keys = t0;
            },
            _remove_closure1: function _remove_closure1() {},
            _remove_closure2: function _remove_closure2() {},
            _keys_closure0: function _keys_closure0() {},
            _values_closure0: function _values_closure0() {},
            _hasKey_closure0: function _hasKey_closure0() {},
            _modify_modifyNestedMap0: function _modify_modifyNestedMap0(t0, t1, t2) {
                this.keyIterator = t0;
                this.modify = t1;
                this.addNesting = t2;
            },
            MapExtensions_get_pairs0: function(_this, $K, $V) {
                var t1 = _this.get$entries(_this);
                return t1.map$1$1(t1, new A.MapExtensions_get_pairs_closure0($K, $V), $K._eval$1("@<0>")._bind$1($V)._eval$1("+(1,2)"));
            },
            MapExtensions_get_pairs_closure0: function MapExtensions_get_pairs_closure0(t0, t1) {
                this.K = t0;
                this.V = t1;
            },
            mapClass_closure: function mapClass_closure() {},
            mapClass__closure: function mapClass__closure() {},
            mapClass__closure0: function mapClass__closure0() {},
            mapClass__closure1: function mapClass__closure1() {},
            _NodeSassMap: function _NodeSassMap() {},
            legacyMapClass_closure: function legacyMapClass_closure() {},
            legacyMapClass__closure: function legacyMapClass__closure() {},
            legacyMapClass__closure0: function legacyMapClass__closure0() {},
            legacyMapClass_closure0: function legacyMapClass_closure0() {},
            legacyMapClass_closure1: function legacyMapClass_closure1() {},
            legacyMapClass_closure2: function legacyMapClass_closure2() {},
            legacyMapClass_closure3: function legacyMapClass_closure3() {},
            legacyMapClass_closure4: function legacyMapClass_closure4() {},
            SassMap0: function SassMap0(t0) {
                this._map0$_contents = t0;
            },
            _singleArgumentMathFunc0: function($name, mathFunc) {
                return A.BuiltInCallable$function0($name, "$number", new A._singleArgumentMathFunc_closure0(mathFunc), "sass:math");
            },
            _numberFunction0: function($name, transform) {
                return A.BuiltInCallable$function0($name, "$number", new A._numberFunction_closure0(transform), "sass:math");
            },
            _function9: function($name, $arguments, callback) {
                return A.BuiltInCallable$function0($name, $arguments, callback, "sass:math");
            },
            global_closure43: function global_closure43() {},
            module_closure26: function module_closure26() {},
            _ceil_closure0: function _ceil_closure0() {},
            _clamp_closure0: function _clamp_closure0() {},
            _floor_closure0: function _floor_closure0() {},
            _max_closure0: function _max_closure0() {},
            _min_closure0: function _min_closure0() {},
            _round_closure0: function _round_closure0() {},
            _hypot_closure0: function _hypot_closure0() {},
            _hypot__closure0: function _hypot__closure0() {},
            _log_closure0: function _log_closure0() {},
            _pow_closure0: function _pow_closure0() {},
            _atan2_closure0: function _atan2_closure0() {},
            _compatible_closure0: function _compatible_closure0() {},
            _isUnitless_closure0: function _isUnitless_closure0() {},
            _unit_closure0: function _unit_closure0() {},
            _percentage_closure0: function _percentage_closure0() {},
            _randomFunction_closure0: function _randomFunction_closure0() {},
            _div_closure0: function _div_closure0() {},
            _singleArgumentMathFunc_closure0: function _singleArgumentMathFunc_closure0(t0) {
                this.mathFunc = t0;
            },
            _numberFunction_closure0: function _numberFunction_closure0(t0) {
                this.transform = t0;
            },
            CssMediaQuery$type0: function(type, conditions, modifier) {
                return new A.CssMediaQuery0(modifier, type, true, conditions == null ? B.List_empty : A.List_List$unmodifiable(conditions, type$.String));
            },
            CssMediaQuery$condition0: function(conditions, conjunction) {
                var t1 = A.List_List$unmodifiable(conditions, type$.String);
                if (t1.length > 1 && conjunction == null) A.throwExpression(A.ArgumentError$(string$.If_con, null));
                return new A.CssMediaQuery0(null, null, conjunction !== false, t1);
            },
            CssMediaQuery0: function CssMediaQuery0(t0, t1, t2, t3) {
                var _ = this;
                _.modifier = t0;
                _.type = t1;
                _.conjunction = t2;
                _.conditions = t3;
            },
            _SingletonCssMediaQueryMergeResult0: function _SingletonCssMediaQueryMergeResult0(t0, t1) {
                this.index = t0;
                this._name = t1;
            },
            MediaQuerySuccessfulMergeResult0: function MediaQuerySuccessfulMergeResult0(t0) {
                this.query = t0;
            },
            MediaQueryParser0: function MediaQueryParser0(t0, t1) {
                this.scanner = t0;
                this._parser1$_interpolationMap = t1;
            },
            MediaQueryParser_parse_closure0: function MediaQueryParser_parse_closure0(t0) {
                this.$this = t0;
            },
            ModifiableCssMediaRule$0: function(queries, span) {
                var t1 = A.List_List$unmodifiable(queries, type$.CssMediaQuery_2), t2 = A._setArrayType([], type$.JSArray_ModifiableCssNode_2);
                if (J.get$isEmpty$asx(queries)) A.throwExpression(A.ArgumentError$value(queries, "queries", "may not be empty."));
                return new A.ModifiableCssMediaRule0(t1, span, new A.UnmodifiableListView(t2, type$.UnmodifiableListView_ModifiableCssNode_2), t2);
            },
            ModifiableCssMediaRule0: function ModifiableCssMediaRule0(t0, t1, t2, t3) {
                var _ = this;
                _.queries = t0;
                _.span = t1;
                _.children = t2;
                _._node$_children = t3;
                _._node$_indexInParent = _._node$_parent = null;
                _.isGroupEnd = false;
            },
            MediaRule$0: function(query, children, span) {
                var t1 = A.List_List$unmodifiable(children, type$.Statement_2), t2 = B.JSArray_methods.any$1(t1, new A.ParentStatement_closure0());
                return new A.MediaRule0(query, span, t1, t2);
            },
            MediaRule0: function MediaRule0(t0, t1, t2, t3) {
                var _ = this;
                _.query = t0;
                _.span = t1;
                _.children = t2;
                _.hasDeclarations = t3;
            },
            MergedExtension_merge0: function(left, right) {
                var t2, t3, t4, t1 = left.extender.selector;
                if (!t1.$eq(0, right.extender.selector) || !left.target.$eq(0, right.target)) throw A.wrapException(A.ArgumentError$(left.toString$0(0) + " and " + right.toString$0(0) + " aren't the same extension.", null));
                t2 = left.mediaContext;
                t3 = t2 == null;
                if (!t3) {
                    t4 = right.mediaContext;
                    t4 = t4 != null && !B.C_ListEquality.equals$2(0, t2, t4);
                } else t4 = false;
                if (t4) throw A.wrapException(A.SassException$0("From " + left.span.message$1(0, "") + string$.x0aYou_m, right.span, null));
                if (right.isOptional && right.mediaContext == null) return left;
                if (left.isOptional && t3) return right;
                if (t3) t2 = right.mediaContext;
                t1.get$specificity();
                t1 = new A.Extender0(t1, false);
                return t1._extension$_extension = new A.MergedExtension0(left, right, t1, left.target, t2, true, left.span);
            },
            MergedExtension0: function MergedExtension0(t0, t1, t2, t3, t4, t5, t6) {
                var _ = this;
                _.left = t0;
                _.right = t1;
                _.extender = t2;
                _.target = t3;
                _.mediaContext = t4;
                _.isOptional = t5;
                _.span = t6;
            },
            MergedMapView$0: function(maps, $K, $V) {
                var t1 = $K._eval$1("@<0>")._bind$1($V);
                t1 = new A.MergedMapView0(A.LinkedHashMap_LinkedHashMap$_empty($K, t1._eval$1("Map<1,2>")), t1._eval$1("MergedMapView0<1,2>"));
                t1.MergedMapView$10(maps, $K, $V);
                return t1;
            },
            MergedMapView0: function MergedMapView0(t0, t1) {
                this._merged_map_view$_mapsByKey = t0;
                this.$ti = t1;
            },
            _function6: function($name, $arguments, callback) {
                return A.BuiltInCallable$function0($name, $arguments, callback, "sass:meta");
            },
            _shared_closure3: function _shared_closure3() {},
            _shared_closure4: function _shared_closure4() {},
            _shared_closure5: function _shared_closure5() {},
            _shared_closure6: function _shared_closure6() {},
            moduleFunctions_closure2: function moduleFunctions_closure2() {},
            moduleFunctions_closure3: function moduleFunctions_closure3() {},
            moduleFunctions__closure0: function moduleFunctions__closure0() {},
            moduleFunctions_closure4: function moduleFunctions_closure4() {},
            mixinClass_closure: function mixinClass_closure() {},
            mixinClass__closure: function mixinClass__closure() {},
            mixinClass__closure0: function mixinClass__closure0() {},
            SassMixin0: function SassMixin0(t0, t1) {
                this.callable = t0;
                this._mixin0$_compileContext = t1;
            },
            MixinRule$0: function($name, parameters, children, span, comment) {
                var t1 = A.stringReplaceAllUnchecked($name, "_", "-"), t2 = A.List_List$unmodifiable(children, type$.Statement_2), t3 = B.JSArray_methods.any$1(t2, new A.ParentStatement_closure0());
                return new A.MixinRule0(t1, $name, parameters, span, t2, t3);
            },
            MixinRule0: function MixinRule0(t0, t1, t2, t3, t4, t5) {
                var _ = this;
                _._mixin_rule$__MixinRule_hasContent_FI = $;
                _.name = t0;
                _.originalName = t1;
                _.parameters = t2;
                _.span = t3;
                _.children = t4;
                _.hasDeclarations = t5;
            },
            _HasContentVisitor0: function _HasContentVisitor0() {},
            __HasContentVisitor_Object_StatementSearchVisitor0: function __HasContentVisitor_Object_StatementSearchVisitor0() {},
            ExtendMode0: function ExtendMode0(t0, t1, t2) {
                this.name = t0;
                this.index = t1;
                this._name = t2;
            },
            JSModule0: function JSModule0() {},
            JSModuleRequire0: function JSModuleRequire0() {},
            MultiSpan0: function MultiSpan0(t0, t1, t2) {
                this._multi_span0$_primary = t0;
                this.primaryLabel = t1;
                this.secondarySpans = t2;
            },
            SupportsNegation0: function SupportsNegation0(t0, t1) {
                this.condition = t0;
                this.span = t1;
            },
            NoOpImporter0: function NoOpImporter0() {},
            NoSourceMapBuffer0: function NoSourceMapBuffer0(t0) {
                this._no_source_map_buffer0$_buffer = t0;
            },
            _FakeAstNode0: function _FakeAstNode0(t0) {
                this._node0$_callback = t0;
            },
            CssNode0: function CssNode0() {},
            CssParentNode0: function CssParentNode0() {},
            _IsInvisibleVisitor1: function _IsInvisibleVisitor1(t0, t1) {
                this.includeBogus = t0;
                this.includeComments = t1;
            },
            __IsInvisibleVisitor_Object_EveryCssVisitor0: function __IsInvisibleVisitor_Object_EveryCssVisitor0() {},
            ModifiableCssNode0: function ModifiableCssNode0() {},
            ModifiableCssNode_hasFollowingSibling_closure0: function ModifiableCssNode_hasFollowingSibling_closure0() {},
            ModifiableCssParentNode0: function ModifiableCssParentNode0() {},
            NodePackageImporter0: function NodePackageImporter0() {
                this._node_package$__NodePackageImporter__entryPointDirectory_F = $;
            },
            NodePackageImporter__nodePackageExportsResolve_closure3: function NodePackageImporter__nodePackageExportsResolve_closure3() {},
            NodePackageImporter__nodePackageExportsResolve_closure4: function NodePackageImporter__nodePackageExportsResolve_closure4() {},
            NodePackageImporter__nodePackageExportsResolve_closure5: function NodePackageImporter__nodePackageExportsResolve_closure5() {},
            NodePackageImporter__nodePackageExportsResolve_closure6: function NodePackageImporter__nodePackageExportsResolve_closure6(t0, t1, t2) {
                this.$this = t0;
                this.exports = t1;
                this.packageRoot = t2;
            },
            NodePackageImporter__nodePackageExportsResolve__closure1: function NodePackageImporter__nodePackageExportsResolve__closure1(t0, t1, t2) {
                this.$this = t0;
                this.variant = t1;
                this.packageRoot = t2;
            },
            NodePackageImporter__nodePackageExportsResolve__closure2: function NodePackageImporter__nodePackageExportsResolve__closure2() {},
            NodePackageImporter__getMainExport_closure0: function NodePackageImporter__getMainExport_closure0() {},
            NullExpression$: function(span) {
                return new A.NullExpression0(span);
            },
            NullExpression0: function NullExpression0(t0) {
                this.span = t0;
            },
            legacyNullClass_closure: function legacyNullClass_closure() {},
            legacyNullClass__closure: function legacyNullClass__closure() {},
            _SassNull0: function _SassNull0() {},
            NumberExpression0: function NumberExpression0(t0, t1, t2) {
                this.value = t0;
                this.unit = t1;
                this.span = t2;
            },
            numberClass_closure: function numberClass_closure() {},
            numberClass__closure: function numberClass__closure() {},
            numberClass__closure0: function numberClass__closure0() {},
            numberClass__closure1: function numberClass__closure1() {},
            numberClass__closure2: function numberClass__closure2() {},
            numberClass__closure3: function numberClass__closure3() {},
            numberClass__closure4: function numberClass__closure4() {},
            numberClass__closure5: function numberClass__closure5() {},
            numberClass__closure6: function numberClass__closure6() {},
            numberClass__closure7: function numberClass__closure7() {},
            numberClass__closure8: function numberClass__closure8() {},
            numberClass__closure9: function numberClass__closure9() {},
            numberClass__closure10: function numberClass__closure10() {},
            numberClass__closure11: function numberClass__closure11() {},
            numberClass__closure12: function numberClass__closure12() {},
            numberClass__closure13: function numberClass__closure13() {},
            numberClass__closure14: function numberClass__closure14() {},
            numberClass__closure15: function numberClass__closure15() {},
            numberClass__closure16: function numberClass__closure16() {},
            numberClass__closure17: function numberClass__closure17() {},
            numberClass__closure18: function numberClass__closure18() {},
            numberClass__closure19: function numberClass__closure19() {},
            _ConstructorOptions0: function _ConstructorOptions0() {},
            _parseNumber: function(value, unit) {
                var invalidUnit, operands, t1, numerator, denominator, numeratorUnits, denominatorUnits;
                if (unit == null || unit.length === 0) return A.SassNumber_SassNumber0(value, null);
                if (!B.JSString_methods.contains$1(unit, "*") && !B.JSString_methods.contains$1(unit, "/")) return A.SassNumber_SassNumber0(value, unit);
                invalidUnit = new A.ArgumentError(true, unit, "unit", "is invalid.");
                operands = unit.split("/");
                t1 = operands.length;
                if (t1 > 2) throw A.wrapException(invalidUnit);
                numerator = operands[0];
                denominator = t1 === 1 ? null : operands[1];
                t1 = type$.JSArray_String;
                numeratorUnits = numerator.length === 0 ? A._setArrayType([], t1) : A._setArrayType(numerator.split("*"), t1);
                if (B.JSArray_methods.any$1(numeratorUnits, new A._parseNumber_closure())) throw A.wrapException(invalidUnit);
                denominatorUnits = denominator == null ? A._setArrayType([], t1) : A._setArrayType(denominator.split("*"), t1);
                if (B.JSArray_methods.any$1(denominatorUnits, new A._parseNumber_closure0())) throw A.wrapException(invalidUnit);
                return A.SassNumber_SassNumber$withUnits0(value, denominatorUnits, numeratorUnits);
            },
            _NodeSassNumber: function _NodeSassNumber() {},
            legacyNumberClass_closure: function legacyNumberClass_closure() {},
            legacyNumberClass_closure0: function legacyNumberClass_closure0() {},
            legacyNumberClass_closure1: function legacyNumberClass_closure1() {},
            legacyNumberClass_closure2: function legacyNumberClass_closure2() {},
            legacyNumberClass_closure3: function legacyNumberClass_closure3() {},
            _parseNumber_closure: function _parseNumber_closure() {},
            _parseNumber_closure0: function _parseNumber_closure0() {},
            conversionFactor0: function(unit1, unit2) {
                var _0_0;
                if (unit1 === unit2) return 1;
                _0_0 = B.Map_NtHoP.$index(0, unit1);
                if (_0_0 != null) return _0_0.$index(0, unit2);
                return null;
            },
            SassNumber_SassNumber0: function(value, unit) {
                return unit == null ? new A.UnitlessSassNumber0(value, null) : new A.SingleUnitSassNumber0(unit, value, null);
            },
            SassNumber_SassNumber$withUnits0: function(value, denominatorUnits, numeratorUnits) {
                var _0_8, _0_10, _0_10_isSet, _0_7, _0_8_isSet, _0_7_isSet, unit, _0_7_isSet0, t2, _0_4_isSet, numerators, denominators, unsimplifiedDenominators, valueDouble, _i, denominator, simplifiedAway, i, factor, _1_2, _1_7_isSet, _1_7, _null = null, _0_3 = numeratorUnits == null, t1 = _0_3, _0_6_isSet = !t1, _0_6 = _null, _0_4 = _null;
                if (_0_6_isSet) {
                    _0_4 = J.get$length$asx(numeratorUnits == null ? type$.List_String._as(numeratorUnits) : numeratorUnits);
                    t1 = _0_4;
                    _0_6 = t1 <= 0;
                    t1 = _0_6;
                } else t1 = true;
                _0_8 = _null;
                _0_10 = _null;
                if (t1) {
                    _0_8 = denominatorUnits == null;
                    t1 = _0_8;
                    _0_10_isSet = !t1;
                    if (_0_10_isSet) {
                        _0_10 = J.get$length$asx(denominatorUnits == null ? type$.List_String._as(denominatorUnits) : denominatorUnits) <= 0;
                        t1 = _0_10;
                    } else t1 = true;
                    _0_7 = denominatorUnits;
                    _0_8_isSet = true;
                    _0_7_isSet = true;
                } else {
                    _0_7 = _null;
                    _0_8_isSet = false;
                    _0_7_isSet = false;
                    _0_10_isSet = false;
                    t1 = false;
                }
                if (t1) return new A.UnitlessSassNumber0(value, _null);
                unit = _null;
                t1 = false;
                if (type$.List_dynamic._is(numeratorUnits)) {
                    _0_7_isSet0 = true;
                    if (_0_6_isSet) {
                        t2 = _0_4;
                        _0_4_isSet = _0_6_isSet;
                    } else {
                        _0_4 = J.get$length$asx(numeratorUnits);
                        t2 = _0_4;
                        _0_4_isSet = true;
                    }
                    if (t2 === 1) {
                        unit = J.$index$asx(numeratorUnits, 0);
                        if (_0_8_isSet) t1 = _0_8;
                        else {
                            if (_0_7_isSet) t1 = _0_7;
                            else {
                                t1 = denominatorUnits;
                                _0_7_isSet = _0_7_isSet0;
                                _0_7 = t1;
                            }
                            _0_8 = t1 == null;
                            t1 = _0_8;
                            _0_8_isSet = true;
                        }
                        if (!t1) {
                            if (_0_10_isSet) t1 = _0_10;
                            else {
                                if (_0_7_isSet) t1 = _0_7;
                                else {
                                    t1 = denominatorUnits;
                                    _0_7_isSet = _0_7_isSet0;
                                    _0_7 = t1;
                                }
                                _0_10 = J.get$length$asx(t1 == null ? type$.List_String._as(t1) : t1) <= 0;
                                t1 = _0_10;
                                _0_10_isSet = true;
                            }
                        } else t1 = true;
                    }
                } else _0_4_isSet = _0_6_isSet;
                if (t1) return new A.SingleUnitSassNumber0(unit, value, _null);
                t1 = false;
                if (numeratorUnits != null) {
                    _0_7_isSet0 = true;
                    if (_0_8_isSet) t1 = _0_8;
                    else {
                        if (_0_7_isSet) t1 = _0_7;
                        else {
                            t1 = denominatorUnits;
                            _0_7_isSet = _0_7_isSet0;
                            _0_7 = t1;
                        }
                        _0_8 = t1 == null;
                        t1 = _0_8;
                    }
                    if (!t1) {
                        if (_0_10_isSet) t1 = _0_10;
                        else {
                            if (_0_7_isSet) t1 = _0_7;
                            else {
                                t1 = denominatorUnits;
                                _0_7_isSet = _0_7_isSet0;
                                _0_7 = t1;
                            }
                            _0_10 = J.get$length$asx(t1 == null ? type$.List_String._as(t1) : t1) <= 0;
                            t1 = _0_10;
                        }
                    } else t1 = true;
                    numerators = numeratorUnits;
                } else numerators = _null;
                if (t1) return new A.ComplexSassNumber0(A.List_List$unmodifiable(numerators, type$.String), B.List_empty, value, _null);
                if (!_0_3) {
                    if (_0_6_isSet) t1 = _0_6;
                    else {
                        if (_0_4_isSet) t1 = _0_4;
                        else {
                            _0_4 = J.get$length$asx(numeratorUnits == null ? type$.List_String._as(numeratorUnits) : numeratorUnits);
                            t1 = _0_4;
                        }
                        _0_6 = t1 <= 0;
                        t1 = _0_6;
                    }
                } else t1 = true;
                denominators = _null;
                if (t1) {
                    if (_0_7_isSet) t1 = _0_7;
                    else {
                        t1 = denominatorUnits;
                        _0_7 = t1;
                        _0_7_isSet = true;
                    }
                    t1 = t1 != null;
                    if (t1) {
                        denominators = _0_7_isSet ? _0_7 : denominatorUnits;
                        if (denominators == null) denominators = type$.List_String._as(denominators);
                    }
                } else t1 = false;
                if (t1) return new A.ComplexSassNumber0(B.List_empty, A.List_List$unmodifiable(denominators, type$.String), value, _null);
                numeratorUnits.toString;
                numerators = J.toList$0$ax(numeratorUnits);
                denominatorUnits.toString;
                unsimplifiedDenominators = J.toList$0$ax(denominatorUnits);
                denominators = A._setArrayType([], type$.JSArray_String);
                for(t1 = unsimplifiedDenominators.length, valueDouble = value, _i = 0; _i < unsimplifiedDenominators.length; unsimplifiedDenominators.length === t1 || (0, A.throwConcurrentModificationError)(unsimplifiedDenominators), ++_i){
                    denominator = unsimplifiedDenominators[_i];
                    i = 0;
                    for(;;){
                        if (!(i < numerators.length)) {
                            simplifiedAway = false;
                            break;
                        }
                        c$0: {
                            factor = A.conversionFactor0(denominator, numerators[i]);
                            if (factor == null) break c$0;
                            valueDouble *= factor;
                            B.JSArray_methods.removeAt$1(numerators, i);
                            simplifiedAway = true;
                            break;
                        }
                        ++i;
                    }
                    if (!simplifiedAway) denominators.push(denominator);
                }
                $label0$1: {
                    _1_2 = numerators.length;
                    t1 = _1_2;
                    _1_7_isSet = t1 <= 0;
                    if (_1_7_isSet) {
                        _1_7 = denominators.length <= 0;
                        t1 = _1_7;
                    } else {
                        _1_7 = _null;
                        t1 = false;
                    }
                    if (t1) {
                        t1 = new A.UnitlessSassNumber0(valueDouble, _null);
                        break $label0$1;
                    }
                    t1 = false;
                    if (_1_2 === 1) {
                        unit = numerators[0];
                        t1 = _1_7_isSet ? _1_7 : denominators.length <= 0;
                    } else unit = _null;
                    if (t1) {
                        t1 = new A.SingleUnitSassNumber0(unit, valueDouble, _null);
                        break $label0$1;
                    }
                    t1 = type$.String;
                    t1 = new A.ComplexSassNumber0(A.List_List$unmodifiable(numerators, t1), A.List_List$unmodifiable(denominators, t1), valueDouble, _null);
                    break $label0$1;
                }
                return t1;
            },
            SassNumber0: function SassNumber0() {},
            SassNumber__coerceOrConvertValue_compatibilityException0: function SassNumber__coerceOrConvertValue_compatibilityException0(t0, t1, t2, t3, t4, t5, t6) {
                var _ = this;
                _.$this = t0;
                _.other = t1;
                _.otherName = t2;
                _.otherHasUnits = t3;
                _.name = t4;
                _.newNumerators = t5;
                _.newDenominators = t6;
            },
            SassNumber__coerceOrConvertValue_closure3: function SassNumber__coerceOrConvertValue_closure3(t0, t1) {
                this._box_0 = t0;
                this.newNumerator = t1;
            },
            SassNumber__coerceOrConvertValue_closure4: function SassNumber__coerceOrConvertValue_closure4(t0) {
                this.compatibilityException = t0;
            },
            SassNumber__coerceOrConvertValue_closure5: function SassNumber__coerceOrConvertValue_closure5(t0, t1) {
                this._box_0 = t0;
                this.newDenominator = t1;
            },
            SassNumber__coerceOrConvertValue_closure6: function SassNumber__coerceOrConvertValue_closure6(t0) {
                this.compatibilityException = t0;
            },
            SassNumber_plus_closure0: function SassNumber_plus_closure0() {},
            SassNumber_minus_closure0: function SassNumber_minus_closure0() {},
            SassNumber_multiplyUnits_closure3: function SassNumber_multiplyUnits_closure3(t0, t1) {
                this._box_0 = t0;
                this.numerator = t1;
            },
            SassNumber_multiplyUnits_closure4: function SassNumber_multiplyUnits_closure4(t0, t1) {
                this.newNumerators = t0;
                this.numerator = t1;
            },
            SassNumber_multiplyUnits_closure5: function SassNumber_multiplyUnits_closure5(t0, t1) {
                this._box_0 = t0;
                this.numerator = t1;
            },
            SassNumber_multiplyUnits_closure6: function SassNumber_multiplyUnits_closure6(t0, t1) {
                this.newNumerators = t0;
                this.numerator = t1;
            },
            SassNumber__areAnyConvertible_closure0: function SassNumber__areAnyConvertible_closure0(t0) {
                this.units2 = t0;
            },
            SassNumber__canonicalizeUnitList_closure0: function SassNumber__canonicalizeUnitList_closure0() {},
            SassNumber__canonicalMultiplier_closure0: function SassNumber__canonicalMultiplier_closure0(t0) {
                this.$this = t0;
            },
            SassNumber_unitSuggestion_closure1: function SassNumber_unitSuggestion_closure1() {},
            SassNumber_unitSuggestion_closure2: function SassNumber_unitSuggestion_closure2() {},
            OklabColorSpace0: function OklabColorSpace0(t0, t1) {
                this.name = t0;
                this._space$_channels = t1;
            },
            OklchColorSpace0: function OklchColorSpace0(t0, t1) {
                this.name = t0;
                this._space$_channels = t1;
            },
            SupportsOperation0: function SupportsOperation0(t0, t1, t2, t3) {
                var _ = this;
                _.left = t0;
                _.right = t1;
                _.operator = t2;
                _.span = t3;
            },
            Parameter0: function Parameter0(t0, t1, t2) {
                this.name = t0;
                this.defaultValue = t1;
                this.span = t2;
            },
            ParameterList_ParameterList$parse0: function(contents, url) {
                return A.ScssParser$0(contents, false, url).parseParameterList$0();
            },
            ParameterList0: function ParameterList0(t0, t1, t2) {
                this.parameters = t0;
                this.restParameter = t1;
                this.span = t2;
            },
            ParameterList_verify_closure1: function ParameterList_verify_closure1() {},
            ParameterList_verify_closure2: function ParameterList_verify_closure2() {},
            InterpolatedParentSelector: function InterpolatedParentSelector(t0, t1) {
                this.suffix = t0;
                this.span = t1;
            },
            ParentSelector0: function ParentSelector0(t0, t1) {
                this.suffix = t0;
                this.span = t1;
            },
            ParentStatement0: function ParentStatement0() {},
            ParentStatement_closure0: function ParentStatement_closure0() {},
            ParentStatement__closure0: function ParentStatement__closure0() {},
            ParenthesizedExpression0: function ParenthesizedExpression0(t0, t1) {
                this.expression = t0;
                this.span = t1;
            },
            loadParserExports: function() {
                A._updateLazyFileSpanPrototype();
                A._updateAstPrototypes();
                return {
                    parse: A.allowInterop(A.parser0___parse$closure()),
                    parseIdentifier: A.allowInterop(A.parser0___parseIdentifier$closure()),
                    toCssIdentifier: A.allowInterop(A.parser0___toCssIdentifier$closure()),
                    createExpressionVisitor: A.allowInterop(new A.loadParserExports_closure()),
                    createIfConditionExpressionVisitor: A.allowInterop(new A.loadParserExports_closure0()),
                    createStatementVisitor: A.allowInterop(new A.loadParserExports_closure1()),
                    createSimpleSelectorVisitor: A.allowInterop(new A.loadParserExports_closure2()),
                    createSourceFile: A.allowInterop(new A.loadParserExports_closure3()),
                    setToJS: A.allowInterop(new A.loadParserExports_closure4()),
                    mapToRecord: A.allowInterop(A.utils3__mapToObject$closure())
                };
            },
            _updateLazyFileSpanPrototype: function() {
                var t1 = type$.JSClass._as(new A.LazyFileSpan0(new A._updateLazyFileSpanPrototype_closure()).constructor);
                A.LinkedHashMap_LinkedHashMap$_literal([
                    "file",
                    new A._updateLazyFileSpanPrototype_closure0(),
                    "length",
                    new A._updateLazyFileSpanPrototype_closure1(),
                    "sourceUrl",
                    new A._updateLazyFileSpanPrototype_closure2()
                ], type$.String, type$.Function).forEach$1(0, A.JSClassExtension_get_defineGetter(t1));
            },
            _updateAstPrototypes: function() {
                var t3, string, $arguments, klass, compound, ifConditionSass, _i, t4, _null = null, _s6_ = "accept", _s9_ = "arguments", file = A.SourceFile$fromString("", _null), t1 = type$.JSClass, t2 = t1._as(file.constructor);
                A.LinkedHashMap_LinkedHashMap$_literal([
                    "getText",
                    new A._updateAstPrototypes_closure(),
                    "span",
                    new A._updateAstPrototypes_closure0()
                ], type$.String, type$.Function).forEach$1(0, A.JSClassExtension_get_defineMethod(t2));
                A.defineGetter(J.get$$prototype$x(t1._as(file.constructor)), "codeUnits", new A._updateAstPrototypes_closure1(), _null);
                t2 = $.$get$_interpolation();
                A.defineGetter(J.get$$prototype$x(t1._as(t2.constructor)), "asPlain", new A._updateAstPrototypes_closure2(), _null);
                t3 = $.$get$bogusSpan0();
                J.get$$prototype$x(t1._as(self.Object.getPrototypeOf(J.get$$prototype$x(t1._as(new A.ExtendRule0(t2, false, t3).constructor))).constructor)).accept = A.allowInteropCaptureThisNamed(_s6_, new A._updateAstPrototypes_closure3());
                string = new A.StringExpression0(t2, false);
                J.get$$prototype$x(t1._as(self.Object.getPrototypeOf(J.get$$prototype$x(t1._as(string.constructor))).constructor)).accept = A.allowInteropCaptureThisNamed(_s6_, new A._updateAstPrototypes_closure4());
                J.get$$prototype$x(t1._as(self.Object.getPrototypeOf(J.get$$prototype$x(t1._as(new A.InterpolatedParentSelector(_null, t3).constructor))).constructor)).accept = A.allowInteropCaptureThisNamed(_s6_, new A._updateAstPrototypes_closure5());
                J.get$$prototype$x(t1._as(self.Object.getPrototypeOf(J.get$$prototype$x(t1._as(new A.IfConditionSass0(string, t3).constructor))).constructor)).accept = A.allowInteropCaptureThisNamed(_s6_, new A._updateAstPrototypes_closure6());
                $arguments = A.ArgumentList$0(B.List_empty24, B.Map_empty14, B.Map_empty5, t3, _null, _null);
                A.defineGetter(J.get$$prototype$x(t1._as(new A.IncludeRule0(_null, A.stringReplaceAllUnchecked("a", "_", "-"), "a", $arguments, _null, t3).constructor)), _s9_, new A._updateAstPrototypes_closure7(), _null);
                A.defineGetter(J.get$$prototype$x(t1._as(new A.ContentRule0($arguments, t3).constructor)), _s9_, new A._updateAstPrototypes_closure8(), _null);
                A.defineGetter(J.get$$prototype$x(t1._as(new A.FunctionExpression0(_null, A.stringReplaceAllUnchecked("a", "_", "-"), "a", $arguments, t3).constructor)), _s9_, new A._updateAstPrototypes_closure9(), _null);
                A.defineGetter(J.get$$prototype$x(t1._as(new A.LegacyIfExpression0($arguments, t3).constructor)), _s9_, new A._updateAstPrototypes_closure10(), _null);
                A.defineGetter(J.get$$prototype$x(t1._as(new A.InterpolatedFunctionExpression0(t2, $arguments, t3).constructor)), _s9_, new A._updateAstPrototypes_closure11(), _null);
                A.defineGetter(J.get$$prototype$x(t1._as(new A.IfConditionFunction0(t2, t2, t3).constructor)), _s9_, new A._updateAstPrototypes_closure12(), _null);
                A._addSupportsConditionToInterpolation();
                klass = new A.InterpolatedClassSelector(t2);
                compound = A.InterpolatedCompoundSelector$(A._setArrayType([
                    klass
                ], type$.JSArray_InterpolatedSimpleSelector));
                ifConditionSass = new A.IfConditionSass0(string, t3);
                for(t2 = [
                    string,
                    new A.BinaryOperationExpression0(B.BinaryOperator_jCK0, string, string, false),
                    new A.SupportsExpression0(new A.SupportsAnything0(t2, t3)),
                    new A.LoudComment0(t2),
                    klass,
                    new A.InterpolatedIDSelector(t2),
                    new A.InterpolatedPlaceholderSelector(t2),
                    new A.InterpolatedTypeSelector(new A.InterpolatedQualifiedName(t2, t3, _null)),
                    compound,
                    A.InterpolatedSelectorList$(A._setArrayType([
                        A.InterpolatedComplexSelector$(A._setArrayType([
                            new A.InterpolatedComplexSelectorComponent(compound, _null, t3)
                        ], type$.JSArray_InterpolatedComplexSelectorComponent), t3, _null)
                    ], type$.JSArray_InterpolatedComplexSelector)),
                    A.IfConditionOperation$0(A._setArrayType([
                        ifConditionSass,
                        ifConditionSass
                    ], type$.JSArray_IfConditionExpression_2), B.BooleanOperator_00),
                    new A.IfConditionRaw0(t2)
                ], _i = 0; _i < 12; ++_i){
                    t3 = J.get$$prototype$x(t1._as(t2[_i].constructor));
                    t4 = {
                        get: A.allowInteropCaptureThis(new A._updateAstPrototypes_closure13()),
                        enumerable: false
                    };
                    self.Object.defineProperty(t3, "span", t4);
                }
            },
            _addSupportsConditionToInterpolation: function() {
                var t3, _i, $function, t4, t1 = $.$get$_interpolation(), t2 = $.$get$bogusSpan0(), anything = new A.SupportsAnything0(t1, t2);
                for(t3 = $.$get$_expression(), t2 = [
                    anything,
                    new A.SupportsDeclaration0(t3, t3, t2),
                    new A.SupportsFunction0(t1, t1, t2),
                    new A.SupportsInterpolation0(t3, t2),
                    new A.SupportsNegation0(anything, t2),
                    new A.SupportsOperation0(anything, anything, B.BooleanOperator_00, t2)
                ], t3 = type$.JSClass, _i = 0; _i < 6; ++_i){
                    t1 = J.get$$prototype$x(t3._as(t2[_i].constructor));
                    $function = A.allowInteropCaptureThis(new A._addSupportsConditionToInterpolation_closure());
                    t4 = {
                        value: "toInterpolation",
                        enumerable: false
                    };
                    self.Object.defineProperty($function, "name", t4);
                    A._hideDartProperties($function);
                    t1.toInterpolation = $function;
                }
            },
            _parse: function(css, syntax, path) {
                var t1;
                $label0$0: {
                    if ("scss" === syntax) {
                        t1 = B.Syntax_SCSS_0_scss0;
                        break $label0$0;
                    }
                    if ("sass" === syntax) {
                        t1 = B.Syntax_Sass_1_sass0;
                        break $label0$0;
                    }
                    if ("css" === syntax) {
                        t1 = B.Syntax_CSS_2_css0;
                        break $label0$0;
                    }
                    t1 = A.throwExpression(A.UnsupportedError$('Unknown syntax "' + syntax + '"'));
                }
                return A.Stylesheet_Stylesheet$parse0(css, t1, true, A.NullableExtension_andThen0(path, A.path__toUri$closure()));
            },
            _parseIdentifier: function(identifier) {
                var t1, _$exception;
                try {
                    t1 = new A.Parser1(A.SpanScanner$(identifier, null), null)._parser1$_parseIdentifier$0();
                    return t1;
                } catch (exception) {
                    if (type$.SassFormatException_2._is(A.unwrapException(exception))) return null;
                    else throw exception;
                }
            },
            _toCssIdentifier: function(text) {
                return A.StringExtension_toCssIdentifier(text);
            },
            ParserExports: function ParserExports() {},
            loadParserExports_closure: function loadParserExports_closure() {},
            loadParserExports_closure0: function loadParserExports_closure0() {},
            loadParserExports_closure1: function loadParserExports_closure1() {},
            loadParserExports_closure2: function loadParserExports_closure2() {},
            loadParserExports_closure3: function loadParserExports_closure3() {},
            loadParserExports_closure4: function loadParserExports_closure4() {},
            _updateLazyFileSpanPrototype_closure: function _updateLazyFileSpanPrototype_closure() {},
            _updateLazyFileSpanPrototype_closure0: function _updateLazyFileSpanPrototype_closure0() {},
            _updateLazyFileSpanPrototype_closure1: function _updateLazyFileSpanPrototype_closure1() {},
            _updateLazyFileSpanPrototype_closure2: function _updateLazyFileSpanPrototype_closure2() {},
            _updateAstPrototypes_closure: function _updateAstPrototypes_closure() {},
            _updateAstPrototypes_closure0: function _updateAstPrototypes_closure0() {},
            _updateAstPrototypes_closure1: function _updateAstPrototypes_closure1() {},
            _updateAstPrototypes_closure2: function _updateAstPrototypes_closure2() {},
            _updateAstPrototypes_closure3: function _updateAstPrototypes_closure3() {},
            _updateAstPrototypes_closure4: function _updateAstPrototypes_closure4() {},
            _updateAstPrototypes_closure5: function _updateAstPrototypes_closure5() {},
            _updateAstPrototypes_closure6: function _updateAstPrototypes_closure6() {},
            _updateAstPrototypes_closure7: function _updateAstPrototypes_closure7() {},
            _updateAstPrototypes_closure8: function _updateAstPrototypes_closure8() {},
            _updateAstPrototypes_closure9: function _updateAstPrototypes_closure9() {},
            _updateAstPrototypes_closure10: function _updateAstPrototypes_closure10() {},
            _updateAstPrototypes_closure11: function _updateAstPrototypes_closure11() {},
            _updateAstPrototypes_closure12: function _updateAstPrototypes_closure12() {},
            _updateAstPrototypes_closure13: function _updateAstPrototypes_closure13() {},
            _addSupportsConditionToInterpolation_closure: function _addSupportsConditionToInterpolation_closure() {},
            Parser_isIdentifier0: function(text) {
                var _$exception;
                try {
                    new A.Parser1(A.SpanScanner$(text, null), null)._parser1$_parseIdentifier$0();
                    return true;
                } catch (exception) {
                    if (type$.SassFormatException_2._is(A.unwrapException(exception))) return false;
                    else throw exception;
                }
            },
            Parser1: function Parser1(t0, t1) {
                this.scanner = t0;
                this._parser1$_interpolationMap = t1;
            },
            Parser__parseIdentifier_closure0: function Parser__parseIdentifier_closure0(t0) {
                this.$this = t0;
            },
            Parser_escape_closure0: function Parser_escape_closure0() {},
            Parser_scanIdentChar_matches0: function Parser_scanIdentChar_matches0(t0, t1) {
                this.caseSensitive = t0;
                this.char = t1;
            },
            Parser_spanFrom_closure0: function Parser_spanFrom_closure0(t0, t1) {
                this.$this = t0;
                this.span = t1;
            },
            Parser_spanFromPosition_closure0: function Parser_spanFromPosition_closure0(t0, t1) {
                this.$this = t0;
                this.span = t1;
            },
            InterpolatedPlaceholderSelector: function InterpolatedPlaceholderSelector(t0) {
                this.name = t0;
            },
            PlaceholderSelector0: function PlaceholderSelector0(t0, t1) {
                this.name = t0;
                this.span = t1;
            },
            PlainCssCallable0: function PlainCssCallable0(t0) {
                this.name = t0;
            },
            PrefixedMapView0: function PrefixedMapView0(t0, t1, t2) {
                this._prefixed_map_view0$_map = t0;
                this._prefixed_map_view0$_prefix = t1;
                this.$ti = t2;
            },
            _PrefixedKeys0: function _PrefixedKeys0(t0) {
                this._prefixed_map_view0$_view = t0;
            },
            _PrefixedKeys_iterator_closure0: function _PrefixedKeys_iterator_closure0(t0) {
                this.$this = t0;
            },
            ProphotoRgbColorSpace0: function ProphotoRgbColorSpace0(t0, t1) {
                this.name = t0;
                this._space$_channels = t1;
            },
            InterpolatedPseudoSelector: function InterpolatedPseudoSelector(t0, t1, t2, t3, t4) {
                var _ = this;
                _.name = t0;
                _.isSyntacticClass = t1;
                _.argument = t2;
                _.selector = t3;
                _.span = t4;
            },
            PseudoSelector$0: function($name, span, argument, element, selector) {
                var t1 = !element, t2 = t1 && !A.PseudoSelector__isFakePseudoElement0($name);
                return new A.PseudoSelector0($name, A.unvendor0($name), t2, t1, argument, selector, span);
            },
            PseudoSelector__isFakePseudoElement0: function($name) {
                switch($name.charCodeAt(0)){
                    case 97:
                    case 65:
                        return A.equalsIgnoreCase0($name, "after");
                    case 98:
                    case 66:
                        return A.equalsIgnoreCase0($name, "before");
                    case 102:
                    case 70:
                        return A.equalsIgnoreCase0($name, "first-line") || A.equalsIgnoreCase0($name, "first-letter");
                    default:
                        return false;
                }
            },
            PseudoSelector0: function PseudoSelector0(t0, t1, t2, t3, t4, t5, t6) {
                var _ = this;
                _.name = t0;
                _.normalizedName = t1;
                _.isClass = t2;
                _.isSyntacticClass = t3;
                _.argument = t4;
                _.selector = t5;
                _._pseudo$__PseudoSelector_specificity_FI = $;
                _.span = t6;
            },
            PseudoSelector_specificity_closure0: function PseudoSelector_specificity_closure0(t0) {
                this.$this = t0;
            },
            PseudoSelector_specificity__closure1: function PseudoSelector_specificity__closure1() {},
            PseudoSelector_specificity__closure2: function PseudoSelector_specificity__closure2() {},
            PseudoSelector_unify_closure0: function PseudoSelector_unify_closure0() {},
            PublicMemberMapView0: function PublicMemberMapView0(t0, t1) {
                this._public_member_map_view0$_inner = t0;
                this.$ti = t1;
            },
            InterpolatedQualifiedName: function InterpolatedQualifiedName(t0, t1, t2) {
                this.name = t0;
                this.span = t1;
                this.namespace = t2;
            },
            QualifiedName0: function QualifiedName0(t0, t1) {
                this.name = t0;
                this.namespace = t1;
            },
            Rec2020ColorSpace0: function Rec2020ColorSpace0(t0, t1) {
                this.name = t0;
                this._space$_channels = t1;
            },
            createJSClass: function($name, $constructor) {
                return type$.JSClass._as(A.allowInteropCaptureThisNamed($name, $constructor));
            },
            JSClassExtension_injectSuperclass: function(_this, superclass) {
                var t1 = J.getInterceptor$x(superclass), t2 = J.getInterceptor$x(_this);
                self.Object.setPrototypeOf(t1.get$$prototype(superclass), J.get$$prototype$x(type$.JSClass._as(self.Object.getPrototypeOf(t2.get$$prototype(_this)).constructor)));
                self.Object.setPrototypeOf(t2.get$$prototype(_this), self.Object.create(t1.get$$prototype(superclass)));
            },
            JSClassExtension_setCustomInspect: function(_this, inspect) {
                if (self.util == null) return;
                J.get$$prototype$x(_this)[self.util.inspect.custom] = A.allowInteropCaptureThis(new A.JSClassExtension_setCustomInspect_closure(inspect));
            },
            JSClassExtension_get_defineStaticMethod: function(_this) {
                return new A.JSClassExtension_get_defineStaticMethod_closure(_this);
            },
            JSClassExtension_get_defineMethod: function(_this) {
                return new A.JSClassExtension_get_defineMethod_closure(_this);
            },
            JSClassExtension_defineMethods: function(_this, methods) {
                methods.forEach$1(0, A.JSClassExtension_get_defineMethod(_this));
            },
            JSClassExtension_get_defineGetter: function(_this) {
                return new A.JSClassExtension_get_defineGetter_closure(_this);
            },
            JSClass0: function JSClass0() {},
            JSClassExtension_setCustomInspect_closure: function JSClassExtension_setCustomInspect_closure(t0) {
                this.inspect = t0;
            },
            JSClassExtension_get_defineStaticMethod_closure: function JSClassExtension_get_defineStaticMethod_closure(t0) {
                this._this = t0;
            },
            JSClassExtension_get_defineMethod_closure: function JSClassExtension_get_defineMethod_closure(t0) {
                this._this = t0;
            },
            JSClassExtension_get_defineGetter_closure: function JSClassExtension_get_defineGetter_closure(t0) {
                this._this = t0;
            },
            RenderContext0: function RenderContext0() {},
            RenderContextOptions0: function RenderContextOptions0() {},
            RenderContextResult0: function RenderContextResult0() {},
            RenderContextResultStats0: function RenderContextResultStats0() {},
            RenderOptions: function RenderOptions() {},
            RenderResult: function RenderResult() {},
            RenderResultStats: function RenderResultStats() {},
            ReplaceExpressionVisitor0: function ReplaceExpressionVisitor0() {},
            ReplaceExpressionVisitor_visitListExpression_closure0: function ReplaceExpressionVisitor_visitListExpression_closure0(t0) {
                this.$this = t0;
            },
            ReplaceExpressionVisitor_visitIfConditionOperation_closure0: function ReplaceExpressionVisitor_visitIfConditionOperation_closure0(t0) {
                this.$this = t0;
            },
            ReplaceExpressionVisitor_visitArgumentList_closure0: function ReplaceExpressionVisitor_visitArgumentList_closure0(t0) {
                this.$this = t0;
            },
            ReplaceExpressionVisitor_visitInterpolation_closure0: function ReplaceExpressionVisitor_visitInterpolation_closure0(t0) {
                this.$this = t0;
            },
            ImporterResult$: function(contents, sourceMapUrl, syntax) {
                if ((sourceMapUrl == null ? null : sourceMapUrl.get$scheme()) === "") A.throwExpression(A.ArgumentError$value(sourceMapUrl, "sourceMapUrl", "must be absolute"));
                return new A.ImporterResult0(contents, sourceMapUrl, syntax);
            },
            ImporterResult0: function ImporterResult0(t0, t1, t2) {
                this.contents = t0;
                this._result$_sourceMapUrl = t1;
                this.syntax = t2;
            },
            ReturnRule0: function ReturnRule0(t0, t1) {
                this.expression = t0;
                this.span = t1;
            },
            RgbColorSpace0: function RgbColorSpace0(t0, t1) {
                this.name = t0;
                this._space$_channels = t1;
            },
            SassParser0: function SassParser0(t0, t1, t2, t3, t4) {
                var _ = this;
                _._sass0$_currentIndentation = 0;
                _._sass0$_spaces = _._sass0$_nextIndentationEnd = _._sass0$_nextIndentation = null;
                _._parseSelectors = t0;
                _._stylesheet0$_isUseAllowed = true;
                _._stylesheet0$_inExpression = _._stylesheet0$_inParentheses = _._stylesheet0$_inStyleRule = _._stylesheet0$_inPlainCssFunction = _._stylesheet0$_inUnknownAtRule = _._stylesheet0$_inControlDirective = _._stylesheet0$_inContentBlock = _._stylesheet0$_inMixin = false;
                _._stylesheet0$_globalVariables = t1;
                _.warnings = t2;
                _.lastSilentComment = null;
                _.scanner = t3;
                _._parser1$_interpolationMap = t4;
            },
            SassParser_styleRuleSelector_closure0: function SassParser_styleRuleSelector_closure0() {},
            SassParser_children_closure0: function SassParser_children_closure0(t0, t1, t2) {
                this.$this = t0;
                this.child = t1;
                this.children = t2;
            },
            SassParser__peekIndentation_closure1: function SassParser__peekIndentation_closure1() {},
            SassParser__peekIndentation_closure2: function SassParser__peekIndentation_closure2() {},
            SassParser__tryTrailingSemicolon_closure0: function SassParser__tryTrailingSemicolon_closure0() {},
            _translateReturnValue: function(val) {
                if (val instanceof A._Future) return A.futureToPromise(val, type$.dynamic);
                else return val;
            },
            main2: function() {
                new Uint8Array(0);
                A.main();
                J.set$cli_pkg_main_0_$x(self.exports, A._wrapMain(A.sass__main$closure()));
            },
            _wrapMain: function(main) {
                if (type$.dynamic_Function._is(main)) return A.allowInterop(new A._wrapMain_closure(main));
                else return A.allowInterop(new A._wrapMain_closure0(main));
            },
            _Exports: function _Exports() {},
            _wrapMain_closure: function _wrapMain_closure(t0) {
                this.main = t0;
            },
            _wrapMain_closure0: function _wrapMain_closure0(t0) {
                this.main = t0;
            },
            ScssParser$0: function(contents, parseSelectors, url) {
                return new A.ScssParser0(parseSelectors, A.LinkedHashMap_LinkedHashMap$_empty(type$.String, type$.FileSpan), A._setArrayType([], type$.JSArray_Record_3_nullable_Deprecation_deprecation_and_String_message_and_FileSpan_span_2), A.SpanScanner$(contents, url), null);
            },
            ScssParser0: function ScssParser0(t0, t1, t2, t3, t4) {
                var _ = this;
                _._parseSelectors = t0;
                _._stylesheet0$_isUseAllowed = true;
                _._stylesheet0$_inExpression = _._stylesheet0$_inParentheses = _._stylesheet0$_inStyleRule = _._stylesheet0$_inPlainCssFunction = _._stylesheet0$_inUnknownAtRule = _._stylesheet0$_inControlDirective = _._stylesheet0$_inContentBlock = _._stylesheet0$_inMixin = false;
                _._stylesheet0$_globalVariables = t1;
                _.warnings = t2;
                _.lastSilentComment = null;
                _.scanner = t3;
                _._parser1$_interpolationMap = t4;
            },
            Selector0: function Selector0() {},
            _IsInvisibleVisitor2: function _IsInvisibleVisitor2(t0) {
                this.includeBogus = t0;
            },
            _IsBogusVisitor0: function _IsBogusVisitor0(t0) {
                this.includeLeadingCombinator = t0;
            },
            _IsBogusVisitor_visitComplexSelector_closure0: function _IsBogusVisitor_visitComplexSelector_closure0(t0) {
                this.$this = t0;
            },
            _IsUselessVisitor0: function _IsUselessVisitor0() {},
            _IsUselessVisitor_visitComplexSelector_closure0: function _IsUselessVisitor_visitComplexSelector_closure0(t0) {
                this.$this = t0;
            },
            _ContainsParentSelectorVisitor0: function _ContainsParentSelectorVisitor0() {},
            __ContainsParentSelectorVisitor_Object_AnySelectorVisitor0: function __ContainsParentSelectorVisitor_Object_AnySelectorVisitor0() {},
            __IsBogusVisitor_Object_AnySelectorVisitor0: function __IsBogusVisitor_Object_AnySelectorVisitor0() {},
            __IsInvisibleVisitor_Object_AnySelectorVisitor0: function __IsInvisibleVisitor_Object_AnySelectorVisitor0() {},
            __IsUselessVisitor_Object_AnySelectorVisitor0: function __IsUselessVisitor_Object_AnySelectorVisitor0() {},
            SelectorExpression0: function SelectorExpression0(t0) {
                this.span = t0;
            },
            _prependParent0: function(compound) {
                var _0_3, _0_4, t2, t3, rest, t1 = A.EvaluationContext_currentOrNull0(), span = (t1 == null ? A.throwExpression(A.StateError$(string$.No_Sass)) : t1).get$currentCallableSpan(), _0_0 = compound.components;
                $label0$0: {
                    _0_3 = _0_0.length >= 1;
                    if (_0_3) {
                        _0_4 = _0_0[0];
                        t1 = _0_4 instanceof A.UniversalSelector0;
                    } else {
                        _0_4 = null;
                        t1 = false;
                    }
                    t2 = null;
                    if (t1) {
                        t1 = t2;
                        break $label0$0;
                    }
                    t1 = false;
                    if (_0_3) {
                        t3 = _0_4;
                        if (t3 instanceof A.TypeSelector0) {
                            t1 = _0_4;
                            t1 = type$.TypeSelector_2._as(t1).name.namespace != null;
                        }
                    }
                    if (t1) {
                        t1 = t2;
                        break $label0$0;
                    }
                    if (_0_3) {
                        t1 = _0_4;
                        t1 = t1 instanceof A.TypeSelector0;
                    } else t1 = false;
                    if (t1) {
                        t1 = _0_3 ? _0_4 : _0_0[0];
                        type$.TypeSelector_2._as(t1);
                        rest = B.JSArray_methods.sublist$1(_0_0, 1);
                        t1 = A._setArrayType([
                            new A.ParentSelector0(t1.name.name, span)
                        ], type$.JSArray_SimpleSelector_2);
                        B.JSArray_methods.addAll$1(t1, rest);
                        t1 = A.CompoundSelector$0(t1, span);
                        break $label0$0;
                    }
                    t1 = A._setArrayType([
                        new A.ParentSelector0(null, span)
                    ], type$.JSArray_SimpleSelector_2);
                    B.JSArray_methods.addAll$1(t1, _0_0);
                    t1 = A.CompoundSelector$0(t1, span);
                    break $label0$0;
                }
                return t1;
            },
            _function8: function($name, $arguments, callback) {
                return A.BuiltInCallable$function0($name, $arguments, callback, "sass:selector");
            },
            _nest_closure0: function _nest_closure0() {},
            _nest__closure1: function _nest__closure1() {},
            _nest__closure2: function _nest__closure2() {},
            _append_closure1: function _append_closure1() {},
            _append__closure1: function _append__closure1() {},
            _append__closure2: function _append__closure2(t0) {
                this.span = t0;
            },
            _append___closure0: function _append___closure0(t0, t1) {
                this.parent = t0;
                this.span = t1;
            },
            _extend_closure0: function _extend_closure0() {},
            _replace_closure0: function _replace_closure0() {},
            _unify_closure0: function _unify_closure0() {},
            _isSuperselector_closure0: function _isSuperselector_closure0() {},
            _simpleSelectors_closure0: function _simpleSelectors_closure0() {},
            _simpleSelectors__closure0: function _simpleSelectors__closure0() {},
            _parse_closure0: function _parse_closure0() {},
            SelectorParser$0: function(contents, allowParent, interpolationMap, logger, plainCss, url) {
                return new A.SelectorParser0(allowParent, plainCss, logger, A.SpanScanner$(contents, url), interpolationMap);
            },
            SelectorParser0: function SelectorParser0(t0, t1, t2, t3, t4) {
                var _ = this;
                _._selector0$_allowParent = t0;
                _._selector0$_plainCss = t1;
                _._selector0$_logger = t2;
                _.scanner = t3;
                _._parser1$_interpolationMap = t4;
            },
            SelectorParser_parse_closure0: function SelectorParser_parse_closure0(t0) {
                this.$this = t0;
            },
            SelectorParser_parseCompoundSelector_closure0: function SelectorParser_parseCompoundSelector_closure0(t0) {
                this.$this = t0;
            },
            SelectorSearchVisitor0: function SelectorSearchVisitor0() {},
            SelectorSearchVisitor_visitComplexSelector_closure0: function SelectorSearchVisitor_visitComplexSelector_closure0(t0) {
                this.$this = t0;
            },
            SelectorSearchVisitor_visitCompoundSelector_closure0: function SelectorSearchVisitor_visitCompoundSelector_closure0(t0) {
                this.$this = t0;
            },
            serialize0: function(node, charset, indentWidth, inspect, lineFeed, logger, sourceMap, style, useSpaces) {
                var t1, css, t2, prefix, visitor = A._SerializeVisitor$0(indentWidth == null ? 2 : indentWidth, inspect, lineFeed, logger, true, sourceMap, style, useSpaces);
                node.accept$1(visitor);
                t1 = visitor._serialize0$_buffer;
                css = t1.toString$0(0);
                if (charset) {
                    t2 = new A.CodeUnits(css);
                    t2 = t2.any$1(t2, new A.serialize_closure0());
                } else t2 = false;
                if (t2) prefix = style === B.OutputStyle_10 ? "\ufeff" : '@charset "UTF-8";\n';
                else prefix = "";
                t1 = sourceMap ? t1.buildSourceMap$1$prefix(prefix) : null;
                return new A._Record_2_sourceMap(prefix + css, t1);
            },
            serializeValue0: function(value, inspect, quote) {
                var _null = null, visitor = A._SerializeVisitor$0(_null, inspect, _null, _null, quote, false, _null, true);
                value.accept$1(visitor);
                return visitor._serialize0$_buffer.toString$0(0);
            },
            serializeSelector0: function(selector, inspect) {
                var _null = null, visitor = A._SerializeVisitor$0(_null, true, _null, _null, true, false, _null, true);
                selector.accept$1(visitor);
                return visitor._serialize0$_buffer.toString$0(0);
            },
            _SerializeVisitor$0: function(indentWidth, inspect, lineFeed, logger, quote, sourceMap, style, useSpaces) {
                var t1 = sourceMap ? new A.SourceMapBuffer0(new A.StringBuffer(""), A._setArrayType([], type$.JSArray_Entry)) : new A.NoSourceMapBuffer0(new A.StringBuffer("")), t2 = style == null ? B.OutputStyle_00 : style, t3 = useSpaces ? 32 : 9, t4 = indentWidth == null ? 2 : indentWidth, t5 = lineFeed == null ? B.LineFeed_oJz : lineFeed;
                A.RangeError_checkValueInInterval(t4, 0, 10, "indentWidth");
                return new A._SerializeVisitor0(t1, t2, inspect, quote, t3, t4, t5);
            },
            serialize_closure0: function serialize_closure0() {},
            _SerializeVisitor0: function _SerializeVisitor0(t0, t1, t2, t3, t4, t5, t6) {
                var _ = this;
                _._serialize0$_buffer = t0;
                _._serialize0$_indentation = 0;
                _._serialize0$_style = t1;
                _._serialize0$_inspect = t2;
                _._serialize0$_quote = t3;
                _._serialize0$_indentCharacter = t4;
                _._serialize0$_indentWidth = t5;
                _._lineFeed = t6;
            },
            _SerializeVisitor_visitCssComment_closure0: function _SerializeVisitor_visitCssComment_closure0(t0, t1) {
                this.$this = t0;
                this.node = t1;
            },
            _SerializeVisitor_visitCssAtRule_closure0: function _SerializeVisitor_visitCssAtRule_closure0(t0, t1) {
                this.$this = t0;
                this.node = t1;
            },
            _SerializeVisitor_visitCssMediaRule_closure0: function _SerializeVisitor_visitCssMediaRule_closure0(t0, t1) {
                this.$this = t0;
                this.node = t1;
            },
            _SerializeVisitor_visitCssImport_closure0: function _SerializeVisitor_visitCssImport_closure0(t0, t1) {
                this.$this = t0;
                this.node = t1;
            },
            _SerializeVisitor_visitCssImport__closure0: function _SerializeVisitor_visitCssImport__closure0(t0, t1) {
                this.$this = t0;
                this.node = t1;
            },
            _SerializeVisitor_visitCssKeyframeBlock_closure0: function _SerializeVisitor_visitCssKeyframeBlock_closure0(t0, t1) {
                this.$this = t0;
                this.node = t1;
            },
            _SerializeVisitor_visitCssStyleRule_closure0: function _SerializeVisitor_visitCssStyleRule_closure0(t0, t1) {
                this.$this = t0;
                this.node = t1;
            },
            _SerializeVisitor_visitCssSupportsRule_closure0: function _SerializeVisitor_visitCssSupportsRule_closure0(t0, t1) {
                this.$this = t0;
                this.node = t1;
            },
            _SerializeVisitor_visitCssDeclaration_closure1: function _SerializeVisitor_visitCssDeclaration_closure1(t0, t1) {
                this.$this = t0;
                this.node = t1;
            },
            _SerializeVisitor_visitCssDeclaration_closure2: function _SerializeVisitor_visitCssDeclaration_closure2(t0, t1) {
                this.$this = t0;
                this.node = t1;
            },
            _SerializeVisitor_visitList_closure2: function _SerializeVisitor_visitList_closure2() {},
            _SerializeVisitor_visitList_closure3: function _SerializeVisitor_visitList_closure3(t0, t1) {
                this.$this = t0;
                this.value = t1;
            },
            _SerializeVisitor_visitList_closure4: function _SerializeVisitor_visitList_closure4(t0) {
                this.$this = t0;
            },
            _SerializeVisitor_visitMap_closure0: function _SerializeVisitor_visitMap_closure0(t0) {
                this.$this = t0;
            },
            _SerializeVisitor_visitSelectorList_closure0: function _SerializeVisitor_visitSelectorList_closure0() {},
            _SerializeVisitor__write_closure0: function _SerializeVisitor__write_closure0(t0, t1) {
                this.$this = t0;
                this.value = t1;
            },
            _SerializeVisitor__visitChildren_closure1: function _SerializeVisitor__visitChildren_closure1(t0, t1) {
                this.$this = t0;
                this.child = t1;
            },
            _SerializeVisitor__visitChildren_closure2: function _SerializeVisitor__visitChildren_closure2(t0, t1) {
                this.$this = t0;
                this.child = t1;
            },
            OutputStyle0: function OutputStyle0(t0, t1) {
                this.index = t0;
                this._name = t1;
            },
            LineFeed0: function LineFeed0(t0, t1, t2, t3) {
                var _ = this;
                _.name = t0;
                _.text = t1;
                _.index = t2;
                _._name = t3;
            },
            JSSet: function JSSet() {},
            ShadowedModuleView_ifNecessary0: function(inner, functions, mixins, variables, $T) {
                return A.ShadowedModuleView__needsBlocklist0(inner.get$variables(), variables) || A.ShadowedModuleView__needsBlocklist0(inner.get$functions(inner), functions) || A.ShadowedModuleView__needsBlocklist0(inner.get$mixins(), mixins) ? new A.ShadowedModuleView0(inner, A.ShadowedModuleView__shadowedMap0(inner.get$variables(), variables, type$.Value_2), A.ShadowedModuleView__shadowedMap0(inner.get$variableNodes(), variables, type$.AstNode_2), A.ShadowedModuleView__shadowedMap0(inner.get$functions(inner), functions, $T), A.ShadowedModuleView__shadowedMap0(inner.get$mixins(), mixins, $T), $T._eval$1("ShadowedModuleView0<0>")) : null;
            },
            ShadowedModuleView__shadowedMap0: function(map, blocklist, $V) {
                var t1 = A.ShadowedModuleView__needsBlocklist0(map, blocklist);
                return !t1 ? map : A.LimitedMapView$blocklist0(map, blocklist, type$.String, $V);
            },
            ShadowedModuleView__needsBlocklist0: function(map, blocklist) {
                return map.get$isNotEmpty(map) && blocklist.any$1(0, map.get$containsKey());
            },
            ShadowedModuleView0: function ShadowedModuleView0(t0, t1, t2, t3, t4, t5) {
                var _ = this;
                _._shadowed_view0$_inner = t0;
                _.variables = t1;
                _.variableNodes = t2;
                _.functions = t3;
                _.mixins = t4;
                _.$ti = t5;
            },
            SilentComment0: function SilentComment0(t0, t1) {
                this.text = t0;
                this.span = t1;
            },
            InterpolatedSimpleSelector: function InterpolatedSimpleSelector() {},
            SimpleSelector0: function SimpleSelector0() {},
            SimpleSelector_isSuperselector_closure0: function SimpleSelector_isSuperselector_closure0(t0) {
                this.$this = t0;
            },
            SimpleSelector_isSuperselector__closure0: function SimpleSelector_isSuperselector__closure0(t0) {
                this.$this = t0;
            },
            JSSimpleSelectorVisitor: function JSSimpleSelectorVisitor(t0) {
                this._simple_selector$_inner = t0;
            },
            JSSimpleSelectorVisitorObject: function JSSimpleSelectorVisitorObject() {},
            SingleUnitSassNumber0: function SingleUnitSassNumber0(t0, t1, t2) {
                var _ = this;
                _._single_unit$_unit = t0;
                _._number1$_value = t1;
                _.hashCache = null;
                _.asSlash = t2;
            },
            SingleUnitSassNumber__coerceToUnit_closure0: function SingleUnitSassNumber__coerceToUnit_closure0(t0, t1) {
                this.$this = t0;
                this.unit = t1;
            },
            SingleUnitSassNumber__coerceValueToUnit_closure0: function SingleUnitSassNumber__coerceValueToUnit_closure0(t0) {
                this.$this = t0;
            },
            SingleUnitSassNumber_multiplyUnits_closure1: function SingleUnitSassNumber_multiplyUnits_closure1(t0, t1) {
                this._box_0 = t0;
                this.$this = t1;
            },
            SingleUnitSassNumber_multiplyUnits_closure2: function SingleUnitSassNumber_multiplyUnits_closure2(t0, t1) {
                this._box_0 = t0;
                this.$this = t1;
            },
            SourceInterpolationVisitor: function SourceInterpolationVisitor(t0) {
                this.buffer = t0;
            },
            SourceInterpolationVisitor__visitArguments_closure: function SourceInterpolationVisitor__visitArguments_closure(t0) {
                this.$this = t0;
            },
            SourceInterpolationVisitor_visitIfConditionOperation_closure: function SourceInterpolationVisitor_visitIfConditionOperation_closure(t0) {
                this.$this = t0;
            },
            SourceInterpolationVisitor_visitListExpression_closure: function SourceInterpolationVisitor_visitListExpression_closure(t0) {
                this.$this = t0;
            },
            SourceMapBuffer0: function SourceMapBuffer0(t0, t1) {
                var _ = this;
                _._source_map_buffer0$_buffer = t0;
                _._source_map_buffer0$_entries = t1;
                _._source_map_buffer0$_column = _._source_map_buffer0$_line = 0;
                _._source_map_buffer0$_inSpan = false;
            },
            SourceMapBuffer_buildSourceMap_closure0: function SourceMapBuffer_buildSourceMap_closure0(t0, t1) {
                this._box_0 = t0;
                this.prefixLength = t1;
            },
            updateSourceSpanPrototype: function() {
                var t3, t4, _i, t5, span = A.SourceFile$fromString("", null).span$1(0, 0), t1 = type$.SourceSpan, t2 = type$.String;
                for(t1 = [
                    span,
                    new A.MultiSpan0(span, "", A.ConstantMap_ConstantMap$from(A.LinkedHashMap_LinkedHashMap$_empty(t1, t2), t1, t2)),
                    new A.LazyFileSpan0(new A.updateSourceSpanPrototype_closure(span))
                ], t3 = type$.JSClass, t4 = type$.Function, _i = 0; _i < 3; ++_i){
                    t5 = t3._as(t1[_i].constructor);
                    A.LinkedHashMap_LinkedHashMap$_literal([
                        "start",
                        new A.updateSourceSpanPrototype_closure0(),
                        "end",
                        new A.updateSourceSpanPrototype_closure1(),
                        "url",
                        new A.updateSourceSpanPrototype_closure2(),
                        "text",
                        new A.updateSourceSpanPrototype_closure3(),
                        "context",
                        new A.updateSourceSpanPrototype_closure4()
                    ], t2, t4).forEach$1(0, A.JSClassExtension_get_defineGetter(t5));
                }
                t1 = t3._as(A.FileLocation$_(span.file, span._file$_start).constructor);
                A.LinkedHashMap_LinkedHashMap$_literal([
                    "line",
                    new A.updateSourceSpanPrototype_closure5(),
                    "column",
                    new A.updateSourceSpanPrototype_closure6()
                ], t2, t4).forEach$1(0, A.JSClassExtension_get_defineGetter(t1));
            },
            updateSourceSpanPrototype_closure: function updateSourceSpanPrototype_closure(t0) {
                this.span = t0;
            },
            updateSourceSpanPrototype_closure0: function updateSourceSpanPrototype_closure0() {},
            updateSourceSpanPrototype_closure1: function updateSourceSpanPrototype_closure1() {},
            updateSourceSpanPrototype_closure2: function updateSourceSpanPrototype_closure2() {},
            updateSourceSpanPrototype__closure: function updateSourceSpanPrototype__closure() {},
            updateSourceSpanPrototype_closure3: function updateSourceSpanPrototype_closure3() {},
            updateSourceSpanPrototype_closure4: function updateSourceSpanPrototype_closure4() {},
            updateSourceSpanPrototype_closure5: function updateSourceSpanPrototype_closure5() {},
            updateSourceSpanPrototype_closure6: function updateSourceSpanPrototype_closure6() {},
            ColorSpace_fromName0: function($name, argumentName) {
                var t1, _0_0 = $name.toLowerCase();
                $label0$0: {
                    if ("rgb" === _0_0) {
                        t1 = B.RgbColorSpace_i0P0;
                        break $label0$0;
                    }
                    if ("hwb" === _0_0) {
                        t1 = B.HwbColorSpace_guQ0;
                        break $label0$0;
                    }
                    if ("hsl" === _0_0) {
                        t1 = B.HslColorSpace_JQ20;
                        break $label0$0;
                    }
                    if ("srgb" === _0_0) {
                        t1 = B.SrgbColorSpace_thf0;
                        break $label0$0;
                    }
                    if ("srgb-linear" === _0_0) {
                        t1 = B.SrgbLinearColorSpace_kUj0;
                        break $label0$0;
                    }
                    if ("display-p3" === _0_0) {
                        t1 = B.DisplayP3ColorSpace_MmT0;
                        break $label0$0;
                    }
                    if ("display-p3-linear" === _0_0) {
                        t1 = B.DisplayP3LinearColorSpace_PrP0;
                        break $label0$0;
                    }
                    if ("a98-rgb" === _0_0) {
                        t1 = B.A98RgbColorSpace_lf20;
                        break $label0$0;
                    }
                    if ("prophoto-rgb" === _0_0) {
                        t1 = B.ProphotoRgbColorSpace_BDz0;
                        break $label0$0;
                    }
                    if ("rec2020" === _0_0) {
                        t1 = B.Rec2020ColorSpace_6oo0;
                        break $label0$0;
                    }
                    if ("xyz" === _0_0 || "xyz-d65" === _0_0) {
                        t1 = B.XyzD65ColorSpace_WiJ0;
                        break $label0$0;
                    }
                    if ("xyz-d50" === _0_0) {
                        t1 = B.XyzD50ColorSpace_2OB0;
                        break $label0$0;
                    }
                    if ("lab" === _0_0) {
                        t1 = B.LabColorSpace_2nT0;
                        break $label0$0;
                    }
                    if ("lch" === _0_0) {
                        t1 = B.LchColorSpace_Bpv0;
                        break $label0$0;
                    }
                    if ("oklab" === _0_0) {
                        t1 = B.OklabColorSpace_5400;
                        break $label0$0;
                    }
                    if ("oklch" === _0_0) {
                        t1 = B.OklchColorSpace_9Gj0;
                        break $label0$0;
                    }
                    t1 = A.throwExpression(A.SassScriptException$0('Unknown color space "' + $name + '".', argumentName));
                }
                return t1;
            },
            ColorSpace0: function ColorSpace0() {},
            SrgbColorSpace0: function SrgbColorSpace0(t0, t1) {
                this.name = t0;
                this._space$_channels = t1;
            },
            SrgbLinearColorSpace0: function SrgbLinearColorSpace0(t0, t1) {
                this.name = t0;
                this._space$_channels = t1;
            },
            Statement0: function Statement0() {},
            JSStatementVisitor: function JSStatementVisitor(t0) {
                this._statement$_inner = t0;
            },
            JSStatementVisitorObject: function JSStatementVisitorObject() {},
            StatementSearchVisitor0: function StatementSearchVisitor0() {},
            StatementSearchVisitor_visitIfRule_closure1: function StatementSearchVisitor_visitIfRule_closure1(t0) {
                this.$this = t0;
            },
            StatementSearchVisitor_visitIfRule__closure2: function StatementSearchVisitor_visitIfRule__closure2(t0) {
                this.$this = t0;
            },
            StatementSearchVisitor_visitIfRule_closure2: function StatementSearchVisitor_visitIfRule_closure2(t0) {
                this.$this = t0;
            },
            StatementSearchVisitor_visitIfRule__closure1: function StatementSearchVisitor_visitIfRule__closure1(t0) {
                this.$this = t0;
            },
            StatementSearchVisitor_visitChildren_closure0: function StatementSearchVisitor_visitChildren_closure0(t0) {
                this.$this = t0;
            },
            StaticImport0: function StaticImport0(t0, t1, t2) {
                this.url = t0;
                this.modifiers = t1;
                this.span = t2;
            },
            StderrLogger0: function StderrLogger0(t0) {
                this.color = t0;
            },
            StringExpression_quoteText0: function(text) {
                var quote = A.StringExpression__bestQuote0(A._setArrayType([
                    text
                ], type$.JSArray_String)), buffer = new A.StringBuffer(""), t1 = A.Primitives_stringFromCharCode(quote);
                buffer._contents = t1;
                A.StringExpression__quoteInnerText0(text, quote, buffer, true);
                t1 = buffer._contents += t1;
                return t1.charCodeAt(0) == 0 ? t1 : t1;
            },
            StringExpression__quoteInnerText0: function(text, quote, buffer, $static) {
                var t1, t2, i, _1_0, _0_0, t3, t4, t5, t0;
                for(t1 = text.length, t2 = t1 - 1, i = 0; i < t1; ++i){
                    _1_0 = text.charCodeAt(i);
                    if (_1_0 === 10 || _1_0 === 13 || _1_0 === 12) {
                        buffer.writeCharCode$1(92);
                        buffer.writeCharCode$1(97);
                        if (i !== t2) {
                            _0_0 = text.charCodeAt(i + 1);
                            t3 = true;
                            if (!(_0_0 === 32 || _0_0 === 9 || _0_0 === 10 || _0_0 === 13 || _0_0 === 12)) {
                                if (!(_0_0 >= 48 && _0_0 <= 57)) {
                                    if (!(_0_0 >= 97 && _0_0 <= 102)) t3 = _0_0 >= 65 && _0_0 <= 70;
                                }
                            }
                            if (t3) buffer.writeCharCode$1(32);
                        }
                        continue;
                    }
                    t3 = 92 === _1_0;
                    if (t3) t4 = _1_0;
                    else t4 = null;
                    if (!t3) {
                        t3 = false;
                        t5 = _1_0 === quote;
                        if (t5) t4 = _1_0;
                        if (!t5) {
                            if (35 === _1_0) {
                                if ($static) {
                                    if (i < t2) {
                                        t3 = text.charCodeAt(i + 1) === 123;
                                        if (t3) t4 = _1_0;
                                        t0 = t4;
                                        t4 = t3;
                                        t3 = t0;
                                    } else {
                                        t0 = t4;
                                        t4 = t3;
                                        t3 = t0;
                                    }
                                } else {
                                    t0 = t4;
                                    t4 = t3;
                                    t3 = t0;
                                }
                            } else {
                                t0 = t4;
                                t4 = t3;
                                t3 = t0;
                            }
                        } else {
                            t3 = t4;
                            t4 = true;
                        }
                    } else {
                        t3 = t4;
                        t4 = true;
                    }
                    if (t4) {
                        buffer.writeCharCode$1(92);
                        buffer.writeCharCode$1(t3);
                        continue;
                    }
                    buffer.writeCharCode$1(_1_0);
                }
            },
            StringExpression__bestQuote0: function(strings) {
                var t1, t2, t3, containsDoubleQuote, t4, t5;
                for(t1 = J.get$iterator$ax(strings), t2 = type$.CodeUnits, t3 = t2._eval$1("ListIterator<ListBase.E>"), t2 = t2._eval$1("ListBase.E"), containsDoubleQuote = false; t1.moveNext$0();)for(t4 = new A.CodeUnits(t1.get$current(t1)), t4 = new A.ListIterator(t4, t4.get$length(0), t3); t4.moveNext$0();){
                    t5 = t4.__internal$_current;
                    if (t5 == null) t5 = t2._as(t5);
                    if (t5 === 39) return 34;
                    if (t5 === 34) containsDoubleQuote = true;
                }
                return containsDoubleQuote ? 39 : 34;
            },
            StringExpression0: function StringExpression0(t0, t1) {
                this.text = t0;
                this.hasQuotes = t1;
            },
            _codepointForIndex0: function(index, lengthInCodepoints, allowNegative) {
                var result;
                if (index === 0) return 0;
                if (index > 0) return Math.min(index - 1, lengthInCodepoints);
                result = lengthInCodepoints + index;
                if (result < 0 && !allowNegative) return 0;
                return result;
            },
            _function7: function($name, $arguments, callback) {
                return A.BuiltInCallable$function0($name, $arguments, callback, "sass:string");
            },
            module_closure25: function module_closure25() {},
            module__closure3: function module__closure3(t0) {
                this.string = t0;
            },
            module__closure4: function module__closure4(t0) {
                this.string = t0;
            },
            _unquote_closure0: function _unquote_closure0() {},
            _quote_closure0: function _quote_closure0() {},
            _length_closure1: function _length_closure1() {},
            _insert_closure0: function _insert_closure0() {},
            _index_closure1: function _index_closure1() {},
            _slice_closure0: function _slice_closure0() {},
            _toUpperCase_closure0: function _toUpperCase_closure0() {},
            _toLowerCase_closure0: function _toLowerCase_closure0() {},
            _uniqueId_closure0: function _uniqueId_closure0() {},
            StringExtension_toCssIdentifier: function(_this) {
                var t1, doubleDash, _2_0, character, _3_0, _s52_ = "The U+0000 can't be represented as a CSS identifier.", _s65_ = "An individual surrogate can't be represented as a CSS identifier.", buffer = new A.StringBuffer(""), scanner = A.SpanScanner$(_this, null), writeEscape = new A.StringExtension_toCssIdentifier_writeEscape(buffer, scanner), consumeSurrogatePair = new A.StringExtension_toCssIdentifier_consumeSurrogatePair(scanner, writeEscape, buffer);
                if (scanner.scanChar$1(45)) {
                    if (scanner._string_scanner$_position === scanner.string.length) return "\\2d";
                    t1 = A.Primitives_stringFromCharCode(45);
                    buffer._contents += t1;
                    doubleDash = scanner.scanChar$1(45);
                    if (doubleDash) buffer._contents += t1;
                } else doubleDash = false;
                if (!doubleDash) $label0$0: {
                    _2_0 = scanner.peekChar$0();
                    if (_2_0 == null) scanner.error$1(0, "The empty string can't be represented as a CSS identifier.");
                    if (0 === _2_0) scanner.error$1(0, _s52_);
                    t1 = _2_0 >>> 10 === 54;
                    character = _2_0;
                    if (t1) {
                        consumeSurrogatePair.call$1(character);
                        break $label0$0;
                    }
                    if (_2_0 >>> 10 === 55) scanner.error$2$length(0, _s65_, 1);
                    if (_2_0 === 95 || A.CharacterExtension_get_isAlphabetic0(_2_0) || _2_0 >= 128) t1 = !(_2_0 >= 57344 && _2_0 <= 63743);
                    else t1 = false;
                    if (t1) {
                        t1 = A.Primitives_stringFromCharCode(scanner.readChar$0());
                        buffer._contents += t1;
                        break $label0$0;
                    }
                    writeEscape.call$1(scanner.readChar$0());
                }
                for(;;){
                    _3_0 = scanner.peekChar$0();
                    if (_3_0 == null) break;
                    if (0 === _3_0) scanner.error$1(0, _s52_);
                    t1 = _3_0 >>> 10 === 54;
                    if (t1) {
                        consumeSurrogatePair.call$1(_3_0);
                        continue;
                    }
                    if (_3_0 >>> 10 === 55) scanner.error$2$length(0, _s65_, 1);
                    if (_3_0 !== 95) {
                        if (!(_3_0 >= 97 && _3_0 <= 122)) t1 = _3_0 >= 65 && _3_0 <= 90;
                        else t1 = true;
                        t1 = t1 || _3_0 >= 128;
                    } else t1 = true;
                    if (!t1) t1 = _3_0 >= 48 && _3_0 <= 57 || _3_0 === 45;
                    else t1 = true;
                    if (t1) t1 = !(_3_0 >= 57344 && _3_0 <= 63743);
                    else t1 = false;
                    if (t1) {
                        t1 = A.Primitives_stringFromCharCode(scanner.readChar$0());
                        buffer._contents += t1;
                        continue;
                    }
                    writeEscape.call$1(scanner.readChar$0());
                }
                t1 = buffer._contents;
                return t1.charCodeAt(0) == 0 ? t1 : t1;
            },
            StringExtension_toCssIdentifier_writeEscape: function StringExtension_toCssIdentifier_writeEscape(t0, t1) {
                this.buffer = t0;
                this.scanner = t1;
            },
            StringExtension_toCssIdentifier_consumeSurrogatePair: function StringExtension_toCssIdentifier_consumeSurrogatePair(t0, t1, t2) {
                this.scanner = t0;
                this.writeEscape = t1;
                this.buffer = t2;
            },
            stringClass_closure: function stringClass_closure() {},
            stringClass__closure: function stringClass__closure() {},
            stringClass__closure0: function stringClass__closure0() {},
            stringClass__closure1: function stringClass__closure1() {},
            stringClass__closure2: function stringClass__closure2() {},
            stringClass__closure3: function stringClass__closure3() {},
            _ConstructorOptions1: function _ConstructorOptions1() {},
            _NodeSassString: function _NodeSassString() {},
            legacyStringClass_closure: function legacyStringClass_closure() {},
            legacyStringClass_closure0: function legacyStringClass_closure0() {},
            legacyStringClass_closure1: function legacyStringClass_closure1() {},
            SassString$0: function(_text, quotes) {
                return new A.SassString0(_text, quotes);
            },
            SassString0: function SassString0(t0, t1) {
                var _ = this;
                _._string0$_text = t0;
                _._string0$_hasQuotes = t1;
                _._string0$__SassString__sassLength_FI = $;
                _._string0$_hashCache = null;
            },
            ModifiableCssStyleRule$0: function(_selector, span, fromPlainCss, originalSelector) {
                var t1 = A._setArrayType([], type$.JSArray_ModifiableCssNode_2);
                return new A.ModifiableCssStyleRule0(_selector, originalSelector, span, fromPlainCss, new A.UnmodifiableListView(t1, type$.UnmodifiableListView_ModifiableCssNode_2), t1);
            },
            ModifiableCssStyleRule0: function ModifiableCssStyleRule0(t0, t1, t2, t3, t4, t5) {
                var _ = this;
                _._style_rule0$_selector = t0;
                _.originalSelector = t1;
                _.span = t2;
                _.fromPlainCss = t3;
                _.children = t4;
                _._node$_children = t5;
                _._node$_indexInParent = _._node$_parent = null;
                _.isGroupEnd = false;
            },
            StyleRule$0: function(selector, children, span) {
                var t1 = A.List_List$unmodifiable(children, type$.Statement_2), t2 = B.JSArray_methods.any$1(t1, new A.ParentStatement_closure0());
                return new A.StyleRule0(selector, null, span, t1, t2);
            },
            StyleRule$withParsedSelector: function(parsedSelector, children, span) {
                var t1 = A.List_List$unmodifiable(children, type$.Statement_2), t2 = B.JSArray_methods.any$1(t1, new A.ParentStatement_closure0());
                return new A.StyleRule0(null, parsedSelector, span, t1, t2);
            },
            StyleRule0: function StyleRule0(t0, t1, t2, t3, t4) {
                var _ = this;
                _.selector = t0;
                _.parsedSelector = t1;
                _.span = t2;
                _.children = t3;
                _.hasDeclarations = t4;
            },
            CssStylesheet0: function CssStylesheet0(t0, t1) {
                this.children = t0;
                this.span = t1;
            },
            ModifiableCssStylesheet$0: function(span) {
                var t1 = A._setArrayType([], type$.JSArray_ModifiableCssNode_2);
                return new A.ModifiableCssStylesheet0(span, new A.UnmodifiableListView(t1, type$.UnmodifiableListView_ModifiableCssNode_2), t1);
            },
            ModifiableCssStylesheet0: function ModifiableCssStylesheet0(t0, t1, t2) {
                var _ = this;
                _.span = t0;
                _.children = t1;
                _._node$_children = t2;
                _._node$_indexInParent = _._node$_parent = null;
                _.isGroupEnd = false;
            },
            StylesheetParser0: function StylesheetParser0() {},
            StylesheetParser_parse_closure0: function StylesheetParser_parse_closure0(t0) {
                this.$this = t0;
            },
            StylesheetParser_parse__closure0: function StylesheetParser_parse__closure0(t0) {
                this.$this = t0;
            },
            StylesheetParser_parseParameterList_closure0: function StylesheetParser_parseParameterList_closure0(t0) {
                this.$this = t0;
            },
            StylesheetParser__parseSingleProduction_closure0: function StylesheetParser__parseSingleProduction_closure0(t0, t1, t2) {
                this.$this = t0;
                this.production = t1;
                this.T = t2;
            },
            StylesheetParser_parseSignature_closure: function StylesheetParser_parseSignature_closure(t0, t1) {
                this.$this = t0;
                this.requireParens = t1;
            },
            StylesheetParser__statement_closure0: function StylesheetParser__statement_closure0(t0) {
                this.$this = t0;
            },
            StylesheetParser_variableDeclarationWithoutNamespace_closure1: function StylesheetParser_variableDeclarationWithoutNamespace_closure1(t0, t1) {
                this.$this = t0;
                this.start = t1;
            },
            StylesheetParser_variableDeclarationWithoutNamespace_closure2: function StylesheetParser_variableDeclarationWithoutNamespace_closure2(t0) {
                this.declaration = t0;
            },
            StylesheetParser__declarationOrBuffer_closure3: function StylesheetParser__declarationOrBuffer_closure3(t0) {
                this.$this = t0;
            },
            StylesheetParser__declarationOrBuffer_closure4: function StylesheetParser__declarationOrBuffer_closure4(t0) {
                this.$this = t0;
            },
            StylesheetParser__declarationOrBuffer_closure5: function StylesheetParser__declarationOrBuffer_closure5() {},
            StylesheetParser__declarationOrBuffer_closure6: function StylesheetParser__declarationOrBuffer_closure6(t0) {
                this.$this = t0;
            },
            StylesheetParser__styleRule_closure0: function StylesheetParser__styleRule_closure0(t0, t1, t2) {
                this.$this = t0;
                this.selector = t1;
                this.start = t2;
            },
            StylesheetParser__styleRule_closure1: function StylesheetParser__styleRule_closure1(t0, t1, t2) {
                this._box_0 = t0;
                this.$this = t1;
                this.start = t2;
            },
            StylesheetParser__withStyleRuleChildren_closure0: function StylesheetParser__withStyleRuleChildren_closure0(t0, t1, t2, t3, t4) {
                var _ = this;
                _.$this = t0;
                _.nodeWithSpan = t1;
                _.wasInStyleRule = t2;
                _.create = t3;
                _.T = t4;
            },
            StylesheetParser__propertyOrVariableDeclaration_closure0: function StylesheetParser__propertyOrVariableDeclaration_closure0(t0) {
                this.$this = t0;
            },
            StylesheetParser__tryDeclarationChildren_closure0: function StylesheetParser__tryDeclarationChildren_closure0(t0, t1) {
                this.name = t0;
                this.value = t1;
            },
            StylesheetParser__atRootRule_closure1: function StylesheetParser__atRootRule_closure1(t0) {
                this.query = t0;
            },
            StylesheetParser__atRootRule_closure2: function StylesheetParser__atRootRule_closure2() {},
            StylesheetParser__eachRule_closure0: function StylesheetParser__eachRule_closure0(t0, t1, t2, t3) {
                var _ = this;
                _.$this = t0;
                _.wasInControlDirective = t1;
                _.variables = t2;
                _.list = t3;
            },
            StylesheetParser__functionRule_closure0: function StylesheetParser__functionRule_closure0(t0, t1, t2) {
                this.name = t0;
                this.parameters = t1;
                this.precedingComment = t2;
            },
            StylesheetParser__forRule_closure1: function StylesheetParser__forRule_closure1(t0, t1) {
                this._box_0 = t0;
                this.$this = t1;
            },
            StylesheetParser__forRule_closure2: function StylesheetParser__forRule_closure2(t0, t1, t2, t3, t4, t5) {
                var _ = this;
                _._box_0 = t0;
                _.$this = t1;
                _.wasInControlDirective = t2;
                _.variable = t3;
                _.from = t4;
                _.to = t5;
            },
            StylesheetParser__memberList_closure0: function StylesheetParser__memberList_closure0(t0, t1, t2) {
                this.$this = t0;
                this.variables = t1;
                this.identifiers = t2;
            },
            StylesheetParser__includeRule_closure0: function StylesheetParser__includeRule_closure0(t0) {
                this.contentParameters_ = t0;
            },
            StylesheetParser_mediaRule_closure0: function StylesheetParser_mediaRule_closure0(t0) {
                this.query = t0;
            },
            StylesheetParser__mixinRule_closure0: function StylesheetParser__mixinRule_closure0(t0, t1, t2, t3) {
                var _ = this;
                _.$this = t0;
                _.name = t1;
                _.parameters = t2;
                _.precedingComment = t3;
            },
            StylesheetParser_mozDocumentRule_closure1: function StylesheetParser_mozDocumentRule_closure1(t0) {
                this.$this = t0;
            },
            StylesheetParser_mozDocumentRule_closure2: function StylesheetParser_mozDocumentRule_closure2(t0, t1, t2, t3) {
                var _ = this;
                _._box_0 = t0;
                _.$this = t1;
                _.name = t2;
                _.value = t3;
            },
            StylesheetParser_supportsRule_closure0: function StylesheetParser_supportsRule_closure0(t0) {
                this.condition = t0;
            },
            StylesheetParser__whileRule_closure0: function StylesheetParser__whileRule_closure0(t0, t1, t2) {
                this.$this = t0;
                this.wasInControlDirective = t1;
                this.condition = t2;
            },
            StylesheetParser_unknownAtRule_closure0: function StylesheetParser_unknownAtRule_closure0(t0, t1) {
                this._box_0 = t0;
                this.name = t1;
            },
            StylesheetParser__expression_resetState0: function StylesheetParser__expression_resetState0(t0, t1, t2) {
                this._box_0 = t0;
                this.$this = t1;
                this.start = t2;
            },
            StylesheetParser__expression_resolveOneOperation0: function StylesheetParser__expression_resolveOneOperation0(t0, t1) {
                this._box_0 = t0;
                this.$this = t1;
            },
            StylesheetParser__expression_resolveOperations0: function StylesheetParser__expression_resolveOperations0(t0, t1) {
                this._box_0 = t0;
                this.resolveOneOperation = t1;
            },
            StylesheetParser__expression_addSingleExpression0: function StylesheetParser__expression_addSingleExpression0(t0, t1, t2, t3) {
                var _ = this;
                _._box_0 = t0;
                _.$this = t1;
                _.resetState = t2;
                _.resolveOperations = t3;
            },
            StylesheetParser__expression_addOperator0: function StylesheetParser__expression_addOperator0(t0, t1, t2, t3) {
                var _ = this;
                _._box_0 = t0;
                _.$this = t1;
                _.resolveOneOperation = t2;
                _.addSingleExpression = t3;
            },
            StylesheetParser__expression_resolveSpaceExpressions0: function StylesheetParser__expression_resolveSpaceExpressions0(t0, t1, t2) {
                this._box_0 = t0;
                this.$this = t1;
                this.resolveOperations = t2;
            },
            StylesheetParser_expressionUntilComma_closure0: function StylesheetParser_expressionUntilComma_closure0(t0) {
                this.$this = t0;
            },
            StylesheetParser__isHexColor_closure0: function StylesheetParser__isHexColor_closure0() {},
            StylesheetParser__unicodeRange_closure1: function StylesheetParser__unicodeRange_closure1() {},
            StylesheetParser__unicodeRange_closure2: function StylesheetParser__unicodeRange_closure2() {},
            StylesheetParser_interpolatedStringToken_closure0: function StylesheetParser_interpolatedStringToken_closure0(t0) {
                this.$this = t0;
            },
            StylesheetParser_namespacedExpression_closure0: function StylesheetParser_namespacedExpression_closure0(t0, t1) {
                this.$this = t0;
                this.start = t1;
            },
            StylesheetParser_trySpecialFunction_closure0: function StylesheetParser_trySpecialFunction_closure0() {},
            StylesheetParser__interpolatedDeclarationValue_closure0: function StylesheetParser__interpolatedDeclarationValue_closure0(t0) {
                this.$this = t0;
            },
            StylesheetParser__expressionUntilComparison_closure0: function StylesheetParser__expressionUntilComparison_closure0(t0) {
                this.$this = t0;
            },
            StylesheetParser__publicIdentifier_closure0: function StylesheetParser__publicIdentifier_closure0(t0, t1) {
                this.$this = t0;
                this.start = t1;
            },
            Stylesheet$internal0: function(children, span, parseTimeWarnings, globalVariables, plainCss) {
                var t1 = A._setArrayType([], type$.JSArray_UseRule_2), t2 = A._setArrayType([], type$.JSArray_ForwardRule_2), t3 = A.ConstantMap_ConstantMap$from(globalVariables, type$.String, type$.FileSpan), t4 = A.List_List$unmodifiable(children, type$.Statement_2), t5 = B.JSArray_methods.any$1(t4, new A.ParentStatement_closure0());
                t1 = new A.Stylesheet0(span, plainCss, t1, t2, new A.UnmodifiableListView(parseTimeWarnings, type$.UnmodifiableListView_Record_3_nullable_Deprecation_deprecation_and_String_message_and_FileSpan_span_2), t3, t4, t5);
                t1.Stylesheet$internal$5$globalVariables$plainCss0(children, span, parseTimeWarnings, globalVariables, plainCss);
                return t1;
            },
            Stylesheet_Stylesheet$parse0: function(contents, syntax, parseSelectors, url) {
                var error, stackTrace, url0, t1, _$exception, t2;
                try {
                    switch(syntax.index){
                        case 1:
                            t1 = new A.SassParser0(parseSelectors, A.LinkedHashMap_LinkedHashMap$_empty(type$.String, type$.FileSpan), A._setArrayType([], type$.JSArray_Record_3_nullable_Deprecation_deprecation_and_String_message_and_FileSpan_span_2), A.SpanScanner$(contents, url), null).parse$0(0);
                            return t1;
                        case 0:
                            t1 = A.ScssParser$0(contents, parseSelectors, url).parse$0(0);
                            return t1;
                        case 2:
                            t1 = new A.CssParser0(parseSelectors, A.LinkedHashMap_LinkedHashMap$_empty(type$.String, type$.FileSpan), A._setArrayType([], type$.JSArray_Record_3_nullable_Deprecation_deprecation_and_String_message_and_FileSpan_span_2), A.SpanScanner$(contents, url), null).parse$0(0);
                            return t1;
                    }
                } catch (exception) {
                    t1 = A.unwrapException(exception);
                    if (t1 instanceof A.SassException0) {
                        error = t1;
                        stackTrace = A.getTraceFromException(exception);
                        t1 = error;
                        t2 = J.getInterceptor$x(t1);
                        t1 = A.SourceSpanException.prototype.get$span.call(t2, t1);
                        url0 = t1.get$sourceUrl(t1);
                        if (url0 == null || url0.toString$0(0) === "stdin") throw exception;
                        t1 = type$.Uri;
                        throw A.wrapException(A.throwWithTrace0(error.withLoadedUrls$1(A.Set_Set$unmodifiable(A.LinkedHashSet_LinkedHashSet$_literal([
                            url0
                        ], t1), t1)), error, stackTrace));
                    } else throw exception;
                }
            },
            Stylesheet0: function Stylesheet0(t0, t1, t2, t3, t4, t5, t6, t7) {
                var _ = this;
                _.span = t0;
                _.plainCss = t1;
                _._stylesheet1$_uses = t2;
                _._stylesheet1$_forwards = t3;
                _.parseTimeWarnings = t4;
                _.globalVariables = t5;
                _.children = t6;
                _.hasDeclarations = t7;
            },
            SupportsExpression0: function SupportsExpression0(t0) {
                this.condition = t0;
            },
            ModifiableCssSupportsRule$0: function(condition, span) {
                var t1 = A._setArrayType([], type$.JSArray_ModifiableCssNode_2);
                return new A.ModifiableCssSupportsRule0(condition, span, new A.UnmodifiableListView(t1, type$.UnmodifiableListView_ModifiableCssNode_2), t1);
            },
            ModifiableCssSupportsRule0: function ModifiableCssSupportsRule0(t0, t1, t2, t3) {
                var _ = this;
                _.condition = t0;
                _.span = t1;
                _.children = t2;
                _._node$_children = t3;
                _._node$_indexInParent = _._node$_parent = null;
                _.isGroupEnd = false;
            },
            SupportsRule$0: function(condition, children, span) {
                var t1 = A.List_List$unmodifiable(children, type$.Statement_2), t2 = B.JSArray_methods.any$1(t1, new A.ParentStatement_closure0());
                return new A.SupportsRule0(condition, span, t1, t2);
            },
            SupportsRule0: function SupportsRule0(t0, t1, t2, t3) {
                var _ = this;
                _.condition = t0;
                _.span = t1;
                _.children = t2;
                _.hasDeclarations = t3;
            },
            JSToDartImporter: function JSToDartImporter(t0, t1, t2) {
                this._sync$_canonicalize = t0;
                this._sync$_load = t1;
                this._sync$_nonCanonicalSchemes = t2;
            },
            JSToDartImporter_canonicalize_closure: function JSToDartImporter_canonicalize_closure(t0, t1) {
                this.$this = t0;
                this.url = t1;
            },
            JSToDartImporter_load_closure: function JSToDartImporter_load_closure(t0, t1) {
                this.$this = t0;
                this.url = t1;
            },
            Syntax_forPath0: function(path) {
                var t1, _0_0 = A.ParsedPath_ParsedPath$parse(path, $.$get$context().style)._splitExtension$1(1)[1];
                $label0$0: {
                    if (".sass" === _0_0) {
                        t1 = B.Syntax_Sass_1_sass0;
                        break $label0$0;
                    }
                    if (".css" === _0_0) {
                        t1 = B.Syntax_CSS_2_css0;
                        break $label0$0;
                    }
                    t1 = B.Syntax_SCSS_0_scss0;
                    break $label0$0;
                }
                return t1;
            },
            Syntax0: function Syntax0(t0, t1, t2) {
                this._syntax0$_name = t0;
                this.index = t1;
                this._name = t2;
            },
            InterpolatedTypeSelector: function InterpolatedTypeSelector(t0) {
                this.name = t0;
            },
            TypeSelector0: function TypeSelector0(t0, t1) {
                this.name = t0;
                this.span = t1;
            },
            Types: function Types() {},
            UnaryOperationExpression0: function UnaryOperationExpression0(t0, t1, t2) {
                this.operator = t0;
                this.operand = t1;
                this.span = t2;
            },
            UnaryOperator0: function UnaryOperator0(t0, t1, t2, t3) {
                var _ = this;
                _.name = t0;
                _.operator = t1;
                _.index = t2;
                _._name = t3;
            },
            UnitlessSassNumber0: function UnitlessSassNumber0(t0, t1) {
                this._number1$_value = t0;
                this.hashCache = null;
                this.asSlash = t1;
            },
            InterpolatedUniversalSelector: function InterpolatedUniversalSelector(t0, t1) {
                this.namespace = t0;
                this.span = t1;
            },
            UniversalSelector0: function UniversalSelector0(t0, t1) {
                this.namespace = t0;
                this.span = t1;
            },
            UnprefixedMapView0: function UnprefixedMapView0(t0, t1, t2) {
                this._unprefixed_map_view0$_map = t0;
                this._unprefixed_map_view0$_prefix = t1;
                this.$ti = t2;
            },
            _UnprefixedKeys0: function _UnprefixedKeys0(t0) {
                this._unprefixed_map_view0$_view = t0;
            },
            _UnprefixedKeys_iterator_closure1: function _UnprefixedKeys_iterator_closure1(t0) {
                this.$this = t0;
            },
            _UnprefixedKeys_iterator_closure2: function _UnprefixedKeys_iterator_closure2(t0) {
                this.$this = t0;
            },
            JSUrl0: function JSUrl0() {},
            UseRule0: function UseRule0(t0, t1, t2, t3) {
                var _ = this;
                _.url = t0;
                _.namespace = t1;
                _.configuration = t2;
                _.span = t3;
            },
            UserDefinedCallable0: function UserDefinedCallable0(t0, t1, t2, t3) {
                var _ = this;
                _.declaration = t0;
                _.environment = t1;
                _.inDependency = t2;
                _.$ti = t3;
            },
            fromImport0: function() {
                var t1 = type$.nullable_CanonicalizeContext_2._as($.Zone__current.$index(0, B.Symbol__canonicalizeContext));
                t1 = t1 == null ? null : t1._canonicalize_context$_fromImport;
                return t1 === true;
            },
            canonicalizeContext0: function() {
                var t1, _0_0 = $.Zone__current.$index(0, B.Symbol__canonicalizeContext);
                $label0$0: {
                    if (_0_0 == null) A.throwExpression(A.StateError$(string$.canoni));
                    if (_0_0 instanceof A.CanonicalizeContext0) {
                        t1 = _0_0;
                        break $label0$0;
                    }
                    t1 = A.throwExpression(A.StateError$(string$.Unexpe + A.S(_0_0) + "."));
                }
                return t1;
            },
            inImportRule: function(callback, $T) {
                var t1, _0_0 = $.Zone__current.$index(0, B.Symbol__canonicalizeContext);
                $label0$0: {
                    if (_0_0 == null) {
                        t1 = type$.nullable_Object;
                        t1 = A.runZoned(callback, A.LinkedHashMap_LinkedHashMap$_literal([
                            B.Symbol__canonicalizeContext,
                            new A.CanonicalizeContext0(true, null)
                        ], t1, t1), $T);
                        break $label0$0;
                    }
                    if (_0_0 instanceof A.CanonicalizeContext0) {
                        t1 = _0_0.withFromImport$2(true, callback);
                        break $label0$0;
                    }
                    t1 = A.throwExpression(A.StateError$(string$.Unexpe + A.S(_0_0) + "."));
                }
                return t1;
            },
            resolveImportPath0: function(path) {
                var t1, extension = A.ParsedPath_ParsedPath$parse(path, $.$get$context().style)._splitExtension$1(1)[1];
                if (extension === ".sass" || extension === ".scss" || extension === ".css") {
                    t1 = A.fromImport0() ? new A.resolveImportPath_closure1(path, extension).call$0() : null;
                    return t1 == null ? A._exactlyOne0(A._tryPath0(path)) : t1;
                }
                t1 = A.fromImport0() ? new A.resolveImportPath_closure2(path).call$0() : null;
                if (t1 == null) t1 = A._exactlyOne0(A._tryPathWithExtensions0(path));
                return t1 == null ? A._tryPathAsDirectory0(path) : t1;
            },
            _tryPathWithExtensions0: function(path) {
                var result = A._tryPath0(path + ".sass");
                B.JSArray_methods.addAll$1(result, A._tryPath0(path + ".scss"));
                return result.length !== 0 ? result : A._tryPath0(path + ".css");
            },
            _tryPath0: function(path) {
                var t1 = $.$get$context(), partial = A.join(t1.dirname$1(path), "_" + A.ParsedPath_ParsedPath$parse(path, t1.style).get$basename(), null);
                t1 = A._setArrayType([], type$.JSArray_String);
                if (A.fileExists0(partial)) t1.push(partial);
                if (A.fileExists0(path)) t1.push(path);
                return t1;
            },
            _tryPathAsDirectory0: function(path) {
                var t1;
                if (!A.dirExists0(path)) return null;
                t1 = A.fromImport0() ? new A._tryPathAsDirectory_closure0(path).call$0() : null;
                return t1 == null ? A._exactlyOne0(A._tryPathWithExtensions0(A.join(path, "index", null))) : t1;
            },
            _exactlyOne0: function(paths) {
                var _0_1, t1, path;
                $label0$0: {
                    _0_1 = paths.length;
                    if (_0_1 <= 0) {
                        t1 = null;
                        break $label0$0;
                    }
                    if (_0_1 === 1) {
                        path = paths[0];
                        t1 = path;
                        break $label0$0;
                    }
                    t1 = A.throwExpression(string$.It_s_n + B.JSArray_methods.map$1$1(paths, new A._exactlyOne_closure0(), type$.String).join$1(0, "\n"));
                }
                return t1;
            },
            resolveImportPath_closure1: function resolveImportPath_closure1(t0, t1) {
                this.path = t0;
                this.extension = t1;
            },
            resolveImportPath_closure2: function resolveImportPath_closure2(t0) {
                this.path = t0;
            },
            _tryPathAsDirectory_closure0: function _tryPathAsDirectory_closure0(t0) {
                this.path = t0;
            },
            _exactlyOne_closure0: function _exactlyOne_closure0() {},
            jsThrow: function(error) {
                return type$.Never._as($.$get$_jsThrow().call$1(error));
            },
            attachJsStack: function(error, trace) {
                var traceString = trace.toString$0(0), firstRealLine = B.JSString_methods.indexOf$1(traceString, "\n    at");
                if (firstRealLine !== -1) traceString = B.JSString_methods.substring$1(traceString, firstRealLine + 1);
                error.stack = "Error: " + A.S(J.get$message$x(error)) + "\n" + traceString;
            },
            jsForEach: function(object, callback) {
                var t1, t2;
                for(t1 = J.get$iterator$ax(self.Object.keys(object)); t1.moveNext$0();){
                    t2 = t1.get$current(t1);
                    callback.call$2(t2, object[t2]);
                }
            },
            jsType: function(value) {
                var typeOf = A._asString(new self.Function("value", "return typeof value").call$1(value));
                return typeOf !== "object" ? typeOf : A._asString(new self.Function("value", '    if (value && value.constructor && value.constructor.name) {\n      return value.constructor.name;\n    }\n    return "object";\n  ').call$1(value));
            },
            defineGetter: function(object, $name, get, value) {
                self.Object.defineProperty(object, $name, get == null ? {
                    value: value,
                    enumerable: false
                } : {
                    get: A.allowInteropCaptureThis(get),
                    enumerable: false
                });
            },
            allowInteropNamed: function($name, $function) {
                $function = A.allowInterop($function);
                A.defineGetter($function, "name", null, $name);
                A._hideDartProperties($function);
                return $function;
            },
            allowInteropCaptureThisNamed: function($name, $function) {
                $function = A.allowInteropCaptureThis($function);
                A.defineGetter($function, "name", null, $name);
                A._hideDartProperties($function);
                return $function;
            },
            _hideDartProperties: function(object) {
                var t1, t2, t3, t4;
                for(t1 = J.cast$1$0$ax(self.Object.getOwnPropertyNames(object), type$.String), t2 = A._instanceType(t1), t1 = new A.ListIterator(t1, t1.get$length(t1), t2._eval$1("ListIterator<ListBase.E>")), t2 = t2._eval$1("ListBase.E"); t1.moveNext$0();){
                    t3 = t1.__internal$_current;
                    if (t3 == null) t3 = t2._as(t3);
                    if (B.JSString_methods.startsWith$1(t3, "_")) {
                        t4 = {
                            value: object[t3],
                            enumerable: false
                        };
                        self.Object.defineProperty(object, t3, t4);
                    }
                }
            },
            futureToPromise0: function(future) {
                return new self.Promise(A.allowInterop(new A.futureToPromise_closure0(future)));
            },
            jsToDartUrl: function(url) {
                return A.Uri_parse(J.toString$0$(url));
            },
            dartToJSUrl: function(url) {
                return new self.URL(url.toString$0(0));
            },
            toJSArray: function(iterable) {
                var t1, t2, array = new self.Array();
                for(t1 = J.get$iterator$ax(iterable), t2 = J.getInterceptor$x(array); t1.moveNext$0();)t2.push$1(array, t1.get$current(t1));
                return array;
            },
            objectToMap: function(object) {
                var map = A.LinkedHashMap_LinkedHashMap$_empty(type$.String, type$.nullable_Object);
                A.jsForEach(object, new A.objectToMap_closure(map));
                return map;
            },
            mapToObject: function(map) {
                var t1, t2, result = new self.Object();
                for(t1 = A.MapExtensions_get_pairs0(map, type$.String, type$.nullable_Object), t1 = t1.get$iterator(t1); t1.moveNext$0();){
                    t2 = t1.get$current(t1);
                    result[t2._0] = t2._1;
                }
                return result;
            },
            jsToDartSeparator: function(separator) {
                var t1;
                $label0$0: {
                    if (" " === separator) {
                        t1 = B.ListSeparator_SrV0;
                        break $label0$0;
                    }
                    if ("," === separator) {
                        t1 = B.ListSeparator_z0K0;
                        break $label0$0;
                    }
                    if ("/" === separator) {
                        t1 = B.ListSeparator_Lul0;
                        break $label0$0;
                    }
                    if (separator == null) {
                        t1 = B.ListSeparator_undecided_null_3_undecided0;
                        break $label0$0;
                    }
                    t1 = A.jsThrow(new self.Error('Unknown separator "' + separator + '".'));
                }
                return t1;
            },
            parseSyntax: function(syntax) {
                var t1;
                $label0$0: {
                    if (syntax == null || "scss" === syntax) {
                        t1 = B.Syntax_SCSS_0_scss0;
                        break $label0$0;
                    }
                    if ("indented" === syntax) {
                        t1 = B.Syntax_Sass_1_sass0;
                        break $label0$0;
                    }
                    if ("css" === syntax) {
                        t1 = B.Syntax_CSS_2_css0;
                        break $label0$0;
                    }
                    t1 = A.jsThrow(new self.Error('Unknown syntax "' + syntax + '".'));
                }
                return t1;
            },
            entrypointFilename: function() {
                var _1_0, _1_5_isSet, _1_5, t2, path, t1 = self.require.main, _0_0 = t1 == null ? null : J.get$filename$x(t1);
                if (_0_0 != null) return _0_0;
                else {
                    _1_0 = J.get$argv$x(self.process);
                    t1 = J.getInterceptor$asx(_1_0);
                    _1_5_isSet = t1.get$length(_1_0) >= 2;
                    if (_1_5_isSet) {
                        _1_5 = t1.$index(_1_0, 1);
                        t2 = typeof _1_5 == "string";
                    } else {
                        _1_5 = null;
                        t2 = false;
                    }
                    if (t2) {
                        path = A._asString(_1_5_isSet ? _1_5 : t1.$index(_1_0, 1));
                        return J.resolve$1$x(J.createRequire$1$x(self.nodeModule, path), path);
                    } else return null;
                }
            },
            _PropertyDescriptor0: function _PropertyDescriptor0() {},
            futureToPromise_closure0: function futureToPromise_closure0(t0) {
                this.future = t0;
            },
            futureToPromise__closure0: function futureToPromise__closure0(t0) {
                this.resolve = t0;
            },
            futureToPromise__closure1: function futureToPromise__closure1(t0) {
                this.reject = t0;
            },
            objectToMap_closure: function objectToMap_closure(t0) {
                this.map = t0;
            },
            _RequireMain0: function _RequireMain0() {},
            toSentence0: function(iter, conjunction) {
                if (iter.get$length(iter) === 1) return J.toString$0$(iter.get$first(iter));
                return A.IterableExtension_get_exceptLast0(iter).join$1(0, ", ") + (" " + conjunction + " " + A.S(iter.get$last(iter)));
            },
            indent0: function(string, indentation) {
                return new A.MappedListIterable(A._setArrayType(string.split("\n"), type$.JSArray_String), new A.indent_closure0(indentation), type$.MappedListIterable_String_String).join$1(0, "\n");
            },
            pluralize0: function($name, number, plural) {
                if (number === 1) return $name;
                if (plural != null) return plural;
                return $name + "s";
            },
            trimAscii0: function(string, excludeEscape) {
                var t1, start = A._firstNonWhitespace0(string);
                if (start == null) t1 = "";
                else {
                    t1 = A._lastNonWhitespace0(string, true);
                    t1.toString;
                    t1 = B.JSString_methods.substring$2(string, start, t1 + 1);
                }
                return t1;
            },
            trimAsciiRight0: function(string, excludeEscape) {
                var end = A._lastNonWhitespace0(string, excludeEscape);
                return end == null ? "" : B.JSString_methods.substring$2(string, 0, end + 1);
            },
            _firstNonWhitespace0: function(string) {
                var t1, i, t2;
                for(t1 = string.length, i = 0; i < t1; ++i){
                    t2 = string.charCodeAt(i);
                    if (!(t2 === 32 || t2 === 9 || t2 === 10 || t2 === 13 || t2 === 12)) return i;
                }
                return null;
            },
            _lastNonWhitespace0: function(string, excludeEscape) {
                var i, i0, codeUnit;
                for(i = string.length - 1, i0 = i; i0 >= 0; --i0){
                    codeUnit = string.charCodeAt(i0);
                    if (!(codeUnit === 32 || codeUnit === 9 || codeUnit === 10 || codeUnit === 13 || codeUnit === 12)) {
                        if (excludeEscape && i0 !== 0 && i0 !== i && codeUnit === 92) return i0 + 1;
                        else return i0;
                    }
                }
                return null;
            },
            isPublic0: function(member) {
                var start = member.charCodeAt(0);
                return start !== 45 && start !== 95;
            },
            flattenVertically0: function(iterable, $T) {
                var result, t1 = iterable.$ti._eval$1("@<ListIterable.E>")._bind$1($T._eval$1("QueueList<0>"))._eval$1("MappedListIterable<1,2>"), queues = A.List_List$_of(new A.MappedListIterable(iterable, new A.flattenVertically_closure1($T), t1), t1._eval$1("ListIterable.E"));
                if (queues.length === 1) return B.JSArray_methods.get$first(queues);
                result = A._setArrayType([], $T._eval$1("JSArray<0>"));
                while(queues.length !== 0){
                    queues.$flags & 1 && A.throwUnsupportedOperation(queues, 16);
                    B.JSArray_methods._removeWhere$2(queues, new A.flattenVertically_closure2(result, $T), true);
                }
                return result;
            },
            codepointIndexToCodeUnitIndex0: function(string, codepointIndex) {
                var codeUnitIndex, i, codeUnitIndex0;
                for(codeUnitIndex = 0, i = 0; i < codepointIndex; ++i){
                    codeUnitIndex0 = codeUnitIndex + 1;
                    codeUnitIndex = string.charCodeAt(codeUnitIndex) >>> 10 === 54 ? codeUnitIndex0 + 1 : codeUnitIndex0;
                }
                return codeUnitIndex;
            },
            codeUnitIndexToCodepointIndex0: function(string, codeUnitIndex) {
                var codepointIndex, i;
                for(codepointIndex = 0, i = 0; i < codeUnitIndex; i = (string.charCodeAt(i) >>> 10 === 54 ? i + 1 : i) + 1)++codepointIndex;
                return codepointIndex;
            },
            frameForSpan0: function(span, member, url) {
                var t2, t3, t1 = url == null ? span.get$sourceUrl(span) : url;
                if (t1 == null) t1 = $.$get$_noSourceUrl0();
                t2 = span.get$start(span);
                t2 = t2.file.getLine$1(t2.offset);
                t3 = span.get$start(span);
                return new A.Frame(t1, t2 + 1, t3.file.getColumn$1(t3.offset) + 1, member);
            },
            declarationName0: function(span) {
                var text = span.get$text();
                return A.trimAsciiRight0(B.JSString_methods.substring$2(text, 0, B.JSString_methods.indexOf$1(text, ":")), false);
            },
            unvendor0: function($name) {
                var i, t1 = $name.length;
                if (t1 < 2) return $name;
                if ($name.charCodeAt(0) !== 45) return $name;
                if ($name.charCodeAt(1) === 45) return $name;
                for(i = 2; i < t1; ++i)if ($name.charCodeAt(i) === 45) return B.JSString_methods.substring$1($name, i + 1);
                return $name;
            },
            equalsIgnoreCase0: function(string1, string2) {
                var t1, i;
                if (string1 === string2) return true;
                if (string1 == null) return false;
                t1 = string1.length;
                if (t1 !== string2.length) return false;
                for(i = 0; i < t1; ++i)if (!A.characterEqualsIgnoreCase0(string1.charCodeAt(i), string2.charCodeAt(i))) return false;
                return true;
            },
            startsWithIgnoreCase0: function(string, prefix) {
                var i, t1 = prefix.length;
                if (string.length < t1) return false;
                for(i = 0; i < t1; ++i)if (!A.characterEqualsIgnoreCase0(string.charCodeAt(i), prefix.charCodeAt(i))) return false;
                return true;
            },
            mapInPlace0: function(list, $function) {
                var i;
                for(i = 0; i < list.length; ++i)list[i] = $function.call$1(list[i]);
            },
            longestCommonSubsequence0: function(list1, list2, select, $T) {
                var t1, _i, selections, i, i0, j, selection, j0, _length = list1.get$length(0) + 1, lengths = J.JSArray_JSArray$allocateFixed(_length, type$.List_int);
                for(t1 = type$.int, _i = 0; _i < _length; ++_i)lengths[_i] = A.List_List$filled(((list2._queue_list$_tail - list2._queue_list$_head & J.get$length$asx(list2._queue_list$_table) - 1) >>> 0) + 1, 0, false, t1);
                _length = list1.get$length(0);
                selections = J.JSArray_JSArray$allocateFixed(_length, $T._eval$1("List<0?>"));
                for(t1 = $T._eval$1("0?"), _i = 0; _i < _length; ++_i)selections[_i] = A.List_List$filled((list2._queue_list$_tail - list2._queue_list$_head & J.get$length$asx(list2._queue_list$_table) - 1) >>> 0, null, false, t1);
                for(i = 0; i < (list1._queue_list$_tail - list1._queue_list$_head & J.get$length$asx(list1._queue_list$_table) - 1) >>> 0; i = i0)for(i0 = i + 1, j = 0; j < (list2._queue_list$_tail - list2._queue_list$_head & J.get$length$asx(list2._queue_list$_table) - 1) >>> 0; j = j0){
                    selection = select.call$2(list1.$index(0, i), list2.$index(0, j));
                    selections[i][j] = selection;
                    t1 = lengths[i0];
                    j0 = j + 1;
                    t1[j0] = selection == null ? Math.max(t1[j], lengths[i][j0]) : lengths[i][j] + 1;
                }
                return new A.longestCommonSubsequence_backtrack0(selections, lengths, $T).call$2(list1.get$length(0) - 1, list2.get$length(0) - 1);
            },
            removeFirstWhere0: function(list, test, orElse) {
                var i;
                for(i = 0; i < list.length; ++i){
                    if (!test.call$1(list[i])) continue;
                    B.JSArray_methods.removeAt$1(list, i);
                    return;
                }
                orElse.call$0();
            },
            mapAddAll20: function(destination, source, $K1, $K2, $V) {
                source.forEach$1(0, new A.mapAddAll2_closure0(destination, $K1, $K2, $V));
            },
            setAll0: function(map, keys, value) {
                var t1;
                for(t1 = keys.get$iterator(keys); t1.moveNext$0();)map.$indexSet(0, t1.get$current(t1), value);
            },
            rotateSlice0: function(list, start, end) {
                var i, next, element = list.$index(0, end - 1);
                for(i = start; i < end; ++i, element = next){
                    next = list.$index(0, i);
                    list.$indexSet(0, i, element);
                }
            },
            mapAsync0: function(iterable, callback, $E, $F) {
                return A.mapAsync$body0(iterable, callback, $E, $F, $F._eval$1("Iterable<0>"));
            },
            mapAsync$body0: function(iterable, callback, $E, $F, $async$type) {
                var $async$goto = 0, $async$completer = A._makeAsyncAwaitCompleter($async$type), $async$returnValue, t2, _i, t1, $async$temp1;
                var $async$mapAsync0 = A._wrapJsFunctionForAsync(function($async$errorCode, $async$result) {
                    if ($async$errorCode === 1) return A._asyncRethrow($async$result, $async$completer);
                    for(;;)switch($async$goto){
                        case 0:
                            // Function start
                            t1 = A._setArrayType([], $F._eval$1("JSArray<0>"));
                            t2 = iterable.length, _i = 0;
                        case 3:
                            // for condition
                            if (!(_i < t2)) {
                                // goto after for
                                $async$goto = 5;
                                break;
                            }
                            $async$temp1 = t1;
                            $async$goto = 6;
                            return A._asyncAwait(callback.call$1(iterable[_i]), $async$mapAsync0);
                        case 6:
                            // returning from await.
                            $async$temp1.push($async$result);
                        case 4:
                            // for update
                            ++_i;
                            // goto for condition
                            $async$goto = 3;
                            break;
                        case 5:
                            // after for
                            $async$returnValue = t1;
                            // goto return
                            $async$goto = 1;
                            break;
                        case 1:
                            // return
                            return A._asyncReturn($async$returnValue, $async$completer);
                    }
                });
                return A._asyncStartSync($async$mapAsync0, $async$completer);
            },
            putIfAbsentAsync0: function(map, key, ifAbsent, $K, $V) {
                return A.putIfAbsentAsync$body0(map, key, ifAbsent, $K, $V, $V);
            },
            putIfAbsentAsync$body0: function(map, key, ifAbsent, $K, $V, $async$type) {
                var $async$goto = 0, $async$completer = A._makeAsyncAwaitCompleter($async$type), $async$returnValue, t1, value;
                var $async$putIfAbsentAsync0 = A._wrapJsFunctionForAsync(function($async$errorCode, $async$result) {
                    if ($async$errorCode === 1) return A._asyncRethrow($async$result, $async$completer);
                    for(;;)switch($async$goto){
                        case 0:
                            // Function start
                            if (map.containsKey$1(key)) {
                                t1 = map.$index(0, key);
                                $async$returnValue = t1 == null ? $V._as(t1) : t1;
                                // goto return
                                $async$goto = 1;
                                break;
                            }
                            $async$goto = 3;
                            return A._asyncAwait(ifAbsent.call$0(), $async$putIfAbsentAsync0);
                        case 3:
                            // returning from await.
                            value = $async$result;
                            map.$indexSet(0, key, value);
                            $async$returnValue = value;
                            // goto return
                            $async$goto = 1;
                            break;
                        case 1:
                            // return
                            return A._asyncReturn($async$returnValue, $async$completer);
                    }
                });
                return A._asyncStartSync($async$putIfAbsentAsync0, $async$completer);
            },
            copyMapOfMap0: function(map, $K1, $K2, $V) {
                var t3, key, child, t1 = $K2._eval$1("@<0>")._bind$1($V)._eval$1("Map<1,2>"), t2 = A.LinkedHashMap_LinkedHashMap$_empty($K1, t1);
                for(t1 = A.MapExtensions_get_pairs0(map, $K1, t1), t1 = t1.get$iterator(t1); t1.moveNext$0();){
                    t3 = t1.get$current(t1);
                    key = t3._0;
                    child = t3._1;
                    t3 = A.LinkedHashMap_LinkedHashMap(null, null, null, $K2, $V);
                    t3.addAll$1(0, child);
                    t2.$indexSet(0, key, t3);
                }
                return t2;
            },
            copyMapOfList0: function(map, $K, $E) {
                var t3, t1 = $E._eval$1("List<0>"), t2 = A.LinkedHashMap_LinkedHashMap$_empty($K, t1);
                for(t1 = A.MapExtensions_get_pairs0(map, $K, t1), t1 = t1.get$iterator(t1); t1.moveNext$0();){
                    t3 = t1.get$current(t1);
                    t2.$indexSet(0, t3._0, J.toList$0$ax(t3._1));
                }
                return t2;
            },
            consumeEscapedCharacter0: function(scanner) {
                var _1_0, value, i, next, t1;
                scanner.expectChar$1(92);
                _1_0 = scanner.peekChar$0();
                if (_1_0 == null) return 65533;
                if (_1_0 === 10 || _1_0 === 13 || _1_0 === 12) scanner.error$1(0, "Expected escape sequence.");
                if (A.CharacterExtension_get_isHex0(_1_0)) {
                    for(value = 0, i = 0; i < 6; ++i){
                        next = scanner.peekChar$0();
                        if (next != null) {
                            t1 = true;
                            if (!(next >= 48 && next <= 57)) {
                                if (!(next >= 97 && next <= 102)) t1 = next >= 65 && next <= 70;
                            }
                            t1 = !t1;
                        } else t1 = true;
                        if (t1) break;
                        value = (value << 4 >>> 0) + A.asHex0(scanner.readChar$0());
                    }
                    t1 = scanner.peekChar$0();
                    if (t1 === 32 || t1 === 9 || t1 === 10 || t1 === 13 || t1 === 12) scanner.readChar$0();
                    $label0$1: {
                        if (0 !== value) t1 = value >= 55296 && value <= 57343 || value >= 1114111;
                        else t1 = true;
                        if (t1) {
                            t1 = 65533;
                            break $label0$1;
                        }
                        t1 = value;
                        break $label0$1;
                    }
                    return t1;
                }
                return scanner.readChar$0();
            },
            throwWithTrace0: function(error, originalError, trace) {
                var t1 = A.getTrace0(originalError);
                A.attachTrace0(error, t1 == null ? trace : t1);
                throw A.wrapException(error);
            },
            attachTrace0: function(error, trace) {
                var t1;
                if (typeof error == "string" || typeof error == "number" || A._isBool(error)) return;
                if (trace.toString$0(0).length === 0) return;
                t1 = $.$get$_traces0();
                A.Expando__checkType(error);
                if (t1._jsWeakMap.get(error) == null) t1.$indexSet(0, error, trace);
            },
            getTrace0: function(error) {
                var t1;
                if (typeof error == "string" || typeof error == "number" || A._isBool(error)) t1 = null;
                else {
                    t1 = $.$get$_traces0();
                    A.Expando__checkType(error);
                    t1 = t1._jsWeakMap.get(error);
                }
                return t1;
            },
            parseSignature: function(signature, requireParens) {
                var error, stackTrace, t1, _$exception, t2;
                try {
                    t1 = A.ScssParser$0(signature, false, null).parseSignature$1$requireParens(requireParens);
                    return t1;
                } catch (exception) {
                    t1 = A.unwrapException(exception);
                    if (type$.SassFormatException_2._is(t1)) {
                        error = t1;
                        stackTrace = A.getTraceFromException(exception);
                        t1 = error._span_exception$_message;
                        t2 = J.get$span$x(error);
                        A.throwWithTrace0(new A.SassFormatException0(B.Set_empty, 'Invalid signature "' + signature + '": ' + t1, t2), error, stackTrace);
                    } else throw exception;
                }
            },
            indent_closure0: function indent_closure0(t0) {
                this.indentation = t0;
            },
            flattenVertically_closure1: function flattenVertically_closure1(t0) {
                this.T = t0;
            },
            flattenVertically_closure2: function flattenVertically_closure2(t0, t1) {
                this.result = t0;
                this.T = t1;
            },
            longestCommonSubsequence_backtrack0: function longestCommonSubsequence_backtrack0(t0, t1, t2) {
                this.selections = t0;
                this.lengths = t1;
                this.T = t2;
            },
            mapAddAll2_closure0: function mapAddAll2_closure0(t0, t1, t2, t3) {
                var _ = this;
                _.destination = t0;
                _.K1 = t1;
                _.K2 = t2;
                _.V = t3;
            },
            CssValue0: function CssValue0(t0, t1, t2) {
                this.value = t0;
                this.span = t1;
                this.$ti = t2;
            },
            ValueExpression0: function ValueExpression0(t0, t1) {
                this.value = t0;
                this.span = t1;
            },
            valueClass_closure: function valueClass_closure() {},
            valueClass__closure: function valueClass__closure() {},
            valueClass__closure0: function valueClass__closure0() {},
            valueClass__closure1: function valueClass__closure1() {},
            valueClass__closure2: function valueClass__closure2() {},
            valueClass__closure3: function valueClass__closure3() {},
            valueClass__closure4: function valueClass__closure4() {},
            valueClass__closure5: function valueClass__closure5() {},
            valueClass__closure6: function valueClass__closure6() {},
            valueClass__closure7: function valueClass__closure7() {},
            valueClass__closure8: function valueClass__closure8() {},
            valueClass__closure9: function valueClass__closure9() {},
            valueClass__closure10: function valueClass__closure10() {},
            valueClass__closure11: function valueClass__closure11() {},
            valueClass__closure12: function valueClass__closure12() {},
            valueClass__closure13: function valueClass__closure13() {},
            valueClass__closure14: function valueClass__closure14() {},
            valueClass__closure15: function valueClass__closure15() {},
            valueClass__closure16: function valueClass__closure16() {},
            valueClass__closure17: function valueClass__closure17() {},
            valueClass__closure18: function valueClass__closure18() {},
            SassApiValue_assertSelector0: function(_this, allowParent, $name) {
                var error, stackTrace, t1, _$exception, string = _this._value$_selectorString$1($name);
                try {
                    t1 = A.EvaluationContext_currentOrNull0();
                    if (t1 == null) t1 = A.throwExpression(A.StateError$(string$.No_Sass));
                    t1 = A.SelectorList_SelectorList$parse0(string, allowParent, null, new A._EvaluationContextLogger0(t1), false);
                    return t1;
                } catch (exception) {
                    t1 = A.unwrapException(exception);
                    if (type$.SassFormatException_2._is(t1)) {
                        error = t1;
                        stackTrace = A.getTraceFromException(exception);
                        t1 = B.JSString_methods.replaceFirst$2(J.toString$0$(error), "Error: ", "");
                        A.throwWithTrace0(new A.SassScriptException0($name == null ? t1 : "$" + $name + ": " + t1), error, stackTrace);
                    } else throw exception;
                }
            },
            SassApiValue_assertCompoundSelector0: function(_this, $name) {
                var error, stackTrace, t1, _$exception, allowParent = false, string = _this._value$_selectorString$1($name);
                try {
                    t1 = A.EvaluationContext_currentOrNull0();
                    if (t1 == null) t1 = A.throwExpression(A.StateError$(string$.No_Sass));
                    t1 = A.SelectorParser$0(string, allowParent, null, new A._EvaluationContextLogger0(t1), false, null).parseCompoundSelector$0();
                    return t1;
                } catch (exception) {
                    t1 = A.unwrapException(exception);
                    if (type$.SassFormatException_2._is(t1)) {
                        error = t1;
                        stackTrace = A.getTraceFromException(exception);
                        t1 = B.JSString_methods.replaceFirst$2(J.toString$0$(error), "Error: ", "");
                        A.throwWithTrace0(new A.SassScriptException0("$" + $name + ": " + t1), error, stackTrace);
                    } else throw exception;
                }
            },
            Value0: function Value0() {},
            VariableExpression0: function VariableExpression0(t0, t1, t2) {
                this.namespace = t0;
                this.name = t1;
                this.span = t2;
            },
            VariableDeclaration$0: function($name, expression, span, comment, global, guarded, namespace) {
                if (namespace != null && global) A.throwExpression(A.ArgumentError$(string$.Other_, null));
                return new A.VariableDeclaration0(namespace, $name, expression, guarded, global, span);
            },
            VariableDeclaration0: function VariableDeclaration0(t0, t1, t2, t3, t4, t5) {
                var _ = this;
                _.namespace = t0;
                _.name = t1;
                _.expression = t2;
                _.isGuarded = t3;
                _.isGlobal = t4;
                _.span = t5;
            },
            WarnRule0: function WarnRule0(t0, t1) {
                this.expression = t0;
                this.span = t1;
            },
            WhileRule$0: function(condition, children, span) {
                var t1 = A.List_List$unmodifiable(children, type$.Statement_2), t2 = B.JSArray_methods.any$1(t1, new A.ParentStatement_closure0());
                return new A.WhileRule0(condition, span, t1, t2);
            },
            WhileRule0: function WhileRule0(t0, t1, t2, t3) {
                var _ = this;
                _.condition = t0;
                _.span = t1;
                _.children = t2;
                _.hasDeclarations = t3;
            },
            XyzD50ColorSpace0: function XyzD50ColorSpace0(t0, t1) {
                this.name = t0;
                this._space$_channels = t1;
            },
            XyzD65ColorSpace0: function XyzD65ColorSpace0(t0, t1) {
                this.name = t0;
                this._space$_channels = t1;
            },
            AsyncCallable_AsyncCallable$fromSignature: function(signature, callback, requireParens) {
                var _0_0 = A.parseSignature(signature, requireParens);
                return new A.AsyncBuiltInCallable0(_0_0._0, _0_0._1, callback, false);
            },
            Callable_Callable$fromSignature: function(signature, callback, requireParens) {
                var _0_0 = A.parseSignature(signature, requireParens);
                return new A.BuiltInCallable0(_0_0._0, A._setArrayType([
                    new A._Record_2(_0_0._1, callback)
                ], type$.JSArray_Record_2_ParameterList_and_Value_Function_List_Value_2), false);
            },
            printString: function(string) {
                if (typeof dartPrint == "function") {
                    dartPrint(string);
                    return;
                }
                if ((typeof console === "undefined" ? "undefined" : (0, $6tOPT._)(console)) == "object" && typeof console.log != "undefined") {
                    console.log(string);
                    return;
                }
                if (typeof print == "function") {
                    print(string);
                    return;
                }
                throw "Unable to print message: " + String(string);
            },
            mergeMaps: function(map1, map2, $K, $V) {
                var result = A.LinkedHashMap_LinkedHashMap$of(map1, $K, $V);
                result.addAll$1(0, map2);
                return result;
            },
            groupBy: function(values, key, $S, $T) {
                var t1, t2, _i, element, t3, t4, map = A.LinkedHashMap_LinkedHashMap$_empty($T, $S._eval$1("List<0>"));
                for(t1 = values.length, t2 = $S._eval$1("JSArray<0>"), _i = 0; _i < values.length; values.length === t1 || (0, A.throwConcurrentModificationError)(values), ++_i){
                    element = values[_i];
                    t3 = key.call$1(element);
                    t4 = map.$index(0, t3);
                    if (t4 == null) {
                        t4 = A._setArrayType([], t2);
                        map.$indexSet(0, t3, t4);
                        t3 = t4;
                    } else t3 = t4;
                    J.add$1$ax(t3, element);
                }
                return map;
            },
            minBy: function(values, orderBy) {
                var t1, t2, minValue, minOrderBy, element, elementOrderBy;
                for(t1 = values.$ti, t2 = new A.MappedIterator(J.get$iterator$ax(values.__internal$_iterable), values._f, t1._eval$1("MappedIterator<1,2>")), t1 = t1._rest[1], minValue = null, minOrderBy = null; t2.moveNext$0();){
                    element = t2.__internal$_current;
                    if (element == null) element = t1._as(element);
                    elementOrderBy = orderBy.call$1(element);
                    if (minOrderBy == null || A.defaultCompare(elementOrderBy, minOrderBy) < 0) {
                        minOrderBy = elementOrderBy;
                        minValue = element;
                    }
                }
                return minValue;
            },
            IterableExtension_firstWhereOrNull: function(_this, test) {
                var t1, element;
                for(t1 = J.get$iterator$ax(_this); t1.moveNext$0();){
                    element = t1.get$current(t1);
                    if (test.call$1(element)) return element;
                }
                return null;
            },
            IterableExtension_get_firstOrNull: function(_this) {
                var iterator = J.get$iterator$ax(_this);
                if (iterator.moveNext$0()) return iterator.get$current(iterator);
                return null;
            },
            IterableExtension_get_lastOrNull: function(_this) {
                if (_this.get$length(0) === 0) return null;
                return _this.get$last(_this);
            },
            IterableExtension_get_singleOrNull: function(_this) {
                var result, iterator = J.get$iterator$ax(_this);
                if (iterator.moveNext$0()) {
                    result = iterator.get$current(iterator);
                    if (!iterator.moveNext$0()) return result;
                }
                return null;
            },
            IterableIntegerExtension_get_maxOrNull: function(_this) {
                var value, newValue, t1 = _this.$ti, iterator = new A.ListIterator(_this, _this.get$length(0), t1._eval$1("ListIterator<ListIterable.E>"));
                if (iterator.moveNext$0()) {
                    value = iterator.__internal$_current;
                    if (value == null) value = t1._eval$1("ListIterable.E")._as(value);
                    for(t1 = t1._eval$1("ListIterable.E"); iterator.moveNext$0();){
                        newValue = iterator.__internal$_current;
                        if (newValue == null) newValue = t1._as(newValue);
                        if (newValue > value) value = newValue;
                    }
                    return value;
                }
                return null;
            },
            IterableIntegerExtension_get_max: function(_this) {
                var t1 = A.IterableIntegerExtension_get_maxOrNull(_this);
                return t1 == null ? A.throwExpression(A.StateError$("No element")) : t1;
            },
            IterableIntegerExtension_get_sum: function(_this) {
                var t1, t2, result, t3;
                for(t1 = _this.$ti, t2 = new A.MappedIterator(J.get$iterator$ax(_this.__internal$_iterable), _this._f, t1._eval$1("MappedIterator<1,2>")), t1 = t1._rest[1], result = 0; t2.moveNext$0();){
                    t3 = t2.__internal$_current;
                    result += t3 == null ? t1._as(t3) : t3;
                }
                return result;
            },
            ListExtensions_mapIndexed: function(_this, convert, $E, $R) {
                return new A._SyncStarIterable(A.ListExtensions_mapIndexed$body(_this, convert, $E, $R), $R._eval$1("_SyncStarIterable<0>"));
            },
            ListExtensions_mapIndexed$body: function($async$_this, $async$convert, $async$$E, $async$$R) {
                return function() {
                    var _this = $async$_this, convert = $async$convert, $E = $async$$E, $R = $async$$R;
                    var $async$goto = 0, $async$handler = 1, $async$errorStack = [], t1, index;
                    return function $async$ListExtensions_mapIndexed($async$iterator, $async$errorCode, $async$result) {
                        if ($async$errorCode === 1) {
                            $async$errorStack.push($async$result);
                            $async$goto = $async$handler;
                        }
                        for(;;)switch($async$goto){
                            case 0:
                                // Function start
                                t1 = _this.length, index = 0;
                            case 2:
                                // for condition
                                if (!(index < t1)) {
                                    // goto after for
                                    $async$goto = 4;
                                    break;
                                }
                                $async$goto = 5;
                                return $async$iterator._async$_current = convert.call$2(index, _this[index]), 1;
                            case 5:
                            // after yield
                            case 3:
                                // for update
                                ++index;
                                // goto for condition
                                $async$goto = 2;
                                break;
                            case 4:
                                // after for
                                // implicit return
                                return 0;
                            case 1:
                                // rethrow
                                return $async$iterator._datum = $async$errorStack.at(-1), 3;
                        }
                    };
                };
            },
            ListExtensions_elementAtOrNull: function(_this, index) {
                var t1 = J.getInterceptor$asx(_this);
                return index < t1.get$length(_this) ? t1.$index(_this, index) : null;
            },
            defaultCompare: function(value1, value2) {
                return J.compareTo$1$ns(type$.Comparable_nullable_Object._as(value1), value2);
            },
            current: function() {
                var _$exception, t1, path, lastIndex, uri = null;
                try {
                    uri = A.Uri_base();
                } catch (exception) {
                    if (type$.Exception._is(A.unwrapException(exception))) {
                        t1 = $._current;
                        if (t1 != null) return t1;
                        throw exception;
                    } else throw exception;
                }
                if (J.$eq$(uri, $._currentUriBase)) {
                    t1 = $._current;
                    t1.toString;
                    return t1;
                }
                $._currentUriBase = uri;
                if ($.$get$Style_platform() === $.$get$Style_url()) t1 = $._current = J.resolve$1$x(uri, ".").toString$0(0);
                else {
                    path = uri.toFilePath$0();
                    lastIndex = path.length - 1;
                    t1 = $._current = lastIndex === 0 ? path : B.JSString_methods.substring$2(path, 0, lastIndex);
                }
                return t1;
            },
            absolute: function(part1, part2, part3, part4, part5, part6, part7, part8, part9, part10, part11, part12, part13, part14, part15) {
                return $.$get$context().absolute$15(part1, part2, part3, part4, part5, part6, part7, part8, part9, part10, part11, part12, part13, part14, part15);
            },
            join: function(part1, part2, part3) {
                var _null = null;
                return $.$get$context().join$16(0, part1, part2, part3, _null, _null, _null, _null, _null, _null, _null, _null, _null, _null, _null, _null, _null);
            },
            toUri: function(path) {
                return $.$get$context().toUri$1(path);
            },
            prettyUri: function(uri) {
                var t1 = $.$get$context();
                uri.toString;
                return t1.prettyUri$1(uri);
            },
            isAlphabetic: function(char) {
                var t1;
                if (!(char >= 65 && char <= 90)) t1 = char >= 97 && char <= 122;
                else t1 = true;
                return t1;
            },
            driveLetterEnd: function(path, index) {
                var t2, t3, _null = null, t1 = path.length, index0 = index + 2;
                if (t1 < index0) return _null;
                if (!A.isAlphabetic(path.charCodeAt(index))) return _null;
                t2 = index + 1;
                if (path.charCodeAt(t2) !== 58) {
                    t3 = index + 4;
                    if (t1 < t3) return _null;
                    if (B.JSString_methods.substring$2(path, t2, t3).toLowerCase() !== "%3a") return _null;
                    index = index0;
                }
                t2 = index + 2;
                if (t1 === t2) return t2;
                if (path.charCodeAt(t2) !== 47) return _null;
                return index + 3;
            },
            main0: function(args) {
                var $async$goto = 0, $async$completer = A._makeAsyncAwaitCompleter(type$.void), t1;
                var $async$main0 = A._wrapJsFunctionForAsync(function($async$errorCode, $async$result) {
                    if ($async$errorCode === 1) return A._asyncRethrow($async$result, $async$completer);
                    for(;;)switch($async$goto){
                        case 0:
                            // Function start
                            A.printError("sass --embedded is unavailable in pure JS mode.");
                            t1 = A.isNodeJs() ? self.process : null;
                            if (t1 != null) J.set$exitCode$x(t1, 1);
                            // implicit return
                            return A._asyncReturn(null, $async$completer);
                    }
                });
                return A._asyncStartSync($async$main0, $async$completer);
            },
            compileStylesheets: function(options, graph, sourcesToDestinations, ifModified) {
                var $async$goto = 0, $async$completer = A._makeAsyncAwaitCompleter(type$.bool), $async$returnValue, _1_4, t2, t3, _i, t4, printedError, errorWithStackTrace, code, error, stackTrace, buffer, t1, $async$temp1;
                var $async$compileStylesheets = A._wrapJsFunctionForAsync(function($async$errorCode, $async$result) {
                    if ($async$errorCode === 1) return A._asyncRethrow($async$result, $async$completer);
                    for(;;)switch($async$goto){
                        case 0:
                            // Function start
                            t1 = type$.nullable_String;
                            t1 = A.List_List$_of(A.MapExtensions_get_pairs(sourcesToDestinations, t1, t1), type$.Record_2_nullable_String_and_nullable_String);
                            $async$goto = t1.length === 1 ? 4 : 5;
                            break;
                        case 4:
                            // then
                            _1_4 = t1[0];
                            $async$temp1 = A;
                            $async$goto = 6;
                            return A._asyncAwait(A.compileStylesheet(options, graph, _1_4._0, _1_4._1, ifModified), $async$compileStylesheets);
                        case 6:
                            // returning from await.
                            t1 = $async$temp1._setArrayType([
                                $async$result
                            ], type$.JSArray_nullable_Record_3_int_and_String_and_nullable_String);
                            // goto break $label0$0
                            $async$goto = 3;
                            break;
                        case 5:
                            // join
                            t2 = A._setArrayType([], type$.JSArray_Future_nullable_Record_3_int_and_String_and_nullable_String);
                            for(t3 = t1.length, _i = 0; _i < t1.length; t1.length === t3 || (0, A.throwConcurrentModificationError)(t1), ++_i){
                                t4 = t1[_i];
                                t2.push(A.compileStylesheet(options, graph, t4._0, t4._1, ifModified));
                            }
                            $async$goto = 7;
                            return A._asyncAwait(A.Future_wait(t2, A._asBool(options._options.$index(0, "stop-on-error")), type$.nullable_Record_3_int_and_String_and_nullable_String), $async$compileStylesheets);
                        case 7:
                            // returning from await.
                            t1 = $async$result;
                            // goto break $label0$0
                            $async$goto = 3;
                            break;
                        case 3:
                            // break $label0$0
                            for(t1 = J.get$iterator$ax(t1), printedError = false; t1.moveNext$0();){
                                errorWithStackTrace = t1.get$current(t1);
                                if (errorWithStackTrace == null) continue;
                                code = errorWithStackTrace._0;
                                error = errorWithStackTrace._1;
                                stackTrace = errorWithStackTrace._2;
                                t2 = self.process;
                                if (t2 == null) t2 = null;
                                else {
                                    t2 = J.get$release$x(t2);
                                    t2 = t2 == null ? null : J.get$name$x(t2);
                                }
                                t2 = J.$eq$(t2, "node") ? self.process : null;
                                t2 = t2 == null ? null : J.get$exitCode$x(t2);
                                if (t2 == null) t2 = 0;
                                t2 = Math.max(t2, code);
                                t3 = self.process;
                                if (t3 == null) t3 = null;
                                else {
                                    t3 = J.get$release$x(t3);
                                    t3 = t3 == null ? null : J.get$name$x(t3);
                                }
                                t3 = J.$eq$(t3, "node") ? self.process : null;
                                if (t3 != null) J.set$exitCode$x(t3, t2);
                                buffer = new A.StringBuffer("");
                                t2 = (printedError ? buffer._contents = "\n" : "") + error;
                                buffer._contents = t2;
                                if (stackTrace != null) {
                                    t2 += "\n";
                                    buffer._contents = t2;
                                    t2 += "\n";
                                    buffer._contents = t2;
                                    buffer._contents = t2 + stackTrace;
                                }
                                A.printError(buffer);
                                printedError = true;
                            }
                            $async$returnValue = !printedError;
                            // goto return
                            $async$goto = 1;
                            break;
                        case 1:
                            // return
                            return A._asyncReturn($async$returnValue, $async$completer);
                    }
                });
                return A._asyncStartSync($async$compileStylesheets, $async$completer);
            },
            CharacterExtension_get_isAlphabetic: function(_this) {
                var t1;
                if (!(_this >= 97 && _this <= 122)) t1 = _this >= 65 && _this <= 90;
                else t1 = true;
                return t1;
            },
            CharacterExtension_get_isHex: function(_this) {
                var t1 = true;
                if (!(_this >= 48 && _this <= 57)) {
                    if (!(_this >= 97 && _this <= 102)) t1 = _this >= 65 && _this <= 70;
                }
                return t1;
            },
            asHex: function(character) {
                var t1;
                $label0$0: {
                    if (character <= 57) {
                        t1 = character - 48;
                        break $label0$0;
                    }
                    if (character <= 70) {
                        t1 = 10 + character - 65;
                        break $label0$0;
                    }
                    t1 = 10 + character - 97;
                    break $label0$0;
                }
                return t1;
            },
            hexCharFor: function(number) {
                return number < 10 ? 48 + number : 87 + number;
            },
            opposite: function(character) {
                var t1;
                $label0$0: {
                    if (40 === character) {
                        t1 = 41;
                        break $label0$0;
                    }
                    if (123 === character) {
                        t1 = 125;
                        break $label0$0;
                    }
                    if (91 === character) {
                        t1 = 93;
                        break $label0$0;
                    }
                    t1 = A.throwExpression(A.ArgumentError$('"' + A.String_String$fromCharCode(character) + "\" isn't a brace-like character.", null));
                }
                return t1;
            },
            characterEqualsIgnoreCase: function(character1, character2) {
                var upperCase1;
                if (character1 === character2) return true;
                if ((character1 ^ character2) >>> 0 !== 32) return false;
                upperCase1 = (character1 & 4294967263) >>> 0;
                return upperCase1 >= 65 && upperCase1 <= 90;
            },
            IterableExtension_search: function(_this, callback) {
                var t1, _0_0;
                for(t1 = J.get$iterator$ax(_this); t1.moveNext$0();){
                    _0_0 = callback.call$1(t1.get$current(t1));
                    if (_0_0 != null) return _0_0;
                }
                return null;
            },
            IterableExtension_get_exceptLast: function(_this) {
                var t1 = J.getInterceptor$asx(_this), size = t1.get$length(_this) - 1;
                if (size < 0) throw A.wrapException(A.StateError$("Iterable may not be empty"));
                return t1.take$1(_this, size);
            },
            NullableExtension_andThen: function(_this, fn) {
                return _this == null ? null : fn.call$1(_this);
            },
            SetExtension_removeNull: function(_this, $T) {
                _this.remove$1(0, null);
                return A.Set_castFrom(_this, _this.get$_newSimilarSet(), A._instanceType(_this)._precomputed1, $T);
            },
            fuzzyEquals: function(number1, number2) {
                var t1;
                if (number1 === number2) return true;
                if (Math.abs(number1 - number2) <= $.$get$_epsilon()) {
                    t1 = $.$get$_inverseEpsilon();
                    t1 = B.JSNumber_methods.round$0(number1 * t1) === B.JSNumber_methods.round$0(number2 * t1);
                } else t1 = false;
                return t1;
            },
            fuzzyEqualsNullable: function(number1, number2) {
                var t1;
                if (number1 == number2) return true;
                if (number1 == null || number2 == null) return false;
                if (Math.abs(number1 - number2) <= $.$get$_epsilon()) {
                    t1 = $.$get$_inverseEpsilon();
                    t1 = B.JSNumber_methods.round$0(number1 * t1) === B.JSNumber_methods.round$0(number2 * t1);
                } else t1 = false;
                return t1;
            },
            fuzzyHashCode: function(number) {
                if (!isFinite(number)) return B.JSNumber_methods.get$hashCode(number);
                return B.JSInt_methods.get$hashCode(B.JSNumber_methods.round$0(number * $.$get$_inverseEpsilon()));
            },
            fuzzyLessThan: function(number1, number2) {
                return number1 < number2 && !A.fuzzyEquals(number1, number2);
            },
            fuzzyLessThanOrEquals: function(number1, number2) {
                return number1 < number2 || A.fuzzyEquals(number1, number2);
            },
            fuzzyGreaterThan: function(number1, number2) {
                return number1 > number2 && !A.fuzzyEquals(number1, number2);
            },
            fuzzyGreaterThanOrEquals: function(number1, number2) {
                return number1 > number2 || A.fuzzyEquals(number1, number2);
            },
            fuzzyIsInt: function(number) {
                if (number == 1 / 0 || number == -1 / 0 || isNaN(number)) return false;
                return A.fuzzyEquals(number, B.JSNumber_methods.round$0(number));
            },
            fuzzyAsInt: function(number) {
                var rounded;
                if (number == 1 / 0 || number == -1 / 0 || isNaN(number)) return null;
                rounded = B.JSNumber_methods.round$0(number);
                return A.fuzzyEquals(number, rounded) ? rounded : null;
            },
            fuzzyRound: function(number) {
                var t1;
                if (number > 0) {
                    t1 = B.JSNumber_methods.$mod(number, 1);
                    return t1 < 0.5 && !A.fuzzyEquals(t1, 0.5) ? B.JSNumber_methods.floor$0(number) : B.JSNumber_methods.ceil$0(number);
                } else {
                    t1 = B.JSNumber_methods.$mod(number, 1);
                    return t1 < 0.5 || A.fuzzyEquals(t1, 0.5) ? B.JSNumber_methods.floor$0(number) : B.JSNumber_methods.ceil$0(number);
                }
            },
            fuzzyCheckRange: function(number, min, max) {
                if (A.fuzzyEquals(number, min)) return min;
                if (A.fuzzyEquals(number, max)) return max;
                if (number > min && number < max) return number;
                return null;
            },
            fuzzyAssertRange: function(number, min, max, $name) {
                var result = A.fuzzyCheckRange(number, min, max);
                if (result != null) return result;
                throw A.wrapException(A.RangeError$range(number, min, max, $name, "must be between " + min + " and " + max));
            },
            moduloLikeSass: function(num1, num2) {
                var result;
                if (num1 == 1 / 0 || num1 == -1 / 0) return 0 / 0;
                if (num2 == 1 / 0 || num2 == -1 / 0) return A.DoubleWithSignedZero_get_signIncludingZero(num1) === J.get$sign$in(num2) ? num1 : 0 / 0;
                if (num2 > 0) return B.JSNumber_methods.$mod(num1, num2);
                if (num2 === 0) return 0 / 0;
                result = B.JSNumber_methods.$mod(num1, num2);
                return result === 0 ? 0 : result + num2;
            },
            sqrt: function(number) {
                number.assertNoUnits$1("number");
                return A.SassNumber_SassNumber(Math.sqrt(number._number$_value), null);
            },
            sin: function(number) {
                return A.SassNumber_SassNumber(Math.sin(number.coerceValueToUnit$2("rad", "number")), null);
            },
            cos: function(number) {
                return A.SassNumber_SassNumber(Math.cos(number.coerceValueToUnit$2("rad", "number")), null);
            },
            tan: function(number) {
                return A.SassNumber_SassNumber(Math.tan(number.coerceValueToUnit$2("rad", "number")), null);
            },
            atan: function(number) {
                number.assertNoUnits$1("number");
                return A.SassNumber_SassNumber$withUnits(Math.atan(number._number$_value) * 57.29577951308232, null, A._setArrayType([
                    "deg"
                ], type$.JSArray_String));
            },
            asin: function(number) {
                number.assertNoUnits$1("number");
                return A.SassNumber_SassNumber$withUnits(Math.asin(number._number$_value) * 57.29577951308232, null, A._setArrayType([
                    "deg"
                ], type$.JSArray_String));
            },
            acos: function(number) {
                number.assertNoUnits$1("number");
                return A.SassNumber_SassNumber$withUnits(Math.acos(number._number$_value) * 57.29577951308232, null, A._setArrayType([
                    "deg"
                ], type$.JSArray_String));
            },
            log: function(number, base) {
                if (base != null) return A.SassNumber_SassNumber(Math.log(number._number$_value) / Math.log(base._number$_value), null);
                return A.SassNumber_SassNumber(Math.log(number._number$_value), null);
            },
            pow0: function(base, exponent) {
                base.assertNoUnits$1("base");
                exponent.assertNoUnits$1("exponent");
                return A.SassNumber_SassNumber(Math.pow(base._number$_value, exponent._number$_value), null);
            },
            DoubleWithSignedZero_get_signIncludingZero: function(_this) {
                if (_this === -0) return -1;
                if (_this === 0) return 1;
                return J.get$sign$in(_this);
            },
            SpanExtensions_trimLeft: function(_this) {
                var t1, start = 0;
                for(;;){
                    t1 = _this.get$text().charCodeAt(start);
                    if (!(t1 === 32 || t1 === 9 || t1 === 10 || t1 === 13 || t1 === 12)) break;
                    ++start;
                }
                return A.FileSpanExtension_subspan(_this, start, null);
            },
            SpanExtensions_trimRight: function(_this) {
                var t1, end = _this.get$text().length - 1;
                for(;;){
                    t1 = _this.get$text().charCodeAt(end);
                    if (!(t1 === 32 || t1 === 9 || t1 === 10 || t1 === 13 || t1 === 12)) break;
                    --end;
                }
                return A.FileSpanExtension_subspan(_this, 0, end + 1);
            },
            SpanExtensions_initialIdentifier: function(_this) {
                var i, scanner = A.StringScanner$(_this.get$text(), null, null);
                for(i = 0; false;);
                A._scanIdentifier(scanner);
                return A.FileSpanExtension_subspan(_this, 0, scanner._string_scanner$_position);
            },
            _scanIdentifier: function(scanner) {
                var t1, _0_0, t2;
                for(t1 = scanner.string.length; scanner._string_scanner$_position !== t1;){
                    _0_0 = scanner.peekChar$0();
                    if (92 === _0_0) {
                        A.consumeEscapedCharacter(scanner);
                        continue;
                    }
                    if (A._isInt(_0_0)) {
                        if (_0_0 !== 95) {
                            if (!(_0_0 >= 97 && _0_0 <= 122)) t2 = _0_0 >= 65 && _0_0 <= 90;
                            else t2 = true;
                            t2 = t2 || _0_0 >= 128;
                        } else t2 = true;
                        if (!t2) t2 = _0_0 >= 48 && _0_0 <= 57 || _0_0 === 45;
                        else t2 = true;
                    } else t2 = false;
                    if (t2) {
                        scanner.readChar$0();
                        continue;
                    }
                    break;
                }
            },
            hueToRgb: function(m1, m2, hue) {
                var t1;
                if (hue < 0) ++hue;
                if (hue > 1) --hue;
                $label0$0: {
                    if (hue < 0.16666666666666666) {
                        t1 = m1 + (m2 - m1) * hue * 6;
                        break $label0$0;
                    }
                    if (hue < 0.5) {
                        t1 = m2;
                        break $label0$0;
                    }
                    if (hue < 0.6666666666666666) {
                        t1 = m1 + (m2 - m1) * (0.6666666666666666 - hue) * 6;
                        break $label0$0;
                    }
                    t1 = m1;
                    break $label0$0;
                }
                return t1;
            },
            srgbAndDisplayP3ToLinear: function(channel) {
                var abs = Math.abs(channel);
                return abs <= 0.04045 ? channel / 12.92 : J.get$sign$in(channel) * Math.pow((abs + 0.055) / 1.055, 2.4);
            },
            srgbAndDisplayP3FromLinear: function(channel) {
                var abs = Math.abs(channel);
                return abs <= 0.0031308 ? channel * 12.92 : J.get$sign$in(channel) * (1.055 * Math.pow(abs, 0.4166666666666667) - 0.055);
            },
            labToLch: function(dest, lightness, a, b, alpha, missingChroma, missingHue) {
                var t3, t4, chroma, hue, t1 = a == null, t2 = t1 ? 0 : a;
                t2 = Math.pow(t2, 2);
                t3 = b == null;
                t4 = t3 ? 0 : b;
                chroma = Math.sqrt(t2 + Math.pow(t4, 2));
                if (missingHue || A.fuzzyEquals(chroma, 0)) hue = null;
                else {
                    t2 = t3 ? 0 : b;
                    t1 = t1 ? 0 : a;
                    hue = Math.atan2(t2, t1) * 180 / 3.141592653589793;
                }
                t1 = missingChroma ? null : chroma;
                return A.SassColor_SassColor$forSpaceInternal(dest, lightness, t1, hue == null || hue >= 0 ? hue : hue + 360, alpha);
            },
            encodeVlq: function(value) {
                var res, signBit, digit, t1;
                if (value < $.$get$minInt32() || value > $.$get$maxInt32()) throw A.wrapException(A.ArgumentError$("expected 32 bit int, got: " + value, null));
                res = A._setArrayType([], type$.JSArray_String);
                if (value < 0) {
                    value = -value;
                    signBit = 1;
                } else signBit = 0;
                value = value << 1 | signBit;
                do {
                    digit = value & 31;
                    value = value >>> 5;
                    t1 = value > 0;
                    res.push(string$.ABCDEF[t1 ? digit | 32 : digit]);
                }while (t1);
                return res;
            },
            isAllTheSame: function(iter) {
                var firstValue, t1, t2, value;
                if (iter.get$length(0) === 0) return true;
                firstValue = iter.get$first(0);
                for(t1 = A.SubListIterable$(iter, 1, null, iter.$ti._eval$1("ListIterable.E")), t2 = t1.$ti, t1 = new A.ListIterator(t1, t1.get$length(0), t2._eval$1("ListIterator<ListIterable.E>")), t2 = t2._eval$1("ListIterable.E"); t1.moveNext$0();){
                    value = t1.__internal$_current;
                    if (!J.$eq$(value == null ? t2._as(value) : value, firstValue)) return false;
                }
                return true;
            },
            replaceFirstNull: function(list, element) {
                var index = B.JSArray_methods.indexOf$1(list, null);
                if (index < 0) throw A.wrapException(A.ArgumentError$(A.S(list) + " contains no null elements.", null));
                list[index] = element;
            },
            replaceWithNull: function(list, element) {
                var index = B.JSArray_methods.indexOf$1(list, element);
                if (index < 0) throw A.wrapException(A.ArgumentError$(A.S(list) + " contains no elements matching " + element.toString$0(0) + ".", null));
                list[index] = null;
            },
            countCodeUnits: function(string, codeUnit) {
                var t1, t2, count, t3;
                for(t1 = new A.CodeUnits(string), t2 = type$.CodeUnits, t1 = new A.ListIterator(t1, t1.get$length(0), t2._eval$1("ListIterator<ListBase.E>")), t2 = t2._eval$1("ListBase.E"), count = 0; t1.moveNext$0();){
                    t3 = t1.__internal$_current;
                    if ((t3 == null ? t2._as(t3) : t3) === codeUnit) ++count;
                }
                return count;
            },
            findLineStart: function(context, text, column) {
                var beginningOfLine, index, lineStart;
                if (text.length === 0) for(beginningOfLine = 0;;){
                    index = B.JSString_methods.indexOf$2(context, "\n", beginningOfLine);
                    if (index === -1) return context.length - beginningOfLine >= column ? beginningOfLine : null;
                    if (index - beginningOfLine >= column) return beginningOfLine;
                    beginningOfLine = index + 1;
                }
                index = B.JSString_methods.indexOf$1(context, text);
                while(index !== -1){
                    lineStart = index === 0 ? 0 : B.JSString_methods.lastIndexOf$2(context, "\n", index - 1) + 1;
                    if (column === index - lineStart) return lineStart;
                    index = B.JSString_methods.indexOf$2(context, text, index + 1);
                }
                return null;
            },
            validateErrorArgs: function(string, match, position, $length) {
                var t2, t1 = position != null;
                if (t1) {
                    if (position < 0) throw A.wrapException(A.RangeError$("position must be greater than or equal to 0."));
                    else if (position > string.length) throw A.wrapException(A.RangeError$("position must be less than or equal to the string length."));
                }
                t2 = $length != null;
                if (t2 && $length < 0) throw A.wrapException(A.RangeError$("length must be greater than or equal to 0."));
                if (t1 && t2 && position + $length > string.length) throw A.wrapException(A.RangeError$("position plus length must not go beyond the end of the string."));
            },
            CharacterExtension_get_isAlphabetic0: function(_this) {
                var t1;
                if (!(_this >= 97 && _this <= 122)) t1 = _this >= 65 && _this <= 90;
                else t1 = true;
                return t1;
            },
            CharacterExtension_get_isHex0: function(_this) {
                var t1 = true;
                if (!(_this >= 48 && _this <= 57)) {
                    if (!(_this >= 97 && _this <= 102)) t1 = _this >= 65 && _this <= 70;
                }
                return t1;
            },
            combineSurrogates: function(highSurrogate, lowSurrogate) {
                return 65536 + ((highSurrogate & 1023) << 10) + (lowSurrogate & 1023);
            },
            asHex0: function(character) {
                var t1;
                $label0$0: {
                    if (character <= 57) {
                        t1 = character - 48;
                        break $label0$0;
                    }
                    if (character <= 70) {
                        t1 = 10 + character - 65;
                        break $label0$0;
                    }
                    t1 = 10 + character - 97;
                    break $label0$0;
                }
                return t1;
            },
            hexCharFor0: function(number) {
                return number < 10 ? 48 + number : 87 + number;
            },
            opposite0: function(character) {
                var t1;
                $label0$0: {
                    if (40 === character) {
                        t1 = 41;
                        break $label0$0;
                    }
                    if (123 === character) {
                        t1 = 125;
                        break $label0$0;
                    }
                    if (91 === character) {
                        t1 = 93;
                        break $label0$0;
                    }
                    t1 = A.throwExpression(A.ArgumentError$('"' + A.String_String$fromCharCode(character) + "\" isn't a brace-like character.", null));
                }
                return t1;
            },
            characterEqualsIgnoreCase0: function(character1, character2) {
                var upperCase1;
                if (character1 === character2) return true;
                if ((character1 ^ character2) >>> 0 !== 32) return false;
                upperCase1 = (character1 & 4294967263) >>> 0;
                return upperCase1 >= 65 && upperCase1 <= 90;
            },
            IterableExtension_search0: function(_this, callback) {
                var t1, _0_0;
                for(t1 = J.get$iterator$ax(_this); t1.moveNext$0();){
                    _0_0 = callback.call$1(t1.get$current(t1));
                    if (_0_0 != null) return _0_0;
                }
                return null;
            },
            IterableExtension_get_exceptLast0: function(_this) {
                var t1 = J.getInterceptor$asx(_this), size = t1.get$length(_this) - 1;
                if (size < 0) throw A.wrapException(A.StateError$("Iterable may not be empty"));
                return t1.take$1(_this, size);
            },
            NullableExtension_andThen0: function(_this, fn) {
                return _this == null ? null : fn.call$1(_this);
            },
            fuzzyEquals0: function(number1, number2) {
                var t1;
                if (number1 === number2) return true;
                if (Math.abs(number1 - number2) <= $.$get$_epsilon0()) {
                    t1 = $.$get$_inverseEpsilon0();
                    t1 = B.JSNumber_methods.round$0(number1 * t1) === B.JSNumber_methods.round$0(number2 * t1);
                } else t1 = false;
                return t1;
            },
            fuzzyEqualsNullable0: function(number1, number2) {
                var t1;
                if (number1 == number2) return true;
                if (number1 == null || number2 == null) return false;
                if (Math.abs(number1 - number2) <= $.$get$_epsilon0()) {
                    t1 = $.$get$_inverseEpsilon0();
                    t1 = B.JSNumber_methods.round$0(number1 * t1) === B.JSNumber_methods.round$0(number2 * t1);
                } else t1 = false;
                return t1;
            },
            fuzzyHashCode0: function(number) {
                if (!isFinite(number)) return B.JSNumber_methods.get$hashCode(number);
                return B.JSInt_methods.get$hashCode(B.JSNumber_methods.round$0(number * $.$get$_inverseEpsilon0()));
            },
            fuzzyLessThan0: function(number1, number2) {
                return number1 < number2 && !A.fuzzyEquals0(number1, number2);
            },
            fuzzyLessThanOrEquals0: function(number1, number2) {
                return number1 < number2 || A.fuzzyEquals0(number1, number2);
            },
            fuzzyGreaterThan0: function(number1, number2) {
                return number1 > number2 && !A.fuzzyEquals0(number1, number2);
            },
            fuzzyGreaterThanOrEquals0: function(number1, number2) {
                return number1 > number2 || A.fuzzyEquals0(number1, number2);
            },
            fuzzyIsInt0: function(number) {
                if (number == 1 / 0 || number == -1 / 0 || isNaN(number)) return false;
                return A.fuzzyEquals0(number, B.JSNumber_methods.round$0(number));
            },
            fuzzyAsInt0: function(number) {
                var rounded;
                if (number == 1 / 0 || number == -1 / 0 || isNaN(number)) return null;
                rounded = B.JSNumber_methods.round$0(number);
                return A.fuzzyEquals0(number, rounded) ? rounded : null;
            },
            fuzzyRound0: function(number) {
                var t1;
                if (number > 0) {
                    t1 = B.JSNumber_methods.$mod(number, 1);
                    return t1 < 0.5 && !A.fuzzyEquals0(t1, 0.5) ? B.JSNumber_methods.floor$0(number) : B.JSNumber_methods.ceil$0(number);
                } else {
                    t1 = B.JSNumber_methods.$mod(number, 1);
                    return t1 < 0.5 || A.fuzzyEquals0(t1, 0.5) ? B.JSNumber_methods.floor$0(number) : B.JSNumber_methods.ceil$0(number);
                }
            },
            fuzzyCheckRange0: function(number, min, max) {
                if (A.fuzzyEquals0(number, min)) return min;
                if (A.fuzzyEquals0(number, max)) return max;
                if (number > min && number < max) return number;
                return null;
            },
            fuzzyAssertRange0: function(number, min, max, $name) {
                var result = A.fuzzyCheckRange0(number, min, max);
                if (result != null) return result;
                throw A.wrapException(A.RangeError$range(number, min, max, $name, "must be between " + min + " and " + max));
            },
            moduloLikeSass0: function(num1, num2) {
                var result;
                if (num1 == 1 / 0 || num1 == -1 / 0) return 0 / 0;
                if (num2 == 1 / 0 || num2 == -1 / 0) return A.DoubleWithSignedZero_get_signIncludingZero0(num1) === J.get$sign$in(num2) ? num1 : 0 / 0;
                if (num2 > 0) return B.JSNumber_methods.$mod(num1, num2);
                if (num2 === 0) return 0 / 0;
                result = B.JSNumber_methods.$mod(num1, num2);
                return result === 0 ? 0 : result + num2;
            },
            sqrt0: function(number) {
                number.assertNoUnits$1("number");
                return A.SassNumber_SassNumber0(Math.sqrt(number._number1$_value), null);
            },
            sin0: function(number) {
                return A.SassNumber_SassNumber0(Math.sin(number.coerceValueToUnit$2("rad", "number")), null);
            },
            cos0: function(number) {
                return A.SassNumber_SassNumber0(Math.cos(number.coerceValueToUnit$2("rad", "number")), null);
            },
            tan0: function(number) {
                return A.SassNumber_SassNumber0(Math.tan(number.coerceValueToUnit$2("rad", "number")), null);
            },
            atan0: function(number) {
                number.assertNoUnits$1("number");
                return A.SassNumber_SassNumber$withUnits0(Math.atan(number._number1$_value) * 57.29577951308232, null, A._setArrayType([
                    "deg"
                ], type$.JSArray_String));
            },
            asin0: function(number) {
                number.assertNoUnits$1("number");
                return A.SassNumber_SassNumber$withUnits0(Math.asin(number._number1$_value) * 57.29577951308232, null, A._setArrayType([
                    "deg"
                ], type$.JSArray_String));
            },
            acos0: function(number) {
                number.assertNoUnits$1("number");
                return A.SassNumber_SassNumber$withUnits0(Math.acos(number._number1$_value) * 57.29577951308232, null, A._setArrayType([
                    "deg"
                ], type$.JSArray_String));
            },
            log0: function(number, base) {
                if (base != null) return A.SassNumber_SassNumber0(Math.log(number._number1$_value) / Math.log(base._number1$_value), null);
                return A.SassNumber_SassNumber0(Math.log(number._number1$_value), null);
            },
            pow1: function(base, exponent) {
                base.assertNoUnits$1("base");
                exponent.assertNoUnits$1("exponent");
                return A.SassNumber_SassNumber0(Math.pow(base._number1$_value, exponent._number1$_value), null);
            },
            DoubleWithSignedZero_get_signIncludingZero0: function(_this) {
                if (_this === -0) return -1;
                if (_this === 0) return 1;
                return J.get$sign$in(_this);
            },
            main1: function(args) {
                return A.main$body(args);
            },
            main$body: function(args) {
                var $async$goto = 0, $async$completer = A._makeAsyncAwaitCompleter(type$.void), $async$returnValue, $async$handler = 2, $async$errorStack = [], options, t1, graph, error, error0, stackTrace, buffer, t2, exception, $async$exception, $async$temp1;
                var $async$main1 = A._wrapJsFunctionForAsync(function($async$errorCode, $async$result) {
                    if ($async$errorCode === 1) {
                        $async$errorStack.push($async$result);
                        $async$goto = $async$handler;
                    }
                    for(;;)switch($async$goto){
                        case 0:
                            // Function start
                            if (args.length >= 1 && "--embedded" === args[0]) {
                                A.main0(B.JSArray_methods.sublist$1(args, 1));
                                // goto return
                                $async$goto = 1;
                                break;
                            }
                            options = null;
                            $async$handler = 4;
                            options = A.ExecutableOptions_ExecutableOptions$parse(args);
                            t2 = options._options;
                            $._glyphs = !(t2.wasParsed$1("unicode") ? A._asBool(t2.$index(0, "unicode")) : $._glyphs !== B.C_AsciiGlyphSet) ? B.C_AsciiGlyphSet : B.C_UnicodeGlyphSet;
                            $async$goto = A._asBool(options._options.$index(0, "version")) ? 7 : 8;
                            break;
                        case 7:
                            // then
                            $async$temp1 = A;
                            $async$goto = 9;
                            return A._asyncAwait(A._loadVersion(), $async$main1);
                        case 9:
                            // returning from await.
                            $async$temp1.print($async$result);
                            t1 = A.isNodeJs() ? self.process : null;
                            if (t1 != null) J.set$exitCode$x(t1, 0);
                            // goto return
                            $async$goto = 1;
                            break;
                        case 8:
                            // join
                            $async$goto = options.get$interactive() ? 10 : 11;
                            break;
                        case 10:
                            // then
                            $async$goto = 12;
                            return A._asyncAwait(A.repl(options), $async$main1);
                        case 12:
                            // returning from await.
                            // goto return
                            $async$goto = 1;
                            break;
                        case 11:
                            // join
                            options.get$silenceDeprecations(0);
                            options.get$futureDeprecations(0);
                            options.get$fatalDeprecations(0);
                            t2 = A.List_List$_of(options.get$pkgImporters(), type$.Importer_2);
                            t1 = t2;
                            J.add$1$ax(t1, $.$get$FilesystemImporter_noLoadPath());
                            t2 = type$.Uri;
                            graph = new A.StylesheetGraph(A.LinkedHashMap_LinkedHashMap$_empty(t2, type$.StylesheetNode), A.ImportCache$(t1, type$.List_String._as(options._options.$index(0, "load-path"))), A.LinkedHashMap_LinkedHashMap$_empty(t2, type$.DateTime));
                            $async$goto = A._asBool(options._options.$index(0, "watch")) ? 13 : 14;
                            break;
                        case 13:
                            // then
                            $async$goto = 15;
                            return A._asyncAwait(A.watch(options, graph), $async$main1);
                        case 15:
                            // returning from await.
                            // goto return
                            $async$goto = 1;
                            break;
                        case 14:
                            // join
                            t1 = options;
                            t2 = options;
                            t2._ensureSources$0();
                            t2 = t2._sourcesToDestinations;
                            t2.toString;
                            $async$goto = 16;
                            return A._asyncAwait(A.compileStylesheets(t1, graph, t2, A._asBool(options._options.$index(0, "update"))), $async$main1);
                        case 16:
                            // returning from await.
                            $async$handler = 2;
                            // goto after finally
                            $async$goto = 6;
                            break;
                        case 4:
                            // catch
                            $async$handler = 3;
                            $async$exception = $async$errorStack.pop();
                            t1 = A.unwrapException($async$exception);
                            if (t1 instanceof A.UsageException) {
                                error = t1;
                                A.print(error.message + "\n");
                                A.print("Usage: sass <input.scss> [output.css]\n       sass <input.scss>:<output.css> <input/>:<output/> <dir/>\n");
                                t1 = $.$get$ExecutableOptions__parser();
                                A.print(new A._Usage(t1._optionsAndSeparators, new A.StringBuffer(""), t1.usageLineLength).generate$0());
                                t1 = A.isNodeJs() ? self.process : null;
                                if (t1 != null) J.set$exitCode$x(t1, 64);
                            } else {
                                error0 = t1;
                                stackTrace = A.getTraceFromException($async$exception);
                                buffer = new A.StringBuffer("");
                                t1 = options;
                                t1 = t1 == null ? null : t1.get$color();
                                if (t1 === true) buffer._contents += "\x1b[31m\x1b[1m";
                                buffer._contents += "Unexpected exception:";
                                t1 = options;
                                t1 = t1 == null ? null : t1.get$color();
                                if (t1 === true) buffer._contents += "\x1b[0m";
                                buffer._contents += "\n";
                                t1 = buffer;
                                t2 = A.S(error0) + "\n";
                                t1._contents += t2;
                                buffer._contents += "\n";
                                buffer._contents += "\n";
                                t2 = buffer;
                                t1 = A.getTrace(error0);
                                t1 = B.JSString_methods.trimRight$0(A.Trace_Trace$from(t1 == null ? stackTrace : t1).get$terse().toString$0(0));
                                t2._contents += t1;
                                A.printError(buffer);
                                t1 = A.isNodeJs() ? self.process : null;
                                if (t1 != null) J.set$exitCode$x(t1, 255);
                            }
                            // goto after finally
                            $async$goto = 6;
                            break;
                        case 3:
                            // uncaught
                            // goto rethrow
                            $async$goto = 2;
                            break;
                        case 6:
                        // after finally
                        case 1:
                            // return
                            return A._asyncReturn($async$returnValue, $async$completer);
                        case 2:
                            // rethrow
                            return A._asyncRethrow($async$errorStack.at(-1), $async$completer);
                    }
                });
                return A._asyncStartSync($async$main1, $async$completer);
            },
            _loadVersion: function() {
                var $async$goto = 0, $async$completer = A._makeAsyncAwaitCompleter(type$.String), $async$returnValue;
                var $async$_loadVersion = A._wrapJsFunctionForAsync(function($async$errorCode, $async$result) {
                    if ($async$errorCode === 1) return A._asyncRethrow($async$result, $async$completer);
                    for(;;)switch($async$goto){
                        case 0:
                            // Function start
                            $async$returnValue = "1.101.0 compiled with dart2js 3.12.2";
                            // goto return
                            $async$goto = 1;
                            break;
                        case 1:
                            // return
                            return A._asyncReturn($async$returnValue, $async$completer);
                    }
                });
                return A._asyncStartSync($async$_loadVersion, $async$completer);
            },
            SpanExtensions_trimLeft0: function(_this) {
                var t1, start = 0;
                for(;;){
                    t1 = _this.get$text().charCodeAt(start);
                    if (!(t1 === 32 || t1 === 9 || t1 === 10 || t1 === 13 || t1 === 12)) break;
                    ++start;
                }
                return A.FileSpanExtension_subspan(_this, start, null);
            },
            SpanExtensions_trimRight0: function(_this) {
                var t1, end = _this.get$text().length - 1;
                for(;;){
                    t1 = _this.get$text().charCodeAt(end);
                    if (!(t1 === 32 || t1 === 9 || t1 === 10 || t1 === 13 || t1 === 12)) break;
                    --end;
                }
                return A.FileSpanExtension_subspan(_this, 0, end + 1);
            },
            SpanExtensions_initialIdentifier0: function(_this) {
                var i, scanner = A.StringScanner$(_this.get$text(), null, null);
                for(i = 0; false;);
                A._scanIdentifier0(scanner);
                return A.FileSpanExtension_subspan(_this, 0, scanner._string_scanner$_position);
            },
            SpanExtensions_between: function(_this, other) {
                if (!J.$eq$(_this.get$sourceUrl(_this), other.get$sourceUrl(other))) throw A.wrapException(A.ArgumentError$(_this.toString$0(0) + " and " + other.toString$0(0) + " are in different files.", null));
                else if (_this.get$end(_this).offset > other.get$start(other).offset) throw A.wrapException(A.ArgumentError$(_this.toString$0(0) + " isn't before " + other.toString$0(0) + ".", null));
                return _this.get$file(_this).span$2(0, _this.get$end(_this).offset, other.get$start(other).offset);
            },
            SpanExtensions_before: function(_this, inner) {
                if (!J.$eq$(_this.get$sourceUrl(_this), inner.get$sourceUrl(inner))) throw A.wrapException(A.ArgumentError$(_this.toString$0(0) + " and " + inner.toString$0(0) + " are in different files.", null));
                else if (inner.get$start(inner).offset < _this.get$start(_this).offset || inner.get$end(inner).offset > _this.get$end(_this).offset) throw A.wrapException(A.ArgumentError$(inner.toString$0(0) + " isn't inside " + _this.toString$0(0) + ".", null));
                return _this.get$file(_this).span$2(0, _this.get$start(_this).offset, inner.get$start(inner).offset);
            },
            SpanExtensions_after: function(_this, inner) {
                if (!J.$eq$(_this.get$sourceUrl(_this), inner.get$sourceUrl(inner))) throw A.wrapException(A.ArgumentError$(_this.toString$0(0) + " and " + inner.toString$0(0) + " are in different files.", null));
                else if (inner.get$start(inner).offset < _this.get$start(_this).offset || inner.get$end(inner).offset > _this.get$end(_this).offset) throw A.wrapException(A.ArgumentError$(inner.toString$0(0) + " isn't inside " + _this.toString$0(0) + ".", null));
                return _this.get$file(_this).span$2(0, inner.get$end(inner).offset, _this.get$end(_this).offset);
            },
            _scanIdentifier0: function(scanner) {
                var t1, _0_0, t2;
                for(t1 = scanner.string.length; scanner._string_scanner$_position !== t1;){
                    _0_0 = scanner.peekChar$0();
                    if (92 === _0_0) {
                        A.consumeEscapedCharacter0(scanner);
                        continue;
                    }
                    if (A._isInt(_0_0)) {
                        if (_0_0 !== 95) {
                            if (!(_0_0 >= 97 && _0_0 <= 122)) t2 = _0_0 >= 65 && _0_0 <= 90;
                            else t2 = true;
                            t2 = t2 || _0_0 >= 128;
                        } else t2 = true;
                        if (!t2) t2 = _0_0 >= 48 && _0_0 <= 57 || _0_0 === 45;
                        else t2 = true;
                    } else t2 = false;
                    if (t2) {
                        scanner.readChar$0();
                        continue;
                    }
                    break;
                }
            },
            validateUrlScheme: function(scheme) {
                var t1 = $.$get$_urlSchemeRegExp();
                if (!t1._nativeRegExp.test(scheme)) A.jsThrow(new self.Error('"' + scheme + '" isn\'t a valid URL scheme (for example "file").'));
            },
            hueToRgb0: function(m1, m2, hue) {
                var t1;
                if (hue < 0) ++hue;
                if (hue > 1) --hue;
                $label0$0: {
                    if (hue < 0.16666666666666666) {
                        t1 = m1 + (m2 - m1) * hue * 6;
                        break $label0$0;
                    }
                    if (hue < 0.5) {
                        t1 = m2;
                        break $label0$0;
                    }
                    if (hue < 0.6666666666666666) {
                        t1 = m1 + (m2 - m1) * (0.6666666666666666 - hue) * 6;
                        break $label0$0;
                    }
                    t1 = m1;
                    break $label0$0;
                }
                return t1;
            },
            srgbAndDisplayP3ToLinear0: function(channel) {
                var abs = Math.abs(channel);
                return abs <= 0.04045 ? channel / 12.92 : J.get$sign$in(channel) * Math.pow((abs + 0.055) / 1.055, 2.4);
            },
            srgbAndDisplayP3FromLinear0: function(channel) {
                var abs = Math.abs(channel);
                return abs <= 0.0031308 ? channel * 12.92 : J.get$sign$in(channel) * (1.055 * Math.pow(abs, 0.4166666666666667) - 0.055);
            },
            labToLch0: function(dest, lightness, a, b, alpha, missingChroma, missingHue) {
                var t3, t4, chroma, hue, t1 = a == null, t2 = t1 ? 0 : a;
                t2 = Math.pow(t2, 2);
                t3 = b == null;
                t4 = t3 ? 0 : b;
                chroma = Math.sqrt(t2 + Math.pow(t4, 2));
                if (missingHue || A.fuzzyEquals0(chroma, 0)) hue = null;
                else {
                    t2 = t3 ? 0 : b;
                    t1 = t1 ? 0 : a;
                    hue = Math.atan2(t2, t1) * 180 / 3.141592653589793;
                }
                t1 = missingChroma ? null : chroma;
                return A.SassColor_SassColor$forSpaceInternal0(dest, lightness, t1, hue == null || hue >= 0 ? hue : hue + 360, alpha);
            },
            unwrapValue: function(object) {
                var value;
                if (object != null) {
                    if (object instanceof A.Value0) return object;
                    value = object.dartValue;
                    if (value != null && value instanceof A.Value0) return value;
                    if (object instanceof self.Error) throw A.wrapException(object);
                }
                throw A.wrapException(A.S(object) + " must be a Sass value type.");
            },
            wrapValue: function(value) {
                var t1;
                $label0$0: {
                    if (value instanceof A.SassColor0) {
                        t1 = A.callConstructor($.$get$legacyColorClass(), [
                            null,
                            null,
                            null,
                            null,
                            value
                        ]);
                        break $label0$0;
                    }
                    if (value instanceof A.SassList0) {
                        t1 = A.callConstructor($.$get$legacyListClass(), [
                            null,
                            null,
                            value
                        ]);
                        break $label0$0;
                    }
                    if (value instanceof A.SassMap0) {
                        t1 = A.callConstructor($.$get$legacyMapClass(), [
                            null,
                            value
                        ]);
                        break $label0$0;
                    }
                    if (value instanceof A.SassNumber0) {
                        t1 = A.callConstructor($.$get$legacyNumberClass(), [
                            null,
                            null,
                            value
                        ]);
                        break $label0$0;
                    }
                    if (value instanceof A.SassString0) {
                        t1 = A.callConstructor($.$get$legacyStringClass(), [
                            null,
                            value
                        ]);
                        break $label0$0;
                    }
                    t1 = value;
                    break $label0$0;
                }
                return t1;
            }
        }, B = {};
        var holders = [
            A,
            J,
            B
        ];
        var $ = {};
        A.JS_CONST.prototype = {};
        J.Interceptor.prototype = {
            $eq: function(receiver, other) {
                return receiver === other;
            },
            get$hashCode: function(receiver) {
                return A.Primitives_objectHashCode(receiver);
            },
            toString$0: function(receiver) {
                return "Instance of '" + A.Primitives_objectTypeName(receiver) + "'";
            },
            noSuchMethod$1: function(receiver, invocation) {
                throw A.wrapException(A.NoSuchMethodError_NoSuchMethodError$withInvocation(receiver, invocation));
            },
            get$runtimeType: function(receiver) {
                return A.createRuntimeType(A._instanceTypeFromConstructor(this));
            }
        };
        J.JSBool.prototype = {
            toString$0: function(receiver) {
                return String(receiver);
            },
            $or: function(receiver, other) {
                return other || receiver;
            },
            get$hashCode: function(receiver) {
                return receiver ? 519018 : 218159;
            },
            get$runtimeType: function(receiver) {
                return A.createRuntimeType(type$.bool);
            },
            $isTrustedGetRuntimeType: 1,
            $isbool: 1
        };
        J.JSNull.prototype = {
            $eq: function(receiver, other) {
                return null == other;
            },
            toString$0: function(receiver) {
                return "null";
            },
            get$hashCode: function(receiver) {
                return 0;
            },
            get$runtimeType: function(receiver) {
                return A.createRuntimeType(type$.Null);
            },
            $isTrustedGetRuntimeType: 1,
            $isNull: 1
        };
        J.JavaScriptObject.prototype = {
            $isJSObject: 1
        };
        var _obj;
        J.LegacyJavaScriptObject.prototype = (_obj = {
            get$hashCode: function(receiver) {
                return 0;
            },
            toString$0: function(receiver) {
                return String(receiver);
            },
            $isPromise: 1,
            $isJsSystemError: 1,
            $isImmutableList: 1,
            $is_ConstructionOptions: 1,
            $is_ChannelOptions: 1,
            $is_ToGamutOptions: 1,
            $is_InterpolationOptions: 1,
            $is_NodeSassColor: 1,
            $isCompileOptions: 1,
            $isCompileStringOptions: 1,
            $isNodeCompileResult: 1,
            $isDeprecation1: 1,
            $is_NodeException: 1,
            $isJSExpressionVisitorObject: 1,
            $isFiber: 1,
            $isJSFunction0: 1,
            $isJSIfConditionExpressionVisitorObject: 1,
            $isImmutableList0: 1,
            $isImmutableMap0: 1,
            $isJSImporter: 1,
            $isJSImporterResult: 1,
            $isNodeImporterResult0: 1,
            $is_ConstructorOptions: 1,
            $is_NodeSassList: 1,
            $isWarnOptions: 1,
            $isDebugOptions: 1,
            $is_NodeSassMap: 1,
            $is_ConstructorOptions0: 1,
            $is_NodeSassNumber: 1,
            $isParserExports: 1,
            $isJSClass0: 1,
            $isRenderContextOptions0: 1,
            $isRenderOptions: 1,
            $isRenderResult: 1,
            $isJSSet: 1,
            $isJSSimpleSelectorVisitorObject: 1,
            $isJSStatementVisitorObject: 1,
            $is_ConstructorOptions1: 1,
            $is_NodeSassString: 1,
            $isJSUrl0: 1,
            get$isTTY: function(obj) {
                return obj.isTTY;
            },
            get$write: function(obj) {
                return obj.write;
            },
            write$1: function(receiver, p0) {
                return receiver.write(p0);
            },
            createInterface$1: function(receiver, p0) {
                return receiver.createInterface(p0);
            },
            on$2: function(receiver, p0, p1) {
                return receiver.on(p0, p1);
            },
            get$close: function(obj) {
                return obj.close;
            },
            close$0: function(receiver) {
                return receiver.close();
            },
            setPrompt$1: function(receiver, p0) {
                return receiver.setPrompt(p0);
            },
            get$length: function(obj) {
                return obj.length;
            }
        }, (0, $c9996135bbccb03d$export$71511d61b312f219)(_obj, "toString$0", function(receiver) {
            return receiver.toString();
        }), (0, $c9996135bbccb03d$export$71511d61b312f219)(_obj, "get$debug", function(obj) {
            return obj.debug;
        }), (0, $c9996135bbccb03d$export$71511d61b312f219)(_obj, "debug$2", function(receiver, p0, p1) {
            return receiver.debug(p0, p1);
        }), (0, $c9996135bbccb03d$export$71511d61b312f219)(_obj, "get$error", function(obj) {
            return obj.error;
        }), (0, $c9996135bbccb03d$export$71511d61b312f219)(_obj, "error$1", function(receiver, p0) {
            return receiver.error(p0);
        }), (0, $c9996135bbccb03d$export$71511d61b312f219)(_obj, "error$2", function(receiver, p0, p1) {
            return receiver.error(p0, p1);
        }), (0, $c9996135bbccb03d$export$71511d61b312f219)(_obj, "log$1", function(receiver, p0) {
            return receiver.log(p0);
        }), (0, $c9996135bbccb03d$export$71511d61b312f219)(_obj, "get$warn", function(obj) {
            return obj.warn;
        }), (0, $c9996135bbccb03d$export$71511d61b312f219)(_obj, "warn$1", function(receiver, p0) {
            return receiver.warn(p0);
        }), (0, $c9996135bbccb03d$export$71511d61b312f219)(_obj, "warn$2", function(receiver, p0, p1) {
            return receiver.warn(p0, p1);
        }), (0, $c9996135bbccb03d$export$71511d61b312f219)(_obj, "existsSync$1", function(receiver, p0) {
            return receiver.existsSync(p0);
        }), (0, $c9996135bbccb03d$export$71511d61b312f219)(_obj, "lstatSync$1", function(receiver, p0) {
            return receiver.lstatSync(p0);
        }), (0, $c9996135bbccb03d$export$71511d61b312f219)(_obj, "mkdirSync$1", function(receiver, p0) {
            return receiver.mkdirSync(p0);
        }), (0, $c9996135bbccb03d$export$71511d61b312f219)(_obj, "readdirSync$1", function(receiver, p0) {
            return receiver.readdirSync(p0);
        }), (0, $c9996135bbccb03d$export$71511d61b312f219)(_obj, "readFileSync$2", function(receiver, p0, p1) {
            return receiver.readFileSync(p0, p1);
        }), (0, $c9996135bbccb03d$export$71511d61b312f219)(_obj, "get$realpathSync", function(obj) {
            return obj.realpathSync;
        }), (0, $c9996135bbccb03d$export$71511d61b312f219)(_obj, "statSync$1", function(receiver, p0) {
            return receiver.statSync(p0);
        }), (0, $c9996135bbccb03d$export$71511d61b312f219)(_obj, "unlinkSync$1", function(receiver, p0) {
            return receiver.unlinkSync(p0);
        }), (0, $c9996135bbccb03d$export$71511d61b312f219)(_obj, "watch$2", function(receiver, p0, p1) {
            return receiver.watch(p0, p1);
        }), (0, $c9996135bbccb03d$export$71511d61b312f219)(_obj, "writeFileSync$2", function(receiver, p0, p1) {
            return receiver.writeFileSync(p0, p1);
        }), (0, $c9996135bbccb03d$export$71511d61b312f219)(_obj, "call$1", function(receiver, p0) {
            return receiver.call(p0);
        }), (0, $c9996135bbccb03d$export$71511d61b312f219)(_obj, "call$2", function(receiver, p0, p1) {
            return receiver.call(p0, p1);
        }), (0, $c9996135bbccb03d$export$71511d61b312f219)(_obj, "call$3$1", function(receiver, p0) {
            return receiver.call(p0);
        }), (0, $c9996135bbccb03d$export$71511d61b312f219)(_obj, "call$2$1", function(receiver, p0) {
            return receiver.call(p0);
        }), (0, $c9996135bbccb03d$export$71511d61b312f219)(_obj, "call$1$1", function(receiver, p0) {
            return receiver.call(p0);
        }), (0, $c9996135bbccb03d$export$71511d61b312f219)(_obj, "call$3", function(receiver, p0, p1, p2) {
            return receiver.call(p0, p1, p2);
        }), (0, $c9996135bbccb03d$export$71511d61b312f219)(_obj, "call$3$3", function(receiver, p0, p1, p2) {
            return receiver.call(p0, p1, p2);
        }), (0, $c9996135bbccb03d$export$71511d61b312f219)(_obj, "call$2$2", function(receiver, p0, p1) {
            return receiver.call(p0, p1);
        }), (0, $c9996135bbccb03d$export$71511d61b312f219)(_obj, "call$1$2", function(receiver, p0, p1) {
            return receiver.call(p0, p1);
        }), (0, $c9996135bbccb03d$export$71511d61b312f219)(_obj, "call$2$3", function(receiver, p0, p1, p2) {
            return receiver.call(p0, p1, p2);
        }), (0, $c9996135bbccb03d$export$71511d61b312f219)(_obj, "native$1", function(receiver, p0) {
            return receiver.native(p0);
        }), (0, $c9996135bbccb03d$export$71511d61b312f219)(_obj, "get$path", function(obj) {
            return obj.path;
        }), (0, $c9996135bbccb03d$export$71511d61b312f219)(_obj, "isDirectory$0", function(receiver) {
            return receiver.isDirectory();
        }), (0, $c9996135bbccb03d$export$71511d61b312f219)(_obj, "isFile$0", function(receiver) {
            return receiver.isFile();
        }), (0, $c9996135bbccb03d$export$71511d61b312f219)(_obj, "isSymbolicLink$0", function(receiver) {
            return receiver.isSymbolicLink();
        }), (0, $c9996135bbccb03d$export$71511d61b312f219)(_obj, "get$mtime", function(obj) {
            return obj.mtime;
        }), (0, $c9996135bbccb03d$export$71511d61b312f219)(_obj, "then$2", function(receiver, p0, p1) {
            return receiver.then(p0, p1);
        }), (0, $c9996135bbccb03d$export$71511d61b312f219)(_obj, "then$1$1", function(receiver, p0) {
            return receiver.then(p0);
        }), (0, $c9996135bbccb03d$export$71511d61b312f219)(_obj, "getTime$0", function(receiver) {
            return receiver.getTime();
        }), (0, $c9996135bbccb03d$export$71511d61b312f219)(_obj, "get$message", function(obj) {
            return obj.message;
        }), (0, $c9996135bbccb03d$export$71511d61b312f219)(_obj, "message$1", function(receiver, p0) {
            return receiver.message(p0);
        }), (0, $c9996135bbccb03d$export$71511d61b312f219)(_obj, "get$filename", function(obj) {
            return obj.filename;
        }), (0, $c9996135bbccb03d$export$71511d61b312f219)(_obj, "get$id", function(obj) {
            return obj.id;
        }), (0, $c9996135bbccb03d$export$71511d61b312f219)(_obj, "get$code", function(obj) {
            return obj.code;
        }), (0, $c9996135bbccb03d$export$71511d61b312f219)(_obj, "get$syscall", function(obj) {
            return obj.syscall;
        }), (0, $c9996135bbccb03d$export$71511d61b312f219)(_obj, "get$argv", function(obj) {
            return obj.argv;
        }), (0, $c9996135bbccb03d$export$71511d61b312f219)(_obj, "get$env", function(obj) {
            return obj.env;
        }), (0, $c9996135bbccb03d$export$71511d61b312f219)(_obj, "get$exitCode", function(obj) {
            return obj.exitCode;
        }), (0, $c9996135bbccb03d$export$71511d61b312f219)(_obj, "set$exitCode", function(obj, v) {
            return obj.exitCode = v;
        }), (0, $c9996135bbccb03d$export$71511d61b312f219)(_obj, "get$platform", function(obj) {
            return obj.platform;
        }), (0, $c9996135bbccb03d$export$71511d61b312f219)(_obj, "get$release", function(obj) {
            return obj.release;
        }), (0, $c9996135bbccb03d$export$71511d61b312f219)(_obj, "get$stderr", function(obj) {
            return obj.stderr;
        }), (0, $c9996135bbccb03d$export$71511d61b312f219)(_obj, "get$stdin", function(obj) {
            return obj.stdin;
        }), (0, $c9996135bbccb03d$export$71511d61b312f219)(_obj, "get$stdout", function(obj) {
            return obj.stdout;
        }), (0, $c9996135bbccb03d$export$71511d61b312f219)(_obj, "get$name", function(obj) {
            return obj.name;
        }), (0, $c9996135bbccb03d$export$71511d61b312f219)(_obj, "push$1", function(receiver, p0) {
            return receiver.push(p0);
        }), (0, $c9996135bbccb03d$export$71511d61b312f219)(_obj, "call$0", function(receiver) {
            return receiver.call();
        }), (0, $c9996135bbccb03d$export$71511d61b312f219)(_obj, "call$2$0", function(receiver) {
            return receiver.call();
        }), (0, $c9996135bbccb03d$export$71511d61b312f219)(_obj, "call$1$0", function(receiver) {
            return receiver.call();
        }), (0, $c9996135bbccb03d$export$71511d61b312f219)(_obj, "apply$2", function(receiver, p0, p1) {
            return receiver.apply(p0, p1);
        }), (0, $c9996135bbccb03d$export$71511d61b312f219)(_obj, "toArray$0", function(receiver) {
            return receiver.toArray();
        }), (0, $c9996135bbccb03d$export$71511d61b312f219)(_obj, "asMutable$0", function(receiver) {
            return receiver.asMutable();
        }), (0, $c9996135bbccb03d$export$71511d61b312f219)(_obj, "asImmutable$0", function(receiver) {
            return receiver.asImmutable();
        }), (0, $c9996135bbccb03d$export$71511d61b312f219)(_obj, "$set$2", function(receiver, p0, p1) {
            return receiver.set(p0, p1);
        }), (0, $c9996135bbccb03d$export$71511d61b312f219)(_obj, "forEach$1", function(receiver, p0) {
            return receiver.forEach(p0);
        }), (0, $c9996135bbccb03d$export$71511d61b312f219)(_obj, "get$file", function(obj) {
            return obj.file;
        }), (0, $c9996135bbccb03d$export$71511d61b312f219)(_obj, "get$contents", function(obj) {
            return obj.contents;
        }), (0, $c9996135bbccb03d$export$71511d61b312f219)(_obj, "get$options", function(obj) {
            return obj.options;
        }), (0, $c9996135bbccb03d$export$71511d61b312f219)(_obj, "get$data", function(obj) {
            return obj.data;
        }), (0, $c9996135bbccb03d$export$71511d61b312f219)(_obj, "get$includePaths", function(obj) {
            return obj.includePaths;
        }), (0, $c9996135bbccb03d$export$71511d61b312f219)(_obj, "get$style", function(obj) {
            return obj.style;
        }), (0, $c9996135bbccb03d$export$71511d61b312f219)(_obj, "get$indentType", function(obj) {
            return obj.indentType;
        }), (0, $c9996135bbccb03d$export$71511d61b312f219)(_obj, "get$indentWidth", function(obj) {
            return obj.indentWidth;
        }), (0, $c9996135bbccb03d$export$71511d61b312f219)(_obj, "get$linefeed", function(obj) {
            return obj.linefeed;
        }), (0, $c9996135bbccb03d$export$71511d61b312f219)(_obj, "set$context", function(obj, v) {
            return obj.context = v;
        }), (0, $c9996135bbccb03d$export$71511d61b312f219)(_obj, "createRequire$1", function(receiver, p0) {
            return receiver.createRequire(p0);
        }), (0, $c9996135bbccb03d$export$71511d61b312f219)(_obj, "resolve$1", function(receiver, p0) {
            return receiver.resolve(p0);
        }), (0, $c9996135bbccb03d$export$71511d61b312f219)(_obj, "get$$prototype", function(obj) {
            return obj.prototype;
        }), (0, $c9996135bbccb03d$export$71511d61b312f219)(_obj, "get$red", function(obj) {
            return obj.red;
        }), (0, $c9996135bbccb03d$export$71511d61b312f219)(_obj, "get$green", function(obj) {
            return obj.green;
        }), (0, $c9996135bbccb03d$export$71511d61b312f219)(_obj, "get$blue", function(obj) {
            return obj.blue;
        }), (0, $c9996135bbccb03d$export$71511d61b312f219)(_obj, "get$hue", function(obj) {
            return obj.hue;
        }), (0, $c9996135bbccb03d$export$71511d61b312f219)(_obj, "get$saturation", function(obj) {
            return obj.saturation;
        }), (0, $c9996135bbccb03d$export$71511d61b312f219)(_obj, "get$lightness", function(obj) {
            return obj.lightness;
        }), (0, $c9996135bbccb03d$export$71511d61b312f219)(_obj, "get$whiteness", function(obj) {
            return obj.whiteness;
        }), (0, $c9996135bbccb03d$export$71511d61b312f219)(_obj, "get$blackness", function(obj) {
            return obj.blackness;
        }), (0, $c9996135bbccb03d$export$71511d61b312f219)(_obj, "get$alpha", function(obj) {
            return obj.alpha;
        }), (0, $c9996135bbccb03d$export$71511d61b312f219)(_obj, "get$a", function(obj) {
            return obj.a;
        }), (0, $c9996135bbccb03d$export$71511d61b312f219)(_obj, "get$b", function(obj) {
            return obj.b;
        }), (0, $c9996135bbccb03d$export$71511d61b312f219)(_obj, "get$x", function(obj) {
            return obj.x;
        }), (0, $c9996135bbccb03d$export$71511d61b312f219)(_obj, "get$y", function(obj) {
            return obj.y;
        }), (0, $c9996135bbccb03d$export$71511d61b312f219)(_obj, "get$z", function(obj) {
            return obj.z;
        }), (0, $c9996135bbccb03d$export$71511d61b312f219)(_obj, "get$chroma", function(obj) {
            return obj.chroma;
        }), (0, $c9996135bbccb03d$export$71511d61b312f219)(_obj, "get$space", function(obj) {
            return obj.space;
        }), (0, $c9996135bbccb03d$export$71511d61b312f219)(_obj, "get$method", function(obj) {
            return obj.method;
        }), (0, $c9996135bbccb03d$export$71511d61b312f219)(_obj, "get$weight", function(obj) {
            return obj.weight;
        }), (0, $c9996135bbccb03d$export$71511d61b312f219)(_obj, "get$dartValue", function(obj) {
            return obj.dartValue;
        }), (0, $c9996135bbccb03d$export$71511d61b312f219)(_obj, "set$dartValue", function(obj, v) {
            return obj.dartValue = v;
        }), (0, $c9996135bbccb03d$export$71511d61b312f219)(_obj, "get$alertAscii", function(obj) {
            return obj.alertAscii;
        }), (0, $c9996135bbccb03d$export$71511d61b312f219)(_obj, "get$alertColor", function(obj) {
            return obj.alertColor;
        }), (0, $c9996135bbccb03d$export$71511d61b312f219)(_obj, "get$loadPaths", function(obj) {
            return obj.loadPaths;
        }), (0, $c9996135bbccb03d$export$71511d61b312f219)(_obj, "get$quietDeps", function(obj) {
            return obj.quietDeps;
        }), (0, $c9996135bbccb03d$export$71511d61b312f219)(_obj, "get$verbose", function(obj) {
            return obj.verbose;
        }), (0, $c9996135bbccb03d$export$71511d61b312f219)(_obj, "get$charset", function(obj) {
            return obj.charset;
        }), (0, $c9996135bbccb03d$export$71511d61b312f219)(_obj, "get$sourceMap", function(obj) {
            return obj.sourceMap;
        }), (0, $c9996135bbccb03d$export$71511d61b312f219)(_obj, "get$sourceMapIncludeSources", function(obj) {
            return obj.sourceMapIncludeSources;
        }), (0, $c9996135bbccb03d$export$71511d61b312f219)(_obj, "get$logger", function(obj) {
            return obj.logger;
        }), (0, $c9996135bbccb03d$export$71511d61b312f219)(_obj, "get$importers", function(obj) {
            return obj.importers;
        }), (0, $c9996135bbccb03d$export$71511d61b312f219)(_obj, "get$functions", function(obj) {
            return obj.functions;
        }), (0, $c9996135bbccb03d$export$71511d61b312f219)(_obj, "get$fatalDeprecations", function(obj) {
            return obj.fatalDeprecations;
        }), (0, $c9996135bbccb03d$export$71511d61b312f219)(_obj, "get$silenceDeprecations", function(obj) {
            return obj.silenceDeprecations;
        }), (0, $c9996135bbccb03d$export$71511d61b312f219)(_obj, "get$futureDeprecations", function(obj) {
            return obj.futureDeprecations;
        }), (0, $c9996135bbccb03d$export$71511d61b312f219)(_obj, "get$syntax", function(obj) {
            return obj.syntax;
        }), (0, $c9996135bbccb03d$export$71511d61b312f219)(_obj, "get$url", function(obj) {
            return obj.url;
        }), (0, $c9996135bbccb03d$export$71511d61b312f219)(_obj, "get$importer", function(obj) {
            return obj.importer;
        }), (0, $c9996135bbccb03d$export$71511d61b312f219)(_obj, "get$_dartException", function(obj) {
            return obj._dartException;
        }), (0, $c9996135bbccb03d$export$71511d61b312f219)(_obj, "set$renderSync", function(obj, v) {
            return obj.renderSync = v;
        }), (0, $c9996135bbccb03d$export$71511d61b312f219)(_obj, "set$compileString", function(obj, v) {
            return obj.compileString = v;
        }), (0, $c9996135bbccb03d$export$71511d61b312f219)(_obj, "set$compileStringAsync", function(obj, v) {
            return obj.compileStringAsync = v;
        }), (0, $c9996135bbccb03d$export$71511d61b312f219)(_obj, "set$compile", function(obj, v) {
            return obj.compile = v;
        }), (0, $c9996135bbccb03d$export$71511d61b312f219)(_obj, "set$compileAsync", function(obj, v) {
            return obj.compileAsync = v;
        }), (0, $c9996135bbccb03d$export$71511d61b312f219)(_obj, "set$initCompiler", function(obj, v) {
            return obj.initCompiler = v;
        }), (0, $c9996135bbccb03d$export$71511d61b312f219)(_obj, "set$initAsyncCompiler", function(obj, v) {
            return obj.initAsyncCompiler = v;
        }), (0, $c9996135bbccb03d$export$71511d61b312f219)(_obj, "set$Compiler", function(obj, v) {
            return obj.Compiler = v;
        }), (0, $c9996135bbccb03d$export$71511d61b312f219)(_obj, "set$AsyncCompiler", function(obj, v) {
            return obj.AsyncCompiler = v;
        }), (0, $c9996135bbccb03d$export$71511d61b312f219)(_obj, "set$info", function(obj, v) {
            return obj.info = v;
        }), (0, $c9996135bbccb03d$export$71511d61b312f219)(_obj, "set$Exception", function(obj, v) {
            return obj.Exception = v;
        }), (0, $c9996135bbccb03d$export$71511d61b312f219)(_obj, "set$Logger", function(obj, v) {
            return obj.Logger = v;
        }), (0, $c9996135bbccb03d$export$71511d61b312f219)(_obj, "set$NodePackageImporter", function(obj, v) {
            return obj.NodePackageImporter = v;
        }), (0, $c9996135bbccb03d$export$71511d61b312f219)(_obj, "set$deprecations", function(obj, v) {
            return obj.deprecations = v;
        }), (0, $c9996135bbccb03d$export$71511d61b312f219)(_obj, "set$Version", function(obj, v) {
            return obj.Version = v;
        }), (0, $c9996135bbccb03d$export$71511d61b312f219)(_obj, "set$Value", function(obj, v) {
            return obj.Value = v;
        }), (0, $c9996135bbccb03d$export$71511d61b312f219)(_obj, "set$SassArgumentList", function(obj, v) {
            return obj.SassArgumentList = v;
        }), (0, $c9996135bbccb03d$export$71511d61b312f219)(_obj, "set$SassCalculation", function(obj, v) {
            return obj.SassCalculation = v;
        }), (0, $c9996135bbccb03d$export$71511d61b312f219)(_obj, "set$CalculationOperation", function(obj, v) {
            return obj.CalculationOperation = v;
        }), (0, $c9996135bbccb03d$export$71511d61b312f219)(_obj, "set$CalculationInterpolation", function(obj, v) {
            return obj.CalculationInterpolation = v;
        }), (0, $c9996135bbccb03d$export$71511d61b312f219)(_obj, "set$SassBoolean", function(obj, v) {
            return obj.SassBoolean = v;
        }), (0, $c9996135bbccb03d$export$71511d61b312f219)(_obj, "set$SassColor", function(obj, v) {
            return obj.SassColor = v;
        }), (0, $c9996135bbccb03d$export$71511d61b312f219)(_obj, "set$SassFunction", function(obj, v) {
            return obj.SassFunction = v;
        }), (0, $c9996135bbccb03d$export$71511d61b312f219)(_obj, "set$SassMixin", function(obj, v) {
            return obj.SassMixin = v;
        }), (0, $c9996135bbccb03d$export$71511d61b312f219)(_obj, "set$SassList", function(obj, v) {
            return obj.SassList = v;
        }), (0, $c9996135bbccb03d$export$71511d61b312f219)(_obj, "set$SassMap", function(obj, v) {
            return obj.SassMap = v;
        }), (0, $c9996135bbccb03d$export$71511d61b312f219)(_obj, "set$SassNumber", function(obj, v) {
            return obj.SassNumber = v;
        }), (0, $c9996135bbccb03d$export$71511d61b312f219)(_obj, "set$SassString", function(obj, v) {
            return obj.SassString = v;
        }), (0, $c9996135bbccb03d$export$71511d61b312f219)(_obj, "set$sassNull", function(obj, v) {
            return obj.sassNull = v;
        }), (0, $c9996135bbccb03d$export$71511d61b312f219)(_obj, "set$sassTrue", function(obj, v) {
            return obj.sassTrue = v;
        }), (0, $c9996135bbccb03d$export$71511d61b312f219)(_obj, "set$sassFalse", function(obj, v) {
            return obj.sassFalse = v;
        }), (0, $c9996135bbccb03d$export$71511d61b312f219)(_obj, "set$render", function(obj, v) {
            return obj.render = v;
        }), (0, $c9996135bbccb03d$export$71511d61b312f219)(_obj, "set$types", function(obj, v) {
            return obj.types = v;
        }), (0, $c9996135bbccb03d$export$71511d61b312f219)(_obj, "set$NULL", function(obj, v) {
            return obj.NULL = v;
        }), (0, $c9996135bbccb03d$export$71511d61b312f219)(_obj, "set$TRUE", function(obj, v) {
            return obj.TRUE = v;
        }), (0, $c9996135bbccb03d$export$71511d61b312f219)(_obj, "set$FALSE", function(obj, v) {
            return obj.FALSE = v;
        }), (0, $c9996135bbccb03d$export$71511d61b312f219)(_obj, "set$loadParserExports_", function(obj, v) {
            return obj.loadParserExports_ = v;
        }), (0, $c9996135bbccb03d$export$71511d61b312f219)(_obj, "visitBinaryOperationExpression$1", function(receiver, p0) {
            return receiver.visitBinaryOperationExpression(p0);
        }), (0, $c9996135bbccb03d$export$71511d61b312f219)(_obj, "visitBooleanExpression$1", function(receiver, p0) {
            return receiver.visitBooleanExpression(p0);
        }), (0, $c9996135bbccb03d$export$71511d61b312f219)(_obj, "visitColorExpression$1", function(receiver, p0) {
            return receiver.visitColorExpression(p0);
        }), (0, $c9996135bbccb03d$export$71511d61b312f219)(_obj, "visitInterpolatedFunctionExpression$1", function(receiver, p0) {
            return receiver.visitInterpolatedFunctionExpression(p0);
        }), (0, $c9996135bbccb03d$export$71511d61b312f219)(_obj, "visitFunctionExpression$1", function(receiver, p0) {
            return receiver.visitFunctionExpression(p0);
        }), (0, $c9996135bbccb03d$export$71511d61b312f219)(_obj, "visitIfExpression$1", function(receiver, p0) {
            return receiver.visitIfExpression(p0);
        }), (0, $c9996135bbccb03d$export$71511d61b312f219)(_obj, "visitLegacyIfExpression$1", function(receiver, p0) {
            return receiver.visitLegacyIfExpression(p0);
        }), (0, $c9996135bbccb03d$export$71511d61b312f219)(_obj, "visitListExpression$1", function(receiver, p0) {
            return receiver.visitListExpression(p0);
        }), (0, $c9996135bbccb03d$export$71511d61b312f219)(_obj, "visitMapExpression$1", function(receiver, p0) {
            return receiver.visitMapExpression(p0);
        }), (0, $c9996135bbccb03d$export$71511d61b312f219)(_obj, "visitNullExpression$1", function(receiver, p0) {
            return receiver.visitNullExpression(p0);
        }), (0, $c9996135bbccb03d$export$71511d61b312f219)(_obj, "visitNumberExpression$1", function(receiver, p0) {
            return receiver.visitNumberExpression(p0);
        }), (0, $c9996135bbccb03d$export$71511d61b312f219)(_obj, "visitParenthesizedExpression$1", function(receiver, p0) {
            return receiver.visitParenthesizedExpression(p0);
        }), (0, $c9996135bbccb03d$export$71511d61b312f219)(_obj, "visitSelectorExpression$1", function(receiver, p0) {
            return receiver.visitSelectorExpression(p0);
        }), (0, $c9996135bbccb03d$export$71511d61b312f219)(_obj, "visitStringExpression$1", function(receiver, p0) {
            return receiver.visitStringExpression(p0);
        }), (0, $c9996135bbccb03d$export$71511d61b312f219)(_obj, "visitSupportsExpression$1", function(receiver, p0) {
            return receiver.visitSupportsExpression(p0);
        }), (0, $c9996135bbccb03d$export$71511d61b312f219)(_obj, "visitUnaryOperationExpression$1", function(receiver, p0) {
            return receiver.visitUnaryOperationExpression(p0);
        }), (0, $c9996135bbccb03d$export$71511d61b312f219)(_obj, "visitValueExpression$1", function(receiver, p0) {
            return receiver.visitValueExpression(p0);
        }), (0, $c9996135bbccb03d$export$71511d61b312f219)(_obj, "visitVariableExpression$1", function(receiver, p0) {
            return receiver.visitVariableExpression(p0);
        }), (0, $c9996135bbccb03d$export$71511d61b312f219)(_obj, "get$current", function(obj) {
            return obj.current;
        }), (0, $c9996135bbccb03d$export$71511d61b312f219)(_obj, "yield$0", function(receiver) {
            return receiver.yield();
        }), (0, $c9996135bbccb03d$export$71511d61b312f219)(_obj, "run$1$1", function(receiver, p0) {
            return receiver.run(p0);
        }), (0, $c9996135bbccb03d$export$71511d61b312f219)(_obj, "run$1", function(receiver, p0) {
            return receiver.run(p0);
        }), (0, $c9996135bbccb03d$export$71511d61b312f219)(_obj, "run$0", function(receiver) {
            return receiver.run();
        }), (0, $c9996135bbccb03d$export$71511d61b312f219)(_obj, "visitIfConditionParenthesized$1", function(receiver, p0) {
            return receiver.visitIfConditionParenthesized(p0);
        }), (0, $c9996135bbccb03d$export$71511d61b312f219)(_obj, "visitIfConditionNegation$1", function(receiver, p0) {
            return receiver.visitIfConditionNegation(p0);
        }), (0, $c9996135bbccb03d$export$71511d61b312f219)(_obj, "visitIfConditionOperation$1", function(receiver, p0) {
            return receiver.visitIfConditionOperation(p0);
        }), (0, $c9996135bbccb03d$export$71511d61b312f219)(_obj, "visitIfConditionFunction$1", function(receiver, p0) {
            return receiver.visitIfConditionFunction(p0);
        }), (0, $c9996135bbccb03d$export$71511d61b312f219)(_obj, "visitIfConditionSass$1", function(receiver, p0) {
            return receiver.visitIfConditionSass(p0);
        }), (0, $c9996135bbccb03d$export$71511d61b312f219)(_obj, "visitIfConditionRaw$1", function(receiver, p0) {
            return receiver.visitIfConditionRaw(p0);
        }), (0, $c9996135bbccb03d$export$71511d61b312f219)(_obj, "get$canonicalize", function(obj) {
            return obj.canonicalize;
        }), (0, $c9996135bbccb03d$export$71511d61b312f219)(_obj, "canonicalize$1", function(receiver, p0) {
            return receiver.canonicalize(p0);
        }), (0, $c9996135bbccb03d$export$71511d61b312f219)(_obj, "get$load", function(obj) {
            return obj.load;
        }), (0, $c9996135bbccb03d$export$71511d61b312f219)(_obj, "load$1", function(receiver, p0) {
            return receiver.load(p0);
        }), (0, $c9996135bbccb03d$export$71511d61b312f219)(_obj, "get$findFileUrl", function(obj) {
            return obj.findFileUrl;
        }), (0, $c9996135bbccb03d$export$71511d61b312f219)(_obj, "get$nonCanonicalScheme", function(obj) {
            return obj.nonCanonicalScheme;
        }), (0, $c9996135bbccb03d$export$71511d61b312f219)(_obj, "get$sourceMapUrl", function(obj) {
            return obj.sourceMapUrl;
        }), (0, $c9996135bbccb03d$export$71511d61b312f219)(_obj, "get$separator", function(obj) {
            return obj.separator;
        }), (0, $c9996135bbccb03d$export$71511d61b312f219)(_obj, "get$brackets", function(obj) {
            return obj.brackets;
        }), (0, $c9996135bbccb03d$export$71511d61b312f219)(_obj, "get$span", function(obj) {
            return obj.span;
        }), (0, $c9996135bbccb03d$export$71511d61b312f219)(_obj, "span$1", function(receiver, p0) {
            return receiver.span(p0);
        }), (0, $c9996135bbccb03d$export$71511d61b312f219)(_obj, "get$numeratorUnits", function(obj) {
            return obj.numeratorUnits;
        }), (0, $c9996135bbccb03d$export$71511d61b312f219)(_obj, "get$denominatorUnits", function(obj) {
            return obj.denominatorUnits;
        }), (0, $c9996135bbccb03d$export$71511d61b312f219)(_obj, "get$pkgImporter", function(obj) {
            return obj.pkgImporter;
        }), (0, $c9996135bbccb03d$export$71511d61b312f219)(_obj, "get$indentedSyntax", function(obj) {
            return obj.indentedSyntax;
        }), (0, $c9996135bbccb03d$export$71511d61b312f219)(_obj, "get$omitSourceMapUrl", function(obj) {
            return obj.omitSourceMapUrl;
        }), (0, $c9996135bbccb03d$export$71511d61b312f219)(_obj, "get$outFile", function(obj) {
            return obj.outFile;
        }), (0, $c9996135bbccb03d$export$71511d61b312f219)(_obj, "get$outputStyle", function(obj) {
            return obj.outputStyle;
        }), (0, $c9996135bbccb03d$export$71511d61b312f219)(_obj, "get$fiber", function(obj) {
            return obj.fiber;
        }), (0, $c9996135bbccb03d$export$71511d61b312f219)(_obj, "get$sourceMapContents", function(obj) {
            return obj.sourceMapContents;
        }), (0, $c9996135bbccb03d$export$71511d61b312f219)(_obj, "get$sourceMapEmbed", function(obj) {
            return obj.sourceMapEmbed;
        }), (0, $c9996135bbccb03d$export$71511d61b312f219)(_obj, "get$sourceMapRoot", function(obj) {
            return obj.sourceMapRoot;
        }), (0, $c9996135bbccb03d$export$71511d61b312f219)(_obj, "set$cli_pkg_main_0_", function(obj, v) {
            return obj.cli_pkg_main_0_ = v;
        }), (0, $c9996135bbccb03d$export$71511d61b312f219)(_obj, "visitAttributeSelector$1", function(receiver, p0) {
            return receiver.visitAttributeSelector(p0);
        }), (0, $c9996135bbccb03d$export$71511d61b312f219)(_obj, "visitClassSelector$1", function(receiver, p0) {
            return receiver.visitClassSelector(p0);
        }), (0, $c9996135bbccb03d$export$71511d61b312f219)(_obj, "visitIDSelector$1", function(receiver, p0) {
            return receiver.visitIDSelector(p0);
        }), (0, $c9996135bbccb03d$export$71511d61b312f219)(_obj, "visitParentSelector$1", function(receiver, p0) {
            return receiver.visitParentSelector(p0);
        }), (0, $c9996135bbccb03d$export$71511d61b312f219)(_obj, "visitPlaceholderSelector$1", function(receiver, p0) {
            return receiver.visitPlaceholderSelector(p0);
        }), (0, $c9996135bbccb03d$export$71511d61b312f219)(_obj, "visitPseudoSelector$1", function(receiver, p0) {
            return receiver.visitPseudoSelector(p0);
        }), (0, $c9996135bbccb03d$export$71511d61b312f219)(_obj, "visitTypeSelector$1", function(receiver, p0) {
            return receiver.visitTypeSelector(p0);
        }), (0, $c9996135bbccb03d$export$71511d61b312f219)(_obj, "visitUniversalSelector$1", function(receiver, p0) {
            return receiver.visitUniversalSelector(p0);
        }), (0, $c9996135bbccb03d$export$71511d61b312f219)(_obj, "visitAtRootRule$1", function(receiver, p0) {
            return receiver.visitAtRootRule(p0);
        }), (0, $c9996135bbccb03d$export$71511d61b312f219)(_obj, "visitAtRule$1", function(receiver, p0) {
            return receiver.visitAtRule(p0);
        }), (0, $c9996135bbccb03d$export$71511d61b312f219)(_obj, "get$visitContentBlock", function(obj) {
            return obj.visitContentBlock;
        }), (0, $c9996135bbccb03d$export$71511d61b312f219)(_obj, "visitContentBlock$1", function(receiver, p0) {
            return receiver.visitContentBlock(p0);
        }), (0, $c9996135bbccb03d$export$71511d61b312f219)(_obj, "visitContentRule$1", function(receiver, p0) {
            return receiver.visitContentRule(p0);
        }), (0, $c9996135bbccb03d$export$71511d61b312f219)(_obj, "visitDebugRule$1", function(receiver, p0) {
            return receiver.visitDebugRule(p0);
        }), (0, $c9996135bbccb03d$export$71511d61b312f219)(_obj, "visitDeclaration$1", function(receiver, p0) {
            return receiver.visitDeclaration(p0);
        }), (0, $c9996135bbccb03d$export$71511d61b312f219)(_obj, "visitEachRule$1", function(receiver, p0) {
            return receiver.visitEachRule(p0);
        }), (0, $c9996135bbccb03d$export$71511d61b312f219)(_obj, "visitErrorRule$1", function(receiver, p0) {
            return receiver.visitErrorRule(p0);
        }), (0, $c9996135bbccb03d$export$71511d61b312f219)(_obj, "visitExtendRule$1", function(receiver, p0) {
            return receiver.visitExtendRule(p0);
        }), (0, $c9996135bbccb03d$export$71511d61b312f219)(_obj, "visitForRule$1", function(receiver, p0) {
            return receiver.visitForRule(p0);
        }), (0, $c9996135bbccb03d$export$71511d61b312f219)(_obj, "visitForwardRule$1", function(receiver, p0) {
            return receiver.visitForwardRule(p0);
        }), (0, $c9996135bbccb03d$export$71511d61b312f219)(_obj, "visitFunctionRule$1", function(receiver, p0) {
            return receiver.visitFunctionRule(p0);
        }), (0, $c9996135bbccb03d$export$71511d61b312f219)(_obj, "visitIfRule$1", function(receiver, p0) {
            return receiver.visitIfRule(p0);
        }), (0, $c9996135bbccb03d$export$71511d61b312f219)(_obj, "visitImportRule$1", function(receiver, p0) {
            return receiver.visitImportRule(p0);
        }), (0, $c9996135bbccb03d$export$71511d61b312f219)(_obj, "visitIncludeRule$1", function(receiver, p0) {
            return receiver.visitIncludeRule(p0);
        }), (0, $c9996135bbccb03d$export$71511d61b312f219)(_obj, "visitLoudComment$1", function(receiver, p0) {
            return receiver.visitLoudComment(p0);
        }), (0, $c9996135bbccb03d$export$71511d61b312f219)(_obj, "visitMediaRule$1", function(receiver, p0) {
            return receiver.visitMediaRule(p0);
        }), (0, $c9996135bbccb03d$export$71511d61b312f219)(_obj, "visitMixinRule$1", function(receiver, p0) {
            return receiver.visitMixinRule(p0);
        }), (0, $c9996135bbccb03d$export$71511d61b312f219)(_obj, "visitReturnRule$1", function(receiver, p0) {
            return receiver.visitReturnRule(p0);
        }), (0, $c9996135bbccb03d$export$71511d61b312f219)(_obj, "visitSilentComment$1", function(receiver, p0) {
            return receiver.visitSilentComment(p0);
        }), (0, $c9996135bbccb03d$export$71511d61b312f219)(_obj, "visitStyleRule$1", function(receiver, p0) {
            return receiver.visitStyleRule(p0);
        }), (0, $c9996135bbccb03d$export$71511d61b312f219)(_obj, "visitStylesheet$1", function(receiver, p0) {
            return receiver.visitStylesheet(p0);
        }), (0, $c9996135bbccb03d$export$71511d61b312f219)(_obj, "visitSupportsRule$1", function(receiver, p0) {
            return receiver.visitSupportsRule(p0);
        }), (0, $c9996135bbccb03d$export$71511d61b312f219)(_obj, "visitUseRule$1", function(receiver, p0) {
            return receiver.visitUseRule(p0);
        }), (0, $c9996135bbccb03d$export$71511d61b312f219)(_obj, "visitVariableDeclaration$1", function(receiver, p0) {
            return receiver.visitVariableDeclaration(p0);
        }), (0, $c9996135bbccb03d$export$71511d61b312f219)(_obj, "visitWarnRule$1", function(receiver, p0) {
            return receiver.visitWarnRule(p0);
        }), (0, $c9996135bbccb03d$export$71511d61b312f219)(_obj, "visitWhileRule$1", function(receiver, p0) {
            return receiver.visitWhileRule(p0);
        }), (0, $c9996135bbccb03d$export$71511d61b312f219)(_obj, "get$quotes", function(obj) {
            return obj.quotes;
        }), _obj);
        J.PlainJavaScriptObject.prototype = {};
        J.UnknownJavaScriptObject.prototype = {};
        J.JavaScriptFunction.prototype = {
            toString$0: function(receiver) {
                var dartClosure = receiver[$.$get$DART_CLOSURE_PROPERTY_NAME()];
                if (dartClosure == null) dartClosure = receiver[$.$get$DART_CLOSURE_DART_JSINTEROP_PROPERTY_NAME()];
                if (dartClosure == null) return this.super$LegacyJavaScriptObject$toString(receiver);
                return "JavaScript function for " + A.S(J.toString$0$(dartClosure));
            },
            $isFunction: 1
        };
        J.JavaScriptBigInt.prototype = {
            get$hashCode: function(receiver) {
                return 0;
            },
            toString$0: function(receiver) {
                return String(receiver);
            }
        };
        J.JavaScriptSymbol.prototype = {
            get$hashCode: function(receiver) {
                return 0;
            },
            toString$0: function(receiver) {
                return String(receiver);
            }
        };
        J.JSArray.prototype = {
            cast$1$0: function(receiver, $R) {
                return new A.CastList(receiver, A._arrayInstanceType(receiver)._eval$1("@<1>")._bind$1($R)._eval$1("CastList<1,2>"));
            },
            add$1: function(receiver, value) {
                receiver.$flags & 1 && A.throwUnsupportedOperation(receiver, 29);
                receiver.push(value);
            },
            removeAt$1: function(receiver, index) {
                var t1;
                receiver.$flags & 1 && A.throwUnsupportedOperation(receiver, "removeAt", 1);
                t1 = receiver.length;
                if (index >= t1) throw A.wrapException(A.RangeError$value(index, null, null));
                return receiver.splice(index, 1)[0];
            },
            insert$2: function(receiver, index, value) {
                var t1;
                receiver.$flags & 1 && A.throwUnsupportedOperation(receiver, "insert", 2);
                t1 = receiver.length;
                if (index > t1) throw A.wrapException(A.RangeError$value(index, null, null));
                receiver.splice(index, 0, value);
            },
            insertAll$2: function(receiver, index, iterable) {
                var insertionLength, end;
                receiver.$flags & 1 && A.throwUnsupportedOperation(receiver, "insertAll", 2);
                A.RangeError_checkValueInInterval(index, 0, receiver.length, "index");
                if (!type$.EfficientLengthIterable_dynamic._is(iterable)) iterable = J.toList$0$ax(iterable);
                insertionLength = J.get$length$asx(iterable);
                receiver.length = receiver.length + insertionLength;
                end = index + insertionLength;
                this.setRange$4(receiver, end, receiver.length, receiver, index);
                this.setRange$3(receiver, index, end, iterable);
            },
            removeLast$0: function(receiver) {
                receiver.$flags & 1 && A.throwUnsupportedOperation(receiver, "removeLast", 1);
                if (receiver.length === 0) throw A.wrapException(A.diagnoseIndexError(receiver, -1));
                return receiver.pop();
            },
            _removeWhere$2: function(receiver, test, removeMatching) {
                var i, element, t1, retained = [], end = receiver.length;
                for(i = 0; i < end; ++i){
                    element = receiver[i];
                    if (!test.call$1(element)) retained.push(element);
                    if (receiver.length !== end) throw A.wrapException(A.ConcurrentModificationError$(receiver));
                }
                t1 = retained.length;
                if (t1 === end) return;
                this.set$length(receiver, t1);
                for(i = 0; i < retained.length; ++i)receiver[i] = retained[i];
            },
            where$1: function(receiver, f) {
                return new A.WhereIterable(receiver, f, A._arrayInstanceType(receiver)._eval$1("WhereIterable<1>"));
            },
            expand$1$1: function(receiver, f, $T) {
                return new A.ExpandIterable(receiver, f, A._arrayInstanceType(receiver)._eval$1("@<1>")._bind$1($T)._eval$1("ExpandIterable<1,2>"));
            },
            addAll$1: function(receiver, collection) {
                var t1;
                receiver.$flags & 1 && A.throwUnsupportedOperation(receiver, "addAll", 2);
                if (Array.isArray(collection)) {
                    this._addAllFromArray$1(receiver, collection);
                    return;
                }
                for(t1 = J.get$iterator$ax(collection); t1.moveNext$0();)receiver.push(t1.get$current(t1));
            },
            _addAllFromArray$1: function(receiver, array) {
                var i, len = array.length;
                if (len === 0) return;
                if (receiver === array) throw A.wrapException(A.ConcurrentModificationError$(receiver));
                for(i = 0; i < len; ++i)receiver.push(array[i]);
            },
            clear$0: function(receiver) {
                receiver.$flags & 1 && A.throwUnsupportedOperation(receiver, "clear", "clear");
                receiver.length = 0;
            },
            forEach$1: function(receiver, f) {
                var i, end = receiver.length;
                for(i = 0; i < end; ++i){
                    f.call$1(receiver[i]);
                    if (receiver.length !== end) throw A.wrapException(A.ConcurrentModificationError$(receiver));
                }
            },
            map$1$1: function(receiver, f, $T) {
                return new A.MappedListIterable(receiver, f, A._arrayInstanceType(receiver)._eval$1("@<1>")._bind$1($T)._eval$1("MappedListIterable<1,2>"));
            },
            join$1: function(receiver, separator) {
                var i, list = A.List_List$filled(receiver.length, "", false, type$.String);
                for(i = 0; i < receiver.length; ++i)list[i] = A.S(receiver[i]);
                return list.join(separator);
            },
            join$0: function(receiver) {
                return this.join$1(receiver, "");
            },
            take$1: function(receiver, n) {
                return A.SubListIterable$(receiver, 0, A.checkNotNullable(n, "count", type$.int), A._arrayInstanceType(receiver)._precomputed1);
            },
            skip$1: function(receiver, n) {
                return A.SubListIterable$(receiver, n, null, A._arrayInstanceType(receiver)._precomputed1);
            },
            fold$1$2: function(receiver, initialValue, combine) {
                var value, i, $length = receiver.length;
                for(value = initialValue, i = 0; i < $length; ++i){
                    value = combine.call$2(value, receiver[i]);
                    if (receiver.length !== $length) throw A.wrapException(A.ConcurrentModificationError$(receiver));
                }
                return value;
            },
            fold$2: function(receiver, initialValue, combine) {
                return this.fold$1$2(receiver, initialValue, combine, type$.dynamic);
            },
            firstWhere$1: function(receiver, test) {
                var i, element, end = receiver.length;
                for(i = 0; i < end; ++i){
                    element = receiver[i];
                    if (test.call$1(element)) return element;
                    if (receiver.length !== end) throw A.wrapException(A.ConcurrentModificationError$(receiver));
                }
                throw A.wrapException(A.IterableElementError_noElement());
            },
            elementAt$1: function(receiver, index) {
                return receiver[index];
            },
            sublist$2: function(receiver, start, end) {
                var end0 = receiver.length;
                if (start > end0) throw A.wrapException(A.RangeError$range(start, 0, end0, "start", null));
                if (end == null) end = end0;
                else if (end < start || end > end0) throw A.wrapException(A.RangeError$range(end, start, end0, "end", null));
                if (start === end) return A._setArrayType([], A._arrayInstanceType(receiver));
                return A._setArrayType(receiver.slice(start, end), A._arrayInstanceType(receiver));
            },
            sublist$1: function(receiver, start) {
                return this.sublist$2(receiver, start, null);
            },
            getRange$2: function(receiver, start, end) {
                A.RangeError_checkValidRange(start, end, receiver.length);
                return A.SubListIterable$(receiver, start, end, A._arrayInstanceType(receiver)._precomputed1);
            },
            get$first: function(receiver) {
                if (receiver.length > 0) return receiver[0];
                throw A.wrapException(A.IterableElementError_noElement());
            },
            get$last: function(receiver) {
                var t1 = receiver.length;
                if (t1 > 0) return receiver[t1 - 1];
                throw A.wrapException(A.IterableElementError_noElement());
            },
            get$single: function(receiver) {
                var t1 = receiver.length;
                if (t1 === 1) return receiver[0];
                if (t1 === 0) throw A.wrapException(A.IterableElementError_noElement());
                throw A.wrapException(A.IterableElementError_tooMany());
            },
            removeRange$2: function(receiver, start, end) {
                receiver.$flags & 1 && A.throwUnsupportedOperation(receiver, 18);
                A.RangeError_checkValidRange(start, end, receiver.length);
                receiver.splice(start, end - start);
            },
            setRange$4: function(receiver, start, end, iterable, skipCount) {
                var $length, otherList, otherStart, t1, i;
                receiver.$flags & 2 && A.throwUnsupportedOperation(receiver, 5);
                A.RangeError_checkValidRange(start, end, receiver.length);
                $length = end - start;
                if ($length === 0) return;
                A.RangeError_checkNotNegative(skipCount, "skipCount");
                if (type$.List_dynamic._is(iterable)) {
                    otherList = iterable;
                    otherStart = skipCount;
                } else {
                    otherList = J.skip$1$ax(iterable, skipCount).toList$1$growable(0, false);
                    otherStart = 0;
                }
                t1 = J.getInterceptor$asx(otherList);
                if (otherStart + $length > t1.get$length(otherList)) throw A.wrapException(A.IterableElementError_tooFew());
                if (otherStart < start) for(i = $length - 1; i >= 0; --i)receiver[start + i] = t1.$index(otherList, otherStart + i);
                else for(i = 0; i < $length; ++i)receiver[start + i] = t1.$index(otherList, otherStart + i);
            },
            setRange$3: function(receiver, start, end, iterable) {
                return this.setRange$4(receiver, start, end, iterable, 0);
            },
            fillRange$3: function(receiver, start, end, fillValue) {
                var i;
                receiver.$flags & 2 && A.throwUnsupportedOperation(receiver, "fillRange");
                A.RangeError_checkValidRange(start, end, receiver.length);
                A._arrayInstanceType(receiver)._precomputed1._as(fillValue);
                for(i = start; i < end; ++i)receiver[i] = fillValue;
            },
            any$1: function(receiver, test) {
                var i, end = receiver.length;
                for(i = 0; i < end; ++i){
                    if (test.call$1(receiver[i])) return true;
                    if (receiver.length !== end) throw A.wrapException(A.ConcurrentModificationError$(receiver));
                }
                return false;
            },
            every$1: function(receiver, test) {
                var i, end = receiver.length;
                for(i = 0; i < end; ++i){
                    if (!test.call$1(receiver[i])) return false;
                    if (receiver.length !== end) throw A.wrapException(A.ConcurrentModificationError$(receiver));
                }
                return true;
            },
            get$reversed: function(receiver) {
                return new A.ReversedListIterable(receiver, A._arrayInstanceType(receiver)._eval$1("ReversedListIterable<1>"));
            },
            sort$1: function(receiver, compare) {
                var len, a, b, undefineds, i;
                receiver.$flags & 2 && A.throwUnsupportedOperation(receiver, "sort");
                len = receiver.length;
                if (len < 2) return;
                if (compare == null) compare = J._interceptors_JSArray__compareAny$closure();
                if (len === 2) {
                    a = receiver[0];
                    b = receiver[1];
                    if (compare.call$2(a, b) > 0) {
                        receiver[0] = b;
                        receiver[1] = a;
                    }
                    return;
                }
                undefineds = 0;
                if (A._arrayInstanceType(receiver)._precomputed1._is(null)) {
                    for(i = 0; i < receiver.length; ++i)if (receiver[i] === void 0) {
                        receiver[i] = null;
                        ++undefineds;
                    }
                }
                receiver.sort(A.convertDartClosureToJS(compare, 2));
                if (undefineds > 0) this._replaceSomeNullsWithUndefined$1(receiver, undefineds);
            },
            sort$0: function(receiver) {
                return this.sort$1(receiver, null);
            },
            _replaceSomeNullsWithUndefined$1: function(receiver, count) {
                var i0, i = receiver.length;
                for(; i0 = i - 1, i > 0; i = i0)if (receiver[i0] === null) {
                    receiver[i0] = void 0;
                    --count;
                    if (count === 0) break;
                }
            },
            indexOf$1: function(receiver, element) {
                var i, $length = receiver.length;
                if (0 >= $length) return -1;
                for(i = 0; i < $length; ++i)if (J.$eq$(receiver[i], element)) return i;
                return -1;
            },
            contains$1: function(receiver, other) {
                var i;
                for(i = 0; i < receiver.length; ++i)if (J.$eq$(receiver[i], other)) return true;
                return false;
            },
            get$isEmpty: function(receiver) {
                return receiver.length === 0;
            },
            get$isNotEmpty: function(receiver) {
                return receiver.length !== 0;
            },
            toString$0: function(receiver) {
                return A.Iterable_iterableToFullString(receiver, "[", "]");
            },
            toList$1$growable: function(receiver, growable) {
                var t1 = A._setArrayType(receiver.slice(0), A._arrayInstanceType(receiver));
                return t1;
            },
            toList$0: function(receiver) {
                return this.toList$1$growable(receiver, true);
            },
            toSet$0: function(receiver) {
                return A.LinkedHashSet_LinkedHashSet$from(receiver, A._arrayInstanceType(receiver)._precomputed1);
            },
            get$iterator: function(receiver) {
                return new J.ArrayIterator(receiver, receiver.length, A._arrayInstanceType(receiver)._eval$1("ArrayIterator<1>"));
            },
            get$hashCode: function(receiver) {
                return A.Primitives_objectHashCode(receiver);
            },
            get$length: function(receiver) {
                return receiver.length;
            },
            set$length: function(receiver, newLength) {
                receiver.$flags & 1 && A.throwUnsupportedOperation(receiver, "set length", "change the length of");
                if (newLength < 0) throw A.wrapException(A.RangeError$range(newLength, 0, null, "newLength", null));
                if (newLength > receiver.length) A._arrayInstanceType(receiver)._precomputed1._as(null);
                receiver.length = newLength;
            },
            $index: function(receiver, index) {
                if (!(index >= 0 && index < receiver.length)) throw A.wrapException(A.diagnoseIndexError(receiver, index));
                return receiver[index];
            },
            $indexSet: function(receiver, index, value) {
                receiver.$flags & 2 && A.throwUnsupportedOperation(receiver);
                if (!(index >= 0 && index < receiver.length)) throw A.wrapException(A.diagnoseIndexError(receiver, index));
                receiver[index] = value;
            },
            $add: function(receiver, other) {
                var t1 = A.List_List$_of(receiver, A._arrayInstanceType(receiver)._precomputed1);
                this.addAll$1(t1, other);
                return t1;
            },
            indexWhere$1: function(receiver, test) {
                var i;
                if (0 >= receiver.length) return -1;
                for(i = 0; i < receiver.length; ++i)if (test.call$1(receiver[i])) return i;
                return -1;
            },
            $isEfficientLengthIterable: 1,
            $isIterable: 1,
            $isList: 1
        };
        J.JSArraySafeToStringHook.prototype = {
            tryFormat$1: function(array) {
                var flags, info, base;
                if (!Array.isArray(array)) return null;
                flags = array.$flags | 0;
                if ((flags & 4) !== 0) info = "const, ";
                else if ((flags & 2) !== 0) info = "unmodifiable, ";
                else info = (flags & 1) !== 0 ? "fixed, " : "";
                base = "Instance of '" + A.Primitives_objectTypeName(array) + "'";
                if (info === "") return base;
                return base + " (" + info + "length: " + array.length + ")";
            }
        };
        J.JSUnmodifiableArray.prototype = {};
        J.ArrayIterator.prototype = {
            get$current: function(_) {
                var t1 = this._current;
                return t1 == null ? this.$ti._precomputed1._as(t1) : t1;
            },
            moveNext$0: function() {
                var t2, _this = this, t1 = _this._iterable, $length = t1.length;
                if (_this._length !== $length) throw A.wrapException(A.throwConcurrentModificationError(t1));
                t2 = _this._index;
                if (t2 >= $length) {
                    _this._current = null;
                    return false;
                }
                _this._current = t1[t2];
                _this._index = t2 + 1;
                return true;
            }
        };
        J.JSNumber.prototype = {
            compareTo$1: function(receiver, b) {
                var bIsNegative;
                if (receiver < b) return -1;
                else if (receiver > b) return 1;
                else if (receiver === b) {
                    if (receiver === 0) {
                        bIsNegative = this.get$isNegative(b);
                        if (this.get$isNegative(receiver) === bIsNegative) return 0;
                        if (this.get$isNegative(receiver)) return -1;
                        return 1;
                    }
                    return 0;
                } else if (isNaN(receiver)) {
                    if (isNaN(b)) return 0;
                    return 1;
                } else return -1;
            },
            get$isNegative: function(receiver) {
                return receiver === 0 ? 1 / receiver < 0 : receiver < 0;
            },
            get$sign: function(receiver) {
                var t1;
                if (receiver > 0) t1 = 1;
                else t1 = receiver < 0 ? -1 : receiver;
                return t1;
            },
            ceil$0: function(receiver) {
                var truncated, d;
                if (receiver >= 0) {
                    if (receiver <= 2147483647) {
                        truncated = receiver | 0;
                        return receiver === truncated ? truncated : truncated + 1;
                    }
                } else if (receiver >= -2147483648) return receiver | 0;
                d = Math.ceil(receiver);
                if (isFinite(d)) return d;
                throw A.wrapException(A.UnsupportedError$("" + receiver + ".ceil()"));
            },
            floor$0: function(receiver) {
                var truncated, d;
                if (receiver >= 0) {
                    if (receiver <= 2147483647) return receiver | 0;
                } else if (receiver >= -2147483648) {
                    truncated = receiver | 0;
                    return receiver === truncated ? truncated : truncated - 1;
                }
                d = Math.floor(receiver);
                if (isFinite(d)) return d;
                throw A.wrapException(A.UnsupportedError$("" + receiver + ".floor()"));
            },
            round$0: function(receiver) {
                if (receiver > 0) {
                    if (receiver !== 1 / 0) return Math.round(receiver);
                } else if (receiver > -1 / 0) return 0 - Math.round(0 - receiver);
                throw A.wrapException(A.UnsupportedError$("" + receiver + ".round()"));
            },
            clamp$2: function(receiver, lowerLimit, upperLimit) {
                if (this.compareTo$1(lowerLimit, upperLimit) > 0) throw A.wrapException(A.argumentErrorValue(lowerLimit));
                if (this.compareTo$1(receiver, lowerLimit) < 0) return lowerLimit;
                if (this.compareTo$1(receiver, upperLimit) > 0) return upperLimit;
                return receiver;
            },
            toRadixString$1: function(receiver, radix) {
                var result, match, exponent, t1;
                if (radix < 2 || radix > 36) throw A.wrapException(A.RangeError$range(radix, 2, 36, "radix", null));
                result = receiver.toString(radix);
                if (result.charCodeAt(result.length - 1) !== 41) return result;
                match = /^([\da-z]+)(?:\.([\da-z]+))?\(e\+(\d+)\)$/.exec(result);
                if (match == null) A.throwExpression(A.UnsupportedError$("Unexpected toString result: " + result));
                result = match[1];
                exponent = +match[3];
                t1 = match[2];
                if (t1 != null) {
                    result += t1;
                    exponent -= t1.length;
                }
                return result + B.JSString_methods.$mul("0", exponent);
            },
            toString$0: function(receiver) {
                if (receiver === 0 && 1 / receiver < 0) return "-0.0";
                else return "" + receiver;
            },
            get$hashCode: function(receiver) {
                var absolute, floorLog2, factor, scaled, intValue = receiver | 0;
                if (receiver === intValue) return intValue & 536870911;
                absolute = Math.abs(receiver);
                floorLog2 = Math.log(absolute) / 0.6931471805599453 | 0;
                factor = Math.pow(2, floorLog2);
                scaled = absolute < 1 ? absolute / factor : factor / absolute;
                return ((scaled * 9007199254740992 | 0) + (scaled * 3542243181176521 | 0)) * 599197 + floorLog2 * 1259 & 536870911;
            },
            $mod: function(receiver, other) {
                var result = receiver % other;
                if (result === 0) return 0;
                if (result > 0) return result;
                if (other < 0) return result - other;
                else return result + other;
            },
            $tdiv: function(receiver, other) {
                if ((receiver | 0) === receiver) {
                    if (other >= 1 || other < -1) return receiver / other | 0;
                }
                return this._tdivSlow$1(receiver, other);
            },
            _tdivFast$1: function(receiver, other) {
                return (receiver | 0) === receiver ? receiver / other | 0 : this._tdivSlow$1(receiver, other);
            },
            _tdivSlow$1: function(receiver, other) {
                var quotient = receiver / other;
                if (quotient >= -2147483648 && quotient <= 2147483647) return quotient | 0;
                if (quotient > 0) {
                    if (quotient !== 1 / 0) return Math.floor(quotient);
                } else if (quotient > -1 / 0) return Math.ceil(quotient);
                throw A.wrapException(A.UnsupportedError$("Result of truncating division is " + A.S(quotient) + ": " + A.S(receiver) + " ~/ " + other));
            },
            _shrOtherPositive$1: function(receiver, other) {
                var t1;
                if (receiver > 0) t1 = this._shrBothPositive$1(receiver, other);
                else {
                    t1 = other > 31 ? 31 : other;
                    t1 = receiver >> t1 >>> 0;
                }
                return t1;
            },
            _shrReceiverPositive$1: function(receiver, other) {
                if (0 > other) throw A.wrapException(A.argumentErrorValue(other));
                return this._shrBothPositive$1(receiver, other);
            },
            _shrBothPositive$1: function(receiver, other) {
                return other > 31 ? 0 : receiver >>> other;
            },
            get$runtimeType: function(receiver) {
                return A.createRuntimeType(type$.num);
            },
            $isComparable: 1,
            $isdouble: 1,
            $isnum: 1
        };
        J.JSInt.prototype = {
            get$sign: function(receiver) {
                var t1;
                if (receiver > 0) t1 = 1;
                else t1 = receiver < 0 ? -1 : receiver;
                return t1;
            },
            get$runtimeType: function(receiver) {
                return A.createRuntimeType(type$.int);
            },
            $isTrustedGetRuntimeType: 1,
            $isint: 1
        };
        J.JSNumNotInt.prototype = {
            get$runtimeType: function(receiver) {
                return A.createRuntimeType(type$.double);
            },
            $isTrustedGetRuntimeType: 1
        };
        J.JSString.prototype = {
            codeUnitAt$1: function(receiver, index) {
                if (index < 0) throw A.wrapException(A.diagnoseIndexError(receiver, index));
                if (index >= receiver.length) A.throwExpression(A.diagnoseIndexError(receiver, index));
                return receiver.charCodeAt(index);
            },
            allMatches$2: function(receiver, string, start) {
                var t1 = string.length;
                if (start > t1) throw A.wrapException(A.RangeError$range(start, 0, t1, null, null));
                return new A._StringAllMatchesIterable(string, receiver, start);
            },
            allMatches$1: function(receiver, string) {
                return this.allMatches$2(receiver, string, 0);
            },
            matchAsPrefix$2: function(receiver, string, start) {
                var t1, i, _null = null;
                if (start < 0 || start > string.length) throw A.wrapException(A.RangeError$range(start, 0, string.length, _null, _null));
                t1 = receiver.length;
                if (start + t1 > string.length) return _null;
                for(i = 0; i < t1; ++i)if (string.charCodeAt(start + i) !== receiver.charCodeAt(i)) return _null;
                return new A.StringMatch(start, receiver);
            },
            $add: function(receiver, other) {
                return receiver + other;
            },
            endsWith$1: function(receiver, other) {
                var otherLength = other.length, t1 = receiver.length;
                if (otherLength > t1) return false;
                return other === this.substring$1(receiver, t1 - otherLength);
            },
            replaceFirst$2: function(receiver, from, to) {
                A.RangeError_checkValueInInterval(0, 0, receiver.length, "startIndex");
                return A.stringReplaceFirstUnchecked(receiver, from, to, 0);
            },
            split$1: function(receiver, pattern) {
                var t1;
                if (typeof pattern == "string") return A._setArrayType(receiver.split(pattern), type$.JSArray_String);
                else {
                    if (pattern instanceof A.JSSyntaxRegExp) {
                        t1 = pattern._hasCapturesCache;
                        t1 = !(t1 == null ? pattern._hasCapturesCache = pattern._computeHasCaptures$0() : t1);
                    } else t1 = false;
                    if (t1) return A._setArrayType(receiver.split(pattern._nativeRegExp), type$.JSArray_String);
                    else return this._defaultSplit$1(receiver, pattern);
                }
            },
            replaceRange$3: function(receiver, start, end, replacement) {
                var e = A.RangeError_checkValidRange(start, end, receiver.length);
                return A.stringReplaceRangeUnchecked(receiver, start, e, replacement);
            },
            _defaultSplit$1: function(receiver, pattern) {
                var t1, start, $length, match, matchStart, matchEnd, result = A._setArrayType([], type$.JSArray_String);
                for(t1 = J.allMatches$1$s(pattern, receiver), t1 = t1.get$iterator(t1), start = 0, $length = 1; t1.moveNext$0();){
                    match = t1.get$current(t1);
                    matchStart = match.get$start(match);
                    matchEnd = match.get$end(match);
                    $length = matchEnd - matchStart;
                    if ($length === 0 && start === matchStart) continue;
                    result.push(this.substring$2(receiver, start, matchStart));
                    start = matchEnd;
                }
                if (start < receiver.length || $length > 0) result.push(this.substring$1(receiver, start));
                return result;
            },
            startsWith$2: function(receiver, pattern, index) {
                var endIndex;
                if (index < 0 || index > receiver.length) throw A.wrapException(A.RangeError$range(index, 0, receiver.length, null, null));
                if (typeof pattern == "string") {
                    endIndex = index + pattern.length;
                    if (endIndex > receiver.length) return false;
                    return pattern === receiver.substring(index, endIndex);
                }
                return J.matchAsPrefix$2$s(pattern, receiver, index) != null;
            },
            startsWith$1: function(receiver, pattern) {
                return this.startsWith$2(receiver, pattern, 0);
            },
            substring$2: function(receiver, start, end) {
                return receiver.substring(start, A.RangeError_checkValidRange(start, end, receiver.length));
            },
            substring$1: function(receiver, start) {
                return this.substring$2(receiver, start, null);
            },
            trim$0: function(receiver) {
                var startIndex, t1, endIndex0, result = receiver.trim(), endIndex = result.length;
                if (endIndex === 0) return result;
                if (result.charCodeAt(0) === 133) {
                    startIndex = J.JSString__skipLeadingWhitespace(result, 1);
                    if (startIndex === endIndex) return "";
                } else startIndex = 0;
                t1 = endIndex - 1;
                endIndex0 = result.charCodeAt(t1) === 133 ? J.JSString__skipTrailingWhitespace(result, t1) : endIndex;
                if (startIndex === 0 && endIndex0 === endIndex) return result;
                return result.substring(startIndex, endIndex0);
            },
            trimLeft$0: function(receiver) {
                var result = receiver.trimStart();
                if (result.length === 0) return result;
                if (result.charCodeAt(0) !== 133) return result;
                return result.substring(J.JSString__skipLeadingWhitespace(result, 1));
            },
            trimRight$0: function(receiver) {
                var t1, result = receiver.trimEnd(), endIndex = result.length;
                if (endIndex === 0) return result;
                t1 = endIndex - 1;
                if (result.charCodeAt(t1) !== 133) return result;
                return result.substring(0, J.JSString__skipTrailingWhitespace(result, t1));
            },
            $mul: function(receiver, times) {
                var s, result;
                if (0 >= times) return "";
                if (times === 1 || receiver.length === 0) return receiver;
                if (times !== times >>> 0) throw A.wrapException(B.C_OutOfMemoryError);
                for(s = receiver, result = "";;){
                    if ((times & 1) === 1) result = s + result;
                    times = times >>> 1;
                    if (times === 0) break;
                    s += s;
                }
                return result;
            },
            padLeft$2: function(receiver, width, padding) {
                var delta = width - receiver.length;
                if (delta <= 0) return receiver;
                return this.$mul(padding, delta) + receiver;
            },
            padRight$1: function(receiver, width) {
                var delta = width - receiver.length;
                if (delta <= 0) return receiver;
                return receiver + this.$mul(" ", delta);
            },
            indexOf$2: function(receiver, pattern, start) {
                var t1;
                if (start < 0 || start > receiver.length) throw A.wrapException(A.RangeError$range(start, 0, receiver.length, null, null));
                t1 = receiver.indexOf(pattern, start);
                return t1;
            },
            indexOf$1: function(receiver, pattern) {
                return this.indexOf$2(receiver, pattern, 0);
            },
            lastIndexOf$2: function(receiver, pattern, start) {
                var t1, t2, i;
                if (start == null) start = receiver.length;
                else if (start < 0 || start > receiver.length) throw A.wrapException(A.RangeError$range(start, 0, receiver.length, null, null));
                if (typeof pattern == "string") {
                    t1 = pattern.length;
                    t2 = receiver.length;
                    if (start + t1 > t2) start = t2 - t1;
                    return receiver.lastIndexOf(pattern, start);
                }
                for(t1 = J.getInterceptor$s(pattern), i = start; i >= 0; --i)if (t1.matchAsPrefix$2(pattern, receiver, i) != null) return i;
                return -1;
            },
            lastIndexOf$1: function(receiver, pattern) {
                return this.lastIndexOf$2(receiver, pattern, null);
            },
            contains$2: function(receiver, other, startIndex) {
                var t1 = receiver.length;
                if (startIndex > t1) throw A.wrapException(A.RangeError$range(startIndex, 0, t1, null, null));
                return A.stringContainsUnchecked(receiver, other, startIndex);
            },
            contains$1: function(receiver, other) {
                return this.contains$2(receiver, other, 0);
            },
            compareTo$1: function(receiver, other) {
                var t1;
                if (receiver === other) t1 = 0;
                else t1 = receiver < other ? -1 : 1;
                return t1;
            },
            toString$0: function(receiver) {
                return receiver;
            },
            get$hashCode: function(receiver) {
                var t1, hash, i;
                for(t1 = receiver.length, hash = 0, i = 0; i < t1; ++i){
                    hash = hash + receiver.charCodeAt(i) & 536870911;
                    hash = hash + ((hash & 524287) << 10) & 536870911;
                    hash ^= hash >> 6;
                }
                hash = hash + ((hash & 67108863) << 3) & 536870911;
                hash ^= hash >> 11;
                return hash + ((hash & 16383) << 15) & 536870911;
            },
            get$runtimeType: function(receiver) {
                return A.createRuntimeType(type$.String);
            },
            get$length: function(receiver) {
                return receiver.length;
            },
            $isTrustedGetRuntimeType: 1,
            $isComparable: 1,
            $isString: 1
        };
        A._CastIterableBase.prototype = {
            get$iterator: function(_) {
                return new A.CastIterator(J.get$iterator$ax(this.get$_source()), A._instanceType(this)._eval$1("CastIterator<1,2>"));
            },
            get$length: function(_) {
                return J.get$length$asx(this.get$_source());
            },
            get$isEmpty: function(_) {
                return J.get$isEmpty$asx(this.get$_source());
            },
            get$isNotEmpty: function(_) {
                return J.get$isNotEmpty$asx(this.get$_source());
            },
            skip$1: function(_, count) {
                var t1 = A._instanceType(this);
                return A.CastIterable_CastIterable(J.skip$1$ax(this.get$_source(), count), t1._precomputed1, t1._rest[1]);
            },
            take$1: function(_, count) {
                var t1 = A._instanceType(this);
                return A.CastIterable_CastIterable(J.take$1$ax(this.get$_source(), count), t1._precomputed1, t1._rest[1]);
            },
            elementAt$1: function(_, index) {
                return A._instanceType(this)._rest[1]._as(J.elementAt$1$ax(this.get$_source(), index));
            },
            get$first: function(_) {
                return A._instanceType(this)._rest[1]._as(J.get$first$ax(this.get$_source()));
            },
            get$last: function(_) {
                return A._instanceType(this)._rest[1]._as(J.get$last$ax(this.get$_source()));
            },
            get$single: function(_) {
                return A._instanceType(this)._rest[1]._as(J.get$single$ax(this.get$_source()));
            },
            contains$1: function(_, other) {
                return J.contains$1$asx(this.get$_source(), other);
            },
            toString$0: function(_) {
                return J.toString$0$(this.get$_source());
            }
        };
        A.CastIterator.prototype = {
            moveNext$0: function() {
                return this._source.moveNext$0();
            },
            get$current: function(_) {
                var t1 = this._source;
                return this.$ti._rest[1]._as(t1.get$current(t1));
            }
        };
        A.CastIterable.prototype = {
            get$_source: function() {
                return this._source;
            }
        };
        A._EfficientLengthCastIterable.prototype = {
            $isEfficientLengthIterable: 1
        };
        A._CastListBase.prototype = {
            $index: function(_, index) {
                return this.$ti._rest[1]._as(J.$index$asx(this._source, index));
            },
            $indexSet: function(_, index, value) {
                J.$indexSet$ax(this._source, index, this.$ti._precomputed1._as(value));
            },
            set$length: function(_, $length) {
                J.set$length$asx(this._source, $length);
            },
            add$1: function(_, value) {
                J.add$1$ax(this._source, this.$ti._precomputed1._as(value));
            },
            addAll$1: function(_, values) {
                var t1 = this.$ti;
                J.addAll$1$ax(this._source, A.CastIterable_CastIterable(values, t1._rest[1], t1._precomputed1));
            },
            sort$1: function(_, compare) {
                var t1 = compare == null ? null : new A._CastListBase_sort_closure(this, compare);
                J.sort$1$ax(this._source, t1);
            },
            getRange$2: function(_, start, end) {
                var t1 = this.$ti;
                return A.CastIterable_CastIterable(J.getRange$2$ax(this._source, start, end), t1._precomputed1, t1._rest[1]);
            },
            setRange$4: function(_, start, end, iterable, skipCount) {
                var t1 = this.$ti;
                J.setRange$4$ax(this._source, start, end, A.CastIterable_CastIterable(iterable, t1._rest[1], t1._precomputed1), skipCount);
            },
            removeRange$2: function(_, start, end) {
                J.removeRange$2$ax(this._source, start, end);
            },
            fillRange$3: function(_, start, end, fillValue) {
                J.fillRange$3$ax(this._source, start, end, this.$ti._precomputed1._as(fillValue));
            },
            $isEfficientLengthIterable: 1,
            $isList: 1
        };
        A._CastListBase_sort_closure.prototype = {
            call$2: function(v1, v2) {
                var t1 = this.$this.$ti._rest[1];
                return this.compare.call$2(t1._as(v1), t1._as(v2));
            },
            $signature: function() {
                return this.$this.$ti._eval$1("int(1,1)");
            }
        };
        A.CastList.prototype = {
            cast$1$0: function(_, $R) {
                return new A.CastList(this._source, this.$ti._eval$1("@<1>")._bind$1($R)._eval$1("CastList<1,2>"));
            },
            get$_source: function() {
                return this._source;
            }
        };
        A.CastSet.prototype = {
            add$1: function(_, value) {
                return this._source.add$1(0, this.$ti._precomputed1._as(value));
            },
            addAll$1: function(_, elements) {
                var t1 = this.$ti;
                this._source.addAll$1(0, A.CastIterable_CastIterable(elements, t1._rest[1], t1._precomputed1));
            },
            difference$1: function(other) {
                var _this = this;
                if (_this._emptySet != null) return _this._conditionalAdd$2(other, false);
                return new A.CastSet(_this._source.difference$1(other), null, _this.$ti);
            },
            _conditionalAdd$2: function(other, otherContains) {
                var t3, castElement, emptySet = this._emptySet, t1 = this.$ti, t2 = t1._rest[1], result = emptySet == null ? A.LinkedHashSet_LinkedHashSet(t2) : emptySet.call$1$0(t2);
                for(t2 = this._source, t2 = t2.get$iterator(t2), t3 = other._source, t1 = t1._rest[1]; t2.moveNext$0();){
                    castElement = t1._as(t2.get$current(t2));
                    if (otherContains === t3.contains$1(0, castElement)) result.add$1(0, castElement);
                }
                return result;
            },
            toSet$0: function(_) {
                var emptySet = this._emptySet, t1 = this.$ti._rest[1], result = emptySet == null ? A.LinkedHashSet_LinkedHashSet(t1) : emptySet.call$1$0(t1);
                result.addAll$1(0, this);
                return result;
            },
            $isEfficientLengthIterable: 1,
            $isSet: 1,
            get$_source: function() {
                return this._source;
            }
        };
        A.CastMap.prototype = {
            cast$2$0: function(_, $RK, $RV) {
                return new A.CastMap(this._source, this.$ti._eval$1("@<1,2>")._bind$1($RK)._bind$1($RV)._eval$1("CastMap<1,2,3,4>"));
            },
            containsKey$1: function(key) {
                return this._source.containsKey$1(key);
            },
            $index: function(_, key) {
                return this.$ti._eval$1("4?")._as(this._source.$index(0, key));
            },
            $indexSet: function(_, key, value) {
                var t1 = this.$ti;
                this._source.$indexSet(0, t1._precomputed1._as(key), t1._rest[1]._as(value));
            },
            addAll$1: function(_, other) {
                this._source.addAll$1(0, new A.CastMap(other, this.$ti._eval$1("CastMap<3,4,1,2>")));
            },
            remove$1: function(_, key) {
                return this.$ti._eval$1("4?")._as(this._source.remove$1(0, key));
            },
            forEach$1: function(_, f) {
                this._source.forEach$1(0, new A.CastMap_forEach_closure(this, f));
            },
            get$keys: function(_) {
                var t1 = this._source, t2 = this.$ti;
                return A.CastIterable_CastIterable(t1.get$keys(t1), t2._precomputed1, t2._rest[2]);
            },
            get$values: function(_) {
                var t1 = this._source, t2 = this.$ti;
                return A.CastIterable_CastIterable(t1.get$values(t1), t2._rest[1], t2._rest[3]);
            },
            get$length: function(_) {
                var t1 = this._source;
                return t1.get$length(t1);
            },
            get$isEmpty: function(_) {
                var t1 = this._source;
                return t1.get$isEmpty(t1);
            },
            get$isNotEmpty: function(_) {
                var t1 = this._source;
                return t1.get$isNotEmpty(t1);
            },
            get$entries: function(_) {
                var t1 = this._source;
                t1 = t1.get$entries(t1);
                return t1.map$1$1(t1, new A.CastMap_entries_closure(this), this.$ti._eval$1("MapEntry<3,4>"));
            }
        };
        A.CastMap_forEach_closure.prototype = {
            call$2: function(key, value) {
                var t1 = this.$this.$ti;
                this.f.call$2(t1._rest[2]._as(key), t1._rest[3]._as(value));
            },
            $signature: function() {
                return this.$this.$ti._eval$1("~(1,2)");
            }
        };
        A.CastMap_entries_closure.prototype = {
            call$1: function(e) {
                var t1 = this.$this.$ti;
                return new A.MapEntry(t1._rest[2]._as(e.key), t1._rest[3]._as(e.value), t1._eval$1("MapEntry<3,4>"));
            },
            $signature: function() {
                return this.$this.$ti._eval$1("MapEntry<3,4>(MapEntry<1,2>)");
            }
        };
        A.LateError.prototype = {
            toString$0: function(_) {
                return "LateInitializationError: " + this._message;
            }
        };
        A.CodeUnits.prototype = {
            get$length: function(_) {
                return this._string.length;
            },
            $index: function(_, i) {
                return this._string.charCodeAt(i);
            }
        };
        A.nullFuture_closure.prototype = {
            call$0: function() {
                return A.Future_Future$value(null, type$.void);
            },
            $signature: 32
        };
        A.SentinelValue.prototype = {};
        A.EfficientLengthIterable.prototype = {};
        A.ListIterable.prototype = {
            get$iterator: function(_) {
                var _this = this;
                return new A.ListIterator(_this, _this.get$length(_this), A._instanceType(_this)._eval$1("ListIterator<ListIterable.E>"));
            },
            get$isEmpty: function(_) {
                return this.get$length(this) === 0;
            },
            get$first: function(_) {
                if (this.get$length(this) === 0) throw A.wrapException(A.IterableElementError_noElement());
                return this.elementAt$1(0, 0);
            },
            get$last: function(_) {
                var _this = this;
                if (_this.get$length(_this) === 0) throw A.wrapException(A.IterableElementError_noElement());
                return _this.elementAt$1(0, _this.get$length(_this) - 1);
            },
            get$single: function(_) {
                var _this = this;
                if (_this.get$length(_this) === 0) throw A.wrapException(A.IterableElementError_noElement());
                if (_this.get$length(_this) > 1) throw A.wrapException(A.IterableElementError_tooMany());
                return _this.elementAt$1(0, 0);
            },
            contains$1: function(_, element) {
                var i, _this = this, $length = _this.get$length(_this);
                for(i = 0; i < $length; ++i){
                    if (J.$eq$(_this.elementAt$1(0, i), element)) return true;
                    if ($length !== _this.get$length(_this)) throw A.wrapException(A.ConcurrentModificationError$(_this));
                }
                return false;
            },
            every$1: function(_, test) {
                var i, _this = this, $length = _this.get$length(_this);
                for(i = 0; i < $length; ++i){
                    if (!test.call$1(_this.elementAt$1(0, i))) return false;
                    if ($length !== _this.get$length(_this)) throw A.wrapException(A.ConcurrentModificationError$(_this));
                }
                return true;
            },
            any$1: function(_, test) {
                var i, _this = this, $length = _this.get$length(_this);
                for(i = 0; i < $length; ++i){
                    if (test.call$1(_this.elementAt$1(0, i))) return true;
                    if ($length !== _this.get$length(_this)) throw A.wrapException(A.ConcurrentModificationError$(_this));
                }
                return false;
            },
            join$1: function(_, separator) {
                var first, t1, i, _this = this, $length = _this.get$length(_this);
                if (separator.length !== 0) {
                    if ($length === 0) return "";
                    first = A.S(_this.elementAt$1(0, 0));
                    if ($length !== _this.get$length(_this)) throw A.wrapException(A.ConcurrentModificationError$(_this));
                    for(t1 = first, i = 1; i < $length; ++i){
                        t1 = t1 + separator + A.S(_this.elementAt$1(0, i));
                        if ($length !== _this.get$length(_this)) throw A.wrapException(A.ConcurrentModificationError$(_this));
                    }
                    return t1.charCodeAt(0) == 0 ? t1 : t1;
                } else {
                    for(i = 0, t1 = ""; i < $length; ++i){
                        t1 += A.S(_this.elementAt$1(0, i));
                        if ($length !== _this.get$length(_this)) throw A.wrapException(A.ConcurrentModificationError$(_this));
                    }
                    return t1.charCodeAt(0) == 0 ? t1 : t1;
                }
            },
            join$0: function(_) {
                return this.join$1(0, "");
            },
            where$1: function(_, test) {
                return this.super$Iterable$where(0, test);
            },
            map$1$1: function(_, toElement, $T) {
                return new A.MappedListIterable(this, toElement, A._instanceType(this)._eval$1("@<ListIterable.E>")._bind$1($T)._eval$1("MappedListIterable<1,2>"));
            },
            reduce$1: function(_, combine) {
                var value, i, _this = this, $length = _this.get$length(_this);
                if ($length === 0) throw A.wrapException(A.IterableElementError_noElement());
                value = _this.elementAt$1(0, 0);
                for(i = 1; i < $length; ++i){
                    value = combine.call$2(value, _this.elementAt$1(0, i));
                    if ($length !== _this.get$length(_this)) throw A.wrapException(A.ConcurrentModificationError$(_this));
                }
                return value;
            },
            fold$1$2: function(_, initialValue, combine) {
                var value, i, _this = this, $length = _this.get$length(_this);
                for(value = initialValue, i = 0; i < $length; ++i){
                    value = combine.call$2(value, _this.elementAt$1(0, i));
                    if ($length !== _this.get$length(_this)) throw A.wrapException(A.ConcurrentModificationError$(_this));
                }
                return value;
            },
            fold$2: function(_, initialValue, combine) {
                return this.fold$1$2(0, initialValue, combine, type$.dynamic);
            },
            skip$1: function(_, count) {
                return A.SubListIterable$(this, count, null, A._instanceType(this)._eval$1("ListIterable.E"));
            },
            take$1: function(_, count) {
                return A.SubListIterable$(this, 0, A.checkNotNullable(count, "count", type$.int), A._instanceType(this)._eval$1("ListIterable.E"));
            },
            toList$1$growable: function(_, growable) {
                var t1 = A.List_List$_of(this, A._instanceType(this)._eval$1("ListIterable.E"));
                return t1;
            },
            toList$0: function(_) {
                return this.toList$1$growable(0, true);
            },
            toSet$0: function(_) {
                var i, _this = this, result = A.LinkedHashSet_LinkedHashSet(A._instanceType(_this)._eval$1("ListIterable.E"));
                for(i = 0; i < _this.get$length(_this); ++i)result.add$1(0, _this.elementAt$1(0, i));
                return result;
            }
        };
        A.SubListIterable.prototype = {
            SubListIterable$3: function(_iterable, _start, _endOrLength, $E) {
                var endOrLength, t1 = this._start;
                A.RangeError_checkNotNegative(t1, "start");
                endOrLength = this._endOrLength;
                if (endOrLength != null) {
                    A.RangeError_checkNotNegative(endOrLength, "end");
                    if (t1 > endOrLength) throw A.wrapException(A.RangeError$range(t1, 0, endOrLength, "start", null));
                }
            },
            get$_endIndex: function() {
                var $length = J.get$length$asx(this.__internal$_iterable), endOrLength = this._endOrLength;
                if (endOrLength == null || endOrLength > $length) return $length;
                return endOrLength;
            },
            get$_startIndex: function() {
                var $length = J.get$length$asx(this.__internal$_iterable), t1 = this._start;
                if (t1 > $length) return $length;
                return t1;
            },
            get$length: function(_) {
                var endOrLength, $length = J.get$length$asx(this.__internal$_iterable), t1 = this._start;
                if (t1 >= $length) return 0;
                endOrLength = this._endOrLength;
                if (endOrLength == null || endOrLength >= $length) return $length - t1;
                return endOrLength - t1;
            },
            elementAt$1: function(_, index) {
                var _this = this, realIndex = _this.get$_startIndex() + index;
                if (index < 0 || realIndex >= _this.get$_endIndex()) throw A.wrapException(A.IndexError$withLength(index, _this.get$length(0), _this, null, "index"));
                return J.elementAt$1$ax(_this.__internal$_iterable, realIndex);
            },
            skip$1: function(_, count) {
                var newStart, endOrLength, _this = this;
                A.RangeError_checkNotNegative(count, "count");
                newStart = _this._start + count;
                endOrLength = _this._endOrLength;
                if (endOrLength != null && newStart >= endOrLength) return new A.EmptyIterable(_this.$ti._eval$1("EmptyIterable<1>"));
                return A.SubListIterable$(_this.__internal$_iterable, newStart, endOrLength, _this.$ti._precomputed1);
            },
            take$1: function(_, count) {
                var endOrLength, t1, newEnd, _this = this;
                A.RangeError_checkNotNegative(count, "count");
                endOrLength = _this._endOrLength;
                t1 = _this._start;
                newEnd = t1 + count;
                if (endOrLength == null) return A.SubListIterable$(_this.__internal$_iterable, t1, newEnd, _this.$ti._precomputed1);
                else {
                    if (endOrLength < newEnd) return _this;
                    return A.SubListIterable$(_this.__internal$_iterable, t1, newEnd, _this.$ti._precomputed1);
                }
            },
            toList$1$growable: function(_, growable) {
                var $length, result, i, _this = this, start = _this._start, t1 = _this.__internal$_iterable, t2 = J.getInterceptor$asx(t1), end = t2.get$length(t1), endOrLength = _this._endOrLength;
                if (endOrLength != null && endOrLength < end) end = endOrLength;
                $length = end - start;
                if ($length <= 0) {
                    t1 = _this.$ti._precomputed1;
                    return growable ? J.JSArray_JSArray$growable(0, t1) : J.JSArray_JSArray$fixed(0, t1);
                }
                result = A.List_List$filled($length, t2.elementAt$1(t1, start), growable, _this.$ti._precomputed1);
                for(i = 1; i < $length; ++i){
                    result[i] = t2.elementAt$1(t1, start + i);
                    if (t2.get$length(t1) < end) throw A.wrapException(A.ConcurrentModificationError$(_this));
                }
                return result;
            },
            toList$0: function(_) {
                return this.toList$1$growable(0, true);
            }
        };
        A.ListIterator.prototype = {
            get$current: function(_) {
                var t1 = this.__internal$_current;
                return t1 == null ? this.$ti._precomputed1._as(t1) : t1;
            },
            moveNext$0: function() {
                var t3, _this = this, t1 = _this.__internal$_iterable, t2 = J.getInterceptor$asx(t1), $length = t2.get$length(t1);
                if (_this.__internal$_length !== $length) throw A.wrapException(A.ConcurrentModificationError$(t1));
                t3 = _this.__internal$_index;
                if (t3 >= $length) {
                    _this.__internal$_current = null;
                    return false;
                }
                _this.__internal$_current = t2.elementAt$1(t1, t3);
                ++_this.__internal$_index;
                return true;
            }
        };
        A.MappedIterable.prototype = {
            get$iterator: function(_) {
                return new A.MappedIterator(J.get$iterator$ax(this.__internal$_iterable), this._f, A._instanceType(this)._eval$1("MappedIterator<1,2>"));
            },
            get$length: function(_) {
                return J.get$length$asx(this.__internal$_iterable);
            },
            get$isEmpty: function(_) {
                return J.get$isEmpty$asx(this.__internal$_iterable);
            },
            get$first: function(_) {
                return this._f.call$1(J.get$first$ax(this.__internal$_iterable));
            },
            get$last: function(_) {
                return this._f.call$1(J.get$last$ax(this.__internal$_iterable));
            },
            get$single: function(_) {
                return this._f.call$1(J.get$single$ax(this.__internal$_iterable));
            },
            elementAt$1: function(_, index) {
                return this._f.call$1(J.elementAt$1$ax(this.__internal$_iterable, index));
            }
        };
        A.EfficientLengthMappedIterable.prototype = {
            $isEfficientLengthIterable: 1
        };
        A.MappedIterator.prototype = {
            moveNext$0: function() {
                var _this = this, t1 = _this._iterator;
                if (t1.moveNext$0()) {
                    _this.__internal$_current = _this._f.call$1(t1.get$current(t1));
                    return true;
                }
                _this.__internal$_current = null;
                return false;
            },
            get$current: function(_) {
                var t1 = this.__internal$_current;
                return t1 == null ? this.$ti._rest[1]._as(t1) : t1;
            }
        };
        A.MappedListIterable.prototype = {
            get$length: function(_) {
                return J.get$length$asx(this._source);
            },
            elementAt$1: function(_, index) {
                return this._f.call$1(J.elementAt$1$ax(this._source, index));
            }
        };
        A.WhereIterable.prototype = {
            get$iterator: function(_) {
                return new A.WhereIterator(J.get$iterator$ax(this.__internal$_iterable), this._f);
            },
            map$1$1: function(_, toElement, $T) {
                return new A.MappedIterable(this, toElement, this.$ti._eval$1("@<1>")._bind$1($T)._eval$1("MappedIterable<1,2>"));
            }
        };
        A.WhereIterator.prototype = {
            moveNext$0: function() {
                var t1, t2;
                for(t1 = this._iterator, t2 = this._f; t1.moveNext$0();)if (t2.call$1(t1.get$current(t1))) return true;
                return false;
            },
            get$current: function(_) {
                var t1 = this._iterator;
                return t1.get$current(t1);
            }
        };
        A.ExpandIterable.prototype = {
            get$iterator: function(_) {
                return new A.ExpandIterator(J.get$iterator$ax(this.__internal$_iterable), this._f, B.C_EmptyIterator, this.$ti._eval$1("ExpandIterator<1,2>"));
            }
        };
        A.ExpandIterator.prototype = {
            get$current: function(_) {
                var t1 = this.__internal$_current;
                return t1 == null ? this.$ti._rest[1]._as(t1) : t1;
            },
            moveNext$0: function() {
                var t2, t3, _this = this, t1 = _this._currentExpansion;
                if (t1 == null) return false;
                for(t2 = _this._iterator, t3 = _this._f; !t1.moveNext$0();){
                    _this.__internal$_current = null;
                    if (t2.moveNext$0()) {
                        _this._currentExpansion = null;
                        t1 = J.get$iterator$ax(t3.call$1(t2.get$current(t2)));
                        _this._currentExpansion = t1;
                    } else return false;
                }
                t1 = _this._currentExpansion;
                _this.__internal$_current = t1.get$current(t1);
                return true;
            }
        };
        A.TakeIterable.prototype = {
            get$iterator: function(_) {
                var t1 = this.__internal$_iterable;
                return new A.TakeIterator(t1.get$iterator(t1), this._takeCount, A._instanceType(this)._eval$1("TakeIterator<1>"));
            }
        };
        A.EfficientLengthTakeIterable.prototype = {
            get$length: function(_) {
                var t1 = this.__internal$_iterable, iterableLength = t1.get$length(t1);
                t1 = this._takeCount;
                if (iterableLength > t1) return t1;
                return iterableLength;
            },
            $isEfficientLengthIterable: 1
        };
        A.TakeIterator.prototype = {
            moveNext$0: function() {
                if (--this._remaining >= 0) return this._iterator.moveNext$0();
                this._remaining = -1;
                return false;
            },
            get$current: function(_) {
                var t1;
                if (this._remaining < 0) {
                    this.$ti._precomputed1._as(null);
                    return null;
                }
                t1 = this._iterator;
                return t1.get$current(t1);
            }
        };
        A.SkipIterable.prototype = {
            skip$1: function(_, count) {
                A.ArgumentError_checkNotNull(count, "count");
                A.RangeError_checkNotNegative(count, "count");
                return new A.SkipIterable(this.__internal$_iterable, this._skipCount + count, A._instanceType(this)._eval$1("SkipIterable<1>"));
            },
            get$iterator: function(_) {
                var t1 = this.__internal$_iterable;
                return new A.SkipIterator(t1.get$iterator(t1), this._skipCount);
            }
        };
        A.EfficientLengthSkipIterable.prototype = {
            get$length: function(_) {
                var t1 = this.__internal$_iterable, $length = t1.get$length(t1) - this._skipCount;
                if ($length >= 0) return $length;
                return 0;
            },
            skip$1: function(_, count) {
                A.ArgumentError_checkNotNull(count, "count");
                A.RangeError_checkNotNegative(count, "count");
                return new A.EfficientLengthSkipIterable(this.__internal$_iterable, this._skipCount + count, this.$ti);
            },
            $isEfficientLengthIterable: 1
        };
        A.SkipIterator.prototype = {
            moveNext$0: function() {
                var t1, i;
                for(t1 = this._iterator, i = 0; i < this._skipCount; ++i)t1.moveNext$0();
                this._skipCount = 0;
                return t1.moveNext$0();
            },
            get$current: function(_) {
                var t1 = this._iterator;
                return t1.get$current(t1);
            }
        };
        A.SkipWhileIterable.prototype = {
            get$iterator: function(_) {
                return new A.SkipWhileIterator(J.get$iterator$ax(this.__internal$_iterable), this._f);
            }
        };
        A.SkipWhileIterator.prototype = {
            moveNext$0: function() {
                var t1, t2, _this = this;
                if (!_this._hasSkipped) {
                    _this._hasSkipped = true;
                    for(t1 = _this._iterator, t2 = _this._f; t1.moveNext$0();)if (!t2.call$1(t1.get$current(t1))) return true;
                }
                return _this._iterator.moveNext$0();
            },
            get$current: function(_) {
                var t1 = this._iterator;
                return t1.get$current(t1);
            }
        };
        A.EmptyIterable.prototype = {
            get$iterator: function(_) {
                return B.C_EmptyIterator;
            },
            get$isEmpty: function(_) {
                return true;
            },
            get$length: function(_) {
                return 0;
            },
            get$first: function(_) {
                throw A.wrapException(A.IterableElementError_noElement());
            },
            get$last: function(_) {
                throw A.wrapException(A.IterableElementError_noElement());
            },
            get$single: function(_) {
                throw A.wrapException(A.IterableElementError_noElement());
            },
            elementAt$1: function(_, index) {
                throw A.wrapException(A.RangeError$range(index, 0, 0, "index", null));
            },
            contains$1: function(_, element) {
                return false;
            },
            every$1: function(_, test) {
                return true;
            },
            any$1: function(_, test) {
                return false;
            },
            join$1: function(_, separator) {
                return "";
            },
            where$1: function(_, test) {
                return this;
            },
            map$1$1: function(_, toElement, $T) {
                return new A.EmptyIterable($T._eval$1("EmptyIterable<0>"));
            },
            skip$1: function(_, count) {
                A.RangeError_checkNotNegative(count, "count");
                return this;
            },
            take$1: function(_, count) {
                A.RangeError_checkNotNegative(count, "count");
                return this;
            },
            toList$1$growable: function(_, growable) {
                var t1 = J.JSArray_JSArray$growable(0, this.$ti._precomputed1);
                return t1;
            },
            toList$0: function(_) {
                return this.toList$1$growable(0, true);
            },
            toSet$0: function(_) {
                return A.LinkedHashSet_LinkedHashSet(this.$ti._precomputed1);
            }
        };
        A.EmptyIterator.prototype = {
            moveNext$0: function() {
                return false;
            },
            get$current: function(_) {
                throw A.wrapException(A.IterableElementError_noElement());
            }
        };
        A.FollowedByIterable.prototype = {
            get$iterator: function(_) {
                return new A.FollowedByIterator(J.get$iterator$ax(this.__internal$_first), this._second);
            },
            get$length: function(_) {
                var t1 = this._second;
                return J.get$length$asx(this.__internal$_first) + t1.get$length(t1);
            },
            get$isEmpty: function(_) {
                var t1;
                if (J.get$isEmpty$asx(this.__internal$_first)) {
                    t1 = this._second;
                    t1 = t1.get$isEmpty(t1);
                } else t1 = false;
                return t1;
            },
            get$isNotEmpty: function(_) {
                var t1;
                if (!J.get$isNotEmpty$asx(this.__internal$_first)) {
                    t1 = this._second;
                    t1 = t1.get$isNotEmpty(t1);
                } else t1 = true;
                return t1;
            },
            contains$1: function(_, value) {
                var t1;
                if (!J.contains$1$asx(this.__internal$_first, value)) {
                    t1 = this._second;
                    t1 = t1.contains$1(t1, value);
                } else t1 = true;
                return t1;
            },
            get$first: function(_) {
                var t1, iterator = J.get$iterator$ax(this.__internal$_first);
                if (iterator.moveNext$0()) return iterator.get$current(iterator);
                t1 = this._second;
                return t1.get$first(t1);
            },
            get$last: function(_) {
                var last, t1 = this._second, iterator = t1.get$iterator(t1);
                if (iterator.moveNext$0()) {
                    last = iterator.get$current(iterator);
                    while(iterator.moveNext$0())last = iterator.get$current(iterator);
                    return last;
                }
                return J.get$last$ax(this.__internal$_first);
            }
        };
        A.EfficientLengthFollowedByIterable.prototype = {
            elementAt$1: function(_, index) {
                var t1 = this.__internal$_first, t2 = J.getInterceptor$asx(t1), firstLength = t2.get$length(t1);
                if (index < firstLength) return t2.elementAt$1(t1, index);
                t1 = this._second;
                return t1.elementAt$1(t1, index - firstLength);
            },
            get$first: function(_) {
                var t1 = this.__internal$_first, t2 = J.getInterceptor$asx(t1);
                if (t2.get$isNotEmpty(t1)) return t2.get$first(t1);
                t1 = this._second;
                return t1.get$first(t1);
            },
            get$last: function(_) {
                var t1 = this._second;
                if (t1.get$isNotEmpty(t1)) return t1.get$last(t1);
                return J.get$last$ax(this.__internal$_first);
            },
            $isEfficientLengthIterable: 1
        };
        A.FollowedByIterator.prototype = {
            moveNext$0: function() {
                var t1, _this = this;
                if (_this._currentIterator.moveNext$0()) return true;
                t1 = _this._nextIterable;
                if (t1 != null) {
                    t1 = t1.get$iterator(t1);
                    _this._currentIterator = t1;
                    _this._nextIterable = null;
                    return t1.moveNext$0();
                }
                return false;
            },
            get$current: function(_) {
                var t1 = this._currentIterator;
                return t1.get$current(t1);
            }
        };
        A.WhereTypeIterable.prototype = {
            get$iterator: function(_) {
                return new A.WhereTypeIterator(J.get$iterator$ax(this._source), this.$ti._eval$1("WhereTypeIterator<1>"));
            }
        };
        A.WhereTypeIterator.prototype = {
            moveNext$0: function() {
                var t1, t2;
                for(t1 = this._source, t2 = this.$ti._precomputed1; t1.moveNext$0();)if (t2._is(t1.get$current(t1))) return true;
                return false;
            },
            get$current: function(_) {
                var t1 = this._source;
                return this.$ti._precomputed1._as(t1.get$current(t1));
            }
        };
        A.NonNullsIterable.prototype = {
            get$_firstNonNull: function() {
                var t1, element;
                for(t1 = J.get$iterator$ax(this._source); t1.moveNext$0();){
                    element = t1.get$current(t1);
                    if (element != null) return element;
                }
                return null;
            },
            get$isEmpty: function(_) {
                return this.get$_firstNonNull() == null;
            },
            get$isNotEmpty: function(_) {
                return this.get$_firstNonNull() != null;
            },
            get$first: function(_) {
                var t1 = this.get$_firstNonNull();
                return t1 == null ? A.throwExpression(A.IterableElementError_noElement()) : t1;
            },
            get$iterator: function(_) {
                return new A.NonNullsIterator(J.get$iterator$ax(this._source));
            }
        };
        A.NonNullsIterator.prototype = {
            moveNext$0: function() {
                var t1, next;
                this.__internal$_current = null;
                for(t1 = this._source; t1.moveNext$0();){
                    next = t1.get$current(t1);
                    if (next != null) {
                        this.__internal$_current = next;
                        return true;
                    }
                }
                return false;
            },
            get$current: function(_) {
                var t1 = this.__internal$_current;
                return t1 == null ? A.throwExpression(A.IterableElementError_noElement()) : t1;
            }
        };
        A.FixedLengthListMixin.prototype = {
            set$length: function(receiver, newLength) {
                throw A.wrapException(A.UnsupportedError$("Cannot change the length of a fixed-length list"));
            },
            add$1: function(receiver, value) {
                throw A.wrapException(A.UnsupportedError$("Cannot add to a fixed-length list"));
            },
            addAll$1: function(receiver, iterable) {
                throw A.wrapException(A.UnsupportedError$("Cannot add to a fixed-length list"));
            },
            removeRange$2: function(receiver, start, end) {
                throw A.wrapException(A.UnsupportedError$("Cannot remove from a fixed-length list"));
            }
        };
        A.UnmodifiableListMixin.prototype = {
            $indexSet: function(_, index, value) {
                throw A.wrapException(A.UnsupportedError$("Cannot modify an unmodifiable list"));
            },
            set$length: function(_, newLength) {
                throw A.wrapException(A.UnsupportedError$("Cannot change the length of an unmodifiable list"));
            },
            add$1: function(_, value) {
                throw A.wrapException(A.UnsupportedError$("Cannot add to an unmodifiable list"));
            },
            addAll$1: function(_, iterable) {
                throw A.wrapException(A.UnsupportedError$("Cannot add to an unmodifiable list"));
            },
            sort$1: function(_, compare) {
                throw A.wrapException(A.UnsupportedError$("Cannot modify an unmodifiable list"));
            },
            setRange$4: function(_, start, end, iterable, skipCount) {
                throw A.wrapException(A.UnsupportedError$("Cannot modify an unmodifiable list"));
            },
            removeRange$2: function(_, start, end) {
                throw A.wrapException(A.UnsupportedError$("Cannot remove from an unmodifiable list"));
            },
            fillRange$3: function(_, start, end, fillValue) {
                throw A.wrapException(A.UnsupportedError$("Cannot modify an unmodifiable list"));
            }
        };
        A.UnmodifiableListBase.prototype = {};
        A.ReversedListIterable.prototype = {
            get$length: function(_) {
                return J.get$length$asx(this._source);
            },
            elementAt$1: function(_, index) {
                var t1 = this._source, t2 = J.getInterceptor$asx(t1);
                return t2.elementAt$1(t1, t2.get$length(t1) - 1 - index);
            }
        };
        A.Symbol.prototype = {
            get$hashCode: function(_) {
                var hash = this._hashCode;
                if (hash != null) return hash;
                hash = 664597 * B.JSString_methods.get$hashCode(this.__internal$_name) & 536870911;
                this._hashCode = hash;
                return hash;
            },
            toString$0: function(_) {
                return 'Symbol("' + this.__internal$_name + '")';
            },
            $eq: function(_, other) {
                if (other == null) return false;
                return other instanceof A.Symbol && this.__internal$_name === other.__internal$_name;
            },
            $isSymbol0: 1
        };
        A.__CastListBase__CastIterableBase_ListMixin.prototype = {};
        A._Record_1.prototype = {
            $recipe: "+(1)",
            $shape: 1
        };
        A._Record_2.prototype = {
            $recipe: "+(1,2)",
            $shape: 2
        };
        A._Record_2_forImport.prototype = {
            $recipe: "+forImport(1,2)",
            $shape: 3
        };
        A._Record_2_imports_modules.prototype = {
            $recipe: "+imports,modules(1,2)",
            $shape: 5
        };
        A._Record_2_loadedUrls_stylesheet.prototype = {
            $recipe: "+loadedUrls,stylesheet(1,2)",
            $shape: 6
        };
        A._Record_2_sourceMap.prototype = {
            $recipe: "+sourceMap(1,2)",
            $shape: 4
        };
        A._Record_3.prototype = {
            $recipe: "+(1,2,3)",
            $shape: 7
        };
        A._Record_3_deprecation_message_span.prototype = {
            get$message: function(_) {
                return this._1;
            },
            $recipe: "+deprecation,message,span(1,2,3)",
            $shape: 11
        };
        A._Record_3_forImport.prototype = {
            $recipe: "+forImport(1,2,3)",
            $shape: 8
        };
        A._Record_3_importer_isDependency.prototype = {
            $recipe: "+importer,isDependency(1,2,3)",
            $shape: 10
        };
        A._Record_3_originalUrl.prototype = {
            $recipe: "+originalUrl(1,2,3)",
            $shape: 9
        };
        A._Record_5_named_namedNodes_positional_positionalNodes_separator.prototype = {
            $recipe: "+named,namedNodes,positional,positionalNodes,separator(1,2,3,4,5)",
            $shape: 13
        };
        A.ConstantMapView.prototype = {};
        A.ConstantMap.prototype = {
            cast$2$0: function(_, $RK, $RV) {
                var t1 = A._instanceType(this);
                return A.Map_castFrom(this, t1._precomputed1, t1._rest[1], $RK, $RV);
            },
            get$isEmpty: function(_) {
                return this.get$length(this) === 0;
            },
            get$isNotEmpty: function(_) {
                return this.get$length(this) !== 0;
            },
            toString$0: function(_) {
                return A.MapBase_mapToString(this);
            },
            $indexSet: function(_, key, value) {
                A.ConstantMap__throwUnmodifiable();
            },
            remove$1: function(_, key) {
                A.ConstantMap__throwUnmodifiable();
            },
            addAll$1: function(_, other) {
                A.ConstantMap__throwUnmodifiable();
            },
            get$entries: function(_) {
                return new A._SyncStarIterable(this.entries$body$ConstantMap(0), A._instanceType(this)._eval$1("_SyncStarIterable<MapEntry<1,2>>"));
            },
            entries$body$ConstantMap: function($async$_) {
                var $async$self = this;
                return function() {
                    var _ = $async$_;
                    var $async$goto = 0, $async$handler = 1, $async$errorStack = [], t1, t2, key;
                    return function $async$get$entries($async$iterator, $async$errorCode, $async$result) {
                        if ($async$errorCode === 1) {
                            $async$errorStack.push($async$result);
                            $async$goto = $async$handler;
                        }
                        for(;;)switch($async$goto){
                            case 0:
                                // Function start
                                t1 = $async$self.get$keys($async$self), t1 = t1.get$iterator(t1), t2 = A._instanceType($async$self)._eval$1("MapEntry<1,2>");
                            case 2:
                                // for condition
                                if (!t1.moveNext$0()) {
                                    // goto after for
                                    $async$goto = 3;
                                    break;
                                }
                                key = t1.get$current(t1);
                                $async$goto = 4;
                                return $async$iterator._async$_current = new A.MapEntry(key, $async$self.$index(0, key), t2), 1;
                            case 4:
                                // after yield
                                // goto for condition
                                $async$goto = 2;
                                break;
                            case 3:
                                // after for
                                // implicit return
                                return 0;
                            case 1:
                                // rethrow
                                return $async$iterator._datum = $async$errorStack.at(-1), 3;
                        }
                    };
                };
            },
            $isMap: 1
        };
        A.ConstantStringMap.prototype = {
            get$length: function(_) {
                return this._values.length;
            },
            get$_keys: function() {
                var keys = this.$keys;
                if (keys == null) {
                    keys = Object.keys(this._jsIndex);
                    this.$keys = keys;
                }
                return keys;
            },
            containsKey$1: function(key) {
                if (typeof key != "string") return false;
                if ("__proto__" === key) return false;
                return this._jsIndex.hasOwnProperty(key);
            },
            $index: function(_, key) {
                if (!this.containsKey$1(key)) return null;
                return this._values[this._jsIndex[key]];
            },
            forEach$1: function(_, f) {
                var t1, i, keys = this.get$_keys(), values = this._values;
                for(t1 = keys.length, i = 0; i < t1; ++i)f.call$2(keys[i], values[i]);
            },
            get$keys: function(_) {
                return new A._KeysOrValues(this.get$_keys(), this.$ti._eval$1("_KeysOrValues<1>"));
            },
            get$values: function(_) {
                return new A._KeysOrValues(this._values, this.$ti._eval$1("_KeysOrValues<2>"));
            }
        };
        A._KeysOrValues.prototype = {
            get$length: function(_) {
                return this._elements.length;
            },
            get$isEmpty: function(_) {
                return 0 === this._elements.length;
            },
            get$isNotEmpty: function(_) {
                return 0 !== this._elements.length;
            },
            get$iterator: function(_) {
                var t1 = this._elements;
                return new A._KeysOrValuesOrElementsIterator(t1, t1.length, this.$ti._eval$1("_KeysOrValuesOrElementsIterator<1>"));
            }
        };
        A._KeysOrValuesOrElementsIterator.prototype = {
            get$current: function(_) {
                var t1 = this.__js_helper$_current;
                return t1 == null ? this.$ti._precomputed1._as(t1) : t1;
            },
            moveNext$0: function() {
                var _this = this, t1 = _this.__js_helper$_index;
                if (t1 >= _this.__js_helper$_length) {
                    _this.__js_helper$_current = null;
                    return false;
                }
                _this.__js_helper$_current = _this._elements[t1];
                _this.__js_helper$_index = t1 + 1;
                return true;
            }
        };
        A.ConstantSet.prototype = {
            add$1: function(_, value) {
                A.ConstantSet__throwUnmodifiable();
            },
            addAll$1: function(_, elements) {
                A.ConstantSet__throwUnmodifiable();
            },
            remove$1: function(_, value) {
                A.ConstantSet__throwUnmodifiable();
            }
        };
        A.ConstantStringSet.prototype = {
            get$length: function(_) {
                return this.__js_helper$_length;
            },
            get$isEmpty: function(_) {
                return this.__js_helper$_length === 0;
            },
            get$isNotEmpty: function(_) {
                return this.__js_helper$_length !== 0;
            },
            get$iterator: function(_) {
                var t1, _this = this, keys = _this.$keys;
                if (keys == null) {
                    keys = Object.keys(_this._jsIndex);
                    _this.$keys = keys;
                }
                t1 = keys;
                return new A._KeysOrValuesOrElementsIterator(t1, t1.length, _this.$ti._eval$1("_KeysOrValuesOrElementsIterator<1>"));
            },
            contains$1: function(_, key) {
                if (typeof key != "string") return false;
                if ("__proto__" === key) return false;
                return this._jsIndex.hasOwnProperty(key);
            },
            toSet$0: function(_) {
                return A.LinkedHashSet_LinkedHashSet$of(this, this.$ti._precomputed1);
            }
        };
        A.GeneralConstantSet.prototype = {
            get$length: function(_) {
                return this._elements.length;
            },
            get$isEmpty: function(_) {
                return this._elements.length === 0;
            },
            get$isNotEmpty: function(_) {
                return this._elements.length !== 0;
            },
            get$iterator: function(_) {
                var t1 = this._elements;
                return new A._KeysOrValuesOrElementsIterator(t1, t1.length, this.$ti._eval$1("_KeysOrValuesOrElementsIterator<1>"));
            },
            _getMap$0: function() {
                var t1, t2, _i, key, _this = this, backingMap = _this.$map;
                if (backingMap == null) {
                    backingMap = new A.JsConstantLinkedHashMap(_this.$ti._eval$1("JsConstantLinkedHashMap<1,1>"));
                    for(t1 = _this._elements, t2 = t1.length, _i = 0; _i < t1.length; t1.length === t2 || (0, A.throwConcurrentModificationError)(t1), ++_i){
                        key = t1[_i];
                        backingMap.$indexSet(0, key, key);
                    }
                    _this.$map = backingMap;
                }
                return backingMap;
            },
            contains$1: function(_, key) {
                return this._getMap$0().containsKey$1(key);
            },
            toSet$0: function(_) {
                return A.LinkedHashSet_LinkedHashSet$of(this, this.$ti._precomputed1);
            }
        };
        A.Instantiation.prototype = {
            Instantiation$1: function(_genericClosure) {},
            $eq: function(_, other) {
                if (other == null) return false;
                return other instanceof A.Instantiation1 && this._genericClosure.$eq(0, other._genericClosure) && A.getRuntimeTypeOfClosure(this) === A.getRuntimeTypeOfClosure(other);
            },
            get$hashCode: function(_) {
                return A.Object_hash(this._genericClosure, A.getRuntimeTypeOfClosure(this), B.C_SentinelValue, B.C_SentinelValue);
            },
            toString$0: function(_) {
                var t1 = B.JSArray_methods.join$1([
                    A.createRuntimeType(this.$ti._precomputed1)
                ], ", ");
                return this._genericClosure.toString$0(0) + " with " + ("<" + t1 + ">");
            }
        };
        A.Instantiation1.prototype = {
            call$0: function() {
                return this._genericClosure.call$1$0(this.$ti._rest[0]);
            },
            call$2: function(a0, a1) {
                return this._genericClosure.call$1$2(a0, a1, this.$ti._rest[0]);
            },
            call$3: function(a0, a1, a2) {
                return this._genericClosure.call$1$3(a0, a1, a2, this.$ti._rest[0]);
            },
            call$4: function(a0, a1, a2, a3) {
                return this._genericClosure.call$1$4(a0, a1, a2, a3, this.$ti._rest[0]);
            },
            $signature: function() {
                return A.instantiatedGenericFunctionType(A.closureFunctionType(this._genericClosure), this.$ti);
            }
        };
        A.JSInvocationMirror.prototype = {
            get$memberName: function() {
                var t1 = this.__js_helper$_memberName;
                if (t1 instanceof A.Symbol) return t1;
                return this.__js_helper$_memberName = new A.Symbol(t1);
            },
            get$positionalArguments: function() {
                var t1, t2, argumentCount, list, index, _this = this;
                if (_this.__js_helper$_kind === 1) return B.List_empty6;
                t1 = _this._arguments;
                t2 = J.getInterceptor$asx(t1);
                argumentCount = t2.get$length(t1) - J.get$length$asx(_this._namedArgumentNames) - _this._typeArgumentCount;
                if (argumentCount === 0) return B.List_empty6;
                list = [];
                for(index = 0; index < argumentCount; ++index)list.push(t2.$index(t1, index));
                list.$flags = 3;
                return list;
            },
            get$namedArguments: function() {
                var t1, t2, namedArgumentCount, t3, t4, namedArgumentsStartIndex, map, i, _this = this;
                if (_this.__js_helper$_kind !== 0) return B.Map_empty2;
                t1 = _this._namedArgumentNames;
                t2 = J.getInterceptor$asx(t1);
                namedArgumentCount = t2.get$length(t1);
                t3 = _this._arguments;
                t4 = J.getInterceptor$asx(t3);
                namedArgumentsStartIndex = t4.get$length(t3) - namedArgumentCount - _this._typeArgumentCount;
                if (namedArgumentCount === 0) return B.Map_empty2;
                map = new A.JsLinkedHashMap(type$.JsLinkedHashMap_Symbol_dynamic);
                for(i = 0; i < namedArgumentCount; ++i)map.$indexSet(0, new A.Symbol(t2.$index(t1, i)), t4.$index(t3, namedArgumentsStartIndex + i));
                return new A.ConstantMapView(map, type$.ConstantMapView_Symbol_dynamic);
            }
        };
        A.Primitives_functionNoSuchMethod_closure.prototype = {
            call$2: function($name, argument) {
                var t1 = this._box_0;
                t1.names = t1.names + "$" + $name;
                this.namedArgumentList.push($name);
                this.$arguments.push(argument);
                ++t1.argumentCount;
            },
            $signature: 140
        };
        A.SafeToStringHook.prototype = {};
        A.TypeErrorDecoder.prototype = {
            matchTypeError$1: function(message) {
                var result, t1, _this = this, match = new RegExp(_this._pattern).exec(message);
                if (match == null) return null;
                result = Object.create(null);
                t1 = _this._arguments;
                if (t1 !== -1) result.arguments = match[t1 + 1];
                t1 = _this._argumentsExpr;
                if (t1 !== -1) result.argumentsExpr = match[t1 + 1];
                t1 = _this._expr;
                if (t1 !== -1) result.expr = match[t1 + 1];
                t1 = _this._method;
                if (t1 !== -1) result.method = match[t1 + 1];
                t1 = _this._receiver;
                if (t1 !== -1) result.receiver = match[t1 + 1];
                return result;
            }
        };
        A.NullError.prototype = {
            toString$0: function(_) {
                return "Null check operator used on a null value";
            }
        };
        A.JsNoSuchMethodError.prototype = {
            toString$0: function(_) {
                var t2, _this = this, _s38_ = "NoSuchMethodError: method not found: '", t1 = _this._method;
                if (t1 == null) return "NoSuchMethodError: " + _this.__js_helper$_message;
                t2 = _this._receiver;
                if (t2 == null) return _s38_ + t1 + "' (" + _this.__js_helper$_message + ")";
                return _s38_ + t1 + "' on '" + t2 + "' (" + _this.__js_helper$_message + ")";
            }
        };
        A.UnknownJsTypeError.prototype = {
            toString$0: function(_) {
                var t1 = this.__js_helper$_message;
                return t1.length === 0 ? "Error" : "Error: " + t1;
            }
        };
        A.NullThrownFromJavaScriptException.prototype = {
            toString$0: function(_) {
                return "Throw of null ('" + (this._irritant === null ? "null" : "undefined") + "' from JavaScript)";
            },
            $isException: 1
        };
        A.ExceptionAndStackTrace.prototype = {};
        A._StackTrace.prototype = {
            toString$0: function(_) {
                var trace, t1 = this._trace;
                if (t1 != null) return t1;
                t1 = this._exception;
                trace = t1 !== null && (typeof t1 === "undefined" ? "undefined" : (0, $6tOPT._)(t1)) === "object" ? t1.stack : null;
                return this._trace = trace == null ? "" : trace;
            },
            $isStackTrace: 1
        };
        A.Closure.prototype = {
            toString$0: function(_) {
                var $constructor = this.constructor, $name = $constructor == null ? null : $constructor.name;
                return "Closure '" + A.unminifyOrTag($name == null ? "unknown" : $name) + "'";
            },
            $isFunction: 1,
            get$$call: function() {
                return this;
            },
            "call*": "call$1",
            $requiredArgCount: 1,
            $defaultValues: null
        };
        A.Closure0Args.prototype = {
            "call*": "call$0",
            $requiredArgCount: 0
        };
        A.Closure2Args.prototype = {
            "call*": "call$2",
            $requiredArgCount: 2
        };
        A.TearOffClosure.prototype = {};
        A.StaticClosure.prototype = {
            toString$0: function(_) {
                var $name = this.$static_name;
                if ($name == null) return "Closure of unknown static method";
                return "Closure '" + A.unminifyOrTag($name) + "'";
            }
        };
        A.BoundClosure.prototype = {
            $eq: function(_, other) {
                if (other == null) return false;
                if (this === other) return true;
                if (!(other instanceof A.BoundClosure)) return false;
                return this.$_target === other.$_target && this._receiver === other._receiver;
            },
            get$hashCode: function(_) {
                return (A.objectHashCode(this._receiver) ^ A.Primitives_objectHashCode(this.$_target)) >>> 0;
            },
            toString$0: function(_) {
                return "Closure '" + this.$_name + "' of " + ("Instance of '" + A.Primitives_objectTypeName(this._receiver) + "'");
            }
        };
        A.RuntimeError.prototype = {
            toString$0: function(_) {
                return "RuntimeError: " + this.message;
            },
            get$message: function(receiver) {
                return this.message;
            }
        };
        A._Required.prototype = {};
        A.JsLinkedHashMap.prototype = {
            get$length: function(_) {
                return this.__js_helper$_length;
            },
            get$isEmpty: function(_) {
                return this.__js_helper$_length === 0;
            },
            get$isNotEmpty: function(_) {
                return this.__js_helper$_length !== 0;
            },
            get$keys: function(_) {
                return new A.LinkedHashMapKeysIterable(this, A._instanceType(this)._eval$1("LinkedHashMapKeysIterable<1>"));
            },
            get$values: function(_) {
                return new A.LinkedHashMapValuesIterable(this, A._instanceType(this)._eval$1("LinkedHashMapValuesIterable<2>"));
            },
            get$entries: function(_) {
                return new A.LinkedHashMapEntriesIterable(this, A._instanceType(this)._eval$1("LinkedHashMapEntriesIterable<1,2>"));
            },
            containsKey$1: function(key) {
                var strings, nums;
                if (typeof key == "string") {
                    strings = this._strings;
                    if (strings == null) return false;
                    return strings[key] != null;
                } else if (typeof key == "number" && (key & 0x3fffffff) === key) {
                    nums = this._nums;
                    if (nums == null) return false;
                    return nums[key] != null;
                } else return this.internalContainsKey$1(key);
            },
            internalContainsKey$1: function(key) {
                var rest = this.__js_helper$_rest;
                if (rest == null) return false;
                return this.internalFindBucketIndex$2(rest[this.internalComputeHashCode$1(key)], key) >= 0;
            },
            addAll$1: function(_, other) {
                other.forEach$1(0, new A.JsLinkedHashMap_addAll_closure(this));
            },
            $index: function(_, key) {
                var strings, cell, t1, nums, _null = null;
                if (typeof key == "string") {
                    strings = this._strings;
                    if (strings == null) return _null;
                    cell = strings[key];
                    t1 = cell == null ? _null : cell.hashMapCellValue;
                    return t1;
                } else if (typeof key == "number" && (key & 0x3fffffff) === key) {
                    nums = this._nums;
                    if (nums == null) return _null;
                    cell = nums[key];
                    t1 = cell == null ? _null : cell.hashMapCellValue;
                    return t1;
                } else return this.internalGet$1(key);
            },
            internalGet$1: function(key) {
                var bucket, index, rest = this.__js_helper$_rest;
                if (rest == null) return null;
                bucket = rest[this.internalComputeHashCode$1(key)];
                index = this.internalFindBucketIndex$2(bucket, key);
                if (index < 0) return null;
                return bucket[index].hashMapCellValue;
            },
            $indexSet: function(_, key, value) {
                var strings, nums, _this = this;
                if (typeof key == "string") {
                    strings = _this._strings;
                    _this._addHashTableEntry$3(strings == null ? _this._strings = _this._newHashTable$0() : strings, key, value);
                } else if (typeof key == "number" && (key & 0x3fffffff) === key) {
                    nums = _this._nums;
                    _this._addHashTableEntry$3(nums == null ? _this._nums = _this._newHashTable$0() : nums, key, value);
                } else _this.internalSet$2(key, value);
            },
            internalSet$2: function(key, value) {
                var hash, bucket, index, _this = this, rest = _this.__js_helper$_rest;
                if (rest == null) rest = _this.__js_helper$_rest = _this._newHashTable$0();
                hash = _this.internalComputeHashCode$1(key);
                bucket = rest[hash];
                if (bucket == null) rest[hash] = [
                    _this._newLinkedCell$2(key, value)
                ];
                else {
                    index = _this.internalFindBucketIndex$2(bucket, key);
                    if (index >= 0) bucket[index].hashMapCellValue = value;
                    else bucket.push(_this._newLinkedCell$2(key, value));
                }
            },
            putIfAbsent$2: function(key, ifAbsent) {
                var t1, value, _this = this;
                if (_this.containsKey$1(key)) {
                    t1 = _this.$index(0, key);
                    return t1 == null ? A._instanceType(_this)._rest[1]._as(t1) : t1;
                }
                value = ifAbsent.call$0();
                _this.$indexSet(0, key, value);
                return value;
            },
            remove$1: function(_, key) {
                var _this = this;
                if (typeof key == "string") return _this.__js_helper$_removeHashTableEntry$2(_this._strings, key);
                else if (typeof key == "number" && (key & 0x3fffffff) === key) return _this.__js_helper$_removeHashTableEntry$2(_this._nums, key);
                else return _this.internalRemove$1(key);
            },
            internalRemove$1: function(key) {
                var hash, bucket, index, cell, _this = this, rest = _this.__js_helper$_rest;
                if (rest == null) return null;
                hash = _this.internalComputeHashCode$1(key);
                bucket = rest[hash];
                index = _this.internalFindBucketIndex$2(bucket, key);
                if (index < 0) return null;
                cell = bucket.splice(index, 1)[0];
                _this.__js_helper$_unlinkCell$1(cell);
                if (bucket.length === 0) delete rest[hash];
                return cell.hashMapCellValue;
            },
            clear$0: function(_) {
                var _this = this;
                if (_this.__js_helper$_length > 0) {
                    _this._strings = _this._nums = _this.__js_helper$_rest = _this._first = _this._last = null;
                    _this.__js_helper$_length = 0;
                    _this._modified$0();
                }
            },
            forEach$1: function(_, action) {
                var _this = this, cell = _this._first, modifications = _this._modifications;
                while(cell != null){
                    action.call$2(cell.hashMapCellKey, cell.hashMapCellValue);
                    if (modifications !== _this._modifications) throw A.wrapException(A.ConcurrentModificationError$(_this));
                    cell = cell._next;
                }
            },
            _addHashTableEntry$3: function(table, key, value) {
                var cell = table[key];
                if (cell == null) table[key] = this._newLinkedCell$2(key, value);
                else cell.hashMapCellValue = value;
            },
            __js_helper$_removeHashTableEntry$2: function(table, key) {
                var cell;
                if (table == null) return null;
                cell = table[key];
                if (cell == null) return null;
                this.__js_helper$_unlinkCell$1(cell);
                delete table[key];
                return cell.hashMapCellValue;
            },
            _modified$0: function() {
                this._modifications = this._modifications + 1 & 1073741823;
            },
            _newLinkedCell$2: function(key, value) {
                var t1, _this = this, cell = new A.LinkedHashMapCell(key, value);
                if (_this._first == null) _this._first = _this._last = cell;
                else {
                    t1 = _this._last;
                    t1.toString;
                    cell._previous = t1;
                    _this._last = t1._next = cell;
                }
                ++_this.__js_helper$_length;
                _this._modified$0();
                return cell;
            },
            __js_helper$_unlinkCell$1: function(cell) {
                var _this = this, previous = cell._previous, next = cell._next;
                if (previous == null) _this._first = next;
                else previous._next = next;
                if (next == null) _this._last = previous;
                else next._previous = previous;
                --_this.__js_helper$_length;
                _this._modified$0();
            },
            internalComputeHashCode$1: function(key) {
                return J.get$hashCode$(key) & 1073741823;
            },
            internalFindBucketIndex$2: function(bucket, key) {
                var $length, i;
                if (bucket == null) return -1;
                $length = bucket.length;
                for(i = 0; i < $length; ++i)if (J.$eq$(bucket[i].hashMapCellKey, key)) return i;
                return -1;
            },
            toString$0: function(_) {
                return A.MapBase_mapToString(this);
            },
            _newHashTable$0: function() {
                var table = Object.create(null);
                table["<non-identifier-key>"] = table;
                delete table["<non-identifier-key>"];
                return table;
            }
        };
        A.JsLinkedHashMap_addAll_closure.prototype = {
            call$2: function(key, value) {
                this.$this.$indexSet(0, key, value);
            },
            $signature: function() {
                return A._instanceType(this.$this)._eval$1("~(1,2)");
            }
        };
        A.LinkedHashMapCell.prototype = {};
        A.LinkedHashMapKeysIterable.prototype = {
            get$length: function(_) {
                return this.__js_helper$_map.__js_helper$_length;
            },
            get$isEmpty: function(_) {
                return this.__js_helper$_map.__js_helper$_length === 0;
            },
            get$iterator: function(_) {
                var t1 = this.__js_helper$_map;
                return new A.LinkedHashMapKeyIterator(t1, t1._modifications, t1._first);
            },
            contains$1: function(_, element) {
                return this.__js_helper$_map.containsKey$1(element);
            }
        };
        A.LinkedHashMapKeyIterator.prototype = {
            get$current: function(_) {
                return this.__js_helper$_current;
            },
            moveNext$0: function() {
                var cell, _this = this, t1 = _this.__js_helper$_map;
                if (_this._modifications !== t1._modifications) throw A.wrapException(A.ConcurrentModificationError$(t1));
                cell = _this._cell;
                if (cell == null) {
                    _this.__js_helper$_current = null;
                    return false;
                } else {
                    _this.__js_helper$_current = cell.hashMapCellKey;
                    _this._cell = cell._next;
                    return true;
                }
            }
        };
        A.LinkedHashMapValuesIterable.prototype = {
            get$length: function(_) {
                return this.__js_helper$_map.__js_helper$_length;
            },
            get$isEmpty: function(_) {
                return this.__js_helper$_map.__js_helper$_length === 0;
            },
            get$iterator: function(_) {
                var t1 = this.__js_helper$_map;
                return new A.LinkedHashMapValueIterator(t1, t1._modifications, t1._first);
            }
        };
        A.LinkedHashMapValueIterator.prototype = {
            get$current: function(_) {
                return this.__js_helper$_current;
            },
            moveNext$0: function() {
                var cell, _this = this, t1 = _this.__js_helper$_map;
                if (_this._modifications !== t1._modifications) throw A.wrapException(A.ConcurrentModificationError$(t1));
                cell = _this._cell;
                if (cell == null) {
                    _this.__js_helper$_current = null;
                    return false;
                } else {
                    _this.__js_helper$_current = cell.hashMapCellValue;
                    _this._cell = cell._next;
                    return true;
                }
            }
        };
        A.LinkedHashMapEntriesIterable.prototype = {
            get$length: function(_) {
                return this.__js_helper$_map.__js_helper$_length;
            },
            get$isEmpty: function(_) {
                return this.__js_helper$_map.__js_helper$_length === 0;
            },
            get$iterator: function(_) {
                var t1 = this.__js_helper$_map;
                return new A.LinkedHashMapEntryIterator(t1, t1._modifications, t1._first, this.$ti._eval$1("LinkedHashMapEntryIterator<1,2>"));
            }
        };
        A.LinkedHashMapEntryIterator.prototype = {
            get$current: function(_) {
                var t1 = this.__js_helper$_current;
                t1.toString;
                return t1;
            },
            moveNext$0: function() {
                var cell, _this = this, t1 = _this.__js_helper$_map;
                if (_this._modifications !== t1._modifications) throw A.wrapException(A.ConcurrentModificationError$(t1));
                cell = _this._cell;
                if (cell == null) {
                    _this.__js_helper$_current = null;
                    return false;
                } else {
                    _this.__js_helper$_current = new A.MapEntry(cell.hashMapCellKey, cell.hashMapCellValue, _this.$ti._eval$1("MapEntry<1,2>"));
                    _this._cell = cell._next;
                    return true;
                }
            }
        };
        A.JsIdentityLinkedHashMap.prototype = {
            internalComputeHashCode$1: function(key) {
                return A.objectHashCode(key) & 1073741823;
            },
            internalFindBucketIndex$2: function(bucket, key) {
                var $length, i, t1;
                if (bucket == null) return -1;
                $length = bucket.length;
                for(i = 0; i < $length; ++i){
                    t1 = bucket[i].hashMapCellKey;
                    if (t1 == null ? key == null : t1 === key) return i;
                }
                return -1;
            }
        };
        A.JsConstantLinkedHashMap.prototype = {
            internalComputeHashCode$1: function(key) {
                return A.constantHashCode(key) & 1073741823;
            },
            internalFindBucketIndex$2: function(bucket, key) {
                var $length, i;
                if (bucket == null) return -1;
                $length = bucket.length;
                for(i = 0; i < $length; ++i)if (J.$eq$(bucket[i].hashMapCellKey, key)) return i;
                return -1;
            }
        };
        A.initHooks_closure.prototype = {
            call$1: function(o) {
                return this.getTag(o);
            },
            $signature: 108
        };
        A.initHooks_closure0.prototype = {
            call$2: function(o, tag) {
                return this.getUnknownTag(o, tag);
            },
            $signature: 339
        };
        A.initHooks_closure1.prototype = {
            call$1: function(tag) {
                return this.prototypeForTag(tag);
            },
            $signature: 186
        };
        A._Record.prototype = {
            toString$0: function(_) {
                return this._toString$1(false);
            },
            _toString$1: function(safe) {
                var t2, separator, i, key, value, keys = this._fieldKeys$0(), values = this._getFieldValues$0(), t1 = (safe ? "Record " : "") + "(";
                for(t2 = keys.length, separator = "", i = 0; i < t2; ++i, separator = ", "){
                    t1 += separator;
                    key = keys[i];
                    if (typeof key == "string") t1 = t1 + key + ": ";
                    value = values[i];
                    t1 = safe ? t1 + A.Primitives_safeToString(value) : t1 + A.S(value);
                }
                t1 += ")";
                return t1.charCodeAt(0) == 0 ? t1 : t1;
            },
            _fieldKeys$0: function() {
                var t1, shapeTag = this.$shape;
                while($._Record__computedFieldKeys.length <= shapeTag)$._Record__computedFieldKeys.push(null);
                t1 = $._Record__computedFieldKeys[shapeTag];
                if (t1 == null) {
                    t1 = this._computeFieldKeys$0();
                    $._Record__computedFieldKeys[shapeTag] = t1;
                }
                return t1;
            },
            _computeFieldKeys$0: function() {
                var i, names, last, recipe = this.$recipe, position = recipe.indexOf("("), joinedNames = recipe.substring(1, position), fields = recipe.substring(position), arity = fields === "()" ? 0 : fields.replace(/[^,]/g, "").length + 1, t1 = type$.Object, result = J.JSArray_JSArray$allocateGrowable(arity, t1);
                for(i = 0; i < arity; ++i)result[i] = i;
                if (joinedNames !== "") {
                    names = joinedNames.split(",");
                    i = names.length;
                    for(last = arity; i > 0;){
                        --last;
                        --i;
                        result[last] = names[i];
                    }
                }
                return A.List_List$unmodifiable(result, t1);
            }
        };
        A._Record2.prototype = {
            _getFieldValues$0: function() {
                return [
                    this._0,
                    this._1
                ];
            },
            $eq: function(_, other) {
                if (other == null) return false;
                return other instanceof A._Record2 && this.$shape === other.$shape && J.$eq$(this._0, other._0) && J.$eq$(this._1, other._1);
            },
            get$hashCode: function(_) {
                return A.Object_hash(this.$shape, this._0, this._1, B.C_SentinelValue);
            }
        };
        A._Record1.prototype = {
            _getFieldValues$0: function() {
                return [
                    this._0
                ];
            },
            $eq: function(_, other) {
                if (other == null) return false;
                return other instanceof A._Record1 && this.$shape === other.$shape && J.$eq$(this._0, other._0);
            },
            get$hashCode: function(_) {
                return A.Object_hash(this.$shape, this._0, B.C_SentinelValue, B.C_SentinelValue);
            }
        };
        A._Record3.prototype = {
            _getFieldValues$0: function() {
                return [
                    this._0,
                    this._1,
                    this._2
                ];
            },
            $eq: function(_, other) {
                var _this = this;
                if (other == null) return false;
                return other instanceof A._Record3 && _this.$shape === other.$shape && J.$eq$(_this._0, other._0) && J.$eq$(_this._1, other._1) && J.$eq$(_this._2, other._2);
            },
            get$hashCode: function(_) {
                var _this = this;
                return A.Object_hash(_this.$shape, _this._0, _this._1, _this._2);
            }
        };
        A._RecordN.prototype = {
            _getFieldValues$0: function() {
                return this._values;
            },
            $eq: function(_, other) {
                if (other == null) return false;
                return other instanceof A._RecordN && this.$shape === other.$shape && A._RecordN__equalValues(this._values, other._values);
            },
            get$hashCode: function(_) {
                return A.Object_hash(this.$shape, A.Object_hashAll(this._values), B.C_SentinelValue, B.C_SentinelValue);
            }
        };
        A.JSSyntaxRegExp.prototype = {
            toString$0: function(_) {
                return "RegExp/" + this.pattern + "/" + this._nativeRegExp.flags;
            },
            get$_nativeGlobalVersion: function() {
                var _this = this, t1 = _this._nativeGlobalRegExp;
                if (t1 != null) return t1;
                t1 = _this._nativeRegExp;
                return _this._nativeGlobalRegExp = A.JSSyntaxRegExp_makeNative(_this.pattern, t1.multiline, !t1.ignoreCase, t1.unicode, t1.dotAll, "g");
            },
            get$_nativeAnchoredVersion: function() {
                var _this = this, t1 = _this._nativeAnchoredRegExp;
                if (t1 != null) return t1;
                t1 = _this._nativeRegExp;
                return _this._nativeAnchoredRegExp = A.JSSyntaxRegExp_makeNative(_this.pattern, t1.multiline, !t1.ignoreCase, t1.unicode, t1.dotAll, "y");
            },
            _computeHasCaptures$0: function() {
                var t2, t1 = this.pattern;
                if (!B.JSString_methods.contains$1(t1, "(")) return false;
                t2 = this._nativeRegExp.unicode ? "u" : "";
                return new RegExp("(?:)|" + t1, t2).exec("").length > 1;
            },
            firstMatch$1: function(string) {
                var m = this._nativeRegExp.exec(string);
                if (m == null) return null;
                return new A._MatchImplementation(m);
            },
            allMatches$2: function(_, string, start) {
                var t1 = string.length;
                if (start > t1) throw A.wrapException(A.RangeError$range(start, 0, t1, null, null));
                return new A._AllMatchesIterable(this, string, start);
            },
            allMatches$1: function(_, string) {
                return this.allMatches$2(0, string, 0);
            },
            _execGlobal$2: function(string, start) {
                var match, regexp = this.get$_nativeGlobalVersion();
                regexp.lastIndex = start;
                match = regexp.exec(string);
                if (match == null) return null;
                return new A._MatchImplementation(match);
            },
            _execAnchored$2: function(string, start) {
                var match, regexp = this.get$_nativeAnchoredVersion();
                regexp.lastIndex = start;
                match = regexp.exec(string);
                if (match == null) return null;
                return new A._MatchImplementation(match);
            },
            matchAsPrefix$2: function(_, string, start) {
                if (start < 0 || start > string.length) throw A.wrapException(A.RangeError$range(start, 0, string.length, null, null));
                return this._execAnchored$2(string, start);
            }
        };
        A._MatchImplementation.prototype = {
            get$start: function(_) {
                return this._match.index;
            },
            get$end: function(_) {
                var t1 = this._match;
                return t1.index + t1[0].length;
            },
            namedGroup$1: function($name) {
                var result, groups = this._match.groups;
                if (groups != null) {
                    result = groups[$name];
                    if (result != null || $name in groups) return result;
                }
                throw A.wrapException(A.ArgumentError$value($name, "name", "Not a capture group name"));
            },
            $isMatch: 1,
            $isRegExpMatch: 1
        };
        A._AllMatchesIterable.prototype = {
            get$iterator: function(_) {
                return new A._AllMatchesIterator(this._re, this.__js_helper$_string, this.__js_helper$_start);
            }
        };
        A._AllMatchesIterator.prototype = {
            get$current: function(_) {
                var t1 = this.__js_helper$_current;
                return t1 == null ? type$.RegExpMatch._as(t1) : t1;
            },
            moveNext$0: function() {
                var t1, t2, t3, match, nextIndex, t4, _this = this, string = _this.__js_helper$_string;
                if (string == null) return false;
                t1 = _this._nextIndex;
                t2 = string.length;
                if (t1 <= t2) {
                    t3 = _this._regExp;
                    match = t3._execGlobal$2(string, t1);
                    if (match != null) {
                        _this.__js_helper$_current = match;
                        nextIndex = match.get$end(0);
                        if (match._match.index === nextIndex) {
                            t1 = false;
                            if (t3._nativeRegExp.unicode) {
                                t3 = _this._nextIndex;
                                t4 = t3 + 1;
                                if (t4 < t2) {
                                    t2 = string.charCodeAt(t3);
                                    if (t2 >= 55296 && t2 <= 56319) {
                                        t1 = string.charCodeAt(t4);
                                        t1 = t1 >= 56320 && t1 <= 57343;
                                    }
                                }
                            }
                            nextIndex = (t1 ? nextIndex + 1 : nextIndex) + 1;
                        }
                        _this._nextIndex = nextIndex;
                        return true;
                    }
                }
                _this.__js_helper$_string = _this.__js_helper$_current = null;
                return false;
            }
        };
        A.StringMatch.prototype = {
            get$end: function(_) {
                return this.start + this.pattern.length;
            },
            $isMatch: 1,
            get$start: function(receiver) {
                return this.start;
            }
        };
        A._StringAllMatchesIterable.prototype = {
            get$iterator: function(_) {
                return new A._StringAllMatchesIterator(this._input, this._pattern, this.__js_helper$_index);
            },
            get$first: function(_) {
                var t1 = this._pattern, index = this._input.indexOf(t1, this.__js_helper$_index);
                if (index >= 0) return new A.StringMatch(index, t1);
                throw A.wrapException(A.IterableElementError_noElement());
            }
        };
        A._StringAllMatchesIterator.prototype = {
            moveNext$0: function() {
                var index, end, _this = this, t1 = _this.__js_helper$_index, t2 = _this._pattern, t3 = t2.length, t4 = _this._input, t5 = t4.length;
                if (t1 + t3 > t5) {
                    _this.__js_helper$_current = null;
                    return false;
                }
                index = t4.indexOf(t2, t1);
                if (index < 0) {
                    _this.__js_helper$_index = t5 + 1;
                    _this.__js_helper$_current = null;
                    return false;
                }
                end = index + t3;
                _this.__js_helper$_current = new A.StringMatch(index, t2);
                _this.__js_helper$_index = end === _this.__js_helper$_index ? end + 1 : end;
                return true;
            },
            get$current: function(_) {
                var t1 = this.__js_helper$_current;
                t1.toString;
                return t1;
            }
        };
        A._Cell.prototype = {
            readLocal$1$0: function() {
                var t1 = this.__late_helper$_value;
                if (t1 === this) A.throwExpression(new A.LateError("Local '' has not been initialized."));
                return t1;
            },
            readLocal$0: function() {
                return this.readLocal$1$0(type$.dynamic);
            },
            _readLocal$0: function() {
                var t1 = this.__late_helper$_value;
                if (t1 === this) throw A.wrapException(new A.LateError("Local '' has not been initialized."));
                return t1;
            }
        };
        A.NativeByteBuffer.prototype = {
            get$runtimeType: function(receiver) {
                return B.Type_ByteBuffer_rqD;
            },
            $isTrustedGetRuntimeType: 1,
            $isByteBuffer: 1
        };
        A.NativeTypedData.prototype = {
            _invalidPosition$3: function(receiver, position, $length, $name) {
                var t1 = A.RangeError$range(position, 0, $length, $name, null);
                throw A.wrapException(t1);
            },
            _checkPosition$3: function(receiver, position, $length, $name) {
                if (position >>> 0 !== position || position > $length) this._invalidPosition$3(receiver, position, $length, $name);
            }
        };
        A.NativeByteData.prototype = {
            get$runtimeType: function(receiver) {
                return B.Type_ByteData_9dB;
            },
            $isTrustedGetRuntimeType: 1,
            $isByteData: 1
        };
        A.NativeTypedArray.prototype = {
            get$length: function(receiver) {
                return receiver.length;
            },
            _setRangeFast$4: function(receiver, start, end, source, skipCount) {
                var count, sourceLength, targetLength = receiver.length;
                this._checkPosition$3(receiver, start, targetLength, "start");
                this._checkPosition$3(receiver, end, targetLength, "end");
                if (start > end) throw A.wrapException(A.RangeError$range(start, 0, end, null, null));
                count = end - start;
                if (skipCount < 0) throw A.wrapException(A.ArgumentError$(skipCount, null));
                sourceLength = source.length;
                if (sourceLength - skipCount < count) throw A.wrapException(A.StateError$("Not enough elements"));
                if (skipCount !== 0 || sourceLength !== count) source = source.subarray(skipCount, skipCount + count);
                receiver.set(source, start);
            },
            $isJavaScriptIndexingBehavior: 1
        };
        A.NativeTypedArrayOfDouble.prototype = {
            $index: function(receiver, index) {
                A._checkValidIndex(index, receiver, receiver.length);
                return receiver[index];
            },
            $indexSet: function(receiver, index, value) {
                receiver.$flags & 2 && A.throwUnsupportedOperation(receiver);
                A._checkValidIndex(index, receiver, receiver.length);
                receiver[index] = value;
            },
            setRange$4: function(receiver, start, end, iterable, skipCount) {
                receiver.$flags & 2 && A.throwUnsupportedOperation(receiver, 5);
                if (type$.NativeTypedArrayOfDouble._is(iterable)) {
                    this._setRangeFast$4(receiver, start, end, iterable, skipCount);
                    return;
                }
                this.super$ListBase$setRange(receiver, start, end, iterable, skipCount);
            },
            $isEfficientLengthIterable: 1,
            $isIterable: 1,
            $isList: 1
        };
        A.NativeTypedArrayOfInt.prototype = {
            $indexSet: function(receiver, index, value) {
                receiver.$flags & 2 && A.throwUnsupportedOperation(receiver);
                A._checkValidIndex(index, receiver, receiver.length);
                receiver[index] = value;
            },
            setRange$4: function(receiver, start, end, iterable, skipCount) {
                receiver.$flags & 2 && A.throwUnsupportedOperation(receiver, 5);
                if (type$.NativeTypedArrayOfInt._is(iterable)) {
                    this._setRangeFast$4(receiver, start, end, iterable, skipCount);
                    return;
                }
                this.super$ListBase$setRange(receiver, start, end, iterable, skipCount);
            },
            $isEfficientLengthIterable: 1,
            $isIterable: 1,
            $isList: 1
        };
        A.NativeFloat32List.prototype = {
            get$runtimeType: function(receiver) {
                return B.Type_Float32List_9Kz;
            },
            sublist$2: function(receiver, start, end) {
                return new Float32Array(receiver.subarray(start, A._checkValidRange(start, end, receiver.length)));
            },
            sublist$1: function(receiver, start) {
                return this.sublist$2(receiver, start, null);
            },
            $isTrustedGetRuntimeType: 1,
            $isFloat32List: 1
        };
        A.NativeFloat64List.prototype = {
            get$runtimeType: function(receiver) {
                return B.Type_Float64List_9Kz;
            },
            sublist$2: function(receiver, start, end) {
                return new Float64Array(receiver.subarray(start, A._checkValidRange(start, end, receiver.length)));
            },
            sublist$1: function(receiver, start) {
                return this.sublist$2(receiver, start, null);
            },
            $isTrustedGetRuntimeType: 1,
            $isFloat64List: 1
        };
        A.NativeInt16List.prototype = {
            get$runtimeType: function(receiver) {
                return B.Type_Int16List_s5h;
            },
            $index: function(receiver, index) {
                A._checkValidIndex(index, receiver, receiver.length);
                return receiver[index];
            },
            sublist$2: function(receiver, start, end) {
                return new Int16Array(receiver.subarray(start, A._checkValidRange(start, end, receiver.length)));
            },
            sublist$1: function(receiver, start) {
                return this.sublist$2(receiver, start, null);
            },
            $isTrustedGetRuntimeType: 1,
            $isInt16List: 1
        };
        A.NativeInt32List.prototype = {
            get$runtimeType: function(receiver) {
                return B.Type_Int32List_O8Z;
            },
            $index: function(receiver, index) {
                A._checkValidIndex(index, receiver, receiver.length);
                return receiver[index];
            },
            sublist$2: function(receiver, start, end) {
                return new Int32Array(receiver.subarray(start, A._checkValidRange(start, end, receiver.length)));
            },
            sublist$1: function(receiver, start) {
                return this.sublist$2(receiver, start, null);
            },
            $isTrustedGetRuntimeType: 1,
            $isInt32List: 1
        };
        A.NativeInt8List.prototype = {
            get$runtimeType: function(receiver) {
                return B.Type_Int8List_rFV;
            },
            $index: function(receiver, index) {
                A._checkValidIndex(index, receiver, receiver.length);
                return receiver[index];
            },
            sublist$2: function(receiver, start, end) {
                return new Int8Array(receiver.subarray(start, A._checkValidRange(start, end, receiver.length)));
            },
            sublist$1: function(receiver, start) {
                return this.sublist$2(receiver, start, null);
            },
            $isTrustedGetRuntimeType: 1,
            $isInt8List: 1
        };
        A.NativeUint16List.prototype = {
            get$runtimeType: function(receiver) {
                return B.Type_Uint16List_kmP;
            },
            $index: function(receiver, index) {
                A._checkValidIndex(index, receiver, receiver.length);
                return receiver[index];
            },
            sublist$2: function(receiver, start, end) {
                return new Uint16Array(receiver.subarray(start, A._checkValidRange(start, end, receiver.length)));
            },
            sublist$1: function(receiver, start) {
                return this.sublist$2(receiver, start, null);
            },
            $isTrustedGetRuntimeType: 1,
            $isUint16List: 1
        };
        A.NativeUint32List.prototype = {
            get$runtimeType: function(receiver) {
                return B.Type_Uint32List_kmP;
            },
            $index: function(receiver, index) {
                A._checkValidIndex(index, receiver, receiver.length);
                return receiver[index];
            },
            sublist$2: function(receiver, start, end) {
                return new Uint32Array(receiver.subarray(start, A._checkValidRange(start, end, receiver.length)));
            },
            sublist$1: function(receiver, start) {
                return this.sublist$2(receiver, start, null);
            },
            $isTrustedGetRuntimeType: 1,
            $isUint32List: 1
        };
        A.NativeUint8ClampedList.prototype = {
            get$runtimeType: function(receiver) {
                return B.Type_Uint8ClampedList_04U;
            },
            get$length: function(receiver) {
                return receiver.length;
            },
            $index: function(receiver, index) {
                A._checkValidIndex(index, receiver, receiver.length);
                return receiver[index];
            },
            sublist$2: function(receiver, start, end) {
                return new Uint8ClampedArray(receiver.subarray(start, A._checkValidRange(start, end, receiver.length)));
            },
            sublist$1: function(receiver, start) {
                return this.sublist$2(receiver, start, null);
            },
            $isTrustedGetRuntimeType: 1,
            $isUint8ClampedList: 1
        };
        A.NativeUint8List.prototype = {
            get$runtimeType: function(receiver) {
                return B.Type_Uint8List_8Eb;
            },
            get$length: function(receiver) {
                return receiver.length;
            },
            $index: function(receiver, index) {
                A._checkValidIndex(index, receiver, receiver.length);
                return receiver[index];
            },
            sublist$2: function(receiver, start, end) {
                return new Uint8Array(receiver.subarray(start, A._checkValidRange(start, end, receiver.length)));
            },
            sublist$1: function(receiver, start) {
                return this.sublist$2(receiver, start, null);
            },
            $isTrustedGetRuntimeType: 1,
            $isNativeUint8List: 1,
            $isUint8List: 1
        };
        A._NativeTypedArrayOfDouble_NativeTypedArray_ListMixin.prototype = {};
        A._NativeTypedArrayOfDouble_NativeTypedArray_ListMixin_FixedLengthListMixin.prototype = {};
        A._NativeTypedArrayOfInt_NativeTypedArray_ListMixin.prototype = {};
        A._NativeTypedArrayOfInt_NativeTypedArray_ListMixin_FixedLengthListMixin.prototype = {};
        A.Rti.prototype = {
            _eval$1: function(recipe) {
                return A._Universe_evalInEnvironment(init.typeUniverse, this, recipe);
            },
            _bind$1: function(typeOrTuple) {
                return A._Universe_bind(init.typeUniverse, this, typeOrTuple);
            }
        };
        A._FunctionParameters.prototype = {};
        A._Type.prototype = {
            toString$0: function(_) {
                return A._rtiToString(this._rti, null);
            }
        };
        A._Error.prototype = {
            toString$0: function(_) {
                return this.__rti$_message;
            }
        };
        A._TypeError.prototype = {
            get$message: function(_) {
                return this.__rti$_message;
            },
            $isTypeError: 1
        };
        A._AsyncRun__initializeScheduleImmediate_internalCallback.prototype = {
            call$1: function(__wc0_formal) {
                var t1 = this._box_0, f = t1.storedCallback;
                t1.storedCallback = null;
                f.call$0();
            },
            $signature: 62
        };
        A._AsyncRun__initializeScheduleImmediate_closure.prototype = {
            call$1: function(callback) {
                var t1, t2;
                this._box_0.storedCallback = callback;
                t1 = this.div;
                t2 = this.span;
                t1.firstChild ? t1.removeChild(t2) : t1.appendChild(t2);
            },
            $signature: 35
        };
        A._AsyncRun__scheduleImmediateJsOverride_internalCallback.prototype = {
            call$0: function() {
                this.callback.call$0();
            },
            $signature: 1
        };
        A._AsyncRun__scheduleImmediateWithSetImmediate_internalCallback.prototype = {
            call$0: function() {
                this.callback.call$0();
            },
            $signature: 1
        };
        A._TimerImpl.prototype = {
            _TimerImpl$2: function(milliseconds, callback) {
                if (self.setTimeout != null) this._handle = self.setTimeout(A.convertDartClosureToJS(new A._TimerImpl_internalCallback(this, callback), 0), milliseconds);
                else throw A.wrapException(A.UnsupportedError$("`setTimeout()` not found."));
            },
            _TimerImpl$periodic$2: function(milliseconds, callback) {
                if (self.setTimeout != null) this._handle = self.setInterval(A.convertDartClosureToJS(new A._TimerImpl$periodic_closure(this, milliseconds, Date.now(), callback), 0), milliseconds);
                else throw A.wrapException(A.UnsupportedError$("Periodic timer."));
            },
            cancel$0: function() {
                if (self.setTimeout != null) {
                    var t1 = this._handle;
                    if (t1 == null) return;
                    if (this._once) self.clearTimeout(t1);
                    else self.clearInterval(t1);
                    this._handle = null;
                } else throw A.wrapException(A.UnsupportedError$("Canceling a timer."));
            }
        };
        A._TimerImpl_internalCallback.prototype = {
            call$0: function() {
                var t1 = this.$this;
                t1._handle = null;
                t1._tick = 1;
                this.callback.call$0();
            },
            $signature: 0
        };
        A._TimerImpl$periodic_closure.prototype = {
            call$0: function() {
                var duration, _this = this, t1 = _this.$this, tick = t1._tick + 1, t2 = _this.milliseconds;
                if (t2 > 0) {
                    duration = Date.now() - _this.start;
                    if (duration > (tick + 1) * t2) tick = B.JSInt_methods.$tdiv(duration, t2);
                }
                t1._tick = tick;
                _this.callback.call$1(t1);
            },
            $signature: 1
        };
        A._AsyncAwaitCompleter.prototype = {
            complete$1: function(value) {
                var t1, _this = this;
                if (value == null) value = _this.$ti._precomputed1._as(value);
                if (!_this.isSync) _this._future._asyncComplete$1(value);
                else {
                    t1 = _this._future;
                    if (_this.$ti._eval$1("Future<1>")._is(value)) t1._chainFuture$1(value);
                    else t1._completeWithValue$1(value);
                }
            },
            completeError$2: function(e, st) {
                var t1 = this._future;
                if (this.isSync) t1._completeErrorObject$1(new A.AsyncError(e, st));
                else t1._asyncCompleteErrorObject$1(new A.AsyncError(e, st));
            }
        };
        A._awaitOnObject_closure.prototype = {
            call$1: function(result) {
                return this.bodyFunction.call$2(0, result);
            },
            $signature: 71
        };
        A._awaitOnObject_closure0.prototype = {
            call$2: function(error, stackTrace) {
                this.bodyFunction.call$2(1, new A.ExceptionAndStackTrace(error, stackTrace));
            },
            $signature: 394
        };
        A._wrapJsFunctionForAsync_closure.prototype = {
            call$2: function(errorCode, result) {
                this.$protected(errorCode, result);
            },
            $signature: 357
        };
        A._SyncStarIterator.prototype = {
            get$current: function(_) {
                return this._async$_current;
            },
            _resumeBody$2: function(errorCode, errorValue) {
                var body, t1, _$exception;
                errorCode;
                errorValue;
                body = this._body;
                for(;;)try {
                    t1 = body(this, errorCode, errorValue);
                    return t1;
                } catch (exception) {
                    errorValue = exception;
                    errorCode = 1;
                }
            },
            moveNext$0: function() {
                var nestedIterator, t1, _$exception, value, suspendedBodies, _this = this, errorValue = null, errorCode = 0;
                for(;;){
                    nestedIterator = _this._nestedIterator;
                    if (nestedIterator != null) try {
                        if (nestedIterator.moveNext$0()) {
                            t1 = nestedIterator;
                            _this._async$_current = t1.get$current(t1);
                            return true;
                        } else _this._nestedIterator = null;
                    } catch (exception) {
                        errorValue = exception;
                        errorCode = 1;
                        _this._nestedIterator = null;
                    }
                    value = _this._resumeBody$2(errorCode, errorValue);
                    if (1 === value) return true;
                    if (0 === value) {
                        _this._async$_current = null;
                        suspendedBodies = _this._suspendedBodies;
                        if (suspendedBodies == null || suspendedBodies.length === 0) {
                            _this._body = A._SyncStarIterator__terminatedBody;
                            return false;
                        }
                        _this._body = suspendedBodies.pop();
                        errorCode = 0;
                        errorValue = null;
                        continue;
                    }
                    if (2 === value) {
                        errorCode = 0;
                        errorValue = null;
                        continue;
                    }
                    if (3 === value) {
                        errorValue = _this._datum;
                        _this._datum = null;
                        suspendedBodies = _this._suspendedBodies;
                        if (suspendedBodies == null || suspendedBodies.length === 0) {
                            _this._async$_current = null;
                            _this._body = A._SyncStarIterator__terminatedBody;
                            throw errorValue;
                        }
                        _this._body = suspendedBodies.pop();
                        errorCode = 1;
                        continue;
                    }
                    throw A.wrapException(A.StateError$("sync*"));
                }
                return false;
            },
            _yieldStar$1: function(iterable) {
                var t1, t2, _this = this;
                if (iterable instanceof A._SyncStarIterable) {
                    t1 = iterable._outerHelper();
                    t2 = _this._suspendedBodies;
                    if (t2 == null) t2 = _this._suspendedBodies = [];
                    t2.push(_this._body);
                    _this._body = t1;
                    return 2;
                } else {
                    _this._nestedIterator = J.get$iterator$ax(iterable);
                    return 2;
                }
            }
        };
        A._SyncStarIterable.prototype = {
            get$iterator: function(_) {
                return new A._SyncStarIterator(this._outerHelper());
            }
        };
        A.AsyncError.prototype = {
            toString$0: function(_) {
                return A.S(this.error);
            },
            $isError: 1,
            get$stackTrace: function() {
                return this.stackTrace;
            }
        };
        A.Future_wait_handleError.prototype = {
            call$2: function(theError, theStackTrace) {
                var _this = this, t1 = _this._box_0, t2 = --t1.remaining;
                if (t1.values != null) {
                    t1.values = null;
                    t1.error = theError;
                    t1.stackTrace = theStackTrace;
                    if (t2 === 0 || _this.eagerError) _this._future._completeErrorObject$1(new A.AsyncError(theError, theStackTrace));
                } else if (t2 === 0 && !_this.eagerError) {
                    t2 = t1.error;
                    t2.toString;
                    t1 = t1.stackTrace;
                    t1.toString;
                    _this._future._completeErrorObject$1(new A.AsyncError(t2, t1));
                }
            },
            $signature: 70
        };
        A.Future_wait_closure.prototype = {
            call$1: function(value) {
                var t1, value0, t3, t4, _i, t5, _this = this, t2 = _this._box_0, remainingResults = --t2.remaining, valueList = t2.values;
                if (valueList != null) {
                    J.$indexSet$ax(valueList, _this.pos, value);
                    if (J.$eq$(remainingResults, 0)) {
                        t2 = _this.T;
                        t1 = A._setArrayType([], t2._eval$1("JSArray<0>"));
                        for(t3 = valueList, t4 = t3.length, _i = 0; _i < t3.length; t3.length === t4 || (0, A.throwConcurrentModificationError)(t3), ++_i){
                            value0 = t3[_i];
                            t5 = value0;
                            if (t5 == null) t5 = t2._as(t5);
                            J.add$1$ax(t1, t5);
                        }
                        _this._future._completeWithValue$1(t1);
                    }
                } else if (J.$eq$(remainingResults, 0) && !_this.eagerError) {
                    t1 = t2.error;
                    t1.toString;
                    t2 = t2.stackTrace;
                    t2.toString;
                    _this._future._completeErrorObject$1(new A.AsyncError(t1, t2));
                }
            },
            $signature: function() {
                return this.T._eval$1("Null(0)");
            }
        };
        A._Completer.prototype = {
            completeError$2: function(error, stackTrace) {
                if ((this.future._state & 30) !== 0) throw A.wrapException(A.StateError$("Future already completed"));
                this._completeErrorObject$1(A._interceptUserError(error, stackTrace));
            },
            completeError$1: function(error) {
                return this.completeError$2(error, null);
            }
        };
        A._AsyncCompleter.prototype = {
            complete$1: function(value) {
                var t1 = this.future;
                if ((t1._state & 30) !== 0) throw A.wrapException(A.StateError$("Future already completed"));
                t1._asyncComplete$1(value);
            },
            complete$0: function() {
                return this.complete$1(null);
            },
            _completeErrorObject$1: function(error) {
                this.future._asyncCompleteErrorObject$1(error);
            }
        };
        A._SyncCompleter.prototype = {
            complete$1: function(value) {
                var t1 = this.future;
                if ((t1._state & 30) !== 0) throw A.wrapException(A.StateError$("Future already completed"));
                t1._complete$1(value);
            },
            _completeErrorObject$1: function(error) {
                this.future._completeErrorObject$1(error);
            }
        };
        A._FutureListener.prototype = {
            matchesErrorTest$1: function(asyncError) {
                if ((this.state & 15) !== 6) return true;
                return this.result._zone.runUnary$2$2(this.callback, asyncError.error, type$.bool, type$.Object);
            },
            handleError$1: function(asyncError) {
                var _$exception, errorCallback = this.errorCallback, result = null, t1 = type$.dynamic, t2 = type$.Object, t3 = asyncError.error, t4 = this.result._zone;
                if (type$.dynamic_Function_Object_StackTrace._is(errorCallback)) result = t4.runBinary$3$3(errorCallback, t3, asyncError.stackTrace, t1, t2, type$.StackTrace);
                else result = t4.runUnary$2$2(errorCallback, t3, t1, t2);
                try {
                    t1 = result;
                    return t1;
                } catch (exception) {
                    if (type$.TypeError._is(A.unwrapException(exception))) {
                        if ((this.state & 1) !== 0) throw A.wrapException(A.ArgumentError$("The error handler of Future.then must return a value of the returned future's type", "onError"));
                        throw A.wrapException(A.ArgumentError$("The error handler of Future.catchError must return a value of the future's type", "onError"));
                    } else throw exception;
                }
            }
        };
        A._Future.prototype = {
            then$1$2$onError: function(_, f, onError, $R) {
                var result, t1, currentZone = $.Zone__current;
                if (currentZone === B.C__RootZone) {
                    if (onError != null && !type$.dynamic_Function_Object_StackTrace._is(onError) && !type$.dynamic_Function_Object._is(onError)) throw A.wrapException(A.ArgumentError$value(onError, "onError", string$.Error_));
                } else {
                    f = currentZone.registerUnaryCallback$2$1(f, $R._eval$1("0/"), this.$ti._precomputed1);
                    if (onError != null) onError = A._registerErrorHandler(onError, currentZone);
                }
                result = new A._Future($.Zone__current, $R._eval$1("_Future<0>"));
                t1 = onError == null ? 1 : 3;
                this._addListener$1(new A._FutureListener(result, t1, f, onError, this.$ti._eval$1("@<1>")._bind$1($R)._eval$1("_FutureListener<1,2>")));
                return result;
            },
            then$1$1: function(_, f, $R) {
                return this.then$1$2$onError(0, f, null, $R);
            },
            _thenAwait$1$2: function(f, onError, $E) {
                var result = new A._Future($.Zone__current, $E._eval$1("_Future<0>"));
                this._addListener$1(new A._FutureListener(result, 19, f, onError, this.$ti._eval$1("@<1>")._bind$1($E)._eval$1("_FutureListener<1,2>")));
                return result;
            },
            catchError$1: function(onError) {
                var t1 = this.$ti, t2 = $.Zone__current, result = new A._Future(t2, t1);
                if (t2 !== B.C__RootZone) onError = A._registerErrorHandler(onError, t2);
                this._addListener$1(new A._FutureListener(result, 2, null, onError, t1._eval$1("_FutureListener<1,1>")));
                return result;
            },
            whenComplete$1: function(action) {
                var t1 = this.$ti, t2 = $.Zone__current, result = new A._Future(t2, t1);
                if (t2 !== B.C__RootZone) action = t2.registerCallback$1$1(action, type$.dynamic);
                this._addListener$1(new A._FutureListener(result, 8, action, null, t1._eval$1("_FutureListener<1,1>")));
                return result;
            },
            _setErrorObject$1: function(error) {
                this._state = this._state & 1 | 16;
                this._resultOrListeners = error;
            },
            _cloneResult$1: function(source) {
                this._state = source._state & 30 | this._state & 1;
                this._resultOrListeners = source._resultOrListeners;
            },
            _addListener$1: function(listener) {
                var _this = this, t1 = _this._state;
                if (t1 <= 3) {
                    listener._nextListener = _this._resultOrListeners;
                    _this._resultOrListeners = listener;
                } else {
                    if ((t1 & 4) !== 0) {
                        t1 = _this._resultOrListeners;
                        if ((t1._state & 24) === 0) {
                            t1._addListener$1(listener);
                            return;
                        }
                        _this._cloneResult$1(t1);
                    }
                    _this._zone.scheduleMicrotask$1(new A._Future__addListener_closure(_this, listener));
                }
            },
            _prependListeners$1: function(listeners) {
                var t1, existingListeners, next, cursor, next0, _this = this, _box_0 = {};
                _box_0.listeners = listeners;
                if (listeners == null) return;
                t1 = _this._state;
                if (t1 <= 3) {
                    existingListeners = _this._resultOrListeners;
                    _this._resultOrListeners = listeners;
                    if (existingListeners != null) {
                        next = listeners._nextListener;
                        for(cursor = listeners; next != null; cursor = next, next = next0)next0 = next._nextListener;
                        cursor._nextListener = existingListeners;
                    }
                } else {
                    if ((t1 & 4) !== 0) {
                        t1 = _this._resultOrListeners;
                        if ((t1._state & 24) === 0) {
                            t1._prependListeners$1(listeners);
                            return;
                        }
                        _this._cloneResult$1(t1);
                    }
                    _box_0.listeners = _this._reverseListeners$1(listeners);
                    _this._zone.scheduleMicrotask$1(new A._Future__prependListeners_closure(_box_0, _this));
                }
            },
            _removeListeners$0: function() {
                var current = this._resultOrListeners;
                this._resultOrListeners = null;
                return this._reverseListeners$1(current);
            },
            _reverseListeners$1: function(listeners) {
                var current, prev, next;
                for(current = listeners, prev = null; current != null; prev = current, current = next){
                    next = current._nextListener;
                    current._nextListener = prev;
                }
                return prev;
            },
            _complete$1: function(value) {
                var listeners, _this = this;
                if (_this.$ti._eval$1("Future<1>")._is(value)) A._Future__chainCoreFuture(value, _this, true);
                else {
                    listeners = _this._removeListeners$0();
                    _this._state = 8;
                    _this._resultOrListeners = value;
                    A._Future__propagateToListeners(_this, listeners);
                }
            },
            _completeWithValue$1: function(value) {
                var _this = this, listeners = _this._removeListeners$0();
                _this._state = 8;
                _this._resultOrListeners = value;
                A._Future__propagateToListeners(_this, listeners);
            },
            _completeWithResultOf$1: function(source) {
                var t1, t2, listeners, _this = this;
                if ((source._state & 16) !== 0) {
                    t1 = _this._zone;
                    t2 = source._zone;
                    t1 = !(t1 === t2 || t1.get$errorZone() === t2.get$errorZone());
                } else t1 = false;
                if (t1) return;
                listeners = _this._removeListeners$0();
                _this._cloneResult$1(source);
                A._Future__propagateToListeners(_this, listeners);
            },
            _completeErrorObject$1: function(error) {
                var listeners = this._removeListeners$0();
                this._setErrorObject$1(error);
                A._Future__propagateToListeners(this, listeners);
            },
            _completeError$2: function(error, stackTrace) {
                this._completeErrorObject$1(new A.AsyncError(error, stackTrace));
            },
            _asyncComplete$1: function(value) {
                if (this.$ti._eval$1("Future<1>")._is(value)) {
                    this._chainFuture$1(value);
                    return;
                }
                this._asyncCompleteWithValue$1(value);
            },
            _asyncCompleteWithValue$1: function(value) {
                this._state ^= 2;
                this._zone.scheduleMicrotask$1(new A._Future__asyncCompleteWithValue_closure(this, value));
            },
            _chainFuture$1: function(value) {
                A._Future__chainCoreFuture(value, this, false);
                return;
            },
            _asyncCompleteErrorObject$1: function(error) {
                this._state ^= 2;
                this._zone.scheduleMicrotask$1(new A._Future__asyncCompleteErrorObject_closure(this, error));
            },
            $isFuture: 1
        };
        A._Future__addListener_closure.prototype = {
            call$0: function() {
                A._Future__propagateToListeners(this.$this, this.listener);
            },
            $signature: 0
        };
        A._Future__prependListeners_closure.prototype = {
            call$0: function() {
                A._Future__propagateToListeners(this.$this, this._box_0.listeners);
            },
            $signature: 0
        };
        A._Future__chainCoreFuture_closure.prototype = {
            call$0: function() {
                A._Future__chainCoreFuture(this._box_0.source, this.target, true);
            },
            $signature: 0
        };
        A._Future__asyncCompleteWithValue_closure.prototype = {
            call$0: function() {
                this.$this._completeWithValue$1(this.value);
            },
            $signature: 0
        };
        A._Future__asyncCompleteErrorObject_closure.prototype = {
            call$0: function() {
                this.$this._completeErrorObject$1(this.error);
            },
            $signature: 0
        };
        A._Future__propagateToListeners_handleWhenCompleteCallback.prototype = {
            call$0: function() {
                var e, s, t1, _$exception, t2, t3, originalSource, joinedResult, _this = this, completeResult = null;
                try {
                    t1 = _this._box_0.listener;
                    completeResult = t1.result._zone.run$1$1(0, t1.callback, type$.dynamic);
                } catch (exception) {
                    e = A.unwrapException(exception);
                    s = A.getTraceFromException(exception);
                    if (_this.hasError && _this._box_1.source._resultOrListeners.error === e) {
                        t1 = _this._box_0;
                        t1.listenerValueOrError = _this._box_1.source._resultOrListeners;
                    } else {
                        t1 = e;
                        t2 = s;
                        if (t2 == null) t2 = A.AsyncError_defaultStackTrace(t1);
                        t3 = _this._box_0;
                        t3.listenerValueOrError = new A.AsyncError(t1, t2);
                        t1 = t3;
                    }
                    t1.listenerHasError = true;
                    return;
                }
                if (completeResult instanceof A._Future && (completeResult._state & 24) !== 0) {
                    if ((completeResult._state & 16) !== 0) {
                        t1 = _this._box_0;
                        t1.listenerValueOrError = completeResult._resultOrListeners;
                        t1.listenerHasError = true;
                    }
                    return;
                }
                if (completeResult instanceof A._Future) {
                    originalSource = _this._box_1.source;
                    joinedResult = new A._Future(originalSource._zone, originalSource.$ti);
                    completeResult.then$1$2$onError(0, new A._Future__propagateToListeners_handleWhenCompleteCallback_closure(joinedResult, originalSource), new A._Future__propagateToListeners_handleWhenCompleteCallback_closure0(joinedResult), type$.void);
                    t1 = _this._box_0;
                    t1.listenerValueOrError = joinedResult;
                    t1.listenerHasError = false;
                }
            },
            $signature: 0
        };
        A._Future__propagateToListeners_handleWhenCompleteCallback_closure.prototype = {
            call$1: function(__wc0_formal) {
                this.joinedResult._completeWithResultOf$1(this.originalSource);
            },
            $signature: 62
        };
        A._Future__propagateToListeners_handleWhenCompleteCallback_closure0.prototype = {
            call$2: function(e, s) {
                this.joinedResult._completeErrorObject$1(new A.AsyncError(e, s));
            },
            $signature: 51
        };
        A._Future__propagateToListeners_handleValueCallback.prototype = {
            call$0: function() {
                var e, s, t1, t2, t3, _$exception;
                try {
                    t1 = this._box_0;
                    t2 = t1.listener;
                    t3 = t2.$ti;
                    t1.listenerValueOrError = t2.result._zone.runUnary$2$2(t2.callback, this.sourceResult, t3._eval$1("2/"), t3._precomputed1);
                } catch (exception) {
                    e = A.unwrapException(exception);
                    s = A.getTraceFromException(exception);
                    t1 = e;
                    t2 = s;
                    if (t2 == null) t2 = A.AsyncError_defaultStackTrace(t1);
                    t3 = this._box_0;
                    t3.listenerValueOrError = new A.AsyncError(t1, t2);
                    t3.listenerHasError = true;
                }
            },
            $signature: 0
        };
        A._Future__propagateToListeners_handleError.prototype = {
            call$0: function() {
                var asyncError, e, s, t1, _$exception, t2, t3, _this = this;
                try {
                    asyncError = _this._box_1.source._resultOrListeners;
                    t1 = _this._box_0;
                    if (t1.listener.matchesErrorTest$1(asyncError) && t1.listener.errorCallback != null) {
                        t1.listenerValueOrError = t1.listener.handleError$1(asyncError);
                        t1.listenerHasError = false;
                    }
                } catch (exception) {
                    e = A.unwrapException(exception);
                    s = A.getTraceFromException(exception);
                    t1 = _this._box_1.source._resultOrListeners;
                    if (t1.error === e) {
                        t2 = _this._box_0;
                        t2.listenerValueOrError = t1;
                        t1 = t2;
                    } else {
                        t1 = e;
                        t2 = s;
                        if (t2 == null) t2 = A.AsyncError_defaultStackTrace(t1);
                        t3 = _this._box_0;
                        t3.listenerValueOrError = new A.AsyncError(t1, t2);
                        t1 = t3;
                    }
                    t1.listenerHasError = true;
                }
            },
            $signature: 0
        };
        A._AsyncCallbackEntry.prototype = {};
        A.Stream.prototype = {
            get$isBroadcast: function() {
                return false;
            },
            get$length: function(_) {
                var t1 = {}, future = new A._Future($.Zone__current, type$._Future_int);
                t1.count = 0;
                this.listen$4$cancelOnError$onDone$onError(0, new A.Stream_length_closure(t1, this), true, new A.Stream_length_closure0(t1, future), future.get$_completeError());
                return future;
            }
        };
        A.Stream_Stream$fromFuture_closure.prototype = {
            call$1: function(value) {
                var t1 = this.controller;
                t1._async$_add$1(value);
                t1._closeUnchecked$0();
            },
            $signature: function() {
                return this.T._eval$1("Null(0)");
            }
        };
        A.Stream_Stream$fromFuture_closure0.prototype = {
            call$2: function(error, stackTrace) {
                var t1 = this.controller;
                t1._addError$2(error, stackTrace);
                t1._closeUnchecked$0();
            },
            $signature: 392
        };
        A.Stream_length_closure.prototype = {
            call$1: function(__wc0_formal) {
                ++this._box_0.count;
            },
            $signature: function() {
                return A._instanceType(this.$this)._eval$1("~(Stream.T)");
            }
        };
        A.Stream_length_closure0.prototype = {
            call$0: function() {
                this.future._complete$1(this._box_0.count);
            },
            $signature: 0
        };
        A._StreamController.prototype = {
            get$stream: function() {
                return new A._ControllerStream(this, A._instanceType(this)._eval$1("_ControllerStream<1>"));
            },
            get$_pendingEvents: function() {
                if ((this._state & 8) === 0) return this._varData;
                return this._varData._varData;
            },
            _ensurePendingEvents$0: function() {
                var events, state, _this = this;
                if ((_this._state & 8) === 0) {
                    events = _this._varData;
                    return events == null ? _this._varData = new A._PendingEvents() : events;
                }
                state = _this._varData;
                events = state._varData;
                return events == null ? state._varData = new A._PendingEvents() : events;
            },
            get$_subscription: function() {
                var varData = this._varData;
                return (this._state & 8) !== 0 ? varData._varData : varData;
            },
            _badEventState$0: function() {
                if ((this._state & 4) !== 0) return new A.StateError("Cannot add event after closing");
                return new A.StateError("Cannot add event while adding a stream");
            },
            addStream$2$cancelOnError: function(source, cancelOnError) {
                var t2, t3, t4, _this = this, t1 = _this._state;
                if (t1 >= 4) throw A.wrapException(_this._badEventState$0());
                if ((t1 & 2) !== 0) {
                    t1 = new A._Future($.Zone__current, type$._Future_dynamic);
                    t1._asyncComplete$1(null);
                    return t1;
                }
                t1 = _this._varData;
                t2 = cancelOnError === true;
                t3 = new A._Future($.Zone__current, type$._Future_dynamic);
                t4 = t2 ? A._AddStreamState_makeErrorHandler(_this) : _this.get$_addError();
                t4 = source.listen$4$cancelOnError$onDone$onError(0, _this.get$_async$_add(), t2, _this.get$_close(), t4);
                t2 = _this._state;
                if ((t2 & 1) !== 0 ? (_this.get$_subscription()._state & 4) !== 0 : (t2 & 2) === 0) t4.pause$0(0);
                _this._varData = new A._StreamControllerAddStreamState(t1, t3, t4);
                _this._state |= 8;
                return t3;
            },
            _ensureDoneFuture$0: function() {
                var t1 = this._doneFuture;
                if (t1 == null) t1 = this._doneFuture = (this._state & 2) !== 0 ? $.$get$Future__nullFuture() : new A._Future($.Zone__current, type$._Future_void);
                return t1;
            },
            add$1: function(_, value) {
                if (this._state >= 4) throw A.wrapException(this._badEventState$0());
                this._async$_add$1(value);
            },
            addError$2: function(error, stackTrace) {
                var _0_0;
                if (this._state >= 4) throw A.wrapException(this._badEventState$0());
                _0_0 = A._interceptUserError(error, stackTrace);
                this._addError$2(_0_0.error, _0_0.stackTrace);
            },
            addError$1: function(error) {
                return this.addError$2(error, null);
            },
            close$0: function(_) {
                var _this = this, t1 = _this._state;
                if ((t1 & 4) !== 0) return _this._ensureDoneFuture$0();
                if (t1 >= 4) throw A.wrapException(_this._badEventState$0());
                _this._closeUnchecked$0();
                return _this._ensureDoneFuture$0();
            },
            _closeUnchecked$0: function() {
                var t1 = this._state |= 4;
                if ((t1 & 1) !== 0) this._sendDone$0();
                else if ((t1 & 3) === 0) this._ensurePendingEvents$0().add$1(0, B.C__DelayedDone);
            },
            _async$_add$1: function(value) {
                var t1 = this._state;
                if ((t1 & 1) !== 0) this._sendData$1(value);
                else if ((t1 & 3) === 0) this._ensurePendingEvents$0().add$1(0, new A._DelayedData(value));
            },
            _addError$2: function(error, stackTrace) {
                var t1 = this._state;
                if ((t1 & 1) !== 0) this._sendError$2(error, stackTrace);
                else if ((t1 & 3) === 0) this._ensurePendingEvents$0().add$1(0, new A._DelayedError(error, stackTrace));
            },
            _close$0: function() {
                var addState = this._varData;
                this._varData = addState._varData;
                this._state &= 4294967287;
                addState.addStreamFuture._asyncComplete$1(null);
            },
            _subscribe$4: function(onData, onError, onDone, cancelOnError) {
                var subscription, pendingEvents, addState, _this = this;
                if ((_this._state & 3) !== 0) throw A.wrapException(A.StateError$("Stream has already been listened to."));
                subscription = A._ControllerSubscription$(_this, onData, onError, onDone, cancelOnError, A._instanceType(_this)._precomputed1);
                pendingEvents = _this.get$_pendingEvents();
                if (((_this._state |= 1) & 8) !== 0) {
                    addState = _this._varData;
                    addState._varData = subscription;
                    addState.addSubscription.resume$0(0);
                } else _this._varData = subscription;
                subscription._setPendingEvents$1(pendingEvents);
                subscription._guardCallback$1(new A._StreamController__subscribe_closure(_this));
                return subscription;
            },
            _recordCancel$1: function(subscription) {
                var onCancel, cancelResult, e, s, _$exception, result0, t1, _this = this, result = null;
                if ((_this._state & 8) !== 0) result = _this._varData.cancel$0();
                _this._varData = null;
                _this._state = _this._state & 4294967286 | 2;
                onCancel = _this.onCancel;
                if (onCancel != null) {
                    if (result == null) try {
                        cancelResult = onCancel.call$0();
                        if (cancelResult instanceof A._Future) result = cancelResult;
                    } catch (exception) {
                        e = A.unwrapException(exception);
                        s = A.getTraceFromException(exception);
                        result0 = new A._Future($.Zone__current, type$._Future_void);
                        result0._asyncCompleteErrorObject$1(new A.AsyncError(e, s));
                        result = result0;
                    }
                    else result = result.whenComplete$1(onCancel);
                }
                t1 = new A._StreamController__recordCancel_complete(_this);
                if (result != null) result = result.whenComplete$1(t1);
                else t1.call$0();
                return result;
            },
            _recordPause$1: function(subscription) {
                if ((this._state & 8) !== 0) this._varData.addSubscription.pause$0(0);
                A._runGuarded(this.onPause);
            },
            _recordResume$1: function(subscription) {
                if ((this._state & 8) !== 0) this._varData.addSubscription.resume$0(0);
                A._runGuarded(this.onResume);
            },
            $isEventSink: 1,
            set$onPause: function(val) {
                return this.onPause = val;
            },
            set$onResume: function(val) {
                return this.onResume = val;
            },
            set$onCancel: function(val) {
                return this.onCancel = val;
            }
        };
        A._StreamController__subscribe_closure.prototype = {
            call$0: function() {
                A._runGuarded(this.$this.onListen);
            },
            $signature: 0
        };
        A._StreamController__recordCancel_complete.prototype = {
            call$0: function() {
                var doneFuture = this.$this._doneFuture;
                if (doneFuture != null && (doneFuture._state & 30) === 0) doneFuture._asyncComplete$1(null);
            },
            $signature: 0
        };
        A._SyncStreamControllerDispatch.prototype = {
            _sendData$1: function(data) {
                this.get$_subscription()._async$_add$1(data);
            },
            _sendError$2: function(error, stackTrace) {
                this.get$_subscription()._addError$2(error, stackTrace);
            },
            _sendDone$0: function() {
                this.get$_subscription()._close$0();
            }
        };
        A._AsyncStreamControllerDispatch.prototype = {
            _sendData$1: function(data) {
                this.get$_subscription()._addPending$1(new A._DelayedData(data));
            },
            _sendError$2: function(error, stackTrace) {
                this.get$_subscription()._addPending$1(new A._DelayedError(error, stackTrace));
            },
            _sendDone$0: function() {
                this.get$_subscription()._addPending$1(B.C__DelayedDone);
            }
        };
        A._AsyncStreamController.prototype = {};
        A._SyncStreamController.prototype = {};
        A._ControllerStream.prototype = {
            get$hashCode: function(_) {
                return (A.Primitives_objectHashCode(this._controller) ^ 892482866) >>> 0;
            },
            $eq: function(_, other) {
                if (other == null) return false;
                if (this === other) return true;
                return other instanceof A._ControllerStream && other._controller === this._controller;
            }
        };
        A._ControllerSubscription.prototype = {
            _async$_onCancel$0: function() {
                return this._controller._recordCancel$1(this);
            },
            _async$_onPause$0: function() {
                this._controller._recordPause$1(this);
            },
            _async$_onResume$0: function() {
                this._controller._recordResume$1(this);
            }
        };
        A._AddStreamState.prototype = {
            cancel$0: function() {
                var cancel = this.addSubscription.cancel$0();
                return cancel.whenComplete$1(new A._AddStreamState_cancel_closure(this));
            }
        };
        A._AddStreamState_makeErrorHandler_closure.prototype = {
            call$2: function(e, s) {
                var t1 = this.controller;
                t1._addError$2(e, s);
                t1._close$0();
            },
            $signature: 51
        };
        A._AddStreamState_cancel_closure.prototype = {
            call$0: function() {
                this.$this.addStreamFuture._asyncComplete$1(null);
            },
            $signature: 1
        };
        A._StreamControllerAddStreamState.prototype = {};
        A._BufferingStreamSubscription.prototype = {
            _setPendingEvents$1: function(pendingEvents) {
                var _this = this;
                if (pendingEvents == null) return;
                _this._pending = pendingEvents;
                if (pendingEvents.lastPendingEvent != null) {
                    _this._state = (_this._state | 128) >>> 0;
                    pendingEvents.schedule$1(_this);
                }
            },
            pause$1: function(_, resumeSignal) {
                var t2, t3, _this = this, t1 = _this._state;
                if ((t1 & 8) !== 0) return;
                t2 = (t1 + 256 | 4) >>> 0;
                _this._state = t2;
                if (t1 < 256) {
                    t3 = _this._pending;
                    if (t3 != null) {
                        if (t3._state === 1) t3._state = 3;
                    }
                }
                if ((t1 & 4) === 0 && (t2 & 64) === 0) _this._guardCallback$1(_this.get$_async$_onPause());
            },
            pause$0: function(_) {
                return this.pause$1(0, null);
            },
            resume$0: function(_) {
                var _this = this, t1 = _this._state;
                if ((t1 & 8) !== 0) return;
                if (t1 >= 256) {
                    t1 = _this._state = t1 - 256;
                    if (t1 < 256) {
                        if ((t1 & 128) !== 0 && _this._pending.lastPendingEvent != null) _this._pending.schedule$1(_this);
                        else {
                            t1 = (t1 & 4294967291) >>> 0;
                            _this._state = t1;
                            if ((t1 & 64) === 0) _this._guardCallback$1(_this.get$_async$_onResume());
                        }
                    }
                }
            },
            cancel$0: function() {
                var _this = this, t1 = (_this._state & 4294967279) >>> 0;
                _this._state = t1;
                if ((t1 & 8) === 0) _this._cancel$0();
                t1 = _this._cancelFuture;
                return t1 == null ? $.$get$Future__nullFuture() : t1;
            },
            _cancel$0: function() {
                var t2, _this = this, t1 = _this._state = (_this._state | 8) >>> 0;
                if ((t1 & 128) !== 0) {
                    t2 = _this._pending;
                    if (t2._state === 1) t2._state = 3;
                }
                if ((t1 & 64) === 0) _this._pending = null;
                _this._cancelFuture = _this._async$_onCancel$0();
            },
            _async$_add$1: function(data) {
                var t1 = this._state;
                if ((t1 & 8) !== 0) return;
                if (t1 < 64) this._sendData$1(data);
                else this._addPending$1(new A._DelayedData(data));
            },
            _addError$2: function(error, stackTrace) {
                var t1;
                if (type$.Error._is(error)) A.Primitives_trySetStackTrace(error, stackTrace);
                t1 = this._state;
                if ((t1 & 8) !== 0) return;
                if (t1 < 64) this._sendError$2(error, stackTrace);
                else this._addPending$1(new A._DelayedError(error, stackTrace));
            },
            _close$0: function() {
                var _this = this, t1 = _this._state;
                if ((t1 & 8) !== 0) return;
                t1 = (t1 | 2) >>> 0;
                _this._state = t1;
                if (t1 < 64) _this._sendDone$0();
                else _this._addPending$1(B.C__DelayedDone);
            },
            _async$_onPause$0: function() {},
            _async$_onResume$0: function() {},
            _async$_onCancel$0: function() {
                return null;
            },
            _addPending$1: function($event) {
                var t1, _this = this, pending = _this._pending;
                if (pending == null) pending = _this._pending = new A._PendingEvents();
                pending.add$1(0, $event);
                t1 = _this._state;
                if ((t1 & 128) === 0) {
                    t1 = (t1 | 128) >>> 0;
                    _this._state = t1;
                    if (t1 < 256) pending.schedule$1(_this);
                }
            },
            _sendData$1: function(data) {
                var _this = this, t1 = _this._state;
                _this._state = (t1 | 64) >>> 0;
                _this._zone.runUnaryGuarded$1$2(_this._onData, data, A._instanceType(_this)._eval$1("_BufferingStreamSubscription.T"));
                _this._state = (_this._state & 4294967231) >>> 0;
                _this._checkState$1((t1 & 4) !== 0);
            },
            _sendError$2: function(error, stackTrace) {
                var cancelFuture, _this = this, t1 = _this._state, t2 = new A._BufferingStreamSubscription__sendError_sendError(_this, error, stackTrace);
                if ((t1 & 1) !== 0) {
                    _this._state = (t1 | 16) >>> 0;
                    _this._cancel$0();
                    cancelFuture = _this._cancelFuture;
                    if (cancelFuture != null && cancelFuture !== $.$get$Future__nullFuture()) cancelFuture.whenComplete$1(t2);
                    else t2.call$0();
                } else {
                    t2.call$0();
                    _this._checkState$1((t1 & 4) !== 0);
                }
            },
            _sendDone$0: function() {
                var cancelFuture, _this = this, t1 = new A._BufferingStreamSubscription__sendDone_sendDone(_this);
                _this._cancel$0();
                _this._state = (_this._state | 16) >>> 0;
                cancelFuture = _this._cancelFuture;
                if (cancelFuture != null && cancelFuture !== $.$get$Future__nullFuture()) cancelFuture.whenComplete$1(t1);
                else t1.call$0();
            },
            _guardCallback$1: function(callback) {
                var _this = this, t1 = _this._state;
                _this._state = (t1 | 64) >>> 0;
                callback.call$0();
                _this._state = (_this._state & 4294967231) >>> 0;
                _this._checkState$1((t1 & 4) !== 0);
            },
            _checkState$1: function(wasInputPaused) {
                var t2, isInputPaused, _this = this, t1 = _this._state;
                if ((t1 & 128) !== 0 && _this._pending.lastPendingEvent == null) {
                    t1 = _this._state = (t1 & 4294967167) >>> 0;
                    t2 = false;
                    if ((t1 & 4) !== 0) {
                        if (t1 < 256) {
                            t2 = _this._pending;
                            t2 = t2 == null ? null : t2.lastPendingEvent == null;
                            t2 = t2 !== false;
                        }
                    }
                    if (t2) {
                        t1 = (t1 & 4294967291) >>> 0;
                        _this._state = t1;
                    }
                }
                for(;; wasInputPaused = isInputPaused){
                    if ((t1 & 8) !== 0) {
                        _this._pending = null;
                        return;
                    }
                    isInputPaused = (t1 & 4) !== 0;
                    if (wasInputPaused === isInputPaused) break;
                    _this._state = (t1 ^ 64) >>> 0;
                    if (isInputPaused) _this._async$_onPause$0();
                    else _this._async$_onResume$0();
                    t1 = (_this._state & 4294967231) >>> 0;
                    _this._state = t1;
                }
                if ((t1 & 128) !== 0 && t1 < 256) _this._pending.schedule$1(_this);
            },
            $isStreamSubscription: 1
        };
        A._BufferingStreamSubscription__sendError_sendError.prototype = {
            call$0: function() {
                var onError, t3, t4, t1 = this.$this, t2 = t1._state;
                if ((t2 & 8) !== 0 && (t2 & 16) === 0) return;
                t1._state = (t2 | 64) >>> 0;
                onError = t1._onError;
                t2 = this.error;
                t3 = type$.Object;
                t4 = t1._zone;
                if (type$.void_Function_Object_StackTrace._is(onError)) t4.runBinaryGuarded$2$3(onError, t2, this.stackTrace, t3, type$.StackTrace);
                else t4.runUnaryGuarded$1$2(onError, t2, t3);
                t1._state = (t1._state & 4294967231) >>> 0;
            },
            $signature: 0
        };
        A._BufferingStreamSubscription__sendDone_sendDone.prototype = {
            call$0: function() {
                var t1 = this.$this, t2 = t1._state;
                if ((t2 & 16) === 0) return;
                t1._state = (t2 | 74) >>> 0;
                t1._zone.runGuarded$1(t1._onDone);
                t1._state = (t1._state & 4294967231) >>> 0;
            },
            $signature: 0
        };
        A._StreamImpl.prototype = {
            listen$4$cancelOnError$onDone$onError: function(_, onData, cancelOnError, onDone, onError) {
                return this._controller._subscribe$4(onData, onError, onDone, cancelOnError === true);
            },
            listen$1: function(_, onData) {
                return this.listen$4$cancelOnError$onDone$onError(0, onData, null, null, null);
            },
            listen$3$onDone$onError: function(_, onData, onDone, onError) {
                return this.listen$4$cancelOnError$onDone$onError(0, onData, null, onDone, onError);
            }
        };
        A._DelayedEvent.prototype = {
            get$next: function() {
                return this.next;
            },
            set$next: function(val) {
                return this.next = val;
            }
        };
        A._DelayedData.prototype = {
            perform$1: function(dispatch) {
                dispatch._sendData$1(this.value);
            }
        };
        A._DelayedError.prototype = {
            perform$1: function(dispatch) {
                dispatch._sendError$2(this.error, this.stackTrace);
            }
        };
        A._DelayedDone.prototype = {
            perform$1: function(dispatch) {
                dispatch._sendDone$0();
            },
            get$next: function() {
                return null;
            },
            set$next: function(__wc0_formal) {
                throw A.wrapException(A.StateError$("No events after a done."));
            }
        };
        A._PendingEvents.prototype = {
            schedule$1: function(dispatch) {
                var _this = this, t1 = _this._state;
                if (t1 === 1) return;
                if (t1 >= 1) {
                    _this._state = 1;
                    return;
                }
                A.scheduleMicrotask(new A._PendingEvents_schedule_closure(_this, dispatch));
                _this._state = 1;
            },
            add$1: function(_, $event) {
                var _this = this, lastEvent = _this.lastPendingEvent;
                if (lastEvent == null) _this.firstPendingEvent = _this.lastPendingEvent = $event;
                else {
                    lastEvent.set$next($event);
                    _this.lastPendingEvent = $event;
                }
            }
        };
        A._PendingEvents_schedule_closure.prototype = {
            call$0: function() {
                var $event, nextEvent, t1 = this.$this, oldState = t1._state;
                t1._state = 0;
                if (oldState === 3) return;
                $event = t1.firstPendingEvent;
                nextEvent = $event.get$next();
                t1.firstPendingEvent = nextEvent;
                if (nextEvent == null) t1.lastPendingEvent = null;
                $event.perform$1(this.dispatch);
            },
            $signature: 0
        };
        A._StreamIterator.prototype = {
            get$current: function(_) {
                if (this._async$_hasValue) return this._stateData;
                return null;
            },
            moveNext$0: function() {
                var future, _this = this, subscription = _this._subscription;
                if (subscription != null) {
                    if (_this._async$_hasValue) {
                        future = new A._Future($.Zone__current, type$._Future_bool);
                        _this._stateData = future;
                        _this._async$_hasValue = false;
                        subscription.resume$0(0);
                        return future;
                    }
                    throw A.wrapException(A.StateError$("Already waiting for next."));
                }
                return _this._initializeOrDone$0();
            },
            _initializeOrDone$0: function() {
                var future, subscription, _this = this, stateData = _this._stateData;
                if (stateData != null) {
                    future = new A._Future($.Zone__current, type$._Future_bool);
                    _this._stateData = future;
                    subscription = stateData.listen$4$cancelOnError$onDone$onError(0, _this.get$_onData(), true, _this.get$_onDone(), _this.get$_onError());
                    if (_this._stateData != null) _this._subscription = subscription;
                    return future;
                }
                return $.$get$Future__falseFuture();
            },
            cancel$0: function() {
                var _this = this, subscription = _this._subscription, stateData = _this._stateData;
                _this._stateData = null;
                if (subscription != null) {
                    _this._subscription = null;
                    if (!_this._async$_hasValue) stateData._asyncComplete$1(false);
                    else _this._async$_hasValue = false;
                    return subscription.cancel$0();
                }
                return $.$get$Future__nullFuture();
            },
            _onData$1: function(data) {
                var moveNextFuture, t1, _this = this;
                if (_this._subscription == null) return;
                moveNextFuture = _this._stateData;
                _this._stateData = data;
                _this._async$_hasValue = true;
                moveNextFuture._complete$1(true);
                if (_this._async$_hasValue) {
                    t1 = _this._subscription;
                    if (t1 != null) t1.pause$0(0);
                }
            },
            _onError$2: function(error, stackTrace) {
                var _this = this, subscription = _this._subscription, moveNextFuture = _this._stateData;
                _this._stateData = _this._subscription = null;
                if (subscription != null) moveNextFuture._completeErrorObject$1(new A.AsyncError(error, stackTrace));
                else moveNextFuture._asyncCompleteErrorObject$1(new A.AsyncError(error, stackTrace));
            },
            _onDone$0: function() {
                var _this = this, subscription = _this._subscription, moveNextFuture = _this._stateData;
                _this._stateData = _this._subscription = null;
                if (subscription != null) moveNextFuture._completeWithValue$1(false);
                else moveNextFuture._asyncCompleteWithValue$1(false);
            }
        };
        A._ForwardingStream.prototype = {
            get$isBroadcast: function() {
                return this._async$_source.get$isBroadcast();
            },
            listen$4$cancelOnError$onDone$onError: function(_, onData, cancelOnError, onDone, onError) {
                var t1 = this.$ti, t2 = $.Zone__current, t3 = cancelOnError === true ? 1 : 0, t4 = onError != null ? 32 : 0, t5 = A._BufferingStreamSubscription__registerDataHandler(t2, onData, t1._rest[1]), t6 = A._BufferingStreamSubscription__registerErrorHandler(t2, onError), t7 = onDone == null ? A.async___nullDoneHandler$closure() : onDone;
                t1 = new A._ForwardingStreamSubscription(this, t5, t6, t2.registerCallback$1$1(t7, type$.void), t2, t3 | t4, t1._eval$1("_ForwardingStreamSubscription<1,2>"));
                t1._subscription = this._async$_source.listen$3$onDone$onError(0, t1.get$_handleData(), t1.get$_handleDone(), t1.get$_handleError());
                return t1;
            },
            listen$1: function(_, onData) {
                return this.listen$4$cancelOnError$onDone$onError(0, onData, null, null, null);
            },
            listen$3$onDone$onError: function(_, onData, onDone, onError) {
                return this.listen$4$cancelOnError$onDone$onError(0, onData, null, onDone, onError);
            }
        };
        A._ForwardingStreamSubscription.prototype = {
            _async$_add$1: function(data) {
                if ((this._state & 2) !== 0) return;
                this.super$_BufferingStreamSubscription$_add(data);
            },
            _addError$2: function(error, stackTrace) {
                if ((this._state & 2) !== 0) return;
                this.super$_BufferingStreamSubscription$_addError(error, stackTrace);
            },
            _async$_onPause$0: function() {
                var t1 = this._subscription;
                if (t1 != null) t1.pause$0(0);
            },
            _async$_onResume$0: function() {
                var t1 = this._subscription;
                if (t1 != null) t1.resume$0(0);
            },
            _async$_onCancel$0: function() {
                var subscription = this._subscription;
                if (subscription != null) {
                    this._subscription = null;
                    return subscription.cancel$0();
                }
                return null;
            },
            _handleData$1: function(data) {
                this._stream._handleData$2(data, this);
            },
            _handleError$2: function(error, stackTrace) {
                this._addError$2(error, stackTrace);
            },
            _handleDone$0: function() {
                this._close$0();
            }
        };
        A._MapStream.prototype = {
            _handleData$2: function(inputEvent, sink) {
                var e, s, _$exception, error, stackTrace, replacement, outputEvent = null;
                try {
                    outputEvent = this._transform.call$1(inputEvent);
                } catch (exception) {
                    e = A.unwrapException(exception);
                    s = A.getTraceFromException(exception);
                    error = e;
                    stackTrace = s;
                    replacement = A._interceptError(error, stackTrace);
                    if (replacement != null) {
                        error = replacement.error;
                        stackTrace = replacement.stackTrace;
                    }
                    sink._addError$2(error, stackTrace);
                    return;
                }
                sink._async$_add$1(outputEvent);
            }
        };
        A._ZoneFunction.prototype = {};
        A._Zone.prototype = {
            _processUncaughtError$3: function(zone, error, stackTrace) {
                var handler, parentDelegate, parentZone, currentZone, e, s, t1, _$exception, implementation = this.get$_handleUncaughtError(), implZone = implementation.zone;
                if (implZone === B.C__RootZone) {
                    A._rootHandleError(error, stackTrace);
                    return;
                }
                handler = implementation.$function;
                parentDelegate = implZone.get$_parentDelegate();
                t1 = J.get$parent$z(implZone);
                t1.toString;
                parentZone = t1;
                currentZone = $.Zone__current;
                try {
                    $.Zone__current = parentZone;
                    handler.call$5(implZone, parentDelegate, zone, error, stackTrace);
                    $.Zone__current = currentZone;
                } catch (exception) {
                    e = A.unwrapException(exception);
                    s = A.getTraceFromException(exception);
                    $.Zone__current = currentZone;
                    t1 = error === e ? stackTrace : s;
                    parentZone._processUncaughtError$3(implZone, e, t1);
                }
            },
            $isZone: 1
        };
        A._CustomZone.prototype = {
            get$_delegate: function() {
                var t1 = this._delegateCache;
                return t1 == null ? this._delegateCache = new A._ZoneDelegate(this) : t1;
            },
            get$_parentDelegate: function() {
                return this.parent.get$_delegate();
            },
            get$errorZone: function() {
                return this._handleUncaughtError.zone;
            },
            runGuarded$1: function(f) {
                var e, s, _$exception;
                try {
                    this.run$1$1(0, f, type$.void);
                } catch (exception) {
                    e = A.unwrapException(exception);
                    s = A.getTraceFromException(exception);
                    this._processUncaughtError$3(this, e, s);
                }
            },
            runUnaryGuarded$1$2: function(f, arg, $T) {
                var e, s, _$exception;
                try {
                    this.runUnary$2$2(f, arg, type$.void, $T);
                } catch (exception) {
                    e = A.unwrapException(exception);
                    s = A.getTraceFromException(exception);
                    this._processUncaughtError$3(this, e, s);
                }
            },
            runBinaryGuarded$2$3: function(f, arg1, arg2, $T1, $T2) {
                var e, s, _$exception;
                try {
                    this.runBinary$3$3(f, arg1, arg2, type$.void, $T1, $T2);
                } catch (exception) {
                    e = A.unwrapException(exception);
                    s = A.getTraceFromException(exception);
                    this._processUncaughtError$3(this, e, s);
                }
            },
            bindCallback$1$1: function(f, $R) {
                return new A._CustomZone_bindCallback_closure(this, this.registerCallback$1$1(f, $R), $R);
            },
            bindUnaryCallback$2$1: function(f, $R, $T) {
                return new A._CustomZone_bindUnaryCallback_closure(this, this.registerUnaryCallback$2$1(f, $R, $T), $T, $R);
            },
            bindCallbackGuarded$1: function(f) {
                return new A._CustomZone_bindCallbackGuarded_closure(this, this.registerCallback$1$1(f, type$.void));
            },
            $index: function(_, key) {
                var value, t1 = this._async$_map, result = t1.$index(0, key);
                if (result != null || t1.containsKey$1(key)) return result;
                value = this.parent.$index(0, key);
                if (value != null) t1.$indexSet(0, key, value);
                return value;
            },
            handleUncaughtError$2: function(error, stackTrace) {
                this._processUncaughtError$3(this, error, stackTrace);
            },
            fork$2$specification$zoneValues: function(specification, zoneValues) {
                var implementation = this._fork, t1 = implementation.zone;
                return implementation.$function.call$5(t1, t1.get$_parentDelegate(), this, specification, zoneValues);
            },
            run$1$1: function(_, f) {
                var implementation = this._run, t1 = implementation.zone;
                return implementation.$function.call$4(t1, t1.get$_parentDelegate(), this, f);
            },
            runUnary$2$2: function(f, arg) {
                var implementation = this._runUnary, t1 = implementation.zone;
                return implementation.$function.call$5(t1, t1.get$_parentDelegate(), this, f, arg);
            },
            runBinary$3$3: function(f, arg1, arg2) {
                var implementation = this._runBinary, t1 = implementation.zone;
                return implementation.$function.call$6(t1, t1.get$_parentDelegate(), this, f, arg1, arg2);
            },
            registerCallback$1$1: function(callback) {
                var implementation = this._registerCallback, t1 = implementation.zone;
                return implementation.$function.call$4(t1, t1.get$_parentDelegate(), this, callback);
            },
            registerUnaryCallback$2$1: function(callback) {
                var implementation = this._registerUnaryCallback, t1 = implementation.zone;
                return implementation.$function.call$4(t1, t1.get$_parentDelegate(), this, callback);
            },
            registerBinaryCallback$3$1: function(callback) {
                var implementation = this._registerBinaryCallback, t1 = implementation.zone;
                return implementation.$function.call$4(t1, t1.get$_parentDelegate(), this, callback);
            },
            errorCallback$2: function(error, stackTrace) {
                var implementation = this._errorCallback, implementationZone = implementation.zone;
                if (implementationZone === B.C__RootZone) return null;
                return implementation.$function.call$5(implementationZone, implementationZone.get$_parentDelegate(), this, error, stackTrace);
            },
            scheduleMicrotask$1: function(f) {
                var implementation = this._scheduleMicrotask, t1 = implementation.zone;
                return implementation.$function.call$4(t1, t1.get$_parentDelegate(), this, f);
            },
            createTimer$2: function(duration, f) {
                var implementation = this._createTimer, t1 = implementation.zone;
                return implementation.$function.call$5(t1, t1.get$_parentDelegate(), this, duration, f);
            },
            print$1: function(line) {
                var implementation = this._print, t1 = implementation.zone;
                return implementation.$function.call$4(t1, t1.get$_parentDelegate(), this, line);
            },
            get$_run: function() {
                return this._run;
            },
            get$_runUnary: function() {
                return this._runUnary;
            },
            get$_runBinary: function() {
                return this._runBinary;
            },
            get$_registerCallback: function() {
                return this._registerCallback;
            },
            get$_registerUnaryCallback: function() {
                return this._registerUnaryCallback;
            },
            get$_registerBinaryCallback: function() {
                return this._registerBinaryCallback;
            },
            get$_errorCallback: function() {
                return this._errorCallback;
            },
            get$_scheduleMicrotask: function() {
                return this._scheduleMicrotask;
            },
            get$_createTimer: function() {
                return this._createTimer;
            },
            get$_createPeriodicTimer: function() {
                return this._createPeriodicTimer;
            },
            get$_print: function() {
                return this._print;
            },
            get$_fork: function() {
                return this._fork;
            },
            get$_handleUncaughtError: function() {
                return this._handleUncaughtError;
            },
            get$parent: function(receiver) {
                return this.parent;
            },
            get$_async$_map: function() {
                return this._async$_map;
            }
        };
        A._CustomZone_bindCallback_closure.prototype = {
            call$0: function() {
                return this.$this.run$1$1(0, this.registered, this.R);
            },
            $signature: function() {
                return this.R._eval$1("0()");
            }
        };
        A._CustomZone_bindUnaryCallback_closure.prototype = {
            call$1: function(arg) {
                var _this = this;
                return _this.$this.runUnary$2$2(_this.registered, arg, _this.R, _this.T);
            },
            $signature: function() {
                return this.R._eval$1("@<0>")._bind$1(this.T)._eval$1("1(2)");
            }
        };
        A._CustomZone_bindCallbackGuarded_closure.prototype = {
            call$0: function() {
                return this.$this.runGuarded$1(this.registered);
            },
            $signature: 0
        };
        A._RootZone.prototype = {
            get$_run: function() {
                return B._ZoneFunction__RootZone__rootRun;
            },
            get$_runUnary: function() {
                return B._ZoneFunction__RootZone__rootRunUnary;
            },
            get$_runBinary: function() {
                return B._ZoneFunction__RootZone__rootRunBinary;
            },
            get$_registerCallback: function() {
                return B._ZoneFunction__RootZone__rootRegisterCallback;
            },
            get$_registerUnaryCallback: function() {
                return B._ZoneFunction_Xkh;
            },
            get$_registerBinaryCallback: function() {
                return B._ZoneFunction_e9o;
            },
            get$_errorCallback: function() {
                return B._ZoneFunction__RootZone__rootErrorCallback;
            },
            get$_scheduleMicrotask: function() {
                return B._ZoneFunction__RootZone__rootScheduleMicrotask;
            },
            get$_createTimer: function() {
                return B._ZoneFunction__RootZone__rootCreateTimer;
            },
            get$_createPeriodicTimer: function() {
                return B._ZoneFunction_PAY;
            },
            get$_print: function() {
                return B._ZoneFunction__RootZone__rootPrint;
            },
            get$_fork: function() {
                return B._ZoneFunction__RootZone__rootFork;
            },
            get$_handleUncaughtError: function() {
                return B._ZoneFunction_KjJ;
            },
            get$parent: function(_) {
                return null;
            },
            get$_async$_map: function() {
                return $.$get$_RootZone__rootMap();
            },
            get$_delegate: function() {
                var t1 = $._RootZone__rootDelegate;
                return t1 == null ? $._RootZone__rootDelegate = new A._ZoneDelegate(this) : t1;
            },
            get$_parentDelegate: function() {
                var t1 = $._RootZone__rootDelegate;
                return t1 == null ? $._RootZone__rootDelegate = new A._ZoneDelegate(this) : t1;
            },
            get$errorZone: function() {
                return this;
            },
            runGuarded$1: function(f) {
                var e, s, _$exception;
                try {
                    if (B.C__RootZone === $.Zone__current) {
                        f.call$0();
                        return;
                    }
                    A._rootRun(null, null, this, f);
                } catch (exception) {
                    e = A.unwrapException(exception);
                    s = A.getTraceFromException(exception);
                    A._rootHandleError(e, s);
                }
            },
            runUnaryGuarded$1$2: function(f, arg) {
                var e, s, _$exception;
                try {
                    if (B.C__RootZone === $.Zone__current) {
                        f.call$1(arg);
                        return;
                    }
                    A._rootRunUnary(null, null, this, f, arg);
                } catch (exception) {
                    e = A.unwrapException(exception);
                    s = A.getTraceFromException(exception);
                    A._rootHandleError(e, s);
                }
            },
            runBinaryGuarded$2$3: function(f, arg1, arg2) {
                var e, s, _$exception;
                try {
                    if (B.C__RootZone === $.Zone__current) {
                        f.call$2(arg1, arg2);
                        return;
                    }
                    A._rootRunBinary(null, null, this, f, arg1, arg2);
                } catch (exception) {
                    e = A.unwrapException(exception);
                    s = A.getTraceFromException(exception);
                    A._rootHandleError(e, s);
                }
            },
            bindCallback$1$1: function(f, $R) {
                return new A._RootZone_bindCallback_closure(this, f, $R);
            },
            bindUnaryCallback$2$1: function(f, $R, $T) {
                return new A._RootZone_bindUnaryCallback_closure(this, f, $T, $R);
            },
            bindCallbackGuarded$1: function(f) {
                return new A._RootZone_bindCallbackGuarded_closure(this, f);
            },
            $index: function(_, key) {
                return null;
            },
            handleUncaughtError$2: function(error, stackTrace) {
                A._rootHandleError(error, stackTrace);
            },
            fork$2$specification$zoneValues: function(specification, zoneValues) {
                return A._rootFork(null, null, this, specification, zoneValues);
            },
            run$1$1: function(_, f) {
                if ($.Zone__current === B.C__RootZone) return f.call$0();
                return A._rootRun(null, null, this, f);
            },
            runUnary$2$2: function(f, arg) {
                if ($.Zone__current === B.C__RootZone) return f.call$1(arg);
                return A._rootRunUnary(null, null, this, f, arg);
            },
            runBinary$3$3: function(f, arg1, arg2) {
                if ($.Zone__current === B.C__RootZone) return f.call$2(arg1, arg2);
                return A._rootRunBinary(null, null, this, f, arg1, arg2);
            },
            registerCallback$1$1: function(f) {
                return f;
            },
            registerUnaryCallback$2$1: function(f) {
                return f;
            },
            registerBinaryCallback$3$1: function(f) {
                return f;
            },
            errorCallback$2: function(error, stackTrace) {
                return null;
            },
            scheduleMicrotask$1: function(f) {
                A._rootScheduleMicrotask(null, null, this, f);
            },
            createTimer$2: function(duration, f) {
                return A.Timer__createTimer(duration, f);
            },
            print$1: function(line) {
                A.printString(line);
            }
        };
        A._RootZone_bindCallback_closure.prototype = {
            call$0: function() {
                return this.$this.run$1$1(0, this.f, this.R);
            },
            $signature: function() {
                return this.R._eval$1("0()");
            }
        };
        A._RootZone_bindUnaryCallback_closure.prototype = {
            call$1: function(arg) {
                var _this = this;
                return _this.$this.runUnary$2$2(_this.f, arg, _this.R, _this.T);
            },
            $signature: function() {
                return this.R._eval$1("@<0>")._bind$1(this.T)._eval$1("1(2)");
            }
        };
        A._RootZone_bindCallbackGuarded_closure.prototype = {
            call$0: function() {
                return this.$this.runGuarded$1(this.f);
            },
            $signature: 0
        };
        A._ZoneDelegate.prototype = {
            $isZoneDelegate: 1
        };
        A._rootHandleError_closure.prototype = {
            call$0: function() {
                A.Error_throwWithStackTrace(this.error, this.stackTrace);
            },
            $signature: 0
        };
        A._ZoneSpecification.prototype = {
            $isZoneSpecification: 1
        };
        A._HashMap.prototype = {
            get$length: function(_) {
                return this._collection$_length;
            },
            get$isEmpty: function(_) {
                return this._collection$_length === 0;
            },
            get$isNotEmpty: function(_) {
                return this._collection$_length !== 0;
            },
            get$keys: function(_) {
                return new A._HashMapKeyIterable(this, A._instanceType(this)._eval$1("_HashMapKeyIterable<1>"));
            },
            get$values: function(_) {
                var t1 = A._instanceType(this);
                return A.MappedIterable_MappedIterable(new A._HashMapKeyIterable(this, t1._eval$1("_HashMapKeyIterable<1>")), new A._HashMap_values_closure(this), t1._precomputed1, t1._rest[1]);
            },
            containsKey$1: function(key) {
                var strings, nums;
                if (typeof key == "string" && key !== "__proto__") {
                    strings = this._collection$_strings;
                    return strings == null ? false : strings[key] != null;
                } else if (typeof key == "number" && (key & 1073741823) === key) {
                    nums = this._collection$_nums;
                    return nums == null ? false : nums[key] != null;
                } else return this._containsKey$1(key);
            },
            _containsKey$1: function(key) {
                var rest = this._collection$_rest;
                if (rest == null) return false;
                return this._findBucketIndex$2(this._getBucket$2(rest, key), key) >= 0;
            },
            addAll$1: function(_, other) {
                other.forEach$1(0, new A._HashMap_addAll_closure(this));
            },
            $index: function(_, key) {
                var strings, t1, nums;
                if (typeof key == "string" && key !== "__proto__") {
                    strings = this._collection$_strings;
                    t1 = strings == null ? null : A._HashMap__getTableEntry(strings, key);
                    return t1;
                } else if (typeof key == "number" && (key & 1073741823) === key) {
                    nums = this._collection$_nums;
                    t1 = nums == null ? null : A._HashMap__getTableEntry(nums, key);
                    return t1;
                } else return this._get$1(key);
            },
            _get$1: function(key) {
                var bucket, index, rest = this._collection$_rest;
                if (rest == null) return null;
                bucket = this._getBucket$2(rest, key);
                index = this._findBucketIndex$2(bucket, key);
                return index < 0 ? null : bucket[index + 1];
            },
            $indexSet: function(_, key, value) {
                var strings, nums, _this = this;
                if (typeof key == "string" && key !== "__proto__") {
                    strings = _this._collection$_strings;
                    _this._collection$_addHashTableEntry$3(strings == null ? _this._collection$_strings = A._HashMap__newHashTable() : strings, key, value);
                } else if (typeof key == "number" && (key & 1073741823) === key) {
                    nums = _this._collection$_nums;
                    _this._collection$_addHashTableEntry$3(nums == null ? _this._collection$_nums = A._HashMap__newHashTable() : nums, key, value);
                } else _this._set$2(key, value);
            },
            _set$2: function(key, value) {
                var hash, bucket, index, _this = this, rest = _this._collection$_rest;
                if (rest == null) rest = _this._collection$_rest = A._HashMap__newHashTable();
                hash = _this._computeHashCode$1(key);
                bucket = rest[hash];
                if (bucket == null) {
                    A._HashMap__setTableEntry(rest, hash, [
                        key,
                        value
                    ]);
                    ++_this._collection$_length;
                    _this._collection$_keys = null;
                } else {
                    index = _this._findBucketIndex$2(bucket, key);
                    if (index >= 0) bucket[index + 1] = value;
                    else {
                        bucket.push(key, value);
                        ++_this._collection$_length;
                        _this._collection$_keys = null;
                    }
                }
            },
            remove$1: function(_, key) {
                var _this = this;
                if (typeof key == "string" && key !== "__proto__") return _this._removeHashTableEntry$2(_this._collection$_strings, key);
                else if (typeof key == "number" && (key & 1073741823) === key) return _this._removeHashTableEntry$2(_this._collection$_nums, key);
                else return _this._remove$1(key);
            },
            _remove$1: function(key) {
                var hash, bucket, index, result, _this = this, rest = _this._collection$_rest;
                if (rest == null) return null;
                hash = _this._computeHashCode$1(key);
                bucket = rest[hash];
                index = _this._findBucketIndex$2(bucket, key);
                if (index < 0) return null;
                --_this._collection$_length;
                _this._collection$_keys = null;
                result = bucket.splice(index, 2)[1];
                if (0 === bucket.length) delete rest[hash];
                return result;
            },
            forEach$1: function(_, action) {
                var $length, t1, i, key, t2, _this = this, keys = _this._computeKeys$0();
                for($length = keys.length, t1 = A._instanceType(_this)._rest[1], i = 0; i < $length; ++i){
                    key = keys[i];
                    t2 = _this.$index(0, key);
                    action.call$2(key, t2 == null ? t1._as(t2) : t2);
                    if (keys !== _this._collection$_keys) throw A.wrapException(A.ConcurrentModificationError$(_this));
                }
            },
            _computeKeys$0: function() {
                var strings, index, names, entries, i, nums, rest, bucket, $length, i0, _this = this, result = _this._collection$_keys;
                if (result != null) return result;
                result = A.List_List$filled(_this._collection$_length, null, false, type$.dynamic);
                strings = _this._collection$_strings;
                index = 0;
                if (strings != null) {
                    names = Object.getOwnPropertyNames(strings);
                    entries = names.length;
                    for(i = 0; i < entries; ++i){
                        result[index] = names[i];
                        ++index;
                    }
                }
                nums = _this._collection$_nums;
                if (nums != null) {
                    names = Object.getOwnPropertyNames(nums);
                    entries = names.length;
                    for(i = 0; i < entries; ++i){
                        result[index] = +names[i];
                        ++index;
                    }
                }
                rest = _this._collection$_rest;
                if (rest != null) {
                    names = Object.getOwnPropertyNames(rest);
                    entries = names.length;
                    for(i = 0; i < entries; ++i){
                        bucket = rest[names[i]];
                        $length = bucket.length;
                        for(i0 = 0; i0 < $length; i0 += 2){
                            result[index] = bucket[i0];
                            ++index;
                        }
                    }
                }
                return _this._collection$_keys = result;
            },
            _collection$_addHashTableEntry$3: function(table, key, value) {
                if (table[key] == null) {
                    ++this._collection$_length;
                    this._collection$_keys = null;
                }
                A._HashMap__setTableEntry(table, key, value);
            },
            _removeHashTableEntry$2: function(table, key) {
                var value;
                if (table != null && table[key] != null) {
                    value = A._HashMap__getTableEntry(table, key);
                    delete table[key];
                    --this._collection$_length;
                    this._collection$_keys = null;
                    return value;
                } else return null;
            },
            _computeHashCode$1: function(key) {
                return J.get$hashCode$(key) & 1073741823;
            },
            _getBucket$2: function(table, key) {
                return table[this._computeHashCode$1(key)];
            },
            _findBucketIndex$2: function(bucket, key) {
                var $length, i;
                if (bucket == null) return -1;
                $length = bucket.length;
                for(i = 0; i < $length; i += 2)if (J.$eq$(bucket[i], key)) return i;
                return -1;
            }
        };
        A._HashMap_values_closure.prototype = {
            call$1: function(each) {
                var t1 = this.$this, t2 = t1.$index(0, each);
                return t2 == null ? A._instanceType(t1)._rest[1]._as(t2) : t2;
            },
            $signature: function() {
                return A._instanceType(this.$this)._eval$1("2(1)");
            }
        };
        A._HashMap_addAll_closure.prototype = {
            call$2: function(key, value) {
                this.$this.$indexSet(0, key, value);
            },
            $signature: function() {
                return A._instanceType(this.$this)._eval$1("~(1,2)");
            }
        };
        A._IdentityHashMap.prototype = {
            _computeHashCode$1: function(key) {
                return A.objectHashCode(key) & 1073741823;
            },
            _findBucketIndex$2: function(bucket, key) {
                var $length, i, t1;
                if (bucket == null) return -1;
                $length = bucket.length;
                for(i = 0; i < $length; i += 2){
                    t1 = bucket[i];
                    if (t1 == null ? key == null : t1 === key) return i;
                }
                return -1;
            }
        };
        A._HashMapKeyIterable.prototype = {
            get$length: function(_) {
                return this._map._collection$_length;
            },
            get$isEmpty: function(_) {
                return this._map._collection$_length === 0;
            },
            get$isNotEmpty: function(_) {
                return this._map._collection$_length !== 0;
            },
            get$iterator: function(_) {
                var t1 = this._map;
                return new A._HashMapKeyIterator(t1, t1._computeKeys$0(), this.$ti._eval$1("_HashMapKeyIterator<1>"));
            },
            contains$1: function(_, element) {
                return this._map.containsKey$1(element);
            }
        };
        A._HashMapKeyIterator.prototype = {
            get$current: function(_) {
                var t1 = this._collection$_current;
                return t1 == null ? this.$ti._precomputed1._as(t1) : t1;
            },
            moveNext$0: function() {
                var _this = this, keys = _this._collection$_keys, offset = _this._offset, t1 = _this._map;
                if (keys !== t1._collection$_keys) throw A.wrapException(A.ConcurrentModificationError$(t1));
                else if (offset >= keys.length) {
                    _this._collection$_current = null;
                    return false;
                } else {
                    _this._collection$_current = keys[offset];
                    _this._offset = offset + 1;
                    return true;
                }
            }
        };
        A._LinkedCustomHashMap.prototype = {
            $index: function(_, key) {
                if (!this._validKey.call$1(key)) return null;
                return this.super$JsLinkedHashMap$internalGet(key);
            },
            $indexSet: function(_, key, value) {
                this.super$JsLinkedHashMap$internalSet(key, value);
            },
            containsKey$1: function(key) {
                if (!this._validKey.call$1(key)) return false;
                return this.super$JsLinkedHashMap$internalContainsKey(key);
            },
            remove$1: function(_, key) {
                if (!this._validKey.call$1(key)) return null;
                return this.super$JsLinkedHashMap$internalRemove(key);
            },
            internalComputeHashCode$1: function(key) {
                return this._hashCode.call$1(key) & 1073741823;
            },
            internalFindBucketIndex$2: function(bucket, key) {
                var $length, t1, i;
                if (bucket == null) return -1;
                $length = bucket.length;
                for(t1 = this._equals, i = 0; i < $length; ++i)if (t1.call$2(bucket[i].hashMapCellKey, key)) return i;
                return -1;
            }
        };
        A._LinkedCustomHashMap_closure.prototype = {
            call$1: function(v) {
                return this.K._is(v);
            },
            $signature: 9
        };
        A._LinkedHashSet.prototype = {
            _newSet$0: function() {
                return new A._LinkedHashSet(A._instanceType(this)._eval$1("_LinkedHashSet<1>"));
            },
            _newSimilarSet$1$0: function($R) {
                return new A._LinkedHashSet($R._eval$1("_LinkedHashSet<0>"));
            },
            _newSimilarSet$0: function() {
                return this._newSimilarSet$1$0(type$.dynamic);
            },
            get$iterator: function(_) {
                var _this = this, t1 = new A._LinkedHashSetIterator(_this, _this._collection$_modifications, A._instanceType(_this)._eval$1("_LinkedHashSetIterator<1>"));
                t1._collection$_cell = _this._collection$_first;
                return t1;
            },
            get$length: function(_) {
                return this._collection$_length;
            },
            get$isEmpty: function(_) {
                return this._collection$_length === 0;
            },
            get$isNotEmpty: function(_) {
                return this._collection$_length !== 0;
            },
            contains$1: function(_, object) {
                var strings, nums;
                if (typeof object == "string" && object !== "__proto__") {
                    strings = this._collection$_strings;
                    if (strings == null) return false;
                    return strings[object] != null;
                } else if (typeof object == "number" && (object & 1073741823) === object) {
                    nums = this._collection$_nums;
                    if (nums == null) return false;
                    return nums[object] != null;
                } else return this._contains$1(object);
            },
            _contains$1: function(object) {
                var rest = this._collection$_rest;
                if (rest == null) return false;
                return this._findBucketIndex$2(rest[this._computeHashCode$1(object)], object) >= 0;
            },
            get$first: function(_) {
                var first = this._collection$_first;
                if (first == null) throw A.wrapException(A.StateError$("No elements"));
                return first._element;
            },
            get$last: function(_) {
                var last = this._collection$_last;
                if (last == null) throw A.wrapException(A.StateError$("No elements"));
                return last._element;
            },
            add$1: function(_, element) {
                var strings, nums, _this = this;
                if (typeof element == "string" && element !== "__proto__") {
                    strings = _this._collection$_strings;
                    return _this._collection$_addHashTableEntry$2(strings == null ? _this._collection$_strings = A._LinkedHashSet__newHashTable() : strings, element);
                } else if (typeof element == "number" && (element & 1073741823) === element) {
                    nums = _this._collection$_nums;
                    return _this._collection$_addHashTableEntry$2(nums == null ? _this._collection$_nums = A._LinkedHashSet__newHashTable() : nums, element);
                } else return _this._add$1(element);
            },
            _add$1: function(element) {
                var hash, bucket, _this = this, rest = _this._collection$_rest;
                if (rest == null) rest = _this._collection$_rest = A._LinkedHashSet__newHashTable();
                hash = _this._computeHashCode$1(element);
                bucket = rest[hash];
                if (bucket == null) rest[hash] = [
                    _this._collection$_newLinkedCell$1(element)
                ];
                else {
                    if (_this._findBucketIndex$2(bucket, element) >= 0) return false;
                    bucket.push(_this._collection$_newLinkedCell$1(element));
                }
                return true;
            },
            remove$1: function(_, object) {
                var _this = this;
                if (typeof object == "string" && object !== "__proto__") return _this._removeHashTableEntry$2(_this._collection$_strings, object);
                else if (typeof object == "number" && (object & 1073741823) === object) return _this._removeHashTableEntry$2(_this._collection$_nums, object);
                else return _this._remove$1(object);
            },
            _remove$1: function(object) {
                var hash, bucket, index, cell, _this = this, rest = _this._collection$_rest;
                if (rest == null) return false;
                hash = _this._computeHashCode$1(object);
                bucket = rest[hash];
                index = _this._findBucketIndex$2(bucket, object);
                if (index < 0) return false;
                cell = bucket.splice(index, 1)[0];
                if (0 === bucket.length) delete rest[hash];
                _this._unlinkCell$1(cell);
                return true;
            },
            _collection$_addHashTableEntry$2: function(table, element) {
                if (table[element] != null) return false;
                table[element] = this._collection$_newLinkedCell$1(element);
                return true;
            },
            _removeHashTableEntry$2: function(table, element) {
                var cell;
                if (table == null) return false;
                cell = table[element];
                if (cell == null) return false;
                this._unlinkCell$1(cell);
                delete table[element];
                return true;
            },
            _collection$_modified$0: function() {
                this._collection$_modifications = this._collection$_modifications + 1 & 1073741823;
            },
            _collection$_newLinkedCell$1: function(element) {
                var t1, _this = this, cell = new A._LinkedHashSetCell(element);
                if (_this._collection$_first == null) _this._collection$_first = _this._collection$_last = cell;
                else {
                    t1 = _this._collection$_last;
                    t1.toString;
                    cell._collection$_previous = t1;
                    _this._collection$_last = t1._collection$_next = cell;
                }
                ++_this._collection$_length;
                _this._collection$_modified$0();
                return cell;
            },
            _unlinkCell$1: function(cell) {
                var _this = this, previous = cell._collection$_previous, next = cell._collection$_next;
                if (previous == null) _this._collection$_first = next;
                else previous._collection$_next = next;
                if (next == null) _this._collection$_last = previous;
                else next._collection$_previous = previous;
                --_this._collection$_length;
                _this._collection$_modified$0();
            },
            _computeHashCode$1: function(element) {
                return J.get$hashCode$(element) & 1073741823;
            },
            _findBucketIndex$2: function(bucket, element) {
                var $length, i;
                if (bucket == null) return -1;
                $length = bucket.length;
                for(i = 0; i < $length; ++i)if (J.$eq$(bucket[i]._element, element)) return i;
                return -1;
            }
        };
        A._LinkedIdentityHashSet.prototype = {
            _newSet$0: function() {
                return new A._LinkedIdentityHashSet(this.$ti);
            },
            _newSimilarSet$1$0: function($R) {
                return new A._LinkedIdentityHashSet($R._eval$1("_LinkedIdentityHashSet<0>"));
            },
            _newSimilarSet$0: function() {
                return this._newSimilarSet$1$0(type$.dynamic);
            },
            _computeHashCode$1: function(key) {
                return A.objectHashCode(key) & 1073741823;
            },
            _findBucketIndex$2: function(bucket, element) {
                var $length, i, t1;
                if (bucket == null) return -1;
                $length = bucket.length;
                for(i = 0; i < $length; ++i){
                    t1 = bucket[i]._element;
                    if (t1 == null ? element == null : t1 === element) return i;
                }
                return -1;
            }
        };
        A._LinkedHashSetCell.prototype = {};
        A._LinkedHashSetIterator.prototype = {
            get$current: function(_) {
                var t1 = this._collection$_current;
                return t1 == null ? this.$ti._precomputed1._as(t1) : t1;
            },
            moveNext$0: function() {
                var _this = this, cell = _this._collection$_cell, t1 = _this._set;
                if (_this._collection$_modifications !== t1._collection$_modifications) throw A.wrapException(A.ConcurrentModificationError$(t1));
                else if (cell == null) {
                    _this._collection$_current = null;
                    return false;
                } else {
                    _this._collection$_current = cell._element;
                    _this._collection$_cell = cell._collection$_next;
                    return true;
                }
            }
        };
        A.UnmodifiableListView.prototype = {
            cast$1$0: function(_, $R) {
                return new A.UnmodifiableListView(J.cast$1$0$ax(this._collection$_source, $R), $R._eval$1("UnmodifiableListView<0>"));
            },
            get$length: function(_) {
                return J.get$length$asx(this._collection$_source);
            },
            $index: function(_, index) {
                return J.elementAt$1$ax(this._collection$_source, index);
            }
        };
        A.HashMap_HashMap$from_closure.prototype = {
            call$2: function(k, v) {
                this.result.$indexSet(0, this.K._as(k), this.V._as(v));
            },
            $signature: 159
        };
        A.LinkedHashMap_LinkedHashMap$from_closure.prototype = {
            call$2: function(k, v) {
                this.result.$indexSet(0, this.K._as(k), this.V._as(v));
            },
            $signature: 159
        };
        A.ListBase.prototype = {
            get$iterator: function(receiver) {
                return new A.ListIterator(receiver, this.get$length(receiver), A.instanceType(receiver)._eval$1("ListIterator<ListBase.E>"));
            },
            elementAt$1: function(receiver, index) {
                return this.$index(receiver, index);
            },
            forEach$1: function(receiver, action) {
                var i, $length = this.get$length(receiver);
                for(i = 0; i < $length; ++i){
                    action.call$1(this.$index(receiver, i));
                    if ($length !== this.get$length(receiver)) throw A.wrapException(A.ConcurrentModificationError$(receiver));
                }
            },
            get$isEmpty: function(receiver) {
                return this.get$length(receiver) === 0;
            },
            get$isNotEmpty: function(receiver) {
                return !this.get$isEmpty(receiver);
            },
            get$first: function(receiver) {
                if (this.get$length(receiver) === 0) throw A.wrapException(A.IterableElementError_noElement());
                return this.$index(receiver, 0);
            },
            get$last: function(receiver) {
                if (this.get$length(receiver) === 0) throw A.wrapException(A.IterableElementError_noElement());
                return this.$index(receiver, this.get$length(receiver) - 1);
            },
            get$single: function(receiver) {
                if (this.get$length(receiver) === 0) throw A.wrapException(A.IterableElementError_noElement());
                if (this.get$length(receiver) > 1) throw A.wrapException(A.IterableElementError_tooMany());
                return this.$index(receiver, 0);
            },
            contains$1: function(receiver, element) {
                var i, $length = this.get$length(receiver);
                for(i = 0; i < $length; ++i){
                    if (J.$eq$(this.$index(receiver, i), element)) return true;
                    if ($length !== this.get$length(receiver)) throw A.wrapException(A.ConcurrentModificationError$(receiver));
                }
                return false;
            },
            every$1: function(receiver, test) {
                var i, $length = this.get$length(receiver);
                for(i = 0; i < $length; ++i){
                    if (!test.call$1(this.$index(receiver, i))) return false;
                    if ($length !== this.get$length(receiver)) throw A.wrapException(A.ConcurrentModificationError$(receiver));
                }
                return true;
            },
            any$1: function(receiver, test) {
                var i, $length = this.get$length(receiver);
                for(i = 0; i < $length; ++i){
                    if (test.call$1(this.$index(receiver, i))) return true;
                    if ($length !== this.get$length(receiver)) throw A.wrapException(A.ConcurrentModificationError$(receiver));
                }
                return false;
            },
            lastWhere$2$orElse: function(receiver, test, orElse) {
                var i, element, $length = this.get$length(receiver);
                for(i = $length - 1; i >= 0; --i){
                    element = this.$index(receiver, i);
                    if (test.call$1(element)) return element;
                    if ($length !== this.get$length(receiver)) throw A.wrapException(A.ConcurrentModificationError$(receiver));
                }
                if (orElse != null) return orElse.call$0();
                throw A.wrapException(A.IterableElementError_noElement());
            },
            join$1: function(receiver, separator) {
                var t1;
                if (this.get$length(receiver) === 0) return "";
                t1 = A.StringBuffer__writeAll("", receiver, separator);
                return t1.charCodeAt(0) == 0 ? t1 : t1;
            },
            where$1: function(receiver, test) {
                return new A.WhereIterable(receiver, test, A.instanceType(receiver)._eval$1("WhereIterable<ListBase.E>"));
            },
            map$1$1: function(receiver, f, $T) {
                return new A.MappedListIterable(receiver, f, A.instanceType(receiver)._eval$1("@<ListBase.E>")._bind$1($T)._eval$1("MappedListIterable<1,2>"));
            },
            expand$1$1: function(receiver, f, $T) {
                return new A.ExpandIterable(receiver, f, A.instanceType(receiver)._eval$1("@<ListBase.E>")._bind$1($T)._eval$1("ExpandIterable<1,2>"));
            },
            skip$1: function(receiver, count) {
                return A.SubListIterable$(receiver, count, null, A.instanceType(receiver)._eval$1("ListBase.E"));
            },
            take$1: function(receiver, count) {
                return A.SubListIterable$(receiver, 0, A.checkNotNullable(count, "count", type$.int), A.instanceType(receiver)._eval$1("ListBase.E"));
            },
            toList$1$growable: function(receiver, growable) {
                var t1, first, result, i, _this = this;
                if (_this.get$isEmpty(receiver)) {
                    t1 = J.JSArray_JSArray$growable(0, A.instanceType(receiver)._eval$1("ListBase.E"));
                    return t1;
                }
                first = _this.$index(receiver, 0);
                result = A.List_List$filled(_this.get$length(receiver), first, true, A.instanceType(receiver)._eval$1("ListBase.E"));
                for(i = 1; i < _this.get$length(receiver); ++i)result[i] = _this.$index(receiver, i);
                return result;
            },
            toList$0: function(receiver) {
                return this.toList$1$growable(receiver, true);
            },
            toSet$0: function(receiver) {
                var i, result = A.LinkedHashSet_LinkedHashSet(A.instanceType(receiver)._eval$1("ListBase.E"));
                for(i = 0; i < this.get$length(receiver); ++i)result.add$1(0, this.$index(receiver, i));
                return result;
            },
            add$1: function(receiver, element) {
                var t1 = this.get$length(receiver);
                this.set$length(receiver, t1 + 1);
                this.$indexSet(receiver, t1, element);
            },
            addAll$1: function(receiver, iterable) {
                var t1, i = this.get$length(receiver);
                for(t1 = iterable.get$iterator(iterable); t1.moveNext$0();){
                    this.add$1(receiver, t1.get$current(t1));
                    ++i;
                }
            },
            _closeGap$2: function(receiver, start, end) {
                var i, _this = this, $length = _this.get$length(receiver), size = end - start;
                for(i = end; i < $length; ++i)_this.$indexSet(receiver, i - size, _this.$index(receiver, i));
                _this.set$length(receiver, $length - size);
            },
            cast$1$0: function(receiver, $R) {
                return new A.CastList(receiver, A.instanceType(receiver)._eval$1("@<ListBase.E>")._bind$1($R)._eval$1("CastList<1,2>"));
            },
            sort$1: function(receiver, compare) {
                var t1 = compare == null ? A.collection_ListBase__compareAny$closure() : compare;
                A.Sort__doSort(receiver, 0, this.get$length(receiver) - 1, t1);
            },
            sublist$2: function(receiver, start, end) {
                var t1, listLength = this.get$length(receiver);
                A.RangeError_checkValidRange(start, listLength, listLength);
                t1 = A.List_List$_of(this.getRange$2(receiver, start, listLength), A.instanceType(receiver)._eval$1("ListBase.E"));
                return t1;
            },
            sublist$1: function(receiver, start) {
                return this.sublist$2(receiver, start, null);
            },
            getRange$2: function(receiver, start, end) {
                A.RangeError_checkValidRange(start, end, this.get$length(receiver));
                return A.SubListIterable$(receiver, start, end, A.instanceType(receiver)._eval$1("ListBase.E"));
            },
            removeRange$2: function(receiver, start, end) {
                A.RangeError_checkValidRange(start, end, this.get$length(receiver));
                if (end > start) this._closeGap$2(receiver, start, end);
            },
            fillRange$3: function(receiver, start, end, fill) {
                var i, value = fill == null ? A.instanceType(receiver)._eval$1("ListBase.E")._as(fill) : fill;
                A.RangeError_checkValidRange(start, end, this.get$length(receiver));
                for(i = start; i < end; ++i)this.$indexSet(receiver, i, value);
            },
            setRange$4: function(receiver, start, end, iterable, skipCount) {
                var $length, otherStart, otherList, t1, i;
                A.RangeError_checkValidRange(start, end, this.get$length(receiver));
                $length = end - start;
                if ($length === 0) return;
                A.RangeError_checkNotNegative(skipCount, "skipCount");
                if (type$.List_dynamic._is(iterable)) {
                    otherStart = skipCount;
                    otherList = iterable;
                } else {
                    otherList = J.skip$1$ax(iterable, skipCount).toList$1$growable(0, false);
                    otherStart = 0;
                }
                t1 = J.getInterceptor$asx(otherList);
                if (otherStart + $length > t1.get$length(otherList)) throw A.wrapException(A.IterableElementError_tooFew());
                if (otherStart < start) for(i = $length - 1; i >= 0; --i)this.$indexSet(receiver, start + i, t1.$index(otherList, otherStart + i));
                else for(i = 0; i < $length; ++i)this.$indexSet(receiver, start + i, t1.$index(otherList, otherStart + i));
            },
            get$reversed: function(receiver) {
                return new A.ReversedListIterable(receiver, A.instanceType(receiver)._eval$1("ReversedListIterable<ListBase.E>"));
            },
            toString$0: function(receiver) {
                return A.Iterable_iterableToFullString(receiver, "[", "]");
            },
            $isEfficientLengthIterable: 1,
            $isIterable: 1,
            $isList: 1
        };
        A.MapBase.prototype = {
            cast$2$0: function(_, $RK, $RV) {
                var t1 = A._instanceType(this);
                return A.Map_castFrom(this, t1._eval$1("MapBase.K"), t1._eval$1("MapBase.V"), $RK, $RV);
            },
            forEach$1: function(_, action) {
                var t1, t2, key, t3, _this = this;
                for(t1 = _this.get$keys(_this), t1 = t1.get$iterator(t1), t2 = A._instanceType(_this)._eval$1("MapBase.V"); t1.moveNext$0();){
                    key = t1.get$current(t1);
                    t3 = _this.$index(0, key);
                    action.call$2(key, t3 == null ? t2._as(t3) : t3);
                }
            },
            addAll$1: function(_, other) {
                other.forEach$1(0, new A.MapBase_addAll_closure(this));
            },
            get$entries: function(_) {
                var _this = this, t1 = _this.get$keys(_this);
                return t1.map$1$1(t1, new A.MapBase_entries_closure(_this), A._instanceType(_this)._eval$1("MapEntry<MapBase.K,MapBase.V>"));
            },
            containsKey$1: function(key) {
                var t1 = this.get$keys(this);
                return t1.contains$1(t1, key);
            },
            get$length: function(_) {
                var t1 = this.get$keys(this);
                return t1.get$length(t1);
            },
            get$isEmpty: function(_) {
                var t1 = this.get$keys(this);
                return t1.get$isEmpty(t1);
            },
            get$isNotEmpty: function(_) {
                var t1 = this.get$keys(this);
                return t1.get$isNotEmpty(t1);
            },
            get$values: function(_) {
                return new A._MapBaseValueIterable(this, A._instanceType(this)._eval$1("_MapBaseValueIterable<MapBase.K,MapBase.V>"));
            },
            toString$0: function(_) {
                return A.MapBase_mapToString(this);
            },
            $isMap: 1
        };
        A.MapBase_addAll_closure.prototype = {
            call$2: function(key, value) {
                this.$this.$indexSet(0, key, value);
            },
            $signature: function() {
                return A._instanceType(this.$this)._eval$1("~(MapBase.K,MapBase.V)");
            }
        };
        A.MapBase_entries_closure.prototype = {
            call$1: function(key) {
                var t1 = this.$this, t2 = t1.$index(0, key);
                if (t2 == null) t2 = A._instanceType(t1)._eval$1("MapBase.V")._as(t2);
                return new A.MapEntry(key, t2, A._instanceType(t1)._eval$1("MapEntry<MapBase.K,MapBase.V>"));
            },
            $signature: function() {
                return A._instanceType(this.$this)._eval$1("MapEntry<MapBase.K,MapBase.V>(MapBase.K)");
            }
        };
        A.MapBase_mapToString_closure.prototype = {
            call$2: function(k, v) {
                var t2, t1 = this._box_0;
                if (!t1.first) this.result._contents += ", ";
                t1.first = false;
                t1 = this.result;
                t2 = A.S(k);
                t1._contents = (t1._contents += t2) + ": ";
                t2 = A.S(v);
                t1._contents += t2;
            },
            $signature: 162
        };
        A.UnmodifiableMapBase.prototype = {};
        A._MapBaseValueIterable.prototype = {
            get$length: function(_) {
                var t1 = this._map;
                return t1.get$length(t1);
            },
            get$isEmpty: function(_) {
                var t1 = this._map;
                return t1.get$isEmpty(t1);
            },
            get$isNotEmpty: function(_) {
                var t1 = this._map;
                return t1.get$isNotEmpty(t1);
            },
            get$first: function(_) {
                var t1 = this._map, t2 = t1.get$keys(t1);
                t2 = t1.$index(0, t2.get$first(t2));
                return t2 == null ? this.$ti._rest[1]._as(t2) : t2;
            },
            get$single: function(_) {
                var t1 = this._map, t2 = t1.get$keys(t1);
                t2 = t1.$index(0, t2.get$single(t2));
                return t2 == null ? this.$ti._rest[1]._as(t2) : t2;
            },
            get$last: function(_) {
                var t1 = this._map, t2 = t1.get$keys(t1);
                t2 = t1.$index(0, t2.get$last(t2));
                return t2 == null ? this.$ti._rest[1]._as(t2) : t2;
            },
            get$iterator: function(_) {
                var t1 = this._map, t2 = t1.get$keys(t1);
                return new A._MapBaseValueIterator(t2.get$iterator(t2), t1, this.$ti._eval$1("_MapBaseValueIterator<1,2>"));
            }
        };
        A._MapBaseValueIterator.prototype = {
            moveNext$0: function() {
                var _this = this, t1 = _this._collection$_keys;
                if (t1.moveNext$0()) {
                    _this._collection$_current = _this._map.$index(0, t1.get$current(t1));
                    return true;
                }
                _this._collection$_current = null;
                return false;
            },
            get$current: function(_) {
                var t1 = this._collection$_current;
                return t1 == null ? this.$ti._rest[1]._as(t1) : t1;
            }
        };
        A._UnmodifiableMapMixin.prototype = {
            $indexSet: function(_, key, value) {
                throw A.wrapException(A.UnsupportedError$("Cannot modify unmodifiable map"));
            },
            addAll$1: function(_, other) {
                throw A.wrapException(A.UnsupportedError$("Cannot modify unmodifiable map"));
            },
            remove$1: function(_, key) {
                throw A.wrapException(A.UnsupportedError$("Cannot modify unmodifiable map"));
            }
        };
        A.MapView.prototype = {
            cast$2$0: function(_, $RK, $RV) {
                return this._map.cast$2$0(0, $RK, $RV);
            },
            $index: function(_, key) {
                return this._map.$index(0, key);
            },
            $indexSet: function(_, key, value) {
                this._map.$indexSet(0, key, value);
            },
            addAll$1: function(_, other) {
                this._map.addAll$1(0, other);
            },
            containsKey$1: function(key) {
                return this._map.containsKey$1(key);
            },
            forEach$1: function(_, action) {
                this._map.forEach$1(0, action);
            },
            get$isEmpty: function(_) {
                var t1 = this._map;
                return t1.get$isEmpty(t1);
            },
            get$isNotEmpty: function(_) {
                var t1 = this._map;
                return t1.get$isNotEmpty(t1);
            },
            get$length: function(_) {
                var t1 = this._map;
                return t1.get$length(t1);
            },
            get$keys: function(_) {
                var t1 = this._map;
                return t1.get$keys(t1);
            },
            remove$1: function(_, key) {
                return this._map.remove$1(0, key);
            },
            toString$0: function(_) {
                return this._map.toString$0(0);
            },
            get$values: function(_) {
                var t1 = this._map;
                return t1.get$values(t1);
            },
            get$entries: function(_) {
                var t1 = this._map;
                return t1.get$entries(t1);
            },
            $isMap: 1
        };
        A.UnmodifiableMapView.prototype = {
            cast$2$0: function(_, $RK, $RV) {
                return new A.UnmodifiableMapView(this._map.cast$2$0(0, $RK, $RV), $RK._eval$1("@<0>")._bind$1($RV)._eval$1("UnmodifiableMapView<1,2>"));
            }
        };
        A.ListQueue.prototype = {
            get$iterator: function(_) {
                var _this = this;
                return new A._ListQueueIterator(_this, _this._tail, _this._modificationCount, _this._head, _this.$ti._eval$1("_ListQueueIterator<1>"));
            },
            get$isEmpty: function(_) {
                return this._head === this._tail;
            },
            get$length: function(_) {
                return (this._tail - this._head & this._table.length - 1) >>> 0;
            },
            get$first: function(_) {
                var _this = this, t1 = _this._head;
                if (t1 === _this._tail) throw A.wrapException(A.IterableElementError_noElement());
                t1 = _this._table[t1];
                return t1 == null ? _this.$ti._precomputed1._as(t1) : t1;
            },
            get$last: function(_) {
                var _this = this, t1 = _this._head, t2 = _this._tail;
                if (t1 === t2) throw A.wrapException(A.IterableElementError_noElement());
                t1 = _this._table;
                t1 = t1[(t2 - 1 & t1.length - 1) >>> 0];
                return t1 == null ? _this.$ti._precomputed1._as(t1) : t1;
            },
            get$single: function(_) {
                var t1, _this = this;
                if (_this._head === _this._tail) throw A.wrapException(A.IterableElementError_noElement());
                if (_this.get$length(0) > 1) throw A.wrapException(A.IterableElementError_tooMany());
                t1 = _this._table[_this._head];
                return t1 == null ? _this.$ti._precomputed1._as(t1) : t1;
            },
            elementAt$1: function(_, index) {
                var t1, _this = this;
                A.IndexError_check(index, _this.get$length(0), _this, null, null);
                t1 = _this._table;
                t1 = t1[(_this._head + index & t1.length - 1) >>> 0];
                return t1 == null ? _this.$ti._precomputed1._as(t1) : t1;
            },
            toList$1$growable: function(_, growable) {
                var t1, list, t2, t3, i, t4, _this = this, mask = _this._table.length - 1, $length = (_this._tail - _this._head & mask) >>> 0;
                if ($length === 0) {
                    t1 = J.JSArray_JSArray$growable(0, _this.$ti._precomputed1);
                    return t1;
                }
                t1 = _this.$ti._precomputed1;
                list = A.List_List$filled($length, _this.get$first(0), true, t1);
                for(t2 = _this._table, t3 = _this._head, i = 0; i < $length; ++i){
                    t4 = t2[(t3 + i & mask) >>> 0];
                    list[i] = t4 == null ? t1._as(t4) : t4;
                }
                return list;
            },
            toList$0: function(_) {
                return this.toList$1$growable(0, true);
            },
            addAll$1: function(_, elements) {
                var newTable, endSpace, preSpace, _this = this, addCount = elements.length, $length = _this.get$length(0), t1 = $length + addCount, t2 = _this._table, t3 = t2.length;
                if (t1 >= t3) {
                    newTable = A.List_List$filled(A.ListQueue__nextPowerOf2(t1 + (t1 >>> 1)), null, false, _this.$ti._eval$1("1?"));
                    _this._tail = _this._collection$_writeToList$1(newTable);
                    _this._table = newTable;
                    _this._head = 0;
                    B.JSArray_methods.setRange$4(newTable, $length, t1, elements, 0);
                    _this._tail += addCount;
                } else {
                    t1 = _this._tail;
                    endSpace = t3 - t1;
                    if (addCount < endSpace) {
                        B.JSArray_methods.setRange$4(t2, t1, t1 + addCount, elements, 0);
                        _this._tail += addCount;
                    } else {
                        preSpace = addCount - endSpace;
                        B.JSArray_methods.setRange$4(t2, t1, t1 + endSpace, elements, 0);
                        B.JSArray_methods.setRange$4(_this._table, 0, preSpace, elements, endSpace);
                        _this._tail = preSpace;
                    }
                }
                ++_this._modificationCount;
            },
            clear$0: function(_) {
                var t2, t3, _this = this, i = _this._head, t1 = _this._tail;
                if (i !== t1) {
                    for(t2 = _this._table, t3 = t2.length - 1; i !== t1; i = (i + 1 & t3) >>> 0)t2[i] = null;
                    _this._head = _this._tail = 0;
                    ++_this._modificationCount;
                }
            },
            toString$0: function(_) {
                return A.Iterable_iterableToFullString(this, "{", "}");
            },
            addFirst$1: function(value) {
                var _this = this, t1 = _this._head, t2 = _this._table;
                t1 = _this._head = (t1 - 1 & t2.length - 1) >>> 0;
                t2[t1] = value;
                if (t1 === _this._tail) _this._grow$0();
                ++_this._modificationCount;
            },
            removeFirst$0: function() {
                var t2, result, _this = this, t1 = _this._head;
                if (t1 === _this._tail) throw A.wrapException(A.IterableElementError_noElement());
                ++_this._modificationCount;
                t2 = _this._table;
                result = t2[t1];
                if (result == null) result = _this.$ti._precomputed1._as(result);
                t2[t1] = null;
                _this._head = (t1 + 1 & t2.length - 1) >>> 0;
                return result;
            },
            _add$1: function(element) {
                var _this = this, t1 = _this._table, t2 = _this._tail;
                t1[t2] = element;
                t1 = (t2 + 1 & t1.length - 1) >>> 0;
                _this._tail = t1;
                if (_this._head === t1) _this._grow$0();
                ++_this._modificationCount;
            },
            _grow$0: function() {
                var _this = this, newTable = A.List_List$filled(_this._table.length * 2, null, false, _this.$ti._eval$1("1?")), t1 = _this._table, t2 = _this._head, split = t1.length - t2;
                B.JSArray_methods.setRange$4(newTable, 0, split, t1, t2);
                B.JSArray_methods.setRange$4(newTable, split, split + _this._head, _this._table, 0);
                _this._head = 0;
                _this._tail = _this._table.length;
                _this._table = newTable;
            },
            _collection$_writeToList$1: function(target) {
                var $length, firstPartSize, _this = this, t1 = _this._head, t2 = _this._tail, t3 = _this._table;
                if (t1 <= t2) {
                    $length = t2 - t1;
                    B.JSArray_methods.setRange$4(target, 0, $length, t3, t1);
                    return $length;
                } else {
                    firstPartSize = t3.length - t1;
                    B.JSArray_methods.setRange$4(target, 0, firstPartSize, t3, t1);
                    B.JSArray_methods.setRange$4(target, firstPartSize, firstPartSize + _this._tail, _this._table, 0);
                    return _this._tail + firstPartSize;
                }
            },
            $isQueue: 1
        };
        A._ListQueueIterator.prototype = {
            get$current: function(_) {
                var t1 = this._collection$_current;
                return t1 == null ? this.$ti._precomputed1._as(t1) : t1;
            },
            moveNext$0: function() {
                var t2, _this = this, t1 = _this._queue;
                if (_this._modificationCount !== t1._modificationCount) A.throwExpression(A.ConcurrentModificationError$(t1));
                t2 = _this._collection$_position;
                if (t2 === _this._collection$_end) {
                    _this._collection$_current = null;
                    return false;
                }
                t1 = t1._table;
                _this._collection$_current = t1[t2];
                _this._collection$_position = (t2 + 1 & t1.length - 1) >>> 0;
                return true;
            }
        };
        A.SetBase.prototype = {
            get$isEmpty: function(_) {
                return this.get$length(this) === 0;
            },
            get$isNotEmpty: function(_) {
                return this.get$length(this) !== 0;
            },
            addAll$1: function(_, elements) {
                var t1;
                for(t1 = J.get$iterator$ax(elements); t1.moveNext$0();)this.add$1(0, t1.get$current(t1));
            },
            removeAll$1: function(elements) {
                var t1;
                for(t1 = J.get$iterator$ax(elements); t1.moveNext$0();)this.remove$1(0, t1.get$current(t1));
            },
            difference$1: function(other) {
                var t1, t2, element, result = this.toSet$0(0);
                for(t1 = this.get$iterator(this), t2 = other._source; t1.moveNext$0();){
                    element = t1.get$current(t1);
                    if (t2.contains$1(0, element)) result.remove$1(0, element);
                }
                return result;
            },
            toList$1$growable: function(_, growable) {
                var t1 = A.List_List$_of(this, A._instanceType(this)._precomputed1);
                return t1;
            },
            toList$0: function(_) {
                return this.toList$1$growable(0, true);
            },
            map$1$1: function(_, f, $T) {
                return new A.EfficientLengthMappedIterable(this, f, A._instanceType(this)._eval$1("@<1>")._bind$1($T)._eval$1("EfficientLengthMappedIterable<1,2>"));
            },
            get$single: function(_) {
                var it, _this = this;
                if (_this.get$length(_this) > 1) throw A.wrapException(A.IterableElementError_tooMany());
                it = _this.get$iterator(_this);
                if (!it.moveNext$0()) throw A.wrapException(A.IterableElementError_noElement());
                return it.get$current(it);
            },
            toString$0: function(_) {
                return A.Iterable_iterableToFullString(this, "{", "}");
            },
            where$1: function(_, f) {
                return new A.WhereIterable(this, f, A._instanceType(this)._eval$1("WhereIterable<1>"));
            },
            forEach$1: function(_, f) {
                var t1;
                for(t1 = this.get$iterator(this); t1.moveNext$0();)f.call$1(t1.get$current(t1));
            },
            every$1: function(_, f) {
                var t1;
                for(t1 = this.get$iterator(this); t1.moveNext$0();)if (!f.call$1(t1.get$current(t1))) return false;
                return true;
            },
            any$1: function(_, test) {
                var t1;
                for(t1 = this.get$iterator(this); t1.moveNext$0();)if (test.call$1(t1.get$current(t1))) return true;
                return false;
            },
            take$1: function(_, n) {
                return A.TakeIterable_TakeIterable(this, n, A._instanceType(this)._precomputed1);
            },
            skip$1: function(_, n) {
                return A.SkipIterable_SkipIterable(this, n, A._instanceType(this)._precomputed1);
            },
            get$first: function(_) {
                var it = this.get$iterator(this);
                if (!it.moveNext$0()) throw A.wrapException(A.IterableElementError_noElement());
                return it.get$current(it);
            },
            get$last: function(_) {
                var result, it = this.get$iterator(this);
                if (!it.moveNext$0()) throw A.wrapException(A.IterableElementError_noElement());
                do result = it.get$current(it);
                while (it.moveNext$0());
                return result;
            },
            elementAt$1: function(_, index) {
                var iterator, skipCount;
                A.RangeError_checkNotNegative(index, "index");
                iterator = this.get$iterator(this);
                for(skipCount = index; iterator.moveNext$0();){
                    if (skipCount === 0) return iterator.get$current(iterator);
                    --skipCount;
                }
                throw A.wrapException(A.IndexError$withLength(index, index - skipCount, this, null, "index"));
            },
            $isEfficientLengthIterable: 1,
            $isIterable: 1,
            $isSet: 1
        };
        A._SetBase.prototype = {
            difference$1: function(other) {
                var t1, t2, element, _this = this, result = _this._newSet$0();
                for(t1 = A._LinkedHashSetIterator$(_this, _this._collection$_modifications, A._instanceType(_this)._precomputed1), t2 = t1.$ti._precomputed1; t1.moveNext$0();){
                    element = t1._collection$_current;
                    if (element == null) element = t2._as(element);
                    if (!other.contains$1(0, element)) result.add$1(0, element);
                }
                return result;
            },
            intersection$1: function(other) {
                var t1, t2, element, _this = this, result = _this._newSet$0();
                for(t1 = A._LinkedHashSetIterator$(_this, _this._collection$_modifications, A._instanceType(_this)._precomputed1), t2 = t1.$ti._precomputed1; t1.moveNext$0();){
                    element = t1._collection$_current;
                    if (element == null) element = t2._as(element);
                    if (other.contains$1(0, element)) result.add$1(0, element);
                }
                return result;
            },
            toSet$0: function(_) {
                var t1 = this._newSet$0();
                t1.addAll$1(0, this);
                return t1;
            }
        };
        A._UnmodifiableSetMixin.prototype = {
            add$1: function(_, value) {
                return A._UnmodifiableSetMixin__throwUnmodifiable();
            },
            addAll$1: function(_, elements) {
                return A._UnmodifiableSetMixin__throwUnmodifiable();
            },
            remove$1: function(_, value) {
                return A._UnmodifiableSetMixin__throwUnmodifiable();
            }
        };
        A.UnmodifiableSetView.prototype = {
            contains$1: function(_, element) {
                return this._collection$_source.contains$1(0, element);
            },
            get$length: function(_) {
                return this._collection$_source._collection$_length;
            },
            get$iterator: function(_) {
                var t1 = this._collection$_source;
                return A._LinkedHashSetIterator$(t1, t1._collection$_modifications, A._instanceType(t1)._precomputed1);
            },
            toSet$0: function(_) {
                return this._collection$_source.toSet$0(0);
            }
        };
        A._UnmodifiableMapView_MapView__UnmodifiableMapMixin.prototype = {};
        A._UnmodifiableSetView_SetBase__UnmodifiableSetMixin.prototype = {};
        A._JsonMap.prototype = {
            $index: function(_, key) {
                var result, t1 = this._processed;
                if (t1 == null) return this._data.$index(0, key);
                else if (typeof key != "string") return null;
                else {
                    result = t1[key];
                    return typeof result == "undefined" ? this._process$1(key) : result;
                }
            },
            get$length: function(_) {
                return this._processed == null ? this._data.__js_helper$_length : this._convert$_computeKeys$0().length;
            },
            get$isEmpty: function(_) {
                return this.get$length(0) === 0;
            },
            get$isNotEmpty: function(_) {
                return this.get$length(0) > 0;
            },
            get$keys: function(_) {
                var t1;
                if (this._processed == null) {
                    t1 = this._data;
                    return new A.LinkedHashMapKeysIterable(t1, A._instanceType(t1)._eval$1("LinkedHashMapKeysIterable<1>"));
                }
                return new A._JsonMapKeyIterable(this);
            },
            get$values: function(_) {
                var t1, _this = this;
                if (_this._processed == null) {
                    t1 = _this._data;
                    return new A.LinkedHashMapValuesIterable(t1, A._instanceType(t1)._eval$1("LinkedHashMapValuesIterable<2>"));
                }
                return A.MappedIterable_MappedIterable(_this._convert$_computeKeys$0(), new A._JsonMap_values_closure(_this), type$.String, type$.dynamic);
            },
            $indexSet: function(_, key, value) {
                var processed, original, _this = this;
                if (_this._processed == null) _this._data.$indexSet(0, key, value);
                else if (_this.containsKey$1(key)) {
                    processed = _this._processed;
                    processed[key] = value;
                    original = _this._original;
                    if (original == null ? processed != null : original !== processed) original[key] = null;
                } else _this._upgrade$0().$indexSet(0, key, value);
            },
            addAll$1: function(_, other) {
                other.forEach$1(0, new A._JsonMap_addAll_closure(this));
            },
            containsKey$1: function(key) {
                if (this._processed == null) return this._data.containsKey$1(key);
                if (typeof key != "string") return false;
                return Object.prototype.hasOwnProperty.call(this._original, key);
            },
            remove$1: function(_, key) {
                if (this._processed != null && !this.containsKey$1(key)) return null;
                return this._upgrade$0().remove$1(0, key);
            },
            forEach$1: function(_, f) {
                var keys, i, key, value, _this = this;
                if (_this._processed == null) return _this._data.forEach$1(0, f);
                keys = _this._convert$_computeKeys$0();
                for(i = 0; i < keys.length; ++i){
                    key = keys[i];
                    value = _this._processed[key];
                    if (typeof value == "undefined") {
                        value = A._convertJsonToDartLazy(_this._original[key]);
                        _this._processed[key] = value;
                    }
                    f.call$2(key, value);
                    if (keys !== _this._data) throw A.wrapException(A.ConcurrentModificationError$(_this));
                }
            },
            _convert$_computeKeys$0: function() {
                var keys = this._data;
                if (keys == null) keys = this._data = A._setArrayType(Object.keys(this._original), type$.JSArray_String);
                return keys;
            },
            _upgrade$0: function() {
                var result, keys, i, t1, key, _this = this;
                if (_this._processed == null) return _this._data;
                result = A.LinkedHashMap_LinkedHashMap$_empty(type$.String, type$.dynamic);
                keys = _this._convert$_computeKeys$0();
                for(i = 0; t1 = keys.length, i < t1; ++i){
                    key = keys[i];
                    result.$indexSet(0, key, _this.$index(0, key));
                }
                if (t1 === 0) keys.push("");
                else B.JSArray_methods.clear$0(keys);
                _this._original = _this._processed = null;
                return _this._data = result;
            },
            _process$1: function(key) {
                var result;
                if (!Object.prototype.hasOwnProperty.call(this._original, key)) return null;
                result = A._convertJsonToDartLazy(this._original[key]);
                return this._processed[key] = result;
            }
        };
        A._JsonMap_values_closure.prototype = {
            call$1: function(each) {
                return this.$this.$index(0, each);
            },
            $signature: 186
        };
        A._JsonMap_addAll_closure.prototype = {
            call$2: function(key, value) {
                this.$this.$indexSet(0, key, value);
            },
            $signature: 140
        };
        A._JsonMapKeyIterable.prototype = {
            get$length: function(_) {
                return this._convert$_parent.get$length(0);
            },
            elementAt$1: function(_, index) {
                var t1 = this._convert$_parent;
                return t1._processed == null ? t1.get$keys(0).elementAt$1(0, index) : t1._convert$_computeKeys$0()[index];
            },
            get$iterator: function(_) {
                var t1 = this._convert$_parent;
                if (t1._processed == null) {
                    t1 = t1.get$keys(0);
                    t1 = t1.get$iterator(t1);
                } else {
                    t1 = t1._convert$_computeKeys$0();
                    t1 = new J.ArrayIterator(t1, t1.length, A._arrayInstanceType(t1)._eval$1("ArrayIterator<1>"));
                }
                return t1;
            },
            contains$1: function(_, key) {
                return this._convert$_parent.containsKey$1(key);
            }
        };
        A._Utf8Decoder__decoder_closure.prototype = {
            call$0: function() {
                var t1, exception;
                try {
                    t1 = new TextDecoder("utf-8", {
                        fatal: true
                    });
                    return t1;
                } catch (exception) {}
                return null;
            },
            $signature: 64
        };
        A._Utf8Decoder__decoderNonfatal_closure.prototype = {
            call$0: function() {
                var t1, exception;
                try {
                    t1 = new TextDecoder("utf-8", {
                        fatal: false
                    });
                    return t1;
                } catch (exception) {}
                return null;
            },
            $signature: 64
        };
        A.AsciiCodec.prototype = {
            encode$1: function(source) {
                return B.AsciiEncoder_127.convert$1(source);
            }
        };
        A._UnicodeSubsetEncoder.prototype = {
            convert$1: function(string) {
                var t1, i, codeUnit, end = A.RangeError_checkValidRange(0, null, string.length), result = new Uint8Array(end);
                for(t1 = ~this._subsetMask, i = 0; i < end; ++i){
                    codeUnit = string.charCodeAt(i);
                    if ((codeUnit & t1) !== 0) throw A.wrapException(A.ArgumentError$value(string, "string", "Contains invalid characters."));
                    result[i] = codeUnit;
                }
                return result;
            }
        };
        A.AsciiEncoder.prototype = {};
        A.Base64Codec.prototype = {
            normalize$3: function(source, start, end) {
                var inverseAlphabet, i, sliceStart, buffer, firstPadding, firstPaddingSourceIndex, paddingCount, i0, char, i1, digit1, digit2, char0, value, t1, t2, endLength, $length, _s31_ = "Invalid base64 encoding length ";
                end = A.RangeError_checkValidRange(start, end, source.length);
                inverseAlphabet = $.$get$_Base64Decoder__inverseAlphabet();
                for(i = start, sliceStart = i, buffer = null, firstPadding = -1, firstPaddingSourceIndex = -1, paddingCount = 0; i < end; i = i0){
                    i0 = i + 1;
                    char = source.charCodeAt(i);
                    if (char === 37) {
                        i1 = i0 + 2;
                        if (i1 <= end) {
                            digit1 = A.hexDigitValue(source.charCodeAt(i0));
                            digit2 = A.hexDigitValue(source.charCodeAt(i0 + 1));
                            char0 = digit1 * 16 + digit2 - (digit2 & 256);
                            if (char0 === 37) char0 = -1;
                            i0 = i1;
                        } else char0 = -1;
                    } else char0 = char;
                    if (0 <= char0 && char0 <= 127) {
                        value = inverseAlphabet[char0];
                        if (value >= 0) {
                            char0 = string$.ABCDEF.charCodeAt(value);
                            if (char0 === char) continue;
                            char = char0;
                        } else {
                            if (value === -1) {
                                if (firstPadding < 0) {
                                    t1 = buffer == null ? null : buffer._contents.length;
                                    if (t1 == null) t1 = 0;
                                    firstPadding = t1 + (i - sliceStart);
                                    firstPaddingSourceIndex = i;
                                }
                                ++paddingCount;
                                if (char === 61) continue;
                            }
                            char = char0;
                        }
                        if (value !== -2) {
                            if (buffer == null) {
                                buffer = new A.StringBuffer("");
                                t1 = buffer;
                            } else t1 = buffer;
                            t1._contents += B.JSString_methods.substring$2(source, sliceStart, i);
                            t2 = A.Primitives_stringFromCharCode(char);
                            t1._contents += t2;
                            sliceStart = i0;
                            continue;
                        }
                    }
                    throw A.wrapException(A.FormatException$("Invalid base64 data", source, i));
                }
                if (buffer != null) {
                    t1 = B.JSString_methods.substring$2(source, sliceStart, end);
                    t1 = buffer._contents += t1;
                    t2 = t1.length;
                    if (firstPadding >= 0) A.Base64Codec__checkPadding(source, firstPaddingSourceIndex, end, firstPadding, paddingCount, t2);
                    else {
                        endLength = B.JSInt_methods.$mod(t2 - 1, 4) + 1;
                        if (endLength === 1) throw A.wrapException(A.FormatException$(_s31_, source, end));
                        while(endLength < 4){
                            t1 += "=";
                            buffer._contents = t1;
                            ++endLength;
                        }
                    }
                    t1 = buffer._contents;
                    return B.JSString_methods.replaceRange$3(source, start, end, t1.charCodeAt(0) == 0 ? t1 : t1);
                }
                $length = end - start;
                if (firstPadding >= 0) A.Base64Codec__checkPadding(source, firstPaddingSourceIndex, end, firstPadding, paddingCount, $length);
                else {
                    endLength = B.JSInt_methods.$mod($length, 4);
                    if (endLength === 1) throw A.wrapException(A.FormatException$(_s31_, source, end));
                    if (endLength > 1) source = B.JSString_methods.replaceRange$3(source, end, end, endLength === 2 ? "==" : "=");
                }
                return source;
            }
        };
        A.Base64Encoder.prototype = {
            startChunkedConversion$1: function(sink) {
                return new A._Utf8Base64EncoderSink(new A._Utf8StringSinkAdapter(new A._Utf8Decoder(false), sink, sink._stringSink), new A._Base64Encoder(string$.ABCDEF));
            }
        };
        A._Base64Encoder.prototype = {
            createBuffer$1: function(bufferLength) {
                return new Uint8Array(bufferLength);
            },
            encode$4: function(bytes, start, end, isLast) {
                var output, _this = this, byteCount = (_this._convert$_state & 3) + (end - start), fullChunks = B.JSInt_methods._tdivFast$1(byteCount, 3), bufferLength = fullChunks * 4;
                if (isLast && byteCount - fullChunks * 3 > 0) bufferLength += 4;
                output = _this.createBuffer$1(bufferLength);
                _this._convert$_state = A._Base64Encoder_encodeChunk(_this._alphabet, bytes, start, end, isLast, output, 0, _this._convert$_state);
                if (bufferLength > 0) return output;
                return null;
            }
        };
        A._Base64EncoderSink.prototype = {};
        A._Utf8Base64EncoderSink.prototype = {
            _convert$_add$4: function(source, start, end, isLast) {
                var buffer = this._encoder.encode$4(source, start, end, isLast);
                if (buffer != null) this._sink.addSlice$4(buffer, 0, buffer.length, isLast);
            }
        };
        A.ByteConversionSink.prototype = {};
        A.Codec.prototype = {};
        A.Converter.prototype = {};
        A.Encoding.prototype = {};
        A.JsonUnsupportedObjectError.prototype = {
            toString$0: function(_) {
                var safeString = A.Error_safeToString(this.unsupportedObject);
                return (this.cause != null ? "Converting object to an encodable object failed:" : "Converting object did not return an encodable object:") + " " + safeString;
            }
        };
        A.JsonCyclicError.prototype = {
            toString$0: function(_) {
                return "Cyclic error in JSON stringify";
            }
        };
        A.JsonCodec.prototype = {
            decode$1: function(source) {
                var t1 = A._parseJson(source, this.get$decoder()._reviver);
                return t1;
            },
            encode$2$toEncodable: function(value, toEncodable) {
                var t1 = A._JsonStringStringifier_stringify(value, this.get$encoder()._toEncodable, null);
                return t1;
            },
            get$encoder: function() {
                return B.JsonEncoder_null;
            },
            get$decoder: function() {
                return B.JsonDecoder_null;
            }
        };
        A.JsonEncoder.prototype = {};
        A.JsonDecoder.prototype = {};
        A._JsonStringifier.prototype = {
            writeStringContent$1: function(s) {
                var offset, i, charCode, t1, t2, _this = this, $length = s.length;
                for(offset = 0, i = 0; i < $length; ++i){
                    charCode = s.charCodeAt(i);
                    if (charCode > 92) {
                        if (charCode >= 55296) {
                            t1 = charCode & 64512;
                            if (t1 === 55296) {
                                t2 = i + 1;
                                t2 = !(t2 < $length && (s.charCodeAt(t2) & 64512) === 56320);
                            } else t2 = false;
                            if (!t2) {
                                if (t1 === 56320) {
                                    t1 = i - 1;
                                    t1 = !(t1 >= 0 && (s.charCodeAt(t1) & 64512) === 55296);
                                } else t1 = false;
                            } else t1 = true;
                            if (t1) {
                                if (i > offset) _this.writeStringSlice$3(s, offset, i);
                                offset = i + 1;
                                _this.writeCharCode$1(92);
                                _this.writeCharCode$1(117);
                                _this.writeCharCode$1(100);
                                t1 = charCode >>> 8 & 15;
                                _this.writeCharCode$1(t1 < 10 ? 48 + t1 : 87 + t1);
                                t1 = charCode >>> 4 & 15;
                                _this.writeCharCode$1(t1 < 10 ? 48 + t1 : 87 + t1);
                                t1 = charCode & 15;
                                _this.writeCharCode$1(t1 < 10 ? 48 + t1 : 87 + t1);
                            }
                        }
                        continue;
                    }
                    if (charCode < 32) {
                        if (i > offset) _this.writeStringSlice$3(s, offset, i);
                        offset = i + 1;
                        _this.writeCharCode$1(92);
                        switch(charCode){
                            case 8:
                                _this.writeCharCode$1(98);
                                break;
                            case 9:
                                _this.writeCharCode$1(116);
                                break;
                            case 10:
                                _this.writeCharCode$1(110);
                                break;
                            case 12:
                                _this.writeCharCode$1(102);
                                break;
                            case 13:
                                _this.writeCharCode$1(114);
                                break;
                            default:
                                _this.writeCharCode$1(117);
                                _this.writeCharCode$1(48);
                                _this.writeCharCode$1(48);
                                t1 = charCode >>> 4 & 15;
                                _this.writeCharCode$1(t1 < 10 ? 48 + t1 : 87 + t1);
                                t1 = charCode & 15;
                                _this.writeCharCode$1(t1 < 10 ? 48 + t1 : 87 + t1);
                                break;
                        }
                    } else if (charCode === 34 || charCode === 92) {
                        if (i > offset) _this.writeStringSlice$3(s, offset, i);
                        offset = i + 1;
                        _this.writeCharCode$1(92);
                        _this.writeCharCode$1(charCode);
                    }
                }
                if (offset === 0) _this.writeString$1(s);
                else if (offset < $length) _this.writeStringSlice$3(s, offset, $length);
            },
            _checkCycle$1: function(object) {
                var t1, t2, i, t3;
                for(t1 = this._seen, t2 = t1.length, i = 0; i < t2; ++i){
                    t3 = t1[i];
                    if (object == null ? t3 == null : object === t3) throw A.wrapException(new A.JsonCyclicError(object, null));
                }
                t1.push(object);
            },
            writeObject$1: function(object) {
                var customJson, e, t1, _$exception, _this = this;
                if (_this.writeJsonValue$1(object)) return;
                _this._checkCycle$1(object);
                try {
                    customJson = _this._toEncodable.call$1(object);
                    if (!_this.writeJsonValue$1(customJson)) {
                        t1 = A.JsonUnsupportedObjectError$(object, null, _this.get$_partialResult());
                        throw A.wrapException(t1);
                    }
                    _this._seen.pop();
                } catch (exception) {
                    e = A.unwrapException(exception);
                    t1 = A.JsonUnsupportedObjectError$(object, e, _this.get$_partialResult());
                    throw A.wrapException(t1);
                }
            },
            writeJsonValue$1: function(object) {
                var success, _this = this;
                if (typeof object == "number") {
                    if (!isFinite(object)) return false;
                    _this.writeNumber$1(object);
                    return true;
                } else if (object === true) {
                    _this.writeString$1("true");
                    return true;
                } else if (object === false) {
                    _this.writeString$1("false");
                    return true;
                } else if (object == null) {
                    _this.writeString$1("null");
                    return true;
                } else if (typeof object == "string") {
                    _this.writeString$1('"');
                    _this.writeStringContent$1(object);
                    _this.writeString$1('"');
                    return true;
                } else if (type$.List_dynamic._is(object)) {
                    _this._checkCycle$1(object);
                    _this.writeList$1(object);
                    _this._seen.pop();
                    return true;
                } else if (type$.Map_dynamic_dynamic._is(object)) {
                    _this._checkCycle$1(object);
                    success = _this.writeMap$1(object);
                    _this._seen.pop();
                    return success;
                } else return false;
            },
            writeList$1: function(list) {
                var t1, i, _this = this;
                _this.writeString$1("[");
                t1 = J.getInterceptor$asx(list);
                if (t1.get$isNotEmpty(list)) {
                    _this.writeObject$1(t1.$index(list, 0));
                    for(i = 1; i < t1.get$length(list); ++i){
                        _this.writeString$1(",");
                        _this.writeObject$1(t1.$index(list, i));
                    }
                }
                _this.writeString$1("]");
            },
            writeMap$1: function(map) {
                var t1, keyValueList, i, separator, _this = this, _box_0 = {};
                if (map.get$isEmpty(map)) {
                    _this.writeString$1("{}");
                    return true;
                }
                t1 = map.get$length(map) * 2;
                keyValueList = A.List_List$filled(t1, null, false, type$.nullable_Object);
                i = _box_0.i = 0;
                _box_0.allStringKeys = true;
                map.forEach$1(0, new A._JsonStringifier_writeMap_closure(_box_0, keyValueList));
                if (!_box_0.allStringKeys) return false;
                _this.writeString$1("{");
                for(separator = '"'; i < t1; i += 2, separator = ',"'){
                    _this.writeString$1(separator);
                    _this.writeStringContent$1(A._asString(keyValueList[i]));
                    _this.writeString$1('":');
                    _this.writeObject$1(keyValueList[i + 1]);
                }
                _this.writeString$1("}");
                return true;
            }
        };
        A._JsonStringifier_writeMap_closure.prototype = {
            call$2: function(key, value) {
                var t1, t2, t3, i;
                if (typeof key != "string") this._box_0.allStringKeys = false;
                t1 = this.keyValueList;
                t2 = this._box_0;
                t3 = t2.i;
                i = t2.i = t3 + 1;
                t1[t3] = key;
                t2.i = i + 1;
                t1[i] = value;
            },
            $signature: 162
        };
        A._JsonStringStringifier.prototype = {
            get$_partialResult: function() {
                var t1 = this._sink._contents;
                return t1.charCodeAt(0) == 0 ? t1 : t1;
            },
            writeNumber$1: function(number) {
                this._sink._contents += B.JSNumber_methods.toString$0(number);
            },
            writeString$1: function(string) {
                this._sink._contents += string;
            },
            writeStringSlice$3: function(string, start, end) {
                this._sink._contents += B.JSString_methods.substring$2(string, start, end);
            },
            writeCharCode$1: function(charCode) {
                var t1 = this._sink, t2 = A.Primitives_stringFromCharCode(charCode);
                t1._contents += t2;
            }
        };
        A.StringConversionSink.prototype = {};
        A._StringSinkConversionSink.prototype = {
            close$0: function(_) {}
        };
        A._StringCallbackSink.prototype = {
            close$0: function(_) {
                var t1 = this._stringSink, t2 = t1._contents;
                t1._contents = "";
                this._convert$_callback.call$1(t2.charCodeAt(0) == 0 ? t2 : t2);
            },
            asUtf8Sink$1: function(allowMalformed) {
                return new A._Utf8StringSinkAdapter(new A._Utf8Decoder(allowMalformed), this, this._stringSink);
            }
        };
        A._Utf8StringSinkAdapter.prototype = {
            close$0: function(_) {
                this._decoder.flush$1(this._stringSink);
                this._sink.close$0(0);
            },
            add$1: function(_, chunk) {
                this.addSlice$4(chunk, 0, J.get$length$asx(chunk), false);
            },
            addSlice$4: function(codeUnits, startIndex, endIndex, isLast) {
                var t1 = this._stringSink, t2 = this._decoder._convertGeneral$4(codeUnits, startIndex, endIndex, false);
                t1._contents += t2;
                if (isLast) this.close$0(0);
            }
        };
        A.Utf8Codec.prototype = {
            encode$1: function(string) {
                return B.C_Utf8Encoder.convert$1(string);
            }
        };
        A.Utf8Encoder.prototype = {
            convert$1: function(string) {
                var t1, encoder, end = A.RangeError_checkValidRange(0, null, string.length);
                if (end === 0) return new Uint8Array(0);
                t1 = new Uint8Array(end * 3);
                encoder = new A._Utf8Encoder(t1);
                if (encoder._fillBuffer$3(string, 0, end) !== end) encoder._writeReplacementCharacter$0();
                return B.NativeUint8List_methods.sublist$2(t1, 0, encoder._bufferIndex);
            }
        };
        A._Utf8Encoder.prototype = {
            _writeReplacementCharacter$0: function() {
                var _this = this, t1 = _this._buffer, t2 = _this._bufferIndex, t3 = _this._bufferIndex = t2 + 1;
                t1.$flags & 2 && A.throwUnsupportedOperation(t1);
                t1[t2] = 239;
                t2 = _this._bufferIndex = t3 + 1;
                t1[t3] = 191;
                _this._bufferIndex = t2 + 1;
                t1[t2] = 189;
            },
            _writeSurrogate$2: function(leadingSurrogate, nextCodeUnit) {
                var rune, t1, t2, t3, _this = this;
                if ((nextCodeUnit & 64512) === 56320) {
                    rune = 65536 + ((leadingSurrogate & 1023) << 10) | nextCodeUnit & 1023;
                    t1 = _this._buffer;
                    t2 = _this._bufferIndex;
                    t3 = _this._bufferIndex = t2 + 1;
                    t1.$flags & 2 && A.throwUnsupportedOperation(t1);
                    t1[t2] = rune >>> 18 | 240;
                    t2 = _this._bufferIndex = t3 + 1;
                    t1[t3] = rune >>> 12 & 63 | 128;
                    t3 = _this._bufferIndex = t2 + 1;
                    t1[t2] = rune >>> 6 & 63 | 128;
                    _this._bufferIndex = t3 + 1;
                    t1[t3] = rune & 63 | 128;
                    return true;
                } else {
                    _this._writeReplacementCharacter$0();
                    return false;
                }
            },
            _fillBuffer$3: function(str, start, end) {
                var t1, t2, t3, stringIndex, codeUnit, t4, stringIndex0, t5, _this = this;
                if (start !== end && (str.charCodeAt(end - 1) & 64512) === 55296) --end;
                for(t1 = _this._buffer, t2 = t1.$flags | 0, t3 = t1.length, stringIndex = start; stringIndex < end; ++stringIndex){
                    codeUnit = str.charCodeAt(stringIndex);
                    if (codeUnit <= 127) {
                        t4 = _this._bufferIndex;
                        if (t4 >= t3) break;
                        _this._bufferIndex = t4 + 1;
                        t2 & 2 && A.throwUnsupportedOperation(t1);
                        t1[t4] = codeUnit;
                    } else {
                        t4 = codeUnit & 64512;
                        if (t4 === 55296) {
                            if (_this._bufferIndex + 4 > t3) break;
                            stringIndex0 = stringIndex + 1;
                            if (_this._writeSurrogate$2(codeUnit, str.charCodeAt(stringIndex0))) stringIndex = stringIndex0;
                        } else if (t4 === 56320) {
                            if (_this._bufferIndex + 3 > t3) break;
                            _this._writeReplacementCharacter$0();
                        } else if (codeUnit <= 2047) {
                            t4 = _this._bufferIndex;
                            t5 = t4 + 1;
                            if (t5 >= t3) break;
                            _this._bufferIndex = t5;
                            t2 & 2 && A.throwUnsupportedOperation(t1);
                            t1[t4] = codeUnit >>> 6 | 192;
                            _this._bufferIndex = t5 + 1;
                            t1[t5] = codeUnit & 63 | 128;
                        } else {
                            t4 = _this._bufferIndex;
                            if (t4 + 2 >= t3) break;
                            t5 = _this._bufferIndex = t4 + 1;
                            t2 & 2 && A.throwUnsupportedOperation(t1);
                            t1[t4] = codeUnit >>> 12 | 224;
                            t4 = _this._bufferIndex = t5 + 1;
                            t1[t5] = codeUnit >>> 6 & 63 | 128;
                            _this._bufferIndex = t4 + 1;
                            t1[t4] = codeUnit & 63 | 128;
                        }
                    }
                }
                return stringIndex;
            }
        };
        A.Utf8Decoder.prototype = {
            convert$1: function(codeUnits) {
                return new A._Utf8Decoder(this._allowMalformed)._convertGeneral$4(codeUnits, 0, null, true);
            }
        };
        A._Utf8Decoder.prototype = {
            _convertGeneral$4: function(codeUnits, start, maybeEnd, single) {
                var casted, bytes, errorOffset, t1, result, message, _this = this, end = A.RangeError_checkValidRange(start, maybeEnd, J.get$length$asx(codeUnits));
                if (start === end) return "";
                if (codeUnits instanceof Uint8Array) {
                    casted = codeUnits;
                    bytes = casted;
                    errorOffset = 0;
                } else {
                    bytes = A._Utf8Decoder__makeNativeUint8List(codeUnits, start, end);
                    end -= start;
                    errorOffset = start;
                    start = 0;
                }
                if (single && end - start >= 15) {
                    t1 = _this.allowMalformed;
                    result = A._Utf8Decoder__convertInterceptedUint8List(t1, bytes, start, end);
                    if (result != null) {
                        if (!t1) return result;
                        if (result.indexOf("\ufffd") < 0) return result;
                    }
                }
                result = _this._decodeRecursive$4(bytes, start, end, single);
                t1 = _this._convert$_state;
                if ((t1 & 1) !== 0) {
                    message = A._Utf8Decoder_errorDescription(t1);
                    _this._convert$_state = 0;
                    throw A.wrapException(A.FormatException$(message, codeUnits, errorOffset + _this._charOrIndex));
                }
                return result;
            },
            _decodeRecursive$4: function(bytes, start, end, single) {
                var mid, s1, _this = this;
                if (end - start > 1000) {
                    mid = B.JSInt_methods._tdivFast$1(start + end, 2);
                    s1 = _this._decodeRecursive$4(bytes, start, mid, false);
                    if ((_this._convert$_state & 1) !== 0) return s1;
                    return s1 + _this._decodeRecursive$4(bytes, mid, end, single);
                }
                return _this.decodeGeneral$4(bytes, start, end, single);
            },
            flush$1: function(sink) {
                var t1, state = this._convert$_state;
                this._convert$_state = 0;
                if (state <= 32) return;
                if (this.allowMalformed) {
                    t1 = A.Primitives_stringFromCharCode(65533);
                    sink._contents += t1;
                } else throw A.wrapException(A.FormatException$(A._Utf8Decoder_errorDescription(77), null, null));
            },
            decodeGeneral$4: function(bytes, start, end, single) {
                var t1, type, t2, i0, markEnd, i1, m, _this = this, _65533 = 65533, state = _this._convert$_state, char = _this._charOrIndex, buffer = new A.StringBuffer(""), i = start + 1, byte = bytes[start];
                $label0$0: for(t1 = _this.allowMalformed;;){
                    for(;; i = i0){
                        type = "AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAFFFFFFFFFFFFFFFFGGGGGGGGGGGGGGGGHHHHHHHHHHHHHHHHHHHHHHHHHHHIHHHJEEBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBKCCCCCCCCCCCCDCLONNNMEEEEEEEEEEE".charCodeAt(byte) & 31;
                        char = state <= 32 ? byte & 61694 >>> type : (byte & 63 | char << 6) >>> 0;
                        state = " \x000:XECCCCCN:lDb \x000:XECCCCCNvlDb \x000:XECCCCCN:lDb AAAAA\x00\x00\x00\x00\x00AAAAA00000AAAAA:::::AAAAAGG000AAAAA00KKKAAAAAG::::AAAAA:IIIIAAAAA000\x800AAAAA\x00\x00\x00\x00 AAAAA".charCodeAt(state + type);
                        if (state === 0) {
                            t2 = A.Primitives_stringFromCharCode(char);
                            buffer._contents += t2;
                            if (i === end) break $label0$0;
                            break;
                        } else if ((state & 1) !== 0) {
                            if (t1) switch(state){
                                case 69:
                                case 67:
                                    t2 = A.Primitives_stringFromCharCode(_65533);
                                    buffer._contents += t2;
                                    break;
                                case 65:
                                    t2 = A.Primitives_stringFromCharCode(_65533);
                                    buffer._contents += t2;
                                    --i;
                                    break;
                                default:
                                    t2 = A.Primitives_stringFromCharCode(_65533);
                                    buffer._contents = (buffer._contents += t2) + t2;
                                    break;
                            }
                            else {
                                _this._convert$_state = state;
                                _this._charOrIndex = i - 1;
                                return "";
                            }
                            state = 0;
                        }
                        if (i === end) break $label0$0;
                        i0 = i + 1;
                        byte = bytes[i];
                    }
                    i0 = i + 1;
                    byte = bytes[i];
                    if (byte < 128) {
                        for(;;){
                            if (!(i0 < end)) {
                                markEnd = end;
                                break;
                            }
                            i1 = i0 + 1;
                            byte = bytes[i0];
                            if (byte >= 128) {
                                markEnd = i1 - 1;
                                i0 = i1;
                                break;
                            }
                            i0 = i1;
                        }
                        if (markEnd - i < 20) for(m = i; m < markEnd; ++m){
                            t2 = A.Primitives_stringFromCharCode(bytes[m]);
                            buffer._contents += t2;
                        }
                        else {
                            t2 = A.String_String$fromCharCodes(bytes, i, markEnd);
                            buffer._contents += t2;
                        }
                        if (markEnd === end) break $label0$0;
                        i = i0;
                    } else i = i0;
                }
                if (single && state > 32) {
                    if (t1) {
                        t1 = A.Primitives_stringFromCharCode(_65533);
                        buffer._contents += t1;
                    } else {
                        _this._convert$_state = 77;
                        _this._charOrIndex = end;
                        return "";
                    }
                }
                _this._convert$_state = state;
                _this._charOrIndex = char;
                t1 = buffer._contents;
                return t1.charCodeAt(0) == 0 ? t1 : t1;
            }
        };
        A.NoSuchMethodError_toString_closure.prototype = {
            call$2: function(key, value) {
                var t1 = this.sb, t2 = this._box_0, t3 = (t1._contents += t2.comma) + key.__internal$_name;
                t1._contents = t3;
                t1._contents = t3 + ": ";
                t3 = A.Error_safeToString(value);
                t1._contents += t3;
                t2.comma = ", ";
            },
            $signature: 373
        };
        A.DateTime.prototype = {
            $eq: function(_, other) {
                var t1;
                if (other == null) return false;
                t1 = false;
                if (other instanceof A.DateTime) {
                    if (this._value === other._value) t1 = this._microsecond === other._microsecond;
                }
                return t1;
            },
            get$hashCode: function(_) {
                return A.Object_hash(this._value, this._microsecond, B.C_SentinelValue, B.C_SentinelValue);
            },
            isAfter$1: function(other) {
                var t1 = this._value, t2 = other._value;
                if (t1 <= t2) t1 = t1 === t2 && this._microsecond > other._microsecond;
                else t1 = true;
                return t1;
            },
            compareTo$1: function(_, other) {
                var r = B.JSInt_methods.compareTo$1(this._value, other._value);
                if (r !== 0) return r;
                return B.JSInt_methods.compareTo$1(this._microsecond, other._microsecond);
            },
            toString$0: function(_) {
                var _this = this, y = A.DateTime__fourDigits(A.Primitives_getYear(_this)), m = A.DateTime__twoDigits(A.Primitives_getMonth(_this)), d = A.DateTime__twoDigits(A.Primitives_getDay(_this)), h = A.DateTime__twoDigits(A.Primitives_getHours(_this)), min = A.DateTime__twoDigits(A.Primitives_getMinutes(_this)), sec = A.DateTime__twoDigits(A.Primitives_getSeconds(_this)), ms = A.DateTime__threeDigits(A.Primitives_getMilliseconds(_this)), t1 = _this._microsecond, us = t1 === 0 ? "" : A.DateTime__threeDigits(t1);
                return y + "-" + m + "-" + d + " " + h + ":" + min + ":" + sec + "." + ms + us;
            },
            $isComparable: 1
        };
        A.Duration.prototype = {
            $eq: function(_, other) {
                if (other == null) return false;
                return other instanceof A.Duration && this._duration === other._duration;
            },
            get$hashCode: function(_) {
                return B.JSInt_methods.get$hashCode(this._duration);
            },
            compareTo$1: function(_, other) {
                return B.JSInt_methods.compareTo$1(this._duration, other._duration);
            },
            toString$0: function(_) {
                var sign, minutes, minutesPadding, seconds, secondsPadding, microseconds = this._duration, hours = B.JSInt_methods._tdivFast$1(microseconds, 3600000000), microseconds0 = microseconds % 3600000000;
                if (microseconds < 0) {
                    hours = 0 - hours;
                    microseconds = 0 - microseconds0;
                    sign = "-";
                } else {
                    microseconds = microseconds0;
                    sign = "";
                }
                minutes = B.JSInt_methods._tdivFast$1(microseconds, 60000000);
                microseconds %= 60000000;
                minutesPadding = minutes < 10 ? "0" : "";
                seconds = B.JSInt_methods._tdivFast$1(microseconds, 1000000);
                secondsPadding = seconds < 10 ? "0" : "";
                return sign + hours + ":" + minutesPadding + minutes + ":" + secondsPadding + seconds + "." + B.JSString_methods.padLeft$2(B.JSInt_methods.toString$0(microseconds % 1000000), 6, "0");
            },
            $isComparable: 1
        };
        A._Enum.prototype = {
            toString$0: function(_) {
                return this._enumToString$0();
            }
        };
        A.Error.prototype = {
            get$stackTrace: function() {
                return A.Primitives_extractStackTrace(this);
            }
        };
        A.AssertionError.prototype = {
            toString$0: function(_) {
                var t1 = this.message;
                if (t1 != null) return "Assertion failed: " + A.Error_safeToString(t1);
                return "Assertion failed";
            },
            get$message: function(receiver) {
                return this.message;
            }
        };
        A.TypeError.prototype = {};
        A.ArgumentError.prototype = {
            get$_errorName: function() {
                return "Invalid argument" + (!this._hasValue ? "(s)" : "");
            },
            get$_errorExplanation: function() {
                return "";
            },
            toString$0: function(_) {
                var _this = this, $name = _this.name, nameString = $name == null ? "" : " (" + $name + ")", message = _this.message, messageString = message == null ? "" : ": " + A.S(message), prefix = _this.get$_errorName() + nameString + messageString;
                if (!_this._hasValue) return prefix;
                return prefix + _this.get$_errorExplanation() + ": " + A.Error_safeToString(_this.get$invalidValue());
            },
            get$invalidValue: function() {
                return this.invalidValue;
            },
            get$message: function(receiver) {
                return this.message;
            }
        };
        A.RangeError.prototype = {
            get$invalidValue: function() {
                return this.invalidValue;
            },
            get$_errorName: function() {
                return "RangeError";
            },
            get$_errorExplanation: function() {
                var explanation, start = this.start, end = this.end;
                if (start == null) explanation = end != null ? ": Not less than or equal to " + A.S(end) : "";
                else if (end == null) explanation = ": Not greater than or equal to " + A.S(start);
                else if (end > start) explanation = ": Not in inclusive range " + A.S(start) + ".." + A.S(end);
                else explanation = end < start ? ": Valid value range is empty" : ": Only valid value is " + A.S(start);
                return explanation;
            }
        };
        A.IndexError.prototype = {
            get$invalidValue: function() {
                return this.invalidValue;
            },
            get$_errorName: function() {
                return "RangeError";
            },
            get$_errorExplanation: function() {
                if (this.invalidValue < 0) return ": index must not be negative";
                var t1 = this.length;
                if (t1 === 0) return ": no indices are valid";
                return ": index should be less than " + t1;
            },
            $isRangeError: 1,
            get$length: function(receiver) {
                return this.length;
            }
        };
        A.NoSuchMethodError.prototype = {
            toString$0: function(_) {
                var $arguments, t1, _i, t2, t3, argument, receiverText, actualParameters, _this = this, _box_0 = {}, sb = new A.StringBuffer("");
                _box_0.comma = "";
                $arguments = _this._core$_arguments;
                for(t1 = $arguments.length, _i = 0, t2 = "", t3 = ""; _i < t1; ++_i, t3 = ", "){
                    argument = $arguments[_i];
                    sb._contents = t2 + t3;
                    t2 = A.Error_safeToString(argument);
                    t2 = sb._contents += t2;
                    _box_0.comma = ", ";
                }
                _this._namedArguments.forEach$1(0, new A.NoSuchMethodError_toString_closure(_box_0, sb));
                receiverText = A.Error_safeToString(_this._core$_receiver);
                actualParameters = sb.toString$0(0);
                return "NoSuchMethodError: method not found: '" + _this._memberName.__internal$_name + "'\nReceiver: " + receiverText + "\nArguments: [" + actualParameters + "]";
            }
        };
        A.UnsupportedError.prototype = {
            toString$0: function(_) {
                return "Unsupported operation: " + this.message;
            },
            get$message: function(receiver) {
                return this.message;
            }
        };
        A.UnimplementedError.prototype = {
            toString$0: function(_) {
                return "UnimplementedError: " + this.message;
            },
            get$message: function(receiver) {
                return this.message;
            }
        };
        A.StateError.prototype = {
            toString$0: function(_) {
                return "Bad state: " + this.message;
            },
            get$message: function(receiver) {
                return this.message;
            }
        };
        A.ConcurrentModificationError.prototype = {
            toString$0: function(_) {
                var t1 = this.modifiedObject;
                if (t1 == null) return "Concurrent modification during iteration.";
                return "Concurrent modification during iteration: " + A.Error_safeToString(t1) + ".";
            }
        };
        A.OutOfMemoryError.prototype = {
            toString$0: function(_) {
                return "Out of Memory";
            },
            get$stackTrace: function() {
                return null;
            },
            $isError: 1
        };
        A.StackOverflowError.prototype = {
            toString$0: function(_) {
                return "Stack Overflow";
            },
            get$stackTrace: function() {
                return null;
            },
            $isError: 1
        };
        A._Exception.prototype = {
            toString$0: function(_) {
                return "Exception: " + this.message;
            },
            $isException: 1,
            get$message: function(receiver) {
                return this.message;
            }
        };
        A.FormatException.prototype = {
            toString$0: function(_) {
                var t1, lineNum, lineStart, previousCharWasCR, i, char, lineEnd, prefix, postfix, end, start, message = this.message, report = "" !== message ? "FormatException: " + message : "FormatException", offset = this.offset, source = this.source;
                if (typeof source == "string") {
                    if (offset != null) t1 = offset < 0 || offset > source.length;
                    else t1 = false;
                    if (t1) offset = null;
                    if (offset == null) {
                        if (source.length > 78) source = B.JSString_methods.substring$2(source, 0, 75) + "...";
                        return report + "\n" + source;
                    }
                    for(lineNum = 1, lineStart = 0, previousCharWasCR = false, i = 0; i < offset; ++i){
                        char = source.charCodeAt(i);
                        if (char === 10) {
                            if (lineStart !== i || !previousCharWasCR) ++lineNum;
                            lineStart = i + 1;
                            previousCharWasCR = false;
                        } else if (char === 13) {
                            ++lineNum;
                            lineStart = i + 1;
                            previousCharWasCR = true;
                        }
                    }
                    report = lineNum > 1 ? report + (" (at line " + lineNum + ", character " + (offset - lineStart + 1) + ")\n") : report + (" (at character " + (offset + 1) + ")\n");
                    lineEnd = source.length;
                    for(i = offset; i < lineEnd; ++i){
                        char = source.charCodeAt(i);
                        if (char === 10 || char === 13) {
                            lineEnd = i;
                            break;
                        }
                    }
                    prefix = "";
                    if (lineEnd - lineStart > 78) {
                        postfix = "...";
                        if (offset - lineStart < 75) {
                            end = lineStart + 75;
                            start = lineStart;
                        } else {
                            if (lineEnd - offset < 75) {
                                start = lineEnd - 75;
                                end = lineEnd;
                                postfix = "";
                            } else {
                                start = offset - 36;
                                end = offset + 36;
                            }
                            prefix = "...";
                        }
                    } else {
                        end = lineEnd;
                        start = lineStart;
                        postfix = "";
                    }
                    return report + prefix + B.JSString_methods.substring$2(source, start, end) + postfix + "\n" + B.JSString_methods.$mul(" ", offset - start + prefix.length) + "^\n";
                } else return offset != null ? report + (" (at offset " + A.S(offset) + ")") : report;
            },
            $isException: 1,
            get$message: function(receiver) {
                return this.message;
            }
        };
        A.Iterable.prototype = {
            cast$1$0: function(_, $R) {
                return A.CastIterable_CastIterable(this, A._instanceType(this)._eval$1("Iterable.E"), $R);
            },
            followedBy$1: function(_, other) {
                var _this = this;
                if (type$.EfficientLengthIterable_dynamic._is(_this)) return A.FollowedByIterable_FollowedByIterable$firstEfficient(_this, other, A._instanceType(_this)._eval$1("Iterable.E"));
                return new A.FollowedByIterable(_this, other, A._instanceType(_this)._eval$1("FollowedByIterable<Iterable.E>"));
            },
            map$1$1: function(_, toElement, $T) {
                return A.MappedIterable_MappedIterable(this, toElement, A._instanceType(this)._eval$1("Iterable.E"), $T);
            },
            where$1: function(_, test) {
                return new A.WhereIterable(this, test, A._instanceType(this)._eval$1("WhereIterable<Iterable.E>"));
            },
            expand$1$1: function(_, toElements, $T) {
                return new A.ExpandIterable(this, toElements, A._instanceType(this)._eval$1("@<Iterable.E>")._bind$1($T)._eval$1("ExpandIterable<1,2>"));
            },
            contains$1: function(_, element) {
                var t1;
                for(t1 = this.get$iterator(this); t1.moveNext$0();)if (J.$eq$(t1.get$current(t1), element)) return true;
                return false;
            },
            forEach$1: function(_, action) {
                var t1;
                for(t1 = this.get$iterator(this); t1.moveNext$0();)action.call$1(t1.get$current(t1));
            },
            fold$1$2: function(_, initialValue, combine) {
                var t1, value;
                for(t1 = this.get$iterator(this), value = initialValue; t1.moveNext$0();)value = combine.call$2(value, t1.get$current(t1));
                return value;
            },
            fold$2: function(_, initialValue, combine) {
                return this.fold$1$2(0, initialValue, combine, type$.dynamic);
            },
            every$1: function(_, test) {
                var t1;
                for(t1 = this.get$iterator(this); t1.moveNext$0();)if (!test.call$1(t1.get$current(t1))) return false;
                return true;
            },
            join$1: function(_, separator) {
                var first, t1, iterator = this.get$iterator(this);
                if (!iterator.moveNext$0()) return "";
                first = J.toString$0$(iterator.get$current(iterator));
                if (!iterator.moveNext$0()) return first;
                if (separator.length === 0) {
                    t1 = first;
                    do t1 += A.S(J.toString$0$(iterator.get$current(iterator)));
                    while (iterator.moveNext$0());
                } else {
                    t1 = first;
                    do t1 = t1 + separator + A.S(J.toString$0$(iterator.get$current(iterator)));
                    while (iterator.moveNext$0());
                }
                return t1.charCodeAt(0) == 0 ? t1 : t1;
            },
            any$1: function(_, test) {
                var t1;
                for(t1 = this.get$iterator(this); t1.moveNext$0();)if (test.call$1(t1.get$current(t1))) return true;
                return false;
            },
            toList$1$growable: function(_, growable) {
                var t1 = A._instanceType(this)._eval$1("Iterable.E");
                if (growable) t1 = A.List_List$_of(this, t1);
                else {
                    t1 = A.List_List$_of(this, t1);
                    t1.$flags = 1;
                    t1;
                }
                return t1;
            },
            toList$0: function(_) {
                return this.toList$1$growable(0, true);
            },
            toSet$0: function(_) {
                return A.LinkedHashSet_LinkedHashSet$of(this, A._instanceType(this)._eval$1("Iterable.E"));
            },
            get$length: function(_) {
                var count, it = this.get$iterator(this);
                for(count = 0; it.moveNext$0();)++count;
                return count;
            },
            get$isEmpty: function(_) {
                return !this.get$iterator(this).moveNext$0();
            },
            get$isNotEmpty: function(_) {
                return !this.get$isEmpty(this);
            },
            take$1: function(_, count) {
                return A.TakeIterable_TakeIterable(this, count, A._instanceType(this)._eval$1("Iterable.E"));
            },
            skip$1: function(_, count) {
                return A.SkipIterable_SkipIterable(this, count, A._instanceType(this)._eval$1("Iterable.E"));
            },
            skipWhile$1: function(_, test) {
                return new A.SkipWhileIterable(this, test, A._instanceType(this)._eval$1("SkipWhileIterable<Iterable.E>"));
            },
            get$first: function(_) {
                var it = this.get$iterator(this);
                if (!it.moveNext$0()) throw A.wrapException(A.IterableElementError_noElement());
                return it.get$current(it);
            },
            get$last: function(_) {
                var result, it = this.get$iterator(this);
                if (!it.moveNext$0()) throw A.wrapException(A.IterableElementError_noElement());
                do result = it.get$current(it);
                while (it.moveNext$0());
                return result;
            },
            get$single: function(_) {
                var result, it = this.get$iterator(this);
                if (!it.moveNext$0()) throw A.wrapException(A.IterableElementError_noElement());
                result = it.get$current(it);
                if (it.moveNext$0()) throw A.wrapException(A.IterableElementError_tooMany());
                return result;
            },
            elementAt$1: function(_, index) {
                var iterator, skipCount;
                A.RangeError_checkNotNegative(index, "index");
                iterator = this.get$iterator(this);
                for(skipCount = index; iterator.moveNext$0();){
                    if (skipCount === 0) return iterator.get$current(iterator);
                    --skipCount;
                }
                throw A.wrapException(A.IndexError$withLength(index, index - skipCount, this, null, "index"));
            },
            toString$0: function(_) {
                return A.Iterable_iterableToShortString(this, "(", ")");
            }
        };
        A._GeneratorIterable.prototype = {
            elementAt$1: function(_, index) {
                A.IndexError_check(index, this.length, this, null, null);
                return this._generator.call$1(index);
            },
            get$length: function(receiver) {
                return this.length;
            }
        };
        A.MapEntry.prototype = {
            toString$0: function(_) {
                return "MapEntry(" + A.S(this.key) + ": " + A.S(this.value) + ")";
            }
        };
        A.Null.prototype = {
            get$hashCode: function(_) {
                return A.Object.prototype.get$hashCode.call(this, 0);
            },
            toString$0: function(_) {
                return "null";
            }
        };
        A.Object.prototype = {
            $isObject: 1,
            $eq: function(_, other) {
                return this === other;
            },
            get$hashCode: function(_) {
                return A.Primitives_objectHashCode(this);
            },
            toString$0: function(_) {
                return "Instance of '" + A.Primitives_objectTypeName(this) + "'";
            },
            noSuchMethod$1: function(_, invocation) {
                throw A.wrapException(A.NoSuchMethodError_NoSuchMethodError$withInvocation(this, invocation));
            },
            get$runtimeType: function(_) {
                return A.getRuntimeTypeOfDartObject(this);
            },
            toString: function() {
                return this.toString$0(this);
            }
        };
        A._StringStackTrace.prototype = {
            toString$0: function(_) {
                return this._stackTrace;
            },
            $isStackTrace: 1
        };
        A.Runes.prototype = {
            get$iterator: function(_) {
                return new A.RuneIterator(this.string);
            },
            get$last: function(_) {
                var code, previousCode, t1 = this.string, t2 = t1.length;
                if (t2 === 0) throw A.wrapException(A.StateError$("No elements."));
                code = t1.charCodeAt(t2 - 1);
                if ((code & 64512) === 56320 && t2 > 1) {
                    previousCode = t1.charCodeAt(t2 - 2);
                    if ((previousCode & 64512) === 55296) return A._combineSurrogatePair(previousCode, code);
                }
                return code;
            }
        };
        A.RuneIterator.prototype = {
            get$current: function(_) {
                return this._currentCodePoint;
            },
            moveNext$0: function() {
                var codeUnit, nextPosition, nextCodeUnit, _this = this, t1 = _this._position = _this._nextPosition, t2 = _this.string, t3 = t2.length;
                if (t1 === t3) {
                    _this._currentCodePoint = -1;
                    return false;
                }
                codeUnit = t2.charCodeAt(t1);
                nextPosition = t1 + 1;
                if ((codeUnit & 64512) === 55296 && nextPosition < t3) {
                    nextCodeUnit = t2.charCodeAt(nextPosition);
                    if ((nextCodeUnit & 64512) === 56320) {
                        _this._nextPosition = nextPosition + 1;
                        _this._currentCodePoint = A._combineSurrogatePair(codeUnit, nextCodeUnit);
                        return true;
                    }
                }
                _this._nextPosition = nextPosition;
                _this._currentCodePoint = codeUnit;
                return true;
            }
        };
        A.StringBuffer.prototype = {
            get$length: function(_) {
                return this._contents.length;
            },
            write$1: function(_, obj) {
                var t1 = A.S(obj);
                this._contents += t1;
            },
            writeCharCode$1: function(charCode) {
                var t1 = A.Primitives_stringFromCharCode(charCode);
                this._contents += t1;
            },
            toString$0: function(_) {
                var t1 = this._contents;
                return t1.charCodeAt(0) == 0 ? t1 : t1;
            }
        };
        A.Uri_parseIPv6Address_error.prototype = {
            call$2: function(msg, position) {
                throw A.wrapException(A.FormatException$("Illegal IPv6 address, " + msg, this.host, position));
            },
            $signature: 465
        };
        A._Uri.prototype = {
            get$_text: function() {
                var t1, t2, t3, t4, _this = this, value = _this.___Uri__text_FI;
                if (value === $) {
                    t1 = _this.scheme;
                    t2 = t1.length !== 0 ? t1 + ":" : "";
                    t3 = _this._host;
                    t4 = t3 == null;
                    if (!t4 || t1 === "file") {
                        t1 = t2 + "//";
                        t2 = _this._userInfo;
                        if (t2.length !== 0) t1 = t1 + t2 + "@";
                        if (!t4) t1 += t3;
                        t2 = _this._port;
                        if (t2 != null) t1 = t1 + ":" + A.S(t2);
                    } else t1 = t2;
                    t1 += _this.path;
                    t2 = _this._query;
                    if (t2 != null) t1 = t1 + "?" + t2;
                    t2 = _this._fragment;
                    if (t2 != null) t1 = t1 + "#" + t2;
                    value = _this.___Uri__text_FI = t1.charCodeAt(0) == 0 ? t1 : t1;
                }
                return value;
            },
            get$pathSegments: function() {
                var pathToSplit, result, _this = this, value = _this.___Uri_pathSegments_FI;
                if (value === $) {
                    pathToSplit = _this.path;
                    if (pathToSplit.length !== 0 && pathToSplit.charCodeAt(0) === 47) pathToSplit = B.JSString_methods.substring$1(pathToSplit, 1);
                    result = pathToSplit.length === 0 ? B.List_empty : A.List_List$unmodifiable(new A.MappedListIterable(A._setArrayType(pathToSplit.split("/"), type$.JSArray_String), A.core_Uri_decodeComponent$closure(), type$.MappedListIterable_String_dynamic), type$.String);
                    _this.___Uri_pathSegments_FI !== $ && A.throwUnnamedLateFieldADI();
                    value = _this.___Uri_pathSegments_FI = result;
                }
                return value;
            },
            get$hashCode: function(_) {
                var result, _this = this, value = _this.___Uri_hashCode_FI;
                if (value === $) {
                    result = B.JSString_methods.get$hashCode(_this.get$_text());
                    _this.___Uri_hashCode_FI !== $ && A.throwUnnamedLateFieldADI();
                    _this.___Uri_hashCode_FI = result;
                    value = result;
                }
                return value;
            },
            get$userInfo: function() {
                return this._userInfo;
            },
            get$host: function() {
                var host = this._host;
                if (host == null) return "";
                if (B.JSString_methods.startsWith$1(host, "[") && !B.JSString_methods.startsWith$2(host, "v", 1)) return B.JSString_methods.substring$2(host, 1, host.length - 1);
                return host;
            },
            get$port: function(_) {
                var t1 = this._port;
                return t1 == null ? A._Uri__defaultPort(this.scheme) : t1;
            },
            get$query: function() {
                var t1 = this._query;
                return t1 == null ? "" : t1;
            },
            get$fragment: function() {
                var t1 = this._fragment;
                return t1 == null ? "" : t1;
            },
            isScheme$1: function(scheme) {
                var thisScheme = this.scheme;
                if (scheme.length !== thisScheme.length) return false;
                return A._caseInsensitiveCompareStart(scheme, thisScheme, 0) >= 0;
            },
            replace$1$scheme: function(scheme) {
                var isFile, userInfo, port, host, currentPath, t1, path, _this = this;
                scheme = A._Uri__makeScheme(scheme, 0, scheme.length);
                isFile = scheme === "file";
                userInfo = _this._userInfo;
                port = _this._port;
                if (scheme !== _this.scheme) port = A._Uri__makePort(port, scheme);
                host = _this._host;
                if (!(host != null)) host = userInfo.length !== 0 || port != null || isFile ? "" : null;
                currentPath = _this.path;
                if (!isFile) t1 = host != null && currentPath.length !== 0;
                else t1 = true;
                if (t1 && !B.JSString_methods.startsWith$1(currentPath, "/")) currentPath = "/" + currentPath;
                path = currentPath;
                return A._Uri$_internal(scheme, userInfo, host, port, path, _this._query, _this._fragment);
            },
            _mergePaths$2: function(base, reference) {
                var backCount, refStart, baseEnd, newEnd, delta, t1, t2;
                for(backCount = 0, refStart = 0; B.JSString_methods.startsWith$2(reference, "../", refStart);){
                    refStart += 3;
                    ++backCount;
                }
                baseEnd = B.JSString_methods.lastIndexOf$1(base, "/");
                for(;;){
                    if (!(baseEnd > 0 && backCount > 0)) break;
                    newEnd = B.JSString_methods.lastIndexOf$2(base, "/", baseEnd - 1);
                    if (newEnd < 0) break;
                    delta = baseEnd - newEnd;
                    t1 = delta !== 2;
                    t2 = false;
                    if (!t1 || delta === 3) {
                        if (base.charCodeAt(newEnd + 1) === 46) t1 = !t1 || base.charCodeAt(newEnd + 2) === 46;
                        else t1 = t2;
                    } else t1 = t2;
                    if (t1) break;
                    --backCount;
                    baseEnd = newEnd;
                }
                return B.JSString_methods.replaceRange$3(base, baseEnd + 1, null, B.JSString_methods.substring$1(reference, refStart - 3 * backCount));
            },
            resolve$1: function(_, reference) {
                return this.resolveUri$1(A.Uri_parse(reference));
            },
            resolveUri$1: function(reference) {
                var targetScheme, targetUserInfo, targetHost, targetPort, targetPath, targetQuery, split, packageNameEnd, packageName, mergedPath, t1, fragment, _this = this, _null = null;
                if (reference.get$scheme().length !== 0) {
                    if (type$._PlatformUri._is(reference)) return reference;
                    targetScheme = reference.get$scheme();
                    if (reference.get$hasAuthority()) {
                        targetUserInfo = reference.get$userInfo();
                        targetHost = reference.get$host();
                        targetPort = reference.get$hasPort() ? reference.get$port(reference) : _null;
                    } else {
                        targetPort = _null;
                        targetHost = targetPort;
                        targetUserInfo = "";
                    }
                    targetPath = A._Uri__removeDotSegments(reference.get$path(reference));
                    targetQuery = reference.get$hasQuery() ? reference.get$query() : _null;
                    split = 0;
                } else {
                    targetScheme = _this.scheme;
                    if (reference.get$hasAuthority()) {
                        if (type$._PlatformUri._is(reference)) return reference.replace$1$scheme(targetScheme);
                        targetUserInfo = reference.get$userInfo();
                        targetHost = reference.get$host();
                        targetPort = A._Uri__makePort(reference.get$hasPort() ? reference.get$port(reference) : _null, targetScheme);
                        targetPath = A._Uri__removeDotSegments(reference.get$path(reference));
                        targetQuery = reference.get$hasQuery() ? reference.get$query() : _null;
                        split = 1;
                    } else {
                        targetUserInfo = _this._userInfo;
                        targetHost = _this._host;
                        targetPort = _this._port;
                        targetPath = _this.path;
                        if (reference.get$hasEmptyPath()) {
                            if (reference.get$hasQuery()) {
                                targetQuery = reference.get$query();
                                split = 3;
                            } else {
                                targetQuery = _this._query;
                                split = 4;
                            }
                        } else {
                            packageNameEnd = A._Uri__packageNameEnd(_this, targetPath);
                            if (packageNameEnd > 0) {
                                packageName = B.JSString_methods.substring$2(targetPath, 0, packageNameEnd);
                                targetPath = reference.get$hasAbsolutePath() ? packageName + A._Uri__removeDotSegments(reference.get$path(reference)) : packageName + A._Uri__removeDotSegments(_this._mergePaths$2(B.JSString_methods.substring$1(targetPath, packageName.length), reference.get$path(reference)));
                            } else if (reference.get$hasAbsolutePath()) targetPath = A._Uri__removeDotSegments(reference.get$path(reference));
                            else if (targetPath.length === 0) {
                                if (targetHost == null) targetPath = targetScheme.length === 0 ? reference.get$path(reference) : A._Uri__removeDotSegments(reference.get$path(reference));
                                else targetPath = A._Uri__removeDotSegments("/" + reference.get$path(reference));
                            } else {
                                mergedPath = _this._mergePaths$2(targetPath, reference.get$path(reference));
                                t1 = targetScheme.length === 0;
                                if (!t1 || targetHost != null || B.JSString_methods.startsWith$1(targetPath, "/")) targetPath = A._Uri__removeDotSegments(mergedPath);
                                else targetPath = A._Uri__normalizeRelativePath(mergedPath, !t1 || targetHost != null);
                            }
                            targetQuery = reference.get$hasQuery() ? reference.get$query() : _null;
                            split = 2;
                        }
                    }
                }
                fragment = reference.get$hasFragment() ? reference.get$fragment() : _null;
                if (!type$._PlatformUri._is(reference)) {
                    if (split === 0) targetScheme = A._Uri__makeScheme(targetScheme, 0, targetScheme.length);
                    if (split <= 1) {
                        t1 = targetUserInfo.length;
                        if (t1 !== 0) targetUserInfo = A._Uri__makeUserInfo(targetUserInfo, 0, t1);
                        if (targetPort != null) targetPort = A._Uri__makePort(targetPort, targetScheme);
                        if (targetHost != null && targetHost.length !== 0) targetHost = A._Uri__makeHost(targetHost, 0, targetHost.length, false);
                    }
                    t1 = split <= 3;
                    if (t1) targetPath = A._Uri__makePath(targetPath, 0, targetPath.length, _null, targetScheme, targetHost != null);
                    if (t1 && targetQuery != null) targetQuery = A._Uri__makeQuery(targetQuery, 0, targetQuery.length, _null);
                    if (fragment != null) fragment = A._Uri__makeFragment(fragment, 0, fragment.length);
                }
                return A._Uri$_internal(targetScheme, targetUserInfo, targetHost, targetPort, targetPath, targetQuery, fragment);
            },
            get$hasAuthority: function() {
                return this._host != null;
            },
            get$hasPort: function() {
                return this._port != null;
            },
            get$hasQuery: function() {
                return this._query != null;
            },
            get$hasFragment: function() {
                return this._fragment != null;
            },
            get$hasEmptyPath: function() {
                return this.path.length === 0;
            },
            get$hasAbsolutePath: function() {
                return B.JSString_methods.startsWith$1(this.path, "/");
            },
            toFilePath$0: function() {
                var pathSegments, _this = this, t1 = _this.scheme;
                if (t1 !== "" && t1 !== "file") throw A.wrapException(A.UnsupportedError$("Cannot extract a file path from a " + t1 + " URI"));
                t1 = _this._query;
                if ((t1 == null ? "" : t1) !== "") throw A.wrapException(A.UnsupportedError$(string$.Cannotfq));
                t1 = _this._fragment;
                if ((t1 == null ? "" : t1) !== "") throw A.wrapException(A.UnsupportedError$(string$.Cannotff));
                t1 = $.$get$_Uri__isWindowsCached();
                if (t1) t1 = A._Uri__toWindowsFilePath(_this);
                else {
                    if (_this._host != null && _this.get$host() !== "") A.throwExpression(A.UnsupportedError$(string$.Cannotn));
                    pathSegments = _this.get$pathSegments();
                    A._Uri__checkNonWindowsPathReservedCharacters(pathSegments, false);
                    t1 = A.StringBuffer__writeAll(B.JSString_methods.startsWith$1(_this.path, "/") ? "/" : "", pathSegments, "/");
                    t1 = t1.charCodeAt(0) == 0 ? t1 : t1;
                }
                return t1;
            },
            toString$0: function(_) {
                return this.get$_text();
            },
            $eq: function(_, other) {
                var t1, t2, t3, _this = this;
                if (other == null) return false;
                if (_this === other) return true;
                t1 = false;
                if (type$.Uri._is(other)) {
                    if (_this.scheme === other.get$scheme()) {
                        if (_this._host != null === other.get$hasAuthority()) {
                            if (_this._userInfo === other.get$userInfo()) {
                                if (_this.get$host() === other.get$host()) {
                                    if (_this.get$port(0) === other.get$port(other)) {
                                        if (_this.path === other.get$path(other)) {
                                            t2 = _this._query;
                                            t3 = t2 == null;
                                            if (!t3 === other.get$hasQuery()) {
                                                if (t3) t2 = "";
                                                if (t2 === other.get$query()) {
                                                    t2 = _this._fragment;
                                                    t3 = t2 == null;
                                                    if (!t3 === other.get$hasFragment()) {
                                                        t1 = t3 ? "" : t2;
                                                        t1 = t1 === other.get$fragment();
                                                    }
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
                return t1;
            },
            $isUri: 1,
            $is_PlatformUri: 1,
            get$scheme: function() {
                return this.scheme;
            },
            get$path: function(receiver) {
                return this.path;
            }
        };
        A._Uri__makePath_closure.prototype = {
            call$1: function(s) {
                return A._Uri__uriEncode(64, s, B.C_Utf8Codec, false);
            },
            $signature: 6
        };
        A.UriData.prototype = {
            get$uri: function() {
                var t2, queryIndex, end, query, _this = this, _null = null, t1 = _this._uriCache;
                if (t1 == null) {
                    t1 = _this._text;
                    t2 = _this._separatorIndices[0] + 1;
                    queryIndex = B.JSString_methods.indexOf$2(t1, "?", t2);
                    end = t1.length;
                    if (queryIndex >= 0) {
                        query = A._Uri__normalizeOrSubstring(t1, queryIndex + 1, end, 256, false, false);
                        end = queryIndex;
                    } else query = _null;
                    t1 = _this._uriCache = new A._DataUri("data", "", _null, _null, A._Uri__normalizeOrSubstring(t1, t2, end, 128, false, false), query, _null);
                }
                return t1;
            },
            toString$0: function(_) {
                var t1 = this._text;
                return this._separatorIndices[0] === -1 ? "data:" + t1 : t1;
            }
        };
        A._SimpleUri.prototype = {
            get$hasAuthority: function() {
                return this._hostStart > 0;
            },
            get$hasPort: function() {
                return this._hostStart > 0 && this._portStart + 1 < this._pathStart;
            },
            get$hasQuery: function() {
                return this._queryStart < this._fragmentStart;
            },
            get$hasFragment: function() {
                return this._fragmentStart < this._uri.length;
            },
            get$hasAbsolutePath: function() {
                return B.JSString_methods.startsWith$2(this._uri, "/", this._pathStart);
            },
            get$hasEmptyPath: function() {
                return this._pathStart === this._queryStart;
            },
            get$scheme: function() {
                var t1 = this._schemeCache;
                return t1 == null ? this._schemeCache = this._computeScheme$0() : t1;
            },
            _computeScheme$0: function() {
                var t2, _this = this, t1 = _this._schemeEnd;
                if (t1 <= 0) return "";
                t2 = t1 === 4;
                if (t2 && B.JSString_methods.startsWith$1(_this._uri, "http")) return "http";
                if (t1 === 5 && B.JSString_methods.startsWith$1(_this._uri, "https")) return "https";
                if (t2 && B.JSString_methods.startsWith$1(_this._uri, "file")) return "file";
                if (t1 === 7 && B.JSString_methods.startsWith$1(_this._uri, "package")) return "package";
                return B.JSString_methods.substring$2(_this._uri, 0, t1);
            },
            get$userInfo: function() {
                var t1 = this._hostStart, t2 = this._schemeEnd + 3;
                return t1 > t2 ? B.JSString_methods.substring$2(this._uri, t2, t1 - 1) : "";
            },
            get$host: function() {
                var t1 = this._hostStart;
                return t1 > 0 ? B.JSString_methods.substring$2(this._uri, t1, this._portStart) : "";
            },
            get$port: function(_) {
                var t1, _this = this;
                if (_this.get$hasPort()) return A.int_parse(B.JSString_methods.substring$2(_this._uri, _this._portStart + 1, _this._pathStart), null);
                t1 = _this._schemeEnd;
                if (t1 === 4 && B.JSString_methods.startsWith$1(_this._uri, "http")) return 80;
                if (t1 === 5 && B.JSString_methods.startsWith$1(_this._uri, "https")) return 443;
                return 0;
            },
            get$path: function(_) {
                return B.JSString_methods.substring$2(this._uri, this._pathStart, this._queryStart);
            },
            get$query: function() {
                var t1 = this._queryStart, t2 = this._fragmentStart;
                return t1 < t2 ? B.JSString_methods.substring$2(this._uri, t1 + 1, t2) : "";
            },
            get$fragment: function() {
                var t1 = this._fragmentStart, t2 = this._uri;
                return t1 < t2.length ? B.JSString_methods.substring$1(t2, t1 + 1) : "";
            },
            get$pathSegments: function() {
                var parts, i, start = this._pathStart, end = this._queryStart, t1 = this._uri;
                if (B.JSString_methods.startsWith$2(t1, "/", start)) ++start;
                if (start === end) return B.List_empty;
                parts = A._setArrayType([], type$.JSArray_String);
                for(i = start; i < end; ++i)if (t1.charCodeAt(i) === 47) {
                    parts.push(B.JSString_methods.substring$2(t1, start, i));
                    start = i + 1;
                }
                parts.push(B.JSString_methods.substring$2(t1, start, end));
                return A.List_List$unmodifiable(parts, type$.String);
            },
            _isPort$1: function(port) {
                var portDigitStart = this._portStart + 1;
                return portDigitStart + port.length === this._pathStart && B.JSString_methods.startsWith$2(this._uri, port, portDigitStart);
            },
            removeFragment$0: function() {
                var _this = this, t1 = _this._fragmentStart, t2 = _this._uri;
                if (t1 >= t2.length) return _this;
                return new A._SimpleUri(B.JSString_methods.substring$2(t2, 0, t1), _this._schemeEnd, _this._hostStart, _this._portStart, _this._pathStart, _this._queryStart, t1, _this._schemeCache);
            },
            replace$1$scheme: function(scheme) {
                var schemeChanged, isFile, t1, userInfo, port, host, t2, path, t3, query, fragment, _this = this, _null = null;
                scheme = A._Uri__makeScheme(scheme, 0, scheme.length);
                schemeChanged = !(_this._schemeEnd === scheme.length && B.JSString_methods.startsWith$1(_this._uri, scheme));
                isFile = scheme === "file";
                t1 = _this._hostStart;
                userInfo = t1 > 0 ? B.JSString_methods.substring$2(_this._uri, _this._schemeEnd + 3, t1) : "";
                port = _this.get$hasPort() ? _this.get$port(0) : _null;
                if (schemeChanged) port = A._Uri__makePort(port, scheme);
                t1 = _this._hostStart;
                if (t1 > 0) host = B.JSString_methods.substring$2(_this._uri, t1, _this._portStart);
                else host = userInfo.length !== 0 || port != null || isFile ? "" : _null;
                t1 = _this._uri;
                t2 = _this._queryStart;
                path = B.JSString_methods.substring$2(t1, _this._pathStart, t2);
                if (!isFile) t3 = host != null && path.length !== 0;
                else t3 = true;
                if (t3 && !B.JSString_methods.startsWith$1(path, "/")) path = "/" + path;
                t3 = _this._fragmentStart;
                query = t2 < t3 ? B.JSString_methods.substring$2(t1, t2 + 1, t3) : _null;
                t2 = _this._fragmentStart;
                fragment = t2 < t1.length ? B.JSString_methods.substring$1(t1, t2 + 1) : _null;
                return A._Uri$_internal(scheme, userInfo, host, port, path, query, fragment);
            },
            resolve$1: function(_, reference) {
                return this.resolveUri$1(A.Uri_parse(reference));
            },
            resolveUri$1: function(reference) {
                if (reference instanceof A._SimpleUri) return this._simpleMerge$2(this, reference);
                return this._toNonSimple$0().resolveUri$1(reference);
            },
            _simpleMerge$2: function(base, ref) {
                var t2, t3, t4, isSimple, delta, refStart, basePathStart, packageNameEnd, basePathStart0, baseStart, baseEnd, baseUri, baseStart0, backCount, refStart0, insert, t1 = ref._schemeEnd;
                if (t1 > 0) return ref;
                t2 = ref._hostStart;
                if (t2 > 0) {
                    t3 = base._schemeEnd;
                    if (t3 <= 0) return ref;
                    t4 = t3 === 4;
                    if (t4 && B.JSString_methods.startsWith$1(base._uri, "file")) isSimple = ref._pathStart !== ref._queryStart;
                    else if (t4 && B.JSString_methods.startsWith$1(base._uri, "http")) isSimple = !ref._isPort$1("80");
                    else isSimple = !(t3 === 5 && B.JSString_methods.startsWith$1(base._uri, "https")) || !ref._isPort$1("443");
                    if (isSimple) {
                        delta = t3 + 1;
                        return new A._SimpleUri(B.JSString_methods.substring$2(base._uri, 0, delta) + B.JSString_methods.substring$1(ref._uri, t1 + 1), t3, t2 + delta, ref._portStart + delta, ref._pathStart + delta, ref._queryStart + delta, ref._fragmentStart + delta, base._schemeCache);
                    } else return this._toNonSimple$0().resolveUri$1(ref);
                }
                refStart = ref._pathStart;
                t1 = ref._queryStart;
                if (refStart === t1) {
                    t2 = ref._fragmentStart;
                    if (t1 < t2) {
                        t3 = base._queryStart;
                        delta = t3 - t1;
                        return new A._SimpleUri(B.JSString_methods.substring$2(base._uri, 0, t3) + B.JSString_methods.substring$1(ref._uri, t1), base._schemeEnd, base._hostStart, base._portStart, base._pathStart, t1 + delta, t2 + delta, base._schemeCache);
                    }
                    t1 = ref._uri;
                    if (t2 < t1.length) {
                        t3 = base._fragmentStart;
                        return new A._SimpleUri(B.JSString_methods.substring$2(base._uri, 0, t3) + B.JSString_methods.substring$1(t1, t2), base._schemeEnd, base._hostStart, base._portStart, base._pathStart, base._queryStart, t2 + (t3 - t2), base._schemeCache);
                    }
                    return base.removeFragment$0();
                }
                t2 = ref._uri;
                if (B.JSString_methods.startsWith$2(t2, "/", refStart)) {
                    basePathStart = base._pathStart;
                    packageNameEnd = A._SimpleUri__packageNameEnd(this);
                    basePathStart0 = packageNameEnd > 0 ? packageNameEnd : basePathStart;
                    delta = basePathStart0 - refStart;
                    return new A._SimpleUri(B.JSString_methods.substring$2(base._uri, 0, basePathStart0) + B.JSString_methods.substring$1(t2, refStart), base._schemeEnd, base._hostStart, base._portStart, basePathStart, t1 + delta, ref._fragmentStart + delta, base._schemeCache);
                }
                baseStart = base._pathStart;
                baseEnd = base._queryStart;
                if (baseStart === baseEnd && base._hostStart > 0) {
                    while(B.JSString_methods.startsWith$2(t2, "../", refStart))refStart += 3;
                    delta = baseStart - refStart + 1;
                    return new A._SimpleUri(B.JSString_methods.substring$2(base._uri, 0, baseStart) + "/" + B.JSString_methods.substring$1(t2, refStart), base._schemeEnd, base._hostStart, base._portStart, baseStart, t1 + delta, ref._fragmentStart + delta, base._schemeCache);
                }
                baseUri = base._uri;
                packageNameEnd = A._SimpleUri__packageNameEnd(this);
                if (packageNameEnd >= 0) baseStart0 = packageNameEnd;
                else for(baseStart0 = baseStart; B.JSString_methods.startsWith$2(baseUri, "../", baseStart0);)baseStart0 += 3;
                backCount = 0;
                for(;;){
                    refStart0 = refStart + 3;
                    if (!(refStart0 <= t1 && B.JSString_methods.startsWith$2(t2, "../", refStart))) break;
                    ++backCount;
                    refStart = refStart0;
                }
                for(insert = ""; baseEnd > baseStart0;){
                    --baseEnd;
                    if (baseUri.charCodeAt(baseEnd) === 47) {
                        if (backCount === 0) {
                            insert = "/";
                            break;
                        }
                        --backCount;
                        insert = "/";
                    }
                }
                if (baseEnd === baseStart0 && base._schemeEnd <= 0 && !B.JSString_methods.startsWith$2(baseUri, "/", baseStart)) {
                    refStart -= backCount * 3;
                    insert = "";
                }
                delta = baseEnd - refStart + insert.length;
                return new A._SimpleUri(B.JSString_methods.substring$2(baseUri, 0, baseEnd) + insert + B.JSString_methods.substring$1(t2, refStart), base._schemeEnd, base._hostStart, base._portStart, baseStart, t1 + delta, ref._fragmentStart + delta, base._schemeCache);
            },
            toFilePath$0: function() {
                var t2, t3, _this = this, t1 = _this._schemeEnd;
                if (t1 >= 0) {
                    t2 = !(t1 === 4 && B.JSString_methods.startsWith$1(_this._uri, "file"));
                    t1 = t2;
                } else t1 = false;
                if (t1) throw A.wrapException(A.UnsupportedError$("Cannot extract a file path from a " + _this.get$scheme() + " URI"));
                t1 = _this._queryStart;
                t2 = _this._uri;
                if (t1 < t2.length) {
                    if (t1 < _this._fragmentStart) throw A.wrapException(A.UnsupportedError$(string$.Cannotfq));
                    throw A.wrapException(A.UnsupportedError$(string$.Cannotff));
                }
                t3 = $.$get$_Uri__isWindowsCached();
                if (t3) t1 = A._Uri__toWindowsFilePath(_this);
                else {
                    if (_this._hostStart < _this._portStart) A.throwExpression(A.UnsupportedError$(string$.Cannotn));
                    t1 = B.JSString_methods.substring$2(t2, _this._pathStart, t1);
                }
                return t1;
            },
            get$hashCode: function(_) {
                var t1 = this._hashCodeCache;
                return t1 == null ? this._hashCodeCache = B.JSString_methods.get$hashCode(this._uri) : t1;
            },
            $eq: function(_, other) {
                if (other == null) return false;
                if (this === other) return true;
                return type$.Uri._is(other) && this._uri === other.toString$0(0);
            },
            _toNonSimple$0: function() {
                var _this = this, _null = null, t1 = _this.get$scheme(), t2 = _this.get$userInfo(), t3 = _this._hostStart > 0 ? _this.get$host() : _null, t4 = _this.get$hasPort() ? _this.get$port(0) : _null, t5 = _this._uri, t6 = _this._queryStart, t7 = B.JSString_methods.substring$2(t5, _this._pathStart, t6), t8 = _this._fragmentStart;
                t6 = t6 < t8 ? _this.get$query() : _null;
                return A._Uri$_internal(t1, t2, t3, t4, t7, t6, t8 < t5.length ? _this.get$fragment() : _null);
            },
            toString$0: function(_) {
                return this._uri;
            },
            $isUri: 1,
            $is_PlatformUri: 1
        };
        A._DataUri.prototype = {};
        A.Expando.prototype = {
            $indexSet: function(_, object, value) {
                if (object instanceof A._Record) A.Expando__badExpandoKey(object);
                this._jsWeakMap.set(object, value);
            },
            toString$0: function(_) {
                return "Expando:null";
            }
        };
        A.NullRejectionException.prototype = {
            toString$0: function(_) {
                return "Promise was rejected with a value of `" + (this.isUndefined ? "undefined" : "null") + "`.";
            },
            $isException: 1
        };
        A.jsify__convert.prototype = {
            call$1: function(o) {
                var t1, convertedMap, key, convertedList;
                if (A._noJsifyRequired(o)) return o;
                t1 = this._convertedObjects;
                if (t1.containsKey$1(o)) return t1.$index(0, o);
                if (type$.Map_dynamic_dynamic._is(o)) {
                    convertedMap = {};
                    t1.$indexSet(0, o, convertedMap);
                    for(t1 = o.get$keys(o), t1 = t1.get$iterator(t1); t1.moveNext$0();){
                        key = t1.get$current(t1);
                        convertedMap[key] = this.call$1(o.$index(0, key));
                    }
                    return convertedMap;
                } else if (type$.Iterable_dynamic._is(o)) {
                    convertedList = [];
                    t1.$indexSet(0, o, convertedList);
                    B.JSArray_methods.addAll$1(convertedList, J.map$1$1$ax(o, this, type$.dynamic));
                    return convertedList;
                } else return o;
            },
            $signature: 542
        };
        A.promiseToFuture_closure.prototype = {
            call$1: function(r) {
                return this.completer.complete$1(r);
            },
            $signature: 71
        };
        A.promiseToFuture_closure0.prototype = {
            call$1: function(e) {
                if (e == null) return this.completer.completeError$1(new A.NullRejectionException(e === undefined));
                return this.completer.completeError$1(e);
            },
            $signature: 71
        };
        A._JSRandom.prototype = {
            nextInt$1: function(max) {
                if (max <= 0 || max > 4294967296) throw A.wrapException(A.RangeError$("max must be in range 0 < max \u2264 2^32, was " + max));
                return Math.random() * max >>> 0;
            },
            nextDouble$0: function() {
                return Math.random();
            }
        };
        A.ArgParser.prototype = {
            addFlag$6$abbr$defaultsTo$help$hide$negatable: function($name, abbr, defaultsTo, help, hide, negatable) {
                var _null = null;
                this._addOption$13$aliases$hide$hideNegatedUsage$negatable($name, abbr, help, _null, _null, _null, defaultsTo, _null, B.OptionType_tI9, B.List_empty, hide, false, negatable);
            },
            addFlag$2$hide: function($name, hide) {
                return this.addFlag$6$abbr$defaultsTo$help$hide$negatable($name, null, false, null, hide, true);
            },
            addFlag$2$help: function($name, help) {
                return this.addFlag$6$abbr$defaultsTo$help$hide$negatable($name, null, false, help, false, true);
            },
            addFlag$3$defaultsTo$help: function($name, defaultsTo, help) {
                return this.addFlag$6$abbr$defaultsTo$help$hide$negatable($name, null, defaultsTo, help, false, true);
            },
            addFlag$3$help$negatable: function($name, help, negatable) {
                return this.addFlag$6$abbr$defaultsTo$help$hide$negatable($name, null, false, help, false, negatable);
            },
            addFlag$3$abbr$help: function($name, abbr, help) {
                return this.addFlag$6$abbr$defaultsTo$help$hide$negatable($name, abbr, false, help, false, true);
            },
            addFlag$4$abbr$help$negatable: function($name, abbr, help, negatable) {
                return this.addFlag$6$abbr$defaultsTo$help$hide$negatable($name, abbr, false, help, false, negatable);
            },
            addOption$7$abbr$allowed$defaultsTo$help$hide$valueHelp: function($name, abbr, allowed, defaultsTo, help, hide, valueHelp) {
                this._addOption$12$aliases$hide$mandatory($name, abbr, help, valueHelp, allowed, null, defaultsTo, null, B.OptionType_zZK, B.List_empty, hide, false);
            },
            addOption$2$hide: function($name, hide) {
                var _null = null;
                return this.addOption$7$abbr$allowed$defaultsTo$help$hide$valueHelp($name, _null, _null, _null, _null, hide, _null);
            },
            addOption$6$abbr$allowed$defaultsTo$help$valueHelp: function($name, abbr, allowed, defaultsTo, help, valueHelp) {
                return this.addOption$7$abbr$allowed$defaultsTo$help$hide$valueHelp($name, abbr, allowed, defaultsTo, help, false, valueHelp);
            },
            addOption$4$allowed$defaultsTo$help: function($name, allowed, defaultsTo, help) {
                return this.addOption$7$abbr$allowed$defaultsTo$help$hide$valueHelp($name, null, allowed, defaultsTo, help, false, null);
            },
            addMultiOption$7$abbr$allowed$allowedHelp$help$splitCommas$valueHelp: function($name, abbr, allowed, allowedHelp, help, splitCommas, valueHelp) {
                var t1 = A._setArrayType([], type$.JSArray_String);
                this._addOption$12$aliases$hide$splitCommas($name, abbr, help, valueHelp, allowed, allowedHelp, t1, null, B.OptionType_1Ol, B.List_empty, false, splitCommas);
            },
            addMultiOption$5$abbr$help$splitCommas$valueHelp: function($name, abbr, help, splitCommas, valueHelp) {
                return this.addMultiOption$7$abbr$allowed$allowedHelp$help$splitCommas$valueHelp($name, abbr, null, null, help, splitCommas, valueHelp);
            },
            addMultiOption$6$abbr$allowed$allowedHelp$help$valueHelp: function($name, abbr, allowed, allowedHelp, help, valueHelp) {
                return this.addMultiOption$7$abbr$allowed$allowedHelp$help$splitCommas$valueHelp($name, abbr, allowed, allowedHelp, help, true, valueHelp);
            },
            addMultiOption$2$help: function($name, help) {
                var _null = null;
                return this.addMultiOption$7$abbr$allowed$allowedHelp$help$splitCommas$valueHelp($name, _null, _null, _null, help, true, _null);
            },
            _addOption$15$aliases$hide$hideNegatedUsage$mandatory$negatable$splitCommas: function($name, abbr, help, valueHelp, allowed, allowedHelp, defaultsTo, callback, type, aliases, hide, hideNegatedUsage, mandatory, negatable, splitCommas) {
                var existing, t2, t3, option, _i, _this = this, _null = null, t1 = A._setArrayType([
                    $name
                ], type$.JSArray_String);
                B.JSArray_methods.addAll$1(t1, aliases);
                if (B.JSArray_methods.any$1(t1, new A.ArgParser__addOption_closure(_this))) throw A.wrapException(A.ArgumentError$('Duplicate option or alias "' + $name + '".', _null));
                t1 = abbr != null;
                if (t1) {
                    existing = _this.findByAbbreviation$1(abbr);
                    if (existing != null) throw A.wrapException(A.ArgumentError$('Abbreviation "' + abbr + '" is already used by "' + existing.name + '".', _null));
                }
                t2 = allowed == null ? _null : A.List_List$unmodifiable(allowed, type$.String);
                if (allowedHelp == null) t3 = _null;
                else {
                    t3 = type$.String;
                    t3 = A.ConstantMap_ConstantMap$from(allowedHelp, t3, t3);
                }
                option = new A.Option($name, abbr, help, valueHelp, t2, t3, defaultsTo, negatable, false, callback, type, splitCommas == null ? type === B.OptionType_1Ol : splitCommas, false, hide);
                if ($name.length === 0) A.throwExpression(A.ArgumentError$("Name cannot be empty.", _null));
                else if (B.JSString_methods.startsWith$1($name, "-")) A.throwExpression(A.ArgumentError$("Name " + $name + ' cannot start with "-".', _null));
                t2 = $.$get$Option__invalidChars()._nativeRegExp;
                if (t2.test($name)) A.throwExpression(A.ArgumentError$('Name "' + $name + '" contains invalid characters.', _null));
                if (t1) {
                    if (abbr.length !== 1) A.throwExpression(A.ArgumentError$("Abbreviation must be null or have length 1.", _null));
                    else if (abbr === "-") A.throwExpression(A.ArgumentError$('Abbreviation cannot be "-".', _null));
                    if (t2.test(abbr)) A.throwExpression(A.ArgumentError$("Abbreviation is an invalid character.", _null));
                }
                _this._arg_parser$_options.$indexSet(0, $name, option);
                _this._optionsAndSeparators.push(option);
                for(t1 = _this._aliases, _i = 0; false;);
            },
            _addOption$12$aliases$hide$splitCommas: function($name, abbr, help, valueHelp, allowed, allowedHelp, defaultsTo, callback, type, aliases, hide, splitCommas) {
                return this._addOption$15$aliases$hide$hideNegatedUsage$mandatory$negatable$splitCommas($name, abbr, help, valueHelp, allowed, allowedHelp, defaultsTo, callback, type, aliases, hide, false, false, false, splitCommas);
            },
            _addOption$12$aliases$hide$mandatory: function($name, abbr, help, valueHelp, allowed, allowedHelp, defaultsTo, callback, type, aliases, hide, mandatory) {
                return this._addOption$15$aliases$hide$hideNegatedUsage$mandatory$negatable$splitCommas($name, abbr, help, valueHelp, allowed, allowedHelp, defaultsTo, callback, type, aliases, hide, false, mandatory, false, null);
            },
            _addOption$13$aliases$hide$hideNegatedUsage$negatable: function($name, abbr, help, valueHelp, allowed, allowedHelp, defaultsTo, callback, type, aliases, hide, hideNegatedUsage, negatable) {
                return this._addOption$15$aliases$hide$hideNegatedUsage$mandatory$negatable$splitCommas($name, abbr, help, valueHelp, allowed, allowedHelp, defaultsTo, callback, type, aliases, hide, hideNegatedUsage, false, negatable, null);
            },
            findByAbbreviation$1: function(abbr) {
                var t1, t2;
                for(t1 = this.options._map, t1 = t1.get$values(t1), t1 = t1.get$iterator(t1); t1.moveNext$0();){
                    t2 = t1.get$current(t1);
                    if (t2.abbr === abbr) return t2;
                }
                return null;
            },
            findByNameOrAlias$1: function($name) {
                var t1 = this._aliases.$index(0, $name);
                if (t1 == null) t1 = $name;
                return this.options._map.$index(0, t1);
            }
        };
        A.ArgParser__addOption_closure.prototype = {
            call$1: function($name) {
                return this.$this.findByNameOrAlias$1($name) != null;
            },
            $signature: 4
        };
        A.ArgParserException.prototype = {};
        A.ArgResults.prototype = {
            $index: function(_, $name) {
                var t1 = this._parser.options._map;
                if (!t1.containsKey$1($name)) throw A.wrapException(A.ArgumentError$('Could not find an option named "--' + $name + '".', null));
                t1 = t1.$index(0, $name);
                t1.toString;
                return t1.valueOrDefault$1(this._parsed.$index(0, $name));
            },
            wasParsed$1: function($name) {
                if (!this._parser.options._map.containsKey$1($name)) throw A.wrapException(A.ArgumentError$('Could not find an option named "--' + $name + '".', null));
                return this._parsed.containsKey$1($name);
            }
        };
        A.Option.prototype = {
            valueOrDefault$1: function(value) {
                var t1;
                if (value != null) return value;
                if (this.type === B.OptionType_1Ol) {
                    t1 = this.defaultsTo;
                    return t1 == null ? A._setArrayType([], type$.JSArray_String) : t1;
                }
                return this.defaultsTo;
            }
        };
        A.OptionType.prototype = {};
        A.Parser0.prototype = {
            parse$0: function(_) {
                var commandResults, commandName, commandParser, error, t1, t3, t4, t5, t6, t7, t8, command, _$exception, _this = this, t2 = _this._args;
                t2.toList$0(0);
                commandResults = null;
                for(t3 = _this._parser$_rest, t4 = _this._grammar, t5 = t4.commands, t6 = t2.$ti._precomputed1; !t2.get$isEmpty(0);){
                    t7 = t2._head;
                    if (t7 === t2._tail) A.throwExpression(A.IterableElementError_noElement());
                    t7 = t2._table[t7];
                    t8 = t7 == null;
                    if ((t8 ? t6._as(t7) : t7) === "--") {
                        t2.removeFirst$0();
                        break;
                    }
                    if (t8) t7 = t6._as(t7);
                    command = t5._map.$index(0, t7);
                    if (command != null) {
                        t5 = t3.length;
                        t7 = t2._head;
                        if (t7 === t2._tail) A.throwExpression(A.IterableElementError_noElement());
                        t7 = t2._table[t7];
                        t6 = t7 == null ? t6._as(t7) : t7;
                        if (t5 !== 0) A.throwExpression(A.ArgParserException$("Cannot specify arguments before a command.", null, t6, null, null));
                        commandName = t2.removeFirst$0();
                        t5 = type$.JSArray_String;
                        t6 = A._setArrayType([], t5);
                        B.JSArray_methods.addAll$1(t6, t3);
                        commandParser = new A.Parser0(commandName, _this, command, t2, t6, A.LinkedHashMap_LinkedHashMap$_empty(type$.String, type$.dynamic));
                        try {
                            commandResults = J.parse$0$z(commandParser);
                        } catch (exception) {
                            t2 = A.unwrapException(exception);
                            if (t2 instanceof A.ArgParserException) {
                                error = t2;
                                t2 = error.message;
                                t1 = A._setArrayType([
                                    commandName
                                ], t5);
                                J.addAll$1$ax(t1, error.commands);
                                throw A.wrapException(A.ArgParserException$(t2, t1, error.argumentName, error.source, error.offset));
                            } else throw exception;
                        }
                        B.JSArray_methods.clear$0(t3);
                        break;
                    }
                    if (_this._parseSoloOption$0()) continue;
                    if (_this._parseAbbreviation$1(_this)) continue;
                    if (_this._parseLongOption$0()) continue;
                    t3.push(t2.removeFirst$0());
                }
                t4.options._map.forEach$1(0, new A.Parser_parse_closure(_this));
                B.JSArray_methods.addAll$1(t3, t2);
                t2.clear$0(0);
                return new A.ArgResults(t4, _this._results, _this._commandName, new A.UnmodifiableListView(t3, type$.UnmodifiableListView_String));
            },
            _readNextArgAsValue$2: function(option, arg) {
                var _this = this, t1 = _this._args;
                _this._validate$3(!t1.get$isEmpty(0), 'Missing argument for "' + arg + '".', arg);
                _this._setOption$4(_this._results, option, t1.get$first(0), arg);
                t1.removeFirst$0();
            },
            _parseSoloOption$0: function() {
                var opt, t1 = this._args;
                if (t1.get$first(0).length !== 2) return false;
                if (!B.JSString_methods.startsWith$1(t1.get$first(0), "-")) return false;
                opt = t1.get$first(0)[1];
                if (!A._isLetterOrDigit(opt.charCodeAt(0))) return false;
                this._handleSoloOption$1(opt);
                return true;
            },
            _handleSoloOption$1: function(opt) {
                var t1, _this = this, option = _this._grammar.findByAbbreviation$1(opt);
                if (option == null) {
                    t1 = _this._parser$_parent;
                    _this._validate$3(t1 != null, 'Could not find an option or flag "-' + opt + '".', "-" + opt);
                    t1._handleSoloOption$1(opt);
                    return true;
                }
                _this._args.removeFirst$0();
                if (option.type === B.OptionType_tI9) _this._results.$indexSet(0, option.name, true);
                else _this._readNextArgAsValue$2(option, "-" + opt);
                return true;
            },
            _parseAbbreviation$1: function(innermostCommand) {
                var t2, index, t3, t4, t5, lettersAndDigits, rest, t1 = this._args;
                if (t1.get$first(0).length < 2) return false;
                if (!B.JSString_methods.startsWith$1(t1.get$first(0), "-")) return false;
                t2 = t1.$ti._precomputed1;
                index = 1;
                for(;;){
                    t3 = t1._head;
                    if (t3 === t1._tail) A.throwExpression(A.IterableElementError_noElement());
                    t3 = t1._table[t3];
                    t4 = t3 == null;
                    if (index < (t4 ? t2._as(t3) : t3).length) {
                        t5 = true;
                        t3 = (t4 ? t2._as(t3) : t3).charCodeAt(index);
                        if (!(t3 >= 65 && t3 <= 90)) {
                            if (!(t3 >= 97 && t3 <= 122)) t3 = t3 >= 48 && t3 <= 57;
                            else t3 = t5;
                        } else t3 = t5;
                    } else t3 = false;
                    if (!t3) break;
                    ++index;
                }
                if (index === 1) return false;
                lettersAndDigits = B.JSString_methods.substring$2(t1.get$first(0), 1, index);
                rest = B.JSString_methods.substring$1(t1.get$first(0), index);
                if (B.JSString_methods.contains$1(rest, "\n") || B.JSString_methods.contains$1(rest, "\r")) return false;
                this._handleAbbreviation$3(lettersAndDigits, rest, innermostCommand);
                return true;
            },
            _handleAbbreviation$3: function(lettersAndDigits, rest, innermostCommand) {
                var t1, i, i0, _this = this, c = B.JSString_methods.substring$2(lettersAndDigits, 0, 1), first = _this._grammar.findByAbbreviation$1(c);
                if (first == null) {
                    t1 = _this._parser$_parent;
                    _this._validate$3(t1 != null, string$.Could_ + c + '".', "-" + c);
                    t1._handleAbbreviation$3(lettersAndDigits, rest, innermostCommand);
                    return true;
                } else {
                    t1 = "-" + c;
                    if (first.type !== B.OptionType_tI9) _this._setOption$4(_this._results, first, B.JSString_methods.substring$1(lettersAndDigits, 1) + rest, t1);
                    else {
                        _this._validate$3(rest === "", 'Option "-' + c + '" is a flag and cannot handle value "' + B.JSString_methods.substring$1(lettersAndDigits, 1) + rest + '".', t1);
                        for(t1 = lettersAndDigits.length, i = 0; i < t1; i = i0){
                            i0 = i + 1;
                            innermostCommand._parseShortFlag$1(B.JSString_methods.substring$2(lettersAndDigits, i, i0));
                        }
                    }
                }
                _this._args.removeFirst$0();
                return true;
            },
            _parseShortFlag$1: function(c) {
                var t1, _this = this, option = _this._grammar.findByAbbreviation$1(c);
                if (option == null) {
                    t1 = _this._parser$_parent;
                    _this._validate$3(t1 != null, string$.Could_ + c + '".', "-" + c);
                    t1._parseShortFlag$1(c);
                    return;
                }
                _this._validate$3(option.type === B.OptionType_tI9, 'Option "-' + c + '" must be a flag to be in a collapsed "-".', "-" + c);
                _this._results.$indexSet(0, option.name, true);
            },
            _parseLongOption$0: function() {
                var index, t2, $name, t3, i, t4, t5, value, t1 = this._args;
                if (!B.JSString_methods.startsWith$1(t1.get$first(0), "--")) return false;
                index = B.JSString_methods.indexOf$1(t1.get$first(0), "=");
                t2 = index === -1;
                $name = t2 ? B.JSString_methods.substring$1(t1.get$first(0), 2) : B.JSString_methods.substring$2(t1.get$first(0), 2, index);
                for(t3 = $name.length, i = 0; i !== t3; ++i){
                    t4 = $name.charCodeAt(i);
                    t5 = true;
                    if (!(t4 >= 65 && t4 <= 90)) {
                        if (!(t4 >= 97 && t4 <= 122)) t5 = t4 >= 48 && t4 <= 57;
                    }
                    if (!(t5 || t4 === 45 || t4 === 95)) return false;
                }
                value = t2 ? null : B.JSString_methods.substring$1(t1.get$first(0), index + 1);
                if (value != null) t1 = B.JSString_methods.contains$1(value, "\n") || B.JSString_methods.contains$1(value, "\r");
                else t1 = false;
                if (t1) return false;
                this._handleLongOption$2($name, value);
                return true;
            },
            _handleLongOption$2: function($name, value) {
                var _this = this, _s34_ = 'Could not find an option named "--', t1 = _this._grammar, option = t1.findByNameOrAlias$1($name);
                if (option != null) {
                    _this._args.removeFirst$0();
                    if (option.type === B.OptionType_tI9) {
                        _this._validate$3(value == null, 'Flag option "--' + $name + '" should not be given a value.', "--" + $name);
                        _this._results.$indexSet(0, option.name, true);
                    } else {
                        t1 = "--" + $name;
                        if (value != null) _this._setOption$4(_this._results, option, value, t1);
                        else _this._readNextArgAsValue$2(option, t1);
                    }
                } else if (B.JSString_methods.startsWith$1($name, "no-")) {
                    option = t1.findByNameOrAlias$1(B.JSString_methods.substring$1($name, 3));
                    if (option == null) {
                        t1 = _this._parser$_parent;
                        _this._validate$3(t1 != null, _s34_ + $name + '".', "--" + $name);
                        t1._handleLongOption$2($name, value);
                        return true;
                    }
                    _this._args.removeFirst$0();
                    t1 = "--" + $name;
                    _this._validate$3(option.type === B.OptionType_tI9, 'Cannot negate non-flag option "--' + $name + '".', t1);
                    _this._validate$3(option.negatable, 'Cannot negate option "--' + $name + '".', t1);
                    _this._results.$indexSet(0, option.name, false);
                } else {
                    t1 = _this._parser$_parent;
                    _this._validate$3(t1 != null, _s34_ + $name + '".', "--" + $name);
                    t1._handleLongOption$2($name, value);
                    return true;
                }
                return true;
            },
            _validate$3: function(condition, message, args) {
                if (!condition) throw A.wrapException(A.ArgParserException$(message, null, args, null, null));
            },
            _setOption$4: function(results, option, value, arg) {
                var list, t1, t2, t3, _i, element;
                if (option.type !== B.OptionType_1Ol) {
                    this._validateAllowed$3(option, value, arg);
                    results.$indexSet(0, option.name, value);
                    return;
                }
                list = type$.List_dynamic._as(results.putIfAbsent$2(option.name, new A.Parser__setOption_closure()));
                if (option.splitCommas) for(t1 = value.split(","), t2 = t1.length, t3 = J.getInterceptor$ax(list), _i = 0; _i < t2; ++_i){
                    element = t1[_i];
                    this._validateAllowed$3(option, element, arg);
                    t3.add$1(list, element);
                }
                else {
                    this._validateAllowed$3(option, value, arg);
                    J.add$1$ax(list, value);
                }
            },
            _validateAllowed$3: function(option, value, arg) {
                var t1 = option.allowed;
                if (t1 == null) return;
                this._validate$3(B.JSArray_methods.contains$1(t1, value), '"' + value + '" is not an allowed value for option "' + arg + '".', arg);
            }
        };
        A.Parser_parse_closure.prototype = {
            call$2: function($name, option) {
                var parsedOption = this.$this._results.$index(0, $name), callback = option.callback;
                if (callback == null) return;
                callback.call$1(option.valueOrDefault$1(parsedOption));
            },
            $signature: 311
        };
        A.Parser__setOption_closure.prototype = {
            call$0: function() {
                return A._setArrayType([], type$.JSArray_String);
            },
            $signature: 139
        };
        A._Usage.prototype = {
            get$_columnWidths: function() {
                var result, _this = this, value = _this.___Usage__columnWidths_FI;
                if (value === $) {
                    result = _this._calculateColumnWidths$0();
                    _this.___Usage__columnWidths_FI !== $ && A.throwUnnamedLateFieldADI();
                    _this.___Usage__columnWidths_FI = result;
                    value = result;
                }
                return value;
            },
            generate$0: function() {
                var t1, t2, t3, t4, _i, optionOrSeparator, t5, _this = this;
                for(t1 = _this._usage$_optionsAndSeparators, t2 = t1.length, t3 = type$.Option, t4 = _this._usage$_buffer, _i = 0; _i < t1.length; t1.length === t2 || (0, A.throwConcurrentModificationError)(t1), ++_i){
                    optionOrSeparator = t1[_i];
                    if (typeof optionOrSeparator == "string") {
                        t5 = t4._contents;
                        t4._contents = (t5.length !== 0 ? t4._contents = t5 + "\n\n" : t5) + optionOrSeparator;
                        _this._newlinesNeeded = 1;
                        continue;
                    }
                    t3._as(optionOrSeparator);
                    if (optionOrSeparator.hide) continue;
                    _this._writeOption$1(optionOrSeparator);
                }
                t1 = t4._contents;
                return t1.charCodeAt(0) == 0 ? t1 : t1;
            },
            _writeOption$1: function(option) {
                var _0_0, _1_0, t2, t3, t4, $name, $content, _this = this, t1 = option.abbr;
                _this._write$2(0, t1 == null ? "" : "-" + t1 + ", ");
                t1 = _this._longOption$1(option);
                _this._write$2(1, t1);
                _0_0 = option.help;
                if (_0_0 != null) _this._write$2(2, _0_0);
                _1_0 = option.allowedHelp;
                if (_1_0 != null) {
                    _this._newline$0();
                    for(t1 = _1_0.get$entries(_1_0), t1 = t1.get$iterator(t1), t2 = option.defaultsTo, t3 = type$.List_dynamic._is(t2); t1.moveNext$0();){
                        t4 = t1.get$current(t1);
                        $name = t4.key;
                        $content = t4.value;
                        t4 = (t3 ? B.JSArray_methods.contains$1(t2, $name) : t2 === $name) ? " (default)" : "";
                        _this._write$2(1, "      [" + $name + "]" + t4);
                        _this._write$2(2, $content);
                    }
                    _this._newline$0();
                } else if (option.allowed != null) _this._write$2(2, _this._buildAllowedList$1(option));
                else {
                    t1 = option.type;
                    if (t1 === B.OptionType_tI9) {
                        if (option.defaultsTo === true) _this._write$2(2, "(defaults to on)");
                    } else if (t1 === B.OptionType_1Ol) {
                        t1 = option.defaultsTo;
                        if (t1 != null && type$.Iterable_dynamic._as(t1).length !== 0) {
                            type$.List_dynamic._as(t1);
                            _this._write$2(2, "(defaults to " + new A.MappedListIterable(t1, new A._Usage__writeOption_closure(), A._arrayInstanceType(t1)._eval$1("MappedListIterable<1,String>")).join$1(0, ", ") + ")");
                        }
                    } else {
                        t1 = option.defaultsTo;
                        if (t1 != null) _this._write$2(2, '(defaults to "' + A.S(t1) + '")');
                    }
                }
            },
            _longOption$1: function(option) {
                var t1 = option.name, result = option.negatable ? "--[no-]" + t1 : "--" + t1;
                t1 = option.valueHelp;
                return t1 != null ? result + ("=<" + t1 + ">") : result;
            },
            _calculateColumnWidths$0: function() {
                var t1, t2, t3, abbr, title, _i, option, t4, t5, t6, t7, t8;
                for(t1 = this._usage$_optionsAndSeparators, t2 = t1.length, t3 = type$.List_dynamic, abbr = 0, title = 0, _i = 0; _i < t1.length; t1.length === t2 || (0, A.throwConcurrentModificationError)(t1), ++_i){
                    option = t1[_i];
                    if (!(option instanceof A.Option)) continue;
                    if (option.hide) continue;
                    t4 = option.abbr;
                    abbr = Math.max(abbr, (t4 == null ? "" : "-" + t4 + ", ").length);
                    t4 = this._longOption$1(option);
                    title = Math.max(title, t4.length);
                    t4 = option.allowedHelp;
                    if (t4 != null) for(t4 = t4.get$keys(t4), t4 = t4.get$iterator(t4), t5 = option.defaultsTo, t6 = t3._is(t5); t4.moveNext$0();){
                        t7 = t4.get$current(t4);
                        t8 = (t6 ? B.JSArray_methods.contains$1(t5, t7) : t5 === t7) ? " (default)" : "";
                        title = Math.max(title, ("      [" + t7 + "]" + t8).length);
                    }
                }
                return A._setArrayType([
                    abbr,
                    title + 4
                ], type$.JSArray_int);
            },
            _newline$0: function() {
                ++this._newlinesNeeded;
                this._currentColumn = 0;
            },
            _write$2: function(column, text) {
                var t1, _i, lines = A._setArrayType(text.split("\n"), type$.JSArray_String);
                this.get$_columnWidths();
                for(;;){
                    if (!(lines.length !== 0 && B.JSString_methods.trim$0(B.JSArray_methods.get$first(lines)) === "")) break;
                    B.JSArray_methods.removeAt$1(lines, 0);
                }
                for(;;){
                    if (!(lines.length !== 0 && B.JSString_methods.trim$0(B.JSArray_methods.get$last(lines)) === "")) break;
                    lines.pop();
                }
                for(t1 = lines.length, _i = 0; _i < lines.length; lines.length === t1 || (0, A.throwConcurrentModificationError)(lines), ++_i)this._writeLine$2(column, lines[_i]);
            },
            _writeLine$2: function(column, text) {
                var t1, t2, t3, _this = this;
                for(t1 = _this._usage$_buffer; t2 = _this._newlinesNeeded, t2 > 0;){
                    t1._contents += "\n";
                    _this._newlinesNeeded = t2 - 1;
                }
                while(t2 = _this._currentColumn, t2 !== column){
                    if (t2 < 2) {
                        t2 = _this.get$_columnWidths();
                        t3 = _this._currentColumn;
                        t2 = B.JSString_methods.$mul(" ", t2[t3]);
                        t1._contents += t2;
                        t2 = t3;
                    } else t1._contents += "\n";
                    _this._currentColumn = (t2 + 1) % 3;
                }
                t2 = _this.get$_columnWidths();
                t3 = t1._contents;
                if (column < 2) t1._contents = t3 + B.JSString_methods.padRight$1(text, t2[column]);
                else t1._contents = t3 + text;
                _this._currentColumn = (_this._currentColumn + 1) % 3;
                if (column === 2) ++_this._newlinesNeeded;
            },
            _buildAllowedList$1: function(option) {
                var t2, first, _i, t3, allowed, t1 = option.defaultsTo, isDefault = type$.List_dynamic._is(t1) ? B.JSArray_methods.get$contains(t1) : new A._Usage__buildAllowedList_closure(option);
                for(t1 = option.allowed, t2 = t1.length, first = true, _i = 0, t3 = "["; _i < t2; ++_i, first = false){
                    allowed = t1[_i];
                    t3 = (!first ? t3 + ", " : t3) + allowed;
                    if (isDefault.call$1(allowed)) t3 += " (default)";
                }
                t1 = t3 + "]";
                return t1.charCodeAt(0) == 0 ? t1 : t1;
            }
        };
        A._Usage__writeOption_closure.prototype = {
            call$1: function(value) {
                return '"' + A.S(value) + '"';
            },
            $signature: 134
        };
        A._Usage__buildAllowedList_closure.prototype = {
            call$1: function(value) {
                return value === this.option.defaultsTo;
            },
            $signature: 4
        };
        A.FutureGroup.prototype = {
            add$1: function(_, task) {
                var t1, index, _this = this;
                if (_this._future_group$_closed) throw A.wrapException(A.StateError$("The FutureGroup is closed."));
                t1 = _this._future_group$_values;
                index = t1.length;
                t1.push(null);
                ++_this._future_group$_pending;
                task.then$1$1(0, new A.FutureGroup_add_closure(_this, index), type$.Null).catchError$1(new A.FutureGroup_add_closure0(_this));
            },
            close$0: function(_) {
                var t1, t2, _this = this;
                _this._future_group$_closed = true;
                if (_this._future_group$_pending !== 0) return;
                t1 = _this._future_group$_completer;
                if ((t1.future._state & 30) !== 0) return;
                t2 = _this.$ti._eval$1("WhereTypeIterable<1>");
                t2 = A.List_List$_of(new A.WhereTypeIterable(_this._future_group$_values, t2), t2._eval$1("Iterable.E"));
                t1.complete$1(t2);
            }
        };
        A.FutureGroup_add_closure.prototype = {
            call$1: function(value) {
                var t3, t4, t1 = this.$this, t2 = t1._future_group$_completer;
                if ((t2.future._state & 30) !== 0) return null;
                t3 = --t1._future_group$_pending;
                t4 = t1._future_group$_values;
                t4[this.index] = value;
                if (t3 !== 0) return null;
                if (!t1._future_group$_closed) return null;
                t1 = t1.$ti._eval$1("WhereTypeIterable<1>");
                t1 = A.List_List$_of(new A.WhereTypeIterable(t4, t1), t1._eval$1("Iterable.E"));
                t2.complete$1(t1);
            },
            $signature: function() {
                return this.$this.$ti._eval$1("Null(1)");
            }
        };
        A.FutureGroup_add_closure0.prototype = {
            call$2: function(error, stackTrace) {
                var t1 = this.$this._future_group$_completer;
                if ((t1.future._state & 30) !== 0) return null;
                t1.completeError$2(error, stackTrace);
            },
            $signature: 51
        };
        A.ErrorResult.prototype = {
            complete$1: function(completer) {
                completer.completeError$2(this.error, this.stackTrace);
            },
            get$hashCode: function(_) {
                return (J.get$hashCode$(this.error) ^ A.Primitives_objectHashCode(this.stackTrace) ^ 492929599) >>> 0;
            },
            $eq: function(_, other) {
                if (other == null) return false;
                return other instanceof A.ErrorResult && J.$eq$(this.error, other.error) && this.stackTrace === other.stackTrace;
            },
            $isResult: 1
        };
        A.ValueResult.prototype = {
            complete$1: function(completer) {
                completer.complete$1(this.value);
            },
            get$hashCode: function(_) {
                return (J.get$hashCode$(this.value) ^ 842997089) >>> 0;
            },
            $eq: function(_, other) {
                if (other == null) return false;
                return other instanceof A.ValueResult && J.$eq$(this.value, other.value);
            },
            $isResult: 1
        };
        A.StreamCompleter.prototype = {
            setSourceStream$1: function(sourceStream) {
                var t1 = this._stream_completer$_stream;
                if (t1._sourceStream != null) throw A.wrapException(A.StateError$("Source stream already set"));
                t1._sourceStream = sourceStream;
                if (t1._stream_completer$_controller != null) t1._linkStreamToController$0();
            },
            setError$2: function(error, stackTrace) {
                var t1 = this.$ti, t2 = A._interceptUserError(error, stackTrace), t3 = new A._Future($.Zone__current, t1._eval$1("_Future<1>"));
                t3._asyncCompleteErrorObject$1(t2);
                this.setSourceStream$1(A.Stream_Stream$fromFuture(t3, t1._precomputed1));
            },
            setError$1: function(error) {
                return this.setError$2(error, null);
            }
        };
        A._CompleterStream.prototype = {
            listen$4$cancelOnError$onDone$onError: function(_, onData, cancelOnError, onDone, onError) {
                var sourceStream, t1, _this = this, _null = null;
                if (_this._stream_completer$_controller == null) {
                    sourceStream = _this._sourceStream;
                    if (sourceStream != null && !sourceStream.get$isBroadcast()) return sourceStream.listen$4$cancelOnError$onDone$onError(0, onData, cancelOnError, onDone, onError);
                    if (_this._stream_completer$_controller == null) _this._stream_completer$_controller = A.StreamController_StreamController(_null, _null, _null, _null, true, _this.$ti._precomputed1);
                    if (_this._sourceStream != null) _this._linkStreamToController$0();
                }
                t1 = _this._stream_completer$_controller;
                t1.toString;
                return new A._ControllerStream(t1, A._instanceType(t1)._eval$1("_ControllerStream<1>")).listen$4$cancelOnError$onDone$onError(0, onData, cancelOnError, onDone, onError);
            },
            listen$1: function(_, onData) {
                return this.listen$4$cancelOnError$onDone$onError(0, onData, null, null, null);
            },
            listen$3$onDone$onError: function(_, onData, onDone, onError) {
                return this.listen$4$cancelOnError$onDone$onError(0, onData, null, onDone, onError);
            },
            _linkStreamToController$0: function() {
                var t2, t1 = this._stream_completer$_controller;
                t1.toString;
                t2 = this._sourceStream;
                t2.toString;
                t1.addStream$2$cancelOnError(t2, false).whenComplete$1(t1.get$close(t1));
            }
        };
        A.StreamGroup.prototype = {
            add$1: function(_, stream) {
                var t1, _this = this;
                if (_this._closed) throw A.wrapException(A.StateError$("Can't add a Stream to a closed StreamGroup."));
                t1 = _this._stream_group$_state;
                if (t1 === B._StreamGroupState_dormant) _this._subscriptions.putIfAbsent$2(stream, new A.StreamGroup_add_closure());
                else if (t1 === B._StreamGroupState_canceled) return stream.listen$1(0, null).cancel$0();
                else _this._subscriptions.putIfAbsent$2(stream, new A.StreamGroup_add_closure0(_this, stream));
                return null;
            },
            remove$1: function(_, stream) {
                var t1 = this._subscriptions, subscription = t1.remove$1(0, stream), future = subscription == null ? null : subscription.cancel$0();
                if (t1.__js_helper$_length === 0) {
                    if (this._closed) {
                        t1 = this.__StreamGroup__controller_A;
                        t1 === $ && A.throwUnnamedLateFieldNI();
                        A.scheduleMicrotask(t1.get$close(t1));
                    }
                }
                return future;
            },
            _onListen$0: function() {
                var stream, t1, t2, t3, _i, entry, _$exception, _this = this;
                _this._stream_group$_state = B._StreamGroupState_listening;
                t1 = _this._subscriptions;
                t2 = A.List_List$_of(new A.LinkedHashMapEntriesIterable(t1, A._instanceType(t1)._eval$1("LinkedHashMapEntriesIterable<1,2>")), _this.$ti._eval$1("MapEntry<Stream<1>,StreamSubscription<1>?>"));
                t3 = t2.length;
                _i = 0;
                for(; _i < t2.length; t2.length === t3 || (0, A.throwConcurrentModificationError)(t2), ++_i){
                    entry = t2[_i];
                    if (entry.value != null) continue;
                    stream = entry.key;
                    try {
                        t1.$indexSet(0, stream, _this._listenToStream$1(stream));
                    } catch (exception) {
                        t1 = _this._onCancel$0();
                        if (t1 != null) t1.catchError$1(new A.StreamGroup__onListen_closure());
                        throw exception;
                    }
                }
            },
            _onPause$0: function() {
                this._stream_group$_state = B._StreamGroupState_paused;
                for(var t1 = this._subscriptions, t1 = new A.LinkedHashMapValueIterator(t1, t1._modifications, t1._first); t1.moveNext$0();)t1.__js_helper$_current.pause$0(0);
            },
            _onResume$0: function() {
                this._stream_group$_state = B._StreamGroupState_listening;
                for(var t1 = this._subscriptions, t1 = new A.LinkedHashMapValueIterator(t1, t1._modifications, t1._first); t1.moveNext$0();)t1.__js_helper$_current.resume$0(0);
            },
            _onCancel$0: function() {
                var t1, t2, t3, futures;
                this._stream_group$_state = B._StreamGroupState_canceled;
                t1 = this._subscriptions;
                t2 = A._instanceType(t1)._eval$1("LinkedHashMapEntriesIterable<1,2>");
                t3 = type$.NonNullsIterable_Future_void;
                futures = A.List_List$_of(new A.NonNullsIterable(A.MappedIterable_MappedIterable(new A.LinkedHashMapEntriesIterable(t1, t2), new A.StreamGroup__onCancel_closure(this), t2._eval$1("Iterable.E"), type$.nullable_Future_void), t3), t3._eval$1("Iterable.E"));
                t1.clear$0(0);
                return futures.length === 0 ? null : A.Future_wait(futures, false, type$.void);
            },
            _listenToStream$1: function(stream) {
                var subscription, t1 = this.__StreamGroup__controller_A;
                t1 === $ && A.throwUnnamedLateFieldNI();
                subscription = stream.listen$3$onDone$onError(0, t1.get$add(t1), new A.StreamGroup__listenToStream_closure(this, stream), t1.get$addError());
                if (this._stream_group$_state === B._StreamGroupState_paused) subscription.pause$0(0);
                return subscription;
            }
        };
        A.StreamGroup_add_closure.prototype = {
            call$0: function() {
                return null;
            },
            $signature: 1
        };
        A.StreamGroup_add_closure0.prototype = {
            call$0: function() {
                return this.$this._listenToStream$1(this.stream);
            },
            $signature: function() {
                return this.$this.$ti._eval$1("StreamSubscription<1>()");
            }
        };
        A.StreamGroup__onListen_closure.prototype = {
            call$1: function(_) {},
            $signature: 62
        };
        A.StreamGroup__onCancel_closure.prototype = {
            call$1: function(entry) {
                var t1, exception, subscription = entry.value;
                try {
                    if (subscription != null) {
                        t1 = subscription.cancel$0();
                        return t1;
                    }
                    t1 = entry.key.listen$1(0, null).cancel$0();
                    return t1;
                } catch (exception) {
                    return null;
                }
            },
            $signature: function() {
                return this.$this.$ti._eval$1("Future<~>?(MapEntry<Stream<1>,StreamSubscription<1>?>)");
            }
        };
        A.StreamGroup__listenToStream_closure.prototype = {
            call$0: function() {
                return this.$this.remove$1(0, this.stream);
            },
            $signature: 0
        };
        A._StreamGroupState.prototype = {
            toString$0: function(_) {
                return this.name;
            }
        };
        A.StreamQueue.prototype = {
            _updateRequests$0: function() {
                var t1, t2, t3, t4, _this = this;
                for(t1 = _this._requestQueue, t2 = _this._eventQueue, t3 = t1.$ti._precomputed1; !t1.get$isEmpty(0);){
                    t4 = t1._head;
                    if (t4 === t1._tail) A.throwExpression(A.IterableElementError_noElement());
                    t4 = t1._table[t4];
                    if (t4 == null) t4 = t3._as(t4);
                    if (t4.update$2(t2, _this._isDone)) t1.removeFirst$0();
                    else return;
                }
                if (!_this._isDone) _this._stream_queue$_subscription.pause$0(0);
            },
            _ensureListening$0: function() {
                var t1, _this = this;
                if (_this._isDone) return;
                t1 = _this._stream_queue$_subscription;
                if (t1 == null) _this._stream_queue$_subscription = _this._stream_queue$_source.listen$3$onDone$onError(0, new A.StreamQueue__ensureListening_closure(_this), new A.StreamQueue__ensureListening_closure0(_this), new A.StreamQueue__ensureListening_closure1(_this));
                else t1.resume$0(0);
            },
            _addResult$1: function(result) {
                ++this._eventsReceived;
                this._eventQueue._queue_list$_add$1(result);
                this._updateRequests$0();
            },
            _addRequest$1: function(request) {
                var _this = this, t1 = _this._requestQueue;
                if (t1._head === t1._tail) {
                    if (request.update$2(_this._eventQueue, _this._isDone)) return;
                    _this._ensureListening$0();
                }
                t1._add$1(request);
            }
        };
        A.StreamQueue__ensureListening_closure.prototype = {
            call$1: function(data) {
                var t1 = this.$this;
                t1._addResult$1(new A.ValueResult(data, t1.$ti._eval$1("ValueResult<1>")));
            },
            $signature: function() {
                return this.$this.$ti._eval$1("~(1)");
            }
        };
        A.StreamQueue__ensureListening_closure1.prototype = {
            call$2: function(error, stackTrace) {
                this.$this._addResult$1(new A.ErrorResult(error, stackTrace));
            },
            $signature: 51
        };
        A.StreamQueue__ensureListening_closure0.prototype = {
            call$0: function() {
                var t1 = this.$this;
                t1._stream_queue$_subscription = null;
                t1._isDone = true;
                t1._updateRequests$0();
            },
            $signature: 0
        };
        A._NextRequest.prototype = {
            update$2: function(events, isDone) {
                if (!events.get$isEmpty(events)) {
                    events.removeFirst$0().complete$1(this._completer);
                    return true;
                }
                if (isDone) {
                    this._completer.completeError$2(new A.StateError("No elements"), A.StackTrace_current());
                    return true;
                }
                return false;
            },
            $is_EventRequest: 1
        };
        A._isStrictMode_closure.prototype = {
            call$0: function() {
                var exception;
                try {
                    "".name = null;
                    return false;
                } catch (exception) {
                    return true;
                }
            },
            $signature: 20
        };
        A.Repl.prototype = {};
        A.alwaysValid_closure.prototype = {
            call$1: function(text) {
                return true;
            },
            $signature: 4
        };
        A.ReplAdapter.prototype = {
            runAsync$0: function() {
                var rl, runController, _this = this, t1 = {}, t2 = J.get$isTTY$x(self.process.stdin), output = (t2 == null ? false : t2) ? self.process.stdout : null;
                t2 = _this.repl.prompt;
                rl = J.createInterface$1$x($.$get$readline(), {
                    input: self.process.stdin,
                    output: output,
                    prompt: t2
                });
                _this.rl = rl;
                t1.statement = "";
                t1.prompt = t2;
                runController = A._Cell$();
                runController.__late_helper$_value = A.StreamController_StreamController(_this.get$exit(_this), new A.ReplAdapter_runAsync_closure(t1, _this, rl, runController), null, null, false, type$.String);
                return runController._readLocal$0().get$stream();
            },
            exit$0: function(_) {
                var t1 = this.rl;
                if (t1 != null) J.close$0$x(t1);
                this.rl = null;
            }
        };
        A.ReplAdapter_runAsync_closure.prototype = {
            call$0: function() {
                var $async$goto = 0, $async$completer = A._makeAsyncAwaitCompleter(type$.void), $async$handler = 1, $async$errorStack = [], $async$self = this, lineController, lineQueue, line, error, stackTrace, t1, t2, t3, t4, $prompt, prompt0, t5, t6, t7, t8, line0, toZone, statement, exception, $async$exception;
                var $async$call$0 = A._wrapJsFunctionForAsync(function($async$errorCode, $async$result) {
                    if ($async$errorCode === 1) {
                        $async$errorStack.push($async$result);
                        $async$goto = $async$handler;
                    }
                    for(;;)switch($async$goto){
                        case 0:
                            // Function start
                            $async$handler = 3;
                            lineController = A.StreamController_StreamController(null, null, null, null, false, type$.String);
                            t1 = lineController;
                            t2 = A.QueueList$(null, type$.Result_String);
                            t3 = A.ListQueue$(type$._EventRequest_dynamic);
                            lineQueue = new A.StreamQueue(new A._ControllerStream(t1, A._instanceType(t1)._eval$1("_ControllerStream<1>")), t2, t3, type$.StreamQueue_String);
                            t1 = $async$self.rl;
                            t2 = J.getInterceptor$x(t1);
                            t2.on$2(t1, "line", A.allowInterop(new A.ReplAdapter_runAsync__closure(lineController)));
                            t3 = $async$self._box_0, t4 = $async$self.$this.repl, $prompt = t4.continuation, prompt0 = t4.prompt, t5 = $async$self.runController;
                        case 6:
                            // for condition
                            // trivial condition
                            t6 = J.get$isTTY$x(self.process.stdin);
                            if (t6 == null ? false : t6) J.write$1$x(self.process.stdout, t3.prompt);
                            t6 = lineQueue;
                            t6.toString;
                            t7 = t6.$ti;
                            t8 = new A._Future($.Zone__current, t7._eval$1("_Future<1>"));
                            t6._addRequest$1(new A._NextRequest(new A._AsyncCompleter(t8, t7._eval$1("_AsyncCompleter<1>")), t7._eval$1("_NextRequest<1>")));
                            $async$goto = 8;
                            return A._asyncAwait(t8, $async$call$0);
                        case 8:
                            // returning from await.
                            line = $async$result;
                            t6 = J.get$isTTY$x(self.process.stdin);
                            if (!(t6 == null ? false : t6)) {
                                line0 = t3.prompt + A.S(line);
                                toZone = $._printToZone;
                                if (toZone == null) A.printString(line0);
                                else toZone.call$1(line0);
                            }
                            statement = B.JSString_methods.$add(t3.statement, line);
                            t3.statement = statement;
                            if (t4.validator.call$1(statement)) {
                                t6 = t5.__late_helper$_value;
                                if (t6 === t5) A.throwExpression(A.LateError$localNI(""));
                                J.add$1$ax(t6, t3.statement);
                                t3.statement = "";
                                t3.prompt = prompt0;
                                t2.setPrompt$1(t1, prompt0);
                            } else {
                                t3.statement += "\n";
                                t3.prompt = $prompt;
                                t2.setPrompt$1(t1, $prompt);
                            }
                            // goto for condition
                            $async$goto = 6;
                            break;
                        case 7:
                            // after for
                            $async$handler = 1;
                            // goto after finally
                            $async$goto = 5;
                            break;
                        case 3:
                            // catch
                            $async$handler = 2;
                            $async$exception = $async$errorStack.pop();
                            error = A.unwrapException($async$exception);
                            stackTrace = A.getTraceFromException($async$exception);
                            t1 = $async$self.runController;
                            t1._readLocal$0().addError$2(error, stackTrace);
                            t2 = $async$self.$this.exit$0(0);
                            t2 = A._Future$value(t2, type$.void);
                            $async$goto = 9;
                            return A._asyncAwait(t2, $async$call$0);
                        case 9:
                            // returning from await.
                            J.close$0$x(t1._readLocal$0());
                            // goto after finally
                            $async$goto = 5;
                            break;
                        case 2:
                            // uncaught
                            // goto rethrow
                            $async$goto = 1;
                            break;
                        case 5:
                            // after finally
                            // implicit return
                            return A._asyncReturn(null, $async$completer);
                        case 1:
                            // rethrow
                            return A._asyncRethrow($async$errorStack.at(-1), $async$completer);
                    }
                });
                return A._asyncStartSync($async$call$0, $async$completer);
            },
            $signature: 32
        };
        A.ReplAdapter_runAsync__closure.prototype = {
            call$1: function(value) {
                return this.lineController.add$1(0, A._asString(value));
            },
            $signature: 71
        };
        A.Stdin.prototype = {};
        A.Stdout.prototype = {};
        A.ReadlineModule.prototype = {};
        A.ReadlineOptions.prototype = {};
        A.ReadlineInterface.prototype = {};
        A.EmptyUnmodifiableSet.prototype = {
            get$iterator: function(_) {
                return B.C_EmptyIterator;
            },
            get$length: function(_) {
                return 0;
            },
            contains$1: function(_, element) {
                return false;
            },
            toSet$0: function(_) {
                return A.LinkedHashSet_LinkedHashSet$_empty(this.$ti._precomputed1);
            },
            $isEfficientLengthIterable: 1,
            $isSet: 1
        };
        A._EmptyUnmodifiableSet_IterableBase_UnmodifiableSetMixin.prototype = {};
        A.DefaultEquality.prototype = {};
        A.IterableEquality.prototype = {
            equals$2: function(_, elements1, elements2) {
                var it1, it2, hasNext;
                if (elements1 === elements2) return true;
                it1 = J.get$iterator$ax(elements1);
                it2 = J.get$iterator$ax(elements2);
                for(;;){
                    hasNext = it1.moveNext$0();
                    if (hasNext !== it2.moveNext$0()) return false;
                    if (!hasNext) return true;
                    if (!J.$eq$(it1.get$current(it1), it2.get$current(it2))) return false;
                }
            },
            hash$1: function(elements) {
                var t1, hash, _i;
                for(t1 = elements.length, hash = 0, _i = 0; _i < elements.length; elements.length === t1 || (0, A.throwConcurrentModificationError)(elements), ++_i){
                    hash = hash + J.get$hashCode$(elements[_i]) & 2147483647;
                    hash = hash + (hash << 10 >>> 0) & 2147483647;
                    hash ^= hash >>> 6;
                }
                hash = hash + (hash << 3 >>> 0) & 2147483647;
                hash ^= hash >>> 11;
                return hash + (hash << 15 >>> 0) & 2147483647;
            }
        };
        A.ListEquality.prototype = {
            equals$2: function(_, list1, list2) {
                var t1, $length, t2, i;
                if (list1 == null ? list2 == null : list1 === list2) return true;
                if (list1 == null || list2 == null) return false;
                t1 = J.getInterceptor$asx(list1);
                $length = t1.get$length(list1);
                t2 = J.getInterceptor$asx(list2);
                if ($length !== t2.get$length(list2)) return false;
                for(i = 0; i < $length; ++i)if (!J.$eq$(t1.$index(list1, i), t2.$index(list2, i))) return false;
                return true;
            },
            hash$1: function(list) {
                var hash, i;
                for(hash = 0, i = 0; i < list.length; ++i){
                    hash = hash + J.get$hashCode$(list[i]) & 2147483647;
                    hash = hash + (hash << 10 >>> 0) & 2147483647;
                    hash ^= hash >>> 6;
                }
                hash = hash + (hash << 3 >>> 0) & 2147483647;
                hash ^= hash >>> 11;
                return hash + (hash << 15 >>> 0) & 2147483647;
            }
        };
        A._MapEntry.prototype = {
            get$hashCode: function(_) {
                return 3 * J.get$hashCode$(this.key) + 7 * J.get$hashCode$(this.value) & 2147483647;
            },
            $eq: function(_, other) {
                if (other == null) return false;
                return other instanceof A._MapEntry && J.$eq$(this.key, other.key) && J.$eq$(this.value, other.value);
            }
        };
        A.MapEquality.prototype = {
            equals$2: function(_, map1, map2) {
                var equalElementCounts, t1, key, entry, count;
                if (map1 === map2) return true;
                if (map1.get$length(map1) !== map2.get$length(map2)) return false;
                equalElementCounts = A.HashMap_HashMap(type$._MapEntry, type$.int);
                for(t1 = map1.get$keys(map1), t1 = t1.get$iterator(t1); t1.moveNext$0();){
                    key = t1.get$current(t1);
                    entry = new A._MapEntry(this, key, map1.$index(0, key));
                    count = equalElementCounts.$index(0, entry);
                    equalElementCounts.$indexSet(0, entry, (count == null ? 0 : count) + 1);
                }
                for(t1 = map2.get$keys(map2), t1 = t1.get$iterator(t1); t1.moveNext$0();){
                    key = t1.get$current(t1);
                    entry = new A._MapEntry(this, key, map2.$index(0, key));
                    count = equalElementCounts.$index(0, entry);
                    if (count == null || count === 0) return false;
                    equalElementCounts.$indexSet(0, entry, count - 1);
                }
                return true;
            },
            hash$1: function(map) {
                var t1, t2, hash, key, keyHash, t3;
                for(t1 = map.get$keys(map), t1 = t1.get$iterator(t1), t2 = this.$ti._rest[1], hash = 0; t1.moveNext$0();){
                    key = t1.get$current(t1);
                    keyHash = J.get$hashCode$(key);
                    t3 = map.$index(0, key);
                    hash = hash + 3 * keyHash + 7 * J.get$hashCode$(t3 == null ? t2._as(t3) : t3) & 2147483647;
                }
                hash = hash + (hash << 3 >>> 0) & 2147483647;
                hash ^= hash >>> 11;
                return hash + (hash << 15 >>> 0) & 2147483647;
            }
        };
        A.QueueList.prototype = {
            add$1: function(_, element) {
                this._queue_list$_add$1(element);
            },
            addAll$1: function(_, iterable) {
                var addCount, $length, t1, endSpace, t2, preSpace, _this = this;
                if (type$.List_dynamic._is(iterable)) {
                    addCount = J.get$length$asx(iterable);
                    $length = _this.get$length(0);
                    t1 = $length + addCount;
                    if (t1 >= J.get$length$asx(_this._queue_list$_table)) {
                        _this._preGrow$1(t1);
                        J.setRange$4$ax(_this._queue_list$_table, $length, t1, iterable, 0);
                        _this.set$_queue_list$_tail(_this.get$_queue_list$_tail() + addCount);
                    } else {
                        endSpace = J.get$length$asx(_this._queue_list$_table) - _this.get$_queue_list$_tail();
                        t1 = _this._queue_list$_table;
                        t2 = J.getInterceptor$ax(t1);
                        if (addCount < endSpace) {
                            t2.setRange$4(t1, _this.get$_queue_list$_tail(), _this.get$_queue_list$_tail() + addCount, iterable, 0);
                            _this.set$_queue_list$_tail(_this.get$_queue_list$_tail() + addCount);
                        } else {
                            preSpace = addCount - endSpace;
                            t2.setRange$4(t1, _this.get$_queue_list$_tail(), _this.get$_queue_list$_tail() + endSpace, iterable, 0);
                            J.setRange$4$ax(_this._queue_list$_table, 0, preSpace, iterable, endSpace);
                            _this.set$_queue_list$_tail(preSpace);
                        }
                    }
                } else for(t1 = J.get$iterator$ax(iterable); t1.moveNext$0();)_this._queue_list$_add$1(t1.get$current(t1));
            },
            cast$1$0: function(_, $T) {
                return new A._CastQueueList(this, J.cast$1$0$ax(this._queue_list$_table, $T), -1, -1, A._instanceType(this)._eval$1("@<QueueList.E>")._bind$1($T)._eval$1("_CastQueueList<1,2>"));
            },
            toString$0: function(_) {
                return A.Iterable_iterableToFullString(this, "{", "}");
            },
            addFirst$1: function(element) {
                var _this = this;
                _this.set$_queue_list$_head((_this.get$_queue_list$_head() - 1 & J.get$length$asx(_this._queue_list$_table) - 1) >>> 0);
                J.$indexSet$ax(_this._queue_list$_table, _this.get$_queue_list$_head(), element);
                if (_this.get$_queue_list$_head() === _this.get$_queue_list$_tail()) _this._queue_list$_grow$0();
            },
            removeFirst$0: function() {
                var result, _this = this;
                if (_this.get$_queue_list$_head() === _this.get$_queue_list$_tail()) throw A.wrapException(A.StateError$("No element"));
                result = J.$index$asx(_this._queue_list$_table, _this.get$_queue_list$_head());
                if (result == null) result = A._instanceType(_this)._eval$1("QueueList.E")._as(result);
                J.$indexSet$ax(_this._queue_list$_table, _this.get$_queue_list$_head(), null);
                _this.set$_queue_list$_head((_this.get$_queue_list$_head() + 1 & J.get$length$asx(_this._queue_list$_table) - 1) >>> 0);
                return result;
            },
            removeLast$0: function(_) {
                var result, _this = this;
                if (_this.get$_queue_list$_head() === _this.get$_queue_list$_tail()) throw A.wrapException(A.StateError$("No element"));
                _this.set$_queue_list$_tail((_this.get$_queue_list$_tail() - 1 & J.get$length$asx(_this._queue_list$_table) - 1) >>> 0);
                result = J.$index$asx(_this._queue_list$_table, _this.get$_queue_list$_tail());
                if (result == null) result = A._instanceType(_this)._eval$1("QueueList.E")._as(result);
                J.$indexSet$ax(_this._queue_list$_table, _this.get$_queue_list$_tail(), null);
                return result;
            },
            get$length: function(_) {
                return (this.get$_queue_list$_tail() - this.get$_queue_list$_head() & J.get$length$asx(this._queue_list$_table) - 1) >>> 0;
            },
            set$length: function(_, value) {
                var delta, newTail, t1, t2, _this = this;
                if (value < 0) throw A.wrapException(A.RangeError$("Length " + value + " may not be negative."));
                if (value > _this.get$length(0) && !A._instanceType(_this)._eval$1("QueueList.E")._is(null)) throw A.wrapException(A.UnsupportedError$("The length can only be increased when the element type is nullable, but the current element type is `" + A.createRuntimeType(A._instanceType(_this)._eval$1("QueueList.E")).toString$0(0) + "`."));
                delta = value - _this.get$length(0);
                if (delta >= 0) {
                    if (J.get$length$asx(_this._queue_list$_table) <= value) _this._preGrow$1(value);
                    _this.set$_queue_list$_tail((_this.get$_queue_list$_tail() + delta & J.get$length$asx(_this._queue_list$_table) - 1) >>> 0);
                    return;
                }
                newTail = _this.get$_queue_list$_tail() + delta;
                t1 = _this._queue_list$_table;
                if (newTail >= 0) J.fillRange$3$ax(t1, newTail, _this.get$_queue_list$_tail(), null);
                else {
                    newTail += J.get$length$asx(t1);
                    J.fillRange$3$ax(_this._queue_list$_table, 0, _this.get$_queue_list$_tail(), null);
                    t1 = _this._queue_list$_table;
                    t2 = J.getInterceptor$asx(t1);
                    t2.fillRange$3(t1, newTail, t2.get$length(t1), null);
                }
                _this.set$_queue_list$_tail(newTail);
            },
            $index: function(_, index) {
                var t1, _this = this;
                if (index < 0 || index >= _this.get$length(0)) throw A.wrapException(A.RangeError$("Index " + index + " must be in the range [0.." + _this.get$length(0) + ")."));
                t1 = J.$index$asx(_this._queue_list$_table, (_this.get$_queue_list$_head() + index & J.get$length$asx(_this._queue_list$_table) - 1) >>> 0);
                return t1 == null ? A._instanceType(_this)._eval$1("QueueList.E")._as(t1) : t1;
            },
            $indexSet: function(_, index, value) {
                var _this = this;
                if (index < 0 || index >= _this.get$length(0)) throw A.wrapException(A.RangeError$("Index " + index + " must be in the range [0.." + _this.get$length(0) + ")."));
                J.$indexSet$ax(_this._queue_list$_table, (_this.get$_queue_list$_head() + index & J.get$length$asx(_this._queue_list$_table) - 1) >>> 0, value);
            },
            _queue_list$_add$1: function(element) {
                var _this = this;
                J.$indexSet$ax(_this._queue_list$_table, _this.get$_queue_list$_tail(), element);
                _this.set$_queue_list$_tail((_this.get$_queue_list$_tail() + 1 & J.get$length$asx(_this._queue_list$_table) - 1) >>> 0);
                if (_this.get$_queue_list$_head() === _this.get$_queue_list$_tail()) _this._queue_list$_grow$0();
            },
            _queue_list$_grow$0: function() {
                var _this = this, newTable = A.List_List$filled(J.get$length$asx(_this._queue_list$_table) * 2, null, false, A._instanceType(_this)._eval$1("QueueList.E?")), split = J.get$length$asx(_this._queue_list$_table) - _this.get$_queue_list$_head();
                B.JSArray_methods.setRange$4(newTable, 0, split, _this._queue_list$_table, _this.get$_queue_list$_head());
                B.JSArray_methods.setRange$4(newTable, split, split + _this.get$_queue_list$_head(), _this._queue_list$_table, 0);
                _this.set$_queue_list$_head(0);
                _this.set$_queue_list$_tail(J.get$length$asx(_this._queue_list$_table));
                _this._queue_list$_table = newTable;
            },
            _writeToList$1: function(target) {
                var $length, firstPartSize, _this = this;
                if (_this.get$_queue_list$_head() <= _this.get$_queue_list$_tail()) {
                    $length = _this.get$_queue_list$_tail() - _this.get$_queue_list$_head();
                    B.JSArray_methods.setRange$4(target, 0, $length, _this._queue_list$_table, _this.get$_queue_list$_head());
                    return $length;
                } else {
                    firstPartSize = J.get$length$asx(_this._queue_list$_table) - _this.get$_queue_list$_head();
                    B.JSArray_methods.setRange$4(target, 0, firstPartSize, _this._queue_list$_table, _this.get$_queue_list$_head());
                    B.JSArray_methods.setRange$4(target, firstPartSize, firstPartSize + _this.get$_queue_list$_tail(), _this._queue_list$_table, 0);
                    return _this.get$_queue_list$_tail() + firstPartSize;
                }
            },
            _preGrow$1: function(newElementCount) {
                var _this = this, newTable = A.List_List$filled(A.QueueList__nextPowerOf2(newElementCount + B.JSInt_methods._shrOtherPositive$1(newElementCount, 1)), null, false, A._instanceType(_this)._eval$1("QueueList.E?"));
                _this.set$_queue_list$_tail(_this._writeToList$1(newTable));
                _this._queue_list$_table = newTable;
                _this.set$_queue_list$_head(0);
            },
            $isEfficientLengthIterable: 1,
            $isQueue: 1,
            $isIterable: 1,
            $isList: 1,
            get$_queue_list$_head: function() {
                return this._queue_list$_head;
            },
            get$_queue_list$_tail: function() {
                return this._queue_list$_tail;
            },
            set$_queue_list$_head: function(val) {
                return this._queue_list$_head = val;
            },
            set$_queue_list$_tail: function(val) {
                return this._queue_list$_tail = val;
            }
        };
        A._CastQueueList.prototype = {
            get$_queue_list$_head: function() {
                return this._queue_list$_delegate.get$_queue_list$_head();
            },
            set$_queue_list$_head: function(value) {
                this._queue_list$_delegate.set$_queue_list$_head(value);
            },
            get$_queue_list$_tail: function() {
                return this._queue_list$_delegate.get$_queue_list$_tail();
            },
            set$_queue_list$_tail: function(value) {
                this._queue_list$_delegate.set$_queue_list$_tail(value);
            }
        };
        A._QueueList_Object_ListMixin.prototype = {};
        A.UnionSet.prototype = {
            get$length: function(_) {
                var t1 = this.get$_union_set$_iterable().get$length(0);
                return t1;
            },
            get$iterator: function(_) {
                var t1 = this.get$_union_set$_iterable();
                return t1.get$iterator(t1);
            },
            get$_union_set$_iterable: function() {
                var t1 = this._sets, t2 = this.$ti._precomputed1, t3 = A._instanceType(t1)._eval$1("@<1>")._bind$1(t2)._eval$1("ExpandIterable<1,2>");
                t2 = A.LinkedHashSet_LinkedHashSet$_empty(t2);
                return new A.WhereIterable(new A.ExpandIterable(t1, new A.UnionSet__iterable_closure(this), t3), t2.get$add(t2), t3._eval$1("WhereIterable<Iterable.E>"));
            },
            contains$1: function(_, element) {
                return this._sets.any$1(0, new A.UnionSet_contains_closure(this, element));
            },
            toSet$0: function(_) {
                var t2, t3, t4, t1 = A.LinkedHashSet_LinkedHashSet$_empty(this.$ti._precomputed1);
                for(t2 = this._sets, t2 = A._LinkedHashSetIterator$(t2, t2._collection$_modifications, A._instanceType(t2)._precomputed1), t3 = t2.$ti._precomputed1; t2.moveNext$0();){
                    t4 = t2._collection$_current;
                    t1.addAll$1(0, t4 == null ? t3._as(t4) : t4);
                }
                return t1;
            }
        };
        A.UnionSet__iterable_closure.prototype = {
            call$1: function(set) {
                return set;
            },
            $signature: function() {
                return this.$this.$ti._eval$1("Set<1>(Set<1>)");
            }
        };
        A.UnionSet_contains_closure.prototype = {
            call$1: function(set) {
                return set.contains$1(0, this.element);
            },
            $signature: function() {
                return this.$this.$ti._eval$1("bool(Set<1>)");
            }
        };
        A._UnionSet_SetBase_UnmodifiableSetMixin.prototype = {};
        A.UnmodifiableSetView0.prototype = {};
        A.UnmodifiableSetMixin.prototype = {
            add$1: function(_, value) {
                return A.UnmodifiableSetMixin__throw();
            },
            addAll$1: function(_, elements) {
                return A.UnmodifiableSetMixin__throw();
            },
            remove$1: function(_, value) {
                return A.UnmodifiableSetMixin__throw();
            }
        };
        A._UnmodifiableSetView_DelegatingSet_UnmodifiableSetMixin.prototype = {};
        A._DelegatingIterableBase.prototype = {
            any$1: function(_, test) {
                var t1 = this.get$_base();
                return t1.any$1(t1, test);
            },
            contains$1: function(_, element) {
                var t1 = this.get$_base();
                return t1.contains$1(t1, element);
            },
            elementAt$1: function(_, index) {
                var t1 = this.get$_base();
                return t1.elementAt$1(t1, index);
            },
            every$1: function(_, test) {
                var t1 = this.get$_base();
                return t1.every$1(t1, test);
            },
            get$first: function(_) {
                var t1 = this.get$_base();
                return t1.get$first(t1);
            },
            get$isEmpty: function(_) {
                var t1 = this.get$_base();
                return t1.get$isEmpty(t1);
            },
            get$isNotEmpty: function(_) {
                var t1 = this.get$_base();
                return t1.get$isNotEmpty(t1);
            },
            get$iterator: function(_) {
                var t1 = this.get$_base();
                return t1.get$iterator(t1);
            },
            get$last: function(_) {
                var t1 = this.get$_base();
                return t1.get$last(t1);
            },
            get$length: function(_) {
                var t1 = this.get$_base();
                return t1.get$length(t1);
            },
            map$1$1: function(_, f, $T) {
                var t1 = this.get$_base();
                return t1.map$1$1(t1, f, $T);
            },
            get$single: function(_) {
                var t1 = this.get$_base();
                return t1.get$single(t1);
            },
            skip$1: function(_, n) {
                var t1 = this.get$_base();
                return t1.skip$1(t1, n);
            },
            take$1: function(_, n) {
                var t1 = this.get$_base();
                return t1.take$1(t1, n);
            },
            toList$1$growable: function(_, growable) {
                var t1 = this.get$_base();
                return t1.toList$1$growable(t1, true);
            },
            toList$0: function(_) {
                return this.toList$1$growable(0, true);
            },
            toSet$0: function(_) {
                var t1 = this.get$_base();
                return t1.toSet$0(t1);
            },
            where$1: function(_, test) {
                var t1 = this.get$_base();
                return t1.where$1(t1, test);
            },
            toString$0: function(_) {
                var t1 = this.get$_base();
                return t1.toString$0(t1);
            },
            $isIterable: 1
        };
        A.DelegatingSet.prototype = {
            add$1: function(_, value) {
                return this._base.add$1(0, value);
            },
            addAll$1: function(_, elements) {
                this._base.addAll$1(0, elements);
            },
            toSet$0: function(_) {
                return new A.DelegatingSet(this._base.toSet$0(0), A._instanceType(this)._eval$1("DelegatingSet<1>"));
            },
            $isEfficientLengthIterable: 1,
            $isSet: 1,
            get$_base: function() {
                return this._base;
            }
        };
        A.MapKeySet.prototype = {
            get$_base: function() {
                var t1 = this._baseMap;
                return t1.get$keys(t1);
            },
            contains$1: function(_, element) {
                return this._baseMap.containsKey$1(element);
            },
            get$isEmpty: function(_) {
                var t1 = this._baseMap;
                return t1.get$isEmpty(t1);
            },
            get$isNotEmpty: function(_) {
                var t1 = this._baseMap;
                return t1.get$isNotEmpty(t1);
            },
            get$length: function(_) {
                var t1 = this._baseMap;
                return t1.get$length(t1);
            },
            toString$0: function(_) {
                return A.Iterable_iterableToFullString(this, "{", "}");
            },
            difference$1: function(other) {
                var t1 = this.get$_base();
                return t1.where$1(t1, new A.MapKeySet_difference_closure(this, other)).toSet$0(0);
            },
            intersection$1: function(other) {
                var t1 = this.get$_base();
                return t1.where$1(t1, other.get$contains(other)).toSet$0(0);
            },
            $isEfficientLengthIterable: 1,
            $isSet: 1
        };
        A.MapKeySet_difference_closure.prototype = {
            call$1: function(element) {
                return !this.other.contains$1(0, element);
            },
            $signature: function() {
                return this.$this.$ti._eval$1("bool(1)");
            }
        };
        A._MapKeySet__DelegatingIterableBase_UnmodifiableSetMixin.prototype = {};
        A.BufferModule.prototype = {};
        A.BufferConstants.prototype = {};
        A.Buffer.prototype = {};
        A.ConsoleModule.prototype = {};
        A.Console.prototype = {};
        A.EventEmitter.prototype = {};
        A.FS.prototype = {};
        A.FSConstants.prototype = {};
        A.Realpath.prototype = {};
        A.RealpathSync.prototype = {};
        A.FSWatcher.prototype = {};
        A.ReadStream.prototype = {};
        A.ReadStreamOptions.prototype = {};
        A.WriteStream.prototype = {};
        A.WriteStreamOptions.prototype = {};
        A.FileOptions.prototype = {};
        A.StatOptions.prototype = {};
        A.MkdirOptions.prototype = {};
        A.RmdirOptions.prototype = {};
        A.WatchOptions.prototype = {};
        A.WatchFileOptions.prototype = {};
        A.Stats.prototype = {};
        A.Promise.prototype = {};
        A.Date.prototype = {};
        A.JsError.prototype = {};
        A.Atomics.prototype = {};
        A.Modules.prototype = {};
        A.Module.prototype = {};
        A.Net.prototype = {};
        A.Socket.prototype = {};
        A.NetAddress.prototype = {};
        A.NetServer.prototype = {};
        A.NodeJsError.prototype = {};
        A.JsAssertionError.prototype = {};
        A.JsRangeError.prototype = {};
        A.JsReferenceError.prototype = {};
        A.JsSyntaxError.prototype = {};
        A.JsTypeError.prototype = {};
        A.JsSystemError.prototype = {};
        A.Process.prototype = {};
        A.CPUUsage.prototype = {};
        A.Release.prototype = {};
        A.StreamModule.prototype = {};
        A.Readable.prototype = {};
        A.Writable.prototype = {};
        A.Duplex.prototype = {};
        A.Transform.prototype = {};
        A.WritableOptions.prototype = {};
        A.ReadableOptions.prototype = {};
        A.Immediate.prototype = {};
        A.Timeout.prototype = {};
        A.TTY.prototype = {};
        A.TTYReadStream.prototype = {};
        A.TTYWriteStream.prototype = {};
        A.Util.prototype = {};
        A.promiseToFuture_closure1.prototype = {
            call$1: function(value) {
                this.completer.complete$1(value);
            },
            $signature: 62
        };
        A.promiseToFuture_closure2.prototype = {
            call$1: function(error) {
                this.completer.completeError$1(error);
            },
            $signature: 62
        };
        A.futureToPromise_closure.prototype = {
            call$2: function(resolve, reject) {
                this.future.then$1$2$onError(0, new A.futureToPromise__closure(resolve, this.T), reject, type$.dynamic);
            },
            $signature: 395
        };
        A.futureToPromise__closure.prototype = {
            call$1: function(result) {
                return this.resolve.call$1(result);
            },
            $signature: function() {
                return this.T._eval$1("@(0)");
            }
        };
        A.Context.prototype = {
            absolute$15: function(part1, part2, part3, part4, part5, part6, part7, part8, part9, part10, part11, part12, part13, part14, part15) {
                var t1;
                A._validateArgList("absolute", A._setArrayType([
                    part1,
                    part2,
                    part3,
                    part4,
                    part5,
                    part6,
                    part7,
                    part8,
                    part9,
                    part10,
                    part11,
                    part12,
                    part13,
                    part14,
                    part15
                ], type$.JSArray_nullable_String));
                if (part2 == null) {
                    t1 = this.style;
                    t1 = t1.rootLength$1(part1) > 0 && !t1.isRootRelative$1(part1);
                } else t1 = false;
                if (t1) return part1;
                t1 = this._context$_current;
                return this.join$16(0, t1 == null ? A.current() : t1, part1, part2, part3, part4, part5, part6, part7, part8, part9, part10, part11, part12, part13, part14, part15);
            },
            absolute$1: function(part1) {
                var _null = null;
                return this.absolute$15(part1, _null, _null, _null, _null, _null, _null, _null, _null, _null, _null, _null, _null, _null, _null);
            },
            dirname$1: function(path) {
                var t1, t2, parsed = A.ParsedPath_ParsedPath$parse(path, this.style);
                parsed.removeTrailingSeparators$0();
                t1 = parsed.parts;
                t2 = t1.length;
                if (t2 === 0) {
                    t1 = parsed.root;
                    return t1 == null ? "." : t1;
                }
                if (t2 === 1) {
                    t1 = parsed.root;
                    return t1 == null ? "." : t1;
                }
                B.JSArray_methods.removeLast$0(t1);
                parsed.separators.pop();
                parsed.removeTrailingSeparators$0();
                return parsed.toString$0(0);
            },
            join$16: function(_, part1, part2, part3, part4, part5, part6, part7, part8, part9, part10, part11, part12, part13, part14, part15, part16) {
                var parts = A._setArrayType([
                    part1,
                    part2,
                    part3,
                    part4,
                    part5,
                    part6,
                    part7,
                    part8,
                    part9,
                    part10,
                    part11,
                    part12,
                    part13,
                    part14,
                    part15,
                    part16
                ], type$.JSArray_nullable_String);
                A._validateArgList("join", parts);
                return this.joinAll$1(new A.WhereTypeIterable(parts, type$.WhereTypeIterable_String));
            },
            join$2: function(_, part1, part2) {
                var _null = null;
                return this.join$16(0, part1, part2, _null, _null, _null, _null, _null, _null, _null, _null, _null, _null, _null, _null, _null, _null);
            },
            joinAll$1: function(parts) {
                var t1, t2, t3, needsSeparator, isAbsoluteAndNotRootRelative, t4, t5, parsed, path;
                for(t1 = J.where$1$ax(parts, new A.Context_joinAll_closure()), t2 = J.get$iterator$ax(t1.__internal$_iterable), t1 = new A.WhereIterator(t2, t1._f), t3 = this.style, needsSeparator = false, isAbsoluteAndNotRootRelative = false, t4 = ""; t1.moveNext$0();){
                    t5 = t2.get$current(t2);
                    if (t3.isRootRelative$1(t5) && isAbsoluteAndNotRootRelative) {
                        parsed = A.ParsedPath_ParsedPath$parse(t5, t3);
                        path = t4.charCodeAt(0) == 0 ? t4 : t4;
                        t4 = B.JSString_methods.substring$2(path, 0, t3.rootLength$2$withDrive(path, true));
                        parsed.root = t4;
                        if (t3.needsSeparator$1(t4)) parsed.separators[0] = t3.get$separator(t3);
                        t4 = parsed.toString$0(0);
                    } else if (t3.rootLength$1(t5) > 0) {
                        isAbsoluteAndNotRootRelative = !t3.isRootRelative$1(t5);
                        t4 = t5;
                    } else {
                        if (!(t5.length !== 0 && t3.containsSeparator$1(t5[0]))) {
                            if (needsSeparator) t4 += t3.get$separator(t3);
                        }
                        t4 += t5;
                    }
                    needsSeparator = t3.needsSeparator$1(t5);
                }
                return t4.charCodeAt(0) == 0 ? t4 : t4;
            },
            split$1: function(_, path) {
                var parsed = A.ParsedPath_ParsedPath$parse(path, this.style), t1 = parsed.parts, t2 = A._arrayInstanceType(t1)._eval$1("WhereIterable<1>");
                t1 = A.List_List$_of(new A.WhereIterable(t1, new A.Context_split_closure(), t2), t2._eval$1("Iterable.E"));
                parsed.parts = t1;
                t2 = parsed.root;
                if (t2 != null) B.JSArray_methods.insert$2(t1, 0, t2);
                return parsed.parts;
            },
            canonicalize$1: function(_, path) {
                var t1, parsed;
                path = this.absolute$1(path);
                t1 = this.style;
                if (t1 !== $.$get$Style_windows() && !this._needsNormalization$1(path)) return path;
                parsed = A.ParsedPath_ParsedPath$parse(path, t1);
                parsed.normalize$1$canonicalize(true);
                return parsed.toString$0(0);
            },
            normalize$1: function(path) {
                var parsed;
                if (!this._needsNormalization$1(path)) return path;
                parsed = A.ParsedPath_ParsedPath$parse(path, this.style);
                parsed.normalize$0();
                return parsed.toString$0(0);
            },
            _needsNormalization$1: function(path) {
                var i, start, previous, t2, previousPrevious, codeUnit, t3, t1 = this.style, root = t1.rootLength$1(path);
                if (root !== 0) {
                    if (t1 === $.$get$Style_windows()) {
                        for(i = 0; i < root; ++i)if (path.charCodeAt(i) === 47) return true;
                    }
                    start = root;
                    previous = 47;
                } else {
                    start = 0;
                    previous = null;
                }
                for(t2 = path.length, i = start, previousPrevious = null; i < t2; ++i, previousPrevious = previous, previous = codeUnit){
                    codeUnit = path.charCodeAt(i);
                    if (t1.isSeparator$1(codeUnit)) {
                        if (t1 === $.$get$Style_windows() && codeUnit === 47) return true;
                        if (previous != null && t1.isSeparator$1(previous)) return true;
                        if (previous === 46) t3 = previousPrevious == null || previousPrevious === 46 || t1.isSeparator$1(previousPrevious);
                        else t3 = false;
                        if (t3) return true;
                    }
                }
                if (previous == null) return true;
                if (t1.isSeparator$1(previous)) return true;
                if (previous === 46) t1 = previousPrevious == null || t1.isSeparator$1(previousPrevious) || previousPrevious === 46;
                else t1 = false;
                if (t1) return true;
                return false;
            },
            relative$2$from: function(path, from) {
                var fromParsed, pathParsed, t2, t3, _this = this, _s26_ = 'Unable to find a path to "', t1 = from == null;
                if (t1 && _this.style.rootLength$1(path) <= 0) return _this.normalize$1(path);
                if (t1) {
                    t1 = _this._context$_current;
                    from = t1 == null ? A.current() : t1;
                } else from = _this.absolute$1(from);
                t1 = _this.style;
                if (t1.rootLength$1(from) <= 0 && t1.rootLength$1(path) > 0) return _this.normalize$1(path);
                if (t1.rootLength$1(path) <= 0 || t1.isRootRelative$1(path)) path = _this.absolute$1(path);
                if (t1.rootLength$1(path) <= 0 && t1.rootLength$1(from) > 0) throw A.wrapException(A.PathException$(_s26_ + path + '" from "' + from + '".'));
                fromParsed = A.ParsedPath_ParsedPath$parse(from, t1);
                fromParsed.normalize$0();
                pathParsed = A.ParsedPath_ParsedPath$parse(path, t1);
                pathParsed.normalize$0();
                t2 = fromParsed.parts;
                if (t2.length !== 0 && t2[0] === ".") return pathParsed.toString$0(0);
                t2 = fromParsed.root;
                t3 = pathParsed.root;
                if (t2 != t3) t2 = t2 == null || t3 == null || !t1.pathsEqual$2(t2, t3);
                else t2 = false;
                if (t2) return pathParsed.toString$0(0);
                for(;;){
                    t2 = fromParsed.parts;
                    if (t2.length !== 0) {
                        t3 = pathParsed.parts;
                        t2 = t3.length !== 0 && t1.pathsEqual$2(t2[0], t3[0]);
                    } else t2 = false;
                    if (!t2) break;
                    B.JSArray_methods.removeAt$1(fromParsed.parts, 0);
                    B.JSArray_methods.removeAt$1(fromParsed.separators, 1);
                    B.JSArray_methods.removeAt$1(pathParsed.parts, 0);
                    B.JSArray_methods.removeAt$1(pathParsed.separators, 1);
                }
                t2 = fromParsed.parts;
                t3 = t2.length;
                if (t3 !== 0 && t2[0] === "..") throw A.wrapException(A.PathException$(_s26_ + path + '" from "' + from + '".'));
                t2 = type$.String;
                B.JSArray_methods.insertAll$2(pathParsed.parts, 0, A.List_List$filled(t3, "..", false, t2));
                t3 = pathParsed.separators;
                t3[0] = "";
                B.JSArray_methods.insertAll$2(t3, 1, A.List_List$filled(fromParsed.parts.length, t1.get$separator(t1), false, t2));
                t1 = pathParsed.parts;
                t2 = t1.length;
                if (t2 === 0) return ".";
                if (t2 > 1 && B.JSArray_methods.get$last(t1) === ".") {
                    B.JSArray_methods.removeLast$0(pathParsed.parts);
                    t1 = pathParsed.separators;
                    t1.pop();
                    t1.pop();
                    t1.push("");
                }
                pathParsed.root = "";
                pathParsed.removeTrailingSeparators$0();
                return pathParsed.toString$0(0);
            },
            relative$1: function(path) {
                return this.relative$2$from(path, null);
            },
            _isWithinOrEquals$2: function($parent, child) {
                var relative, t1, parentIsAbsolute, childIsAbsolute, childIsRootRelative, parentIsRootRelative, result, _$exception, _this = this;
                $parent;
                child;
                t1 = _this.style;
                parentIsAbsolute = t1.rootLength$1($parent) > 0;
                childIsAbsolute = t1.rootLength$1(child) > 0;
                if (parentIsAbsolute && !childIsAbsolute) {
                    child = _this.absolute$1(child);
                    if (t1.isRootRelative$1($parent)) $parent = _this.absolute$1($parent);
                } else if (childIsAbsolute && !parentIsAbsolute) {
                    $parent = _this.absolute$1($parent);
                    if (t1.isRootRelative$1(child)) child = _this.absolute$1(child);
                } else if (childIsAbsolute && parentIsAbsolute) {
                    childIsRootRelative = t1.isRootRelative$1(child);
                    parentIsRootRelative = t1.isRootRelative$1($parent);
                    if (childIsRootRelative && !parentIsRootRelative) child = _this.absolute$1(child);
                    else if (parentIsRootRelative && !childIsRootRelative) $parent = _this.absolute$1($parent);
                }
                result = _this._isWithinOrEqualsFast$2($parent, child);
                if (result !== B._PathRelation_inconclusive) return result;
                relative = null;
                try {
                    relative = _this.relative$2$from(child, $parent);
                } catch (exception) {
                    if (A.unwrapException(exception) instanceof A.PathException) return B._PathRelation_different;
                    else throw exception;
                }
                if (t1.rootLength$1(relative) > 0) return B._PathRelation_different;
                if (J.$eq$(relative, ".")) return B._PathRelation_equal;
                if (J.$eq$(relative, "..")) return B._PathRelation_different;
                return J.get$length$asx(relative) >= 3 && J.startsWith$1$s(relative, "..") && t1.isSeparator$1(J.codeUnitAt$1$s(relative, 2)) ? B._PathRelation_different : B._PathRelation_within;
            },
            _isWithinOrEqualsFast$2: function($parent, child) {
                var t1, parentRootLength, childRootLength, i, t2, t3, childIndex, parentIndex, lastCodeUnit, lastParentSeparator, parentCodeUnit, childCodeUnit, parentIndex0, direction, _this = this;
                if ($parent === ".") $parent = "";
                t1 = _this.style;
                parentRootLength = t1.rootLength$1($parent);
                childRootLength = t1.rootLength$1(child);
                if (parentRootLength !== childRootLength) return B._PathRelation_different;
                for(i = 0; i < parentRootLength; ++i)if (!t1.codeUnitsEqual$2($parent.charCodeAt(i), child.charCodeAt(i))) return B._PathRelation_different;
                t2 = child.length;
                t3 = $parent.length;
                childIndex = childRootLength;
                parentIndex = parentRootLength;
                lastCodeUnit = 47;
                lastParentSeparator = null;
                for(;;){
                    if (!(parentIndex < t3 && childIndex < t2)) break;
                    c$0: {
                        parentCodeUnit = $parent.charCodeAt(parentIndex);
                        childCodeUnit = child.charCodeAt(childIndex);
                        if (t1.codeUnitsEqual$2(parentCodeUnit, childCodeUnit)) {
                            if (t1.isSeparator$1(parentCodeUnit)) lastParentSeparator = parentIndex;
                            ++parentIndex;
                            ++childIndex;
                            lastCodeUnit = parentCodeUnit;
                            break c$0;
                        }
                        if (t1.isSeparator$1(parentCodeUnit) && t1.isSeparator$1(lastCodeUnit)) {
                            parentIndex0 = parentIndex + 1;
                            lastParentSeparator = parentIndex;
                            parentIndex = parentIndex0;
                            break c$0;
                        } else if (t1.isSeparator$1(childCodeUnit) && t1.isSeparator$1(lastCodeUnit)) {
                            ++childIndex;
                            break c$0;
                        }
                        if (parentCodeUnit === 46 && t1.isSeparator$1(lastCodeUnit)) {
                            ++parentIndex;
                            if (parentIndex === t3) break;
                            parentCodeUnit = $parent.charCodeAt(parentIndex);
                            if (t1.isSeparator$1(parentCodeUnit)) {
                                parentIndex0 = parentIndex + 1;
                                lastParentSeparator = parentIndex;
                                parentIndex = parentIndex0;
                                break c$0;
                            }
                            if (parentCodeUnit === 46) {
                                ++parentIndex;
                                if (parentIndex === t3 || t1.isSeparator$1($parent.charCodeAt(parentIndex))) return B._PathRelation_inconclusive;
                            }
                        }
                        if (childCodeUnit === 46 && t1.isSeparator$1(lastCodeUnit)) {
                            ++childIndex;
                            if (childIndex === t2) break;
                            childCodeUnit = child.charCodeAt(childIndex);
                            if (t1.isSeparator$1(childCodeUnit)) {
                                ++childIndex;
                                break c$0;
                            }
                            if (childCodeUnit === 46) {
                                ++childIndex;
                                if (childIndex === t2 || t1.isSeparator$1(child.charCodeAt(childIndex))) return B._PathRelation_inconclusive;
                            }
                        }
                        if (_this._pathDirection$2(child, childIndex) !== B._PathDirection_Wme) return B._PathRelation_inconclusive;
                        if (_this._pathDirection$2($parent, parentIndex) !== B._PathDirection_Wme) return B._PathRelation_inconclusive;
                        return B._PathRelation_different;
                    }
                }
                if (childIndex === t2) {
                    if (parentIndex === t3 || t1.isSeparator$1($parent.charCodeAt(parentIndex))) lastParentSeparator = parentIndex;
                    else if (lastParentSeparator == null) lastParentSeparator = Math.max(0, parentRootLength - 1);
                    direction = _this._pathDirection$2($parent, lastParentSeparator);
                    if (direction === B._PathDirection_dMN) return B._PathRelation_equal;
                    return direction === B._PathDirection_vgO ? B._PathRelation_inconclusive : B._PathRelation_different;
                }
                direction = _this._pathDirection$2(child, childIndex);
                if (direction === B._PathDirection_dMN) return B._PathRelation_equal;
                if (direction === B._PathDirection_vgO) return B._PathRelation_inconclusive;
                return t1.isSeparator$1(child.charCodeAt(childIndex)) || t1.isSeparator$1(lastCodeUnit) ? B._PathRelation_within : B._PathRelation_different;
            },
            _pathDirection$2: function(path, index) {
                var t1, t2, i, depth, reachedRoot, i0, t3;
                for(t1 = path.length, t2 = this.style, i = index, depth = 0, reachedRoot = false; i < t1;){
                    for(;;){
                        if (!(i < t1 && t2.isSeparator$1(path.charCodeAt(i)))) break;
                        ++i;
                    }
                    if (i === t1) break;
                    i0 = i;
                    for(;;){
                        if (!(i0 < t1 && !t2.isSeparator$1(path.charCodeAt(i0)))) break;
                        ++i0;
                    }
                    t3 = i0 - i;
                    if (!(t3 === 1 && path.charCodeAt(i) === 46)) {
                        if (t3 === 2 && path.charCodeAt(i) === 46 && path.charCodeAt(i + 1) === 46) {
                            --depth;
                            if (depth < 0) break;
                            if (depth === 0) reachedRoot = true;
                        } else ++depth;
                    }
                    if (i0 === t1) break;
                    i = i0 + 1;
                }
                if (depth < 0) return B._PathDirection_vgO;
                if (depth === 0) return B._PathDirection_dMN;
                if (reachedRoot) return B._PathDirection_6kc;
                return B._PathDirection_Wme;
            },
            hash$1: function(path) {
                var result, parsed, t1, _this = this;
                path = _this.absolute$1(path);
                result = _this._hashFast$1(path);
                if (result != null) return result;
                parsed = A.ParsedPath_ParsedPath$parse(path, _this.style);
                parsed.normalize$0();
                t1 = _this._hashFast$1(parsed.toString$0(0));
                t1.toString;
                return t1;
            },
            _hashFast$1: function(path) {
                var t1, t2, hash, beginning, wasSeparator, i, codeUnit, t3, next;
                for(t1 = path.length, t2 = this.style, hash = 4603, beginning = true, wasSeparator = true, i = 0; i < t1; ++i){
                    codeUnit = t2.canonicalizeCodeUnit$1(path.charCodeAt(i));
                    if (t2.isSeparator$1(codeUnit)) {
                        wasSeparator = true;
                        continue;
                    }
                    if (codeUnit === 46 && wasSeparator) {
                        t3 = i + 1;
                        if (t3 === t1) break;
                        next = path.charCodeAt(t3);
                        if (t2.isSeparator$1(next)) continue;
                        t3 = false;
                        if (!beginning) {
                            if (next === 46) {
                                t3 = i + 2;
                                t3 = t3 === t1 || t2.isSeparator$1(path.charCodeAt(t3));
                            }
                        }
                        if (t3) return null;
                    }
                    hash = ((hash & 67108863) * 33 ^ codeUnit) >>> 0;
                    beginning = false;
                    wasSeparator = false;
                }
                return hash;
            },
            withoutExtension$1: function(path) {
                var t1, i, parsed = A.ParsedPath_ParsedPath$parse(path, this.style);
                for(t1 = parsed.parts, i = t1.length - 1; i >= 0; --i)if (t1[i].length !== 0) {
                    t1[i] = parsed._splitExtension$0()[0];
                    break;
                }
                return parsed.toString$0(0);
            },
            toUri$1: function(path) {
                var t2, t1 = this.style;
                if (t1.rootLength$1(path) <= 0) return t1.relativePathToUri$1(path);
                else {
                    t2 = this._context$_current;
                    return t1.absolutePathToUri$1(this.join$2(0, t2 == null ? A.current() : t2, path));
                }
            },
            prettyUri$1: function(uri) {
                var path, rel, _this = this, typedUri = A._parseUri(uri);
                if (typedUri.get$scheme() === "file" && _this.style === $.$get$Style_url()) return typedUri.toString$0(0);
                else if (typedUri.get$scheme() !== "file" && typedUri.get$scheme() !== "" && _this.style !== $.$get$Style_url()) return typedUri.toString$0(0);
                path = _this.normalize$1(_this.style.pathFromUri$1(A._parseUri(typedUri)));
                rel = _this.relative$1(path);
                return _this.split$1(0, rel).length > _this.split$1(0, path).length ? path : rel;
            }
        };
        A.Context_joinAll_closure.prototype = {
            call$1: function(part) {
                return part !== "";
            },
            $signature: 4
        };
        A.Context_split_closure.prototype = {
            call$1: function(part) {
                return part.length !== 0;
            },
            $signature: 4
        };
        A._validateArgList_closure.prototype = {
            call$1: function(arg) {
                return arg == null ? "null" : '"' + arg + '"';
            },
            $signature: 396
        };
        A._PathDirection.prototype = {
            toString$0: function(_) {
                return this.name;
            }
        };
        A._PathRelation.prototype = {
            toString$0: function(_) {
                return this.name;
            }
        };
        A.InternalStyle.prototype = {
            getRoot$1: function(path) {
                var $length = this.rootLength$1(path);
                if ($length > 0) return B.JSString_methods.substring$2(path, 0, $length);
                return this.isRootRelative$1(path) ? path[0] : null;
            },
            relativePathToUri$1: function(path) {
                var segments, _null = null, t1 = path.length;
                if (t1 === 0) return A._Uri__Uri(_null, _null, _null, _null);
                segments = A.Context_Context(this).split$1(0, path);
                if (this.isSeparator$1(path.charCodeAt(t1 - 1))) B.JSArray_methods.add$1(segments, "");
                return A._Uri__Uri(_null, _null, segments, _null);
            },
            codeUnitsEqual$2: function(codeUnit1, codeUnit2) {
                return codeUnit1 === codeUnit2;
            },
            pathsEqual$2: function(path1, path2) {
                return path1 === path2;
            },
            canonicalizeCodeUnit$1: function(codeUnit) {
                return codeUnit;
            },
            canonicalizePart$1: function(part) {
                return part;
            }
        };
        A.ParsedPath.prototype = {
            get$basename: function() {
                var _this = this, t1 = type$.String, copy = new A.ParsedPath(_this.style, _this.root, _this.isRootRelative, A.List_List$from(_this.parts, true, t1), A.List_List$from(_this.separators, true, t1));
                copy.removeTrailingSeparators$0();
                t1 = copy.parts;
                if (t1.length === 0) {
                    t1 = _this.root;
                    return t1 == null ? "" : t1;
                }
                return B.JSArray_methods.get$last(t1);
            },
            get$hasTrailingSeparator: function() {
                var t1 = this.parts;
                if (t1.length !== 0) t1 = B.JSArray_methods.get$last(t1) === "" || B.JSArray_methods.get$last(this.separators) !== "";
                else t1 = false;
                return t1;
            },
            removeTrailingSeparators$0: function() {
                var t1, t2, _this = this;
                for(;;){
                    t1 = _this.parts;
                    if (!(t1.length !== 0 && B.JSArray_methods.get$last(t1) === "")) break;
                    B.JSArray_methods.removeLast$0(_this.parts);
                    _this.separators.pop();
                }
                t1 = _this.separators;
                t2 = t1.length;
                if (t2 !== 0) t1[t2 - 1] = "";
            },
            normalize$1$canonicalize: function(canonicalize) {
                var t1, t2, t3, leadingDoubles, _i, part, _this = this, newParts = A._setArrayType([], type$.JSArray_String);
                for(t1 = _this.parts, t2 = t1.length, t3 = _this.style, leadingDoubles = 0, _i = 0; _i < t1.length; t1.length === t2 || (0, A.throwConcurrentModificationError)(t1), ++_i){
                    part = t1[_i];
                    if (!(part === "." || part === "")) {
                        if (part === "..") {
                            if (newParts.length !== 0) newParts.pop();
                            else ++leadingDoubles;
                        } else newParts.push(canonicalize ? t3.canonicalizePart$1(part) : part);
                    }
                }
                if (_this.root == null) B.JSArray_methods.insertAll$2(newParts, 0, A.List_List$filled(leadingDoubles, "..", false, type$.String));
                if (newParts.length === 0 && _this.root == null) newParts.push(".");
                _this.parts = newParts;
                _this.separators = A.List_List$filled(newParts.length + 1, t3.get$separator(t3), true, type$.String);
                t1 = _this.root;
                if (t1 == null || newParts.length === 0 || !t3.needsSeparator$1(t1)) _this.separators[0] = "";
                t1 = _this.root;
                if (t1 != null && t3 === $.$get$Style_windows()) {
                    if (canonicalize) t1 = _this.root = t1.toLowerCase();
                    _this.root = A.stringReplaceAllUnchecked(t1, "/", "\\");
                }
                _this.removeTrailingSeparators$0();
            },
            normalize$0: function() {
                return this.normalize$1$canonicalize(false);
            },
            toString$0: function(_) {
                var t2, t3, t4, i, t1 = this.root;
                t1 = t1 != null ? t1 : "";
                for(t2 = this.parts, t3 = t2.length, t4 = this.separators, i = 0; i < t3; ++i)t1 = t1 + t4[i] + t2[i];
                t1 += B.JSArray_methods.get$last(t4);
                return t1.charCodeAt(0) == 0 ? t1 : t1;
            },
            _kthLastIndexOf$3: function(path, character, k) {
                var index, count, leftMostIndexedCharacter;
                for(index = path.length - 1, count = 0, leftMostIndexedCharacter = 0; index >= 0; --index)if (path[index] === character) {
                    ++count;
                    if (count === k) return index;
                    leftMostIndexedCharacter = index;
                }
                return leftMostIndexedCharacter;
            },
            _splitExtension$1: function(level) {
                var t1, file, lastDot;
                if (level <= 0) throw A.wrapException(A.RangeError$value(level, "level", "level's value must be greater than 0"));
                t1 = this.parts;
                t1 = new A.CastList(t1, A._arrayInstanceType(t1)._eval$1("CastList<1,String?>"));
                file = t1.lastWhere$2$orElse(t1, new A.ParsedPath__splitExtension_closure(), new A.ParsedPath__splitExtension_closure0());
                if (file == null) return A._setArrayType([
                    "",
                    ""
                ], type$.JSArray_String);
                if (file === "..") return A._setArrayType([
                    "..",
                    ""
                ], type$.JSArray_String);
                lastDot = this._kthLastIndexOf$3(file, ".", level);
                if (lastDot <= 0) return A._setArrayType([
                    file,
                    ""
                ], type$.JSArray_String);
                return A._setArrayType([
                    B.JSString_methods.substring$2(file, 0, lastDot),
                    B.JSString_methods.substring$1(file, lastDot)
                ], type$.JSArray_String);
            },
            _splitExtension$0: function() {
                return this._splitExtension$1(1);
            }
        };
        A.ParsedPath__splitExtension_closure.prototype = {
            call$1: function(p) {
                return p !== "";
            },
            $signature: 227
        };
        A.ParsedPath__splitExtension_closure0.prototype = {
            call$0: function() {
                return null;
            },
            $signature: 1
        };
        A.PathException.prototype = {
            toString$0: function(_) {
                return "PathException: " + this.message;
            },
            $isException: 1,
            get$message: function(receiver) {
                return this.message;
            }
        };
        A.PathMap.prototype = {};
        A.PathMap__create_closure.prototype = {
            call$2: function(path1, path2) {
                if (path1 == null) return path2 == null;
                if (path2 == null) return false;
                return this._box_0.context._isWithinOrEquals$2(path1, path2) === B._PathRelation_equal;
            },
            $signature: 398
        };
        A.PathMap__create_closure0.prototype = {
            call$1: function(path) {
                return path == null ? 0 : this._box_0.context.hash$1(path);
            },
            $signature: 404
        };
        A.PathMap__create_closure1.prototype = {
            call$1: function(path) {
                return typeof path == "string" || path == null;
            },
            $signature: 456
        };
        A.Style.prototype = {
            toString$0: function(_) {
                return this.get$name(this);
            }
        };
        A.PosixStyle.prototype = {
            containsSeparator$1: function(path) {
                return B.JSString_methods.contains$1(path, "/");
            },
            isSeparator$1: function(codeUnit) {
                return codeUnit === 47;
            },
            needsSeparator$1: function(path) {
                var t1 = path.length;
                return t1 !== 0 && path.charCodeAt(t1 - 1) !== 47;
            },
            rootLength$2$withDrive: function(path, withDrive) {
                if (path.length !== 0 && path.charCodeAt(0) === 47) return 1;
                return 0;
            },
            rootLength$1: function(path) {
                return this.rootLength$2$withDrive(path, false);
            },
            isRootRelative$1: function(path) {
                return false;
            },
            pathFromUri$1: function(uri) {
                var t1;
                if (uri.get$scheme() === "" || uri.get$scheme() === "file") {
                    t1 = uri.get$path(uri);
                    return A._Uri__uriDecode(t1, 0, t1.length, B.C_Utf8Codec, false);
                }
                throw A.wrapException(A.ArgumentError$("Uri " + uri.toString$0(0) + " must have scheme 'file:'.", null));
            },
            absolutePathToUri$1: function(path) {
                var parsed = A.ParsedPath_ParsedPath$parse(path, this), t1 = parsed.parts;
                if (t1.length === 0) B.JSArray_methods.addAll$1(t1, A._setArrayType([
                    "",
                    ""
                ], type$.JSArray_String));
                else if (parsed.get$hasTrailingSeparator()) B.JSArray_methods.add$1(parsed.parts, "");
                return A._Uri__Uri(null, null, parsed.parts, "file");
            },
            get$name: function() {
                return "posix";
            },
            get$separator: function() {
                return "/";
            }
        };
        A.UrlStyle.prototype = {
            containsSeparator$1: function(path) {
                return B.JSString_methods.contains$1(path, "/");
            },
            isSeparator$1: function(codeUnit) {
                return codeUnit === 47;
            },
            needsSeparator$1: function(path) {
                var t1 = path.length;
                if (t1 === 0) return false;
                if (path.charCodeAt(t1 - 1) !== 47) return true;
                return B.JSString_methods.endsWith$1(path, "://") && this.rootLength$1(path) === t1;
            },
            rootLength$2$withDrive: function(path, withDrive) {
                var i, codeUnit, index, t1 = path.length;
                if (t1 === 0) return 0;
                if (path.charCodeAt(0) === 47) return 1;
                for(i = 0; i < t1; ++i){
                    codeUnit = path.charCodeAt(i);
                    if (codeUnit === 47) return 0;
                    if (codeUnit === 58) {
                        if (i === 0) return 0;
                        index = B.JSString_methods.indexOf$2(path, "/", B.JSString_methods.startsWith$2(path, "//", i + 1) ? i + 3 : i);
                        if (index <= 0) return t1;
                        if (!withDrive || t1 < index + 3) return index;
                        if (!B.JSString_methods.startsWith$1(path, "file://")) return index;
                        t1 = A.driveLetterEnd(path, index + 1);
                        return t1 == null ? index : t1;
                    }
                }
                return 0;
            },
            rootLength$1: function(path) {
                return this.rootLength$2$withDrive(path, false);
            },
            isRootRelative$1: function(path) {
                return path.length !== 0 && path.charCodeAt(0) === 47;
            },
            pathFromUri$1: function(uri) {
                return uri.toString$0(0);
            },
            relativePathToUri$1: function(path) {
                return A.Uri_parse(path);
            },
            absolutePathToUri$1: function(path) {
                return A.Uri_parse(path);
            },
            get$name: function() {
                return "url";
            },
            get$separator: function() {
                return "/";
            }
        };
        A.WindowsStyle.prototype = {
            containsSeparator$1: function(path) {
                return B.JSString_methods.contains$1(path, "/");
            },
            isSeparator$1: function(codeUnit) {
                return codeUnit === 47 || codeUnit === 92;
            },
            needsSeparator$1: function(path) {
                var t1 = path.length;
                if (t1 === 0) return false;
                t1 = path.charCodeAt(t1 - 1);
                return !(t1 === 47 || t1 === 92);
            },
            rootLength$2$withDrive: function(path, withDrive) {
                var index, t1 = path.length;
                if (t1 === 0) return 0;
                if (path.charCodeAt(0) === 47) return 1;
                if (path.charCodeAt(0) === 92) {
                    if (t1 < 2 || path.charCodeAt(1) !== 92) return 1;
                    index = B.JSString_methods.indexOf$2(path, "\\", 2);
                    if (index > 0) {
                        index = B.JSString_methods.indexOf$2(path, "\\", index + 1);
                        if (index > 0) return index;
                    }
                    return t1;
                }
                if (t1 < 3) return 0;
                if (!A.isAlphabetic(path.charCodeAt(0))) return 0;
                if (path.charCodeAt(1) !== 58) return 0;
                t1 = path.charCodeAt(2);
                if (!(t1 === 47 || t1 === 92)) return 0;
                return 3;
            },
            rootLength$1: function(path) {
                return this.rootLength$2$withDrive(path, false);
            },
            isRootRelative$1: function(path) {
                return this.rootLength$1(path) === 1;
            },
            pathFromUri$1: function(uri) {
                var path, t1;
                if (uri.get$scheme() !== "" && uri.get$scheme() !== "file") throw A.wrapException(A.ArgumentError$("Uri " + uri.toString$0(0) + " must have scheme 'file:'.", null));
                path = uri.get$path(uri);
                if (uri.get$host() === "") {
                    if (path.length >= 3 && B.JSString_methods.startsWith$1(path, "/") && A.driveLetterEnd(path, 1) != null) path = B.JSString_methods.replaceFirst$2(path, "/", "");
                } else path = "\\\\" + uri.get$host() + path;
                t1 = A.stringReplaceAllUnchecked(path, "/", "\\");
                return A._Uri__uriDecode(t1, 0, t1.length, B.C_Utf8Codec, false);
            },
            absolutePathToUri$1: function(path) {
                var rootParts, t2, parsed = A.ParsedPath_ParsedPath$parse(path, this), t1 = parsed.root;
                t1.toString;
                if (B.JSString_methods.startsWith$1(t1, "\\\\")) {
                    rootParts = new A.WhereIterable(A._setArrayType(t1.split("\\"), type$.JSArray_String), new A.WindowsStyle_absolutePathToUri_closure(), type$.WhereIterable_String);
                    B.JSArray_methods.insert$2(parsed.parts, 0, rootParts.get$last(0));
                    if (parsed.get$hasTrailingSeparator()) B.JSArray_methods.add$1(parsed.parts, "");
                    return A._Uri__Uri(rootParts.get$first(0), null, parsed.parts, "file");
                } else {
                    if (parsed.parts.length === 0 || parsed.get$hasTrailingSeparator()) B.JSArray_methods.add$1(parsed.parts, "");
                    t1 = parsed.parts;
                    t2 = parsed.root;
                    t2.toString;
                    t2 = A.stringReplaceAllUnchecked(t2, "/", "");
                    B.JSArray_methods.insert$2(t1, 0, A.stringReplaceAllUnchecked(t2, "\\", ""));
                    return A._Uri__Uri(null, null, parsed.parts, "file");
                }
            },
            codeUnitsEqual$2: function(codeUnit1, codeUnit2) {
                var upperCase1;
                if (codeUnit1 === codeUnit2) return true;
                if (codeUnit1 === 47) return codeUnit2 === 92;
                if (codeUnit1 === 92) return codeUnit2 === 47;
                if ((codeUnit1 ^ codeUnit2) !== 32) return false;
                upperCase1 = codeUnit1 | 32;
                return upperCase1 >= 97 && upperCase1 <= 122;
            },
            pathsEqual$2: function(path1, path2) {
                var t1, i;
                if (path1 === path2) return true;
                t1 = path1.length;
                if (t1 !== path2.length) return false;
                for(i = 0; i < t1; ++i)if (!this.codeUnitsEqual$2(path1.charCodeAt(i), path2.charCodeAt(i))) return false;
                return true;
            },
            canonicalizeCodeUnit$1: function(codeUnit) {
                if (codeUnit === 47) return 92;
                if (codeUnit < 65) return codeUnit;
                if (codeUnit > 90) return codeUnit;
                return codeUnit | 32;
            },
            canonicalizePart$1: function(part) {
                return part.toLowerCase();
            },
            get$name: function() {
                return "windows";
            },
            get$separator: function() {
                return "\\";
            }
        };
        A.WindowsStyle_absolutePathToUri_closure.prototype = {
            call$1: function(part) {
                return part !== "";
            },
            $signature: 4
        };
        A.Version.prototype = {
            get$min: function() {
                return this;
            },
            get$max: function() {
                return this;
            },
            get$includeMin: function() {
                return true;
            },
            get$includeMax: function() {
                return true;
            },
            $eq: function(_, other) {
                var _this = this;
                if (other == null) return false;
                return other instanceof A.Version && _this.major === other.major && _this.minor === other.minor && _this.patch === other.patch && B.C_IterableEquality.equals$2(0, _this.preRelease, other.preRelease) && B.C_IterableEquality.equals$2(0, _this.build, other.build);
            },
            get$hashCode: function(_) {
                var _this = this;
                return (_this.major ^ _this.minor ^ _this.patch ^ B.C_IterableEquality.hash$1(_this.preRelease) ^ B.C_IterableEquality.hash$1(_this.build)) >>> 0;
            },
            compareTo$1: function(_, other) {
                var t1, t2, t3, comparison, _this = this;
                if (other instanceof A.Version) {
                    t1 = _this.major;
                    t2 = other.major;
                    if (t1 !== t2) return B.JSInt_methods.compareTo$1(t1, t2);
                    t1 = _this.minor;
                    t2 = other.minor;
                    if (t1 !== t2) return B.JSInt_methods.compareTo$1(t1, t2);
                    t1 = _this.patch;
                    t2 = other.patch;
                    if (t1 !== t2) return B.JSInt_methods.compareTo$1(t1, t2);
                    t1 = _this.preRelease;
                    t2 = t1.length === 0;
                    if (t2 && other.preRelease.length !== 0) return 1;
                    t3 = other.preRelease;
                    if (t3.length === 0 && !t2) return -1;
                    comparison = _this._compareLists$2(t1, t3);
                    if (comparison !== 0) return comparison;
                    t1 = _this.build;
                    t2 = t1.length === 0;
                    if (t2 && other.build.length !== 0) return -1;
                    t3 = other.build;
                    if (t3.length === 0 && !t2) return 1;
                    return _this._compareLists$2(t1, t3);
                } else return -other.compareTo$1(0, _this);
            },
            toString$0: function(_) {
                return this._version$_text;
            },
            _compareLists$2: function(a, b) {
                var i, t1, t2, aPart, bPart;
                for(i = 0; t1 = a.length, t2 = b.length, i < Math.max(t1, t2); ++i){
                    aPart = i < t1 ? a[i] : null;
                    bPart = i < t2 ? b[i] : null;
                    if (J.$eq$(aPart, bPart)) continue;
                    if (aPart == null) return -1;
                    if (bPart == null) return 1;
                    if (typeof aPart == "number") {
                        if (typeof bPart == "number") return B.JSNumber_methods.compareTo$1(aPart, bPart);
                        else return -1;
                    } else if (typeof bPart == "number") return 1;
                    else {
                        A._asString(aPart);
                        A._asString(bPart);
                        if (aPart === bPart) t1 = 0;
                        else t1 = aPart < bPart ? -1 : 1;
                        return t1;
                    }
                }
                return 0;
            },
            $isComparable: 1,
            $isVersionRange: 1
        };
        A.Version__splitParts_closure.prototype = {
            call$1: function(part) {
                var t1 = A.Primitives_parseInt(part, null);
                return t1 == null ? part : t1;
            },
            $signature: 476
        };
        A.VersionRange.prototype = {
            $eq: function(_, other) {
                var t1;
                if (other == null) return false;
                if (!type$.VersionRange._is(other)) return false;
                t1 = false;
                if (this.min == other.get$min()) {
                    if (J.$eq$(this.max, other.get$max())) {
                        t1 = !other.get$includeMin();
                        if (t1) other.get$includeMax();
                    }
                }
                return t1;
            },
            get$hashCode: function(_) {
                var t1 = B.JSNull_methods.get$hashCode(this.min), t2 = J.get$hashCode$(this.max);
                return (t1 ^ t2 * 3 ^ 2607885) >>> 0;
            },
            allows$1: function(other) {
                var t1 = this.max;
                if (t1 != null) {
                    if (other.compareTo$1(0, t1) > 0) return false;
                }
                return true;
            },
            compareTo$1: function(_, other) {
                if (other.get$min() == null) return this._compareMax$1(other);
                return -1;
            },
            _compareMax$1: function(other) {
                var t2, result, t1 = this.max;
                if (t1 == null) {
                    if (other.get$max() == null) return 0;
                    return 1;
                } else if (other.get$max() == null) return -1;
                t2 = other.get$max();
                t2.toString;
                result = t1.compareTo$1(0, t2);
                if (result !== 0) return result;
                other.get$includeMax();
                return 0;
            },
            toString$0: function(_) {
                var t2, max = this.max, t1 = max == null;
                if (!t1) t2 = "<=" + max.toString$0(0);
                else t2 = "";
                t1 = t1 ? t2 + "any" : t2;
                return t1.charCodeAt(0) == 0 ? t1 : t1;
            },
            $isComparable: 1,
            get$min: function() {
                return this.min;
            },
            get$max: function() {
                return this.max;
            },
            get$includeMin: function() {
                return this.includeMin;
            },
            get$includeMax: function() {
                return this.includeMax;
            }
        };
        A.CssMediaQuery.prototype = {
            merge$1: function(other) {
                var t1, ourModifier, t2, t3, ourType, t4, theirModifier, t5, t6, theirType, t7, t8, negativeConditions, conditions, type, modifier, fewerConditions, fewerConditions0, moreConditions, _this = this, _null = null, _s3_ = "all";
                if (!_this.conjunction || !other.conjunction) return B._SingletonCssMediaQueryMergeResult_1;
                t1 = _this.modifier;
                ourModifier = t1 == null ? _null : t1.toLowerCase();
                t2 = _this.type;
                t3 = t2 == null;
                ourType = t3 ? _null : t2.toLowerCase();
                t4 = other.modifier;
                theirModifier = t4 == null ? _null : t4.toLowerCase();
                t5 = other.type;
                t6 = t5 == null;
                theirType = t6 ? _null : t5.toLowerCase();
                t7 = ourType == null;
                if (t7 && theirType == null) {
                    t1 = A.List_List$_of(_this.conditions, type$.String);
                    B.JSArray_methods.addAll$1(t1, other.conditions);
                    return new A.MediaQuerySuccessfulMergeResult(A.CssMediaQuery$condition(t1, true));
                }
                t8 = ourModifier === "not";
                if (t8 !== (theirModifier === "not")) {
                    if (ourType == theirType) {
                        negativeConditions = t8 ? _this.conditions : other.conditions;
                        if (B.JSArray_methods.every$1(negativeConditions, B.JSArray_methods.get$contains(t8 ? other.conditions : _this.conditions))) return B._SingletonCssMediaQueryMergeResult_0;
                        else return B._SingletonCssMediaQueryMergeResult_1;
                    } else if (t3 || A.equalsIgnoreCase(t2, _s3_) || t6 || A.equalsIgnoreCase(t5, _s3_)) return B._SingletonCssMediaQueryMergeResult_1;
                    if (t8) {
                        conditions = other.conditions;
                        type = theirType;
                        modifier = theirModifier;
                    } else {
                        conditions = _this.conditions;
                        type = ourType;
                        modifier = ourModifier;
                    }
                } else if (t8) {
                    if (ourType != theirType) return B._SingletonCssMediaQueryMergeResult_1;
                    fewerConditions = _this.conditions;
                    fewerConditions0 = other.conditions;
                    t3 = fewerConditions.length > fewerConditions0.length;
                    moreConditions = t3 ? fewerConditions : fewerConditions0;
                    if (t3) fewerConditions = fewerConditions0;
                    if (!B.JSArray_methods.every$1(fewerConditions, B.JSArray_methods.get$contains(moreConditions))) return B._SingletonCssMediaQueryMergeResult_1;
                    conditions = moreConditions;
                    type = ourType;
                    modifier = ourModifier;
                } else if (t3 || A.equalsIgnoreCase(t2, _s3_)) {
                    type = (t6 || A.equalsIgnoreCase(t5, _s3_)) && t7 ? _null : theirType;
                    t3 = A.List_List$_of(_this.conditions, type$.String);
                    B.JSArray_methods.addAll$1(t3, other.conditions);
                    conditions = t3;
                    modifier = theirModifier;
                } else {
                    if (t6 || A.equalsIgnoreCase(t5, _s3_)) {
                        t3 = A.List_List$_of(_this.conditions, type$.String);
                        B.JSArray_methods.addAll$1(t3, other.conditions);
                        conditions = t3;
                        modifier = ourModifier;
                    } else {
                        if (ourType != theirType) return B._SingletonCssMediaQueryMergeResult_0;
                        else {
                            modifier = ourModifier == null ? theirModifier : ourModifier;
                            t3 = A.List_List$_of(_this.conditions, type$.String);
                            B.JSArray_methods.addAll$1(t3, other.conditions);
                        }
                        conditions = t3;
                    }
                    type = ourType;
                }
                t2 = type == ourType ? t2 : t5;
                return new A.MediaQuerySuccessfulMergeResult(A.CssMediaQuery$type(t2, conditions, modifier == ourModifier ? t1 : t4));
            },
            $eq: function(_, other) {
                if (other == null) return false;
                return other instanceof A.CssMediaQuery && other.modifier == this.modifier && other.type == this.type && B.C_ListEquality.equals$2(0, other.conditions, this.conditions);
            },
            get$hashCode: function(_) {
                return J.get$hashCode$(this.modifier) ^ J.get$hashCode$(this.type) ^ B.C_ListEquality0.hash$1(this.conditions);
            },
            toString$0: function(_) {
                var t2, _this = this, t1 = _this.modifier;
                t1 = t1 != null ? t1 + " " : "";
                t2 = _this.type;
                if (t2 != null) {
                    t1 += t2;
                    if (_this.conditions.length !== 0) t1 += " and ";
                }
                t2 = _this.conjunction ? " and " : " or ";
                t2 = t1 + B.JSArray_methods.join$1(_this.conditions, t2);
                return t2.charCodeAt(0) == 0 ? t2 : t2;
            }
        };
        A._SingletonCssMediaQueryMergeResult.prototype = {
            _enumToString$0: function() {
                return "_SingletonCssMediaQueryMergeResult." + this._name;
            }
        };
        A.MediaQuerySuccessfulMergeResult.prototype = {
            toString$0: function(_) {
                return this.query.toString$0(0);
            }
        };
        A.ModifiableCssAtRule.prototype = {
            accept$1$1: function(visitor) {
                return visitor.visitCssAtRule$1(this);
            },
            accept$1: function(visitor) {
                return this.accept$1$1(visitor, type$.dynamic);
            },
            equalsIgnoringChildren$1: function(other) {
                var t1, t2;
                if (other instanceof A.ModifiableCssAtRule) {
                    t1 = this.name;
                    t2 = other.name;
                    t1 = t1.$ti._is(t2) && J.$eq$(t2.value, t1.value) && J.$eq$(this.value, other.value) && this.isChildless === other.isChildless;
                } else t1 = false;
                return t1;
            },
            copyWithoutChildren$0: function() {
                var _this = this;
                return A.ModifiableCssAtRule$(_this.name, _this.span, _this.isChildless, _this.value);
            },
            addChild$1: function(child) {
                this.super$ModifiableCssParentNode$addChild(child);
            },
            get$isChildless: function() {
                return this.isChildless;
            },
            get$span: function(receiver) {
                return this.span;
            }
        };
        A.ModifiableCssComment.prototype = {
            accept$1$1: function(visitor) {
                return visitor.visitCssComment$1(this);
            },
            accept$1: function(visitor) {
                return this.accept$1$1(visitor, type$.dynamic);
            },
            $isCssComment: 1,
            get$span: function(receiver) {
                return this.span;
            }
        };
        A.ModifiableCssDeclaration.prototype = {
            accept$1$1: function(visitor) {
                return visitor.visitCssDeclaration$1(this);
            },
            accept$1: function(visitor) {
                return this.accept$1$1(visitor, type$.dynamic);
            },
            toString$0: function(_) {
                return this.name.toString$0(0) + ": " + this.value.toString$0(0) + ";";
            },
            get$span: function(receiver) {
                return this.span;
            }
        };
        A.ModifiableCssImport.prototype = {
            accept$1$1: function(visitor) {
                return visitor.visitCssImport$1(this);
            },
            accept$1: function(visitor) {
                return this.accept$1$1(visitor, type$.dynamic);
            },
            get$span: function(receiver) {
                return this.span;
            }
        };
        A.ModifiableCssKeyframeBlock.prototype = {
            accept$1$1: function(visitor) {
                return visitor.visitCssKeyframeBlock$1(this);
            },
            accept$1: function(visitor) {
                return this.accept$1$1(visitor, type$.dynamic);
            },
            equalsIgnoringChildren$1: function(other) {
                return other instanceof A.ModifiableCssKeyframeBlock && B.C_ListEquality.equals$2(0, this.selector.value, other.selector.value);
            },
            copyWithoutChildren$0: function() {
                return A.ModifiableCssKeyframeBlock$(this.selector, this.span);
            },
            get$span: function(receiver) {
                return this.span;
            }
        };
        A.ModifiableCssMediaRule.prototype = {
            accept$1$1: function(visitor) {
                return visitor.visitCssMediaRule$1(this);
            },
            accept$1: function(visitor) {
                return this.accept$1$1(visitor, type$.dynamic);
            },
            equalsIgnoringChildren$1: function(other) {
                return other instanceof A.ModifiableCssMediaRule && B.C_ListEquality.equals$2(0, this.queries, other.queries);
            },
            copyWithoutChildren$0: function() {
                return A.ModifiableCssMediaRule$(this.queries, this.span);
            },
            get$span: function(receiver) {
                return this.span;
            }
        };
        A.ModifiableCssNode.prototype = {
            get$hasFollowingSibling: function() {
                var t2, t1 = this._parent;
                if (t1 == null) t1 = null;
                else {
                    t1 = t1.children;
                    t2 = this._indexInParent;
                    t2.toString;
                    t1 = A.SubListIterable$(t1, t2 + 1, null, t1.$ti._eval$1("ListBase.E")).any$1(0, new A.ModifiableCssNode_hasFollowingSibling_closure());
                }
                return t1 === true;
            },
            get$isGroupEnd: function() {
                return this.isGroupEnd;
            }
        };
        A.ModifiableCssNode_hasFollowingSibling_closure.prototype = {
            call$1: function(sibling) {
                return !sibling.accept$1(B._IsInvisibleVisitor_true_false);
            },
            $signature: 599
        };
        A.ModifiableCssParentNode.prototype = {
            get$isChildless: function() {
                return false;
            },
            addChild$1: function(child) {
                var t1;
                child._parent = this;
                t1 = this._children;
                child._indexInParent = t1.length;
                t1.push(child);
            },
            clearChildren$0: function() {
                var t1, t2, _i, child;
                for(t1 = this._children, t2 = t1.length, _i = 0; _i < t2; ++_i){
                    child = t1[_i];
                    child._indexInParent = child._parent = null;
                }
                B.JSArray_methods.clear$0(t1);
            },
            $isCssParentNode: 1,
            get$children: function(receiver) {
                return this.children;
            }
        };
        A.ModifiableCssStyleRule.prototype = {
            accept$1$1: function(visitor) {
                return visitor.visitCssStyleRule$1(this);
            },
            accept$1: function(visitor) {
                return this.accept$1$1(visitor, type$.dynamic);
            },
            equalsIgnoringChildren$1: function(other) {
                var t1;
                if (other instanceof A.ModifiableCssStyleRule) t1 = B.C_ListEquality.equals$2(0, other._style_rule$_selector._box$_inner.value.components, this._style_rule$_selector._box$_inner.value.components);
                else t1 = false;
                return t1;
            },
            copyWithoutChildren$0: function() {
                return A.ModifiableCssStyleRule$(this._style_rule$_selector, this.span, false, this.originalSelector);
            },
            get$span: function(receiver) {
                return this.span;
            }
        };
        A.ModifiableCssStylesheet.prototype = {
            accept$1$1: function(visitor) {
                return visitor.visitCssStylesheet$1(this);
            },
            accept$1: function(visitor) {
                return this.accept$1$1(visitor, type$.dynamic);
            },
            equalsIgnoringChildren$1: function(other) {
                return other instanceof A.ModifiableCssStylesheet;
            },
            copyWithoutChildren$0: function() {
                return A.ModifiableCssStylesheet$(this.span);
            },
            $isCssStylesheet: 1,
            get$span: function(receiver) {
                return this.span;
            }
        };
        A.ModifiableCssSupportsRule.prototype = {
            accept$1$1: function(visitor) {
                return visitor.visitCssSupportsRule$1(this);
            },
            accept$1: function(visitor) {
                return this.accept$1$1(visitor, type$.dynamic);
            },
            equalsIgnoringChildren$1: function(other) {
                var t1, t2;
                if (other instanceof A.ModifiableCssSupportsRule) {
                    t1 = this.condition;
                    t2 = other.condition;
                    t1 = t1.$ti._is(t2) && J.$eq$(t2.value, t1.value);
                } else t1 = false;
                return t1;
            },
            copyWithoutChildren$0: function() {
                return A.ModifiableCssSupportsRule$(this.condition, this.span);
            },
            get$span: function(receiver) {
                return this.span;
            }
        };
        A.CssNode.prototype = {
            toString$0: function(_) {
                var _null = null;
                return A.serialize(this, true, _null, true, _null, _null, false, _null, true)._0;
            },
            $isAstNode: 1
        };
        A.CssParentNode.prototype = {};
        A._IsInvisibleVisitor.prototype = {
            visitCssAtRule$1: function(rule) {
                return false;
            },
            visitCssComment$1: function(comment) {
                return this.includeComments && comment.text.charCodeAt(2) !== 33;
            },
            visitCssStyleRule$1: function(rule) {
                var t1 = rule._style_rule$_selector._box$_inner;
                return (this.includeBogus ? t1.value.accept$1(B._IsInvisibleVisitor_true) : t1.value.accept$1(B._IsInvisibleVisitor_false)) || this.super$EveryCssVisitor$visitCssStyleRule(rule);
            }
        };
        A.__IsInvisibleVisitor_Object_EveryCssVisitor.prototype = {};
        A.CssStylesheet.prototype = {
            get$isGroupEnd: function() {
                return false;
            },
            get$isChildless: function() {
                return false;
            },
            accept$1$1: function(visitor) {
                return visitor.visitCssStylesheet$1(this);
            },
            accept$1: function(visitor) {
                return this.accept$1$1(visitor, type$.dynamic);
            },
            get$children: function(receiver) {
                return this.children;
            },
            get$span: function(receiver) {
                return this.span;
            }
        };
        A.CssValue.prototype = {
            $eq: function(_, other) {
                if (other == null) return false;
                return this.$ti._is(other) && J.$eq$(other.value, this.value);
            },
            get$hashCode: function(_) {
                return J.get$hashCode$(this.value);
            },
            toString$0: function(_) {
                return J.toString$0$(this.value);
            },
            $isAstNode: 1,
            get$span: function(receiver) {
                return this.span;
            }
        };
        A._FakeAstNode.prototype = {
            get$span: function(_) {
                return this._callback.call$0();
            },
            $isAstNode: 1
        };
        A.ArgumentList.prototype = {
            get$isEmpty: function(_) {
                var t1;
                if (this.positional.length === 0) {
                    t1 = this.named;
                    t1 = t1.get$isEmpty(t1) && this.rest == null;
                } else t1 = false;
                return t1;
            },
            toString$0: function(_) {
                var t2, t3, _i, _1_0, _2_0, _this = this, t1 = A._setArrayType([], type$.JSArray_String);
                for(t2 = _this.positional, t3 = t2.length, _i = 0; _i < t3; ++_i)t1.push(_this._parenthesizeArgument$1(t2[_i]));
                for(t2 = A.MapExtensions_get_pairs(_this.named, type$.String, type$.Expression), t2 = t2.get$iterator(t2); t2.moveNext$0();){
                    t3 = t2.get$current(t2);
                    t1.push("$" + t3._0 + ": " + _this._parenthesizeArgument$1(t3._1));
                }
                _1_0 = _this.rest;
                if (_1_0 != null) t1.push(_this._parenthesizeArgument$1(_1_0) + "...");
                _2_0 = _this.keywordRest;
                if (_2_0 != null) t1.push(_this._parenthesizeArgument$1(_2_0) + "...");
                return "(" + B.JSArray_methods.join$1(t1, ", ") + ")";
            },
            _parenthesizeArgument$1: function(argument) {
                var t1;
                $label0$0: {
                    if (argument instanceof A.ListExpression && B.ListSeparator_z0K === argument.separator && !argument.hasBrackets && argument.contents.length >= 2) {
                        t1 = "(" + argument.toString$0(0) + ")";
                        break $label0$0;
                    }
                    t1 = argument.toString$0(0);
                    break $label0$0;
                }
                return t1;
            },
            $isAstNode: 1,
            get$span: function(receiver) {
                return this.span;
            }
        };
        A.AtRootQuery.prototype = {
            excludes$1: function(node) {
                var t1, _this = this;
                if (_this._all) return !_this.include;
                $label0$0: {
                    if (node instanceof A.ModifiableCssStyleRule) {
                        t1 = _this._at_root_query$_rule !== _this.include;
                        break $label0$0;
                    }
                    if (node instanceof A.ModifiableCssMediaRule) {
                        t1 = _this.excludesName$1("media");
                        break $label0$0;
                    }
                    if (node instanceof A.ModifiableCssSupportsRule) {
                        t1 = _this.excludesName$1("supports");
                        break $label0$0;
                    }
                    if (node instanceof A.ModifiableCssAtRule) {
                        t1 = _this.excludesName$1(node.name.value.toLowerCase());
                        break $label0$0;
                    }
                    t1 = false;
                    break $label0$0;
                }
                return t1;
            },
            excludesName$1: function($name) {
                var t1 = this._all || this.names.contains$1(0, $name);
                return t1 !== this.include;
            }
        };
        A.BooleanOperator.prototype = {
            _enumToString$0: function() {
                return "BooleanOperator." + this._name;
            },
            toString$0: function(_) {
                return this._name;
            }
        };
        A.ConfiguredVariable.prototype = {
            toString$0: function(_) {
                var t1 = this.expression.toString$0(0), t2 = this.isGuarded ? " !default" : "";
                return "$" + this.name + ": " + t1 + t2;
            },
            $isAstNode: 1,
            get$span: function(receiver) {
                return this.span;
            }
        };
        A.Expression.prototype = {
            $isAstNode: 1
        };
        A.BinaryOperationExpression.prototype = {
            get$span: function(_) {
                var right, left = this.left;
                while(left instanceof A.BinaryOperationExpression)left = left.left;
                right = this.right;
                while(right instanceof A.BinaryOperationExpression)right = right.right;
                return left.get$span(left).expand$1(0, right.get$span(right));
            },
            get$operatorSpan: function() {
                var t3, t4, t1 = this.left, t2 = t1.get$span(t1);
                t2 = t2.get$file(t2);
                t3 = this.right;
                t4 = t3.get$span(t3);
                if (t2 === t4.get$file(t4)) {
                    t2 = t1.get$span(t1);
                    t2 = t2.get$end(t2);
                    t4 = t3.get$span(t3);
                    t4 = t2.offset < t4.get$start(t4).offset;
                    t2 = t4;
                } else t2 = false;
                if (t2) {
                    t2 = t1.get$span(t1);
                    t2 = t2.get$file(t2);
                    t1 = t1.get$span(t1);
                    t1 = t1.get$end(t1);
                    t3 = t3.get$span(t3);
                    t3 = A.SpanExtensions_trimRight(A.SpanExtensions_trimLeft(t2.span$2(0, t1.offset, t3.get$start(t3).offset)));
                    t1 = t3;
                } else t1 = this.get$span(0);
                return t1;
            },
            accept$1$1: function(visitor) {
                return visitor.visitBinaryOperationExpression$1(0, this);
            },
            accept$1: function(visitor) {
                return this.accept$1$1(visitor, type$.dynamic);
            },
            toString$0: function(_) {
                var t1, t2, t3, right, operator, _this = this, _0_0 = _this.left;
                $label0$0: {
                    if (_0_0 instanceof A.BinaryOperationExpression) {
                        t1 = _0_0.operator.precedence < _this.operator.precedence;
                        break $label0$0;
                    }
                    if (_0_0 instanceof A.ListExpression && !_0_0.hasBrackets && _0_0.contents.length >= 2) {
                        t1 = true;
                        break $label0$0;
                    }
                    t1 = false;
                    break $label0$0;
                }
                t2 = t1 ? A.Primitives_stringFromCharCode(40) : "";
                t2 += _0_0.toString$0(0);
                t1 = t1 ? t2 + A.Primitives_stringFromCharCode(41) : t2;
                t2 = A.Primitives_stringFromCharCode(32);
                t3 = _this.operator;
                t2 = t1 + t2 + t3.operator + t2;
                right = _this.right;
                $label1$1: {
                    t1 = false;
                    if (right instanceof A.BinaryOperationExpression) {
                        operator = right.operator;
                        if (operator.precedence <= t3.precedence) t1 = !(operator === t3 && operator.isAssociative);
                        break $label1$1;
                    }
                    if (right instanceof A.ListExpression && !right.hasBrackets && right.contents.length >= 2) {
                        t1 = true;
                        break $label1$1;
                    }
                    break $label1$1;
                }
                if (t1) t2 += A.Primitives_stringFromCharCode(40);
                t2 += right.toString$0(0);
                t1 = t1 ? t2 + A.Primitives_stringFromCharCode(41) : t2;
                return t1.charCodeAt(0) == 0 ? t1 : t1;
            }
        };
        A.BinaryOperator.prototype = {
            _enumToString$0: function() {
                return "BinaryOperator." + this._name;
            },
            toString$0: function(_) {
                return this.name;
            }
        };
        A.BooleanExpression.prototype = {
            accept$1$1: function(visitor) {
                return visitor.visitBooleanExpression$1(0, this);
            },
            accept$1: function(visitor) {
                return this.accept$1$1(visitor, type$.dynamic);
            },
            toString$0: function(_) {
                return String(this.value);
            },
            get$span: function(receiver) {
                return this.span;
            }
        };
        A.ColorExpression.prototype = {
            accept$1$1: function(visitor) {
                return visitor.visitColorExpression$1(0, this);
            },
            accept$1: function(visitor) {
                return this.accept$1$1(visitor, type$.dynamic);
            },
            toString$0: function(_) {
                return A.serializeValue(this.value, true, true);
            },
            get$span: function(receiver) {
                return this.span;
            }
        };
        A.FunctionExpression.prototype = {
            accept$1$1: function(visitor) {
                return visitor.visitFunctionExpression$1(0, this);
            },
            accept$1: function(visitor) {
                return this.accept$1$1(visitor, type$.dynamic);
            },
            toString$0: function(_) {
                var t1 = this.namespace;
                t1 = t1 != null ? t1 + "." : "";
                t1 += this.originalName + this.$arguments.toString$0(0);
                return t1.charCodeAt(0) == 0 ? t1 : t1;
            },
            get$span: function(receiver) {
                return this.span;
            }
        };
        A.IfExpression.prototype = {
            accept$1$1: function(visitor) {
                return visitor.visitIfExpression$1(0, this);
            },
            accept$1: function(visitor) {
                return this.accept$1$1(visitor, type$.dynamic);
            },
            toString$0: function(_) {
                var t1, t2, first, _i, t3, t4, condition;
                for(t1 = this.branches, t2 = t1.length, first = true, _i = 0, t3 = "if("; _i < t2; ++_i){
                    t4 = t1[_i];
                    condition = t4._0;
                    if (first) first = false;
                    else t3 += "; ";
                    t3 = t3 + A.S(condition == null ? "else" : condition) + ": " + t4._1.toString$0(0);
                }
                t1 = t3 + A.Primitives_stringFromCharCode(41);
                return t1.charCodeAt(0) == 0 ? t1 : t1;
            },
            get$span: function(receiver) {
                return this.span;
            }
        };
        A.IfConditionExpression.prototype = {
            get$isArbitrarySubstitution: function() {
                return false;
            },
            $isAstNode: 1
        };
        A.IfConditionParenthesized.prototype = {
            toInterpolation$1: function(arbitrarySubstitution) {
                var t1 = new A.StringBuffer(""), t2 = new A.InterpolationBuffer(t1, A._setArrayType([], type$.JSArray_Object), A._setArrayType([], type$.JSArray_nullable_FileSpan)), t3 = A.Primitives_stringFromCharCode(40);
                t1._contents += t3;
                t2.addInterpolation$1(this.expression.toInterpolation$1(arbitrarySubstitution));
                t3 = A.Primitives_stringFromCharCode(41);
                t1._contents += t3;
                return t2.interpolation$1(this.span);
            },
            accept$1$1: function(visitor) {
                return visitor.visitIfConditionParenthesized$1(0, this);
            },
            accept$1: function(visitor) {
                return this.accept$1$1(visitor, type$.dynamic);
            },
            toString$0: function(_) {
                return "(" + this.expression.toString$0(0) + ")";
            },
            get$span: function(receiver) {
                return this.span;
            }
        };
        A.IfConditionNegation.prototype = {
            toInterpolation$1: function(arbitrarySubstitution) {
                var t1 = new A.StringBuffer(""), t2 = new A.InterpolationBuffer(t1, A._setArrayType([], type$.JSArray_Object), A._setArrayType([], type$.JSArray_nullable_FileSpan));
                t1._contents = "not ";
                t2.addInterpolation$1(this.expression.toInterpolation$1(arbitrarySubstitution));
                return t2.interpolation$1(this.span);
            },
            accept$1$1: function(visitor) {
                return visitor.visitIfConditionNegation$1(0, this);
            },
            accept$1: function(visitor) {
                return this.accept$1$1(visitor, type$.dynamic);
            },
            toString$0: function(_) {
                return "not " + this.expression.toString$0(0);
            },
            get$span: function(receiver) {
                return this.span;
            }
        };
        A.IfConditionOperation.prototype = {
            get$span: function(_) {
                var t1 = this.expressions, t2 = B.JSArray_methods.get$first(t1);
                t2 = t2.get$span(t2);
                t1 = B.JSArray_methods.get$last(t1);
                return t2.expand$1(0, t1.get$span(t1));
            },
            toInterpolation$1: function(arbitrarySubstitution) {
                var t2, t3, t4, first, _i, expression, t1 = new A.StringBuffer(""), buffer = new A.InterpolationBuffer(t1, A._setArrayType([], type$.JSArray_Object), A._setArrayType([], type$.JSArray_nullable_FileSpan));
                for(t2 = this.expressions, t3 = t2.length, t4 = this.op, first = true, _i = 0; _i < t3; ++_i){
                    expression = t2[_i];
                    if (first) first = false;
                    else t1._contents += " " + t4.toString$0(0) + " ";
                    buffer.addInterpolation$1(expression.toInterpolation$1(arbitrarySubstitution));
                }
                return buffer.interpolation$1(new A.LazyFileSpan(new A.IfConditionOperation_toInterpolation_closure(this)));
            },
            accept$1$1: function(visitor) {
                return visitor.visitIfConditionOperation$1(0, this);
            },
            accept$1: function(visitor) {
                return this.accept$1$1(visitor, type$.dynamic);
            },
            toString$0: function(_) {
                return B.JSArray_methods.join$1(this.expressions, " " + this.op.toString$0(0) + " ");
            }
        };
        A.IfConditionOperation_toInterpolation_closure.prototype = {
            call$0: function() {
                return this.$this.get$span(0);
            },
            $signature: 16
        };
        A.IfConditionFunction.prototype = {
            get$isArbitrarySubstitution: function() {
                var t2, t1 = this.name.get$asPlain(), _0_0 = t1 == null ? null : t1.toLowerCase();
                $label0$0: {
                    t1 = true;
                    if ("if" === _0_0 || "var" === _0_0 || "attr" === _0_0) break $label0$0;
                    if (_0_0 != null) t2 = B.JSString_methods.startsWith$1(_0_0, "--");
                    else t2 = false;
                    if (t2) break $label0$0;
                    t1 = false;
                    break $label0$0;
                }
                return t1;
            },
            toInterpolation$1: function(_) {
                var t3, t1 = new A.StringBuffer(""), t2 = new A.InterpolationBuffer(t1, A._setArrayType([], type$.JSArray_Object), A._setArrayType([], type$.JSArray_nullable_FileSpan));
                t2.addInterpolation$1(this.name);
                t3 = A.Primitives_stringFromCharCode(40);
                t1._contents += t3;
                t2.addInterpolation$1(this.$arguments);
                t3 = A.Primitives_stringFromCharCode(41);
                t1._contents += t3;
                return t2.interpolation$1(this.span);
            },
            accept$1$1: function(visitor) {
                return visitor.visitIfConditionFunction$1(0, this);
            },
            accept$1: function(visitor) {
                return this.accept$1$1(visitor, type$.dynamic);
            },
            toString$0: function(_) {
                return this.name.toString$0(0) + "(" + this.$arguments.toString$0(0) + ")";
            },
            get$span: function(receiver) {
                return this.span;
            }
        };
        A.IfConditionSass.prototype = {
            toInterpolation$1: function(arbitrarySubstitution) {
                return A.throwExpression(A.MultiSourceSpanFormatException$(string$.if___c, arbitrarySubstitution.get$span(arbitrarySubstitution), "arbitrary substitution", A.LinkedHashMap_LinkedHashMap$_literal([
                    this.span,
                    "sass() expression"
                ], type$.SourceSpan, type$.String), null));
            },
            accept$1$1: function(visitor) {
                return visitor.visitIfConditionSass$1(0, this);
            },
            accept$1: function(visitor) {
                return this.accept$1$1(visitor, type$.dynamic);
            },
            toString$0: function(_) {
                return "sass(" + this.expression.toString$0(0) + ")";
            },
            get$span: function(receiver) {
                return this.span;
            }
        };
        A.IfConditionRaw.prototype = {
            get$span: function(_) {
                return this.text.span;
            },
            get$isArbitrarySubstitution: function() {
                return true;
            },
            toInterpolation$1: function(_) {
                return this.text;
            },
            accept$1$1: function(visitor) {
                return visitor.visitIfConditionRaw$1(0, this);
            },
            accept$1: function(visitor) {
                return this.accept$1$1(visitor, type$.dynamic);
            },
            toString$0: function(_) {
                return this.text.toString$0(0);
            }
        };
        A.InterpolatedFunctionExpression.prototype = {
            accept$1$1: function(visitor) {
                return visitor.visitInterpolatedFunctionExpression$1(0, this);
            },
            accept$1: function(visitor) {
                return this.accept$1$1(visitor, type$.dynamic);
            },
            toString$0: function(_) {
                return this.name.toString$0(0) + this.$arguments.toString$0(0);
            },
            get$span: function(receiver) {
                return this.span;
            }
        };
        A.LegacyIfExpression.prototype = {
            get$modernSuggestion: function() {
                var _0_1, ifTrue, ifFalse, t1, condition, _null = null, _0_0 = this.$arguments;
                $label0$0: {
                    _0_1 = _0_0.positional;
                    ifTrue = _null;
                    ifFalse = _null;
                    t1 = false;
                    if (_0_1.length === 3) {
                        condition = _0_1[0];
                        ifTrue = _0_1[1];
                        ifFalse = _0_1[2];
                        t1 = _0_0.named;
                        t1 = t1.get$isEmpty(t1) && _0_0.rest == null;
                    } else condition = _null;
                    if (t1) {
                        if (ifFalse instanceof A.NullExpression) t1 = "if(sass(" + A.S(condition) + "): " + A.S(ifTrue) + ")";
                        else t1 = ifTrue instanceof A.NullExpression ? "if(not sass(" + A.S(condition) + "): " + A.S(ifFalse) + ")" : "if(sass(" + A.S(condition) + "): " + A.S(ifTrue) + "; else: " + A.S(ifFalse) + ")";
                        break $label0$0;
                    }
                    t1 = _null;
                    break $label0$0;
                }
                return t1;
            },
            accept$1$1: function(visitor) {
                return visitor.visitLegacyIfExpression$1(0, this);
            },
            accept$1: function(visitor) {
                return this.accept$1$1(visitor, type$.dynamic);
            },
            toString$0: function(_) {
                return "if" + this.$arguments.toString$0(0);
            },
            get$span: function(receiver) {
                return this.span;
            }
        };
        A.ListExpression.prototype = {
            accept$1$1: function(visitor) {
                return visitor.visitListExpression$1(0, this);
            },
            accept$1: function(visitor) {
                return this.accept$1$1(visitor, type$.dynamic);
            },
            toString$0: function(_) {
                var t2, t3, t4, t5, _this = this, t1 = _this.hasBrackets;
                if (t1) t2 = A.Primitives_stringFromCharCode(91);
                else {
                    t2 = _this.contents.length;
                    if (t2 !== 0) t2 = t2 === 1 && _this.separator === B.ListSeparator_z0K;
                    else t2 = true;
                    t2 = t2 ? A.Primitives_stringFromCharCode(40) : "";
                }
                t3 = _this.contents;
                t4 = _this.separator === B.ListSeparator_z0K;
                t5 = t4 ? ", " : " ";
                t5 = t2 + new A.MappedListIterable(t3, new A.ListExpression_toString_closure(_this), A._arrayInstanceType(t3)._eval$1("MappedListIterable<1,String>")).join$1(0, t5);
                if (t1) t1 = t5 + A.Primitives_stringFromCharCode(93);
                else {
                    t1 = t3.length;
                    if (t1 === 0) t1 = t5 + A.Primitives_stringFromCharCode(41);
                    else t1 = t1 === 1 && t4 ? t5 + ",)" : t5;
                }
                return t1.charCodeAt(0) == 0 ? t1 : t1;
            },
            _list0$_elementNeedsParens$1: function(expression) {
                var childSeparator, t1, _0_13;
                $label0$0: {
                    if (expression instanceof A.ListExpression && expression.contents.length >= 2 && !expression.hasBrackets) {
                        childSeparator = expression.separator;
                        t1 = this.separator === B.ListSeparator_z0K ? childSeparator === B.ListSeparator_z0K : childSeparator !== B.ListSeparator_undecided_null_3_undecided;
                        break $label0$0;
                    }
                    if (expression instanceof A.UnaryOperationExpression) {
                        _0_13 = expression.operator;
                        if (B.UnaryOperator_n2K !== _0_13) t1 = B.UnaryOperator_hCO === _0_13;
                        else t1 = true;
                    } else t1 = false;
                    if (t1) {
                        t1 = this.separator === B.ListSeparator_SrV;
                        break $label0$0;
                    }
                    t1 = false;
                    break $label0$0;
                }
                return t1;
            },
            get$span: function(receiver) {
                return this.span;
            }
        };
        A.ListExpression_toString_closure.prototype = {
            call$1: function(element) {
                return this.$this._list0$_elementNeedsParens$1(element) ? "(" + element.toString$0(0) + ")" : element.toString$0(0);
            },
            $signature: 133
        };
        A.MapExpression.prototype = {
            accept$1$1: function(visitor) {
                return visitor.visitMapExpression$1(0, this);
            },
            accept$1: function(visitor) {
                return this.accept$1$1(visitor, type$.dynamic);
            },
            toString$0: function(_) {
                var t2, t3, _i, t4, t1 = A._setArrayType([], type$.JSArray_String);
                for(t2 = this.pairs, t3 = t2.length, _i = 0; _i < t3; ++_i){
                    t4 = t2[_i];
                    t1.push(t4._0.toString$0(0) + ": " + t4._1.toString$0(0));
                }
                return "(" + B.JSArray_methods.join$1(t1, ", ") + ")";
            },
            get$span: function(receiver) {
                return this.span;
            }
        };
        A.NullExpression.prototype = {
            accept$1$1: function(visitor) {
                return visitor.visitNullExpression$1(0, this);
            },
            accept$1: function(visitor) {
                return this.accept$1$1(visitor, type$.dynamic);
            },
            toString$0: function(_) {
                return "null";
            },
            get$span: function(receiver) {
                return this.span;
            }
        };
        A.NumberExpression.prototype = {
            accept$1$1: function(visitor) {
                return visitor.visitNumberExpression$1(0, this);
            },
            accept$1: function(visitor) {
                return this.accept$1$1(visitor, type$.dynamic);
            },
            toString$0: function(_) {
                return A.serializeValue(A.SassNumber_SassNumber(this.value, this.unit), true, true);
            },
            get$span: function(receiver) {
                return this.span;
            }
        };
        A.ParenthesizedExpression.prototype = {
            accept$1$1: function(visitor) {
                return visitor.visitParenthesizedExpression$1(0, this);
            },
            accept$1: function(visitor) {
                return this.accept$1$1(visitor, type$.dynamic);
            },
            toString$0: function(_) {
                return "(" + this.expression.toString$0(0) + ")";
            },
            get$span: function(receiver) {
                return this.span;
            }
        };
        A.SelectorExpression.prototype = {
            accept$1$1: function(visitor) {
                return visitor.visitSelectorExpression$1(0, this);
            },
            accept$1: function(visitor) {
                return this.accept$1$1(visitor, type$.dynamic);
            },
            toString$0: function(_) {
                return "&";
            },
            get$span: function(receiver) {
                return this.span;
            }
        };
        A.StringExpression.prototype = {
            get$span: function(_) {
                return this.text.span;
            },
            accept$1$1: function(visitor) {
                return visitor.visitStringExpression$1(0, this);
            },
            accept$1: function(visitor) {
                return this.accept$1$1(visitor, type$.dynamic);
            },
            asInterpolation$1$static: function($static) {
                var t1, t2, quote, t3, t4, t5, buffer, t6, t7, i, value, t8;
                if (!this.hasQuotes) return this.text;
                t1 = this.text;
                t2 = t1.contents;
                quote = A.StringExpression__bestQuote(new A.WhereTypeIterable(t2, type$.WhereTypeIterable_String));
                t3 = new A.StringBuffer("");
                t4 = A._setArrayType([], type$.JSArray_Object);
                t5 = A._setArrayType([], type$.JSArray_nullable_FileSpan);
                buffer = new A.InterpolationBuffer(t3, t4, t5);
                t6 = A.Primitives_stringFromCharCode(quote);
                t3._contents += t6;
                for(t7 = t2.length, i = 0; i < t7; ++i){
                    value = t2[i];
                    if (value instanceof A.Expression) {
                        t8 = t1.spanForElement$1(i);
                        buffer._flushText$0();
                        t4.push(value);
                        t5.push(t8);
                        continue;
                    }
                    if (typeof value == "string") A.StringExpression__quoteInnerText(value, quote, buffer, $static);
                }
                t3._contents += t6;
                return buffer.interpolation$1(t1.span);
            },
            asInterpolation$0: function() {
                return this.asInterpolation$1$static(false);
            },
            toString$0: function(_) {
                return this.asInterpolation$0().toString$0(0);
            }
        };
        A.SupportsExpression.prototype = {
            get$span: function(_) {
                var t1 = this.condition;
                return t1.get$span(t1);
            },
            accept$1$1: function(visitor) {
                return visitor.visitSupportsExpression$1(0, this);
            },
            accept$1: function(visitor) {
                return this.accept$1$1(visitor, type$.dynamic);
            },
            toString$0: function(_) {
                return this.condition.toString$0(0);
            }
        };
        A.UnaryOperationExpression.prototype = {
            accept$1$1: function(visitor) {
                return visitor.visitUnaryOperationExpression$1(0, this);
            },
            accept$1: function(visitor) {
                return this.accept$1$1(visitor, type$.dynamic);
            },
            toString$0: function(_) {
                var operand, t1 = this.operator, t2 = t1.operator;
                t1 = t1 === B.UnaryOperator_not_not_3_not ? t2 + A.Primitives_stringFromCharCode(32) : t2;
                operand = this.operand;
                $label0$0: {
                    t2 = true;
                    if (!(operand instanceof A.BinaryOperationExpression)) {
                        if (!(operand instanceof A.UnaryOperationExpression)) t2 = operand instanceof A.ListExpression && !operand.hasBrackets && operand.contents.length >= 2;
                    }
                    break $label0$0;
                }
                if (t2) t1 += "40";
                t1 += operand.toString$0(0);
                if (t2) t1 += "41";
                return t1.charCodeAt(0) == 0 ? t1 : t1;
            },
            get$span: function(receiver) {
                return this.span;
            }
        };
        A.UnaryOperator.prototype = {
            _enumToString$0: function() {
                return "UnaryOperator." + this._name;
            },
            toString$0: function(_) {
                return this.name;
            }
        };
        A.ValueExpression.prototype = {
            accept$1$1: function(visitor) {
                return visitor.visitValueExpression$1(0, this);
            },
            accept$1: function(visitor) {
                return this.accept$1$1(visitor, type$.dynamic);
            },
            toString$0: function(_) {
                return this.value.toString$0(0);
            },
            get$span: function(receiver) {
                return this.span;
            }
        };
        A.VariableExpression.prototype = {
            accept$1$1: function(visitor) {
                return visitor.visitVariableExpression$1(0, this);
            },
            accept$1: function(visitor) {
                return this.accept$1$1(visitor, type$.dynamic);
            },
            toString$0: function(_) {
                return this.span.get$text();
            },
            get$span: function(receiver) {
                return this.span;
            }
        };
        A.DynamicImport.prototype = {
            toString$0: function(_) {
                return A.StringExpression_quoteText(this.urlString);
            },
            $isAstNode: 1,
            $isImport: 1,
            get$span: function(receiver) {
                return this.span;
            }
        };
        A.StaticImport.prototype = {
            toString$0: function(_) {
                var t1 = this.url.toString$0(0), t2 = this.modifiers;
                return t1 + (t2 == null ? "" : " " + t2.toString$0(0));
            },
            $isAstNode: 1,
            $isImport: 1,
            get$span: function(receiver) {
                return this.span;
            }
        };
        A.Interpolation.prototype = {
            get$asPlain: function() {
                var _0_1, t1, _0_6_isSet, _0_6, first, _0_0 = this.contents;
                $label0$0: {
                    _0_1 = _0_0.length;
                    if (_0_1 <= 0) {
                        t1 = "";
                        break $label0$0;
                    }
                    _0_6_isSet = _0_1 === 1;
                    if (_0_6_isSet) {
                        _0_6 = _0_0[0];
                        t1 = typeof _0_6 == "string";
                    } else {
                        _0_6 = null;
                        t1 = false;
                    }
                    if (t1) {
                        first = A._asString(_0_6_isSet ? _0_6 : _0_0[0]);
                        t1 = first;
                        break $label0$0;
                    }
                    t1 = null;
                    break $label0$0;
                }
                return t1;
            },
            get$initialPlain: function() {
                var _0_4_isSet, _0_4, t1, first, _0_0 = this.contents;
                $label0$0: {
                    _0_4_isSet = _0_0.length >= 1;
                    if (_0_4_isSet) {
                        _0_4 = _0_0[0];
                        t1 = typeof _0_4 == "string";
                    } else {
                        _0_4 = null;
                        t1 = false;
                    }
                    if (t1) {
                        first = A._asString(_0_4_isSet ? _0_4 : _0_0[0]);
                        t1 = first;
                        break $label0$0;
                    }
                    t1 = "";
                    break $label0$0;
                }
                return t1;
            },
            spanForElement$1: function(index) {
                var t1, t2, t3, t4, t5, _this = this;
                $label0$0: {
                    if (typeof _this.contents[index] == "string") {
                        t1 = _this.span;
                        t2 = t1.get$file(t1);
                        if (index === 0) t3 = t1.get$start(t1);
                        else {
                            t3 = _this.spans[index - 1];
                            t3 = t3.get$end(t3);
                        }
                        t4 = index + 1;
                        t5 = _this.spans;
                        if (t4 === t5.length) t1 = t1.get$end(t1);
                        else {
                            t1 = t5[t4];
                            t1 = t1.get$start(t1);
                        }
                        t1 = t2.span$2(0, t3.offset, t1.offset);
                        break $label0$0;
                    }
                    t1 = _this.spans[index];
                    t1.toString;
                    break $label0$0;
                }
                return t1;
            },
            Interpolation$3: function(contents, spans, span) {
                var t1, t2, t3, t4, i, t5, isString, _s5_ = "spans", _s8_ = "contents";
                if (spans.length !== J.get$length$asx(contents)) throw A.wrapException(A.ArgumentError$value(this.spans, _s5_, "Must be the same length as contents."));
                for(t1 = this.contents, t2 = t1.length, t3 = spans.length, t4 = this.spans, i = 0; i < t2; ++i){
                    t5 = t1[i];
                    isString = typeof t5 == "string";
                    if (!isString && !(t5 instanceof A.Expression)) throw A.wrapException(A.ArgumentError$value(t1, _s8_, "May only contain Strings or Expressions."));
                    else if (isString) {
                        if (i !== 0 && typeof t1[i - 1] == "string") throw A.wrapException(A.ArgumentError$value(t1, _s8_, "May not contain adjacent Strings."));
                        else if (i < t3 && t4[i] != null) throw A.wrapException(A.ArgumentError$value(t4, _s5_, string$.May_no + i + ")."));
                    } else if (i >= t3 || t4[i] == null) throw A.wrapException(A.ArgumentError$value(t4, _s5_, string$.Must_n + i + ")."));
                }
            },
            toString$0: function(_) {
                var t1 = this.contents;
                return new A.MappedListIterable(t1, new A.Interpolation_toString_closure(), A._arrayInstanceType(t1)._eval$1("MappedListIterable<1,String>")).join$0(0);
            },
            $isAstNode: 1,
            get$span: function(receiver) {
                return this.span;
            }
        };
        A.Interpolation_toString_closure.prototype = {
            call$1: function(value) {
                return typeof value == "string" ? value : "#{" + A.S(value) + "}";
            },
            $signature: 132
        };
        A.Parameter.prototype = {
            toString$0: function(_) {
                var t1 = this.defaultValue, t2 = this.name;
                return t1 == null ? t2 : t2 + ": " + t1.toString$0(0);
            },
            $isAstNode: 1,
            get$span: function(receiver) {
                return this.span;
            }
        };
        A.ParameterList.prototype = {
            get$spanWithName: function() {
                var t2, t3, t1 = this.span, text = A.String_String$fromCharCodes(B.NativeUint32List_methods.sublist$2(t1.get$file(t1)._decodedChars, 0, null), 0, null), i = t1.get$start(t1).offset - 1;
                for(;;){
                    if (i > 0) {
                        t2 = text.charCodeAt(i);
                        t2 = t2 === 32 || t2 === 9 || t2 === 10 || t2 === 13 || t2 === 12;
                    } else t2 = false;
                    if (!t2) break;
                    --i;
                }
                t2 = text.charCodeAt(i);
                if (!(t2 === 95 || A.CharacterExtension_get_isAlphabetic(t2) || t2 >= 128)) t2 = t2 >= 48 && t2 <= 57 || t2 === 45;
                else t2 = true;
                if (!t2) return t1;
                --i;
                for(;;){
                    if (i >= 0) {
                        t2 = text.charCodeAt(i);
                        if (t2 !== 95) {
                            if (!(t2 >= 97 && t2 <= 122)) t3 = t2 >= 65 && t2 <= 90;
                            else t3 = true;
                            t3 = t3 || t2 >= 128;
                        } else t3 = true;
                        if (!t3) t2 = t2 >= 48 && t2 <= 57 || t2 === 45;
                        else t2 = true;
                    } else t2 = false;
                    if (!t2) break;
                    --i;
                }
                t2 = i + 1;
                t3 = text.charCodeAt(t2);
                if (!(t3 === 95 || A.CharacterExtension_get_isAlphabetic(t3) || t3 >= 128)) return t1;
                return A.SpanExtensions_trimRight(A.SpanExtensions_trimLeft(t1.get$file(t1).span$2(0, t2, t1.get$end(t1).offset)));
            },
            verify$2: function(positional, names) {
                var t1, t2, t3, namedUsed, i, parameter, t4, unknownNames, _this = this, _s10_ = "invocation";
                for(t1 = _this.parameters, t2 = t1.length, t3 = names._baseMap, namedUsed = 0, i = 0; i < t2; ++i){
                    parameter = t1[i];
                    if (i < positional) {
                        t4 = parameter.name;
                        if (t3.containsKey$1(t4)) throw A.wrapException(A.SassScriptException$("Argument " + _this._originalParameterName$1(t4) + string$.x20was_p, null));
                    } else {
                        t4 = parameter.name;
                        if (t3.containsKey$1(t4)) ++namedUsed;
                        else if (parameter.defaultValue == null) throw A.wrapException(A.MultiSpanSassScriptException$("Missing argument " + _this._originalParameterName$1(t4) + ".", _s10_, A.LinkedHashMap_LinkedHashMap$_literal([
                            _this.get$spanWithName(),
                            "declaration"
                        ], type$.FileSpan, type$.String)));
                    }
                }
                if (_this.restParameter != null) return;
                if (positional > t2) {
                    t1 = names.get$isEmpty(0) ? "" : "positional ";
                    throw A.wrapException(A.MultiSpanSassScriptException$("Only " + t2 + " " + t1 + A.pluralize("argument", t2, null) + " allowed, but " + positional + " " + A.pluralize("was", positional, "were") + " passed.", _s10_, A.LinkedHashMap_LinkedHashMap$_literal([
                        _this.get$spanWithName(),
                        "declaration"
                    ], type$.FileSpan, type$.String)));
                }
                if (namedUsed < t3.get$length(t3)) {
                    t2 = type$.String;
                    unknownNames = A.LinkedHashSet_LinkedHashSet$of(names, t2);
                    unknownNames.removeAll$1(new A.MappedListIterable(t1, new A.ParameterList_verify_closure(), A._arrayInstanceType(t1)._eval$1("MappedListIterable<1,Object?>")));
                    throw A.wrapException(A.MultiSpanSassScriptException$("No " + A.pluralize("parameter", unknownNames._collection$_length, null) + " named " + A.toSentence(unknownNames.map$1$1(0, new A.ParameterList_verify_closure0(), type$.Object), "or") + ".", _s10_, A.LinkedHashMap_LinkedHashMap$_literal([
                        _this.get$spanWithName(),
                        "declaration"
                    ], type$.FileSpan, t2)));
                }
            },
            _originalParameterName$1: function($name) {
                var text, t1, t2, _i, parameter, end;
                if ($name === this.restParameter) {
                    text = this.span.get$text();
                    return B.JSString_methods.substring$2(B.JSString_methods.substring$1(text, B.JSString_methods.lastIndexOf$1(text, "$")), 0, B.JSString_methods.indexOf$1(text, "."));
                }
                for(t1 = this.parameters, t2 = t1.length, _i = 0; _i < t2; ++_i){
                    parameter = t1[_i];
                    if (parameter.name === $name) {
                        t1 = parameter.span;
                        if (parameter.defaultValue == null) t1 = t1.get$text();
                        else {
                            text = t1.get$text();
                            t1 = B.JSString_methods.substring$2(text, 0, B.JSString_methods.indexOf$1(text, ":"));
                            end = A._lastNonWhitespace(t1, false);
                            t1 = end == null ? "" : B.JSString_methods.substring$2(t1, 0, end + 1);
                        }
                        return t1;
                    }
                }
                throw A.wrapException(A.ArgumentError$(string$.This_d + $name + '".', null));
            },
            matches$2: function(positional, names) {
                var t1, t2, t3, namedUsed, i, parameter;
                for(t1 = this.parameters, t2 = t1.length, t3 = names._baseMap, namedUsed = 0, i = 0; i < t2; ++i){
                    parameter = t1[i];
                    if (i < positional) {
                        if (t3.containsKey$1(parameter.name)) return false;
                    } else if (t3.containsKey$1(parameter.name)) ++namedUsed;
                    else if (parameter.defaultValue == null) return false;
                }
                if (this.restParameter != null) return true;
                if (positional > t2) return false;
                if (namedUsed < t3.get$length(t3)) return false;
                return true;
            },
            toString$0: function(_) {
                var t2, t3, _i, t1 = A._setArrayType([], type$.JSArray_String);
                for(t2 = this.parameters, t3 = t2.length, _i = 0; _i < t3; ++_i)t1.push("$" + t2[_i].toString$0(0));
                t2 = this.restParameter;
                if (t2 != null) t1.push("$" + t2 + "...");
                return B.JSArray_methods.join$1(t1, ", ");
            },
            $isAstNode: 1,
            get$span: function(receiver) {
                return this.span;
            }
        };
        A.ParameterList_verify_closure.prototype = {
            call$1: function(parameter) {
                return parameter.name;
            },
            $signature: 326
        };
        A.ParameterList_verify_closure0.prototype = {
            call$1: function($name) {
                return "$" + $name;
            },
            $signature: 6
        };
        A.Statement.prototype = {
            $isAstNode: 1
        };
        A.AtRootRule.prototype = {
            accept$1$1: function(visitor) {
                return visitor.visitAtRootRule$1(0, this);
            },
            accept$1: function(visitor) {
                return this.accept$1$1(visitor, type$.dynamic);
            },
            toString$0: function(_) {
                var buffer = new A.StringBuffer("@at-root "), t1 = this.query;
                if (t1 != null) buffer._contents = "@at-root " + (t1.toString$0(0) + " ");
                return buffer.toString$0(0) + " {" + B.JSArray_methods.join$1(this.children, " ") + "}";
            },
            get$span: function(receiver) {
                return this.span;
            }
        };
        A.AtRule.prototype = {
            accept$1$1: function(visitor) {
                return visitor.visitAtRule$1(0, this);
            },
            accept$1: function(visitor) {
                return this.accept$1$1(visitor, type$.dynamic);
            },
            toString$0: function(_) {
                var children, t1 = "@" + this.name.toString$0(0), buffer = new A.StringBuffer(t1), t2 = this.value;
                if (t2 != null) buffer._contents = t1 + (" " + t2.toString$0(0));
                children = this.children;
                return children == null ? buffer.toString$0(0) + ";" : buffer.toString$0(0) + " {" + B.JSArray_methods.join$1(children, " ") + "}";
            },
            get$span: function(receiver) {
                return this.span;
            }
        };
        A.CallableDeclaration.prototype = {
            get$span: function(receiver) {
                return this.span;
            }
        };
        A.ContentBlock.prototype = {
            accept$1$1: function(visitor) {
                return visitor.visitContentBlock$1(0, this);
            },
            accept$1: function(visitor) {
                return this.accept$1$1(visitor, type$.dynamic);
            },
            toString$0: function(_) {
                var t1 = this.parameters;
                t1 = t1.parameters.length === 0 && t1.restParameter == null ? "" : " using (" + t1.toString$0(0) + ")";
                return t1 + (" {" + B.JSArray_methods.join$1(this.children, " ") + "}");
            }
        };
        A.ContentRule.prototype = {
            accept$1$1: function(visitor) {
                return visitor.visitContentRule$1(0, this);
            },
            accept$1: function(visitor) {
                return this.accept$1$1(visitor, type$.dynamic);
            },
            toString$0: function(_) {
                var t1 = this.$arguments;
                return t1.get$isEmpty(0) ? "@content;" : "@content(" + t1.toString$0(0) + ");";
            },
            get$span: function(receiver) {
                return this.span;
            }
        };
        A.DebugRule.prototype = {
            accept$1$1: function(visitor) {
                return visitor.visitDebugRule$1(0, this);
            },
            accept$1: function(visitor) {
                return this.accept$1$1(visitor, type$.dynamic);
            },
            toString$0: function(_) {
                return "@debug " + this.expression.toString$0(0) + ";";
            },
            get$span: function(receiver) {
                return this.span;
            }
        };
        A.Declaration.prototype = {
            accept$1$1: function(visitor) {
                return visitor.visitDeclaration$1(0, this);
            },
            accept$1: function(visitor) {
                return this.accept$1$1(visitor, type$.dynamic);
            },
            toString$0: function(_) {
                var t2, _0_0, _this = this, buffer = new A.StringBuffer(""), t1 = _this.name.toString$0(0);
                buffer._contents = t1;
                t1 = buffer._contents = t1 + A.Primitives_stringFromCharCode(58);
                t2 = _this.value;
                if (t2 != null) {
                    if (_this.parsedAsSassScript) t1 = buffer._contents = t1 + A.Primitives_stringFromCharCode(32);
                    buffer._contents = t1 + t2.toString$0(0);
                }
                _0_0 = _this.children;
                if (_0_0 != null) return buffer.toString$0(0) + " {" + B.JSArray_methods.join$1(_0_0, " ") + "}";
                else return buffer.toString$0(0) + ";";
            },
            get$span: function(receiver) {
                return this.span;
            }
        };
        A.EachRule.prototype = {
            accept$1$1: function(visitor) {
                return visitor.visitEachRule$1(0, this);
            },
            accept$1: function(visitor) {
                return this.accept$1$1(visitor, type$.dynamic);
            },
            toString$0: function(_) {
                var t1 = this.variables;
                return "@each " + new A.MappedListIterable(t1, new A.EachRule_toString_closure(), A._arrayInstanceType(t1)._eval$1("MappedListIterable<1,String>")).join$1(0, ", ") + " in " + this.list.toString$0(0) + " {" + B.JSArray_methods.join$1(this.children, " ") + "}";
            },
            get$span: function(receiver) {
                return this.span;
            }
        };
        A.EachRule_toString_closure.prototype = {
            call$1: function(variable) {
                return "$" + variable;
            },
            $signature: 6
        };
        A.ErrorRule.prototype = {
            accept$1$1: function(visitor) {
                return visitor.visitErrorRule$1(0, this);
            },
            accept$1: function(visitor) {
                return this.accept$1$1(visitor, type$.dynamic);
            },
            toString$0: function(_) {
                return "@error " + this.expression.toString$0(0) + ";";
            },
            get$span: function(receiver) {
                return this.span;
            }
        };
        A.ExtendRule.prototype = {
            accept$1$1: function(visitor) {
                return visitor.visitExtendRule$1(0, this);
            },
            accept$1: function(visitor) {
                return this.accept$1$1(visitor, type$.dynamic);
            },
            toString$0: function(_) {
                var t1 = this.selector.toString$0(0), t2 = this.isOptional ? " !optional" : "";
                return "@extend " + t1 + t2 + ";";
            },
            get$span: function(receiver) {
                return this.span;
            }
        };
        A.ForRule.prototype = {
            accept$1$1: function(visitor) {
                return visitor.visitForRule$1(0, this);
            },
            accept$1: function(visitor) {
                return this.accept$1$1(visitor, type$.dynamic);
            },
            toString$0: function(_) {
                var _this = this, t1 = _this.from.toString$0(0), t2 = _this.isExclusive ? "to" : "through";
                return "@for $" + _this.variable + " from " + t1 + " " + t2 + " " + _this.to.toString$0(0) + " {" + B.JSArray_methods.join$1(_this.children, " ") + "}";
            },
            get$span: function(receiver) {
                return this.span;
            }
        };
        A.ForwardRule.prototype = {
            accept$1$1: function(visitor) {
                return visitor.visitForwardRule$1(0, this);
            },
            accept$1: function(visitor) {
                return this.accept$1$1(visitor, type$.dynamic);
            },
            toString$0: function(_) {
                var t2, prefix, _this = this, t1 = "@forward " + A.StringExpression_quoteText(_this.url.toString$0(0)), shownMixinsAndFunctions = _this.shownMixinsAndFunctions, hiddenMixinsAndFunctions = _this.hiddenMixinsAndFunctions;
                if (shownMixinsAndFunctions != null) {
                    t2 = _this.shownVariables;
                    t2.toString;
                    t2 = t1 + " show " + _this._forward_rule$_memberList$2(shownMixinsAndFunctions, t2);
                    t1 = t2;
                } else if (hiddenMixinsAndFunctions != null && hiddenMixinsAndFunctions._base.get$isNotEmpty(0)) {
                    t2 = _this.hiddenVariables;
                    t2.toString;
                    t2 = t1 + " hide " + _this._forward_rule$_memberList$2(hiddenMixinsAndFunctions, t2);
                    t1 = t2;
                }
                prefix = _this.prefix;
                if (prefix != null) t1 += " as " + prefix + "*";
                t2 = _this.configuration;
                t1 = (t2.length !== 0 ? t1 + (" with (" + B.JSArray_methods.join$1(t2, ", ") + ")") : t1) + ";";
                return t1.charCodeAt(0) == 0 ? t1 : t1;
            },
            _forward_rule$_memberList$2: function(mixinsAndFunctions, variables) {
                var t2, t1 = A.List_List$_of(mixinsAndFunctions, type$.String);
                for(t2 = variables._base.get$iterator(0); t2.moveNext$0();)t1.push("$" + t2.get$current(0));
                return B.JSArray_methods.join$1(t1, ", ");
            },
            get$span: function(receiver) {
                return this.span;
            }
        };
        A.FunctionRule.prototype = {
            accept$1$1: function(visitor) {
                return visitor.visitFunctionRule$1(0, this);
            },
            accept$1: function(visitor) {
                return this.accept$1$1(visitor, type$.dynamic);
            },
            toString$0: function(_) {
                return "@function " + this.name + "(" + this.parameters.toString$0(0) + ") {" + B.JSArray_methods.join$1(this.children, " ") + "}";
            }
        };
        A.IfRule.prototype = {
            accept$1$1: function(visitor) {
                return visitor.visitIfRule$1(0, this);
            },
            accept$1: function(visitor) {
                return this.accept$1$1(visitor, type$.dynamic);
            },
            toString$0: function(_) {
                var result = A.ListExtensions_mapIndexed(this.clauses, new A.IfRule_toString_closure(), type$.IfClause, type$.String).join$1(0, " "), lastClause = this.lastClause;
                return lastClause != null ? result + (" " + lastClause.toString$0(0)) : result;
            },
            get$span: function(receiver) {
                return this.span;
            }
        };
        A.IfRule_toString_closure.prototype = {
            call$2: function(index, clause) {
                var t1 = index === 0 ? "if" : "else if";
                return "@" + t1 + " " + clause.expression.toString$0(0) + " {" + B.JSArray_methods.join$1(clause.children, " ") + "}";
            },
            $signature: 397
        };
        A.IfRuleClause.prototype = {};
        A.IfRuleClause$__closure.prototype = {
            call$1: function(child) {
                var t1;
                $label0$0: {
                    if (child instanceof A.VariableDeclaration || child instanceof A.FunctionRule || child instanceof A.MixinRule) {
                        t1 = true;
                        break $label0$0;
                    }
                    if (child instanceof A.ImportRule) {
                        t1 = B.JSArray_methods.any$1(child.imports, new A.IfRuleClause$___closure());
                        break $label0$0;
                    }
                    t1 = false;
                    break $label0$0;
                }
                return t1;
            },
            $signature: 148
        };
        A.IfRuleClause$___closure.prototype = {
            call$1: function($import) {
                return $import instanceof A.DynamicImport;
            },
            $signature: 150
        };
        A.IfClause.prototype = {
            toString$0: function(_) {
                return "@if " + this.expression.toString$0(0) + " {" + B.JSArray_methods.join$1(this.children, " ") + "}";
            }
        };
        A.ElseClause.prototype = {
            toString$0: function(_) {
                return "@else {" + B.JSArray_methods.join$1(this.children, " ") + "}";
            }
        };
        A.ImportRule.prototype = {
            accept$1$1: function(visitor) {
                return visitor.visitImportRule$1(0, this);
            },
            accept$1: function(visitor) {
                return this.accept$1$1(visitor, type$.dynamic);
            },
            toString$0: function(_) {
                return "@import " + B.JSArray_methods.join$1(this.imports, ", ") + ";";
            },
            get$span: function(receiver) {
                return this.span;
            }
        };
        A.IncludeRule.prototype = {
            get$spanWithoutContent: function() {
                var t2, t1 = this.span;
                if (!(this.content == null)) {
                    t2 = this.$arguments.span;
                    t2 = A.SpanExtensions_trimRight(A.SpanExtensions_trimLeft(t1.get$file(t1).span$2(0, t1.get$start(t1).offset, t2.get$end(t2).offset)));
                    t1 = t2;
                }
                return t1;
            },
            get$nameSpan: function() {
                var startSpan, scanner, _null = null, t1 = this.span;
                if (B.JSString_methods.startsWith$1(t1.get$text(), "+")) startSpan = A.SpanExtensions_trimLeft(A.FileSpanExtension_subspan(t1, 1, _null));
                else {
                    scanner = A.StringScanner$(t1.get$text(), _null, _null);
                    scanner.expectChar$1(64);
                    A._scanIdentifier(scanner);
                    startSpan = A.SpanExtensions_trimLeft(A.FileSpanExtension_subspan(t1, scanner._string_scanner$_position, _null));
                }
                if (this.namespace != null) {
                    scanner = A.StringScanner$(startSpan.get$text(), _null, _null);
                    A._scanIdentifier(scanner);
                    startSpan = A.FileSpanExtension_subspan(A.FileSpanExtension_subspan(startSpan, scanner._string_scanner$_position, _null), 1, _null);
                }
                return A.SpanExtensions_initialIdentifier(startSpan);
            },
            accept$1$1: function(visitor) {
                return visitor.visitIncludeRule$1(0, this);
            },
            accept$1: function(visitor) {
                return this.accept$1$1(visitor, type$.dynamic);
            },
            toString$0: function(_) {
                var t2, _this = this, t1 = _this.namespace;
                t1 = t1 != null ? "@include " + (t1 + ".") : "@include ";
                t1 += _this.name;
                t2 = _this.$arguments;
                if (!t2.get$isEmpty(0)) t1 += "(" + t2.toString$0(0) + ")";
                t2 = _this.content;
                t1 += t2 == null ? ";" : " " + t2.toString$0(0);
                return t1.charCodeAt(0) == 0 ? t1 : t1;
            },
            get$span: function(receiver) {
                return this.span;
            }
        };
        A.LoudComment.prototype = {
            get$span: function(_) {
                return this.text.span;
            },
            accept$1$1: function(visitor) {
                return visitor.visitLoudComment$1(0, this);
            },
            accept$1: function(visitor) {
                return this.accept$1$1(visitor, type$.dynamic);
            },
            toString$0: function(_) {
                return this.text.toString$0(0);
            }
        };
        A.MediaRule.prototype = {
            accept$1$1: function(visitor) {
                return visitor.visitMediaRule$1(0, this);
            },
            accept$1: function(visitor) {
                return this.accept$1$1(visitor, type$.dynamic);
            },
            toString$0: function(_) {
                return "@media " + this.query.toString$0(0) + " {" + B.JSArray_methods.join$1(this.children, " ") + "}";
            },
            get$span: function(receiver) {
                return this.span;
            }
        };
        A.MixinRule.prototype = {
            get$hasContent: function() {
                var result, _this = this, value = _this.__MixinRule_hasContent_FI;
                if (value === $) {
                    result = J.$eq$(B.C__HasContentVisitor.visitChildren$1(_this.children), true);
                    _this.__MixinRule_hasContent_FI !== $ && A.throwUnnamedLateFieldADI();
                    _this.__MixinRule_hasContent_FI = result;
                    value = result;
                }
                return value;
            },
            accept$1$1: function(visitor) {
                return visitor.visitMixinRule$1(0, this);
            },
            accept$1: function(visitor) {
                return this.accept$1$1(visitor, type$.dynamic);
            },
            toString$0: function(_) {
                var t1 = "@mixin " + this.name, t2 = this.parameters;
                if (!(t2.parameters.length === 0 && t2.restParameter == null)) t1 += "(" + t2.toString$0(0) + ")";
                t1 += " {" + B.JSArray_methods.join$1(this.children, " ") + "}";
                return t1.charCodeAt(0) == 0 ? t1 : t1;
            }
        };
        A._HasContentVisitor.prototype = {
            visitContentRule$1: function(_, _0) {
                return true;
            }
        };
        A.__HasContentVisitor_Object_StatementSearchVisitor.prototype = {};
        A.ParentStatement.prototype = {};
        A.ParentStatement_closure.prototype = {
            call$1: function(child) {
                var t1;
                $label0$0: {
                    if (child instanceof A.VariableDeclaration || child instanceof A.FunctionRule || child instanceof A.MixinRule) {
                        t1 = true;
                        break $label0$0;
                    }
                    if (child instanceof A.ImportRule) {
                        t1 = B.JSArray_methods.any$1(child.imports, new A.ParentStatement__closure());
                        break $label0$0;
                    }
                    t1 = false;
                    break $label0$0;
                }
                return t1;
            },
            $signature: 148
        };
        A.ParentStatement__closure.prototype = {
            call$1: function($import) {
                return $import instanceof A.DynamicImport;
            },
            $signature: 150
        };
        A.ReturnRule.prototype = {
            accept$1$1: function(visitor) {
                return visitor.visitReturnRule$1(0, this);
            },
            accept$1: function(visitor) {
                return this.accept$1$1(visitor, type$.dynamic);
            },
            toString$0: function(_) {
                return "@return " + this.expression.toString$0(0) + ";";
            },
            get$span: function(receiver) {
                return this.span;
            }
        };
        A.SilentComment.prototype = {
            accept$1$1: function(visitor) {
                return visitor.visitSilentComment$1(0, this);
            },
            accept$1: function(visitor) {
                return this.accept$1$1(visitor, type$.dynamic);
            },
            toString$0: function(_) {
                return this.text;
            },
            get$span: function(receiver) {
                return this.span;
            }
        };
        A.StyleRule.prototype = {
            accept$1$1: function(visitor) {
                return visitor.visitStyleRule$1(0, this);
            },
            accept$1: function(visitor) {
                return this.accept$1$1(visitor, type$.dynamic);
            },
            toString$0: function(_) {
                var t1 = this.selector;
                return A.S(t1 == null ? this.parsedSelector : t1) + " {" + B.JSArray_methods.join$1(this.children, " ") + "}";
            },
            get$span: function(receiver) {
                return this.span;
            }
        };
        A.Stylesheet.prototype = {
            Stylesheet$internal$5$globalVariables$plainCss: function(children, span, parseTimeWarnings, globalVariables, plainCss) {
                var t1, t2, t3, t4, _i, child;
                for(t1 = this.children, t2 = t1.length, t3 = this._forwards, t4 = this._uses, _i = 0; _i < t2; ++_i){
                    child = t1[_i];
                    if (child instanceof A.UseRule) {
                        t4.push(child);
                        continue;
                    }
                    if (child instanceof A.ForwardRule) {
                        t3.push(child);
                        continue;
                    }
                    if (child instanceof A.SilentComment || child instanceof A.LoudComment || child instanceof A.VariableDeclaration) continue;
                    break;
                }
            },
            accept$1$1: function(visitor) {
                return visitor.visitStylesheet$1(0, this);
            },
            accept$1: function(visitor) {
                return this.accept$1$1(visitor, type$.dynamic);
            },
            toString$0: function(_) {
                return B.JSArray_methods.join$1(this.children, " ");
            },
            get$span: function(receiver) {
                return this.span;
            }
        };
        A.SupportsRule.prototype = {
            accept$1$1: function(visitor) {
                return visitor.visitSupportsRule$1(0, this);
            },
            accept$1: function(visitor) {
                return this.accept$1$1(visitor, type$.dynamic);
            },
            toString$0: function(_) {
                return "@supports " + this.condition.toString$0(0) + " {" + B.JSArray_methods.join$1(this.children, " ") + "}";
            },
            get$span: function(receiver) {
                return this.span;
            }
        };
        A.UseRule.prototype = {
            UseRule$4$configuration: function(url, namespace, span, configuration) {
                var t1, t2, _i, variable;
                for(t1 = this.configuration, t2 = t1.length, _i = 0; _i < t2; ++_i){
                    variable = t1[_i];
                    if (variable.isGuarded) throw A.wrapException(A.ArgumentError$value(variable, "configured variable", "can't be guarded in a @use rule."));
                }
            },
            accept$1$1: function(visitor) {
                return visitor.visitUseRule$1(0, this);
            },
            accept$1: function(visitor) {
                return this.accept$1$1(visitor, type$.dynamic);
            },
            toString$0: function(_) {
                var t1 = this.url, t2 = "@use " + A.StringExpression_quoteText(t1.toString$0(0)), basename = t1.get$pathSegments().length === 0 ? "" : B.JSArray_methods.get$last(t1.get$pathSegments()), dot = B.JSString_methods.indexOf$1(basename, ".");
                t1 = this.namespace;
                if (t1 !== B.JSString_methods.substring$2(basename, 0, dot === -1 ? basename.length : dot)) t1 = t2 + (" as " + (t1 == null ? "*" : t1));
                else t1 = t2;
                t2 = this.configuration;
                t1 = (t2.length !== 0 ? t1 + (" with (" + B.JSArray_methods.join$1(t2, ", ") + ")") : t1) + ";";
                return t1.charCodeAt(0) == 0 ? t1 : t1;
            },
            get$span: function(receiver) {
                return this.span;
            }
        };
        A.VariableDeclaration.prototype = {
            accept$1$1: function(visitor) {
                return visitor.visitVariableDeclaration$1(0, this);
            },
            accept$1: function(visitor) {
                return this.accept$1$1(visitor, type$.dynamic);
            },
            toString$0: function(_) {
                var t1 = this.namespace;
                t1 = t1 != null ? t1 + "." : "";
                t1 += "$" + this.name + ": " + this.expression.toString$0(0) + ";";
                return t1.charCodeAt(0) == 0 ? t1 : t1;
            },
            get$span: function(receiver) {
                return this.span;
            }
        };
        A.WarnRule.prototype = {
            accept$1$1: function(visitor) {
                return visitor.visitWarnRule$1(0, this);
            },
            accept$1: function(visitor) {
                return this.accept$1$1(visitor, type$.dynamic);
            },
            toString$0: function(_) {
                return "@warn " + this.expression.toString$0(0) + ";";
            },
            get$span: function(receiver) {
                return this.span;
            }
        };
        A.WhileRule.prototype = {
            accept$1$1: function(visitor) {
                return visitor.visitWhileRule$1(0, this);
            },
            accept$1: function(visitor) {
                return this.accept$1$1(visitor, type$.dynamic);
            },
            toString$0: function(_) {
                return "@while " + this.condition.toString$0(0) + " {" + B.JSArray_methods.join$1(this.children, " ") + "}";
            },
            get$span: function(receiver) {
                return this.span;
            }
        };
        A.SupportsAnything.prototype = {
            withSpan$1: function(span) {
                return new A.SupportsAnything(this.contents, span);
            },
            toString$0: function(_) {
                return "(" + this.contents.toString$0(0) + ")";
            },
            $isAstNode: 1,
            get$span: function(receiver) {
                return this.span;
            }
        };
        A.SupportsDeclaration.prototype = {
            get$isCustomProperty: function() {
                var t1, _0_0 = this.name;
                $label0$0: {
                    if (_0_0 instanceof A.StringExpression && !_0_0.hasQuotes) {
                        t1 = B.JSString_methods.startsWith$1(_0_0.text.get$initialPlain(), "--");
                        break $label0$0;
                    }
                    t1 = false;
                    break $label0$0;
                }
                return t1;
            },
            withSpan$1: function(span) {
                return new A.SupportsDeclaration(this.name, this.value, span);
            },
            toString$0: function(_) {
                return "(" + this.name.toString$0(0) + ": " + this.value.toString$0(0) + ")";
            },
            $isAstNode: 1,
            get$span: function(receiver) {
                return this.span;
            }
        };
        A.SupportsFunction.prototype = {
            withSpan$1: function(span) {
                return new A.SupportsFunction(this.name, this.$arguments, span);
            },
            toString$0: function(_) {
                return this.name.toString$0(0) + "(" + this.$arguments.toString$0(0) + ")";
            },
            $isAstNode: 1,
            get$span: function(receiver) {
                return this.span;
            }
        };
        A.SupportsInterpolation.prototype = {
            withSpan$1: function(span) {
                return new A.SupportsInterpolation(this.expression, span);
            },
            toString$0: function(_) {
                return "#{" + this.expression.toString$0(0) + "}";
            },
            $isAstNode: 1,
            get$span: function(receiver) {
                return this.span;
            }
        };
        A.SupportsNegation.prototype = {
            withSpan$1: function(span) {
                return new A.SupportsNegation(this.condition, span);
            },
            toString$0: function(_) {
                var t1 = this.condition;
                if (t1 instanceof A.SupportsNegation || t1 instanceof A.SupportsOperation) return "not (" + t1.toString$0(0) + ")";
                else return "not " + t1.toString$0(0);
            },
            $isAstNode: 1,
            get$span: function(receiver) {
                return this.span;
            }
        };
        A.SupportsOperation.prototype = {
            withSpan$1: function(span) {
                return new A.SupportsOperation(this.left, this.right, this.operator, span);
            },
            toString$0: function(_) {
                var _this = this;
                return _this._parenthesize$1(_this.left) + " " + _this.operator.toString$0(0) + " " + _this._parenthesize$1(_this.right);
            },
            _parenthesize$1: function(condition) {
                var t1;
                if (!(condition instanceof A.SupportsNegation)) t1 = condition instanceof A.SupportsOperation && condition.operator === this.operator;
                else t1 = true;
                return t1 ? "(" + condition.toString$0(0) + ")" : condition.toString$0(0);
            },
            $isAstNode: 1,
            get$span: function(receiver) {
                return this.span;
            }
        };
        A.Selector.prototype = {
            assertNotBogus$1$name: function($name) {
                if (!this.accept$1(B._IsBogusVisitor_true)) return;
                A.warnForDeprecation("$" + $name + ": " + (this.toString$0(0) + string$.x20is_nov), B.Deprecation_0rM);
            },
            toString$0: function(_) {
                var _null = null, visitor = A._SerializeVisitor$(_null, true, _null, _null, true, false, _null, true);
                this.accept$1(visitor);
                return visitor._serialize$_buffer.toString$0(0);
            },
            $isAstNode: 1,
            get$span: function(receiver) {
                return this.span;
            }
        };
        A._IsInvisibleVisitor0.prototype = {
            visitSelectorList$1: function(list) {
                return B.JSArray_methods.every$1(list.components, this.get$visitComplexSelector());
            },
            visitComplexSelector$1: function(complex) {
                var t1;
                if (!this.super$AnySelectorVisitor$visitComplexSelector(complex)) t1 = this.includeBogus && complex.accept$1(B._IsBogusVisitor_false);
                else t1 = true;
                return t1;
            },
            visitPlaceholderSelector$1: function(_, placeholder) {
                return true;
            },
            visitPseudoSelector$1: function(_, pseudo) {
                var t1, _0_0 = pseudo.selector;
                if (_0_0 != null) {
                    if (pseudo.name === "not") t1 = this.includeBogus && _0_0.accept$1(B._IsBogusVisitor_true);
                    else t1 = this.visitSelectorList$1(_0_0);
                    return t1;
                } else return false;
            }
        };
        A._IsBogusVisitor.prototype = {
            visitComplexSelector$1: function(complex) {
                var t2, t1 = complex.components;
                if (t1.length === 0) return complex.leadingCombinators.length !== 0;
                else {
                    t2 = this.includeLeadingCombinator ? 0 : 1;
                    return complex.leadingCombinators.length > t2 || B.JSArray_methods.get$last(t1).combinators.length !== 0 || B.JSArray_methods.any$1(t1, new A._IsBogusVisitor_visitComplexSelector_closure(this));
                }
            },
            visitPseudoSelector$1: function(_, pseudo) {
                var selector = pseudo.selector;
                if (selector == null) return false;
                return pseudo.name === "has" ? selector.accept$1(B._IsBogusVisitor_false) : selector.accept$1(B._IsBogusVisitor_true);
            }
        };
        A._IsBogusVisitor_visitComplexSelector_closure.prototype = {
            call$1: function(component) {
                return component.combinators.length > 1 || this.$this.visitCompoundSelector$1(component.selector);
            },
            $signature: 54
        };
        A._IsUselessVisitor.prototype = {
            visitComplexSelector$1: function(complex) {
                return complex.leadingCombinators.length > 1 || B.JSArray_methods.any$1(complex.components, new A._IsUselessVisitor_visitComplexSelector_closure(this));
            },
            visitPseudoSelector$1: function(_, pseudo) {
                return pseudo.accept$1(B._IsBogusVisitor_true);
            }
        };
        A._IsUselessVisitor_visitComplexSelector_closure.prototype = {
            call$1: function(component) {
                return component.combinators.length > 1 || this.$this.visitCompoundSelector$1(component.selector);
            },
            $signature: 54
        };
        A._ContainsParentSelectorVisitor.prototype = {
            visitParentSelector$1: function(_, _0) {
                return true;
            }
        };
        A.__ContainsParentSelectorVisitor_Object_AnySelectorVisitor.prototype = {};
        A.__IsBogusVisitor_Object_AnySelectorVisitor.prototype = {};
        A.__IsInvisibleVisitor_Object_AnySelectorVisitor.prototype = {};
        A.__IsUselessVisitor_Object_AnySelectorVisitor.prototype = {};
        A.AttributeSelector.prototype = {
            accept$1$1: function(visitor) {
                return visitor.visitAttributeSelector$1(0, this);
            },
            accept$1: function(visitor) {
                return this.accept$1$1(visitor, type$.dynamic);
            },
            $eq: function(_, other) {
                var _this = this;
                if (other == null) return false;
                return other instanceof A.AttributeSelector && other.name.$eq(0, _this.name) && other.op == _this.op && other.value == _this.value && other.modifier == _this.modifier;
            },
            get$hashCode: function(_) {
                var _this = this, t1 = _this.name;
                return (B.JSString_methods.get$hashCode(t1.name) ^ J.get$hashCode$(t1.namespace) ^ J.get$hashCode$(_this.op) ^ J.get$hashCode$(_this.value) ^ J.get$hashCode$(_this.modifier)) >>> 0;
            }
        };
        A.AttributeOperator.prototype = {
            _enumToString$0: function() {
                return "AttributeOperator." + this._name;
            },
            toString$0: function(_) {
                return this._attribute$_text;
            }
        };
        A.ClassSelector.prototype = {
            $eq: function(_, other) {
                if (other == null) return false;
                return other instanceof A.ClassSelector && other.name === this.name;
            },
            accept$1$1: function(visitor) {
                return visitor.visitClassSelector$1(0, this);
            },
            accept$1: function(visitor) {
                return this.accept$1$1(visitor, type$.dynamic);
            },
            addSuffix$1: function(suffix) {
                return new A.ClassSelector(this.name + suffix, this.span);
            },
            get$hashCode: function(_) {
                return B.JSString_methods.get$hashCode(this.name);
            }
        };
        A.Combinator.prototype = {
            _enumToString$0: function() {
                return "Combinator." + this._name;
            },
            toString$0: function(_) {
                return this._combinator$_text;
            }
        };
        A.ComplexSelector.prototype = {
            get$specificity: function() {
                var result, _this = this, value = _this.__ComplexSelector_specificity_FI;
                if (value === $) {
                    result = B.JSArray_methods.fold$2(_this.components, 0, new A.ComplexSelector_specificity_closure());
                    _this.__ComplexSelector_specificity_FI !== $ && A.throwUnnamedLateFieldADI();
                    _this.__ComplexSelector_specificity_FI = result;
                    value = result;
                }
                return value;
            },
            get$singleCompound: function() {
                var _0_0, t1, _0_4, selector;
                if (this.leadingCombinators.length !== 0) return null;
                _0_0 = this.components;
                $label0$0: {
                    t1 = false;
                    if (_0_0.length === 1) {
                        _0_4 = _0_0[0];
                        selector = _0_4.selector;
                        t1 = _0_4.combinators.length <= 0;
                    } else selector = null;
                    if (t1) {
                        t1 = selector;
                        break $label0$0;
                    }
                    t1 = null;
                    break $label0$0;
                }
                return t1;
            },
            accept$1$1: function(visitor) {
                return visitor.visitComplexSelector$1(this);
            },
            accept$1: function(visitor) {
                return this.accept$1$1(visitor, type$.dynamic);
            },
            isSuperselector$1: function(other) {
                return this.leadingCombinators.length === 0 && other.leadingCombinators.length === 0 && A.complexIsSuperselector(this.components, other.components);
            },
            withAdditionalCombinators$1: function(combinators) {
                var _0_0, _0_1, t1, initial, last, _this = this;
                if (combinators.length === 0) return _this;
                _0_0 = _this.components;
                $label0$0: {
                    _0_1 = _0_0.length;
                    if (_0_1 >= 1) {
                        t1 = _0_1 - 1;
                        initial = B.JSArray_methods.sublist$2(_0_0, 0, t1);
                        last = _0_0[t1];
                        t1 = A.List_List$_of(initial, type$.ComplexSelectorComponent);
                        t1.push(last.withAdditionalCombinators$1(combinators));
                        t1 = A.ComplexSelector$(_this.leadingCombinators, t1, _this.span, _this.lineBreak);
                        break $label0$0;
                    }
                    if (_0_1 <= 0) {
                        t1 = A.List_List$_of(_this.leadingCombinators, type$.CssValue_Combinator);
                        B.JSArray_methods.addAll$1(t1, combinators);
                        t1 = A.ComplexSelector$(t1, B.List_empty2, _this.span, _this.lineBreak);
                        break $label0$0;
                    }
                    t1 = null;
                }
                return t1;
            },
            concatenate$3$forceLineBreak: function(child, span, forceLineBreak) {
                var t2, _0_1, initial, last, _this = this, t1 = child.leadingCombinators, _0_0 = _this.components;
                if (t1.length === 0) {
                    t1 = A.List_List$_of(_0_0, type$.ComplexSelectorComponent);
                    B.JSArray_methods.addAll$1(t1, child.components);
                    t2 = _this.lineBreak || child.lineBreak || forceLineBreak;
                    return A.ComplexSelector$(_this.leadingCombinators, t1, span, t2);
                } else {
                    _0_1 = _0_0.length;
                    if (_0_1 >= 1) {
                        t2 = _0_1 - 1;
                        initial = B.JSArray_methods.sublist$2(_0_0, 0, t2);
                        last = _0_0[t2];
                        t2 = A.List_List$_of(initial, type$.ComplexSelectorComponent);
                        t2.push(last.withAdditionalCombinators$1(t1));
                        B.JSArray_methods.addAll$1(t2, child.components);
                        t1 = _this.lineBreak || child.lineBreak || forceLineBreak;
                        return A.ComplexSelector$(_this.leadingCombinators, t2, span, t1);
                    } else {
                        t2 = A.List_List$_of(_this.leadingCombinators, type$.CssValue_Combinator);
                        B.JSArray_methods.addAll$1(t2, t1);
                        t1 = _this.lineBreak || child.lineBreak || forceLineBreak;
                        return A.ComplexSelector$(t2, child.components, span, t1);
                    }
                }
            },
            concatenate$2: function(child, span) {
                return this.concatenate$3$forceLineBreak(child, span, false);
            },
            get$hashCode: function(_) {
                return B.C_ListEquality0.hash$1(this.leadingCombinators) ^ B.C_ListEquality0.hash$1(this.components);
            },
            $eq: function(_, other) {
                if (other == null) return false;
                return other instanceof A.ComplexSelector && B.C_ListEquality.equals$2(0, this.leadingCombinators, other.leadingCombinators) && B.C_ListEquality.equals$2(0, this.components, other.components);
            }
        };
        A.ComplexSelector_specificity_closure.prototype = {
            call$2: function(sum, component) {
                return sum + component.selector.get$specificity();
            },
            $signature: 356
        };
        A.ComplexSelectorComponent.prototype = {
            withAdditionalCombinators$1: function(combinators) {
                var t1, t2, _this = this;
                if (combinators.length === 0) t1 = _this;
                else {
                    t1 = type$.CssValue_Combinator;
                    t2 = A.List_List$_of(_this.combinators, t1);
                    B.JSArray_methods.addAll$1(t2, combinators);
                    t1 = new A.ComplexSelectorComponent(_this.selector, A.List_List$unmodifiable(t2, t1), _this.span);
                }
                return t1;
            },
            get$hashCode: function(_) {
                return B.C_ListEquality0.hash$1(this.selector.components) ^ B.C_ListEquality0.hash$1(this.combinators);
            },
            $eq: function(_, other) {
                var t1;
                if (other == null) return false;
                if (other instanceof A.ComplexSelectorComponent) {
                    t1 = B.C_ListEquality.equals$2(0, this.selector.components, other.selector.components);
                    t1 = t1 && B.C_ListEquality.equals$2(0, this.combinators, other.combinators);
                } else t1 = false;
                return t1;
            },
            toString$0: function(_) {
                var t1 = this.combinators;
                return A.serializeSelector(this.selector, true) + new A.MappedListIterable(t1, new A.ComplexSelectorComponent_toString_closure(), A._arrayInstanceType(t1)._eval$1("MappedListIterable<1,String>")).join$1(0, "");
            }
        };
        A.ComplexSelectorComponent_toString_closure.prototype = {
            call$1: function(combinator) {
                return " " + combinator.toString$0(0);
            },
            $signature: 393
        };
        A.CompoundSelector.prototype = {
            get$specificity: function() {
                var result, _this = this, value = _this.__CompoundSelector_specificity_FI;
                if (value === $) {
                    result = B.JSArray_methods.fold$2(_this.components, 0, new A.CompoundSelector_specificity_closure());
                    _this.__CompoundSelector_specificity_FI !== $ && A.throwUnnamedLateFieldADI();
                    _this.__CompoundSelector_specificity_FI = result;
                    value = result;
                }
                return value;
            },
            get$hasComplicatedSuperselectorSemantics: function() {
                var result, _this = this, value = _this.__CompoundSelector_hasComplicatedSuperselectorSemantics_FI;
                if (value === $) {
                    result = B.JSArray_methods.any$1(_this.components, new A.CompoundSelector_hasComplicatedSuperselectorSemantics_closure());
                    _this.__CompoundSelector_hasComplicatedSuperselectorSemantics_FI !== $ && A.throwUnnamedLateFieldADI();
                    _this.__CompoundSelector_hasComplicatedSuperselectorSemantics_FI = result;
                    value = result;
                }
                return value;
            },
            accept$1$1: function(visitor) {
                return visitor.visitCompoundSelector$1(this);
            },
            accept$1: function(visitor) {
                return this.accept$1$1(visitor, type$.dynamic);
            },
            get$hashCode: function(_) {
                return B.C_ListEquality0.hash$1(this.components);
            },
            $eq: function(_, other) {
                if (other == null) return false;
                return other instanceof A.CompoundSelector && B.C_ListEquality.equals$2(0, this.components, other.components);
            }
        };
        A.CompoundSelector_specificity_closure.prototype = {
            call$2: function(sum, component) {
                return sum + component.get$specificity();
            },
            $signature: 446
        };
        A.CompoundSelector_hasComplicatedSuperselectorSemantics_closure.prototype = {
            call$1: function(component) {
                return component.get$hasComplicatedSuperselectorSemantics();
            },
            $signature: 14
        };
        A.IDSelector.prototype = {
            get$specificity: function() {
                return A._asInt(Math.pow(A.SimpleSelector.prototype.get$specificity.call(this), 2));
            },
            accept$1$1: function(visitor) {
                return visitor.visitIDSelector$1(0, this);
            },
            accept$1: function(visitor) {
                return this.accept$1$1(visitor, type$.dynamic);
            },
            addSuffix$1: function(suffix) {
                return new A.IDSelector(this.name + suffix, this.span);
            },
            unify$1: function(compound) {
                if (B.JSArray_methods.any$1(compound, new A.IDSelector_unify_closure(this))) return null;
                return this.super$SimpleSelector$unify(compound);
            },
            $eq: function(_, other) {
                if (other == null) return false;
                return other instanceof A.IDSelector && other.name === this.name;
            },
            get$hashCode: function(_) {
                return B.JSString_methods.get$hashCode(this.name);
            }
        };
        A.IDSelector_unify_closure.prototype = {
            call$1: function(simple) {
                var t1;
                if (simple instanceof A.IDSelector) t1 = this.$this.name !== simple.name;
                else t1 = false;
                return t1;
            },
            $signature: 14
        };
        A.SelectorList.prototype = {
            get$asSassList: function() {
                var t1 = this.components;
                return A.SassList$(new A.MappedListIterable(t1, new A.SelectorList_asSassList_closure(), A._arrayInstanceType(t1)._eval$1("MappedListIterable<1,Value>")), B.ListSeparator_z0K, false);
            },
            accept$1$1: function(visitor) {
                return visitor.visitSelectorList$1(this);
            },
            accept$1: function(visitor) {
                return this.accept$1$1(visitor, type$.dynamic);
            },
            unify$1: function(other) {
                var t3, t4, t5, t6, _i, complex1, t7, _i0, t8, t1 = type$.JSArray_ComplexSelector, t2 = A._setArrayType([], t1);
                for(t3 = this.components, t4 = t3.length, t5 = other.components, t6 = t5.length, _i = 0; _i < t4; ++_i){
                    complex1 = t3[_i];
                    for(t7 = complex1.span, _i0 = 0; _i0 < t6; ++_i0){
                        t8 = A.unifyComplex(A._setArrayType([
                            complex1,
                            t5[_i0]
                        ], t1), t7);
                        if (t8 != null) B.JSArray_methods.addAll$1(t2, t8);
                    }
                }
                return t2.length === 0 ? null : A.SelectorList$(t2, this.span);
            },
            nestWithin$3$implicitParent$preserveParentSelectors: function($parent, implicitParent, preserveParentSelectors) {
                var _0_0, t1, _this = this;
                if ($parent == null) {
                    if (preserveParentSelectors) return _this;
                    _0_0 = B.C__ParentSelectorVisitor.visitSelectorList$1(_this);
                    if (_0_0 instanceof A.ParentSelector) t1 = _0_0.suffix != null;
                    else t1 = false;
                    if (t1) throw A.wrapException(A.SassException$(string$.A_top_, _0_0.span, null));
                    return _this;
                }
                t1 = _this.components;
                return A.SelectorList$(A.flattenVertically(new A.MappedListIterable(t1, new A.SelectorList_nestWithin_closure(_this, preserveParentSelectors, implicitParent, $parent), A._arrayInstanceType(t1)._eval$1("MappedListIterable<1,Iterable<ComplexSelector>>")), type$.ComplexSelector), _this.span);
            },
            nestWithin$1: function($parent) {
                return this.nestWithin$3$implicitParent$preserveParentSelectors($parent, true, false);
            },
            nestWithin$2$implicitParent: function($parent, implicitParent) {
                return this.nestWithin$3$implicitParent$preserveParentSelectors($parent, implicitParent, false);
            },
            _nestWithinCompound$2: function(component, $parent) {
                var resolvedSimples, parentSelector, error, stackTrace, t2, resolvedSimples0, _$exception, t1 = component.selector, simples = t1.components, containsSelectorPseudo = J.any$1$ax(simples, new A.SelectorList__nestWithinCompound_closure());
                if (!containsSelectorPseudo && !(J.get$first$ax(simples) instanceof A.ParentSelector)) return null;
                if (containsSelectorPseudo) {
                    t2 = simples;
                    resolvedSimples0 = new A.MappedListIterable(t2, new A.SelectorList__nestWithinCompound_closure0($parent), A._arrayInstanceType(t2)._eval$1("MappedListIterable<1,SimpleSelector>"));
                } else resolvedSimples0 = simples;
                resolvedSimples = resolvedSimples0;
                parentSelector = J.get$first$ax(simples);
                try {
                    if (!(parentSelector instanceof A.ParentSelector)) {
                        t2 = component.span;
                        t2 = A._setArrayType([
                            A.ComplexSelector$(B.List_empty0, A._setArrayType([
                                new A.ComplexSelectorComponent(A.CompoundSelector$(resolvedSimples, t1.span), A.List_List$unmodifiable(component.combinators, type$.CssValue_Combinator), t2)
                            ], type$.JSArray_ComplexSelectorComponent), t2, false)
                        ], type$.JSArray_ComplexSelector);
                        return t2;
                    } else if (J.get$length$asx(simples) === 1 && parentSelector.suffix == null) {
                        t1 = $parent.withAdditionalCombinators$1(component.combinators);
                        return t1.components;
                    }
                } catch (exception) {
                    t1 = A.unwrapException(exception);
                    if (t1 instanceof A.SassException) {
                        error = t1;
                        stackTrace = A.getTraceFromException(exception);
                        A.throwWithTrace(error.withAdditionalSpan$2(parentSelector.span, "parent selector"), error, stackTrace);
                    } else throw exception;
                }
                t1 = $parent.components;
                return new A.MappedListIterable(t1, new A.SelectorList__nestWithinCompound_closure1(parentSelector, resolvedSimples, component), A._arrayInstanceType(t1)._eval$1("MappedListIterable<1,ComplexSelector>"));
            },
            isSuperselector$1: function(other) {
                return A.listIsSuperselector(this.components, other.components);
            },
            withAdditionalCombinators$1: function(combinators) {
                var t1;
                if (combinators.length === 0) t1 = this;
                else {
                    t1 = this.components;
                    t1 = A.SelectorList$(new A.MappedListIterable(t1, new A.SelectorList_withAdditionalCombinators_closure(combinators), A._arrayInstanceType(t1)._eval$1("MappedListIterable<1,ComplexSelector>")), this.span);
                }
                return t1;
            },
            get$hashCode: function(_) {
                return B.C_ListEquality0.hash$1(this.components);
            },
            $eq: function(_, other) {
                if (other == null) return false;
                return other instanceof A.SelectorList && B.C_ListEquality.equals$2(0, this.components, other.components);
            }
        };
        A.SelectorList_asSassList_closure.prototype = {
            call$1: function(complex) {
                var t3, t4, _i, component, visitor, t5, t6, t7, _i0, _null = null, t1 = type$.JSArray_Value, t2 = A._setArrayType([], t1);
                for(t3 = complex.leadingCombinators, t4 = t3.length, _i = 0; _i < t4; ++_i)t2.push(new A.SassString(J.toString$0$(t3[_i].value), false));
                for(t3 = complex.components, t4 = t3.length, _i = 0; _i < t4; ++_i){
                    component = t3[_i];
                    visitor = A._SerializeVisitor$(_null, true, _null, _null, true, false, _null, true);
                    component.selector.accept$1(visitor);
                    t5 = A._setArrayType([
                        new A.SassString(visitor._serialize$_buffer.toString$0(0), false)
                    ], t1);
                    for(t6 = component.combinators, t7 = t6.length, _i0 = 0; _i0 < t7; ++_i0)t5.push(new A.SassString(J.toString$0$(t6[_i0].value), false));
                    B.JSArray_methods.addAll$1(t2, t5);
                }
                return A.SassList$(t2, B.ListSeparator_SrV, false);
            },
            $signature: 329
        };
        A.SelectorList_nestWithin_closure.prototype = {
            call$1: function(complex) {
                var t1, newComplexes, t2, t3, t4, t5, t6, t7, t8, t9, t10, t11, _i, component, resolved, i, t12, t13, t14, _i0, newComplex, t15, t16, _this = this;
                if (_this.preserveParentSelectors || complex.accept$1(B.C__ParentSelectorVisitor) == null) {
                    if (!_this.implicitParent) return A._setArrayType([
                        complex
                    ], type$.JSArray_ComplexSelector);
                    t1 = _this.parent.components;
                    return new A.MappedListIterable(t1, new A.SelectorList_nestWithin__closure(complex), A._arrayInstanceType(t1)._eval$1("MappedListIterable<1,ComplexSelector>"));
                }
                t1 = type$.JSArray_ComplexSelector;
                newComplexes = A._setArrayType([], t1);
                for(t2 = complex.components, t3 = t2.length, t4 = _this.$this, t5 = _this.parent, t6 = type$.ComplexSelector, t7 = complex.leadingCombinators, t8 = t7.length === 0, t9 = complex.span, t10 = type$.ComplexSelectorComponent, t11 = type$.JSArray_ComplexSelectorComponent, _i = 0; _i < t3; ++_i){
                    component = t2[_i];
                    resolved = t4._nestWithinCompound$2(component, t5);
                    if (resolved == null) {
                        if (newComplexes.length === 0) newComplexes.push(A.ComplexSelector$(t7, A._setArrayType([
                            component
                        ], t11), t9, false));
                        else for(i = 0; i < newComplexes.length; ++i){
                            t12 = newComplexes[i];
                            t13 = A.List_List$_of(t12.components, t10);
                            t13.push(component);
                            newComplexes[i] = A.ComplexSelector$(t12.leadingCombinators, t13, t9, t12.lineBreak);
                        }
                    } else if (newComplexes.length === 0) B.JSArray_methods.addAll$1(newComplexes, t8 ? resolved : J.map$1$1$ax(resolved, new A.SelectorList_nestWithin__closure0(complex), t6));
                    else {
                        t12 = A._setArrayType([], t1);
                        for(t13 = newComplexes.length, t14 = J.getInterceptor$ax(resolved), _i0 = 0; _i0 < newComplexes.length; newComplexes.length === t13 || (0, A.throwConcurrentModificationError)(newComplexes), ++_i0){
                            newComplex = newComplexes[_i0];
                            for(t15 = t14.get$iterator(resolved), t16 = newComplex.span; t15.moveNext$0();)t12.push(newComplex.concatenate$2(t15.get$current(t15), t16));
                        }
                        newComplexes = t12;
                    }
                }
                return newComplexes;
            },
            $signature: 346
        };
        A.SelectorList_nestWithin__closure.prototype = {
            call$1: function(parentComplex) {
                var t1 = this.complex;
                return parentComplex.concatenate$2(t1, t1.span);
            },
            $signature: 61
        };
        A.SelectorList_nestWithin__closure0.prototype = {
            call$1: function(resolvedComplex) {
                var t1 = resolvedComplex.leadingCombinators, t2 = this.complex, t3 = t2.leadingCombinators;
                if (t1.length === 0) t1 = t3;
                else {
                    t3 = A.List_List$_of(t3, type$.CssValue_Combinator);
                    B.JSArray_methods.addAll$1(t3, t1);
                    t1 = t3;
                }
                return A.ComplexSelector$(t1, resolvedComplex.components, t2.span, resolvedComplex.lineBreak);
            },
            $signature: 61
        };
        A.SelectorList__nestWithinCompound_closure.prototype = {
            call$1: function(simple) {
                var selector;
                if (!(simple instanceof A.PseudoSelector)) return false;
                selector = simple.selector;
                return selector != null && selector.accept$1(B.C__ParentSelectorVisitor) != null;
            },
            $signature: 14
        };
        A.SelectorList__nestWithinCompound_closure0.prototype = {
            call$1: function(simple) {
                var selector, t1, _0_2;
                $label0$0: {
                    selector = null;
                    t1 = false;
                    if (simple instanceof A.PseudoSelector) {
                        _0_2 = simple.selector;
                        if (_0_2 != null) {
                            selector = _0_2 == null ? type$.SelectorList._as(_0_2) : _0_2;
                            t1 = selector.accept$1(B.C__ParentSelectorVisitor) != null;
                        }
                    }
                    if (t1) {
                        t1 = simple.withSelector$1(selector.nestWithin$2$implicitParent(this.parent, false));
                        break $label0$0;
                    }
                    t1 = simple;
                    break $label0$0;
                }
                return t1;
            },
            $signature: 367
        };
        A.SelectorList__nestWithinCompound_closure1.prototype = {
            call$1: function(complex) {
                var lastComponent, suffix, lastSimples, t1, t2, last, t3, error, stackTrace, t4, t5, _$exception, _this = this;
                try {
                    t4 = complex.components;
                    lastComponent = B.JSArray_methods.get$last(t4);
                    if (lastComponent.combinators.length !== 0) {
                        t1 = A.MultiSpanSassException$('Selector "' + complex.toString$0(0) + string$.x22x20can_, A.SpanExtensions_trimRight(lastComponent.span), "outer selector", A.LinkedHashMap_LinkedHashMap$_literal([
                            _this.parentSelector.span,
                            "parent selector"
                        ], type$.FileSpan, type$.String), null);
                        throw A.wrapException(t1);
                    }
                    suffix = _this.parentSelector.suffix;
                    lastSimples = lastComponent.selector.components;
                    t5 = type$.SimpleSelector;
                    if (suffix == null) {
                        t2 = A.List_List$_of(lastSimples, t5);
                        t1 = t2;
                        J.addAll$1$ax(t1, J.skip$1$ax(_this.resolvedSimples, 1));
                        t1;
                    } else {
                        t1 = A.List_List$_of(A.IterableExtension_get_exceptLast(lastSimples), t5);
                        t2 = t1;
                        J.add$1$ax(t2, J.get$last$ax(lastSimples).addSuffix$1(suffix));
                        J.addAll$1$ax(t2, J.skip$1$ax(_this.resolvedSimples, 1));
                        t1 = t2;
                    }
                    t2 = _this.component;
                    last = A.CompoundSelector$(t1, t2.selector.span);
                    t1 = A.List_List$_of(A.IterableExtension_get_exceptLast(t4), type$.ComplexSelectorComponent);
                    t3 = t1;
                    t1 = t2.span;
                    J.add$1$ax(t3, new A.ComplexSelectorComponent(last, A.List_List$unmodifiable(t2.combinators, type$.CssValue_Combinator), t1));
                    t1 = A.ComplexSelector$(complex.leadingCombinators, t3, t1, complex.lineBreak);
                    return t1;
                } catch (exception) {
                    t1 = A.unwrapException(exception);
                    if (t1 instanceof A.SassException) {
                        error = t1;
                        stackTrace = A.getTraceFromException(exception);
                        A.throwWithTrace(error.withAdditionalSpan$2(_this.parentSelector.span, "parent selector"), error, stackTrace);
                    } else throw exception;
                }
            },
            $signature: 61
        };
        A.SelectorList_withAdditionalCombinators_closure.prototype = {
            call$1: function(complex) {
                return complex.withAdditionalCombinators$1(this.combinators);
            },
            $signature: 61
        };
        A._ParentSelectorVisitor.prototype = {
            visitParentSelector$1: function(_, selector) {
                return selector;
            }
        };
        A.__ParentSelectorVisitor_Object_SelectorSearchVisitor.prototype = {};
        A.ParentSelector.prototype = {
            accept$1$1: function(visitor) {
                return visitor.visitParentSelector$1(0, this);
            },
            accept$1: function(visitor) {
                return this.accept$1$1(visitor, type$.dynamic);
            },
            unify$1: function(compound) {
                return A.throwExpression(A.UnsupportedError$("& doesn't support unification."));
            }
        };
        A.PlaceholderSelector.prototype = {
            accept$1$1: function(visitor) {
                return visitor.visitPlaceholderSelector$1(0, this);
            },
            accept$1: function(visitor) {
                return this.accept$1$1(visitor, type$.dynamic);
            },
            addSuffix$1: function(suffix) {
                return new A.PlaceholderSelector(this.name + suffix, this.span);
            },
            $eq: function(_, other) {
                if (other == null) return false;
                return other instanceof A.PlaceholderSelector && other.name === this.name;
            },
            get$hashCode: function(_) {
                return B.JSString_methods.get$hashCode(this.name);
            }
        };
        A.PseudoSelector.prototype = {
            get$isHostContext: function() {
                return this.isClass && this.name === "host-context" && this.selector != null;
            },
            get$hasComplicatedSuperselectorSemantics: function() {
                return !this.isClass || this.selector != null;
            },
            get$specificity: function() {
                var result, _this = this, value = _this.__PseudoSelector_specificity_FI;
                if (value === $) {
                    result = new A.PseudoSelector_specificity_closure(_this).call$0();
                    _this.__PseudoSelector_specificity_FI !== $ && A.throwUnnamedLateFieldADI();
                    _this.__PseudoSelector_specificity_FI = result;
                    value = result;
                }
                return value;
            },
            withSelector$1: function(selector) {
                var _this = this;
                return A.PseudoSelector$(_this.name, _this.span, _this.argument, !_this.isClass, selector);
            },
            addSuffix$1: function(suffix) {
                var _this = this;
                if (_this.argument != null || _this.selector != null) _this.super$SimpleSelector$addSuffix(suffix);
                return A.PseudoSelector$(_this.name + suffix, _this.span, null, !_this.isClass, null);
            },
            unify$1: function(compound) {
                var other, result, t2, addedThis, _i, simple, _this = this, t1 = _this.name;
                if (t1 === "host" || t1 === "host-context") {
                    if (!B.JSArray_methods.every$1(compound, new A.PseudoSelector_unify_closure())) return null;
                } else {
                    t1 = false;
                    if (compound.length === 1) {
                        other = compound[0];
                        if (!(other instanceof A.UniversalSelector)) {
                            if (other instanceof A.PseudoSelector) t1 = other.isClass && other.name === "host" || other.get$isHostContext();
                        } else t1 = true;
                    } else other = null;
                    if (t1) return other.unify$1(A._setArrayType([
                        _this
                    ], type$.JSArray_SimpleSelector));
                }
                if (B.JSArray_methods.contains$1(compound, _this)) return compound;
                result = A._setArrayType([], type$.JSArray_SimpleSelector);
                for(t1 = compound.length, t2 = !_this.isClass, addedThis = false, _i = 0; _i < compound.length; compound.length === t1 || (0, A.throwConcurrentModificationError)(compound), ++_i){
                    simple = compound[_i];
                    if (simple instanceof A.PseudoSelector && !simple.isClass) {
                        if (t2) return null;
                        result.push(_this);
                        addedThis = true;
                    }
                    result.push(simple);
                }
                if (!addedThis) result.push(_this);
                return result;
            },
            isSuperselector$1: function(other) {
                var selector, t1, t2, _this = this;
                if (_this.super$SimpleSelector$isSuperselector(other)) return true;
                selector = _this.selector;
                if (selector == null) return _this.$eq(0, other);
                if (other instanceof A.PseudoSelector && !_this.isClass && !other.isClass && _this.normalizedName === "slotted" && other.name === _this.name) {
                    t1 = A.NullableExtension_andThen(other.selector, selector.get$isSuperselector());
                    return t1 == null ? false : t1;
                }
                t1 = type$.JSArray_SimpleSelector;
                t2 = _this.span;
                return A.compoundIsSuperselector(A.CompoundSelector$(A._setArrayType([
                    _this
                ], t1), t2), A.CompoundSelector$(A._setArrayType([
                    other
                ], t1), t2), null);
            },
            accept$1$1: function(visitor) {
                return visitor.visitPseudoSelector$1(0, this);
            },
            accept$1: function(visitor) {
                return this.accept$1$1(visitor, type$.dynamic);
            },
            $eq: function(_, other) {
                var _this = this;
                if (other == null) return false;
                return other instanceof A.PseudoSelector && other.name === _this.name && other.isClass === _this.isClass && other.argument == _this.argument && J.$eq$(other.selector, _this.selector);
            },
            get$hashCode: function(_) {
                var _this = this, t1 = B.JSString_methods.get$hashCode(_this.name), t2 = !_this.isClass ? 519018 : 218159;
                return t1 ^ t2 ^ J.get$hashCode$(_this.argument) ^ J.get$hashCode$(_this.selector);
            }
        };
        A.PseudoSelector_specificity_closure.prototype = {
            call$0: function() {
                var selector, t2, t1 = this.$this;
                if (!t1.isClass) return 1;
                selector = t1.selector;
                if (selector == null) return A.SimpleSelector.prototype.get$specificity.call(t1);
                switch(t1.normalizedName){
                    case "where":
                        return 0;
                    case "is":
                    case "not":
                    case "has":
                    case "matches":
                        t1 = selector.components;
                        return A.IterableIntegerExtension_get_max(new A.MappedListIterable(t1, new A.PseudoSelector_specificity__closure(), A._arrayInstanceType(t1)._eval$1("MappedListIterable<1,int>")));
                    case "nth-child":
                    case "nth-last-child":
                        t1 = A.SimpleSelector.prototype.get$specificity.call(t1);
                        t2 = selector.components;
                        return t1 + A.IterableIntegerExtension_get_max(new A.MappedListIterable(t2, new A.PseudoSelector_specificity__closure0(), A._arrayInstanceType(t2)._eval$1("MappedListIterable<1,int>")));
                    default:
                        return A.SimpleSelector.prototype.get$specificity.call(t1);
                }
            },
            $signature: 10
        };
        A.PseudoSelector_specificity__closure.prototype = {
            call$1: function(component) {
                return component.get$specificity();
            },
            $signature: 171
        };
        A.PseudoSelector_specificity__closure0.prototype = {
            call$1: function(component) {
                return component.get$specificity();
            },
            $signature: 171
        };
        A.PseudoSelector_unify_closure.prototype = {
            call$1: function(simple) {
                var t1;
                if (simple instanceof A.PseudoSelector) t1 = simple.isClass && simple.name === "host" || simple.selector != null;
                else t1 = false;
                return t1;
            },
            $signature: 14
        };
        A.QualifiedName.prototype = {
            $eq: function(_, other) {
                if (other == null) return false;
                return other instanceof A.QualifiedName && other.name === this.name && other.namespace == this.namespace;
            },
            get$hashCode: function(_) {
                return B.JSString_methods.get$hashCode(this.name) ^ J.get$hashCode$(this.namespace);
            },
            toString$0: function(_) {
                var t1 = this.namespace, t2 = this.name;
                return t1 == null ? t2 : t1 + "|" + t2;
            }
        };
        A.SimpleSelector.prototype = {
            get$specificity: function() {
                return 1000;
            },
            get$hasComplicatedSuperselectorSemantics: function() {
                return false;
            },
            addSuffix$1: function(suffix) {
                return A.throwExpression(A.MultiSpanSassException$('Selector "' + this.toString$0(0) + "\" can't have a suffix", this.span, "outer selector", A.LinkedHashMap_LinkedHashMap$_empty(type$.FileSpan, type$.String), null));
            },
            unify$1: function(compound) {
                var other, result, addedThis, _i, simple, _this = this, t1 = false;
                if (compound.length === 1) {
                    other = compound[0];
                    if (!(other instanceof A.UniversalSelector)) {
                        if (other instanceof A.PseudoSelector) t1 = other.isClass && other.name === "host" || other.get$isHostContext();
                    } else t1 = true;
                } else other = null;
                if (t1) return other.unify$1(A._setArrayType([
                    _this
                ], type$.JSArray_SimpleSelector));
                if (B.JSArray_methods.contains$1(compound, _this)) return compound;
                result = A._setArrayType([], type$.JSArray_SimpleSelector);
                for(t1 = compound.length, addedThis = false, _i = 0; _i < compound.length; compound.length === t1 || (0, A.throwConcurrentModificationError)(compound), ++_i){
                    simple = compound[_i];
                    if (!addedThis && simple instanceof A.PseudoSelector) {
                        result.push(_this);
                        addedThis = true;
                    }
                    result.push(simple);
                }
                if (!addedThis) result.push(_this);
                return result;
            },
            isSuperselector$1: function(other) {
                var list;
                if (this.$eq(0, other)) return true;
                if (other instanceof A.PseudoSelector && other.isClass) {
                    list = other.selector;
                    if (list != null && $._subselectorPseudos.contains$1(0, other.normalizedName)) return B.JSArray_methods.every$1(list.components, new A.SimpleSelector_isSuperselector_closure(this));
                }
                return false;
            }
        };
        A.SimpleSelector_isSuperselector_closure.prototype = {
            call$1: function(complex) {
                var t1 = complex.components;
                return t1.length !== 0 && B.JSArray_methods.any$1(B.JSArray_methods.get$last(t1).selector.components, new A.SimpleSelector_isSuperselector__closure(this.$this));
            },
            $signature: 21
        };
        A.SimpleSelector_isSuperselector__closure.prototype = {
            call$1: function(simple) {
                return this.$this.isSuperselector$1(simple);
            },
            $signature: 14
        };
        A.TypeSelector.prototype = {
            get$specificity: function() {
                return 1;
            },
            accept$1$1: function(visitor) {
                return visitor.visitTypeSelector$1(0, this);
            },
            accept$1: function(visitor) {
                return this.accept$1$1(visitor, type$.dynamic);
            },
            addSuffix$1: function(suffix) {
                var t1 = this.name;
                return new A.TypeSelector(new A.QualifiedName(t1.name + suffix, t1.namespace), this.span);
            },
            unify$1: function(compound) {
                var unified, t1, _0_0 = A.IterableExtensions_get_firstOrNull(compound);
                if (_0_0 instanceof A.UniversalSelector || _0_0 instanceof A.TypeSelector) {
                    unified = A.unifyUniversalAndElement(this, B.JSArray_methods.get$first(compound));
                    if (unified == null) return null;
                    t1 = A._setArrayType([
                        unified
                    ], type$.JSArray_SimpleSelector);
                    B.JSArray_methods.addAll$1(t1, A.SubListIterable$(compound, 1, null, A._arrayInstanceType(compound)._precomputed1));
                    return t1;
                } else {
                    t1 = A._setArrayType([
                        this
                    ], type$.JSArray_SimpleSelector);
                    B.JSArray_methods.addAll$1(t1, compound);
                    return t1;
                }
            },
            isSuperselector$1: function(other) {
                var t1, t2, t3;
                if (!this.super$SimpleSelector$isSuperselector(other)) {
                    t1 = false;
                    if (other instanceof A.TypeSelector) {
                        t2 = this.name;
                        t3 = other.name;
                        if (t2.name === t3.name) {
                            t1 = t2.namespace;
                            t1 = t1 === "*" || t1 == t3.namespace;
                        }
                    }
                } else t1 = true;
                return t1;
            },
            $eq: function(_, other) {
                if (other == null) return false;
                return other instanceof A.TypeSelector && other.name.$eq(0, this.name);
            },
            get$hashCode: function(_) {
                var t1 = this.name;
                return B.JSString_methods.get$hashCode(t1.name) ^ J.get$hashCode$(t1.namespace);
            }
        };
        A.UniversalSelector.prototype = {
            get$specificity: function() {
                return 0;
            },
            accept$1$1: function(visitor) {
                return visitor.visitUniversalSelector$1(0, this);
            },
            accept$1: function(visitor) {
                return this.accept$1$1(visitor, type$.dynamic);
            },
            unify$1: function(compound) {
                var _0_4, t1, rest, unified, t2, _this = this, _null = null, _0_1 = compound.length, _0_4_isSet = _0_1 >= 1;
                if (_0_4_isSet) {
                    _0_4 = compound[0];
                    if (!(_0_4 instanceof A.UniversalSelector)) t1 = _0_4 instanceof A.TypeSelector;
                    else t1 = true;
                    rest = t1 ? B.JSArray_methods.sublist$1(compound, 1) : _null;
                } else {
                    rest = _null;
                    _0_4 = rest;
                    t1 = false;
                }
                if (t1) {
                    unified = A.unifyUniversalAndElement(_this, B.JSArray_methods.get$first(compound));
                    if (unified == null) return _null;
                    t1 = A._setArrayType([
                        unified
                    ], type$.JSArray_SimpleSelector);
                    B.JSArray_methods.addAll$1(t1, rest);
                    return t1;
                }
                t1 = false;
                if (_0_1 === 1) {
                    if (_0_4_isSet) t2 = _0_4;
                    else {
                        _0_4 = compound[0];
                        t2 = _0_4;
                        _0_4_isSet = true;
                    }
                    if (t2 instanceof A.PseudoSelector) {
                        t2 = _0_4_isSet ? _0_4 : compound[0];
                        type$.PseudoSelector._as(t2);
                        t1 = t2.isClass && t2.name === "host" || t2.get$isHostContext();
                    }
                }
                if (t1) return _null;
                if (_0_1 <= 0) return A._setArrayType([
                    _this
                ], type$.JSArray_SimpleSelector);
                t1 = _this.namespace;
                if (t1 == null || t1 === "*") t1 = compound;
                else {
                    t1 = A._setArrayType([
                        _this
                    ], type$.JSArray_SimpleSelector);
                    B.JSArray_methods.addAll$1(t1, compound);
                }
                return t1;
            },
            isSuperselector$1: function(other) {
                var t1 = this.namespace;
                if (t1 === "*") return true;
                if (other instanceof A.TypeSelector) return t1 == other.name.namespace;
                if (other instanceof A.UniversalSelector) return t1 == other.namespace;
                return t1 == null || this.super$SimpleSelector$isSuperselector(other);
            },
            $eq: function(_, other) {
                if (other == null) return false;
                return other instanceof A.UniversalSelector && other.namespace == this.namespace;
            },
            get$hashCode: function(_) {
                return J.get$hashCode$(this.namespace);
            }
        };
        A._compileStylesheet_closure0.prototype = {
            call$1: function(url) {
                var t1;
                if (url === "") {
                    t1 = this.stylesheet.span;
                    t1 = A.Uri_Uri$dataFromString(A.String_String$fromCharCodes(B.NativeUint32List_methods.sublist$2(t1.get$file(t1)._decodedChars, 0, null), 0, null), B.C_Utf8Codec, null).get$_text();
                } else t1 = this.importCache.sourceMapUrl$1(0, A.Uri_parse(url)).toString$0(0);
                return t1;
            },
            $signature: 6
        };
        A.AsyncEnvironment.prototype = {
            closure$0: function() {
                var t4, t5, t6, _this = this, t1 = _this._async_environment$_forwardedModules, t2 = _this._async_environment$_nestedForwardedModules, t3 = _this._async_environment$_variables;
                t3 = A._setArrayType(t3.slice(0), A._arrayInstanceType(t3));
                t4 = _this._async_environment$_variableNodes;
                t4 = A._setArrayType(t4.slice(0), A._arrayInstanceType(t4));
                t5 = _this._async_environment$_functions;
                t5 = A._setArrayType(t5.slice(0), A._arrayInstanceType(t5));
                t6 = _this._async_environment$_mixins;
                t6 = A._setArrayType(t6.slice(0), A._arrayInstanceType(t6));
                return A.AsyncEnvironment$_(_this._async_environment$_modules, _this._async_environment$_namespaceNodes, _this._async_environment$_globalModules, _this._async_environment$_importedModules, t1, t2, _this._async_environment$_allModules, t3, t4, t5, t6, _this._async_environment$_content, B.Set_empty1);
            },
            forwardModule$2: function(module, rule) {
                var view, t1, t2, _this = this, forwardedModules = _this._async_environment$_forwardedModules;
                if (forwardedModules == null) forwardedModules = _this._async_environment$_forwardedModules = A.LinkedHashMap_LinkedHashMap$_empty(type$.Module_AsyncCallable, type$.AstNode);
                view = A.ForwardedModuleView_ifNecessary(module, rule, type$.AsyncCallable);
                for(t1 = new A.LinkedHashMapKeyIterator(forwardedModules, forwardedModules._modifications, forwardedModules._first); t1.moveNext$0();){
                    t2 = t1.__js_helper$_current;
                    _this._async_environment$_assertNoConflicts$5(view.get$variables(), t2.get$variables(), view, t2, "variable");
                    _this._async_environment$_assertNoConflicts$5(view.get$functions(view), t2.get$functions(t2), view, t2, "function");
                    _this._async_environment$_assertNoConflicts$5(view.get$mixins(), t2.get$mixins(), view, t2, "mixin");
                }
                _this._async_environment$_allModules.push(module);
                forwardedModules.$indexSet(0, view, rule);
            },
            _async_environment$_assertNoConflicts$5: function(newMembers, oldMembers, newModule, oldModule, type) {
                var larger, smaller, t1, t2, t3, t4, $name, small, large, span;
                if (newMembers.get$length(newMembers) < oldMembers.get$length(oldMembers)) {
                    larger = oldMembers;
                    smaller = newMembers;
                } else {
                    larger = newMembers;
                    smaller = oldMembers;
                }
                for(t1 = type$.String, t2 = A.MapExtensions_get_pairs(smaller, t1, type$.Object), t2 = t2.get$iterator(t2), t3 = type === "variable"; t2.moveNext$0();){
                    t4 = t2.get$current(t2);
                    $name = t4._0;
                    small = t4._1;
                    large = larger.$index(0, $name);
                    if (large == null) continue;
                    if (t3 ? newModule.variableIdentity$1($name) === oldModule.variableIdentity$1($name) : J.$eq$(large, small)) continue;
                    if (t3) $name = "$" + $name;
                    t2 = this._async_environment$_forwardedModules;
                    if (t2 == null) span = null;
                    else {
                        t2 = t2.$index(0, oldModule);
                        span = t2 == null ? null : t2.get$span(t2);
                    }
                    t2 = A.LinkedHashMap_LinkedHashMap$_empty(type$.FileSpan, t1);
                    if (span != null) t2.$indexSet(0, span, "original @forward");
                    throw A.wrapException(A.MultiSpanSassScriptException$("Two forwarded modules both define a " + type + " named " + $name + ".", "new @forward", t2));
                }
            },
            importForwards$1: function(module) {
                var forwardedModules, t1, t2, t3, t4, node, t5, t6, t7, t8, t9, t10, _i, t11, shadowed, t12, t13, _length, _list, _this = this, forwarded = module._async_environment$_environment._async_environment$_forwardedModules;
                if (forwarded == null) return;
                forwardedModules = _this._async_environment$_forwardedModules;
                if (forwardedModules != null) {
                    t1 = type$.Module_AsyncCallable;
                    t2 = type$.AstNode;
                    t3 = A.LinkedHashMap_LinkedHashMap$_empty(t1, t2);
                    for(t1 = A.MapExtensions_get_pairs(forwarded, t1, t2), t1 = t1.get$iterator(t1), t2 = _this._async_environment$_globalModules; t1.moveNext$0();){
                        t4 = t1.get$current(t1);
                        module = t4._0;
                        node = t4._1;
                        if (!forwardedModules.containsKey$1(module) || !t2.containsKey$1(module)) t3.$indexSet(0, module, node);
                    }
                    forwarded = t3;
                } else forwardedModules = _this._async_environment$_forwardedModules = A.LinkedHashMap_LinkedHashMap$_empty(type$.Module_AsyncCallable, type$.AstNode);
                t1 = type$.String;
                t2 = A.LinkedHashSet_LinkedHashSet$_empty(t1);
                for(t3 = new A.LinkedHashMapKeyIterator(forwarded, forwarded._modifications, forwarded._first); t3.moveNext$0();)for(t4 = t3.__js_helper$_current.get$variables(), t4 = t4.get$keys(t4), t4 = t4.get$iterator(t4); t4.moveNext$0();)t2.add$1(0, t4.get$current(t4));
                t3 = A.LinkedHashSet_LinkedHashSet$_empty(t1);
                for(t4 = new A.LinkedHashMapKeyIterator(forwarded, forwarded._modifications, forwarded._first); t4.moveNext$0();){
                    t5 = t4.__js_helper$_current;
                    for(t5 = t5.get$functions(t5), t5 = t5.get$keys(t5), t5 = t5.get$iterator(t5); t5.moveNext$0();)t3.add$1(0, t5.get$current(t5));
                }
                t1 = A.LinkedHashSet_LinkedHashSet$_empty(t1);
                for(t4 = new A.LinkedHashMapKeyIterator(forwarded, forwarded._modifications, forwarded._first); t4.moveNext$0();)for(t5 = t4.__js_helper$_current.get$mixins(), t5 = t5.get$keys(t5), t5 = t5.get$iterator(t5); t5.moveNext$0();)t1.add$1(0, t5.get$current(t5));
                t4 = _this._async_environment$_variables;
                t5 = t4.length;
                if (t5 === 1) {
                    for(t5 = _this._async_environment$_importedModules, t6 = type$.Module_AsyncCallable, t7 = type$.AstNode, t8 = A.MapExtensions_get_pairs(t5, t6, t7).toList$0(0), t9 = t8.length, t10 = type$.AsyncCallable, _i = 0; _i < t8.length; t8.length === t9 || (0, A.throwConcurrentModificationError)(t8), ++_i){
                        t11 = t8[_i];
                        module = t11._0;
                        shadowed = A.ShadowedModuleView_ifNecessary(module, t3, t1, t2, t10);
                        if (shadowed != null) {
                            t5.remove$1(0, module);
                            t12 = shadowed.variables;
                            t13 = false;
                            if (t12.get$isEmpty(t12)) {
                                t12 = shadowed.functions;
                                if (t12.get$isEmpty(t12)) {
                                    t12 = shadowed.mixins;
                                    if (t12.get$isEmpty(t12)) {
                                        t12 = shadowed._shadowed_view$_inner;
                                        t12 = t12.get$css(t12);
                                        t12 = J.get$isEmpty$asx(t12.get$children(t12));
                                    } else t12 = t13;
                                } else t12 = t13;
                            } else t12 = t13;
                            if (!t12) t5.$indexSet(0, shadowed, t11._1);
                        }
                    }
                    for(t6 = A.MapExtensions_get_pairs(forwardedModules, t6, t7).toList$0(0), t7 = t6.length, _i = 0; _i < t6.length; t6.length === t7 || (0, A.throwConcurrentModificationError)(t6), ++_i){
                        t8 = t6[_i];
                        module = t8._0;
                        shadowed = A.ShadowedModuleView_ifNecessary(module, t3, t1, t2, t10);
                        if (shadowed != null) {
                            forwardedModules.remove$1(0, module);
                            t9 = shadowed.variables;
                            t11 = false;
                            if (t9.get$isEmpty(t9)) {
                                t9 = shadowed.functions;
                                if (t9.get$isEmpty(t9)) {
                                    t9 = shadowed.mixins;
                                    if (t9.get$isEmpty(t9)) {
                                        t9 = shadowed._shadowed_view$_inner;
                                        t9 = t9.get$css(t9);
                                        t9 = J.get$isEmpty$asx(t9.get$children(t9));
                                    } else t9 = t11;
                                } else t9 = t11;
                            } else t9 = t11;
                            if (!t9) forwardedModules.$indexSet(0, shadowed, t8._1);
                        }
                    }
                    t5.addAll$1(0, forwarded);
                    forwardedModules.addAll$1(0, forwarded);
                } else {
                    t6 = _this._async_environment$_nestedForwardedModules;
                    if (t6 == null) {
                        _length = t5 - 1;
                        _list = J.JSArray_JSArray$allocateGrowable(_length, type$.List_Module_AsyncCallable);
                        for(t5 = type$.JSArray_Module_AsyncCallable, _i = 0; _i < _length; ++_i)_list[_i] = A._setArrayType([], t5);
                        _this._async_environment$_nestedForwardedModules = _list;
                        t5 = _list;
                    } else t5 = t6;
                    B.JSArray_methods.addAll$1(B.JSArray_methods.get$last(t5), new A.LinkedHashMapKeysIterable(forwarded, A._instanceType(forwarded)._eval$1("LinkedHashMapKeysIterable<1>")));
                }
                for(t2 = A._LinkedHashSetIterator$(t2, t2._collection$_modifications, t2.$ti._precomputed1), t5 = _this._async_environment$_variableIndices, t6 = _this._async_environment$_variableNodes, t7 = t2.$ti._precomputed1; t2.moveNext$0();){
                    t8 = t2._collection$_current;
                    if (t8 == null) t8 = t7._as(t8);
                    t5.remove$1(0, t8);
                    B.JSArray_methods.get$last(t4).remove$1(0, t8);
                    B.JSArray_methods.get$last(t6).remove$1(0, t8);
                }
                for(t2 = A._LinkedHashSetIterator$(t3, t3._collection$_modifications, t3.$ti._precomputed1), t3 = _this._async_environment$_functionIndices, t4 = _this._async_environment$_functions, t5 = t2.$ti._precomputed1; t2.moveNext$0();){
                    t6 = t2._collection$_current;
                    if (t6 == null) t6 = t5._as(t6);
                    t3.remove$1(0, t6);
                    B.JSArray_methods.get$last(t4).remove$1(0, t6);
                }
                for(t1 = A._LinkedHashSetIterator$(t1, t1._collection$_modifications, t1.$ti._precomputed1), t2 = _this._async_environment$_mixinIndices, t3 = _this._async_environment$_mixins, t4 = t1.$ti._precomputed1; t1.moveNext$0();){
                    t5 = t1._collection$_current;
                    if (t5 == null) t5 = t4._as(t5);
                    t2.remove$1(0, t5);
                    B.JSArray_methods.get$last(t3).remove$1(0, t5);
                }
            },
            getVariable$2$namespace: function($name, namespace) {
                var t1, _0_0, _1_0, _this = this;
                if (namespace != null) return _this._async_environment$_getModule$1(namespace).get$variables().$index(0, $name);
                if (_this._async_environment$_lastVariableName === $name) {
                    t1 = _this._async_environment$_lastVariableIndex;
                    t1.toString;
                    t1 = _this._async_environment$_variables[t1].$index(0, $name);
                    return t1 == null ? _this._async_environment$_getVariableFromGlobalModule$1($name) : t1;
                }
                t1 = _this._async_environment$_variableIndices;
                _0_0 = t1.$index(0, $name);
                if (_0_0 != null) {
                    _this._async_environment$_lastVariableName = $name;
                    _this._async_environment$_lastVariableIndex = _0_0;
                    t1 = _this._async_environment$_variables[_0_0].$index(0, $name);
                    return t1 == null ? _this._async_environment$_getVariableFromGlobalModule$1($name) : t1;
                } else {
                    _1_0 = _this._async_environment$_variableIndex$1($name);
                    if (_1_0 != null) {
                        _this._async_environment$_lastVariableName = $name;
                        _this._async_environment$_lastVariableIndex = _1_0;
                        t1.$indexSet(0, $name, _1_0);
                        t1 = _this._async_environment$_variables[_1_0].$index(0, $name);
                        return t1 == null ? _this._async_environment$_getVariableFromGlobalModule$1($name) : t1;
                    } else return _this._async_environment$_getVariableFromGlobalModule$1($name);
                }
            },
            getVariable$1: function($name) {
                return this.getVariable$2$namespace($name, null);
            },
            _async_environment$_getVariableFromGlobalModule$1: function($name) {
                return this._async_environment$_fromOneModule$3($name, "variable", new A.AsyncEnvironment__getVariableFromGlobalModule_closure($name));
            },
            getVariableNode$2$namespace: function($name, namespace) {
                var t1, _0_0, _1_0, _this = this;
                if (namespace != null) return _this._async_environment$_getModule$1(namespace).get$variableNodes().$index(0, $name);
                if (_this._async_environment$_lastVariableName === $name) {
                    t1 = _this._async_environment$_lastVariableIndex;
                    t1.toString;
                    t1 = _this._async_environment$_variableNodes[t1].$index(0, $name);
                    return t1 == null ? _this._async_environment$_getVariableNodeFromGlobalModule$1($name) : t1;
                }
                t1 = _this._async_environment$_variableIndices;
                _0_0 = t1.$index(0, $name);
                if (_0_0 != null) {
                    _this._async_environment$_lastVariableName = $name;
                    _this._async_environment$_lastVariableIndex = _0_0;
                    t1 = _this._async_environment$_variableNodes[_0_0].$index(0, $name);
                    return t1 == null ? _this._async_environment$_getVariableNodeFromGlobalModule$1($name) : t1;
                } else {
                    _1_0 = _this._async_environment$_variableIndex$1($name);
                    if (_1_0 != null) {
                        _this._async_environment$_lastVariableName = $name;
                        _this._async_environment$_lastVariableIndex = _1_0;
                        t1.$indexSet(0, $name, _1_0);
                        t1 = _this._async_environment$_variableNodes[_1_0].$index(0, $name);
                        return t1 == null ? _this._async_environment$_getVariableNodeFromGlobalModule$1($name) : t1;
                    } else return _this._async_environment$_getVariableNodeFromGlobalModule$1($name);
                }
            },
            _async_environment$_getVariableNodeFromGlobalModule$1: function($name) {
                var t1, t2, _0_0;
                for(t1 = this._async_environment$_importedModules, t2 = this._async_environment$_globalModules, t2 = new A.LinkedHashMapKeysIterable(t1, A._instanceType(t1)._eval$1("LinkedHashMapKeysIterable<1>")).followedBy$1(0, new A.LinkedHashMapKeysIterable(t2, A._instanceType(t2)._eval$1("LinkedHashMapKeysIterable<1>"))), t2 = new A.FollowedByIterator(J.get$iterator$ax(t2.__internal$_first), t2._second); t2.moveNext$0();){
                    t1 = t2._currentIterator;
                    _0_0 = t1.get$current(t1).get$variableNodes().$index(0, $name);
                    if (_0_0 != null) return _0_0;
                }
                return null;
            },
            globalVariableExists$2$namespace: function($name, namespace) {
                if (namespace != null) return this._async_environment$_getModule$1(namespace).get$variables().containsKey$1($name);
                if (B.JSArray_methods.get$first(this._async_environment$_variables).containsKey$1($name)) return true;
                return this._async_environment$_getVariableFromGlobalModule$1($name) != null;
            },
            globalVariableExists$1: function($name) {
                return this.globalVariableExists$2$namespace($name, null);
            },
            _async_environment$_variableIndex$1: function($name) {
                var t1, i;
                for(t1 = this._async_environment$_variables, i = t1.length - 1; i >= 0; --i)if (t1[i].containsKey$1($name)) return i;
                return null;
            },
            setVariable$5$global$namespace: function($name, value, nodeWithSpan, global, namespace) {
                var t1, moduleWithName, nestedForwardedModules, t2, t3, t4, t5, index, _this = this;
                if (namespace != null) {
                    _this._async_environment$_getModule$1(namespace).setVariable$3($name, value, nodeWithSpan);
                    return;
                }
                if (global || _this._async_environment$_variables.length === 1) {
                    _this._async_environment$_variableIndices.putIfAbsent$2($name, new A.AsyncEnvironment_setVariable_closure(_this, $name));
                    t1 = _this._async_environment$_variables;
                    if (!B.JSArray_methods.get$first(t1).containsKey$1($name)) {
                        moduleWithName = _this._async_environment$_fromOneModule$3($name, "variable", new A.AsyncEnvironment_setVariable_closure0($name));
                        if (moduleWithName != null) {
                            moduleWithName.setVariable$3($name, value, nodeWithSpan);
                            return;
                        }
                    }
                    B.JSArray_methods.get$first(t1).$indexSet(0, $name, value);
                    B.JSArray_methods.get$first(_this._async_environment$_variableNodes).$indexSet(0, $name, nodeWithSpan);
                    return;
                }
                nestedForwardedModules = _this._async_environment$_nestedForwardedModules;
                if (nestedForwardedModules != null && !_this._async_environment$_variableIndices.containsKey$1($name) && _this._async_environment$_variableIndex$1($name) == null) for(t1 = A._arrayInstanceType(nestedForwardedModules)._eval$1("ReversedListIterable<1>"), t2 = new A.ReversedListIterable(nestedForwardedModules, t1), t2 = new A.ListIterator(t2, t2.get$length(0), t1._eval$1("ListIterator<ListIterable.E>")), t1 = t1._eval$1("ListIterable.E"); t2.moveNext$0();){
                    t3 = t2.__internal$_current;
                    for(t3 = J.get$reversed$ax(t3 == null ? t1._as(t3) : t3), t4 = t3.$ti, t3 = new A.ListIterator(t3, t3.get$length(0), t4._eval$1("ListIterator<ListIterable.E>")), t4 = t4._eval$1("ListIterable.E"); t3.moveNext$0();){
                        t5 = t3.__internal$_current;
                        if (t5 == null) t5 = t4._as(t5);
                        if (t5.get$variables().containsKey$1($name)) {
                            t5.setVariable$3($name, value, nodeWithSpan);
                            return;
                        }
                    }
                }
                if (_this._async_environment$_lastVariableName === $name) {
                    t1 = _this._async_environment$_lastVariableIndex;
                    t1.toString;
                    index = t1;
                } else index = _this._async_environment$_variableIndices.putIfAbsent$2($name, new A.AsyncEnvironment_setVariable_closure1(_this, $name));
                if (!_this._async_environment$_inSemiGlobalScope && index === 0) {
                    index = _this._async_environment$_variables.length - 1;
                    _this._async_environment$_variableIndices.$indexSet(0, $name, index);
                }
                _this._async_environment$_lastVariableName = $name;
                _this._async_environment$_lastVariableIndex = index;
                _this._async_environment$_variables[index].$indexSet(0, $name, value);
                _this._async_environment$_variableNodes[index].$indexSet(0, $name, nodeWithSpan);
            },
            setVariable$4$global: function($name, value, nodeWithSpan, global) {
                return this.setVariable$5$global$namespace($name, value, nodeWithSpan, global, null);
            },
            setLocalVariable$3: function($name, value, nodeWithSpan) {
                var index, _this = this, t1 = _this._async_environment$_variables, t2 = t1.length;
                _this._async_environment$_lastVariableName = $name;
                index = _this._async_environment$_lastVariableIndex = t2 - 1;
                _this._async_environment$_variableIndices.$indexSet(0, $name, index);
                t1[index].$indexSet(0, $name, value);
                _this._async_environment$_variableNodes[index].$indexSet(0, $name, nodeWithSpan);
            },
            getFunction$2$namespace: function($name, namespace) {
                var t1, _0_0, _1_0, _this = this;
                if (namespace != null) {
                    t1 = _this._async_environment$_getModule$1(namespace);
                    return t1.get$functions(t1).$index(0, $name);
                }
                t1 = _this._async_environment$_functionIndices;
                _0_0 = t1.$index(0, $name);
                if (_0_0 != null) {
                    t1 = _this._async_environment$_functions[_0_0].$index(0, $name);
                    return t1 == null ? _this._async_environment$_getFunctionFromGlobalModule$1($name) : t1;
                } else {
                    _1_0 = _this._async_environment$_functionIndex$1($name);
                    if (_1_0 != null) {
                        t1.$indexSet(0, $name, _1_0);
                        t1 = _this._async_environment$_functions[_1_0].$index(0, $name);
                        return t1 == null ? _this._async_environment$_getFunctionFromGlobalModule$1($name) : t1;
                    } else return _this._async_environment$_getFunctionFromGlobalModule$1($name);
                }
            },
            getFunction$1: function($name) {
                return this.getFunction$2$namespace($name, null);
            },
            _async_environment$_getFunctionFromGlobalModule$1: function($name) {
                return this._async_environment$_fromOneModule$3($name, "function", new A.AsyncEnvironment__getFunctionFromGlobalModule_closure($name));
            },
            _async_environment$_functionIndex$1: function($name) {
                var t1, i;
                for(t1 = this._async_environment$_functions, i = t1.length - 1; i >= 0; --i)if (t1[i].containsKey$1($name)) return i;
                return null;
            },
            getMixin$2$namespace: function($name, namespace) {
                var t1, _0_0, _1_0, _this = this;
                if (namespace != null) return _this._async_environment$_getModule$1(namespace).get$mixins().$index(0, $name);
                t1 = _this._async_environment$_mixinIndices;
                _0_0 = t1.$index(0, $name);
                if (_0_0 != null) {
                    t1 = _this._async_environment$_mixins[_0_0].$index(0, $name);
                    return t1 == null ? _this._async_environment$_getMixinFromGlobalModule$1($name) : t1;
                } else {
                    _1_0 = _this._async_environment$_mixinIndex$1($name);
                    if (_1_0 != null) {
                        t1.$indexSet(0, $name, _1_0);
                        t1 = _this._async_environment$_mixins[_1_0].$index(0, $name);
                        return t1 == null ? _this._async_environment$_getMixinFromGlobalModule$1($name) : t1;
                    } else return _this._async_environment$_getMixinFromGlobalModule$1($name);
                }
            },
            _async_environment$_getMixinFromGlobalModule$1: function($name) {
                return this._async_environment$_fromOneModule$3($name, "mixin", new A.AsyncEnvironment__getMixinFromGlobalModule_closure($name));
            },
            _async_environment$_mixinIndex$1: function($name) {
                var t1, i;
                for(t1 = this._async_environment$_mixins, i = t1.length - 1; i >= 0; --i)if (t1[i].containsKey$1($name)) return i;
                return null;
            },
            withContent$2: function($content, callback) {
                return this.withContent$body$AsyncEnvironment($content, callback);
            },
            withContent$body$AsyncEnvironment: function($content, callback) {
                var $async$goto = 0, $async$completer = A._makeAsyncAwaitCompleter(type$.void), $async$self = this, oldContent;
                var $async$withContent$2 = A._wrapJsFunctionForAsync(function($async$errorCode, $async$result) {
                    if ($async$errorCode === 1) return A._asyncRethrow($async$result, $async$completer);
                    for(;;)switch($async$goto){
                        case 0:
                            // Function start
                            oldContent = $async$self._async_environment$_content;
                            $async$self._async_environment$_content = $content;
                            $async$goto = 2;
                            return A._asyncAwait(callback.call$0(), $async$withContent$2);
                        case 2:
                            // returning from await.
                            $async$self._async_environment$_content = oldContent;
                            // implicit return
                            return A._asyncReturn(null, $async$completer);
                    }
                });
                return A._asyncStartSync($async$withContent$2, $async$completer);
            },
            asMixin$1: function(callback) {
                var $async$goto = 0, $async$completer = A._makeAsyncAwaitCompleter(type$.void), $async$self = this, oldInMixin;
                var $async$asMixin$1 = A._wrapJsFunctionForAsync(function($async$errorCode, $async$result) {
                    if ($async$errorCode === 1) return A._asyncRethrow($async$result, $async$completer);
                    for(;;)switch($async$goto){
                        case 0:
                            // Function start
                            oldInMixin = $async$self._async_environment$_inMixin;
                            $async$self._async_environment$_inMixin = true;
                            $async$goto = 2;
                            return A._asyncAwait(callback.call$0(), $async$asMixin$1);
                        case 2:
                            // returning from await.
                            $async$self._async_environment$_inMixin = oldInMixin;
                            // implicit return
                            return A._asyncReturn(null, $async$completer);
                    }
                });
                return A._asyncStartSync($async$asMixin$1, $async$completer);
            },
            scope$1$3$semiGlobal$when: function(callback, semiGlobal, when, $T) {
                return this.scope$body$AsyncEnvironment(callback, semiGlobal, when, $T, $T);
            },
            scope$1$1: function(callback, $T) {
                return this.scope$1$3$semiGlobal$when(callback, false, true, $T);
            },
            scope$1$2$when: function(callback, when, $T) {
                return this.scope$1$3$semiGlobal$when(callback, false, when, $T);
            },
            scope$1$2$semiGlobal: function(callback, semiGlobal, $T) {
                return this.scope$1$3$semiGlobal$when(callback, semiGlobal, true, $T);
            },
            scope$body$AsyncEnvironment: function(callback, semiGlobal, when, $T, $async$type) {
                var $async$goto = 0, $async$completer = A._makeAsyncAwaitCompleter($async$type), $async$returnValue, $async$handler = 2, $async$errorStack = [], $async$next = [], $async$self = this, wasInSemiGlobalScope, $name, name0, name1, t1, t2, t3, t4, t5, t6;
                var $async$scope$1$3$semiGlobal$when = A._wrapJsFunctionForAsync(function($async$errorCode, $async$result) {
                    if ($async$errorCode === 1) {
                        $async$errorStack.push($async$result);
                        $async$goto = $async$handler;
                    }
                    for(;;)switch($async$goto){
                        case 0:
                            // Function start
                            semiGlobal = semiGlobal && $async$self._async_environment$_inSemiGlobalScope;
                            wasInSemiGlobalScope = $async$self._async_environment$_inSemiGlobalScope;
                            $async$self._async_environment$_inSemiGlobalScope = semiGlobal;
                            $async$goto = !when ? 3 : 4;
                            break;
                        case 3:
                            // then
                            $async$handler = 5;
                            $async$goto = 8;
                            return A._asyncAwait(callback.call$0(), $async$scope$1$3$semiGlobal$when);
                        case 8:
                            // returning from await.
                            t1 = $async$result;
                            $async$returnValue = t1;
                            $async$next = [
                                1
                            ];
                            // goto finally
                            $async$goto = 6;
                            break;
                        case 5:
                            // uncaught
                            $async$next = [
                                2
                            ];
                        case 6:
                            // finally
                            $async$handler = 2;
                            $async$self._async_environment$_inSemiGlobalScope = wasInSemiGlobalScope;
                            // goto the next finally handler
                            $async$goto = $async$next.pop();
                            break;
                        case 7:
                        // after finally
                        case 4:
                            // join
                            t1 = $async$self._async_environment$_variables;
                            t2 = type$.String;
                            B.JSArray_methods.add$1(t1, A.LinkedHashMap_LinkedHashMap$_empty(t2, type$.Value));
                            t3 = $async$self._async_environment$_variableNodes;
                            B.JSArray_methods.add$1(t3, A.LinkedHashMap_LinkedHashMap$_empty(t2, type$.AstNode));
                            t4 = $async$self._async_environment$_functions;
                            t5 = type$.AsyncCallable;
                            B.JSArray_methods.add$1(t4, A.LinkedHashMap_LinkedHashMap$_empty(t2, t5));
                            t6 = $async$self._async_environment$_mixins;
                            B.JSArray_methods.add$1(t6, A.LinkedHashMap_LinkedHashMap$_empty(t2, t5));
                            t5 = $async$self._async_environment$_nestedForwardedModules;
                            if (t5 != null) t5.push(A._setArrayType([], type$.JSArray_Module_AsyncCallable));
                            $async$handler = 9;
                            $async$goto = 12;
                            return A._asyncAwait(callback.call$0(), $async$scope$1$3$semiGlobal$when);
                        case 12:
                            // returning from await.
                            t2 = $async$result;
                            $async$returnValue = t2;
                            $async$next = [
                                1
                            ];
                            // goto finally
                            $async$goto = 10;
                            break;
                        case 9:
                            // uncaught
                            $async$next = [
                                2
                            ];
                        case 10:
                            // finally
                            $async$handler = 2;
                            $async$self._async_environment$_inSemiGlobalScope = wasInSemiGlobalScope;
                            $async$self._async_environment$_lastVariableIndex = $async$self._async_environment$_lastVariableName = null;
                            for(t1 = B.JSArray_methods.removeLast$0(t1), t1 = t1.get$keys(t1), t1 = t1.get$iterator(t1), t2 = $async$self._async_environment$_variableIndices; t1.moveNext$0();){
                                $name = t1.get$current(t1);
                                t2.remove$1(0, $name);
                            }
                            B.JSArray_methods.removeLast$0(t3);
                            for(t1 = B.JSArray_methods.removeLast$0(t4), t1 = t1.get$keys(t1), t1 = t1.get$iterator(t1), t2 = $async$self._async_environment$_functionIndices; t1.moveNext$0();){
                                name0 = t1.get$current(t1);
                                t2.remove$1(0, name0);
                            }
                            for(t1 = B.JSArray_methods.removeLast$0(t6), t1 = t1.get$keys(t1), t1 = t1.get$iterator(t1), t2 = $async$self._async_environment$_mixinIndices; t1.moveNext$0();){
                                name1 = t1.get$current(t1);
                                t2.remove$1(0, name1);
                            }
                            t1 = $async$self._async_environment$_nestedForwardedModules;
                            if (t1 != null) t1.pop();
                            // goto the next finally handler
                            $async$goto = $async$next.pop();
                            break;
                        case 11:
                        // after finally
                        case 1:
                            // return
                            return A._asyncReturn($async$returnValue, $async$completer);
                        case 2:
                            // rethrow
                            return A._asyncRethrow($async$errorStack.at(-1), $async$completer);
                    }
                });
                return A._asyncStartSync($async$scope$1$3$semiGlobal$when, $async$completer);
            },
            toImplicitConfiguration$0: function() {
                var t2, t3, t4, t5, t6, i, modules, t7, t8, t9, t10, $name, value, values, nodes, _this = this, _null = null, t1 = type$.String, configuration = A.LinkedHashMap_LinkedHashMap$_empty(t1, type$.ConfiguredValue);
                for(t2 = _this._async_environment$_variables, t3 = type$.Value, t4 = _this._async_environment$_variableNodes, t5 = _this._async_environment$_importedModules, t6 = A._instanceType(t5)._eval$1("LinkedHashMapKeysIterable<1>"), i = 0; i < t2.length; ++i){
                    if (i === 0) modules = new A.LinkedHashMapKeysIterable(t5, t6);
                    else {
                        t7 = _this._async_environment$_nestedForwardedModules;
                        modules = t7 == null ? _null : t7[i - 1];
                    }
                    t7 = J.get$iterator$ax(modules == null ? B.List_empty15 : modules);
                    while(t7.moveNext$0()){
                        t8 = t7.get$current(t7);
                        for(t9 = A.MapExtensions_get_pairs(t8.get$variables(), t1, t3), t9 = t9.get$iterator(t9); t9.moveNext$0();){
                            t10 = t9.get$current(t9);
                            $name = t10._0;
                            value = t10._1;
                            t10 = t8.get$variableNodes().$index(0, $name);
                            t10.toString;
                            configuration.$indexSet(0, $name, new A.ConfiguredValue(value, _null, t10));
                        }
                    }
                    values = t2[i];
                    nodes = t4[i];
                    for(t7 = A.MapExtensions_get_pairs(values, t1, t3), t7 = t7.get$iterator(t7); t7.moveNext$0();){
                        t8 = t7.get$current(t7);
                        $name = t8._0;
                        value = t8._1;
                        t8 = nodes.$index(0, $name);
                        t8.toString;
                        configuration.$indexSet(0, $name, new A.ConfiguredValue(value, _null, t8));
                    }
                }
                return new A.Configuration(configuration, _null);
            },
            toModule$3: function(css, preModuleComments, extensionStore) {
                return A._EnvironmentModule__EnvironmentModule0(this, css, preModuleComments, extensionStore, A.NullableExtension_andThen(this._async_environment$_forwardedModules, new A.AsyncEnvironment_toModule_closure()));
            },
            toDummyModule$0: function() {
                return A._EnvironmentModule__EnvironmentModule0(this, new A.CssStylesheet(new A.UnmodifiableListView(B.List_empty3, type$.UnmodifiableListView_CssNode), A.SourceFile$decoded(B.List_empty4, "<dummy module>").span$1(0, 0)), B.Map_empty7, B.C_EmptyExtensionStore, A.NullableExtension_andThen(this._async_environment$_forwardedModules, new A.AsyncEnvironment_toDummyModule_closure()));
            },
            _async_environment$_getModule$1: function(namespace) {
                var _0_0 = this._async_environment$_modules.$index(0, namespace);
                if (_0_0 != null) return _0_0;
                throw A.wrapException(A.SassScriptException$('There is no module with the namespace "' + namespace + '".', null));
            },
            _async_environment$_fromOneModule$1$3: function($name, type, callback) {
                var t1, t2, t3, t4, t5, _1_0, _2_0, value, identity, valueInModule, identityFromModule, module, node, _0_0 = this._async_environment$_nestedForwardedModules;
                if (_0_0 != null) for(t1 = A._arrayInstanceType(_0_0)._eval$1("ReversedListIterable<1>"), t2 = new A.ReversedListIterable(_0_0, t1), t2 = new A.ListIterator(t2, t2.get$length(0), t1._eval$1("ListIterator<ListIterable.E>")), t1 = t1._eval$1("ListIterable.E"); t2.moveNext$0();){
                    t3 = t2.__internal$_current;
                    for(t3 = J.get$reversed$ax(t3 == null ? t1._as(t3) : t3), t4 = t3.$ti, t3 = new A.ListIterator(t3, t3.get$length(0), t4._eval$1("ListIterator<ListIterable.E>")), t4 = t4._eval$1("ListIterable.E"); t3.moveNext$0();){
                        t5 = t3.__internal$_current;
                        _1_0 = callback.call$1(t5 == null ? t4._as(t5) : t5);
                        if (_1_0 != null) return _1_0;
                    }
                }
                for(t1 = this._async_environment$_importedModules, t1 = new A.LinkedHashMapKeyIterator(t1, t1._modifications, t1._first); t1.moveNext$0();){
                    _2_0 = callback.call$1(t1.__js_helper$_current);
                    if (_2_0 != null) return _2_0;
                }
                for(t1 = this._async_environment$_globalModules, t2 = new A.LinkedHashMapKeyIterator(t1, t1._modifications, t1._first), t3 = type$.AsyncCallable, value = null, identity = null; t2.moveNext$0();){
                    t4 = t2.__js_helper$_current;
                    valueInModule = callback.call$1(t4);
                    if (valueInModule == null) continue;
                    identityFromModule = t3._is(valueInModule) ? valueInModule : t4.variableIdentity$1($name);
                    if (identityFromModule.$eq(0, identity)) continue;
                    if (value != null) {
                        t2 = A.LinkedHashMap_LinkedHashMap$_empty(type$.FileSpan, type$.String);
                        for(t3 = A.MapExtensions_get_pairs(t1, type$.Module_AsyncCallable, type$.AstNode), t3 = t3.get$iterator(t3), t4 = "includes " + type; t3.moveNext$0();){
                            t1 = t3.get$current(t3);
                            module = t1._0;
                            node = t1._1;
                            if (callback.call$1(module) != null) t2.$indexSet(0, node.get$span(node), t4);
                        }
                        throw A.wrapException(A.MultiSpanSassScriptException$("This " + type + string$.x20is_av, type + " use", t2));
                    }
                    identity = identityFromModule;
                    value = valueInModule;
                }
                return value;
            },
            _async_environment$_fromOneModule$3: function($name, type, callback) {
                return this._async_environment$_fromOneModule$1$3($name, type, callback, type$.dynamic);
            }
        };
        A.AsyncEnvironment__getVariableFromGlobalModule_closure.prototype = {
            call$1: function(module) {
                return module.get$variables().$index(0, this.name);
            },
            $signature: 401
        };
        A.AsyncEnvironment_setVariable_closure.prototype = {
            call$0: function() {
                var t1 = this.$this;
                t1._async_environment$_lastVariableName = this.name;
                return t1._async_environment$_lastVariableIndex = 0;
            },
            $signature: 10
        };
        A.AsyncEnvironment_setVariable_closure0.prototype = {
            call$1: function(module) {
                return module.get$variables().containsKey$1(this.name) ? module : null;
            },
            $signature: 403
        };
        A.AsyncEnvironment_setVariable_closure1.prototype = {
            call$0: function() {
                var t1 = this.$this, t2 = t1._async_environment$_variableIndex$1(this.name);
                return t2 == null ? t1._async_environment$_variables.length - 1 : t2;
            },
            $signature: 10
        };
        A.AsyncEnvironment__getFunctionFromGlobalModule_closure.prototype = {
            call$1: function(module) {
                return module.get$functions(module).$index(0, this.name);
            },
            $signature: 173
        };
        A.AsyncEnvironment__getMixinFromGlobalModule_closure.prototype = {
            call$1: function(module) {
                return module.get$mixins().$index(0, this.name);
            },
            $signature: 173
        };
        A.AsyncEnvironment_toModule_closure.prototype = {
            call$1: function(modules) {
                return new A.MapKeySet(modules, type$.MapKeySet_Module_AsyncCallable);
            },
            $signature: 174
        };
        A.AsyncEnvironment_toDummyModule_closure.prototype = {
            call$1: function(modules) {
                return new A.MapKeySet(modules, type$.MapKeySet_Module_AsyncCallable);
            },
            $signature: 174
        };
        A._EnvironmentModule0.prototype = {
            get$url: function(_) {
                var t1 = this.css;
                t1 = t1.get$span(t1);
                return t1.get$sourceUrl(t1);
            },
            setVariable$3: function($name, value, nodeWithSpan) {
                var t1, t2, _0_0 = this._async_environment$_modulesByVariable.$index(0, $name);
                if (_0_0 != null) {
                    _0_0.setVariable$3($name, value, nodeWithSpan);
                    return;
                }
                t1 = this._async_environment$_environment;
                t2 = t1._async_environment$_variables;
                if (!B.JSArray_methods.get$first(t2).containsKey$1($name)) throw A.wrapException(A.SassScriptException$("Undefined variable.", null));
                B.JSArray_methods.get$first(t2).$indexSet(0, $name, value);
                B.JSArray_methods.get$first(t1._async_environment$_variableNodes).$indexSet(0, $name, nodeWithSpan);
                return;
            },
            variableIdentity$1: function($name) {
                var module = this._async_environment$_modulesByVariable.$index(0, $name);
                return module == null ? this : module.variableIdentity$1($name);
            },
            couldHaveBeenConfigured$1: function(variables) {
                var t2, t3, _0_0, variable, module, t1 = this._async_environment$_environment._async_environment$_configurableVariables;
                if (!(variables.get$length(variables) < t1.get$length(t1) ? variables.any$1(0, t1.get$contains(t1)) : t1.any$1(0, variables.get$contains(variables)))) {
                    t1 = this._async_environment$_modulesByVariable;
                    t2 = type$.Module_AsyncCallable;
                    if (variables.get$length(variables) < t1.get$length(t1)) {
                        t2 = A.LinkedHashSet_LinkedHashSet$_empty(t2);
                        for(t3 = variables.get$iterator(variables); t3.moveNext$0();){
                            _0_0 = t1.$index(0, t3.get$current(t3));
                            if (_0_0 != null) t2.add$1(0, _0_0);
                        }
                        t1 = t2;
                    } else {
                        t3 = A.LinkedHashSet_LinkedHashSet$_empty(t2);
                        for(t1 = A.MapExtensions_get_pairs(t1, type$.String, t2), t1 = t1.get$iterator(t1); t1.moveNext$0();){
                            t2 = t1.get$current(t1);
                            variable = t2._0;
                            module = t2._1;
                            if (variables.contains$1(0, variable)) t3.add$1(0, module);
                        }
                        t1 = t3;
                    }
                    t1 = t1.any$1(0, new A._EnvironmentModule_couldHaveBeenConfigured_closure0(variables));
                } else t1 = true;
                return t1;
            },
            cloneCss$0: function() {
                var _0_0, _this = this;
                if (!_this.transitivelyContainsCss) return _this;
                _0_0 = A.cloneCssStylesheet(_this.css, _this.extensionStore);
                return A._EnvironmentModule$_0(_this._async_environment$_environment, _0_0._0, _this.preModuleComments, _0_0._1, _this._async_environment$_modulesByVariable, _this.variables, _this.variableNodes, _this.functions, _this.mixins, true, _this.transitivelyContainsExtensions);
            },
            toString$0: function(_) {
                var t1 = this.css, t2 = t1.get$span(t1);
                if (t2.get$sourceUrl(t2) == null) t1 = "<unknown url>";
                else {
                    t1 = t1.get$span(t1);
                    t1 = t1.get$sourceUrl(t1);
                    t2 = $.$get$context();
                    t1.toString;
                    t1 = t2.prettyUri$1(t1);
                }
                return t1;
            },
            $isModule0: 1,
            get$upstream: function() {
                return this.upstream;
            },
            get$variables: function() {
                return this.variables;
            },
            get$variableNodes: function() {
                return this.variableNodes;
            },
            get$functions: function(receiver) {
                return this.functions;
            },
            get$mixins: function() {
                return this.mixins;
            },
            get$extensionStore: function() {
                return this.extensionStore;
            },
            get$css: function(receiver) {
                return this.css;
            },
            get$preModuleComments: function() {
                return this.preModuleComments;
            },
            get$transitivelyContainsCss: function() {
                return this.transitivelyContainsCss;
            },
            get$transitivelyContainsExtensions: function() {
                return this.transitivelyContainsExtensions;
            }
        };
        A._EnvironmentModule__EnvironmentModule_closure5.prototype = {
            call$1: function(module) {
                return module.get$variables();
            },
            $signature: 425
        };
        A._EnvironmentModule__EnvironmentModule_closure6.prototype = {
            call$1: function(module) {
                return module.get$variableNodes();
            },
            $signature: 695
        };
        A._EnvironmentModule__EnvironmentModule_closure7.prototype = {
            call$1: function(module) {
                return module.get$functions(module);
            },
            $signature: 180
        };
        A._EnvironmentModule__EnvironmentModule_closure8.prototype = {
            call$1: function(module) {
                return module.get$mixins();
            },
            $signature: 180
        };
        A._EnvironmentModule__EnvironmentModule_closure9.prototype = {
            call$1: function(module) {
                return module.get$transitivelyContainsCss();
            },
            $signature: 102
        };
        A._EnvironmentModule__EnvironmentModule_closure10.prototype = {
            call$1: function(module) {
                return module.get$transitivelyContainsExtensions();
            },
            $signature: 102
        };
        A._EnvironmentModule_couldHaveBeenConfigured_closure0.prototype = {
            call$1: function(module) {
                return module.couldHaveBeenConfigured$1(this.variables);
            },
            $signature: 102
        };
        A.AsyncImportCache.prototype = {
            canonicalize$4$baseImporter$baseUrl$forImport: function(_, url, baseImporter, baseUrl, forImport) {
                return this.canonicalize$body$AsyncImportCache(0, url, baseImporter, baseUrl, forImport);
            },
            canonicalize$body$AsyncImportCache: function(_, url, baseImporter, baseUrl, forImport) {
                var $async$goto = 0, $async$completer = A._makeAsyncAwaitCompleter(type$.nullable_Record_3_AsyncImporter_and_Uri_and_Uri_originalUrl), $async$returnValue, $async$self = this, t1, resolvedUrl, key, relativeResult, t2, t3, t4, t5, t6, cacheable, i, importer, perImporterKey, t7, _1_0, _1_2_isSet, result, _1_2, _2_0, _2_1, _2_5_isSet, _2_5, _2_3, _2_3_isSet, j;
                var $async$canonicalize$4$baseImporter$baseUrl$forImport = A._wrapJsFunctionForAsync(function($async$errorCode, $async$result) {
                    if ($async$errorCode === 1) return A._asyncRethrow($async$result, $async$completer);
                    for(;;)switch($async$goto){
                        case 0:
                            // Function start
                            if (A.isBrowser()) t1 = (baseImporter == null || baseImporter instanceof A.NoOpImporter) && $async$self._async_import_cache$_importers.length === 0;
                            else t1 = false;
                            if (t1) throw A.wrapException(string$.Customi);
                            $async$goto = baseImporter != null && url.get$scheme() === "" ? 3 : 4;
                            break;
                        case 3:
                            // then
                            resolvedUrl = baseUrl == null ? null : baseUrl.resolveUri$1(url);
                            if (resolvedUrl == null) resolvedUrl = url;
                            key = new A._Record_3_forImport(baseImporter, resolvedUrl, forImport);
                            $async$goto = 5;
                            return A._asyncAwait(A.putIfAbsentAsync($async$self._async_import_cache$_perImporterCanonicalizeCache, key, new A.AsyncImportCache_canonicalize_closure($async$self, baseImporter, resolvedUrl, baseUrl, forImport, key, url), type$.Record_3_AsyncImporter_and_Uri_and_bool_forImport, type$.nullable_Record_3_AsyncImporter_and_Uri_and_Uri_originalUrl), $async$canonicalize$4$baseImporter$baseUrl$forImport);
                        case 5:
                            // returning from await.
                            relativeResult = $async$result;
                            if (relativeResult != null) {
                                $async$returnValue = relativeResult;
                                // goto return
                                $async$goto = 1;
                                break;
                            }
                        case 4:
                            // join
                            key = new A._Record_2_forImport(url, forImport);
                            t1 = $async$self._async_import_cache$_canonicalizeCache;
                            if (t1.containsKey$1(key)) {
                                $async$returnValue = t1.$index(0, key);
                                // goto return
                                $async$goto = 1;
                                break;
                            }
                            t2 = $async$self._async_import_cache$_importers, t3 = type$.Record_1_nullable_Object, t4 = $async$self._async_import_cache$_perImporterCanonicalizeCache, t5 = type$.nullable_Record_3_AsyncImporter_and_Uri_and_Uri_originalUrl, t6 = type$.Record_3_AsyncImporter_and_Uri_and_Uri_originalUrl, cacheable = true, i = 0;
                        case 6:
                            // for condition
                            if (!(i < t2.length)) {
                                // goto after for
                                $async$goto = 8;
                                break;
                            }
                            importer = t2[i];
                            perImporterKey = new A._Record_3_forImport(importer, url, forImport);
                            if (t4.containsKey$1(perImporterKey)) {
                                t7 = t4.$index(0, perImporterKey);
                                _1_0 = new A._Record_1(t7 == null ? t5._as(t7) : t7);
                            } else _1_0 = null;
                            _1_2_isSet = t3._is(_1_0);
                            result = null;
                            if (_1_2_isSet) {
                                _1_2 = _1_0._0;
                                t7 = _1_2 != null;
                                if (t7) {
                                    t6._as(_1_2);
                                    result = _1_2;
                                }
                            } else {
                                _1_2 = null;
                                t7 = false;
                            }
                            if (t7) {
                                $async$returnValue = result;
                                // goto return
                                $async$goto = 1;
                                break;
                            }
                            if (_1_2_isSet) t7 = _1_2 == null;
                            else t7 = false;
                            if (t7) {
                                // goto for update
                                $async$goto = 7;
                                break;
                            }
                            $async$goto = 10;
                            return A._asyncAwait($async$self._async_import_cache$_canonicalize$4(importer, url, baseUrl, forImport), $async$canonicalize$4$baseImporter$baseUrl$forImport);
                        case 10:
                            // returning from await.
                            _2_0 = $async$result;
                            _2_1 = _2_0._0;
                            _2_5_isSet = _2_1 != null;
                            _2_5 = null;
                            _2_3 = null;
                            t7 = false;
                            if (_2_5_isSet) {
                                result = _2_1 == null ? t6._as(_2_1) : _2_1;
                                _2_3 = _2_0._1;
                                t7 = _2_3;
                                _2_5 = t7;
                                t7 = t7 && cacheable;
                            } else result = null;
                            if (t7) {
                                t1.$indexSet(0, key, result);
                                $async$returnValue = result;
                                // goto return
                                $async$goto = 1;
                                break;
                            }
                            if (_2_5_isSet) {
                                t7 = _2_5;
                                _2_3_isSet = _2_5_isSet;
                            } else {
                                _2_3 = _2_0._1;
                                t7 = _2_3;
                                _2_3_isSet = true;
                            }
                            t7 = t7 && !cacheable;
                            if (t7) {
                                t4.$indexSet(0, perImporterKey, _2_1);
                                if (_2_1 != null) {
                                    $async$returnValue = _2_1;
                                    // goto return
                                    $async$goto = 1;
                                    break;
                                }
                                // goto break $label0$1
                                $async$goto = 9;
                                break;
                            }
                            t7 = false === (_2_3_isSet ? _2_3 : _2_0._1);
                            if (t7) {
                                if (cacheable) {
                                    for(j = 0; j < i; ++j)t4.$indexSet(0, new A._Record_3_forImport(t2[j], url, forImport), null);
                                    cacheable = false;
                                }
                                if (_2_1 != null) {
                                    $async$returnValue = _2_1;
                                    // goto return
                                    $async$goto = 1;
                                    break;
                                }
                            }
                        case 9:
                        // break $label0$1
                        case 7:
                            // for update
                            ++i;
                            // goto for condition
                            $async$goto = 6;
                            break;
                        case 8:
                            // after for
                            if (cacheable) t1.$indexSet(0, key, null);
                            $async$returnValue = null;
                            // goto return
                            $async$goto = 1;
                            break;
                        case 1:
                            // return
                            return A._asyncReturn($async$returnValue, $async$completer);
                    }
                });
                return A._asyncStartSync($async$canonicalize$4$baseImporter$baseUrl$forImport, $async$completer);
            },
            _async_import_cache$_canonicalize$4: function(importer, url, baseUrl, forImport) {
                return this._canonicalize$body$AsyncImportCache(importer, url, baseUrl, forImport);
            },
            _canonicalize$body$AsyncImportCache: function(importer, url, baseUrl, forImport) {
                var $async$goto = 0, $async$completer = A._makeAsyncAwaitCompleter(type$.Record_2_nullable_Record_3_AsyncImporter_and_Uri_and_Uri_originalUrl_and_bool), $async$returnValue, t1, passContainingUrl, canonicalizeContext, result, cacheable;
                var $async$_async_import_cache$_canonicalize$4 = A._wrapJsFunctionForAsync(function($async$errorCode, $async$result) {
                    if ($async$errorCode === 1) return A._asyncRethrow($async$result, $async$completer);
                    for(;;)switch($async$goto){
                        case 0:
                            // Function start
                            $async$goto = baseUrl != null ? 3 : 5;
                            break;
                        case 3:
                            // then
                            $async$goto = url.get$scheme() !== "" ? 6 : 8;
                            break;
                        case 6:
                            // then
                            t1 = A._Future$value(importer.isNonCanonicalScheme$1(url.get$scheme()), type$.bool);
                            $async$goto = 9;
                            return A._asyncAwait(t1, $async$_async_import_cache$_canonicalize$4);
                        case 9:
                            // returning from await.
                            t1 = $async$result;
                            passContainingUrl = t1;
                            // goto join
                            $async$goto = 7;
                            break;
                        case 8:
                            // else
                            passContainingUrl = true;
                        case 7:
                            // join
                            // goto join
                            $async$goto = 4;
                            break;
                        case 5:
                            // else
                            passContainingUrl = false;
                        case 4:
                            // join
                            canonicalizeContext = new A.CanonicalizeContext(forImport, passContainingUrl ? baseUrl : null);
                            t1 = type$.nullable_Object;
                            t1 = A.runZoned(new A.AsyncImportCache__canonicalize_closure(importer, url), A.LinkedHashMap_LinkedHashMap$_literal([
                                B.Symbol__canonicalizeContext,
                                canonicalizeContext
                            ], t1, t1), type$.FutureOr_nullable_Uri);
                            $async$goto = 10;
                            return A._asyncAwait(type$.Future_nullable_Uri._is(t1) ? t1 : A._Future$value(t1, type$.nullable_Uri), $async$_async_import_cache$_canonicalize$4);
                        case 10:
                            // returning from await.
                            result = $async$result;
                            cacheable = !passContainingUrl || !canonicalizeContext._wasContainingUrlAccessed;
                            if (result == null) {
                                $async$returnValue = new A._Record_2(null, cacheable);
                                // goto return
                                $async$goto = 1;
                                break;
                            }
                            $async$goto = result.get$scheme() !== "" ? 11 : 13;
                            break;
                        case 11:
                            // then
                            t1 = A._Future$value(importer.isNonCanonicalScheme$1(result.get$scheme()), type$.bool);
                            $async$goto = 14;
                            return A._asyncAwait(t1, $async$_async_import_cache$_canonicalize$4);
                        case 14:
                            // returning from await.
                            t1 = $async$result;
                            // goto join
                            $async$goto = 12;
                            break;
                        case 13:
                            // else
                            t1 = false;
                        case 12:
                            // join
                            if (t1) throw A.wrapException("Importer " + importer.toString$0(0) + " canonicalized " + url.toString$0(0) + " to " + result.toString$0(0) + string$.x2c_whicu);
                            $async$returnValue = new A._Record_2(new A._Record_3_originalUrl(importer, result, url), cacheable);
                            // goto return
                            $async$goto = 1;
                            break;
                        case 1:
                            // return
                            return A._asyncReturn($async$returnValue, $async$completer);
                    }
                });
                return A._asyncStartSync($async$_async_import_cache$_canonicalize$4, $async$completer);
            },
            importCanonical$3$originalUrl: function(importer, canonicalUrl, originalUrl) {
                return this.importCanonical$body$AsyncImportCache(importer, canonicalUrl, originalUrl);
            },
            importCanonical$body$AsyncImportCache: function(importer, canonicalUrl, originalUrl) {
                var $async$goto = 0, $async$completer = A._makeAsyncAwaitCompleter(type$.nullable_Stylesheet), $async$returnValue, $async$self = this;
                var $async$importCanonical$3$originalUrl = A._wrapJsFunctionForAsync(function($async$errorCode, $async$result) {
                    if ($async$errorCode === 1) return A._asyncRethrow($async$result, $async$completer);
                    for(;;)switch($async$goto){
                        case 0:
                            // Function start
                            $async$goto = 3;
                            return A._asyncAwait(A.putIfAbsentAsync($async$self._async_import_cache$_importCache, canonicalUrl, new A.AsyncImportCache_importCanonical_closure($async$self, importer, canonicalUrl, originalUrl), type$.Uri, type$.nullable_Stylesheet), $async$importCanonical$3$originalUrl);
                        case 3:
                            // returning from await.
                            $async$returnValue = $async$result;
                            // goto return
                            $async$goto = 1;
                            break;
                        case 1:
                            // return
                            return A._asyncReturn($async$returnValue, $async$completer);
                    }
                });
                return A._asyncStartSync($async$importCanonical$3$originalUrl, $async$completer);
            },
            humanize$1: function(canonicalUrl) {
                var t1 = this._async_import_cache$_canonicalizeCache, t2 = type$.NonNullsIterable_Record_3_AsyncImporter_and_Uri_and_Uri_originalUrl;
                t2 = A.NullableExtension_andThen(A.minBy(new A.MappedIterable(new A.WhereIterable(new A.NonNullsIterable(new A.LinkedHashMapValuesIterable(t1, A._instanceType(t1)._eval$1("LinkedHashMapValuesIterable<2>")), t2), new A.AsyncImportCache_humanize_closure(canonicalUrl), t2._eval$1("WhereIterable<Iterable.E>")), new A.AsyncImportCache_humanize_closure0(), t2._eval$1("MappedIterable<Iterable.E,Uri>")), new A.AsyncImportCache_humanize_closure1()), new A.AsyncImportCache_humanize_closure2(canonicalUrl));
                return t2 == null ? canonicalUrl : t2;
            },
            sourceMapUrl$1: function(_, canonicalUrl) {
                var t1 = this._async_import_cache$_resultsCache.$index(0, canonicalUrl);
                t1 = t1 == null ? null : t1.get$sourceMapUrl(0);
                return t1 == null ? canonicalUrl : t1;
            }
        };
        A.AsyncImportCache_canonicalize_closure.prototype = {
            call$0: function() {
                var $async$goto = 0, $async$completer = A._makeAsyncAwaitCompleter(type$.nullable_Record_3_AsyncImporter_and_Uri_and_Uri_originalUrl), $async$returnValue, $async$self = this, t1, t2, _0_0, result;
                var $async$call$0 = A._wrapJsFunctionForAsync(function($async$errorCode, $async$result) {
                    if ($async$errorCode === 1) return A._asyncRethrow($async$result, $async$completer);
                    for(;;)switch($async$goto){
                        case 0:
                            // Function start
                            t1 = $async$self.$this;
                            t2 = $async$self.baseUrl;
                            $async$goto = 3;
                            return A._asyncAwait(t1._async_import_cache$_canonicalize$4($async$self.baseImporter, $async$self.resolvedUrl, t2, $async$self.forImport), $async$call$0);
                        case 3:
                            // returning from await.
                            _0_0 = $async$result;
                            result = _0_0._0;
                            _0_0._1;
                            if (t2 != null) t1._async_import_cache$_nonCanonicalRelativeUrls.$indexSet(0, $async$self.key, $async$self.url);
                            $async$returnValue = result;
                            // goto return
                            $async$goto = 1;
                            break;
                        case 1:
                            // return
                            return A._asyncReturn($async$returnValue, $async$completer);
                    }
                });
                return A._asyncStartSync($async$call$0, $async$completer);
            },
            $signature: 469
        };
        A.AsyncImportCache__canonicalize_closure.prototype = {
            call$0: function() {
                return this.importer.canonicalize$1(0, this.url);
            },
            $signature: 182
        };
        A.AsyncImportCache_importCanonical_closure.prototype = {
            call$0: function() {
                var $async$goto = 0, $async$completer = A._makeAsyncAwaitCompleter(type$.nullable_Stylesheet), $async$returnValue, $async$self = this, t1, t2, t3, result;
                var $async$call$0 = A._wrapJsFunctionForAsync(function($async$errorCode, $async$result) {
                    if ($async$errorCode === 1) return A._asyncRethrow($async$result, $async$completer);
                    for(;;)switch($async$goto){
                        case 0:
                            // Function start
                            t1 = Date.now();
                            t2 = $async$self.canonicalUrl;
                            t3 = A._Future$value($async$self.importer.load$1(0, t2), type$.nullable_ImporterResult);
                            $async$goto = 3;
                            return A._asyncAwait(t3, $async$call$0);
                        case 3:
                            // returning from await.
                            result = $async$result;
                            if (result == null) {
                                $async$returnValue = null;
                                // goto return
                                $async$goto = 1;
                                break;
                            }
                            t3 = $async$self.$this;
                            t3._async_import_cache$_loadTimes.$indexSet(0, t2, new A.DateTime(t1, 0, false));
                            t3._async_import_cache$_resultsCache.$indexSet(0, t2, result);
                            t3 = result.contents;
                            t1 = result.syntax;
                            t2 = $async$self.originalUrl.resolveUri$1(t2);
                            $async$returnValue = A.Stylesheet_Stylesheet$parse(t3, t1, false, t2);
                            // goto return
                            $async$goto = 1;
                            break;
                        case 1:
                            // return
                            return A._asyncReturn($async$returnValue, $async$completer);
                    }
                });
                return A._asyncStartSync($async$call$0, $async$completer);
            },
            $signature: 494
        };
        A.AsyncImportCache_humanize_closure.prototype = {
            call$1: function(result) {
                return result._1.$eq(0, this.canonicalUrl);
            },
            $signature: 516
        };
        A.AsyncImportCache_humanize_closure0.prototype = {
            call$1: function(result) {
                return result._2;
            },
            $signature: 518
        };
        A.AsyncImportCache_humanize_closure1.prototype = {
            call$1: function(url) {
                return url.get$path(url).length;
            },
            $signature: 107
        };
        A.AsyncImportCache_humanize_closure2.prototype = {
            call$1: function(url) {
                var t1 = $.$get$url(), t2 = this.canonicalUrl;
                return url.resolve$1(0, A.ParsedPath_ParsedPath$parse(t2.get$path(t2), t1.style).get$basename());
            },
            $signature: 49
        };
        A.AsyncBuiltInCallable.prototype = {
            callbackFor$2: function(positional, names) {
                return new A._Record_2(this._parameters, this._async_built_in$_callback);
            },
            withDeprecationWarning$1: function(module) {
                return new A.AsyncBuiltInCallable(this.name, this._parameters, new A.AsyncBuiltInCallable_withDeprecationWarning_closure(this, module, null), false);
            },
            $isAsyncCallable: 1,
            get$name: function(receiver) {
                return this.name;
            },
            get$acceptsContent: function() {
                return this.acceptsContent;
            }
        };
        A.AsyncBuiltInCallable$mixin_closure.prototype = {
            call$1: function($arguments) {
                return this.$call$body$AsyncBuiltInCallable$mixin_closure($arguments);
            },
            $call$body$AsyncBuiltInCallable$mixin_closure: function($arguments) {
                var $async$goto = 0, $async$completer = A._makeAsyncAwaitCompleter(type$.Value), $async$returnValue, $async$self = this, t1;
                var $async$call$1 = A._wrapJsFunctionForAsync(function($async$errorCode, $async$result) {
                    if ($async$errorCode === 1) return A._asyncRethrow($async$result, $async$completer);
                    for(;;)switch($async$goto){
                        case 0:
                            // Function start
                            t1 = $async$self.callback.call$1($arguments);
                            $async$goto = 3;
                            return A._asyncAwait(t1 instanceof A._Future ? t1 : A._Future$value(t1, type$.void), $async$call$1);
                        case 3:
                            // returning from await.
                            $async$returnValue = B.C__SassNull;
                            // goto return
                            $async$goto = 1;
                            break;
                        case 1:
                            // return
                            return A._asyncReturn($async$returnValue, $async$completer);
                    }
                });
                return A._asyncStartSync($async$call$1, $async$completer);
            },
            $signature: 190
        };
        A.AsyncBuiltInCallable_withDeprecationWarning_closure.prototype = {
            call$1: function(args) {
                var t1 = this.$this;
                A.warnForDeprecation(string$.Global + this.module + "." + t1.name + string$.x20inste, B.Deprecation_WW3);
                return t1._async_built_in$_callback.call$1(args);
            },
            $signature: 587
        };
        A.BuiltInCallable.prototype = {
            callbackFor$2: function(positional, names) {
                var t1, t2, fuzzyMatch, minMismatchDistance, _i, overload, t3, mismatchDistance, t4;
                for(t1 = this._overloads, t2 = t1.length, fuzzyMatch = null, minMismatchDistance = null, _i = 0; _i < t1.length; t1.length === t2 || (0, A.throwConcurrentModificationError)(t1), ++_i){
                    overload = t1[_i];
                    t3 = overload._0;
                    if (t3.matches$2(positional, names)) return overload;
                    mismatchDistance = t3.parameters.length - positional;
                    if (minMismatchDistance != null) {
                        t3 = Math.abs(mismatchDistance);
                        t4 = Math.abs(minMismatchDistance);
                        if (t3 > t4) continue;
                        if (t3 === t4 && mismatchDistance < 0) continue;
                    }
                    minMismatchDistance = mismatchDistance;
                    fuzzyMatch = overload;
                }
                if (fuzzyMatch != null) return fuzzyMatch;
                throw A.wrapException(A.StateError$("BuiltInCallable " + this.name + " may not have empty overloads."));
            },
            withName$1: function($name) {
                return new A.BuiltInCallable($name, this._overloads, this.acceptsContent);
            },
            withDeprecationWarning$2: function(module, newName) {
                var t2, t3, _i, t4, t5, _this = this, t1 = A._setArrayType([], type$.JSArray_Record_2_ParameterList_and_Value_Function_List_Value);
                for(t2 = _this._overloads, t3 = t2.length, _i = 0; _i < t2.length; t2.length === t3 || (0, A.throwConcurrentModificationError)(t2), ++_i){
                    t4 = {};
                    t5 = t2[_i];
                    t4.$function = null;
                    t4.$function = t5._1;
                    t1.push(new A._Record_2(t5._0, new A.BuiltInCallable_withDeprecationWarning_closure(t4, _this, module, newName)));
                }
                return new A.BuiltInCallable(_this.name, t1, _this.acceptsContent);
            },
            withDeprecationWarning$1: function(module) {
                return this.withDeprecationWarning$2(module, null);
            },
            $isCallable0: 1,
            $isAsyncCallable: 1,
            $isAsyncBuiltInCallable: 1,
            get$name: function(receiver) {
                return this.name;
            },
            get$acceptsContent: function() {
                return this.acceptsContent;
            }
        };
        A.BuiltInCallable$mixin_closure.prototype = {
            call$1: function($arguments) {
                this.callback.call$1($arguments);
                return B.C__SassNull;
            },
            $signature: 5
        };
        A.BuiltInCallable_withDeprecationWarning_closure.prototype = {
            call$1: function(args) {
                var _this = this, t1 = _this.newName;
                if (t1 == null) t1 = _this.$this.name;
                A.warnForDeprecation(string$.Global + _this.module + "." + t1 + string$.x20inste, B.Deprecation_WW3);
                return _this._box_0.$function.call$1(args);
            },
            $signature: 5
        };
        A.PlainCssCallable.prototype = {
            $eq: function(_, other) {
                if (other == null) return false;
                return other instanceof A.PlainCssCallable && this.name === other.name;
            },
            get$hashCode: function(_) {
                return B.JSString_methods.get$hashCode(this.name);
            },
            $isCallable0: 1,
            $isAsyncCallable: 1,
            get$name: function(receiver) {
                return this.name;
            }
        };
        A.UserDefinedCallable.prototype = {
            get$name: function(_) {
                return this.declaration.name;
            },
            $isCallable0: 1,
            $isAsyncCallable: 1
        };
        A._compileStylesheet_closure.prototype = {
            call$1: function(url) {
                var t1;
                if (url === "") {
                    t1 = this.stylesheet.span;
                    t1 = A.Uri_Uri$dataFromString(A.String_String$fromCharCodes(B.NativeUint32List_methods.sublist$2(t1.get$file(t1)._decodedChars, 0, null), 0, null), B.C_Utf8Codec, null).get$_text();
                } else t1 = this.importCache.sourceMapUrl$1(0, A.Uri_parse(url)).toString$0(0);
                return t1;
            },
            $signature: 6
        };
        A.CompileResult.prototype = {};
        A.Configuration.prototype = {
            throughForward$1: function($forward) {
                var _0_0, _1_0, _2_0, t1, hiddenVariables, newValues = this._configuration$_values;
                if (newValues.get$isEmpty(newValues)) return this;
                _0_0 = $forward.prefix;
                if (_0_0 != null) newValues = new A.UnprefixedMapView(newValues, _0_0, type$.UnprefixedMapView_ConfiguredValue);
                _1_0 = $forward.shownVariables;
                if (_1_0 != null) newValues = new A.LimitedMapView(newValues, _1_0._base.intersection$1(new A.MapKeySet(newValues, type$.MapKeySet_nullable_Object)), type$.LimitedMapView_String_ConfiguredValue);
                else {
                    _2_0 = $forward.hiddenVariables;
                    if (_2_0 != null) {
                        t1 = _2_0._base.get$isNotEmpty(0);
                        hiddenVariables = _2_0;
                    } else {
                        hiddenVariables = null;
                        t1 = false;
                    }
                    if (t1) newValues = A.LimitedMapView$blocklist(newValues, hiddenVariables, type$.String, type$.ConfiguredValue);
                }
                return this._withValues$1(newValues);
            },
            _withValues$1: function(values) {
                var t1 = this.__originalConfiguration;
                return new A.Configuration(values, t1 == null ? this : t1);
            },
            toString$0: function(_) {
                var t2, t3, t1 = A._setArrayType([], type$.JSArray_String);
                for(t2 = A.MapExtensions_get_pairs(new A.UnmodifiableMapView(this._configuration$_values, type$.UnmodifiableMapView_String_ConfiguredValue), type$.String, type$.ConfiguredValue), t2 = t2.get$iterator(t2); t2.moveNext$0();){
                    t3 = t2.get$current(t2);
                    t1.push("$" + t3._0 + ": " + t3._1.toString$0(0));
                }
                return "(" + B.JSArray_methods.join$1(t1, ",") + ")";
            }
        };
        A.ExplicitConfiguration.prototype = {
            _withValues$1: function(values) {
                var t1 = this.__originalConfiguration;
                if (t1 == null) t1 = this;
                return new A.ExplicitConfiguration(this.nodeWithSpan, values, t1);
            }
        };
        A.ConfiguredValue.prototype = {
            toString$0: function(_) {
                return this.value.toString$0(0);
            }
        };
        A.Deprecation.prototype = {
            _enumToString$0: function() {
                return "Deprecation." + this._name;
            },
            toString$0: function(_) {
                return this.id;
            }
        };
        A.Deprecation_fromId_closure.prototype = {
            call$1: function(deprecation) {
                return deprecation.id === this.id;
            },
            $signature: 668
        };
        A.Environment.prototype = {
            closure$0: function() {
                var t4, t5, t6, _this = this, t1 = _this._forwardedModules, t2 = _this._nestedForwardedModules, t3 = _this._variables;
                t3 = A._setArrayType(t3.slice(0), A._arrayInstanceType(t3));
                t4 = _this._variableNodes;
                t4 = A._setArrayType(t4.slice(0), A._arrayInstanceType(t4));
                t5 = _this._functions;
                t5 = A._setArrayType(t5.slice(0), A._arrayInstanceType(t5));
                t6 = _this._mixins;
                t6 = A._setArrayType(t6.slice(0), A._arrayInstanceType(t6));
                return A.Environment$_(_this._environment$_modules, _this._namespaceNodes, _this._globalModules, _this._importedModules, t1, t2, _this._allModules, t3, t4, t5, t6, _this._content, B.Set_empty1);
            },
            forwardModule$2: function(module, rule) {
                var view, t1, t2, _this = this, forwardedModules = _this._forwardedModules;
                if (forwardedModules == null) forwardedModules = _this._forwardedModules = A.LinkedHashMap_LinkedHashMap$_empty(type$.Module_Callable, type$.AstNode);
                view = A.ForwardedModuleView_ifNecessary(module, rule, type$.Callable);
                for(t1 = new A.LinkedHashMapKeyIterator(forwardedModules, forwardedModules._modifications, forwardedModules._first); t1.moveNext$0();){
                    t2 = t1.__js_helper$_current;
                    _this._assertNoConflicts$5(view.get$variables(), t2.get$variables(), view, t2, "variable");
                    _this._assertNoConflicts$5(view.get$functions(view), t2.get$functions(t2), view, t2, "function");
                    _this._assertNoConflicts$5(view.get$mixins(), t2.get$mixins(), view, t2, "mixin");
                }
                _this._allModules.push(module);
                forwardedModules.$indexSet(0, view, rule);
            },
            _assertNoConflicts$5: function(newMembers, oldMembers, newModule, oldModule, type) {
                var larger, smaller, t1, t2, t3, t4, $name, small, large, span;
                if (newMembers.get$length(newMembers) < oldMembers.get$length(oldMembers)) {
                    larger = oldMembers;
                    smaller = newMembers;
                } else {
                    larger = newMembers;
                    smaller = oldMembers;
                }
                for(t1 = type$.String, t2 = A.MapExtensions_get_pairs(smaller, t1, type$.Object), t2 = t2.get$iterator(t2), t3 = type === "variable"; t2.moveNext$0();){
                    t4 = t2.get$current(t2);
                    $name = t4._0;
                    small = t4._1;
                    large = larger.$index(0, $name);
                    if (large == null) continue;
                    if (t3 ? newModule.variableIdentity$1($name) === oldModule.variableIdentity$1($name) : J.$eq$(large, small)) continue;
                    if (t3) $name = "$" + $name;
                    t2 = this._forwardedModules;
                    if (t2 == null) span = null;
                    else {
                        t2 = t2.$index(0, oldModule);
                        span = t2 == null ? null : t2.get$span(t2);
                    }
                    t2 = A.LinkedHashMap_LinkedHashMap$_empty(type$.FileSpan, t1);
                    if (span != null) t2.$indexSet(0, span, "original @forward");
                    throw A.wrapException(A.MultiSpanSassScriptException$("Two forwarded modules both define a " + type + " named " + $name + ".", "new @forward", t2));
                }
            },
            importForwards$1: function(module) {
                var forwardedModules, t1, t2, t3, t4, node, t5, t6, t7, t8, t9, t10, _i, t11, shadowed, t12, t13, _length, _list, _this = this, forwarded = module._environment$_environment._forwardedModules;
                if (forwarded == null) return;
                forwardedModules = _this._forwardedModules;
                if (forwardedModules != null) {
                    t1 = type$.Module_Callable;
                    t2 = type$.AstNode;
                    t3 = A.LinkedHashMap_LinkedHashMap$_empty(t1, t2);
                    for(t1 = A.MapExtensions_get_pairs(forwarded, t1, t2), t1 = t1.get$iterator(t1), t2 = _this._globalModules; t1.moveNext$0();){
                        t4 = t1.get$current(t1);
                        module = t4._0;
                        node = t4._1;
                        if (!forwardedModules.containsKey$1(module) || !t2.containsKey$1(module)) t3.$indexSet(0, module, node);
                    }
                    forwarded = t3;
                } else forwardedModules = _this._forwardedModules = A.LinkedHashMap_LinkedHashMap$_empty(type$.Module_Callable, type$.AstNode);
                t1 = type$.String;
                t2 = A.LinkedHashSet_LinkedHashSet$_empty(t1);
                for(t3 = new A.LinkedHashMapKeyIterator(forwarded, forwarded._modifications, forwarded._first); t3.moveNext$0();)for(t4 = t3.__js_helper$_current.get$variables(), t4 = t4.get$keys(t4), t4 = t4.get$iterator(t4); t4.moveNext$0();)t2.add$1(0, t4.get$current(t4));
                t3 = A.LinkedHashSet_LinkedHashSet$_empty(t1);
                for(t4 = new A.LinkedHashMapKeyIterator(forwarded, forwarded._modifications, forwarded._first); t4.moveNext$0();){
                    t5 = t4.__js_helper$_current;
                    for(t5 = t5.get$functions(t5), t5 = t5.get$keys(t5), t5 = t5.get$iterator(t5); t5.moveNext$0();)t3.add$1(0, t5.get$current(t5));
                }
                t1 = A.LinkedHashSet_LinkedHashSet$_empty(t1);
                for(t4 = new A.LinkedHashMapKeyIterator(forwarded, forwarded._modifications, forwarded._first); t4.moveNext$0();)for(t5 = t4.__js_helper$_current.get$mixins(), t5 = t5.get$keys(t5), t5 = t5.get$iterator(t5); t5.moveNext$0();)t1.add$1(0, t5.get$current(t5));
                t4 = _this._variables;
                t5 = t4.length;
                if (t5 === 1) {
                    for(t5 = _this._importedModules, t6 = type$.Module_Callable, t7 = type$.AstNode, t8 = A.MapExtensions_get_pairs(t5, t6, t7).toList$0(0), t9 = t8.length, t10 = type$.Callable, _i = 0; _i < t8.length; t8.length === t9 || (0, A.throwConcurrentModificationError)(t8), ++_i){
                        t11 = t8[_i];
                        module = t11._0;
                        shadowed = A.ShadowedModuleView_ifNecessary(module, t3, t1, t2, t10);
                        if (shadowed != null) {
                            t5.remove$1(0, module);
                            t12 = shadowed.variables;
                            t13 = false;
                            if (t12.get$isEmpty(t12)) {
                                t12 = shadowed.functions;
                                if (t12.get$isEmpty(t12)) {
                                    t12 = shadowed.mixins;
                                    if (t12.get$isEmpty(t12)) {
                                        t12 = shadowed._shadowed_view$_inner;
                                        t12 = t12.get$css(t12);
                                        t12 = J.get$isEmpty$asx(t12.get$children(t12));
                                    } else t12 = t13;
                                } else t12 = t13;
                            } else t12 = t13;
                            if (!t12) t5.$indexSet(0, shadowed, t11._1);
                        }
                    }
                    for(t6 = A.MapExtensions_get_pairs(forwardedModules, t6, t7).toList$0(0), t7 = t6.length, _i = 0; _i < t6.length; t6.length === t7 || (0, A.throwConcurrentModificationError)(t6), ++_i){
                        t8 = t6[_i];
                        module = t8._0;
                        shadowed = A.ShadowedModuleView_ifNecessary(module, t3, t1, t2, t10);
                        if (shadowed != null) {
                            forwardedModules.remove$1(0, module);
                            t9 = shadowed.variables;
                            t11 = false;
                            if (t9.get$isEmpty(t9)) {
                                t9 = shadowed.functions;
                                if (t9.get$isEmpty(t9)) {
                                    t9 = shadowed.mixins;
                                    if (t9.get$isEmpty(t9)) {
                                        t9 = shadowed._shadowed_view$_inner;
                                        t9 = t9.get$css(t9);
                                        t9 = J.get$isEmpty$asx(t9.get$children(t9));
                                    } else t9 = t11;
                                } else t9 = t11;
                            } else t9 = t11;
                            if (!t9) forwardedModules.$indexSet(0, shadowed, t8._1);
                        }
                    }
                    t5.addAll$1(0, forwarded);
                    forwardedModules.addAll$1(0, forwarded);
                } else {
                    t6 = _this._nestedForwardedModules;
                    if (t6 == null) {
                        _length = t5 - 1;
                        _list = J.JSArray_JSArray$allocateGrowable(_length, type$.List_Module_Callable);
                        for(t5 = type$.JSArray_Module_Callable, _i = 0; _i < _length; ++_i)_list[_i] = A._setArrayType([], t5);
                        _this._nestedForwardedModules = _list;
                        t5 = _list;
                    } else t5 = t6;
                    B.JSArray_methods.addAll$1(B.JSArray_methods.get$last(t5), new A.LinkedHashMapKeysIterable(forwarded, A._instanceType(forwarded)._eval$1("LinkedHashMapKeysIterable<1>")));
                }
                for(t2 = A._LinkedHashSetIterator$(t2, t2._collection$_modifications, t2.$ti._precomputed1), t5 = _this._variableIndices, t6 = _this._variableNodes, t7 = t2.$ti._precomputed1; t2.moveNext$0();){
                    t8 = t2._collection$_current;
                    if (t8 == null) t8 = t7._as(t8);
                    t5.remove$1(0, t8);
                    B.JSArray_methods.get$last(t4).remove$1(0, t8);
                    B.JSArray_methods.get$last(t6).remove$1(0, t8);
                }
                for(t2 = A._LinkedHashSetIterator$(t3, t3._collection$_modifications, t3.$ti._precomputed1), t3 = _this._functionIndices, t4 = _this._functions, t5 = t2.$ti._precomputed1; t2.moveNext$0();){
                    t6 = t2._collection$_current;
                    if (t6 == null) t6 = t5._as(t6);
                    t3.remove$1(0, t6);
                    B.JSArray_methods.get$last(t4).remove$1(0, t6);
                }
                for(t1 = A._LinkedHashSetIterator$(t1, t1._collection$_modifications, t1.$ti._precomputed1), t2 = _this._mixinIndices, t3 = _this._mixins, t4 = t1.$ti._precomputed1; t1.moveNext$0();){
                    t5 = t1._collection$_current;
                    if (t5 == null) t5 = t4._as(t5);
                    t2.remove$1(0, t5);
                    B.JSArray_methods.get$last(t3).remove$1(0, t5);
                }
            },
            getVariable$2$namespace: function($name, namespace) {
                var t1, _0_0, _1_0, _this = this;
                if (namespace != null) return _this._getModule$1(namespace).get$variables().$index(0, $name);
                if (_this._lastVariableName === $name) {
                    t1 = _this._lastVariableIndex;
                    t1.toString;
                    t1 = _this._variables[t1].$index(0, $name);
                    return t1 == null ? _this._getVariableFromGlobalModule$1($name) : t1;
                }
                t1 = _this._variableIndices;
                _0_0 = t1.$index(0, $name);
                if (_0_0 != null) {
                    _this._lastVariableName = $name;
                    _this._lastVariableIndex = _0_0;
                    t1 = _this._variables[_0_0].$index(0, $name);
                    return t1 == null ? _this._getVariableFromGlobalModule$1($name) : t1;
                } else {
                    _1_0 = _this._variableIndex$1($name);
                    if (_1_0 != null) {
                        _this._lastVariableName = $name;
                        _this._lastVariableIndex = _1_0;
                        t1.$indexSet(0, $name, _1_0);
                        t1 = _this._variables[_1_0].$index(0, $name);
                        return t1 == null ? _this._getVariableFromGlobalModule$1($name) : t1;
                    } else return _this._getVariableFromGlobalModule$1($name);
                }
            },
            getVariable$1: function($name) {
                return this.getVariable$2$namespace($name, null);
            },
            _getVariableFromGlobalModule$1: function($name) {
                return this._fromOneModule$3($name, "variable", new A.Environment__getVariableFromGlobalModule_closure($name));
            },
            getVariableNode$2$namespace: function($name, namespace) {
                var t1, _0_0, _1_0, _this = this;
                if (namespace != null) return _this._getModule$1(namespace).get$variableNodes().$index(0, $name);
                if (_this._lastVariableName === $name) {
                    t1 = _this._lastVariableIndex;
                    t1.toString;
                    t1 = _this._variableNodes[t1].$index(0, $name);
                    return t1 == null ? _this._getVariableNodeFromGlobalModule$1($name) : t1;
                }
                t1 = _this._variableIndices;
                _0_0 = t1.$index(0, $name);
                if (_0_0 != null) {
                    _this._lastVariableName = $name;
                    _this._lastVariableIndex = _0_0;
                    t1 = _this._variableNodes[_0_0].$index(0, $name);
                    return t1 == null ? _this._getVariableNodeFromGlobalModule$1($name) : t1;
                } else {
                    _1_0 = _this._variableIndex$1($name);
                    if (_1_0 != null) {
                        _this._lastVariableName = $name;
                        _this._lastVariableIndex = _1_0;
                        t1.$indexSet(0, $name, _1_0);
                        t1 = _this._variableNodes[_1_0].$index(0, $name);
                        return t1 == null ? _this._getVariableNodeFromGlobalModule$1($name) : t1;
                    } else return _this._getVariableNodeFromGlobalModule$1($name);
                }
            },
            _getVariableNodeFromGlobalModule$1: function($name) {
                var t1, t2, _0_0;
                for(t1 = this._importedModules, t2 = this._globalModules, t2 = new A.LinkedHashMapKeysIterable(t1, A._instanceType(t1)._eval$1("LinkedHashMapKeysIterable<1>")).followedBy$1(0, new A.LinkedHashMapKeysIterable(t2, A._instanceType(t2)._eval$1("LinkedHashMapKeysIterable<1>"))), t2 = new A.FollowedByIterator(J.get$iterator$ax(t2.__internal$_first), t2._second); t2.moveNext$0();){
                    t1 = t2._currentIterator;
                    _0_0 = t1.get$current(t1).get$variableNodes().$index(0, $name);
                    if (_0_0 != null) return _0_0;
                }
                return null;
            },
            globalVariableExists$2$namespace: function($name, namespace) {
                if (namespace != null) return this._getModule$1(namespace).get$variables().containsKey$1($name);
                if (B.JSArray_methods.get$first(this._variables).containsKey$1($name)) return true;
                return this._getVariableFromGlobalModule$1($name) != null;
            },
            globalVariableExists$1: function($name) {
                return this.globalVariableExists$2$namespace($name, null);
            },
            _variableIndex$1: function($name) {
                var t1, i;
                for(t1 = this._variables, i = t1.length - 1; i >= 0; --i)if (t1[i].containsKey$1($name)) return i;
                return null;
            },
            setVariable$5$global$namespace: function($name, value, nodeWithSpan, global, namespace) {
                var t1, moduleWithName, nestedForwardedModules, t2, t3, t4, t5, index, _this = this;
                if (namespace != null) {
                    _this._getModule$1(namespace).setVariable$3($name, value, nodeWithSpan);
                    return;
                }
                if (global || _this._variables.length === 1) {
                    _this._variableIndices.putIfAbsent$2($name, new A.Environment_setVariable_closure(_this, $name));
                    t1 = _this._variables;
                    if (!B.JSArray_methods.get$first(t1).containsKey$1($name)) {
                        moduleWithName = _this._fromOneModule$3($name, "variable", new A.Environment_setVariable_closure0($name));
                        if (moduleWithName != null) {
                            moduleWithName.setVariable$3($name, value, nodeWithSpan);
                            return;
                        }
                    }
                    B.JSArray_methods.get$first(t1).$indexSet(0, $name, value);
                    B.JSArray_methods.get$first(_this._variableNodes).$indexSet(0, $name, nodeWithSpan);
                    return;
                }
                nestedForwardedModules = _this._nestedForwardedModules;
                if (nestedForwardedModules != null && !_this._variableIndices.containsKey$1($name) && _this._variableIndex$1($name) == null) for(t1 = A._arrayInstanceType(nestedForwardedModules)._eval$1("ReversedListIterable<1>"), t2 = new A.ReversedListIterable(nestedForwardedModules, t1), t2 = new A.ListIterator(t2, t2.get$length(0), t1._eval$1("ListIterator<ListIterable.E>")), t1 = t1._eval$1("ListIterable.E"); t2.moveNext$0();){
                    t3 = t2.__internal$_current;
                    for(t3 = J.get$reversed$ax(t3 == null ? t1._as(t3) : t3), t4 = t3.$ti, t3 = new A.ListIterator(t3, t3.get$length(0), t4._eval$1("ListIterator<ListIterable.E>")), t4 = t4._eval$1("ListIterable.E"); t3.moveNext$0();){
                        t5 = t3.__internal$_current;
                        if (t5 == null) t5 = t4._as(t5);
                        if (t5.get$variables().containsKey$1($name)) {
                            t5.setVariable$3($name, value, nodeWithSpan);
                            return;
                        }
                    }
                }
                if (_this._lastVariableName === $name) {
                    t1 = _this._lastVariableIndex;
                    t1.toString;
                    index = t1;
                } else index = _this._variableIndices.putIfAbsent$2($name, new A.Environment_setVariable_closure1(_this, $name));
                if (!_this._inSemiGlobalScope && index === 0) {
                    index = _this._variables.length - 1;
                    _this._variableIndices.$indexSet(0, $name, index);
                }
                _this._lastVariableName = $name;
                _this._lastVariableIndex = index;
                _this._variables[index].$indexSet(0, $name, value);
                _this._variableNodes[index].$indexSet(0, $name, nodeWithSpan);
            },
            setVariable$4$global: function($name, value, nodeWithSpan, global) {
                return this.setVariable$5$global$namespace($name, value, nodeWithSpan, global, null);
            },
            setLocalVariable$3: function($name, value, nodeWithSpan) {
                var index, _this = this, t1 = _this._variables, t2 = t1.length;
                _this._lastVariableName = $name;
                index = _this._lastVariableIndex = t2 - 1;
                _this._variableIndices.$indexSet(0, $name, index);
                t1[index].$indexSet(0, $name, value);
                _this._variableNodes[index].$indexSet(0, $name, nodeWithSpan);
            },
            getFunction$2$namespace: function($name, namespace) {
                var t1, _0_0, _1_0, _this = this;
                if (namespace != null) {
                    t1 = _this._getModule$1(namespace);
                    return t1.get$functions(t1).$index(0, $name);
                }
                t1 = _this._functionIndices;
                _0_0 = t1.$index(0, $name);
                if (_0_0 != null) {
                    t1 = _this._functions[_0_0].$index(0, $name);
                    return t1 == null ? _this._getFunctionFromGlobalModule$1($name) : t1;
                } else {
                    _1_0 = _this._functionIndex$1($name);
                    if (_1_0 != null) {
                        t1.$indexSet(0, $name, _1_0);
                        t1 = _this._functions[_1_0].$index(0, $name);
                        return t1 == null ? _this._getFunctionFromGlobalModule$1($name) : t1;
                    } else return _this._getFunctionFromGlobalModule$1($name);
                }
            },
            getFunction$1: function($name) {
                return this.getFunction$2$namespace($name, null);
            },
            _getFunctionFromGlobalModule$1: function($name) {
                return this._fromOneModule$3($name, "function", new A.Environment__getFunctionFromGlobalModule_closure($name));
            },
            _functionIndex$1: function($name) {
                var t1, i;
                for(t1 = this._functions, i = t1.length - 1; i >= 0; --i)if (t1[i].containsKey$1($name)) return i;
                return null;
            },
            getMixin$2$namespace: function($name, namespace) {
                var t1, _0_0, _1_0, _this = this;
                if (namespace != null) return _this._getModule$1(namespace).get$mixins().$index(0, $name);
                t1 = _this._mixinIndices;
                _0_0 = t1.$index(0, $name);
                if (_0_0 != null) {
                    t1 = _this._mixins[_0_0].$index(0, $name);
                    return t1 == null ? _this._getMixinFromGlobalModule$1($name) : t1;
                } else {
                    _1_0 = _this._mixinIndex$1($name);
                    if (_1_0 != null) {
                        t1.$indexSet(0, $name, _1_0);
                        t1 = _this._mixins[_1_0].$index(0, $name);
                        return t1 == null ? _this._getMixinFromGlobalModule$1($name) : t1;
                    } else return _this._getMixinFromGlobalModule$1($name);
                }
            },
            _getMixinFromGlobalModule$1: function($name) {
                return this._fromOneModule$3($name, "mixin", new A.Environment__getMixinFromGlobalModule_closure($name));
            },
            _mixinIndex$1: function($name) {
                var t1, i;
                for(t1 = this._mixins, i = t1.length - 1; i >= 0; --i)if (t1[i].containsKey$1($name)) return i;
                return null;
            },
            withContent$2: function($content, callback) {
                var oldContent = this._content;
                this._content = $content;
                callback.call$0();
                this._content = oldContent;
            },
            asMixin$1: function(callback) {
                var oldInMixin = this._inMixin;
                this._inMixin = true;
                callback.call$0();
                this._inMixin = oldInMixin;
            },
            scope$1$3$semiGlobal$when: function(callback, semiGlobal, when) {
                var wasInSemiGlobalScope, $name, name0, name1, t1, t2, t3, t4, t5, t6, _this = this;
                semiGlobal = semiGlobal && _this._inSemiGlobalScope;
                wasInSemiGlobalScope = _this._inSemiGlobalScope;
                _this._inSemiGlobalScope = semiGlobal;
                if (!when) try {
                    t1 = callback.call$0();
                    return t1;
                } finally{
                    _this._inSemiGlobalScope = wasInSemiGlobalScope;
                }
                t1 = _this._variables;
                t2 = type$.String;
                B.JSArray_methods.add$1(t1, A.LinkedHashMap_LinkedHashMap$_empty(t2, type$.Value));
                t3 = _this._variableNodes;
                B.JSArray_methods.add$1(t3, A.LinkedHashMap_LinkedHashMap$_empty(t2, type$.AstNode));
                t4 = _this._functions;
                t5 = type$.Callable;
                B.JSArray_methods.add$1(t4, A.LinkedHashMap_LinkedHashMap$_empty(t2, t5));
                t6 = _this._mixins;
                B.JSArray_methods.add$1(t6, A.LinkedHashMap_LinkedHashMap$_empty(t2, t5));
                t5 = _this._nestedForwardedModules;
                if (t5 != null) t5.push(A._setArrayType([], type$.JSArray_Module_Callable));
                try {
                    t2 = callback.call$0();
                    return t2;
                } finally{
                    _this._inSemiGlobalScope = wasInSemiGlobalScope;
                    _this._lastVariableIndex = _this._lastVariableName = null;
                    for(t1 = B.JSArray_methods.removeLast$0(t1), t1 = t1.get$keys(t1), t1 = t1.get$iterator(t1), t2 = _this._variableIndices; t1.moveNext$0();){
                        $name = t1.get$current(t1);
                        t2.remove$1(0, $name);
                    }
                    B.JSArray_methods.removeLast$0(t3);
                    for(t1 = B.JSArray_methods.removeLast$0(t4), t1 = t1.get$keys(t1), t1 = t1.get$iterator(t1), t2 = _this._functionIndices; t1.moveNext$0();){
                        name0 = t1.get$current(t1);
                        t2.remove$1(0, name0);
                    }
                    for(t1 = B.JSArray_methods.removeLast$0(t6), t1 = t1.get$keys(t1), t1 = t1.get$iterator(t1), t2 = _this._mixinIndices; t1.moveNext$0();){
                        name1 = t1.get$current(t1);
                        t2.remove$1(0, name1);
                    }
                    t1 = _this._nestedForwardedModules;
                    if (t1 != null) t1.pop();
                }
            },
            scope$1$1: function(callback) {
                return this.scope$1$3$semiGlobal$when(callback, false, true);
            },
            scope$1$2$when: function(callback, when) {
                return this.scope$1$3$semiGlobal$when(callback, false, when);
            },
            scope$1$2$semiGlobal: function(callback, semiGlobal) {
                return this.scope$1$3$semiGlobal$when(callback, semiGlobal, true);
            },
            toImplicitConfiguration$0: function() {
                var t2, t3, t4, t5, t6, i, modules, t7, t8, t9, t10, $name, value, values, nodes, _this = this, _null = null, t1 = type$.String, configuration = A.LinkedHashMap_LinkedHashMap$_empty(t1, type$.ConfiguredValue);
                for(t2 = _this._variables, t3 = type$.Value, t4 = _this._variableNodes, t5 = _this._importedModules, t6 = A._instanceType(t5)._eval$1("LinkedHashMapKeysIterable<1>"), i = 0; i < t2.length; ++i){
                    if (i === 0) modules = new A.LinkedHashMapKeysIterable(t5, t6);
                    else {
                        t7 = _this._nestedForwardedModules;
                        modules = t7 == null ? _null : t7[i - 1];
                    }
                    t7 = J.get$iterator$ax(modules == null ? B.List_empty10 : modules);
                    while(t7.moveNext$0()){
                        t8 = t7.get$current(t7);
                        for(t9 = A.MapExtensions_get_pairs(t8.get$variables(), t1, t3), t9 = t9.get$iterator(t9); t9.moveNext$0();){
                            t10 = t9.get$current(t9);
                            $name = t10._0;
                            value = t10._1;
                            t10 = t8.get$variableNodes().$index(0, $name);
                            t10.toString;
                            configuration.$indexSet(0, $name, new A.ConfiguredValue(value, _null, t10));
                        }
                    }
                    values = t2[i];
                    nodes = t4[i];
                    for(t7 = A.MapExtensions_get_pairs(values, t1, t3), t7 = t7.get$iterator(t7); t7.moveNext$0();){
                        t8 = t7.get$current(t7);
                        $name = t8._0;
                        value = t8._1;
                        t8 = nodes.$index(0, $name);
                        t8.toString;
                        configuration.$indexSet(0, $name, new A.ConfiguredValue(value, _null, t8));
                    }
                }
                return new A.Configuration(configuration, _null);
            },
            toModule$3: function(css, preModuleComments, extensionStore) {
                return A._EnvironmentModule__EnvironmentModule(this, css, preModuleComments, extensionStore, A.NullableExtension_andThen(this._forwardedModules, new A.Environment_toModule_closure()));
            },
            toDummyModule$0: function() {
                return A._EnvironmentModule__EnvironmentModule(this, new A.CssStylesheet(new A.UnmodifiableListView(B.List_empty3, type$.UnmodifiableListView_CssNode), A.SourceFile$decoded(B.List_empty4, "<dummy module>").span$1(0, 0)), B.Map_empty, B.C_EmptyExtensionStore, A.NullableExtension_andThen(this._forwardedModules, new A.Environment_toDummyModule_closure()));
            },
            _getModule$1: function(namespace) {
                var _0_0 = this._environment$_modules.$index(0, namespace);
                if (_0_0 != null) return _0_0;
                throw A.wrapException(A.SassScriptException$('There is no module with the namespace "' + namespace + '".', null));
            },
            _fromOneModule$1$3: function($name, type, callback) {
                var t1, t2, t3, t4, t5, _1_0, _2_0, value, identity, valueInModule, identityFromModule, module, node, _0_0 = this._nestedForwardedModules;
                if (_0_0 != null) for(t1 = A._arrayInstanceType(_0_0)._eval$1("ReversedListIterable<1>"), t2 = new A.ReversedListIterable(_0_0, t1), t2 = new A.ListIterator(t2, t2.get$length(0), t1._eval$1("ListIterator<ListIterable.E>")), t1 = t1._eval$1("ListIterable.E"); t2.moveNext$0();){
                    t3 = t2.__internal$_current;
                    for(t3 = J.get$reversed$ax(t3 == null ? t1._as(t3) : t3), t4 = t3.$ti, t3 = new A.ListIterator(t3, t3.get$length(0), t4._eval$1("ListIterator<ListIterable.E>")), t4 = t4._eval$1("ListIterable.E"); t3.moveNext$0();){
                        t5 = t3.__internal$_current;
                        _1_0 = callback.call$1(t5 == null ? t4._as(t5) : t5);
                        if (_1_0 != null) return _1_0;
                    }
                }
                for(t1 = this._importedModules, t1 = new A.LinkedHashMapKeyIterator(t1, t1._modifications, t1._first); t1.moveNext$0();){
                    _2_0 = callback.call$1(t1.__js_helper$_current);
                    if (_2_0 != null) return _2_0;
                }
                for(t1 = this._globalModules, t2 = new A.LinkedHashMapKeyIterator(t1, t1._modifications, t1._first), t3 = type$.Callable, value = null, identity = null; t2.moveNext$0();){
                    t4 = t2.__js_helper$_current;
                    valueInModule = callback.call$1(t4);
                    if (valueInModule == null) continue;
                    identityFromModule = t3._is(valueInModule) ? valueInModule : t4.variableIdentity$1($name);
                    if (identityFromModule.$eq(0, identity)) continue;
                    if (value != null) {
                        t2 = A.LinkedHashMap_LinkedHashMap$_empty(type$.FileSpan, type$.String);
                        for(t3 = A.MapExtensions_get_pairs(t1, type$.Module_Callable, type$.AstNode), t3 = t3.get$iterator(t3), t4 = "includes " + type; t3.moveNext$0();){
                            t1 = t3.get$current(t3);
                            module = t1._0;
                            node = t1._1;
                            if (callback.call$1(module) != null) t2.$indexSet(0, node.get$span(node), t4);
                        }
                        throw A.wrapException(A.MultiSpanSassScriptException$("This " + type + string$.x20is_av, type + " use", t2));
                    }
                    identity = identityFromModule;
                    value = valueInModule;
                }
                return value;
            },
            _fromOneModule$3: function($name, type, callback) {
                return this._fromOneModule$1$3($name, type, callback, type$.dynamic);
            }
        };
        A.Environment__getVariableFromGlobalModule_closure.prototype = {
            call$1: function(module) {
                return module.get$variables().$index(0, this.name);
            },
            $signature: 280
        };
        A.Environment_setVariable_closure.prototype = {
            call$0: function() {
                var t1 = this.$this;
                t1._lastVariableName = this.name;
                return t1._lastVariableIndex = 0;
            },
            $signature: 10
        };
        A.Environment_setVariable_closure0.prototype = {
            call$1: function(module) {
                return module.get$variables().containsKey$1(this.name) ? module : null;
            },
            $signature: 289
        };
        A.Environment_setVariable_closure1.prototype = {
            call$0: function() {
                var t1 = this.$this, t2 = t1._variableIndex$1(this.name);
                return t2 == null ? t1._variables.length - 1 : t2;
            },
            $signature: 10
        };
        A.Environment__getFunctionFromGlobalModule_closure.prototype = {
            call$1: function(module) {
                return module.get$functions(module).$index(0, this.name);
            },
            $signature: 198
        };
        A.Environment__getMixinFromGlobalModule_closure.prototype = {
            call$1: function(module) {
                return module.get$mixins().$index(0, this.name);
            },
            $signature: 198
        };
        A.Environment_toModule_closure.prototype = {
            call$1: function(modules) {
                return new A.MapKeySet(modules, type$.MapKeySet_Module_Callable);
            },
            $signature: 201
        };
        A.Environment_toDummyModule_closure.prototype = {
            call$1: function(modules) {
                return new A.MapKeySet(modules, type$.MapKeySet_Module_Callable);
            },
            $signature: 201
        };
        A._EnvironmentModule.prototype = {
            get$url: function(_) {
                var t1 = this.css;
                t1 = t1.get$span(t1);
                return t1.get$sourceUrl(t1);
            },
            setVariable$3: function($name, value, nodeWithSpan) {
                var t1, t2, _0_0 = this._modulesByVariable.$index(0, $name);
                if (_0_0 != null) {
                    _0_0.setVariable$3($name, value, nodeWithSpan);
                    return;
                }
                t1 = this._environment$_environment;
                t2 = t1._variables;
                if (!B.JSArray_methods.get$first(t2).containsKey$1($name)) throw A.wrapException(A.SassScriptException$("Undefined variable.", null));
                B.JSArray_methods.get$first(t2).$indexSet(0, $name, value);
                B.JSArray_methods.get$first(t1._variableNodes).$indexSet(0, $name, nodeWithSpan);
                return;
            },
            variableIdentity$1: function($name) {
                var module = this._modulesByVariable.$index(0, $name);
                return module == null ? this : module.variableIdentity$1($name);
            },
            couldHaveBeenConfigured$1: function(variables) {
                var t2, t3, _0_0, variable, module, t1 = this._environment$_environment._configurableVariables;
                if (!(variables.get$length(variables) < t1.get$length(t1) ? variables.any$1(0, t1.get$contains(t1)) : t1.any$1(0, variables.get$contains(variables)))) {
                    t1 = this._modulesByVariable;
                    t2 = type$.Module_Callable;
                    if (variables.get$length(variables) < t1.get$length(t1)) {
                        t2 = A.LinkedHashSet_LinkedHashSet$_empty(t2);
                        for(t3 = variables.get$iterator(variables); t3.moveNext$0();){
                            _0_0 = t1.$index(0, t3.get$current(t3));
                            if (_0_0 != null) t2.add$1(0, _0_0);
                        }
                        t1 = t2;
                    } else {
                        t3 = A.LinkedHashSet_LinkedHashSet$_empty(t2);
                        for(t1 = A.MapExtensions_get_pairs(t1, type$.String, t2), t1 = t1.get$iterator(t1); t1.moveNext$0();){
                            t2 = t1.get$current(t1);
                            variable = t2._0;
                            module = t2._1;
                            if (variables.contains$1(0, variable)) t3.add$1(0, module);
                        }
                        t1 = t3;
                    }
                    t1 = t1.any$1(0, new A._EnvironmentModule_couldHaveBeenConfigured_closure(variables));
                } else t1 = true;
                return t1;
            },
            cloneCss$0: function() {
                var _0_0, _this = this;
                if (!_this.transitivelyContainsCss) return _this;
                _0_0 = A.cloneCssStylesheet(_this.css, _this.extensionStore);
                return A._EnvironmentModule$_(_this._environment$_environment, _0_0._0, _this.preModuleComments, _0_0._1, _this._modulesByVariable, _this.variables, _this.variableNodes, _this.functions, _this.mixins, true, _this.transitivelyContainsExtensions);
            },
            toString$0: function(_) {
                var t1 = this.css, t2 = t1.get$span(t1);
                if (t2.get$sourceUrl(t2) == null) t1 = "<unknown url>";
                else {
                    t1 = t1.get$span(t1);
                    t1 = t1.get$sourceUrl(t1);
                    t2 = $.$get$context();
                    t1.toString;
                    t1 = t2.prettyUri$1(t1);
                }
                return t1;
            },
            $isModule0: 1,
            get$upstream: function() {
                return this.upstream;
            },
            get$variables: function() {
                return this.variables;
            },
            get$variableNodes: function() {
                return this.variableNodes;
            },
            get$functions: function(receiver) {
                return this.functions;
            },
            get$mixins: function() {
                return this.mixins;
            },
            get$extensionStore: function() {
                return this.extensionStore;
            },
            get$css: function(receiver) {
                return this.css;
            },
            get$preModuleComments: function() {
                return this.preModuleComments;
            },
            get$transitivelyContainsCss: function() {
                return this.transitivelyContainsCss;
            },
            get$transitivelyContainsExtensions: function() {
                return this.transitivelyContainsExtensions;
            }
        };
        A._EnvironmentModule__EnvironmentModule_closure.prototype = {
            call$1: function(module) {
                return module.get$variables();
            },
            $signature: 306
        };
        A._EnvironmentModule__EnvironmentModule_closure0.prototype = {
            call$1: function(module) {
                return module.get$variableNodes();
            },
            $signature: 307
        };
        A._EnvironmentModule__EnvironmentModule_closure1.prototype = {
            call$1: function(module) {
                return module.get$functions(module);
            },
            $signature: 202
        };
        A._EnvironmentModule__EnvironmentModule_closure2.prototype = {
            call$1: function(module) {
                return module.get$mixins();
            },
            $signature: 202
        };
        A._EnvironmentModule__EnvironmentModule_closure3.prototype = {
            call$1: function(module) {
                return module.get$transitivelyContainsCss();
            },
            $signature: 95
        };
        A._EnvironmentModule__EnvironmentModule_closure4.prototype = {
            call$1: function(module) {
                return module.get$transitivelyContainsExtensions();
            },
            $signature: 95
        };
        A._EnvironmentModule_couldHaveBeenConfigured_closure.prototype = {
            call$1: function(module) {
                return module.couldHaveBeenConfigured$1(this.variables);
            },
            $signature: 95
        };
        A.EvaluationContext.prototype = {};
        A._EvaluationContextLogger.prototype = {
            internalWarn$4$deprecation$span$trace: function(message, deprecation, span, trace) {
                this._evaluation_context$_context.warn$2(0, message, deprecation);
            }
        };
        A.SassException.prototype = {
            get$trace: function(_) {
                return A.Trace$(A._setArrayType([
                    A.frameForSpan(A.SourceSpanException.prototype.get$span.call(this, 0), "root stylesheet", null)
                ], type$.JSArray_Frame), null);
            },
            get$span: function(_) {
                return A.SourceSpanException.prototype.get$span.call(this, 0);
            },
            withAdditionalSpan$2: function(span, label) {
                return A.MultiSpanSassException$(this._span_exception$_message, A.SourceSpanException.prototype.get$span.call(this, 0), "", A.LinkedHashMap_LinkedHashMap$_literal([
                    span,
                    label
                ], type$.FileSpan, type$.String), this.loadedUrls);
            },
            withTrace$1: function(trace) {
                var t1 = A.SourceSpanException.prototype.get$span.call(this, 0), t2 = A.Set_Set$unmodifiable(this.loadedUrls, type$.Uri);
                return new A.SassRuntimeException(trace, t2, this._span_exception$_message, t1);
            },
            withLoadedUrls$1: function(loadedUrls) {
                var t1 = A.SourceSpanException.prototype.get$span.call(this, 0), t2 = A.Set_Set$unmodifiable(loadedUrls, type$.Uri);
                return new A.SassException(t2, this._span_exception$_message, t1);
            },
            toString$1$color: function(_, color) {
                var t2, _i, frame, _this = this, buffer = new A.StringBuffer(""), t1 = "Error: " + _this._span_exception$_message + "\n";
                buffer._contents = t1;
                buffer._contents = t1 + A.SourceSpanException.prototype.get$span.call(_this, 0).highlight$1$color(color);
                for(t1 = _this.get$trace(_this).toString$0(0).split("\n"), t2 = t1.length, _i = 0; _i < t2; ++_i){
                    frame = t1[_i];
                    if (frame.length === 0) continue;
                    buffer._contents = (buffer._contents += "\n") + ("  " + frame);
                }
                t1 = buffer._contents;
                return t1.charCodeAt(0) == 0 ? t1 : t1;
            },
            toString$0: function(_) {
                return this.toString$1$color(0, null);
            },
            toCssString$0: function() {
                var commentMessage, stringMessage, rune, t1 = $._glyphs, t2 = $._glyphs = B.C_AsciiGlyphSet, t3 = this.toString$1$color(0, false);
                t3 = A.stringReplaceAllUnchecked(t3, "*/", "*\u2215");
                commentMessage = A.stringReplaceAllUnchecked(t3, "\r\n", "\n");
                $._glyphs = t1 === B.C_AsciiGlyphSet ? t2 : B.C_UnicodeGlyphSet;
                stringMessage = new A.StringBuffer("");
                for(t1 = new A.RuneIterator(A.serializeValue(new A.SassString(this.toString$1$color(0, false), true), true, true)); t1.moveNext$0();){
                    rune = t1._currentCodePoint;
                    if (rune > 127) {
                        t2 = A.Primitives_stringFromCharCode(92);
                        stringMessage._contents += t2;
                        t2 = B.JSInt_methods.toRadixString$1(rune, 16);
                        stringMessage._contents += t2;
                        t2 = A.Primitives_stringFromCharCode(32);
                        stringMessage._contents += t2;
                    } else {
                        t2 = A.Primitives_stringFromCharCode(rune);
                        stringMessage._contents += t2;
                    }
                }
                return "/* " + B.JSArray_methods.join$1(A._setArrayType(commentMessage.split("\n"), type$.JSArray_String), "\n * ") + ' */\n\nbody::before {\n  font-family: "Source Code Pro", "SF Mono", Monaco, Inconsolata, "Fira Mono",\n      "Droid Sans Mono", monospace, monospace;\n  white-space: pre;\n  display: block;\n  padding: 1em;\n  margin-bottom: 1em;\n  border-bottom: 2px solid black;\n  content: ' + stringMessage.toString$0(0) + ";\n}";
            }
        };
        A.MultiSpanSassException.prototype = {
            withAdditionalSpan$2: function(span, label) {
                var _this = this, t1 = A.SourceSpanException.prototype.get$span.call(_this, 0), t2 = A.LinkedHashMap_LinkedHashMap$of(_this.secondarySpans, type$.FileSpan, type$.String);
                t2.$indexSet(0, span, label);
                return A.MultiSpanSassException$(_this._span_exception$_message, t1, _this.primaryLabel, t2, _this.loadedUrls);
            },
            withTrace$1: function(trace) {
                var _this = this;
                return A.MultiSpanSassRuntimeException$(_this._span_exception$_message, A.SourceSpanException.prototype.get$span.call(_this, 0), _this.primaryLabel, _this.secondarySpans, trace, _this.loadedUrls);
            },
            withLoadedUrls$1: function(loadedUrls) {
                var _this = this;
                return A.MultiSpanSassException$(_this._span_exception$_message, A.SourceSpanException.prototype.get$span.call(_this, 0), _this.primaryLabel, _this.secondarySpans, loadedUrls);
            },
            toString$1$color: function(_, color) {
                var t1, t2, _i, frame, _this = this, useColor = color === true, buffer = new A.StringBuffer("Error: " + _this._span_exception$_message + "\n");
                A.NullableExtension_andThen(A.Highlighter$multiple(A.SourceSpanException.prototype.get$span.call(_this, 0), _this.primaryLabel, _this.secondarySpans, useColor, null, null).highlight$0(), buffer.get$write(buffer));
                for(t1 = _this.get$trace(_this).toString$0(0).split("\n"), t2 = t1.length, _i = 0; _i < t2; ++_i){
                    frame = t1[_i];
                    if (frame.length === 0) continue;
                    buffer._contents = (buffer._contents += "\n") + ("  " + frame);
                }
                t1 = buffer._contents;
                return t1.charCodeAt(0) == 0 ? t1 : t1;
            },
            toString$0: function(_) {
                return this.toString$1$color(0, null);
            },
            get$primaryLabel: function() {
                return this.primaryLabel;
            },
            get$secondarySpans: function() {
                return this.secondarySpans;
            }
        };
        A.SassRuntimeException.prototype = {
            withAdditionalSpan$2: function(span, label) {
                var _this = this;
                return A.MultiSpanSassRuntimeException$(_this._span_exception$_message, A.SourceSpanException.prototype.get$span.call(_this, 0), "", A.LinkedHashMap_LinkedHashMap$_literal([
                    span,
                    label
                ], type$.FileSpan, type$.String), _this.trace, _this.loadedUrls);
            },
            withLoadedUrls$1: function(loadedUrls) {
                var t1 = A.SourceSpanException.prototype.get$span.call(this, 0), t2 = A.Set_Set$unmodifiable(loadedUrls, type$.Uri);
                return new A.SassRuntimeException(this.trace, t2, this._span_exception$_message, t1);
            },
            get$trace: function(receiver) {
                return this.trace;
            }
        };
        A.MultiSpanSassRuntimeException.prototype = {
            withAdditionalSpan$2: function(span, label) {
                var _this = this, t1 = A.SourceSpanException.prototype.get$span.call(_this, 0), t2 = A.LinkedHashMap_LinkedHashMap$of(_this.secondarySpans, type$.FileSpan, type$.String);
                t2.$indexSet(0, span, label);
                return A.MultiSpanSassRuntimeException$(_this._span_exception$_message, t1, _this.primaryLabel, t2, _this.trace, _this.loadedUrls);
            },
            withLoadedUrls$1: function(loadedUrls) {
                var _this = this;
                return A.MultiSpanSassRuntimeException$(_this._span_exception$_message, A.SourceSpanException.prototype.get$span.call(_this, 0), _this.primaryLabel, _this.secondarySpans, _this.trace, loadedUrls);
            },
            $isSassRuntimeException: 1,
            get$trace: function(receiver) {
                return this.trace;
            }
        };
        A.SassFormatException.prototype = {
            get$source: function() {
                var t1 = A.SourceSpanException.prototype.get$span.call(this, 0);
                return A.String_String$fromCharCodes(B.NativeUint32List_methods.sublist$2(t1.get$file(t1)._decodedChars, 0, null), 0, null);
            },
            withAdditionalSpan$2: function(span, label) {
                return A.MultiSpanSassFormatException$(this._span_exception$_message, A.SourceSpanException.prototype.get$span.call(this, 0), "", A.LinkedHashMap_LinkedHashMap$_literal([
                    span,
                    label
                ], type$.FileSpan, type$.String), this.loadedUrls);
            },
            withLoadedUrls$1: function(loadedUrls) {
                var t1 = A.SourceSpanException.prototype.get$span.call(this, 0), t2 = A.Set_Set$unmodifiable(loadedUrls, type$.Uri);
                return new A.SassFormatException(t2, this._span_exception$_message, t1);
            },
            $isFormatException: 1,
            $isSourceSpanFormatException: 1
        };
        A.MultiSpanSassFormatException.prototype = {
            get$source: function() {
                var t1 = A.SourceSpanException.prototype.get$span.call(this, 0);
                return A.String_String$fromCharCodes(B.NativeUint32List_methods.sublist$2(t1.get$file(t1)._decodedChars, 0, null), 0, null);
            },
            withAdditionalSpan$2: function(span, label) {
                var _this = this, t1 = A.SourceSpanException.prototype.get$span.call(_this, 0), t2 = A.LinkedHashMap_LinkedHashMap$of(_this.secondarySpans, type$.FileSpan, type$.String);
                t2.$indexSet(0, span, label);
                return A.MultiSpanSassFormatException$(_this._span_exception$_message, t1, _this.primaryLabel, t2, _this.loadedUrls);
            },
            withLoadedUrls$1: function(loadedUrls) {
                var _this = this;
                return A.MultiSpanSassFormatException$(_this._span_exception$_message, A.SourceSpanException.prototype.get$span.call(_this, 0), _this.primaryLabel, _this.secondarySpans, loadedUrls);
            },
            $isFormatException: 1,
            $isSassFormatException: 1,
            $isSourceSpanFormatException: 1,
            $isMultiSourceSpanFormatException: 1
        };
        A.SassScriptException.prototype = {
            withSpan$1: function(span) {
                return new A.SassException(B.Set_empty, this.message, span);
            },
            toString$0: function(_) {
                return this.message + string$.x0a_BUG_;
            },
            get$message: function(receiver) {
                return this.message;
            }
        };
        A.MultiSpanSassScriptException.prototype = {
            withSpan$1: function(span) {
                return A.MultiSpanSassException$(this.message, span, this.primaryLabel, this.secondarySpans, null);
            }
        };
        A._writeSourceMap_closure.prototype = {
            call$1: function(url) {
                return this.options.sourceMapUrl$2(0, A.Uri_parse(url), this.destination).toString$0(0);
            },
            $signature: 6
        };
        A.ExecutableOptions.prototype = {
            get$interactive: function() {
                var result, _this = this, value = _this.__ExecutableOptions_interactive_FI;
                if (value === $) {
                    result = new A.ExecutableOptions_interactive_closure(_this).call$0();
                    _this.__ExecutableOptions_interactive_FI !== $ && A.throwUnnamedLateFieldADI();
                    _this.__ExecutableOptions_interactive_FI = result;
                    value = result;
                }
                return value;
            },
            get$color: function() {
                var t1 = this._options;
                if (t1.wasParsed$1("color")) t1 = A._asBool(t1.$index(0, "color"));
                else t1 = A.hasTerminal() || A.isBrowser();
                return t1;
            },
            get$pkgImporters: function() {
                var t2, t3, t4, _null = null, t1 = A._setArrayType([], type$.JSArray_Importer);
                for(t2 = J.get$iterator$ax(type$.List_String._as(this._options.$index(0, "pkg-importer"))); t2.moveNext$0();){
                    t2.get$current(t2);
                    t3 = new A.NodePackageImporter();
                    t4 = self.process;
                    if (t4 == null) t4 = _null;
                    else {
                        t4 = J.get$release$x(t4);
                        t4 = t4 == null ? _null : J.get$name$x(t4);
                    }
                    if (!J.$eq$(t4, "node") && self.document != null && typeof self.document.querySelector == "function") A.throwExpression(string$.The_No);
                    t3.__NodePackageImporter__entryPointDirectory_F = $.$get$context().absolute$15(".", _null, _null, _null, _null, _null, _null, _null, _null, _null, _null, _null, _null, _null, _null);
                    t1.push(t3);
                }
                return t1;
            },
            get$emitErrorCss: function() {
                var t1 = A._asBoolQ(this._options.$index(0, "error-css"));
                if (t1 == null) {
                    this._ensureSources$0();
                    t1 = this._sourcesToDestinations;
                    t1 = t1.get$values(t1);
                    t1 = t1.any$1(t1, new A.ExecutableOptions_emitErrorCss_closure());
                }
                return t1;
            },
            _ensureSources$0: function() {
                var t1, stdin, t2, t3, $directories, t4, t5, t6, colonArgs, positionalArgs, t7, t8, t9, message, target, source, destination, seen, _0_0, _this = this, _null = null, _s18_ = 'Duplicate source "';
                if (_this._sourcesToDestinations != null) return;
                t1 = _this._options;
                stdin = A._asBool(t1.$index(0, "stdin"));
                t2 = t1.rest;
                if (t2.get$length(0) === 0 && !stdin) A.ExecutableOptions__fail("Compile Sass to CSS.");
                t3 = type$.String;
                $directories = A.LinkedHashSet_LinkedHashSet$_empty(t3);
                for(t4 = t2.$ti, t5 = t4._eval$1("ListIterator<ListBase.E>"), t6 = new A.ListIterator(t2, t2.get$length(0), t5), t4 = t4._eval$1("ListBase.E"), colonArgs = false, positionalArgs = false; t6.moveNext$0();){
                    t7 = t6.__internal$_current;
                    if (t7 == null) t7 = t4._as(t7);
                    t8 = t7.length;
                    if (t8 === 0) A.ExecutableOptions__fail('Invalid argument "".');
                    if (A.stringContainsUnchecked(t7, ":", 0)) {
                        if (t8 > 2) {
                            t9 = t7.charCodeAt(0);
                            if (!(t9 >= 97 && t9 <= 122)) t9 = t9 >= 65 && t9 <= 90;
                            else t9 = true;
                            t9 = t9 && t7.charCodeAt(1) === 58;
                        } else t9 = false;
                        if (t9) {
                            if (2 > t8) A.throwExpression(A.RangeError$range(2, 0, t8, _null, _null));
                            t8 = A.stringContainsUnchecked(t7, ":", 2);
                        } else t8 = true;
                    } else t8 = false;
                    if (t8) colonArgs = true;
                    else if (A.dirExists(t7)) $directories.add$1(0, t7);
                    else positionalArgs = true;
                }
                if (positionalArgs || t2.get$length(0) === 0) {
                    if (colonArgs) A.ExecutableOptions__fail('Positional and ":" arguments may not both be used.');
                    else if (stdin) {
                        if (J.get$length$asx(t2._collection$_source) > 1) A.ExecutableOptions__fail("Only one argument is allowed with --stdin.");
                        else if (A._asBool(t1.$index(0, "update"))) A.ExecutableOptions__fail("--update is not allowed with --stdin.");
                        else if (A._asBool(t1.$index(0, "watch"))) A.ExecutableOptions__fail("--watch is not allowed with --stdin.");
                        t1 = t2.get$length(0) === 0 ? _null : t2.get$first(t2);
                        t2 = type$.dynamic;
                        t3 = type$.nullable_String;
                        _this._sourcesToDestinations = A.ConstantMap_ConstantMap$from(A.LinkedHashMap_LinkedHashMap$_literal([
                            null,
                            t1
                        ], t2, t2), t3, t3);
                    } else {
                        t3 = t2._collection$_source;
                        t4 = J.getInterceptor$asx(t3);
                        if (t4.get$length(t3) > 2) A.ExecutableOptions__fail("Only two positional args may be passed.");
                        else if ($directories._collection$_length !== 0) {
                            message = 'Directory "' + $directories.get$first(0) + '" may not be a positional arg.';
                            target = t2.get$last(t2);
                            A.ExecutableOptions__fail($directories.get$first(0) === t2.get$first(t2) && !A.fileExists(target) ? message + ('\nTo compile all CSS in "' + $directories.get$first(0) + '" to "' + target + '", use `sass ' + $directories.get$first(0) + ":" + target + "`.") : message);
                        } else {
                            source = t2.get$first(t2) === "-" ? _null : t2.get$first(t2);
                            destination = t4.get$length(t3) === 1 ? _null : t2.get$last(t2);
                            if (destination == null) {
                                if (A._asBool(t1.$index(0, "update"))) A.ExecutableOptions__fail("--update is not allowed when printing to stdout.");
                                else if (A._asBool(t1.$index(0, "watch"))) A.ExecutableOptions__fail("--watch is not allowed when printing to stdout.");
                            }
                            t1 = A.PathMap__create(_null, type$.nullable_String);
                            t1.$indexSet(0, source, destination);
                            _this._sourcesToDestinations = new A.UnmodifiableMapView(new A.PathMap(t1, type$.PathMap_nullable_String), type$.UnmodifiableMapView_of_nullable_String_and_nullable_String);
                        }
                    }
                    _this.__ExecutableOptions__sourceDirectoriesToDestinations_F !== $ && A.throwUnnamedLateFieldAI();
                    _this.__ExecutableOptions__sourceDirectoriesToDestinations_F = B.Map_empty9;
                    return;
                }
                if (stdin) A.ExecutableOptions__fail('--stdin may not be used with ":" arguments.');
                seen = A.LinkedHashSet_LinkedHashSet$_empty(t3);
                t1 = A.PathMap__create(_null, t3);
                t6 = type$.PathMap_String;
                t3 = A.PathMap__create(_null, t3);
                for(t2 = new A.ListIterator(t2, t2.get$length(0), t5); t2.moveNext$0();){
                    t5 = t2.__internal$_current;
                    if (t5 == null) t5 = t4._as(t5);
                    if ($directories.contains$1(0, t5)) {
                        if (!seen.add$1(0, t5)) A.ExecutableOptions__fail(_s18_ + t5 + '".');
                        t3.$indexSet(0, t5, t5);
                        t1.addAll$1(0, _this._listSourceDirectory$2(t5, t5));
                        continue;
                    }
                    _0_0 = _this._splitSourceAndDestination$1(t5);
                    source = _0_0._0;
                    destination = _0_0._1;
                    if (!seen.add$1(0, source)) A.ExecutableOptions__fail(_s18_ + source + '".');
                    if (source === "-") t1.$indexSet(0, _null, destination);
                    else if (A.dirExists(source)) {
                        t3.$indexSet(0, source, destination);
                        t1.addAll$1(0, _this._listSourceDirectory$2(source, destination));
                    } else t1.$indexSet(0, source, destination);
                }
                _this._sourcesToDestinations = new A.UnmodifiableMapView(new A.PathMap(t1, t6), type$.UnmodifiableMapView_of_nullable_String_and_nullable_String);
                _this.__ExecutableOptions__sourceDirectoriesToDestinations_F !== $ && A.throwUnnamedLateFieldAI();
                _this.__ExecutableOptions__sourceDirectoriesToDestinations_F = new A.UnmodifiableMapView(new A.PathMap(t3, t6), type$.UnmodifiableMapView_of_nullable_String_and_String);
            },
            _splitSourceAndDestination$1: function(argument) {
                var t1, i, t2, t3, nextColon;
                for(t1 = argument.length, i = 0; i < t1; ++i){
                    t2 = false;
                    if (i === 1) {
                        t3 = i - 1;
                        if (t1 > t3 + 2) {
                            t2 = argument.charCodeAt(t3);
                            if (!(t2 >= 97 && t2 <= 122)) t2 = t2 >= 65 && t2 <= 90;
                            else t2 = true;
                            t2 = t2 && argument.charCodeAt(t3 + 1) === 58;
                        }
                    }
                    if (t2) continue;
                    if (argument.charCodeAt(i) === 58) {
                        t2 = i + 1;
                        nextColon = B.JSString_methods.indexOf$2(argument, ":", t2);
                        t3 = false;
                        if (nextColon === i + 2) {
                            if (t1 > t2 + 2) {
                                t1 = argument.charCodeAt(t2);
                                if (!(t1 >= 97 && t1 <= 122)) t1 = t1 >= 65 && t1 <= 90;
                                else t1 = true;
                                t1 = t1 && argument.charCodeAt(t2 + 1) === 58;
                            } else t1 = t3;
                        } else t1 = t3;
                        if ((t1 ? B.JSString_methods.indexOf$2(argument, ":", nextColon + 1) : nextColon) !== -1) A.ExecutableOptions__fail('"' + argument + '" may only contain one ":".');
                        return new A._Record_2(B.JSString_methods.substring$2(argument, 0, i), B.JSString_methods.substring$1(argument, t2));
                    }
                }
                throw A.wrapException(A.ArgumentError$('Expected "' + argument + '" to contain a colon.', null));
            },
            _listSourceDirectory$2: function(source, destination) {
                var t2, t3, t4, t5, t1 = type$.String;
                t1 = A.LinkedHashMap_LinkedHashMap$_empty(t1, t1);
                for(t2 = J.get$iterator$ax(A.listDir(source, true)), t3 = source === destination; t2.moveNext$0();){
                    t4 = t2.get$current(t2);
                    if (this._isEntrypoint$1(t4)) t5 = !(t3 && A.ParsedPath_ParsedPath$parse(t4, $.$get$context().style)._splitExtension$1(1)[1] === ".css");
                    else t5 = false;
                    if (t5) {
                        t5 = $.$get$context();
                        t1.$indexSet(0, t4, A.join(destination, t5.withoutExtension$1(t5.relative$2$from(t4, source)) + ".css", null));
                    }
                }
                return t1;
            },
            _isEntrypoint$1: function(path) {
                var extension, t1 = $.$get$context().style;
                if (B.JSString_methods.startsWith$1(A.ParsedPath_ParsedPath$parse(path, t1).get$basename(), "_")) return false;
                extension = A.ParsedPath_ParsedPath$parse(path, t1)._splitExtension$1(1)[1];
                return extension === ".scss" || extension === ".sass" || extension === ".css";
            },
            get$_writeToStdout: function() {
                var t1, _this = this;
                _this._ensureSources$0();
                t1 = _this._sourcesToDestinations;
                if (t1.get$length(t1) === 1) {
                    _this._ensureSources$0();
                    t1 = _this._sourcesToDestinations;
                    t1 = t1.get$values(t1);
                    t1 = t1.get$single(t1) == null;
                } else t1 = false;
                return t1;
            },
            get$emitSourceMap: function() {
                var _this = this, _s10_ = "source-map", _s15_ = "source-map-urls", _s13_ = "embed-sources", _s16_ = "embed-source-map", t1 = _this._options;
                if (!A._asBool(t1.$index(0, _s10_))) {
                    if (t1.wasParsed$1(_s15_)) A.ExecutableOptions__fail("--source-map-urls isn't allowed with --no-source-map.");
                    else if (t1.wasParsed$1(_s13_)) A.ExecutableOptions__fail("--embed-sources isn't allowed with --no-source-map.");
                    else if (t1.wasParsed$1(_s16_)) A.ExecutableOptions__fail("--embed-source-map isn't allowed with --no-source-map.");
                }
                if (!_this.get$_writeToStdout()) return A._asBool(t1.$index(0, _s10_));
                if (J.$eq$(_this._ifParsed$1(_s15_), "relative")) A.ExecutableOptions__fail("--source-map-urls=relative isn't allowed when printing to stdout.");
                if (A._asBool(t1.$index(0, _s16_))) return A._asBool(t1.$index(0, _s10_));
                else if (J.$eq$(_this._ifParsed$1(_s10_), true)) A.ExecutableOptions__fail("When printing to stdout, --source-map requires --embed-source-map.");
                else if (t1.wasParsed$1(_s15_)) A.ExecutableOptions__fail("When printing to stdout, --source-map-urls requires --embed-source-map.");
                else if (A._asBool(t1.$index(0, _s13_))) A.ExecutableOptions__fail("When printing to stdout, --embed-sources requires --embed-source-map.");
                else return false;
            },
            sourceMapUrl$2: function(_, url, destination) {
                var t1, path, t2, _null = null;
                if (url.get$scheme().length !== 0 && url.get$scheme() !== "file") return url;
                t1 = $.$get$context();
                path = t1.style.pathFromUri$1(A._parseUri(url));
                if (J.$eq$(this._options.$index(0, "source-map-urls"), "relative") && !this.get$_writeToStdout()) {
                    destination.toString;
                    t2 = t1.relative$2$from(path, t1.dirname$1(destination));
                } else t2 = A.absolute(path, _null, _null, _null, _null, _null, _null, _null, _null, _null, _null, _null, _null, _null, _null);
                return t1.toUri$1(t2);
            },
            get$silenceDeprecations: function(_) {
                var t2, t3, t4, t1 = A.LinkedHashSet_LinkedHashSet$_empty(type$.Deprecation);
                for(t2 = J.get$iterator$ax(type$.List_String._as(this._options.$index(0, "silence-deprecation"))); t2.moveNext$0();){
                    t3 = t2.get$current(t2);
                    t4 = A.Deprecation_fromId(t3);
                    t1.add$1(0, t4 == null ? A.ExecutableOptions__fail('Invalid deprecation "' + t3 + '".') : t4);
                }
                return t1;
            },
            get$fatalDeprecations: function(_) {
                var t1 = this._fatalDeprecations;
                return t1 == null ? this._fatalDeprecations = new A.ExecutableOptions_fatalDeprecations_closure(this).call$0() : t1;
            },
            get$futureDeprecations: function(_) {
                var t2, t3, t4, t1 = A.LinkedHashSet_LinkedHashSet$_empty(type$.Deprecation);
                for(t2 = J.get$iterator$ax(type$.List_String._as(this._options.$index(0, "future-deprecation"))); t2.moveNext$0();){
                    t3 = t2.get$current(t2);
                    t4 = A.Deprecation_fromId(t3);
                    t1.add$1(0, t4 == null ? A.ExecutableOptions__fail('Invalid deprecation "' + t3 + '".') : t4);
                }
                return t1;
            },
            _ifParsed$1: function($name) {
                var t1 = this._options;
                return t1.wasParsed$1($name) ? t1.$index(0, $name) : null;
            }
        };
        A.ExecutableOptions__parser_closure.prototype = {
            call$0: function() {
                var t1 = type$.String, t2 = A.LinkedHashMap_LinkedHashMap$_empty(t1, type$.Option), t3 = A._setArrayType([], type$.JSArray_Object), parser = new A.ArgParser(t2, A.LinkedHashMap_LinkedHashMap$_empty(t1, t1), new A.UnmodifiableMapView(t2, type$.UnmodifiableMapView_String_Option), new A.UnmodifiableMapView(A.LinkedHashMap_LinkedHashMap$_empty(t1, type$.ArgParser), type$.UnmodifiableMapView_String_ArgParser), t3, true, null);
                parser.addOption$2$hide("precision", true);
                parser.addFlag$2$hide("async", true);
                t3.push(A.ExecutableOptions__separator("Input and Output"));
                parser.addFlag$2$help("stdin", "Read the stylesheet from stdin.");
                parser.addFlag$2$help("indented", "Use the indented syntax for input from stdin.");
                parser.addMultiOption$5$abbr$help$splitCommas$valueHelp("load-path", "I", "A path to use when resolving imports.\nMay be passed multiple times.", false, "PATH");
                t2 = type$.JSArray_String;
                parser.addMultiOption$6$abbr$allowed$allowedHelp$help$valueHelp("pkg-importer", "p", A._setArrayType([
                    "node"
                ], t2), A.LinkedHashMap_LinkedHashMap$_literal([
                    "node",
                    "Load files like Node.js package resolution."
                ], t1, t1), "Built-in importer(s) to use for pkg: URLs.", "TYPE");
                parser.addOption$6$abbr$allowed$defaultsTo$help$valueHelp("style", "s", A._setArrayType([
                    "expanded",
                    "compressed"
                ], t2), "expanded", "Output style.", "NAME");
                parser.addFlag$3$defaultsTo$help("charset", true, "Emit a @charset or BOM for CSS with non-ASCII characters.");
                parser.addFlag$3$defaultsTo$help("error-css", null, "When an error occurs, emit a stylesheet describing it.\nDefaults to true when compiling to a file.");
                parser.addFlag$3$help$negatable("update", "Only compile out-of-date stylesheets.", false);
                t3.push(A.ExecutableOptions__separator("Source Maps"));
                parser.addFlag$3$defaultsTo$help("source-map", true, "Whether to generate source maps.");
                parser.addOption$4$allowed$defaultsTo$help("source-map-urls", A._setArrayType([
                    "relative",
                    "absolute"
                ], t2), "relative", "How to link from source maps to source files.");
                parser.addFlag$3$defaultsTo$help("embed-sources", false, "Embed source file contents in source maps.");
                parser.addFlag$3$defaultsTo$help("embed-source-map", false, "Embed source map contents in CSS.");
                t3.push(A.ExecutableOptions__separator("Warnings"));
                parser.addFlag$3$abbr$help("quiet", "q", "Don't print warnings.");
                parser.addFlag$2$help("quiet-deps", "Don't print compiler warnings from dependencies.\nStylesheets imported through load paths count as dependencies.");
                parser.addFlag$2$help("verbose", "Print all deprecation warnings even when they're repetitive.");
                parser.addMultiOption$2$help("fatal-deprecation", "Deprecations to treat as errors. You may also pass a Sass\nversion to include any behavior deprecated in or before it.\nSee https://sass-lang.com/documentation/breaking-changes for \na complete list.");
                parser.addMultiOption$2$help("silence-deprecation", "Deprecations to ignore.");
                parser.addMultiOption$2$help("future-deprecation", "Opt in to a deprecation early.");
                t3.push(A.ExecutableOptions__separator("Other"));
                parser.addFlag$4$abbr$help$negatable("watch", "w", "Watch stylesheets and recompile when they change.", false);
                parser.addFlag$2$help("poll", "Manually check for changes rather than using a native watcher.\nOnly valid with --watch.");
                parser.addFlag$2$help("stop-on-error", "Don't compile more files once an error is encountered.");
                parser.addFlag$4$abbr$help$negatable("interactive", "i", "Run an interactive SassScript shell.", false);
                parser.addFlag$3$abbr$help("color", "c", "Whether to use terminal colors for messages.");
                parser.addFlag$2$help("unicode", "Whether to use Unicode characters for messages.");
                parser.addFlag$2$help("trace", "Print full Dart stack traces for exceptions.");
                parser.addFlag$4$abbr$help$negatable("help", "h", "Print this usage information.", false);
                parser.addFlag$3$help$negatable("version", "Print the version of Dart Sass.", false);
                return parser;
            },
            $signature: 312
        };
        A.ExecutableOptions_interactive_closure.prototype = {
            call$0: function() {
                var _0_0, t1 = this.$this._options;
                if (!A._asBool(t1.$index(0, "interactive"))) return false;
                _0_0 = A.IterableExtension_firstWhereOrNull(A._setArrayType([
                    "stdin",
                    "indented",
                    "style",
                    "source-map",
                    "source-map-urls",
                    "embed-sources",
                    "embed-source-map",
                    "update",
                    "watch"
                ], type$.JSArray_String), t1.get$wasParsed());
                if (_0_0 != null) throw A.wrapException(A.UsageException$("--" + _0_0 + " isn't allowed with --interactive."));
                return true;
            },
            $signature: 20
        };
        A.ExecutableOptions_emitErrorCss_closure.prototype = {
            call$1: function(destination) {
                return destination != null;
            },
            $signature: 227
        };
        A.ExecutableOptions_fatalDeprecations_closure.prototype = {
            call$0: function() {
                var id, argVersion, sassVersion, t1, t2, _0_0, _$exception, deprecations = A.LinkedHashSet_LinkedHashSet$_empty(type$.Deprecation);
                for(t1 = J.get$iterator$ax(type$.List_String._as(this.$this._options.$index(0, "fatal-deprecation"))), t2 = type$.FormatException; t1.moveNext$0();){
                    id = t1.get$current(t1);
                    _0_0 = A.Deprecation_fromId(id);
                    if (_0_0 != null) {
                        J.add$1$ax(deprecations, _0_0);
                        continue;
                    }
                    try {
                        argVersion = A.Version_Version$parse(id);
                        sassVersion = A.Version_Version$parse("1.101.0");
                        if (J.compareTo$1$ns(argVersion, sassVersion) > 0) A.ExecutableOptions__fail("Invalid version " + A.S(argVersion) + ". --fatal-deprecation requires a version less than or equal to the current Dart Sass version.");
                        J.addAll$1$ax(deprecations, A.Deprecation_forVersion(argVersion));
                    } catch (exception) {
                        if (t2._is(A.unwrapException(exception))) A.ExecutableOptions__fail('Invalid deprecation "' + A.S(id) + '".');
                        else throw exception;
                    }
                }
                return deprecations;
            },
            $signature: 321
        };
        A.UsageException.prototype = {
            $isException: 1,
            get$message: function(receiver) {
                return this.message;
            }
        };
        A.repl_warn.prototype = {
            call$1: function(warning) {
                var _0_1, _0_3, deprecation, t1, _0_2, span, _null = null;
                $label0$0: {
                    _0_1 = warning._1;
                    _0_3 = _null;
                    deprecation = _null;
                    t1 = false;
                    _0_2 = warning._2;
                    _0_3 = warning._0;
                    t1 = _0_3 != null;
                    if (t1) deprecation = _0_3 == null ? type$.Deprecation._as(_0_3) : _0_3;
                    span = _0_2;
                    if (t1) {
                        A.WarnForDeprecation_warnForDeprecation(this.logger, deprecation, _0_1, span, _null);
                        break $label0$0;
                    }
                    t1 = false;
                    t1 = _0_3 == null;
                    span = _0_2;
                    if (t1) this.logger.internalWarn$4$deprecation$span$trace(_0_1, _null, span, _null);
                }
            },
            $signature: 324
        };
        A.watch_closure.prototype = {
            call$1: function(dir) {
                while(!A.dirExists(dir))dir = $.$get$context().dirname$1(dir);
                return this.dirWatcher.watch$1(0, dir);
            },
            $signature: 325
        };
        A._Watcher.prototype = {
            _delete$1: function(path) {
                var buffer, t1, _$exception;
                try {
                    A.deleteFile(path);
                    buffer = new A.StringBuffer("");
                    t1 = this._watch$_options;
                    if (t1.get$color()) buffer._contents += "\x1b[33m";
                    buffer._contents += "Deleted " + path + ".";
                    if (t1.get$color()) buffer._contents += "\x1b[0m";
                    A.print(buffer);
                } catch (exception) {
                    if (!(A.unwrapException(exception) instanceof A.FileSystemException)) throw exception;
                }
            },
            watch$1: function(_, watcher) {
                return this.watch$body$_Watcher(0, watcher);
            },
            watch$body$_Watcher: function(_, watcher) {
                var $async$goto = 0, $async$completer = A._makeAsyncAwaitCompleter(type$.void), $async$returnValue, $async$handler = 2, $async$errorStack = [], $async$next = [], $async$self = this, batch, $event, extension, t1, toRecompile, success, t3, t4, t5, t6, t7, t8, t9, t10, t11, t12, t13, url, _0_0, t2;
                var $async$watch$1 = A._wrapJsFunctionForAsync(function($async$errorCode, $async$result) {
                    if ($async$errorCode === 1) {
                        $async$errorStack.push($async$result);
                        $async$goto = $async$handler;
                    }
                    for(;;)switch($async$goto){
                        case 0:
                            // Function start
                            t2 = watcher._group.__StreamGroup__controller_A;
                            t2 === $ && A.throwUnnamedLateFieldNI();
                            t2 = new A._StreamIterator(A.checkNotNullable($async$self._debounceEvents$1(new A._ControllerStream(t2, A._instanceType(t2)._eval$1("_ControllerStream<1>"))), "stream", type$.Object));
                            $async$handler = 3;
                            t3 = $async$self._toRecompile, t4 = type$.String, t5 = $async$self._watch$_options, t6 = $async$self._graph, t7 = t6._nodes, t8 = type$.JSArray_StylesheetNode, t9 = t5._options;
                        case 6:
                            // for condition
                            $async$goto = 8;
                            return A._asyncAwait(t2.moveNext$0(), $async$watch$1);
                        case 8:
                            // returning from await.
                            if (!$async$result) {
                                // goto after for
                                $async$goto = 7;
                                break;
                            }
                            batch = t2.get$current(0);
                            for(t10 = J.get$iterator$ax(batch); t10.moveNext$0();){
                                $event = t10.get$current(t10);
                                t11 = $event.path;
                                t12 = $.$get$context();
                                extension = A.ParsedPath_ParsedPath$parse(t11, t12.style)._splitExtension$1(1)[1];
                                if (!J.$eq$(extension, ".sass") && !J.$eq$(extension, ".scss") && !J.$eq$(extension, ".css")) continue;
                                switch($event.type){
                                    case B.ChangeType_modify:
                                        t11 = $event.path;
                                        t13 = self.process;
                                        if (t13 == null) t13 = null;
                                        else {
                                            t13 = J.get$release$x(t13);
                                            t13 = t13 == null ? null : J.get$name$x(t13);
                                        }
                                        t13 = J.$eq$(t13, "node") ? self.process : null;
                                        if (!J.$eq$(t13 == null ? null : J.get$platform$x(t13), "win32")) {
                                            t13 = self.process;
                                            if (t13 == null) t13 = null;
                                            else {
                                                t13 = J.get$release$x(t13);
                                                t13 = t13 == null ? null : J.get$name$x(t13);
                                            }
                                            t13 = J.$eq$(t13, "node") ? self.process : null;
                                            t13 = J.$eq$(t13 == null ? null : J.get$platform$x(t13), "darwin");
                                        } else t13 = true;
                                        url = t12.toUri$1(t13 ? A._realCasePath(t12.normalize$1(t12.absolute$15(t11, null, null, null, null, null, null, null, null, null, null, null, null, null, null))) : t12.canonicalize$1(0, t11));
                                        _0_0 = t7.$index(0, url);
                                        if (_0_0 != null) {
                                            t6.reload$1(url);
                                            $async$self._recompileDownstream$1(A._setArrayType([
                                                _0_0
                                            ], t8));
                                        } else $async$self._handleAdd$1(t11);
                                        break;
                                    case B.ChangeType_add:
                                        $async$self._handleAdd$1($event.path);
                                        break;
                                    case B.ChangeType_remove:
                                        $async$self._handleRemove$1($event.path);
                                        break;
                                }
                            }
                            t10 = A.LinkedHashMap_LinkedHashMap(null, null, null, t4, t4);
                            t10.addAll$1(0, t3);
                            t1 = t10;
                            toRecompile = t1;
                            t3.clear$0(0);
                            $async$goto = 9;
                            return A._asyncAwait(A.compileStylesheets(t5, t6, toRecompile, true), $async$watch$1);
                        case 9:
                            // returning from await.
                            success = $async$result;
                            if (!success && A._asBool(t9.$index(0, "stop-on-error"))) {
                                $async$next = [
                                    1
                                ];
                                // goto finally
                                $async$goto = 4;
                                break;
                            }
                            // goto for condition
                            $async$goto = 6;
                            break;
                        case 7:
                            // after for
                            $async$next.push(5);
                            // goto finally
                            $async$goto = 4;
                            break;
                        case 3:
                            // uncaught
                            $async$next = [
                                2
                            ];
                        case 4:
                            // finally
                            $async$handler = 2;
                            $async$goto = 10;
                            return A._asyncAwait(t2.cancel$0(), $async$watch$1);
                        case 10:
                            // returning from await.
                            // goto the next finally handler
                            $async$goto = $async$next.pop();
                            break;
                        case 5:
                        // after finally
                        case 1:
                            // return
                            return A._asyncReturn($async$returnValue, $async$completer);
                        case 2:
                            // rethrow
                            return A._asyncRethrow($async$errorStack.at(-1), $async$completer);
                    }
                });
                return A._asyncStartSync($async$watch$1, $async$completer);
            },
            _handleAdd$1: function(path) {
                var t1, t2, t3, t0, _this = this, _null = null, destination = _this._destinationFor$1(path);
                if (destination != null) _this._toRecompile.$indexSet(0, path, destination);
                t1 = $.$get$FilesystemImporter_cwd();
                t2 = A.isNodeJs() ? self.process : _null;
                if (!J.$eq$(t2 == null ? _null : J.get$platform$x(t2), "win32")) {
                    t2 = A.isNodeJs() ? self.process : _null;
                    t2 = J.$eq$(t2 == null ? _null : J.get$platform$x(t2), "darwin");
                } else t2 = true;
                if (t2) {
                    t2 = A.absolute(path, _null, _null, _null, _null, _null, _null, _null, _null, _null, _null, _null, _null, _null, _null);
                    t3 = $.$get$context();
                    t2 = A._realCasePath(t3.normalize$1(t2));
                } else {
                    t2 = $.$get$context();
                    t3 = t2.canonicalize$1(0, path);
                    t0 = t3;
                    t3 = t2;
                    t2 = t0;
                }
                _this._recompileDownstream$1(_this._graph.addCanonical$3(t1, t3.toUri$1(t2), t3.toUri$1(path)));
            },
            _handleRemove$1: function(path) {
                return this._handleRemove$body$_Watcher(path);
            },
            _handleRemove$body$_Watcher: function(path) {
                var $async$goto = 0, $async$completer = A._makeAsyncAwaitCompleter(type$.void), $async$self = this, t2, t0, url, _0_0, t1;
                var $async$_handleRemove$1 = A._wrapJsFunctionForAsync(function($async$errorCode, $async$result) {
                    if ($async$errorCode === 1) return A._asyncRethrow($async$result, $async$completer);
                    for(;;)switch($async$goto){
                        case 0:
                            // Function start
                            t1 = A.isNodeJs() ? self.process : null;
                            if (!J.$eq$(t1 == null ? null : J.get$platform$x(t1), "win32")) {
                                t1 = A.isNodeJs() ? self.process : null;
                                t1 = J.$eq$(t1 == null ? null : J.get$platform$x(t1), "darwin");
                            } else t1 = true;
                            if (t1) {
                                t1 = A.absolute(path, null, null, null, null, null, null, null, null, null, null, null, null, null, null);
                                t2 = $.$get$context();
                                t1 = A._realCasePath(t2.normalize$1(t1));
                            } else {
                                t1 = $.$get$context();
                                t2 = t1.canonicalize$1(0, path);
                                t0 = t2;
                                t2 = t1;
                                t1 = t0;
                            }
                            url = t2.toUri$1(t1);
                            t1 = $async$self._graph;
                            if (t1._nodes.containsKey$1(url)) {
                                _0_0 = $async$self._destinationFor$1(path);
                                if (_0_0 != null) {
                                    $async$self._delete$1(_0_0);
                                    $async$self._delete$1(_0_0 + ".map");
                                }
                            }
                            $async$self._recompileDownstream$1(t1.remove$2(0, $.$get$FilesystemImporter_cwd(), url));
                            // implicit return
                            return A._asyncReturn(null, $async$completer);
                    }
                });
                return A._asyncStartSync($async$_handleRemove$1, $async$completer);
            },
            _debounceEvents$1: function(events) {
                var t1 = type$.WatchEvent;
                t1 = A.RateLimit__debounceAggregate(events, A.Duration$(0, 25), A.instantiate1(A.rate_limit___collect$closure(), t1), false, true, t1, type$.List_WatchEvent);
                return new A._MapStream(new A._Watcher__debounceEvents_closure(), t1, A._instanceType(t1)._eval$1("_MapStream<Stream.T,List<WatchEvent>>"));
            },
            _recompileDownstream$1: function(nodes) {
                var t1, t2, t3, t4, t5, t6, _i, seen = A.LinkedHashSet_LinkedHashSet$_empty(type$.StylesheetNode);
                for(t1 = type$.UnmodifiableSetView_StylesheetNode, t2 = this._toRecompile, t3 = type$.JSArray_StylesheetNode; t4 = J.getInterceptor$asx(nodes), t4.get$isNotEmpty(nodes); nodes = t4){
                    t5 = A._setArrayType([], t3);
                    for(t4 = t4.get$iterator(nodes); t4.moveNext$0();){
                        t6 = t4.get$current(t4);
                        if (seen.add$1(0, t6)) t5.push(t6);
                    }
                    t2.addAll$1(0, this._sourceEntrypointsToDestinations$1(t5));
                    t4 = A._setArrayType([], t3);
                    for(t6 = t5.length, _i = 0; _i < t5.length; t5.length === t6 || (0, A.throwConcurrentModificationError)(t5), ++_i)B.JSArray_methods.addAll$1(t4, new A.UnmodifiableSetView0(t5[_i]._downstream, t1));
                }
            },
            _sourceEntrypointsToDestinations$1: function(nodes) {
                var _i, url, source, _0_0, t1 = type$.String, entrypoints = A.LinkedHashMap_LinkedHashMap$_empty(t1, t1);
                for(t1 = nodes.length, _i = 0; _i < nodes.length; nodes.length === t1 || (0, A.throwConcurrentModificationError)(nodes), ++_i){
                    url = nodes[_i].canonicalUrl;
                    if (url.get$scheme() !== "file") continue;
                    source = $.$get$context().style.pathFromUri$1(A._parseUri(url));
                    _0_0 = this._destinationFor$1(source);
                    if (_0_0 != null) entrypoints.$indexSet(0, source, _0_0);
                }
                return entrypoints;
            },
            _destinationFor$1: function(source) {
                var t2, _0_0, t3, sourceDir, destinationDir, destination, t1 = this._watch$_options;
                t1._ensureSources$0();
                t2 = type$.String;
                _0_0 = t1._sourcesToDestinations.cast$2$0(0, t2, t2).$index(0, source);
                if (_0_0 != null) return _0_0;
                t3 = $.$get$context();
                if (B.JSString_methods.startsWith$1(A.ParsedPath_ParsedPath$parse(source, t3.style).get$basename(), "_")) return null;
                t1._ensureSources$0();
                t1 = t1.__ExecutableOptions__sourceDirectoriesToDestinations_F;
                t1 === $ && A.throwUnnamedLateFieldNI();
                t2 = A.MapExtensions_get_pairs(t1.cast$2$0(0, t2, t2), t2, t2);
                t2 = t2.get$iterator(t2);
                while(t2.moveNext$0()){
                    t1 = t2.get$current(t2);
                    sourceDir = t1._0;
                    destinationDir = t1._1;
                    if (t3._isWithinOrEquals$2(sourceDir, source) !== B._PathRelation_within) continue;
                    destination = A.join(destinationDir, t3.withoutExtension$1(t3.relative$2$from(source, sourceDir)) + ".css", null);
                    if (t3._isWithinOrEquals$2(destination, source) !== B._PathRelation_equal) return destination;
                }
                return null;
            }
        };
        A._Watcher__debounceEvents_closure.prototype = {
            call$1: function(buffer) {
                var t3, t4, t5, oldType, _0_4, _1_1, t1 = type$.ChangeType, t2 = A.PathMap__create(null, t1);
                for(t3 = J.get$iterator$ax(buffer); t3.moveNext$0();){
                    t4 = t3.get$current(t3);
                    t5 = t4.path;
                    oldType = t2.$index(0, t5);
                    _0_4 = t4.type;
                    $label0$0: {
                        if (oldType == null) {
                            t4 = _0_4;
                            break $label0$0;
                        }
                        if (B.ChangeType_remove === _0_4) {
                            t4 = B.ChangeType_remove;
                            break $label0$0;
                        }
                        if (B.ChangeType_add === oldType) {
                            t4 = B.ChangeType_add;
                            break $label0$0;
                        }
                        t4 = B.ChangeType_modify;
                        break $label0$0;
                    }
                    t2.$indexSet(0, t5, t4);
                }
                t3 = A._setArrayType([], type$.JSArray_WatchEvent);
                for(t1 = A.MapExtensions_get_pairs(new A.PathMap(t2, type$.PathMap_ChangeType), type$.nullable_String, t1), t1 = t1.get$iterator(t1); t1.moveNext$0();){
                    t2 = t1.get$current(t1);
                    _1_1 = t2._0;
                    _1_1.toString;
                    t3.push(new A.WatchEvent(t2._1, _1_1));
                }
                return t3;
            },
            $signature: 276
        };
        A.EmptyExtensionStore.prototype = {
            get$_extensions: function() {
                return A.throwExpression(A.NoSuchMethodError_NoSuchMethodError$withInvocation(this, A.JSInvocationMirror$(B.Symbol__extensions, "get$_empty_extension_store$_extensions", 1, [], [], 0)));
            },
            get$_sourceSpecificity: function() {
                return A.throwExpression(A.NoSuchMethodError_NoSuchMethodError$withInvocation(this, A.JSInvocationMirror$(B.Symbol__sourceSpecificity, "get$_empty_extension_store$_sourceSpecificity", 1, [], [], 0)));
            },
            get$isEmpty: function(_) {
                return true;
            },
            get$simpleSelectors: function() {
                return B.C_EmptyUnmodifiableSet;
            },
            extensionsWhereTarget$1: function(callback) {
                return B.List_empty5;
            },
            addSelector$2: function(selector, mediaContext) {
                throw A.wrapException(A.UnsupportedError$(string$.addSel));
            },
            addExtension$4: function(extender, target, extend, mediaContext) {
                throw A.wrapException(A.UnsupportedError$(string$.addExt_));
            },
            addExtensions$1: function(extenders) {
                throw A.wrapException(A.UnsupportedError$(string$.addExts));
            },
            clone$0: function() {
                return B.Record2_EmptyExtensionStore_Map_empty;
            },
            $isExtensionStore: 1
        };
        A.Extension.prototype = {
            toString$0: function(_) {
                var t1 = this.extender.toString$0(0), t2 = this.target.toString$0(0), t3 = this.isOptional ? " !optional" : "";
                return t1 + " {@extend " + t2 + t3 + "}";
            }
        };
        A.Extender.prototype = {
            assertCompatibleMediaContext$1: function(mediaContext) {
                var expectedMediaContext, extension = this._extension;
                if (extension == null) return;
                expectedMediaContext = extension.mediaContext;
                if (expectedMediaContext == null) return;
                if (mediaContext != null && B.C_ListEquality.equals$2(0, expectedMediaContext, mediaContext)) return;
                throw A.wrapException(A.SassException$(string$.You_ma, extension.span, null));
            },
            toString$0: function(_) {
                return A.serializeSelector(this.selector, true);
            }
        };
        A.ExtensionStore.prototype = {
            get$isEmpty: function(_) {
                return this._extensions.__js_helper$_length === 0;
            },
            get$simpleSelectors: function() {
                return new A.MapKeySet(this._selectors, type$.MapKeySet_SimpleSelector);
            },
            extensionsWhereTarget$1: function(callback) {
                return new A._SyncStarIterable(this.extensionsWhereTarget$body$ExtensionStore(callback), type$._SyncStarIterable_Extension);
            },
            extensionsWhereTarget$body$ExtensionStore: function($async$callback) {
                var $async$self = this;
                return function() {
                    var callback = $async$callback;
                    var $async$goto = 0, $async$handler = 1, $async$errorStack = [], t1, t2, simple, sources, t3;
                    return function $async$extensionsWhereTarget$1($async$iterator, $async$errorCode, $async$result) {
                        if ($async$errorCode === 1) {
                            $async$errorStack.push($async$result);
                            $async$goto = $async$handler;
                        }
                        for(;;)switch($async$goto){
                            case 0:
                                // Function start
                                t1 = A.MapExtensions_get_pairs($async$self._extensions, type$.SimpleSelector, type$.Map_ComplexSelector_Extension), t1 = t1.get$iterator(t1);
                            case 2:
                                // for condition
                                if (!t1.moveNext$0()) {
                                    // goto after for
                                    $async$goto = 3;
                                    break;
                                }
                                t2 = t1.get$current(t1);
                                simple = t2._0;
                                sources = t2._1;
                                if (!callback.call$1(simple)) {
                                    // goto for condition
                                    $async$goto = 2;
                                    break;
                                }
                                t2 = sources.get$values(sources), t2 = t2.get$iterator(t2);
                            case 4:
                                // for condition
                                if (!t2.moveNext$0()) {
                                    // goto after for
                                    $async$goto = 5;
                                    break;
                                }
                                t3 = t2.get$current(t2);
                                $async$goto = t3 instanceof A.MergedExtension ? 6 : 8;
                                break;
                            case 6:
                                // then
                                t3 = t3.unmerge$0();
                                $async$goto = 9;
                                return $async$iterator._yieldStar$1(new A.WhereIterable(t3, new A.ExtensionStore_extensionsWhereTarget_closure(), t3.$ti._eval$1("WhereIterable<Iterable.E>")));
                            case 9:
                                // after yield
                                // goto join
                                $async$goto = 7;
                                break;
                            case 8:
                                // else
                                $async$goto = !t3.isOptional ? 10 : 11;
                                break;
                            case 10:
                                // then
                                $async$goto = 12;
                                return $async$iterator._async$_current = t3, 1;
                            case 12:
                            // after yield
                            case 11:
                            // join
                            case 7:
                                // join
                                // goto for condition
                                $async$goto = 4;
                                break;
                            case 5:
                                // after for
                                // goto for condition
                                $async$goto = 2;
                                break;
                            case 3:
                                // after for
                                // implicit return
                                return 0;
                            case 1:
                                // rethrow
                                return $async$iterator._datum = $async$errorStack.at(-1), 3;
                        }
                    };
                };
            },
            addSelector$2: function(selector, mediaContext) {
                var originalSelector, error, stackTrace, t1, _$exception, t2, t3, t4, modifiableSelector, _this = this;
                selector;
                originalSelector = selector;
                if (!originalSelector.accept$1(B._IsInvisibleVisitor_true)) _this._originals.addAll$1(0, originalSelector.components);
                t1 = _this._extensions;
                if (t1.__js_helper$_length !== 0) try {
                    selector = _this._extendList$3(originalSelector, t1, mediaContext);
                } catch (exception) {
                    t1 = A.unwrapException(exception);
                    if (t1 instanceof A.SassException) {
                        error = t1;
                        stackTrace = A.getTraceFromException(exception);
                        t1 = error;
                        t2 = J.getInterceptor$x(t1);
                        t1 = A.SourceSpanException.prototype.get$span.call(t2, t1).message$1(0, "");
                        t2 = error._span_exception$_message;
                        t3 = error;
                        t4 = J.getInterceptor$x(t3);
                        t3 = A.SourceSpanException.prototype.get$span.call(t4, t3);
                        A.throwWithTrace(new A.SassException(B.Set_empty, "From " + t1 + "\n" + t2, t3), error, stackTrace);
                    } else throw exception;
                }
                modifiableSelector = new A.ModifiableBox(selector, type$.ModifiableBox_SelectorList);
                if (mediaContext != null) _this._mediaContexts.$indexSet(0, modifiableSelector, mediaContext);
                _this._registerSelector$2(selector, modifiableSelector);
                return new A.Box(modifiableSelector, type$.Box_SelectorList);
            },
            _registerSelector$2: function(list, selector) {
                var t1, t2, t3, t4, _i, t5, t6, _i0, t7, t8, _i1, simple, _0_2_isSet, _0_2, t9, selectorInPseudo;
                for(t1 = list.components, t2 = t1.length, t3 = this._selectors, t4 = type$.SelectorList, _i = 0; _i < t2; ++_i)for(t5 = t1[_i].components, t6 = t5.length, _i0 = 0; _i0 < t6; ++_i0)for(t7 = t5[_i0].selector.components, t8 = t7.length, _i1 = 0; _i1 < t8; ++_i1){
                    simple = t7[_i1];
                    t3.putIfAbsent$2(simple, new A.ExtensionStore__registerSelector_closure()).add$1(0, selector);
                    _0_2_isSet = simple instanceof A.PseudoSelector;
                    _0_2 = null;
                    if (_0_2_isSet) {
                        _0_2 = simple.selector;
                        t9 = _0_2;
                        t9 = t9 != null;
                    } else t9 = false;
                    if (t9) {
                        selectorInPseudo = _0_2_isSet ? _0_2 : simple.selector;
                        this._registerSelector$2(selectorInPseudo == null ? t4._as(selectorInPseudo) : selectorInPseudo, selector);
                    }
                }
            },
            addExtension$4: function(extender, target, extend, mediaContext) {
                var t2, t3, t4, t5, t6, t7, t8, t9, t10, newExtensions, _i, complex, t11, extension, _0_0, t12, newExtensionsByTarget, additionalExtensions, _this = this, selectors = _this._selectors.$index(0, target), t1 = _this._extensionsByExtender, existingExtensions = t1.$index(0, target), sources = _this._extensions.putIfAbsent$2(target, new A.ExtensionStore_addExtension_closure());
                for(t2 = extender.components, t3 = t2.length, t4 = selectors == null, t5 = _this._sourceSpecificity, t6 = extend.span, t7 = extend.isOptional, t8 = existingExtensions != null, t9 = type$.ComplexSelector, t10 = type$.Extension, newExtensions = null, _i = 0; _i < t3; ++_i){
                    complex = t2[_i];
                    if (complex.accept$1(B.C__IsUselessVisitor)) continue;
                    complex.get$specificity();
                    t11 = new A.Extender(complex, false);
                    extension = t11._extension = new A.Extension(t11, target, mediaContext, t7, t6);
                    _0_0 = sources.$index(0, complex);
                    if (_0_0 != null) {
                        sources.$indexSet(0, complex, A.MergedExtension_merge(_0_0, extension));
                        continue;
                    }
                    sources.$indexSet(0, complex, extension);
                    for(t11 = new A._SyncStarIterator(_this._simpleSelectors$1(complex)._outerHelper()); t11.moveNext$0();){
                        t12 = t11._async$_current;
                        J.add$1$ax(t1.putIfAbsent$2(t12, new A.ExtensionStore_addExtension_closure0()), extension);
                        t5.putIfAbsent$2(t12, new A.ExtensionStore_addExtension_closure1(complex));
                    }
                    if (!t4 || t8) {
                        if (newExtensions == null) newExtensions = A.LinkedHashMap_LinkedHashMap$_empty(t9, t10);
                        newExtensions.$indexSet(0, complex, extension);
                    }
                }
                if (newExtensions == null) return;
                t1 = type$.SimpleSelector;
                newExtensionsByTarget = A.LinkedHashMap_LinkedHashMap$_literal([
                    target,
                    newExtensions
                ], t1, type$.Map_ComplexSelector_Extension);
                if (t8) {
                    additionalExtensions = _this._extendExistingExtensions$2(existingExtensions, newExtensionsByTarget);
                    if (additionalExtensions != null) A.mapAddAll2(newExtensionsByTarget, additionalExtensions, t1, t9, t10);
                }
                if (!t4) _this._extendExistingSelectors$2(selectors, newExtensionsByTarget);
            },
            _simpleSelectors$1: function(complex) {
                return new A._SyncStarIterable(this._simpleSelectors$body$ExtensionStore(complex), type$._SyncStarIterable_SimpleSelector);
            },
            _simpleSelectors$body$ExtensionStore: function($async$complex) {
                var $async$self = this;
                return function() {
                    var complex = $async$complex;
                    var $async$goto = 0, $async$handler = 1, $async$errorStack = [], t1, t2, t3, _i, t4, t5, _i0, simple, _0_2_isSet, _0_2, t6, selector, t7, _i1;
                    return function $async$_simpleSelectors$1($async$iterator, $async$errorCode, $async$result) {
                        if ($async$errorCode === 1) {
                            $async$errorStack.push($async$result);
                            $async$goto = $async$handler;
                        }
                        for(;;)switch($async$goto){
                            case 0:
                                // Function start
                                t1 = complex.components, t2 = t1.length, t3 = type$.SelectorList, _i = 0;
                            case 2:
                                // for condition
                                if (!(_i < t2)) {
                                    // goto after for
                                    $async$goto = 4;
                                    break;
                                }
                                t4 = t1[_i].selector.components, t5 = t4.length, _i0 = 0;
                            case 5:
                                // for condition
                                if (!(_i0 < t5)) {
                                    // goto after for
                                    $async$goto = 7;
                                    break;
                                }
                                simple = t4[_i0];
                                $async$goto = 8;
                                return $async$iterator._async$_current = simple, 1;
                            case 8:
                                // after yield
                                _0_2_isSet = simple instanceof A.PseudoSelector;
                                _0_2 = null;
                                if (_0_2_isSet) {
                                    _0_2 = simple.selector;
                                    t6 = _0_2;
                                    t6 = t6 != null;
                                } else t6 = false;
                                $async$goto = t6 ? 9 : 10;
                                break;
                            case 9:
                                // then
                                selector = _0_2_isSet ? _0_2 : simple.selector;
                                t6 = (selector == null ? t3._as(selector) : selector).components, t7 = t6.length, _i1 = 0;
                            case 11:
                                // for condition
                                if (!(_i1 < t7)) {
                                    // goto after for
                                    $async$goto = 13;
                                    break;
                                }
                                $async$goto = 14;
                                return $async$iterator._yieldStar$1($async$self._simpleSelectors$1(t6[_i1]));
                            case 14:
                            // after yield
                            case 12:
                                // for update
                                ++_i1;
                                // goto for condition
                                $async$goto = 11;
                                break;
                            case 13:
                            // after for
                            case 10:
                            // join
                            case 6:
                                // for update
                                ++_i0;
                                // goto for condition
                                $async$goto = 5;
                                break;
                            case 7:
                            // after for
                            case 3:
                                // for update
                                ++_i;
                                // goto for condition
                                $async$goto = 2;
                                break;
                            case 4:
                                // after for
                                // implicit return
                                return 0;
                            case 1:
                                // rethrow
                                return $async$iterator._datum = $async$errorStack.at(-1), 3;
                        }
                    };
                };
            },
            _extendExistingExtensions$2: function(extensions, newExtensions) {
                var extension, selectors, error, stackTrace, t1, t2, t3, t4, t5, t6, additionalExtensions, _i, t7, _$exception, t8, t9, selectors0, t10, t11, t12, t13, t14, withExtender, _0_0, _i0, _i1;
                for(t1 = J.toList$0$ax(extensions), t2 = t1.length, t3 = this._extensionsByExtender, t4 = type$.SimpleSelector, t5 = type$.Map_ComplexSelector_Extension, t6 = this._extensions, additionalExtensions = null, _i = 0; _i < t1.length; t1.length === t2 || (0, A.throwConcurrentModificationError)(t1), ++_i){
                    extension = t1[_i];
                    t7 = t6.$index(0, extension.target);
                    t7.toString;
                    selectors = null;
                    try {
                        selectors = this._extendComplex$3(extension.extender.selector, newExtensions, extension.mediaContext);
                        if (selectors == null) continue;
                    } catch (exception) {
                        t8 = A.unwrapException(exception);
                        if (t8 instanceof A.SassException) {
                            error = t8;
                            stackTrace = A.getTraceFromException(exception);
                            A.throwWithTrace(error.withAdditionalSpan$2(extension.extender.selector.span, "target selector"), error, stackTrace);
                        } else throw exception;
                    }
                    t8 = J.get$first$ax(selectors);
                    t9 = extension.extender.selector;
                    if (B.C_ListEquality.equals$2(0, t8.leadingCombinators, t9.leadingCombinators) && B.C_ListEquality.equals$2(0, t8.components, t9.components)) {
                        t8 = selectors;
                        t9 = A._arrayInstanceType(t8);
                        selectors0 = new A.SubListIterable(t8, 1, null, t9._eval$1("SubListIterable<1>"));
                        selectors0.SubListIterable$3(t8, 1, null, t9._precomputed1);
                        selectors = selectors0;
                    }
                    for(t8 = J.get$iterator$ax(selectors); t8.moveNext$0();){
                        t9 = t8.get$current(t8);
                        t10 = extension;
                        t11 = t10.target;
                        t12 = t10.span;
                        t13 = t10.mediaContext;
                        t10 = t10.isOptional;
                        t9.get$specificity();
                        t14 = new A.Extender(t9, false);
                        withExtender = t14._extension = new A.Extension(t14, t11, t13, t10, t12);
                        _0_0 = t7.$index(0, t9);
                        if (_0_0 != null) t7.$indexSet(0, t9, A.MergedExtension_merge(_0_0, withExtender));
                        else {
                            t7.$indexSet(0, t9, withExtender);
                            for(t10 = t9.components, t11 = t10.length, _i0 = 0; _i0 < t11; ++_i0)for(t12 = t10[_i0].selector.components, t13 = t12.length, _i1 = 0; _i1 < t13; ++_i1)J.add$1$ax(t3.putIfAbsent$2(t12[_i1], new A.ExtensionStore__extendExistingExtensions_closure()), withExtender);
                            if (newExtensions.containsKey$1(extension.target)) {
                                if (additionalExtensions == null) additionalExtensions = A.LinkedHashMap_LinkedHashMap$_empty(t4, t5);
                                additionalExtensions.putIfAbsent$2(extension.target, new A.ExtensionStore__extendExistingExtensions_closure0()).$indexSet(0, t9, withExtender);
                            }
                        }
                    }
                }
                return additionalExtensions;
            },
            _extendExistingSelectors$2: function(selectors, newExtensions) {
                var selector, error, stackTrace, t1, t2, oldValue, _$exception, t3, t4, t5, t6;
                for(t1 = selectors.get$iterator(selectors), t2 = this._mediaContexts; t1.moveNext$0();){
                    selector = t1.get$current(t1);
                    oldValue = selector.value;
                    try {
                        selector.value = this._extendList$3(selector.value, newExtensions, t2.$index(0, selector));
                    } catch (exception) {
                        t3 = A.unwrapException(exception);
                        if (t3 instanceof A.SassException) {
                            error = t3;
                            stackTrace = A.getTraceFromException(exception);
                            t3 = selector.value.span.message$1(0, "");
                            t4 = error._span_exception$_message;
                            t5 = error;
                            t6 = J.getInterceptor$x(t5);
                            t5 = A.SourceSpanException.prototype.get$span.call(t6, t5);
                            A.throwWithTrace(new A.SassException(B.Set_empty, "From " + t3 + "\n" + t4, t5), error, stackTrace);
                        } else throw exception;
                    }
                    if (oldValue === selector.value) continue;
                    this._registerSelector$2(selector.value, selector);
                }
            },
            addExtensions$1: function(extensionStores) {
                var t1, t2, t3, t4, t5, t6, t7, t8, t9, t10, t11, newExtensions, selectorsToExtend, extensionsToExtend, t12, t13, target, newSources, first, extensionsForTarget, t14, selectorsForTarget, t15, _2_0, t16, extender, extension, _this = this, _null = null;
                for(t1 = J.get$iterator$ax(extensionStores), t2 = type$.SimpleSelector, t3 = type$.Map_ComplexSelector_Extension, t4 = _this._extensions, t5 = type$.ComplexSelector, t6 = type$.Extension, t7 = _this._selectors, t8 = _this._extensionsByExtender, t9 = type$.JSArray_Extension, t10 = type$.ModifiableBox_SelectorList, t11 = _this._sourceSpecificity, newExtensions = _null, selectorsToExtend = newExtensions, extensionsToExtend = selectorsToExtend; t1.moveNext$0();){
                    t12 = t1.get$current(t1);
                    if (t12.get$isEmpty(t12)) continue;
                    t11.addAll$1(0, t12.get$_sourceSpecificity());
                    for(t12 = A.MapExtensions_get_pairs(t12.get$_extensions(), t2, t3), t12 = t12.get$iterator(t12); t12.moveNext$0();){
                        t13 = t12.get$current(t12);
                        target = t13._0;
                        newSources = t13._1;
                        if (target instanceof A.PlaceholderSelector) {
                            first = target.name.charCodeAt(0);
                            t13 = first === 45 || first === 95;
                        } else t13 = false;
                        if (t13) continue;
                        extensionsForTarget = t8.$index(0, target);
                        t13 = extensionsForTarget == null;
                        if (!t13) {
                            if (extensionsToExtend == null) {
                                extensionsToExtend = A._setArrayType([], t9);
                                t14 = extensionsToExtend;
                            } else t14 = extensionsToExtend;
                            B.JSArray_methods.addAll$1(t14, extensionsForTarget);
                        }
                        selectorsForTarget = t7.$index(0, target);
                        t14 = selectorsForTarget != null;
                        if (t14) {
                            if (selectorsToExtend == null) {
                                selectorsToExtend = A.LinkedHashSet_LinkedHashSet$_empty(t10);
                                t15 = selectorsToExtend;
                            } else t15 = selectorsToExtend;
                            t15.addAll$1(0, selectorsForTarget);
                        }
                        _2_0 = t4.$index(0, target);
                        if (_2_0 != null) for(t15 = A.MapExtensions_get_pairs(newSources, t5, t6), t15 = t15.get$iterator(t15); t15.moveNext$0();){
                            t16 = t15.get$current(t15);
                            extender = t16._0;
                            extension = t16._1;
                            if (_2_0.containsKey$1(extender)) {
                                t16 = _2_0.$index(0, extender);
                                extension = A.MergedExtension_merge(t16 == null ? t6._as(t16) : t16, extension);
                                _2_0.$indexSet(0, extender, extension);
                            } else _2_0.$indexSet(0, extender, extension);
                            if (!t13 || t14) {
                                if (newExtensions == null) {
                                    newExtensions = A.LinkedHashMap_LinkedHashMap$_empty(t2, t3);
                                    t16 = newExtensions;
                                } else t16 = newExtensions;
                                t16.putIfAbsent$2(target, new A.ExtensionStore_addExtensions_closure()).$indexSet(0, extender, extension);
                            }
                        }
                        else {
                            t15 = A.LinkedHashMap_LinkedHashMap(_null, _null, _null, t5, t6);
                            t15.addAll$1(0, newSources);
                            t4.$indexSet(0, target, t15);
                            if (!t13 || t14) {
                                if (newExtensions == null) {
                                    newExtensions = A.LinkedHashMap_LinkedHashMap$_empty(t2, t3);
                                    t13 = newExtensions;
                                } else t13 = newExtensions;
                                t14 = A.LinkedHashMap_LinkedHashMap(_null, _null, _null, t5, t6);
                                t14.addAll$1(0, newSources);
                                t13.$indexSet(0, target, t14);
                            }
                        }
                    }
                }
                if (newExtensions != null) {
                    if (extensionsToExtend != null) _this._extendExistingExtensions$2(extensionsToExtend, newExtensions);
                    if (selectorsToExtend != null) _this._extendExistingSelectors$2(selectorsToExtend, newExtensions);
                }
            },
            _extendList$3: function(list, extensions, mediaQueryContext) {
                var t1, t2, t3, extended, i, complex, result, t4;
                for(t1 = list.components, t2 = t1.length, t3 = type$.JSArray_ComplexSelector, extended = null, i = 0; i < t2; ++i){
                    complex = t1[i];
                    result = this._extendComplex$3(complex, extensions, mediaQueryContext);
                    if (result == null) {
                        if (extended != null) extended.push(complex);
                    } else {
                        if (extended == null) {
                            if (i === 0) extended = A._setArrayType([], t3);
                            else {
                                t4 = B.JSArray_methods.sublist$2(t1, 0, i);
                                extended = A._setArrayType(t4.slice(0), A._arrayInstanceType(t4));
                            }
                        }
                        B.JSArray_methods.addAll$1(extended, result);
                    }
                }
                if (extended == null) return list;
                t1 = this._originals;
                return A.SelectorList$(this._trim$2(extended, t1.get$contains(t1)), list.span);
            },
            _extendList$2: function(list, extensions) {
                return this._extendList$3(list, extensions, null);
            },
            _extendComplex$3: function(complex, extensions, mediaQueryContext) {
                var isOriginal, t3, t4, t5, t6, t7, t8, t9, t10, extendedNotExpanded, i, component, extended, t11, t12, t13, t14, _box_0 = {}, t1 = complex.leadingCombinators, t2 = t1.length;
                if (t2 > 1) return null;
                isOriginal = this._originals.contains$1(0, complex);
                for(t3 = complex.components, t4 = t3.length, t5 = type$.JSArray_List_ComplexSelector, t6 = complex.lineBreak, t7 = !t6, t8 = complex.span, t9 = type$.JSArray_ComplexSelector, t2 = t2 === 0, t10 = type$.JSArray_ComplexSelectorComponent, extendedNotExpanded = null, i = 0; i < t4; ++i){
                    component = t3[i];
                    extended = this._extendCompound$4$inOriginal(component, extensions, mediaQueryContext, isOriginal);
                    if (extended == null) {
                        if (extendedNotExpanded != null) extendedNotExpanded.push(A._setArrayType([
                            A.ComplexSelector$(B.List_empty0, A._setArrayType([
                                component
                            ], t10), t8, t6)
                        ], t9));
                    } else if (extendedNotExpanded != null) extendedNotExpanded.push(extended);
                    else if (i !== 0) {
                        t11 = A._arrayInstanceType(t3);
                        t12 = new A.SubListIterable(t3, 0, i, t11._eval$1("SubListIterable<1>"));
                        t12.SubListIterable$3(t3, 0, i, t11._precomputed1);
                        extendedNotExpanded = A._setArrayType([
                            A._setArrayType([
                                A.ComplexSelector$(t1, t12, t8, t6)
                            ], t9),
                            extended
                        ], t5);
                    } else if (t2) extendedNotExpanded = A._setArrayType([
                        extended
                    ], t5);
                    else {
                        t11 = A._setArrayType([], t9);
                        for(t12 = J.get$iterator$ax(extended); t12.moveNext$0();){
                            t13 = t12.get$current(t12);
                            t14 = t13.leadingCombinators;
                            if (t14.length === 0 || B.C_ListEquality.equals$2(0, t1, t14)) {
                                t14 = t13.components;
                                t11.push(A.ComplexSelector$(t1, t14, t8, !t7 || t13.lineBreak));
                            }
                        }
                        extendedNotExpanded = A._setArrayType([
                            t11
                        ], t5);
                    }
                }
                if (extendedNotExpanded == null) return null;
                _box_0.first = true;
                t1 = type$.ComplexSelector;
                t1 = J.expand$1$1$ax(A.paths(extendedNotExpanded, t1), new A.ExtensionStore__extendComplex_closure(_box_0, this, complex), t1);
                t1 = A.List_List$_of(t1, t1.$ti._eval$1("Iterable.E"));
                return t1;
            },
            _extendCompound$4$inOriginal: function(component, extensions, mediaQueryContext, inOriginal) {
                var t3, t4, t5, t6, t7, t8, t9, t10, t11, options, i, simple, extended, t12, result, compound, complex, extenderPaths, withCombinators, isOriginal, _this = this, _null = null, t1 = _this._mode, targetsUsed = t1 === B.ExtendMode_normal_0_normal || extensions.__js_helper$_length < 2 ? _null : A.LinkedHashSet_LinkedHashSet$_empty(type$.SimpleSelector), t2 = component.selector, simples = t2.components;
                for(t3 = simples.length, t4 = type$.JSArray_List_Extender, t5 = type$.JSArray_Extender, t6 = type$.CssValue_Combinator, t7 = type$.JSArray_ComplexSelectorComponent, t8 = A._arrayInstanceType(simples), t9 = t8._precomputed1, t8 = t8._eval$1("SubListIterable<1>"), t10 = component.span, t11 = type$.SimpleSelector, options = _null, i = 0; i < t3; ++i){
                    simple = simples[i];
                    extended = _this._extendSimple$4(simple, extensions, mediaQueryContext, targetsUsed);
                    if (extended == null) {
                        if (options != null) options.push(A._setArrayType([
                            _this._extenderForSimple$1(simple)
                        ], t5));
                    } else {
                        if (options == null) {
                            options = A._setArrayType([], t4);
                            if (i !== 0) {
                                t12 = new A.SubListIterable(simples, 0, i, t8);
                                t12.SubListIterable$3(simples, 0, i, t9);
                                result = A.List_List$from(t12, false, t11);
                                result.$flags = 3;
                                t12 = result;
                                compound = new A.CompoundSelector(t12, t10);
                                if (t12.length === 0) A.throwExpression(A.ArgumentError$("components may not be empty.", _null));
                                result = A.List_List$from(B.List_empty0, false, t6);
                                result.$flags = 3;
                                t12 = A.ComplexSelector$(B.List_empty0, A._setArrayType([
                                    new A.ComplexSelectorComponent(compound, result, t10)
                                ], t7), t10, false);
                                _this._sourceSpecificityFor$1(compound);
                                options.push(A._setArrayType([
                                    new A.Extender(t12, true)
                                ], t5));
                            }
                        }
                        B.JSArray_methods.addAll$1(options, extended);
                    }
                }
                if (options == null) return _null;
                if (targetsUsed != null && targetsUsed._collection$_length !== extensions.__js_helper$_length) return _null;
                if (options.length === 1) {
                    for(t1 = J.get$iterator$ax(options[0]), t2 = component.combinators, t3 = type$.JSArray_ComplexSelector, result = _null; t1.moveNext$0();){
                        t4 = t1.get$current(t1);
                        t4.assertCompatibleMediaContext$1(mediaQueryContext);
                        complex = t4.selector.withAdditionalCombinators$1(t2);
                        if (complex.accept$1(B.C__IsUselessVisitor)) continue;
                        if (result == null) result = A._setArrayType([], t3);
                        result.push(complex);
                    }
                    return result;
                }
                extenderPaths = A.paths(options, type$.Extender);
                t3 = A._setArrayType([], type$.JSArray_ComplexSelector);
                t1 = t1 === B.ExtendMode_replace_1_replace;
                t4 = !t1;
                if (t4) t3.push(A.ComplexSelector$(B.List_empty0, A._setArrayType([
                    new A.ComplexSelectorComponent(A.CompoundSelector$(J.expand$1$1$ax(J.get$first$ax(extenderPaths), new A.ExtensionStore__extendCompound_closure(), t11), t2.span), A.List_List$unmodifiable(component.combinators, t6), t10)
                ], t7), t10, false));
                t2 = J.skip$1$ax(extenderPaths, t1 ? 0 : 1);
                t5 = t2.$ti;
                t2 = new A.ListIterator(t2, t2.get$length(0), t5._eval$1("ListIterator<ListIterable.E>"));
                t6 = component.combinators;
                t5 = t5._eval$1("ListIterable.E");
                while(t2.moveNext$0()){
                    t1 = t2.__internal$_current;
                    extended = _this._unifyExtenders$3(t1 == null ? t5._as(t1) : t1, mediaQueryContext, t10);
                    if (extended == null) continue;
                    for(t1 = J.get$iterator$ax(extended); t1.moveNext$0();){
                        withCombinators = t1.get$current(t1).withAdditionalCombinators$1(t6);
                        if (!withCombinators.accept$1(B.C__IsUselessVisitor)) t3.push(withCombinators);
                    }
                }
                isOriginal = new A.ExtensionStore__extendCompound_closure0();
                return _this._trim$2(t3, inOriginal && t4 ? new A.ExtensionStore__extendCompound_closure1(B.JSArray_methods.get$first(t3)) : isOriginal);
            },
            _unifyExtenders$3: function(extenders, mediaQueryContext, span) {
                var t1, t2, t3, originals, originalsLineBreak, t4, complexes, _null = null, toUnify = A.QueueList$(_null, type$.ComplexSelector);
                for(t1 = J.getInterceptor$ax(extenders), t2 = t1.get$iterator(extenders), t3 = type$.JSArray_SimpleSelector, originals = _null, originalsLineBreak = false; t2.moveNext$0();){
                    t4 = t2.get$current(t2);
                    if (t4.isOriginal) {
                        if (originals == null) originals = A._setArrayType([], t3);
                        t4 = t4.selector;
                        B.JSArray_methods.addAll$1(originals, B.JSArray_methods.get$last(t4.components).selector.components);
                        originalsLineBreak = originalsLineBreak || t4.lineBreak;
                    } else {
                        t4 = t4.selector;
                        if (t4.accept$1(B.C__IsUselessVisitor)) return _null;
                        else toUnify._queue_list$_add$1(t4);
                    }
                }
                if (originals != null) toUnify.addFirst$1(A.ComplexSelector$(B.List_empty0, A._setArrayType([
                    new A.ComplexSelectorComponent(A.CompoundSelector$(originals, span), A.List_List$unmodifiable(B.List_empty0, type$.CssValue_Combinator), span)
                ], type$.JSArray_ComplexSelectorComponent), span, originalsLineBreak));
                complexes = A.unifyComplex(toUnify, span);
                if (complexes == null) return _null;
                for(t1 = t1.get$iterator(extenders); t1.moveNext$0();)t1.get$current(t1).assertCompatibleMediaContext$1(mediaQueryContext);
                return complexes;
            },
            _extendSimple$4: function(simple, extensions, mediaQueryContext, targetsUsed) {
                var t2, _1_0, t1 = new A.ExtensionStore__extendSimple_withoutPseudo(this, extensions, targetsUsed);
                if (simple instanceof A.PseudoSelector) t2 = simple.selector != null;
                else t2 = false;
                if (t2) {
                    _1_0 = this._extendPseudo$3(simple, extensions, mediaQueryContext);
                    if (_1_0 != null) return new A.MappedListIterable(_1_0, new A.ExtensionStore__extendSimple_closure(this, t1), A._arrayInstanceType(_1_0)._eval$1("MappedListIterable<1,List<Extender>>"));
                }
                return A.NullableExtension_andThen(t1.call$1(simple), new A.ExtensionStore__extendSimple_closure0());
            },
            _extenderForSimple$1: function(simple) {
                var t1 = simple.span;
                t1 = A.ComplexSelector$(B.List_empty0, A._setArrayType([
                    new A.ComplexSelectorComponent(A.CompoundSelector$(A._setArrayType([
                        simple
                    ], type$.JSArray_SimpleSelector), t1), A.List_List$unmodifiable(B.List_empty0, type$.CssValue_Combinator), t1)
                ], type$.JSArray_ComplexSelectorComponent), t1, false);
                this._sourceSpecificity.$index(0, simple);
                return new A.Extender(t1, true);
            },
            _extendPseudo$3: function(pseudo, extensions, mediaQueryContext) {
                var extended, complexes, t1, result, selector = pseudo.selector;
                if (selector == null) throw A.wrapException(A.ArgumentError$("Selector " + pseudo.toString$0(0) + " must have a selector argument.", null));
                extended = this._extendList$3(selector, extensions, mediaQueryContext);
                if (extended === selector) return null;
                complexes = extended.components;
                t1 = pseudo.normalizedName === "not";
                if (t1 && !B.JSArray_methods.any$1(selector.components, new A.ExtensionStore__extendPseudo_closure()) && B.JSArray_methods.any$1(complexes, new A.ExtensionStore__extendPseudo_closure0())) complexes = new A.WhereIterable(complexes, new A.ExtensionStore__extendPseudo_closure1(), A._arrayInstanceType(complexes)._eval$1("WhereIterable<1>"));
                complexes = J.expand$1$1$ax(complexes, new A.ExtensionStore__extendPseudo_closure2(pseudo), type$.ComplexSelector);
                if (t1 && selector.components.length === 1) {
                    t1 = A.MappedIterable_MappedIterable(complexes, new A.ExtensionStore__extendPseudo_closure3(pseudo, selector), complexes.$ti._eval$1("Iterable.E"), type$.PseudoSelector);
                    result = A.List_List$_of(t1, A._instanceType(t1)._eval$1("Iterable.E"));
                    return result.length === 0 ? null : result;
                } else return A._setArrayType([
                    pseudo.withSelector$1(A.SelectorList$(complexes, selector.span))
                ], type$.JSArray_PseudoSelector);
            },
            _trim$2: function(selectors, isOriginal) {
                var result, i, t1, t2, numOriginals, _box_0, complex1, j, t3, t4, _i, t5, maxSpecificity;
                if (selectors.length > 100) return selectors;
                result = A.QueueList$(null, type$.ComplexSelector);
                $label0$0: for(i = selectors.length - 1, t1 = A._arrayInstanceType(selectors), t2 = t1._precomputed1, t1 = t1._eval$1("SubListIterable<1>"), numOriginals = 0; i >= 0; --i){
                    _box_0 = {};
                    complex1 = selectors[i];
                    if (isOriginal.call$1(complex1)) {
                        for(j = 0; j < numOriginals; ++j)if (result.$index(0, j).$eq(0, complex1)) {
                            A.rotateSlice(result, 0, j + 1);
                            continue $label0$0;
                        }
                        ++numOriginals;
                        result.addFirst$1(complex1);
                        continue $label0$0;
                    }
                    _box_0.maxSpecificity = 0;
                    for(t3 = complex1.components, t4 = t3.length, _i = 0, t5 = 0; _i < t4; ++_i, t5 = maxSpecificity){
                        maxSpecificity = Math.max(t5, this._sourceSpecificityFor$1(t3[_i].selector));
                        _box_0.maxSpecificity = maxSpecificity;
                    }
                    if (result.any$1(result, new A.ExtensionStore__trim_closure(_box_0, complex1))) continue $label0$0;
                    t3 = new A.SubListIterable(selectors, 0, i, t1);
                    t3.SubListIterable$3(selectors, 0, i, t2);
                    if (t3.any$1(0, new A.ExtensionStore__trim_closure0(_box_0, complex1))) continue $label0$0;
                    result.addFirst$1(complex1);
                }
                return result;
            },
            _sourceSpecificityFor$1: function(compound) {
                var t1, t2, t3, specificity, _i, t4;
                for(t1 = compound.components, t2 = t1.length, t3 = this._sourceSpecificity, specificity = 0, _i = 0; _i < t2; ++_i){
                    t4 = t3.$index(0, t1[_i]);
                    if (t4 == null) t4 = 0;
                    specificity = Math.max(specificity, t4);
                }
                return specificity;
            },
            clone$0: function() {
                var t3, t4, _this = this, t1 = type$.SimpleSelector, newSelectors = A.LinkedHashMap_LinkedHashMap$_empty(t1, type$.Set_ModifiableBox_SelectorList), t2 = type$.ModifiableBox_SelectorList, newMediaContexts = A.LinkedHashMap_LinkedHashMap$_empty(t2, type$.List_CssMediaQuery), oldToNewSelectors = new A.JsIdentityLinkedHashMap(type$.JsIdentityLinkedHashMap_of_SelectorList_and_Box_SelectorList);
                _this._selectors.forEach$1(0, new A.ExtensionStore_clone_closure(_this, newSelectors, A.LinkedHashMap_LinkedHashMap$_empty(t2, t2), oldToNewSelectors, newMediaContexts));
                t2 = type$.Extension;
                t3 = A.copyMapOfMap(_this._extensions, t1, type$.ComplexSelector, t2);
                t2 = A.copyMapOfList(_this._extensionsByExtender, t1, t2);
                t1 = new A.JsIdentityLinkedHashMap(type$.JsIdentityLinkedHashMap_SimpleSelector_int);
                t1.addAll$1(0, _this._sourceSpecificity);
                t4 = new A._LinkedIdentityHashSet(type$._LinkedIdentityHashSet_ComplexSelector);
                t4.addAll$1(0, _this._originals);
                return new A._Record_2(new A.ExtensionStore(newSelectors, t3, t2, newMediaContexts, t1, t4, B.ExtendMode_normal_0_normal), oldToNewSelectors);
            },
            get$_extensions: function() {
                return this._extensions;
            },
            get$_sourceSpecificity: function() {
                return this._sourceSpecificity;
            }
        };
        A.ExtensionStore_extensionsWhereTarget_closure.prototype = {
            call$1: function(extension) {
                return !extension.isOptional;
            },
            $signature: 334
        };
        A.ExtensionStore__registerSelector_closure.prototype = {
            call$0: function() {
                return A.LinkedHashSet_LinkedHashSet$_empty(type$.ModifiableBox_SelectorList);
            },
            $signature: 338
        };
        A.ExtensionStore_addExtension_closure.prototype = {
            call$0: function() {
                return A.LinkedHashMap_LinkedHashMap$_empty(type$.ComplexSelector, type$.Extension);
            },
            $signature: 130
        };
        A.ExtensionStore_addExtension_closure0.prototype = {
            call$0: function() {
                return A._setArrayType([], type$.JSArray_Extension);
            },
            $signature: 213
        };
        A.ExtensionStore_addExtension_closure1.prototype = {
            call$0: function() {
                return this.complex.get$specificity();
            },
            $signature: 10
        };
        A.ExtensionStore__extendExistingExtensions_closure.prototype = {
            call$0: function() {
                return A._setArrayType([], type$.JSArray_Extension);
            },
            $signature: 213
        };
        A.ExtensionStore__extendExistingExtensions_closure0.prototype = {
            call$0: function() {
                return A.LinkedHashMap_LinkedHashMap$_empty(type$.ComplexSelector, type$.Extension);
            },
            $signature: 130
        };
        A.ExtensionStore_addExtensions_closure.prototype = {
            call$0: function() {
                return A.LinkedHashMap_LinkedHashMap$_empty(type$.ComplexSelector, type$.Extension);
            },
            $signature: 130
        };
        A.ExtensionStore__extendComplex_closure.prototype = {
            call$1: function(path) {
                var t1 = this.complex;
                return J.map$1$1$ax(A.weave(path, t1.span, t1.lineBreak), new A.ExtensionStore__extendComplex__closure(this._box_0, this.$this, t1), type$.ComplexSelector);
            },
            $signature: 343
        };
        A.ExtensionStore__extendComplex__closure.prototype = {
            call$1: function(outputComplex) {
                var _this = this, t1 = _this._box_0;
                if (t1.first && _this.$this._originals.contains$1(0, _this.complex)) _this.$this._originals.add$1(0, outputComplex);
                t1.first = false;
                return outputComplex;
            },
            $signature: 61
        };
        A.ExtensionStore__extendCompound_closure.prototype = {
            call$1: function(extender) {
                return B.JSArray_methods.get$last(extender.selector.components).selector.components;
            },
            $signature: 345
        };
        A.ExtensionStore__extendCompound_closure0.prototype = {
            call$1: function(_) {
                return false;
            },
            $signature: 21
        };
        A.ExtensionStore__extendCompound_closure1.prototype = {
            call$1: function(complex) {
                return complex.$eq(0, this.original);
            },
            $signature: 21
        };
        A.ExtensionStore__extendSimple_withoutPseudo.prototype = {
            call$1: function(simple) {
                var t1, t2, extensionsForSimple = this.extensions.$index(0, simple);
                if (extensionsForSimple == null) return null;
                t1 = this.targetsUsed;
                if (t1 != null) t1.add$1(0, simple);
                t1 = A._setArrayType([], type$.JSArray_Extender);
                t2 = this.$this;
                if (t2._mode !== B.ExtendMode_replace_1_replace) t1.push(t2._extenderForSimple$1(simple));
                for(t2 = extensionsForSimple.get$values(extensionsForSimple), t2 = t2.get$iterator(t2); t2.moveNext$0();)t1.push(t2.get$current(t2).extender);
                return t1;
            },
            $signature: 351
        };
        A.ExtensionStore__extendSimple_closure.prototype = {
            call$1: function(pseudo) {
                var t1 = this.withoutPseudo.call$1(pseudo);
                return t1 == null ? A._setArrayType([
                    this.$this._extenderForSimple$1(pseudo)
                ], type$.JSArray_Extender) : t1;
            },
            $signature: 352
        };
        A.ExtensionStore__extendSimple_closure0.prototype = {
            call$1: function(result) {
                return A._setArrayType([
                    result
                ], type$.JSArray_List_Extender);
            },
            $signature: 353
        };
        A.ExtensionStore__extendPseudo_closure.prototype = {
            call$1: function(complex) {
                return complex.components.length > 1;
            },
            $signature: 21
        };
        A.ExtensionStore__extendPseudo_closure0.prototype = {
            call$1: function(complex) {
                return complex.components.length === 1;
            },
            $signature: 21
        };
        A.ExtensionStore__extendPseudo_closure1.prototype = {
            call$1: function(complex) {
                return complex.components.length <= 1;
            },
            $signature: 21
        };
        A.ExtensionStore__extendPseudo_closure2.prototype = {
            call$1: function(complex) {
                var innerPseudo, innerSelector, t1 = complex.get$singleCompound();
                if (t1 == null) innerPseudo = null;
                else {
                    t1 = t1.components;
                    innerPseudo = t1.length === 1 ? B.JSArray_methods.get$first(t1) : null;
                }
                if (!(innerPseudo instanceof A.PseudoSelector)) return A._setArrayType([
                    complex
                ], type$.JSArray_ComplexSelector);
                innerSelector = innerPseudo.selector;
                if (innerSelector == null) return A._setArrayType([
                    complex
                ], type$.JSArray_ComplexSelector);
                t1 = this.pseudo;
                switch(t1.normalizedName){
                    case "not":
                        if (!B.Set_0egh6.contains$1(0, innerPseudo.normalizedName)) return A._setArrayType([], type$.JSArray_ComplexSelector);
                        return innerSelector.components;
                    case "is":
                    case "matches":
                    case "where":
                    case "any":
                    case "current":
                    case "nth-child":
                    case "nth-last-child":
                        if (innerPseudo.name !== t1.name) return A._setArrayType([], type$.JSArray_ComplexSelector);
                        if (innerPseudo.argument != t1.argument) return A._setArrayType([], type$.JSArray_ComplexSelector);
                        return innerSelector.components;
                    case "has":
                    case "host":
                    case "host-context":
                    case "slotted":
                        return A._setArrayType([
                            complex
                        ], type$.JSArray_ComplexSelector);
                    default:
                        return A._setArrayType([], type$.JSArray_ComplexSelector);
                }
            },
            $signature: 354
        };
        A.ExtensionStore__extendPseudo_closure3.prototype = {
            call$1: function(complex) {
                return this.pseudo.withSelector$1(A.SelectorList$(A._setArrayType([
                    complex
                ], type$.JSArray_ComplexSelector), this.selector.span));
            },
            $signature: 355
        };
        A.ExtensionStore__trim_closure.prototype = {
            call$1: function(complex2) {
                return complex2.get$specificity() >= this._box_0.maxSpecificity && complex2.isSuperselector$1(this.complex1);
            },
            $signature: 21
        };
        A.ExtensionStore__trim_closure0.prototype = {
            call$1: function(complex2) {
                return complex2.get$specificity() >= this._box_0.maxSpecificity && complex2.isSuperselector$1(this.complex1);
            },
            $signature: 21
        };
        A.ExtensionStore_clone_closure.prototype = {
            call$2: function(simple, selectors) {
                var t1, t2, t3, t4, t5, t6, newSelector, _0_0, _this = this, newSelectorSet = A.LinkedHashSet_LinkedHashSet$_empty(type$.ModifiableBox_SelectorList);
                _this.newSelectors.$indexSet(0, simple, newSelectorSet);
                for(t1 = selectors.get$iterator(selectors), t2 = _this.newBoxes, t3 = _this.oldToNewSelectors, t4 = _this.$this._mediaContexts, t5 = _this.newMediaContexts; t1.moveNext$0();){
                    t6 = t1.get$current(t1);
                    newSelector = t2.putIfAbsent$2(t6, new A.ExtensionStore_clone__closure(t6));
                    newSelectorSet.add$1(0, newSelector);
                    t3.$indexSet(0, t6.value, new A.Box(newSelector, newSelector.$ti._eval$1("Box<1>")));
                    _0_0 = t4.$index(0, t6);
                    if (_0_0 != null) t5.$indexSet(0, newSelector, _0_0);
                }
            },
            $signature: 359
        };
        A.ExtensionStore_clone__closure.prototype = {
            call$0: function() {
                return new A.ModifiableBox(this.selector.value, type$.ModifiableBox_SelectorList);
            },
            $signature: 360
        };
        A.unifyComplex_closure.prototype = {
            call$1: function(complex) {
                return complex.lineBreak;
            },
            $signature: 21
        };
        A._weaveParents_closure.prototype = {
            call$2: function(group1, group2) {
                var t1, unified;
                if (B.C_ListEquality.equals$2(0, group1, group2)) return group1;
                if (A._complexIsParentSuperselector(group1, group2)) return group2;
                if (A._complexIsParentSuperselector(group2, group1)) return group1;
                if (!A._mustUnify(group1, group2)) return null;
                t1 = this.span;
                unified = A.unifyComplex(A._setArrayType([
                    A.ComplexSelector$(B.List_empty0, group1, t1, false),
                    A.ComplexSelector$(B.List_empty0, group2, t1, false)
                ], type$.JSArray_ComplexSelector), t1);
                if (unified == null) t1 = null;
                else {
                    t1 = A.IterableExtension_get_singleOrNull(unified);
                    t1 = t1 == null ? null : t1.components;
                }
                return t1;
            },
            $signature: 362
        };
        A._weaveParents_closure0.prototype = {
            call$1: function(sequence) {
                return A._complexIsParentSuperselector(sequence.get$first(sequence), this.group);
            },
            $signature: 219
        };
        A._weaveParents_closure1.prototype = {
            call$1: function(sequence) {
                return sequence.get$length(0) === 0;
            },
            $signature: 219
        };
        A._weaveParents_closure2.prototype = {
            call$1: function(choice) {
                return J.get$isNotEmpty$asx(choice);
            },
            $signature: 364
        };
        A._mustUnify_closure.prototype = {
            call$1: function(component) {
                return B.JSArray_methods.any$1(component.selector.components, new A._mustUnify__closure(this.uniqueSelectors));
            },
            $signature: 54
        };
        A._mustUnify__closure.prototype = {
            call$1: function(simple) {
                var t1;
                if (!(simple instanceof A.IDSelector)) t1 = simple instanceof A.PseudoSelector && !simple.isClass;
                else t1 = true;
                return t1 && this.uniqueSelectors.contains$1(0, simple);
            },
            $signature: 14
        };
        A.paths_closure.prototype = {
            call$2: function(paths, choice) {
                var t1 = this.T;
                t1 = J.expand$1$1$ax(choice, new A.paths__closure(paths, t1), t1._eval$1("List<0>"));
                t1 = A.List_List$_of(t1, t1.$ti._eval$1("Iterable.E"));
                return t1;
            },
            $signature: function() {
                return this.T._eval$1("List<List<0>>(List<List<0>>,List<0>)");
            }
        };
        A.paths__closure.prototype = {
            call$1: function(option) {
                var t1 = this.T;
                return J.map$1$1$ax(this.paths, new A.paths___closure(option, t1), t1._eval$1("List<0>"));
            },
            $signature: function() {
                return this.T._eval$1("Iterable<List<0>>(0)");
            }
        };
        A.paths___closure.prototype = {
            call$1: function(path) {
                var t1 = A.List_List$_of(path, this.T);
                t1.push(this.option);
                return t1;
            },
            $signature: function() {
                return this.T._eval$1("List<0>(List<0>)");
            }
        };
        A.listIsSuperselector_closure.prototype = {
            call$1: function(complex1) {
                return B.JSArray_methods.any$1(this.list1, new A.listIsSuperselector__closure(complex1));
            },
            $signature: 21
        };
        A.listIsSuperselector__closure.prototype = {
            call$1: function(complex2) {
                return complex2.isSuperselector$1(this.complex1);
            },
            $signature: 21
        };
        A.complexIsSuperselector_closure.prototype = {
            call$1: function($parent) {
                return $parent.combinators.length > 1;
            },
            $signature: 54
        };
        A.complexIsSuperselector_closure0.prototype = {
            call$1: function(component) {
                return A._isSupercombinator(this.combinator1, A.IterableExtension_get_firstOrNull(component.combinators));
            },
            $signature: 54
        };
        A._compatibleWithPreviousCombinator_closure.prototype = {
            call$1: function(component) {
                var t1 = component.combinators, t2 = A.IterableExtension_get_firstOrNull(t1);
                if ((t2 == null ? null : t2.value) !== B.Combinator_98W) {
                    t1 = A.IterableExtension_get_firstOrNull(t1);
                    t1 = (t1 == null ? null : t1.value) === B.Combinator_sHB;
                } else t1 = true;
                return t1;
            },
            $signature: 54
        };
        A.compoundIsSuperselector_closure.prototype = {
            call$1: function(simple1) {
                return B.JSArray_methods.any$1(this.compound2.components, simple1.get$isSuperselector());
            },
            $signature: 14
        };
        A._selectorPseudoIsSuperselector_closure.prototype = {
            call$1: function(selector2) {
                return A.listIsSuperselector(this.selector1.components, selector2.components);
            },
            $signature: 77
        };
        A._selectorPseudoIsSuperselector_closure0.prototype = {
            call$1: function(complex1) {
                var t1, t2;
                if (complex1.leadingCombinators.length === 0) {
                    t1 = A._setArrayType([], type$.JSArray_ComplexSelectorComponent);
                    t2 = this.parents;
                    if (t2 != null) B.JSArray_methods.addAll$1(t1, t2);
                    t2 = this.compound2;
                    t1.push(new A.ComplexSelectorComponent(t2, A.List_List$unmodifiable(B.List_empty0, type$.CssValue_Combinator), t2.span));
                    t1 = A.complexIsSuperselector(complex1.components, t1);
                } else t1 = false;
                return t1;
            },
            $signature: 21
        };
        A._selectorPseudoIsSuperselector_closure1.prototype = {
            call$1: function(selector2) {
                return A.listIsSuperselector(this.selector1.components, selector2.components);
            },
            $signature: 77
        };
        A._selectorPseudoIsSuperselector_closure2.prototype = {
            call$1: function(selector2) {
                return A.listIsSuperselector(this.selector1.components, selector2.components);
            },
            $signature: 77
        };
        A._selectorPseudoIsSuperselector_closure3.prototype = {
            call$1: function(complex) {
                if (complex.accept$1(B._IsBogusVisitor_true)) return false;
                return B.JSArray_methods.any$1(this.compound2.components, new A._selectorPseudoIsSuperselector__closure(complex, this.pseudo1));
            },
            $signature: 21
        };
        A._selectorPseudoIsSuperselector__closure.prototype = {
            call$1: function(simple2) {
                var t1, selector2, _0_4, _this = this;
                $label0$1: {
                    if (simple2 instanceof A.TypeSelector) {
                        t1 = B.JSArray_methods.any$1(B.JSArray_methods.get$last(_this.complex.components).selector.components, new A._selectorPseudoIsSuperselector___closure(simple2));
                        break $label0$1;
                    }
                    if (simple2 instanceof A.IDSelector) {
                        t1 = B.JSArray_methods.any$1(B.JSArray_methods.get$last(_this.complex.components).selector.components, new A._selectorPseudoIsSuperselector___closure0(simple2));
                        break $label0$1;
                    }
                    selector2 = null;
                    t1 = false;
                    if (simple2 instanceof A.PseudoSelector) {
                        _0_4 = simple2.selector;
                        if (_0_4 != null) {
                            selector2 = _0_4 == null ? type$.SelectorList._as(_0_4) : _0_4;
                            t1 = simple2.name === _this.pseudo1.name;
                        }
                    }
                    if (t1) {
                        t1 = A.listIsSuperselector(selector2.components, A._setArrayType([
                            _this.complex
                        ], type$.JSArray_ComplexSelector));
                        break $label0$1;
                    }
                    t1 = false;
                    break $label0$1;
                }
                return t1;
            },
            $signature: 14
        };
        A._selectorPseudoIsSuperselector___closure.prototype = {
            call$1: function(simple1) {
                var t1;
                if (simple1 instanceof A.TypeSelector) {
                    t1 = this.simple2.name.$eq(0, simple1.name);
                    t1 = !t1;
                } else t1 = false;
                return t1;
            },
            $signature: 14
        };
        A._selectorPseudoIsSuperselector___closure0.prototype = {
            call$1: function(simple1) {
                var t1;
                if (simple1 instanceof A.IDSelector) t1 = this.simple2.name !== simple1.name;
                else t1 = false;
                return t1;
            },
            $signature: 14
        };
        A._selectorPseudoIsSuperselector_closure4.prototype = {
            call$1: function(selector2) {
                var t1 = B.C_ListEquality.equals$2(0, this.selector1.components, selector2.components);
                return t1;
            },
            $signature: 77
        };
        A._selectorPseudoIsSuperselector_closure5.prototype = {
            call$1: function(pseudo2) {
                var t1, selector2;
                if (!(pseudo2 instanceof A.PseudoSelector)) return false;
                t1 = this.pseudo1;
                if (pseudo2.name !== t1.name) return false;
                if (pseudo2.argument != t1.argument) return false;
                selector2 = pseudo2.selector;
                if (selector2 == null) return false;
                return A.listIsSuperselector(this.selector1.components, selector2.components);
            },
            $signature: 14
        };
        A._selectorPseudoArgs_closure.prototype = {
            call$1: function(pseudo) {
                return pseudo.isClass === this.isClass && pseudo.name === this.name;
            },
            $signature: 375
        };
        A._selectorPseudoArgs_closure0.prototype = {
            call$1: function(pseudo) {
                return pseudo.selector;
            },
            $signature: 376
        };
        A.MergedExtension.prototype = {
            unmerge$0: function() {
                return new A._SyncStarIterable(this.unmerge$body$MergedExtension(), type$._SyncStarIterable_Extension);
            },
            unmerge$body$MergedExtension: function() {
                var $async$self = this;
                return function() {
                    var $async$goto = 0, $async$handler = 1, $async$errorStack = [], right, left;
                    return function $async$unmerge$0($async$iterator, $async$errorCode, $async$result) {
                        if ($async$errorCode === 1) {
                            $async$errorStack.push($async$result);
                            $async$goto = $async$handler;
                        }
                        for(;;)switch($async$goto){
                            case 0:
                                // Function start
                                left = $async$self.left;
                                $async$goto = left instanceof A.MergedExtension ? 2 : 4;
                                break;
                            case 2:
                                // then
                                $async$goto = 5;
                                return $async$iterator._yieldStar$1(left.unmerge$0());
                            case 5:
                                // after yield
                                // goto join
                                $async$goto = 3;
                                break;
                            case 4:
                                // else
                                $async$goto = 6;
                                return $async$iterator._async$_current = left, 1;
                            case 6:
                            // after yield
                            case 3:
                                // join
                                right = $async$self.right;
                                $async$goto = right instanceof A.MergedExtension ? 7 : 9;
                                break;
                            case 7:
                                // then
                                $async$goto = 10;
                                return $async$iterator._yieldStar$1(right.unmerge$0());
                            case 10:
                                // after yield
                                // goto join
                                $async$goto = 8;
                                break;
                            case 9:
                                // else
                                $async$goto = 11;
                                return $async$iterator._async$_current = right, 1;
                            case 11:
                            // after yield
                            case 8:
                                // join
                                // implicit return
                                return 0;
                            case 1:
                                // rethrow
                                return $async$iterator._datum = $async$errorStack.at(-1), 3;
                        }
                    };
                };
            }
        };
        A.ExtendMode.prototype = {
            _enumToString$0: function() {
                return "ExtendMode." + this._name;
            },
            toString$0: function(_) {
                return this.name;
            }
        };
        A.globalFunctions_closure.prototype = {
            call$1: function($arguments) {
                var t1 = J.getInterceptor$asx($arguments);
                return t1.$index($arguments, 0).get$isTruthy() ? t1.$index($arguments, 1) : t1.$index($arguments, 2);
            },
            $signature: 5
        };
        A.global_closure0.prototype = {
            call$1: function(color) {
                return B.JSNumber_methods.round$0(color._legacyChannel$2(B.RgbColorSpace_i0P, "red"));
            },
            $signature: 66
        };
        A.global_closure1.prototype = {
            call$1: function(color) {
                return B.JSNumber_methods.round$0(color._legacyChannel$2(B.RgbColorSpace_i0P, "green"));
            },
            $signature: 66
        };
        A.global_closure2.prototype = {
            call$1: function(color) {
                return B.JSNumber_methods.round$0(color._legacyChannel$2(B.RgbColorSpace_i0P, "blue"));
            },
            $signature: 66
        };
        A.global_closure3.prototype = {
            call$1: function($arguments) {
                return A._rgb("rgb", $arguments);
            },
            $signature: 5
        };
        A.global_closure4.prototype = {
            call$1: function($arguments) {
                return A._rgb("rgb", $arguments);
            },
            $signature: 5
        };
        A.global_closure5.prototype = {
            call$1: function($arguments) {
                return A._rgbTwoArg("rgb", $arguments);
            },
            $signature: 5
        };
        A.global_closure6.prototype = {
            call$1: function($arguments) {
                return A._parseChannels("rgb", J.$index$asx($arguments, 0), "channels", B.RgbColorSpace_i0P);
            },
            $signature: 5
        };
        A.global_closure7.prototype = {
            call$1: function($arguments) {
                return A._rgb("rgba", $arguments);
            },
            $signature: 5
        };
        A.global_closure8.prototype = {
            call$1: function($arguments) {
                return A._rgb("rgba", $arguments);
            },
            $signature: 5
        };
        A.global_closure9.prototype = {
            call$1: function($arguments) {
                return A._rgbTwoArg("rgba", $arguments);
            },
            $signature: 5
        };
        A.global_closure10.prototype = {
            call$1: function($arguments) {
                return A._parseChannels("rgba", J.$index$asx($arguments, 0), "channels", B.RgbColorSpace_i0P);
            },
            $signature: 5
        };
        A.global_closure11.prototype = {
            call$1: function($arguments) {
                var t1 = J.getInterceptor$asx($arguments);
                if (!(t1.$index($arguments, 0) instanceof A.SassNumber) && !t1.$index($arguments, 0).get$isSpecialNumber()) A.warnForDeprecation(string$.Globalci, B.Deprecation_WW3);
                return A._invert($arguments, true);
            },
            $signature: 5
        };
        A.global_closure12.prototype = {
            call$1: function(color) {
                return color._legacyChannel$2(B.HslColorSpace_JQ2, "hue");
            },
            $signature: 45
        };
        A.global_closure13.prototype = {
            call$1: function(color) {
                return color._legacyChannel$2(B.HslColorSpace_JQ2, "saturation");
            },
            $signature: 45
        };
        A.global_closure14.prototype = {
            call$1: function(color) {
                return color._legacyChannel$2(B.HslColorSpace_JQ2, "lightness");
            },
            $signature: 45
        };
        A.global_closure15.prototype = {
            call$1: function($arguments) {
                return A._hsl("hsl", $arguments);
            },
            $signature: 5
        };
        A.global_closure16.prototype = {
            call$1: function($arguments) {
                return A._hsl("hsl", $arguments);
            },
            $signature: 5
        };
        A.global_closure17.prototype = {
            call$1: function($arguments) {
                var t1 = J.getInterceptor$asx($arguments);
                if (t1.$index($arguments, 0).get$isSpecialVariable() || t1.$index($arguments, 1).get$isSpecialVariable()) return A._functionString("hsl", $arguments);
                else throw A.wrapException(A.SassScriptException$("Missing argument $lightness.", null));
            },
            $signature: 19
        };
        A.global_closure18.prototype = {
            call$1: function($arguments) {
                return A._parseChannels("hsl", J.$index$asx($arguments, 0), "channels", B.HslColorSpace_JQ2);
            },
            $signature: 5
        };
        A.global_closure19.prototype = {
            call$1: function($arguments) {
                return A._hsl("hsla", $arguments);
            },
            $signature: 5
        };
        A.global_closure20.prototype = {
            call$1: function($arguments) {
                return A._hsl("hsla", $arguments);
            },
            $signature: 5
        };
        A.global_closure21.prototype = {
            call$1: function($arguments) {
                var t1 = J.getInterceptor$asx($arguments);
                if (t1.$index($arguments, 0).get$isSpecialVariable() || t1.$index($arguments, 1).get$isSpecialVariable()) return A._functionString("hsla", $arguments);
                else throw A.wrapException(A.SassScriptException$("Missing argument $lightness.", null));
            },
            $signature: 19
        };
        A.global_closure22.prototype = {
            call$1: function($arguments) {
                return A._parseChannels("hsla", J.$index$asx($arguments, 0), "channels", B.HslColorSpace_JQ2);
            },
            $signature: 5
        };
        A.global_closure23.prototype = {
            call$1: function($arguments) {
                var t1 = J.getInterceptor$asx($arguments);
                if (t1.$index($arguments, 0) instanceof A.SassNumber || t1.$index($arguments, 0).get$isSpecialNumber()) return A._functionString("grayscale", $arguments);
                else {
                    A.warnForDeprecation(string$.Globalcg, B.Deprecation_WW3);
                    return A._grayscale(t1.$index($arguments, 0));
                }
            },
            $signature: 5
        };
        A.global_closure24.prototype = {
            call$1: function($arguments) {
                var t1 = J.getInterceptor$asx($arguments), color = t1.$index($arguments, 0).assertColor$1("color"), degrees = A._angleValue(t1.$index($arguments, 1), "degrees");
                if (!color._space.get$isLegacyInternal()) throw A.wrapException(A.SassScriptException$(string$.adjusto, null));
                A.warnForDeprecation(string$.adjustd + A.serializeValue(A.SassNumber_SassNumber(degrees, "deg"), false, true) + string$.x29x0a_Mor_, B.Deprecation_zUK);
                return color.changeHsl$1$hue(color._legacyChannel$2(B.HslColorSpace_JQ2, "hue") + degrees);
            },
            $signature: 23
        };
        A.global_closure25.prototype = {
            call$1: function($arguments) {
                var result, _s9_ = "lightness", t1 = J.getInterceptor$asx($arguments), color = t1.$index($arguments, 0).assertColor$1("color"), amount = t1.$index($arguments, 1).assertNumber$1("amount");
                if (!color._space.get$isLegacyInternal()) throw A.wrapException(A.SassScriptException$(string$.lighte, null));
                t1 = color._legacyChannel$2(B.HslColorSpace_JQ2, _s9_) + amount.valueInRange$3(0, 100, "amount");
                result = color.changeHsl$1$lightness(isNaN(t1) ? 0 : B.JSNumber_methods.clamp$2(t1, 0, 100));
                A.warnForDeprecation("lighten() is deprecated. " + A._suggestScaleAndAdjust(color, amount._number$_value, _s9_) + string$.x0a_Morex3ac, B.Deprecation_zUK);
                return result;
            },
            $signature: 23
        };
        A.global_closure26.prototype = {
            call$1: function($arguments) {
                var result, _s9_ = "lightness", t1 = J.getInterceptor$asx($arguments), color = t1.$index($arguments, 0).assertColor$1("color"), amount = t1.$index($arguments, 1).assertNumber$1("amount");
                if (!color._space.get$isLegacyInternal()) throw A.wrapException(A.SassScriptException$(string$.darken, null));
                t1 = color._legacyChannel$2(B.HslColorSpace_JQ2, _s9_) - amount.valueInRange$3(0, 100, "amount");
                result = color.changeHsl$1$lightness(isNaN(t1) ? 0 : B.JSNumber_methods.clamp$2(t1, 0, 100));
                A.warnForDeprecation("darken() is deprecated. " + A._suggestScaleAndAdjust(color, -amount._number$_value, _s9_) + string$.x0a_Morex3ac, B.Deprecation_zUK);
                return result;
            },
            $signature: 23
        };
        A.global_closure27.prototype = {
            call$1: function($arguments) {
                var t1 = J.getInterceptor$asx($arguments);
                if (t1.$index($arguments, 0) instanceof A.SassNumber || t1.$index($arguments, 0).get$isSpecialNumber()) return A._functionString("saturate", $arguments);
                return new A.SassString("saturate(" + A.serializeValue(t1.$index($arguments, 0).assertNumber$1("amount"), false, true) + ")", false);
            },
            $signature: 19
        };
        A.global_closure28.prototype = {
            call$1: function($arguments) {
                var t1, color, amount, result, _s10_ = "saturation";
                A.warnForDeprecation(string$.Globalcad, B.Deprecation_WW3);
                t1 = J.getInterceptor$asx($arguments);
                color = t1.$index($arguments, 0).assertColor$1("color");
                amount = t1.$index($arguments, 1).assertNumber$1("amount");
                if (!color._space.get$isLegacyInternal()) throw A.wrapException(A.SassScriptException$(string$.satura, null));
                t1 = color._legacyChannel$2(B.HslColorSpace_JQ2, _s10_) + amount.valueInRange$3(0, 100, "amount");
                result = color.changeHsl$1$saturation(isNaN(t1) ? 0 : B.JSNumber_methods.clamp$2(t1, 0, 100));
                A.warnForDeprecation("saturate() is deprecated. " + A._suggestScaleAndAdjust(color, amount._number$_value, _s10_) + string$.x0a_Morex3ac, B.Deprecation_zUK);
                return result;
            },
            $signature: 23
        };
        A.global_closure29.prototype = {
            call$1: function($arguments) {
                var result, _s10_ = "saturation", t1 = J.getInterceptor$asx($arguments), color = t1.$index($arguments, 0).assertColor$1("color"), amount = t1.$index($arguments, 1).assertNumber$1("amount");
                if (!color._space.get$isLegacyInternal()) throw A.wrapException(A.SassScriptException$(string$.desatu, null));
                t1 = color._legacyChannel$2(B.HslColorSpace_JQ2, _s10_) - amount.valueInRange$3(0, 100, "amount");
                result = color.changeHsl$1$saturation(isNaN(t1) ? 0 : B.JSNumber_methods.clamp$2(t1, 0, 100));
                A.warnForDeprecation("desaturate() is deprecated. " + A._suggestScaleAndAdjust(color, -amount._number$_value, _s10_) + string$.x0a_Morex3ac, B.Deprecation_zUK);
                return result;
            },
            $signature: 23
        };
        A.global_closure30.prototype = {
            call$1: function($arguments) {
                return A._opacify("opacify", $arguments);
            },
            $signature: 23
        };
        A.global_closure31.prototype = {
            call$1: function($arguments) {
                return A._opacify("fade-in", $arguments);
            },
            $signature: 23
        };
        A.global_closure32.prototype = {
            call$1: function($arguments) {
                return A._transparentize("transparentize", $arguments);
            },
            $signature: 23
        };
        A.global_closure33.prototype = {
            call$1: function($arguments) {
                return A._transparentize("fade-out", $arguments);
            },
            $signature: 23
        };
        A.global_closure34.prototype = {
            call$1: function($arguments) {
                var _0_0 = J.$index$asx($arguments, 0), t1 = false;
                if (_0_0 instanceof A.SassString) {
                    if (!_0_0._hasQuotes) t1 = B.JSString_methods.contains$1(_0_0._string$_text, $.$get$_microsoftFilterStart());
                }
                if (t1) return A._functionString("alpha", $arguments);
                if (_0_0 instanceof A.SassColor && !_0_0._space.get$isLegacyInternal()) throw A.wrapException(A.SassScriptException$(string$.alpha_, null));
                A.warnForDeprecation(string$.Globalcal, B.Deprecation_WW3);
                t1 = _0_0.assertColor$1("color").alphaOrNull;
                return A.SassNumber_SassNumber(t1 == null ? 0 : t1, null);
            },
            $signature: 5
        };
        A.global_closure35.prototype = {
            call$1: function($arguments) {
                var t1, argList = J.$index$asx($arguments, 0).get$asList();
                if (argList.length !== 0 && B.JSArray_methods.every$1(argList, new A.global__closure())) return A._functionString("alpha", $arguments);
                t1 = argList.length;
                if (t1 === 0) throw A.wrapException(A.SassScriptException$("Missing argument $color.", null));
                else throw A.wrapException(A.SassScriptException$("Only 1 argument allowed, but " + t1 + " were passed.", null));
            },
            $signature: 19
        };
        A.global__closure.prototype = {
            call$1: function(argument) {
                return argument instanceof A.SassString && !argument._hasQuotes && B.JSString_methods.contains$1(argument._string$_text, $.$get$_microsoftFilterStart());
            },
            $signature: 79
        };
        A.global_closure36.prototype = {
            call$1: function($arguments) {
                var t1 = J.getInterceptor$asx($arguments);
                if (t1.$index($arguments, 0) instanceof A.SassNumber || t1.$index($arguments, 0).get$isSpecialNumber()) return A._functionString("opacity", $arguments);
                A.warnForDeprecation(string$.Globalco, B.Deprecation_WW3);
                t1 = t1.$index($arguments, 0).assertColor$1("color").alphaOrNull;
                return A.SassNumber_SassNumber(t1 == null ? 0 : t1, null);
            },
            $signature: 5
        };
        A.global_closure37.prototype = {
            call$1: function($arguments) {
                return A._parseChannels("color", J.$index$asx($arguments, 0), "description", null);
            },
            $signature: 5
        };
        A.global_closure38.prototype = {
            call$1: function($arguments) {
                return A._parseChannels("hwb", J.$index$asx($arguments, 0), "channels", B.HwbColorSpace_guQ);
            },
            $signature: 5
        };
        A.global_closure39.prototype = {
            call$1: function($arguments) {
                return A._parseChannels("lab", J.$index$asx($arguments, 0), "channels", B.LabColorSpace_2nT);
            },
            $signature: 5
        };
        A.global_closure40.prototype = {
            call$1: function($arguments) {
                return A._parseChannels("lch", J.$index$asx($arguments, 0), "channels", B.LchColorSpace_Bpv);
            },
            $signature: 5
        };
        A.global_closure41.prototype = {
            call$1: function($arguments) {
                return A._parseChannels("oklab", J.$index$asx($arguments, 0), "channels", B.OklabColorSpace_540);
            },
            $signature: 5
        };
        A.global_closure42.prototype = {
            call$1: function($arguments) {
                return A._parseChannels("oklch", J.$index$asx($arguments, 0), "channels", B.OklchColorSpace_9Gj);
            },
            $signature: 5
        };
        A.module_closure1.prototype = {
            call$1: function(color) {
                return B.JSNumber_methods.round$0(color._legacyChannel$2(B.RgbColorSpace_i0P, "red"));
            },
            $signature: 66
        };
        A.module_closure2.prototype = {
            call$1: function(color) {
                return B.JSNumber_methods.round$0(color._legacyChannel$2(B.RgbColorSpace_i0P, "green"));
            },
            $signature: 66
        };
        A.module_closure3.prototype = {
            call$1: function(color) {
                return B.JSNumber_methods.round$0(color._legacyChannel$2(B.RgbColorSpace_i0P, "blue"));
            },
            $signature: 66
        };
        A.module_closure4.prototype = {
            call$1: function($arguments) {
                var result = A._invert($arguments, false);
                if (result instanceof A.SassString) A.warnForDeprecation("Passing a number (" + J.$index$asx($arguments, 0).toString$0(0) + string$.x29x20to_cli + result.toString$0(0), B.Deprecation_7Bn);
                return result;
            },
            $signature: 5
        };
        A.module_closure5.prototype = {
            call$1: function(color) {
                return color._legacyChannel$2(B.HslColorSpace_JQ2, "hue");
            },
            $signature: 45
        };
        A.module_closure6.prototype = {
            call$1: function(color) {
                return color._legacyChannel$2(B.HslColorSpace_JQ2, "saturation");
            },
            $signature: 45
        };
        A.module_closure7.prototype = {
            call$1: function(color) {
                return color._legacyChannel$2(B.HslColorSpace_JQ2, "lightness");
            },
            $signature: 45
        };
        A.module_closure8.prototype = {
            call$1: function($arguments) {
                var result, t1 = J.getInterceptor$asx($arguments);
                if (t1.$index($arguments, 0) instanceof A.SassNumber) {
                    result = A._functionString("grayscale", t1.take$1($arguments, 1));
                    A.warnForDeprecation("Passing a number (" + t1.$index($arguments, 0).toString$0(0) + string$.x29x20to_clg + result.toString$0(0), B.Deprecation_7Bn);
                    return result;
                }
                return A._grayscale(t1.$index($arguments, 0));
            },
            $signature: 5
        };
        A.module_closure9.prototype = {
            call$1: function($arguments) {
                var t1 = J.getInterceptor$asx($arguments), t2 = type$.JSArray_Value;
                return A._parseChannels("hwb", A.SassList$(A._setArrayType([
                    A.SassList$(A._setArrayType([
                        t1.$index($arguments, 0),
                        t1.$index($arguments, 1),
                        t1.$index($arguments, 2)
                    ], t2), B.ListSeparator_SrV, false),
                    t1.$index($arguments, 3)
                ], t2), B.ListSeparator_Lul, false), null, B.HwbColorSpace_guQ);
            },
            $signature: 5
        };
        A.module_closure10.prototype = {
            call$1: function($arguments) {
                return A._parseChannels("hwb", J.$index$asx($arguments, 0), "channels", B.HwbColorSpace_guQ);
            },
            $signature: 5
        };
        A.module_closure11.prototype = {
            call$1: function(color) {
                return color._legacyChannel$2(B.HwbColorSpace_guQ, "whiteness");
            },
            $signature: 45
        };
        A.module_closure12.prototype = {
            call$1: function(color) {
                return color._legacyChannel$2(B.HwbColorSpace_guQ, "blackness");
            },
            $signature: 45
        };
        A.module_closure13.prototype = {
            call$1: function($arguments) {
                var result, _0_0 = J.$index$asx($arguments, 0), t1 = false;
                if (_0_0 instanceof A.SassString) {
                    if (!_0_0._hasQuotes) t1 = B.JSString_methods.contains$1(_0_0._string$_text, $.$get$_microsoftFilterStart());
                }
                if (t1) {
                    result = A._functionString("alpha", $arguments);
                    A.warnForDeprecation(string$.Using_c + result.toString$0(0), B.Deprecation_7Bn);
                    return result;
                }
                if (_0_0 instanceof A.SassColor && !_0_0._space.get$isLegacyInternal()) throw A.wrapException(A.SassScriptException$(string$.color_a, null));
                t1 = _0_0.assertColor$1("color").alphaOrNull;
                return A.SassNumber_SassNumber(t1 == null ? 0 : t1, null);
            },
            $signature: 5
        };
        A.module_closure14.prototype = {
            call$1: function($arguments) {
                var result, t1 = J.getInterceptor$asx($arguments);
                if (B.JSArray_methods.every$1(t1.$index($arguments, 0).get$asList(), new A.module__closure2())) {
                    result = A._functionString("alpha", $arguments);
                    A.warnForDeprecation(string$.Using_c + result.toString$0(0), B.Deprecation_7Bn);
                    return result;
                }
                throw A.wrapException(A.SassScriptException$("Only 1 argument allowed, but " + t1.get$length($arguments) + " were passed.", null));
            },
            $signature: 19
        };
        A.module__closure2.prototype = {
            call$1: function(argument) {
                return argument instanceof A.SassString && !argument._hasQuotes && B.JSString_methods.contains$1(argument._string$_text, $.$get$_microsoftFilterStart());
            },
            $signature: 79
        };
        A.module_closure15.prototype = {
            call$1: function($arguments) {
                var result, t1 = J.getInterceptor$asx($arguments);
                if (t1.$index($arguments, 0) instanceof A.SassNumber) {
                    result = A._functionString("opacity", $arguments);
                    A.warnForDeprecation("Passing a number (" + t1.$index($arguments, 0).toString$0(0) + string$.x20to_co + result.toString$0(0), B.Deprecation_7Bn);
                    return result;
                }
                t1 = t1.$index($arguments, 0).assertColor$1("color").alphaOrNull;
                return A.SassNumber_SassNumber(t1 == null ? 0 : t1, null);
            },
            $signature: 5
        };
        A.module_closure16.prototype = {
            call$1: function($arguments) {
                return new A.SassString(J.get$first$ax($arguments).assertColor$1("color")._space.name, false);
            },
            $signature: 19
        };
        A.module_closure17.prototype = {
            call$1: function($arguments) {
                var t1 = J.getInterceptor$asx($arguments);
                return A._colorInSpace(t1.$index($arguments, 0), t1.$index($arguments, 1), false);
            },
            $signature: 23
        };
        A.module_closure18.prototype = {
            call$1: function($arguments) {
                return J.$index$asx($arguments, 0).assertColor$1("color")._space.get$isLegacyInternal() ? B.SassBoolean_true : B.SassBoolean_false;
            },
            $signature: 11
        };
        A.module_closure19.prototype = {
            call$1: function($arguments) {
                var t1 = J.getInterceptor$asx($arguments);
                return t1.$index($arguments, 0).assertColor$1("color").isChannelMissing$3$channelName$colorName(A._channelName(t1.$index($arguments, 1)), "channel", "color") ? B.SassBoolean_true : B.SassBoolean_false;
            },
            $signature: 11
        };
        A.module_closure20.prototype = {
            call$1: function($arguments) {
                var t1 = J.getInterceptor$asx($arguments);
                return A._colorInSpace(t1.$index($arguments, 0), t1.$index($arguments, 1), true).get$isInGamut() ? B.SassBoolean_true : B.SassBoolean_false;
            },
            $signature: 11
        };
        A.module_closure21.prototype = {
            call$1: function($arguments) {
                var space, method, _s5_ = "space", _s6_ = "method", t1 = J.getInterceptor$asx($arguments), color = t1.$index($arguments, 0).assertColor$1("color"), t2 = t1.$index($arguments, 1);
                if (t2.$eq(0, B.C__SassNull)) space = color._space;
                else {
                    t2 = t2.assertString$1(_s5_);
                    t2.assertUnquoted$1(_s5_);
                    space = A.ColorSpace_fromName(t2._string$_text, _s5_);
                }
                if (t1.$index($arguments, 2).$eq(0, B.C__SassNull)) throw A.wrapException(A.SassScriptException$(string$.color_t, _s6_));
                t1 = t1.$index($arguments, 2).assertString$1(_s6_);
                t1.assertUnquoted$1(_s6_);
                method = A.GamutMapMethod_GamutMapMethod$fromName(t1._string$_text);
                if (!space.get$isBoundedInternal()) return color;
                t1 = color.toSpace$1(space);
                t1 = t1.get$isInGamut() ? t1 : method.map$1(0, t1);
                return t1.toSpace$2$legacyMissing(color._space, false);
            },
            $signature: 23
        };
        A.module_closure22.prototype = {
            call$1: function($arguments) {
                var channelIndex, channelInfo, channelValue, unit, t1 = J.getInterceptor$asx($arguments), color = A._colorInSpace(t1.$index($arguments, 0), t1.$index($arguments, 2), true), channelName = A._channelName(t1.$index($arguments, 1));
                if (channelName === "alpha") {
                    t1 = color.alphaOrNull;
                    return A.SassNumber_SassNumber(t1 == null ? 0 : t1, null);
                }
                t1 = color._space._channels;
                channelIndex = B.JSArray_methods.indexWhere$1(t1, new A.module__closure1(channelName));
                if (channelIndex === -1) throw A.wrapException(A.SassScriptException$("Color " + color.toString$0(0) + " has no channel named " + channelName + ".", "channel"));
                channelInfo = t1[channelIndex];
                channelValue = color.get$channels()[channelIndex];
                unit = channelInfo.associatedUnit;
                return A.SassNumber_SassNumber(unit === "%" ? channelValue * 100 / type$.LinearChannel._as(channelInfo).max : channelValue, unit);
            },
            $signature: 24
        };
        A.module__closure1.prototype = {
            call$1: function(channel) {
                return channel.name === this.channelName;
            },
            $signature: 93
        };
        A.module_closure23.prototype = {
            call$1: function($arguments) {
                var t2, t3, t1 = J.getInterceptor$asx($arguments), color1 = t1.$index($arguments, 0).assertColor$1("color1"), color2 = t1.$index($arguments, 1).assertColor$1("color2");
                t1 = new A.module_closure_toXyzNoMissing();
                if (color1._space === color2._space) {
                    t1 = color1.channel0OrNull;
                    t2 = false;
                    if (t1 == null) t1 = 0;
                    t3 = color2.channel0OrNull;
                    if (A.fuzzyEquals(t1, t3 == null ? 0 : t3)) {
                        t1 = color1.channel1OrNull;
                        if (t1 == null) t1 = 0;
                        t3 = color2.channel1OrNull;
                        if (A.fuzzyEquals(t1, t3 == null ? 0 : t3)) {
                            t1 = color1.channel2OrNull;
                            if (t1 == null) t1 = 0;
                            t3 = color2.channel2OrNull;
                            if (A.fuzzyEquals(t1, t3 == null ? 0 : t3)) {
                                t1 = color1.alphaOrNull;
                                if (t1 == null) t1 = 0;
                                t2 = color2.alphaOrNull;
                                t1 = A.fuzzyEquals(t1, t2 == null ? 0 : t2);
                            } else t1 = t2;
                        } else t1 = t2;
                    } else t1 = t2;
                } else t1 = J.$eq$(t1.call$1(color1), t1.call$1(color2));
                return t1 ? B.SassBoolean_true : B.SassBoolean_false;
            },
            $signature: 11
        };
        A.module_closure_toXyzNoMissing.prototype = {
            call$1: function(color) {
                var _1_1, _1_3, t1, _1_7, channel0, _1_8, channel1, _1_9, channel2, _1_10, alpha, _null = null;
                $label0$0: {
                    _1_1 = color._space;
                    _1_3 = B.XyzD65ColorSpace_WiJ === _1_1;
                    t1 = _1_3;
                    if (t1) t1 = !(color.channel0OrNull == null || color.channel1OrNull == null || color.channel2OrNull == null || color.alphaOrNull == null);
                    else t1 = false;
                    if (t1) {
                        t1 = color;
                        break $label0$0;
                    }
                    if (_1_3) {
                        _1_7 = color.channel0OrNull;
                        if (_1_7 == null) _1_7 = 0;
                        channel0 = _1_7;
                        _1_8 = color.channel1OrNull;
                        if (_1_8 == null) _1_8 = 0;
                        channel1 = _1_8;
                        _1_9 = color.channel2OrNull;
                        if (_1_9 == null) _1_9 = 0;
                        channel2 = _1_9;
                        _1_10 = color.alphaOrNull;
                        if (_1_10 == null) _1_10 = 0;
                        alpha = _1_10;
                        t1 = A.SassColor$_forSpace(B.XyzD65ColorSpace_WiJ, channel0, channel1, channel2, alpha, _null);
                        break $label0$0;
                    }
                    _1_7 = color.channel0OrNull;
                    if (_1_7 == null) _1_7 = 0;
                    channel0 = _1_7;
                    _1_8 = color.channel1OrNull;
                    if (_1_8 == null) _1_8 = 0;
                    channel1 = _1_8;
                    _1_9 = color.channel2OrNull;
                    if (_1_9 == null) _1_9 = 0;
                    channel2 = _1_9;
                    _1_10 = color.alphaOrNull;
                    if (_1_10 == null) _1_10 = 0;
                    alpha = _1_10;
                    t1 = _1_1.convert$5(B.XyzD65ColorSpace_WiJ, channel0, channel1, channel2, alpha);
                    break $label0$0;
                }
                return t1;
            },
            $signature: 421
        };
        A.module_closure24.prototype = {
            call$1: function($arguments) {
                var t1 = J.getInterceptor$asx($arguments);
                return A._colorInSpace(t1.$index($arguments, 0), t1.$index($arguments, 2), true).isChannelPowerless$3$channelName$colorName(A._channelName(t1.$index($arguments, 1)), "channel", "color") ? B.SassBoolean_true : B.SassBoolean_false;
            },
            $signature: 11
        };
        A._mix_closure.prototype = {
            call$1: function($arguments) {
                var _s6_ = "weight", _s41_ = string$.To_usem, _s29_ = ", you must provide a $method.", t1 = J.getInterceptor$asx($arguments), color1 = t1.$index($arguments, 0).assertColor$1("color1"), color2 = t1.$index($arguments, 1).assertColor$1("color2"), weight = t1.$index($arguments, 2).assertNumber$1(_s6_);
                if (!t1.$index($arguments, 3).$eq(0, B.C__SassNull)) return color1.interpolate$4$legacyMissing$weight(color2, A.InterpolationMethod_InterpolationMethod$fromValue(t1.$index($arguments, 3), "method"), false, weight.valueInRangeWithUnit$4(0, 100, _s6_, "%") / 100);
                A._checkPercent(weight, _s6_);
                if (!color1._space.get$isLegacyInternal()) throw A.wrapException(A.SassScriptException$(_s41_ + color1.toString$0(0) + _s29_, "color1"));
                else if (!color2._space.get$isLegacyInternal()) throw A.wrapException(A.SassScriptException$(_s41_ + color2.toString$0(0) + _s29_, "color2"));
                return A._mixLegacy(color1, color2, weight);
            },
            $signature: 23
        };
        A._complement_closure.prototype = {
            call$1: function($arguments) {
                var space, t3, colorInSpace, t4, t5, t6, _s5_ = "space", t1 = J.getInterceptor$asx($arguments), color = t1.$index($arguments, 0).assertColor$1("color"), t2 = color._space;
                if (t2.get$isLegacyInternal() && t1.$index($arguments, 1).$eq(0, B.C__SassNull)) space = B.HslColorSpace_JQ2;
                else {
                    t3 = t1.$index($arguments, 1).assertString$1(_s5_);
                    t3.assertUnquoted$1(_s5_);
                    space = A.ColorSpace_fromName(t3._string$_text, _s5_);
                }
                if (!space.get$isPolarInternal()) throw A.wrapException(A.SassScriptException$("Color space " + space.toString$0(0) + " doesn't have a hue channel.", _s5_));
                colorInSpace = color.toSpace$2$legacyMissing(space, !t1.$index($arguments, 1).$eq(0, B.C__SassNull));
                t1 = space._channels;
                t3 = colorInSpace.channel0OrNull;
                t4 = colorInSpace.channel1OrNull;
                t5 = colorInSpace.channel2OrNull;
                t6 = colorInSpace.alphaOrNull;
                return (space.get$isLegacyInternal() ? A.SassColor_SassColor$forSpaceInternal(space, A._adjustChannel(colorInSpace, t1[0], t3, A.SassNumber_SassNumber(180, null)), t4, t5, t6) : A.SassColor_SassColor$forSpaceInternal(space, t3, t4, A._adjustChannel(colorInSpace, t1[2], t5, A.SassNumber_SassNumber(180, null)), t6)).toSpace$2$legacyMissing(t2, false);
            },
            $signature: 23
        };
        A._adjust_closure.prototype = {
            call$1: function($arguments) {
                return A._updateComponents($arguments, true, false, false);
            },
            $signature: 23
        };
        A._scale_closure.prototype = {
            call$1: function($arguments) {
                return A._updateComponents($arguments, false, false, true);
            },
            $signature: 23
        };
        A._change_closure.prototype = {
            call$1: function($arguments) {
                return A._updateComponents($arguments, false, true, false);
            },
            $signature: 23
        };
        A._ieHexStr_closure.prototype = {
            call$1: function($arguments) {
                var t1, t2, t3, t4, t5, color = J.$index$asx($arguments, 0).assertColor$1("color").toSpace$1(B.RgbColorSpace_i0P);
                color = color.get$isInGamut() ? color : B.LocalMindeGamutMap_A2x.map$1(0, color);
                t1 = new A._ieHexStr_closure_hexString();
                t2 = color.alphaOrNull;
                t2 = A.S(t1.call$1((t2 == null ? 0 : t2) * 255));
                t3 = color.channel0OrNull;
                t3 = A.S(t1.call$1(t3 == null ? 0 : t3));
                t4 = color.channel1OrNull;
                t4 = A.S(t1.call$1(t4 == null ? 0 : t4));
                t5 = color.channel2OrNull;
                return new A.SassString("#" + t2 + t3 + t4 + A.S(t1.call$1(t5 == null ? 0 : t5)), false);
            },
            $signature: 19
        };
        A._ieHexStr_closure_hexString.prototype = {
            call$1: function(component) {
                return B.JSString_methods.padLeft$2(B.JSInt_methods.toRadixString$1(A.fuzzyRound(component), 16), 2, "0").toUpperCase();
            },
            $signature: 275
        };
        A._updateComponents_closure.prototype = {
            call$1: function(space) {
                return this.originalColor.toSpace$2$legacyMissing(space, false);
            },
            $signature: 428
        };
        A._updateComponents_closure0.prototype = {
            call$1: function(info) {
                return this._box_0.name === info.name;
            },
            $signature: 93
        };
        A._changeColor_closure.prototype = {
            call$0: function() {
                var t1 = this.alphaArg;
                A.warnForDeprecation("$alpha: Passing a unit other than % (" + t1.toString$0(0) + string$.x29x20is_d_ + t1.unitSuggestion$1("alpha") + string$.x0a_See_, B.Deprecation_7TE);
                return t1.valueInRange$3(0, 1, "alpha");
            },
            $signature: 240
        };
        A._adjustColor_closure.prototype = {
            call$1: function(alpha) {
                return isNaN(alpha) ? 0 : B.JSNumber_methods.clamp$2(alpha, 0, 1);
            },
            $signature: 12
        };
        A._functionString_closure.prototype = {
            call$1: function(argument) {
                return A.serializeValue(argument, false, true);
            },
            $signature: 458
        };
        A._removedColorFunction_closure.prototype = {
            call$1: function($arguments) {
                var t1 = this.name, t2 = J.getInterceptor$asx($arguments), t3 = t2.$index($arguments, 0).toString$0(0), t4 = this.negative ? "-" : "";
                throw A.wrapException(A.SassScriptException$("The function " + t1 + string$.x28__isn + t3 + ", $" + this.argument + ": " + t4 + t2.$index($arguments, 1).toString$0(0) + string$.x29x0a_Moro + t1, null));
            },
            $signature: 463
        };
        A._rgb_closure.prototype = {
            call$1: function(alpha) {
                var t1 = A._percentageOrUnitless(alpha.assertNumber$1("alpha"), 1, "alpha");
                return isNaN(t1) ? 0 : B.JSNumber_methods.clamp$2(t1, 0, 1);
            },
            $signature: 245
        };
        A._hsl_closure.prototype = {
            call$1: function(alpha) {
                var t1 = A._percentageOrUnitless(alpha.assertNumber$1("alpha"), 1, "alpha");
                return isNaN(t1) ? 0 : B.JSNumber_methods.clamp$2(t1, 0, 1);
            },
            $signature: 245
        };
        A._parseChannels_closure.prototype = {
            call$1: function($name) {
                return $name + " channel";
            },
            $signature: 6
        };
        A._parseChannels_closure0.prototype = {
            call$1: function(channel) {
                return channel.get$isSpecialNumber();
            },
            $signature: 79
        };
        A._colorFromChannels_closure.prototype = {
            call$1: function(channel0) {
                return A._angleValue(channel0, "hue");
            },
            $signature: 129
        };
        A._colorFromChannels_closure0.prototype = {
            call$1: function(channel0) {
                return A._angleValue(channel0, "hue");
            },
            $signature: 129
        };
        A._channelFromValue_closure.prototype = {
            call$1: function(value) {
                var t1, _0_8, t2, _0_5, _0_8_isSet, upperClamped, t3, _0_0 = this.channel;
                $label0$0: {
                    t1 = _0_0 instanceof A.LinearChannel;
                    if (t1 && _0_0.requiresPercent && !value.hasUnit$1("%")) A.throwExpression(A.SassScriptException$("Expected " + value.toString$0(0) + ' to have unit "%".', _0_0.name));
                    _0_8 = null;
                    t2 = false;
                    if (t1) {
                        _0_5 = _0_0.lowerClamped;
                        _0_8_isSet = !_0_5;
                        if (_0_8_isSet) {
                            _0_8 = _0_0.upperClamped;
                            t2 = !_0_8;
                        }
                    } else {
                        _0_5 = null;
                        _0_8_isSet = false;
                    }
                    if (t2) {
                        t1 = A._percentageOrUnitless(value, _0_0.max, _0_0.name);
                        break $label0$0;
                    }
                    if (t1 && !this.clamp) {
                        t1 = A._percentageOrUnitless(value, _0_0.max, _0_0.name);
                        break $label0$0;
                    }
                    if (t1) {
                        upperClamped = _0_8_isSet ? _0_8 : _0_0.upperClamped;
                        t1 = _0_0.max;
                        t2 = A._percentageOrUnitless(value, t1, _0_0.name);
                        t3 = _0_5 ? _0_0.min : -1 / 0;
                        t1 = upperClamped ? t1 : 1 / 0;
                        t1 = isNaN(t2) ? t3 : B.JSNumber_methods.clamp$2(t2, t3, t1);
                        break $label0$0;
                    }
                    t1 = B.JSNumber_methods.$mod(value.coerceValueToUnit$2("deg", _0_0.name), 360);
                    break $label0$0;
                }
                return t1;
            },
            $signature: 129
        };
        A._channelFunction_closure.prototype = {
            call$1: function($arguments) {
                var _this = this, result = A.SassNumber_SassNumber(_this.getter.call$1(J.get$first$ax($arguments).assertColor$1("color")), _this.unit), t1 = _this.global ? "" : "color.", t2 = _this.name;
                A.warnForDeprecation(t1 + t2 + string$.x28__is_d + t2 + '", $space: ' + _this.space.toString$0(0) + string$.x29x0a_Mor_, B.Deprecation_zUK);
                return result;
            },
            $signature: 24
        };
        A._suggestScaleAndAdjust_closure.prototype = {
            call$1: function(channel) {
                return channel.name === this.channelName;
            },
            $signature: 93
        };
        A._length_closure0.prototype = {
            call$1: function($arguments) {
                return A.SassNumber_SassNumber(J.$index$asx($arguments, 0).get$asList().length, null);
            },
            $signature: 24
        };
        A._nth_closure.prototype = {
            call$1: function($arguments) {
                var t1 = J.getInterceptor$asx($arguments), list = t1.$index($arguments, 0), index = t1.$index($arguments, 1);
                return list.get$asList()[list.sassIndexToListIndex$2(index, "n")];
            },
            $signature: 5
        };
        A._setNth_closure.prototype = {
            call$1: function($arguments) {
                var newList, t1 = J.getInterceptor$asx($arguments), list = t1.$index($arguments, 0), index = t1.$index($arguments, 1), value = t1.$index($arguments, 2);
                t1 = list.get$asList();
                newList = A._setArrayType(t1.slice(0), A._arrayInstanceType(t1));
                newList[list.sassIndexToListIndex$2(index, "n")] = value;
                return list.withListContents$1(newList);
            },
            $signature: 28
        };
        A._join_closure.prototype = {
            call$1: function($arguments) {
                var _0_1, _0_4, _0_3, t2, _0_40, _0_4_isSet, separator, bracketed, _null = null, t1 = J.getInterceptor$asx($arguments), list1 = t1.$index($arguments, 0), list2 = t1.$index($arguments, 1), separatorParam = t1.$index($arguments, 2).assertString$1("separator"), bracketedParam = t1.$index($arguments, 3), _1_0 = separatorParam._string$_text;
                $label1$1: {
                    if ("auto" === _1_0) {
                        _0_1 = list1.get$separator(list1);
                        _0_4 = list2.get$separator(list2);
                        $label0$0: {
                            t1 = _null;
                            _0_3 = B.ListSeparator_undecided_null_3_undecided === _0_1;
                            t2 = _0_3;
                            if (t2) {
                                t2 = B.ListSeparator_undecided_null_3_undecided === _0_4;
                                _0_40 = _0_4;
                                _0_4_isSet = true;
                            } else {
                                _0_40 = _null;
                                _0_4_isSet = false;
                                t2 = false;
                            }
                            if (t2) {
                                t1 = B.ListSeparator_SrV;
                                break $label0$0;
                            }
                            if (_0_3) {
                                separator = _0_4_isSet ? _0_40 : _0_4;
                                t2 = true;
                            } else {
                                separator = t1;
                                t2 = false;
                            }
                            if (!t2) separator = _0_1;
                            t1 = separator;
                            break $label0$0;
                        }
                        break $label1$1;
                    }
                    if ("space" === _1_0) {
                        t1 = B.ListSeparator_SrV;
                        break $label1$1;
                    }
                    if ("comma" === _1_0) {
                        t1 = B.ListSeparator_z0K;
                        break $label1$1;
                    }
                    if ("slash" === _1_0) {
                        t1 = B.ListSeparator_Lul;
                        break $label1$1;
                    }
                    t1 = A.throwExpression(A.SassScriptException$(string$.x24separ, _null));
                }
                bracketed = bracketedParam instanceof A.SassString && bracketedParam._string$_text === "auto" ? list1.get$hasBrackets() : bracketedParam.get$isTruthy();
                t2 = A.List_List$_of(list1.get$asList(), type$.Value);
                B.JSArray_methods.addAll$1(t2, list2.get$asList());
                return A.SassList$(t2, t1, bracketed);
            },
            $signature: 28
        };
        A._append_closure0.prototype = {
            call$1: function($arguments) {
                var t2, t1 = J.getInterceptor$asx($arguments), list = t1.$index($arguments, 0), value = t1.$index($arguments, 1), _0_0 = t1.$index($arguments, 2).assertString$1("separator")._string$_text;
                $label0$0: {
                    if ("auto" === _0_0) {
                        t1 = list.get$separator(list) === B.ListSeparator_undecided_null_3_undecided ? B.ListSeparator_SrV : list.get$separator(list);
                        break $label0$0;
                    }
                    if ("space" === _0_0) {
                        t1 = B.ListSeparator_SrV;
                        break $label0$0;
                    }
                    if ("comma" === _0_0) {
                        t1 = B.ListSeparator_z0K;
                        break $label0$0;
                    }
                    if ("slash" === _0_0) {
                        t1 = B.ListSeparator_Lul;
                        break $label0$0;
                    }
                    t1 = A.throwExpression(A.SassScriptException$(string$.x24separ, null));
                }
                t2 = A.List_List$_of(list.get$asList(), type$.Value);
                t2.push(value);
                return list.withListContents$2$separator(t2, t1);
            },
            $signature: 28
        };
        A._zip_closure.prototype = {
            call$1: function($arguments) {
                var results, result, _box_0 = {}, t1 = J.$index$asx($arguments, 0).get$asList(), t2 = A._arrayInstanceType(t1)._eval$1("MappedListIterable<1,List<Value>>"), lists = A.List_List$_of(new A.MappedListIterable(t1, new A._zip__closure(), t2), t2._eval$1("ListIterable.E"));
                if (lists.length === 0) return B.SassList_oH0;
                _box_0.i = 0;
                results = A._setArrayType([], type$.JSArray_SassList);
                for(t1 = A._arrayInstanceType(lists)._eval$1("MappedListIterable<1,Value>"), t2 = type$.Value; B.JSArray_methods.every$1(lists, new A._zip__closure0(_box_0));){
                    result = A.List_List$from(new A.MappedListIterable(lists, new A._zip__closure1(_box_0), t1), false, t2);
                    result.$flags = 3;
                    results.push(new A.SassList(result, B.ListSeparator_SrV, false));
                    ++_box_0.i;
                }
                return A.SassList$(results, B.ListSeparator_z0K, false);
            },
            $signature: 28
        };
        A._zip__closure.prototype = {
            call$1: function(list) {
                return list.get$asList();
            },
            $signature: 509
        };
        A._zip__closure0.prototype = {
            call$1: function(list) {
                return this._box_0.i !== J.get$length$asx(list);
            },
            $signature: 586
        };
        A._zip__closure1.prototype = {
            call$1: function(list) {
                return J.$index$asx(list, this._box_0.i);
            },
            $signature: 5
        };
        A._index_closure0.prototype = {
            call$1: function($arguments) {
                var t1 = J.getInterceptor$asx($arguments), index = B.JSArray_methods.indexOf$1(t1.$index($arguments, 0).get$asList(), t1.$index($arguments, 1));
                return index === -1 ? B.C__SassNull : A.SassNumber_SassNumber(index + 1, null);
            },
            $signature: 5
        };
        A._separator_closure.prototype = {
            call$1: function($arguments) {
                var t1 = J.$index$asx($arguments, 0), _0_0 = t1.get$separator(t1);
                $label0$0: {
                    if (B.ListSeparator_z0K === _0_0) {
                        t1 = new A.SassString("comma", false);
                        break $label0$0;
                    }
                    if (B.ListSeparator_Lul === _0_0) {
                        t1 = new A.SassString("slash", false);
                        break $label0$0;
                    }
                    t1 = new A.SassString("space", false);
                    break $label0$0;
                }
                return t1;
            },
            $signature: 19
        };
        A._isBracketed_closure.prototype = {
            call$1: function($arguments) {
                return J.$index$asx($arguments, 0).get$hasBrackets() ? B.SassBoolean_true : B.SassBoolean_false;
            },
            $signature: 11
        };
        A._slash_closure.prototype = {
            call$1: function($arguments) {
                var list = J.$index$asx($arguments, 0).get$asList();
                if (list.length < 2) throw A.wrapException(A.SassScriptException$("At least two elements are required.", null));
                return A.SassList$(list, B.ListSeparator_Lul, false);
            },
            $signature: 28
        };
        A._get_closure.prototype = {
            call$1: function($arguments) {
                var value, t1 = J.getInterceptor$asx($arguments), map = t1.$index($arguments, 0).assertMap$1("map"), t2 = A._setArrayType([
                    t1.$index($arguments, 1)
                ], type$.JSArray_Value);
                B.JSArray_methods.addAll$1(t2, t1.$index($arguments, 2).get$asList());
                for(t1 = A.IterableExtension_get_exceptLast(t2), t1 = t1.get$iterator(t1); t1.moveNext$0(); map = value){
                    value = map._map$_contents.$index(0, t1.get$current(t1));
                    if (!(value instanceof A.SassMap)) return B.C__SassNull;
                }
                t1 = map._map$_contents.$index(0, B.JSArray_methods.get$last(t2));
                return t1 == null ? B.C__SassNull : t1;
            },
            $signature: 5
        };
        A._set_closure.prototype = {
            call$1: function($arguments) {
                var t1 = J.getInterceptor$asx($arguments);
                return A._modify(t1.$index($arguments, 0).assertMap$1("map"), A._setArrayType([
                    t1.$index($arguments, 1)
                ], type$.JSArray_Value), new A._set__closure0($arguments), true);
            },
            $signature: 5
        };
        A._set__closure0.prototype = {
            call$1: function(_) {
                return J.$index$asx(this.$arguments, 2);
            },
            $signature: 43
        };
        A._set_closure0.prototype = {
            call$1: function($arguments) {
                var keys, t2, t3, t1 = J.getInterceptor$asx($arguments), map = t1.$index($arguments, 0).assertMap$1("map"), _0_0 = t1.$index($arguments, 1).get$asList(), _0_1 = _0_0.length;
                if (_0_1 <= 0) throw A.wrapException(A.SassScriptException$("Expected $args to contain a key.", null));
                if (_0_1 === 1) throw A.wrapException(A.SassScriptException$("Expected $args to contain a value.", null));
                t1 = {};
                keys = t1.value = null;
                t2 = _0_1 >= 1;
                if (t2) {
                    t3 = _0_1 - 1;
                    keys = B.JSArray_methods.sublist$2(_0_0, 0, t3);
                    t1.value = _0_0[t3];
                }
                if (t2) return A._modify(map, keys, new A._set__closure(t1), true);
                throw A.wrapException("[BUG] Unreachable code");
            },
            $signature: 5
        };
        A._set__closure.prototype = {
            call$1: function(_) {
                return this._box_0.value;
            },
            $signature: 43
        };
        A._merge_closure.prototype = {
            call$1: function($arguments) {
                var t2, t1 = J.getInterceptor$asx($arguments), map1 = t1.$index($arguments, 0).assertMap$1("map1"), map2 = t1.$index($arguments, 1).assertMap$1("map2");
                t1 = type$.Value;
                t2 = A.LinkedHashMap_LinkedHashMap$of(map1._map$_contents, t1, t1);
                t2.addAll$1(0, map2._map$_contents);
                return new A.SassMap(A.ConstantMap_ConstantMap$from(t2, t1, t1));
            },
            $signature: 38
        };
        A._merge_closure0.prototype = {
            call$1: function($arguments) {
                var last, t2, keys, _null = null, t1 = J.getInterceptor$asx($arguments), map1 = t1.$index($arguments, 0).assertMap$1("map1"), _0_0 = t1.$index($arguments, 1).get$asList(), _0_1 = _0_0.length;
                if (_0_1 <= 0) throw A.wrapException(A.SassScriptException$("Expected $args to contain a key.", _null));
                if (_0_1 === 1) throw A.wrapException(A.SassScriptException$("Expected $args to contain a map.", _null));
                t1 = _0_1 >= 1;
                last = _null;
                if (t1) {
                    t2 = _0_1 - 1;
                    keys = B.JSArray_methods.sublist$2(_0_0, 0, t2);
                    last = _0_0[t2];
                } else keys = _null;
                if (t1) return A._modify(map1, keys, new A._merge__closure(last.assertMap$1("map2")), true);
                throw A.wrapException("[BUG] Unreachable code");
            },
            $signature: 5
        };
        A._merge__closure.prototype = {
            call$1: function(oldValue) {
                var t1, t2, nestedMap = oldValue.tryMap$0();
                if (nestedMap == null) return this.map2;
                t1 = type$.Value;
                t2 = A.LinkedHashMap_LinkedHashMap$of(nestedMap._map$_contents, t1, t1);
                t2.addAll$1(0, this.map2._map$_contents);
                return new A.SassMap(A.ConstantMap_ConstantMap$from(t2, t1, t1));
            },
            $signature: 654
        };
        A._deepMerge_closure.prototype = {
            call$1: function($arguments) {
                var t1 = J.getInterceptor$asx($arguments);
                return A._deepMergeImpl(t1.$index($arguments, 0).assertMap$1("map1"), t1.$index($arguments, 1).assertMap$1("map2"));
            },
            $signature: 38
        };
        A._deepRemove_closure.prototype = {
            call$1: function($arguments) {
                var t1 = J.getInterceptor$asx($arguments), map = t1.$index($arguments, 0).assertMap$1("map"), t2 = A._setArrayType([
                    t1.$index($arguments, 1)
                ], type$.JSArray_Value);
                B.JSArray_methods.addAll$1(t2, t1.$index($arguments, 2).get$asList());
                return A._modify(map, A.IterableExtension_get_exceptLast(t2), new A._deepRemove__closure(t2), false);
            },
            $signature: 5
        };
        A._deepRemove__closure.prototype = {
            call$1: function(value) {
                var t1, nestedMap, t2, _0_0 = value.tryMap$0();
                if (_0_0 != null) {
                    t1 = _0_0._map$_contents.containsKey$1(B.JSArray_methods.get$last(this.keys));
                    nestedMap = _0_0;
                } else {
                    nestedMap = null;
                    t1 = false;
                }
                if (t1) {
                    t1 = type$.Value;
                    t2 = A.LinkedHashMap_LinkedHashMap$of(nestedMap._map$_contents, t1, t1);
                    t2.remove$1(0, B.JSArray_methods.get$last(this.keys));
                    return new A.SassMap(A.ConstantMap_ConstantMap$from(t2, t1, t1));
                }
                return value;
            },
            $signature: 43
        };
        A._remove_closure.prototype = {
            call$1: function($arguments) {
                return J.$index$asx($arguments, 0).assertMap$1("map");
            },
            $signature: 38
        };
        A._remove_closure0.prototype = {
            call$1: function($arguments) {
                var mutableMap, t3, _i, t1 = J.getInterceptor$asx($arguments), map = t1.$index($arguments, 0).assertMap$1("map"), t2 = A._setArrayType([
                    t1.$index($arguments, 1)
                ], type$.JSArray_Value);
                B.JSArray_methods.addAll$1(t2, t1.$index($arguments, 2).get$asList());
                t1 = type$.Value;
                mutableMap = A.LinkedHashMap_LinkedHashMap$of(map._map$_contents, t1, t1);
                for(t3 = t2.length, _i = 0; _i < t2.length; t2.length === t3 || (0, A.throwConcurrentModificationError)(t2), ++_i)mutableMap.remove$1(0, t2[_i]);
                return new A.SassMap(A.ConstantMap_ConstantMap$from(mutableMap, t1, t1));
            },
            $signature: 38
        };
        A._keys_closure.prototype = {
            call$1: function($arguments) {
                var t1 = J.$index$asx($arguments, 0).assertMap$1("map")._map$_contents;
                return A.SassList$(t1.get$keys(t1), B.ListSeparator_z0K, false);
            },
            $signature: 28
        };
        A._values_closure.prototype = {
            call$1: function($arguments) {
                var t1 = J.$index$asx($arguments, 0).assertMap$1("map")._map$_contents;
                return A.SassList$(t1.get$values(t1), B.ListSeparator_z0K, false);
            },
            $signature: 28
        };
        A._hasKey_closure.prototype = {
            call$1: function($arguments) {
                var value, t1 = J.getInterceptor$asx($arguments), map = t1.$index($arguments, 0).assertMap$1("map"), t2 = A._setArrayType([
                    t1.$index($arguments, 1)
                ], type$.JSArray_Value);
                B.JSArray_methods.addAll$1(t2, t1.$index($arguments, 2).get$asList());
                for(t1 = A.IterableExtension_get_exceptLast(t2), t1 = t1.get$iterator(t1); t1.moveNext$0(); map = value){
                    value = map._map$_contents.$index(0, t1.get$current(t1));
                    if (!(value instanceof A.SassMap)) return B.SassBoolean_false;
                }
                return map._map$_contents.containsKey$1(B.JSArray_methods.get$last(t2)) ? B.SassBoolean_true : B.SassBoolean_false;
            },
            $signature: 11
        };
        A._modify_modifyNestedMap.prototype = {
            call$1: function(map) {
                var nestedMap, _this = this, t1 = type$.Value, mutableMap = A.LinkedHashMap_LinkedHashMap$of(map._map$_contents, t1, t1), t2 = _this.keyIterator, key = t2.get$current(t2);
                if (!t2.moveNext$0()) {
                    t2 = mutableMap.$index(0, key);
                    if (t2 == null) t2 = B.C__SassNull;
                    mutableMap.$indexSet(0, key, _this.modify.call$1(t2));
                    return new A.SassMap(A.ConstantMap_ConstantMap$from(mutableMap, t1, t1));
                }
                t2 = mutableMap.$index(0, key);
                nestedMap = t2 == null ? null : t2.tryMap$0();
                t2 = nestedMap == null;
                if (t2 && !_this.addNesting) return new A.SassMap(A.ConstantMap_ConstantMap$from(mutableMap, t1, t1));
                mutableMap.$indexSet(0, key, _this.call$1(t2 ? B.SassMap_Map_empty : nestedMap));
                return new A.SassMap(A.ConstantMap_ConstantMap$from(mutableMap, t1, t1));
            },
            $signature: 671
        };
        A.global_closure.prototype = {
            call$1: function($arguments) {
                var t1, number = J.$index$asx($arguments, 0).assertNumber$1("number");
                if (number.hasUnit$1("%")) A.warnForDeprecation(string$.Passinp + number.toString$0(0) + ")\nTo emit a CSS abs() now: abs(#{" + number.toString$0(0) + string$.x7dx29_Mor, B.Deprecation_Usi);
                else A.warnForDeprecation(string$.Globalm, B.Deprecation_WW3);
                t1 = number.get$numeratorUnits(number);
                return A.SassNumber_SassNumber$withUnits(Math.abs(number._number$_value), number.get$denominatorUnits(number), t1);
            },
            $signature: 24
        };
        A.module_closure0.prototype = {
            call$1: function(value) {
                return Math.abs(value);
            },
            $signature: 12
        };
        A._ceil_closure.prototype = {
            call$1: function(value) {
                return B.JSNumber_methods.ceil$0(value);
            },
            $signature: 12
        };
        A._clamp_closure.prototype = {
            call$1: function($arguments) {
                var t1 = J.getInterceptor$asx($arguments), min = t1.$index($arguments, 0).assertNumber$1("min"), number = t1.$index($arguments, 1).assertNumber$1("number"), max = t1.$index($arguments, 2).assertNumber$1("max");
                number.convertValueToMatch$3(min, "number", "min");
                max.convertValueToMatch$3(min, "max", "min");
                if (min.greaterThanOrEquals$1(max).value) return min;
                if (min.greaterThanOrEquals$1(number).value) return min;
                if (number.greaterThanOrEquals$1(max).value) return max;
                return number;
            },
            $signature: 24
        };
        A._floor_closure.prototype = {
            call$1: function(value) {
                return B.JSNumber_methods.floor$0(value);
            },
            $signature: 12
        };
        A._max_closure.prototype = {
            call$1: function($arguments) {
                var t1, t2, max, _i, number;
                for(t1 = J.$index$asx($arguments, 0).get$asList(), t2 = t1.length, max = null, _i = 0; _i < t1.length; t1.length === t2 || (0, A.throwConcurrentModificationError)(t1), ++_i){
                    number = t1[_i].assertNumber$0();
                    if (max == null || max.lessThan$1(number).value) max = number;
                }
                if (max != null) return max;
                throw A.wrapException(A.SassScriptException$("At least one argument must be passed.", null));
            },
            $signature: 24
        };
        A._min_closure.prototype = {
            call$1: function($arguments) {
                var t1, t2, min, _i, number;
                for(t1 = J.$index$asx($arguments, 0).get$asList(), t2 = t1.length, min = null, _i = 0; _i < t1.length; t1.length === t2 || (0, A.throwConcurrentModificationError)(t1), ++_i){
                    number = t1[_i].assertNumber$0();
                    if (min == null || min.greaterThan$1(number).value) min = number;
                }
                if (min != null) return min;
                throw A.wrapException(A.SassScriptException$("At least one argument must be passed.", null));
            },
            $signature: 24
        };
        A._round_closure.prototype = {
            call$1: function(number) {
                return B.JSNumber_methods.round$0(number);
            },
            $signature: 12
        };
        A._hypot_closure.prototype = {
            call$1: function($arguments) {
                var subtotal, i, i0, t3, t1 = J.$index$asx($arguments, 0).get$asList(), t2 = A._arrayInstanceType(t1)._eval$1("MappedListIterable<1,SassNumber>"), numbers = A.List_List$_of(new A.MappedListIterable(t1, new A._hypot__closure(), t2), t2._eval$1("ListIterable.E"));
                if (numbers.length === 0) throw A.wrapException(A.SassScriptException$("At least one argument must be passed.", null));
                for(subtotal = 0, i = 0; i < numbers.length; i = i0){
                    i0 = i + 1;
                    subtotal += Math.pow(numbers[i].convertValueToMatch$3(numbers[0], "numbers[" + i0 + "]", "numbers[1]"), 2);
                }
                t1 = Math.sqrt(subtotal);
                t2 = numbers[0];
                t2 = t2.get$numeratorUnits(t2);
                t3 = numbers[0];
                return A.SassNumber_SassNumber$withUnits(t1, t3.get$denominatorUnits(t3), t2);
            },
            $signature: 24
        };
        A._hypot__closure.prototype = {
            call$1: function(argument) {
                return argument.assertNumber$0();
            },
            $signature: 692
        };
        A._log_closure.prototype = {
            call$1: function($arguments) {
                var base, _s18_ = " to have no units.", _null = null, t1 = J.getInterceptor$asx($arguments), number = t1.$index($arguments, 0).assertNumber$1("number");
                if (number.get$hasUnits()) throw A.wrapException(A.SassScriptException$("$number: Expected " + number.toString$0(0) + _s18_, _null));
                else if (t1.$index($arguments, 1).$eq(0, B.C__SassNull)) return A.SassNumber_SassNumber(Math.log(number._number$_value), _null);
                base = t1.$index($arguments, 1).assertNumber$1("base");
                if (base.get$hasUnits()) throw A.wrapException(A.SassScriptException$("$base: Expected " + base.toString$0(0) + _s18_, _null));
                else return A.SassNumber_SassNumber(Math.log(number._number$_value) / Math.log(base._number$_value), _null);
            },
            $signature: 24
        };
        A._pow_closure.prototype = {
            call$1: function($arguments) {
                var t1 = J.getInterceptor$asx($arguments);
                return A.pow0(t1.$index($arguments, 0).assertNumber$1("base"), t1.$index($arguments, 1).assertNumber$1("exponent"));
            },
            $signature: 24
        };
        A._atan2_closure.prototype = {
            call$1: function($arguments) {
                var t1 = J.getInterceptor$asx($arguments), y = t1.$index($arguments, 0).assertNumber$1("y");
                return A.SassNumber_SassNumber$withUnits(Math.atan2(y._number$_value, t1.$index($arguments, 1).assertNumber$1("x").convertValueToMatch$3(y, "x", "y")) * 57.29577951308232, null, A._setArrayType([
                    "deg"
                ], type$.JSArray_String));
            },
            $signature: 24
        };
        A._compatible_closure.prototype = {
            call$1: function($arguments) {
                var t1 = J.getInterceptor$asx($arguments);
                return t1.$index($arguments, 0).assertNumber$1("number1").isComparableTo$1(t1.$index($arguments, 1).assertNumber$1("number2")) ? B.SassBoolean_true : B.SassBoolean_false;
            },
            $signature: 11
        };
        A._isUnitless_closure.prototype = {
            call$1: function($arguments) {
                return !J.$index$asx($arguments, 0).assertNumber$1("number").get$hasUnits() ? B.SassBoolean_true : B.SassBoolean_false;
            },
            $signature: 11
        };
        A._unit_closure.prototype = {
            call$1: function($arguments) {
                return new A.SassString(J.$index$asx($arguments, 0).assertNumber$1("number").get$unitString(), true);
            },
            $signature: 19
        };
        A._percentage_closure.prototype = {
            call$1: function($arguments) {
                var number = J.$index$asx($arguments, 0).assertNumber$1("number");
                number.assertNoUnits$1("number");
                return A.SassNumber_SassNumber(number._number$_value * 100, "%");
            },
            $signature: 24
        };
        A._randomFunction_closure.prototype = {
            call$1: function($arguments) {
                var limit, limitScalar, t1 = J.getInterceptor$asx($arguments);
                if (t1.$index($arguments, 0).$eq(0, B.C__SassNull)) return A.SassNumber_SassNumber($.$get$_random0().nextDouble$0(), null);
                limit = t1.$index($arguments, 0).assertNumber$1("limit");
                if (limit.get$hasUnits()) A.warnForDeprecation(string$.math_r + limit.toString$0(0) + string$.x29x20in_a + limit.get$unitString() + ")) * 1" + limit.get$unitString() + string$.x0a_To_p + limit.get$unitString() + string$.x29x29__Mo, B.Deprecation_7TE);
                limitScalar = limit.assertInt$1("limit");
                if (limitScalar < 1) throw A.wrapException(A.SassScriptException$("$limit: Must be greater than 0, was " + limit.toString$0(0) + ".", null));
                return A.SassNumber_SassNumber($.$get$_random0().nextInt$1(limitScalar) + 1, null);
            },
            $signature: 24
        };
        A._div_closure.prototype = {
            call$1: function($arguments) {
                var t1 = J.getInterceptor$asx($arguments), number1 = t1.$index($arguments, 0), number2 = t1.$index($arguments, 1);
                if (!(number1 instanceof A.SassNumber) || !(number2 instanceof A.SassNumber)) A.warn(string$.math_d);
                return number1.dividedBy$1(number2);
            },
            $signature: 5
        };
        A._singleArgumentMathFunc_closure.prototype = {
            call$1: function($arguments) {
                return this.mathFunc.call$1(J.$index$asx($arguments, 0).assertNumber$1("number"));
            },
            $signature: 24
        };
        A._numberFunction_closure.prototype = {
            call$1: function($arguments) {
                var number = J.$index$asx($arguments, 0).assertNumber$1("number"), t1 = this.transform.call$1(number._number$_value), t2 = number.get$numeratorUnits(number);
                return A.SassNumber_SassNumber$withUnits(t1, number.get$denominatorUnits(number), t2);
            },
            $signature: 24
        };
        A._shared_closure.prototype = {
            call$1: function($arguments) {
                A.warnForDeprecation(string$.The_fe, B.Deprecation_PY0);
                return $._features.contains$1(0, J.$index$asx($arguments, 0).assertString$1("feature")._string$_text) ? B.SassBoolean_true : B.SassBoolean_false;
            },
            $signature: 11
        };
        A._shared_closure0.prototype = {
            call$1: function($arguments) {
                return new A.SassString(A.serializeValue(J.get$first$ax($arguments), true, true), false);
            },
            $signature: 19
        };
        A._shared_closure1.prototype = {
            call$1: function($arguments) {
                var t1 = J.getInterceptor$asx($arguments), _0_0 = t1.$index($arguments, 0);
                $label0$0: {
                    if (_0_0 instanceof A.SassArgumentList) {
                        t1 = "arglist";
                        break $label0$0;
                    }
                    if (_0_0 instanceof A.SassBoolean) {
                        t1 = "bool";
                        break $label0$0;
                    }
                    if (_0_0 instanceof A.SassColor) {
                        t1 = "color";
                        break $label0$0;
                    }
                    if (_0_0 instanceof A.SassList) {
                        t1 = "list";
                        break $label0$0;
                    }
                    if (_0_0 instanceof A.SassMap) {
                        t1 = "map";
                        break $label0$0;
                    }
                    if (B.C__SassNull === _0_0) {
                        t1 = "null";
                        break $label0$0;
                    }
                    if (_0_0 instanceof A.SassNumber) {
                        t1 = "number";
                        break $label0$0;
                    }
                    if (_0_0 instanceof A.SassFunction) {
                        t1 = "function";
                        break $label0$0;
                    }
                    if (_0_0 instanceof A.SassMixin) {
                        t1 = "mixin";
                        break $label0$0;
                    }
                    if (_0_0 instanceof A.SassCalculation) {
                        t1 = "calculation";
                        break $label0$0;
                    }
                    if (_0_0 instanceof A.SassString) {
                        t1 = "string";
                        break $label0$0;
                    }
                    t1 = A.throwExpression("[BUG] Unknown value type " + t1.$index($arguments, 0).toString$0(0));
                }
                return new A.SassString(t1, false);
            },
            $signature: 19
        };
        A._shared_closure2.prototype = {
            call$1: function($arguments) {
                var t2, t3, t4, t1 = J.getInterceptor$asx($arguments), _1_0 = t1.$index($arguments, 0);
                if (_1_0 instanceof A.SassArgumentList) {
                    _1_0._wereKeywordsAccessed = true;
                    t1 = type$.Value;
                    t2 = A.LinkedHashMap_LinkedHashMap$_empty(t1, t1);
                    for(t3 = A.MapExtensions_get_pairs(_1_0._keywords, type$.String, t1), t3 = t3.get$iterator(t3); t3.moveNext$0();){
                        t4 = t3.get$current(t3);
                        t2.$indexSet(0, new A.SassString(t4._0, false), t4._1);
                    }
                    return new A.SassMap(A.ConstantMap_ConstantMap$from(t2, t1, t1));
                } else throw A.wrapException("$args: " + t1.$index($arguments, 0).toString$0(0) + " is not an argument list.");
            },
            $signature: 38
        };
        A.moduleFunctions_closure.prototype = {
            call$1: function($arguments) {
                return new A.SassString(J.$index$asx($arguments, 0).assertCalculation$1("calc").name, true);
            },
            $signature: 19
        };
        A.moduleFunctions_closure0.prototype = {
            call$1: function($arguments) {
                var t1 = J.$index$asx($arguments, 0).assertCalculation$1("calc").$arguments;
                return A.SassList$(new A.MappedListIterable(t1, new A.moduleFunctions__closure(), A._arrayInstanceType(t1)._eval$1("MappedListIterable<1,Value>")), B.ListSeparator_z0K, false);
            },
            $signature: 28
        };
        A.moduleFunctions__closure.prototype = {
            call$1: function(argument) {
                return argument instanceof A.Value ? argument : new A.SassString(J.toString$0$(argument), false);
            },
            $signature: 693
        };
        A.moduleFunctions_closure1.prototype = {
            call$1: function($arguments) {
                var _0_2_isSet, _0_2, acceptsContent, t1, _0_5_isSet, _0_5, hasContent, _null = null, mixin = J.$index$asx($arguments, 0).assertMixin$1("mixin"), _0_0 = mixin.callable;
                $label0$0: {
                    _0_2_isSet = type$.AsyncBuiltInCallable._is(_0_0);
                    _0_2 = _null;
                    acceptsContent = _null;
                    if (_0_2_isSet) {
                        _0_2 = _0_0.get$acceptsContent();
                        acceptsContent = _0_2;
                    }
                    if (!_0_2_isSet) {
                        _0_2_isSet = _0_0 instanceof A.BuiltInCallable;
                        if (_0_2_isSet) acceptsContent = _0_0.acceptsContent;
                        t1 = _0_2_isSet;
                    } else t1 = true;
                    if (t1) {
                        t1 = acceptsContent;
                        break $label0$0;
                    }
                    _0_5_isSet = _0_0 instanceof A.UserDefinedCallable;
                    _0_5 = _null;
                    if (_0_5_isSet) {
                        _0_5 = _0_0.declaration;
                        t1 = _0_5;
                        t1 = t1 instanceof A.MixinRule;
                    } else t1 = false;
                    if (t1) {
                        t1 = _0_5_isSet ? _0_5 : _0_0.declaration;
                        hasContent = type$.MixinRule._as(t1).get$hasContent();
                        t1 = hasContent;
                        break $label0$0;
                    }
                    t1 = A.throwExpression(A.UnsupportedError$("Unknown callable type " + mixin.toString$0(0) + "."));
                }
                return t1 ? B.SassBoolean_true : B.SassBoolean_false;
            },
            $signature: 11
        };
        A._nest_closure.prototype = {
            call$1: function($arguments) {
                var t1 = J.$index$asx($arguments, 0).get$asList();
                t1 = new A.MappedListIterable(t1, new A._nest__closure(), A._arrayInstanceType(t1)._eval$1("MappedListIterable<1,SelectorList>")).fold$2(0, null, new A._nest__closure0());
                t1 = t1 == null ? null : t1.get$asSassList();
                return t1 == null ? A.throwExpression(A.SassScriptException$(string$.x24selec, null)) : t1;
            },
            $signature: 28
        };
        A._nest__closure.prototype = {
            call$1: function(selector) {
                return A.SassApiValue_assertSelector(selector, true, null);
            },
            $signature: 187
        };
        A._nest__closure0.prototype = {
            call$2: function($parent, child) {
                return child.nestWithin$1($parent);
            },
            $signature: 327
        };
        A._append_closure.prototype = {
            call$1: function($arguments) {
                var t1, selectors = J.$index$asx($arguments, 0).get$asList();
                if (selectors.length === 0) throw A.wrapException(A.SassScriptException$(string$.x24selec, null));
                t1 = A.EvaluationContext_currentOrNull();
                return new A.MappedListIterable(selectors, new A._append__closure(), A._arrayInstanceType(selectors)._eval$1("MappedListIterable<1,SelectorList>")).reduce$1(0, new A._append__closure0((t1 == null ? A.throwExpression(A.StateError$(string$.No_Sass)) : t1).get$currentCallableSpan())).get$asSassList();
            },
            $signature: 28
        };
        A._append__closure.prototype = {
            call$1: function(selector) {
                return A.SassApiValue_assertSelector(selector, false, null);
            },
            $signature: 187
        };
        A._append__closure0.prototype = {
            call$2: function($parent, child) {
                var t1 = child.components, t2 = this.span;
                return A.SelectorList$(new A.MappedListIterable(t1, new A._append___closure($parent, t2), A._arrayInstanceType(t1)._eval$1("MappedListIterable<1,ComplexSelector>")), t2).nestWithin$1($parent);
            },
            $signature: 462
        };
        A._append___closure.prototype = {
            call$1: function(complex) {
                var _0_0, t1, component, rest, newCompound, t2, _null = null;
                if (complex.leadingCombinators.length !== 0) throw A.wrapException(A.SassScriptException$("Can't append " + complex.toString$0(0) + " to " + this.parent.toString$0(0) + ".", _null));
                _0_0 = complex.components;
                t1 = _0_0.length >= 1;
                if (t1) {
                    component = _0_0[0];
                    rest = B.JSArray_methods.sublist$1(_0_0, 1);
                } else {
                    rest = _null;
                    component = rest;
                }
                if (!t1) throw A.wrapException(A.StateError$("Pattern matching error"));
                newCompound = A._prependParent(component.selector);
                if (newCompound == null) throw A.wrapException(A.SassScriptException$("Can't append " + complex.toString$0(0) + " to " + this.parent.toString$0(0) + ".", _null));
                t1 = this.span;
                t2 = A._setArrayType([
                    new A.ComplexSelectorComponent(newCompound, A.List_List$unmodifiable(component.combinators, type$.CssValue_Combinator), t1)
                ], type$.JSArray_ComplexSelectorComponent);
                B.JSArray_methods.addAll$1(t2, rest);
                return A.ComplexSelector$(B.List_empty0, t2, t1, false);
            },
            $signature: 61
        };
        A._extend_closure.prototype = {
            call$1: function($arguments) {
                var target, source, _s8_ = "selector", _s8_0 = "extendee", _s8_1 = "extender", t1 = J.getInterceptor$asx($arguments), selector = A.SassApiValue_assertSelector(t1.$index($arguments, 0), false, _s8_);
                selector.assertNotBogus$1$name(_s8_);
                target = A.SassApiValue_assertSelector(t1.$index($arguments, 1), false, _s8_0);
                target.assertNotBogus$1$name(_s8_0);
                source = A.SassApiValue_assertSelector(t1.$index($arguments, 2), false, _s8_1);
                source.assertNotBogus$1$name(_s8_1);
                t1 = A.EvaluationContext_currentOrNull();
                return A.ExtensionStore__extendOrReplace(selector, source, target, B.ExtendMode_allTargets_2_allTargets, (t1 == null ? A.throwExpression(A.StateError$(string$.No_Sass)) : t1).get$currentCallableSpan()).get$asSassList();
            },
            $signature: 28
        };
        A._replace_closure.prototype = {
            call$1: function($arguments) {
                var target, source, _s8_ = "selector", _s8_0 = "original", _s11_ = "replacement", t1 = J.getInterceptor$asx($arguments), selector = A.SassApiValue_assertSelector(t1.$index($arguments, 0), false, _s8_);
                selector.assertNotBogus$1$name(_s8_);
                target = A.SassApiValue_assertSelector(t1.$index($arguments, 1), false, _s8_0);
                target.assertNotBogus$1$name(_s8_0);
                source = A.SassApiValue_assertSelector(t1.$index($arguments, 2), false, _s11_);
                source.assertNotBogus$1$name(_s11_);
                t1 = A.EvaluationContext_currentOrNull();
                return A.ExtensionStore__extendOrReplace(selector, source, target, B.ExtendMode_replace_1_replace, (t1 == null ? A.throwExpression(A.StateError$(string$.No_Sass)) : t1).get$currentCallableSpan()).get$asSassList();
            },
            $signature: 28
        };
        A._unify_closure.prototype = {
            call$1: function($arguments) {
                var selector2, _s9_ = "selector1", _s9_0 = "selector2", t1 = J.getInterceptor$asx($arguments), selector1 = A.SassApiValue_assertSelector(t1.$index($arguments, 0), false, _s9_);
                selector1.assertNotBogus$1$name(_s9_);
                selector2 = A.SassApiValue_assertSelector(t1.$index($arguments, 1), false, _s9_0);
                selector2.assertNotBogus$1$name(_s9_0);
                t1 = selector1.unify$1(selector2);
                t1 = t1 == null ? null : t1.get$asSassList();
                return t1 == null ? B.C__SassNull : t1;
            },
            $signature: 5
        };
        A._isSuperselector_closure.prototype = {
            call$1: function($arguments) {
                var selector2, t1 = J.getInterceptor$asx($arguments), selector1 = A.SassApiValue_assertSelector(t1.$index($arguments, 0), false, "super");
                selector1.assertNotBogus$1$name("super");
                selector2 = A.SassApiValue_assertSelector(t1.$index($arguments, 1), false, "sub");
                selector2.assertNotBogus$1$name("sub");
                return A.listIsSuperselector(selector1.components, selector2.components) ? B.SassBoolean_true : B.SassBoolean_false;
            },
            $signature: 11
        };
        A._simpleSelectors_closure.prototype = {
            call$1: function($arguments) {
                var t1 = A.SassApiValue_assertCompoundSelector(J.$index$asx($arguments, 0), "selector").components;
                return A.SassList$(new A.MappedListIterable(t1, new A._simpleSelectors__closure(), A._arrayInstanceType(t1)._eval$1("MappedListIterable<1,Value>")), B.ListSeparator_z0K, false);
            },
            $signature: 28
        };
        A._simpleSelectors__closure.prototype = {
            call$1: function(simple) {
                return new A.SassString(A.serializeSelector(simple, true), false);
            },
            $signature: 330
        };
        A._parse_closure.prototype = {
            call$1: function($arguments) {
                return A.SassApiValue_assertSelector(J.$index$asx($arguments, 0), false, "selector").get$asSassList();
            },
            $signature: 28
        };
        A.module_closure.prototype = {
            call$1: function($arguments) {
                var limit, t2, chunks, i, lastEnd, match, t3, t1 = J.getInterceptor$asx($arguments), string = t1.$index($arguments, 0).assertString$1("string"), separator = t1.$index($arguments, 1).assertString$1("separator");
                t1 = t1.$index($arguments, 2).get$realNull();
                limit = t1 == null ? null : t1.assertNumber$1("limit").assertInt$1("limit");
                if (limit != null && limit < 1) throw A.wrapException(A.SassScriptException$("$limit: Must be 1 or greater, was " + A.S(limit) + ".", null));
                t1 = string._string$_text;
                if (t1.length === 0) return B.SassList_oWx;
                else {
                    t2 = separator._string$_text;
                    if (t2.length === 0) return A.SassList$(A.MappedIterable_MappedIterable(new A.Runes(t1), new A.module__closure(string), type$.Runes._eval$1("Iterable.E"), type$.Value), B.ListSeparator_z0K, true);
                }
                chunks = A._setArrayType([], type$.JSArray_String);
                for(t2 = B.JSString_methods.allMatches$1(t2, t1), t2 = new A._StringAllMatchesIterator(t2._input, t2._pattern, t2.__js_helper$_index), i = 0, lastEnd = 0; t2.moveNext$0();){
                    match = t2.__js_helper$_current;
                    t3 = match.start;
                    chunks.push(B.JSString_methods.substring$2(t1, lastEnd, t3));
                    lastEnd = t3 + match.pattern.length;
                    ++i;
                    if (i === limit) break;
                }
                chunks.push(B.JSString_methods.substring$1(t1, lastEnd));
                return A.SassList$(new A.MappedListIterable(chunks, new A.module__closure0(string), type$.MappedListIterable_String_Value), B.ListSeparator_z0K, true);
            },
            $signature: 28
        };
        A.module__closure.prototype = {
            call$1: function(rune) {
                return new A.SassString(A.Primitives_stringFromCharCode(rune), this.string._hasQuotes);
            },
            $signature: 341
        };
        A.module__closure0.prototype = {
            call$1: function(chunk) {
                return new A.SassString(chunk, this.string._hasQuotes);
            },
            $signature: 349
        };
        A._unquote_closure.prototype = {
            call$1: function($arguments) {
                var string = J.$index$asx($arguments, 0).assertString$1("string");
                if (!string._hasQuotes) return string;
                return new A.SassString(string._string$_text, false);
            },
            $signature: 19
        };
        A._quote_closure.prototype = {
            call$1: function($arguments) {
                var string = J.$index$asx($arguments, 0).assertString$1("string");
                if (string._hasQuotes) return string;
                return new A.SassString(string._string$_text, true);
            },
            $signature: 19
        };
        A._length_closure.prototype = {
            call$1: function($arguments) {
                return A.SassNumber_SassNumber(J.$index$asx($arguments, 0).assertString$1("string").get$_sassLength(), null);
            },
            $signature: 24
        };
        A._insert_closure.prototype = {
            call$1: function($arguments) {
                var indexInt, codeUnitIndex, _s5_ = "index", t1 = J.getInterceptor$asx($arguments), string = t1.$index($arguments, 0).assertString$1("string"), insert = t1.$index($arguments, 1).assertString$1("insert"), index = t1.$index($arguments, 2).assertNumber$1(_s5_);
                index.assertNoUnits$1(_s5_);
                indexInt = index.assertInt$1(_s5_);
                if (indexInt < 0) indexInt = Math.max(string.get$_sassLength() + indexInt + 2, 0);
                t1 = string._string$_text;
                codeUnitIndex = A.codepointIndexToCodeUnitIndex(t1, A._codepointForIndex(indexInt, string.get$_sassLength(), false));
                return new A.SassString(B.JSString_methods.replaceRange$3(t1, codeUnitIndex, codeUnitIndex, insert._string$_text), string._hasQuotes);
            },
            $signature: 19
        };
        A._index_closure.prototype = {
            call$1: function($arguments) {
                var t1 = J.getInterceptor$asx($arguments), t2 = t1.$index($arguments, 0).assertString$1("string")._string$_text, codeUnitIndex = B.JSString_methods.indexOf$1(t2, t1.$index($arguments, 1).assertString$1("substring")._string$_text);
                if (codeUnitIndex === -1) return B.C__SassNull;
                return A.SassNumber_SassNumber(A.codeUnitIndexToCodepointIndex(t2, codeUnitIndex) + 1, null);
            },
            $signature: 5
        };
        A._slice_closure.prototype = {
            call$1: function($arguments) {
                var lengthInCodepoints, endInt, startCodepoint, endCodepoint, _s8_ = "start-at", t1 = J.getInterceptor$asx($arguments), string = t1.$index($arguments, 0).assertString$1("string"), start = t1.$index($arguments, 1).assertNumber$1(_s8_), end = t1.$index($arguments, 2).assertNumber$1("end-at");
                start.assertNoUnits$1(_s8_);
                end.assertNoUnits$1("end-at");
                lengthInCodepoints = string.get$_sassLength();
                endInt = end.assertInt$0();
                if (endInt === 0) return string._hasQuotes ? $.$get$_emptyQuoted() : $.$get$_emptyUnquoted();
                startCodepoint = A._codepointForIndex(start.assertInt$0(), lengthInCodepoints, false);
                endCodepoint = A._codepointForIndex(endInt, lengthInCodepoints, true);
                if (endCodepoint === lengthInCodepoints) --endCodepoint;
                if (endCodepoint < startCodepoint) return string._hasQuotes ? $.$get$_emptyQuoted() : $.$get$_emptyUnquoted();
                t1 = string._string$_text;
                return new A.SassString(B.JSString_methods.substring$2(t1, A.codepointIndexToCodeUnitIndex(t1, startCodepoint), A.codepointIndexToCodeUnitIndex(t1, endCodepoint + 1)), string._hasQuotes);
            },
            $signature: 19
        };
        A._toUpperCase_closure.prototype = {
            call$1: function($arguments) {
                var t1, t2, i, t3, t4, string = J.$index$asx($arguments, 0).assertString$1("string");
                for(t1 = string._string$_text, t2 = t1.length, i = 0, t3 = ""; i < t2; ++i){
                    t4 = t1.charCodeAt(i);
                    t3 += A.Primitives_stringFromCharCode(t4 >= 97 && t4 <= 122 ? t4 & 4294967263 : t4);
                }
                return new A.SassString(t3.charCodeAt(0) == 0 ? t3 : t3, string._hasQuotes);
            },
            $signature: 19
        };
        A._toLowerCase_closure.prototype = {
            call$1: function($arguments) {
                var t1, t2, i, t3, t4, string = J.$index$asx($arguments, 0).assertString$1("string");
                for(t1 = string._string$_text, t2 = t1.length, i = 0, t3 = ""; i < t2; ++i){
                    t4 = t1.charCodeAt(i);
                    t3 += A.Primitives_stringFromCharCode(t4 >= 65 && t4 <= 90 ? t4 | 32 : t4);
                }
                return new A.SassString(t3.charCodeAt(0) == 0 ? t3 : t3, string._hasQuotes);
            },
            $signature: 19
        };
        A._uniqueId_closure.prototype = {
            call$1: function($arguments) {
                var t1 = $.$get$_previousUniqueId() + ($.$get$_random().nextInt$1(36) + 1);
                $._previousUniqueId = t1;
                if (t1 > Math.pow(36, 6)) $._previousUniqueId = B.JSInt_methods.$mod($.$get$_previousUniqueId(), A._asInt(Math.pow(36, 6)));
                return new A.SassString("u" + B.JSString_methods.padLeft$2(B.JSInt_methods.toRadixString$1($.$get$_previousUniqueId(), 36), 6, "0"), false);
            },
            $signature: 19
        };
        A.ImportCache.prototype = {
            canonicalize$4$baseImporter$baseUrl$forImport: function(_, url, baseImporter, baseUrl, forImport) {
                var t1, resolvedUrl, key, relativeResult, t2, t3, t4, t5, t6, cacheable, i, importer, perImporterKey, t7, _1_0, _1_2_isSet, result, _1_2, _2_0, _2_1, _2_5_isSet, _2_5, _2_3, _2_3_isSet, j, _this = this, _null = null;
                if (A.isBrowser()) t1 = (baseImporter == null || baseImporter instanceof A.NoOpImporter) && _this._importers.length === 0;
                else t1 = false;
                if (t1) throw A.wrapException(string$.Customi);
                if (baseImporter != null && url.get$scheme() === "") {
                    resolvedUrl = baseUrl == null ? _null : baseUrl.resolveUri$1(url);
                    if (resolvedUrl == null) resolvedUrl = url;
                    key = new A._Record_3_forImport(baseImporter, resolvedUrl, forImport);
                    relativeResult = _this._perImporterCanonicalizeCache.putIfAbsent$2(key, new A.ImportCache_canonicalize_closure(_this, baseImporter, resolvedUrl, baseUrl, forImport, key, url));
                    if (relativeResult != null) return relativeResult;
                }
                key = new A._Record_2_forImport(url, forImport);
                t1 = _this._canonicalizeCache;
                if (t1.containsKey$1(key)) return t1.$index(0, key);
                for(t2 = _this._importers, t3 = type$.Record_1_nullable_Object, t4 = _this._perImporterCanonicalizeCache, t5 = type$.nullable_Record_3_Importer_and_Uri_and_Uri_originalUrl, t6 = type$.Record_3_Importer_and_Uri_and_Uri_originalUrl, cacheable = true, i = 0; i < t2.length; ++i){
                    importer = t2[i];
                    perImporterKey = new A._Record_3_forImport(importer, url, forImport);
                    if (t4.containsKey$1(perImporterKey)) {
                        t7 = t4.$index(0, perImporterKey);
                        _1_0 = new A._Record_1(t7 == null ? t5._as(t7) : t7);
                    } else _1_0 = _null;
                    _1_2_isSet = t3._is(_1_0);
                    result = _null;
                    if (_1_2_isSet) {
                        _1_2 = _1_0._0;
                        t7 = _1_2 != null;
                        if (t7) {
                            t6._as(_1_2);
                            result = _1_2;
                        }
                    } else {
                        _1_2 = _null;
                        t7 = false;
                    }
                    if (t7) return result;
                    if (_1_2_isSet) t7 = _1_2 == null;
                    else t7 = false;
                    if (t7) continue;
                    $label0$1: {
                        _2_0 = _this._canonicalize$4(importer, url, baseUrl, forImport);
                        _2_1 = _2_0._0;
                        _2_5_isSet = _2_1 != null;
                        _2_5 = _null;
                        _2_3 = _null;
                        t7 = false;
                        if (_2_5_isSet) {
                            result = _2_1 == null ? t6._as(_2_1) : _2_1;
                            _2_3 = _2_0._1;
                            t7 = _2_3;
                            _2_5 = t7;
                            t7 = t7 && cacheable;
                        } else result = _null;
                        if (t7) {
                            t1.$indexSet(0, key, result);
                            return result;
                        }
                        if (_2_5_isSet) {
                            t7 = _2_5;
                            _2_3_isSet = _2_5_isSet;
                        } else {
                            _2_3 = _2_0._1;
                            t7 = _2_3;
                            _2_3_isSet = true;
                        }
                        t7 = t7 && !cacheable;
                        if (t7) {
                            t4.$indexSet(0, perImporterKey, _2_1);
                            if (_2_1 != null) return _2_1;
                            break $label0$1;
                        }
                        t7 = false === (_2_3_isSet ? _2_3 : _2_0._1);
                        if (t7) {
                            if (cacheable) {
                                for(j = 0; j < i; ++j)t4.$indexSet(0, new A._Record_3_forImport(t2[j], url, forImport), _null);
                                cacheable = false;
                            }
                            if (_2_1 != null) return _2_1;
                        }
                    }
                }
                if (cacheable) t1.$indexSet(0, key, _null);
                return _null;
            },
            canonicalize$3$baseImporter$baseUrl: function(_, url, baseImporter, baseUrl) {
                return this.canonicalize$4$baseImporter$baseUrl$forImport(0, url, baseImporter, baseUrl, false);
            },
            _canonicalize$4: function(importer, url, baseUrl, forImport) {
                var passContainingUrl, canonicalizeContext, t1, result, cacheable;
                if (baseUrl != null) passContainingUrl = url.get$scheme() === "" || importer.isNonCanonicalScheme$1(url.get$scheme());
                else passContainingUrl = false;
                canonicalizeContext = new A.CanonicalizeContext(forImport, passContainingUrl ? baseUrl : null);
                t1 = type$.nullable_Object;
                result = A.runZoned(new A.ImportCache__canonicalize_closure(importer, url), A.LinkedHashMap_LinkedHashMap$_literal([
                    B.Symbol__canonicalizeContext,
                    canonicalizeContext
                ], t1, t1), type$.nullable_Uri);
                cacheable = !passContainingUrl || !canonicalizeContext._wasContainingUrlAccessed;
                if (result == null) return new A._Record_2(null, cacheable);
                if (result.get$scheme() !== "" && importer.isNonCanonicalScheme$1(result.get$scheme())) throw A.wrapException("Importer " + importer.toString$0(0) + " canonicalized " + url.toString$0(0) + " to " + result.toString$0(0) + string$.x2c_whicu);
                return new A._Record_2(new A._Record_3_originalUrl(importer, result, url), cacheable);
            },
            importCanonical$3$originalUrl: function(importer, canonicalUrl, originalUrl) {
                return this._importCache.putIfAbsent$2(canonicalUrl, new A.ImportCache_importCanonical_closure(this, importer, canonicalUrl, originalUrl));
            },
            importCanonical$2: function(importer, canonicalUrl) {
                return this.importCanonical$3$originalUrl(importer, canonicalUrl, null);
            },
            humanize$1: function(canonicalUrl) {
                var t1 = this._canonicalizeCache, t2 = type$.NonNullsIterable_Record_3_Importer_and_Uri_and_Uri_originalUrl;
                t2 = A.NullableExtension_andThen(A.minBy(new A.MappedIterable(new A.WhereIterable(new A.NonNullsIterable(new A.LinkedHashMapValuesIterable(t1, A._instanceType(t1)._eval$1("LinkedHashMapValuesIterable<2>")), t2), new A.ImportCache_humanize_closure(canonicalUrl), t2._eval$1("WhereIterable<Iterable.E>")), new A.ImportCache_humanize_closure0(), t2._eval$1("MappedIterable<Iterable.E,Uri>")), new A.ImportCache_humanize_closure1()), new A.ImportCache_humanize_closure2(canonicalUrl));
                return t2 == null ? canonicalUrl : t2;
            },
            sourceMapUrl$1: function(_, canonicalUrl) {
                var t1 = this._resultsCache.$index(0, canonicalUrl);
                t1 = t1 == null ? null : t1.get$sourceMapUrl(0);
                return t1 == null ? canonicalUrl : t1;
            },
            clearCanonicalize$1: function(canonicalUrl) {
                var key, t5, t6, _i0, t1 = this._canonicalizeCache, t2 = A.List_List$_of(new A.LinkedHashMapKeysIterable(t1, A._instanceType(t1)._eval$1("LinkedHashMapKeysIterable<1>")), type$.Record_2_Uri_and_bool_forImport), t3 = t2.length, t4 = this._importers, _i = 0;
                for(; _i < t2.length; t2.length === t3 || (0, A.throwConcurrentModificationError)(t2), ++_i){
                    key = t2[_i];
                    for(t5 = t4.length, t6 = key._0, _i0 = 0; _i0 < t4.length; t4.length === t5 || (0, A.throwConcurrentModificationError)(t4), ++_i0)if (t4[_i0].couldCanonicalize$2(t6, canonicalUrl)) {
                        t1.remove$1(0, key);
                        break;
                    }
                }
                t1 = this._perImporterCanonicalizeCache;
                t2 = A.List_List$_of(new A.LinkedHashMapKeysIterable(t1, A._instanceType(t1)._eval$1("LinkedHashMapKeysIterable<1>")), type$.Record_3_Importer_and_Uri_and_bool_forImport);
                t3 = t2.length;
                _i = 0;
                for(; _i < t2.length; t2.length === t3 || (0, A.throwConcurrentModificationError)(t2), ++_i){
                    key = t2[_i];
                    if (key._0.couldCanonicalize$2(key._1, canonicalUrl)) t1.remove$1(0, key);
                }
            },
            clearImport$1: function(canonicalUrl) {
                this._resultsCache.remove$1(0, canonicalUrl);
                this._importCache.remove$1(0, canonicalUrl);
            }
        };
        A.ImportCache_canonicalize_closure.prototype = {
            call$0: function() {
                var _this = this, t1 = _this.$this, t2 = _this.baseUrl, _0_0 = t1._canonicalize$4(_this.baseImporter, _this.resolvedUrl, t2, _this.forImport);
                if (t2 != null) t1._nonCanonicalRelativeUrls.$indexSet(0, _this.key, _this.url);
                return _0_0._0;
            },
            $signature: 128
        };
        A.ImportCache__canonicalize_closure.prototype = {
            call$0: function() {
                return this.importer.canonicalize$1(0, this.url);
            },
            $signature: 144
        };
        A.ImportCache_importCanonical_closure.prototype = {
            call$0: function() {
                var t3, t4, _this = this, t1 = Date.now(), t2 = _this.canonicalUrl, result = _this.importer.load$1(0, t2);
                if (result == null) return null;
                t3 = _this.$this;
                t3._loadTimes.$indexSet(0, t2, new A.DateTime(t1, 0, false));
                t3._resultsCache.$indexSet(0, t2, result);
                t3 = result.contents;
                t1 = result.syntax;
                t4 = _this.originalUrl;
                return A.Stylesheet_Stylesheet$parse(t3, t1, false, t4 == null ? t2 : t4.resolveUri$1(t2));
            },
            $signature: 86
        };
        A.ImportCache_humanize_closure.prototype = {
            call$1: function(result) {
                return result._1.$eq(0, this.canonicalUrl);
            },
            $signature: 320
        };
        A.ImportCache_humanize_closure0.prototype = {
            call$1: function(result) {
                return result._2;
            },
            $signature: 323
        };
        A.ImportCache_humanize_closure1.prototype = {
            call$1: function(url) {
                return url.get$path(url).length;
            },
            $signature: 107
        };
        A.ImportCache_humanize_closure2.prototype = {
            call$1: function(url) {
                var t1 = $.$get$url(), t2 = this.canonicalUrl;
                return url.resolve$1(0, A.ParsedPath_ParsedPath$parse(t2.get$path(t2), t1.style).get$basename());
            },
            $signature: 49
        };
        A.Importer.prototype = {
            modificationTime$1: function(url) {
                return new A.DateTime(Date.now(), 0, false);
            },
            couldCanonicalize$2: function(url, canonicalUrl) {
                return true;
            },
            isNonCanonicalScheme$1: function(scheme) {
                return false;
            }
        };
        A.AsyncImporter.prototype = {};
        A.CanonicalizeContext.prototype = {};
        A.FilesystemImporter.prototype = {
            canonicalize$1: function(_, url) {
                var resolved, _0_0;
                if (url.get$scheme() === "file") resolved = A.resolveImportPath($.$get$context().style.pathFromUri$1(A._parseUri(url)));
                else if (url.get$scheme() !== "") return null;
                else {
                    _0_0 = this._loadPath;
                    if (_0_0 != null) {
                        resolved = A.resolveImportPath(A.join(_0_0, $.$get$context().style.pathFromUri$1(A._parseUri(url)), null));
                        if (resolved != null && this._loadPathDeprecated) A.warnForDeprecation(string$.Using_t, B.Deprecation_uJ0);
                    } else return null;
                }
                return A.NullableExtension_andThen(resolved, new A.FilesystemImporter_canonicalize_closure());
            },
            load$1: function(_, url) {
                var path = $.$get$context().style.pathFromUri$1(A._parseUri(url)), t1 = A.readFile(path), t2 = A.Syntax_forPath(path), t3 = url.get$scheme();
                if (t3 === "") A.throwExpression(A.ArgumentError$value(url, "sourceMapUrl", "must be absolute"));
                return new A.ImporterResult(t1, url, t2);
            },
            modificationTime$1: function(url) {
                return A.modificationTime($.$get$context().style.pathFromUri$1(A._parseUri(url)));
            },
            couldCanonicalize$2: function(url, canonicalUrl) {
                var t1, t2, basename, canonicalBasename;
                if (url.get$scheme() !== "file" && url.get$scheme() !== "") return false;
                if (canonicalUrl.get$scheme() !== "file") return false;
                t1 = $.$get$url();
                t2 = t1.style;
                basename = A.ParsedPath_ParsedPath$parse(url.get$path(url), t2).get$basename();
                canonicalBasename = A.ParsedPath_ParsedPath$parse(canonicalUrl.get$path(canonicalUrl), t2).get$basename();
                if (!B.JSString_methods.startsWith$1(basename, "_") && B.JSString_methods.startsWith$1(canonicalBasename, "_")) canonicalBasename = B.JSString_methods.substring$1(canonicalBasename, 1);
                return basename === canonicalBasename || basename === t1.withoutExtension$1(canonicalBasename);
            },
            toString$0: function(_) {
                var t1 = this._loadPath;
                return t1 == null ? "<absolute file importer>" : t1;
            }
        };
        A.FilesystemImporter_canonicalize_closure.prototype = {
            call$1: function(resolved) {
                var t2, t0, _null = null, t1 = A.isNodeJs() ? self.process : _null;
                if (!J.$eq$(t1 == null ? _null : J.get$platform$x(t1), "win32")) {
                    t1 = A.isNodeJs() ? self.process : _null;
                    t1 = J.$eq$(t1 == null ? _null : J.get$platform$x(t1), "darwin");
                } else t1 = true;
                if (t1) {
                    t1 = A.absolute(resolved, _null, _null, _null, _null, _null, _null, _null, _null, _null, _null, _null, _null, _null, _null);
                    t2 = $.$get$context();
                    t1 = A._realCasePath(t2.normalize$1(t1));
                } else {
                    t1 = $.$get$context();
                    t2 = t1.canonicalize$1(0, resolved);
                    t0 = t2;
                    t2 = t1;
                    t1 = t0;
                }
                return t2.toUri$1(t1);
            },
            $signature: 127
        };
        A.NoOpImporter.prototype = {};
        A.NodePackageImporter.prototype = {
            isNonCanonicalScheme$1: function(scheme) {
                return scheme === "pkg";
            },
            canonicalize$1: function(_, url) {
                var packageName, jsonPath, jsonString, packageManifest, e, t1, t2, t3, t4, baseDirectory, parts, t5, $name, subpath, packageRoot, _$exception, _1_0, rootPath, subpathInRoot, _this = this, _null = null;
                if (url.get$scheme() === "file") return $.$get$FilesystemImporter_cwd().canonicalize$1(0, url);
                if (url.get$scheme() !== "pkg") return _null;
                if (url.get$hasAuthority()) throw A.wrapException(string$.A_pkg_h);
                else {
                    t1 = $.$get$url();
                    t2 = t1.style;
                    if (t2.rootLength$1(url.get$path(url)) > 0) throw A.wrapException("A pkg: URL's path must not begin with /.");
                    else if (url.get$path(url).length === 0) throw A.wrapException("A pkg: URL must not have an empty path.");
                    else if (url.get$hasQuery() || url.get$hasFragment()) throw A.wrapException(string$.A_pkg_q);
                }
                t3 = A.canonicalizeContext();
                t3._wasContainingUrlAccessed = true;
                t3 = t3._containingUrl;
                if ((t3 == null ? _null : t3.get$scheme()) === "file") {
                    t3 = A.canonicalizeContext();
                    t3._wasContainingUrlAccessed = true;
                    t3 = t3._containingUrl;
                    t3.toString;
                    t4 = $.$get$context();
                    baseDirectory = t4.dirname$1(t4.style.pathFromUri$1(A._parseUri(t3)));
                } else {
                    t3 = _this.__NodePackageImporter__entryPointDirectory_F;
                    t3 === $ && A.throwUnnamedLateFieldNI();
                    baseDirectory = t3;
                }
                packageName = null;
                parts = t1.split$1(0, url.get$path(url));
                t3 = B.JSArray_methods.removeAt$1(parts, 0);
                t4 = $.$get$context();
                t5 = t4.style;
                $name = t5.pathFromUri$1(A._parseUri(t3));
                if (B.JSString_methods.startsWith$1($name, "@")) $name = parts.length !== 0 ? t1.join$2(0, $name, B.JSArray_methods.removeAt$1(parts, 0)) : $name;
                subpath = parts.length !== 0 ? t5.pathFromUri$1(A._parseUri(t1.joinAll$1(parts))) : _null;
                packageName = $name;
                t1 = true;
                if (!J.startsWith$1$s(packageName, ".")) {
                    if (!J.contains$1$asx(packageName, "\\")) {
                        if (!J.contains$1$asx(packageName, "%")) t1 = J.startsWith$1$s(packageName, "@") && !J.contains$1$asx(packageName, t2.get$separator(t2));
                    }
                }
                if (t1) return _null;
                packageRoot = _this._resolvePackageRoot$2(packageName, baseDirectory);
                if (packageRoot == null) return _null;
                jsonPath = A.join(packageRoot, "package.json", _null);
                jsonString = A.readFile(jsonPath);
                packageManifest = null;
                try {
                    packageManifest = type$.Map_String_dynamic._as(B.C_JsonCodec.decode$1(jsonString));
                } catch (exception) {
                    e = A.unwrapException(exception);
                    t1 = A.S(jsonPath);
                    t2 = A.S(packageName);
                    t3 = A.S(e);
                    throw A.wrapException("Failed to parse " + t1 + ' for "pkg:' + t2 + '": ' + t3);
                }
                _1_0 = _this._resolvePackageExports$4(packageRoot, subpath, packageManifest, packageName);
                if (_1_0 != null) {
                    if (B.Set_FTDN4.contains$1(0, A.ParsedPath_ParsedPath$parse(_1_0, t5)._splitExtension$1(1)[1])) return t4.toUri$1(t4.canonicalize$1(0, _this._resolveImportOnly$1(_1_0)));
                    else {
                        t1 = subpath == null ? "root" : subpath;
                        throw A.wrapException("The export for '" + t1 + "' in '" + A.S(packageName) + "' resolved to '" + _1_0 + string$.x27x2c_whi);
                    }
                }
                if (subpath == null) {
                    rootPath = _this._resolvePackageRootValues$2(packageRoot, packageManifest);
                    return rootPath != null ? t4.toUri$1(t4.canonicalize$1(0, rootPath)) : _null;
                }
                subpathInRoot = A.join(packageRoot, subpath, _null);
                return $.$get$FilesystemImporter_cwd().canonicalize$1(0, t4.toUri$1(subpathInRoot));
            },
            load$1: function(_, url) {
                return $.$get$FilesystemImporter_cwd().load$1(0, url);
            },
            _resolvePackageRoot$2: function(packageName, baseDirectory) {
                var potentialPackage, t1;
                for(;;){
                    potentialPackage = A.join(baseDirectory, "node_modules", packageName);
                    if (A.dirExists(potentialPackage)) return potentialPackage;
                    t1 = $.$get$context();
                    if (t1.split$1(0, baseDirectory).length === 1) return null;
                    baseDirectory = t1.dirname$1(baseDirectory);
                }
            },
            _resolvePackageRootValues$2: function(packageRoot, packageManifest) {
                var t1, sassValue, _1_0, styleValue, _null = null, _0_0 = packageManifest.$index(0, "sass");
                if (typeof _0_0 == "string") {
                    t1 = B.Set_FTDN4.contains$1(0, A.ParsedPath_ParsedPath$parse(_0_0, $.$get$url().style)._splitExtension$1(1)[1]);
                    sassValue = _0_0;
                } else {
                    sassValue = _null;
                    t1 = false;
                }
                if (t1) return this._resolveImportOnly$1(A.join(packageRoot, sassValue, _null));
                else {
                    _1_0 = packageManifest.$index(0, "style");
                    if (typeof _1_0 == "string") {
                        t1 = B.Set_FTDN4.contains$1(0, A.ParsedPath_ParsedPath$parse(_1_0, $.$get$url().style)._splitExtension$1(1)[1]);
                        styleValue = _1_0;
                    } else {
                        styleValue = _null;
                        t1 = false;
                    }
                    if (t1) return this._resolveImportOnly$1(A.join(packageRoot, styleValue, _null));
                }
                return A.resolveImportPath(A.join(packageRoot, "index", _null));
            },
            _resolvePackageExports$4: function(packageRoot, subpath, packageManifest, packageName) {
                var _0_0, _1_0, _this = this, exports = packageManifest.$index(0, "exports");
                if (exports == null) return null;
                _0_0 = _this._nodePackageExportsResolve$5(packageRoot, _this._exportsToCheck$1(subpath), exports, subpath, packageName);
                if (_0_0 != null) return _0_0;
                if (subpath != null && A.ParsedPath_ParsedPath$parse(subpath, $.$get$url().style)._splitExtension$1(1)[1].length !== 0) return null;
                _1_0 = _this._nodePackageExportsResolve$5(packageRoot, _this._exportsToCheck$2$addIndex(subpath, true), exports, subpath, packageName);
                if (_1_0 != null) return _1_0;
                return null;
            },
            _nodePackageExportsResolve$5: function(packageRoot, subpathVariants, exports, subpath, packageName) {
                var t2, matches, _1_1, path, t1 = false;
                if (type$.Map_String_dynamic._is(exports)) {
                    t2 = exports.get$keys(exports);
                    if (t2.any$1(t2, new A.NodePackageImporter__nodePackageExportsResolve_closure())) {
                        t1 = exports.get$keys(exports);
                        t1 = t1.any$1(t1, new A.NodePackageImporter__nodePackageExportsResolve_closure0());
                    }
                }
                if (t1) {
                    t1 = exports.get$keys(exports);
                    throw A.wrapException("`exports` in " + packageName + string$.x20can_n + t1.map$1$1(t1, new A.NodePackageImporter__nodePackageExportsResolve_closure1(), type$.String).join$1(0, ",") + " in " + A.join(packageRoot, "package.json", null) + ".");
                }
                t1 = type$.NonNullsIterable_String;
                t1 = A.LinkedHashSet_LinkedHashSet$of(new A.NonNullsIterable(new A.MappedListIterable(subpathVariants, new A.NodePackageImporter__nodePackageExportsResolve_closure2(this, exports, packageRoot), A._arrayInstanceType(subpathVariants)._eval$1("MappedListIterable<1,String?>")), t1), t1._eval$1("Iterable.E"));
                matches = A.List_List$_of(t1, A._instanceType(t1)._precomputed1);
                $label0$1: {
                    _1_1 = matches.length;
                    if (_1_1 === 1) {
                        path = matches[0];
                        t1 = path;
                        break $label0$1;
                    }
                    if (_1_1 <= 0) {
                        t1 = null;
                        break $label0$1;
                    }
                    t1 = subpath == null ? "root" : subpath;
                    t1 = A.throwExpression(string$.Unable + t1 + " in " + packageName + " should be used. \n\nFound:\n" + B.JSArray_methods.join$1(matches, "\n"));
                }
                return t1;
            },
            _resolveImportOnly$1: function(path) {
                var t1, extension, importOnly;
                if (!A.fromImport()) return path;
                t1 = $.$get$context();
                extension = A.ParsedPath_ParsedPath$parse(path, t1.style)._splitExtension$1(1)[1];
                importOnly = t1.withoutExtension$1(path) + ".import" + extension;
                return A.fileExists(importOnly) ? importOnly : path;
            },
            _compareExpansionKeys$2: function(keyA, keyB) {
                var t1 = B.JSString_methods.contains$1(keyA, "*"), baseLengthA = t1 ? B.JSString_methods.indexOf$1(keyA, "*") + 1 : keyA.length, t2 = B.JSString_methods.contains$1(keyB, "*"), baseLengthB = t2 ? B.JSString_methods.indexOf$1(keyB, "*") + 1 : keyB.length;
                if (baseLengthA > baseLengthB) return -1;
                if (baseLengthB > baseLengthA) return 1;
                if (!t1) return 1;
                if (!t2) return -1;
                t1 = keyA.length;
                t2 = keyB.length;
                if (t1 > t2) return -1;
                if (t2 > t1) return 1;
                return 0;
            },
            _packageTargetResolve$4: function(subpath, exports, packageRoot, patternMatch) {
                var t2, string, path, map, key, value, _1_0, array, _2_0, _null = null, t1 = typeof exports == "string";
                if (t1) {
                    t2 = !B.JSString_methods.startsWith$1(exports, "./");
                    string = exports;
                } else {
                    string = _null;
                    t2 = false;
                }
                if (t2) throw A.wrapException("Export '" + A.S(string) + string$.x27x20must + packageRoot + "'.");
                if (t1) {
                    t2 = patternMatch != null;
                    string = exports;
                } else {
                    string = _null;
                    t2 = false;
                }
                if (t2) {
                    t1 = J.replaceFirst$2$s(string, "*", patternMatch);
                    t2 = $.$get$context();
                    path = t2.normalize$1(A.join(packageRoot, t2.style.pathFromUri$1(A._parseUri(t1)), _null));
                    return A.fileExists(path) ? path : _null;
                }
                string = t1 ? exports : _null;
                if (t1) {
                    t1 = $.$get$context();
                    string.toString;
                    return A.join(packageRoot, t1.style.pathFromUri$1(A._parseUri(string)), _null);
                }
                t1 = type$.Map_String_dynamic._is(exports);
                map = t1 ? exports : _null;
                if (t1) {
                    for(t1 = A.MapExtensions_get_pairs(map, type$.String, type$.dynamic), t1 = t1.get$iterator(t1); t1.moveNext$0();){
                        t2 = t1.get$current(t1);
                        key = t2._0;
                        value = t2._1;
                        if (!B.Set_8229z.contains$1(0, key)) continue;
                        if (value == null) continue;
                        _1_0 = this._packageTargetResolve$4(subpath, value, packageRoot, patternMatch);
                        if (_1_0 != null) return _1_0;
                    }
                    return _null;
                }
                t1 = type$.List_dynamic._is(exports);
                if (t1 && J.get$length$asx(exports) <= 0) return _null;
                array = t1 ? exports : _null;
                if (t1) {
                    for(t1 = J.get$iterator$ax(array); t1.moveNext$0();){
                        value = t1.get$current(t1);
                        if (value == null) continue;
                        _2_0 = this._packageTargetResolve$4(subpath, value, packageRoot, patternMatch);
                        if (_2_0 != null) return _2_0;
                    }
                    return _null;
                }
                throw A.wrapException("Invalid 'exports' value " + A.S(exports) + " in " + A.join(packageRoot, "package.json", _null) + ".");
            },
            _packageTargetResolve$3: function(subpath, exports, packageRoot) {
                return this._packageTargetResolve$4(subpath, exports, packageRoot, null);
            },
            _getMainExport$1: function(exports) {
                var t1, t2, t3, map, _0_4, t4, $export;
                $label0$0: {
                    t1 = null;
                    if (typeof exports == "string") {
                        t1 = exports;
                        break $label0$0;
                    }
                    if (type$.List_String._is(exports)) {
                        t1 = exports;
                        break $label0$0;
                    }
                    t2 = type$.Map_String_dynamic._is(exports);
                    if (t2) {
                        t3 = exports.get$keys(exports);
                        t3 = !t3.any$1(t3, new A.NodePackageImporter__getMainExport_closure());
                        map = exports;
                    } else {
                        map = t1;
                        t3 = false;
                    }
                    if (t3) {
                        t1 = map;
                        break $label0$0;
                    }
                    t3 = false;
                    if (t2) {
                        _0_4 = exports.$index(0, ".");
                        if (_0_4 == null) t4 = exports.containsKey$1(".");
                        else t4 = true;
                        if (t4) t3 = _0_4 != null;
                    } else _0_4 = null;
                    if (t3) {
                        $export = t2 ? _0_4 : exports.$index(0, ".");
                        t1 = $export;
                        break $label0$0;
                    }
                    break $label0$0;
                }
                return t1;
            },
            _exportsToCheck$2$addIndex: function(subpath, addIndex) {
                var basename, dirname, t3, t4, _i, path, t1 = type$.JSArray_String, paths = A._setArrayType([], t1), t2 = subpath == null;
                if (t2 && addIndex) subpath = "index";
                else if (!t2 && addIndex) subpath = A.join(subpath, "index", null);
                if (subpath == null) return A._setArrayType([
                    null
                ], type$.JSArray_nullable_String);
                if (B.Set_FTDN4.contains$1(0, A.ParsedPath_ParsedPath$parse(subpath, $.$get$url().style)._splitExtension$1(1)[1])) paths.push(subpath);
                else B.JSArray_methods.addAll$1(paths, A._setArrayType([
                    subpath,
                    subpath + ".scss",
                    subpath + ".sass",
                    subpath + ".css"
                ], t1));
                t1 = $.$get$context();
                t2 = t1.style;
                basename = A.ParsedPath_ParsedPath$parse(subpath, t2).get$basename();
                dirname = t1.dirname$1(subpath);
                if (B.JSString_methods.startsWith$1(basename, "_")) return paths;
                t1 = A.List_List$_of(paths, type$.nullable_String);
                for(t3 = paths.length, t4 = dirname === ".", _i = 0; _i < paths.length; paths.length === t3 || (0, A.throwConcurrentModificationError)(paths), ++_i){
                    path = paths[_i];
                    if (t4) t1.push("_" + A.ParsedPath_ParsedPath$parse(path, t2).get$basename());
                    else t1.push(A.join(dirname, "_" + A.ParsedPath_ParsedPath$parse(path, t2).get$basename(), null));
                }
                return t1;
            },
            _exportsToCheck$1: function(subpath) {
                return this._exportsToCheck$2$addIndex(subpath, false);
            }
        };
        A.NodePackageImporter__nodePackageExportsResolve_closure.prototype = {
            call$1: function(key) {
                return B.JSString_methods.startsWith$1(key, ".");
            },
            $signature: 4
        };
        A.NodePackageImporter__nodePackageExportsResolve_closure0.prototype = {
            call$1: function(key) {
                return !B.JSString_methods.startsWith$1(key, ".");
            },
            $signature: 4
        };
        A.NodePackageImporter__nodePackageExportsResolve_closure1.prototype = {
            call$1: function(key) {
                return '"' + key + '"';
            },
            $signature: 6
        };
        A.NodePackageImporter__nodePackageExportsResolve_closure2.prototype = {
            call$1: function(variant) {
                var t1, t2, matchKey, t3, t4, t5, _i, expansionKey, _0_0, t6, patternBase, patternTrailer, t7, target, _this = this, _null = null;
                if (variant == null) {
                    t1 = _this.$this;
                    return A.NullableExtension_andThen(t1._getMainExport$1(_this.exports), new A.NodePackageImporter__nodePackageExportsResolve__closure(t1, variant, _this.packageRoot));
                } else {
                    t1 = _this.exports;
                    if (type$.Map_String_dynamic._is(t1)) {
                        t2 = t1.get$keys(t1);
                        t2 = t2.every$1(t2, new A.NodePackageImporter__nodePackageExportsResolve__closure0());
                    } else t2 = true;
                    if (t2) return _null;
                }
                matchKey = "./" + $.$get$context().toUri$1(variant).toString$0(0);
                if (t1.containsKey$1(matchKey) && t1.$index(0, matchKey) != null && !B.JSString_methods.contains$1(matchKey, "*")) {
                    t1 = t1.$index(0, matchKey);
                    if (t1 == null) t1 = A._asObject(t1);
                    return _this.$this._packageTargetResolve$3(matchKey, t1, _this.packageRoot);
                }
                t2 = A._setArrayType([], type$.JSArray_String);
                for(t3 = t1.get$keys(t1), t3 = t3.get$iterator(t3); t3.moveNext$0();){
                    t4 = t3.get$current(t3);
                    if (B.JSString_methods.allMatches$1("*", t4).get$length(0) === 1) t2.push(t4);
                }
                t3 = _this.$this;
                B.JSArray_methods.sort$1(t2, t3.get$_compareExpansionKeys());
                for(t4 = t2.length, t5 = matchKey.length, _i = 0; _i < t2.length; t2.length === t4 || (0, A.throwConcurrentModificationError)(t2), ++_i){
                    expansionKey = t2[_i];
                    _0_0 = expansionKey.split("*");
                    t6 = _0_0.length === 2;
                    if (t6) {
                        patternBase = _0_0[0];
                        patternTrailer = _0_0[1];
                    } else {
                        patternTrailer = _null;
                        patternBase = patternTrailer;
                    }
                    if (!t6) throw A.wrapException(A.StateError$("Pattern matching error"));
                    if (!B.JSString_methods.startsWith$1(matchKey, patternBase)) continue;
                    if (matchKey === patternBase) continue;
                    t6 = patternTrailer.length;
                    if (t6 !== 0) t7 = B.JSString_methods.endsWith$1(matchKey, patternTrailer) && t5 >= expansionKey.length;
                    else t7 = true;
                    if (t7) {
                        target = t1.$index(0, expansionKey);
                        if (target == null) continue;
                        return t3._packageTargetResolve$4(variant, target, _this.packageRoot, B.JSString_methods.substring$2(matchKey, patternBase.length, t5 - t6));
                    }
                }
                return _null;
            },
            $signature: 146
        };
        A.NodePackageImporter__nodePackageExportsResolve__closure.prototype = {
            call$1: function(mainExport) {
                return this.$this._packageTargetResolve$3(this.variant, mainExport, this.packageRoot);
            },
            $signature: 147
        };
        A.NodePackageImporter__nodePackageExportsResolve__closure0.prototype = {
            call$1: function(key) {
                return !B.JSString_methods.startsWith$1(key, ".");
            },
            $signature: 4
        };
        A.NodePackageImporter__getMainExport_closure.prototype = {
            call$1: function(key) {
                return B.JSString_methods.startsWith$1(key, ".");
            },
            $signature: 4
        };
        A.ImporterResult.prototype = {
            get$sourceMapUrl: function(_) {
                return this._sourceMapUrl;
            }
        };
        A.resolveImportPath_closure.prototype = {
            call$0: function() {
                return A._exactlyOne(A._tryPath($.$get$context().withoutExtension$1(this.path) + ".import" + this.extension));
            },
            $signature: 47
        };
        A.resolveImportPath_closure0.prototype = {
            call$0: function() {
                return A._exactlyOne(A._tryPathWithExtensions(this.path + ".import"));
            },
            $signature: 47
        };
        A._tryPathAsDirectory_closure.prototype = {
            call$0: function() {
                return A._exactlyOne(A._tryPathWithExtensions(A.join(this.path, "index.import", null)));
            },
            $signature: 47
        };
        A._exactlyOne_closure.prototype = {
            call$1: function(path) {
                var t1 = $.$get$context();
                return "  " + t1.prettyUri$1(t1.toUri$1(path));
            },
            $signature: 6
        };
        A.InterpolationBuffer.prototype = {
            writeCharCode$1: function(character) {
                var t1 = this._interpolation_buffer$_text, t2 = A.Primitives_stringFromCharCode(character);
                t1._contents += t2;
                return null;
            },
            add$2: function(_, expression, span) {
                this._flushText$0();
                this._interpolation_buffer$_contents.push(expression);
                this._spans.push(span);
            },
            addInterpolation$1: function(interpolation) {
                var spansToAdd, _0_4_isSet, _0_4, first, rest, t2, t3, _this = this, toAdd = interpolation.contents, t1 = toAdd.length;
                if (t1 === 0) return;
                spansToAdd = interpolation.spans;
                _0_4_isSet = t1 >= 1;
                if (_0_4_isSet) {
                    _0_4 = toAdd[0];
                    t1 = typeof _0_4 == "string";
                } else {
                    _0_4 = null;
                    t1 = false;
                }
                if (t1) {
                    first = A._asString(_0_4_isSet ? _0_4 : toAdd[0]);
                    rest = B.JSArray_methods.sublist$1(toAdd, 1);
                    t1 = _this._interpolation_buffer$_text;
                    t1._contents += first;
                    spansToAdd = A.SubListIterable$(spansToAdd, 1, null, A._arrayInstanceType(spansToAdd)._precomputed1);
                    toAdd = rest;
                }
                _this._flushText$0();
                t1 = _this._interpolation_buffer$_contents;
                B.JSArray_methods.addAll$1(t1, toAdd);
                t2 = _this._spans;
                B.JSArray_methods.addAll$1(t2, spansToAdd);
                if (typeof B.JSArray_methods.get$last(t1) == "string") {
                    t3 = _this._interpolation_buffer$_text;
                    t1 = A.S(t1.pop());
                    t3._contents += t1;
                    t2.pop();
                }
            },
            _flushText$0: function() {
                var t1 = this._interpolation_buffer$_text, t2 = t1._contents;
                if (t2.length === 0) return;
                this._interpolation_buffer$_contents.push(t2.charCodeAt(0) == 0 ? t2 : t2);
                this._spans.push(null);
                t1._contents = "";
            },
            interpolation$1: function(span) {
                var t1 = A.List_List$_of(this._interpolation_buffer$_contents, type$.Object), t2 = this._interpolation_buffer$_text, t3 = t2._contents;
                if (t3.length !== 0) t1.push(t3.charCodeAt(0) == 0 ? t3 : t3);
                t3 = A.List_List$_of(this._spans, type$.nullable_FileSpan);
                if (t2._contents.length !== 0) t3.push(null);
                return A.Interpolation$(t1, t3, span);
            },
            toString$0: function(_) {
                var t1, t2, _i, t3, element;
                for(t1 = this._interpolation_buffer$_contents, t2 = t1.length, _i = 0, t3 = ""; _i < t1.length; t1.length === t2 || (0, A.throwConcurrentModificationError)(t1), ++_i){
                    element = t1[_i];
                    t3 = typeof element == "string" ? t3 + element : t3 + "#{" + A.S(element) + A.Primitives_stringFromCharCode(125);
                }
                t1 = t3 + this._interpolation_buffer$_text.toString$0(0);
                return t1.charCodeAt(0) == 0 ? t1 : t1;
            }
        };
        A.InterpolationMap.prototype = {
            mapException$1: function(error) {
                var source, startIndex, endIndex, t3, t4, _this = this, target = error.get$span(error), t1 = _this._interpolation, t2 = t1.contents;
                if (t2.length === 0) {
                    if (_this._isMapped$1(target)) return error;
                    return new A.SourceSpanFormatException(error.get$source(), error._span_exception$_message, t1.span);
                }
                source = _this.mapSpan$1(target);
                if (source === target) return error;
                startIndex = _this._indexInContents$1(target.get$start(target));
                endIndex = _this._indexInContents$1(target.get$end(target));
                t1 = error._span_exception$_message;
                if (!A.SubListIterable$(t2, startIndex, null, A._arrayInstanceType(t2)._precomputed1).take$1(0, endIndex - startIndex + 1).any$1(0, new A.InterpolationMap_mapException_closure())) return new A.SourceSpanFormatException(error.get$source(), t1, source);
                else {
                    t2 = type$.SourceSpan;
                    t3 = type$.String;
                    t4 = A.LinkedHashMap_LinkedHashMap$_literal([
                        target,
                        "error in interpolated output"
                    ], t2, t3);
                    return new A.MultiSourceSpanFormatException(error.get$source(), "", A.ConstantMap_ConstantMap$from(t4, t2, t3), t1, source);
                }
            },
            mapSpan$1: function(target) {
                var _0_1, _0_2, t1, _0_2_isSet, t2, start, _0_20, end, _this = this, _null = null;
                if (_this._isMapped$1(target)) return target;
                _0_1 = _this._mapLocation$1(target.get$start(target));
                _0_2 = _this._mapLocation$1(target.get$end(target));
                $label0$0: {
                    t1 = type$.FileSpan;
                    _0_2_isSet = t1._is(_0_1);
                    t2 = false;
                    if (_0_2_isSet) {
                        t2 = t1._is(_0_2);
                        start = _0_1;
                        _0_20 = _0_2;
                    } else {
                        start = _null;
                        _0_20 = start;
                    }
                    if (t2) {
                        t1 = start.expand$1(0, t1._as(_0_2_isSet ? _0_20 : _0_2));
                        break $label0$0;
                    }
                    t2 = false;
                    if (t1._is(_0_1)) {
                        if (_0_2_isSet) t2 = _0_20;
                        else {
                            t2 = _0_2;
                            _0_20 = t2;
                            _0_2_isSet = true;
                        }
                        t2 = t2 instanceof A.FileLocation;
                        start = _0_1;
                    } else start = _null;
                    if (t2) {
                        t1 = _0_2_isSet ? _0_20 : _0_2;
                        type$.FileLocation._as(t1);
                        t2 = _this._interpolation.span;
                        t1 = t2.get$file(t2).span$2(0, _this._expandInterpolationSpanLeft$1(start.get$start(start)), t1.offset);
                        break $label0$0;
                    }
                    t2 = false;
                    if (_0_1 instanceof A.FileLocation) {
                        if (_0_2_isSet) t2 = _0_20;
                        else {
                            t2 = _0_2;
                            _0_20 = t2;
                            _0_2_isSet = true;
                        }
                        t2 = t1._is(t2);
                        start = _0_1;
                    } else start = _null;
                    if (t2) {
                        end = t1._as(_0_2_isSet ? _0_20 : _0_2);
                        t1 = _this._interpolation.span;
                        t1 = t1.get$file(t1).span$2(0, start.offset, _this._expandInterpolationSpanRight$1(end.get$end(end)));
                        break $label0$0;
                    }
                    t1 = false;
                    if (_0_1 instanceof A.FileLocation) {
                        if (_0_2_isSet) t1 = _0_20;
                        else {
                            t1 = _0_2;
                            _0_20 = t1;
                            _0_2_isSet = true;
                        }
                        t1 = t1 instanceof A.FileLocation;
                        start = _0_1;
                    } else start = _null;
                    if (t1) {
                        t1 = _0_2_isSet ? _0_20 : _0_2;
                        type$.FileLocation._as(t1);
                        t2 = _this._interpolation.span;
                        t1 = t2.get$file(t2).span$2(0, start.offset, t1.offset);
                        break $label0$0;
                    }
                    t1 = A.throwExpression("[BUG] Unreachable");
                }
                return t1;
            },
            _isMapped$1: function(span) {
                var file, t1;
                $label0$0: {
                    file = span.get$file(span);
                    t1 = this._interpolation.span;
                    t1 = t1.get$file(t1);
                    break $label0$0;
                }
                return file === t1;
            },
            _mapLocation$1: function(target) {
                var index, _0_0, t3, previousLocation, _this = this, t1 = _this._interpolation, t2 = t1.contents;
                if (t2.length === 0) return t1.span;
                index = _this._indexInContents$1(target);
                _0_0 = t2[index];
                if (_0_0 instanceof A.Expression) return _0_0.get$span(_0_0);
                t3 = index === 0;
                t1 = t1.span;
                if (t3) previousLocation = t1.get$start(t1);
                else {
                    t1 = t1.get$file(t1);
                    t2 = type$.Expression._as(t2[index - 1]);
                    t2 = t2.get$span(t2);
                    previousLocation = A.FileLocation$_(t1, _this._expandInterpolationSpanRight$1(t2.get$end(t2)));
                }
                t1 = t3 ? 0 : _this._targetOffsets[index - 1];
                return A.FileLocation$_(previousLocation.file, previousLocation.offset + (target.offset - t1));
            },
            _indexInContents$1: function(target) {
                var t1, t2, t3, i;
                for(t1 = this._targetOffsets, t2 = t1.length, t3 = target.offset, i = 0; i < t2; ++i)if (t3 < t1[i]) return i;
                return this._interpolation.contents.length - 1;
            },
            _expandInterpolationSpanLeft$1: function(start) {
                var i0, prev, char, source = start.file._decodedChars, i = start.offset - 1;
                while(i >= 0){
                    i0 = i - 1;
                    prev = source[i];
                    if (prev === 123) {
                        if (source[i0] === 35) {
                            i = i0;
                            break;
                        }
                        i = i0;
                    } else if (prev === 47) {
                        i = i0 - 1;
                        if (source[i0] === 42) for(;;){
                            i0 = i - 1;
                            if (source[i] !== 42) {
                                i = i0;
                                continue;
                            }
                            i = i0;
                            do {
                                i0 = i - 1;
                                char = source[i];
                                if (char === 42) {
                                    i = i0;
                                    continue;
                                } else break;
                            }while (true);
                            if (char === 47) {
                                i = i0;
                                break;
                            }
                            i = i0;
                        }
                    } else i = i0;
                }
                return i;
            },
            _expandInterpolationSpanRight$1: function(end) {
                var t1, i0, next, second, t2, char, source = end.file._decodedChars, i = end.offset;
                for(t1 = source.length; i < t1;){
                    i0 = i + 1;
                    next = source[i];
                    if (next === 125) {
                        i = i0;
                        break;
                    }
                    if (next === 47) {
                        i = i0 + 1;
                        second = source[i0];
                        if (second === 47) {
                            for(;;){
                                i0 = i + 1;
                                t2 = source[i];
                                if (!!(t2 === 10 || t2 === 13 || t2 === 12)) break;
                                i = i0;
                            }
                            i = i0;
                        } else if (second === 42) for(;;){
                            i0 = i + 1;
                            if (source[i] !== 42) {
                                i = i0;
                                continue;
                            }
                            i = i0;
                            do {
                                i0 = i + 1;
                                char = source[i];
                                if (char === 42) {
                                    i = i0;
                                    continue;
                                } else break;
                            }while (true);
                            if (char === 47) {
                                i = i0;
                                break;
                            }
                            i = i0;
                        }
                    } else i = i0;
                }
                return i;
            }
        };
        A.InterpolationMap_mapException_closure.prototype = {
            call$1: function($content) {
                return $content instanceof A.Expression;
            },
            $signature: 73
        };
        A._realCasePath_helper.prototype = {
            call$2: function(path, realPath) {
                var dirname = $.$get$context().dirname$1(path);
                if (dirname === path) return path;
                return $._realCaseCache.putIfAbsent$2(path, new A._realCasePath_helper_closure(path, realPath, this, dirname));
            },
            call$1: function(path) {
                return this.call$2(path, null);
            },
            $signature: 149
        };
        A._realCasePath_helper_closure.prototype = {
            call$0: function() {
                var realPathNonNull, realDirname, basename, matches, t1, _0_0, match, realPathNonNull0, _$exception, _this = this, t2 = _this.path;
                if (!A.linkExists(t2)) {
                    realPathNonNull = null;
                    try {
                        realPathNonNull0 = _this.realPath;
                        realPathNonNull = realPathNonNull0 == null ? A.realpath(t2) : realPathNonNull0;
                    } catch (exception) {
                        if (A.unwrapException(exception) instanceof A.FileSystemException) return t2;
                        else throw exception;
                    }
                    t1 = realPathNonNull;
                    t2 = $.$get$context();
                    return A.join(_this.helper.call$2(_this.dirname, t2.dirname$1(t1)), A.ParsedPath_ParsedPath$parse(realPathNonNull, t2.style).get$basename(), null);
                }
                realDirname = _this.helper.call$1(_this.dirname);
                basename = A.ParsedPath_ParsedPath$parse(t2, $.$get$context().style).get$basename();
                try {
                    matches = J.where$1$ax(A.listDir(realDirname, false), new A._realCasePath_helper__closure(basename)).toList$0(0);
                    t1 = null;
                    _0_0 = matches;
                    $label0$0: {
                        match = null;
                        if (J.get$length$asx(_0_0) === 1) {
                            match = J.$index$asx(_0_0, 0);
                            t1 = match;
                            break $label0$0;
                        }
                        t1 = A.join(realDirname, basename, null);
                        break $label0$0;
                    }
                    t1;
                    return t1;
                } catch (exception) {
                    if (A.unwrapException(exception) instanceof A.FileSystemException) return t2;
                    else throw exception;
                }
            },
            $signature: 29
        };
        A._realCasePath_helper__closure.prototype = {
            call$1: function(realPath) {
                return A.equalsIgnoreCase(A.ParsedPath_ParsedPath$parse(realPath, $.$get$context().style).get$basename(), this.basename);
            },
            $signature: 4
        };
        A.FileSystemException.prototype = {
            toString$0: function(_) {
                var t1 = $.$get$context();
                return t1.prettyUri$1(t1.toUri$1(this.path)) + ": " + this.message;
            },
            get$message: function(receiver) {
                return this.message;
            }
        };
        A._readFile_closure.prototype = {
            call$0: function() {
                return J.readFileSync$2$x(A.fs(), this.path, this.encoding);
            },
            $signature: 64
        };
        A.writeFile_closure.prototype = {
            call$0: function() {
                return J.writeFileSync$2$x(A.fs(), this.path, this.contents);
            },
            $signature: 0
        };
        A.deleteFile_closure.prototype = {
            call$0: function() {
                return J.unlinkSync$1$x(A.fs(), this.path);
            },
            $signature: 0
        };
        A.readStdin_closure.prototype = {
            call$1: function(result) {
                this._box_0.contents = result;
                this.completer.complete$1(result);
            },
            $signature: 90
        };
        A.readStdin_closure0.prototype = {
            call$1: function(chunk) {
                this.sink.add$1(0, type$.List_int._as(chunk));
            },
            call$0: function() {
                return this.call$1(null);
            },
            "call*": "call$1",
            $requiredArgCount: 0,
            $defaultValues: function() {
                return [
                    null
                ];
            },
            $signature: 84
        };
        A.readStdin_closure1.prototype = {
            call$1: function(arg) {
                this.sink.close$0(0);
            },
            call$0: function() {
                return this.call$1(null);
            },
            "call*": "call$1",
            $requiredArgCount: 0,
            $defaultValues: function() {
                return [
                    null
                ];
            },
            $signature: 84
        };
        A.readStdin_closure2.prototype = {
            call$1: function(e) {
                A.printError("Failed to read from stdin");
                A.printError(e);
                e.toString;
                this.completer.completeError$1(e);
            },
            call$0: function() {
                return this.call$1(null);
            },
            "call*": "call$1",
            $requiredArgCount: 0,
            $defaultValues: function() {
                return [
                    null
                ];
            },
            $signature: 84
        };
        A.fileExists_closure.prototype = {
            call$0: function() {
                var error, systemError, _$exception, t1 = this.path;
                if (!J.existsSync$1$x(A.fs(), t1)) return false;
                try {
                    t1 = J.isFile$0$x(J.statSync$1$x(A.fs(), t1));
                    return t1;
                } catch (exception) {
                    error = A.unwrapException(exception);
                    systemError = type$.JsSystemError._as(error);
                    if (J.$eq$(J.get$code$x(systemError), "ENOENT")) return false;
                    throw exception;
                }
            },
            $signature: 20
        };
        A.dirExists_closure.prototype = {
            call$0: function() {
                var error, systemError, _$exception, t1 = this.path;
                if (!J.existsSync$1$x(A.fs(), t1)) return false;
                try {
                    t1 = J.isDirectory$0$x(J.statSync$1$x(A.fs(), t1));
                    return t1;
                } catch (exception) {
                    error = A.unwrapException(exception);
                    systemError = type$.JsSystemError._as(error);
                    if (J.$eq$(J.get$code$x(systemError), "ENOENT")) return false;
                    throw exception;
                }
            },
            $signature: 20
        };
        A.linkExists_closure.prototype = {
            call$0: function() {
                var error, systemError, t1, _$exception;
                try {
                    t1 = J.isSymbolicLink$0$x(J.lstatSync$1$x(A.fs(), this.path));
                    return t1;
                } catch (exception) {
                    error = A.unwrapException(exception);
                    systemError = type$.JsSystemError._as(error);
                    if (J.$eq$(J.get$code$x(systemError), "ENOENT")) return false;
                    throw exception;
                }
            },
            $signature: 20
        };
        A.ensureDir_closure.prototype = {
            call$0: function() {
                var error, systemError, _$exception, t1;
                try {
                    J.mkdirSync$1$x(A.fs(), this.path);
                } catch (exception) {
                    error = A.unwrapException(exception);
                    systemError = type$.JsSystemError._as(error);
                    if (J.$eq$(J.get$code$x(systemError), "EEXIST")) return;
                    if (!J.$eq$(J.get$code$x(systemError), "ENOENT")) throw exception;
                    t1 = this.path;
                    A.ensureDir($.$get$context().dirname$1(t1));
                    J.mkdirSync$1$x(A.fs(), t1);
                }
            },
            $signature: 0
        };
        A.listDir_closure.prototype = {
            call$0: function() {
                var t1 = this.path;
                if (!this.recursive) return J.map$1$1$ax(J.readdirSync$1$x(A.fs(), t1), new A.listDir__closure(t1), type$.String).super$Iterable$where(0, new A.listDir__closure0());
                else return new A.listDir_closure_list().call$1(t1);
            },
            $signature: 152
        };
        A.listDir__closure.prototype = {
            call$1: function(child) {
                return A.join(this.path, A._asString(child), null);
            },
            $signature: 134
        };
        A.listDir__closure0.prototype = {
            call$1: function(child) {
                return !A.dirExists(child);
            },
            $signature: 4
        };
        A.listDir_closure_list.prototype = {
            call$1: function($parent) {
                return J.expand$1$1$ax(J.readdirSync$1$x(A.fs(), $parent), new A.listDir__list_closure($parent, this), type$.String);
            },
            $signature: 153
        };
        A.listDir__list_closure.prototype = {
            call$1: function(child) {
                var path = A.join(this.parent, A._asString(child), null);
                return A.dirExists(path) ? this.list.call$1(path) : A._setArrayType([
                    path
                ], type$.JSArray_String);
            },
            $signature: 154
        };
        A.realpath_closure.prototype = {
            call$0: function() {
                return J.native$1$x(J.get$realpathSync$x(A.fs()), this.path);
            },
            $signature: 29
        };
        A.modificationTime_closure.prototype = {
            call$0: function() {
                return A.DateTime$fromMillisecondsSinceEpoch(J.getTime$0$x(J.get$mtime$x(J.statSync$1$x(A.fs(), this.path))));
            },
            $signature: 155
        };
        A.watchDir_closure0.prototype = {
            call$2: function(error, events) {
                var t1, t2, t3, t4, t5, lastEvent;
                if (error != null) {
                    t1 = this._box_0.controller;
                    if (t1 != null) t1.addError$1(error);
                } else for(t1 = J.get$iterator$ax(events), t2 = this._box_0; t1.moveNext$0();){
                    t3 = t1.get$current(t1);
                    switch(t3.type){
                        case "create":
                            t4 = t2.controller;
                            if (t4 != null) {
                                t3 = new A.WatchEvent(B.ChangeType_add, t3.path);
                                t5 = t4._state;
                                if (t5 >= 4) A.throwExpression(t4._badEventState$0());
                                if ((t5 & 1) !== 0) t4._sendData$1(t3);
                                else if ((t5 & 3) === 0) {
                                    t4 = t4._ensurePendingEvents$0();
                                    t3 = new A._DelayedData(t3);
                                    lastEvent = t4.lastPendingEvent;
                                    if (lastEvent == null) t4.firstPendingEvent = t4.lastPendingEvent = t3;
                                    else {
                                        lastEvent.set$next(t3);
                                        t4.lastPendingEvent = t3;
                                    }
                                }
                            }
                            break;
                        case "update":
                            t4 = t2.controller;
                            if (t4 != null) {
                                t3 = new A.WatchEvent(B.ChangeType_modify, t3.path);
                                t5 = t4._state;
                                if (t5 >= 4) A.throwExpression(t4._badEventState$0());
                                if ((t5 & 1) !== 0) t4._sendData$1(t3);
                                else if ((t5 & 3) === 0) {
                                    t4 = t4._ensurePendingEvents$0();
                                    t3 = new A._DelayedData(t3);
                                    lastEvent = t4.lastPendingEvent;
                                    if (lastEvent == null) t4.firstPendingEvent = t4.lastPendingEvent = t3;
                                    else {
                                        lastEvent.set$next(t3);
                                        t4.lastPendingEvent = t3;
                                    }
                                }
                            }
                            break;
                        case "delete":
                            t4 = t2.controller;
                            if (t4 != null) {
                                t3 = new A.WatchEvent(B.ChangeType_remove, t3.path);
                                t5 = t4._state;
                                if (t5 >= 4) A.throwExpression(t4._badEventState$0());
                                if ((t5 & 1) !== 0) t4._sendData$1(t3);
                                else if ((t5 & 3) === 0) {
                                    t4 = t4._ensurePendingEvents$0();
                                    t3 = new A._DelayedData(t3);
                                    lastEvent = t4.lastPendingEvent;
                                    if (lastEvent == null) t4.firstPendingEvent = t4.lastPendingEvent = t3;
                                    else {
                                        lastEvent.set$next(t3);
                                        t4.lastPendingEvent = t3;
                                    }
                                }
                            }
                            break;
                    }
                }
            },
            $signature: 344
        };
        A.watchDir_closure.prototype = {
            call$0: function() {
                this.subscription.unsubscribe();
            },
            $signature: 1
        };
        A.watchDir_closure1.prototype = {
            call$2: function(path, _) {
                var t1 = this._box_0.controller;
                return t1 == null ? null : t1.add$1(0, new A.WatchEvent(B.ChangeType_add, path));
            },
            call$1: function(path) {
                return this.call$2(path, null);
            },
            "call*": "call$2",
            $requiredArgCount: 1,
            $defaultValues: function() {
                return [
                    null
                ];
            },
            $signature: 156
        };
        A.watchDir_closure2.prototype = {
            call$2: function(path, _) {
                var t1 = this._box_0.controller;
                return t1 == null ? null : t1.add$1(0, new A.WatchEvent(B.ChangeType_modify, path));
            },
            call$1: function(path) {
                return this.call$2(path, null);
            },
            "call*": "call$2",
            $requiredArgCount: 1,
            $defaultValues: function() {
                return [
                    null
                ];
            },
            $signature: 156
        };
        A.watchDir_closure3.prototype = {
            call$1: function(path) {
                var t1 = this._box_0.controller;
                return t1 == null ? null : t1.add$1(0, new A.WatchEvent(B.ChangeType_remove, path));
            },
            $signature: 90
        };
        A.watchDir_closure4.prototype = {
            call$1: function(error) {
                var t1 = this._box_0.controller;
                return t1 == null ? null : t1.addError$1(error);
            },
            $signature: 97
        };
        A.watchDir_closure5.prototype = {
            call$0: function() {
                var controller = A.StreamController_StreamController(new A.watchDir__closure(this.watcher), null, null, null, false, type$.WatchEvent);
                this._box_0.controller = controller;
                this.completer.complete$1(new A._ControllerStream(controller, A._instanceType(controller)._eval$1("_ControllerStream<1>")));
            },
            $signature: 1
        };
        A.watchDir__closure.prototype = {
            call$0: function() {
                J.close$0$x(this.watcher);
            },
            $signature: 1
        };
        A.JSArray0.prototype = {};
        A.Chokidar.prototype = {};
        A.ChokidarOptions.prototype = {};
        A.ChokidarWatcher.prototype = {};
        A.JSFunction.prototype = {};
        A.ImmutableList.prototype = {};
        A.ImmutableMap.prototype = {};
        A.NodeImporterResult.prototype = {};
        A.RenderContext.prototype = {};
        A.RenderContextOptions.prototype = {};
        A.RenderContextResult.prototype = {};
        A.RenderContextResultStats.prototype = {};
        A.JSModule.prototype = {};
        A.JSModuleRequire.prototype = {};
        A.ParcelWatcher_subscribe_closure.prototype = {
            call$2: function(error, events) {
                var t1 = type$.List_JSObject._is(events) ? events : new A.CastList(events, A._arrayInstanceType(events)._eval$1("CastList<1,JSObject>"));
                this.callback.call$2(error, t1);
            },
            $signature: 385
        };
        A.JSClass.prototype = {};
        A.JSUrl.prototype = {};
        A._PropertyDescriptor.prototype = {};
        A._RequireMain.prototype = {};
        A.LoggerWithDeprecationType.prototype = {
            warn$4$deprecation$span$trace: function(_, message, deprecation, span, trace) {
                this.internalWarn$4$deprecation$span$trace(message, deprecation ? B.Deprecation_gGh : null, span, trace);
            },
            warn$1: function(_, message) {
                return this.warn$4$deprecation$span$trace(0, message, false, null, null);
            },
            warn$3$span$trace: function(_, message, span, trace) {
                return this.warn$4$deprecation$span$trace(0, message, false, span, trace);
            }
        };
        A._QuietLogger.prototype = {
            warn$4$deprecation$span$trace: function(_, message, deprecation, span, trace) {},
            warn$1: function(_, message) {
                return this.warn$4$deprecation$span$trace(0, message, false, null, null);
            },
            warn$3$span$trace: function(_, message, span, trace) {
                return this.warn$4$deprecation$span$trace(0, message, false, span, trace);
            },
            debug$2: function(_, message, span) {}
        };
        A.DefaultLogger.prototype = {
            get$_default$_inner: function() {
                var t1 = $._default;
                if (t1 == null) t1 = $._default = new A.StderrLogger(A.hasTerminal() || A.isBrowser());
                return t1;
            },
            internalWarn$4$deprecation$span$trace: function(message, deprecation, span, trace) {
                return this.get$_default$_inner().internalWarn$4$deprecation$span$trace(message, deprecation, span, trace);
            },
            debug$2: function(_, message, span) {
                return this.get$_default$_inner().debug$2(0, message, span);
            }
        };
        A.DeprecationProcessingLogger.prototype = {
            validate$0: function() {
                var t1, t2, t3, $self, t4, t5, _this = this, _null = null;
                for(t1 = _this.fatalDeprecations, t1 = t1.get$iterator(t1), t2 = _this.silenceDeprecations; t1.moveNext$0();){
                    t3 = t1.get$current(t1);
                    $self = t3._obsoleteIn;
                    if ($self == null) t4 = _null;
                    else t4 = A.Version___parse_tearOff($self);
                    if (t4 instanceof A.Version) {
                        t3 = t3.toString$0(0);
                        _this.internalWarn$4$deprecation$span$trace(t3 + string$.x20deprex20ix2c, _null, _null, _null);
                        continue;
                    }
                    t4 = t2.contains$1(0, t3);
                    if (t4) {
                        t3 = t3.toString$0(0);
                        _this.internalWarn$4$deprecation$span$trace("Ignoring setting to silence " + t3 + string$.x20deprex2c, _null, _null, _null);
                        continue;
                    }
                }
                for(t1 = A._LinkedHashSetIterator$(t2, t2._collection$_modifications, A._instanceType(t2)._precomputed1), t2 = t1.$ti._precomputed1, t3 = _this.futureDeprecations; t1.moveNext$0();){
                    t4 = t1._collection$_current;
                    if (t4 == null) t4 = t2._as(t4);
                    if (B.Deprecation_gGh === t4) {
                        _this.internalWarn$4$deprecation$span$trace(string$.User_a, _null, _null, _null);
                        continue;
                    }
                    $self = t4._obsoleteIn;
                    if ($self == null) t5 = _null;
                    else t5 = A.Version___parse_tearOff($self);
                    if (t5 instanceof A.Version) {
                        t4 = t4.toString$0(0);
                        _this.internalWarn$4$deprecation$span$trace(t4 + string$.x20deprex20ix2e, _null, _null, _null);
                        continue;
                    }
                }
                for(t1 = A._LinkedHashSetIterator$(t3, t3._collection$_modifications, A._instanceType(t3)._precomputed1), t2 = t1.$ti._precomputed1; t1.moveNext$0();){
                    t3 = t1._collection$_current;
                    t3 = (t3 == null ? t2._as(t3) : t3).toString$0(0);
                    _this.internalWarn$4$deprecation$span$trace(t3 + string$.x20is_noaf, _null, _null, _null);
                }
            },
            internalWarn$4$deprecation$span$trace: function(message, deprecation, span, trace) {
                if (deprecation != null) this._handleDeprecation$4$span$trace(deprecation, message, span, trace);
                else this._inner.warn$3$span$trace(0, message, span, trace);
            },
            _handleDeprecation$4$span$trace: function(deprecation, message, span, trace) {
                var _0_3_isSet, t1, span0, _0_3, t2, count, _1_0, _this = this, _null = null;
                if (_this.fatalDeprecations.contains$1(0, deprecation)) {
                    message += string$.x0a_This + deprecation.toString$0(0) + string$.x20deprex20t;
                    $label0$0: {
                        _0_3_isSet = span != null;
                        t1 = false;
                        if (_0_3_isSet) {
                            t1 = trace != null;
                            span0 = span;
                            _0_3 = trace;
                        } else {
                            span0 = _null;
                            _0_3 = span0;
                        }
                        if (t1) {
                            if (_0_3_isSet) trace = _0_3;
                            t1 = A.SassRuntimeException$(message, span0, trace == null ? type$.Trace._as(trace) : trace, _null);
                            break $label0$0;
                        }
                        t1 = false;
                        if (span != null) t1 = (_0_3_isSet ? _0_3 : trace) == null;
                        else span = _null;
                        if (t1) {
                            t1 = A.SassException$(message, span, _null);
                            break $label0$0;
                        }
                        t1 = A.SassScriptException$(message, _null);
                        break $label0$0;
                    }
                    throw A.wrapException(t1);
                }
                if (_this.silenceDeprecations.contains$1(0, deprecation)) return;
                if (_this.limitRepetition) {
                    t1 = _this._warningCounts;
                    t2 = t1.$index(0, deprecation);
                    count = (t2 == null ? 0 : t2) + 1;
                    t1.$indexSet(0, deprecation, count);
                    if (count > 5) return;
                }
                _1_0 = _this._inner;
                if (_1_0 instanceof A.LoggerWithDeprecationType) _1_0.internalWarn$4$deprecation$span$trace(message, deprecation, span, trace);
                else _1_0.warn$4$deprecation$span$trace(0, message, true, span, trace);
            },
            debug$2: function(_, message, span) {
                return this._inner.debug$2(0, message, span);
            },
            summarize$1$js: function(js) {
                var t1 = this._warningCounts, t2 = A._instanceType(t1)._eval$1("LinkedHashMapValuesIterable<2>"), total = A.IterableIntegerExtension_get_sum(new A.MappedIterable(new A.WhereIterable(new A.LinkedHashMapValuesIterable(t1, t2), new A.DeprecationProcessingLogger_summarize_closure(), t2._eval$1("WhereIterable<Iterable.E>")), new A.DeprecationProcessingLogger_summarize_closure0(), t2._eval$1("MappedIterable<Iterable.E,int>")));
                if (total > 0) {
                    t1 = js ? "" : string$.x0aRun_i;
                    this._inner.warn$1(0, "" + total + string$.x20repet + t1);
                }
            }
        };
        A.DeprecationProcessingLogger_summarize_closure.prototype = {
            call$1: function(count) {
                return count > 5;
            },
            $signature: 50
        };
        A.DeprecationProcessingLogger_summarize_closure0.prototype = {
            call$1: function(count) {
                return count - 5;
            },
            $signature: 157
        };
        A.StderrLogger.prototype = {
            internalWarn$4$deprecation$span$trace: function(message, deprecation, span, trace) {
                var t3, result = new A.StringBuffer(""), t1 = deprecation != null, showDeprecation = t1 && deprecation !== B.Deprecation_gGh, t2 = this.color;
                if (t2) {
                    t3 = result._contents = "\x1b[33m\x1b[1m";
                    t3 = result._contents = (t1 ? result._contents = "\x1b[33m\x1b[1mDeprecation " : t3) + "Warning\x1b[0m";
                    if (showDeprecation) {
                        t1 = t3 + (" [\x1b[34m" + deprecation.toString$0(0) + "\x1b[0m]");
                        result._contents = t1;
                    } else t1 = t3;
                } else {
                    t3 = result._contents = (t1 ? result._contents = "DEPRECATION " : "") + "WARNING";
                    if (showDeprecation) {
                        t1 = t3 + (" [" + deprecation.toString$0(0) + "]");
                        result._contents = t1;
                    } else t1 = t3;
                }
                if (span == null) t1 = result._contents = t1 + (": " + message + "\n");
                else if (trace != null) {
                    t1 += ": " + message + "\n\n" + span.highlight$1$color(t2) + "\n";
                    result._contents = t1;
                } else {
                    t1 += " on " + span.message$2$color(0, "\n" + message, t2) + "\n";
                    result._contents = t1;
                }
                if (trace != null) result._contents = t1 + (A.indent(B.JSString_methods.trimRight$0(trace.toString$0(0)), 4) + "\n");
                A.printError(result);
            },
            debug$2: function(_, message, span) {
                var url, t1, t2;
                if (span.get$start(span).file.url == null) url = "-";
                else {
                    t1 = span.get$start(span).file.url;
                    t2 = $.$get$context();
                    t1.toString;
                    url = t2.prettyUri$1(t1);
                }
                t1 = span.get$start(span);
                t1 = t1.file.getLine$1(t1.offset);
                t2 = this.color ? "\x1b[1mDebug\x1b[0m" : "DEBUG";
                t2 = url + ":" + (t1 + 1) + " " + t2 + (": " + message);
                A.printError(t2.charCodeAt(0) == 0 ? t2 : t2);
            }
        };
        A.TrackingLogger.prototype = {
            warn$4$deprecation$span$trace: function(_, message, deprecation, span, trace) {
                this._emittedWarning = true;
                this._tracking$_logger.warn$4$deprecation$span$trace(0, message, deprecation, span, trace);
            },
            warn$1: function(_, message) {
                return this.warn$4$deprecation$span$trace(0, message, false, null, null);
            },
            warn$3$span$trace: function(_, message, span, trace) {
                return this.warn$4$deprecation$span$trace(0, message, false, span, trace);
            },
            debug$2: function(_, message, span) {
                this._emittedDebug = true;
                this._tracking$_logger.debug$2(0, message, span);
            }
        };
        A.BuiltInModule.prototype = {
            get$upstream: function() {
                return B.List_empty7;
            },
            get$variableNodes: function() {
                return B.Map_empty3;
            },
            get$extensionStore: function() {
                return B.C_EmptyExtensionStore;
            },
            get$css: function(_) {
                return new A.CssStylesheet(B.List_empty3, A.SourceFile$decoded(B.List_empty4, this.url).span$2(0, 0, 0));
            },
            get$preModuleComments: function() {
                return B.Map_empty1;
            },
            get$transitivelyContainsCss: function() {
                return false;
            },
            get$transitivelyContainsExtensions: function() {
                return false;
            },
            setVariable$3: function($name, value, nodeWithSpan) {
                if (!this.variables.containsKey$1($name)) throw A.wrapException(A.SassScriptException$("Undefined variable.", null));
                throw A.wrapException(A.SassScriptException$("Cannot modify built-in variable.", null));
            },
            variableIdentity$1: function($name) {
                return this;
            },
            couldHaveBeenConfigured$1: function(_) {
                return false;
            },
            cloneCss$0: function() {
                return this;
            },
            $isModule0: 1,
            get$url: function(receiver) {
                return this.url;
            },
            get$functions: function(receiver) {
                return this.functions;
            },
            get$mixins: function() {
                return this.mixins;
            },
            get$variables: function() {
                return this.variables;
            }
        };
        A.ForwardedModuleView.prototype = {
            get$url: function(_) {
                var t1 = this._forwarded_view$_inner;
                return t1.get$url(t1);
            },
            get$upstream: function() {
                return this._forwarded_view$_inner.get$upstream();
            },
            get$extensionStore: function() {
                return this._forwarded_view$_inner.get$extensionStore();
            },
            get$css: function(_) {
                var t1 = this._forwarded_view$_inner;
                return t1.get$css(t1);
            },
            get$preModuleComments: function() {
                return this._forwarded_view$_inner.get$preModuleComments();
            },
            get$transitivelyContainsCss: function() {
                return this._forwarded_view$_inner.get$transitivelyContainsCss();
            },
            get$transitivelyContainsExtensions: function() {
                return this._forwarded_view$_inner.get$transitivelyContainsExtensions();
            },
            setVariable$3: function($name, value, nodeWithSpan) {
                var t2, _1_0, _2_0, _s19_ = "Undefined variable.", t1 = this._rule, _0_0 = t1.shownVariables;
                if (_0_0 != null) t2 = !_0_0._base.contains$1(0, $name);
                else t2 = false;
                if (t2) throw A.wrapException(A.SassScriptException$(_s19_, null));
                else {
                    _1_0 = t1.hiddenVariables;
                    if (_1_0 != null) t2 = _1_0._base.contains$1(0, $name);
                    else t2 = false;
                    if (t2) throw A.wrapException(A.SassScriptException$(_s19_, null));
                }
                _2_0 = t1.prefix;
                if (_2_0 != null) {
                    if (!B.JSString_methods.startsWith$1($name, _2_0)) throw A.wrapException(A.SassScriptException$(_s19_, null));
                    $name = B.JSString_methods.substring$1($name, _2_0.length);
                }
                return this._forwarded_view$_inner.setVariable$3($name, value, nodeWithSpan);
            },
            variableIdentity$1: function($name) {
                var _0_0 = this._rule.prefix;
                if (_0_0 != null) $name = B.JSString_methods.substring$1($name, _0_0.length);
                return this._forwarded_view$_inner.variableIdentity$1($name);
            },
            couldHaveBeenConfigured$1: function(variables) {
                var t5, t6, _1_0, _2_0, blocklist, _this = this, t1 = _this._rule, t2 = t1.prefix, t3 = t2 == null, t4 = false;
                if (t3) {
                    if (t1.shownVariables == null) {
                        t4 = t1.hiddenVariables;
                        t4 = t4 == null ? null : t4._base.get$isEmpty(0);
                        t4 = t4 !== false;
                    }
                }
                if (t4) return _this._forwarded_view$_inner.couldHaveBeenConfigured$1(variables);
                if (!t3) {
                    t3 = A.LinkedHashSet_LinkedHashSet$_empty(type$.String);
                    for(t4 = variables.get$iterator(variables), t5 = t2.length; t4.moveNext$0();){
                        t6 = t4.get$current(t4);
                        if (B.JSString_methods.startsWith$1(t6, t2)) t3.add$1(0, B.JSString_methods.substring$1(t6, t5));
                    }
                    variables = t3;
                }
                _1_0 = t1.shownVariables;
                if (_1_0 != null) return _this._forwarded_view$_inner.couldHaveBeenConfigured$1(variables.intersection$1(_1_0));
                else {
                    _2_0 = t1.hiddenVariables;
                    if (_2_0 != null) {
                        t1 = _2_0._base.get$isNotEmpty(0);
                        blocklist = _2_0;
                    } else {
                        blocklist = null;
                        t1 = false;
                    }
                    t2 = _this._forwarded_view$_inner;
                    if (t1) return t2.couldHaveBeenConfigured$1(variables.difference$1(blocklist));
                    else return t2.couldHaveBeenConfigured$1(variables);
                }
            },
            $eq: function(_, other) {
                if (other == null) return false;
                return other instanceof A.ForwardedModuleView && this._forwarded_view$_inner.$eq(0, other._forwarded_view$_inner) && this._rule === other._rule;
            },
            get$hashCode: function(_) {
                var t1 = this._forwarded_view$_inner;
                return (t1.get$hashCode(t1) ^ A.Primitives_objectHashCode(this._rule)) >>> 0;
            },
            cloneCss$0: function() {
                return A.ForwardedModuleView$(this._forwarded_view$_inner.cloneCss$0(), this._rule, this.$ti._precomputed1);
            },
            toString$0: function(_) {
                return "forwarded " + this._forwarded_view$_inner.toString$0(0);
            },
            $isModule0: 1,
            get$variables: function() {
                return this.variables;
            },
            get$variableNodes: function() {
                return this.variableNodes;
            },
            get$functions: function(receiver) {
                return this.functions;
            },
            get$mixins: function() {
                return this.mixins;
            }
        };
        A.ShadowedModuleView.prototype = {
            get$url: function(_) {
                var t1 = this._shadowed_view$_inner;
                return t1.get$url(t1);
            },
            get$upstream: function() {
                return this._shadowed_view$_inner.get$upstream();
            },
            get$extensionStore: function() {
                return this._shadowed_view$_inner.get$extensionStore();
            },
            get$css: function(_) {
                var t1 = this._shadowed_view$_inner;
                return t1.get$css(t1);
            },
            get$preModuleComments: function() {
                return this._shadowed_view$_inner.get$preModuleComments();
            },
            get$transitivelyContainsCss: function() {
                return this._shadowed_view$_inner.get$transitivelyContainsCss();
            },
            get$transitivelyContainsExtensions: function() {
                return this._shadowed_view$_inner.get$transitivelyContainsExtensions();
            },
            setVariable$3: function($name, value, nodeWithSpan) {
                if (!this.variables.containsKey$1($name)) throw A.wrapException(A.SassScriptException$("Undefined variable.", null));
                else this._shadowed_view$_inner.setVariable$3($name, value, nodeWithSpan);
            },
            variableIdentity$1: function($name) {
                return this._shadowed_view$_inner.variableIdentity$1($name);
            },
            couldHaveBeenConfigured$1: function(variables) {
                var t3, t4, t1 = this.variables, t2 = this._shadowed_view$_inner;
                if (t1 === t2.get$variables()) t1 = t2.couldHaveBeenConfigured$1(variables);
                else {
                    t3 = A.LinkedHashSet_LinkedHashSet$_empty(type$.String);
                    for(t1 = t1.get$keys(t1), t1 = t1.get$iterator(t1); t1.moveNext$0();){
                        t4 = t1.get$current(t1);
                        if (variables.contains$1(0, t4)) t3.add$1(0, t4);
                    }
                    t1 = t2.couldHaveBeenConfigured$1(t3);
                }
                return t1;
            },
            $eq: function(_, other) {
                var t1, t2, t3, _this = this;
                if (other == null) return false;
                t1 = false;
                if (other instanceof A.ShadowedModuleView) {
                    if (_this._shadowed_view$_inner.$eq(0, other._shadowed_view$_inner)) {
                        t2 = _this.variables;
                        t2 = t2.get$keys(t2);
                        t3 = other.variables;
                        if (B.C_IterableEquality.equals$2(0, t2, t3.get$keys(t3))) {
                            t2 = _this.functions;
                            t2 = t2.get$keys(t2);
                            t3 = other.functions;
                            if (B.C_IterableEquality.equals$2(0, t2, t3.get$keys(t3))) {
                                t1 = _this.mixins;
                                t1 = t1.get$keys(t1);
                                t2 = other.mixins;
                                t2 = B.C_IterableEquality.equals$2(0, t1, t2.get$keys(t2));
                                t1 = t2;
                            }
                        }
                    }
                }
                return t1;
            },
            get$hashCode: function(_) {
                var t1 = this._shadowed_view$_inner;
                return t1.get$hashCode(t1);
            },
            cloneCss$0: function() {
                var _this = this;
                return new A.ShadowedModuleView(_this._shadowed_view$_inner.cloneCss$0(), _this.variables, _this.variableNodes, _this.functions, _this.mixins, _this.$ti);
            },
            toString$0: function(_) {
                return "shadowed " + this._shadowed_view$_inner.toString$0(0);
            },
            $isModule0: 1,
            get$variables: function() {
                return this.variables;
            },
            get$variableNodes: function() {
                return this.variableNodes;
            },
            get$functions: function(receiver) {
                return this.functions;
            },
            get$mixins: function() {
                return this.mixins;
            }
        };
        A.AtRootQueryParser.prototype = {
            parse$0: function(_) {
                return this.wrapSpanFormatException$1(new A.AtRootQueryParser_parse_closure(this));
            }
        };
        A.AtRootQueryParser_parse_closure.prototype = {
            call$0: function() {
                var include, atRules, t1 = this.$this, t2 = t1.scanner;
                t2.expectChar$1(40);
                t1.whitespace$1$consumeNewlines(true);
                include = t1.scanIdentifier$1("with");
                if (!include) t1.expectIdentifier$2$name("without", '"with" or "without"');
                t1.whitespace$1$consumeNewlines(true);
                t2.expectChar$1(58);
                t1.whitespace$1$consumeNewlines(true);
                atRules = A.LinkedHashSet_LinkedHashSet$_empty(type$.String);
                do {
                    atRules.add$1(0, t1.identifier$0().toLowerCase());
                    t1.whitespace$1$consumeNewlines(true);
                }while (t1.lookingAtIdentifier$0());
                t2.expectChar$1(41);
                t2.expectDone$0();
                return new A.AtRootQuery(include, atRules, atRules.contains$1(0, "all"), atRules.contains$1(0, "rule"));
            },
            $signature: 423
        };
        A._disallowedFunctionNames_closure.prototype = {
            call$1: function($function) {
                return $function.name;
            },
            $signature: 424
        };
        A.CssParser.prototype = {
            get$plainCss: function() {
                return true;
            },
            silentComment$0: function() {
                var t1, t2, _this = this;
                if (_this._inExpression) return false;
                t1 = _this.scanner;
                t2 = t1._string_scanner$_position;
                _this.super$Parser$silentComment();
                _this.error$2(0, string$.Silent, _this.spanFrom$1(new A._SpanScannerState(t1, t2)));
            },
            atRule$2$root: function(child, root) {
                var $name, _0_0, result, _this = this, t1 = _this.scanner, start = new A._SpanScannerState(t1, t1._string_scanner$_position);
                t1.expectChar$1(64);
                $name = _this.interpolatedIdentifier$0();
                _this.whitespace$1$consumeNewlines(true);
                _0_0 = $name.get$asPlain();
                $label0$0: {
                    if ("at-root" === _0_0 || "content" === _0_0 || "debug" === _0_0 || "each" === _0_0 || "error" === _0_0 || "extend" === _0_0 || "for" === _0_0 || "if" === _0_0 || "include" === _0_0 || "mixin" === _0_0 || "return" === _0_0 || "warn" === _0_0 || "while" === _0_0) _this._forbiddenAtRule$1(start);
                    if ("import" === _0_0) {
                        t1 = _this._cssImportRule$1(start);
                        break $label0$0;
                    }
                    if ("function" === _0_0) {
                        _this.whitespace$1$consumeNewlines(true);
                        if (!t1.matches$1("--")) {
                            _this.almostAnyValue$0();
                            _this.error$2(0, "This at-rule isn't allowed in plain CSS.", t1.spanFrom$1(start));
                            result = null;
                        } else result = _this.unknownAtRule$2(start, $name);
                        t1 = result;
                        break $label0$0;
                    }
                    if ("media" === _0_0) {
                        t1 = _this.mediaRule$1(start);
                        break $label0$0;
                    }
                    if ("-moz-document" === _0_0) {
                        t1 = _this.mozDocumentRule$2(start, $name);
                        break $label0$0;
                    }
                    if ("supports" === _0_0) {
                        t1 = _this.supportsRule$1(start);
                        break $label0$0;
                    }
                    t1 = _this.unknownAtRule$2(start, $name);
                    break $label0$0;
                }
                return t1;
            },
            _forbiddenAtRule$1: function(start) {
                this.almostAnyValue$0();
                this.error$2(0, "This at-rule isn't allowed in plain CSS.", this.spanFrom$1(start));
            },
            _cssImportRule$1: function(start) {
                var _0_0, t3, string, $name, _0_3, _0_4, t4, _0_8, t5, modifiers, _this = this, _null = null, t1 = _this.scanner, t2 = t1._string_scanner$_position, _1_0 = t1.peekChar$0();
                $label1$1: {
                    if (117 === _1_0 || 85 === _1_0) {
                        _0_0 = _this.dynamicUrl$0();
                        $label0$0: {
                            if (_0_0 instanceof A.StringExpression) {
                                t3 = _0_0.text;
                                break $label0$0;
                            }
                            string = _null;
                            t3 = false;
                            if (_0_0 instanceof A.InterpolatedFunctionExpression) {
                                $name = _0_0.name;
                                _0_3 = _0_0.$arguments;
                                _0_4 = _0_3.positional;
                                t4 = _0_4;
                                if (t4.length === 1) {
                                    _0_8 = _0_4[0];
                                    t4 = _0_8;
                                    if (t4 instanceof A.StringExpression) {
                                        type$.StringExpression._as(_0_8);
                                        t4 = _0_3.named;
                                        if (t4.get$isEmpty(t4)) {
                                            if (_0_3.rest == null) t3 = _0_3.keywordRest == null;
                                        }
                                        string = _0_8;
                                    }
                                }
                            } else $name = _null;
                            if (t3) {
                                t3 = new A.StringBuffer("");
                                t4 = new A.InterpolationBuffer(t3, A._setArrayType([], type$.JSArray_Object), A._setArrayType([], type$.JSArray_nullable_FileSpan));
                                t4.addInterpolation$1($name);
                                t5 = A.Primitives_stringFromCharCode(40);
                                t3._contents += t5;
                                t4.addInterpolation$1(string.asInterpolation$0());
                                t5 = A.Primitives_stringFromCharCode(41);
                                t3._contents += t5;
                                t4 = t4.interpolation$1(_0_0.span);
                                t3 = t4;
                                break $label0$0;
                            }
                            t3 = _this.error$2(0, "Unsupported plain CSS import.", _0_0.get$span(_0_0));
                        }
                        break $label1$1;
                    }
                    t3 = _this.interpolatedString$0().asInterpolation$1$static(true);
                    break $label1$1;
                }
                _this.whitespace$1$consumeNewlines(true);
                modifiers = _this.tryImportModifiers$0();
                _this.expectStatementSeparator$1("@import rule");
                t2 = A._setArrayType([
                    new A.StaticImport(t3, modifiers, _this.spanFrom$1(new A._SpanScannerState(t1, t2)))
                ], type$.JSArray_Import);
                t1 = _this.spanFrom$1(start);
                return new A.ImportRule(A.List_List$unmodifiable(t2, type$.Import), t1);
            },
            parentheses$0: function() {
                var expression, _this = this, t1 = _this.scanner, t2 = t1._string_scanner$_position;
                t1.expectChar$1(40);
                _this.whitespace$1$consumeNewlines(true);
                expression = _this.expressionUntilComma$0();
                t1.expectChar$1(41);
                return new A.ParenthesizedExpression(expression, _this.spanFrom$1(new A._SpanScannerState(t1, t2)));
            },
            identifierLike$0: function() {
                var t2, allowEmptySecondArg, $arguments, t3, t4, _this = this, t1 = _this.scanner, start = new A._SpanScannerState(t1, t1._string_scanner$_position), identifier = _this.interpolatedIdentifier$0(), plain = identifier.get$asPlain(), lower = plain.toLowerCase(), _0_0 = _this.trySpecialFunction$2(lower, start);
                if (_0_0 != null) return _0_0;
                t2 = t1._string_scanner$_position;
                if (t1.scanChar$1(46)) return _this.namespacedExpression$2(plain, start);
                else if (lower === "if" && t1.peekChar$0() === 40) return _this.ifExpression$1(start);
                else if (!t1.scanChar$1(40)) return new A.StringExpression(identifier, false);
                allowEmptySecondArg = lower === "var";
                $arguments = A._setArrayType([], type$.JSArray_Expression);
                if (!t1.scanChar$1(41)) {
                    do {
                        _this.whitespace$1$consumeNewlines(true);
                        if (allowEmptySecondArg && $arguments.length === 1 && t1.peekChar$0() === 41) {
                            t3 = A.FileLocation$_(t1._sourceFile, t1._string_scanner$_position);
                            t4 = t3.offset;
                            t4 = A._FileSpan$(t3.file, t4, t4);
                            $arguments.push(new A.StringExpression(new A.Interpolation(A.List_List$unmodifiable([
                                ""
                            ], type$.Object), B.List_null, t4), false));
                            break;
                        }
                        $arguments.push(_this.expressionUntilComma$1$singleEquals(true));
                        _this.whitespace$1$consumeNewlines(true);
                    }while (t1.scanChar$1(44));
                    t1.expectChar$1(41);
                }
                if ($.$get$_disallowedFunctionNames().contains$1(0, plain)) _this.error$2(0, string$.This_f, _this.spanFrom$1(start));
                t1 = A.ArgumentList$($arguments, B.Map_empty4, B.Map_empty5, _this.spanFrom$1(new A._SpanScannerState(t1, t2)), null, null);
                t2 = _this.spanFrom$1(start);
                return new A.FunctionExpression(null, A.stringReplaceAllUnchecked(plain, "_", "-"), plain, t1, t2);
            },
            namespacedExpression$2: function(namespace, start) {
                var expression = this.super$StylesheetParser$namespacedExpression(namespace, start);
                this.error$2(0, string$.Modulen, expression.get$span(expression));
            }
        };
        A.KeyframeSelectorParser.prototype = {
            parse$0: function(_) {
                return this.wrapSpanFormatException$1(new A.KeyframeSelectorParser_parse_closure(this));
            },
            _percentage$0: function() {
                var $self, _0_0, t1 = this.scanner, t2 = t1.scanChar$1(43) ? A.Primitives_stringFromCharCode(43) : "", second = t1.peekChar$0();
                if (!(second != null && second >= 48 && second <= 57) && second !== 46) t1.error$1(0, "Expected number.");
                for(;;){
                    $self = t1.peekChar$0();
                    if (!($self != null && $self >= 48 && $self <= 57)) break;
                    t2 += A.Primitives_stringFromCharCode(t1.readChar$0());
                }
                if (t1.peekChar$0() === 46) {
                    t2 += A.Primitives_stringFromCharCode(t1.readChar$0());
                    for(;;){
                        $self = t1.peekChar$0();
                        if (!($self != null && $self >= 48 && $self <= 57)) break;
                        t2 += A.Primitives_stringFromCharCode(t1.readChar$0());
                    }
                }
                if (this.scanIdentChar$1(101)) {
                    t2 += A.Primitives_stringFromCharCode(101);
                    _0_0 = t1.peekChar$0();
                    if (43 === _0_0 || 45 === _0_0) t2 += A.Primitives_stringFromCharCode(t1.readChar$0());
                    $self = t1.peekChar$0();
                    if (!($self != null && $self >= 48 && $self <= 57)) t1.error$1(0, "Expected digit.");
                    do {
                        t2 += A.Primitives_stringFromCharCode(t1.readChar$0());
                        $self = t1.peekChar$0();
                    }while ($self != null && $self >= 48 && $self <= 57);
                }
                t1.expectChar$1(37);
                t2 += A.Primitives_stringFromCharCode(37);
                return t2.charCodeAt(0) == 0 ? t2 : t2;
            }
        };
        A.KeyframeSelectorParser_parse_closure.prototype = {
            call$0: function() {
                var selectors = A._setArrayType([], type$.JSArray_String), t1 = this.$this, t2 = t1.scanner;
                do {
                    t1.whitespace$1$consumeNewlines(true);
                    if (t1.lookingAtIdentifier$0()) {
                        if (t1.scanIdentifier$1("from")) selectors.push("from");
                        else {
                            t1.expectIdentifier$2$name("to", '"to" or "from"');
                            selectors.push("to");
                        }
                    } else selectors.push(t1._percentage$0());
                    t1.whitespace$1$consumeNewlines(true);
                }while (t2.scanChar$1(44));
                t2.expectDone$0();
                return selectors;
            },
            $signature: 139
        };
        A.MediaQueryParser.prototype = {
            parse$0: function(_) {
                return this.wrapSpanFormatException$1(new A.MediaQueryParser_parse_closure(this));
            },
            _mediaQuery$0: function() {
                var conditions, conjunction, t1, identifier1, identifier2, type, modifier, _this = this, _null = null, _s3_ = "and";
                if (_this.scanner.peekChar$0() === 40) {
                    conditions = A._setArrayType([
                        _this._mediaInParens$0()
                    ], type$.JSArray_String);
                    _this.whitespace$1$consumeNewlines(true);
                    if (_this.scanIdentifier$1(_s3_)) {
                        _this.expectWhitespace$0();
                        B.JSArray_methods.addAll$1(conditions, _this._mediaLogicSequence$1(_s3_));
                        conjunction = true;
                    } else {
                        t1 = _this.scanIdentifier$1("or");
                        if (t1) {
                            _this.expectWhitespace$0();
                            B.JSArray_methods.addAll$1(conditions, _this._mediaLogicSequence$1("or"));
                        }
                        conjunction = !t1;
                    }
                    return A.CssMediaQuery$condition(conditions, conjunction);
                }
                identifier1 = _this.identifier$0();
                if (A.equalsIgnoreCase(identifier1, "not")) {
                    _this.expectWhitespace$0();
                    if (!_this.lookingAtIdentifier$0()) return A.CssMediaQuery$condition(A._setArrayType([
                        "(not " + _this._mediaInParens$0() + ")"
                    ], type$.JSArray_String), _null);
                }
                _this.whitespace$1$consumeNewlines(true);
                if (!_this.lookingAtIdentifier$0()) return A.CssMediaQuery$type(identifier1, _null, _null);
                identifier2 = _this.identifier$0();
                if (A.equalsIgnoreCase(identifier2, _s3_)) {
                    _this.expectWhitespace$0();
                    type = identifier1;
                    modifier = _null;
                } else {
                    _this.whitespace$1$consumeNewlines(true);
                    if (_this.scanIdentifier$1(_s3_)) _this.expectWhitespace$0();
                    else return A.CssMediaQuery$type(identifier2, _null, identifier1);
                    type = identifier2;
                    modifier = identifier1;
                }
                if (_this.scanIdentifier$1("not")) {
                    _this.expectWhitespace$0();
                    return A.CssMediaQuery$type(type, A._setArrayType([
                        "(not " + _this._mediaInParens$0() + ")"
                    ], type$.JSArray_String), modifier);
                }
                return A.CssMediaQuery$type(type, _this._mediaLogicSequence$1(_s3_), modifier);
            },
            _mediaLogicSequence$1: function(operator) {
                var t1, t2, _this = this, result = A._setArrayType([], type$.JSArray_String);
                for(t1 = _this.scanner;;){
                    t1.expectChar$2$name(40, "media condition in parentheses");
                    t2 = _this.declarationValue$0();
                    t1.expectChar$1(41);
                    result.push("(" + t2 + ")");
                    _this.whitespace$1$consumeNewlines(true);
                    if (!_this.scanIdentifier$1(operator)) return result;
                    _this.expectWhitespace$0();
                }
            },
            _mediaInParens$0: function() {
                var t2, t1 = this.scanner;
                t1.expectChar$2$name(40, "media condition in parentheses");
                t2 = this.declarationValue$0();
                t1.expectChar$1(41);
                return "(" + t2 + ")";
            }
        };
        A.MediaQueryParser_parse_closure.prototype = {
            call$0: function() {
                var queries = A._setArrayType([], type$.JSArray_CssMediaQuery), t1 = this.$this, t2 = t1.scanner;
                do {
                    t1.whitespace$1$consumeNewlines(true);
                    queries.push(t1._mediaQuery$0());
                    t1.whitespace$1$consumeNewlines(true);
                }while (t2.scanChar$1(44));
                t2.expectDone$0();
                return queries;
            },
            $signature: 430
        };
        A.Parser.prototype = {
            _parseIdentifier$0: function() {
                return this.wrapSpanFormatException$1(new A.Parser__parseIdentifier_closure(this));
            },
            _isVariableDeclarationLike$0: function() {
                var _this = this, t1 = _this.scanner;
                if (!t1.scanChar$1(36)) return false;
                if (!_this.lookingAtIdentifier$0()) return false;
                _this.identifier$0();
                _this.whitespace$1$consumeNewlines(true);
                return t1.scanChar$1(58);
            },
            whitespace$1$consumeNewlines: function(consumeNewlines) {
                do this.whitespaceWithoutComments$1$consumeNewlines(consumeNewlines);
                while (this.scanComment$0());
            },
            whitespaceWithoutComments$1$consumeNewlines: function(consumeNewlines) {
                var t3, t1 = this.scanner, t2 = t1.string.length;
                for(;;){
                    if (t1._string_scanner$_position !== t2) {
                        t3 = t1.peekChar$0();
                        t3 = t3 === 32 || t3 === 9 || t3 === 10 || t3 === 13 || t3 === 12;
                    } else t3 = false;
                    if (!t3) break;
                    t1.readChar$0();
                }
            },
            spaces$0: function() {
                var t3, t1 = this.scanner, t2 = t1.string.length;
                for(;;){
                    if (t1._string_scanner$_position !== t2) {
                        t3 = t1.peekChar$0();
                        t3 = t3 === 32 || t3 === 9;
                    } else t3 = false;
                    if (!t3) break;
                    t1.readChar$0();
                }
            },
            scanComment$0: function() {
                var _0_0, t1 = this.scanner;
                if (t1.peekChar$0() !== 47) return false;
                _0_0 = t1.peekChar$1(1);
                if (47 === _0_0) return this.silentComment$0();
                if (42 === _0_0) {
                    this.loudComment$0();
                    return true;
                }
                return false;
            },
            expectWhitespace$1$consumeNewlines: function(consumeNewlines) {
                var t2, t3, t1 = this.scanner;
                if (t1._string_scanner$_position !== t1.string.length) {
                    t2 = t1.peekChar$0();
                    t3 = !(t2 === 32 || t2 === 9 || t2 === 10 || t2 === 13 || t2 === 12 || this.scanComment$0());
                    t2 = t3;
                } else t2 = true;
                if (t2) t1.error$1(0, "Expected whitespace.");
                this.whitespace$1$consumeNewlines(consumeNewlines);
            },
            expectWhitespace$0: function() {
                return this.expectWhitespace$1$consumeNewlines(false);
            },
            silentComment$0: function() {
                var t2, t3, t1 = this.scanner;
                t1.expect$1("//");
                t2 = t1.string.length;
                for(;;){
                    if (t1._string_scanner$_position !== t2) {
                        t3 = t1.peekChar$0();
                        t3 = !(t3 === 10 || t3 === 13 || t3 === 12);
                    } else t3 = false;
                    if (!t3) break;
                    t1.readChar$0();
                }
                return true;
            },
            loudComment$0: function() {
                var next, t1 = this.scanner;
                t1.expect$1("/*");
                for(;;){
                    if (t1.readChar$0() !== 42) continue;
                    do next = t1.readChar$0();
                    while (next === 42);
                    if (next === 47) break;
                }
            },
            identifier$2$normalize$unit: function(normalize, unit) {
                var t2, _0_0, _this = this, _s20_ = "Expected identifier.", text = new A.StringBuffer(""), t1 = _this.scanner;
                if (t1.scanChar$1(45)) {
                    t2 = text._contents = A.Primitives_stringFromCharCode(45);
                    if (t1.scanChar$1(45)) {
                        text._contents = t2 + t2;
                        _this._identifierBody$3$normalize$unit(text, normalize, unit);
                        t1 = text._contents;
                        return t1.charCodeAt(0) == 0 ? t1 : t1;
                    }
                } else t2 = "";
                $label0$0: {
                    _0_0 = t1.peekChar$0();
                    if (_0_0 == null) t1.error$1(0, _s20_);
                    if (95 === _0_0 && normalize) {
                        t1.readChar$0();
                        text._contents = t2 + A.Primitives_stringFromCharCode(45);
                        break $label0$0;
                    }
                    if (_0_0 === 95 || A.CharacterExtension_get_isAlphabetic(_0_0) || _0_0 >= 128) {
                        text._contents = t2 + A.Primitives_stringFromCharCode(t1.readChar$0());
                        break $label0$0;
                    }
                    if (92 === _0_0) {
                        text._contents = t2 + _this.escape$1$identifierStart(true);
                        break $label0$0;
                    }
                    t1.error$1(0, _s20_);
                }
                _this._identifierBody$3$normalize$unit(text, normalize, unit);
                t1 = text._contents;
                return t1.charCodeAt(0) == 0 ? t1 : t1;
            },
            identifier$0: function() {
                return this.identifier$2$normalize$unit(false, false);
            },
            identifier$1$normalize: function(normalize) {
                return this.identifier$2$normalize$unit(normalize, false);
            },
            identifier$1$unit: function(unit) {
                return this.identifier$2$normalize$unit(false, unit);
            },
            _identifierBody$3$normalize$unit: function(text, normalize, unit) {
                var t1, _1_0, _0_0, t2;
                for(t1 = this.scanner;;){
                    _1_0 = t1.peekChar$0();
                    if (_1_0 == null) break;
                    if (45 === _1_0 && unit) {
                        _0_0 = t1.peekChar$1(1);
                        if (46 !== _0_0) t2 = A._isInt(_0_0) && _0_0 >= 48 && _0_0 <= 57;
                        else t2 = true;
                        if (t2) break;
                        t2 = A.Primitives_stringFromCharCode(t1.readChar$0());
                        text._contents += t2;
                        continue;
                    }
                    if (95 === _1_0 && normalize) {
                        t1.readChar$0();
                        t2 = A.Primitives_stringFromCharCode(45);
                        text._contents += t2;
                        continue;
                    }
                    if (_1_0 !== 95) {
                        if (!(_1_0 >= 97 && _1_0 <= 122)) t2 = _1_0 >= 65 && _1_0 <= 90;
                        else t2 = true;
                        t2 = t2 || _1_0 >= 128;
                    } else t2 = true;
                    if (!t2) t2 = _1_0 >= 48 && _1_0 <= 57 || _1_0 === 45;
                    else t2 = true;
                    if (t2) {
                        t2 = A.Primitives_stringFromCharCode(t1.readChar$0());
                        text._contents += t2;
                        continue;
                    }
                    if (92 === _1_0) {
                        t2 = this.escape$0();
                        text._contents += t2;
                        continue;
                    }
                    break;
                }
            },
            _identifierBody$1: function(text) {
                return this._identifierBody$3$normalize$unit(text, false, false);
            },
            string$0: function() {
                var buffer, _0_0, t2, t1 = this.scanner, quote = t1.readChar$0();
                if (quote !== 39 && quote !== 34) t1.error$2$position(0, "Expected string.", t1._string_scanner$_position - 1);
                buffer = new A.StringBuffer("");
                for(;;){
                    _0_0 = t1.peekChar$0();
                    if (_0_0 === quote) {
                        t1.readChar$0();
                        break;
                    }
                    if (_0_0 == null || _0_0 === 10 || _0_0 === 13 || _0_0 === 12) t1.error$1(0, "Expected " + A.Primitives_stringFromCharCode(quote) + ".");
                    if (92 === _0_0) {
                        t2 = t1.peekChar$1(1);
                        if (t2 === 10 || t2 === 13 || t2 === 12) {
                            t1.readChar$0();
                            t1.readChar$0();
                        } else {
                            t2 = A.Primitives_stringFromCharCode(A.consumeEscapedCharacter(t1));
                            buffer._contents += t2;
                        }
                        continue;
                    }
                    t2 = A.Primitives_stringFromCharCode(t1.readChar$0());
                    buffer._contents += t2;
                }
                t1 = buffer._contents;
                return t1.charCodeAt(0) == 0 ? t1 : t1;
            },
            declarationValue$1$allowEmpty: function(allowEmpty) {
                var t1, t2, t3, wroteNewline, next, wroteNewline0, t4, start, end, _0_0, _this = this, buffer = new A.StringBuffer(""), brackets = A._setArrayType([], type$.JSArray_int);
                for(t1 = _this.scanner, t2 = _this.get$loudComment(), t3 = _this.get$string(), wroteNewline = false;;){
                    next = t1.peekChar$0();
                    if (next == null) break;
                    wroteNewline0 = false;
                    if (92 === next) {
                        t4 = _this.escape$1$identifierStart(true);
                        buffer._contents += t4;
                        wroteNewline = wroteNewline0;
                        continue;
                    }
                    if (34 === next || 39 === next) {
                        start = t1._string_scanner$_position;
                        t3.call$0();
                        end = t1._string_scanner$_position;
                        buffer._contents += B.JSString_methods.substring$2(t1.string, start, end);
                        wroteNewline = wroteNewline0;
                        continue;
                    }
                    if (47 === next) {
                        if (t1.peekChar$1(1) === 42) {
                            start = t1._string_scanner$_position;
                            t2.call$0();
                            end = t1._string_scanner$_position;
                            buffer._contents += B.JSString_methods.substring$2(t1.string, start, end);
                        } else {
                            t4 = A.Primitives_stringFromCharCode(t1.readChar$0());
                            buffer._contents += t4;
                        }
                        wroteNewline = wroteNewline0;
                        continue;
                    }
                    if (32 === next || 9 === next) {
                        if (!wroteNewline) {
                            t4 = t1.peekChar$1(1);
                            t4 = !(t4 === 32 || t4 === 9 || t4 === 10 || t4 === 13 || t4 === 12);
                        } else t4 = true;
                        if (t4) {
                            t4 = A.Primitives_stringFromCharCode(32);
                            buffer._contents += t4;
                        }
                        t1.readChar$0();
                        continue;
                    }
                    if (10 === next || 13 === next || 12 === next) {
                        t4 = t1.peekChar$1(-1);
                        if (!(t4 === 10 || t4 === 13 || t4 === 12)) buffer._contents += "\n";
                        t1.readChar$0();
                        wroteNewline = true;
                        continue;
                    }
                    if (40 === next || 123 === next || 91 === next) {
                        t4 = A.Primitives_stringFromCharCode(next);
                        buffer._contents += t4;
                        brackets.push(A.opposite(t1.readChar$0()));
                        wroteNewline = wroteNewline0;
                        continue;
                    }
                    if (41 === next || 125 === next || 93 === next) {
                        if (brackets.length === 0) break;
                        t4 = A.Primitives_stringFromCharCode(next);
                        buffer._contents += t4;
                        t1.expectChar$1(brackets.pop());
                        wroteNewline = wroteNewline0;
                        continue;
                    }
                    if (59 === next) {
                        if (brackets.length === 0) break;
                        t4 = A.Primitives_stringFromCharCode(t1.readChar$0());
                        buffer._contents += t4;
                        continue;
                    }
                    if (117 === next || 85 === next) {
                        _0_0 = _this.tryUrl$0();
                        if (_0_0 != null) buffer._contents += _0_0;
                        else {
                            t4 = A.Primitives_stringFromCharCode(t1.readChar$0());
                            buffer._contents += t4;
                        }
                        wroteNewline = wroteNewline0;
                        continue;
                    }
                    if (_this.lookingAtIdentifier$0()) {
                        t4 = _this.identifier$0();
                        buffer._contents += t4;
                    } else {
                        t4 = A.Primitives_stringFromCharCode(t1.readChar$0());
                        buffer._contents += t4;
                    }
                    wroteNewline = wroteNewline0;
                }
                if (brackets.length !== 0) t1.expectChar$1(B.JSArray_methods.get$last(brackets));
                if (!allowEmpty && buffer._contents.length === 0) t1.error$1(0, "Expected token.");
                t1 = buffer._contents;
                return t1.charCodeAt(0) == 0 ? t1 : t1;
            },
            declarationValue$0: function() {
                return this.declarationValue$1$allowEmpty(false);
            },
            tryUrl$0: function() {
                var buffer, _0_0, t2, _this = this, t1 = _this.scanner, start = new A._SpanScannerState(t1, t1._string_scanner$_position);
                if (!_this.scanIdentifier$1("url")) return null;
                if (!t1.scanChar$1(40)) {
                    t1.set$state(start);
                    return null;
                }
                _this.whitespace$1$consumeNewlines(true);
                buffer = new A.StringBuffer("");
                buffer._contents = "url(";
                for(;;){
                    _0_0 = t1.peekChar$0();
                    if (_0_0 == null) break;
                    if (92 === _0_0) {
                        t2 = _this.escape$0();
                        buffer._contents += t2;
                        continue;
                    }
                    t2 = true;
                    if (37 !== _0_0) {
                        if (38 !== _0_0) {
                            if (35 !== _0_0) t2 = _0_0 >= 42 && _0_0 <= 126 || _0_0 >= 128;
                        }
                    }
                    if (t2) {
                        t2 = A.Primitives_stringFromCharCode(t1.readChar$0());
                        buffer._contents += t2;
                        continue;
                    }
                    if (_0_0 === 32 || _0_0 === 9 || _0_0 === 10 || _0_0 === 13 || _0_0 === 12) {
                        _this.whitespace$1$consumeNewlines(true);
                        if (t1.peekChar$0() !== 41) break;
                        continue;
                    }
                    if (41 === _0_0) {
                        t2 = A.Primitives_stringFromCharCode(t1.readChar$0());
                        t2 = buffer._contents += t2;
                        return t2.charCodeAt(0) == 0 ? t2 : t2;
                    }
                    break;
                }
                t1.set$state(start);
                return null;
            },
            variableName$0: function() {
                this.scanner.expectChar$1(36);
                return this.identifier$1$normalize(true);
            },
            escape$1$identifierStart: function(identifierStart) {
                var value, _0_0, i, next, t2, _$exception, _s25_ = "Expected escape sequence.", t1 = this.scanner, start = t1._string_scanner$_position;
                t1.expectChar$1(92);
                value = 0;
                $label0$1: {
                    _0_0 = t1.peekChar$0();
                    if (_0_0 == null) t1.error$1(0, _s25_);
                    if (_0_0 === 10 || _0_0 === 13 || _0_0 === 12) t1.error$1(0, _s25_);
                    if (A.CharacterExtension_get_isHex(_0_0)) {
                        for(i = 0; i < 6; ++i){
                            next = t1.peekChar$0();
                            if (next != null) {
                                t2 = true;
                                if (!(next >= 48 && next <= 57)) {
                                    if (!(next >= 97 && next <= 102)) t2 = next >= 65 && next <= 70;
                                }
                                t2 = !t2;
                            } else t2 = true;
                            if (t2) break;
                            value *= 16;
                            value += A.asHex(t1.readChar$0());
                        }
                        this.scanCharIf$1(new A.Parser_escape_closure());
                        break $label0$1;
                    }
                    value = t1.readChar$0();
                }
                if (identifierStart) {
                    t2 = value;
                    t2 = t2 === 95 || A.CharacterExtension_get_isAlphabetic(t2) || t2 >= 128;
                } else {
                    t2 = value;
                    if (!(t2 === 95 || A.CharacterExtension_get_isAlphabetic(t2) || t2 >= 128)) t2 = t2 >= 48 && t2 <= 57 || t2 === 45;
                    else t2 = true;
                }
                if (t2) try {
                    t2 = A.Primitives_stringFromCharCode(value);
                    return t2;
                } catch (exception) {
                    if (type$.RangeError._is(A.unwrapException(exception))) t1.error$3$length$position(0, "Invalid Unicode code point.", t1._string_scanner$_position - start, start);
                    else throw exception;
                }
                else {
                    t1 = true;
                    if (!(value <= 31)) {
                        if (!J.$eq$(value, 127)) {
                            if (identifierStart) {
                                t1 = value;
                                t1 = t1 >= 48 && t1 <= 57;
                            } else t1 = false;
                        }
                    }
                    if (t1) {
                        t1 = A.Primitives_stringFromCharCode(92);
                        if (value > 15) t1 += A.Primitives_stringFromCharCode(A.hexCharFor(B.JSNumber_methods._shrOtherPositive$1(value, 4)));
                        t1 = t1 + A.Primitives_stringFromCharCode(A.hexCharFor(value & 15)) + A.Primitives_stringFromCharCode(32);
                        return t1.charCodeAt(0) == 0 ? t1 : t1;
                    } else return A.String_String$fromCharCodes(A._setArrayType([
                        92,
                        value
                    ], type$.JSArray_int), 0, null);
                }
            },
            escape$0: function() {
                return this.escape$1$identifierStart(false);
            },
            scanCharIf$1: function(condition) {
                var t1 = this.scanner;
                if (!condition.call$1(t1.peekChar$0())) return false;
                t1.readChar$0();
                return true;
            },
            scanIdentChar$2$caseSensitive: function(char, caseSensitive) {
                var t3, t1 = new A.Parser_scanIdentChar_matches(caseSensitive, char), t2 = this.scanner, _0_0 = t2.peekChar$0();
                if (_0_0 != null) t3 = t1.call$1(_0_0);
                else t3 = false;
                if (t3) {
                    t2.readChar$0();
                    return true;
                }
                if (92 === _0_0) {
                    t3 = t2._string_scanner$_position;
                    if (t1.call$1(A.consumeEscapedCharacter(t2))) return true;
                    t2.set$state(new A._SpanScannerState(t2, t3));
                }
                return false;
            },
            scanIdentChar$1: function(char) {
                return this.scanIdentChar$2$caseSensitive(char, false);
            },
            expectIdentChar$1: function(letter) {
                var t1;
                if (this.scanIdentChar$2$caseSensitive(letter, false)) return;
                t1 = this.scanner;
                t1.error$2$position(0, 'Expected "' + A.Primitives_stringFromCharCode(letter) + '".', t1._string_scanner$_position);
            },
            lookingAtIdentifier$1: function($forward) {
                var t1, _1_0, t2, _0_0;
                if ($forward == null) $forward = 0;
                t1 = this.scanner;
                _1_0 = t1.peekChar$1($forward);
                $label0$0: {
                    if (A._isInt(_1_0)) t2 = _1_0 === 95 || A.CharacterExtension_get_isAlphabetic(_1_0) || _1_0 >= 128;
                    else t2 = false;
                    if (t2 || 92 === _1_0) {
                        t1 = true;
                        break $label0$0;
                    }
                    if (45 === _1_0) {
                        _0_0 = t1.peekChar$1($forward + 1);
                        $label1$1: {
                            if (A._isInt(_0_0)) t1 = _0_0 === 95 || A.CharacterExtension_get_isAlphabetic(_0_0) || _0_0 >= 128;
                            else t1 = false;
                            t1 = t1 || 92 === _0_0 || 45 === _0_0;
                            break $label1$1;
                        }
                        break $label0$0;
                    }
                    t1 = false;
                    break $label0$0;
                }
                return t1;
            },
            lookingAtIdentifier$0: function() {
                return this.lookingAtIdentifier$1(null);
            },
            lookingAtIdentifierBody$0: function() {
                var t1, next = this.scanner.peekChar$0();
                if (next != null) {
                    if (!(next === 95 || A.CharacterExtension_get_isAlphabetic(next) || next >= 128)) t1 = next >= 48 && next <= 57 || next === 45;
                    else t1 = true;
                    t1 = t1 || next === 92;
                } else t1 = false;
                return t1;
            },
            scanIdentifier$2$caseSensitive: function(text, caseSensitive) {
                var t1, t2, _this = this;
                if (!_this.lookingAtIdentifier$0()) return false;
                t1 = _this.scanner;
                t2 = t1._string_scanner$_position;
                if (_this._consumeIdentifier$2(text, caseSensitive) && !_this.lookingAtIdentifierBody$0()) return true;
                else {
                    t1.set$state(new A._SpanScannerState(t1, t2));
                    return false;
                }
            },
            scanIdentifier$1: function(text) {
                return this.scanIdentifier$2$caseSensitive(text, false);
            },
            _consumeIdentifier$2: function(text, caseSensitive) {
                var t1, t2, t3;
                for(t1 = new A.CodeUnits(text), t2 = type$.CodeUnits, t1 = new A.ListIterator(t1, t1.get$length(0), t2._eval$1("ListIterator<ListBase.E>")), t2 = t2._eval$1("ListBase.E"); t1.moveNext$0();){
                    t3 = t1.__internal$_current;
                    if (!this.scanIdentChar$2$caseSensitive(t3 == null ? t2._as(t3) : t3, caseSensitive)) return false;
                }
                return true;
            },
            expectIdentifier$2$name: function(text, $name) {
                var t1, start, t2, t3, t4, t5, t6;
                if ($name == null) $name = '"' + text + '"';
                t1 = this.scanner;
                start = t1._string_scanner$_position;
                for(t2 = new A.CodeUnits(text), t3 = type$.CodeUnits, t2 = new A.ListIterator(t2, t2.get$length(0), t3._eval$1("ListIterator<ListBase.E>")), t4 = "Expected " + $name, t5 = t4 + ".", t3 = t3._eval$1("ListBase.E"); t2.moveNext$0();){
                    t6 = t2.__internal$_current;
                    if (this.scanIdentChar$2$caseSensitive(t6 == null ? t3._as(t6) : t6, false)) continue;
                    t1.error$2$position(0, t5, start);
                }
                if (!this.lookingAtIdentifierBody$0()) return;
                t1.error$2$position(0, t4, start);
            },
            expectIdentifier$1: function(text) {
                return this.expectIdentifier$2$name(text, null);
            },
            rawText$1: function(consumer) {
                var t1 = this.scanner, start = t1._string_scanner$_position;
                consumer.call$0();
                return t1.substring$1(0, start);
            },
            spanFrom$2: function(start, end) {
                var span = this.scanner.spanFrom$2(start, end);
                return this._interpolationMap == null ? span : new A.LazyFileSpan(new A.Parser_spanFrom_closure(this, span));
            },
            spanFrom$1: function(start) {
                return this.spanFrom$2(start, null);
            },
            spanFromPosition$2: function(start, end) {
                var span = this.scanner.spanFromPosition$2(start, end);
                return this._interpolationMap == null ? span : new A.LazyFileSpan(new A.Parser_spanFromPosition_closure(this, span));
            },
            spanFromPosition$1: function(start) {
                return this.spanFromPosition$2(start, null);
            },
            error$3: function(_, message, span, trace) {
                var exception = new A.StringScannerException(this.scanner.string, message, span);
                if (trace == null) throw A.wrapException(exception);
                else A.throwWithTrace(exception, this.get$error(this), trace);
            },
            error$2: function(_, message, span) {
                return this.error$3(0, message, span, null);
            },
            withErrorMessage$1$2: function(message, callback) {
                var error, stackTrace, t1, _$exception;
                try {
                    t1 = callback.call$0();
                    return t1;
                } catch (exception) {
                    t1 = A.unwrapException(exception);
                    if (type$.SourceSpanFormatException._is(t1)) {
                        error = t1;
                        stackTrace = A.getTraceFromException(exception);
                        t1 = J.get$span$x(error);
                        A.throwWithTrace(new A.SourceSpanFormatException(error.get$source(), message, t1), error, stackTrace);
                    } else throw exception;
                }
            },
            withErrorMessage$2: function(message, callback) {
                return this.withErrorMessage$1$2(message, callback, type$.dynamic);
            },
            wrapSpanFormatException$1$1: function(callback) {
                var error, stackTrace, map, mapped, error0, stackTrace0, span, secondarySpans, t1, t2, span0, description, _0_0, error1, stackTrace1, span1, t3, _$exception, t4, _this = this, _s8_ = "expected";
                try {
                    try {
                        t3 = callback.call$0();
                        return t3;
                    } catch (exception) {
                        t3 = A.unwrapException(exception);
                        if (type$.SourceSpanFormatException._is(t3)) {
                            error = t3;
                            stackTrace = A.getTraceFromException(exception);
                            map = _this._interpolationMap;
                            if (map == null) throw exception;
                            mapped = map.mapException$1(error);
                            t3 = mapped;
                            t4 = error;
                            if (t3 == null ? t4 == null : t3 === t4) throw exception;
                            A.throwWithTrace(mapped, error, stackTrace);
                        } else throw exception;
                    }
                } catch (exception) {
                    t3 = A.unwrapException(exception);
                    if (type$.MultiSourceSpanFormatException._is(t3)) {
                        error0 = t3;
                        stackTrace0 = A.getTraceFromException(exception);
                        span = J.get$span$x(error0);
                        t3 = type$.FileSpan;
                        t4 = type$.String;
                        secondarySpans = error0.get$secondarySpans().cast$2$0(0, t3, t4);
                        if (A.startsWithIgnoreCase(error0._span_exception$_message, _s8_)) {
                            span = _this._adjustExceptionSpan$1(span);
                            t1 = A.LinkedHashMap_LinkedHashMap$_empty(t3, t4);
                            for(t3 = A.MapExtensions_get_pairs(secondarySpans, t3, t4), t3 = t3.get$iterator(t3); t3.moveNext$0();){
                                t2 = t3.get$current(t3);
                                span0 = null;
                                description = null;
                                _0_0 = t2;
                                span0 = _0_0._0;
                                description = _0_0._1;
                                J.$indexSet$ax(t1, _this._adjustExceptionSpan$1(span0), description);
                            }
                            secondarySpans = t1;
                        }
                        A.throwWithTrace(A.MultiSpanSassFormatException$(error0._span_exception$_message, span, error0.get$primaryLabel(), secondarySpans, null), error0, stackTrace0);
                    } else if (type$.SourceSpanFormatException._is(t3)) {
                        error1 = t3;
                        stackTrace1 = A.getTraceFromException(exception);
                        span1 = J.get$span$x(error1);
                        if (A.startsWithIgnoreCase(error1._span_exception$_message, _s8_)) span1 = _this._adjustExceptionSpan$1(span1);
                        t1 = error1._span_exception$_message;
                        t2 = span1;
                        A.throwWithTrace(new A.SassFormatException(B.Set_empty, t1, t2), error1, stackTrace1);
                    } else throw exception;
                }
            },
            wrapSpanFormatException$1: function(callback) {
                return this.wrapSpanFormatException$1$1(callback, type$.dynamic);
            },
            _adjustExceptionSpan$1: function(span) {
                var start, t1;
                if (span.get$length(span) > 0) return span;
                start = this._firstNewlineBefore$1(span.get$start(span));
                if (start.$eq(0, span.get$start(span))) t1 = span;
                else {
                    t1 = start.offset;
                    t1 = A._FileSpan$(start.file, t1, t1);
                }
                return t1;
            },
            _firstNewlineBefore$1: function($location) {
                var lastNewline, codeUnit, t1 = $location.file, t2 = $location.offset, text = A.String_String$fromCharCodes(B.NativeUint32List_methods.sublist$2(t1._decodedChars, 0, t2), 0, null), index = t2 - 1;
                for(lastNewline = null; index >= 0;){
                    codeUnit = text.charCodeAt(index);
                    if (!(codeUnit === 32 || codeUnit === 9 || codeUnit === 10 || codeUnit === 13 || codeUnit === 12)) {
                        if (lastNewline == null) t1 = $location;
                        else {
                            t2 = new A.FileLocation(t1, lastNewline);
                            t2.FileLocation$_$2(t1, lastNewline);
                            t1 = t2;
                        }
                        return t1;
                    }
                    if (codeUnit === 10 || codeUnit === 13 || codeUnit === 12) lastNewline = index;
                    --index;
                }
                return $location;
            }
        };
        A.Parser__parseIdentifier_closure.prototype = {
            call$0: function() {
                var t1 = this.$this, result = t1.identifier$0();
                t1.scanner.expectDone$0();
                return result;
            },
            $signature: 29
        };
        A.Parser_escape_closure.prototype = {
            call$1: function(char) {
                return char === 32 || char === 9 || char === 10 || char === 13 || char === 12;
            },
            $signature: 31
        };
        A.Parser_scanIdentChar_matches.prototype = {
            call$1: function(actual) {
                var t1 = this.char;
                return this.caseSensitive ? actual === t1 : A.characterEqualsIgnoreCase(t1, actual);
            },
            $signature: 50
        };
        A.Parser_spanFrom_closure.prototype = {
            call$0: function() {
                var t1 = this.$this._interpolationMap;
                if (t1 == null) t1 = type$.InterpolationMap._as(t1);
                return t1.mapSpan$1(this.span);
            },
            $signature: 16
        };
        A.Parser_spanFromPosition_closure.prototype = {
            call$0: function() {
                var t1 = this.$this._interpolationMap;
                if (t1 == null) t1 = type$.InterpolationMap._as(t1);
                return t1.mapSpan$1(this.span);
            },
            $signature: 16
        };
        A.SassParser.prototype = {
            get$currentIndentation: function() {
                return this._currentIndentation;
            },
            get$indented: function() {
                return true;
            },
            styleRuleSelector$0: function() {
                var t4, _this = this, t1 = _this.scanner, t2 = t1._string_scanner$_position, t3 = new A.StringBuffer(""), buffer = new A.InterpolationBuffer(t3, A._setArrayType([], type$.JSArray_Object), A._setArrayType([], type$.JSArray_nullable_FileSpan));
                do {
                    buffer.addInterpolation$1(_this.almostAnyValue$1$omitComments(true));
                    t4 = A.Primitives_stringFromCharCode(10);
                    t4 = t3._contents += t4;
                }while (B.JSString_methods.endsWith$1(B.JSString_methods.trimRight$0(t4.charCodeAt(0) == 0 ? t4 : t4), ",") && _this.scanCharIf$1(new A.SassParser_styleRuleSelector_closure()));
                return buffer.interpolation$1(_this.spanFrom$1(new A._SpanScannerState(t1, t2)));
            },
            expectStatementSeparator$1: function($name) {
                var t1, _this = this, trailingSemicolon = _this._tryTrailingSemicolon$0();
                if (!_this.atEndOfStatement$0()) _this._expectNewline$1$trailingSemicolon(trailingSemicolon);
                if (_this._peekIndentation$0() <= _this._currentIndentation) return;
                t1 = $name == null ? "here" : "beneath a " + $name;
                _this.scanner.error$2$position(0, "Nothing may be indented " + t1 + ".", _this._nextIndentationEnd.position);
            },
            expectStatementSeparator$0: function() {
                return this.expectStatementSeparator$1(null);
            },
            atEndOfStatement$0: function() {
                var t1 = this.scanner.peekChar$0();
                if (t1 == null) t1 = null;
                else t1 = t1 === 10 || t1 === 13 || t1 === 12;
                return t1 !== false;
            },
            lookingAtChildren$0: function() {
                return this.atEndOfStatement$0() && this._peekIndentation$0() > this._currentIndentation;
            },
            importArgument$0: function() {
                var url, span, innerError, stackTrace, t1, _0_0, start, t2, next, t3, _$exception, _this = this;
                $label0$0: {
                    t1 = _this.scanner;
                    _0_0 = t1.peekChar$0();
                    if (117 === _0_0 || 85 === _0_0) {
                        start = new A._SpanScannerState(t1, t1._string_scanner$_position);
                        if (_this.scanIdentifier$1("url")) {
                            if (t1.scanChar$1(40)) {
                                t1.set$state(start);
                                return _this.super$StylesheetParser$importArgument();
                            } else t1.set$state(start);
                        }
                        break $label0$0;
                    }
                    if (39 === _0_0 || 34 === _0_0) return _this.super$StylesheetParser$importArgument();
                }
                t2 = t1._string_scanner$_position;
                next = t1.peekChar$0();
                for(;;){
                    t3 = false;
                    if (next != null) {
                        if (next !== 44) {
                            if (next !== 59) t3 = !(next === 10 || next === 13 || next === 12);
                        }
                    }
                    if (!t3) break;
                    t1.readChar$0();
                    next = t1.peekChar$0();
                }
                url = t1.substring$1(0, t2);
                span = _this.spanFrom$1(new A._SpanScannerState(t1, t2));
                if (_this.isPlainImportUrl$1(url)) return new A.StaticImport(new A.Interpolation(A.List_List$unmodifiable([
                    A.serializeValue(new A.SassString(url, true), true, true)
                ], type$.Object), B.List_null, span), null, span);
                else try {
                    t1 = _this.parseImportUrl$1(url);
                    return new A.DynamicImport(t1, span);
                } catch (exception) {
                    t1 = A.unwrapException(exception);
                    if (type$.FormatException._is(t1)) {
                        innerError = t1;
                        stackTrace = A.getTraceFromException(exception);
                        _this.error$3(0, "Invalid URL: " + J.get$message$x(innerError), span, stackTrace);
                    } else throw exception;
                }
            },
            scanElse$1: function(ifIndentation) {
                var t1, t2, startIndentation, startNextIndentation, startNextIndentationEnd, _this = this;
                if (_this._peekIndentation$0() !== ifIndentation) return false;
                t1 = _this.scanner;
                t2 = t1._string_scanner$_position;
                startIndentation = _this._currentIndentation;
                startNextIndentation = _this._nextIndentation;
                startNextIndentationEnd = _this._nextIndentationEnd;
                _this._readIndentation$0();
                if (t1.scanChar$1(64) && _this.scanIdentifier$1("else")) return true;
                t1.set$state(new A._SpanScannerState(t1, t2));
                _this._currentIndentation = startIndentation;
                _this._nextIndentation = startNextIndentation;
                _this._nextIndentationEnd = startNextIndentationEnd;
                return false;
            },
            children$1: function(_, child) {
                var children = A._setArrayType([], type$.JSArray_Statement);
                this._whileIndentedLower$1(new A.SassParser_children_closure(this, child, children));
                return children;
            },
            statements$1: function(statement) {
                var statements, t2, _1_0, t1 = this.scanner, _0_0 = t1.peekChar$0();
                if (9 === _0_0 || 32 === _0_0) t1.error$3$length$position(0, string$.Indent, t1._string_scanner$_position, 0);
                statements = A._setArrayType([], type$.JSArray_Statement);
                for(t2 = t1.string.length; t1._string_scanner$_position !== t2;){
                    _1_0 = this._child$1(statement);
                    if (_1_0 != null) statements.push(_1_0);
                    this._readIndentation$0();
                }
                return statements;
            },
            _child$1: function(child) {
                var _0_0, _this = this, t1 = _this.scanner, _1_0 = t1.peekChar$0();
                $label0$0: {
                    if (13 === _1_0 || 10 === _1_0 || 12 === _1_0) {
                        t1 = null;
                        break $label0$0;
                    }
                    if (36 === _1_0) {
                        t1 = _this.variableDeclarationWithoutNamespace$0();
                        break $label0$0;
                    }
                    if (47 === _1_0) {
                        _0_0 = t1.peekChar$1(1);
                        $label1$1: {
                            if (47 === _0_0) {
                                t1 = _this._silentComment$0();
                                break $label1$1;
                            }
                            if (42 === _0_0) {
                                t1 = _this._loudComment$0();
                                break $label1$1;
                            }
                            t1 = child.call$0();
                            break $label1$1;
                        }
                        break $label0$0;
                    }
                    t1 = child.call$0();
                    break $label0$0;
                }
                return t1;
            },
            _silentComment$0: function() {
                var buffer, parentIndentation, t3, t4, t5, commentPrefix, i, t6, i0, t7, _this = this, t1 = _this.scanner, t2 = t1._string_scanner$_position;
                t1.expect$1("//");
                buffer = new A.StringBuffer("");
                parentIndentation = _this._currentIndentation;
                t3 = t1.string.length;
                t4 = 1 + parentIndentation;
                t5 = 2 + parentIndentation;
                $label0$0: do {
                    commentPrefix = t1.scanChar$1(47) ? "///" : "//";
                    for(i = commentPrefix.length;;){
                        t6 = buffer._contents += commentPrefix;
                        for(i0 = i; i0 < _this._currentIndentation - parentIndentation; ++i0){
                            t6 += A.Primitives_stringFromCharCode(32);
                            buffer._contents = t6;
                        }
                        for(;;){
                            if (t1._string_scanner$_position !== t3) {
                                t7 = t1.peekChar$0();
                                t7 = !(t7 === 10 || t7 === 13 || t7 === 12);
                            } else t7 = false;
                            if (!t7) break;
                            t6 += A.Primitives_stringFromCharCode(t1.readChar$0());
                            buffer._contents = t6;
                        }
                        buffer._contents = t6 + "\n";
                        if (_this._peekIndentation$0() < parentIndentation) break $label0$0;
                        if (_this._peekIndentation$0() === parentIndentation) {
                            if (t1.peekChar$1(t4) === 47 && t1.peekChar$1(t5) === 47) _this._readIndentation$0();
                            break;
                        }
                        _this._readIndentation$0();
                    }
                }while (t1.scan$1("//"));
                t3 = buffer._contents;
                return _this.lastSilentComment = new A.SilentComment(t3.charCodeAt(0) == 0 ? t3 : t3, _this.spanFrom$1(new A._SpanScannerState(t1, t2)));
            },
            _loudComment$0: function() {
                var t2, t3, t4, buffer, parentIndentation, t5, t6, first, beginningOfComment, t7, end, i, _1_0, _0_0, span, _this = this, t1 = _this.scanner, start = new A._SpanScannerState(t1, t1._string_scanner$_position);
                t1.expect$1("/*");
                t2 = new A.StringBuffer("");
                t3 = A._setArrayType([], type$.JSArray_Object);
                t4 = A._setArrayType([], type$.JSArray_nullable_FileSpan);
                buffer = new A.InterpolationBuffer(t2, t3, t4);
                t2._contents = "/*";
                parentIndentation = _this._currentIndentation;
                for(t5 = t1.string, t6 = t5.length, first = true;; first = false){
                    if (first) {
                        beginningOfComment = t1._string_scanner$_position;
                        _this.spaces$0();
                        t7 = t1.peekChar$0();
                        if (t7 === 10 || t7 === 13 || t7 === 12) {
                            _this._readIndentation$0();
                            t7 = A.Primitives_stringFromCharCode(32);
                            t2._contents += t7;
                        } else {
                            end = t1._string_scanner$_position;
                            t2._contents += B.JSString_methods.substring$2(t5, beginningOfComment, end);
                        }
                    } else t2._contents = (t2._contents += "\n") + " * ";
                    for(i = 3; i < _this._currentIndentation - parentIndentation; ++i){
                        t7 = A.Primitives_stringFromCharCode(32);
                        t2._contents += t7;
                    }
                    while(t1._string_scanner$_position !== t6){
                        _1_0 = t1.peekChar$0();
                        if (10 === _1_0 || 13 === _1_0 || 12 === _1_0) break;
                        if (35 === _1_0) {
                            if (t1.peekChar$1(1) === 123) {
                                _0_0 = _this.singleInterpolation$0();
                                buffer._flushText$0();
                                t3.push(_0_0._0);
                                t4.push(_0_0._1);
                            } else {
                                t7 = A.Primitives_stringFromCharCode(t1.readChar$0());
                                t2._contents += t7;
                            }
                            continue;
                        }
                        if (42 === _1_0) {
                            if (t1.peekChar$1(1) === 47) {
                                t3 = A.Primitives_stringFromCharCode(t1.readChar$0());
                                t2._contents += t3;
                                t3 = A.Primitives_stringFromCharCode(t1.readChar$0());
                                t2._contents += t3;
                                span = _this.spanFrom$1(start);
                                _this.whitespace$1$consumeNewlines(false);
                                for(;;){
                                    t2 = t1.peekChar$0();
                                    if (!((t2 === 10 || t2 === 13 || t2 === 12) && _this._peekIndentation$0() > parentIndentation)) break;
                                    while(_this._lookingAtDoubleNewline$0())_this._expectNewline$0();
                                    _this._readIndentation$0();
                                    _this.whitespace$1$consumeNewlines(false);
                                }
                                if (t1._string_scanner$_position !== t6) {
                                    t2 = t1.peekChar$0();
                                    t2 = !(t2 === 10 || t2 === 13 || t2 === 12);
                                } else t2 = false;
                                if (t2) {
                                    t2 = t1._string_scanner$_position;
                                    for(;;){
                                        if (t1._string_scanner$_position !== t6) {
                                            t3 = t1.peekChar$0();
                                            t3 = !(t3 === 10 || t3 === 13 || t3 === 12);
                                        } else t3 = false;
                                        if (!t3) break;
                                        t1.readChar$0();
                                    }
                                    throw A.wrapException(A.MultiSpanSassFormatException$("Unexpected text after end of comment", _this.spanFrom$1(new A._SpanScannerState(t1, t2)), "extra text", A.LinkedHashMap_LinkedHashMap$_literal([
                                        span,
                                        "comment"
                                    ], type$.FileSpan, type$.String), null));
                                } else return new A.LoudComment(buffer.interpolation$1(span));
                            } else {
                                t7 = A.Primitives_stringFromCharCode(t1.readChar$0());
                                t2._contents += t7;
                            }
                            continue;
                        }
                        t7 = A.Primitives_stringFromCharCode(t1.readChar$0());
                        t2._contents += t7;
                    }
                    if (_this._peekIndentation$0() <= parentIndentation) break;
                    while(_this._lookingAtDoubleNewline$0()){
                        _this._expectNewline$0();
                        t2._contents = (t2._contents += "\n") + " *";
                    }
                    _this._readIndentation$0();
                }
                return new A.LoudComment(buffer.interpolation$1(_this.spanFrom$1(start)));
            },
            whitespaceWithoutComments$1$consumeNewlines: function(consumeNewlines) {
                var t1, t2, next, t3;
                for(t1 = this.scanner, t2 = t1.string.length; t1._string_scanner$_position !== t2;){
                    next = t1.peekChar$0();
                    if (consumeNewlines) t3 = !(next === 32 || next === 9 || next === 10 || next === 13 || next === 12);
                    else t3 = !(next === 32 || next === 9);
                    if (t3) break;
                    t1.readChar$0();
                }
            },
            _expectNewline$1$trailingSemicolon: function(trailingSemicolon) {
                var t1 = this.scanner, _0_0 = t1.peekChar$0();
                if (13 === _0_0) {
                    t1.readChar$0();
                    if (t1.peekChar$0() === 10) t1.readChar$0();
                    return;
                }
                if (10 === _0_0 || 12 === _0_0) {
                    t1.readChar$0();
                    return;
                }
                t1.error$1(0, trailingSemicolon ? string$.multip : "expected newline.");
            },
            _expectNewline$0: function() {
                return this._expectNewline$1$trailingSemicolon(false);
            },
            _lookingAtDoubleNewline$0: function() {
                var t2, _0_0, t1 = this.scanner, _1_0 = t1.peekChar$0();
                $label1$1: {
                    t2 = false;
                    if (13 === _1_0) {
                        _0_0 = t1.peekChar$1(1);
                        $label0$0: {
                            if (10 === _0_0) {
                                t1 = t1.peekChar$1(2);
                                t1 = t1 === 10 || t1 === 13 || t1 === 12;
                                break $label0$0;
                            }
                            if (13 === _0_0 || 12 === _0_0) {
                                t1 = true;
                                break $label0$0;
                            }
                            t1 = t2;
                            break $label0$0;
                        }
                        break $label1$1;
                    }
                    if (10 === _1_0 || 12 === _1_0) {
                        t1 = t1.peekChar$1(1);
                        t1 = t1 === 10 || t1 === 13 || t1 === 12;
                        break $label1$1;
                    }
                    t1 = t2;
                    break $label1$1;
                }
                return t1;
            },
            _whileIndentedLower$1: function(body) {
                var t1, t2, childIndentation, indentation, t3, t4, _this = this, parentIndentation = _this._currentIndentation;
                for(t1 = _this.scanner, t2 = t1._sourceFile, childIndentation = null; _this._peekIndentation$0() > parentIndentation;){
                    indentation = _this._readIndentation$0();
                    if (childIndentation == null) childIndentation = indentation;
                    if (childIndentation !== indentation) {
                        t3 = t1._string_scanner$_position;
                        t4 = t2.getColumn$1(t3);
                        t1.error$3$length$position(0, "Inconsistent indentation, expected " + childIndentation + " spaces.", t2.getColumn$1(t1._string_scanner$_position), t3 - t4);
                    }
                    body.call$0();
                }
            },
            _readIndentation$0: function() {
                var t1, _this = this, currentIndentation = _this._nextIndentation;
                if (currentIndentation == null) currentIndentation = _this._nextIndentation = _this._peekIndentation$0();
                _this._currentIndentation = currentIndentation;
                t1 = _this._nextIndentationEnd;
                t1.toString;
                _this.scanner.set$state(t1);
                _this._nextIndentationEnd = _this._nextIndentation = null;
                return currentIndentation;
            },
            _peekIndentation$0: function() {
                var t1, t2, t3, start, containsTab, containsSpace, nextIndentation, _1_0, t4, _this = this, _0_0 = _this._nextIndentation;
                if (_0_0 != null) return _0_0;
                t1 = _this.scanner;
                t2 = t1._string_scanner$_position;
                t3 = t1.string.length;
                if (t2 === t3) {
                    _this._nextIndentation = 0;
                    _this._nextIndentationEnd = new A._SpanScannerState(t1, t2);
                    return 0;
                }
                start = new A._SpanScannerState(t1, t2);
                if (!_this.scanCharIf$1(new A.SassParser__peekIndentation_closure())) t1.error$2$position(0, "Expected newline.", t1._string_scanner$_position);
                containsTab = A._Cell$();
                containsSpace = A._Cell$();
                nextIndentation = A._Cell$();
                do {
                    containsSpace.__late_helper$_value = containsTab.__late_helper$_value = false;
                    nextIndentation.__late_helper$_value = 0;
                    for(;;){
                        $label0$0: {
                            _1_0 = t1.peekChar$0();
                            if (32 === _1_0) {
                                containsSpace.__late_helper$_value = true;
                                break $label0$0;
                            }
                            if (9 === _1_0) {
                                containsTab.__late_helper$_value = true;
                                break $label0$0;
                            }
                            break;
                        }
                        t2 = nextIndentation.__late_helper$_value;
                        if (t2 === nextIndentation) A.throwExpression(A.LateError$localNI(""));
                        nextIndentation.__late_helper$_value = t2 + 1;
                        t1.readChar$0();
                    }
                    t2 = t1._string_scanner$_position;
                    if (t2 === t3) {
                        _this._nextIndentation = 0;
                        _this._nextIndentationEnd = new A._SpanScannerState(t1, t2);
                        t1.set$state(start);
                        return 0;
                    }
                }while (_this.scanCharIf$1(new A.SassParser__peekIndentation_closure0()));
                t2 = containsTab._readLocal$0();
                t3 = containsSpace._readLocal$0();
                if (t2) {
                    if (t3) {
                        t2 = t1._string_scanner$_position;
                        t3 = t1._sourceFile;
                        t4 = t3.getColumn$1(t2);
                        t1.error$3$length$position(0, "Tabs and spaces may not be mixed.", t3.getColumn$1(t1._string_scanner$_position), t2 - t4);
                    } else if (_this._spaces === true) {
                        t2 = t1._string_scanner$_position;
                        t3 = t1._sourceFile;
                        t4 = t3.getColumn$1(t2);
                        t1.error$3$length$position(0, "Expected spaces, was tabs.", t3.getColumn$1(t1._string_scanner$_position), t2 - t4);
                    }
                } else if (t3 && _this._spaces === false) {
                    t2 = t1._string_scanner$_position;
                    t3 = t1._sourceFile;
                    t4 = t3.getColumn$1(t2);
                    t1.error$3$length$position(0, "Expected tabs, was spaces.", t3.getColumn$1(t1._string_scanner$_position), t2 - t4);
                }
                _this._nextIndentation = nextIndentation._readLocal$0();
                if (nextIndentation._readLocal$0() > 0) {
                    if (_this._spaces == null) _this._spaces = containsSpace._readLocal$0();
                }
                _this._nextIndentationEnd = new A._SpanScannerState(t1, t1._string_scanner$_position);
                t1.set$state(start);
                return nextIndentation._readLocal$0();
            },
            _tryTrailingSemicolon$0: function() {
                if (this.scanCharIf$1(new A.SassParser__tryTrailingSemicolon_closure())) {
                    this.whitespace$1$consumeNewlines(false);
                    return true;
                }
                return false;
            }
        };
        A.SassParser_styleRuleSelector_closure.prototype = {
            call$1: function(char) {
                return char === 10 || char === 13 || char === 12;
            },
            $signature: 31
        };
        A.SassParser_children_closure.prototype = {
            call$0: function() {
                var _0_0 = this.$this._child$1(this.child);
                if (_0_0 != null) this.children.push(_0_0);
            },
            $signature: 0
        };
        A.SassParser__peekIndentation_closure.prototype = {
            call$1: function(char) {
                return char === 10 || char === 13 || char === 12;
            },
            $signature: 31
        };
        A.SassParser__peekIndentation_closure0.prototype = {
            call$1: function(char) {
                return char === 10 || char === 13 || char === 12;
            },
            $signature: 31
        };
        A.SassParser__tryTrailingSemicolon_closure.prototype = {
            call$1: function(char) {
                return char === 59;
            },
            $signature: 31
        };
        A.ScssParser.prototype = {
            get$indented: function() {
                return false;
            },
            get$currentIndentation: function() {
                return 0;
            },
            styleRuleSelector$0: function() {
                return this.almostAnyValue$0();
            },
            expectStatementSeparator$1: function($name) {
                var t1, _0_0;
                this.whitespaceWithoutComments$1$consumeNewlines(true);
                t1 = this.scanner;
                if (t1._string_scanner$_position === t1.string.length) return;
                _0_0 = t1.peekChar$0();
                if (59 === _0_0 || 125 === _0_0) return;
                t1.expectChar$1(59);
            },
            expectStatementSeparator$0: function() {
                return this.expectStatementSeparator$1(null);
            },
            atEndOfStatement$0: function() {
                var next = this.scanner.peekChar$0();
                return next == null || next === 59 || next === 125 || next === 123;
            },
            lookingAtChildren$0: function() {
                return this.scanner.peekChar$0() === 123;
            },
            scanElse$1: function(ifIndentation) {
                var t3, _this = this, t1 = _this.scanner, t2 = t1._string_scanner$_position;
                _this.whitespace$1$consumeNewlines(true);
                t3 = t1._string_scanner$_position;
                if (t1.scanChar$1(64)) {
                    if (_this.scanIdentifier$2$caseSensitive("else", true)) return true;
                    if (_this.scanIdentifier$2$caseSensitive("elseif", true)) {
                        _this.warnings.push(new A._Record_3_deprecation_message_span(B.Deprecation_HUu, string$.x40elsei, _this.spanFrom$1(new A._SpanScannerState(t1, t3))));
                        t1.set$position(t1._string_scanner$_position - 2);
                        return true;
                    }
                }
                t1.set$state(new A._SpanScannerState(t1, t2));
                return false;
            },
            children$1: function(_, child) {
                var children, _this = this, t1 = _this.scanner;
                t1.expectChar$1(123);
                _this.whitespaceWithoutComments$1$consumeNewlines(true);
                children = A._setArrayType([], type$.JSArray_Statement);
                for(;;)switch(t1.peekChar$0()){
                    case 36:
                        children.push(_this.variableDeclarationWithoutNamespace$0());
                        break;
                    case 47:
                        switch(t1.peekChar$1(1)){
                            case 47:
                                children.push(_this._scss$_silentComment$0());
                                _this.whitespaceWithoutComments$1$consumeNewlines(true);
                                break;
                            case 42:
                                children.push(_this._scss$_loudComment$0());
                                _this.whitespaceWithoutComments$1$consumeNewlines(true);
                                break;
                            default:
                                children.push(child.call$0());
                        }
                        break;
                    case 59:
                        t1.readChar$0();
                        _this.whitespaceWithoutComments$1$consumeNewlines(true);
                        break;
                    case 125:
                        t1.expectChar$1(125);
                        return children;
                    default:
                        children.push(child.call$0());
                }
            },
            statements$1: function(statement) {
                var t1, t2, _0_0, _1_0, _this = this, statements = A._setArrayType([], type$.JSArray_Statement);
                _this.whitespaceWithoutComments$1$consumeNewlines(true);
                for(t1 = _this.scanner, t2 = t1.string.length; t1._string_scanner$_position !== t2;)switch(t1.peekChar$0()){
                    case 36:
                        statements.push(_this.variableDeclarationWithoutNamespace$0());
                        break;
                    case 47:
                        switch(t1.peekChar$1(1)){
                            case 47:
                                statements.push(_this._scss$_silentComment$0());
                                _this.whitespaceWithoutComments$1$consumeNewlines(true);
                                break;
                            case 42:
                                statements.push(_this._scss$_loudComment$0());
                                _this.whitespaceWithoutComments$1$consumeNewlines(true);
                                break;
                            default:
                                _0_0 = statement.call$0();
                                if (_0_0 != null) statements.push(_0_0);
                        }
                        break;
                    case 59:
                        t1.readChar$0();
                        _this.whitespaceWithoutComments$1$consumeNewlines(true);
                        break;
                    default:
                        _1_0 = statement.call$0();
                        if (_1_0 != null) statements.push(_1_0);
                }
                return statements;
            },
            _scss$_silentComment$0: function() {
                var t3, t4, _this = this, t1 = _this.scanner, t2 = t1._string_scanner$_position, start = new A._SpanScannerState(t1, t2);
                t1.expect$1("//");
                t3 = t1.string.length;
                do {
                    for(;;){
                        if (t1._string_scanner$_position !== t3) {
                            t4 = t1.readChar$0();
                            t4 = !(t4 === 10 || t4 === 13 || t4 === 12);
                        } else t4 = false;
                        if (!t4) break;
                    }
                    if (t1._string_scanner$_position === t3) break;
                    _this.spaces$0();
                }while (t1.scan$1("//"));
                if (_this.get$plainCss()) _this.error$2(0, string$.Silent, _this.spanFrom$1(start));
                return _this.lastSilentComment = new A.SilentComment(t1.substring$1(0, t2), _this.spanFrom$1(start));
            },
            _scss$_loudComment$0: function() {
                var t3, t4, t5, buffer, _0_0, t6, t1 = this.scanner, t2 = t1._string_scanner$_position;
                t1.expect$1("/*");
                t3 = new A.StringBuffer("");
                t4 = A._setArrayType([], type$.JSArray_Object);
                t5 = A._setArrayType([], type$.JSArray_nullable_FileSpan);
                buffer = new A.InterpolationBuffer(t3, t4, t5);
                t3._contents = "/*";
                $label0$1: for(;;)switch(t1.peekChar$0()){
                    case 35:
                        if (t1.peekChar$1(1) === 123) {
                            _0_0 = this.singleInterpolation$0();
                            buffer._flushText$0();
                            t4.push(_0_0._0);
                            t5.push(_0_0._1);
                        } else {
                            t6 = A.Primitives_stringFromCharCode(t1.readChar$0());
                            t3._contents += t6;
                        }
                        break;
                    case 42:
                        t6 = A.Primitives_stringFromCharCode(t1.readChar$0());
                        t3._contents += t6;
                        if (t1.peekChar$0() !== 47) continue $label0$1;
                        t4 = A.Primitives_stringFromCharCode(t1.readChar$0());
                        t3._contents += t4;
                        return new A.LoudComment(buffer.interpolation$1(this.spanFrom$1(new A._SpanScannerState(t1, t2))));
                    case 13:
                        t1.readChar$0();
                        if (t1.peekChar$0() !== 10) {
                            t6 = A.Primitives_stringFromCharCode(10);
                            t3._contents += t6;
                        }
                        break;
                    case 12:
                        t1.readChar$0();
                        t6 = A.Primitives_stringFromCharCode(10);
                        t3._contents += t6;
                        break;
                    default:
                        t6 = A.Primitives_stringFromCharCode(t1.readChar$0());
                        t3._contents += t6;
                }
            }
        };
        A.SelectorParser.prototype = {
            parse$0: function(_) {
                return this.wrapSpanFormatException$1(new A.SelectorParser_parse_closure(this));
            },
            parseCompoundSelector$0: function() {
                return this.wrapSpanFormatException$1(new A.SelectorParser_parseCompoundSelector_closure(this));
            },
            _selectorList$0: function() {
                var t4, t5, lineBreak, _this = this, t1 = _this.scanner, t2 = t1._string_scanner$_position, t3 = t1._sourceFile, previousLine = t3.getLine$1(t2), components = A._setArrayType([
                    _this._complexSelector$0()
                ], type$.JSArray_ComplexSelector);
                _this.whitespace$1$consumeNewlines(true);
                for(t4 = t1.string.length; t1.scanChar$1(44);){
                    _this.whitespace$1$consumeNewlines(true);
                    if (t1.peekChar$0() === 44) continue;
                    t5 = t1._string_scanner$_position;
                    if (t5 === t4) break;
                    lineBreak = t3.getLine$1(t5) !== previousLine;
                    if (lineBreak) previousLine = t3.getLine$1(t1._string_scanner$_position);
                    components.push(_this._complexSelector$1$lineBreak(lineBreak));
                }
                return A.SelectorList$(components, _this.spanFrom$1(new A._SpanScannerState(t1, t2)));
            },
            _complexSelector$1$lineBreak: function(lineBreak) {
                var t4, t5, lastCompound, initialCombinators, beforeWhitespace, t6, _0_0, t7, t8, result, nextCompound, _this = this, _s18_ = "expected selector.", t1 = _this.scanner, t2 = t1._string_scanner$_position, componentStart = new A._SpanScannerState(t1, t2), t3 = type$.JSArray_CssValue_Combinator, combinators = A._setArrayType([], t3), components = A._setArrayType([], type$.JSArray_ComplexSelectorComponent);
                for(t4 = type$.CssValue_Combinator, t5 = _this._selector$_logger, lastCompound = null, initialCombinators = null;;){
                    beforeWhitespace = t1._string_scanner$_position;
                    _this.whitespace$1$consumeNewlines(true);
                    t6 = t1._string_scanner$_position === beforeWhitespace;
                    _0_0 = t1.peekChar$0();
                    if (43 === _0_0) {
                        t6 = t1._string_scanner$_position;
                        t1.readChar$0();
                        combinators.push(new A.CssValue(B.Combinator_sHB, _this.spanFrom$1(new A._SpanScannerState(t1, t6)), t4));
                        continue;
                    }
                    if (62 === _0_0) {
                        t6 = t1._string_scanner$_position;
                        t1.readChar$0();
                        combinators.push(new A.CssValue(B.Combinator_iUF, _this.spanFrom$1(new A._SpanScannerState(t1, t6)), t4));
                        continue;
                    }
                    if (126 === _0_0) {
                        t6 = t1._string_scanner$_position;
                        t1.readChar$0();
                        combinators.push(new A.CssValue(B.Combinator_98W, _this.spanFrom$1(new A._SpanScannerState(t1, t6)), t4));
                        continue;
                    }
                    if (_0_0 == null) break;
                    t7 = true;
                    if (91 !== _0_0) {
                        if (46 !== _0_0) {
                            if (35 !== _0_0) {
                                if (37 !== _0_0) {
                                    if (58 !== _0_0) {
                                        if (38 !== _0_0) {
                                            if (42 !== _0_0) {
                                                if (124 !== _0_0) t7 = _this.lookingAtIdentifier$0();
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                    if (t7) {
                        t7 = lastCompound != null;
                        if (t7) {
                            t8 = _this.spanFrom$1(componentStart);
                            result = A.List_List$from(combinators, false, t4);
                            result.$flags = 3;
                            components.push(new A.ComplexSelectorComponent(lastCompound, result, t8));
                        } else if (combinators.length !== 0) {
                            componentStart = new A._SpanScannerState(t1, t1._string_scanner$_position);
                            initialCombinators = combinators;
                        }
                        nextCompound = _this._compoundSelector$0();
                        if (t7 && combinators.length === 0 && t6) A.WarnForDeprecation_warnForDeprecation(t5, B.Deprecation_V8h, string$.Adjace + lastCompound.toString$0(0) + " " + nextCompound.toString$0(0) + string$.x0a_Morex3aa, lastCompound.span.expand$1(0, nextCompound.span), null);
                        combinators = A._setArrayType([], t3);
                        if (t1.peekChar$0() === 38) t1.error$1(0, string$.x22x26__ma);
                        lastCompound = nextCompound;
                        continue;
                    }
                    break;
                }
                t3 = combinators.length !== 0;
                if (t3 && _this._plainCss) t1.error$1(0, _s18_);
                else if (lastCompound != null) {
                    t3 = _this.spanFrom$1(componentStart);
                    components.push(new A.ComplexSelectorComponent(lastCompound, A.List_List$unmodifiable(combinators, t4), t3));
                } else if (t3) initialCombinators = combinators;
                else t1.error$1(0, _s18_);
                t3 = initialCombinators == null ? B.List_empty0 : initialCombinators;
                return A.ComplexSelector$(t3, components, _this.spanFrom$1(new A._SpanScannerState(t1, t2)), lineBreak);
            },
            _complexSelector$0: function() {
                return this._complexSelector$1$lineBreak(false);
            },
            _compoundSelector$0: function() {
                var t3, _this = this, t1 = _this.scanner, t2 = t1._string_scanner$_position, components = A._setArrayType([
                    _this._simpleSelector$0()
                ], type$.JSArray_SimpleSelector);
                for(t3 = _this._plainCss; _this._isSimpleSelectorStart$1(t1.peekChar$0());)components.push(_this._simpleSelector$1$allowParent(t3));
                return A.CompoundSelector$(components, _this.spanFrom$1(new A._SpanScannerState(t1, t2)));
            },
            _simpleSelector$1$allowParent: function(allowParent) {
                var t2, $name, text, t3, suffix, _this = this, t1 = _this.scanner, start = new A._SpanScannerState(t1, t1._string_scanner$_position);
                if (allowParent == null) allowParent = _this._allowParent;
                switch(t1.peekChar$0()){
                    case 91:
                        return _this._attributeSelector$0();
                    case 46:
                        t2 = t1._string_scanner$_position;
                        t1.expectChar$1(46);
                        return new A.ClassSelector(_this.identifier$0(), _this.spanFrom$1(new A._SpanScannerState(t1, t2)));
                    case 35:
                        t2 = t1._string_scanner$_position;
                        t1.expectChar$1(35);
                        return new A.IDSelector(_this.identifier$0(), _this.spanFrom$1(new A._SpanScannerState(t1, t2)));
                    case 37:
                        t2 = t1._string_scanner$_position;
                        t1.expectChar$1(37);
                        $name = _this.identifier$0();
                        t2 = _this.spanFrom$1(new A._SpanScannerState(t1, t2));
                        if (_this._plainCss) _this.error$2(0, string$.Placeh, _this.spanFrom$1(start));
                        return new A.PlaceholderSelector($name, t2);
                    case 58:
                        return _this._pseudoSelector$0();
                    case 38:
                        t2 = t1._string_scanner$_position;
                        t1.expectChar$1(38);
                        if (_this.lookingAtIdentifierBody$0()) {
                            text = new A.StringBuffer("");
                            _this._identifierBody$1(text);
                            if (text._contents.length === 0) t1.error$1(0, "Expected identifier body.");
                            t3 = text._contents;
                            suffix = t3.charCodeAt(0) == 0 ? t3 : t3;
                        } else suffix = null;
                        if (_this._plainCss && suffix != null) t1.error$3$length$position(0, string$.Parent, t1._string_scanner$_position - t2, t2);
                        t1 = _this.spanFrom$1(new A._SpanScannerState(t1, t2));
                        if (!allowParent) _this.error$2(0, "Parent selectors aren't allowed here.", _this.spanFrom$1(start));
                        return new A.ParentSelector(suffix, t1);
                    default:
                        return _this._typeOrUniversalSelector$0();
                }
            },
            _simpleSelector$0: function() {
                return this._simpleSelector$1$allowParent(null);
            },
            _attributeSelector$0: function() {
                var $name, operator, next, value, modifier, _this = this, _null = null, t1 = _this.scanner, start = new A._SpanScannerState(t1, t1._string_scanner$_position);
                t1.expectChar$1(91);
                _this.whitespace$1$consumeNewlines(true);
                $name = _this._attributeName$0();
                _this.whitespace$1$consumeNewlines(true);
                if (t1.scanChar$1(93)) return new A.AttributeSelector($name, _null, _null, _null, _this.spanFrom$1(start));
                operator = _this._attributeOperator$0();
                _this.whitespace$1$consumeNewlines(true);
                next = t1.peekChar$0();
                value = next === 39 || next === 34 ? _this.string$0() : _this.identifier$0();
                _this.whitespace$1$consumeNewlines(true);
                next = t1.peekChar$0();
                modifier = next != null && A.CharacterExtension_get_isAlphabetic(next) ? A.Primitives_stringFromCharCode(t1.readChar$0()) : _null;
                t1.expectChar$1(93);
                return new A.AttributeSelector($name, operator, value, modifier, _this.spanFrom$1(start));
            },
            _attributeName$0: function() {
                var nameOrNamespace, _this = this, t1 = _this.scanner;
                if (t1.scanChar$1(42)) {
                    t1.expectChar$1(124);
                    return new A.QualifiedName(_this.identifier$0(), "*");
                }
                if (t1.scanChar$1(124)) return new A.QualifiedName(_this.identifier$0(), "");
                nameOrNamespace = _this.identifier$0();
                if (t1.peekChar$0() !== 124 || t1.peekChar$1(1) === 61) return new A.QualifiedName(nameOrNamespace, null);
                t1.readChar$0();
                return new A.QualifiedName(_this.identifier$0(), nameOrNamespace);
            },
            _attributeOperator$0: function() {
                var t1 = this.scanner, start = t1._string_scanner$_position;
                switch(t1.readChar$0()){
                    case 61:
                        return B.AttributeOperator_jFZ;
                    case 126:
                        t1.expectChar$1(61);
                        return B.AttributeOperator_OrK;
                    case 124:
                        t1.expectChar$1(61);
                        return B.AttributeOperator_g5B;
                    case 94:
                        t1.expectChar$1(61);
                        return B.AttributeOperator_stc;
                    case 36:
                        t1.expectChar$1(61);
                        return B.AttributeOperator_xJ9;
                    case 42:
                        t1.expectChar$1(61);
                        return B.AttributeOperator_h20;
                    default:
                        t1.error$2$position(0, 'Expected "]".', start);
                }
            },
            _pseudoSelector$0: function() {
                var element, $name, unvendored, argument, selector, t2, _this = this, _null = null, t1 = _this.scanner, start = new A._SpanScannerState(t1, t1._string_scanner$_position);
                t1.expectChar$1(58);
                element = t1.scanChar$1(58);
                $name = _this.identifier$0();
                if (!t1.scanChar$1(40)) return A.PseudoSelector$($name, _this.spanFrom$1(start), _null, element, _null);
                _this.whitespace$1$consumeNewlines(true);
                unvendored = A.unvendor($name);
                argument = _null;
                selector = _null;
                if (element) {
                    if ($.selectorPseudoElements.contains$1(0, unvendored)) selector = _this._selectorList$0();
                    else argument = _this.declarationValue$1$allowEmpty(true);
                } else if ($.selectorPseudoClasses.contains$1(0, unvendored)) selector = _this._selectorList$0();
                else if (unvendored === "nth-child" || unvendored === "nth-last-child") {
                    argument = _this._aNPlusB$0();
                    _this.whitespace$1$consumeNewlines(true);
                    t2 = t1.peekChar$1(-1);
                    if ((t2 === 32 || t2 === 9 || t2 === 10 || t2 === 13 || t2 === 12) && t1.peekChar$0() !== 41) {
                        _this.expectIdentifier$1("of");
                        argument += " of";
                        _this.whitespace$1$consumeNewlines(true);
                        selector = _this._selectorList$0();
                    }
                } else argument = B.JSString_methods.trimRight$0(_this.declarationValue$1$allowEmpty(true));
                t1.expectChar$1(41);
                return A.PseudoSelector$($name, _this.spanFrom$1(start), argument, element, selector);
            },
            _aNPlusB$0: function() {
                var t1, _0_0, t2, $self, next, _this = this;
                $label0$0: {
                    t1 = _this.scanner;
                    _0_0 = t1.peekChar$0();
                    if (101 === _0_0 || 69 === _0_0) {
                        _this.expectIdentifier$1("even");
                        return "even";
                    }
                    if (111 === _0_0 || 79 === _0_0) {
                        _this.expectIdentifier$1("odd");
                        return "odd";
                    }
                    if (43 === _0_0 || 45 === _0_0) {
                        t2 = A.Primitives_stringFromCharCode(t1.readChar$0());
                        break $label0$0;
                    }
                    t2 = "";
                }
                $self = t1.peekChar$0();
                if ($self != null && $self >= 48 && $self <= 57) {
                    do {
                        t2 += A.Primitives_stringFromCharCode(t1.readChar$0());
                        $self = t1.peekChar$0();
                    }while ($self != null && $self >= 48 && $self <= 57);
                    _this.whitespace$1$consumeNewlines(true);
                    if (!_this.scanIdentChar$1(110)) return t2.charCodeAt(0) == 0 ? t2 : t2;
                } else _this.expectIdentChar$1(110);
                t2 += A.Primitives_stringFromCharCode(110);
                _this.whitespace$1$consumeNewlines(true);
                next = t1.peekChar$0();
                if (next !== 43 && next !== 45) return t2.charCodeAt(0) == 0 ? t2 : t2;
                t2 += A.Primitives_stringFromCharCode(t1.readChar$0());
                _this.whitespace$1$consumeNewlines(true);
                $self = t1.peekChar$0();
                if (!($self != null && $self >= 48 && $self <= 57)) t1.error$1(0, "Expected a number.");
                do {
                    t2 += A.Primitives_stringFromCharCode(t1.readChar$0());
                    $self = t1.peekChar$0();
                }while ($self != null && $self >= 48 && $self <= 57);
                return t2.charCodeAt(0) == 0 ? t2 : t2;
            },
            _typeOrUniversalSelector$0: function() {
                var nameOrNamespace, _this = this, t1 = _this.scanner, start = new A._SpanScannerState(t1, t1._string_scanner$_position);
                if (t1.scanChar$1(42)) {
                    if (!t1.scanChar$1(124)) return new A.UniversalSelector(null, _this.spanFrom$1(start));
                    return t1.scanChar$1(42) ? new A.UniversalSelector("*", _this.spanFrom$1(start)) : new A.TypeSelector(new A.QualifiedName(_this.identifier$0(), "*"), _this.spanFrom$1(start));
                } else if (t1.scanChar$1(124)) return t1.scanChar$1(42) ? new A.UniversalSelector("", _this.spanFrom$1(start)) : new A.TypeSelector(new A.QualifiedName(_this.identifier$0(), ""), _this.spanFrom$1(start));
                nameOrNamespace = _this.identifier$0();
                if (!t1.scanChar$1(124)) return new A.TypeSelector(new A.QualifiedName(nameOrNamespace, null), _this.spanFrom$1(start));
                else if (t1.scanChar$1(42)) return new A.UniversalSelector(nameOrNamespace, _this.spanFrom$1(start));
                else return new A.TypeSelector(new A.QualifiedName(_this.identifier$0(), nameOrNamespace), _this.spanFrom$1(start));
            },
            _isSimpleSelectorStart$1: function(character) {
                var t1;
                $label0$0: {
                    if (42 === character || 91 === character || 46 === character || 35 === character || 37 === character || 58 === character) {
                        t1 = true;
                        break $label0$0;
                    }
                    if (38 === character) {
                        t1 = this._plainCss;
                        break $label0$0;
                    }
                    t1 = false;
                    break $label0$0;
                }
                return t1;
            }
        };
        A.SelectorParser_parse_closure.prototype = {
            call$0: function() {
                var t1 = this.$this, selector = t1._selectorList$0();
                t1 = t1.scanner;
                if (t1._string_scanner$_position !== t1.string.length) t1.error$1(0, "expected selector.");
                return selector;
            },
            $signature: 450
        };
        A.SelectorParser_parseCompoundSelector_closure.prototype = {
            call$0: function() {
                var t1 = this.$this, compound = t1._compoundSelector$0();
                t1 = t1.scanner;
                if (t1._string_scanner$_position !== t1.string.length) t1.error$1(0, "expected selector.");
                return compound;
            },
            $signature: 453
        };
        A.StylesheetParser.prototype = {
            parse$0: function(_) {
                return this.wrapSpanFormatException$1(new A.StylesheetParser_parse_closure(this));
            },
            parseParameterList$0: function() {
                return this._parseSingleProduction$1$1(new A.StylesheetParser_parseParameterList_closure(this), type$.ParameterList);
            },
            parseVariableDeclaration$0: function() {
                return new A._Record_2(this._parseSingleProduction$1$1(new A.StylesheetParser_parseVariableDeclaration_closure(this), type$.VariableDeclaration), this.warnings);
            },
            parseUseRule$0: function() {
                return new A._Record_2(this._parseSingleProduction$1$1(new A.StylesheetParser_parseUseRule_closure(this), type$.UseRule), this.warnings);
            },
            _parseSingleProduction$1$1: function(production, $T) {
                return this.wrapSpanFormatException$1(new A.StylesheetParser__parseSingleProduction_closure(this, production, $T));
            },
            _statement$1$root: function(root) {
                var t2, _this = this, t1 = _this.scanner, _0_0 = t1.peekChar$0();
                if (64 === _0_0) return _this.atRule$2$root(new A.StylesheetParser__statement_closure(_this), root);
                if (43 === _0_0) {
                    if (!_this.get$indented() || !_this.lookingAtIdentifier$1(1)) return _this._styleRule$0();
                    _this._isUseAllowed = false;
                    t2 = t1._string_scanner$_position;
                    t1.readChar$0();
                    return _this._includeRule$1(new A._SpanScannerState(t1, t2));
                }
                if (61 === _0_0) {
                    if (!_this.get$indented()) return _this._styleRule$0();
                    _this._isUseAllowed = false;
                    t2 = t1._string_scanner$_position;
                    t1.readChar$0();
                    _this.whitespace$1$consumeNewlines(true);
                    return _this._mixinRule$1(new A._SpanScannerState(t1, t2));
                }
                if (125 === _0_0) t1.error$2$length(0, 'unmatched "}".', 1);
                return _this._inStyleRule || _this._stylesheet$_inUnknownAtRule || _this._stylesheet$_inMixin || _this._inContentBlock ? _this._declarationOrStyleRule$0() : _this._variableDeclarationOrStyleRule$0();
            },
            _statement$0: function() {
                return this._statement$1$root(false);
            },
            _variableDeclarationWithNamespace$0: function() {
                var t1 = this.scanner, t2 = t1._string_scanner$_position, namespace = this.identifier$0();
                t1.expectChar$1(46);
                return this.variableDeclarationWithoutNamespace$2(namespace, new A._SpanScannerState(t1, t2));
            },
            variableDeclarationWithoutNamespace$2: function(namespace, start_) {
                var t1, start, $name, t2, value, flagStart, t3, guarded, global, _0_0, declaration, _this = this, precedingComment = _this.lastSilentComment;
                _this.lastSilentComment = null;
                if (start_ == null) {
                    t1 = _this.scanner;
                    start = new A._SpanScannerState(t1, t1._string_scanner$_position);
                } else start = start_;
                $name = _this.variableName$0();
                t1 = namespace != null;
                if (t1) _this._assertPublic$2($name, new A.StylesheetParser_variableDeclarationWithoutNamespace_closure(_this, start));
                if (_this.get$plainCss()) _this.error$2(0, string$.Sass_v, _this.spanFrom$1(start));
                _this.whitespace$1$consumeNewlines(true);
                t2 = _this.scanner;
                t2.expectChar$1(58);
                _this.whitespace$1$consumeNewlines(true);
                value = _this._expression$0();
                flagStart = new A._SpanScannerState(t2, t2._string_scanner$_position);
                for(t3 = _this.warnings, guarded = false, global = false; t2.scanChar$1(33);){
                    $label0$0: {
                        _0_0 = _this.identifier$0();
                        if ("default" === _0_0) {
                            if (guarded) t3.push(new A._Record_3_deprecation_message_span(B.Deprecation_nRC, string$.x21defau, _this.spanFrom$1(flagStart)));
                            guarded = true;
                            break $label0$0;
                        }
                        if ("global" === _0_0) {
                            if (t1) _this.error$2(0, string$.x21globai, _this.spanFrom$1(flagStart));
                            else if (global) t3.push(new A._Record_3_deprecation_message_span(B.Deprecation_nRC, string$.x21globas, _this.spanFrom$1(flagStart)));
                            global = true;
                            break $label0$0;
                        }
                        _this.error$2(0, "Invalid flag name.", _this.spanFrom$1(flagStart));
                    }
                    _this.whitespace$1$consumeNewlines(false);
                    flagStart = new A._SpanScannerState(t2, t2._string_scanner$_position);
                }
                _this.expectStatementSeparator$1("variable declaration");
                declaration = A.VariableDeclaration$($name, value, _this.spanFrom$1(start), precedingComment, global, guarded, namespace);
                if (global) _this._globalVariables.putIfAbsent$2($name, new A.StylesheetParser_variableDeclarationWithoutNamespace_closure0(declaration));
                return declaration;
            },
            variableDeclarationWithoutNamespace$0: function() {
                return this.variableDeclarationWithoutNamespace$2(null, null);
            },
            _variableDeclarationOrStyleRule$0: function() {
                var t1, t2, variableOrInterpolation, t3, _this = this;
                if (_this.get$plainCss()) return _this._styleRule$0();
                if (_this.get$indented() && _this.scanner.scanChar$1(92)) return _this._styleRule$0();
                if (!_this.lookingAtIdentifier$0()) return _this._styleRule$0();
                t1 = _this.scanner;
                t2 = t1._string_scanner$_position;
                variableOrInterpolation = _this._variableDeclarationOrInterpolation$0();
                if (variableOrInterpolation instanceof A.VariableDeclaration) t1 = variableOrInterpolation;
                else {
                    t3 = new A.InterpolationBuffer(new A.StringBuffer(""), A._setArrayType([], type$.JSArray_Object), A._setArrayType([], type$.JSArray_nullable_FileSpan));
                    t3.addInterpolation$1(type$.Interpolation._as(variableOrInterpolation));
                    t2 = _this._styleRule$2(t3, new A._SpanScannerState(t1, t2));
                    t1 = t2;
                }
                return t1;
            },
            _declarationOrStyleRule$0: function() {
                var t1, t2, declarationOrBuffer, _this = this;
                if (_this.get$indented() && _this.scanner.scanChar$1(92)) return _this._styleRule$0();
                t1 = _this.scanner;
                t2 = t1._string_scanner$_position;
                declarationOrBuffer = _this._declarationOrBuffer$0();
                return declarationOrBuffer instanceof A.Statement ? declarationOrBuffer : _this._styleRule$2(type$.InterpolationBuffer._as(declarationOrBuffer), new A._SpanScannerState(t1, t2));
            },
            _declarationOrBuffer$0: function() {
                var midBuffer, couldBeSelector, beforeDeclaration, value, additional, t2, t3, variableOrInterpolation, $name, isCustomProperty, t4, postColonWhitespace, _0_0, _$exception, _1_0, _this = this, t1 = _this.scanner, start = new A._SpanScannerState(t1, t1._string_scanner$_position), nameBuffer = new A.InterpolationBuffer(new A.StringBuffer(""), A._setArrayType([], type$.JSArray_Object), A._setArrayType([], type$.JSArray_nullable_FileSpan)), startsWithPunctuation = _this._lookingAtPotentialPropertyHack$0();
                if (startsWithPunctuation) {
                    t2 = t1.readChar$0();
                    t3 = nameBuffer._interpolation_buffer$_text;
                    t2 = A.Primitives_stringFromCharCode(t2);
                    t3._contents += t2;
                    t2 = _this.rawText$1(new A.StylesheetParser__declarationOrBuffer_closure(_this));
                    t3 = nameBuffer._interpolation_buffer$_text;
                    t3._contents += t2;
                }
                if (!_this._lookingAtInterpolatedIdentifier$0()) return nameBuffer;
                variableOrInterpolation = startsWithPunctuation ? _this.interpolatedIdentifier$0() : _this._variableDeclarationOrInterpolation$0();
                if (variableOrInterpolation instanceof A.VariableDeclaration) return variableOrInterpolation;
                else nameBuffer.addInterpolation$1(type$.Interpolation._as(variableOrInterpolation));
                _this._isUseAllowed = false;
                if (t1.matches$1("/*")) {
                    t2 = _this.rawText$1(_this.get$loudComment());
                    t3 = nameBuffer._interpolation_buffer$_text;
                    t3._contents += t2;
                }
                midBuffer = new A.StringBuffer("");
                t2 = midBuffer;
                t3 = _this.rawText$1(new A.StylesheetParser__declarationOrBuffer_closure0(_this));
                t2._contents += t3;
                t3 = t1._string_scanner$_position;
                if (!t1.scanChar$1(58)) {
                    if (midBuffer._contents.length !== 0) {
                        t1 = nameBuffer._interpolation_buffer$_text;
                        t2 = A.Primitives_stringFromCharCode(32);
                        t1._contents += t2;
                    }
                    return nameBuffer;
                }
                t2 = A.Primitives_stringFromCharCode(58);
                midBuffer._contents += t2;
                $name = nameBuffer.interpolation$1(_this.spanFrom$2(start, new A._SpanScannerState(t1, t3)));
                isCustomProperty = B.JSString_methods.startsWith$1($name.get$initialPlain(), "--");
                if (!isCustomProperty) {
                    if (_this._inPlainCssFunction) {
                        t3 = A.NullableExtension_andThen($name.get$asPlain(), new A.StylesheetParser__declarationOrBuffer_closure1());
                        if (t3 == null) t3 = false;
                    } else t3 = false;
                } else t3 = true;
                if (t3) {
                    if (_this.atEndOfStatement$0()) {
                        t1 = A.FileLocation$_(t1._sourceFile, t1._string_scanner$_position);
                        t2 = t1.offset;
                        t2 = A.Interpolation$(B.List_empty12, B.List_empty13, A._FileSpan$(t1.file, t2, t2));
                        t1 = t2;
                    } else t1 = _this._interpolatedDeclarationValue$1$silentComments(false);
                    _this.expectStatementSeparator$1(isCustomProperty ? "custom property" : "@function result");
                    return A.Declaration$notSassScript($name, new A.StringExpression(t1, false), _this.spanFrom$1(start));
                }
                if (t1.scanChar$1(58)) {
                    t1 = nameBuffer;
                    t3 = t1._interpolation_buffer$_text;
                    t4 = A.S(midBuffer);
                    t3._contents = (t3._contents += t4) + t2;
                    return t1;
                } else if (_this.get$indented() && _this._lookingAtInterpolatedIdentifier$0()) {
                    t1 = nameBuffer;
                    t2 = t1._interpolation_buffer$_text;
                    t3 = A.S(midBuffer);
                    t2._contents += t3;
                    return t1;
                }
                postColonWhitespace = _this.rawText$1(new A.StylesheetParser__declarationOrBuffer_closure2(_this));
                _0_0 = _this._tryDeclarationChildren$2($name, start);
                if (_0_0 != null) return _0_0;
                midBuffer._contents += postColonWhitespace;
                couldBeSelector = postColonWhitespace.length === 0 && _this._lookingAtInterpolatedIdentifier$0();
                beforeDeclaration = new A._SpanScannerState(t1, t1._string_scanner$_position);
                value = null;
                try {
                    value = _this._expression$0();
                    if (_this.lookingAtChildren$0()) {
                        if (couldBeSelector) _this.expectStatementSeparator$0();
                    } else if (!_this.atEndOfStatement$0()) _this.expectStatementSeparator$0();
                } catch (exception) {
                    if (type$.FormatException._is(A.unwrapException(exception))) {
                        if (!couldBeSelector) throw exception;
                        t1.set$state(beforeDeclaration);
                        additional = _this.almostAnyValue$0();
                        if (!_this.get$indented() && t1.peekChar$0() === 59) throw exception;
                        t1 = nameBuffer._interpolation_buffer$_text;
                        t2 = A.S(midBuffer);
                        t1._contents += t2;
                        nameBuffer.addInterpolation$1(additional);
                        return nameBuffer;
                    } else throw exception;
                }
                _1_0 = _this._tryDeclarationChildren$3$value($name, start, value);
                if (_1_0 != null) return _1_0;
                else {
                    _this.expectStatementSeparator$0();
                    return A.Declaration$($name, value, _this.spanFrom$1(start));
                }
            },
            _variableDeclarationOrInterpolation$0: function() {
                var t1, start, identifier, buffer, _this = this;
                if (!_this.lookingAtIdentifier$0()) return _this.interpolatedIdentifier$0();
                t1 = _this.scanner;
                start = new A._SpanScannerState(t1, t1._string_scanner$_position);
                identifier = _this.identifier$0();
                if (t1.matches$1(".$")) {
                    t1.readChar$0();
                    return _this.variableDeclarationWithoutNamespace$2(identifier, start);
                } else {
                    t1 = new A.StringBuffer("");
                    buffer = new A.InterpolationBuffer(t1, A._setArrayType([], type$.JSArray_Object), A._setArrayType([], type$.JSArray_nullable_FileSpan));
                    t1._contents = identifier;
                    if (_this._lookingAtInterpolatedIdentifierBody$0()) buffer.addInterpolation$1(_this.interpolatedIdentifier$0());
                    return buffer.interpolation$1(_this.spanFrom$1(start));
                }
            },
            _styleRule$2: function(buffer, start_) {
                var t1, start, interpolation, t2, _this = this;
                _this._isUseAllowed = false;
                if (start_ == null) {
                    t1 = _this.scanner;
                    start = new A._SpanScannerState(t1, t1._string_scanner$_position);
                } else start = start_;
                t1 = {};
                interpolation = t1.interpolation = _this.styleRuleSelector$0();
                if (buffer != null) {
                    buffer.addInterpolation$1(interpolation);
                    t2 = t1.interpolation = buffer.interpolation$1(_this.spanFrom$1(start));
                } else t2 = interpolation;
                if (t2.contents.length === 0) _this.scanner.error$1(0, 'expected "}".');
                return _this._withStyleRuleChildren$1$3(t2, start, new A.StylesheetParser__styleRule_closure(t1, _this, start), type$.StyleRule);
            },
            _styleRule$0: function() {
                return this._styleRule$2(null, null);
            },
            _withStyleRuleChildren$1$3: function(nodeWithSpan, start, create, $T) {
                var _this = this, wasInStyleRule = _this._inStyleRule;
                _this._inStyleRule = true;
                return _this._withChildren$3(_this.get$_statement(), start, new A.StylesheetParser__withStyleRuleChildren_closure(_this, nodeWithSpan, wasInStyleRule, create, $T));
            },
            _propertyOrVariableDeclaration$0: function() {
                var t2, nameBuffer, t3, $name, variableOrInterpolation, _0_0, value, _1_0, _this = this, t1 = _this.scanner, start = new A._SpanScannerState(t1, t1._string_scanner$_position);
                if (_this._lookingAtPotentialPropertyHack$0()) {
                    t2 = new A.StringBuffer("");
                    nameBuffer = new A.InterpolationBuffer(t2, A._setArrayType([], type$.JSArray_Object), A._setArrayType([], type$.JSArray_nullable_FileSpan));
                    t3 = A.Primitives_stringFromCharCode(t1.readChar$0());
                    t2._contents += t3;
                    t3 = _this.rawText$1(new A.StylesheetParser__propertyOrVariableDeclaration_closure(_this));
                    t2._contents += t3;
                    nameBuffer.addInterpolation$1(_this.interpolatedIdentifier$0());
                    $name = nameBuffer.interpolation$1(_this.spanFrom$1(start));
                } else if (!_this.get$plainCss()) {
                    variableOrInterpolation = _this._variableDeclarationOrInterpolation$0();
                    if (variableOrInterpolation instanceof A.VariableDeclaration) return variableOrInterpolation;
                    else type$.Interpolation._as(variableOrInterpolation);
                    $name = variableOrInterpolation;
                } else $name = _this.interpolatedIdentifier$0();
                _this.whitespace$1$consumeNewlines(false);
                t1.expectChar$1(58);
                if (B.JSString_methods.startsWith$1($name.get$initialPlain(), "--")) _this.error$2(0, string$.Declarw, $name.span);
                _this.whitespace$1$consumeNewlines(false);
                _0_0 = _this._tryDeclarationChildren$2($name, start);
                if (_0_0 != null) return _0_0;
                value = _this._expression$0();
                _1_0 = _this._tryDeclarationChildren$3$value($name, start, value);
                if (_1_0 != null) return _1_0;
                else {
                    _this.expectStatementSeparator$0();
                    return A.Declaration$($name, value, _this.spanFrom$1(start));
                }
            },
            _tryDeclarationChildren$3$value: function($name, start, value) {
                var _this = this;
                if (!_this.lookingAtChildren$0()) return null;
                if (_this.get$plainCss()) _this.scanner.error$1(0, string$.Nested);
                return _this._withChildren$3(_this.get$_declarationChild(), start, new A.StylesheetParser__tryDeclarationChildren_closure($name, value));
            },
            _tryDeclarationChildren$2: function($name, start) {
                return this._tryDeclarationChildren$3$value($name, start, null);
            },
            _declarationChild$0: function() {
                return this.scanner.peekChar$0() === 64 ? this._declarationAtRule$0() : this._propertyOrVariableDeclaration$0();
            },
            atRule$2$root: function(child, root) {
                var $name, wasUseAllowed, value, optional, _this = this, t1 = _this.scanner, start = new A._SpanScannerState(t1, t1._string_scanner$_position);
                t1.expectChar$2$name(64, "@-rule");
                $name = _this.interpolatedIdentifier$0();
                wasUseAllowed = _this._isUseAllowed;
                _this._isUseAllowed = false;
                switch($name.get$asPlain()){
                    case "at-root":
                        return _this._atRootRule$1(start);
                    case "content":
                        return _this._contentRule$1(start);
                    case "debug":
                        return _this._debugRule$1(start);
                    case "each":
                        return _this._eachRule$2(start, child);
                    case "else":
                        return _this._disallowedAtRule$1(start);
                    case "error":
                        return _this._errorRule$1(start);
                    case "extend":
                        _this.whitespace$1$consumeNewlines(true);
                        if (!_this._inStyleRule && !_this._stylesheet$_inMixin && !_this._inContentBlock) _this.error$2(0, string$.x40exten, _this.spanFrom$1(start));
                        value = _this.almostAnyValue$0();
                        optional = t1.scanChar$1(33);
                        if (optional) {
                            _this.expectIdentifier$1("optional");
                            _this.whitespace$1$consumeNewlines(false);
                        }
                        _this.expectStatementSeparator$1("@extend rule");
                        return new A.ExtendRule(value, optional, _this.spanFrom$1(start));
                    case "for":
                        return _this._forRule$2(start, child);
                    case "forward":
                        _this._isUseAllowed = wasUseAllowed;
                        if (!root) _this._disallowedAtRule$1(start);
                        return _this._forwardRule$1(start);
                    case "function":
                        return _this._functionRule$2(start, $name);
                    case "if":
                        return _this._ifRule$2(start, child);
                    case "import":
                        return _this._importRule$1(start);
                    case "include":
                        return _this._includeRule$1(start);
                    case "media":
                        return _this.mediaRule$1(start);
                    case "mixin":
                        return _this._mixinRule$1(start);
                    case "-moz-document":
                        return _this.mozDocumentRule$2(start, $name);
                    case "return":
                        return _this._disallowedAtRule$1(start);
                    case "supports":
                        return _this.supportsRule$1(start);
                    case "use":
                        _this._isUseAllowed = wasUseAllowed;
                        if (!root) _this._disallowedAtRule$1(start);
                        return _this._useRule$1(start);
                    case "warn":
                        return _this._warnRule$1(start);
                    case "while":
                        return _this._whileRule$2(start, child);
                    default:
                        return _this.unknownAtRule$2(start, $name);
                }
            },
            _declarationAtRule$0: function() {
                var _this = this, t1 = _this.scanner, start = new A._SpanScannerState(t1, t1._string_scanner$_position), _0_0 = _this._plainAtRuleName$0();
                $label0$0: {
                    if ("content" === _0_0) {
                        t1 = _this._contentRule$1(start);
                        break $label0$0;
                    }
                    if ("debug" === _0_0) {
                        t1 = _this._debugRule$1(start);
                        break $label0$0;
                    }
                    if ("each" === _0_0) {
                        t1 = _this._eachRule$2(start, _this.get$_declarationChild());
                        break $label0$0;
                    }
                    if ("else" === _0_0) _this._disallowedAtRule$1(start);
                    if ("error" === _0_0) {
                        t1 = _this._errorRule$1(start);
                        break $label0$0;
                    }
                    if ("for" === _0_0) {
                        t1 = _this._forRule$2(start, _this.get$_declarationChild());
                        break $label0$0;
                    }
                    if ("if" === _0_0) {
                        t1 = _this._ifRule$2(start, _this.get$_declarationChild());
                        break $label0$0;
                    }
                    if ("include" === _0_0) {
                        t1 = _this._includeRule$1(start);
                        break $label0$0;
                    }
                    if ("warn" === _0_0) {
                        t1 = _this._warnRule$1(start);
                        break $label0$0;
                    }
                    if ("while" === _0_0) {
                        t1 = _this._whileRule$2(start, _this.get$_declarationChild());
                        break $label0$0;
                    }
                    t1 = _this._disallowedAtRule$1(start);
                }
                return t1;
            },
            _functionChild$0: function() {
                var state, variableDeclarationError, stackTrace, statement, t2, _$exception, t3, start, _0_0, value, _this = this, t1 = _this.scanner;
                if (t1.peekChar$0() !== 64) {
                    state = new A._SpanScannerState(t1, t1._string_scanner$_position);
                    try {
                        t2 = _this._variableDeclarationWithNamespace$0();
                        return t2;
                    } catch (exception) {
                        t2 = A.unwrapException(exception);
                        t3 = type$.SourceSpanFormatException;
                        if (t3._is(t2)) {
                            variableDeclarationError = t2;
                            stackTrace = A.getTraceFromException(exception);
                            t1.set$state(state);
                            statement = null;
                            try {
                                statement = _this._declarationOrStyleRule$0();
                            } catch (exception) {
                                if (t3._is(A.unwrapException(exception))) throw A.wrapException(variableDeclarationError);
                                else throw exception;
                            }
                            t2 = statement instanceof A.StyleRule ? "style rules" : "declarations";
                            _this.error$3(0, "@function rules may not contain " + t2 + ".", J.get$span$x(statement), stackTrace);
                        } else throw exception;
                    }
                }
                start = new A._SpanScannerState(t1, t1._string_scanner$_position);
                _0_0 = _this._plainAtRuleName$0();
                $label0$0: {
                    if ("debug" === _0_0) {
                        t1 = _this._debugRule$1(start);
                        break $label0$0;
                    }
                    if ("each" === _0_0) {
                        t1 = _this._eachRule$2(start, _this.get$_functionChild());
                        break $label0$0;
                    }
                    if ("else" === _0_0) _this._disallowedAtRule$1(start);
                    if ("error" === _0_0) {
                        t1 = _this._errorRule$1(start);
                        break $label0$0;
                    }
                    if ("for" === _0_0) {
                        t1 = _this._forRule$2(start, _this.get$_functionChild());
                        break $label0$0;
                    }
                    if ("if" === _0_0) {
                        t1 = _this._ifRule$2(start, _this.get$_functionChild());
                        break $label0$0;
                    }
                    if ("return" === _0_0) {
                        _this.whitespace$1$consumeNewlines(true);
                        value = _this._expression$0();
                        _this.expectStatementSeparator$1("@return rule");
                        t1 = new A.ReturnRule(value, _this.spanFrom$1(start));
                        break $label0$0;
                    }
                    if ("warn" === _0_0) {
                        t1 = _this._warnRule$1(start);
                        break $label0$0;
                    }
                    if ("while" === _0_0) {
                        t1 = _this._whileRule$2(start, _this.get$_functionChild());
                        break $label0$0;
                    }
                    t1 = _this._disallowedAtRule$1(start);
                }
                return t1;
            },
            _plainAtRuleName$0: function() {
                this.scanner.expectChar$2$name(64, "@-rule");
                return this.identifier$0();
            },
            _atRootRule$1: function(start) {
                var t1, t2, t3, buffer, t4, _this = this;
                _this.whitespace$1$consumeNewlines(false);
                t1 = _this.scanner;
                if (t1.peekChar$0() === 40) {
                    t2 = t1._string_scanner$_position;
                    t3 = new A.StringBuffer("");
                    buffer = new A.InterpolationBuffer(t3, A._setArrayType([], type$.JSArray_Object), A._setArrayType([], type$.JSArray_nullable_FileSpan));
                    t1.expectChar$1(40);
                    t4 = A.Primitives_stringFromCharCode(40);
                    t3._contents += t4;
                    _this.whitespace$1$consumeNewlines(true);
                    _this._addOrInject$2(buffer, _this._expression$1$consumeNewlines(true));
                    if (t1.scanChar$1(58)) {
                        _this.whitespace$1$consumeNewlines(true);
                        t4 = A.Primitives_stringFromCharCode(58);
                        t3._contents += t4;
                        t4 = A.Primitives_stringFromCharCode(32);
                        t3._contents += t4;
                        _this._addOrInject$2(buffer, _this._expression$1$consumeNewlines(true));
                    }
                    t1.expectChar$1(41);
                    _this.whitespace$1$consumeNewlines(false);
                    t4 = A.Primitives_stringFromCharCode(41);
                    t3._contents += t4;
                    return _this._withChildren$3(_this.get$_statement(), start, new A.StylesheetParser__atRootRule_closure(buffer.interpolation$1(_this.spanFrom$1(new A._SpanScannerState(t1, t2)))));
                } else {
                    if (!_this.lookingAtChildren$0()) t1 = _this.get$indented() && _this.atEndOfStatement$0();
                    else t1 = true;
                    if (t1) return _this._withChildren$3(_this.get$_statement(), start, new A.StylesheetParser__atRootRule_closure0());
                    else return A.AtRootRule$(A._setArrayType([
                        _this._styleRule$0()
                    ], type$.JSArray_Statement), _this.spanFrom$1(start), null);
                }
            },
            _contentRule$1: function(start) {
                var t1, beforeWhitespace, $arguments, _this = this;
                if (!_this._stylesheet$_inMixin) _this.error$2(0, string$.x40conte, _this.spanFrom$1(start));
                t1 = _this.scanner;
                beforeWhitespace = A.FileLocation$_(t1._sourceFile, t1._string_scanner$_position);
                _this.whitespace$1$consumeNewlines(false);
                if (t1.peekChar$0() === 40) {
                    $arguments = _this._argumentInvocation$1$mixin(true);
                    _this.whitespace$1$consumeNewlines(false);
                } else {
                    t1 = beforeWhitespace.offset;
                    $arguments = A.ArgumentList$empty(A._FileSpan$(beforeWhitespace.file, t1, t1));
                }
                _this.expectStatementSeparator$1("@content rule");
                return new A.ContentRule($arguments, _this.spanFrom$1(start));
            },
            _debugRule$1: function(start) {
                var value, t1, t2, _this = this;
                _this.whitespace$1$consumeNewlines(true);
                value = _this._expression$0();
                t1 = _this.scanner;
                t2 = t1._string_scanner$_position;
                _this.expectStatementSeparator$1("@debug rule");
                return new A.DebugRule(value, _this.spanFrom$2(start, new A._SpanScannerState(t1, t2)));
            },
            _eachRule$2: function(start, child) {
                var wasInControlDirective, variables, t1, _this = this;
                _this.whitespace$1$consumeNewlines(true);
                wasInControlDirective = _this._inControlDirective;
                _this._inControlDirective = true;
                variables = A._setArrayType([
                    _this.variableName$0()
                ], type$.JSArray_String);
                _this.whitespace$1$consumeNewlines(true);
                for(t1 = _this.scanner; t1.scanChar$1(44);){
                    _this.whitespace$1$consumeNewlines(true);
                    t1.expectChar$1(36);
                    variables.push(_this.identifier$1$normalize(true));
                    _this.whitespace$1$consumeNewlines(true);
                }
                _this.whitespace$1$consumeNewlines(true);
                _this.expectIdentifier$1("in");
                _this.whitespace$1$consumeNewlines(true);
                return _this._withChildren$3(child, start, new A.StylesheetParser__eachRule_closure(_this, wasInControlDirective, variables, _this._expression$0()));
            },
            _errorRule$1: function(start) {
                var value, t1, t2, _this = this;
                _this.whitespace$1$consumeNewlines(true);
                value = _this._expression$0();
                t1 = _this.scanner;
                t2 = t1._string_scanner$_position;
                _this.expectStatementSeparator$1("@error rule");
                return new A.ErrorRule(value, _this.spanFrom$2(start, new A._SpanScannerState(t1, t2)));
            },
            _functionRule$2: function(start, atRuleName) {
                var precedingComment, t1, beforeName, $name, _1_0, parameters, _this = this;
                _this.whitespace$1$consumeNewlines(true);
                precedingComment = _this.lastSilentComment;
                _this.lastSilentComment = null;
                t1 = _this.scanner;
                beforeName = new A._SpanScannerState(t1, t1._string_scanner$_position);
                if (t1.matches$1("--")) return _this.unknownAtRule$2(start, atRuleName);
                $name = _this.identifier$0();
                if (A.equalsIgnoreCase($name, "type")) _this.error$2(0, string$.This_n, _this.spanFrom$1(beforeName));
                $label0$0: {
                    if ("expression" === $name || "url" === $name || "and" === $name || "or" === $name || "not" === $name) {
                        t1 = true;
                        break $label0$0;
                    }
                    t1 = A.unvendor($name) === "element";
                    break $label0$0;
                }
                if (t1) _this.error$2(0, "Invalid function name.", _this.spanFrom$1(beforeName));
                else {
                    _1_0 = $name.toLowerCase();
                    $label1$1: {
                        if ("expression" === _1_0 || "url" === _1_0) {
                            t1 = true;
                            break $label1$1;
                        }
                        t1 = A.unvendor(_1_0) === "element";
                        break $label1$1;
                    }
                    if (t1) _this.warnings.push(new A._Record_3_deprecation_message_span(B.Deprecation_H4k, string$.Customf, _this.spanFrom$1(beforeName)));
                }
                _this.whitespace$1$consumeNewlines(true);
                parameters = _this._parameterList$0();
                if (_this._stylesheet$_inMixin || _this._inContentBlock) _this.error$2(0, string$.Mixinscf, _this.spanFrom$1(start));
                else if (_this._inControlDirective) _this.error$2(0, string$.Functi, _this.spanFrom$1(start));
                _this.whitespace$1$consumeNewlines(false);
                return _this._withChildren$3(_this.get$_functionChild(), start, new A.StylesheetParser__functionRule_closure($name, parameters, precedingComment));
            },
            _forRule$2: function(start, child) {
                var wasInControlDirective, variable, from, _this = this, t1 = {};
                _this.whitespace$1$consumeNewlines(true);
                wasInControlDirective = _this._inControlDirective;
                _this._inControlDirective = true;
                variable = _this.variableName$0();
                _this.whitespace$1$consumeNewlines(true);
                _this.expectIdentifier$1("from");
                _this.whitespace$1$consumeNewlines(true);
                t1.exclusive = null;
                from = _this._expression$2$consumeNewlines$until(true, new A.StylesheetParser__forRule_closure(t1, _this));
                if (t1.exclusive == null) _this.scanner.error$1(0, 'Expected "to" or "through".');
                _this.whitespace$1$consumeNewlines(true);
                return _this._withChildren$3(child, start, new A.StylesheetParser__forRule_closure0(t1, _this, wasInControlDirective, variable, from, _this._expression$0()));
            },
            _forwardRule$1: function(start) {
                var url, prefix, hiddenMixinsAndFunctions, hiddenVariables, _0_0, shownMixinsAndFunctions, shownVariables, _1_0, configuration, span, t1, t2, t3, t4, _this = this, _null = null;
                _this.whitespace$1$consumeNewlines(true);
                url = _this._urlString$0();
                _this.whitespace$1$consumeNewlines(false);
                if (_this.scanIdentifier$1("as")) {
                    _this.whitespace$1$consumeNewlines(true);
                    prefix = _this.identifier$1$normalize(true);
                    _this.scanner.expectChar$1(42);
                    _this.whitespace$1$consumeNewlines(false);
                } else prefix = _null;
                hiddenMixinsAndFunctions = _null;
                hiddenVariables = _null;
                if (_this.scanIdentifier$1("show")) {
                    _this.whitespace$1$consumeNewlines(true);
                    _0_0 = _this._memberList$0();
                    shownMixinsAndFunctions = _0_0._0;
                    shownVariables = _0_0._1;
                } else {
                    if (_this.scanIdentifier$1("hide")) {
                        _this.whitespace$1$consumeNewlines(true);
                        _1_0 = _this._memberList$0();
                        hiddenMixinsAndFunctions = _1_0._0;
                        hiddenVariables = _1_0._1;
                    }
                    shownVariables = _null;
                    shownMixinsAndFunctions = shownVariables;
                }
                configuration = _this._stylesheet$_configuration$1$allowGuarded(true);
                _this.whitespace$1$consumeNewlines(false);
                _this.expectStatementSeparator$1("@forward rule");
                span = _this.spanFrom$1(start);
                if (!_this._isUseAllowed) _this.error$2(0, string$.x40forwa, span);
                if (shownMixinsAndFunctions != null) {
                    shownVariables.toString;
                    t1 = type$.String;
                    t2 = A.LinkedHashSet_LinkedHashSet$of(shownMixinsAndFunctions, t1);
                    t3 = type$.UnmodifiableSetView_String;
                    t1 = A.LinkedHashSet_LinkedHashSet$of(shownVariables, t1);
                    t4 = configuration == null ? B.List_empty11 : A.List_List$unmodifiable(configuration, type$.ConfiguredVariable);
                    return new A.ForwardRule(url, new A.UnmodifiableSetView0(t2, t3), new A.UnmodifiableSetView0(t1, t3), _null, _null, prefix, t4, span);
                } else if (hiddenMixinsAndFunctions != null) {
                    hiddenVariables.toString;
                    t1 = type$.String;
                    t2 = A.LinkedHashSet_LinkedHashSet$of(hiddenMixinsAndFunctions, t1);
                    t3 = type$.UnmodifiableSetView_String;
                    t1 = A.LinkedHashSet_LinkedHashSet$of(hiddenVariables, t1);
                    t4 = configuration == null ? B.List_empty11 : A.List_List$unmodifiable(configuration, type$.ConfiguredVariable);
                    return new A.ForwardRule(url, _null, _null, new A.UnmodifiableSetView0(t2, t3), new A.UnmodifiableSetView0(t1, t3), prefix, t4, span);
                } else return new A.ForwardRule(url, _null, _null, _null, _null, prefix, configuration == null ? B.List_empty11 : A.List_List$unmodifiable(configuration, type$.ConfiguredVariable), span);
            },
            _memberList$0: function() {
                var _this = this, t1 = type$.String, identifiers = A.LinkedHashSet_LinkedHashSet$_empty(t1), variables = A.LinkedHashSet_LinkedHashSet$_empty(t1);
                t1 = _this.scanner;
                do {
                    _this.whitespace$1$consumeNewlines(true);
                    _this.withErrorMessage$2(string$.Expectv, new A.StylesheetParser__memberList_closure(_this, variables, identifiers));
                    _this.whitespace$1$consumeNewlines(false);
                }while (t1.scanChar$1(44));
                return new A._Record_2(identifiers, variables);
            },
            _ifRule$2: function(start, child) {
                var ifIndentation, wasInControlDirective, condition, children, clauses, lastClause, span, _this = this;
                _this.whitespace$1$consumeNewlines(true);
                ifIndentation = _this.get$currentIndentation();
                wasInControlDirective = _this._inControlDirective;
                _this._inControlDirective = true;
                condition = _this._expression$0();
                children = _this.children$1(0, child);
                _this.whitespaceWithoutComments$1$consumeNewlines(false);
                clauses = A._setArrayType([
                    A.IfClause$(condition, children)
                ], type$.JSArray_IfClause);
                for(;;){
                    if (!_this.scanElse$1(ifIndentation)) {
                        lastClause = null;
                        break;
                    }
                    _this.whitespace$1$consumeNewlines(false);
                    if (_this.scanIdentifier$1("if")) {
                        _this.whitespace$1$consumeNewlines(true);
                        clauses.push(A.IfClause$(_this._expression$0(), _this.children$1(0, child)));
                    } else {
                        lastClause = A.ElseClause$(_this.children$1(0, child));
                        break;
                    }
                }
                _this._inControlDirective = wasInControlDirective;
                span = _this.spanFrom$1(start);
                _this.whitespaceWithoutComments$1$consumeNewlines(false);
                return new A.IfRule(A.List_List$unmodifiable(clauses, type$.IfClause), lastClause, span);
            },
            _importRule$1: function(start) {
                var argument, t3, _this = this, imports = A._setArrayType([], type$.JSArray_Import), t1 = _this.scanner, t2 = _this.warnings;
                do {
                    _this.whitespace$1$consumeNewlines(false);
                    argument = _this.importArgument$0();
                    t3 = argument instanceof A.DynamicImport;
                    if (t3) t2.push(new A._Record_3_deprecation_message_span(B.Deprecation_6BW, string$.Sass__i, argument.span));
                    if ((_this._inControlDirective || _this._stylesheet$_inMixin) && t3) _this._disallowedAtRule$1(start);
                    imports.push(argument);
                    _this.whitespace$1$consumeNewlines(false);
                }while (t1.scanChar$1(44));
                _this.expectStatementSeparator$1("@import rule");
                t1 = _this.spanFrom$1(start);
                return new A.ImportRule(A.List_List$unmodifiable(imports, type$.Import), t1);
            },
            importArgument$0: function() {
                var url, urlSpan, innerError, stackTrace, modifiers, _$exception, _this = this, t1 = _this.scanner, start = new A._SpanScannerState(t1, t1._string_scanner$_position), _0_0 = t1.peekChar$0();
                if (117 === _0_0 || 85 === _0_0) {
                    url = _this.dynamicUrl$0();
                    _this.whitespace$1$consumeNewlines(false);
                    modifiers = _this.tryImportModifiers$0();
                    t1 = url instanceof A.StringExpression ? url.text : A.Interpolation$(A._setArrayType([
                        url
                    ], type$.JSArray_Object), A._setArrayType([
                        url.get$span(url)
                    ], type$.JSArray_nullable_FileSpan), url.get$span(url));
                    return new A.StaticImport(t1, modifiers, _this.spanFrom$1(start));
                }
                url = _this.string$0();
                urlSpan = _this.spanFrom$1(start);
                _this.whitespace$1$consumeNewlines(false);
                modifiers = _this.tryImportModifiers$0();
                if (_this.isPlainImportUrl$1(url) || modifiers != null) return new A.StaticImport(new A.Interpolation(A.List_List$unmodifiable([
                    urlSpan.get$text()
                ], type$.Object), B.List_null, urlSpan), modifiers, _this.spanFrom$1(start));
                else try {
                    t1 = _this.parseImportUrl$1(url);
                    return new A.DynamicImport(t1, urlSpan);
                } catch (exception) {
                    t1 = A.unwrapException(exception);
                    if (type$.FormatException._is(t1)) {
                        innerError = t1;
                        stackTrace = A.getTraceFromException(exception);
                        _this.error$3(0, "Invalid URL: " + J.get$message$x(innerError), urlSpan, stackTrace);
                    } else throw exception;
                }
            },
            parseImportUrl$1: function(url) {
                var t1 = $.$get$windows();
                if (t1.style.rootLength$1(url) > 0 && !$.$get$url().style.isRootRelative$1(url)) return t1.toUri$1(url).toString$0(0);
                A.Uri_parse(url);
                return url;
            },
            isPlainImportUrl$1: function(url) {
                var _0_0, t1;
                if (url.length < 5) return false;
                if (B.JSString_methods.endsWith$1(url, ".css")) return true;
                _0_0 = url.charCodeAt(0);
                $label0$0: {
                    if (47 === _0_0) {
                        t1 = url.charCodeAt(1) === 47;
                        break $label0$0;
                    }
                    if (104 === _0_0) {
                        t1 = B.JSString_methods.startsWith$1(url, "http://") || B.JSString_methods.startsWith$1(url, "https://");
                        break $label0$0;
                    }
                    t1 = false;
                    break $label0$0;
                }
                return t1;
            },
            tryImportModifiers$0: function() {
                var t1, start, t2, t3, t4, buffer, t5, identifier, $name, query, t6, _this = this;
                if (!_this._lookingAtInterpolatedIdentifier$0() && _this.scanner.peekChar$0() !== 40) return null;
                t1 = _this.scanner;
                start = new A._SpanScannerState(t1, t1._string_scanner$_position);
                t2 = new A.StringBuffer("");
                t3 = A._setArrayType([], type$.JSArray_Object);
                t4 = A._setArrayType([], type$.JSArray_nullable_FileSpan);
                buffer = new A.InterpolationBuffer(t2, t3, t4);
                for(;;)if (_this._lookingAtInterpolatedIdentifier$0()) {
                    if (!(t3.length === 0 && t2._contents.length === 0)) {
                        t5 = A.Primitives_stringFromCharCode(32);
                        t2._contents += t5;
                    }
                    identifier = _this.interpolatedIdentifier$0();
                    buffer.addInterpolation$1(identifier);
                    t5 = identifier.get$asPlain();
                    $name = t5 == null ? null : t5.toLowerCase();
                    if ($name !== "and" && t1.scanChar$1(40)) {
                        if ($name === "supports") {
                            query = _this._importSupportsQuery$0();
                            t5 = !(query instanceof A.SupportsDeclaration);
                            if (t5) {
                                t6 = A.Primitives_stringFromCharCode(40);
                                t2._contents += t6;
                            }
                            t6 = query.get$span(query);
                            buffer._flushText$0();
                            t3.push(new A.SupportsExpression(query));
                            t4.push(t6);
                            if (t5) {
                                t5 = A.Primitives_stringFromCharCode(41);
                                t2._contents += t5;
                            }
                        } else {
                            t5 = A.Primitives_stringFromCharCode(40);
                            t2._contents += t5;
                            buffer.addInterpolation$1(_this._interpolatedDeclarationValue$3$allowEmpty$allowSemicolon$consumeNewlines(true, true, true));
                            t5 = A.Primitives_stringFromCharCode(41);
                            t2._contents += t5;
                        }
                        t1.expectChar$1(41);
                        _this.whitespace$1$consumeNewlines(false);
                    } else {
                        _this.whitespace$1$consumeNewlines(false);
                        if (t1.scanChar$1(44)) {
                            t2._contents += ", ";
                            buffer.addInterpolation$1(_this._mediaQueryList$0());
                            return buffer.interpolation$1(_this.spanFrom$1(start));
                        }
                    }
                } else if (t1.peekChar$0() === 40) {
                    if (!(t3.length === 0 && t2._contents.length === 0)) {
                        t1 = A.Primitives_stringFromCharCode(32);
                        t2._contents += t1;
                    }
                    buffer.addInterpolation$1(_this._mediaQueryList$0());
                    return buffer.interpolation$1(_this.spanFrom$1(start));
                } else return buffer.interpolation$1(_this.spanFrom$1(start));
            },
            _importSupportsQuery$0: function() {
                var t1, t2, _0_0, $name, _this = this;
                _this.whitespace$1$consumeNewlines(true);
                if (_this.scanIdentifier$1("not")) {
                    _this.whitespace$1$consumeNewlines(true);
                    t1 = _this.scanner;
                    t2 = t1._string_scanner$_position;
                    return new A.SupportsNegation(_this._supportsConditionInParens$0(), _this.spanFrom$1(new A._SpanScannerState(t1, t2)));
                } else {
                    t1 = _this.scanner;
                    if (t1.peekChar$0() === 40) return _this._supportsCondition$1$inParentheses(true);
                    else {
                        _0_0 = _this._tryImportSupportsFunction$0();
                        if (_0_0 != null) return _0_0;
                        t2 = t1._string_scanner$_position;
                        $name = _this._expression$1$consumeNewlines(true);
                        t1.expectChar$1(58);
                        return new A.SupportsDeclaration($name, _this._supportsDeclarationValue$1($name), _this.spanFrom$1(new A._SpanScannerState(t1, t2)));
                    }
                }
            },
            _tryImportSupportsFunction$0: function() {
                var t1, start, $name, value, _this = this;
                if (!_this._lookingAtInterpolatedIdentifier$0()) return null;
                t1 = _this.scanner;
                start = new A._SpanScannerState(t1, t1._string_scanner$_position);
                $name = _this.interpolatedIdentifier$0();
                if (!t1.scanChar$1(40)) {
                    t1.set$state(start);
                    return null;
                }
                value = _this._interpolatedDeclarationValue$3$allowEmpty$allowSemicolon$consumeNewlines(true, true, true);
                t1.expectChar$1(41);
                return new A.SupportsFunction($name, value, _this.spanFrom$1(start));
            },
            _includeRule$1: function(start) {
                var $name, t1, name0, namespace, $arguments, t2, t3, contentParameters, contentParameters_, wasInContentBlock, $content, span, _this = this, _null = null;
                _this.whitespace$1$consumeNewlines(true);
                $name = _this.identifier$0();
                t1 = _this.scanner;
                if (t1.scanChar$1(46)) {
                    name0 = _this._publicIdentifier$0();
                    namespace = $name;
                    $name = name0;
                } else namespace = _null;
                _this.whitespace$1$consumeNewlines(false);
                if (t1.peekChar$0() === 40) $arguments = _this._argumentInvocation$1$mixin(true);
                else {
                    t2 = A.FileLocation$_(t1._sourceFile, t1._string_scanner$_position);
                    t3 = t2.offset;
                    $arguments = A.ArgumentList$empty(A._FileSpan$(t2.file, t3, t3));
                }
                _this.whitespace$1$consumeNewlines(false);
                if (_this.scanIdentifier$1("using")) {
                    _this.whitespace$1$consumeNewlines(true);
                    contentParameters = _this._parameterList$0();
                    _this.whitespace$1$consumeNewlines(false);
                } else contentParameters = _null;
                t2 = contentParameters == null;
                if (!t2 || _this.lookingAtChildren$0()) {
                    if (t2) {
                        t1 = A.FileLocation$_(t1._sourceFile, t1._string_scanner$_position);
                        t2 = t1.offset;
                        contentParameters_ = new A.ParameterList(B.List_empty14, _null, A._FileSpan$(t1.file, t2, t2));
                    } else contentParameters_ = contentParameters;
                    wasInContentBlock = _this._inContentBlock;
                    _this._inContentBlock = true;
                    $content = _this._withChildren$3(_this.get$_statement(), start, new A.StylesheetParser__includeRule_closure(contentParameters_));
                    _this._inContentBlock = wasInContentBlock;
                } else {
                    _this.expectStatementSeparator$0();
                    $content = _null;
                }
                t1 = _this.spanFrom$2(start, start);
                t2 = $content == null ? $arguments : $content;
                span = t1.expand$1(0, t2.get$span(t2));
                return new A.IncludeRule(namespace, A.stringReplaceAllUnchecked($name, "_", "-"), $name, $arguments, $content, span);
            },
            mediaRule$1: function(start) {
                var _this = this;
                _this.whitespace$1$consumeNewlines(false);
                return _this._withChildren$3(_this.get$_statement(), start, new A.StylesheetParser_mediaRule_closure(_this._mediaQueryList$0()));
            },
            _mixinRule$1: function(start) {
                var precedingComment, t1, t2, $name, parameters, _this = this;
                _this.whitespace$1$consumeNewlines(true);
                precedingComment = _this.lastSilentComment;
                _this.lastSilentComment = null;
                t1 = _this.scanner;
                t2 = t1._string_scanner$_position;
                $name = _this.identifier$0();
                if (B.JSString_methods.startsWith$1($name, "--")) _this.error$2(0, string$.Sass__m, _this.spanFrom$1(new A._SpanScannerState(t1, t2)));
                _this.whitespace$1$consumeNewlines(false);
                if (t1.peekChar$0() === 40) parameters = _this._parameterList$0();
                else {
                    t1 = A.FileLocation$_(t1._sourceFile, t1._string_scanner$_position);
                    t2 = t1.offset;
                    parameters = new A.ParameterList(B.List_empty14, null, A._FileSpan$(t1.file, t2, t2));
                }
                if (_this._stylesheet$_inMixin || _this._inContentBlock) _this.error$2(0, string$.Mixinscm, _this.spanFrom$1(start));
                else if (_this._inControlDirective) _this.error$2(0, string$.Mixinsb, _this.spanFrom$1(start));
                _this.whitespace$1$consumeNewlines(false);
                _this._stylesheet$_inMixin = true;
                return _this._withChildren$3(_this.get$_statement(), start, new A.StylesheetParser__mixinRule_closure(_this, $name, parameters, precedingComment));
            },
            mozDocumentRule$2: function(start, $name) {
                var t1, t2, t3, t4, t5, buffer, _0_0, identifierStart, identifier, _1_0, argument, t6, trailing, start0, end, _this = this, _box_0 = {};
                _this.whitespace$1$consumeNewlines(false);
                t1 = _this.scanner;
                t2 = t1._string_scanner$_position;
                t3 = new A.StringBuffer("");
                t4 = A._setArrayType([], type$.JSArray_Object);
                t5 = A._setArrayType([], type$.JSArray_nullable_FileSpan);
                buffer = new A.InterpolationBuffer(t3, t4, t5);
                _box_0.needsDeprecationWarning = false;
                for(;;){
                    if (t1.peekChar$0() === 35) {
                        _0_0 = _this.singleInterpolation$0();
                        buffer._flushText$0();
                        t4.push(_0_0._0);
                        t5.push(_0_0._1);
                        _box_0.needsDeprecationWarning = true;
                    } else {
                        identifierStart = new A._SpanScannerState(t1, t1._string_scanner$_position);
                        identifier = _this.identifier$0();
                        $label0$0: {
                            if ("url" === identifier || "url-prefix" === identifier || "domain" === identifier) {
                                _1_0 = _this._tryUrlContents$2$name(identifierStart, identifier);
                                if (_1_0 != null) buffer.addInterpolation$1(_1_0);
                                else {
                                    t1.expectChar$1(40);
                                    _this.whitespace$1$consumeNewlines(false);
                                    argument = _this.interpolatedStringToken$0();
                                    t1.expectChar$1(41);
                                    t3._contents += identifier;
                                    t6 = A.Primitives_stringFromCharCode(40);
                                    t3._contents += t6;
                                    buffer.addInterpolation$1(argument);
                                    t6 = A.Primitives_stringFromCharCode(41);
                                    t3._contents += t6;
                                }
                                t6 = t3._contents;
                                trailing = t6.charCodeAt(0) == 0 ? t6 : t6;
                                if (!B.JSString_methods.endsWith$1(trailing, "url-prefix()") && !B.JSString_methods.endsWith$1(trailing, "url-prefix('')") && !B.JSString_methods.endsWith$1(trailing, 'url-prefix("")')) _box_0.needsDeprecationWarning = true;
                                break $label0$0;
                            }
                            if ("regexp" === identifier) {
                                t3._contents += "regexp(";
                                t1.expectChar$1(40);
                                buffer.addInterpolation$1(_this.interpolatedStringToken$0());
                                t1.expectChar$1(41);
                                t6 = A.Primitives_stringFromCharCode(41);
                                t3._contents += t6;
                                _box_0.needsDeprecationWarning = true;
                                break $label0$0;
                            }
                            _this.error$2(0, "Invalid function name.", _this.spanFrom$1(identifierStart));
                        }
                    }
                    _this.whitespace$1$consumeNewlines(false);
                    if (!t1.scanChar$1(44)) break;
                    t6 = A.Primitives_stringFromCharCode(44);
                    t3._contents += t6;
                    start0 = t1._string_scanner$_position;
                    new A.StylesheetParser_mozDocumentRule_closure(_this).call$0();
                    end = t1._string_scanner$_position;
                    t3._contents += B.JSString_methods.substring$2(t1.string, start0, end);
                }
                return _this._withChildren$3(_this.get$_statement(), start, new A.StylesheetParser_mozDocumentRule_closure0(_box_0, _this, $name, buffer.interpolation$1(_this.spanFrom$1(new A._SpanScannerState(t1, t2)))));
            },
            supportsRule$1: function(start) {
                var condition, _this = this;
                _this.whitespace$1$consumeNewlines(false);
                condition = _this._supportsCondition$0();
                _this.whitespace$1$consumeNewlines(false);
                return _this._withChildren$3(_this.get$_statement(), start, new A.StylesheetParser_supportsRule_closure(condition));
            },
            _useRule$1: function(start) {
                var url, namespace, configuration, span, t1, _this = this;
                _this.whitespace$1$consumeNewlines(true);
                url = _this._urlString$0();
                _this.whitespace$1$consumeNewlines(false);
                namespace = _this._useNamespace$2(url, start);
                _this.whitespace$1$consumeNewlines(false);
                configuration = _this._stylesheet$_configuration$0();
                _this.whitespace$1$consumeNewlines(false);
                span = _this.spanFrom$1(start);
                if (!_this._isUseAllowed) _this.error$2(0, string$.x40use_r, span);
                _this.expectStatementSeparator$1("@use rule");
                t1 = new A.UseRule(url, namespace, configuration == null ? B.List_empty11 : A.List_List$unmodifiable(configuration, type$.ConfiguredVariable), span);
                t1.UseRule$4$configuration(url, namespace, span, configuration);
                return t1;
            },
            _useNamespace$2: function(url, start) {
                var namespace, basename, dot, t1, _$exception, _this = this;
                if (_this.scanIdentifier$1("as")) {
                    _this.whitespace$1$consumeNewlines(true);
                    return _this.scanner.scanChar$1(42) ? null : _this.identifier$0();
                }
                basename = url.get$pathSegments().length === 0 ? "" : B.JSArray_methods.get$last(url.get$pathSegments());
                dot = B.JSString_methods.indexOf$1(basename, ".");
                t1 = B.JSString_methods.startsWith$1(basename, "_") ? 1 : 0;
                namespace = B.JSString_methods.substring$2(basename, t1, dot === -1 ? basename.length : dot);
                try {
                    t1 = new A.Parser(A.SpanScanner$(namespace, null), null)._parseIdentifier$0();
                    return t1;
                } catch (exception) {
                    if (type$.SassFormatException._is(A.unwrapException(exception))) _this.error$2(0, 'The default namespace "' + A.S(namespace) + string$.x22x20is_n, _this.spanFrom$1(start));
                    else throw exception;
                }
            },
            _stylesheet$_configuration$1$allowGuarded: function(allowGuarded) {
                var variableNames, configuration, t1, t2, variableStart, $name, expression, t3, guarded, span, _this = this;
                if (!_this.scanIdentifier$1("with")) return null;
                variableNames = A.LinkedHashSet_LinkedHashSet$_empty(type$.String);
                configuration = A._setArrayType([], type$.JSArray_ConfiguredVariable);
                _this.whitespace$1$consumeNewlines(true);
                t1 = _this.scanner;
                t1.expectChar$1(40);
                for(t2 = _this.warnings;;){
                    _this.whitespace$1$consumeNewlines(true);
                    variableStart = new A._SpanScannerState(t1, t1._string_scanner$_position);
                    t1.expectChar$1(36);
                    $name = _this.identifier$1$normalize(true);
                    if (B.JSString_methods.startsWith$1($name, "-")) t2.push(new A._Record_3_deprecation_message_span(B.Deprecation_mXO, string$.Config, _this.spanFrom$1(variableStart)));
                    _this.whitespace$1$consumeNewlines(true);
                    t1.expectChar$1(58);
                    _this.whitespace$1$consumeNewlines(true);
                    expression = _this.expressionUntilComma$0();
                    t3 = t1._string_scanner$_position;
                    if (allowGuarded && t1.scanChar$1(33)) {
                        guarded = _this.identifier$0() === "default";
                        if (guarded) _this.whitespace$1$consumeNewlines(true);
                        else _this.error$2(0, "Invalid flag name.", _this.spanFrom$1(new A._SpanScannerState(t1, t3)));
                    } else guarded = false;
                    span = _this.spanFrom$1(variableStart);
                    if (variableNames.contains$1(0, $name)) _this.error$2(0, string$.The_sa, span);
                    variableNames.add$1(0, $name);
                    configuration.push(new A.ConfiguredVariable($name, expression, guarded, span));
                    if (!t1.scanChar$1(44)) break;
                    _this.whitespace$1$consumeNewlines(true);
                    if (!_this._lookingAtExpression$0()) break;
                }
                t1.expectChar$1(41);
                return configuration;
            },
            _stylesheet$_configuration$0: function() {
                return this._stylesheet$_configuration$1$allowGuarded(false);
            },
            _warnRule$1: function(start) {
                var value, t1, t2, _this = this;
                _this.whitespace$1$consumeNewlines(true);
                value = _this._expression$0();
                t1 = _this.scanner;
                t2 = t1._string_scanner$_position;
                _this.expectStatementSeparator$1("@warn rule");
                return new A.WarnRule(value, _this.spanFrom$2(start, new A._SpanScannerState(t1, t2)));
            },
            _whileRule$2: function(start, child) {
                var wasInControlDirective, _this = this;
                _this.whitespace$1$consumeNewlines(true);
                wasInControlDirective = _this._inControlDirective;
                _this._inControlDirective = true;
                return _this._withChildren$3(child, start, new A.StylesheetParser__whileRule_closure(_this, wasInControlDirective, _this._expression$0()));
            },
            unknownAtRule$2: function(start, $name) {
                var wasInPlainCssFunction, t2, _0_0, t3, _this = this, t1 = {}, wasInUnknownAtRule = _this._stylesheet$_inUnknownAtRule;
                _this._stylesheet$_inUnknownAtRule = true;
                _this.whitespace$1$consumeNewlines(false);
                t1.value = null;
                t2 = _this.scanner.peekChar$0() !== 33 && !_this.atEndOfStatement$0() ? t1.value = _this._interpolatedDeclarationValue$1$allowOpenBrace(false) : null;
                wasInPlainCssFunction = _this._inPlainCssFunction;
                _0_0 = $name.get$asPlain();
                if (_0_0 != null) t3 = A.equalsIgnoreCase(_0_0, "function");
                else t3 = false;
                if (t3) _this._inPlainCssFunction = true;
                try {
                    if (_this.lookingAtChildren$0()) {
                        t1 = _this._withChildren$3(_this.get$_statement(), start, new A.StylesheetParser_unknownAtRule_closure(t1, $name));
                        return t1;
                    } else {
                        _this.expectStatementSeparator$0();
                        t1 = A.AtRule$($name, _this.spanFrom$1(start), null, t2);
                        return t1;
                    }
                } finally{
                    _this._stylesheet$_inUnknownAtRule = wasInUnknownAtRule;
                    _this._inPlainCssFunction = wasInPlainCssFunction;
                }
            },
            _disallowedAtRule$1: function(start) {
                var _this = this;
                _this.whitespace$1$consumeNewlines(false);
                _this._interpolatedDeclarationValue$2$allowEmpty$allowOpenBrace(true, false);
                _this.error$2(0, "This at-rule is not allowed here.", _this.spanFrom$1(start));
            },
            _parameterList$0: function() {
                var parameters, named, restParameter, t3, $name, defaultValue, _this = this, t1 = _this.scanner, t2 = t1._string_scanner$_position;
                t1.expectChar$1(40);
                _this.whitespace$1$consumeNewlines(true);
                parameters = A._setArrayType([], type$.JSArray_Parameter);
                named = A.LinkedHashSet_LinkedHashSet$_empty(type$.String);
                while(restParameter = null, t1.peekChar$0() === 36){
                    t3 = t1._string_scanner$_position;
                    t1.expectChar$1(36);
                    $name = _this.identifier$1$normalize(true);
                    _this.whitespace$1$consumeNewlines(true);
                    if (t1.scanChar$1(58)) {
                        _this.whitespace$1$consumeNewlines(true);
                        defaultValue = _this.expressionUntilComma$0();
                    } else {
                        if (t1.scanChar$1(46)) {
                            t1.expectChar$1(46);
                            t1.expectChar$1(46);
                            _this.whitespace$1$consumeNewlines(true);
                            if (t1.scanChar$1(44)) _this.whitespace$1$consumeNewlines(true);
                            restParameter = $name;
                            break;
                        }
                        defaultValue = null;
                    }
                    parameters.push(new A.Parameter($name, defaultValue, _this.spanFrom$1(new A._SpanScannerState(t1, t3))));
                    if (!named.add$1(0, $name)) _this.error$2(0, "Duplicate parameter.", B.JSArray_methods.get$last(parameters).span);
                    if (!t1.scanChar$1(44)) break;
                    _this.whitespace$1$consumeNewlines(true);
                }
                t1.expectChar$1(41);
                t1 = _this.spanFrom$1(new A._SpanScannerState(t1, t2));
                return new A.ParameterList(A.List_List$unmodifiable(parameters, type$.Parameter), restParameter, t1);
            },
            _argumentInvocation$2$allowEmptySecondArg$mixin: function(allowEmptySecondArg, mixin) {
                var positional, t3, named, namedSpans, t4, t5, t6, rest, emittedRestDeprecation, keywordRest, expression, emittedRestDeprecation0, t7, value, t8, result, _this = this, t1 = _this.scanner, t2 = t1._string_scanner$_position;
                t1.expectChar$1(40);
                _this.whitespace$1$consumeNewlines(true);
                positional = A._setArrayType([], type$.JSArray_Expression);
                t3 = type$.String;
                named = A.LinkedHashMap_LinkedHashMap$_empty(t3, type$.Expression);
                namedSpans = A.LinkedHashMap_LinkedHashMap$_empty(t3, type$.FileSpan);
                for(t4 = !mixin, t5 = _this.warnings, t6 = type$.SourceSpan, rest = null, emittedRestDeprecation = false; keywordRest = null, _this._lookingAtExpression$0();){
                    expression = _this.expressionUntilComma$1$singleEquals(t4);
                    _this.whitespace$1$consumeNewlines(true);
                    emittedRestDeprecation0 = true;
                    if (expression instanceof A.VariableExpression && t1.scanChar$1(58)) {
                        _this.whitespace$1$consumeNewlines(true);
                        t7 = expression.name;
                        if (named.containsKey$1(t7)) _this.error$2(0, "Duplicate argument.", expression.span);
                        value = _this.expressionUntilComma$1$singleEquals(t4);
                        named.$indexSet(0, t7, value);
                        t8 = expression.span;
                        namedSpans.$indexSet(0, t7, t8.expand$1(0, value.get$span(value)));
                        if (rest != null && !emittedRestDeprecation) {
                            t5.push(new A._Record_3_deprecation_message_span(B.Deprecation_8Zg, string$.Named_, new A.MultiSpan(_this.spanFromPosition$1(t8.get$start(t8).offset), "named argument", A.ConstantMap_ConstantMap$from(A.LinkedHashMap_LinkedHashMap$_literal([
                                rest.get$span(rest),
                                "rest argument"
                            ], t6, t3), t6, t3))));
                            emittedRestDeprecation = emittedRestDeprecation0;
                        }
                    } else if (t1.scanChar$1(46)) {
                        t1.expectChar$1(46);
                        t1.expectChar$1(46);
                        if (rest != null) {
                            _this.whitespace$1$consumeNewlines(true);
                            if (t1.scanChar$1(44)) _this.whitespace$1$consumeNewlines(true);
                            keywordRest = expression;
                            break;
                        }
                        rest = expression;
                    } else if (named.__js_helper$_length !== 0) _this.error$2(0, string$.Positik, expression.get$span(expression));
                    else {
                        positional.push(expression);
                        if (rest != null && !emittedRestDeprecation) {
                            t5.push(new A._Record_3_deprecation_message_span(B.Deprecation_8Zg, string$.Positir, new A.MultiSpan(expression.get$span(expression), "positional argument", A.ConstantMap_ConstantMap$from(A.LinkedHashMap_LinkedHashMap$_literal([
                                rest.get$span(rest),
                                "rest argument"
                            ], t6, t3), t6, t3))));
                            emittedRestDeprecation = emittedRestDeprecation0;
                        }
                    }
                    _this.whitespace$1$consumeNewlines(true);
                    if (!t1.scanChar$1(44)) break;
                    _this.whitespace$1$consumeNewlines(true);
                    if (allowEmptySecondArg && positional.length === 1 && named.__js_helper$_length === 0 && rest == null && t1.peekChar$0() === 41) {
                        t3 = t1._sourceFile;
                        t4 = t1._string_scanner$_position;
                        new A.FileLocation(t3, t4).FileLocation$_$2(t3, t4);
                        t5 = new A._FileSpan(t3, t4, t4);
                        t5._FileSpan$3(t3, t4, t4);
                        result = A.List_List$from([
                            ""
                        ], false, type$.Object);
                        result.$flags = 3;
                        positional.push(new A.StringExpression(new A.Interpolation(result, B.List_null, t5), false));
                        break;
                    }
                }
                t1.expectChar$1(41);
                return A.ArgumentList$(positional, named, namedSpans, _this.spanFrom$1(new A._SpanScannerState(t1, t2)), keywordRest, rest);
            },
            _argumentInvocation$0: function() {
                return this._argumentInvocation$2$allowEmptySecondArg$mixin(false, false);
            },
            _argumentInvocation$1$allowEmptySecondArg: function(allowEmptySecondArg) {
                return this._argumentInvocation$2$allowEmptySecondArg$mixin(allowEmptySecondArg, false);
            },
            _argumentInvocation$1$mixin: function(mixin) {
                return this._argumentInvocation$2$allowEmptySecondArg$mixin(false, mixin);
            },
            _expression$4$bracketList$consumeNewlines$singleEquals$until: function(bracketList, consumeNewlines, singleEquals, until) {
                var t2, beforeBracket, start, wasInExpression, wasInParentheses, resetState, resolveOneOperation, resolveOperations, addSingleExpression, addOperator, resolveSpaceExpressions, t3, t4, _3_0, _1_0, t5, _3_28, _2_0, _3_32, _3_40, commaExpressions, spaceExpressions, singleExpression, _this = this, _s20_ = "Expected expression.", _box_0 = {}, t1 = until != null;
                if (t1 && until.call$0()) _this.scanner.error$1(0, _s20_);
                if (bracketList) {
                    t2 = _this.scanner;
                    beforeBracket = new A._SpanScannerState(t2, t2._string_scanner$_position);
                    t2.expectChar$1(91);
                    _this.whitespace$1$consumeNewlines(true);
                    if (t2.scanChar$1(93)) {
                        t1 = A._setArrayType([], type$.JSArray_Expression);
                        t2 = _this.spanFrom$1(beforeBracket);
                        return new A.ListExpression(A.List_List$unmodifiable(t1, type$.Expression), B.ListSeparator_undecided_null_3_undecided, true, t2);
                    }
                } else beforeBracket = null;
                t2 = _this.scanner;
                start = new A._SpanScannerState(t2, t2._string_scanner$_position);
                wasInExpression = _this._inExpression;
                wasInParentheses = _this._inParentheses;
                _this._inExpression = true;
                _box_0.operands_ = _box_0.operators_ = _box_0.spaceExpressions_ = _box_0.commaExpressions_ = null;
                _box_0.allowSlash = true;
                _box_0.singleExpression_ = _this._singleExpression$0();
                resetState = new A.StylesheetParser__expression_resetState(_box_0, _this, start);
                resolveOneOperation = new A.StylesheetParser__expression_resolveOneOperation(_box_0, _this);
                resolveOperations = new A.StylesheetParser__expression_resolveOperations(_box_0, resolveOneOperation);
                addSingleExpression = new A.StylesheetParser__expression_addSingleExpression(_box_0, _this, resetState, resolveOperations);
                addOperator = new A.StylesheetParser__expression_addOperator(_box_0, _this, resolveOneOperation, addSingleExpression);
                resolveSpaceExpressions = new A.StylesheetParser__expression_resolveSpaceExpressions(_box_0, _this, resolveOperations);
                for(t3 = !consumeNewlines, t4 = type$.JSArray_Expression;;){
                    _this.whitespace$1$consumeNewlines(!t3 || bracketList);
                    if (t1 && until.call$0()) break;
                    _3_0 = t2.peekChar$0();
                    if (_3_0 == null) break;
                    if (40 === _3_0) {
                        addSingleExpression.call$1(_this.parentheses$0());
                        continue;
                    }
                    if (91 === _3_0) {
                        addSingleExpression.call$1(_this._expression$1$bracketList(true));
                        continue;
                    }
                    if (36 === _3_0) {
                        addSingleExpression.call$1(_this._variable$0());
                        continue;
                    }
                    if (38 === _3_0) {
                        addSingleExpression.call$1(_this._selector$0());
                        continue;
                    }
                    if (39 === _3_0 || 34 === _3_0) {
                        addSingleExpression.call$1(_this.interpolatedString$0());
                        continue;
                    }
                    if (35 === _3_0) {
                        addSingleExpression.call$1(_this._hashExpression$0());
                        continue;
                    }
                    if (61 === _3_0) {
                        t2.readChar$0();
                        if (singleEquals && t2.peekChar$0() !== 61) addOperator.call$1(B.BinaryOperator_g6F);
                        else {
                            t2.expectChar$1(61);
                            addOperator.call$1(B.BinaryOperator_K7S);
                        }
                        continue;
                    }
                    if (33 === _3_0) {
                        $label0$1: {
                            _1_0 = t2.peekChar$1(1);
                            if (61 === _1_0) {
                                t2.readChar$0();
                                t2.readChar$0();
                                addOperator.call$1(B.BinaryOperator_Fv2);
                                break $label0$1;
                            }
                            t5 = true;
                            if (_1_0 != null) {
                                if (105 !== _1_0) {
                                    if (73 !== _1_0) t5 = _1_0 === 32 || _1_0 === 9 || _1_0 === 10 || _1_0 === 13 || _1_0 === 12;
                                }
                            }
                            if (t5) {
                                addSingleExpression.call$1(_this._importantExpression$0());
                                break $label0$1;
                            }
                            break;
                        }
                        continue;
                    }
                    if (60 === _3_0) {
                        t2.readChar$0();
                        addOperator.call$1(t2.scanChar$1(61) ? B.BinaryOperator_f2c : B.BinaryOperator_CG2);
                        continue;
                    }
                    if (62 === _3_0) {
                        t2.readChar$0();
                        addOperator.call$1(t2.scanChar$1(61) ? B.BinaryOperator_YGt : B.BinaryOperator_Tic);
                        continue;
                    }
                    if (42 === _3_0) {
                        t2.readChar$0();
                        addOperator.call$1(B.BinaryOperator_wkM);
                        continue;
                    }
                    _3_28 = 43 === _3_0;
                    if (_3_28 && _box_0.singleExpression_ == null) {
                        addSingleExpression.call$1(_this._unaryOperation$0());
                        continue;
                    }
                    if (_3_28) {
                        t2.readChar$0();
                        addOperator.call$1(B.BinaryOperator_jCK);
                        continue;
                    }
                    if (45 === _3_0) {
                        _2_0 = t2.peekChar$1(1);
                        if (A._isInt(_2_0) && _2_0 >= 48 && _2_0 <= 57 || 46 === _2_0) {
                            if (_box_0.singleExpression_ != null) {
                                t5 = t2.peekChar$1(-1);
                                t5 = t5 === 32 || t5 === 9 || t5 === 10 || t5 === 13 || t5 === 12;
                            } else t5 = true;
                        } else t5 = false;
                        if (t5) addSingleExpression.call$1(_this._number$0());
                        else if (_this._lookingAtInterpolatedIdentifier$0()) addSingleExpression.call$1(_this.identifierLike$0());
                        else if (_box_0.singleExpression_ == null) addSingleExpression.call$1(_this._unaryOperation$0());
                        else {
                            t2.readChar$0();
                            addOperator.call$1(B.BinaryOperator_tDf);
                        }
                        continue;
                    }
                    _3_32 = 47 === _3_0;
                    if (_3_32 && _box_0.singleExpression_ == null) {
                        addSingleExpression.call$1(_this._unaryOperation$0());
                        continue;
                    }
                    if (_3_32) {
                        t2.readChar$0();
                        addOperator.call$1(B.BinaryOperator_ehp);
                        continue;
                    }
                    if (37 === _3_0) {
                        t2.readChar$0();
                        addOperator.call$1(B.BinaryOperator_bgA);
                        continue;
                    }
                    if (_3_0 >= 48 && _3_0 <= 57) {
                        addSingleExpression.call$1(_this._number$0());
                        continue;
                    }
                    _3_40 = 46 === _3_0;
                    if (_3_40 && t2.peekChar$1(1) === 46) break;
                    if (_3_40) {
                        addSingleExpression.call$1(_this._number$0());
                        continue;
                    }
                    if (97 === _3_0 && !_this.get$plainCss() && _this.scanIdentifier$1("and")) {
                        addOperator.call$1(B.BinaryOperator_5vK);
                        continue;
                    }
                    if (111 === _3_0 && !_this.get$plainCss() && _this.scanIdentifier$1("or")) {
                        addOperator.call$1(B.BinaryOperator_OOf);
                        continue;
                    }
                    if ((117 === _3_0 || 85 === _3_0) && t2.peekChar$1(1) === 43) {
                        addSingleExpression.call$1(_this._unicodeRange$0());
                        continue;
                    }
                    if (!(_3_0 >= 97 && _3_0 <= 122)) t5 = _3_0 >= 65 && _3_0 <= 90 || 95 === _3_0 || 92 === _3_0 || _3_0 >= 128;
                    else t5 = true;
                    if (t5) {
                        addSingleExpression.call$1(_this.identifierLike$0());
                        continue;
                    }
                    if (44 === _3_0) {
                        if (_this._inParentheses) {
                            _this._inParentheses = false;
                            if (_box_0.allowSlash) {
                                resetState.call$0();
                                continue;
                            }
                        }
                        commaExpressions = _box_0.commaExpressions_;
                        if (commaExpressions == null) commaExpressions = _box_0.commaExpressions_ = A._setArrayType([], t4);
                        if (_box_0.singleExpression_ == null) t2.error$1(0, _s20_);
                        resolveSpaceExpressions.call$0();
                        t5 = _box_0.singleExpression_;
                        t5.toString;
                        commaExpressions.push(t5);
                        t2.readChar$0();
                        _box_0.allowSlash = true;
                        _box_0.singleExpression_ = null;
                        continue;
                    }
                    break;
                }
                if (bracketList) t2.expectChar$1(93);
                commaExpressions = _box_0.commaExpressions_;
                spaceExpressions = _box_0.spaceExpressions_;
                if (commaExpressions != null) {
                    resolveSpaceExpressions.call$0();
                    _this._inParentheses = wasInParentheses;
                    singleExpression = _box_0.singleExpression_;
                    if (singleExpression != null) commaExpressions.push(singleExpression);
                    _this._inExpression = wasInExpression;
                    t1 = _this.spanFrom$1(beforeBracket == null ? start : beforeBracket);
                    return new A.ListExpression(A.List_List$unmodifiable(commaExpressions, type$.Expression), B.ListSeparator_z0K, bracketList, t1);
                } else if (bracketList && spaceExpressions != null) {
                    resolveOperations.call$0();
                    _this._inExpression = wasInExpression;
                    t1 = _box_0.singleExpression_;
                    t1.toString;
                    spaceExpressions.push(t1);
                    beforeBracket.toString;
                    t1 = _this.spanFrom$1(beforeBracket);
                    return new A.ListExpression(A.List_List$unmodifiable(spaceExpressions, type$.Expression), B.ListSeparator_SrV, true, t1);
                } else {
                    resolveSpaceExpressions.call$0();
                    if (bracketList) {
                        t1 = _box_0.singleExpression_;
                        t1.toString;
                        t4 = A._setArrayType([
                            t1
                        ], t4);
                        beforeBracket.toString;
                        t1 = _this.spanFrom$1(beforeBracket);
                        _box_0.singleExpression_ = new A.ListExpression(A.List_List$unmodifiable(t4, type$.Expression), B.ListSeparator_undecided_null_3_undecided, true, t1);
                    }
                    _this._inExpression = wasInExpression;
                    t1 = _box_0.singleExpression_;
                    t1.toString;
                    return t1;
                }
            },
            _expression$0: function() {
                return this._expression$4$bracketList$consumeNewlines$singleEquals$until(false, false, false, null);
            },
            _expression$1$consumeNewlines: function(consumeNewlines) {
                return this._expression$4$bracketList$consumeNewlines$singleEquals$until(false, consumeNewlines, false, null);
            },
            _expression$3$consumeNewlines$singleEquals$until: function(consumeNewlines, singleEquals, until) {
                return this._expression$4$bracketList$consumeNewlines$singleEquals$until(false, consumeNewlines, singleEquals, until);
            },
            _expression$1$bracketList: function(bracketList) {
                return this._expression$4$bracketList$consumeNewlines$singleEquals$until(bracketList, false, false, null);
            },
            _expression$2$consumeNewlines$until: function(consumeNewlines, until) {
                return this._expression$4$bracketList$consumeNewlines$singleEquals$until(false, consumeNewlines, false, until);
            },
            expressionUntilComma$1$singleEquals: function(singleEquals) {
                return this._expression$3$consumeNewlines$singleEquals$until(true, singleEquals, new A.StylesheetParser_expressionUntilComma_closure(this));
            },
            expressionUntilComma$0: function() {
                return this.expressionUntilComma$1$singleEquals(false);
            },
            _isSlashOperand$1: function(expression) {
                var t1 = true;
                if (!(expression instanceof A.NumberExpression)) {
                    if (!(expression instanceof A.FunctionExpression)) t1 = expression instanceof A.BinaryOperationExpression && expression.allowsSlash;
                }
                return t1;
            },
            _singleExpression$0: function() {
                var next, t2, _this = this, _s20_ = "Expected expression.", t1 = _this.scanner, _0_0 = t1.peekChar$0();
                $label0$0: {
                    if (_0_0 == null) t1.error$1(0, _s20_);
                    if (40 === _0_0) {
                        t1 = _this.parentheses$0();
                        break $label0$0;
                    }
                    if (47 === _0_0) {
                        t1 = _this._unaryOperation$0();
                        break $label0$0;
                    }
                    if (46 === _0_0) {
                        t1 = _this._number$0();
                        break $label0$0;
                    }
                    if (91 === _0_0) {
                        t1 = _this._expression$1$bracketList(true);
                        break $label0$0;
                    }
                    if (36 === _0_0) {
                        t1 = _this._variable$0();
                        break $label0$0;
                    }
                    if (38 === _0_0) {
                        t1 = _this._selector$0();
                        break $label0$0;
                    }
                    if (39 === _0_0 || 34 === _0_0) {
                        t1 = _this.interpolatedString$0();
                        break $label0$0;
                    }
                    if (35 === _0_0) {
                        t1 = _this._hashExpression$0();
                        break $label0$0;
                    }
                    if (43 === _0_0) {
                        next = t1.peekChar$1(1);
                        t1 = next != null && next >= 48 && next <= 57 || next === 46 ? _this._number$0() : _this._unaryOperation$0();
                        break $label0$0;
                    }
                    if (45 === _0_0) {
                        t1 = _this._minusExpression$0();
                        break $label0$0;
                    }
                    if (33 === _0_0) {
                        t1 = _this._importantExpression$0();
                        break $label0$0;
                    }
                    if (37 === _0_0) {
                        t2 = t1._string_scanner$_position;
                        t1.readChar$0();
                        t2 = _this.spanFrom$1(new A._SpanScannerState(t1, t2));
                        t2 = new A.StringExpression(new A.Interpolation(A.List_List$unmodifiable([
                            "%"
                        ], type$.Object), B.List_null, t2), false);
                        t1 = t2;
                        break $label0$0;
                    }
                    if ((117 === _0_0 || 85 === _0_0) && t1.peekChar$1(1) === 43) {
                        t1 = _this._unicodeRange$0();
                        break $label0$0;
                    }
                    if (_0_0 >= 48 && _0_0 <= 57) {
                        t1 = _this._number$0();
                        break $label0$0;
                    }
                    if (!(_0_0 >= 97 && _0_0 <= 122)) t2 = _0_0 >= 65 && _0_0 <= 90 || 95 === _0_0 || 92 === _0_0 || _0_0 >= 128;
                    else t2 = true;
                    if (t2) {
                        t1 = _this.identifierLike$0();
                        break $label0$0;
                    }
                    t1 = t1.error$1(0, _s20_);
                }
                return t1;
            },
            parentheses$0: function() {
                var start, inside, first, expressions, list, t1, t2, _this = this, wasInParentheses = _this._inParentheses;
                _this._inParentheses = true;
                try {
                    t1 = _this.scanner;
                    start = new A._SpanScannerState(t1, t1._string_scanner$_position);
                    t1.expectChar$1(40);
                    _this.whitespace$1$consumeNewlines(true);
                    inside = new A._SpanScannerState(t1, t1._string_scanner$_position);
                    if (!_this._lookingAtExpression$0()) {
                        t1.expectChar$1(41);
                        t1 = A._setArrayType([], type$.JSArray_Expression);
                        t2 = _this.spanFrom$1(start);
                        t1 = A.List_List$unmodifiable(t1, type$.Expression);
                        return new A.ListExpression(t1, B.ListSeparator_undecided_null_3_undecided, false, t2);
                    }
                    first = _this.expressionUntilComma$0();
                    if (t1.scanChar$1(58)) {
                        _this.whitespace$1$consumeNewlines(true);
                        t1 = _this._stylesheet$_map$2(first, start);
                        return t1;
                    }
                    if (!t1.scanChar$1(44)) {
                        t1.expectChar$1(41);
                        t1 = _this.spanFrom$1(start);
                        return new A.ParenthesizedExpression(first, t1);
                    }
                    _this.whitespace$1$consumeNewlines(true);
                    expressions = A._setArrayType([
                        first
                    ], type$.JSArray_Expression);
                    for(;;){
                        if (!_this._lookingAtExpression$0()) break;
                        J.add$1$ax(expressions, _this.expressionUntilComma$0());
                        if (!t1.scanChar$1(44)) break;
                        _this.whitespace$1$consumeNewlines(true);
                    }
                    t2 = _this.spanFrom$1(inside);
                    list = new A.ListExpression(A.List_List$unmodifiable(expressions, type$.Expression), B.ListSeparator_z0K, false, t2);
                    t1.expectChar$1(41);
                    t1 = _this.spanFrom$1(start);
                    return new A.ParenthesizedExpression(list, t1);
                } finally{
                    _this._inParentheses = wasInParentheses;
                }
            },
            _stylesheet$_map$2: function(first, start) {
                var t1, key, _this = this, pairs = A._setArrayType([
                    new A._Record_2(first, _this.expressionUntilComma$0())
                ], type$.JSArray_Record_2_Expression_and_Expression);
                for(t1 = _this.scanner; t1.scanChar$1(44);){
                    _this.whitespace$1$consumeNewlines(true);
                    if (!_this._lookingAtExpression$0()) break;
                    key = _this.expressionUntilComma$0();
                    t1.expectChar$1(58);
                    _this.whitespace$1$consumeNewlines(true);
                    pairs.push(new A._Record_2(key, _this.expressionUntilComma$0()));
                }
                t1.expectChar$1(41);
                t1 = _this.spanFrom$1(start);
                return new A.MapExpression(A.List_List$unmodifiable(pairs, type$.Record_2_Expression_and_Expression), t1);
            },
            _hashExpression$0: function() {
                var start, t2, identifier, buffer, _this = this, t1 = _this.scanner;
                if (t1.peekChar$1(1) === 123) return _this.identifierLike$0();
                start = new A._SpanScannerState(t1, t1._string_scanner$_position);
                t1.expectChar$1(35);
                t2 = t1.peekChar$0();
                if (t2 == null) t2 = null;
                else t2 = t2 >= 48 && t2 <= 57;
                if (t2 === true) return new A.ColorExpression(_this._hexColorContents$1(start), _this.spanFrom$1(start));
                t2 = t1._string_scanner$_position;
                identifier = _this.interpolatedIdentifier$0();
                if (_this._isHexColor$1(identifier)) {
                    t1.set$state(new A._SpanScannerState(t1, t2));
                    return new A.ColorExpression(_this._hexColorContents$1(start), _this.spanFrom$1(start));
                }
                t1 = new A.StringBuffer("");
                buffer = new A.InterpolationBuffer(t1, A._setArrayType([], type$.JSArray_Object), A._setArrayType([], type$.JSArray_nullable_FileSpan));
                t2 = A.Primitives_stringFromCharCode(35);
                t1._contents += t2;
                buffer.addInterpolation$1(identifier);
                return new A.StringExpression(buffer.interpolation$1(_this.spanFrom$1(start)), false);
            },
            _hexColorContents$1: function(start) {
                var red, green, blue, alpha, digit4, t2, t3, t4, _this = this, digit1 = _this._hexDigit$0(), digit2 = _this._hexDigit$0(), digit3 = _this._hexDigit$0(), t1 = _this.scanner, $self = t1.peekChar$0();
                if (!($self != null && A.CharacterExtension_get_isHex($self))) {
                    red = (digit1 << 4 >>> 0) + digit1;
                    green = (digit2 << 4 >>> 0) + digit2;
                    blue = (digit3 << 4 >>> 0) + digit3;
                    alpha = null;
                } else {
                    digit4 = _this._hexDigit$0();
                    $self = t1.peekChar$0();
                    t2 = $self != null && A.CharacterExtension_get_isHex($self);
                    t3 = digit1 << 4 >>> 0;
                    t4 = digit3 << 4 >>> 0;
                    if (!t2) {
                        red = t3 + digit1;
                        green = (digit2 << 4 >>> 0) + digit2;
                        blue = t4 + digit3;
                        alpha = ((digit4 << 4 >>> 0) + digit4) / 255;
                    } else {
                        red = t3 + digit2;
                        green = t4 + digit4;
                        blue = (_this._hexDigit$0() << 4 >>> 0) + _this._hexDigit$0();
                        $self = t1.peekChar$0();
                        alpha = $self != null && A.CharacterExtension_get_isHex($self) ? ((_this._hexDigit$0() << 4 >>> 0) + _this._hexDigit$0()) / 255 : null;
                    }
                }
                t1 = alpha == null;
                t2 = t1 ? 1 : alpha;
                return A.SassColor_SassColor$rgbInternal(red, green, blue, t2, t1 ? new A.SpanColorFormat(_this.spanFrom$1(start)) : null);
            },
            _isHexColor$1: function(interpolation) {
                var _0_2, t1, plain = interpolation.get$asPlain();
                if (typeof plain == "string") {
                    _0_2 = plain.length;
                    t1 = true;
                    if (3 !== _0_2) {
                        if (4 !== _0_2) {
                            if (6 !== _0_2) t1 = 8 === _0_2;
                        }
                    }
                } else t1 = false;
                if (t1) {
                    t1 = new A.CodeUnits(plain);
                    return t1.every$1(t1, new A.StylesheetParser__isHexColor_closure());
                } else return false;
            },
            _hexDigit$0: function() {
                var t1 = this.scanner, t2 = t1.peekChar$0();
                t2 = t2 == null ? null : A.CharacterExtension_get_isHex(t2);
                return t2 === true ? A.asHex(t1.readChar$0()) : t1.error$1(0, "Expected hex digit.");
            },
            _minusExpression$0: function() {
                var _this = this, _0_0 = _this.scanner.peekChar$1(1);
                if (A._isInt(_0_0) && _0_0 >= 48 && _0_0 <= 57 || 46 === _0_0) return _this._number$0();
                if (_this._lookingAtInterpolatedIdentifier$0()) return _this.identifierLike$0();
                return _this._unaryOperation$0();
            },
            _importantExpression$0: function() {
                var _this = this, t1 = _this.scanner, t2 = t1._string_scanner$_position;
                t1.readChar$0();
                _this.whitespace$1$consumeNewlines(true);
                _this.expectIdentifier$1("important");
                t2 = _this.spanFrom$1(new A._SpanScannerState(t1, t2));
                return new A.StringExpression(new A.Interpolation(A.List_List$unmodifiable([
                    "!important"
                ], type$.Object), B.List_null, t2), false);
            },
            _unaryOperation$0: function() {
                var _this = this, t1 = _this.scanner, t2 = t1._string_scanner$_position, operator = _this._unaryOperatorFor$1(t1.readChar$0());
                if (operator == null) t1.error$2$position(0, "Expected unary operator.", t1._string_scanner$_position - 1);
                else if (_this.get$plainCss() && operator !== B.UnaryOperator_Y93) t1.error$3$length$position(0, "Operators aren't allowed in plain CSS.", 1, t1._string_scanner$_position - 1);
                _this.whitespace$1$consumeNewlines(true);
                return new A.UnaryOperationExpression(operator, _this._singleExpression$0(), _this.spanFrom$1(new A._SpanScannerState(t1, t2)));
            },
            _unaryOperatorFor$1: function(character) {
                var t1;
                $label0$0: {
                    if (43 === character) {
                        t1 = B.UnaryOperator_n2K;
                        break $label0$0;
                    }
                    if (45 === character) {
                        t1 = B.UnaryOperator_hCO;
                        break $label0$0;
                    }
                    if (47 === character) {
                        t1 = B.UnaryOperator_Y93;
                        break $label0$0;
                    }
                    t1 = null;
                    break $label0$0;
                }
                return t1;
            },
            _number$0: function() {
                var number, unit, _this = this, t1 = _this.scanner, t2 = t1._string_scanner$_position, first = t1.peekChar$0(), t3 = first !== 43;
                if (!t3 || first === 45) t1.readChar$0();
                if (t1.peekChar$0() !== 46) _this._consumeNaturalNumber$0();
                _this._tryDecimal$1$allowTrailingDot(t1._string_scanner$_position !== t2 && t3 && first !== 45);
                _this._tryExponent$0();
                number = A.double_parse(t1.substring$1(0, t2));
                if (t1.scanChar$1(37)) unit = "%";
                else {
                    if (_this.lookingAtIdentifier$0()) t3 = t1.peekChar$0() !== 45 || t1.peekChar$1(1) !== 45;
                    else t3 = false;
                    unit = t3 ? _this.identifier$1$unit(true) : null;
                }
                return new A.NumberExpression(number, unit, _this.spanFrom$1(new A._SpanScannerState(t1, t2)));
            },
            _consumeNaturalNumber$0: function() {
                var $self, t1 = this.scanner, t2 = t1.readChar$0();
                if (!(t2 >= 48 && t2 <= 57)) t1.error$2$position(0, "Expected digit.", t1._string_scanner$_position - 1);
                for(;;){
                    $self = t1.peekChar$0();
                    if (!($self != null && $self >= 48 && $self <= 57)) break;
                    t1.readChar$0();
                }
            },
            _tryDecimal$1$allowTrailingDot: function(allowTrailingDot) {
                var $self, t1 = this.scanner;
                if (t1.peekChar$0() !== 46) return;
                $self = t1.peekChar$1(1);
                if (!($self != null && $self >= 48 && $self <= 57)) {
                    if (allowTrailingDot) return;
                    t1.error$2$position(0, "Expected digit.", t1._string_scanner$_position + 1);
                }
                t1.readChar$0();
                for(;;){
                    $self = t1.peekChar$0();
                    if (!($self != null && $self >= 48 && $self <= 57)) break;
                    t1.readChar$0();
                }
            },
            _tryExponent$0: function() {
                var next, $self, t1 = this.scanner, first = t1.peekChar$0();
                if (first !== 101 && first !== 69) return;
                next = t1.peekChar$1(1);
                if (!(next != null && next >= 48 && next <= 57) && next !== 45 && next !== 43) return;
                t1.readChar$0();
                if (43 === next || 45 === next) t1.readChar$0();
                $self = t1.peekChar$0();
                if (!($self != null && $self >= 48 && $self <= 57)) t1.error$1(0, "Expected digit.");
                for(;;){
                    $self = t1.peekChar$0();
                    if (!($self != null && $self >= 48 && $self <= 57)) break;
                    t1.readChar$0();
                }
            },
            _unicodeRange$0: function() {
                var firstRangeLength, hasQuestionMark, t3, secondRangeLength, _this = this, _s26_ = "Expected at most 6 digits.", t1 = _this.scanner, t2 = t1._string_scanner$_position, start = new A._SpanScannerState(t1, t2);
                _this.expectIdentChar$1(117);
                t1.expectChar$1(43);
                for(firstRangeLength = 0; _this.scanCharIf$1(new A.StylesheetParser__unicodeRange_closure());)++firstRangeLength;
                for(hasQuestionMark = false; t1.scanChar$1(63); hasQuestionMark = true)++firstRangeLength;
                if (firstRangeLength === 0) t1.error$1(0, 'Expected hex digit or "?".');
                else if (firstRangeLength > 6) _this.error$2(0, _s26_, _this.spanFrom$1(start));
                else if (hasQuestionMark) {
                    t1 = t1.substring$1(0, t2);
                    t2 = _this.spanFrom$1(start);
                    return new A.StringExpression(new A.Interpolation(A.List_List$unmodifiable([
                        t1
                    ], type$.Object), B.List_null, t2), false);
                }
                if (t1.scanChar$1(45)) {
                    t3 = t1._string_scanner$_position;
                    for(secondRangeLength = 0; _this.scanCharIf$1(new A.StylesheetParser__unicodeRange_closure0());)++secondRangeLength;
                    if (secondRangeLength === 0) t1.error$1(0, "Expected hex digit.");
                    else if (secondRangeLength > 6) _this.error$2(0, _s26_, _this.spanFrom$1(new A._SpanScannerState(t1, t3)));
                }
                if (_this._lookingAtInterpolatedIdentifierBody$0()) t1.error$1(0, "Expected end of identifier.");
                t1 = t1.substring$1(0, t2);
                t2 = _this.spanFrom$1(start);
                return new A.StringExpression(new A.Interpolation(A.List_List$unmodifiable([
                    t1
                ], type$.Object), B.List_null, t2), false);
            },
            _variable$0: function() {
                var _this = this, t1 = _this.scanner, start = new A._SpanScannerState(t1, t1._string_scanner$_position), $name = _this.variableName$0();
                if (_this.get$plainCss()) _this.error$2(0, string$.Sass_v, _this.spanFrom$1(start));
                return new A.VariableExpression(null, $name, _this.spanFrom$1(start));
            },
            _selector$0: function() {
                var t1, start, _this = this;
                if (_this.get$plainCss()) _this.scanner.error$2$length(0, string$.The_pa, 1);
                t1 = _this.scanner;
                start = new A._SpanScannerState(t1, t1._string_scanner$_position);
                t1.expectChar$1(38);
                if (t1.scanChar$1(38)) {
                    _this.warnings.push(new A._Record_3_deprecation_message_span(null, string$.In_Sas, _this.spanFrom$1(start)));
                    t1.set$position(t1._string_scanner$_position - 1);
                }
                return new A.SelectorExpression(_this.spanFrom$1(start));
            },
            interpolatedString$0: function() {
                var t3, t4, t5, buffer, _1_0, second, t6, _0_0, t1 = this.scanner, t2 = t1._string_scanner$_position, quote = t1.readChar$0();
                if (quote !== 39 && quote !== 34) t1.error$2$position(0, "Expected string.", t2);
                t3 = new A.StringBuffer("");
                t4 = A._setArrayType([], type$.JSArray_Object);
                t5 = A._setArrayType([], type$.JSArray_nullable_FileSpan);
                buffer = new A.InterpolationBuffer(t3, t4, t5);
                for(;;){
                    _1_0 = t1.peekChar$0();
                    if (_1_0 === quote) {
                        t1.readChar$0();
                        break;
                    }
                    if (_1_0 == null || _1_0 === 10 || _1_0 === 13 || _1_0 === 12) t1.error$1(0, "Expected " + A.Primitives_stringFromCharCode(quote) + ".");
                    if (92 === _1_0) {
                        second = t1.peekChar$1(1);
                        if (second === 10 || second === 13 || second === 12) {
                            t1.readChar$0();
                            t1.readChar$0();
                            if (second === 13) t1.scanChar$1(10);
                        } else {
                            t6 = A.Primitives_stringFromCharCode(A.consumeEscapedCharacter(t1));
                            t3._contents += t6;
                        }
                        continue;
                    }
                    if (35 === _1_0 && t1.peekChar$1(1) === 123) {
                        _0_0 = this.singleInterpolation$0();
                        buffer._flushText$0();
                        t4.push(_0_0._0);
                        t5.push(_0_0._1);
                        continue;
                    }
                    t6 = A.Primitives_stringFromCharCode(t1.readChar$0());
                    t3._contents += t6;
                }
                return new A.StringExpression(buffer.interpolation$1(this.spanFrom$1(new A._SpanScannerState(t1, t2))), true);
            },
            interpolatedStringToken$0: function() {
                var t3, t4, t5, buffer, t6, _1_0, second, t7, start, end, _0_0, _this = this, t1 = _this.scanner, t2 = t1._string_scanner$_position, quote = t1.readChar$0();
                if (quote !== 39 && quote !== 34) t1.error$2$position(0, "Expected string.", t2);
                t3 = new A.StringBuffer("");
                t4 = A._setArrayType([], type$.JSArray_Object);
                t5 = A._setArrayType([], type$.JSArray_nullable_FileSpan);
                buffer = new A.InterpolationBuffer(t3, t4, t5);
                t6 = A.Primitives_stringFromCharCode(quote);
                t3._contents += t6;
                for(;;){
                    _1_0 = t1.peekChar$0();
                    if (_1_0 === quote) {
                        t4 = A.Primitives_stringFromCharCode(t1.readChar$0());
                        t3._contents += t4;
                        break;
                    }
                    if (_1_0 == null || _1_0 === 10 || _1_0 === 13 || _1_0 === 12) t1.error$1(0, "Expected " + t6 + ".");
                    if (92 === _1_0) {
                        second = t1.peekChar$1(1);
                        if (second === 10 || second === 13 || second === 12) {
                            t7 = A.Primitives_stringFromCharCode(t1.readChar$0());
                            t3._contents += t7;
                            t7 = A.Primitives_stringFromCharCode(t1.readChar$0());
                            t3._contents += t7;
                            if (second === 13) {
                                if (t1.scanChar$1(10)) {
                                    t7 = A.Primitives_stringFromCharCode(10);
                                    t3._contents += t7;
                                }
                            }
                        } else {
                            start = t1._string_scanner$_position;
                            new A.StylesheetParser_interpolatedStringToken_closure(_this).call$0();
                            end = t1._string_scanner$_position;
                            t3._contents += B.JSString_methods.substring$2(t1.string, start, end);
                        }
                        continue;
                    }
                    if (35 === _1_0 && t1.peekChar$1(1) === 123) {
                        _0_0 = _this.singleInterpolation$0();
                        buffer._flushText$0();
                        t4.push(_0_0._0);
                        t5.push(_0_0._1);
                        continue;
                    }
                    t7 = A.Primitives_stringFromCharCode(t1.readChar$0());
                    t3._contents += t7;
                }
                return buffer.interpolation$1(_this.spanFrom$1(new A._SpanScannerState(t1, t2)));
            },
            identifierLike$0: function() {
                var beforeParen, invocation, expression, t1, _0_0, suggestion, _$exception, _1_0, t4, _2_0, _3_0, _3_2, _3_4, _this = this, t2 = _this.scanner, start = new A._SpanScannerState(t2, t2._string_scanner$_position), identifier = _this.interpolatedIdentifier$0(), plain = identifier.get$asPlain(), lower = A._Cell$(), t3 = plain != null;
                if (t3) {
                    if (plain === "if" && t2.peekChar$0() === 40) {
                        beforeParen = new A._SpanScannerState(t2, t2._string_scanner$_position);
                        try {
                            invocation = _this._argumentInvocation$0();
                            expression = new A.LegacyIfExpression(invocation, identifier.span.expand$1(0, invocation.span));
                            t1 = null;
                            _0_0 = expression.get$modernSuggestion();
                            $label0$0: {
                                suggestion = null;
                                if (_0_0 != null) {
                                    suggestion = _0_0;
                                    t1 = "Suggestion: " + A.S(suggestion) + "\n\n";
                                    break $label0$0;
                                }
                                t1 = "";
                                break $label0$0;
                            }
                            _this.warnings.push(new A._Record_3_deprecation_message_span(B.Deprecation_qPD, B.JSString_methods.$add(string$.The_Sa, t1) + string$.More_i, expression.span));
                            return expression;
                        } catch (exception) {
                            if (type$.FormatException._is(A.unwrapException(exception))) {
                                t2.set$state(beforeParen);
                                return _this.ifExpression$1(start);
                            } else throw exception;
                        }
                    } else if (plain.toLowerCase() === "if" && t2.peekChar$0() === 40) return _this.ifExpression$1(start);
                    else if (plain === "not") {
                        _this.whitespace$1$consumeNewlines(true);
                        expression = _this._singleExpression$0();
                        return new A.UnaryOperationExpression(B.UnaryOperator_not_not_3_not, expression, identifier.span.expand$1(0, expression.get$span(expression)));
                    }
                    lower.__late_helper$_value = plain.toLowerCase();
                    if (t2.peekChar$0() !== 40) {
                        switch(plain){
                            case "false":
                                return new A.BooleanExpression(false, identifier.span);
                            case "null":
                                return new A.NullExpression(identifier.span);
                            case "true":
                                return new A.BooleanExpression(true, identifier.span);
                        }
                        _1_0 = $.$get$colorsByName().$index(0, lower._readLocal$0());
                        if (_1_0 != null) {
                            t1 = B.JSNumber_methods.round$0(_1_0._legacyChannel$2(B.RgbColorSpace_i0P, "red"));
                            t2 = B.JSNumber_methods.round$0(_1_0._legacyChannel$2(B.RgbColorSpace_i0P, "green"));
                            t3 = B.JSNumber_methods.round$0(_1_0._legacyChannel$2(B.RgbColorSpace_i0P, "blue"));
                            t4 = _1_0.alphaOrNull;
                            if (t4 == null) t4 = 0;
                            return new A.ColorExpression(A.SassColor_SassColor$rgbInternal(t1, t2, t3, t4, new A.SpanColorFormat(identifier.span)), identifier.span);
                        }
                    }
                    _2_0 = _this.trySpecialFunction$2(lower._readLocal$0(), start);
                    if (_2_0 != null) return _2_0;
                }
                _3_0 = t2.peekChar$0();
                _3_2 = 46 === _3_0;
                if (_3_2 && t2.peekChar$1(1) === 46) return new A.StringExpression(identifier, false);
                if (_3_2) {
                    t2.readChar$0();
                    if (t3) return _this.namespacedExpression$2(plain, start);
                    _this.error$2(0, string$.Interpn, identifier.span);
                }
                _3_4 = 40 === _3_0;
                if (_3_4 && t3) {
                    t1 = _this._argumentInvocation$1$allowEmptySecondArg(J.$eq$(lower._readLocal$0(), "var"));
                    t2 = _this.spanFrom$1(start);
                    return new A.FunctionExpression(null, A.stringReplaceAllUnchecked(plain, "_", "-"), plain, t1, t2);
                }
                if (_3_4) return new A.InterpolatedFunctionExpression(identifier, _this._argumentInvocation$0(), _this.spanFrom$1(start));
                return new A.StringExpression(identifier, false);
            },
            ifExpression$1: function(start) {
                var branches, condition, t2, _this = this, t1 = _this.scanner;
                t1.expectChar$1(40);
                _this.whitespace$1$consumeNewlines(true);
                branches = A._setArrayType([], type$.JSArray_Record_2_nullable_IfConditionExpression_and_Expression);
                while(t1.peekChar$0() !== 41){
                    condition = _this.scanIdentifier$1("else") ? null : _this._ifConditionExpression$0();
                    _this.whitespace$1$consumeNewlines(true);
                    t1.expectChar$1(58);
                    _this.whitespace$1$consumeNewlines(true);
                    branches.push(new A._Record_2(condition, _this._expression$1$consumeNewlines(true)));
                    _this.whitespace$1$consumeNewlines(true);
                    if (!t1.scanChar$1(59)) break;
                    _this.whitespace$1$consumeNewlines(true);
                }
                t1.expectChar$1(41);
                t1 = t1.spanFrom$1(start);
                t2 = A.List_List$unmodifiable(branches, type$.Record_2_nullable_IfConditionExpression_and_Expression);
                if (t2.length === 0) A.throwExpression(A.ArgumentError$value(t2, "branches", "may not be empty"));
                return new A.IfExpression(t2, t1);
            },
            _ifConditionExpression$0: function() {
                var groups, op, _0_0, single, result, _2_0, _this = this, _s44_ = string$.Whitesa, _s11_ = "expressions", _s21_ = "must have length >= 2", t1 = _this.scanner, t2 = t1._string_scanner$_position;
                if (_this.scanIdentifier$1("not")) {
                    if (t1.peekChar$0() === 40) t1.error$1(0, string$.Whitesn);
                    _this.whitespace$1$consumeNewlines(true);
                    return new A.IfConditionNegation(_this._ifGroup$0(), t1.spanFrom$1(new A._SpanScannerState(t1, t2)));
                }
                groups = A._setArrayType([
                    _this._ifGroup$0()
                ], type$.JSArray_IfConditionExpression);
                _this.whitespace$1$consumeNewlines(true);
                for(op = null;;){
                    if (op !== B.BooleanOperator_1 && _this.scanIdentifier$1("and")) {
                        if (t1.peekChar$0() === 40) t1.error$1(0, _s44_);
                        _this.whitespace$1$consumeNewlines(true);
                        if (op == null) op = B.BooleanOperator_0;
                        groups.push(_this._ifGroup$0());
                    } else if (op !== B.BooleanOperator_0 && _this.scanIdentifier$1("or")) {
                        if (t1.peekChar$0() === 40) t1.error$1(0, _s44_);
                        _this.whitespace$1$consumeNewlines(true);
                        if (op == null) op = B.BooleanOperator_1;
                        groups.push(_this._ifGroup$0());
                    } else {
                        _0_0 = t1.peekChar$0();
                        if (_0_0 != null && _0_0 !== 41 && _0_0 !== 58 && B.JSArray_methods.get$last(groups).get$isArbitrarySubstitution()) {
                            $label0$0: {
                                if (groups.length === 1) {
                                    single = groups[0];
                                    t1 = single;
                                    break $label0$0;
                                }
                                op.toString;
                                result = A.List_List$from(groups, false, type$.IfConditionExpression);
                                result.$flags = 3;
                                t1 = result;
                                t2 = new A.IfConditionOperation(t1, op);
                                if (t1.length < 2) A.throwExpression(A.ArgumentError$value(t1, _s11_, _s21_));
                                t1 = t2;
                                break $label0$0;
                            }
                            return _this._ifConditionRaw$2(t1, _this._ifGroup$0());
                        } else {
                            _2_0 = _this._tryArbitrarySubstitution$0();
                            if (_2_0 != null) {
                                $label1$1: {
                                    if (groups.length === 1) {
                                        single = groups[0];
                                        t1 = single;
                                        break $label1$1;
                                    }
                                    op.toString;
                                    result = A.List_List$from(groups, false, type$.IfConditionExpression);
                                    result.$flags = 3;
                                    t1 = result;
                                    t2 = new A.IfConditionOperation(t1, op);
                                    if (t1.length < 2) A.throwExpression(A.ArgumentError$value(t1, _s11_, _s21_));
                                    t1 = t2;
                                    break $label1$1;
                                }
                                return _this._ifConditionRaw$2(t1, _2_0);
                            } else break;
                        }
                    }
                    _this.whitespace$1$consumeNewlines(true);
                }
                $label2$3: {
                    if (groups.length === 1) {
                        single = groups[0];
                        t1 = single;
                        break $label2$3;
                    }
                    op.toString;
                    t1 = A.IfConditionOperation$(groups, op);
                    break $label2$3;
                }
                return t1;
            },
            _ifConditionRaw$2: function(preceding, next) {
                var t1, t2, _0_5, _0_6, t3, last, buffer, op, t4, lastGroup, lastGroup0, _1_0, _2_0, _this = this, _null = null;
                $label0$0: {
                    if (preceding.get$isArbitrarySubstitution()) {
                        t1 = preceding;
                        break $label0$0;
                    }
                    t1 = _null;
                    t2 = false;
                    if (preceding instanceof A.IfConditionOperation) {
                        _0_5 = preceding.expressions;
                        _0_6 = _0_5.length;
                        t3 = _0_6;
                        if (t3 >= 1) {
                            last = _0_5[_0_6 - 1];
                            t1 = last.get$isArbitrarySubstitution();
                        } else {
                            last = t1;
                            t1 = t2;
                        }
                    } else {
                        last = t1;
                        t1 = t2;
                    }
                    if (t1) {
                        t1 = last;
                        break $label0$0;
                    }
                    t1 = next.get$isArbitrarySubstitution();
                    if (t1) {
                        t1 = next;
                        break $label0$0;
                    }
                    t1 = A.throwExpression(A.ArgumentError$("Either " + preceding.toString$0(0) + string$.x20must_e + next.toString$0(0) + " must be one.", _null));
                }
                t2 = new A.StringBuffer("");
                buffer = new A.InterpolationBuffer(t2, A._setArrayType([], type$.JSArray_Object), A._setArrayType([], type$.JSArray_nullable_FileSpan));
                buffer.addInterpolation$1(preceding.toInterpolation$1(t1));
                t3 = A.Primitives_stringFromCharCode(32);
                t2._contents += t3;
                buffer.addInterpolation$1(next.toInterpolation$1(t1));
                op = preceding instanceof A.IfConditionOperation ? preceding.op : _null;
                _this.whitespace$1$consumeNewlines(true);
                for(t4 = _this.scanner, lastGroup = next;;){
                    if (op !== B.BooleanOperator_1 && _this.scanIdentifier$1("and")) {
                        if (t4.peekChar$0() === 40) t4.error$1(0, string$.Whitesa);
                        _this.whitespace$1$consumeNewlines(true);
                        if (op == null) op = B.BooleanOperator_0;
                        lastGroup0 = _this._ifGroup$0();
                        t2._contents += " and ";
                        buffer.addInterpolation$1(lastGroup0.toInterpolation$1(t1));
                    } else if (op !== B.BooleanOperator_0 && _this.scanIdentifier$1("or")) {
                        if (t4.peekChar$0() === 40) t4.error$1(0, string$.Whiteso);
                        _this.whitespace$1$consumeNewlines(true);
                        if (op == null) op = B.BooleanOperator_1;
                        lastGroup = _this._ifGroup$0();
                        _this.whitespace$1$consumeNewlines(true);
                        t2._contents += " or ";
                        buffer.addInterpolation$1(lastGroup.toInterpolation$1(t1));
                    } else {
                        _1_0 = t4.peekChar$0();
                        if (_1_0 != null && _1_0 !== 41 && _1_0 !== 58 && lastGroup.get$isArbitrarySubstitution()) {
                            lastGroup = _this._ifGroup$0();
                            t2._contents += t3;
                            buffer.addInterpolation$1(lastGroup.toInterpolation$1(t1));
                        } else {
                            _2_0 = _this._tryArbitrarySubstitution$0();
                            if (_2_0 != null) {
                                t2._contents += t3;
                                buffer.addInterpolation$1(_2_0.toInterpolation$1(t1));
                            } else break;
                            lastGroup = _2_0;
                        }
                    }
                    _this.whitespace$1$consumeNewlines(true);
                }
                t1 = preceding.get$span(preceding);
                t4 = A.FileLocation$_(t4._sourceFile, t4._string_scanner$_position);
                t2 = t4.offset;
                return new A.IfConditionRaw(buffer.interpolation$1(t1.expand$1(0, A._FileSpan$(t4.file, t2, t2))));
            },
            _ifGroup$0: function() {
                var expression, t2, identifier, _0_1, _0_6, plain, _this = this, t1 = _this.scanner, start = new A._SpanScannerState(t1, t1._string_scanner$_position);
                if (40 === t1.peekChar$0()) {
                    t1.expectChar$1(40);
                    _this.whitespace$1$consumeNewlines(true);
                    expression = _this._ifConditionExpression$0();
                    _this.whitespace$1$consumeNewlines(true);
                    t1.expectChar$1(41);
                    return new A.IfConditionParenthesized(expression, t1.spanFrom$1(start));
                }
                t2 = _this.scanIdentifier$2$caseSensitive("sass", true);
                if (t2) {
                    t1.expectChar$1(40);
                    _this.whitespace$1$consumeNewlines(true);
                    expression = _this._expression$0();
                    _this.whitespace$1$consumeNewlines(true);
                    t1.expectChar$1(41);
                    if (_this.get$plainCss()) _this.error$2(0, string$.sass__, t1.spanFrom$1(start));
                    else return new A.IfConditionSass(expression, t1.spanFrom$1(start));
                }
                identifier = _this.interpolatedIdentifier$0();
                _0_1 = identifier.contents;
                if (_0_1.length === 1) t2 = _0_1[0] instanceof A.Expression && t1.peekChar$0() !== 40;
                else t2 = false;
                if (t2) return new A.IfConditionRaw(identifier);
                _0_6 = identifier.get$asPlain();
                if (_0_6 != null) {
                    plain = _0_6 == null ? A._asString(_0_6) : _0_6;
                    t2 = B.Set_6V2Gi.contains$1(0, plain.toLowerCase()) && t1.peekChar$0() === 40;
                } else t2 = false;
                if (t2) t1.error$1(0, 'Whitespace is required between "' + identifier.toString$0(0) + '" and "("');
                t1.expectChar$1(40);
                _this.whitespace$1$consumeNewlines(true);
                expression = _this._interpolatedDeclarationValue$3$allowEmpty$allowSemicolon$consumeNewlines(true, true, true);
                _this.whitespace$1$consumeNewlines(true);
                t1.expectChar$1(41);
                return new A.IfConditionFunction(identifier, expression, t1.spanFrom$1(start));
            },
            _tryArbitrarySubstitution$0: function() {
                var _0_0, span, start, t2, $arguments, _this = this, t1 = _this.scanner;
                if (t1.peekChar$0() === 35) {
                    _0_0 = _this.singleInterpolation$0();
                    span = _0_0._1;
                    t1 = new A.InterpolationBuffer(new A.StringBuffer(""), A._setArrayType([], type$.JSArray_Object), A._setArrayType([], type$.JSArray_nullable_FileSpan));
                    t1.add$2(0, _0_0._0, span);
                    return new A.IfConditionRaw(t1.interpolation$1(span));
                }
                start = new A._SpanScannerState(t1, t1._string_scanner$_position);
                $label0$0: {
                    t2 = _this.scanIdentifier$1("if");
                    if (t2) {
                        t2 = t1.spanFrom$1(start);
                        t2 = new A.Interpolation(A.List_List$unmodifiable([
                            "if"
                        ], type$.Object), B.List_null, t2);
                        break $label0$0;
                    }
                    t2 = _this.scanIdentifier$1("var");
                    if (t2) {
                        t2 = t1.spanFrom$1(start);
                        t2 = new A.Interpolation(A.List_List$unmodifiable([
                            "var"
                        ], type$.Object), B.List_null, t2);
                        break $label0$0;
                    }
                    t2 = _this.scanIdentifier$1("attr");
                    if (t2) {
                        t2 = t1.spanFrom$1(start);
                        t2 = new A.Interpolation(A.List_List$unmodifiable([
                            "attr"
                        ], type$.Object), B.List_null, t2);
                        break $label0$0;
                    }
                    t2 = t1.matches$1("--");
                    if (t2) {
                        t2 = _this.interpolatedIdentifier$0();
                        break $label0$0;
                    }
                    t2 = null;
                    break $label0$0;
                }
                if (t2 == null) return null;
                if (!t1.scanChar$1(40)) {
                    t1.set$state(start);
                    return null;
                }
                $arguments = _this._interpolatedDeclarationValue$3$allowEmpty$allowSemicolon$consumeNewlines(true, true, true);
                t1.expectChar$1(41);
                return new A.IfConditionFunction(t2, $arguments, t1.spanFrom$1(start));
            },
            namespacedExpression$2: function(namespace, start) {
                var $name, t1, t2, t3, _this = this;
                if (_this.scanner.peekChar$0() === 36) {
                    $name = _this.variableName$0();
                    _this._assertPublic$2($name, new A.StylesheetParser_namespacedExpression_closure(_this, start));
                    return new A.VariableExpression(namespace, $name, _this.spanFrom$1(start));
                }
                t1 = _this._publicIdentifier$0();
                t2 = _this._argumentInvocation$0();
                t3 = _this.spanFrom$1(start);
                return new A.FunctionExpression(namespace, A.stringReplaceAllUnchecked(t1, "_", "-"), t1, t2, t3);
            },
            trySpecialFunction$2: function($name, start) {
                var invalidSassScript, nonCssSassScript, argument, t1, buffer, t2, normalized, vendored, _0_2, t3, _$exception, value, suggestion, next, _this = this;
                if ($name === "type" && _this.scanner.scanChar$1(40)) {
                    t1 = new A.StringBuffer("");
                    buffer = new A.InterpolationBuffer(t1, A._setArrayType([], type$.JSArray_Object), A._setArrayType([], type$.JSArray_nullable_FileSpan));
                    t1._contents = $name;
                    t2 = A.Primitives_stringFromCharCode(40);
                    t1._contents += t2;
                } else {
                    normalized = A.unvendor($name);
                    t1 = normalized === $name;
                    vendored = !t1;
                    $label0$0: {
                        _0_2 = "expression" === normalized;
                        if (_0_2 && vendored && _this.scanner.scanChar$1(40)) {
                            t1 = new A.StringBuffer("");
                            buffer = new A.InterpolationBuffer(t1, A._setArrayType([], type$.JSArray_Object), A._setArrayType([], type$.JSArray_nullable_FileSpan));
                            t1._contents = $name;
                            t2 = A.Primitives_stringFromCharCode(40);
                            t1._contents += t2;
                            t2 = _this.scanner;
                            t3 = t2._string_scanner$_position;
                            invalidSassScript = false;
                            nonCssSassScript = false;
                            try {
                                argument = _this._expression$0();
                                nonCssSassScript = !argument.accept$1(new A.IsPlainCssVisitor(true));
                            } catch (exception) {
                                if (A.unwrapException(exception) instanceof A.StringScannerException) invalidSassScript = true;
                                else throw exception;
                            }
                            t2.set$state(new A._SpanScannerState(t2, t3));
                            value = _this._interpolatedDeclarationValue$1$allowEmpty(true);
                            buffer.addInterpolation$1(value);
                            t2.expectChar$1(41);
                            t2 = A.Primitives_stringFromCharCode(41);
                            t1._contents += t2;
                            if (invalidSassScript || nonCssSassScript) {
                                suggestion = new A.StringExpression(value, true).asInterpolation$0();
                                t1 = invalidSassScript ? "be parsed as SassScript. " : "no longer be valid syntax. ";
                                _this.warnings.push(new A._Record_3_deprecation_message_span(B.Deprecation_H4k, "Vendor-prefixed " + normalized + string$.x28__fun + t1 + ("To preserve current behavior:\n\n" + $name + "(#{" + suggestion.toString$0(0) + string$.x7dx29__Mo), _this.spanFrom$1(start)));
                            }
                            return new A.StringExpression(buffer.interpolation$1(_this.spanFrom$1(start)), false);
                        }
                        t2 = true;
                        if (!("calc" === normalized && vendored && _this.scanner.scanChar$1(40))) {
                            if (!(_0_2 && t1 && _this.scanner.scanChar$1(40))) t1 = "element" === normalized && _this.scanner.scanChar$1(40);
                            else t1 = t2;
                        } else t1 = t2;
                        if (t1) {
                            t1 = new A.StringBuffer("");
                            buffer = new A.InterpolationBuffer(t1, A._setArrayType([], type$.JSArray_Object), A._setArrayType([], type$.JSArray_nullable_FileSpan));
                            t1._contents = $name;
                            t2 = A.Primitives_stringFromCharCode(40);
                            t1._contents += t2;
                            break $label0$0;
                        }
                        if ("progid" === normalized && _this.scanner.scanChar$1(58)) {
                            t1 = new A.StringBuffer("");
                            buffer = new A.InterpolationBuffer(t1, A._setArrayType([], type$.JSArray_Object), A._setArrayType([], type$.JSArray_nullable_FileSpan));
                            t1._contents = $name;
                            t2 = A.Primitives_stringFromCharCode(58);
                            t1._contents += t2;
                            t2 = _this.scanner;
                            next = t2.peekChar$0();
                            for(;;){
                                if (next != null) {
                                    if (!(next >= 97 && next <= 122)) t3 = next >= 65 && next <= 90;
                                    else t3 = true;
                                    t3 = t3 || next === 46;
                                } else t3 = false;
                                if (!t3) break;
                                t3 = A.Primitives_stringFromCharCode(t2.readChar$0());
                                t1._contents += t3;
                                next = t2.peekChar$0();
                            }
                            t2.expectChar$1(40);
                            t3 = A.Primitives_stringFromCharCode(40);
                            t1._contents += t3;
                            buffer.addInterpolation$1(_this._interpolatedDeclarationValue$1$allowEmpty(true));
                            t2.expectChar$1(41);
                            t2 = A.Primitives_stringFromCharCode(41);
                            t1._contents += t2;
                            if (vendored) _this.warnings.push(new A._Record_3_deprecation_message_span(B.Deprecation_H4k, string$.Vendorp + new A.StringExpression(buffer.interpolation$1(_this.spanFrom$1(start)), true).asInterpolation$0().toString$0(0) + string$.x7dx0a_Mor, _this.spanFrom$1(start)));
                            return new A.StringExpression(buffer.interpolation$1(_this.spanFrom$1(start)), false);
                        }
                        if ("url" === normalized) return A.NullableExtension_andThen(_this._tryUrlContents$2$vendored(start, vendored), new A.StylesheetParser_trySpecialFunction_closure());
                        return null;
                    }
                }
                buffer.addInterpolation$1(_this._interpolatedDeclarationValue$1$allowEmpty(true));
                _this.scanner.expectChar$1(41);
                t1 = buffer._interpolation_buffer$_text;
                t2 = A.Primitives_stringFromCharCode(41);
                t1._contents += t2;
                return new A.StringExpression(buffer.interpolation$1(_this.spanFrom$1(start)), false);
            },
            _tryUrlContents$3$name$vendored: function(start, $name, vendored) {
                var invalidSassScript, t3, _$exception, t4, t5, buffer, t6, _1_0, _1_6, _0_0, _this = this, t1 = _this.scanner, t2 = t1._string_scanner$_position;
                if (!t1.scanChar$1(40)) return null;
                invalidSassScript = false;
                if (vendored) {
                    t3 = t1._string_scanner$_position;
                    try {
                        _this._expression$0();
                    } catch (exception) {
                        if (A.unwrapException(exception) instanceof A.StringScannerException) invalidSassScript = true;
                        else throw exception;
                    }
                    t1.set$state(new A._SpanScannerState(t1, t3));
                }
                _this.whitespaceWithoutComments$1$consumeNewlines(true);
                t3 = new A.StringBuffer("");
                t4 = A._setArrayType([], type$.JSArray_Object);
                t5 = A._setArrayType([], type$.JSArray_nullable_FileSpan);
                buffer = new A.InterpolationBuffer(t3, t4, t5);
                t3._contents = $name == null ? "url" : $name;
                t6 = A.Primitives_stringFromCharCode(40);
                t3._contents += t6;
                for(;;){
                    _1_0 = t1.peekChar$0();
                    if (_1_0 == null) break;
                    if (92 === _1_0) {
                        t6 = _this.escape$0();
                        t3._contents += t6;
                        continue;
                    }
                    _1_6 = 35 === _1_0;
                    if (_1_6 && t1.peekChar$1(1) === 123) {
                        _0_0 = _this.singleInterpolation$0();
                        buffer._flushText$0();
                        t4.push(_0_0._0);
                        t5.push(_0_0._1);
                        continue;
                    }
                    t6 = true;
                    if (33 !== _1_0) {
                        if (37 !== _1_0) {
                            if (38 !== _1_0) {
                                if (!_1_6) t6 = _1_0 >= 42 && _1_0 <= 126 || _1_0 >= 128;
                            }
                        }
                    }
                    if (t6) {
                        t6 = A.Primitives_stringFromCharCode(t1.readChar$0());
                        t3._contents += t6;
                        continue;
                    }
                    if (_1_0 === 32 || _1_0 === 9 || _1_0 === 10 || _1_0 === 13 || _1_0 === 12) {
                        _this.whitespaceWithoutComments$1$consumeNewlines(true);
                        if (t1.peekChar$0() !== 41) break;
                        continue;
                    }
                    if (41 === _1_0) {
                        t2 = A.Primitives_stringFromCharCode(t1.readChar$0());
                        t3._contents += t2;
                        if (vendored && invalidSassScript) _this.warnings.push(new A._Record_3_deprecation_message_span(B.Deprecation_H4k, string$.Vendoru + A.S($name) + "(#{" + new A.StringExpression(buffer.interpolation$1(_this.spanFrom$1(start)), true).asInterpolation$0().toString$0(0) + string$.x7dx29__Mo, _this.spanFrom$1(start)));
                        return buffer.interpolation$1(_this.spanFrom$1(start));
                    }
                    break;
                }
                t1.set$state(new A._SpanScannerState(t1, t2));
                return null;
            },
            _tryUrlContents$2$vendored: function(start, vendored) {
                return this._tryUrlContents$3$name$vendored(start, null, vendored);
            },
            _tryUrlContents$2$name: function(start, $name) {
                return this._tryUrlContents$3$name$vendored(start, $name, false);
            },
            _tryUrlContents$1: function(start) {
                return this._tryUrlContents$3$name$vendored(start, null, false);
            },
            dynamicUrl$0: function() {
                var _0_0, _this = this, t1 = _this.scanner, start = new A._SpanScannerState(t1, t1._string_scanner$_position);
                _this.expectIdentifier$1("url");
                _0_0 = _this._tryUrlContents$1(start);
                if (_0_0 != null) return new A.StringExpression(_0_0, false);
                t1 = _this.spanFrom$1(start);
                return new A.InterpolatedFunctionExpression(new A.Interpolation(A.List_List$unmodifiable([
                    "url"
                ], type$.Object), B.List_null, t1), _this._argumentInvocation$0(), _this.spanFrom$1(start));
            },
            almostAnyValue$1$omitComments: function(omitComments) {
                var t4, t5, t6, t7, _2_0, t8, _0_0, _0_2, start, end, _0_4, identifier, _1_0, bracket, char, _this = this, t1 = _this.scanner, t2 = t1._string_scanner$_position, t3 = new A.StringBuffer(""), buffer = new A.InterpolationBuffer(t3, A._setArrayType([], type$.JSArray_Object), A._setArrayType([], type$.JSArray_nullable_FileSpan)), brackets = A._setArrayType([], type$.JSArray_int);
                for(t4 = t1.string, t5 = t4.length, t6 = !omitComments, t7 = _this.get$loudComment();;)$label0$0: {
                    _2_0 = t1.peekChar$0();
                    if (92 === _2_0) {
                        t8 = A.Primitives_stringFromCharCode(t1.readChar$0());
                        t3._contents += t8;
                        t8 = A.Primitives_stringFromCharCode(t1.readChar$0());
                        t3._contents += t8;
                        break $label0$0;
                    }
                    if (34 === _2_0 || 39 === _2_0) {
                        buffer.addInterpolation$1(_this.interpolatedStringToken$0());
                        break $label0$0;
                    }
                    if (47 === _2_0) {
                        $label1$1: {
                            _0_0 = t1.peekChar$1(1);
                            _0_2 = 42 === _0_0;
                            if (_0_2 && t6) {
                                start = t1._string_scanner$_position;
                                t7.call$0();
                                end = t1._string_scanner$_position;
                                t3._contents += B.JSString_methods.substring$2(t4, start, end);
                                break $label1$1;
                            }
                            if (_0_2) {
                                _this.loudComment$0();
                                break $label1$1;
                            }
                            _0_4 = 47 === _0_0;
                            if (_0_4 && t6) {
                                t8 = _this.get$silentComment();
                                start = t1._string_scanner$_position;
                                t8.call$0();
                                end = t1._string_scanner$_position;
                                t3._contents += B.JSString_methods.substring$2(t4, start, end);
                                break $label1$1;
                            }
                            if (_0_4) {
                                _this.silentComment$0();
                                break $label1$1;
                            }
                            t8 = A.Primitives_stringFromCharCode(t1.readChar$0());
                            t3._contents += t8;
                        }
                        break $label0$0;
                    }
                    if (35 === _2_0 && t1.peekChar$1(1) === 123) {
                        buffer.addInterpolation$1(_this.interpolatedIdentifier$0());
                        break $label0$0;
                    }
                    if (13 === _2_0 || 10 === _2_0 || 12 === _2_0) {
                        if (_this.get$indented() && brackets.length === 0) break;
                        t8 = A.Primitives_stringFromCharCode(t1.readChar$0());
                        t3._contents += t8;
                        break $label0$0;
                    }
                    if (33 === _2_0 || 59 === _2_0 || 123 === _2_0 || 125 === _2_0) break;
                    if (117 === _2_0 || 85 === _2_0) {
                        t8 = t1._string_scanner$_position;
                        identifier = _this.identifier$0();
                        if (identifier !== "url" && identifier !== "url-prefix") {
                            t3._contents += identifier;
                            continue;
                        }
                        _1_0 = _this._tryUrlContents$2$name(new A._SpanScannerState(t1, t8), identifier);
                        if (_1_0 != null) buffer.addInterpolation$1(_1_0);
                        else {
                            if ((t8 === 0 ? 1 / t8 < 0 : t8 < 0) || t8 > t5) A.throwExpression(A.ArgumentError$("Invalid position " + t8, null));
                            t1._string_scanner$_position = t8;
                            t1._lastMatch = null;
                            t8 = A.Primitives_stringFromCharCode(t1.readChar$0());
                            t3._contents += t8;
                        }
                        break $label0$0;
                    }
                    if (40 === _2_0 || 91 === _2_0) {
                        bracket = t1.readChar$0();
                        t8 = A.Primitives_stringFromCharCode(bracket);
                        t3._contents += t8;
                        brackets.push(A.opposite(bracket));
                        break $label0$0;
                    }
                    if (41 === _2_0 || 93 === _2_0) {
                        t8 = _2_0 != null;
                        char = t8 ? _2_0 : null;
                    } else {
                        char = null;
                        t8 = false;
                    }
                    if (t8) {
                        if (brackets.length === 0) t1.error$1(0, 'Unexpected "' + A.Primitives_stringFromCharCode(char) + '".');
                        bracket = brackets.pop();
                        t1.expectChar$1(bracket);
                        t8 = A.Primitives_stringFromCharCode(bracket);
                        t3._contents += t8;
                        break $label0$0;
                    }
                    if (_2_0 == null) break;
                    t8 = _this.lookingAtIdentifier$0();
                    if (t8) {
                        t8 = _this.identifier$0();
                        t3._contents += t8;
                        break $label0$0;
                    }
                    t8 = A.Primitives_stringFromCharCode(t1.readChar$0());
                    t3._contents += t8;
                }
                return buffer.interpolation$1(_this.spanFrom$1(new A._SpanScannerState(t1, t2)));
            },
            almostAnyValue$0: function() {
                return this.almostAnyValue$1$omitComments(false);
            },
            _interpolatedDeclarationValue$7$allowColon$allowEmpty$allowOpenBrace$allowSemicolon$consumeNewlines$endAfterOf$silentComments: function(allowColon, allowEmpty, allowOpenBrace, allowSemicolon, consumeNewlines, endAfterOf, silentComments) {
                var t5, t6, t7, t8, t9, t10, t11, wroteNewline, _2_0, wroteNewline0, t12, _0_0, start, end, _2_12, _2_14_isSet, _2_14, t13, _2_16, _2_18_isSet, _2_20, _2_18, _2_20_isSet, _2_22, bracket, identifier, _1_0, of, _this = this, _null = null, t1 = _this.scanner, t2 = t1._string_scanner$_position, t3 = new A.StringBuffer(""), t4 = A._setArrayType([], type$.JSArray_Object), buffer = new A.InterpolationBuffer(t3, t4, A._setArrayType([], type$.JSArray_nullable_FileSpan)), brackets = A._setArrayType([], type$.JSArray_int);
                for(t5 = !consumeNewlines, t6 = !allowOpenBrace, t7 = t1.string, t8 = t7.length, t9 = !allowColon, t10 = !allowSemicolon, t11 = _this.get$loudComment(), wroteNewline = false;;)$label0$0: {
                    _2_0 = t1.peekChar$0();
                    wroteNewline0 = false;
                    if (92 === _2_0) {
                        t12 = _this.escape$1$identifierStart(true);
                        t3._contents += t12;
                        wroteNewline = wroteNewline0;
                        break $label0$0;
                    }
                    if (34 === _2_0 || 39 === _2_0) {
                        buffer.addInterpolation$1(_this.interpolatedStringToken$0());
                        wroteNewline = wroteNewline0;
                        break $label0$0;
                    }
                    if (47 === _2_0) {
                        $label1$1: {
                            _0_0 = t1.peekChar$1(1);
                            if (42 === _0_0) {
                                start = t1._string_scanner$_position;
                                t11.call$0();
                                end = t1._string_scanner$_position;
                                t3._contents += B.JSString_methods.substring$2(t7, start, end);
                                break $label1$1;
                            }
                            if (47 === _0_0 && silentComments) {
                                _this.silentComment$0();
                                break $label1$1;
                            }
                            t12 = A.Primitives_stringFromCharCode(t1.readChar$0());
                            t3._contents += t12;
                        }
                        wroteNewline = wroteNewline0;
                        break $label0$0;
                    }
                    if (35 === _2_0 && t1.peekChar$1(1) === 123) {
                        buffer.addInterpolation$1(_this.interpolatedIdentifier$0());
                        wroteNewline = wroteNewline0;
                        break $label0$0;
                    }
                    _2_12 = 32 === _2_0;
                    _2_14_isSet = !_2_12;
                    if (_2_14_isSet) {
                        _2_14 = 9 === _2_0;
                        t12 = _2_14;
                    } else {
                        _2_14 = _null;
                        t12 = true;
                    }
                    t13 = false;
                    if (t12) {
                        if (!wroteNewline) {
                            t12 = t1.peekChar$1(1);
                            t12 = t12 === 32 || t12 === 9 || t12 === 10 || t12 === 13 || t12 === 12;
                        } else t12 = t13;
                    } else t12 = t13;
                    if (t12) {
                        t1.readChar$0();
                        break $label0$0;
                    }
                    if (!_2_12) t12 = _2_14_isSet ? _2_14 : 9 === _2_0;
                    else t12 = true;
                    if (t12) {
                        t12 = A.Primitives_stringFromCharCode(t1.readChar$0());
                        t3._contents += t12;
                        break $label0$0;
                    }
                    _2_16 = 10 === _2_0;
                    _2_18_isSet = !_2_16;
                    _2_20 = _null;
                    t12 = true;
                    if (_2_18_isSet) {
                        _2_18 = 13 === _2_0;
                        _2_20_isSet = !_2_18;
                        if (_2_20_isSet) {
                            _2_20 = 12 === _2_0;
                            t12 = _2_20;
                        }
                    } else {
                        _2_18 = _null;
                        _2_20_isSet = false;
                    }
                    if (t12 && _this.get$indented() && t5 && brackets.length === 0) break;
                    t12 = true;
                    if (!_2_16) {
                        if (!(_2_18_isSet ? _2_18 : 13 === _2_0)) t12 = _2_20_isSet ? _2_20 : 12 === _2_0;
                    }
                    if (t12) {
                        t12 = t1.peekChar$1(-1);
                        if (!(t12 === 10 || t12 === 13 || t12 === 12)) t3._contents += "\n";
                        t1.readChar$0();
                        wroteNewline = true;
                        break $label0$0;
                    }
                    _2_22 = 123 === _2_0;
                    if (_2_22 && t6) break;
                    if (40 !== _2_0) t12 = _2_22 || 91 === _2_0;
                    else t12 = true;
                    if (t12) {
                        bracket = t1.readChar$0();
                        t12 = A.Primitives_stringFromCharCode(bracket);
                        t3._contents += t12;
                        brackets.push(A.opposite(bracket));
                        wroteNewline = wroteNewline0;
                        break $label0$0;
                    }
                    if (41 === _2_0 || 125 === _2_0 || 93 === _2_0) {
                        if (brackets.length === 0) break;
                        bracket = brackets.pop();
                        t1.expectChar$1(bracket);
                        t12 = A.Primitives_stringFromCharCode(bracket);
                        t3._contents += t12;
                        wroteNewline = wroteNewline0;
                        break $label0$0;
                    }
                    if (59 === _2_0) {
                        if (t10 && brackets.length === 0) break;
                        t12 = A.Primitives_stringFromCharCode(t1.readChar$0());
                        t3._contents += t12;
                        wroteNewline = wroteNewline0;
                        break $label0$0;
                    }
                    if (58 === _2_0) {
                        if (t9 && brackets.length === 0) break;
                        t12 = A.Primitives_stringFromCharCode(t1.readChar$0());
                        t3._contents += t12;
                        wroteNewline = wroteNewline0;
                        break $label0$0;
                    }
                    if (117 === _2_0 || 85 === _2_0) {
                        t12 = t1._string_scanner$_position;
                        identifier = _this.identifier$0();
                        if (identifier !== "url" && identifier !== "url-prefix") {
                            t3._contents += identifier;
                            wroteNewline = wroteNewline0;
                            continue;
                        }
                        _1_0 = _this._tryUrlContents$2$name(new A._SpanScannerState(t1, t12), identifier);
                        if (_1_0 != null) buffer.addInterpolation$1(_1_0);
                        else {
                            if ((t12 === 0 ? 1 / t12 < 0 : t12 < 0) || t12 > t8) A.throwExpression(A.ArgumentError$("Invalid position " + t12, _null));
                            t1._string_scanner$_position = t12;
                            t1._lastMatch = null;
                            t12 = A.Primitives_stringFromCharCode(t1.readChar$0());
                            t3._contents += t12;
                        }
                        wroteNewline = wroteNewline0;
                        break $label0$0;
                    }
                    if (111 === _2_0 || 79 === _2_0) {
                        if (endAfterOf && brackets.length === 0) {
                            start = t1._string_scanner$_position;
                            new A.StylesheetParser__interpolatedDeclarationValue_closure(_this).call$0();
                            end = t1._string_scanner$_position;
                            of = B.JSString_methods.substring$2(t7, start, end);
                            if (of !== "") {
                                t3._contents += of;
                                break;
                            }
                        }
                        t12 = A.Primitives_stringFromCharCode(t1.readChar$0());
                        t3._contents += t12;
                        wroteNewline = wroteNewline0;
                        break $label0$0;
                    }
                    if (_2_0 == null) break;
                    t12 = _this.lookingAtIdentifier$0();
                    if (t12) {
                        t12 = _this.identifier$0();
                        t3._contents += t12;
                        wroteNewline = wroteNewline0;
                        break $label0$0;
                    }
                    t12 = A.Primitives_stringFromCharCode(t1.readChar$0());
                    t3._contents += t12;
                    wroteNewline = wroteNewline0;
                }
                if (brackets.length !== 0) t1.expectChar$1(B.JSArray_methods.get$last(brackets));
                if (!allowEmpty && t4.length === 0 && t3._contents.length === 0) t1.error$1(0, "Expected token.");
                return buffer.interpolation$1(_this.spanFrom$1(new A._SpanScannerState(t1, t2)));
            },
            _interpolatedDeclarationValue$1$allowEmpty: function(allowEmpty) {
                return this._interpolatedDeclarationValue$7$allowColon$allowEmpty$allowOpenBrace$allowSemicolon$consumeNewlines$endAfterOf$silentComments(true, allowEmpty, true, false, false, false, true);
            },
            _interpolatedDeclarationValue$3$allowEmpty$allowSemicolon$consumeNewlines: function(allowEmpty, allowSemicolon, consumeNewlines) {
                return this._interpolatedDeclarationValue$7$allowColon$allowEmpty$allowOpenBrace$allowSemicolon$consumeNewlines$endAfterOf$silentComments(true, allowEmpty, true, allowSemicolon, consumeNewlines, false, true);
            },
            _interpolatedDeclarationValue$4$allowColon$allowEmpty$allowSemicolon$consumeNewlines: function(allowColon, allowEmpty, allowSemicolon, consumeNewlines) {
                return this._interpolatedDeclarationValue$7$allowColon$allowEmpty$allowOpenBrace$allowSemicolon$consumeNewlines$endAfterOf$silentComments(allowColon, allowEmpty, true, allowSemicolon, consumeNewlines, false, true);
            },
            _interpolatedDeclarationValue$0: function() {
                return this._interpolatedDeclarationValue$7$allowColon$allowEmpty$allowOpenBrace$allowSemicolon$consumeNewlines$endAfterOf$silentComments(true, false, true, false, false, false, true);
            },
            _interpolatedDeclarationValue$1$allowOpenBrace: function(allowOpenBrace) {
                return this._interpolatedDeclarationValue$7$allowColon$allowEmpty$allowOpenBrace$allowSemicolon$consumeNewlines$endAfterOf$silentComments(true, false, allowOpenBrace, false, false, false, true);
            },
            _interpolatedDeclarationValue$2$allowEmpty$allowOpenBrace: function(allowEmpty, allowOpenBrace) {
                return this._interpolatedDeclarationValue$7$allowColon$allowEmpty$allowOpenBrace$allowSemicolon$consumeNewlines$endAfterOf$silentComments(true, allowEmpty, allowOpenBrace, false, false, false, true);
            },
            _interpolatedDeclarationValue$1$silentComments: function(silentComments) {
                return this._interpolatedDeclarationValue$7$allowColon$allowEmpty$allowOpenBrace$allowSemicolon$consumeNewlines$endAfterOf$silentComments(true, false, true, false, false, false, silentComments);
            },
            interpolatedIdentifier$0: function() {
                var t3, _1_0, _0_0, _this = this, _s20_ = "Expected identifier.", t1 = _this.scanner, start = new A._SpanScannerState(t1, t1._string_scanner$_position), t2 = new A.StringBuffer(""), buffer = new A.InterpolationBuffer(t2, A._setArrayType([], type$.JSArray_Object), A._setArrayType([], type$.JSArray_nullable_FileSpan));
                if (t1.scanChar$1(45)) {
                    t3 = A.Primitives_stringFromCharCode(45);
                    t2._contents += t3;
                    if (t1.scanChar$1(45)) {
                        t2._contents += t3;
                        _this._interpolatedIdentifierBodyHelper$1(buffer);
                        return buffer.interpolation$1(_this.spanFrom$1(start));
                    }
                }
                $label0$0: {
                    _1_0 = t1.peekChar$0();
                    if (_1_0 == null) t1.error$1(0, _s20_);
                    if (_1_0 === 95 || A.CharacterExtension_get_isAlphabetic(_1_0) || _1_0 >= 128) {
                        t1 = A.Primitives_stringFromCharCode(t1.readChar$0());
                        t2._contents += t1;
                        break $label0$0;
                    }
                    if (92 === _1_0) {
                        t1 = _this.escape$1$identifierStart(true);
                        t2._contents += t1;
                        break $label0$0;
                    }
                    if (35 === _1_0 && t1.peekChar$1(1) === 123) {
                        _0_0 = _this.singleInterpolation$0();
                        buffer.add$2(0, _0_0._0, _0_0._1);
                        break $label0$0;
                    }
                    t1.error$1(0, _s20_);
                }
                _this._interpolatedIdentifierBodyHelper$1(buffer);
                return buffer.interpolation$1(_this.spanFrom$1(start));
            },
            _interpolatedIdentifierBodyHelper$1: function(buffer) {
                var t1, t2, t3, t4, _1_0, t5, _0_0;
                for(t1 = buffer._interpolation_buffer$_contents, t2 = buffer._spans, t3 = this.scanner, t4 = buffer._interpolation_buffer$_text;;){
                    _1_0 = t3.peekChar$0();
                    if (_1_0 == null) break;
                    t5 = true;
                    if (95 !== _1_0) {
                        if (45 !== _1_0) {
                            if (!(_1_0 >= 97 && _1_0 <= 122)) t5 = _1_0 >= 65 && _1_0 <= 90;
                            else t5 = true;
                            if (!t5) t5 = _1_0 >= 48 && _1_0 <= 57;
                            else t5 = true;
                            t5 = t5 || _1_0 >= 128;
                        }
                    }
                    if (t5) {
                        t5 = A.Primitives_stringFromCharCode(t3.readChar$0());
                        t4._contents += t5;
                        continue;
                    }
                    if (92 === _1_0) {
                        t5 = this.escape$0();
                        t4._contents += t5;
                        continue;
                    }
                    if (35 === _1_0 && t3.peekChar$1(1) === 123) {
                        _0_0 = this.singleInterpolation$0();
                        buffer._flushText$0();
                        t1.push(_0_0._0);
                        t2.push(_0_0._1);
                        continue;
                    }
                    break;
                }
            },
            singleInterpolation$0: function() {
                var contents, span, _this = this, t1 = _this.scanner, t2 = t1._string_scanner$_position;
                t1.expect$1("#{");
                _this.whitespace$1$consumeNewlines(true);
                contents = _this._expression$1$consumeNewlines(true);
                t1.expectChar$1(125);
                span = _this.spanFrom$1(new A._SpanScannerState(t1, t2));
                if (_this.get$plainCss()) _this.error$2(0, string$.Interpp, span);
                return new A._Record_2(contents, span);
            },
            _mediaQueryList$0: function() {
                var t4, _this = this, t1 = _this.scanner, t2 = t1._string_scanner$_position, t3 = new A.StringBuffer(""), buffer = new A.InterpolationBuffer(t3, A._setArrayType([], type$.JSArray_Object), A._setArrayType([], type$.JSArray_nullable_FileSpan));
                for(;;){
                    _this.whitespace$1$consumeNewlines(false);
                    _this._stylesheet$_mediaQuery$1(buffer);
                    _this.whitespace$1$consumeNewlines(false);
                    if (!t1.scanChar$1(44)) break;
                    t4 = A.Primitives_stringFromCharCode(44);
                    t3._contents += t4;
                    t4 = A.Primitives_stringFromCharCode(32);
                    t3._contents += t4;
                }
                return buffer.interpolation$1(_this.spanFrom$1(new A._SpanScannerState(t1, t2)));
            },
            _stylesheet$_mediaQuery$1: function(buffer) {
                var identifier1, t1, t2, identifier2, _this = this, _s3_ = "and";
                if (_this.scanner.peekChar$0() === 40) {
                    _this._stylesheet$_mediaInParens$1(buffer);
                    _this.whitespace$1$consumeNewlines(false);
                    if (_this.scanIdentifier$1(_s3_)) {
                        buffer._interpolation_buffer$_text._contents += " and ";
                        _this.expectWhitespace$0();
                        _this._stylesheet$_mediaLogicSequence$2(buffer, _s3_);
                    } else if (_this.scanIdentifier$1("or")) {
                        buffer._interpolation_buffer$_text._contents += " or ";
                        _this.expectWhitespace$0();
                        _this._stylesheet$_mediaLogicSequence$2(buffer, "or");
                    }
                    return;
                }
                identifier1 = _this.interpolatedIdentifier$0();
                if (A.equalsIgnoreCase(identifier1.get$asPlain(), "not")) {
                    _this.expectWhitespace$0();
                    if (!_this._lookingAtInterpolatedIdentifier$0()) {
                        buffer._interpolation_buffer$_text._contents += "not ";
                        _this._mediaOrInterp$1(buffer);
                        return;
                    }
                }
                _this.whitespace$1$consumeNewlines(false);
                buffer.addInterpolation$1(identifier1);
                if (!_this._lookingAtInterpolatedIdentifier$0()) return;
                t1 = buffer._interpolation_buffer$_text;
                t2 = A.Primitives_stringFromCharCode(32);
                t1._contents += t2;
                identifier2 = _this.interpolatedIdentifier$0();
                if (A.equalsIgnoreCase(identifier2.get$asPlain(), _s3_)) {
                    _this.expectWhitespace$0();
                    t1._contents += " and ";
                } else {
                    _this.whitespace$1$consumeNewlines(false);
                    buffer.addInterpolation$1(identifier2);
                    if (_this.scanIdentifier$1(_s3_)) {
                        _this.expectWhitespace$0();
                        t1._contents += " and ";
                    } else return;
                }
                if (_this.scanIdentifier$1("not")) {
                    _this.expectWhitespace$0();
                    t1._contents += "not ";
                    _this._mediaOrInterp$1(buffer);
                    return;
                }
                _this._stylesheet$_mediaLogicSequence$2(buffer, _s3_);
                return;
            },
            _stylesheet$_mediaLogicSequence$2: function(buffer, operator) {
                var t1, t2, t3, _this = this;
                for(t1 = buffer._interpolation_buffer$_text;;){
                    _this._mediaOrInterp$1(buffer);
                    _this.whitespace$1$consumeNewlines(false);
                    if (!_this.scanIdentifier$1(operator)) return;
                    _this.expectWhitespace$1$consumeNewlines(false);
                    t2 = A.Primitives_stringFromCharCode(32);
                    t3 = (t1._contents += t2) + operator;
                    t1._contents = t3;
                    t1._contents = t3 + t2;
                }
            },
            _mediaOrInterp$1: function(buffer) {
                var _0_0;
                if (this.scanner.peekChar$0() === 35) {
                    _0_0 = this.singleInterpolation$0();
                    buffer.add$2(0, _0_0._0, _0_0._1);
                } else this._stylesheet$_mediaInParens$1(buffer);
            },
            _stylesheet$_mediaInParens$1: function(buffer) {
                var t2, t3, expressionBefore, expressionAfter, next, t4, t5, expressionMiddle, _this = this, t1 = _this.scanner;
                t1.expectChar$2$name(40, "media condition in parentheses");
                t2 = buffer._interpolation_buffer$_text;
                t3 = A.Primitives_stringFromCharCode(40);
                t2._contents += t3;
                _this.whitespace$1$consumeNewlines(true);
                if (t1.peekChar$0() === 40) {
                    _this._stylesheet$_mediaInParens$1(buffer);
                    _this.whitespace$1$consumeNewlines(true);
                    if (_this.scanIdentifier$1("and")) {
                        t2._contents += " and ";
                        _this.expectWhitespace$1$consumeNewlines(true);
                        _this._stylesheet$_mediaLogicSequence$2(buffer, "and");
                    } else if (_this.scanIdentifier$1("or")) {
                        t2._contents += " or ";
                        _this.expectWhitespace$1$consumeNewlines(true);
                        _this._stylesheet$_mediaLogicSequence$2(buffer, "or");
                    }
                } else if (_this.scanIdentifier$1("not")) {
                    t2._contents += "not ";
                    _this.expectWhitespace$1$consumeNewlines(true);
                    _this._mediaOrInterp$1(buffer);
                } else {
                    expressionBefore = _this._expressionUntilComparison$0();
                    buffer.add$2(0, expressionBefore, expressionBefore.get$span(expressionBefore));
                    if (t1.scanChar$1(58)) {
                        _this.whitespace$1$consumeNewlines(true);
                        t3 = A.Primitives_stringFromCharCode(58);
                        t2._contents += t3;
                        t3 = A.Primitives_stringFromCharCode(32);
                        t2._contents += t3;
                        expressionAfter = _this._expression$1$consumeNewlines(true);
                        buffer.add$2(0, expressionAfter, expressionAfter.get$span(expressionAfter));
                    } else {
                        next = t1.peekChar$0();
                        t3 = 60 !== next;
                        if (!t3 || 62 === next || 61 === next) {
                            t4 = A.Primitives_stringFromCharCode(32);
                            t2._contents += t4;
                            t5 = A.Primitives_stringFromCharCode(t1.readChar$0());
                            t2._contents += t5;
                            if ((!t3 || 62 === next) && t1.scanChar$1(61)) {
                                t5 = A.Primitives_stringFromCharCode(61);
                                t2._contents += t5;
                            }
                            t2._contents += t4;
                            _this.whitespace$1$consumeNewlines(true);
                            expressionMiddle = _this._expressionUntilComparison$0();
                            buffer.add$2(0, expressionMiddle, expressionMiddle.get$span(expressionMiddle));
                            if (!t3 || 62 === next) {
                                next.toString;
                                t3 = t1.scanChar$1(next);
                            } else t3 = false;
                            if (t3) {
                                t2._contents += t4;
                                t3 = A.Primitives_stringFromCharCode(next);
                                t2._contents += t3;
                                if (t1.scanChar$1(61)) {
                                    t3 = A.Primitives_stringFromCharCode(61);
                                    t2._contents += t3;
                                }
                                t2._contents += t4;
                                _this.whitespace$1$consumeNewlines(true);
                                expressionAfter = _this._expressionUntilComparison$0();
                                buffer.add$2(0, expressionAfter, expressionAfter.get$span(expressionAfter));
                            }
                        }
                    }
                }
                t1.expectChar$1(41);
                _this.whitespace$1$consumeNewlines(false);
                t1 = A.Primitives_stringFromCharCode(41);
                t2._contents += t1;
            },
            _expressionUntilComparison$0: function() {
                return this._expression$2$consumeNewlines$until(true, new A.StylesheetParser__expressionUntilComparison_closure(this));
            },
            _supportsCondition$1$inParentheses: function(inParentheses) {
                var condition, operator, _this = this, t1 = _this.scanner, start = new A._SpanScannerState(t1, t1._string_scanner$_position);
                if (_this.scanIdentifier$1("not")) {
                    _this.whitespace$1$consumeNewlines(inParentheses);
                    return new A.SupportsNegation(_this._supportsConditionInParens$0(), _this.spanFrom$1(start));
                }
                condition = _this._supportsConditionInParens$0();
                _this.whitespace$1$consumeNewlines(inParentheses);
                for(operator = null; _this.lookingAtIdentifier$0();){
                    if (operator != null) _this.expectIdentifier$1(operator._name);
                    else if (_this.scanIdentifier$1("or")) operator = B.BooleanOperator_1;
                    else {
                        _this.expectIdentifier$1("and");
                        operator = B.BooleanOperator_0;
                    }
                    _this.whitespace$1$consumeNewlines(inParentheses);
                    condition = new A.SupportsOperation(condition, _this._supportsConditionInParens$0(), operator, _this.spanFrom$1(start));
                    _this.whitespace$1$consumeNewlines(inParentheses);
                }
                return condition;
            },
            _supportsCondition$0: function() {
                return this._supportsCondition$1$inParentheses(false);
            },
            _supportsConditionInParens$0: function() {
                var $name, nameStart, wasInParentheses, identifier, _1_0, operation, contents, identifier0, t2, $arguments, _0_0, _0_4_isSet, _0_4, condition, _$exception, value, _this = this, t1 = _this.scanner, start = new A._SpanScannerState(t1, t1._string_scanner$_position);
                if (_this._lookingAtInterpolatedIdentifier$0()) {
                    identifier0 = _this.interpolatedIdentifier$0();
                    t2 = identifier0.get$asPlain();
                    if ((t2 == null ? null : t2.toLowerCase()) === "not") _this.error$2(0, '"not" is not a valid identifier here.', identifier0.span);
                    if (t1.scanChar$1(40)) {
                        $arguments = _this._interpolatedDeclarationValue$3$allowEmpty$allowSemicolon$consumeNewlines(true, true, true);
                        t1.expectChar$1(41);
                        return new A.SupportsFunction(identifier0, $arguments, _this.spanFrom$1(start));
                    } else {
                        _0_0 = identifier0.contents;
                        _0_4_isSet = _0_0.length === 1;
                        if (_0_4_isSet) {
                            _0_4 = _0_0[0];
                            t2 = _0_4 instanceof A.Expression;
                        } else {
                            _0_4 = null;
                            t2 = false;
                        }
                        if (t2) {
                            t1 = _0_4_isSet ? _0_4 : _0_0[0];
                            return new A.SupportsInterpolation(type$.Expression._as(t1), _this.spanFrom$1(start));
                        } else _this.error$2(0, "Expected @supports condition.", identifier0.span);
                    }
                }
                t1.expectChar$1(40);
                _this.whitespace$1$consumeNewlines(true);
                if (_this.scanIdentifier$1("not")) {
                    _this.whitespace$1$consumeNewlines(true);
                    condition = _this._supportsConditionInParens$0();
                    t1.expectChar$1(41);
                    return new A.SupportsNegation(condition, _this.spanFrom$1(start));
                } else if (t1.peekChar$0() === 40) {
                    condition = _this._supportsCondition$1$inParentheses(true);
                    t1.expectChar$1(41);
                    return condition.withSpan$1(_this.spanFrom$1(start));
                }
                $name = null;
                nameStart = new A._SpanScannerState(t1, t1._string_scanner$_position);
                wasInParentheses = _this._inParentheses;
                try {
                    $name = _this._expression$1$consumeNewlines(true);
                    t1.expectChar$1(58);
                } catch (exception) {
                    if (type$.FormatException._is(A.unwrapException(exception))) {
                        t1.set$state(nameStart);
                        _this._inParentheses = wasInParentheses;
                        identifier = _this.interpolatedIdentifier$0();
                        _1_0 = _this._trySupportsOperation$2(identifier, nameStart);
                        operation = null;
                        if (_1_0 != null) {
                            operation = _1_0;
                            t1.expectChar$1(41);
                            t1 = operation;
                            t2 = _this.spanFrom$1(start);
                            return new A.SupportsOperation(t1.left, t1.right, t1.operator, t2);
                        }
                        t2 = new A.InterpolationBuffer(new A.StringBuffer(""), A._setArrayType([], type$.JSArray_Object), A._setArrayType([], type$.JSArray_nullable_FileSpan));
                        t2.addInterpolation$1(identifier);
                        t2.addInterpolation$1(_this._interpolatedDeclarationValue$4$allowColon$allowEmpty$allowSemicolon$consumeNewlines(false, true, true, true));
                        contents = t2.interpolation$1(_this.spanFrom$1(nameStart));
                        if (t1.peekChar$0() === 58) throw exception;
                        t1.expectChar$1(41);
                        return new A.SupportsAnything(contents, _this.spanFrom$1(start));
                    } else throw exception;
                }
                value = _this._supportsDeclarationValue$1($name);
                t1.expectChar$1(41);
                return new A.SupportsDeclaration($name, value, _this.spanFrom$1(start));
            },
            _supportsDeclarationValue$1: function($name) {
                var t1 = false;
                if ($name instanceof A.StringExpression) {
                    if (!$name.hasQuotes) t1 = B.JSString_methods.startsWith$1($name.text.get$initialPlain(), "--");
                }
                if (t1) return new A.StringExpression(this._interpolatedDeclarationValue$0(), false);
                else {
                    this.whitespace$1$consumeNewlines(true);
                    return this._expression$1$consumeNewlines(true);
                }
            },
            _trySupportsOperation$2: function(interpolation, start) {
                var expression, t2, t3, operator, operation, right, t4, _this = this, _null = null, t1 = interpolation.contents;
                if (t1.length !== 1) return _null;
                expression = B.JSArray_methods.get$first(t1);
                if (!(expression instanceof A.Expression)) return _null;
                t1 = _this.scanner;
                t2 = t1._string_scanner$_position;
                _this.whitespace$1$consumeNewlines(true);
                for(t3 = interpolation.span, operator = _null, operation = operator; _this.lookingAtIdentifier$0();){
                    if (operator != null) _this.expectIdentifier$1(operator._name);
                    else if (_this.scanIdentifier$1("and")) operator = B.BooleanOperator_0;
                    else {
                        if (!_this.scanIdentifier$1("or")) {
                            if ((t2 === 0 ? 1 / t2 < 0 : t2 < 0) || t2 > t1.string.length) A.throwExpression(A.ArgumentError$("Invalid position " + t2, _null));
                            t1._string_scanner$_position = t2;
                            return t1._lastMatch = null;
                        }
                        operator = B.BooleanOperator_1;
                    }
                    _this.whitespace$1$consumeNewlines(true);
                    right = _this._supportsConditionInParens$0();
                    t4 = operation == null ? new A.SupportsInterpolation(expression, t3) : operation;
                    operation = new A.SupportsOperation(t4, right, operator, _this.spanFrom$1(start));
                    _this.whitespace$1$consumeNewlines(true);
                }
                return operation;
            },
            _lookingAtInterpolatedIdentifier$0: function() {
                var t2, _0_0, t1 = this.scanner, _1_0 = t1.peekChar$0();
                $label0$0: {
                    t2 = false;
                    if (_1_0 == null) {
                        t1 = t2;
                        break $label0$0;
                    }
                    if (_1_0 === 95 || A.CharacterExtension_get_isAlphabetic(_1_0) || _1_0 >= 128 || 92 === _1_0) {
                        t1 = true;
                        break $label0$0;
                    }
                    if (35 === _1_0) {
                        t1 = t1.peekChar$1(1) === 123;
                        break $label0$0;
                    }
                    if (45 === _1_0) {
                        _0_0 = t1.peekChar$1(1);
                        $label1$1: {
                            if (_0_0 == null) {
                                t1 = t2;
                                break $label1$1;
                            }
                            if (35 === _0_0) {
                                t1 = t1.peekChar$1(2) === 123;
                                break $label1$1;
                            }
                            if (_0_0 === 95 || A.CharacterExtension_get_isAlphabetic(_0_0) || _0_0 >= 128 || 92 === _0_0 || 45 === _0_0) {
                                t1 = true;
                                break $label1$1;
                            }
                            t1 = t2;
                            break $label1$1;
                        }
                        break $label0$0;
                    }
                    t1 = t2;
                    break $label0$0;
                }
                return t1;
            },
            _lookingAtPotentialPropertyHack$0: function() {
                var t1 = this.scanner, _0_0 = t1.peekChar$0();
                $label0$0: {
                    if (58 === _0_0 || 42 === _0_0 || 46 === _0_0) {
                        t1 = true;
                        break $label0$0;
                    }
                    if (35 === _0_0) {
                        t1 = t1.peekChar$1(1) !== 123;
                        break $label0$0;
                    }
                    t1 = false;
                    break $label0$0;
                }
                return t1;
            },
            _lookingAtInterpolatedIdentifierBody$0: function() {
                var t2, t3, t1 = this.scanner, _0_0 = t1.peekChar$0();
                $label0$0: {
                    t2 = false;
                    if (_0_0 == null) {
                        t1 = t2;
                        break $label0$0;
                    }
                    if (!(_0_0 === 95 || A.CharacterExtension_get_isAlphabetic(_0_0) || _0_0 >= 128)) t3 = _0_0 >= 48 && _0_0 <= 57 || _0_0 === 45;
                    else t3 = true;
                    if (t3 || 92 === _0_0) {
                        t1 = true;
                        break $label0$0;
                    }
                    if (35 === _0_0) {
                        t1 = t1.peekChar$1(1) === 123;
                        break $label0$0;
                    }
                    t1 = t2;
                    break $label0$0;
                }
                return t1;
            },
            _lookingAtExpression$0: function() {
                var t2, _0_0, t1 = this.scanner, _1_0 = t1.peekChar$0();
                $label0$0: {
                    t2 = true;
                    if (_1_0 == null) {
                        t1 = false;
                        break $label0$0;
                    }
                    if (46 === _1_0) {
                        t1 = t1.peekChar$1(1) !== 46;
                        break $label0$0;
                    }
                    if (33 === _1_0) {
                        _0_0 = t1.peekChar$1(1);
                        $label1$1: {
                            if (_0_0 != null) {
                                if (105 !== _0_0) {
                                    if (73 !== _0_0) t1 = _0_0 === 32 || _0_0 === 9 || _0_0 === 10 || _0_0 === 13 || _0_0 === 12;
                                    else t1 = t2;
                                } else t1 = t2;
                            } else t1 = t2;
                            break $label1$1;
                        }
                        break $label0$0;
                    }
                    t1 = true;
                    if (40 !== _1_0) {
                        if (47 !== _1_0) {
                            if (91 !== _1_0) {
                                if (39 !== _1_0) {
                                    if (34 !== _1_0) {
                                        if (35 !== _1_0) {
                                            if (43 !== _1_0) {
                                                if (45 !== _1_0) {
                                                    if (92 !== _1_0) {
                                                        if (36 !== _1_0) {
                                                            if (38 !== _1_0) {
                                                                if (37 !== _1_0) {
                                                                    if (!(_1_0 === 95 || A.CharacterExtension_get_isAlphabetic(_1_0) || _1_0 >= 128)) t1 = _1_0 >= 48 && _1_0 <= 57;
                                                                }
                                                            }
                                                        }
                                                    }
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                    if (t1) {
                        t1 = t2;
                        break $label0$0;
                    }
                    t1 = false;
                    break $label0$0;
                }
                return t1;
            },
            _withChildren$1$3: function(child, start, create) {
                var result = create.call$2(this.children$1(0, child), this.spanFrom$1(start));
                this.whitespaceWithoutComments$1$consumeNewlines(false);
                return result;
            },
            _withChildren$3: function(child, start, create) {
                return this._withChildren$1$3(child, start, create, type$.dynamic);
            },
            _urlString$0: function() {
                var innerError, stackTrace, _$exception, _this = this, t1 = _this.scanner, start = new A._SpanScannerState(t1, t1._string_scanner$_position), url = _this.string$0();
                try {
                    t1 = A.Uri_parse(url);
                    return t1;
                } catch (exception) {
                    t1 = A.unwrapException(exception);
                    if (type$.FormatException._is(t1)) {
                        innerError = t1;
                        stackTrace = A.getTraceFromException(exception);
                        _this.error$3(0, "Invalid URL: " + J.get$message$x(innerError), _this.spanFrom$1(start), stackTrace);
                    } else throw exception;
                }
            },
            _publicIdentifier$0: function() {
                var _this = this, t1 = _this.scanner, t2 = t1._string_scanner$_position, result = _this.identifier$0();
                _this._assertPublic$2(result, new A.StylesheetParser__publicIdentifier_closure(_this, new A._SpanScannerState(t1, t2)));
                return result;
            },
            _assertPublic$2: function(identifier, span) {
                var first = identifier.charCodeAt(0);
                if (!(first === 45 || first === 95)) return;
                this.error$2(0, string$.Privat, span.call$0());
            },
            _addOrInject$2: function(buffer, expression) {
                if (expression instanceof A.StringExpression && !expression.hasQuotes) buffer.addInterpolation$1(expression.text);
                else buffer.add$2(0, expression, expression.get$span(expression));
            },
            get$plainCss: function() {
                return false;
            }
        };
        A.StylesheetParser_parse_closure.prototype = {
            call$0: function() {
                var statements, t1 = this.$this, t2 = t1.scanner, t3 = t2._string_scanner$_position;
                t2.scanChar$1(65279);
                statements = t1.statements$1(new A.StylesheetParser_parse__closure(t1));
                t2.expectDone$0();
                return A.Stylesheet$internal(statements, t1.spanFrom$1(new A._SpanScannerState(t2, t3)), t1.warnings, t1._globalVariables, t1.get$plainCss());
            },
            $signature: 487
        };
        A.StylesheetParser_parse__closure.prototype = {
            call$0: function() {
                var t1 = this.$this;
                if (t1.scanner.scan$1("@charset")) {
                    t1.whitespace$1$consumeNewlines(false);
                    t1.string$0();
                    return null;
                }
                return t1._statement$1$root(true);
            },
            $signature: 531
        };
        A.StylesheetParser_parseParameterList_closure.prototype = {
            call$0: function() {
                var parameters, t1 = this.$this, t2 = t1.scanner;
                t2.expectChar$2$name(64, "@-rule");
                t1.identifier$0();
                t1.whitespace$1$consumeNewlines(true);
                t1.identifier$0();
                parameters = t1._parameterList$0();
                t1.whitespace$1$consumeNewlines(true);
                t2.expectChar$1(123);
                return parameters;
            },
            $signature: 540
        };
        A.StylesheetParser_parseVariableDeclaration_closure.prototype = {
            call$0: function() {
                var t1 = this.$this;
                return t1.lookingAtIdentifier$0() ? t1._variableDeclarationWithNamespace$0() : t1.variableDeclarationWithoutNamespace$0();
            },
            $signature: 547
        };
        A.StylesheetParser_parseUseRule_closure.prototype = {
            call$0: function() {
                var t1 = this.$this, t2 = t1.scanner, t3 = t2._string_scanner$_position;
                t2.expectChar$2$name(64, "@-rule");
                t1.expectIdentifier$1("use");
                t1.whitespace$1$consumeNewlines(true);
                return t1._useRule$1(new A._SpanScannerState(t2, t3));
            },
            $signature: 548
        };
        A.StylesheetParser__parseSingleProduction_closure.prototype = {
            call$0: function() {
                var result = this.production.call$0();
                this.$this.scanner.expectDone$0();
                return result;
            },
            $signature: function() {
                return this.T._eval$1("0()");
            }
        };
        A.StylesheetParser__statement_closure.prototype = {
            call$0: function() {
                return this.$this._statement$0();
            },
            $signature: 125
        };
        A.StylesheetParser_variableDeclarationWithoutNamespace_closure.prototype = {
            call$0: function() {
                return this.$this.spanFrom$1(this.start);
            },
            $signature: 16
        };
        A.StylesheetParser_variableDeclarationWithoutNamespace_closure0.prototype = {
            call$0: function() {
                return this.declaration.span;
            },
            $signature: 16
        };
        A.StylesheetParser__declarationOrBuffer_closure.prototype = {
            call$0: function() {
                return this.$this.whitespace$1$consumeNewlines(false);
            },
            $signature: 0
        };
        A.StylesheetParser__declarationOrBuffer_closure0.prototype = {
            call$0: function() {
                return this.$this.whitespace$1$consumeNewlines(false);
            },
            $signature: 0
        };
        A.StylesheetParser__declarationOrBuffer_closure1.prototype = {
            call$1: function($name) {
                return A.equalsIgnoreCase($name, "result");
            },
            $signature: 4
        };
        A.StylesheetParser__declarationOrBuffer_closure2.prototype = {
            call$0: function() {
                return this.$this.whitespace$1$consumeNewlines(false);
            },
            $signature: 0
        };
        A.StylesheetParser__styleRule_closure.prototype = {
            call$2: function(children, span) {
                return A.StyleRule$(this._box_0.interpolation, children, this.$this.spanFrom$1(this.start));
            },
            $signature: 549
        };
        A.StylesheetParser__withStyleRuleChildren_closure.prototype = {
            call$2: function(children, span) {
                var t2, _this = this, t1 = _this.$this;
                if (t1.get$indented() && children.length === 0) {
                    t2 = _this.nodeWithSpan;
                    t1.warnings.push(new A._Record_3_deprecation_message_span(null, string$.This_s, t2.get$span(t2)));
                }
                t1._inStyleRule = _this.wasInStyleRule;
                return _this.create.call$2(children, span);
            },
            $signature: function() {
                return this.T._eval$1("0(List<Statement>,FileSpan)");
            }
        };
        A.StylesheetParser__propertyOrVariableDeclaration_closure.prototype = {
            call$0: function() {
                return this.$this.whitespace$1$consumeNewlines(false);
            },
            $signature: 0
        };
        A.StylesheetParser__tryDeclarationChildren_closure.prototype = {
            call$2: function(children, span) {
                return A.Declaration$nested(this.name, children, span, this.value);
            },
            $signature: 551
        };
        A.StylesheetParser__atRootRule_closure.prototype = {
            call$2: function(children, span) {
                return A.AtRootRule$(children, span, this.query);
            },
            $signature: 160
        };
        A.StylesheetParser__atRootRule_closure0.prototype = {
            call$2: function(children, span) {
                return A.AtRootRule$(children, span, null);
            },
            $signature: 160
        };
        A.StylesheetParser__eachRule_closure.prototype = {
            call$2: function(children, span) {
                var _this = this;
                _this.$this._inControlDirective = _this.wasInControlDirective;
                return A.EachRule$(_this.variables, _this.list, children, span);
            },
            $signature: 608
        };
        A.StylesheetParser__functionRule_closure.prototype = {
            call$2: function(children, span) {
                return A.FunctionRule$(this.name, this.parameters, children, span, this.precedingComment);
            },
            $signature: 624
        };
        A.StylesheetParser__forRule_closure.prototype = {
            call$0: function() {
                var t1 = this.$this;
                if (!t1.lookingAtIdentifier$0()) return false;
                if (t1.scanIdentifier$1("to")) return this._box_0.exclusive = true;
                else if (t1.scanIdentifier$1("through")) {
                    this._box_0.exclusive = false;
                    return true;
                } else return false;
            },
            $signature: 20
        };
        A.StylesheetParser__forRule_closure0.prototype = {
            call$2: function(children, span) {
                var t1, _this = this;
                _this.$this._inControlDirective = _this.wasInControlDirective;
                t1 = _this._box_0.exclusive;
                t1.toString;
                return A.ForRule$(_this.variable, _this.from, _this.to, children, span, t1);
            },
            $signature: 278
        };
        A.StylesheetParser__memberList_closure.prototype = {
            call$0: function() {
                var t1 = this.$this;
                if (t1.scanner.peekChar$0() === 36) this.variables.add$1(0, t1.variableName$0());
                else this.identifiers.add$1(0, t1.identifier$1$normalize(true));
            },
            $signature: 1
        };
        A.StylesheetParser__includeRule_closure.prototype = {
            call$2: function(children, span) {
                return A.ContentBlock$(this.contentParameters_, children, span);
            },
            $signature: 282
        };
        A.StylesheetParser_mediaRule_closure.prototype = {
            call$2: function(children, span) {
                return A.MediaRule$(this.query, children, span);
            },
            $signature: 297
        };
        A.StylesheetParser__mixinRule_closure.prototype = {
            call$2: function(children, span) {
                var _this = this;
                _this.$this._stylesheet$_inMixin = false;
                return A.MixinRule$(_this.name, _this.parameters, children, span, _this.precedingComment);
            },
            $signature: 299
        };
        A.StylesheetParser_mozDocumentRule_closure.prototype = {
            call$0: function() {
                return this.$this.whitespace$1$consumeNewlines(false);
            },
            $signature: 0
        };
        A.StylesheetParser_mozDocumentRule_closure0.prototype = {
            call$2: function(children, span) {
                var _this = this;
                if (_this._box_0.needsDeprecationWarning) _this.$this.warnings.push(new A._Record_3_deprecation_message_span(B.Deprecation_PmQ, string$.x40_moz_, span));
                return A.AtRule$(_this.name, span, children, _this.value);
            },
            $signature: 161
        };
        A.StylesheetParser_supportsRule_closure.prototype = {
            call$2: function(children, span) {
                return A.SupportsRule$(this.condition, children, span);
            },
            $signature: 302
        };
        A.StylesheetParser__whileRule_closure.prototype = {
            call$2: function(children, span) {
                this.$this._inControlDirective = this.wasInControlDirective;
                return A.WhileRule$(this.condition, children, span);
            },
            $signature: 303
        };
        A.StylesheetParser_unknownAtRule_closure.prototype = {
            call$2: function(children, span) {
                return A.AtRule$(this.name, span, children, this._box_0.value);
            },
            $signature: 161
        };
        A.StylesheetParser__expression_resetState.prototype = {
            call$0: function() {
                var t2, t1 = this._box_0;
                t1.operands_ = t1.operators_ = t1.spaceExpressions_ = t1.commaExpressions_ = null;
                t2 = this.$this;
                t2.scanner.set$state(this.start);
                t1.allowSlash = true;
                t1.singleExpression_ = t2._singleExpression$0();
            },
            $signature: 0
        };
        A.StylesheetParser__expression_resolveOneOperation.prototype = {
            call$0: function() {
                var t2, t3, t4, t5, t6, t7, _this = this, t1 = _this._box_0, operator = t1.operators_.pop(), left = t1.operands_.pop(), right = t1.singleExpression_;
                if (right == null) {
                    t2 = _this.$this.scanner;
                    t3 = operator.operator.length;
                    t2.error$3$length$position(0, "Expected expression.", t3, t2._string_scanner$_position - t3);
                }
                if (t1.allowSlash) {
                    t2 = _this.$this;
                    t2 = !t2._inParentheses && operator === B.BinaryOperator_ehp && t2._isSlashOperand$1(left) && t2._isSlashOperand$1(right);
                } else t2 = false;
                if (t2) t1.singleExpression_ = new A.BinaryOperationExpression(B.BinaryOperator_ehp, left, right, true);
                else {
                    t1.singleExpression_ = new A.BinaryOperationExpression(operator, left, right, false);
                    t2 = t1.allowSlash = false;
                    if (B.BinaryOperator_jCK === operator || B.BinaryOperator_tDf === operator) {
                        t3 = _this.$this;
                        t4 = t3.scanner.string;
                        t5 = right.get$span(right);
                        t5 = t5.get$start(t5);
                        t6 = right.get$span(right);
                        t7 = operator.operator;
                        if (B.JSString_methods.substring$2(t4, t5.offset - 1, t6.get$start(t6).offset) === t7) {
                            t2 = left.get$span(left);
                            t2 = t4.charCodeAt(t2.get$end(t2).offset);
                            t2 = t2 === 32 || t2 === 9 || t2 === 10 || t2 === 13 || t2 === 12;
                        }
                        if (t2) {
                            t2 = left.toString$0(0);
                            t4 = right.toString$0(0);
                            t5 = left.toString$0(0);
                            t6 = right.toString$0(0);
                            t1 = t1.singleExpression_;
                            t3.warnings.push(new A._Record_3_deprecation_message_span(B.Deprecation_K9u, "This operation is parsed as:\n\n    " + t2 + " " + t7 + " " + t4 + string$.x0a_but_ + t5 + " (" + t7 + t6 + ")\n\nAdd a space after " + t7 + string$.x20to_cl, t1.get$span(t1)));
                        }
                    }
                }
            },
            $signature: 0
        };
        A.StylesheetParser__expression_resolveOperations.prototype = {
            call$0: function() {
                var t1, operators = this._box_0.operators_;
                if (operators == null) return;
                for(t1 = this.resolveOneOperation; operators.length !== 0;)t1.call$0();
            },
            $signature: 0
        };
        A.StylesheetParser__expression_addSingleExpression.prototype = {
            call$1: function(expression) {
                var t2, spaceExpressions, _this = this, t1 = _this._box_0;
                if (t1.singleExpression_ != null) {
                    t2 = _this.$this;
                    if (t2._inParentheses) {
                        t2._inParentheses = false;
                        if (t1.allowSlash) {
                            _this.resetState.call$0();
                            return;
                        }
                    }
                    spaceExpressions = t1.spaceExpressions_;
                    if (spaceExpressions == null) spaceExpressions = t1.spaceExpressions_ = A._setArrayType([], type$.JSArray_Expression);
                    _this.resolveOperations.call$0();
                    t2 = t1.singleExpression_;
                    t2.toString;
                    spaceExpressions.push(t2);
                    t1.allowSlash = true;
                }
                t1.singleExpression_ = expression;
            },
            $signature: 305
        };
        A.StylesheetParser__expression_addOperator.prototype = {
            call$1: function(operator) {
                var t2, t3, operators, operands, t4, singleExpression, operatorEnd, _this = this, t1 = _this.$this;
                if (t1.get$plainCss() && operator !== B.BinaryOperator_g6F && operator !== B.BinaryOperator_jCK && operator !== B.BinaryOperator_tDf && operator !== B.BinaryOperator_wkM && operator !== B.BinaryOperator_ehp) {
                    t2 = t1.scanner;
                    t3 = operator.operator.length;
                    t2.error$3$length$position(0, "Operators aren't allowed in plain CSS.", t3, t2._string_scanner$_position - t3);
                }
                t2 = _this._box_0;
                t2.allowSlash = t2.allowSlash && operator === B.BinaryOperator_ehp;
                operators = t2.operators_;
                if (operators == null) operators = t2.operators_ = A._setArrayType([], type$.JSArray_BinaryOperator);
                operands = t2.operands_;
                if (operands == null) operands = t2.operands_ = A._setArrayType([], type$.JSArray_Expression);
                t3 = _this.resolveOneOperation;
                t4 = operator.precedence;
                for(;;){
                    if (!(operators.length !== 0 && B.JSArray_methods.get$last(operators).precedence >= t4)) break;
                    t3.call$0();
                }
                singleExpression = t2.singleExpression_;
                if (singleExpression == null) {
                    t3 = t1.scanner;
                    t4 = operator.operator.length;
                    t3.error$3$length$position(0, "Expected expression.", t4, t3._string_scanner$_position - t4);
                }
                operatorEnd = t1.scanner._string_scanner$_position;
                t1.whitespace$1$consumeNewlines(true);
                if (operator === B.BinaryOperator_bgA && !t1._lookingAtExpression$0()) {
                    t1 = t1.spanFromPosition$2(operatorEnd - 1, operatorEnd);
                    _this.addSingleExpression.call$1(new A.StringExpression(new A.Interpolation(A.List_List$unmodifiable([
                        "%"
                    ], type$.Object), B.List_null, t1), false));
                } else {
                    operators.push(operator);
                    operands.push(singleExpression);
                    t2.singleExpression_ = t1._singleExpression$0();
                }
            },
            $signature: 308
        };
        A.StylesheetParser__expression_resolveSpaceExpressions.prototype = {
            call$0: function() {
                var t1, spaceExpressions, singleExpression, t2;
                this.resolveOperations.call$0();
                t1 = this._box_0;
                spaceExpressions = t1.spaceExpressions_;
                if (spaceExpressions == null) return;
                singleExpression = t1.singleExpression_;
                if (singleExpression == null) this.$this.scanner.error$1(0, "Expected expression.");
                spaceExpressions.push(singleExpression);
                t2 = B.JSArray_methods.get$first(spaceExpressions);
                t2 = t2.get$span(t2).expand$1(0, singleExpression.get$span(singleExpression));
                t1.singleExpression_ = new A.ListExpression(A.List_List$unmodifiable(spaceExpressions, type$.Expression), B.ListSeparator_SrV, false, t2);
                t1.spaceExpressions_ = null;
            },
            $signature: 0
        };
        A.StylesheetParser_expressionUntilComma_closure.prototype = {
            call$0: function() {
                return this.$this.scanner.peekChar$0() === 44;
            },
            $signature: 20
        };
        A.StylesheetParser__isHexColor_closure.prototype = {
            call$1: function(char) {
                return A.CharacterExtension_get_isHex(char);
            },
            $signature: 50
        };
        A.StylesheetParser__unicodeRange_closure.prototype = {
            call$1: function(char) {
                return char != null && A.CharacterExtension_get_isHex(char);
            },
            $signature: 31
        };
        A.StylesheetParser__unicodeRange_closure0.prototype = {
            call$1: function(char) {
                return char != null && A.CharacterExtension_get_isHex(char);
            },
            $signature: 31
        };
        A.StylesheetParser_interpolatedStringToken_closure.prototype = {
            call$0: function() {
                return A.consumeEscapedCharacter(this.$this.scanner);
            },
            $signature: 0
        };
        A.StylesheetParser_namespacedExpression_closure.prototype = {
            call$0: function() {
                return this.$this.spanFrom$1(this.start);
            },
            $signature: 16
        };
        A.StylesheetParser_trySpecialFunction_closure.prototype = {
            call$1: function(contents) {
                return new A.StringExpression(contents, false);
            },
            $signature: 316
        };
        A.StylesheetParser__interpolatedDeclarationValue_closure.prototype = {
            call$0: function() {
                return this.$this.scanIdentifier$2$caseSensitive("of", false);
            },
            $signature: 0
        };
        A.StylesheetParser__expressionUntilComparison_closure.prototype = {
            call$0: function() {
                var t1 = this.$this.scanner, _0_0 = t1.peekChar$0();
                $label0$0: {
                    if (61 === _0_0) {
                        t1 = t1.peekChar$1(1) !== 61;
                        break $label0$0;
                    }
                    if (60 === _0_0 || 62 === _0_0) {
                        t1 = true;
                        break $label0$0;
                    }
                    t1 = false;
                    break $label0$0;
                }
                return t1;
            },
            $signature: 20
        };
        A.StylesheetParser__publicIdentifier_closure.prototype = {
            call$0: function() {
                return this.$this.spanFrom$1(this.start);
            },
            $signature: 16
        };
        A.StylesheetGraph.prototype = {
            modifiedSince$3: function(url, since, baseImporter) {
                var node = this._stylesheet_graph$_add$3(url, baseImporter, null);
                if (node == null) return true;
                return new A.StylesheetGraph_modifiedSince_transitiveModificationTime(this, A.LinkedHashSet_LinkedHashSet$_empty(type$.StylesheetNode)).call$1(node).isAfter$1(since);
            },
            _stylesheet_graph$_add$3: function(url, baseImporter, baseUrl) {
                var importer, canonicalUrl, _this = this, result = _this._ignoreErrors$1(new A.StylesheetGraph__add_closure(_this, url, baseImporter, baseUrl));
                if (type$.Record_3_nullable_Object_and_nullable_Object_and_nullable_Object_originalUrl._is(result)) {
                    importer = result._0;
                    canonicalUrl = result._1;
                    _this.addCanonical$3(importer, canonicalUrl, result._2);
                    return _this._nodes.$index(0, canonicalUrl);
                } else return null;
            },
            addCanonical$4$recanonicalize: function(importer, canonicalUrl, originalUrl, recanonicalize) {
                var stylesheet, _this = this, t1 = _this._nodes;
                if (t1.$index(0, canonicalUrl) != null) return B.Set_empty4;
                stylesheet = _this._ignoreErrors$1(new A.StylesheetGraph_addCanonical_closure(_this, importer, canonicalUrl, originalUrl));
                if (stylesheet == null) return B.Set_empty4;
                t1.$indexSet(0, canonicalUrl, A.StylesheetNode$_(stylesheet, importer, canonicalUrl, _this._upstreamNodes$3(stylesheet, importer, canonicalUrl)));
                return recanonicalize ? _this._recanonicalizeImports$2(importer, canonicalUrl) : B.Set_empty4;
            },
            addCanonical$3: function(importer, canonicalUrl, originalUrl) {
                return this.addCanonical$4$recanonicalize(importer, canonicalUrl, originalUrl, true);
            },
            _upstreamNodes$4: function(stylesheet, baseImporter, baseUrl, active) {
                var t1, t2, t3, t4, t5, t6, t7, t8;
                if (active == null) active = A.LinkedHashSet_LinkedHashSet$_literal([
                    baseUrl
                ], type$.Uri);
                t1 = type$.Uri;
                t2 = A.LinkedHashSet_LinkedHashSet$_empty(t1);
                t3 = A.LinkedHashSet_LinkedHashSet$_empty(t1);
                t4 = A.LinkedHashSet_LinkedHashSet$_empty(t1);
                t5 = A.LinkedHashSet_LinkedHashSet$_empty(t1);
                new A._FindDependenciesVisitor(t2, t3, t4, t5, A.LinkedHashSet_LinkedHashSet$_empty(type$.nullable_String)).visitChildren$1(stylesheet.children);
                t6 = type$.UnmodifiableSetView_Uri;
                t7 = type$.nullable_StylesheetNode;
                t8 = A.LinkedHashMap_LinkedHashMap$_empty(t1, t7);
                for(t2 = new A.UnionSet(A.LinkedHashSet_LinkedHashSet$_literal([
                    new A.UnmodifiableSetView0(t2, t6),
                    new A.UnmodifiableSetView0(t3, t6),
                    new A.UnmodifiableSetView0(t4, t6)
                ], type$.Set_Uri), type$.UnionSet_Uri).get$_union_set$_iterable(), t2 = t2.get$iterator(t2); t2.moveNext$0();){
                    t3 = t2.get$current(t2);
                    t8.$indexSet(0, t3, this._nodeFor$4(t3, baseImporter, baseUrl, active));
                }
                t1 = A.LinkedHashMap_LinkedHashMap$_empty(t1, t7);
                for(t2 = t5.get$iterator(0); t2.moveNext$0();){
                    t3 = t2.get$current(0);
                    t1.$indexSet(0, t3, this._nodeFor$5$forImport(t3, baseImporter, baseUrl, active, true));
                }
                return new A._Record_2_imports_modules(t1, t8);
            },
            _upstreamNodes$3: function(stylesheet, baseImporter, baseUrl) {
                return this._upstreamNodes$4(stylesheet, baseImporter, baseUrl, null);
            },
            reload$1: function(canonicalUrl) {
                var stylesheet, upstream, _this = this, node = _this._nodes.$index(0, canonicalUrl);
                if (node == null) throw A.wrapException(A.StateError$(canonicalUrl.toString$0(0) + " is not in the dependency graph."));
                _this._transitiveModificationTimes.clear$0(0);
                _this.importCache.clearImport$1(canonicalUrl);
                stylesheet = _this._ignoreErrors$1(new A.StylesheetGraph_reload_closure(_this, node, canonicalUrl));
                if (stylesheet == null) return false;
                node._stylesheet = stylesheet;
                upstream = _this._upstreamNodes$3(stylesheet, node.importer, canonicalUrl);
                node._replaceUpstream$2(upstream._1, upstream._0);
                return true;
            },
            reloadAllModified$0: function() {
                var node, modified, loadTime, t2, t3, _i, t4, t5, t6, t7, modified0, _$exception, _this = this, t1 = _this._nodes;
                t1 = A.List_List$_of(new A.LinkedHashMapValuesIterable(t1, A._instanceType(t1)._eval$1("LinkedHashMapValuesIterable<2>")), type$.StylesheetNode);
                t2 = t1.length;
                t3 = _this.importCache._loadTimes;
                _i = 0;
                for(; _i < t1.length; t1.length === t2 || (0, A.throwConcurrentModificationError)(t1), ++_i){
                    node = t1[_i];
                    modified = false;
                    try {
                        loadTime = t3.$index(0, node.canonicalUrl);
                        if (loadTime != null) {
                            t4 = node.importer.modificationTime$1(node.canonicalUrl);
                            t5 = loadTime;
                            t6 = t4._value;
                            t7 = t5._value;
                            if (t6 <= t7) {
                                t4 = t6 === t7 && t4._microsecond > t5._microsecond;
                                modified0 = t4;
                            } else modified0 = true;
                        } else modified0 = false;
                        modified = modified0;
                    } catch (exception) {
                        if (A.unwrapException(exception) instanceof A.FileSystemException) modified = true;
                        else throw exception;
                    }
                    if (modified) {
                        if (!_this.reload$1(node.canonicalUrl)) _this.remove$2(0, node.importer, node.canonicalUrl);
                    }
                }
            },
            remove$2: function(_, importer, canonicalUrl) {
                var toRecompile, _this = this, node = _this._nodes.remove$1(0, canonicalUrl), t1 = node != null;
                if (t1) {
                    _this._transitiveModificationTimes.clear$0(0);
                    _this.importCache.clearImport$1(canonicalUrl);
                    node._stylesheet_graph$_remove$0();
                }
                toRecompile = _this._recanonicalizeImports$2(importer, canonicalUrl);
                if (t1) toRecompile.addAll$1(0, node._downstream);
                return toRecompile;
            },
            _recanonicalizeImports$2: function(importer, canonicalUrl) {
                var changed, t1, t2, t3, t4, t5, newUpstream, newUpstreamImports, _this = this;
                _this.importCache.clearCanonicalize$1(canonicalUrl);
                changed = A.LinkedHashSet_LinkedHashSet$_empty(type$.StylesheetNode);
                for(t1 = _this._nodes.get$values(0).get$iterator(0), t2 = type$.UnmodifiableMapView_of_Uri_and_nullable_StylesheetNode, t3 = type$.Uri, t4 = type$.nullable_StylesheetNode; t1.moveNext$0();){
                    t5 = t1.get$current(0);
                    newUpstream = _this._recanonicalizeImportsForNode$4$forImport(t5, importer, canonicalUrl, false);
                    newUpstreamImports = _this._recanonicalizeImportsForNode$4$forImport(t5, importer, canonicalUrl, true);
                    if (newUpstream.__js_helper$_length !== 0 || newUpstreamImports.__js_helper$_length !== 0) {
                        changed.add$1(0, t5);
                        t5._replaceUpstream$2(A.mergeMaps(new A.UnmodifiableMapView(t5._upstream, t2), newUpstream, t3, t4), A.mergeMaps(new A.UnmodifiableMapView(t5._upstreamImports, t2), newUpstreamImports, t3, t4));
                    }
                }
                if (changed._collection$_length !== 0) _this._transitiveModificationTimes.clear$0(0);
                return changed;
            },
            _recanonicalizeImportsForNode$4$forImport: function(node, importer, canonicalUrl, forImport) {
                var url, result, t2, newMap, t3, t4, t5, t6, upstream, exception, newCanonicalUrl, t1 = type$.UnmodifiableMapView_of_Uri_and_nullable_StylesheetNode, map = forImport ? new A.UnmodifiableMapView(node._upstreamImports, t1) : new A.UnmodifiableMapView(node._upstream, t1);
                t1 = type$.Uri;
                t2 = type$.nullable_StylesheetNode;
                newMap = A.LinkedHashMap_LinkedHashMap$_empty(t1, t2);
                for(t1 = A.MapExtensions_get_pairs(map, t1, t2), t1 = t1.get$iterator(t1), t2 = this._nodes, t3 = this.importCache, t4 = node.importer, t5 = node.canonicalUrl; t1.moveNext$0();){
                    t6 = t1.get$current(t1);
                    url = null;
                    url = t6._0;
                    upstream = t6._1;
                    if (!importer.couldCanonicalize$2(url, canonicalUrl)) continue;
                    result = null;
                    try {
                        result = t3.canonicalize$4$baseImporter$baseUrl$forImport(0, url, t4, t5, forImport);
                    } catch (exception) {}
                    t6 = result;
                    newCanonicalUrl = t6 == null ? null : t6._1;
                    if (J.$eq$(newCanonicalUrl, upstream == null ? null : upstream.canonicalUrl)) continue;
                    t6 = url;
                    newMap.$indexSet(0, t6, result == null ? null : t2.$index(0, newCanonicalUrl));
                }
                return newMap;
            },
            _nodeFor$5$forImport: function(url, baseImporter, baseUrl, active, forImport) {
                var canonicalUrl, t2, _1_0, stylesheet, t3, t4, node, _this = this, t1 = {}, result = _this._ignoreErrors$1(new A.StylesheetGraph__nodeFor_closure(_this, url, baseImporter, baseUrl, forImport));
                if (result == null) return null;
                t1.originalUrl = t1.canonicalUrl = t1.importer = null;
                t1.importer = result._0;
                canonicalUrl = t1.canonicalUrl = result._1;
                t1.originalUrl = result._2;
                t2 = _this._nodes;
                _1_0 = t2.$index(0, canonicalUrl);
                if (_1_0 != null) return _1_0;
                if (active.contains$1(0, canonicalUrl)) return null;
                stylesheet = _this._ignoreErrors$1(new A.StylesheetGraph__nodeFor_closure0(t1, _this));
                if (stylesheet == null) return null;
                active.add$1(0, t1.canonicalUrl);
                t3 = t1.importer;
                t4 = t1.canonicalUrl;
                node = A.StylesheetNode$_(stylesheet, t3, t4, _this._upstreamNodes$4(stylesheet, t3, t4, active));
                active.remove$1(0, t1.canonicalUrl);
                t2.$indexSet(0, t1.canonicalUrl, node);
                return node;
            },
            _nodeFor$4: function(url, baseImporter, baseUrl, active) {
                return this._nodeFor$5$forImport(url, baseImporter, baseUrl, active, false);
            },
            _ignoreErrors$1$1: function(callback) {
                var t1, exception;
                try {
                    t1 = callback.call$0();
                    return t1;
                } catch (exception) {
                    return null;
                }
            },
            _ignoreErrors$1: function(callback) {
                return this._ignoreErrors$1$1(callback, type$.dynamic);
            }
        };
        A.StylesheetGraph_modifiedSince_transitiveModificationTime.prototype = {
            call$1: function(node) {
                var t1 = this.seenNodes;
                t1.add$1(0, node);
                return this.$this._transitiveModificationTimes.putIfAbsent$2(node.canonicalUrl, new A.StylesheetGraph_modifiedSince_transitiveModificationTime_closure(node, t1, this));
            },
            $signature: 317
        };
        A.StylesheetGraph_modifiedSince_transitiveModificationTime_closure.prototype = {
            call$0: function() {
                var t2, t3, t4, t5, t6, t1 = this.node, latest = t1.importer.modificationTime$1(t1.canonicalUrl);
                for(t1 = t1._upstream.get$values(0).followedBy$1(0, t1._upstreamImports.get$values(0)).get$iterator(0), t2 = this.transitiveModificationTime, t3 = this.seenNodes; t1.moveNext$0();){
                    t4 = t1.get$current(0);
                    $label0$0: {
                        if (t4 == null) {
                            t4 = new A.DateTime(Date.now(), 0, false);
                            break $label0$0;
                        }
                        t5 = t3.contains$1(0, t4);
                        if (t5) {
                            t4 = new A.DateTime(A.DateTime__validate(0, 0, false), 0, false);
                            break $label0$0;
                        }
                        t4 = t2.call$1(t4);
                        break $label0$0;
                    }
                    t5 = t4._value;
                    t6 = latest._value;
                    if (t5 <= t6) t5 = t5 === t6 && t4._microsecond > latest._microsecond;
                    else t5 = true;
                    if (t5) latest = t4;
                }
                return latest;
            },
            $signature: 155
        };
        A.StylesheetGraph__add_closure.prototype = {
            call$0: function() {
                var _this = this;
                return _this.$this.importCache.canonicalize$3$baseImporter$baseUrl(0, _this.url, _this.baseImporter, _this.baseUrl);
            },
            $signature: 128
        };
        A.StylesheetGraph_addCanonical_closure.prototype = {
            call$0: function() {
                var _this = this;
                return _this.$this.importCache.importCanonical$3$originalUrl(_this.importer, _this.canonicalUrl, _this.originalUrl);
            },
            $signature: 86
        };
        A.StylesheetGraph_reload_closure.prototype = {
            call$0: function() {
                return this.$this.importCache.importCanonical$2(this.node.importer, this.canonicalUrl);
            },
            $signature: 86
        };
        A.StylesheetGraph__nodeFor_closure.prototype = {
            call$0: function() {
                var _this = this;
                return _this.$this.importCache.canonicalize$4$baseImporter$baseUrl$forImport(0, _this.url, _this.baseImporter, _this.baseUrl, _this.forImport);
            },
            $signature: 128
        };
        A.StylesheetGraph__nodeFor_closure0.prototype = {
            call$0: function() {
                var t1 = this._box_0;
                return this.$this.importCache.importCanonical$3$originalUrl(t1.importer, t1.canonicalUrl, t1.originalUrl);
            },
            $signature: 86
        };
        A.StylesheetNode.prototype = {
            StylesheetNode$_$4: function(_stylesheet, importer, canonicalUrl, allUpstream) {
                var t1, t2;
                for(t1 = this._upstream.get$values(0).followedBy$1(0, this._upstreamImports.get$values(0)).get$iterator(0); t1.moveNext$0();){
                    t2 = t1.get$current(0);
                    if (t2 != null) t2._downstream.add$1(0, this);
                }
            },
            _replaceUpstream$2: function(newUpstream, newUpstreamImports) {
                var t3, oldUpstream, newUpstreamSet, _this = this, t1 = type$.nullable_StylesheetNode, t2 = A.LinkedHashSet_LinkedHashSet$of(_this._upstream.get$values(0), t1);
                t2.addAll$1(0, _this._upstreamImports.get$values(0));
                t3 = type$.StylesheetNode;
                oldUpstream = A.SetExtension_removeNull(t2, t3);
                t1 = A.LinkedHashSet_LinkedHashSet$of(new A.LinkedHashMapValuesIterable(newUpstream, A._instanceType(newUpstream)._eval$1("LinkedHashMapValuesIterable<2>")), t1);
                t1.addAll$1(0, new A.LinkedHashMapValuesIterable(newUpstreamImports, A._instanceType(newUpstreamImports)._eval$1("LinkedHashMapValuesIterable<2>")));
                newUpstreamSet = A.SetExtension_removeNull(t1, t3);
                for(t1 = oldUpstream.difference$1(newUpstreamSet), t1 = t1.get$iterator(t1); t1.moveNext$0();)t1.get$current(t1)._downstream.remove$1(0, _this);
                for(t1 = newUpstreamSet.difference$1(oldUpstream), t1 = t1.get$iterator(t1); t1.moveNext$0();)t1.get$current(t1)._downstream.add$1(0, _this);
                _this._upstream = newUpstream;
                _this._upstreamImports = newUpstreamImports;
            },
            _stylesheet_graph$_remove$0: function() {
                var t1, t2, t3, t4, _i, url, _this = this;
                for(t1 = A.LinkedHashSet_LinkedHashSet$of(_this._upstream.get$values(0), type$.nullable_StylesheetNode), t1.addAll$1(0, _this._upstreamImports.get$values(0)), t1 = A._LinkedHashSetIterator$(t1, t1._collection$_modifications, A._instanceType(t1)._precomputed1), t2 = t1.$ti._precomputed1; t1.moveNext$0();){
                    t3 = t1._collection$_current;
                    if (t3 == null) t3 = t2._as(t3);
                    if (t3 == null) continue;
                    t3._downstream.remove$1(0, _this);
                }
                for(t1 = _this._downstream.get$iterator(0); t1.moveNext$0();){
                    t2 = t1.get$current(0);
                    t3 = t2._upstream;
                    t4 = A._instanceType(t3)._eval$1("LinkedHashMapKeysIterable<1>");
                    t3 = A.List_List$_of(new A.LinkedHashMapKeysIterable(t3, t4), t4._eval$1("Iterable.E"));
                    t4 = t3.length;
                    _i = 0;
                    for(; _i < t3.length; t3.length === t4 || (0, A.throwConcurrentModificationError)(t3), ++_i){
                        url = t3[_i];
                        if (t2._upstream.$index(0, url) === _this) {
                            t2._upstream.$indexSet(0, url, null);
                            break;
                        }
                    }
                    t3 = t2._upstreamImports;
                    t4 = A._instanceType(t3)._eval$1("LinkedHashMapKeysIterable<1>");
                    t3 = A.List_List$_of(new A.LinkedHashMapKeysIterable(t3, t4), t4._eval$1("Iterable.E"));
                    t4 = t3.length;
                    _i = 0;
                    for(; _i < t3.length; t3.length === t4 || (0, A.throwConcurrentModificationError)(t3), ++_i){
                        url = t3[_i];
                        if (t2._upstreamImports.$index(0, url) === _this) {
                            t2._upstreamImports.$indexSet(0, url, null);
                            break;
                        }
                    }
                }
            },
            toString$0: function(_) {
                var t1 = this._stylesheet.span;
                t1 = A.NullableExtension_andThen(t1.get$sourceUrl(t1), A.path__prettyUri$closure());
                return t1 == null ? "<unknown>" : t1;
            }
        };
        A.Syntax.prototype = {
            _enumToString$0: function() {
                return "Syntax." + this._name;
            },
            toString$0: function(_) {
                return this._syntax$_name;
            }
        };
        A.Box.prototype = {
            $eq: function(_, other) {
                if (other == null) return false;
                return this.$ti._is(other) && other._box$_inner === this._box$_inner;
            },
            get$hashCode: function(_) {
                return A.Primitives_objectHashCode(this._box$_inner);
            },
            toString$0: function(_) {
                return "<box: " + this._box$_inner.value.toString$0(0) + ">";
            }
        };
        A.ModifiableBox.prototype = {
            toString$0: function(_) {
                return "<modifiable box: " + this.value.toString$0(0) + ">";
            }
        };
        A.LazyFileSpan.prototype = {
            get$span: function(_) {
                var t1 = this._lazy_file_span$_span;
                return t1 == null ? this._lazy_file_span$_span = this._builder.call$0() : t1;
            },
            compareTo$1: function(_, other) {
                return this.get$span(0).compareTo$1(0, other);
            },
            get$context: function(_) {
                var t1 = this.get$span(0);
                return t1.get$context(t1);
            },
            get$end: function(_) {
                var t1 = this.get$span(0);
                return t1.get$end(t1);
            },
            expand$1: function(_, other) {
                return this.get$span(0).expand$1(0, other);
            },
            get$file: function(_) {
                var t1 = this.get$span(0);
                return t1.get$file(t1);
            },
            highlight$1$color: function(color) {
                return this.get$span(0).highlight$1$color(color);
            },
            get$length: function(_) {
                var t1 = this.get$span(0);
                return t1.get$length(t1);
            },
            message$2$color: function(_, message, color) {
                return this.get$span(0).message$2$color(0, message, color);
            },
            message$1: function(_, message) {
                return this.message$2$color(0, message, null);
            },
            get$sourceUrl: function(_) {
                var t1 = this.get$span(0);
                return t1.get$sourceUrl(t1);
            },
            get$start: function(_) {
                var t1 = this.get$span(0);
                return t1.get$start(t1);
            },
            get$text: function() {
                return this.get$span(0).get$text();
            },
            $isComparable: 1,
            $isFileSpan: 1,
            $isSourceSpan: 1,
            $isSourceSpanWithContext: 1
        };
        A.LimitedMapView.prototype = {
            get$keys: function(_) {
                return this._limited_map_view$_keys;
            },
            get$length: function(_) {
                return this._limited_map_view$_keys._collection$_length;
            },
            get$isEmpty: function(_) {
                return this._limited_map_view$_keys._collection$_length === 0;
            },
            get$isNotEmpty: function(_) {
                return this._limited_map_view$_keys._collection$_length !== 0;
            },
            $index: function(_, key) {
                return this._limited_map_view$_keys.contains$1(0, key) ? this._limited_map_view$_map.$index(0, key) : null;
            },
            containsKey$1: function(key) {
                return this._limited_map_view$_keys.contains$1(0, key);
            },
            remove$1: function(_, key) {
                return this._limited_map_view$_keys.contains$1(0, key) ? this._limited_map_view$_map.remove$1(0, key) : null;
            }
        };
        A.MapExtensions_get_pairs_closure.prototype = {
            call$1: function(e) {
                return new A._Record_2(e.key, e.value);
            },
            $signature: function() {
                return this.K._eval$1("@<0>")._bind$1(this.V)._eval$1("+(1,2)(MapEntry<1,2>)");
            }
        };
        A.MergedMapView.prototype = {
            get$keys: function(_) {
                var t1 = this._mapsByKey;
                return new A.LinkedHashMapKeysIterable(t1, A._instanceType(t1)._eval$1("LinkedHashMapKeysIterable<1>"));
            },
            get$length: function(_) {
                return this._mapsByKey.__js_helper$_length;
            },
            get$isEmpty: function(_) {
                return this._mapsByKey.__js_helper$_length === 0;
            },
            get$isNotEmpty: function(_) {
                return this._mapsByKey.__js_helper$_length !== 0;
            },
            MergedMapView$1: function(maps, $K, $V) {
                var t1, t2, _i, map, t3, t4;
                for(t1 = maps.length, t2 = this._mapsByKey, _i = 0; _i < maps.length; maps.length === t1 || (0, A.throwConcurrentModificationError)(maps), ++_i){
                    map = maps[_i];
                    if (map instanceof A.MergedMapView) for(t3 = map._mapsByKey, t3 = new A.LinkedHashMapValueIterator(t3, t3._modifications, t3._first); t3.moveNext$0();){
                        t4 = t3.__js_helper$_current;
                        A.setAll(t2, t4.get$keys(t4), t4);
                    }
                    else A.setAll(t2, map.get$keys(map), map);
                }
            },
            $index: function(_, key) {
                var t1 = this._mapsByKey.$index(0, this.$ti._precomputed1._as(key));
                return t1 == null ? null : t1.$index(0, key);
            },
            $indexSet: function(_, key, value) {
                var _0_0 = this._mapsByKey.$index(0, key);
                if (_0_0 != null) _0_0.$indexSet(0, key, value);
                else throw A.wrapException(A.UnsupportedError$(string$.New_en));
            },
            remove$1: function(_, key) {
                throw A.wrapException(A.UnsupportedError$(string$.Entrie));
            },
            containsKey$1: function(key) {
                return this._mapsByKey.containsKey$1(key);
            }
        };
        A.MultiDirWatcher.prototype = {
            watch$1: function(_, directory) {
                var t1, t2, t3, t4, isParentOfExistingDir, _i, t5, _0_1, t6, future, stream, completer;
                for(t1 = this._watchers, t2 = A.MapExtensions_get_pairs(t1, type$.nullable_String, type$.Stream_WatchEvent).toList$0(0), t3 = t2.length, t1 = t1._map, t4 = this._group, isParentOfExistingDir = false, _i = 0; _i < t2.length; t2.length === t3 || (0, A.throwConcurrentModificationError)(t2), ++_i){
                    t5 = t2[_i];
                    _0_1 = t5._0;
                    _0_1.toString;
                    if (!isParentOfExistingDir) {
                        t6 = $.$get$context();
                        t6 = t6._isWithinOrEquals$2(_0_1, directory) === B._PathRelation_equal || t6._isWithinOrEquals$2(_0_1, directory) === B._PathRelation_within;
                    } else t6 = false;
                    if (t6) {
                        t1 = new A._Future($.Zone__current, type$._Future_void);
                        t1._asyncComplete$1(null);
                        return t1;
                    }
                    if ($.$get$context()._isWithinOrEquals$2(directory, _0_1) === B._PathRelation_within) {
                        t1.remove$1(0, _0_1);
                        t4.remove$1(0, t5._1);
                        isParentOfExistingDir = true;
                    }
                }
                future = A.watchDir(directory, this._poll);
                stream = new A._CompleterStream(type$._CompleterStream_WatchEvent);
                completer = new A.StreamCompleter(stream, type$.StreamCompleter_WatchEvent);
                future.then$1$2$onError(0, completer.get$setSourceStream(), completer.get$setError(), type$.void);
                t1.$indexSet(0, directory, stream);
                t4.add$1(0, stream);
                return future;
            }
        };
        A.MultiSpan.prototype = {
            get$start: function(_) {
                var t1 = this._multi_span$_primary;
                return t1.get$start(t1);
            },
            get$end: function(_) {
                var t1 = this._multi_span$_primary;
                return t1.get$end(t1);
            },
            get$text: function() {
                return this._multi_span$_primary.get$text();
            },
            get$context: function(_) {
                var t1 = this._multi_span$_primary;
                return t1.get$context(t1);
            },
            get$file: function(_) {
                var t1 = this._multi_span$_primary;
                return t1.get$file(t1);
            },
            get$length: function(_) {
                var t1 = this._multi_span$_primary;
                return t1.get$length(t1);
            },
            get$sourceUrl: function(_) {
                var t1 = this._multi_span$_primary;
                return t1.get$sourceUrl(t1);
            },
            compareTo$1: function(_, other) {
                return this._multi_span$_primary.compareTo$1(0, other);
            },
            toString$0: function(_) {
                return this._multi_span$_primary.toString$0(0);
            },
            expand$1: function(_, other) {
                return new A.MultiSpan(this._multi_span$_primary.expand$1(0, other), this.primaryLabel, this.secondarySpans);
            },
            highlight$1$color: function(color) {
                return A.Highlighter$multiple(this._multi_span$_primary, this.primaryLabel, this.secondarySpans, color === true, null, null).highlight$0();
            },
            message$2$color: function(_, message, color) {
                var t1 = J.$eq$(color, true) || typeof color == "string", t2 = typeof color == "string" ? color : null;
                return A.SourceSpanExtension_messageMultiple(this._multi_span$_primary, message, this.primaryLabel, this.secondarySpans, t1, t2, null);
            },
            message$1: function(_, message) {
                return this.message$2$color(0, message, null);
            },
            $isComparable: 1,
            $isFileSpan: 1,
            $isSourceSpan: 1,
            $isSourceSpanWithContext: 1
        };
        A.NoSourceMapBuffer.prototype = {
            get$length: function(_) {
                return this._no_source_map_buffer$_buffer._contents.length;
            },
            forSpan$1$2: function(span, callback) {
                return callback.call$0();
            },
            forSpan$2: function(span, callback) {
                return this.forSpan$1$2(span, callback, type$.dynamic);
            },
            write$1: function(_, object) {
                var t1 = this._no_source_map_buffer$_buffer, t2 = A.S(object);
                t1._contents += t2;
                return null;
            },
            writeCharCode$1: function(charCode) {
                var t1 = this._no_source_map_buffer$_buffer, t2 = A.Primitives_stringFromCharCode(charCode);
                t1._contents += t2;
                return null;
            },
            toString$0: function(_) {
                var t1 = this._no_source_map_buffer$_buffer._contents;
                return t1.charCodeAt(0) == 0 ? t1 : t1;
            },
            buildSourceMap$1$prefix: function(prefix) {
                return A.throwExpression(A.UnsupportedError$(string$.NoSour));
            }
        };
        A.PrefixedMapView.prototype = {
            get$keys: function(_) {
                return new A._PrefixedKeys(this);
            },
            get$length: function(_) {
                var t1 = this._prefixed_map_view$_map;
                return t1.get$length(t1);
            },
            get$isEmpty: function(_) {
                var t1 = this._prefixed_map_view$_map;
                return t1.get$isEmpty(t1);
            },
            get$isNotEmpty: function(_) {
                var t1 = this._prefixed_map_view$_map;
                return t1.get$isNotEmpty(t1);
            },
            $index: function(_, key) {
                return typeof key == "string" && B.JSString_methods.startsWith$1(key, this._prefix) ? this._prefixed_map_view$_map.$index(0, B.JSString_methods.substring$1(key, this._prefix.length)) : null;
            },
            containsKey$1: function(key) {
                return typeof key == "string" && B.JSString_methods.startsWith$1(key, this._prefix) && this._prefixed_map_view$_map.containsKey$1(B.JSString_methods.substring$1(key, this._prefix.length));
            }
        };
        A._PrefixedKeys.prototype = {
            get$length: function(_) {
                var t1 = this._view._prefixed_map_view$_map;
                return t1.get$length(t1);
            },
            get$iterator: function(_) {
                var t1 = this._view._prefixed_map_view$_map;
                t1 = t1.get$keys(t1);
                t1 = t1.map$1$1(t1, new A._PrefixedKeys_iterator_closure(this), type$.String);
                return t1.get$iterator(t1);
            },
            contains$1: function(_, key) {
                return this._view.containsKey$1(key);
            }
        };
        A._PrefixedKeys_iterator_closure.prototype = {
            call$1: function(key) {
                return this.$this._view._prefix + key;
            },
            $signature: 6
        };
        A.PublicMemberMapView.prototype = {
            get$keys: function(_) {
                var t1 = this._public_member_map_view$_inner;
                t1 = t1.get$keys(t1);
                return t1.where$1(t1, A.utils__isPublic$closure());
            },
            containsKey$1: function(key) {
                return typeof key == "string" && A.isPublic(key) && this._public_member_map_view$_inner.containsKey$1(key);
            },
            $index: function(_, key) {
                if (typeof key == "string" && A.isPublic(key)) return this._public_member_map_view$_inner.$index(0, key);
                return null;
            }
        };
        A.SourceMapBuffer.prototype = {
            get$_targetLocation: function() {
                var t1 = this._source_map_buffer$_buffer._contents, t2 = this._line;
                return A.SourceLocation$(t1.length, this._column, t2, null);
            },
            get$length: function(_) {
                return this._source_map_buffer$_buffer._contents.length;
            },
            forSpan$1$2: function(span, callback) {
                var t1, _this = this, wasInSpan = _this._inSpan;
                _this._inSpan = true;
                _this._addEntry$2(span.get$start(span), _this.get$_targetLocation());
                try {
                    t1 = callback.call$0();
                    return t1;
                } finally{
                    _this._inSpan = wasInSpan;
                }
            },
            forSpan$2: function(span, callback) {
                return this.forSpan$1$2(span, callback, type$.dynamic);
            },
            _addEntry$2: function(source, target) {
                var entry, t2, t1 = this._entries;
                if (t1.length !== 0) {
                    entry = B.JSArray_methods.get$last(t1);
                    t2 = entry.source;
                    if (t2.file.getLine$1(t2.offset) === source.file.getLine$1(source.offset) && entry.target.line === target.line) return;
                    if (entry.target.offset === target.offset) return;
                }
                t1.push(new A.Entry(source, target, null));
            },
            write$1: function(_, object) {
                var t1, i, string = J.toString$0$(object);
                this._source_map_buffer$_buffer._contents += string;
                for(t1 = string.length, i = 0; i < t1; ++i)if (string.charCodeAt(i) === 10) this._source_map_buffer$_writeLine$0();
                else ++this._column;
            },
            writeCharCode$1: function(charCode) {
                var t1 = this._source_map_buffer$_buffer, t2 = A.Primitives_stringFromCharCode(charCode);
                t1._contents += t2;
                if (charCode === 10) this._source_map_buffer$_writeLine$0();
                else ++this._column;
            },
            _source_map_buffer$_writeLine$0: function() {
                var _this = this, t1 = _this._entries;
                if (B.JSArray_methods.get$last(t1).target.line === _this._line && B.JSArray_methods.get$last(t1).target.column === _this._column) t1.pop();
                ++_this._line;
                _this._column = 0;
                if (_this._inSpan) t1.push(new A.Entry(B.JSArray_methods.get$last(t1).source, _this.get$_targetLocation(), null));
            },
            toString$0: function(_) {
                var t1 = this._source_map_buffer$_buffer._contents;
                return t1.charCodeAt(0) == 0 ? t1 : t1;
            },
            buildSourceMap$1$prefix: function(prefix) {
                var i, t2, prefixColumn, _box_0 = {}, t1 = prefix.length;
                if (t1 === 0) return A.SingleMapping_SingleMapping$fromEntries(this._entries);
                _box_0.prefixColumn = _box_0.prefixLines = 0;
                for(i = 0, t2 = 0; i < t1; ++i)if (prefix.charCodeAt(i) === 10) {
                    ++_box_0.prefixLines;
                    _box_0.prefixColumn = 0;
                    t2 = 0;
                } else {
                    prefixColumn = t2 + 1;
                    _box_0.prefixColumn = prefixColumn;
                    t2 = prefixColumn;
                }
                t2 = this._entries;
                return A.SingleMapping_SingleMapping$fromEntries(new A.MappedListIterable(t2, new A.SourceMapBuffer_buildSourceMap_closure(_box_0, t1), A._arrayInstanceType(t2)._eval$1("MappedListIterable<1,Entry>")));
            }
        };
        A.SourceMapBuffer_buildSourceMap_closure.prototype = {
            call$1: function(entry) {
                var t1 = entry.target, t2 = t1.line, t3 = this._box_0, t4 = t3.prefixLines;
                t3 = t2 === 0 ? t3.prefixColumn : 0;
                return new A.Entry(entry.source, A.SourceLocation$(t1.offset + this.prefixLength, t1.column + t3, t2 + t4, null), entry.identifierName);
            },
            $signature: 164
        };
        A.UnprefixedMapView.prototype = {
            get$keys: function(_) {
                return new A._UnprefixedKeys(this);
            },
            $index: function(_, key) {
                return typeof key == "string" ? this._unprefixed_map_view$_map.$index(0, this._unprefixed_map_view$_prefix + key) : null;
            },
            containsKey$1: function(key) {
                return typeof key == "string" && this._unprefixed_map_view$_map.containsKey$1(this._unprefixed_map_view$_prefix + key);
            },
            remove$1: function(_, key) {
                return typeof key == "string" ? this._unprefixed_map_view$_map.remove$1(0, this._unprefixed_map_view$_prefix + key) : null;
            }
        };
        A._UnprefixedKeys.prototype = {
            get$iterator: function(_) {
                var t1 = this._unprefixed_map_view$_view._unprefixed_map_view$_map;
                t1 = t1.get$keys(t1);
                t1 = t1.where$1(t1, new A._UnprefixedKeys_iterator_closure(this)).map$1$1(0, new A._UnprefixedKeys_iterator_closure0(this), type$.String);
                return t1.get$iterator(t1);
            },
            contains$1: function(_, key) {
                return this._unprefixed_map_view$_view.containsKey$1(key);
            }
        };
        A._UnprefixedKeys_iterator_closure.prototype = {
            call$1: function(key) {
                return B.JSString_methods.startsWith$1(key, this.$this._unprefixed_map_view$_view._unprefixed_map_view$_prefix);
            },
            $signature: 4
        };
        A._UnprefixedKeys_iterator_closure0.prototype = {
            call$1: function(key) {
                return B.JSString_methods.substring$1(key, this.$this._unprefixed_map_view$_view._unprefixed_map_view$_prefix.length);
            },
            $signature: 6
        };
        A.indent_closure.prototype = {
            call$1: function(line) {
                return B.JSString_methods.$mul(" ", this.indentation) + line;
            },
            $signature: 6
        };
        A.flattenVertically_closure.prototype = {
            call$1: function(inner) {
                return A.QueueList_QueueList$from(inner, this.T);
            },
            $signature: function() {
                return this.T._eval$1("QueueList<0>(Iterable<0>)");
            }
        };
        A.flattenVertically_closure0.prototype = {
            call$1: function(queue) {
                this.result.push(queue.removeFirst$0());
                return queue.get$length(0) === 0;
            },
            $signature: function() {
                return this.T._eval$1("bool(QueueList<0>)");
            }
        };
        A.longestCommonSubsequence_backtrack.prototype = {
            call$2: function(i, j) {
                var selection, t1, _this = this;
                if (i === -1 || j === -1) return A._setArrayType([], _this.T._eval$1("JSArray<0>"));
                selection = _this.selections[i][j];
                if (selection != null) {
                    t1 = _this.call$2(i - 1, j - 1);
                    J.add$1$ax(t1, selection);
                    return t1;
                }
                t1 = _this.lengths;
                return t1[i + 1][j] > t1[i][j + 1] ? _this.call$2(i, j - 1) : _this.call$2(i - 1, j);
            },
            $signature: function() {
                return this.T._eval$1("List<0>(int,int)");
            }
        };
        A.mapAddAll2_closure.prototype = {
            call$2: function(key, inner) {
                var t1 = this.destination, _0_0 = t1.$index(0, key);
                if (_0_0 != null) _0_0.addAll$1(0, inner);
                else t1.$indexSet(0, key, inner);
            },
            $signature: function() {
                return this.K1._eval$1("@<0>")._bind$1(this.K2)._bind$1(this.V)._eval$1("~(1,Map<2,3>)");
            }
        };
        A.Value.prototype = {
            get$isTruthy: function() {
                return true;
            },
            get$separator: function(_) {
                return B.ListSeparator_undecided_null_3_undecided;
            },
            get$hasBrackets: function() {
                return false;
            },
            get$asList: function() {
                return A._setArrayType([
                    this
                ], type$.JSArray_Value);
            },
            get$lengthAsList: function() {
                return 1;
            },
            get$isBlank: function() {
                return false;
            },
            get$isSpecialNumber: function() {
                return false;
            },
            get$isSpecialVariable: function() {
                return false;
            },
            get$realNull: function() {
                return this;
            },
            sassIndexToListIndex$2: function(sassIndex, $name) {
                var t1, index, indexValue = sassIndex.assertNumber$1($name);
                if (indexValue.get$hasUnits()) {
                    t1 = indexValue.get$unitString();
                    A.warnForDeprecation("$" + $name + ": Passing a number with unit " + t1 + string$.x20is_de + indexValue.unitSuggestion$1($name) + string$.x0a_Morex3af, B.Deprecation_7TE);
                }
                index = indexValue.assertInt$1($name);
                if (index === 0) throw A.wrapException(A.SassScriptException$("List index may not be 0.", $name));
                if (Math.abs(index) > this.get$lengthAsList()) throw A.wrapException(A.SassScriptException$("Invalid index " + sassIndex.toString$0(0) + " for a list with " + this.get$lengthAsList() + " elements.", $name));
                return index < 0 ? this.get$lengthAsList() + index : index - 1;
            },
            assertCalculation$1: function($name) {
                return A.throwExpression(A.SassScriptException$(this.toString$0(0) + " is not a calculation.", $name));
            },
            assertColor$1: function($name) {
                return A.throwExpression(A.SassScriptException$(this.toString$0(0) + " is not a color.", $name));
            },
            assertFunction$1: function($name) {
                return A.throwExpression(A.SassScriptException$(this.toString$0(0) + " is not a function reference.", $name));
            },
            assertMixin$1: function($name) {
                return A.throwExpression(A.SassScriptException$(this.toString$0(0) + " is not a mixin reference.", $name));
            },
            assertMap$1: function($name) {
                return A.throwExpression(A.SassScriptException$(this.toString$0(0) + " is not a map.", $name));
            },
            tryMap$0: function() {
                return null;
            },
            assertNumber$1: function($name) {
                return A.throwExpression(A.SassScriptException$(this.toString$0(0) + " is not a number.", $name));
            },
            assertNumber$0: function() {
                return this.assertNumber$1(null);
            },
            assertString$1: function($name) {
                return A.throwExpression(A.SassScriptException$(this.toString$0(0) + " is not a string.", $name));
            },
            assertCommonListStyle$2$allowSlash: function($name, allowSlash) {
                var invalidSeparator, buffer, t1, _this = this, _s8_ = "Expected", _s23_ = "Expected an unbracketed";
                if (_this.get$separator(_this) !== B.ListSeparator_z0K) invalidSeparator = !allowSlash && _this.get$separator(_this) === B.ListSeparator_Lul;
                else invalidSeparator = true;
                if (!invalidSeparator && !_this.get$hasBrackets()) return _this.get$asList();
                buffer = new A.StringBuffer(_s8_);
                if (_this.get$hasBrackets()) {
                    buffer._contents = _s23_;
                    t1 = _s23_;
                } else t1 = _s8_;
                if (invalidSeparator) {
                    t1 += _this.get$hasBrackets() ? "," : " a";
                    buffer._contents = t1;
                    t1 = buffer._contents = t1 + " space-";
                    t1 = buffer._contents = (allowSlash ? buffer._contents = t1 + " or slash-" : t1) + "separated";
                }
                buffer._contents = t1 + (" list, was " + _this.toString$0(0));
                throw A.wrapException(A.SassScriptException$(buffer.toString$0(0), $name));
            },
            _selectorString$1: function($name) {
                var _0_0 = this._selectorStringOrNull$0();
                if (_0_0 != null) return _0_0;
                throw A.wrapException(A.SassScriptException$(this.toString$0(0) + string$.x20is_noav, $name));
            },
            _selectorStringOrNull$0: function() {
                var t1, t2, result, _1_0, _i, complex, string, compound, _this = this, _null = null;
                if (_this instanceof A.SassString) return _this._string$_text;
                if (!(_this instanceof A.SassList)) return _null;
                t1 = _this._list$_contents;
                t2 = t1.length;
                if (t2 === 0) return _null;
                result = A._setArrayType([], type$.JSArray_String);
                $label0$1: {
                    _1_0 = _this._separator;
                    if (B.ListSeparator_z0K === _1_0) {
                        for(_i = 0; _i < t2; ++_i){
                            complex = t1[_i];
                            if (complex instanceof A.SassString) {
                                result.push(complex._string$_text);
                                continue;
                            }
                            if (complex instanceof A.SassList && B.ListSeparator_SrV === complex._separator) {
                                string = complex._selectorStringOrNull$0();
                                if (string == null) return _null;
                                result.push(string);
                                continue;
                            }
                            return _null;
                        }
                        break $label0$1;
                    }
                    if (B.ListSeparator_Lul === _1_0) return _null;
                    for(_i = 0; _i < t2; ++_i){
                        compound = t1[_i];
                        if (!(compound instanceof A.SassString)) return _null;
                        result.push(compound._string$_text);
                    }
                }
                return B.JSArray_methods.join$1(result, _1_0 === B.ListSeparator_z0K ? ", " : " ");
            },
            withListContents$2$separator: function(contents, separator) {
                var t1 = separator == null ? this.get$separator(this) : separator, t2 = this.get$hasBrackets();
                return A.SassList$(contents, t1, t2);
            },
            withListContents$1: function(contents) {
                return this.withListContents$2$separator(contents, null);
            },
            greaterThan$1: function(other) {
                return A.throwExpression(A.SassScriptException$('Undefined operation "' + this.toString$0(0) + " > " + other.toString$0(0) + '".', null));
            },
            greaterThanOrEquals$1: function(other) {
                return A.throwExpression(A.SassScriptException$('Undefined operation "' + this.toString$0(0) + " >= " + other.toString$0(0) + '".', null));
            },
            lessThan$1: function(other) {
                return A.throwExpression(A.SassScriptException$('Undefined operation "' + this.toString$0(0) + " < " + other.toString$0(0) + '".', null));
            },
            lessThanOrEquals$1: function(other) {
                return A.throwExpression(A.SassScriptException$('Undefined operation "' + this.toString$0(0) + " <= " + other.toString$0(0) + '".', null));
            },
            times$1: function(other) {
                return A.throwExpression(A.SassScriptException$('Undefined operation "' + this.toString$0(0) + " * " + other.toString$0(0) + '".', null));
            },
            modulo$1: function(other) {
                return A.throwExpression(A.SassScriptException$('Undefined operation "' + this.toString$0(0) + " % " + other.toString$0(0) + '".', null));
            },
            plus$1: function(other) {
                var t1;
                $label0$0: {
                    if (other instanceof A.SassString) {
                        t1 = new A.SassString(A.serializeValue(this, false, true) + other._string$_text, other._hasQuotes);
                        break $label0$0;
                    }
                    if (other instanceof A.SassCalculation) A.throwExpression(A.SassScriptException$('Undefined operation "' + this.toString$0(0) + " + " + other.toString$0(0) + '".', null));
                    t1 = new A.SassString(A.serializeValue(this, false, true) + A.serializeValue(other, false, true), false);
                    break $label0$0;
                }
                return t1;
            },
            minus$1: function(other) {
                return other instanceof A.SassCalculation ? A.throwExpression(A.SassScriptException$('Undefined operation "' + this.toString$0(0) + " - " + other.toString$0(0) + '".', null)) : new A.SassString(A.serializeValue(this, false, true) + "-" + A.serializeValue(other, false, true), false);
            },
            dividedBy$1: function(other) {
                return new A.SassString(A.serializeValue(this, false, true) + "/" + A.serializeValue(other, false, true), false);
            },
            unaryPlus$0: function() {
                return new A.SassString("+" + A.serializeValue(this, false, true), false);
            },
            unaryMinus$0: function() {
                return new A.SassString("-" + A.serializeValue(this, false, true), false);
            },
            unaryNot$0: function() {
                return B.SassBoolean_false;
            },
            withoutSlash$0: function() {
                return this;
            },
            toCssString$1$quote: function(quote) {
                return A.serializeValue(this, false, quote);
            },
            toCssString$0: function() {
                return this.toCssString$1$quote(true);
            },
            toString$0: function(_) {
                return A.serializeValue(this, true, true);
            }
        };
        A.SassArgumentList.prototype = {};
        A.SassBoolean.prototype = {
            get$isTruthy: function() {
                return this.value;
            },
            accept$1$1: function(visitor) {
                return visitor._serialize$_buffer.write$1(0, String(this.value));
            },
            accept$1: function(visitor) {
                return this.accept$1$1(visitor, type$.dynamic);
            },
            unaryNot$0: function() {
                return this.value ? B.SassBoolean_false : B.SassBoolean_true;
            }
        };
        A.SassCalculation.prototype = {
            get$isSpecialNumber: function() {
                return true;
            },
            accept$1$1: function(visitor) {
                return visitor.visitCalculation$1(this);
            },
            accept$1: function(visitor) {
                return this.accept$1$1(visitor, type$.dynamic);
            },
            assertCalculation$1: function($name) {
                return this;
            },
            plus$1: function(other) {
                if (other instanceof A.SassString) return this.super$Value$plus(other);
                throw A.wrapException(A.SassScriptException$('Undefined operation "' + this.toString$0(0) + " + " + other.toString$0(0) + '".', null));
            },
            minus$1: function(other) {
                return A.throwExpression(A.SassScriptException$('Undefined operation "' + this.toString$0(0) + " - " + other.toString$0(0) + '".', null));
            },
            unaryPlus$0: function() {
                return A.throwExpression(A.SassScriptException$('Undefined operation "+' + this.toString$0(0) + '".', null));
            },
            unaryMinus$0: function() {
                return A.throwExpression(A.SassScriptException$('Undefined operation "-' + this.toString$0(0) + '".', null));
            },
            $eq: function(_, other) {
                if (other == null) return false;
                return other instanceof A.SassCalculation && this.name === other.name && B.C_ListEquality.equals$2(0, this.$arguments, other.$arguments);
            },
            get$hashCode: function(_) {
                return B.JSString_methods.get$hashCode(this.name) ^ B.C_ListEquality0.hash$1(this.$arguments);
            }
        };
        A.SassCalculation__verifyLength_closure.prototype = {
            call$1: function(arg) {
                return arg instanceof A.SassString;
            },
            $signature: 73
        };
        A.CalculationOperation.prototype = {
            $eq: function(_, other) {
                if (other == null) return false;
                return other instanceof A.CalculationOperation && this._operator === other._operator && J.$eq$(this._left, other._left) && J.$eq$(this._right, other._right);
            },
            get$hashCode: function(_) {
                return (A.Primitives_objectHashCode(this._operator) ^ J.get$hashCode$(this._left) ^ J.get$hashCode$(this._right)) >>> 0;
            },
            toString$0: function(_) {
                var parenthesized = A.serializeValue(new A.SassCalculation("", A._setArrayType([
                    this
                ], type$.JSArray_Object)), true, true);
                return B.JSString_methods.substring$2(parenthesized, 1, parenthesized.length - 1);
            }
        };
        A.CalculationOperator.prototype = {
            _enumToString$0: function() {
                return "CalculationOperator." + this._name;
            },
            toString$0: function(_) {
                return this.name;
            }
        };
        A.SassColor.prototype = {
            get$channels: function() {
                var t2, t3, t1 = this.channel0OrNull;
                if (t1 == null) t1 = 0;
                t2 = this.channel1OrNull;
                if (t2 == null) t2 = 0;
                t3 = this.channel2OrNull;
                return A.List_List$unmodifiable([
                    t1,
                    t2,
                    t3 == null ? 0 : t3
                ], type$.double);
            },
            get$channelsOrNull: function() {
                return A.List_List$unmodifiable([
                    this.channel0OrNull,
                    this.channel1OrNull,
                    this.channel2OrNull
                ], type$.nullable_double);
            },
            get$isChannel0Powerless: function() {
                var t1, t2, _this = this, _0_0 = _this._space;
                $label0$0: {
                    if (B.HslColorSpace_JQ2 === _0_0) {
                        t1 = _this.channel1OrNull;
                        t1 = A.fuzzyEquals(t1 == null ? 0 : t1, 0);
                        break $label0$0;
                    }
                    if (B.HwbColorSpace_guQ === _0_0) {
                        t1 = _this.channel1OrNull;
                        if (t1 == null) t1 = 0;
                        t2 = _this.channel2OrNull;
                        t1 += t2 == null ? 0 : t2;
                        t1 = t1 > 100 || A.fuzzyEquals(t1, 100);
                        break $label0$0;
                    }
                    t1 = false;
                    break $label0$0;
                }
                return t1;
            },
            get$isChannel2Powerless: function() {
                var t1, _0_0 = this._space;
                $label0$0: {
                    if (B.LchColorSpace_Bpv === _0_0 || B.OklchColorSpace_9Gj === _0_0) {
                        t1 = this.channel1OrNull;
                        t1 = A.fuzzyEquals(t1 == null ? 0 : t1, 0);
                        break $label0$0;
                    }
                    t1 = false;
                    break $label0$0;
                }
                return t1;
            },
            get$isInGamut: function() {
                var t2, t3, _this = this, t1 = _this._space;
                if (!t1.get$isBoundedInternal()) return true;
                t2 = _this.channel0OrNull;
                if (t2 == null) t2 = 0;
                t1 = t1._channels;
                t3 = false;
                if (_this._isChannelInGamut$2(t2, t1[0])) {
                    t2 = _this.channel1OrNull;
                    if (t2 == null) t2 = 0;
                    if (_this._isChannelInGamut$2(t2, t1[1])) {
                        t2 = _this.channel2OrNull;
                        if (t2 == null) t2 = 0;
                        t1 = _this._isChannelInGamut$2(t2, t1[2]);
                    } else t1 = t3;
                } else t1 = t3;
                return t1;
            },
            _isChannelInGamut$2: function(value, channel) {
                var min, max, t1;
                $label0$0: {
                    if (channel instanceof A.LinearChannel) {
                        min = channel.min;
                        max = channel.max;
                        if (value < max || A.fuzzyEquals(value, max)) t1 = value > min || A.fuzzyEquals(value, min);
                        else t1 = false;
                        break $label0$0;
                    }
                    t1 = true;
                    break $label0$0;
                }
                return t1;
            },
            accept$1$1: function(visitor) {
                return visitor.visitColor$1(this);
            },
            accept$1: function(visitor) {
                return this.accept$1$1(visitor, type$.dynamic);
            },
            assertColor$1: function($name) {
                return this;
            },
            assertLegacy$1: function($name) {
                if (this._space.get$isLegacyInternal()) return;
                throw A.wrapException(A.SassScriptException$("Expected " + this.toString$0(0) + string$.x20to_be, $name));
            },
            channel$1: function(_, channel) {
                var t1, _this = this, channels = _this._space._channels;
                if (channel === channels[0].name) {
                    t1 = _this.channel0OrNull;
                    return t1 == null ? 0 : t1;
                }
                if (channel === channels[1].name) {
                    t1 = _this.channel1OrNull;
                    return t1 == null ? 0 : t1;
                }
                if (channel === channels[2].name) {
                    t1 = _this.channel2OrNull;
                    return t1 == null ? 0 : t1;
                }
                if (channel === "alpha") {
                    t1 = _this.alphaOrNull;
                    return t1 == null ? 0 : t1;
                }
                throw A.wrapException(A.SassScriptException$("Color " + _this.toString$0(0) + " doesn't have a channel named \"" + channel + '".', null));
            },
            isChannelMissing$3$channelName$colorName: function(channel, channelName, colorName) {
                var _this = this, channels = _this._space._channels;
                if (channel === channels[0].name) return _this.channel0OrNull == null;
                if (channel === channels[1].name) return _this.channel1OrNull == null;
                if (channel === channels[2].name) return _this.channel2OrNull == null;
                if (channel === "alpha") return _this.alphaOrNull == null;
                throw A.wrapException(A.SassScriptException$("Color " + _this.toString$0(0) + " doesn't have a channel named \"" + channel + '".', channelName));
            },
            isChannelMissing$1: function(channel) {
                return this.isChannelMissing$3$channelName$colorName(channel, null, null);
            },
            isChannelPowerless$3$channelName$colorName: function(channel, channelName, colorName) {
                var _this = this, channels = _this._space._channels;
                if (channel === channels[0].name) return _this.get$isChannel0Powerless();
                if (channel === channels[1].name) return false;
                if (channel === channels[2].name) return _this.get$isChannel2Powerless();
                if (channel === "alpha") return false;
                throw A.wrapException(A.SassScriptException$("Color " + _this.toString$0(0) + " doesn't have a channel named \"" + channel + '".', channelName));
            },
            _legacyChannel$2: function(space, channel) {
                if (!this._space.get$isLegacyInternal()) throw A.wrapException(A.SassScriptException$("color." + channel + string$.x28__is_oc, null));
                return this.toSpace$1(space).channel$1(0, channel);
            },
            toSpace$2$legacyMissing: function(space, legacyMissing) {
                var t2, converted, t3, t4, _this = this, t1 = _this._space;
                if (t1 === space) return _this;
                t2 = _this.alphaOrNull;
                if (t2 == null) t2 = 0;
                converted = t1.convert$5(space, _this.channel0OrNull, _this.channel1OrNull, _this.channel2OrNull, t2);
                t1 = false;
                if (!legacyMissing) {
                    if (converted._space.get$isLegacyInternal()) t1 = converted.channel0OrNull == null || converted.channel1OrNull == null || converted.channel2OrNull == null || converted.alphaOrNull == null;
                }
                if (t1) {
                    t1 = converted.channel0OrNull;
                    if (t1 == null) t1 = 0;
                    t2 = converted.channel1OrNull;
                    if (t2 == null) t2 = 0;
                    t3 = converted.channel2OrNull;
                    if (t3 == null) t3 = 0;
                    t4 = converted.alphaOrNull;
                    if (t4 == null) t4 = 0;
                    t4 = A.SassColor_SassColor$forSpaceInternal(converted._space, t1, t2, t3, t4);
                    t1 = t4;
                } else t1 = converted;
                return t1;
            },
            toSpace$1: function(space) {
                return this.toSpace$2$legacyMissing(space, true);
            },
            changeHsl$3$hue$lightness$saturation: function(hue, lightness, saturation) {
                var t2, t3, t4, t5, _this = this, _null = null, t1 = _this._space;
                if (!t1.get$isLegacyInternal()) throw A.wrapException(A.SassScriptException$(string$.color_c, _null));
                t2 = hue == null ? _null : hue;
                if (t2 == null) t2 = _this._legacyChannel$2(B.HslColorSpace_JQ2, "hue");
                t3 = saturation == null ? _null : saturation;
                if (t3 == null) t3 = _this._legacyChannel$2(B.HslColorSpace_JQ2, "saturation");
                t4 = lightness == null ? _null : lightness;
                if (t4 == null) t4 = _this._legacyChannel$2(B.HslColorSpace_JQ2, "lightness");
                t5 = _this.alphaOrNull;
                if (t5 == null) t5 = 0;
                return A.SassColor_SassColor$hsl(t2, t3, t4, t5).toSpace$1(t1);
            },
            changeHsl$1$saturation: function(saturation) {
                return this.changeHsl$3$hue$lightness$saturation(null, null, saturation);
            },
            changeHsl$1$lightness: function(lightness) {
                return this.changeHsl$3$hue$lightness$saturation(null, lightness, null);
            },
            changeHsl$1$hue: function(hue) {
                return this.changeHsl$3$hue$lightness$saturation(hue, null, null);
            },
            changeAlpha$1: function(alpha) {
                var t2, t3, _this = this, t1 = _this.channel0OrNull;
                if (t1 == null) t1 = 0;
                t2 = _this.channel1OrNull;
                if (t2 == null) t2 = 0;
                t3 = _this.channel2OrNull;
                if (t3 == null) t3 = 0;
                return A.SassColor_SassColor$forSpaceInternal(_this._space, t1, t2, t3, alpha);
            },
            interpolate$4$legacyMissing$weight: function(other, method, legacyMissing, weight) {
                var t1, color1, color2, missing1_0, missing1_1, missing1_2, missing2_0, missing2_1, missing2_2, channel1_0, channel1_1, channel1_2, channel2_0, channel2_1, channel2_2, alpha1, t2, t3, alpha10, alpha2, alpha20, thisMultiplier, t4, t5, otherMultiplier, mixedAlpha, mixed0, mixed1, mixed2, _this = this, _null = null;
                if (A.fuzzyEquals(weight, 0)) return other;
                if (A.fuzzyEquals(weight, 1)) return _this;
                t1 = method.space;
                color1 = _this.toSpace$1(t1);
                color2 = other.toSpace$1(t1);
                if (weight < 0 || weight > 1) throw A.wrapException(A.RangeError$range(weight, 0, 1, "weight", _null));
                missing1_0 = _this._isAnalogousChannelMissing$3(_this, color1, 0);
                missing1_1 = _this._isAnalogousChannelMissing$3(_this, color1, 1);
                missing1_2 = _this._isAnalogousChannelMissing$3(_this, color1, 2);
                missing2_0 = _this._isAnalogousChannelMissing$3(other, color2, 0);
                missing2_1 = _this._isAnalogousChannelMissing$3(other, color2, 1);
                missing2_2 = _this._isAnalogousChannelMissing$3(other, color2, 2);
                channel1_0 = (missing1_0 ? color2 : color1).channel0OrNull;
                if (channel1_0 == null) channel1_0 = 0;
                channel1_1 = (missing1_1 ? color2 : color1).channel1OrNull;
                if (channel1_1 == null) channel1_1 = 0;
                channel1_2 = (missing1_2 ? color2 : color1).channel2OrNull;
                if (channel1_2 == null) channel1_2 = 0;
                channel2_0 = (missing2_0 ? color1 : color2).channel0OrNull;
                if (channel2_0 == null) channel2_0 = 0;
                channel2_1 = (missing2_1 ? color1 : color2).channel1OrNull;
                if (channel2_1 == null) channel2_1 = 0;
                channel2_2 = (missing2_2 ? color1 : color2).channel2OrNull;
                if (channel2_2 == null) channel2_2 = 0;
                alpha1 = _this.alphaOrNull;
                t2 = alpha1 == null;
                if (t2) {
                    t3 = other.alphaOrNull;
                    alpha10 = t3 == null ? 0 : t3;
                } else alpha10 = alpha1;
                alpha2 = other.alphaOrNull;
                t3 = alpha2 == null;
                if (t3) alpha20 = t2 ? 0 : alpha1;
                else alpha20 = alpha2;
                thisMultiplier = (t2 ? 1 : alpha1) * weight;
                t4 = t3 ? 1 : alpha2;
                t5 = 1 - weight;
                otherMultiplier = t4 * t5;
                mixedAlpha = t2 && t3 ? _null : alpha10 * weight + alpha20 * t5;
                if (missing1_0 && missing2_0) mixed0 = _null;
                else {
                    t2 = mixedAlpha == null ? 1 : mixedAlpha;
                    mixed0 = (channel1_0 * thisMultiplier + channel2_0 * otherMultiplier) / t2;
                }
                if (missing1_1 && missing2_1) mixed1 = _null;
                else {
                    t2 = mixedAlpha == null ? 1 : mixedAlpha;
                    mixed1 = (channel1_1 * thisMultiplier + channel2_1 * otherMultiplier) / t2;
                }
                if (missing1_2 && missing2_2) mixed2 = _null;
                else {
                    t2 = mixedAlpha == null ? 1 : mixedAlpha;
                    mixed2 = (channel1_2 * thisMultiplier + channel2_2 * otherMultiplier) / t2;
                }
                $label0$0: {
                    if (B.HslColorSpace_JQ2 === t1 || B.HwbColorSpace_guQ === t1) {
                        if (missing1_0 && missing2_0) t2 = _null;
                        else {
                            t2 = method.hue;
                            t2.toString;
                            t2 = _this._interpolateHues$4(channel1_0, channel2_0, t2, weight);
                        }
                        t2 = A.SassColor_SassColor$forSpaceInternal(t1, t2, mixed1, mixed2, mixedAlpha);
                        t1 = t2;
                        break $label0$0;
                    }
                    if (B.LchColorSpace_Bpv === t1 || B.OklchColorSpace_9Gj === t1) {
                        if (missing1_2 && missing2_2) t2 = _null;
                        else {
                            t2 = method.hue;
                            t2.toString;
                            t2 = _this._interpolateHues$4(channel1_2, channel2_2, t2, weight);
                        }
                        t2 = A.SassColor_SassColor$forSpaceInternal(t1, mixed0, mixed1, t2, mixedAlpha);
                        t1 = t2;
                        break $label0$0;
                    }
                    t1 = A.SassColor_SassColor$forSpaceInternal(t1, mixed0, mixed1, mixed2, mixedAlpha);
                    break $label0$0;
                }
                return t1.toSpace$2$legacyMissing(_this._space, false);
            },
            _isAnalogousChannelMissing$3: function(original, output, outputChannelIndex) {
                var originalChannel;
                if (output.get$channelsOrNull()[outputChannelIndex] == null) return true;
                if (original === output) return false;
                originalChannel = A.IterableExtension_firstWhereOrNull(original._space._channels, output._space._channels[outputChannelIndex].get$isAnalogous());
                if (originalChannel == null) return false;
                return original.isChannelMissing$1(originalChannel.name);
            },
            _interpolateHues$4: function(hue1, hue2, method, weight) {
                var _0_0, _1_0;
                $label1$1: {
                    if (B.HueInterpolationMethod_0 === method) {
                        $label0$0: {
                            _0_0 = hue2 - hue1;
                            if (_0_0 > 180) {
                                hue1 += 360;
                                break $label0$0;
                            }
                            if (_0_0 < -180) hue2 += 360;
                        }
                        break $label1$1;
                    }
                    if (B.HueInterpolationMethod_1 === method) {
                        $label2$2: {
                            _1_0 = hue2 - hue1;
                            if (_1_0 > 0 && _1_0 < 180) {
                                hue2 += 360;
                                break $label2$2;
                            }
                            if (_1_0 > -180 && _1_0 <= 0) hue1 += 360;
                        }
                        break $label1$1;
                    }
                    if (B.HueInterpolationMethod_2 === method && hue2 < hue1) {
                        hue2 += 360;
                        break $label1$1;
                    }
                    if (B.HueInterpolationMethod_3 === method && hue1 < hue2) {
                        hue1 += 360;
                        break $label1$1;
                    }
                }
                return hue1 * weight + hue2 * (1 - weight);
            },
            plus$1: function(other) {
                if (!(other instanceof A.SassNumber) && !(other instanceof A.SassColor)) return this.super$Value$plus(other);
                throw A.wrapException(A.SassScriptException$('Undefined operation "' + this.toString$0(0) + " + " + other.toString$0(0) + '".', null));
            },
            minus$1: function(other) {
                if (!(other instanceof A.SassNumber) && !(other instanceof A.SassColor)) return this.super$Value$minus(other);
                throw A.wrapException(A.SassScriptException$('Undefined operation "' + this.toString$0(0) + " - " + other.toString$0(0) + '".', null));
            },
            dividedBy$1: function(other) {
                if (!(other instanceof A.SassNumber) && !(other instanceof A.SassColor)) return this.super$Value$dividedBy(other);
                throw A.wrapException(A.SassScriptException$('Undefined operation "' + this.toString$0(0) + " / " + other.toString$0(0) + '".', null));
            },
            $eq: function(_, other) {
                var t1, t2, _this = this;
                if (other == null) return false;
                if (!(other instanceof A.SassColor)) return false;
                t1 = _this._space;
                if (t1.get$isLegacyInternal()) {
                    t2 = other._space;
                    if (!t2.get$isLegacyInternal()) return false;
                    if (!A.fuzzyEqualsNullable(_this.alphaOrNull, other.alphaOrNull)) return false;
                    if (t1 === t2) return A.fuzzyEqualsNullable(_this.channel0OrNull, other.channel0OrNull) && A.fuzzyEqualsNullable(_this.channel1OrNull, other.channel1OrNull) && A.fuzzyEqualsNullable(_this.channel2OrNull, other.channel2OrNull);
                    else return _this.toSpace$1(B.RgbColorSpace_i0P).$eq(0, other.toSpace$1(B.RgbColorSpace_i0P));
                }
                return t1 === other._space && A.fuzzyEqualsNullable(_this.channel0OrNull, other.channel0OrNull) && A.fuzzyEqualsNullable(_this.channel1OrNull, other.channel1OrNull) && A.fuzzyEqualsNullable(_this.channel2OrNull, other.channel2OrNull) && A.fuzzyEqualsNullable(_this.alphaOrNull, other.alphaOrNull);
            },
            get$hashCode: function(_) {
                var rgb, t2, t3, t4, t5, _this = this, t1 = _this._space;
                if (t1.get$isLegacyInternal()) {
                    rgb = _this.toSpace$1(B.RgbColorSpace_i0P);
                    t1 = rgb.channel0OrNull;
                    t1 = A.fuzzyHashCode(t1 == null ? 0 : t1);
                    t2 = rgb.channel1OrNull;
                    t2 = A.fuzzyHashCode(t2 == null ? 0 : t2);
                    t3 = rgb.channel2OrNull;
                    t3 = A.fuzzyHashCode(t3 == null ? 0 : t3);
                    t4 = _this.alphaOrNull;
                    return t1 ^ t2 ^ t3 ^ A.fuzzyHashCode(t4 == null ? 0 : t4);
                } else {
                    t1 = A.Primitives_objectHashCode(t1);
                    t2 = _this.channel0OrNull;
                    t2 = A.fuzzyHashCode(t2 == null ? 0 : t2);
                    t3 = _this.channel1OrNull;
                    t3 = A.fuzzyHashCode(t3 == null ? 0 : t3);
                    t4 = _this.channel2OrNull;
                    t4 = A.fuzzyHashCode(t4 == null ? 0 : t4);
                    t5 = _this.alphaOrNull;
                    return (t1 ^ t2 ^ t3 ^ t4 ^ A.fuzzyHashCode(t5 == null ? 0 : t5)) >>> 0;
                }
            }
        };
        A.SassColor$_forSpace_closure.prototype = {
            call$1: function(alpha) {
                return A.fuzzyAssertRange(alpha, 0, 1, "alpha");
            },
            $signature: 12
        };
        A._ColorFormatEnum.prototype = {
            toString$0: function(_) {
                return "rgbFunction";
            }
        };
        A.SpanColorFormat.prototype = {};
        A.ColorChannel.prototype = {
            isAnalogous$1: function(other) {
                var _0_6_isSet, t1, _0_60, t2, _0_6_isSet0, _0_1 = this.name, _0_6 = other.name;
                $label0$0: {
                    if ("red" !== _0_1) _0_6_isSet = "x" === _0_1;
                    else _0_6_isSet = true;
                    if (_0_6_isSet) {
                        if ("red" !== _0_6) t1 = "x" === _0_6;
                        else t1 = true;
                        _0_60 = _0_6;
                    } else {
                        _0_60 = null;
                        t1 = false;
                    }
                    t2 = true;
                    if (!t1) {
                        if ("green" !== _0_1) t1 = "y" === _0_1;
                        else t1 = true;
                        if (t1) {
                            _0_6_isSet0 = true;
                            if (_0_6_isSet) t1 = _0_60;
                            else {
                                t1 = _0_6;
                                _0_6_isSet = _0_6_isSet0;
                                _0_60 = t1;
                            }
                            if ("green" !== t1) {
                                if (_0_6_isSet) t1 = _0_60;
                                else {
                                    t1 = _0_6;
                                    _0_6_isSet = _0_6_isSet0;
                                    _0_60 = t1;
                                }
                                t1 = "y" === t1;
                            } else t1 = true;
                        } else t1 = false;
                        if (!t1) {
                            if ("blue" !== _0_1) t1 = "z" === _0_1;
                            else t1 = true;
                            if (t1) {
                                _0_6_isSet0 = true;
                                if (_0_6_isSet) t1 = _0_60;
                                else {
                                    t1 = _0_6;
                                    _0_6_isSet = _0_6_isSet0;
                                    _0_60 = t1;
                                }
                                if ("blue" !== t1) {
                                    if (_0_6_isSet) t1 = _0_60;
                                    else {
                                        t1 = _0_6;
                                        _0_6_isSet = _0_6_isSet0;
                                        _0_60 = t1;
                                    }
                                    t1 = "z" === t1;
                                } else t1 = true;
                            } else t1 = false;
                            if (!t1) {
                                if ("chroma" !== _0_1) t1 = "saturation" === _0_1;
                                else t1 = true;
                                if (t1) {
                                    _0_6_isSet0 = true;
                                    if (_0_6_isSet) t1 = _0_60;
                                    else {
                                        t1 = _0_6;
                                        _0_6_isSet = _0_6_isSet0;
                                        _0_60 = t1;
                                    }
                                    if ("chroma" !== t1) {
                                        if (_0_6_isSet) t1 = _0_60;
                                        else {
                                            t1 = _0_6;
                                            _0_6_isSet = _0_6_isSet0;
                                            _0_60 = t1;
                                        }
                                        t1 = "saturation" === t1;
                                    } else t1 = true;
                                } else t1 = false;
                                if (!t1) {
                                    if ("lightness" === _0_1) {
                                        if (_0_6_isSet) t1 = _0_60;
                                        else {
                                            t1 = _0_6;
                                            _0_60 = t1;
                                            _0_6_isSet = true;
                                        }
                                        t1 = "lightness" === t1;
                                    } else t1 = false;
                                    if (!t1) {
                                        if ("hue" === _0_1) t1 = "hue" === (_0_6_isSet ? _0_60 : _0_6);
                                        else t1 = false;
                                    } else t1 = t2;
                                } else t1 = t2;
                            } else t1 = t2;
                        } else t1 = t2;
                    } else t1 = t2;
                    break $label0$0;
                }
                return t1;
            }
        };
        A.LinearChannel.prototype = {};
        A.GamutMapMethod.prototype = {
            toString$0: function(_) {
                return this.name;
            }
        };
        A.ClipGamutMap.prototype = {
            map$1: function(_, color) {
                var t1 = color._space, t2 = t1._channels;
                return A.SassColor_SassColor$forSpaceInternal(t1, this._clampChannel$2(color.channel0OrNull, t2[0]), this._clampChannel$2(color.channel1OrNull, t2[1]), this._clampChannel$2(color.channel2OrNull, t2[2]), color.alphaOrNull);
            },
            _clampChannel$2: function(value, channel) {
                var t1, min;
                if (value == null) t1 = null;
                else $label0$0: {
                    if (channel instanceof A.LinearChannel) {
                        min = channel.min;
                        t1 = isNaN(value) ? min : B.JSNumber_methods.clamp$2(value, min, channel.max);
                        break $label0$0;
                    }
                    t1 = value;
                    break $label0$0;
                }
                return t1;
            }
        };
        A.LocalMindeGamutMap.prototype = {
            map$1: function(_, color) {
                var clipped, max, min, minInGamut, chroma, current, e, originOklch = color.toSpace$1(B.OklchColorSpace_9Gj), lightness = originOklch.channel0OrNull, hue = originOklch.channel2OrNull, alpha = originOklch.alphaOrNull, t1 = lightness == null, t2 = t1 ? 0 : lightness;
                if (t2 > 1 || A.fuzzyEquals(t2, 1)) {
                    t1 = color._space;
                    t2 = color.alphaOrNull;
                    return t1.get$isLegacyInternal() ? A.SassColor_SassColor$rgbInternal(255, 255, 255, t2, null).toSpace$1(t1) : A.SassColor_SassColor$forSpaceInternal(t1, 1, 1, 1, t2);
                } else {
                    t1 = t1 ? 0 : lightness;
                    if (t1 < 0 || A.fuzzyEquals(t1, 0)) return A.SassColor_SassColor$rgbInternal(0, 0, 0, color.alphaOrNull, null).toSpace$1(color._space);
                }
                clipped = color.get$isInGamut() ? color : B.ClipGamutMap_clip.map$1(0, color);
                if (this._deltaEOK$2(clipped, color) < 0.02) return clipped;
                max = originOklch.channel1OrNull;
                if (max == null) max = 0;
                for(t1 = color._space, min = 0, minInGamut = true; max - min > 0.0001;){
                    chroma = (min + max) / 2;
                    current = B.OklchColorSpace_9Gj.convert$5(t1, lightness, chroma, hue, alpha);
                    if (minInGamut && current.get$isInGamut()) {
                        min = chroma;
                        continue;
                    }
                    clipped = current.get$isInGamut() ? current : B.ClipGamutMap_clip.map$1(0, current);
                    e = this._deltaEOK$2(clipped, current);
                    if (e < 0.02) {
                        if (0.02 - e < 0.0001) return clipped;
                        min = chroma;
                        minInGamut = false;
                    } else max = chroma;
                }
                return clipped;
            },
            _deltaEOK$2: function(color1, color2) {
                var t2, t3, t4, lab1 = color1.toSpace$1(B.OklabColorSpace_540), lab2 = color2.toSpace$1(B.OklabColorSpace_540), t1 = lab1.channel0OrNull;
                if (t1 == null) t1 = 0;
                t2 = lab2.channel0OrNull;
                t1 = Math.pow(t1 - (t2 == null ? 0 : t2), 2);
                t2 = lab1.channel1OrNull;
                if (t2 == null) t2 = 0;
                t3 = lab2.channel1OrNull;
                t2 = Math.pow(t2 - (t3 == null ? 0 : t3), 2);
                t3 = lab1.channel2OrNull;
                if (t3 == null) t3 = 0;
                t4 = lab2.channel2OrNull;
                return Math.sqrt(t1 + t2 + Math.pow(t3 - (t4 == null ? 0 : t4), 2));
            }
        };
        A.InterpolationMethod.prototype = {
            toString$0: function(_) {
                var t1 = this.hue;
                t1 = t1 == null ? "" : " " + t1.toString$0(0) + " hue";
                return this.space.name + t1;
            }
        };
        A.HueInterpolationMethod.prototype = {
            _enumToString$0: function() {
                return "HueInterpolationMethod." + this._name;
            }
        };
        A.ColorSpace.prototype = {
            get$isLegacyInternal: function() {
                return false;
            },
            get$isPolarInternal: function() {
                return false;
            },
            convert$5: function(dest, channel0, channel1, channel2, alpha) {
                return this.convertLinear$5(dest, channel0, channel1, channel2, alpha);
            },
            convertLinear$10$missingA$missingB$missingChroma$missingHue$missingLightness: function(dest, red, green, blue, alpha, missingA, missingB, missingChroma, missingHue, missingLightness) {
                var t1, t2, transformedBlue, transformedGreen, transformedRed, linearRed, linearGreen, linearBlue, matrix, _this = this;
                $label0$0: {
                    t1 = B.HslColorSpace_JQ2 !== dest;
                    if (!t1 || B.HwbColorSpace_guQ === dest) {
                        t2 = B.SrgbColorSpace_thf;
                        break $label0$0;
                    }
                    if (B.LabColorSpace_2nT === dest || B.LchColorSpace_Bpv === dest) {
                        t2 = B.XyzD50ColorSpace_2OB;
                        break $label0$0;
                    }
                    if (B.OklabColorSpace_540 === dest || B.OklchColorSpace_9Gj === dest) {
                        t2 = B.LmsColorSpace_Os3;
                        break $label0$0;
                    }
                    t2 = dest;
                    break $label0$0;
                }
                if (t2 === _this) {
                    transformedBlue = blue;
                    transformedGreen = green;
                    transformedRed = red;
                } else {
                    linearRed = _this.toLinear$1(red == null ? 0 : red);
                    linearGreen = _this.toLinear$1(green == null ? 0 : green);
                    linearBlue = _this.toLinear$1(blue == null ? 0 : blue);
                    matrix = _this.transformationMatrix$1(t2);
                    transformedRed = t2.fromLinear$1(matrix[0] * linearRed + matrix[1] * linearGreen + matrix[2] * linearBlue);
                    transformedGreen = t2.fromLinear$1(matrix[3] * linearRed + matrix[4] * linearGreen + matrix[5] * linearBlue);
                    transformedBlue = t2.fromLinear$1(matrix[6] * linearRed + matrix[7] * linearGreen + matrix[8] * linearBlue);
                }
                $label1$1: {
                    if (!t1 || B.HwbColorSpace_guQ === dest) {
                        t1 = B.SrgbColorSpace_thf.convert$8$missingChroma$missingHue$missingLightness(dest, transformedRed, transformedGreen, transformedBlue, alpha, missingChroma, missingHue, missingLightness);
                        break $label1$1;
                    }
                    if (B.LabColorSpace_2nT === dest || B.LchColorSpace_Bpv === dest) {
                        t1 = B.XyzD50ColorSpace_2OB.convert$10$missingA$missingB$missingChroma$missingHue$missingLightness(dest, transformedRed, transformedGreen, transformedBlue, alpha, missingA, missingB, missingChroma, missingHue, missingLightness);
                        break $label1$1;
                    }
                    if (B.OklabColorSpace_540 === dest || B.OklchColorSpace_9Gj === dest) {
                        t1 = B.LmsColorSpace_Os3.convert$10$missingA$missingB$missingChroma$missingHue$missingLightness(dest, transformedRed, transformedGreen, transformedBlue, alpha, missingA, missingB, missingChroma, missingHue, missingLightness);
                        break $label1$1;
                    }
                    t1 = red == null ? null : transformedRed;
                    t2 = green == null ? null : transformedGreen;
                    t1 = A.SassColor_SassColor$forSpaceInternal(dest, t1, t2, blue == null ? null : transformedBlue, alpha);
                    break $label1$1;
                }
                return t1;
            },
            convertLinear$5: function(dest, red, green, blue, alpha) {
                return this.convertLinear$10$missingA$missingB$missingChroma$missingHue$missingLightness(dest, red, green, blue, alpha, false, false, false, false, false);
            },
            toLinear$1: function(channel) {
                return A.throwExpression(A.UnimplementedError$("[BUG] Color space " + this.toString$0(0) + " doesn't support linear conversions."));
            },
            fromLinear$1: function(channel) {
                return A.throwExpression(A.UnimplementedError$("[BUG] Color space " + this.toString$0(0) + " doesn't support linear conversions."));
            },
            transformationMatrix$1: function(dest) {
                return A.throwExpression(A.UnimplementedError$("[BUG] Color space conversion from " + this.toString$0(0) + " to " + dest.toString$0(0) + " not implemented."));
            },
            toString$0: function(_) {
                return this.name;
            }
        };
        A.A98RgbColorSpace.prototype = {
            get$isBoundedInternal: function() {
                return true;
            },
            toLinear$1: function(channel) {
                return J.get$sign$in(channel) * Math.pow(Math.abs(channel), 2.19921875);
            },
            fromLinear$1: function(channel) {
                return J.get$sign$in(channel) * Math.pow(Math.abs(channel), 0.4547069271758437);
            },
            transformationMatrix$1: function(dest) {
                var t1;
                $label0$0: {
                    if (B.SrgbLinearColorSpace_kUj === dest || B.SrgbColorSpace_thf === dest || B.RgbColorSpace_i0P === dest) {
                        t1 = $.$get$linearA98RgbToLinearSrgb();
                        break $label0$0;
                    }
                    if (B.DisplayP3ColorSpace_MmT === dest || B.DisplayP3LinearColorSpace_PrP === dest) {
                        t1 = $.$get$linearA98RgbToLinearDisplayP3();
                        break $label0$0;
                    }
                    if (B.ProphotoRgbColorSpace_BDz === dest) {
                        t1 = $.$get$linearA98RgbToLinearProphotoRgb();
                        break $label0$0;
                    }
                    if (B.Rec2020ColorSpace_6oo === dest) {
                        t1 = $.$get$linearA98RgbToLinearRec2020();
                        break $label0$0;
                    }
                    if (B.XyzD65ColorSpace_WiJ === dest) {
                        t1 = $.$get$linearA98RgbToXyzD65();
                        break $label0$0;
                    }
                    if (B.XyzD50ColorSpace_2OB === dest) {
                        t1 = $.$get$linearA98RgbToXyzD50();
                        break $label0$0;
                    }
                    if (B.LmsColorSpace_Os3 === dest) {
                        t1 = $.$get$linearA98RgbToLms();
                        break $label0$0;
                    }
                    t1 = this.super$ColorSpace$transformationMatrix(dest);
                    break $label0$0;
                }
                return t1;
            }
        };
        A.DisplayP3ColorSpace.prototype = {
            get$isBoundedInternal: function() {
                return true;
            },
            convert$5: function(dest, red, green, blue, alpha) {
                var t1;
                if (dest === B.DisplayP3LinearColorSpace_PrP) {
                    t1 = this.get$toLinear();
                    t1 = A.SassColor_SassColor$forSpaceInternal(dest, A.NullableExtension_andThen(red, t1), A.NullableExtension_andThen(green, t1), A.NullableExtension_andThen(blue, t1), alpha);
                } else t1 = this.super$ColorSpace$convertLinear(dest, red, green, blue, alpha, false, false, false, false, false);
                return t1;
            },
            toLinear$1: function(channel) {
                return A.srgbAndDisplayP3ToLinear(channel);
            },
            fromLinear$1: function(channel) {
                return A.srgbAndDisplayP3FromLinear(channel);
            },
            transformationMatrix$1: function(dest) {
                var t1;
                $label0$0: {
                    if (B.SrgbLinearColorSpace_kUj === dest || B.SrgbColorSpace_thf === dest || B.RgbColorSpace_i0P === dest) {
                        t1 = $.$get$linearDisplayP3ToLinearSrgb();
                        break $label0$0;
                    }
                    if (B.A98RgbColorSpace_lf2 === dest) {
                        t1 = $.$get$linearDisplayP3ToLinearA98Rgb();
                        break $label0$0;
                    }
                    if (B.ProphotoRgbColorSpace_BDz === dest) {
                        t1 = $.$get$linearDisplayP3ToLinearProphotoRgb();
                        break $label0$0;
                    }
                    if (B.Rec2020ColorSpace_6oo === dest) {
                        t1 = $.$get$linearDisplayP3ToLinearRec2020();
                        break $label0$0;
                    }
                    if (B.XyzD65ColorSpace_WiJ === dest) {
                        t1 = $.$get$linearDisplayP3ToXyzD65();
                        break $label0$0;
                    }
                    if (B.XyzD50ColorSpace_2OB === dest) {
                        t1 = $.$get$linearDisplayP3ToXyzD50();
                        break $label0$0;
                    }
                    if (B.LmsColorSpace_Os3 === dest) {
                        t1 = $.$get$linearDisplayP3ToLms();
                        break $label0$0;
                    }
                    t1 = this.super$ColorSpace$transformationMatrix(dest);
                    break $label0$0;
                }
                return t1;
            }
        };
        A.DisplayP3LinearColorSpace.prototype = {
            get$isBoundedInternal: function() {
                return true;
            },
            convert$5: function(dest, red, green, blue, alpha) {
                return dest === B.DisplayP3ColorSpace_MmT ? A.SassColor_SassColor$forSpaceInternal(dest, A.NullableExtension_andThen(red, A.utils0__srgbAndDisplayP3FromLinear$closure()), A.NullableExtension_andThen(green, A.utils0__srgbAndDisplayP3FromLinear$closure()), A.NullableExtension_andThen(blue, A.utils0__srgbAndDisplayP3FromLinear$closure()), alpha) : this.super$ColorSpace$convert(dest, red, green, blue, alpha);
            },
            toLinear$1: function(channel) {
                return channel;
            },
            fromLinear$1: function(channel) {
                return channel;
            },
            transformationMatrix$1: function(dest) {
                var t1;
                $label0$0: {
                    if (B.SrgbLinearColorSpace_kUj === dest || B.SrgbColorSpace_thf === dest || B.RgbColorSpace_i0P === dest) {
                        t1 = $.$get$linearDisplayP3ToLinearSrgb();
                        break $label0$0;
                    }
                    if (B.A98RgbColorSpace_lf2 === dest) {
                        t1 = $.$get$linearDisplayP3ToLinearA98Rgb();
                        break $label0$0;
                    }
                    if (B.ProphotoRgbColorSpace_BDz === dest) {
                        t1 = $.$get$linearDisplayP3ToLinearProphotoRgb();
                        break $label0$0;
                    }
                    if (B.Rec2020ColorSpace_6oo === dest) {
                        t1 = $.$get$linearDisplayP3ToLinearRec2020();
                        break $label0$0;
                    }
                    if (B.XyzD65ColorSpace_WiJ === dest) {
                        t1 = $.$get$linearDisplayP3ToXyzD65();
                        break $label0$0;
                    }
                    if (B.XyzD50ColorSpace_2OB === dest) {
                        t1 = $.$get$linearDisplayP3ToXyzD50();
                        break $label0$0;
                    }
                    if (B.LmsColorSpace_Os3 === dest) {
                        t1 = $.$get$linearDisplayP3ToLms();
                        break $label0$0;
                    }
                    t1 = this.super$ColorSpace$transformationMatrix(dest);
                    break $label0$0;
                }
                return t1;
            }
        };
        A.HslColorSpace.prototype = {
            get$isBoundedInternal: function() {
                return true;
            },
            get$isLegacyInternal: function() {
                return true;
            },
            get$isPolarInternal: function() {
                return true;
            },
            convert$5: function(dest, hue, saturation, lightness, alpha) {
                var t1 = hue == null, scaledHue = B.JSNumber_methods.$mod((t1 ? 0 : hue) / 360, 1), t2 = saturation == null, scaledSaturation = (t2 ? 0 : saturation) / 100, t3 = lightness == null, scaledLightness = (t3 ? 0 : lightness) / 100, m2 = scaledLightness <= 0.5 ? scaledLightness * (scaledSaturation + 1) : scaledLightness + scaledSaturation - scaledLightness * scaledSaturation, m1 = scaledLightness * 2 - m2;
                return B.SrgbColorSpace_thf.convert$8$missingChroma$missingHue$missingLightness(dest, A.hueToRgb(m1, m2, scaledHue + 0.3333333333333333), A.hueToRgb(m1, m2, scaledHue), A.hueToRgb(m1, m2, scaledHue - 0.3333333333333333), alpha, t2, t1, t3);
            }
        };
        A.HwbColorSpace.prototype = {
            get$isBoundedInternal: function() {
                return true;
            },
            get$isLegacyInternal: function() {
                return true;
            },
            get$isPolarInternal: function() {
                return true;
            },
            convert$5: function(dest, hue, whiteness, blackness, alpha) {
                var t3, t1 = {}, t2 = hue == null, scaledHue = B.JSNumber_methods.$mod(t2 ? 0 : hue, 360) / 360, scaledWhiteness = t1.scaledWhiteness = (whiteness == null ? 0 : whiteness) / 100, scaledBlackness = (blackness == null ? 0 : blackness) / 100, sum = scaledWhiteness + scaledBlackness;
                if (sum > 1) {
                    t3 = t1.scaledWhiteness = scaledWhiteness / sum;
                    scaledBlackness /= sum;
                } else t3 = scaledWhiteness;
                t3 = new A.HwbColorSpace_convert_toRgb(t1, 1 - t3 - scaledBlackness);
                return B.SrgbColorSpace_thf.convert$6$missingHue(dest, t3.call$1(scaledHue + 0.3333333333333333), t3.call$1(scaledHue), t3.call$1(scaledHue - 0.3333333333333333), alpha, t2);
            }
        };
        A.HwbColorSpace_convert_toRgb.prototype = {
            call$1: function(hue) {
                return A.hueToRgb(0, 1, hue) * this.factor + this._box_0.scaledWhiteness;
            },
            $signature: 12
        };
        A.LabColorSpace.prototype = {
            get$isBoundedInternal: function() {
                return false;
            },
            convert$7$missingChroma$missingHue: function(dest, lightness, a, b, alpha, missingChroma, missingHue) {
                var powerlessAB, t1, missingLightness, f1, t2, t3, t4;
                switch(dest){
                    case B.LabColorSpace_2nT:
                        powerlessAB = lightness == null || A.fuzzyEquals(lightness, 0);
                        t1 = a == null || powerlessAB ? null : a;
                        return A.SassColor$_forSpace(B.LabColorSpace_2nT, lightness, t1, b == null || powerlessAB ? null : b, alpha, null);
                    case B.LchColorSpace_Bpv:
                        return A.labToLch(dest, lightness, a, b, alpha, false, false);
                    default:
                        missingLightness = lightness == null;
                        if (missingLightness) lightness = 0;
                        f1 = (lightness + 16) / 116;
                        t1 = a == null;
                        t2 = this._convertFToXorZ$1((t1 ? 0 : a) / 500 + f1);
                        t3 = lightness > 8 ? Math.pow(f1, 3) : lightness / 903.2962962962963;
                        t4 = b == null;
                        return B.XyzD50ColorSpace_2OB.convert$10$missingA$missingB$missingChroma$missingHue$missingLightness(dest, t2 * 0.9642956764295677, t3, this._convertFToXorZ$1(f1 - (t4 ? 0 : b) / 200) * 0.8251046025104602, alpha, t1, t4, missingChroma, missingHue, missingLightness);
                }
            },
            convert$5: function(dest, lightness, a, b, alpha) {
                return this.convert$7$missingChroma$missingHue(dest, lightness, a, b, alpha, false, false);
            },
            _convertFToXorZ$1: function(component) {
                var cubed = Math.pow(component, 3) + 0;
                return cubed > 0.008856451679035631 ? cubed : (116 * component - 16) / 903.2962962962963;
            }
        };
        A.LchColorSpace.prototype = {
            get$isBoundedInternal: function() {
                return false;
            },
            get$isPolarInternal: function() {
                return true;
            },
            convert$5: function(dest, lightness, chroma, hue, alpha) {
                var t1 = hue == null, hueRadians = (t1 ? 0 : hue) * 3.141592653589793 / 180, t2 = chroma == null, t3 = t2 ? 0 : chroma, t4 = Math.cos(hueRadians), t5 = t2 ? 0 : chroma;
                return B.LabColorSpace_2nT.convert$7$missingChroma$missingHue(dest, lightness, t3 * t4, t5 * Math.sin(hueRadians), alpha, t2, t1);
            }
        };
        A.LmsColorSpace.prototype = {
            get$isBoundedInternal: function() {
                return false;
            },
            convert$10$missingA$missingB$missingChroma$missingHue$missingLightness: function(dest, long, medium, short, alpha, missingA, missingB, missingChroma, missingHue, missingLightness) {
                var t1, longScaled, mediumScaled, shortScaled, lightness, t2, t3, _null = null;
                switch(dest){
                    case B.OklabColorSpace_540:
                        t1 = long == null ? 0 : long;
                        longScaled = Math.pow(Math.abs(t1), 0.3333333333333333) * J.get$sign$in(t1);
                        t1 = medium == null ? 0 : medium;
                        mediumScaled = Math.pow(Math.abs(t1), 0.3333333333333333) * J.get$sign$in(t1);
                        t1 = short == null ? 0 : short;
                        shortScaled = Math.pow(Math.abs(t1), 0.3333333333333333) * J.get$sign$in(t1);
                        t1 = $.$get$lmsToOklab();
                        lightness = t1[0] * longScaled + t1[1] * mediumScaled + t1[2] * shortScaled;
                        t2 = missingLightness ? _null : lightness;
                        t3 = missingA ? _null : t1[3] * longScaled + t1[4] * mediumScaled + t1[5] * shortScaled;
                        return A.SassColor$_forSpace(B.OklabColorSpace_540, t2, t3, missingB ? _null : t1[6] * longScaled + t1[7] * mediumScaled + t1[8] * shortScaled, alpha, _null);
                    case B.OklchColorSpace_9Gj:
                        t1 = long == null ? 0 : long;
                        longScaled = Math.pow(Math.abs(t1), 0.3333333333333333) * J.get$sign$in(t1);
                        t1 = medium == null ? 0 : medium;
                        mediumScaled = Math.pow(Math.abs(t1), 0.3333333333333333) * J.get$sign$in(t1);
                        t1 = short == null ? 0 : short;
                        shortScaled = Math.pow(Math.abs(t1), 0.3333333333333333) * J.get$sign$in(t1);
                        if (missingLightness) t1 = _null;
                        else {
                            t1 = $.$get$lmsToOklab();
                            t1 = t1[0] * longScaled + t1[1] * mediumScaled + t1[2] * shortScaled;
                        }
                        t2 = $.$get$lmsToOklab();
                        return A.labToLch(dest, t1, t2[3] * longScaled + t2[4] * mediumScaled + t2[5] * shortScaled, t2[6] * longScaled + t2[7] * mediumScaled + t2[8] * shortScaled, alpha, missingChroma, missingHue);
                    default:
                        return this.super$ColorSpace$convertLinear(dest, long, medium, short, alpha, missingA, missingB, missingChroma, missingHue, missingLightness);
                }
            },
            convert$5: function(dest, long, medium, short, alpha) {
                return this.convert$10$missingA$missingB$missingChroma$missingHue$missingLightness(dest, long, medium, short, alpha, false, false, false, false, false);
            },
            toLinear$1: function(channel) {
                return channel;
            },
            fromLinear$1: function(channel) {
                return channel;
            },
            transformationMatrix$1: function(dest) {
                var t1;
                $label0$0: {
                    if (B.SrgbLinearColorSpace_kUj === dest || B.SrgbColorSpace_thf === dest || B.RgbColorSpace_i0P === dest) {
                        t1 = $.$get$lmsToLinearSrgb();
                        break $label0$0;
                    }
                    if (B.A98RgbColorSpace_lf2 === dest) {
                        t1 = $.$get$lmsToLinearA98Rgb();
                        break $label0$0;
                    }
                    if (B.ProphotoRgbColorSpace_BDz === dest) {
                        t1 = $.$get$lmsToLinearProphotoRgb();
                        break $label0$0;
                    }
                    if (B.DisplayP3ColorSpace_MmT === dest || B.DisplayP3LinearColorSpace_PrP === dest) {
                        t1 = $.$get$lmsToLinearDisplayP3();
                        break $label0$0;
                    }
                    if (B.Rec2020ColorSpace_6oo === dest) {
                        t1 = $.$get$lmsToLinearRec2020();
                        break $label0$0;
                    }
                    if (B.XyzD65ColorSpace_WiJ === dest) {
                        t1 = $.$get$lmsToXyzD65();
                        break $label0$0;
                    }
                    if (B.XyzD50ColorSpace_2OB === dest) {
                        t1 = $.$get$lmsToXyzD50();
                        break $label0$0;
                    }
                    t1 = this.super$ColorSpace$transformationMatrix(dest);
                    break $label0$0;
                }
                return t1;
            }
        };
        A.OklabColorSpace.prototype = {
            get$isBoundedInternal: function() {
                return false;
            },
            convert$7$missingChroma$missingHue: function(dest, lightness, a, b, alpha, missingChroma, missingHue) {
                var missingLightness, missingA, missingB, t1;
                if (dest === B.OklchColorSpace_9Gj) return A.labToLch(dest, lightness, a, b, alpha, missingChroma, missingHue);
                missingLightness = lightness == null;
                missingA = a == null;
                missingB = b == null;
                if (missingLightness) lightness = 0;
                if (missingA) a = 0;
                if (missingB) b = 0;
                t1 = $.$get$oklabToLms();
                return B.LmsColorSpace_Os3.convert$10$missingA$missingB$missingChroma$missingHue$missingLightness(dest, Math.pow(t1[0] * lightness + t1[1] * a + t1[2] * b, 3) + 0, Math.pow(t1[3] * lightness + t1[4] * a + t1[5] * b, 3) + 0, Math.pow(t1[6] * lightness + t1[7] * a + t1[8] * b, 3) + 0, alpha, missingA, missingB, missingChroma, missingHue, missingLightness);
            },
            convert$5: function(dest, lightness, a, b, alpha) {
                return this.convert$7$missingChroma$missingHue(dest, lightness, a, b, alpha, false, false);
            }
        };
        A.OklchColorSpace.prototype = {
            get$isBoundedInternal: function() {
                return false;
            },
            get$isPolarInternal: function() {
                return true;
            },
            convert$5: function(dest, lightness, chroma, hue, alpha) {
                var t1 = hue == null, hueRadians = (t1 ? 0 : hue) * 3.141592653589793 / 180, t2 = chroma == null, t3 = t2 ? 0 : chroma, t4 = Math.cos(hueRadians), t5 = t2 ? 0 : chroma;
                return B.OklabColorSpace_540.convert$7$missingChroma$missingHue(dest, lightness, t3 * t4, t5 * Math.sin(hueRadians), alpha, t2, t1);
            }
        };
        A.ProphotoRgbColorSpace.prototype = {
            get$isBoundedInternal: function() {
                return true;
            },
            toLinear$1: function(channel) {
                var abs = Math.abs(channel);
                return abs <= 0.03125 ? channel / 16 : J.get$sign$in(channel) * Math.pow(abs, 1.8);
            },
            fromLinear$1: function(channel) {
                var abs = Math.abs(channel);
                return abs >= 0.001953125 ? J.get$sign$in(channel) * Math.pow(abs, 0.5555555555555556) : 16 * channel;
            },
            transformationMatrix$1: function(dest) {
                var t1;
                $label0$0: {
                    if (B.SrgbLinearColorSpace_kUj === dest || B.SrgbColorSpace_thf === dest || B.RgbColorSpace_i0P === dest) {
                        t1 = $.$get$linearProphotoRgbToLinearSrgb();
                        break $label0$0;
                    }
                    if (B.A98RgbColorSpace_lf2 === dest) {
                        t1 = $.$get$linearProphotoRgbToLinearA98Rgb();
                        break $label0$0;
                    }
                    if (B.DisplayP3ColorSpace_MmT === dest || B.DisplayP3LinearColorSpace_PrP === dest) {
                        t1 = $.$get$linearProphotoRgbToLinearDisplayP3();
                        break $label0$0;
                    }
                    if (B.Rec2020ColorSpace_6oo === dest) {
                        t1 = $.$get$linearProphotoRgbToLinearRec2020();
                        break $label0$0;
                    }
                    if (B.XyzD65ColorSpace_WiJ === dest) {
                        t1 = $.$get$linearProphotoRgbToXyzD65();
                        break $label0$0;
                    }
                    if (B.XyzD50ColorSpace_2OB === dest) {
                        t1 = $.$get$linearProphotoRgbToXyzD50();
                        break $label0$0;
                    }
                    if (B.LmsColorSpace_Os3 === dest) {
                        t1 = $.$get$linearProphotoRgbToLms();
                        break $label0$0;
                    }
                    t1 = this.super$ColorSpace$transformationMatrix(dest);
                    break $label0$0;
                }
                return t1;
            }
        };
        A.Rec2020ColorSpace.prototype = {
            get$isBoundedInternal: function() {
                return true;
            },
            toLinear$1: function(channel) {
                var abs = Math.abs(channel);
                return abs < 0.08124285829863151 ? channel / 4.5 : J.get$sign$in(channel) * Math.pow((abs + 1.09929682680944 - 1) / 1.09929682680944, 2.2222222222222223);
            },
            fromLinear$1: function(channel) {
                var abs = Math.abs(channel);
                return abs > 0.018053968510807 ? J.get$sign$in(channel) * (1.09929682680944 * Math.pow(abs, 0.45) - 0.09929682680944008) : 4.5 * channel;
            },
            transformationMatrix$1: function(dest) {
                var t1;
                $label0$0: {
                    if (B.SrgbLinearColorSpace_kUj === dest || B.SrgbColorSpace_thf === dest || B.RgbColorSpace_i0P === dest) {
                        t1 = $.$get$linearRec2020ToLinearSrgb();
                        break $label0$0;
                    }
                    if (B.A98RgbColorSpace_lf2 === dest) {
                        t1 = $.$get$linearRec2020ToLinearA98Rgb();
                        break $label0$0;
                    }
                    if (B.DisplayP3ColorSpace_MmT === dest || B.DisplayP3LinearColorSpace_PrP === dest) {
                        t1 = $.$get$linearRec2020ToLinearDisplayP3();
                        break $label0$0;
                    }
                    if (B.ProphotoRgbColorSpace_BDz === dest) {
                        t1 = $.$get$linearRec2020ToLinearProphotoRgb();
                        break $label0$0;
                    }
                    if (B.XyzD65ColorSpace_WiJ === dest) {
                        t1 = $.$get$linearRec2020ToXyzD65();
                        break $label0$0;
                    }
                    if (B.XyzD50ColorSpace_2OB === dest) {
                        t1 = $.$get$linearRec2020ToXyzD50();
                        break $label0$0;
                    }
                    if (B.LmsColorSpace_Os3 === dest) {
                        t1 = $.$get$linearRec2020ToLms();
                        break $label0$0;
                    }
                    t1 = this.super$ColorSpace$transformationMatrix(dest);
                    break $label0$0;
                }
                return t1;
            }
        };
        A.RgbColorSpace.prototype = {
            get$isBoundedInternal: function() {
                return true;
            },
            get$isLegacyInternal: function() {
                return true;
            },
            convert$5: function(dest, red, green, blue, alpha) {
                var t1 = red == null ? null : red / 255, t2 = green == null ? null : green / 255;
                return B.SrgbColorSpace_thf.convert$5(dest, t1, t2, blue == null ? null : blue / 255, alpha);
            },
            toLinear$1: function(channel) {
                return A.srgbAndDisplayP3ToLinear(channel / 255);
            },
            fromLinear$1: function(channel) {
                return A.srgbAndDisplayP3FromLinear(channel) * 255;
            }
        };
        A.SrgbColorSpace.prototype = {
            get$isBoundedInternal: function() {
                return true;
            },
            convert$8$missingChroma$missingHue$missingLightness: function(dest, red, green, blue, alpha, missingChroma, missingHue, missingLightness) {
                var max, min, delta, hue, lightness, saturation, t1, t2, whiteness, blackness, _null = null;
                if (B.HslColorSpace_JQ2 === dest || B.HwbColorSpace_guQ === dest) {
                    if (red == null) red = 0;
                    if (green == null) green = 0;
                    if (blue == null) blue = 0;
                    max = Math.max(Math.max(red, green), blue);
                    min = Math.min(Math.min(red, green), blue);
                    delta = max - min;
                    if (max === min) hue = 0;
                    else if (max === red) hue = 60 * (green - blue) / delta + 360;
                    else hue = max === green ? 60 * (blue - red) / delta + 120 : 60 * (red - green) / delta + 240;
                    if (dest === B.HslColorSpace_JQ2) {
                        lightness = (min + max) / 2;
                        saturation = lightness === 0 || lightness === 1 ? 0 : 100 * (max - lightness) / Math.min(lightness, 1 - lightness);
                        if (saturation < 0) {
                            hue += 180;
                            saturation = Math.abs(saturation);
                        }
                        t1 = missingHue || A.fuzzyEquals(saturation, 0) ? _null : B.JSNumber_methods.$mod(hue, 360);
                        t2 = missingChroma ? _null : saturation;
                        return A.SassColor_SassColor$forSpaceInternal(dest, t1, t2, missingLightness ? _null : lightness * 100, alpha);
                    } else {
                        whiteness = min * 100;
                        blackness = 100 - max * 100;
                        if (!missingHue) {
                            t1 = whiteness + blackness;
                            t1 = t1 > 100 || A.fuzzyEquals(t1, 100);
                        } else t1 = true;
                        return A.SassColor_SassColor$forSpaceInternal(dest, t1 ? _null : B.JSNumber_methods.$mod(hue, 360), whiteness, blackness, alpha);
                    }
                }
                if (B.RgbColorSpace_i0P === dest) {
                    t1 = red == null ? _null : red * 255;
                    t2 = green == null ? _null : green * 255;
                    return A.SassColor_SassColor$rgbInternal(t1, t2, blue == null ? _null : blue * 255, alpha, _null);
                }
                if (B.SrgbLinearColorSpace_kUj === dest) {
                    t1 = this.get$toLinear();
                    return A.SassColor_SassColor$forSpaceInternal(dest, A.NullableExtension_andThen(red, t1), A.NullableExtension_andThen(green, t1), A.NullableExtension_andThen(blue, t1), alpha);
                }
                return this.super$ColorSpace$convertLinear(dest, red, green, blue, alpha, false, false, missingChroma, missingHue, missingLightness);
            },
            convert$5: function(dest, red, green, blue, alpha) {
                return this.convert$8$missingChroma$missingHue$missingLightness(dest, red, green, blue, alpha, false, false, false);
            },
            convert$6$missingHue: function(dest, red, green, blue, alpha, missingHue) {
                return this.convert$8$missingChroma$missingHue$missingLightness(dest, red, green, blue, alpha, false, missingHue, false);
            },
            toLinear$1: function(channel) {
                return A.srgbAndDisplayP3ToLinear(channel);
            },
            fromLinear$1: function(channel) {
                return A.srgbAndDisplayP3FromLinear(channel);
            },
            transformationMatrix$1: function(dest) {
                var t1;
                $label0$0: {
                    if (B.DisplayP3ColorSpace_MmT === dest || B.DisplayP3LinearColorSpace_PrP === dest) {
                        t1 = $.$get$linearSrgbToLinearDisplayP3();
                        break $label0$0;
                    }
                    if (B.A98RgbColorSpace_lf2 === dest) {
                        t1 = $.$get$linearSrgbToLinearA98Rgb();
                        break $label0$0;
                    }
                    if (B.ProphotoRgbColorSpace_BDz === dest) {
                        t1 = $.$get$linearSrgbToLinearProphotoRgb();
                        break $label0$0;
                    }
                    if (B.Rec2020ColorSpace_6oo === dest) {
                        t1 = $.$get$linearSrgbToLinearRec2020();
                        break $label0$0;
                    }
                    if (B.XyzD65ColorSpace_WiJ === dest) {
                        t1 = $.$get$linearSrgbToXyzD65();
                        break $label0$0;
                    }
                    if (B.XyzD50ColorSpace_2OB === dest) {
                        t1 = $.$get$linearSrgbToXyzD50();
                        break $label0$0;
                    }
                    if (B.LmsColorSpace_Os3 === dest) {
                        t1 = $.$get$linearSrgbToLms();
                        break $label0$0;
                    }
                    t1 = this.super$ColorSpace$transformationMatrix(dest);
                    break $label0$0;
                }
                return t1;
            }
        };
        A.SrgbLinearColorSpace.prototype = {
            get$isBoundedInternal: function() {
                return true;
            },
            convert$5: function(dest, red, green, blue, alpha) {
                var t1;
                $label0$0: {
                    if (B.RgbColorSpace_i0P === dest || B.HslColorSpace_JQ2 === dest || B.HwbColorSpace_guQ === dest || B.SrgbColorSpace_thf === dest) {
                        t1 = B.SrgbColorSpace_thf.convert$5(dest, A.NullableExtension_andThen(red, A.utils0__srgbAndDisplayP3FromLinear$closure()), A.NullableExtension_andThen(green, A.utils0__srgbAndDisplayP3FromLinear$closure()), A.NullableExtension_andThen(blue, A.utils0__srgbAndDisplayP3FromLinear$closure()), alpha);
                        break $label0$0;
                    }
                    t1 = this.super$ColorSpace$convert(dest, red, green, blue, alpha);
                    break $label0$0;
                }
                return t1;
            },
            toLinear$1: function(channel) {
                return channel;
            },
            fromLinear$1: function(channel) {
                return channel;
            },
            transformationMatrix$1: function(dest) {
                var t1;
                $label0$0: {
                    if (B.DisplayP3ColorSpace_MmT === dest || B.DisplayP3LinearColorSpace_PrP === dest) {
                        t1 = $.$get$linearSrgbToLinearDisplayP3();
                        break $label0$0;
                    }
                    if (B.A98RgbColorSpace_lf2 === dest) {
                        t1 = $.$get$linearSrgbToLinearA98Rgb();
                        break $label0$0;
                    }
                    if (B.ProphotoRgbColorSpace_BDz === dest) {
                        t1 = $.$get$linearSrgbToLinearProphotoRgb();
                        break $label0$0;
                    }
                    if (B.Rec2020ColorSpace_6oo === dest) {
                        t1 = $.$get$linearSrgbToLinearRec2020();
                        break $label0$0;
                    }
                    if (B.XyzD65ColorSpace_WiJ === dest) {
                        t1 = $.$get$linearSrgbToXyzD65();
                        break $label0$0;
                    }
                    if (B.XyzD50ColorSpace_2OB === dest) {
                        t1 = $.$get$linearSrgbToXyzD50();
                        break $label0$0;
                    }
                    if (B.LmsColorSpace_Os3 === dest) {
                        t1 = $.$get$linearSrgbToLms();
                        break $label0$0;
                    }
                    t1 = this.super$ColorSpace$transformationMatrix(dest);
                    break $label0$0;
                }
                return t1;
            }
        };
        A.XyzD50ColorSpace.prototype = {
            get$isBoundedInternal: function() {
                return false;
            },
            convert$10$missingA$missingB$missingChroma$missingHue$missingLightness: function(dest, x, y, z, alpha, missingA, missingB, missingChroma, missingHue, missingLightness) {
                var f0, f1, f2, lightness, a, b, t1, _this = this, _null = null;
                if (B.LabColorSpace_2nT === dest || B.LchColorSpace_Bpv === dest) {
                    f0 = _this._convertComponentToLabF$1((x == null ? 0 : x) / 0.9642956764295677);
                    f1 = _this._convertComponentToLabF$1((y == null ? 0 : y) / 1);
                    f2 = _this._convertComponentToLabF$1((z == null ? 0 : z) / 0.8251046025104602);
                    lightness = missingLightness ? _null : 116 * f1 - 16;
                    a = 500 * (f0 - f1);
                    b = 200 * (f1 - f2);
                    if (dest === B.LabColorSpace_2nT) {
                        t1 = missingA ? _null : a;
                        t1 = A.SassColor$_forSpace(B.LabColorSpace_2nT, lightness, t1, missingB ? _null : b, alpha, _null);
                    } else t1 = A.labToLch(B.LchColorSpace_Bpv, lightness, a, b, alpha, missingChroma, missingHue);
                    return t1;
                }
                return _this.super$ColorSpace$convertLinear(dest, x, y, z, alpha, missingA, missingB, missingChroma, missingHue, missingLightness);
            },
            convert$5: function(dest, x, y, z, alpha) {
                return this.convert$10$missingA$missingB$missingChroma$missingHue$missingLightness(dest, x, y, z, alpha, false, false, false, false, false);
            },
            _convertComponentToLabF$1: function(component) {
                return component > 0.008856451679035631 ? Math.pow(component, 0.3333333333333333) + 0 : (903.2962962962963 * component + 16) / 116;
            },
            toLinear$1: function(channel) {
                return channel;
            },
            fromLinear$1: function(channel) {
                return channel;
            },
            transformationMatrix$1: function(dest) {
                var t1;
                $label0$0: {
                    if (B.SrgbLinearColorSpace_kUj === dest || B.SrgbColorSpace_thf === dest || B.RgbColorSpace_i0P === dest) {
                        t1 = $.$get$xyzD50ToLinearSrgb();
                        break $label0$0;
                    }
                    if (B.A98RgbColorSpace_lf2 === dest) {
                        t1 = $.$get$xyzD50ToLinearA98Rgb();
                        break $label0$0;
                    }
                    if (B.ProphotoRgbColorSpace_BDz === dest) {
                        t1 = $.$get$xyzD50ToLinearProphotoRgb();
                        break $label0$0;
                    }
                    if (B.DisplayP3ColorSpace_MmT === dest || B.DisplayP3LinearColorSpace_PrP === dest) {
                        t1 = $.$get$xyzD50ToLinearDisplayP3();
                        break $label0$0;
                    }
                    if (B.Rec2020ColorSpace_6oo === dest) {
                        t1 = $.$get$xyzD50ToLinearRec2020();
                        break $label0$0;
                    }
                    if (B.XyzD65ColorSpace_WiJ === dest) {
                        t1 = $.$get$xyzD50ToXyzD65();
                        break $label0$0;
                    }
                    if (B.LmsColorSpace_Os3 === dest) {
                        t1 = $.$get$xyzD50ToLms();
                        break $label0$0;
                    }
                    t1 = this.super$ColorSpace$transformationMatrix(dest);
                    break $label0$0;
                }
                return t1;
            }
        };
        A.XyzD65ColorSpace.prototype = {
            get$isBoundedInternal: function() {
                return false;
            },
            toLinear$1: function(channel) {
                return channel;
            },
            fromLinear$1: function(channel) {
                return channel;
            },
            transformationMatrix$1: function(dest) {
                var t1;
                $label0$0: {
                    if (B.SrgbLinearColorSpace_kUj === dest || B.SrgbColorSpace_thf === dest || B.RgbColorSpace_i0P === dest) {
                        t1 = $.$get$xyzD65ToLinearSrgb();
                        break $label0$0;
                    }
                    if (B.A98RgbColorSpace_lf2 === dest) {
                        t1 = $.$get$xyzD65ToLinearA98Rgb();
                        break $label0$0;
                    }
                    if (B.ProphotoRgbColorSpace_BDz === dest) {
                        t1 = $.$get$xyzD65ToLinearProphotoRgb();
                        break $label0$0;
                    }
                    if (B.DisplayP3ColorSpace_MmT === dest || B.DisplayP3LinearColorSpace_PrP === dest) {
                        t1 = $.$get$xyzD65ToLinearDisplayP3();
                        break $label0$0;
                    }
                    if (B.Rec2020ColorSpace_6oo === dest) {
                        t1 = $.$get$xyzD65ToLinearRec2020();
                        break $label0$0;
                    }
                    if (B.XyzD50ColorSpace_2OB === dest) {
                        t1 = $.$get$xyzD65ToXyzD50();
                        break $label0$0;
                    }
                    if (B.LmsColorSpace_Os3 === dest) {
                        t1 = $.$get$xyzD65ToLms();
                        break $label0$0;
                    }
                    t1 = this.super$ColorSpace$transformationMatrix(dest);
                    break $label0$0;
                }
                return t1;
            }
        };
        A.SassFunction.prototype = {
            accept$1$1: function(visitor) {
                var t1, t2;
                if (!visitor._inspect) A.throwExpression(A.SassScriptException$(this.toString$0(0) + " isn't a valid CSS value.", null));
                t1 = visitor._serialize$_buffer;
                t1.write$1(0, "get-function(");
                t2 = this.callable;
                visitor._visitQuotedString$1(t2.get$name(t2));
                t1.writeCharCode$1(41);
                return null;
            },
            accept$1: function(visitor) {
                return this.accept$1$1(visitor, type$.dynamic);
            },
            assertFunction$1: function($name) {
                return this;
            },
            assertCompileContext$1: function(compileContext) {
                var t1 = this._function$_compileContext !== compileContext;
                if (t1) throw A.wrapException(A.SassScriptException$(this.toString$0(0) + " does not belong to current compilation.", null));
                return this;
            },
            $eq: function(_, other) {
                if (other == null) return false;
                return other instanceof A.SassFunction && this.callable.$eq(0, other.callable);
            },
            get$hashCode: function(_) {
                var t1 = this.callable;
                return t1.get$hashCode(t1);
            }
        };
        A.SassList.prototype = {
            get$separator: function(_) {
                return this._separator;
            },
            get$hasBrackets: function() {
                return this._hasBrackets;
            },
            get$isBlank: function() {
                return !this._hasBrackets && B.JSArray_methods.every$1(this._list$_contents, new A.SassList_isBlank_closure());
            },
            get$asList: function() {
                return this._list$_contents;
            },
            get$lengthAsList: function() {
                return this._list$_contents.length;
            },
            SassList$3$brackets: function(contents, _separator, brackets) {
                if (this._separator === B.ListSeparator_undecided_null_3_undecided && this._list$_contents.length > 1) throw A.wrapException(A.ArgumentError$(string$.A_list, null));
            },
            toString$0: function(_) {
                var t2, _this = this, t1 = true;
                if (!_this._hasBrackets) {
                    t2 = _this._list$_contents.length;
                    if (t2 !== 0) t1 = t2 === 1 && _this._separator === B.ListSeparator_z0K;
                }
                if (t1) return _this.super$Value$toString(0);
                return "(" + _this.super$Value$toString(0) + ")";
            },
            accept$1$1: function(visitor) {
                return visitor.visitList$1(this);
            },
            accept$1: function(visitor) {
                return this.accept$1$1(visitor, type$.dynamic);
            },
            assertMap$1: function($name) {
                return this._list$_contents.length === 0 ? B.SassMap_Map_empty : this.super$Value$assertMap($name);
            },
            tryMap$0: function() {
                return this._list$_contents.length === 0 ? B.SassMap_Map_empty : null;
            },
            $eq: function(_, other) {
                var t1, _this = this;
                if (other == null) return false;
                if (!(other instanceof A.SassList && other._separator === _this._separator && other._hasBrackets === _this._hasBrackets && B.C_ListEquality.equals$2(0, other._list$_contents, _this._list$_contents))) t1 = _this._list$_contents.length === 0 && other instanceof A.SassMap && other.get$asList().length === 0;
                else t1 = true;
                return t1;
            },
            get$hashCode: function(_) {
                return B.C_ListEquality0.hash$1(this._list$_contents);
            }
        };
        A.SassList_isBlank_closure.prototype = {
            call$1: function(element) {
                return element.get$isBlank();
            },
            $signature: 79
        };
        A.ListSeparator.prototype = {
            _enumToString$0: function() {
                return "ListSeparator." + this._name;
            },
            toString$0: function(_) {
                return this._list$_name;
            }
        };
        A.SassMap.prototype = {
            get$separator: function(_) {
                var t1 = this._map$_contents;
                return t1.get$isEmpty(t1) ? B.ListSeparator_undecided_null_3_undecided : B.ListSeparator_z0K;
            },
            get$asList: function() {
                var t3, t4, t5, result, t1 = type$.JSArray_Value, t2 = A._setArrayType([], t1);
                for(t3 = type$.Value, t4 = A.MapExtensions_get_pairs(this._map$_contents, t3, t3), t4 = t4.get$iterator(t4); t4.moveNext$0();){
                    t5 = t4.get$current(t4);
                    result = A.List_List$from(A._setArrayType([
                        t5._0,
                        t5._1
                    ], t1), false, t3);
                    result.$flags = 3;
                    t2.push(new A.SassList(result, B.ListSeparator_SrV, false));
                }
                return t2;
            },
            get$lengthAsList: function() {
                var t1 = this._map$_contents;
                return t1.get$length(t1);
            },
            accept$1$1: function(visitor) {
                return visitor.visitMap$1(this);
            },
            accept$1: function(visitor) {
                return this.accept$1$1(visitor, type$.dynamic);
            },
            assertMap$1: function($name) {
                return this;
            },
            tryMap$0: function() {
                return this;
            },
            $eq: function(_, other) {
                var t1;
                if (other == null) return false;
                if (!(other instanceof A.SassMap && B.C_MapEquality.equals$2(0, other._map$_contents, this._map$_contents))) {
                    t1 = this._map$_contents;
                    t1 = t1.get$isEmpty(t1) && other instanceof A.SassList && other._list$_contents.length === 0;
                } else t1 = true;
                return t1;
            },
            get$hashCode: function(_) {
                var t1 = this._map$_contents;
                return t1.get$isEmpty(t1) ? B.C_ListEquality0.hash$1(B.List_empty8) : B.C_MapEquality.hash$1(t1);
            }
        };
        A.SassMixin.prototype = {
            accept$1$1: function(visitor) {
                var t1, t2;
                if (!visitor._inspect) A.throwExpression(A.SassScriptException$(this.toString$0(0) + " isn't a valid CSS value.", null));
                t1 = visitor._serialize$_buffer;
                t1.write$1(0, "get-mixin(");
                t2 = this.callable;
                visitor._visitQuotedString$1(t2.get$name(t2));
                t1.writeCharCode$1(41);
                return null;
            },
            accept$1: function(visitor) {
                return this.accept$1$1(visitor, type$.dynamic);
            },
            assertMixin$1: function($name) {
                return this;
            },
            assertCompileContext$1: function(compileContext) {
                var t1 = this._mixin$_compileContext !== compileContext;
                if (t1) throw A.wrapException(A.SassScriptException$(this.toString$0(0) + " does not belong to current compilation.", null));
                return this;
            },
            $eq: function(_, other) {
                if (other == null) return false;
                return other instanceof A.SassMixin && this.callable.$eq(0, other.callable);
            },
            get$hashCode: function(_) {
                var t1 = this.callable;
                return t1.get$hashCode(t1);
            }
        };
        A._SassNull.prototype = {
            get$isTruthy: function() {
                return false;
            },
            get$isBlank: function() {
                return true;
            },
            get$realNull: function() {
                return null;
            },
            accept$1$1: function(visitor) {
                if (visitor._inspect) visitor._serialize$_buffer.write$1(0, "null");
                return null;
            },
            accept$1: function(visitor) {
                return this.accept$1$1(visitor, type$.dynamic);
            },
            unaryNot$0: function() {
                return B.SassBoolean_true;
            }
        };
        A.SassNumber.prototype = {
            get$unitString: function() {
                var _this = this;
                return _this.get$hasUnits() ? _this._unitString$2(_this.get$numeratorUnits(_this), _this.get$denominatorUnits(_this)) : "";
            },
            accept$1$1: function(visitor) {
                return visitor.visitNumber$1(this);
            },
            accept$1: function(visitor) {
                return this.accept$1$1(visitor, type$.dynamic);
            },
            withoutSlash$0: function() {
                var _this = this;
                return _this.asSlash == null ? _this : _this.withValue$1(_this._number$_value);
            },
            assertNumber$1: function($name) {
                return this;
            },
            assertNumber$0: function() {
                return this.assertNumber$1(null);
            },
            assertInt$1: function($name) {
                var _0_0 = A.fuzzyAsInt(this._number$_value);
                if (_0_0 != null) return _0_0;
                throw A.wrapException(A.SassScriptException$(this.toString$0(0) + " is not an int.", $name));
            },
            assertInt$0: function() {
                return this.assertInt$1(null);
            },
            valueInRange$3: function(min, max, $name) {
                var _this = this, _0_0 = A.fuzzyCheckRange(_this._number$_value, min, max);
                if (_0_0 != null) return _0_0;
                throw A.wrapException(A.SassScriptException$("Expected " + _this.toString$0(0) + " to be within " + min + _this.get$unitString() + " and " + max + _this.get$unitString() + ".", $name));
            },
            valueInRangeWithUnit$4: function(min, max, $name, unit) {
                var _0_0 = A.fuzzyCheckRange(this._number$_value, min, max);
                if (_0_0 != null) return _0_0;
                throw A.wrapException(A.SassScriptException$("Expected " + this.toString$0(0) + " to be within " + min + unit + " and " + max + unit + ".", $name));
            },
            hasCompatibleUnits$1: function(other) {
                var _this = this;
                if (_this.get$numeratorUnits(_this).length !== other.get$numeratorUnits(other).length) return false;
                if (_this.get$denominatorUnits(_this).length !== other.get$denominatorUnits(other).length) return false;
                return _this.isComparableTo$1(other);
            },
            assertUnit$2: function(unit, $name) {
                if (this.hasUnit$1(unit)) return;
                throw A.wrapException(A.SassScriptException$("Expected " + this.toString$0(0) + ' to have unit "' + unit + '".', $name));
            },
            assertNoUnits$1: function($name) {
                if (!this.get$hasUnits()) return;
                throw A.wrapException(A.SassScriptException$("Expected " + this.toString$0(0) + " to have no units.", $name));
            },
            assertNoUnits$0: function() {
                return this.assertNoUnits$1(null);
            },
            convertValueToMatch$3: function(other, $name, otherName) {
                return this._coerceOrConvertValue$6$coerceUnitless$name$other$otherName(other.get$numeratorUnits(other), other.get$denominatorUnits(other), false, $name, other, otherName);
            },
            convertValueToMatch$1: function(other) {
                return this.convertValueToMatch$3(other, null, null);
            },
            coerce$3: function(newNumerators, newDenominators, $name) {
                return A.SassNumber_SassNumber$withUnits(this.coerceValue$3(newNumerators, newDenominators, $name), newDenominators, newNumerators);
            },
            coerce$2: function(newNumerators, newDenominators) {
                return this.coerce$3(newNumerators, newDenominators, null);
            },
            coerceValue$3: function(newNumerators, newDenominators, $name) {
                return this._coerceOrConvertValue$4$coerceUnitless$name(newNumerators, newDenominators, true, $name);
            },
            coerceValueToUnit$2: function(unit, $name) {
                var t1 = type$.JSArray_String;
                return this.coerceValue$3(A._setArrayType([
                    unit
                ], t1), A._setArrayType([], t1), $name);
            },
            coerceValueToUnit$1: function(unit) {
                return this.coerceValueToUnit$2(unit, null);
            },
            coerceToMatch$3: function(other, $name, otherName) {
                var t1 = this.coerceValueToMatch$3(other, $name, otherName), t2 = other.get$numeratorUnits(other);
                return A.SassNumber_SassNumber$withUnits(t1, other.get$denominatorUnits(other), t2);
            },
            coerceValueToMatch$3: function(other, $name, otherName) {
                return this._coerceOrConvertValue$6$coerceUnitless$name$other$otherName(other.get$numeratorUnits(other), other.get$denominatorUnits(other), true, $name, other, otherName);
            },
            coerceValueToMatch$1: function(other) {
                return this.coerceValueToMatch$3(other, null, null);
            },
            _coerceOrConvertValue$6$coerceUnitless$name$other$otherName: function(newNumerators, newDenominators, coerceUnitless, $name, other, otherName) {
                var otherHasUnits, t1, compatibilityException, oldNumerators, _i, oldDenominators, _this = this, _box_0 = {};
                if (B.C_ListEquality.equals$2(0, _this.get$numeratorUnits(_this), newNumerators) && B.C_ListEquality.equals$2(0, _this.get$denominatorUnits(_this), newDenominators)) return _this._number$_value;
                otherHasUnits = newNumerators.length !== 0 || newDenominators.length !== 0;
                if (coerceUnitless) t1 = !_this.get$hasUnits() || !otherHasUnits;
                else t1 = false;
                if (t1) return _this._number$_value;
                compatibilityException = new A.SassNumber__coerceOrConvertValue_compatibilityException(_this, other, otherName, otherHasUnits, $name, newNumerators, newDenominators);
                _box_0.value = _this._number$_value;
                t1 = _this.get$numeratorUnits(_this);
                oldNumerators = A._setArrayType(t1.slice(0), A._arrayInstanceType(t1));
                for(t1 = newNumerators.length, _i = 0; _i < newNumerators.length; newNumerators.length === t1 || (0, A.throwConcurrentModificationError)(newNumerators), ++_i)A.removeFirstWhere(oldNumerators, new A.SassNumber__coerceOrConvertValue_closure(_box_0, newNumerators[_i]), new A.SassNumber__coerceOrConvertValue_closure0(compatibilityException));
                t1 = _this.get$denominatorUnits(_this);
                oldDenominators = A._setArrayType(t1.slice(0), A._arrayInstanceType(t1));
                for(t1 = newDenominators.length, _i = 0; _i < newDenominators.length; newDenominators.length === t1 || (0, A.throwConcurrentModificationError)(newDenominators), ++_i)A.removeFirstWhere(oldDenominators, new A.SassNumber__coerceOrConvertValue_closure1(_box_0, newDenominators[_i]), new A.SassNumber__coerceOrConvertValue_closure2(compatibilityException));
                if (oldNumerators.length !== 0 || oldDenominators.length !== 0) throw A.wrapException(compatibilityException.call$0());
                return _box_0.value;
            },
            _coerceOrConvertValue$4$coerceUnitless$name: function(newNumerators, newDenominators, coerceUnitless, $name) {
                return this._coerceOrConvertValue$6$coerceUnitless$name$other$otherName(newNumerators, newDenominators, coerceUnitless, $name, null, null);
            },
            isComparableTo$1: function(other) {
                var _$exception;
                if (!this.get$hasUnits() || !other.get$hasUnits()) return true;
                try {
                    this.greaterThan$1(other);
                    return true;
                } catch (exception) {
                    if (A.unwrapException(exception) instanceof A.SassScriptException) return false;
                    else throw exception;
                }
            },
            greaterThan$1: function(other) {
                if (other instanceof A.SassNumber) return this._coerceUnits$2(other, A.number0__fuzzyGreaterThan$closure()) ? B.SassBoolean_true : B.SassBoolean_false;
                throw A.wrapException(A.SassScriptException$('Undefined operation "' + this.toString$0(0) + " > " + other.toString$0(0) + '".', null));
            },
            greaterThanOrEquals$1: function(other) {
                if (other instanceof A.SassNumber) return this._coerceUnits$2(other, A.number0__fuzzyGreaterThanOrEquals$closure()) ? B.SassBoolean_true : B.SassBoolean_false;
                throw A.wrapException(A.SassScriptException$('Undefined operation "' + this.toString$0(0) + " >= " + other.toString$0(0) + '".', null));
            },
            lessThan$1: function(other) {
                if (other instanceof A.SassNumber) return this._coerceUnits$2(other, A.number0__fuzzyLessThan$closure()) ? B.SassBoolean_true : B.SassBoolean_false;
                throw A.wrapException(A.SassScriptException$('Undefined operation "' + this.toString$0(0) + " < " + other.toString$0(0) + '".', null));
            },
            lessThanOrEquals$1: function(other) {
                if (other instanceof A.SassNumber) return this._coerceUnits$2(other, A.number0__fuzzyLessThanOrEquals$closure()) ? B.SassBoolean_true : B.SassBoolean_false;
                throw A.wrapException(A.SassScriptException$('Undefined operation "' + this.toString$0(0) + " <= " + other.toString$0(0) + '".', null));
            },
            modulo$1: function(other) {
                if (other instanceof A.SassNumber) return this.withValue$1(this._coerceUnits$2(other, A.number0__moduloLikeSass$closure()));
                throw A.wrapException(A.SassScriptException$('Undefined operation "' + this.toString$0(0) + " % " + other.toString$0(0) + '".', null));
            },
            plus$1: function(other) {
                var _this = this;
                if (other instanceof A.SassNumber) return _this.withValue$1(_this._coerceUnits$2(other, new A.SassNumber_plus_closure()));
                if (!(other instanceof A.SassColor)) return _this.super$Value$plus(other);
                throw A.wrapException(A.SassScriptException$('Undefined operation "' + _this.toString$0(0) + " + " + other.toString$0(0) + '".', null));
            },
            minus$1: function(other) {
                var _this = this;
                if (other instanceof A.SassNumber) return _this.withValue$1(_this._coerceUnits$2(other, new A.SassNumber_minus_closure()));
                if (!(other instanceof A.SassColor)) return _this.super$Value$minus(other);
                throw A.wrapException(A.SassScriptException$('Undefined operation "' + _this.toString$0(0) + " - " + other.toString$0(0) + '".', null));
            },
            times$1: function(other) {
                var _this = this;
                if (other instanceof A.SassNumber) {
                    if (!other.get$hasUnits()) return _this.withValue$1(_this._number$_value * other._number$_value);
                    return _this.multiplyUnits$3(_this._number$_value * other._number$_value, other.get$numeratorUnits(other), other.get$denominatorUnits(other));
                }
                throw A.wrapException(A.SassScriptException$('Undefined operation "' + _this.toString$0(0) + " * " + other.toString$0(0) + '".', null));
            },
            dividedBy$1: function(other) {
                var _this = this;
                if (other instanceof A.SassNumber) {
                    if (!other.get$hasUnits()) return _this.withValue$1(_this._number$_value / other._number$_value);
                    return _this.multiplyUnits$3(_this._number$_value / other._number$_value, other.get$denominatorUnits(other), other.get$numeratorUnits(other));
                }
                return _this.super$Value$dividedBy(other);
            },
            unaryPlus$0: function() {
                return this;
            },
            _coerceUnits$1$2: function(other, operation) {
                var t1, _$exception;
                try {
                    t1 = operation.call$2(this._number$_value, other.coerceValueToMatch$1(this));
                    return t1;
                } catch (exception) {
                    if (A.unwrapException(exception) instanceof A.SassScriptException) {
                        this.coerceValueToMatch$1(other);
                        throw exception;
                    } else throw exception;
                }
            },
            _coerceUnits$2: function(other, operation) {
                return this._coerceUnits$1$2(other, operation, type$.dynamic);
            },
            multiplyUnits$3: function(value, otherNumerators, otherDenominators) {
                var t1, _0_1, _0_6, _0_3, _0_9, _0_9_isSet, _0_7, _0_7_isSet, t2, _0_2, t3, denominators_case_0, _0_11_isSet, _0_11, _0_13, _0_13_isSet, numerators_case_0, t4, t5, t6, t7, numerators_case_1, denominators_case_1, t0, newNumerators, mutableOtherDenominators, _i, numerator, mutableDenominatorUnits, _this = this, _null = null, _box_0 = {};
                _box_0.value = value;
                t1 = [
                    _this.get$numeratorUnits(_this),
                    _this.get$denominatorUnits(_this),
                    otherNumerators,
                    otherDenominators
                ];
                _0_1 = t1[0];
                _0_6 = _null;
                _0_3 = _null;
                _0_9 = _null;
                _0_9_isSet = false;
                _0_7 = _null;
                _0_7_isSet = false;
                t2 = false;
                _0_2 = t1[1];
                _0_3 = t1[2];
                _0_6 = _0_3.length <= 0;
                t3 = _0_6;
                if (t3) {
                    _0_7 = t1[3];
                    _0_9 = _0_7.length <= 0;
                    t2 = _0_9;
                    _0_9_isSet = true;
                    _0_7_isSet = true;
                }
                denominators_case_0 = _0_2;
                _0_11_isSet = !t2;
                _0_11 = _null;
                _0_13 = _null;
                _0_13_isSet = false;
                t2 = true;
                if (_0_11_isSet) {
                    _0_11 = _0_1.length <= 0;
                    t3 = _0_11;
                    if (t3) {
                        _0_13 = _0_2.length <= 0;
                        t3 = _0_13;
                        if (t3) {
                            if (_0_7_isSet) denominators_case_0 = _0_7;
                            else {
                                _0_7 = t1[3];
                                denominators_case_0 = _0_7;
                                _0_7_isSet = true;
                            }
                            numerators_case_0 = _0_3;
                        } else {
                            numerators_case_0 = _0_1;
                            t2 = false;
                        }
                        _0_13_isSet = true;
                    } else {
                        numerators_case_0 = _0_1;
                        t2 = false;
                    }
                } else numerators_case_0 = _0_1;
                if (t2) {
                    t4 = denominators_case_0;
                    t3 = numerators_case_0;
                } else {
                    t4 = _null;
                    t3 = t4;
                }
                if (!t2) {
                    t2 = _null;
                    t5 = _null;
                    if (_0_11_isSet) t6 = _0_11;
                    else {
                        _0_11 = _0_1.length <= 0;
                        t6 = _0_11;
                    }
                    t7 = false;
                    if (t6) {
                        if (_0_9_isSet) t2 = _0_9;
                        else {
                            if (_0_7_isSet) t2 = _0_7;
                            else {
                                _0_7 = t1[3];
                                t2 = _0_7;
                                _0_7_isSet = true;
                            }
                            _0_9 = t2.length <= 0;
                            t2 = _0_9;
                        }
                        numerators_case_1 = _0_3;
                        denominators_case_1 = _0_2;
                    } else {
                        numerators_case_1 = t2;
                        t2 = t7;
                        denominators_case_1 = t5;
                    }
                    if (!t2) {
                        t2 = false;
                        if (_0_13_isSet) t5 = _0_13;
                        else {
                            _0_13 = _0_2.length <= 0;
                            t5 = _0_13;
                        }
                        if (t5) {
                            if (_0_6) {
                                denominators_case_1 = _0_7_isSet ? _0_7 : t1[3];
                                t1 = true;
                            } else t1 = t2;
                        } else t1 = t2;
                        numerators_case_1 = _0_1;
                    } else t1 = true;
                    if (t1) {
                        t1 = !_this._areAnyConvertible$2(numerators_case_1, denominators_case_1);
                        if (t1) {
                            t3 = denominators_case_1;
                            t2 = numerators_case_1;
                        } else {
                            t2 = t3;
                            t3 = t4;
                        }
                        t0 = t3;
                        t3 = t1;
                        t1 = t2;
                        t2 = t0;
                    } else {
                        t2 = t4;
                        t1 = t3;
                        t3 = false;
                    }
                } else {
                    t2 = t4;
                    t1 = t3;
                    t3 = true;
                }
                if (t3) return A.SassNumber_SassNumber$withUnits(value, t2, t1);
                newNumerators = A._setArrayType([], type$.JSArray_String);
                mutableOtherDenominators = A._setArrayType(otherDenominators.slice(0), A._arrayInstanceType(otherDenominators));
                for(t1 = _this.get$numeratorUnits(_this), t2 = t1.length, _i = 0; _i < t2; ++_i){
                    numerator = t1[_i];
                    A.removeFirstWhere(mutableOtherDenominators, new A.SassNumber_multiplyUnits_closure(_box_0, numerator), new A.SassNumber_multiplyUnits_closure0(newNumerators, numerator));
                }
                t1 = _this.get$denominatorUnits(_this);
                mutableDenominatorUnits = A._setArrayType(t1.slice(0), A._arrayInstanceType(t1));
                for(t1 = otherNumerators.length, _i = 0; _i < t1; ++_i){
                    numerator = otherNumerators[_i];
                    A.removeFirstWhere(mutableDenominatorUnits, new A.SassNumber_multiplyUnits_closure1(_box_0, numerator), new A.SassNumber_multiplyUnits_closure2(newNumerators, numerator));
                }
                t1 = _box_0.value;
                B.JSArray_methods.addAll$1(mutableDenominatorUnits, mutableOtherDenominators);
                return A.SassNumber_SassNumber$withUnits(t1, mutableDenominatorUnits, newNumerators);
            },
            _areAnyConvertible$2: function(units1, units2) {
                return B.JSArray_methods.any$1(units1, new A.SassNumber__areAnyConvertible_closure(units2));
            },
            _unitString$2: function(numerators, denominators) {
                var _0_4, _0_7, _0_6, _0_5, t1, _0_9, _0_10, denominator, _null = null;
                $label0$0: {
                    _0_4 = numerators.length <= 0;
                    _0_7 = _null;
                    _0_6 = _null;
                    _0_5 = _null;
                    if (_0_4) {
                        _0_6 = denominators.length;
                        t1 = _0_6;
                        _0_7 = t1 <= 0;
                        t1 = _0_7;
                        _0_5 = denominators;
                    } else t1 = false;
                    if (t1) {
                        t1 = "no units";
                        break $label0$0;
                    }
                    _0_9 = _null;
                    if (_0_4) {
                        t1 = _0_6;
                        _0_9 = t1 === 1;
                        t1 = _0_9;
                    } else t1 = false;
                    if (t1) {
                        _0_10 = (_0_4 ? _0_5 : denominators)[0];
                        denominator = _0_10;
                        t1 = denominator + "^-1";
                        break $label0$0;
                    }
                    if (_0_4) {
                        t1 = "(" + B.JSArray_methods.join$1(denominators, "*") + ")^-1";
                        break $label0$0;
                    }
                    t1 = denominators;
                    _0_5 = t1;
                    _0_6 = t1.length;
                    t1 = _0_6;
                    _0_7 = t1 <= 0;
                    t1 = _0_7;
                    if (t1) {
                        t1 = B.JSArray_methods.join$1(numerators, "*");
                        break $label0$0;
                    }
                    t1 = _0_6;
                    _0_9 = t1 === 1;
                    t1 = _0_9;
                    if (t1) {
                        _0_10 = _0_5[0];
                        denominator = _0_10;
                        t1 = B.JSArray_methods.join$1(numerators, "*") + "/" + denominator;
                        break $label0$0;
                    }
                    t1 = B.JSArray_methods.join$1(numerators, "*") + "/(" + B.JSArray_methods.join$1(denominators, "*") + ")";
                    break $label0$0;
                }
                return t1;
            },
            $eq: function(_, other) {
                var _this = this;
                if (other == null) return false;
                if (!(other instanceof A.SassNumber)) return false;
                if (_this.get$numeratorUnits(_this).length !== other.get$numeratorUnits(other).length || _this.get$denominatorUnits(_this).length !== other.get$denominatorUnits(other).length) return false;
                if (!_this.get$hasUnits()) return A.fuzzyEquals(_this._number$_value, other._number$_value);
                if (!B.C_ListEquality.equals$2(0, _this._canonicalizeUnitList$1(_this.get$numeratorUnits(_this)), _this._canonicalizeUnitList$1(other.get$numeratorUnits(other))) || !B.C_ListEquality.equals$2(0, _this._canonicalizeUnitList$1(_this.get$denominatorUnits(_this)), _this._canonicalizeUnitList$1(other.get$denominatorUnits(other)))) return false;
                return A.fuzzyEquals(_this._number$_value * _this._canonicalMultiplier$1(_this.get$numeratorUnits(_this)) / _this._canonicalMultiplier$1(_this.get$denominatorUnits(_this)), other._number$_value * _this._canonicalMultiplier$1(other.get$numeratorUnits(other)) / _this._canonicalMultiplier$1(other.get$denominatorUnits(other)));
            },
            get$hashCode: function(_) {
                var _this = this, t1 = _this.hashCache;
                return t1 == null ? _this.hashCache = A.fuzzyHashCode(_this._number$_value * _this._canonicalMultiplier$1(_this.get$numeratorUnits(_this)) / _this._canonicalMultiplier$1(_this.get$denominatorUnits(_this))) : t1;
            },
            _canonicalizeUnitList$1: function(units) {
                var type, t1 = units.length;
                if (t1 === 0) return units;
                if (t1 === 1) {
                    type = $.$get$_typesByUnit().$index(0, B.JSArray_methods.get$first(units));
                    if (type == null) t1 = units;
                    else {
                        t1 = B.Map_Sr65K.$index(0, type);
                        t1.toString;
                        t1 = A._setArrayType([
                            B.JSArray_methods.get$first(t1)
                        ], type$.JSArray_String);
                    }
                    return t1;
                }
                t1 = A._arrayInstanceType(units)._eval$1("MappedListIterable<1,String>");
                t1 = A.List_List$_of(new A.MappedListIterable(units, new A.SassNumber__canonicalizeUnitList_closure(), t1), t1._eval$1("ListIterable.E"));
                B.JSArray_methods.sort$0(t1);
                return t1;
            },
            _canonicalMultiplier$1: function(units) {
                return B.JSArray_methods.fold$2(units, 1, new A.SassNumber__canonicalMultiplier_closure(this));
            },
            canonicalMultiplierForUnit$1: function(unit) {
                var t1, innerMap = B.Map_NtHoP.$index(0, unit);
                if (innerMap == null) t1 = 1;
                else {
                    t1 = innerMap.get$values(innerMap);
                    t1 = 1 / t1.get$first(t1);
                }
                return t1;
            },
            unitSuggestion$2: function($name, unit) {
                var t2, t3, result, _this = this, t1 = _this.get$denominatorUnits(_this);
                t1 = new A.MappedListIterable(t1, new A.SassNumber_unitSuggestion_closure(), A._arrayInstanceType(t1)._eval$1("MappedListIterable<1,String>")).join$0(0);
                t2 = _this.get$numeratorUnits(_this);
                t2 = new A.MappedListIterable(t2, new A.SassNumber_unitSuggestion_closure0(), A._arrayInstanceType(t2)._eval$1("MappedListIterable<1,String>")).join$0(0);
                t3 = unit == null ? "" : " * 1" + unit;
                result = "$" + $name + t1 + t2 + t3;
                return _this.get$numeratorUnits(_this).length === 0 ? result : "calc(" + result + ")";
            },
            unitSuggestion$1: function($name) {
                return this.unitSuggestion$2($name, null);
            }
        };
        A.SassNumber__coerceOrConvertValue_compatibilityException.prototype = {
            call$0: function() {
                var t2, t3, message, t4, type, unit, _this = this, t1 = _this.other;
                if (t1 != null) {
                    t2 = _this.$this;
                    t3 = t2.toString$0(0) + " and";
                    message = new A.StringBuffer(t3);
                    t4 = _this.otherName;
                    if (t4 != null) t3 = message._contents = t3 + (" $" + t4 + ":");
                    t1 = t3 + (" " + t1.toString$0(0) + " have incompatible units");
                    message._contents = t1;
                    if (!t2.get$hasUnits() || !_this.otherHasUnits) message._contents = t1 + " (one has units and the other doesn't)";
                    t1 = message.toString$0(0) + ".";
                    t2 = _this.name;
                    return new A.SassScriptException(t2 == null ? t1 : "$" + t2 + ": " + t1);
                } else if (!_this.otherHasUnits) {
                    t1 = "Expected " + _this.$this.toString$0(0) + " to have no units.";
                    t2 = _this.name;
                    return new A.SassScriptException(t2 == null ? t1 : "$" + t2 + ": " + t1);
                } else {
                    t1 = _this.newNumerators;
                    if (t1.length === 1 && _this.newDenominators.length === 0) {
                        type = $.$get$_typesByUnit().$index(0, B.JSArray_methods.get$first(t1));
                        if (type != null) {
                            t1 = _this.$this.toString$0(0);
                            t2 = B.JSArray_methods.contains$1(A._setArrayType([
                                97,
                                101,
                                105,
                                111,
                                117
                            ], type$.JSArray_int), type.charCodeAt(0)) ? "an " + type : "a " + type;
                            t3 = B.Map_Sr65K.$index(0, type);
                            t3.toString;
                            t3 = "Expected " + t1 + " to have " + t2 + " unit (" + B.JSArray_methods.join$1(t3, ", ") + ").";
                            t2 = _this.name;
                            return new A.SassScriptException(t2 == null ? t3 : "$" + t2 + ": " + t3);
                        }
                    }
                    t2 = _this.newDenominators;
                    unit = A.pluralize("unit", t1.length + t2.length, null);
                    t3 = _this.$this;
                    t2 = "Expected " + t3.toString$0(0) + " to have " + unit + " " + t3._unitString$2(t1, t2) + ".";
                    t1 = _this.name;
                    return new A.SassScriptException(t1 == null ? t2 : "$" + t1 + ": " + t2);
                }
            },
            $signature: 328
        };
        A.SassNumber__coerceOrConvertValue_closure.prototype = {
            call$1: function(oldNumerator) {
                var factor = A.conversionFactor(this.newNumerator, oldNumerator);
                if (factor == null) return false;
                this._box_0.value *= factor;
                return true;
            },
            $signature: 4
        };
        A.SassNumber__coerceOrConvertValue_closure0.prototype = {
            call$0: function() {
                return A.throwExpression(this.compatibilityException.call$0());
            },
            $signature: 0
        };
        A.SassNumber__coerceOrConvertValue_closure1.prototype = {
            call$1: function(oldDenominator) {
                var factor = A.conversionFactor(this.newDenominator, oldDenominator);
                if (factor == null) return false;
                this._box_0.value /= factor;
                return true;
            },
            $signature: 4
        };
        A.SassNumber__coerceOrConvertValue_closure2.prototype = {
            call$0: function() {
                return A.throwExpression(this.compatibilityException.call$0());
            },
            $signature: 0
        };
        A.SassNumber_plus_closure.prototype = {
            call$2: function(num1, num2) {
                return num1 + num2;
            },
            $signature: 57
        };
        A.SassNumber_minus_closure.prototype = {
            call$2: function(num1, num2) {
                return num1 - num2;
            },
            $signature: 57
        };
        A.SassNumber_multiplyUnits_closure.prototype = {
            call$1: function(denominator) {
                var factor = A.conversionFactor(this.numerator, denominator);
                if (factor == null) return false;
                this._box_0.value /= factor;
                return true;
            },
            $signature: 4
        };
        A.SassNumber_multiplyUnits_closure0.prototype = {
            call$0: function() {
                return this.newNumerators.push(this.numerator);
            },
            $signature: 0
        };
        A.SassNumber_multiplyUnits_closure1.prototype = {
            call$1: function(denominator) {
                var factor = A.conversionFactor(this.numerator, denominator);
                if (factor == null) return false;
                this._box_0.value /= factor;
                return true;
            },
            $signature: 4
        };
        A.SassNumber_multiplyUnits_closure2.prototype = {
            call$0: function() {
                return this.newNumerators.push(this.numerator);
            },
            $signature: 0
        };
        A.SassNumber__areAnyConvertible_closure.prototype = {
            call$1: function(unit1) {
                var t1, _0_0 = B.Map_NtHoP.$index(0, unit1);
                $label0$0: {
                    if (_0_0 != null) {
                        t1 = B.JSArray_methods.any$1(this.units2, _0_0.get$containsKey());
                        break $label0$0;
                    }
                    t1 = B.JSArray_methods.contains$1(this.units2, unit1);
                    break $label0$0;
                }
                return t1;
            },
            $signature: 4
        };
        A.SassNumber__canonicalizeUnitList_closure.prototype = {
            call$1: function(unit) {
                var t1, type = $.$get$_typesByUnit().$index(0, unit);
                if (type == null) t1 = unit;
                else {
                    t1 = B.Map_Sr65K.$index(0, type);
                    t1.toString;
                    t1 = B.JSArray_methods.get$first(t1);
                }
                return t1;
            },
            $signature: 6
        };
        A.SassNumber__canonicalMultiplier_closure.prototype = {
            call$2: function(multiplier, unit) {
                return multiplier * this.$this.canonicalMultiplierForUnit$1(unit);
            },
            $signature: 165
        };
        A.SassNumber_unitSuggestion_closure.prototype = {
            call$1: function(unit) {
                return " * 1" + unit;
            },
            $signature: 6
        };
        A.SassNumber_unitSuggestion_closure0.prototype = {
            call$1: function(unit) {
                return " / 1" + unit;
            },
            $signature: 6
        };
        A.ComplexSassNumber.prototype = {
            get$numeratorUnits: function(_) {
                return this._numeratorUnits;
            },
            get$denominatorUnits: function(_) {
                return this._denominatorUnits;
            },
            get$hasUnits: function() {
                return true;
            },
            get$hasComplexUnits: function() {
                return true;
            },
            hasUnit$1: function(unit) {
                return false;
            },
            compatibleWithUnit$1: function(unit) {
                return false;
            },
            hasPossiblyCompatibleUnits$1: function(other) {
                throw A.wrapException(A.UnimplementedError$(string$.Comple));
            },
            withValue$1: function(value) {
                return new A.ComplexSassNumber(this._numeratorUnits, this._denominatorUnits, value, null);
            },
            withSlash$2: function(numerator, denominator) {
                return new A.ComplexSassNumber(this._numeratorUnits, this._denominatorUnits, this._number$_value, new A._Record_2(numerator, denominator));
            }
        };
        A.SingleUnitSassNumber.prototype = {
            get$numeratorUnits: function(_) {
                return A.List_List$unmodifiable([
                    this._unit
                ], type$.String);
            },
            get$denominatorUnits: function(_) {
                return B.List_empty;
            },
            get$hasUnits: function() {
                return true;
            },
            get$hasComplexUnits: function() {
                return false;
            },
            withValue$1: function(value) {
                return new A.SingleUnitSassNumber(this._unit, value, null);
            },
            withSlash$2: function(numerator, denominator) {
                return new A.SingleUnitSassNumber(this._unit, this._number$_value, new A._Record_2(numerator, denominator));
            },
            hasUnit$1: function(unit) {
                return unit === this._unit;
            },
            hasCompatibleUnits$1: function(other) {
                return other instanceof A.SingleUnitSassNumber && A.conversionFactor(this._unit, other._unit) != null;
            },
            hasPossiblyCompatibleUnits$1: function(other) {
                var t1, knownCompatibilities, otherUnit;
                if (!(other instanceof A.SingleUnitSassNumber)) return false;
                t1 = $.$get$_knownCompatibilitiesByUnit();
                knownCompatibilities = t1.$index(0, this._unit.toLowerCase());
                if (knownCompatibilities == null) return true;
                otherUnit = other._unit.toLowerCase();
                return knownCompatibilities.contains$1(0, otherUnit) || !t1.containsKey$1(otherUnit);
            },
            compatibleWithUnit$1: function(unit) {
                return A.conversionFactor(this._unit, unit) != null;
            },
            coerceToMatch$1: function(other) {
                var t1 = other instanceof A.SingleUnitSassNumber ? this._coerceToUnit$1(other._unit) : null;
                return t1 == null ? this.super$SassNumber$coerceToMatch(other, null, null) : t1;
            },
            coerceValueToMatch$3: function(other, $name, otherName) {
                var t1 = other instanceof A.SingleUnitSassNumber ? this._coerceValueToUnit$1(other._unit) : null;
                return t1 == null ? this.super$SassNumber$coerceValueToMatch(other, $name, otherName) : t1;
            },
            coerceValueToMatch$1: function(other) {
                return this.coerceValueToMatch$3(other, null, null);
            },
            convertValueToMatch$3: function(other, $name, otherName) {
                var t1 = other instanceof A.SingleUnitSassNumber ? this._coerceValueToUnit$1(other._unit) : null;
                return t1 == null ? this.super$SassNumber$convertValueToMatch(other, $name, otherName) : t1;
            },
            convertValueToMatch$1: function(other) {
                return this.convertValueToMatch$3(other, null, null);
            },
            coerce$2: function(newNumerators, newDenominators) {
                var t1 = newNumerators.length === 1 && newDenominators.length === 0 ? this._coerceToUnit$1(newNumerators[0]) : null;
                return t1 == null ? this.super$SassNumber$coerce(newNumerators, newDenominators, null) : t1;
            },
            coerceValue$3: function(newNumerators, newDenominators, $name) {
                var t1 = newNumerators.length === 1 && newDenominators.length === 0 ? this._coerceValueToUnit$1(newNumerators[0]) : null;
                return t1 == null ? this.super$SassNumber$coerceValue(newNumerators, newDenominators, $name) : t1;
            },
            coerceValueToUnit$2: function(unit, $name) {
                var t1 = this._coerceValueToUnit$1(unit);
                return t1 == null ? this.super$SassNumber$coerceValueToUnit(unit, $name) : t1;
            },
            coerceValueToUnit$1: function(unit) {
                return this.coerceValueToUnit$2(unit, null);
            },
            _coerceToUnit$1: function(unit) {
                var t1 = this._unit;
                if (t1 === unit) return this;
                return A.NullableExtension_andThen(A.conversionFactor(unit, t1), new A.SingleUnitSassNumber__coerceToUnit_closure(this, unit));
            },
            _coerceValueToUnit$1: function(unit) {
                return A.NullableExtension_andThen(A.conversionFactor(unit, this._unit), new A.SingleUnitSassNumber__coerceValueToUnit_closure(this));
            },
            multiplyUnits$3: function(value, otherNumerators, otherDenominators) {
                var mutableOtherDenominators, t1 = {};
                t1.value = value;
                t1.newNumerators = otherNumerators;
                mutableOtherDenominators = A._setArrayType(otherDenominators.slice(0), A._arrayInstanceType(otherDenominators));
                A.removeFirstWhere(mutableOtherDenominators, new A.SingleUnitSassNumber_multiplyUnits_closure(t1, this), new A.SingleUnitSassNumber_multiplyUnits_closure0(t1, this));
                return A.SassNumber_SassNumber$withUnits(t1.value, mutableOtherDenominators, t1.newNumerators);
            },
            unaryMinus$0: function() {
                return new A.SingleUnitSassNumber(this._unit, -this._number$_value, null);
            },
            $eq: function(_, other) {
                var factor;
                if (other == null) return false;
                if (other instanceof A.SingleUnitSassNumber) {
                    factor = A.conversionFactor(other._unit, this._unit);
                    return factor != null && A.fuzzyEquals(this._number$_value * factor, other._number$_value);
                } else return false;
            },
            get$hashCode: function(_) {
                var _this = this, t1 = _this.hashCache;
                return t1 == null ? _this.hashCache = A.fuzzyHashCode(_this._number$_value * _this.canonicalMultiplierForUnit$1(_this._unit)) : t1;
            }
        };
        A.SingleUnitSassNumber__coerceToUnit_closure.prototype = {
            call$1: function(factor) {
                return new A.SingleUnitSassNumber(this.unit, this.$this._number$_value * factor, null);
            },
            $signature: 336
        };
        A.SingleUnitSassNumber__coerceValueToUnit_closure.prototype = {
            call$1: function(factor) {
                return this.$this._number$_value * factor;
            },
            $signature: 12
        };
        A.SingleUnitSassNumber_multiplyUnits_closure.prototype = {
            call$1: function(denominator) {
                var factor = A.conversionFactor(denominator, this.$this._unit);
                if (factor == null) return false;
                this._box_0.value *= factor;
                return true;
            },
            $signature: 4
        };
        A.SingleUnitSassNumber_multiplyUnits_closure0.prototype = {
            call$0: function() {
                var t1 = A._setArrayType([
                    this.$this._unit
                ], type$.JSArray_String), t2 = this._box_0;
                B.JSArray_methods.addAll$1(t1, t2.newNumerators);
                t2.newNumerators = t1;
            },
            $signature: 0
        };
        A.UnitlessSassNumber.prototype = {
            get$numeratorUnits: function(_) {
                return B.List_empty;
            },
            get$denominatorUnits: function(_) {
                return B.List_empty;
            },
            get$hasUnits: function() {
                return false;
            },
            get$hasComplexUnits: function() {
                return false;
            },
            withValue$1: function(value) {
                return new A.UnitlessSassNumber(value, null);
            },
            withSlash$2: function(numerator, denominator) {
                return new A.UnitlessSassNumber(this._number$_value, new A._Record_2(numerator, denominator));
            },
            hasUnit$1: function(unit) {
                return false;
            },
            hasCompatibleUnits$1: function(other) {
                return other instanceof A.UnitlessSassNumber;
            },
            hasPossiblyCompatibleUnits$1: function(other) {
                return other instanceof A.UnitlessSassNumber;
            },
            compatibleWithUnit$1: function(unit) {
                return true;
            },
            coerceToMatch$1: function(other) {
                return other.withValue$1(this._number$_value);
            },
            coerceValueToMatch$3: function(other, $name, otherName) {
                return this._number$_value;
            },
            coerceValueToMatch$1: function(other) {
                return this.coerceValueToMatch$3(other, null, null);
            },
            convertValueToMatch$3: function(other, $name, otherName) {
                return other.get$hasUnits() ? this.super$SassNumber$convertValueToMatch(other, $name, otherName) : this._number$_value;
            },
            convertValueToMatch$1: function(other) {
                return this.convertValueToMatch$3(other, null, null);
            },
            coerce$2: function(newNumerators, newDenominators) {
                return A.SassNumber_SassNumber$withUnits(this._number$_value, newDenominators, newNumerators);
            },
            coerceValue$3: function(newNumerators, newDenominators, $name) {
                return this._number$_value;
            },
            coerceValueToUnit$2: function(unit, $name) {
                return this._number$_value;
            },
            coerceValueToUnit$1: function(unit) {
                return this.coerceValueToUnit$2(unit, null);
            },
            greaterThan$1: function(other) {
                var t1, t2;
                if (other instanceof A.SassNumber) {
                    t1 = this._number$_value;
                    t2 = other._number$_value;
                    return t1 > t2 && !A.fuzzyEquals(t1, t2) ? B.SassBoolean_true : B.SassBoolean_false;
                }
                return this.super$SassNumber$greaterThan(other);
            },
            greaterThanOrEquals$1: function(other) {
                var t1, t2;
                if (other instanceof A.SassNumber) {
                    t1 = this._number$_value;
                    t2 = other._number$_value;
                    return t1 > t2 || A.fuzzyEquals(t1, t2) ? B.SassBoolean_true : B.SassBoolean_false;
                }
                return this.super$SassNumber$greaterThanOrEquals(other);
            },
            lessThan$1: function(other) {
                var t1, t2;
                if (other instanceof A.SassNumber) {
                    t1 = this._number$_value;
                    t2 = other._number$_value;
                    return t1 < t2 && !A.fuzzyEquals(t1, t2) ? B.SassBoolean_true : B.SassBoolean_false;
                }
                return this.super$SassNumber$lessThan(other);
            },
            lessThanOrEquals$1: function(other) {
                var t1, t2;
                if (other instanceof A.SassNumber) {
                    t1 = this._number$_value;
                    t2 = other._number$_value;
                    return t1 < t2 || A.fuzzyEquals(t1, t2) ? B.SassBoolean_true : B.SassBoolean_false;
                }
                return this.super$SassNumber$lessThanOrEquals(other);
            },
            modulo$1: function(other) {
                if (other instanceof A.SassNumber) return other.withValue$1(A.moduloLikeSass(this._number$_value, other._number$_value));
                return this.super$SassNumber$modulo(other);
            },
            plus$1: function(other) {
                if (other instanceof A.SassNumber) return other.withValue$1(this._number$_value + other._number$_value);
                return this.super$SassNumber$plus(other);
            },
            minus$1: function(other) {
                if (other instanceof A.SassNumber) return other.withValue$1(this._number$_value - other._number$_value);
                return this.super$SassNumber$minus(other);
            },
            times$1: function(other) {
                if (other instanceof A.SassNumber) return other.withValue$1(this._number$_value * other._number$_value);
                return this.super$SassNumber$times(other);
            },
            dividedBy$1: function(other) {
                var t1, t2;
                if (other instanceof A.SassNumber) {
                    t1 = this._number$_value / other._number$_value;
                    if (other.get$hasUnits()) {
                        t2 = other.get$denominatorUnits(other);
                        t2 = A.SassNumber_SassNumber$withUnits(t1, other.get$numeratorUnits(other), t2);
                        t1 = t2;
                    } else t1 = new A.UnitlessSassNumber(t1, null);
                    return t1;
                }
                return this.super$SassNumber$dividedBy(other);
            },
            unaryMinus$0: function() {
                return new A.UnitlessSassNumber(-this._number$_value, null);
            },
            $eq: function(_, other) {
                if (other == null) return false;
                return other instanceof A.UnitlessSassNumber && A.fuzzyEquals(this._number$_value, other._number$_value);
            },
            get$hashCode: function(_) {
                var t1 = this.hashCache;
                return t1 == null ? this.hashCache = A.fuzzyHashCode(this._number$_value) : t1;
            }
        };
        A.SassString.prototype = {
            get$_sassLength: function() {
                var result, _this = this, value = _this.__SassString__sassLength_FI;
                if (value === $) {
                    result = new A.Runes(_this._string$_text).get$length(0);
                    _this.__SassString__sassLength_FI !== $ && A.throwUnnamedLateFieldADI();
                    _this.__SassString__sassLength_FI = result;
                    value = result;
                }
                return value;
            },
            get$isSpecialNumber: function() {
                var t1, _2_0, t2, _0_0, _1_0;
                if (this._hasQuotes) return false;
                t1 = this._string$_text;
                if (t1.length < 6) return false;
                _2_0 = t1.charCodeAt(0);
                $label0$0: {
                    t2 = false;
                    if (97 === _2_0 || 65 === _2_0) {
                        t1 = (t1.charCodeAt(1) | 32) === 116 && (t1.charCodeAt(2) | 32) === 116 && (t1.charCodeAt(3) | 32) === 114 && t1.charCodeAt(4) === 40;
                        break $label0$0;
                    }
                    if (99 === _2_0 || 67 === _2_0) {
                        _0_0 = t1.charCodeAt(1);
                        $label1$1: {
                            if (108 === _0_0 || 76 === _0_0) {
                                t1 = (t1.charCodeAt(2) | 32) === 97 && (t1.charCodeAt(3) | 32) === 109 && (t1.charCodeAt(4) | 32) === 112 && t1.charCodeAt(5) === 40;
                                break $label1$1;
                            }
                            if (97 === _0_0 || 65 === _0_0) {
                                t1 = (t1.charCodeAt(2) | 32) === 108 && (t1.charCodeAt(3) | 32) === 99 && t1.charCodeAt(4) === 40;
                                break $label1$1;
                            }
                            t1 = t2;
                            break $label1$1;
                        }
                        break $label0$0;
                    }
                    if (118 === _2_0 || 86 === _2_0) {
                        t1 = (t1.charCodeAt(1) | 32) === 97 && (t1.charCodeAt(2) | 32) === 114 && t1.charCodeAt(3) === 40;
                        break $label0$0;
                    }
                    if (101 === _2_0 || 69 === _2_0) {
                        t1 = (t1.charCodeAt(1) | 32) === 110 && (t1.charCodeAt(2) | 32) === 118 && t1.charCodeAt(3) === 40;
                        break $label0$0;
                    }
                    if (109 === _2_0 || 77 === _2_0) {
                        _1_0 = t1.charCodeAt(1);
                        $label2$2: {
                            if (97 === _1_0 || 65 === _1_0) {
                                t1 = (t1.charCodeAt(2) | 32) === 120 && t1.charCodeAt(3) === 40;
                                break $label2$2;
                            }
                            if (105 === _1_0 || 73 === _1_0) {
                                t1 = (t1.charCodeAt(2) | 32) === 110 && t1.charCodeAt(3) === 40;
                                break $label2$2;
                            }
                            t1 = t2;
                            break $label2$2;
                        }
                        break $label0$0;
                    }
                    if (105 === _2_0 || 73 === _2_0) {
                        t1 = (t1.charCodeAt(1) | 32) === 102 && t1.charCodeAt(2) === 40;
                        break $label0$0;
                    }
                    t1 = t2;
                    break $label0$0;
                }
                return t1;
            },
            get$isSpecialVariable: function() {
                var t1, _0_0;
                if (this._hasQuotes) return false;
                t1 = this._string$_text;
                if (t1.length < 6) return false;
                _0_0 = t1.charCodeAt(0);
                $label0$0: {
                    if (97 === _0_0 || 65 === _0_0) {
                        t1 = (t1.charCodeAt(1) | 32) === 116 && (t1.charCodeAt(2) | 32) === 116 && (t1.charCodeAt(3) | 32) === 114 && t1.charCodeAt(4) === 40;
                        break $label0$0;
                    }
                    if (105 === _0_0 || 73 === _0_0) {
                        t1 = (t1.charCodeAt(1) | 32) === 102 && t1.charCodeAt(2) === 40;
                        break $label0$0;
                    }
                    if (118 === _0_0 || 86 === _0_0) {
                        t1 = (t1.charCodeAt(1) | 32) === 97 && (t1.charCodeAt(2) | 32) === 114 && t1.charCodeAt(3) === 40;
                        break $label0$0;
                    }
                    t1 = false;
                    break $label0$0;
                }
                return t1;
            },
            get$isBlank: function() {
                return !this._hasQuotes && this._string$_text.length === 0;
            },
            assertQuoted$1: function($name) {
                if (this._hasQuotes) return;
                throw A.wrapException(A.SassScriptException$("Expected " + this.toString$0(0) + " to be a quoted string.", $name));
            },
            assertUnquoted$1: function($name) {
                if (!this._hasQuotes) return;
                throw A.wrapException(A.SassScriptException$("Expected " + this.toString$0(0) + " to be an unquoted string.", $name));
            },
            assertUnquoted$0: function() {
                return this.assertUnquoted$1(null);
            },
            accept$1$1: function(visitor) {
                var t1 = visitor._quote && this._hasQuotes, t2 = this._string$_text;
                if (t1) visitor._visitQuotedString$1(t2);
                else visitor._visitUnquotedString$1(t2);
                return null;
            },
            accept$1: function(visitor) {
                return this.accept$1$1(visitor, type$.dynamic);
            },
            assertString$1: function($name) {
                return this;
            },
            plus$1: function(other) {
                var t1 = this._string$_text, t2 = this._hasQuotes;
                return other instanceof A.SassString ? new A.SassString(t1 + other._string$_text, t2) : new A.SassString(t1 + A.serializeValue(other, false, true), t2);
            },
            $eq: function(_, other) {
                if (other == null) return false;
                return other instanceof A.SassString && this._string$_text === other._string$_text;
            },
            get$hashCode: function(_) {
                var t1 = this._hashCache;
                return t1 == null ? this._hashCache = B.JSString_methods.get$hashCode(this._string$_text) : t1;
            }
        };
        A.AnySelectorVisitor.prototype = {
            visitComplexSelector$1: function(complex) {
                return B.JSArray_methods.any$1(complex.components, new A.AnySelectorVisitor_visitComplexSelector_closure(this));
            },
            visitCompoundSelector$1: function(compound) {
                return B.JSArray_methods.any$1(compound.components, new A.AnySelectorVisitor_visitCompoundSelector_closure(this));
            },
            visitPseudoSelector$1: function(_, pseudo) {
                var selector = pseudo.selector;
                return selector == null ? false : this.visitSelectorList$1(selector);
            },
            visitSelectorList$1: function(list) {
                return B.JSArray_methods.any$1(list.components, this.get$visitComplexSelector());
            },
            visitAttributeSelector$1: function(_, attribute) {
                return false;
            },
            visitClassSelector$1: function(_, klass) {
                return false;
            },
            visitIDSelector$1: function(_, id) {
                return false;
            },
            visitParentSelector$1: function(_, $parent) {
                return false;
            },
            visitPlaceholderSelector$1: function(_, placeholder) {
                return false;
            },
            visitTypeSelector$1: function(_, type) {
                return false;
            },
            visitUniversalSelector$1: function(_, universal) {
                return false;
            }
        };
        A.AnySelectorVisitor_visitComplexSelector_closure.prototype = {
            call$1: function(component) {
                return this.$this.visitCompoundSelector$1(component.selector);
            },
            $signature: 54
        };
        A.AnySelectorVisitor_visitCompoundSelector_closure.prototype = {
            call$1: function(simple) {
                return simple.accept$1(this.$this);
            },
            $signature: 14
        };
        A._EvaluateVisitor0.prototype = {
            get$_async_evaluate$_hasCssNesting: function() {
                var _0_0, t1, grandparent, $parent = this._async_evaluate$_atRootExcludingStyleRule ? null : this._async_evaluate$_styleRuleIgnoringAtRoot;
                for(;; $parent = grandparent){
                    _0_0 = $parent == null ? null : $parent._parent;
                    if (_0_0 instanceof A.ModifiableCssStyleRule) return true;
                    t1 = _0_0 != null;
                    grandparent = t1 ? _0_0 : null;
                    if (t1) continue;
                    return false;
                }
            },
            _EvaluateVisitor$6$functions$importCache$logger$nodeImporter$quietDeps$sourceMap0: function(functions, importCache, logger, nodeImporter, quietDeps, sourceMap) {
                var t2, metaModule, t3, _i, module, $function, t4, _this = this, _s20_ = "$name, $module: null", _s9_ = "sass:meta", _s7_ = "$module", t1 = type$.JSArray_AsyncBuiltInCallable, metaFunctions = A._setArrayType([
                    A.BuiltInCallable$function("global-variable-exists", _s20_, new A._EvaluateVisitor_closure12(_this), _s9_),
                    A.BuiltInCallable$function("variable-exists", "$name", new A._EvaluateVisitor_closure13(_this), _s9_),
                    A.BuiltInCallable$function("function-exists", _s20_, new A._EvaluateVisitor_closure14(_this), _s9_),
                    A.BuiltInCallable$function("mixin-exists", _s20_, new A._EvaluateVisitor_closure15(_this), _s9_),
                    A.BuiltInCallable$function("content-exists", "", new A._EvaluateVisitor_closure16(_this), _s9_),
                    A.BuiltInCallable$function("module-variables", _s7_, new A._EvaluateVisitor_closure17(_this), _s9_),
                    A.BuiltInCallable$function("module-functions", _s7_, new A._EvaluateVisitor_closure18(_this), _s9_),
                    A.BuiltInCallable$function("module-mixins", _s7_, new A._EvaluateVisitor_closure19(_this), _s9_),
                    A.BuiltInCallable$function("get-function", "$name, $css: false, $module: null", new A._EvaluateVisitor_closure20(_this), _s9_),
                    A.BuiltInCallable$function("get-mixin", _s20_, new A._EvaluateVisitor_closure21(_this), _s9_),
                    new A.AsyncBuiltInCallable("call", A.ScssParser$("@function call($function, $args...) {", false, _s9_).parseParameterList$0(), new A._EvaluateVisitor_closure22(_this), false)
                ], t1), metaMixins = A._setArrayType([
                    A.AsyncBuiltInCallable$mixin("load-css", "$url, $with: null", new A._EvaluateVisitor_closure23(_this), false, _s9_),
                    A.AsyncBuiltInCallable$mixin("apply", "$mixin, $args...", new A._EvaluateVisitor_closure24(_this), true, _s9_)
                ], t1);
                t1 = type$.AsyncBuiltInCallable;
                t2 = A.List_List$_of($.$get$moduleFunctions(), t1);
                B.JSArray_methods.addAll$1(t2, metaFunctions);
                metaModule = A.BuiltInModule$("meta", t2, metaMixins, null, t1);
                t1 = A.List_List$_of($.$get$coreModules(), type$.BuiltInModule_AsyncCallable);
                t1.push(metaModule);
                t2 = t1.length;
                t3 = _this._async_evaluate$_builtInModules;
                _i = 0;
                for(; _i < t1.length; t1.length === t2 || (0, A.throwConcurrentModificationError)(t1), ++_i){
                    module = t1[_i];
                    t3.$indexSet(0, module.url, module);
                }
                t1 = type$.JSArray_AsyncCallable;
                t2 = A._setArrayType([], t1);
                B.JSArray_methods.addAll$1(t2, $.$get$globalFunctions());
                t1 = A._setArrayType([], t1);
                for(_i = 0; _i < 11; ++_i)t1.push(metaFunctions[_i].withDeprecationWarning$1("meta"));
                B.JSArray_methods.addAll$1(t2, t1);
                for(t1 = t2.length, t3 = _this._async_evaluate$_builtInFunctions, _i = 0; _i < t2.length; t2.length === t1 || (0, A.throwConcurrentModificationError)(t2), ++_i){
                    $function = t2[_i];
                    t4 = $function.get$name($function);
                    t3.$indexSet(0, A.stringReplaceAllUnchecked(t4, "_", "-"), $function);
                }
            },
            run$2: function(_, importer, node) {
                return this.run$body$_EvaluateVisitor(0, importer, node);
            },
            run$body$_EvaluateVisitor: function(_, importer, node) {
                var $async$goto = 0, $async$completer = A._makeAsyncAwaitCompleter(type$.Record_2_Set_Uri_loadedUrls_and_CssStylesheet_stylesheet), $async$returnValue, $async$handler = 2, $async$errorStack = [], $async$self = this, error, stackTrace, t1, exception, $async$exception;
                var $async$run$2 = A._wrapJsFunctionForAsync(function($async$errorCode, $async$result) {
                    if ($async$errorCode === 1) {
                        $async$errorStack.push($async$result);
                        $async$goto = $async$handler;
                    }
                    for(;;)switch($async$goto){
                        case 0:
                            // Function start
                            $async$handler = 4;
                            t1 = type$.nullable_Object;
                            t1 = A.runZoned(new A._EvaluateVisitor_run_closure0($async$self, node, importer), A.LinkedHashMap_LinkedHashMap$_literal([
                                B.Symbol__evaluationContext,
                                new A._EvaluationContext0($async$self, node)
                            ], t1, t1), type$.FutureOr_Record_2_Set_Uri_loadedUrls_and_CssStylesheet_stylesheet);
                            $async$goto = 7;
                            return A._asyncAwait(type$.Future_Record_2_Set_Uri_loadedUrls_and_CssStylesheet_stylesheet._is(t1) ? t1 : A._Future$value(t1, type$.Record_2_Set_Uri_loadedUrls_and_CssStylesheet_stylesheet), $async$run$2);
                        case 7:
                            // returning from await.
                            t1 = $async$result;
                            $async$returnValue = t1;
                            // goto return
                            $async$goto = 1;
                            break;
                        case 4:
                            // catch
                            $async$handler = 3;
                            $async$exception = $async$errorStack.pop();
                            t1 = A.unwrapException($async$exception);
                            if (t1 instanceof A.SassException) {
                                error = t1;
                                stackTrace = A.getTraceFromException($async$exception);
                                A.throwWithTrace(error.withLoadedUrls$1($async$self._async_evaluate$_loadedUrls), error, stackTrace);
                            } else throw $async$exception;
                            // goto after finally
                            $async$goto = 6;
                            break;
                        case 3:
                            // uncaught
                            // goto rethrow
                            $async$goto = 2;
                            break;
                        case 6:
                        // after finally
                        case 1:
                            // return
                            return A._asyncReturn($async$returnValue, $async$completer);
                        case 2:
                            // rethrow
                            return A._asyncRethrow($async$errorStack.at(-1), $async$completer);
                    }
                });
                return A._asyncStartSync($async$run$2, $async$completer);
            },
            _async_evaluate$_assertInModule$1$2: function(value, $name) {
                if (value != null) return value;
                throw A.wrapException(A.StateError$("Can't access " + $name + " outside of a module."));
            },
            _async_evaluate$_assertInModule$2: function(value, $name) {
                return this._async_evaluate$_assertInModule$1$2(value, $name, type$.dynamic);
            },
            _async_evaluate$_loadModule$7$baseUrl$configuration$namesInErrors: function(url, stackFrame, nodeWithSpan, callback, baseUrl, configuration, namesInErrors) {
                return this._loadModule$body$_EvaluateVisitor(url, stackFrame, nodeWithSpan, callback, baseUrl, configuration, namesInErrors);
            },
            _async_evaluate$_loadModule$5$configuration: function(url, stackFrame, nodeWithSpan, callback, configuration) {
                return this._async_evaluate$_loadModule$7$baseUrl$configuration$namesInErrors(url, stackFrame, nodeWithSpan, callback, null, configuration, false);
            },
            _async_evaluate$_loadModule$4: function(url, stackFrame, nodeWithSpan, callback) {
                return this._async_evaluate$_loadModule$7$baseUrl$configuration$namesInErrors(url, stackFrame, nodeWithSpan, callback, null, null, false);
            },
            _loadModule$body$_EvaluateVisitor: function(url, stackFrame, nodeWithSpan, callback, baseUrl, configuration, namesInErrors) {
                var $async$goto = 0, $async$completer = A._makeAsyncAwaitCompleter(type$.void), $async$returnValue, $async$self = this, t2, _0_0, t1;
                var $async$_async_evaluate$_loadModule$7$baseUrl$configuration$namesInErrors = A._wrapJsFunctionForAsync(function($async$errorCode, $async$result) {
                    if ($async$errorCode === 1) return A._asyncRethrow($async$result, $async$completer);
                    for(;;)switch($async$goto){
                        case 0:
                            // Function start
                            _0_0 = $async$self._async_evaluate$_builtInModules.$index(0, url);
                            t1 = {};
                            t1.builtInModule = null;
                            $async$goto = _0_0 != null ? 3 : 4;
                            break;
                        case 3:
                            // then
                            t1.builtInModule = _0_0;
                            if (configuration instanceof A.ExplicitConfiguration) {
                                t1 = namesInErrors ? "Built-in module " + url.toString$0(0) + " can't be configured." : "Built-in modules can't be configured.";
                                t2 = configuration.nodeWithSpan;
                                throw A.wrapException($async$self._async_evaluate$_exception$2(t1, t2.get$span(t2)));
                            }
                            $async$goto = 5;
                            return A._asyncAwait($async$self._addExceptionSpanAsync$1$2(nodeWithSpan, new A._EvaluateVisitor__loadModule_closure1(t1, callback), type$.void), $async$_async_evaluate$_loadModule$7$baseUrl$configuration$namesInErrors);
                        case 5:
                            // returning from await.
                            // goto return
                            $async$goto = 1;
                            break;
                        case 4:
                            // join
                            $async$goto = 6;
                            return A._asyncAwait($async$self._async_evaluate$_withStackFrame$1$3(stackFrame, nodeWithSpan, new A._EvaluateVisitor__loadModule_closure2($async$self, url, nodeWithSpan, baseUrl, namesInErrors, configuration, callback), type$.Null), $async$_async_evaluate$_loadModule$7$baseUrl$configuration$namesInErrors);
                        case 6:
                        // returning from await.
                        case 1:
                            // return
                            return A._asyncReturn($async$returnValue, $async$completer);
                    }
                });
                return A._asyncStartSync($async$_async_evaluate$_loadModule$7$baseUrl$configuration$namesInErrors, $async$completer);
            },
            _async_evaluate$_execute$5$configuration$namesInErrors$nodeWithSpan: function(importer, stylesheet, configuration, namesInErrors, nodeWithSpan) {
                return this._execute$body$_EvaluateVisitor(importer, stylesheet, configuration, namesInErrors, nodeWithSpan);
            },
            _async_evaluate$_execute$2: function(importer, stylesheet) {
                return this._async_evaluate$_execute$5$configuration$namesInErrors$nodeWithSpan(importer, stylesheet, null, false, null);
            },
            _execute$body$_EvaluateVisitor: function(importer, stylesheet, configuration, namesInErrors, nodeWithSpan) {
                var $async$goto = 0, $async$completer = A._makeAsyncAwaitCompleter(type$.Module_AsyncCallable), $async$returnValue, $async$self = this, currentConfiguration, t2, _0_0, t3, message, existingSpan, configurationSpan, environment, css, preModuleComments, extensionStore, module, t1, url;
                var $async$_async_evaluate$_execute$5$configuration$namesInErrors$nodeWithSpan = A._wrapJsFunctionForAsync(function($async$errorCode, $async$result) {
                    if ($async$errorCode === 1) return A._asyncRethrow($async$result, $async$completer);
                    for(;;)switch($async$goto){
                        case 0:
                            // Function start
                            t1 = stylesheet.span;
                            url = t1.get$sourceUrl(t1);
                            t1 = configuration == null;
                            currentConfiguration = t1 ? $async$self._async_evaluate$_configuration : configuration;
                            t2 = $async$self._async_evaluate$_modules;
                            _0_0 = t2.$index(0, url);
                            if (_0_0 != null) {
                                t2 = $async$self._async_evaluate$_moduleConfigurations.$index(0, url);
                                t3 = t2.__originalConfiguration;
                                t2 = t3 == null ? t2 : t3;
                                t3 = currentConfiguration.__originalConfiguration;
                                if (t2 !== (t3 == null ? currentConfiguration : t3) && currentConfiguration instanceof A.ExplicitConfiguration && _0_0.couldHaveBeenConfigured$1(new A.MapKeySet(new A.UnmodifiableMapView(currentConfiguration._configuration$_values, type$.UnmodifiableMapView_String_ConfiguredValue), type$.MapKeySet_String))) {
                                    if (namesInErrors) {
                                        t2 = $.$get$context();
                                        url.toString;
                                        message = t2.prettyUri$1(url) + string$.x20was_a;
                                    } else message = string$.This_mw;
                                    t2 = $async$self._async_evaluate$_moduleNodes.$index(0, url);
                                    existingSpan = t2 == null ? null : t2.get$span(t2);
                                    if (t1) {
                                        t1 = currentConfiguration.nodeWithSpan;
                                        configurationSpan = t1.get$span(t1);
                                    } else configurationSpan = null;
                                    t1 = A.LinkedHashMap_LinkedHashMap$_empty(type$.FileSpan, type$.String);
                                    if (existingSpan != null) t1.$indexSet(0, existingSpan, "original load");
                                    if (configurationSpan != null) t1.$indexSet(0, configurationSpan, "configuration");
                                    throw A.wrapException(t1.get$isEmpty(0) ? $async$self._async_evaluate$_exception$1(message) : $async$self._async_evaluate$_multiSpanException$3(message, "new load", t1));
                                }
                                $async$returnValue = _0_0;
                                // goto return
                                $async$goto = 1;
                                break;
                            }
                            environment = A.AsyncEnvironment$();
                            css = A._Cell$();
                            preModuleComments = A._Cell$();
                            extensionStore = A.ExtensionStore$();
                            $async$goto = 3;
                            return A._asyncAwait($async$self._async_evaluate$_withEnvironment$1$2(environment, new A._EvaluateVisitor__execute_closure0($async$self, importer, stylesheet, extensionStore, configuration, css, preModuleComments), type$.Null), $async$_async_evaluate$_execute$5$configuration$namesInErrors$nodeWithSpan);
                        case 3:
                            // returning from await.
                            t1 = css._readLocal$0();
                            t3 = preModuleComments._readLocal$0();
                            module = environment.toModule$3(t1, t3 == null ? B.Map_empty7 : t3, extensionStore);
                            if (url != null) {
                                t2.$indexSet(0, url, module);
                                $async$self._async_evaluate$_moduleConfigurations.$indexSet(0, url, currentConfiguration);
                                if (nodeWithSpan != null) $async$self._async_evaluate$_moduleNodes.$indexSet(0, url, nodeWithSpan);
                            }
                            $async$returnValue = module;
                            // goto return
                            $async$goto = 1;
                            break;
                        case 1:
                            // return
                            return A._asyncReturn($async$returnValue, $async$completer);
                    }
                });
                return A._asyncStartSync($async$_async_evaluate$_execute$5$configuration$namesInErrors$nodeWithSpan, $async$completer);
            },
            _async_evaluate$_addOutOfOrderImports$0: function() {
                var t1, t2, _this = this, _s5_ = "_root", _s13_ = "_endOfImports", _0_0 = _this._async_evaluate$_outOfOrderImports;
                $label0$0: {
                    if (_0_0 == null) {
                        t1 = _this._async_evaluate$_assertInModule$2(_this._async_evaluate$__root, _s5_).children;
                        break $label0$0;
                    }
                    t1 = _this._async_evaluate$_assertInModule$2(_this._async_evaluate$__root, _s5_).children;
                    t1 = A.List_List$_of(A.SubListIterable$(t1, 0, A.checkNotNullable(_this._async_evaluate$_assertInModule$2(_this._async_evaluate$__endOfImports, _s13_), "count", type$.int), t1.$ti._eval$1("ListBase.E")), type$.ModifiableCssNode);
                    B.JSArray_methods.addAll$1(t1, _0_0);
                    t2 = _this._async_evaluate$_assertInModule$2(_this._async_evaluate$__root, _s5_).children;
                    B.JSArray_methods.addAll$1(t1, A.SubListIterable$(t2, _this._async_evaluate$_assertInModule$2(_this._async_evaluate$__endOfImports, _s13_), null, t2.$ti._eval$1("ListBase.E")));
                    break $label0$0;
                }
                return t1;
            },
            _async_evaluate$_combineCss$2$clone: function(root, clone) {
                var selectors, _0_0, t1, imports, css, sorted, t2;
                if (!B.JSArray_methods.any$1(root.get$upstream(), new A._EvaluateVisitor__combineCss_closure1())) {
                    selectors = root.get$extensionStore().get$simpleSelectors();
                    _0_0 = A.IterableExtension_get_firstOrNull(root.get$extensionStore().extensionsWhereTarget$1(new A._EvaluateVisitor__combineCss_closure2(selectors)));
                    if (_0_0 != null) this._async_evaluate$_throwForUnsatisfiedExtension$1(_0_0);
                    return root.get$css(root);
                }
                t1 = type$.JSArray_CssNode;
                imports = A._setArrayType([], t1);
                css = A._setArrayType([], t1);
                t1 = type$.Module_AsyncCallable;
                sorted = A.ListQueue$(t1);
                new A._EvaluateVisitor__combineCss_visitModule0(this, A.LinkedHashSet_LinkedHashSet$_empty(t1), clone, css, imports, sorted).call$1(root);
                if (root.get$transitivelyContainsExtensions()) this._async_evaluate$_extendModules$1(sorted);
                t1 = B.JSArray_methods.$add(imports, css);
                t2 = root.get$css(root);
                return new A.CssStylesheet(new A.UnmodifiableListView(t1, type$.UnmodifiableListView_CssNode), t2.get$span(t2));
            },
            _async_evaluate$_combineCss$1: function(root) {
                return this._async_evaluate$_combineCss$2$clone(root, false);
            },
            _async_evaluate$_extendModules$1: function(sortedModules) {
                var t1, t2, t3, originalSelectors, $self, t4, t5, _i, upstream, _0_0, downstreamExtensionStores = A.LinkedHashMap_LinkedHashMap$_empty(type$.Uri, type$.List_ExtensionStore), unsatisfiedExtensions = new A._LinkedIdentityHashSet(type$._LinkedIdentityHashSet_Extension);
                for(t1 = A._ListQueueIterator$(sortedModules, sortedModules.$ti._precomputed1), t2 = t1.$ti._precomputed1; t1.moveNext$0();){
                    t3 = t1._collection$_current;
                    if (t3 == null) t3 = t2._as(t3);
                    originalSelectors = t3.get$extensionStore().get$simpleSelectors().toSet$0(0);
                    unsatisfiedExtensions.addAll$1(0, t3.get$extensionStore().extensionsWhereTarget$1(new A._EvaluateVisitor__extendModules_closure1(originalSelectors)));
                    $self = downstreamExtensionStores.$index(0, t3.get$url(t3));
                    t4 = t3.get$extensionStore().get$addExtensions();
                    if ($self != null) t4.call$1($self);
                    t4 = t3.get$extensionStore();
                    if (t4.get$isEmpty(t4)) continue;
                    for(t4 = t3.get$upstream(), t5 = t4.length, _i = 0; _i < t4.length; t4.length === t5 || (0, A.throwConcurrentModificationError)(t4), ++_i){
                        upstream = t4[_i];
                        _0_0 = upstream.get$url(upstream);
                        if (_0_0 != null) J.add$1$ax(downstreamExtensionStores.putIfAbsent$2(_0_0, new A._EvaluateVisitor__extendModules_closure2()), t3.get$extensionStore());
                    }
                    unsatisfiedExtensions.removeAll$1(t3.get$extensionStore().extensionsWhereTarget$1(originalSelectors.get$contains(originalSelectors)));
                }
                if (unsatisfiedExtensions._collection$_length !== 0) this._async_evaluate$_throwForUnsatisfiedExtension$1(unsatisfiedExtensions.get$first(0));
            },
            _async_evaluate$_throwForUnsatisfiedExtension$1: function(extension) {
                throw A.wrapException(A.SassException$(string$.The_ta + extension.target.toString$0(0) + ' !optional" to avoid this error.', extension.span, null));
            },
            _async_evaluate$_indexAfterImports$1: function(statements) {
                var t1, lastImport, i, _0_0;
                for(t1 = J.getInterceptor$asx(statements), lastImport = -1, i = 0; i < t1.get$length(statements); ++i){
                    $label0$0: {
                        _0_0 = t1.$index(statements, i);
                        if (_0_0 instanceof A.ModifiableCssImport) break $label0$0;
                        if (_0_0 instanceof A.ModifiableCssComment) continue;
                        break;
                    }
                    lastImport = i;
                }
                return lastImport + 1;
            },
            visitStylesheet$1: function(_, node) {
                return this.visitStylesheet$body$_EvaluateVisitor(0, node);
            },
            visitStylesheet$body$_EvaluateVisitor: function(_, node) {
                var $async$goto = 0, $async$completer = A._makeAsyncAwaitCompleter(type$.nullable_Value), $async$returnValue, $async$self = this, t1, t2, warning, _i, $name, span;
                var $async$visitStylesheet$1 = A._wrapJsFunctionForAsync(function($async$errorCode, $async$result) {
                    if ($async$errorCode === 1) return A._asyncRethrow($async$result, $async$completer);
                    for(;;)switch($async$goto){
                        case 0:
                            // Function start
                            for(t1 = node.parseTimeWarnings, t2 = t1.$ti, t1 = new A.ListIterator(t1, t1.get$length(0), t2._eval$1("ListIterator<ListBase.E>")), t2 = t2._eval$1("ListBase.E"); t1.moveNext$0();){
                                warning = t1.__internal$_current;
                                if (warning == null) warning = t2._as(warning);
                                $async$self._async_evaluate$_warn$3(warning._1, warning._2, warning._0);
                            }
                            t1 = node.children, t2 = t1.length, _i = 0;
                        case 3:
                            // for condition
                            if (!(_i < t2)) {
                                // goto after for
                                $async$goto = 5;
                                break;
                            }
                            $async$goto = 6;
                            return A._asyncAwait(t1[_i].accept$1($async$self), $async$visitStylesheet$1);
                        case 6:
                        // returning from await.
                        case 4:
                            // for update
                            ++_i;
                            // goto for condition
                            $async$goto = 3;
                            break;
                        case 5:
                            // after for
                            for(t1 = A.MapExtensions_get_pairs(node.globalVariables, type$.String, type$.FileSpan), t1 = t1.get$iterator(t1); t1.moveNext$0();){
                                t2 = t1.get$current(t1);
                                $name = t2._0;
                                span = t2._1;
                                $async$self.visitVariableDeclaration$1(0, new A.VariableDeclaration(null, $name, new A.NullExpression(span), true, false, span));
                            }
                            $async$returnValue = null;
                            // goto return
                            $async$goto = 1;
                            break;
                        case 1:
                            // return
                            return A._asyncReturn($async$returnValue, $async$completer);
                    }
                });
                return A._asyncStartSync($async$visitStylesheet$1, $async$completer);
            },
            visitAtRootRule$1: function(_, node) {
                return this.visitAtRootRule$body$_EvaluateVisitor(0, node);
            },
            visitAtRootRule$body$_EvaluateVisitor: function(_, node) {
                var $async$goto = 0, $async$completer = A._makeAsyncAwaitCompleter(type$.nullable_Value), $async$returnValue, $async$self = this, _1_0, resolved, query, $parent, included, t1, _2_0, root, first, rest, innerCopy, outerCopy, _i, copy, _0_0;
                var $async$visitAtRootRule$1 = A._wrapJsFunctionForAsync(function($async$errorCode, $async$result) {
                    if ($async$errorCode === 1) return A._asyncRethrow($async$result, $async$completer);
                    for(;;)switch($async$goto){
                        case 0:
                            // Function start
                            _0_0 = node.query;
                            $async$goto = _0_0 != null ? 3 : 5;
                            break;
                        case 3:
                            // then
                            $async$goto = 6;
                            return A._asyncAwait($async$self._async_evaluate$_performInterpolationWithMap$2$warnForColor(_0_0, true), $async$visitAtRootRule$1);
                        case 6:
                            // returning from await.
                            _1_0 = $async$result;
                            resolved = _1_0._0;
                            _1_0._1;
                            query = new A.AtRootQueryParser(A.SpanScanner$(resolved, null), null).parse$0(0);
                            // goto join
                            $async$goto = 4;
                            break;
                        case 5:
                            // else
                            query = B.AtRootQuery_bfj;
                        case 4:
                            // join
                            $parent = $async$self._async_evaluate$_assertInModule$2($async$self._async_evaluate$__parent, "__parent");
                            included = A._setArrayType([], type$.JSArray_ModifiableCssParentNode);
                            for(t1 = type$.CssStylesheet; !t1._is($parent); $parent = _2_0){
                                if (!query.excludes$1($parent)) included.push($parent);
                                _2_0 = $parent._parent;
                                if (_2_0 == null) throw A.wrapException(A.StateError$(string$.CssNod));
                            }
                            root = $async$self._async_evaluate$_trimIncluded$1(included);
                            $async$goto = root === $async$self._async_evaluate$_assertInModule$2($async$self._async_evaluate$__parent, "__parent") ? 7 : 8;
                            break;
                        case 7:
                            // then
                            $async$goto = 9;
                            return A._asyncAwait($async$self._async_evaluate$_environment.scope$1$2$when(new A._EvaluateVisitor_visitAtRootRule_closure1($async$self, node), node.hasDeclarations, type$.Null), $async$visitAtRootRule$1);
                        case 9:
                            // returning from await.
                            $async$returnValue = null;
                            // goto return
                            $async$goto = 1;
                            break;
                        case 8:
                            // join
                            if (included.length >= 1) {
                                first = included[0];
                                rest = B.JSArray_methods.sublist$1(included, 1);
                                innerCopy = first.copyWithoutChildren$0();
                                for(t1 = rest.length, outerCopy = innerCopy, _i = 0; _i < rest.length; rest.length === t1 || (0, A.throwConcurrentModificationError)(rest), ++_i, outerCopy = copy){
                                    copy = rest[_i].copyWithoutChildren$0();
                                    copy.addChild$1(outerCopy);
                                }
                                root.addChild$1(outerCopy);
                            } else innerCopy = root;
                            $async$goto = 10;
                            return A._asyncAwait($async$self._async_evaluate$_scopeForAtRoot$4(node, innerCopy, query, included).call$1(new A._EvaluateVisitor_visitAtRootRule_closure2($async$self, node)), $async$visitAtRootRule$1);
                        case 10:
                            // returning from await.
                            $async$returnValue = null;
                            // goto return
                            $async$goto = 1;
                            break;
                        case 1:
                            // return
                            return A._asyncReturn($async$returnValue, $async$completer);
                    }
                });
                return A._asyncStartSync($async$visitAtRootRule$1, $async$completer);
            },
            _async_evaluate$_trimIncluded$1: function(nodes) {
                var $parent, t1, innermostContiguous, i, t2, _0_0, _1_0, root, _this = this, _null = null, _s5_ = "_root", _s22_ = " to be an ancestor of ";
                if (nodes.length === 0) return _this._async_evaluate$_assertInModule$2(_this._async_evaluate$__root, _s5_);
                $parent = _this._async_evaluate$_assertInModule$2(_this._async_evaluate$__parent, "__parent");
                for(t1 = nodes.length, innermostContiguous = _null, i = 0; i < t1; ++i, $parent = _1_0){
                    for(; t2 = nodes[i], $parent !== t2; innermostContiguous = _null, $parent = _0_0){
                        _0_0 = $parent._parent;
                        if (_0_0 == null) throw A.wrapException(A.ArgumentError$("Expected " + t2.toString$0(0) + _s22_ + _this.toString$0(0) + ".", _null));
                    }
                    if (innermostContiguous == null) innermostContiguous = i;
                    _1_0 = $parent._parent;
                    if (_1_0 == null) throw A.wrapException(A.ArgumentError$("Expected " + t2.toString$0(0) + _s22_ + _this.toString$0(0) + ".", _null));
                }
                if ($parent !== _this._async_evaluate$_assertInModule$2(_this._async_evaluate$__root, _s5_)) return _this._async_evaluate$_assertInModule$2(_this._async_evaluate$__root, _s5_);
                innermostContiguous.toString;
                root = nodes[innermostContiguous];
                B.JSArray_methods.removeRange$2(nodes, innermostContiguous, nodes.length);
                return root;
            },
            _async_evaluate$_scopeForAtRoot$4: function(node, newParent, query, included) {
                var _this = this, scope = new A._EvaluateVisitor__scopeForAtRoot_closure5(_this, newParent, node), t1 = query._all || query._at_root_query$_rule;
                if (t1 !== query.include) scope = new A._EvaluateVisitor__scopeForAtRoot_closure6(_this, scope);
                if (_this._async_evaluate$_mediaQueries != null && query.excludesName$1("media")) scope = new A._EvaluateVisitor__scopeForAtRoot_closure7(_this, scope);
                if (_this._async_evaluate$_inKeyframes && query.excludesName$1("keyframes")) scope = new A._EvaluateVisitor__scopeForAtRoot_closure8(_this, scope);
                return _this._async_evaluate$_inUnknownAtRule && !B.JSArray_methods.any$1(included, new A._EvaluateVisitor__scopeForAtRoot_closure9()) ? new A._EvaluateVisitor__scopeForAtRoot_closure10(_this, scope) : scope;
            },
            visitContentBlock$1: function(_, node) {
                return A.throwExpression(A.UnsupportedError$(string$.Evalua));
            },
            visitContentRule$1: function(_, node) {
                return this.visitContentRule$body$_EvaluateVisitor(0, node);
            },
            visitContentRule$body$_EvaluateVisitor: function(_, node) {
                var $async$goto = 0, $async$completer = A._makeAsyncAwaitCompleter(type$.nullable_Value), $async$returnValue, $async$self = this, $content;
                var $async$visitContentRule$1 = A._wrapJsFunctionForAsync(function($async$errorCode, $async$result) {
                    if ($async$errorCode === 1) return A._asyncRethrow($async$result, $async$completer);
                    for(;;)switch($async$goto){
                        case 0:
                            // Function start
                            $content = $async$self._async_evaluate$_environment._async_environment$_content;
                            if ($content == null) {
                                $async$returnValue = null;
                                // goto return
                                $async$goto = 1;
                                break;
                            }
                            $async$goto = 3;
                            return A._asyncAwait($async$self._async_evaluate$_runUserDefinedCallable$1$4(node.$arguments, $content, node, new A._EvaluateVisitor_visitContentRule_closure0($async$self, $content), type$.Null), $async$visitContentRule$1);
                        case 3:
                            // returning from await.
                            $async$returnValue = null;
                            // goto return
                            $async$goto = 1;
                            break;
                        case 1:
                            // return
                            return A._asyncReturn($async$returnValue, $async$completer);
                    }
                });
                return A._asyncStartSync($async$visitContentRule$1, $async$completer);
            },
            visitDebugRule$1: function(_, node) {
                return this.visitDebugRule$body$_EvaluateVisitor(0, node);
            },
            visitDebugRule$body$_EvaluateVisitor: function(_, node) {
                var $async$goto = 0, $async$completer = A._makeAsyncAwaitCompleter(type$.nullable_Value), $async$returnValue, $async$self = this, value, t1;
                var $async$visitDebugRule$1 = A._wrapJsFunctionForAsync(function($async$errorCode, $async$result) {
                    if ($async$errorCode === 1) return A._asyncRethrow($async$result, $async$completer);
                    for(;;)switch($async$goto){
                        case 0:
                            // Function start
                            $async$goto = 3;
                            return A._asyncAwait(node.expression.accept$1($async$self), $async$visitDebugRule$1);
                        case 3:
                            // returning from await.
                            value = $async$result;
                            t1 = value instanceof A.SassString ? value._string$_text : A.serializeValue(value, true, true);
                            $async$self._async_evaluate$_logger.debug$2(0, t1, node.span);
                            $async$returnValue = null;
                            // goto return
                            $async$goto = 1;
                            break;
                        case 1:
                            // return
                            return A._asyncReturn($async$returnValue, $async$completer);
                    }
                });
                return A._asyncStartSync($async$visitDebugRule$1, $async$completer);
            },
            visitDeclaration$1: function(_, node) {
                return this.visitDeclaration$body$_EvaluateVisitor(0, node);
            },
            visitDeclaration$body$_EvaluateVisitor: function(_, node) {
                var $async$goto = 0, $async$completer = A._makeAsyncAwaitCompleter(type$.nullable_Value), $async$returnValue, $async$self = this, t1, $name, _0_0, _1_0, value, t2, t3, _2_0, oldDeclarationName;
                var $async$visitDeclaration$1 = A._wrapJsFunctionForAsync(function($async$errorCode, $async$result) {
                    if ($async$errorCode === 1) return A._asyncRethrow($async$result, $async$completer);
                    for(;;)switch($async$goto){
                        case 0:
                            // Function start
                            if (($async$self._async_evaluate$_atRootExcludingStyleRule ? null : $async$self._async_evaluate$_styleRuleIgnoringAtRoot) == null && !$async$self._async_evaluate$_inUnknownAtRule && !$async$self._async_evaluate$_inKeyframes) throw A.wrapException($async$self._async_evaluate$_exception$2(string$.Declarm, node.span));
                            if ($async$self._async_evaluate$_declarationName != null && !node.parsedAsSassScript) {
                                t1 = B.JSString_methods.startsWith$1(node.name.get$initialPlain(), "--") ? string$.Declarw : string$.Declarp;
                                throw A.wrapException($async$self._async_evaluate$_exception$2(t1, node.span));
                            }
                            $async$goto = 3;
                            return A._asyncAwait($async$self._async_evaluate$_interpolationToValue$2$warnForColor(node.name, true), $async$visitDeclaration$1);
                        case 3:
                            // returning from await.
                            $name = $async$result;
                            _0_0 = $async$self._async_evaluate$_declarationName;
                            if (_0_0 != null) $name = new A.CssValue(_0_0 + "-" + $name.value, $name.span, type$.CssValue_String);
                            _1_0 = node.value;
                            $async$goto = _1_0 != null ? 4 : 5;
                            break;
                        case 4:
                            // then
                            $async$goto = 6;
                            return A._asyncAwait(_1_0.accept$1($async$self), $async$visitDeclaration$1);
                        case 6:
                            // returning from await.
                            value = $async$result;
                            if (!value.get$isBlank() || value.get$asList().length === 0 || B.JSString_methods.startsWith$1($name.value, "--")) {
                                $async$self._async_evaluate$_copyParentAfterSibling$0();
                                t1 = $async$self._async_evaluate$_assertInModule$2($async$self._async_evaluate$__parent, "__parent");
                                t2 = _1_0.get$span(_1_0);
                                if ($async$self._async_evaluate$_sourceMap) {
                                    t3 = A.NullableExtension_andThen(_1_0, $async$self.get$_async_evaluate$_expressionNode());
                                    t3 = t3 == null ? null : J.get$span$x(t3);
                                } else t3 = null;
                                t1.addChild$1(A.ModifiableCssDeclaration$($name, new A.CssValue(value, t2, type$.CssValue_Value), node.span, node.parsedAsSassScript, t3));
                            }
                        case 5:
                            // join
                            _2_0 = node.children;
                            t1 = {};
                            t1.children = null;
                            $async$goto = _2_0 != null ? 7 : 8;
                            break;
                        case 7:
                            // then
                            t1.children = _2_0;
                            oldDeclarationName = $async$self._async_evaluate$_declarationName;
                            $async$self._async_evaluate$_declarationName = $name.value;
                            $async$goto = 9;
                            return A._asyncAwait($async$self._async_evaluate$_environment.scope$1$2$when(new A._EvaluateVisitor_visitDeclaration_closure0(t1, $async$self), node.hasDeclarations, type$.Null), $async$visitDeclaration$1);
                        case 9:
                            // returning from await.
                            $async$self._async_evaluate$_declarationName = oldDeclarationName;
                        case 8:
                            // join
                            $async$returnValue = null;
                            // goto return
                            $async$goto = 1;
                            break;
                        case 1:
                            // return
                            return A._asyncReturn($async$returnValue, $async$completer);
                    }
                });
                return A._asyncStartSync($async$visitDeclaration$1, $async$completer);
            },
            visitEachRule$1: function(_, node) {
                return this.visitEachRule$body$_EvaluateVisitor(0, node);
            },
            visitEachRule$body$_EvaluateVisitor: function(_, node) {
                var $async$goto = 0, $async$completer = A._makeAsyncAwaitCompleter(type$.nullable_Value), $async$returnValue, $async$self = this, t1, list, nodeWithSpan, _0_0;
                var $async$visitEachRule$1 = A._wrapJsFunctionForAsync(function($async$errorCode, $async$result) {
                    if ($async$errorCode === 1) return A._asyncRethrow($async$result, $async$completer);
                    for(;;)switch($async$goto){
                        case 0:
                            // Function start
                            t1 = node.list;
                            $async$goto = 3;
                            return A._asyncAwait(t1.accept$1($async$self), $async$visitEachRule$1);
                        case 3:
                            // returning from await.
                            list = $async$result;
                            nodeWithSpan = $async$self._async_evaluate$_expressionNode$1(t1);
                            _0_0 = node.variables;
                            $label0$0: {
                                t1 = {};
                                t1.variable = null;
                                if (_0_0.length === 1) {
                                    t1.variable = _0_0[0];
                                    t1 = new A._EvaluateVisitor_visitEachRule_closure2(t1, $async$self, nodeWithSpan);
                                    break $label0$0;
                                }
                                t1 = {};
                                t1.variables = null;
                                t1.variables = _0_0;
                                t1 = new A._EvaluateVisitor_visitEachRule_closure3(t1, $async$self, nodeWithSpan);
                                break $label0$0;
                            }
                            $async$returnValue = $async$self._async_evaluate$_environment.scope$1$2$semiGlobal(new A._EvaluateVisitor_visitEachRule_closure4($async$self, list, t1, node), true, type$.nullable_Value);
                            // goto return
                            $async$goto = 1;
                            break;
                        case 1:
                            // return
                            return A._asyncReturn($async$returnValue, $async$completer);
                    }
                });
                return A._asyncStartSync($async$visitEachRule$1, $async$completer);
            },
            _async_evaluate$_setMultipleVariables$3: function(variables, value, nodeWithSpan) {
                var i, list = value.get$asList(), t1 = variables.length, minLength = Math.min(t1, list.length);
                for(i = 0; i < minLength; ++i)this._async_evaluate$_environment.setLocalVariable$3(variables[i], this._async_evaluate$_withoutSlash$2(list[i], nodeWithSpan), nodeWithSpan);
                for(i = minLength; i < t1; ++i)this._async_evaluate$_environment.setLocalVariable$3(variables[i], B.C__SassNull, nodeWithSpan);
            },
            visitErrorRule$1: function(_, node) {
                return this.visitErrorRule$body$_EvaluateVisitor(0, node);
            },
            visitErrorRule$body$_EvaluateVisitor: function(_, node) {
                var $async$goto = 0, $async$completer = A._makeAsyncAwaitCompleter(type$.Value), $async$self = this, $async$temp1, $async$temp2;
                var $async$visitErrorRule$1 = A._wrapJsFunctionForAsync(function($async$errorCode, $async$result) {
                    if ($async$errorCode === 1) return A._asyncRethrow($async$result, $async$completer);
                    for(;;)switch($async$goto){
                        case 0:
                            // Function start
                            $async$temp1 = A;
                            $async$temp2 = J;
                            $async$goto = 2;
                            return A._asyncAwait(node.expression.accept$1($async$self), $async$visitErrorRule$1);
                        case 2:
                            // returning from await.
                            throw $async$temp1.wrapException($async$self._async_evaluate$_exception$2($async$temp2.toString$0$($async$result), node.span));
                    }
                });
                return A._asyncStartSync($async$visitErrorRule$1, $async$completer);
            },
            visitExtendRule$1: function(_, node) {
                return this.visitExtendRule$body$_EvaluateVisitor(0, node);
            },
            visitExtendRule$body$_EvaluateVisitor: function(_, node) {
                var $async$goto = 0, $async$completer = A._makeAsyncAwaitCompleter(type$.nullable_Value), $async$returnValue, $async$self = this, t1, t2, t3, t4, t5, _i, complex, visitor, t6, t7, _0_0, targetText, targetMap, compound, simple, styleRule;
                var $async$visitExtendRule$1 = A._wrapJsFunctionForAsync(function($async$errorCode, $async$result) {
                    if ($async$errorCode === 1) return A._asyncRethrow($async$result, $async$completer);
                    for(;;)switch($async$goto){
                        case 0:
                            // Function start
                            styleRule = $async$self._async_evaluate$_atRootExcludingStyleRule ? null : $async$self._async_evaluate$_styleRuleIgnoringAtRoot;
                            if (styleRule == null || $async$self._async_evaluate$_declarationName != null) throw A.wrapException($async$self._async_evaluate$_exception$2(string$.x40exten, node.span));
                            for(t1 = styleRule.originalSelector.components, t2 = t1.length, t3 = node.span, t4 = type$.SourceSpan, t5 = type$.String, _i = 0; _i < t2; ++_i){
                                complex = t1[_i];
                                if (!complex.accept$1(B._IsBogusVisitor_true)) continue;
                                visitor = A._SerializeVisitor$(null, true, null, null, true, false, null, true);
                                complex.accept$1(visitor);
                                t6 = B.JSString_methods.trim$0(visitor._serialize$_buffer.toString$0(0));
                                t7 = complex.accept$1(B.C__IsUselessVisitor) ? "can't" : "shouldn't";
                                $async$self._async_evaluate$_warn$3('The selector "' + t6 + '" is invalid CSS and ' + t7 + string$.x20be_an, new A.MultiSpan(A.SpanExtensions_trimRight(complex.span), "invalid selector", A.ConstantMap_ConstantMap$from(A.LinkedHashMap_LinkedHashMap$_literal([
                                    t3,
                                    "@extend rule"
                                ], t4, t5), t4, t5)), B.Deprecation_0rM);
                            }
                            $async$goto = 3;
                            return A._asyncAwait($async$self._async_evaluate$_performInterpolationWithMap$2$warnForColor(node.selector, true), $async$visitExtendRule$1);
                        case 3:
                            // returning from await.
                            _0_0 = $async$result;
                            targetText = _0_0._0;
                            targetMap = _0_0._1;
                            for(t1 = A.SelectorList_SelectorList$parse(A.trimAscii(targetText, true), false, targetMap, $async$self._async_evaluate$_logger, false).components, t2 = t1.length, t3 = styleRule._style_rule$_selector._box$_inner, _i = 0; _i < t2; ++_i){
                                complex = t1[_i];
                                compound = complex.get$singleCompound();
                                if (compound == null) throw A.wrapException(A.SassFormatException$("complex selectors may not be extended.", complex.span, null));
                                t4 = compound.components;
                                simple = t4.length === 1 ? B.JSArray_methods.get$first(t4) : null;
                                if (simple == null) throw A.wrapException(A.SassFormatException$(string$.compou + B.JSArray_methods.join$1(t4, ", ") + string$.x60_inst, compound.span, null));
                                $async$self._async_evaluate$_assertInModule$2($async$self._async_evaluate$__extensionStore, "_extensionStore").addExtension$4(t3.value, simple, node, $async$self._async_evaluate$_mediaQueries);
                            }
                            $async$returnValue = null;
                            // goto return
                            $async$goto = 1;
                            break;
                        case 1:
                            // return
                            return A._asyncReturn($async$returnValue, $async$completer);
                    }
                });
                return A._asyncStartSync($async$visitExtendRule$1, $async$completer);
            },
            visitAtRule$1: function(_, node) {
                return this.visitAtRule$body$_EvaluateVisitor(0, node);
            },
            visitAtRule$body$_EvaluateVisitor: function(_, node) {
                var $async$goto = 0, $async$completer = A._makeAsyncAwaitCompleter(type$.nullable_Value), $async$returnValue, $async$self = this, $name, t1, value, children, wasInKeyframes, wasInUnknownAtRule, rule;
                var $async$visitAtRule$1 = A._wrapJsFunctionForAsync(function($async$errorCode, $async$result) {
                    if ($async$errorCode === 1) return A._asyncRethrow($async$result, $async$completer);
                    for(;;)switch($async$goto){
                        case 0:
                            // Function start
                            if ($async$self._async_evaluate$_declarationName != null) throw A.wrapException($async$self._async_evaluate$_exception$2(string$.At_rul, node.span));
                            $async$goto = 3;
                            return A._asyncAwait($async$self._async_evaluate$_interpolationToValue$1(node.name), $async$visitAtRule$1);
                        case 3:
                            // returning from await.
                            $name = $async$result;
                            t1 = A.NullableExtension_andThen(node.value, new A._EvaluateVisitor_visitAtRule_closure3($async$self));
                            $async$goto = 4;
                            return A._asyncAwait(type$.Future_nullable_CssValue_String._is(t1) ? t1 : A._Future$value(t1, type$.nullable_CssValue_String), $async$visitAtRule$1);
                        case 4:
                            // returning from await.
                            value = $async$result;
                            children = node.children;
                            if (children == null) {
                                $async$self._async_evaluate$_copyParentAfterSibling$0();
                                $async$self._async_evaluate$_assertInModule$2($async$self._async_evaluate$__parent, "__parent").addChild$1(A.ModifiableCssAtRule$($name, node.span, true, value));
                                $async$returnValue = null;
                                // goto return
                                $async$goto = 1;
                                break;
                            }
                            wasInKeyframes = $async$self._async_evaluate$_inKeyframes;
                            wasInUnknownAtRule = $async$self._async_evaluate$_inUnknownAtRule;
                            if (A.unvendor($name.value) === "keyframes") $async$self._async_evaluate$_inKeyframes = true;
                            else $async$self._async_evaluate$_inUnknownAtRule = true;
                            rule = A.ModifiableCssAtRule$($name, node.span, false, value);
                            $async$goto = $async$self.get$_async_evaluate$_hasCssNesting() ? 5 : 6;
                            break;
                        case 5:
                            // then
                            $async$goto = 7;
                            return A._asyncAwait($async$self._async_evaluate$_withParent$2$3$scopeWhen(rule, new A._EvaluateVisitor_visitAtRule_closure4($async$self, children), node.hasDeclarations, type$.ModifiableCssAtRule, type$.Null), $async$visitAtRule$1);
                        case 7:
                            // returning from await.
                            $async$self._async_evaluate$_inUnknownAtRule = wasInUnknownAtRule;
                            $async$self._async_evaluate$_inKeyframes = wasInKeyframes;
                            $async$returnValue = null;
                            // goto return
                            $async$goto = 1;
                            break;
                        case 6:
                            // join
                            $async$goto = 8;
                            return A._asyncAwait($async$self._async_evaluate$_withParent$2$4$scopeWhen$through(rule, new A._EvaluateVisitor_visitAtRule_closure5($async$self, $name, children), node.hasDeclarations, new A._EvaluateVisitor_visitAtRule_closure6(), type$.ModifiableCssAtRule, type$.Null), $async$visitAtRule$1);
                        case 8:
                            // returning from await.
                            $async$self._async_evaluate$_inUnknownAtRule = wasInUnknownAtRule;
                            $async$self._async_evaluate$_inKeyframes = wasInKeyframes;
                            $async$returnValue = null;
                            // goto return
                            $async$goto = 1;
                            break;
                        case 1:
                            // return
                            return A._asyncReturn($async$returnValue, $async$completer);
                    }
                });
                return A._asyncStartSync($async$visitAtRule$1, $async$completer);
            },
            visitForRule$1: function(_, node) {
                return this.visitForRule$body$_EvaluateVisitor(0, node);
            },
            visitForRule$body$_EvaluateVisitor: function(_, node) {
                var $async$goto = 0, $async$completer = A._makeAsyncAwaitCompleter(type$.nullable_Value), $async$returnValue, $async$self = this, t1, t2, t3, fromNumber, t4, toNumber, from, to, direction;
                var $async$visitForRule$1 = A._wrapJsFunctionForAsync(function($async$errorCode, $async$result) {
                    if ($async$errorCode === 1) return A._asyncRethrow($async$result, $async$completer);
                    for(;;)switch($async$goto){
                        case 0:
                            // Function start
                            t1 = {};
                            t2 = node.from;
                            t3 = type$.SassNumber;
                            $async$goto = 3;
                            return A._asyncAwait($async$self._addExceptionSpanAsync$1$2(t2, new A._EvaluateVisitor_visitForRule_closure4($async$self, node), t3), $async$visitForRule$1);
                        case 3:
                            // returning from await.
                            fromNumber = $async$result;
                            t4 = node.to;
                            $async$goto = 4;
                            return A._asyncAwait($async$self._addExceptionSpanAsync$1$2(t4, new A._EvaluateVisitor_visitForRule_closure5($async$self, node), t3), $async$visitForRule$1);
                        case 4:
                            // returning from await.
                            toNumber = $async$result;
                            from = $async$self._async_evaluate$_addExceptionSpan$2(t2, new A._EvaluateVisitor_visitForRule_closure6(fromNumber));
                            to = t1.to = $async$self._async_evaluate$_addExceptionSpan$2(t4, new A._EvaluateVisitor_visitForRule_closure7(toNumber, fromNumber));
                            direction = from > to ? -1 : 1;
                            if (from === (!node.isExclusive ? t1.to = to + direction : to)) {
                                $async$returnValue = null;
                                // goto return
                                $async$goto = 1;
                                break;
                            }
                            $async$returnValue = $async$self._async_evaluate$_environment.scope$1$2$semiGlobal(new A._EvaluateVisitor_visitForRule_closure8(t1, $async$self, node, from, direction, fromNumber), true, type$.nullable_Value);
                            // goto return
                            $async$goto = 1;
                            break;
                        case 1:
                            // return
                            return A._asyncReturn($async$returnValue, $async$completer);
                    }
                });
                return A._asyncStartSync($async$visitForRule$1, $async$completer);
            },
            visitForwardRule$1: function(_, node) {
                return this.visitForwardRule$body$_EvaluateVisitor(0, node);
            },
            visitForwardRule$body$_EvaluateVisitor: function(_, node) {
                var $async$goto = 0, $async$completer = A._makeAsyncAwaitCompleter(type$.nullable_Value), $async$returnValue, $async$self = this, newConfiguration, t4, _i, variable, $name, oldConfiguration, adjustedConfiguration, t1, t2, t3;
                var $async$visitForwardRule$1 = A._wrapJsFunctionForAsync(function($async$errorCode, $async$result) {
                    if ($async$errorCode === 1) return A._asyncRethrow($async$result, $async$completer);
                    for(;;)switch($async$goto){
                        case 0:
                            // Function start
                            oldConfiguration = $async$self._async_evaluate$_configuration;
                            adjustedConfiguration = oldConfiguration.throughForward$1(node);
                            t1 = node.configuration;
                            t2 = t1.length;
                            t3 = node.url;
                            $async$goto = t2 !== 0 ? 3 : 5;
                            break;
                        case 3:
                            // then
                            $async$goto = 6;
                            return A._asyncAwait($async$self._async_evaluate$_addForwardConfiguration$2(adjustedConfiguration, node), $async$visitForwardRule$1);
                        case 6:
                            // returning from await.
                            newConfiguration = $async$result;
                            $async$goto = 7;
                            return A._asyncAwait($async$self._async_evaluate$_loadModule$5$configuration(t3, "@forward", node, new A._EvaluateVisitor_visitForwardRule_closure1($async$self, node), newConfiguration), $async$visitForwardRule$1);
                        case 7:
                            // returning from await.
                            t3 = type$.String;
                            t4 = A.LinkedHashSet_LinkedHashSet$_empty(t3);
                            for(_i = 0; _i < t2; ++_i){
                                variable = t1[_i];
                                if (!variable.isGuarded) t4.add$1(0, variable.name);
                            }
                            $async$self._async_evaluate$_removeUsedConfiguration$3$except(adjustedConfiguration, newConfiguration, t4);
                            t3 = A.LinkedHashSet_LinkedHashSet$_empty(t3);
                            for(_i = 0; _i < t2; ++_i)t3.add$1(0, t1[_i].name);
                            for(t1 = newConfiguration._configuration$_values, t2 = t1.get$keys(t1), t2 = t2.toList$0(t2), t4 = t2.length, _i = 0; _i < t2.length; t2.length === t4 || (0, A.throwConcurrentModificationError)(t2), ++_i){
                                $name = t2[_i];
                                if (!t3.contains$1(0, $name)) {
                                    if (!t1.get$isEmpty(t1)) t1.remove$1(0, $name);
                                }
                            }
                            $async$self._async_evaluate$_assertConfigurationIsEmpty$1(newConfiguration);
                            // goto join
                            $async$goto = 4;
                            break;
                        case 5:
                            // else
                            $async$self._async_evaluate$_configuration = adjustedConfiguration;
                            $async$goto = 8;
                            return A._asyncAwait($async$self._async_evaluate$_loadModule$4(t3, "@forward", node, new A._EvaluateVisitor_visitForwardRule_closure2($async$self, node)), $async$visitForwardRule$1);
                        case 8:
                            // returning from await.
                            $async$self._async_evaluate$_configuration = oldConfiguration;
                        case 4:
                            // join
                            $async$returnValue = null;
                            // goto return
                            $async$goto = 1;
                            break;
                        case 1:
                            // return
                            return A._asyncReturn($async$returnValue, $async$completer);
                    }
                });
                return A._asyncStartSync($async$visitForwardRule$1, $async$completer);
            },
            _async_evaluate$_addForwardConfiguration$2: function(configuration, node) {
                return this._addForwardConfiguration$body$_EvaluateVisitor(configuration, node);
            },
            _addForwardConfiguration$body$_EvaluateVisitor: function(configuration, node) {
                var $async$goto = 0, $async$completer = A._makeAsyncAwaitCompleter(type$.Configuration), $async$returnValue, $async$self = this, t2, t3, t4, t5, _i, variable, t6, _0_0, t7, oldValue, variableNodeWithSpan, t1, newValues, $async$temp1, $async$temp2, $async$temp3;
                var $async$_async_evaluate$_addForwardConfiguration$2 = A._wrapJsFunctionForAsync(function($async$errorCode, $async$result) {
                    if ($async$errorCode === 1) return A._asyncRethrow($async$result, $async$completer);
                    for(;;)switch($async$goto){
                        case 0:
                            // Function start
                            t1 = configuration._configuration$_values;
                            newValues = A.LinkedHashMap_LinkedHashMap$of(new A.UnmodifiableMapView(t1, type$.UnmodifiableMapView_String_ConfiguredValue), type$.String, type$.ConfiguredValue);
                            t2 = node.configuration, t3 = t2.length, t4 = type$._Future_Value, t5 = type$.Future_Value, _i = 0;
                        case 3:
                            // for condition
                            if (!(_i < t3)) {
                                // goto after for
                                $async$goto = 5;
                                break;
                            }
                            variable = t2[_i];
                            if (variable.isGuarded) {
                                t6 = variable.name;
                                _0_0 = t1.get$isEmpty(t1) ? null : t1.remove$1(0, t6);
                                if (_0_0 != null) {
                                    t7 = !_0_0.value.$eq(0, B.C__SassNull);
                                    oldValue = _0_0;
                                } else {
                                    oldValue = null;
                                    t7 = false;
                                }
                                if (t7) {
                                    newValues.$indexSet(0, t6, oldValue);
                                    // goto for update
                                    $async$goto = 4;
                                    break;
                                }
                            }
                            t6 = variable.expression;
                            variableNodeWithSpan = $async$self._async_evaluate$_expressionNode$1(t6);
                            t6 = t6.accept$1($async$self);
                            if (!t5._is(t6)) {
                                t7 = new A._Future($.Zone__current, t4);
                                t7._state = 8;
                                t7._resultOrListeners = t6;
                                t6 = t7;
                            }
                            $async$temp1 = newValues;
                            $async$temp2 = variable.name;
                            $async$temp3 = A;
                            $async$goto = 6;
                            return A._asyncAwait(t6, $async$_async_evaluate$_addForwardConfiguration$2);
                        case 6:
                            // returning from await.
                            $async$temp1.$indexSet(0, $async$temp2, new $async$temp3.ConfiguredValue($async$self._async_evaluate$_withoutSlash$2($async$result, variableNodeWithSpan), variable.span, variableNodeWithSpan));
                        case 4:
                            // for update
                            ++_i;
                            // goto for condition
                            $async$goto = 3;
                            break;
                        case 5:
                            // after for
                            if (configuration instanceof A.ExplicitConfiguration || t1.get$isEmpty(t1)) {
                                $async$returnValue = new A.ExplicitConfiguration(node, newValues, null);
                                // goto return
                                $async$goto = 1;
                                break;
                            } else {
                                $async$returnValue = new A.Configuration(newValues, null);
                                // goto return
                                $async$goto = 1;
                                break;
                            }
                        case 1:
                            // return
                            return A._asyncReturn($async$returnValue, $async$completer);
                    }
                });
                return A._asyncStartSync($async$_async_evaluate$_addForwardConfiguration$2, $async$completer);
            },
            _async_evaluate$_registerCommentsForModule$1: function(module) {
                var _this = this, _s5_ = "_root", t1 = _this._async_evaluate$__root;
                if (t1 == null) return;
                if (_this._async_evaluate$_assertInModule$2(t1, _s5_).children.get$length(0) === 0 || !module.get$transitivelyContainsCss()) return;
                t1 = _this._async_evaluate$_preModuleComments;
                if (t1 == null) t1 = _this._async_evaluate$_preModuleComments = A.LinkedHashMap_LinkedHashMap$_empty(type$.Module_AsyncCallable, type$.List_CssComment);
                J.addAll$1$ax(t1.putIfAbsent$2(module, new A._EvaluateVisitor__registerCommentsForModule_closure0()), new A.UnmodifiableListView(J.cast$1$0$ax(_this._async_evaluate$_assertInModule$2(_this._async_evaluate$__root, _s5_).children._collection$_source, type$.CssComment), type$.UnmodifiableListView_CssComment));
                _this._async_evaluate$_assertInModule$2(_this._async_evaluate$__root, _s5_).clearChildren$0();
                _this._async_evaluate$__endOfImports = 0;
            },
            _async_evaluate$_removeUsedConfiguration$3$except: function(upstream, downstream, except) {
                var t1, t2, t3, t4, _i, $name;
                for(t1 = upstream._configuration$_values, t2 = t1.get$keys(t1), t2 = t2.toList$0(t2), t3 = t2.length, t4 = downstream._configuration$_values, _i = 0; _i < t2.length; t2.length === t3 || (0, A.throwConcurrentModificationError)(t2), ++_i){
                    $name = t2[_i];
                    if (except.contains$1(0, $name)) continue;
                    if (!t4.containsKey$1($name)) {
                        if (!t1.get$isEmpty(t1)) t1.remove$1(0, $name);
                    }
                }
            },
            _async_evaluate$_assertConfigurationIsEmpty$2$nameInError: function(configuration, nameInError) {
                var t1, _0_0;
                if (!(configuration instanceof A.ExplicitConfiguration)) return;
                t1 = configuration._configuration$_values;
                if (t1.get$isEmpty(t1)) return;
                t1 = A.MapExtensions_get_pairs(new A.UnmodifiableMapView(t1, type$.UnmodifiableMapView_String_ConfiguredValue), type$.String, type$.ConfiguredValue);
                _0_0 = t1.get$first(t1);
                t1 = nameInError ? "$" + _0_0._0 + string$.x20was_n : string$.This_v;
                throw A.wrapException(this._async_evaluate$_exception$2(t1, _0_0._1.configurationSpan));
            },
            _async_evaluate$_assertConfigurationIsEmpty$1: function(configuration) {
                return this._async_evaluate$_assertConfigurationIsEmpty$2$nameInError(configuration, false);
            },
            visitFunctionRule$1: function(_, node) {
                return this.visitFunctionRule$body$_EvaluateVisitor(0, node);
            },
            visitFunctionRule$body$_EvaluateVisitor: function(_, node) {
                var $async$goto = 0, $async$completer = A._makeAsyncAwaitCompleter(type$.nullable_Value), $async$returnValue, $async$self = this, t1, t2, t3, t4, index, t5;
                var $async$visitFunctionRule$1 = A._wrapJsFunctionForAsync(function($async$errorCode, $async$result) {
                    if ($async$errorCode === 1) return A._asyncRethrow($async$result, $async$completer);
                    for(;;)switch($async$goto){
                        case 0:
                            // Function start
                            t1 = $async$self._async_evaluate$_environment;
                            t2 = t1.closure$0();
                            t3 = $async$self._async_evaluate$_inDependency;
                            t4 = t1._async_environment$_functions;
                            index = t4.length - 1;
                            t5 = node.name;
                            t1._async_environment$_functionIndices.$indexSet(0, t5, index);
                            t4[index].$indexSet(0, t5, new A.UserDefinedCallable(node, t2, t3, type$.UserDefinedCallable_AsyncEnvironment));
                            $async$returnValue = null;
                            // goto return
                            $async$goto = 1;
                            break;
                        case 1:
                            // return
                            return A._asyncReturn($async$returnValue, $async$completer);
                    }
                });
                return A._asyncStartSync($async$visitFunctionRule$1, $async$completer);
            },
            visitIfRule$1: function(_, node) {
                return this.visitIfRule$body$_EvaluateVisitor(0, node);
            },
            visitIfRule$body$_EvaluateVisitor: function(_, node) {
                var $async$goto = 0, $async$completer = A._makeAsyncAwaitCompleter(type$.nullable_Value), $async$returnValue, $async$self = this, t1, t2, _i, clauseToCheck, clause;
                var $async$visitIfRule$1 = A._wrapJsFunctionForAsync(function($async$errorCode, $async$result) {
                    if ($async$errorCode === 1) return A._asyncRethrow($async$result, $async$completer);
                    for(;;)switch($async$goto){
                        case 0:
                            // Function start
                            clause = node.lastClause;
                            t1 = node.clauses, t2 = t1.length, _i = 0;
                        case 3:
                            // for condition
                            if (!(_i < t2)) {
                                // goto after for
                                $async$goto = 5;
                                break;
                            }
                            clauseToCheck = t1[_i];
                            $async$goto = 6;
                            return A._asyncAwait(clauseToCheck.expression.accept$1($async$self), $async$visitIfRule$1);
                        case 6:
                            // returning from await.
                            if ($async$result.get$isTruthy()) {
                                clause = clauseToCheck;
                                // goto after for
                                $async$goto = 5;
                                break;
                            }
                        case 4:
                            // for update
                            ++_i;
                            // goto for condition
                            $async$goto = 3;
                            break;
                        case 5:
                            // after for
                            t1 = A.NullableExtension_andThen(clause, new A._EvaluateVisitor_visitIfRule_closure0($async$self));
                            $async$goto = 7;
                            return A._asyncAwait(type$.Future_nullable_Value._is(t1) ? t1 : A._Future$value(t1, type$.nullable_Value), $async$visitIfRule$1);
                        case 7:
                            // returning from await.
                            $async$returnValue = $async$result;
                            // goto return
                            $async$goto = 1;
                            break;
                        case 1:
                            // return
                            return A._asyncReturn($async$returnValue, $async$completer);
                    }
                });
                return A._asyncStartSync($async$visitIfRule$1, $async$completer);
            },
            visitImportRule$1: function(_, node) {
                return this.visitImportRule$body$_EvaluateVisitor(0, node);
            },
            visitImportRule$body$_EvaluateVisitor: function(_, node) {
                var $async$goto = 0, $async$completer = A._makeAsyncAwaitCompleter(type$.nullable_Value), $async$returnValue, $async$self = this, t1, t2, t3, _i, $import;
                var $async$visitImportRule$1 = A._wrapJsFunctionForAsync(function($async$errorCode, $async$result) {
                    if ($async$errorCode === 1) return A._asyncRethrow($async$result, $async$completer);
                    for(;;)switch($async$goto){
                        case 0:
                            // Function start
                            t1 = node.imports, t2 = t1.length, t3 = type$.StaticImport, _i = 0;
                        case 3:
                            // for condition
                            if (!(_i < t2)) {
                                // goto after for
                                $async$goto = 5;
                                break;
                            }
                            $import = t1[_i];
                            $async$goto = $import instanceof A.DynamicImport ? 6 : 8;
                            break;
                        case 6:
                            // then
                            $async$goto = 9;
                            return A._asyncAwait($async$self._async_evaluate$_visitDynamicImport$1($import), $async$visitImportRule$1);
                        case 9:
                            // returning from await.
                            // goto join
                            $async$goto = 7;
                            break;
                        case 8:
                            // else
                            $async$goto = 10;
                            return A._asyncAwait($async$self._visitStaticImport$1(t3._as($import)), $async$visitImportRule$1);
                        case 10:
                        // returning from await.
                        case 7:
                        // join
                        case 4:
                            // for update
                            ++_i;
                            // goto for condition
                            $async$goto = 3;
                            break;
                        case 5:
                            // after for
                            $async$returnValue = null;
                            // goto return
                            $async$goto = 1;
                            break;
                        case 1:
                            // return
                            return A._asyncReturn($async$returnValue, $async$completer);
                    }
                });
                return A._asyncStartSync($async$visitImportRule$1, $async$completer);
            },
            _async_evaluate$_visitDynamicImport$1: function($import) {
                return this._async_evaluate$_withStackFrame$1$3("@import", $import, new A._EvaluateVisitor__visitDynamicImport_closure0(this, $import), type$.void);
            },
            _async_evaluate$_loadStylesheet$4$baseUrl$forImport: function(url, span, baseUrl, forImport) {
                return this._loadStylesheet$body$_EvaluateVisitor(url, span, baseUrl, forImport);
            },
            _async_evaluate$_loadStylesheet$3$baseUrl: function(url, span, baseUrl) {
                return this._async_evaluate$_loadStylesheet$4$baseUrl$forImport(url, span, baseUrl, false);
            },
            _async_evaluate$_loadStylesheet$3$forImport: function(url, span, forImport) {
                return this._async_evaluate$_loadStylesheet$4$baseUrl$forImport(url, span, null, forImport);
            },
            _loadStylesheet$body$_EvaluateVisitor: function(url, span, baseUrl, forImport) {
                var $async$goto = 0, $async$completer = A._makeAsyncAwaitCompleter(type$.Record_3_Stylesheet_and_nullable_AsyncImporter_importer_and_bool_isDependency), $async$returnValue, $async$handler = 2, $async$errorStack = [], $async$next = [], $async$self = this, _0_0, importCache, _1_0, importer, canonicalUrl, originalUrl, isDependency, _2_0, stylesheet, error, stackTrace, error0, stackTrace0, t1, t2, exception, $async$exception;
                var $async$_async_evaluate$_loadStylesheet$4$baseUrl$forImport = A._wrapJsFunctionForAsync(function($async$errorCode, $async$result) {
                    if ($async$errorCode === 1) {
                        $async$errorStack.push($async$result);
                        $async$goto = $async$handler;
                    }
                    for(;;)switch($async$goto){
                        case 0:
                            // Function start
                            baseUrl;
                            $async$handler = 4;
                            $async$self._async_evaluate$_importSpan = span;
                            _0_0 = $async$self._async_evaluate$_importCache;
                            importCache = null;
                            $async$goto = _0_0 != null ? 7 : 8;
                            break;
                        case 7:
                            // then
                            importCache = _0_0;
                            if (baseUrl == null) {
                                t1 = $async$self._async_evaluate$_assertInModule$2($async$self._async_evaluate$__stylesheet, "_stylesheet").span;
                                baseUrl = t1.get$sourceUrl(t1);
                            }
                            $async$goto = 9;
                            return A._asyncAwait(J.canonicalize$4$baseImporter$baseUrl$forImport$x(importCache, A.Uri_parse(url), $async$self._async_evaluate$_importer, baseUrl, forImport), $async$_async_evaluate$_loadStylesheet$4$baseUrl$forImport);
                        case 9:
                            // returning from await.
                            _1_0 = $async$result;
                            importer = null;
                            canonicalUrl = null;
                            originalUrl = null;
                            $async$goto = type$.Record_3_nullable_Object_and_nullable_Object_and_nullable_Object_originalUrl._is(_1_0) ? 10 : 11;
                            break;
                        case 10:
                            // then
                            importer = _1_0._0;
                            canonicalUrl = _1_0._1;
                            originalUrl = _1_0._2;
                            if (canonicalUrl.get$scheme() === "") A.WarnForDeprecation_warnForDeprecation($async$self._async_evaluate$_logger, B.Deprecation_IqB, "Importer " + A.S(importer) + " canonicalized " + url + " to " + A.S(canonicalUrl) + string$.x2e_Rela, null, null);
                            $async$self._async_evaluate$_loadedUrls.add$1(0, canonicalUrl);
                            isDependency = $async$self._async_evaluate$_inDependency || !J.$eq$(importer, $async$self._async_evaluate$_importer);
                            $async$goto = 12;
                            return A._asyncAwait(importCache.importCanonical$3$originalUrl(importer, canonicalUrl, originalUrl), $async$_async_evaluate$_loadStylesheet$4$baseUrl$forImport);
                        case 12:
                            // returning from await.
                            _2_0 = $async$result;
                            stylesheet = null;
                            if (_2_0 != null) {
                                stylesheet = _2_0;
                                t1 = stylesheet;
                                t2 = importer;
                                $async$returnValue = new A._Record_3_importer_isDependency(t1, t2, isDependency);
                                $async$next = [
                                    1
                                ];
                                // goto finally
                                $async$goto = 5;
                                break;
                            }
                        case 11:
                        // join
                        case 8:
                            // join
                            t1 = B.JSString_methods.startsWith$1(url, "package:");
                            if (t1) throw A.wrapException(string$.x22packa);
                            else throw A.wrapException("Can't find stylesheet to import.");
                            $async$next.push(6);
                            // goto finally
                            $async$goto = 5;
                            break;
                        case 4:
                            // catch
                            $async$handler = 3;
                            $async$exception = $async$errorStack.pop();
                            t1 = A.unwrapException($async$exception);
                            if (t1 instanceof A.SassException) throw $async$exception;
                            else if (t1 instanceof A.ArgumentError) {
                                error = t1;
                                stackTrace = A.getTraceFromException($async$exception);
                                A.throwWithTrace($async$self._async_evaluate$_exception$1(J.toString$0$(error)), error, stackTrace);
                            } else {
                                error0 = t1;
                                stackTrace0 = A.getTraceFromException($async$exception);
                                A.throwWithTrace($async$self._async_evaluate$_exception$1($async$self._async_evaluate$_getErrorMessage$1(error0)), error0, stackTrace0);
                            }
                            $async$next.push(6);
                            // goto finally
                            $async$goto = 5;
                            break;
                        case 3:
                            // uncaught
                            $async$next = [
                                2
                            ];
                        case 5:
                            // finally
                            $async$handler = 2;
                            $async$self._async_evaluate$_importSpan = null;
                            // goto the next finally handler
                            $async$goto = $async$next.pop();
                            break;
                        case 6:
                        // after finally
                        case 1:
                            // return
                            return A._asyncReturn($async$returnValue, $async$completer);
                        case 2:
                            // rethrow
                            return A._asyncRethrow($async$errorStack.at(-1), $async$completer);
                    }
                });
                return A._asyncStartSync($async$_async_evaluate$_loadStylesheet$4$baseUrl$forImport, $async$completer);
            },
            _visitStaticImport$1: function($import) {
                return this._visitStaticImport$body$_EvaluateVisitor($import);
            },
            _visitStaticImport$body$_EvaluateVisitor: function($import) {
                var $async$goto = 0, $async$completer = A._makeAsyncAwaitCompleter(type$.void), $async$self = this, t1, t2, node, $async$temp1, $async$temp2;
                var $async$_visitStaticImport$1 = A._wrapJsFunctionForAsync(function($async$errorCode, $async$result) {
                    if ($async$errorCode === 1) return A._asyncRethrow($async$result, $async$completer);
                    for(;;)switch($async$goto){
                        case 0:
                            // Function start
                            $async$goto = 2;
                            return A._asyncAwait($async$self._async_evaluate$_interpolationToValue$1($import.url), $async$_visitStaticImport$1);
                        case 2:
                            // returning from await.
                            t1 = $async$result;
                            t2 = A.NullableExtension_andThen($import.modifiers, $async$self.get$_async_evaluate$_interpolationToValue());
                            $async$temp1 = A;
                            $async$temp2 = t1;
                            $async$goto = 3;
                            return A._asyncAwait(type$.Future_nullable_CssValue_String._is(t2) ? t2 : A._Future$value(t2, type$.nullable_CssValue_String), $async$_visitStaticImport$1);
                        case 3:
                            // returning from await.
                            node = new $async$temp1.ModifiableCssImport($async$temp2, $async$result, $import.span);
                            if ($async$self._async_evaluate$_assertInModule$2($async$self._async_evaluate$__parent, "__parent") !== $async$self._async_evaluate$_assertInModule$2($async$self._async_evaluate$__root, "_root")) {
                                $async$self._async_evaluate$_copyParentAfterSibling$0();
                                $async$self._async_evaluate$_assertInModule$2($async$self._async_evaluate$__parent, "__parent").addChild$1(node);
                            } else if ($async$self._async_evaluate$_assertInModule$2($async$self._async_evaluate$__endOfImports, "_endOfImports") === J.get$length$asx($async$self._async_evaluate$_assertInModule$2($async$self._async_evaluate$__root, "_root").children._collection$_source)) {
                                $async$self._async_evaluate$_assertInModule$2($async$self._async_evaluate$__root, "_root").addChild$1(node);
                                $async$self._async_evaluate$__endOfImports = $async$self._async_evaluate$_assertInModule$2($async$self._async_evaluate$__endOfImports, "_endOfImports") + 1;
                            } else {
                                t1 = $async$self._async_evaluate$_outOfOrderImports;
                                (t1 == null ? $async$self._async_evaluate$_outOfOrderImports = A._setArrayType([], type$.JSArray_ModifiableCssImport) : t1).push(node);
                            }
                            // implicit return
                            return A._asyncReturn(null, $async$completer);
                    }
                });
                return A._asyncStartSync($async$_visitStaticImport$1, $async$completer);
            },
            _async_evaluate$_applyMixin$5: function(mixin, contentCallable, $arguments, nodeWithSpan, nodeWithSpanWithoutContent) {
                return this._applyMixin$body$_EvaluateVisitor(mixin, contentCallable, $arguments, nodeWithSpan, nodeWithSpanWithoutContent);
            },
            _applyMixin$body$_EvaluateVisitor: function(mixin, contentCallable, $arguments, nodeWithSpan, nodeWithSpanWithoutContent) {
                var $async$goto = 0, $async$completer = A._makeAsyncAwaitCompleter(type$.void), $async$self = this, t1, _0_0, t2, _1_8, t3;
                var $async$_async_evaluate$_applyMixin$5 = A._wrapJsFunctionForAsync(function($async$errorCode, $async$result) {
                    if ($async$errorCode === 1) return A._asyncRethrow($async$result, $async$completer);
                    for(;;)switch($async$goto){
                        case 0:
                            // Function start
                            if (mixin == null) throw A.wrapException($async$self._async_evaluate$_exception$2("Undefined mixin.", nodeWithSpan.get$span(nodeWithSpan)));
                            t1 = type$.AsyncBuiltInCallable._is(mixin);
                            $async$goto = t1 && !mixin.get$acceptsContent() && contentCallable != null ? 3 : 4;
                            break;
                        case 3:
                            // then
                            $async$goto = 5;
                            return A._asyncAwait($async$self._async_evaluate$_evaluateArguments$1($arguments), $async$_async_evaluate$_applyMixin$5);
                        case 5:
                            // returning from await.
                            t1 = $async$result._values;
                            _0_0 = mixin.callbackFor$2(J.get$length$asx(t1[2]), new A.MapKeySet(t1[0], type$.MapKeySet_String));
                            throw A.wrapException(A.MultiSpanSassRuntimeException$("Mixin doesn't accept a content block.", nodeWithSpanWithoutContent.get$span(nodeWithSpanWithoutContent), "invocation", A.LinkedHashMap_LinkedHashMap$_literal([
                                _0_0._0.get$spanWithName(),
                                "declaration"
                            ], type$.FileSpan, type$.String), $async$self._async_evaluate$_stackTrace$1(nodeWithSpanWithoutContent.get$span(nodeWithSpanWithoutContent)), null));
                        case 4:
                            // join
                            $async$goto = t1 ? 6 : 7;
                            break;
                        case 6:
                            // then
                            $async$goto = 8;
                            return A._asyncAwait($async$self._async_evaluate$_environment.withContent$2(contentCallable, new A._EvaluateVisitor__applyMixin_closure1($async$self, $arguments, mixin, nodeWithSpanWithoutContent)), $async$_async_evaluate$_applyMixin$5);
                        case 8:
                            // returning from await.
                            // goto break $label0$0
                            $async$goto = 2;
                            break;
                        case 7:
                            // join
                            t1 = type$.UserDefinedCallable_AsyncEnvironment._is(mixin);
                            t2 = false;
                            if (t1) {
                                _1_8 = mixin.declaration;
                                t3 = _1_8;
                                if (t3 instanceof A.MixinRule) t2 = !type$.MixinRule._as(_1_8).get$hasContent() && contentCallable != null;
                            }
                            if (t2) throw A.wrapException(A.MultiSpanSassRuntimeException$("Mixin doesn't accept a content block.", nodeWithSpanWithoutContent.get$span(nodeWithSpanWithoutContent), "invocation", A.LinkedHashMap_LinkedHashMap$_literal([
                                mixin.declaration.parameters.get$spanWithName(),
                                "declaration"
                            ], type$.FileSpan, type$.String), $async$self._async_evaluate$_stackTrace$1(nodeWithSpanWithoutContent.get$span(nodeWithSpanWithoutContent)), null));
                            $async$goto = t1 ? 9 : 10;
                            break;
                        case 9:
                            // then
                            $async$goto = 11;
                            return A._asyncAwait($async$self._async_evaluate$_runUserDefinedCallable$1$4($arguments, mixin, nodeWithSpanWithoutContent, new A._EvaluateVisitor__applyMixin_closure2($async$self, contentCallable, mixin, nodeWithSpanWithoutContent), type$.Null), $async$_async_evaluate$_applyMixin$5);
                        case 11:
                            // returning from await.
                            // goto break $label0$0
                            $async$goto = 2;
                            break;
                        case 10:
                            // join
                            throw A.wrapException(A.UnsupportedError$("Unknown callable type " + mixin.toString$0(0) + "."));
                        case 2:
                            // break $label0$0
                            // implicit return
                            return A._asyncReturn(null, $async$completer);
                    }
                });
                return A._asyncStartSync($async$_async_evaluate$_applyMixin$5, $async$completer);
            },
            visitIncludeRule$1: function(_, node) {
                return this.visitIncludeRule$body$_EvaluateVisitor(0, node);
            },
            visitIncludeRule$body$_EvaluateVisitor: function(_, node) {
                var $async$goto = 0, $async$completer = A._makeAsyncAwaitCompleter(type$.nullable_Value), $async$returnValue, $async$self = this, mixin;
                var $async$visitIncludeRule$1 = A._wrapJsFunctionForAsync(function($async$errorCode, $async$result) {
                    if ($async$errorCode === 1) return A._asyncRethrow($async$result, $async$completer);
                    for(;;)switch($async$goto){
                        case 0:
                            // Function start
                            mixin = $async$self._async_evaluate$_addExceptionSpan$2(node, new A._EvaluateVisitor_visitIncludeRule_closure2($async$self, node));
                            if (B.JSString_methods.startsWith$1(node.originalName, "--") && mixin instanceof A.UserDefinedCallable && !B.JSString_methods.startsWith$1(mixin.declaration.originalName, "--")) throw A.wrapException($async$self._async_evaluate$_exception$2(string$.Sass__m, node.get$nameSpan()));
                            $async$goto = 3;
                            return A._asyncAwait($async$self._async_evaluate$_applyMixin$5(mixin, A.NullableExtension_andThen(node.content, new A._EvaluateVisitor_visitIncludeRule_closure3($async$self)), node.$arguments, node, new A._FakeAstNode(new A._EvaluateVisitor_visitIncludeRule_closure4(node))), $async$visitIncludeRule$1);
                        case 3:
                            // returning from await.
                            $async$returnValue = null;
                            // goto return
                            $async$goto = 1;
                            break;
                        case 1:
                            // return
                            return A._asyncReturn($async$returnValue, $async$completer);
                    }
                });
                return A._asyncStartSync($async$visitIncludeRule$1, $async$completer);
            },
            visitMixinRule$1: function(_, node) {
                return this.visitMixinRule$body$_EvaluateVisitor(0, node);
            },
            visitMixinRule$body$_EvaluateVisitor: function(_, node) {
                var $async$goto = 0, $async$completer = A._makeAsyncAwaitCompleter(type$.nullable_Value), $async$returnValue, $async$self = this, t1, t2, t3, t4, index, t5;
                var $async$visitMixinRule$1 = A._wrapJsFunctionForAsync(function($async$errorCode, $async$result) {
                    if ($async$errorCode === 1) return A._asyncRethrow($async$result, $async$completer);
                    for(;;)switch($async$goto){
                        case 0:
                            // Function start
                            t1 = $async$self._async_evaluate$_environment;
                            t2 = t1.closure$0();
                            t3 = $async$self._async_evaluate$_inDependency;
                            t4 = t1._async_environment$_mixins;
                            index = t4.length - 1;
                            t5 = node.name;
                            t1._async_environment$_mixinIndices.$indexSet(0, t5, index);
                            t4[index].$indexSet(0, t5, new A.UserDefinedCallable(node, t2, t3, type$.UserDefinedCallable_AsyncEnvironment));
                            $async$returnValue = null;
                            // goto return
                            $async$goto = 1;
                            break;
                        case 1:
                            // return
                            return A._asyncReturn($async$returnValue, $async$completer);
                    }
                });
                return A._asyncStartSync($async$visitMixinRule$1, $async$completer);
            },
            visitLoudComment$1: function(_, node) {
                return this.visitLoudComment$body$_EvaluateVisitor(0, node);
            },
            visitLoudComment$body$_EvaluateVisitor: function(_, node) {
                var $async$goto = 0, $async$completer = A._makeAsyncAwaitCompleter(type$.nullable_Value), $async$returnValue, $async$self = this, t1, text;
                var $async$visitLoudComment$1 = A._wrapJsFunctionForAsync(function($async$errorCode, $async$result) {
                    if ($async$errorCode === 1) return A._asyncRethrow($async$result, $async$completer);
                    for(;;)switch($async$goto){
                        case 0:
                            // Function start
                            if ($async$self._async_evaluate$_inFunction) {
                                $async$returnValue = null;
                                // goto return
                                $async$goto = 1;
                                break;
                            }
                            if ($async$self._async_evaluate$_assertInModule$2($async$self._async_evaluate$__parent, "__parent") === $async$self._async_evaluate$_assertInModule$2($async$self._async_evaluate$__root, "_root") && $async$self._async_evaluate$_assertInModule$2($async$self._async_evaluate$__endOfImports, "_endOfImports") === J.get$length$asx($async$self._async_evaluate$_assertInModule$2($async$self._async_evaluate$__root, "_root").children._collection$_source)) $async$self._async_evaluate$__endOfImports = $async$self._async_evaluate$_assertInModule$2($async$self._async_evaluate$__endOfImports, "_endOfImports") + 1;
                            t1 = node.text;
                            $async$goto = 3;
                            return A._asyncAwait($async$self._async_evaluate$_performInterpolation$1(t1), $async$visitLoudComment$1);
                        case 3:
                            // returning from await.
                            text = $async$result;
                            if (!B.JSString_methods.endsWith$1(text, "*/")) text += " */";
                            $async$self._async_evaluate$_copyParentAfterSibling$0();
                            $async$self._async_evaluate$_assertInModule$2($async$self._async_evaluate$__parent, "__parent").addChild$1(new A.ModifiableCssComment(text, t1.span));
                            $async$returnValue = null;
                            // goto return
                            $async$goto = 1;
                            break;
                        case 1:
                            // return
                            return A._asyncReturn($async$returnValue, $async$completer);
                    }
                });
                return A._asyncStartSync($async$visitLoudComment$1, $async$completer);
            },
            visitMediaRule$1: function(_, node) {
                return this.visitMediaRule$body$_EvaluateVisitor(0, node);
            },
            visitMediaRule$body$_EvaluateVisitor: function(_, node) {
                var $async$goto = 0, $async$completer = A._makeAsyncAwaitCompleter(type$.nullable_Value), $async$returnValue, $async$self = this, queries, mergedQueries, t1, mergedSources, t2, t3;
                var $async$visitMediaRule$1 = A._wrapJsFunctionForAsync(function($async$errorCode, $async$result) {
                    if ($async$errorCode === 1) return A._asyncRethrow($async$result, $async$completer);
                    for(;;)switch($async$goto){
                        case 0:
                            // Function start
                            if ($async$self._async_evaluate$_declarationName != null) throw A.wrapException($async$self._async_evaluate$_exception$2(string$.Media_, node.span));
                            $async$goto = 3;
                            return A._asyncAwait($async$self._visitMediaQueries$1(node.query), $async$visitMediaRule$1);
                        case 3:
                            // returning from await.
                            queries = $async$result;
                            $async$goto = $async$self.get$_async_evaluate$_hasCssNesting() ? 4 : 5;
                            break;
                        case 4:
                            // then
                            $async$goto = 6;
                            return A._asyncAwait($async$self._async_evaluate$_withParent$2$3$scopeWhen(A.ModifiableCssMediaRule$(queries, node.span), new A._EvaluateVisitor_visitMediaRule_closure3($async$self, node), false, type$.ModifiableCssMediaRule, type$.Null), $async$visitMediaRule$1);
                        case 6:
                            // returning from await.
                            $async$returnValue = null;
                            // goto return
                            $async$goto = 1;
                            break;
                        case 5:
                            // join
                            mergedQueries = A.NullableExtension_andThen($async$self._async_evaluate$_mediaQueries, new A._EvaluateVisitor_visitMediaRule_closure4($async$self, queries));
                            t1 = mergedQueries == null;
                            if (!t1 && J.get$isEmpty$asx(mergedQueries)) {
                                $async$returnValue = null;
                                // goto return
                                $async$goto = 1;
                                break;
                            }
                            if (t1) mergedSources = B.Set_empty2;
                            else {
                                t2 = $async$self._async_evaluate$_mediaQuerySources;
                                t2.toString;
                                t2 = A.LinkedHashSet_LinkedHashSet$of(t2, type$.CssMediaQuery);
                                t3 = $async$self._async_evaluate$_mediaQueries;
                                t3.toString;
                                t2.addAll$1(0, t3);
                                t2.addAll$1(0, queries);
                                mergedSources = t2;
                            }
                            t1 = t1 ? queries : mergedQueries;
                            $async$goto = 7;
                            return A._asyncAwait($async$self._async_evaluate$_withParent$2$4$scopeWhen$through(A.ModifiableCssMediaRule$(t1, node.span), new A._EvaluateVisitor_visitMediaRule_closure5($async$self, mergedQueries, queries, mergedSources, node), node.hasDeclarations, new A._EvaluateVisitor_visitMediaRule_closure6(mergedSources), type$.ModifiableCssMediaRule, type$.Null), $async$visitMediaRule$1);
                        case 7:
                            // returning from await.
                            $async$returnValue = null;
                            // goto return
                            $async$goto = 1;
                            break;
                        case 1:
                            // return
                            return A._asyncReturn($async$returnValue, $async$completer);
                    }
                });
                return A._asyncStartSync($async$visitMediaRule$1, $async$completer);
            },
            _visitMediaQueries$1: function(interpolation) {
                return this._visitMediaQueries$body$_EvaluateVisitor(interpolation);
            },
            _visitMediaQueries$body$_EvaluateVisitor: function(interpolation) {
                var $async$goto = 0, $async$completer = A._makeAsyncAwaitCompleter(type$.List_CssMediaQuery), $async$returnValue, $async$self = this, _0_0, resolved, map;
                var $async$_visitMediaQueries$1 = A._wrapJsFunctionForAsync(function($async$errorCode, $async$result) {
                    if ($async$errorCode === 1) return A._asyncRethrow($async$result, $async$completer);
                    for(;;)switch($async$goto){
                        case 0:
                            // Function start
                            $async$goto = 3;
                            return A._asyncAwait($async$self._async_evaluate$_performInterpolationWithMap$2$warnForColor(interpolation, true), $async$_visitMediaQueries$1);
                        case 3:
                            // returning from await.
                            _0_0 = $async$result;
                            resolved = _0_0._0;
                            map = _0_0._1;
                            $async$returnValue = new A.MediaQueryParser(A.SpanScanner$(resolved, null), map).parse$0(0);
                            // goto return
                            $async$goto = 1;
                            break;
                        case 1:
                            // return
                            return A._asyncReturn($async$returnValue, $async$completer);
                    }
                });
                return A._asyncStartSync($async$_visitMediaQueries$1, $async$completer);
            },
            _async_evaluate$_mergeMediaQueries$2: function(queries1, queries2) {
                var t1, t2, t3, t4, _0_0, t5, result, queries = A._setArrayType([], type$.JSArray_CssMediaQuery);
                for(t1 = J.get$iterator$ax(queries1), t2 = J.getInterceptor$ax(queries2); t1.moveNext$0();){
                    t3 = t1.get$current(t1);
                    for(t4 = t2.get$iterator(queries2); t4.moveNext$0();){
                        _0_0 = t3.merge$1(t4.get$current(t4));
                        if (B._SingletonCssMediaQueryMergeResult_0 === _0_0) continue;
                        if (B._SingletonCssMediaQueryMergeResult_1 === _0_0) return null;
                        t5 = _0_0 instanceof A.MediaQuerySuccessfulMergeResult;
                        result = t5 ? _0_0 : null;
                        if (t5) queries.push(result.query);
                    }
                }
                return queries;
            },
            visitReturnRule$1: function(_, node) {
                return this.visitReturnRule$body$_EvaluateVisitor(0, node);
            },
            visitReturnRule$body$_EvaluateVisitor: function(_, node) {
                var $async$goto = 0, $async$completer = A._makeAsyncAwaitCompleter(type$.Value), $async$returnValue, $async$self = this, t1, t2;
                var $async$visitReturnRule$1 = A._wrapJsFunctionForAsync(function($async$errorCode, $async$result) {
                    if ($async$errorCode === 1) return A._asyncRethrow($async$result, $async$completer);
                    for(;;)switch($async$goto){
                        case 0:
                            // Function start
                            t1 = node.expression;
                            t2 = t1.accept$1($async$self);
                            $async$goto = 3;
                            return A._asyncAwait(type$.Future_Value._is(t2) ? t2 : A._Future$value(t2, type$.Value), $async$visitReturnRule$1);
                        case 3:
                            // returning from await.
                            $async$returnValue = $async$self._async_evaluate$_withoutSlash$2($async$result, t1);
                            // goto return
                            $async$goto = 1;
                            break;
                        case 1:
                            // return
                            return A._asyncReturn($async$returnValue, $async$completer);
                    }
                });
                return A._asyncStartSync($async$visitReturnRule$1, $async$completer);
            },
            visitSilentComment$1: function(_, node) {
                return this.visitSilentComment$body$_EvaluateVisitor(0, node);
            },
            visitSilentComment$body$_EvaluateVisitor: function(_, node) {
                var $async$goto = 0, $async$completer = A._makeAsyncAwaitCompleter(type$.nullable_Value), $async$returnValue;
                var $async$visitSilentComment$1 = A._wrapJsFunctionForAsync(function($async$errorCode, $async$result) {
                    if ($async$errorCode === 1) return A._asyncRethrow($async$result, $async$completer);
                    for(;;)switch($async$goto){
                        case 0:
                            // Function start
                            $async$returnValue = null;
                            // goto return
                            $async$goto = 1;
                            break;
                        case 1:
                            // return
                            return A._asyncReturn($async$returnValue, $async$completer);
                    }
                });
                return A._asyncStartSync($async$visitSilentComment$1, $async$completer);
            },
            visitStyleRule$1: function(_, node) {
                return this.visitStyleRule$body$_EvaluateVisitor(0, node);
            },
            visitStyleRule$body$_EvaluateVisitor: function(_, node) {
                var $async$goto = 0, $async$completer = A._makeAsyncAwaitCompleter(type$.nullable_Value), $async$returnValue, $async$self = this, t1, _0_0, selectorText, selectorMap, parsedSelector, _1_0, t2, t3, _i, _2_0, first, t4, rule, oldAtRootExcludingStyleRule;
                var $async$visitStyleRule$1 = A._wrapJsFunctionForAsync(function($async$errorCode, $async$result) {
                    if ($async$errorCode === 1) return A._asyncRethrow($async$result, $async$completer);
                    for(;;)switch($async$goto){
                        case 0:
                            // Function start
                            if ($async$self._async_evaluate$_declarationName != null) throw A.wrapException($async$self._async_evaluate$_exception$2(string$.Style_n, node.span));
                            else if ($async$self._async_evaluate$_inKeyframes && $async$self._async_evaluate$_assertInModule$2($async$self._async_evaluate$__parent, "__parent") instanceof A.ModifiableCssKeyframeBlock) throw A.wrapException($async$self._async_evaluate$_exception$2(string$.Style_k, node.span));
                            t1 = node.selector;
                            t1.toString;
                            $async$goto = 3;
                            return A._asyncAwait($async$self._async_evaluate$_performInterpolationWithMap$2$warnForColor(t1, true), $async$visitStyleRule$1);
                        case 3:
                            // returning from await.
                            _0_0 = $async$result;
                            selectorText = _0_0._0;
                            selectorMap = _0_0._1;
                            $async$goto = $async$self._async_evaluate$_inKeyframes ? 4 : 5;
                            break;
                        case 4:
                            // then
                            $async$goto = 6;
                            return A._asyncAwait($async$self._async_evaluate$_withParent$2$4$scopeWhen$through(A.ModifiableCssKeyframeBlock$(new A.CssValue(A.List_List$unmodifiable(new A.KeyframeSelectorParser(A.SpanScanner$(selectorText, null), selectorMap).parse$0(0), type$.String), t1.span, type$.CssValue_List_String), node.span), new A._EvaluateVisitor_visitStyleRule_closure3($async$self, node), node.hasDeclarations, new A._EvaluateVisitor_visitStyleRule_closure4(), type$.ModifiableCssKeyframeBlock, type$.Null), $async$visitStyleRule$1);
                        case 6:
                            // returning from await.
                            $async$returnValue = null;
                            // goto return
                            $async$goto = 1;
                            break;
                        case 5:
                            // join
                            parsedSelector = A.SelectorList_SelectorList$parse(selectorText, true, selectorMap, $async$self._async_evaluate$_logger, $async$self._async_evaluate$_assertInModule$2($async$self._async_evaluate$__stylesheet, "_stylesheet").plainCss);
                            _1_0 = $async$self._async_evaluate$_atRootExcludingStyleRule ? null : $async$self._async_evaluate$_styleRuleIgnoringAtRoot;
                            $label0$0: {
                                if (_1_0 == null) {
                                    t1 = true;
                                    break $label0$0;
                                }
                                if (_1_0.fromPlainCss) {
                                    t1 = false;
                                    break $label0$0;
                                }
                                t1 = !($async$self._async_evaluate$_assertInModule$2($async$self._async_evaluate$__stylesheet, "_stylesheet").plainCss && parsedSelector.accept$1(B.C__ContainsParentSelectorVisitor));
                                break $label0$0;
                            }
                            if (t1) {
                                if ($async$self._async_evaluate$_assertInModule$2($async$self._async_evaluate$__stylesheet, "_stylesheet").plainCss) for(t2 = parsedSelector.components, t3 = t2.length, _i = 0; _i < t3; ++_i){
                                    _2_0 = t2[_i].leadingCombinators;
                                    if (_2_0.length >= 1) {
                                        first = _2_0[0];
                                        t4 = $async$self._async_evaluate$_assertInModule$2($async$self._async_evaluate$__stylesheet, "_stylesheet").plainCss;
                                    } else {
                                        first = null;
                                        t4 = false;
                                    }
                                    if (t4) throw A.wrapException($async$self._async_evaluate$_exception$2(string$.Top_le, first.span));
                                }
                                t2 = $async$self._async_evaluate$_styleRuleIgnoringAtRoot;
                                t2 = t2 == null ? null : t2.originalSelector;
                                parsedSelector = parsedSelector.nestWithin$3$implicitParent$preserveParentSelectors(t2, !$async$self._async_evaluate$_atRootExcludingStyleRule, $async$self._async_evaluate$_assertInModule$2($async$self._async_evaluate$__stylesheet, "_stylesheet").plainCss);
                            }
                            rule = A.ModifiableCssStyleRule$($async$self._async_evaluate$_assertInModule$2($async$self._async_evaluate$__extensionStore, "_extensionStore").addSelector$2(parsedSelector, $async$self._async_evaluate$_mediaQueries), node.span, $async$self._async_evaluate$_assertInModule$2($async$self._async_evaluate$__stylesheet, "_stylesheet").plainCss, parsedSelector);
                            oldAtRootExcludingStyleRule = $async$self._async_evaluate$_atRootExcludingStyleRule;
                            t2 = $async$self._async_evaluate$_atRootExcludingStyleRule = false;
                            t1 = t1 ? new A._EvaluateVisitor_visitStyleRule_closure5() : null;
                            $async$goto = 7;
                            return A._asyncAwait($async$self._async_evaluate$_withParent$2$4$scopeWhen$through(rule, new A._EvaluateVisitor_visitStyleRule_closure6($async$self, rule, node), node.hasDeclarations, t1, type$.ModifiableCssStyleRule, type$.Null), $async$visitStyleRule$1);
                        case 7:
                            // returning from await.
                            $async$self._async_evaluate$_atRootExcludingStyleRule = oldAtRootExcludingStyleRule;
                            $async$self._async_evaluate$_warnForBogusCombinators$1(rule);
                            if (($async$self._async_evaluate$_atRootExcludingStyleRule ? null : $async$self._async_evaluate$_styleRuleIgnoringAtRoot) == null) {
                                t1 = $async$self._async_evaluate$_assertInModule$2($async$self._async_evaluate$__parent, "__parent").children;
                                t1 = !t1.get$isEmpty(t1);
                            } else t1 = t2;
                            if (t1) {
                                t1 = $async$self._async_evaluate$_assertInModule$2($async$self._async_evaluate$__parent, "__parent").children;
                                t1.get$last(t1).isGroupEnd = true;
                            }
                            $async$returnValue = null;
                            // goto return
                            $async$goto = 1;
                            break;
                        case 1:
                            // return
                            return A._asyncReturn($async$returnValue, $async$completer);
                    }
                });
                return A._asyncStartSync($async$visitStyleRule$1, $async$completer);
            },
            _async_evaluate$_warnForBogusCombinators$1: function(rule) {
                var t1, t2, t3, t4, t5, _i, complex, visitor, t6, t7, t8, t9, _this = this, _null = null;
                if (!rule.accept$1(B._IsInvisibleVisitor_false_false)) for(t1 = rule._style_rule$_selector._box$_inner.value.components, t2 = t1.length, t3 = type$.SourceSpan, t4 = type$.String, t5 = rule.children, _i = 0; _i < t2; ++_i){
                    complex = t1[_i];
                    if (!complex.accept$1(B._IsBogusVisitor_true)) continue;
                    if (complex.accept$1(B.C__IsUselessVisitor)) {
                        visitor = A._SerializeVisitor$(_null, true, _null, _null, true, false, _null, true);
                        complex.accept$1(visitor);
                        _this._async_evaluate$_warn$3('The selector "' + B.JSString_methods.trim$0(visitor._serialize$_buffer.toString$0(0)) + string$.x22x20is_ix20, A.SpanExtensions_trimRight(complex.span), B.Deprecation_0rM);
                    } else if (complex.leadingCombinators.length !== 0) {
                        if (!_this._async_evaluate$_assertInModule$2(_this._async_evaluate$__stylesheet, "_stylesheet").plainCss) {
                            visitor = A._SerializeVisitor$(_null, true, _null, _null, true, false, _null, true);
                            complex.accept$1(visitor);
                            _this._async_evaluate$_warn$3('The selector "' + B.JSString_methods.trim$0(visitor._serialize$_buffer.toString$0(0)) + string$.x22x20is_ix0a, A.SpanExtensions_trimRight(complex.span), B.Deprecation_0rM);
                        }
                    } else {
                        visitor = A._SerializeVisitor$(_null, true, _null, _null, true, false, _null, true);
                        complex.accept$1(visitor);
                        t6 = B.JSString_methods.trim$0(visitor._serialize$_buffer.toString$0(0));
                        t7 = complex.accept$1(B._IsBogusVisitor_false) ? string$.x20It_wi : "";
                        t8 = A.SpanExtensions_trimRight(complex.span);
                        if (t5.get$length(0) === 0) A.throwExpression(A.IterableElementError_noElement());
                        t9 = J.get$span$x(t5.$index(0, 0));
                        _this._async_evaluate$_warn$3('The selector "' + t6 + string$.x22x20is_o + t7 + string$.x0aThis_, new A.MultiSpan(t8, "invalid selector", A.ConstantMap_ConstantMap$from(A.LinkedHashMap_LinkedHashMap$_literal([
                            t9,
                            "this is not a style rule" + (t5.every$1(t5, new A._EvaluateVisitor__warnForBogusCombinators_closure0()) ? "\n(try converting to a //-style comment)" : "")
                        ], t3, t4), t3, t4)), B.Deprecation_0rM);
                    }
                }
            },
            visitSupportsRule$1: function(_, node) {
                return this.visitSupportsRule$body$_EvaluateVisitor(0, node);
            },
            visitSupportsRule$body$_EvaluateVisitor: function(_, node) {
                var $async$goto = 0, $async$completer = A._makeAsyncAwaitCompleter(type$.nullable_Value), $async$returnValue, $async$self = this, t1, rule, $async$temp1, $async$temp2;
                var $async$visitSupportsRule$1 = A._wrapJsFunctionForAsync(function($async$errorCode, $async$result) {
                    if ($async$errorCode === 1) return A._asyncRethrow($async$result, $async$completer);
                    for(;;)switch($async$goto){
                        case 0:
                            // Function start
                            if ($async$self._async_evaluate$_declarationName != null) throw A.wrapException($async$self._async_evaluate$_exception$2(string$.Suppor, node.span));
                            t1 = node.condition;
                            $async$temp1 = A;
                            $async$temp2 = A;
                            $async$goto = 3;
                            return A._asyncAwait($async$self._async_evaluate$_visitSupportsCondition$1(t1), $async$visitSupportsRule$1);
                        case 3:
                            // returning from await.
                            rule = $async$temp1.ModifiableCssSupportsRule$(new $async$temp2.CssValue($async$result, t1.get$span(t1), type$.CssValue_String), node.span);
                            $async$goto = $async$self.get$_async_evaluate$_hasCssNesting() ? 4 : 5;
                            break;
                        case 4:
                            // then
                            $async$goto = 6;
                            return A._asyncAwait($async$self._async_evaluate$_withParent$2$3$scopeWhen(rule, new A._EvaluateVisitor_visitSupportsRule_closure2($async$self, node), node.hasDeclarations, type$.ModifiableCssSupportsRule, type$.Null), $async$visitSupportsRule$1);
                        case 6:
                            // returning from await.
                            $async$returnValue = null;
                            // goto return
                            $async$goto = 1;
                            break;
                        case 5:
                            // join
                            $async$goto = 7;
                            return A._asyncAwait($async$self._async_evaluate$_withParent$2$4$scopeWhen$through(rule, new A._EvaluateVisitor_visitSupportsRule_closure3($async$self, node), node.hasDeclarations, new A._EvaluateVisitor_visitSupportsRule_closure4(), type$.ModifiableCssSupportsRule, type$.Null), $async$visitSupportsRule$1);
                        case 7:
                            // returning from await.
                            $async$returnValue = null;
                            // goto return
                            $async$goto = 1;
                            break;
                        case 1:
                            // return
                            return A._asyncReturn($async$returnValue, $async$completer);
                    }
                });
                return A._asyncStartSync($async$visitSupportsRule$1, $async$completer);
            },
            _async_evaluate$_visitSupportsCondition$1: function(condition) {
                return this._visitSupportsCondition$body$_EvaluateVisitor(condition);
            },
            _visitSupportsCondition$body$_EvaluateVisitor: function(condition) {
                var $async$goto = 0, $async$completer = A._makeAsyncAwaitCompleter(type$.String), $async$returnValue, $async$self = this, t1, $async$temp1, $async$temp2;
                var $async$_async_evaluate$_visitSupportsCondition$1 = A._wrapJsFunctionForAsync(function($async$errorCode, $async$result) {
                    if ($async$errorCode === 1) return A._asyncRethrow($async$result, $async$completer);
                    for(;;)switch($async$goto){
                        case 0:
                            // Function start
                            $async$goto = condition instanceof A.SupportsOperation ? 4 : 5;
                            break;
                        case 4:
                            // then
                            t1 = condition.operator;
                            $async$temp1 = A;
                            $async$goto = 6;
                            return A._asyncAwait($async$self._async_evaluate$_parenthesize$2(condition.left, t1), $async$_async_evaluate$_visitSupportsCondition$1);
                        case 6:
                            // returning from await.
                            $async$temp1 = $async$temp1.S($async$result) + " " + t1.toString$0(0) + " ";
                            $async$temp2 = A;
                            $async$goto = 7;
                            return A._asyncAwait($async$self._async_evaluate$_parenthesize$2(condition.right, t1), $async$_async_evaluate$_visitSupportsCondition$1);
                        case 7:
                            // returning from await.
                            t1 = $async$temp1 + $async$temp2.S($async$result);
                            // goto break $label0$0
                            $async$goto = 3;
                            break;
                        case 5:
                            // join
                            $async$goto = condition instanceof A.SupportsNegation ? 8 : 9;
                            break;
                        case 8:
                            // then
                            $async$temp1 = A;
                            $async$goto = 10;
                            return A._asyncAwait($async$self._async_evaluate$_parenthesize$1(condition.condition), $async$_async_evaluate$_visitSupportsCondition$1);
                        case 10:
                            // returning from await.
                            t1 = "not " + $async$temp1.S($async$result);
                            // goto break $label0$0
                            $async$goto = 3;
                            break;
                        case 9:
                            // join
                            $async$goto = condition instanceof A.SupportsInterpolation ? 11 : 12;
                            break;
                        case 11:
                            // then
                            $async$goto = 13;
                            return A._asyncAwait($async$self._evaluateToCss$2$quote(condition.expression, false), $async$_async_evaluate$_visitSupportsCondition$1);
                        case 13:
                            // returning from await.
                            t1 = $async$result;
                            // goto break $label0$0
                            $async$goto = 3;
                            break;
                        case 12:
                            // join
                            t1 = {};
                            t1.declaration = null;
                            $async$goto = condition instanceof A.SupportsDeclaration ? 14 : 15;
                            break;
                        case 14:
                            // then
                            t1.declaration = condition;
                            $async$goto = 16;
                            return A._asyncAwait($async$self._async_evaluate$_withSupportsDeclaration$1$1(new A._EvaluateVisitor__visitSupportsCondition_closure0(t1, $async$self), type$.String), $async$_async_evaluate$_visitSupportsCondition$1);
                        case 16:
                            // returning from await.
                            t1 = $async$result;
                            // goto break $label0$0
                            $async$goto = 3;
                            break;
                        case 15:
                            // join
                            $async$goto = condition instanceof A.SupportsFunction ? 17 : 18;
                            break;
                        case 17:
                            // then
                            $async$temp1 = A;
                            $async$goto = 19;
                            return A._asyncAwait($async$self._async_evaluate$_performInterpolation$1(condition.name), $async$_async_evaluate$_visitSupportsCondition$1);
                        case 19:
                            // returning from await.
                            $async$temp1 = $async$temp1.S($async$result) + "(";
                            $async$temp2 = A;
                            $async$goto = 20;
                            return A._asyncAwait($async$self._async_evaluate$_performInterpolation$1(condition.$arguments), $async$_async_evaluate$_visitSupportsCondition$1);
                        case 20:
                            // returning from await.
                            t1 = $async$temp1 + $async$temp2.S($async$result) + ")";
                            // goto break $label0$0
                            $async$goto = 3;
                            break;
                        case 18:
                            // join
                            $async$goto = condition instanceof A.SupportsAnything ? 21 : 22;
                            break;
                        case 21:
                            // then
                            $async$temp1 = A;
                            $async$goto = 23;
                            return A._asyncAwait($async$self._async_evaluate$_performInterpolation$1(condition.contents), $async$_async_evaluate$_visitSupportsCondition$1);
                        case 23:
                            // returning from await.
                            t1 = "(" + $async$temp1.S($async$result) + ")";
                            // goto break $label0$0
                            $async$goto = 3;
                            break;
                        case 22:
                            // join
                            t1 = A.throwExpression(A.ArgumentError$("Unknown supports condition type " + A.getRuntimeTypeOfDartObject(condition).toString$0(0) + ".", null));
                        case 3:
                            // break $label0$0
                            $async$returnValue = t1;
                            // goto return
                            $async$goto = 1;
                            break;
                        case 1:
                            // return
                            return A._asyncReturn($async$returnValue, $async$completer);
                    }
                });
                return A._asyncStartSync($async$_async_evaluate$_visitSupportsCondition$1, $async$completer);
            },
            _async_evaluate$_withSupportsDeclaration$1$1: function(callback, $T) {
                return this._withSupportsDeclaration$body$_EvaluateVisitor(callback, $T, $T);
            },
            _withSupportsDeclaration$body$_EvaluateVisitor: function(callback, $T, $async$type) {
                var $async$goto = 0, $async$completer = A._makeAsyncAwaitCompleter($async$type), $async$returnValue, $async$handler = 2, $async$errorStack = [], $async$next = [], $async$self = this, t1, oldInSupportsDeclaration;
                var $async$_async_evaluate$_withSupportsDeclaration$1$1 = A._wrapJsFunctionForAsync(function($async$errorCode, $async$result) {
                    if ($async$errorCode === 1) {
                        $async$errorStack.push($async$result);
                        $async$goto = $async$handler;
                    }
                    for(;;)switch($async$goto){
                        case 0:
                            // Function start
                            oldInSupportsDeclaration = $async$self._async_evaluate$_inSupportsDeclaration;
                            $async$self._async_evaluate$_inSupportsDeclaration = true;
                            $async$handler = 3;
                            t1 = callback.call$0();
                            $async$goto = 6;
                            return A._asyncAwait($T._eval$1("Future<0>")._is(t1) ? t1 : A._Future$value(t1, $T), $async$_async_evaluate$_withSupportsDeclaration$1$1);
                        case 6:
                            // returning from await.
                            t1 = $async$result;
                            $async$returnValue = t1;
                            $async$next = [
                                1
                            ];
                            // goto finally
                            $async$goto = 4;
                            break;
                        case 3:
                            // uncaught
                            $async$next = [
                                2
                            ];
                        case 4:
                            // finally
                            $async$handler = 2;
                            $async$self._async_evaluate$_inSupportsDeclaration = oldInSupportsDeclaration;
                            // goto the next finally handler
                            $async$goto = $async$next.pop();
                            break;
                        case 5:
                        // after finally
                        case 1:
                            // return
                            return A._asyncReturn($async$returnValue, $async$completer);
                        case 2:
                            // rethrow
                            return A._asyncRethrow($async$errorStack.at(-1), $async$completer);
                    }
                });
                return A._asyncStartSync($async$_async_evaluate$_withSupportsDeclaration$1$1, $async$completer);
            },
            _async_evaluate$_parenthesize$2: function(condition, operator) {
                return this._parenthesize$body$_EvaluateVisitor(condition, operator);
            },
            _async_evaluate$_parenthesize$1: function(condition) {
                return this._async_evaluate$_parenthesize$2(condition, null);
            },
            _parenthesize$body$_EvaluateVisitor: function(condition, operator) {
                var $async$goto = 0, $async$completer = A._makeAsyncAwaitCompleter(type$.String), $async$returnValue, $async$self = this, t1, $async$temp1;
                var $async$_async_evaluate$_parenthesize$2 = A._wrapJsFunctionForAsync(function($async$errorCode, $async$result) {
                    if ($async$errorCode === 1) return A._asyncRethrow($async$result, $async$completer);
                    for(;;)switch($async$goto){
                        case 0:
                            // Function start
                            if (!(condition instanceof A.SupportsNegation)) {
                                if (condition instanceof A.SupportsOperation) t1 = operator == null || operator !== condition.operator;
                                else t1 = false;
                            } else t1 = true;
                            $async$goto = t1 ? 3 : 4;
                            break;
                        case 3:
                            // then
                            $async$temp1 = A;
                            $async$goto = 5;
                            return A._asyncAwait($async$self._async_evaluate$_visitSupportsCondition$1(condition), $async$_async_evaluate$_parenthesize$2);
                        case 5:
                            // returning from await.
                            $async$returnValue = "(" + $async$temp1.S($async$result) + ")";
                            // goto return
                            $async$goto = 1;
                            break;
                        case 4:
                            // join
                            $async$goto = 6;
                            return A._asyncAwait($async$self._async_evaluate$_visitSupportsCondition$1(condition), $async$_async_evaluate$_parenthesize$2);
                        case 6:
                            // returning from await.
                            $async$returnValue = $async$result;
                            // goto return
                            $async$goto = 1;
                            break;
                        case 1:
                            // return
                            return A._asyncReturn($async$returnValue, $async$completer);
                    }
                });
                return A._asyncStartSync($async$_async_evaluate$_parenthesize$2, $async$completer);
            },
            visitVariableDeclaration$1: function(_, node) {
                return this.visitVariableDeclaration$body$_EvaluateVisitor(0, node);
            },
            visitVariableDeclaration$body$_EvaluateVisitor: function(_, node) {
                var $async$goto = 0, $async$completer = A._makeAsyncAwaitCompleter(type$.nullable_Value), $async$returnValue, $async$self = this, t1, t2, _0_0, value, $async$temp1, $async$temp2, $async$temp3;
                var $async$visitVariableDeclaration$1 = A._wrapJsFunctionForAsync(function($async$errorCode, $async$result) {
                    if ($async$errorCode === 1) return A._asyncRethrow($async$result, $async$completer);
                    for(;;)switch($async$goto){
                        case 0:
                            // Function start
                            if (node.isGuarded) {
                                if (node.namespace == null && $async$self._async_evaluate$_environment._async_environment$_variables.length === 1) {
                                    t1 = node.name;
                                    $async$self._async_evaluate$_environment._async_environment$_configurableVariables.add$1(0, t1);
                                    t2 = $async$self._async_evaluate$_configuration._configuration$_values;
                                    _0_0 = t2.get$isEmpty(t2) ? null : t2.remove$1(0, t1);
                                    t1 = {};
                                    t1.override = null;
                                    if (_0_0 != null) {
                                        t1.override = _0_0;
                                        t2 = !_0_0.value.$eq(0, B.C__SassNull);
                                    } else t2 = false;
                                    if (t2) {
                                        $async$self._async_evaluate$_addExceptionSpan$2(node, new A._EvaluateVisitor_visitVariableDeclaration_closure2(t1, $async$self, node));
                                        $async$returnValue = null;
                                        // goto return
                                        $async$goto = 1;
                                        break;
                                    }
                                }
                                value = $async$self._async_evaluate$_addExceptionSpan$2(node, new A._EvaluateVisitor_visitVariableDeclaration_closure3($async$self, node));
                                if (value != null && !value.$eq(0, B.C__SassNull)) {
                                    $async$returnValue = null;
                                    // goto return
                                    $async$goto = 1;
                                    break;
                                }
                            }
                            if (node.isGlobal && !$async$self._async_evaluate$_environment.globalVariableExists$1(node.name)) {
                                t1 = $async$self._async_evaluate$_environment._async_environment$_variables.length === 1 ? string$.As_of_S : string$.As_of_R + A.declarationName(node.span) + ": null` at the stylesheet root.";
                                $async$self._async_evaluate$_warn$3(t1, node.span, B.Deprecation_jGw);
                            }
                            t1 = node.expression;
                            t2 = t1.accept$1($async$self);
                            $async$temp1 = node;
                            $async$temp2 = A;
                            $async$temp3 = node;
                            $async$goto = 3;
                            return A._asyncAwait(type$.Future_Value._is(t2) ? t2 : A._Future$value(t2, type$.Value), $async$visitVariableDeclaration$1);
                        case 3:
                            // returning from await.
                            $async$self._async_evaluate$_addExceptionSpan$2($async$temp1, new $async$temp2._EvaluateVisitor_visitVariableDeclaration_closure4($async$self, $async$temp3, $async$self._async_evaluate$_withoutSlash$2($async$result, t1)));
                            $async$returnValue = null;
                            // goto return
                            $async$goto = 1;
                            break;
                        case 1:
                            // return
                            return A._asyncReturn($async$returnValue, $async$completer);
                    }
                });
                return A._asyncStartSync($async$visitVariableDeclaration$1, $async$completer);
            },
            visitUseRule$1: function(_, node) {
                return this.visitUseRule$body$_EvaluateVisitor(0, node);
            },
            visitUseRule$body$_EvaluateVisitor: function(_, node) {
                var $async$goto = 0, $async$completer = A._makeAsyncAwaitCompleter(type$.nullable_Value), $async$returnValue, $async$self = this, values, t3, t4, _i, variable, t5, variableNodeWithSpan, t6, configuration, t1, t2, $async$temp1, $async$temp2, $async$temp3;
                var $async$visitUseRule$1 = A._wrapJsFunctionForAsync(function($async$errorCode, $async$result) {
                    if ($async$errorCode === 1) return A._asyncRethrow($async$result, $async$completer);
                    for(;;)switch($async$goto){
                        case 0:
                            // Function start
                            t1 = node.configuration;
                            t2 = t1.length;
                            $async$goto = t2 !== 0 ? 3 : 5;
                            break;
                        case 3:
                            // then
                            values = A.LinkedHashMap_LinkedHashMap$_empty(type$.String, type$.ConfiguredValue);
                            t3 = type$._Future_Value, t4 = type$.Future_Value, _i = 0;
                        case 6:
                            // for condition
                            if (!(_i < t2)) {
                                // goto after for
                                $async$goto = 8;
                                break;
                            }
                            variable = t1[_i];
                            t5 = variable.expression;
                            variableNodeWithSpan = $async$self._async_evaluate$_expressionNode$1(t5);
                            t5 = t5.accept$1($async$self);
                            if (!t4._is(t5)) {
                                t6 = new A._Future($.Zone__current, t3);
                                t6._state = 8;
                                t6._resultOrListeners = t5;
                                t5 = t6;
                            }
                            $async$temp1 = values;
                            $async$temp2 = variable.name;
                            $async$temp3 = A;
                            $async$goto = 9;
                            return A._asyncAwait(t5, $async$visitUseRule$1);
                        case 9:
                            // returning from await.
                            $async$temp1.$indexSet(0, $async$temp2, new $async$temp3.ConfiguredValue($async$self._async_evaluate$_withoutSlash$2($async$result, variableNodeWithSpan), variable.span, variableNodeWithSpan));
                        case 7:
                            // for update
                            ++_i;
                            // goto for condition
                            $async$goto = 6;
                            break;
                        case 8:
                            // after for
                            configuration = new A.ExplicitConfiguration(node, values, null);
                            // goto join
                            $async$goto = 4;
                            break;
                        case 5:
                            // else
                            configuration = B.Configuration_Map_empty_null;
                        case 4:
                            // join
                            $async$goto = 10;
                            return A._asyncAwait($async$self._async_evaluate$_loadModule$5$configuration(node.url, "@use", node, new A._EvaluateVisitor_visitUseRule_closure0($async$self, node), configuration), $async$visitUseRule$1);
                        case 10:
                            // returning from await.
                            $async$self._async_evaluate$_assertConfigurationIsEmpty$1(configuration);
                            $async$returnValue = null;
                            // goto return
                            $async$goto = 1;
                            break;
                        case 1:
                            // return
                            return A._asyncReturn($async$returnValue, $async$completer);
                    }
                });
                return A._asyncStartSync($async$visitUseRule$1, $async$completer);
            },
            visitWarnRule$1: function(_, node) {
                return this.visitWarnRule$body$_EvaluateVisitor(0, node);
            },
            visitWarnRule$body$_EvaluateVisitor: function(_, node) {
                var $async$goto = 0, $async$completer = A._makeAsyncAwaitCompleter(type$.nullable_Value), $async$returnValue, $async$self = this, value, t1, t2;
                var $async$visitWarnRule$1 = A._wrapJsFunctionForAsync(function($async$errorCode, $async$result) {
                    if ($async$errorCode === 1) return A._asyncRethrow($async$result, $async$completer);
                    for(;;)switch($async$goto){
                        case 0:
                            // Function start
                            $async$goto = 3;
                            return A._asyncAwait($async$self._addExceptionSpanAsync$1$2(node, new A._EvaluateVisitor_visitWarnRule_closure0($async$self, node), type$.Value), $async$visitWarnRule$1);
                        case 3:
                            // returning from await.
                            value = $async$result;
                            t1 = value instanceof A.SassString ? value._string$_text : $async$self._async_evaluate$_serialize$2(value, node.expression);
                            t2 = $async$self._async_evaluate$_stackTrace$1(node.span);
                            $async$self._async_evaluate$_logger.internalWarn$4$deprecation$span$trace(t1, null, null, t2);
                            $async$returnValue = null;
                            // goto return
                            $async$goto = 1;
                            break;
                        case 1:
                            // return
                            return A._asyncReturn($async$returnValue, $async$completer);
                    }
                });
                return A._asyncStartSync($async$visitWarnRule$1, $async$completer);
            },
            visitWhileRule$1: function(_, node) {
                return this._async_evaluate$_environment.scope$1$3$semiGlobal$when(new A._EvaluateVisitor_visitWhileRule_closure0(this, node), true, node.hasDeclarations, type$.nullable_Value);
            },
            visitBinaryOperationExpression$1: function(_, node) {
                var t1, _this = this;
                if (_this._async_evaluate$_assertInModule$2(_this._async_evaluate$__stylesheet, "_stylesheet").plainCss) {
                    t1 = node.operator;
                    t1 = t1 !== B.BinaryOperator_g6F && t1 !== B.BinaryOperator_ehp;
                } else t1 = false;
                if (t1) throw A.wrapException(_this._async_evaluate$_exception$2("Operators aren't allowed in plain CSS.", node.get$operatorSpan()));
                return _this._addExceptionSpanAsync$1$2(node, new A._EvaluateVisitor_visitBinaryOperationExpression_closure0(_this, node), type$.Value);
            },
            _async_evaluate$_slash$3: function(left, right, node) {
                var left0, _1_2, result = left.dividedBy$1(right), _1_2_isSet = left instanceof A.SassNumber, right0 = null, t1 = false;
                if (_1_2_isSet) {
                    if (right instanceof A.SassNumber) {
                        t1 = node.allowsSlash && this._async_evaluate$_operandAllowsSlash$1(node.left) && this._async_evaluate$_operandAllowsSlash$1(node.right);
                        right0 = right;
                    }
                    left0 = left;
                    _1_2 = right;
                } else {
                    _1_2 = null;
                    left0 = null;
                }
                if (t1) return type$.SassNumber._as(result).withSlash$2(left0, right0);
                if (left instanceof A.SassNumber) t1 = (_1_2_isSet ? _1_2 : right) instanceof A.SassNumber;
                else t1 = false;
                if (t1) {
                    this._async_evaluate$_warn$3(string$.Using__o + A.S(new A._EvaluateVisitor__slash_recommendation0().call$1(node)) + " or " + A.expressionToCalc(node).toString$0(0) + string$.x0a_Morex20, node.get$span(0), B.Deprecation_qZ1);
                    return result;
                }
                return result;
            },
            _async_evaluate$_operandAllowsSlash$1: function(node) {
                var t1;
                if (node instanceof A.FunctionExpression) {
                    if (node.namespace == null) {
                        t1 = node.name;
                        t1 = B.Set_Pr3yj.contains$1(0, t1.toLowerCase()) && this._async_evaluate$_environment.getFunction$1(t1) == null;
                    } else t1 = false;
                } else t1 = true;
                return t1;
            },
            visitValueExpression$1: function(_, node) {
                return this.visitValueExpression$body$_EvaluateVisitor(0, node);
            },
            visitValueExpression$body$_EvaluateVisitor: function(_, node) {
                var $async$goto = 0, $async$completer = A._makeAsyncAwaitCompleter(type$.Value), $async$returnValue;
                var $async$visitValueExpression$1 = A._wrapJsFunctionForAsync(function($async$errorCode, $async$result) {
                    if ($async$errorCode === 1) return A._asyncRethrow($async$result, $async$completer);
                    for(;;)switch($async$goto){
                        case 0:
                            // Function start
                            $async$returnValue = node.value;
                            // goto return
                            $async$goto = 1;
                            break;
                        case 1:
                            // return
                            return A._asyncReturn($async$returnValue, $async$completer);
                    }
                });
                return A._asyncStartSync($async$visitValueExpression$1, $async$completer);
            },
            visitVariableExpression$1: function(_, node) {
                return this.visitVariableExpression$body$_EvaluateVisitor(0, node);
            },
            visitVariableExpression$body$_EvaluateVisitor: function(_, node) {
                var $async$goto = 0, $async$completer = A._makeAsyncAwaitCompleter(type$.Value), $async$returnValue, $async$self = this, result;
                var $async$visitVariableExpression$1 = A._wrapJsFunctionForAsync(function($async$errorCode, $async$result) {
                    if ($async$errorCode === 1) return A._asyncRethrow($async$result, $async$completer);
                    for(;;)switch($async$goto){
                        case 0:
                            // Function start
                            result = $async$self._async_evaluate$_addExceptionSpan$2(node, new A._EvaluateVisitor_visitVariableExpression_closure0($async$self, node));
                            if (result != null) {
                                $async$returnValue = result;
                                // goto return
                                $async$goto = 1;
                                break;
                            }
                            throw A.wrapException($async$self._async_evaluate$_exception$2("Undefined variable.", node.span));
                        case 1:
                            // return
                            return A._asyncReturn($async$returnValue, $async$completer);
                    }
                });
                return A._asyncStartSync($async$visitVariableExpression$1, $async$completer);
            },
            visitUnaryOperationExpression$1: function(_, node) {
                return this.visitUnaryOperationExpression$body$_EvaluateVisitor(0, node);
            },
            visitUnaryOperationExpression$body$_EvaluateVisitor: function(_, node) {
                var $async$goto = 0, $async$completer = A._makeAsyncAwaitCompleter(type$.Value), $async$returnValue, $async$self = this, $async$temp1, $async$temp2, $async$temp3;
                var $async$visitUnaryOperationExpression$1 = A._wrapJsFunctionForAsync(function($async$errorCode, $async$result) {
                    if ($async$errorCode === 1) return A._asyncRethrow($async$result, $async$completer);
                    for(;;)switch($async$goto){
                        case 0:
                            // Function start
                            $async$temp1 = node;
                            $async$temp2 = A;
                            $async$temp3 = node;
                            $async$goto = 3;
                            return A._asyncAwait(node.operand.accept$1($async$self), $async$visitUnaryOperationExpression$1);
                        case 3:
                            // returning from await.
                            $async$returnValue = $async$self._async_evaluate$_addExceptionSpan$2($async$temp1, new $async$temp2._EvaluateVisitor_visitUnaryOperationExpression_closure0($async$temp3, $async$result));
                            // goto return
                            $async$goto = 1;
                            break;
                        case 1:
                            // return
                            return A._asyncReturn($async$returnValue, $async$completer);
                    }
                });
                return A._asyncStartSync($async$visitUnaryOperationExpression$1, $async$completer);
            },
            visitBooleanExpression$1: function(_, node) {
                return this.visitBooleanExpression$body$_EvaluateVisitor(0, node);
            },
            visitBooleanExpression$body$_EvaluateVisitor: function(_, node) {
                var $async$goto = 0, $async$completer = A._makeAsyncAwaitCompleter(type$.SassBoolean), $async$returnValue;
                var $async$visitBooleanExpression$1 = A._wrapJsFunctionForAsync(function($async$errorCode, $async$result) {
                    if ($async$errorCode === 1) return A._asyncRethrow($async$result, $async$completer);
                    for(;;)switch($async$goto){
                        case 0:
                            // Function start
                            $async$returnValue = node.value ? B.SassBoolean_true : B.SassBoolean_false;
                            // goto return
                            $async$goto = 1;
                            break;
                        case 1:
                            // return
                            return A._asyncReturn($async$returnValue, $async$completer);
                    }
                });
                return A._asyncStartSync($async$visitBooleanExpression$1, $async$completer);
            },
            visitIfExpression$1: function(_, node) {
                return this.visitIfExpression$body$_EvaluateVisitor(0, node);
            },
            visitIfExpression$body$_EvaluateVisitor: function(_, node) {
                var $async$goto = 0, $async$completer = A._makeAsyncAwaitCompleter(type$.Value), $async$returnValue, $async$self = this, t1, t2, t3, t4, t5, t6, results, _i, t7, condition, expression, t8, result, _1_2, $async$temp1, $async$temp2, $async$temp3;
                var $async$visitIfExpression$1 = A._wrapJsFunctionForAsync(function($async$errorCode, $async$result) {
                    if ($async$errorCode === 1) return A._asyncRethrow($async$result, $async$completer);
                    for(;;)switch($async$goto){
                        case 0:
                            // Function start
                            t1 = node.branches, t2 = t1.length, t3 = type$._Future_nullable_Object, t4 = type$._Future_Value, t5 = type$.Future_Value, t6 = type$.JSArray_Record_2_String_and_Value, results = null, _i = 0;
                        case 3:
                            // for condition
                            if (!(_i < t2)) {
                                // goto after for
                                $async$goto = 5;
                                break;
                            }
                            t7 = t1[_i];
                            condition = t7._0;
                            expression = t7._1;
                            t7 = condition == null ? null : condition.accept$1($async$self);
                            if (!(t7 instanceof A._Future)) {
                                t8 = new A._Future($.Zone__current, t3);
                                t8._state = 8;
                                t8._resultOrListeners = t7;
                                t7 = t8;
                            }
                            $async$goto = 6;
                            return A._asyncAwait(t7, $async$visitIfExpression$1);
                        case 6:
                            // returning from await.
                            result = $async$result;
                            if (result == null) result = true;
                            t7 = typeof result == "string";
                            condition = t7 ? result : null;
                            $async$goto = t7 ? 7 : 8;
                            break;
                        case 7:
                            // then
                            if (results == null) results = A._setArrayType([], t6);
                            t7 = expression.accept$1($async$self);
                            if (!t5._is(t7)) {
                                t8 = new A._Future($.Zone__current, t4);
                                t8._state = 8;
                                t8._resultOrListeners = t7;
                                t7 = t8;
                            }
                            $async$temp1 = results;
                            $async$temp2 = A;
                            $async$temp3 = condition;
                            $async$goto = 9;
                            return A._asyncAwait(t7, $async$visitIfExpression$1);
                        case 9:
                            // returning from await.
                            $async$temp1.push(new $async$temp2._Record_2($async$temp3, $async$result));
                            // goto for update
                            $async$goto = 4;
                            break;
                        case 8:
                            // join
                            _1_2 = true === result;
                            $async$goto = _1_2 && results != null ? 10 : 11;
                            break;
                        case 10:
                            // then
                            t7 = expression.accept$1($async$self);
                            if (!t5._is(t7)) {
                                t8 = new A._Future($.Zone__current, t4);
                                t8._state = 8;
                                t8._resultOrListeners = t7;
                                t7 = t8;
                            }
                            $async$temp1 = results;
                            $async$temp2 = A;
                            $async$goto = 12;
                            return A._asyncAwait(t7, $async$visitIfExpression$1);
                        case 12:
                            // returning from await.
                            $async$temp1.push(new $async$temp2._Record_2("else", $async$result));
                            // goto for update
                            $async$goto = 4;
                            break;
                        case 11:
                            // join
                            $async$goto = _1_2 ? 13 : 14;
                            break;
                        case 13:
                            // then
                            t1 = expression.accept$1($async$self);
                            if (!t5._is(t1)) {
                                t2 = new A._Future($.Zone__current, t4);
                                t2._state = 8;
                                t2._resultOrListeners = t1;
                                t1 = t2;
                            }
                            $async$goto = 15;
                            return A._asyncAwait(t1, $async$visitIfExpression$1);
                        case 15:
                            // returning from await.
                            $async$returnValue = $async$result;
                            // goto return
                            $async$goto = 1;
                            break;
                        case 14:
                        // join
                        case 4:
                            // for update
                            ++_i;
                            // goto for condition
                            $async$goto = 3;
                            break;
                        case 5:
                            // after for
                            if (results == null) {
                                $async$returnValue = B.C__SassNull;
                                // goto return
                                $async$goto = 1;
                                break;
                            }
                            $async$returnValue = new A.SassString("if(" + new A.MappedListIterable(results, new A._EvaluateVisitor_visitIfExpression_closure0(), A._arrayInstanceType(results)._eval$1("MappedListIterable<1,String>")).join$1(0, "; ") + ")", false);
                            // goto return
                            $async$goto = 1;
                            break;
                        case 1:
                            // return
                            return A._asyncReturn($async$returnValue, $async$completer);
                    }
                });
                return A._asyncStartSync($async$visitIfExpression$1, $async$completer);
            },
            visitIfConditionParenthesized$1: function(_, node) {
                return this.visitIfConditionParenthesized$body$_EvaluateVisitor(0, node);
            },
            visitIfConditionParenthesized$body$_EvaluateVisitor: function(_, node) {
                var $async$goto = 0, $async$completer = A._makeAsyncAwaitCompleter(type$.Object), $async$returnValue, $async$self = this, t1, _0_0;
                var $async$visitIfConditionParenthesized$1 = A._wrapJsFunctionForAsync(function($async$errorCode, $async$result) {
                    if ($async$errorCode === 1) return A._asyncRethrow($async$result, $async$completer);
                    for(;;)switch($async$goto){
                        case 0:
                            // Function start
                            $async$goto = 3;
                            return A._asyncAwait(node.expression.accept$1($async$self), $async$visitIfConditionParenthesized$1);
                        case 3:
                            // returning from await.
                            _0_0 = $async$result;
                            $label0$0: {
                                if (typeof _0_0 == "string") {
                                    t1 = "(" + _0_0 + ")";
                                    break $label0$0;
                                }
                                t1 = _0_0;
                                break $label0$0;
                            }
                            $async$returnValue = t1;
                            // goto return
                            $async$goto = 1;
                            break;
                        case 1:
                            // return
                            return A._asyncReturn($async$returnValue, $async$completer);
                    }
                });
                return A._asyncStartSync($async$visitIfConditionParenthesized$1, $async$completer);
            },
            visitIfConditionNegation$1: function(_, node) {
                return this.visitIfConditionNegation$body$_EvaluateVisitor(0, node);
            },
            visitIfConditionNegation$body$_EvaluateVisitor: function(_, node) {
                var $async$goto = 0, $async$completer = A._makeAsyncAwaitCompleter(type$.Object), $async$returnValue, $async$self = this, t1, _0_0;
                var $async$visitIfConditionNegation$1 = A._wrapJsFunctionForAsync(function($async$errorCode, $async$result) {
                    if ($async$errorCode === 1) return A._asyncRethrow($async$result, $async$completer);
                    for(;;)switch($async$goto){
                        case 0:
                            // Function start
                            $async$goto = 3;
                            return A._asyncAwait(node.expression.accept$1($async$self), $async$visitIfConditionNegation$1);
                        case 3:
                            // returning from await.
                            _0_0 = $async$result;
                            $label0$0: {
                                if (typeof _0_0 == "string") {
                                    t1 = "not " + _0_0;
                                    break $label0$0;
                                }
                                if (A._isBool(_0_0)) {
                                    t1 = !_0_0;
                                    break $label0$0;
                                }
                                t1 = A.throwExpression(A.UnsupportedError$("unreachable"));
                            }
                            $async$returnValue = t1;
                            // goto return
                            $async$goto = 1;
                            break;
                        case 1:
                            // return
                            return A._asyncReturn($async$returnValue, $async$completer);
                    }
                });
                return A._asyncStartSync($async$visitIfConditionNegation$1, $async$completer);
            },
            visitIfConditionOperation$1: function(_, node) {
                return this.visitIfConditionOperation$body$_EvaluateVisitor(0, node);
            },
            visitIfConditionOperation$body$_EvaluateVisitor: function(_, node) {
                var $async$goto = 0, $async$completer = A._makeAsyncAwaitCompleter(type$.Object), $async$returnValue, $async$self = this, t1, t2, t3, t4, t5, t6, values, _i, expression, _0_0, t7, right, _1_6_isSet, _1_6, string;
                var $async$visitIfConditionOperation$1 = A._wrapJsFunctionForAsync(function($async$errorCode, $async$result) {
                    if ($async$errorCode === 1) return A._asyncRethrow($async$result, $async$completer);
                    for(;;)switch($async$goto){
                        case 0:
                            // Function start
                            t1 = node.expressions, t2 = t1.length, t3 = node.op, t4 = t3 === B.BooleanOperator_0, t5 = t3 === B.BooleanOperator_1, t6 = type$.JSArray_Record_2_IfConditionExpression_and_String, values = null, _i = 0;
                        case 3:
                            // for condition
                            if (!(_i < t2)) {
                                // goto after for
                                $async$goto = 5;
                                break;
                            }
                            expression = t1[_i];
                            $async$goto = 6;
                            return A._asyncAwait(expression.accept$1($async$self), $async$visitIfConditionOperation$1);
                        case 6:
                            // returning from await.
                            _0_0 = $async$result;
                            t7 = typeof _0_0 == "string";
                            right = t7 ? _0_0 : null;
                            if (t7) {
                                if (values == null) values = A._setArrayType([], t6);
                                values.push(new A._Record_2(expression, right));
                                // goto for update
                                $async$goto = 4;
                                break;
                            }
                            if (false === _0_0 && t4) {
                                $async$returnValue = false;
                                // goto return
                                $async$goto = 1;
                                break;
                            }
                            if (true === _0_0 && t5) {
                                $async$returnValue = true;
                                // goto return
                                $async$goto = 1;
                                break;
                            }
                        case 4:
                            // for update
                            ++_i;
                            // goto for condition
                            $async$goto = 3;
                            break;
                        case 5:
                            // after for
                            $label0$1: {
                                if (values == null) {
                                    t1 = t4;
                                    break $label0$1;
                                }
                                _1_6_isSet = values.length === 1;
                                if (_1_6_isSet) {
                                    _1_6 = values[0];
                                    t1 = _1_6._0 instanceof A.IfConditionParenthesized;
                                } else {
                                    _1_6 = null;
                                    t1 = false;
                                }
                                if (t1) {
                                    string = (_1_6_isSet ? _1_6 : values[0])._1;
                                    t1 = B.JSString_methods.substring$2(string, 1, string.length - 1);
                                    break $label0$1;
                                }
                                t1 = new A.MappedListIterable(values, new A._EvaluateVisitor_visitIfConditionOperation_closure0(), A._arrayInstanceType(values)._eval$1("MappedListIterable<1,String>")).join$1(0, " " + t3.toString$0(0) + " ");
                                break $label0$1;
                            }
                            $async$returnValue = t1;
                            // goto return
                            $async$goto = 1;
                            break;
                        case 1:
                            // return
                            return A._asyncReturn($async$returnValue, $async$completer);
                    }
                });
                return A._asyncStartSync($async$visitIfConditionOperation$1, $async$completer);
            },
            visitIfConditionFunction$1: function(_, node) {
                return this.visitIfConditionFunction$body$_EvaluateVisitor(0, node);
            },
            visitIfConditionFunction$body$_EvaluateVisitor: function(_, node) {
                var $async$goto = 0, $async$completer = A._makeAsyncAwaitCompleter(type$.Object), $async$returnValue, $async$self = this, $async$temp1, $async$temp2;
                var $async$visitIfConditionFunction$1 = A._wrapJsFunctionForAsync(function($async$errorCode, $async$result) {
                    if ($async$errorCode === 1) return A._asyncRethrow($async$result, $async$completer);
                    for(;;)switch($async$goto){
                        case 0:
                            // Function start
                            $async$temp1 = B.JSString_methods;
                            $async$temp2 = J;
                            $async$goto = 3;
                            return A._asyncAwait($async$self._async_evaluate$_performInterpolation$1(node.name), $async$visitIfConditionFunction$1);
                        case 3:
                            // returning from await.
                            $async$temp2 = $async$temp2.$add$ansx($async$result, "(");
                            $async$goto = 4;
                            return A._asyncAwait($async$self._async_evaluate$_performInterpolation$1(node.$arguments), $async$visitIfConditionFunction$1);
                        case 4:
                            // returning from await.
                            $async$returnValue = $async$temp1.$add($async$temp2, $async$result) + ")";
                            // goto return
                            $async$goto = 1;
                            break;
                        case 1:
                            // return
                            return A._asyncReturn($async$returnValue, $async$completer);
                    }
                });
                return A._asyncStartSync($async$visitIfConditionFunction$1, $async$completer);
            },
            visitIfConditionSass$1: function(_, node) {
                return this.visitIfConditionSass$body$_EvaluateVisitor(0, node);
            },
            visitIfConditionSass$body$_EvaluateVisitor: function(_, node) {
                var $async$goto = 0, $async$completer = A._makeAsyncAwaitCompleter(type$.Object), $async$returnValue, $async$self = this;
                var $async$visitIfConditionSass$1 = A._wrapJsFunctionForAsync(function($async$errorCode, $async$result) {
                    if ($async$errorCode === 1) return A._asyncRethrow($async$result, $async$completer);
                    for(;;)switch($async$goto){
                        case 0:
                            // Function start
                            $async$goto = 3;
                            return A._asyncAwait(node.expression.accept$1($async$self), $async$visitIfConditionSass$1);
                        case 3:
                            // returning from await.
                            $async$returnValue = $async$result.get$isTruthy();
                            // goto return
                            $async$goto = 1;
                            break;
                        case 1:
                            // return
                            return A._asyncReturn($async$returnValue, $async$completer);
                    }
                });
                return A._asyncStartSync($async$visitIfConditionSass$1, $async$completer);
            },
            visitIfConditionRaw$1: function(_, node) {
                return this.visitIfConditionRaw$body$_EvaluateVisitor(0, node);
            },
            visitIfConditionRaw$body$_EvaluateVisitor: function(_, node) {
                var $async$goto = 0, $async$completer = A._makeAsyncAwaitCompleter(type$.Object), $async$returnValue, $async$self = this;
                var $async$visitIfConditionRaw$1 = A._wrapJsFunctionForAsync(function($async$errorCode, $async$result) {
                    if ($async$errorCode === 1) return A._asyncRethrow($async$result, $async$completer);
                    for(;;)switch($async$goto){
                        case 0:
                            // Function start
                            $async$goto = 3;
                            return A._asyncAwait($async$self._async_evaluate$_performInterpolation$1(node.text), $async$visitIfConditionRaw$1);
                        case 3:
                            // returning from await.
                            $async$returnValue = $async$result;
                            // goto return
                            $async$goto = 1;
                            break;
                        case 1:
                            // return
                            return A._asyncReturn($async$returnValue, $async$completer);
                    }
                });
                return A._asyncStartSync($async$visitIfConditionRaw$1, $async$completer);
            },
            visitLegacyIfExpression$1: function(_, node) {
                return this.visitLegacyIfExpression$body$_EvaluateVisitor(0, node);
            },
            visitLegacyIfExpression$body$_EvaluateVisitor: function(_, node) {
                var $async$goto = 0, $async$completer = A._makeAsyncAwaitCompleter(type$.Value), $async$returnValue, $async$self = this, condition, t1, ifTrue, ifFalse, result, _0_0, positional, named;
                var $async$visitLegacyIfExpression$1 = A._wrapJsFunctionForAsync(function($async$errorCode, $async$result) {
                    if ($async$errorCode === 1) return A._asyncRethrow($async$result, $async$completer);
                    for(;;)switch($async$goto){
                        case 0:
                            // Function start
                            $async$goto = 3;
                            return A._asyncAwait($async$self._async_evaluate$_evaluateMacroArguments$1(node), $async$visitLegacyIfExpression$1);
                        case 3:
                            // returning from await.
                            _0_0 = $async$result;
                            positional = _0_0._0;
                            named = _0_0._1;
                            $async$self._async_evaluate$_verifyArguments$4(J.get$length$asx(positional), named, $.$get$LegacyIfExpression_declaration(), node);
                            condition = A.ListExtensions_elementAtOrNull(positional, 0);
                            if (condition == null) {
                                t1 = named.$index(0, "condition");
                                t1.toString;
                                condition = t1;
                            }
                            ifTrue = A.ListExtensions_elementAtOrNull(positional, 1);
                            if (ifTrue == null) {
                                t1 = named.$index(0, "if-true");
                                t1.toString;
                                ifTrue = t1;
                            }
                            ifFalse = A.ListExtensions_elementAtOrNull(positional, 2);
                            if (ifFalse == null) {
                                t1 = named.$index(0, "if-false");
                                t1.toString;
                                ifFalse = t1;
                            }
                            $async$goto = 4;
                            return A._asyncAwait(condition.accept$1($async$self), $async$visitLegacyIfExpression$1);
                        case 4:
                            // returning from await.
                            result = $async$result.get$isTruthy() ? ifTrue : ifFalse;
                            t1 = result.accept$1($async$self);
                            $async$goto = 5;
                            return A._asyncAwait(type$.Future_Value._is(t1) ? t1 : A._Future$value(t1, type$.Value), $async$visitLegacyIfExpression$1);
                        case 5:
                            // returning from await.
                            $async$returnValue = $async$self._async_evaluate$_withoutSlash$2($async$result, $async$self._async_evaluate$_expressionNode$1(result));
                            // goto return
                            $async$goto = 1;
                            break;
                        case 1:
                            // return
                            return A._asyncReturn($async$returnValue, $async$completer);
                    }
                });
                return A._asyncStartSync($async$visitLegacyIfExpression$1, $async$completer);
            },
            visitNullExpression$1: function(_, node) {
                return this.visitNullExpression$body$_EvaluateVisitor(0, node);
            },
            visitNullExpression$body$_EvaluateVisitor: function(_, node) {
                var $async$goto = 0, $async$completer = A._makeAsyncAwaitCompleter(type$.Value), $async$returnValue;
                var $async$visitNullExpression$1 = A._wrapJsFunctionForAsync(function($async$errorCode, $async$result) {
                    if ($async$errorCode === 1) return A._asyncRethrow($async$result, $async$completer);
                    for(;;)switch($async$goto){
                        case 0:
                            // Function start
                            $async$returnValue = B.C__SassNull;
                            // goto return
                            $async$goto = 1;
                            break;
                        case 1:
                            // return
                            return A._asyncReturn($async$returnValue, $async$completer);
                    }
                });
                return A._asyncStartSync($async$visitNullExpression$1, $async$completer);
            },
            visitNumberExpression$1: function(_, node) {
                return this.visitNumberExpression$body$_EvaluateVisitor(0, node);
            },
            visitNumberExpression$body$_EvaluateVisitor: function(_, node) {
                var $async$goto = 0, $async$completer = A._makeAsyncAwaitCompleter(type$.SassNumber), $async$returnValue;
                var $async$visitNumberExpression$1 = A._wrapJsFunctionForAsync(function($async$errorCode, $async$result) {
                    if ($async$errorCode === 1) return A._asyncRethrow($async$result, $async$completer);
                    for(;;)switch($async$goto){
                        case 0:
                            // Function start
                            $async$returnValue = A.SassNumber_SassNumber(node.value, node.unit);
                            // goto return
                            $async$goto = 1;
                            break;
                        case 1:
                            // return
                            return A._asyncReturn($async$returnValue, $async$completer);
                    }
                });
                return A._asyncStartSync($async$visitNumberExpression$1, $async$completer);
            },
            visitParenthesizedExpression$1: function(_, node) {
                var _this = this;
                return _this._async_evaluate$_assertInModule$2(_this._async_evaluate$__stylesheet, "_stylesheet").plainCss ? A.throwExpression(_this._async_evaluate$_exception$2("Parentheses aren't allowed in plain CSS.", node.span)) : node.expression.accept$1(_this);
            },
            visitColorExpression$1: function(_, node) {
                return this.visitColorExpression$body$_EvaluateVisitor(0, node);
            },
            visitColorExpression$body$_EvaluateVisitor: function(_, node) {
                var $async$goto = 0, $async$completer = A._makeAsyncAwaitCompleter(type$.SassColor), $async$returnValue;
                var $async$visitColorExpression$1 = A._wrapJsFunctionForAsync(function($async$errorCode, $async$result) {
                    if ($async$errorCode === 1) return A._asyncRethrow($async$result, $async$completer);
                    for(;;)switch($async$goto){
                        case 0:
                            // Function start
                            $async$returnValue = node.value;
                            // goto return
                            $async$goto = 1;
                            break;
                        case 1:
                            // return
                            return A._asyncReturn($async$returnValue, $async$completer);
                    }
                });
                return A._asyncStartSync($async$visitColorExpression$1, $async$completer);
            },
            visitListExpression$1: function(_, node) {
                return this.visitListExpression$body$_EvaluateVisitor(0, node);
            },
            visitListExpression$body$_EvaluateVisitor: function(_, node) {
                var $async$goto = 0, $async$completer = A._makeAsyncAwaitCompleter(type$.SassList), $async$returnValue, $async$self = this, $async$temp1;
                var $async$visitListExpression$1 = A._wrapJsFunctionForAsync(function($async$errorCode, $async$result) {
                    if ($async$errorCode === 1) return A._asyncRethrow($async$result, $async$completer);
                    for(;;)switch($async$goto){
                        case 0:
                            // Function start
                            $async$temp1 = A;
                            $async$goto = 3;
                            return A._asyncAwait(A.mapAsync(node.contents, new A._EvaluateVisitor_visitListExpression_closure0($async$self), type$.Expression, type$.Value), $async$visitListExpression$1);
                        case 3:
                            // returning from await.
                            $async$returnValue = $async$temp1.SassList$($async$result, node.separator, node.hasBrackets);
                            // goto return
                            $async$goto = 1;
                            break;
                        case 1:
                            // return
                            return A._asyncReturn($async$returnValue, $async$completer);
                    }
                });
                return A._asyncStartSync($async$visitListExpression$1, $async$completer);
            },
            visitMapExpression$1: function(_, node) {
                return this.visitMapExpression$body$_EvaluateVisitor(0, node);
            },
            visitMapExpression$body$_EvaluateVisitor: function(_, node) {
                var $async$goto = 0, $async$completer = A._makeAsyncAwaitCompleter(type$.SassMap), $async$returnValue, $async$self = this, t2, t3, _i, t4, key, keyValue, valueValue, oldValueSpan, t1, map, keyNodes;
                var $async$visitMapExpression$1 = A._wrapJsFunctionForAsync(function($async$errorCode, $async$result) {
                    if ($async$errorCode === 1) return A._asyncRethrow($async$result, $async$completer);
                    for(;;)switch($async$goto){
                        case 0:
                            // Function start
                            t1 = type$.Value;
                            map = A.LinkedHashMap_LinkedHashMap$_empty(t1, t1);
                            keyNodes = A.LinkedHashMap_LinkedHashMap$_empty(t1, type$.AstNode);
                            t2 = node.pairs, t3 = t2.length, _i = 0;
                        case 3:
                            // for condition
                            if (!(_i < t3)) {
                                // goto after for
                                $async$goto = 5;
                                break;
                            }
                            t4 = t2[_i];
                            key = t4._0;
                            $async$goto = 6;
                            return A._asyncAwait(key.accept$1($async$self), $async$visitMapExpression$1);
                        case 6:
                            // returning from await.
                            keyValue = $async$result;
                            $async$goto = 7;
                            return A._asyncAwait(t4._1.accept$1($async$self), $async$visitMapExpression$1);
                        case 7:
                            // returning from await.
                            valueValue = $async$result;
                            if (map.containsKey$1(keyValue)) {
                                t1 = keyNodes.$index(0, keyValue);
                                oldValueSpan = t1 == null ? null : t1.get$span(t1);
                                t1 = key.get$span(key);
                                t2 = A.LinkedHashMap_LinkedHashMap$_empty(type$.FileSpan, type$.String);
                                if (oldValueSpan != null) t2.$indexSet(0, oldValueSpan, "first key");
                                throw A.wrapException(A.MultiSpanSassRuntimeException$("Duplicate key.", t1, "second key", t2, $async$self._async_evaluate$_stackTrace$1(key.get$span(key)), null));
                            }
                            map.$indexSet(0, keyValue, valueValue);
                            keyNodes.$indexSet(0, keyValue, key);
                        case 4:
                            // for update
                            ++_i;
                            // goto for condition
                            $async$goto = 3;
                            break;
                        case 5:
                            // after for
                            $async$returnValue = new A.SassMap(A.ConstantMap_ConstantMap$from(map, t1, t1));
                            // goto return
                            $async$goto = 1;
                            break;
                        case 1:
                            // return
                            return A._asyncReturn($async$returnValue, $async$completer);
                    }
                });
                return A._asyncStartSync($async$visitMapExpression$1, $async$completer);
            },
            visitFunctionExpression$1: function(_, node) {
                return this.visitFunctionExpression$body$_EvaluateVisitor(0, node);
            },
            visitFunctionExpression$body$_EvaluateVisitor: function(_, node) {
                var $async$goto = 0, $async$completer = A._makeAsyncAwaitCompleter(type$.Value), $async$returnValue, $async$self = this, t2, _0_0, t3, t4, $name, oldInFunction, result, t1, $function;
                var $async$visitFunctionExpression$1 = A._wrapJsFunctionForAsync(function($async$errorCode, $async$result) {
                    if ($async$errorCode === 1) return A._asyncRethrow($async$result, $async$completer);
                    for(;;)switch($async$goto){
                        case 0:
                            // Function start
                            t1 = {};
                            $function = $async$self._async_evaluate$_assertInModule$2($async$self._async_evaluate$__stylesheet, "_stylesheet").plainCss ? null : $async$self._async_evaluate$_addExceptionSpan$2(node, new A._EvaluateVisitor_visitFunctionExpression_closure2($async$self, node));
                            t1.$function = $function;
                            $async$goto = $function == null || B.JSString_methods.startsWith$1(node.originalName, "--") ? 3 : 4;
                            break;
                        case 3:
                            // then
                            if (node.namespace != null) throw A.wrapException($async$self._async_evaluate$_exception$2("Undefined function.", node.span));
                            t2 = node.name;
                            _0_0 = t2.toLowerCase();
                            t3 = false;
                            if ("min" === _0_0 || "max" === _0_0 || "round" === _0_0 || "abs" === _0_0) {
                                t3 = node.$arguments;
                                t4 = t3.named;
                                t3 = t4.get$isEmpty(t4) && t3.rest == null && B.JSArray_methods.every$1(t3.positional, new A._EvaluateVisitor_visitFunctionExpression_closure3());
                                $name = _0_0;
                            } else $name = null;
                            $async$goto = t3 ? 5 : 6;
                            break;
                        case 5:
                            // then
                            $async$goto = 7;
                            return A._asyncAwait($async$self._async_evaluate$_visitCalculation$2$inLegacySassFunction(node, $name), $async$visitFunctionExpression$1);
                        case 7:
                            // returning from await.
                            $async$returnValue = $async$result;
                            // goto return
                            $async$goto = 1;
                            break;
                        case 6:
                            // join
                            $async$goto = "calc" === _0_0 || "clamp" === _0_0 || "hypot" === _0_0 || "sin" === _0_0 || "cos" === _0_0 || "tan" === _0_0 || "asin" === _0_0 || "acos" === _0_0 || "atan" === _0_0 || "sqrt" === _0_0 || "exp" === _0_0 || "sign" === _0_0 || "mod" === _0_0 || "rem" === _0_0 || "atan2" === _0_0 || "pow" === _0_0 || "log" === _0_0 || "calc-size" === _0_0 ? 8 : 9;
                            break;
                        case 8:
                            // then
                            $async$goto = 10;
                            return A._asyncAwait($async$self._async_evaluate$_visitCalculation$1(node), $async$visitFunctionExpression$1);
                        case 10:
                            // returning from await.
                            $async$returnValue = $async$result;
                            // goto return
                            $async$goto = 1;
                            break;
                        case 9:
                            // join
                            $function = $async$self._async_evaluate$_assertInModule$2($async$self._async_evaluate$__stylesheet, "_stylesheet").plainCss ? null : $async$self._async_evaluate$_builtInFunctions.$index(0, t2);
                            t1.$function = $function == null ? new A.PlainCssCallable(node.originalName) : $function;
                        case 4:
                            // join
                            oldInFunction = $async$self._async_evaluate$_inFunction;
                            $async$self._async_evaluate$_inFunction = true;
                            $async$goto = 11;
                            return A._asyncAwait($async$self._async_evaluate$_addErrorSpan$1$2(node, new A._EvaluateVisitor_visitFunctionExpression_closure4(t1, $async$self, node), type$.Value), $async$visitFunctionExpression$1);
                        case 11:
                            // returning from await.
                            result = $async$result;
                            $async$self._async_evaluate$_inFunction = oldInFunction;
                            $async$returnValue = result;
                            // goto return
                            $async$goto = 1;
                            break;
                        case 1:
                            // return
                            return A._asyncReturn($async$returnValue, $async$completer);
                    }
                });
                return A._asyncStartSync($async$visitFunctionExpression$1, $async$completer);
            },
            _async_evaluate$_visitCalculation$2$inLegacySassFunction: function(node, inLegacySassFunction) {
                return this._visitCalculation$body$_EvaluateVisitor(node, inLegacySassFunction);
            },
            _async_evaluate$_visitCalculation$1: function(node) {
                return this._async_evaluate$_visitCalculation$2$inLegacySassFunction(node, null);
            },
            _visitCalculation$body$_EvaluateVisitor: function(node, inLegacySassFunction) {
                var $async$goto = 0, $async$completer = A._makeAsyncAwaitCompleter(type$.Value), $async$returnValue, $async$next = [], $async$self = this, $arguments, oldCallableNode, t1, _0_0, error, stackTrace, t4, _i, exception, t2, t3, $async$temp1;
                var $async$_async_evaluate$_visitCalculation$2$inLegacySassFunction = A._wrapJsFunctionForAsync(function($async$errorCode, $async$result) {
                    if ($async$errorCode === 1) return A._asyncRethrow($async$result, $async$completer);
                    for(;;)switch($async$goto){
                        case 0:
                            // Function start
                            t2 = node.$arguments;
                            t3 = t2.named;
                            if (t3.get$isNotEmpty(t3)) throw A.wrapException($async$self._async_evaluate$_exception$2(string$.Keywor, node.span));
                            else if (t2.rest != null) throw A.wrapException($async$self._async_evaluate$_exception$2(string$.Rest_a, node.span));
                            $async$self._async_evaluate$_checkCalculationArguments$1(node);
                            t3 = A._setArrayType([], type$.JSArray_Object);
                            t2 = t2.positional, t4 = t2.length, _i = 0;
                        case 3:
                            // for condition
                            if (!(_i < t4)) {
                                // goto after for
                                $async$goto = 5;
                                break;
                            }
                            $async$temp1 = t3;
                            $async$goto = 6;
                            return A._asyncAwait($async$self._async_evaluate$_visitCalculationExpression$2$inLegacySassFunction(t2[_i], inLegacySassFunction), $async$_async_evaluate$_visitCalculation$2$inLegacySassFunction);
                        case 6:
                            // returning from await.
                            $async$temp1.push($async$result);
                        case 4:
                            // for update
                            ++_i;
                            // goto for condition
                            $async$goto = 3;
                            break;
                        case 5:
                            // after for
                            $arguments = t3;
                            if ($async$self._async_evaluate$_inSupportsDeclaration) {
                                $async$returnValue = new A.SassCalculation(node.name, A.List_List$unmodifiable($arguments, type$.Object));
                                // goto return
                                $async$goto = 1;
                                break;
                            }
                            oldCallableNode = $async$self._async_evaluate$_callableNode;
                            $async$self._async_evaluate$_callableNode = node;
                            try {
                                t1 = null;
                                t3 = node.name;
                                _0_0 = t3.toLowerCase();
                                $label0$0: {
                                    if ("calc" === _0_0) {
                                        t1 = A.SassCalculation_calc(J.$index$asx($arguments, 0));
                                        break $label0$0;
                                    }
                                    if ("sqrt" === _0_0) {
                                        t1 = A.SassCalculation__singleArgument("sqrt", J.$index$asx($arguments, 0), A.number0__sqrt$closure(), true);
                                        break $label0$0;
                                    }
                                    if ("sin" === _0_0) {
                                        t1 = A.SassCalculation__singleArgument("sin", J.$index$asx($arguments, 0), A.number0__sin$closure(), false);
                                        break $label0$0;
                                    }
                                    if ("cos" === _0_0) {
                                        t1 = A.SassCalculation__singleArgument("cos", J.$index$asx($arguments, 0), A.number0__cos$closure(), false);
                                        break $label0$0;
                                    }
                                    if ("tan" === _0_0) {
                                        t1 = A.SassCalculation__singleArgument("tan", J.$index$asx($arguments, 0), A.number0__tan$closure(), false);
                                        break $label0$0;
                                    }
                                    if ("asin" === _0_0) {
                                        t1 = A.SassCalculation__singleArgument("asin", J.$index$asx($arguments, 0), A.number0__asin$closure(), true);
                                        break $label0$0;
                                    }
                                    if ("acos" === _0_0) {
                                        t1 = A.SassCalculation__singleArgument("acos", J.$index$asx($arguments, 0), A.number0__acos$closure(), true);
                                        break $label0$0;
                                    }
                                    if ("atan" === _0_0) {
                                        t1 = A.SassCalculation__singleArgument("atan", J.$index$asx($arguments, 0), A.number0__atan$closure(), true);
                                        break $label0$0;
                                    }
                                    if ("abs" === _0_0) {
                                        t1 = A.SassCalculation_abs(J.$index$asx($arguments, 0));
                                        break $label0$0;
                                    }
                                    if ("exp" === _0_0) {
                                        t1 = A.SassCalculation_exp(J.$index$asx($arguments, 0));
                                        break $label0$0;
                                    }
                                    if ("sign" === _0_0) {
                                        t1 = A.SassCalculation_sign(J.$index$asx($arguments, 0));
                                        break $label0$0;
                                    }
                                    if ("min" === _0_0) {
                                        t1 = A.SassCalculation_min($arguments);
                                        break $label0$0;
                                    }
                                    if ("max" === _0_0) {
                                        t1 = A.SassCalculation_max($arguments);
                                        break $label0$0;
                                    }
                                    if ("hypot" === _0_0) {
                                        t1 = A.SassCalculation_hypot($arguments);
                                        break $label0$0;
                                    }
                                    if ("pow" === _0_0) {
                                        t1 = A.SassCalculation_pow(J.$index$asx($arguments, 0), A.ListExtensions_elementAtOrNull($arguments, 1));
                                        break $label0$0;
                                    }
                                    if ("atan2" === _0_0) {
                                        t1 = A.SassCalculation_atan2(J.$index$asx($arguments, 0), A.ListExtensions_elementAtOrNull($arguments, 1));
                                        break $label0$0;
                                    }
                                    if ("log" === _0_0) {
                                        t1 = A.SassCalculation_log(J.$index$asx($arguments, 0), A.ListExtensions_elementAtOrNull($arguments, 1));
                                        break $label0$0;
                                    }
                                    if ("mod" === _0_0) {
                                        t1 = A.SassCalculation_mod(J.$index$asx($arguments, 0), A.ListExtensions_elementAtOrNull($arguments, 1));
                                        break $label0$0;
                                    }
                                    if ("rem" === _0_0) {
                                        t1 = A.SassCalculation_rem(J.$index$asx($arguments, 0), A.ListExtensions_elementAtOrNull($arguments, 1));
                                        break $label0$0;
                                    }
                                    if ("round" === _0_0) {
                                        t1 = A.SassCalculation_roundInternal(J.$index$asx($arguments, 0), A.ListExtensions_elementAtOrNull($arguments, 1), A.ListExtensions_elementAtOrNull($arguments, 2), inLegacySassFunction, node.span, new A._EvaluateVisitor__visitCalculation_closure0($async$self, node));
                                        break $label0$0;
                                    }
                                    if ("clamp" === _0_0) {
                                        t1 = A.SassCalculation_clamp(J.$index$asx($arguments, 0), A.ListExtensions_elementAtOrNull($arguments, 1), A.ListExtensions_elementAtOrNull($arguments, 2));
                                        break $label0$0;
                                    }
                                    if ("calc-size" === _0_0) {
                                        t1 = A.SassCalculation_calcSize(J.$index$asx($arguments, 0), A.ListExtensions_elementAtOrNull($arguments, 1));
                                        break $label0$0;
                                    }
                                    t3 = A.UnsupportedError$('Unknown calculation name "' + t3 + '".');
                                    t1 = A.throwExpression(t3);
                                }
                                t1;
                                $async$returnValue = t1;
                                // goto return
                                $async$goto = 1;
                                break;
                            } catch (exception) {
                                t1 = A.unwrapException(exception);
                                if (t1 instanceof A.SassScriptException) {
                                    error = t1;
                                    stackTrace = A.getTraceFromException(exception);
                                    if (B.JSString_methods.contains$1(error.message, "compatible")) $async$self._async_evaluate$_verifyCompatibleNumbers$2($arguments, t2);
                                    A.throwWithTrace($async$self._async_evaluate$_exception$2(error.message, node.span), error, stackTrace);
                                } else throw exception;
                            } finally{
                                $async$self._async_evaluate$_callableNode = oldCallableNode;
                            }
                        case 1:
                            // return
                            return A._asyncReturn($async$returnValue, $async$completer);
                    }
                });
                return A._asyncStartSync($async$_async_evaluate$_visitCalculation$2$inLegacySassFunction, $async$completer);
            },
            _async_evaluate$_checkCalculationArguments$1: function(node) {
                var t1, _0_0, check = new A._EvaluateVisitor__checkCalculationArguments_check0(this, node);
                $label0$0: {
                    t1 = node.name;
                    _0_0 = t1.toLowerCase();
                    if ("calc" === _0_0 || "sqrt" === _0_0 || "sin" === _0_0 || "cos" === _0_0 || "tan" === _0_0 || "asin" === _0_0 || "acos" === _0_0 || "atan" === _0_0 || "abs" === _0_0 || "exp" === _0_0 || "sign" === _0_0) {
                        check.call$1(1);
                        break $label0$0;
                    }
                    if ("min" === _0_0 || "max" === _0_0 || "hypot" === _0_0) {
                        check.call$0();
                        break $label0$0;
                    }
                    if ("pow" === _0_0 || "atan2" === _0_0 || "log" === _0_0 || "mod" === _0_0 || "rem" === _0_0 || "calc-size" === _0_0) {
                        check.call$1(2);
                        break $label0$0;
                    }
                    if ("round" === _0_0 || "clamp" === _0_0) {
                        check.call$1(3);
                        break $label0$0;
                    }
                    throw A.wrapException(A.UnsupportedError$('Unknown calculation name "' + t1 + '".'));
                }
            },
            _async_evaluate$_verifyCompatibleNumbers$2: function(args, nodesWithSpans) {
                var i, t1, _0_0, arg, t2, number1, j, number2, t3, t4, t5, t6;
                for(i = 0; t1 = args.length, i < t1; ++i){
                    _0_0 = args[i];
                    if (_0_0 instanceof A.SassNumber) {
                        t1 = _0_0.get$hasComplexUnits();
                        arg = _0_0;
                    } else {
                        arg = null;
                        t1 = false;
                    }
                    if (t1) {
                        t1 = A.S(arg);
                        t2 = nodesWithSpans[i];
                        throw A.wrapException(this._async_evaluate$_exception$2("Number " + t1 + " isn't compatible with CSS calculations.", t2.get$span(t2)));
                    }
                }
                for(i = 0; i < t1 - 1; ++i){
                    number1 = args[i];
                    if (!(number1 instanceof A.SassNumber)) continue;
                    for(j = i + 1; t1 = args.length, j < t1; ++j){
                        number2 = args[j];
                        if (!(number2 instanceof A.SassNumber)) continue;
                        if (number1.hasPossiblyCompatibleUnits$1(number2)) continue;
                        t1 = number1.toString$0(0);
                        t2 = number2.toString$0(0);
                        t3 = nodesWithSpans[i];
                        t3 = t3.get$span(t3);
                        t4 = number1.toString$0(0);
                        t5 = nodesWithSpans[j];
                        t5 = A.LinkedHashMap_LinkedHashMap$_literal([
                            t5.get$span(t5),
                            number2.toString$0(0)
                        ], type$.FileSpan, type$.String);
                        t6 = nodesWithSpans[i];
                        throw A.wrapException(A.MultiSpanSassRuntimeException$(t1 + " and " + t2 + " are incompatible.", t3, t4, t5, this._async_evaluate$_stackTrace$1(t6.get$span(t6)), null));
                    }
                }
            },
            _async_evaluate$_visitCalculationExpression$2$inLegacySassFunction: function(node, inLegacySassFunction) {
                return this._visitCalculationExpression$body$_EvaluateVisitor(node, inLegacySassFunction);
            },
            _visitCalculationExpression$body$_EvaluateVisitor: function(node, inLegacySassFunction) {
                var $async$goto = 0, $async$completer = A._makeAsyncAwaitCompleter(type$.Object), $async$returnValue, $async$self = this, result, t2, _0_0, _box_0, _1_0, t3, _i, i, t1, inner, $async$temp1;
                var $async$_async_evaluate$_visitCalculationExpression$2$inLegacySassFunction = A._wrapJsFunctionForAsync(function($async$errorCode, $async$result) {
                    if ($async$errorCode === 1) return A._asyncRethrow($async$result, $async$completer);
                    for(;;)switch($async$goto){
                        case 0:
                            // Function start
                            t1 = node instanceof A.ParenthesizedExpression;
                            inner = t1 ? node.expression : null;
                            $async$goto = t1 ? 3 : 4;
                            break;
                        case 3:
                            // then
                            $async$goto = 5;
                            return A._asyncAwait($async$self._async_evaluate$_visitCalculationExpression$2$inLegacySassFunction(inner, inLegacySassFunction), $async$_async_evaluate$_visitCalculationExpression$2$inLegacySassFunction);
                        case 5:
                            // returning from await.
                            result = $async$result;
                            $async$returnValue = result instanceof A.SassString ? new A.SassString("(" + result._string$_text + ")", false) : result;
                            // goto return
                            $async$goto = 1;
                            break;
                        case 4:
                            // join
                            $async$goto = node instanceof A.StringExpression && node.accept$1(B.C_IsCalculationSafeVisitor) ? 6 : 7;
                            break;
                        case 6:
                            // then
                            t1 = node.text;
                            t2 = t1.get$asPlain();
                            _0_0 = t2 == null ? null : t2.toLowerCase();
                            if ("pi" === _0_0) {
                                t1 = A.SassNumber_SassNumber(3.141592653589793, null);
                                // goto break $label0$0
                                $async$goto = 8;
                                break;
                            }
                            if ("e" === _0_0) {
                                t1 = A.SassNumber_SassNumber(2.718281828459045, null);
                                // goto break $label0$0
                                $async$goto = 8;
                                break;
                            }
                            if ("infinity" === _0_0) {
                                t1 = A.SassNumber_SassNumber(1 / 0, null);
                                // goto break $label0$0
                                $async$goto = 8;
                                break;
                            }
                            if ("-infinity" === _0_0) {
                                t1 = A.SassNumber_SassNumber(-1 / 0, null);
                                // goto break $label0$0
                                $async$goto = 8;
                                break;
                            }
                            if ("nan" === _0_0) {
                                t1 = A.SassNumber_SassNumber(0 / 0, null);
                                // goto break $label0$0
                                $async$goto = 8;
                                break;
                            }
                            $async$temp1 = A;
                            $async$goto = 9;
                            return A._asyncAwait($async$self._async_evaluate$_performInterpolation$1(t1), $async$_async_evaluate$_visitCalculationExpression$2$inLegacySassFunction);
                        case 9:
                            // returning from await.
                            t1 = new $async$temp1.SassString($async$result, false);
                            // goto break $label0$0
                            $async$goto = 8;
                            break;
                        case 8:
                            // break $label0$0
                            $async$returnValue = t1;
                            // goto return
                            $async$goto = 1;
                            break;
                        case 7:
                            // join
                            _box_0 = {};
                            _box_0.right = _box_0.left = _box_0.operator = null;
                            t1 = node instanceof A.BinaryOperationExpression;
                            if (t1) {
                                _box_0.operator = node.operator;
                                _box_0.left = node.left;
                                _box_0.right = node.right;
                            }
                            $async$goto = t1 ? 10 : 11;
                            break;
                        case 10:
                            // then
                            $async$self._async_evaluate$_checkWhitespaceAroundCalculationOperator$1(node);
                            $async$goto = 12;
                            return A._asyncAwait($async$self._addExceptionSpanAsync$1$2(node, new A._EvaluateVisitor__visitCalculationExpression_closure0(_box_0, $async$self, node, inLegacySassFunction), type$.Object), $async$_async_evaluate$_visitCalculationExpression$2$inLegacySassFunction);
                        case 12:
                            // returning from await.
                            $async$returnValue = $async$result;
                            // goto return
                            $async$goto = 1;
                            break;
                        case 11:
                            // join
                            $async$goto = node instanceof A.NumberExpression || node instanceof A.VariableExpression || node instanceof A.FunctionExpression || node instanceof A.LegacyIfExpression ? 13 : 14;
                            break;
                        case 13:
                            // then
                            $async$goto = 15;
                            return A._asyncAwait(node.accept$1($async$self), $async$_async_evaluate$_visitCalculationExpression$2$inLegacySassFunction);
                        case 15:
                            // returning from await.
                            _1_0 = $async$result;
                            $label1$1: {
                                if (_1_0 instanceof A.SassNumber) {
                                    t1 = _1_0;
                                    break $label1$1;
                                }
                                if (_1_0 instanceof A.SassCalculation) {
                                    t1 = _1_0;
                                    break $label1$1;
                                }
                                if (_1_0 instanceof A.SassString) {
                                    t1 = !_1_0._hasQuotes;
                                    result = _1_0;
                                } else {
                                    result = null;
                                    t1 = false;
                                }
                                if (t1) {
                                    t1 = result;
                                    break $label1$1;
                                }
                                t1 = A.throwExpression($async$self._async_evaluate$_exception$2("Value " + _1_0.toString$0(0) + " can't be used in a calculation.", node.get$span(node)));
                            }
                            $async$returnValue = t1;
                            // goto return
                            $async$goto = 1;
                            break;
                        case 14:
                            // join
                            $async$goto = node instanceof A.ListExpression && !node.hasBrackets && B.ListSeparator_SrV === node.separator && node.contents.length >= 2 ? 16 : 17;
                            break;
                        case 16:
                            // then
                            t1 = A._setArrayType([], type$.JSArray_Object);
                            t2 = node.contents, t3 = t2.length, _i = 0;
                        case 18:
                            // for condition
                            if (!(_i < t3)) {
                                // goto after for
                                $async$goto = 20;
                                break;
                            }
                            $async$temp1 = t1;
                            $async$goto = 21;
                            return A._asyncAwait($async$self._async_evaluate$_visitCalculationExpression$2$inLegacySassFunction(t2[_i], inLegacySassFunction), $async$_async_evaluate$_visitCalculationExpression$2$inLegacySassFunction);
                        case 21:
                            // returning from await.
                            $async$temp1.push($async$result);
                        case 19:
                            // for update
                            ++_i;
                            // goto for condition
                            $async$goto = 18;
                            break;
                        case 20:
                            // after for
                            $async$self._async_evaluate$_checkAdjacentCalculationValues$2(t1, node);
                            for(i = 0; i < t1.length; ++i){
                                t3 = t1[i];
                                if (t3 instanceof A.CalculationOperation && t2[i] instanceof A.ParenthesizedExpression) t1[i] = new A.SassString("(" + t3.toString$0(0) + ")", false);
                            }
                            $async$returnValue = new A.SassString(B.JSArray_methods.join$1(t1, " "), false);
                            // goto return
                            $async$goto = 1;
                            break;
                        case 17:
                            // join
                            throw A.wrapException($async$self._async_evaluate$_exception$2(string$.This_e, node.get$span(node)));
                        case 1:
                            // return
                            return A._asyncReturn($async$returnValue, $async$completer);
                    }
                });
                return A._asyncStartSync($async$_async_evaluate$_visitCalculationExpression$2$inLegacySassFunction, $async$completer);
            },
            _async_evaluate$_checkWhitespaceAroundCalculationOperator$1: function(node) {
                var t2, t3, t4, textBetweenOperands, first, last, t1 = node.operator;
                if (t1 !== B.BinaryOperator_jCK && t1 !== B.BinaryOperator_tDf) return;
                t1 = node.left;
                t2 = t1.get$span(t1);
                t2 = t2.get$file(t2);
                t3 = node.right;
                t4 = t3.get$span(t3);
                if (t2 !== t4.get$file(t4)) return;
                t2 = t1.get$span(t1);
                t2 = t2.get$end(t2);
                t4 = t3.get$span(t3);
                if (t2.offset >= t4.get$start(t4).offset) return;
                t2 = t1.get$span(t1);
                t2 = t2.get$file(t2);
                t1 = t1.get$span(t1);
                t1 = t1.get$end(t1);
                t3 = t3.get$span(t3);
                textBetweenOperands = A.String_String$fromCharCodes(B.NativeUint32List_methods.sublist$2(t2._decodedChars, t1.offset, t3.get$start(t3).offset), 0, null);
                first = textBetweenOperands.charCodeAt(0);
                last = textBetweenOperands.charCodeAt(textBetweenOperands.length - 1);
                if (first === 32 || first === 9 || first === 10 || first === 13 || first === 12 || first === 47) t1 = !(last === 32 || last === 9 || last === 10 || last === 13 || last === 12 || last === 47);
                else t1 = true;
                if (t1) throw A.wrapException(this._async_evaluate$_exception$2(string$.x22x2b__an, node.get$operatorSpan()));
            },
            _async_evaluate$_binaryOperatorToCalculationOperator$2: function(operator, node) {
                var t1;
                $label0$0: {
                    if (B.BinaryOperator_jCK === operator) {
                        t1 = B.CalculationOperator_dpX;
                        break $label0$0;
                    }
                    if (B.BinaryOperator_tDf === operator) {
                        t1 = B.CalculationOperator_KrC;
                        break $label0$0;
                    }
                    if (B.BinaryOperator_wkM === operator) {
                        t1 = B.CalculationOperator_LPB;
                        break $label0$0;
                    }
                    if (B.BinaryOperator_ehp === operator) {
                        t1 = B.CalculationOperator_wFL;
                        break $label0$0;
                    }
                    t1 = A.throwExpression(this._async_evaluate$_exception$2(string$.This_o, node.get$operatorSpan()));
                }
                return t1;
            },
            _async_evaluate$_checkAdjacentCalculationValues$2: function(elements, node) {
                var t1, i, t2, previous, current, previousNode, currentNode, _0_2;
                for(t1 = elements.length, i = 1; i < t1; ++i){
                    t2 = i - 1;
                    previous = elements[t2];
                    current = elements[i];
                    if (previous instanceof A.SassString || current instanceof A.SassString) continue;
                    t1 = node.contents;
                    previousNode = t1[t2];
                    currentNode = t1[i];
                    if (currentNode instanceof A.UnaryOperationExpression) {
                        _0_2 = currentNode.operator;
                        if (B.UnaryOperator_hCO !== _0_2) t1 = B.UnaryOperator_n2K === _0_2;
                        else t1 = true;
                    } else t1 = false;
                    if (!t1) t1 = currentNode instanceof A.NumberExpression && currentNode.value < 0;
                    else t1 = true;
                    if (t1) throw A.wrapException(this._async_evaluate$_exception$2(string$.x22x2b__an, A.FileSpanExtension_subspan(currentNode.get$span(currentNode), 0, 1)));
                    else throw A.wrapException(this._async_evaluate$_exception$2("Missing math operator.", previousNode.get$span(previousNode).expand$1(0, currentNode.get$span(currentNode))));
                }
            },
            visitInterpolatedFunctionExpression$1: function(_, node) {
                return this.visitInterpolatedFunctionExpression$body$_EvaluateVisitor(0, node);
            },
            visitInterpolatedFunctionExpression$body$_EvaluateVisitor: function(_, node) {
                var $async$goto = 0, $async$completer = A._makeAsyncAwaitCompleter(type$.Value), $async$returnValue, $async$self = this, result, t1, oldInFunction;
                var $async$visitInterpolatedFunctionExpression$1 = A._wrapJsFunctionForAsync(function($async$errorCode, $async$result) {
                    if ($async$errorCode === 1) return A._asyncRethrow($async$result, $async$completer);
                    for(;;)switch($async$goto){
                        case 0:
                            // Function start
                            $async$goto = 3;
                            return A._asyncAwait($async$self._async_evaluate$_performInterpolation$1(node.name), $async$visitInterpolatedFunctionExpression$1);
                        case 3:
                            // returning from await.
                            t1 = $async$result;
                            oldInFunction = $async$self._async_evaluate$_inFunction;
                            $async$self._async_evaluate$_inFunction = true;
                            $async$goto = 4;
                            return A._asyncAwait($async$self._async_evaluate$_addErrorSpan$1$2(node, new A._EvaluateVisitor_visitInterpolatedFunctionExpression_closure0($async$self, node, new A.PlainCssCallable(t1)), type$.Value), $async$visitInterpolatedFunctionExpression$1);
                        case 4:
                            // returning from await.
                            result = $async$result;
                            $async$self._async_evaluate$_inFunction = oldInFunction;
                            $async$returnValue = result;
                            // goto return
                            $async$goto = 1;
                            break;
                        case 1:
                            // return
                            return A._asyncReturn($async$returnValue, $async$completer);
                    }
                });
                return A._asyncStartSync($async$visitInterpolatedFunctionExpression$1, $async$completer);
            },
            _async_evaluate$_runUserDefinedCallable$1$4: function($arguments, callable, nodeWithSpan, run, $V) {
                return this._runUserDefinedCallable$body$_EvaluateVisitor($arguments, callable, nodeWithSpan, run, $V, $V);
            },
            _runUserDefinedCallable$body$_EvaluateVisitor: function($arguments, callable, nodeWithSpan, run, $V, $async$type) {
                var $async$goto = 0, $async$completer = A._makeAsyncAwaitCompleter($async$type), $async$returnValue, $async$self = this, oldInDependency, result, evaluated, $name;
                var $async$_async_evaluate$_runUserDefinedCallable$1$4 = A._wrapJsFunctionForAsync(function($async$errorCode, $async$result) {
                    if ($async$errorCode === 1) return A._asyncRethrow($async$result, $async$completer);
                    for(;;)switch($async$goto){
                        case 0:
                            // Function start
                            $async$goto = 3;
                            return A._asyncAwait($async$self._async_evaluate$_evaluateArguments$1($arguments), $async$_async_evaluate$_runUserDefinedCallable$1$4);
                        case 3:
                            // returning from await.
                            evaluated = $async$result;
                            $name = callable.declaration.name;
                            if ($name !== "@content") $name += "()";
                            oldInDependency = $async$self._async_evaluate$_inDependency;
                            $async$self._async_evaluate$_inDependency = callable.inDependency;
                            $async$goto = 4;
                            return A._asyncAwait($async$self._async_evaluate$_withStackFrame$1$3($name, nodeWithSpan, new A._EvaluateVisitor__runUserDefinedCallable_closure0($async$self, callable, evaluated, nodeWithSpan, run, $V), $V), $async$_async_evaluate$_runUserDefinedCallable$1$4);
                        case 4:
                            // returning from await.
                            result = $async$result;
                            $async$self._async_evaluate$_inDependency = oldInDependency;
                            $async$returnValue = result;
                            // goto return
                            $async$goto = 1;
                            break;
                        case 1:
                            // return
                            return A._asyncReturn($async$returnValue, $async$completer);
                    }
                });
                return A._asyncStartSync($async$_async_evaluate$_runUserDefinedCallable$1$4, $async$completer);
            },
            _async_evaluate$_runFunctionCallable$3: function($arguments, callable, nodeWithSpan) {
                return this._runFunctionCallable$body$_EvaluateVisitor($arguments, callable, nodeWithSpan);
            },
            _runFunctionCallable$body$_EvaluateVisitor: function($arguments, callable, nodeWithSpan) {
                var $async$goto = 0, $async$completer = A._makeAsyncAwaitCompleter(type$.Value), $async$returnValue, $async$handler = 2, $async$errorStack = [], $async$self = this, buffer, first, argument, restArg, rest, error, t1, t2, _i, t3, t4, exception, $async$exception, $async$temp1;
                var $async$_async_evaluate$_runFunctionCallable$3 = A._wrapJsFunctionForAsync(function($async$errorCode, $async$result) {
                    if ($async$errorCode === 1) {
                        $async$errorStack.push($async$result);
                        $async$goto = $async$handler;
                    }
                    for(;;)switch($async$goto){
                        case 0:
                            // Function start
                            $async$goto = type$.AsyncBuiltInCallable._is(callable) ? 3 : 5;
                            break;
                        case 3:
                            // then
                            $async$goto = 6;
                            return A._asyncAwait($async$self._async_evaluate$_runBuiltInCallable$3($arguments, callable, nodeWithSpan), $async$_async_evaluate$_runFunctionCallable$3);
                        case 6:
                            // returning from await.
                            $async$returnValue = $async$self._async_evaluate$_withoutSlash$2($async$result, nodeWithSpan);
                            // goto return
                            $async$goto = 1;
                            break;
                        case 5:
                            // else
                            $async$goto = type$.UserDefinedCallable_AsyncEnvironment._is(callable) ? 7 : 9;
                            break;
                        case 7:
                            // then
                            $async$goto = 10;
                            return A._asyncAwait($async$self._async_evaluate$_runUserDefinedCallable$1$4($arguments, callable, nodeWithSpan, new A._EvaluateVisitor__runFunctionCallable_closure0($async$self, callable), type$.Value), $async$_async_evaluate$_runFunctionCallable$3);
                        case 10:
                            // returning from await.
                            $async$returnValue = $async$result;
                            // goto return
                            $async$goto = 1;
                            break;
                        case 9:
                            // else
                            $async$goto = callable instanceof A.PlainCssCallable ? 11 : 13;
                            break;
                        case 11:
                            // then
                            t1 = $arguments.named;
                            if (t1.get$isNotEmpty(t1) || $arguments.keywordRest != null) throw A.wrapException($async$self._async_evaluate$_exception$2(string$.Plain_, nodeWithSpan.get$span(nodeWithSpan)));
                            buffer = new A.StringBuffer(callable.name + "(");
                            $async$handler = 15;
                            first = true;
                            t1 = $arguments.positional, t2 = t1.length, _i = 0;
                        case 18:
                            // for condition
                            if (!(_i < t2)) {
                                // goto after for
                                $async$goto = 20;
                                break;
                            }
                            argument = t1[_i];
                            if (first) first = false;
                            else buffer._contents += ", ";
                            t3 = buffer;
                            $async$temp1 = A;
                            $async$goto = 21;
                            return A._asyncAwait($async$self._evaluateToCss$1(argument), $async$_async_evaluate$_runFunctionCallable$3);
                        case 21:
                            // returning from await.
                            t4 = $async$temp1.S($async$result);
                            t3._contents += t4;
                        case 19:
                            // for update
                            ++_i;
                            // goto for condition
                            $async$goto = 18;
                            break;
                        case 20:
                            // after for
                            restArg = $arguments.rest;
                            $async$goto = restArg != null ? 22 : 23;
                            break;
                        case 22:
                            // then
                            $async$goto = 24;
                            return A._asyncAwait(restArg.accept$1($async$self), $async$_async_evaluate$_runFunctionCallable$3);
                        case 24:
                            // returning from await.
                            rest = $async$result;
                            if (!first) buffer._contents += ", ";
                            t1 = buffer;
                            t2 = $async$self._async_evaluate$_serialize$2(rest, restArg);
                            t1._contents += t2;
                        case 23:
                            // join
                            $async$handler = 2;
                            // goto after finally
                            $async$goto = 17;
                            break;
                        case 15:
                            // catch
                            $async$handler = 14;
                            $async$exception = $async$errorStack.pop();
                            t1 = A.unwrapException($async$exception);
                            if (type$.SassRuntimeException._is(t1)) {
                                error = t1;
                                if (!B.JSString_methods.endsWith$1(error._span_exception$_message, "isn't a valid CSS value.")) throw $async$exception;
                                throw A.wrapException(A.MultiSpanSassRuntimeException$(error._span_exception$_message, J.get$span$x(error), "value", A.LinkedHashMap_LinkedHashMap$_literal([
                                    nodeWithSpan.get$span(nodeWithSpan),
                                    "unknown function treated as plain CSS"
                                ], type$.FileSpan, type$.String), J.get$trace$z(error), null));
                            } else throw $async$exception;
                            // goto after finally
                            $async$goto = 17;
                            break;
                        case 14:
                            // uncaught
                            // goto rethrow
                            $async$goto = 2;
                            break;
                        case 17:
                            // after finally
                            t1 = buffer;
                            t2 = A.Primitives_stringFromCharCode(41);
                            t1._contents += t2;
                            t2 = buffer._contents;
                            $async$returnValue = new A.SassString(t2.charCodeAt(0) == 0 ? t2 : t2, false);
                            // goto return
                            $async$goto = 1;
                            break;
                        case 13:
                            // else
                            throw A.wrapException(A.ArgumentError$("Unknown callable type " + J.get$runtimeType$(callable).toString$0(0) + ".", null));
                        case 12:
                        // join
                        case 8:
                        // join
                        case 4:
                        // join
                        case 1:
                            // return
                            return A._asyncReturn($async$returnValue, $async$completer);
                        case 2:
                            // rethrow
                            return A._asyncRethrow($async$errorStack.at(-1), $async$completer);
                    }
                });
                return A._asyncStartSync($async$_async_evaluate$_runFunctionCallable$3, $async$completer);
            },
            _async_evaluate$_runBuiltInCallable$3: function($arguments, callable, nodeWithSpan) {
                return this._runBuiltInCallable$body$_EvaluateVisitor($arguments, callable, nodeWithSpan);
            },
            _runBuiltInCallable$body$_EvaluateVisitor: function($arguments, callable, nodeWithSpan) {
                var $async$goto = 0, $async$completer = A._makeAsyncAwaitCompleter(type$.Value), $async$returnValue, $async$handler = 2, $async$errorStack = [], $async$self = this, result, error, stackTrace, namedSet, _0_0, parameters, i, t1, t2, t3, parameter, t4, t5, t6, t7, rest, argumentList, exception, _box_0, evaluated, oldCallableNode, $async$exception;
                var $async$_async_evaluate$_runBuiltInCallable$3 = A._wrapJsFunctionForAsync(function($async$errorCode, $async$result) {
                    if ($async$errorCode === 1) {
                        $async$errorStack.push($async$result);
                        $async$goto = $async$handler;
                    }
                    for(;;)switch($async$goto){
                        case 0:
                            // Function start
                            _box_0 = {};
                            $async$goto = 3;
                            return A._asyncAwait($async$self._async_evaluate$_evaluateArguments$1($arguments), $async$_async_evaluate$_runBuiltInCallable$3);
                        case 3:
                            // returning from await.
                            evaluated = $async$result;
                            oldCallableNode = $async$self._async_evaluate$_callableNode;
                            $async$self._async_evaluate$_callableNode = nodeWithSpan;
                            namedSet = new A.MapKeySet(evaluated._values[0], type$.MapKeySet_String);
                            _box_0.callback = _box_0.overload = null;
                            _0_0 = callable.callbackFor$2(J.get$length$asx(evaluated._values[2]), namedSet);
                            _box_0.overload = _0_0._0;
                            _box_0.callback = _0_0._1;
                            $async$self._async_evaluate$_addExceptionSpan$2(nodeWithSpan, new A._EvaluateVisitor__runBuiltInCallable_closure2(_box_0, evaluated, namedSet));
                            parameters = _box_0.overload.parameters;
                            i = J.get$length$asx(evaluated._values[2]), t1 = parameters.length, t2 = type$._Future_Value, t3 = type$.Future_Value;
                        case 4:
                            // for condition
                            if (!(i < t1)) {
                                // goto after for
                                $async$goto = 6;
                                break;
                            }
                            parameter = parameters[i];
                            t4 = evaluated._values[2];
                            t5 = evaluated._values[0].remove$1(0, parameter.name);
                            $async$goto = t5 == null ? 7 : 8;
                            break;
                        case 7:
                            // then
                            t5 = parameter.defaultValue;
                            t6 = t5.accept$1($async$self);
                            if (!t3._is(t6)) {
                                t7 = new A._Future($.Zone__current, t2);
                                t7._state = 8;
                                t7._resultOrListeners = t6;
                                t6 = t7;
                            }
                            $async$goto = 9;
                            return A._asyncAwait(t6, $async$_async_evaluate$_runBuiltInCallable$3);
                        case 9:
                            // returning from await.
                            t5 = $async$self._async_evaluate$_withoutSlash$2($async$result, t5);
                        case 8:
                            // join
                            J.add$1$ax(t4, t5);
                        case 5:
                            // for update
                            ++i;
                            // goto for condition
                            $async$goto = 4;
                            break;
                        case 6:
                            // after for
                            if (_box_0.overload.restParameter != null) {
                                if (J.get$length$asx(evaluated._values[2]) > t1) {
                                    rest = J.sublist$1$ax(evaluated._values[2], t1);
                                    J.removeRange$2$ax(evaluated._values[2], t1, J.get$length$asx(evaluated._values[2]));
                                } else rest = B.List_empty8;
                                t1 = evaluated._values[0];
                                argumentList = A.SassArgumentList$(rest, t1, evaluated._values[4] === B.ListSeparator_undecided_null_3_undecided ? B.ListSeparator_z0K : evaluated._values[4]);
                                J.add$1$ax(evaluated._values[2], argumentList);
                            } else argumentList = null;
                            result = null;
                            $async$handler = 11;
                            $async$goto = 14;
                            return A._asyncAwait($async$self._addExceptionSpanAsync$1$2(nodeWithSpan, new A._EvaluateVisitor__runBuiltInCallable_closure3(_box_0, evaluated), type$.Value), $async$_async_evaluate$_runBuiltInCallable$3);
                        case 14:
                            // returning from await.
                            result = $async$result;
                            $async$handler = 2;
                            // goto after finally
                            $async$goto = 13;
                            break;
                        case 11:
                            // catch
                            $async$handler = 10;
                            $async$exception = $async$errorStack.pop();
                            t1 = A.unwrapException($async$exception);
                            if (t1 instanceof A.SassException) throw $async$exception;
                            else {
                                error = t1;
                                stackTrace = A.getTraceFromException($async$exception);
                                A.throwWithTrace($async$self._async_evaluate$_exception$2($async$self._async_evaluate$_getErrorMessage$1(error), nodeWithSpan.get$span(nodeWithSpan)), error, stackTrace);
                            }
                            // goto after finally
                            $async$goto = 13;
                            break;
                        case 10:
                            // uncaught
                            // goto rethrow
                            $async$goto = 2;
                            break;
                        case 13:
                            // after finally
                            $async$self._async_evaluate$_callableNode = oldCallableNode;
                            if (argumentList == null) {
                                $async$returnValue = result;
                                // goto return
                                $async$goto = 1;
                                break;
                            }
                            t1 = evaluated._values[0];
                            if (t1.get$isEmpty(t1)) {
                                $async$returnValue = result;
                                // goto return
                                $async$goto = 1;
                                break;
                            }
                            if (argumentList._wereKeywordsAccessed) {
                                $async$returnValue = result;
                                // goto return
                                $async$goto = 1;
                                break;
                            }
                            t1 = evaluated._values[0];
                            t1 = t1.get$keys(t1);
                            t1 = A.pluralize("parameter", t1.get$length(t1), null);
                            t2 = evaluated._values[0];
                            t2 = t2.get$keys(t2);
                            throw A.wrapException(A.MultiSpanSassRuntimeException$("No " + t1 + " named " + A.toSentence(t2.map$1$1(t2, new A._EvaluateVisitor__runBuiltInCallable_closure4(), type$.Object), "or") + ".", nodeWithSpan.get$span(nodeWithSpan), "invocation", A.LinkedHashMap_LinkedHashMap$_literal([
                                _box_0.overload.get$spanWithName(),
                                "declaration"
                            ], type$.FileSpan, type$.String), $async$self._async_evaluate$_stackTrace$1(nodeWithSpan.get$span(nodeWithSpan)), null));
                        case 1:
                            // return
                            return A._asyncReturn($async$returnValue, $async$completer);
                        case 2:
                            // rethrow
                            return A._asyncRethrow($async$errorStack.at(-1), $async$completer);
                    }
                });
                return A._asyncStartSync($async$_async_evaluate$_runBuiltInCallable$3, $async$completer);
            },
            _async_evaluate$_evaluateArguments$1: function($arguments) {
                return this._evaluateArguments$body$_EvaluateVisitor($arguments);
            },
            _evaluateArguments$body$_EvaluateVisitor: function($arguments) {
                var $async$goto = 0, $async$completer = A._makeAsyncAwaitCompleter(type$.Record_5_Map_String_Value_named_and_Map_String_AstNode_namedNodes_and_List_Value_positional_and_List_AstNode_positionalNodes_and_ListSeparator_separator), $async$returnValue, $async$self = this, t1, t2, t3, t4, _i, expression, nodeForSpan, t5, t6, named, namedNodes, $name, value, t7, restArgs, rest, restNodeForSpan, separator, keywordRestArgs, keywordRest, keywordRestNodeForSpan, positional, positionalNodes, $async$temp1, $async$temp2;
                var $async$_async_evaluate$_evaluateArguments$1 = A._wrapJsFunctionForAsync(function($async$errorCode, $async$result) {
                    if ($async$errorCode === 1) return A._asyncRethrow($async$result, $async$completer);
                    for(;;)switch($async$goto){
                        case 0:
                            // Function start
                            positional = A._setArrayType([], type$.JSArray_Value);
                            positionalNodes = A._setArrayType([], type$.JSArray_AstNode);
                            t1 = $arguments.positional, t2 = t1.length, t3 = type$._Future_Value, t4 = type$.Future_Value, _i = 0;
                        case 3:
                            // for condition
                            if (!(_i < t2)) {
                                // goto after for
                                $async$goto = 5;
                                break;
                            }
                            expression = t1[_i];
                            nodeForSpan = $async$self._async_evaluate$_expressionNode$1(expression);
                            t5 = expression.accept$1($async$self);
                            if (!t4._is(t5)) {
                                t6 = new A._Future($.Zone__current, t3);
                                t6._state = 8;
                                t6._resultOrListeners = t5;
                                t5 = t6;
                            }
                            $async$temp1 = positional;
                            $async$goto = 6;
                            return A._asyncAwait(t5, $async$_async_evaluate$_evaluateArguments$1);
                        case 6:
                            // returning from await.
                            $async$temp1.push($async$self._async_evaluate$_withoutSlash$2($async$result, nodeForSpan));
                            positionalNodes.push(nodeForSpan);
                        case 4:
                            // for update
                            ++_i;
                            // goto for condition
                            $async$goto = 3;
                            break;
                        case 5:
                            // after for
                            t1 = type$.String;
                            named = A.LinkedHashMap_LinkedHashMap$_empty(t1, type$.Value);
                            t2 = type$.AstNode;
                            namedNodes = A.LinkedHashMap_LinkedHashMap$_empty(t1, t2);
                            t5 = A.MapExtensions_get_pairs($arguments.named, t1, type$.Expression), t5 = t5.get$iterator(t5);
                        case 7:
                            // for condition
                            if (!t5.moveNext$0()) {
                                // goto after for
                                $async$goto = 8;
                                break;
                            }
                            t6 = t5.get$current(t5);
                            $name = t6._0;
                            value = t6._1;
                            nodeForSpan = $async$self._async_evaluate$_expressionNode$1(value);
                            t6 = value.accept$1($async$self);
                            if (!t4._is(t6)) {
                                t7 = new A._Future($.Zone__current, t3);
                                t7._state = 8;
                                t7._resultOrListeners = t6;
                                t6 = t7;
                            }
                            $async$temp1 = named;
                            $async$temp2 = $name;
                            $async$goto = 9;
                            return A._asyncAwait(t6, $async$_async_evaluate$_evaluateArguments$1);
                        case 9:
                            // returning from await.
                            $async$temp1.$indexSet(0, $async$temp2, $async$self._async_evaluate$_withoutSlash$2($async$result, nodeForSpan));
                            namedNodes.$indexSet(0, $name, nodeForSpan);
                            // goto for condition
                            $async$goto = 7;
                            break;
                        case 8:
                            // after for
                            restArgs = $arguments.rest;
                            if (restArgs == null) {
                                $async$returnValue = new A._Record_5_named_namedNodes_positional_positionalNodes_separator([
                                    named,
                                    namedNodes,
                                    positional,
                                    positionalNodes,
                                    B.ListSeparator_undecided_null_3_undecided
                                ]);
                                // goto return
                                $async$goto = 1;
                                break;
                            }
                            $async$goto = 10;
                            return A._asyncAwait(restArgs.accept$1($async$self), $async$_async_evaluate$_evaluateArguments$1);
                        case 10:
                            // returning from await.
                            rest = $async$result;
                            restNodeForSpan = $async$self._async_evaluate$_expressionNode$1(restArgs);
                            if (rest instanceof A.SassMap) {
                                $async$self._async_evaluate$_addRestMap$4(named, rest, restArgs, new A._EvaluateVisitor__evaluateArguments_closure3());
                                t3 = A.LinkedHashMap_LinkedHashMap$_empty(t1, t2);
                                for(t4 = rest._map$_contents, t4 = t4.get$keys(t4), t4 = t4.get$iterator(t4), t5 = type$.SassString; t4.moveNext$0();)t3.$indexSet(0, t5._as(t4.get$current(t4))._string$_text, restNodeForSpan);
                                namedNodes.addAll$1(0, t3);
                                separator = B.ListSeparator_undecided_null_3_undecided;
                            } else if (rest instanceof A.SassList) {
                                t3 = rest._list$_contents;
                                B.JSArray_methods.addAll$1(positional, new A.MappedListIterable(t3, new A._EvaluateVisitor__evaluateArguments_closure4($async$self, restNodeForSpan), A._arrayInstanceType(t3)._eval$1("MappedListIterable<1,Value>")));
                                B.JSArray_methods.addAll$1(positionalNodes, A.List_List$filled(t3.length, restNodeForSpan, false, t2));
                                separator = rest._separator;
                                if (rest instanceof A.SassArgumentList) {
                                    rest._wereKeywordsAccessed = true;
                                    rest._keywords.forEach$1(0, new A._EvaluateVisitor__evaluateArguments_closure5($async$self, named, restNodeForSpan, namedNodes));
                                }
                            } else {
                                positional.push($async$self._async_evaluate$_withoutSlash$2(rest, restNodeForSpan));
                                positionalNodes.push(restNodeForSpan);
                                separator = B.ListSeparator_undecided_null_3_undecided;
                            }
                            keywordRestArgs = $arguments.keywordRest;
                            if (keywordRestArgs == null) {
                                $async$returnValue = new A._Record_5_named_namedNodes_positional_positionalNodes_separator([
                                    named,
                                    namedNodes,
                                    positional,
                                    positionalNodes,
                                    separator
                                ]);
                                // goto return
                                $async$goto = 1;
                                break;
                            }
                            $async$goto = 11;
                            return A._asyncAwait(keywordRestArgs.accept$1($async$self), $async$_async_evaluate$_evaluateArguments$1);
                        case 11:
                            // returning from await.
                            keywordRest = $async$result;
                            keywordRestNodeForSpan = $async$self._async_evaluate$_expressionNode$1(keywordRestArgs);
                            if (keywordRest instanceof A.SassMap) {
                                $async$self._async_evaluate$_addRestMap$4(named, keywordRest, keywordRestArgs, new A._EvaluateVisitor__evaluateArguments_closure6());
                                t1 = A.LinkedHashMap_LinkedHashMap$_empty(t1, t2);
                                for(t2 = keywordRest._map$_contents, t2 = t2.get$keys(t2), t2 = t2.get$iterator(t2), t3 = type$.SassString; t2.moveNext$0();)t1.$indexSet(0, t3._as(t2.get$current(t2))._string$_text, keywordRestNodeForSpan);
                                namedNodes.addAll$1(0, t1);
                                $async$returnValue = new A._Record_5_named_namedNodes_positional_positionalNodes_separator([
                                    named,
                                    namedNodes,
                                    positional,
                                    positionalNodes,
                                    separator
                                ]);
                                // goto return
                                $async$goto = 1;
                                break;
                            } else throw A.wrapException($async$self._async_evaluate$_exception$2(string$.Variabs + keywordRest.toString$0(0) + ").", keywordRestArgs.get$span(keywordRestArgs)));
                        case 1:
                            // return
                            return A._asyncReturn($async$returnValue, $async$completer);
                    }
                });
                return A._asyncStartSync($async$_async_evaluate$_evaluateArguments$1, $async$completer);
            },
            _async_evaluate$_evaluateMacroArguments$1: function(invocation) {
                return this._evaluateMacroArguments$body$_EvaluateVisitor(invocation);
            },
            _evaluateMacroArguments$body$_EvaluateVisitor: function(invocation) {
                var $async$goto = 0, $async$completer = A._makeAsyncAwaitCompleter(type$.Record_2_List_Expression_and_Map_String_Expression), $async$returnValue, $async$self = this, t2, positional, named, rest, restNodeForSpan, keywordRestArgs_, keywordRest, keywordRestNodeForSpan, t1, restArgs_;
                var $async$_async_evaluate$_evaluateMacroArguments$1 = A._wrapJsFunctionForAsync(function($async$errorCode, $async$result) {
                    if ($async$errorCode === 1) return A._asyncRethrow($async$result, $async$completer);
                    for(;;)switch($async$goto){
                        case 0:
                            // Function start
                            t1 = invocation.$arguments;
                            restArgs_ = t1.rest;
                            if (restArgs_ == null) {
                                $async$returnValue = new A._Record_2(t1.positional, t1.named);
                                // goto return
                                $async$goto = 1;
                                break;
                            }
                            t2 = t1.positional;
                            positional = A._setArrayType(t2.slice(0), A._arrayInstanceType(t2));
                            named = A.LinkedHashMap_LinkedHashMap$of(t1.named, type$.String, type$.Expression);
                            $async$goto = 3;
                            return A._asyncAwait(restArgs_.accept$1($async$self), $async$_async_evaluate$_evaluateMacroArguments$1);
                        case 3:
                            // returning from await.
                            rest = $async$result;
                            restNodeForSpan = $async$self._async_evaluate$_expressionNode$1(restArgs_);
                            if (rest instanceof A.SassMap) $async$self._async_evaluate$_addRestMap$4(named, rest, invocation, new A._EvaluateVisitor__evaluateMacroArguments_closure3(restArgs_));
                            else if (rest instanceof A.SassList) {
                                t2 = rest._list$_contents;
                                B.JSArray_methods.addAll$1(positional, new A.MappedListIterable(t2, new A._EvaluateVisitor__evaluateMacroArguments_closure4($async$self, restNodeForSpan, restArgs_), A._arrayInstanceType(t2)._eval$1("MappedListIterable<1,Expression>")));
                                if (rest instanceof A.SassArgumentList) {
                                    rest._wereKeywordsAccessed = true;
                                    rest._keywords.forEach$1(0, new A._EvaluateVisitor__evaluateMacroArguments_closure5($async$self, named, restNodeForSpan, restArgs_));
                                }
                            } else positional.push(new A.ValueExpression($async$self._async_evaluate$_withoutSlash$2(rest, restNodeForSpan), restArgs_.get$span(restArgs_)));
                            keywordRestArgs_ = t1.keywordRest;
                            if (keywordRestArgs_ == null) {
                                $async$returnValue = new A._Record_2(positional, named);
                                // goto return
                                $async$goto = 1;
                                break;
                            }
                            $async$goto = 4;
                            return A._asyncAwait(keywordRestArgs_.accept$1($async$self), $async$_async_evaluate$_evaluateMacroArguments$1);
                        case 4:
                            // returning from await.
                            keywordRest = $async$result;
                            keywordRestNodeForSpan = $async$self._async_evaluate$_expressionNode$1(keywordRestArgs_);
                            if (keywordRest instanceof A.SassMap) {
                                $async$self._async_evaluate$_addRestMap$4(named, keywordRest, invocation, new A._EvaluateVisitor__evaluateMacroArguments_closure6($async$self, keywordRestNodeForSpan, keywordRestArgs_));
                                $async$returnValue = new A._Record_2(positional, named);
                                // goto return
                                $async$goto = 1;
                                break;
                            } else throw A.wrapException($async$self._async_evaluate$_exception$2(string$.Variabs + keywordRest.toString$0(0) + ").", keywordRestArgs_.get$span(keywordRestArgs_)));
                        case 1:
                            // return
                            return A._asyncReturn($async$returnValue, $async$completer);
                    }
                });
                return A._asyncStartSync($async$_async_evaluate$_evaluateMacroArguments$1, $async$completer);
            },
            _async_evaluate$_addRestMap$1$4: function(values, map, nodeWithSpan, convert) {
                map._map$_contents.forEach$1(0, new A._EvaluateVisitor__addRestMap_closure0(this, values, convert, this._async_evaluate$_expressionNode$1(nodeWithSpan), map, nodeWithSpan));
            },
            _async_evaluate$_addRestMap$4: function(values, map, nodeWithSpan, convert) {
                return this._async_evaluate$_addRestMap$1$4(values, map, nodeWithSpan, convert, type$.dynamic);
            },
            _async_evaluate$_verifyArguments$4: function(positional, named, parameters, nodeWithSpan) {
                return this._async_evaluate$_addExceptionSpan$2(nodeWithSpan, new A._EvaluateVisitor__verifyArguments_closure0(parameters, positional, named));
            },
            visitSelectorExpression$1: function(_, node) {
                return this.visitSelectorExpression$body$_EvaluateVisitor(0, node);
            },
            visitSelectorExpression$body$_EvaluateVisitor: function(_, node) {
                var $async$goto = 0, $async$completer = A._makeAsyncAwaitCompleter(type$.Value), $async$returnValue, $async$self = this, t1;
                var $async$visitSelectorExpression$1 = A._wrapJsFunctionForAsync(function($async$errorCode, $async$result) {
                    if ($async$errorCode === 1) return A._asyncRethrow($async$result, $async$completer);
                    for(;;)switch($async$goto){
                        case 0:
                            // Function start
                            t1 = $async$self._async_evaluate$_styleRuleIgnoringAtRoot;
                            t1 = t1 == null ? null : t1.originalSelector.get$asSassList();
                            $async$returnValue = t1 == null ? B.C__SassNull : t1;
                            // goto return
                            $async$goto = 1;
                            break;
                        case 1:
                            // return
                            return A._asyncReturn($async$returnValue, $async$completer);
                    }
                });
                return A._asyncStartSync($async$visitSelectorExpression$1, $async$completer);
            },
            visitStringExpression$1: function(_, node) {
                return this.visitStringExpression$body$_EvaluateVisitor(0, node);
            },
            visitStringExpression$body$_EvaluateVisitor: function(_, node) {
                var $async$goto = 0, $async$completer = A._makeAsyncAwaitCompleter(type$.SassString), $async$returnValue, $async$self = this, t1, t2, t3, _i, value, t4, _0_0, text, oldInSupportsDeclaration;
                var $async$visitStringExpression$1 = A._wrapJsFunctionForAsync(function($async$errorCode, $async$result) {
                    if ($async$errorCode === 1) return A._asyncRethrow($async$result, $async$completer);
                    for(;;)switch($async$goto){
                        case 0:
                            // Function start
                            oldInSupportsDeclaration = $async$self._async_evaluate$_inSupportsDeclaration;
                            $async$self._async_evaluate$_inSupportsDeclaration = false;
                            t1 = A._setArrayType([], type$.JSArray_String);
                            t2 = node.text.contents, t3 = t2.length, _i = 0;
                        case 3:
                            // for condition
                            if (!(_i < t3)) {
                                // goto after for
                                $async$goto = 5;
                                break;
                            }
                            value = t2[_i];
                            if (typeof value == "string") {
                                t4 = value;
                                // goto break $label0$0
                                $async$goto = 6;
                                break;
                            }
                            $async$goto = value instanceof A.Expression ? 7 : 8;
                            break;
                        case 7:
                            // then
                            $async$goto = 9;
                            return A._asyncAwait(value.accept$1($async$self), $async$visitStringExpression$1);
                        case 9:
                            // returning from await.
                            _0_0 = $async$result;
                            $label1$1: {
                                if (_0_0 instanceof A.SassString) {
                                    text = _0_0._string$_text;
                                    t4 = text;
                                    break $label1$1;
                                }
                                t4 = $async$self._async_evaluate$_serialize$3$quote(_0_0, value, false);
                                break $label1$1;
                            }
                            // goto break $label0$0
                            $async$goto = 6;
                            break;
                        case 8:
                            // join
                            t4 = A.throwExpression(A.UnsupportedError$("Unknown interpolation value " + A.S(value)));
                        case 6:
                            // break $label0$0
                            t1.push(t4);
                        case 4:
                            // for update
                            ++_i;
                            // goto for condition
                            $async$goto = 3;
                            break;
                        case 5:
                            // after for
                            t1 = B.JSArray_methods.join$0(t1);
                            $async$self._async_evaluate$_inSupportsDeclaration = oldInSupportsDeclaration;
                            $async$returnValue = new A.SassString(t1, node.hasQuotes);
                            // goto return
                            $async$goto = 1;
                            break;
                        case 1:
                            // return
                            return A._asyncReturn($async$returnValue, $async$completer);
                    }
                });
                return A._asyncStartSync($async$visitStringExpression$1, $async$completer);
            },
            visitSupportsExpression$1: function(_, expression) {
                return this.visitSupportsExpression$body$_EvaluateVisitor(0, expression);
            },
            visitSupportsExpression$body$_EvaluateVisitor: function(_, expression) {
                var $async$goto = 0, $async$completer = A._makeAsyncAwaitCompleter(type$.SassString), $async$returnValue, $async$self = this, $async$temp1;
                var $async$visitSupportsExpression$1 = A._wrapJsFunctionForAsync(function($async$errorCode, $async$result) {
                    if ($async$errorCode === 1) return A._asyncRethrow($async$result, $async$completer);
                    for(;;)switch($async$goto){
                        case 0:
                            // Function start
                            $async$temp1 = A;
                            $async$goto = 3;
                            return A._asyncAwait($async$self._async_evaluate$_visitSupportsCondition$1(expression.condition), $async$visitSupportsExpression$1);
                        case 3:
                            // returning from await.
                            $async$returnValue = new $async$temp1.SassString($async$result, false);
                            // goto return
                            $async$goto = 1;
                            break;
                        case 1:
                            // return
                            return A._asyncReturn($async$returnValue, $async$completer);
                    }
                });
                return A._asyncStartSync($async$visitSupportsExpression$1, $async$completer);
            },
            visitCssAtRule$1: function(node) {
                return this.visitCssAtRule$body$_EvaluateVisitor(node);
            },
            visitCssAtRule$body$_EvaluateVisitor: function(node) {
                var $async$goto = 0, $async$completer = A._makeAsyncAwaitCompleter(type$.void), $async$returnValue, $async$self = this, wasInKeyframes, wasInUnknownAtRule, t1, rule;
                var $async$visitCssAtRule$1 = A._wrapJsFunctionForAsync(function($async$errorCode, $async$result) {
                    if ($async$errorCode === 1) return A._asyncRethrow($async$result, $async$completer);
                    for(;;)switch($async$goto){
                        case 0:
                            // Function start
                            if ($async$self._async_evaluate$_declarationName != null) throw A.wrapException($async$self._async_evaluate$_exception$2(string$.At_rul, node.span));
                            if (node.isChildless) {
                                $async$self._async_evaluate$_copyParentAfterSibling$0();
                                $async$self._async_evaluate$_assertInModule$2($async$self._async_evaluate$__parent, "__parent").addChild$1(A.ModifiableCssAtRule$(node.name, node.span, true, node.value));
                                // goto return
                                $async$goto = 1;
                                break;
                            }
                            wasInKeyframes = $async$self._async_evaluate$_inKeyframes;
                            wasInUnknownAtRule = $async$self._async_evaluate$_inUnknownAtRule;
                            t1 = node.name;
                            if (A.unvendor(t1.value) === "keyframes") $async$self._async_evaluate$_inKeyframes = true;
                            else $async$self._async_evaluate$_inUnknownAtRule = true;
                            rule = A.ModifiableCssAtRule$(t1, node.span, false, node.value);
                            $async$goto = $async$self.get$_async_evaluate$_hasCssNesting() ? 3 : 4;
                            break;
                        case 3:
                            // then
                            $async$goto = 5;
                            return A._asyncAwait($async$self._async_evaluate$_withParent$2$3$scopeWhen(rule, new A._EvaluateVisitor_visitCssAtRule_closure2($async$self, node), false, type$.ModifiableCssAtRule, type$.Null), $async$visitCssAtRule$1);
                        case 5:
                            // returning from await.
                            $async$self._async_evaluate$_inUnknownAtRule = wasInUnknownAtRule;
                            $async$self._async_evaluate$_inKeyframes = wasInKeyframes;
                            // goto return
                            $async$goto = 1;
                            break;
                        case 4:
                            // join
                            $async$goto = 6;
                            return A._asyncAwait($async$self._async_evaluate$_withParent$2$4$scopeWhen$through(rule, new A._EvaluateVisitor_visitCssAtRule_closure3($async$self, node), false, new A._EvaluateVisitor_visitCssAtRule_closure4(), type$.ModifiableCssAtRule, type$.Null), $async$visitCssAtRule$1);
                        case 6:
                            // returning from await.
                            $async$self._async_evaluate$_inUnknownAtRule = wasInUnknownAtRule;
                            $async$self._async_evaluate$_inKeyframes = wasInKeyframes;
                        case 1:
                            // return
                            return A._asyncReturn($async$returnValue, $async$completer);
                    }
                });
                return A._asyncStartSync($async$visitCssAtRule$1, $async$completer);
            },
            visitCssComment$1: function(node) {
                return this.visitCssComment$body$_EvaluateVisitor(node);
            },
            visitCssComment$body$_EvaluateVisitor: function(node) {
                var $async$goto = 0, $async$completer = A._makeAsyncAwaitCompleter(type$.void), $async$self = this;
                var $async$visitCssComment$1 = A._wrapJsFunctionForAsync(function($async$errorCode, $async$result) {
                    if ($async$errorCode === 1) return A._asyncRethrow($async$result, $async$completer);
                    for(;;)switch($async$goto){
                        case 0:
                            // Function start
                            if ($async$self._async_evaluate$_assertInModule$2($async$self._async_evaluate$__parent, "__parent") === $async$self._async_evaluate$_assertInModule$2($async$self._async_evaluate$__root, "_root") && $async$self._async_evaluate$_assertInModule$2($async$self._async_evaluate$__endOfImports, "_endOfImports") === J.get$length$asx($async$self._async_evaluate$_assertInModule$2($async$self._async_evaluate$__root, "_root").children._collection$_source)) $async$self._async_evaluate$__endOfImports = $async$self._async_evaluate$_assertInModule$2($async$self._async_evaluate$__endOfImports, "_endOfImports") + 1;
                            $async$self._async_evaluate$_copyParentAfterSibling$0();
                            $async$self._async_evaluate$_assertInModule$2($async$self._async_evaluate$__parent, "__parent").addChild$1(new A.ModifiableCssComment(node.text, node.span));
                            // implicit return
                            return A._asyncReturn(null, $async$completer);
                    }
                });
                return A._asyncStartSync($async$visitCssComment$1, $async$completer);
            },
            visitCssDeclaration$1: function(node) {
                return this.visitCssDeclaration$body$_EvaluateVisitor(node);
            },
            visitCssDeclaration$body$_EvaluateVisitor: function(node) {
                var $async$goto = 0, $async$completer = A._makeAsyncAwaitCompleter(type$.void), $async$self = this;
                var $async$visitCssDeclaration$1 = A._wrapJsFunctionForAsync(function($async$errorCode, $async$result) {
                    if ($async$errorCode === 1) return A._asyncRethrow($async$result, $async$completer);
                    for(;;)switch($async$goto){
                        case 0:
                            // Function start
                            $async$self._async_evaluate$_copyParentAfterSibling$0();
                            $async$self._async_evaluate$_assertInModule$2($async$self._async_evaluate$__parent, "__parent").addChild$1(A.ModifiableCssDeclaration$(node.name, node.value, node.span, node.parsedAsSassScript, node.valueSpanForMap));
                            // implicit return
                            return A._asyncReturn(null, $async$completer);
                    }
                });
                return A._asyncStartSync($async$visitCssDeclaration$1, $async$completer);
            },
            visitCssImport$1: function(node) {
                return this.visitCssImport$body$_EvaluateVisitor(node);
            },
            visitCssImport$body$_EvaluateVisitor: function(node) {
                var $async$goto = 0, $async$completer = A._makeAsyncAwaitCompleter(type$.void), $async$self = this, t1, modifiableNode;
                var $async$visitCssImport$1 = A._wrapJsFunctionForAsync(function($async$errorCode, $async$result) {
                    if ($async$errorCode === 1) return A._asyncRethrow($async$result, $async$completer);
                    for(;;)switch($async$goto){
                        case 0:
                            // Function start
                            modifiableNode = new A.ModifiableCssImport(node.url, node.modifiers, node.span);
                            if ($async$self._async_evaluate$_assertInModule$2($async$self._async_evaluate$__parent, "__parent") !== $async$self._async_evaluate$_assertInModule$2($async$self._async_evaluate$__root, "_root")) {
                                $async$self._async_evaluate$_copyParentAfterSibling$0();
                                $async$self._async_evaluate$_assertInModule$2($async$self._async_evaluate$__parent, "__parent").addChild$1(modifiableNode);
                            } else if ($async$self._async_evaluate$_assertInModule$2($async$self._async_evaluate$__endOfImports, "_endOfImports") === J.get$length$asx($async$self._async_evaluate$_assertInModule$2($async$self._async_evaluate$__root, "_root").children._collection$_source)) {
                                $async$self._async_evaluate$_assertInModule$2($async$self._async_evaluate$__root, "_root").addChild$1(modifiableNode);
                                $async$self._async_evaluate$__endOfImports = $async$self._async_evaluate$_assertInModule$2($async$self._async_evaluate$__endOfImports, "_endOfImports") + 1;
                            } else {
                                t1 = $async$self._async_evaluate$_outOfOrderImports;
                                (t1 == null ? $async$self._async_evaluate$_outOfOrderImports = A._setArrayType([], type$.JSArray_ModifiableCssImport) : t1).push(modifiableNode);
                            }
                            // implicit return
                            return A._asyncReturn(null, $async$completer);
                    }
                });
                return A._asyncStartSync($async$visitCssImport$1, $async$completer);
            },
            visitCssKeyframeBlock$1: function(node) {
                return this.visitCssKeyframeBlock$body$_EvaluateVisitor(node);
            },
            visitCssKeyframeBlock$body$_EvaluateVisitor: function(node) {
                var $async$goto = 0, $async$completer = A._makeAsyncAwaitCompleter(type$.void), $async$self = this;
                var $async$visitCssKeyframeBlock$1 = A._wrapJsFunctionForAsync(function($async$errorCode, $async$result) {
                    if ($async$errorCode === 1) return A._asyncRethrow($async$result, $async$completer);
                    for(;;)switch($async$goto){
                        case 0:
                            // Function start
                            $async$goto = 2;
                            return A._asyncAwait($async$self._async_evaluate$_withParent$2$4$scopeWhen$through(A.ModifiableCssKeyframeBlock$(node.selector, node.span), new A._EvaluateVisitor_visitCssKeyframeBlock_closure1($async$self, node), false, new A._EvaluateVisitor_visitCssKeyframeBlock_closure2(), type$.ModifiableCssKeyframeBlock, type$.Null), $async$visitCssKeyframeBlock$1);
                        case 2:
                            // returning from await.
                            // implicit return
                            return A._asyncReturn(null, $async$completer);
                    }
                });
                return A._asyncStartSync($async$visitCssKeyframeBlock$1, $async$completer);
            },
            visitCssMediaRule$1: function(node) {
                return this.visitCssMediaRule$body$_EvaluateVisitor(node);
            },
            visitCssMediaRule$body$_EvaluateVisitor: function(node) {
                var $async$goto = 0, $async$completer = A._makeAsyncAwaitCompleter(type$.void), $async$returnValue, $async$self = this, mergedQueries, t1, mergedSources, t2, t3;
                var $async$visitCssMediaRule$1 = A._wrapJsFunctionForAsync(function($async$errorCode, $async$result) {
                    if ($async$errorCode === 1) return A._asyncRethrow($async$result, $async$completer);
                    for(;;)switch($async$goto){
                        case 0:
                            // Function start
                            if ($async$self._async_evaluate$_declarationName != null) throw A.wrapException($async$self._async_evaluate$_exception$2(string$.Media_, node.span));
                            $async$goto = $async$self.get$_async_evaluate$_hasCssNesting() ? 3 : 4;
                            break;
                        case 3:
                            // then
                            $async$goto = 5;
                            return A._asyncAwait($async$self._async_evaluate$_withParent$2$3$scopeWhen(A.ModifiableCssMediaRule$(node.queries, node.span), new A._EvaluateVisitor_visitCssMediaRule_closure3($async$self, node), false, type$.ModifiableCssMediaRule, type$.Null), $async$visitCssMediaRule$1);
                        case 5:
                            // returning from await.
                            // goto return
                            $async$goto = 1;
                            break;
                        case 4:
                            // join
                            mergedQueries = A.NullableExtension_andThen($async$self._async_evaluate$_mediaQueries, new A._EvaluateVisitor_visitCssMediaRule_closure4($async$self, node));
                            t1 = mergedQueries == null;
                            if (!t1 && J.get$isEmpty$asx(mergedQueries)) {
                                // goto return
                                $async$goto = 1;
                                break;
                            }
                            if (t1) mergedSources = B.Set_empty2;
                            else {
                                t2 = $async$self._async_evaluate$_mediaQuerySources;
                                t2.toString;
                                t2 = A.LinkedHashSet_LinkedHashSet$of(t2, type$.CssMediaQuery);
                                t3 = $async$self._async_evaluate$_mediaQueries;
                                t3.toString;
                                t2.addAll$1(0, t3);
                                t2.addAll$1(0, node.queries);
                                mergedSources = t2;
                            }
                            t1 = t1 ? node.queries : mergedQueries;
                            $async$goto = 6;
                            return A._asyncAwait($async$self._async_evaluate$_withParent$2$4$scopeWhen$through(A.ModifiableCssMediaRule$(t1, node.span), new A._EvaluateVisitor_visitCssMediaRule_closure5($async$self, mergedQueries, node, mergedSources), false, new A._EvaluateVisitor_visitCssMediaRule_closure6(mergedSources), type$.ModifiableCssMediaRule, type$.Null), $async$visitCssMediaRule$1);
                        case 6:
                        // returning from await.
                        case 1:
                            // return
                            return A._asyncReturn($async$returnValue, $async$completer);
                    }
                });
                return A._asyncStartSync($async$visitCssMediaRule$1, $async$completer);
            },
            visitCssStyleRule$1: function(node) {
                return this.visitCssStyleRule$body$_EvaluateVisitor(node);
            },
            visitCssStyleRule$body$_EvaluateVisitor: function(node) {
                var $async$goto = 0, $async$completer = A._makeAsyncAwaitCompleter(type$.void), $async$self = this, t1, styleRule, _0_0, t2, t3, originalSelector, rule, oldAtRootExcludingStyleRule, _1_1, lastChild;
                var $async$visitCssStyleRule$1 = A._wrapJsFunctionForAsync(function($async$errorCode, $async$result) {
                    if ($async$errorCode === 1) return A._asyncRethrow($async$result, $async$completer);
                    for(;;)switch($async$goto){
                        case 0:
                            // Function start
                            if ($async$self._async_evaluate$_declarationName != null) throw A.wrapException($async$self._async_evaluate$_exception$2(string$.Style_n, node.span));
                            else if ($async$self._async_evaluate$_inKeyframes && $async$self._async_evaluate$_assertInModule$2($async$self._async_evaluate$__parent, "__parent") instanceof A.ModifiableCssKeyframeBlock) throw A.wrapException($async$self._async_evaluate$_exception$2(string$.Style_k, node.span));
                            t1 = $async$self._async_evaluate$_atRootExcludingStyleRule;
                            styleRule = t1 ? null : $async$self._async_evaluate$_styleRuleIgnoringAtRoot;
                            _0_0 = t1 ? null : $async$self._async_evaluate$_styleRuleIgnoringAtRoot;
                            $label0$0: {
                                if (_0_0 == null) {
                                    t1 = true;
                                    break $label0$0;
                                }
                                if (_0_0.fromPlainCss) {
                                    t1 = false;
                                    break $label0$0;
                                }
                                t1 = !(node.fromPlainCss && node._style_rule$_selector._box$_inner.value.accept$1(B.C__ContainsParentSelectorVisitor));
                                break $label0$0;
                            }
                            t2 = node._style_rule$_selector._box$_inner;
                            if (t1) {
                                t2 = t2.value;
                                t3 = styleRule == null ? null : styleRule.originalSelector;
                                originalSelector = t2.nestWithin$3$implicitParent$preserveParentSelectors(t3, !$async$self._async_evaluate$_atRootExcludingStyleRule, node.fromPlainCss);
                            } else originalSelector = t2.value;
                            rule = A.ModifiableCssStyleRule$($async$self._async_evaluate$_assertInModule$2($async$self._async_evaluate$__extensionStore, "_extensionStore").addSelector$2(originalSelector, $async$self._async_evaluate$_mediaQueries), node.span, node.fromPlainCss, originalSelector);
                            oldAtRootExcludingStyleRule = $async$self._async_evaluate$_atRootExcludingStyleRule;
                            $async$self._async_evaluate$_atRootExcludingStyleRule = false;
                            t1 = t1 ? new A._EvaluateVisitor_visitCssStyleRule_closure1() : null;
                            $async$goto = 2;
                            return A._asyncAwait($async$self._async_evaluate$_withParent$2$4$scopeWhen$through(rule, new A._EvaluateVisitor_visitCssStyleRule_closure2($async$self, rule, node), false, t1, type$.ModifiableCssStyleRule, type$.Null), $async$visitCssStyleRule$1);
                        case 2:
                            // returning from await.
                            $async$self._async_evaluate$_atRootExcludingStyleRule = oldAtRootExcludingStyleRule;
                            t1 = $async$self._async_evaluate$_assertInModule$2($async$self._async_evaluate$__parent, "__parent").children._collection$_source;
                            t2 = J.getInterceptor$asx(t1);
                            _1_1 = t2.get$length(t1);
                            if (_1_1 >= 1) {
                                lastChild = t2.elementAt$1(t1, _1_1 - 1);
                                t1 = styleRule == null;
                            } else {
                                lastChild = null;
                                t1 = false;
                            }
                            if (t1) lastChild.isGroupEnd = true;
                            // implicit return
                            return A._asyncReturn(null, $async$completer);
                    }
                });
                return A._asyncStartSync($async$visitCssStyleRule$1, $async$completer);
            },
            visitCssStylesheet$1: function(node) {
                return this.visitCssStylesheet$body$_EvaluateVisitor(node);
            },
            visitCssStylesheet$body$_EvaluateVisitor: function(node) {
                var $async$goto = 0, $async$completer = A._makeAsyncAwaitCompleter(type$.void), $async$self = this, t1;
                var $async$visitCssStylesheet$1 = A._wrapJsFunctionForAsync(function($async$errorCode, $async$result) {
                    if ($async$errorCode === 1) return A._asyncRethrow($async$result, $async$completer);
                    for(;;)switch($async$goto){
                        case 0:
                            // Function start
                            t1 = J.get$iterator$ax(node.get$children(node));
                        case 2:
                            // for condition
                            if (!t1.moveNext$0()) {
                                // goto after for
                                $async$goto = 3;
                                break;
                            }
                            $async$goto = 4;
                            return A._asyncAwait(t1.get$current(t1).accept$1($async$self), $async$visitCssStylesheet$1);
                        case 4:
                            // returning from await.
                            // goto for condition
                            $async$goto = 2;
                            break;
                        case 3:
                            // after for
                            // implicit return
                            return A._asyncReturn(null, $async$completer);
                    }
                });
                return A._asyncStartSync($async$visitCssStylesheet$1, $async$completer);
            },
            visitCssSupportsRule$1: function(node) {
                return this.visitCssSupportsRule$body$_EvaluateVisitor(node);
            },
            visitCssSupportsRule$body$_EvaluateVisitor: function(node) {
                var $async$goto = 0, $async$completer = A._makeAsyncAwaitCompleter(type$.void), $async$returnValue, $async$self = this, rule;
                var $async$visitCssSupportsRule$1 = A._wrapJsFunctionForAsync(function($async$errorCode, $async$result) {
                    if ($async$errorCode === 1) return A._asyncRethrow($async$result, $async$completer);
                    for(;;)switch($async$goto){
                        case 0:
                            // Function start
                            if ($async$self._async_evaluate$_declarationName != null) throw A.wrapException($async$self._async_evaluate$_exception$2(string$.Suppor, node.span));
                            rule = A.ModifiableCssSupportsRule$(node.condition, node.span);
                            $async$goto = $async$self.get$_async_evaluate$_hasCssNesting() ? 3 : 4;
                            break;
                        case 3:
                            // then
                            $async$goto = 5;
                            return A._asyncAwait($async$self._async_evaluate$_withParent$2$3$scopeWhen(rule, new A._EvaluateVisitor_visitCssSupportsRule_closure2($async$self, node), false, type$.ModifiableCssSupportsRule, type$.Null), $async$visitCssSupportsRule$1);
                        case 5:
                            // returning from await.
                            // goto return
                            $async$goto = 1;
                            break;
                        case 4:
                            // join
                            $async$goto = 6;
                            return A._asyncAwait($async$self._async_evaluate$_withParent$2$4$scopeWhen$through(rule, new A._EvaluateVisitor_visitCssSupportsRule_closure3($async$self, node), false, new A._EvaluateVisitor_visitCssSupportsRule_closure4(), type$.ModifiableCssSupportsRule, type$.Null), $async$visitCssSupportsRule$1);
                        case 6:
                        // returning from await.
                        case 1:
                            // return
                            return A._asyncReturn($async$returnValue, $async$completer);
                    }
                });
                return A._asyncStartSync($async$visitCssSupportsRule$1, $async$completer);
            },
            _async_evaluate$_handleReturn$1$2: function(list, callback) {
                return this._handleReturn$body$_EvaluateVisitor(list, callback);
            },
            _async_evaluate$_handleReturn$2: function(list, callback) {
                return this._async_evaluate$_handleReturn$1$2(list, callback, type$.dynamic);
            },
            _handleReturn$body$_EvaluateVisitor: function(list, callback) {
                var $async$goto = 0, $async$completer = A._makeAsyncAwaitCompleter(type$.nullable_Value), $async$returnValue, t1, _i, _0_0;
                var $async$_async_evaluate$_handleReturn$1$2 = A._wrapJsFunctionForAsync(function($async$errorCode, $async$result) {
                    if ($async$errorCode === 1) return A._asyncRethrow($async$result, $async$completer);
                    for(;;)switch($async$goto){
                        case 0:
                            // Function start
                            t1 = list.length, _i = 0;
                        case 3:
                            // for condition
                            if (!(_i < list.length)) {
                                // goto after for
                                $async$goto = 5;
                                break;
                            }
                            $async$goto = 6;
                            return A._asyncAwait(callback.call$1(list[_i]), $async$_async_evaluate$_handleReturn$1$2);
                        case 6:
                            // returning from await.
                            _0_0 = $async$result;
                            if (_0_0 != null) {
                                $async$returnValue = _0_0;
                                // goto return
                                $async$goto = 1;
                                break;
                            }
                        case 4:
                            // for update
                            list.length === t1 || (0, A.throwConcurrentModificationError)(list), ++_i;
                            // goto for condition
                            $async$goto = 3;
                            break;
                        case 5:
                            // after for
                            $async$returnValue = null;
                            // goto return
                            $async$goto = 1;
                            break;
                        case 1:
                            // return
                            return A._asyncReturn($async$returnValue, $async$completer);
                    }
                });
                return A._asyncStartSync($async$_async_evaluate$_handleReturn$1$2, $async$completer);
            },
            _async_evaluate$_withEnvironment$1$2: function(environment, callback, $T) {
                return this._withEnvironment$body$_EvaluateVisitor(environment, callback, $T, $T);
            },
            _withEnvironment$body$_EvaluateVisitor: function(environment, callback, $T, $async$type) {
                var $async$goto = 0, $async$completer = A._makeAsyncAwaitCompleter($async$type), $async$returnValue, $async$self = this, result, oldEnvironment;
                var $async$_async_evaluate$_withEnvironment$1$2 = A._wrapJsFunctionForAsync(function($async$errorCode, $async$result) {
                    if ($async$errorCode === 1) return A._asyncRethrow($async$result, $async$completer);
                    for(;;)switch($async$goto){
                        case 0:
                            // Function start
                            oldEnvironment = $async$self._async_evaluate$_environment;
                            $async$self._async_evaluate$_environment = environment;
                            $async$goto = 3;
                            return A._asyncAwait(callback.call$0(), $async$_async_evaluate$_withEnvironment$1$2);
                        case 3:
                            // returning from await.
                            result = $async$result;
                            $async$self._async_evaluate$_environment = oldEnvironment;
                            $async$returnValue = result;
                            // goto return
                            $async$goto = 1;
                            break;
                        case 1:
                            // return
                            return A._asyncReturn($async$returnValue, $async$completer);
                    }
                });
                return A._asyncStartSync($async$_async_evaluate$_withEnvironment$1$2, $async$completer);
            },
            _async_evaluate$_interpolationToValue$3$trim$warnForColor: function(interpolation, trim, warnForColor) {
                return this._interpolationToValue$body$_EvaluateVisitor(interpolation, trim, warnForColor);
            },
            _async_evaluate$_interpolationToValue$1: function(interpolation) {
                return this._async_evaluate$_interpolationToValue$3$trim$warnForColor(interpolation, false, false);
            },
            _async_evaluate$_interpolationToValue$2$warnForColor: function(interpolation, warnForColor) {
                return this._async_evaluate$_interpolationToValue$3$trim$warnForColor(interpolation, false, warnForColor);
            },
            _interpolationToValue$body$_EvaluateVisitor: function(interpolation, trim, warnForColor) {
                var $async$goto = 0, $async$completer = A._makeAsyncAwaitCompleter(type$.CssValue_String), $async$returnValue, $async$self = this, result, t1;
                var $async$_async_evaluate$_interpolationToValue$3$trim$warnForColor = A._wrapJsFunctionForAsync(function($async$errorCode, $async$result) {
                    if ($async$errorCode === 1) return A._asyncRethrow($async$result, $async$completer);
                    for(;;)switch($async$goto){
                        case 0:
                            // Function start
                            $async$goto = 3;
                            return A._asyncAwait($async$self._async_evaluate$_performInterpolation$2$warnForColor(interpolation, warnForColor), $async$_async_evaluate$_interpolationToValue$3$trim$warnForColor);
                        case 3:
                            // returning from await.
                            result = $async$result;
                            t1 = trim ? A.trimAscii(result, true) : result;
                            $async$returnValue = new A.CssValue(t1, interpolation.span, type$.CssValue_String);
                            // goto return
                            $async$goto = 1;
                            break;
                        case 1:
                            // return
                            return A._asyncReturn($async$returnValue, $async$completer);
                    }
                });
                return A._asyncStartSync($async$_async_evaluate$_interpolationToValue$3$trim$warnForColor, $async$completer);
            },
            _async_evaluate$_performInterpolation$2$warnForColor: function(interpolation, warnForColor) {
                return this._performInterpolation$body$_EvaluateVisitor(interpolation, warnForColor);
            },
            _async_evaluate$_performInterpolation$1: function(interpolation) {
                return this._async_evaluate$_performInterpolation$2$warnForColor(interpolation, false);
            },
            _performInterpolation$body$_EvaluateVisitor: function(interpolation, warnForColor) {
                var $async$goto = 0, $async$completer = A._makeAsyncAwaitCompleter(type$.String), $async$returnValue, $async$self = this;
                var $async$_async_evaluate$_performInterpolation$2$warnForColor = A._wrapJsFunctionForAsync(function($async$errorCode, $async$result) {
                    if ($async$errorCode === 1) return A._asyncRethrow($async$result, $async$completer);
                    for(;;)switch($async$goto){
                        case 0:
                            // Function start
                            $async$goto = 3;
                            return A._asyncAwait($async$self._async_evaluate$_performInterpolationHelper$3$sourceMap$warnForColor(interpolation, false, warnForColor), $async$_async_evaluate$_performInterpolation$2$warnForColor);
                        case 3:
                            // returning from await.
                            $async$returnValue = $async$result._0;
                            // goto return
                            $async$goto = 1;
                            break;
                        case 1:
                            // return
                            return A._asyncReturn($async$returnValue, $async$completer);
                    }
                });
                return A._asyncStartSync($async$_async_evaluate$_performInterpolation$2$warnForColor, $async$completer);
            },
            _async_evaluate$_performInterpolationWithMap$2$warnForColor: function(interpolation, warnForColor) {
                return this._performInterpolationWithMap$body$_EvaluateVisitor(interpolation, true);
            },
            _performInterpolationWithMap$body$_EvaluateVisitor: function(interpolation, warnForColor) {
                var $async$goto = 0, $async$completer = A._makeAsyncAwaitCompleter(type$.Record_2_String_and_InterpolationMap), $async$returnValue, $async$self = this, _0_0, result, map;
                var $async$_async_evaluate$_performInterpolationWithMap$2$warnForColor = A._wrapJsFunctionForAsync(function($async$errorCode, $async$result) {
                    if ($async$errorCode === 1) return A._asyncRethrow($async$result, $async$completer);
                    for(;;)switch($async$goto){
                        case 0:
                            // Function start
                            $async$goto = 3;
                            return A._asyncAwait($async$self._async_evaluate$_performInterpolationHelper$3$sourceMap$warnForColor(interpolation, true, true), $async$_async_evaluate$_performInterpolationWithMap$2$warnForColor);
                        case 3:
                            // returning from await.
                            _0_0 = $async$result;
                            result = _0_0._0;
                            map = _0_0._1;
                            map.toString;
                            $async$returnValue = new A._Record_2(result, map);
                            // goto return
                            $async$goto = 1;
                            break;
                        case 1:
                            // return
                            return A._asyncReturn($async$returnValue, $async$completer);
                    }
                });
                return A._asyncStartSync($async$_async_evaluate$_performInterpolationWithMap$2$warnForColor, $async$completer);
            },
            _async_evaluate$_performInterpolationHelper$3$sourceMap$warnForColor: function(interpolation, sourceMap, warnForColor) {
                return this._performInterpolationHelper$body$_EvaluateVisitor(interpolation, sourceMap, warnForColor);
            },
            _performInterpolationHelper$body$_EvaluateVisitor: function(interpolation, sourceMap, warnForColor) {
                var $async$goto = 0, $async$completer = A._makeAsyncAwaitCompleter(type$.Record_2_String_and_nullable_InterpolationMap), $async$returnValue, $async$self = this, t1, t2, t3, t4, t5, t6, first, _i, t7, value, result, result0, t8, targetOffsets, oldInSupportsDeclaration;
                var $async$_async_evaluate$_performInterpolationHelper$3$sourceMap$warnForColor = A._wrapJsFunctionForAsync(function($async$errorCode, $async$result) {
                    if ($async$errorCode === 1) return A._asyncRethrow($async$result, $async$completer);
                    for(;;)switch($async$goto){
                        case 0:
                            // Function start
                            targetOffsets = sourceMap ? A._setArrayType([], type$.JSArray_int) : null;
                            oldInSupportsDeclaration = $async$self._async_evaluate$_inSupportsDeclaration;
                            $async$self._async_evaluate$_inSupportsDeclaration = false;
                            t1 = interpolation.contents, t2 = t1.length, t3 = type$.Expression, t4 = targetOffsets == null, t5 = interpolation.span, t6 = type$.Object, first = true, _i = 0, t7 = "";
                        case 3:
                            // for condition
                            if (!(_i < t2)) {
                                // goto after for
                                $async$goto = 5;
                                break;
                            }
                            value = t1[_i];
                            if (!first) {
                                if (!t4) targetOffsets.push(t7.length);
                            }
                            if (typeof value == "string") {
                                t7 += value;
                                // goto for update
                                $async$goto = 4;
                                break;
                            }
                            t3._as(value);
                            $async$goto = 6;
                            return A._asyncAwait(value.accept$1($async$self), $async$_async_evaluate$_performInterpolationHelper$3$sourceMap$warnForColor);
                        case 6:
                            // returning from await.
                            result = $async$result;
                            if (warnForColor && $.$get$namesByColor().containsKey$1(result)) {
                                result0 = A.List_List$from([
                                    ""
                                ], false, t6);
                                result0.$flags = 3;
                                t8 = $.$get$namesByColor();
                                $async$self._async_evaluate$_warn$2(string$.You_pr + A.S(t8.$index(0, result)) + string$.x20in_in + result.toString$0(0) + string$.x2c_whicw + A.S(t8.$index(0, result)) + string$.x22x29__If + new A.BinaryOperationExpression(B.BinaryOperator_jCK, new A.StringExpression(new A.Interpolation(result0, B.List_null, t5), true), value, false).toString$0(0) + "'.", value.get$span(value));
                            }
                            t7 += $async$self._async_evaluate$_serialize$3$quote(result, value, false);
                        case 4:
                            // for update
                            ++_i, first = false;
                            // goto for condition
                            $async$goto = 3;
                            break;
                        case 5:
                            // after for
                            $async$self._async_evaluate$_inSupportsDeclaration = oldInSupportsDeclaration;
                            $async$returnValue = new A._Record_2(t7.charCodeAt(0) == 0 ? t7 : t7, A.NullableExtension_andThen(targetOffsets, new A._EvaluateVisitor__performInterpolationHelper_closure0(interpolation)));
                            // goto return
                            $async$goto = 1;
                            break;
                        case 1:
                            // return
                            return A._asyncReturn($async$returnValue, $async$completer);
                    }
                });
                return A._asyncStartSync($async$_async_evaluate$_performInterpolationHelper$3$sourceMap$warnForColor, $async$completer);
            },
            _evaluateToCss$2$quote: function(expression, quote) {
                return this._evaluateToCss$body$_EvaluateVisitor(expression, quote);
            },
            _evaluateToCss$1: function(expression) {
                return this._evaluateToCss$2$quote(expression, true);
            },
            _evaluateToCss$body$_EvaluateVisitor: function(expression, quote) {
                var $async$goto = 0, $async$completer = A._makeAsyncAwaitCompleter(type$.String), $async$returnValue, $async$self = this, t1;
                var $async$_evaluateToCss$2$quote = A._wrapJsFunctionForAsync(function($async$errorCode, $async$result) {
                    if ($async$errorCode === 1) return A._asyncRethrow($async$result, $async$completer);
                    for(;;)switch($async$goto){
                        case 0:
                            // Function start
                            t1 = expression.accept$1($async$self);
                            $async$goto = 3;
                            return A._asyncAwait(type$.Future_Value._is(t1) ? t1 : A._Future$value(t1, type$.Value), $async$_evaluateToCss$2$quote);
                        case 3:
                            // returning from await.
                            $async$returnValue = $async$self._async_evaluate$_serialize$3$quote($async$result, expression, quote);
                            // goto return
                            $async$goto = 1;
                            break;
                        case 1:
                            // return
                            return A._asyncReturn($async$returnValue, $async$completer);
                    }
                });
                return A._asyncStartSync($async$_evaluateToCss$2$quote, $async$completer);
            },
            _async_evaluate$_serialize$3$quote: function(value, nodeWithSpan, quote) {
                return this._async_evaluate$_addExceptionSpan$2(nodeWithSpan, new A._EvaluateVisitor__serialize_closure0(value, quote));
            },
            _async_evaluate$_serialize$2: function(value, nodeWithSpan) {
                return this._async_evaluate$_serialize$3$quote(value, nodeWithSpan, true);
            },
            _async_evaluate$_expressionNode$1: function(expression) {
                var t1;
                if (expression instanceof A.VariableExpression) {
                    t1 = this._async_evaluate$_addExceptionSpan$2(expression, new A._EvaluateVisitor__expressionNode_closure0(this, expression));
                    return t1 == null ? expression : t1;
                } else return expression;
            },
            _async_evaluate$_withParent$2$4$scopeWhen$through: function(node, callback, scopeWhen, through, $S, $T) {
                return this._withParent$body$_EvaluateVisitor(node, callback, scopeWhen, through, $S, $T, $T);
            },
            _async_evaluate$_withParent$2$3$scopeWhen: function(node, callback, scopeWhen, $S, $T) {
                return this._async_evaluate$_withParent$2$4$scopeWhen$through(node, callback, scopeWhen, null, $S, $T);
            },
            _async_evaluate$_withParent$2$2: function(node, callback, $S, $T) {
                return this._async_evaluate$_withParent$2$4$scopeWhen$through(node, callback, true, null, $S, $T);
            },
            _withParent$body$_EvaluateVisitor: function(node, callback, scopeWhen, through, $S, $T, $async$type) {
                var $async$goto = 0, $async$completer = A._makeAsyncAwaitCompleter($async$type), $async$returnValue, $async$self = this, oldParent, result;
                var $async$_async_evaluate$_withParent$2$4$scopeWhen$through = A._wrapJsFunctionForAsync(function($async$errorCode, $async$result) {
                    if ($async$errorCode === 1) return A._asyncRethrow($async$result, $async$completer);
                    for(;;)switch($async$goto){
                        case 0:
                            // Function start
                            $async$self._async_evaluate$_addChild$2$through(node, through);
                            oldParent = $async$self._async_evaluate$_assertInModule$2($async$self._async_evaluate$__parent, "__parent");
                            $async$self._async_evaluate$__parent = node;
                            $async$goto = 3;
                            return A._asyncAwait($async$self._async_evaluate$_environment.scope$1$2$when(callback, scopeWhen, $T), $async$_async_evaluate$_withParent$2$4$scopeWhen$through);
                        case 3:
                            // returning from await.
                            result = $async$result;
                            $async$self._async_evaluate$__parent = oldParent;
                            $async$returnValue = result;
                            // goto return
                            $async$goto = 1;
                            break;
                        case 1:
                            // return
                            return A._asyncReturn($async$returnValue, $async$completer);
                    }
                });
                return A._asyncStartSync($async$_async_evaluate$_withParent$2$4$scopeWhen$through, $async$completer);
            },
            _async_evaluate$_copyParentAfterSibling$0: function() {
                var t1, grandparent, newParent, _this = this, _s8_ = "__parent", _0_0 = _this._async_evaluate$_assertInModule$2(_this._async_evaluate$__parent, _s8_)._parent;
                if (_0_0 != null) {
                    t1 = _0_0.children;
                    t1 = t1.get$last(t1) !== _this._async_evaluate$_assertInModule$2(_this._async_evaluate$__parent, _s8_);
                    grandparent = _0_0;
                } else {
                    grandparent = null;
                    t1 = false;
                }
                if (t1) {
                    newParent = _this._async_evaluate$_assertInModule$2(_this._async_evaluate$__parent, _s8_).copyWithoutChildren$0();
                    grandparent.addChild$1(newParent);
                    _this._async_evaluate$__parent = newParent;
                }
            },
            _async_evaluate$_addChild$2$through: function(node, through) {
                var _0_0, grandparent, t1, $parent = this._async_evaluate$_assertInModule$2(this._async_evaluate$__parent, "__parent");
                if (through != null) {
                    for(; through.call$1($parent); $parent = _0_0){
                        _0_0 = $parent._parent;
                        if (_0_0 == null) throw A.wrapException(A.ArgumentError$(string$.throug + node.toString$0(0) + ".", null));
                    }
                    if ($parent.get$hasFollowingSibling()) {
                        grandparent = $parent._parent;
                        t1 = grandparent.children;
                        if ($parent.equalsIgnoringChildren$1(t1.get$last(t1))) $parent = type$.ModifiableCssParentNode._as(t1.get$last(t1));
                        else {
                            $parent = $parent.copyWithoutChildren$0();
                            grandparent.addChild$1($parent);
                        }
                    }
                }
                $parent.addChild$1(node);
            },
            _async_evaluate$_addChild$1: function(node) {
                return this._async_evaluate$_addChild$2$through(node, null);
            },
            _async_evaluate$_withStyleRule$1$2: function(rule, callback, $T) {
                return this._withStyleRule$body$_EvaluateVisitor(rule, callback, $T, $T);
            },
            _withStyleRule$body$_EvaluateVisitor: function(rule, callback, $T, $async$type) {
                var $async$goto = 0, $async$completer = A._makeAsyncAwaitCompleter($async$type), $async$returnValue, $async$self = this, result, oldRule;
                var $async$_async_evaluate$_withStyleRule$1$2 = A._wrapJsFunctionForAsync(function($async$errorCode, $async$result) {
                    if ($async$errorCode === 1) return A._asyncRethrow($async$result, $async$completer);
                    for(;;)switch($async$goto){
                        case 0:
                            // Function start
                            oldRule = $async$self._async_evaluate$_styleRuleIgnoringAtRoot;
                            $async$self._async_evaluate$_styleRuleIgnoringAtRoot = rule;
                            $async$goto = 3;
                            return A._asyncAwait(callback.call$0(), $async$_async_evaluate$_withStyleRule$1$2);
                        case 3:
                            // returning from await.
                            result = $async$result;
                            $async$self._async_evaluate$_styleRuleIgnoringAtRoot = oldRule;
                            $async$returnValue = result;
                            // goto return
                            $async$goto = 1;
                            break;
                        case 1:
                            // return
                            return A._asyncReturn($async$returnValue, $async$completer);
                    }
                });
                return A._asyncStartSync($async$_async_evaluate$_withStyleRule$1$2, $async$completer);
            },
            _async_evaluate$_withMediaQueries$1$3: function(queries, sources, callback, $T) {
                return this._withMediaQueries$body$_EvaluateVisitor(queries, sources, callback, $T, $T);
            },
            _withMediaQueries$body$_EvaluateVisitor: function(queries, sources, callback, $T, $async$type) {
                var $async$goto = 0, $async$completer = A._makeAsyncAwaitCompleter($async$type), $async$returnValue, $async$self = this, result, oldMediaQueries, oldSources;
                var $async$_async_evaluate$_withMediaQueries$1$3 = A._wrapJsFunctionForAsync(function($async$errorCode, $async$result) {
                    if ($async$errorCode === 1) return A._asyncRethrow($async$result, $async$completer);
                    for(;;)switch($async$goto){
                        case 0:
                            // Function start
                            oldMediaQueries = $async$self._async_evaluate$_mediaQueries;
                            oldSources = $async$self._async_evaluate$_mediaQuerySources;
                            $async$self._async_evaluate$_mediaQueries = queries;
                            $async$self._async_evaluate$_mediaQuerySources = sources;
                            $async$goto = 3;
                            return A._asyncAwait(callback.call$0(), $async$_async_evaluate$_withMediaQueries$1$3);
                        case 3:
                            // returning from await.
                            result = $async$result;
                            $async$self._async_evaluate$_mediaQueries = oldMediaQueries;
                            $async$self._async_evaluate$_mediaQuerySources = oldSources;
                            $async$returnValue = result;
                            // goto return
                            $async$goto = 1;
                            break;
                        case 1:
                            // return
                            return A._asyncReturn($async$returnValue, $async$completer);
                    }
                });
                return A._asyncStartSync($async$_async_evaluate$_withMediaQueries$1$3, $async$completer);
            },
            _async_evaluate$_withStackFrame$1$3: function(member, nodeWithSpan, callback, $T) {
                return this._withStackFrame$body$_EvaluateVisitor(member, nodeWithSpan, callback, $T, $T);
            },
            _withStackFrame$body$_EvaluateVisitor: function(member, nodeWithSpan, callback, $T, $async$type) {
                var $async$goto = 0, $async$completer = A._makeAsyncAwaitCompleter($async$type), $async$returnValue, $async$self = this, oldMember, result, t1;
                var $async$_async_evaluate$_withStackFrame$1$3 = A._wrapJsFunctionForAsync(function($async$errorCode, $async$result) {
                    if ($async$errorCode === 1) return A._asyncRethrow($async$result, $async$completer);
                    for(;;)switch($async$goto){
                        case 0:
                            // Function start
                            t1 = $async$self._async_evaluate$_stack;
                            t1.push(new A._Record_2($async$self._async_evaluate$_member, nodeWithSpan));
                            oldMember = $async$self._async_evaluate$_member;
                            $async$self._async_evaluate$_member = member;
                            $async$goto = 3;
                            return A._asyncAwait(callback.call$0(), $async$_async_evaluate$_withStackFrame$1$3);
                        case 3:
                            // returning from await.
                            result = $async$result;
                            $async$self._async_evaluate$_member = oldMember;
                            t1.pop();
                            $async$returnValue = result;
                            // goto return
                            $async$goto = 1;
                            break;
                        case 1:
                            // return
                            return A._asyncReturn($async$returnValue, $async$completer);
                    }
                });
                return A._asyncStartSync($async$_async_evaluate$_withStackFrame$1$3, $async$completer);
            },
            _async_evaluate$_withoutSlash$2: function(value, nodeForSpan) {
                var t1;
                if (value instanceof A.SassNumber) t1 = value.asSlash != null;
                else t1 = false;
                if (t1) this._async_evaluate$_warn$3(string$.Using__i + A.S(new A._EvaluateVisitor__withoutSlash_recommendation0().call$1(value)) + string$.x0a_Morex20, nodeForSpan.get$span(nodeForSpan), B.Deprecation_qZ1);
                return value.withoutSlash$0();
            },
            _async_evaluate$_stackFrame$2: function(member, span) {
                return A.frameForSpan(span, member, A.NullableExtension_andThen(span.get$sourceUrl(span), new A._EvaluateVisitor__stackFrame_closure0(this)));
            },
            _async_evaluate$_stackTrace$1: function(span) {
                var t2, t3, _i, t4, nodeWithSpan, _this = this, t1 = A._setArrayType([], type$.JSArray_Frame);
                for(t2 = _this._async_evaluate$_stack, t3 = t2.length, _i = 0; _i < t2.length; t2.length === t3 || (0, A.throwConcurrentModificationError)(t2), ++_i){
                    t4 = t2[_i];
                    nodeWithSpan = t4._1;
                    t1.push(_this._async_evaluate$_stackFrame$2(t4._0, nodeWithSpan.get$span(nodeWithSpan)));
                }
                if (span != null) t1.push(_this._async_evaluate$_stackFrame$2(_this._async_evaluate$_member, span));
                return A.Trace$(new A.ReversedListIterable(t1, type$.ReversedListIterable_Frame), null);
            },
            _async_evaluate$_stackTrace$0: function() {
                return this._async_evaluate$_stackTrace$1(null);
            },
            _async_evaluate$_warn$3: function(message, span, deprecation) {
                var trace, t1, _this = this;
                if (_this._async_evaluate$_quietDeps && _this._async_evaluate$_inDependency) return;
                if (!_this._async_evaluate$_warningsEmitted.add$1(0, new A._Record_2(message, span))) return;
                trace = _this._async_evaluate$_stackTrace$1(span);
                t1 = _this._async_evaluate$_logger;
                if (deprecation == null) t1.internalWarn$4$deprecation$span$trace(message, null, span, trace);
                else A.WarnForDeprecation_warnForDeprecation(t1, deprecation, message, span, trace);
            },
            _async_evaluate$_warn$2: function(message, span) {
                return this._async_evaluate$_warn$3(message, span, null);
            },
            _async_evaluate$_exception$2: function(message, span) {
                var t1, t2;
                if (span == null) {
                    t1 = B.JSArray_methods.get$last(this._async_evaluate$_stack)._1;
                    t1 = t1.get$span(t1);
                } else t1 = span;
                t2 = this._async_evaluate$_stackTrace$1(span);
                return new A.SassRuntimeException(t2, B.Set_empty, message, t1);
            },
            _async_evaluate$_exception$1: function(message) {
                return this._async_evaluate$_exception$2(message, null);
            },
            _async_evaluate$_multiSpanException$3: function(message, primaryLabel, secondaryLabels) {
                var t1 = B.JSArray_methods.get$last(this._async_evaluate$_stack)._1;
                return A.MultiSpanSassRuntimeException$(message, t1.get$span(t1), primaryLabel, secondaryLabels, this._async_evaluate$_stackTrace$0(), null);
            },
            _async_evaluate$_addExceptionSpan$1$2: function(nodeWithSpan, callback) {
                var error, stackTrace, t1, _$exception, addStackFrame = true;
                try {
                    t1 = callback.call$0();
                    return t1;
                } catch (exception) {
                    t1 = A.unwrapException(exception);
                    if (t1 instanceof A.SassScriptException) {
                        error = t1;
                        stackTrace = A.getTraceFromException(exception);
                        t1 = error.withSpan$1(nodeWithSpan.get$span(nodeWithSpan));
                        A.throwWithTrace(t1.withTrace$1(this._async_evaluate$_stackTrace$1(addStackFrame ? nodeWithSpan.get$span(nodeWithSpan) : null)), error, stackTrace);
                    } else throw exception;
                }
            },
            _async_evaluate$_addExceptionSpan$2: function(nodeWithSpan, callback) {
                return this._async_evaluate$_addExceptionSpan$1$2(nodeWithSpan, callback, type$.dynamic);
            },
            _addExceptionSpanAsync$1$3$addStackFrame: function(nodeWithSpan, callback, addStackFrame, $T) {
                return this._addExceptionSpanAsync$body$_EvaluateVisitor(nodeWithSpan, callback, addStackFrame, $T, $T);
            },
            _addExceptionSpanAsync$1$2: function(nodeWithSpan, callback, $T) {
                return this._addExceptionSpanAsync$1$3$addStackFrame(nodeWithSpan, callback, true, $T);
            },
            _addExceptionSpanAsync$body$_EvaluateVisitor: function(nodeWithSpan, callback, addStackFrame, $T, $async$type) {
                var $async$goto = 0, $async$completer = A._makeAsyncAwaitCompleter($async$type), $async$returnValue, $async$handler = 2, $async$errorStack = [], $async$self = this, error, stackTrace, t1, exception, $async$exception;
                var $async$_addExceptionSpanAsync$1$3$addStackFrame = A._wrapJsFunctionForAsync(function($async$errorCode, $async$result) {
                    if ($async$errorCode === 1) {
                        $async$errorStack.push($async$result);
                        $async$goto = $async$handler;
                    }
                    for(;;)switch($async$goto){
                        case 0:
                            // Function start
                            $async$handler = 4;
                            t1 = callback.call$0();
                            $async$goto = 7;
                            return A._asyncAwait($T._eval$1("Future<0>")._is(t1) ? t1 : A._Future$value(t1, $T), $async$_addExceptionSpanAsync$1$3$addStackFrame);
                        case 7:
                            // returning from await.
                            t1 = $async$result;
                            $async$returnValue = t1;
                            // goto return
                            $async$goto = 1;
                            break;
                        case 4:
                            // catch
                            $async$handler = 3;
                            $async$exception = $async$errorStack.pop();
                            t1 = A.unwrapException($async$exception);
                            if (t1 instanceof A.SassScriptException) {
                                error = t1;
                                stackTrace = A.getTraceFromException($async$exception);
                                t1 = error.withSpan$1(nodeWithSpan.get$span(nodeWithSpan));
                                A.throwWithTrace(t1.withTrace$1($async$self._async_evaluate$_stackTrace$1(addStackFrame ? nodeWithSpan.get$span(nodeWithSpan) : null)), error, stackTrace);
                            } else throw $async$exception;
                            // goto after finally
                            $async$goto = 6;
                            break;
                        case 3:
                            // uncaught
                            // goto rethrow
                            $async$goto = 2;
                            break;
                        case 6:
                        // after finally
                        case 1:
                            // return
                            return A._asyncReturn($async$returnValue, $async$completer);
                        case 2:
                            // rethrow
                            return A._asyncRethrow($async$errorStack.at(-1), $async$completer);
                    }
                });
                return A._asyncStartSync($async$_addExceptionSpanAsync$1$3$addStackFrame, $async$completer);
            },
            _async_evaluate$_addExceptionTrace$1$1: function(callback, $T) {
                return this._addExceptionTrace$body$_EvaluateVisitor(callback, $T, $T);
            },
            _addExceptionTrace$body$_EvaluateVisitor: function(callback, $T, $async$type) {
                var $async$goto = 0, $async$completer = A._makeAsyncAwaitCompleter($async$type), $async$returnValue, $async$handler = 2, $async$errorStack = [], $async$self = this, error, stackTrace, t1, exception, t2, $async$exception;
                var $async$_async_evaluate$_addExceptionTrace$1$1 = A._wrapJsFunctionForAsync(function($async$errorCode, $async$result) {
                    if ($async$errorCode === 1) {
                        $async$errorStack.push($async$result);
                        $async$goto = $async$handler;
                    }
                    for(;;)switch($async$goto){
                        case 0:
                            // Function start
                            $async$handler = 4;
                            t1 = callback.call$0();
                            $async$goto = 7;
                            return A._asyncAwait($T._eval$1("Future<0>")._is(t1) ? t1 : A._Future$value(t1, $T), $async$_async_evaluate$_addExceptionTrace$1$1);
                        case 7:
                            // returning from await.
                            t1 = $async$result;
                            $async$returnValue = t1;
                            // goto return
                            $async$goto = 1;
                            break;
                        case 4:
                            // catch
                            $async$handler = 3;
                            $async$exception = $async$errorStack.pop();
                            t1 = A.unwrapException($async$exception);
                            if (type$.SassRuntimeException._is(t1)) throw $async$exception;
                            else if (t1 instanceof A.SassException) {
                                error = t1;
                                stackTrace = A.getTraceFromException($async$exception);
                                t1 = error;
                                t2 = J.getInterceptor$x(t1);
                                A.throwWithTrace(error.withTrace$1($async$self._async_evaluate$_stackTrace$1(A.SourceSpanException.prototype.get$span.call(t2, t1))), error, stackTrace);
                            } else throw $async$exception;
                            // goto after finally
                            $async$goto = 6;
                            break;
                        case 3:
                            // uncaught
                            // goto rethrow
                            $async$goto = 2;
                            break;
                        case 6:
                        // after finally
                        case 1:
                            // return
                            return A._asyncReturn($async$returnValue, $async$completer);
                        case 2:
                            // rethrow
                            return A._asyncRethrow($async$errorStack.at(-1), $async$completer);
                    }
                });
                return A._asyncStartSync($async$_async_evaluate$_addExceptionTrace$1$1, $async$completer);
            },
            _async_evaluate$_addErrorSpan$1$2: function(nodeWithSpan, callback, $T) {
                return this._addErrorSpan$body$_EvaluateVisitor(nodeWithSpan, callback, $T, $T);
            },
            _addErrorSpan$body$_EvaluateVisitor: function(nodeWithSpan, callback, $T, $async$type) {
                var $async$goto = 0, $async$completer = A._makeAsyncAwaitCompleter($async$type), $async$returnValue, $async$handler = 2, $async$errorStack = [], $async$self = this, error, stackTrace, t1, exception, t2, t3, $async$exception;
                var $async$_async_evaluate$_addErrorSpan$1$2 = A._wrapJsFunctionForAsync(function($async$errorCode, $async$result) {
                    if ($async$errorCode === 1) {
                        $async$errorStack.push($async$result);
                        $async$goto = $async$handler;
                    }
                    for(;;)switch($async$goto){
                        case 0:
                            // Function start
                            $async$handler = 4;
                            $async$goto = 7;
                            return A._asyncAwait(callback.call$0(), $async$_async_evaluate$_addErrorSpan$1$2);
                        case 7:
                            // returning from await.
                            t1 = $async$result;
                            $async$returnValue = t1;
                            // goto return
                            $async$goto = 1;
                            break;
                        case 4:
                            // catch
                            $async$handler = 3;
                            $async$exception = $async$errorStack.pop();
                            t1 = A.unwrapException($async$exception);
                            if (type$.SassRuntimeException._is(t1)) {
                                error = t1;
                                stackTrace = A.getTraceFromException($async$exception);
                                if (!B.JSString_methods.startsWith$1(J.get$span$x(error).get$text(), "@error")) throw $async$exception;
                                t1 = error._span_exception$_message;
                                t2 = nodeWithSpan.get$span(nodeWithSpan);
                                t3 = $async$self._async_evaluate$_stackTrace$0();
                                A.throwWithTrace(new A.SassRuntimeException(t3, B.Set_empty, t1, t2), error, stackTrace);
                            } else throw $async$exception;
                            // goto after finally
                            $async$goto = 6;
                            break;
                        case 3:
                            // uncaught
                            // goto rethrow
                            $async$goto = 2;
                            break;
                        case 6:
                        // after finally
                        case 1:
                            // return
                            return A._asyncReturn($async$returnValue, $async$completer);
                        case 2:
                            // rethrow
                            return A._asyncRethrow($async$errorStack.at(-1), $async$completer);
                    }
                });
                return A._asyncStartSync($async$_async_evaluate$_addErrorSpan$1$2, $async$completer);
            },
            _async_evaluate$_getErrorMessage$1: function(error) {
                var t1, exception;
                if (type$.Error._is(error)) return error.toString$0(0);
                try {
                    t1 = A._asString(J.get$message$x(error));
                    return t1;
                } catch (exception) {
                    t1 = J.toString$0$(error);
                    return t1;
                }
            }
        };
        A._EvaluateVisitor_closure12.prototype = {
            call$1: function($arguments) {
                var module, t2, t1 = J.getInterceptor$asx($arguments), variable = t1.$index($arguments, 0).assertString$1("name");
                t1 = t1.$index($arguments, 1).get$realNull();
                module = t1 == null ? null : t1.assertString$1("module");
                t1 = this.$this._async_evaluate$_environment;
                t2 = A.stringReplaceAllUnchecked(variable._string$_text, "_", "-");
                return t1.globalVariableExists$2$namespace(t2, module == null ? null : module._string$_text) ? B.SassBoolean_true : B.SassBoolean_false;
            },
            $signature: 11
        };
        A._EvaluateVisitor_closure13.prototype = {
            call$1: function($arguments) {
                var variable = J.$index$asx($arguments, 0).assertString$1("name"), t1 = this.$this._async_evaluate$_environment;
                return t1.getVariable$1(A.stringReplaceAllUnchecked(variable._string$_text, "_", "-")) != null ? B.SassBoolean_true : B.SassBoolean_false;
            },
            $signature: 11
        };
        A._EvaluateVisitor_closure14.prototype = {
            call$1: function($arguments) {
                var module, t2, t3, t4, t1 = J.getInterceptor$asx($arguments), variable = t1.$index($arguments, 0).assertString$1("name");
                t1 = t1.$index($arguments, 1).get$realNull();
                module = t1 == null ? null : t1.assertString$1("module");
                t1 = this.$this;
                t2 = t1._async_evaluate$_environment;
                t3 = variable._string$_text;
                t4 = A.stringReplaceAllUnchecked(t3, "_", "-");
                return t2.getFunction$2$namespace(t4, module == null ? null : module._string$_text) != null || t1._async_evaluate$_builtInFunctions.containsKey$1(t3) ? B.SassBoolean_true : B.SassBoolean_false;
            },
            $signature: 11
        };
        A._EvaluateVisitor_closure15.prototype = {
            call$1: function($arguments) {
                var module, t2, t1 = J.getInterceptor$asx($arguments), variable = t1.$index($arguments, 0).assertString$1("name");
                t1 = t1.$index($arguments, 1).get$realNull();
                module = t1 == null ? null : t1.assertString$1("module");
                t1 = this.$this._async_evaluate$_environment;
                t2 = A.stringReplaceAllUnchecked(variable._string$_text, "_", "-");
                return t1.getMixin$2$namespace(t2, module == null ? null : module._string$_text) != null ? B.SassBoolean_true : B.SassBoolean_false;
            },
            $signature: 11
        };
        A._EvaluateVisitor_closure16.prototype = {
            call$1: function($arguments) {
                var t1 = this.$this._async_evaluate$_environment;
                if (!t1._async_environment$_inMixin) throw A.wrapException(A.SassScriptException$(string$.conten, null));
                return t1._async_environment$_content != null ? B.SassBoolean_true : B.SassBoolean_false;
            },
            $signature: 11
        };
        A._EvaluateVisitor_closure17.prototype = {
            call$1: function($arguments) {
                var t2, t3, t4, t1 = J.$index$asx($arguments, 0).assertString$1("module")._string$_text, module = this.$this._async_evaluate$_environment._async_environment$_modules.$index(0, t1);
                if (module == null) throw A.wrapException('There is no module with namespace "' + t1 + '".');
                t1 = type$.Value;
                t2 = A.LinkedHashMap_LinkedHashMap$_empty(t1, t1);
                for(t3 = A.MapExtensions_get_pairs(module.get$variables(), type$.String, t1), t3 = t3.get$iterator(t3); t3.moveNext$0();){
                    t4 = t3.get$current(t3);
                    t2.$indexSet(0, new A.SassString(t4._0, true), t4._1);
                }
                return new A.SassMap(A.ConstantMap_ConstantMap$from(t2, t1, t1));
            },
            $signature: 38
        };
        A._EvaluateVisitor_closure18.prototype = {
            call$1: function($arguments) {
                var t3, t4, t5, t1 = this.$this, t2 = J.$index$asx($arguments, 0).assertString$1("module")._string$_text, module = t1._async_evaluate$_environment._async_environment$_modules.$index(0, t2);
                if (module == null) throw A.wrapException('There is no module with namespace "' + t2 + '".');
                t2 = type$.Value;
                t3 = A.LinkedHashMap_LinkedHashMap$_empty(t2, t2);
                for(t4 = A.MapExtensions_get_pairs(module.get$functions(module), type$.String, type$.AsyncCallable), t4 = t4.get$iterator(t4), t1 = t1._async_evaluate$_compileContext; t4.moveNext$0();){
                    t5 = t4.get$current(t4);
                    t3.$indexSet(0, new A.SassString(t5._0, true), new A.SassFunction(t5._1, t1));
                }
                return new A.SassMap(A.ConstantMap_ConstantMap$from(t3, t2, t2));
            },
            $signature: 38
        };
        A._EvaluateVisitor_closure19.prototype = {
            call$1: function($arguments) {
                var t3, t4, t5, t1 = this.$this, t2 = J.$index$asx($arguments, 0).assertString$1("module")._string$_text, module = t1._async_evaluate$_environment._async_environment$_modules.$index(0, t2);
                if (module == null) throw A.wrapException('There is no module with namespace "' + t2 + '".');
                t2 = type$.Value;
                t3 = A.LinkedHashMap_LinkedHashMap$_empty(t2, t2);
                for(t4 = A.MapExtensions_get_pairs(module.get$mixins(), type$.String, type$.AsyncCallable), t4 = t4.get$iterator(t4), t1 = t1._async_evaluate$_compileContext; t4.moveNext$0();){
                    t5 = t4.get$current(t4);
                    t3.$indexSet(0, new A.SassString(t5._0, true), new A.SassMixin(t5._1, t1));
                }
                return new A.SassMap(A.ConstantMap_ConstantMap$from(t3, t2, t2));
            },
            $signature: 38
        };
        A._EvaluateVisitor_closure20.prototype = {
            call$1: function($arguments) {
                var module, t2, callable, t1 = J.getInterceptor$asx($arguments), $name = t1.$index($arguments, 0).assertString$1("name"), css = t1.$index($arguments, 1).get$isTruthy();
                t1 = t1.$index($arguments, 2).get$realNull();
                module = t1 == null ? null : t1.assertString$1("module");
                if (css) {
                    if (module != null) throw A.wrapException(string$.x24css_a);
                    return new A.SassFunction(new A.PlainCssCallable($name._string$_text), this.$this._async_evaluate$_compileContext);
                }
                t1 = this.$this;
                t2 = t1._async_evaluate$_callableNode;
                t2.toString;
                callable = t1._async_evaluate$_addExceptionSpan$2(t2, new A._EvaluateVisitor__closure6(t1, $name, module));
                if (callable == null) throw A.wrapException("Function not found: " + $name.toString$0(0));
                return new A.SassFunction(callable, t1._async_evaluate$_compileContext);
            },
            $signature: 167
        };
        A._EvaluateVisitor__closure6.prototype = {
            call$0: function() {
                var local, normalizedName = A.stringReplaceAllUnchecked(this.name._string$_text, "_", "-"), t1 = this.module, namespace = t1 == null ? null : t1._string$_text;
                t1 = this.$this;
                local = t1._async_evaluate$_environment.getFunction$2$namespace(normalizedName, namespace);
                if (local != null || namespace != null) return local;
                return t1._async_evaluate$_builtInFunctions.$index(0, normalizedName);
            },
            $signature: 103
        };
        A._EvaluateVisitor_closure21.prototype = {
            call$1: function($arguments) {
                var module, t2, callable, t1 = J.getInterceptor$asx($arguments), $name = t1.$index($arguments, 0).assertString$1("name");
                t1 = t1.$index($arguments, 1).get$realNull();
                module = t1 == null ? null : t1.assertString$1("module");
                t1 = this.$this;
                t2 = t1._async_evaluate$_callableNode;
                t2.toString;
                callable = t1._async_evaluate$_addExceptionSpan$2(t2, new A._EvaluateVisitor__closure5(t1, $name, module));
                if (callable == null) throw A.wrapException("Mixin not found: " + $name.toString$0(0));
                return new A.SassMixin(callable, t1._async_evaluate$_compileContext);
            },
            $signature: 168
        };
        A._EvaluateVisitor__closure5.prototype = {
            call$0: function() {
                var t1 = this.$this._async_evaluate$_environment, t2 = A.stringReplaceAllUnchecked(this.name._string$_text, "_", "-"), t3 = this.module;
                return t1.getMixin$2$namespace(t2, t3 == null ? null : t3._string$_text);
            },
            $signature: 103
        };
        A._EvaluateVisitor_closure22.prototype = {
            call$1: function($arguments) {
                return this.$call$body$_EvaluateVisitor_closure1($arguments);
            },
            $call$body$_EvaluateVisitor_closure1: function($arguments) {
                var $async$goto = 0, $async$completer = A._makeAsyncAwaitCompleter(type$.Value), $async$returnValue, $async$self = this, callableNode, t2, t3, t4, t5, t6, t7, invocation, t1, $function, args;
                var $async$call$1 = A._wrapJsFunctionForAsync(function($async$errorCode, $async$result) {
                    if ($async$errorCode === 1) return A._asyncRethrow($async$result, $async$completer);
                    for(;;)switch($async$goto){
                        case 0:
                            // Function start
                            t1 = J.getInterceptor$asx($arguments);
                            $function = t1.$index($arguments, 0);
                            args = type$.SassArgumentList._as(t1.$index($arguments, 1));
                            t1 = $async$self.$this;
                            callableNode = t1._async_evaluate$_callableNode;
                            t2 = callableNode.get$span(callableNode);
                            t3 = callableNode.get$span(callableNode);
                            args._wereKeywordsAccessed = true;
                            t4 = args._keywords;
                            if (t4.get$isEmpty(t4)) t4 = null;
                            else {
                                t5 = type$.Value;
                                t6 = A.LinkedHashMap_LinkedHashMap$_empty(t5, t5);
                                for(args._wereKeywordsAccessed = true, t4 = A.MapExtensions_get_pairs(t4, type$.String, t5), t4 = t4.get$iterator(t4); t4.moveNext$0();){
                                    t7 = t4.get$current(t4);
                                    t6.$indexSet(0, new A.SassString(t7._0, false), t7._1);
                                }
                                t4 = new A.ValueExpression(new A.SassMap(A.ConstantMap_ConstantMap$from(t6, t5, t5)), callableNode.get$span(callableNode));
                            }
                            invocation = A.ArgumentList$(B.List_empty9, B.Map_empty4, B.Map_empty5, t2, t4, new A.ValueExpression(args, t3));
                            $async$goto = $function instanceof A.SassString ? 3 : 4;
                            break;
                        case 3:
                            // then
                            A.warnForDeprecation(string$.Passina + $function.toString$0(0) + "))", B.Deprecation_c4i);
                            callableNode = t1._async_evaluate$_callableNode;
                            t2 = $function._string$_text;
                            t3 = callableNode.get$span(callableNode);
                            t1 = t1.visitFunctionExpression$1(0, new A.FunctionExpression(null, A.stringReplaceAllUnchecked(t2, "_", "-"), t2, invocation, t3));
                            $async$goto = 5;
                            return A._asyncAwait(type$.Future_Value._is(t1) ? t1 : A._Future$value(t1, type$.Value), $async$call$1);
                        case 5:
                            // returning from await.
                            $async$returnValue = $async$result;
                            // goto return
                            $async$goto = 1;
                            break;
                        case 4:
                            // join
                            t2 = $function.assertFunction$1("function").assertCompileContext$1(t1._async_evaluate$_compileContext);
                            t3 = t1._async_evaluate$_callableNode;
                            t3.toString;
                            $async$goto = 6;
                            return A._asyncAwait(t1._async_evaluate$_runFunctionCallable$3(invocation, t2.callable, t3), $async$call$1);
                        case 6:
                            // returning from await.
                            t3 = $async$result;
                            $async$returnValue = t3;
                            // goto return
                            $async$goto = 1;
                            break;
                        case 1:
                            // return
                            return A._asyncReturn($async$returnValue, $async$completer);
                    }
                });
                return A._asyncStartSync($async$call$1, $async$completer);
            },
            $signature: 190
        };
        A._EvaluateVisitor_closure23.prototype = {
            call$1: function($arguments) {
                return this.$call$body$_EvaluateVisitor_closure0($arguments);
            },
            $call$body$_EvaluateVisitor_closure0: function($arguments) {
                var $async$goto = 0, $async$completer = A._makeAsyncAwaitCompleter(type$.void), $async$self = this, withMap, t2, t3, values, span, configuration, t1, url;
                var $async$call$1 = A._wrapJsFunctionForAsync(function($async$errorCode, $async$result) {
                    if ($async$errorCode === 1) return A._asyncRethrow($async$result, $async$completer);
                    for(;;)switch($async$goto){
                        case 0:
                            // Function start
                            t1 = J.getInterceptor$asx($arguments);
                            url = A.Uri_parse(t1.$index($arguments, 0).assertString$1("url")._string$_text);
                            t1 = t1.$index($arguments, 1).get$realNull();
                            withMap = t1 == null ? null : t1.assertMap$1("with")._map$_contents;
                            t1 = $async$self.$this;
                            t2 = t1._async_evaluate$_callableNode;
                            t2.toString;
                            if (withMap != null) {
                                t3 = {};
                                values = A.LinkedHashMap_LinkedHashMap$_empty(type$.String, type$.ConfiguredValue);
                                span = t2.get$span(t2);
                                t3.privateDeprecation = false;
                                withMap.forEach$1(0, new A._EvaluateVisitor__closure3(t3, values, span, t2));
                                configuration = new A.ExplicitConfiguration(t2, values, null);
                            } else configuration = B.Configuration_Map_empty_null;
                            t3 = t2.get$span(t2);
                            $async$goto = 2;
                            return A._asyncAwait(t1._async_evaluate$_loadModule$7$baseUrl$configuration$namesInErrors(url, "load-css()", t2, new A._EvaluateVisitor__closure4(t1), t3.get$sourceUrl(t3), configuration, true), $async$call$1);
                        case 2:
                            // returning from await.
                            t1._async_evaluate$_assertConfigurationIsEmpty$2$nameInError(configuration, true);
                            // implicit return
                            return A._asyncReturn(null, $async$completer);
                    }
                });
                return A._asyncStartSync($async$call$1, $async$completer);
            },
            $signature: 169
        };
        A._EvaluateVisitor__closure3.prototype = {
            call$2: function(variable, value) {
                var _this = this, t1 = variable.assertString$1("with key"), $name = A.stringReplaceAllUnchecked(t1._string$_text, "_", "-");
                t1 = _this.values;
                if (t1.containsKey$1($name)) throw A.wrapException("The variable $" + $name + " was configured twice.");
                else if (B.JSString_methods.startsWith$1($name, "-") && !_this._box_0.privateDeprecation) {
                    _this._box_0.privateDeprecation = true;
                    A.warnForDeprecation("Configuring private variables (such as $" + $name + string$.x29x20is_dT, B.Deprecation_mXO);
                }
                t1.$indexSet(0, $name, new A.ConfiguredValue(value, _this.span, _this.callableNode));
            },
            $signature: 99
        };
        A._EvaluateVisitor__closure4.prototype = {
            call$2: function(module, _) {
                var t1 = this.$this;
                return t1._async_evaluate$_combineCss$2$clone(module, true).accept$1(t1);
            },
            $signature: 363
        };
        A._EvaluateVisitor_closure24.prototype = {
            call$1: function($arguments) {
                return this.$call$body$_EvaluateVisitor_closure($arguments);
            },
            $call$body$_EvaluateVisitor_closure: function($arguments) {
                var $async$goto = 0, $async$completer = A._makeAsyncAwaitCompleter(type$.void), $async$self = this, callableNode, invocation, t1, mixin, args;
                var $async$call$1 = A._wrapJsFunctionForAsync(function($async$errorCode, $async$result) {
                    if ($async$errorCode === 1) return A._asyncRethrow($async$result, $async$completer);
                    for(;;)switch($async$goto){
                        case 0:
                            // Function start
                            t1 = J.getInterceptor$asx($arguments);
                            mixin = t1.$index($arguments, 0);
                            args = type$.SassArgumentList._as(t1.$index($arguments, 1));
                            t1 = $async$self.$this;
                            callableNode = t1._async_evaluate$_callableNode;
                            invocation = A.ArgumentList$(B.List_empty9, B.Map_empty4, B.Map_empty5, callableNode.get$span(callableNode), null, new A.ValueExpression(args, callableNode.get$span(callableNode)));
                            $async$goto = 2;
                            return A._asyncAwait(t1._async_evaluate$_applyMixin$5(mixin.assertMixin$1("mixin").assertCompileContext$1(t1._async_evaluate$_compileContext).callable, t1._async_evaluate$_environment._async_environment$_content, invocation, callableNode, callableNode), $async$call$1);
                        case 2:
                            // returning from await.
                            // implicit return
                            return A._asyncReturn(null, $async$completer);
                    }
                });
                return A._asyncStartSync($async$call$1, $async$completer);
            },
            $signature: 169
        };
        A._EvaluateVisitor_run_closure0.prototype = {
            call$0: function() {
                var $async$goto = 0, $async$completer = A._makeAsyncAwaitCompleter(type$.Record_2_Set_Uri_loadedUrls_and_CssStylesheet_stylesheet), $async$returnValue, $async$self = this, module, t1, t2, _0_0, url;
                var $async$call$0 = A._wrapJsFunctionForAsync(function($async$errorCode, $async$result) {
                    if ($async$errorCode === 1) return A._asyncRethrow($async$result, $async$completer);
                    for(;;)switch($async$goto){
                        case 0:
                            // Function start
                            t1 = $async$self.node;
                            t2 = t1.span;
                            _0_0 = t2.get$sourceUrl(t2);
                            url = null;
                            if (_0_0 != null) {
                                url = _0_0;
                                t2 = $async$self.$this;
                                t2._async_evaluate$_activeModules.$indexSet(0, url, null);
                                t2._async_evaluate$_loadedUrls.add$1(0, url);
                            }
                            t2 = $async$self.$this;
                            $async$goto = 3;
                            return A._asyncAwait(t2._async_evaluate$_addExceptionTrace$1$1(new A._EvaluateVisitor_run__closure0(t2, $async$self.importer, t1), type$.Module_AsyncCallable), $async$call$0);
                        case 3:
                            // returning from await.
                            module = $async$result;
                            $async$returnValue = new A._Record_2_loadedUrls_stylesheet(t2._async_evaluate$_loadedUrls, t2._async_evaluate$_combineCss$1(module));
                            // goto return
                            $async$goto = 1;
                            break;
                        case 1:
                            // return
                            return A._asyncReturn($async$returnValue, $async$completer);
                    }
                });
                return A._asyncStartSync($async$call$0, $async$completer);
            },
            $signature: 365
        };
        A._EvaluateVisitor_run__closure0.prototype = {
            call$0: function() {
                return this.$this._async_evaluate$_execute$2(this.importer, this.node);
            },
            $signature: 366
        };
        A._EvaluateVisitor__loadModule_closure1.prototype = {
            call$0: function() {
                return this.callback.call$2(this._box_0.builtInModule, false);
            },
            $signature: 0
        };
        A._EvaluateVisitor__loadModule_closure2.prototype = {
            call$0: function() {
                return this.$call$body$_EvaluateVisitor__loadModule_closure();
            },
            $call$body$_EvaluateVisitor__loadModule_closure: function() {
                var $async$goto = 0, $async$completer = A._makeAsyncAwaitCompleter(type$.Null), $async$handler = 1, $async$errorStack = [], $async$next = [], $async$self = this, canonicalUrl, oldInDependency, isDependency, t4, message, t1, stylesheet, importer, t2, t3, _1_0, $async$temp1;
                var $async$call$0 = A._wrapJsFunctionForAsync(function($async$errorCode, $async$result) {
                    if ($async$errorCode === 1) {
                        $async$errorStack.push($async$result);
                        $async$goto = $async$handler;
                    }
                    for(;;)switch($async$goto){
                        case 0:
                            // Function start
                            t1 = {};
                            stylesheet = null;
                            importer = null;
                            t2 = $async$self.$this;
                            t3 = $async$self.nodeWithSpan;
                            $async$goto = 2;
                            return A._asyncAwait(t2._async_evaluate$_loadStylesheet$3$baseUrl($async$self.url.toString$0(0), t3.get$span(t3), $async$self.baseUrl), $async$call$0);
                        case 2:
                            // returning from await.
                            _1_0 = $async$result;
                            stylesheet = _1_0._0;
                            importer = _1_0._1;
                            isDependency = _1_0._2;
                            t4 = stylesheet.span;
                            canonicalUrl = t4.get$sourceUrl(t4);
                            if (canonicalUrl != null) {
                                t4 = t2._async_evaluate$_activeModules;
                                if (t4.containsKey$1(canonicalUrl)) {
                                    message = $async$self.namesInErrors ? "Module loop: " + $.$get$context().prettyUri$1(canonicalUrl) + " is already being loaded." : string$.Modulel;
                                    t1 = A.NullableExtension_andThen(t4.$index(0, canonicalUrl), new A._EvaluateVisitor__loadModule__closure1(t2, message));
                                    throw A.wrapException(t1 == null ? t2._async_evaluate$_exception$1(message) : t1);
                                } else t4.$indexSet(0, canonicalUrl, t3);
                            }
                            t4 = t2._async_evaluate$_modules.containsKey$1(canonicalUrl);
                            oldInDependency = t2._async_evaluate$_inDependency;
                            t2._async_evaluate$_inDependency = isDependency;
                            t1.module = null;
                            $async$handler = 3;
                            $async$temp1 = t1;
                            $async$goto = 6;
                            return A._asyncAwait(t2._async_evaluate$_execute$5$configuration$namesInErrors$nodeWithSpan(importer, stylesheet, $async$self.configuration, $async$self.namesInErrors, t3), $async$call$0);
                        case 6:
                            // returning from await.
                            $async$temp1.module = $async$result;
                            $async$next.push(5);
                            // goto finally
                            $async$goto = 4;
                            break;
                        case 3:
                            // uncaught
                            $async$next = [
                                1
                            ];
                        case 4:
                            // finally
                            $async$handler = 1;
                            t2._async_evaluate$_activeModules.remove$1(0, canonicalUrl);
                            t2._async_evaluate$_inDependency = oldInDependency;
                            // goto the next finally handler
                            $async$goto = $async$next.pop();
                            break;
                        case 5:
                            // after finally
                            $async$goto = 7;
                            return A._asyncAwait(t2._addExceptionSpanAsync$1$3$addStackFrame(t3, new A._EvaluateVisitor__loadModule__closure2(t1, $async$self.callback, !t4), false, type$.void), $async$call$0);
                        case 7:
                            // returning from await.
                            // implicit return
                            return A._asyncReturn(null, $async$completer);
                        case 1:
                            // rethrow
                            return A._asyncRethrow($async$errorStack.at(-1), $async$completer);
                    }
                });
                return A._asyncStartSync($async$call$0, $async$completer);
            },
            $signature: 2
        };
        A._EvaluateVisitor__loadModule__closure1.prototype = {
            call$1: function(previousLoad) {
                return this.$this._async_evaluate$_multiSpanException$3(this.message, "new load", A.LinkedHashMap_LinkedHashMap$_literal([
                    previousLoad.get$span(previousLoad),
                    "original load"
                ], type$.FileSpan, type$.String));
            },
            $signature: 111
        };
        A._EvaluateVisitor__loadModule__closure2.prototype = {
            call$0: function() {
                return this.callback.call$2(this._box_1.module, this.firstLoad);
            },
            $signature: 0
        };
        A._EvaluateVisitor__execute_closure0.prototype = {
            call$0: function() {
                var $async$goto = 0, $async$completer = A._makeAsyncAwaitCompleter(type$.Null), $async$self = this, t3, t4, t5, t6, t1, oldImporter, oldStylesheet, oldRoot, oldPreModuleComments, oldParent, oldEndOfImports, oldOutOfOrderImports, oldExtensionStore, t2, oldStyleRule, oldMediaQueries, oldDeclarationName, oldInUnknownAtRule, oldInKeyframes, oldConfiguration;
                var $async$call$0 = A._wrapJsFunctionForAsync(function($async$errorCode, $async$result) {
                    if ($async$errorCode === 1) return A._asyncRethrow($async$result, $async$completer);
                    for(;;)switch($async$goto){
                        case 0:
                            // Function start
                            t1 = $async$self.$this;
                            oldImporter = t1._async_evaluate$_importer;
                            oldStylesheet = t1._async_evaluate$__stylesheet;
                            oldRoot = t1._async_evaluate$__root;
                            oldPreModuleComments = t1._async_evaluate$_preModuleComments;
                            oldParent = t1._async_evaluate$__parent;
                            oldEndOfImports = t1._async_evaluate$__endOfImports;
                            oldOutOfOrderImports = t1._async_evaluate$_outOfOrderImports;
                            oldExtensionStore = t1._async_evaluate$__extensionStore;
                            t2 = t1._async_evaluate$_atRootExcludingStyleRule;
                            oldStyleRule = t2 ? null : t1._async_evaluate$_styleRuleIgnoringAtRoot;
                            oldMediaQueries = t1._async_evaluate$_mediaQueries;
                            oldDeclarationName = t1._async_evaluate$_declarationName;
                            oldInUnknownAtRule = t1._async_evaluate$_inUnknownAtRule;
                            oldInKeyframes = t1._async_evaluate$_inKeyframes;
                            oldConfiguration = t1._async_evaluate$_configuration;
                            t1._async_evaluate$_importer = $async$self.importer;
                            t3 = t1._async_evaluate$__stylesheet = $async$self.stylesheet;
                            t4 = t3.span;
                            t5 = t1._async_evaluate$__parent = t1._async_evaluate$__root = A.ModifiableCssStylesheet$(t4);
                            t1._async_evaluate$__endOfImports = 0;
                            t1._async_evaluate$_outOfOrderImports = null;
                            t1._async_evaluate$__extensionStore = $async$self.extensionStore;
                            t1._async_evaluate$_declarationName = t1._async_evaluate$_mediaQueries = t1._async_evaluate$_styleRuleIgnoringAtRoot = null;
                            t1._async_evaluate$_inKeyframes = t1._async_evaluate$_atRootExcludingStyleRule = t1._async_evaluate$_inUnknownAtRule = false;
                            t6 = $async$self.configuration;
                            if (t6 != null) t1._async_evaluate$_configuration = t6;
                            $async$goto = 2;
                            return A._asyncAwait(t1.visitStylesheet$1(0, t3), $async$call$0);
                        case 2:
                            // returning from await.
                            t3 = t1._async_evaluate$_outOfOrderImports == null ? t5 : new A.CssStylesheet(new A.UnmodifiableListView(t1._async_evaluate$_addOutOfOrderImports$0(), type$.UnmodifiableListView_CssNode), t4);
                            $async$self.css.__late_helper$_value = t3;
                            $async$self.preModuleComments.__late_helper$_value = t1._async_evaluate$_preModuleComments;
                            t1._async_evaluate$_importer = oldImporter;
                            t1._async_evaluate$__stylesheet = oldStylesheet;
                            t1._async_evaluate$__root = oldRoot;
                            t1._async_evaluate$_preModuleComments = oldPreModuleComments;
                            t1._async_evaluate$__parent = oldParent;
                            t1._async_evaluate$__endOfImports = oldEndOfImports;
                            t1._async_evaluate$_outOfOrderImports = oldOutOfOrderImports;
                            t1._async_evaluate$__extensionStore = oldExtensionStore;
                            t1._async_evaluate$_styleRuleIgnoringAtRoot = oldStyleRule;
                            t1._async_evaluate$_mediaQueries = oldMediaQueries;
                            t1._async_evaluate$_declarationName = oldDeclarationName;
                            t1._async_evaluate$_inUnknownAtRule = oldInUnknownAtRule;
                            t1._async_evaluate$_atRootExcludingStyleRule = t2;
                            t1._async_evaluate$_inKeyframes = oldInKeyframes;
                            t1._async_evaluate$_configuration = oldConfiguration;
                            // implicit return
                            return A._asyncReturn(null, $async$completer);
                    }
                });
                return A._asyncStartSync($async$call$0, $async$completer);
            },
            $signature: 2
        };
        A._EvaluateVisitor__combineCss_closure1.prototype = {
            call$1: function(module) {
                return module.get$transitivelyContainsCss();
            },
            $signature: 102
        };
        A._EvaluateVisitor__combineCss_closure2.prototype = {
            call$1: function(target) {
                return !this.selectors.contains$1(0, target);
            },
            $signature: 14
        };
        A._EvaluateVisitor__combineCss_visitModule0.prototype = {
            call$1: function(module) {
                var t1, t2, t3, t4, _i, upstream, _1_0, statements, index, _this = this;
                if (!_this.seen.add$1(0, module)) return;
                if (_this.clone) module = module.cloneCss$0();
                for(t1 = module.get$upstream(), t2 = t1.length, t3 = _this.css, t4 = _this.imports, _i = 0; _i < t1.length; t1.length === t2 || (0, A.throwConcurrentModificationError)(t1), ++_i){
                    upstream = t1[_i];
                    if (upstream.get$transitivelyContainsCss()) {
                        _1_0 = module.get$preModuleComments().$index(0, upstream);
                        if (_1_0 != null) B.JSArray_methods.addAll$1(t3.length === 0 ? t4 : t3, _1_0);
                        _this.call$1(upstream);
                    }
                }
                _this.sorted.addFirst$1(module);
                t1 = module.get$css(module);
                statements = t1.get$children(t1);
                index = _this.$this._async_evaluate$_indexAfterImports$1(statements);
                t1 = J.getInterceptor$ax(statements);
                B.JSArray_methods.addAll$1(t4, t1.getRange$2(statements, 0, index));
                B.JSArray_methods.addAll$1(t3, t1.getRange$2(statements, index, t1.get$length(statements)));
            },
            $signature: 374
        };
        A._EvaluateVisitor__extendModules_closure1.prototype = {
            call$1: function(target) {
                return !this.originalSelectors.contains$1(0, target);
            },
            $signature: 14
        };
        A._EvaluateVisitor__extendModules_closure2.prototype = {
            call$0: function() {
                return A._setArrayType([], type$.JSArray_ExtensionStore);
            },
            $signature: 170
        };
        A._EvaluateVisitor_visitAtRootRule_closure1.prototype = {
            call$0: function() {
                var $async$goto = 0, $async$completer = A._makeAsyncAwaitCompleter(type$.Null), $async$self = this, t1, t2, t3, _i;
                var $async$call$0 = A._wrapJsFunctionForAsync(function($async$errorCode, $async$result) {
                    if ($async$errorCode === 1) return A._asyncRethrow($async$result, $async$completer);
                    for(;;)switch($async$goto){
                        case 0:
                            // Function start
                            t1 = $async$self.node.children, t2 = t1.length, t3 = $async$self.$this, _i = 0;
                        case 2:
                            // for condition
                            if (!(_i < t2)) {
                                // goto after for
                                $async$goto = 4;
                                break;
                            }
                            $async$goto = 5;
                            return A._asyncAwait(t1[_i].accept$1(t3), $async$call$0);
                        case 5:
                        // returning from await.
                        case 3:
                            // for update
                            ++_i;
                            // goto for condition
                            $async$goto = 2;
                            break;
                        case 4:
                            // after for
                            // implicit return
                            return A._asyncReturn(null, $async$completer);
                    }
                });
                return A._asyncStartSync($async$call$0, $async$completer);
            },
            $signature: 2
        };
        A._EvaluateVisitor_visitAtRootRule_closure2.prototype = {
            call$0: function() {
                var $async$goto = 0, $async$completer = A._makeAsyncAwaitCompleter(type$.void), $async$self = this, t1, t2, t3, _i;
                var $async$call$0 = A._wrapJsFunctionForAsync(function($async$errorCode, $async$result) {
                    if ($async$errorCode === 1) return A._asyncRethrow($async$result, $async$completer);
                    for(;;)switch($async$goto){
                        case 0:
                            // Function start
                            t1 = $async$self.node.children, t2 = t1.length, t3 = $async$self.$this, _i = 0;
                        case 2:
                            // for condition
                            if (!(_i < t2)) {
                                // goto after for
                                $async$goto = 4;
                                break;
                            }
                            $async$goto = 5;
                            return A._asyncAwait(t1[_i].accept$1(t3), $async$call$0);
                        case 5:
                        // returning from await.
                        case 3:
                            // for update
                            ++_i;
                            // goto for condition
                            $async$goto = 2;
                            break;
                        case 4:
                            // after for
                            // implicit return
                            return A._asyncReturn(null, $async$completer);
                    }
                });
                return A._asyncStartSync($async$call$0, $async$completer);
            },
            $signature: 32
        };
        A._EvaluateVisitor__scopeForAtRoot_closure5.prototype = {
            call$1: function(callback) {
                var $async$goto = 0, $async$completer = A._makeAsyncAwaitCompleter(type$.Null), $async$self = this, t1, oldParent;
                var $async$call$1 = A._wrapJsFunctionForAsync(function($async$errorCode, $async$result) {
                    if ($async$errorCode === 1) return A._asyncRethrow($async$result, $async$completer);
                    for(;;)switch($async$goto){
                        case 0:
                            // Function start
                            t1 = $async$self.$this;
                            oldParent = t1._async_evaluate$_assertInModule$2(t1._async_evaluate$__parent, "__parent");
                            t1._async_evaluate$__parent = $async$self.newParent;
                            $async$goto = 2;
                            return A._asyncAwait(t1._async_evaluate$_environment.scope$1$2$when(callback, $async$self.node.hasDeclarations, type$.void), $async$call$1);
                        case 2:
                            // returning from await.
                            t1._async_evaluate$__parent = oldParent;
                            // implicit return
                            return A._asyncReturn(null, $async$completer);
                    }
                });
                return A._asyncStartSync($async$call$1, $async$completer);
            },
            $signature: 40
        };
        A._EvaluateVisitor__scopeForAtRoot_closure6.prototype = {
            call$1: function(callback) {
                var $async$goto = 0, $async$completer = A._makeAsyncAwaitCompleter(type$.Null), $async$self = this, t1, oldAtRootExcludingStyleRule;
                var $async$call$1 = A._wrapJsFunctionForAsync(function($async$errorCode, $async$result) {
                    if ($async$errorCode === 1) return A._asyncRethrow($async$result, $async$completer);
                    for(;;)switch($async$goto){
                        case 0:
                            // Function start
                            t1 = $async$self.$this;
                            oldAtRootExcludingStyleRule = t1._async_evaluate$_atRootExcludingStyleRule;
                            t1._async_evaluate$_atRootExcludingStyleRule = true;
                            $async$goto = 2;
                            return A._asyncAwait($async$self.innerScope.call$1(callback), $async$call$1);
                        case 2:
                            // returning from await.
                            t1._async_evaluate$_atRootExcludingStyleRule = oldAtRootExcludingStyleRule;
                            // implicit return
                            return A._asyncReturn(null, $async$completer);
                    }
                });
                return A._asyncStartSync($async$call$1, $async$completer);
            },
            $signature: 40
        };
        A._EvaluateVisitor__scopeForAtRoot_closure7.prototype = {
            call$1: function(callback) {
                return this.$this._async_evaluate$_withMediaQueries$1$3(null, null, new A._EvaluateVisitor__scopeForAtRoot__closure0(this.innerScope, callback), type$.Null);
            },
            $signature: 40
        };
        A._EvaluateVisitor__scopeForAtRoot__closure0.prototype = {
            call$0: function() {
                return this.innerScope.call$1(this.callback);
            },
            $signature: 2
        };
        A._EvaluateVisitor__scopeForAtRoot_closure8.prototype = {
            call$1: function(callback) {
                var $async$goto = 0, $async$completer = A._makeAsyncAwaitCompleter(type$.Null), $async$self = this, t1, wasInKeyframes;
                var $async$call$1 = A._wrapJsFunctionForAsync(function($async$errorCode, $async$result) {
                    if ($async$errorCode === 1) return A._asyncRethrow($async$result, $async$completer);
                    for(;;)switch($async$goto){
                        case 0:
                            // Function start
                            t1 = $async$self.$this;
                            wasInKeyframes = t1._async_evaluate$_inKeyframes;
                            t1._async_evaluate$_inKeyframes = false;
                            $async$goto = 2;
                            return A._asyncAwait($async$self.innerScope.call$1(callback), $async$call$1);
                        case 2:
                            // returning from await.
                            t1._async_evaluate$_inKeyframes = wasInKeyframes;
                            // implicit return
                            return A._asyncReturn(null, $async$completer);
                    }
                });
                return A._asyncStartSync($async$call$1, $async$completer);
            },
            $signature: 40
        };
        A._EvaluateVisitor__scopeForAtRoot_closure9.prototype = {
            call$1: function($parent) {
                return $parent instanceof A.ModifiableCssAtRule;
            },
            $signature: 172
        };
        A._EvaluateVisitor__scopeForAtRoot_closure10.prototype = {
            call$1: function(callback) {
                var $async$goto = 0, $async$completer = A._makeAsyncAwaitCompleter(type$.Null), $async$self = this, t1, wasInUnknownAtRule;
                var $async$call$1 = A._wrapJsFunctionForAsync(function($async$errorCode, $async$result) {
                    if ($async$errorCode === 1) return A._asyncRethrow($async$result, $async$completer);
                    for(;;)switch($async$goto){
                        case 0:
                            // Function start
                            t1 = $async$self.$this;
                            wasInUnknownAtRule = t1._async_evaluate$_inUnknownAtRule;
                            t1._async_evaluate$_inUnknownAtRule = false;
                            $async$goto = 2;
                            return A._asyncAwait($async$self.innerScope.call$1(callback), $async$call$1);
                        case 2:
                            // returning from await.
                            t1._async_evaluate$_inUnknownAtRule = wasInUnknownAtRule;
                            // implicit return
                            return A._asyncReturn(null, $async$completer);
                    }
                });
                return A._asyncStartSync($async$call$1, $async$completer);
            },
            $signature: 40
        };
        A._EvaluateVisitor_visitContentRule_closure0.prototype = {
            call$0: function() {
                var $async$goto = 0, $async$completer = A._makeAsyncAwaitCompleter(type$.Null), $async$returnValue, $async$self = this, t1, t2, t3, _i;
                var $async$call$0 = A._wrapJsFunctionForAsync(function($async$errorCode, $async$result) {
                    if ($async$errorCode === 1) return A._asyncRethrow($async$result, $async$completer);
                    for(;;)switch($async$goto){
                        case 0:
                            // Function start
                            t1 = $async$self.content.declaration.children, t2 = t1.length, t3 = $async$self.$this, _i = 0;
                        case 3:
                            // for condition
                            if (!(_i < t2)) {
                                // goto after for
                                $async$goto = 5;
                                break;
                            }
                            $async$goto = 6;
                            return A._asyncAwait(t1[_i].accept$1(t3), $async$call$0);
                        case 6:
                        // returning from await.
                        case 4:
                            // for update
                            ++_i;
                            // goto for condition
                            $async$goto = 3;
                            break;
                        case 5:
                            // after for
                            $async$returnValue = null;
                            // goto return
                            $async$goto = 1;
                            break;
                        case 1:
                            // return
                            return A._asyncReturn($async$returnValue, $async$completer);
                    }
                });
                return A._asyncStartSync($async$call$0, $async$completer);
            },
            $signature: 2
        };
        A._EvaluateVisitor_visitDeclaration_closure0.prototype = {
            call$0: function() {
                var $async$goto = 0, $async$completer = A._makeAsyncAwaitCompleter(type$.Null), $async$self = this, t1, t2, t3, _i;
                var $async$call$0 = A._wrapJsFunctionForAsync(function($async$errorCode, $async$result) {
                    if ($async$errorCode === 1) return A._asyncRethrow($async$result, $async$completer);
                    for(;;)switch($async$goto){
                        case 0:
                            // Function start
                            t1 = $async$self._box_0.children, t2 = t1.length, t3 = $async$self.$this, _i = 0;
                        case 2:
                            // for condition
                            if (!(_i < t2)) {
                                // goto after for
                                $async$goto = 4;
                                break;
                            }
                            $async$goto = 5;
                            return A._asyncAwait(t1[_i].accept$1(t3), $async$call$0);
                        case 5:
                        // returning from await.
                        case 3:
                            // for update
                            ++_i;
                            // goto for condition
                            $async$goto = 2;
                            break;
                        case 4:
                            // after for
                            // implicit return
                            return A._asyncReturn(null, $async$completer);
                    }
                });
                return A._asyncStartSync($async$call$0, $async$completer);
            },
            $signature: 2
        };
        A._EvaluateVisitor_visitEachRule_closure2.prototype = {
            call$1: function(value) {
                var t1 = this.$this, t2 = this.nodeWithSpan;
                return t1._async_evaluate$_environment.setLocalVariable$3(this._box_0.variable, t1._async_evaluate$_withoutSlash$2(value, t2), t2);
            },
            $signature: 58
        };
        A._EvaluateVisitor_visitEachRule_closure3.prototype = {
            call$1: function(value) {
                return this.$this._async_evaluate$_setMultipleVariables$3(this._box_1.variables, value, this.nodeWithSpan);
            },
            $signature: 58
        };
        A._EvaluateVisitor_visitEachRule_closure4.prototype = {
            call$0: function() {
                var _this = this, t1 = _this.$this;
                return t1._async_evaluate$_handleReturn$2(_this.list.get$asList(), new A._EvaluateVisitor_visitEachRule__closure0(t1, _this.setVariables, _this.node));
            },
            $signature: 69
        };
        A._EvaluateVisitor_visitEachRule__closure0.prototype = {
            call$1: function(element) {
                var t1;
                this.setVariables.call$1(element);
                t1 = this.$this;
                return t1._async_evaluate$_handleReturn$2(this.node.children, new A._EvaluateVisitor_visitEachRule___closure0(t1));
            },
            $signature: 418
        };
        A._EvaluateVisitor_visitEachRule___closure0.prototype = {
            call$1: function(child) {
                return child.accept$1(this.$this);
            },
            $signature: 87
        };
        A._EvaluateVisitor_visitAtRule_closure3.prototype = {
            call$1: function(value) {
                return this.$this._async_evaluate$_interpolationToValue$3$trim$warnForColor(value, true, true);
            },
            $signature: 348
        };
        A._EvaluateVisitor_visitAtRule_closure4.prototype = {
            call$0: function() {
                var $async$goto = 0, $async$completer = A._makeAsyncAwaitCompleter(type$.Null), $async$self = this, t1, t2, t3, _i;
                var $async$call$0 = A._wrapJsFunctionForAsync(function($async$errorCode, $async$result) {
                    if ($async$errorCode === 1) return A._asyncRethrow($async$result, $async$completer);
                    for(;;)switch($async$goto){
                        case 0:
                            // Function start
                            t1 = $async$self.children, t2 = t1.length, t3 = $async$self.$this, _i = 0;
                        case 2:
                            // for condition
                            if (!(_i < t2)) {
                                // goto after for
                                $async$goto = 4;
                                break;
                            }
                            $async$goto = 5;
                            return A._asyncAwait(t1[_i].accept$1(t3), $async$call$0);
                        case 5:
                        // returning from await.
                        case 3:
                            // for update
                            ++_i;
                            // goto for condition
                            $async$goto = 2;
                            break;
                        case 4:
                            // after for
                            // implicit return
                            return A._asyncReturn(null, $async$completer);
                    }
                });
                return A._asyncStartSync($async$call$0, $async$completer);
            },
            $signature: 2
        };
        A._EvaluateVisitor_visitAtRule_closure5.prototype = {
            call$0: function() {
                var $async$goto = 0, $async$completer = A._makeAsyncAwaitCompleter(type$.Null), $async$self = this, t2, t3, _i, t1, styleRule;
                var $async$call$0 = A._wrapJsFunctionForAsync(function($async$errorCode, $async$result) {
                    if ($async$errorCode === 1) return A._asyncRethrow($async$result, $async$completer);
                    for(;;)switch($async$goto){
                        case 0:
                            // Function start
                            t1 = $async$self.$this;
                            styleRule = t1._async_evaluate$_atRootExcludingStyleRule ? null : t1._async_evaluate$_styleRuleIgnoringAtRoot;
                            $async$goto = styleRule == null || t1._async_evaluate$_inKeyframes || $async$self.name.value === "font-face" ? 2 : 4;
                            break;
                        case 2:
                            // then
                            t2 = $async$self.children, t3 = t2.length, _i = 0;
                        case 5:
                            // for condition
                            if (!(_i < t3)) {
                                // goto after for
                                $async$goto = 7;
                                break;
                            }
                            $async$goto = 8;
                            return A._asyncAwait(t2[_i].accept$1(t1), $async$call$0);
                        case 8:
                        // returning from await.
                        case 6:
                            // for update
                            ++_i;
                            // goto for condition
                            $async$goto = 5;
                            break;
                        case 7:
                            // after for
                            // goto join
                            $async$goto = 3;
                            break;
                        case 4:
                            // else
                            $async$goto = 9;
                            return A._asyncAwait(t1._async_evaluate$_withParent$2$3$scopeWhen(A.ModifiableCssStyleRule$(styleRule._style_rule$_selector, styleRule.span, false, styleRule.originalSelector), new A._EvaluateVisitor_visitAtRule__closure0(t1, $async$self.children), false, type$.ModifiableCssStyleRule, type$.Null), $async$call$0);
                        case 9:
                        // returning from await.
                        case 3:
                            // join
                            // implicit return
                            return A._asyncReturn(null, $async$completer);
                    }
                });
                return A._asyncStartSync($async$call$0, $async$completer);
            },
            $signature: 2
        };
        A._EvaluateVisitor_visitAtRule__closure0.prototype = {
            call$0: function() {
                var $async$goto = 0, $async$completer = A._makeAsyncAwaitCompleter(type$.Null), $async$self = this, t1, t2, t3, _i;
                var $async$call$0 = A._wrapJsFunctionForAsync(function($async$errorCode, $async$result) {
                    if ($async$errorCode === 1) return A._asyncRethrow($async$result, $async$completer);
                    for(;;)switch($async$goto){
                        case 0:
                            // Function start
                            t1 = $async$self.children, t2 = t1.length, t3 = $async$self.$this, _i = 0;
                        case 2:
                            // for condition
                            if (!(_i < t2)) {
                                // goto after for
                                $async$goto = 4;
                                break;
                            }
                            $async$goto = 5;
                            return A._asyncAwait(t1[_i].accept$1(t3), $async$call$0);
                        case 5:
                        // returning from await.
                        case 3:
                            // for update
                            ++_i;
                            // goto for condition
                            $async$goto = 2;
                            break;
                        case 4:
                            // after for
                            // implicit return
                            return A._asyncReturn(null, $async$completer);
                    }
                });
                return A._asyncStartSync($async$call$0, $async$completer);
            },
            $signature: 2
        };
        A._EvaluateVisitor_visitAtRule_closure6.prototype = {
            call$1: function(node) {
                return node instanceof A.ModifiableCssStyleRule;
            },
            $signature: 7
        };
        A._EvaluateVisitor_visitForRule_closure4.prototype = {
            call$0: function() {
                var $async$goto = 0, $async$completer = A._makeAsyncAwaitCompleter(type$.SassNumber), $async$returnValue, $async$self = this;
                var $async$call$0 = A._wrapJsFunctionForAsync(function($async$errorCode, $async$result) {
                    if ($async$errorCode === 1) return A._asyncRethrow($async$result, $async$completer);
                    for(;;)switch($async$goto){
                        case 0:
                            // Function start
                            $async$goto = 3;
                            return A._asyncAwait($async$self.node.from.accept$1($async$self.$this), $async$call$0);
                        case 3:
                            // returning from await.
                            $async$returnValue = $async$result.assertNumber$0();
                            // goto return
                            $async$goto = 1;
                            break;
                        case 1:
                            // return
                            return A._asyncReturn($async$returnValue, $async$completer);
                    }
                });
                return A._asyncStartSync($async$call$0, $async$completer);
            },
            $signature: 175
        };
        A._EvaluateVisitor_visitForRule_closure5.prototype = {
            call$0: function() {
                var $async$goto = 0, $async$completer = A._makeAsyncAwaitCompleter(type$.SassNumber), $async$returnValue, $async$self = this;
                var $async$call$0 = A._wrapJsFunctionForAsync(function($async$errorCode, $async$result) {
                    if ($async$errorCode === 1) return A._asyncRethrow($async$result, $async$completer);
                    for(;;)switch($async$goto){
                        case 0:
                            // Function start
                            $async$goto = 3;
                            return A._asyncAwait($async$self.node.to.accept$1($async$self.$this), $async$call$0);
                        case 3:
                            // returning from await.
                            $async$returnValue = $async$result.assertNumber$0();
                            // goto return
                            $async$goto = 1;
                            break;
                        case 1:
                            // return
                            return A._asyncReturn($async$returnValue, $async$completer);
                    }
                });
                return A._asyncStartSync($async$call$0, $async$completer);
            },
            $signature: 175
        };
        A._EvaluateVisitor_visitForRule_closure6.prototype = {
            call$0: function() {
                return this.fromNumber.assertInt$0();
            },
            $signature: 10
        };
        A._EvaluateVisitor_visitForRule_closure7.prototype = {
            call$0: function() {
                var t1 = this.fromNumber;
                return this.toNumber.coerce$2(t1.get$numeratorUnits(t1), t1.get$denominatorUnits(t1)).assertInt$0();
            },
            $signature: 10
        };
        A._EvaluateVisitor_visitForRule_closure8.prototype = {
            call$0: function() {
                var $async$goto = 0, $async$completer = A._makeAsyncAwaitCompleter(type$.nullable_Value), $async$returnValue, $async$self = this, i, t3, t4, t5, t6, t7, t8, _0_0, t1, t2, nodeWithSpan;
                var $async$call$0 = A._wrapJsFunctionForAsync(function($async$errorCode, $async$result) {
                    if ($async$errorCode === 1) return A._asyncRethrow($async$result, $async$completer);
                    for(;;)switch($async$goto){
                        case 0:
                            // Function start
                            t1 = $async$self.$this;
                            t2 = $async$self.node;
                            nodeWithSpan = t1._async_evaluate$_expressionNode$1(t2.from);
                            i = $async$self.from, t3 = $async$self._box_0, t4 = $async$self.direction, t5 = t2.variable, t6 = $async$self.fromNumber, t2 = t2.children;
                        case 3:
                            // for condition
                            if (!(i !== t3.to)) {
                                // goto after for
                                $async$goto = 5;
                                break;
                            }
                            t7 = t1._async_evaluate$_environment;
                            t8 = t6.get$numeratorUnits(t6);
                            t7.setLocalVariable$3(t5, A.SassNumber_SassNumber$withUnits(i, t6.get$denominatorUnits(t6), t8), nodeWithSpan);
                            $async$goto = 6;
                            return A._asyncAwait(t1._async_evaluate$_handleReturn$2(t2, new A._EvaluateVisitor_visitForRule__closure0(t1)), $async$call$0);
                        case 6:
                            // returning from await.
                            _0_0 = $async$result;
                            if (_0_0 != null) {
                                $async$returnValue = _0_0;
                                // goto return
                                $async$goto = 1;
                                break;
                            }
                        case 4:
                            // for update
                            i += t4;
                            // goto for condition
                            $async$goto = 3;
                            break;
                        case 5:
                            // after for
                            $async$returnValue = null;
                            // goto return
                            $async$goto = 1;
                            break;
                        case 1:
                            // return
                            return A._asyncReturn($async$returnValue, $async$completer);
                    }
                });
                return A._asyncStartSync($async$call$0, $async$completer);
            },
            $signature: 69
        };
        A._EvaluateVisitor_visitForRule__closure0.prototype = {
            call$1: function(child) {
                return child.accept$1(this.$this);
            },
            $signature: 87
        };
        A._EvaluateVisitor_visitForwardRule_closure1.prototype = {
            call$2: function(module, firstLoad) {
                if (firstLoad) this.$this._async_evaluate$_registerCommentsForModule$1(module);
                this.$this._async_evaluate$_environment.forwardModule$2(module, this.node);
            },
            $signature: 141
        };
        A._EvaluateVisitor_visitForwardRule_closure2.prototype = {
            call$2: function(module, firstLoad) {
                if (firstLoad) this.$this._async_evaluate$_registerCommentsForModule$1(module);
                this.$this._async_evaluate$_environment.forwardModule$2(module, this.node);
            },
            $signature: 141
        };
        A._EvaluateVisitor__registerCommentsForModule_closure0.prototype = {
            call$0: function() {
                return A._setArrayType([], type$.JSArray_CssComment);
            },
            $signature: 177
        };
        A._EvaluateVisitor_visitIfRule_closure0.prototype = {
            call$1: function(clause) {
                var t1 = this.$this;
                return t1._async_evaluate$_environment.scope$1$3$semiGlobal$when(new A._EvaluateVisitor_visitIfRule__closure0(t1, clause), true, clause.hasDeclarations, type$.nullable_Value);
            },
            $signature: 449
        };
        A._EvaluateVisitor_visitIfRule__closure0.prototype = {
            call$0: function() {
                var t1 = this.$this;
                return t1._async_evaluate$_handleReturn$2(this.clause.children, new A._EvaluateVisitor_visitIfRule___closure0(t1));
            },
            $signature: 69
        };
        A._EvaluateVisitor_visitIfRule___closure0.prototype = {
            call$1: function(child) {
                return child.accept$1(this.$this);
            },
            $signature: 87
        };
        A._EvaluateVisitor__visitDynamicImport_closure0.prototype = {
            call$0: function() {
                return this.$call$body$_EvaluateVisitor__visitDynamicImport_closure();
            },
            $call$body$_EvaluateVisitor__visitDynamicImport_closure: function() {
                var $async$goto = 0, $async$completer = A._makeAsyncAwaitCompleter(type$.void), $async$returnValue, $async$self = this, t1, t2, _0_0, stylesheet, importer, isDependency, t3, url, oldImporter, oldStylesheet, oldInDependency, loadsUserDefinedModules, children, t4, t5, t6, t7, t8, t9, t10, t11, environment, module, visitor, _box_0;
                var $async$call$0 = A._wrapJsFunctionForAsync(function($async$errorCode, $async$result) {
                    if ($async$errorCode === 1) return A._asyncRethrow($async$result, $async$completer);
                    for(;;)switch($async$goto){
                        case 0:
                            // Function start
                            _box_0 = {};
                            _box_0.isDependency = _box_0.importer = _box_0.stylesheet = null;
                            t1 = $async$self.$this;
                            t2 = $async$self.$import;
                            $async$goto = 3;
                            return A._asyncAwait(t1._async_evaluate$_loadStylesheet$3$forImport(t2.urlString, t2.span, true), $async$call$0);
                        case 3:
                            // returning from await.
                            _0_0 = $async$result;
                            stylesheet = _box_0.stylesheet = _0_0._0;
                            importer = _0_0._1;
                            _box_0.importer = importer;
                            isDependency = _0_0._2;
                            _box_0.isDependency = isDependency;
                            t3 = stylesheet.span;
                            url = t3.get$sourceUrl(t3);
                            if (url != null) {
                                t3 = t1._async_evaluate$_activeModules;
                                if (t3.containsKey$1(url)) {
                                    t2 = A.NullableExtension_andThen(t3.$index(0, url), new A._EvaluateVisitor__visitDynamicImport__closure3(t1));
                                    throw A.wrapException(t2 == null ? t1._async_evaluate$_exception$1("This file is already being loaded.") : t2);
                                }
                                t3.$indexSet(0, url, t2);
                            }
                            t2 = stylesheet._uses;
                            t3 = type$.UnmodifiableListView_UseRule;
                            $async$goto = new A.UnmodifiableListView(t2, t3).get$length(0) === 0 && new A.UnmodifiableListView(stylesheet._forwards, type$.UnmodifiableListView_ForwardRule).get$length(0) === 0 ? 4 : 5;
                            break;
                        case 4:
                            // then
                            oldImporter = t1._async_evaluate$_importer;
                            oldStylesheet = t1._async_evaluate$_assertInModule$2(t1._async_evaluate$__stylesheet, "_stylesheet");
                            oldInDependency = t1._async_evaluate$_inDependency;
                            t1._async_evaluate$_importer = importer;
                            t1._async_evaluate$__stylesheet = stylesheet;
                            t1._async_evaluate$_inDependency = isDependency;
                            $async$goto = 6;
                            return A._asyncAwait(t1.visitStylesheet$1(0, stylesheet), $async$call$0);
                        case 6:
                            // returning from await.
                            t1._async_evaluate$_importer = oldImporter;
                            t1._async_evaluate$__stylesheet = oldStylesheet;
                            t1._async_evaluate$_inDependency = oldInDependency;
                            t1._async_evaluate$_activeModules.remove$1(0, url);
                            // goto return
                            $async$goto = 1;
                            break;
                        case 5:
                            // join
                            t2 = new A.UnmodifiableListView(t2, t3);
                            if (!t2.any$1(t2, new A._EvaluateVisitor__visitDynamicImport__closure4())) {
                                t2 = new A.UnmodifiableListView(stylesheet._forwards, type$.UnmodifiableListView_ForwardRule);
                                loadsUserDefinedModules = t2.any$1(t2, new A._EvaluateVisitor__visitDynamicImport__closure5());
                            } else loadsUserDefinedModules = true;
                            children = A._Cell$();
                            t2 = t1._async_evaluate$_environment;
                            t3 = type$.String;
                            t4 = type$.Module_AsyncCallable;
                            t5 = type$.AstNode;
                            t6 = t2._async_environment$_nestedForwardedModules;
                            t7 = A._setArrayType([], type$.JSArray_Module_AsyncCallable);
                            t8 = t2._async_environment$_variables;
                            t8 = A._setArrayType(t8.slice(0), A._arrayInstanceType(t8));
                            t9 = t2._async_environment$_variableNodes;
                            t9 = A._setArrayType(t9.slice(0), A._arrayInstanceType(t9));
                            t10 = t2._async_environment$_functions;
                            t10 = A._setArrayType(t10.slice(0), A._arrayInstanceType(t10));
                            t11 = t2._async_environment$_mixins;
                            t11 = A._setArrayType(t11.slice(0), A._arrayInstanceType(t11));
                            environment = A.AsyncEnvironment$_(A.LinkedHashMap_LinkedHashMap$_empty(t3, t4), A.LinkedHashMap_LinkedHashMap$_empty(t3, t5), A.LinkedHashMap_LinkedHashMap$_empty(t4, t5), t2._async_environment$_importedModules, null, t6, t7, t8, t9, t10, t11, t2._async_environment$_content, t2._async_environment$_configurableVariables);
                            $async$goto = 7;
                            return A._asyncAwait(t1._async_evaluate$_withEnvironment$1$2(environment, new A._EvaluateVisitor__visitDynamicImport__closure6(_box_0, t1, loadsUserDefinedModules, environment, children), type$.Null), $async$call$0);
                        case 7:
                            // returning from await.
                            module = environment.toDummyModule$0();
                            t1._async_evaluate$_environment.importForwards$1(module);
                            $async$goto = loadsUserDefinedModules ? 8 : 9;
                            break;
                        case 8:
                            // then
                            $async$goto = module.transitivelyContainsCss ? 10 : 11;
                            break;
                        case 10:
                            // then
                            $async$goto = 12;
                            return A._asyncAwait(t1._async_evaluate$_combineCss$2$clone(module, module.transitivelyContainsExtensions).accept$1(t1), $async$call$0);
                        case 12:
                        // returning from await.
                        case 11:
                            // join
                            visitor = new A._ImportedCssVisitor0(t1);
                            for(t2 = J.get$iterator$ax(children._readLocal$0()); t2.moveNext$0();)t2.get$current(t2).accept$1(visitor);
                        case 9:
                            // join
                            t1._async_evaluate$_activeModules.remove$1(0, url);
                        case 1:
                            // return
                            return A._asyncReturn($async$returnValue, $async$completer);
                    }
                });
                return A._asyncStartSync($async$call$0, $async$completer);
            },
            $signature: 32
        };
        A._EvaluateVisitor__visitDynamicImport__closure3.prototype = {
            call$1: function(previousLoad) {
                return this.$this._async_evaluate$_multiSpanException$3("This file is already being loaded.", "new load", A.LinkedHashMap_LinkedHashMap$_literal([
                    previousLoad.get$span(previousLoad),
                    "original load"
                ], type$.FileSpan, type$.String));
            },
            $signature: 111
        };
        A._EvaluateVisitor__visitDynamicImport__closure4.prototype = {
            call$1: function(rule) {
                return rule.url.get$scheme() !== "sass";
            },
            $signature: 178
        };
        A._EvaluateVisitor__visitDynamicImport__closure5.prototype = {
            call$1: function(rule) {
                return rule.url.get$scheme() !== "sass";
            },
            $signature: 179
        };
        A._EvaluateVisitor__visitDynamicImport__closure6.prototype = {
            call$0: function() {
                var $async$goto = 0, $async$completer = A._makeAsyncAwaitCompleter(type$.Null), $async$self = this, t3, t4, t1, oldImporter, oldStylesheet, oldRoot, oldParent, oldEndOfImports, oldOutOfOrderImports, oldConfiguration, oldInDependency, t2;
                var $async$call$0 = A._wrapJsFunctionForAsync(function($async$errorCode, $async$result) {
                    if ($async$errorCode === 1) return A._asyncRethrow($async$result, $async$completer);
                    for(;;)switch($async$goto){
                        case 0:
                            // Function start
                            t1 = $async$self.$this;
                            oldImporter = t1._async_evaluate$_importer;
                            oldStylesheet = t1._async_evaluate$_assertInModule$2(t1._async_evaluate$__stylesheet, "_stylesheet");
                            oldRoot = t1._async_evaluate$_assertInModule$2(t1._async_evaluate$__root, "_root");
                            oldParent = t1._async_evaluate$_assertInModule$2(t1._async_evaluate$__parent, "__parent");
                            oldEndOfImports = t1._async_evaluate$_assertInModule$2(t1._async_evaluate$__endOfImports, "_endOfImports");
                            oldOutOfOrderImports = t1._async_evaluate$_outOfOrderImports;
                            oldConfiguration = t1._async_evaluate$_configuration;
                            oldInDependency = t1._async_evaluate$_inDependency;
                            t2 = $async$self._box_0;
                            t1._async_evaluate$_importer = t2.importer;
                            t3 = t2.stylesheet;
                            t1._async_evaluate$__stylesheet = t3;
                            t4 = $async$self.loadsUserDefinedModules;
                            if (t4) {
                                t3 = A.ModifiableCssStylesheet$(t3.span);
                                t1._async_evaluate$__root = t3;
                                t1._async_evaluate$__parent = t1._async_evaluate$_assertInModule$2(t3, "_root");
                                t1._async_evaluate$__endOfImports = 0;
                                t1._async_evaluate$_outOfOrderImports = null;
                            }
                            t1._async_evaluate$_inDependency = t2.isDependency;
                            t3 = new A.UnmodifiableListView(t2.stylesheet._forwards, type$.UnmodifiableListView_ForwardRule);
                            if (!t3.get$isEmpty(t3)) t1._async_evaluate$_configuration = $async$self.environment.toImplicitConfiguration$0();
                            $async$goto = 2;
                            return A._asyncAwait(t1.visitStylesheet$1(0, t2.stylesheet), $async$call$0);
                        case 2:
                            // returning from await.
                            t2 = t4 ? t1._async_evaluate$_addOutOfOrderImports$0() : A._setArrayType([], type$.JSArray_ModifiableCssNode);
                            $async$self.children.__late_helper$_value = t2;
                            t1._async_evaluate$_importer = oldImporter;
                            t1._async_evaluate$__stylesheet = oldStylesheet;
                            if (t4) {
                                t1._async_evaluate$__root = oldRoot;
                                t1._async_evaluate$__parent = oldParent;
                                t1._async_evaluate$__endOfImports = oldEndOfImports;
                                t1._async_evaluate$_outOfOrderImports = oldOutOfOrderImports;
                            }
                            t1._async_evaluate$_configuration = oldConfiguration;
                            t1._async_evaluate$_inDependency = oldInDependency;
                            // implicit return
                            return A._asyncReturn(null, $async$completer);
                    }
                });
                return A._asyncStartSync($async$call$0, $async$completer);
            },
            $signature: 2
        };
        A._EvaluateVisitor__applyMixin_closure1.prototype = {
            call$0: function() {
                var $async$goto = 0, $async$completer = A._makeAsyncAwaitCompleter(type$.void), $async$self = this, t1;
                var $async$call$0 = A._wrapJsFunctionForAsync(function($async$errorCode, $async$result) {
                    if ($async$errorCode === 1) return A._asyncRethrow($async$result, $async$completer);
                    for(;;)switch($async$goto){
                        case 0:
                            // Function start
                            t1 = $async$self.$this;
                            $async$goto = 2;
                            return A._asyncAwait(t1._async_evaluate$_environment.asMixin$1(new A._EvaluateVisitor__applyMixin__closure2(t1, $async$self.$arguments, $async$self.mixin, $async$self.nodeWithSpanWithoutContent)), $async$call$0);
                        case 2:
                            // returning from await.
                            // implicit return
                            return A._asyncReturn(null, $async$completer);
                    }
                });
                return A._asyncStartSync($async$call$0, $async$completer);
            },
            $signature: 32
        };
        A._EvaluateVisitor__applyMixin__closure2.prototype = {
            call$0: function() {
                var $async$goto = 0, $async$completer = A._makeAsyncAwaitCompleter(type$.void), $async$self = this;
                var $async$call$0 = A._wrapJsFunctionForAsync(function($async$errorCode, $async$result) {
                    if ($async$errorCode === 1) return A._asyncRethrow($async$result, $async$completer);
                    for(;;)switch($async$goto){
                        case 0:
                            // Function start
                            $async$goto = 2;
                            return A._asyncAwait($async$self.$this._async_evaluate$_runBuiltInCallable$3($async$self.$arguments, $async$self.mixin, $async$self.nodeWithSpanWithoutContent), $async$call$0);
                        case 2:
                            // returning from await.
                            // implicit return
                            return A._asyncReturn(null, $async$completer);
                    }
                });
                return A._asyncStartSync($async$call$0, $async$completer);
            },
            $signature: 32
        };
        A._EvaluateVisitor__applyMixin_closure2.prototype = {
            call$0: function() {
                var $async$goto = 0, $async$completer = A._makeAsyncAwaitCompleter(type$.Null), $async$self = this, t1;
                var $async$call$0 = A._wrapJsFunctionForAsync(function($async$errorCode, $async$result) {
                    if ($async$errorCode === 1) return A._asyncRethrow($async$result, $async$completer);
                    for(;;)switch($async$goto){
                        case 0:
                            // Function start
                            t1 = $async$self.$this;
                            $async$goto = 2;
                            return A._asyncAwait(t1._async_evaluate$_environment.withContent$2($async$self.contentCallable, new A._EvaluateVisitor__applyMixin__closure1(t1, $async$self.mixin, $async$self.nodeWithSpanWithoutContent)), $async$call$0);
                        case 2:
                            // returning from await.
                            // implicit return
                            return A._asyncReturn(null, $async$completer);
                    }
                });
                return A._asyncStartSync($async$call$0, $async$completer);
            },
            $signature: 2
        };
        A._EvaluateVisitor__applyMixin__closure1.prototype = {
            call$0: function() {
                var $async$goto = 0, $async$completer = A._makeAsyncAwaitCompleter(type$.void), $async$self = this, t1;
                var $async$call$0 = A._wrapJsFunctionForAsync(function($async$errorCode, $async$result) {
                    if ($async$errorCode === 1) return A._asyncRethrow($async$result, $async$completer);
                    for(;;)switch($async$goto){
                        case 0:
                            // Function start
                            t1 = $async$self.$this;
                            $async$goto = 2;
                            return A._asyncAwait(t1._async_evaluate$_environment.asMixin$1(new A._EvaluateVisitor__applyMixin___closure0(t1, $async$self.mixin, $async$self.nodeWithSpanWithoutContent)), $async$call$0);
                        case 2:
                            // returning from await.
                            // implicit return
                            return A._asyncReturn(null, $async$completer);
                    }
                });
                return A._asyncStartSync($async$call$0, $async$completer);
            },
            $signature: 32
        };
        A._EvaluateVisitor__applyMixin___closure0.prototype = {
            call$0: function() {
                var $async$goto = 0, $async$completer = A._makeAsyncAwaitCompleter(type$.void), $async$self = this, t1, t2, t3, t4, t5, _i;
                var $async$call$0 = A._wrapJsFunctionForAsync(function($async$errorCode, $async$result) {
                    if ($async$errorCode === 1) return A._asyncRethrow($async$result, $async$completer);
                    for(;;)switch($async$goto){
                        case 0:
                            // Function start
                            t1 = $async$self.mixin.declaration.children, t2 = t1.length, t3 = $async$self.$this, t4 = $async$self.nodeWithSpanWithoutContent, t5 = type$.nullable_Value, _i = 0;
                        case 2:
                            // for condition
                            if (!(_i < t2)) {
                                // goto after for
                                $async$goto = 4;
                                break;
                            }
                            $async$goto = 5;
                            return A._asyncAwait(t3._async_evaluate$_addErrorSpan$1$2(t4, new A._EvaluateVisitor__applyMixin____closure0(t3, t1[_i]), t5), $async$call$0);
                        case 5:
                        // returning from await.
                        case 3:
                            // for update
                            ++_i;
                            // goto for condition
                            $async$goto = 2;
                            break;
                        case 4:
                            // after for
                            // implicit return
                            return A._asyncReturn(null, $async$completer);
                    }
                });
                return A._asyncStartSync($async$call$0, $async$completer);
            },
            $signature: 32
        };
        A._EvaluateVisitor__applyMixin____closure0.prototype = {
            call$0: function() {
                return this.statement.accept$1(this.$this);
            },
            $signature: 69
        };
        A._EvaluateVisitor_visitIncludeRule_closure2.prototype = {
            call$0: function() {
                var t1 = this.node;
                return this.$this._async_evaluate$_environment.getMixin$2$namespace(t1.name, t1.namespace);
            },
            $signature: 103
        };
        A._EvaluateVisitor_visitIncludeRule_closure3.prototype = {
            call$1: function($content) {
                var t1 = this.$this;
                return new A.UserDefinedCallable($content, t1._async_evaluate$_environment.closure$0(), t1._async_evaluate$_inDependency, type$.UserDefinedCallable_AsyncEnvironment);
            },
            $signature: 454
        };
        A._EvaluateVisitor_visitIncludeRule_closure4.prototype = {
            call$0: function() {
                return this.node.get$spanWithoutContent();
            },
            $signature: 16
        };
        A._EvaluateVisitor_visitMediaRule_closure3.prototype = {
            call$0: function() {
                var $async$goto = 0, $async$completer = A._makeAsyncAwaitCompleter(type$.Null), $async$self = this, t1, t2, t3, _i;
                var $async$call$0 = A._wrapJsFunctionForAsync(function($async$errorCode, $async$result) {
                    if ($async$errorCode === 1) return A._asyncRethrow($async$result, $async$completer);
                    for(;;)switch($async$goto){
                        case 0:
                            // Function start
                            t1 = $async$self.node.children, t2 = t1.length, t3 = $async$self.$this, _i = 0;
                        case 2:
                            // for condition
                            if (!(_i < t2)) {
                                // goto after for
                                $async$goto = 4;
                                break;
                            }
                            $async$goto = 5;
                            return A._asyncAwait(t1[_i].accept$1(t3), $async$call$0);
                        case 5:
                        // returning from await.
                        case 3:
                            // for update
                            ++_i;
                            // goto for condition
                            $async$goto = 2;
                            break;
                        case 4:
                            // after for
                            // implicit return
                            return A._asyncReturn(null, $async$completer);
                    }
                });
                return A._asyncStartSync($async$call$0, $async$completer);
            },
            $signature: 2
        };
        A._EvaluateVisitor_visitMediaRule_closure4.prototype = {
            call$1: function(mediaQueries) {
                return this.$this._async_evaluate$_mergeMediaQueries$2(mediaQueries, this.queries);
            },
            $signature: 89
        };
        A._EvaluateVisitor_visitMediaRule_closure5.prototype = {
            call$0: function() {
                var $async$goto = 0, $async$completer = A._makeAsyncAwaitCompleter(type$.Null), $async$self = this, t1, t2;
                var $async$call$0 = A._wrapJsFunctionForAsync(function($async$errorCode, $async$result) {
                    if ($async$errorCode === 1) return A._asyncRethrow($async$result, $async$completer);
                    for(;;)switch($async$goto){
                        case 0:
                            // Function start
                            t1 = $async$self.$this;
                            t2 = $async$self.mergedQueries;
                            if (t2 == null) t2 = $async$self.queries;
                            $async$goto = 2;
                            return A._asyncAwait(t1._async_evaluate$_withMediaQueries$1$3(t2, $async$self.mergedSources, new A._EvaluateVisitor_visitMediaRule__closure0(t1, $async$self.node), type$.Null), $async$call$0);
                        case 2:
                            // returning from await.
                            // implicit return
                            return A._asyncReturn(null, $async$completer);
                    }
                });
                return A._asyncStartSync($async$call$0, $async$completer);
            },
            $signature: 2
        };
        A._EvaluateVisitor_visitMediaRule__closure0.prototype = {
            call$0: function() {
                var $async$goto = 0, $async$completer = A._makeAsyncAwaitCompleter(type$.Null), $async$self = this, t2, t3, _i, t1, _0_0;
                var $async$call$0 = A._wrapJsFunctionForAsync(function($async$errorCode, $async$result) {
                    if ($async$errorCode === 1) return A._asyncRethrow($async$result, $async$completer);
                    for(;;)switch($async$goto){
                        case 0:
                            // Function start
                            t1 = $async$self.$this;
                            _0_0 = t1._async_evaluate$_atRootExcludingStyleRule ? null : t1._async_evaluate$_styleRuleIgnoringAtRoot;
                            $async$goto = _0_0 != null ? 2 : 4;
                            break;
                        case 2:
                            // then
                            $async$goto = 5;
                            return A._asyncAwait(t1._async_evaluate$_withParent$2$3$scopeWhen(A.ModifiableCssStyleRule$(_0_0._style_rule$_selector, _0_0.span, false, _0_0.originalSelector), new A._EvaluateVisitor_visitMediaRule___closure0(t1, $async$self.node), false, type$.ModifiableCssStyleRule, type$.Null), $async$call$0);
                        case 5:
                            // returning from await.
                            // goto join
                            $async$goto = 3;
                            break;
                        case 4:
                            // else
                            t2 = $async$self.node.children, t3 = t2.length, _i = 0;
                        case 6:
                            // for condition
                            if (!(_i < t3)) {
                                // goto after for
                                $async$goto = 8;
                                break;
                            }
                            $async$goto = 9;
                            return A._asyncAwait(t2[_i].accept$1(t1), $async$call$0);
                        case 9:
                        // returning from await.
                        case 7:
                            // for update
                            ++_i;
                            // goto for condition
                            $async$goto = 6;
                            break;
                        case 8:
                        // after for
                        case 3:
                            // join
                            // implicit return
                            return A._asyncReturn(null, $async$completer);
                    }
                });
                return A._asyncStartSync($async$call$0, $async$completer);
            },
            $signature: 2
        };
        A._EvaluateVisitor_visitMediaRule___closure0.prototype = {
            call$0: function() {
                var $async$goto = 0, $async$completer = A._makeAsyncAwaitCompleter(type$.Null), $async$self = this, t1, t2, t3, _i;
                var $async$call$0 = A._wrapJsFunctionForAsync(function($async$errorCode, $async$result) {
                    if ($async$errorCode === 1) return A._asyncRethrow($async$result, $async$completer);
                    for(;;)switch($async$goto){
                        case 0:
                            // Function start
                            t1 = $async$self.node.children, t2 = t1.length, t3 = $async$self.$this, _i = 0;
                        case 2:
                            // for condition
                            if (!(_i < t2)) {
                                // goto after for
                                $async$goto = 4;
                                break;
                            }
                            $async$goto = 5;
                            return A._asyncAwait(t1[_i].accept$1(t3), $async$call$0);
                        case 5:
                        // returning from await.
                        case 3:
                            // for update
                            ++_i;
                            // goto for condition
                            $async$goto = 2;
                            break;
                        case 4:
                            // after for
                            // implicit return
                            return A._asyncReturn(null, $async$completer);
                    }
                });
                return A._asyncStartSync($async$call$0, $async$completer);
            },
            $signature: 2
        };
        A._EvaluateVisitor_visitMediaRule_closure6.prototype = {
            call$1: function(node) {
                var t1;
                if (!(node instanceof A.ModifiableCssStyleRule)) {
                    t1 = this.mergedSources;
                    t1 = t1.get$isNotEmpty(t1) && node instanceof A.ModifiableCssMediaRule && B.JSArray_methods.every$1(node.queries, t1.get$contains(t1));
                } else t1 = true;
                return t1;
            },
            $signature: 7
        };
        A._EvaluateVisitor_visitStyleRule_closure3.prototype = {
            call$0: function() {
                var $async$goto = 0, $async$completer = A._makeAsyncAwaitCompleter(type$.Null), $async$self = this, t1, t2, t3, _i;
                var $async$call$0 = A._wrapJsFunctionForAsync(function($async$errorCode, $async$result) {
                    if ($async$errorCode === 1) return A._asyncRethrow($async$result, $async$completer);
                    for(;;)switch($async$goto){
                        case 0:
                            // Function start
                            t1 = $async$self.node.children, t2 = t1.length, t3 = $async$self.$this, _i = 0;
                        case 2:
                            // for condition
                            if (!(_i < t2)) {
                                // goto after for
                                $async$goto = 4;
                                break;
                            }
                            $async$goto = 5;
                            return A._asyncAwait(t1[_i].accept$1(t3), $async$call$0);
                        case 5:
                        // returning from await.
                        case 3:
                            // for update
                            ++_i;
                            // goto for condition
                            $async$goto = 2;
                            break;
                        case 4:
                            // after for
                            // implicit return
                            return A._asyncReturn(null, $async$completer);
                    }
                });
                return A._asyncStartSync($async$call$0, $async$completer);
            },
            $signature: 2
        };
        A._EvaluateVisitor_visitStyleRule_closure4.prototype = {
            call$1: function(node) {
                return node instanceof A.ModifiableCssStyleRule;
            },
            $signature: 7
        };
        A._EvaluateVisitor_visitStyleRule_closure6.prototype = {
            call$0: function() {
                var $async$goto = 0, $async$completer = A._makeAsyncAwaitCompleter(type$.Null), $async$self = this, t1;
                var $async$call$0 = A._wrapJsFunctionForAsync(function($async$errorCode, $async$result) {
                    if ($async$errorCode === 1) return A._asyncRethrow($async$result, $async$completer);
                    for(;;)switch($async$goto){
                        case 0:
                            // Function start
                            t1 = $async$self.$this;
                            $async$goto = 2;
                            return A._asyncAwait(t1._async_evaluate$_withStyleRule$1$2($async$self.rule, new A._EvaluateVisitor_visitStyleRule__closure0(t1, $async$self.node), type$.Null), $async$call$0);
                        case 2:
                            // returning from await.
                            // implicit return
                            return A._asyncReturn(null, $async$completer);
                    }
                });
                return A._asyncStartSync($async$call$0, $async$completer);
            },
            $signature: 2
        };
        A._EvaluateVisitor_visitStyleRule__closure0.prototype = {
            call$0: function() {
                var $async$goto = 0, $async$completer = A._makeAsyncAwaitCompleter(type$.Null), $async$self = this, t1, t2, t3, _i;
                var $async$call$0 = A._wrapJsFunctionForAsync(function($async$errorCode, $async$result) {
                    if ($async$errorCode === 1) return A._asyncRethrow($async$result, $async$completer);
                    for(;;)switch($async$goto){
                        case 0:
                            // Function start
                            t1 = $async$self.node.children, t2 = t1.length, t3 = $async$self.$this, _i = 0;
                        case 2:
                            // for condition
                            if (!(_i < t2)) {
                                // goto after for
                                $async$goto = 4;
                                break;
                            }
                            $async$goto = 5;
                            return A._asyncAwait(t1[_i].accept$1(t3), $async$call$0);
                        case 5:
                        // returning from await.
                        case 3:
                            // for update
                            ++_i;
                            // goto for condition
                            $async$goto = 2;
                            break;
                        case 4:
                            // after for
                            // implicit return
                            return A._asyncReturn(null, $async$completer);
                    }
                });
                return A._asyncStartSync($async$call$0, $async$completer);
            },
            $signature: 2
        };
        A._EvaluateVisitor_visitStyleRule_closure5.prototype = {
            call$1: function(node) {
                return node instanceof A.ModifiableCssStyleRule;
            },
            $signature: 7
        };
        A._EvaluateVisitor__warnForBogusCombinators_closure0.prototype = {
            call$1: function(child) {
                return child instanceof A.ModifiableCssComment;
            },
            $signature: 7
        };
        A._EvaluateVisitor_visitSupportsRule_closure2.prototype = {
            call$0: function() {
                var $async$goto = 0, $async$completer = A._makeAsyncAwaitCompleter(type$.Null), $async$self = this, t1, t2, t3, _i;
                var $async$call$0 = A._wrapJsFunctionForAsync(function($async$errorCode, $async$result) {
                    if ($async$errorCode === 1) return A._asyncRethrow($async$result, $async$completer);
                    for(;;)switch($async$goto){
                        case 0:
                            // Function start
                            t1 = $async$self.node.children, t2 = t1.length, t3 = $async$self.$this, _i = 0;
                        case 2:
                            // for condition
                            if (!(_i < t2)) {
                                // goto after for
                                $async$goto = 4;
                                break;
                            }
                            $async$goto = 5;
                            return A._asyncAwait(t1[_i].accept$1(t3), $async$call$0);
                        case 5:
                        // returning from await.
                        case 3:
                            // for update
                            ++_i;
                            // goto for condition
                            $async$goto = 2;
                            break;
                        case 4:
                            // after for
                            // implicit return
                            return A._asyncReturn(null, $async$completer);
                    }
                });
                return A._asyncStartSync($async$call$0, $async$completer);
            },
            $signature: 2
        };
        A._EvaluateVisitor_visitSupportsRule_closure3.prototype = {
            call$0: function() {
                var $async$goto = 0, $async$completer = A._makeAsyncAwaitCompleter(type$.Null), $async$self = this, t2, t3, _i, t1, _0_0;
                var $async$call$0 = A._wrapJsFunctionForAsync(function($async$errorCode, $async$result) {
                    if ($async$errorCode === 1) return A._asyncRethrow($async$result, $async$completer);
                    for(;;)switch($async$goto){
                        case 0:
                            // Function start
                            t1 = $async$self.$this;
                            _0_0 = t1._async_evaluate$_atRootExcludingStyleRule ? null : t1._async_evaluate$_styleRuleIgnoringAtRoot;
                            $async$goto = _0_0 != null ? 2 : 4;
                            break;
                        case 2:
                            // then
                            $async$goto = 5;
                            return A._asyncAwait(t1._async_evaluate$_withParent$2$2(A.ModifiableCssStyleRule$(_0_0._style_rule$_selector, _0_0.span, false, _0_0.originalSelector), new A._EvaluateVisitor_visitSupportsRule__closure0(t1, $async$self.node), type$.ModifiableCssStyleRule, type$.Null), $async$call$0);
                        case 5:
                            // returning from await.
                            // goto join
                            $async$goto = 3;
                            break;
                        case 4:
                            // else
                            t2 = $async$self.node.children, t3 = t2.length, _i = 0;
                        case 6:
                            // for condition
                            if (!(_i < t3)) {
                                // goto after for
                                $async$goto = 8;
                                break;
                            }
                            $async$goto = 9;
                            return A._asyncAwait(t2[_i].accept$1(t1), $async$call$0);
                        case 9:
                        // returning from await.
                        case 7:
                            // for update
                            ++_i;
                            // goto for condition
                            $async$goto = 6;
                            break;
                        case 8:
                        // after for
                        case 3:
                            // join
                            // implicit return
                            return A._asyncReturn(null, $async$completer);
                    }
                });
                return A._asyncStartSync($async$call$0, $async$completer);
            },
            $signature: 2
        };
        A._EvaluateVisitor_visitSupportsRule__closure0.prototype = {
            call$0: function() {
                var $async$goto = 0, $async$completer = A._makeAsyncAwaitCompleter(type$.Null), $async$self = this, t1, t2, t3, _i;
                var $async$call$0 = A._wrapJsFunctionForAsync(function($async$errorCode, $async$result) {
                    if ($async$errorCode === 1) return A._asyncRethrow($async$result, $async$completer);
                    for(;;)switch($async$goto){
                        case 0:
                            // Function start
                            t1 = $async$self.node.children, t2 = t1.length, t3 = $async$self.$this, _i = 0;
                        case 2:
                            // for condition
                            if (!(_i < t2)) {
                                // goto after for
                                $async$goto = 4;
                                break;
                            }
                            $async$goto = 5;
                            return A._asyncAwait(t1[_i].accept$1(t3), $async$call$0);
                        case 5:
                        // returning from await.
                        case 3:
                            // for update
                            ++_i;
                            // goto for condition
                            $async$goto = 2;
                            break;
                        case 4:
                            // after for
                            // implicit return
                            return A._asyncReturn(null, $async$completer);
                    }
                });
                return A._asyncStartSync($async$call$0, $async$completer);
            },
            $signature: 2
        };
        A._EvaluateVisitor_visitSupportsRule_closure4.prototype = {
            call$1: function(node) {
                return node instanceof A.ModifiableCssStyleRule;
            },
            $signature: 7
        };
        A._EvaluateVisitor__visitSupportsCondition_closure0.prototype = {
            call$0: function() {
                var $async$goto = 0, $async$completer = A._makeAsyncAwaitCompleter(type$.String), $async$returnValue, $async$self = this, t1, t2, t3, t4, $async$temp1, $async$temp2;
                var $async$call$0 = A._wrapJsFunctionForAsync(function($async$errorCode, $async$result) {
                    if ($async$errorCode === 1) return A._asyncRethrow($async$result, $async$completer);
                    for(;;)switch($async$goto){
                        case 0:
                            // Function start
                            t1 = $async$self.$this;
                            t2 = $async$self._box_0;
                            $async$temp1 = A;
                            $async$goto = 3;
                            return A._asyncAwait(t1._evaluateToCss$1(t2.declaration.name), $async$call$0);
                        case 3:
                            // returning from await.
                            t3 = $async$temp1.S($async$result);
                            t4 = t2.declaration.get$isCustomProperty() ? "" : " ";
                            $async$temp1 = "(" + t3 + ":" + t4;
                            $async$temp2 = A;
                            $async$goto = 4;
                            return A._asyncAwait(t1._evaluateToCss$1(t2.declaration.value), $async$call$0);
                        case 4:
                            // returning from await.
                            $async$returnValue = $async$temp1 + $async$temp2.S($async$result) + ")";
                            // goto return
                            $async$goto = 1;
                            break;
                        case 1:
                            // return
                            return A._asyncReturn($async$returnValue, $async$completer);
                    }
                });
                return A._asyncStartSync($async$call$0, $async$completer);
            },
            $signature: 181
        };
        A._EvaluateVisitor_visitVariableDeclaration_closure2.prototype = {
            call$0: function() {
                var t1 = this.$this._async_evaluate$_environment, t2 = this._box_0.override;
                t1.setVariable$4$global(this.node.name, t2.value, t2.assignmentNode, true);
            },
            $signature: 1
        };
        A._EvaluateVisitor_visitVariableDeclaration_closure3.prototype = {
            call$0: function() {
                var t1 = this.node;
                return this.$this._async_evaluate$_environment.getVariable$2$namespace(t1.name, t1.namespace);
            },
            $signature: 44
        };
        A._EvaluateVisitor_visitVariableDeclaration_closure4.prototype = {
            call$0: function() {
                var t1 = this.$this, t2 = this.node;
                t1._async_evaluate$_environment.setVariable$5$global$namespace(t2.name, this.value, t1._async_evaluate$_expressionNode$1(t2.expression), t2.isGlobal, t2.namespace);
            },
            $signature: 1
        };
        A._EvaluateVisitor_visitUseRule_closure0.prototype = {
            call$2: function(module, firstLoad) {
                var t1, t2, t3, _0_0, t4, t5, span;
                if (firstLoad) this.$this._async_evaluate$_registerCommentsForModule$1(module);
                t1 = this.$this._async_evaluate$_environment;
                t2 = this.node;
                t3 = t2.namespace;
                if (t3 == null) {
                    t1._async_environment$_globalModules.$indexSet(0, module, t2);
                    t1._async_environment$_allModules.push(module);
                    t1 = B.JSArray_methods.get$first(t1._async_environment$_variables);
                    _0_0 = A.IterableExtension_firstWhereOrNull(t1.get$keys(t1), module.get$variables().get$containsKey());
                    if (_0_0 != null) A.throwExpression(A.SassScriptException$(string$.This_ma + _0_0 + '".', null));
                } else {
                    t4 = t1._async_environment$_modules;
                    if (t4.containsKey$1(t3)) {
                        t5 = t1._async_environment$_namespaceNodes.$index(0, t3);
                        span = t5 == null ? null : t5.span;
                        t5 = A.LinkedHashMap_LinkedHashMap$_empty(type$.FileSpan, type$.String);
                        if (span != null) t5.$indexSet(0, span, "original @use");
                        A.throwExpression(A.MultiSpanSassScriptException$(string$.There_ + t3 + '".', "new @use", t5));
                    }
                    t4.$indexSet(0, t3, module);
                    t1._async_environment$_namespaceNodes.$indexSet(0, t3, t2);
                    t1._async_environment$_allModules.push(module);
                }
            },
            $signature: 141
        };
        A._EvaluateVisitor_visitWarnRule_closure0.prototype = {
            call$0: function() {
                return this.node.expression.accept$1(this.$this);
            },
            $signature: 72
        };
        A._EvaluateVisitor_visitWhileRule_closure0.prototype = {
            call$0: function() {
                var $async$goto = 0, $async$completer = A._makeAsyncAwaitCompleter(type$.nullable_Value), $async$returnValue, $async$self = this, t1, t2, t3, _0_0;
                var $async$call$0 = A._wrapJsFunctionForAsync(function($async$errorCode, $async$result) {
                    if ($async$errorCode === 1) return A._asyncRethrow($async$result, $async$completer);
                    for(;;)switch($async$goto){
                        case 0:
                            // Function start
                            t1 = $async$self.node, t2 = t1.condition, t3 = $async$self.$this, t1 = t1.children;
                        case 3:
                            // for condition
                            $async$goto = 5;
                            return A._asyncAwait(t2.accept$1(t3), $async$call$0);
                        case 5:
                            // returning from await.
                            if (!$async$result.get$isTruthy()) {
                                // goto after for
                                $async$goto = 4;
                                break;
                            }
                            $async$goto = 6;
                            return A._asyncAwait(t3._async_evaluate$_handleReturn$2(t1, new A._EvaluateVisitor_visitWhileRule__closure0(t3)), $async$call$0);
                        case 6:
                            // returning from await.
                            _0_0 = $async$result;
                            if (_0_0 != null) {
                                $async$returnValue = _0_0;
                                // goto return
                                $async$goto = 1;
                                break;
                            }
                            // goto for condition
                            $async$goto = 3;
                            break;
                        case 4:
                            // after for
                            $async$returnValue = null;
                            // goto return
                            $async$goto = 1;
                            break;
                        case 1:
                            // return
                            return A._asyncReturn($async$returnValue, $async$completer);
                    }
                });
                return A._asyncStartSync($async$call$0, $async$completer);
            },
            $signature: 69
        };
        A._EvaluateVisitor_visitWhileRule__closure0.prototype = {
            call$1: function(child) {
                return child.accept$1(this.$this);
            },
            $signature: 87
        };
        A._EvaluateVisitor_visitBinaryOperationExpression_closure0.prototype = {
            call$0: function() {
                var $async$goto = 0, $async$completer = A._makeAsyncAwaitCompleter(type$.Value), $async$returnValue, $async$self = this, t3, t1, t2, left, $async$temp1, $async$temp2;
                var $async$call$0 = A._wrapJsFunctionForAsync(function($async$errorCode, $async$result) {
                    if ($async$errorCode === 1) return A._asyncRethrow($async$result, $async$completer);
                    for(;;)switch($async$goto){
                        case 0:
                            // Function start
                            t1 = $async$self.node;
                            t2 = $async$self.$this;
                            $async$goto = 3;
                            return A._asyncAwait(t1.left.accept$1(t2), $async$call$0);
                        case 3:
                            // returning from await.
                            left = $async$result;
                        case 4:
                            // switch
                            switch(t1.operator.index){
                                case 0:
                                    // goto case
                                    $async$goto = 6;
                                    break;
                                case 1:
                                    // goto case
                                    $async$goto = 7;
                                    break;
                                case 2:
                                    // goto case
                                    $async$goto = 8;
                                    break;
                                case 3:
                                    // goto case
                                    $async$goto = 9;
                                    break;
                                case 4:
                                    // goto case
                                    $async$goto = 10;
                                    break;
                                case 5:
                                    // goto case
                                    $async$goto = 11;
                                    break;
                                case 6:
                                    // goto case
                                    $async$goto = 12;
                                    break;
                                case 7:
                                    // goto case
                                    $async$goto = 13;
                                    break;
                                case 8:
                                    // goto case
                                    $async$goto = 14;
                                    break;
                                case 9:
                                    // goto case
                                    $async$goto = 15;
                                    break;
                                case 10:
                                    // goto case
                                    $async$goto = 16;
                                    break;
                                case 11:
                                    // goto case
                                    $async$goto = 17;
                                    break;
                                case 12:
                                    // goto case
                                    $async$goto = 18;
                                    break;
                                case 13:
                                    // goto case
                                    $async$goto = 19;
                                    break;
                                default:
                                    // goto default
                                    $async$goto = 20;
                                    break;
                            }
                            break;
                        case 6:
                            // case
                            t1 = t1.right.accept$1(t2);
                            $async$goto = 21;
                            return A._asyncAwait(type$.Future_Value._is(t1) ? t1 : A._Future$value(t1, type$.Value), $async$call$0);
                        case 21:
                            // returning from await.
                            t1 = $async$result;
                            t1 = new A.SassString(A.serializeValue(left, false, true) + "=" + A.serializeValue(t1, false, true), false);
                            // goto after switch
                            $async$goto = 5;
                            break;
                        case 7:
                            // case
                            $async$goto = left.get$isTruthy() ? 22 : 24;
                            break;
                        case 22:
                            // then
                            t1 = left;
                            // goto join
                            $async$goto = 23;
                            break;
                        case 24:
                            // else
                            t1 = t1.right.accept$1(t2);
                            $async$goto = 25;
                            return A._asyncAwait(type$.Future_Value._is(t1) ? t1 : A._Future$value(t1, type$.Value), $async$call$0);
                        case 25:
                            // returning from await.
                            t1 = $async$result;
                        case 23:
                            // join
                            // goto after switch
                            $async$goto = 5;
                            break;
                        case 8:
                            // case
                            $async$goto = left.get$isTruthy() ? 26 : 28;
                            break;
                        case 26:
                            // then
                            t1 = t1.right.accept$1(t2);
                            $async$goto = 29;
                            return A._asyncAwait(type$.Future_Value._is(t1) ? t1 : A._Future$value(t1, type$.Value), $async$call$0);
                        case 29:
                            // returning from await.
                            t1 = $async$result;
                            // goto join
                            $async$goto = 27;
                            break;
                        case 28:
                            // else
                            t1 = left;
                        case 27:
                            // join
                            // goto after switch
                            $async$goto = 5;
                            break;
                        case 9:
                            // case
                            $async$temp1 = left;
                            $async$goto = 30;
                            return A._asyncAwait(t1.right.accept$1(t2), $async$call$0);
                        case 30:
                            // returning from await.
                            t1 = $async$temp1.$eq(0, $async$result) ? B.SassBoolean_true : B.SassBoolean_false;
                            // goto after switch
                            $async$goto = 5;
                            break;
                        case 10:
                            // case
                            $async$temp1 = left;
                            $async$goto = 31;
                            return A._asyncAwait(t1.right.accept$1(t2), $async$call$0);
                        case 31:
                            // returning from await.
                            t1 = !$async$temp1.$eq(0, $async$result) ? B.SassBoolean_true : B.SassBoolean_false;
                            // goto after switch
                            $async$goto = 5;
                            break;
                        case 11:
                            // case
                            t1 = t1.right.accept$1(t2);
                            $async$temp1 = left;
                            $async$goto = 32;
                            return A._asyncAwait(type$.Future_Value._is(t1) ? t1 : A._Future$value(t1, type$.Value), $async$call$0);
                        case 32:
                            // returning from await.
                            t1 = $async$temp1.greaterThan$1($async$result);
                            // goto after switch
                            $async$goto = 5;
                            break;
                        case 12:
                            // case
                            t1 = t1.right.accept$1(t2);
                            $async$temp1 = left;
                            $async$goto = 33;
                            return A._asyncAwait(type$.Future_Value._is(t1) ? t1 : A._Future$value(t1, type$.Value), $async$call$0);
                        case 33:
                            // returning from await.
                            t1 = $async$temp1.greaterThanOrEquals$1($async$result);
                            // goto after switch
                            $async$goto = 5;
                            break;
                        case 13:
                            // case
                            t1 = t1.right.accept$1(t2);
                            $async$temp1 = left;
                            $async$goto = 34;
                            return A._asyncAwait(type$.Future_Value._is(t1) ? t1 : A._Future$value(t1, type$.Value), $async$call$0);
                        case 34:
                            // returning from await.
                            t1 = $async$temp1.lessThan$1($async$result);
                            // goto after switch
                            $async$goto = 5;
                            break;
                        case 14:
                            // case
                            t1 = t1.right.accept$1(t2);
                            $async$temp1 = left;
                            $async$goto = 35;
                            return A._asyncAwait(type$.Future_Value._is(t1) ? t1 : A._Future$value(t1, type$.Value), $async$call$0);
                        case 35:
                            // returning from await.
                            t1 = $async$temp1.lessThanOrEquals$1($async$result);
                            // goto after switch
                            $async$goto = 5;
                            break;
                        case 15:
                            // case
                            t1 = t1.right.accept$1(t2);
                            $async$temp1 = left;
                            $async$goto = 36;
                            return A._asyncAwait(type$.Future_Value._is(t1) ? t1 : A._Future$value(t1, type$.Value), $async$call$0);
                        case 36:
                            // returning from await.
                            t1 = $async$temp1.plus$1($async$result);
                            // goto after switch
                            $async$goto = 5;
                            break;
                        case 16:
                            // case
                            t1 = t1.right.accept$1(t2);
                            $async$temp1 = left;
                            $async$goto = 37;
                            return A._asyncAwait(type$.Future_Value._is(t1) ? t1 : A._Future$value(t1, type$.Value), $async$call$0);
                        case 37:
                            // returning from await.
                            t1 = $async$temp1.minus$1($async$result);
                            // goto after switch
                            $async$goto = 5;
                            break;
                        case 17:
                            // case
                            t1 = t1.right.accept$1(t2);
                            $async$temp1 = left;
                            $async$goto = 38;
                            return A._asyncAwait(type$.Future_Value._is(t1) ? t1 : A._Future$value(t1, type$.Value), $async$call$0);
                        case 38:
                            // returning from await.
                            t1 = $async$temp1.times$1($async$result);
                            // goto after switch
                            $async$goto = 5;
                            break;
                        case 18:
                            // case
                            t3 = t1.right.accept$1(t2);
                            $async$temp1 = t2;
                            $async$temp2 = left;
                            $async$goto = 39;
                            return A._asyncAwait(type$.Future_Value._is(t3) ? t3 : A._Future$value(t3, type$.Value), $async$call$0);
                        case 39:
                            // returning from await.
                            t1 = $async$temp1._async_evaluate$_slash$3($async$temp2, $async$result, t1);
                            // goto after switch
                            $async$goto = 5;
                            break;
                        case 19:
                            // case
                            t1 = t1.right.accept$1(t2);
                            $async$temp1 = left;
                            $async$goto = 40;
                            return A._asyncAwait(type$.Future_Value._is(t1) ? t1 : A._Future$value(t1, type$.Value), $async$call$0);
                        case 40:
                            // returning from await.
                            t1 = $async$temp1.modulo$1($async$result);
                            // goto after switch
                            $async$goto = 5;
                            break;
                        case 20:
                            // default
                            t1 = null;
                        case 5:
                            // after switch
                            $async$returnValue = t1;
                            // goto return
                            $async$goto = 1;
                            break;
                        case 1:
                            // return
                            return A._asyncReturn($async$returnValue, $async$completer);
                    }
                });
                return A._asyncStartSync($async$call$0, $async$completer);
            },
            $signature: 72
        };
        A._EvaluateVisitor__slash_recommendation0.prototype = {
            call$1: function(expression) {
                var t1;
                $label0$0: {
                    if (expression instanceof A.BinaryOperationExpression && B.BinaryOperator_ehp === expression.operator) {
                        t1 = "math.div(" + A.S(this.call$1(expression.left)) + ", " + A.S(this.call$1(expression.right)) + ")";
                        break $label0$0;
                    }
                    if (expression instanceof A.ParenthesizedExpression) {
                        t1 = expression.expression.toString$0(0);
                        break $label0$0;
                    }
                    t1 = expression.toString$0(0);
                    break $label0$0;
                }
                return t1;
            },
            $signature: 133
        };
        A._EvaluateVisitor_visitVariableExpression_closure0.prototype = {
            call$0: function() {
                var t1 = this.node;
                return this.$this._async_evaluate$_environment.getVariable$2$namespace(t1.name, t1.namespace);
            },
            $signature: 44
        };
        A._EvaluateVisitor_visitUnaryOperationExpression_closure0.prototype = {
            call$0: function() {
                var t1, _this = this;
                switch(_this.node.operator.index){
                    case 0:
                        t1 = _this.operand.unaryPlus$0();
                        break;
                    case 1:
                        t1 = _this.operand.unaryMinus$0();
                        break;
                    case 2:
                        t1 = new A.SassString("/" + A.serializeValue(_this.operand, false, true), false);
                        break;
                    case 3:
                        t1 = _this.operand.unaryNot$0();
                        break;
                    default:
                        t1 = null;
                }
                return t1;
            },
            $signature: 33
        };
        A._EvaluateVisitor_visitIfExpression_closure0.prototype = {
            call$1: function(pair) {
                return pair._0 + ": " + pair._1.toString$0(0);
            },
            $signature: 183
        };
        A._EvaluateVisitor_visitIfConditionOperation_closure0.prototype = {
            call$1: function(pair) {
                return pair._1;
            },
            $signature: 184
        };
        A._EvaluateVisitor_visitListExpression_closure0.prototype = {
            call$1: function(expression) {
                return expression.accept$1(this.$this);
            },
            $signature: 493
        };
        A._EvaluateVisitor_visitFunctionExpression_closure2.prototype = {
            call$0: function() {
                var t1 = this.node;
                return this.$this._async_evaluate$_environment.getFunction$2$namespace(t1.name, t1.namespace);
            },
            $signature: 103
        };
        A._EvaluateVisitor_visitFunctionExpression_closure3.prototype = {
            call$1: function(argument) {
                return argument.accept$1(B.C_IsCalculationSafeVisitor);
            },
            $signature: 74
        };
        A._EvaluateVisitor_visitFunctionExpression_closure4.prototype = {
            call$0: function() {
                var t1 = this.node;
                return this.$this._async_evaluate$_runFunctionCallable$3(t1.$arguments, this._box_0.$function, t1);
            },
            $signature: 72
        };
        A._EvaluateVisitor__visitCalculation_closure0.prototype = {
            call$2: function(message, deprecation) {
                return this.$this._async_evaluate$_warn$3(message, this.node.span, deprecation);
            },
            call$1: function(message) {
                return this.call$2(message, null);
            },
            $signature: 105
        };
        A._EvaluateVisitor__checkCalculationArguments_check0.prototype = {
            call$1: function(maxArgs) {
                var t1 = this.node, t2 = t1.$arguments.positional.length;
                if (t2 === 0) throw A.wrapException(this.$this._async_evaluate$_exception$2("Missing argument.", t1.span));
                else if (maxArgs != null && t2 > maxArgs) throw A.wrapException(this.$this._async_evaluate$_exception$2("Only " + A.S(maxArgs) + " " + A.pluralize("argument", maxArgs, null) + " allowed, but " + t2 + " " + A.pluralize("was", t2, "were") + " passed.", t1.span));
            },
            call$0: function() {
                return this.call$1(null);
            },
            $signature: 82
        };
        A._EvaluateVisitor__visitCalculationExpression_closure0.prototype = {
            call$0: function() {
                var $async$goto = 0, $async$completer = A._makeAsyncAwaitCompleter(type$.Object), $async$returnValue, $async$self = this, t1, t2, t3, t4, $async$temp1, $async$temp2, $async$temp3;
                var $async$call$0 = A._wrapJsFunctionForAsync(function($async$errorCode, $async$result) {
                    if ($async$errorCode === 1) return A._asyncRethrow($async$result, $async$completer);
                    for(;;)switch($async$goto){
                        case 0:
                            // Function start
                            t1 = $async$self.$this;
                            t2 = $async$self._box_0;
                            t3 = $async$self.node;
                            t4 = $async$self.inLegacySassFunction;
                            $async$temp1 = A;
                            $async$temp2 = t1._async_evaluate$_binaryOperatorToCalculationOperator$2(t2.operator, t3);
                            $async$goto = 3;
                            return A._asyncAwait(t1._async_evaluate$_visitCalculationExpression$2$inLegacySassFunction(t2.left, t4), $async$call$0);
                        case 3:
                            // returning from await.
                            $async$temp3 = $async$result;
                            $async$goto = 4;
                            return A._asyncAwait(t1._async_evaluate$_visitCalculationExpression$2$inLegacySassFunction(t2.right, t4), $async$call$0);
                        case 4:
                            // returning from await.
                            $async$returnValue = $async$temp1.SassCalculation_operateInternal($async$temp2, $async$temp3, $async$result, t4, !t1._async_evaluate$_inSupportsDeclaration, new A._EvaluateVisitor__visitCalculationExpression__closure0(t1, t3));
                            // goto return
                            $async$goto = 1;
                            break;
                        case 1:
                            // return
                            return A._asyncReturn($async$returnValue, $async$completer);
                    }
                });
                return A._asyncStartSync($async$call$0, $async$completer);
            },
            $signature: 185
        };
        A._EvaluateVisitor__visitCalculationExpression__closure0.prototype = {
            call$2: function(message, deprecation) {
                return this.$this._async_evaluate$_warn$3(message, this.node.get$span(0), deprecation);
            },
            call$1: function(message) {
                return this.call$2(message, null);
            },
            $signature: 105
        };
        A._EvaluateVisitor_visitInterpolatedFunctionExpression_closure0.prototype = {
            call$0: function() {
                var t1 = this.node;
                return this.$this._async_evaluate$_runFunctionCallable$3(t1.$arguments, this.$function, t1);
            },
            $signature: 72
        };
        A._EvaluateVisitor__runUserDefinedCallable_closure0.prototype = {
            call$0: function() {
                var _this = this, t1 = _this.$this, t2 = _this.callable, t3 = _this.V;
                return t1._async_evaluate$_withEnvironment$1$2(t2.environment.closure$0(), new A._EvaluateVisitor__runUserDefinedCallable__closure0(t1, _this.evaluated, t2, _this.nodeWithSpan, _this.run, t3), t3);
            },
            $signature: function() {
                return this.V._eval$1("Future<0>()");
            }
        };
        A._EvaluateVisitor__runUserDefinedCallable__closure0.prototype = {
            call$0: function() {
                var _this = this, t1 = _this.$this, t2 = _this.V;
                return t1._async_evaluate$_environment.scope$1$1(new A._EvaluateVisitor__runUserDefinedCallable___closure0(t1, _this.evaluated, _this.callable, _this.nodeWithSpan, _this.run, t2), t2);
            },
            $signature: function() {
                return this.V._eval$1("Future<0>()");
            }
        };
        A._EvaluateVisitor__runUserDefinedCallable___closure0.prototype = {
            call$0: function() {
                return this.$call$body$_EvaluateVisitor__runUserDefinedCallable___closure(this.V);
            },
            $call$body$_EvaluateVisitor__runUserDefinedCallable___closure: function($async$type) {
                var $async$goto = 0, $async$completer = A._makeAsyncAwaitCompleter($async$type), $async$returnValue, $async$self = this, parameters, t5, minLength, i, parameter, t6, value, t7, t8, restParameter, rest, argumentList, result, parameterWord, t1, t2, t3, t4, $async$temp1;
                var $async$call$0 = A._wrapJsFunctionForAsync(function($async$errorCode, $async$result) {
                    if ($async$errorCode === 1) return A._asyncRethrow($async$result, $async$completer);
                    for(;;)switch($async$goto){
                        case 0:
                            // Function start
                            t1 = $async$self.$this;
                            t2 = $async$self.evaluated._values;
                            t3 = $async$self.callable.declaration.parameters;
                            t4 = $async$self.nodeWithSpan;
                            t1._async_evaluate$_verifyArguments$4(J.get$length$asx(t2[2]), t2[0], t3, t4);
                            parameters = t3.parameters;
                            t5 = parameters.length;
                            minLength = Math.min(J.get$length$asx(t2[2]), t5);
                            for(i = 0; i < minLength; ++i)t1._async_evaluate$_environment.setLocalVariable$3(parameters[i].name, J.$index$asx(t2[2], i), J.$index$asx(t2[3], i));
                            i = J.get$length$asx(t2[2]);
                        case 3:
                            // for condition
                            if (!(i < t5)) {
                                // goto after for
                                $async$goto = 5;
                                break;
                            }
                            parameter = parameters[i];
                            t6 = parameter.name;
                            value = t2[0].remove$1(0, t6);
                            $async$goto = value == null ? 6 : 7;
                            break;
                        case 6:
                            // then
                            t7 = parameter.defaultValue;
                            $async$temp1 = t1;
                            $async$goto = 8;
                            return A._asyncAwait(t7.accept$1(t1), $async$call$0);
                        case 8:
                            // returning from await.
                            value = $async$temp1._async_evaluate$_withoutSlash$2($async$result, t1._async_evaluate$_expressionNode$1(t7));
                        case 7:
                            // join
                            t7 = t1._async_evaluate$_environment;
                            t8 = t2[1].$index(0, t6);
                            if (t8 == null) {
                                t8 = parameter.defaultValue;
                                t8.toString;
                                t8 = t1._async_evaluate$_expressionNode$1(t8);
                            }
                            t7.setLocalVariable$3(t6, value, t8);
                        case 4:
                            // for update
                            ++i;
                            // goto for condition
                            $async$goto = 3;
                            break;
                        case 5:
                            // after for
                            restParameter = t3.restParameter;
                            if (restParameter != null) {
                                rest = J.get$length$asx(t2[2]) > t5 ? J.sublist$1$ax(t2[2], t5) : B.List_empty8;
                                t5 = t2[0];
                                t6 = t2[4];
                                argumentList = A.SassArgumentList$(rest, t5, t6 === B.ListSeparator_undecided_null_3_undecided ? B.ListSeparator_z0K : t6);
                                t1._async_evaluate$_environment.setLocalVariable$3(restParameter, argumentList, t4);
                            } else argumentList = null;
                            $async$goto = 9;
                            return A._asyncAwait($async$self.run.call$0(), $async$call$0);
                        case 9:
                            // returning from await.
                            result = $async$result;
                            if (argumentList == null) {
                                $async$returnValue = result;
                                // goto return
                                $async$goto = 1;
                                break;
                            }
                            t5 = t2[0];
                            if (t5.get$isEmpty(t5)) {
                                $async$returnValue = result;
                                // goto return
                                $async$goto = 1;
                                break;
                            }
                            if (argumentList._wereKeywordsAccessed) {
                                $async$returnValue = result;
                                // goto return
                                $async$goto = 1;
                                break;
                            }
                            t5 = t2[0];
                            t5 = t5.get$keys(t5);
                            parameterWord = A.pluralize("parameter", t5.get$length(t5), null);
                            t2 = t2[0];
                            t2 = t2.get$keys(t2);
                            throw A.wrapException(A.MultiSpanSassRuntimeException$("No " + parameterWord + " named " + A.toSentence(t2.map$1$1(t2, new A._EvaluateVisitor__runUserDefinedCallable____closure0(), type$.Object), "or") + ".", t4.get$span(t4), "invocation", A.LinkedHashMap_LinkedHashMap$_literal([
                                t3.get$spanWithName(),
                                "declaration"
                            ], type$.FileSpan, type$.String), t1._async_evaluate$_stackTrace$1(t4.get$span(t4)), null));
                        case 1:
                            // return
                            return A._asyncReturn($async$returnValue, $async$completer);
                    }
                });
                return A._asyncStartSync($async$call$0, $async$completer);
            },
            $signature: function() {
                return this.V._eval$1("Future<0>()");
            }
        };
        A._EvaluateVisitor__runUserDefinedCallable____closure0.prototype = {
            call$1: function($name) {
                return "$" + $name;
            },
            $signature: 6
        };
        A._EvaluateVisitor__runFunctionCallable_closure0.prototype = {
            call$0: function() {
                var $async$goto = 0, $async$completer = A._makeAsyncAwaitCompleter(type$.Value), $async$returnValue, $async$self = this, t1, t2, t3, t4, _i, $returnValue;
                var $async$call$0 = A._wrapJsFunctionForAsync(function($async$errorCode, $async$result) {
                    if ($async$errorCode === 1) return A._asyncRethrow($async$result, $async$completer);
                    for(;;)switch($async$goto){
                        case 0:
                            // Function start
                            t1 = $async$self.callable.declaration, t2 = t1.children, t3 = t2.length, t4 = $async$self.$this, _i = 0;
                        case 3:
                            // for condition
                            if (!(_i < t3)) {
                                // goto after for
                                $async$goto = 5;
                                break;
                            }
                            $async$goto = 6;
                            return A._asyncAwait(t2[_i].accept$1(t4), $async$call$0);
                        case 6:
                            // returning from await.
                            $returnValue = $async$result;
                            if ($returnValue instanceof A.Value) {
                                $async$returnValue = $returnValue;
                                // goto return
                                $async$goto = 1;
                                break;
                            }
                        case 4:
                            // for update
                            ++_i;
                            // goto for condition
                            $async$goto = 3;
                            break;
                        case 5:
                            // after for
                            throw A.wrapException(t4._async_evaluate$_exception$2("Function finished without @return.", t1.span));
                        case 1:
                            // return
                            return A._asyncReturn($async$returnValue, $async$completer);
                    }
                });
                return A._asyncStartSync($async$call$0, $async$completer);
            },
            $signature: 72
        };
        A._EvaluateVisitor__runBuiltInCallable_closure2.prototype = {
            call$0: function() {
                return this._box_0.overload.verify$2(J.get$length$asx(this.evaluated._values[2]), this.namedSet);
            },
            $signature: 0
        };
        A._EvaluateVisitor__runBuiltInCallable_closure3.prototype = {
            call$0: function() {
                return this._box_0.callback.call$1(this.evaluated._values[2]);
            },
            $signature: 533
        };
        A._EvaluateVisitor__runBuiltInCallable_closure4.prototype = {
            call$1: function($name) {
                return "$" + $name;
            },
            $signature: 6
        };
        A._EvaluateVisitor__evaluateArguments_closure3.prototype = {
            call$1: function(value) {
                return value;
            },
            $signature: 43
        };
        A._EvaluateVisitor__evaluateArguments_closure4.prototype = {
            call$1: function(value) {
                return this.$this._async_evaluate$_withoutSlash$2(value, this.restNodeForSpan);
            },
            $signature: 43
        };
        A._EvaluateVisitor__evaluateArguments_closure5.prototype = {
            call$2: function(key, value) {
                var _this = this, t1 = _this.restNodeForSpan;
                _this.named.$indexSet(0, key, _this.$this._async_evaluate$_withoutSlash$2(value, t1));
                _this.namedNodes.$indexSet(0, key, t1);
            },
            $signature: 109
        };
        A._EvaluateVisitor__evaluateArguments_closure6.prototype = {
            call$1: function(value) {
                return value;
            },
            $signature: 43
        };
        A._EvaluateVisitor__evaluateMacroArguments_closure3.prototype = {
            call$1: function(value) {
                var t1 = this.restArgs;
                return new A.ValueExpression(value, t1.get$span(t1));
            },
            $signature: 60
        };
        A._EvaluateVisitor__evaluateMacroArguments_closure4.prototype = {
            call$1: function(value) {
                var t1 = this.restArgs;
                return new A.ValueExpression(this.$this._async_evaluate$_withoutSlash$2(value, this.restNodeForSpan), t1.get$span(t1));
            },
            $signature: 60
        };
        A._EvaluateVisitor__evaluateMacroArguments_closure5.prototype = {
            call$2: function(key, value) {
                var _this = this, t1 = _this.restArgs;
                _this.named.$indexSet(0, key, new A.ValueExpression(_this.$this._async_evaluate$_withoutSlash$2(value, _this.restNodeForSpan), t1.get$span(t1)));
            },
            $signature: 109
        };
        A._EvaluateVisitor__evaluateMacroArguments_closure6.prototype = {
            call$1: function(value) {
                var t1 = this.keywordRestArgs;
                return new A.ValueExpression(this.$this._async_evaluate$_withoutSlash$2(value, this.keywordRestNodeForSpan), t1.get$span(t1));
            },
            $signature: 60
        };
        A._EvaluateVisitor__addRestMap_closure0.prototype = {
            call$2: function(key, value) {
                var t2, _this = this, t1 = _this.$this;
                if (key instanceof A.SassString) _this.values.$indexSet(0, key._string$_text, _this.convert.call$1(t1._async_evaluate$_withoutSlash$2(value, _this.expressionNode)));
                else {
                    t2 = _this.nodeWithSpan;
                    throw A.wrapException(t1._async_evaluate$_exception$2(string$.Variab_ + key.toString$0(0) + " is not a string in " + _this.map.toString$0(0) + ".", t2.get$span(t2)));
                }
            },
            $signature: 99
        };
        A._EvaluateVisitor__verifyArguments_closure0.prototype = {
            call$0: function() {
                return this.parameters.verify$2(this.positional, new A.MapKeySet(this.named, type$.MapKeySet_String));
            },
            $signature: 0
        };
        A._EvaluateVisitor_visitCssAtRule_closure2.prototype = {
            call$0: function() {
                var $async$goto = 0, $async$completer = A._makeAsyncAwaitCompleter(type$.Null), $async$self = this, t1, t2, t3, t4;
                var $async$call$0 = A._wrapJsFunctionForAsync(function($async$errorCode, $async$result) {
                    if ($async$errorCode === 1) return A._asyncRethrow($async$result, $async$completer);
                    for(;;)switch($async$goto){
                        case 0:
                            // Function start
                            t1 = $async$self.node.children, t2 = t1.$ti, t1 = new A.ListIterator(t1, t1.get$length(0), t2._eval$1("ListIterator<ListBase.E>")), t3 = $async$self.$this, t2 = t2._eval$1("ListBase.E");
                        case 2:
                            // for condition
                            if (!t1.moveNext$0()) {
                                // goto after for
                                $async$goto = 3;
                                break;
                            }
                            t4 = t1.__internal$_current;
                            $async$goto = 4;
                            return A._asyncAwait((t4 == null ? t2._as(t4) : t4).accept$1(t3), $async$call$0);
                        case 4:
                            // returning from await.
                            // goto for condition
                            $async$goto = 2;
                            break;
                        case 3:
                            // after for
                            // implicit return
                            return A._asyncReturn(null, $async$completer);
                    }
                });
                return A._asyncStartSync($async$call$0, $async$completer);
            },
            $signature: 2
        };
        A._EvaluateVisitor_visitCssAtRule_closure3.prototype = {
            call$0: function() {
                var $async$goto = 0, $async$completer = A._makeAsyncAwaitCompleter(type$.Null), $async$self = this, t1, t2, t3, t4;
                var $async$call$0 = A._wrapJsFunctionForAsync(function($async$errorCode, $async$result) {
                    if ($async$errorCode === 1) return A._asyncRethrow($async$result, $async$completer);
                    for(;;)switch($async$goto){
                        case 0:
                            // Function start
                            t1 = $async$self.node.children, t2 = t1.$ti, t1 = new A.ListIterator(t1, t1.get$length(0), t2._eval$1("ListIterator<ListBase.E>")), t3 = $async$self.$this, t2 = t2._eval$1("ListBase.E");
                        case 2:
                            // for condition
                            if (!t1.moveNext$0()) {
                                // goto after for
                                $async$goto = 3;
                                break;
                            }
                            t4 = t1.__internal$_current;
                            $async$goto = 4;
                            return A._asyncAwait((t4 == null ? t2._as(t4) : t4).accept$1(t3), $async$call$0);
                        case 4:
                            // returning from await.
                            // goto for condition
                            $async$goto = 2;
                            break;
                        case 3:
                            // after for
                            // implicit return
                            return A._asyncReturn(null, $async$completer);
                    }
                });
                return A._asyncStartSync($async$call$0, $async$completer);
            },
            $signature: 2
        };
        A._EvaluateVisitor_visitCssAtRule_closure4.prototype = {
            call$1: function(node) {
                return node instanceof A.ModifiableCssStyleRule;
            },
            $signature: 7
        };
        A._EvaluateVisitor_visitCssKeyframeBlock_closure1.prototype = {
            call$0: function() {
                var $async$goto = 0, $async$completer = A._makeAsyncAwaitCompleter(type$.Null), $async$self = this, t1, t2, t3, t4;
                var $async$call$0 = A._wrapJsFunctionForAsync(function($async$errorCode, $async$result) {
                    if ($async$errorCode === 1) return A._asyncRethrow($async$result, $async$completer);
                    for(;;)switch($async$goto){
                        case 0:
                            // Function start
                            t1 = $async$self.node.children, t2 = t1.$ti, t1 = new A.ListIterator(t1, t1.get$length(0), t2._eval$1("ListIterator<ListBase.E>")), t3 = $async$self.$this, t2 = t2._eval$1("ListBase.E");
                        case 2:
                            // for condition
                            if (!t1.moveNext$0()) {
                                // goto after for
                                $async$goto = 3;
                                break;
                            }
                            t4 = t1.__internal$_current;
                            $async$goto = 4;
                            return A._asyncAwait((t4 == null ? t2._as(t4) : t4).accept$1(t3), $async$call$0);
                        case 4:
                            // returning from await.
                            // goto for condition
                            $async$goto = 2;
                            break;
                        case 3:
                            // after for
                            // implicit return
                            return A._asyncReturn(null, $async$completer);
                    }
                });
                return A._asyncStartSync($async$call$0, $async$completer);
            },
            $signature: 2
        };
        A._EvaluateVisitor_visitCssKeyframeBlock_closure2.prototype = {
            call$1: function(node) {
                return node instanceof A.ModifiableCssStyleRule;
            },
            $signature: 7
        };
        A._EvaluateVisitor_visitCssMediaRule_closure3.prototype = {
            call$0: function() {
                var $async$goto = 0, $async$completer = A._makeAsyncAwaitCompleter(type$.Null), $async$self = this, t1, t2, t3, t4;
                var $async$call$0 = A._wrapJsFunctionForAsync(function($async$errorCode, $async$result) {
                    if ($async$errorCode === 1) return A._asyncRethrow($async$result, $async$completer);
                    for(;;)switch($async$goto){
                        case 0:
                            // Function start
                            t1 = $async$self.node.children, t2 = t1.$ti, t1 = new A.ListIterator(t1, t1.get$length(0), t2._eval$1("ListIterator<ListBase.E>")), t3 = $async$self.$this, t2 = t2._eval$1("ListBase.E");
                        case 2:
                            // for condition
                            if (!t1.moveNext$0()) {
                                // goto after for
                                $async$goto = 3;
                                break;
                            }
                            t4 = t1.__internal$_current;
                            $async$goto = 4;
                            return A._asyncAwait((t4 == null ? t2._as(t4) : t4).accept$1(t3), $async$call$0);
                        case 4:
                            // returning from await.
                            // goto for condition
                            $async$goto = 2;
                            break;
                        case 3:
                            // after for
                            // implicit return
                            return A._asyncReturn(null, $async$completer);
                    }
                });
                return A._asyncStartSync($async$call$0, $async$completer);
            },
            $signature: 2
        };
        A._EvaluateVisitor_visitCssMediaRule_closure4.prototype = {
            call$1: function(mediaQueries) {
                return this.$this._async_evaluate$_mergeMediaQueries$2(mediaQueries, this.node.queries);
            },
            $signature: 89
        };
        A._EvaluateVisitor_visitCssMediaRule_closure5.prototype = {
            call$0: function() {
                var $async$goto = 0, $async$completer = A._makeAsyncAwaitCompleter(type$.Null), $async$self = this, t1, t2;
                var $async$call$0 = A._wrapJsFunctionForAsync(function($async$errorCode, $async$result) {
                    if ($async$errorCode === 1) return A._asyncRethrow($async$result, $async$completer);
                    for(;;)switch($async$goto){
                        case 0:
                            // Function start
                            t1 = $async$self.$this;
                            t2 = $async$self.mergedQueries;
                            if (t2 == null) t2 = $async$self.node.queries;
                            $async$goto = 2;
                            return A._asyncAwait(t1._async_evaluate$_withMediaQueries$1$3(t2, $async$self.mergedSources, new A._EvaluateVisitor_visitCssMediaRule__closure0(t1, $async$self.node), type$.Null), $async$call$0);
                        case 2:
                            // returning from await.
                            // implicit return
                            return A._asyncReturn(null, $async$completer);
                    }
                });
                return A._asyncStartSync($async$call$0, $async$completer);
            },
            $signature: 2
        };
        A._EvaluateVisitor_visitCssMediaRule__closure0.prototype = {
            call$0: function() {
                var $async$goto = 0, $async$completer = A._makeAsyncAwaitCompleter(type$.Null), $async$self = this, t2, t3, t4, t1, _0_0;
                var $async$call$0 = A._wrapJsFunctionForAsync(function($async$errorCode, $async$result) {
                    if ($async$errorCode === 1) return A._asyncRethrow($async$result, $async$completer);
                    for(;;)switch($async$goto){
                        case 0:
                            // Function start
                            t1 = $async$self.$this;
                            _0_0 = t1._async_evaluate$_atRootExcludingStyleRule ? null : t1._async_evaluate$_styleRuleIgnoringAtRoot;
                            $async$goto = _0_0 != null ? 2 : 4;
                            break;
                        case 2:
                            // then
                            $async$goto = 5;
                            return A._asyncAwait(t1._async_evaluate$_withParent$2$3$scopeWhen(A.ModifiableCssStyleRule$(_0_0._style_rule$_selector, _0_0.span, false, _0_0.originalSelector), new A._EvaluateVisitor_visitCssMediaRule___closure0(t1, $async$self.node), false, type$.ModifiableCssStyleRule, type$.Null), $async$call$0);
                        case 5:
                            // returning from await.
                            // goto join
                            $async$goto = 3;
                            break;
                        case 4:
                            // else
                            t2 = $async$self.node.children, t3 = t2.$ti, t2 = new A.ListIterator(t2, t2.get$length(0), t3._eval$1("ListIterator<ListBase.E>")), t3 = t3._eval$1("ListBase.E");
                        case 6:
                            // for condition
                            if (!t2.moveNext$0()) {
                                // goto after for
                                $async$goto = 7;
                                break;
                            }
                            t4 = t2.__internal$_current;
                            $async$goto = 8;
                            return A._asyncAwait((t4 == null ? t3._as(t4) : t4).accept$1(t1), $async$call$0);
                        case 8:
                            // returning from await.
                            // goto for condition
                            $async$goto = 6;
                            break;
                        case 7:
                        // after for
                        case 3:
                            // join
                            // implicit return
                            return A._asyncReturn(null, $async$completer);
                    }
                });
                return A._asyncStartSync($async$call$0, $async$completer);
            },
            $signature: 2
        };
        A._EvaluateVisitor_visitCssMediaRule___closure0.prototype = {
            call$0: function() {
                var $async$goto = 0, $async$completer = A._makeAsyncAwaitCompleter(type$.Null), $async$self = this, t1, t2, t3, t4;
                var $async$call$0 = A._wrapJsFunctionForAsync(function($async$errorCode, $async$result) {
                    if ($async$errorCode === 1) return A._asyncRethrow($async$result, $async$completer);
                    for(;;)switch($async$goto){
                        case 0:
                            // Function start
                            t1 = $async$self.node.children, t2 = t1.$ti, t1 = new A.ListIterator(t1, t1.get$length(0), t2._eval$1("ListIterator<ListBase.E>")), t3 = $async$self.$this, t2 = t2._eval$1("ListBase.E");
                        case 2:
                            // for condition
                            if (!t1.moveNext$0()) {
                                // goto after for
                                $async$goto = 3;
                                break;
                            }
                            t4 = t1.__internal$_current;
                            $async$goto = 4;
                            return A._asyncAwait((t4 == null ? t2._as(t4) : t4).accept$1(t3), $async$call$0);
                        case 4:
                            // returning from await.
                            // goto for condition
                            $async$goto = 2;
                            break;
                        case 3:
                            // after for
                            // implicit return
                            return A._asyncReturn(null, $async$completer);
                    }
                });
                return A._asyncStartSync($async$call$0, $async$completer);
            },
            $signature: 2
        };
        A._EvaluateVisitor_visitCssMediaRule_closure6.prototype = {
            call$1: function(node) {
                var t1;
                if (!(node instanceof A.ModifiableCssStyleRule)) {
                    t1 = this.mergedSources;
                    t1 = t1.get$isNotEmpty(t1) && node instanceof A.ModifiableCssMediaRule && B.JSArray_methods.every$1(node.queries, t1.get$contains(t1));
                } else t1 = true;
                return t1;
            },
            $signature: 7
        };
        A._EvaluateVisitor_visitCssStyleRule_closure2.prototype = {
            call$0: function() {
                var $async$goto = 0, $async$completer = A._makeAsyncAwaitCompleter(type$.Null), $async$self = this, t1;
                var $async$call$0 = A._wrapJsFunctionForAsync(function($async$errorCode, $async$result) {
                    if ($async$errorCode === 1) return A._asyncRethrow($async$result, $async$completer);
                    for(;;)switch($async$goto){
                        case 0:
                            // Function start
                            t1 = $async$self.$this;
                            $async$goto = 2;
                            return A._asyncAwait(t1._async_evaluate$_withStyleRule$1$2($async$self.rule, new A._EvaluateVisitor_visitCssStyleRule__closure0(t1, $async$self.node), type$.Null), $async$call$0);
                        case 2:
                            // returning from await.
                            // implicit return
                            return A._asyncReturn(null, $async$completer);
                    }
                });
                return A._asyncStartSync($async$call$0, $async$completer);
            },
            $signature: 2
        };
        A._EvaluateVisitor_visitCssStyleRule__closure0.prototype = {
            call$0: function() {
                var $async$goto = 0, $async$completer = A._makeAsyncAwaitCompleter(type$.Null), $async$self = this, t1, t2, t3, t4;
                var $async$call$0 = A._wrapJsFunctionForAsync(function($async$errorCode, $async$result) {
                    if ($async$errorCode === 1) return A._asyncRethrow($async$result, $async$completer);
                    for(;;)switch($async$goto){
                        case 0:
                            // Function start
                            t1 = $async$self.node.children, t2 = t1.$ti, t1 = new A.ListIterator(t1, t1.get$length(0), t2._eval$1("ListIterator<ListBase.E>")), t3 = $async$self.$this, t2 = t2._eval$1("ListBase.E");
                        case 2:
                            // for condition
                            if (!t1.moveNext$0()) {
                                // goto after for
                                $async$goto = 3;
                                break;
                            }
                            t4 = t1.__internal$_current;
                            $async$goto = 4;
                            return A._asyncAwait((t4 == null ? t2._as(t4) : t4).accept$1(t3), $async$call$0);
                        case 4:
                            // returning from await.
                            // goto for condition
                            $async$goto = 2;
                            break;
                        case 3:
                            // after for
                            // implicit return
                            return A._asyncReturn(null, $async$completer);
                    }
                });
                return A._asyncStartSync($async$call$0, $async$completer);
            },
            $signature: 2
        };
        A._EvaluateVisitor_visitCssStyleRule_closure1.prototype = {
            call$1: function(node) {
                return node instanceof A.ModifiableCssStyleRule;
            },
            $signature: 7
        };
        A._EvaluateVisitor_visitCssSupportsRule_closure2.prototype = {
            call$0: function() {
                var $async$goto = 0, $async$completer = A._makeAsyncAwaitCompleter(type$.Null), $async$self = this, t1, t2, t3, t4;
                var $async$call$0 = A._wrapJsFunctionForAsync(function($async$errorCode, $async$result) {
                    if ($async$errorCode === 1) return A._asyncRethrow($async$result, $async$completer);
                    for(;;)switch($async$goto){
                        case 0:
                            // Function start
                            t1 = $async$self.node.children, t2 = t1.$ti, t1 = new A.ListIterator(t1, t1.get$length(0), t2._eval$1("ListIterator<ListBase.E>")), t3 = $async$self.$this, t2 = t2._eval$1("ListBase.E");
                        case 2:
                            // for condition
                            if (!t1.moveNext$0()) {
                                // goto after for
                                $async$goto = 3;
                                break;
                            }
                            t4 = t1.__internal$_current;
                            $async$goto = 4;
                            return A._asyncAwait((t4 == null ? t2._as(t4) : t4).accept$1(t3), $async$call$0);
                        case 4:
                            // returning from await.
                            // goto for condition
                            $async$goto = 2;
                            break;
                        case 3:
                            // after for
                            // implicit return
                            return A._asyncReturn(null, $async$completer);
                    }
                });
                return A._asyncStartSync($async$call$0, $async$completer);
            },
            $signature: 2
        };
        A._EvaluateVisitor_visitCssSupportsRule_closure3.prototype = {
            call$0: function() {
                var $async$goto = 0, $async$completer = A._makeAsyncAwaitCompleter(type$.Null), $async$self = this, t2, t3, t4, t1, _0_0;
                var $async$call$0 = A._wrapJsFunctionForAsync(function($async$errorCode, $async$result) {
                    if ($async$errorCode === 1) return A._asyncRethrow($async$result, $async$completer);
                    for(;;)switch($async$goto){
                        case 0:
                            // Function start
                            t1 = $async$self.$this;
                            _0_0 = t1._async_evaluate$_atRootExcludingStyleRule ? null : t1._async_evaluate$_styleRuleIgnoringAtRoot;
                            $async$goto = _0_0 != null ? 2 : 4;
                            break;
                        case 2:
                            // then
                            $async$goto = 5;
                            return A._asyncAwait(t1._async_evaluate$_withParent$2$2(A.ModifiableCssStyleRule$(_0_0._style_rule$_selector, _0_0.span, false, _0_0.originalSelector), new A._EvaluateVisitor_visitCssSupportsRule__closure0(t1, $async$self.node), type$.ModifiableCssStyleRule, type$.Null), $async$call$0);
                        case 5:
                            // returning from await.
                            // goto join
                            $async$goto = 3;
                            break;
                        case 4:
                            // else
                            t2 = $async$self.node.children, t3 = t2.$ti, t2 = new A.ListIterator(t2, t2.get$length(0), t3._eval$1("ListIterator<ListBase.E>")), t3 = t3._eval$1("ListBase.E");
                        case 6:
                            // for condition
                            if (!t2.moveNext$0()) {
                                // goto after for
                                $async$goto = 7;
                                break;
                            }
                            t4 = t2.__internal$_current;
                            $async$goto = 8;
                            return A._asyncAwait((t4 == null ? t3._as(t4) : t4).accept$1(t1), $async$call$0);
                        case 8:
                            // returning from await.
                            // goto for condition
                            $async$goto = 6;
                            break;
                        case 7:
                        // after for
                        case 3:
                            // join
                            // implicit return
                            return A._asyncReturn(null, $async$completer);
                    }
                });
                return A._asyncStartSync($async$call$0, $async$completer);
            },
            $signature: 2
        };
        A._EvaluateVisitor_visitCssSupportsRule__closure0.prototype = {
            call$0: function() {
                var $async$goto = 0, $async$completer = A._makeAsyncAwaitCompleter(type$.Null), $async$self = this, t1, t2, t3, t4;
                var $async$call$0 = A._wrapJsFunctionForAsync(function($async$errorCode, $async$result) {
                    if ($async$errorCode === 1) return A._asyncRethrow($async$result, $async$completer);
                    for(;;)switch($async$goto){
                        case 0:
                            // Function start
                            t1 = $async$self.node.children, t2 = t1.$ti, t1 = new A.ListIterator(t1, t1.get$length(0), t2._eval$1("ListIterator<ListBase.E>")), t3 = $async$self.$this, t2 = t2._eval$1("ListBase.E");
                        case 2:
                            // for condition
                            if (!t1.moveNext$0()) {
                                // goto after for
                                $async$goto = 3;
                                break;
                            }
                            t4 = t1.__internal$_current;
                            $async$goto = 4;
                            return A._asyncAwait((t4 == null ? t2._as(t4) : t4).accept$1(t3), $async$call$0);
                        case 4:
                            // returning from await.
                            // goto for condition
                            $async$goto = 2;
                            break;
                        case 3:
                            // after for
                            // implicit return
                            return A._asyncReturn(null, $async$completer);
                    }
                });
                return A._asyncStartSync($async$call$0, $async$completer);
            },
            $signature: 2
        };
        A._EvaluateVisitor_visitCssSupportsRule_closure4.prototype = {
            call$1: function(node) {
                return node instanceof A.ModifiableCssStyleRule;
            },
            $signature: 7
        };
        A._EvaluateVisitor__performInterpolationHelper_closure0.prototype = {
            call$1: function(targetOffsets) {
                return A.InterpolationMap$(this.interpolation, targetOffsets);
            },
            $signature: 143
        };
        A._EvaluateVisitor__serialize_closure0.prototype = {
            call$0: function() {
                return A.serializeValue(this.value, false, this.quote);
            },
            $signature: 29
        };
        A._EvaluateVisitor__expressionNode_closure0.prototype = {
            call$0: function() {
                var t1 = this.expression;
                return this.$this._async_evaluate$_environment.getVariableNode$2$namespace(t1.name, t1.namespace);
            },
            $signature: 188
        };
        A._EvaluateVisitor__withoutSlash_recommendation0.prototype = {
            call$1: function(number) {
                var before, after, t1, _1_0 = number.asSlash;
                $label0$0: {
                    if (type$.Record_2_nullable_Object_and_nullable_Object._is(_1_0)) {
                        before = _1_0._0;
                        after = _1_0._1;
                        t1 = "math.div(" + A.S(this.call$1(before)) + ", " + A.S(this.call$1(after)) + ")";
                        break $label0$0;
                    }
                    t1 = A.serializeValue(number, true, true);
                    break $label0$0;
                }
                return t1;
            },
            $signature: 189
        };
        A._EvaluateVisitor__stackFrame_closure0.prototype = {
            call$1: function(url) {
                var t1 = this.$this._async_evaluate$_importCache;
                t1 = t1 == null ? null : t1.humanize$1(url);
                return t1 == null ? url : t1;
            },
            $signature: 49
        };
        A._ImportedCssVisitor0.prototype = {
            visitCssAtRule$1: function(node) {
                var t1 = node.isChildless ? null : new A._ImportedCssVisitor_visitCssAtRule_closure0();
                this._async_evaluate$_visitor._async_evaluate$_addChild$2$through(node, t1);
            },
            visitCssComment$1: function(node) {
                return this._async_evaluate$_visitor._async_evaluate$_addChild$1(node);
            },
            visitCssDeclaration$1: function(node) {
                return this._async_evaluate$_visitor._async_evaluate$_addChild$1(node);
            },
            visitCssImport$1: function(node) {
                var t2, _s13_ = "_endOfImports", t1 = this._async_evaluate$_visitor;
                if (t1._async_evaluate$_assertInModule$2(t1._async_evaluate$__parent, "__parent") !== t1._async_evaluate$_assertInModule$2(t1._async_evaluate$__root, "_root")) t1._async_evaluate$_addChild$1(node);
                else if (t1._async_evaluate$_assertInModule$2(t1._async_evaluate$__endOfImports, _s13_) === J.get$length$asx(t1._async_evaluate$_assertInModule$2(t1._async_evaluate$__root, "_root").children._collection$_source)) {
                    t1._async_evaluate$_addChild$1(node);
                    t1._async_evaluate$__endOfImports = t1._async_evaluate$_assertInModule$2(t1._async_evaluate$__endOfImports, _s13_) + 1;
                } else {
                    t2 = t1._async_evaluate$_outOfOrderImports;
                    (t2 == null ? t1._async_evaluate$_outOfOrderImports = A._setArrayType([], type$.JSArray_ModifiableCssImport) : t2).push(node);
                }
            },
            visitCssKeyframeBlock$1: function(node) {},
            visitCssMediaRule$1: function(node) {
                var t1 = this._async_evaluate$_visitor, mediaQueries = t1._async_evaluate$_mediaQueries;
                t1._async_evaluate$_addChild$2$through(node, new A._ImportedCssVisitor_visitCssMediaRule_closure0(mediaQueries == null || t1._async_evaluate$_mergeMediaQueries$2(mediaQueries, node.queries) != null));
            },
            visitCssStyleRule$1: function(node) {
                return this._async_evaluate$_visitor._async_evaluate$_addChild$2$through(node, new A._ImportedCssVisitor_visitCssStyleRule_closure0());
            },
            visitCssStylesheet$1: function(node) {
                var t1, t2, t3;
                for(t1 = node.children, t2 = t1.$ti, t1 = new A.ListIterator(t1, t1.get$length(0), t2._eval$1("ListIterator<ListBase.E>")), t2 = t2._eval$1("ListBase.E"); t1.moveNext$0();){
                    t3 = t1.__internal$_current;
                    (t3 == null ? t2._as(t3) : t3).accept$1(this);
                }
            },
            visitCssSupportsRule$1: function(node) {
                return this._async_evaluate$_visitor._async_evaluate$_addChild$2$through(node, new A._ImportedCssVisitor_visitCssSupportsRule_closure0());
            }
        };
        A._ImportedCssVisitor_visitCssAtRule_closure0.prototype = {
            call$1: function(node) {
                return node instanceof A.ModifiableCssStyleRule;
            },
            $signature: 7
        };
        A._ImportedCssVisitor_visitCssMediaRule_closure0.prototype = {
            call$1: function(node) {
                var t1;
                if (!(node instanceof A.ModifiableCssStyleRule)) t1 = this.hasBeenMerged && node instanceof A.ModifiableCssMediaRule;
                else t1 = true;
                return t1;
            },
            $signature: 7
        };
        A._ImportedCssVisitor_visitCssStyleRule_closure0.prototype = {
            call$1: function(node) {
                return node instanceof A.ModifiableCssStyleRule;
            },
            $signature: 7
        };
        A._ImportedCssVisitor_visitCssSupportsRule_closure0.prototype = {
            call$1: function(node) {
                return node instanceof A.ModifiableCssStyleRule;
            },
            $signature: 7
        };
        A._EvaluationContext0.prototype = {
            get$currentCallableSpan: function() {
                var _0_0 = this._async_evaluate$_visitor._async_evaluate$_callableNode;
                if (_0_0 != null) return _0_0.get$span(_0_0);
                throw A.wrapException(A.StateError$(string$.No_Sasc));
            },
            warn$2: function(_, message, deprecation) {
                var t1 = this._async_evaluate$_visitor, t2 = t1._async_evaluate$_importSpan;
                if (t2 == null) {
                    t2 = t1._async_evaluate$_callableNode;
                    t2 = t2 == null ? null : t2.get$span(t2);
                }
                t1._async_evaluate$_warn$3(message, t2 == null ? this._async_evaluate$_defaultWarnNodeWithSpan.span : t2, deprecation);
            }
        };
        A._CloneCssVisitor.prototype = {
            visitCssAtRule$1: function(node) {
                var t1 = node.isChildless, rule = A.ModifiableCssAtRule$(node.name, node.span, t1, node.value);
                return t1 ? rule : this._visitChildren$2(rule, node);
            },
            visitCssComment$1: function(node) {
                return new A.ModifiableCssComment(node.text, node.span);
            },
            visitCssDeclaration$1: function(node) {
                return A.ModifiableCssDeclaration$(node.name, node.value, node.span, node.parsedAsSassScript, node.valueSpanForMap);
            },
            visitCssImport$1: function(node) {
                return new A.ModifiableCssImport(node.url, node.modifiers, node.span);
            },
            visitCssKeyframeBlock$1: function(node) {
                return this._visitChildren$2(A.ModifiableCssKeyframeBlock$(node.selector, node.span), node);
            },
            visitCssMediaRule$1: function(node) {
                return this._visitChildren$2(A.ModifiableCssMediaRule$(node.queries, node.span), node);
            },
            visitCssStyleRule$1: function(node) {
                var _0_0 = this._oldToNewSelectors.$index(0, node._style_rule$_selector._box$_inner.value);
                if (_0_0 != null) return this._visitChildren$2(A.ModifiableCssStyleRule$(_0_0, node.span, false, node.originalSelector), node);
                else throw A.wrapException(A.StateError$(string$.The_Ex));
            },
            visitCssStylesheet$1: function(node) {
                return this._visitChildren$2(A.ModifiableCssStylesheet$(node.get$span(node)), node);
            },
            visitCssSupportsRule$1: function(node) {
                return this._visitChildren$2(A.ModifiableCssSupportsRule$(node.condition, node.span), node);
            },
            _visitChildren$1$2: function(newParent, oldParent) {
                var t1, t2, newChild;
                for(t1 = J.get$iterator$ax(oldParent.get$children(oldParent)); t1.moveNext$0();){
                    t2 = t1.get$current(t1);
                    newChild = t2.accept$1(this);
                    newChild.isGroupEnd = t2.get$isGroupEnd();
                    newParent.addChild$1(newChild);
                }
                return newParent;
            },
            _visitChildren$2: function(newParent, oldParent) {
                return this._visitChildren$1$2(newParent, oldParent, type$.ModifiableCssParentNode);
            }
        };
        A.Evaluator.prototype = {};
        A._EvaluateVisitor.prototype = {
            get$_hasCssNesting: function() {
                var _0_0, t1, grandparent, $parent = this._atRootExcludingStyleRule ? null : this._styleRuleIgnoringAtRoot;
                for(;; $parent = grandparent){
                    _0_0 = $parent == null ? null : $parent._parent;
                    if (_0_0 instanceof A.ModifiableCssStyleRule) return true;
                    t1 = _0_0 != null;
                    grandparent = t1 ? _0_0 : null;
                    if (t1) continue;
                    return false;
                }
            },
            _EvaluateVisitor$6$functions$importCache$logger$nodeImporter$quietDeps$sourceMap: function(functions, importCache, logger, nodeImporter, quietDeps, sourceMap) {
                var t2, metaModule, t3, _i, module, $function, t4, _this = this, _s20_ = "$name, $module: null", _s9_ = "sass:meta", _s7_ = "$module", t1 = type$.JSArray_BuiltInCallable, metaFunctions = A._setArrayType([
                    A.BuiltInCallable$function("global-variable-exists", _s20_, new A._EvaluateVisitor_closure(_this), _s9_),
                    A.BuiltInCallable$function("variable-exists", "$name", new A._EvaluateVisitor_closure0(_this), _s9_),
                    A.BuiltInCallable$function("function-exists", _s20_, new A._EvaluateVisitor_closure1(_this), _s9_),
                    A.BuiltInCallable$function("mixin-exists", _s20_, new A._EvaluateVisitor_closure2(_this), _s9_),
                    A.BuiltInCallable$function("content-exists", "", new A._EvaluateVisitor_closure3(_this), _s9_),
                    A.BuiltInCallable$function("module-variables", _s7_, new A._EvaluateVisitor_closure4(_this), _s9_),
                    A.BuiltInCallable$function("module-functions", _s7_, new A._EvaluateVisitor_closure5(_this), _s9_),
                    A.BuiltInCallable$function("module-mixins", _s7_, new A._EvaluateVisitor_closure6(_this), _s9_),
                    A.BuiltInCallable$function("get-function", "$name, $css: false, $module: null", new A._EvaluateVisitor_closure7(_this), _s9_),
                    A.BuiltInCallable$function("get-mixin", _s20_, new A._EvaluateVisitor_closure8(_this), _s9_),
                    A.BuiltInCallable$function("call", "$function, $args...", new A._EvaluateVisitor_closure9(_this), _s9_)
                ], t1), metaMixins = A._setArrayType([
                    A.BuiltInCallable$mixin("load-css", "$url, $with: null", new A._EvaluateVisitor_closure10(_this), false, _s9_),
                    A.BuiltInCallable$mixin("apply", "$mixin, $args...", new A._EvaluateVisitor_closure11(_this), true, _s9_)
                ], t1);
                t1 = type$.BuiltInCallable;
                t2 = A.List_List$_of($.$get$moduleFunctions(), t1);
                B.JSArray_methods.addAll$1(t2, metaFunctions);
                metaModule = A.BuiltInModule$("meta", t2, metaMixins, null, t1);
                t1 = A.List_List$_of($.$get$coreModules(), type$.BuiltInModule_Callable);
                t1.push(metaModule);
                t2 = t1.length;
                t3 = _this._builtInModules;
                _i = 0;
                for(; _i < t1.length; t1.length === t2 || (0, A.throwConcurrentModificationError)(t1), ++_i){
                    module = t1[_i];
                    t3.$indexSet(0, module.url, module);
                }
                t1 = type$.JSArray_Callable;
                t2 = A._setArrayType([], t1);
                B.JSArray_methods.addAll$1(t2, $.$get$globalFunctions());
                t1 = A._setArrayType([], t1);
                for(_i = 0; _i < 11; ++_i)t1.push(metaFunctions[_i].withDeprecationWarning$1("meta"));
                B.JSArray_methods.addAll$1(t2, t1);
                for(t1 = t2.length, t3 = _this._builtInFunctions, _i = 0; _i < t2.length; t2.length === t1 || (0, A.throwConcurrentModificationError)(t2), ++_i){
                    $function = t2[_i];
                    t4 = $function.get$name($function);
                    t3.$indexSet(0, A.stringReplaceAllUnchecked(t4, "_", "-"), $function);
                }
            },
            run$2: function(_, importer, node) {
                var error, stackTrace, t1, _$exception;
                try {
                    t1 = type$.nullable_Object;
                    t1 = A.runZoned(new A._EvaluateVisitor_run_closure(this, node, importer), A.LinkedHashMap_LinkedHashMap$_literal([
                        B.Symbol__evaluationContext,
                        new A._EvaluationContext(this, node)
                    ], t1, t1), type$.Record_2_Set_Uri_loadedUrls_and_CssStylesheet_stylesheet);
                    return t1;
                } catch (exception) {
                    t1 = A.unwrapException(exception);
                    if (t1 instanceof A.SassException) {
                        error = t1;
                        stackTrace = A.getTraceFromException(exception);
                        A.throwWithTrace(error.withLoadedUrls$1(this._loadedUrls), error, stackTrace);
                    } else throw exception;
                }
            },
            runExpression$2: function(importer, expression) {
                var t1 = type$.nullable_Object;
                return A.runZoned(new A._EvaluateVisitor_runExpression_closure(this, importer, expression), A.LinkedHashMap_LinkedHashMap$_literal([
                    B.Symbol__evaluationContext,
                    new A._EvaluationContext(this, expression)
                ], t1, t1), type$.Value);
            },
            runStatement$2: function(importer, statement) {
                var t1 = type$.nullable_Object;
                return A.runZoned(new A._EvaluateVisitor_runStatement_closure(this, importer, statement), A.LinkedHashMap_LinkedHashMap$_literal([
                    B.Symbol__evaluationContext,
                    new A._EvaluationContext(this, statement)
                ], t1, t1), type$.void);
            },
            _assertInModule$1$2: function(value, $name) {
                if (value != null) return value;
                throw A.wrapException(A.StateError$("Can't access " + $name + " outside of a module."));
            },
            _assertInModule$2: function(value, $name) {
                return this._assertInModule$1$2(value, $name, type$.dynamic);
            },
            _withFakeStylesheet$1$3: function(importer, nodeWithSpan, callback) {
                var t1, _this = this, oldImporter = _this._importer;
                _this._importer = importer;
                _this.__stylesheet = A.Stylesheet$(B.List_empty16, nodeWithSpan.get$span(nodeWithSpan));
                try {
                    t1 = callback.call$0();
                    return t1;
                } finally{
                    _this._importer = oldImporter;
                    _this.__stylesheet = null;
                }
            },
            _withFakeStylesheet$3: function(importer, nodeWithSpan, callback) {
                return this._withFakeStylesheet$1$3(importer, nodeWithSpan, callback, type$.dynamic);
            },
            _loadModule$7$baseUrl$configuration$namesInErrors: function(url, stackFrame, nodeWithSpan, callback, baseUrl, configuration, namesInErrors) {
                var t2, _this = this, _0_0 = _this._builtInModules.$index(0, url), t1 = {};
                t1.builtInModule = null;
                if (_0_0 != null) {
                    t1.builtInModule = _0_0;
                    if (configuration instanceof A.ExplicitConfiguration) {
                        t1 = namesInErrors ? "Built-in module " + url.toString$0(0) + " can't be configured." : "Built-in modules can't be configured.";
                        t2 = configuration.nodeWithSpan;
                        throw A.wrapException(_this._evaluate$_exception$2(t1, t2.get$span(t2)));
                    }
                    _this._addExceptionSpan$2(nodeWithSpan, new A._EvaluateVisitor__loadModule_closure(t1, callback));
                    return;
                }
                _this._withStackFrame$3(stackFrame, nodeWithSpan, new A._EvaluateVisitor__loadModule_closure0(_this, url, nodeWithSpan, baseUrl, namesInErrors, configuration, callback));
            },
            _loadModule$5$configuration: function(url, stackFrame, nodeWithSpan, callback, configuration) {
                return this._loadModule$7$baseUrl$configuration$namesInErrors(url, stackFrame, nodeWithSpan, callback, null, configuration, false);
            },
            _loadModule$4: function(url, stackFrame, nodeWithSpan, callback) {
                return this._loadModule$7$baseUrl$configuration$namesInErrors(url, stackFrame, nodeWithSpan, callback, null, null, false);
            },
            _execute$5$configuration$namesInErrors$nodeWithSpan: function(importer, stylesheet, configuration, namesInErrors, nodeWithSpan) {
                var currentConfiguration, t2, _0_0, t3, message, existingSpan, configurationSpan, environment, css, preModuleComments, extensionStore, module, _this = this, t1 = stylesheet.span, url = t1.get$sourceUrl(t1);
                t1 = configuration == null;
                currentConfiguration = t1 ? _this._configuration : configuration;
                t2 = _this._modules;
                _0_0 = t2.$index(0, url);
                if (_0_0 != null) {
                    t2 = _this._moduleConfigurations.$index(0, url);
                    t3 = t2.__originalConfiguration;
                    t2 = t3 == null ? t2 : t3;
                    t3 = currentConfiguration.__originalConfiguration;
                    if (t2 !== (t3 == null ? currentConfiguration : t3) && currentConfiguration instanceof A.ExplicitConfiguration && _0_0.couldHaveBeenConfigured$1(new A.MapKeySet(new A.UnmodifiableMapView(currentConfiguration._configuration$_values, type$.UnmodifiableMapView_String_ConfiguredValue), type$.MapKeySet_String))) {
                        if (namesInErrors) {
                            t2 = $.$get$context();
                            url.toString;
                            message = t2.prettyUri$1(url) + string$.x20was_a;
                        } else message = string$.This_mw;
                        t2 = _this._moduleNodes.$index(0, url);
                        existingSpan = t2 == null ? null : t2.get$span(t2);
                        if (t1) {
                            t1 = currentConfiguration.nodeWithSpan;
                            configurationSpan = t1.get$span(t1);
                        } else configurationSpan = null;
                        t1 = A.LinkedHashMap_LinkedHashMap$_empty(type$.FileSpan, type$.String);
                        if (existingSpan != null) t1.$indexSet(0, existingSpan, "original load");
                        if (configurationSpan != null) t1.$indexSet(0, configurationSpan, "configuration");
                        throw A.wrapException(t1.get$isEmpty(0) ? _this._evaluate$_exception$1(message) : _this._multiSpanException$3(message, "new load", t1));
                    }
                    return _0_0;
                }
                environment = A.Environment$();
                css = A._Cell$();
                preModuleComments = A._Cell$();
                extensionStore = A.ExtensionStore$();
                _this._withEnvironment$2(environment, new A._EvaluateVisitor__execute_closure(_this, importer, stylesheet, extensionStore, configuration, css, preModuleComments));
                t1 = css._readLocal$0();
                t3 = preModuleComments._readLocal$0();
                module = environment.toModule$3(t1, t3 == null ? B.Map_empty : t3, extensionStore);
                if (url != null) {
                    t2.$indexSet(0, url, module);
                    _this._moduleConfigurations.$indexSet(0, url, currentConfiguration);
                    if (nodeWithSpan != null) _this._moduleNodes.$indexSet(0, url, nodeWithSpan);
                }
                return module;
            },
            _execute$2: function(importer, stylesheet) {
                return this._execute$5$configuration$namesInErrors$nodeWithSpan(importer, stylesheet, null, false, null);
            },
            _addOutOfOrderImports$0: function() {
                var t1, t2, _this = this, _s5_ = "_root", _s13_ = "_endOfImports", _0_0 = _this._outOfOrderImports;
                $label0$0: {
                    if (_0_0 == null) {
                        t1 = _this._assertInModule$2(_this.__root, _s5_).children;
                        break $label0$0;
                    }
                    t1 = _this._assertInModule$2(_this.__root, _s5_).children;
                    t1 = A.List_List$_of(A.SubListIterable$(t1, 0, A.checkNotNullable(_this._assertInModule$2(_this.__endOfImports, _s13_), "count", type$.int), t1.$ti._eval$1("ListBase.E")), type$.ModifiableCssNode);
                    B.JSArray_methods.addAll$1(t1, _0_0);
                    t2 = _this._assertInModule$2(_this.__root, _s5_).children;
                    B.JSArray_methods.addAll$1(t1, A.SubListIterable$(t2, _this._assertInModule$2(_this.__endOfImports, _s13_), null, t2.$ti._eval$1("ListBase.E")));
                    break $label0$0;
                }
                return t1;
            },
            _combineCss$2$clone: function(root, clone) {
                var selectors, _0_0, t1, imports, css, sorted, t2;
                if (!B.JSArray_methods.any$1(root.get$upstream(), new A._EvaluateVisitor__combineCss_closure())) {
                    selectors = root.get$extensionStore().get$simpleSelectors();
                    _0_0 = A.IterableExtension_get_firstOrNull(root.get$extensionStore().extensionsWhereTarget$1(new A._EvaluateVisitor__combineCss_closure0(selectors)));
                    if (_0_0 != null) this._throwForUnsatisfiedExtension$1(_0_0);
                    return root.get$css(root);
                }
                t1 = type$.JSArray_CssNode;
                imports = A._setArrayType([], t1);
                css = A._setArrayType([], t1);
                t1 = type$.Module_Callable;
                sorted = A.ListQueue$(t1);
                new A._EvaluateVisitor__combineCss_visitModule(this, A.LinkedHashSet_LinkedHashSet$_empty(t1), clone, css, imports, sorted).call$1(root);
                if (root.get$transitivelyContainsExtensions()) this._extendModules$1(sorted);
                t1 = B.JSArray_methods.$add(imports, css);
                t2 = root.get$css(root);
                return new A.CssStylesheet(new A.UnmodifiableListView(t1, type$.UnmodifiableListView_CssNode), t2.get$span(t2));
            },
            _combineCss$1: function(root) {
                return this._combineCss$2$clone(root, false);
            },
            _extendModules$1: function(sortedModules) {
                var t1, t2, t3, originalSelectors, $self, t4, t5, _i, upstream, _0_0, downstreamExtensionStores = A.LinkedHashMap_LinkedHashMap$_empty(type$.Uri, type$.List_ExtensionStore), unsatisfiedExtensions = new A._LinkedIdentityHashSet(type$._LinkedIdentityHashSet_Extension);
                for(t1 = A._ListQueueIterator$(sortedModules, sortedModules.$ti._precomputed1), t2 = t1.$ti._precomputed1; t1.moveNext$0();){
                    t3 = t1._collection$_current;
                    if (t3 == null) t3 = t2._as(t3);
                    originalSelectors = t3.get$extensionStore().get$simpleSelectors().toSet$0(0);
                    unsatisfiedExtensions.addAll$1(0, t3.get$extensionStore().extensionsWhereTarget$1(new A._EvaluateVisitor__extendModules_closure(originalSelectors)));
                    $self = downstreamExtensionStores.$index(0, t3.get$url(t3));
                    t4 = t3.get$extensionStore().get$addExtensions();
                    if ($self != null) t4.call$1($self);
                    t4 = t3.get$extensionStore();
                    if (t4.get$isEmpty(t4)) continue;
                    for(t4 = t3.get$upstream(), t5 = t4.length, _i = 0; _i < t4.length; t4.length === t5 || (0, A.throwConcurrentModificationError)(t4), ++_i){
                        upstream = t4[_i];
                        _0_0 = upstream.get$url(upstream);
                        if (_0_0 != null) J.add$1$ax(downstreamExtensionStores.putIfAbsent$2(_0_0, new A._EvaluateVisitor__extendModules_closure0()), t3.get$extensionStore());
                    }
                    unsatisfiedExtensions.removeAll$1(t3.get$extensionStore().extensionsWhereTarget$1(originalSelectors.get$contains(originalSelectors)));
                }
                if (unsatisfiedExtensions._collection$_length !== 0) this._throwForUnsatisfiedExtension$1(unsatisfiedExtensions.get$first(0));
            },
            _throwForUnsatisfiedExtension$1: function(extension) {
                throw A.wrapException(A.SassException$(string$.The_ta + extension.target.toString$0(0) + ' !optional" to avoid this error.', extension.span, null));
            },
            _indexAfterImports$1: function(statements) {
                var t1, lastImport, i, _0_0;
                for(t1 = J.getInterceptor$asx(statements), lastImport = -1, i = 0; i < t1.get$length(statements); ++i){
                    $label0$0: {
                        _0_0 = t1.$index(statements, i);
                        if (_0_0 instanceof A.ModifiableCssImport) break $label0$0;
                        if (_0_0 instanceof A.ModifiableCssComment) continue;
                        break;
                    }
                    lastImport = i;
                }
                return lastImport + 1;
            },
            visitStylesheet$1: function(_, node) {
                var t1, t2, warning, _i, $name, span;
                for(t1 = node.parseTimeWarnings, t2 = t1.$ti, t1 = new A.ListIterator(t1, t1.get$length(0), t2._eval$1("ListIterator<ListBase.E>")), t2 = t2._eval$1("ListBase.E"); t1.moveNext$0();){
                    warning = t1.__internal$_current;
                    if (warning == null) warning = t2._as(warning);
                    this._warn$3(warning._1, warning._2, warning._0);
                }
                for(t1 = node.children, t2 = t1.length, _i = 0; _i < t2; ++_i)t1[_i].accept$1(this);
                for(t1 = A.MapExtensions_get_pairs(node.globalVariables, type$.String, type$.FileSpan), t1 = t1.get$iterator(t1); t1.moveNext$0();){
                    t2 = t1.get$current(t1);
                    $name = t2._0;
                    span = t2._1;
                    this.visitVariableDeclaration$1(0, new A.VariableDeclaration(null, $name, new A.NullExpression(span), true, false, span));
                }
                return null;
            },
            visitAtRootRule$1: function(_, node) {
                var t1, _2_0, root, first, rest, innerCopy, outerCopy, _i, copy, _this = this, _null = null, _s8_ = "__parent", _0_0 = node.query, query = _0_0 != null ? new A.AtRootQueryParser(A.SpanScanner$(_this._performInterpolationWithMap$2$warnForColor(_0_0, true)._0, _null), _null).parse$0(0) : B.AtRootQuery_bfj, $parent = _this._assertInModule$2(_this.__parent, _s8_), included = A._setArrayType([], type$.JSArray_ModifiableCssParentNode);
                for(t1 = type$.CssStylesheet; !t1._is($parent); $parent = _2_0){
                    if (!query.excludes$1($parent)) included.push($parent);
                    _2_0 = $parent._parent;
                    if (_2_0 == null) throw A.wrapException(A.StateError$(string$.CssNod));
                }
                root = _this._trimIncluded$1(included);
                if (root === _this._assertInModule$2(_this.__parent, _s8_)) {
                    _this._environment.scope$1$2$when(new A._EvaluateVisitor_visitAtRootRule_closure(_this, node), node.hasDeclarations, type$.Null);
                    return _null;
                }
                if (included.length >= 1) {
                    first = included[0];
                    rest = B.JSArray_methods.sublist$1(included, 1);
                    innerCopy = first.copyWithoutChildren$0();
                    for(t1 = rest.length, outerCopy = innerCopy, _i = 0; _i < rest.length; rest.length === t1 || (0, A.throwConcurrentModificationError)(rest), ++_i, outerCopy = copy){
                        copy = rest[_i].copyWithoutChildren$0();
                        copy.addChild$1(outerCopy);
                    }
                    root.addChild$1(outerCopy);
                } else innerCopy = root;
                _this._scopeForAtRoot$4(node, innerCopy, query, included).call$1(new A._EvaluateVisitor_visitAtRootRule_closure0(_this, node));
                return _null;
            },
            _trimIncluded$1: function(nodes) {
                var $parent, t1, innermostContiguous, i, t2, _0_0, _1_0, root, _this = this, _null = null, _s5_ = "_root", _s22_ = " to be an ancestor of ";
                if (nodes.length === 0) return _this._assertInModule$2(_this.__root, _s5_);
                $parent = _this._assertInModule$2(_this.__parent, "__parent");
                for(t1 = nodes.length, innermostContiguous = _null, i = 0; i < t1; ++i, $parent = _1_0){
                    for(; t2 = nodes[i], $parent !== t2; innermostContiguous = _null, $parent = _0_0){
                        _0_0 = $parent._parent;
                        if (_0_0 == null) throw A.wrapException(A.ArgumentError$("Expected " + t2.toString$0(0) + _s22_ + _this.toString$0(0) + ".", _null));
                    }
                    if (innermostContiguous == null) innermostContiguous = i;
                    _1_0 = $parent._parent;
                    if (_1_0 == null) throw A.wrapException(A.ArgumentError$("Expected " + t2.toString$0(0) + _s22_ + _this.toString$0(0) + ".", _null));
                }
                if ($parent !== _this._assertInModule$2(_this.__root, _s5_)) return _this._assertInModule$2(_this.__root, _s5_);
                innermostContiguous.toString;
                root = nodes[innermostContiguous];
                B.JSArray_methods.removeRange$2(nodes, innermostContiguous, nodes.length);
                return root;
            },
            _scopeForAtRoot$4: function(node, newParent, query, included) {
                var _this = this, scope = new A._EvaluateVisitor__scopeForAtRoot_closure(_this, newParent, node), t1 = query._all || query._at_root_query$_rule;
                if (t1 !== query.include) scope = new A._EvaluateVisitor__scopeForAtRoot_closure0(_this, scope);
                if (_this._mediaQueries != null && query.excludesName$1("media")) scope = new A._EvaluateVisitor__scopeForAtRoot_closure1(_this, scope);
                if (_this._inKeyframes && query.excludesName$1("keyframes")) scope = new A._EvaluateVisitor__scopeForAtRoot_closure2(_this, scope);
                return _this._inUnknownAtRule && !B.JSArray_methods.any$1(included, new A._EvaluateVisitor__scopeForAtRoot_closure3()) ? new A._EvaluateVisitor__scopeForAtRoot_closure4(_this, scope) : scope;
            },
            visitContentBlock$1: function(_, node) {
                return A.throwExpression(A.UnsupportedError$(string$.Evalua));
            },
            visitContentRule$1: function(_, node) {
                var $content = this._environment._content;
                if ($content == null) return null;
                this._runUserDefinedCallable$1$4(node.$arguments, $content, node, new A._EvaluateVisitor_visitContentRule_closure(this, $content), type$.Null);
                return null;
            },
            visitDebugRule$1: function(_, node) {
                var value = node.expression.accept$1(this), t1 = value instanceof A.SassString ? value._string$_text : A.serializeValue(value, true, true);
                this._logger.debug$2(0, t1, node.span);
                return null;
            },
            visitDeclaration$1: function(_, node) {
                var t1, $name, _0_0, _1_0, value, t2, t3, _2_0, oldDeclarationName, _this = this, _null = null;
                if ((_this._atRootExcludingStyleRule ? _null : _this._styleRuleIgnoringAtRoot) == null && !_this._inUnknownAtRule && !_this._inKeyframes) throw A.wrapException(_this._evaluate$_exception$2(string$.Declarm, node.span));
                if (_this._declarationName != null && !node.parsedAsSassScript) {
                    t1 = B.JSString_methods.startsWith$1(node.name.get$initialPlain(), "--") ? string$.Declarw : string$.Declarp;
                    throw A.wrapException(_this._evaluate$_exception$2(t1, node.span));
                }
                $name = _this._interpolationToValue$2$warnForColor(node.name, true);
                _0_0 = _this._declarationName;
                if (_0_0 != null) $name = new A.CssValue(_0_0 + "-" + $name.value, $name.span, type$.CssValue_String);
                _1_0 = node.value;
                if (_1_0 != null) {
                    value = _1_0.accept$1(_this);
                    if (!value.get$isBlank() || value.get$asList().length === 0 || B.JSString_methods.startsWith$1($name.value, "--")) {
                        _this._copyParentAfterSibling$0();
                        t1 = _this._assertInModule$2(_this.__parent, "__parent");
                        t2 = _1_0.get$span(_1_0);
                        if (_this._sourceMap) {
                            t3 = A.NullableExtension_andThen(_1_0, _this.get$_expressionNode());
                            t3 = t3 == null ? _null : J.get$span$x(t3);
                        } else t3 = _null;
                        t1.addChild$1(A.ModifiableCssDeclaration$($name, new A.CssValue(value, t2, type$.CssValue_Value), node.span, node.parsedAsSassScript, t3));
                    }
                }
                _2_0 = node.children;
                t1 = {};
                t1.children = null;
                if (_2_0 != null) {
                    t1.children = _2_0;
                    oldDeclarationName = _this._declarationName;
                    _this._declarationName = $name.value;
                    _this._environment.scope$1$2$when(new A._EvaluateVisitor_visitDeclaration_closure(t1, _this), node.hasDeclarations, type$.Null);
                    _this._declarationName = oldDeclarationName;
                }
                return _null;
            },
            visitEachRule$1: function(_, node) {
                var _this = this, t1 = node.list, list = t1.accept$1(_this), nodeWithSpan = _this._expressionNode$1(t1), _0_0 = node.variables;
                $label0$0: {
                    t1 = {};
                    t1.variable = null;
                    if (_0_0.length === 1) {
                        t1.variable = _0_0[0];
                        t1 = new A._EvaluateVisitor_visitEachRule_closure(t1, _this, nodeWithSpan);
                        break $label0$0;
                    }
                    t1 = {};
                    t1.variables = null;
                    t1.variables = _0_0;
                    t1 = new A._EvaluateVisitor_visitEachRule_closure0(t1, _this, nodeWithSpan);
                    break $label0$0;
                }
                return _this._environment.scope$1$2$semiGlobal(new A._EvaluateVisitor_visitEachRule_closure1(_this, list, t1, node), true, type$.nullable_Value);
            },
            _setMultipleVariables$3: function(variables, value, nodeWithSpan) {
                var i, list = value.get$asList(), t1 = variables.length, minLength = Math.min(t1, list.length);
                for(i = 0; i < minLength; ++i)this._environment.setLocalVariable$3(variables[i], this._withoutSlash$2(list[i], nodeWithSpan), nodeWithSpan);
                for(i = minLength; i < t1; ++i)this._environment.setLocalVariable$3(variables[i], B.C__SassNull, nodeWithSpan);
            },
            visitErrorRule$1: function(_, node) {
                throw A.wrapException(this._evaluate$_exception$2(node.expression.accept$1(this).toString$0(0), node.span));
            },
            visitExtendRule$1: function(_, node) {
                var t1, t2, t3, t4, t5, _i, complex, visitor, t6, t7, _0_0, compound, simple, _this = this, _null = null, styleRule = _this._atRootExcludingStyleRule ? _null : _this._styleRuleIgnoringAtRoot;
                if (styleRule == null || _this._declarationName != null) throw A.wrapException(_this._evaluate$_exception$2(string$.x40exten, node.span));
                for(t1 = styleRule.originalSelector.components, t2 = t1.length, t3 = node.span, t4 = type$.SourceSpan, t5 = type$.String, _i = 0; _i < t2; ++_i){
                    complex = t1[_i];
                    if (!complex.accept$1(B._IsBogusVisitor_true)) continue;
                    visitor = A._SerializeVisitor$(_null, true, _null, _null, true, false, _null, true);
                    complex.accept$1(visitor);
                    t6 = B.JSString_methods.trim$0(visitor._serialize$_buffer.toString$0(0));
                    t7 = complex.accept$1(B.C__IsUselessVisitor) ? "can't" : "shouldn't";
                    _this._warn$3('The selector "' + t6 + '" is invalid CSS and ' + t7 + string$.x20be_an, new A.MultiSpan(A.SpanExtensions_trimRight(complex.span), "invalid selector", A.ConstantMap_ConstantMap$from(A.LinkedHashMap_LinkedHashMap$_literal([
                        t3,
                        "@extend rule"
                    ], t4, t5), t4, t5)), B.Deprecation_0rM);
                }
                _0_0 = _this._performInterpolationWithMap$2$warnForColor(node.selector, true);
                for(t1 = A.SelectorList_SelectorList$parse(A.trimAscii(_0_0._0, true), false, _0_0._1, _this._logger, false).components, t2 = t1.length, t3 = styleRule._style_rule$_selector._box$_inner, _i = 0; _i < t2; ++_i){
                    complex = t1[_i];
                    compound = complex.get$singleCompound();
                    if (compound == null) throw A.wrapException(A.SassFormatException$("complex selectors may not be extended.", complex.span, _null));
                    t4 = compound.components;
                    simple = t4.length === 1 ? B.JSArray_methods.get$first(t4) : _null;
                    if (simple == null) throw A.wrapException(A.SassFormatException$(string$.compou + B.JSArray_methods.join$1(t4, ", ") + string$.x60_inst, compound.span, _null));
                    _this._assertInModule$2(_this.__extensionStore, "_extensionStore").addExtension$4(t3.value, simple, node, _this._mediaQueries);
                }
                return _null;
            },
            visitAtRule$1: function(_, node) {
                var $name, value, children, wasInKeyframes, wasInUnknownAtRule, rule, _this = this;
                if (_this._declarationName != null) throw A.wrapException(_this._evaluate$_exception$2(string$.At_rul, node.span));
                $name = _this._interpolationToValue$1(node.name);
                value = A.NullableExtension_andThen(node.value, new A._EvaluateVisitor_visitAtRule_closure(_this));
                children = node.children;
                if (children == null) {
                    _this._copyParentAfterSibling$0();
                    _this._assertInModule$2(_this.__parent, "__parent").addChild$1(A.ModifiableCssAtRule$($name, node.span, true, value));
                    return null;
                }
                wasInKeyframes = _this._inKeyframes;
                wasInUnknownAtRule = _this._inUnknownAtRule;
                if (A.unvendor($name.value) === "keyframes") _this._inKeyframes = true;
                else _this._inUnknownAtRule = true;
                rule = A.ModifiableCssAtRule$($name, node.span, false, value);
                if (_this.get$_hasCssNesting()) {
                    _this._withParent$2$3$scopeWhen(rule, new A._EvaluateVisitor_visitAtRule_closure0(_this, children), node.hasDeclarations, type$.ModifiableCssAtRule, type$.Null);
                    _this._inUnknownAtRule = wasInUnknownAtRule;
                    _this._inKeyframes = wasInKeyframes;
                    return null;
                }
                _this._withParent$2$4$scopeWhen$through(rule, new A._EvaluateVisitor_visitAtRule_closure1(_this, $name, children), node.hasDeclarations, new A._EvaluateVisitor_visitAtRule_closure2(), type$.ModifiableCssAtRule, type$.Null);
                _this._inUnknownAtRule = wasInUnknownAtRule;
                _this._inKeyframes = wasInKeyframes;
                return null;
            },
            visitForRule$1: function(_, node) {
                var _this = this, t1 = {}, t2 = node.from, fromNumber = _this._addExceptionSpan$2(t2, new A._EvaluateVisitor_visitForRule_closure(_this, node)), t3 = node.to, toNumber = _this._addExceptionSpan$2(t3, new A._EvaluateVisitor_visitForRule_closure0(_this, node)), from = _this._addExceptionSpan$2(t2, new A._EvaluateVisitor_visitForRule_closure1(fromNumber)), to = t1.to = _this._addExceptionSpan$2(t3, new A._EvaluateVisitor_visitForRule_closure2(toNumber, fromNumber)), direction = from > to ? -1 : 1;
                if (from === (!node.isExclusive ? t1.to = to + direction : to)) return null;
                return _this._environment.scope$1$2$semiGlobal(new A._EvaluateVisitor_visitForRule_closure3(t1, _this, node, from, direction, fromNumber), true, type$.nullable_Value);
            },
            visitForwardRule$1: function(_, node) {
                var newConfiguration, t4, _i, variable, $name, _this = this, _s8_ = "@forward", oldConfiguration = _this._configuration, adjustedConfiguration = oldConfiguration.throughForward$1(node), t1 = node.configuration, t2 = t1.length, t3 = node.url;
                if (t2 !== 0) {
                    newConfiguration = _this._addForwardConfiguration$2(adjustedConfiguration, node);
                    _this._loadModule$5$configuration(t3, _s8_, node, new A._EvaluateVisitor_visitForwardRule_closure(_this, node), newConfiguration);
                    t3 = type$.String;
                    t4 = A.LinkedHashSet_LinkedHashSet$_empty(t3);
                    for(_i = 0; _i < t2; ++_i){
                        variable = t1[_i];
                        if (!variable.isGuarded) t4.add$1(0, variable.name);
                    }
                    _this._removeUsedConfiguration$3$except(adjustedConfiguration, newConfiguration, t4);
                    t3 = A.LinkedHashSet_LinkedHashSet$_empty(t3);
                    for(_i = 0; _i < t2; ++_i)t3.add$1(0, t1[_i].name);
                    for(t1 = newConfiguration._configuration$_values, t2 = t1.get$keys(t1), t2 = t2.toList$0(t2), t4 = t2.length, _i = 0; _i < t2.length; t2.length === t4 || (0, A.throwConcurrentModificationError)(t2), ++_i){
                        $name = t2[_i];
                        if (!t3.contains$1(0, $name)) {
                            if (!t1.get$isEmpty(t1)) t1.remove$1(0, $name);
                        }
                    }
                    _this._assertConfigurationIsEmpty$1(newConfiguration);
                } else {
                    _this._configuration = adjustedConfiguration;
                    _this._loadModule$4(t3, _s8_, node, new A._EvaluateVisitor_visitForwardRule_closure0(_this, node));
                    _this._configuration = oldConfiguration;
                }
                return null;
            },
            _addForwardConfiguration$2: function(configuration, node) {
                var t2, t3, _i, variable, t4, _0_0, t5, oldValue, variableNodeWithSpan, _null = null, t1 = configuration._configuration$_values, newValues = A.LinkedHashMap_LinkedHashMap$of(new A.UnmodifiableMapView(t1, type$.UnmodifiableMapView_String_ConfiguredValue), type$.String, type$.ConfiguredValue);
                for(t2 = node.configuration, t3 = t2.length, _i = 0; _i < t3; ++_i){
                    variable = t2[_i];
                    if (variable.isGuarded) {
                        t4 = variable.name;
                        _0_0 = t1.get$isEmpty(t1) ? _null : t1.remove$1(0, t4);
                        if (_0_0 != null) {
                            t5 = !_0_0.value.$eq(0, B.C__SassNull);
                            oldValue = _0_0;
                        } else {
                            oldValue = _null;
                            t5 = false;
                        }
                        if (t5) {
                            newValues.$indexSet(0, t4, oldValue);
                            continue;
                        }
                    }
                    t4 = variable.expression;
                    variableNodeWithSpan = this._expressionNode$1(t4);
                    newValues.$indexSet(0, variable.name, new A.ConfiguredValue(this._withoutSlash$2(t4.accept$1(this), variableNodeWithSpan), variable.span, variableNodeWithSpan));
                }
                if (configuration instanceof A.ExplicitConfiguration || t1.get$isEmpty(t1)) return new A.ExplicitConfiguration(node, newValues, _null);
                else return new A.Configuration(newValues, _null);
            },
            _registerCommentsForModule$1: function(module) {
                var _this = this, _s5_ = "_root", t1 = _this.__root;
                if (t1 == null) return;
                if (_this._assertInModule$2(t1, _s5_).children.get$length(0) === 0 || !module.get$transitivelyContainsCss()) return;
                t1 = _this._preModuleComments;
                if (t1 == null) t1 = _this._preModuleComments = A.LinkedHashMap_LinkedHashMap$_empty(type$.Module_Callable, type$.List_CssComment);
                J.addAll$1$ax(t1.putIfAbsent$2(module, new A._EvaluateVisitor__registerCommentsForModule_closure()), new A.UnmodifiableListView(J.cast$1$0$ax(_this._assertInModule$2(_this.__root, _s5_).children._collection$_source, type$.CssComment), type$.UnmodifiableListView_CssComment));
                _this._assertInModule$2(_this.__root, _s5_).clearChildren$0();
                _this.__endOfImports = 0;
            },
            _removeUsedConfiguration$3$except: function(upstream, downstream, except) {
                var t1, t2, t3, t4, _i, $name;
                for(t1 = upstream._configuration$_values, t2 = t1.get$keys(t1), t2 = t2.toList$0(t2), t3 = t2.length, t4 = downstream._configuration$_values, _i = 0; _i < t2.length; t2.length === t3 || (0, A.throwConcurrentModificationError)(t2), ++_i){
                    $name = t2[_i];
                    if (except.contains$1(0, $name)) continue;
                    if (!t4.containsKey$1($name)) {
                        if (!t1.get$isEmpty(t1)) t1.remove$1(0, $name);
                    }
                }
            },
            _assertConfigurationIsEmpty$2$nameInError: function(configuration, nameInError) {
                var t1, _0_0;
                if (!(configuration instanceof A.ExplicitConfiguration)) return;
                t1 = configuration._configuration$_values;
                if (t1.get$isEmpty(t1)) return;
                t1 = A.MapExtensions_get_pairs(new A.UnmodifiableMapView(t1, type$.UnmodifiableMapView_String_ConfiguredValue), type$.String, type$.ConfiguredValue);
                _0_0 = t1.get$first(t1);
                t1 = nameInError ? "$" + _0_0._0 + string$.x20was_n : string$.This_v;
                throw A.wrapException(this._evaluate$_exception$2(t1, _0_0._1.configurationSpan));
            },
            _assertConfigurationIsEmpty$1: function(configuration) {
                return this._assertConfigurationIsEmpty$2$nameInError(configuration, false);
            },
            visitFunctionRule$1: function(_, node) {
                var t1 = this._environment, t2 = t1.closure$0(), t3 = this._inDependency, t4 = t1._functions, index = t4.length - 1, t5 = node.name;
                t1._functionIndices.$indexSet(0, t5, index);
                t4[index].$indexSet(0, t5, new A.UserDefinedCallable(node, t2, t3, type$.UserDefinedCallable_Environment));
                return null;
            },
            visitIfRule$1: function(_, node) {
                var t1, t2, _i, clauseToCheck, clause = node.lastClause;
                for(t1 = node.clauses, t2 = t1.length, _i = 0; _i < t2; ++_i){
                    clauseToCheck = t1[_i];
                    if (clauseToCheck.expression.accept$1(this).get$isTruthy()) {
                        clause = clauseToCheck;
                        break;
                    }
                }
                return A.NullableExtension_andThen(clause, new A._EvaluateVisitor_visitIfRule_closure(this));
            },
            visitImportRule$1: function(_, node) {
                var t1, t2, t3, t4, t5, t6, _i, $import, t7, _0_0, $self, t8, _this = this, _s8_ = "__parent", _s5_ = "_root", _s13_ = "_endOfImports";
                for(t1 = node.imports, t2 = t1.length, t3 = type$.CssValue_String, t4 = _this.get$_interpolationToValue(), t5 = type$.StaticImport, t6 = type$.JSArray_ModifiableCssImport, _i = 0; _i < t2; ++_i){
                    $import = t1[_i];
                    if ($import instanceof A.DynamicImport) _this._visitDynamicImport$1($import);
                    else {
                        t5._as($import);
                        t7 = $import.url;
                        _0_0 = _this._performInterpolationHelper$3$sourceMap$warnForColor(t7, false, false);
                        $self = $import.modifiers;
                        t8 = $self == null ? null : t4.call$1($self);
                        node = new A.ModifiableCssImport(new A.CssValue(_0_0._0, t7.span, t3), t8, $import.span);
                        if (_this._assertInModule$2(_this.__parent, _s8_) !== _this._assertInModule$2(_this.__root, _s5_)) {
                            _this._copyParentAfterSibling$0();
                            _this._assertInModule$2(_this.__parent, _s8_).addChild$1(node);
                        } else if (_this._assertInModule$2(_this.__endOfImports, _s13_) === J.get$length$asx(_this._assertInModule$2(_this.__root, _s5_).children._collection$_source)) {
                            t7 = _this._assertInModule$2(_this.__root, _s5_);
                            node._parent = t7;
                            t7 = t7._children;
                            node._indexInParent = t7.length;
                            t7.push(node);
                            _this.__endOfImports = _this._assertInModule$2(_this.__endOfImports, _s13_) + 1;
                        } else {
                            t7 = _this._outOfOrderImports;
                            (t7 == null ? _this._outOfOrderImports = A._setArrayType([], t6) : t7).push(node);
                        }
                    }
                }
                return null;
            },
            _visitDynamicImport$1: function($import) {
                return this._withStackFrame$3("@import", $import, new A._EvaluateVisitor__visitDynamicImport_closure(this, $import));
            },
            _loadStylesheet$4$baseUrl$forImport: function(url, span, baseUrl, forImport) {
                var _0_0, importCache, _1_0, importer, canonicalUrl, originalUrl, isDependency, _2_0, stylesheet, error, stackTrace, error0, stackTrace0, t1, t2, _$exception, _this = this;
                baseUrl;
                try {
                    _this._importSpan = span;
                    _0_0 = _this._evaluate$_importCache;
                    importCache = null;
                    if (_0_0 != null) {
                        importCache = _0_0;
                        if (baseUrl == null) {
                            t1 = _this._assertInModule$2(_this.__stylesheet, "_stylesheet").span;
                            baseUrl = t1.get$sourceUrl(t1);
                        }
                        _1_0 = J.canonicalize$4$baseImporter$baseUrl$forImport$x(importCache, A.Uri_parse(url), _this._importer, baseUrl, forImport);
                        importer = null;
                        canonicalUrl = null;
                        originalUrl = null;
                        if (type$.Record_3_nullable_Object_and_nullable_Object_and_nullable_Object_originalUrl._is(_1_0)) {
                            importer = _1_0._0;
                            canonicalUrl = _1_0._1;
                            originalUrl = _1_0._2;
                            if (canonicalUrl.get$scheme() === "") A.WarnForDeprecation_warnForDeprecation(_this._logger, B.Deprecation_IqB, "Importer " + A.S(importer) + " canonicalized " + url + " to " + A.S(canonicalUrl) + string$.x2e_Rela, null, null);
                            _this._loadedUrls.add$1(0, canonicalUrl);
                            isDependency = _this._inDependency || !J.$eq$(importer, _this._importer);
                            _2_0 = importCache.importCanonical$3$originalUrl(importer, canonicalUrl, originalUrl);
                            stylesheet = null;
                            if (_2_0 != null) {
                                stylesheet = _2_0;
                                t1 = stylesheet;
                                t2 = importer;
                                return new A._Record_3_importer_isDependency(t1, t2, isDependency);
                            }
                        }
                    }
                    t1 = B.JSString_methods.startsWith$1(url, "package:");
                    if (t1) throw A.wrapException(string$.x22packa);
                    else throw A.wrapException("Can't find stylesheet to import.");
                } catch (exception) {
                    t1 = A.unwrapException(exception);
                    if (t1 instanceof A.SassException) throw exception;
                    else if (t1 instanceof A.ArgumentError) {
                        error = t1;
                        stackTrace = A.getTraceFromException(exception);
                        A.throwWithTrace(_this._evaluate$_exception$1(J.toString$0$(error)), error, stackTrace);
                    } else {
                        error0 = t1;
                        stackTrace0 = A.getTraceFromException(exception);
                        A.throwWithTrace(_this._evaluate$_exception$1(_this._getErrorMessage$1(error0)), error0, stackTrace0);
                    }
                } finally{
                    _this._importSpan = null;
                }
            },
            _loadStylesheet$3$baseUrl: function(url, span, baseUrl) {
                return this._loadStylesheet$4$baseUrl$forImport(url, span, baseUrl, false);
            },
            _loadStylesheet$3$forImport: function(url, span, forImport) {
                return this._loadStylesheet$4$baseUrl$forImport(url, span, null, forImport);
            },
            _applyMixin$5: function(mixin, contentCallable, $arguments, nodeWithSpan, nodeWithSpanWithoutContent) {
                var t1, _0_0, t2, _1_8, t3, _this = this, _null = null, _s37_ = "Mixin doesn't accept a content block.", _s10_ = "invocation";
                $label0$0: {
                    if (mixin == null) throw A.wrapException(_this._evaluate$_exception$2("Undefined mixin.", nodeWithSpan.get$span(nodeWithSpan)));
                    t1 = mixin instanceof A.BuiltInCallable;
                    if (t1 && !mixin.acceptsContent && contentCallable != null) {
                        t1 = _this._evaluateArguments$1($arguments)._values;
                        _0_0 = mixin.callbackFor$2(t1[2].length, new A.MapKeySet(t1[0], type$.MapKeySet_String));
                        throw A.wrapException(A.MultiSpanSassRuntimeException$(_s37_, nodeWithSpanWithoutContent.get$span(nodeWithSpanWithoutContent), _s10_, A.LinkedHashMap_LinkedHashMap$_literal([
                            _0_0._0.get$spanWithName(),
                            "declaration"
                        ], type$.FileSpan, type$.String), _this._evaluate$_stackTrace$1(nodeWithSpanWithoutContent.get$span(nodeWithSpanWithoutContent)), _null));
                    }
                    if (t1) {
                        _this._environment.withContent$2(contentCallable, new A._EvaluateVisitor__applyMixin_closure(_this, $arguments, mixin, nodeWithSpanWithoutContent));
                        break $label0$0;
                    }
                    t1 = type$.UserDefinedCallable_Environment._is(mixin);
                    t2 = false;
                    if (t1) {
                        _1_8 = mixin.declaration;
                        t3 = _1_8;
                        if (t3 instanceof A.MixinRule) t2 = !type$.MixinRule._as(_1_8).get$hasContent() && contentCallable != null;
                    }
                    if (t2) throw A.wrapException(A.MultiSpanSassRuntimeException$(_s37_, nodeWithSpanWithoutContent.get$span(nodeWithSpanWithoutContent), _s10_, A.LinkedHashMap_LinkedHashMap$_literal([
                        mixin.declaration.parameters.get$spanWithName(),
                        "declaration"
                    ], type$.FileSpan, type$.String), _this._evaluate$_stackTrace$1(nodeWithSpanWithoutContent.get$span(nodeWithSpanWithoutContent)), _null));
                    if (t1) {
                        _this._runUserDefinedCallable$1$4($arguments, mixin, nodeWithSpanWithoutContent, new A._EvaluateVisitor__applyMixin_closure0(_this, contentCallable, mixin, nodeWithSpanWithoutContent), type$.Null);
                        break $label0$0;
                    }
                    throw A.wrapException(A.UnsupportedError$("Unknown callable type " + mixin.toString$0(0) + "."));
                }
            },
            visitIncludeRule$1: function(_, node) {
                var _this = this, mixin = _this._addExceptionSpan$2(node, new A._EvaluateVisitor_visitIncludeRule_closure(_this, node));
                if (B.JSString_methods.startsWith$1(node.originalName, "--") && mixin instanceof A.UserDefinedCallable && !B.JSString_methods.startsWith$1(mixin.declaration.originalName, "--")) throw A.wrapException(_this._evaluate$_exception$2(string$.Sass__m, node.get$nameSpan()));
                _this._applyMixin$5(mixin, A.NullableExtension_andThen(node.content, new A._EvaluateVisitor_visitIncludeRule_closure0(_this)), node.$arguments, node, new A._FakeAstNode(new A._EvaluateVisitor_visitIncludeRule_closure1(node)));
                return null;
            },
            visitMixinRule$1: function(_, node) {
                var t1 = this._environment, t2 = t1.closure$0(), t3 = this._inDependency, t4 = t1._mixins, index = t4.length - 1, t5 = node.name;
                t1._mixinIndices.$indexSet(0, t5, index);
                t4[index].$indexSet(0, t5, new A.UserDefinedCallable(node, t2, t3, type$.UserDefinedCallable_Environment));
                return null;
            },
            visitLoudComment$1: function(_, node) {
                var t1, text, _this = this, _s8_ = "__parent", _s13_ = "_endOfImports";
                if (_this._inFunction) return null;
                if (_this._assertInModule$2(_this.__parent, _s8_) === _this._assertInModule$2(_this.__root, "_root") && _this._assertInModule$2(_this.__endOfImports, _s13_) === J.get$length$asx(_this._assertInModule$2(_this.__root, "_root").children._collection$_source)) _this.__endOfImports = _this._assertInModule$2(_this.__endOfImports, _s13_) + 1;
                t1 = node.text;
                text = _this._performInterpolation$1(t1);
                if (!B.JSString_methods.endsWith$1(text, "*/")) text += " */";
                _this._copyParentAfterSibling$0();
                _this._assertInModule$2(_this.__parent, _s8_).addChild$1(new A.ModifiableCssComment(text, t1.span));
                return null;
            },
            visitMediaRule$1: function(_, node) {
                var _0_0, queries, mergedQueries, t1, mergedSources, t2, t3, _this = this, _null = null;
                if (_this._declarationName != null) throw A.wrapException(_this._evaluate$_exception$2(string$.Media_, node.span));
                _0_0 = _this._performInterpolationWithMap$2$warnForColor(node.query, true);
                queries = new A.MediaQueryParser(A.SpanScanner$(_0_0._0, _null), _0_0._1).parse$0(0);
                if (_this.get$_hasCssNesting()) {
                    _this._withParent$2$3$scopeWhen(A.ModifiableCssMediaRule$(queries, node.span), new A._EvaluateVisitor_visitMediaRule_closure(_this, node), false, type$.ModifiableCssMediaRule, type$.Null);
                    return _null;
                }
                mergedQueries = A.NullableExtension_andThen(_this._mediaQueries, new A._EvaluateVisitor_visitMediaRule_closure0(_this, queries));
                t1 = mergedQueries == null;
                if (!t1 && J.get$isEmpty$asx(mergedQueries)) return _null;
                if (t1) mergedSources = B.Set_empty2;
                else {
                    t2 = _this._mediaQuerySources;
                    t2.toString;
                    t2 = A.LinkedHashSet_LinkedHashSet$of(t2, type$.CssMediaQuery);
                    t3 = _this._mediaQueries;
                    t3.toString;
                    t2.addAll$1(0, t3);
                    t2.addAll$1(0, queries);
                    mergedSources = t2;
                }
                t1 = t1 ? queries : mergedQueries;
                _this._withParent$2$4$scopeWhen$through(A.ModifiableCssMediaRule$(t1, node.span), new A._EvaluateVisitor_visitMediaRule_closure1(_this, mergedQueries, queries, mergedSources, node), node.hasDeclarations, new A._EvaluateVisitor_visitMediaRule_closure2(mergedSources), type$.ModifiableCssMediaRule, type$.Null);
                return _null;
            },
            _mergeMediaQueries$2: function(queries1, queries2) {
                var t1, t2, t3, t4, _0_0, t5, result, queries = A._setArrayType([], type$.JSArray_CssMediaQuery);
                for(t1 = J.get$iterator$ax(queries1), t2 = J.getInterceptor$ax(queries2); t1.moveNext$0();){
                    t3 = t1.get$current(t1);
                    for(t4 = t2.get$iterator(queries2); t4.moveNext$0();){
                        _0_0 = t3.merge$1(t4.get$current(t4));
                        if (B._SingletonCssMediaQueryMergeResult_0 === _0_0) continue;
                        if (B._SingletonCssMediaQueryMergeResult_1 === _0_0) return null;
                        t5 = _0_0 instanceof A.MediaQuerySuccessfulMergeResult;
                        result = t5 ? _0_0 : null;
                        if (t5) queries.push(result.query);
                    }
                }
                return queries;
            },
            visitReturnRule$1: function(_, node) {
                var t1 = node.expression;
                return this._withoutSlash$2(t1.accept$1(this), t1);
            },
            visitSilentComment$1: function(_, node) {
                return null;
            },
            visitStyleRule$1: function(_, node) {
                var t1, _0_0, selectorText, selectorMap, parsedSelector, _1_0, t2, t3, _i, _2_0, first, t4, rule, oldAtRootExcludingStyleRule, _this = this, _null = null, _s8_ = "__parent", _s11_ = "_stylesheet";
                if (_this._declarationName != null) throw A.wrapException(_this._evaluate$_exception$2(string$.Style_n, node.span));
                else if (_this._inKeyframes && _this._assertInModule$2(_this.__parent, _s8_) instanceof A.ModifiableCssKeyframeBlock) throw A.wrapException(_this._evaluate$_exception$2(string$.Style_k, node.span));
                t1 = node.selector;
                t1.toString;
                _0_0 = _this._performInterpolationWithMap$2$warnForColor(t1, true);
                selectorText = _0_0._0;
                selectorMap = _0_0._1;
                if (_this._inKeyframes) {
                    _this._withParent$2$4$scopeWhen$through(A.ModifiableCssKeyframeBlock$(new A.CssValue(A.List_List$unmodifiable(new A.KeyframeSelectorParser(A.SpanScanner$(selectorText, _null), selectorMap).parse$0(0), type$.String), t1.span, type$.CssValue_List_String), node.span), new A._EvaluateVisitor_visitStyleRule_closure(_this, node), node.hasDeclarations, new A._EvaluateVisitor_visitStyleRule_closure0(), type$.ModifiableCssKeyframeBlock, type$.Null);
                    return _null;
                }
                parsedSelector = A.SelectorList_SelectorList$parse(selectorText, true, selectorMap, _this._logger, _this._assertInModule$2(_this.__stylesheet, _s11_).plainCss);
                _1_0 = _this._atRootExcludingStyleRule ? _null : _this._styleRuleIgnoringAtRoot;
                $label0$0: {
                    if (_1_0 == null) {
                        t1 = true;
                        break $label0$0;
                    }
                    if (_1_0.fromPlainCss) {
                        t1 = false;
                        break $label0$0;
                    }
                    t1 = !(_this._assertInModule$2(_this.__stylesheet, _s11_).plainCss && parsedSelector.accept$1(B.C__ContainsParentSelectorVisitor));
                    break $label0$0;
                }
                if (t1) {
                    if (_this._assertInModule$2(_this.__stylesheet, _s11_).plainCss) for(t2 = parsedSelector.components, t3 = t2.length, _i = 0; _i < t3; ++_i){
                        _2_0 = t2[_i].leadingCombinators;
                        if (_2_0.length >= 1) {
                            first = _2_0[0];
                            t4 = _this._assertInModule$2(_this.__stylesheet, _s11_).plainCss;
                        } else {
                            first = _null;
                            t4 = false;
                        }
                        if (t4) throw A.wrapException(_this._evaluate$_exception$2(string$.Top_le, first.span));
                    }
                    t2 = _this._styleRuleIgnoringAtRoot;
                    t2 = t2 == null ? _null : t2.originalSelector;
                    parsedSelector = parsedSelector.nestWithin$3$implicitParent$preserveParentSelectors(t2, !_this._atRootExcludingStyleRule, _this._assertInModule$2(_this.__stylesheet, _s11_).plainCss);
                }
                rule = A.ModifiableCssStyleRule$(_this._assertInModule$2(_this.__extensionStore, "_extensionStore").addSelector$2(parsedSelector, _this._mediaQueries), node.span, _this._assertInModule$2(_this.__stylesheet, _s11_).plainCss, parsedSelector);
                oldAtRootExcludingStyleRule = _this._atRootExcludingStyleRule;
                t2 = _this._atRootExcludingStyleRule = false;
                t1 = t1 ? new A._EvaluateVisitor_visitStyleRule_closure1() : _null;
                _this._withParent$2$4$scopeWhen$through(rule, new A._EvaluateVisitor_visitStyleRule_closure2(_this, rule, node), node.hasDeclarations, t1, type$.ModifiableCssStyleRule, type$.Null);
                _this._atRootExcludingStyleRule = oldAtRootExcludingStyleRule;
                _this._warnForBogusCombinators$1(rule);
                if ((_this._atRootExcludingStyleRule ? _null : _this._styleRuleIgnoringAtRoot) == null) {
                    t1 = _this._assertInModule$2(_this.__parent, _s8_).children;
                    t1 = !t1.get$isEmpty(t1);
                } else t1 = t2;
                if (t1) {
                    t1 = _this._assertInModule$2(_this.__parent, _s8_).children;
                    t1.get$last(t1).isGroupEnd = true;
                }
                return _null;
            },
            _warnForBogusCombinators$1: function(rule) {
                var t1, t2, t3, t4, t5, _i, complex, visitor, t6, t7, t8, t9, _this = this, _null = null;
                if (!rule.accept$1(B._IsInvisibleVisitor_false_false)) for(t1 = rule._style_rule$_selector._box$_inner.value.components, t2 = t1.length, t3 = type$.SourceSpan, t4 = type$.String, t5 = rule.children, _i = 0; _i < t2; ++_i){
                    complex = t1[_i];
                    if (!complex.accept$1(B._IsBogusVisitor_true)) continue;
                    if (complex.accept$1(B.C__IsUselessVisitor)) {
                        visitor = A._SerializeVisitor$(_null, true, _null, _null, true, false, _null, true);
                        complex.accept$1(visitor);
                        _this._warn$3('The selector "' + B.JSString_methods.trim$0(visitor._serialize$_buffer.toString$0(0)) + string$.x22x20is_ix20, A.SpanExtensions_trimRight(complex.span), B.Deprecation_0rM);
                    } else if (complex.leadingCombinators.length !== 0) {
                        if (!_this._assertInModule$2(_this.__stylesheet, "_stylesheet").plainCss) {
                            visitor = A._SerializeVisitor$(_null, true, _null, _null, true, false, _null, true);
                            complex.accept$1(visitor);
                            _this._warn$3('The selector "' + B.JSString_methods.trim$0(visitor._serialize$_buffer.toString$0(0)) + string$.x22x20is_ix0a, A.SpanExtensions_trimRight(complex.span), B.Deprecation_0rM);
                        }
                    } else {
                        visitor = A._SerializeVisitor$(_null, true, _null, _null, true, false, _null, true);
                        complex.accept$1(visitor);
                        t6 = B.JSString_methods.trim$0(visitor._serialize$_buffer.toString$0(0));
                        t7 = complex.accept$1(B._IsBogusVisitor_false) ? string$.x20It_wi : "";
                        t8 = A.SpanExtensions_trimRight(complex.span);
                        if (t5.get$length(0) === 0) A.throwExpression(A.IterableElementError_noElement());
                        t9 = J.get$span$x(t5.$index(0, 0));
                        _this._warn$3('The selector "' + t6 + string$.x22x20is_o + t7 + string$.x0aThis_, new A.MultiSpan(t8, "invalid selector", A.ConstantMap_ConstantMap$from(A.LinkedHashMap_LinkedHashMap$_literal([
                            t9,
                            "this is not a style rule" + (t5.every$1(t5, new A._EvaluateVisitor__warnForBogusCombinators_closure()) ? "\n(try converting to a //-style comment)" : "")
                        ], t3, t4), t3, t4)), B.Deprecation_0rM);
                    }
                }
            },
            visitSupportsRule$1: function(_, node) {
                var t1, rule, _this = this;
                if (_this._declarationName != null) throw A.wrapException(_this._evaluate$_exception$2(string$.Suppor, node.span));
                t1 = node.condition;
                rule = A.ModifiableCssSupportsRule$(new A.CssValue(_this._visitSupportsCondition$1(t1), t1.get$span(t1), type$.CssValue_String), node.span);
                if (_this.get$_hasCssNesting()) {
                    _this._withParent$2$3$scopeWhen(rule, new A._EvaluateVisitor_visitSupportsRule_closure(_this, node), node.hasDeclarations, type$.ModifiableCssSupportsRule, type$.Null);
                    return null;
                }
                _this._withParent$2$4$scopeWhen$through(rule, new A._EvaluateVisitor_visitSupportsRule_closure0(_this, node), node.hasDeclarations, new A._EvaluateVisitor_visitSupportsRule_closure1(), type$.ModifiableCssSupportsRule, type$.Null);
                return null;
            },
            _visitSupportsCondition$1: function(condition) {
                var t1, _this = this;
                $label0$0: {
                    if (condition instanceof A.SupportsOperation) {
                        t1 = condition.operator;
                        t1 = _this._evaluate$_parenthesize$2(condition.left, t1) + " " + t1.toString$0(0) + " " + _this._evaluate$_parenthesize$2(condition.right, t1);
                        break $label0$0;
                    }
                    if (condition instanceof A.SupportsNegation) {
                        t1 = "not " + _this._evaluate$_parenthesize$1(condition.condition);
                        break $label0$0;
                    }
                    if (condition instanceof A.SupportsInterpolation) {
                        t1 = condition.expression;
                        t1 = _this._evaluate$_serialize$3$quote(t1.accept$1(_this), t1, false);
                        break $label0$0;
                    }
                    t1 = {};
                    t1.declaration = null;
                    if (condition instanceof A.SupportsDeclaration) {
                        t1.declaration = condition;
                        t1 = _this._withSupportsDeclaration$1(new A._EvaluateVisitor__visitSupportsCondition_closure(t1, _this));
                        break $label0$0;
                    }
                    if (condition instanceof A.SupportsFunction) {
                        t1 = _this._performInterpolation$1(condition.name) + "(" + _this._performInterpolation$1(condition.$arguments) + ")";
                        break $label0$0;
                    }
                    if (condition instanceof A.SupportsAnything) {
                        t1 = "(" + _this._performInterpolation$1(condition.contents) + ")";
                        break $label0$0;
                    }
                    t1 = A.throwExpression(A.ArgumentError$("Unknown supports condition type " + A.getRuntimeTypeOfDartObject(condition).toString$0(0) + ".", null));
                }
                return t1;
            },
            _withSupportsDeclaration$1$1: function(callback) {
                var t1, oldInSupportsDeclaration = this._inSupportsDeclaration;
                this._inSupportsDeclaration = true;
                try {
                    t1 = callback.call$0();
                    return t1;
                } finally{
                    this._inSupportsDeclaration = oldInSupportsDeclaration;
                }
            },
            _withSupportsDeclaration$1: function(callback) {
                return this._withSupportsDeclaration$1$1(callback, type$.dynamic);
            },
            _evaluate$_parenthesize$2: function(condition, operator) {
                var t1;
                if (!(condition instanceof A.SupportsNegation)) {
                    if (condition instanceof A.SupportsOperation) t1 = operator == null || operator !== condition.operator;
                    else t1 = false;
                } else t1 = true;
                if (t1) return "(" + this._visitSupportsCondition$1(condition) + ")";
                return this._visitSupportsCondition$1(condition);
            },
            _evaluate$_parenthesize$1: function(condition) {
                return this._evaluate$_parenthesize$2(condition, null);
            },
            visitVariableDeclaration$1: function(_, node) {
                var t1, t2, _0_0, value, _this = this, _null = null;
                if (node.isGuarded) {
                    if (node.namespace == null && _this._environment._variables.length === 1) {
                        t1 = node.name;
                        _this._environment._configurableVariables.add$1(0, t1);
                        t2 = _this._configuration._configuration$_values;
                        _0_0 = t2.get$isEmpty(t2) ? _null : t2.remove$1(0, t1);
                        t1 = {};
                        t1.override = null;
                        if (_0_0 != null) {
                            t1.override = _0_0;
                            t2 = !_0_0.value.$eq(0, B.C__SassNull);
                        } else t2 = false;
                        if (t2) {
                            _this._addExceptionSpan$2(node, new A._EvaluateVisitor_visitVariableDeclaration_closure(t1, _this, node));
                            return _null;
                        }
                    }
                    value = _this._addExceptionSpan$2(node, new A._EvaluateVisitor_visitVariableDeclaration_closure0(_this, node));
                    if (value != null && !value.$eq(0, B.C__SassNull)) return _null;
                }
                if (node.isGlobal && !_this._environment.globalVariableExists$1(node.name)) {
                    t1 = _this._environment._variables.length === 1 ? string$.As_of_S : string$.As_of_R + A.declarationName(node.span) + ": null` at the stylesheet root.";
                    _this._warn$3(t1, node.span, B.Deprecation_jGw);
                }
                t1 = node.expression;
                _this._addExceptionSpan$2(node, new A._EvaluateVisitor_visitVariableDeclaration_closure1(_this, node, _this._withoutSlash$2(t1.accept$1(_this), t1)));
                return _null;
            },
            visitUseRule$1: function(_, node) {
                var values, _i, variable, t3, variableNodeWithSpan, configuration, _this = this, t1 = node.configuration, t2 = t1.length;
                if (t2 !== 0) {
                    values = A.LinkedHashMap_LinkedHashMap$_empty(type$.String, type$.ConfiguredValue);
                    for(_i = 0; _i < t2; ++_i){
                        variable = t1[_i];
                        t3 = variable.expression;
                        variableNodeWithSpan = _this._expressionNode$1(t3);
                        values.$indexSet(0, variable.name, new A.ConfiguredValue(_this._withoutSlash$2(t3.accept$1(_this), variableNodeWithSpan), variable.span, variableNodeWithSpan));
                    }
                    configuration = new A.ExplicitConfiguration(node, values, null);
                } else configuration = B.Configuration_Map_empty_null;
                _this._loadModule$5$configuration(node.url, "@use", node, new A._EvaluateVisitor_visitUseRule_closure(_this, node), configuration);
                _this._assertConfigurationIsEmpty$1(configuration);
                return null;
            },
            visitWarnRule$1: function(_, node) {
                var _this = this, value = _this._addExceptionSpan$2(node, new A._EvaluateVisitor_visitWarnRule_closure(_this, node)), t1 = value instanceof A.SassString ? value._string$_text : _this._evaluate$_serialize$2(value, node.expression), t2 = _this._evaluate$_stackTrace$1(node.span);
                _this._logger.internalWarn$4$deprecation$span$trace(t1, null, null, t2);
                return null;
            },
            visitWhileRule$1: function(_, node) {
                return this._environment.scope$1$3$semiGlobal$when(new A._EvaluateVisitor_visitWhileRule_closure(this, node), true, node.hasDeclarations, type$.nullable_Value);
            },
            visitBinaryOperationExpression$1: function(_, node) {
                var t1, _this = this;
                if (_this._assertInModule$2(_this.__stylesheet, "_stylesheet").plainCss) {
                    t1 = node.operator;
                    t1 = t1 !== B.BinaryOperator_g6F && t1 !== B.BinaryOperator_ehp;
                } else t1 = false;
                if (t1) throw A.wrapException(_this._evaluate$_exception$2("Operators aren't allowed in plain CSS.", node.get$operatorSpan()));
                return _this._addExceptionSpan$2(node, new A._EvaluateVisitor_visitBinaryOperationExpression_closure(_this, node));
            },
            _slash$3: function(left, right, node) {
                var left0, _1_2, result = left.dividedBy$1(right), _1_2_isSet = left instanceof A.SassNumber, right0 = null, t1 = false;
                if (_1_2_isSet) {
                    if (right instanceof A.SassNumber) {
                        t1 = node.allowsSlash && this._operandAllowsSlash$1(node.left) && this._operandAllowsSlash$1(node.right);
                        right0 = right;
                    }
                    left0 = left;
                    _1_2 = right;
                } else {
                    _1_2 = null;
                    left0 = null;
                }
                if (t1) return type$.SassNumber._as(result).withSlash$2(left0, right0);
                if (left instanceof A.SassNumber) t1 = (_1_2_isSet ? _1_2 : right) instanceof A.SassNumber;
                else t1 = false;
                if (t1) {
                    this._warn$3(string$.Using__o + A.S(new A._EvaluateVisitor__slash_recommendation().call$1(node)) + " or " + A.expressionToCalc(node).toString$0(0) + string$.x0a_Morex20, node.get$span(0), B.Deprecation_qZ1);
                    return result;
                }
                return result;
            },
            _operandAllowsSlash$1: function(node) {
                var t1;
                if (node instanceof A.FunctionExpression) {
                    if (node.namespace == null) {
                        t1 = node.name;
                        t1 = B.Set_Pr3yj.contains$1(0, t1.toLowerCase()) && this._environment.getFunction$1(t1) == null;
                    } else t1 = false;
                } else t1 = true;
                return t1;
            },
            visitValueExpression$1: function(_, node) {
                return node.value;
            },
            visitVariableExpression$1: function(_, node) {
                var result = this._addExceptionSpan$2(node, new A._EvaluateVisitor_visitVariableExpression_closure(this, node));
                if (result != null) return result;
                throw A.wrapException(this._evaluate$_exception$2("Undefined variable.", node.span));
            },
            visitUnaryOperationExpression$1: function(_, node) {
                return this._addExceptionSpan$2(node, new A._EvaluateVisitor_visitUnaryOperationExpression_closure(node, node.operand.accept$1(this)));
            },
            visitBooleanExpression$1: function(_, node) {
                return node.value ? B.SassBoolean_true : B.SassBoolean_false;
            },
            visitIfExpression$1: function(_, node) {
                var t1, t2, t3, results, _i, t4, condition, expression, result, _1_2, _this = this;
                for(t1 = node.branches, t2 = t1.length, t3 = type$.JSArray_Record_2_String_and_Value, results = null, _i = 0; _i < t2; ++_i){
                    t4 = t1[_i];
                    condition = t4._0;
                    expression = t4._1;
                    result = condition == null ? null : condition.accept$1(_this);
                    if (result == null) result = true;
                    t4 = typeof result == "string";
                    condition = t4 ? result : null;
                    if (t4) {
                        if (results == null) results = A._setArrayType([], t3);
                        results.push(new A._Record_2(condition, expression.accept$1(_this)));
                        continue;
                    }
                    _1_2 = true === result;
                    if (_1_2 && results != null) {
                        results.push(new A._Record_2("else", expression.accept$1(_this)));
                        continue;
                    }
                    if (_1_2) return expression.accept$1(_this);
                }
                if (results == null) return B.C__SassNull;
                return new A.SassString("if(" + new A.MappedListIterable(results, new A._EvaluateVisitor_visitIfExpression_closure(), A._arrayInstanceType(results)._eval$1("MappedListIterable<1,String>")).join$1(0, "; ") + ")", false);
            },
            visitIfConditionParenthesized$1: function(_, node) {
                var t1, _0_0 = node.expression.accept$1(this);
                $label0$0: {
                    if (typeof _0_0 == "string") {
                        t1 = "(" + _0_0 + ")";
                        break $label0$0;
                    }
                    t1 = _0_0;
                    break $label0$0;
                }
                return t1;
            },
            visitIfConditionNegation$1: function(_, node) {
                var t1, _0_0 = node.expression.accept$1(this);
                $label0$0: {
                    if (typeof _0_0 == "string") {
                        t1 = "not " + _0_0;
                        break $label0$0;
                    }
                    if (A._isBool(_0_0)) {
                        t1 = !_0_0;
                        break $label0$0;
                    }
                    t1 = A.throwExpression(A.UnsupportedError$("unreachable"));
                }
                return t1;
            },
            visitIfConditionOperation$1: function(_, node) {
                var t1, t2, t3, t4, t5, t6, values, _i, expression, _0_0, t7, right, _1_6_isSet, _1_6, string;
                for(t1 = node.expressions, t2 = t1.length, t3 = node.op, t4 = t3 === B.BooleanOperator_0, t5 = t3 === B.BooleanOperator_1, t6 = type$.JSArray_Record_2_IfConditionExpression_and_String, values = null, _i = 0; _i < t2; ++_i){
                    expression = t1[_i];
                    _0_0 = expression.accept$1(this);
                    t7 = typeof _0_0 == "string";
                    right = t7 ? _0_0 : null;
                    if (t7) {
                        if (values == null) values = A._setArrayType([], t6);
                        values.push(new A._Record_2(expression, right));
                        continue;
                    }
                    if (false === _0_0 && t4) return false;
                    if (true === _0_0 && t5) return true;
                }
                $label0$1: {
                    if (values == null) {
                        t1 = t4;
                        break $label0$1;
                    }
                    _1_6_isSet = values.length === 1;
                    if (_1_6_isSet) {
                        _1_6 = values[0];
                        t1 = _1_6._0 instanceof A.IfConditionParenthesized;
                    } else {
                        _1_6 = null;
                        t1 = false;
                    }
                    if (t1) {
                        string = (_1_6_isSet ? _1_6 : values[0])._1;
                        t1 = B.JSString_methods.substring$2(string, 1, string.length - 1);
                        break $label0$1;
                    }
                    t1 = new A.MappedListIterable(values, new A._EvaluateVisitor_visitIfConditionOperation_closure(), A._arrayInstanceType(values)._eval$1("MappedListIterable<1,String>")).join$1(0, " " + t3.toString$0(0) + " ");
                    break $label0$1;
                }
                return t1;
            },
            visitIfConditionFunction$1: function(_, node) {
                return this._performInterpolation$1(node.name) + "(" + this._performInterpolation$1(node.$arguments) + ")";
            },
            visitIfConditionSass$1: function(_, node) {
                return node.expression.accept$1(this).get$isTruthy();
            },
            visitIfConditionRaw$1: function(_, node) {
                return this._performInterpolation$1(node.text);
            },
            visitLegacyIfExpression$1: function(_, node) {
                var condition, t1, ifTrue, ifFalse, result, _this = this, _0_0 = _this._evaluateMacroArguments$1(node), positional = _0_0._0, named = _0_0._1;
                _this._verifyArguments$4(positional.length, named, $.$get$LegacyIfExpression_declaration(), node);
                condition = A.ListExtensions_elementAtOrNull(positional, 0);
                if (condition == null) {
                    t1 = named.$index(0, "condition");
                    t1.toString;
                    condition = t1;
                }
                ifTrue = A.ListExtensions_elementAtOrNull(positional, 1);
                if (ifTrue == null) {
                    t1 = named.$index(0, "if-true");
                    t1.toString;
                    ifTrue = t1;
                }
                ifFalse = A.ListExtensions_elementAtOrNull(positional, 2);
                if (ifFalse == null) {
                    t1 = named.$index(0, "if-false");
                    t1.toString;
                    ifFalse = t1;
                }
                result = condition.accept$1(_this).get$isTruthy() ? ifTrue : ifFalse;
                return _this._withoutSlash$2(result.accept$1(_this), _this._expressionNode$1(result));
            },
            visitNullExpression$1: function(_, node) {
                return B.C__SassNull;
            },
            visitNumberExpression$1: function(_, node) {
                return A.SassNumber_SassNumber(node.value, node.unit);
            },
            visitParenthesizedExpression$1: function(_, node) {
                var _this = this;
                return _this._assertInModule$2(_this.__stylesheet, "_stylesheet").plainCss ? A.throwExpression(_this._evaluate$_exception$2("Parentheses aren't allowed in plain CSS.", node.span)) : node.expression.accept$1(_this);
            },
            visitColorExpression$1: function(_, node) {
                return node.value;
            },
            visitListExpression$1: function(_, node) {
                var t1 = node.contents;
                return A.SassList$(new A.MappedListIterable(t1, new A._EvaluateVisitor_visitListExpression_closure(this), A._arrayInstanceType(t1)._eval$1("MappedListIterable<1,Value>")), node.separator, node.hasBrackets);
            },
            visitMapExpression$1: function(_, node) {
                var t2, t3, _i, t4, key, keyValue, valueValue, oldValueSpan, t1 = type$.Value, map = A.LinkedHashMap_LinkedHashMap$_empty(t1, t1), keyNodes = A.LinkedHashMap_LinkedHashMap$_empty(t1, type$.AstNode);
                for(t2 = node.pairs, t3 = t2.length, _i = 0; _i < t3; ++_i){
                    t4 = t2[_i];
                    key = t4._0;
                    keyValue = key.accept$1(this);
                    valueValue = t4._1.accept$1(this);
                    if (map.containsKey$1(keyValue)) {
                        t1 = keyNodes.$index(0, keyValue);
                        oldValueSpan = t1 == null ? null : t1.get$span(t1);
                        t1 = key.get$span(key);
                        t2 = A.LinkedHashMap_LinkedHashMap$_empty(type$.FileSpan, type$.String);
                        if (oldValueSpan != null) t2.$indexSet(0, oldValueSpan, "first key");
                        throw A.wrapException(A.MultiSpanSassRuntimeException$("Duplicate key.", t1, "second key", t2, this._evaluate$_stackTrace$1(key.get$span(key)), null));
                    }
                    map.$indexSet(0, keyValue, valueValue);
                    keyNodes.$indexSet(0, keyValue, key);
                }
                return new A.SassMap(A.ConstantMap_ConstantMap$from(map, t1, t1));
            },
            visitFunctionExpression$1: function(_, node) {
                var t2, _0_0, t3, t4, $name, oldInFunction, result, _this = this, _s11_ = "_stylesheet", t1 = {}, $function = _this._assertInModule$2(_this.__stylesheet, _s11_).plainCss ? null : _this._addExceptionSpan$2(node, new A._EvaluateVisitor_visitFunctionExpression_closure(_this, node));
                t1.$function = $function;
                if ($function == null || B.JSString_methods.startsWith$1(node.originalName, "--")) {
                    if (node.namespace != null) throw A.wrapException(_this._evaluate$_exception$2("Undefined function.", node.span));
                    t2 = node.name;
                    _0_0 = t2.toLowerCase();
                    t3 = false;
                    if ("min" === _0_0 || "max" === _0_0 || "round" === _0_0 || "abs" === _0_0) {
                        t3 = node.$arguments;
                        t4 = t3.named;
                        t3 = t4.get$isEmpty(t4) && t3.rest == null && B.JSArray_methods.every$1(t3.positional, new A._EvaluateVisitor_visitFunctionExpression_closure0());
                        $name = _0_0;
                    } else $name = null;
                    if (t3) return _this._visitCalculation$2$inLegacySassFunction(node, $name);
                    if ("calc" === _0_0 || "clamp" === _0_0 || "hypot" === _0_0 || "sin" === _0_0 || "cos" === _0_0 || "tan" === _0_0 || "asin" === _0_0 || "acos" === _0_0 || "atan" === _0_0 || "sqrt" === _0_0 || "exp" === _0_0 || "sign" === _0_0 || "mod" === _0_0 || "rem" === _0_0 || "atan2" === _0_0 || "pow" === _0_0 || "log" === _0_0 || "calc-size" === _0_0) return _this._visitCalculation$1(node);
                    $function = _this._assertInModule$2(_this.__stylesheet, _s11_).plainCss ? null : _this._builtInFunctions.$index(0, t2);
                    t1.$function = $function == null ? new A.PlainCssCallable(node.originalName) : $function;
                }
                oldInFunction = _this._inFunction;
                _this._inFunction = true;
                result = _this._addErrorSpan$2(node, new A._EvaluateVisitor_visitFunctionExpression_closure1(t1, _this, node));
                _this._inFunction = oldInFunction;
                return result;
            },
            _visitCalculation$2$inLegacySassFunction: function(node, inLegacySassFunction) {
                var $arguments, oldCallableNode, t1, _0_0, error, stackTrace, t4, _i, _$exception, _this = this, t2 = node.$arguments, t3 = t2.named;
                if (t3.get$isNotEmpty(t3)) throw A.wrapException(_this._evaluate$_exception$2(string$.Keywor, node.span));
                else if (t2.rest != null) throw A.wrapException(_this._evaluate$_exception$2(string$.Rest_a, node.span));
                _this._checkCalculationArguments$1(node);
                t3 = A._setArrayType([], type$.JSArray_Object);
                for(t2 = t2.positional, t4 = t2.length, _i = 0; _i < t4; ++_i)t3.push(_this._visitCalculationExpression$2$inLegacySassFunction(t2[_i], inLegacySassFunction));
                $arguments = t3;
                if (_this._inSupportsDeclaration) return new A.SassCalculation(node.name, A.List_List$unmodifiable($arguments, type$.Object));
                oldCallableNode = _this._callableNode;
                _this._callableNode = node;
                try {
                    t1 = null;
                    t3 = node.name;
                    _0_0 = t3.toLowerCase();
                    $label0$0: {
                        if ("calc" === _0_0) {
                            t1 = A.SassCalculation_calc(J.$index$asx($arguments, 0));
                            break $label0$0;
                        }
                        if ("sqrt" === _0_0) {
                            t1 = A.SassCalculation__singleArgument("sqrt", J.$index$asx($arguments, 0), A.number0__sqrt$closure(), true);
                            break $label0$0;
                        }
                        if ("sin" === _0_0) {
                            t1 = A.SassCalculation__singleArgument("sin", J.$index$asx($arguments, 0), A.number0__sin$closure(), false);
                            break $label0$0;
                        }
                        if ("cos" === _0_0) {
                            t1 = A.SassCalculation__singleArgument("cos", J.$index$asx($arguments, 0), A.number0__cos$closure(), false);
                            break $label0$0;
                        }
                        if ("tan" === _0_0) {
                            t1 = A.SassCalculation__singleArgument("tan", J.$index$asx($arguments, 0), A.number0__tan$closure(), false);
                            break $label0$0;
                        }
                        if ("asin" === _0_0) {
                            t1 = A.SassCalculation__singleArgument("asin", J.$index$asx($arguments, 0), A.number0__asin$closure(), true);
                            break $label0$0;
                        }
                        if ("acos" === _0_0) {
                            t1 = A.SassCalculation__singleArgument("acos", J.$index$asx($arguments, 0), A.number0__acos$closure(), true);
                            break $label0$0;
                        }
                        if ("atan" === _0_0) {
                            t1 = A.SassCalculation__singleArgument("atan", J.$index$asx($arguments, 0), A.number0__atan$closure(), true);
                            break $label0$0;
                        }
                        if ("abs" === _0_0) {
                            t1 = A.SassCalculation_abs(J.$index$asx($arguments, 0));
                            break $label0$0;
                        }
                        if ("exp" === _0_0) {
                            t1 = A.SassCalculation_exp(J.$index$asx($arguments, 0));
                            break $label0$0;
                        }
                        if ("sign" === _0_0) {
                            t1 = A.SassCalculation_sign(J.$index$asx($arguments, 0));
                            break $label0$0;
                        }
                        if ("min" === _0_0) {
                            t1 = A.SassCalculation_min($arguments);
                            break $label0$0;
                        }
                        if ("max" === _0_0) {
                            t1 = A.SassCalculation_max($arguments);
                            break $label0$0;
                        }
                        if ("hypot" === _0_0) {
                            t1 = A.SassCalculation_hypot($arguments);
                            break $label0$0;
                        }
                        if ("pow" === _0_0) {
                            t1 = A.SassCalculation_pow(J.$index$asx($arguments, 0), A.ListExtensions_elementAtOrNull($arguments, 1));
                            break $label0$0;
                        }
                        if ("atan2" === _0_0) {
                            t1 = A.SassCalculation_atan2(J.$index$asx($arguments, 0), A.ListExtensions_elementAtOrNull($arguments, 1));
                            break $label0$0;
                        }
                        if ("log" === _0_0) {
                            t1 = A.SassCalculation_log(J.$index$asx($arguments, 0), A.ListExtensions_elementAtOrNull($arguments, 1));
                            break $label0$0;
                        }
                        if ("mod" === _0_0) {
                            t1 = A.SassCalculation_mod(J.$index$asx($arguments, 0), A.ListExtensions_elementAtOrNull($arguments, 1));
                            break $label0$0;
                        }
                        if ("rem" === _0_0) {
                            t1 = A.SassCalculation_rem(J.$index$asx($arguments, 0), A.ListExtensions_elementAtOrNull($arguments, 1));
                            break $label0$0;
                        }
                        if ("round" === _0_0) {
                            t1 = A.SassCalculation_roundInternal(J.$index$asx($arguments, 0), A.ListExtensions_elementAtOrNull($arguments, 1), A.ListExtensions_elementAtOrNull($arguments, 2), inLegacySassFunction, node.span, new A._EvaluateVisitor__visitCalculation_closure(_this, node));
                            break $label0$0;
                        }
                        if ("clamp" === _0_0) {
                            t1 = A.SassCalculation_clamp(J.$index$asx($arguments, 0), A.ListExtensions_elementAtOrNull($arguments, 1), A.ListExtensions_elementAtOrNull($arguments, 2));
                            break $label0$0;
                        }
                        if ("calc-size" === _0_0) {
                            t1 = A.SassCalculation_calcSize(J.$index$asx($arguments, 0), A.ListExtensions_elementAtOrNull($arguments, 1));
                            break $label0$0;
                        }
                        t3 = A.UnsupportedError$('Unknown calculation name "' + t3 + '".');
                        t1 = A.throwExpression(t3);
                    }
                    t1;
                    return t1;
                } catch (exception) {
                    t1 = A.unwrapException(exception);
                    if (t1 instanceof A.SassScriptException) {
                        error = t1;
                        stackTrace = A.getTraceFromException(exception);
                        if (B.JSString_methods.contains$1(error.message, "compatible")) _this._verifyCompatibleNumbers$2($arguments, t2);
                        A.throwWithTrace(_this._evaluate$_exception$2(error.message, node.span), error, stackTrace);
                    } else throw exception;
                } finally{
                    _this._callableNode = oldCallableNode;
                }
            },
            _visitCalculation$1: function(node) {
                return this._visitCalculation$2$inLegacySassFunction(node, null);
            },
            _checkCalculationArguments$1: function(node) {
                var t1, _0_0, check = new A._EvaluateVisitor__checkCalculationArguments_check(this, node);
                $label0$0: {
                    t1 = node.name;
                    _0_0 = t1.toLowerCase();
                    if ("calc" === _0_0 || "sqrt" === _0_0 || "sin" === _0_0 || "cos" === _0_0 || "tan" === _0_0 || "asin" === _0_0 || "acos" === _0_0 || "atan" === _0_0 || "abs" === _0_0 || "exp" === _0_0 || "sign" === _0_0) {
                        check.call$1(1);
                        break $label0$0;
                    }
                    if ("min" === _0_0 || "max" === _0_0 || "hypot" === _0_0) {
                        check.call$0();
                        break $label0$0;
                    }
                    if ("pow" === _0_0 || "atan2" === _0_0 || "log" === _0_0 || "mod" === _0_0 || "rem" === _0_0 || "calc-size" === _0_0) {
                        check.call$1(2);
                        break $label0$0;
                    }
                    if ("round" === _0_0 || "clamp" === _0_0) {
                        check.call$1(3);
                        break $label0$0;
                    }
                    throw A.wrapException(A.UnsupportedError$('Unknown calculation name "' + t1 + '".'));
                }
            },
            _verifyCompatibleNumbers$2: function(args, nodesWithSpans) {
                var i, t1, _0_0, arg, t2, number1, j, number2, t3, t4, t5, t6;
                for(i = 0; t1 = args.length, i < t1; ++i){
                    _0_0 = args[i];
                    if (_0_0 instanceof A.SassNumber) {
                        t1 = _0_0.get$hasComplexUnits();
                        arg = _0_0;
                    } else {
                        arg = null;
                        t1 = false;
                    }
                    if (t1) {
                        t1 = A.S(arg);
                        t2 = nodesWithSpans[i];
                        throw A.wrapException(this._evaluate$_exception$2("Number " + t1 + " isn't compatible with CSS calculations.", t2.get$span(t2)));
                    }
                }
                for(i = 0; i < t1 - 1; ++i){
                    number1 = args[i];
                    if (!(number1 instanceof A.SassNumber)) continue;
                    for(j = i + 1; t1 = args.length, j < t1; ++j){
                        number2 = args[j];
                        if (!(number2 instanceof A.SassNumber)) continue;
                        if (number1.hasPossiblyCompatibleUnits$1(number2)) continue;
                        t1 = number1.toString$0(0);
                        t2 = number2.toString$0(0);
                        t3 = nodesWithSpans[i];
                        t3 = t3.get$span(t3);
                        t4 = number1.toString$0(0);
                        t5 = nodesWithSpans[j];
                        t5 = A.LinkedHashMap_LinkedHashMap$_literal([
                            t5.get$span(t5),
                            number2.toString$0(0)
                        ], type$.FileSpan, type$.String);
                        t6 = nodesWithSpans[i];
                        throw A.wrapException(A.MultiSpanSassRuntimeException$(t1 + " and " + t2 + " are incompatible.", t3, t4, t5, this._evaluate$_stackTrace$1(t6.get$span(t6)), null));
                    }
                }
            },
            _visitCalculationExpression$2$inLegacySassFunction: function(node, inLegacySassFunction) {
                var result, t2, _0_0, _box_0, _1_0, t3, _i, i, _this = this, _null = null, t1 = node instanceof A.ParenthesizedExpression, inner = t1 ? node.expression : _null;
                if (t1) {
                    result = _this._visitCalculationExpression$2$inLegacySassFunction(inner, inLegacySassFunction);
                    return result instanceof A.SassString ? new A.SassString("(" + result._string$_text + ")", false) : result;
                }
                if (node instanceof A.StringExpression && node.accept$1(B.C_IsCalculationSafeVisitor)) {
                    t1 = node.text;
                    t2 = t1.get$asPlain();
                    _0_0 = t2 == null ? _null : t2.toLowerCase();
                    $label0$0: {
                        if ("pi" === _0_0) {
                            t1 = A.SassNumber_SassNumber(3.141592653589793, _null);
                            break $label0$0;
                        }
                        if ("e" === _0_0) {
                            t1 = A.SassNumber_SassNumber(2.718281828459045, _null);
                            break $label0$0;
                        }
                        if ("infinity" === _0_0) {
                            t1 = A.SassNumber_SassNumber(1 / 0, _null);
                            break $label0$0;
                        }
                        if ("-infinity" === _0_0) {
                            t1 = A.SassNumber_SassNumber(-1 / 0, _null);
                            break $label0$0;
                        }
                        if ("nan" === _0_0) {
                            t1 = A.SassNumber_SassNumber(0 / 0, _null);
                            break $label0$0;
                        }
                        t1 = new A.SassString(_this._performInterpolation$1(t1), false);
                        break $label0$0;
                    }
                    return t1;
                }
                _box_0 = {};
                _box_0.right = _box_0.left = _box_0.operator = null;
                t1 = node instanceof A.BinaryOperationExpression;
                if (t1) {
                    _box_0.operator = node.operator;
                    _box_0.left = node.left;
                    _box_0.right = node.right;
                }
                if (t1) {
                    _this._checkWhitespaceAroundCalculationOperator$1(node);
                    return _this._addExceptionSpan$2(node, new A._EvaluateVisitor__visitCalculationExpression_closure(_box_0, _this, node, inLegacySassFunction));
                }
                if (node instanceof A.NumberExpression || node instanceof A.VariableExpression || node instanceof A.FunctionExpression || node instanceof A.LegacyIfExpression) {
                    _1_0 = node.accept$1(_this);
                    $label1$1: {
                        if (_1_0 instanceof A.SassNumber) {
                            t1 = _1_0;
                            break $label1$1;
                        }
                        if (_1_0 instanceof A.SassCalculation) {
                            t1 = _1_0;
                            break $label1$1;
                        }
                        if (_1_0 instanceof A.SassString) {
                            t1 = !_1_0._hasQuotes;
                            result = _1_0;
                        } else {
                            result = _null;
                            t1 = false;
                        }
                        if (t1) {
                            t1 = result;
                            break $label1$1;
                        }
                        t1 = A.throwExpression(_this._evaluate$_exception$2("Value " + _1_0.toString$0(0) + " can't be used in a calculation.", node.get$span(node)));
                    }
                    return t1;
                }
                if (node instanceof A.ListExpression && !node.hasBrackets && B.ListSeparator_SrV === node.separator && node.contents.length >= 2) {
                    t1 = A._setArrayType([], type$.JSArray_Object);
                    for(t2 = node.contents, t3 = t2.length, _i = 0; _i < t3; ++_i)t1.push(_this._visitCalculationExpression$2$inLegacySassFunction(t2[_i], inLegacySassFunction));
                    _this._checkAdjacentCalculationValues$2(t1, node);
                    for(i = 0; i < t1.length; ++i){
                        t3 = t1[i];
                        if (t3 instanceof A.CalculationOperation && t2[i] instanceof A.ParenthesizedExpression) t1[i] = new A.SassString("(" + t3.toString$0(0) + ")", false);
                    }
                    return new A.SassString(B.JSArray_methods.join$1(t1, " "), false);
                }
                throw A.wrapException(_this._evaluate$_exception$2(string$.This_e, node.get$span(node)));
            },
            _checkWhitespaceAroundCalculationOperator$1: function(node) {
                var t2, t3, t4, textBetweenOperands, first, last, t1 = node.operator;
                if (t1 !== B.BinaryOperator_jCK && t1 !== B.BinaryOperator_tDf) return;
                t1 = node.left;
                t2 = t1.get$span(t1);
                t2 = t2.get$file(t2);
                t3 = node.right;
                t4 = t3.get$span(t3);
                if (t2 !== t4.get$file(t4)) return;
                t2 = t1.get$span(t1);
                t2 = t2.get$end(t2);
                t4 = t3.get$span(t3);
                if (t2.offset >= t4.get$start(t4).offset) return;
                t2 = t1.get$span(t1);
                t2 = t2.get$file(t2);
                t1 = t1.get$span(t1);
                t1 = t1.get$end(t1);
                t3 = t3.get$span(t3);
                textBetweenOperands = A.String_String$fromCharCodes(B.NativeUint32List_methods.sublist$2(t2._decodedChars, t1.offset, t3.get$start(t3).offset), 0, null);
                first = textBetweenOperands.charCodeAt(0);
                last = textBetweenOperands.charCodeAt(textBetweenOperands.length - 1);
                if (first === 32 || first === 9 || first === 10 || first === 13 || first === 12 || first === 47) t1 = !(last === 32 || last === 9 || last === 10 || last === 13 || last === 12 || last === 47);
                else t1 = true;
                if (t1) throw A.wrapException(this._evaluate$_exception$2(string$.x22x2b__an, node.get$operatorSpan()));
            },
            _binaryOperatorToCalculationOperator$2: function(operator, node) {
                var t1;
                $label0$0: {
                    if (B.BinaryOperator_jCK === operator) {
                        t1 = B.CalculationOperator_dpX;
                        break $label0$0;
                    }
                    if (B.BinaryOperator_tDf === operator) {
                        t1 = B.CalculationOperator_KrC;
                        break $label0$0;
                    }
                    if (B.BinaryOperator_wkM === operator) {
                        t1 = B.CalculationOperator_LPB;
                        break $label0$0;
                    }
                    if (B.BinaryOperator_ehp === operator) {
                        t1 = B.CalculationOperator_wFL;
                        break $label0$0;
                    }
                    t1 = A.throwExpression(this._evaluate$_exception$2(string$.This_o, node.get$operatorSpan()));
                }
                return t1;
            },
            _checkAdjacentCalculationValues$2: function(elements, node) {
                var t1, i, t2, previous, current, previousNode, currentNode, _0_2;
                for(t1 = elements.length, i = 1; i < t1; ++i){
                    t2 = i - 1;
                    previous = elements[t2];
                    current = elements[i];
                    if (previous instanceof A.SassString || current instanceof A.SassString) continue;
                    t1 = node.contents;
                    previousNode = t1[t2];
                    currentNode = t1[i];
                    if (currentNode instanceof A.UnaryOperationExpression) {
                        _0_2 = currentNode.operator;
                        if (B.UnaryOperator_hCO !== _0_2) t1 = B.UnaryOperator_n2K === _0_2;
                        else t1 = true;
                    } else t1 = false;
                    if (!t1) t1 = currentNode instanceof A.NumberExpression && currentNode.value < 0;
                    else t1 = true;
                    if (t1) throw A.wrapException(this._evaluate$_exception$2(string$.x22x2b__an, A.FileSpanExtension_subspan(currentNode.get$span(currentNode), 0, 1)));
                    else throw A.wrapException(this._evaluate$_exception$2("Missing math operator.", previousNode.get$span(previousNode).expand$1(0, currentNode.get$span(currentNode))));
                }
            },
            visitInterpolatedFunctionExpression$1: function(_, node) {
                var result, _this = this, t1 = _this._performInterpolation$1(node.name), oldInFunction = _this._inFunction;
                _this._inFunction = true;
                result = _this._addErrorSpan$2(node, new A._EvaluateVisitor_visitInterpolatedFunctionExpression_closure(_this, node, new A.PlainCssCallable(t1)));
                _this._inFunction = oldInFunction;
                return result;
            },
            _runUserDefinedCallable$1$4: function($arguments, callable, nodeWithSpan, run, $V) {
                var oldInDependency, result, _this = this, evaluated = _this._evaluateArguments$1($arguments), $name = callable.declaration.name;
                if ($name !== "@content") $name += "()";
                oldInDependency = _this._inDependency;
                _this._inDependency = callable.inDependency;
                result = _this._withStackFrame$3($name, nodeWithSpan, new A._EvaluateVisitor__runUserDefinedCallable_closure(_this, callable, evaluated, nodeWithSpan, run, $V));
                _this._inDependency = oldInDependency;
                return result;
            },
            _runFunctionCallable$3: function($arguments, callable, nodeWithSpan) {
                var buffer, first, argument, restArg, rest, error, t1, t2, _i, t3, t4, _$exception, _this = this;
                if (callable instanceof A.BuiltInCallable) return _this._withoutSlash$2(_this._runBuiltInCallable$3($arguments, callable, nodeWithSpan), nodeWithSpan);
                else if (type$.UserDefinedCallable_Environment._is(callable)) return _this._runUserDefinedCallable$1$4($arguments, callable, nodeWithSpan, new A._EvaluateVisitor__runFunctionCallable_closure(_this, callable), type$.Value);
                else if (callable instanceof A.PlainCssCallable) {
                    t1 = $arguments.named;
                    if (t1.get$isNotEmpty(t1) || $arguments.keywordRest != null) throw A.wrapException(_this._evaluate$_exception$2(string$.Plain_, nodeWithSpan.get$span(nodeWithSpan)));
                    buffer = new A.StringBuffer(callable.name + "(");
                    try {
                        first = true;
                        for(t1 = $arguments.positional, t2 = t1.length, _i = 0; _i < t2; ++_i){
                            argument = t1[_i];
                            if (first) first = false;
                            else buffer._contents += ", ";
                            t3 = buffer;
                            t4 = argument;
                            t4 = _this._evaluate$_serialize$3$quote(t4.accept$1(_this), t4, true);
                            t3._contents += t4;
                        }
                        restArg = $arguments.rest;
                        if (restArg != null) {
                            rest = restArg.accept$1(_this);
                            if (!first) buffer._contents += ", ";
                            t1 = buffer;
                            t2 = _this._evaluate$_serialize$2(rest, restArg);
                            t1._contents += t2;
                        }
                    } catch (exception) {
                        t1 = A.unwrapException(exception);
                        if (type$.SassRuntimeException._is(t1)) {
                            error = t1;
                            if (!B.JSString_methods.endsWith$1(error._span_exception$_message, "isn't a valid CSS value.")) throw exception;
                            throw A.wrapException(A.MultiSpanSassRuntimeException$(error._span_exception$_message, J.get$span$x(error), "value", A.LinkedHashMap_LinkedHashMap$_literal([
                                nodeWithSpan.get$span(nodeWithSpan),
                                "unknown function treated as plain CSS"
                            ], type$.FileSpan, type$.String), J.get$trace$z(error), null));
                        } else throw exception;
                    }
                    t1 = buffer;
                    t2 = A.Primitives_stringFromCharCode(41);
                    t1._contents += t2;
                    t2 = buffer._contents;
                    return new A.SassString(t2.charCodeAt(0) == 0 ? t2 : t2, false);
                } else throw A.wrapException(A.ArgumentError$("Unknown callable type " + J.get$runtimeType$(callable).toString$0(0) + ".", null));
            },
            _runBuiltInCallable$3: function($arguments, callable, nodeWithSpan) {
                var result, error, stackTrace, namedSet, _0_0, parameters, i, t1, parameter, t2, t3, rest, argumentList, _$exception, _this = this, _box_0 = {}, evaluated = _this._evaluateArguments$1($arguments), oldCallableNode = _this._callableNode;
                _this._callableNode = nodeWithSpan;
                namedSet = new A.MapKeySet(evaluated._values[0], type$.MapKeySet_String);
                _box_0.callback = _box_0.overload = null;
                _0_0 = callable.callbackFor$2(evaluated._values[2].length, namedSet);
                _box_0.overload = _0_0._0;
                _box_0.callback = _0_0._1;
                _this._addExceptionSpan$2(nodeWithSpan, new A._EvaluateVisitor__runBuiltInCallable_closure(_box_0, evaluated, namedSet));
                parameters = _box_0.overload.parameters;
                for(i = evaluated._values[2].length, t1 = parameters.length; i < t1; ++i){
                    parameter = parameters[i];
                    t2 = evaluated._values[2];
                    t3 = evaluated._values[0].remove$1(0, parameter.name);
                    if (t3 == null) {
                        t3 = parameter.defaultValue;
                        t3 = _this._withoutSlash$2(t3.accept$1(_this), t3);
                    }
                    t2.push(t3);
                }
                if (_box_0.overload.restParameter != null) {
                    if (evaluated._values[2].length > t1) {
                        rest = B.JSArray_methods.sublist$1(evaluated._values[2], t1);
                        B.JSArray_methods.removeRange$2(evaluated._values[2], t1, evaluated._values[2].length);
                    } else rest = B.List_empty8;
                    t1 = evaluated._values[0];
                    argumentList = A.SassArgumentList$(rest, t1, evaluated._values[4] === B.ListSeparator_undecided_null_3_undecided ? B.ListSeparator_z0K : evaluated._values[4]);
                    evaluated._values[2].push(argumentList);
                } else argumentList = null;
                result = null;
                try {
                    result = _this._addExceptionSpan$2(nodeWithSpan, new A._EvaluateVisitor__runBuiltInCallable_closure0(_box_0, evaluated));
                } catch (exception) {
                    t1 = A.unwrapException(exception);
                    if (t1 instanceof A.SassException) throw exception;
                    else {
                        error = t1;
                        stackTrace = A.getTraceFromException(exception);
                        A.throwWithTrace(_this._evaluate$_exception$2(_this._getErrorMessage$1(error), nodeWithSpan.get$span(nodeWithSpan)), error, stackTrace);
                    }
                }
                _this._callableNode = oldCallableNode;
                if (argumentList == null) return result;
                if (evaluated._values[0].__js_helper$_length === 0) return result;
                if (argumentList._wereKeywordsAccessed) return result;
                throw A.wrapException(A.MultiSpanSassRuntimeException$("No " + A.pluralize("parameter", evaluated._values[0].get$keys(0).get$length(0), null) + " named " + A.toSentence(evaluated._values[0].get$keys(0).map$1$1(0, new A._EvaluateVisitor__runBuiltInCallable_closure1(), type$.Object), "or") + ".", nodeWithSpan.get$span(nodeWithSpan), "invocation", A.LinkedHashMap_LinkedHashMap$_literal([
                    _box_0.overload.get$spanWithName(),
                    "declaration"
                ], type$.FileSpan, type$.String), _this._evaluate$_stackTrace$1(nodeWithSpan.get$span(nodeWithSpan)), null));
            },
            _evaluateArguments$1: function($arguments) {
                var t1, t2, _i, expression, nodeForSpan, named, namedNodes, t3, t4, $name, value, restArgs, rest, restNodeForSpan, t5, separator, keywordRestArgs, keywordRest, keywordRestNodeForSpan, _this = this, positional = A._setArrayType([], type$.JSArray_Value), positionalNodes = A._setArrayType([], type$.JSArray_AstNode);
                for(t1 = $arguments.positional, t2 = t1.length, _i = 0; _i < t2; ++_i){
                    expression = t1[_i];
                    nodeForSpan = _this._expressionNode$1(expression);
                    positional.push(_this._withoutSlash$2(expression.accept$1(_this), nodeForSpan));
                    positionalNodes.push(nodeForSpan);
                }
                t1 = type$.String;
                named = A.LinkedHashMap_LinkedHashMap$_empty(t1, type$.Value);
                t2 = type$.AstNode;
                namedNodes = A.LinkedHashMap_LinkedHashMap$_empty(t1, t2);
                for(t3 = A.MapExtensions_get_pairs($arguments.named, t1, type$.Expression), t3 = t3.get$iterator(t3); t3.moveNext$0();){
                    t4 = t3.get$current(t3);
                    $name = t4._0;
                    value = t4._1;
                    nodeForSpan = _this._expressionNode$1(value);
                    named.$indexSet(0, $name, _this._withoutSlash$2(value.accept$1(_this), nodeForSpan));
                    namedNodes.$indexSet(0, $name, nodeForSpan);
                }
                restArgs = $arguments.rest;
                if (restArgs == null) return new A._Record_5_named_namedNodes_positional_positionalNodes_separator([
                    named,
                    namedNodes,
                    positional,
                    positionalNodes,
                    B.ListSeparator_undecided_null_3_undecided
                ]);
                rest = restArgs.accept$1(_this);
                restNodeForSpan = _this._expressionNode$1(restArgs);
                if (rest instanceof A.SassMap) {
                    _this._addRestMap$4(named, rest, restArgs, new A._EvaluateVisitor__evaluateArguments_closure());
                    t3 = A.LinkedHashMap_LinkedHashMap$_empty(t1, t2);
                    for(t4 = rest._map$_contents, t4 = t4.get$keys(t4), t4 = t4.get$iterator(t4), t5 = type$.SassString; t4.moveNext$0();)t3.$indexSet(0, t5._as(t4.get$current(t4))._string$_text, restNodeForSpan);
                    namedNodes.addAll$1(0, t3);
                    separator = B.ListSeparator_undecided_null_3_undecided;
                } else if (rest instanceof A.SassList) {
                    t3 = rest._list$_contents;
                    B.JSArray_methods.addAll$1(positional, new A.MappedListIterable(t3, new A._EvaluateVisitor__evaluateArguments_closure0(_this, restNodeForSpan), A._arrayInstanceType(t3)._eval$1("MappedListIterable<1,Value>")));
                    B.JSArray_methods.addAll$1(positionalNodes, A.List_List$filled(t3.length, restNodeForSpan, false, t2));
                    separator = rest._separator;
                    if (rest instanceof A.SassArgumentList) {
                        rest._wereKeywordsAccessed = true;
                        rest._keywords.forEach$1(0, new A._EvaluateVisitor__evaluateArguments_closure1(_this, named, restNodeForSpan, namedNodes));
                    }
                } else {
                    positional.push(_this._withoutSlash$2(rest, restNodeForSpan));
                    positionalNodes.push(restNodeForSpan);
                    separator = B.ListSeparator_undecided_null_3_undecided;
                }
                keywordRestArgs = $arguments.keywordRest;
                if (keywordRestArgs == null) return new A._Record_5_named_namedNodes_positional_positionalNodes_separator([
                    named,
                    namedNodes,
                    positional,
                    positionalNodes,
                    separator
                ]);
                keywordRest = keywordRestArgs.accept$1(_this);
                keywordRestNodeForSpan = _this._expressionNode$1(keywordRestArgs);
                if (keywordRest instanceof A.SassMap) {
                    _this._addRestMap$4(named, keywordRest, keywordRestArgs, new A._EvaluateVisitor__evaluateArguments_closure2());
                    t1 = A.LinkedHashMap_LinkedHashMap$_empty(t1, t2);
                    for(t2 = keywordRest._map$_contents, t2 = t2.get$keys(t2), t2 = t2.get$iterator(t2), t3 = type$.SassString; t2.moveNext$0();)t1.$indexSet(0, t3._as(t2.get$current(t2))._string$_text, keywordRestNodeForSpan);
                    namedNodes.addAll$1(0, t1);
                    return new A._Record_5_named_namedNodes_positional_positionalNodes_separator([
                        named,
                        namedNodes,
                        positional,
                        positionalNodes,
                        separator
                    ]);
                } else throw A.wrapException(_this._evaluate$_exception$2(string$.Variabs + keywordRest.toString$0(0) + ").", keywordRestArgs.get$span(keywordRestArgs)));
            },
            _evaluateMacroArguments$1: function(invocation) {
                var t2, positional, named, rest, restNodeForSpan, keywordRestArgs_, keywordRest, keywordRestNodeForSpan, _this = this, t1 = invocation.$arguments, restArgs_ = t1.rest;
                if (restArgs_ == null) return new A._Record_2(t1.positional, t1.named);
                t2 = t1.positional;
                positional = A._setArrayType(t2.slice(0), A._arrayInstanceType(t2));
                named = A.LinkedHashMap_LinkedHashMap$of(t1.named, type$.String, type$.Expression);
                rest = restArgs_.accept$1(_this);
                restNodeForSpan = _this._expressionNode$1(restArgs_);
                if (rest instanceof A.SassMap) _this._addRestMap$4(named, rest, invocation, new A._EvaluateVisitor__evaluateMacroArguments_closure(restArgs_));
                else if (rest instanceof A.SassList) {
                    t2 = rest._list$_contents;
                    B.JSArray_methods.addAll$1(positional, new A.MappedListIterable(t2, new A._EvaluateVisitor__evaluateMacroArguments_closure0(_this, restNodeForSpan, restArgs_), A._arrayInstanceType(t2)._eval$1("MappedListIterable<1,Expression>")));
                    if (rest instanceof A.SassArgumentList) {
                        rest._wereKeywordsAccessed = true;
                        rest._keywords.forEach$1(0, new A._EvaluateVisitor__evaluateMacroArguments_closure1(_this, named, restNodeForSpan, restArgs_));
                    }
                } else positional.push(new A.ValueExpression(_this._withoutSlash$2(rest, restNodeForSpan), restArgs_.get$span(restArgs_)));
                keywordRestArgs_ = t1.keywordRest;
                if (keywordRestArgs_ == null) return new A._Record_2(positional, named);
                keywordRest = keywordRestArgs_.accept$1(_this);
                keywordRestNodeForSpan = _this._expressionNode$1(keywordRestArgs_);
                if (keywordRest instanceof A.SassMap) {
                    _this._addRestMap$4(named, keywordRest, invocation, new A._EvaluateVisitor__evaluateMacroArguments_closure2(_this, keywordRestNodeForSpan, keywordRestArgs_));
                    return new A._Record_2(positional, named);
                } else throw A.wrapException(_this._evaluate$_exception$2(string$.Variabs + keywordRest.toString$0(0) + ").", keywordRestArgs_.get$span(keywordRestArgs_)));
            },
            _addRestMap$1$4: function(values, map, nodeWithSpan, convert) {
                map._map$_contents.forEach$1(0, new A._EvaluateVisitor__addRestMap_closure(this, values, convert, this._expressionNode$1(nodeWithSpan), map, nodeWithSpan));
            },
            _addRestMap$4: function(values, map, nodeWithSpan, convert) {
                return this._addRestMap$1$4(values, map, nodeWithSpan, convert, type$.dynamic);
            },
            _verifyArguments$4: function(positional, named, parameters, nodeWithSpan) {
                return this._addExceptionSpan$2(nodeWithSpan, new A._EvaluateVisitor__verifyArguments_closure(parameters, positional, named));
            },
            visitSelectorExpression$1: function(_, node) {
                var t1 = this._styleRuleIgnoringAtRoot;
                t1 = t1 == null ? null : t1.originalSelector.get$asSassList();
                return t1 == null ? B.C__SassNull : t1;
            },
            visitStringExpression$1: function(_, node) {
                var t1, t2, t3, _i, value, t4, _0_0, text, _this = this, oldInSupportsDeclaration = _this._inSupportsDeclaration;
                _this._inSupportsDeclaration = false;
                t1 = A._setArrayType([], type$.JSArray_String);
                for(t2 = node.text.contents, t3 = t2.length, _i = 0; _i < t3; ++_i){
                    value = t2[_i];
                    $label0$0: {
                        if (typeof value == "string") {
                            t4 = value;
                            break $label0$0;
                        }
                        if (value instanceof A.Expression) {
                            _0_0 = value.accept$1(_this);
                            $label1$1: {
                                if (_0_0 instanceof A.SassString) {
                                    text = _0_0._string$_text;
                                    t4 = text;
                                    break $label1$1;
                                }
                                t4 = _this._evaluate$_serialize$3$quote(_0_0, value, false);
                                break $label1$1;
                            }
                            break $label0$0;
                        }
                        t4 = A.throwExpression(A.UnsupportedError$("Unknown interpolation value " + A.S(value)));
                    }
                    t1.push(t4);
                }
                t1 = B.JSArray_methods.join$0(t1);
                _this._inSupportsDeclaration = oldInSupportsDeclaration;
                return new A.SassString(t1, node.hasQuotes);
            },
            visitSupportsExpression$1: function(_, expression) {
                return new A.SassString(this._visitSupportsCondition$1(expression.condition), false);
            },
            visitCssAtRule$1: function(node) {
                var wasInKeyframes, wasInUnknownAtRule, t1, rule, _this = this;
                if (_this._declarationName != null) throw A.wrapException(_this._evaluate$_exception$2(string$.At_rul, node.span));
                if (node.isChildless) {
                    _this._copyParentAfterSibling$0();
                    _this._assertInModule$2(_this.__parent, "__parent").addChild$1(A.ModifiableCssAtRule$(node.name, node.span, true, node.value));
                    return;
                }
                wasInKeyframes = _this._inKeyframes;
                wasInUnknownAtRule = _this._inUnknownAtRule;
                t1 = node.name;
                if (A.unvendor(t1.value) === "keyframes") _this._inKeyframes = true;
                else _this._inUnknownAtRule = true;
                rule = A.ModifiableCssAtRule$(t1, node.span, false, node.value);
                if (_this.get$_hasCssNesting()) {
                    _this._withParent$2$3$scopeWhen(rule, new A._EvaluateVisitor_visitCssAtRule_closure(_this, node), false, type$.ModifiableCssAtRule, type$.Null);
                    _this._inUnknownAtRule = wasInUnknownAtRule;
                    _this._inKeyframes = wasInKeyframes;
                    return;
                }
                _this._withParent$2$4$scopeWhen$through(rule, new A._EvaluateVisitor_visitCssAtRule_closure0(_this, node), false, new A._EvaluateVisitor_visitCssAtRule_closure1(), type$.ModifiableCssAtRule, type$.Null);
                _this._inUnknownAtRule = wasInUnknownAtRule;
                _this._inKeyframes = wasInKeyframes;
            },
            visitCssComment$1: function(node) {
                var _this = this, _s8_ = "__parent", _s13_ = "_endOfImports";
                if (_this._assertInModule$2(_this.__parent, _s8_) === _this._assertInModule$2(_this.__root, "_root") && _this._assertInModule$2(_this.__endOfImports, _s13_) === J.get$length$asx(_this._assertInModule$2(_this.__root, "_root").children._collection$_source)) _this.__endOfImports = _this._assertInModule$2(_this.__endOfImports, _s13_) + 1;
                _this._copyParentAfterSibling$0();
                _this._assertInModule$2(_this.__parent, _s8_).addChild$1(new A.ModifiableCssComment(node.text, node.span));
            },
            visitCssDeclaration$1: function(node) {
                this._copyParentAfterSibling$0();
                this._assertInModule$2(this.__parent, "__parent").addChild$1(A.ModifiableCssDeclaration$(node.name, node.value, node.span, node.parsedAsSassScript, node.valueSpanForMap));
            },
            visitCssImport$1: function(node) {
                var t1, _this = this, _s8_ = "__parent", _s5_ = "_root", _s13_ = "_endOfImports", modifiableNode = new A.ModifiableCssImport(node.url, node.modifiers, node.span);
                if (_this._assertInModule$2(_this.__parent, _s8_) !== _this._assertInModule$2(_this.__root, _s5_)) {
                    _this._copyParentAfterSibling$0();
                    _this._assertInModule$2(_this.__parent, _s8_).addChild$1(modifiableNode);
                } else if (_this._assertInModule$2(_this.__endOfImports, _s13_) === J.get$length$asx(_this._assertInModule$2(_this.__root, _s5_).children._collection$_source)) {
                    _this._assertInModule$2(_this.__root, _s5_).addChild$1(modifiableNode);
                    _this.__endOfImports = _this._assertInModule$2(_this.__endOfImports, _s13_) + 1;
                } else {
                    t1 = _this._outOfOrderImports;
                    (t1 == null ? _this._outOfOrderImports = A._setArrayType([], type$.JSArray_ModifiableCssImport) : t1).push(modifiableNode);
                }
            },
            visitCssKeyframeBlock$1: function(node) {
                this._withParent$2$4$scopeWhen$through(A.ModifiableCssKeyframeBlock$(node.selector, node.span), new A._EvaluateVisitor_visitCssKeyframeBlock_closure(this, node), false, new A._EvaluateVisitor_visitCssKeyframeBlock_closure0(), type$.ModifiableCssKeyframeBlock, type$.Null);
            },
            visitCssMediaRule$1: function(node) {
                var mergedQueries, t1, mergedSources, t2, t3, _this = this;
                if (_this._declarationName != null) throw A.wrapException(_this._evaluate$_exception$2(string$.Media_, node.span));
                if (_this.get$_hasCssNesting()) {
                    _this._withParent$2$3$scopeWhen(A.ModifiableCssMediaRule$(node.queries, node.span), new A._EvaluateVisitor_visitCssMediaRule_closure(_this, node), false, type$.ModifiableCssMediaRule, type$.Null);
                    return;
                }
                mergedQueries = A.NullableExtension_andThen(_this._mediaQueries, new A._EvaluateVisitor_visitCssMediaRule_closure0(_this, node));
                t1 = mergedQueries == null;
                if (!t1 && J.get$isEmpty$asx(mergedQueries)) return;
                if (t1) mergedSources = B.Set_empty2;
                else {
                    t2 = _this._mediaQuerySources;
                    t2.toString;
                    t2 = A.LinkedHashSet_LinkedHashSet$of(t2, type$.CssMediaQuery);
                    t3 = _this._mediaQueries;
                    t3.toString;
                    t2.addAll$1(0, t3);
                    t2.addAll$1(0, node.queries);
                    mergedSources = t2;
                }
                t1 = t1 ? node.queries : mergedQueries;
                _this._withParent$2$4$scopeWhen$through(A.ModifiableCssMediaRule$(t1, node.span), new A._EvaluateVisitor_visitCssMediaRule_closure1(_this, mergedQueries, node, mergedSources), false, new A._EvaluateVisitor_visitCssMediaRule_closure2(mergedSources), type$.ModifiableCssMediaRule, type$.Null);
            },
            visitCssStyleRule$1: function(node) {
                var t1, styleRule, _0_0, t2, t3, originalSelector, rule, oldAtRootExcludingStyleRule, _1_1, lastChild, _this = this, _null = null, _s8_ = "__parent";
                if (_this._declarationName != null) throw A.wrapException(_this._evaluate$_exception$2(string$.Style_n, node.span));
                else if (_this._inKeyframes && _this._assertInModule$2(_this.__parent, _s8_) instanceof A.ModifiableCssKeyframeBlock) throw A.wrapException(_this._evaluate$_exception$2(string$.Style_k, node.span));
                t1 = _this._atRootExcludingStyleRule;
                styleRule = t1 ? _null : _this._styleRuleIgnoringAtRoot;
                _0_0 = t1 ? _null : _this._styleRuleIgnoringAtRoot;
                $label0$0: {
                    if (_0_0 == null) {
                        t1 = true;
                        break $label0$0;
                    }
                    if (_0_0.fromPlainCss) {
                        t1 = false;
                        break $label0$0;
                    }
                    t1 = !(node.fromPlainCss && node._style_rule$_selector._box$_inner.value.accept$1(B.C__ContainsParentSelectorVisitor));
                    break $label0$0;
                }
                t2 = node._style_rule$_selector._box$_inner;
                if (t1) {
                    t2 = t2.value;
                    t3 = styleRule == null ? _null : styleRule.originalSelector;
                    originalSelector = t2.nestWithin$3$implicitParent$preserveParentSelectors(t3, !_this._atRootExcludingStyleRule, node.fromPlainCss);
                } else originalSelector = t2.value;
                rule = A.ModifiableCssStyleRule$(_this._assertInModule$2(_this.__extensionStore, "_extensionStore").addSelector$2(originalSelector, _this._mediaQueries), node.span, node.fromPlainCss, originalSelector);
                oldAtRootExcludingStyleRule = _this._atRootExcludingStyleRule;
                _this._atRootExcludingStyleRule = false;
                t1 = t1 ? new A._EvaluateVisitor_visitCssStyleRule_closure() : _null;
                _this._withParent$2$4$scopeWhen$through(rule, new A._EvaluateVisitor_visitCssStyleRule_closure0(_this, rule, node), false, t1, type$.ModifiableCssStyleRule, type$.Null);
                _this._atRootExcludingStyleRule = oldAtRootExcludingStyleRule;
                t1 = _this._assertInModule$2(_this.__parent, _s8_).children._collection$_source;
                t2 = J.getInterceptor$asx(t1);
                _1_1 = t2.get$length(t1);
                if (_1_1 >= 1) {
                    lastChild = t2.elementAt$1(t1, _1_1 - 1);
                    t1 = styleRule == null;
                } else {
                    lastChild = _null;
                    t1 = false;
                }
                if (t1) lastChild.isGroupEnd = true;
            },
            visitCssStylesheet$1: function(node) {
                var t1;
                for(t1 = J.get$iterator$ax(node.get$children(node)); t1.moveNext$0();)t1.get$current(t1).accept$1(this);
            },
            visitCssSupportsRule$1: function(node) {
                var rule, _this = this;
                if (_this._declarationName != null) throw A.wrapException(_this._evaluate$_exception$2(string$.Suppor, node.span));
                rule = A.ModifiableCssSupportsRule$(node.condition, node.span);
                if (_this.get$_hasCssNesting()) {
                    _this._withParent$2$3$scopeWhen(rule, new A._EvaluateVisitor_visitCssSupportsRule_closure(_this, node), false, type$.ModifiableCssSupportsRule, type$.Null);
                    return;
                }
                _this._withParent$2$4$scopeWhen$through(rule, new A._EvaluateVisitor_visitCssSupportsRule_closure0(_this, node), false, new A._EvaluateVisitor_visitCssSupportsRule_closure1(), type$.ModifiableCssSupportsRule, type$.Null);
            },
            _handleReturn$1$2: function(list, callback) {
                var t1, _i, _0_0;
                for(t1 = list.length, _i = 0; _i < list.length; list.length === t1 || (0, A.throwConcurrentModificationError)(list), ++_i){
                    _0_0 = callback.call$1(list[_i]);
                    if (_0_0 != null) return _0_0;
                }
                return null;
            },
            _handleReturn$2: function(list, callback) {
                return this._handleReturn$1$2(list, callback, type$.dynamic);
            },
            _withEnvironment$1$2: function(environment, callback) {
                var result, oldEnvironment = this._environment;
                this._environment = environment;
                result = callback.call$0();
                this._environment = oldEnvironment;
                return result;
            },
            _withEnvironment$2: function(environment, callback) {
                return this._withEnvironment$1$2(environment, callback, type$.dynamic);
            },
            _interpolationToValue$3$trim$warnForColor: function(interpolation, trim, warnForColor) {
                var result = this._performInterpolation$2$warnForColor(interpolation, warnForColor), t1 = trim ? A.trimAscii(result, true) : result;
                return new A.CssValue(t1, interpolation.span, type$.CssValue_String);
            },
            _interpolationToValue$1: function(interpolation) {
                return this._interpolationToValue$3$trim$warnForColor(interpolation, false, false);
            },
            _interpolationToValue$2$warnForColor: function(interpolation, warnForColor) {
                return this._interpolationToValue$3$trim$warnForColor(interpolation, false, warnForColor);
            },
            _performInterpolation$2$warnForColor: function(interpolation, warnForColor) {
                return this._performInterpolationHelper$3$sourceMap$warnForColor(interpolation, false, warnForColor)._0;
            },
            _performInterpolation$1: function(interpolation) {
                return this._performInterpolation$2$warnForColor(interpolation, false);
            },
            _performInterpolationWithMap$2$warnForColor: function(interpolation, warnForColor) {
                var _0_0 = this._performInterpolationHelper$3$sourceMap$warnForColor(interpolation, true, true), map = _0_0._1;
                map.toString;
                return new A._Record_2(_0_0._0, map);
            },
            _performInterpolationHelper$3$sourceMap$warnForColor: function(interpolation, sourceMap, warnForColor) {
                var t1, t2, t3, t4, t5, t6, first, _i, t7, value, result, result0, t8, _this = this, targetOffsets = sourceMap ? A._setArrayType([], type$.JSArray_int) : null, oldInSupportsDeclaration = _this._inSupportsDeclaration;
                _this._inSupportsDeclaration = false;
                for(t1 = interpolation.contents, t2 = t1.length, t3 = type$.Expression, t4 = targetOffsets == null, t5 = interpolation.span, t6 = type$.Object, first = true, _i = 0, t7 = ""; _i < t2; ++_i, first = false){
                    value = t1[_i];
                    if (!first) {
                        if (!t4) targetOffsets.push(t7.length);
                    }
                    if (typeof value == "string") {
                        t7 += value;
                        continue;
                    }
                    t3._as(value);
                    result = value.accept$1(_this);
                    if (warnForColor && $.$get$namesByColor().containsKey$1(result)) {
                        result0 = A.List_List$from([
                            ""
                        ], false, t6);
                        result0.$flags = 3;
                        t8 = $.$get$namesByColor();
                        _this._warn$2(string$.You_pr + A.S(t8.$index(0, result)) + string$.x20in_in + result.toString$0(0) + string$.x2c_whicw + A.S(t8.$index(0, result)) + string$.x22x29__If + new A.BinaryOperationExpression(B.BinaryOperator_jCK, new A.StringExpression(new A.Interpolation(result0, B.List_null, t5), true), value, false).toString$0(0) + "'.", value.get$span(value));
                    }
                    t7 += _this._evaluate$_serialize$3$quote(result, value, false);
                }
                _this._inSupportsDeclaration = oldInSupportsDeclaration;
                return new A._Record_2(t7.charCodeAt(0) == 0 ? t7 : t7, A.NullableExtension_andThen(targetOffsets, new A._EvaluateVisitor__performInterpolationHelper_closure(interpolation)));
            },
            _evaluate$_serialize$3$quote: function(value, nodeWithSpan, quote) {
                return this._addExceptionSpan$2(nodeWithSpan, new A._EvaluateVisitor__serialize_closure(value, quote));
            },
            _evaluate$_serialize$2: function(value, nodeWithSpan) {
                return this._evaluate$_serialize$3$quote(value, nodeWithSpan, true);
            },
            _expressionNode$1: function(expression) {
                var t1;
                if (expression instanceof A.VariableExpression) {
                    t1 = this._addExceptionSpan$2(expression, new A._EvaluateVisitor__expressionNode_closure(this, expression));
                    return t1 == null ? expression : t1;
                } else return expression;
            },
            _withParent$2$4$scopeWhen$through: function(node, callback, scopeWhen, through, $S, $T) {
                var oldParent, result, _this = this;
                _this._addChild$2$through(node, through);
                oldParent = _this._assertInModule$2(_this.__parent, "__parent");
                _this.__parent = node;
                result = _this._environment.scope$1$2$when(callback, scopeWhen, $T);
                _this.__parent = oldParent;
                return result;
            },
            _withParent$2$3$scopeWhen: function(node, callback, scopeWhen, $S, $T) {
                return this._withParent$2$4$scopeWhen$through(node, callback, scopeWhen, null, $S, $T);
            },
            _withParent$2$2: function(node, callback, $S, $T) {
                return this._withParent$2$4$scopeWhen$through(node, callback, true, null, $S, $T);
            },
            _copyParentAfterSibling$0: function() {
                var t1, grandparent, newParent, _this = this, _s8_ = "__parent", _0_0 = _this._assertInModule$2(_this.__parent, _s8_)._parent;
                if (_0_0 != null) {
                    t1 = _0_0.children;
                    t1 = t1.get$last(t1) !== _this._assertInModule$2(_this.__parent, _s8_);
                    grandparent = _0_0;
                } else {
                    grandparent = null;
                    t1 = false;
                }
                if (t1) {
                    newParent = _this._assertInModule$2(_this.__parent, _s8_).copyWithoutChildren$0();
                    grandparent.addChild$1(newParent);
                    _this.__parent = newParent;
                }
            },
            _addChild$2$through: function(node, through) {
                var _0_0, grandparent, t1, $parent = this._assertInModule$2(this.__parent, "__parent");
                if (through != null) {
                    for(; through.call$1($parent); $parent = _0_0){
                        _0_0 = $parent._parent;
                        if (_0_0 == null) throw A.wrapException(A.ArgumentError$(string$.throug + node.toString$0(0) + ".", null));
                    }
                    if ($parent.get$hasFollowingSibling()) {
                        grandparent = $parent._parent;
                        t1 = grandparent.children;
                        if ($parent.equalsIgnoringChildren$1(t1.get$last(t1))) $parent = type$.ModifiableCssParentNode._as(t1.get$last(t1));
                        else {
                            $parent = $parent.copyWithoutChildren$0();
                            grandparent.addChild$1($parent);
                        }
                    }
                }
                $parent.addChild$1(node);
            },
            _addChild$1: function(node) {
                return this._addChild$2$through(node, null);
            },
            _withStyleRule$1$2: function(rule, callback) {
                var result, oldRule = this._styleRuleIgnoringAtRoot;
                this._styleRuleIgnoringAtRoot = rule;
                result = callback.call$0();
                this._styleRuleIgnoringAtRoot = oldRule;
                return result;
            },
            _withStyleRule$2: function(rule, callback) {
                return this._withStyleRule$1$2(rule, callback, type$.dynamic);
            },
            _withMediaQueries$1$3: function(queries, sources, callback) {
                var result, _this = this, oldMediaQueries = _this._mediaQueries, oldSources = _this._mediaQuerySources;
                _this._mediaQueries = queries;
                _this._mediaQuerySources = sources;
                result = callback.call$0();
                _this._mediaQueries = oldMediaQueries;
                _this._mediaQuerySources = oldSources;
                return result;
            },
            _withMediaQueries$3: function(queries, sources, callback) {
                return this._withMediaQueries$1$3(queries, sources, callback, type$.dynamic);
            },
            _withStackFrame$1$3: function(member, nodeWithSpan, callback) {
                var oldMember, result, _this = this, t1 = _this._stack;
                t1.push(new A._Record_2(_this._member, nodeWithSpan));
                oldMember = _this._member;
                _this._member = member;
                result = callback.call$0();
                _this._member = oldMember;
                t1.pop();
                return result;
            },
            _withStackFrame$3: function(member, nodeWithSpan, callback) {
                return this._withStackFrame$1$3(member, nodeWithSpan, callback, type$.dynamic);
            },
            _withoutSlash$2: function(value, nodeForSpan) {
                var t1;
                if (value instanceof A.SassNumber) t1 = value.asSlash != null;
                else t1 = false;
                if (t1) this._warn$3(string$.Using__i + A.S(new A._EvaluateVisitor__withoutSlash_recommendation().call$1(value)) + string$.x0a_Morex20, nodeForSpan.get$span(nodeForSpan), B.Deprecation_qZ1);
                return value.withoutSlash$0();
            },
            _stackFrame$2: function(member, span) {
                return A.frameForSpan(span, member, A.NullableExtension_andThen(span.get$sourceUrl(span), new A._EvaluateVisitor__stackFrame_closure(this)));
            },
            _evaluate$_stackTrace$1: function(span) {
                var t2, t3, _i, t4, nodeWithSpan, _this = this, t1 = A._setArrayType([], type$.JSArray_Frame);
                for(t2 = _this._stack, t3 = t2.length, _i = 0; _i < t2.length; t2.length === t3 || (0, A.throwConcurrentModificationError)(t2), ++_i){
                    t4 = t2[_i];
                    nodeWithSpan = t4._1;
                    t1.push(_this._stackFrame$2(t4._0, nodeWithSpan.get$span(nodeWithSpan)));
                }
                if (span != null) t1.push(_this._stackFrame$2(_this._member, span));
                return A.Trace$(new A.ReversedListIterable(t1, type$.ReversedListIterable_Frame), null);
            },
            _evaluate$_stackTrace$0: function() {
                return this._evaluate$_stackTrace$1(null);
            },
            _warn$3: function(message, span, deprecation) {
                var trace, t1, _this = this;
                if (_this._quietDeps && _this._inDependency) return;
                if (!_this._warningsEmitted.add$1(0, new A._Record_2(message, span))) return;
                trace = _this._evaluate$_stackTrace$1(span);
                t1 = _this._logger;
                if (deprecation == null) t1.internalWarn$4$deprecation$span$trace(message, null, span, trace);
                else A.WarnForDeprecation_warnForDeprecation(t1, deprecation, message, span, trace);
            },
            _warn$2: function(message, span) {
                return this._warn$3(message, span, null);
            },
            _evaluate$_exception$2: function(message, span) {
                var t1, t2;
                if (span == null) {
                    t1 = B.JSArray_methods.get$last(this._stack)._1;
                    t1 = t1.get$span(t1);
                } else t1 = span;
                t2 = this._evaluate$_stackTrace$1(span);
                return new A.SassRuntimeException(t2, B.Set_empty, message, t1);
            },
            _evaluate$_exception$1: function(message) {
                return this._evaluate$_exception$2(message, null);
            },
            _multiSpanException$3: function(message, primaryLabel, secondaryLabels) {
                var t1 = B.JSArray_methods.get$last(this._stack)._1;
                return A.MultiSpanSassRuntimeException$(message, t1.get$span(t1), primaryLabel, secondaryLabels, this._evaluate$_stackTrace$0(), null);
            },
            _addExceptionSpan$1$3$addStackFrame: function(nodeWithSpan, callback, addStackFrame) {
                var error, stackTrace, t1, _$exception;
                try {
                    t1 = callback.call$0();
                    return t1;
                } catch (exception) {
                    t1 = A.unwrapException(exception);
                    if (t1 instanceof A.SassScriptException) {
                        error = t1;
                        stackTrace = A.getTraceFromException(exception);
                        t1 = error.withSpan$1(nodeWithSpan.get$span(nodeWithSpan));
                        A.throwWithTrace(t1.withTrace$1(this._evaluate$_stackTrace$1(addStackFrame ? nodeWithSpan.get$span(nodeWithSpan) : null)), error, stackTrace);
                    } else throw exception;
                }
            },
            _addExceptionSpan$2: function(nodeWithSpan, callback) {
                return this._addExceptionSpan$1$3$addStackFrame(nodeWithSpan, callback, true, type$.dynamic);
            },
            _addExceptionSpan$3$addStackFrame: function(nodeWithSpan, callback, addStackFrame) {
                return this._addExceptionSpan$1$3$addStackFrame(nodeWithSpan, callback, addStackFrame, type$.dynamic);
            },
            _addExceptionTrace$1$1: function(callback) {
                var error, stackTrace, t1, _$exception, t2;
                try {
                    t1 = callback.call$0();
                    return t1;
                } catch (exception) {
                    t1 = A.unwrapException(exception);
                    if (type$.SassRuntimeException._is(t1)) throw exception;
                    else if (t1 instanceof A.SassException) {
                        error = t1;
                        stackTrace = A.getTraceFromException(exception);
                        t1 = error;
                        t2 = J.getInterceptor$x(t1);
                        A.throwWithTrace(error.withTrace$1(this._evaluate$_stackTrace$1(A.SourceSpanException.prototype.get$span.call(t2, t1))), error, stackTrace);
                    } else throw exception;
                }
            },
            _addExceptionTrace$1: function(callback) {
                return this._addExceptionTrace$1$1(callback, type$.dynamic);
            },
            _addErrorSpan$1$2: function(nodeWithSpan, callback) {
                var error, stackTrace, t1, _$exception, t2, t3;
                try {
                    t1 = callback.call$0();
                    return t1;
                } catch (exception) {
                    t1 = A.unwrapException(exception);
                    if (type$.SassRuntimeException._is(t1)) {
                        error = t1;
                        stackTrace = A.getTraceFromException(exception);
                        if (!B.JSString_methods.startsWith$1(J.get$span$x(error).get$text(), "@error")) throw exception;
                        t1 = error._span_exception$_message;
                        t2 = nodeWithSpan.get$span(nodeWithSpan);
                        t3 = this._evaluate$_stackTrace$0();
                        A.throwWithTrace(new A.SassRuntimeException(t3, B.Set_empty, t1, t2), error, stackTrace);
                    } else throw exception;
                }
            },
            _addErrorSpan$2: function(nodeWithSpan, callback) {
                return this._addErrorSpan$1$2(nodeWithSpan, callback, type$.dynamic);
            },
            _getErrorMessage$1: function(error) {
                var t1, exception;
                if (type$.Error._is(error)) return error.toString$0(0);
                try {
                    t1 = A._asString(J.get$message$x(error));
                    return t1;
                } catch (exception) {
                    t1 = J.toString$0$(error);
                    return t1;
                }
            }
        };
        A._EvaluateVisitor_closure.prototype = {
            call$1: function($arguments) {
                var module, t2, t1 = J.getInterceptor$asx($arguments), variable = t1.$index($arguments, 0).assertString$1("name");
                t1 = t1.$index($arguments, 1).get$realNull();
                module = t1 == null ? null : t1.assertString$1("module");
                t1 = this.$this._environment;
                t2 = A.stringReplaceAllUnchecked(variable._string$_text, "_", "-");
                return t1.globalVariableExists$2$namespace(t2, module == null ? null : module._string$_text) ? B.SassBoolean_true : B.SassBoolean_false;
            },
            $signature: 11
        };
        A._EvaluateVisitor_closure0.prototype = {
            call$1: function($arguments) {
                var variable = J.$index$asx($arguments, 0).assertString$1("name"), t1 = this.$this._environment;
                return t1.getVariable$1(A.stringReplaceAllUnchecked(variable._string$_text, "_", "-")) != null ? B.SassBoolean_true : B.SassBoolean_false;
            },
            $signature: 11
        };
        A._EvaluateVisitor_closure1.prototype = {
            call$1: function($arguments) {
                var module, t2, t3, t4, t1 = J.getInterceptor$asx($arguments), variable = t1.$index($arguments, 0).assertString$1("name");
                t1 = t1.$index($arguments, 1).get$realNull();
                module = t1 == null ? null : t1.assertString$1("module");
                t1 = this.$this;
                t2 = t1._environment;
                t3 = variable._string$_text;
                t4 = A.stringReplaceAllUnchecked(t3, "_", "-");
                return t2.getFunction$2$namespace(t4, module == null ? null : module._string$_text) != null || t1._builtInFunctions.containsKey$1(t3) ? B.SassBoolean_true : B.SassBoolean_false;
            },
            $signature: 11
        };
        A._EvaluateVisitor_closure2.prototype = {
            call$1: function($arguments) {
                var module, t2, t1 = J.getInterceptor$asx($arguments), variable = t1.$index($arguments, 0).assertString$1("name");
                t1 = t1.$index($arguments, 1).get$realNull();
                module = t1 == null ? null : t1.assertString$1("module");
                t1 = this.$this._environment;
                t2 = A.stringReplaceAllUnchecked(variable._string$_text, "_", "-");
                return t1.getMixin$2$namespace(t2, module == null ? null : module._string$_text) != null ? B.SassBoolean_true : B.SassBoolean_false;
            },
            $signature: 11
        };
        A._EvaluateVisitor_closure3.prototype = {
            call$1: function($arguments) {
                var t1 = this.$this._environment;
                if (!t1._inMixin) throw A.wrapException(A.SassScriptException$(string$.conten, null));
                return t1._content != null ? B.SassBoolean_true : B.SassBoolean_false;
            },
            $signature: 11
        };
        A._EvaluateVisitor_closure4.prototype = {
            call$1: function($arguments) {
                var t2, t3, t4, t1 = J.$index$asx($arguments, 0).assertString$1("module")._string$_text, module = this.$this._environment._environment$_modules.$index(0, t1);
                if (module == null) throw A.wrapException('There is no module with namespace "' + t1 + '".');
                t1 = type$.Value;
                t2 = A.LinkedHashMap_LinkedHashMap$_empty(t1, t1);
                for(t3 = A.MapExtensions_get_pairs(module.get$variables(), type$.String, t1), t3 = t3.get$iterator(t3); t3.moveNext$0();){
                    t4 = t3.get$current(t3);
                    t2.$indexSet(0, new A.SassString(t4._0, true), t4._1);
                }
                return new A.SassMap(A.ConstantMap_ConstantMap$from(t2, t1, t1));
            },
            $signature: 38
        };
        A._EvaluateVisitor_closure5.prototype = {
            call$1: function($arguments) {
                var t3, t4, t5, t1 = this.$this, t2 = J.$index$asx($arguments, 0).assertString$1("module")._string$_text, module = t1._environment._environment$_modules.$index(0, t2);
                if (module == null) throw A.wrapException('There is no module with namespace "' + t2 + '".');
                t2 = type$.Value;
                t3 = A.LinkedHashMap_LinkedHashMap$_empty(t2, t2);
                for(t4 = A.MapExtensions_get_pairs(module.get$functions(module), type$.String, type$.Callable), t4 = t4.get$iterator(t4), t1 = t1._compileContext; t4.moveNext$0();){
                    t5 = t4.get$current(t4);
                    t3.$indexSet(0, new A.SassString(t5._0, true), new A.SassFunction(t5._1, t1));
                }
                return new A.SassMap(A.ConstantMap_ConstantMap$from(t3, t2, t2));
            },
            $signature: 38
        };
        A._EvaluateVisitor_closure6.prototype = {
            call$1: function($arguments) {
                var t3, t4, t5, t1 = this.$this, t2 = J.$index$asx($arguments, 0).assertString$1("module")._string$_text, module = t1._environment._environment$_modules.$index(0, t2);
                if (module == null) throw A.wrapException('There is no module with namespace "' + t2 + '".');
                t2 = type$.Value;
                t3 = A.LinkedHashMap_LinkedHashMap$_empty(t2, t2);
                for(t4 = A.MapExtensions_get_pairs(module.get$mixins(), type$.String, type$.Callable), t4 = t4.get$iterator(t4), t1 = t1._compileContext; t4.moveNext$0();){
                    t5 = t4.get$current(t4);
                    t3.$indexSet(0, new A.SassString(t5._0, true), new A.SassMixin(t5._1, t1));
                }
                return new A.SassMap(A.ConstantMap_ConstantMap$from(t3, t2, t2));
            },
            $signature: 38
        };
        A._EvaluateVisitor_closure7.prototype = {
            call$1: function($arguments) {
                var module, t2, callable, t1 = J.getInterceptor$asx($arguments), $name = t1.$index($arguments, 0).assertString$1("name"), css = t1.$index($arguments, 1).get$isTruthy();
                t1 = t1.$index($arguments, 2).get$realNull();
                module = t1 == null ? null : t1.assertString$1("module");
                if (css) {
                    if (module != null) throw A.wrapException(string$.x24css_a);
                    return new A.SassFunction(new A.PlainCssCallable($name._string$_text), this.$this._compileContext);
                }
                t1 = this.$this;
                t2 = t1._callableNode;
                t2.toString;
                callable = t1._addExceptionSpan$2(t2, new A._EvaluateVisitor__closure2(t1, $name, module));
                if (callable == null) throw A.wrapException("Function not found: " + $name.toString$0(0));
                return new A.SassFunction(callable, t1._compileContext);
            },
            $signature: 167
        };
        A._EvaluateVisitor__closure2.prototype = {
            call$0: function() {
                var local, normalizedName = A.stringReplaceAllUnchecked(this.name._string$_text, "_", "-"), t1 = this.module, namespace = t1 == null ? null : t1._string$_text;
                t1 = this.$this;
                local = t1._environment.getFunction$2$namespace(normalizedName, namespace);
                if (local != null || namespace != null) return local;
                return t1._builtInFunctions.$index(0, normalizedName);
            },
            $signature: 113
        };
        A._EvaluateVisitor_closure8.prototype = {
            call$1: function($arguments) {
                var module, t2, callable, t1 = J.getInterceptor$asx($arguments), $name = t1.$index($arguments, 0).assertString$1("name");
                t1 = t1.$index($arguments, 1).get$realNull();
                module = t1 == null ? null : t1.assertString$1("module");
                t1 = this.$this;
                t2 = t1._callableNode;
                t2.toString;
                callable = t1._addExceptionSpan$2(t2, new A._EvaluateVisitor__closure1(t1, $name, module));
                if (callable == null) throw A.wrapException("Mixin not found: " + $name.toString$0(0));
                return new A.SassMixin(callable, t1._compileContext);
            },
            $signature: 168
        };
        A._EvaluateVisitor__closure1.prototype = {
            call$0: function() {
                var t1 = this.$this._environment, t2 = A.stringReplaceAllUnchecked(this.name._string$_text, "_", "-"), t3 = this.module;
                return t1.getMixin$2$namespace(t2, t3 == null ? null : t3._string$_text);
            },
            $signature: 113
        };
        A._EvaluateVisitor_closure9.prototype = {
            call$1: function($arguments) {
                var callableNode, t2, t3, t4, t5, t6, t7, invocation, callable, t1 = J.getInterceptor$asx($arguments), $function = t1.$index($arguments, 0), args = type$.SassArgumentList._as(t1.$index($arguments, 1));
                t1 = this.$this;
                callableNode = t1._callableNode;
                t2 = callableNode.get$span(callableNode);
                t3 = callableNode.get$span(callableNode);
                args._wereKeywordsAccessed = true;
                t4 = args._keywords;
                if (t4.get$isEmpty(t4)) t4 = null;
                else {
                    t5 = type$.Value;
                    t6 = A.LinkedHashMap_LinkedHashMap$_empty(t5, t5);
                    for(args._wereKeywordsAccessed = true, t4 = A.MapExtensions_get_pairs(t4, type$.String, t5), t4 = t4.get$iterator(t4); t4.moveNext$0();){
                        t7 = t4.get$current(t4);
                        t6.$indexSet(0, new A.SassString(t7._0, false), t7._1);
                    }
                    t4 = new A.ValueExpression(new A.SassMap(A.ConstantMap_ConstantMap$from(t6, t5, t5)), callableNode.get$span(callableNode));
                }
                invocation = A.ArgumentList$(B.List_empty9, B.Map_empty4, B.Map_empty5, t2, t4, new A.ValueExpression(args, t3));
                if ($function instanceof A.SassString) {
                    A.warnForDeprecation(string$.Passina + $function.toString$0(0) + "))", B.Deprecation_c4i);
                    callableNode = t1._callableNode;
                    t2 = $function._string$_text;
                    t3 = callableNode.get$span(callableNode);
                    return t1.visitFunctionExpression$1(0, new A.FunctionExpression(null, A.stringReplaceAllUnchecked(t2, "_", "-"), t2, invocation, t3));
                }
                callable = $function.assertFunction$1("function").assertCompileContext$1(t1._compileContext).callable;
                if (type$.Callable._is(callable)) {
                    t2 = t1._callableNode;
                    t2.toString;
                    return t1._runFunctionCallable$3(invocation, callable, t2);
                } else throw A.wrapException(A.SassScriptException$("The function " + callable.get$name(callable) + string$.x20is_as, null));
            },
            $signature: 5
        };
        A._EvaluateVisitor_closure10.prototype = {
            call$1: function($arguments) {
                var withMap, t2, t3, values, span, configuration, t1 = J.getInterceptor$asx($arguments), url = A.Uri_parse(t1.$index($arguments, 0).assertString$1("url")._string$_text);
                t1 = t1.$index($arguments, 1).get$realNull();
                withMap = t1 == null ? null : t1.assertMap$1("with")._map$_contents;
                t1 = this.$this;
                t2 = t1._callableNode;
                t2.toString;
                if (withMap != null) {
                    t3 = {};
                    values = A.LinkedHashMap_LinkedHashMap$_empty(type$.String, type$.ConfiguredValue);
                    span = t2.get$span(t2);
                    t3.privateDeprecation = false;
                    withMap.forEach$1(0, new A._EvaluateVisitor__closure(t3, values, span, t2));
                    configuration = new A.ExplicitConfiguration(t2, values, null);
                } else configuration = B.Configuration_Map_empty_null;
                t3 = t2.get$span(t2);
                t1._loadModule$7$baseUrl$configuration$namesInErrors(url, "load-css()", t2, new A._EvaluateVisitor__closure0(t1), t3.get$sourceUrl(t3), configuration, true);
                t1._assertConfigurationIsEmpty$2$nameInError(configuration, true);
            },
            $signature: 191
        };
        A._EvaluateVisitor__closure.prototype = {
            call$2: function(variable, value) {
                var _this = this, t1 = variable.assertString$1("with key"), $name = A.stringReplaceAllUnchecked(t1._string$_text, "_", "-");
                t1 = _this.values;
                if (t1.containsKey$1($name)) throw A.wrapException("The variable $" + $name + " was configured twice.");
                else if (B.JSString_methods.startsWith$1($name, "-") && !_this._box_0.privateDeprecation) {
                    _this._box_0.privateDeprecation = true;
                    A.warnForDeprecation("Configuring private variables (such as $" + $name + string$.x29x20is_dT, B.Deprecation_mXO);
                }
                t1.$indexSet(0, $name, new A.ConfiguredValue(value, _this.span, _this.callableNode));
            },
            $signature: 99
        };
        A._EvaluateVisitor__closure0.prototype = {
            call$2: function(module, _) {
                var t1 = this.$this;
                return t1._combineCss$2$clone(module, true).accept$1(t1);
            },
            $signature: 114
        };
        A._EvaluateVisitor_closure11.prototype = {
            call$1: function($arguments) {
                var callableNode, invocation, callable, $content, t1 = J.getInterceptor$asx($arguments), mixin = t1.$index($arguments, 0), args = type$.SassArgumentList._as(t1.$index($arguments, 1));
                t1 = this.$this;
                callableNode = t1._callableNode;
                invocation = A.ArgumentList$(B.List_empty9, B.Map_empty4, B.Map_empty5, callableNode.get$span(callableNode), null, new A.ValueExpression(args, callableNode.get$span(callableNode)));
                callable = mixin.assertMixin$1("mixin").assertCompileContext$1(t1._compileContext).callable;
                $content = t1._environment._content;
                if (type$.Callable._is(callable)) t1._applyMixin$5(callable, $content, invocation, callableNode, callableNode);
                else throw A.wrapException(A.SassScriptException$("The mixin " + callable.get$name(callable) + string$.x20is_as, null));
            },
            $signature: 191
        };
        A._EvaluateVisitor_run_closure.prototype = {
            call$0: function() {
                var module, _this = this, t1 = _this.node, t2 = t1.span, _0_0 = t2.get$sourceUrl(t2), url = null;
                if (_0_0 != null) {
                    url = _0_0;
                    t2 = _this.$this;
                    t2._activeModules.$indexSet(0, url, null);
                    t2._loadedUrls.add$1(0, url);
                }
                t2 = _this.$this;
                module = t2._addExceptionTrace$1(new A._EvaluateVisitor_run__closure(t2, _this.importer, t1));
                return new A._Record_2_loadedUrls_stylesheet(t2._loadedUrls, t2._combineCss$1(module));
            },
            $signature: 589
        };
        A._EvaluateVisitor_run__closure.prototype = {
            call$0: function() {
                return this.$this._execute$2(this.importer, this.node);
            },
            $signature: 601
        };
        A._EvaluateVisitor_runExpression_closure.prototype = {
            call$0: function() {
                var t1 = this.$this, t2 = this.expression;
                return t1._withFakeStylesheet$3(this.importer, t2, new A._EvaluateVisitor_runExpression__closure(t1, t2));
            },
            $signature: 33
        };
        A._EvaluateVisitor_runExpression__closure.prototype = {
            call$0: function() {
                var t1 = this.$this;
                return t1._addExceptionTrace$1(new A._EvaluateVisitor_runExpression___closure(t1, this.expression));
            },
            $signature: 33
        };
        A._EvaluateVisitor_runExpression___closure.prototype = {
            call$0: function() {
                return this.expression.accept$1(this.$this);
            },
            $signature: 33
        };
        A._EvaluateVisitor_runStatement_closure.prototype = {
            call$0: function() {
                var t1 = this.$this, t2 = this.statement;
                return t1._withFakeStylesheet$3(this.importer, t2, new A._EvaluateVisitor_runStatement__closure(t1, t2));
            },
            $signature: 0
        };
        A._EvaluateVisitor_runStatement__closure.prototype = {
            call$0: function() {
                var t1 = this.$this;
                return t1._addExceptionTrace$1(new A._EvaluateVisitor_runStatement___closure(t1, this.statement));
            },
            $signature: 0
        };
        A._EvaluateVisitor_runStatement___closure.prototype = {
            call$0: function() {
                return this.statement.accept$1(this.$this);
            },
            $signature: 0
        };
        A._EvaluateVisitor__loadModule_closure.prototype = {
            call$0: function() {
                return this.callback.call$2(this._box_0.builtInModule, false);
            },
            $signature: 0
        };
        A._EvaluateVisitor__loadModule_closure0.prototype = {
            call$0: function() {
                var canonicalUrl, oldInDependency, t4, message, _this = this, t1 = {}, stylesheet = null, importer = null, t2 = _this.$this, t3 = _this.nodeWithSpan, _1_0 = t2._loadStylesheet$3$baseUrl(_this.url.toString$0(0), t3.get$span(t3), _this.baseUrl);
                stylesheet = _1_0._0;
                importer = _1_0._1;
                t4 = stylesheet.span;
                canonicalUrl = t4.get$sourceUrl(t4);
                if (canonicalUrl != null) {
                    t4 = t2._activeModules;
                    if (t4.containsKey$1(canonicalUrl)) {
                        message = _this.namesInErrors ? "Module loop: " + $.$get$context().prettyUri$1(canonicalUrl) + " is already being loaded." : string$.Modulel;
                        t1 = A.NullableExtension_andThen(t4.$index(0, canonicalUrl), new A._EvaluateVisitor__loadModule__closure(t2, message));
                        throw A.wrapException(t1 == null ? t2._evaluate$_exception$1(message) : t1);
                    } else t4.$indexSet(0, canonicalUrl, t3);
                }
                t4 = t2._modules.containsKey$1(canonicalUrl);
                oldInDependency = t2._inDependency;
                t2._inDependency = _1_0._2;
                t1.module = null;
                try {
                    t1.module = t2._execute$5$configuration$namesInErrors$nodeWithSpan(importer, stylesheet, _this.configuration, _this.namesInErrors, t3);
                } finally{
                    t2._activeModules.remove$1(0, canonicalUrl);
                    t2._inDependency = oldInDependency;
                }
                t2._addExceptionSpan$3$addStackFrame(t3, new A._EvaluateVisitor__loadModule__closure0(t1, _this.callback, !t4), false);
            },
            $signature: 1
        };
        A._EvaluateVisitor__loadModule__closure.prototype = {
            call$1: function(previousLoad) {
                return this.$this._multiSpanException$3(this.message, "new load", A.LinkedHashMap_LinkedHashMap$_literal([
                    previousLoad.get$span(previousLoad),
                    "original load"
                ], type$.FileSpan, type$.String));
            },
            $signature: 111
        };
        A._EvaluateVisitor__loadModule__closure0.prototype = {
            call$0: function() {
                return this.callback.call$2(this._box_1.module, this.firstLoad);
            },
            $signature: 0
        };
        A._EvaluateVisitor__execute_closure.prototype = {
            call$0: function() {
                var t3, t4, t5, t6, _this = this, t1 = _this.$this, oldImporter = t1._importer, oldStylesheet = t1.__stylesheet, oldRoot = t1.__root, oldPreModuleComments = t1._preModuleComments, oldParent = t1.__parent, oldEndOfImports = t1.__endOfImports, oldOutOfOrderImports = t1._outOfOrderImports, oldExtensionStore = t1.__extensionStore, t2 = t1._atRootExcludingStyleRule, oldStyleRule = t2 ? null : t1._styleRuleIgnoringAtRoot, oldMediaQueries = t1._mediaQueries, oldDeclarationName = t1._declarationName, oldInUnknownAtRule = t1._inUnknownAtRule, oldInKeyframes = t1._inKeyframes, oldConfiguration = t1._configuration;
                t1._importer = _this.importer;
                t3 = t1.__stylesheet = _this.stylesheet;
                t4 = t3.span;
                t5 = t1.__parent = t1.__root = A.ModifiableCssStylesheet$(t4);
                t1.__endOfImports = 0;
                t1._outOfOrderImports = null;
                t1.__extensionStore = _this.extensionStore;
                t1._declarationName = t1._mediaQueries = t1._styleRuleIgnoringAtRoot = null;
                t1._inKeyframes = t1._atRootExcludingStyleRule = t1._inUnknownAtRule = false;
                t6 = _this.configuration;
                if (t6 != null) t1._configuration = t6;
                t1.visitStylesheet$1(0, t3);
                t3 = t1._outOfOrderImports == null ? t5 : new A.CssStylesheet(new A.UnmodifiableListView(t1._addOutOfOrderImports$0(), type$.UnmodifiableListView_CssNode), t4);
                _this.css.__late_helper$_value = t3;
                _this.preModuleComments.__late_helper$_value = t1._preModuleComments;
                t1._importer = oldImporter;
                t1.__stylesheet = oldStylesheet;
                t1.__root = oldRoot;
                t1._preModuleComments = oldPreModuleComments;
                t1.__parent = oldParent;
                t1.__endOfImports = oldEndOfImports;
                t1._outOfOrderImports = oldOutOfOrderImports;
                t1.__extensionStore = oldExtensionStore;
                t1._styleRuleIgnoringAtRoot = oldStyleRule;
                t1._mediaQueries = oldMediaQueries;
                t1._declarationName = oldDeclarationName;
                t1._inUnknownAtRule = oldInUnknownAtRule;
                t1._atRootExcludingStyleRule = t2;
                t1._inKeyframes = oldInKeyframes;
                t1._configuration = oldConfiguration;
            },
            $signature: 1
        };
        A._EvaluateVisitor__combineCss_closure.prototype = {
            call$1: function(module) {
                return module.get$transitivelyContainsCss();
            },
            $signature: 95
        };
        A._EvaluateVisitor__combineCss_closure0.prototype = {
            call$1: function(target) {
                return !this.selectors.contains$1(0, target);
            },
            $signature: 14
        };
        A._EvaluateVisitor__combineCss_visitModule.prototype = {
            call$1: function(module) {
                var t1, t2, t3, t4, _i, upstream, _1_0, statements, index, _this = this;
                if (!_this.seen.add$1(0, module)) return;
                if (_this.clone) module = module.cloneCss$0();
                for(t1 = module.get$upstream(), t2 = t1.length, t3 = _this.css, t4 = _this.imports, _i = 0; _i < t1.length; t1.length === t2 || (0, A.throwConcurrentModificationError)(t1), ++_i){
                    upstream = t1[_i];
                    if (upstream.get$transitivelyContainsCss()) {
                        _1_0 = module.get$preModuleComments().$index(0, upstream);
                        if (_1_0 != null) B.JSArray_methods.addAll$1(t3.length === 0 ? t4 : t3, _1_0);
                        _this.call$1(upstream);
                    }
                }
                _this.sorted.addFirst$1(module);
                t1 = module.get$css(module);
                statements = t1.get$children(t1);
                index = _this.$this._indexAfterImports$1(statements);
                t1 = J.getInterceptor$ax(statements);
                B.JSArray_methods.addAll$1(t4, t1.getRange$2(statements, 0, index));
                B.JSArray_methods.addAll$1(t3, t1.getRange$2(statements, index, t1.get$length(statements)));
            },
            $signature: 604
        };
        A._EvaluateVisitor__extendModules_closure.prototype = {
            call$1: function(target) {
                return !this.originalSelectors.contains$1(0, target);
            },
            $signature: 14
        };
        A._EvaluateVisitor__extendModules_closure0.prototype = {
            call$0: function() {
                return A._setArrayType([], type$.JSArray_ExtensionStore);
            },
            $signature: 170
        };
        A._EvaluateVisitor_visitAtRootRule_closure.prototype = {
            call$0: function() {
                var t1, t2, t3, _i;
                for(t1 = this.node.children, t2 = t1.length, t3 = this.$this, _i = 0; _i < t2; ++_i)t1[_i].accept$1(t3);
            },
            $signature: 1
        };
        A._EvaluateVisitor_visitAtRootRule_closure0.prototype = {
            call$0: function() {
                var t1, t2, t3, _i;
                for(t1 = this.node.children, t2 = t1.length, t3 = this.$this, _i = 0; _i < t2; ++_i)t1[_i].accept$1(t3);
            },
            $signature: 0
        };
        A._EvaluateVisitor__scopeForAtRoot_closure.prototype = {
            call$1: function(callback) {
                var t1 = this.$this, oldParent = t1._assertInModule$2(t1.__parent, "__parent");
                t1.__parent = this.newParent;
                t1._environment.scope$1$2$when(callback, this.node.hasDeclarations, type$.void);
                t1.__parent = oldParent;
            },
            $signature: 35
        };
        A._EvaluateVisitor__scopeForAtRoot_closure0.prototype = {
            call$1: function(callback) {
                var t1 = this.$this, oldAtRootExcludingStyleRule = t1._atRootExcludingStyleRule;
                t1._atRootExcludingStyleRule = true;
                this.innerScope.call$1(callback);
                t1._atRootExcludingStyleRule = oldAtRootExcludingStyleRule;
            },
            $signature: 35
        };
        A._EvaluateVisitor__scopeForAtRoot_closure1.prototype = {
            call$1: function(callback) {
                return this.$this._withMediaQueries$3(null, null, new A._EvaluateVisitor__scopeForAtRoot__closure(this.innerScope, callback));
            },
            $signature: 35
        };
        A._EvaluateVisitor__scopeForAtRoot__closure.prototype = {
            call$0: function() {
                return this.innerScope.call$1(this.callback);
            },
            $signature: 1
        };
        A._EvaluateVisitor__scopeForAtRoot_closure2.prototype = {
            call$1: function(callback) {
                var t1 = this.$this, wasInKeyframes = t1._inKeyframes;
                t1._inKeyframes = false;
                this.innerScope.call$1(callback);
                t1._inKeyframes = wasInKeyframes;
            },
            $signature: 35
        };
        A._EvaluateVisitor__scopeForAtRoot_closure3.prototype = {
            call$1: function($parent) {
                return $parent instanceof A.ModifiableCssAtRule;
            },
            $signature: 172
        };
        A._EvaluateVisitor__scopeForAtRoot_closure4.prototype = {
            call$1: function(callback) {
                var t1 = this.$this, wasInUnknownAtRule = t1._inUnknownAtRule;
                t1._inUnknownAtRule = false;
                this.innerScope.call$1(callback);
                t1._inUnknownAtRule = wasInUnknownAtRule;
            },
            $signature: 35
        };
        A._EvaluateVisitor_visitContentRule_closure.prototype = {
            call$0: function() {
                var t1, t2, t3, _i;
                for(t1 = this.content.declaration.children, t2 = t1.length, t3 = this.$this, _i = 0; _i < t2; ++_i)t1[_i].accept$1(t3);
                return null;
            },
            $signature: 1
        };
        A._EvaluateVisitor_visitDeclaration_closure.prototype = {
            call$0: function() {
                var t1, t2, t3, _i;
                for(t1 = this._box_0.children, t2 = t1.length, t3 = this.$this, _i = 0; _i < t2; ++_i)t1[_i].accept$1(t3);
            },
            $signature: 1
        };
        A._EvaluateVisitor_visitEachRule_closure.prototype = {
            call$1: function(value) {
                var t1 = this.$this, t2 = this.nodeWithSpan;
                return t1._environment.setLocalVariable$3(this._box_0.variable, t1._withoutSlash$2(value, t2), t2);
            },
            $signature: 58
        };
        A._EvaluateVisitor_visitEachRule_closure0.prototype = {
            call$1: function(value) {
                return this.$this._setMultipleVariables$3(this._box_1.variables, value, this.nodeWithSpan);
            },
            $signature: 58
        };
        A._EvaluateVisitor_visitEachRule_closure1.prototype = {
            call$0: function() {
                var _this = this, t1 = _this.$this;
                return t1._handleReturn$2(_this.list.get$asList(), new A._EvaluateVisitor_visitEachRule__closure(t1, _this.setVariables, _this.node));
            },
            $signature: 44
        };
        A._EvaluateVisitor_visitEachRule__closure.prototype = {
            call$1: function(element) {
                var t1;
                this.setVariables.call$1(element);
                t1 = this.$this;
                return t1._handleReturn$2(this.node.children, new A._EvaluateVisitor_visitEachRule___closure(t1));
            },
            $signature: 605
        };
        A._EvaluateVisitor_visitEachRule___closure.prototype = {
            call$1: function(child) {
                return child.accept$1(this.$this);
            },
            $signature: 116
        };
        A._EvaluateVisitor_visitAtRule_closure.prototype = {
            call$1: function(value) {
                return this.$this._interpolationToValue$3$trim$warnForColor(value, true, true);
            },
            $signature: 618
        };
        A._EvaluateVisitor_visitAtRule_closure0.prototype = {
            call$0: function() {
                var t1, t2, t3, _i;
                for(t1 = this.children, t2 = t1.length, t3 = this.$this, _i = 0; _i < t2; ++_i)t1[_i].accept$1(t3);
            },
            $signature: 1
        };
        A._EvaluateVisitor_visitAtRule_closure1.prototype = {
            call$0: function() {
                var t2, t3, _i, _this = this, t1 = _this.$this, styleRule = t1._atRootExcludingStyleRule ? null : t1._styleRuleIgnoringAtRoot;
                if (styleRule == null || t1._inKeyframes || _this.name.value === "font-face") for(t2 = _this.children, t3 = t2.length, _i = 0; _i < t3; ++_i)t2[_i].accept$1(t1);
                else t1._withParent$2$3$scopeWhen(A.ModifiableCssStyleRule$(styleRule._style_rule$_selector, styleRule.span, false, styleRule.originalSelector), new A._EvaluateVisitor_visitAtRule__closure(t1, _this.children), false, type$.ModifiableCssStyleRule, type$.Null);
            },
            $signature: 1
        };
        A._EvaluateVisitor_visitAtRule__closure.prototype = {
            call$0: function() {
                var t1, t2, t3, _i;
                for(t1 = this.children, t2 = t1.length, t3 = this.$this, _i = 0; _i < t2; ++_i)t1[_i].accept$1(t3);
            },
            $signature: 1
        };
        A._EvaluateVisitor_visitAtRule_closure2.prototype = {
            call$1: function(node) {
                return node instanceof A.ModifiableCssStyleRule;
            },
            $signature: 7
        };
        A._EvaluateVisitor_visitForRule_closure.prototype = {
            call$0: function() {
                return this.node.from.accept$1(this.$this).assertNumber$0();
            },
            $signature: 193
        };
        A._EvaluateVisitor_visitForRule_closure0.prototype = {
            call$0: function() {
                return this.node.to.accept$1(this.$this).assertNumber$0();
            },
            $signature: 193
        };
        A._EvaluateVisitor_visitForRule_closure1.prototype = {
            call$0: function() {
                return this.fromNumber.assertInt$0();
            },
            $signature: 10
        };
        A._EvaluateVisitor_visitForRule_closure2.prototype = {
            call$0: function() {
                var t1 = this.fromNumber;
                return this.toNumber.coerce$2(t1.get$numeratorUnits(t1), t1.get$denominatorUnits(t1)).assertInt$0();
            },
            $signature: 10
        };
        A._EvaluateVisitor_visitForRule_closure3.prototype = {
            call$0: function() {
                var i, t3, t4, t5, t6, t7, t8, _0_0, _this = this, t1 = _this.$this, t2 = _this.node, nodeWithSpan = t1._expressionNode$1(t2.from);
                for(i = _this.from, t3 = _this._box_0, t4 = _this.direction, t5 = t2.variable, t6 = _this.fromNumber, t2 = t2.children; i !== t3.to; i += t4){
                    t7 = t1._environment;
                    t8 = t6.get$numeratorUnits(t6);
                    t7.setLocalVariable$3(t5, A.SassNumber_SassNumber$withUnits(i, t6.get$denominatorUnits(t6), t8), nodeWithSpan);
                    _0_0 = t1._handleReturn$2(t2, new A._EvaluateVisitor_visitForRule__closure(t1));
                    if (_0_0 != null) return _0_0;
                }
                return null;
            },
            $signature: 44
        };
        A._EvaluateVisitor_visitForRule__closure.prototype = {
            call$1: function(child) {
                return child.accept$1(this.$this);
            },
            $signature: 116
        };
        A._EvaluateVisitor_visitForwardRule_closure.prototype = {
            call$2: function(module, firstLoad) {
                if (firstLoad) this.$this._registerCommentsForModule$1(module);
                this.$this._environment.forwardModule$2(module, this.node);
            },
            $signature: 114
        };
        A._EvaluateVisitor_visitForwardRule_closure0.prototype = {
            call$2: function(module, firstLoad) {
                if (firstLoad) this.$this._registerCommentsForModule$1(module);
                this.$this._environment.forwardModule$2(module, this.node);
            },
            $signature: 114
        };
        A._EvaluateVisitor__registerCommentsForModule_closure.prototype = {
            call$0: function() {
                return A._setArrayType([], type$.JSArray_CssComment);
            },
            $signature: 177
        };
        A._EvaluateVisitor_visitIfRule_closure.prototype = {
            call$1: function(clause) {
                var t1 = this.$this;
                return t1._environment.scope$1$3$semiGlobal$when(new A._EvaluateVisitor_visitIfRule__closure(t1, clause), true, clause.hasDeclarations, type$.nullable_Value);
            },
            $signature: 626
        };
        A._EvaluateVisitor_visitIfRule__closure.prototype = {
            call$0: function() {
                var t1 = this.$this;
                return t1._handleReturn$2(this.clause.children, new A._EvaluateVisitor_visitIfRule___closure(t1));
            },
            $signature: 44
        };
        A._EvaluateVisitor_visitIfRule___closure.prototype = {
            call$1: function(child) {
                return child.accept$1(this.$this);
            },
            $signature: 116
        };
        A._EvaluateVisitor__visitDynamicImport_closure.prototype = {
            call$0: function() {
                var t1, t2, _0_0, stylesheet, importer, isDependency, t3, url, oldImporter, oldStylesheet, oldInDependency, loadsUserDefinedModules, children, t4, t5, t6, t7, t8, t9, t10, t11, environment, module, visitor, _box_0 = {};
                _box_0.isDependency = _box_0.importer = _box_0.stylesheet = null;
                t1 = this.$this;
                t2 = this.$import;
                _0_0 = t1._loadStylesheet$3$forImport(t2.urlString, t2.span, true);
                stylesheet = _box_0.stylesheet = _0_0._0;
                importer = _0_0._1;
                _box_0.importer = importer;
                isDependency = _0_0._2;
                _box_0.isDependency = isDependency;
                t3 = stylesheet.span;
                url = t3.get$sourceUrl(t3);
                if (url != null) {
                    t3 = t1._activeModules;
                    if (t3.containsKey$1(url)) {
                        t2 = A.NullableExtension_andThen(t3.$index(0, url), new A._EvaluateVisitor__visitDynamicImport__closure(t1));
                        throw A.wrapException(t2 == null ? t1._evaluate$_exception$1("This file is already being loaded.") : t2);
                    }
                    t3.$indexSet(0, url, t2);
                }
                t2 = stylesheet._uses;
                t3 = type$.UnmodifiableListView_UseRule;
                if (new A.UnmodifiableListView(t2, t3).get$length(0) === 0 && new A.UnmodifiableListView(stylesheet._forwards, type$.UnmodifiableListView_ForwardRule).get$length(0) === 0) {
                    oldImporter = t1._importer;
                    oldStylesheet = t1._assertInModule$2(t1.__stylesheet, "_stylesheet");
                    oldInDependency = t1._inDependency;
                    t1._importer = importer;
                    t1.__stylesheet = stylesheet;
                    t1._inDependency = isDependency;
                    t1.visitStylesheet$1(0, stylesheet);
                    t1._importer = oldImporter;
                    t1.__stylesheet = oldStylesheet;
                    t1._inDependency = oldInDependency;
                    t1._activeModules.remove$1(0, url);
                    return;
                }
                t2 = new A.UnmodifiableListView(t2, t3);
                if (!t2.any$1(t2, new A._EvaluateVisitor__visitDynamicImport__closure0())) {
                    t2 = new A.UnmodifiableListView(stylesheet._forwards, type$.UnmodifiableListView_ForwardRule);
                    loadsUserDefinedModules = t2.any$1(t2, new A._EvaluateVisitor__visitDynamicImport__closure1());
                } else loadsUserDefinedModules = true;
                children = A._Cell$();
                t2 = t1._environment;
                t3 = type$.String;
                t4 = type$.Module_Callable;
                t5 = type$.AstNode;
                t6 = t2._nestedForwardedModules;
                t7 = A._setArrayType([], type$.JSArray_Module_Callable);
                t8 = t2._variables;
                t8 = A._setArrayType(t8.slice(0), A._arrayInstanceType(t8));
                t9 = t2._variableNodes;
                t9 = A._setArrayType(t9.slice(0), A._arrayInstanceType(t9));
                t10 = t2._functions;
                t10 = A._setArrayType(t10.slice(0), A._arrayInstanceType(t10));
                t11 = t2._mixins;
                t11 = A._setArrayType(t11.slice(0), A._arrayInstanceType(t11));
                environment = A.Environment$_(A.LinkedHashMap_LinkedHashMap$_empty(t3, t4), A.LinkedHashMap_LinkedHashMap$_empty(t3, t5), A.LinkedHashMap_LinkedHashMap$_empty(t4, t5), t2._importedModules, null, t6, t7, t8, t9, t10, t11, t2._content, t2._configurableVariables);
                t1._withEnvironment$2(environment, new A._EvaluateVisitor__visitDynamicImport__closure2(_box_0, t1, loadsUserDefinedModules, environment, children));
                module = environment.toDummyModule$0();
                t1._environment.importForwards$1(module);
                if (loadsUserDefinedModules) {
                    if (module.transitivelyContainsCss) t1._combineCss$2$clone(module, module.transitivelyContainsExtensions).accept$1(t1);
                    visitor = new A._ImportedCssVisitor(t1);
                    for(t2 = J.get$iterator$ax(children._readLocal$0()); t2.moveNext$0();)t2.get$current(t2).accept$1(visitor);
                }
                t1._activeModules.remove$1(0, url);
            },
            $signature: 0
        };
        A._EvaluateVisitor__visitDynamicImport__closure.prototype = {
            call$1: function(previousLoad) {
                return this.$this._multiSpanException$3("This file is already being loaded.", "new load", A.LinkedHashMap_LinkedHashMap$_literal([
                    previousLoad.get$span(previousLoad),
                    "original load"
                ], type$.FileSpan, type$.String));
            },
            $signature: 111
        };
        A._EvaluateVisitor__visitDynamicImport__closure0.prototype = {
            call$1: function(rule) {
                return rule.url.get$scheme() !== "sass";
            },
            $signature: 178
        };
        A._EvaluateVisitor__visitDynamicImport__closure1.prototype = {
            call$1: function(rule) {
                return rule.url.get$scheme() !== "sass";
            },
            $signature: 179
        };
        A._EvaluateVisitor__visitDynamicImport__closure2.prototype = {
            call$0: function() {
                var t3, t4, _this = this, t1 = _this.$this, oldImporter = t1._importer, oldStylesheet = t1._assertInModule$2(t1.__stylesheet, "_stylesheet"), oldRoot = t1._assertInModule$2(t1.__root, "_root"), oldParent = t1._assertInModule$2(t1.__parent, "__parent"), oldEndOfImports = t1._assertInModule$2(t1.__endOfImports, "_endOfImports"), oldOutOfOrderImports = t1._outOfOrderImports, oldConfiguration = t1._configuration, oldInDependency = t1._inDependency, t2 = _this._box_0;
                t1._importer = t2.importer;
                t3 = t2.stylesheet;
                t1.__stylesheet = t3;
                t4 = _this.loadsUserDefinedModules;
                if (t4) {
                    t3 = A.ModifiableCssStylesheet$(t3.span);
                    t1.__root = t3;
                    t1.__parent = t1._assertInModule$2(t3, "_root");
                    t1.__endOfImports = 0;
                    t1._outOfOrderImports = null;
                }
                t1._inDependency = t2.isDependency;
                t3 = new A.UnmodifiableListView(t2.stylesheet._forwards, type$.UnmodifiableListView_ForwardRule);
                if (!t3.get$isEmpty(t3)) t1._configuration = _this.environment.toImplicitConfiguration$0();
                t1.visitStylesheet$1(0, t2.stylesheet);
                t2 = t4 ? t1._addOutOfOrderImports$0() : A._setArrayType([], type$.JSArray_ModifiableCssNode);
                _this.children.__late_helper$_value = t2;
                t1._importer = oldImporter;
                t1.__stylesheet = oldStylesheet;
                if (t4) {
                    t1.__root = oldRoot;
                    t1.__parent = oldParent;
                    t1.__endOfImports = oldEndOfImports;
                    t1._outOfOrderImports = oldOutOfOrderImports;
                }
                t1._configuration = oldConfiguration;
                t1._inDependency = oldInDependency;
            },
            $signature: 1
        };
        A._EvaluateVisitor__applyMixin_closure.prototype = {
            call$0: function() {
                var _this = this, t1 = _this.$this;
                t1._environment.asMixin$1(new A._EvaluateVisitor__applyMixin__closure0(t1, _this.$arguments, _this.mixin, _this.nodeWithSpanWithoutContent));
            },
            $signature: 0
        };
        A._EvaluateVisitor__applyMixin__closure0.prototype = {
            call$0: function() {
                var _this = this;
                _this.$this._runBuiltInCallable$3(_this.$arguments, _this.mixin, _this.nodeWithSpanWithoutContent);
            },
            $signature: 0
        };
        A._EvaluateVisitor__applyMixin_closure0.prototype = {
            call$0: function() {
                var _this = this, t1 = _this.$this;
                t1._environment.withContent$2(_this.contentCallable, new A._EvaluateVisitor__applyMixin__closure(t1, _this.mixin, _this.nodeWithSpanWithoutContent));
            },
            $signature: 1
        };
        A._EvaluateVisitor__applyMixin__closure.prototype = {
            call$0: function() {
                var t1 = this.$this;
                t1._environment.asMixin$1(new A._EvaluateVisitor__applyMixin___closure(t1, this.mixin, this.nodeWithSpanWithoutContent));
            },
            $signature: 0
        };
        A._EvaluateVisitor__applyMixin___closure.prototype = {
            call$0: function() {
                var t1, t2, t3, t4, _i;
                for(t1 = this.mixin.declaration.children, t2 = t1.length, t3 = this.$this, t4 = this.nodeWithSpanWithoutContent, _i = 0; _i < t2; ++_i)t3._addErrorSpan$2(t4, new A._EvaluateVisitor__applyMixin____closure(t3, t1[_i]));
            },
            $signature: 0
        };
        A._EvaluateVisitor__applyMixin____closure.prototype = {
            call$0: function() {
                return this.statement.accept$1(this.$this);
            },
            $signature: 44
        };
        A._EvaluateVisitor_visitIncludeRule_closure.prototype = {
            call$0: function() {
                var t1 = this.node;
                return this.$this._environment.getMixin$2$namespace(t1.name, t1.namespace);
            },
            $signature: 113
        };
        A._EvaluateVisitor_visitIncludeRule_closure0.prototype = {
            call$1: function($content) {
                var t1 = this.$this;
                return new A.UserDefinedCallable($content, t1._environment.closure$0(), t1._inDependency, type$.UserDefinedCallable_Environment);
            },
            $signature: 633
        };
        A._EvaluateVisitor_visitIncludeRule_closure1.prototype = {
            call$0: function() {
                return this.node.get$spanWithoutContent();
            },
            $signature: 16
        };
        A._EvaluateVisitor_visitMediaRule_closure.prototype = {
            call$0: function() {
                var t1, t2, t3, _i;
                for(t1 = this.node.children, t2 = t1.length, t3 = this.$this, _i = 0; _i < t2; ++_i)t1[_i].accept$1(t3);
            },
            $signature: 1
        };
        A._EvaluateVisitor_visitMediaRule_closure0.prototype = {
            call$1: function(mediaQueries) {
                return this.$this._mergeMediaQueries$2(mediaQueries, this.queries);
            },
            $signature: 89
        };
        A._EvaluateVisitor_visitMediaRule_closure1.prototype = {
            call$0: function() {
                var _this = this, t1 = _this.$this, t2 = _this.mergedQueries;
                if (t2 == null) t2 = _this.queries;
                t1._withMediaQueries$3(t2, _this.mergedSources, new A._EvaluateVisitor_visitMediaRule__closure(t1, _this.node));
            },
            $signature: 1
        };
        A._EvaluateVisitor_visitMediaRule__closure.prototype = {
            call$0: function() {
                var t2, t3, _i, t1 = this.$this, _0_0 = t1._atRootExcludingStyleRule ? null : t1._styleRuleIgnoringAtRoot;
                if (_0_0 != null) t1._withParent$2$3$scopeWhen(A.ModifiableCssStyleRule$(_0_0._style_rule$_selector, _0_0.span, false, _0_0.originalSelector), new A._EvaluateVisitor_visitMediaRule___closure(t1, this.node), false, type$.ModifiableCssStyleRule, type$.Null);
                else for(t2 = this.node.children, t3 = t2.length, _i = 0; _i < t3; ++_i)t2[_i].accept$1(t1);
            },
            $signature: 1
        };
        A._EvaluateVisitor_visitMediaRule___closure.prototype = {
            call$0: function() {
                var t1, t2, t3, _i;
                for(t1 = this.node.children, t2 = t1.length, t3 = this.$this, _i = 0; _i < t2; ++_i)t1[_i].accept$1(t3);
            },
            $signature: 1
        };
        A._EvaluateVisitor_visitMediaRule_closure2.prototype = {
            call$1: function(node) {
                var t1;
                if (!(node instanceof A.ModifiableCssStyleRule)) {
                    t1 = this.mergedSources;
                    t1 = t1.get$isNotEmpty(t1) && node instanceof A.ModifiableCssMediaRule && B.JSArray_methods.every$1(node.queries, t1.get$contains(t1));
                } else t1 = true;
                return t1;
            },
            $signature: 7
        };
        A._EvaluateVisitor_visitStyleRule_closure.prototype = {
            call$0: function() {
                var t1, t2, t3, _i;
                for(t1 = this.node.children, t2 = t1.length, t3 = this.$this, _i = 0; _i < t2; ++_i)t1[_i].accept$1(t3);
            },
            $signature: 1
        };
        A._EvaluateVisitor_visitStyleRule_closure0.prototype = {
            call$1: function(node) {
                return node instanceof A.ModifiableCssStyleRule;
            },
            $signature: 7
        };
        A._EvaluateVisitor_visitStyleRule_closure2.prototype = {
            call$0: function() {
                var t1 = this.$this;
                t1._withStyleRule$2(this.rule, new A._EvaluateVisitor_visitStyleRule__closure(t1, this.node));
            },
            $signature: 1
        };
        A._EvaluateVisitor_visitStyleRule__closure.prototype = {
            call$0: function() {
                var t1, t2, t3, _i;
                for(t1 = this.node.children, t2 = t1.length, t3 = this.$this, _i = 0; _i < t2; ++_i)t1[_i].accept$1(t3);
            },
            $signature: 1
        };
        A._EvaluateVisitor_visitStyleRule_closure1.prototype = {
            call$1: function(node) {
                return node instanceof A.ModifiableCssStyleRule;
            },
            $signature: 7
        };
        A._EvaluateVisitor__warnForBogusCombinators_closure.prototype = {
            call$1: function(child) {
                return child instanceof A.ModifiableCssComment;
            },
            $signature: 7
        };
        A._EvaluateVisitor_visitSupportsRule_closure.prototype = {
            call$0: function() {
                var t1, t2, t3, _i;
                for(t1 = this.node.children, t2 = t1.length, t3 = this.$this, _i = 0; _i < t2; ++_i)t1[_i].accept$1(t3);
            },
            $signature: 1
        };
        A._EvaluateVisitor_visitSupportsRule_closure0.prototype = {
            call$0: function() {
                var t2, t3, _i, t1 = this.$this, _0_0 = t1._atRootExcludingStyleRule ? null : t1._styleRuleIgnoringAtRoot;
                if (_0_0 != null) t1._withParent$2$2(A.ModifiableCssStyleRule$(_0_0._style_rule$_selector, _0_0.span, false, _0_0.originalSelector), new A._EvaluateVisitor_visitSupportsRule__closure(t1, this.node), type$.ModifiableCssStyleRule, type$.Null);
                else for(t2 = this.node.children, t3 = t2.length, _i = 0; _i < t3; ++_i)t2[_i].accept$1(t1);
            },
            $signature: 1
        };
        A._EvaluateVisitor_visitSupportsRule__closure.prototype = {
            call$0: function() {
                var t1, t2, t3, _i;
                for(t1 = this.node.children, t2 = t1.length, t3 = this.$this, _i = 0; _i < t2; ++_i)t1[_i].accept$1(t3);
            },
            $signature: 1
        };
        A._EvaluateVisitor_visitSupportsRule_closure1.prototype = {
            call$1: function(node) {
                return node instanceof A.ModifiableCssStyleRule;
            },
            $signature: 7
        };
        A._EvaluateVisitor__visitSupportsCondition_closure.prototype = {
            call$0: function() {
                var t4, t1 = this.$this, t2 = this._box_0, t3 = t2.declaration.name;
                t3 = t1._evaluate$_serialize$3$quote(t3.accept$1(t1), t3, true);
                t4 = t2.declaration.get$isCustomProperty() ? "" : " ";
                t2 = t2.declaration.value;
                return "(" + t3 + ":" + t4 + t1._evaluate$_serialize$3$quote(t2.accept$1(t1), t2, true) + ")";
            },
            $signature: 29
        };
        A._EvaluateVisitor_visitVariableDeclaration_closure.prototype = {
            call$0: function() {
                var t1 = this.$this._environment, t2 = this._box_0.override;
                t1.setVariable$4$global(this.node.name, t2.value, t2.assignmentNode, true);
            },
            $signature: 1
        };
        A._EvaluateVisitor_visitVariableDeclaration_closure0.prototype = {
            call$0: function() {
                var t1 = this.node;
                return this.$this._environment.getVariable$2$namespace(t1.name, t1.namespace);
            },
            $signature: 44
        };
        A._EvaluateVisitor_visitVariableDeclaration_closure1.prototype = {
            call$0: function() {
                var t1 = this.$this, t2 = this.node;
                t1._environment.setVariable$5$global$namespace(t2.name, this.value, t1._expressionNode$1(t2.expression), t2.isGlobal, t2.namespace);
            },
            $signature: 1
        };
        A._EvaluateVisitor_visitUseRule_closure.prototype = {
            call$2: function(module, firstLoad) {
                var t1, t2, t3, _0_0, t4, t5, span;
                if (firstLoad) this.$this._registerCommentsForModule$1(module);
                t1 = this.$this._environment;
                t2 = this.node;
                t3 = t2.namespace;
                if (t3 == null) {
                    t1._globalModules.$indexSet(0, module, t2);
                    t1._allModules.push(module);
                    t1 = B.JSArray_methods.get$first(t1._variables);
                    _0_0 = A.IterableExtension_firstWhereOrNull(t1.get$keys(t1), module.get$variables().get$containsKey());
                    if (_0_0 != null) A.throwExpression(A.SassScriptException$(string$.This_ma + _0_0 + '".', null));
                } else {
                    t4 = t1._environment$_modules;
                    if (t4.containsKey$1(t3)) {
                        t5 = t1._namespaceNodes.$index(0, t3);
                        span = t5 == null ? null : t5.span;
                        t5 = A.LinkedHashMap_LinkedHashMap$_empty(type$.FileSpan, type$.String);
                        if (span != null) t5.$indexSet(0, span, "original @use");
                        A.throwExpression(A.MultiSpanSassScriptException$(string$.There_ + t3 + '".', "new @use", t5));
                    }
                    t4.$indexSet(0, t3, module);
                    t1._namespaceNodes.$indexSet(0, t3, t2);
                    t1._allModules.push(module);
                }
            },
            $signature: 114
        };
        A._EvaluateVisitor_visitWarnRule_closure.prototype = {
            call$0: function() {
                return this.node.expression.accept$1(this.$this);
            },
            $signature: 33
        };
        A._EvaluateVisitor_visitWhileRule_closure.prototype = {
            call$0: function() {
                var t1, t2, t3, _0_0;
                for(t1 = this.node, t2 = t1.condition, t3 = this.$this, t1 = t1.children; t2.accept$1(t3).get$isTruthy();){
                    _0_0 = t3._handleReturn$2(t1, new A._EvaluateVisitor_visitWhileRule__closure(t3));
                    if (_0_0 != null) return _0_0;
                }
                return null;
            },
            $signature: 44
        };
        A._EvaluateVisitor_visitWhileRule__closure.prototype = {
            call$1: function(child) {
                return child.accept$1(this.$this);
            },
            $signature: 116
        };
        A._EvaluateVisitor_visitBinaryOperationExpression_closure.prototype = {
            call$0: function() {
                var t1 = this.node, t2 = this.$this, left = t1.left.accept$1(t2);
                switch(t1.operator.index){
                    case 0:
                        t1 = t1.right.accept$1(t2);
                        t1 = new A.SassString(A.serializeValue(left, false, true) + "=" + A.serializeValue(t1, false, true), false);
                        break;
                    case 1:
                        t1 = left.get$isTruthy() ? left : t1.right.accept$1(t2);
                        break;
                    case 2:
                        t1 = left.get$isTruthy() ? t1.right.accept$1(t2) : left;
                        break;
                    case 3:
                        t1 = left.$eq(0, t1.right.accept$1(t2)) ? B.SassBoolean_true : B.SassBoolean_false;
                        break;
                    case 4:
                        t1 = !left.$eq(0, t1.right.accept$1(t2)) ? B.SassBoolean_true : B.SassBoolean_false;
                        break;
                    case 5:
                        t1 = left.greaterThan$1(t1.right.accept$1(t2));
                        break;
                    case 6:
                        t1 = left.greaterThanOrEquals$1(t1.right.accept$1(t2));
                        break;
                    case 7:
                        t1 = left.lessThan$1(t1.right.accept$1(t2));
                        break;
                    case 8:
                        t1 = left.lessThanOrEquals$1(t1.right.accept$1(t2));
                        break;
                    case 9:
                        t1 = left.plus$1(t1.right.accept$1(t2));
                        break;
                    case 10:
                        t1 = left.minus$1(t1.right.accept$1(t2));
                        break;
                    case 11:
                        t1 = left.times$1(t1.right.accept$1(t2));
                        break;
                    case 12:
                        t1 = t2._slash$3(left, t1.right.accept$1(t2), t1);
                        break;
                    case 13:
                        t1 = left.modulo$1(t1.right.accept$1(t2));
                        break;
                    default:
                        t1 = null;
                }
                return t1;
            },
            $signature: 33
        };
        A._EvaluateVisitor__slash_recommendation.prototype = {
            call$1: function(expression) {
                var t1;
                $label0$0: {
                    if (expression instanceof A.BinaryOperationExpression && B.BinaryOperator_ehp === expression.operator) {
                        t1 = "math.div(" + A.S(this.call$1(expression.left)) + ", " + A.S(this.call$1(expression.right)) + ")";
                        break $label0$0;
                    }
                    if (expression instanceof A.ParenthesizedExpression) {
                        t1 = expression.expression.toString$0(0);
                        break $label0$0;
                    }
                    t1 = expression.toString$0(0);
                    break $label0$0;
                }
                return t1;
            },
            $signature: 133
        };
        A._EvaluateVisitor_visitVariableExpression_closure.prototype = {
            call$0: function() {
                var t1 = this.node;
                return this.$this._environment.getVariable$2$namespace(t1.name, t1.namespace);
            },
            $signature: 44
        };
        A._EvaluateVisitor_visitUnaryOperationExpression_closure.prototype = {
            call$0: function() {
                var t1, _this = this;
                switch(_this.node.operator.index){
                    case 0:
                        t1 = _this.operand.unaryPlus$0();
                        break;
                    case 1:
                        t1 = _this.operand.unaryMinus$0();
                        break;
                    case 2:
                        t1 = new A.SassString("/" + A.serializeValue(_this.operand, false, true), false);
                        break;
                    case 3:
                        t1 = _this.operand.unaryNot$0();
                        break;
                    default:
                        t1 = null;
                }
                return t1;
            },
            $signature: 33
        };
        A._EvaluateVisitor_visitIfExpression_closure.prototype = {
            call$1: function(pair) {
                return pair._0 + ": " + pair._1.toString$0(0);
            },
            $signature: 183
        };
        A._EvaluateVisitor_visitIfConditionOperation_closure.prototype = {
            call$1: function(pair) {
                return pair._1;
            },
            $signature: 184
        };
        A._EvaluateVisitor_visitListExpression_closure.prototype = {
            call$1: function(expression) {
                return expression.accept$1(this.$this);
            },
            $signature: 653
        };
        A._EvaluateVisitor_visitFunctionExpression_closure.prototype = {
            call$0: function() {
                var t1 = this.node;
                return this.$this._environment.getFunction$2$namespace(t1.name, t1.namespace);
            },
            $signature: 113
        };
        A._EvaluateVisitor_visitFunctionExpression_closure0.prototype = {
            call$1: function(argument) {
                return argument.accept$1(B.C_IsCalculationSafeVisitor);
            },
            $signature: 74
        };
        A._EvaluateVisitor_visitFunctionExpression_closure1.prototype = {
            call$0: function() {
                var t1 = this.node;
                return this.$this._runFunctionCallable$3(t1.$arguments, this._box_0.$function, t1);
            },
            $signature: 33
        };
        A._EvaluateVisitor__visitCalculation_closure.prototype = {
            call$2: function(message, deprecation) {
                return this.$this._warn$3(message, this.node.span, deprecation);
            },
            call$1: function(message) {
                return this.call$2(message, null);
            },
            $signature: 105
        };
        A._EvaluateVisitor__checkCalculationArguments_check.prototype = {
            call$1: function(maxArgs) {
                var t1 = this.node, t2 = t1.$arguments.positional.length;
                if (t2 === 0) throw A.wrapException(this.$this._evaluate$_exception$2("Missing argument.", t1.span));
                else if (maxArgs != null && t2 > maxArgs) throw A.wrapException(this.$this._evaluate$_exception$2("Only " + A.S(maxArgs) + " " + A.pluralize("argument", maxArgs, null) + " allowed, but " + t2 + " " + A.pluralize("was", t2, "were") + " passed.", t1.span));
            },
            call$0: function() {
                return this.call$1(null);
            },
            $signature: 82
        };
        A._EvaluateVisitor__visitCalculationExpression_closure.prototype = {
            call$0: function() {
                var _this = this, t1 = _this.$this, t2 = _this._box_0, t3 = _this.node, t4 = _this.inLegacySassFunction;
                return A.SassCalculation_operateInternal(t1._binaryOperatorToCalculationOperator$2(t2.operator, t3), t1._visitCalculationExpression$2$inLegacySassFunction(t2.left, t4), t1._visitCalculationExpression$2$inLegacySassFunction(t2.right, t4), t4, !t1._inSupportsDeclaration, new A._EvaluateVisitor__visitCalculationExpression__closure(t1, t3));
            },
            $signature: 83
        };
        A._EvaluateVisitor__visitCalculationExpression__closure.prototype = {
            call$2: function(message, deprecation) {
                return this.$this._warn$3(message, this.node.get$span(0), deprecation);
            },
            call$1: function(message) {
                return this.call$2(message, null);
            },
            $signature: 105
        };
        A._EvaluateVisitor_visitInterpolatedFunctionExpression_closure.prototype = {
            call$0: function() {
                var t1 = this.node;
                return this.$this._runFunctionCallable$3(t1.$arguments, this.$function, t1);
            },
            $signature: 33
        };
        A._EvaluateVisitor__runUserDefinedCallable_closure.prototype = {
            call$0: function() {
                var _this = this, t1 = _this.$this, t2 = _this.callable;
                return t1._withEnvironment$2(t2.environment.closure$0(), new A._EvaluateVisitor__runUserDefinedCallable__closure(t1, _this.evaluated, t2, _this.nodeWithSpan, _this.run, _this.V));
            },
            $signature: function() {
                return this.V._eval$1("0()");
            }
        };
        A._EvaluateVisitor__runUserDefinedCallable__closure.prototype = {
            call$0: function() {
                var _this = this, t1 = _this.$this, t2 = _this.V;
                return t1._environment.scope$1$1(new A._EvaluateVisitor__runUserDefinedCallable___closure(t1, _this.evaluated, _this.callable, _this.nodeWithSpan, _this.run, t2), t2);
            },
            $signature: function() {
                return this.V._eval$1("0()");
            }
        };
        A._EvaluateVisitor__runUserDefinedCallable___closure.prototype = {
            call$0: function() {
                var parameters, t5, minLength, i, parameter, t6, value, t7, t8, restParameter, rest, argumentList, result, parameterWord, _this = this, t1 = _this.$this, t2 = _this.evaluated._values, t3 = _this.callable.declaration.parameters, t4 = _this.nodeWithSpan;
                t1._verifyArguments$4(t2[2].length, t2[0], t3, t4);
                parameters = t3.parameters;
                t5 = parameters.length;
                minLength = Math.min(t2[2].length, t5);
                for(i = 0; i < minLength; ++i)t1._environment.setLocalVariable$3(parameters[i].name, t2[2][i], t2[3][i]);
                for(i = t2[2].length; i < t5; ++i){
                    parameter = parameters[i];
                    t6 = parameter.name;
                    value = t2[0].remove$1(0, t6);
                    if (value == null) {
                        t7 = parameter.defaultValue;
                        value = t1._withoutSlash$2(t7.accept$1(t1), t1._expressionNode$1(t7));
                    }
                    t7 = t1._environment;
                    t8 = t2[1].$index(0, t6);
                    if (t8 == null) {
                        t8 = parameter.defaultValue;
                        t8.toString;
                        t8 = t1._expressionNode$1(t8);
                    }
                    t7.setLocalVariable$3(t6, value, t8);
                }
                restParameter = t3.restParameter;
                if (restParameter != null) {
                    t6 = t2[2];
                    rest = t6.length > t5 ? B.JSArray_methods.sublist$1(t6, t5) : B.List_empty8;
                    t5 = t2[0];
                    t6 = t2[4];
                    argumentList = A.SassArgumentList$(rest, t5, t6 === B.ListSeparator_undecided_null_3_undecided ? B.ListSeparator_z0K : t6);
                    t1._environment.setLocalVariable$3(restParameter, argumentList, t4);
                } else argumentList = null;
                result = _this.run.call$0();
                if (argumentList == null) return result;
                t5 = t2[0].__js_helper$_length;
                if (t5 === 0) return result;
                if (argumentList._wereKeywordsAccessed) return result;
                parameterWord = A.pluralize("parameter", t5, null);
                t2 = t2[0];
                t5 = A._instanceType(t2)._eval$1("LinkedHashMapKeysIterable<1>");
                throw A.wrapException(A.MultiSpanSassRuntimeException$("No " + parameterWord + " named " + A.toSentence(A.MappedIterable_MappedIterable(new A.LinkedHashMapKeysIterable(t2, t5), new A._EvaluateVisitor__runUserDefinedCallable____closure(), t5._eval$1("Iterable.E"), type$.Object), "or") + ".", t4.get$span(t4), "invocation", A.LinkedHashMap_LinkedHashMap$_literal([
                    t3.get$spanWithName(),
                    "declaration"
                ], type$.FileSpan, type$.String), t1._evaluate$_stackTrace$1(t4.get$span(t4)), null));
            },
            $signature: function() {
                return this.V._eval$1("0()");
            }
        };
        A._EvaluateVisitor__runUserDefinedCallable____closure.prototype = {
            call$1: function($name) {
                return "$" + $name;
            },
            $signature: 6
        };
        A._EvaluateVisitor__runFunctionCallable_closure.prototype = {
            call$0: function() {
                var t1, t2, t3, t4, _i, $returnValue;
                for(t1 = this.callable.declaration, t2 = t1.children, t3 = t2.length, t4 = this.$this, _i = 0; _i < t3; ++_i){
                    $returnValue = t2[_i].accept$1(t4);
                    if ($returnValue instanceof A.Value) return $returnValue;
                }
                throw A.wrapException(t4._evaluate$_exception$2("Function finished without @return.", t1.span));
            },
            $signature: 33
        };
        A._EvaluateVisitor__runBuiltInCallable_closure.prototype = {
            call$0: function() {
                return this._box_0.overload.verify$2(this.evaluated._values[2].length, this.namedSet);
            },
            $signature: 0
        };
        A._EvaluateVisitor__runBuiltInCallable_closure0.prototype = {
            call$0: function() {
                return this._box_0.callback.call$1(this.evaluated._values[2]);
            },
            $signature: 33
        };
        A._EvaluateVisitor__runBuiltInCallable_closure1.prototype = {
            call$1: function($name) {
                return "$" + $name;
            },
            $signature: 6
        };
        A._EvaluateVisitor__evaluateArguments_closure.prototype = {
            call$1: function(value) {
                return value;
            },
            $signature: 43
        };
        A._EvaluateVisitor__evaluateArguments_closure0.prototype = {
            call$1: function(value) {
                return this.$this._withoutSlash$2(value, this.restNodeForSpan);
            },
            $signature: 43
        };
        A._EvaluateVisitor__evaluateArguments_closure1.prototype = {
            call$2: function(key, value) {
                var _this = this, t1 = _this.restNodeForSpan;
                _this.named.$indexSet(0, key, _this.$this._withoutSlash$2(value, t1));
                _this.namedNodes.$indexSet(0, key, t1);
            },
            $signature: 109
        };
        A._EvaluateVisitor__evaluateArguments_closure2.prototype = {
            call$1: function(value) {
                return value;
            },
            $signature: 43
        };
        A._EvaluateVisitor__evaluateMacroArguments_closure.prototype = {
            call$1: function(value) {
                var t1 = this.restArgs;
                return new A.ValueExpression(value, t1.get$span(t1));
            },
            $signature: 60
        };
        A._EvaluateVisitor__evaluateMacroArguments_closure0.prototype = {
            call$1: function(value) {
                var t1 = this.restArgs;
                return new A.ValueExpression(this.$this._withoutSlash$2(value, this.restNodeForSpan), t1.get$span(t1));
            },
            $signature: 60
        };
        A._EvaluateVisitor__evaluateMacroArguments_closure1.prototype = {
            call$2: function(key, value) {
                var _this = this, t1 = _this.restArgs;
                _this.named.$indexSet(0, key, new A.ValueExpression(_this.$this._withoutSlash$2(value, _this.restNodeForSpan), t1.get$span(t1)));
            },
            $signature: 109
        };
        A._EvaluateVisitor__evaluateMacroArguments_closure2.prototype = {
            call$1: function(value) {
                var t1 = this.keywordRestArgs;
                return new A.ValueExpression(this.$this._withoutSlash$2(value, this.keywordRestNodeForSpan), t1.get$span(t1));
            },
            $signature: 60
        };
        A._EvaluateVisitor__addRestMap_closure.prototype = {
            call$2: function(key, value) {
                var t2, _this = this, t1 = _this.$this;
                if (key instanceof A.SassString) _this.values.$indexSet(0, key._string$_text, _this.convert.call$1(t1._withoutSlash$2(value, _this.expressionNode)));
                else {
                    t2 = _this.nodeWithSpan;
                    throw A.wrapException(t1._evaluate$_exception$2(string$.Variab_ + key.toString$0(0) + " is not a string in " + _this.map.toString$0(0) + ".", t2.get$span(t2)));
                }
            },
            $signature: 99
        };
        A._EvaluateVisitor__verifyArguments_closure.prototype = {
            call$0: function() {
                return this.parameters.verify$2(this.positional, new A.MapKeySet(this.named, type$.MapKeySet_String));
            },
            $signature: 0
        };
        A._EvaluateVisitor_visitCssAtRule_closure.prototype = {
            call$0: function() {
                var t1, t2, t3, t4;
                for(t1 = this.node.children, t2 = t1.$ti, t1 = new A.ListIterator(t1, t1.get$length(0), t2._eval$1("ListIterator<ListBase.E>")), t3 = this.$this, t2 = t2._eval$1("ListBase.E"); t1.moveNext$0();){
                    t4 = t1.__internal$_current;
                    (t4 == null ? t2._as(t4) : t4).accept$1(t3);
                }
            },
            $signature: 1
        };
        A._EvaluateVisitor_visitCssAtRule_closure0.prototype = {
            call$0: function() {
                var t1, t2, t3, t4;
                for(t1 = this.node.children, t2 = t1.$ti, t1 = new A.ListIterator(t1, t1.get$length(0), t2._eval$1("ListIterator<ListBase.E>")), t3 = this.$this, t2 = t2._eval$1("ListBase.E"); t1.moveNext$0();){
                    t4 = t1.__internal$_current;
                    (t4 == null ? t2._as(t4) : t4).accept$1(t3);
                }
            },
            $signature: 1
        };
        A._EvaluateVisitor_visitCssAtRule_closure1.prototype = {
            call$1: function(node) {
                return node instanceof A.ModifiableCssStyleRule;
            },
            $signature: 7
        };
        A._EvaluateVisitor_visitCssKeyframeBlock_closure.prototype = {
            call$0: function() {
                var t1, t2, t3, t4;
                for(t1 = this.node.children, t2 = t1.$ti, t1 = new A.ListIterator(t1, t1.get$length(0), t2._eval$1("ListIterator<ListBase.E>")), t3 = this.$this, t2 = t2._eval$1("ListBase.E"); t1.moveNext$0();){
                    t4 = t1.__internal$_current;
                    (t4 == null ? t2._as(t4) : t4).accept$1(t3);
                }
            },
            $signature: 1
        };
        A._EvaluateVisitor_visitCssKeyframeBlock_closure0.prototype = {
            call$1: function(node) {
                return node instanceof A.ModifiableCssStyleRule;
            },
            $signature: 7
        };
        A._EvaluateVisitor_visitCssMediaRule_closure.prototype = {
            call$0: function() {
                var t1, t2, t3, t4;
                for(t1 = this.node.children, t2 = t1.$ti, t1 = new A.ListIterator(t1, t1.get$length(0), t2._eval$1("ListIterator<ListBase.E>")), t3 = this.$this, t2 = t2._eval$1("ListBase.E"); t1.moveNext$0();){
                    t4 = t1.__internal$_current;
                    (t4 == null ? t2._as(t4) : t4).accept$1(t3);
                }
            },
            $signature: 1
        };
        A._EvaluateVisitor_visitCssMediaRule_closure0.prototype = {
            call$1: function(mediaQueries) {
                return this.$this._mergeMediaQueries$2(mediaQueries, this.node.queries);
            },
            $signature: 89
        };
        A._EvaluateVisitor_visitCssMediaRule_closure1.prototype = {
            call$0: function() {
                var _this = this, t1 = _this.$this, t2 = _this.mergedQueries;
                if (t2 == null) t2 = _this.node.queries;
                t1._withMediaQueries$3(t2, _this.mergedSources, new A._EvaluateVisitor_visitCssMediaRule__closure(t1, _this.node));
            },
            $signature: 1
        };
        A._EvaluateVisitor_visitCssMediaRule__closure.prototype = {
            call$0: function() {
                var t2, t3, t4, t1 = this.$this, _0_0 = t1._atRootExcludingStyleRule ? null : t1._styleRuleIgnoringAtRoot;
                if (_0_0 != null) t1._withParent$2$3$scopeWhen(A.ModifiableCssStyleRule$(_0_0._style_rule$_selector, _0_0.span, false, _0_0.originalSelector), new A._EvaluateVisitor_visitCssMediaRule___closure(t1, this.node), false, type$.ModifiableCssStyleRule, type$.Null);
                else for(t2 = this.node.children, t3 = t2.$ti, t2 = new A.ListIterator(t2, t2.get$length(0), t3._eval$1("ListIterator<ListBase.E>")), t3 = t3._eval$1("ListBase.E"); t2.moveNext$0();){
                    t4 = t2.__internal$_current;
                    (t4 == null ? t3._as(t4) : t4).accept$1(t1);
                }
            },
            $signature: 1
        };
        A._EvaluateVisitor_visitCssMediaRule___closure.prototype = {
            call$0: function() {
                var t1, t2, t3, t4;
                for(t1 = this.node.children, t2 = t1.$ti, t1 = new A.ListIterator(t1, t1.get$length(0), t2._eval$1("ListIterator<ListBase.E>")), t3 = this.$this, t2 = t2._eval$1("ListBase.E"); t1.moveNext$0();){
                    t4 = t1.__internal$_current;
                    (t4 == null ? t2._as(t4) : t4).accept$1(t3);
                }
            },
            $signature: 1
        };
        A._EvaluateVisitor_visitCssMediaRule_closure2.prototype = {
            call$1: function(node) {
                var t1;
                if (!(node instanceof A.ModifiableCssStyleRule)) {
                    t1 = this.mergedSources;
                    t1 = t1.get$isNotEmpty(t1) && node instanceof A.ModifiableCssMediaRule && B.JSArray_methods.every$1(node.queries, t1.get$contains(t1));
                } else t1 = true;
                return t1;
            },
            $signature: 7
        };
        A._EvaluateVisitor_visitCssStyleRule_closure0.prototype = {
            call$0: function() {
                var t1 = this.$this;
                t1._withStyleRule$2(this.rule, new A._EvaluateVisitor_visitCssStyleRule__closure(t1, this.node));
            },
            $signature: 1
        };
        A._EvaluateVisitor_visitCssStyleRule__closure.prototype = {
            call$0: function() {
                var t1, t2, t3, t4;
                for(t1 = this.node.children, t2 = t1.$ti, t1 = new A.ListIterator(t1, t1.get$length(0), t2._eval$1("ListIterator<ListBase.E>")), t3 = this.$this, t2 = t2._eval$1("ListBase.E"); t1.moveNext$0();){
                    t4 = t1.__internal$_current;
                    (t4 == null ? t2._as(t4) : t4).accept$1(t3);
                }
            },
            $signature: 1
        };
        A._EvaluateVisitor_visitCssStyleRule_closure.prototype = {
            call$1: function(node) {
                return node instanceof A.ModifiableCssStyleRule;
            },
            $signature: 7
        };
        A._EvaluateVisitor_visitCssSupportsRule_closure.prototype = {
            call$0: function() {
                var t1, t2, t3, t4;
                for(t1 = this.node.children, t2 = t1.$ti, t1 = new A.ListIterator(t1, t1.get$length(0), t2._eval$1("ListIterator<ListBase.E>")), t3 = this.$this, t2 = t2._eval$1("ListBase.E"); t1.moveNext$0();){
                    t4 = t1.__internal$_current;
                    (t4 == null ? t2._as(t4) : t4).accept$1(t3);
                }
            },
            $signature: 1
        };
        A._EvaluateVisitor_visitCssSupportsRule_closure0.prototype = {
            call$0: function() {
                var t2, t3, t4, t1 = this.$this, _0_0 = t1._atRootExcludingStyleRule ? null : t1._styleRuleIgnoringAtRoot;
                if (_0_0 != null) t1._withParent$2$2(A.ModifiableCssStyleRule$(_0_0._style_rule$_selector, _0_0.span, false, _0_0.originalSelector), new A._EvaluateVisitor_visitCssSupportsRule__closure(t1, this.node), type$.ModifiableCssStyleRule, type$.Null);
                else for(t2 = this.node.children, t3 = t2.$ti, t2 = new A.ListIterator(t2, t2.get$length(0), t3._eval$1("ListIterator<ListBase.E>")), t3 = t3._eval$1("ListBase.E"); t2.moveNext$0();){
                    t4 = t2.__internal$_current;
                    (t4 == null ? t3._as(t4) : t4).accept$1(t1);
                }
            },
            $signature: 1
        };
        A._EvaluateVisitor_visitCssSupportsRule__closure.prototype = {
            call$0: function() {
                var t1, t2, t3, t4;
                for(t1 = this.node.children, t2 = t1.$ti, t1 = new A.ListIterator(t1, t1.get$length(0), t2._eval$1("ListIterator<ListBase.E>")), t3 = this.$this, t2 = t2._eval$1("ListBase.E"); t1.moveNext$0();){
                    t4 = t1.__internal$_current;
                    (t4 == null ? t2._as(t4) : t4).accept$1(t3);
                }
            },
            $signature: 1
        };
        A._EvaluateVisitor_visitCssSupportsRule_closure1.prototype = {
            call$1: function(node) {
                return node instanceof A.ModifiableCssStyleRule;
            },
            $signature: 7
        };
        A._EvaluateVisitor__performInterpolationHelper_closure.prototype = {
            call$1: function(targetOffsets) {
                return A.InterpolationMap$(this.interpolation, targetOffsets);
            },
            $signature: 143
        };
        A._EvaluateVisitor__serialize_closure.prototype = {
            call$0: function() {
                return A.serializeValue(this.value, false, this.quote);
            },
            $signature: 29
        };
        A._EvaluateVisitor__expressionNode_closure.prototype = {
            call$0: function() {
                var t1 = this.expression;
                return this.$this._environment.getVariableNode$2$namespace(t1.name, t1.namespace);
            },
            $signature: 188
        };
        A._EvaluateVisitor__withoutSlash_recommendation.prototype = {
            call$1: function(number) {
                var before, after, t1, _1_0 = number.asSlash;
                $label0$0: {
                    if (type$.Record_2_nullable_Object_and_nullable_Object._is(_1_0)) {
                        before = _1_0._0;
                        after = _1_0._1;
                        t1 = "math.div(" + A.S(this.call$1(before)) + ", " + A.S(this.call$1(after)) + ")";
                        break $label0$0;
                    }
                    t1 = A.serializeValue(number, true, true);
                    break $label0$0;
                }
                return t1;
            },
            $signature: 189
        };
        A._EvaluateVisitor__stackFrame_closure.prototype = {
            call$1: function(url) {
                var t1 = this.$this._evaluate$_importCache;
                t1 = t1 == null ? null : t1.humanize$1(url);
                return t1 == null ? url : t1;
            },
            $signature: 49
        };
        A._ImportedCssVisitor.prototype = {
            visitCssAtRule$1: function(node) {
                var t1 = node.isChildless ? null : new A._ImportedCssVisitor_visitCssAtRule_closure();
                this._visitor._addChild$2$through(node, t1);
            },
            visitCssComment$1: function(node) {
                return this._visitor._addChild$1(node);
            },
            visitCssDeclaration$1: function(node) {
                return this._visitor._addChild$1(node);
            },
            visitCssImport$1: function(node) {
                var t2, _s13_ = "_endOfImports", t1 = this._visitor;
                if (t1._assertInModule$2(t1.__parent, "__parent") !== t1._assertInModule$2(t1.__root, "_root")) t1._addChild$1(node);
                else if (t1._assertInModule$2(t1.__endOfImports, _s13_) === J.get$length$asx(t1._assertInModule$2(t1.__root, "_root").children._collection$_source)) {
                    t1._addChild$1(node);
                    t1.__endOfImports = t1._assertInModule$2(t1.__endOfImports, _s13_) + 1;
                } else {
                    t2 = t1._outOfOrderImports;
                    (t2 == null ? t1._outOfOrderImports = A._setArrayType([], type$.JSArray_ModifiableCssImport) : t2).push(node);
                }
            },
            visitCssKeyframeBlock$1: function(node) {},
            visitCssMediaRule$1: function(node) {
                var t1 = this._visitor, mediaQueries = t1._mediaQueries;
                t1._addChild$2$through(node, new A._ImportedCssVisitor_visitCssMediaRule_closure(mediaQueries == null || t1._mergeMediaQueries$2(mediaQueries, node.queries) != null));
            },
            visitCssStyleRule$1: function(node) {
                return this._visitor._addChild$2$through(node, new A._ImportedCssVisitor_visitCssStyleRule_closure());
            },
            visitCssStylesheet$1: function(node) {
                var t1, t2, t3;
                for(t1 = node.children, t2 = t1.$ti, t1 = new A.ListIterator(t1, t1.get$length(0), t2._eval$1("ListIterator<ListBase.E>")), t2 = t2._eval$1("ListBase.E"); t1.moveNext$0();){
                    t3 = t1.__internal$_current;
                    (t3 == null ? t2._as(t3) : t3).accept$1(this);
                }
            },
            visitCssSupportsRule$1: function(node) {
                return this._visitor._addChild$2$through(node, new A._ImportedCssVisitor_visitCssSupportsRule_closure());
            }
        };
        A._ImportedCssVisitor_visitCssAtRule_closure.prototype = {
            call$1: function(node) {
                return node instanceof A.ModifiableCssStyleRule;
            },
            $signature: 7
        };
        A._ImportedCssVisitor_visitCssMediaRule_closure.prototype = {
            call$1: function(node) {
                var t1;
                if (!(node instanceof A.ModifiableCssStyleRule)) t1 = this.hasBeenMerged && node instanceof A.ModifiableCssMediaRule;
                else t1 = true;
                return t1;
            },
            $signature: 7
        };
        A._ImportedCssVisitor_visitCssStyleRule_closure.prototype = {
            call$1: function(node) {
                return node instanceof A.ModifiableCssStyleRule;
            },
            $signature: 7
        };
        A._ImportedCssVisitor_visitCssSupportsRule_closure.prototype = {
            call$1: function(node) {
                return node instanceof A.ModifiableCssStyleRule;
            },
            $signature: 7
        };
        A._EvaluationContext.prototype = {
            get$currentCallableSpan: function() {
                var _0_0 = this._visitor._callableNode;
                if (_0_0 != null) return _0_0.get$span(_0_0);
                throw A.wrapException(A.StateError$(string$.No_Sasc));
            },
            warn$2: function(_, message, deprecation) {
                var t1 = this._visitor, t2 = t1._importSpan;
                if (t2 == null) {
                    t2 = t1._callableNode;
                    t2 = t2 == null ? null : t2.get$span(t2);
                }
                if (t2 == null) {
                    t2 = this._defaultWarnNodeWithSpan;
                    t2 = t2.get$span(t2);
                }
                t1._warn$3(message, t2, deprecation);
            }
        };
        A.EveryCssVisitor.prototype = {
            visitCssAtRule$1: function(node) {
                var t1 = node.children;
                return t1.every$1(t1, new A.EveryCssVisitor_visitCssAtRule_closure(this));
            },
            visitCssComment$1: function(node) {
                return false;
            },
            visitCssDeclaration$1: function(node) {
                return false;
            },
            visitCssImport$1: function(node) {
                return false;
            },
            visitCssKeyframeBlock$1: function(node) {
                var t1 = node.children;
                return t1.every$1(t1, new A.EveryCssVisitor_visitCssKeyframeBlock_closure(this));
            },
            visitCssMediaRule$1: function(node) {
                var t1 = node.children;
                return t1.every$1(t1, new A.EveryCssVisitor_visitCssMediaRule_closure(this));
            },
            visitCssStyleRule$1: function(node) {
                var t1 = node.children;
                return t1.every$1(t1, new A.EveryCssVisitor_visitCssStyleRule_closure(this));
            },
            visitCssStylesheet$1: function(node) {
                return J.every$1$ax(node.get$children(node), new A.EveryCssVisitor_visitCssStylesheet_closure(this));
            },
            visitCssSupportsRule$1: function(node) {
                var t1 = node.children;
                return t1.every$1(t1, new A.EveryCssVisitor_visitCssSupportsRule_closure(this));
            }
        };
        A.EveryCssVisitor_visitCssAtRule_closure.prototype = {
            call$1: function(child) {
                return child.accept$1(this.$this);
            },
            $signature: 7
        };
        A.EveryCssVisitor_visitCssKeyframeBlock_closure.prototype = {
            call$1: function(child) {
                return child.accept$1(this.$this);
            },
            $signature: 7
        };
        A.EveryCssVisitor_visitCssMediaRule_closure.prototype = {
            call$1: function(child) {
                return child.accept$1(this.$this);
            },
            $signature: 7
        };
        A.EveryCssVisitor_visitCssStyleRule_closure.prototype = {
            call$1: function(child) {
                return child.accept$1(this.$this);
            },
            $signature: 7
        };
        A.EveryCssVisitor_visitCssStylesheet_closure.prototype = {
            call$1: function(child) {
                return child.accept$1(this.$this);
            },
            $signature: 7
        };
        A.EveryCssVisitor_visitCssSupportsRule_closure.prototype = {
            call$1: function(child) {
                return child.accept$1(this.$this);
            },
            $signature: 7
        };
        A._MakeExpressionCalculationSafe.prototype = {
            visitBinaryOperationExpression$1: function(_, node) {
                var t1, t2;
                if (node.operator === B.BinaryOperator_bgA) {
                    t1 = A.ArgumentList$(A._setArrayType([
                        node
                    ], type$.JSArray_Expression), B.Map_empty4, B.Map_empty5, node.get$span(0), null, null);
                    t2 = node.get$span(0);
                    t1 = new A.FunctionExpression("math", A.stringReplaceAllUnchecked("max", "_", "-"), "max", t1, t2);
                } else t1 = this.super$ReplaceExpressionVisitor$visitBinaryOperationExpression(0, node);
                return t1;
            },
            visitInterpolatedFunctionExpression$1: function(_, node) {
                return node;
            },
            visitIfExpression$1: function(_, node) {
                return node;
            },
            visitUnaryOperationExpression$1: function(_, node) {
                var t1, _0_0 = node.operator;
                $label0$0: {
                    if (B.UnaryOperator_n2K === _0_0) {
                        t1 = node.operand;
                        break $label0$0;
                    }
                    if (B.UnaryOperator_hCO === _0_0) {
                        t1 = new A.BinaryOperationExpression(B.BinaryOperator_wkM, new A.NumberExpression(-1, null, node.span), node.operand, false);
                        break $label0$0;
                    }
                    t1 = this.super$ReplaceExpressionVisitor$visitUnaryOperationExpression(0, node);
                    break $label0$0;
                }
                return t1;
            }
        };
        A.__MakeExpressionCalculationSafe_Object_ReplaceExpressionVisitor.prototype = {};
        A._FindDependenciesVisitor.prototype = {
            visitEachRule$1: function(_, node) {},
            visitForRule$1: function(_, node) {},
            visitIfRule$1: function(_, node) {},
            visitWhileRule$1: function(_, node) {},
            visitUseRule$1: function(_, node) {
                var t1 = node.url;
                if (t1.get$scheme() !== "sass") this._find_dependencies$_uses.add$1(0, t1);
                else if (t1.toString$0(0) === "sass:meta") this._metaNamespaces.add$1(0, node.namespace);
            },
            visitForwardRule$1: function(_, node) {
                var t1 = node.url;
                if (t1.get$scheme() !== "sass") this._find_dependencies$_forwards.add$1(0, t1);
            },
            visitImportRule$1: function(_, node) {
                var t1, t2, t3, _i, $import;
                for(t1 = node.imports, t2 = t1.length, t3 = this._imports, _i = 0; _i < t2; ++_i){
                    $import = t1[_i];
                    if ($import instanceof A.DynamicImport) t3.add$1(0, A.Uri_parse($import.urlString));
                }
            },
            visitIncludeRule$1: function(_, node) {
                var url, _0_0, _0_4_isSet, _0_7, t1, _0_4, _0_7_isSet, url0, _$exception;
                if (node.name !== "load-css") return;
                if (!this._metaNamespaces.contains$1(0, node.namespace)) return;
                _0_0 = node.$arguments.positional;
                url = null;
                _0_4_isSet = _0_0.length === 1;
                _0_7 = null;
                t1 = false;
                if (_0_4_isSet) {
                    _0_4 = _0_0[0];
                    _0_7_isSet = _0_4 instanceof A.StringExpression;
                    if (_0_7_isSet) {
                        type$.StringExpression._as(_0_4);
                        _0_7 = _0_4.text.get$asPlain();
                        t1 = _0_7;
                        t1 = t1 != null;
                    }
                } else {
                    _0_4 = null;
                    _0_7_isSet = false;
                }
                if (t1) {
                    if (_0_7_isSet) url0 = _0_7;
                    else {
                        t1 = _0_4_isSet ? _0_4 : _0_0[0];
                        _0_7 = type$.StringExpression._as(t1).text.get$asPlain();
                        url0 = _0_7;
                    }
                    url = url0 == null ? A._asString(url0) : url0;
                    try {
                        this._metaLoadCss.add$1(0, A.Uri_parse(url));
                    } catch (exception) {
                        if (!type$.FormatException._is(A.unwrapException(exception))) throw exception;
                    }
                }
            }
        };
        A.__FindDependenciesVisitor_Object_RecursiveStatementVisitor.prototype = {};
        A.IsCalculationSafeVisitor.prototype = {
            visitBinaryOperationExpression$1: function(_, node) {
                return B.Set_xkEMv.contains$1(0, node.operator) && node.left.accept$1(this) && node.right.accept$1(this);
            },
            visitBooleanExpression$1: function(_, node) {
                return false;
            },
            visitColorExpression$1: function(_, node) {
                return false;
            },
            visitFunctionExpression$1: function(_, node) {
                return true;
            },
            visitIfExpression$1: function(_, node) {
                return true;
            },
            visitInterpolatedFunctionExpression$1: function(_, node) {
                return true;
            },
            visitLegacyIfExpression$1: function(_, node) {
                return true;
            },
            visitListExpression$1: function(_, node) {
                var t1 = false;
                if (node.separator === B.ListSeparator_SrV) {
                    if (!node.hasBrackets) {
                        t1 = node.contents;
                        t1 = t1.length > 1 && B.JSArray_methods.every$1(t1, new A.IsCalculationSafeVisitor_visitListExpression_closure(this));
                    }
                }
                return t1;
            },
            visitMapExpression$1: function(_, node) {
                return false;
            },
            visitNullExpression$1: function(_, node) {
                return false;
            },
            visitNumberExpression$1: function(_, node) {
                return true;
            },
            visitParenthesizedExpression$1: function(_, node) {
                return node.expression.accept$1(this);
            },
            visitSelectorExpression$1: function(_, node) {
                return false;
            },
            visitStringExpression$1: function(_, node) {
                var text, t1, t2;
                if (node.hasQuotes) return false;
                text = node.text.get$initialPlain();
                t1 = false;
                if (!B.JSString_methods.startsWith$1(text, "!")) {
                    if (!B.JSString_methods.startsWith$1(text, "#")) {
                        t2 = text.length;
                        if ((1 >= t2 ? null : text.charCodeAt(1)) !== 43) t1 = (3 >= t2 ? null : text.charCodeAt(3)) !== 40;
                    }
                }
                return t1;
            },
            visitSupportsExpression$1: function(_, node) {
                return false;
            },
            visitUnaryOperationExpression$1: function(_, node) {
                return false;
            },
            visitValueExpression$1: function(_, node) {
                return false;
            },
            visitVariableExpression$1: function(_, node) {
                return true;
            }
        };
        A.IsCalculationSafeVisitor_visitListExpression_closure.prototype = {
            call$1: function(expression) {
                return expression.accept$1(this.$this);
            },
            $signature: 74
        };
        A.IsPlainCssVisitor.prototype = {
            visitBinaryOperationExpression$1: function(_, node) {
                return false;
            },
            visitBooleanExpression$1: function(_, node) {
                return false;
            },
            visitColorExpression$1: function(_, node) {
                return true;
            },
            visitFunctionExpression$1: function(_, node) {
                return node.namespace == null && this._visitArgumentList$1(node.$arguments);
            },
            visitIfExpression$1: function(_, node) {
                return B.JSArray_methods.every$1(node.branches, new A.IsPlainCssVisitor_visitIfExpression_closure(this));
            },
            visitInterpolatedFunctionExpression$1: function(_, node) {
                var t1 = this._visitArgumentList$1(node.$arguments);
                return t1;
            },
            visitLegacyIfExpression$1: function(_, node) {
                return false;
            },
            visitListExpression$1: function(_, node) {
                var t1 = node.contents;
                return (t1.length !== 0 || node.hasBrackets) && B.JSArray_methods.every$1(t1, new A.IsPlainCssVisitor_visitListExpression_closure(this));
            },
            visitMapExpression$1: function(_, node) {
                return false;
            },
            visitNullExpression$1: function(_, node) {
                return false;
            },
            visitNumberExpression$1: function(_, node) {
                return true;
            },
            visitParenthesizedExpression$1: function(_, node) {
                return node.expression.accept$1(this);
            },
            visitSelectorExpression$1: function(_, node) {
                return false;
            },
            visitStringExpression$1: function(_, node) {
                return true;
            },
            visitSupportsExpression$1: function(_, node) {
                return false;
            },
            visitUnaryOperationExpression$1: function(_, node) {
                return false;
            },
            visitValueExpression$1: function(_, node) {
                return false;
            },
            visitVariableExpression$1: function(_, node) {
                return false;
            },
            visitIfConditionParenthesized$1: function(_, node) {
                return node.expression.accept$1(this);
            },
            visitIfConditionNegation$1: function(_, node) {
                return node.expression.accept$1(this);
            },
            visitIfConditionOperation$1: function(_, node) {
                return B.JSArray_methods.every$1(node.expressions, new A.IsPlainCssVisitor_visitIfConditionOperation_closure(this));
            },
            visitIfConditionFunction$1: function(_, node) {
                return true;
            },
            visitIfConditionSass$1: function(_, node) {
                return false;
            },
            visitIfConditionRaw$1: function(_, node) {
                return true;
            },
            _visitArgumentList$1: function(node) {
                var t1 = node.named;
                return t1.get$isEmpty(t1) && node.rest == null && B.JSArray_methods.every$1(node.positional, new A.IsPlainCssVisitor__visitArgumentList_closure(this));
            }
        };
        A.IsPlainCssVisitor_visitIfExpression_closure.prototype = {
            call$1: function(pair) {
                var _0_1, condition, t1;
                $label0$0: {
                    _0_1 = pair._0;
                    if (_0_1 != null) {
                        condition = _0_1 == null ? type$.IfConditionExpression._as(_0_1) : _0_1;
                        t1 = this.$this;
                        t1 = condition.accept$1(t1) && pair._1.accept$1(t1);
                        break $label0$0;
                    }
                    t1 = pair._1.accept$1(this.$this);
                    break $label0$0;
                }
                return t1;
            },
            $signature: 669
        };
        A.IsPlainCssVisitor_visitListExpression_closure.prototype = {
            call$1: function(element) {
                return element.accept$1(this.$this);
            },
            $signature: 74
        };
        A.IsPlainCssVisitor_visitIfConditionOperation_closure.prototype = {
            call$1: function(expression) {
                return expression.accept$1(this.$this);
            },
            $signature: 672
        };
        A.IsPlainCssVisitor__visitArgumentList_closure.prototype = {
            call$1: function(argument) {
                return argument.accept$1(this.$this);
            },
            $signature: 74
        };
        A.RecursiveStatementVisitor.prototype = {
            visitAtRootRule$1: function(_, node) {
                this.visitChildren$1(node.children);
            },
            visitAtRule$1: function(_, node) {
                return A.NullableExtension_andThen(node.children, this.get$visitChildren());
            },
            visitContentBlock$1: function(_, node) {
                return null;
            },
            visitContentRule$1: function(_, node) {},
            visitDebugRule$1: function(_, node) {},
            visitDeclaration$1: function(_, node) {
                return A.NullableExtension_andThen(node.children, this.get$visitChildren());
            },
            visitEachRule$1: function(_, node) {
                return this.visitChildren$1(node.children);
            },
            visitErrorRule$1: function(_, node) {},
            visitExtendRule$1: function(_, node) {},
            visitForRule$1: function(_, node) {
                return this.visitChildren$1(node.children);
            },
            visitForwardRule$1: function(_, node) {},
            visitFunctionRule$1: function(_, node) {
                return null;
            },
            visitIfRule$1: function(_, node) {
                var t1, t2, _i, t3, t4, _i0, _0_0;
                for(t1 = node.clauses, t2 = t1.length, _i = 0; _i < t2; ++_i)for(t3 = t1[_i].children, t4 = t3.length, _i0 = 0; _i0 < t4; ++_i0)t3[_i0].accept$1(this);
                _0_0 = node.lastClause;
                if (_0_0 != null) for(t1 = _0_0.children, t2 = t1.length, _i = 0; _i < t2; ++_i)t1[_i].accept$1(this);
            },
            visitImportRule$1: function(_, node) {},
            visitIncludeRule$1: function(_, node) {
                return A.NullableExtension_andThen(node.content, this.get$visitContentBlock(this));
            },
            visitLoudComment$1: function(_, node) {},
            visitMediaRule$1: function(_, node) {
                return this.visitChildren$1(node.children);
            },
            visitMixinRule$1: function(_, node) {
                return null;
            },
            visitReturnRule$1: function(_, node) {},
            visitSilentComment$1: function(_, node) {},
            visitStyleRule$1: function(_, node) {
                return this.visitChildren$1(node.children);
            },
            visitStylesheet$1: function(_, node) {
                return this.visitChildren$1(node.children);
            },
            visitSupportsRule$1: function(_, node) {
                return this.visitChildren$1(node.children);
            },
            visitUseRule$1: function(_, node) {},
            visitVariableDeclaration$1: function(_, node) {},
            visitWarnRule$1: function(_, node) {},
            visitWhileRule$1: function(_, node) {
                return this.visitChildren$1(node.children);
            },
            visitChildren$1: function(children) {
                var t1;
                for(t1 = J.get$iterator$ax(children); t1.moveNext$0();)t1.get$current(t1).accept$1(this);
            }
        };
        A.ReplaceExpressionVisitor.prototype = {
            visitBinaryOperationExpression$1: function(_, node) {
                return new A.BinaryOperationExpression(node.operator, node.left.accept$1(this), node.right.accept$1(this), false);
            },
            visitBooleanExpression$1: function(_, node) {
                return node;
            },
            visitColorExpression$1: function(_, node) {
                return node;
            },
            visitFunctionExpression$1: function(_, node) {
                var t1 = node.originalName, t2 = this.visitArgumentList$1(node.$arguments);
                return new A.FunctionExpression(node.namespace, A.stringReplaceAllUnchecked(t1, "_", "-"), t1, t2, node.span);
            },
            visitInterpolatedFunctionExpression$1: function(_, node) {
                return new A.InterpolatedFunctionExpression(this.visitInterpolation$1(node.name), this.visitArgumentList$1(node.$arguments), node.span);
            },
            visitLegacyIfExpression$1: function(_, node) {
                return new A.LegacyIfExpression(this.visitArgumentList$1(node.$arguments), node.span);
            },
            visitListExpression$1: function(_, node) {
                var t1 = node.contents;
                return new A.ListExpression(A.List_List$unmodifiable(new A.MappedListIterable(t1, new A.ReplaceExpressionVisitor_visitListExpression_closure(this), A._arrayInstanceType(t1)._eval$1("MappedListIterable<1,Expression>")), type$.Expression), node.separator, node.hasBrackets, node.span);
            },
            visitMapExpression$1: function(_, node) {
                var t2, t3, _i, t4, t1 = A._setArrayType([], type$.JSArray_Record_2_Expression_and_Expression);
                for(t2 = node.pairs, t3 = t2.length, _i = 0; _i < t3; ++_i){
                    t4 = t2[_i];
                    t1.push(new A._Record_2(t4._0.accept$1(this), t4._1.accept$1(this)));
                }
                return new A.MapExpression(A.List_List$unmodifiable(t1, type$.Record_2_Expression_and_Expression), node.span);
            },
            visitNullExpression$1: function(_, node) {
                return node;
            },
            visitNumberExpression$1: function(_, node) {
                return node;
            },
            visitParenthesizedExpression$1: function(_, node) {
                return new A.ParenthesizedExpression(node.expression.accept$1(this), node.span);
            },
            visitSelectorExpression$1: function(_, node) {
                return node;
            },
            visitStringExpression$1: function(_, node) {
                return new A.StringExpression(this.visitInterpolation$1(node.text), node.hasQuotes);
            },
            visitSupportsExpression$1: function(_, node) {
                return new A.SupportsExpression(this.visitSupportsCondition$1(node.condition));
            },
            visitUnaryOperationExpression$1: function(_, node) {
                return new A.UnaryOperationExpression(node.operator, node.operand.accept$1(this), node.span);
            },
            visitValueExpression$1: function(_, node) {
                return node;
            },
            visitVariableExpression$1: function(_, node) {
                return node;
            },
            visitIfConditionParenthesized$1: function(_, node) {
                return new A.IfConditionParenthesized(node.expression.accept$1(this), node.span);
            },
            visitIfConditionNegation$1: function(_, node) {
                return new A.IfConditionNegation(node.expression.accept$1(this), node.span);
            },
            visitIfConditionOperation$1: function(_, node) {
                var t1 = node.expressions;
                return A.IfConditionOperation$(new A.MappedListIterable(t1, new A.ReplaceExpressionVisitor_visitIfConditionOperation_closure(this), A._arrayInstanceType(t1)._eval$1("MappedListIterable<1,IfConditionExpression>")), node.op);
            },
            visitIfConditionFunction$1: function(_, node) {
                return new A.IfConditionFunction(this.visitInterpolation$1(node.name), this.visitInterpolation$1(node.$arguments), node.span);
            },
            visitIfConditionSass$1: function(_, node) {
                return new A.IfConditionSass(node.expression.accept$1(this), node.span);
            },
            visitIfConditionRaw$1: function(_, node) {
                return new A.IfConditionRaw(this.visitInterpolation$1(node.text));
            },
            visitArgumentList$1: function(invocation) {
                var _this = this, t1 = invocation.positional, t2 = type$.String, t3 = type$.Expression, t4 = A.LinkedHashMap_LinkedHashMap$_empty(t2, t3);
                for(t2 = A.MapExtensions_get_pairs(invocation.named, t2, t3), t2 = t2.get$iterator(t2); t2.moveNext$0();){
                    t3 = t2.get$current(t2);
                    t4.$indexSet(0, t3._0, t3._1.accept$1(_this));
                }
                t2 = invocation.rest;
                t2 = t2 == null ? null : t2.accept$1(_this);
                t3 = invocation.keywordRest;
                t3 = t3 == null ? null : t3.accept$1(_this);
                return A.ArgumentList$(new A.MappedListIterable(t1, new A.ReplaceExpressionVisitor_visitArgumentList_closure(_this), A._arrayInstanceType(t1)._eval$1("MappedListIterable<1,Expression>")), t4, invocation.namedSpans, invocation.span, t3, t2);
            },
            visitSupportsCondition$1: function(condition) {
                var _this = this;
                if (condition instanceof A.SupportsOperation) return new A.SupportsOperation(_this.visitSupportsCondition$1(condition.left), _this.visitSupportsCondition$1(condition.right), condition.operator, condition.span);
                else if (condition instanceof A.SupportsNegation) return new A.SupportsNegation(_this.visitSupportsCondition$1(condition.condition), condition.span);
                else if (condition instanceof A.SupportsInterpolation) return new A.SupportsInterpolation(condition.expression.accept$1(_this), condition.span);
                else if (condition instanceof A.SupportsDeclaration) return new A.SupportsDeclaration(condition.name.accept$1(_this), condition.value.accept$1(_this), condition.span);
                else throw A.wrapException(A.SassException$("BUG: Unknown SupportsCondition " + condition.toString$0(0) + ".", condition.get$span(condition), null));
            },
            visitInterpolation$1: function(interpolation) {
                var t1 = interpolation.contents;
                return A.Interpolation$(new A.MappedListIterable(t1, new A.ReplaceExpressionVisitor_visitInterpolation_closure(this), A._arrayInstanceType(t1)._eval$1("MappedListIterable<1,Object>")), interpolation.spans, interpolation.span);
            }
        };
        A.ReplaceExpressionVisitor_visitListExpression_closure.prototype = {
            call$1: function(item) {
                return item.accept$1(this.$this);
            },
            $signature: 194
        };
        A.ReplaceExpressionVisitor_visitIfConditionOperation_closure.prototype = {
            call$1: function(expression) {
                return expression.accept$1(this.$this);
            },
            $signature: 279
        };
        A.ReplaceExpressionVisitor_visitArgumentList_closure.prototype = {
            call$1: function(expression) {
                return expression.accept$1(this.$this);
            },
            $signature: 194
        };
        A.ReplaceExpressionVisitor_visitInterpolation_closure.prototype = {
            call$1: function(node) {
                return node instanceof A.Expression ? node.accept$1(this.$this) : node;
            },
            $signature: 75
        };
        A.SelectorSearchVisitor.prototype = {
            visitAttributeSelector$1: function(_, attribute) {
                return null;
            },
            visitClassSelector$1: function(_, klass) {
                return null;
            },
            visitIDSelector$1: function(_, id) {
                return null;
            },
            visitParentSelector$1: function(_, placeholder) {
                return null;
            },
            visitPlaceholderSelector$1: function(_, placeholder) {
                return null;
            },
            visitTypeSelector$1: function(_, type) {
                return null;
            },
            visitUniversalSelector$1: function(_, universal) {
                return null;
            },
            visitComplexSelector$1: function(complex) {
                return A.IterableExtension_search(complex.components, new A.SelectorSearchVisitor_visitComplexSelector_closure(this));
            },
            visitCompoundSelector$1: function(compound) {
                return A.IterableExtension_search(compound.components, new A.SelectorSearchVisitor_visitCompoundSelector_closure(this));
            },
            visitPseudoSelector$1: function(_, pseudo) {
                return A.NullableExtension_andThen(pseudo.selector, this.get$visitSelectorList());
            },
            visitSelectorList$1: function(list) {
                return A.IterableExtension_search(list.components, this.get$visitComplexSelector());
            }
        };
        A.SelectorSearchVisitor_visitComplexSelector_closure.prototype = {
            call$1: function(component) {
                return this.$this.visitCompoundSelector$1(component.selector);
            },
            $signature: function() {
                return A._instanceType(this.$this)._eval$1("SelectorSearchVisitor.T?(ComplexSelectorComponent)");
            }
        };
        A.SelectorSearchVisitor_visitCompoundSelector_closure.prototype = {
            call$1: function(simple) {
                return simple.accept$1(this.$this);
            },
            $signature: function() {
                return A._instanceType(this.$this)._eval$1("SelectorSearchVisitor.T?(SimpleSelector)");
            }
        };
        A.serialize_closure.prototype = {
            call$1: function(codeUnit) {
                return codeUnit > 127;
            },
            $signature: 50
        };
        A._SerializeVisitor.prototype = {
            visitCssStylesheet$1: function(node) {
                var t1, t2, t3, t4, t5, t6, previous, previous0, t7, _this = this;
                for(t1 = J.get$iterator$ax(node.get$children(node)), t2 = !_this._inspect, t3 = _this._style === B.OutputStyle_1, t4 = !t3, t5 = type$.CssParentNode, t6 = _this._serialize$_buffer, previous = null; t1.moveNext$0();){
                    previous0 = t1.get$current(t1);
                    if (t2) t7 = t3 ? previous0.accept$1(B._IsInvisibleVisitor_true_true) : previous0.accept$1(B._IsInvisibleVisitor_true_false);
                    else t7 = false;
                    if (t7) continue;
                    if (previous != null) {
                        if (t5._is(previous) ? previous.get$isChildless() : !(previous instanceof A.ModifiableCssComment)) t6.writeCharCode$1(59);
                        if (_this._isTrailingComment$2(previous0, previous)) {
                            if (t4) t6.writeCharCode$1(32);
                        } else {
                            if (t4) t6.write$1(0, "\n");
                            if (previous.get$isGroupEnd()) {
                                if (t4) t6.write$1(0, "\n");
                            }
                        }
                    }
                    previous0.accept$1(_this);
                    previous = previous0;
                }
                if (previous != null) t1 = (t5._is(previous) ? previous.get$isChildless() : !(previous instanceof A.ModifiableCssComment)) && t4;
                else t1 = false;
                if (t1) t6.writeCharCode$1(59);
            },
            visitCssComment$1: function(node) {
                this._serialize$_buffer.forSpan$2(node.span, new A._SerializeVisitor_visitCssComment_closure(this, node));
            },
            visitCssAtRule$1: function(node) {
                var t1, _this = this;
                _this._writeIndentation$0();
                t1 = _this._serialize$_buffer;
                t1.forSpan$2(node.span, new A._SerializeVisitor_visitCssAtRule_closure(_this, node));
                if (!node.isChildless) {
                    if (_this._style !== B.OutputStyle_1) t1.writeCharCode$1(32);
                    _this._serialize$_visitChildren$1(node);
                }
            },
            visitCssMediaRule$1: function(node) {
                var t1, _this = this;
                _this._writeIndentation$0();
                t1 = _this._serialize$_buffer;
                t1.forSpan$2(node.span, new A._SerializeVisitor_visitCssMediaRule_closure(_this, node));
                if (_this._style !== B.OutputStyle_1) t1.writeCharCode$1(32);
                _this._serialize$_visitChildren$1(node);
            },
            visitCssImport$1: function(node) {
                this._writeIndentation$0();
                this._serialize$_buffer.forSpan$2(node.span, new A._SerializeVisitor_visitCssImport_closure(this, node));
            },
            _writeImportUrl$1: function(url) {
                var urlContents, maybeQuote, _this = this;
                if (_this._style !== B.OutputStyle_1 || url.charCodeAt(0) !== 117) {
                    _this._serialize$_buffer.write$1(0, url);
                    return;
                }
                urlContents = B.JSString_methods.substring$2(url, 4, url.length - 1);
                maybeQuote = urlContents.charCodeAt(0);
                if (maybeQuote === 39 || maybeQuote === 34) _this._serialize$_buffer.write$1(0, urlContents);
                else _this._visitQuotedString$1(urlContents);
            },
            visitCssKeyframeBlock$1: function(node) {
                var t1, _this = this;
                _this._writeIndentation$0();
                t1 = _this._serialize$_buffer;
                t1.forSpan$2(node.selector.span, new A._SerializeVisitor_visitCssKeyframeBlock_closure(_this, node));
                if (_this._style !== B.OutputStyle_1) t1.writeCharCode$1(32);
                _this._serialize$_visitChildren$1(node);
            },
            _visitMediaQuery$1: function(query) {
                var t1, _1_0, _2_0, condition, operator, t2, _this = this, _0_0 = query.modifier;
                if (_0_0 != null) {
                    t1 = _this._serialize$_buffer;
                    t1.write$1(0, _0_0);
                    t1.writeCharCode$1(32);
                }
                _1_0 = query.type;
                if (_1_0 != null) {
                    t1 = _this._serialize$_buffer;
                    t1.write$1(0, _1_0);
                    if (query.conditions.length !== 0) t1.write$1(0, " and ");
                }
                _2_0 = query.conditions;
                if (_2_0.length === 1) t1 = B.JSString_methods.startsWith$1(_2_0[0], "(not ");
                else t1 = false;
                if (t1) {
                    t1 = _this._serialize$_buffer;
                    t1.write$1(0, "not ");
                    condition = B.JSArray_methods.get$first(_2_0);
                    t1.write$1(0, B.JSString_methods.substring$2(condition, 5, condition.length - 1));
                } else {
                    operator = query.conjunction ? "and" : "or";
                    t1 = _this._style === B.OutputStyle_1 ? operator + " " : " " + operator + " ";
                    t2 = _this._serialize$_buffer;
                    _this._writeBetween$3(_2_0, t1, t2.get$write(t2));
                }
            },
            visitCssStyleRule$1: function(node) {
                var t1, _this = this;
                _this._writeIndentation$0();
                t1 = _this._serialize$_buffer;
                t1.forSpan$2(node._style_rule$_selector._box$_inner.value.span, new A._SerializeVisitor_visitCssStyleRule_closure(_this, node));
                if (_this._style !== B.OutputStyle_1) t1.writeCharCode$1(32);
                _this._serialize$_visitChildren$1(node);
            },
            visitCssSupportsRule$1: function(node) {
                var t1, _this = this;
                _this._writeIndentation$0();
                t1 = _this._serialize$_buffer;
                t1.forSpan$2(node.span, new A._SerializeVisitor_visitCssSupportsRule_closure(_this, node));
                if (_this._style !== B.OutputStyle_1) t1.writeCharCode$1(32);
                _this._serialize$_visitChildren$1(node);
            },
            visitCssDeclaration$1: function(node) {
                var error, stackTrace, error0, stackTrace0, t1, _$exception, _this = this;
                _this._writeIndentation$0();
                _this._serialize$_write$1(node.name);
                t1 = _this._serialize$_buffer;
                t1.writeCharCode$1(58);
                if (!node.parsedAsSassScript) t1.forSpan$2(node.value.span, new A._SerializeVisitor_visitCssDeclaration_closure(_this, node));
                else {
                    if (_this._style !== B.OutputStyle_1) t1.writeCharCode$1(32);
                    try {
                        t1.forSpan$2(node.valueSpanForMap, new A._SerializeVisitor_visitCssDeclaration_closure0(_this, node));
                    } catch (exception) {
                        t1 = A.unwrapException(exception);
                        if (t1 instanceof A.MultiSpanSassScriptException) {
                            error = t1;
                            stackTrace = A.getTraceFromException(exception);
                            A.throwWithTrace(A.MultiSpanSassException$(error.message, node.value.span, error.primaryLabel, error.secondarySpans, null), error, stackTrace);
                        } else if (t1 instanceof A.SassScriptException) {
                            error0 = t1;
                            stackTrace0 = A.getTraceFromException(exception);
                            t1 = error0.message;
                            A.throwWithTrace(new A.SassException(B.Set_empty, t1, node.value.span), error0, stackTrace0);
                        } else throw exception;
                    }
                }
            },
            _writeFoldedValue$1: function(node) {
                var t1, t2, next, t3, scanner = A.StringScanner$(type$.SassString._as(node.value.value)._string$_text, null, null);
                for(t1 = scanner.string.length, t2 = this._serialize$_buffer; scanner._string_scanner$_position !== t1;){
                    next = scanner.readChar$0();
                    if (next !== 10) {
                        t2.writeCharCode$1(next);
                        continue;
                    }
                    t2.writeCharCode$1(32);
                    for(;;){
                        t3 = scanner.peekChar$0();
                        if (!(t3 === 32 || t3 === 9 || t3 === 10 || t3 === 13 || t3 === 12)) break;
                        scanner.readChar$0();
                    }
                }
            },
            _writeReindentedValue$1: function(node) {
                var _0_0, t1, _this = this, value = type$.SassString._as(node.value.value)._string$_text;
                $label0$0: {
                    _0_0 = _this._minimumIndentation$1(value);
                    if (_0_0 == null) {
                        _this._serialize$_buffer.write$1(0, value);
                        break $label0$0;
                    }
                    if (-1 === _0_0) {
                        t1 = _this._serialize$_buffer;
                        t1.write$1(0, A.trimAsciiRight(value, true));
                        t1.writeCharCode$1(32);
                        break $label0$0;
                    }
                    t1 = node.name.span;
                    t1 = t1.get$start(t1);
                    _this._writeWithIndent$2(value, Math.min(_0_0, t1.file.getColumn$1(t1.offset)));
                }
            },
            _minimumIndentation$1: function(text) {
                var character, t2, min, next, min0, scanner = A.LineScanner$(text), t1 = scanner.string.length;
                for(;;){
                    if (scanner._string_scanner$_position !== t1) {
                        character = scanner.super$StringScanner$readChar();
                        scanner._adjustLineAndColumn$1(character);
                        t2 = character !== 10;
                    } else t2 = false;
                    if (!t2) break;
                }
                if (scanner._string_scanner$_position === t1) return scanner.peekChar$1(-1) === 10 ? -1 : null;
                for(min = null; scanner._string_scanner$_position !== t1;){
                    while(scanner._string_scanner$_position !== t1){
                        next = scanner.peekChar$0();
                        if (next !== 32 && next !== 9) break;
                        scanner._adjustLineAndColumn$1(scanner.super$StringScanner$readChar());
                    }
                    if (scanner._string_scanner$_position === t1 || scanner.scanChar$1(10)) continue;
                    min0 = scanner._line_scanner$_column;
                    min = min == null ? min0 : Math.min(min, min0);
                    for(;;){
                        if (scanner._string_scanner$_position !== t1) {
                            character = scanner.super$StringScanner$readChar();
                            scanner._adjustLineAndColumn$1(character);
                            t2 = character !== 10;
                        } else t2 = false;
                        if (!t2) break;
                    }
                }
                return min == null ? -1 : min;
            },
            _writeWithIndent$2: function(text, minimumIndentation) {
                var t1, t2, t3, character, lineStart, newlines, end, scanner = A.LineScanner$(text);
                for(t1 = scanner.string, t2 = t1.length, t3 = this._serialize$_buffer; scanner._string_scanner$_position !== t2;){
                    character = scanner.super$StringScanner$readChar();
                    scanner._adjustLineAndColumn$1(character);
                    if (character === 10) break;
                    t3.writeCharCode$1(character);
                }
                for(;;){
                    lineStart = scanner._string_scanner$_position;
                    for(newlines = 1;;){
                        if (scanner._string_scanner$_position === t2) {
                            t3.writeCharCode$1(32);
                            return;
                        }
                        $label0$2: {
                            character = scanner.super$StringScanner$readChar();
                            scanner._adjustLineAndColumn$1(character);
                            if (32 === character || 9 === character) continue;
                            if (10 === character) {
                                lineStart = scanner._string_scanner$_position;
                                ++newlines;
                                break $label0$2;
                            }
                            break;
                        }
                    }
                    this._writeTimes$2(10, newlines);
                    this._writeIndentation$0();
                    end = scanner._string_scanner$_position;
                    t3.write$1(0, B.JSString_methods.substring$2(t1, lineStart + minimumIndentation, end));
                    for(;;){
                        if (scanner._string_scanner$_position === t2) return;
                        character = scanner.super$StringScanner$readChar();
                        scanner._adjustLineAndColumn$1(character);
                        if (character === 10) break;
                        t3.writeCharCode$1(character);
                    }
                }
            },
            visitCalculation$1: function(value) {
                var t2, _this = this, t1 = _this._serialize$_buffer;
                t1.write$1(0, value.name);
                t1.writeCharCode$1(40);
                t2 = _this._style === B.OutputStyle_1 ? "," : ", ";
                _this._writeBetween$3(value.$arguments, t2, _this.get$_writeCalculationValue());
                t1.writeCharCode$1(41);
            },
            _writeCalculationValue$1: function(value) {
                var t1, _0_0, _1_0, first, rest, left, right, operator, parenthesizeLeft, operatorWhitespace, parenthesizeRight, t2, _this = this;
                $label1$1: {
                    t1 = value instanceof A.SassNumber;
                    if (t1 && !isFinite(value._number$_value)) {
                        $label0$0: {
                            _0_0 = value._number$_value;
                            if (1 / 0 === _0_0) {
                                _this._serialize$_buffer.write$1(0, "infinity");
                                break $label0$0;
                            }
                            if (-1 / 0 === _0_0) {
                                _this._serialize$_buffer.write$1(0, "-infinity");
                                break $label0$0;
                            }
                            if (isNaN(_0_0)) _this._serialize$_buffer.write$1(0, "NaN");
                        }
                        _this._writeCalculationUnits$2(value.get$numeratorUnits(value), value.get$denominatorUnits(value));
                        break $label1$1;
                    }
                    if (t1 && value.get$hasComplexUnits()) {
                        _this._writeNumber$1(value._number$_value);
                        _1_0 = value.get$numeratorUnits(value);
                        if (_1_0.length >= 1) {
                            first = _1_0[0];
                            rest = B.JSArray_methods.sublist$1(_1_0, 1);
                            _this._serialize$_buffer.write$1(0, first);
                            _this._writeCalculationUnits$2(rest, value.get$denominatorUnits(value));
                        } else _this._writeCalculationUnits$2(A._setArrayType([], type$.JSArray_String), value.get$denominatorUnits(value));
                        break $label1$1;
                    }
                    if (value instanceof A.Value) {
                        value.accept$1(_this);
                        break $label1$1;
                    }
                    t1 = value instanceof A.CalculationOperation;
                    left = null;
                    right = null;
                    if (t1) {
                        operator = value._operator;
                        left = value._left;
                        right = value._right;
                    } else operator = null;
                    if (t1) {
                        parenthesizeLeft = left instanceof A.CalculationOperation && left._operator.precedence < operator.precedence;
                        if (parenthesizeLeft) _this._serialize$_buffer.writeCharCode$1(40);
                        _this._writeCalculationValue$1(left);
                        if (parenthesizeLeft) _this._serialize$_buffer.writeCharCode$1(41);
                        operatorWhitespace = _this._style !== B.OutputStyle_1 || operator.precedence === 1;
                        if (operatorWhitespace) _this._serialize$_buffer.writeCharCode$1(32);
                        t1 = _this._serialize$_buffer;
                        t1.write$1(0, operator.operator);
                        if (operatorWhitespace) t1.writeCharCode$1(32);
                        if (!(right instanceof A.CalculationOperation && _this._parenthesizeCalculationRhs$2(operator, right._operator))) {
                            parenthesizeRight = false;
                            if (operator === B.CalculationOperator_wFL) {
                                if (right instanceof A.SassNumber) t2 = isFinite(right._number$_value) ? right.get$hasComplexUnits() : right.get$hasUnits();
                                else t2 = parenthesizeRight;
                                parenthesizeRight = t2;
                            }
                        } else parenthesizeRight = true;
                        if (parenthesizeRight) t1.writeCharCode$1(40);
                        _this._writeCalculationValue$1(right);
                        if (parenthesizeRight) t1.writeCharCode$1(41);
                    }
                }
            },
            _writeCalculationUnits$2: function(numeratorUnits, denominatorUnits) {
                var t1, t2, t3, t4;
                for(t1 = J.get$iterator$ax(numeratorUnits), t2 = this._serialize$_buffer, t3 = this._style !== B.OutputStyle_1; t1.moveNext$0();){
                    t4 = t1.get$current(t1);
                    if (t3) t2.writeCharCode$1(32);
                    t2.writeCharCode$1(42);
                    if (t3) t2.writeCharCode$1(32);
                    t2.writeCharCode$1(49);
                    t2.write$1(0, t4);
                }
                for(t1 = J.get$iterator$ax(denominatorUnits); t1.moveNext$0();){
                    t4 = t1.get$current(t1);
                    if (t3) t2.writeCharCode$1(32);
                    t2.writeCharCode$1(47);
                    if (t3) t2.writeCharCode$1(32);
                    t2.writeCharCode$1(49);
                    t2.write$1(0, t4);
                }
            },
            _parenthesizeCalculationRhs$2: function(outer, right) {
                var t1;
                $label0$0: {
                    if (B.CalculationOperator_wFL === outer) {
                        t1 = true;
                        break $label0$0;
                    }
                    if (B.CalculationOperator_dpX === outer) {
                        t1 = false;
                        break $label0$0;
                    }
                    t1 = right === B.CalculationOperator_dpX || right === B.CalculationOperator_KrC;
                    break $label0$0;
                }
                return t1;
            },
            visitColor$1: function(value) {
                var _0_0, _0_2, _0_6, t1, _0_4, _0_6_isSet, t2, _0_10_isSet, _0_10, _0_12_isSet, _0_14, _0_12, _0_14_isSet, t3, _0_10_isSet0, polar, t4, t5, _this = this, _null = null;
                $label0$0: {
                    _0_0 = value._space;
                    _0_2 = B.RgbColorSpace_i0P === _0_0;
                    _0_6 = _null;
                    t1 = true;
                    if (!_0_2) {
                        _0_4 = B.HslColorSpace_JQ2 === _0_0;
                        _0_6_isSet = !_0_4;
                        if (_0_6_isSet) {
                            _0_6 = B.HwbColorSpace_guQ === _0_0;
                            t1 = _0_6;
                        }
                    } else {
                        _0_4 = _null;
                        _0_6_isSet = false;
                    }
                    if (t1 && value.channel0OrNull != null && value.channel1OrNull != null && value.channel2OrNull != null && value.alphaOrNull != null) {
                        _this._writeLegacyColor$1(value);
                        break $label0$0;
                    }
                    if (_0_2) {
                        t1 = _this._serialize$_buffer;
                        t1.write$1(0, "rgb(");
                        _this._writeChannel$1(value.channel0OrNull);
                        t1.writeCharCode$1(32);
                        _this._writeChannel$1(value.channel1OrNull);
                        t1.writeCharCode$1(32);
                        _this._writeChannel$1(value.channel2OrNull);
                        _this._maybeWriteSlashAlpha$1(value);
                        t1.writeCharCode$1(41);
                        break $label0$0;
                    }
                    if (!_0_4) t1 = _0_6_isSet ? _0_6 : B.HwbColorSpace_guQ === _0_0;
                    else t1 = true;
                    if (t1) {
                        t1 = _this._serialize$_buffer;
                        t1.write$1(0, _0_0);
                        t1.writeCharCode$1(40);
                        t2 = _this._style === B.OutputStyle_1 ? _null : "deg";
                        _this._writeChannel$2(value.channel0OrNull, t2);
                        t1.writeCharCode$1(32);
                        _this._writeChannel$2(value.channel1OrNull, "%");
                        t1.writeCharCode$1(32);
                        _this._writeChannel$2(value.channel2OrNull, "%");
                        _this._maybeWriteSlashAlpha$1(value);
                        t1.writeCharCode$1(41);
                        break $label0$0;
                    }
                    _0_10_isSet = B.LabColorSpace_2nT !== _0_0;
                    if (_0_10_isSet) {
                        _0_10 = B.LchColorSpace_Bpv === _0_0;
                        t1 = _0_10;
                    } else {
                        _0_10 = _null;
                        t1 = true;
                    }
                    t2 = false;
                    if (t1) {
                        if (!_this._inspect) {
                            t1 = value.channel0OrNull;
                            if (t1 == null) t1 = 0;
                            if (t1 > 0 || A.fuzzyEquals(t1, 0)) t1 = t1 < 100 || A.fuzzyEquals(t1, 100);
                            else t1 = false;
                            t1 = !t1 && value.channel1OrNull != null && value.channel2OrNull != null;
                        } else t1 = t2;
                    } else t1 = t2;
                    _0_12_isSet = !t1;
                    _0_14 = _null;
                    if (_0_12_isSet) {
                        _0_12 = B.OklabColorSpace_540 === _0_0;
                        t1 = false;
                        _0_14_isSet = !_0_12;
                        if (_0_14_isSet) {
                            _0_14 = B.OklchColorSpace_9Gj === _0_0;
                            t2 = _0_14;
                        } else t2 = true;
                        t3 = false;
                        if (t2) {
                            if (!_this._inspect) {
                                t2 = value.channel0OrNull;
                                if (t2 == null) t2 = 0;
                                if (t2 > 0 || A.fuzzyEquals(t2, 0)) t2 = t2 < 1 || A.fuzzyEquals(t2, 1);
                                else t2 = false;
                                t2 = !t2 && value.channel1OrNull != null && value.channel2OrNull != null;
                            } else t2 = t3;
                        } else t2 = t3;
                        if (!t2) {
                            if (_0_10_isSet) {
                                t2 = _0_10;
                                _0_10_isSet0 = _0_10_isSet;
                            } else {
                                _0_10 = B.LchColorSpace_Bpv === _0_0;
                                t2 = _0_10;
                                _0_10_isSet0 = true;
                            }
                            if (!t2) {
                                if (_0_14_isSet) t2 = _0_14;
                                else {
                                    _0_14 = B.OklchColorSpace_9Gj === _0_0;
                                    t2 = _0_14;
                                    _0_14_isSet = true;
                                }
                            } else t2 = true;
                            if (t2) {
                                if (!_this._inspect) {
                                    t1 = value.channel1OrNull;
                                    t2 = t1 == null;
                                    if (t2) t1 = 0;
                                    t1 = t1 < 0 && !A.fuzzyEquals(t1, 0) && value.channel0OrNull != null && !t2;
                                }
                            }
                        } else {
                            _0_10_isSet0 = _0_10_isSet;
                            t1 = true;
                        }
                    } else {
                        _0_12 = _null;
                        _0_10_isSet0 = _0_10_isSet;
                        _0_14_isSet = false;
                        t1 = true;
                    }
                    if (t1) {
                        t1 = _this._serialize$_buffer;
                        t1.write$1(0, "color-mix(in ");
                        t1.write$1(0, _0_0);
                        t2 = _this._style === B.OutputStyle_1;
                        t1.write$1(0, t2 ? "," : ", ");
                        _this._writeColorFunction$1(value.toSpace$1(B.XyzD65ColorSpace_WiJ));
                        if (!t2) t1.writeCharCode$1(32);
                        t1.write$1(0, "100%");
                        t1.write$1(0, t2 ? "," : ", ");
                        t1.write$1(0, t2 ? "red" : "black");
                        t1.writeCharCode$1(41);
                        break $label0$0;
                    }
                    t1 = true;
                    if (_0_10_isSet) {
                        if (!(_0_12_isSet ? _0_12 : B.OklabColorSpace_540 === _0_0)) {
                            if (!(_0_10_isSet0 ? _0_10 : B.LchColorSpace_Bpv === _0_0)) t1 = _0_14_isSet ? _0_14 : B.OklchColorSpace_9Gj === _0_0;
                        }
                    }
                    if (t1) {
                        t1 = _this._serialize$_buffer;
                        t1.write$1(0, _0_0);
                        t1.writeCharCode$1(40);
                        t2 = _0_0._channels;
                        polar = t2[2].isPolarAngle;
                        t3 = false;
                        if (!_this._inspect) {
                            t4 = value.channel0OrNull;
                            if (t4 == null) t4 = 0;
                            if (t4 > 0 || A.fuzzyEquals(t4, 0)) t4 = t4 < 100 || A.fuzzyEquals(t4, 100);
                            else t4 = false;
                            if (t4) {
                                if (polar) {
                                    t3 = value.channel1OrNull;
                                    if (t3 == null) t3 = 0;
                                    t3 = t3 < 0 && !A.fuzzyEquals(t3, 0);
                                }
                            } else t3 = true;
                        }
                        if (t3) {
                            t1.write$1(0, "from ");
                            t1.write$1(0, _this._style === B.OutputStyle_1 ? "red" : "black");
                            t1.writeCharCode$1(32);
                        }
                        t3 = _this._style !== B.OutputStyle_1;
                        t4 = t3 && value.channel0OrNull != null;
                        t5 = value.channel0OrNull;
                        if (t4) {
                            t2 = type$.LinearChannel._as(t2[0]);
                            _this._writeNumber$1((t5 == null ? 0 : t5) * 100 / t2.max);
                            t1.writeCharCode$1(37);
                        } else _this._writeChannel$1(t5);
                        t1.writeCharCode$1(32);
                        _this._writeChannel$1(value.channel1OrNull);
                        t1.writeCharCode$1(32);
                        t2 = polar && t3 ? "deg" : _null;
                        _this._writeChannel$2(value.channel2OrNull, t2);
                        _this._maybeWriteSlashAlpha$1(value);
                        t1.writeCharCode$1(41);
                        break $label0$0;
                    }
                    _this._writeColorFunction$1(value);
                }
            },
            _writeChannel$2: function(channel, unit) {
                var _this = this;
                if (channel == null) _this._serialize$_buffer.write$1(0, "none");
                else if (isFinite(channel)) {
                    _this._writeNumber$1(channel);
                    if (unit != null) _this._serialize$_buffer.write$1(0, unit);
                } else _this.visitNumber$1(A.SassNumber_SassNumber(channel, unit));
            },
            _writeChannel$1: function(channel) {
                return this._writeChannel$2(channel, null);
            },
            _writeLegacyColor$1: function(color) {
                var rgb, t3, red, green, blue, hsl, hue, saturation, lightness, hwb, _0_0, format, _1_0, _this = this, t1 = color.alphaOrNull, t2 = t1 == null, opaque = A.fuzzyEquals(t2 ? 0 : t1, 1);
                if (!color.get$isInGamut() && !_this._inspect) {
                    _this._writeHsl$1(color);
                    return;
                }
                if (_this._style === B.OutputStyle_1) {
                    rgb = color.toSpace$1(B.RgbColorSpace_i0P);
                    if (opaque && _this._tryIntegerRgb$1(rgb)) return;
                    t3 = rgb.channel0OrNull;
                    red = _this._writeNumberToString$1(t3 == null ? 0 : t3);
                    t3 = rgb.channel1OrNull;
                    green = _this._writeNumberToString$1(t3 == null ? 0 : t3);
                    t3 = rgb.channel2OrNull;
                    blue = _this._writeNumberToString$1(t3 == null ? 0 : t3);
                    hsl = color.toSpace$1(B.HslColorSpace_JQ2);
                    t3 = hsl.channel0OrNull;
                    hue = _this._writeNumberToString$1(t3 == null ? 0 : t3);
                    t3 = hsl.channel1OrNull;
                    saturation = _this._writeNumberToString$1(t3 == null ? 0 : t3);
                    t3 = hsl.channel2OrNull;
                    lightness = _this._writeNumberToString$1(t3 == null ? 0 : t3);
                    t3 = _this._serialize$_buffer;
                    if (red.length + green.length + blue.length <= hue.length + saturation.length + lightness.length + 2) {
                        t3.write$1(0, opaque ? "rgb(" : "rgba(");
                        t3.write$1(0, red);
                        t3.writeCharCode$1(44);
                        t3.write$1(0, green);
                        t3.writeCharCode$1(44);
                        t3.write$1(0, blue);
                    } else {
                        t3.write$1(0, opaque ? "hsl(" : "hsla(");
                        t3.write$1(0, hue);
                        t3.writeCharCode$1(44);
                        t3.write$1(0, saturation);
                        t3.write$1(0, "%,");
                        t3.write$1(0, lightness);
                        t3.writeCharCode$1(37);
                    }
                    if (!opaque) {
                        t3.writeCharCode$1(44);
                        _this._writeNumber$1(t2 ? 0 : t1);
                    }
                    t3.writeCharCode$1(41);
                    return;
                }
                t3 = color._space;
                if (t3 === B.HslColorSpace_JQ2) {
                    _this._writeHsl$1(color);
                    return;
                } else if (_this._inspect && t3 === B.HwbColorSpace_guQ) {
                    t3 = _this._serialize$_buffer;
                    t3.write$1(0, "hwb(");
                    hwb = color.toSpace$1(B.HwbColorSpace_guQ);
                    _this._writeNumber$1(hwb.channel$1(0, "hue"));
                    t3.writeCharCode$1(32);
                    _this._writeNumber$1(hwb.channel$1(0, "whiteness"));
                    t3.writeCharCode$1(37);
                    t3.writeCharCode$1(32);
                    _this._writeNumber$1(hwb.channel$1(0, "blackness"));
                    t3.writeCharCode$1(37);
                    if (!A.fuzzyEquals(t2 ? 0 : t1, 1)) {
                        t3.write$1(0, " / ");
                        _this._writeNumber$1(t2 ? 0 : t1);
                    }
                    t3.writeCharCode$1(41);
                    return;
                }
                _0_0 = color.format;
                if (B.C__ColorFormatEnum === _0_0) {
                    _this._writeRgb$1(color);
                    return;
                }
                t1 = _0_0 instanceof A.SpanColorFormat;
                format = t1 ? _0_0 : null;
                if (t1) {
                    _this._serialize$_buffer.write$1(0, format._color$_span.get$text());
                    return;
                }
                if (opaque) {
                    rgb = color.toSpace$1(B.RgbColorSpace_i0P);
                    _1_0 = $.$get$namesByColor().$index(0, rgb);
                    if (_1_0 != null) {
                        _this._serialize$_buffer.write$1(0, _1_0);
                        return;
                    }
                    if (_this._canUseHex$1(rgb)) {
                        _this._serialize$_buffer.writeCharCode$1(35);
                        t1 = rgb.channel0OrNull;
                        _this._writeHexComponent$1(B.JSNumber_methods.round$0(t1 == null ? 0 : t1));
                        t1 = rgb.channel1OrNull;
                        _this._writeHexComponent$1(B.JSNumber_methods.round$0(t1 == null ? 0 : t1));
                        t1 = rgb.channel2OrNull;
                        _this._writeHexComponent$1(B.JSNumber_methods.round$0(t1 == null ? 0 : t1));
                        return;
                    }
                }
                if (t3 === B.HwbColorSpace_guQ) _this._writeHsl$1(color);
                else _this._writeRgb$1(color);
            },
            _tryIntegerRgb$1: function(rgb) {
                var t1, redInt, greenInt, blueInt, shortHex, _0_0, t2, t3, $name, _this = this;
                if (!_this._canUseHex$1(rgb)) return false;
                t1 = rgb.channel0OrNull;
                redInt = B.JSNumber_methods.round$0(t1 == null ? 0 : t1);
                t1 = rgb.channel1OrNull;
                greenInt = B.JSNumber_methods.round$0(t1 == null ? 0 : t1);
                t1 = rgb.channel2OrNull;
                blueInt = B.JSNumber_methods.round$0(t1 == null ? 0 : t1);
                t1 = redInt & 15;
                shortHex = t1 === B.JSInt_methods._shrOtherPositive$1(redInt, 4) && (greenInt & 15) === B.JSInt_methods._shrOtherPositive$1(greenInt, 4) && (blueInt & 15) === B.JSInt_methods._shrOtherPositive$1(blueInt, 4);
                _0_0 = $.$get$namesByColor().$index(0, rgb);
                t2 = false;
                if (_0_0 != null) {
                    t3 = _0_0.length;
                    t2 = t3 <= (shortHex ? 4 : 7);
                    $name = _0_0;
                } else $name = null;
                if (t2) _this._serialize$_buffer.write$1(0, $name);
                else {
                    t2 = _this._serialize$_buffer;
                    if (shortHex) {
                        t2.writeCharCode$1(35);
                        t2.writeCharCode$1(A.hexCharFor(t1));
                        t2.writeCharCode$1(A.hexCharFor(greenInt & 15));
                        t2.writeCharCode$1(A.hexCharFor(blueInt & 15));
                    } else {
                        t2.writeCharCode$1(35);
                        _this._writeHexComponent$1(redInt);
                        _this._writeHexComponent$1(greenInt);
                        _this._writeHexComponent$1(blueInt);
                    }
                }
                return true;
            },
            _canUseHex$1: function(rgb) {
                var t2, t1 = rgb.channel0OrNull;
                if (t1 == null) t1 = 0;
                if (A.fuzzyIsInt(t1)) t1 = (t1 > 0 || A.fuzzyEquals(t1, 0)) && t1 < 256 && !A.fuzzyEquals(t1, 256);
                else t1 = false;
                t2 = false;
                if (t1) {
                    t1 = rgb.channel1OrNull;
                    if (t1 == null) t1 = 0;
                    if (A.fuzzyIsInt(t1)) t1 = (t1 > 0 || A.fuzzyEquals(t1, 0)) && t1 < 256 && !A.fuzzyEquals(t1, 256);
                    else t1 = false;
                    if (t1) {
                        t1 = rgb.channel2OrNull;
                        if (t1 == null) t1 = 0;
                        if (A.fuzzyIsInt(t1)) t1 = (t1 > 0 || A.fuzzyEquals(t1, 0)) && t1 < 256 && !A.fuzzyEquals(t1, 256);
                        else t1 = t2;
                    } else t1 = t2;
                } else t1 = t2;
                return t1;
            },
            _writeRgb$1: function(color) {
                var t4, _this = this, t1 = color.alphaOrNull, t2 = t1 == null, opaque = A.fuzzyEquals(t2 ? 0 : t1, 1), rgb = color.toSpace$1(B.RgbColorSpace_i0P), t3 = _this._serialize$_buffer;
                t3.write$1(0, opaque ? "rgb(" : "rgba(");
                _this._writeNumber$1(rgb.channel$1(0, "red"));
                t4 = _this._style === B.OutputStyle_1;
                t3.write$1(0, t4 ? "," : ", ");
                _this._writeNumber$1(rgb.channel$1(0, "green"));
                t3.write$1(0, t4 ? "," : ", ");
                _this._writeNumber$1(rgb.channel$1(0, "blue"));
                if (!opaque) {
                    t3.write$1(0, t4 ? "," : ", ");
                    _this._writeNumber$1(t2 ? 0 : t1);
                }
                t3.writeCharCode$1(41);
            },
            _writeHsl$1: function(color) {
                var t4, _this = this, t1 = color.alphaOrNull, t2 = t1 == null, opaque = A.fuzzyEquals(t2 ? 0 : t1, 1), hsl = color.toSpace$1(B.HslColorSpace_JQ2), t3 = _this._serialize$_buffer;
                t3.write$1(0, opaque ? "hsl(" : "hsla(");
                _this._writeChannel$1(hsl.channel$1(0, "hue"));
                t4 = _this._style === B.OutputStyle_1;
                t3.write$1(0, t4 ? "," : ", ");
                _this._writeChannel$2(hsl.channel$1(0, "saturation"), "%");
                t3.write$1(0, t4 ? "," : ", ");
                _this._writeChannel$2(hsl.channel$1(0, "lightness"), "%");
                if (!opaque) {
                    t3.write$1(0, t4 ? "," : ", ");
                    _this._writeNumber$1(t2 ? 0 : t1);
                }
                t3.writeCharCode$1(41);
            },
            _writeColorFunction$1: function(color) {
                var _this = this, t1 = _this._serialize$_buffer;
                t1.write$1(0, "color(");
                t1.write$1(0, color._space);
                t1.writeCharCode$1(32);
                _this._writeBetween$3(color.get$channelsOrNull(), " ", _this.get$_writeChannel());
                _this._maybeWriteSlashAlpha$1(color);
                t1.writeCharCode$1(41);
            },
            _writeHexComponent$1: function(color) {
                var t1 = this._serialize$_buffer;
                t1.writeCharCode$1(A.hexCharFor(B.JSInt_methods._shrOtherPositive$1(color, 4)));
                t1.writeCharCode$1(A.hexCharFor(color & 15));
            },
            _maybeWriteSlashAlpha$1: function(color) {
                var t2, t3, _this = this, t1 = color.alphaOrNull;
                if (A.fuzzyEquals(t1 == null ? 0 : t1, 1)) return;
                t2 = _this._style !== B.OutputStyle_1;
                if (t2) _this._serialize$_buffer.writeCharCode$1(32);
                t3 = _this._serialize$_buffer;
                t3.writeCharCode$1(47);
                if (t2) t3.writeCharCode$1(32);
                _this._writeChannel$1(t1);
            },
            visitList$1: function(value) {
                var t2, singleton, t3, t4, t5, _this = this, t1 = value._hasBrackets;
                if (t1) _this._serialize$_buffer.writeCharCode$1(91);
                else if (value._list$_contents.length === 0) {
                    if (!_this._inspect) throw A.wrapException(A.SassScriptException$("() isn't a valid CSS value.", null));
                    _this._serialize$_buffer.write$1(0, "()");
                    return;
                }
                t2 = _this._inspect;
                singleton = false;
                if (t2) {
                    if (value._list$_contents.length === 1) {
                        t3 = value._separator;
                        t3 = t3 === B.ListSeparator_z0K || t3 === B.ListSeparator_Lul;
                        singleton = t3;
                    }
                }
                if (singleton && !t1) _this._serialize$_buffer.writeCharCode$1(40);
                t3 = value._list$_contents;
                t3 = t2 ? t3 : new A.WhereIterable(t3, new A._SerializeVisitor_visitList_closure(), A._arrayInstanceType(t3)._eval$1("WhereIterable<1>"));
                t4 = value._separator;
                t5 = _this._separatorString$1(t4);
                _this._writeBetween$3(t3, t5, t2 ? new A._SerializeVisitor_visitList_closure0(_this, value) : new A._SerializeVisitor_visitList_closure1(_this));
                if (singleton) {
                    t2 = _this._serialize$_buffer;
                    t2.write$1(0, t4.separator);
                    if (!t1) t2.writeCharCode$1(41);
                }
                if (t1) _this._serialize$_buffer.writeCharCode$1(93);
            },
            _separatorString$1: function(separator) {
                var t1;
                $label0$0: {
                    if (B.ListSeparator_z0K === separator) {
                        t1 = this._style === B.OutputStyle_1 ? "," : ", ";
                        break $label0$0;
                    }
                    if (B.ListSeparator_Lul === separator) {
                        t1 = this._style === B.OutputStyle_1 ? "/" : " / ";
                        break $label0$0;
                    }
                    if (B.ListSeparator_SrV === separator) {
                        t1 = " ";
                        break $label0$0;
                    }
                    t1 = "";
                    break $label0$0;
                }
                return t1;
            },
            _elementNeedsParens$2: function(separator, value) {
                var t1;
                $label1$1: {
                    if (value instanceof A.SassList && value._list$_contents.length > 1 && !value._hasBrackets) {
                        $label0$0: {
                            if (B.ListSeparator_z0K === separator) {
                                t1 = value._separator === B.ListSeparator_z0K;
                                break $label0$0;
                            }
                            if (B.ListSeparator_Lul === separator) {
                                t1 = value._separator;
                                t1 = t1 === B.ListSeparator_z0K || t1 === B.ListSeparator_Lul;
                                break $label0$0;
                            }
                            t1 = value._separator !== B.ListSeparator_undecided_null_3_undecided;
                            break $label0$0;
                        }
                        break $label1$1;
                    }
                    t1 = false;
                    break $label1$1;
                }
                return t1;
            },
            visitMap$1: function(map) {
                var t1, t2, _this = this;
                if (!_this._inspect) throw A.wrapException(A.SassScriptException$(map.toString$0(0) + " isn't a valid CSS value.", null));
                t1 = _this._serialize$_buffer;
                t1.writeCharCode$1(40);
                t2 = map._map$_contents;
                _this._writeBetween$3(t2.get$entries(t2), ", ", new A._SerializeVisitor_visitMap_closure(_this));
                t1.writeCharCode$1(41);
            },
            _writeMapElement$1: function(value) {
                var needsParens = value instanceof A.SassList && value._separator === B.ListSeparator_z0K && !value._hasBrackets;
                if (needsParens) this._serialize$_buffer.writeCharCode$1(40);
                value.accept$1(this);
                if (needsParens) this._serialize$_buffer.writeCharCode$1(41);
            },
            visitNumber$1: function(value) {
                var before, after, t1, _1_0, _this = this, _0_0 = value.asSlash;
                if (type$.Record_2_nullable_Object_and_nullable_Object._is(_0_0)) {
                    before = _0_0._0;
                    after = _0_0._1;
                    _this.visitNumber$1(before);
                    _this._serialize$_buffer.writeCharCode$1(47);
                    _this.visitNumber$1(after);
                    return;
                }
                t1 = value._number$_value;
                if (!isFinite(t1)) {
                    _this.visitCalculation$1(new A.SassCalculation("calc", A.List_List$unmodifiable(A._setArrayType([
                        value
                    ], type$.JSArray_Object), type$.Object)));
                    return;
                }
                if (value.get$hasComplexUnits()) _this.visitCalculation$1(new A.SassCalculation("calc", A.List_List$unmodifiable(A._setArrayType([
                    value
                ], type$.JSArray_Object), type$.Object)));
                else {
                    _this._writeNumber$1(t1);
                    _1_0 = value.get$numeratorUnits(value);
                    if (_1_0.length === 1) _this._serialize$_buffer.write$1(0, _1_0[0]);
                }
            },
            _writeNumberToString$1: function(number) {
                var t1 = new A.StringBuffer("");
                this._writeNumber$2(number, new A.NoSourceMapBuffer(t1));
                t1 = t1._contents;
                return t1.charCodeAt(0) == 0 ? t1 : t1;
            },
            _writeNumber$2: function(number, buffer) {
                var _0_0, t1, integer, text, _this = this;
                if (buffer == null) buffer = _this._serialize$_buffer;
                _0_0 = A.fuzzyAsInt(number);
                t1 = false;
                if (_0_0 != null) {
                    t1 = !_this._inspect || number === _0_0;
                    integer = _0_0;
                } else integer = null;
                if (t1) {
                    buffer.write$1(0, _this._removeExponent$1(J.toString$0$(integer)));
                    return;
                }
                text = _this._removeExponent$1(B.JSNumber_methods.toString$0(number));
                if (_this._inspect) {
                    buffer.write$1(0, text);
                    return;
                }
                if (text.length < 12) {
                    buffer.write$1(0, _this._style === B.OutputStyle_1 && text.charCodeAt(0) === 48 ? B.JSString_methods.substring$1(text, 1) : text);
                    return;
                }
                _this._writeRounded$2(text, buffer);
            },
            _writeNumber$1: function(number) {
                return this._writeNumber$2(number, null);
            },
            _removeExponent$1: function(text) {
                var buffer, t2, t3, additionalZeroes, negative = text.charCodeAt(0) === 45, exponent = A._Cell$(), t1 = text.length, i = 0;
                for(;;){
                    if (!(i < t1)) {
                        buffer = null;
                        break;
                    }
                    c$0: {
                        if (text.charCodeAt(i) !== 101) break c$0;
                        buffer = new A.StringBuffer("");
                        t2 = buffer._contents = A.Primitives_stringFromCharCode(text.charCodeAt(0));
                        if (negative) {
                            t2 += A.Primitives_stringFromCharCode(text.charCodeAt(1));
                            buffer._contents = t2;
                            if (i > 3) buffer._contents = t2 + B.JSString_methods.substring$2(text, 3, i);
                        } else if (i > 2) buffer._contents = t2 + B.JSString_methods.substring$2(text, 2, i);
                        exponent.__late_helper$_value = A.int_parse(B.JSString_methods.substring$2(text, i + 1, t1), null);
                        break;
                    }
                    ++i;
                }
                if (buffer == null) return text;
                if (exponent._readLocal$0() > 0) {
                    t1 = exponent._readLocal$0();
                    t2 = buffer._contents;
                    t3 = negative ? 1 : 0;
                    additionalZeroes = t1 - (t2.length - 1 - t3);
                    for(t1 = t2, i = 0; i < additionalZeroes; ++i){
                        t1 = A.Primitives_stringFromCharCode(48);
                        t1 = buffer._contents += t1;
                    }
                    return t1.charCodeAt(0) == 0 ? t1 : t1;
                } else {
                    negative = text.charCodeAt(0) === 45;
                    t1 = (negative ? A.Primitives_stringFromCharCode(45) : "") + "0.";
                    i = -1;
                    for(;;){
                        t2 = exponent.__late_helper$_value;
                        if (t2 === exponent) A.throwExpression(A.LateError$localNI(""));
                        if (!(i > t2)) break;
                        t1 += A.Primitives_stringFromCharCode(48);
                        --i;
                    }
                    if (negative) {
                        t2 = buffer._contents;
                        t2 = B.JSString_methods.substring$1(t2.charCodeAt(0) == 0 ? t2 : t2, 1);
                    } else t2 = buffer;
                    t2 = t1 + A.S(t2);
                    return t2.charCodeAt(0) == 0 ? t2 : t2;
                }
            },
            _writeRounded$2: function(text, buffer) {
                var t1, digits, negative, textIndex, digitsIndex, textIndex0, codeUnit, digitsIndex0, indexAfterPrecision, digitsIndex1, newDigit, writtenIndex;
                if (B.JSString_methods.endsWith$1(text, ".0")) {
                    buffer.write$1(0, B.JSString_methods.substring$2(text, 0, text.length - 2));
                    return;
                }
                t1 = text.length;
                digits = new Uint8Array(t1 + 1);
                negative = text.charCodeAt(0) === 45;
                textIndex = negative ? 1 : 0;
                for(digitsIndex = 1;; textIndex = textIndex0, digitsIndex = digitsIndex0){
                    if (textIndex === t1) {
                        buffer.write$1(0, text);
                        return;
                    }
                    textIndex0 = textIndex + 1;
                    codeUnit = text.charCodeAt(textIndex);
                    if (codeUnit === 46) {
                        textIndex = textIndex0;
                        break;
                    }
                    digitsIndex0 = digitsIndex + 1;
                    digits[digitsIndex] = codeUnit - 48;
                }
                indexAfterPrecision = textIndex + 10;
                if (indexAfterPrecision >= t1) {
                    buffer.write$1(0, text);
                    return;
                }
                for(digitsIndex0 = digitsIndex; textIndex < indexAfterPrecision; textIndex = textIndex0, digitsIndex0 = digitsIndex1){
                    digitsIndex1 = digitsIndex0 + 1;
                    textIndex0 = textIndex + 1;
                    digits[digitsIndex0] = text.charCodeAt(textIndex) - 48;
                }
                if (text.charCodeAt(textIndex) - 48 >= 5) for(;; digitsIndex0 = digitsIndex1){
                    digitsIndex1 = digitsIndex0 - 1;
                    newDigit = digits[digitsIndex1] + 1;
                    digits[digitsIndex1] = newDigit;
                    if (newDigit !== 10) break;
                }
                for(; digitsIndex0 < digitsIndex; ++digitsIndex0)digits[digitsIndex0] = 0;
                for(;;){
                    t1 = digitsIndex0 > digitsIndex;
                    if (!(t1 && digits[digitsIndex0 - 1] === 0)) break;
                    --digitsIndex0;
                }
                if (digitsIndex0 === 2 && digits[0] === 0 && digits[1] === 0) {
                    buffer.writeCharCode$1(48);
                    return;
                }
                if (negative) buffer.writeCharCode$1(45);
                if (digits[0] === 0) writtenIndex = this._style === B.OutputStyle_1 && digits[1] === 0 ? 2 : 1;
                else writtenIndex = 0;
                for(; writtenIndex < digitsIndex; ++writtenIndex)buffer.writeCharCode$1(48 + digits[writtenIndex]);
                if (t1) {
                    buffer.writeCharCode$1(46);
                    for(; writtenIndex < digitsIndex0; ++writtenIndex)buffer.writeCharCode$1(48 + digits[writtenIndex]);
                }
            },
            _visitQuotedString$2$forceDoubleQuote: function(string, forceDoubleQuote) {
                var t1, includesSingleQuote, includesDoubleQuote, i, char, _1_2, _1_4, _0_0, quote, _this = this, buffer = forceDoubleQuote ? _this._serialize$_buffer : new A.StringBuffer("");
                if (forceDoubleQuote) buffer.writeCharCode$1(34);
                for(t1 = string.length, includesSingleQuote = false, includesDoubleQuote = false, i = 0; i < t1; ++i){
                    char = string.charCodeAt(i);
                    _1_2 = 39 === char;
                    if (_1_2 && forceDoubleQuote) {
                        buffer.writeCharCode$1(39);
                        continue;
                    }
                    if (_1_2 && includesDoubleQuote) {
                        _this._visitQuotedString$2$forceDoubleQuote(string, true);
                        return;
                    }
                    if (_1_2) {
                        buffer.writeCharCode$1(39);
                        includesSingleQuote = true;
                        continue;
                    }
                    _1_4 = 34 === char;
                    if (_1_4 && forceDoubleQuote) {
                        buffer.writeCharCode$1(92);
                        buffer.writeCharCode$1(34);
                        continue;
                    }
                    if (_1_4 && includesSingleQuote) {
                        _this._visitQuotedString$2$forceDoubleQuote(string, true);
                        return;
                    }
                    if (_1_4) {
                        buffer.writeCharCode$1(34);
                        includesDoubleQuote = true;
                        continue;
                    }
                    if (0 === char || 1 === char || 2 === char || 3 === char || 4 === char || 5 === char || 6 === char || 7 === char || 8 === char || 10 === char || 11 === char || 12 === char || 13 === char || 14 === char || 15 === char || 16 === char || 17 === char || 18 === char || 19 === char || 20 === char || 21 === char || 22 === char || 23 === char || 24 === char || 25 === char || 26 === char || 27 === char || 28 === char || 29 === char || 30 === char || 31 === char || 127 === char) {
                        _this._writeEscape$4(buffer, char, string, i);
                        continue;
                    }
                    if (92 === char) {
                        buffer.writeCharCode$1(92);
                        buffer.writeCharCode$1(92);
                        continue;
                    }
                    _0_0 = _this._tryPrivateUseCharacter$4(buffer, char, string, i);
                    if (_0_0 != null) i = _0_0;
                    else buffer.writeCharCode$1(char);
                }
                if (forceDoubleQuote) buffer.writeCharCode$1(34);
                else {
                    quote = includesDoubleQuote ? 39 : 34;
                    t1 = _this._serialize$_buffer;
                    t1.writeCharCode$1(quote);
                    t1.write$1(0, buffer);
                    t1.writeCharCode$1(quote);
                }
            },
            _visitQuotedString$1: function(string) {
                return this._visitQuotedString$2$forceDoubleQuote(string, false);
            },
            _visitUnquotedString$1: function(string) {
                var t1, t2, afterNewline, i, _1_0, _0_0;
                for(t1 = string.length, t2 = this._serialize$_buffer, afterNewline = false, i = 0; i < t1; ++i){
                    _1_0 = string.charCodeAt(i);
                    if (10 === _1_0) {
                        t2.writeCharCode$1(32);
                        afterNewline = true;
                        continue;
                    }
                    if (32 === _1_0) {
                        if (!afterNewline) t2.writeCharCode$1(32);
                        continue;
                    }
                    _0_0 = this._tryPrivateUseCharacter$4(t2, _1_0, string, i);
                    if (_0_0 != null) i = _0_0;
                    else t2.writeCharCode$1(_1_0);
                    afterNewline = false;
                }
            },
            _tryPrivateUseCharacter$4: function(buffer, codeUnit, string, i) {
                var t1;
                if (this._style === B.OutputStyle_1) return null;
                if (codeUnit >= 57344 && codeUnit <= 63743) {
                    this._writeEscape$4(buffer, codeUnit, string, i);
                    return i;
                }
                if (codeUnit >>> 7 === 439 && string.length > i + 1) {
                    t1 = i + 1;
                    this._writeEscape$4(buffer, 65536 + ((codeUnit & 1023) << 10) + (string.charCodeAt(t1) & 1023), string, t1);
                    return t1;
                }
                return null;
            },
            _writeEscape$4: function(buffer, character, string, i) {
                var t1, next;
                buffer.writeCharCode$1(92);
                buffer.write$1(0, B.JSInt_methods.toRadixString$1(character, 16));
                t1 = i + 1;
                if (string.length === t1) return;
                next = string.charCodeAt(t1);
                if (A.CharacterExtension_get_isHex(next) || 32 === next || 9 === next) buffer.writeCharCode$1(32);
            },
            visitAttributeSelector$1: function(_, attribute) {
                var _0_0, t2, t1 = this._serialize$_buffer;
                t1.writeCharCode$1(91);
                t1.write$1(0, attribute.name);
                _0_0 = attribute.value;
                if (_0_0 != null) {
                    t1.write$1(0, attribute.op);
                    if (A.Parser_isIdentifier(_0_0) && !B.JSString_methods.startsWith$1(_0_0, "--")) {
                        t1.write$1(0, _0_0);
                        t2 = attribute.modifier;
                        if (t2 != null) t1.writeCharCode$1(32);
                    } else {
                        this._visitQuotedString$1(_0_0);
                        t2 = attribute.modifier;
                        if (t2 != null) {
                            if (this._style !== B.OutputStyle_1) t1.writeCharCode$1(32);
                        }
                    }
                    A.NullableExtension_andThen(t2, t1.get$write(t1));
                }
                t1.writeCharCode$1(93);
            },
            visitClassSelector$1: function(_, klass) {
                var t1 = this._serialize$_buffer;
                t1.writeCharCode$1(46);
                t1.write$1(0, klass.name);
            },
            visitComplexSelector$1: function(complex) {
                var t2, t3, t4, t5, t6, i, component, t7, t8, t9, _this = this, t1 = complex.leadingCombinators;
                _this._writeCombinators$1(t1);
                if (t1.length >= 1 && complex.components.length >= 1) {
                    if (_this._style !== B.OutputStyle_1) _this._serialize$_buffer.writeCharCode$1(32);
                }
                for(t1 = complex.components, t2 = t1.length, t3 = t2 - 1, t4 = _this._serialize$_buffer, t5 = _this._style === B.OutputStyle_1, t6 = !t5, i = 0; i < t2; ++i){
                    component = t1[i];
                    _this.visitCompoundSelector$1(component.selector);
                    t7 = component.combinators;
                    t8 = t7.length === 0;
                    if (!t8) {
                        if (t6) t4.writeCharCode$1(32);
                    }
                    t9 = t5 ? "" : " ";
                    _this._writeBetween$3(t7, t9, t4.get$write(t4));
                    if (i !== t3) t7 = !t5 || t8;
                    else t7 = false;
                    if (t7) t4.writeCharCode$1(32);
                }
            },
            _writeCombinators$1: function(combinators) {
                var t1 = this._style === B.OutputStyle_1 ? "" : " ", t2 = this._serialize$_buffer;
                return this._writeBetween$3(combinators, t1, t2.get$write(t2));
            },
            visitCompoundSelector$1: function(compound) {
                var t2, t3, _i, t1 = this._serialize$_buffer, start = t1.get$length(t1);
                for(t2 = compound.components, t3 = t2.length, _i = 0; _i < t3; ++_i)t2[_i].accept$1(this);
                if (t1.get$length(t1) === start) t1.writeCharCode$1(42);
            },
            visitIDSelector$1: function(_, id) {
                var t1 = this._serialize$_buffer;
                t1.writeCharCode$1(35);
                t1.write$1(0, id.name);
            },
            visitSelectorList$1: function(list) {
                var t1, t2, t3, first, t4, _this = this, complexes = list.components;
                for(t1 = J.get$iterator$ax(_this._inspect ? complexes : new A.WhereIterable(complexes, new A._SerializeVisitor_visitSelectorList_closure(), A._arrayInstanceType(complexes)._eval$1("WhereIterable<1>"))), t2 = _this._style !== B.OutputStyle_1, t3 = _this._serialize$_buffer, first = true; t1.moveNext$0();){
                    t4 = t1.get$current(t1);
                    if (first) first = false;
                    else {
                        t3.writeCharCode$1(44);
                        if (t4.lineBreak) {
                            if (t2) t3.write$1(0, "\n");
                            _this._writeIndentation$0();
                        } else if (t2) t3.writeCharCode$1(32);
                    }
                    _this.visitComplexSelector$1(t4);
                }
            },
            visitParentSelector$1: function(_, $parent) {
                var t1 = this._serialize$_buffer;
                t1.writeCharCode$1(38);
                A.NullableExtension_andThen($parent.suffix, t1.get$write(t1));
            },
            visitPlaceholderSelector$1: function(_, placeholder) {
                var t1 = this._serialize$_buffer;
                t1.writeCharCode$1(37);
                t1.write$1(0, placeholder.name);
            },
            visitPseudoSelector$1: function(_, pseudo) {
                var _0_4, t3, t1 = pseudo.name, t2 = false;
                if ("not" === t1) {
                    _0_4 = pseudo.selector;
                    if (_0_4 instanceof A.SelectorList) t2 = (_0_4 == null ? type$.SelectorList._as(_0_4) : _0_4).accept$1(B._IsInvisibleVisitor_true);
                }
                if (t2) return;
                t2 = this._serialize$_buffer;
                t2.writeCharCode$1(58);
                if (!pseudo.isSyntacticClass) t2.writeCharCode$1(58);
                t2.write$1(0, t1);
                t1 = pseudo.argument;
                t3 = t1 == null;
                if (t3 && pseudo.selector == null) return;
                t2.writeCharCode$1(40);
                if (!t3) {
                    t2.write$1(0, t1);
                    if (pseudo.selector != null) t2.writeCharCode$1(32);
                }
                A.NullableExtension_andThen(pseudo.selector, this.get$visitSelectorList());
                t2.writeCharCode$1(41);
            },
            visitTypeSelector$1: function(_, type) {
                this._serialize$_buffer.write$1(0, type.name);
            },
            visitUniversalSelector$1: function(_, universal) {
                var t2, t1 = universal.namespace;
                if (t1 != null) {
                    t2 = this._serialize$_buffer;
                    t2.write$1(0, t1);
                    t2.writeCharCode$1(124);
                }
                this._serialize$_buffer.writeCharCode$1(42);
            },
            _serialize$_write$1: function(value) {
                return this._serialize$_buffer.forSpan$2(value.span, new A._SerializeVisitor__write_closure(this, value));
            },
            _serialize$_visitChildren$1: function($parent) {
                var t2, t3, t4, t5, t6, t7, prePrevious, previous, t8, previous0, t9, savedIndentation, _this = this, t1 = _this._serialize$_buffer;
                t1.writeCharCode$1(123);
                for(t2 = $parent.children, t3 = t2.$ti, t2 = new A.ListIterator(t2, t2.get$length(0), t3._eval$1("ListIterator<ListBase.E>")), t4 = _this._style === B.OutputStyle_1, t5 = !t4, t6 = _this.get$_requiresSemicolon(), t7 = !_this._inspect, t3 = t3._eval$1("ListBase.E"), prePrevious = null, previous = null; t2.moveNext$0();){
                    t8 = t2.__internal$_current;
                    previous0 = t8 == null ? t3._as(t8) : t8;
                    if (t7) t8 = t4 ? previous0.accept$1(B._IsInvisibleVisitor_true_true) : previous0.accept$1(B._IsInvisibleVisitor_true_false);
                    else t8 = false;
                    if (t8) continue;
                    t8 = previous == null;
                    t9 = t8 ? null : t6.call$1(previous);
                    if (t9 == null ? false : t9) t1.writeCharCode$1(59);
                    if (_this._isTrailingComment$2(previous0, t8 ? $parent : previous)) {
                        if (t5) t1.writeCharCode$1(32);
                        savedIndentation = _this._indentation;
                        _this._indentation = 0;
                        new A._SerializeVisitor__visitChildren_closure(_this, previous0).call$0();
                        _this._indentation = savedIndentation;
                    } else {
                        if (t5) t1.write$1(0, "\n");
                        ++_this._indentation;
                        new A._SerializeVisitor__visitChildren_closure0(_this, previous0).call$0();
                        --_this._indentation;
                    }
                    prePrevious = previous;
                    previous = previous0;
                }
                if (previous != null) {
                    if ((type$.CssParentNode._is(previous) ? previous.get$isChildless() : !(previous instanceof A.ModifiableCssComment)) && t5) t1.writeCharCode$1(59);
                    if (prePrevious == null && _this._isTrailingComment$2(previous, $parent)) {
                        if (t5) t1.writeCharCode$1(32);
                    } else {
                        _this._writeLineFeed$0();
                        _this._writeIndentation$0();
                    }
                }
                t1.writeCharCode$1(125);
            },
            _requiresSemicolon$1: function(node) {
                return type$.CssParentNode._is(node) ? node.get$isChildless() : !(node instanceof A.ModifiableCssComment);
            },
            _isTrailingComment$2: function(node, previous) {
                var t1, t2, t3, searchFrom, endOffset, t4, span;
                if (this._style === B.OutputStyle_1) return false;
                if (!(node instanceof A.ModifiableCssComment)) return false;
                t1 = node.span;
                t2 = t1.get$sourceUrl(t1);
                t3 = previous.get$span(previous);
                if (!J.$eq$(t2, t3.get$sourceUrl(t3))) return false;
                t2 = previous.get$span(previous);
                if (!(J.$eq$(t2.get$file(t2).url, t1.get$file(t1).url) && t2.get$start(t2).offset <= t1.get$start(t1).offset && t2.get$end(t2).offset >= t1.get$end(t1).offset)) {
                    t1 = t1.get$start(t1);
                    t1 = t1.file.getLine$1(t1.offset);
                    t2 = previous.get$span(previous);
                    t2 = t2.get$end(t2);
                    return t1 === t2.file.getLine$1(t2.offset);
                }
                t2 = t1.get$start(t1);
                t3 = previous.get$span(previous);
                searchFrom = t2.offset - t3.get$start(t3).offset - 1;
                if (searchFrom < 0) return false;
                endOffset = Math.max(0, B.JSString_methods.lastIndexOf$2(previous.get$span(previous).get$text(), "{", searchFrom));
                t2 = previous.get$span(previous);
                t2 = t2.get$file(t2);
                t3 = previous.get$span(previous);
                t3 = t3.get$start(t3);
                t4 = previous.get$span(previous);
                span = t2.span$2(0, t3.offset, t4.get$start(t4).offset + endOffset);
                t1 = t1.get$start(t1);
                t1 = t1.file.getLine$1(t1.offset);
                t4 = A.FileLocation$_(span.file, span._end);
                return t1 === t4.file.getLine$1(t4.offset);
            },
            _writeLineFeed$0: function() {
                if (this._style !== B.OutputStyle_1) this._serialize$_buffer.write$1(0, "\n");
            },
            _writeIndentation$0: function() {
                var _this = this;
                if (_this._style === B.OutputStyle_1) return;
                _this._writeTimes$2(_this._indentCharacter, _this._indentation * _this._indentWidth);
            },
            _writeTimes$2: function(char, times) {
                var t1, i;
                for(t1 = this._serialize$_buffer, i = 0; i < times; ++i)t1.writeCharCode$1(char);
            },
            _writeBetween$1$3: function(iterable, text, callback) {
                var t1, t2, first, value;
                for(t1 = J.get$iterator$ax(iterable), t2 = this._serialize$_buffer, first = true; t1.moveNext$0();){
                    value = t1.get$current(t1);
                    if (first) first = false;
                    else t2.write$1(0, text);
                    callback.call$1(value);
                }
            },
            _writeBetween$3: function(iterable, text, callback) {
                return this._writeBetween$1$3(iterable, text, callback, type$.dynamic);
            }
        };
        A._SerializeVisitor_visitCssComment_closure.prototype = {
            call$0: function() {
                var t2, t3, _0_0, minimumIndentation, t1 = this.$this;
                if (t1._style === B.OutputStyle_1 && this.node.text.charCodeAt(2) !== 33) return;
                t2 = this.node;
                t3 = t2.text;
                if (B.JSString_methods.startsWith$1(t3, A.RegExp_RegExp("/\\*# source(Mapping)?URL=", false))) return;
                _0_0 = t1._minimumIndentation$1(t3);
                if (_0_0 != null) {
                    t2 = t2.span;
                    t2 = t2.get$start(t2);
                    minimumIndentation = Math.min(_0_0, t2.file.getColumn$1(t2.offset));
                    t1._writeIndentation$0();
                    t1._writeWithIndent$2(t3, minimumIndentation);
                } else {
                    t1._writeIndentation$0();
                    t1._serialize$_buffer.write$1(0, t3);
                }
            },
            $signature: 1
        };
        A._SerializeVisitor_visitCssAtRule_closure.prototype = {
            call$0: function() {
                var t3, _0_0, t1 = this.$this, t2 = t1._serialize$_buffer;
                t2.writeCharCode$1(64);
                t3 = this.node;
                t1._serialize$_write$1(t3.name);
                _0_0 = t3.value;
                if (_0_0 != null) {
                    t2.writeCharCode$1(32);
                    t1._serialize$_write$1(_0_0);
                }
            },
            $signature: 1
        };
        A._SerializeVisitor_visitCssMediaRule_closure.prototype = {
            call$0: function() {
                var t3, firstQuery, t4, t5, t1 = this.$this, t2 = t1._serialize$_buffer;
                t2.write$1(0, "@media");
                t3 = this.node.queries;
                firstQuery = B.JSArray_methods.get$first(t3);
                t4 = t1._style === B.OutputStyle_1;
                t5 = true;
                if (t4) {
                    if (firstQuery.modifier == null) {
                        if (firstQuery.type == null) {
                            t5 = firstQuery.conditions;
                            t5 = t5.length === 1 && B.JSString_methods.startsWith$1(B.JSArray_methods.get$first(t5), "(not ");
                        }
                    }
                }
                if (t5) t2.writeCharCode$1(32);
                t2 = t4 ? "," : ", ";
                t1._writeBetween$3(t3, t2, t1.get$_visitMediaQuery());
            },
            $signature: 1
        };
        A._SerializeVisitor_visitCssImport_closure.prototype = {
            call$0: function() {
                var t3, t4, _0_0, t1 = this.$this, t2 = t1._serialize$_buffer;
                t2.write$1(0, "@import");
                t3 = t1._style !== B.OutputStyle_1;
                if (t3) t2.writeCharCode$1(32);
                t4 = this.node;
                t2.forSpan$2(t4.url.span, new A._SerializeVisitor_visitCssImport__closure(t1, t4));
                _0_0 = t4.modifiers;
                if (_0_0 != null) {
                    if (t3) t2.writeCharCode$1(32);
                    t2.write$1(0, _0_0);
                }
            },
            $signature: 1
        };
        A._SerializeVisitor_visitCssImport__closure.prototype = {
            call$0: function() {
                return this.$this._writeImportUrl$1(this.node.url.value);
            },
            $signature: 0
        };
        A._SerializeVisitor_visitCssKeyframeBlock_closure.prototype = {
            call$0: function() {
                var t1 = this.$this, t2 = t1._style === B.OutputStyle_1 ? "," : ", ", t3 = t1._serialize$_buffer;
                return t1._writeBetween$3(this.node.selector.value, t2, t3.get$write(t3));
            },
            $signature: 0
        };
        A._SerializeVisitor_visitCssStyleRule_closure.prototype = {
            call$0: function() {
                return this.$this.visitSelectorList$1(this.node._style_rule$_selector._box$_inner.value);
            },
            $signature: 0
        };
        A._SerializeVisitor_visitCssSupportsRule_closure.prototype = {
            call$0: function() {
                var t1 = this.$this, t2 = t1._serialize$_buffer;
                t2.write$1(0, "@supports");
                if (!(t1._style === B.OutputStyle_1 && this.node.condition.value.charCodeAt(0) === 40)) t2.writeCharCode$1(32);
                t1._serialize$_write$1(this.node.condition);
            },
            $signature: 1
        };
        A._SerializeVisitor_visitCssDeclaration_closure.prototype = {
            call$0: function() {
                var t1 = this.$this, t2 = this.node;
                if (t1._style === B.OutputStyle_1) t1._writeFoldedValue$1(t2);
                else t1._writeReindentedValue$1(t2);
            },
            $signature: 1
        };
        A._SerializeVisitor_visitCssDeclaration_closure0.prototype = {
            call$0: function() {
                return this.node.value.value.accept$1(this.$this);
            },
            $signature: 0
        };
        A._SerializeVisitor_visitList_closure.prototype = {
            call$1: function(element) {
                return !element.get$isBlank();
            },
            $signature: 79
        };
        A._SerializeVisitor_visitList_closure0.prototype = {
            call$1: function(element) {
                var t1 = this.$this, needsParens = t1._elementNeedsParens$2(this.value._separator, element);
                if (needsParens) t1._serialize$_buffer.writeCharCode$1(40);
                element.accept$1(t1);
                if (needsParens) t1._serialize$_buffer.writeCharCode$1(41);
            },
            $signature: 58
        };
        A._SerializeVisitor_visitList_closure1.prototype = {
            call$1: function(element) {
                element.accept$1(this.$this);
            },
            $signature: 58
        };
        A._SerializeVisitor_visitMap_closure.prototype = {
            call$1: function(entry) {
                var t1 = this.$this;
                t1._writeMapElement$1(entry.key);
                t1._serialize$_buffer.write$1(0, ": ");
                t1._writeMapElement$1(entry.value);
            },
            $signature: 284
        };
        A._SerializeVisitor_visitSelectorList_closure.prototype = {
            call$1: function(complex) {
                return !complex.accept$1(B._IsInvisibleVisitor_true);
            },
            $signature: 21
        };
        A._SerializeVisitor__write_closure.prototype = {
            call$0: function() {
                return this.$this._serialize$_buffer.write$1(0, this.value.value);
            },
            $signature: 0
        };
        A._SerializeVisitor__visitChildren_closure.prototype = {
            call$0: function() {
                return this.child.accept$1(this.$this);
            },
            $signature: 0
        };
        A._SerializeVisitor__visitChildren_closure0.prototype = {
            call$0: function() {
                this.child.accept$1(this.$this);
            },
            $signature: 0
        };
        A.OutputStyle.prototype = {
            _enumToString$0: function() {
                return "OutputStyle." + this._name;
            }
        };
        A.LineFeed.prototype = {
            _enumToString$0: function() {
                return "LineFeed." + this._name;
            },
            toString$0: function(_) {
                return "lf";
            }
        };
        A.StatementSearchVisitor.prototype = {
            visitAtRootRule$1: function(_, node) {
                return this.visitChildren$1(node.children);
            },
            visitAtRule$1: function(_, node) {
                return A.NullableExtension_andThen(node.children, this.get$visitChildren());
            },
            visitContentBlock$1: function(_, node) {
                return this.visitChildren$1(node.children);
            },
            visitContentRule$1: function(_, node) {
                return null;
            },
            visitDebugRule$1: function(_, node) {
                return null;
            },
            visitDeclaration$1: function(_, node) {
                return A.NullableExtension_andThen(node.children, this.get$visitChildren());
            },
            visitEachRule$1: function(_, node) {
                return this.visitChildren$1(node.children);
            },
            visitErrorRule$1: function(_, node) {
                return null;
            },
            visitExtendRule$1: function(_, node) {
                return null;
            },
            visitForRule$1: function(_, node) {
                return this.visitChildren$1(node.children);
            },
            visitForwardRule$1: function(_, node) {
                return null;
            },
            visitFunctionRule$1: function(_, node) {
                return this.visitChildren$1(node.children);
            },
            visitIfRule$1: function(_, node) {
                var t1 = A.IterableExtension_search(node.clauses, new A.StatementSearchVisitor_visitIfRule_closure(this));
                return t1 == null ? A.NullableExtension_andThen(node.lastClause, new A.StatementSearchVisitor_visitIfRule_closure0(this)) : t1;
            },
            visitImportRule$1: function(_, node) {
                return null;
            },
            visitIncludeRule$1: function(_, node) {
                return A.NullableExtension_andThen(node.content, this.get$visitContentBlock(this));
            },
            visitLoudComment$1: function(_, node) {
                return null;
            },
            visitMediaRule$1: function(_, node) {
                return this.visitChildren$1(node.children);
            },
            visitMixinRule$1: function(_, node) {
                return this.visitChildren$1(node.children);
            },
            visitReturnRule$1: function(_, node) {
                return null;
            },
            visitSilentComment$1: function(_, node) {
                return null;
            },
            visitStyleRule$1: function(_, node) {
                return this.visitChildren$1(node.children);
            },
            visitStylesheet$1: function(_, node) {
                return this.visitChildren$1(node.children);
            },
            visitSupportsRule$1: function(_, node) {
                return this.visitChildren$1(node.children);
            },
            visitUseRule$1: function(_, node) {
                return null;
            },
            visitVariableDeclaration$1: function(_, node) {
                return null;
            },
            visitWarnRule$1: function(_, node) {
                return null;
            },
            visitWhileRule$1: function(_, node) {
                return this.visitChildren$1(node.children);
            },
            visitChildren$1: function(children) {
                return A.IterableExtension_search(children, new A.StatementSearchVisitor_visitChildren_closure(this));
            }
        };
        A.StatementSearchVisitor_visitIfRule_closure.prototype = {
            call$1: function(clause) {
                return A.IterableExtension_search(clause.children, new A.StatementSearchVisitor_visitIfRule__closure0(this.$this));
            },
            $signature: function() {
                return A._instanceType(this.$this)._eval$1("StatementSearchVisitor.T?(IfClause)");
            }
        };
        A.StatementSearchVisitor_visitIfRule__closure0.prototype = {
            call$1: function(child) {
                return child.accept$1(this.$this);
            },
            $signature: function() {
                return A._instanceType(this.$this)._eval$1("StatementSearchVisitor.T?(Statement)");
            }
        };
        A.StatementSearchVisitor_visitIfRule_closure0.prototype = {
            call$1: function(lastClause) {
                return A.IterableExtension_search(lastClause.children, new A.StatementSearchVisitor_visitIfRule__closure(this.$this));
            },
            $signature: function() {
                return A._instanceType(this.$this)._eval$1("StatementSearchVisitor.T?(ElseClause)");
            }
        };
        A.StatementSearchVisitor_visitIfRule__closure.prototype = {
            call$1: function(child) {
                return child.accept$1(this.$this);
            },
            $signature: function() {
                return A._instanceType(this.$this)._eval$1("StatementSearchVisitor.T?(Statement)");
            }
        };
        A.StatementSearchVisitor_visitChildren_closure.prototype = {
            call$1: function(child) {
                return child.accept$1(this.$this);
            },
            $signature: function() {
                return A._instanceType(this.$this)._eval$1("StatementSearchVisitor.T?(Statement)");
            }
        };
        A.Entry.prototype = {
            compareTo$1: function(_, other) {
                var t1, t2, res = this.target.compareTo$1(0, other.target);
                if (res !== 0) return res;
                t1 = this.source;
                t2 = other.source;
                res = B.JSString_methods.compareTo$1(J.toString$0$(t1.file.url), J.toString$0$(t2.file.url));
                if (res !== 0) return res;
                return t1.compareTo$1(0, t2);
            },
            $isComparable: 1
        };
        A.Mapping.prototype = {};
        A.SingleMapping.prototype = {
            toJson$1$includeSourceContents: function(includeSourceContents) {
                var t1, t2, line, column, srcLine, srcColumn, srcUrlId, srcNameId, first, _i, entry, nextLine, i, t3, t4, column0, t5, newUrlId, srcLine0, srcColumn0, srcNameId0, result, _this = this, buff = new A.StringBuffer("");
                for(t1 = _this.lines, t2 = t1.length, line = 0, column = 0, srcLine = 0, srcColumn = 0, srcUrlId = 0, srcNameId = 0, first = true, _i = 0; _i < t1.length; t1.length === t2 || (0, A.throwConcurrentModificationError)(t1), ++_i){
                    entry = t1[_i];
                    nextLine = entry.line;
                    if (nextLine > line) {
                        for(i = line; i < nextLine; ++i)buff._contents += ";";
                        line = nextLine;
                        column = 0;
                        first = true;
                    }
                    for(t3 = J.get$iterator$ax(entry.entries); t3.moveNext$0(); column = column0, first = false){
                        t4 = t3.get$current(t3);
                        if (!first) buff._contents += ",";
                        column0 = t4.column;
                        t5 = A.encodeVlq(column0 - column);
                        t5 = A.StringBuffer__writeAll(buff._contents, t5, "");
                        buff._contents = t5;
                        newUrlId = t4.sourceUrlId;
                        t5 = A.StringBuffer__writeAll(t5, A.encodeVlq(newUrlId - srcUrlId), "");
                        buff._contents = t5;
                        srcLine0 = t4.sourceLine;
                        t5 = A.StringBuffer__writeAll(t5, A.encodeVlq(srcLine0 - srcLine), "");
                        buff._contents = t5;
                        srcColumn0 = t4.sourceColumn;
                        t5 = A.StringBuffer__writeAll(t5, A.encodeVlq(srcColumn0 - srcColumn), "");
                        buff._contents = t5;
                        srcNameId0 = t4.sourceNameId;
                        if (srcNameId0 == null) {
                            srcUrlId = newUrlId;
                            srcColumn = srcColumn0;
                            srcLine = srcLine0;
                            continue;
                        }
                        buff._contents = A.StringBuffer__writeAll(t5, A.encodeVlq(srcNameId0 - srcNameId), "");
                        srcNameId = srcNameId0;
                        srcUrlId = newUrlId;
                        srcColumn = srcColumn0;
                        srcLine = srcLine0;
                    }
                }
                t1 = _this.sourceRoot;
                if (t1 == null) t1 = "";
                t2 = buff._contents;
                result = A.LinkedHashMap_LinkedHashMap$_literal([
                    "version",
                    3,
                    "sourceRoot",
                    t1,
                    "sources",
                    _this.urls,
                    "names",
                    _this.names,
                    "mappings",
                    t2.charCodeAt(0) == 0 ? t2 : t2
                ], type$.String, type$.dynamic);
                t1 = _this.targetUrl;
                if (t1 != null) result.$indexSet(0, "file", t1);
                if (includeSourceContents) {
                    t1 = _this.files;
                    t2 = A._arrayInstanceType(t1)._eval$1("MappedListIterable<1,String?>");
                    t1 = A.List_List$_of(new A.MappedListIterable(t1, new A.SingleMapping_toJson_closure(), t2), t2._eval$1("ListIterable.E"));
                    result.$indexSet(0, "sourcesContent", t1);
                }
                _this.extensions.forEach$1(0, new A.SingleMapping_toJson_closure0(result));
                return result;
            },
            toJson$0: function() {
                return this.toJson$1$includeSourceContents(false);
            },
            toString$0: function(_) {
                var _this = this, t1 = A.getRuntimeTypeOfDartObject(_this).toString$0(0) + " : [targetUrl: " + A.S(_this.targetUrl) + ", sourceRoot: " + A.S(_this.sourceRoot) + ", urls: " + A.S(_this.urls) + ", names: " + A.S(_this.names) + ", lines: " + A.S(_this.lines) + "]";
                return t1.charCodeAt(0) == 0 ? t1 : t1;
            }
        };
        A.SingleMapping_SingleMapping$fromEntries_closure.prototype = {
            call$0: function() {
                return this.urls.__js_helper$_length;
            },
            $signature: 10
        };
        A.SingleMapping_SingleMapping$fromEntries_closure0.prototype = {
            call$0: function() {
                return this.sourceEntry.source.file;
            },
            $signature: 285
        };
        A.SingleMapping_SingleMapping$fromEntries_closure1.prototype = {
            call$1: function(i) {
                return this.files.$index(0, i);
            },
            $signature: 286
        };
        A.SingleMapping_toJson_closure.prototype = {
            call$1: function(file) {
                return file == null ? null : A.String_String$fromCharCodes(B.NativeUint32List_methods.sublist$2(file._decodedChars, 0, null), 0, null);
            },
            $signature: 287
        };
        A.SingleMapping_toJson_closure0.prototype = {
            call$2: function($name, value) {
                this.result.$indexSet(0, $name, value);
                return value;
            },
            $signature: 140
        };
        A.TargetLineEntry.prototype = {
            toString$0: function(_) {
                return A.getRuntimeTypeOfDartObject(this).toString$0(0) + ": " + this.line + " " + A.S(this.entries);
            }
        };
        A.TargetEntry.prototype = {
            toString$0: function(_) {
                var _this = this;
                return A.getRuntimeTypeOfDartObject(_this).toString$0(0) + ": (" + _this.column + ", " + _this.sourceUrlId + ", " + _this.sourceLine + ", " + _this.sourceColumn + ", " + A.S(_this.sourceNameId) + ")";
            }
        };
        A.SourceFile.prototype = {
            get$length: function(_) {
                return this._decodedChars.length;
            },
            get$lines: function() {
                return this._lineStarts.length;
            },
            SourceFile$_fromList$2$url: function(decodedChars, url) {
                var t1, t2, t3, t4, t5, i, c, j;
                for(t1 = this._decodedChars, t2 = t1.length, t3 = J.getInterceptor$asx(decodedChars), t4 = t1.$flags | 0, t5 = this._lineStarts, i = 0; i < t2; ++i){
                    c = t3.$index(decodedChars, i);
                    t4 & 2 && A.throwUnsupportedOperation(t1);
                    t1[i] = c;
                    if (c === 13) {
                        j = i + 1;
                        if (j >= t3.get$length(decodedChars) || t3.$index(decodedChars, j) !== 10) c = 10;
                    }
                    if (c === 10) t5.push(i + 1);
                }
            },
            span$2: function(_, start, end) {
                return A._FileSpan$(this, start, end == null ? this._decodedChars.length : end);
            },
            span$1: function(_, start) {
                return this.span$2(0, start, null);
            },
            getLine$1: function(offset) {
                var t1, _this = this;
                if (offset < 0) throw A.wrapException(A.RangeError$("Offset may not be negative, was " + offset + "."));
                else if (offset > _this._decodedChars.length) throw A.wrapException(A.RangeError$("Offset " + offset + string$.x20must_n + _this.get$length(0) + "."));
                t1 = _this._lineStarts;
                if (offset < B.JSArray_methods.get$first(t1)) return -1;
                if (offset >= B.JSArray_methods.get$last(t1)) return t1.length - 1;
                if (_this._isNearCachedLine$1(offset)) {
                    t1 = _this._cachedLine;
                    t1.toString;
                    return t1;
                }
                return _this._cachedLine = _this._binarySearch$1(offset) - 1;
            },
            _isNearCachedLine$1: function(offset) {
                var t2, t3, t1 = this._cachedLine;
                if (t1 == null) return false;
                t2 = this._lineStarts;
                if (offset < t2[t1]) return false;
                t3 = t2.length;
                if (t1 >= t3 - 1 || offset < t2[t1 + 1]) return true;
                if (t1 >= t3 - 2 || offset < t2[t1 + 2]) {
                    this._cachedLine = t1 + 1;
                    return true;
                }
                return false;
            },
            _binarySearch$1: function(offset) {
                var min, half, t1 = this._lineStarts, max = t1.length - 1;
                for(min = 0; min < max;){
                    half = min + B.JSInt_methods._tdivFast$1(max - min, 2);
                    if (t1[half] > offset) max = half;
                    else min = half + 1;
                }
                return max;
            },
            getColumn$1: function(offset) {
                var line, lineStart, _this = this;
                if (offset < 0) throw A.wrapException(A.RangeError$("Offset may not be negative, was " + offset + "."));
                else if (offset > _this._decodedChars.length) throw A.wrapException(A.RangeError$("Offset " + offset + " must be not be greater than the number of characters in the file, " + _this.get$length(0) + "."));
                line = _this.getLine$1(offset);
                lineStart = _this._lineStarts[line];
                if (lineStart > offset) throw A.wrapException(A.RangeError$("Line " + line + " comes after offset " + offset + "."));
                return offset - lineStart;
            },
            getOffset$1: function(line) {
                var t1, t2, result, t3;
                if (line < 0) throw A.wrapException(A.RangeError$("Line may not be negative, was " + line + "."));
                else {
                    t1 = this._lineStarts;
                    t2 = t1.length;
                    if (line >= t2) throw A.wrapException(A.RangeError$("Line " + line + " must be less than the number of lines in the file, " + this.get$lines() + "."));
                }
                result = t1[line];
                if (result <= this._decodedChars.length) {
                    t3 = line + 1;
                    t1 = t3 < t2 && result >= t1[t3];
                } else t1 = true;
                if (t1) throw A.wrapException(A.RangeError$("Line " + line + " doesn't have 0 columns."));
                return result;
            }
        };
        A.FileLocation.prototype = {
            get$sourceUrl: function(_) {
                return this.file.url;
            },
            get$line: function() {
                return this.file.getLine$1(this.offset);
            },
            get$column: function() {
                return this.file.getColumn$1(this.offset);
            },
            FileLocation$_$2: function(file, offset) {
                var t2, t1 = this.offset;
                if (t1 < 0) throw A.wrapException(A.RangeError$("Offset may not be negative, was " + t1 + "."));
                else {
                    t2 = this.file;
                    if (t1 > t2._decodedChars.length) throw A.wrapException(A.RangeError$("Offset " + t1 + string$.x20must_n + t2.get$length(0) + "."));
                }
            },
            pointSpan$0: function() {
                var t1 = this.offset;
                return A._FileSpan$(this.file, t1, t1);
            },
            get$offset: function() {
                return this.offset;
            }
        };
        A._FileSpan.prototype = {
            get$sourceUrl: function(_) {
                return this.file.url;
            },
            get$length: function(_) {
                return this._end - this._file$_start;
            },
            get$start: function(_) {
                return A.FileLocation$_(this.file, this._file$_start);
            },
            get$end: function(_) {
                return A.FileLocation$_(this.file, this._end);
            },
            get$text: function() {
                return A.String_String$fromCharCodes(B.NativeUint32List_methods.sublist$2(this.file._decodedChars, this._file$_start, this._end), 0, null);
            },
            get$context: function(_) {
                var _this = this, t1 = _this.file, endOffset = _this._end, endLine = t1.getLine$1(endOffset);
                if (t1.getColumn$1(endOffset) === 0 && endLine !== 0) {
                    if (endOffset - _this._file$_start === 0) return endLine === t1._lineStarts.length - 1 ? "" : A.String_String$fromCharCodes(B.NativeUint32List_methods.sublist$2(t1._decodedChars, t1.getOffset$1(endLine), t1.getOffset$1(endLine + 1)), 0, null);
                } else endOffset = endLine === t1._lineStarts.length - 1 ? t1._decodedChars.length : t1.getOffset$1(endLine + 1);
                return A.String_String$fromCharCodes(B.NativeUint32List_methods.sublist$2(t1._decodedChars, t1.getOffset$1(t1.getLine$1(_this._file$_start)), endOffset), 0, null);
            },
            _FileSpan$3: function(file, _start, _end) {
                var t3, t1 = this._end, t2 = this._file$_start;
                if (t1 < t2) throw A.wrapException(A.ArgumentError$("End " + t1 + " must come after start " + t2 + ".", null));
                else {
                    t3 = this.file;
                    if (t1 > t3._decodedChars.length) throw A.wrapException(A.RangeError$("End " + t1 + string$.x20must_n + t3.get$length(0) + "."));
                    else if (t2 < 0) throw A.wrapException(A.RangeError$("Start may not be negative, was " + t2 + "."));
                }
            },
            compareTo$1: function(_, other) {
                var result;
                if (!(other instanceof A._FileSpan)) return this.super$SourceSpanMixin$compareTo(0, other);
                result = B.JSInt_methods.compareTo$1(this._file$_start, other._file$_start);
                return result === 0 ? B.JSInt_methods.compareTo$1(this._end, other._end) : result;
            },
            $eq: function(_, other) {
                var _this = this;
                if (other == null) return false;
                if (!type$.FileSpan._is(other)) return _this.super$SourceSpanMixin$$eq(0, other);
                if (!(other instanceof A._FileSpan)) return _this.super$SourceSpanMixin$$eq(0, other) && J.$eq$(_this.file.url, other.get$sourceUrl(other));
                return _this._file$_start === other._file$_start && _this._end === other._end && J.$eq$(_this.file.url, other.file.url);
            },
            get$hashCode: function(_) {
                return A.Object_hash(this._file$_start, this._end, this.file.url, B.C_SentinelValue);
            },
            expand$1: function(_, other) {
                var t2, t3, _this = this, t1 = _this.file;
                if (!J.$eq$(t1.url, other.get$sourceUrl(other))) throw A.wrapException(A.ArgumentError$('Source URLs "' + A.S(_this.get$sourceUrl(0)) + '" and  "' + A.S(other.get$sourceUrl(other)) + "\" don't match.", null));
                t2 = _this._file$_start;
                t3 = _this._end;
                if (other instanceof A._FileSpan) return A._FileSpan$(t1, Math.min(t2, other._file$_start), Math.max(t3, other._end));
                else return A._FileSpan$(t1, Math.min(t2, other.get$start(other).offset), Math.max(t3, other.get$end(other).offset));
            },
            $isFileSpan: 1,
            $isSourceSpanWithContext: 1,
            get$file: function(receiver) {
                return this.file;
            }
        };
        A.Highlighter.prototype = {
            highlight$0: function() {
                var t2, highlightsByColumn, t3, t4, i, line, lastLine, t5, t6, t7, t8, t9, t10, t11, index, primaryIdx, primary, _i, highlight, _this = this, _null = null, t1 = _this._lines;
                _this._writeFileStart$1(B.JSArray_methods.get$first(t1).url);
                t2 = _this._maxMultilineSpans;
                highlightsByColumn = A.List_List$filled(t2, _null, false, type$.nullable__Highlight);
                for(t3 = _this._highlighter$_buffer, t2 = t2 !== 0, t4 = _this._primaryColor, i = 0; i < t1.length; ++i){
                    line = t1[i];
                    if (i > 0) {
                        lastLine = t1[i - 1];
                        t5 = line.url;
                        if (!J.$eq$(lastLine.url, t5)) {
                            _this._writeSidebar$1$end($._glyphs.get$upEnd());
                            t3._contents += "\n";
                            _this._writeFileStart$1(t5);
                        } else if (lastLine.number + 1 !== line.number) {
                            _this._writeSidebar$1$text("...");
                            t3._contents += "\n";
                        }
                    }
                    for(t5 = line.highlights, t6 = A._arrayInstanceType(t5)._eval$1("ReversedListIterable<1>"), t7 = new A.ReversedListIterable(t5, t6), t7 = new A.ListIterator(t7, t7.get$length(0), t6._eval$1("ListIterator<ListIterable.E>")), t6 = t6._eval$1("ListIterable.E"), t8 = line.number, t9 = line.text; t7.moveNext$0();){
                        t10 = t7.__internal$_current;
                        if (t10 == null) t10 = t6._as(t10);
                        t11 = t10.span;
                        if (t11.get$start(t11).get$line() !== t11.get$end(t11).get$line() && t11.get$start(t11).get$line() === t8 && _this._isOnlyWhitespace$1(B.JSString_methods.substring$2(t9, 0, t11.get$start(t11).get$column()))) {
                            index = B.JSArray_methods.indexOf$1(highlightsByColumn, _null);
                            if (index < 0) A.throwExpression(A.ArgumentError$(A.S(highlightsByColumn) + " contains no null elements.", _null));
                            highlightsByColumn[index] = t10;
                        }
                    }
                    _this._writeSidebar$1$line(t8);
                    t3._contents += " ";
                    _this._writeMultilineHighlights$2(line, highlightsByColumn);
                    if (t2) t3._contents += " ";
                    primaryIdx = B.JSArray_methods.indexWhere$1(t5, new A.Highlighter_highlight_closure());
                    primary = primaryIdx === -1 ? _null : t5[primaryIdx];
                    t6 = primary != null;
                    if (t6) {
                        t7 = primary.span;
                        t10 = t7.get$start(t7).get$line() === t8 ? t7.get$start(t7).get$column() : 0;
                        _this._writeHighlightedText$4$color(t9, t10, t7.get$end(t7).get$line() === t8 ? t7.get$end(t7).get$column() : t9.length, t4);
                    } else _this._writeText$1(t9);
                    t3._contents += "\n";
                    if (t6) _this._writeIndicator$3(line, primary, highlightsByColumn);
                    for(t6 = t5.length, _i = 0; _i < t5.length; t5.length === t6 || (0, A.throwConcurrentModificationError)(t5), ++_i){
                        highlight = t5[_i];
                        if (highlight.isPrimary) continue;
                        _this._writeIndicator$3(line, highlight, highlightsByColumn);
                    }
                }
                _this._writeSidebar$1$end($._glyphs.get$upEnd());
                t1 = t3._contents;
                return t1.charCodeAt(0) == 0 ? t1 : t1;
            },
            _writeFileStart$1: function(url) {
                var _this = this, t1 = !_this._multipleFiles || !type$.Uri._is(url), t2 = $._glyphs;
                if (t1) _this._writeSidebar$1$end(t2.get$downEnd());
                else {
                    _this._writeSidebar$1$end(t2.get$topLeftCorner());
                    _this._colorize$2$color(new A.Highlighter__writeFileStart_closure(_this), "\x1b[34m");
                    t1 = _this._highlighter$_buffer;
                    t2 = " " + $.$get$context().prettyUri$1(url);
                    t1._contents += t2;
                }
                _this._highlighter$_buffer._contents += "\n";
            },
            _writeMultilineHighlights$3$current: function(line, highlightsByColumn, current) {
                var t1, currentColor, t2, t3, t4, t5, foundCurrent, _i, highlight, t6, startLine, t7, endLine, _this = this, _box_0 = {};
                _box_0.openedOnThisLine = false;
                _box_0.openedOnThisLineColor = null;
                t1 = current == null;
                if (t1) currentColor = null;
                else currentColor = current.isPrimary ? _this._primaryColor : _this._secondaryColor;
                for(t2 = highlightsByColumn.length, t3 = _this._secondaryColor, t1 = !t1, t4 = _this._primaryColor, t5 = _this._highlighter$_buffer, foundCurrent = false, _i = 0; _i < t2; ++_i){
                    highlight = highlightsByColumn[_i];
                    t6 = highlight == null;
                    if (t6) startLine = null;
                    else {
                        t7 = highlight.span;
                        startLine = t7.get$start(t7).get$line();
                    }
                    if (t6) endLine = null;
                    else {
                        t7 = highlight.span;
                        endLine = t7.get$end(t7).get$line();
                    }
                    if (t1 && highlight === current) {
                        _this._colorize$2$color(new A.Highlighter__writeMultilineHighlights_closure(_this, startLine, line), currentColor);
                        foundCurrent = true;
                    } else if (foundCurrent) _this._colorize$2$color(new A.Highlighter__writeMultilineHighlights_closure0(_this, highlight), currentColor);
                    else if (t6) {
                        if (_box_0.openedOnThisLine) _this._colorize$2$color(new A.Highlighter__writeMultilineHighlights_closure1(_this), _box_0.openedOnThisLineColor);
                        else t5._contents += " ";
                    } else {
                        t6 = highlight.isPrimary ? t4 : t3;
                        _this._colorize$2$color(new A.Highlighter__writeMultilineHighlights_closure2(_box_0, _this, current, startLine, line, highlight, endLine), t6);
                    }
                }
            },
            _writeMultilineHighlights$2: function(line, highlightsByColumn) {
                return this._writeMultilineHighlights$3$current(line, highlightsByColumn, null);
            },
            _writeHighlightedText$4$color: function(text, startColumn, endColumn, color) {
                var _this = this;
                _this._writeText$1(B.JSString_methods.substring$2(text, 0, startColumn));
                _this._colorize$2$color(new A.Highlighter__writeHighlightedText_closure(_this, text, startColumn, endColumn), color);
                _this._writeText$1(B.JSString_methods.substring$2(text, endColumn, text.length));
            },
            _writeIndicator$3: function(line, highlight, highlightsByColumn) {
                var t2, coversWholeLine, _this = this, color = highlight.isPrimary ? _this._primaryColor : _this._secondaryColor, t1 = highlight.span;
                if (t1.get$start(t1).get$line() === t1.get$end(t1).get$line()) {
                    _this._writeSidebar$0();
                    t1 = _this._highlighter$_buffer;
                    t1._contents += " ";
                    _this._writeMultilineHighlights$3$current(line, highlightsByColumn, highlight);
                    if (highlightsByColumn.length !== 0) t1._contents += " ";
                    _this._writeLabel$3(highlight, highlightsByColumn, _this._colorize$2$color(new A.Highlighter__writeIndicator_closure(_this, line, highlight), color));
                } else {
                    t2 = line.number;
                    if (t1.get$start(t1).get$line() === t2) {
                        if (B.JSArray_methods.contains$1(highlightsByColumn, highlight)) return;
                        A.replaceFirstNull(highlightsByColumn, highlight);
                        _this._writeSidebar$0();
                        t1 = _this._highlighter$_buffer;
                        t1._contents += " ";
                        _this._writeMultilineHighlights$3$current(line, highlightsByColumn, highlight);
                        _this._colorize$2$color(new A.Highlighter__writeIndicator_closure0(_this, line, highlight), color);
                        t1._contents += "\n";
                    } else if (t1.get$end(t1).get$line() === t2) {
                        coversWholeLine = t1.get$end(t1).get$column() === line.text.length;
                        if (coversWholeLine && highlight.label == null) {
                            A.replaceWithNull(highlightsByColumn, highlight);
                            return;
                        }
                        _this._writeSidebar$0();
                        _this._highlighter$_buffer._contents += " ";
                        _this._writeMultilineHighlights$3$current(line, highlightsByColumn, highlight);
                        _this._writeLabel$3(highlight, highlightsByColumn, _this._colorize$2$color(new A.Highlighter__writeIndicator_closure1(_this, coversWholeLine, line, highlight), color));
                        A.replaceWithNull(highlightsByColumn, highlight);
                    }
                }
            },
            _writeArrow$3$beginning: function(line, column, beginning) {
                var t2, t1 = beginning ? 0 : 1, tabs = this._countTabs$1(B.JSString_methods.substring$2(line.text, 0, column + t1));
                t1 = this._highlighter$_buffer;
                t2 = B.JSString_methods.$mul($._glyphs.get$horizontalLine(), 1 + column + tabs * 3);
                t1._contents = (t1._contents += t2) + "^";
            },
            _writeArrow$2: function(line, column) {
                return this._writeArrow$3$beginning(line, column, true);
            },
            _writeLabel$3: function(highlight, highlightsByColumn, underlineLength) {
                var lines, color, t1, t2, t3, t4, t5, t6, _i, columnHighlight, _this = this, label = highlight.label;
                if (label == null) {
                    _this._highlighter$_buffer._contents += "\n";
                    return;
                }
                lines = A._setArrayType(label.split("\n"), type$.JSArray_String);
                color = highlight.isPrimary ? _this._primaryColor : _this._secondaryColor;
                _this._colorize$2$color(new A.Highlighter__writeLabel_closure(_this, lines), color);
                t1 = _this._highlighter$_buffer;
                t1._contents += "\n";
                for(t2 = A.SubListIterable$(lines, 1, null, type$.String), t3 = t2.$ti, t2 = new A.ListIterator(t2, t2.get$length(0), t3._eval$1("ListIterator<ListIterable.E>")), t4 = highlightsByColumn.length, t3 = t3._eval$1("ListIterable.E"); t2.moveNext$0();){
                    t5 = t2.__internal$_current;
                    if (t5 == null) t5 = t3._as(t5);
                    _this._writeSidebar$0();
                    t6 = t1._contents += " ";
                    for(_i = 0; _i < t4; ++_i){
                        columnHighlight = highlightsByColumn[_i];
                        if (columnHighlight == null || columnHighlight === highlight) {
                            t6 += " ";
                            t1._contents = t6;
                        } else {
                            t6 = $._glyphs.get$verticalLine();
                            t6 = t1._contents += t6;
                        }
                    }
                    t1._contents = t6 + B.JSString_methods.$mul(" ", underlineLength);
                    _this._colorize$2$color(new A.Highlighter__writeLabel_closure0(_this, t5), color);
                    t1._contents += "\n";
                }
            },
            _writeText$1: function(text) {
                var t1, t2, t3, t4;
                for(t1 = new A.CodeUnits(text), t2 = type$.CodeUnits, t1 = new A.ListIterator(t1, t1.get$length(0), t2._eval$1("ListIterator<ListBase.E>")), t3 = this._highlighter$_buffer, t2 = t2._eval$1("ListBase.E"); t1.moveNext$0();){
                    t4 = t1.__internal$_current;
                    if (t4 == null) t4 = t2._as(t4);
                    if (t4 === 9) t3._contents += B.JSString_methods.$mul(" ", 4);
                    else {
                        t4 = A.Primitives_stringFromCharCode(t4);
                        t3._contents += t4;
                    }
                }
            },
            _writeSidebar$3$end$line$text: function(end, line, text) {
                var t1 = {};
                t1.text = text;
                if (line != null) t1.text = B.JSInt_methods.toString$0(line + 1);
                this._colorize$2$color(new A.Highlighter__writeSidebar_closure(t1, this, end), "\x1b[34m");
            },
            _writeSidebar$1$end: function(end) {
                return this._writeSidebar$3$end$line$text(end, null, null);
            },
            _writeSidebar$1$text: function(text) {
                return this._writeSidebar$3$end$line$text(null, null, text);
            },
            _writeSidebar$1$line: function(line) {
                return this._writeSidebar$3$end$line$text(null, line, null);
            },
            _writeSidebar$0: function() {
                return this._writeSidebar$3$end$line$text(null, null, null);
            },
            _countTabs$1: function(text) {
                var t1, t2, count, t3;
                for(t1 = new A.CodeUnits(text), t2 = type$.CodeUnits, t1 = new A.ListIterator(t1, t1.get$length(0), t2._eval$1("ListIterator<ListBase.E>")), t2 = t2._eval$1("ListBase.E"), count = 0; t1.moveNext$0();){
                    t3 = t1.__internal$_current;
                    if ((t3 == null ? t2._as(t3) : t3) === 9) ++count;
                }
                return count;
            },
            _isOnlyWhitespace$1: function(text) {
                var t1, t2, t3;
                for(t1 = new A.CodeUnits(text), t2 = type$.CodeUnits, t1 = new A.ListIterator(t1, t1.get$length(0), t2._eval$1("ListIterator<ListBase.E>")), t2 = t2._eval$1("ListBase.E"); t1.moveNext$0();){
                    t3 = t1.__internal$_current;
                    if (t3 == null) t3 = t2._as(t3);
                    if (t3 !== 32 && t3 !== 9) return false;
                }
                return true;
            },
            _colorize$1$2$color: function(callback, color) {
                var result, t1 = this._primaryColor != null;
                if (t1 && color != null) this._highlighter$_buffer._contents += color;
                result = callback.call$0();
                if (t1 && color != null) this._highlighter$_buffer._contents += "\x1b[0m";
                return result;
            },
            _colorize$2$color: function(callback, color) {
                return this._colorize$1$2$color(callback, color, type$.dynamic);
            }
        };
        A.Highlighter_closure.prototype = {
            call$0: function() {
                var t1 = this.color, t2 = J.getInterceptor$(t1);
                if (t2.$eq(t1, true)) return "\x1b[31m";
                if (t2.$eq(t1, false)) return null;
                return A._asStringQ(t1);
            },
            $signature: 47
        };
        A.Highlighter$__closure.prototype = {
            call$1: function(line) {
                var t1 = line.highlights;
                return new A.WhereIterable(t1, new A.Highlighter$___closure(), A._arrayInstanceType(t1)._eval$1("WhereIterable<1>")).get$length(0);
            },
            $signature: 288
        };
        A.Highlighter$___closure.prototype = {
            call$1: function(highlight) {
                var t1 = highlight.span;
                return t1.get$start(t1).get$line() !== t1.get$end(t1).get$line();
            },
            $signature: 122
        };
        A.Highlighter$__closure0.prototype = {
            call$1: function(line) {
                return line.url;
            },
            $signature: 290
        };
        A.Highlighter__collateLines_closure.prototype = {
            call$1: function(highlight) {
                var t1 = highlight.span;
                t1 = t1.get$sourceUrl(t1);
                return t1 == null ? new A.Object() : t1;
            },
            $signature: 291
        };
        A.Highlighter__collateLines_closure0.prototype = {
            call$2: function(highlight1, highlight2) {
                return highlight1.span.compareTo$1(0, highlight2.span);
            },
            $signature: 292
        };
        A.Highlighter__collateLines_closure1.prototype = {
            call$1: function(entry) {
                var t1, t2, t3, t4, context, t5, linesBeforeSpan, lineNumber, _i, line, activeHighlights, flags, highlightIndex, oldHighlightLength, t6, t7, url = entry.key, highlightsForFile = entry.value, lines = A._setArrayType([], type$.JSArray__Line);
                for(t1 = J.getInterceptor$ax(highlightsForFile), t2 = t1.get$iterator(highlightsForFile), t3 = type$.JSArray__Highlight; t2.moveNext$0();){
                    t4 = t2.get$current(t2).span;
                    context = t4.get$context(t4);
                    t5 = A.findLineStart(context, t4.get$text(), t4.get$start(t4).get$column());
                    t5.toString;
                    linesBeforeSpan = B.JSString_methods.allMatches$1("\n", B.JSString_methods.substring$2(context, 0, t5)).get$length(0);
                    lineNumber = t4.get$start(t4).get$line() - linesBeforeSpan;
                    for(t4 = context.split("\n"), t5 = t4.length, _i = 0; _i < t5; ++_i){
                        line = t4[_i];
                        if (lines.length === 0 || lineNumber > B.JSArray_methods.get$last(lines).number) lines.push(new A._Line(line, lineNumber, url, A._setArrayType([], t3)));
                        ++lineNumber;
                    }
                }
                activeHighlights = A._setArrayType([], t3);
                for(t2 = lines.length, flags = activeHighlights.$flags | 0, highlightIndex = 0, _i = 0; _i < lines.length; lines.length === t2 || (0, A.throwConcurrentModificationError)(lines), ++_i){
                    line = lines[_i];
                    flags & 1 && A.throwUnsupportedOperation(activeHighlights, 16);
                    B.JSArray_methods._removeWhere$2(activeHighlights, new A.Highlighter__collateLines__closure(line), true);
                    oldHighlightLength = activeHighlights.length;
                    for(t3 = t1.skip$1(highlightsForFile, highlightIndex), t4 = t3.$ti, t3 = new A.ListIterator(t3, t3.get$length(0), t4._eval$1("ListIterator<ListIterable.E>")), t5 = line.number, t4 = t4._eval$1("ListIterable.E"); t3.moveNext$0();){
                        t6 = t3.__internal$_current;
                        if (t6 == null) t6 = t4._as(t6);
                        t7 = t6.span;
                        if (t7.get$start(t7).get$line() > t5) break;
                        activeHighlights.push(t6);
                    }
                    highlightIndex += activeHighlights.length - oldHighlightLength;
                    B.JSArray_methods.addAll$1(line.highlights, activeHighlights);
                }
                return lines;
            },
            $signature: 293
        };
        A.Highlighter__collateLines__closure.prototype = {
            call$1: function(highlight) {
                var t1 = highlight.span;
                return t1.get$end(t1).get$line() < this.line.number;
            },
            $signature: 122
        };
        A.Highlighter_highlight_closure.prototype = {
            call$1: function(highlight) {
                return highlight.isPrimary;
            },
            $signature: 122
        };
        A.Highlighter__writeFileStart_closure.prototype = {
            call$0: function() {
                var t1 = this.$this._highlighter$_buffer, t2 = B.JSString_methods.$mul($._glyphs.get$horizontalLine(), 2) + ">";
                t1._contents += t2;
                return null;
            },
            $signature: 0
        };
        A.Highlighter__writeMultilineHighlights_closure.prototype = {
            call$0: function() {
                var t1 = this.$this._highlighter$_buffer, t2 = $._glyphs;
                t2 = this.startLine === this.line.number ? t2.get$topLeftCorner() : t2.get$bottomLeftCorner();
                t1._contents += t2;
            },
            $signature: 1
        };
        A.Highlighter__writeMultilineHighlights_closure0.prototype = {
            call$0: function() {
                var t1 = this.$this._highlighter$_buffer, t2 = $._glyphs;
                t2 = this.highlight == null ? t2.get$horizontalLine() : t2.get$cross();
                t1._contents += t2;
            },
            $signature: 1
        };
        A.Highlighter__writeMultilineHighlights_closure1.prototype = {
            call$0: function() {
                var t1 = this.$this._highlighter$_buffer, t2 = $._glyphs.get$horizontalLine();
                t1._contents += t2;
                return null;
            },
            $signature: 0
        };
        A.Highlighter__writeMultilineHighlights_closure2.prototype = {
            call$0: function() {
                var _this = this, t1 = _this._box_0, t2 = t1.openedOnThisLine, t3 = $._glyphs, vertical = t2 ? t3.get$cross() : t3.get$verticalLine();
                if (_this.current != null) _this.$this._highlighter$_buffer._contents += vertical;
                else {
                    t2 = _this.line;
                    t3 = t2.number;
                    if (_this.startLine === t3) {
                        t2 = _this.$this;
                        t2._colorize$2$color(new A.Highlighter__writeMultilineHighlights__closure(t1, t2), t1.openedOnThisLineColor);
                        t1.openedOnThisLine = true;
                        if (t1.openedOnThisLineColor == null) t1.openedOnThisLineColor = _this.highlight.isPrimary ? t2._primaryColor : t2._secondaryColor;
                    } else {
                        if (_this.endLine === t3) {
                            t3 = _this.highlight.span;
                            t2 = t3.get$end(t3).get$column() === t2.text.length;
                        } else t2 = false;
                        t3 = _this.$this;
                        if (t2) {
                            t1 = t3._highlighter$_buffer;
                            t2 = _this.highlight.label == null ? $._glyphs.glyphOrAscii$2("\u2514", "\\") : vertical;
                            t1._contents += t2;
                        } else t3._colorize$2$color(new A.Highlighter__writeMultilineHighlights__closure0(t3, vertical), t1.openedOnThisLineColor);
                    }
                }
            },
            $signature: 1
        };
        A.Highlighter__writeMultilineHighlights__closure.prototype = {
            call$0: function() {
                var t1 = this.$this._highlighter$_buffer, t2 = this._box_0.openedOnThisLine ? "\u252c" : "\u250c";
                t2 = $._glyphs.glyphOrAscii$2(t2, "/");
                t1._contents += t2;
            },
            $signature: 1
        };
        A.Highlighter__writeMultilineHighlights__closure0.prototype = {
            call$0: function() {
                this.$this._highlighter$_buffer._contents += this.vertical;
            },
            $signature: 1
        };
        A.Highlighter__writeHighlightedText_closure.prototype = {
            call$0: function() {
                var _this = this;
                return _this.$this._writeText$1(B.JSString_methods.substring$2(_this.text, _this.startColumn, _this.endColumn));
            },
            $signature: 0
        };
        A.Highlighter__writeIndicator_closure.prototype = {
            call$0: function() {
                var startColumn, endColumn, tabsBefore, tabsInside, t1 = this.$this, t2 = t1._highlighter$_buffer, t3 = t2._contents, t4 = this.highlight, t5 = t4.span;
                t4 = t4.isPrimary ? "^" : $._glyphs.get$horizontalLineBold();
                startColumn = t5.get$start(t5).get$column();
                endColumn = t5.get$end(t5).get$column();
                t5 = this.line.text;
                tabsBefore = t1._countTabs$1(B.JSString_methods.substring$2(t5, 0, startColumn));
                tabsInside = t1._countTabs$1(B.JSString_methods.substring$2(t5, startColumn, endColumn));
                startColumn += tabsBefore * 3;
                t4 = (t2._contents += B.JSString_methods.$mul(" ", startColumn)) + B.JSString_methods.$mul(t4, Math.max(endColumn + (tabsBefore + tabsInside) * 3 - startColumn, 1));
                t2._contents = t4;
                return t4.length - t3.length;
            },
            $signature: 10
        };
        A.Highlighter__writeIndicator_closure0.prototype = {
            call$0: function() {
                var t1 = this.highlight.span;
                return this.$this._writeArrow$2(this.line, t1.get$start(t1).get$column());
            },
            $signature: 0
        };
        A.Highlighter__writeIndicator_closure1.prototype = {
            call$0: function() {
                var t4, _this = this, t1 = _this.$this, t2 = t1._highlighter$_buffer, t3 = t2._contents;
                if (_this.coversWholeLine) {
                    t1 = B.JSString_methods.$mul($._glyphs.get$horizontalLine(), 3);
                    t2._contents += t1;
                } else {
                    t4 = _this.highlight.span;
                    t1._writeArrow$3$beginning(_this.line, Math.max(t4.get$end(t4).get$column() - 1, 0), false);
                }
                return t2._contents.length - t3.length;
            },
            $signature: 10
        };
        A.Highlighter__writeLabel_closure.prototype = {
            call$0: function() {
                var t1 = this.$this._highlighter$_buffer, t2 = " " + B.JSArray_methods.get$first(this.lines);
                t1._contents += t2;
                return null;
            },
            $signature: 0
        };
        A.Highlighter__writeLabel_closure0.prototype = {
            call$0: function() {
                this.$this._highlighter$_buffer._contents += " " + this.text;
                return null;
            },
            $signature: 0
        };
        A.Highlighter__writeSidebar_closure.prototype = {
            call$0: function() {
                var t1 = this.$this, t2 = t1._highlighter$_buffer, t3 = this._box_0.text;
                if (t3 == null) t3 = "";
                t1 = B.JSString_methods.padRight$1(t3, t1._paddingBeforeSidebar);
                t2._contents += t1;
                t1 = this.end;
                if (t1 == null) t1 = $._glyphs.get$verticalLine();
                t2._contents += t1;
            },
            $signature: 1
        };
        A._Highlight.prototype = {
            toString$0: function(_) {
                var t1 = this.isPrimary ? "primary " : "", t2 = this.span;
                t2 = t1 + ("" + t2.get$start(t2).get$line() + ":" + t2.get$start(t2).get$column() + "-" + t2.get$end(t2).get$line() + ":" + t2.get$end(t2).get$column());
                t1 = this.label;
                t1 = t1 != null ? t2 + (" (" + t1 + ")") : t2;
                return t1.charCodeAt(0) == 0 ? t1 : t1;
            }
        };
        A._Highlight_closure.prototype = {
            call$0: function() {
                var t1, t2, t3, t4, newSpan = this.span;
                if (!(type$.SourceSpanWithContext._is(newSpan) && A.findLineStart(newSpan.get$context(newSpan), newSpan.get$text(), newSpan.get$start(newSpan).get$column()) != null)) {
                    t1 = A.SourceLocation$(newSpan.get$start(newSpan).get$offset(), 0, 0, newSpan.get$sourceUrl(newSpan));
                    t2 = newSpan.get$end(newSpan).get$offset();
                    t3 = newSpan.get$sourceUrl(newSpan);
                    t4 = A.countCodeUnits(newSpan.get$text(), 10);
                    newSpan = A.SourceSpanWithContext$(t1, A.SourceLocation$(t2, A._Highlight__lastLineLength(newSpan.get$text()), t4, t3), newSpan.get$text(), newSpan.get$text());
                }
                return A._Highlight__normalizeEndOfLine(A._Highlight__normalizeTrailingNewline(A._Highlight__normalizeNewlines(newSpan)));
            },
            $signature: 294
        };
        A._Line.prototype = {
            toString$0: function(_) {
                return "" + this.number + ': "' + this.text + '" (' + B.JSArray_methods.join$1(this.highlights, ", ") + ")";
            }
        };
        A.SourceLocation.prototype = {
            distance$1: function(other) {
                var t1 = this.sourceUrl;
                if (!J.$eq$(t1, other.get$sourceUrl(other))) throw A.wrapException(A.ArgumentError$('Source URLs "' + A.S(t1) + '" and "' + A.S(other.get$sourceUrl(other)) + "\" don't match.", null));
                return Math.abs(this.offset - other.get$offset());
            },
            compareTo$1: function(_, other) {
                var t1 = this.sourceUrl;
                if (!J.$eq$(t1, other.get$sourceUrl(other))) throw A.wrapException(A.ArgumentError$('Source URLs "' + A.S(t1) + '" and "' + A.S(other.get$sourceUrl(other)) + "\" don't match.", null));
                return this.offset - other.get$offset();
            },
            $eq: function(_, other) {
                if (other == null) return false;
                return type$.SourceLocation._is(other) && J.$eq$(this.sourceUrl, other.get$sourceUrl(other)) && this.offset === other.get$offset();
            },
            get$hashCode: function(_) {
                var t1 = this.sourceUrl;
                t1 = t1 == null ? null : t1.get$hashCode(t1);
                if (t1 == null) t1 = 0;
                return t1 + this.offset;
            },
            toString$0: function(_) {
                var _this = this, t1 = A.getRuntimeTypeOfDartObject(_this).toString$0(0), source = _this.sourceUrl;
                return "<" + t1 + ": " + _this.offset + " " + (A.S(source == null ? "unknown source" : source) + ":" + (_this.line + 1) + ":" + (_this.column + 1)) + ">";
            },
            $isComparable: 1,
            get$sourceUrl: function(receiver) {
                return this.sourceUrl;
            },
            get$offset: function() {
                return this.offset;
            },
            get$line: function() {
                return this.line;
            },
            get$column: function() {
                return this.column;
            }
        };
        A.SourceLocationMixin.prototype = {
            distance$1: function(other) {
                if (!J.$eq$(this.file.url, other.get$sourceUrl(other))) throw A.wrapException(A.ArgumentError$('Source URLs "' + A.S(this.get$sourceUrl(0)) + '" and "' + A.S(other.get$sourceUrl(other)) + "\" don't match.", null));
                return Math.abs(this.offset - other.get$offset());
            },
            compareTo$1: function(_, other) {
                if (!J.$eq$(this.file.url, other.get$sourceUrl(other))) throw A.wrapException(A.ArgumentError$('Source URLs "' + A.S(this.get$sourceUrl(0)) + '" and "' + A.S(other.get$sourceUrl(other)) + "\" don't match.", null));
                return this.offset - other.get$offset();
            },
            $eq: function(_, other) {
                if (other == null) return false;
                return type$.SourceLocation._is(other) && J.$eq$(this.file.url, other.get$sourceUrl(other)) && this.offset === other.get$offset();
            },
            get$hashCode: function(_) {
                var t1 = this.file.url;
                t1 = t1 == null ? null : t1.get$hashCode(t1);
                if (t1 == null) t1 = 0;
                return t1 + this.offset;
            },
            toString$0: function(_) {
                var t1 = A.getRuntimeTypeOfDartObject(this).toString$0(0), t2 = this.offset, t3 = this.file, source = t3.url;
                return "<" + t1 + ": " + t2 + " " + (A.S(source == null ? "unknown source" : source) + ":" + (t3.getLine$1(t2) + 1) + ":" + (t3.getColumn$1(t2) + 1)) + ">";
            },
            $isComparable: 1,
            $isSourceLocation: 1
        };
        A.SourceSpanBase.prototype = {
            SourceSpanBase$3: function(start, end, text) {
                var t3, t1 = this.end, t2 = this.start;
                if (!J.$eq$(t1.get$sourceUrl(t1), t2.get$sourceUrl(t2))) throw A.wrapException(A.ArgumentError$('Source URLs "' + A.S(t2.get$sourceUrl(t2)) + '" and  "' + A.S(t1.get$sourceUrl(t1)) + "\" don't match.", null));
                else if (t1.get$offset() < t2.get$offset()) throw A.wrapException(A.ArgumentError$("End " + t1.toString$0(0) + " must come after start " + t2.toString$0(0) + ".", null));
                else {
                    t3 = this.text;
                    if (t3.length !== t2.distance$1(t1)) throw A.wrapException(A.ArgumentError$('Text "' + t3 + '" must be ' + t2.distance$1(t1) + " characters long.", null));
                }
            },
            get$start: function(receiver) {
                return this.start;
            },
            get$end: function(receiver) {
                return this.end;
            },
            get$text: function() {
                return this.text;
            }
        };
        A.SourceSpanException.prototype = {
            get$message: function(_) {
                return this._span_exception$_message;
            },
            get$span: function(_) {
                return this._span;
            },
            toString$1$color: function(_, color) {
                var _this = this;
                _this.get$span(_this);
                return "Error on " + _this.get$span(_this).message$2$color(0, _this._span_exception$_message, color);
            },
            toString$0: function(_) {
                return this.toString$1$color(0, null);
            },
            $isException: 1
        };
        A.SourceSpanFormatException.prototype = {
            $isFormatException: 1,
            get$source: function() {
                return this.source;
            }
        };
        A.MultiSourceSpanException.prototype = {
            toString$0: function(_) {
                var _this = this;
                return "Error on " + A.SourceSpanExtension_messageMultiple(_this._span, _this._span_exception$_message, _this.primaryLabel, _this.secondarySpans, false, null, null);
            },
            get$primaryLabel: function() {
                return this.primaryLabel;
            },
            get$secondarySpans: function() {
                return this.secondarySpans;
            }
        };
        A.MultiSourceSpanFormatException.prototype = {
            $isFormatException: 1
        };
        A.SourceSpanMixin.prototype = {
            get$sourceUrl: function(_) {
                var t1 = this.get$start(this);
                return t1.get$sourceUrl(t1);
            },
            get$length: function(_) {
                var _this = this;
                return _this.get$end(_this).get$offset() - _this.get$start(_this).get$offset();
            },
            compareTo$1: function(_, other) {
                var _this = this, result = _this.get$start(_this).compareTo$1(0, other.get$start(other));
                return result === 0 ? _this.get$end(_this).compareTo$1(0, other.get$end(other)) : result;
            },
            message$2$color: function(_, message, color) {
                var t2, t3, highlight, _this = this, t1 = "line " + (_this.get$start(_this).get$line() + 1) + ", column " + (_this.get$start(_this).get$column() + 1);
                if (_this.get$sourceUrl(_this) != null) {
                    t2 = _this.get$sourceUrl(_this);
                    t3 = $.$get$context();
                    t2.toString;
                    t2 = t1 + (" of " + t3.prettyUri$1(t2));
                    t1 = t2;
                }
                t1 += ": " + message;
                highlight = _this.highlight$1$color(color);
                if (highlight.length !== 0) t1 = t1 + "\n" + highlight;
                return t1.charCodeAt(0) == 0 ? t1 : t1;
            },
            message$1: function(_, message) {
                return this.message$2$color(0, message, null);
            },
            highlight$1$color: function(color) {
                var _this = this;
                if (!type$.SourceSpanWithContext._is(_this) && _this.get$length(_this) === 0) return "";
                return A.Highlighter$(_this, color).highlight$0();
            },
            $eq: function(_, other) {
                var _this = this;
                if (other == null) return false;
                return type$.SourceSpan._is(other) && _this.get$start(_this).$eq(0, other.get$start(other)) && _this.get$end(_this).$eq(0, other.get$end(other));
            },
            get$hashCode: function(_) {
                var _this = this;
                return A.Object_hash(_this.get$start(_this), _this.get$end(_this), B.C_SentinelValue, B.C_SentinelValue);
            },
            toString$0: function(_) {
                var _this = this;
                return "<" + A.getRuntimeTypeOfDartObject(_this).toString$0(0) + ": from " + _this.get$start(_this).toString$0(0) + " to " + _this.get$end(_this).toString$0(0) + ' "' + _this.get$text() + '">';
            },
            $isComparable: 1,
            $isSourceSpan: 1
        };
        A.SourceSpanWithContext.prototype = {
            get$context: function(_) {
                return this._context;
            }
        };
        A.Chain.prototype = {
            toTrace$0: function() {
                var t1 = this.traces;
                return A.Trace$(new A.ExpandIterable(t1, new A.Chain_toTrace_closure(), A._arrayInstanceType(t1)._eval$1("ExpandIterable<1,Frame>")), null);
            },
            toString$0: function(_) {
                var t1 = this.traces, t2 = A._arrayInstanceType(t1);
                return new A.MappedListIterable(t1, new A.Chain_toString_closure(new A.MappedListIterable(t1, new A.Chain_toString_closure0(), t2._eval$1("MappedListIterable<1,int>")).fold$2(0, 0, B.CONSTANT)), t2._eval$1("MappedListIterable<1,String>")).join$1(0, string$.x3d_____);
            },
            $isStackTrace: 1
        };
        A.Chain_Chain$parse_closure.prototype = {
            call$1: function(line) {
                return line.length !== 0;
            },
            $signature: 4
        };
        A.Chain_toTrace_closure.prototype = {
            call$1: function(trace) {
                return trace.get$frames();
            },
            $signature: 295
        };
        A.Chain_toString_closure0.prototype = {
            call$1: function(trace) {
                var t1 = trace.get$frames();
                return new A.MappedListIterable(t1, new A.Chain_toString__closure0(), A._arrayInstanceType(t1)._eval$1("MappedListIterable<1,int>")).fold$2(0, 0, B.CONSTANT);
            },
            $signature: 296
        };
        A.Chain_toString__closure0.prototype = {
            call$1: function(frame) {
                return frame.get$location().length;
            },
            $signature: 196
        };
        A.Chain_toString_closure.prototype = {
            call$1: function(trace) {
                var t1 = trace.get$frames();
                return new A.MappedListIterable(t1, new A.Chain_toString__closure(this.longest), A._arrayInstanceType(t1)._eval$1("MappedListIterable<1,String>")).join$0(0);
            },
            $signature: 298
        };
        A.Chain_toString__closure.prototype = {
            call$1: function(frame) {
                return B.JSString_methods.padRight$1(frame.get$location(), this.longest) + "  " + A.S(frame.get$member()) + "\n";
            },
            $signature: 197
        };
        A.Frame.prototype = {
            get$isCore: function() {
                return this.uri.get$scheme() === "dart";
            },
            get$library: function() {
                var t1 = this.uri;
                if (t1.get$scheme() === "data") return "data:...";
                return $.$get$context().prettyUri$1(t1);
            },
            get$$package: function() {
                var t1 = this.uri;
                if (t1.get$scheme() !== "package") return null;
                return B.JSArray_methods.get$first(t1.get$path(t1).split("/"));
            },
            get$location: function() {
                var t2, _this = this, t1 = _this.line;
                if (t1 == null) return _this.get$library();
                t2 = _this.column;
                if (t2 == null) return _this.get$library() + " " + A.S(t1);
                return _this.get$library() + " " + A.S(t1) + ":" + A.S(t2);
            },
            toString$0: function(_) {
                return this.get$location() + " in " + A.S(this.member);
            },
            get$uri: function() {
                return this.uri;
            },
            get$line: function() {
                return this.line;
            },
            get$column: function() {
                return this.column;
            },
            get$member: function() {
                return this.member;
            }
        };
        A.Frame_Frame$parseVM_closure.prototype = {
            call$0: function() {
                var match, t2, t3, member, uri, lineAndColumn, line, _null = null, t1 = this.frame;
                if (t1 === "...") return new A.Frame(A._Uri__Uri(_null, _null, _null, _null), _null, _null, "...");
                match = $.$get$_vmFrame().firstMatch$1(t1);
                if (match == null) return new A.UnparsedFrame(A._Uri__Uri(_null, "unparsed", _null, _null), t1);
                t1 = match._match;
                t2 = t1[1];
                t2.toString;
                t3 = $.$get$_asyncBody();
                t2 = A.stringReplaceAllUnchecked(t2, t3, "<async>");
                member = A.stringReplaceAllUnchecked(t2, "<anonymous closure>", "<fn>");
                t2 = t1[2];
                t3 = t2;
                t3.toString;
                if (B.JSString_methods.startsWith$1(t3, "<data:")) uri = A.Uri_Uri$dataFromString("", _null, _null);
                else {
                    t2;
                    t2.toString;
                    uri = A.Uri_parse(t2);
                }
                lineAndColumn = t1[3].split(":");
                t1 = lineAndColumn.length;
                line = t1 > 1 ? A.int_parse(lineAndColumn[1], _null) : _null;
                return new A.Frame(uri, line, t1 > 2 ? A.int_parse(lineAndColumn[2], _null) : _null, member);
            },
            $signature: 76
        };
        A.Frame_Frame$parseV8_closure.prototype = {
            call$0: function() {
                var member, uri, t2, functionOffset, t3, _s4_ = "<fn>", t1 = this.frame, match = $.$get$_v8WasmFrame().firstMatch$1(t1);
                if (match != null) {
                    member = match.namedGroup$1("member");
                    t1 = match.namedGroup$1("uri");
                    t1.toString;
                    uri = A.Frame__uriOrPathToUri(t1);
                    t1 = match.namedGroup$1("index");
                    t1.toString;
                    t2 = match.namedGroup$1("offset");
                    t2.toString;
                    functionOffset = A.int_parse(t2, 16);
                    if (!(member == null)) t1 = member;
                    return new A.Frame(uri, 1, functionOffset + 1, t1);
                }
                match = $.$get$_v8JsFrame().firstMatch$1(t1);
                if (match != null) {
                    t1 = new A.Frame_Frame$parseV8_closure_parseJsLocation(t1);
                    t2 = match._match;
                    t3 = t2[2];
                    if (t3 != null) {
                        t3;
                        t3.toString;
                        t2 = t2[1];
                        t2.toString;
                        t2 = A.stringReplaceAllUnchecked(t2, "<anonymous>", _s4_);
                        t2 = A.stringReplaceAllUnchecked(t2, "Anonymous function", _s4_);
                        return t1.call$2(t3, A.stringReplaceAllUnchecked(t2, "(anonymous function)", _s4_));
                    } else {
                        t2 = t2[3];
                        t2.toString;
                        return t1.call$2(t2, _s4_);
                    }
                }
                return new A.UnparsedFrame(A._Uri__Uri(null, "unparsed", null, null), t1);
            },
            $signature: 76
        };
        A.Frame_Frame$parseV8_closure_parseJsLocation.prototype = {
            call$2: function($location, member) {
                var t2, urlMatch, uri, line, columnMatch, _null = null, t1 = $.$get$_v8EvalLocation(), evalMatch = t1.firstMatch$1($location);
                for(; evalMatch != null; $location = t2){
                    t2 = evalMatch._match[1];
                    t2.toString;
                    evalMatch = t1.firstMatch$1(t2);
                }
                if ($location === "native") return new A.Frame(A.Uri_parse("native"), _null, _null, member);
                urlMatch = $.$get$_v8JsUrlLocation().firstMatch$1($location);
                if (urlMatch == null) return new A.UnparsedFrame(A._Uri__Uri(_null, "unparsed", _null, _null), this.frame);
                t1 = urlMatch._match;
                t2 = t1[1];
                t2.toString;
                uri = A.Frame__uriOrPathToUri(t2);
                t2 = t1[2];
                t2.toString;
                line = A.int_parse(t2, _null);
                columnMatch = t1[3];
                return new A.Frame(uri, line, columnMatch != null ? A.int_parse(columnMatch, _null) : _null, member);
            },
            $signature: 301
        };
        A.Frame_Frame$_parseFirefoxEval_closure.prototype = {
            call$0: function() {
                var t2, member, uri, line, _null = null, t1 = this.frame, match = $.$get$_firefoxEvalLocation().firstMatch$1(t1);
                if (match == null) return new A.UnparsedFrame(A._Uri__Uri(_null, "unparsed", _null, _null), t1);
                t1 = match._match;
                t2 = t1[1];
                t2.toString;
                member = A.stringReplaceAllUnchecked(t2, "/<", "");
                t2 = t1[2];
                t2.toString;
                uri = A.Frame__uriOrPathToUri(t2);
                t1 = t1[3];
                t1.toString;
                line = A.int_parse(t1, _null);
                return new A.Frame(uri, line, _null, member.length === 0 || member === "anonymous" ? "<fn>" : member);
            },
            $signature: 76
        };
        A.Frame_Frame$parseFirefox_closure.prototype = {
            call$0: function() {
                var t2, t3, t4, uri, member, line, column, functionOffset, _null = null, t1 = this.frame, match = $.$get$_firefoxSafariJSFrame().firstMatch$1(t1);
                if (match != null) {
                    t2 = match._match;
                    t3 = t2[3];
                    t4 = t3;
                    t4.toString;
                    if (B.JSString_methods.contains$1(t4, " line ")) return A.Frame_Frame$_parseFirefoxEval(t1);
                    t1 = t3;
                    t1.toString;
                    uri = A.Frame__uriOrPathToUri(t1);
                    member = t2[1];
                    if (member != null) {
                        t1 = t2[2];
                        t1.toString;
                        member += B.JSArray_methods.join$0(A.List_List$filled(B.JSString_methods.allMatches$1("/", t1).get$length(0), ".<fn>", false, type$.String));
                        if (member === "") member = "<fn>";
                        member = B.JSString_methods.replaceFirst$2(member, $.$get$_initialDot(), "");
                    } else member = "<fn>";
                    t1 = t2[4];
                    if (t1 === "") line = _null;
                    else {
                        t1;
                        t1.toString;
                        line = A.int_parse(t1, _null);
                    }
                    t1 = t2[5];
                    if (t1 == null || t1 === "") column = _null;
                    else {
                        t1;
                        t1.toString;
                        column = A.int_parse(t1, _null);
                    }
                    return new A.Frame(uri, line, column, member);
                }
                match = $.$get$_firefoxWasmFrame().firstMatch$1(t1);
                if (match != null) {
                    t1 = match.namedGroup$1("member");
                    t1.toString;
                    t2 = match.namedGroup$1("uri");
                    t2.toString;
                    uri = A.Frame__uriOrPathToUri(t2);
                    t2 = match.namedGroup$1("index");
                    t2.toString;
                    t3 = match.namedGroup$1("offset");
                    t3.toString;
                    functionOffset = A.int_parse(t3, 16);
                    if (!(t1.length !== 0)) t1 = t2;
                    return new A.Frame(uri, 1, functionOffset + 1, t1);
                }
                match = $.$get$_safariWasmFrame().firstMatch$1(t1);
                if (match != null) {
                    t1 = match.namedGroup$1("member");
                    t1.toString;
                    return new A.Frame(A._Uri__Uri(_null, "wasm code", _null, _null), _null, _null, t1);
                }
                return new A.UnparsedFrame(A._Uri__Uri(_null, "unparsed", _null, _null), t1);
            },
            $signature: 76
        };
        A.Frame_Frame$parseFriendly_closure.prototype = {
            call$0: function() {
                var t2, uri, line, column, _null = null, t1 = this.frame, match = $.$get$_friendlyFrame().firstMatch$1(t1);
                if (match == null) throw A.wrapException(A.FormatException$("Couldn't parse package:stack_trace stack trace line '" + t1 + "'.", _null, _null));
                t1 = match._match;
                t2 = t1[1];
                if (t2 === "data:...") uri = A.Uri_Uri$dataFromString("", _null, _null);
                else {
                    t2;
                    t2.toString;
                    uri = A.Uri_parse(t2);
                }
                if (uri.get$scheme() === "") {
                    t2 = $.$get$context();
                    uri = t2.toUri$1(A.absolute(t2.style.pathFromUri$1(A._parseUri(uri)), _null, _null, _null, _null, _null, _null, _null, _null, _null, _null, _null, _null, _null, _null));
                }
                t2 = t1[2];
                if (t2 == null) line = _null;
                else {
                    t2;
                    t2.toString;
                    line = A.int_parse(t2, _null);
                }
                t2 = t1[3];
                if (t2 == null) column = _null;
                else {
                    t2;
                    t2.toString;
                    column = A.int_parse(t2, _null);
                }
                return new A.Frame(uri, line, column, t1[4]);
            },
            $signature: 76
        };
        A.LazyTrace.prototype = {
            get$_lazy_trace$_trace: function() {
                var result, _this = this, value = _this.__LazyTrace__trace_FI;
                if (value === $) {
                    result = _this._thunk.call$0();
                    _this.__LazyTrace__trace_FI !== $ && A.throwUnnamedLateFieldADI();
                    _this.__LazyTrace__trace_FI = result;
                    value = result;
                }
                return value;
            },
            get$frames: function() {
                return this.get$_lazy_trace$_trace().get$frames();
            },
            get$terse: function() {
                return new A.LazyTrace(new A.LazyTrace_terse_closure(this));
            },
            toString$0: function(_) {
                return this.get$_lazy_trace$_trace().toString$0(0);
            },
            $isStackTrace: 1,
            $isTrace: 1
        };
        A.LazyTrace_terse_closure.prototype = {
            call$0: function() {
                return this.$this.get$_lazy_trace$_trace().get$terse();
            },
            $signature: 199
        };
        A.Trace.prototype = {
            get$terse: function() {
                return this.foldFrames$2$terse(new A.Trace_terse_closure(), true);
            },
            foldFrames$2$terse: function(predicate, terse) {
                var newFrames, t1, t2, t3, _box_0 = {};
                _box_0.predicate = predicate;
                _box_0.predicate = new A.Trace_foldFrames_closure(predicate);
                newFrames = A._setArrayType([], type$.JSArray_Frame);
                for(t1 = this.frames, t2 = A._arrayInstanceType(t1)._eval$1("ReversedListIterable<1>"), t1 = new A.ReversedListIterable(t1, t2), t1 = new A.ListIterator(t1, t1.get$length(0), t2._eval$1("ListIterator<ListIterable.E>")), t2 = t2._eval$1("ListIterable.E"); t1.moveNext$0();){
                    t3 = t1.__internal$_current;
                    if (t3 == null) t3 = t2._as(t3);
                    if (t3 instanceof A.UnparsedFrame || !_box_0.predicate.call$1(t3)) newFrames.push(t3);
                    else if (newFrames.length === 0 || !_box_0.predicate.call$1(B.JSArray_methods.get$last(newFrames))) newFrames.push(new A.Frame(t3.get$uri(), t3.get$line(), t3.get$column(), t3.get$member()));
                }
                t1 = type$.MappedListIterable_Frame_Frame;
                newFrames = A.List_List$_of(new A.MappedListIterable(newFrames, new A.Trace_foldFrames_closure0(_box_0), t1), t1._eval$1("ListIterable.E"));
                if (newFrames.length > 1 && _box_0.predicate.call$1(B.JSArray_methods.get$first(newFrames))) B.JSArray_methods.removeAt$1(newFrames, 0);
                return A.Trace$(new A.ReversedListIterable(newFrames, A._arrayInstanceType(newFrames)._eval$1("ReversedListIterable<1>")), this.original._stackTrace);
            },
            toString$0: function(_) {
                var t1 = this.frames, t2 = A._arrayInstanceType(t1);
                return new A.MappedListIterable(t1, new A.Trace_toString_closure(new A.MappedListIterable(t1, new A.Trace_toString_closure0(), t2._eval$1("MappedListIterable<1,int>")).fold$2(0, 0, B.CONSTANT)), t2._eval$1("MappedListIterable<1,String>")).join$0(0);
            },
            $isStackTrace: 1,
            get$frames: function() {
                return this.frames;
            }
        };
        A.Trace_Trace$from_closure.prototype = {
            call$0: function() {
                return A.Trace_Trace$parse(this.trace.toString$0(0));
            },
            $signature: 199
        };
        A.Trace__parseVM_closure.prototype = {
            call$1: function(line) {
                return line.length !== 0;
            },
            $signature: 4
        };
        A.Trace$parseV8_closure.prototype = {
            call$1: function(line) {
                return !B.JSString_methods.startsWith$1(line, $.$get$_v8TraceLine());
            },
            $signature: 4
        };
        A.Trace$parseJSCore_closure.prototype = {
            call$1: function(line) {
                return line !== "\tat ";
            },
            $signature: 4
        };
        A.Trace$parseFirefox_closure.prototype = {
            call$1: function(line) {
                return line.length !== 0 && line !== "[native code]";
            },
            $signature: 4
        };
        A.Trace$parseFriendly_closure.prototype = {
            call$1: function(line) {
                return !B.JSString_methods.startsWith$1(line, "=====");
            },
            $signature: 4
        };
        A.Trace_terse_closure.prototype = {
            call$1: function(_) {
                return false;
            },
            $signature: 200
        };
        A.Trace_foldFrames_closure.prototype = {
            call$1: function(frame) {
                var t1;
                if (this.oldPredicate.call$1(frame)) return true;
                if (frame.get$isCore()) return true;
                if (frame.get$$package() === "stack_trace") return true;
                t1 = frame.get$member();
                t1.toString;
                if (!B.JSString_methods.contains$1(t1, "<async>")) return false;
                return frame.get$line() == null;
            },
            $signature: 200
        };
        A.Trace_foldFrames_closure0.prototype = {
            call$1: function(frame) {
                var t1, t2;
                if (frame instanceof A.UnparsedFrame || !this._box_0.predicate.call$1(frame)) return frame;
                t1 = frame.get$library();
                t2 = $.$get$_terseRegExp();
                return new A.Frame(A.Uri_parse(A.stringReplaceAllUnchecked(t1, t2, "")), null, null, frame.get$member());
            },
            $signature: 304
        };
        A.Trace_toString_closure0.prototype = {
            call$1: function(frame) {
                return frame.get$location().length;
            },
            $signature: 196
        };
        A.Trace_toString_closure.prototype = {
            call$1: function(frame) {
                if (frame instanceof A.UnparsedFrame) return frame.toString$0(0) + "\n";
                return B.JSString_methods.padRight$1(frame.get$location(), this.longest) + "  " + A.S(frame.get$member()) + "\n";
            },
            $signature: 197
        };
        A.UnparsedFrame.prototype = {
            toString$0: function(_) {
                return this.member;
            },
            $isFrame: 1,
            get$uri: function() {
                return this.uri;
            },
            get$line: function() {
                return null;
            },
            get$column: function() {
                return null;
            },
            get$isCore: function() {
                return false;
            },
            get$library: function() {
                return "unparsed";
            },
            get$$package: function() {
                return null;
            },
            get$location: function() {
                return "unparsed";
            },
            get$member: function() {
                return this.member;
            }
        };
        A.TransformByHandlers_transformByHandlers_closure.prototype = {
            call$0: function() {
                var t2, subscription, t3, t4, _this = this, t1 = {};
                t1.valuesDone = false;
                t2 = _this.controller;
                subscription = _this._this.listen$3$onDone$onError(0, new A.TransformByHandlers_transformByHandlers__closure(_this.onData, t2, _this.S), new A.TransformByHandlers_transformByHandlers__closure0(t1, _this.handleDone, t2), new A.TransformByHandlers_transformByHandlers__closure1(_this.handleError, t2));
                t3 = _this._box_1;
                t3.subscription = subscription;
                t2.set$onPause(subscription.get$pause(subscription));
                t4 = t3.subscription;
                t2.set$onResume(t4.get$resume(t4));
                t2.set$onCancel(new A.TransformByHandlers_transformByHandlers__closure2(t3, t1));
            },
            $signature: 0
        };
        A.TransformByHandlers_transformByHandlers__closure.prototype = {
            call$1: function(value) {
                return this.onData.call$2(value, this.controller);
            },
            $signature: function() {
                return this.S._eval$1("~(0)");
            }
        };
        A.TransformByHandlers_transformByHandlers__closure1.prototype = {
            call$2: function(error, stackTrace) {
                this.handleError.call$3(error, stackTrace, this.controller);
            },
            $signature: 51
        };
        A.TransformByHandlers_transformByHandlers__closure0.prototype = {
            call$0: function() {
                this._box_0.valuesDone = true;
                this.handleDone.call$1(this.controller);
            },
            $signature: 0
        };
        A.TransformByHandlers_transformByHandlers__closure2.prototype = {
            call$0: function() {
                var t1 = this._box_1, toCancel = t1.subscription;
                t1.subscription = null;
                if (!this._box_0.valuesDone) return toCancel.cancel$0();
                return null;
            },
            $signature: 226
        };
        A.RateLimit__debounceAggregate_closure.prototype = {
            call$2: function(value, sink) {
                var _this = this, t1 = _this._box_0, t2 = new A.RateLimit__debounceAggregate_closure_emit(t1, sink, _this.S), t3 = t1.timer;
                if (t3 != null) t3.cancel$0();
                t1.soFar = _this.collect.call$2(value, t1.soFar);
                t1.hasPending = true;
                if (t1.timer == null && _this.leading) {
                    t1.emittedLatestAsLeading = true;
                    t2.call$0();
                } else t1.emittedLatestAsLeading = false;
                t1.timer = A.Timer_Timer(_this.duration, new A.RateLimit__debounceAggregate__closure(t1, _this.trailing, t2, sink));
            },
            $signature: function() {
                return this.T._eval$1("@<0>")._bind$1(this.S)._eval$1("~(1,EventSink<2>)");
            }
        };
        A.RateLimit__debounceAggregate_closure_emit.prototype = {
            call$0: function() {
                var t1 = this._box_0, t2 = t1.soFar;
                if (t2 == null) t2 = this.S._as(t2);
                this.sink.add$1(0, t2);
                t1.soFar = null;
                t1.hasPending = false;
            },
            $signature: 0
        };
        A.RateLimit__debounceAggregate__closure.prototype = {
            call$0: function() {
                var t1 = this._box_0, t2 = t1.emittedLatestAsLeading;
                if (!t2) this.emit.call$0();
                if (t1.shouldClose) this.sink.close$0(0);
                t1.timer = null;
            },
            $signature: 0
        };
        A.RateLimit__debounceAggregate_closure0.prototype = {
            call$1: function(sink) {
                var t1 = this._box_0;
                if (t1.hasPending && this.trailing) t1.shouldClose = true;
                else {
                    t1 = t1.timer;
                    if (t1 != null) t1.cancel$0();
                    sink.close$0(0);
                }
            },
            $signature: function() {
                return this.S._eval$1("~(EventSink<0>)");
            }
        };
        A.StringScannerException.prototype = {
            get$source: function() {
                return A._asString(this.source);
            }
        };
        A.LineScanner.prototype = {
            scanChar$1: function(character) {
                if (!this.super$StringScanner$scanChar(character)) return false;
                this._adjustLineAndColumn$1(character);
                return true;
            },
            readChar$0: function() {
                var character = this.super$StringScanner$readChar();
                this._adjustLineAndColumn$1(character);
                return character;
            },
            _adjustLineAndColumn$1: function(character) {
                var t1, _this = this;
                if (character !== 10) t1 = character === 13 && _this.peekChar$0() !== 10;
                else t1 = true;
                if (t1) {
                    ++_this._line_scanner$_line;
                    _this._line_scanner$_column = 0;
                } else {
                    t1 = _this._line_scanner$_column;
                    _this._line_scanner$_column = t1 + (character >= 65536 && character <= 1114111 ? 2 : 1);
                }
            },
            scan$1: function(pattern) {
                var t1, newlines, t2, _this = this;
                if (!_this.super$StringScanner$scan(pattern)) return false;
                t1 = _this.get$lastMatch();
                newlines = _this._newlinesIn$2$endPosition(t1.pattern, _this._string_scanner$_position);
                t1 = _this._line_scanner$_line;
                t2 = newlines.length;
                _this._line_scanner$_line = t1 + t2;
                if (t2 === 0) {
                    t1 = _this._line_scanner$_column;
                    t2 = _this.get$lastMatch();
                    _this._line_scanner$_column = t1 + t2.pattern.length;
                } else {
                    t1 = _this.get$lastMatch();
                    t1 = t1.pattern;
                    t2 = B.JSArray_methods.get$last(newlines);
                    _this._line_scanner$_column = t1.length - t2.get$end(t2);
                }
                return true;
            },
            _newlinesIn$2$endPosition: function(text, endPosition) {
                var t1 = $.$get$_newlineRegExp().allMatches$1(0, text), newlines = A.List_List$_of(t1, A._instanceType(t1)._eval$1("Iterable.E"));
                t1 = this.string;
                if (endPosition < t1.length && B.JSString_methods.endsWith$1(text, "\r") && t1[endPosition] === "\n") newlines.pop();
                return newlines;
            }
        };
        A.SpanScanner.prototype = {
            set$state: function(state) {
                if (state._scanner !== this) throw A.wrapException(A.ArgumentError$("The given LineScannerState was not returned by this LineScanner.", null));
                this.set$position(state.position);
            },
            spanFrom$2: function(startState, endState) {
                var endPosition = endState == null ? this._string_scanner$_position : endState.position;
                return this._sourceFile.span$2(0, startState.position, endPosition);
            },
            spanFrom$1: function(startState) {
                return this.spanFrom$2(startState, null);
            },
            spanFromPosition$2: function(startPosition, endPosition) {
                var t1 = endPosition == null ? this._string_scanner$_position : endPosition;
                return this._sourceFile.span$2(0, startPosition, t1);
            },
            matches$1: function(pattern) {
                var t1, t2, _this = this;
                if (!_this.super$StringScanner$matches(pattern)) return false;
                t1 = _this._string_scanner$_position;
                t2 = _this.get$lastMatch();
                _this._sourceFile.span$2(0, t1, t2.start + t2.pattern.length);
                return true;
            },
            error$3$length$position: function(_, message, $length, position) {
                var match, t2, _this = this, t1 = _this.string;
                A.validateErrorArgs(t1, null, position, $length);
                match = position == null && $length == null ? _this.get$lastMatch() : null;
                if (position == null) position = match == null ? _this._string_scanner$_position : match.start;
                if ($length == null) {
                    if (match == null) $length = 0;
                    else {
                        t2 = match.start;
                        $length = t2 + match.pattern.length - t2;
                    }
                }
                throw A.wrapException(A.StringScannerException$(message, _this._sourceFile.span$2(0, position, position + $length), t1));
            },
            error$1: function(_, message) {
                return this.error$3$length$position(0, message, null, null);
            },
            error$2$position: function(_, message, position) {
                return this.error$3$length$position(0, message, null, position);
            },
            error$2$length: function(_, message, $length) {
                return this.error$3$length$position(0, message, $length, null);
            }
        };
        A._SpanScannerState.prototype = {};
        A.StringScanner.prototype = {
            set$position: function(position) {
                if (B.JSInt_methods.get$isNegative(position) || position > this.string.length) throw A.wrapException(A.ArgumentError$("Invalid position " + position, null));
                this._string_scanner$_position = position;
                this._lastMatch = null;
            },
            get$lastMatch: function() {
                var _this = this;
                if (_this._string_scanner$_position !== _this._lastMatchPosition) _this._lastMatch = null;
                return _this._lastMatch;
            },
            readChar$0: function() {
                var _this = this, t1 = _this.string;
                if (_this._string_scanner$_position === t1.length) _this._fail$1("more input");
                return t1.charCodeAt(_this._string_scanner$_position++);
            },
            peekChar$1: function(offset) {
                var index;
                if (offset == null) offset = 0;
                index = this._string_scanner$_position + offset;
                if (index < 0 || index >= this.string.length) return null;
                return this.string.charCodeAt(index);
            },
            peekChar$0: function() {
                return this.peekChar$1(null);
            },
            scanChar$1: function(character) {
                var t1, t2, t3, t4, _this = this;
                if (character >= 65536 && character <= 1114111) {
                    t1 = _this._string_scanner$_position;
                    t2 = t1 + 1;
                    t3 = _this.string;
                    if (t2 < t3.length) {
                        t4 = character - 65536;
                        t2 = t3.charCodeAt(t1) !== B.JSInt_methods._shrOtherPositive$1(t4, 10) + 55296 || t3.charCodeAt(t2) !== (t4 & 1023) + 56320;
                    } else t2 = true;
                    if (t2) return false;
                    else {
                        _this._string_scanner$_position = t1 + 2;
                        return true;
                    }
                } else {
                    t1 = _this._string_scanner$_position;
                    t2 = _this.string;
                    if (t1 === t2.length) return false;
                    if (t2.charCodeAt(t1) !== character) return false;
                    _this._string_scanner$_position = t1 + 1;
                    return true;
                }
            },
            expectChar$2$name: function(character, $name) {
                if (this.scanChar$1(character)) return;
                if ($name == null) {
                    if (character === 92) $name = '"\\"';
                    else $name = character === 34 ? '"\\""' : '"' + A.Primitives_stringFromCharCode(character) + '"';
                }
                this._fail$1($name);
            },
            expectChar$1: function(character) {
                return this.expectChar$2$name(character, null);
            },
            scan$1: function(pattern) {
                var t1, _this = this, success = _this.matches$1(pattern);
                if (success) {
                    t1 = _this._lastMatch;
                    _this._lastMatchPosition = _this._string_scanner$_position = t1.start + t1.pattern.length;
                }
                return success;
            },
            expect$1: function(pattern) {
                var t1, $name;
                if (this.scan$1(pattern)) return;
                t1 = A.stringReplaceAllUnchecked(pattern, "\\", "\\\\");
                $name = '"' + A.stringReplaceAllUnchecked(t1, '"', '\\"') + '"';
                this._fail$1($name);
            },
            expectDone$0: function() {
                if (this._string_scanner$_position === this.string.length) return;
                this._fail$1("no more input");
            },
            matches$1: function(pattern) {
                var _this = this, t1 = B.JSString_methods.matchAsPrefix$2(pattern, _this.string, _this._string_scanner$_position);
                _this._lastMatch = t1;
                _this._lastMatchPosition = _this._string_scanner$_position;
                return t1 != null;
            },
            substring$1: function(_, start) {
                var end = this._string_scanner$_position;
                return B.JSString_methods.substring$2(this.string, start, end);
            },
            error$3$length$position: function(_, message, $length, position) {
                var match, t2, _this = this, t1 = _this.string;
                A.validateErrorArgs(t1, null, position, $length);
                match = position == null && $length == null ? _this.get$lastMatch() : null;
                if (position == null) position = match == null ? _this._string_scanner$_position : match.start;
                if ($length == null) {
                    if (match == null) $length = 0;
                    else {
                        t2 = match.start;
                        $length = t2 + match.pattern.length - t2;
                    }
                }
                throw A.wrapException(A.StringScannerException$(message, A.SourceFile$fromString(t1, _this.sourceUrl).span$2(0, position, position + $length), t1));
            },
            error$1: function(_, message) {
                return this.error$3$length$position(0, message, null, null);
            },
            _fail$1: function($name) {
                this.error$3$length$position(0, "expected " + $name + ".", 0, this._string_scanner$_position);
            }
        };
        A.AsciiGlyphSet.prototype = {
            glyphOrAscii$2: function(glyph, alternative) {
                return alternative;
            },
            get$horizontalLine: function() {
                return "-";
            },
            get$verticalLine: function() {
                return "|";
            },
            get$topLeftCorner: function() {
                return ",";
            },
            get$bottomLeftCorner: function() {
                return "'";
            },
            get$cross: function() {
                return "+";
            },
            get$upEnd: function() {
                return "'";
            },
            get$downEnd: function() {
                return ",";
            },
            get$horizontalLineBold: function() {
                return "=";
            }
        };
        A.UnicodeGlyphSet.prototype = {
            glyphOrAscii$2: function(glyph, alternative) {
                return glyph;
            },
            get$horizontalLine: function() {
                return "\u2500";
            },
            get$verticalLine: function() {
                return "\u2502";
            },
            get$topLeftCorner: function() {
                return "\u250c";
            },
            get$bottomLeftCorner: function() {
                return "\u2514";
            },
            get$cross: function() {
                return "\u253c";
            },
            get$upEnd: function() {
                return "\u2575";
            },
            get$downEnd: function() {
                return "\u2577";
            },
            get$horizontalLineBold: function() {
                return "\u2501";
            }
        };
        A.WatchEvent.prototype = {
            toString$0: function(_) {
                return this.type.toString$0(0) + " " + this.path;
            }
        };
        A.ChangeType.prototype = {
            toString$0: function(_) {
                return this._watch_event$_name;
            }
        };
        A.A98RgbColorSpace0.prototype = {
            get$isBoundedInternal: function() {
                return true;
            },
            toLinear$1: function(channel) {
                return J.get$sign$in(channel) * Math.pow(Math.abs(channel), 2.19921875);
            },
            fromLinear$1: function(channel) {
                return J.get$sign$in(channel) * Math.pow(Math.abs(channel), 0.4547069271758437);
            },
            transformationMatrix$1: function(dest) {
                var t1;
                $label0$0: {
                    if (B.SrgbLinearColorSpace_kUj0 === dest || B.SrgbColorSpace_thf0 === dest || B.RgbColorSpace_i0P0 === dest) {
                        t1 = $.$get$linearA98RgbToLinearSrgb0();
                        break $label0$0;
                    }
                    if (B.DisplayP3ColorSpace_MmT0 === dest || B.DisplayP3LinearColorSpace_PrP0 === dest) {
                        t1 = $.$get$linearA98RgbToLinearDisplayP30();
                        break $label0$0;
                    }
                    if (B.ProphotoRgbColorSpace_BDz0 === dest) {
                        t1 = $.$get$linearA98RgbToLinearProphotoRgb0();
                        break $label0$0;
                    }
                    if (B.Rec2020ColorSpace_6oo0 === dest) {
                        t1 = $.$get$linearA98RgbToLinearRec20200();
                        break $label0$0;
                    }
                    if (B.XyzD65ColorSpace_WiJ0 === dest) {
                        t1 = $.$get$linearA98RgbToXyzD650();
                        break $label0$0;
                    }
                    if (B.XyzD50ColorSpace_2OB0 === dest) {
                        t1 = $.$get$linearA98RgbToXyzD500();
                        break $label0$0;
                    }
                    if (B.LmsColorSpace_Os30 === dest) {
                        t1 = $.$get$linearA98RgbToLms0();
                        break $label0$0;
                    }
                    t1 = this.super$ColorSpace$transformationMatrix0(dest);
                    break $label0$0;
                }
                return t1;
            }
        };
        A.AnySelectorVisitor0.prototype = {
            visitComplexSelector$1: function(complex) {
                return B.JSArray_methods.any$1(complex.components, new A.AnySelectorVisitor_visitComplexSelector_closure0(this));
            },
            visitCompoundSelector$1: function(compound) {
                return B.JSArray_methods.any$1(compound.components, new A.AnySelectorVisitor_visitCompoundSelector_closure0(this));
            },
            visitPseudoSelector$1: function(_, pseudo) {
                var selector = pseudo.selector;
                return selector == null ? false : this.visitSelectorList$1(selector);
            },
            visitSelectorList$1: function(list) {
                return B.JSArray_methods.any$1(list.components, this.get$visitComplexSelector());
            },
            visitAttributeSelector$1: function(_, attribute) {
                return false;
            },
            visitClassSelector$1: function(_, klass) {
                return false;
            },
            visitIDSelector$1: function(_, id) {
                return false;
            },
            visitParentSelector$1: function(_, $parent) {
                return false;
            },
            visitPlaceholderSelector$1: function(_, placeholder) {
                return false;
            },
            visitTypeSelector$1: function(_, type) {
                return false;
            },
            visitUniversalSelector$1: function(_, universal) {
                return false;
            }
        };
        A.AnySelectorVisitor_visitComplexSelector_closure0.prototype = {
            call$1: function(component) {
                return this.$this.visitCompoundSelector$1(component.selector);
            },
            $signature: 55
        };
        A.AnySelectorVisitor_visitCompoundSelector_closure0.prototype = {
            call$1: function(simple) {
                return simple.accept$1(this.$this);
            },
            $signature: 15
        };
        A.SupportsAnything0.prototype = {
            toInterpolation$0: function() {
                var t1 = new A.StringBuffer(""), t2 = new A.InterpolationBuffer0(t1, A._setArrayType([], type$.JSArray_Object), A._setArrayType([], type$.JSArray_nullable_FileSpan)), t3 = this.span, t4 = this.contents, t5 = t4.span, t6 = A.SpanExtensions_before(t3, t5);
                t6 = A.String_String$fromCharCodes(B.NativeUint32List_methods.sublist$2(t6.file._decodedChars, t6._file$_start, t6._end), 0, null);
                t1._contents += t6;
                t2.addInterpolation$1(t4);
                t5 = A.SpanExtensions_after(t3, t5);
                t5 = A.String_String$fromCharCodes(B.NativeUint32List_methods.sublist$2(t5.file._decodedChars, t5._file$_start, t5._end), 0, null);
                t1._contents += t5;
                return t2.interpolation$1(t3);
            },
            withSpan$1: function(span) {
                return new A.SupportsAnything0(this.contents, span);
            },
            toString$0: function(_) {
                return "(" + this.contents.toString$0(0) + ")";
            },
            $isAstNode0: 1,
            $isSassNode: 1,
            $isSupportsCondition: 1,
            get$span: function(receiver) {
                return this.span;
            }
        };
        A.ArgumentList0.prototype = {
            get$isEmpty: function(_) {
                var t1;
                if (this.positional.length === 0) {
                    t1 = this.named;
                    t1 = t1.get$isEmpty(t1) && this.rest == null;
                } else t1 = false;
                return t1;
            },
            toString$0: function(_) {
                var t2, t3, _i, _1_0, _2_0, _this = this, t1 = A._setArrayType([], type$.JSArray_String);
                for(t2 = _this.positional, t3 = t2.length, _i = 0; _i < t3; ++_i)t1.push(_this._argument_list0$_parenthesizeArgument$1(t2[_i]));
                for(t2 = A.MapExtensions_get_pairs0(_this.named, type$.String, type$.Expression_2), t2 = t2.get$iterator(t2); t2.moveNext$0();){
                    t3 = t2.get$current(t2);
                    t1.push("$" + t3._0 + ": " + _this._argument_list0$_parenthesizeArgument$1(t3._1));
                }
                _1_0 = _this.rest;
                if (_1_0 != null) t1.push(_this._argument_list0$_parenthesizeArgument$1(_1_0) + "...");
                _2_0 = _this.keywordRest;
                if (_2_0 != null) t1.push(_this._argument_list0$_parenthesizeArgument$1(_2_0) + "...");
                return "(" + B.JSArray_methods.join$1(t1, ", ") + ")";
            },
            _argument_list0$_parenthesizeArgument$1: function(argument) {
                var t1;
                $label0$0: {
                    if (argument instanceof A.ListExpression0 && B.ListSeparator_z0K0 === argument.separator && !argument.hasBrackets && argument.contents.length >= 2) {
                        t1 = "(" + argument.toString$0(0) + ")";
                        break $label0$0;
                    }
                    t1 = argument.toString$0(0);
                    break $label0$0;
                }
                return t1;
            },
            $isAstNode0: 1,
            $isSassNode: 1,
            get$span: function(receiver) {
                return this.span;
            }
        };
        A.argumentListClass_closure.prototype = {
            call$0: function() {
                var t1 = type$.JSClass, jsClass = t1._as(A.allowInteropCaptureThisNamed("sass.SassArgumentList", new A.argumentListClass__closure()));
                A.defineGetter(J.get$$prototype$x(jsClass), "keywords", new A.argumentListClass__closure0(), null);
                A.JSClassExtension_injectSuperclass(t1._as(A.SassArgumentList$0(A._setArrayType([], type$.JSArray_Value_2), A.LinkedHashMap_LinkedHashMap$_empty(type$.String, type$.Value_2), B.ListSeparator_undecided_null_3_undecided0).constructor), jsClass);
                return jsClass;
            },
            $signature: 17
        };
        A.argumentListClass__closure.prototype = {
            call$4: function($self, contents, keywords, separator) {
                var t3, t1 = self.immutable.isOrderedMap(contents) ? J.toArray$0$x(type$.ImmutableList._as(contents)) : type$.List_dynamic._as(contents), t2 = type$.Value_2;
                t1 = J.cast$1$0$ax(t1, t2);
                t3 = self.immutable.isOrderedMap(keywords) ? A.immutableMapToDartMap(type$.ImmutableMap._as(keywords)) : A.objectToMap(keywords);
                return A.SassArgumentList$0(t1, t3.cast$2$0(0, type$.String, t2), A.jsToDartSeparator(separator));
            },
            call$3: function($self, contents, keywords) {
                return this.call$4($self, contents, keywords, ",");
            },
            "call*": "call$4",
            $requiredArgCount: 3,
            $defaultValues: function() {
                return [
                    ","
                ];
            },
            $signature: 309
        };
        A.argumentListClass__closure0.prototype = {
            call$1: function($self) {
                $self._argument_list$_wereKeywordsAccessed = true;
                return A.dartMapToImmutableMap($self._argument_list$_keywords);
            },
            $signature: 310
        };
        A.SassArgumentList0.prototype = {};
        A.JSArray1.prototype = {};
        A.AsyncImporter0.prototype = {
            isNonCanonicalScheme$1: function(scheme) {
                return false;
            }
        };
        A.JSToDartAsyncImporter.prototype = {
            canonicalize$1: function(_, url) {
                return this.canonicalize$body$JSToDartAsyncImporter(0, url);
            },
            canonicalize$body$JSToDartAsyncImporter: function(_, url) {
                var $async$goto = 0, $async$completer = A._makeAsyncAwaitCompleter(type$.nullable_Uri), $async$returnValue, $async$self = this, t1, result;
                var $async$canonicalize$1 = A._wrapJsFunctionForAsync(function($async$errorCode, $async$result) {
                    if ($async$errorCode === 1) return A._asyncRethrow($async$result, $async$completer);
                    for(;;)switch($async$goto){
                        case 0:
                            // Function start
                            result = A.wrapJSExceptions(new A.JSToDartAsyncImporter_canonicalize_closure($async$self, url));
                            $async$goto = result != null && result instanceof self.Promise ? 3 : 4;
                            break;
                        case 3:
                            // then
                            $async$goto = 5;
                            return A._asyncAwait(A.promiseToFuture0(type$.Promise._as(result), type$.nullable_Object), $async$canonicalize$1);
                        case 5:
                            // returning from await.
                            result = $async$result;
                        case 4:
                            // join
                            if (result == null) {
                                $async$returnValue = null;
                                // goto return
                                $async$goto = 1;
                                break;
                            }
                            t1 = self.URL;
                            if (result instanceof t1) {
                                $async$returnValue = A.Uri_parse(J.toString$0$(type$.JSUrl._as(result)));
                                // goto return
                                $async$goto = 1;
                                break;
                            }
                            A.jsThrow(new self.Error(string$.The_ca));
                        case 1:
                            // return
                            return A._asyncReturn($async$returnValue, $async$completer);
                    }
                });
                return A._asyncStartSync($async$canonicalize$1, $async$completer);
            },
            load$1: function(_, url) {
                return this.load$body$JSToDartAsyncImporter(0, url);
            },
            load$body$JSToDartAsyncImporter: function(_, url) {
                var $async$goto = 0, $async$completer = A._makeAsyncAwaitCompleter(type$.nullable_ImporterResult_2), $async$returnValue, $async$self = this, t1, contents, syntax, t2, result;
                var $async$load$1 = A._wrapJsFunctionForAsync(function($async$errorCode, $async$result) {
                    if ($async$errorCode === 1) return A._asyncRethrow($async$result, $async$completer);
                    for(;;)switch($async$goto){
                        case 0:
                            // Function start
                            result = A.wrapJSExceptions(new A.JSToDartAsyncImporter_load_closure($async$self, url));
                            $async$goto = result != null && result instanceof self.Promise ? 3 : 4;
                            break;
                        case 3:
                            // then
                            $async$goto = 5;
                            return A._asyncAwait(A.promiseToFuture0(type$.Promise._as(result), type$.nullable_Object), $async$load$1);
                        case 5:
                            // returning from await.
                            result = $async$result;
                        case 4:
                            // join
                            if (result == null) {
                                $async$returnValue = null;
                                // goto return
                                $async$goto = 1;
                                break;
                            }
                            type$.JSImporterResult._as(result);
                            t1 = J.getInterceptor$x(result);
                            contents = t1.get$contents(result);
                            if (A._asString(new self.Function("value", "return typeof value").call$1(contents)) !== "string") A.jsThrow(new A.ArgumentError(true, contents, "contents", "must be a string but was: " + A.jsType(contents)));
                            syntax = t1.get$syntax(result);
                            if (contents == null || syntax == null) A.jsThrow(new self.Error(string$.The_lo));
                            t2 = A.parseSyntax(syntax);
                            $async$returnValue = A.ImporterResult$(contents, A.NullableExtension_andThen0(t1.get$sourceMapUrl(result), A.utils3__jsToDartUrl$closure()), t2);
                            // goto return
                            $async$goto = 1;
                            break;
                        case 1:
                            // return
                            return A._asyncReturn($async$returnValue, $async$completer);
                    }
                });
                return A._asyncStartSync($async$load$1, $async$completer);
            },
            isNonCanonicalScheme$1: function(scheme) {
                return this._nonCanonicalSchemes.contains$1(0, scheme);
            }
        };
        A.JSToDartAsyncImporter_canonicalize_closure.prototype = {
            call$0: function() {
                return this.$this._async0$_canonicalize.call$2(this.url.toString$0(0), A.canonicalizeContext0());
            },
            $signature: 36
        };
        A.JSToDartAsyncImporter_load_closure.prototype = {
            call$0: function() {
                return this.$this._load.call$1(new self.URL(this.url.toString$0(0)));
            },
            $signature: 36
        };
        A.AsyncBuiltInCallable0.prototype = {
            callbackFor$2: function(positional, names) {
                return new A._Record_2(this._async_built_in0$_parameters, this._async_built_in0$_callback);
            },
            withDeprecationWarning$1: function(module) {
                return new A.AsyncBuiltInCallable0(this.name, this._async_built_in0$_parameters, new A.AsyncBuiltInCallable_withDeprecationWarning_closure0(this, module, null), false);
            },
            $isAsyncCallable0: 1,
            get$name: function(receiver) {
                return this.name;
            },
            get$acceptsContent: function() {
                return this.acceptsContent;
            }
        };
        A.AsyncBuiltInCallable$mixin_closure0.prototype = {
            call$1: function($arguments) {
                return this.$call$body$AsyncBuiltInCallable$mixin_closure0($arguments);
            },
            $call$body$AsyncBuiltInCallable$mixin_closure0: function($arguments) {
                var $async$goto = 0, $async$completer = A._makeAsyncAwaitCompleter(type$.Value_2), $async$returnValue, $async$self = this, t1;
                var $async$call$1 = A._wrapJsFunctionForAsync(function($async$errorCode, $async$result) {
                    if ($async$errorCode === 1) return A._asyncRethrow($async$result, $async$completer);
                    for(;;)switch($async$goto){
                        case 0:
                            // Function start
                            t1 = $async$self.callback.call$1($arguments);
                            $async$goto = 3;
                            return A._asyncAwait(t1 instanceof A._Future ? t1 : A._Future$value(t1, type$.void), $async$call$1);
                        case 3:
                            // returning from await.
                            $async$returnValue = B.C__SassNull0;
                            // goto return
                            $async$goto = 1;
                            break;
                        case 1:
                            // return
                            return A._asyncReturn($async$returnValue, $async$completer);
                    }
                });
                return A._asyncStartSync($async$call$1, $async$completer);
            },
            $signature: 92
        };
        A.AsyncBuiltInCallable_withDeprecationWarning_closure0.prototype = {
            call$1: function(args) {
                var t1 = this.$this;
                A.warnForDeprecation0(string$.Global + this.module + "." + t1.name + string$.x20inste, B.Deprecation_SGB);
                return t1._async_built_in0$_callback.call$1(args);
            },
            $signature: 313
        };
        A._compileStylesheet_closure2.prototype = {
            call$1: function(url) {
                var t1;
                if (url === "") {
                    t1 = this.stylesheet.span;
                    t1 = A.Uri_Uri$dataFromString(A.String_String$fromCharCodes(B.NativeUint32List_methods.sublist$2(t1.get$file(t1)._decodedChars, 0, null), 0, null), B.C_Utf8Codec, null).get$_text();
                } else t1 = this.importCache.sourceMapUrl$1(0, A.Uri_parse(url)).toString$0(0);
                return t1;
            },
            $signature: 6
        };
        A.AsyncEnvironment0.prototype = {
            closure$0: function() {
                var t4, t5, t6, _this = this, t1 = _this._async_environment0$_forwardedModules, t2 = _this._async_environment0$_nestedForwardedModules, t3 = _this._async_environment0$_variables;
                t3 = A._setArrayType(t3.slice(0), A._arrayInstanceType(t3));
                t4 = _this._async_environment0$_variableNodes;
                t4 = A._setArrayType(t4.slice(0), A._arrayInstanceType(t4));
                t5 = _this._async_environment0$_functions;
                t5 = A._setArrayType(t5.slice(0), A._arrayInstanceType(t5));
                t6 = _this._async_environment0$_mixins;
                t6 = A._setArrayType(t6.slice(0), A._arrayInstanceType(t6));
                return A.AsyncEnvironment$_0(_this._async_environment0$_modules, _this._async_environment0$_namespaceNodes, _this._async_environment0$_globalModules, _this._async_environment0$_importedModules, t1, t2, _this._async_environment0$_allModules, t3, t4, t5, t6, _this._async_environment0$_content, B.Set_empty1);
            },
            forwardModule$2: function(module, rule) {
                var view, t1, t2, _this = this, forwardedModules = _this._async_environment0$_forwardedModules;
                if (forwardedModules == null) forwardedModules = _this._async_environment0$_forwardedModules = A.LinkedHashMap_LinkedHashMap$_empty(type$.Module_AsyncCallable_2, type$.AstNode_2);
                view = A.ForwardedModuleView_ifNecessary0(module, rule, type$.AsyncCallable_2);
                for(t1 = new A.LinkedHashMapKeyIterator(forwardedModules, forwardedModules._modifications, forwardedModules._first); t1.moveNext$0();){
                    t2 = t1.__js_helper$_current;
                    _this._async_environment0$_assertNoConflicts$5(view.get$variables(), t2.get$variables(), view, t2, "variable");
                    _this._async_environment0$_assertNoConflicts$5(view.get$functions(view), t2.get$functions(t2), view, t2, "function");
                    _this._async_environment0$_assertNoConflicts$5(view.get$mixins(), t2.get$mixins(), view, t2, "mixin");
                }
                _this._async_environment0$_allModules.push(module);
                forwardedModules.$indexSet(0, view, rule);
            },
            _async_environment0$_assertNoConflicts$5: function(newMembers, oldMembers, newModule, oldModule, type) {
                var larger, smaller, t1, t2, t3, t4, $name, small, large, span;
                if (newMembers.get$length(newMembers) < oldMembers.get$length(oldMembers)) {
                    larger = oldMembers;
                    smaller = newMembers;
                } else {
                    larger = newMembers;
                    smaller = oldMembers;
                }
                for(t1 = type$.String, t2 = A.MapExtensions_get_pairs0(smaller, t1, type$.Object), t2 = t2.get$iterator(t2), t3 = type === "variable"; t2.moveNext$0();){
                    t4 = t2.get$current(t2);
                    $name = t4._0;
                    small = t4._1;
                    large = larger.$index(0, $name);
                    if (large == null) continue;
                    if (t3 ? newModule.variableIdentity$1($name) === oldModule.variableIdentity$1($name) : J.$eq$(large, small)) continue;
                    if (t3) $name = "$" + $name;
                    t2 = this._async_environment0$_forwardedModules;
                    if (t2 == null) span = null;
                    else {
                        t2 = t2.$index(0, oldModule);
                        span = t2 == null ? null : t2.get$span(t2);
                    }
                    t2 = A.LinkedHashMap_LinkedHashMap$_empty(type$.FileSpan, t1);
                    if (span != null) t2.$indexSet(0, span, "original @forward");
                    throw A.wrapException(A.MultiSpanSassScriptException$0("Two forwarded modules both define a " + type + " named " + $name + ".", "new @forward", t2));
                }
            },
            importForwards$1: function(module) {
                var forwardedModules, t1, t2, t3, t4, node, t5, t6, t7, t8, t9, t10, _i, t11, shadowed, t12, t13, _length, _list, _this = this, forwarded = module._async_environment0$_environment._async_environment0$_forwardedModules;
                if (forwarded == null) return;
                forwardedModules = _this._async_environment0$_forwardedModules;
                if (forwardedModules != null) {
                    t1 = type$.Module_AsyncCallable_2;
                    t2 = type$.AstNode_2;
                    t3 = A.LinkedHashMap_LinkedHashMap$_empty(t1, t2);
                    for(t1 = A.MapExtensions_get_pairs0(forwarded, t1, t2), t1 = t1.get$iterator(t1), t2 = _this._async_environment0$_globalModules; t1.moveNext$0();){
                        t4 = t1.get$current(t1);
                        module = t4._0;
                        node = t4._1;
                        if (!forwardedModules.containsKey$1(module) || !t2.containsKey$1(module)) t3.$indexSet(0, module, node);
                    }
                    forwarded = t3;
                } else forwardedModules = _this._async_environment0$_forwardedModules = A.LinkedHashMap_LinkedHashMap$_empty(type$.Module_AsyncCallable_2, type$.AstNode_2);
                t1 = type$.String;
                t2 = A.LinkedHashSet_LinkedHashSet$_empty(t1);
                for(t3 = new A.LinkedHashMapKeyIterator(forwarded, forwarded._modifications, forwarded._first); t3.moveNext$0();)for(t4 = t3.__js_helper$_current.get$variables(), t4 = t4.get$keys(t4), t4 = t4.get$iterator(t4); t4.moveNext$0();)t2.add$1(0, t4.get$current(t4));
                t3 = A.LinkedHashSet_LinkedHashSet$_empty(t1);
                for(t4 = new A.LinkedHashMapKeyIterator(forwarded, forwarded._modifications, forwarded._first); t4.moveNext$0();){
                    t5 = t4.__js_helper$_current;
                    for(t5 = t5.get$functions(t5), t5 = t5.get$keys(t5), t5 = t5.get$iterator(t5); t5.moveNext$0();)t3.add$1(0, t5.get$current(t5));
                }
                t1 = A.LinkedHashSet_LinkedHashSet$_empty(t1);
                for(t4 = new A.LinkedHashMapKeyIterator(forwarded, forwarded._modifications, forwarded._first); t4.moveNext$0();)for(t5 = t4.__js_helper$_current.get$mixins(), t5 = t5.get$keys(t5), t5 = t5.get$iterator(t5); t5.moveNext$0();)t1.add$1(0, t5.get$current(t5));
                t4 = _this._async_environment0$_variables;
                t5 = t4.length;
                if (t5 === 1) {
                    for(t5 = _this._async_environment0$_importedModules, t6 = type$.Module_AsyncCallable_2, t7 = type$.AstNode_2, t8 = A.MapExtensions_get_pairs0(t5, t6, t7).toList$0(0), t9 = t8.length, t10 = type$.AsyncCallable_2, _i = 0; _i < t8.length; t8.length === t9 || (0, A.throwConcurrentModificationError)(t8), ++_i){
                        t11 = t8[_i];
                        module = t11._0;
                        shadowed = A.ShadowedModuleView_ifNecessary0(module, t3, t1, t2, t10);
                        if (shadowed != null) {
                            t5.remove$1(0, module);
                            t12 = shadowed.variables;
                            t13 = false;
                            if (t12.get$isEmpty(t12)) {
                                t12 = shadowed.functions;
                                if (t12.get$isEmpty(t12)) {
                                    t12 = shadowed.mixins;
                                    if (t12.get$isEmpty(t12)) {
                                        t12 = shadowed._shadowed_view0$_inner;
                                        t12 = t12.get$css(t12);
                                        t12 = J.get$isEmpty$asx(t12.get$children(t12));
                                    } else t12 = t13;
                                } else t12 = t13;
                            } else t12 = t13;
                            if (!t12) t5.$indexSet(0, shadowed, t11._1);
                        }
                    }
                    for(t6 = A.MapExtensions_get_pairs0(forwardedModules, t6, t7).toList$0(0), t7 = t6.length, _i = 0; _i < t6.length; t6.length === t7 || (0, A.throwConcurrentModificationError)(t6), ++_i){
                        t8 = t6[_i];
                        module = t8._0;
                        shadowed = A.ShadowedModuleView_ifNecessary0(module, t3, t1, t2, t10);
                        if (shadowed != null) {
                            forwardedModules.remove$1(0, module);
                            t9 = shadowed.variables;
                            t11 = false;
                            if (t9.get$isEmpty(t9)) {
                                t9 = shadowed.functions;
                                if (t9.get$isEmpty(t9)) {
                                    t9 = shadowed.mixins;
                                    if (t9.get$isEmpty(t9)) {
                                        t9 = shadowed._shadowed_view0$_inner;
                                        t9 = t9.get$css(t9);
                                        t9 = J.get$isEmpty$asx(t9.get$children(t9));
                                    } else t9 = t11;
                                } else t9 = t11;
                            } else t9 = t11;
                            if (!t9) forwardedModules.$indexSet(0, shadowed, t8._1);
                        }
                    }
                    t5.addAll$1(0, forwarded);
                    forwardedModules.addAll$1(0, forwarded);
                } else {
                    t6 = _this._async_environment0$_nestedForwardedModules;
                    if (t6 == null) {
                        _length = t5 - 1;
                        _list = J.JSArray_JSArray$allocateGrowable(_length, type$.List_Module_AsyncCallable_2);
                        for(t5 = type$.JSArray_Module_AsyncCallable_2, _i = 0; _i < _length; ++_i)_list[_i] = A._setArrayType([], t5);
                        _this._async_environment0$_nestedForwardedModules = _list;
                        t5 = _list;
                    } else t5 = t6;
                    B.JSArray_methods.addAll$1(B.JSArray_methods.get$last(t5), new A.LinkedHashMapKeysIterable(forwarded, A._instanceType(forwarded)._eval$1("LinkedHashMapKeysIterable<1>")));
                }
                for(t2 = A._LinkedHashSetIterator$(t2, t2._collection$_modifications, t2.$ti._precomputed1), t5 = _this._async_environment0$_variableIndices, t6 = _this._async_environment0$_variableNodes, t7 = t2.$ti._precomputed1; t2.moveNext$0();){
                    t8 = t2._collection$_current;
                    if (t8 == null) t8 = t7._as(t8);
                    t5.remove$1(0, t8);
                    B.JSArray_methods.get$last(t4).remove$1(0, t8);
                    B.JSArray_methods.get$last(t6).remove$1(0, t8);
                }
                for(t2 = A._LinkedHashSetIterator$(t3, t3._collection$_modifications, t3.$ti._precomputed1), t3 = _this._async_environment0$_functionIndices, t4 = _this._async_environment0$_functions, t5 = t2.$ti._precomputed1; t2.moveNext$0();){
                    t6 = t2._collection$_current;
                    if (t6 == null) t6 = t5._as(t6);
                    t3.remove$1(0, t6);
                    B.JSArray_methods.get$last(t4).remove$1(0, t6);
                }
                for(t1 = A._LinkedHashSetIterator$(t1, t1._collection$_modifications, t1.$ti._precomputed1), t2 = _this._async_environment0$_mixinIndices, t3 = _this._async_environment0$_mixins, t4 = t1.$ti._precomputed1; t1.moveNext$0();){
                    t5 = t1._collection$_current;
                    if (t5 == null) t5 = t4._as(t5);
                    t2.remove$1(0, t5);
                    B.JSArray_methods.get$last(t3).remove$1(0, t5);
                }
            },
            getVariable$2$namespace: function($name, namespace) {
                var t1, _0_0, _1_0, _this = this;
                if (namespace != null) return _this._async_environment0$_getModule$1(namespace).get$variables().$index(0, $name);
                if (_this._async_environment0$_lastVariableName === $name) {
                    t1 = _this._async_environment0$_lastVariableIndex;
                    t1.toString;
                    t1 = _this._async_environment0$_variables[t1].$index(0, $name);
                    return t1 == null ? _this._async_environment0$_getVariableFromGlobalModule$1($name) : t1;
                }
                t1 = _this._async_environment0$_variableIndices;
                _0_0 = t1.$index(0, $name);
                if (_0_0 != null) {
                    _this._async_environment0$_lastVariableName = $name;
                    _this._async_environment0$_lastVariableIndex = _0_0;
                    t1 = _this._async_environment0$_variables[_0_0].$index(0, $name);
                    return t1 == null ? _this._async_environment0$_getVariableFromGlobalModule$1($name) : t1;
                } else {
                    _1_0 = _this._async_environment0$_variableIndex$1($name);
                    if (_1_0 != null) {
                        _this._async_environment0$_lastVariableName = $name;
                        _this._async_environment0$_lastVariableIndex = _1_0;
                        t1.$indexSet(0, $name, _1_0);
                        t1 = _this._async_environment0$_variables[_1_0].$index(0, $name);
                        return t1 == null ? _this._async_environment0$_getVariableFromGlobalModule$1($name) : t1;
                    } else return _this._async_environment0$_getVariableFromGlobalModule$1($name);
                }
            },
            getVariable$1: function($name) {
                return this.getVariable$2$namespace($name, null);
            },
            _async_environment0$_getVariableFromGlobalModule$1: function($name) {
                return this._async_environment0$_fromOneModule$3($name, "variable", new A.AsyncEnvironment__getVariableFromGlobalModule_closure0($name));
            },
            getVariableNode$2$namespace: function($name, namespace) {
                var t1, _0_0, _1_0, _this = this;
                if (namespace != null) return _this._async_environment0$_getModule$1(namespace).get$variableNodes().$index(0, $name);
                if (_this._async_environment0$_lastVariableName === $name) {
                    t1 = _this._async_environment0$_lastVariableIndex;
                    t1.toString;
                    t1 = _this._async_environment0$_variableNodes[t1].$index(0, $name);
                    return t1 == null ? _this._async_environment0$_getVariableNodeFromGlobalModule$1($name) : t1;
                }
                t1 = _this._async_environment0$_variableIndices;
                _0_0 = t1.$index(0, $name);
                if (_0_0 != null) {
                    _this._async_environment0$_lastVariableName = $name;
                    _this._async_environment0$_lastVariableIndex = _0_0;
                    t1 = _this._async_environment0$_variableNodes[_0_0].$index(0, $name);
                    return t1 == null ? _this._async_environment0$_getVariableNodeFromGlobalModule$1($name) : t1;
                } else {
                    _1_0 = _this._async_environment0$_variableIndex$1($name);
                    if (_1_0 != null) {
                        _this._async_environment0$_lastVariableName = $name;
                        _this._async_environment0$_lastVariableIndex = _1_0;
                        t1.$indexSet(0, $name, _1_0);
                        t1 = _this._async_environment0$_variableNodes[_1_0].$index(0, $name);
                        return t1 == null ? _this._async_environment0$_getVariableNodeFromGlobalModule$1($name) : t1;
                    } else return _this._async_environment0$_getVariableNodeFromGlobalModule$1($name);
                }
            },
            _async_environment0$_getVariableNodeFromGlobalModule$1: function($name) {
                var t1, t2, _0_0;
                for(t1 = this._async_environment0$_importedModules, t2 = this._async_environment0$_globalModules, t2 = new A.LinkedHashMapKeysIterable(t1, A._instanceType(t1)._eval$1("LinkedHashMapKeysIterable<1>")).followedBy$1(0, new A.LinkedHashMapKeysIterable(t2, A._instanceType(t2)._eval$1("LinkedHashMapKeysIterable<1>"))), t2 = new A.FollowedByIterator(J.get$iterator$ax(t2.__internal$_first), t2._second); t2.moveNext$0();){
                    t1 = t2._currentIterator;
                    _0_0 = t1.get$current(t1).get$variableNodes().$index(0, $name);
                    if (_0_0 != null) return _0_0;
                }
                return null;
            },
            globalVariableExists$2$namespace: function($name, namespace) {
                if (namespace != null) return this._async_environment0$_getModule$1(namespace).get$variables().containsKey$1($name);
                if (B.JSArray_methods.get$first(this._async_environment0$_variables).containsKey$1($name)) return true;
                return this._async_environment0$_getVariableFromGlobalModule$1($name) != null;
            },
            globalVariableExists$1: function($name) {
                return this.globalVariableExists$2$namespace($name, null);
            },
            _async_environment0$_variableIndex$1: function($name) {
                var t1, i;
                for(t1 = this._async_environment0$_variables, i = t1.length - 1; i >= 0; --i)if (t1[i].containsKey$1($name)) return i;
                return null;
            },
            setVariable$5$global$namespace: function($name, value, nodeWithSpan, global, namespace) {
                var t1, moduleWithName, nestedForwardedModules, t2, t3, t4, t5, index, _this = this;
                if (namespace != null) {
                    _this._async_environment0$_getModule$1(namespace).setVariable$3($name, value, nodeWithSpan);
                    return;
                }
                if (global || _this._async_environment0$_variables.length === 1) {
                    _this._async_environment0$_variableIndices.putIfAbsent$2($name, new A.AsyncEnvironment_setVariable_closure2(_this, $name));
                    t1 = _this._async_environment0$_variables;
                    if (!B.JSArray_methods.get$first(t1).containsKey$1($name)) {
                        moduleWithName = _this._async_environment0$_fromOneModule$3($name, "variable", new A.AsyncEnvironment_setVariable_closure3($name));
                        if (moduleWithName != null) {
                            moduleWithName.setVariable$3($name, value, nodeWithSpan);
                            return;
                        }
                    }
                    B.JSArray_methods.get$first(t1).$indexSet(0, $name, value);
                    B.JSArray_methods.get$first(_this._async_environment0$_variableNodes).$indexSet(0, $name, nodeWithSpan);
                    return;
                }
                nestedForwardedModules = _this._async_environment0$_nestedForwardedModules;
                if (nestedForwardedModules != null && !_this._async_environment0$_variableIndices.containsKey$1($name) && _this._async_environment0$_variableIndex$1($name) == null) for(t1 = A._arrayInstanceType(nestedForwardedModules)._eval$1("ReversedListIterable<1>"), t2 = new A.ReversedListIterable(nestedForwardedModules, t1), t2 = new A.ListIterator(t2, t2.get$length(0), t1._eval$1("ListIterator<ListIterable.E>")), t1 = t1._eval$1("ListIterable.E"); t2.moveNext$0();){
                    t3 = t2.__internal$_current;
                    for(t3 = J.get$reversed$ax(t3 == null ? t1._as(t3) : t3), t4 = t3.$ti, t3 = new A.ListIterator(t3, t3.get$length(0), t4._eval$1("ListIterator<ListIterable.E>")), t4 = t4._eval$1("ListIterable.E"); t3.moveNext$0();){
                        t5 = t3.__internal$_current;
                        if (t5 == null) t5 = t4._as(t5);
                        if (t5.get$variables().containsKey$1($name)) {
                            t5.setVariable$3($name, value, nodeWithSpan);
                            return;
                        }
                    }
                }
                if (_this._async_environment0$_lastVariableName === $name) {
                    t1 = _this._async_environment0$_lastVariableIndex;
                    t1.toString;
                    index = t1;
                } else index = _this._async_environment0$_variableIndices.putIfAbsent$2($name, new A.AsyncEnvironment_setVariable_closure4(_this, $name));
                if (!_this._async_environment0$_inSemiGlobalScope && index === 0) {
                    index = _this._async_environment0$_variables.length - 1;
                    _this._async_environment0$_variableIndices.$indexSet(0, $name, index);
                }
                _this._async_environment0$_lastVariableName = $name;
                _this._async_environment0$_lastVariableIndex = index;
                _this._async_environment0$_variables[index].$indexSet(0, $name, value);
                _this._async_environment0$_variableNodes[index].$indexSet(0, $name, nodeWithSpan);
            },
            setVariable$4$global: function($name, value, nodeWithSpan, global) {
                return this.setVariable$5$global$namespace($name, value, nodeWithSpan, global, null);
            },
            setLocalVariable$3: function($name, value, nodeWithSpan) {
                var index, _this = this, t1 = _this._async_environment0$_variables, t2 = t1.length;
                _this._async_environment0$_lastVariableName = $name;
                index = _this._async_environment0$_lastVariableIndex = t2 - 1;
                _this._async_environment0$_variableIndices.$indexSet(0, $name, index);
                t1[index].$indexSet(0, $name, value);
                _this._async_environment0$_variableNodes[index].$indexSet(0, $name, nodeWithSpan);
            },
            getFunction$2$namespace: function($name, namespace) {
                var t1, _0_0, _1_0, _this = this;
                if (namespace != null) {
                    t1 = _this._async_environment0$_getModule$1(namespace);
                    return t1.get$functions(t1).$index(0, $name);
                }
                t1 = _this._async_environment0$_functionIndices;
                _0_0 = t1.$index(0, $name);
                if (_0_0 != null) {
                    t1 = _this._async_environment0$_functions[_0_0].$index(0, $name);
                    return t1 == null ? _this._async_environment0$_getFunctionFromGlobalModule$1($name) : t1;
                } else {
                    _1_0 = _this._async_environment0$_functionIndex$1($name);
                    if (_1_0 != null) {
                        t1.$indexSet(0, $name, _1_0);
                        t1 = _this._async_environment0$_functions[_1_0].$index(0, $name);
                        return t1 == null ? _this._async_environment0$_getFunctionFromGlobalModule$1($name) : t1;
                    } else return _this._async_environment0$_getFunctionFromGlobalModule$1($name);
                }
            },
            getFunction$1: function($name) {
                return this.getFunction$2$namespace($name, null);
            },
            _async_environment0$_getFunctionFromGlobalModule$1: function($name) {
                return this._async_environment0$_fromOneModule$3($name, "function", new A.AsyncEnvironment__getFunctionFromGlobalModule_closure0($name));
            },
            _async_environment0$_functionIndex$1: function($name) {
                var t1, i;
                for(t1 = this._async_environment0$_functions, i = t1.length - 1; i >= 0; --i)if (t1[i].containsKey$1($name)) return i;
                return null;
            },
            getMixin$2$namespace: function($name, namespace) {
                var t1, _0_0, _1_0, _this = this;
                if (namespace != null) return _this._async_environment0$_getModule$1(namespace).get$mixins().$index(0, $name);
                t1 = _this._async_environment0$_mixinIndices;
                _0_0 = t1.$index(0, $name);
                if (_0_0 != null) {
                    t1 = _this._async_environment0$_mixins[_0_0].$index(0, $name);
                    return t1 == null ? _this._async_environment0$_getMixinFromGlobalModule$1($name) : t1;
                } else {
                    _1_0 = _this._async_environment0$_mixinIndex$1($name);
                    if (_1_0 != null) {
                        t1.$indexSet(0, $name, _1_0);
                        t1 = _this._async_environment0$_mixins[_1_0].$index(0, $name);
                        return t1 == null ? _this._async_environment0$_getMixinFromGlobalModule$1($name) : t1;
                    } else return _this._async_environment0$_getMixinFromGlobalModule$1($name);
                }
            },
            _async_environment0$_getMixinFromGlobalModule$1: function($name) {
                return this._async_environment0$_fromOneModule$3($name, "mixin", new A.AsyncEnvironment__getMixinFromGlobalModule_closure0($name));
            },
            _async_environment0$_mixinIndex$1: function($name) {
                var t1, i;
                for(t1 = this._async_environment0$_mixins, i = t1.length - 1; i >= 0; --i)if (t1[i].containsKey$1($name)) return i;
                return null;
            },
            withContent$2: function($content, callback) {
                return this.withContent$body$AsyncEnvironment0($content, callback);
            },
            withContent$body$AsyncEnvironment0: function($content, callback) {
                var $async$goto = 0, $async$completer = A._makeAsyncAwaitCompleter(type$.void), $async$self = this, oldContent;
                var $async$withContent$2 = A._wrapJsFunctionForAsync(function($async$errorCode, $async$result) {
                    if ($async$errorCode === 1) return A._asyncRethrow($async$result, $async$completer);
                    for(;;)switch($async$goto){
                        case 0:
                            // Function start
                            oldContent = $async$self._async_environment0$_content;
                            $async$self._async_environment0$_content = $content;
                            $async$goto = 2;
                            return A._asyncAwait(callback.call$0(), $async$withContent$2);
                        case 2:
                            // returning from await.
                            $async$self._async_environment0$_content = oldContent;
                            // implicit return
                            return A._asyncReturn(null, $async$completer);
                    }
                });
                return A._asyncStartSync($async$withContent$2, $async$completer);
            },
            asMixin$1: function(callback) {
                var $async$goto = 0, $async$completer = A._makeAsyncAwaitCompleter(type$.void), $async$self = this, oldInMixin;
                var $async$asMixin$1 = A._wrapJsFunctionForAsync(function($async$errorCode, $async$result) {
                    if ($async$errorCode === 1) return A._asyncRethrow($async$result, $async$completer);
                    for(;;)switch($async$goto){
                        case 0:
                            // Function start
                            oldInMixin = $async$self._async_environment0$_inMixin;
                            $async$self._async_environment0$_inMixin = true;
                            $async$goto = 2;
                            return A._asyncAwait(callback.call$0(), $async$asMixin$1);
                        case 2:
                            // returning from await.
                            $async$self._async_environment0$_inMixin = oldInMixin;
                            // implicit return
                            return A._asyncReturn(null, $async$completer);
                    }
                });
                return A._asyncStartSync($async$asMixin$1, $async$completer);
            },
            scope$1$3$semiGlobal$when: function(callback, semiGlobal, when, $T) {
                return this.scope$body$AsyncEnvironment0(callback, semiGlobal, when, $T, $T);
            },
            scope$1$1: function(callback, $T) {
                return this.scope$1$3$semiGlobal$when(callback, false, true, $T);
            },
            scope$1$2$when: function(callback, when, $T) {
                return this.scope$1$3$semiGlobal$when(callback, false, when, $T);
            },
            scope$1$2$semiGlobal: function(callback, semiGlobal, $T) {
                return this.scope$1$3$semiGlobal$when(callback, semiGlobal, true, $T);
            },
            scope$body$AsyncEnvironment0: function(callback, semiGlobal, when, $T, $async$type) {
                var $async$goto = 0, $async$completer = A._makeAsyncAwaitCompleter($async$type), $async$returnValue, $async$handler = 2, $async$errorStack = [], $async$next = [], $async$self = this, wasInSemiGlobalScope, $name, name0, name1, t1, t2, t3, t4, t5, t6;
                var $async$scope$1$3$semiGlobal$when = A._wrapJsFunctionForAsync(function($async$errorCode, $async$result) {
                    if ($async$errorCode === 1) {
                        $async$errorStack.push($async$result);
                        $async$goto = $async$handler;
                    }
                    for(;;)switch($async$goto){
                        case 0:
                            // Function start
                            semiGlobal = semiGlobal && $async$self._async_environment0$_inSemiGlobalScope;
                            wasInSemiGlobalScope = $async$self._async_environment0$_inSemiGlobalScope;
                            $async$self._async_environment0$_inSemiGlobalScope = semiGlobal;
                            $async$goto = !when ? 3 : 4;
                            break;
                        case 3:
                            // then
                            $async$handler = 5;
                            $async$goto = 8;
                            return A._asyncAwait(callback.call$0(), $async$scope$1$3$semiGlobal$when);
                        case 8:
                            // returning from await.
                            t1 = $async$result;
                            $async$returnValue = t1;
                            $async$next = [
                                1
                            ];
                            // goto finally
                            $async$goto = 6;
                            break;
                        case 5:
                            // uncaught
                            $async$next = [
                                2
                            ];
                        case 6:
                            // finally
                            $async$handler = 2;
                            $async$self._async_environment0$_inSemiGlobalScope = wasInSemiGlobalScope;
                            // goto the next finally handler
                            $async$goto = $async$next.pop();
                            break;
                        case 7:
                        // after finally
                        case 4:
                            // join
                            t1 = $async$self._async_environment0$_variables;
                            t2 = type$.String;
                            B.JSArray_methods.add$1(t1, A.LinkedHashMap_LinkedHashMap$_empty(t2, type$.Value_2));
                            t3 = $async$self._async_environment0$_variableNodes;
                            B.JSArray_methods.add$1(t3, A.LinkedHashMap_LinkedHashMap$_empty(t2, type$.AstNode_2));
                            t4 = $async$self._async_environment0$_functions;
                            t5 = type$.AsyncCallable_2;
                            B.JSArray_methods.add$1(t4, A.LinkedHashMap_LinkedHashMap$_empty(t2, t5));
                            t6 = $async$self._async_environment0$_mixins;
                            B.JSArray_methods.add$1(t6, A.LinkedHashMap_LinkedHashMap$_empty(t2, t5));
                            t5 = $async$self._async_environment0$_nestedForwardedModules;
                            if (t5 != null) t5.push(A._setArrayType([], type$.JSArray_Module_AsyncCallable_2));
                            $async$handler = 9;
                            $async$goto = 12;
                            return A._asyncAwait(callback.call$0(), $async$scope$1$3$semiGlobal$when);
                        case 12:
                            // returning from await.
                            t2 = $async$result;
                            $async$returnValue = t2;
                            $async$next = [
                                1
                            ];
                            // goto finally
                            $async$goto = 10;
                            break;
                        case 9:
                            // uncaught
                            $async$next = [
                                2
                            ];
                        case 10:
                            // finally
                            $async$handler = 2;
                            $async$self._async_environment0$_inSemiGlobalScope = wasInSemiGlobalScope;
                            $async$self._async_environment0$_lastVariableIndex = $async$self._async_environment0$_lastVariableName = null;
                            for(t1 = B.JSArray_methods.removeLast$0(t1), t1 = t1.get$keys(t1), t1 = t1.get$iterator(t1), t2 = $async$self._async_environment0$_variableIndices; t1.moveNext$0();){
                                $name = t1.get$current(t1);
                                t2.remove$1(0, $name);
                            }
                            B.JSArray_methods.removeLast$0(t3);
                            for(t1 = B.JSArray_methods.removeLast$0(t4), t1 = t1.get$keys(t1), t1 = t1.get$iterator(t1), t2 = $async$self._async_environment0$_functionIndices; t1.moveNext$0();){
                                name0 = t1.get$current(t1);
                                t2.remove$1(0, name0);
                            }
                            for(t1 = B.JSArray_methods.removeLast$0(t6), t1 = t1.get$keys(t1), t1 = t1.get$iterator(t1), t2 = $async$self._async_environment0$_mixinIndices; t1.moveNext$0();){
                                name1 = t1.get$current(t1);
                                t2.remove$1(0, name1);
                            }
                            t1 = $async$self._async_environment0$_nestedForwardedModules;
                            if (t1 != null) t1.pop();
                            // goto the next finally handler
                            $async$goto = $async$next.pop();
                            break;
                        case 11:
                        // after finally
                        case 1:
                            // return
                            return A._asyncReturn($async$returnValue, $async$completer);
                        case 2:
                            // rethrow
                            return A._asyncRethrow($async$errorStack.at(-1), $async$completer);
                    }
                });
                return A._asyncStartSync($async$scope$1$3$semiGlobal$when, $async$completer);
            },
            toImplicitConfiguration$0: function() {
                var t2, t3, t4, t5, t6, i, modules, t7, t8, t9, t10, $name, value, values, nodes, _this = this, _null = null, t1 = type$.String, configuration = A.LinkedHashMap_LinkedHashMap$_empty(t1, type$.ConfiguredValue_2);
                for(t2 = _this._async_environment0$_variables, t3 = type$.Value_2, t4 = _this._async_environment0$_variableNodes, t5 = _this._async_environment0$_importedModules, t6 = A._instanceType(t5)._eval$1("LinkedHashMapKeysIterable<1>"), i = 0; i < t2.length; ++i){
                    if (i === 0) modules = new A.LinkedHashMapKeysIterable(t5, t6);
                    else {
                        t7 = _this._async_environment0$_nestedForwardedModules;
                        modules = t7 == null ? _null : t7[i - 1];
                    }
                    t7 = J.get$iterator$ax(modules == null ? B.List_empty30 : modules);
                    while(t7.moveNext$0()){
                        t8 = t7.get$current(t7);
                        for(t9 = A.MapExtensions_get_pairs0(t8.get$variables(), t1, t3), t9 = t9.get$iterator(t9); t9.moveNext$0();){
                            t10 = t9.get$current(t9);
                            $name = t10._0;
                            value = t10._1;
                            t10 = t8.get$variableNodes().$index(0, $name);
                            t10.toString;
                            configuration.$indexSet(0, $name, new A.ConfiguredValue0(value, _null, t10));
                        }
                    }
                    values = t2[i];
                    nodes = t4[i];
                    for(t7 = A.MapExtensions_get_pairs0(values, t1, t3), t7 = t7.get$iterator(t7); t7.moveNext$0();){
                        t8 = t7.get$current(t7);
                        $name = t8._0;
                        value = t8._1;
                        t8 = nodes.$index(0, $name);
                        t8.toString;
                        configuration.$indexSet(0, $name, new A.ConfiguredValue0(value, _null, t8));
                    }
                }
                return new A.Configuration0(configuration, _null);
            },
            toModule$3: function(css, preModuleComments, extensionStore) {
                return A._EnvironmentModule__EnvironmentModule2(this, css, preModuleComments, extensionStore, A.NullableExtension_andThen0(this._async_environment0$_forwardedModules, new A.AsyncEnvironment_toModule_closure0()));
            },
            toDummyModule$0: function() {
                return A._EnvironmentModule__EnvironmentModule2(this, new A.CssStylesheet0(new A.UnmodifiableListView(B.List_empty20, type$.UnmodifiableListView_CssNode_2), A.SourceFile$decoded(B.List_empty4, "<dummy module>").span$1(0, 0)), B.Map_empty16, B.C_EmptyExtensionStore0, A.NullableExtension_andThen0(this._async_environment0$_forwardedModules, new A.AsyncEnvironment_toDummyModule_closure0()));
            },
            _async_environment0$_getModule$1: function(namespace) {
                var _0_0 = this._async_environment0$_modules.$index(0, namespace);
                if (_0_0 != null) return _0_0;
                throw A.wrapException(A.SassScriptException$0('There is no module with the namespace "' + namespace + '".', null));
            },
            _async_environment0$_fromOneModule$1$3: function($name, type, callback) {
                var t1, t2, t3, t4, t5, _1_0, _2_0, value, identity, valueInModule, identityFromModule, module, node, _0_0 = this._async_environment0$_nestedForwardedModules;
                if (_0_0 != null) for(t1 = A._arrayInstanceType(_0_0)._eval$1("ReversedListIterable<1>"), t2 = new A.ReversedListIterable(_0_0, t1), t2 = new A.ListIterator(t2, t2.get$length(0), t1._eval$1("ListIterator<ListIterable.E>")), t1 = t1._eval$1("ListIterable.E"); t2.moveNext$0();){
                    t3 = t2.__internal$_current;
                    for(t3 = J.get$reversed$ax(t3 == null ? t1._as(t3) : t3), t4 = t3.$ti, t3 = new A.ListIterator(t3, t3.get$length(0), t4._eval$1("ListIterator<ListIterable.E>")), t4 = t4._eval$1("ListIterable.E"); t3.moveNext$0();){
                        t5 = t3.__internal$_current;
                        _1_0 = callback.call$1(t5 == null ? t4._as(t5) : t5);
                        if (_1_0 != null) return _1_0;
                    }
                }
                for(t1 = this._async_environment0$_importedModules, t1 = new A.LinkedHashMapKeyIterator(t1, t1._modifications, t1._first); t1.moveNext$0();){
                    _2_0 = callback.call$1(t1.__js_helper$_current);
                    if (_2_0 != null) return _2_0;
                }
                for(t1 = this._async_environment0$_globalModules, t2 = new A.LinkedHashMapKeyIterator(t1, t1._modifications, t1._first), t3 = type$.AsyncCallable_2, value = null, identity = null; t2.moveNext$0();){
                    t4 = t2.__js_helper$_current;
                    valueInModule = callback.call$1(t4);
                    if (valueInModule == null) continue;
                    identityFromModule = t3._is(valueInModule) ? valueInModule : t4.variableIdentity$1($name);
                    if (identityFromModule.$eq(0, identity)) continue;
                    if (value != null) {
                        t2 = A.LinkedHashMap_LinkedHashMap$_empty(type$.FileSpan, type$.String);
                        for(t3 = A.MapExtensions_get_pairs0(t1, type$.Module_AsyncCallable_2, type$.AstNode_2), t3 = t3.get$iterator(t3), t4 = "includes " + type; t3.moveNext$0();){
                            t1 = t3.get$current(t3);
                            module = t1._0;
                            node = t1._1;
                            if (callback.call$1(module) != null) t2.$indexSet(0, node.get$span(node), t4);
                        }
                        throw A.wrapException(A.MultiSpanSassScriptException$0("This " + type + string$.x20is_av, type + " use", t2));
                    }
                    identity = identityFromModule;
                    value = valueInModule;
                }
                return value;
            },
            _async_environment0$_fromOneModule$3: function($name, type, callback) {
                return this._async_environment0$_fromOneModule$1$3($name, type, callback, type$.dynamic);
            }
        };
        A.AsyncEnvironment__getVariableFromGlobalModule_closure0.prototype = {
            call$1: function(module) {
                return module.get$variables().$index(0, this.name);
            },
            $signature: 314
        };
        A.AsyncEnvironment_setVariable_closure2.prototype = {
            call$0: function() {
                var t1 = this.$this;
                t1._async_environment0$_lastVariableName = this.name;
                return t1._async_environment0$_lastVariableIndex = 0;
            },
            $signature: 10
        };
        A.AsyncEnvironment_setVariable_closure3.prototype = {
            call$1: function(module) {
                return module.get$variables().containsKey$1(this.name) ? module : null;
            },
            $signature: 315
        };
        A.AsyncEnvironment_setVariable_closure4.prototype = {
            call$0: function() {
                var t1 = this.$this, t2 = t1._async_environment0$_variableIndex$1(this.name);
                return t2 == null ? t1._async_environment0$_variables.length - 1 : t2;
            },
            $signature: 10
        };
        A.AsyncEnvironment__getFunctionFromGlobalModule_closure0.prototype = {
            call$1: function(module) {
                return module.get$functions(module).$index(0, this.name);
            },
            $signature: 203
        };
        A.AsyncEnvironment__getMixinFromGlobalModule_closure0.prototype = {
            call$1: function(module) {
                return module.get$mixins().$index(0, this.name);
            },
            $signature: 203
        };
        A.AsyncEnvironment_toModule_closure0.prototype = {
            call$1: function(modules) {
                return new A.MapKeySet(modules, type$.MapKeySet_Module_AsyncCallable_2);
            },
            $signature: 204
        };
        A.AsyncEnvironment_toDummyModule_closure0.prototype = {
            call$1: function(modules) {
                return new A.MapKeySet(modules, type$.MapKeySet_Module_AsyncCallable_2);
            },
            $signature: 204
        };
        A._EnvironmentModule2.prototype = {
            get$url: function(_) {
                var t1 = this.css;
                t1 = t1.get$span(t1);
                return t1.get$sourceUrl(t1);
            },
            setVariable$3: function($name, value, nodeWithSpan) {
                var t1, t2, _0_0 = this._async_environment0$_modulesByVariable.$index(0, $name);
                if (_0_0 != null) {
                    _0_0.setVariable$3($name, value, nodeWithSpan);
                    return;
                }
                t1 = this._async_environment0$_environment;
                t2 = t1._async_environment0$_variables;
                if (!B.JSArray_methods.get$first(t2).containsKey$1($name)) throw A.wrapException(A.SassScriptException$0("Undefined variable.", null));
                B.JSArray_methods.get$first(t2).$indexSet(0, $name, value);
                B.JSArray_methods.get$first(t1._async_environment0$_variableNodes).$indexSet(0, $name, nodeWithSpan);
                return;
            },
            variableIdentity$1: function($name) {
                var module = this._async_environment0$_modulesByVariable.$index(0, $name);
                return module == null ? this : module.variableIdentity$1($name);
            },
            couldHaveBeenConfigured$1: function(variables) {
                var t2, t3, _0_0, variable, module, t1 = this._async_environment0$_environment._async_environment0$_configurableVariables;
                if (!(variables.get$length(variables) < t1.get$length(t1) ? variables.any$1(0, t1.get$contains(t1)) : t1.any$1(0, variables.get$contains(variables)))) {
                    t1 = this._async_environment0$_modulesByVariable;
                    t2 = type$.Module_AsyncCallable_2;
                    if (variables.get$length(variables) < t1.get$length(t1)) {
                        t2 = A.LinkedHashSet_LinkedHashSet$_empty(t2);
                        for(t3 = variables.get$iterator(variables); t3.moveNext$0();){
                            _0_0 = t1.$index(0, t3.get$current(t3));
                            if (_0_0 != null) t2.add$1(0, _0_0);
                        }
                        t1 = t2;
                    } else {
                        t3 = A.LinkedHashSet_LinkedHashSet$_empty(t2);
                        for(t1 = A.MapExtensions_get_pairs0(t1, type$.String, t2), t1 = t1.get$iterator(t1); t1.moveNext$0();){
                            t2 = t1.get$current(t1);
                            variable = t2._0;
                            module = t2._1;
                            if (variables.contains$1(0, variable)) t3.add$1(0, module);
                        }
                        t1 = t3;
                    }
                    t1 = t1.any$1(0, new A._EnvironmentModule_couldHaveBeenConfigured_closure2(variables));
                } else t1 = true;
                return t1;
            },
            cloneCss$0: function() {
                var _0_0, _this = this;
                if (!_this.transitivelyContainsCss) return _this;
                _0_0 = A.cloneCssStylesheet0(_this.css, _this.extensionStore);
                return A._EnvironmentModule$_2(_this._async_environment0$_environment, _0_0._0, _this.preModuleComments, _0_0._1, _this._async_environment0$_modulesByVariable, _this.variables, _this.variableNodes, _this.functions, _this.mixins, true, _this.transitivelyContainsExtensions);
            },
            toString$0: function(_) {
                var t1 = this.css, t2 = t1.get$span(t1);
                if (t2.get$sourceUrl(t2) == null) t1 = "<unknown url>";
                else {
                    t1 = t1.get$span(t1);
                    t1 = t1.get$sourceUrl(t1);
                    t2 = $.$get$context();
                    t1.toString;
                    t1 = t2.prettyUri$1(t1);
                }
                return t1;
            },
            $isModule1: 1,
            get$upstream: function() {
                return this.upstream;
            },
            get$variables: function() {
                return this.variables;
            },
            get$variableNodes: function() {
                return this.variableNodes;
            },
            get$functions: function(receiver) {
                return this.functions;
            },
            get$mixins: function() {
                return this.mixins;
            },
            get$extensionStore: function() {
                return this.extensionStore;
            },
            get$css: function(receiver) {
                return this.css;
            },
            get$preModuleComments: function() {
                return this.preModuleComments;
            },
            get$transitivelyContainsCss: function() {
                return this.transitivelyContainsCss;
            },
            get$transitivelyContainsExtensions: function() {
                return this.transitivelyContainsExtensions;
            }
        };
        A._EnvironmentModule__EnvironmentModule_closure17.prototype = {
            call$1: function(module) {
                return module.get$variables();
            },
            $signature: 318
        };
        A._EnvironmentModule__EnvironmentModule_closure18.prototype = {
            call$1: function(module) {
                return module.get$variableNodes();
            },
            $signature: 319
        };
        A._EnvironmentModule__EnvironmentModule_closure19.prototype = {
            call$1: function(module) {
                return module.get$functions(module);
            },
            $signature: 205
        };
        A._EnvironmentModule__EnvironmentModule_closure20.prototype = {
            call$1: function(module) {
                return module.get$mixins();
            },
            $signature: 205
        };
        A._EnvironmentModule__EnvironmentModule_closure21.prototype = {
            call$1: function(module) {
                return module.get$transitivelyContainsCss();
            },
            $signature: 118
        };
        A._EnvironmentModule__EnvironmentModule_closure22.prototype = {
            call$1: function(module) {
                return module.get$transitivelyContainsExtensions();
            },
            $signature: 118
        };
        A._EnvironmentModule_couldHaveBeenConfigured_closure2.prototype = {
            call$1: function(module) {
                return module.couldHaveBeenConfigured$1(this.variables);
            },
            $signature: 118
        };
        A._EvaluateVisitor2.prototype = {
            get$_async_evaluate0$_hasCssNesting: function() {
                var _0_0, t1, grandparent, $parent = this._async_evaluate0$_atRootExcludingStyleRule ? null : this._async_evaluate0$_styleRuleIgnoringAtRoot;
                for(;; $parent = grandparent){
                    _0_0 = $parent == null ? null : $parent._node$_parent;
                    if (_0_0 instanceof A.ModifiableCssStyleRule0) return true;
                    t1 = _0_0 != null;
                    grandparent = t1 ? _0_0 : null;
                    if (t1) continue;
                    return false;
                }
            },
            _EvaluateVisitor$6$functions$importCache$logger$nodeImporter$quietDeps$sourceMap2: function(functions, importCache, logger, nodeImporter, quietDeps, sourceMap) {
                var t2, metaModule, t3, _i, module, $function, t4, _this = this, _s20_ = "$name, $module: null", _s9_ = "sass:meta", _s7_ = "$module", t1 = type$.JSArray_AsyncBuiltInCallable_2, metaFunctions = A._setArrayType([
                    A.BuiltInCallable$function0("global-variable-exists", _s20_, new A._EvaluateVisitor_closure38(_this), _s9_),
                    A.BuiltInCallable$function0("variable-exists", "$name", new A._EvaluateVisitor_closure39(_this), _s9_),
                    A.BuiltInCallable$function0("function-exists", _s20_, new A._EvaluateVisitor_closure40(_this), _s9_),
                    A.BuiltInCallable$function0("mixin-exists", _s20_, new A._EvaluateVisitor_closure41(_this), _s9_),
                    A.BuiltInCallable$function0("content-exists", "", new A._EvaluateVisitor_closure42(_this), _s9_),
                    A.BuiltInCallable$function0("module-variables", _s7_, new A._EvaluateVisitor_closure43(_this), _s9_),
                    A.BuiltInCallable$function0("module-functions", _s7_, new A._EvaluateVisitor_closure44(_this), _s9_),
                    A.BuiltInCallable$function0("module-mixins", _s7_, new A._EvaluateVisitor_closure45(_this), _s9_),
                    A.BuiltInCallable$function0("get-function", "$name, $css: false, $module: null", new A._EvaluateVisitor_closure46(_this), _s9_),
                    A.BuiltInCallable$function0("get-mixin", _s20_, new A._EvaluateVisitor_closure47(_this), _s9_),
                    new A.AsyncBuiltInCallable0("call", A.ScssParser$0("@function call($function, $args...) {", false, _s9_).parseParameterList$0(), new A._EvaluateVisitor_closure48(_this), false)
                ], t1), metaMixins = A._setArrayType([
                    A.AsyncBuiltInCallable$mixin0("load-css", "$url, $with: null", new A._EvaluateVisitor_closure49(_this), false, _s9_),
                    A.AsyncBuiltInCallable$mixin0("apply", "$mixin, $args...", new A._EvaluateVisitor_closure50(_this), true, _s9_)
                ], t1);
                t1 = type$.AsyncBuiltInCallable_2;
                t2 = A.List_List$_of($.$get$moduleFunctions0(), t1);
                B.JSArray_methods.addAll$1(t2, metaFunctions);
                metaModule = A.BuiltInModule$0("meta", t2, metaMixins, null, t1);
                t1 = A.List_List$_of($.$get$coreModules0(), type$.BuiltInModule_AsyncCallable_2);
                t1.push(metaModule);
                t2 = t1.length;
                t3 = _this._async_evaluate0$_builtInModules;
                _i = 0;
                for(; _i < t1.length; t1.length === t2 || (0, A.throwConcurrentModificationError)(t1), ++_i){
                    module = t1[_i];
                    t3.$indexSet(0, module.url, module);
                }
                t1 = type$.JSArray_AsyncCallable_2;
                t2 = A._setArrayType([], t1);
                B.JSArray_methods.addAll$1(t2, functions);
                B.JSArray_methods.addAll$1(t2, $.$get$globalFunctions0());
                t1 = A._setArrayType([], t1);
                for(_i = 0; _i < 11; ++_i)t1.push(metaFunctions[_i].withDeprecationWarning$1("meta"));
                B.JSArray_methods.addAll$1(t2, t1);
                for(t1 = t2.length, t3 = _this._async_evaluate0$_builtInFunctions, _i = 0; _i < t2.length; t2.length === t1 || (0, A.throwConcurrentModificationError)(t2), ++_i){
                    $function = t2[_i];
                    t4 = $function.get$name($function);
                    t3.$indexSet(0, A.stringReplaceAllUnchecked(t4, "_", "-"), $function);
                }
            },
            run$2: function(_, importer, node) {
                return this.run$body$_EvaluateVisitor0(0, importer, node);
            },
            run$body$_EvaluateVisitor0: function(_, importer, node) {
                var $async$goto = 0, $async$completer = A._makeAsyncAwaitCompleter(type$.Record_2_Set_Uri_loadedUrls_and_CssStylesheet_stylesheet_2), $async$returnValue, $async$handler = 2, $async$errorStack = [], $async$self = this, error, stackTrace, t1, exception, $async$exception;
                var $async$run$2 = A._wrapJsFunctionForAsync(function($async$errorCode, $async$result) {
                    if ($async$errorCode === 1) {
                        $async$errorStack.push($async$result);
                        $async$goto = $async$handler;
                    }
                    for(;;)switch($async$goto){
                        case 0:
                            // Function start
                            $async$handler = 4;
                            t1 = type$.nullable_Object;
                            t1 = A.runZoned(new A._EvaluateVisitor_run_closure2($async$self, node, importer), A.LinkedHashMap_LinkedHashMap$_literal([
                                B.Symbol__evaluationContext,
                                new A._EvaluationContext2($async$self, node)
                            ], t1, t1), type$.FutureOr_Record_2_Set_Uri_loadedUrls_and_CssStylesheet_stylesheet_2);
                            $async$goto = 7;
                            return A._asyncAwait(type$.Future_Record_2_Set_Uri_loadedUrls_and_CssStylesheet_stylesheet_2._is(t1) ? t1 : A._Future$value(t1, type$.Record_2_Set_Uri_loadedUrls_and_CssStylesheet_stylesheet_2), $async$run$2);
                        case 7:
                            // returning from await.
                            t1 = $async$result;
                            $async$returnValue = t1;
                            // goto return
                            $async$goto = 1;
                            break;
                        case 4:
                            // catch
                            $async$handler = 3;
                            $async$exception = $async$errorStack.pop();
                            t1 = A.unwrapException($async$exception);
                            if (t1 instanceof A.SassException0) {
                                error = t1;
                                stackTrace = A.getTraceFromException($async$exception);
                                A.throwWithTrace0(error.withLoadedUrls$1($async$self._async_evaluate0$_loadedUrls), error, stackTrace);
                            } else throw $async$exception;
                            // goto after finally
                            $async$goto = 6;
                            break;
                        case 3:
                            // uncaught
                            // goto rethrow
                            $async$goto = 2;
                            break;
                        case 6:
                        // after finally
                        case 1:
                            // return
                            return A._asyncReturn($async$returnValue, $async$completer);
                        case 2:
                            // rethrow
                            return A._asyncRethrow($async$errorStack.at(-1), $async$completer);
                    }
                });
                return A._asyncStartSync($async$run$2, $async$completer);
            },
            _async_evaluate0$_assertInModule$1$2: function(value, $name) {
                if (value != null) return value;
                throw A.wrapException(A.StateError$("Can't access " + $name + " outside of a module."));
            },
            _async_evaluate0$_assertInModule$2: function(value, $name) {
                return this._async_evaluate0$_assertInModule$1$2(value, $name, type$.dynamic);
            },
            _async_evaluate0$_loadModule$7$baseUrl$configuration$namesInErrors: function(url, stackFrame, nodeWithSpan, callback, baseUrl, configuration, namesInErrors) {
                return this._loadModule$body$_EvaluateVisitor0(url, stackFrame, nodeWithSpan, callback, baseUrl, configuration, namesInErrors);
            },
            _async_evaluate0$_loadModule$5$configuration: function(url, stackFrame, nodeWithSpan, callback, configuration) {
                return this._async_evaluate0$_loadModule$7$baseUrl$configuration$namesInErrors(url, stackFrame, nodeWithSpan, callback, null, configuration, false);
            },
            _async_evaluate0$_loadModule$4: function(url, stackFrame, nodeWithSpan, callback) {
                return this._async_evaluate0$_loadModule$7$baseUrl$configuration$namesInErrors(url, stackFrame, nodeWithSpan, callback, null, null, false);
            },
            _loadModule$body$_EvaluateVisitor0: function(url, stackFrame, nodeWithSpan, callback, baseUrl, configuration, namesInErrors) {
                var $async$goto = 0, $async$completer = A._makeAsyncAwaitCompleter(type$.void), $async$returnValue, $async$self = this, t2, _0_0, t1;
                var $async$_async_evaluate0$_loadModule$7$baseUrl$configuration$namesInErrors = A._wrapJsFunctionForAsync(function($async$errorCode, $async$result) {
                    if ($async$errorCode === 1) return A._asyncRethrow($async$result, $async$completer);
                    for(;;)switch($async$goto){
                        case 0:
                            // Function start
                            _0_0 = $async$self._async_evaluate0$_builtInModules.$index(0, url);
                            t1 = {};
                            t1.builtInModule = null;
                            $async$goto = _0_0 != null ? 3 : 4;
                            break;
                        case 3:
                            // then
                            t1.builtInModule = _0_0;
                            if (configuration instanceof A.ExplicitConfiguration0) {
                                t1 = namesInErrors ? "Built-in module " + url.toString$0(0) + " can't be configured." : "Built-in modules can't be configured.";
                                t2 = configuration.nodeWithSpan;
                                throw A.wrapException($async$self._async_evaluate0$_exception$2(t1, t2.get$span(t2)));
                            }
                            $async$goto = 5;
                            return A._asyncAwait($async$self._async_evaluate0$_addExceptionSpanAsync$1$2(nodeWithSpan, new A._EvaluateVisitor__loadModule_closure5(t1, callback), type$.void), $async$_async_evaluate0$_loadModule$7$baseUrl$configuration$namesInErrors);
                        case 5:
                            // returning from await.
                            // goto return
                            $async$goto = 1;
                            break;
                        case 4:
                            // join
                            $async$goto = 6;
                            return A._asyncAwait($async$self._async_evaluate0$_withStackFrame$1$3(stackFrame, nodeWithSpan, new A._EvaluateVisitor__loadModule_closure6($async$self, url, nodeWithSpan, baseUrl, namesInErrors, configuration, callback), type$.Null), $async$_async_evaluate0$_loadModule$7$baseUrl$configuration$namesInErrors);
                        case 6:
                        // returning from await.
                        case 1:
                            // return
                            return A._asyncReturn($async$returnValue, $async$completer);
                    }
                });
                return A._asyncStartSync($async$_async_evaluate0$_loadModule$7$baseUrl$configuration$namesInErrors, $async$completer);
            },
            _async_evaluate0$_execute$5$configuration$namesInErrors$nodeWithSpan: function(importer, stylesheet, configuration, namesInErrors, nodeWithSpan) {
                return this._execute$body$_EvaluateVisitor0(importer, stylesheet, configuration, namesInErrors, nodeWithSpan);
            },
            _async_evaluate0$_execute$2: function(importer, stylesheet) {
                return this._async_evaluate0$_execute$5$configuration$namesInErrors$nodeWithSpan(importer, stylesheet, null, false, null);
            },
            _execute$body$_EvaluateVisitor0: function(importer, stylesheet, configuration, namesInErrors, nodeWithSpan) {
                var $async$goto = 0, $async$completer = A._makeAsyncAwaitCompleter(type$.Module_AsyncCallable_2), $async$returnValue, $async$self = this, currentConfiguration, t2, _0_0, t3, message, existingSpan, configurationSpan, environment, css, preModuleComments, extensionStore, module, t1, url;
                var $async$_async_evaluate0$_execute$5$configuration$namesInErrors$nodeWithSpan = A._wrapJsFunctionForAsync(function($async$errorCode, $async$result) {
                    if ($async$errorCode === 1) return A._asyncRethrow($async$result, $async$completer);
                    for(;;)switch($async$goto){
                        case 0:
                            // Function start
                            t1 = stylesheet.span;
                            url = t1.get$sourceUrl(t1);
                            t1 = configuration == null;
                            currentConfiguration = t1 ? $async$self._async_evaluate0$_configuration : configuration;
                            t2 = $async$self._async_evaluate0$_modules;
                            _0_0 = t2.$index(0, url);
                            if (_0_0 != null) {
                                t2 = $async$self._async_evaluate0$_moduleConfigurations.$index(0, url);
                                t3 = t2._configuration0$__originalConfiguration;
                                t2 = t3 == null ? t2 : t3;
                                t3 = currentConfiguration._configuration0$__originalConfiguration;
                                if (t2 !== (t3 == null ? currentConfiguration : t3) && currentConfiguration instanceof A.ExplicitConfiguration0 && _0_0.couldHaveBeenConfigured$1(new A.MapKeySet(new A.UnmodifiableMapView(currentConfiguration._configuration0$_values, type$.UnmodifiableMapView_String_ConfiguredValue_2), type$.MapKeySet_String))) {
                                    if (namesInErrors) {
                                        t2 = $.$get$context();
                                        url.toString;
                                        message = t2.prettyUri$1(url) + string$.x20was_a;
                                    } else message = string$.This_mw;
                                    t2 = $async$self._async_evaluate0$_moduleNodes.$index(0, url);
                                    existingSpan = t2 == null ? null : t2.get$span(t2);
                                    if (t1) {
                                        t1 = currentConfiguration.nodeWithSpan;
                                        configurationSpan = t1.get$span(t1);
                                    } else configurationSpan = null;
                                    t1 = A.LinkedHashMap_LinkedHashMap$_empty(type$.FileSpan, type$.String);
                                    if (existingSpan != null) t1.$indexSet(0, existingSpan, "original load");
                                    if (configurationSpan != null) t1.$indexSet(0, configurationSpan, "configuration");
                                    throw A.wrapException(t1.get$isEmpty(0) ? $async$self._async_evaluate0$_exception$1(message) : $async$self._async_evaluate0$_multiSpanException$3(message, "new load", t1));
                                }
                                $async$returnValue = _0_0;
                                // goto return
                                $async$goto = 1;
                                break;
                            }
                            environment = A.AsyncEnvironment$0();
                            css = A._Cell$();
                            preModuleComments = A._Cell$();
                            extensionStore = A.ExtensionStore$0();
                            $async$goto = 3;
                            return A._asyncAwait($async$self._async_evaluate0$_withEnvironment$1$2(environment, new A._EvaluateVisitor__execute_closure2($async$self, importer, stylesheet, extensionStore, configuration, css, preModuleComments), type$.Null), $async$_async_evaluate0$_execute$5$configuration$namesInErrors$nodeWithSpan);
                        case 3:
                            // returning from await.
                            t1 = css._readLocal$0();
                            t3 = preModuleComments._readLocal$0();
                            module = environment.toModule$3(t1, t3 == null ? B.Map_empty16 : t3, extensionStore);
                            if (url != null) {
                                t2.$indexSet(0, url, module);
                                $async$self._async_evaluate0$_moduleConfigurations.$indexSet(0, url, currentConfiguration);
                                if (nodeWithSpan != null) $async$self._async_evaluate0$_moduleNodes.$indexSet(0, url, nodeWithSpan);
                            }
                            $async$returnValue = module;
                            // goto return
                            $async$goto = 1;
                            break;
                        case 1:
                            // return
                            return A._asyncReturn($async$returnValue, $async$completer);
                    }
                });
                return A._asyncStartSync($async$_async_evaluate0$_execute$5$configuration$namesInErrors$nodeWithSpan, $async$completer);
            },
            _async_evaluate0$_addOutOfOrderImports$0: function() {
                var t1, t2, _this = this, _s5_ = "_root", _s13_ = "_endOfImports", _0_0 = _this._async_evaluate0$_outOfOrderImports;
                $label0$0: {
                    if (_0_0 == null) {
                        t1 = _this._async_evaluate0$_assertInModule$2(_this._async_evaluate0$__root, _s5_).children;
                        break $label0$0;
                    }
                    t1 = _this._async_evaluate0$_assertInModule$2(_this._async_evaluate0$__root, _s5_).children;
                    t1 = A.List_List$_of(A.SubListIterable$(t1, 0, A.checkNotNullable(_this._async_evaluate0$_assertInModule$2(_this._async_evaluate0$__endOfImports, _s13_), "count", type$.int), t1.$ti._eval$1("ListBase.E")), type$.ModifiableCssNode_2);
                    B.JSArray_methods.addAll$1(t1, _0_0);
                    t2 = _this._async_evaluate0$_assertInModule$2(_this._async_evaluate0$__root, _s5_).children;
                    B.JSArray_methods.addAll$1(t1, A.SubListIterable$(t2, _this._async_evaluate0$_assertInModule$2(_this._async_evaluate0$__endOfImports, _s13_), null, t2.$ti._eval$1("ListBase.E")));
                    break $label0$0;
                }
                return t1;
            },
            _async_evaluate0$_combineCss$2$clone: function(root, clone) {
                var selectors, _0_0, t1, imports, css, sorted, t2;
                if (!B.JSArray_methods.any$1(root.get$upstream(), new A._EvaluateVisitor__combineCss_closure5())) {
                    selectors = root.get$extensionStore().get$simpleSelectors();
                    _0_0 = A.IterableExtension_get_firstOrNull(root.get$extensionStore().extensionsWhereTarget$1(new A._EvaluateVisitor__combineCss_closure6(selectors)));
                    if (_0_0 != null) this._async_evaluate0$_throwForUnsatisfiedExtension$1(_0_0);
                    return root.get$css(root);
                }
                t1 = type$.JSArray_CssNode_2;
                imports = A._setArrayType([], t1);
                css = A._setArrayType([], t1);
                t1 = type$.Module_AsyncCallable_2;
                sorted = A.ListQueue$(t1);
                new A._EvaluateVisitor__combineCss_visitModule2(this, A.LinkedHashSet_LinkedHashSet$_empty(t1), clone, css, imports, sorted).call$1(root);
                if (root.get$transitivelyContainsExtensions()) this._async_evaluate0$_extendModules$1(sorted);
                t1 = B.JSArray_methods.$add(imports, css);
                t2 = root.get$css(root);
                return new A.CssStylesheet0(new A.UnmodifiableListView(t1, type$.UnmodifiableListView_CssNode_2), t2.get$span(t2));
            },
            _async_evaluate0$_combineCss$1: function(root) {
                return this._async_evaluate0$_combineCss$2$clone(root, false);
            },
            _async_evaluate0$_extendModules$1: function(sortedModules) {
                var t1, t2, t3, originalSelectors, $self, t4, t5, _i, upstream, _0_0, downstreamExtensionStores = A.LinkedHashMap_LinkedHashMap$_empty(type$.Uri, type$.List_ExtensionStore_2), unsatisfiedExtensions = new A._LinkedIdentityHashSet(type$._LinkedIdentityHashSet_Extension_2);
                for(t1 = A._ListQueueIterator$(sortedModules, sortedModules.$ti._precomputed1), t2 = t1.$ti._precomputed1; t1.moveNext$0();){
                    t3 = t1._collection$_current;
                    if (t3 == null) t3 = t2._as(t3);
                    originalSelectors = t3.get$extensionStore().get$simpleSelectors().toSet$0(0);
                    unsatisfiedExtensions.addAll$1(0, t3.get$extensionStore().extensionsWhereTarget$1(new A._EvaluateVisitor__extendModules_closure5(originalSelectors)));
                    $self = downstreamExtensionStores.$index(0, t3.get$url(t3));
                    t4 = t3.get$extensionStore().get$addExtensions();
                    if ($self != null) t4.call$1($self);
                    t4 = t3.get$extensionStore();
                    if (t4.get$isEmpty(t4)) continue;
                    for(t4 = t3.get$upstream(), t5 = t4.length, _i = 0; _i < t4.length; t4.length === t5 || (0, A.throwConcurrentModificationError)(t4), ++_i){
                        upstream = t4[_i];
                        _0_0 = upstream.get$url(upstream);
                        if (_0_0 != null) J.add$1$ax(downstreamExtensionStores.putIfAbsent$2(_0_0, new A._EvaluateVisitor__extendModules_closure6()), t3.get$extensionStore());
                    }
                    unsatisfiedExtensions.removeAll$1(t3.get$extensionStore().extensionsWhereTarget$1(originalSelectors.get$contains(originalSelectors)));
                }
                if (unsatisfiedExtensions._collection$_length !== 0) this._async_evaluate0$_throwForUnsatisfiedExtension$1(unsatisfiedExtensions.get$first(0));
            },
            _async_evaluate0$_throwForUnsatisfiedExtension$1: function(extension) {
                throw A.wrapException(A.SassException$0(string$.The_ta + extension.target.toString$0(0) + ' !optional" to avoid this error.', extension.span, null));
            },
            _async_evaluate0$_indexAfterImports$1: function(statements) {
                var t1, lastImport, i, _0_0;
                for(t1 = J.getInterceptor$asx(statements), lastImport = -1, i = 0; i < t1.get$length(statements); ++i){
                    $label0$0: {
                        _0_0 = t1.$index(statements, i);
                        if (_0_0 instanceof A.ModifiableCssImport0) break $label0$0;
                        if (_0_0 instanceof A.ModifiableCssComment0) continue;
                        break;
                    }
                    lastImport = i;
                }
                return lastImport + 1;
            },
            visitStylesheet$1: function(_, node) {
                return this.visitStylesheet$body$_EvaluateVisitor0(0, node);
            },
            visitStylesheet$body$_EvaluateVisitor0: function(_, node) {
                var $async$goto = 0, $async$completer = A._makeAsyncAwaitCompleter(type$.nullable_Value_2), $async$returnValue, $async$self = this, t1, t2, warning, _i, $name, span;
                var $async$visitStylesheet$1 = A._wrapJsFunctionForAsync(function($async$errorCode, $async$result) {
                    if ($async$errorCode === 1) return A._asyncRethrow($async$result, $async$completer);
                    for(;;)switch($async$goto){
                        case 0:
                            // Function start
                            for(t1 = node.parseTimeWarnings, t2 = t1.$ti, t1 = new A.ListIterator(t1, t1.get$length(0), t2._eval$1("ListIterator<ListBase.E>")), t2 = t2._eval$1("ListBase.E"); t1.moveNext$0();){
                                warning = t1.__internal$_current;
                                if (warning == null) warning = t2._as(warning);
                                $async$self._async_evaluate0$_warn$3(warning._1, warning._2, warning._0);
                            }
                            t1 = node.children, t2 = t1.length, _i = 0;
                        case 3:
                            // for condition
                            if (!(_i < t2)) {
                                // goto after for
                                $async$goto = 5;
                                break;
                            }
                            $async$goto = 6;
                            return A._asyncAwait(t1[_i].accept$1($async$self), $async$visitStylesheet$1);
                        case 6:
                        // returning from await.
                        case 4:
                            // for update
                            ++_i;
                            // goto for condition
                            $async$goto = 3;
                            break;
                        case 5:
                            // after for
                            for(t1 = A.MapExtensions_get_pairs0(node.globalVariables, type$.String, type$.FileSpan), t1 = t1.get$iterator(t1); t1.moveNext$0();){
                                t2 = t1.get$current(t1);
                                $name = t2._0;
                                span = t2._1;
                                $async$self.visitVariableDeclaration$1(0, new A.VariableDeclaration0(null, $name, new A.NullExpression0(span), true, false, span));
                            }
                            $async$returnValue = null;
                            // goto return
                            $async$goto = 1;
                            break;
                        case 1:
                            // return
                            return A._asyncReturn($async$returnValue, $async$completer);
                    }
                });
                return A._asyncStartSync($async$visitStylesheet$1, $async$completer);
            },
            visitAtRootRule$1: function(_, node) {
                return this.visitAtRootRule$body$_EvaluateVisitor0(0, node);
            },
            visitAtRootRule$body$_EvaluateVisitor0: function(_, node) {
                var $async$goto = 0, $async$completer = A._makeAsyncAwaitCompleter(type$.nullable_Value_2), $async$returnValue, $async$self = this, _1_0, resolved, query, $parent, included, t1, _2_0, root, first, rest, innerCopy, outerCopy, _i, copy, _0_0;
                var $async$visitAtRootRule$1 = A._wrapJsFunctionForAsync(function($async$errorCode, $async$result) {
                    if ($async$errorCode === 1) return A._asyncRethrow($async$result, $async$completer);
                    for(;;)switch($async$goto){
                        case 0:
                            // Function start
                            _0_0 = node.query;
                            $async$goto = _0_0 != null ? 3 : 5;
                            break;
                        case 3:
                            // then
                            $async$goto = 6;
                            return A._asyncAwait($async$self._async_evaluate0$_performInterpolationWithMap$2$warnForColor(_0_0, true), $async$visitAtRootRule$1);
                        case 6:
                            // returning from await.
                            _1_0 = $async$result;
                            resolved = _1_0._0;
                            _1_0._1;
                            query = new A.AtRootQueryParser0(A.SpanScanner$(resolved, null), null).parse$0(0);
                            // goto join
                            $async$goto = 4;
                            break;
                        case 5:
                            // else
                            query = B.AtRootQuery_bfj0;
                        case 4:
                            // join
                            $parent = $async$self._async_evaluate0$_assertInModule$2($async$self._async_evaluate0$__parent, "__parent");
                            included = A._setArrayType([], type$.JSArray_ModifiableCssParentNode_2);
                            for(t1 = type$.CssStylesheet_2; !t1._is($parent); $parent = _2_0){
                                if (!query.excludes$1($parent)) included.push($parent);
                                _2_0 = $parent._node$_parent;
                                if (_2_0 == null) throw A.wrapException(A.StateError$(string$.CssNod));
                            }
                            root = $async$self._async_evaluate0$_trimIncluded$1(included);
                            $async$goto = root === $async$self._async_evaluate0$_assertInModule$2($async$self._async_evaluate0$__parent, "__parent") ? 7 : 8;
                            break;
                        case 7:
                            // then
                            $async$goto = 9;
                            return A._asyncAwait($async$self._async_evaluate0$_environment.scope$1$2$when(new A._EvaluateVisitor_visitAtRootRule_closure5($async$self, node), node.hasDeclarations, type$.Null), $async$visitAtRootRule$1);
                        case 9:
                            // returning from await.
                            $async$returnValue = null;
                            // goto return
                            $async$goto = 1;
                            break;
                        case 8:
                            // join
                            if (included.length >= 1) {
                                first = included[0];
                                rest = B.JSArray_methods.sublist$1(included, 1);
                                innerCopy = first.copyWithoutChildren$0();
                                for(t1 = rest.length, outerCopy = innerCopy, _i = 0; _i < rest.length; rest.length === t1 || (0, A.throwConcurrentModificationError)(rest), ++_i, outerCopy = copy){
                                    copy = rest[_i].copyWithoutChildren$0();
                                    copy.addChild$1(outerCopy);
                                }
                                root.addChild$1(outerCopy);
                            } else innerCopy = root;
                            $async$goto = 10;
                            return A._asyncAwait($async$self._async_evaluate0$_scopeForAtRoot$4(node, innerCopy, query, included).call$1(new A._EvaluateVisitor_visitAtRootRule_closure6($async$self, node)), $async$visitAtRootRule$1);
                        case 10:
                            // returning from await.
                            $async$returnValue = null;
                            // goto return
                            $async$goto = 1;
                            break;
                        case 1:
                            // return
                            return A._asyncReturn($async$returnValue, $async$completer);
                    }
                });
                return A._asyncStartSync($async$visitAtRootRule$1, $async$completer);
            },
            _async_evaluate0$_trimIncluded$1: function(nodes) {
                var $parent, t1, innermostContiguous, i, t2, _0_0, _1_0, root, _this = this, _null = null, _s5_ = "_root", _s22_ = " to be an ancestor of ";
                if (nodes.length === 0) return _this._async_evaluate0$_assertInModule$2(_this._async_evaluate0$__root, _s5_);
                $parent = _this._async_evaluate0$_assertInModule$2(_this._async_evaluate0$__parent, "__parent");
                for(t1 = nodes.length, innermostContiguous = _null, i = 0; i < t1; ++i, $parent = _1_0){
                    for(; t2 = nodes[i], $parent !== t2; innermostContiguous = _null, $parent = _0_0){
                        _0_0 = $parent._node$_parent;
                        if (_0_0 == null) throw A.wrapException(A.ArgumentError$("Expected " + t2.toString$0(0) + _s22_ + _this.toString$0(0) + ".", _null));
                    }
                    if (innermostContiguous == null) innermostContiguous = i;
                    _1_0 = $parent._node$_parent;
                    if (_1_0 == null) throw A.wrapException(A.ArgumentError$("Expected " + t2.toString$0(0) + _s22_ + _this.toString$0(0) + ".", _null));
                }
                if ($parent !== _this._async_evaluate0$_assertInModule$2(_this._async_evaluate0$__root, _s5_)) return _this._async_evaluate0$_assertInModule$2(_this._async_evaluate0$__root, _s5_);
                innermostContiguous.toString;
                root = nodes[innermostContiguous];
                B.JSArray_methods.removeRange$2(nodes, innermostContiguous, nodes.length);
                return root;
            },
            _async_evaluate0$_scopeForAtRoot$4: function(node, newParent, query, included) {
                var _this = this, scope = new A._EvaluateVisitor__scopeForAtRoot_closure17(_this, newParent, node), t1 = query._at_root_query0$_all || query._at_root_query0$_rule;
                if (t1 !== query.include) scope = new A._EvaluateVisitor__scopeForAtRoot_closure18(_this, scope);
                if (_this._async_evaluate0$_mediaQueries != null && query.excludesName$1("media")) scope = new A._EvaluateVisitor__scopeForAtRoot_closure19(_this, scope);
                if (_this._async_evaluate0$_inKeyframes && query.excludesName$1("keyframes")) scope = new A._EvaluateVisitor__scopeForAtRoot_closure20(_this, scope);
                return _this._async_evaluate0$_inUnknownAtRule && !B.JSArray_methods.any$1(included, new A._EvaluateVisitor__scopeForAtRoot_closure21()) ? new A._EvaluateVisitor__scopeForAtRoot_closure22(_this, scope) : scope;
            },
            visitContentBlock$1: function(_, node) {
                return A.throwExpression(A.UnsupportedError$(string$.Evalua));
            },
            visitContentRule$1: function(_, node) {
                return this.visitContentRule$body$_EvaluateVisitor0(0, node);
            },
            visitContentRule$body$_EvaluateVisitor0: function(_, node) {
                var $async$goto = 0, $async$completer = A._makeAsyncAwaitCompleter(type$.nullable_Value_2), $async$returnValue, $async$self = this, $content;
                var $async$visitContentRule$1 = A._wrapJsFunctionForAsync(function($async$errorCode, $async$result) {
                    if ($async$errorCode === 1) return A._asyncRethrow($async$result, $async$completer);
                    for(;;)switch($async$goto){
                        case 0:
                            // Function start
                            $content = $async$self._async_evaluate0$_environment._async_environment0$_content;
                            if ($content == null) {
                                $async$returnValue = null;
                                // goto return
                                $async$goto = 1;
                                break;
                            }
                            $async$goto = 3;
                            return A._asyncAwait($async$self._async_evaluate0$_runUserDefinedCallable$1$4(node.$arguments, $content, node, new A._EvaluateVisitor_visitContentRule_closure2($async$self, $content), type$.Null), $async$visitContentRule$1);
                        case 3:
                            // returning from await.
                            $async$returnValue = null;
                            // goto return
                            $async$goto = 1;
                            break;
                        case 1:
                            // return
                            return A._asyncReturn($async$returnValue, $async$completer);
                    }
                });
                return A._asyncStartSync($async$visitContentRule$1, $async$completer);
            },
            visitDebugRule$1: function(_, node) {
                return this.visitDebugRule$body$_EvaluateVisitor0(0, node);
            },
            visitDebugRule$body$_EvaluateVisitor0: function(_, node) {
                var $async$goto = 0, $async$completer = A._makeAsyncAwaitCompleter(type$.nullable_Value_2), $async$returnValue, $async$self = this, value, t1;
                var $async$visitDebugRule$1 = A._wrapJsFunctionForAsync(function($async$errorCode, $async$result) {
                    if ($async$errorCode === 1) return A._asyncRethrow($async$result, $async$completer);
                    for(;;)switch($async$goto){
                        case 0:
                            // Function start
                            $async$goto = 3;
                            return A._asyncAwait(node.expression.accept$1($async$self), $async$visitDebugRule$1);
                        case 3:
                            // returning from await.
                            value = $async$result;
                            t1 = value instanceof A.SassString0 ? value._string0$_text : A.serializeValue0(value, true, true);
                            $async$self._async_evaluate0$_logger.debug$2(0, t1, node.span);
                            $async$returnValue = null;
                            // goto return
                            $async$goto = 1;
                            break;
                        case 1:
                            // return
                            return A._asyncReturn($async$returnValue, $async$completer);
                    }
                });
                return A._asyncStartSync($async$visitDebugRule$1, $async$completer);
            },
            visitDeclaration$1: function(_, node) {
                return this.visitDeclaration$body$_EvaluateVisitor0(0, node);
            },
            visitDeclaration$body$_EvaluateVisitor0: function(_, node) {
                var $async$goto = 0, $async$completer = A._makeAsyncAwaitCompleter(type$.nullable_Value_2), $async$returnValue, $async$self = this, t1, $name, _0_0, _1_0, value, t2, t3, _2_0, oldDeclarationName;
                var $async$visitDeclaration$1 = A._wrapJsFunctionForAsync(function($async$errorCode, $async$result) {
                    if ($async$errorCode === 1) return A._asyncRethrow($async$result, $async$completer);
                    for(;;)switch($async$goto){
                        case 0:
                            // Function start
                            if (($async$self._async_evaluate0$_atRootExcludingStyleRule ? null : $async$self._async_evaluate0$_styleRuleIgnoringAtRoot) == null && !$async$self._async_evaluate0$_inUnknownAtRule && !$async$self._async_evaluate0$_inKeyframes) throw A.wrapException($async$self._async_evaluate0$_exception$2(string$.Declarm, node.span));
                            if ($async$self._async_evaluate0$_declarationName != null && !node.parsedAsSassScript) {
                                t1 = B.JSString_methods.startsWith$1(node.name.get$initialPlain(), "--") ? string$.Declarw : string$.Declarp;
                                throw A.wrapException($async$self._async_evaluate0$_exception$2(t1, node.span));
                            }
                            $async$goto = 3;
                            return A._asyncAwait($async$self._async_evaluate0$_interpolationToValue$2$warnForColor(node.name, true), $async$visitDeclaration$1);
                        case 3:
                            // returning from await.
                            $name = $async$result;
                            _0_0 = $async$self._async_evaluate0$_declarationName;
                            if (_0_0 != null) $name = new A.CssValue0(_0_0 + "-" + $name.value, $name.span, type$.CssValue_String_2);
                            _1_0 = node.value;
                            $async$goto = _1_0 != null ? 4 : 5;
                            break;
                        case 4:
                            // then
                            $async$goto = 6;
                            return A._asyncAwait(_1_0.accept$1($async$self), $async$visitDeclaration$1);
                        case 6:
                            // returning from await.
                            value = $async$result;
                            if (!value.get$isBlank() || value.get$asList().length === 0 || B.JSString_methods.startsWith$1($name.value, "--")) {
                                $async$self._async_evaluate0$_copyParentAfterSibling$0();
                                t1 = $async$self._async_evaluate0$_assertInModule$2($async$self._async_evaluate0$__parent, "__parent");
                                t2 = _1_0.get$span(_1_0);
                                if ($async$self._async_evaluate0$_sourceMap) {
                                    t3 = A.NullableExtension_andThen0(_1_0, $async$self.get$_async_evaluate0$_expressionNode());
                                    t3 = t3 == null ? null : J.get$span$x(t3);
                                } else t3 = null;
                                t1.addChild$1(A.ModifiableCssDeclaration$0($name, new A.CssValue0(value, t2, type$.CssValue_Value_2), node.span, node.parsedAsSassScript, t3));
                            }
                        case 5:
                            // join
                            _2_0 = node.children;
                            t1 = {};
                            t1.children = null;
                            $async$goto = _2_0 != null ? 7 : 8;
                            break;
                        case 7:
                            // then
                            t1.children = _2_0;
                            oldDeclarationName = $async$self._async_evaluate0$_declarationName;
                            $async$self._async_evaluate0$_declarationName = $name.value;
                            $async$goto = 9;
                            return A._asyncAwait($async$self._async_evaluate0$_environment.scope$1$2$when(new A._EvaluateVisitor_visitDeclaration_closure2(t1, $async$self), node.hasDeclarations, type$.Null), $async$visitDeclaration$1);
                        case 9:
                            // returning from await.
                            $async$self._async_evaluate0$_declarationName = oldDeclarationName;
                        case 8:
                            // join
                            $async$returnValue = null;
                            // goto return
                            $async$goto = 1;
                            break;
                        case 1:
                            // return
                            return A._asyncReturn($async$returnValue, $async$completer);
                    }
                });
                return A._asyncStartSync($async$visitDeclaration$1, $async$completer);
            },
            visitEachRule$1: function(_, node) {
                return this.visitEachRule$body$_EvaluateVisitor0(0, node);
            },
            visitEachRule$body$_EvaluateVisitor0: function(_, node) {
                var $async$goto = 0, $async$completer = A._makeAsyncAwaitCompleter(type$.nullable_Value_2), $async$returnValue, $async$self = this, t1, list, nodeWithSpan, _0_0;
                var $async$visitEachRule$1 = A._wrapJsFunctionForAsync(function($async$errorCode, $async$result) {
                    if ($async$errorCode === 1) return A._asyncRethrow($async$result, $async$completer);
                    for(;;)switch($async$goto){
                        case 0:
                            // Function start
                            t1 = node.list;
                            $async$goto = 3;
                            return A._asyncAwait(t1.accept$1($async$self), $async$visitEachRule$1);
                        case 3:
                            // returning from await.
                            list = $async$result;
                            nodeWithSpan = $async$self._async_evaluate0$_expressionNode$1(t1);
                            _0_0 = node.variables;
                            $label0$0: {
                                t1 = {};
                                t1.variable = null;
                                if (_0_0.length === 1) {
                                    t1.variable = _0_0[0];
                                    t1 = new A._EvaluateVisitor_visitEachRule_closure8(t1, $async$self, nodeWithSpan);
                                    break $label0$0;
                                }
                                t1 = {};
                                t1.variables = null;
                                t1.variables = _0_0;
                                t1 = new A._EvaluateVisitor_visitEachRule_closure9(t1, $async$self, nodeWithSpan);
                                break $label0$0;
                            }
                            $async$returnValue = $async$self._async_evaluate0$_environment.scope$1$2$semiGlobal(new A._EvaluateVisitor_visitEachRule_closure10($async$self, list, t1, node), true, type$.nullable_Value_2);
                            // goto return
                            $async$goto = 1;
                            break;
                        case 1:
                            // return
                            return A._asyncReturn($async$returnValue, $async$completer);
                    }
                });
                return A._asyncStartSync($async$visitEachRule$1, $async$completer);
            },
            _async_evaluate0$_setMultipleVariables$3: function(variables, value, nodeWithSpan) {
                var i, list = value.get$asList(), t1 = variables.length, minLength = Math.min(t1, list.length);
                for(i = 0; i < minLength; ++i)this._async_evaluate0$_environment.setLocalVariable$3(variables[i], this._async_evaluate0$_withoutSlash$2(list[i], nodeWithSpan), nodeWithSpan);
                for(i = minLength; i < t1; ++i)this._async_evaluate0$_environment.setLocalVariable$3(variables[i], B.C__SassNull0, nodeWithSpan);
            },
            visitErrorRule$1: function(_, node) {
                return this.visitErrorRule$body$_EvaluateVisitor0(0, node);
            },
            visitErrorRule$body$_EvaluateVisitor0: function(_, node) {
                var $async$goto = 0, $async$completer = A._makeAsyncAwaitCompleter(type$.Value_2), $async$self = this, $async$temp1, $async$temp2;
                var $async$visitErrorRule$1 = A._wrapJsFunctionForAsync(function($async$errorCode, $async$result) {
                    if ($async$errorCode === 1) return A._asyncRethrow($async$result, $async$completer);
                    for(;;)switch($async$goto){
                        case 0:
                            // Function start
                            $async$temp1 = A;
                            $async$temp2 = J;
                            $async$goto = 2;
                            return A._asyncAwait(node.expression.accept$1($async$self), $async$visitErrorRule$1);
                        case 2:
                            // returning from await.
                            throw $async$temp1.wrapException($async$self._async_evaluate0$_exception$2($async$temp2.toString$0$($async$result), node.span));
                    }
                });
                return A._asyncStartSync($async$visitErrorRule$1, $async$completer);
            },
            visitExtendRule$1: function(_, node) {
                return this.visitExtendRule$body$_EvaluateVisitor0(0, node);
            },
            visitExtendRule$body$_EvaluateVisitor0: function(_, node) {
                var $async$goto = 0, $async$completer = A._makeAsyncAwaitCompleter(type$.nullable_Value_2), $async$returnValue, $async$self = this, t1, t2, t3, t4, t5, _i, complex, visitor, t6, t7, _0_0, targetText, targetMap, compound, simple, styleRule;
                var $async$visitExtendRule$1 = A._wrapJsFunctionForAsync(function($async$errorCode, $async$result) {
                    if ($async$errorCode === 1) return A._asyncRethrow($async$result, $async$completer);
                    for(;;)switch($async$goto){
                        case 0:
                            // Function start
                            styleRule = $async$self._async_evaluate0$_atRootExcludingStyleRule ? null : $async$self._async_evaluate0$_styleRuleIgnoringAtRoot;
                            if (styleRule == null || $async$self._async_evaluate0$_declarationName != null) throw A.wrapException($async$self._async_evaluate0$_exception$2(string$.x40exten, node.span));
                            for(t1 = styleRule.originalSelector.components, t2 = t1.length, t3 = node.span, t4 = type$.SourceSpan, t5 = type$.String, _i = 0; _i < t2; ++_i){
                                complex = t1[_i];
                                if (!complex.accept$1(B._IsBogusVisitor_true0)) continue;
                                visitor = A._SerializeVisitor$0(null, true, null, null, true, false, null, true);
                                complex.accept$1(visitor);
                                t6 = B.JSString_methods.trim$0(visitor._serialize0$_buffer.toString$0(0));
                                t7 = complex.accept$1(B.C__IsUselessVisitor0) ? "can't" : "shouldn't";
                                $async$self._async_evaluate0$_warn$3('The selector "' + t6 + '" is invalid CSS and ' + t7 + string$.x20be_an, new A.MultiSpan0(A.SpanExtensions_trimRight0(complex.span), "invalid selector", A.ConstantMap_ConstantMap$from(A.LinkedHashMap_LinkedHashMap$_literal([
                                    t3,
                                    "@extend rule"
                                ], t4, t5), t4, t5)), B.Deprecation_2PR);
                            }
                            $async$goto = 3;
                            return A._asyncAwait($async$self._async_evaluate0$_performInterpolationWithMap$2$warnForColor(node.selector, true), $async$visitExtendRule$1);
                        case 3:
                            // returning from await.
                            _0_0 = $async$result;
                            targetText = _0_0._0;
                            targetMap = _0_0._1;
                            for(t1 = A.SelectorList_SelectorList$parse0(A.trimAscii0(targetText, true), false, targetMap, $async$self._async_evaluate0$_logger, false).components, t2 = t1.length, t3 = styleRule._style_rule0$_selector._box0$_inner, _i = 0; _i < t2; ++_i){
                                complex = t1[_i];
                                compound = complex.get$singleCompound();
                                if (compound == null) throw A.wrapException(A.SassFormatException$0("complex selectors may not be extended.", complex.span, null));
                                t4 = compound.components;
                                simple = t4.length === 1 ? B.JSArray_methods.get$first(t4) : null;
                                if (simple == null) throw A.wrapException(A.SassFormatException$0(string$.compou + B.JSArray_methods.join$1(t4, ", ") + string$.x60_inst, compound.span, null));
                                $async$self._async_evaluate0$_assertInModule$2($async$self._async_evaluate0$__extensionStore, "_extensionStore").addExtension$4(t3.value, simple, node, $async$self._async_evaluate0$_mediaQueries);
                            }
                            $async$returnValue = null;
                            // goto return
                            $async$goto = 1;
                            break;
                        case 1:
                            // return
                            return A._asyncReturn($async$returnValue, $async$completer);
                    }
                });
                return A._asyncStartSync($async$visitExtendRule$1, $async$completer);
            },
            visitAtRule$1: function(_, node) {
                return this.visitAtRule$body$_EvaluateVisitor0(0, node);
            },
            visitAtRule$body$_EvaluateVisitor0: function(_, node) {
                var $async$goto = 0, $async$completer = A._makeAsyncAwaitCompleter(type$.nullable_Value_2), $async$returnValue, $async$self = this, $name, t1, value, children, wasInKeyframes, wasInUnknownAtRule, rule;
                var $async$visitAtRule$1 = A._wrapJsFunctionForAsync(function($async$errorCode, $async$result) {
                    if ($async$errorCode === 1) return A._asyncRethrow($async$result, $async$completer);
                    for(;;)switch($async$goto){
                        case 0:
                            // Function start
                            if ($async$self._async_evaluate0$_declarationName != null) throw A.wrapException($async$self._async_evaluate0$_exception$2(string$.At_rul, node.span));
                            $async$goto = 3;
                            return A._asyncAwait($async$self._async_evaluate0$_interpolationToValue$1(node.name), $async$visitAtRule$1);
                        case 3:
                            // returning from await.
                            $name = $async$result;
                            t1 = A.NullableExtension_andThen0(node.value, new A._EvaluateVisitor_visitAtRule_closure11($async$self));
                            $async$goto = 4;
                            return A._asyncAwait(type$.Future_nullable_CssValue_String_2._is(t1) ? t1 : A._Future$value(t1, type$.nullable_CssValue_String_2), $async$visitAtRule$1);
                        case 4:
                            // returning from await.
                            value = $async$result;
                            children = node.children;
                            if (children == null) {
                                $async$self._async_evaluate0$_copyParentAfterSibling$0();
                                $async$self._async_evaluate0$_assertInModule$2($async$self._async_evaluate0$__parent, "__parent").addChild$1(A.ModifiableCssAtRule$0($name, node.span, true, value));
                                $async$returnValue = null;
                                // goto return
                                $async$goto = 1;
                                break;
                            }
                            wasInKeyframes = $async$self._async_evaluate0$_inKeyframes;
                            wasInUnknownAtRule = $async$self._async_evaluate0$_inUnknownAtRule;
                            if (A.unvendor0($name.value) === "keyframes") $async$self._async_evaluate0$_inKeyframes = true;
                            else $async$self._async_evaluate0$_inUnknownAtRule = true;
                            rule = A.ModifiableCssAtRule$0($name, node.span, false, value);
                            $async$goto = $async$self.get$_async_evaluate0$_hasCssNesting() ? 5 : 6;
                            break;
                        case 5:
                            // then
                            $async$goto = 7;
                            return A._asyncAwait($async$self._async_evaluate0$_withParent$2$3$scopeWhen(rule, new A._EvaluateVisitor_visitAtRule_closure12($async$self, children), node.hasDeclarations, type$.ModifiableCssAtRule_2, type$.Null), $async$visitAtRule$1);
                        case 7:
                            // returning from await.
                            $async$self._async_evaluate0$_inUnknownAtRule = wasInUnknownAtRule;
                            $async$self._async_evaluate0$_inKeyframes = wasInKeyframes;
                            $async$returnValue = null;
                            // goto return
                            $async$goto = 1;
                            break;
                        case 6:
                            // join
                            $async$goto = 8;
                            return A._asyncAwait($async$self._async_evaluate0$_withParent$2$4$scopeWhen$through(rule, new A._EvaluateVisitor_visitAtRule_closure13($async$self, $name, children), node.hasDeclarations, new A._EvaluateVisitor_visitAtRule_closure14(), type$.ModifiableCssAtRule_2, type$.Null), $async$visitAtRule$1);
                        case 8:
                            // returning from await.
                            $async$self._async_evaluate0$_inUnknownAtRule = wasInUnknownAtRule;
                            $async$self._async_evaluate0$_inKeyframes = wasInKeyframes;
                            $async$returnValue = null;
                            // goto return
                            $async$goto = 1;
                            break;
                        case 1:
                            // return
                            return A._asyncReturn($async$returnValue, $async$completer);
                    }
                });
                return A._asyncStartSync($async$visitAtRule$1, $async$completer);
            },
            visitForRule$1: function(_, node) {
                return this.visitForRule$body$_EvaluateVisitor0(0, node);
            },
            visitForRule$body$_EvaluateVisitor0: function(_, node) {
                var $async$goto = 0, $async$completer = A._makeAsyncAwaitCompleter(type$.nullable_Value_2), $async$returnValue, $async$self = this, t1, t2, t3, fromNumber, t4, toNumber, from, to, direction;
                var $async$visitForRule$1 = A._wrapJsFunctionForAsync(function($async$errorCode, $async$result) {
                    if ($async$errorCode === 1) return A._asyncRethrow($async$result, $async$completer);
                    for(;;)switch($async$goto){
                        case 0:
                            // Function start
                            t1 = {};
                            t2 = node.from;
                            t3 = type$.SassNumber_2;
                            $async$goto = 3;
                            return A._asyncAwait($async$self._async_evaluate0$_addExceptionSpanAsync$1$2(t2, new A._EvaluateVisitor_visitForRule_closure14($async$self, node), t3), $async$visitForRule$1);
                        case 3:
                            // returning from await.
                            fromNumber = $async$result;
                            t4 = node.to;
                            $async$goto = 4;
                            return A._asyncAwait($async$self._async_evaluate0$_addExceptionSpanAsync$1$2(t4, new A._EvaluateVisitor_visitForRule_closure15($async$self, node), t3), $async$visitForRule$1);
                        case 4:
                            // returning from await.
                            toNumber = $async$result;
                            from = $async$self._async_evaluate0$_addExceptionSpan$2(t2, new A._EvaluateVisitor_visitForRule_closure16(fromNumber));
                            to = t1.to = $async$self._async_evaluate0$_addExceptionSpan$2(t4, new A._EvaluateVisitor_visitForRule_closure17(toNumber, fromNumber));
                            direction = from > to ? -1 : 1;
                            if (from === (!node.isExclusive ? t1.to = to + direction : to)) {
                                $async$returnValue = null;
                                // goto return
                                $async$goto = 1;
                                break;
                            }
                            $async$returnValue = $async$self._async_evaluate0$_environment.scope$1$2$semiGlobal(new A._EvaluateVisitor_visitForRule_closure18(t1, $async$self, node, from, direction, fromNumber), true, type$.nullable_Value_2);
                            // goto return
                            $async$goto = 1;
                            break;
                        case 1:
                            // return
                            return A._asyncReturn($async$returnValue, $async$completer);
                    }
                });
                return A._asyncStartSync($async$visitForRule$1, $async$completer);
            },
            visitForwardRule$1: function(_, node) {
                return this.visitForwardRule$body$_EvaluateVisitor0(0, node);
            },
            visitForwardRule$body$_EvaluateVisitor0: function(_, node) {
                var $async$goto = 0, $async$completer = A._makeAsyncAwaitCompleter(type$.nullable_Value_2), $async$returnValue, $async$self = this, newConfiguration, t4, _i, variable, $name, oldConfiguration, adjustedConfiguration, t1, t2, t3;
                var $async$visitForwardRule$1 = A._wrapJsFunctionForAsync(function($async$errorCode, $async$result) {
                    if ($async$errorCode === 1) return A._asyncRethrow($async$result, $async$completer);
                    for(;;)switch($async$goto){
                        case 0:
                            // Function start
                            oldConfiguration = $async$self._async_evaluate0$_configuration;
                            adjustedConfiguration = oldConfiguration.throughForward$1(node);
                            t1 = node.configuration;
                            t2 = t1.length;
                            t3 = node.url;
                            $async$goto = t2 !== 0 ? 3 : 5;
                            break;
                        case 3:
                            // then
                            $async$goto = 6;
                            return A._asyncAwait($async$self._async_evaluate0$_addForwardConfiguration$2(adjustedConfiguration, node), $async$visitForwardRule$1);
                        case 6:
                            // returning from await.
                            newConfiguration = $async$result;
                            $async$goto = 7;
                            return A._asyncAwait($async$self._async_evaluate0$_loadModule$5$configuration(t3, "@forward", node, new A._EvaluateVisitor_visitForwardRule_closure5($async$self, node), newConfiguration), $async$visitForwardRule$1);
                        case 7:
                            // returning from await.
                            t3 = type$.String;
                            t4 = A.LinkedHashSet_LinkedHashSet$_empty(t3);
                            for(_i = 0; _i < t2; ++_i){
                                variable = t1[_i];
                                if (!variable.isGuarded) t4.add$1(0, variable.name);
                            }
                            $async$self._async_evaluate0$_removeUsedConfiguration$3$except(adjustedConfiguration, newConfiguration, t4);
                            t3 = A.LinkedHashSet_LinkedHashSet$_empty(t3);
                            for(_i = 0; _i < t2; ++_i)t3.add$1(0, t1[_i].name);
                            for(t1 = newConfiguration._configuration0$_values, t2 = t1.get$keys(t1), t2 = t2.toList$0(t2), t4 = t2.length, _i = 0; _i < t2.length; t2.length === t4 || (0, A.throwConcurrentModificationError)(t2), ++_i){
                                $name = t2[_i];
                                if (!t3.contains$1(0, $name)) {
                                    if (!t1.get$isEmpty(t1)) t1.remove$1(0, $name);
                                }
                            }
                            $async$self._async_evaluate0$_assertConfigurationIsEmpty$1(newConfiguration);
                            // goto join
                            $async$goto = 4;
                            break;
                        case 5:
                            // else
                            $async$self._async_evaluate0$_configuration = adjustedConfiguration;
                            $async$goto = 8;
                            return A._asyncAwait($async$self._async_evaluate0$_loadModule$4(t3, "@forward", node, new A._EvaluateVisitor_visitForwardRule_closure6($async$self, node)), $async$visitForwardRule$1);
                        case 8:
                            // returning from await.
                            $async$self._async_evaluate0$_configuration = oldConfiguration;
                        case 4:
                            // join
                            $async$returnValue = null;
                            // goto return
                            $async$goto = 1;
                            break;
                        case 1:
                            // return
                            return A._asyncReturn($async$returnValue, $async$completer);
                    }
                });
                return A._asyncStartSync($async$visitForwardRule$1, $async$completer);
            },
            _async_evaluate0$_addForwardConfiguration$2: function(configuration, node) {
                return this._addForwardConfiguration$body$_EvaluateVisitor0(configuration, node);
            },
            _addForwardConfiguration$body$_EvaluateVisitor0: function(configuration, node) {
                var $async$goto = 0, $async$completer = A._makeAsyncAwaitCompleter(type$.Configuration_2), $async$returnValue, $async$self = this, t2, t3, t4, t5, _i, variable, t6, _0_0, t7, oldValue, variableNodeWithSpan, t1, newValues, $async$temp1, $async$temp2, $async$temp3;
                var $async$_async_evaluate0$_addForwardConfiguration$2 = A._wrapJsFunctionForAsync(function($async$errorCode, $async$result) {
                    if ($async$errorCode === 1) return A._asyncRethrow($async$result, $async$completer);
                    for(;;)switch($async$goto){
                        case 0:
                            // Function start
                            t1 = configuration._configuration0$_values;
                            newValues = A.LinkedHashMap_LinkedHashMap$of(new A.UnmodifiableMapView(t1, type$.UnmodifiableMapView_String_ConfiguredValue_2), type$.String, type$.ConfiguredValue_2);
                            t2 = node.configuration, t3 = t2.length, t4 = type$._Future_Value_2, t5 = type$.Future_Value_2, _i = 0;
                        case 3:
                            // for condition
                            if (!(_i < t3)) {
                                // goto after for
                                $async$goto = 5;
                                break;
                            }
                            variable = t2[_i];
                            if (variable.isGuarded) {
                                t6 = variable.name;
                                _0_0 = t1.get$isEmpty(t1) ? null : t1.remove$1(0, t6);
                                if (_0_0 != null) {
                                    t7 = !_0_0.value.$eq(0, B.C__SassNull0);
                                    oldValue = _0_0;
                                } else {
                                    oldValue = null;
                                    t7 = false;
                                }
                                if (t7) {
                                    newValues.$indexSet(0, t6, oldValue);
                                    // goto for update
                                    $async$goto = 4;
                                    break;
                                }
                            }
                            t6 = variable.expression;
                            variableNodeWithSpan = $async$self._async_evaluate0$_expressionNode$1(t6);
                            t6 = t6.accept$1($async$self);
                            if (!t5._is(t6)) {
                                t7 = new A._Future($.Zone__current, t4);
                                t7._state = 8;
                                t7._resultOrListeners = t6;
                                t6 = t7;
                            }
                            $async$temp1 = newValues;
                            $async$temp2 = variable.name;
                            $async$temp3 = A;
                            $async$goto = 6;
                            return A._asyncAwait(t6, $async$_async_evaluate0$_addForwardConfiguration$2);
                        case 6:
                            // returning from await.
                            $async$temp1.$indexSet(0, $async$temp2, new $async$temp3.ConfiguredValue0($async$self._async_evaluate0$_withoutSlash$2($async$result, variableNodeWithSpan), variable.span, variableNodeWithSpan));
                        case 4:
                            // for update
                            ++_i;
                            // goto for condition
                            $async$goto = 3;
                            break;
                        case 5:
                            // after for
                            if (configuration instanceof A.ExplicitConfiguration0 || t1.get$isEmpty(t1)) {
                                $async$returnValue = new A.ExplicitConfiguration0(node, newValues, null);
                                // goto return
                                $async$goto = 1;
                                break;
                            } else {
                                $async$returnValue = new A.Configuration0(newValues, null);
                                // goto return
                                $async$goto = 1;
                                break;
                            }
                        case 1:
                            // return
                            return A._asyncReturn($async$returnValue, $async$completer);
                    }
                });
                return A._asyncStartSync($async$_async_evaluate0$_addForwardConfiguration$2, $async$completer);
            },
            _async_evaluate0$_registerCommentsForModule$1: function(module) {
                var _this = this, _s5_ = "_root", t1 = _this._async_evaluate0$__root;
                if (t1 == null) return;
                if (_this._async_evaluate0$_assertInModule$2(t1, _s5_).children.get$length(0) === 0 || !module.get$transitivelyContainsCss()) return;
                t1 = _this._async_evaluate0$_preModuleComments;
                if (t1 == null) t1 = _this._async_evaluate0$_preModuleComments = A.LinkedHashMap_LinkedHashMap$_empty(type$.Module_AsyncCallable_2, type$.List_CssComment_2);
                J.addAll$1$ax(t1.putIfAbsent$2(module, new A._EvaluateVisitor__registerCommentsForModule_closure2()), new A.UnmodifiableListView(J.cast$1$0$ax(_this._async_evaluate0$_assertInModule$2(_this._async_evaluate0$__root, _s5_).children._collection$_source, type$.CssComment_2), type$.UnmodifiableListView_CssComment_2));
                _this._async_evaluate0$_assertInModule$2(_this._async_evaluate0$__root, _s5_).clearChildren$0();
                _this._async_evaluate0$__endOfImports = 0;
            },
            _async_evaluate0$_removeUsedConfiguration$3$except: function(upstream, downstream, except) {
                var t1, t2, t3, t4, _i, $name;
                for(t1 = upstream._configuration0$_values, t2 = t1.get$keys(t1), t2 = t2.toList$0(t2), t3 = t2.length, t4 = downstream._configuration0$_values, _i = 0; _i < t2.length; t2.length === t3 || (0, A.throwConcurrentModificationError)(t2), ++_i){
                    $name = t2[_i];
                    if (except.contains$1(0, $name)) continue;
                    if (!t4.containsKey$1($name)) {
                        if (!t1.get$isEmpty(t1)) t1.remove$1(0, $name);
                    }
                }
            },
            _async_evaluate0$_assertConfigurationIsEmpty$2$nameInError: function(configuration, nameInError) {
                var t1, _0_0;
                if (!(configuration instanceof A.ExplicitConfiguration0)) return;
                t1 = configuration._configuration0$_values;
                if (t1.get$isEmpty(t1)) return;
                t1 = A.MapExtensions_get_pairs0(new A.UnmodifiableMapView(t1, type$.UnmodifiableMapView_String_ConfiguredValue_2), type$.String, type$.ConfiguredValue_2);
                _0_0 = t1.get$first(t1);
                t1 = nameInError ? "$" + _0_0._0 + string$.x20was_n : string$.This_v;
                throw A.wrapException(this._async_evaluate0$_exception$2(t1, _0_0._1.configurationSpan));
            },
            _async_evaluate0$_assertConfigurationIsEmpty$1: function(configuration) {
                return this._async_evaluate0$_assertConfigurationIsEmpty$2$nameInError(configuration, false);
            },
            visitFunctionRule$1: function(_, node) {
                return this.visitFunctionRule$body$_EvaluateVisitor0(0, node);
            },
            visitFunctionRule$body$_EvaluateVisitor0: function(_, node) {
                var $async$goto = 0, $async$completer = A._makeAsyncAwaitCompleter(type$.nullable_Value_2), $async$returnValue, $async$self = this, t1, t2, t3, t4, index, t5;
                var $async$visitFunctionRule$1 = A._wrapJsFunctionForAsync(function($async$errorCode, $async$result) {
                    if ($async$errorCode === 1) return A._asyncRethrow($async$result, $async$completer);
                    for(;;)switch($async$goto){
                        case 0:
                            // Function start
                            t1 = $async$self._async_evaluate0$_environment;
                            t2 = t1.closure$0();
                            t3 = $async$self._async_evaluate0$_inDependency;
                            t4 = t1._async_environment0$_functions;
                            index = t4.length - 1;
                            t5 = node.name;
                            t1._async_environment0$_functionIndices.$indexSet(0, t5, index);
                            t4[index].$indexSet(0, t5, new A.UserDefinedCallable0(node, t2, t3, type$.UserDefinedCallable_AsyncEnvironment_2));
                            $async$returnValue = null;
                            // goto return
                            $async$goto = 1;
                            break;
                        case 1:
                            // return
                            return A._asyncReturn($async$returnValue, $async$completer);
                    }
                });
                return A._asyncStartSync($async$visitFunctionRule$1, $async$completer);
            },
            visitIfRule$1: function(_, node) {
                return this.visitIfRule$body$_EvaluateVisitor0(0, node);
            },
            visitIfRule$body$_EvaluateVisitor0: function(_, node) {
                var $async$goto = 0, $async$completer = A._makeAsyncAwaitCompleter(type$.nullable_Value_2), $async$returnValue, $async$self = this, t1, t2, _i, clauseToCheck, clause;
                var $async$visitIfRule$1 = A._wrapJsFunctionForAsync(function($async$errorCode, $async$result) {
                    if ($async$errorCode === 1) return A._asyncRethrow($async$result, $async$completer);
                    for(;;)switch($async$goto){
                        case 0:
                            // Function start
                            clause = node.lastClause;
                            t1 = node.clauses, t2 = t1.length, _i = 0;
                        case 3:
                            // for condition
                            if (!(_i < t2)) {
                                // goto after for
                                $async$goto = 5;
                                break;
                            }
                            clauseToCheck = t1[_i];
                            $async$goto = 6;
                            return A._asyncAwait(clauseToCheck.expression.accept$1($async$self), $async$visitIfRule$1);
                        case 6:
                            // returning from await.
                            if ($async$result.get$isTruthy()) {
                                clause = clauseToCheck;
                                // goto after for
                                $async$goto = 5;
                                break;
                            }
                        case 4:
                            // for update
                            ++_i;
                            // goto for condition
                            $async$goto = 3;
                            break;
                        case 5:
                            // after for
                            t1 = A.NullableExtension_andThen0(clause, new A._EvaluateVisitor_visitIfRule_closure2($async$self));
                            $async$goto = 7;
                            return A._asyncAwait(type$.Future_nullable_Value_2._is(t1) ? t1 : A._Future$value(t1, type$.nullable_Value_2), $async$visitIfRule$1);
                        case 7:
                            // returning from await.
                            $async$returnValue = $async$result;
                            // goto return
                            $async$goto = 1;
                            break;
                        case 1:
                            // return
                            return A._asyncReturn($async$returnValue, $async$completer);
                    }
                });
                return A._asyncStartSync($async$visitIfRule$1, $async$completer);
            },
            visitImportRule$1: function(_, node) {
                return this.visitImportRule$body$_EvaluateVisitor0(0, node);
            },
            visitImportRule$body$_EvaluateVisitor0: function(_, node) {
                var $async$goto = 0, $async$completer = A._makeAsyncAwaitCompleter(type$.nullable_Value_2), $async$returnValue, $async$self = this, t1, t2, t3, _i, $import;
                var $async$visitImportRule$1 = A._wrapJsFunctionForAsync(function($async$errorCode, $async$result) {
                    if ($async$errorCode === 1) return A._asyncRethrow($async$result, $async$completer);
                    for(;;)switch($async$goto){
                        case 0:
                            // Function start
                            t1 = node.imports, t2 = t1.length, t3 = type$.StaticImport_2, _i = 0;
                        case 3:
                            // for condition
                            if (!(_i < t2)) {
                                // goto after for
                                $async$goto = 5;
                                break;
                            }
                            $import = t1[_i];
                            $async$goto = $import instanceof A.DynamicImport0 ? 6 : 8;
                            break;
                        case 6:
                            // then
                            $async$goto = 9;
                            return A._asyncAwait($async$self._async_evaluate0$_visitDynamicImport$1($import), $async$visitImportRule$1);
                        case 9:
                            // returning from await.
                            // goto join
                            $async$goto = 7;
                            break;
                        case 8:
                            // else
                            $async$goto = 10;
                            return A._asyncAwait($async$self._async_evaluate0$_visitStaticImport$1(t3._as($import)), $async$visitImportRule$1);
                        case 10:
                        // returning from await.
                        case 7:
                        // join
                        case 4:
                            // for update
                            ++_i;
                            // goto for condition
                            $async$goto = 3;
                            break;
                        case 5:
                            // after for
                            $async$returnValue = null;
                            // goto return
                            $async$goto = 1;
                            break;
                        case 1:
                            // return
                            return A._asyncReturn($async$returnValue, $async$completer);
                    }
                });
                return A._asyncStartSync($async$visitImportRule$1, $async$completer);
            },
            _async_evaluate0$_visitDynamicImport$1: function($import) {
                return this._async_evaluate0$_withStackFrame$1$3("@import", $import, new A._EvaluateVisitor__visitDynamicImport_closure2(this, $import), type$.void);
            },
            _async_evaluate0$_loadStylesheet$4$baseUrl$forImport: function(url, span, baseUrl, forImport) {
                return this._loadStylesheet$body$_EvaluateVisitor0(url, span, baseUrl, forImport);
            },
            _async_evaluate0$_loadStylesheet$3$baseUrl: function(url, span, baseUrl) {
                return this._async_evaluate0$_loadStylesheet$4$baseUrl$forImport(url, span, baseUrl, false);
            },
            _async_evaluate0$_loadStylesheet$3$forImport: function(url, span, forImport) {
                return this._async_evaluate0$_loadStylesheet$4$baseUrl$forImport(url, span, null, forImport);
            },
            _loadStylesheet$body$_EvaluateVisitor0: function(url, span, baseUrl, forImport) {
                var $async$goto = 0, $async$completer = A._makeAsyncAwaitCompleter(type$.Record_3_Stylesheet_and_nullable_AsyncImporter_importer_and_bool_isDependency_2), $async$returnValue, $async$handler = 2, $async$errorStack = [], $async$next = [], $async$self = this, _0_0, importCache, _1_0, importer, canonicalUrl, originalUrl, isDependency, _2_0, stylesheet, _3_0, result, error, stackTrace, error0, stackTrace0, t1, t2, exception, $async$exception;
                var $async$_async_evaluate0$_loadStylesheet$4$baseUrl$forImport = A._wrapJsFunctionForAsync(function($async$errorCode, $async$result) {
                    if ($async$errorCode === 1) {
                        $async$errorStack.push($async$result);
                        $async$goto = $async$handler;
                    }
                    for(;;)switch($async$goto){
                        case 0:
                            // Function start
                            baseUrl;
                            $async$handler = 4;
                            $async$self._async_evaluate0$_importSpan = span;
                            _0_0 = $async$self._async_evaluate0$_importCache;
                            importCache = null;
                            $async$goto = _0_0 != null ? 7 : 8;
                            break;
                        case 7:
                            // then
                            importCache = _0_0;
                            if (baseUrl == null) {
                                t1 = $async$self._async_evaluate0$_assertInModule$2($async$self._async_evaluate0$__stylesheet, "_stylesheet").span;
                                baseUrl = t1.get$sourceUrl(t1);
                            }
                            $async$goto = 9;
                            return A._asyncAwait(J.canonicalize$4$baseImporter$baseUrl$forImport$x(importCache, A.Uri_parse(url), $async$self._async_evaluate0$_importer, baseUrl, forImport), $async$_async_evaluate0$_loadStylesheet$4$baseUrl$forImport);
                        case 9:
                            // returning from await.
                            _1_0 = $async$result;
                            importer = null;
                            canonicalUrl = null;
                            originalUrl = null;
                            $async$goto = type$.Record_3_nullable_Object_and_nullable_Object_and_nullable_Object_originalUrl._is(_1_0) ? 10 : 11;
                            break;
                        case 10:
                            // then
                            importer = _1_0._0;
                            canonicalUrl = _1_0._1;
                            originalUrl = _1_0._2;
                            if (canonicalUrl.get$scheme() === "") A.WarnForDeprecation_warnForDeprecation0($async$self._async_evaluate0$_logger, B.Deprecation_Vc9, "Importer " + A.S(importer) + " canonicalized " + url + " to " + A.S(canonicalUrl) + string$.x2e_Rela, null, null);
                            $async$self._async_evaluate0$_loadedUrls.add$1(0, canonicalUrl);
                            isDependency = $async$self._async_evaluate0$_inDependency || !J.$eq$(importer, $async$self._async_evaluate0$_importer);
                            $async$goto = 12;
                            return A._asyncAwait(importCache.importCanonical$3$originalUrl(importer, canonicalUrl, originalUrl), $async$_async_evaluate0$_loadStylesheet$4$baseUrl$forImport);
                        case 12:
                            // returning from await.
                            _2_0 = $async$result;
                            stylesheet = null;
                            if (_2_0 != null) {
                                stylesheet = _2_0;
                                t1 = stylesheet;
                                t2 = importer;
                                $async$returnValue = new A._Record_3_importer_isDependency(t1, t2, isDependency);
                                $async$next = [
                                    1
                                ];
                                // goto finally
                                $async$goto = 5;
                                break;
                            }
                        case 11:
                        // join
                        case 8:
                            // join
                            $async$goto = $async$self._async_evaluate0$_nodeImporter != null ? 13 : 14;
                            break;
                        case 13:
                            // then
                            t1 = baseUrl;
                            if (t1 == null) {
                                t1 = $async$self._async_evaluate0$_assertInModule$2($async$self._async_evaluate0$__stylesheet, "_stylesheet").span;
                                t1 = t1.get$sourceUrl(t1);
                            }
                            $async$goto = 15;
                            return A._asyncAwait($async$self._async_evaluate0$_importLikeNode$3(url, t1, forImport), $async$_async_evaluate0$_loadStylesheet$4$baseUrl$forImport);
                        case 15:
                            // returning from await.
                            _3_0 = $async$result;
                            result = null;
                            if (_3_0 != null) {
                                result = _3_0;
                                t1 = result._0.span;
                                t2 = $async$self._async_evaluate0$_loadedUrls;
                                A.NullableExtension_andThen0(t1.get$sourceUrl(t1), t2.get$add(t2));
                                t2 = result;
                                $async$returnValue = t2;
                                $async$next = [
                                    1
                                ];
                                // goto finally
                                $async$goto = 5;
                                break;
                            }
                        case 14:
                            // join
                            t1 = B.JSString_methods.startsWith$1(url, "package:");
                            if (t1) throw A.wrapException(string$.x22packa);
                            else throw A.wrapException("Can't find stylesheet to import.");
                            $async$next.push(6);
                            // goto finally
                            $async$goto = 5;
                            break;
                        case 4:
                            // catch
                            $async$handler = 3;
                            $async$exception = $async$errorStack.pop();
                            t1 = A.unwrapException($async$exception);
                            if (t1 instanceof A.SassException0) throw $async$exception;
                            else if (t1 instanceof A.ArgumentError) {
                                error = t1;
                                stackTrace = A.getTraceFromException($async$exception);
                                A.throwWithTrace0($async$self._async_evaluate0$_exception$1(J.toString$0$(error)), error, stackTrace);
                            } else {
                                error0 = t1;
                                stackTrace0 = A.getTraceFromException($async$exception);
                                A.throwWithTrace0($async$self._async_evaluate0$_exception$1($async$self._async_evaluate0$_getErrorMessage$1(error0)), error0, stackTrace0);
                            }
                            $async$next.push(6);
                            // goto finally
                            $async$goto = 5;
                            break;
                        case 3:
                            // uncaught
                            $async$next = [
                                2
                            ];
                        case 5:
                            // finally
                            $async$handler = 2;
                            $async$self._async_evaluate0$_importSpan = null;
                            // goto the next finally handler
                            $async$goto = $async$next.pop();
                            break;
                        case 6:
                        // after finally
                        case 1:
                            // return
                            return A._asyncReturn($async$returnValue, $async$completer);
                        case 2:
                            // rethrow
                            return A._asyncRethrow($async$errorStack.at(-1), $async$completer);
                    }
                });
                return A._asyncStartSync($async$_async_evaluate0$_loadStylesheet$4$baseUrl$forImport, $async$completer);
            },
            _async_evaluate0$_importLikeNode$3: function(originalUrl, previous, forImport) {
                return this._importLikeNode$body$_EvaluateVisitor(originalUrl, previous, forImport);
            },
            _importLikeNode$body$_EvaluateVisitor: function(originalUrl, previous, forImport) {
                var $async$goto = 0, $async$completer = A._makeAsyncAwaitCompleter(type$.nullable_Record_3_Stylesheet_and_nullable_AsyncImporter_importer_and_bool_isDependency), $async$returnValue, $async$self = this, isDependency, url, t1, result;
                var $async$_async_evaluate0$_importLikeNode$3 = A._wrapJsFunctionForAsync(function($async$errorCode, $async$result) {
                    if ($async$errorCode === 1) return A._asyncRethrow($async$result, $async$completer);
                    for(;;)switch($async$goto){
                        case 0:
                            // Function start
                            t1 = $async$self._async_evaluate0$_nodeImporter;
                            result = t1.loadRelative$3(originalUrl, previous, forImport);
                            $async$goto = result != null ? 3 : 5;
                            break;
                        case 3:
                            // then
                            isDependency = $async$self._async_evaluate0$_inDependency;
                            // goto join
                            $async$goto = 4;
                            break;
                        case 5:
                            // else
                            $async$goto = 6;
                            return A._asyncAwait(t1.loadAsync$3(originalUrl, previous, forImport), $async$_async_evaluate0$_importLikeNode$3);
                        case 6:
                            // returning from await.
                            result = $async$result;
                            if (result == null) {
                                $async$returnValue = null;
                                // goto return
                                $async$goto = 1;
                                break;
                            }
                            isDependency = true;
                        case 4:
                            // join
                            url = result._1;
                            t1 = B.JSString_methods.startsWith$1(url, "file") ? A.Syntax_forPath0(url) : B.Syntax_SCSS_0_scss0;
                            $async$returnValue = new A._Record_3_importer_isDependency(A.Stylesheet_Stylesheet$parse0(result._0, t1, false, url), null, isDependency);
                            // goto return
                            $async$goto = 1;
                            break;
                        case 1:
                            // return
                            return A._asyncReturn($async$returnValue, $async$completer);
                    }
                });
                return A._asyncStartSync($async$_async_evaluate0$_importLikeNode$3, $async$completer);
            },
            _async_evaluate0$_visitStaticImport$1: function($import) {
                return this._visitStaticImport$body$_EvaluateVisitor0($import);
            },
            _visitStaticImport$body$_EvaluateVisitor0: function($import) {
                var $async$goto = 0, $async$completer = A._makeAsyncAwaitCompleter(type$.void), $async$self = this, t1, t2, node, $async$temp1, $async$temp2;
                var $async$_async_evaluate0$_visitStaticImport$1 = A._wrapJsFunctionForAsync(function($async$errorCode, $async$result) {
                    if ($async$errorCode === 1) return A._asyncRethrow($async$result, $async$completer);
                    for(;;)switch($async$goto){
                        case 0:
                            // Function start
                            $async$goto = 2;
                            return A._asyncAwait($async$self._async_evaluate0$_interpolationToValue$1($import.url), $async$_async_evaluate0$_visitStaticImport$1);
                        case 2:
                            // returning from await.
                            t1 = $async$result;
                            t2 = A.NullableExtension_andThen0($import.modifiers, $async$self.get$_async_evaluate0$_interpolationToValue());
                            $async$temp1 = A;
                            $async$temp2 = t1;
                            $async$goto = 3;
                            return A._asyncAwait(type$.Future_nullable_CssValue_String_2._is(t2) ? t2 : A._Future$value(t2, type$.nullable_CssValue_String_2), $async$_async_evaluate0$_visitStaticImport$1);
                        case 3:
                            // returning from await.
                            node = new $async$temp1.ModifiableCssImport0($async$temp2, $async$result, $import.span);
                            if ($async$self._async_evaluate0$_assertInModule$2($async$self._async_evaluate0$__parent, "__parent") !== $async$self._async_evaluate0$_assertInModule$2($async$self._async_evaluate0$__root, "_root")) {
                                $async$self._async_evaluate0$_copyParentAfterSibling$0();
                                $async$self._async_evaluate0$_assertInModule$2($async$self._async_evaluate0$__parent, "__parent").addChild$1(node);
                            } else if ($async$self._async_evaluate0$_assertInModule$2($async$self._async_evaluate0$__endOfImports, "_endOfImports") === J.get$length$asx($async$self._async_evaluate0$_assertInModule$2($async$self._async_evaluate0$__root, "_root").children._collection$_source)) {
                                $async$self._async_evaluate0$_assertInModule$2($async$self._async_evaluate0$__root, "_root").addChild$1(node);
                                $async$self._async_evaluate0$__endOfImports = $async$self._async_evaluate0$_assertInModule$2($async$self._async_evaluate0$__endOfImports, "_endOfImports") + 1;
                            } else {
                                t1 = $async$self._async_evaluate0$_outOfOrderImports;
                                (t1 == null ? $async$self._async_evaluate0$_outOfOrderImports = A._setArrayType([], type$.JSArray_ModifiableCssImport_2) : t1).push(node);
                            }
                            // implicit return
                            return A._asyncReturn(null, $async$completer);
                    }
                });
                return A._asyncStartSync($async$_async_evaluate0$_visitStaticImport$1, $async$completer);
            },
            _async_evaluate0$_applyMixin$5: function(mixin, contentCallable, $arguments, nodeWithSpan, nodeWithSpanWithoutContent) {
                return this._applyMixin$body$_EvaluateVisitor0(mixin, contentCallable, $arguments, nodeWithSpan, nodeWithSpanWithoutContent);
            },
            _applyMixin$body$_EvaluateVisitor0: function(mixin, contentCallable, $arguments, nodeWithSpan, nodeWithSpanWithoutContent) {
                var $async$goto = 0, $async$completer = A._makeAsyncAwaitCompleter(type$.void), $async$self = this, t1, _0_0, t2, _1_8, t3;
                var $async$_async_evaluate0$_applyMixin$5 = A._wrapJsFunctionForAsync(function($async$errorCode, $async$result) {
                    if ($async$errorCode === 1) return A._asyncRethrow($async$result, $async$completer);
                    for(;;)switch($async$goto){
                        case 0:
                            // Function start
                            if (mixin == null) throw A.wrapException($async$self._async_evaluate0$_exception$2("Undefined mixin.", nodeWithSpan.get$span(nodeWithSpan)));
                            t1 = type$.AsyncBuiltInCallable_2._is(mixin);
                            $async$goto = t1 && !mixin.get$acceptsContent() && contentCallable != null ? 3 : 4;
                            break;
                        case 3:
                            // then
                            $async$goto = 5;
                            return A._asyncAwait($async$self._async_evaluate0$_evaluateArguments$1($arguments), $async$_async_evaluate0$_applyMixin$5);
                        case 5:
                            // returning from await.
                            t1 = $async$result._values;
                            _0_0 = mixin.callbackFor$2(J.get$length$asx(t1[2]), new A.MapKeySet(t1[0], type$.MapKeySet_String));
                            throw A.wrapException(A.MultiSpanSassRuntimeException$0("Mixin doesn't accept a content block.", nodeWithSpanWithoutContent.get$span(nodeWithSpanWithoutContent), "invocation", A.LinkedHashMap_LinkedHashMap$_literal([
                                _0_0._0.get$spanWithName(),
                                "declaration"
                            ], type$.FileSpan, type$.String), $async$self._async_evaluate0$_stackTrace$1(nodeWithSpanWithoutContent.get$span(nodeWithSpanWithoutContent)), null));
                        case 4:
                            // join
                            $async$goto = t1 ? 6 : 7;
                            break;
                        case 6:
                            // then
                            $async$goto = 8;
                            return A._asyncAwait($async$self._async_evaluate0$_environment.withContent$2(contentCallable, new A._EvaluateVisitor__applyMixin_closure5($async$self, $arguments, mixin, nodeWithSpanWithoutContent)), $async$_async_evaluate0$_applyMixin$5);
                        case 8:
                            // returning from await.
                            // goto break $label0$0
                            $async$goto = 2;
                            break;
                        case 7:
                            // join
                            t1 = type$.UserDefinedCallable_AsyncEnvironment_2._is(mixin);
                            t2 = false;
                            if (t1) {
                                _1_8 = mixin.declaration;
                                t3 = _1_8;
                                if (t3 instanceof A.MixinRule0) t2 = !type$.MixinRule_2._as(_1_8).get$hasContent() && contentCallable != null;
                            }
                            if (t2) throw A.wrapException(A.MultiSpanSassRuntimeException$0("Mixin doesn't accept a content block.", nodeWithSpanWithoutContent.get$span(nodeWithSpanWithoutContent), "invocation", A.LinkedHashMap_LinkedHashMap$_literal([
                                mixin.declaration.parameters.get$spanWithName(),
                                "declaration"
                            ], type$.FileSpan, type$.String), $async$self._async_evaluate0$_stackTrace$1(nodeWithSpanWithoutContent.get$span(nodeWithSpanWithoutContent)), null));
                            $async$goto = t1 ? 9 : 10;
                            break;
                        case 9:
                            // then
                            $async$goto = 11;
                            return A._asyncAwait($async$self._async_evaluate0$_runUserDefinedCallable$1$4($arguments, mixin, nodeWithSpanWithoutContent, new A._EvaluateVisitor__applyMixin_closure6($async$self, contentCallable, mixin, nodeWithSpanWithoutContent), type$.Null), $async$_async_evaluate0$_applyMixin$5);
                        case 11:
                            // returning from await.
                            // goto break $label0$0
                            $async$goto = 2;
                            break;
                        case 10:
                            // join
                            throw A.wrapException(A.UnsupportedError$("Unknown callable type " + mixin.toString$0(0) + "."));
                        case 2:
                            // break $label0$0
                            // implicit return
                            return A._asyncReturn(null, $async$completer);
                    }
                });
                return A._asyncStartSync($async$_async_evaluate0$_applyMixin$5, $async$completer);
            },
            visitIncludeRule$1: function(_, node) {
                return this.visitIncludeRule$body$_EvaluateVisitor0(0, node);
            },
            visitIncludeRule$body$_EvaluateVisitor0: function(_, node) {
                var $async$goto = 0, $async$completer = A._makeAsyncAwaitCompleter(type$.nullable_Value_2), $async$returnValue, $async$self = this, mixin;
                var $async$visitIncludeRule$1 = A._wrapJsFunctionForAsync(function($async$errorCode, $async$result) {
                    if ($async$errorCode === 1) return A._asyncRethrow($async$result, $async$completer);
                    for(;;)switch($async$goto){
                        case 0:
                            // Function start
                            mixin = $async$self._async_evaluate0$_addExceptionSpan$2(node, new A._EvaluateVisitor_visitIncludeRule_closure8($async$self, node));
                            if (B.JSString_methods.startsWith$1(node.originalName, "--") && mixin instanceof A.UserDefinedCallable0 && !B.JSString_methods.startsWith$1(mixin.declaration.originalName, "--")) throw A.wrapException($async$self._async_evaluate0$_exception$2(string$.Sass__m, node.get$nameSpan()));
                            $async$goto = 3;
                            return A._asyncAwait($async$self._async_evaluate0$_applyMixin$5(mixin, A.NullableExtension_andThen0(node.content, new A._EvaluateVisitor_visitIncludeRule_closure9($async$self)), node.$arguments, node, new A._FakeAstNode0(new A._EvaluateVisitor_visitIncludeRule_closure10(node))), $async$visitIncludeRule$1);
                        case 3:
                            // returning from await.
                            $async$returnValue = null;
                            // goto return
                            $async$goto = 1;
                            break;
                        case 1:
                            // return
                            return A._asyncReturn($async$returnValue, $async$completer);
                    }
                });
                return A._asyncStartSync($async$visitIncludeRule$1, $async$completer);
            },
            visitMixinRule$1: function(_, node) {
                return this.visitMixinRule$body$_EvaluateVisitor0(0, node);
            },
            visitMixinRule$body$_EvaluateVisitor0: function(_, node) {
                var $async$goto = 0, $async$completer = A._makeAsyncAwaitCompleter(type$.nullable_Value_2), $async$returnValue, $async$self = this, t1, t2, t3, t4, index, t5;
                var $async$visitMixinRule$1 = A._wrapJsFunctionForAsync(function($async$errorCode, $async$result) {
                    if ($async$errorCode === 1) return A._asyncRethrow($async$result, $async$completer);
                    for(;;)switch($async$goto){
                        case 0:
                            // Function start
                            t1 = $async$self._async_evaluate0$_environment;
                            t2 = t1.closure$0();
                            t3 = $async$self._async_evaluate0$_inDependency;
                            t4 = t1._async_environment0$_mixins;
                            index = t4.length - 1;
                            t5 = node.name;
                            t1._async_environment0$_mixinIndices.$indexSet(0, t5, index);
                            t4[index].$indexSet(0, t5, new A.UserDefinedCallable0(node, t2, t3, type$.UserDefinedCallable_AsyncEnvironment_2));
                            $async$returnValue = null;
                            // goto return
                            $async$goto = 1;
                            break;
                        case 1:
                            // return
                            return A._asyncReturn($async$returnValue, $async$completer);
                    }
                });
                return A._asyncStartSync($async$visitMixinRule$1, $async$completer);
            },
            visitLoudComment$1: function(_, node) {
                return this.visitLoudComment$body$_EvaluateVisitor0(0, node);
            },
            visitLoudComment$body$_EvaluateVisitor0: function(_, node) {
                var $async$goto = 0, $async$completer = A._makeAsyncAwaitCompleter(type$.nullable_Value_2), $async$returnValue, $async$self = this, t1, text;
                var $async$visitLoudComment$1 = A._wrapJsFunctionForAsync(function($async$errorCode, $async$result) {
                    if ($async$errorCode === 1) return A._asyncRethrow($async$result, $async$completer);
                    for(;;)switch($async$goto){
                        case 0:
                            // Function start
                            if ($async$self._async_evaluate0$_inFunction) {
                                $async$returnValue = null;
                                // goto return
                                $async$goto = 1;
                                break;
                            }
                            if ($async$self._async_evaluate0$_assertInModule$2($async$self._async_evaluate0$__parent, "__parent") === $async$self._async_evaluate0$_assertInModule$2($async$self._async_evaluate0$__root, "_root") && $async$self._async_evaluate0$_assertInModule$2($async$self._async_evaluate0$__endOfImports, "_endOfImports") === J.get$length$asx($async$self._async_evaluate0$_assertInModule$2($async$self._async_evaluate0$__root, "_root").children._collection$_source)) $async$self._async_evaluate0$__endOfImports = $async$self._async_evaluate0$_assertInModule$2($async$self._async_evaluate0$__endOfImports, "_endOfImports") + 1;
                            t1 = node.text;
                            $async$goto = 3;
                            return A._asyncAwait($async$self._async_evaluate0$_performInterpolation$1(t1), $async$visitLoudComment$1);
                        case 3:
                            // returning from await.
                            text = $async$result;
                            if (!B.JSString_methods.endsWith$1(text, "*/")) text += " */";
                            $async$self._async_evaluate0$_copyParentAfterSibling$0();
                            $async$self._async_evaluate0$_assertInModule$2($async$self._async_evaluate0$__parent, "__parent").addChild$1(new A.ModifiableCssComment0(text, t1.span));
                            $async$returnValue = null;
                            // goto return
                            $async$goto = 1;
                            break;
                        case 1:
                            // return
                            return A._asyncReturn($async$returnValue, $async$completer);
                    }
                });
                return A._asyncStartSync($async$visitLoudComment$1, $async$completer);
            },
            visitMediaRule$1: function(_, node) {
                return this.visitMediaRule$body$_EvaluateVisitor0(0, node);
            },
            visitMediaRule$body$_EvaluateVisitor0: function(_, node) {
                var $async$goto = 0, $async$completer = A._makeAsyncAwaitCompleter(type$.nullable_Value_2), $async$returnValue, $async$self = this, queries, mergedQueries, t1, mergedSources, t2, t3;
                var $async$visitMediaRule$1 = A._wrapJsFunctionForAsync(function($async$errorCode, $async$result) {
                    if ($async$errorCode === 1) return A._asyncRethrow($async$result, $async$completer);
                    for(;;)switch($async$goto){
                        case 0:
                            // Function start
                            if ($async$self._async_evaluate0$_declarationName != null) throw A.wrapException($async$self._async_evaluate0$_exception$2(string$.Media_, node.span));
                            $async$goto = 3;
                            return A._asyncAwait($async$self._async_evaluate0$_visitMediaQueries$1(node.query), $async$visitMediaRule$1);
                        case 3:
                            // returning from await.
                            queries = $async$result;
                            $async$goto = $async$self.get$_async_evaluate0$_hasCssNesting() ? 4 : 5;
                            break;
                        case 4:
                            // then
                            $async$goto = 6;
                            return A._asyncAwait($async$self._async_evaluate0$_withParent$2$3$scopeWhen(A.ModifiableCssMediaRule$0(queries, node.span), new A._EvaluateVisitor_visitMediaRule_closure11($async$self, node), false, type$.ModifiableCssMediaRule_2, type$.Null), $async$visitMediaRule$1);
                        case 6:
                            // returning from await.
                            $async$returnValue = null;
                            // goto return
                            $async$goto = 1;
                            break;
                        case 5:
                            // join
                            mergedQueries = A.NullableExtension_andThen0($async$self._async_evaluate0$_mediaQueries, new A._EvaluateVisitor_visitMediaRule_closure12($async$self, queries));
                            t1 = mergedQueries == null;
                            if (!t1 && J.get$isEmpty$asx(mergedQueries)) {
                                $async$returnValue = null;
                                // goto return
                                $async$goto = 1;
                                break;
                            }
                            if (t1) mergedSources = B.Set_empty6;
                            else {
                                t2 = $async$self._async_evaluate0$_mediaQuerySources;
                                t2.toString;
                                t2 = A.LinkedHashSet_LinkedHashSet$of(t2, type$.CssMediaQuery_2);
                                t3 = $async$self._async_evaluate0$_mediaQueries;
                                t3.toString;
                                t2.addAll$1(0, t3);
                                t2.addAll$1(0, queries);
                                mergedSources = t2;
                            }
                            t1 = t1 ? queries : mergedQueries;
                            $async$goto = 7;
                            return A._asyncAwait($async$self._async_evaluate0$_withParent$2$4$scopeWhen$through(A.ModifiableCssMediaRule$0(t1, node.span), new A._EvaluateVisitor_visitMediaRule_closure13($async$self, mergedQueries, queries, mergedSources, node), node.hasDeclarations, new A._EvaluateVisitor_visitMediaRule_closure14(mergedSources), type$.ModifiableCssMediaRule_2, type$.Null), $async$visitMediaRule$1);
                        case 7:
                            // returning from await.
                            $async$returnValue = null;
                            // goto return
                            $async$goto = 1;
                            break;
                        case 1:
                            // return
                            return A._asyncReturn($async$returnValue, $async$completer);
                    }
                });
                return A._asyncStartSync($async$visitMediaRule$1, $async$completer);
            },
            _async_evaluate0$_visitMediaQueries$1: function(interpolation) {
                return this._visitMediaQueries$body$_EvaluateVisitor0(interpolation);
            },
            _visitMediaQueries$body$_EvaluateVisitor0: function(interpolation) {
                var $async$goto = 0, $async$completer = A._makeAsyncAwaitCompleter(type$.List_CssMediaQuery_2), $async$returnValue, $async$self = this, _0_0, resolved, map;
                var $async$_async_evaluate0$_visitMediaQueries$1 = A._wrapJsFunctionForAsync(function($async$errorCode, $async$result) {
                    if ($async$errorCode === 1) return A._asyncRethrow($async$result, $async$completer);
                    for(;;)switch($async$goto){
                        case 0:
                            // Function start
                            $async$goto = 3;
                            return A._asyncAwait($async$self._async_evaluate0$_performInterpolationWithMap$2$warnForColor(interpolation, true), $async$_async_evaluate0$_visitMediaQueries$1);
                        case 3:
                            // returning from await.
                            _0_0 = $async$result;
                            resolved = _0_0._0;
                            map = _0_0._1;
                            $async$returnValue = new A.MediaQueryParser0(A.SpanScanner$(resolved, null), map).parse$0(0);
                            // goto return
                            $async$goto = 1;
                            break;
                        case 1:
                            // return
                            return A._asyncReturn($async$returnValue, $async$completer);
                    }
                });
                return A._asyncStartSync($async$_async_evaluate0$_visitMediaQueries$1, $async$completer);
            },
            _async_evaluate0$_mergeMediaQueries$2: function(queries1, queries2) {
                var t1, t2, t3, t4, _0_0, t5, result, queries = A._setArrayType([], type$.JSArray_CssMediaQuery_2);
                for(t1 = J.get$iterator$ax(queries1), t2 = J.getInterceptor$ax(queries2); t1.moveNext$0();){
                    t3 = t1.get$current(t1);
                    for(t4 = t2.get$iterator(queries2); t4.moveNext$0();){
                        _0_0 = t3.merge$1(t4.get$current(t4));
                        if (B._SingletonCssMediaQueryMergeResult_00 === _0_0) continue;
                        if (B._SingletonCssMediaQueryMergeResult_10 === _0_0) return null;
                        t5 = _0_0 instanceof A.MediaQuerySuccessfulMergeResult0;
                        result = t5 ? _0_0 : null;
                        if (t5) queries.push(result.query);
                    }
                }
                return queries;
            },
            visitReturnRule$1: function(_, node) {
                return this.visitReturnRule$body$_EvaluateVisitor0(0, node);
            },
            visitReturnRule$body$_EvaluateVisitor0: function(_, node) {
                var $async$goto = 0, $async$completer = A._makeAsyncAwaitCompleter(type$.Value_2), $async$returnValue, $async$self = this, t1, t2;
                var $async$visitReturnRule$1 = A._wrapJsFunctionForAsync(function($async$errorCode, $async$result) {
                    if ($async$errorCode === 1) return A._asyncRethrow($async$result, $async$completer);
                    for(;;)switch($async$goto){
                        case 0:
                            // Function start
                            t1 = node.expression;
                            t2 = t1.accept$1($async$self);
                            $async$goto = 3;
                            return A._asyncAwait(type$.Future_Value_2._is(t2) ? t2 : A._Future$value(t2, type$.Value_2), $async$visitReturnRule$1);
                        case 3:
                            // returning from await.
                            $async$returnValue = $async$self._async_evaluate0$_withoutSlash$2($async$result, t1);
                            // goto return
                            $async$goto = 1;
                            break;
                        case 1:
                            // return
                            return A._asyncReturn($async$returnValue, $async$completer);
                    }
                });
                return A._asyncStartSync($async$visitReturnRule$1, $async$completer);
            },
            visitSilentComment$1: function(_, node) {
                return this.visitSilentComment$body$_EvaluateVisitor0(0, node);
            },
            visitSilentComment$body$_EvaluateVisitor0: function(_, node) {
                var $async$goto = 0, $async$completer = A._makeAsyncAwaitCompleter(type$.nullable_Value_2), $async$returnValue;
                var $async$visitSilentComment$1 = A._wrapJsFunctionForAsync(function($async$errorCode, $async$result) {
                    if ($async$errorCode === 1) return A._asyncRethrow($async$result, $async$completer);
                    for(;;)switch($async$goto){
                        case 0:
                            // Function start
                            $async$returnValue = null;
                            // goto return
                            $async$goto = 1;
                            break;
                        case 1:
                            // return
                            return A._asyncReturn($async$returnValue, $async$completer);
                    }
                });
                return A._asyncStartSync($async$visitSilentComment$1, $async$completer);
            },
            visitStyleRule$1: function(_, node) {
                return this.visitStyleRule$body$_EvaluateVisitor0(0, node);
            },
            visitStyleRule$body$_EvaluateVisitor0: function(_, node) {
                var $async$goto = 0, $async$completer = A._makeAsyncAwaitCompleter(type$.nullable_Value_2), $async$returnValue, $async$self = this, t1, _0_0, selectorText, selectorMap, parsedSelector, _1_0, t2, t3, _i, _2_0, first, t4, rule, oldAtRootExcludingStyleRule;
                var $async$visitStyleRule$1 = A._wrapJsFunctionForAsync(function($async$errorCode, $async$result) {
                    if ($async$errorCode === 1) return A._asyncRethrow($async$result, $async$completer);
                    for(;;)switch($async$goto){
                        case 0:
                            // Function start
                            if ($async$self._async_evaluate0$_declarationName != null) throw A.wrapException($async$self._async_evaluate0$_exception$2(string$.Style_n, node.span));
                            else if ($async$self._async_evaluate0$_inKeyframes && $async$self._async_evaluate0$_assertInModule$2($async$self._async_evaluate0$__parent, "__parent") instanceof A.ModifiableCssKeyframeBlock0) throw A.wrapException($async$self._async_evaluate0$_exception$2(string$.Style_k, node.span));
                            t1 = node.selector;
                            t1.toString;
                            $async$goto = 3;
                            return A._asyncAwait($async$self._async_evaluate0$_performInterpolationWithMap$2$warnForColor(t1, true), $async$visitStyleRule$1);
                        case 3:
                            // returning from await.
                            _0_0 = $async$result;
                            selectorText = _0_0._0;
                            selectorMap = _0_0._1;
                            $async$goto = $async$self._async_evaluate0$_inKeyframes ? 4 : 5;
                            break;
                        case 4:
                            // then
                            $async$goto = 6;
                            return A._asyncAwait($async$self._async_evaluate0$_withParent$2$4$scopeWhen$through(A.ModifiableCssKeyframeBlock$0(new A.CssValue0(A.List_List$unmodifiable(new A.KeyframeSelectorParser0(A.SpanScanner$(selectorText, null), selectorMap).parse$0(0), type$.String), t1.span, type$.CssValue_List_String_2), node.span), new A._EvaluateVisitor_visitStyleRule_closure11($async$self, node), node.hasDeclarations, new A._EvaluateVisitor_visitStyleRule_closure12(), type$.ModifiableCssKeyframeBlock_2, type$.Null), $async$visitStyleRule$1);
                        case 6:
                            // returning from await.
                            $async$returnValue = null;
                            // goto return
                            $async$goto = 1;
                            break;
                        case 5:
                            // join
                            parsedSelector = A.SelectorList_SelectorList$parse0(selectorText, true, selectorMap, $async$self._async_evaluate0$_logger, $async$self._async_evaluate0$_assertInModule$2($async$self._async_evaluate0$__stylesheet, "_stylesheet").plainCss);
                            _1_0 = $async$self._async_evaluate0$_atRootExcludingStyleRule ? null : $async$self._async_evaluate0$_styleRuleIgnoringAtRoot;
                            $label0$0: {
                                if (_1_0 == null) {
                                    t1 = true;
                                    break $label0$0;
                                }
                                if (_1_0.fromPlainCss) {
                                    t1 = false;
                                    break $label0$0;
                                }
                                t1 = !($async$self._async_evaluate0$_assertInModule$2($async$self._async_evaluate0$__stylesheet, "_stylesheet").plainCss && parsedSelector.accept$1(B.C__ContainsParentSelectorVisitor0));
                                break $label0$0;
                            }
                            if (t1) {
                                if ($async$self._async_evaluate0$_assertInModule$2($async$self._async_evaluate0$__stylesheet, "_stylesheet").plainCss) for(t2 = parsedSelector.components, t3 = t2.length, _i = 0; _i < t3; ++_i){
                                    _2_0 = t2[_i].leadingCombinators;
                                    if (_2_0.length >= 1) {
                                        first = _2_0[0];
                                        t4 = $async$self._async_evaluate0$_assertInModule$2($async$self._async_evaluate0$__stylesheet, "_stylesheet").plainCss;
                                    } else {
                                        first = null;
                                        t4 = false;
                                    }
                                    if (t4) throw A.wrapException($async$self._async_evaluate0$_exception$2(string$.Top_le, first.span));
                                }
                                t2 = $async$self._async_evaluate0$_styleRuleIgnoringAtRoot;
                                t2 = t2 == null ? null : t2.originalSelector;
                                parsedSelector = parsedSelector.nestWithin$3$implicitParent$preserveParentSelectors(t2, !$async$self._async_evaluate0$_atRootExcludingStyleRule, $async$self._async_evaluate0$_assertInModule$2($async$self._async_evaluate0$__stylesheet, "_stylesheet").plainCss);
                            }
                            rule = A.ModifiableCssStyleRule$0($async$self._async_evaluate0$_assertInModule$2($async$self._async_evaluate0$__extensionStore, "_extensionStore").addSelector$2(parsedSelector, $async$self._async_evaluate0$_mediaQueries), node.span, $async$self._async_evaluate0$_assertInModule$2($async$self._async_evaluate0$__stylesheet, "_stylesheet").plainCss, parsedSelector);
                            oldAtRootExcludingStyleRule = $async$self._async_evaluate0$_atRootExcludingStyleRule;
                            t2 = $async$self._async_evaluate0$_atRootExcludingStyleRule = false;
                            t1 = t1 ? new A._EvaluateVisitor_visitStyleRule_closure13() : null;
                            $async$goto = 7;
                            return A._asyncAwait($async$self._async_evaluate0$_withParent$2$4$scopeWhen$through(rule, new A._EvaluateVisitor_visitStyleRule_closure14($async$self, rule, node), node.hasDeclarations, t1, type$.ModifiableCssStyleRule_2, type$.Null), $async$visitStyleRule$1);
                        case 7:
                            // returning from await.
                            $async$self._async_evaluate0$_atRootExcludingStyleRule = oldAtRootExcludingStyleRule;
                            $async$self._async_evaluate0$_warnForBogusCombinators$1(rule);
                            if (($async$self._async_evaluate0$_atRootExcludingStyleRule ? null : $async$self._async_evaluate0$_styleRuleIgnoringAtRoot) == null) {
                                t1 = $async$self._async_evaluate0$_assertInModule$2($async$self._async_evaluate0$__parent, "__parent").children;
                                t1 = !t1.get$isEmpty(t1);
                            } else t1 = t2;
                            if (t1) {
                                t1 = $async$self._async_evaluate0$_assertInModule$2($async$self._async_evaluate0$__parent, "__parent").children;
                                t1.get$last(t1).isGroupEnd = true;
                            }
                            $async$returnValue = null;
                            // goto return
                            $async$goto = 1;
                            break;
                        case 1:
                            // return
                            return A._asyncReturn($async$returnValue, $async$completer);
                    }
                });
                return A._asyncStartSync($async$visitStyleRule$1, $async$completer);
            },
            _async_evaluate0$_warnForBogusCombinators$1: function(rule) {
                var t1, t2, t3, t4, t5, _i, complex, visitor, t6, t7, t8, t9, _this = this, _null = null;
                if (!rule.accept$1(B._IsInvisibleVisitor_false_false0)) for(t1 = rule._style_rule0$_selector._box0$_inner.value.components, t2 = t1.length, t3 = type$.SourceSpan, t4 = type$.String, t5 = rule.children, _i = 0; _i < t2; ++_i){
                    complex = t1[_i];
                    if (!complex.accept$1(B._IsBogusVisitor_true0)) continue;
                    if (complex.accept$1(B.C__IsUselessVisitor0)) {
                        visitor = A._SerializeVisitor$0(_null, true, _null, _null, true, false, _null, true);
                        complex.accept$1(visitor);
                        _this._async_evaluate0$_warn$3('The selector "' + B.JSString_methods.trim$0(visitor._serialize0$_buffer.toString$0(0)) + string$.x22x20is_ix20, A.SpanExtensions_trimRight0(complex.span), B.Deprecation_2PR);
                    } else if (complex.leadingCombinators.length !== 0) {
                        if (!_this._async_evaluate0$_assertInModule$2(_this._async_evaluate0$__stylesheet, "_stylesheet").plainCss) {
                            visitor = A._SerializeVisitor$0(_null, true, _null, _null, true, false, _null, true);
                            complex.accept$1(visitor);
                            _this._async_evaluate0$_warn$3('The selector "' + B.JSString_methods.trim$0(visitor._serialize0$_buffer.toString$0(0)) + string$.x22x20is_ix0a, A.SpanExtensions_trimRight0(complex.span), B.Deprecation_2PR);
                        }
                    } else {
                        visitor = A._SerializeVisitor$0(_null, true, _null, _null, true, false, _null, true);
                        complex.accept$1(visitor);
                        t6 = B.JSString_methods.trim$0(visitor._serialize0$_buffer.toString$0(0));
                        t7 = complex.accept$1(B._IsBogusVisitor_false0) ? string$.x20It_wi : "";
                        t8 = A.SpanExtensions_trimRight0(complex.span);
                        if (t5.get$length(0) === 0) A.throwExpression(A.IterableElementError_noElement());
                        t9 = J.get$span$x(t5.$index(0, 0));
                        _this._async_evaluate0$_warn$3('The selector "' + t6 + string$.x22x20is_o + t7 + string$.x0aThis_, new A.MultiSpan0(t8, "invalid selector", A.ConstantMap_ConstantMap$from(A.LinkedHashMap_LinkedHashMap$_literal([
                            t9,
                            "this is not a style rule" + (t5.every$1(t5, new A._EvaluateVisitor__warnForBogusCombinators_closure2()) ? "\n(try converting to a //-style comment)" : "")
                        ], t3, t4), t3, t4)), B.Deprecation_2PR);
                    }
                }
            },
            visitSupportsRule$1: function(_, node) {
                return this.visitSupportsRule$body$_EvaluateVisitor0(0, node);
            },
            visitSupportsRule$body$_EvaluateVisitor0: function(_, node) {
                var $async$goto = 0, $async$completer = A._makeAsyncAwaitCompleter(type$.nullable_Value_2), $async$returnValue, $async$self = this, t1, rule, $async$temp1, $async$temp2;
                var $async$visitSupportsRule$1 = A._wrapJsFunctionForAsync(function($async$errorCode, $async$result) {
                    if ($async$errorCode === 1) return A._asyncRethrow($async$result, $async$completer);
                    for(;;)switch($async$goto){
                        case 0:
                            // Function start
                            if ($async$self._async_evaluate0$_declarationName != null) throw A.wrapException($async$self._async_evaluate0$_exception$2(string$.Suppor, node.span));
                            t1 = node.condition;
                            $async$temp1 = A;
                            $async$temp2 = A;
                            $async$goto = 3;
                            return A._asyncAwait($async$self._async_evaluate0$_visitSupportsCondition$1(t1), $async$visitSupportsRule$1);
                        case 3:
                            // returning from await.
                            rule = $async$temp1.ModifiableCssSupportsRule$0(new $async$temp2.CssValue0($async$result, t1.get$span(t1), type$.CssValue_String_2), node.span);
                            $async$goto = $async$self.get$_async_evaluate0$_hasCssNesting() ? 4 : 5;
                            break;
                        case 4:
                            // then
                            $async$goto = 6;
                            return A._asyncAwait($async$self._async_evaluate0$_withParent$2$3$scopeWhen(rule, new A._EvaluateVisitor_visitSupportsRule_closure8($async$self, node), node.hasDeclarations, type$.ModifiableCssSupportsRule_2, type$.Null), $async$visitSupportsRule$1);
                        case 6:
                            // returning from await.
                            $async$returnValue = null;
                            // goto return
                            $async$goto = 1;
                            break;
                        case 5:
                            // join
                            $async$goto = 7;
                            return A._asyncAwait($async$self._async_evaluate0$_withParent$2$4$scopeWhen$through(rule, new A._EvaluateVisitor_visitSupportsRule_closure9($async$self, node), node.hasDeclarations, new A._EvaluateVisitor_visitSupportsRule_closure10(), type$.ModifiableCssSupportsRule_2, type$.Null), $async$visitSupportsRule$1);
                        case 7:
                            // returning from await.
                            $async$returnValue = null;
                            // goto return
                            $async$goto = 1;
                            break;
                        case 1:
                            // return
                            return A._asyncReturn($async$returnValue, $async$completer);
                    }
                });
                return A._asyncStartSync($async$visitSupportsRule$1, $async$completer);
            },
            _async_evaluate0$_visitSupportsCondition$1: function(condition) {
                return this._visitSupportsCondition$body$_EvaluateVisitor0(condition);
            },
            _visitSupportsCondition$body$_EvaluateVisitor0: function(condition) {
                var $async$goto = 0, $async$completer = A._makeAsyncAwaitCompleter(type$.String), $async$returnValue, $async$self = this, t1, $async$temp1, $async$temp2;
                var $async$_async_evaluate0$_visitSupportsCondition$1 = A._wrapJsFunctionForAsync(function($async$errorCode, $async$result) {
                    if ($async$errorCode === 1) return A._asyncRethrow($async$result, $async$completer);
                    for(;;)switch($async$goto){
                        case 0:
                            // Function start
                            $async$goto = condition instanceof A.SupportsOperation0 ? 4 : 5;
                            break;
                        case 4:
                            // then
                            t1 = condition.operator;
                            $async$temp1 = A;
                            $async$goto = 6;
                            return A._asyncAwait($async$self._async_evaluate0$_parenthesize$2(condition.left, t1), $async$_async_evaluate0$_visitSupportsCondition$1);
                        case 6:
                            // returning from await.
                            $async$temp1 = $async$temp1.S($async$result) + " " + t1.toString$0(0) + " ";
                            $async$temp2 = A;
                            $async$goto = 7;
                            return A._asyncAwait($async$self._async_evaluate0$_parenthesize$2(condition.right, t1), $async$_async_evaluate0$_visitSupportsCondition$1);
                        case 7:
                            // returning from await.
                            t1 = $async$temp1 + $async$temp2.S($async$result);
                            // goto break $label0$0
                            $async$goto = 3;
                            break;
                        case 5:
                            // join
                            $async$goto = condition instanceof A.SupportsNegation0 ? 8 : 9;
                            break;
                        case 8:
                            // then
                            $async$temp1 = A;
                            $async$goto = 10;
                            return A._asyncAwait($async$self._async_evaluate0$_parenthesize$1(condition.condition), $async$_async_evaluate0$_visitSupportsCondition$1);
                        case 10:
                            // returning from await.
                            t1 = "not " + $async$temp1.S($async$result);
                            // goto break $label0$0
                            $async$goto = 3;
                            break;
                        case 9:
                            // join
                            $async$goto = condition instanceof A.SupportsInterpolation0 ? 11 : 12;
                            break;
                        case 11:
                            // then
                            $async$goto = 13;
                            return A._asyncAwait($async$self._async_evaluate0$_evaluateToCss$2$quote(condition.expression, false), $async$_async_evaluate0$_visitSupportsCondition$1);
                        case 13:
                            // returning from await.
                            t1 = $async$result;
                            // goto break $label0$0
                            $async$goto = 3;
                            break;
                        case 12:
                            // join
                            t1 = {};
                            t1.declaration = null;
                            $async$goto = condition instanceof A.SupportsDeclaration0 ? 14 : 15;
                            break;
                        case 14:
                            // then
                            t1.declaration = condition;
                            $async$goto = 16;
                            return A._asyncAwait($async$self._async_evaluate0$_withSupportsDeclaration$1$1(new A._EvaluateVisitor__visitSupportsCondition_closure2(t1, $async$self), type$.String), $async$_async_evaluate0$_visitSupportsCondition$1);
                        case 16:
                            // returning from await.
                            t1 = $async$result;
                            // goto break $label0$0
                            $async$goto = 3;
                            break;
                        case 15:
                            // join
                            $async$goto = condition instanceof A.SupportsFunction0 ? 17 : 18;
                            break;
                        case 17:
                            // then
                            $async$temp1 = A;
                            $async$goto = 19;
                            return A._asyncAwait($async$self._async_evaluate0$_performInterpolation$1(condition.name), $async$_async_evaluate0$_visitSupportsCondition$1);
                        case 19:
                            // returning from await.
                            $async$temp1 = $async$temp1.S($async$result) + "(";
                            $async$temp2 = A;
                            $async$goto = 20;
                            return A._asyncAwait($async$self._async_evaluate0$_performInterpolation$1(condition.$arguments), $async$_async_evaluate0$_visitSupportsCondition$1);
                        case 20:
                            // returning from await.
                            t1 = $async$temp1 + $async$temp2.S($async$result) + ")";
                            // goto break $label0$0
                            $async$goto = 3;
                            break;
                        case 18:
                            // join
                            $async$goto = condition instanceof A.SupportsAnything0 ? 21 : 22;
                            break;
                        case 21:
                            // then
                            $async$temp1 = A;
                            $async$goto = 23;
                            return A._asyncAwait($async$self._async_evaluate0$_performInterpolation$1(condition.contents), $async$_async_evaluate0$_visitSupportsCondition$1);
                        case 23:
                            // returning from await.
                            t1 = "(" + $async$temp1.S($async$result) + ")";
                            // goto break $label0$0
                            $async$goto = 3;
                            break;
                        case 22:
                            // join
                            t1 = A.throwExpression(A.ArgumentError$("Unknown supports condition type " + A.getRuntimeTypeOfDartObject(condition).toString$0(0) + ".", null));
                        case 3:
                            // break $label0$0
                            $async$returnValue = t1;
                            // goto return
                            $async$goto = 1;
                            break;
                        case 1:
                            // return
                            return A._asyncReturn($async$returnValue, $async$completer);
                    }
                });
                return A._asyncStartSync($async$_async_evaluate0$_visitSupportsCondition$1, $async$completer);
            },
            _async_evaluate0$_withSupportsDeclaration$1$1: function(callback, $T) {
                return this._withSupportsDeclaration$body$_EvaluateVisitor0(callback, $T, $T);
            },
            _withSupportsDeclaration$body$_EvaluateVisitor0: function(callback, $T, $async$type) {
                var $async$goto = 0, $async$completer = A._makeAsyncAwaitCompleter($async$type), $async$returnValue, $async$handler = 2, $async$errorStack = [], $async$next = [], $async$self = this, t1, oldInSupportsDeclaration;
                var $async$_async_evaluate0$_withSupportsDeclaration$1$1 = A._wrapJsFunctionForAsync(function($async$errorCode, $async$result) {
                    if ($async$errorCode === 1) {
                        $async$errorStack.push($async$result);
                        $async$goto = $async$handler;
                    }
                    for(;;)switch($async$goto){
                        case 0:
                            // Function start
                            oldInSupportsDeclaration = $async$self._async_evaluate0$_inSupportsDeclaration;
                            $async$self._async_evaluate0$_inSupportsDeclaration = true;
                            $async$handler = 3;
                            t1 = callback.call$0();
                            $async$goto = 6;
                            return A._asyncAwait($T._eval$1("Future<0>")._is(t1) ? t1 : A._Future$value(t1, $T), $async$_async_evaluate0$_withSupportsDeclaration$1$1);
                        case 6:
                            // returning from await.
                            t1 = $async$result;
                            $async$returnValue = t1;
                            $async$next = [
                                1
                            ];
                            // goto finally
                            $async$goto = 4;
                            break;
                        case 3:
                            // uncaught
                            $async$next = [
                                2
                            ];
                        case 4:
                            // finally
                            $async$handler = 2;
                            $async$self._async_evaluate0$_inSupportsDeclaration = oldInSupportsDeclaration;
                            // goto the next finally handler
                            $async$goto = $async$next.pop();
                            break;
                        case 5:
                        // after finally
                        case 1:
                            // return
                            return A._asyncReturn($async$returnValue, $async$completer);
                        case 2:
                            // rethrow
                            return A._asyncRethrow($async$errorStack.at(-1), $async$completer);
                    }
                });
                return A._asyncStartSync($async$_async_evaluate0$_withSupportsDeclaration$1$1, $async$completer);
            },
            _async_evaluate0$_parenthesize$2: function(condition, operator) {
                return this._parenthesize$body$_EvaluateVisitor0(condition, operator);
            },
            _async_evaluate0$_parenthesize$1: function(condition) {
                return this._async_evaluate0$_parenthesize$2(condition, null);
            },
            _parenthesize$body$_EvaluateVisitor0: function(condition, operator) {
                var $async$goto = 0, $async$completer = A._makeAsyncAwaitCompleter(type$.String), $async$returnValue, $async$self = this, t1, $async$temp1;
                var $async$_async_evaluate0$_parenthesize$2 = A._wrapJsFunctionForAsync(function($async$errorCode, $async$result) {
                    if ($async$errorCode === 1) return A._asyncRethrow($async$result, $async$completer);
                    for(;;)switch($async$goto){
                        case 0:
                            // Function start
                            if (!(condition instanceof A.SupportsNegation0)) {
                                if (condition instanceof A.SupportsOperation0) t1 = operator == null || operator !== condition.operator;
                                else t1 = false;
                            } else t1 = true;
                            $async$goto = t1 ? 3 : 4;
                            break;
                        case 3:
                            // then
                            $async$temp1 = A;
                            $async$goto = 5;
                            return A._asyncAwait($async$self._async_evaluate0$_visitSupportsCondition$1(condition), $async$_async_evaluate0$_parenthesize$2);
                        case 5:
                            // returning from await.
                            $async$returnValue = "(" + $async$temp1.S($async$result) + ")";
                            // goto return
                            $async$goto = 1;
                            break;
                        case 4:
                            // join
                            $async$goto = 6;
                            return A._asyncAwait($async$self._async_evaluate0$_visitSupportsCondition$1(condition), $async$_async_evaluate0$_parenthesize$2);
                        case 6:
                            // returning from await.
                            $async$returnValue = $async$result;
                            // goto return
                            $async$goto = 1;
                            break;
                        case 1:
                            // return
                            return A._asyncReturn($async$returnValue, $async$completer);
                    }
                });
                return A._asyncStartSync($async$_async_evaluate0$_parenthesize$2, $async$completer);
            },
            visitVariableDeclaration$1: function(_, node) {
                return this.visitVariableDeclaration$body$_EvaluateVisitor0(0, node);
            },
            visitVariableDeclaration$body$_EvaluateVisitor0: function(_, node) {
                var $async$goto = 0, $async$completer = A._makeAsyncAwaitCompleter(type$.nullable_Value_2), $async$returnValue, $async$self = this, t1, t2, _0_0, value, $async$temp1, $async$temp2, $async$temp3;
                var $async$visitVariableDeclaration$1 = A._wrapJsFunctionForAsync(function($async$errorCode, $async$result) {
                    if ($async$errorCode === 1) return A._asyncRethrow($async$result, $async$completer);
                    for(;;)switch($async$goto){
                        case 0:
                            // Function start
                            if (node.isGuarded) {
                                if (node.namespace == null && $async$self._async_evaluate0$_environment._async_environment0$_variables.length === 1) {
                                    t1 = node.name;
                                    $async$self._async_evaluate0$_environment._async_environment0$_configurableVariables.add$1(0, t1);
                                    t2 = $async$self._async_evaluate0$_configuration._configuration0$_values;
                                    _0_0 = t2.get$isEmpty(t2) ? null : t2.remove$1(0, t1);
                                    t1 = {};
                                    t1.override = null;
                                    if (_0_0 != null) {
                                        t1.override = _0_0;
                                        t2 = !_0_0.value.$eq(0, B.C__SassNull0);
                                    } else t2 = false;
                                    if (t2) {
                                        $async$self._async_evaluate0$_addExceptionSpan$2(node, new A._EvaluateVisitor_visitVariableDeclaration_closure8(t1, $async$self, node));
                                        $async$returnValue = null;
                                        // goto return
                                        $async$goto = 1;
                                        break;
                                    }
                                }
                                value = $async$self._async_evaluate0$_addExceptionSpan$2(node, new A._EvaluateVisitor_visitVariableDeclaration_closure9($async$self, node));
                                if (value != null && !value.$eq(0, B.C__SassNull0)) {
                                    $async$returnValue = null;
                                    // goto return
                                    $async$goto = 1;
                                    break;
                                }
                            }
                            if (node.isGlobal && !$async$self._async_evaluate0$_environment.globalVariableExists$1(node.name)) {
                                t1 = $async$self._async_evaluate0$_environment._async_environment0$_variables.length === 1 ? string$.As_of_S : string$.As_of_R + A.declarationName0(node.span) + ": null` at the stylesheet root.";
                                $async$self._async_evaluate0$_warn$3(t1, node.span, B.Deprecation_pwd);
                            }
                            t1 = node.expression;
                            t2 = t1.accept$1($async$self);
                            $async$temp1 = node;
                            $async$temp2 = A;
                            $async$temp3 = node;
                            $async$goto = 3;
                            return A._asyncAwait(type$.Future_Value_2._is(t2) ? t2 : A._Future$value(t2, type$.Value_2), $async$visitVariableDeclaration$1);
                        case 3:
                            // returning from await.
                            $async$self._async_evaluate0$_addExceptionSpan$2($async$temp1, new $async$temp2._EvaluateVisitor_visitVariableDeclaration_closure10($async$self, $async$temp3, $async$self._async_evaluate0$_withoutSlash$2($async$result, t1)));
                            $async$returnValue = null;
                            // goto return
                            $async$goto = 1;
                            break;
                        case 1:
                            // return
                            return A._asyncReturn($async$returnValue, $async$completer);
                    }
                });
                return A._asyncStartSync($async$visitVariableDeclaration$1, $async$completer);
            },
            visitUseRule$1: function(_, node) {
                return this.visitUseRule$body$_EvaluateVisitor0(0, node);
            },
            visitUseRule$body$_EvaluateVisitor0: function(_, node) {
                var $async$goto = 0, $async$completer = A._makeAsyncAwaitCompleter(type$.nullable_Value_2), $async$returnValue, $async$self = this, values, t3, t4, _i, variable, t5, variableNodeWithSpan, t6, configuration, t1, t2, $async$temp1, $async$temp2, $async$temp3;
                var $async$visitUseRule$1 = A._wrapJsFunctionForAsync(function($async$errorCode, $async$result) {
                    if ($async$errorCode === 1) return A._asyncRethrow($async$result, $async$completer);
                    for(;;)switch($async$goto){
                        case 0:
                            // Function start
                            t1 = node.configuration;
                            t2 = t1.length;
                            $async$goto = t2 !== 0 ? 3 : 5;
                            break;
                        case 3:
                            // then
                            values = A.LinkedHashMap_LinkedHashMap$_empty(type$.String, type$.ConfiguredValue_2);
                            t3 = type$._Future_Value_2, t4 = type$.Future_Value_2, _i = 0;
                        case 6:
                            // for condition
                            if (!(_i < t2)) {
                                // goto after for
                                $async$goto = 8;
                                break;
                            }
                            variable = t1[_i];
                            t5 = variable.expression;
                            variableNodeWithSpan = $async$self._async_evaluate0$_expressionNode$1(t5);
                            t5 = t5.accept$1($async$self);
                            if (!t4._is(t5)) {
                                t6 = new A._Future($.Zone__current, t3);
                                t6._state = 8;
                                t6._resultOrListeners = t5;
                                t5 = t6;
                            }
                            $async$temp1 = values;
                            $async$temp2 = variable.name;
                            $async$temp3 = A;
                            $async$goto = 9;
                            return A._asyncAwait(t5, $async$visitUseRule$1);
                        case 9:
                            // returning from await.
                            $async$temp1.$indexSet(0, $async$temp2, new $async$temp3.ConfiguredValue0($async$self._async_evaluate0$_withoutSlash$2($async$result, variableNodeWithSpan), variable.span, variableNodeWithSpan));
                        case 7:
                            // for update
                            ++_i;
                            // goto for condition
                            $async$goto = 6;
                            break;
                        case 8:
                            // after for
                            configuration = new A.ExplicitConfiguration0(node, values, null);
                            // goto join
                            $async$goto = 4;
                            break;
                        case 5:
                            // else
                            configuration = B.Configuration_Map_empty_null0;
                        case 4:
                            // join
                            $async$goto = 10;
                            return A._asyncAwait($async$self._async_evaluate0$_loadModule$5$configuration(node.url, "@use", node, new A._EvaluateVisitor_visitUseRule_closure2($async$self, node), configuration), $async$visitUseRule$1);
                        case 10:
                            // returning from await.
                            $async$self._async_evaluate0$_assertConfigurationIsEmpty$1(configuration);
                            $async$returnValue = null;
                            // goto return
                            $async$goto = 1;
                            break;
                        case 1:
                            // return
                            return A._asyncReturn($async$returnValue, $async$completer);
                    }
                });
                return A._asyncStartSync($async$visitUseRule$1, $async$completer);
            },
            visitWarnRule$1: function(_, node) {
                return this.visitWarnRule$body$_EvaluateVisitor0(0, node);
            },
            visitWarnRule$body$_EvaluateVisitor0: function(_, node) {
                var $async$goto = 0, $async$completer = A._makeAsyncAwaitCompleter(type$.nullable_Value_2), $async$returnValue, $async$self = this, value, t1, t2;
                var $async$visitWarnRule$1 = A._wrapJsFunctionForAsync(function($async$errorCode, $async$result) {
                    if ($async$errorCode === 1) return A._asyncRethrow($async$result, $async$completer);
                    for(;;)switch($async$goto){
                        case 0:
                            // Function start
                            $async$goto = 3;
                            return A._asyncAwait($async$self._async_evaluate0$_addExceptionSpanAsync$1$2(node, new A._EvaluateVisitor_visitWarnRule_closure2($async$self, node), type$.Value_2), $async$visitWarnRule$1);
                        case 3:
                            // returning from await.
                            value = $async$result;
                            t1 = value instanceof A.SassString0 ? value._string0$_text : $async$self._async_evaluate0$_serialize$2(value, node.expression);
                            t2 = $async$self._async_evaluate0$_stackTrace$1(node.span);
                            $async$self._async_evaluate0$_logger.internalWarn$4$deprecation$span$trace(t1, null, null, t2);
                            $async$returnValue = null;
                            // goto return
                            $async$goto = 1;
                            break;
                        case 1:
                            // return
                            return A._asyncReturn($async$returnValue, $async$completer);
                    }
                });
                return A._asyncStartSync($async$visitWarnRule$1, $async$completer);
            },
            visitWhileRule$1: function(_, node) {
                return this._async_evaluate0$_environment.scope$1$3$semiGlobal$when(new A._EvaluateVisitor_visitWhileRule_closure2(this, node), true, node.hasDeclarations, type$.nullable_Value_2);
            },
            visitBinaryOperationExpression$1: function(_, node) {
                var t1, _this = this;
                if (_this._async_evaluate0$_assertInModule$2(_this._async_evaluate0$__stylesheet, "_stylesheet").plainCss) {
                    t1 = node.operator;
                    t1 = t1 !== B.BinaryOperator_g6F0 && t1 !== B.BinaryOperator_ehp0;
                } else t1 = false;
                if (t1) throw A.wrapException(_this._async_evaluate0$_exception$2("Operators aren't allowed in plain CSS.", node.get$operatorSpan()));
                return _this._async_evaluate0$_addExceptionSpanAsync$1$2(node, new A._EvaluateVisitor_visitBinaryOperationExpression_closure2(_this, node), type$.Value_2);
            },
            _async_evaluate0$_slash$3: function(left, right, node) {
                var left0, _1_2, result = left.dividedBy$1(right), _1_2_isSet = left instanceof A.SassNumber0, right0 = null, t1 = false;
                if (_1_2_isSet) {
                    if (right instanceof A.SassNumber0) {
                        t1 = node.allowsSlash && this._async_evaluate0$_operandAllowsSlash$1(node.left) && this._async_evaluate0$_operandAllowsSlash$1(node.right);
                        right0 = right;
                    }
                    left0 = left;
                    _1_2 = right;
                } else {
                    _1_2 = null;
                    left0 = null;
                }
                if (t1) return type$.SassNumber_2._as(result).withSlash$2(left0, right0);
                if (left instanceof A.SassNumber0) t1 = (_1_2_isSet ? _1_2 : right) instanceof A.SassNumber0;
                else t1 = false;
                if (t1) {
                    this._async_evaluate0$_warn$3(string$.Using__o + A.S(new A._EvaluateVisitor__slash_recommendation2().call$1(node)) + " or " + A.expressionToCalc0(node).toString$0(0) + string$.x0a_Morex20, node.get$span(0), B.Deprecation_v81);
                    return result;
                }
                return result;
            },
            _async_evaluate0$_operandAllowsSlash$1: function(node) {
                var t1;
                if (node instanceof A.FunctionExpression0) {
                    if (node.namespace == null) {
                        t1 = node.name;
                        t1 = B.Set_Pr3yj.contains$1(0, t1.toLowerCase()) && this._async_evaluate0$_environment.getFunction$1(t1) == null;
                    } else t1 = false;
                } else t1 = true;
                return t1;
            },
            visitValueExpression$1: function(_, node) {
                return this.visitValueExpression$body$_EvaluateVisitor0(0, node);
            },
            visitValueExpression$body$_EvaluateVisitor0: function(_, node) {
                var $async$goto = 0, $async$completer = A._makeAsyncAwaitCompleter(type$.Value_2), $async$returnValue;
                var $async$visitValueExpression$1 = A._wrapJsFunctionForAsync(function($async$errorCode, $async$result) {
                    if ($async$errorCode === 1) return A._asyncRethrow($async$result, $async$completer);
                    for(;;)switch($async$goto){
                        case 0:
                            // Function start
                            $async$returnValue = node.value;
                            // goto return
                            $async$goto = 1;
                            break;
                        case 1:
                            // return
                            return A._asyncReturn($async$returnValue, $async$completer);
                    }
                });
                return A._asyncStartSync($async$visitValueExpression$1, $async$completer);
            },
            visitVariableExpression$1: function(_, node) {
                return this.visitVariableExpression$body$_EvaluateVisitor0(0, node);
            },
            visitVariableExpression$body$_EvaluateVisitor0: function(_, node) {
                var $async$goto = 0, $async$completer = A._makeAsyncAwaitCompleter(type$.Value_2), $async$returnValue, $async$self = this, result;
                var $async$visitVariableExpression$1 = A._wrapJsFunctionForAsync(function($async$errorCode, $async$result) {
                    if ($async$errorCode === 1) return A._asyncRethrow($async$result, $async$completer);
                    for(;;)switch($async$goto){
                        case 0:
                            // Function start
                            result = $async$self._async_evaluate0$_addExceptionSpan$2(node, new A._EvaluateVisitor_visitVariableExpression_closure2($async$self, node));
                            if (result != null) {
                                $async$returnValue = result;
                                // goto return
                                $async$goto = 1;
                                break;
                            }
                            throw A.wrapException($async$self._async_evaluate0$_exception$2("Undefined variable.", node.span));
                        case 1:
                            // return
                            return A._asyncReturn($async$returnValue, $async$completer);
                    }
                });
                return A._asyncStartSync($async$visitVariableExpression$1, $async$completer);
            },
            visitUnaryOperationExpression$1: function(_, node) {
                return this.visitUnaryOperationExpression$body$_EvaluateVisitor0(0, node);
            },
            visitUnaryOperationExpression$body$_EvaluateVisitor0: function(_, node) {
                var $async$goto = 0, $async$completer = A._makeAsyncAwaitCompleter(type$.Value_2), $async$returnValue, $async$self = this, $async$temp1, $async$temp2, $async$temp3;
                var $async$visitUnaryOperationExpression$1 = A._wrapJsFunctionForAsync(function($async$errorCode, $async$result) {
                    if ($async$errorCode === 1) return A._asyncRethrow($async$result, $async$completer);
                    for(;;)switch($async$goto){
                        case 0:
                            // Function start
                            $async$temp1 = node;
                            $async$temp2 = A;
                            $async$temp3 = node;
                            $async$goto = 3;
                            return A._asyncAwait(node.operand.accept$1($async$self), $async$visitUnaryOperationExpression$1);
                        case 3:
                            // returning from await.
                            $async$returnValue = $async$self._async_evaluate0$_addExceptionSpan$2($async$temp1, new $async$temp2._EvaluateVisitor_visitUnaryOperationExpression_closure2($async$temp3, $async$result));
                            // goto return
                            $async$goto = 1;
                            break;
                        case 1:
                            // return
                            return A._asyncReturn($async$returnValue, $async$completer);
                    }
                });
                return A._asyncStartSync($async$visitUnaryOperationExpression$1, $async$completer);
            },
            visitBooleanExpression$1: function(_, node) {
                return this.visitBooleanExpression$body$_EvaluateVisitor0(0, node);
            },
            visitBooleanExpression$body$_EvaluateVisitor0: function(_, node) {
                var $async$goto = 0, $async$completer = A._makeAsyncAwaitCompleter(type$.SassBoolean_2), $async$returnValue;
                var $async$visitBooleanExpression$1 = A._wrapJsFunctionForAsync(function($async$errorCode, $async$result) {
                    if ($async$errorCode === 1) return A._asyncRethrow($async$result, $async$completer);
                    for(;;)switch($async$goto){
                        case 0:
                            // Function start
                            $async$returnValue = node.value ? B.SassBoolean_true0 : B.SassBoolean_false0;
                            // goto return
                            $async$goto = 1;
                            break;
                        case 1:
                            // return
                            return A._asyncReturn($async$returnValue, $async$completer);
                    }
                });
                return A._asyncStartSync($async$visitBooleanExpression$1, $async$completer);
            },
            visitIfExpression$1: function(_, node) {
                return this.visitIfExpression$body$_EvaluateVisitor0(0, node);
            },
            visitIfExpression$body$_EvaluateVisitor0: function(_, node) {
                var $async$goto = 0, $async$completer = A._makeAsyncAwaitCompleter(type$.Value_2), $async$returnValue, $async$self = this, t1, t2, t3, t4, t5, t6, results, _i, t7, condition, expression, t8, result, _1_2, $async$temp1, $async$temp2, $async$temp3;
                var $async$visitIfExpression$1 = A._wrapJsFunctionForAsync(function($async$errorCode, $async$result) {
                    if ($async$errorCode === 1) return A._asyncRethrow($async$result, $async$completer);
                    for(;;)switch($async$goto){
                        case 0:
                            // Function start
                            t1 = node.branches, t2 = t1.length, t3 = type$._Future_nullable_Object, t4 = type$._Future_Value_2, t5 = type$.Future_Value_2, t6 = type$.JSArray_Record_2_String_and_Value_2, results = null, _i = 0;
                        case 3:
                            // for condition
                            if (!(_i < t2)) {
                                // goto after for
                                $async$goto = 5;
                                break;
                            }
                            t7 = t1[_i];
                            condition = t7._0;
                            expression = t7._1;
                            t7 = condition == null ? null : condition.accept$1($async$self);
                            if (!(t7 instanceof A._Future)) {
                                t8 = new A._Future($.Zone__current, t3);
                                t8._state = 8;
                                t8._resultOrListeners = t7;
                                t7 = t8;
                            }
                            $async$goto = 6;
                            return A._asyncAwait(t7, $async$visitIfExpression$1);
                        case 6:
                            // returning from await.
                            result = $async$result;
                            if (result == null) result = true;
                            t7 = typeof result == "string";
                            condition = t7 ? result : null;
                            $async$goto = t7 ? 7 : 8;
                            break;
                        case 7:
                            // then
                            if (results == null) results = A._setArrayType([], t6);
                            t7 = expression.accept$1($async$self);
                            if (!t5._is(t7)) {
                                t8 = new A._Future($.Zone__current, t4);
                                t8._state = 8;
                                t8._resultOrListeners = t7;
                                t7 = t8;
                            }
                            $async$temp1 = results;
                            $async$temp2 = A;
                            $async$temp3 = condition;
                            $async$goto = 9;
                            return A._asyncAwait(t7, $async$visitIfExpression$1);
                        case 9:
                            // returning from await.
                            $async$temp1.push(new $async$temp2._Record_2($async$temp3, $async$result));
                            // goto for update
                            $async$goto = 4;
                            break;
                        case 8:
                            // join
                            _1_2 = true === result;
                            $async$goto = _1_2 && results != null ? 10 : 11;
                            break;
                        case 10:
                            // then
                            t7 = expression.accept$1($async$self);
                            if (!t5._is(t7)) {
                                t8 = new A._Future($.Zone__current, t4);
                                t8._state = 8;
                                t8._resultOrListeners = t7;
                                t7 = t8;
                            }
                            $async$temp1 = results;
                            $async$temp2 = A;
                            $async$goto = 12;
                            return A._asyncAwait(t7, $async$visitIfExpression$1);
                        case 12:
                            // returning from await.
                            $async$temp1.push(new $async$temp2._Record_2("else", $async$result));
                            // goto for update
                            $async$goto = 4;
                            break;
                        case 11:
                            // join
                            $async$goto = _1_2 ? 13 : 14;
                            break;
                        case 13:
                            // then
                            t1 = expression.accept$1($async$self);
                            if (!t5._is(t1)) {
                                t2 = new A._Future($.Zone__current, t4);
                                t2._state = 8;
                                t2._resultOrListeners = t1;
                                t1 = t2;
                            }
                            $async$goto = 15;
                            return A._asyncAwait(t1, $async$visitIfExpression$1);
                        case 15:
                            // returning from await.
                            $async$returnValue = $async$result;
                            // goto return
                            $async$goto = 1;
                            break;
                        case 14:
                        // join
                        case 4:
                            // for update
                            ++_i;
                            // goto for condition
                            $async$goto = 3;
                            break;
                        case 5:
                            // after for
                            if (results == null) {
                                $async$returnValue = B.C__SassNull0;
                                // goto return
                                $async$goto = 1;
                                break;
                            }
                            $async$returnValue = new A.SassString0("if(" + new A.MappedListIterable(results, new A._EvaluateVisitor_visitIfExpression_closure2(), A._arrayInstanceType(results)._eval$1("MappedListIterable<1,String>")).join$1(0, "; ") + ")", false);
                            // goto return
                            $async$goto = 1;
                            break;
                        case 1:
                            // return
                            return A._asyncReturn($async$returnValue, $async$completer);
                    }
                });
                return A._asyncStartSync($async$visitIfExpression$1, $async$completer);
            },
            visitIfConditionParenthesized$1: function(_, node) {
                return this.visitIfConditionParenthesized$body$_EvaluateVisitor0(0, node);
            },
            visitIfConditionParenthesized$body$_EvaluateVisitor0: function(_, node) {
                var $async$goto = 0, $async$completer = A._makeAsyncAwaitCompleter(type$.Object), $async$returnValue, $async$self = this, t1, _0_0;
                var $async$visitIfConditionParenthesized$1 = A._wrapJsFunctionForAsync(function($async$errorCode, $async$result) {
                    if ($async$errorCode === 1) return A._asyncRethrow($async$result, $async$completer);
                    for(;;)switch($async$goto){
                        case 0:
                            // Function start
                            $async$goto = 3;
                            return A._asyncAwait(node.expression.accept$1($async$self), $async$visitIfConditionParenthesized$1);
                        case 3:
                            // returning from await.
                            _0_0 = $async$result;
                            $label0$0: {
                                if (typeof _0_0 == "string") {
                                    t1 = "(" + _0_0 + ")";
                                    break $label0$0;
                                }
                                t1 = _0_0;
                                break $label0$0;
                            }
                            $async$returnValue = t1;
                            // goto return
                            $async$goto = 1;
                            break;
                        case 1:
                            // return
                            return A._asyncReturn($async$returnValue, $async$completer);
                    }
                });
                return A._asyncStartSync($async$visitIfConditionParenthesized$1, $async$completer);
            },
            visitIfConditionNegation$1: function(_, node) {
                return this.visitIfConditionNegation$body$_EvaluateVisitor0(0, node);
            },
            visitIfConditionNegation$body$_EvaluateVisitor0: function(_, node) {
                var $async$goto = 0, $async$completer = A._makeAsyncAwaitCompleter(type$.Object), $async$returnValue, $async$self = this, t1, _0_0;
                var $async$visitIfConditionNegation$1 = A._wrapJsFunctionForAsync(function($async$errorCode, $async$result) {
                    if ($async$errorCode === 1) return A._asyncRethrow($async$result, $async$completer);
                    for(;;)switch($async$goto){
                        case 0:
                            // Function start
                            $async$goto = 3;
                            return A._asyncAwait(node.expression.accept$1($async$self), $async$visitIfConditionNegation$1);
                        case 3:
                            // returning from await.
                            _0_0 = $async$result;
                            $label0$0: {
                                if (typeof _0_0 == "string") {
                                    t1 = "not " + _0_0;
                                    break $label0$0;
                                }
                                if (A._isBool(_0_0)) {
                                    t1 = !_0_0;
                                    break $label0$0;
                                }
                                t1 = A.throwExpression(A.UnsupportedError$("unreachable"));
                            }
                            $async$returnValue = t1;
                            // goto return
                            $async$goto = 1;
                            break;
                        case 1:
                            // return
                            return A._asyncReturn($async$returnValue, $async$completer);
                    }
                });
                return A._asyncStartSync($async$visitIfConditionNegation$1, $async$completer);
            },
            visitIfConditionOperation$1: function(_, node) {
                return this.visitIfConditionOperation$body$_EvaluateVisitor0(0, node);
            },
            visitIfConditionOperation$body$_EvaluateVisitor0: function(_, node) {
                var $async$goto = 0, $async$completer = A._makeAsyncAwaitCompleter(type$.Object), $async$returnValue, $async$self = this, t1, t2, t3, t4, t5, t6, values, _i, expression, _0_0, t7, right, _1_6_isSet, _1_6, string;
                var $async$visitIfConditionOperation$1 = A._wrapJsFunctionForAsync(function($async$errorCode, $async$result) {
                    if ($async$errorCode === 1) return A._asyncRethrow($async$result, $async$completer);
                    for(;;)switch($async$goto){
                        case 0:
                            // Function start
                            t1 = node.expressions, t2 = t1.length, t3 = node.op, t4 = t3 === B.BooleanOperator_00, t5 = t3 === B.BooleanOperator_10, t6 = type$.JSArray_Record_2_IfConditionExpression_and_String_2, values = null, _i = 0;
                        case 3:
                            // for condition
                            if (!(_i < t2)) {
                                // goto after for
                                $async$goto = 5;
                                break;
                            }
                            expression = t1[_i];
                            $async$goto = 6;
                            return A._asyncAwait(expression.accept$1($async$self), $async$visitIfConditionOperation$1);
                        case 6:
                            // returning from await.
                            _0_0 = $async$result;
                            t7 = typeof _0_0 == "string";
                            right = t7 ? _0_0 : null;
                            if (t7) {
                                if (values == null) values = A._setArrayType([], t6);
                                values.push(new A._Record_2(expression, right));
                                // goto for update
                                $async$goto = 4;
                                break;
                            }
                            if (false === _0_0 && t4) {
                                $async$returnValue = false;
                                // goto return
                                $async$goto = 1;
                                break;
                            }
                            if (true === _0_0 && t5) {
                                $async$returnValue = true;
                                // goto return
                                $async$goto = 1;
                                break;
                            }
                        case 4:
                            // for update
                            ++_i;
                            // goto for condition
                            $async$goto = 3;
                            break;
                        case 5:
                            // after for
                            $label0$1: {
                                if (values == null) {
                                    t1 = t4;
                                    break $label0$1;
                                }
                                _1_6_isSet = values.length === 1;
                                if (_1_6_isSet) {
                                    _1_6 = values[0];
                                    t1 = _1_6._0 instanceof A.IfConditionParenthesized0;
                                } else {
                                    _1_6 = null;
                                    t1 = false;
                                }
                                if (t1) {
                                    string = (_1_6_isSet ? _1_6 : values[0])._1;
                                    t1 = B.JSString_methods.substring$2(string, 1, string.length - 1);
                                    break $label0$1;
                                }
                                t1 = new A.MappedListIterable(values, new A._EvaluateVisitor_visitIfConditionOperation_closure2(), A._arrayInstanceType(values)._eval$1("MappedListIterable<1,String>")).join$1(0, " " + t3.toString$0(0) + " ");
                                break $label0$1;
                            }
                            $async$returnValue = t1;
                            // goto return
                            $async$goto = 1;
                            break;
                        case 1:
                            // return
                            return A._asyncReturn($async$returnValue, $async$completer);
                    }
                });
                return A._asyncStartSync($async$visitIfConditionOperation$1, $async$completer);
            },
            visitIfConditionFunction$1: function(_, node) {
                return this.visitIfConditionFunction$body$_EvaluateVisitor0(0, node);
            },
            visitIfConditionFunction$body$_EvaluateVisitor0: function(_, node) {
                var $async$goto = 0, $async$completer = A._makeAsyncAwaitCompleter(type$.Object), $async$returnValue, $async$self = this, $async$temp1, $async$temp2;
                var $async$visitIfConditionFunction$1 = A._wrapJsFunctionForAsync(function($async$errorCode, $async$result) {
                    if ($async$errorCode === 1) return A._asyncRethrow($async$result, $async$completer);
                    for(;;)switch($async$goto){
                        case 0:
                            // Function start
                            $async$temp1 = B.JSString_methods;
                            $async$temp2 = J;
                            $async$goto = 3;
                            return A._asyncAwait($async$self._async_evaluate0$_performInterpolation$1(node.name), $async$visitIfConditionFunction$1);
                        case 3:
                            // returning from await.
                            $async$temp2 = $async$temp2.$add$ansx($async$result, "(");
                            $async$goto = 4;
                            return A._asyncAwait($async$self._async_evaluate0$_performInterpolation$1(node.$arguments), $async$visitIfConditionFunction$1);
                        case 4:
                            // returning from await.
                            $async$returnValue = $async$temp1.$add($async$temp2, $async$result) + ")";
                            // goto return
                            $async$goto = 1;
                            break;
                        case 1:
                            // return
                            return A._asyncReturn($async$returnValue, $async$completer);
                    }
                });
                return A._asyncStartSync($async$visitIfConditionFunction$1, $async$completer);
            },
            visitIfConditionSass$1: function(_, node) {
                return this.visitIfConditionSass$body$_EvaluateVisitor0(0, node);
            },
            visitIfConditionSass$body$_EvaluateVisitor0: function(_, node) {
                var $async$goto = 0, $async$completer = A._makeAsyncAwaitCompleter(type$.Object), $async$returnValue, $async$self = this;
                var $async$visitIfConditionSass$1 = A._wrapJsFunctionForAsync(function($async$errorCode, $async$result) {
                    if ($async$errorCode === 1) return A._asyncRethrow($async$result, $async$completer);
                    for(;;)switch($async$goto){
                        case 0:
                            // Function start
                            $async$goto = 3;
                            return A._asyncAwait(node.expression.accept$1($async$self), $async$visitIfConditionSass$1);
                        case 3:
                            // returning from await.
                            $async$returnValue = $async$result.get$isTruthy();
                            // goto return
                            $async$goto = 1;
                            break;
                        case 1:
                            // return
                            return A._asyncReturn($async$returnValue, $async$completer);
                    }
                });
                return A._asyncStartSync($async$visitIfConditionSass$1, $async$completer);
            },
            visitIfConditionRaw$1: function(_, node) {
                return this.visitIfConditionRaw$body$_EvaluateVisitor0(0, node);
            },
            visitIfConditionRaw$body$_EvaluateVisitor0: function(_, node) {
                var $async$goto = 0, $async$completer = A._makeAsyncAwaitCompleter(type$.Object), $async$returnValue, $async$self = this;
                var $async$visitIfConditionRaw$1 = A._wrapJsFunctionForAsync(function($async$errorCode, $async$result) {
                    if ($async$errorCode === 1) return A._asyncRethrow($async$result, $async$completer);
                    for(;;)switch($async$goto){
                        case 0:
                            // Function start
                            $async$goto = 3;
                            return A._asyncAwait($async$self._async_evaluate0$_performInterpolation$1(node.text), $async$visitIfConditionRaw$1);
                        case 3:
                            // returning from await.
                            $async$returnValue = $async$result;
                            // goto return
                            $async$goto = 1;
                            break;
                        case 1:
                            // return
                            return A._asyncReturn($async$returnValue, $async$completer);
                    }
                });
                return A._asyncStartSync($async$visitIfConditionRaw$1, $async$completer);
            },
            visitLegacyIfExpression$1: function(_, node) {
                return this.visitLegacyIfExpression$body$_EvaluateVisitor0(0, node);
            },
            visitLegacyIfExpression$body$_EvaluateVisitor0: function(_, node) {
                var $async$goto = 0, $async$completer = A._makeAsyncAwaitCompleter(type$.Value_2), $async$returnValue, $async$self = this, condition, t1, ifTrue, ifFalse, result, _0_0, positional, named;
                var $async$visitLegacyIfExpression$1 = A._wrapJsFunctionForAsync(function($async$errorCode, $async$result) {
                    if ($async$errorCode === 1) return A._asyncRethrow($async$result, $async$completer);
                    for(;;)switch($async$goto){
                        case 0:
                            // Function start
                            $async$goto = 3;
                            return A._asyncAwait($async$self._async_evaluate0$_evaluateMacroArguments$1(node), $async$visitLegacyIfExpression$1);
                        case 3:
                            // returning from await.
                            _0_0 = $async$result;
                            positional = _0_0._0;
                            named = _0_0._1;
                            $async$self._async_evaluate0$_verifyArguments$4(J.get$length$asx(positional), named, $.$get$LegacyIfExpression_declaration0(), node);
                            condition = A.ListExtensions_elementAtOrNull(positional, 0);
                            if (condition == null) {
                                t1 = named.$index(0, "condition");
                                t1.toString;
                                condition = t1;
                            }
                            ifTrue = A.ListExtensions_elementAtOrNull(positional, 1);
                            if (ifTrue == null) {
                                t1 = named.$index(0, "if-true");
                                t1.toString;
                                ifTrue = t1;
                            }
                            ifFalse = A.ListExtensions_elementAtOrNull(positional, 2);
                            if (ifFalse == null) {
                                t1 = named.$index(0, "if-false");
                                t1.toString;
                                ifFalse = t1;
                            }
                            $async$goto = 4;
                            return A._asyncAwait(condition.accept$1($async$self), $async$visitLegacyIfExpression$1);
                        case 4:
                            // returning from await.
                            result = $async$result.get$isTruthy() ? ifTrue : ifFalse;
                            t1 = result.accept$1($async$self);
                            $async$goto = 5;
                            return A._asyncAwait(type$.Future_Value_2._is(t1) ? t1 : A._Future$value(t1, type$.Value_2), $async$visitLegacyIfExpression$1);
                        case 5:
                            // returning from await.
                            $async$returnValue = $async$self._async_evaluate0$_withoutSlash$2($async$result, $async$self._async_evaluate0$_expressionNode$1(result));
                            // goto return
                            $async$goto = 1;
                            break;
                        case 1:
                            // return
                            return A._asyncReturn($async$returnValue, $async$completer);
                    }
                });
                return A._asyncStartSync($async$visitLegacyIfExpression$1, $async$completer);
            },
            visitNullExpression$1: function(_, node) {
                return this.visitNullExpression$body$_EvaluateVisitor0(0, node);
            },
            visitNullExpression$body$_EvaluateVisitor0: function(_, node) {
                var $async$goto = 0, $async$completer = A._makeAsyncAwaitCompleter(type$.Value_2), $async$returnValue;
                var $async$visitNullExpression$1 = A._wrapJsFunctionForAsync(function($async$errorCode, $async$result) {
                    if ($async$errorCode === 1) return A._asyncRethrow($async$result, $async$completer);
                    for(;;)switch($async$goto){
                        case 0:
                            // Function start
                            $async$returnValue = B.C__SassNull0;
                            // goto return
                            $async$goto = 1;
                            break;
                        case 1:
                            // return
                            return A._asyncReturn($async$returnValue, $async$completer);
                    }
                });
                return A._asyncStartSync($async$visitNullExpression$1, $async$completer);
            },
            visitNumberExpression$1: function(_, node) {
                return this.visitNumberExpression$body$_EvaluateVisitor0(0, node);
            },
            visitNumberExpression$body$_EvaluateVisitor0: function(_, node) {
                var $async$goto = 0, $async$completer = A._makeAsyncAwaitCompleter(type$.SassNumber_2), $async$returnValue;
                var $async$visitNumberExpression$1 = A._wrapJsFunctionForAsync(function($async$errorCode, $async$result) {
                    if ($async$errorCode === 1) return A._asyncRethrow($async$result, $async$completer);
                    for(;;)switch($async$goto){
                        case 0:
                            // Function start
                            $async$returnValue = A.SassNumber_SassNumber0(node.value, node.unit);
                            // goto return
                            $async$goto = 1;
                            break;
                        case 1:
                            // return
                            return A._asyncReturn($async$returnValue, $async$completer);
                    }
                });
                return A._asyncStartSync($async$visitNumberExpression$1, $async$completer);
            },
            visitParenthesizedExpression$1: function(_, node) {
                var _this = this;
                return _this._async_evaluate0$_assertInModule$2(_this._async_evaluate0$__stylesheet, "_stylesheet").plainCss ? A.throwExpression(_this._async_evaluate0$_exception$2("Parentheses aren't allowed in plain CSS.", node.span)) : node.expression.accept$1(_this);
            },
            visitColorExpression$1: function(_, node) {
                return this.visitColorExpression$body$_EvaluateVisitor0(0, node);
            },
            visitColorExpression$body$_EvaluateVisitor0: function(_, node) {
                var $async$goto = 0, $async$completer = A._makeAsyncAwaitCompleter(type$.SassColor_2), $async$returnValue;
                var $async$visitColorExpression$1 = A._wrapJsFunctionForAsync(function($async$errorCode, $async$result) {
                    if ($async$errorCode === 1) return A._asyncRethrow($async$result, $async$completer);
                    for(;;)switch($async$goto){
                        case 0:
                            // Function start
                            $async$returnValue = node.value;
                            // goto return
                            $async$goto = 1;
                            break;
                        case 1:
                            // return
                            return A._asyncReturn($async$returnValue, $async$completer);
                    }
                });
                return A._asyncStartSync($async$visitColorExpression$1, $async$completer);
            },
            visitListExpression$1: function(_, node) {
                return this.visitListExpression$body$_EvaluateVisitor0(0, node);
            },
            visitListExpression$body$_EvaluateVisitor0: function(_, node) {
                var $async$goto = 0, $async$completer = A._makeAsyncAwaitCompleter(type$.SassList_2), $async$returnValue, $async$self = this, $async$temp1;
                var $async$visitListExpression$1 = A._wrapJsFunctionForAsync(function($async$errorCode, $async$result) {
                    if ($async$errorCode === 1) return A._asyncRethrow($async$result, $async$completer);
                    for(;;)switch($async$goto){
                        case 0:
                            // Function start
                            $async$temp1 = A;
                            $async$goto = 3;
                            return A._asyncAwait(A.mapAsync0(node.contents, new A._EvaluateVisitor_visitListExpression_closure2($async$self), type$.Expression_2, type$.Value_2), $async$visitListExpression$1);
                        case 3:
                            // returning from await.
                            $async$returnValue = $async$temp1.SassList$0($async$result, node.separator, node.hasBrackets);
                            // goto return
                            $async$goto = 1;
                            break;
                        case 1:
                            // return
                            return A._asyncReturn($async$returnValue, $async$completer);
                    }
                });
                return A._asyncStartSync($async$visitListExpression$1, $async$completer);
            },
            visitMapExpression$1: function(_, node) {
                return this.visitMapExpression$body$_EvaluateVisitor0(0, node);
            },
            visitMapExpression$body$_EvaluateVisitor0: function(_, node) {
                var $async$goto = 0, $async$completer = A._makeAsyncAwaitCompleter(type$.SassMap_2), $async$returnValue, $async$self = this, t2, t3, _i, t4, key, keyValue, valueValue, oldValueSpan, t1, map, keyNodes;
                var $async$visitMapExpression$1 = A._wrapJsFunctionForAsync(function($async$errorCode, $async$result) {
                    if ($async$errorCode === 1) return A._asyncRethrow($async$result, $async$completer);
                    for(;;)switch($async$goto){
                        case 0:
                            // Function start
                            t1 = type$.Value_2;
                            map = A.LinkedHashMap_LinkedHashMap$_empty(t1, t1);
                            keyNodes = A.LinkedHashMap_LinkedHashMap$_empty(t1, type$.AstNode_2);
                            t2 = node.pairs, t3 = t2.length, _i = 0;
                        case 3:
                            // for condition
                            if (!(_i < t3)) {
                                // goto after for
                                $async$goto = 5;
                                break;
                            }
                            t4 = t2[_i];
                            key = t4._0;
                            $async$goto = 6;
                            return A._asyncAwait(key.accept$1($async$self), $async$visitMapExpression$1);
                        case 6:
                            // returning from await.
                            keyValue = $async$result;
                            $async$goto = 7;
                            return A._asyncAwait(t4._1.accept$1($async$self), $async$visitMapExpression$1);
                        case 7:
                            // returning from await.
                            valueValue = $async$result;
                            if (map.containsKey$1(keyValue)) {
                                t1 = keyNodes.$index(0, keyValue);
                                oldValueSpan = t1 == null ? null : t1.get$span(t1);
                                t1 = key.get$span(key);
                                t2 = A.LinkedHashMap_LinkedHashMap$_empty(type$.FileSpan, type$.String);
                                if (oldValueSpan != null) t2.$indexSet(0, oldValueSpan, "first key");
                                throw A.wrapException(A.MultiSpanSassRuntimeException$0("Duplicate key.", t1, "second key", t2, $async$self._async_evaluate0$_stackTrace$1(key.get$span(key)), null));
                            }
                            map.$indexSet(0, keyValue, valueValue);
                            keyNodes.$indexSet(0, keyValue, key);
                        case 4:
                            // for update
                            ++_i;
                            // goto for condition
                            $async$goto = 3;
                            break;
                        case 5:
                            // after for
                            $async$returnValue = new A.SassMap0(A.ConstantMap_ConstantMap$from(map, t1, t1));
                            // goto return
                            $async$goto = 1;
                            break;
                        case 1:
                            // return
                            return A._asyncReturn($async$returnValue, $async$completer);
                    }
                });
                return A._asyncStartSync($async$visitMapExpression$1, $async$completer);
            },
            visitFunctionExpression$1: function(_, node) {
                return this.visitFunctionExpression$body$_EvaluateVisitor0(0, node);
            },
            visitFunctionExpression$body$_EvaluateVisitor0: function(_, node) {
                var $async$goto = 0, $async$completer = A._makeAsyncAwaitCompleter(type$.Value_2), $async$returnValue, $async$self = this, t2, _0_0, t3, t4, $name, oldInFunction, result, t1, $function;
                var $async$visitFunctionExpression$1 = A._wrapJsFunctionForAsync(function($async$errorCode, $async$result) {
                    if ($async$errorCode === 1) return A._asyncRethrow($async$result, $async$completer);
                    for(;;)switch($async$goto){
                        case 0:
                            // Function start
                            t1 = {};
                            $function = $async$self._async_evaluate0$_assertInModule$2($async$self._async_evaluate0$__stylesheet, "_stylesheet").plainCss ? null : $async$self._async_evaluate0$_addExceptionSpan$2(node, new A._EvaluateVisitor_visitFunctionExpression_closure8($async$self, node));
                            t1.$function = $function;
                            $async$goto = $function == null || B.JSString_methods.startsWith$1(node.originalName, "--") ? 3 : 4;
                            break;
                        case 3:
                            // then
                            if (node.namespace != null) throw A.wrapException($async$self._async_evaluate0$_exception$2("Undefined function.", node.span));
                            t2 = node.name;
                            _0_0 = t2.toLowerCase();
                            t3 = false;
                            if ("min" === _0_0 || "max" === _0_0 || "round" === _0_0 || "abs" === _0_0) {
                                t3 = node.$arguments;
                                t4 = t3.named;
                                t3 = t4.get$isEmpty(t4) && t3.rest == null && B.JSArray_methods.every$1(t3.positional, new A._EvaluateVisitor_visitFunctionExpression_closure9());
                                $name = _0_0;
                            } else $name = null;
                            $async$goto = t3 ? 5 : 6;
                            break;
                        case 5:
                            // then
                            $async$goto = 7;
                            return A._asyncAwait($async$self._async_evaluate0$_visitCalculation$2$inLegacySassFunction(node, $name), $async$visitFunctionExpression$1);
                        case 7:
                            // returning from await.
                            $async$returnValue = $async$result;
                            // goto return
                            $async$goto = 1;
                            break;
                        case 6:
                            // join
                            $async$goto = "calc" === _0_0 || "clamp" === _0_0 || "hypot" === _0_0 || "sin" === _0_0 || "cos" === _0_0 || "tan" === _0_0 || "asin" === _0_0 || "acos" === _0_0 || "atan" === _0_0 || "sqrt" === _0_0 || "exp" === _0_0 || "sign" === _0_0 || "mod" === _0_0 || "rem" === _0_0 || "atan2" === _0_0 || "pow" === _0_0 || "log" === _0_0 || "calc-size" === _0_0 ? 8 : 9;
                            break;
                        case 8:
                            // then
                            $async$goto = 10;
                            return A._asyncAwait($async$self._async_evaluate0$_visitCalculation$1(node), $async$visitFunctionExpression$1);
                        case 10:
                            // returning from await.
                            $async$returnValue = $async$result;
                            // goto return
                            $async$goto = 1;
                            break;
                        case 9:
                            // join
                            $function = $async$self._async_evaluate0$_assertInModule$2($async$self._async_evaluate0$__stylesheet, "_stylesheet").plainCss ? null : $async$self._async_evaluate0$_builtInFunctions.$index(0, t2);
                            t1.$function = $function == null ? new A.PlainCssCallable0(node.originalName) : $function;
                        case 4:
                            // join
                            oldInFunction = $async$self._async_evaluate0$_inFunction;
                            $async$self._async_evaluate0$_inFunction = true;
                            $async$goto = 11;
                            return A._asyncAwait($async$self._async_evaluate0$_addErrorSpan$1$2(node, new A._EvaluateVisitor_visitFunctionExpression_closure10(t1, $async$self, node), type$.Value_2), $async$visitFunctionExpression$1);
                        case 11:
                            // returning from await.
                            result = $async$result;
                            $async$self._async_evaluate0$_inFunction = oldInFunction;
                            $async$returnValue = result;
                            // goto return
                            $async$goto = 1;
                            break;
                        case 1:
                            // return
                            return A._asyncReturn($async$returnValue, $async$completer);
                    }
                });
                return A._asyncStartSync($async$visitFunctionExpression$1, $async$completer);
            },
            _async_evaluate0$_visitCalculation$2$inLegacySassFunction: function(node, inLegacySassFunction) {
                return this._visitCalculation$body$_EvaluateVisitor0(node, inLegacySassFunction);
            },
            _async_evaluate0$_visitCalculation$1: function(node) {
                return this._async_evaluate0$_visitCalculation$2$inLegacySassFunction(node, null);
            },
            _visitCalculation$body$_EvaluateVisitor0: function(node, inLegacySassFunction) {
                var $async$goto = 0, $async$completer = A._makeAsyncAwaitCompleter(type$.Value_2), $async$returnValue, $async$next = [], $async$self = this, $arguments, oldCallableNode, t1, _0_0, error, stackTrace, t4, _i, exception, t2, t3, $async$temp1;
                var $async$_async_evaluate0$_visitCalculation$2$inLegacySassFunction = A._wrapJsFunctionForAsync(function($async$errorCode, $async$result) {
                    if ($async$errorCode === 1) return A._asyncRethrow($async$result, $async$completer);
                    for(;;)switch($async$goto){
                        case 0:
                            // Function start
                            t2 = node.$arguments;
                            t3 = t2.named;
                            if (t3.get$isNotEmpty(t3)) throw A.wrapException($async$self._async_evaluate0$_exception$2(string$.Keywor, node.span));
                            else if (t2.rest != null) throw A.wrapException($async$self._async_evaluate0$_exception$2(string$.Rest_a, node.span));
                            $async$self._async_evaluate0$_checkCalculationArguments$1(node);
                            t3 = A._setArrayType([], type$.JSArray_Object);
                            t2 = t2.positional, t4 = t2.length, _i = 0;
                        case 3:
                            // for condition
                            if (!(_i < t4)) {
                                // goto after for
                                $async$goto = 5;
                                break;
                            }
                            $async$temp1 = t3;
                            $async$goto = 6;
                            return A._asyncAwait($async$self._async_evaluate0$_visitCalculationExpression$2$inLegacySassFunction(t2[_i], inLegacySassFunction), $async$_async_evaluate0$_visitCalculation$2$inLegacySassFunction);
                        case 6:
                            // returning from await.
                            $async$temp1.push($async$result);
                        case 4:
                            // for update
                            ++_i;
                            // goto for condition
                            $async$goto = 3;
                            break;
                        case 5:
                            // after for
                            $arguments = t3;
                            if ($async$self._async_evaluate0$_inSupportsDeclaration) {
                                $async$returnValue = new A.SassCalculation0(node.name, A.List_List$unmodifiable($arguments, type$.Object));
                                // goto return
                                $async$goto = 1;
                                break;
                            }
                            oldCallableNode = $async$self._async_evaluate0$_callableNode;
                            $async$self._async_evaluate0$_callableNode = node;
                            try {
                                t1 = null;
                                t3 = node.name;
                                _0_0 = t3.toLowerCase();
                                $label0$0: {
                                    if ("calc" === _0_0) {
                                        t1 = A.SassCalculation_calc0(J.$index$asx($arguments, 0));
                                        break $label0$0;
                                    }
                                    if ("sqrt" === _0_0) {
                                        t1 = A.SassCalculation__singleArgument0("sqrt", J.$index$asx($arguments, 0), A.number2__sqrt$closure(), true);
                                        break $label0$0;
                                    }
                                    if ("sin" === _0_0) {
                                        t1 = A.SassCalculation__singleArgument0("sin", J.$index$asx($arguments, 0), A.number2__sin$closure(), false);
                                        break $label0$0;
                                    }
                                    if ("cos" === _0_0) {
                                        t1 = A.SassCalculation__singleArgument0("cos", J.$index$asx($arguments, 0), A.number2__cos$closure(), false);
                                        break $label0$0;
                                    }
                                    if ("tan" === _0_0) {
                                        t1 = A.SassCalculation__singleArgument0("tan", J.$index$asx($arguments, 0), A.number2__tan$closure(), false);
                                        break $label0$0;
                                    }
                                    if ("asin" === _0_0) {
                                        t1 = A.SassCalculation__singleArgument0("asin", J.$index$asx($arguments, 0), A.number2__asin$closure(), true);
                                        break $label0$0;
                                    }
                                    if ("acos" === _0_0) {
                                        t1 = A.SassCalculation__singleArgument0("acos", J.$index$asx($arguments, 0), A.number2__acos$closure(), true);
                                        break $label0$0;
                                    }
                                    if ("atan" === _0_0) {
                                        t1 = A.SassCalculation__singleArgument0("atan", J.$index$asx($arguments, 0), A.number2__atan$closure(), true);
                                        break $label0$0;
                                    }
                                    if ("abs" === _0_0) {
                                        t1 = A.SassCalculation_abs0(J.$index$asx($arguments, 0));
                                        break $label0$0;
                                    }
                                    if ("exp" === _0_0) {
                                        t1 = A.SassCalculation_exp0(J.$index$asx($arguments, 0));
                                        break $label0$0;
                                    }
                                    if ("sign" === _0_0) {
                                        t1 = A.SassCalculation_sign0(J.$index$asx($arguments, 0));
                                        break $label0$0;
                                    }
                                    if ("min" === _0_0) {
                                        t1 = A.SassCalculation_min0($arguments);
                                        break $label0$0;
                                    }
                                    if ("max" === _0_0) {
                                        t1 = A.SassCalculation_max0($arguments);
                                        break $label0$0;
                                    }
                                    if ("hypot" === _0_0) {
                                        t1 = A.SassCalculation_hypot0($arguments);
                                        break $label0$0;
                                    }
                                    if ("pow" === _0_0) {
                                        t1 = A.SassCalculation_pow0(J.$index$asx($arguments, 0), A.ListExtensions_elementAtOrNull($arguments, 1));
                                        break $label0$0;
                                    }
                                    if ("atan2" === _0_0) {
                                        t1 = A.SassCalculation_atan20(J.$index$asx($arguments, 0), A.ListExtensions_elementAtOrNull($arguments, 1));
                                        break $label0$0;
                                    }
                                    if ("log" === _0_0) {
                                        t1 = A.SassCalculation_log0(J.$index$asx($arguments, 0), A.ListExtensions_elementAtOrNull($arguments, 1));
                                        break $label0$0;
                                    }
                                    if ("mod" === _0_0) {
                                        t1 = A.SassCalculation_mod0(J.$index$asx($arguments, 0), A.ListExtensions_elementAtOrNull($arguments, 1));
                                        break $label0$0;
                                    }
                                    if ("rem" === _0_0) {
                                        t1 = A.SassCalculation_rem0(J.$index$asx($arguments, 0), A.ListExtensions_elementAtOrNull($arguments, 1));
                                        break $label0$0;
                                    }
                                    if ("round" === _0_0) {
                                        t1 = A.SassCalculation_roundInternal0(J.$index$asx($arguments, 0), A.ListExtensions_elementAtOrNull($arguments, 1), A.ListExtensions_elementAtOrNull($arguments, 2), inLegacySassFunction, node.span, new A._EvaluateVisitor__visitCalculation_closure2($async$self, node));
                                        break $label0$0;
                                    }
                                    if ("clamp" === _0_0) {
                                        t1 = A.SassCalculation_clamp0(J.$index$asx($arguments, 0), A.ListExtensions_elementAtOrNull($arguments, 1), A.ListExtensions_elementAtOrNull($arguments, 2));
                                        break $label0$0;
                                    }
                                    if ("calc-size" === _0_0) {
                                        t1 = A.SassCalculation_calcSize0(J.$index$asx($arguments, 0), A.ListExtensions_elementAtOrNull($arguments, 1));
                                        break $label0$0;
                                    }
                                    t3 = A.UnsupportedError$('Unknown calculation name "' + t3 + '".');
                                    t1 = A.throwExpression(t3);
                                }
                                t1;
                                $async$returnValue = t1;
                                // goto return
                                $async$goto = 1;
                                break;
                            } catch (exception) {
                                t1 = A.unwrapException(exception);
                                if (t1 instanceof A.SassScriptException0) {
                                    error = t1;
                                    stackTrace = A.getTraceFromException(exception);
                                    if (B.JSString_methods.contains$1(error.message, "compatible")) $async$self._async_evaluate0$_verifyCompatibleNumbers$2($arguments, t2);
                                    A.throwWithTrace0($async$self._async_evaluate0$_exception$2(error.message, node.span), error, stackTrace);
                                } else throw exception;
                            } finally{
                                $async$self._async_evaluate0$_callableNode = oldCallableNode;
                            }
                        case 1:
                            // return
                            return A._asyncReturn($async$returnValue, $async$completer);
                    }
                });
                return A._asyncStartSync($async$_async_evaluate0$_visitCalculation$2$inLegacySassFunction, $async$completer);
            },
            _async_evaluate0$_checkCalculationArguments$1: function(node) {
                var t1, _0_0, check = new A._EvaluateVisitor__checkCalculationArguments_check2(this, node);
                $label0$0: {
                    t1 = node.name;
                    _0_0 = t1.toLowerCase();
                    if ("calc" === _0_0 || "sqrt" === _0_0 || "sin" === _0_0 || "cos" === _0_0 || "tan" === _0_0 || "asin" === _0_0 || "acos" === _0_0 || "atan" === _0_0 || "abs" === _0_0 || "exp" === _0_0 || "sign" === _0_0) {
                        check.call$1(1);
                        break $label0$0;
                    }
                    if ("min" === _0_0 || "max" === _0_0 || "hypot" === _0_0) {
                        check.call$0();
                        break $label0$0;
                    }
                    if ("pow" === _0_0 || "atan2" === _0_0 || "log" === _0_0 || "mod" === _0_0 || "rem" === _0_0 || "calc-size" === _0_0) {
                        check.call$1(2);
                        break $label0$0;
                    }
                    if ("round" === _0_0 || "clamp" === _0_0) {
                        check.call$1(3);
                        break $label0$0;
                    }
                    throw A.wrapException(A.UnsupportedError$('Unknown calculation name "' + t1 + '".'));
                }
            },
            _async_evaluate0$_verifyCompatibleNumbers$2: function(args, nodesWithSpans) {
                var i, t1, _0_0, arg, t2, number1, j, number2, t3, t4, t5, t6;
                for(i = 0; t1 = args.length, i < t1; ++i){
                    _0_0 = args[i];
                    if (_0_0 instanceof A.SassNumber0) {
                        t1 = _0_0.get$hasComplexUnits();
                        arg = _0_0;
                    } else {
                        arg = null;
                        t1 = false;
                    }
                    if (t1) {
                        t1 = A.S(arg);
                        t2 = nodesWithSpans[i];
                        throw A.wrapException(this._async_evaluate0$_exception$2("Number " + t1 + " isn't compatible with CSS calculations.", t2.get$span(t2)));
                    }
                }
                for(i = 0; i < t1 - 1; ++i){
                    number1 = args[i];
                    if (!(number1 instanceof A.SassNumber0)) continue;
                    for(j = i + 1; t1 = args.length, j < t1; ++j){
                        number2 = args[j];
                        if (!(number2 instanceof A.SassNumber0)) continue;
                        if (number1.hasPossiblyCompatibleUnits$1(number2)) continue;
                        t1 = number1.toString$0(0);
                        t2 = number2.toString$0(0);
                        t3 = nodesWithSpans[i];
                        t3 = t3.get$span(t3);
                        t4 = number1.toString$0(0);
                        t5 = nodesWithSpans[j];
                        t5 = A.LinkedHashMap_LinkedHashMap$_literal([
                            t5.get$span(t5),
                            number2.toString$0(0)
                        ], type$.FileSpan, type$.String);
                        t6 = nodesWithSpans[i];
                        throw A.wrapException(A.MultiSpanSassRuntimeException$0(t1 + " and " + t2 + " are incompatible.", t3, t4, t5, this._async_evaluate0$_stackTrace$1(t6.get$span(t6)), null));
                    }
                }
            },
            _async_evaluate0$_visitCalculationExpression$2$inLegacySassFunction: function(node, inLegacySassFunction) {
                return this._visitCalculationExpression$body$_EvaluateVisitor0(node, inLegacySassFunction);
            },
            _visitCalculationExpression$body$_EvaluateVisitor0: function(node, inLegacySassFunction) {
                var $async$goto = 0, $async$completer = A._makeAsyncAwaitCompleter(type$.Object), $async$returnValue, $async$self = this, result, t2, _0_0, _box_0, _1_0, t3, _i, i, t1, inner, $async$temp1;
                var $async$_async_evaluate0$_visitCalculationExpression$2$inLegacySassFunction = A._wrapJsFunctionForAsync(function($async$errorCode, $async$result) {
                    if ($async$errorCode === 1) return A._asyncRethrow($async$result, $async$completer);
                    for(;;)switch($async$goto){
                        case 0:
                            // Function start
                            t1 = node instanceof A.ParenthesizedExpression0;
                            inner = t1 ? node.expression : null;
                            $async$goto = t1 ? 3 : 4;
                            break;
                        case 3:
                            // then
                            $async$goto = 5;
                            return A._asyncAwait($async$self._async_evaluate0$_visitCalculationExpression$2$inLegacySassFunction(inner, inLegacySassFunction), $async$_async_evaluate0$_visitCalculationExpression$2$inLegacySassFunction);
                        case 5:
                            // returning from await.
                            result = $async$result;
                            $async$returnValue = result instanceof A.SassString0 ? new A.SassString0("(" + result._string0$_text + ")", false) : result;
                            // goto return
                            $async$goto = 1;
                            break;
                        case 4:
                            // join
                            $async$goto = node instanceof A.StringExpression0 && node.accept$1(B.C_IsCalculationSafeVisitor0) ? 6 : 7;
                            break;
                        case 6:
                            // then
                            t1 = node.text;
                            t2 = t1.get$asPlain();
                            _0_0 = t2 == null ? null : t2.toLowerCase();
                            if ("pi" === _0_0) {
                                t1 = A.SassNumber_SassNumber0(3.141592653589793, null);
                                // goto break $label0$0
                                $async$goto = 8;
                                break;
                            }
                            if ("e" === _0_0) {
                                t1 = A.SassNumber_SassNumber0(2.718281828459045, null);
                                // goto break $label0$0
                                $async$goto = 8;
                                break;
                            }
                            if ("infinity" === _0_0) {
                                t1 = A.SassNumber_SassNumber0(1 / 0, null);
                                // goto break $label0$0
                                $async$goto = 8;
                                break;
                            }
                            if ("-infinity" === _0_0) {
                                t1 = A.SassNumber_SassNumber0(-1 / 0, null);
                                // goto break $label0$0
                                $async$goto = 8;
                                break;
                            }
                            if ("nan" === _0_0) {
                                t1 = A.SassNumber_SassNumber0(0 / 0, null);
                                // goto break $label0$0
                                $async$goto = 8;
                                break;
                            }
                            $async$temp1 = A;
                            $async$goto = 9;
                            return A._asyncAwait($async$self._async_evaluate0$_performInterpolation$1(t1), $async$_async_evaluate0$_visitCalculationExpression$2$inLegacySassFunction);
                        case 9:
                            // returning from await.
                            t1 = new $async$temp1.SassString0($async$result, false);
                            // goto break $label0$0
                            $async$goto = 8;
                            break;
                        case 8:
                            // break $label0$0
                            $async$returnValue = t1;
                            // goto return
                            $async$goto = 1;
                            break;
                        case 7:
                            // join
                            _box_0 = {};
                            _box_0.right = _box_0.left = _box_0.operator = null;
                            t1 = node instanceof A.BinaryOperationExpression0;
                            if (t1) {
                                _box_0.operator = node.operator;
                                _box_0.left = node.left;
                                _box_0.right = node.right;
                            }
                            $async$goto = t1 ? 10 : 11;
                            break;
                        case 10:
                            // then
                            $async$self._async_evaluate0$_checkWhitespaceAroundCalculationOperator$1(node);
                            $async$goto = 12;
                            return A._asyncAwait($async$self._async_evaluate0$_addExceptionSpanAsync$1$2(node, new A._EvaluateVisitor__visitCalculationExpression_closure2(_box_0, $async$self, node, inLegacySassFunction), type$.Object), $async$_async_evaluate0$_visitCalculationExpression$2$inLegacySassFunction);
                        case 12:
                            // returning from await.
                            $async$returnValue = $async$result;
                            // goto return
                            $async$goto = 1;
                            break;
                        case 11:
                            // join
                            $async$goto = node instanceof A.NumberExpression0 || node instanceof A.VariableExpression0 || node instanceof A.FunctionExpression0 || node instanceof A.LegacyIfExpression0 ? 13 : 14;
                            break;
                        case 13:
                            // then
                            $async$goto = 15;
                            return A._asyncAwait(node.accept$1($async$self), $async$_async_evaluate0$_visitCalculationExpression$2$inLegacySassFunction);
                        case 15:
                            // returning from await.
                            _1_0 = $async$result;
                            $label1$1: {
                                if (_1_0 instanceof A.SassNumber0) {
                                    t1 = _1_0;
                                    break $label1$1;
                                }
                                if (_1_0 instanceof A.SassCalculation0) {
                                    t1 = _1_0;
                                    break $label1$1;
                                }
                                if (_1_0 instanceof A.SassString0) {
                                    t1 = !_1_0._string0$_hasQuotes;
                                    result = _1_0;
                                } else {
                                    result = null;
                                    t1 = false;
                                }
                                if (t1) {
                                    t1 = result;
                                    break $label1$1;
                                }
                                t1 = A.throwExpression($async$self._async_evaluate0$_exception$2("Value " + _1_0.toString$0(0) + " can't be used in a calculation.", node.get$span(node)));
                            }
                            $async$returnValue = t1;
                            // goto return
                            $async$goto = 1;
                            break;
                        case 14:
                            // join
                            $async$goto = node instanceof A.ListExpression0 && !node.hasBrackets && B.ListSeparator_SrV0 === node.separator && node.contents.length >= 2 ? 16 : 17;
                            break;
                        case 16:
                            // then
                            t1 = A._setArrayType([], type$.JSArray_Object);
                            t2 = node.contents, t3 = t2.length, _i = 0;
                        case 18:
                            // for condition
                            if (!(_i < t3)) {
                                // goto after for
                                $async$goto = 20;
                                break;
                            }
                            $async$temp1 = t1;
                            $async$goto = 21;
                            return A._asyncAwait($async$self._async_evaluate0$_visitCalculationExpression$2$inLegacySassFunction(t2[_i], inLegacySassFunction), $async$_async_evaluate0$_visitCalculationExpression$2$inLegacySassFunction);
                        case 21:
                            // returning from await.
                            $async$temp1.push($async$result);
                        case 19:
                            // for update
                            ++_i;
                            // goto for condition
                            $async$goto = 18;
                            break;
                        case 20:
                            // after for
                            $async$self._async_evaluate0$_checkAdjacentCalculationValues$2(t1, node);
                            for(i = 0; i < t1.length; ++i){
                                t3 = t1[i];
                                if (t3 instanceof A.CalculationOperation0 && t2[i] instanceof A.ParenthesizedExpression0) t1[i] = new A.SassString0("(" + t3.toString$0(0) + ")", false);
                            }
                            $async$returnValue = new A.SassString0(B.JSArray_methods.join$1(t1, " "), false);
                            // goto return
                            $async$goto = 1;
                            break;
                        case 17:
                            // join
                            throw A.wrapException($async$self._async_evaluate0$_exception$2(string$.This_e, node.get$span(node)));
                        case 1:
                            // return
                            return A._asyncReturn($async$returnValue, $async$completer);
                    }
                });
                return A._asyncStartSync($async$_async_evaluate0$_visitCalculationExpression$2$inLegacySassFunction, $async$completer);
            },
            _async_evaluate0$_checkWhitespaceAroundCalculationOperator$1: function(node) {
                var t2, t3, t4, textBetweenOperands, first, last, t1 = node.operator;
                if (t1 !== B.BinaryOperator_jCK0 && t1 !== B.BinaryOperator_tDf0) return;
                t1 = node.left;
                t2 = t1.get$span(t1);
                t2 = t2.get$file(t2);
                t3 = node.right;
                t4 = t3.get$span(t3);
                if (t2 !== t4.get$file(t4)) return;
                t2 = t1.get$span(t1);
                t2 = t2.get$end(t2);
                t4 = t3.get$span(t3);
                if (t2.offset >= t4.get$start(t4).offset) return;
                t2 = t1.get$span(t1);
                t2 = t2.get$file(t2);
                t1 = t1.get$span(t1);
                t1 = t1.get$end(t1);
                t3 = t3.get$span(t3);
                textBetweenOperands = A.String_String$fromCharCodes(B.NativeUint32List_methods.sublist$2(t2._decodedChars, t1.offset, t3.get$start(t3).offset), 0, null);
                first = textBetweenOperands.charCodeAt(0);
                last = textBetweenOperands.charCodeAt(textBetweenOperands.length - 1);
                if (first === 32 || first === 9 || first === 10 || first === 13 || first === 12 || first === 47) t1 = !(last === 32 || last === 9 || last === 10 || last === 13 || last === 12 || last === 47);
                else t1 = true;
                if (t1) throw A.wrapException(this._async_evaluate0$_exception$2(string$.x22x2b__an, node.get$operatorSpan()));
            },
            _async_evaluate0$_binaryOperatorToCalculationOperator$2: function(operator, node) {
                var t1;
                $label0$0: {
                    if (B.BinaryOperator_jCK0 === operator) {
                        t1 = B.CalculationOperator_dpX0;
                        break $label0$0;
                    }
                    if (B.BinaryOperator_tDf0 === operator) {
                        t1 = B.CalculationOperator_KrC0;
                        break $label0$0;
                    }
                    if (B.BinaryOperator_wkM0 === operator) {
                        t1 = B.CalculationOperator_LPB0;
                        break $label0$0;
                    }
                    if (B.BinaryOperator_ehp0 === operator) {
                        t1 = B.CalculationOperator_wFL0;
                        break $label0$0;
                    }
                    t1 = A.throwExpression(this._async_evaluate0$_exception$2(string$.This_o, node.get$operatorSpan()));
                }
                return t1;
            },
            _async_evaluate0$_checkAdjacentCalculationValues$2: function(elements, node) {
                var t1, i, t2, previous, current, previousNode, currentNode, _0_2;
                for(t1 = elements.length, i = 1; i < t1; ++i){
                    t2 = i - 1;
                    previous = elements[t2];
                    current = elements[i];
                    if (previous instanceof A.SassString0 || current instanceof A.SassString0) continue;
                    t1 = node.contents;
                    previousNode = t1[t2];
                    currentNode = t1[i];
                    if (currentNode instanceof A.UnaryOperationExpression0) {
                        _0_2 = currentNode.operator;
                        if (B.UnaryOperator_hCO0 !== _0_2) t1 = B.UnaryOperator_n2K0 === _0_2;
                        else t1 = true;
                    } else t1 = false;
                    if (!t1) t1 = currentNode instanceof A.NumberExpression0 && currentNode.value < 0;
                    else t1 = true;
                    if (t1) throw A.wrapException(this._async_evaluate0$_exception$2(string$.x22x2b__an, A.FileSpanExtension_subspan(currentNode.get$span(currentNode), 0, 1)));
                    else throw A.wrapException(this._async_evaluate0$_exception$2("Missing math operator.", previousNode.get$span(previousNode).expand$1(0, currentNode.get$span(currentNode))));
                }
            },
            visitInterpolatedFunctionExpression$1: function(_, node) {
                return this.visitInterpolatedFunctionExpression$body$_EvaluateVisitor0(0, node);
            },
            visitInterpolatedFunctionExpression$body$_EvaluateVisitor0: function(_, node) {
                var $async$goto = 0, $async$completer = A._makeAsyncAwaitCompleter(type$.Value_2), $async$returnValue, $async$self = this, result, t1, oldInFunction;
                var $async$visitInterpolatedFunctionExpression$1 = A._wrapJsFunctionForAsync(function($async$errorCode, $async$result) {
                    if ($async$errorCode === 1) return A._asyncRethrow($async$result, $async$completer);
                    for(;;)switch($async$goto){
                        case 0:
                            // Function start
                            $async$goto = 3;
                            return A._asyncAwait($async$self._async_evaluate0$_performInterpolation$1(node.name), $async$visitInterpolatedFunctionExpression$1);
                        case 3:
                            // returning from await.
                            t1 = $async$result;
                            oldInFunction = $async$self._async_evaluate0$_inFunction;
                            $async$self._async_evaluate0$_inFunction = true;
                            $async$goto = 4;
                            return A._asyncAwait($async$self._async_evaluate0$_addErrorSpan$1$2(node, new A._EvaluateVisitor_visitInterpolatedFunctionExpression_closure2($async$self, node, new A.PlainCssCallable0(t1)), type$.Value_2), $async$visitInterpolatedFunctionExpression$1);
                        case 4:
                            // returning from await.
                            result = $async$result;
                            $async$self._async_evaluate0$_inFunction = oldInFunction;
                            $async$returnValue = result;
                            // goto return
                            $async$goto = 1;
                            break;
                        case 1:
                            // return
                            return A._asyncReturn($async$returnValue, $async$completer);
                    }
                });
                return A._asyncStartSync($async$visitInterpolatedFunctionExpression$1, $async$completer);
            },
            _async_evaluate0$_runUserDefinedCallable$1$4: function($arguments, callable, nodeWithSpan, run, $V) {
                return this._runUserDefinedCallable$body$_EvaluateVisitor0($arguments, callable, nodeWithSpan, run, $V, $V);
            },
            _runUserDefinedCallable$body$_EvaluateVisitor0: function($arguments, callable, nodeWithSpan, run, $V, $async$type) {
                var $async$goto = 0, $async$completer = A._makeAsyncAwaitCompleter($async$type), $async$returnValue, $async$self = this, oldInDependency, result, evaluated, $name;
                var $async$_async_evaluate0$_runUserDefinedCallable$1$4 = A._wrapJsFunctionForAsync(function($async$errorCode, $async$result) {
                    if ($async$errorCode === 1) return A._asyncRethrow($async$result, $async$completer);
                    for(;;)switch($async$goto){
                        case 0:
                            // Function start
                            $async$goto = 3;
                            return A._asyncAwait($async$self._async_evaluate0$_evaluateArguments$1($arguments), $async$_async_evaluate0$_runUserDefinedCallable$1$4);
                        case 3:
                            // returning from await.
                            evaluated = $async$result;
                            $name = callable.declaration.name;
                            if ($name !== "@content") $name += "()";
                            oldInDependency = $async$self._async_evaluate0$_inDependency;
                            $async$self._async_evaluate0$_inDependency = callable.inDependency;
                            $async$goto = 4;
                            return A._asyncAwait($async$self._async_evaluate0$_withStackFrame$1$3($name, nodeWithSpan, new A._EvaluateVisitor__runUserDefinedCallable_closure2($async$self, callable, evaluated, nodeWithSpan, run, $V), $V), $async$_async_evaluate0$_runUserDefinedCallable$1$4);
                        case 4:
                            // returning from await.
                            result = $async$result;
                            $async$self._async_evaluate0$_inDependency = oldInDependency;
                            $async$returnValue = result;
                            // goto return
                            $async$goto = 1;
                            break;
                        case 1:
                            // return
                            return A._asyncReturn($async$returnValue, $async$completer);
                    }
                });
                return A._asyncStartSync($async$_async_evaluate0$_runUserDefinedCallable$1$4, $async$completer);
            },
            _async_evaluate0$_runFunctionCallable$3: function($arguments, callable, nodeWithSpan) {
                return this._runFunctionCallable$body$_EvaluateVisitor0($arguments, callable, nodeWithSpan);
            },
            _runFunctionCallable$body$_EvaluateVisitor0: function($arguments, callable, nodeWithSpan) {
                var $async$goto = 0, $async$completer = A._makeAsyncAwaitCompleter(type$.Value_2), $async$returnValue, $async$handler = 2, $async$errorStack = [], $async$self = this, buffer, first, argument, restArg, rest, error, t1, t2, _i, t3, t4, exception, $async$exception, $async$temp1;
                var $async$_async_evaluate0$_runFunctionCallable$3 = A._wrapJsFunctionForAsync(function($async$errorCode, $async$result) {
                    if ($async$errorCode === 1) {
                        $async$errorStack.push($async$result);
                        $async$goto = $async$handler;
                    }
                    for(;;)switch($async$goto){
                        case 0:
                            // Function start
                            $async$goto = type$.AsyncBuiltInCallable_2._is(callable) ? 3 : 5;
                            break;
                        case 3:
                            // then
                            $async$goto = 6;
                            return A._asyncAwait($async$self._async_evaluate0$_runBuiltInCallable$3($arguments, callable, nodeWithSpan), $async$_async_evaluate0$_runFunctionCallable$3);
                        case 6:
                            // returning from await.
                            $async$returnValue = $async$self._async_evaluate0$_withoutSlash$2($async$result, nodeWithSpan);
                            // goto return
                            $async$goto = 1;
                            break;
                        case 5:
                            // else
                            $async$goto = type$.UserDefinedCallable_AsyncEnvironment_2._is(callable) ? 7 : 9;
                            break;
                        case 7:
                            // then
                            $async$goto = 10;
                            return A._asyncAwait($async$self._async_evaluate0$_runUserDefinedCallable$1$4($arguments, callable, nodeWithSpan, new A._EvaluateVisitor__runFunctionCallable_closure2($async$self, callable), type$.Value_2), $async$_async_evaluate0$_runFunctionCallable$3);
                        case 10:
                            // returning from await.
                            $async$returnValue = $async$result;
                            // goto return
                            $async$goto = 1;
                            break;
                        case 9:
                            // else
                            $async$goto = callable instanceof A.PlainCssCallable0 ? 11 : 13;
                            break;
                        case 11:
                            // then
                            t1 = $arguments.named;
                            if (t1.get$isNotEmpty(t1) || $arguments.keywordRest != null) throw A.wrapException($async$self._async_evaluate0$_exception$2(string$.Plain_, nodeWithSpan.get$span(nodeWithSpan)));
                            buffer = new A.StringBuffer(callable.name + "(");
                            $async$handler = 15;
                            first = true;
                            t1 = $arguments.positional, t2 = t1.length, _i = 0;
                        case 18:
                            // for condition
                            if (!(_i < t2)) {
                                // goto after for
                                $async$goto = 20;
                                break;
                            }
                            argument = t1[_i];
                            if (first) first = false;
                            else buffer._contents += ", ";
                            t3 = buffer;
                            $async$temp1 = A;
                            $async$goto = 21;
                            return A._asyncAwait($async$self._async_evaluate0$_evaluateToCss$1(argument), $async$_async_evaluate0$_runFunctionCallable$3);
                        case 21:
                            // returning from await.
                            t4 = $async$temp1.S($async$result);
                            t3._contents += t4;
                        case 19:
                            // for update
                            ++_i;
                            // goto for condition
                            $async$goto = 18;
                            break;
                        case 20:
                            // after for
                            restArg = $arguments.rest;
                            $async$goto = restArg != null ? 22 : 23;
                            break;
                        case 22:
                            // then
                            $async$goto = 24;
                            return A._asyncAwait(restArg.accept$1($async$self), $async$_async_evaluate0$_runFunctionCallable$3);
                        case 24:
                            // returning from await.
                            rest = $async$result;
                            if (!first) buffer._contents += ", ";
                            t1 = buffer;
                            t2 = $async$self._async_evaluate0$_serialize$2(rest, restArg);
                            t1._contents += t2;
                        case 23:
                            // join
                            $async$handler = 2;
                            // goto after finally
                            $async$goto = 17;
                            break;
                        case 15:
                            // catch
                            $async$handler = 14;
                            $async$exception = $async$errorStack.pop();
                            t1 = A.unwrapException($async$exception);
                            if (type$.SassRuntimeException_2._is(t1)) {
                                error = t1;
                                if (!B.JSString_methods.endsWith$1(error._span_exception$_message, "isn't a valid CSS value.")) throw $async$exception;
                                throw A.wrapException(A.MultiSpanSassRuntimeException$0(error._span_exception$_message, J.get$span$x(error), "value", A.LinkedHashMap_LinkedHashMap$_literal([
                                    nodeWithSpan.get$span(nodeWithSpan),
                                    "unknown function treated as plain CSS"
                                ], type$.FileSpan, type$.String), J.get$trace$z(error), null));
                            } else throw $async$exception;
                            // goto after finally
                            $async$goto = 17;
                            break;
                        case 14:
                            // uncaught
                            // goto rethrow
                            $async$goto = 2;
                            break;
                        case 17:
                            // after finally
                            t1 = buffer;
                            t2 = A.Primitives_stringFromCharCode(41);
                            t1._contents += t2;
                            t2 = buffer._contents;
                            $async$returnValue = new A.SassString0(t2.charCodeAt(0) == 0 ? t2 : t2, false);
                            // goto return
                            $async$goto = 1;
                            break;
                        case 13:
                            // else
                            throw A.wrapException(A.ArgumentError$("Unknown callable type " + J.get$runtimeType$(callable).toString$0(0) + ".", null));
                        case 12:
                        // join
                        case 8:
                        // join
                        case 4:
                        // join
                        case 1:
                            // return
                            return A._asyncReturn($async$returnValue, $async$completer);
                        case 2:
                            // rethrow
                            return A._asyncRethrow($async$errorStack.at(-1), $async$completer);
                    }
                });
                return A._asyncStartSync($async$_async_evaluate0$_runFunctionCallable$3, $async$completer);
            },
            _async_evaluate0$_runBuiltInCallable$3: function($arguments, callable, nodeWithSpan) {
                return this._runBuiltInCallable$body$_EvaluateVisitor0($arguments, callable, nodeWithSpan);
            },
            _runBuiltInCallable$body$_EvaluateVisitor0: function($arguments, callable, nodeWithSpan) {
                var $async$goto = 0, $async$completer = A._makeAsyncAwaitCompleter(type$.Value_2), $async$returnValue, $async$handler = 2, $async$errorStack = [], $async$self = this, result, error, stackTrace, namedSet, _0_0, parameters, i, t1, t2, t3, parameter, t4, t5, t6, t7, rest, argumentList, exception, _box_0, evaluated, oldCallableNode, $async$exception;
                var $async$_async_evaluate0$_runBuiltInCallable$3 = A._wrapJsFunctionForAsync(function($async$errorCode, $async$result) {
                    if ($async$errorCode === 1) {
                        $async$errorStack.push($async$result);
                        $async$goto = $async$handler;
                    }
                    for(;;)switch($async$goto){
                        case 0:
                            // Function start
                            _box_0 = {};
                            $async$goto = 3;
                            return A._asyncAwait($async$self._async_evaluate0$_evaluateArguments$1($arguments), $async$_async_evaluate0$_runBuiltInCallable$3);
                        case 3:
                            // returning from await.
                            evaluated = $async$result;
                            oldCallableNode = $async$self._async_evaluate0$_callableNode;
                            $async$self._async_evaluate0$_callableNode = nodeWithSpan;
                            namedSet = new A.MapKeySet(evaluated._values[0], type$.MapKeySet_String);
                            _box_0.callback = _box_0.overload = null;
                            _0_0 = callable.callbackFor$2(J.get$length$asx(evaluated._values[2]), namedSet);
                            _box_0.overload = _0_0._0;
                            _box_0.callback = _0_0._1;
                            $async$self._async_evaluate0$_addExceptionSpan$2(nodeWithSpan, new A._EvaluateVisitor__runBuiltInCallable_closure8(_box_0, evaluated, namedSet));
                            parameters = _box_0.overload.parameters;
                            i = J.get$length$asx(evaluated._values[2]), t1 = parameters.length, t2 = type$._Future_Value_2, t3 = type$.Future_Value_2;
                        case 4:
                            // for condition
                            if (!(i < t1)) {
                                // goto after for
                                $async$goto = 6;
                                break;
                            }
                            parameter = parameters[i];
                            t4 = evaluated._values[2];
                            t5 = evaluated._values[0].remove$1(0, parameter.name);
                            $async$goto = t5 == null ? 7 : 8;
                            break;
                        case 7:
                            // then
                            t5 = parameter.defaultValue;
                            t6 = t5.accept$1($async$self);
                            if (!t3._is(t6)) {
                                t7 = new A._Future($.Zone__current, t2);
                                t7._state = 8;
                                t7._resultOrListeners = t6;
                                t6 = t7;
                            }
                            $async$goto = 9;
                            return A._asyncAwait(t6, $async$_async_evaluate0$_runBuiltInCallable$3);
                        case 9:
                            // returning from await.
                            t5 = $async$self._async_evaluate0$_withoutSlash$2($async$result, t5);
                        case 8:
                            // join
                            J.add$1$ax(t4, t5);
                        case 5:
                            // for update
                            ++i;
                            // goto for condition
                            $async$goto = 4;
                            break;
                        case 6:
                            // after for
                            if (_box_0.overload.restParameter != null) {
                                if (J.get$length$asx(evaluated._values[2]) > t1) {
                                    rest = J.sublist$1$ax(evaluated._values[2], t1);
                                    J.removeRange$2$ax(evaluated._values[2], t1, J.get$length$asx(evaluated._values[2]));
                                } else rest = B.List_empty23;
                                t1 = evaluated._values[0];
                                argumentList = A.SassArgumentList$0(rest, t1, evaluated._values[4] === B.ListSeparator_undecided_null_3_undecided0 ? B.ListSeparator_z0K0 : evaluated._values[4]);
                                J.add$1$ax(evaluated._values[2], argumentList);
                            } else argumentList = null;
                            result = null;
                            $async$handler = 11;
                            $async$goto = 14;
                            return A._asyncAwait($async$self._async_evaluate0$_addExceptionSpanAsync$1$2(nodeWithSpan, new A._EvaluateVisitor__runBuiltInCallable_closure9(_box_0, evaluated), type$.Value_2), $async$_async_evaluate0$_runBuiltInCallable$3);
                        case 14:
                            // returning from await.
                            result = $async$result;
                            $async$handler = 2;
                            // goto after finally
                            $async$goto = 13;
                            break;
                        case 11:
                            // catch
                            $async$handler = 10;
                            $async$exception = $async$errorStack.pop();
                            t1 = A.unwrapException($async$exception);
                            if (t1 instanceof A.SassException0) throw $async$exception;
                            else {
                                error = t1;
                                stackTrace = A.getTraceFromException($async$exception);
                                A.throwWithTrace0($async$self._async_evaluate0$_exception$2($async$self._async_evaluate0$_getErrorMessage$1(error), nodeWithSpan.get$span(nodeWithSpan)), error, stackTrace);
                            }
                            // goto after finally
                            $async$goto = 13;
                            break;
                        case 10:
                            // uncaught
                            // goto rethrow
                            $async$goto = 2;
                            break;
                        case 13:
                            // after finally
                            $async$self._async_evaluate0$_callableNode = oldCallableNode;
                            if (argumentList == null) {
                                $async$returnValue = result;
                                // goto return
                                $async$goto = 1;
                                break;
                            }
                            t1 = evaluated._values[0];
                            if (t1.get$isEmpty(t1)) {
                                $async$returnValue = result;
                                // goto return
                                $async$goto = 1;
                                break;
                            }
                            if (argumentList._argument_list$_wereKeywordsAccessed) {
                                $async$returnValue = result;
                                // goto return
                                $async$goto = 1;
                                break;
                            }
                            t1 = evaluated._values[0];
                            t1 = t1.get$keys(t1);
                            t1 = A.pluralize0("parameter", t1.get$length(t1), null);
                            t2 = evaluated._values[0];
                            t2 = t2.get$keys(t2);
                            throw A.wrapException(A.MultiSpanSassRuntimeException$0("No " + t1 + " named " + A.toSentence0(t2.map$1$1(t2, new A._EvaluateVisitor__runBuiltInCallable_closure10(), type$.Object), "or") + ".", nodeWithSpan.get$span(nodeWithSpan), "invocation", A.LinkedHashMap_LinkedHashMap$_literal([
                                _box_0.overload.get$spanWithName(),
                                "declaration"
                            ], type$.FileSpan, type$.String), $async$self._async_evaluate0$_stackTrace$1(nodeWithSpan.get$span(nodeWithSpan)), null));
                        case 1:
                            // return
                            return A._asyncReturn($async$returnValue, $async$completer);
                        case 2:
                            // rethrow
                            return A._asyncRethrow($async$errorStack.at(-1), $async$completer);
                    }
                });
                return A._asyncStartSync($async$_async_evaluate0$_runBuiltInCallable$3, $async$completer);
            },
            _async_evaluate0$_evaluateArguments$1: function($arguments) {
                return this._evaluateArguments$body$_EvaluateVisitor0($arguments);
            },
            _evaluateArguments$body$_EvaluateVisitor0: function($arguments) {
                var $async$goto = 0, $async$completer = A._makeAsyncAwaitCompleter(type$.Record_5_Map_String_Value_named_and_Map_String_AstNode_namedNodes_and_List_Value_positional_and_List_AstNode_positionalNodes_and_ListSeparator_separator_2), $async$returnValue, $async$self = this, t1, t2, t3, t4, _i, expression, nodeForSpan, t5, t6, named, namedNodes, $name, value, t7, restArgs, rest, restNodeForSpan, separator, keywordRestArgs, keywordRest, keywordRestNodeForSpan, positional, positionalNodes, $async$temp1, $async$temp2;
                var $async$_async_evaluate0$_evaluateArguments$1 = A._wrapJsFunctionForAsync(function($async$errorCode, $async$result) {
                    if ($async$errorCode === 1) return A._asyncRethrow($async$result, $async$completer);
                    for(;;)switch($async$goto){
                        case 0:
                            // Function start
                            positional = A._setArrayType([], type$.JSArray_Value_2);
                            positionalNodes = A._setArrayType([], type$.JSArray_AstNode_2);
                            t1 = $arguments.positional, t2 = t1.length, t3 = type$._Future_Value_2, t4 = type$.Future_Value_2, _i = 0;
                        case 3:
                            // for condition
                            if (!(_i < t2)) {
                                // goto after for
                                $async$goto = 5;
                                break;
                            }
                            expression = t1[_i];
                            nodeForSpan = $async$self._async_evaluate0$_expressionNode$1(expression);
                            t5 = expression.accept$1($async$self);
                            if (!t4._is(t5)) {
                                t6 = new A._Future($.Zone__current, t3);
                                t6._state = 8;
                                t6._resultOrListeners = t5;
                                t5 = t6;
                            }
                            $async$temp1 = positional;
                            $async$goto = 6;
                            return A._asyncAwait(t5, $async$_async_evaluate0$_evaluateArguments$1);
                        case 6:
                            // returning from await.
                            $async$temp1.push($async$self._async_evaluate0$_withoutSlash$2($async$result, nodeForSpan));
                            positionalNodes.push(nodeForSpan);
                        case 4:
                            // for update
                            ++_i;
                            // goto for condition
                            $async$goto = 3;
                            break;
                        case 5:
                            // after for
                            t1 = type$.String;
                            named = A.LinkedHashMap_LinkedHashMap$_empty(t1, type$.Value_2);
                            t2 = type$.AstNode_2;
                            namedNodes = A.LinkedHashMap_LinkedHashMap$_empty(t1, t2);
                            t5 = A.MapExtensions_get_pairs0($arguments.named, t1, type$.Expression_2), t5 = t5.get$iterator(t5);
                        case 7:
                            // for condition
                            if (!t5.moveNext$0()) {
                                // goto after for
                                $async$goto = 8;
                                break;
                            }
                            t6 = t5.get$current(t5);
                            $name = t6._0;
                            value = t6._1;
                            nodeForSpan = $async$self._async_evaluate0$_expressionNode$1(value);
                            t6 = value.accept$1($async$self);
                            if (!t4._is(t6)) {
                                t7 = new A._Future($.Zone__current, t3);
                                t7._state = 8;
                                t7._resultOrListeners = t6;
                                t6 = t7;
                            }
                            $async$temp1 = named;
                            $async$temp2 = $name;
                            $async$goto = 9;
                            return A._asyncAwait(t6, $async$_async_evaluate0$_evaluateArguments$1);
                        case 9:
                            // returning from await.
                            $async$temp1.$indexSet(0, $async$temp2, $async$self._async_evaluate0$_withoutSlash$2($async$result, nodeForSpan));
                            namedNodes.$indexSet(0, $name, nodeForSpan);
                            // goto for condition
                            $async$goto = 7;
                            break;
                        case 8:
                            // after for
                            restArgs = $arguments.rest;
                            if (restArgs == null) {
                                $async$returnValue = new A._Record_5_named_namedNodes_positional_positionalNodes_separator([
                                    named,
                                    namedNodes,
                                    positional,
                                    positionalNodes,
                                    B.ListSeparator_undecided_null_3_undecided0
                                ]);
                                // goto return
                                $async$goto = 1;
                                break;
                            }
                            $async$goto = 10;
                            return A._asyncAwait(restArgs.accept$1($async$self), $async$_async_evaluate0$_evaluateArguments$1);
                        case 10:
                            // returning from await.
                            rest = $async$result;
                            restNodeForSpan = $async$self._async_evaluate0$_expressionNode$1(restArgs);
                            if (rest instanceof A.SassMap0) {
                                $async$self._async_evaluate0$_addRestMap$4(named, rest, restArgs, new A._EvaluateVisitor__evaluateArguments_closure11());
                                t3 = A.LinkedHashMap_LinkedHashMap$_empty(t1, t2);
                                for(t4 = rest._map0$_contents, t4 = t4.get$keys(t4), t4 = t4.get$iterator(t4), t5 = type$.SassString_2; t4.moveNext$0();)t3.$indexSet(0, t5._as(t4.get$current(t4))._string0$_text, restNodeForSpan);
                                namedNodes.addAll$1(0, t3);
                                separator = B.ListSeparator_undecided_null_3_undecided0;
                            } else if (rest instanceof A.SassList0) {
                                t3 = rest._list1$_contents;
                                B.JSArray_methods.addAll$1(positional, new A.MappedListIterable(t3, new A._EvaluateVisitor__evaluateArguments_closure12($async$self, restNodeForSpan), A._arrayInstanceType(t3)._eval$1("MappedListIterable<1,Value0>")));
                                B.JSArray_methods.addAll$1(positionalNodes, A.List_List$filled(t3.length, restNodeForSpan, false, t2));
                                separator = rest._list1$_separator;
                                if (rest instanceof A.SassArgumentList0) {
                                    rest._argument_list$_wereKeywordsAccessed = true;
                                    rest._argument_list$_keywords.forEach$1(0, new A._EvaluateVisitor__evaluateArguments_closure13($async$self, named, restNodeForSpan, namedNodes));
                                }
                            } else {
                                positional.push($async$self._async_evaluate0$_withoutSlash$2(rest, restNodeForSpan));
                                positionalNodes.push(restNodeForSpan);
                                separator = B.ListSeparator_undecided_null_3_undecided0;
                            }
                            keywordRestArgs = $arguments.keywordRest;
                            if (keywordRestArgs == null) {
                                $async$returnValue = new A._Record_5_named_namedNodes_positional_positionalNodes_separator([
                                    named,
                                    namedNodes,
                                    positional,
                                    positionalNodes,
                                    separator
                                ]);
                                // goto return
                                $async$goto = 1;
                                break;
                            }
                            $async$goto = 11;
                            return A._asyncAwait(keywordRestArgs.accept$1($async$self), $async$_async_evaluate0$_evaluateArguments$1);
                        case 11:
                            // returning from await.
                            keywordRest = $async$result;
                            keywordRestNodeForSpan = $async$self._async_evaluate0$_expressionNode$1(keywordRestArgs);
                            if (keywordRest instanceof A.SassMap0) {
                                $async$self._async_evaluate0$_addRestMap$4(named, keywordRest, keywordRestArgs, new A._EvaluateVisitor__evaluateArguments_closure14());
                                t1 = A.LinkedHashMap_LinkedHashMap$_empty(t1, t2);
                                for(t2 = keywordRest._map0$_contents, t2 = t2.get$keys(t2), t2 = t2.get$iterator(t2), t3 = type$.SassString_2; t2.moveNext$0();)t1.$indexSet(0, t3._as(t2.get$current(t2))._string0$_text, keywordRestNodeForSpan);
                                namedNodes.addAll$1(0, t1);
                                $async$returnValue = new A._Record_5_named_namedNodes_positional_positionalNodes_separator([
                                    named,
                                    namedNodes,
                                    positional,
                                    positionalNodes,
                                    separator
                                ]);
                                // goto return
                                $async$goto = 1;
                                break;
                            } else throw A.wrapException($async$self._async_evaluate0$_exception$2(string$.Variabs + keywordRest.toString$0(0) + ").", keywordRestArgs.get$span(keywordRestArgs)));
                        case 1:
                            // return
                            return A._asyncReturn($async$returnValue, $async$completer);
                    }
                });
                return A._asyncStartSync($async$_async_evaluate0$_evaluateArguments$1, $async$completer);
            },
            _async_evaluate0$_evaluateMacroArguments$1: function(invocation) {
                return this._evaluateMacroArguments$body$_EvaluateVisitor0(invocation);
            },
            _evaluateMacroArguments$body$_EvaluateVisitor0: function(invocation) {
                var $async$goto = 0, $async$completer = A._makeAsyncAwaitCompleter(type$.Record_2_List_Expression_and_Map_String_Expression_2), $async$returnValue, $async$self = this, t2, positional, named, rest, restNodeForSpan, keywordRestArgs_, keywordRest, keywordRestNodeForSpan, t1, restArgs_;
                var $async$_async_evaluate0$_evaluateMacroArguments$1 = A._wrapJsFunctionForAsync(function($async$errorCode, $async$result) {
                    if ($async$errorCode === 1) return A._asyncRethrow($async$result, $async$completer);
                    for(;;)switch($async$goto){
                        case 0:
                            // Function start
                            t1 = invocation.$arguments;
                            restArgs_ = t1.rest;
                            if (restArgs_ == null) {
                                $async$returnValue = new A._Record_2(t1.positional, t1.named);
                                // goto return
                                $async$goto = 1;
                                break;
                            }
                            t2 = t1.positional;
                            positional = A._setArrayType(t2.slice(0), A._arrayInstanceType(t2));
                            named = A.LinkedHashMap_LinkedHashMap$of(t1.named, type$.String, type$.Expression_2);
                            $async$goto = 3;
                            return A._asyncAwait(restArgs_.accept$1($async$self), $async$_async_evaluate0$_evaluateMacroArguments$1);
                        case 3:
                            // returning from await.
                            rest = $async$result;
                            restNodeForSpan = $async$self._async_evaluate0$_expressionNode$1(restArgs_);
                            if (rest instanceof A.SassMap0) $async$self._async_evaluate0$_addRestMap$4(named, rest, invocation, new A._EvaluateVisitor__evaluateMacroArguments_closure11(restArgs_));
                            else if (rest instanceof A.SassList0) {
                                t2 = rest._list1$_contents;
                                B.JSArray_methods.addAll$1(positional, new A.MappedListIterable(t2, new A._EvaluateVisitor__evaluateMacroArguments_closure12($async$self, restNodeForSpan, restArgs_), A._arrayInstanceType(t2)._eval$1("MappedListIterable<1,Expression0>")));
                                if (rest instanceof A.SassArgumentList0) {
                                    rest._argument_list$_wereKeywordsAccessed = true;
                                    rest._argument_list$_keywords.forEach$1(0, new A._EvaluateVisitor__evaluateMacroArguments_closure13($async$self, named, restNodeForSpan, restArgs_));
                                }
                            } else positional.push(new A.ValueExpression0($async$self._async_evaluate0$_withoutSlash$2(rest, restNodeForSpan), restArgs_.get$span(restArgs_)));
                            keywordRestArgs_ = t1.keywordRest;
                            if (keywordRestArgs_ == null) {
                                $async$returnValue = new A._Record_2(positional, named);
                                // goto return
                                $async$goto = 1;
                                break;
                            }
                            $async$goto = 4;
                            return A._asyncAwait(keywordRestArgs_.accept$1($async$self), $async$_async_evaluate0$_evaluateMacroArguments$1);
                        case 4:
                            // returning from await.
                            keywordRest = $async$result;
                            keywordRestNodeForSpan = $async$self._async_evaluate0$_expressionNode$1(keywordRestArgs_);
                            if (keywordRest instanceof A.SassMap0) {
                                $async$self._async_evaluate0$_addRestMap$4(named, keywordRest, invocation, new A._EvaluateVisitor__evaluateMacroArguments_closure14($async$self, keywordRestNodeForSpan, keywordRestArgs_));
                                $async$returnValue = new A._Record_2(positional, named);
                                // goto return
                                $async$goto = 1;
                                break;
                            } else throw A.wrapException($async$self._async_evaluate0$_exception$2(string$.Variabs + keywordRest.toString$0(0) + ").", keywordRestArgs_.get$span(keywordRestArgs_)));
                        case 1:
                            // return
                            return A._asyncReturn($async$returnValue, $async$completer);
                    }
                });
                return A._asyncStartSync($async$_async_evaluate0$_evaluateMacroArguments$1, $async$completer);
            },
            _async_evaluate0$_addRestMap$1$4: function(values, map, nodeWithSpan, convert) {
                map._map0$_contents.forEach$1(0, new A._EvaluateVisitor__addRestMap_closure2(this, values, convert, this._async_evaluate0$_expressionNode$1(nodeWithSpan), map, nodeWithSpan));
            },
            _async_evaluate0$_addRestMap$4: function(values, map, nodeWithSpan, convert) {
                return this._async_evaluate0$_addRestMap$1$4(values, map, nodeWithSpan, convert, type$.dynamic);
            },
            _async_evaluate0$_verifyArguments$4: function(positional, named, parameters, nodeWithSpan) {
                return this._async_evaluate0$_addExceptionSpan$2(nodeWithSpan, new A._EvaluateVisitor__verifyArguments_closure2(parameters, positional, named));
            },
            visitSelectorExpression$1: function(_, node) {
                return this.visitSelectorExpression$body$_EvaluateVisitor0(0, node);
            },
            visitSelectorExpression$body$_EvaluateVisitor0: function(_, node) {
                var $async$goto = 0, $async$completer = A._makeAsyncAwaitCompleter(type$.Value_2), $async$returnValue, $async$self = this, t1;
                var $async$visitSelectorExpression$1 = A._wrapJsFunctionForAsync(function($async$errorCode, $async$result) {
                    if ($async$errorCode === 1) return A._asyncRethrow($async$result, $async$completer);
                    for(;;)switch($async$goto){
                        case 0:
                            // Function start
                            t1 = $async$self._async_evaluate0$_styleRuleIgnoringAtRoot;
                            t1 = t1 == null ? null : t1.originalSelector.get$asSassList();
                            $async$returnValue = t1 == null ? B.C__SassNull0 : t1;
                            // goto return
                            $async$goto = 1;
                            break;
                        case 1:
                            // return
                            return A._asyncReturn($async$returnValue, $async$completer);
                    }
                });
                return A._asyncStartSync($async$visitSelectorExpression$1, $async$completer);
            },
            visitStringExpression$1: function(_, node) {
                return this.visitStringExpression$body$_EvaluateVisitor0(0, node);
            },
            visitStringExpression$body$_EvaluateVisitor0: function(_, node) {
                var $async$goto = 0, $async$completer = A._makeAsyncAwaitCompleter(type$.SassString_2), $async$returnValue, $async$self = this, t1, t2, t3, _i, value, t4, _0_0, text, oldInSupportsDeclaration;
                var $async$visitStringExpression$1 = A._wrapJsFunctionForAsync(function($async$errorCode, $async$result) {
                    if ($async$errorCode === 1) return A._asyncRethrow($async$result, $async$completer);
                    for(;;)switch($async$goto){
                        case 0:
                            // Function start
                            oldInSupportsDeclaration = $async$self._async_evaluate0$_inSupportsDeclaration;
                            $async$self._async_evaluate0$_inSupportsDeclaration = false;
                            t1 = A._setArrayType([], type$.JSArray_String);
                            t2 = node.text.contents, t3 = t2.length, _i = 0;
                        case 3:
                            // for condition
                            if (!(_i < t3)) {
                                // goto after for
                                $async$goto = 5;
                                break;
                            }
                            value = t2[_i];
                            if (typeof value == "string") {
                                t4 = value;
                                // goto break $label0$0
                                $async$goto = 6;
                                break;
                            }
                            $async$goto = value instanceof A.Expression0 ? 7 : 8;
                            break;
                        case 7:
                            // then
                            $async$goto = 9;
                            return A._asyncAwait(value.accept$1($async$self), $async$visitStringExpression$1);
                        case 9:
                            // returning from await.
                            _0_0 = $async$result;
                            $label1$1: {
                                if (_0_0 instanceof A.SassString0) {
                                    text = _0_0._string0$_text;
                                    t4 = text;
                                    break $label1$1;
                                }
                                t4 = $async$self._async_evaluate0$_serialize$3$quote(_0_0, value, false);
                                break $label1$1;
                            }
                            // goto break $label0$0
                            $async$goto = 6;
                            break;
                        case 8:
                            // join
                            t4 = A.throwExpression(A.UnsupportedError$("Unknown interpolation value " + A.S(value)));
                        case 6:
                            // break $label0$0
                            t1.push(t4);
                        case 4:
                            // for update
                            ++_i;
                            // goto for condition
                            $async$goto = 3;
                            break;
                        case 5:
                            // after for
                            t1 = B.JSArray_methods.join$0(t1);
                            $async$self._async_evaluate0$_inSupportsDeclaration = oldInSupportsDeclaration;
                            $async$returnValue = new A.SassString0(t1, node.hasQuotes);
                            // goto return
                            $async$goto = 1;
                            break;
                        case 1:
                            // return
                            return A._asyncReturn($async$returnValue, $async$completer);
                    }
                });
                return A._asyncStartSync($async$visitStringExpression$1, $async$completer);
            },
            visitSupportsExpression$1: function(_, expression) {
                return this.visitSupportsExpression$body$_EvaluateVisitor0(0, expression);
            },
            visitSupportsExpression$body$_EvaluateVisitor0: function(_, expression) {
                var $async$goto = 0, $async$completer = A._makeAsyncAwaitCompleter(type$.SassString_2), $async$returnValue, $async$self = this, $async$temp1;
                var $async$visitSupportsExpression$1 = A._wrapJsFunctionForAsync(function($async$errorCode, $async$result) {
                    if ($async$errorCode === 1) return A._asyncRethrow($async$result, $async$completer);
                    for(;;)switch($async$goto){
                        case 0:
                            // Function start
                            $async$temp1 = A;
                            $async$goto = 3;
                            return A._asyncAwait($async$self._async_evaluate0$_visitSupportsCondition$1(expression.condition), $async$visitSupportsExpression$1);
                        case 3:
                            // returning from await.
                            $async$returnValue = new $async$temp1.SassString0($async$result, false);
                            // goto return
                            $async$goto = 1;
                            break;
                        case 1:
                            // return
                            return A._asyncReturn($async$returnValue, $async$completer);
                    }
                });
                return A._asyncStartSync($async$visitSupportsExpression$1, $async$completer);
            },
            visitCssAtRule$1: function(node) {
                return this.visitCssAtRule$body$_EvaluateVisitor0(node);
            },
            visitCssAtRule$body$_EvaluateVisitor0: function(node) {
                var $async$goto = 0, $async$completer = A._makeAsyncAwaitCompleter(type$.void), $async$returnValue, $async$self = this, wasInKeyframes, wasInUnknownAtRule, t1, rule;
                var $async$visitCssAtRule$1 = A._wrapJsFunctionForAsync(function($async$errorCode, $async$result) {
                    if ($async$errorCode === 1) return A._asyncRethrow($async$result, $async$completer);
                    for(;;)switch($async$goto){
                        case 0:
                            // Function start
                            if ($async$self._async_evaluate0$_declarationName != null) throw A.wrapException($async$self._async_evaluate0$_exception$2(string$.At_rul, node.span));
                            if (node.isChildless) {
                                $async$self._async_evaluate0$_copyParentAfterSibling$0();
                                $async$self._async_evaluate0$_assertInModule$2($async$self._async_evaluate0$__parent, "__parent").addChild$1(A.ModifiableCssAtRule$0(node.name, node.span, true, node.value));
                                // goto return
                                $async$goto = 1;
                                break;
                            }
                            wasInKeyframes = $async$self._async_evaluate0$_inKeyframes;
                            wasInUnknownAtRule = $async$self._async_evaluate0$_inUnknownAtRule;
                            t1 = node.name;
                            if (A.unvendor0(t1.value) === "keyframes") $async$self._async_evaluate0$_inKeyframes = true;
                            else $async$self._async_evaluate0$_inUnknownAtRule = true;
                            rule = A.ModifiableCssAtRule$0(t1, node.span, false, node.value);
                            $async$goto = $async$self.get$_async_evaluate0$_hasCssNesting() ? 3 : 4;
                            break;
                        case 3:
                            // then
                            $async$goto = 5;
                            return A._asyncAwait($async$self._async_evaluate0$_withParent$2$3$scopeWhen(rule, new A._EvaluateVisitor_visitCssAtRule_closure8($async$self, node), false, type$.ModifiableCssAtRule_2, type$.Null), $async$visitCssAtRule$1);
                        case 5:
                            // returning from await.
                            $async$self._async_evaluate0$_inUnknownAtRule = wasInUnknownAtRule;
                            $async$self._async_evaluate0$_inKeyframes = wasInKeyframes;
                            // goto return
                            $async$goto = 1;
                            break;
                        case 4:
                            // join
                            $async$goto = 6;
                            return A._asyncAwait($async$self._async_evaluate0$_withParent$2$4$scopeWhen$through(rule, new A._EvaluateVisitor_visitCssAtRule_closure9($async$self, node), false, new A._EvaluateVisitor_visitCssAtRule_closure10(), type$.ModifiableCssAtRule_2, type$.Null), $async$visitCssAtRule$1);
                        case 6:
                            // returning from await.
                            $async$self._async_evaluate0$_inUnknownAtRule = wasInUnknownAtRule;
                            $async$self._async_evaluate0$_inKeyframes = wasInKeyframes;
                        case 1:
                            // return
                            return A._asyncReturn($async$returnValue, $async$completer);
                    }
                });
                return A._asyncStartSync($async$visitCssAtRule$1, $async$completer);
            },
            visitCssComment$1: function(node) {
                return this.visitCssComment$body$_EvaluateVisitor0(node);
            },
            visitCssComment$body$_EvaluateVisitor0: function(node) {
                var $async$goto = 0, $async$completer = A._makeAsyncAwaitCompleter(type$.void), $async$self = this;
                var $async$visitCssComment$1 = A._wrapJsFunctionForAsync(function($async$errorCode, $async$result) {
                    if ($async$errorCode === 1) return A._asyncRethrow($async$result, $async$completer);
                    for(;;)switch($async$goto){
                        case 0:
                            // Function start
                            if ($async$self._async_evaluate0$_assertInModule$2($async$self._async_evaluate0$__parent, "__parent") === $async$self._async_evaluate0$_assertInModule$2($async$self._async_evaluate0$__root, "_root") && $async$self._async_evaluate0$_assertInModule$2($async$self._async_evaluate0$__endOfImports, "_endOfImports") === J.get$length$asx($async$self._async_evaluate0$_assertInModule$2($async$self._async_evaluate0$__root, "_root").children._collection$_source)) $async$self._async_evaluate0$__endOfImports = $async$self._async_evaluate0$_assertInModule$2($async$self._async_evaluate0$__endOfImports, "_endOfImports") + 1;
                            $async$self._async_evaluate0$_copyParentAfterSibling$0();
                            $async$self._async_evaluate0$_assertInModule$2($async$self._async_evaluate0$__parent, "__parent").addChild$1(new A.ModifiableCssComment0(node.text, node.span));
                            // implicit return
                            return A._asyncReturn(null, $async$completer);
                    }
                });
                return A._asyncStartSync($async$visitCssComment$1, $async$completer);
            },
            visitCssDeclaration$1: function(node) {
                return this.visitCssDeclaration$body$_EvaluateVisitor0(node);
            },
            visitCssDeclaration$body$_EvaluateVisitor0: function(node) {
                var $async$goto = 0, $async$completer = A._makeAsyncAwaitCompleter(type$.void), $async$self = this;
                var $async$visitCssDeclaration$1 = A._wrapJsFunctionForAsync(function($async$errorCode, $async$result) {
                    if ($async$errorCode === 1) return A._asyncRethrow($async$result, $async$completer);
                    for(;;)switch($async$goto){
                        case 0:
                            // Function start
                            $async$self._async_evaluate0$_copyParentAfterSibling$0();
                            $async$self._async_evaluate0$_assertInModule$2($async$self._async_evaluate0$__parent, "__parent").addChild$1(A.ModifiableCssDeclaration$0(node.name, node.value, node.span, node.parsedAsSassScript, node.valueSpanForMap));
                            // implicit return
                            return A._asyncReturn(null, $async$completer);
                    }
                });
                return A._asyncStartSync($async$visitCssDeclaration$1, $async$completer);
            },
            visitCssImport$1: function(node) {
                return this.visitCssImport$body$_EvaluateVisitor0(node);
            },
            visitCssImport$body$_EvaluateVisitor0: function(node) {
                var $async$goto = 0, $async$completer = A._makeAsyncAwaitCompleter(type$.void), $async$self = this, t1, modifiableNode;
                var $async$visitCssImport$1 = A._wrapJsFunctionForAsync(function($async$errorCode, $async$result) {
                    if ($async$errorCode === 1) return A._asyncRethrow($async$result, $async$completer);
                    for(;;)switch($async$goto){
                        case 0:
                            // Function start
                            modifiableNode = new A.ModifiableCssImport0(node.url, node.modifiers, node.span);
                            if ($async$self._async_evaluate0$_assertInModule$2($async$self._async_evaluate0$__parent, "__parent") !== $async$self._async_evaluate0$_assertInModule$2($async$self._async_evaluate0$__root, "_root")) {
                                $async$self._async_evaluate0$_copyParentAfterSibling$0();
                                $async$self._async_evaluate0$_assertInModule$2($async$self._async_evaluate0$__parent, "__parent").addChild$1(modifiableNode);
                            } else if ($async$self._async_evaluate0$_assertInModule$2($async$self._async_evaluate0$__endOfImports, "_endOfImports") === J.get$length$asx($async$self._async_evaluate0$_assertInModule$2($async$self._async_evaluate0$__root, "_root").children._collection$_source)) {
                                $async$self._async_evaluate0$_assertInModule$2($async$self._async_evaluate0$__root, "_root").addChild$1(modifiableNode);
                                $async$self._async_evaluate0$__endOfImports = $async$self._async_evaluate0$_assertInModule$2($async$self._async_evaluate0$__endOfImports, "_endOfImports") + 1;
                            } else {
                                t1 = $async$self._async_evaluate0$_outOfOrderImports;
                                (t1 == null ? $async$self._async_evaluate0$_outOfOrderImports = A._setArrayType([], type$.JSArray_ModifiableCssImport_2) : t1).push(modifiableNode);
                            }
                            // implicit return
                            return A._asyncReturn(null, $async$completer);
                    }
                });
                return A._asyncStartSync($async$visitCssImport$1, $async$completer);
            },
            visitCssKeyframeBlock$1: function(node) {
                return this.visitCssKeyframeBlock$body$_EvaluateVisitor0(node);
            },
            visitCssKeyframeBlock$body$_EvaluateVisitor0: function(node) {
                var $async$goto = 0, $async$completer = A._makeAsyncAwaitCompleter(type$.void), $async$self = this;
                var $async$visitCssKeyframeBlock$1 = A._wrapJsFunctionForAsync(function($async$errorCode, $async$result) {
                    if ($async$errorCode === 1) return A._asyncRethrow($async$result, $async$completer);
                    for(;;)switch($async$goto){
                        case 0:
                            // Function start
                            $async$goto = 2;
                            return A._asyncAwait($async$self._async_evaluate0$_withParent$2$4$scopeWhen$through(A.ModifiableCssKeyframeBlock$0(node.selector, node.span), new A._EvaluateVisitor_visitCssKeyframeBlock_closure5($async$self, node), false, new A._EvaluateVisitor_visitCssKeyframeBlock_closure6(), type$.ModifiableCssKeyframeBlock_2, type$.Null), $async$visitCssKeyframeBlock$1);
                        case 2:
                            // returning from await.
                            // implicit return
                            return A._asyncReturn(null, $async$completer);
                    }
                });
                return A._asyncStartSync($async$visitCssKeyframeBlock$1, $async$completer);
            },
            visitCssMediaRule$1: function(node) {
                return this.visitCssMediaRule$body$_EvaluateVisitor0(node);
            },
            visitCssMediaRule$body$_EvaluateVisitor0: function(node) {
                var $async$goto = 0, $async$completer = A._makeAsyncAwaitCompleter(type$.void), $async$returnValue, $async$self = this, mergedQueries, t1, mergedSources, t2, t3;
                var $async$visitCssMediaRule$1 = A._wrapJsFunctionForAsync(function($async$errorCode, $async$result) {
                    if ($async$errorCode === 1) return A._asyncRethrow($async$result, $async$completer);
                    for(;;)switch($async$goto){
                        case 0:
                            // Function start
                            if ($async$self._async_evaluate0$_declarationName != null) throw A.wrapException($async$self._async_evaluate0$_exception$2(string$.Media_, node.span));
                            $async$goto = $async$self.get$_async_evaluate0$_hasCssNesting() ? 3 : 4;
                            break;
                        case 3:
                            // then
                            $async$goto = 5;
                            return A._asyncAwait($async$self._async_evaluate0$_withParent$2$3$scopeWhen(A.ModifiableCssMediaRule$0(node.queries, node.span), new A._EvaluateVisitor_visitCssMediaRule_closure11($async$self, node), false, type$.ModifiableCssMediaRule_2, type$.Null), $async$visitCssMediaRule$1);
                        case 5:
                            // returning from await.
                            // goto return
                            $async$goto = 1;
                            break;
                        case 4:
                            // join
                            mergedQueries = A.NullableExtension_andThen0($async$self._async_evaluate0$_mediaQueries, new A._EvaluateVisitor_visitCssMediaRule_closure12($async$self, node));
                            t1 = mergedQueries == null;
                            if (!t1 && J.get$isEmpty$asx(mergedQueries)) {
                                // goto return
                                $async$goto = 1;
                                break;
                            }
                            if (t1) mergedSources = B.Set_empty6;
                            else {
                                t2 = $async$self._async_evaluate0$_mediaQuerySources;
                                t2.toString;
                                t2 = A.LinkedHashSet_LinkedHashSet$of(t2, type$.CssMediaQuery_2);
                                t3 = $async$self._async_evaluate0$_mediaQueries;
                                t3.toString;
                                t2.addAll$1(0, t3);
                                t2.addAll$1(0, node.queries);
                                mergedSources = t2;
                            }
                            t1 = t1 ? node.queries : mergedQueries;
                            $async$goto = 6;
                            return A._asyncAwait($async$self._async_evaluate0$_withParent$2$4$scopeWhen$through(A.ModifiableCssMediaRule$0(t1, node.span), new A._EvaluateVisitor_visitCssMediaRule_closure13($async$self, mergedQueries, node, mergedSources), false, new A._EvaluateVisitor_visitCssMediaRule_closure14(mergedSources), type$.ModifiableCssMediaRule_2, type$.Null), $async$visitCssMediaRule$1);
                        case 6:
                        // returning from await.
                        case 1:
                            // return
                            return A._asyncReturn($async$returnValue, $async$completer);
                    }
                });
                return A._asyncStartSync($async$visitCssMediaRule$1, $async$completer);
            },
            visitCssStyleRule$1: function(node) {
                return this.visitCssStyleRule$body$_EvaluateVisitor0(node);
            },
            visitCssStyleRule$body$_EvaluateVisitor0: function(node) {
                var $async$goto = 0, $async$completer = A._makeAsyncAwaitCompleter(type$.void), $async$self = this, t1, styleRule, _0_0, t2, t3, originalSelector, rule, oldAtRootExcludingStyleRule, _1_1, lastChild;
                var $async$visitCssStyleRule$1 = A._wrapJsFunctionForAsync(function($async$errorCode, $async$result) {
                    if ($async$errorCode === 1) return A._asyncRethrow($async$result, $async$completer);
                    for(;;)switch($async$goto){
                        case 0:
                            // Function start
                            if ($async$self._async_evaluate0$_declarationName != null) throw A.wrapException($async$self._async_evaluate0$_exception$2(string$.Style_n, node.span));
                            else if ($async$self._async_evaluate0$_inKeyframes && $async$self._async_evaluate0$_assertInModule$2($async$self._async_evaluate0$__parent, "__parent") instanceof A.ModifiableCssKeyframeBlock0) throw A.wrapException($async$self._async_evaluate0$_exception$2(string$.Style_k, node.span));
                            t1 = $async$self._async_evaluate0$_atRootExcludingStyleRule;
                            styleRule = t1 ? null : $async$self._async_evaluate0$_styleRuleIgnoringAtRoot;
                            _0_0 = t1 ? null : $async$self._async_evaluate0$_styleRuleIgnoringAtRoot;
                            $label0$0: {
                                if (_0_0 == null) {
                                    t1 = true;
                                    break $label0$0;
                                }
                                if (_0_0.fromPlainCss) {
                                    t1 = false;
                                    break $label0$0;
                                }
                                t1 = !(node.fromPlainCss && node._style_rule0$_selector._box0$_inner.value.accept$1(B.C__ContainsParentSelectorVisitor0));
                                break $label0$0;
                            }
                            t2 = node._style_rule0$_selector._box0$_inner;
                            if (t1) {
                                t2 = t2.value;
                                t3 = styleRule == null ? null : styleRule.originalSelector;
                                originalSelector = t2.nestWithin$3$implicitParent$preserveParentSelectors(t3, !$async$self._async_evaluate0$_atRootExcludingStyleRule, node.fromPlainCss);
                            } else originalSelector = t2.value;
                            rule = A.ModifiableCssStyleRule$0($async$self._async_evaluate0$_assertInModule$2($async$self._async_evaluate0$__extensionStore, "_extensionStore").addSelector$2(originalSelector, $async$self._async_evaluate0$_mediaQueries), node.span, node.fromPlainCss, originalSelector);
                            oldAtRootExcludingStyleRule = $async$self._async_evaluate0$_atRootExcludingStyleRule;
                            $async$self._async_evaluate0$_atRootExcludingStyleRule = false;
                            t1 = t1 ? new A._EvaluateVisitor_visitCssStyleRule_closure5() : null;
                            $async$goto = 2;
                            return A._asyncAwait($async$self._async_evaluate0$_withParent$2$4$scopeWhen$through(rule, new A._EvaluateVisitor_visitCssStyleRule_closure6($async$self, rule, node), false, t1, type$.ModifiableCssStyleRule_2, type$.Null), $async$visitCssStyleRule$1);
                        case 2:
                            // returning from await.
                            $async$self._async_evaluate0$_atRootExcludingStyleRule = oldAtRootExcludingStyleRule;
                            t1 = $async$self._async_evaluate0$_assertInModule$2($async$self._async_evaluate0$__parent, "__parent").children._collection$_source;
                            t2 = J.getInterceptor$asx(t1);
                            _1_1 = t2.get$length(t1);
                            if (_1_1 >= 1) {
                                lastChild = t2.elementAt$1(t1, _1_1 - 1);
                                t1 = styleRule == null;
                            } else {
                                lastChild = null;
                                t1 = false;
                            }
                            if (t1) lastChild.isGroupEnd = true;
                            // implicit return
                            return A._asyncReturn(null, $async$completer);
                    }
                });
                return A._asyncStartSync($async$visitCssStyleRule$1, $async$completer);
            },
            visitCssStylesheet$1: function(node) {
                return this.visitCssStylesheet$body$_EvaluateVisitor0(node);
            },
            visitCssStylesheet$body$_EvaluateVisitor0: function(node) {
                var $async$goto = 0, $async$completer = A._makeAsyncAwaitCompleter(type$.void), $async$self = this, t1;
                var $async$visitCssStylesheet$1 = A._wrapJsFunctionForAsync(function($async$errorCode, $async$result) {
                    if ($async$errorCode === 1) return A._asyncRethrow($async$result, $async$completer);
                    for(;;)switch($async$goto){
                        case 0:
                            // Function start
                            t1 = J.get$iterator$ax(node.get$children(node));
                        case 2:
                            // for condition
                            if (!t1.moveNext$0()) {
                                // goto after for
                                $async$goto = 3;
                                break;
                            }
                            $async$goto = 4;
                            return A._asyncAwait(t1.get$current(t1).accept$1($async$self), $async$visitCssStylesheet$1);
                        case 4:
                            // returning from await.
                            // goto for condition
                            $async$goto = 2;
                            break;
                        case 3:
                            // after for
                            // implicit return
                            return A._asyncReturn(null, $async$completer);
                    }
                });
                return A._asyncStartSync($async$visitCssStylesheet$1, $async$completer);
            },
            visitCssSupportsRule$1: function(node) {
                return this.visitCssSupportsRule$body$_EvaluateVisitor0(node);
            },
            visitCssSupportsRule$body$_EvaluateVisitor0: function(node) {
                var $async$goto = 0, $async$completer = A._makeAsyncAwaitCompleter(type$.void), $async$returnValue, $async$self = this, rule;
                var $async$visitCssSupportsRule$1 = A._wrapJsFunctionForAsync(function($async$errorCode, $async$result) {
                    if ($async$errorCode === 1) return A._asyncRethrow($async$result, $async$completer);
                    for(;;)switch($async$goto){
                        case 0:
                            // Function start
                            if ($async$self._async_evaluate0$_declarationName != null) throw A.wrapException($async$self._async_evaluate0$_exception$2(string$.Suppor, node.span));
                            rule = A.ModifiableCssSupportsRule$0(node.condition, node.span);
                            $async$goto = $async$self.get$_async_evaluate0$_hasCssNesting() ? 3 : 4;
                            break;
                        case 3:
                            // then
                            $async$goto = 5;
                            return A._asyncAwait($async$self._async_evaluate0$_withParent$2$3$scopeWhen(rule, new A._EvaluateVisitor_visitCssSupportsRule_closure8($async$self, node), false, type$.ModifiableCssSupportsRule_2, type$.Null), $async$visitCssSupportsRule$1);
                        case 5:
                            // returning from await.
                            // goto return
                            $async$goto = 1;
                            break;
                        case 4:
                            // join
                            $async$goto = 6;
                            return A._asyncAwait($async$self._async_evaluate0$_withParent$2$4$scopeWhen$through(rule, new A._EvaluateVisitor_visitCssSupportsRule_closure9($async$self, node), false, new A._EvaluateVisitor_visitCssSupportsRule_closure10(), type$.ModifiableCssSupportsRule_2, type$.Null), $async$visitCssSupportsRule$1);
                        case 6:
                        // returning from await.
                        case 1:
                            // return
                            return A._asyncReturn($async$returnValue, $async$completer);
                    }
                });
                return A._asyncStartSync($async$visitCssSupportsRule$1, $async$completer);
            },
            _async_evaluate0$_handleReturn$1$2: function(list, callback) {
                return this._handleReturn$body$_EvaluateVisitor0(list, callback);
            },
            _async_evaluate0$_handleReturn$2: function(list, callback) {
                return this._async_evaluate0$_handleReturn$1$2(list, callback, type$.dynamic);
            },
            _handleReturn$body$_EvaluateVisitor0: function(list, callback) {
                var $async$goto = 0, $async$completer = A._makeAsyncAwaitCompleter(type$.nullable_Value_2), $async$returnValue, t1, _i, _0_0;
                var $async$_async_evaluate0$_handleReturn$1$2 = A._wrapJsFunctionForAsync(function($async$errorCode, $async$result) {
                    if ($async$errorCode === 1) return A._asyncRethrow($async$result, $async$completer);
                    for(;;)switch($async$goto){
                        case 0:
                            // Function start
                            t1 = list.length, _i = 0;
                        case 3:
                            // for condition
                            if (!(_i < list.length)) {
                                // goto after for
                                $async$goto = 5;
                                break;
                            }
                            $async$goto = 6;
                            return A._asyncAwait(callback.call$1(list[_i]), $async$_async_evaluate0$_handleReturn$1$2);
                        case 6:
                            // returning from await.
                            _0_0 = $async$result;
                            if (_0_0 != null) {
                                $async$returnValue = _0_0;
                                // goto return
                                $async$goto = 1;
                                break;
                            }
                        case 4:
                            // for update
                            list.length === t1 || (0, A.throwConcurrentModificationError)(list), ++_i;
                            // goto for condition
                            $async$goto = 3;
                            break;
                        case 5:
                            // after for
                            $async$returnValue = null;
                            // goto return
                            $async$goto = 1;
                            break;
                        case 1:
                            // return
                            return A._asyncReturn($async$returnValue, $async$completer);
                    }
                });
                return A._asyncStartSync($async$_async_evaluate0$_handleReturn$1$2, $async$completer);
            },
            _async_evaluate0$_withEnvironment$1$2: function(environment, callback, $T) {
                return this._withEnvironment$body$_EvaluateVisitor0(environment, callback, $T, $T);
            },
            _withEnvironment$body$_EvaluateVisitor0: function(environment, callback, $T, $async$type) {
                var $async$goto = 0, $async$completer = A._makeAsyncAwaitCompleter($async$type), $async$returnValue, $async$self = this, result, oldEnvironment;
                var $async$_async_evaluate0$_withEnvironment$1$2 = A._wrapJsFunctionForAsync(function($async$errorCode, $async$result) {
                    if ($async$errorCode === 1) return A._asyncRethrow($async$result, $async$completer);
                    for(;;)switch($async$goto){
                        case 0:
                            // Function start
                            oldEnvironment = $async$self._async_evaluate0$_environment;
                            $async$self._async_evaluate0$_environment = environment;
                            $async$goto = 3;
                            return A._asyncAwait(callback.call$0(), $async$_async_evaluate0$_withEnvironment$1$2);
                        case 3:
                            // returning from await.
                            result = $async$result;
                            $async$self._async_evaluate0$_environment = oldEnvironment;
                            $async$returnValue = result;
                            // goto return
                            $async$goto = 1;
                            break;
                        case 1:
                            // return
                            return A._asyncReturn($async$returnValue, $async$completer);
                    }
                });
                return A._asyncStartSync($async$_async_evaluate0$_withEnvironment$1$2, $async$completer);
            },
            _async_evaluate0$_interpolationToValue$3$trim$warnForColor: function(interpolation, trim, warnForColor) {
                return this._interpolationToValue$body$_EvaluateVisitor0(interpolation, trim, warnForColor);
            },
            _async_evaluate0$_interpolationToValue$1: function(interpolation) {
                return this._async_evaluate0$_interpolationToValue$3$trim$warnForColor(interpolation, false, false);
            },
            _async_evaluate0$_interpolationToValue$2$warnForColor: function(interpolation, warnForColor) {
                return this._async_evaluate0$_interpolationToValue$3$trim$warnForColor(interpolation, false, warnForColor);
            },
            _interpolationToValue$body$_EvaluateVisitor0: function(interpolation, trim, warnForColor) {
                var $async$goto = 0, $async$completer = A._makeAsyncAwaitCompleter(type$.CssValue_String_2), $async$returnValue, $async$self = this, result, t1;
                var $async$_async_evaluate0$_interpolationToValue$3$trim$warnForColor = A._wrapJsFunctionForAsync(function($async$errorCode, $async$result) {
                    if ($async$errorCode === 1) return A._asyncRethrow($async$result, $async$completer);
                    for(;;)switch($async$goto){
                        case 0:
                            // Function start
                            $async$goto = 3;
                            return A._asyncAwait($async$self._async_evaluate0$_performInterpolation$2$warnForColor(interpolation, warnForColor), $async$_async_evaluate0$_interpolationToValue$3$trim$warnForColor);
                        case 3:
                            // returning from await.
                            result = $async$result;
                            t1 = trim ? A.trimAscii0(result, true) : result;
                            $async$returnValue = new A.CssValue0(t1, interpolation.span, type$.CssValue_String_2);
                            // goto return
                            $async$goto = 1;
                            break;
                        case 1:
                            // return
                            return A._asyncReturn($async$returnValue, $async$completer);
                    }
                });
                return A._asyncStartSync($async$_async_evaluate0$_interpolationToValue$3$trim$warnForColor, $async$completer);
            },
            _async_evaluate0$_performInterpolation$2$warnForColor: function(interpolation, warnForColor) {
                return this._performInterpolation$body$_EvaluateVisitor0(interpolation, warnForColor);
            },
            _async_evaluate0$_performInterpolation$1: function(interpolation) {
                return this._async_evaluate0$_performInterpolation$2$warnForColor(interpolation, false);
            },
            _performInterpolation$body$_EvaluateVisitor0: function(interpolation, warnForColor) {
                var $async$goto = 0, $async$completer = A._makeAsyncAwaitCompleter(type$.String), $async$returnValue, $async$self = this;
                var $async$_async_evaluate0$_performInterpolation$2$warnForColor = A._wrapJsFunctionForAsync(function($async$errorCode, $async$result) {
                    if ($async$errorCode === 1) return A._asyncRethrow($async$result, $async$completer);
                    for(;;)switch($async$goto){
                        case 0:
                            // Function start
                            $async$goto = 3;
                            return A._asyncAwait($async$self._async_evaluate0$_performInterpolationHelper$3$sourceMap$warnForColor(interpolation, false, warnForColor), $async$_async_evaluate0$_performInterpolation$2$warnForColor);
                        case 3:
                            // returning from await.
                            $async$returnValue = $async$result._0;
                            // goto return
                            $async$goto = 1;
                            break;
                        case 1:
                            // return
                            return A._asyncReturn($async$returnValue, $async$completer);
                    }
                });
                return A._asyncStartSync($async$_async_evaluate0$_performInterpolation$2$warnForColor, $async$completer);
            },
            _async_evaluate0$_performInterpolationWithMap$2$warnForColor: function(interpolation, warnForColor) {
                return this._performInterpolationWithMap$body$_EvaluateVisitor0(interpolation, true);
            },
            _performInterpolationWithMap$body$_EvaluateVisitor0: function(interpolation, warnForColor) {
                var $async$goto = 0, $async$completer = A._makeAsyncAwaitCompleter(type$.Record_2_String_and_InterpolationMap_2), $async$returnValue, $async$self = this, _0_0, result, map;
                var $async$_async_evaluate0$_performInterpolationWithMap$2$warnForColor = A._wrapJsFunctionForAsync(function($async$errorCode, $async$result) {
                    if ($async$errorCode === 1) return A._asyncRethrow($async$result, $async$completer);
                    for(;;)switch($async$goto){
                        case 0:
                            // Function start
                            $async$goto = 3;
                            return A._asyncAwait($async$self._async_evaluate0$_performInterpolationHelper$3$sourceMap$warnForColor(interpolation, true, true), $async$_async_evaluate0$_performInterpolationWithMap$2$warnForColor);
                        case 3:
                            // returning from await.
                            _0_0 = $async$result;
                            result = _0_0._0;
                            map = _0_0._1;
                            map.toString;
                            $async$returnValue = new A._Record_2(result, map);
                            // goto return
                            $async$goto = 1;
                            break;
                        case 1:
                            // return
                            return A._asyncReturn($async$returnValue, $async$completer);
                    }
                });
                return A._asyncStartSync($async$_async_evaluate0$_performInterpolationWithMap$2$warnForColor, $async$completer);
            },
            _async_evaluate0$_performInterpolationHelper$3$sourceMap$warnForColor: function(interpolation, sourceMap, warnForColor) {
                return this._performInterpolationHelper$body$_EvaluateVisitor0(interpolation, sourceMap, warnForColor);
            },
            _performInterpolationHelper$body$_EvaluateVisitor0: function(interpolation, sourceMap, warnForColor) {
                var $async$goto = 0, $async$completer = A._makeAsyncAwaitCompleter(type$.Record_2_String_and_nullable_InterpolationMap_2), $async$returnValue, $async$self = this, t1, t2, t3, t4, t5, t6, first, _i, t7, value, result, result0, t8, targetOffsets, oldInSupportsDeclaration;
                var $async$_async_evaluate0$_performInterpolationHelper$3$sourceMap$warnForColor = A._wrapJsFunctionForAsync(function($async$errorCode, $async$result) {
                    if ($async$errorCode === 1) return A._asyncRethrow($async$result, $async$completer);
                    for(;;)switch($async$goto){
                        case 0:
                            // Function start
                            targetOffsets = sourceMap ? A._setArrayType([], type$.JSArray_int) : null;
                            oldInSupportsDeclaration = $async$self._async_evaluate0$_inSupportsDeclaration;
                            $async$self._async_evaluate0$_inSupportsDeclaration = false;
                            t1 = interpolation.contents, t2 = t1.length, t3 = type$.Expression_2, t4 = targetOffsets == null, t5 = interpolation.span, t6 = type$.Object, first = true, _i = 0, t7 = "";
                        case 3:
                            // for condition
                            if (!(_i < t2)) {
                                // goto after for
                                $async$goto = 5;
                                break;
                            }
                            value = t1[_i];
                            if (!first) {
                                if (!t4) targetOffsets.push(t7.length);
                            }
                            if (typeof value == "string") {
                                t7 += value;
                                // goto for update
                                $async$goto = 4;
                                break;
                            }
                            t3._as(value);
                            $async$goto = 6;
                            return A._asyncAwait(value.accept$1($async$self), $async$_async_evaluate0$_performInterpolationHelper$3$sourceMap$warnForColor);
                        case 6:
                            // returning from await.
                            result = $async$result;
                            if (warnForColor && $.$get$namesByColor0().containsKey$1(result)) {
                                result0 = A.List_List$from([
                                    ""
                                ], false, t6);
                                result0.$flags = 3;
                                t8 = $.$get$namesByColor0();
                                $async$self._async_evaluate0$_warn$2(string$.You_pr + A.S(t8.$index(0, result)) + string$.x20in_in + result.toString$0(0) + string$.x2c_whicw + A.S(t8.$index(0, result)) + string$.x22x29__If + new A.BinaryOperationExpression0(B.BinaryOperator_jCK0, new A.StringExpression0(new A.Interpolation0(result0, B.List_null, t5), true), value, false).toString$0(0) + "'.", value.get$span(value));
                            }
                            t7 += $async$self._async_evaluate0$_serialize$3$quote(result, value, false);
                        case 4:
                            // for update
                            ++_i, first = false;
                            // goto for condition
                            $async$goto = 3;
                            break;
                        case 5:
                            // after for
                            $async$self._async_evaluate0$_inSupportsDeclaration = oldInSupportsDeclaration;
                            $async$returnValue = new A._Record_2(t7.charCodeAt(0) == 0 ? t7 : t7, A.NullableExtension_andThen0(targetOffsets, new A._EvaluateVisitor__performInterpolationHelper_closure2(interpolation)));
                            // goto return
                            $async$goto = 1;
                            break;
                        case 1:
                            // return
                            return A._asyncReturn($async$returnValue, $async$completer);
                    }
                });
                return A._asyncStartSync($async$_async_evaluate0$_performInterpolationHelper$3$sourceMap$warnForColor, $async$completer);
            },
            _async_evaluate0$_evaluateToCss$2$quote: function(expression, quote) {
                return this._evaluateToCss$body$_EvaluateVisitor0(expression, quote);
            },
            _async_evaluate0$_evaluateToCss$1: function(expression) {
                return this._async_evaluate0$_evaluateToCss$2$quote(expression, true);
            },
            _evaluateToCss$body$_EvaluateVisitor0: function(expression, quote) {
                var $async$goto = 0, $async$completer = A._makeAsyncAwaitCompleter(type$.String), $async$returnValue, $async$self = this, t1;
                var $async$_async_evaluate0$_evaluateToCss$2$quote = A._wrapJsFunctionForAsync(function($async$errorCode, $async$result) {
                    if ($async$errorCode === 1) return A._asyncRethrow($async$result, $async$completer);
                    for(;;)switch($async$goto){
                        case 0:
                            // Function start
                            t1 = expression.accept$1($async$self);
                            $async$goto = 3;
                            return A._asyncAwait(type$.Future_Value_2._is(t1) ? t1 : A._Future$value(t1, type$.Value_2), $async$_async_evaluate0$_evaluateToCss$2$quote);
                        case 3:
                            // returning from await.
                            $async$returnValue = $async$self._async_evaluate0$_serialize$3$quote($async$result, expression, quote);
                            // goto return
                            $async$goto = 1;
                            break;
                        case 1:
                            // return
                            return A._asyncReturn($async$returnValue, $async$completer);
                    }
                });
                return A._asyncStartSync($async$_async_evaluate0$_evaluateToCss$2$quote, $async$completer);
            },
            _async_evaluate0$_serialize$3$quote: function(value, nodeWithSpan, quote) {
                return this._async_evaluate0$_addExceptionSpan$2(nodeWithSpan, new A._EvaluateVisitor__serialize_closure2(value, quote));
            },
            _async_evaluate0$_serialize$2: function(value, nodeWithSpan) {
                return this._async_evaluate0$_serialize$3$quote(value, nodeWithSpan, true);
            },
            _async_evaluate0$_expressionNode$1: function(expression) {
                var t1;
                if (expression instanceof A.VariableExpression0) {
                    t1 = this._async_evaluate0$_addExceptionSpan$2(expression, new A._EvaluateVisitor__expressionNode_closure2(this, expression));
                    return t1 == null ? expression : t1;
                } else return expression;
            },
            _async_evaluate0$_withParent$2$4$scopeWhen$through: function(node, callback, scopeWhen, through, $S, $T) {
                return this._withParent$body$_EvaluateVisitor0(node, callback, scopeWhen, through, $S, $T, $T);
            },
            _async_evaluate0$_withParent$2$3$scopeWhen: function(node, callback, scopeWhen, $S, $T) {
                return this._async_evaluate0$_withParent$2$4$scopeWhen$through(node, callback, scopeWhen, null, $S, $T);
            },
            _async_evaluate0$_withParent$2$2: function(node, callback, $S, $T) {
                return this._async_evaluate0$_withParent$2$4$scopeWhen$through(node, callback, true, null, $S, $T);
            },
            _withParent$body$_EvaluateVisitor0: function(node, callback, scopeWhen, through, $S, $T, $async$type) {
                var $async$goto = 0, $async$completer = A._makeAsyncAwaitCompleter($async$type), $async$returnValue, $async$self = this, oldParent, result;
                var $async$_async_evaluate0$_withParent$2$4$scopeWhen$through = A._wrapJsFunctionForAsync(function($async$errorCode, $async$result) {
                    if ($async$errorCode === 1) return A._asyncRethrow($async$result, $async$completer);
                    for(;;)switch($async$goto){
                        case 0:
                            // Function start
                            $async$self._async_evaluate0$_addChild$2$through(node, through);
                            oldParent = $async$self._async_evaluate0$_assertInModule$2($async$self._async_evaluate0$__parent, "__parent");
                            $async$self._async_evaluate0$__parent = node;
                            $async$goto = 3;
                            return A._asyncAwait($async$self._async_evaluate0$_environment.scope$1$2$when(callback, scopeWhen, $T), $async$_async_evaluate0$_withParent$2$4$scopeWhen$through);
                        case 3:
                            // returning from await.
                            result = $async$result;
                            $async$self._async_evaluate0$__parent = oldParent;
                            $async$returnValue = result;
                            // goto return
                            $async$goto = 1;
                            break;
                        case 1:
                            // return
                            return A._asyncReturn($async$returnValue, $async$completer);
                    }
                });
                return A._asyncStartSync($async$_async_evaluate0$_withParent$2$4$scopeWhen$through, $async$completer);
            },
            _async_evaluate0$_copyParentAfterSibling$0: function() {
                var t1, grandparent, newParent, _this = this, _s8_ = "__parent", _0_0 = _this._async_evaluate0$_assertInModule$2(_this._async_evaluate0$__parent, _s8_)._node$_parent;
                if (_0_0 != null) {
                    t1 = _0_0.children;
                    t1 = t1.get$last(t1) !== _this._async_evaluate0$_assertInModule$2(_this._async_evaluate0$__parent, _s8_);
                    grandparent = _0_0;
                } else {
                    grandparent = null;
                    t1 = false;
                }
                if (t1) {
                    newParent = _this._async_evaluate0$_assertInModule$2(_this._async_evaluate0$__parent, _s8_).copyWithoutChildren$0();
                    grandparent.addChild$1(newParent);
                    _this._async_evaluate0$__parent = newParent;
                }
            },
            _async_evaluate0$_addChild$2$through: function(node, through) {
                var _0_0, grandparent, t1, $parent = this._async_evaluate0$_assertInModule$2(this._async_evaluate0$__parent, "__parent");
                if (through != null) {
                    for(; through.call$1($parent); $parent = _0_0){
                        _0_0 = $parent._node$_parent;
                        if (_0_0 == null) throw A.wrapException(A.ArgumentError$(string$.throug + node.toString$0(0) + ".", null));
                    }
                    if ($parent.get$hasFollowingSibling()) {
                        grandparent = $parent._node$_parent;
                        t1 = grandparent.children;
                        if ($parent.equalsIgnoringChildren$1(t1.get$last(t1))) $parent = type$.ModifiableCssParentNode_2._as(t1.get$last(t1));
                        else {
                            $parent = $parent.copyWithoutChildren$0();
                            grandparent.addChild$1($parent);
                        }
                    }
                }
                $parent.addChild$1(node);
            },
            _async_evaluate0$_addChild$1: function(node) {
                return this._async_evaluate0$_addChild$2$through(node, null);
            },
            _async_evaluate0$_withStyleRule$1$2: function(rule, callback, $T) {
                return this._withStyleRule$body$_EvaluateVisitor0(rule, callback, $T, $T);
            },
            _withStyleRule$body$_EvaluateVisitor0: function(rule, callback, $T, $async$type) {
                var $async$goto = 0, $async$completer = A._makeAsyncAwaitCompleter($async$type), $async$returnValue, $async$self = this, result, oldRule;
                var $async$_async_evaluate0$_withStyleRule$1$2 = A._wrapJsFunctionForAsync(function($async$errorCode, $async$result) {
                    if ($async$errorCode === 1) return A._asyncRethrow($async$result, $async$completer);
                    for(;;)switch($async$goto){
                        case 0:
                            // Function start
                            oldRule = $async$self._async_evaluate0$_styleRuleIgnoringAtRoot;
                            $async$self._async_evaluate0$_styleRuleIgnoringAtRoot = rule;
                            $async$goto = 3;
                            return A._asyncAwait(callback.call$0(), $async$_async_evaluate0$_withStyleRule$1$2);
                        case 3:
                            // returning from await.
                            result = $async$result;
                            $async$self._async_evaluate0$_styleRuleIgnoringAtRoot = oldRule;
                            $async$returnValue = result;
                            // goto return
                            $async$goto = 1;
                            break;
                        case 1:
                            // return
                            return A._asyncReturn($async$returnValue, $async$completer);
                    }
                });
                return A._asyncStartSync($async$_async_evaluate0$_withStyleRule$1$2, $async$completer);
            },
            _async_evaluate0$_withMediaQueries$1$3: function(queries, sources, callback, $T) {
                return this._withMediaQueries$body$_EvaluateVisitor0(queries, sources, callback, $T, $T);
            },
            _withMediaQueries$body$_EvaluateVisitor0: function(queries, sources, callback, $T, $async$type) {
                var $async$goto = 0, $async$completer = A._makeAsyncAwaitCompleter($async$type), $async$returnValue, $async$self = this, result, oldMediaQueries, oldSources;
                var $async$_async_evaluate0$_withMediaQueries$1$3 = A._wrapJsFunctionForAsync(function($async$errorCode, $async$result) {
                    if ($async$errorCode === 1) return A._asyncRethrow($async$result, $async$completer);
                    for(;;)switch($async$goto){
                        case 0:
                            // Function start
                            oldMediaQueries = $async$self._async_evaluate0$_mediaQueries;
                            oldSources = $async$self._async_evaluate0$_mediaQuerySources;
                            $async$self._async_evaluate0$_mediaQueries = queries;
                            $async$self._async_evaluate0$_mediaQuerySources = sources;
                            $async$goto = 3;
                            return A._asyncAwait(callback.call$0(), $async$_async_evaluate0$_withMediaQueries$1$3);
                        case 3:
                            // returning from await.
                            result = $async$result;
                            $async$self._async_evaluate0$_mediaQueries = oldMediaQueries;
                            $async$self._async_evaluate0$_mediaQuerySources = oldSources;
                            $async$returnValue = result;
                            // goto return
                            $async$goto = 1;
                            break;
                        case 1:
                            // return
                            return A._asyncReturn($async$returnValue, $async$completer);
                    }
                });
                return A._asyncStartSync($async$_async_evaluate0$_withMediaQueries$1$3, $async$completer);
            },
            _async_evaluate0$_withStackFrame$1$3: function(member, nodeWithSpan, callback, $T) {
                return this._withStackFrame$body$_EvaluateVisitor0(member, nodeWithSpan, callback, $T, $T);
            },
            _withStackFrame$body$_EvaluateVisitor0: function(member, nodeWithSpan, callback, $T, $async$type) {
                var $async$goto = 0, $async$completer = A._makeAsyncAwaitCompleter($async$type), $async$returnValue, $async$self = this, oldMember, result, t1;
                var $async$_async_evaluate0$_withStackFrame$1$3 = A._wrapJsFunctionForAsync(function($async$errorCode, $async$result) {
                    if ($async$errorCode === 1) return A._asyncRethrow($async$result, $async$completer);
                    for(;;)switch($async$goto){
                        case 0:
                            // Function start
                            t1 = $async$self._async_evaluate0$_stack;
                            t1.push(new A._Record_2($async$self._async_evaluate0$_member, nodeWithSpan));
                            oldMember = $async$self._async_evaluate0$_member;
                            $async$self._async_evaluate0$_member = member;
                            $async$goto = 3;
                            return A._asyncAwait(callback.call$0(), $async$_async_evaluate0$_withStackFrame$1$3);
                        case 3:
                            // returning from await.
                            result = $async$result;
                            $async$self._async_evaluate0$_member = oldMember;
                            t1.pop();
                            $async$returnValue = result;
                            // goto return
                            $async$goto = 1;
                            break;
                        case 1:
                            // return
                            return A._asyncReturn($async$returnValue, $async$completer);
                    }
                });
                return A._asyncStartSync($async$_async_evaluate0$_withStackFrame$1$3, $async$completer);
            },
            _async_evaluate0$_withoutSlash$2: function(value, nodeForSpan) {
                var t1;
                if (value instanceof A.SassNumber0) t1 = value.asSlash != null;
                else t1 = false;
                if (t1) this._async_evaluate0$_warn$3(string$.Using__i + A.S(new A._EvaluateVisitor__withoutSlash_recommendation2().call$1(value)) + string$.x0a_Morex20, nodeForSpan.get$span(nodeForSpan), B.Deprecation_v81);
                return value.withoutSlash$0();
            },
            _async_evaluate0$_stackFrame$2: function(member, span) {
                return A.frameForSpan0(span, member, A.NullableExtension_andThen0(span.get$sourceUrl(span), new A._EvaluateVisitor__stackFrame_closure2(this)));
            },
            _async_evaluate0$_stackTrace$1: function(span) {
                var t2, t3, _i, t4, nodeWithSpan, _this = this, t1 = A._setArrayType([], type$.JSArray_Frame);
                for(t2 = _this._async_evaluate0$_stack, t3 = t2.length, _i = 0; _i < t2.length; t2.length === t3 || (0, A.throwConcurrentModificationError)(t2), ++_i){
                    t4 = t2[_i];
                    nodeWithSpan = t4._1;
                    t1.push(_this._async_evaluate0$_stackFrame$2(t4._0, nodeWithSpan.get$span(nodeWithSpan)));
                }
                if (span != null) t1.push(_this._async_evaluate0$_stackFrame$2(_this._async_evaluate0$_member, span));
                return A.Trace$(new A.ReversedListIterable(t1, type$.ReversedListIterable_Frame), null);
            },
            _async_evaluate0$_stackTrace$0: function() {
                return this._async_evaluate0$_stackTrace$1(null);
            },
            _async_evaluate0$_warn$3: function(message, span, deprecation) {
                var trace, t1, _this = this;
                if (_this._async_evaluate0$_quietDeps && _this._async_evaluate0$_inDependency) return;
                if (!_this._async_evaluate0$_warningsEmitted.add$1(0, new A._Record_2(message, span))) return;
                trace = _this._async_evaluate0$_stackTrace$1(span);
                t1 = _this._async_evaluate0$_logger;
                if (deprecation == null) t1.internalWarn$4$deprecation$span$trace(message, null, span, trace);
                else A.WarnForDeprecation_warnForDeprecation0(t1, deprecation, message, span, trace);
            },
            _async_evaluate0$_warn$2: function(message, span) {
                return this._async_evaluate0$_warn$3(message, span, null);
            },
            _async_evaluate0$_exception$2: function(message, span) {
                var t1, t2;
                if (span == null) {
                    t1 = B.JSArray_methods.get$last(this._async_evaluate0$_stack)._1;
                    t1 = t1.get$span(t1);
                } else t1 = span;
                t2 = this._async_evaluate0$_stackTrace$1(span);
                return new A.SassRuntimeException0(t2, B.Set_empty, message, t1);
            },
            _async_evaluate0$_exception$1: function(message) {
                return this._async_evaluate0$_exception$2(message, null);
            },
            _async_evaluate0$_multiSpanException$3: function(message, primaryLabel, secondaryLabels) {
                var t1 = B.JSArray_methods.get$last(this._async_evaluate0$_stack)._1;
                return A.MultiSpanSassRuntimeException$0(message, t1.get$span(t1), primaryLabel, secondaryLabels, this._async_evaluate0$_stackTrace$0(), null);
            },
            _async_evaluate0$_addExceptionSpan$1$2: function(nodeWithSpan, callback) {
                var error, stackTrace, t1, _$exception, addStackFrame = true;
                try {
                    t1 = callback.call$0();
                    return t1;
                } catch (exception) {
                    t1 = A.unwrapException(exception);
                    if (t1 instanceof A.SassScriptException0) {
                        error = t1;
                        stackTrace = A.getTraceFromException(exception);
                        t1 = error.withSpan$1(nodeWithSpan.get$span(nodeWithSpan));
                        A.throwWithTrace0(t1.withTrace$1(this._async_evaluate0$_stackTrace$1(addStackFrame ? nodeWithSpan.get$span(nodeWithSpan) : null)), error, stackTrace);
                    } else throw exception;
                }
            },
            _async_evaluate0$_addExceptionSpan$2: function(nodeWithSpan, callback) {
                return this._async_evaluate0$_addExceptionSpan$1$2(nodeWithSpan, callback, type$.dynamic);
            },
            _async_evaluate0$_addExceptionSpanAsync$1$3$addStackFrame: function(nodeWithSpan, callback, addStackFrame, $T) {
                return this._addExceptionSpanAsync$body$_EvaluateVisitor0(nodeWithSpan, callback, addStackFrame, $T, $T);
            },
            _async_evaluate0$_addExceptionSpanAsync$1$2: function(nodeWithSpan, callback, $T) {
                return this._async_evaluate0$_addExceptionSpanAsync$1$3$addStackFrame(nodeWithSpan, callback, true, $T);
            },
            _addExceptionSpanAsync$body$_EvaluateVisitor0: function(nodeWithSpan, callback, addStackFrame, $T, $async$type) {
                var $async$goto = 0, $async$completer = A._makeAsyncAwaitCompleter($async$type), $async$returnValue, $async$handler = 2, $async$errorStack = [], $async$self = this, error, stackTrace, t1, exception, $async$exception;
                var $async$_async_evaluate0$_addExceptionSpanAsync$1$3$addStackFrame = A._wrapJsFunctionForAsync(function($async$errorCode, $async$result) {
                    if ($async$errorCode === 1) {
                        $async$errorStack.push($async$result);
                        $async$goto = $async$handler;
                    }
                    for(;;)switch($async$goto){
                        case 0:
                            // Function start
                            $async$handler = 4;
                            t1 = callback.call$0();
                            $async$goto = 7;
                            return A._asyncAwait($T._eval$1("Future<0>")._is(t1) ? t1 : A._Future$value(t1, $T), $async$_async_evaluate0$_addExceptionSpanAsync$1$3$addStackFrame);
                        case 7:
                            // returning from await.
                            t1 = $async$result;
                            $async$returnValue = t1;
                            // goto return
                            $async$goto = 1;
                            break;
                        case 4:
                            // catch
                            $async$handler = 3;
                            $async$exception = $async$errorStack.pop();
                            t1 = A.unwrapException($async$exception);
                            if (t1 instanceof A.SassScriptException0) {
                                error = t1;
                                stackTrace = A.getTraceFromException($async$exception);
                                t1 = error.withSpan$1(nodeWithSpan.get$span(nodeWithSpan));
                                A.throwWithTrace0(t1.withTrace$1($async$self._async_evaluate0$_stackTrace$1(addStackFrame ? nodeWithSpan.get$span(nodeWithSpan) : null)), error, stackTrace);
                            } else throw $async$exception;
                            // goto after finally
                            $async$goto = 6;
                            break;
                        case 3:
                            // uncaught
                            // goto rethrow
                            $async$goto = 2;
                            break;
                        case 6:
                        // after finally
                        case 1:
                            // return
                            return A._asyncReturn($async$returnValue, $async$completer);
                        case 2:
                            // rethrow
                            return A._asyncRethrow($async$errorStack.at(-1), $async$completer);
                    }
                });
                return A._asyncStartSync($async$_async_evaluate0$_addExceptionSpanAsync$1$3$addStackFrame, $async$completer);
            },
            _async_evaluate0$_addExceptionTrace$1$1: function(callback, $T) {
                return this._addExceptionTrace$body$_EvaluateVisitor0(callback, $T, $T);
            },
            _addExceptionTrace$body$_EvaluateVisitor0: function(callback, $T, $async$type) {
                var $async$goto = 0, $async$completer = A._makeAsyncAwaitCompleter($async$type), $async$returnValue, $async$handler = 2, $async$errorStack = [], $async$self = this, error, stackTrace, t1, exception, t2, $async$exception;
                var $async$_async_evaluate0$_addExceptionTrace$1$1 = A._wrapJsFunctionForAsync(function($async$errorCode, $async$result) {
                    if ($async$errorCode === 1) {
                        $async$errorStack.push($async$result);
                        $async$goto = $async$handler;
                    }
                    for(;;)switch($async$goto){
                        case 0:
                            // Function start
                            $async$handler = 4;
                            t1 = callback.call$0();
                            $async$goto = 7;
                            return A._asyncAwait($T._eval$1("Future<0>")._is(t1) ? t1 : A._Future$value(t1, $T), $async$_async_evaluate0$_addExceptionTrace$1$1);
                        case 7:
                            // returning from await.
                            t1 = $async$result;
                            $async$returnValue = t1;
                            // goto return
                            $async$goto = 1;
                            break;
                        case 4:
                            // catch
                            $async$handler = 3;
                            $async$exception = $async$errorStack.pop();
                            t1 = A.unwrapException($async$exception);
                            if (type$.SassRuntimeException_2._is(t1)) throw $async$exception;
                            else if (t1 instanceof A.SassException0) {
                                error = t1;
                                stackTrace = A.getTraceFromException($async$exception);
                                t1 = error;
                                t2 = J.getInterceptor$x(t1);
                                A.throwWithTrace0(error.withTrace$1($async$self._async_evaluate0$_stackTrace$1(A.SourceSpanException.prototype.get$span.call(t2, t1))), error, stackTrace);
                            } else throw $async$exception;
                            // goto after finally
                            $async$goto = 6;
                            break;
                        case 3:
                            // uncaught
                            // goto rethrow
                            $async$goto = 2;
                            break;
                        case 6:
                        // after finally
                        case 1:
                            // return
                            return A._asyncReturn($async$returnValue, $async$completer);
                        case 2:
                            // rethrow
                            return A._asyncRethrow($async$errorStack.at(-1), $async$completer);
                    }
                });
                return A._asyncStartSync($async$_async_evaluate0$_addExceptionTrace$1$1, $async$completer);
            },
            _async_evaluate0$_addErrorSpan$1$2: function(nodeWithSpan, callback, $T) {
                return this._addErrorSpan$body$_EvaluateVisitor0(nodeWithSpan, callback, $T, $T);
            },
            _addErrorSpan$body$_EvaluateVisitor0: function(nodeWithSpan, callback, $T, $async$type) {
                var $async$goto = 0, $async$completer = A._makeAsyncAwaitCompleter($async$type), $async$returnValue, $async$handler = 2, $async$errorStack = [], $async$self = this, error, stackTrace, t1, exception, t2, t3, $async$exception;
                var $async$_async_evaluate0$_addErrorSpan$1$2 = A._wrapJsFunctionForAsync(function($async$errorCode, $async$result) {
                    if ($async$errorCode === 1) {
                        $async$errorStack.push($async$result);
                        $async$goto = $async$handler;
                    }
                    for(;;)switch($async$goto){
                        case 0:
                            // Function start
                            $async$handler = 4;
                            $async$goto = 7;
                            return A._asyncAwait(callback.call$0(), $async$_async_evaluate0$_addErrorSpan$1$2);
                        case 7:
                            // returning from await.
                            t1 = $async$result;
                            $async$returnValue = t1;
                            // goto return
                            $async$goto = 1;
                            break;
                        case 4:
                            // catch
                            $async$handler = 3;
                            $async$exception = $async$errorStack.pop();
                            t1 = A.unwrapException($async$exception);
                            if (type$.SassRuntimeException_2._is(t1)) {
                                error = t1;
                                stackTrace = A.getTraceFromException($async$exception);
                                if (!B.JSString_methods.startsWith$1(J.get$span$x(error).get$text(), "@error")) throw $async$exception;
                                t1 = error._span_exception$_message;
                                t2 = nodeWithSpan.get$span(nodeWithSpan);
                                t3 = $async$self._async_evaluate0$_stackTrace$0();
                                A.throwWithTrace0(new A.SassRuntimeException0(t3, B.Set_empty, t1, t2), error, stackTrace);
                            } else throw $async$exception;
                            // goto after finally
                            $async$goto = 6;
                            break;
                        case 3:
                            // uncaught
                            // goto rethrow
                            $async$goto = 2;
                            break;
                        case 6:
                        // after finally
                        case 1:
                            // return
                            return A._asyncReturn($async$returnValue, $async$completer);
                        case 2:
                            // rethrow
                            return A._asyncRethrow($async$errorStack.at(-1), $async$completer);
                    }
                });
                return A._asyncStartSync($async$_async_evaluate0$_addErrorSpan$1$2, $async$completer);
            },
            _async_evaluate0$_getErrorMessage$1: function(error) {
                var t1, exception;
                if (type$.Error._is(error)) return error.toString$0(0);
                try {
                    t1 = A._asString(J.get$message$x(error));
                    return t1;
                } catch (exception) {
                    t1 = J.toString$0$(error);
                    return t1;
                }
            },
            $isExpressionVisitor: 1,
            $isIfConditionExpressionVisitor: 1,
            $isStatementVisitor: 1
        };
        A._EvaluateVisitor_closure38.prototype = {
            call$1: function($arguments) {
                var module, t2, t1 = J.getInterceptor$asx($arguments), variable = t1.$index($arguments, 0).assertString$1("name");
                t1 = t1.$index($arguments, 1).get$realNull();
                module = t1 == null ? null : t1.assertString$1("module");
                t1 = this.$this._async_evaluate0$_environment;
                t2 = A.stringReplaceAllUnchecked(variable._string0$_text, "_", "-");
                return t1.globalVariableExists$2$namespace(t2, module == null ? null : module._string0$_text) ? B.SassBoolean_true0 : B.SassBoolean_false0;
            },
            $signature: 13
        };
        A._EvaluateVisitor_closure39.prototype = {
            call$1: function($arguments) {
                var variable = J.$index$asx($arguments, 0).assertString$1("name"), t1 = this.$this._async_evaluate0$_environment;
                return t1.getVariable$1(A.stringReplaceAllUnchecked(variable._string0$_text, "_", "-")) != null ? B.SassBoolean_true0 : B.SassBoolean_false0;
            },
            $signature: 13
        };
        A._EvaluateVisitor_closure40.prototype = {
            call$1: function($arguments) {
                var module, t2, t3, t4, t1 = J.getInterceptor$asx($arguments), variable = t1.$index($arguments, 0).assertString$1("name");
                t1 = t1.$index($arguments, 1).get$realNull();
                module = t1 == null ? null : t1.assertString$1("module");
                t1 = this.$this;
                t2 = t1._async_evaluate0$_environment;
                t3 = variable._string0$_text;
                t4 = A.stringReplaceAllUnchecked(t3, "_", "-");
                return t2.getFunction$2$namespace(t4, module == null ? null : module._string0$_text) != null || t1._async_evaluate0$_builtInFunctions.containsKey$1(t3) ? B.SassBoolean_true0 : B.SassBoolean_false0;
            },
            $signature: 13
        };
        A._EvaluateVisitor_closure41.prototype = {
            call$1: function($arguments) {
                var module, t2, t1 = J.getInterceptor$asx($arguments), variable = t1.$index($arguments, 0).assertString$1("name");
                t1 = t1.$index($arguments, 1).get$realNull();
                module = t1 == null ? null : t1.assertString$1("module");
                t1 = this.$this._async_evaluate0$_environment;
                t2 = A.stringReplaceAllUnchecked(variable._string0$_text, "_", "-");
                return t1.getMixin$2$namespace(t2, module == null ? null : module._string0$_text) != null ? B.SassBoolean_true0 : B.SassBoolean_false0;
            },
            $signature: 13
        };
        A._EvaluateVisitor_closure42.prototype = {
            call$1: function($arguments) {
                var t1 = this.$this._async_evaluate0$_environment;
                if (!t1._async_environment0$_inMixin) throw A.wrapException(A.SassScriptException$0(string$.conten, null));
                return t1._async_environment0$_content != null ? B.SassBoolean_true0 : B.SassBoolean_false0;
            },
            $signature: 13
        };
        A._EvaluateVisitor_closure43.prototype = {
            call$1: function($arguments) {
                var t2, t3, t4, t1 = J.$index$asx($arguments, 0).assertString$1("module")._string0$_text, module = this.$this._async_evaluate0$_environment._async_environment0$_modules.$index(0, t1);
                if (module == null) throw A.wrapException('There is no module with namespace "' + t1 + '".');
                t1 = type$.Value_2;
                t2 = A.LinkedHashMap_LinkedHashMap$_empty(t1, t1);
                for(t3 = A.MapExtensions_get_pairs0(module.get$variables(), type$.String, t1), t3 = t3.get$iterator(t3); t3.moveNext$0();){
                    t4 = t3.get$current(t3);
                    t2.$indexSet(0, new A.SassString0(t4._0, true), t4._1);
                }
                return new A.SassMap0(A.ConstantMap_ConstantMap$from(t2, t1, t1));
            },
            $signature: 34
        };
        A._EvaluateVisitor_closure44.prototype = {
            call$1: function($arguments) {
                var t3, t4, t5, t1 = this.$this, t2 = J.$index$asx($arguments, 0).assertString$1("module")._string0$_text, module = t1._async_evaluate0$_environment._async_environment0$_modules.$index(0, t2);
                if (module == null) throw A.wrapException('There is no module with namespace "' + t2 + '".');
                t2 = type$.Value_2;
                t3 = A.LinkedHashMap_LinkedHashMap$_empty(t2, t2);
                for(t4 = A.MapExtensions_get_pairs0(module.get$functions(module), type$.String, type$.AsyncCallable_2), t4 = t4.get$iterator(t4), t1 = t1._async_evaluate0$_compileContext; t4.moveNext$0();){
                    t5 = t4.get$current(t4);
                    t3.$indexSet(0, new A.SassString0(t5._0, true), new A.SassFunction0(t5._1, t1));
                }
                return new A.SassMap0(A.ConstantMap_ConstantMap$from(t3, t2, t2));
            },
            $signature: 34
        };
        A._EvaluateVisitor_closure45.prototype = {
            call$1: function($arguments) {
                var t3, t4, t5, t1 = this.$this, t2 = J.$index$asx($arguments, 0).assertString$1("module")._string0$_text, module = t1._async_evaluate0$_environment._async_environment0$_modules.$index(0, t2);
                if (module == null) throw A.wrapException('There is no module with namespace "' + t2 + '".');
                t2 = type$.Value_2;
                t3 = A.LinkedHashMap_LinkedHashMap$_empty(t2, t2);
                for(t4 = A.MapExtensions_get_pairs0(module.get$mixins(), type$.String, type$.AsyncCallable_2), t4 = t4.get$iterator(t4), t1 = t1._async_evaluate0$_compileContext; t4.moveNext$0();){
                    t5 = t4.get$current(t4);
                    t3.$indexSet(0, new A.SassString0(t5._0, true), new A.SassMixin0(t5._1, t1));
                }
                return new A.SassMap0(A.ConstantMap_ConstantMap$from(t3, t2, t2));
            },
            $signature: 34
        };
        A._EvaluateVisitor_closure46.prototype = {
            call$1: function($arguments) {
                var module, t2, callable, t1 = J.getInterceptor$asx($arguments), $name = t1.$index($arguments, 0).assertString$1("name"), css = t1.$index($arguments, 1).get$isTruthy();
                t1 = t1.$index($arguments, 2).get$realNull();
                module = t1 == null ? null : t1.assertString$1("module");
                if (css) {
                    if (module != null) throw A.wrapException(string$.x24css_a);
                    return new A.SassFunction0(new A.PlainCssCallable0($name._string0$_text), this.$this._async_evaluate0$_compileContext);
                }
                t1 = this.$this;
                t2 = t1._async_evaluate0$_callableNode;
                t2.toString;
                callable = t1._async_evaluate0$_addExceptionSpan$2(t2, new A._EvaluateVisitor__closure14(t1, $name, module));
                if (callable == null) throw A.wrapException("Function not found: " + $name.toString$0(0));
                return new A.SassFunction0(callable, t1._async_evaluate0$_compileContext);
            },
            $signature: 207
        };
        A._EvaluateVisitor__closure14.prototype = {
            call$0: function() {
                var local, normalizedName = A.stringReplaceAllUnchecked(this.name._string0$_text, "_", "-"), t1 = this.module, namespace = t1 == null ? null : t1._string0$_text;
                t1 = this.$this;
                local = t1._async_evaluate0$_environment.getFunction$2$namespace(normalizedName, namespace);
                if (local != null || namespace != null) return local;
                return t1._async_evaluate0$_builtInFunctions.$index(0, normalizedName);
            },
            $signature: 96
        };
        A._EvaluateVisitor_closure47.prototype = {
            call$1: function($arguments) {
                var module, t2, callable, t1 = J.getInterceptor$asx($arguments), $name = t1.$index($arguments, 0).assertString$1("name");
                t1 = t1.$index($arguments, 1).get$realNull();
                module = t1 == null ? null : t1.assertString$1("module");
                t1 = this.$this;
                t2 = t1._async_evaluate0$_callableNode;
                t2.toString;
                callable = t1._async_evaluate0$_addExceptionSpan$2(t2, new A._EvaluateVisitor__closure13(t1, $name, module));
                if (callable == null) throw A.wrapException("Mixin not found: " + $name.toString$0(0));
                return new A.SassMixin0(callable, t1._async_evaluate0$_compileContext);
            },
            $signature: 208
        };
        A._EvaluateVisitor__closure13.prototype = {
            call$0: function() {
                var t1 = this.$this._async_evaluate0$_environment, t2 = A.stringReplaceAllUnchecked(this.name._string0$_text, "_", "-"), t3 = this.module;
                return t1.getMixin$2$namespace(t2, t3 == null ? null : t3._string0$_text);
            },
            $signature: 96
        };
        A._EvaluateVisitor_closure48.prototype = {
            call$1: function($arguments) {
                return this.$call$body$_EvaluateVisitor_closure4($arguments);
            },
            $call$body$_EvaluateVisitor_closure4: function($arguments) {
                var $async$goto = 0, $async$completer = A._makeAsyncAwaitCompleter(type$.Value_2), $async$returnValue, $async$self = this, callableNode, t2, t3, t4, t5, t6, t7, invocation, t1, $function, args;
                var $async$call$1 = A._wrapJsFunctionForAsync(function($async$errorCode, $async$result) {
                    if ($async$errorCode === 1) return A._asyncRethrow($async$result, $async$completer);
                    for(;;)switch($async$goto){
                        case 0:
                            // Function start
                            t1 = J.getInterceptor$asx($arguments);
                            $function = t1.$index($arguments, 0);
                            args = type$.SassArgumentList_2._as(t1.$index($arguments, 1));
                            t1 = $async$self.$this;
                            callableNode = t1._async_evaluate0$_callableNode;
                            t2 = callableNode.get$span(callableNode);
                            t3 = callableNode.get$span(callableNode);
                            args._argument_list$_wereKeywordsAccessed = true;
                            t4 = args._argument_list$_keywords;
                            if (t4.get$isEmpty(t4)) t4 = null;
                            else {
                                t5 = type$.Value_2;
                                t6 = A.LinkedHashMap_LinkedHashMap$_empty(t5, t5);
                                for(args._argument_list$_wereKeywordsAccessed = true, t4 = A.MapExtensions_get_pairs0(t4, type$.String, t5), t4 = t4.get$iterator(t4); t4.moveNext$0();){
                                    t7 = t4.get$current(t4);
                                    t6.$indexSet(0, new A.SassString0(t7._0, false), t7._1);
                                }
                                t4 = new A.ValueExpression0(new A.SassMap0(A.ConstantMap_ConstantMap$from(t6, t5, t5)), callableNode.get$span(callableNode));
                            }
                            invocation = A.ArgumentList$0(B.List_empty24, B.Map_empty14, B.Map_empty5, t2, t4, new A.ValueExpression0(args, t3));
                            $async$goto = $function instanceof A.SassString0 ? 3 : 4;
                            break;
                        case 3:
                            // then
                            A.warnForDeprecation0(string$.Passina + $function.toString$0(0) + "))", B.Deprecation_LIY);
                            callableNode = t1._async_evaluate0$_callableNode;
                            t2 = $function._string0$_text;
                            t3 = callableNode.get$span(callableNode);
                            t1 = t1.visitFunctionExpression$1(0, new A.FunctionExpression0(null, A.stringReplaceAllUnchecked(t2, "_", "-"), t2, invocation, t3));
                            $async$goto = 5;
                            return A._asyncAwait(type$.Future_Value_2._is(t1) ? t1 : A._Future$value(t1, type$.Value_2), $async$call$1);
                        case 5:
                            // returning from await.
                            $async$returnValue = $async$result;
                            // goto return
                            $async$goto = 1;
                            break;
                        case 4:
                            // join
                            t2 = $function.assertFunction$1("function").assertCompileContext$1(t1._async_evaluate0$_compileContext);
                            t3 = t1._async_evaluate0$_callableNode;
                            t3.toString;
                            $async$goto = 6;
                            return A._asyncAwait(t1._async_evaluate0$_runFunctionCallable$3(invocation, t2.callable, t3), $async$call$1);
                        case 6:
                            // returning from await.
                            t3 = $async$result;
                            $async$returnValue = t3;
                            // goto return
                            $async$goto = 1;
                            break;
                        case 1:
                            // return
                            return A._asyncReturn($async$returnValue, $async$completer);
                    }
                });
                return A._asyncStartSync($async$call$1, $async$completer);
            },
            $signature: 92
        };
        A._EvaluateVisitor_closure49.prototype = {
            call$1: function($arguments) {
                return this.$call$body$_EvaluateVisitor_closure3($arguments);
            },
            $call$body$_EvaluateVisitor_closure3: function($arguments) {
                var $async$goto = 0, $async$completer = A._makeAsyncAwaitCompleter(type$.void), $async$self = this, withMap, t2, t3, values, span, configuration, t1, url;
                var $async$call$1 = A._wrapJsFunctionForAsync(function($async$errorCode, $async$result) {
                    if ($async$errorCode === 1) return A._asyncRethrow($async$result, $async$completer);
                    for(;;)switch($async$goto){
                        case 0:
                            // Function start
                            t1 = J.getInterceptor$asx($arguments);
                            url = A.Uri_parse(t1.$index($arguments, 0).assertString$1("url")._string0$_text);
                            t1 = t1.$index($arguments, 1).get$realNull();
                            withMap = t1 == null ? null : t1.assertMap$1("with")._map0$_contents;
                            t1 = $async$self.$this;
                            t2 = t1._async_evaluate0$_callableNode;
                            t2.toString;
                            if (withMap != null) {
                                t3 = {};
                                values = A.LinkedHashMap_LinkedHashMap$_empty(type$.String, type$.ConfiguredValue_2);
                                span = t2.get$span(t2);
                                t3.privateDeprecation = false;
                                withMap.forEach$1(0, new A._EvaluateVisitor__closure11(t3, values, span, t2));
                                configuration = new A.ExplicitConfiguration0(t2, values, null);
                            } else configuration = B.Configuration_Map_empty_null0;
                            t3 = t2.get$span(t2);
                            $async$goto = 2;
                            return A._asyncAwait(t1._async_evaluate0$_loadModule$7$baseUrl$configuration$namesInErrors(url, "load-css()", t2, new A._EvaluateVisitor__closure12(t1), t3.get$sourceUrl(t3), configuration, true), $async$call$1);
                        case 2:
                            // returning from await.
                            t1._async_evaluate0$_assertConfigurationIsEmpty$2$nameInError(configuration, true);
                            // implicit return
                            return A._asyncReturn(null, $async$completer);
                    }
                });
                return A._asyncStartSync($async$call$1, $async$completer);
            },
            $signature: 209
        };
        A._EvaluateVisitor__closure11.prototype = {
            call$2: function(variable, value) {
                var _this = this, t1 = variable.assertString$1("with key"), $name = A.stringReplaceAllUnchecked(t1._string0$_text, "_", "-");
                t1 = _this.values;
                if (t1.containsKey$1($name)) throw A.wrapException("The variable $" + $name + " was configured twice.");
                else if (B.JSString_methods.startsWith$1($name, "-") && !_this._box_0.privateDeprecation) {
                    _this._box_0.privateDeprecation = true;
                    A.warnForDeprecation0("Configuring private variables (such as $" + $name + string$.x29x20is_dT, B.Deprecation_lkJ);
                }
                t1.$indexSet(0, $name, new A.ConfiguredValue0(value, _this.span, _this.callableNode));
            },
            $signature: 117
        };
        A._EvaluateVisitor__closure12.prototype = {
            call$2: function(module, _) {
                var t1 = this.$this;
                return t1._async_evaluate0$_combineCss$2$clone(module, true).accept$1(t1);
            },
            $signature: 331
        };
        A._EvaluateVisitor_closure50.prototype = {
            call$1: function($arguments) {
                return this.$call$body$_EvaluateVisitor_closure2($arguments);
            },
            $call$body$_EvaluateVisitor_closure2: function($arguments) {
                var $async$goto = 0, $async$completer = A._makeAsyncAwaitCompleter(type$.void), $async$self = this, callableNode, invocation, t1, mixin, args;
                var $async$call$1 = A._wrapJsFunctionForAsync(function($async$errorCode, $async$result) {
                    if ($async$errorCode === 1) return A._asyncRethrow($async$result, $async$completer);
                    for(;;)switch($async$goto){
                        case 0:
                            // Function start
                            t1 = J.getInterceptor$asx($arguments);
                            mixin = t1.$index($arguments, 0);
                            args = type$.SassArgumentList_2._as(t1.$index($arguments, 1));
                            t1 = $async$self.$this;
                            callableNode = t1._async_evaluate0$_callableNode;
                            invocation = A.ArgumentList$0(B.List_empty24, B.Map_empty14, B.Map_empty5, callableNode.get$span(callableNode), null, new A.ValueExpression0(args, callableNode.get$span(callableNode)));
                            $async$goto = 2;
                            return A._asyncAwait(t1._async_evaluate0$_applyMixin$5(mixin.assertMixin$1("mixin").assertCompileContext$1(t1._async_evaluate0$_compileContext).callable, t1._async_evaluate0$_environment._async_environment0$_content, invocation, callableNode, callableNode), $async$call$1);
                        case 2:
                            // returning from await.
                            // implicit return
                            return A._asyncReturn(null, $async$completer);
                    }
                });
                return A._asyncStartSync($async$call$1, $async$completer);
            },
            $signature: 209
        };
        A._EvaluateVisitor_run_closure2.prototype = {
            call$0: function() {
                var $async$goto = 0, $async$completer = A._makeAsyncAwaitCompleter(type$.Record_2_Set_Uri_loadedUrls_and_CssStylesheet_stylesheet_2), $async$returnValue, $async$self = this, module, t1, t2, _0_0, url;
                var $async$call$0 = A._wrapJsFunctionForAsync(function($async$errorCode, $async$result) {
                    if ($async$errorCode === 1) return A._asyncRethrow($async$result, $async$completer);
                    for(;;)switch($async$goto){
                        case 0:
                            // Function start
                            t1 = $async$self.node;
                            t2 = t1.span;
                            _0_0 = t2.get$sourceUrl(t2);
                            url = null;
                            if (_0_0 != null) {
                                url = _0_0;
                                t2 = $async$self.$this;
                                t2._async_evaluate0$_activeModules.$indexSet(0, url, null);
                                if (!(t2._async_evaluate0$_nodeImporter != null && J.toString$0$(url) === "stdin")) t2._async_evaluate0$_loadedUrls.add$1(0, url);
                            }
                            t2 = $async$self.$this;
                            $async$goto = 3;
                            return A._asyncAwait(t2._async_evaluate0$_addExceptionTrace$1$1(new A._EvaluateVisitor_run__closure2(t2, $async$self.importer, t1), type$.Module_AsyncCallable_2), $async$call$0);
                        case 3:
                            // returning from await.
                            module = $async$result;
                            $async$returnValue = new A._Record_2_loadedUrls_stylesheet(t2._async_evaluate0$_loadedUrls, t2._async_evaluate0$_combineCss$1(module));
                            // goto return
                            $async$goto = 1;
                            break;
                        case 1:
                            // return
                            return A._asyncReturn($async$returnValue, $async$completer);
                    }
                });
                return A._asyncStartSync($async$call$0, $async$completer);
            },
            $signature: 332
        };
        A._EvaluateVisitor_run__closure2.prototype = {
            call$0: function() {
                return this.$this._async_evaluate0$_execute$2(this.importer, this.node);
            },
            $signature: 333
        };
        A._EvaluateVisitor__loadModule_closure5.prototype = {
            call$0: function() {
                return this.callback.call$2(this._box_0.builtInModule, false);
            },
            $signature: 0
        };
        A._EvaluateVisitor__loadModule_closure6.prototype = {
            call$0: function() {
                return this.$call$body$_EvaluateVisitor__loadModule_closure0();
            },
            $call$body$_EvaluateVisitor__loadModule_closure0: function() {
                var $async$goto = 0, $async$completer = A._makeAsyncAwaitCompleter(type$.Null), $async$handler = 1, $async$errorStack = [], $async$next = [], $async$self = this, canonicalUrl, oldInDependency, isDependency, t4, message, t1, stylesheet, importer, t2, t3, _1_0, $async$temp1;
                var $async$call$0 = A._wrapJsFunctionForAsync(function($async$errorCode, $async$result) {
                    if ($async$errorCode === 1) {
                        $async$errorStack.push($async$result);
                        $async$goto = $async$handler;
                    }
                    for(;;)switch($async$goto){
                        case 0:
                            // Function start
                            t1 = {};
                            stylesheet = null;
                            importer = null;
                            t2 = $async$self.$this;
                            t3 = $async$self.nodeWithSpan;
                            $async$goto = 2;
                            return A._asyncAwait(t2._async_evaluate0$_loadStylesheet$3$baseUrl($async$self.url.toString$0(0), t3.get$span(t3), $async$self.baseUrl), $async$call$0);
                        case 2:
                            // returning from await.
                            _1_0 = $async$result;
                            stylesheet = _1_0._0;
                            importer = _1_0._1;
                            isDependency = _1_0._2;
                            t4 = stylesheet.span;
                            canonicalUrl = t4.get$sourceUrl(t4);
                            if (canonicalUrl != null) {
                                t4 = t2._async_evaluate0$_activeModules;
                                if (t4.containsKey$1(canonicalUrl)) {
                                    message = $async$self.namesInErrors ? "Module loop: " + $.$get$context().prettyUri$1(canonicalUrl) + " is already being loaded." : string$.Modulel;
                                    t1 = A.NullableExtension_andThen0(t4.$index(0, canonicalUrl), new A._EvaluateVisitor__loadModule__closure5(t2, message));
                                    throw A.wrapException(t1 == null ? t2._async_evaluate0$_exception$1(message) : t1);
                                } else t4.$indexSet(0, canonicalUrl, t3);
                            }
                            t4 = t2._async_evaluate0$_modules.containsKey$1(canonicalUrl);
                            oldInDependency = t2._async_evaluate0$_inDependency;
                            t2._async_evaluate0$_inDependency = isDependency;
                            t1.module = null;
                            $async$handler = 3;
                            $async$temp1 = t1;
                            $async$goto = 6;
                            return A._asyncAwait(t2._async_evaluate0$_execute$5$configuration$namesInErrors$nodeWithSpan(importer, stylesheet, $async$self.configuration, $async$self.namesInErrors, t3), $async$call$0);
                        case 6:
                            // returning from await.
                            $async$temp1.module = $async$result;
                            $async$next.push(5);
                            // goto finally
                            $async$goto = 4;
                            break;
                        case 3:
                            // uncaught
                            $async$next = [
                                1
                            ];
                        case 4:
                            // finally
                            $async$handler = 1;
                            t2._async_evaluate0$_activeModules.remove$1(0, canonicalUrl);
                            t2._async_evaluate0$_inDependency = oldInDependency;
                            // goto the next finally handler
                            $async$goto = $async$next.pop();
                            break;
                        case 5:
                            // after finally
                            $async$goto = 7;
                            return A._asyncAwait(t2._async_evaluate0$_addExceptionSpanAsync$1$3$addStackFrame(t3, new A._EvaluateVisitor__loadModule__closure6(t1, $async$self.callback, !t4), false, type$.void), $async$call$0);
                        case 7:
                            // returning from await.
                            // implicit return
                            return A._asyncReturn(null, $async$completer);
                        case 1:
                            // rethrow
                            return A._asyncRethrow($async$errorStack.at(-1), $async$completer);
                    }
                });
                return A._asyncStartSync($async$call$0, $async$completer);
            },
            $signature: 2
        };
        A._EvaluateVisitor__loadModule__closure5.prototype = {
            call$1: function(previousLoad) {
                return this.$this._async_evaluate0$_multiSpanException$3(this.message, "new load", A.LinkedHashMap_LinkedHashMap$_literal([
                    previousLoad.get$span(previousLoad),
                    "original load"
                ], type$.FileSpan, type$.String));
            },
            $signature: 98
        };
        A._EvaluateVisitor__loadModule__closure6.prototype = {
            call$0: function() {
                return this.callback.call$2(this._box_1.module, this.firstLoad);
            },
            $signature: 0
        };
        A._EvaluateVisitor__execute_closure2.prototype = {
            call$0: function() {
                var $async$goto = 0, $async$completer = A._makeAsyncAwaitCompleter(type$.Null), $async$self = this, t3, t4, t5, t6, t1, oldImporter, oldStylesheet, oldRoot, oldPreModuleComments, oldParent, oldEndOfImports, oldOutOfOrderImports, oldExtensionStore, t2, oldStyleRule, oldMediaQueries, oldDeclarationName, oldInUnknownAtRule, oldInKeyframes, oldConfiguration;
                var $async$call$0 = A._wrapJsFunctionForAsync(function($async$errorCode, $async$result) {
                    if ($async$errorCode === 1) return A._asyncRethrow($async$result, $async$completer);
                    for(;;)switch($async$goto){
                        case 0:
                            // Function start
                            t1 = $async$self.$this;
                            oldImporter = t1._async_evaluate0$_importer;
                            oldStylesheet = t1._async_evaluate0$__stylesheet;
                            oldRoot = t1._async_evaluate0$__root;
                            oldPreModuleComments = t1._async_evaluate0$_preModuleComments;
                            oldParent = t1._async_evaluate0$__parent;
                            oldEndOfImports = t1._async_evaluate0$__endOfImports;
                            oldOutOfOrderImports = t1._async_evaluate0$_outOfOrderImports;
                            oldExtensionStore = t1._async_evaluate0$__extensionStore;
                            t2 = t1._async_evaluate0$_atRootExcludingStyleRule;
                            oldStyleRule = t2 ? null : t1._async_evaluate0$_styleRuleIgnoringAtRoot;
                            oldMediaQueries = t1._async_evaluate0$_mediaQueries;
                            oldDeclarationName = t1._async_evaluate0$_declarationName;
                            oldInUnknownAtRule = t1._async_evaluate0$_inUnknownAtRule;
                            oldInKeyframes = t1._async_evaluate0$_inKeyframes;
                            oldConfiguration = t1._async_evaluate0$_configuration;
                            t1._async_evaluate0$_importer = $async$self.importer;
                            t3 = t1._async_evaluate0$__stylesheet = $async$self.stylesheet;
                            t4 = t3.span;
                            t5 = t1._async_evaluate0$__parent = t1._async_evaluate0$__root = A.ModifiableCssStylesheet$0(t4);
                            t1._async_evaluate0$__endOfImports = 0;
                            t1._async_evaluate0$_outOfOrderImports = null;
                            t1._async_evaluate0$__extensionStore = $async$self.extensionStore;
                            t1._async_evaluate0$_declarationName = t1._async_evaluate0$_mediaQueries = t1._async_evaluate0$_styleRuleIgnoringAtRoot = null;
                            t1._async_evaluate0$_inKeyframes = t1._async_evaluate0$_atRootExcludingStyleRule = t1._async_evaluate0$_inUnknownAtRule = false;
                            t6 = $async$self.configuration;
                            if (t6 != null) t1._async_evaluate0$_configuration = t6;
                            $async$goto = 2;
                            return A._asyncAwait(t1.visitStylesheet$1(0, t3), $async$call$0);
                        case 2:
                            // returning from await.
                            t3 = t1._async_evaluate0$_outOfOrderImports == null ? t5 : new A.CssStylesheet0(new A.UnmodifiableListView(t1._async_evaluate0$_addOutOfOrderImports$0(), type$.UnmodifiableListView_CssNode_2), t4);
                            $async$self.css.__late_helper$_value = t3;
                            $async$self.preModuleComments.__late_helper$_value = t1._async_evaluate0$_preModuleComments;
                            t1._async_evaluate0$_importer = oldImporter;
                            t1._async_evaluate0$__stylesheet = oldStylesheet;
                            t1._async_evaluate0$__root = oldRoot;
                            t1._async_evaluate0$_preModuleComments = oldPreModuleComments;
                            t1._async_evaluate0$__parent = oldParent;
                            t1._async_evaluate0$__endOfImports = oldEndOfImports;
                            t1._async_evaluate0$_outOfOrderImports = oldOutOfOrderImports;
                            t1._async_evaluate0$__extensionStore = oldExtensionStore;
                            t1._async_evaluate0$_styleRuleIgnoringAtRoot = oldStyleRule;
                            t1._async_evaluate0$_mediaQueries = oldMediaQueries;
                            t1._async_evaluate0$_declarationName = oldDeclarationName;
                            t1._async_evaluate0$_inUnknownAtRule = oldInUnknownAtRule;
                            t1._async_evaluate0$_atRootExcludingStyleRule = t2;
                            t1._async_evaluate0$_inKeyframes = oldInKeyframes;
                            t1._async_evaluate0$_configuration = oldConfiguration;
                            // implicit return
                            return A._asyncReturn(null, $async$completer);
                    }
                });
                return A._asyncStartSync($async$call$0, $async$completer);
            },
            $signature: 2
        };
        A._EvaluateVisitor__combineCss_closure5.prototype = {
            call$1: function(module) {
                return module.get$transitivelyContainsCss();
            },
            $signature: 118
        };
        A._EvaluateVisitor__combineCss_closure6.prototype = {
            call$1: function(target) {
                return !this.selectors.contains$1(0, target);
            },
            $signature: 15
        };
        A._EvaluateVisitor__combineCss_visitModule2.prototype = {
            call$1: function(module) {
                var t1, t2, t3, t4, _i, upstream, _1_0, statements, index, _this = this;
                if (!_this.seen.add$1(0, module)) return;
                if (_this.clone) module = module.cloneCss$0();
                for(t1 = module.get$upstream(), t2 = t1.length, t3 = _this.css, t4 = _this.imports, _i = 0; _i < t1.length; t1.length === t2 || (0, A.throwConcurrentModificationError)(t1), ++_i){
                    upstream = t1[_i];
                    if (upstream.get$transitivelyContainsCss()) {
                        _1_0 = module.get$preModuleComments().$index(0, upstream);
                        if (_1_0 != null) B.JSArray_methods.addAll$1(t3.length === 0 ? t4 : t3, _1_0);
                        _this.call$1(upstream);
                    }
                }
                _this.sorted.addFirst$1(module);
                t1 = module.get$css(module);
                statements = t1.get$children(t1);
                index = _this.$this._async_evaluate0$_indexAfterImports$1(statements);
                t1 = J.getInterceptor$ax(statements);
                B.JSArray_methods.addAll$1(t4, t1.getRange$2(statements, 0, index));
                B.JSArray_methods.addAll$1(t3, t1.getRange$2(statements, index, t1.get$length(statements)));
            },
            $signature: 335
        };
        A._EvaluateVisitor__extendModules_closure5.prototype = {
            call$1: function(target) {
                return !this.originalSelectors.contains$1(0, target);
            },
            $signature: 15
        };
        A._EvaluateVisitor__extendModules_closure6.prototype = {
            call$0: function() {
                return A._setArrayType([], type$.JSArray_ExtensionStore_2);
            },
            $signature: 211
        };
        A._EvaluateVisitor_visitAtRootRule_closure5.prototype = {
            call$0: function() {
                var $async$goto = 0, $async$completer = A._makeAsyncAwaitCompleter(type$.Null), $async$self = this, t1, t2, t3, _i;
                var $async$call$0 = A._wrapJsFunctionForAsync(function($async$errorCode, $async$result) {
                    if ($async$errorCode === 1) return A._asyncRethrow($async$result, $async$completer);
                    for(;;)switch($async$goto){
                        case 0:
                            // Function start
                            t1 = $async$self.node.children, t2 = t1.length, t3 = $async$self.$this, _i = 0;
                        case 2:
                            // for condition
                            if (!(_i < t2)) {
                                // goto after for
                                $async$goto = 4;
                                break;
                            }
                            $async$goto = 5;
                            return A._asyncAwait(t1[_i].accept$1(t3), $async$call$0);
                        case 5:
                        // returning from await.
                        case 3:
                            // for update
                            ++_i;
                            // goto for condition
                            $async$goto = 2;
                            break;
                        case 4:
                            // after for
                            // implicit return
                            return A._asyncReturn(null, $async$completer);
                    }
                });
                return A._asyncStartSync($async$call$0, $async$completer);
            },
            $signature: 2
        };
        A._EvaluateVisitor_visitAtRootRule_closure6.prototype = {
            call$0: function() {
                var $async$goto = 0, $async$completer = A._makeAsyncAwaitCompleter(type$.void), $async$self = this, t1, t2, t3, _i;
                var $async$call$0 = A._wrapJsFunctionForAsync(function($async$errorCode, $async$result) {
                    if ($async$errorCode === 1) return A._asyncRethrow($async$result, $async$completer);
                    for(;;)switch($async$goto){
                        case 0:
                            // Function start
                            t1 = $async$self.node.children, t2 = t1.length, t3 = $async$self.$this, _i = 0;
                        case 2:
                            // for condition
                            if (!(_i < t2)) {
                                // goto after for
                                $async$goto = 4;
                                break;
                            }
                            $async$goto = 5;
                            return A._asyncAwait(t1[_i].accept$1(t3), $async$call$0);
                        case 5:
                        // returning from await.
                        case 3:
                            // for update
                            ++_i;
                            // goto for condition
                            $async$goto = 2;
                            break;
                        case 4:
                            // after for
                            // implicit return
                            return A._asyncReturn(null, $async$completer);
                    }
                });
                return A._asyncStartSync($async$call$0, $async$completer);
            },
            $signature: 32
        };
        A._EvaluateVisitor__scopeForAtRoot_closure17.prototype = {
            call$1: function(callback) {
                var $async$goto = 0, $async$completer = A._makeAsyncAwaitCompleter(type$.Null), $async$self = this, t1, oldParent;
                var $async$call$1 = A._wrapJsFunctionForAsync(function($async$errorCode, $async$result) {
                    if ($async$errorCode === 1) return A._asyncRethrow($async$result, $async$completer);
                    for(;;)switch($async$goto){
                        case 0:
                            // Function start
                            t1 = $async$self.$this;
                            oldParent = t1._async_evaluate0$_assertInModule$2(t1._async_evaluate0$__parent, "__parent");
                            t1._async_evaluate0$__parent = $async$self.newParent;
                            $async$goto = 2;
                            return A._asyncAwait(t1._async_evaluate0$_environment.scope$1$2$when(callback, $async$self.node.hasDeclarations, type$.void), $async$call$1);
                        case 2:
                            // returning from await.
                            t1._async_evaluate0$__parent = oldParent;
                            // implicit return
                            return A._asyncReturn(null, $async$completer);
                    }
                });
                return A._asyncStartSync($async$call$1, $async$completer);
            },
            $signature: 40
        };
        A._EvaluateVisitor__scopeForAtRoot_closure18.prototype = {
            call$1: function(callback) {
                var $async$goto = 0, $async$completer = A._makeAsyncAwaitCompleter(type$.Null), $async$self = this, t1, oldAtRootExcludingStyleRule;
                var $async$call$1 = A._wrapJsFunctionForAsync(function($async$errorCode, $async$result) {
                    if ($async$errorCode === 1) return A._asyncRethrow($async$result, $async$completer);
                    for(;;)switch($async$goto){
                        case 0:
                            // Function start
                            t1 = $async$self.$this;
                            oldAtRootExcludingStyleRule = t1._async_evaluate0$_atRootExcludingStyleRule;
                            t1._async_evaluate0$_atRootExcludingStyleRule = true;
                            $async$goto = 2;
                            return A._asyncAwait($async$self.innerScope.call$1(callback), $async$call$1);
                        case 2:
                            // returning from await.
                            t1._async_evaluate0$_atRootExcludingStyleRule = oldAtRootExcludingStyleRule;
                            // implicit return
                            return A._asyncReturn(null, $async$completer);
                    }
                });
                return A._asyncStartSync($async$call$1, $async$completer);
            },
            $signature: 40
        };
        A._EvaluateVisitor__scopeForAtRoot_closure19.prototype = {
            call$1: function(callback) {
                return this.$this._async_evaluate0$_withMediaQueries$1$3(null, null, new A._EvaluateVisitor__scopeForAtRoot__closure2(this.innerScope, callback), type$.Null);
            },
            $signature: 40
        };
        A._EvaluateVisitor__scopeForAtRoot__closure2.prototype = {
            call$0: function() {
                return this.innerScope.call$1(this.callback);
            },
            $signature: 2
        };
        A._EvaluateVisitor__scopeForAtRoot_closure20.prototype = {
            call$1: function(callback) {
                var $async$goto = 0, $async$completer = A._makeAsyncAwaitCompleter(type$.Null), $async$self = this, t1, wasInKeyframes;
                var $async$call$1 = A._wrapJsFunctionForAsync(function($async$errorCode, $async$result) {
                    if ($async$errorCode === 1) return A._asyncRethrow($async$result, $async$completer);
                    for(;;)switch($async$goto){
                        case 0:
                            // Function start
                            t1 = $async$self.$this;
                            wasInKeyframes = t1._async_evaluate0$_inKeyframes;
                            t1._async_evaluate0$_inKeyframes = false;
                            $async$goto = 2;
                            return A._asyncAwait($async$self.innerScope.call$1(callback), $async$call$1);
                        case 2:
                            // returning from await.
                            t1._async_evaluate0$_inKeyframes = wasInKeyframes;
                            // implicit return
                            return A._asyncReturn(null, $async$completer);
                    }
                });
                return A._asyncStartSync($async$call$1, $async$completer);
            },
            $signature: 40
        };
        A._EvaluateVisitor__scopeForAtRoot_closure21.prototype = {
            call$1: function($parent) {
                return $parent instanceof A.ModifiableCssAtRule0;
            },
            $signature: 212
        };
        A._EvaluateVisitor__scopeForAtRoot_closure22.prototype = {
            call$1: function(callback) {
                var $async$goto = 0, $async$completer = A._makeAsyncAwaitCompleter(type$.Null), $async$self = this, t1, wasInUnknownAtRule;
                var $async$call$1 = A._wrapJsFunctionForAsync(function($async$errorCode, $async$result) {
                    if ($async$errorCode === 1) return A._asyncRethrow($async$result, $async$completer);
                    for(;;)switch($async$goto){
                        case 0:
                            // Function start
                            t1 = $async$self.$this;
                            wasInUnknownAtRule = t1._async_evaluate0$_inUnknownAtRule;
                            t1._async_evaluate0$_inUnknownAtRule = false;
                            $async$goto = 2;
                            return A._asyncAwait($async$self.innerScope.call$1(callback), $async$call$1);
                        case 2:
                            // returning from await.
                            t1._async_evaluate0$_inUnknownAtRule = wasInUnknownAtRule;
                            // implicit return
                            return A._asyncReturn(null, $async$completer);
                    }
                });
                return A._asyncStartSync($async$call$1, $async$completer);
            },
            $signature: 40
        };
        A._EvaluateVisitor_visitContentRule_closure2.prototype = {
            call$0: function() {
                var $async$goto = 0, $async$completer = A._makeAsyncAwaitCompleter(type$.Null), $async$returnValue, $async$self = this, t1, t2, t3, _i;
                var $async$call$0 = A._wrapJsFunctionForAsync(function($async$errorCode, $async$result) {
                    if ($async$errorCode === 1) return A._asyncRethrow($async$result, $async$completer);
                    for(;;)switch($async$goto){
                        case 0:
                            // Function start
                            t1 = $async$self.content.declaration.children, t2 = t1.length, t3 = $async$self.$this, _i = 0;
                        case 3:
                            // for condition
                            if (!(_i < t2)) {
                                // goto after for
                                $async$goto = 5;
                                break;
                            }
                            $async$goto = 6;
                            return A._asyncAwait(t1[_i].accept$1(t3), $async$call$0);
                        case 6:
                        // returning from await.
                        case 4:
                            // for update
                            ++_i;
                            // goto for condition
                            $async$goto = 3;
                            break;
                        case 5:
                            // after for
                            $async$returnValue = null;
                            // goto return
                            $async$goto = 1;
                            break;
                        case 1:
                            // return
                            return A._asyncReturn($async$returnValue, $async$completer);
                    }
                });
                return A._asyncStartSync($async$call$0, $async$completer);
            },
            $signature: 2
        };
        A._EvaluateVisitor_visitDeclaration_closure2.prototype = {
            call$0: function() {
                var $async$goto = 0, $async$completer = A._makeAsyncAwaitCompleter(type$.Null), $async$self = this, t1, t2, t3, _i;
                var $async$call$0 = A._wrapJsFunctionForAsync(function($async$errorCode, $async$result) {
                    if ($async$errorCode === 1) return A._asyncRethrow($async$result, $async$completer);
                    for(;;)switch($async$goto){
                        case 0:
                            // Function start
                            t1 = $async$self._box_0.children, t2 = t1.length, t3 = $async$self.$this, _i = 0;
                        case 2:
                            // for condition
                            if (!(_i < t2)) {
                                // goto after for
                                $async$goto = 4;
                                break;
                            }
                            $async$goto = 5;
                            return A._asyncAwait(t1[_i].accept$1(t3), $async$call$0);
                        case 5:
                        // returning from await.
                        case 3:
                            // for update
                            ++_i;
                            // goto for condition
                            $async$goto = 2;
                            break;
                        case 4:
                            // after for
                            // implicit return
                            return A._asyncReturn(null, $async$completer);
                    }
                });
                return A._asyncStartSync($async$call$0, $async$completer);
            },
            $signature: 2
        };
        A._EvaluateVisitor_visitEachRule_closure8.prototype = {
            call$1: function(value) {
                var t1 = this.$this, t2 = this.nodeWithSpan;
                return t1._async_evaluate0$_environment.setLocalVariable$3(this._box_0.variable, t1._async_evaluate0$_withoutSlash$2(value, t2), t2);
            },
            $signature: 63
        };
        A._EvaluateVisitor_visitEachRule_closure9.prototype = {
            call$1: function(value) {
                return this.$this._async_evaluate0$_setMultipleVariables$3(this._box_1.variables, value, this.nodeWithSpan);
            },
            $signature: 63
        };
        A._EvaluateVisitor_visitEachRule_closure10.prototype = {
            call$0: function() {
                var _this = this, t1 = _this.$this;
                return t1._async_evaluate0$_handleReturn$2(_this.list.get$asList(), new A._EvaluateVisitor_visitEachRule__closure2(t1, _this.setVariables, _this.node));
            },
            $signature: 78
        };
        A._EvaluateVisitor_visitEachRule__closure2.prototype = {
            call$1: function(element) {
                var t1;
                this.setVariables.call$1(element);
                t1 = this.$this;
                return t1._async_evaluate0$_handleReturn$2(this.node.children, new A._EvaluateVisitor_visitEachRule___closure2(t1));
            },
            $signature: 340
        };
        A._EvaluateVisitor_visitEachRule___closure2.prototype = {
            call$1: function(child) {
                return child.accept$1(this.$this);
            },
            $signature: 101
        };
        A._EvaluateVisitor_visitAtRule_closure11.prototype = {
            call$1: function(value) {
                return this.$this._async_evaluate0$_interpolationToValue$3$trim$warnForColor(value, true, true);
            },
            $signature: 342
        };
        A._EvaluateVisitor_visitAtRule_closure12.prototype = {
            call$0: function() {
                var $async$goto = 0, $async$completer = A._makeAsyncAwaitCompleter(type$.Null), $async$self = this, t1, t2, t3, _i;
                var $async$call$0 = A._wrapJsFunctionForAsync(function($async$errorCode, $async$result) {
                    if ($async$errorCode === 1) return A._asyncRethrow($async$result, $async$completer);
                    for(;;)switch($async$goto){
                        case 0:
                            // Function start
                            t1 = $async$self.children, t2 = t1.length, t3 = $async$self.$this, _i = 0;
                        case 2:
                            // for condition
                            if (!(_i < t2)) {
                                // goto after for
                                $async$goto = 4;
                                break;
                            }
                            $async$goto = 5;
                            return A._asyncAwait(t1[_i].accept$1(t3), $async$call$0);
                        case 5:
                        // returning from await.
                        case 3:
                            // for update
                            ++_i;
                            // goto for condition
                            $async$goto = 2;
                            break;
                        case 4:
                            // after for
                            // implicit return
                            return A._asyncReturn(null, $async$completer);
                    }
                });
                return A._asyncStartSync($async$call$0, $async$completer);
            },
            $signature: 2
        };
        A._EvaluateVisitor_visitAtRule_closure13.prototype = {
            call$0: function() {
                var $async$goto = 0, $async$completer = A._makeAsyncAwaitCompleter(type$.Null), $async$self = this, t2, t3, _i, t1, styleRule;
                var $async$call$0 = A._wrapJsFunctionForAsync(function($async$errorCode, $async$result) {
                    if ($async$errorCode === 1) return A._asyncRethrow($async$result, $async$completer);
                    for(;;)switch($async$goto){
                        case 0:
                            // Function start
                            t1 = $async$self.$this;
                            styleRule = t1._async_evaluate0$_atRootExcludingStyleRule ? null : t1._async_evaluate0$_styleRuleIgnoringAtRoot;
                            $async$goto = styleRule == null || t1._async_evaluate0$_inKeyframes || $async$self.name.value === "font-face" ? 2 : 4;
                            break;
                        case 2:
                            // then
                            t2 = $async$self.children, t3 = t2.length, _i = 0;
                        case 5:
                            // for condition
                            if (!(_i < t3)) {
                                // goto after for
                                $async$goto = 7;
                                break;
                            }
                            $async$goto = 8;
                            return A._asyncAwait(t2[_i].accept$1(t1), $async$call$0);
                        case 8:
                        // returning from await.
                        case 6:
                            // for update
                            ++_i;
                            // goto for condition
                            $async$goto = 5;
                            break;
                        case 7:
                            // after for
                            // goto join
                            $async$goto = 3;
                            break;
                        case 4:
                            // else
                            $async$goto = 9;
                            return A._asyncAwait(t1._async_evaluate0$_withParent$2$3$scopeWhen(A.ModifiableCssStyleRule$0(styleRule._style_rule0$_selector, styleRule.span, false, styleRule.originalSelector), new A._EvaluateVisitor_visitAtRule__closure2(t1, $async$self.children), false, type$.ModifiableCssStyleRule_2, type$.Null), $async$call$0);
                        case 9:
                        // returning from await.
                        case 3:
                            // join
                            // implicit return
                            return A._asyncReturn(null, $async$completer);
                    }
                });
                return A._asyncStartSync($async$call$0, $async$completer);
            },
            $signature: 2
        };
        A._EvaluateVisitor_visitAtRule__closure2.prototype = {
            call$0: function() {
                var $async$goto = 0, $async$completer = A._makeAsyncAwaitCompleter(type$.Null), $async$self = this, t1, t2, t3, _i;
                var $async$call$0 = A._wrapJsFunctionForAsync(function($async$errorCode, $async$result) {
                    if ($async$errorCode === 1) return A._asyncRethrow($async$result, $async$completer);
                    for(;;)switch($async$goto){
                        case 0:
                            // Function start
                            t1 = $async$self.children, t2 = t1.length, t3 = $async$self.$this, _i = 0;
                        case 2:
                            // for condition
                            if (!(_i < t2)) {
                                // goto after for
                                $async$goto = 4;
                                break;
                            }
                            $async$goto = 5;
                            return A._asyncAwait(t1[_i].accept$1(t3), $async$call$0);
                        case 5:
                        // returning from await.
                        case 3:
                            // for update
                            ++_i;
                            // goto for condition
                            $async$goto = 2;
                            break;
                        case 4:
                            // after for
                            // implicit return
                            return A._asyncReturn(null, $async$completer);
                    }
                });
                return A._asyncStartSync($async$call$0, $async$completer);
            },
            $signature: 2
        };
        A._EvaluateVisitor_visitAtRule_closure14.prototype = {
            call$1: function(node) {
                return node instanceof A.ModifiableCssStyleRule0;
            },
            $signature: 8
        };
        A._EvaluateVisitor_visitForRule_closure14.prototype = {
            call$0: function() {
                var $async$goto = 0, $async$completer = A._makeAsyncAwaitCompleter(type$.SassNumber_2), $async$returnValue, $async$self = this;
                var $async$call$0 = A._wrapJsFunctionForAsync(function($async$errorCode, $async$result) {
                    if ($async$errorCode === 1) return A._asyncRethrow($async$result, $async$completer);
                    for(;;)switch($async$goto){
                        case 0:
                            // Function start
                            $async$goto = 3;
                            return A._asyncAwait($async$self.node.from.accept$1($async$self.$this), $async$call$0);
                        case 3:
                            // returning from await.
                            $async$returnValue = $async$result.assertNumber$0();
                            // goto return
                            $async$goto = 1;
                            break;
                        case 1:
                            // return
                            return A._asyncReturn($async$returnValue, $async$completer);
                    }
                });
                return A._asyncStartSync($async$call$0, $async$completer);
            },
            $signature: 214
        };
        A._EvaluateVisitor_visitForRule_closure15.prototype = {
            call$0: function() {
                var $async$goto = 0, $async$completer = A._makeAsyncAwaitCompleter(type$.SassNumber_2), $async$returnValue, $async$self = this;
                var $async$call$0 = A._wrapJsFunctionForAsync(function($async$errorCode, $async$result) {
                    if ($async$errorCode === 1) return A._asyncRethrow($async$result, $async$completer);
                    for(;;)switch($async$goto){
                        case 0:
                            // Function start
                            $async$goto = 3;
                            return A._asyncAwait($async$self.node.to.accept$1($async$self.$this), $async$call$0);
                        case 3:
                            // returning from await.
                            $async$returnValue = $async$result.assertNumber$0();
                            // goto return
                            $async$goto = 1;
                            break;
                        case 1:
                            // return
                            return A._asyncReturn($async$returnValue, $async$completer);
                    }
                });
                return A._asyncStartSync($async$call$0, $async$completer);
            },
            $signature: 214
        };
        A._EvaluateVisitor_visitForRule_closure16.prototype = {
            call$0: function() {
                return this.fromNumber.assertInt$0();
            },
            $signature: 10
        };
        A._EvaluateVisitor_visitForRule_closure17.prototype = {
            call$0: function() {
                var t1 = this.fromNumber;
                return this.toNumber.coerce$2(t1.get$numeratorUnits(t1), t1.get$denominatorUnits(t1)).assertInt$0();
            },
            $signature: 10
        };
        A._EvaluateVisitor_visitForRule_closure18.prototype = {
            call$0: function() {
                var $async$goto = 0, $async$completer = A._makeAsyncAwaitCompleter(type$.nullable_Value_2), $async$returnValue, $async$self = this, i, t3, t4, t5, t6, t7, t8, _0_0, t1, t2, nodeWithSpan;
                var $async$call$0 = A._wrapJsFunctionForAsync(function($async$errorCode, $async$result) {
                    if ($async$errorCode === 1) return A._asyncRethrow($async$result, $async$completer);
                    for(;;)switch($async$goto){
                        case 0:
                            // Function start
                            t1 = $async$self.$this;
                            t2 = $async$self.node;
                            nodeWithSpan = t1._async_evaluate0$_expressionNode$1(t2.from);
                            i = $async$self.from, t3 = $async$self._box_0, t4 = $async$self.direction, t5 = t2.variable, t6 = $async$self.fromNumber, t2 = t2.children;
                        case 3:
                            // for condition
                            if (!(i !== t3.to)) {
                                // goto after for
                                $async$goto = 5;
                                break;
                            }
                            t7 = t1._async_evaluate0$_environment;
                            t8 = t6.get$numeratorUnits(t6);
                            t7.setLocalVariable$3(t5, A.SassNumber_SassNumber$withUnits0(i, t6.get$denominatorUnits(t6), t8), nodeWithSpan);
                            $async$goto = 6;
                            return A._asyncAwait(t1._async_evaluate0$_handleReturn$2(t2, new A._EvaluateVisitor_visitForRule__closure2(t1)), $async$call$0);
                        case 6:
                            // returning from await.
                            _0_0 = $async$result;
                            if (_0_0 != null) {
                                $async$returnValue = _0_0;
                                // goto return
                                $async$goto = 1;
                                break;
                            }
                        case 4:
                            // for update
                            i += t4;
                            // goto for condition
                            $async$goto = 3;
                            break;
                        case 5:
                            // after for
                            $async$returnValue = null;
                            // goto return
                            $async$goto = 1;
                            break;
                        case 1:
                            // return
                            return A._asyncReturn($async$returnValue, $async$completer);
                    }
                });
                return A._asyncStartSync($async$call$0, $async$completer);
            },
            $signature: 78
        };
        A._EvaluateVisitor_visitForRule__closure2.prototype = {
            call$1: function(child) {
                return child.accept$1(this.$this);
            },
            $signature: 101
        };
        A._EvaluateVisitor_visitForwardRule_closure5.prototype = {
            call$2: function(module, firstLoad) {
                if (firstLoad) this.$this._async_evaluate0$_registerCommentsForModule$1(module);
                this.$this._async_evaluate0$_environment.forwardModule$2(module, this.node);
            },
            $signature: 121
        };
        A._EvaluateVisitor_visitForwardRule_closure6.prototype = {
            call$2: function(module, firstLoad) {
                if (firstLoad) this.$this._async_evaluate0$_registerCommentsForModule$1(module);
                this.$this._async_evaluate0$_environment.forwardModule$2(module, this.node);
            },
            $signature: 121
        };
        A._EvaluateVisitor__registerCommentsForModule_closure2.prototype = {
            call$0: function() {
                return A._setArrayType([], type$.JSArray_CssComment_2);
            },
            $signature: 215
        };
        A._EvaluateVisitor_visitIfRule_closure2.prototype = {
            call$1: function(clause) {
                var t1 = this.$this;
                return t1._async_evaluate0$_environment.scope$1$3$semiGlobal$when(new A._EvaluateVisitor_visitIfRule__closure2(t1, clause), true, clause.hasDeclarations, type$.nullable_Value_2);
            },
            $signature: 347
        };
        A._EvaluateVisitor_visitIfRule__closure2.prototype = {
            call$0: function() {
                var t1 = this.$this;
                return t1._async_evaluate0$_handleReturn$2(this.clause.children, new A._EvaluateVisitor_visitIfRule___closure2(t1));
            },
            $signature: 78
        };
        A._EvaluateVisitor_visitIfRule___closure2.prototype = {
            call$1: function(child) {
                return child.accept$1(this.$this);
            },
            $signature: 101
        };
        A._EvaluateVisitor__visitDynamicImport_closure2.prototype = {
            call$0: function() {
                return this.$call$body$_EvaluateVisitor__visitDynamicImport_closure0();
            },
            $call$body$_EvaluateVisitor__visitDynamicImport_closure0: function() {
                var $async$goto = 0, $async$completer = A._makeAsyncAwaitCompleter(type$.void), $async$returnValue, $async$self = this, t1, t2, _0_0, stylesheet, importer, isDependency, t3, url, oldImporter, oldStylesheet, oldInDependency, loadsUserDefinedModules, children, t4, t5, t6, t7, t8, t9, t10, t11, environment, module, visitor, _box_0;
                var $async$call$0 = A._wrapJsFunctionForAsync(function($async$errorCode, $async$result) {
                    if ($async$errorCode === 1) return A._asyncRethrow($async$result, $async$completer);
                    for(;;)switch($async$goto){
                        case 0:
                            // Function start
                            _box_0 = {};
                            _box_0.isDependency = _box_0.importer = _box_0.stylesheet = null;
                            t1 = $async$self.$this;
                            t2 = $async$self.$import;
                            $async$goto = 3;
                            return A._asyncAwait(t1._async_evaluate0$_loadStylesheet$3$forImport(t2.urlString, t2.span, true), $async$call$0);
                        case 3:
                            // returning from await.
                            _0_0 = $async$result;
                            stylesheet = _box_0.stylesheet = _0_0._0;
                            importer = _0_0._1;
                            _box_0.importer = importer;
                            isDependency = _0_0._2;
                            _box_0.isDependency = isDependency;
                            t3 = stylesheet.span;
                            url = t3.get$sourceUrl(t3);
                            if (url != null) {
                                t3 = t1._async_evaluate0$_activeModules;
                                if (t3.containsKey$1(url)) {
                                    t2 = A.NullableExtension_andThen0(t3.$index(0, url), new A._EvaluateVisitor__visitDynamicImport__closure11(t1));
                                    throw A.wrapException(t2 == null ? t1._async_evaluate0$_exception$1("This file is already being loaded.") : t2);
                                }
                                t3.$indexSet(0, url, t2);
                            }
                            t2 = stylesheet._stylesheet1$_uses;
                            t3 = type$.UnmodifiableListView_UseRule_2;
                            $async$goto = new A.UnmodifiableListView(t2, t3).get$length(0) === 0 && new A.UnmodifiableListView(stylesheet._stylesheet1$_forwards, type$.UnmodifiableListView_ForwardRule_2).get$length(0) === 0 ? 4 : 5;
                            break;
                        case 4:
                            // then
                            oldImporter = t1._async_evaluate0$_importer;
                            oldStylesheet = t1._async_evaluate0$_assertInModule$2(t1._async_evaluate0$__stylesheet, "_stylesheet");
                            oldInDependency = t1._async_evaluate0$_inDependency;
                            t1._async_evaluate0$_importer = importer;
                            t1._async_evaluate0$__stylesheet = stylesheet;
                            t1._async_evaluate0$_inDependency = isDependency;
                            $async$goto = 6;
                            return A._asyncAwait(t1.visitStylesheet$1(0, stylesheet), $async$call$0);
                        case 6:
                            // returning from await.
                            t1._async_evaluate0$_importer = oldImporter;
                            t1._async_evaluate0$__stylesheet = oldStylesheet;
                            t1._async_evaluate0$_inDependency = oldInDependency;
                            t1._async_evaluate0$_activeModules.remove$1(0, url);
                            // goto return
                            $async$goto = 1;
                            break;
                        case 5:
                            // join
                            t2 = new A.UnmodifiableListView(t2, t3);
                            if (!t2.any$1(t2, new A._EvaluateVisitor__visitDynamicImport__closure12())) {
                                t2 = new A.UnmodifiableListView(stylesheet._stylesheet1$_forwards, type$.UnmodifiableListView_ForwardRule_2);
                                loadsUserDefinedModules = t2.any$1(t2, new A._EvaluateVisitor__visitDynamicImport__closure13());
                            } else loadsUserDefinedModules = true;
                            children = A._Cell$();
                            t2 = t1._async_evaluate0$_environment;
                            t3 = type$.String;
                            t4 = type$.Module_AsyncCallable_2;
                            t5 = type$.AstNode_2;
                            t6 = t2._async_environment0$_nestedForwardedModules;
                            t7 = A._setArrayType([], type$.JSArray_Module_AsyncCallable_2);
                            t8 = t2._async_environment0$_variables;
                            t8 = A._setArrayType(t8.slice(0), A._arrayInstanceType(t8));
                            t9 = t2._async_environment0$_variableNodes;
                            t9 = A._setArrayType(t9.slice(0), A._arrayInstanceType(t9));
                            t10 = t2._async_environment0$_functions;
                            t10 = A._setArrayType(t10.slice(0), A._arrayInstanceType(t10));
                            t11 = t2._async_environment0$_mixins;
                            t11 = A._setArrayType(t11.slice(0), A._arrayInstanceType(t11));
                            environment = A.AsyncEnvironment$_0(A.LinkedHashMap_LinkedHashMap$_empty(t3, t4), A.LinkedHashMap_LinkedHashMap$_empty(t3, t5), A.LinkedHashMap_LinkedHashMap$_empty(t4, t5), t2._async_environment0$_importedModules, null, t6, t7, t8, t9, t10, t11, t2._async_environment0$_content, t2._async_environment0$_configurableVariables);
                            $async$goto = 7;
                            return A._asyncAwait(t1._async_evaluate0$_withEnvironment$1$2(environment, new A._EvaluateVisitor__visitDynamicImport__closure14(_box_0, t1, loadsUserDefinedModules, environment, children), type$.Null), $async$call$0);
                        case 7:
                            // returning from await.
                            module = environment.toDummyModule$0();
                            t1._async_evaluate0$_environment.importForwards$1(module);
                            $async$goto = loadsUserDefinedModules ? 8 : 9;
                            break;
                        case 8:
                            // then
                            $async$goto = module.transitivelyContainsCss ? 10 : 11;
                            break;
                        case 10:
                            // then
                            $async$goto = 12;
                            return A._asyncAwait(t1._async_evaluate0$_combineCss$2$clone(module, module.transitivelyContainsExtensions).accept$1(t1), $async$call$0);
                        case 12:
                        // returning from await.
                        case 11:
                            // join
                            visitor = new A._ImportedCssVisitor2(t1);
                            for(t2 = J.get$iterator$ax(children._readLocal$0()); t2.moveNext$0();)t2.get$current(t2).accept$1(visitor);
                        case 9:
                            // join
                            t1._async_evaluate0$_activeModules.remove$1(0, url);
                        case 1:
                            // return
                            return A._asyncReturn($async$returnValue, $async$completer);
                    }
                });
                return A._asyncStartSync($async$call$0, $async$completer);
            },
            $signature: 32
        };
        A._EvaluateVisitor__visitDynamicImport__closure11.prototype = {
            call$1: function(previousLoad) {
                return this.$this._async_evaluate0$_multiSpanException$3("This file is already being loaded.", "new load", A.LinkedHashMap_LinkedHashMap$_literal([
                    previousLoad.get$span(previousLoad),
                    "original load"
                ], type$.FileSpan, type$.String));
            },
            $signature: 98
        };
        A._EvaluateVisitor__visitDynamicImport__closure12.prototype = {
            call$1: function(rule) {
                return rule.url.get$scheme() !== "sass";
            },
            $signature: 142
        };
        A._EvaluateVisitor__visitDynamicImport__closure13.prototype = {
            call$1: function(rule) {
                return rule.url.get$scheme() !== "sass";
            },
            $signature: 216
        };
        A._EvaluateVisitor__visitDynamicImport__closure14.prototype = {
            call$0: function() {
                var $async$goto = 0, $async$completer = A._makeAsyncAwaitCompleter(type$.Null), $async$self = this, t3, t4, t1, oldImporter, oldStylesheet, oldRoot, oldParent, oldEndOfImports, oldOutOfOrderImports, oldConfiguration, oldInDependency, t2;
                var $async$call$0 = A._wrapJsFunctionForAsync(function($async$errorCode, $async$result) {
                    if ($async$errorCode === 1) return A._asyncRethrow($async$result, $async$completer);
                    for(;;)switch($async$goto){
                        case 0:
                            // Function start
                            t1 = $async$self.$this;
                            oldImporter = t1._async_evaluate0$_importer;
                            oldStylesheet = t1._async_evaluate0$_assertInModule$2(t1._async_evaluate0$__stylesheet, "_stylesheet");
                            oldRoot = t1._async_evaluate0$_assertInModule$2(t1._async_evaluate0$__root, "_root");
                            oldParent = t1._async_evaluate0$_assertInModule$2(t1._async_evaluate0$__parent, "__parent");
                            oldEndOfImports = t1._async_evaluate0$_assertInModule$2(t1._async_evaluate0$__endOfImports, "_endOfImports");
                            oldOutOfOrderImports = t1._async_evaluate0$_outOfOrderImports;
                            oldConfiguration = t1._async_evaluate0$_configuration;
                            oldInDependency = t1._async_evaluate0$_inDependency;
                            t2 = $async$self._box_0;
                            t1._async_evaluate0$_importer = t2.importer;
                            t3 = t2.stylesheet;
                            t1._async_evaluate0$__stylesheet = t3;
                            t4 = $async$self.loadsUserDefinedModules;
                            if (t4) {
                                t3 = A.ModifiableCssStylesheet$0(t3.span);
                                t1._async_evaluate0$__root = t3;
                                t1._async_evaluate0$__parent = t1._async_evaluate0$_assertInModule$2(t3, "_root");
                                t1._async_evaluate0$__endOfImports = 0;
                                t1._async_evaluate0$_outOfOrderImports = null;
                            }
                            t1._async_evaluate0$_inDependency = t2.isDependency;
                            t3 = new A.UnmodifiableListView(t2.stylesheet._stylesheet1$_forwards, type$.UnmodifiableListView_ForwardRule_2);
                            if (!t3.get$isEmpty(t3)) t1._async_evaluate0$_configuration = $async$self.environment.toImplicitConfiguration$0();
                            $async$goto = 2;
                            return A._asyncAwait(t1.visitStylesheet$1(0, t2.stylesheet), $async$call$0);
                        case 2:
                            // returning from await.
                            t2 = t4 ? t1._async_evaluate0$_addOutOfOrderImports$0() : A._setArrayType([], type$.JSArray_ModifiableCssNode_2);
                            $async$self.children.__late_helper$_value = t2;
                            t1._async_evaluate0$_importer = oldImporter;
                            t1._async_evaluate0$__stylesheet = oldStylesheet;
                            if (t4) {
                                t1._async_evaluate0$__root = oldRoot;
                                t1._async_evaluate0$__parent = oldParent;
                                t1._async_evaluate0$__endOfImports = oldEndOfImports;
                                t1._async_evaluate0$_outOfOrderImports = oldOutOfOrderImports;
                            }
                            t1._async_evaluate0$_configuration = oldConfiguration;
                            t1._async_evaluate0$_inDependency = oldInDependency;
                            // implicit return
                            return A._asyncReturn(null, $async$completer);
                    }
                });
                return A._asyncStartSync($async$call$0, $async$completer);
            },
            $signature: 2
        };
        A._EvaluateVisitor__applyMixin_closure5.prototype = {
            call$0: function() {
                var $async$goto = 0, $async$completer = A._makeAsyncAwaitCompleter(type$.void), $async$self = this, t1;
                var $async$call$0 = A._wrapJsFunctionForAsync(function($async$errorCode, $async$result) {
                    if ($async$errorCode === 1) return A._asyncRethrow($async$result, $async$completer);
                    for(;;)switch($async$goto){
                        case 0:
                            // Function start
                            t1 = $async$self.$this;
                            $async$goto = 2;
                            return A._asyncAwait(t1._async_evaluate0$_environment.asMixin$1(new A._EvaluateVisitor__applyMixin__closure6(t1, $async$self.$arguments, $async$self.mixin, $async$self.nodeWithSpanWithoutContent)), $async$call$0);
                        case 2:
                            // returning from await.
                            // implicit return
                            return A._asyncReturn(null, $async$completer);
                    }
                });
                return A._asyncStartSync($async$call$0, $async$completer);
            },
            $signature: 32
        };
        A._EvaluateVisitor__applyMixin__closure6.prototype = {
            call$0: function() {
                var $async$goto = 0, $async$completer = A._makeAsyncAwaitCompleter(type$.void), $async$self = this;
                var $async$call$0 = A._wrapJsFunctionForAsync(function($async$errorCode, $async$result) {
                    if ($async$errorCode === 1) return A._asyncRethrow($async$result, $async$completer);
                    for(;;)switch($async$goto){
                        case 0:
                            // Function start
                            $async$goto = 2;
                            return A._asyncAwait($async$self.$this._async_evaluate0$_runBuiltInCallable$3($async$self.$arguments, $async$self.mixin, $async$self.nodeWithSpanWithoutContent), $async$call$0);
                        case 2:
                            // returning from await.
                            // implicit return
                            return A._asyncReturn(null, $async$completer);
                    }
                });
                return A._asyncStartSync($async$call$0, $async$completer);
            },
            $signature: 32
        };
        A._EvaluateVisitor__applyMixin_closure6.prototype = {
            call$0: function() {
                var $async$goto = 0, $async$completer = A._makeAsyncAwaitCompleter(type$.Null), $async$self = this, t1;
                var $async$call$0 = A._wrapJsFunctionForAsync(function($async$errorCode, $async$result) {
                    if ($async$errorCode === 1) return A._asyncRethrow($async$result, $async$completer);
                    for(;;)switch($async$goto){
                        case 0:
                            // Function start
                            t1 = $async$self.$this;
                            $async$goto = 2;
                            return A._asyncAwait(t1._async_evaluate0$_environment.withContent$2($async$self.contentCallable, new A._EvaluateVisitor__applyMixin__closure5(t1, $async$self.mixin, $async$self.nodeWithSpanWithoutContent)), $async$call$0);
                        case 2:
                            // returning from await.
                            // implicit return
                            return A._asyncReturn(null, $async$completer);
                    }
                });
                return A._asyncStartSync($async$call$0, $async$completer);
            },
            $signature: 2
        };
        A._EvaluateVisitor__applyMixin__closure5.prototype = {
            call$0: function() {
                var $async$goto = 0, $async$completer = A._makeAsyncAwaitCompleter(type$.void), $async$self = this, t1;
                var $async$call$0 = A._wrapJsFunctionForAsync(function($async$errorCode, $async$result) {
                    if ($async$errorCode === 1) return A._asyncRethrow($async$result, $async$completer);
                    for(;;)switch($async$goto){
                        case 0:
                            // Function start
                            t1 = $async$self.$this;
                            $async$goto = 2;
                            return A._asyncAwait(t1._async_evaluate0$_environment.asMixin$1(new A._EvaluateVisitor__applyMixin___closure2(t1, $async$self.mixin, $async$self.nodeWithSpanWithoutContent)), $async$call$0);
                        case 2:
                            // returning from await.
                            // implicit return
                            return A._asyncReturn(null, $async$completer);
                    }
                });
                return A._asyncStartSync($async$call$0, $async$completer);
            },
            $signature: 32
        };
        A._EvaluateVisitor__applyMixin___closure2.prototype = {
            call$0: function() {
                var $async$goto = 0, $async$completer = A._makeAsyncAwaitCompleter(type$.void), $async$self = this, t1, t2, t3, t4, t5, _i;
                var $async$call$0 = A._wrapJsFunctionForAsync(function($async$errorCode, $async$result) {
                    if ($async$errorCode === 1) return A._asyncRethrow($async$result, $async$completer);
                    for(;;)switch($async$goto){
                        case 0:
                            // Function start
                            t1 = $async$self.mixin.declaration.children, t2 = t1.length, t3 = $async$self.$this, t4 = $async$self.nodeWithSpanWithoutContent, t5 = type$.nullable_Value_2, _i = 0;
                        case 2:
                            // for condition
                            if (!(_i < t2)) {
                                // goto after for
                                $async$goto = 4;
                                break;
                            }
                            $async$goto = 5;
                            return A._asyncAwait(t3._async_evaluate0$_addErrorSpan$1$2(t4, new A._EvaluateVisitor__applyMixin____closure2(t3, t1[_i]), t5), $async$call$0);
                        case 5:
                        // returning from await.
                        case 3:
                            // for update
                            ++_i;
                            // goto for condition
                            $async$goto = 2;
                            break;
                        case 4:
                            // after for
                            // implicit return
                            return A._asyncReturn(null, $async$completer);
                    }
                });
                return A._asyncStartSync($async$call$0, $async$completer);
            },
            $signature: 32
        };
        A._EvaluateVisitor__applyMixin____closure2.prototype = {
            call$0: function() {
                return this.statement.accept$1(this.$this);
            },
            $signature: 78
        };
        A._EvaluateVisitor_visitIncludeRule_closure8.prototype = {
            call$0: function() {
                var t1 = this.node;
                return this.$this._async_evaluate0$_environment.getMixin$2$namespace(t1.name, t1.namespace);
            },
            $signature: 96
        };
        A._EvaluateVisitor_visitIncludeRule_closure9.prototype = {
            call$1: function($content) {
                var t1 = this.$this;
                return new A.UserDefinedCallable0($content, t1._async_evaluate0$_environment.closure$0(), t1._async_evaluate0$_inDependency, type$.UserDefinedCallable_AsyncEnvironment_2);
            },
            $signature: 350
        };
        A._EvaluateVisitor_visitIncludeRule_closure10.prototype = {
            call$0: function() {
                return this.node.get$spanWithoutContent();
            },
            $signature: 16
        };
        A._EvaluateVisitor_visitMediaRule_closure11.prototype = {
            call$0: function() {
                var $async$goto = 0, $async$completer = A._makeAsyncAwaitCompleter(type$.Null), $async$self = this, t1, t2, t3, _i;
                var $async$call$0 = A._wrapJsFunctionForAsync(function($async$errorCode, $async$result) {
                    if ($async$errorCode === 1) return A._asyncRethrow($async$result, $async$completer);
                    for(;;)switch($async$goto){
                        case 0:
                            // Function start
                            t1 = $async$self.node.children, t2 = t1.length, t3 = $async$self.$this, _i = 0;
                        case 2:
                            // for condition
                            if (!(_i < t2)) {
                                // goto after for
                                $async$goto = 4;
                                break;
                            }
                            $async$goto = 5;
                            return A._asyncAwait(t1[_i].accept$1(t3), $async$call$0);
                        case 5:
                        // returning from await.
                        case 3:
                            // for update
                            ++_i;
                            // goto for condition
                            $async$goto = 2;
                            break;
                        case 4:
                            // after for
                            // implicit return
                            return A._asyncReturn(null, $async$completer);
                    }
                });
                return A._asyncStartSync($async$call$0, $async$completer);
            },
            $signature: 2
        };
        A._EvaluateVisitor_visitMediaRule_closure12.prototype = {
            call$1: function(mediaQueries) {
                return this.$this._async_evaluate0$_mergeMediaQueries$2(mediaQueries, this.queries);
            },
            $signature: 104
        };
        A._EvaluateVisitor_visitMediaRule_closure13.prototype = {
            call$0: function() {
                var $async$goto = 0, $async$completer = A._makeAsyncAwaitCompleter(type$.Null), $async$self = this, t1, t2;
                var $async$call$0 = A._wrapJsFunctionForAsync(function($async$errorCode, $async$result) {
                    if ($async$errorCode === 1) return A._asyncRethrow($async$result, $async$completer);
                    for(;;)switch($async$goto){
                        case 0:
                            // Function start
                            t1 = $async$self.$this;
                            t2 = $async$self.mergedQueries;
                            if (t2 == null) t2 = $async$self.queries;
                            $async$goto = 2;
                            return A._asyncAwait(t1._async_evaluate0$_withMediaQueries$1$3(t2, $async$self.mergedSources, new A._EvaluateVisitor_visitMediaRule__closure2(t1, $async$self.node), type$.Null), $async$call$0);
                        case 2:
                            // returning from await.
                            // implicit return
                            return A._asyncReturn(null, $async$completer);
                    }
                });
                return A._asyncStartSync($async$call$0, $async$completer);
            },
            $signature: 2
        };
        A._EvaluateVisitor_visitMediaRule__closure2.prototype = {
            call$0: function() {
                var $async$goto = 0, $async$completer = A._makeAsyncAwaitCompleter(type$.Null), $async$self = this, t2, t3, _i, t1, _0_0;
                var $async$call$0 = A._wrapJsFunctionForAsync(function($async$errorCode, $async$result) {
                    if ($async$errorCode === 1) return A._asyncRethrow($async$result, $async$completer);
                    for(;;)switch($async$goto){
                        case 0:
                            // Function start
                            t1 = $async$self.$this;
                            _0_0 = t1._async_evaluate0$_atRootExcludingStyleRule ? null : t1._async_evaluate0$_styleRuleIgnoringAtRoot;
                            $async$goto = _0_0 != null ? 2 : 4;
                            break;
                        case 2:
                            // then
                            $async$goto = 5;
                            return A._asyncAwait(t1._async_evaluate0$_withParent$2$3$scopeWhen(A.ModifiableCssStyleRule$0(_0_0._style_rule0$_selector, _0_0.span, false, _0_0.originalSelector), new A._EvaluateVisitor_visitMediaRule___closure2(t1, $async$self.node), false, type$.ModifiableCssStyleRule_2, type$.Null), $async$call$0);
                        case 5:
                            // returning from await.
                            // goto join
                            $async$goto = 3;
                            break;
                        case 4:
                            // else
                            t2 = $async$self.node.children, t3 = t2.length, _i = 0;
                        case 6:
                            // for condition
                            if (!(_i < t3)) {
                                // goto after for
                                $async$goto = 8;
                                break;
                            }
                            $async$goto = 9;
                            return A._asyncAwait(t2[_i].accept$1(t1), $async$call$0);
                        case 9:
                        // returning from await.
                        case 7:
                            // for update
                            ++_i;
                            // goto for condition
                            $async$goto = 6;
                            break;
                        case 8:
                        // after for
                        case 3:
                            // join
                            // implicit return
                            return A._asyncReturn(null, $async$completer);
                    }
                });
                return A._asyncStartSync($async$call$0, $async$completer);
            },
            $signature: 2
        };
        A._EvaluateVisitor_visitMediaRule___closure2.prototype = {
            call$0: function() {
                var $async$goto = 0, $async$completer = A._makeAsyncAwaitCompleter(type$.Null), $async$self = this, t1, t2, t3, _i;
                var $async$call$0 = A._wrapJsFunctionForAsync(function($async$errorCode, $async$result) {
                    if ($async$errorCode === 1) return A._asyncRethrow($async$result, $async$completer);
                    for(;;)switch($async$goto){
                        case 0:
                            // Function start
                            t1 = $async$self.node.children, t2 = t1.length, t3 = $async$self.$this, _i = 0;
                        case 2:
                            // for condition
                            if (!(_i < t2)) {
                                // goto after for
                                $async$goto = 4;
                                break;
                            }
                            $async$goto = 5;
                            return A._asyncAwait(t1[_i].accept$1(t3), $async$call$0);
                        case 5:
                        // returning from await.
                        case 3:
                            // for update
                            ++_i;
                            // goto for condition
                            $async$goto = 2;
                            break;
                        case 4:
                            // after for
                            // implicit return
                            return A._asyncReturn(null, $async$completer);
                    }
                });
                return A._asyncStartSync($async$call$0, $async$completer);
            },
            $signature: 2
        };
        A._EvaluateVisitor_visitMediaRule_closure14.prototype = {
            call$1: function(node) {
                var t1;
                if (!(node instanceof A.ModifiableCssStyleRule0)) {
                    t1 = this.mergedSources;
                    t1 = t1.get$isNotEmpty(t1) && node instanceof A.ModifiableCssMediaRule0 && B.JSArray_methods.every$1(node.queries, t1.get$contains(t1));
                } else t1 = true;
                return t1;
            },
            $signature: 8
        };
        A._EvaluateVisitor_visitStyleRule_closure11.prototype = {
            call$0: function() {
                var $async$goto = 0, $async$completer = A._makeAsyncAwaitCompleter(type$.Null), $async$self = this, t1, t2, t3, _i;
                var $async$call$0 = A._wrapJsFunctionForAsync(function($async$errorCode, $async$result) {
                    if ($async$errorCode === 1) return A._asyncRethrow($async$result, $async$completer);
                    for(;;)switch($async$goto){
                        case 0:
                            // Function start
                            t1 = $async$self.node.children, t2 = t1.length, t3 = $async$self.$this, _i = 0;
                        case 2:
                            // for condition
                            if (!(_i < t2)) {
                                // goto after for
                                $async$goto = 4;
                                break;
                            }
                            $async$goto = 5;
                            return A._asyncAwait(t1[_i].accept$1(t3), $async$call$0);
                        case 5:
                        // returning from await.
                        case 3:
                            // for update
                            ++_i;
                            // goto for condition
                            $async$goto = 2;
                            break;
                        case 4:
                            // after for
                            // implicit return
                            return A._asyncReturn(null, $async$completer);
                    }
                });
                return A._asyncStartSync($async$call$0, $async$completer);
            },
            $signature: 2
        };
        A._EvaluateVisitor_visitStyleRule_closure12.prototype = {
            call$1: function(node) {
                return node instanceof A.ModifiableCssStyleRule0;
            },
            $signature: 8
        };
        A._EvaluateVisitor_visitStyleRule_closure14.prototype = {
            call$0: function() {
                var $async$goto = 0, $async$completer = A._makeAsyncAwaitCompleter(type$.Null), $async$self = this, t1;
                var $async$call$0 = A._wrapJsFunctionForAsync(function($async$errorCode, $async$result) {
                    if ($async$errorCode === 1) return A._asyncRethrow($async$result, $async$completer);
                    for(;;)switch($async$goto){
                        case 0:
                            // Function start
                            t1 = $async$self.$this;
                            $async$goto = 2;
                            return A._asyncAwait(t1._async_evaluate0$_withStyleRule$1$2($async$self.rule, new A._EvaluateVisitor_visitStyleRule__closure2(t1, $async$self.node), type$.Null), $async$call$0);
                        case 2:
                            // returning from await.
                            // implicit return
                            return A._asyncReturn(null, $async$completer);
                    }
                });
                return A._asyncStartSync($async$call$0, $async$completer);
            },
            $signature: 2
        };
        A._EvaluateVisitor_visitStyleRule__closure2.prototype = {
            call$0: function() {
                var $async$goto = 0, $async$completer = A._makeAsyncAwaitCompleter(type$.Null), $async$self = this, t1, t2, t3, _i;
                var $async$call$0 = A._wrapJsFunctionForAsync(function($async$errorCode, $async$result) {
                    if ($async$errorCode === 1) return A._asyncRethrow($async$result, $async$completer);
                    for(;;)switch($async$goto){
                        case 0:
                            // Function start
                            t1 = $async$self.node.children, t2 = t1.length, t3 = $async$self.$this, _i = 0;
                        case 2:
                            // for condition
                            if (!(_i < t2)) {
                                // goto after for
                                $async$goto = 4;
                                break;
                            }
                            $async$goto = 5;
                            return A._asyncAwait(t1[_i].accept$1(t3), $async$call$0);
                        case 5:
                        // returning from await.
                        case 3:
                            // for update
                            ++_i;
                            // goto for condition
                            $async$goto = 2;
                            break;
                        case 4:
                            // after for
                            // implicit return
                            return A._asyncReturn(null, $async$completer);
                    }
                });
                return A._asyncStartSync($async$call$0, $async$completer);
            },
            $signature: 2
        };
        A._EvaluateVisitor_visitStyleRule_closure13.prototype = {
            call$1: function(node) {
                return node instanceof A.ModifiableCssStyleRule0;
            },
            $signature: 8
        };
        A._EvaluateVisitor__warnForBogusCombinators_closure2.prototype = {
            call$1: function(child) {
                return child instanceof A.ModifiableCssComment0;
            },
            $signature: 8
        };
        A._EvaluateVisitor_visitSupportsRule_closure8.prototype = {
            call$0: function() {
                var $async$goto = 0, $async$completer = A._makeAsyncAwaitCompleter(type$.Null), $async$self = this, t1, t2, t3, _i;
                var $async$call$0 = A._wrapJsFunctionForAsync(function($async$errorCode, $async$result) {
                    if ($async$errorCode === 1) return A._asyncRethrow($async$result, $async$completer);
                    for(;;)switch($async$goto){
                        case 0:
                            // Function start
                            t1 = $async$self.node.children, t2 = t1.length, t3 = $async$self.$this, _i = 0;
                        case 2:
                            // for condition
                            if (!(_i < t2)) {
                                // goto after for
                                $async$goto = 4;
                                break;
                            }
                            $async$goto = 5;
                            return A._asyncAwait(t1[_i].accept$1(t3), $async$call$0);
                        case 5:
                        // returning from await.
                        case 3:
                            // for update
                            ++_i;
                            // goto for condition
                            $async$goto = 2;
                            break;
                        case 4:
                            // after for
                            // implicit return
                            return A._asyncReturn(null, $async$completer);
                    }
                });
                return A._asyncStartSync($async$call$0, $async$completer);
            },
            $signature: 2
        };
        A._EvaluateVisitor_visitSupportsRule_closure9.prototype = {
            call$0: function() {
                var $async$goto = 0, $async$completer = A._makeAsyncAwaitCompleter(type$.Null), $async$self = this, t2, t3, _i, t1, _0_0;
                var $async$call$0 = A._wrapJsFunctionForAsync(function($async$errorCode, $async$result) {
                    if ($async$errorCode === 1) return A._asyncRethrow($async$result, $async$completer);
                    for(;;)switch($async$goto){
                        case 0:
                            // Function start
                            t1 = $async$self.$this;
                            _0_0 = t1._async_evaluate0$_atRootExcludingStyleRule ? null : t1._async_evaluate0$_styleRuleIgnoringAtRoot;
                            $async$goto = _0_0 != null ? 2 : 4;
                            break;
                        case 2:
                            // then
                            $async$goto = 5;
                            return A._asyncAwait(t1._async_evaluate0$_withParent$2$2(A.ModifiableCssStyleRule$0(_0_0._style_rule0$_selector, _0_0.span, false, _0_0.originalSelector), new A._EvaluateVisitor_visitSupportsRule__closure2(t1, $async$self.node), type$.ModifiableCssStyleRule_2, type$.Null), $async$call$0);
                        case 5:
                            // returning from await.
                            // goto join
                            $async$goto = 3;
                            break;
                        case 4:
                            // else
                            t2 = $async$self.node.children, t3 = t2.length, _i = 0;
                        case 6:
                            // for condition
                            if (!(_i < t3)) {
                                // goto after for
                                $async$goto = 8;
                                break;
                            }
                            $async$goto = 9;
                            return A._asyncAwait(t2[_i].accept$1(t1), $async$call$0);
                        case 9:
                        // returning from await.
                        case 7:
                            // for update
                            ++_i;
                            // goto for condition
                            $async$goto = 6;
                            break;
                        case 8:
                        // after for
                        case 3:
                            // join
                            // implicit return
                            return A._asyncReturn(null, $async$completer);
                    }
                });
                return A._asyncStartSync($async$call$0, $async$completer);
            },
            $signature: 2
        };
        A._EvaluateVisitor_visitSupportsRule__closure2.prototype = {
            call$0: function() {
                var $async$goto = 0, $async$completer = A._makeAsyncAwaitCompleter(type$.Null), $async$self = this, t1, t2, t3, _i;
                var $async$call$0 = A._wrapJsFunctionForAsync(function($async$errorCode, $async$result) {
                    if ($async$errorCode === 1) return A._asyncRethrow($async$result, $async$completer);
                    for(;;)switch($async$goto){
                        case 0:
                            // Function start
                            t1 = $async$self.node.children, t2 = t1.length, t3 = $async$self.$this, _i = 0;
                        case 2:
                            // for condition
                            if (!(_i < t2)) {
                                // goto after for
                                $async$goto = 4;
                                break;
                            }
                            $async$goto = 5;
                            return A._asyncAwait(t1[_i].accept$1(t3), $async$call$0);
                        case 5:
                        // returning from await.
                        case 3:
                            // for update
                            ++_i;
                            // goto for condition
                            $async$goto = 2;
                            break;
                        case 4:
                            // after for
                            // implicit return
                            return A._asyncReturn(null, $async$completer);
                    }
                });
                return A._asyncStartSync($async$call$0, $async$completer);
            },
            $signature: 2
        };
        A._EvaluateVisitor_visitSupportsRule_closure10.prototype = {
            call$1: function(node) {
                return node instanceof A.ModifiableCssStyleRule0;
            },
            $signature: 8
        };
        A._EvaluateVisitor__visitSupportsCondition_closure2.prototype = {
            call$0: function() {
                var $async$goto = 0, $async$completer = A._makeAsyncAwaitCompleter(type$.String), $async$returnValue, $async$self = this, t1, t2, t3, t4, $async$temp1, $async$temp2;
                var $async$call$0 = A._wrapJsFunctionForAsync(function($async$errorCode, $async$result) {
                    if ($async$errorCode === 1) return A._asyncRethrow($async$result, $async$completer);
                    for(;;)switch($async$goto){
                        case 0:
                            // Function start
                            t1 = $async$self.$this;
                            t2 = $async$self._box_0;
                            $async$temp1 = A;
                            $async$goto = 3;
                            return A._asyncAwait(t1._async_evaluate0$_evaluateToCss$1(t2.declaration.name), $async$call$0);
                        case 3:
                            // returning from await.
                            t3 = $async$temp1.S($async$result);
                            t4 = t2.declaration.get$isCustomProperty() ? "" : " ";
                            $async$temp1 = "(" + t3 + ":" + t4;
                            $async$temp2 = A;
                            $async$goto = 4;
                            return A._asyncAwait(t1._async_evaluate0$_evaluateToCss$1(t2.declaration.value), $async$call$0);
                        case 4:
                            // returning from await.
                            $async$returnValue = $async$temp1 + $async$temp2.S($async$result) + ")";
                            // goto return
                            $async$goto = 1;
                            break;
                        case 1:
                            // return
                            return A._asyncReturn($async$returnValue, $async$completer);
                    }
                });
                return A._asyncStartSync($async$call$0, $async$completer);
            },
            $signature: 181
        };
        A._EvaluateVisitor_visitVariableDeclaration_closure8.prototype = {
            call$0: function() {
                var t1 = this.$this._async_evaluate0$_environment, t2 = this._box_0.override;
                t1.setVariable$4$global(this.node.name, t2.value, t2.assignmentNode, true);
            },
            $signature: 1
        };
        A._EvaluateVisitor_visitVariableDeclaration_closure9.prototype = {
            call$0: function() {
                var t1 = this.node;
                return this.$this._async_evaluate0$_environment.getVariable$2$namespace(t1.name, t1.namespace);
            },
            $signature: 42
        };
        A._EvaluateVisitor_visitVariableDeclaration_closure10.prototype = {
            call$0: function() {
                var t1 = this.$this, t2 = this.node;
                t1._async_evaluate0$_environment.setVariable$5$global$namespace(t2.name, this.value, t1._async_evaluate0$_expressionNode$1(t2.expression), t2.isGlobal, t2.namespace);
            },
            $signature: 1
        };
        A._EvaluateVisitor_visitUseRule_closure2.prototype = {
            call$2: function(module, firstLoad) {
                var t1, t2, t3, _0_0, t4, t5, span;
                if (firstLoad) this.$this._async_evaluate0$_registerCommentsForModule$1(module);
                t1 = this.$this._async_evaluate0$_environment;
                t2 = this.node;
                t3 = t2.namespace;
                if (t3 == null) {
                    t1._async_environment0$_globalModules.$indexSet(0, module, t2);
                    t1._async_environment0$_allModules.push(module);
                    t1 = B.JSArray_methods.get$first(t1._async_environment0$_variables);
                    _0_0 = A.IterableExtension_firstWhereOrNull(t1.get$keys(t1), module.get$variables().get$containsKey());
                    if (_0_0 != null) A.throwExpression(A.SassScriptException$0(string$.This_ma + _0_0 + '".', null));
                } else {
                    t4 = t1._async_environment0$_modules;
                    if (t4.containsKey$1(t3)) {
                        t5 = t1._async_environment0$_namespaceNodes.$index(0, t3);
                        span = t5 == null ? null : t5.span;
                        t5 = A.LinkedHashMap_LinkedHashMap$_empty(type$.FileSpan, type$.String);
                        if (span != null) t5.$indexSet(0, span, "original @use");
                        A.throwExpression(A.MultiSpanSassScriptException$0(string$.There_ + t3 + '".', "new @use", t5));
                    }
                    t4.$indexSet(0, t3, module);
                    t1._async_environment0$_namespaceNodes.$indexSet(0, t3, t2);
                    t1._async_environment0$_allModules.push(module);
                }
            },
            $signature: 121
        };
        A._EvaluateVisitor_visitWarnRule_closure2.prototype = {
            call$0: function() {
                return this.node.expression.accept$1(this.$this);
            },
            $signature: 80
        };
        A._EvaluateVisitor_visitWhileRule_closure2.prototype = {
            call$0: function() {
                var $async$goto = 0, $async$completer = A._makeAsyncAwaitCompleter(type$.nullable_Value_2), $async$returnValue, $async$self = this, t1, t2, t3, _0_0;
                var $async$call$0 = A._wrapJsFunctionForAsync(function($async$errorCode, $async$result) {
                    if ($async$errorCode === 1) return A._asyncRethrow($async$result, $async$completer);
                    for(;;)switch($async$goto){
                        case 0:
                            // Function start
                            t1 = $async$self.node, t2 = t1.condition, t3 = $async$self.$this, t1 = t1.children;
                        case 3:
                            // for condition
                            $async$goto = 5;
                            return A._asyncAwait(t2.accept$1(t3), $async$call$0);
                        case 5:
                            // returning from await.
                            if (!$async$result.get$isTruthy()) {
                                // goto after for
                                $async$goto = 4;
                                break;
                            }
                            $async$goto = 6;
                            return A._asyncAwait(t3._async_evaluate0$_handleReturn$2(t1, new A._EvaluateVisitor_visitWhileRule__closure2(t3)), $async$call$0);
                        case 6:
                            // returning from await.
                            _0_0 = $async$result;
                            if (_0_0 != null) {
                                $async$returnValue = _0_0;
                                // goto return
                                $async$goto = 1;
                                break;
                            }
                            // goto for condition
                            $async$goto = 3;
                            break;
                        case 4:
                            // after for
                            $async$returnValue = null;
                            // goto return
                            $async$goto = 1;
                            break;
                        case 1:
                            // return
                            return A._asyncReturn($async$returnValue, $async$completer);
                    }
                });
                return A._asyncStartSync($async$call$0, $async$completer);
            },
            $signature: 78
        };
        A._EvaluateVisitor_visitWhileRule__closure2.prototype = {
            call$1: function(child) {
                return child.accept$1(this.$this);
            },
            $signature: 101
        };
        A._EvaluateVisitor_visitBinaryOperationExpression_closure2.prototype = {
            call$0: function() {
                var $async$goto = 0, $async$completer = A._makeAsyncAwaitCompleter(type$.Value_2), $async$returnValue, $async$self = this, t3, t1, t2, left, $async$temp1, $async$temp2;
                var $async$call$0 = A._wrapJsFunctionForAsync(function($async$errorCode, $async$result) {
                    if ($async$errorCode === 1) return A._asyncRethrow($async$result, $async$completer);
                    for(;;)switch($async$goto){
                        case 0:
                            // Function start
                            t1 = $async$self.node;
                            t2 = $async$self.$this;
                            $async$goto = 3;
                            return A._asyncAwait(t1.left.accept$1(t2), $async$call$0);
                        case 3:
                            // returning from await.
                            left = $async$result;
                        case 4:
                            // switch
                            switch(t1.operator.index){
                                case 0:
                                    // goto case
                                    $async$goto = 6;
                                    break;
                                case 1:
                                    // goto case
                                    $async$goto = 7;
                                    break;
                                case 2:
                                    // goto case
                                    $async$goto = 8;
                                    break;
                                case 3:
                                    // goto case
                                    $async$goto = 9;
                                    break;
                                case 4:
                                    // goto case
                                    $async$goto = 10;
                                    break;
                                case 5:
                                    // goto case
                                    $async$goto = 11;
                                    break;
                                case 6:
                                    // goto case
                                    $async$goto = 12;
                                    break;
                                case 7:
                                    // goto case
                                    $async$goto = 13;
                                    break;
                                case 8:
                                    // goto case
                                    $async$goto = 14;
                                    break;
                                case 9:
                                    // goto case
                                    $async$goto = 15;
                                    break;
                                case 10:
                                    // goto case
                                    $async$goto = 16;
                                    break;
                                case 11:
                                    // goto case
                                    $async$goto = 17;
                                    break;
                                case 12:
                                    // goto case
                                    $async$goto = 18;
                                    break;
                                case 13:
                                    // goto case
                                    $async$goto = 19;
                                    break;
                                default:
                                    // goto default
                                    $async$goto = 20;
                                    break;
                            }
                            break;
                        case 6:
                            // case
                            t1 = t1.right.accept$1(t2);
                            $async$goto = 21;
                            return A._asyncAwait(type$.Future_Value_2._is(t1) ? t1 : A._Future$value(t1, type$.Value_2), $async$call$0);
                        case 21:
                            // returning from await.
                            t1 = $async$result;
                            t1 = new A.SassString0(A.serializeValue0(left, false, true) + "=" + A.serializeValue0(t1, false, true), false);
                            // goto after switch
                            $async$goto = 5;
                            break;
                        case 7:
                            // case
                            $async$goto = left.get$isTruthy() ? 22 : 24;
                            break;
                        case 22:
                            // then
                            t1 = left;
                            // goto join
                            $async$goto = 23;
                            break;
                        case 24:
                            // else
                            t1 = t1.right.accept$1(t2);
                            $async$goto = 25;
                            return A._asyncAwait(type$.Future_Value_2._is(t1) ? t1 : A._Future$value(t1, type$.Value_2), $async$call$0);
                        case 25:
                            // returning from await.
                            t1 = $async$result;
                        case 23:
                            // join
                            // goto after switch
                            $async$goto = 5;
                            break;
                        case 8:
                            // case
                            $async$goto = left.get$isTruthy() ? 26 : 28;
                            break;
                        case 26:
                            // then
                            t1 = t1.right.accept$1(t2);
                            $async$goto = 29;
                            return A._asyncAwait(type$.Future_Value_2._is(t1) ? t1 : A._Future$value(t1, type$.Value_2), $async$call$0);
                        case 29:
                            // returning from await.
                            t1 = $async$result;
                            // goto join
                            $async$goto = 27;
                            break;
                        case 28:
                            // else
                            t1 = left;
                        case 27:
                            // join
                            // goto after switch
                            $async$goto = 5;
                            break;
                        case 9:
                            // case
                            $async$temp1 = left;
                            $async$goto = 30;
                            return A._asyncAwait(t1.right.accept$1(t2), $async$call$0);
                        case 30:
                            // returning from await.
                            t1 = $async$temp1.$eq(0, $async$result) ? B.SassBoolean_true0 : B.SassBoolean_false0;
                            // goto after switch
                            $async$goto = 5;
                            break;
                        case 10:
                            // case
                            $async$temp1 = left;
                            $async$goto = 31;
                            return A._asyncAwait(t1.right.accept$1(t2), $async$call$0);
                        case 31:
                            // returning from await.
                            t1 = !$async$temp1.$eq(0, $async$result) ? B.SassBoolean_true0 : B.SassBoolean_false0;
                            // goto after switch
                            $async$goto = 5;
                            break;
                        case 11:
                            // case
                            t1 = t1.right.accept$1(t2);
                            $async$temp1 = left;
                            $async$goto = 32;
                            return A._asyncAwait(type$.Future_Value_2._is(t1) ? t1 : A._Future$value(t1, type$.Value_2), $async$call$0);
                        case 32:
                            // returning from await.
                            t1 = $async$temp1.greaterThan$1($async$result);
                            // goto after switch
                            $async$goto = 5;
                            break;
                        case 12:
                            // case
                            t1 = t1.right.accept$1(t2);
                            $async$temp1 = left;
                            $async$goto = 33;
                            return A._asyncAwait(type$.Future_Value_2._is(t1) ? t1 : A._Future$value(t1, type$.Value_2), $async$call$0);
                        case 33:
                            // returning from await.
                            t1 = $async$temp1.greaterThanOrEquals$1($async$result);
                            // goto after switch
                            $async$goto = 5;
                            break;
                        case 13:
                            // case
                            t1 = t1.right.accept$1(t2);
                            $async$temp1 = left;
                            $async$goto = 34;
                            return A._asyncAwait(type$.Future_Value_2._is(t1) ? t1 : A._Future$value(t1, type$.Value_2), $async$call$0);
                        case 34:
                            // returning from await.
                            t1 = $async$temp1.lessThan$1($async$result);
                            // goto after switch
                            $async$goto = 5;
                            break;
                        case 14:
                            // case
                            t1 = t1.right.accept$1(t2);
                            $async$temp1 = left;
                            $async$goto = 35;
                            return A._asyncAwait(type$.Future_Value_2._is(t1) ? t1 : A._Future$value(t1, type$.Value_2), $async$call$0);
                        case 35:
                            // returning from await.
                            t1 = $async$temp1.lessThanOrEquals$1($async$result);
                            // goto after switch
                            $async$goto = 5;
                            break;
                        case 15:
                            // case
                            t1 = t1.right.accept$1(t2);
                            $async$temp1 = left;
                            $async$goto = 36;
                            return A._asyncAwait(type$.Future_Value_2._is(t1) ? t1 : A._Future$value(t1, type$.Value_2), $async$call$0);
                        case 36:
                            // returning from await.
                            t1 = $async$temp1.plus$1($async$result);
                            // goto after switch
                            $async$goto = 5;
                            break;
                        case 16:
                            // case
                            t1 = t1.right.accept$1(t2);
                            $async$temp1 = left;
                            $async$goto = 37;
                            return A._asyncAwait(type$.Future_Value_2._is(t1) ? t1 : A._Future$value(t1, type$.Value_2), $async$call$0);
                        case 37:
                            // returning from await.
                            t1 = $async$temp1.minus$1($async$result);
                            // goto after switch
                            $async$goto = 5;
                            break;
                        case 17:
                            // case
                            t1 = t1.right.accept$1(t2);
                            $async$temp1 = left;
                            $async$goto = 38;
                            return A._asyncAwait(type$.Future_Value_2._is(t1) ? t1 : A._Future$value(t1, type$.Value_2), $async$call$0);
                        case 38:
                            // returning from await.
                            t1 = $async$temp1.times$1($async$result);
                            // goto after switch
                            $async$goto = 5;
                            break;
                        case 18:
                            // case
                            t3 = t1.right.accept$1(t2);
                            $async$temp1 = t2;
                            $async$temp2 = left;
                            $async$goto = 39;
                            return A._asyncAwait(type$.Future_Value_2._is(t3) ? t3 : A._Future$value(t3, type$.Value_2), $async$call$0);
                        case 39:
                            // returning from await.
                            t1 = $async$temp1._async_evaluate0$_slash$3($async$temp2, $async$result, t1);
                            // goto after switch
                            $async$goto = 5;
                            break;
                        case 19:
                            // case
                            t1 = t1.right.accept$1(t2);
                            $async$temp1 = left;
                            $async$goto = 40;
                            return A._asyncAwait(type$.Future_Value_2._is(t1) ? t1 : A._Future$value(t1, type$.Value_2), $async$call$0);
                        case 40:
                            // returning from await.
                            t1 = $async$temp1.modulo$1($async$result);
                            // goto after switch
                            $async$goto = 5;
                            break;
                        case 20:
                            // default
                            t1 = null;
                        case 5:
                            // after switch
                            $async$returnValue = t1;
                            // goto return
                            $async$goto = 1;
                            break;
                        case 1:
                            // return
                            return A._asyncReturn($async$returnValue, $async$completer);
                    }
                });
                return A._asyncStartSync($async$call$0, $async$completer);
            },
            $signature: 80
        };
        A._EvaluateVisitor__slash_recommendation2.prototype = {
            call$1: function(expression) {
                var t1;
                $label0$0: {
                    if (expression instanceof A.BinaryOperationExpression0 && B.BinaryOperator_ehp0 === expression.operator) {
                        t1 = "math.div(" + A.S(this.call$1(expression.left)) + ", " + A.S(this.call$1(expression.right)) + ")";
                        break $label0$0;
                    }
                    if (expression instanceof A.ParenthesizedExpression0) {
                        t1 = expression.expression.toString$0(0);
                        break $label0$0;
                    }
                    t1 = expression.toString$0(0);
                    break $label0$0;
                }
                return t1;
            },
            $signature: 120
        };
        A._EvaluateVisitor_visitVariableExpression_closure2.prototype = {
            call$0: function() {
                var t1 = this.node;
                return this.$this._async_evaluate0$_environment.getVariable$2$namespace(t1.name, t1.namespace);
            },
            $signature: 42
        };
        A._EvaluateVisitor_visitUnaryOperationExpression_closure2.prototype = {
            call$0: function() {
                var t1, _this = this;
                switch(_this.node.operator.index){
                    case 0:
                        t1 = _this.operand.unaryPlus$0();
                        break;
                    case 1:
                        t1 = _this.operand.unaryMinus$0();
                        break;
                    case 2:
                        t1 = new A.SassString0("/" + A.serializeValue0(_this.operand, false, true), false);
                        break;
                    case 3:
                        t1 = _this.operand.unaryNot$0();
                        break;
                    default:
                        t1 = null;
                }
                return t1;
            },
            $signature: 46
        };
        A._EvaluateVisitor_visitIfExpression_closure2.prototype = {
            call$1: function(pair) {
                return pair._0 + ": " + pair._1.toString$0(0);
            },
            $signature: 217
        };
        A._EvaluateVisitor_visitIfConditionOperation_closure2.prototype = {
            call$1: function(pair) {
                return pair._1;
            },
            $signature: 218
        };
        A._EvaluateVisitor_visitListExpression_closure2.prototype = {
            call$1: function(expression) {
                return expression.accept$1(this.$this);
            },
            $signature: 358
        };
        A._EvaluateVisitor_visitFunctionExpression_closure8.prototype = {
            call$0: function() {
                var t1 = this.node;
                return this.$this._async_evaluate0$_environment.getFunction$2$namespace(t1.name, t1.namespace);
            },
            $signature: 96
        };
        A._EvaluateVisitor_visitFunctionExpression_closure9.prototype = {
            call$1: function(argument) {
                return argument.accept$1(B.C_IsCalculationSafeVisitor0);
            },
            $signature: 81
        };
        A._EvaluateVisitor_visitFunctionExpression_closure10.prototype = {
            call$0: function() {
                var t1 = this.node;
                return this.$this._async_evaluate0$_runFunctionCallable$3(t1.$arguments, this._box_0.$function, t1);
            },
            $signature: 80
        };
        A._EvaluateVisitor__visitCalculation_closure2.prototype = {
            call$2: function(message, deprecation) {
                return this.$this._async_evaluate0$_warn$3(message, this.node.span, deprecation);
            },
            call$1: function(message) {
                return this.call$2(message, null);
            },
            $signature: 110
        };
        A._EvaluateVisitor__checkCalculationArguments_check2.prototype = {
            call$1: function(maxArgs) {
                var t1 = this.node, t2 = t1.$arguments.positional.length;
                if (t2 === 0) throw A.wrapException(this.$this._async_evaluate0$_exception$2("Missing argument.", t1.span));
                else if (maxArgs != null && t2 > maxArgs) throw A.wrapException(this.$this._async_evaluate0$_exception$2("Only " + A.S(maxArgs) + " " + A.pluralize0("argument", maxArgs, null) + " allowed, but " + t2 + " " + A.pluralize0("was", t2, "were") + " passed.", t1.span));
            },
            call$0: function() {
                return this.call$1(null);
            },
            $signature: 82
        };
        A._EvaluateVisitor__visitCalculationExpression_closure2.prototype = {
            call$0: function() {
                var $async$goto = 0, $async$completer = A._makeAsyncAwaitCompleter(type$.Object), $async$returnValue, $async$self = this, t1, t2, t3, t4, $async$temp1, $async$temp2, $async$temp3;
                var $async$call$0 = A._wrapJsFunctionForAsync(function($async$errorCode, $async$result) {
                    if ($async$errorCode === 1) return A._asyncRethrow($async$result, $async$completer);
                    for(;;)switch($async$goto){
                        case 0:
                            // Function start
                            t1 = $async$self.$this;
                            t2 = $async$self._box_0;
                            t3 = $async$self.node;
                            t4 = $async$self.inLegacySassFunction;
                            $async$temp1 = A;
                            $async$temp2 = t1._async_evaluate0$_binaryOperatorToCalculationOperator$2(t2.operator, t3);
                            $async$goto = 3;
                            return A._asyncAwait(t1._async_evaluate0$_visitCalculationExpression$2$inLegacySassFunction(t2.left, t4), $async$call$0);
                        case 3:
                            // returning from await.
                            $async$temp3 = $async$result;
                            $async$goto = 4;
                            return A._asyncAwait(t1._async_evaluate0$_visitCalculationExpression$2$inLegacySassFunction(t2.right, t4), $async$call$0);
                        case 4:
                            // returning from await.
                            $async$returnValue = $async$temp1.SassCalculation_operateInternal0($async$temp2, $async$temp3, $async$result, t4, !t1._async_evaluate0$_inSupportsDeclaration, new A._EvaluateVisitor__visitCalculationExpression__closure2(t1, t3));
                            // goto return
                            $async$goto = 1;
                            break;
                        case 1:
                            // return
                            return A._asyncReturn($async$returnValue, $async$completer);
                    }
                });
                return A._asyncStartSync($async$call$0, $async$completer);
            },
            $signature: 185
        };
        A._EvaluateVisitor__visitCalculationExpression__closure2.prototype = {
            call$2: function(message, deprecation) {
                return this.$this._async_evaluate0$_warn$3(message, this.node.get$span(0), deprecation);
            },
            call$1: function(message) {
                return this.call$2(message, null);
            },
            $signature: 110
        };
        A._EvaluateVisitor_visitInterpolatedFunctionExpression_closure2.prototype = {
            call$0: function() {
                var t1 = this.node;
                return this.$this._async_evaluate0$_runFunctionCallable$3(t1.$arguments, this.$function, t1);
            },
            $signature: 80
        };
        A._EvaluateVisitor__runUserDefinedCallable_closure2.prototype = {
            call$0: function() {
                var _this = this, t1 = _this.$this, t2 = _this.callable, t3 = _this.V;
                return t1._async_evaluate0$_withEnvironment$1$2(t2.environment.closure$0(), new A._EvaluateVisitor__runUserDefinedCallable__closure2(t1, _this.evaluated, t2, _this.nodeWithSpan, _this.run, t3), t3);
            },
            $signature: function() {
                return this.V._eval$1("Future<0>()");
            }
        };
        A._EvaluateVisitor__runUserDefinedCallable__closure2.prototype = {
            call$0: function() {
                var _this = this, t1 = _this.$this, t2 = _this.V;
                return t1._async_evaluate0$_environment.scope$1$1(new A._EvaluateVisitor__runUserDefinedCallable___closure2(t1, _this.evaluated, _this.callable, _this.nodeWithSpan, _this.run, t2), t2);
            },
            $signature: function() {
                return this.V._eval$1("Future<0>()");
            }
        };
        A._EvaluateVisitor__runUserDefinedCallable___closure2.prototype = {
            call$0: function() {
                return this.$call$body$_EvaluateVisitor__runUserDefinedCallable___closure0(this.V);
            },
            $call$body$_EvaluateVisitor__runUserDefinedCallable___closure0: function($async$type) {
                var $async$goto = 0, $async$completer = A._makeAsyncAwaitCompleter($async$type), $async$returnValue, $async$self = this, parameters, t5, minLength, i, parameter, t6, value, t7, t8, restParameter, rest, argumentList, result, parameterWord, t1, t2, t3, t4, $async$temp1;
                var $async$call$0 = A._wrapJsFunctionForAsync(function($async$errorCode, $async$result) {
                    if ($async$errorCode === 1) return A._asyncRethrow($async$result, $async$completer);
                    for(;;)switch($async$goto){
                        case 0:
                            // Function start
                            t1 = $async$self.$this;
                            t2 = $async$self.evaluated._values;
                            t3 = $async$self.callable.declaration.parameters;
                            t4 = $async$self.nodeWithSpan;
                            t1._async_evaluate0$_verifyArguments$4(J.get$length$asx(t2[2]), t2[0], t3, t4);
                            parameters = t3.parameters;
                            t5 = parameters.length;
                            minLength = Math.min(J.get$length$asx(t2[2]), t5);
                            for(i = 0; i < minLength; ++i)t1._async_evaluate0$_environment.setLocalVariable$3(parameters[i].name, J.$index$asx(t2[2], i), J.$index$asx(t2[3], i));
                            i = J.get$length$asx(t2[2]);
                        case 3:
                            // for condition
                            if (!(i < t5)) {
                                // goto after for
                                $async$goto = 5;
                                break;
                            }
                            parameter = parameters[i];
                            t6 = parameter.name;
                            value = t2[0].remove$1(0, t6);
                            $async$goto = value == null ? 6 : 7;
                            break;
                        case 6:
                            // then
                            t7 = parameter.defaultValue;
                            $async$temp1 = t1;
                            $async$goto = 8;
                            return A._asyncAwait(t7.accept$1(t1), $async$call$0);
                        case 8:
                            // returning from await.
                            value = $async$temp1._async_evaluate0$_withoutSlash$2($async$result, t1._async_evaluate0$_expressionNode$1(t7));
                        case 7:
                            // join
                            t7 = t1._async_evaluate0$_environment;
                            t8 = t2[1].$index(0, t6);
                            if (t8 == null) {
                                t8 = parameter.defaultValue;
                                t8.toString;
                                t8 = t1._async_evaluate0$_expressionNode$1(t8);
                            }
                            t7.setLocalVariable$3(t6, value, t8);
                        case 4:
                            // for update
                            ++i;
                            // goto for condition
                            $async$goto = 3;
                            break;
                        case 5:
                            // after for
                            restParameter = t3.restParameter;
                            if (restParameter != null) {
                                rest = J.get$length$asx(t2[2]) > t5 ? J.sublist$1$ax(t2[2], t5) : B.List_empty23;
                                t5 = t2[0];
                                t6 = t2[4];
                                argumentList = A.SassArgumentList$0(rest, t5, t6 === B.ListSeparator_undecided_null_3_undecided0 ? B.ListSeparator_z0K0 : t6);
                                t1._async_evaluate0$_environment.setLocalVariable$3(restParameter, argumentList, t4);
                            } else argumentList = null;
                            $async$goto = 9;
                            return A._asyncAwait($async$self.run.call$0(), $async$call$0);
                        case 9:
                            // returning from await.
                            result = $async$result;
                            if (argumentList == null) {
                                $async$returnValue = result;
                                // goto return
                                $async$goto = 1;
                                break;
                            }
                            t5 = t2[0];
                            if (t5.get$isEmpty(t5)) {
                                $async$returnValue = result;
                                // goto return
                                $async$goto = 1;
                                break;
                            }
                            if (argumentList._argument_list$_wereKeywordsAccessed) {
                                $async$returnValue = result;
                                // goto return
                                $async$goto = 1;
                                break;
                            }
                            t5 = t2[0];
                            t5 = t5.get$keys(t5);
                            parameterWord = A.pluralize0("parameter", t5.get$length(t5), null);
                            t2 = t2[0];
                            t2 = t2.get$keys(t2);
                            throw A.wrapException(A.MultiSpanSassRuntimeException$0("No " + parameterWord + " named " + A.toSentence0(t2.map$1$1(t2, new A._EvaluateVisitor__runUserDefinedCallable____closure2(), type$.Object), "or") + ".", t4.get$span(t4), "invocation", A.LinkedHashMap_LinkedHashMap$_literal([
                                t3.get$spanWithName(),
                                "declaration"
                            ], type$.FileSpan, type$.String), t1._async_evaluate0$_stackTrace$1(t4.get$span(t4)), null));
                        case 1:
                            // return
                            return A._asyncReturn($async$returnValue, $async$completer);
                    }
                });
                return A._asyncStartSync($async$call$0, $async$completer);
            },
            $signature: function() {
                return this.V._eval$1("Future<0>()");
            }
        };
        A._EvaluateVisitor__runUserDefinedCallable____closure2.prototype = {
            call$1: function($name) {
                return "$" + $name;
            },
            $signature: 6
        };
        A._EvaluateVisitor__runFunctionCallable_closure2.prototype = {
            call$0: function() {
                var $async$goto = 0, $async$completer = A._makeAsyncAwaitCompleter(type$.Value_2), $async$returnValue, $async$self = this, t1, t2, t3, t4, _i, $returnValue;
                var $async$call$0 = A._wrapJsFunctionForAsync(function($async$errorCode, $async$result) {
                    if ($async$errorCode === 1) return A._asyncRethrow($async$result, $async$completer);
                    for(;;)switch($async$goto){
                        case 0:
                            // Function start
                            t1 = $async$self.callable.declaration, t2 = t1.children, t3 = t2.length, t4 = $async$self.$this, _i = 0;
                        case 3:
                            // for condition
                            if (!(_i < t3)) {
                                // goto after for
                                $async$goto = 5;
                                break;
                            }
                            $async$goto = 6;
                            return A._asyncAwait(t2[_i].accept$1(t4), $async$call$0);
                        case 6:
                            // returning from await.
                            $returnValue = $async$result;
                            if ($returnValue instanceof A.Value0) {
                                $async$returnValue = $returnValue;
                                // goto return
                                $async$goto = 1;
                                break;
                            }
                        case 4:
                            // for update
                            ++_i;
                            // goto for condition
                            $async$goto = 3;
                            break;
                        case 5:
                            // after for
                            throw A.wrapException(t4._async_evaluate0$_exception$2("Function finished without @return.", t1.span));
                        case 1:
                            // return
                            return A._asyncReturn($async$returnValue, $async$completer);
                    }
                });
                return A._asyncStartSync($async$call$0, $async$completer);
            },
            $signature: 80
        };
        A._EvaluateVisitor__runBuiltInCallable_closure8.prototype = {
            call$0: function() {
                return this._box_0.overload.verify$2(J.get$length$asx(this.evaluated._values[2]), this.namedSet);
            },
            $signature: 0
        };
        A._EvaluateVisitor__runBuiltInCallable_closure9.prototype = {
            call$0: function() {
                return this._box_0.callback.call$1(this.evaluated._values[2]);
            },
            $signature: 361
        };
        A._EvaluateVisitor__runBuiltInCallable_closure10.prototype = {
            call$1: function($name) {
                return "$" + $name;
            },
            $signature: 6
        };
        A._EvaluateVisitor__evaluateArguments_closure11.prototype = {
            call$1: function(value) {
                return value;
            },
            $signature: 41
        };
        A._EvaluateVisitor__evaluateArguments_closure12.prototype = {
            call$1: function(value) {
                return this.$this._async_evaluate0$_withoutSlash$2(value, this.restNodeForSpan);
            },
            $signature: 41
        };
        A._EvaluateVisitor__evaluateArguments_closure13.prototype = {
            call$2: function(key, value) {
                var _this = this, t1 = _this.restNodeForSpan;
                _this.named.$indexSet(0, key, _this.$this._async_evaluate0$_withoutSlash$2(value, t1));
                _this.namedNodes.$indexSet(0, key, t1);
            },
            $signature: 112
        };
        A._EvaluateVisitor__evaluateArguments_closure14.prototype = {
            call$1: function(value) {
                return value;
            },
            $signature: 41
        };
        A._EvaluateVisitor__evaluateMacroArguments_closure11.prototype = {
            call$1: function(value) {
                var t1 = this.restArgs;
                return new A.ValueExpression0(value, t1.get$span(t1));
            },
            $signature: 65
        };
        A._EvaluateVisitor__evaluateMacroArguments_closure12.prototype = {
            call$1: function(value) {
                var t1 = this.restArgs;
                return new A.ValueExpression0(this.$this._async_evaluate0$_withoutSlash$2(value, this.restNodeForSpan), t1.get$span(t1));
            },
            $signature: 65
        };
        A._EvaluateVisitor__evaluateMacroArguments_closure13.prototype = {
            call$2: function(key, value) {
                var _this = this, t1 = _this.restArgs;
                _this.named.$indexSet(0, key, new A.ValueExpression0(_this.$this._async_evaluate0$_withoutSlash$2(value, _this.restNodeForSpan), t1.get$span(t1)));
            },
            $signature: 112
        };
        A._EvaluateVisitor__evaluateMacroArguments_closure14.prototype = {
            call$1: function(value) {
                var t1 = this.keywordRestArgs;
                return new A.ValueExpression0(this.$this._async_evaluate0$_withoutSlash$2(value, this.keywordRestNodeForSpan), t1.get$span(t1));
            },
            $signature: 65
        };
        A._EvaluateVisitor__addRestMap_closure2.prototype = {
            call$2: function(key, value) {
                var t2, _this = this, t1 = _this.$this;
                if (key instanceof A.SassString0) _this.values.$indexSet(0, key._string0$_text, _this.convert.call$1(t1._async_evaluate0$_withoutSlash$2(value, _this.expressionNode)));
                else {
                    t2 = _this.nodeWithSpan;
                    throw A.wrapException(t1._async_evaluate0$_exception$2(string$.Variab_ + key.toString$0(0) + " is not a string in " + _this.map.toString$0(0) + ".", t2.get$span(t2)));
                }
            },
            $signature: 117
        };
        A._EvaluateVisitor__verifyArguments_closure2.prototype = {
            call$0: function() {
                return this.parameters.verify$2(this.positional, new A.MapKeySet(this.named, type$.MapKeySet_String));
            },
            $signature: 0
        };
        A._EvaluateVisitor_visitCssAtRule_closure8.prototype = {
            call$0: function() {
                var $async$goto = 0, $async$completer = A._makeAsyncAwaitCompleter(type$.Null), $async$self = this, t1, t2, t3, t4;
                var $async$call$0 = A._wrapJsFunctionForAsync(function($async$errorCode, $async$result) {
                    if ($async$errorCode === 1) return A._asyncRethrow($async$result, $async$completer);
                    for(;;)switch($async$goto){
                        case 0:
                            // Function start
                            t1 = $async$self.node.children, t2 = t1.$ti, t1 = new A.ListIterator(t1, t1.get$length(0), t2._eval$1("ListIterator<ListBase.E>")), t3 = $async$self.$this, t2 = t2._eval$1("ListBase.E");
                        case 2:
                            // for condition
                            if (!t1.moveNext$0()) {
                                // goto after for
                                $async$goto = 3;
                                break;
                            }
                            t4 = t1.__internal$_current;
                            $async$goto = 4;
                            return A._asyncAwait((t4 == null ? t2._as(t4) : t4).accept$1(t3), $async$call$0);
                        case 4:
                            // returning from await.
                            // goto for condition
                            $async$goto = 2;
                            break;
                        case 3:
                            // after for
                            // implicit return
                            return A._asyncReturn(null, $async$completer);
                    }
                });
                return A._asyncStartSync($async$call$0, $async$completer);
            },
            $signature: 2
        };
        A._EvaluateVisitor_visitCssAtRule_closure9.prototype = {
            call$0: function() {
                var $async$goto = 0, $async$completer = A._makeAsyncAwaitCompleter(type$.Null), $async$self = this, t1, t2, t3, t4;
                var $async$call$0 = A._wrapJsFunctionForAsync(function($async$errorCode, $async$result) {
                    if ($async$errorCode === 1) return A._asyncRethrow($async$result, $async$completer);
                    for(;;)switch($async$goto){
                        case 0:
                            // Function start
                            t1 = $async$self.node.children, t2 = t1.$ti, t1 = new A.ListIterator(t1, t1.get$length(0), t2._eval$1("ListIterator<ListBase.E>")), t3 = $async$self.$this, t2 = t2._eval$1("ListBase.E");
                        case 2:
                            // for condition
                            if (!t1.moveNext$0()) {
                                // goto after for
                                $async$goto = 3;
                                break;
                            }
                            t4 = t1.__internal$_current;
                            $async$goto = 4;
                            return A._asyncAwait((t4 == null ? t2._as(t4) : t4).accept$1(t3), $async$call$0);
                        case 4:
                            // returning from await.
                            // goto for condition
                            $async$goto = 2;
                            break;
                        case 3:
                            // after for
                            // implicit return
                            return A._asyncReturn(null, $async$completer);
                    }
                });
                return A._asyncStartSync($async$call$0, $async$completer);
            },
            $signature: 2
        };
        A._EvaluateVisitor_visitCssAtRule_closure10.prototype = {
            call$1: function(node) {
                return node instanceof A.ModifiableCssStyleRule0;
            },
            $signature: 8
        };
        A._EvaluateVisitor_visitCssKeyframeBlock_closure5.prototype = {
            call$0: function() {
                var $async$goto = 0, $async$completer = A._makeAsyncAwaitCompleter(type$.Null), $async$self = this, t1, t2, t3, t4;
                var $async$call$0 = A._wrapJsFunctionForAsync(function($async$errorCode, $async$result) {
                    if ($async$errorCode === 1) return A._asyncRethrow($async$result, $async$completer);
                    for(;;)switch($async$goto){
                        case 0:
                            // Function start
                            t1 = $async$self.node.children, t2 = t1.$ti, t1 = new A.ListIterator(t1, t1.get$length(0), t2._eval$1("ListIterator<ListBase.E>")), t3 = $async$self.$this, t2 = t2._eval$1("ListBase.E");
                        case 2:
                            // for condition
                            if (!t1.moveNext$0()) {
                                // goto after for
                                $async$goto = 3;
                                break;
                            }
                            t4 = t1.__internal$_current;
                            $async$goto = 4;
                            return A._asyncAwait((t4 == null ? t2._as(t4) : t4).accept$1(t3), $async$call$0);
                        case 4:
                            // returning from await.
                            // goto for condition
                            $async$goto = 2;
                            break;
                        case 3:
                            // after for
                            // implicit return
                            return A._asyncReturn(null, $async$completer);
                    }
                });
                return A._asyncStartSync($async$call$0, $async$completer);
            },
            $signature: 2
        };
        A._EvaluateVisitor_visitCssKeyframeBlock_closure6.prototype = {
            call$1: function(node) {
                return node instanceof A.ModifiableCssStyleRule0;
            },
            $signature: 8
        };
        A._EvaluateVisitor_visitCssMediaRule_closure11.prototype = {
            call$0: function() {
                var $async$goto = 0, $async$completer = A._makeAsyncAwaitCompleter(type$.Null), $async$self = this, t1, t2, t3, t4;
                var $async$call$0 = A._wrapJsFunctionForAsync(function($async$errorCode, $async$result) {
                    if ($async$errorCode === 1) return A._asyncRethrow($async$result, $async$completer);
                    for(;;)switch($async$goto){
                        case 0:
                            // Function start
                            t1 = $async$self.node.children, t2 = t1.$ti, t1 = new A.ListIterator(t1, t1.get$length(0), t2._eval$1("ListIterator<ListBase.E>")), t3 = $async$self.$this, t2 = t2._eval$1("ListBase.E");
                        case 2:
                            // for condition
                            if (!t1.moveNext$0()) {
                                // goto after for
                                $async$goto = 3;
                                break;
                            }
                            t4 = t1.__internal$_current;
                            $async$goto = 4;
                            return A._asyncAwait((t4 == null ? t2._as(t4) : t4).accept$1(t3), $async$call$0);
                        case 4:
                            // returning from await.
                            // goto for condition
                            $async$goto = 2;
                            break;
                        case 3:
                            // after for
                            // implicit return
                            return A._asyncReturn(null, $async$completer);
                    }
                });
                return A._asyncStartSync($async$call$0, $async$completer);
            },
            $signature: 2
        };
        A._EvaluateVisitor_visitCssMediaRule_closure12.prototype = {
            call$1: function(mediaQueries) {
                return this.$this._async_evaluate0$_mergeMediaQueries$2(mediaQueries, this.node.queries);
            },
            $signature: 104
        };
        A._EvaluateVisitor_visitCssMediaRule_closure13.prototype = {
            call$0: function() {
                var $async$goto = 0, $async$completer = A._makeAsyncAwaitCompleter(type$.Null), $async$self = this, t1, t2;
                var $async$call$0 = A._wrapJsFunctionForAsync(function($async$errorCode, $async$result) {
                    if ($async$errorCode === 1) return A._asyncRethrow($async$result, $async$completer);
                    for(;;)switch($async$goto){
                        case 0:
                            // Function start
                            t1 = $async$self.$this;
                            t2 = $async$self.mergedQueries;
                            if (t2 == null) t2 = $async$self.node.queries;
                            $async$goto = 2;
                            return A._asyncAwait(t1._async_evaluate0$_withMediaQueries$1$3(t2, $async$self.mergedSources, new A._EvaluateVisitor_visitCssMediaRule__closure2(t1, $async$self.node), type$.Null), $async$call$0);
                        case 2:
                            // returning from await.
                            // implicit return
                            return A._asyncReturn(null, $async$completer);
                    }
                });
                return A._asyncStartSync($async$call$0, $async$completer);
            },
            $signature: 2
        };
        A._EvaluateVisitor_visitCssMediaRule__closure2.prototype = {
            call$0: function() {
                var $async$goto = 0, $async$completer = A._makeAsyncAwaitCompleter(type$.Null), $async$self = this, t2, t3, t4, t1, _0_0;
                var $async$call$0 = A._wrapJsFunctionForAsync(function($async$errorCode, $async$result) {
                    if ($async$errorCode === 1) return A._asyncRethrow($async$result, $async$completer);
                    for(;;)switch($async$goto){
                        case 0:
                            // Function start
                            t1 = $async$self.$this;
                            _0_0 = t1._async_evaluate0$_atRootExcludingStyleRule ? null : t1._async_evaluate0$_styleRuleIgnoringAtRoot;
                            $async$goto = _0_0 != null ? 2 : 4;
                            break;
                        case 2:
                            // then
                            $async$goto = 5;
                            return A._asyncAwait(t1._async_evaluate0$_withParent$2$3$scopeWhen(A.ModifiableCssStyleRule$0(_0_0._style_rule0$_selector, _0_0.span, false, _0_0.originalSelector), new A._EvaluateVisitor_visitCssMediaRule___closure2(t1, $async$self.node), false, type$.ModifiableCssStyleRule_2, type$.Null), $async$call$0);
                        case 5:
                            // returning from await.
                            // goto join
                            $async$goto = 3;
                            break;
                        case 4:
                            // else
                            t2 = $async$self.node.children, t3 = t2.$ti, t2 = new A.ListIterator(t2, t2.get$length(0), t3._eval$1("ListIterator<ListBase.E>")), t3 = t3._eval$1("ListBase.E");
                        case 6:
                            // for condition
                            if (!t2.moveNext$0()) {
                                // goto after for
                                $async$goto = 7;
                                break;
                            }
                            t4 = t2.__internal$_current;
                            $async$goto = 8;
                            return A._asyncAwait((t4 == null ? t3._as(t4) : t4).accept$1(t1), $async$call$0);
                        case 8:
                            // returning from await.
                            // goto for condition
                            $async$goto = 6;
                            break;
                        case 7:
                        // after for
                        case 3:
                            // join
                            // implicit return
                            return A._asyncReturn(null, $async$completer);
                    }
                });
                return A._asyncStartSync($async$call$0, $async$completer);
            },
            $signature: 2
        };
        A._EvaluateVisitor_visitCssMediaRule___closure2.prototype = {
            call$0: function() {
                var $async$goto = 0, $async$completer = A._makeAsyncAwaitCompleter(type$.Null), $async$self = this, t1, t2, t3, t4;
                var $async$call$0 = A._wrapJsFunctionForAsync(function($async$errorCode, $async$result) {
                    if ($async$errorCode === 1) return A._asyncRethrow($async$result, $async$completer);
                    for(;;)switch($async$goto){
                        case 0:
                            // Function start
                            t1 = $async$self.node.children, t2 = t1.$ti, t1 = new A.ListIterator(t1, t1.get$length(0), t2._eval$1("ListIterator<ListBase.E>")), t3 = $async$self.$this, t2 = t2._eval$1("ListBase.E");
                        case 2:
                            // for condition
                            if (!t1.moveNext$0()) {
                                // goto after for
                                $async$goto = 3;
                                break;
                            }
                            t4 = t1.__internal$_current;
                            $async$goto = 4;
                            return A._asyncAwait((t4 == null ? t2._as(t4) : t4).accept$1(t3), $async$call$0);
                        case 4:
                            // returning from await.
                            // goto for condition
                            $async$goto = 2;
                            break;
                        case 3:
                            // after for
                            // implicit return
                            return A._asyncReturn(null, $async$completer);
                    }
                });
                return A._asyncStartSync($async$call$0, $async$completer);
            },
            $signature: 2
        };
        A._EvaluateVisitor_visitCssMediaRule_closure14.prototype = {
            call$1: function(node) {
                var t1;
                if (!(node instanceof A.ModifiableCssStyleRule0)) {
                    t1 = this.mergedSources;
                    t1 = t1.get$isNotEmpty(t1) && node instanceof A.ModifiableCssMediaRule0 && B.JSArray_methods.every$1(node.queries, t1.get$contains(t1));
                } else t1 = true;
                return t1;
            },
            $signature: 8
        };
        A._EvaluateVisitor_visitCssStyleRule_closure6.prototype = {
            call$0: function() {
                var $async$goto = 0, $async$completer = A._makeAsyncAwaitCompleter(type$.Null), $async$self = this, t1;
                var $async$call$0 = A._wrapJsFunctionForAsync(function($async$errorCode, $async$result) {
                    if ($async$errorCode === 1) return A._asyncRethrow($async$result, $async$completer);
                    for(;;)switch($async$goto){
                        case 0:
                            // Function start
                            t1 = $async$self.$this;
                            $async$goto = 2;
                            return A._asyncAwait(t1._async_evaluate0$_withStyleRule$1$2($async$self.rule, new A._EvaluateVisitor_visitCssStyleRule__closure2(t1, $async$self.node), type$.Null), $async$call$0);
                        case 2:
                            // returning from await.
                            // implicit return
                            return A._asyncReturn(null, $async$completer);
                    }
                });
                return A._asyncStartSync($async$call$0, $async$completer);
            },
            $signature: 2
        };
        A._EvaluateVisitor_visitCssStyleRule__closure2.prototype = {
            call$0: function() {
                var $async$goto = 0, $async$completer = A._makeAsyncAwaitCompleter(type$.Null), $async$self = this, t1, t2, t3, t4;
                var $async$call$0 = A._wrapJsFunctionForAsync(function($async$errorCode, $async$result) {
                    if ($async$errorCode === 1) return A._asyncRethrow($async$result, $async$completer);
                    for(;;)switch($async$goto){
                        case 0:
                            // Function start
                            t1 = $async$self.node.children, t2 = t1.$ti, t1 = new A.ListIterator(t1, t1.get$length(0), t2._eval$1("ListIterator<ListBase.E>")), t3 = $async$self.$this, t2 = t2._eval$1("ListBase.E");
                        case 2:
                            // for condition
                            if (!t1.moveNext$0()) {
                                // goto after for
                                $async$goto = 3;
                                break;
                            }
                            t4 = t1.__internal$_current;
                            $async$goto = 4;
                            return A._asyncAwait((t4 == null ? t2._as(t4) : t4).accept$1(t3), $async$call$0);
                        case 4:
                            // returning from await.
                            // goto for condition
                            $async$goto = 2;
                            break;
                        case 3:
                            // after for
                            // implicit return
                            return A._asyncReturn(null, $async$completer);
                    }
                });
                return A._asyncStartSync($async$call$0, $async$completer);
            },
            $signature: 2
        };
        A._EvaluateVisitor_visitCssStyleRule_closure5.prototype = {
            call$1: function(node) {
                return node instanceof A.ModifiableCssStyleRule0;
            },
            $signature: 8
        };
        A._EvaluateVisitor_visitCssSupportsRule_closure8.prototype = {
            call$0: function() {
                var $async$goto = 0, $async$completer = A._makeAsyncAwaitCompleter(type$.Null), $async$self = this, t1, t2, t3, t4;
                var $async$call$0 = A._wrapJsFunctionForAsync(function($async$errorCode, $async$result) {
                    if ($async$errorCode === 1) return A._asyncRethrow($async$result, $async$completer);
                    for(;;)switch($async$goto){
                        case 0:
                            // Function start
                            t1 = $async$self.node.children, t2 = t1.$ti, t1 = new A.ListIterator(t1, t1.get$length(0), t2._eval$1("ListIterator<ListBase.E>")), t3 = $async$self.$this, t2 = t2._eval$1("ListBase.E");
                        case 2:
                            // for condition
                            if (!t1.moveNext$0()) {
                                // goto after for
                                $async$goto = 3;
                                break;
                            }
                            t4 = t1.__internal$_current;
                            $async$goto = 4;
                            return A._asyncAwait((t4 == null ? t2._as(t4) : t4).accept$1(t3), $async$call$0);
                        case 4:
                            // returning from await.
                            // goto for condition
                            $async$goto = 2;
                            break;
                        case 3:
                            // after for
                            // implicit return
                            return A._asyncReturn(null, $async$completer);
                    }
                });
                return A._asyncStartSync($async$call$0, $async$completer);
            },
            $signature: 2
        };
        A._EvaluateVisitor_visitCssSupportsRule_closure9.prototype = {
            call$0: function() {
                var $async$goto = 0, $async$completer = A._makeAsyncAwaitCompleter(type$.Null), $async$self = this, t2, t3, t4, t1, _0_0;
                var $async$call$0 = A._wrapJsFunctionForAsync(function($async$errorCode, $async$result) {
                    if ($async$errorCode === 1) return A._asyncRethrow($async$result, $async$completer);
                    for(;;)switch($async$goto){
                        case 0:
                            // Function start
                            t1 = $async$self.$this;
                            _0_0 = t1._async_evaluate0$_atRootExcludingStyleRule ? null : t1._async_evaluate0$_styleRuleIgnoringAtRoot;
                            $async$goto = _0_0 != null ? 2 : 4;
                            break;
                        case 2:
                            // then
                            $async$goto = 5;
                            return A._asyncAwait(t1._async_evaluate0$_withParent$2$2(A.ModifiableCssStyleRule$0(_0_0._style_rule0$_selector, _0_0.span, false, _0_0.originalSelector), new A._EvaluateVisitor_visitCssSupportsRule__closure2(t1, $async$self.node), type$.ModifiableCssStyleRule_2, type$.Null), $async$call$0);
                        case 5:
                            // returning from await.
                            // goto join
                            $async$goto = 3;
                            break;
                        case 4:
                            // else
                            t2 = $async$self.node.children, t3 = t2.$ti, t2 = new A.ListIterator(t2, t2.get$length(0), t3._eval$1("ListIterator<ListBase.E>")), t3 = t3._eval$1("ListBase.E");
                        case 6:
                            // for condition
                            if (!t2.moveNext$0()) {
                                // goto after for
                                $async$goto = 7;
                                break;
                            }
                            t4 = t2.__internal$_current;
                            $async$goto = 8;
                            return A._asyncAwait((t4 == null ? t3._as(t4) : t4).accept$1(t1), $async$call$0);
                        case 8:
                            // returning from await.
                            // goto for condition
                            $async$goto = 6;
                            break;
                        case 7:
                        // after for
                        case 3:
                            // join
                            // implicit return
                            return A._asyncReturn(null, $async$completer);
                    }
                });
                return A._asyncStartSync($async$call$0, $async$completer);
            },
            $signature: 2
        };
        A._EvaluateVisitor_visitCssSupportsRule__closure2.prototype = {
            call$0: function() {
                var $async$goto = 0, $async$completer = A._makeAsyncAwaitCompleter(type$.Null), $async$self = this, t1, t2, t3, t4;
                var $async$call$0 = A._wrapJsFunctionForAsync(function($async$errorCode, $async$result) {
                    if ($async$errorCode === 1) return A._asyncRethrow($async$result, $async$completer);
                    for(;;)switch($async$goto){
                        case 0:
                            // Function start
                            t1 = $async$self.node.children, t2 = t1.$ti, t1 = new A.ListIterator(t1, t1.get$length(0), t2._eval$1("ListIterator<ListBase.E>")), t3 = $async$self.$this, t2 = t2._eval$1("ListBase.E");
                        case 2:
                            // for condition
                            if (!t1.moveNext$0()) {
                                // goto after for
                                $async$goto = 3;
                                break;
                            }
                            t4 = t1.__internal$_current;
                            $async$goto = 4;
                            return A._asyncAwait((t4 == null ? t2._as(t4) : t4).accept$1(t3), $async$call$0);
                        case 4:
                            // returning from await.
                            // goto for condition
                            $async$goto = 2;
                            break;
                        case 3:
                            // after for
                            // implicit return
                            return A._asyncReturn(null, $async$completer);
                    }
                });
                return A._asyncStartSync($async$call$0, $async$completer);
            },
            $signature: 2
        };
        A._EvaluateVisitor_visitCssSupportsRule_closure10.prototype = {
            call$1: function(node) {
                return node instanceof A.ModifiableCssStyleRule0;
            },
            $signature: 8
        };
        A._EvaluateVisitor__performInterpolationHelper_closure2.prototype = {
            call$1: function(targetOffsets) {
                return A.InterpolationMap$0(this.interpolation, targetOffsets);
            },
            $signature: 220
        };
        A._EvaluateVisitor__serialize_closure2.prototype = {
            call$0: function() {
                return A.serializeValue0(this.value, false, this.quote);
            },
            $signature: 29
        };
        A._EvaluateVisitor__expressionNode_closure2.prototype = {
            call$0: function() {
                var t1 = this.expression;
                return this.$this._async_evaluate0$_environment.getVariableNode$2$namespace(t1.name, t1.namespace);
            },
            $signature: 221
        };
        A._EvaluateVisitor__withoutSlash_recommendation2.prototype = {
            call$1: function(number) {
                var before, after, t1, _1_0 = number.asSlash;
                $label0$0: {
                    if (type$.Record_2_nullable_Object_and_nullable_Object._is(_1_0)) {
                        before = _1_0._0;
                        after = _1_0._1;
                        t1 = "math.div(" + A.S(this.call$1(before)) + ", " + A.S(this.call$1(after)) + ")";
                        break $label0$0;
                    }
                    t1 = A.serializeValue0(number, true, true);
                    break $label0$0;
                }
                return t1;
            },
            $signature: 222
        };
        A._EvaluateVisitor__stackFrame_closure2.prototype = {
            call$1: function(url) {
                var t1 = this.$this._async_evaluate0$_importCache;
                t1 = t1 == null ? null : t1.humanize$1(url);
                return t1 == null ? url : t1;
            },
            $signature: 49
        };
        A._ImportedCssVisitor2.prototype = {
            visitCssAtRule$1: function(node) {
                var t1 = node.isChildless ? null : new A._ImportedCssVisitor_visitCssAtRule_closure2();
                this._async_evaluate0$_visitor._async_evaluate0$_addChild$2$through(node, t1);
            },
            visitCssComment$1: function(node) {
                return this._async_evaluate0$_visitor._async_evaluate0$_addChild$1(node);
            },
            visitCssDeclaration$1: function(node) {
                return this._async_evaluate0$_visitor._async_evaluate0$_addChild$1(node);
            },
            visitCssImport$1: function(node) {
                var t2, _s13_ = "_endOfImports", t1 = this._async_evaluate0$_visitor;
                if (t1._async_evaluate0$_assertInModule$2(t1._async_evaluate0$__parent, "__parent") !== t1._async_evaluate0$_assertInModule$2(t1._async_evaluate0$__root, "_root")) t1._async_evaluate0$_addChild$1(node);
                else if (t1._async_evaluate0$_assertInModule$2(t1._async_evaluate0$__endOfImports, _s13_) === J.get$length$asx(t1._async_evaluate0$_assertInModule$2(t1._async_evaluate0$__root, "_root").children._collection$_source)) {
                    t1._async_evaluate0$_addChild$1(node);
                    t1._async_evaluate0$__endOfImports = t1._async_evaluate0$_assertInModule$2(t1._async_evaluate0$__endOfImports, _s13_) + 1;
                } else {
                    t2 = t1._async_evaluate0$_outOfOrderImports;
                    (t2 == null ? t1._async_evaluate0$_outOfOrderImports = A._setArrayType([], type$.JSArray_ModifiableCssImport_2) : t2).push(node);
                }
            },
            visitCssKeyframeBlock$1: function(node) {},
            visitCssMediaRule$1: function(node) {
                var t1 = this._async_evaluate0$_visitor, mediaQueries = t1._async_evaluate0$_mediaQueries;
                t1._async_evaluate0$_addChild$2$through(node, new A._ImportedCssVisitor_visitCssMediaRule_closure2(mediaQueries == null || t1._async_evaluate0$_mergeMediaQueries$2(mediaQueries, node.queries) != null));
            },
            visitCssStyleRule$1: function(node) {
                return this._async_evaluate0$_visitor._async_evaluate0$_addChild$2$through(node, new A._ImportedCssVisitor_visitCssStyleRule_closure2());
            },
            visitCssStylesheet$1: function(node) {
                var t1, t2, t3;
                for(t1 = node.children, t2 = t1.$ti, t1 = new A.ListIterator(t1, t1.get$length(0), t2._eval$1("ListIterator<ListBase.E>")), t2 = t2._eval$1("ListBase.E"); t1.moveNext$0();){
                    t3 = t1.__internal$_current;
                    (t3 == null ? t2._as(t3) : t3).accept$1(this);
                }
            },
            visitCssSupportsRule$1: function(node) {
                return this._async_evaluate0$_visitor._async_evaluate0$_addChild$2$through(node, new A._ImportedCssVisitor_visitCssSupportsRule_closure2());
            }
        };
        A._ImportedCssVisitor_visitCssAtRule_closure2.prototype = {
            call$1: function(node) {
                return node instanceof A.ModifiableCssStyleRule0;
            },
            $signature: 8
        };
        A._ImportedCssVisitor_visitCssMediaRule_closure2.prototype = {
            call$1: function(node) {
                var t1;
                if (!(node instanceof A.ModifiableCssStyleRule0)) t1 = this.hasBeenMerged && node instanceof A.ModifiableCssMediaRule0;
                else t1 = true;
                return t1;
            },
            $signature: 8
        };
        A._ImportedCssVisitor_visitCssStyleRule_closure2.prototype = {
            call$1: function(node) {
                return node instanceof A.ModifiableCssStyleRule0;
            },
            $signature: 8
        };
        A._ImportedCssVisitor_visitCssSupportsRule_closure2.prototype = {
            call$1: function(node) {
                return node instanceof A.ModifiableCssStyleRule0;
            },
            $signature: 8
        };
        A._EvaluationContext2.prototype = {
            get$currentCallableSpan: function() {
                var _0_0 = this._async_evaluate0$_visitor._async_evaluate0$_callableNode;
                if (_0_0 != null) return _0_0.get$span(_0_0);
                throw A.wrapException(A.StateError$(string$.No_Sasc));
            },
            warn$2: function(_, message, deprecation) {
                var t1 = this._async_evaluate0$_visitor, t2 = t1._async_evaluate0$_importSpan;
                if (t2 == null) {
                    t2 = t1._async_evaluate0$_callableNode;
                    t2 = t2 == null ? null : t2.get$span(t2);
                }
                t1._async_evaluate0$_warn$3(message, t2 == null ? this._async_evaluate0$_defaultWarnNodeWithSpan.span : t2, deprecation);
            }
        };
        A.JSToDartAsyncFileImporter.prototype = {
            canonicalize$1: function(_, url) {
                return this.canonicalize$body$JSToDartAsyncFileImporter(0, url);
            },
            canonicalize$body$JSToDartAsyncFileImporter: function(_, url) {
                var $async$goto = 0, $async$completer = A._makeAsyncAwaitCompleter(type$.nullable_Uri), $async$returnValue, $async$self = this, result, t1, resultUrl;
                var $async$canonicalize$1 = A._wrapJsFunctionForAsync(function($async$errorCode, $async$result) {
                    if ($async$errorCode === 1) return A._asyncRethrow($async$result, $async$completer);
                    for(;;)switch($async$goto){
                        case 0:
                            // Function start
                            if (url.get$scheme() === "file") {
                                $async$returnValue = $.$get$FilesystemImporter_cwd0().canonicalize$1(0, url);
                                // goto return
                                $async$goto = 1;
                                break;
                            }
                            result = A.wrapJSExceptions(new A.JSToDartAsyncFileImporter_canonicalize_closure($async$self, url));
                            $async$goto = result != null && result instanceof self.Promise ? 3 : 4;
                            break;
                        case 3:
                            // then
                            $async$goto = 5;
                            return A._asyncAwait(A.promiseToFuture0(type$.Promise._as(result), type$.nullable_Object), $async$canonicalize$1);
                        case 5:
                            // returning from await.
                            result = $async$result;
                        case 4:
                            // join
                            if (result == null) {
                                $async$returnValue = null;
                                // goto return
                                $async$goto = 1;
                                break;
                            }
                            t1 = self.URL;
                            if (!(result instanceof t1)) A.jsThrow(new self.Error(string$.The_fie));
                            resultUrl = A.Uri_parse(J.toString$0$(type$.JSUrl._as(result)));
                            if (resultUrl.get$scheme() !== "file") A.jsThrow(new self.Error(string$.The_fiu + url.toString$0(0) + '".'));
                            $async$returnValue = $.$get$FilesystemImporter_cwd0().canonicalize$1(0, resultUrl);
                            // goto return
                            $async$goto = 1;
                            break;
                        case 1:
                            // return
                            return A._asyncReturn($async$returnValue, $async$completer);
                    }
                });
                return A._asyncStartSync($async$canonicalize$1, $async$completer);
            },
            load$1: function(_, url) {
                return $.$get$FilesystemImporter_cwd0().load$1(0, url);
            },
            isNonCanonicalScheme$1: function(scheme) {
                return scheme !== "file";
            }
        };
        A.JSToDartAsyncFileImporter_canonicalize_closure.prototype = {
            call$0: function() {
                return this.$this._findFileUrl.call$2(this.url.toString$0(0), A.canonicalizeContext0());
            },
            $signature: 36
        };
        A.AsyncImportCache0.prototype = {
            canonicalize$4$baseImporter$baseUrl$forImport: function(_, url, baseImporter, baseUrl, forImport) {
                return this.canonicalize$body$AsyncImportCache0(0, url, baseImporter, baseUrl, forImport);
            },
            canonicalize$body$AsyncImportCache0: function(_, url, baseImporter, baseUrl, forImport) {
                var $async$goto = 0, $async$completer = A._makeAsyncAwaitCompleter(type$.nullable_Record_3_AsyncImporter_and_Uri_and_Uri_originalUrl_2), $async$returnValue, $async$self = this, t1, resolvedUrl, key, relativeResult, t2, t3, t4, t5, t6, cacheable, i, importer, perImporterKey, t7, _1_0, _1_2_isSet, result, _1_2, _2_0, _2_1, _2_5_isSet, _2_5, _2_3, _2_3_isSet, j;
                var $async$canonicalize$4$baseImporter$baseUrl$forImport = A._wrapJsFunctionForAsync(function($async$errorCode, $async$result) {
                    if ($async$errorCode === 1) return A._asyncRethrow($async$result, $async$completer);
                    for(;;)switch($async$goto){
                        case 0:
                            // Function start
                            if (A.isBrowser()) t1 = (baseImporter == null || baseImporter instanceof A.NoOpImporter0) && $async$self._async_import_cache0$_importers.length === 0;
                            else t1 = false;
                            if (t1) throw A.wrapException(string$.Customi);
                            $async$goto = baseImporter != null && url.get$scheme() === "" ? 3 : 4;
                            break;
                        case 3:
                            // then
                            resolvedUrl = baseUrl == null ? null : baseUrl.resolveUri$1(url);
                            if (resolvedUrl == null) resolvedUrl = url;
                            key = new A._Record_3_forImport(baseImporter, resolvedUrl, forImport);
                            $async$goto = 5;
                            return A._asyncAwait(A.putIfAbsentAsync0($async$self._async_import_cache0$_perImporterCanonicalizeCache, key, new A.AsyncImportCache_canonicalize_closure0($async$self, baseImporter, resolvedUrl, baseUrl, forImport, key, url), type$.Record_3_AsyncImporter_and_Uri_and_bool_forImport_2, type$.nullable_Record_3_AsyncImporter_and_Uri_and_Uri_originalUrl_2), $async$canonicalize$4$baseImporter$baseUrl$forImport);
                        case 5:
                            // returning from await.
                            relativeResult = $async$result;
                            if (relativeResult != null) {
                                $async$returnValue = relativeResult;
                                // goto return
                                $async$goto = 1;
                                break;
                            }
                        case 4:
                            // join
                            key = new A._Record_2_forImport(url, forImport);
                            t1 = $async$self._async_import_cache0$_canonicalizeCache;
                            if (t1.containsKey$1(key)) {
                                $async$returnValue = t1.$index(0, key);
                                // goto return
                                $async$goto = 1;
                                break;
                            }
                            t2 = $async$self._async_import_cache0$_importers, t3 = type$.Record_1_nullable_Object, t4 = $async$self._async_import_cache0$_perImporterCanonicalizeCache, t5 = type$.nullable_Record_3_AsyncImporter_and_Uri_and_Uri_originalUrl_2, t6 = type$.Record_3_AsyncImporter_and_Uri_and_Uri_originalUrl_2, cacheable = true, i = 0;
                        case 6:
                            // for condition
                            if (!(i < t2.length)) {
                                // goto after for
                                $async$goto = 8;
                                break;
                            }
                            importer = t2[i];
                            perImporterKey = new A._Record_3_forImport(importer, url, forImport);
                            if (t4.containsKey$1(perImporterKey)) {
                                t7 = t4.$index(0, perImporterKey);
                                _1_0 = new A._Record_1(t7 == null ? t5._as(t7) : t7);
                            } else _1_0 = null;
                            _1_2_isSet = t3._is(_1_0);
                            result = null;
                            if (_1_2_isSet) {
                                _1_2 = _1_0._0;
                                t7 = _1_2 != null;
                                if (t7) {
                                    t6._as(_1_2);
                                    result = _1_2;
                                }
                            } else {
                                _1_2 = null;
                                t7 = false;
                            }
                            if (t7) {
                                $async$returnValue = result;
                                // goto return
                                $async$goto = 1;
                                break;
                            }
                            if (_1_2_isSet) t7 = _1_2 == null;
                            else t7 = false;
                            if (t7) {
                                // goto for update
                                $async$goto = 7;
                                break;
                            }
                            $async$goto = 10;
                            return A._asyncAwait($async$self._async_import_cache0$_canonicalize$4(importer, url, baseUrl, forImport), $async$canonicalize$4$baseImporter$baseUrl$forImport);
                        case 10:
                            // returning from await.
                            _2_0 = $async$result;
                            _2_1 = _2_0._0;
                            _2_5_isSet = _2_1 != null;
                            _2_5 = null;
                            _2_3 = null;
                            t7 = false;
                            if (_2_5_isSet) {
                                result = _2_1 == null ? t6._as(_2_1) : _2_1;
                                _2_3 = _2_0._1;
                                t7 = _2_3;
                                _2_5 = t7;
                                t7 = t7 && cacheable;
                            } else result = null;
                            if (t7) {
                                t1.$indexSet(0, key, result);
                                $async$returnValue = result;
                                // goto return
                                $async$goto = 1;
                                break;
                            }
                            if (_2_5_isSet) {
                                t7 = _2_5;
                                _2_3_isSet = _2_5_isSet;
                            } else {
                                _2_3 = _2_0._1;
                                t7 = _2_3;
                                _2_3_isSet = true;
                            }
                            t7 = t7 && !cacheable;
                            if (t7) {
                                t4.$indexSet(0, perImporterKey, _2_1);
                                if (_2_1 != null) {
                                    $async$returnValue = _2_1;
                                    // goto return
                                    $async$goto = 1;
                                    break;
                                }
                                // goto break $label0$1
                                $async$goto = 9;
                                break;
                            }
                            t7 = false === (_2_3_isSet ? _2_3 : _2_0._1);
                            if (t7) {
                                if (cacheable) {
                                    for(j = 0; j < i; ++j)t4.$indexSet(0, new A._Record_3_forImport(t2[j], url, forImport), null);
                                    cacheable = false;
                                }
                                if (_2_1 != null) {
                                    $async$returnValue = _2_1;
                                    // goto return
                                    $async$goto = 1;
                                    break;
                                }
                            }
                        case 9:
                        // break $label0$1
                        case 7:
                            // for update
                            ++i;
                            // goto for condition
                            $async$goto = 6;
                            break;
                        case 8:
                            // after for
                            if (cacheable) t1.$indexSet(0, key, null);
                            $async$returnValue = null;
                            // goto return
                            $async$goto = 1;
                            break;
                        case 1:
                            // return
                            return A._asyncReturn($async$returnValue, $async$completer);
                    }
                });
                return A._asyncStartSync($async$canonicalize$4$baseImporter$baseUrl$forImport, $async$completer);
            },
            _async_import_cache0$_canonicalize$4: function(importer, url, baseUrl, forImport) {
                return this._canonicalize$body$AsyncImportCache0(importer, url, baseUrl, forImport);
            },
            _canonicalize$body$AsyncImportCache0: function(importer, url, baseUrl, forImport) {
                var $async$goto = 0, $async$completer = A._makeAsyncAwaitCompleter(type$.Record_2_nullable_Record_3_AsyncImporter_and_Uri_and_Uri_originalUrl_and_bool_2), $async$returnValue, t1, passContainingUrl, canonicalizeContext, result, cacheable;
                var $async$_async_import_cache0$_canonicalize$4 = A._wrapJsFunctionForAsync(function($async$errorCode, $async$result) {
                    if ($async$errorCode === 1) return A._asyncRethrow($async$result, $async$completer);
                    for(;;)switch($async$goto){
                        case 0:
                            // Function start
                            $async$goto = baseUrl != null ? 3 : 5;
                            break;
                        case 3:
                            // then
                            $async$goto = url.get$scheme() !== "" ? 6 : 8;
                            break;
                        case 6:
                            // then
                            t1 = A._Future$value(importer.isNonCanonicalScheme$1(url.get$scheme()), type$.bool);
                            $async$goto = 9;
                            return A._asyncAwait(t1, $async$_async_import_cache0$_canonicalize$4);
                        case 9:
                            // returning from await.
                            t1 = $async$result;
                            passContainingUrl = t1;
                            // goto join
                            $async$goto = 7;
                            break;
                        case 8:
                            // else
                            passContainingUrl = true;
                        case 7:
                            // join
                            // goto join
                            $async$goto = 4;
                            break;
                        case 5:
                            // else
                            passContainingUrl = false;
                        case 4:
                            // join
                            canonicalizeContext = new A.CanonicalizeContext0(forImport, passContainingUrl ? baseUrl : null);
                            t1 = type$.nullable_Object;
                            t1 = A.runZoned(new A.AsyncImportCache__canonicalize_closure0(importer, url), A.LinkedHashMap_LinkedHashMap$_literal([
                                B.Symbol__canonicalizeContext,
                                canonicalizeContext
                            ], t1, t1), type$.FutureOr_nullable_Uri);
                            $async$goto = 10;
                            return A._asyncAwait(type$.Future_nullable_Uri._is(t1) ? t1 : A._Future$value(t1, type$.nullable_Uri), $async$_async_import_cache0$_canonicalize$4);
                        case 10:
                            // returning from await.
                            result = $async$result;
                            cacheable = !passContainingUrl || !canonicalizeContext._canonicalize_context$_wasContainingUrlAccessed;
                            if (result == null) {
                                $async$returnValue = new A._Record_2(null, cacheable);
                                // goto return
                                $async$goto = 1;
                                break;
                            }
                            $async$goto = result.get$scheme() !== "" ? 11 : 13;
                            break;
                        case 11:
                            // then
                            t1 = A._Future$value(importer.isNonCanonicalScheme$1(result.get$scheme()), type$.bool);
                            $async$goto = 14;
                            return A._asyncAwait(t1, $async$_async_import_cache0$_canonicalize$4);
                        case 14:
                            // returning from await.
                            t1 = $async$result;
                            // goto join
                            $async$goto = 12;
                            break;
                        case 13:
                            // else
                            t1 = false;
                        case 12:
                            // join
                            if (t1) throw A.wrapException("Importer " + importer.toString$0(0) + " canonicalized " + url.toString$0(0) + " to " + result.toString$0(0) + string$.x2c_whicu);
                            $async$returnValue = new A._Record_2(new A._Record_3_originalUrl(importer, result, url), cacheable);
                            // goto return
                            $async$goto = 1;
                            break;
                        case 1:
                            // return
                            return A._asyncReturn($async$returnValue, $async$completer);
                    }
                });
                return A._asyncStartSync($async$_async_import_cache0$_canonicalize$4, $async$completer);
            },
            importCanonical$3$originalUrl: function(importer, canonicalUrl, originalUrl) {
                return this.importCanonical$body$AsyncImportCache0(importer, canonicalUrl, originalUrl);
            },
            importCanonical$body$AsyncImportCache0: function(importer, canonicalUrl, originalUrl) {
                var $async$goto = 0, $async$completer = A._makeAsyncAwaitCompleter(type$.nullable_Stylesheet_2), $async$returnValue, $async$self = this;
                var $async$importCanonical$3$originalUrl = A._wrapJsFunctionForAsync(function($async$errorCode, $async$result) {
                    if ($async$errorCode === 1) return A._asyncRethrow($async$result, $async$completer);
                    for(;;)switch($async$goto){
                        case 0:
                            // Function start
                            $async$goto = 3;
                            return A._asyncAwait(A.putIfAbsentAsync0($async$self._async_import_cache0$_importCache, canonicalUrl, new A.AsyncImportCache_importCanonical_closure0($async$self, importer, canonicalUrl, originalUrl), type$.Uri, type$.nullable_Stylesheet_2), $async$importCanonical$3$originalUrl);
                        case 3:
                            // returning from await.
                            $async$returnValue = $async$result;
                            // goto return
                            $async$goto = 1;
                            break;
                        case 1:
                            // return
                            return A._asyncReturn($async$returnValue, $async$completer);
                    }
                });
                return A._asyncStartSync($async$importCanonical$3$originalUrl, $async$completer);
            },
            humanize$1: function(canonicalUrl) {
                var t1 = this._async_import_cache0$_canonicalizeCache, t2 = type$.NonNullsIterable_Record_3_AsyncImporter_and_Uri_and_Uri_originalUrl_2;
                t2 = A.NullableExtension_andThen0(A.minBy(new A.MappedIterable(new A.WhereIterable(new A.NonNullsIterable(new A.LinkedHashMapValuesIterable(t1, A._instanceType(t1)._eval$1("LinkedHashMapValuesIterable<2>")), t2), new A.AsyncImportCache_humanize_closure3(canonicalUrl), t2._eval$1("WhereIterable<Iterable.E>")), new A.AsyncImportCache_humanize_closure4(), t2._eval$1("MappedIterable<Iterable.E,Uri>")), new A.AsyncImportCache_humanize_closure5()), new A.AsyncImportCache_humanize_closure6(canonicalUrl));
                return t2 == null ? canonicalUrl : t2;
            },
            sourceMapUrl$1: function(_, canonicalUrl) {
                var t1 = this._async_import_cache0$_resultsCache.$index(0, canonicalUrl);
                t1 = t1 == null ? null : t1.get$sourceMapUrl(0);
                return t1 == null ? canonicalUrl : t1;
            }
        };
        A.AsyncImportCache_canonicalize_closure0.prototype = {
            call$0: function() {
                var $async$goto = 0, $async$completer = A._makeAsyncAwaitCompleter(type$.nullable_Record_3_AsyncImporter_and_Uri_and_Uri_originalUrl_2), $async$returnValue, $async$self = this, t1, t2, _0_0, result;
                var $async$call$0 = A._wrapJsFunctionForAsync(function($async$errorCode, $async$result) {
                    if ($async$errorCode === 1) return A._asyncRethrow($async$result, $async$completer);
                    for(;;)switch($async$goto){
                        case 0:
                            // Function start
                            t1 = $async$self.$this;
                            t2 = $async$self.baseUrl;
                            $async$goto = 3;
                            return A._asyncAwait(t1._async_import_cache0$_canonicalize$4($async$self.baseImporter, $async$self.resolvedUrl, t2, $async$self.forImport), $async$call$0);
                        case 3:
                            // returning from await.
                            _0_0 = $async$result;
                            result = _0_0._0;
                            _0_0._1;
                            if (t2 != null) t1._async_import_cache0$_nonCanonicalRelativeUrls.$indexSet(0, $async$self.key, $async$self.url);
                            $async$returnValue = result;
                            // goto return
                            $async$goto = 1;
                            break;
                        case 1:
                            // return
                            return A._asyncReturn($async$returnValue, $async$completer);
                    }
                });
                return A._asyncStartSync($async$call$0, $async$completer);
            },
            $signature: 368
        };
        A.AsyncImportCache__canonicalize_closure0.prototype = {
            call$0: function() {
                return this.importer.canonicalize$1(0, this.url);
            },
            $signature: 182
        };
        A.AsyncImportCache_importCanonical_closure0.prototype = {
            call$0: function() {
                var $async$goto = 0, $async$completer = A._makeAsyncAwaitCompleter(type$.nullable_Stylesheet_2), $async$returnValue, $async$self = this, t1, t2, t3, result;
                var $async$call$0 = A._wrapJsFunctionForAsync(function($async$errorCode, $async$result) {
                    if ($async$errorCode === 1) return A._asyncRethrow($async$result, $async$completer);
                    for(;;)switch($async$goto){
                        case 0:
                            // Function start
                            t1 = Date.now();
                            t2 = $async$self.canonicalUrl;
                            t3 = $async$self.importer.load$1(0, t2);
                            $async$goto = 3;
                            return A._asyncAwait(type$.Future_nullable_ImporterResult._is(t3) ? t3 : A._Future$value(t3, type$.nullable_ImporterResult_2), $async$call$0);
                        case 3:
                            // returning from await.
                            result = $async$result;
                            if (result == null) {
                                $async$returnValue = null;
                                // goto return
                                $async$goto = 1;
                                break;
                            }
                            t3 = $async$self.$this;
                            t3._async_import_cache0$_loadTimes.$indexSet(0, t2, new A.DateTime(t1, 0, false));
                            t3._async_import_cache0$_resultsCache.$indexSet(0, t2, result);
                            t3 = result.contents;
                            t1 = result.syntax;
                            t2 = $async$self.originalUrl.resolveUri$1(t2);
                            $async$returnValue = A.Stylesheet_Stylesheet$parse0(t3, t1, false, t2);
                            // goto return
                            $async$goto = 1;
                            break;
                        case 1:
                            // return
                            return A._asyncReturn($async$returnValue, $async$completer);
                    }
                });
                return A._asyncStartSync($async$call$0, $async$completer);
            },
            $signature: 369
        };
        A.AsyncImportCache_humanize_closure3.prototype = {
            call$1: function(result) {
                return result._1.$eq(0, this.canonicalUrl);
            },
            $signature: 370
        };
        A.AsyncImportCache_humanize_closure4.prototype = {
            call$1: function(result) {
                return result._2;
            },
            $signature: 371
        };
        A.AsyncImportCache_humanize_closure5.prototype = {
            call$1: function(url) {
                return url.get$path(url).length;
            },
            $signature: 107
        };
        A.AsyncImportCache_humanize_closure6.prototype = {
            call$1: function(url) {
                var t1 = $.$get$url(), t2 = this.canonicalUrl;
                return url.resolve$1(0, A.ParsedPath_ParsedPath$parse(t2.get$path(t2), t1.style).get$basename());
            },
            $signature: 49
        };
        A.AtRootQueryParser0.prototype = {
            parse$0: function(_) {
                return this.wrapSpanFormatException$1(new A.AtRootQueryParser_parse_closure0(this));
            }
        };
        A.AtRootQueryParser_parse_closure0.prototype = {
            call$0: function() {
                var include, atRules, t1 = this.$this, t2 = t1.scanner;
                t2.expectChar$1(40);
                t1.whitespace$1$consumeNewlines(true);
                include = t1.scanIdentifier$1("with");
                if (!include) t1.expectIdentifier$2$name("without", '"with" or "without"');
                t1.whitespace$1$consumeNewlines(true);
                t2.expectChar$1(58);
                t1.whitespace$1$consumeNewlines(true);
                atRules = A.LinkedHashSet_LinkedHashSet$_empty(type$.String);
                do {
                    atRules.add$1(0, t1.identifier$0().toLowerCase());
                    t1.whitespace$1$consumeNewlines(true);
                }while (t1.lookingAtIdentifier$0());
                t2.expectChar$1(41);
                t2.expectDone$0();
                return new A.AtRootQuery0(include, atRules, atRules.contains$1(0, "all"), atRules.contains$1(0, "rule"));
            },
            $signature: 372
        };
        A.AtRootQuery0.prototype = {
            excludes$1: function(node) {
                var t1, _this = this;
                if (_this._at_root_query0$_all) return !_this.include;
                $label0$0: {
                    if (node instanceof A.ModifiableCssStyleRule0) {
                        t1 = _this._at_root_query0$_rule !== _this.include;
                        break $label0$0;
                    }
                    if (node instanceof A.ModifiableCssMediaRule0) {
                        t1 = _this.excludesName$1("media");
                        break $label0$0;
                    }
                    if (node instanceof A.ModifiableCssSupportsRule0) {
                        t1 = _this.excludesName$1("supports");
                        break $label0$0;
                    }
                    if (node instanceof A.ModifiableCssAtRule0) {
                        t1 = _this.excludesName$1(node.name.value.toLowerCase());
                        break $label0$0;
                    }
                    t1 = false;
                    break $label0$0;
                }
                return t1;
            },
            excludesName$1: function($name) {
                var t1 = this._at_root_query0$_all || this.names.contains$1(0, $name);
                return t1 !== this.include;
            }
        };
        A.AtRootRule0.prototype = {
            accept$1$1: function(visitor) {
                return visitor.visitAtRootRule$1(0, this);
            },
            accept$1: function(visitor) {
                return this.accept$1$1(visitor, type$.dynamic);
            },
            toString$0: function(_) {
                var buffer = new A.StringBuffer("@at-root "), t1 = this.query;
                if (t1 != null) buffer._contents = "@at-root " + (t1.toString$0(0) + " ");
                return buffer.toString$0(0) + " {" + B.JSArray_methods.join$1(this.children, " ") + "}";
            },
            get$span: function(receiver) {
                return this.span;
            }
        };
        A.ModifiableCssAtRule0.prototype = {
            accept$1$1: function(visitor) {
                return visitor.visitCssAtRule$1(this);
            },
            accept$1: function(visitor) {
                return this.accept$1$1(visitor, type$.dynamic);
            },
            equalsIgnoringChildren$1: function(other) {
                var t1, t2;
                if (other instanceof A.ModifiableCssAtRule0) {
                    t1 = this.name;
                    t2 = other.name;
                    t1 = t1.$ti._is(t2) && J.$eq$(t2.value, t1.value) && J.$eq$(this.value, other.value) && this.isChildless === other.isChildless;
                } else t1 = false;
                return t1;
            },
            copyWithoutChildren$0: function() {
                var _this = this;
                return A.ModifiableCssAtRule$0(_this.name, _this.span, _this.isChildless, _this.value);
            },
            addChild$1: function(child) {
                this.super$ModifiableCssParentNode$addChild0(child);
            },
            get$isChildless: function() {
                return this.isChildless;
            },
            get$span: function(receiver) {
                return this.span;
            }
        };
        A.AtRule0.prototype = {
            accept$1$1: function(visitor) {
                return visitor.visitAtRule$1(0, this);
            },
            accept$1: function(visitor) {
                return this.accept$1$1(visitor, type$.dynamic);
            },
            toString$0: function(_) {
                var children, t1 = "@" + this.name.toString$0(0), buffer = new A.StringBuffer(t1), t2 = this.value;
                if (t2 != null) buffer._contents = t1 + (" " + t2.toString$0(0));
                children = this.children;
                return children == null ? buffer.toString$0(0) + ";" : buffer.toString$0(0) + " {" + B.JSArray_methods.join$1(children, " ") + "}";
            },
            get$span: function(receiver) {
                return this.span;
            }
        };
        A.InterpolatedAttributeSelector.prototype = {
            accept$1$1: function(visitor) {
                return J.visitAttributeSelector$1$x(visitor._simple_selector$_inner, this);
            },
            accept$1: function(visitor) {
                return this.accept$1$1(visitor, type$.dynamic);
            },
            toString$0: function(_) {
                var _this = this, result = "[" + _this.name.toString$0(0), t1 = _this.op;
                if (t1 != null) {
                    result += t1.toString$0(0) + A.S(_this.value);
                    t1 = _this.modifier;
                    if (t1 != null) result += " " + t1.toString$0(0);
                }
                return result;
            },
            get$span: function(receiver) {
                return this.span;
            }
        };
        A.AttributeSelector0.prototype = {
            accept$1$1: function(visitor) {
                return visitor.visitAttributeSelector$1(0, this);
            },
            accept$1: function(visitor) {
                return this.accept$1$1(visitor, type$.dynamic);
            },
            $eq: function(_, other) {
                var _this = this;
                if (other == null) return false;
                return other instanceof A.AttributeSelector0 && other.name.$eq(0, _this.name) && other.op == _this.op && other.value == _this.value && other.modifier == _this.modifier;
            },
            get$hashCode: function(_) {
                var _this = this, t1 = _this.name;
                return (B.JSString_methods.get$hashCode(t1.name) ^ J.get$hashCode$(t1.namespace) ^ J.get$hashCode$(_this.op) ^ J.get$hashCode$(_this.value) ^ J.get$hashCode$(_this.modifier)) >>> 0;
            }
        };
        A.AttributeOperator0.prototype = {
            _enumToString$0: function() {
                return "AttributeOperator." + this._name;
            },
            toString$0: function(_) {
                return this._attribute0$_text;
            }
        };
        A.BinaryOperationExpression0.prototype = {
            get$span: function(_) {
                var right, left = this.left;
                while(left instanceof A.BinaryOperationExpression0)left = left.left;
                right = this.right;
                while(right instanceof A.BinaryOperationExpression0)right = right.right;
                return left.get$span(left).expand$1(0, right.get$span(right));
            },
            get$operatorSpan: function() {
                var t3, t4, t1 = this.left, t2 = t1.get$span(t1);
                t2 = t2.get$file(t2);
                t3 = this.right;
                t4 = t3.get$span(t3);
                if (t2 === t4.get$file(t4)) {
                    t2 = t1.get$span(t1);
                    t2 = t2.get$end(t2);
                    t4 = t3.get$span(t3);
                    t4 = t2.offset < t4.get$start(t4).offset;
                    t2 = t4;
                } else t2 = false;
                if (t2) {
                    t2 = t1.get$span(t1);
                    t2 = t2.get$file(t2);
                    t1 = t1.get$span(t1);
                    t1 = t1.get$end(t1);
                    t3 = t3.get$span(t3);
                    t3 = A.SpanExtensions_trimRight0(A.SpanExtensions_trimLeft0(t2.span$2(0, t1.offset, t3.get$start(t3).offset)));
                    t1 = t3;
                } else t1 = this.get$span(0);
                return t1;
            },
            accept$1$1: function(visitor) {
                return visitor.visitBinaryOperationExpression$1(0, this);
            },
            accept$1: function(visitor) {
                return this.accept$1$1(visitor, type$.dynamic);
            },
            toString$0: function(_) {
                var t1, t2, t3, right, operator, _this = this, _0_0 = _this.left;
                $label0$0: {
                    if (_0_0 instanceof A.BinaryOperationExpression0) {
                        t1 = _0_0.operator.precedence < _this.operator.precedence;
                        break $label0$0;
                    }
                    if (_0_0 instanceof A.ListExpression0 && !_0_0.hasBrackets && _0_0.contents.length >= 2) {
                        t1 = true;
                        break $label0$0;
                    }
                    t1 = false;
                    break $label0$0;
                }
                t2 = t1 ? A.Primitives_stringFromCharCode(40) : "";
                t2 += _0_0.toString$0(0);
                t1 = t1 ? t2 + A.Primitives_stringFromCharCode(41) : t2;
                t2 = A.Primitives_stringFromCharCode(32);
                t3 = _this.operator;
                t2 = t1 + t2 + t3.operator + t2;
                right = _this.right;
                $label1$1: {
                    t1 = false;
                    if (right instanceof A.BinaryOperationExpression0) {
                        operator = right.operator;
                        if (operator.precedence <= t3.precedence) t1 = !(operator === t3 && operator.isAssociative);
                        break $label1$1;
                    }
                    if (right instanceof A.ListExpression0 && !right.hasBrackets && right.contents.length >= 2) {
                        t1 = true;
                        break $label1$1;
                    }
                    break $label1$1;
                }
                if (t1) t2 += A.Primitives_stringFromCharCode(40);
                t2 += right.toString$0(0);
                t1 = t1 ? t2 + A.Primitives_stringFromCharCode(41) : t2;
                return t1.charCodeAt(0) == 0 ? t1 : t1;
            }
        };
        A.BinaryOperator0.prototype = {
            _enumToString$0: function() {
                return "BinaryOperator." + this._name;
            },
            toString$0: function(_) {
                return this.name;
            }
        };
        A.BooleanExpression0.prototype = {
            accept$1$1: function(visitor) {
                return visitor.visitBooleanExpression$1(0, this);
            },
            accept$1: function(visitor) {
                return this.accept$1$1(visitor, type$.dynamic);
            },
            toString$0: function(_) {
                return String(this.value);
            },
            get$span: function(receiver) {
                return this.span;
            }
        };
        A.booleanClass_closure.prototype = {
            call$0: function() {
                var t1 = type$.JSClass, jsClass = t1._as(A.allowInteropCaptureThisNamed("sass.SassBoolean", new A.booleanClass__closure()));
                A.JSClassExtension_injectSuperclass(t1._as(B.SassBoolean_true0.constructor), jsClass);
                return jsClass;
            },
            $signature: 17
        };
        A.booleanClass__closure.prototype = {
            call$2: function($self, _) {
                A.jsThrow(new self.Error("new sass.SassBoolean() isn't allowed.\nUse sass.sassTrue or sass.sassFalse instead."));
            },
            call$1: function($self) {
                return this.call$2($self, null);
            },
            "call*": "call$2",
            $requiredArgCount: 1,
            $defaultValues: function() {
                return [
                    null
                ];
            },
            $signature: 223
        };
        A.legacyBooleanClass_closure.prototype = {
            call$0: function() {
                var t1 = type$.JSClass, jsClass = t1._as(A.allowInteropCaptureThisNamed("sass.types.Boolean", new A.legacyBooleanClass__closure()));
                J.get$$prototype$x(jsClass).getValue = A.allowInteropCaptureThisNamed("getValue", new A.legacyBooleanClass__closure0());
                jsClass.TRUE = B.SassBoolean_true0;
                jsClass.FALSE = B.SassBoolean_false0;
                A.JSClassExtension_injectSuperclass(t1._as(B.SassBoolean_true0.constructor), jsClass);
                return jsClass;
            },
            $signature: 17
        };
        A.legacyBooleanClass__closure.prototype = {
            call$2: function(_, __) {
                throw A.wrapException("new sass.types.Boolean() isn't allowed.\nUse sass.types.Boolean.TRUE or sass.types.Boolean.FALSE instead.");
            },
            call$1: function(_) {
                return this.call$2(_, null);
            },
            "call*": "call$2",
            $requiredArgCount: 1,
            $defaultValues: function() {
                return [
                    null
                ];
            },
            $signature: 224
        };
        A.legacyBooleanClass__closure0.prototype = {
            call$1: function($self) {
                return $self === B.SassBoolean_true0;
            },
            $signature: 73
        };
        A.SassBoolean0.prototype = {
            get$isTruthy: function() {
                return this.value;
            },
            accept$1$1: function(visitor) {
                return visitor._serialize0$_buffer.write$1(0, String(this.value));
            },
            accept$1: function(visitor) {
                return this.accept$1$1(visitor, type$.dynamic);
            },
            assertBoolean$1: function($name) {
                return this;
            },
            unaryNot$0: function() {
                return this.value ? B.SassBoolean_false0 : B.SassBoolean_true0;
            }
        };
        A.BooleanOperator0.prototype = {
            _enumToString$0: function() {
                return "BooleanOperator." + this._name;
            },
            toString$0: function(_) {
                return this._name;
            }
        };
        A.Box0.prototype = {
            $eq: function(_, other) {
                if (other == null) return false;
                return this.$ti._is(other) && other._box0$_inner === this._box0$_inner;
            },
            get$hashCode: function(_) {
                return A.Primitives_objectHashCode(this._box0$_inner);
            },
            toString$0: function(_) {
                return "<box: " + this._box0$_inner.value.toString$0(0) + ">";
            }
        };
        A.ModifiableBox0.prototype = {
            toString$0: function(_) {
                return "<modifiable box: " + this.value.toString$0(0) + ">";
            }
        };
        A.BuiltInCallable0.prototype = {
            callbackFor$2: function(positional, names) {
                var t1, t2, fuzzyMatch, minMismatchDistance, _i, overload, t3, mismatchDistance, t4;
                for(t1 = this._built_in$_overloads, t2 = t1.length, fuzzyMatch = null, minMismatchDistance = null, _i = 0; _i < t1.length; t1.length === t2 || (0, A.throwConcurrentModificationError)(t1), ++_i){
                    overload = t1[_i];
                    t3 = overload._0;
                    if (t3.matches$2(positional, names)) return overload;
                    mismatchDistance = t3.parameters.length - positional;
                    if (minMismatchDistance != null) {
                        t3 = Math.abs(mismatchDistance);
                        t4 = Math.abs(minMismatchDistance);
                        if (t3 > t4) continue;
                        if (t3 === t4 && mismatchDistance < 0) continue;
                    }
                    minMismatchDistance = mismatchDistance;
                    fuzzyMatch = overload;
                }
                if (fuzzyMatch != null) return fuzzyMatch;
                throw A.wrapException(A.StateError$("BuiltInCallable " + this.name + " may not have empty overloads."));
            },
            withName$1: function($name) {
                return new A.BuiltInCallable0($name, this._built_in$_overloads, this.acceptsContent);
            },
            withDeprecationWarning$2: function(module, newName) {
                var t2, t3, _i, t4, t5, _this = this, t1 = A._setArrayType([], type$.JSArray_Record_2_ParameterList_and_Value_Function_List_Value_2);
                for(t2 = _this._built_in$_overloads, t3 = t2.length, _i = 0; _i < t2.length; t2.length === t3 || (0, A.throwConcurrentModificationError)(t2), ++_i){
                    t4 = {};
                    t5 = t2[_i];
                    t4.$function = null;
                    t4.$function = t5._1;
                    t1.push(new A._Record_2(t5._0, new A.BuiltInCallable_withDeprecationWarning_closure0(t4, _this, module, newName)));
                }
                return new A.BuiltInCallable0(_this.name, t1, _this.acceptsContent);
            },
            withDeprecationWarning$1: function(module) {
                return this.withDeprecationWarning$2(module, null);
            },
            $isAsyncCallable0: 1,
            $isAsyncBuiltInCallable0: 1,
            $isCallable: 1,
            get$name: function(receiver) {
                return this.name;
            },
            get$acceptsContent: function() {
                return this.acceptsContent;
            }
        };
        A.BuiltInCallable$mixin_closure0.prototype = {
            call$1: function($arguments) {
                this.callback.call$1($arguments);
                return B.C__SassNull0;
            },
            $signature: 3
        };
        A.BuiltInCallable_withDeprecationWarning_closure0.prototype = {
            call$1: function(args) {
                var _this = this, t1 = _this.newName;
                if (t1 == null) t1 = _this.$this.name;
                A.warnForDeprecation0(string$.Global + _this.module + "." + t1 + string$.x20inste, B.Deprecation_SGB);
                return _this._box_0.$function.call$1(args);
            },
            $signature: 3
        };
        A.BuiltInModule0.prototype = {
            get$upstream: function() {
                return B.List_empty22;
            },
            get$variableNodes: function() {
                return B.Map_empty13;
            },
            get$extensionStore: function() {
                return B.C_EmptyExtensionStore0;
            },
            get$css: function(_) {
                return new A.CssStylesheet0(B.List_empty20, A.SourceFile$decoded(B.List_empty4, this.url).span$2(0, 0, 0));
            },
            get$preModuleComments: function() {
                return B.Map_empty12;
            },
            get$transitivelyContainsCss: function() {
                return false;
            },
            get$transitivelyContainsExtensions: function() {
                return false;
            },
            setVariable$3: function($name, value, nodeWithSpan) {
                if (!this.variables.containsKey$1($name)) throw A.wrapException(A.SassScriptException$0("Undefined variable.", null));
                throw A.wrapException(A.SassScriptException$0("Cannot modify built-in variable.", null));
            },
            variableIdentity$1: function($name) {
                return this;
            },
            couldHaveBeenConfigured$1: function(_) {
                return false;
            },
            cloneCss$0: function() {
                return this;
            },
            $isModule1: 1,
            get$url: function(receiver) {
                return this.url;
            },
            get$functions: function(receiver) {
                return this.functions;
            },
            get$mixins: function() {
                return this.mixins;
            },
            get$variables: function() {
                return this.variables;
            }
        };
        A.calculationClass_closure.prototype = {
            call$0: function() {
                var t1 = type$.JSClass, jsClass = t1._as(A.allowInteropCaptureThisNamed("sass.SassCalculation", new A.calculationClass__closure())), t2 = type$.String, t3 = type$.Function;
                A.LinkedHashMap_LinkedHashMap$_literal([
                    "calc",
                    new A.calculationClass__closure0(),
                    "min",
                    new A.calculationClass__closure1(),
                    "max",
                    new A.calculationClass__closure2(),
                    "clamp",
                    new A.calculationClass__closure3()
                ], t2, t3).forEach$1(0, A.JSClassExtension_get_defineStaticMethod(jsClass));
                A.LinkedHashMap_LinkedHashMap$_literal([
                    "assertCalculation",
                    new A.calculationClass__closure4()
                ], t2, t3).forEach$1(0, A.JSClassExtension_get_defineMethod(jsClass));
                A.LinkedHashMap_LinkedHashMap$_literal([
                    "arguments",
                    new A.calculationClass__closure5()
                ], t2, t3).forEach$1(0, A.JSClassExtension_get_defineGetter(jsClass));
                A.JSClassExtension_injectSuperclass(t1._as(new A.SassCalculation0("calc", A.List_List$unmodifiable(A._setArrayType([
                    A.SassNumber_SassNumber0(1, null)
                ], type$.JSArray_Object), type$.Object)).constructor), jsClass);
                return jsClass;
            },
            $signature: 17
        };
        A.calculationClass__closure.prototype = {
            call$2: function($self, _) {
                A.jsThrow0(new self.Error("new sass.SassCalculation() isn't allowed"));
            },
            call$1: function($self) {
                return this.call$2($self, null);
            },
            "call*": "call$2",
            $requiredArgCount: 1,
            $defaultValues: function() {
                return [
                    null
                ];
            },
            $signature: 223
        };
        A.calculationClass__closure0.prototype = {
            call$1: function(argument) {
                A._assertCalculationValue(argument);
                return new A.SassCalculation0("calc", A.List_List$unmodifiable(A._setArrayType([
                    argument
                ], type$.JSArray_Object), type$.Object));
            },
            $signature: 119
        };
        A.calculationClass__closure1.prototype = {
            call$1: function($arguments) {
                var t1 = self.immutable.isOrderedMap($arguments) ? J.toArray$0$x(type$.ImmutableList_2._as($arguments)) : type$.List_dynamic._as($arguments), t2 = type$.Object, argList = J.cast$1$0$ax(t1, t2);
                argList.forEach$1(argList, A.calculation1___assertCalculationValue$closure());
                return new A.SassCalculation0("min", A.List_List$unmodifiable(argList, t2));
            },
            $signature: 119
        };
        A.calculationClass__closure2.prototype = {
            call$1: function($arguments) {
                var t1 = self.immutable.isOrderedMap($arguments) ? J.toArray$0$x(type$.ImmutableList_2._as($arguments)) : type$.List_dynamic._as($arguments), t2 = type$.Object, argList = J.cast$1$0$ax(t1, t2);
                argList.forEach$1(argList, A.calculation1___assertCalculationValue$closure());
                return new A.SassCalculation0("max", A.List_List$unmodifiable(argList, t2));
            },
            $signature: 119
        };
        A.calculationClass__closure3.prototype = {
            call$3: function(min, value, max) {
                var t1;
                if (!(value == null && !A._isValidClampArg(min))) t1 = max == null && !B.JSArray_methods.any$1([
                    min,
                    value
                ], A.calculation1___isValidClampArg$closure());
                else t1 = true;
                if (t1) A.jsThrow0(new self.Error("Expected at least one SassString or CalculationInterpolation in `" + new A.NonNullsIterable([
                    min,
                    value,
                    max
                ], type$.NonNullsIterable_Object).toString$0(0) + "`"));
                t1 = type$.NonNullsIterable_Object;
                new A.NonNullsIterable([
                    min,
                    value,
                    max
                ], t1).forEach$1(0, A.calculation1___assertCalculationValue$closure());
                return new A.SassCalculation0("clamp", A.List_List$unmodifiable(new A.NonNullsIterable([
                    min,
                    value,
                    max
                ], t1), type$.Object));
            },
            call$1: function(min) {
                return this.call$3(min, null, null);
            },
            call$2: function(min, value) {
                return this.call$3(min, value, null);
            },
            "call*": "call$3",
            $requiredArgCount: 1,
            $defaultValues: function() {
                return [
                    null,
                    null
                ];
            },
            $signature: 377
        };
        A.calculationClass__closure4.prototype = {
            call$2: function($self, $name) {
                return $self;
            },
            call$1: function($self) {
                return this.call$2($self, null);
            },
            "call*": "call$2",
            $requiredArgCount: 1,
            $defaultValues: function() {
                return [
                    null
                ];
            },
            $signature: 378
        };
        A.calculationClass__closure5.prototype = {
            call$1: function($self) {
                return new self.immutable.List($self.$arguments);
            },
            $signature: 379
        };
        A.calculationOperationClass_closure.prototype = {
            call$0: function() {
                var _null = null, t1 = type$.JSClass, jsClass = t1._as(A.allowInteropCaptureThisNamed("sass.CalculationOperation", new A.calculationOperationClass__closure())), t2 = type$.String, t3 = type$.Function;
                A.LinkedHashMap_LinkedHashMap$_literal([
                    "equals",
                    new A.calculationOperationClass__closure0(),
                    "hashCode",
                    new A.calculationOperationClass__closure1()
                ], t2, t3).forEach$1(0, A.JSClassExtension_get_defineMethod(jsClass));
                A.LinkedHashMap_LinkedHashMap$_literal([
                    "operator",
                    new A.calculationOperationClass__closure2(),
                    "left",
                    new A.calculationOperationClass__closure3(),
                    "right",
                    new A.calculationOperationClass__closure4()
                ], t2, t3).forEach$1(0, A.JSClassExtension_get_defineGetter(jsClass));
                A.JSClassExtension_injectSuperclass(t1._as(A.SassCalculation_operateInternal0(B.CalculationOperator_dpX0, A.SassNumber_SassNumber0(1, _null), A.SassNumber_SassNumber0(1, _null), _null, false, _null).constructor), jsClass);
                return jsClass;
            },
            $signature: 17
        };
        A.calculationOperationClass__closure.prototype = {
            call$4: function($self, strOperator, left, right) {
                var operator = A.IterableExtension_firstWhereOrNull(B.List_UqK, new A.calculationOperationClass___closure(strOperator));
                if (operator == null) A.jsThrow0(new self.Error("Invalid operator: " + strOperator));
                A._assertCalculationValue(left);
                A._assertCalculationValue(right);
                return A.SassCalculation_operateInternal0(operator, left, right, null, false, null);
            },
            "call*": "call$4",
            $requiredArgCount: 4,
            $signature: 380
        };
        A.calculationOperationClass___closure.prototype = {
            call$1: function(value) {
                return value.operator === this.strOperator;
            },
            $signature: 381
        };
        A.calculationOperationClass__closure0.prototype = {
            call$2: function($self, other) {
                return $self.$eq(0, other);
            },
            $signature: 382
        };
        A.calculationOperationClass__closure1.prototype = {
            call$1: function($self) {
                return $self.get$hashCode(0);
            },
            $signature: 383
        };
        A.calculationOperationClass__closure2.prototype = {
            call$1: function($self) {
                return $self._calculation0$_operator.operator;
            },
            $signature: 384
        };
        A.calculationOperationClass__closure3.prototype = {
            call$1: function($self) {
                return $self._calculation0$_left;
            },
            $signature: 225
        };
        A.calculationOperationClass__closure4.prototype = {
            call$1: function($self) {
                return $self._calculation0$_right;
            },
            $signature: 225
        };
        A.calculationInterpolationClass_closure.prototype = {
            call$0: function() {
                var t1 = type$.JSClass, jsClass = t1._as(A.allowInteropCaptureThisNamed("sass.CalculationInterpolation", new A.calculationInterpolationClass__closure())), t2 = type$.String, t3 = type$.Function;
                A.LinkedHashMap_LinkedHashMap$_literal([
                    "equals",
                    new A.calculationInterpolationClass__closure0(),
                    "hashCode",
                    new A.calculationInterpolationClass__closure1()
                ], t2, t3).forEach$1(0, A.JSClassExtension_get_defineMethod(jsClass));
                A.LinkedHashMap_LinkedHashMap$_literal([
                    "value",
                    new A.calculationInterpolationClass__closure2()
                ], t2, t3).forEach$1(0, A.JSClassExtension_get_defineGetter(jsClass));
                A.JSClassExtension_injectSuperclass(t1._as(new A.CalculationInterpolation("").constructor), jsClass);
                return jsClass;
            },
            $signature: 17
        };
        A.calculationInterpolationClass__closure.prototype = {
            call$2: function($self, value) {
                return new A.CalculationInterpolation(value);
            },
            $signature: 386
        };
        A.calculationInterpolationClass__closure0.prototype = {
            call$2: function($self, other) {
                return other instanceof A.CalculationInterpolation && $self._calculation0$_value === other._calculation0$_value;
            },
            $signature: 387
        };
        A.calculationInterpolationClass__closure1.prototype = {
            call$1: function($self) {
                return B.JSString_methods.get$hashCode($self._calculation0$_value);
            },
            $signature: 388
        };
        A.calculationInterpolationClass__closure2.prototype = {
            call$1: function($self) {
                return $self._calculation0$_value;
            },
            $signature: 389
        };
        A.SassCalculation0.prototype = {
            get$isSpecialNumber: function() {
                return true;
            },
            accept$1$1: function(visitor) {
                return visitor.visitCalculation$1(this);
            },
            accept$1: function(visitor) {
                return this.accept$1$1(visitor, type$.dynamic);
            },
            assertCalculation$1: function($name) {
                return this;
            },
            plus$1: function(other) {
                if (other instanceof A.SassString0) return this.super$Value$plus0(other);
                throw A.wrapException(A.SassScriptException$0('Undefined operation "' + this.toString$0(0) + " + " + other.toString$0(0) + '".', null));
            },
            minus$1: function(other) {
                return A.throwExpression(A.SassScriptException$0('Undefined operation "' + this.toString$0(0) + " - " + other.toString$0(0) + '".', null));
            },
            unaryPlus$0: function() {
                return A.throwExpression(A.SassScriptException$0('Undefined operation "+' + this.toString$0(0) + '".', null));
            },
            unaryMinus$0: function() {
                return A.throwExpression(A.SassScriptException$0('Undefined operation "-' + this.toString$0(0) + '".', null));
            },
            $eq: function(_, other) {
                if (other == null) return false;
                return other instanceof A.SassCalculation0 && this.name === other.name && B.C_ListEquality.equals$2(0, this.$arguments, other.$arguments);
            },
            get$hashCode: function(_) {
                return B.JSString_methods.get$hashCode(this.name) ^ B.C_ListEquality0.hash$1(this.$arguments);
            }
        };
        A.SassCalculation__verifyLength_closure0.prototype = {
            call$1: function(arg) {
                return arg instanceof A.SassString0;
            },
            $signature: 73
        };
        A.CalculationOperation0.prototype = {
            $eq: function(_, other) {
                if (other == null) return false;
                return other instanceof A.CalculationOperation0 && this._calculation0$_operator === other._calculation0$_operator && J.$eq$(this._calculation0$_left, other._calculation0$_left) && J.$eq$(this._calculation0$_right, other._calculation0$_right);
            },
            get$hashCode: function(_) {
                return (A.Primitives_objectHashCode(this._calculation0$_operator) ^ J.get$hashCode$(this._calculation0$_left) ^ J.get$hashCode$(this._calculation0$_right)) >>> 0;
            },
            toString$0: function(_) {
                var parenthesized = A.serializeValue0(new A.SassCalculation0("", A._setArrayType([
                    this
                ], type$.JSArray_Object)), true, true);
                return B.JSString_methods.substring$2(parenthesized, 1, parenthesized.length - 1);
            }
        };
        A.CalculationOperator0.prototype = {
            _enumToString$0: function() {
                return "CalculationOperator." + this._name;
            },
            toString$0: function(_) {
                return this.name;
            }
        };
        A.CalculationInterpolation.prototype = {
            $eq: function(_, other) {
                if (other == null) return false;
                return other instanceof A.CalculationInterpolation && this._calculation0$_value === other._calculation0$_value;
            },
            get$hashCode: function(_) {
                return B.JSString_methods.get$hashCode(this._calculation0$_value);
            },
            toString$0: function(_) {
                return this._calculation0$_value;
            }
        };
        A.CallableDeclaration0.prototype = {
            get$span: function(receiver) {
                return this.span;
            }
        };
        A.updateCanonicalizeContextPrototype_closure.prototype = {
            call$1: function($self) {
                return $self._canonicalize_context$_fromImport;
            },
            $signature: 390
        };
        A.updateCanonicalizeContextPrototype_closure0.prototype = {
            call$1: function($self) {
                $self._canonicalize_context$_wasContainingUrlAccessed = true;
                return A.NullableExtension_andThen0($self._canonicalize_context$_containingUrl, A.utils3__dartToJSUrl$closure());
            },
            $signature: 391
        };
        A.CanonicalizeContext0.prototype = {
            withFromImport$1$2: function(fromImport, callback) {
                var t1, oldFromImport = this._canonicalize_context$_fromImport;
                this._canonicalize_context$_fromImport = true;
                try {
                    t1 = callback.call$0();
                    return t1;
                } finally{
                    this._canonicalize_context$_fromImport = oldFromImport;
                }
            },
            withFromImport$2: function(fromImport, callback) {
                return this.withFromImport$1$2(fromImport, callback, type$.dynamic);
            }
        };
        A.ColorChannel0.prototype = {
            isAnalogous$1: function(other) {
                var _0_6_isSet, t1, _0_60, t2, _0_6_isSet0, _0_1 = this.name, _0_6 = other.name;
                $label0$0: {
                    if ("red" !== _0_1) _0_6_isSet = "x" === _0_1;
                    else _0_6_isSet = true;
                    if (_0_6_isSet) {
                        if ("red" !== _0_6) t1 = "x" === _0_6;
                        else t1 = true;
                        _0_60 = _0_6;
                    } else {
                        _0_60 = null;
                        t1 = false;
                    }
                    t2 = true;
                    if (!t1) {
                        if ("green" !== _0_1) t1 = "y" === _0_1;
                        else t1 = true;
                        if (t1) {
                            _0_6_isSet0 = true;
                            if (_0_6_isSet) t1 = _0_60;
                            else {
                                t1 = _0_6;
                                _0_6_isSet = _0_6_isSet0;
                                _0_60 = t1;
                            }
                            if ("green" !== t1) {
                                if (_0_6_isSet) t1 = _0_60;
                                else {
                                    t1 = _0_6;
                                    _0_6_isSet = _0_6_isSet0;
                                    _0_60 = t1;
                                }
                                t1 = "y" === t1;
                            } else t1 = true;
                        } else t1 = false;
                        if (!t1) {
                            if ("blue" !== _0_1) t1 = "z" === _0_1;
                            else t1 = true;
                            if (t1) {
                                _0_6_isSet0 = true;
                                if (_0_6_isSet) t1 = _0_60;
                                else {
                                    t1 = _0_6;
                                    _0_6_isSet = _0_6_isSet0;
                                    _0_60 = t1;
                                }
                                if ("blue" !== t1) {
                                    if (_0_6_isSet) t1 = _0_60;
                                    else {
                                        t1 = _0_6;
                                        _0_6_isSet = _0_6_isSet0;
                                        _0_60 = t1;
                                    }
                                    t1 = "z" === t1;
                                } else t1 = true;
                            } else t1 = false;
                            if (!t1) {
                                if ("chroma" !== _0_1) t1 = "saturation" === _0_1;
                                else t1 = true;
                                if (t1) {
                                    _0_6_isSet0 = true;
                                    if (_0_6_isSet) t1 = _0_60;
                                    else {
                                        t1 = _0_6;
                                        _0_6_isSet = _0_6_isSet0;
                                        _0_60 = t1;
                                    }
                                    if ("chroma" !== t1) {
                                        if (_0_6_isSet) t1 = _0_60;
                                        else {
                                            t1 = _0_6;
                                            _0_6_isSet = _0_6_isSet0;
                                            _0_60 = t1;
                                        }
                                        t1 = "saturation" === t1;
                                    } else t1 = true;
                                } else t1 = false;
                                if (!t1) {
                                    if ("lightness" === _0_1) {
                                        if (_0_6_isSet) t1 = _0_60;
                                        else {
                                            t1 = _0_6;
                                            _0_60 = t1;
                                            _0_6_isSet = true;
                                        }
                                        t1 = "lightness" === t1;
                                    } else t1 = false;
                                    if (!t1) {
                                        if ("hue" === _0_1) t1 = "hue" === (_0_6_isSet ? _0_60 : _0_6);
                                        else t1 = false;
                                    } else t1 = t2;
                                } else t1 = t2;
                            } else t1 = t2;
                        } else t1 = t2;
                    } else t1 = t2;
                    break $label0$0;
                }
                return t1;
            }
        };
        A.LinearChannel0.prototype = {};
        A.Chokidar0.prototype = {};
        A.ChokidarOptions0.prototype = {};
        A.ChokidarWatcher0.prototype = {};
        A.InterpolatedClassSelector.prototype = {
            get$span: function(_) {
                var t1 = this.name.span;
                return t1.get$file(t1).span$2(0, t1.get$start(t1).offset - 1, t1.get$end(t1).offset);
            },
            accept$1$1: function(visitor) {
                return J.visitClassSelector$1$x(visitor._simple_selector$_inner, this);
            },
            accept$1: function(visitor) {
                return this.accept$1$1(visitor, type$.dynamic);
            },
            toString$0: function(_) {
                return "." + this.name.toString$0(0);
            }
        };
        A.ClassSelector0.prototype = {
            $eq: function(_, other) {
                if (other == null) return false;
                return other instanceof A.ClassSelector0 && other.name === this.name;
            },
            accept$1$1: function(visitor) {
                return visitor.visitClassSelector$1(0, this);
            },
            accept$1: function(visitor) {
                return this.accept$1$1(visitor, type$.dynamic);
            },
            addSuffix$1: function(suffix) {
                return new A.ClassSelector0(this.name + suffix, this.span);
            },
            get$hashCode: function(_) {
                return B.JSString_methods.get$hashCode(this.name);
            }
        };
        A.ClipGamutMap0.prototype = {
            map$1: function(_, color) {
                var t1 = color._color0$_space, t2 = t1._space$_channels;
                return A.SassColor_SassColor$forSpaceInternal0(t1, this._clip$_clampChannel$2(color.channel0OrNull, t2[0]), this._clip$_clampChannel$2(color.channel1OrNull, t2[1]), this._clip$_clampChannel$2(color.channel2OrNull, t2[2]), color.alphaOrNull);
            },
            _clip$_clampChannel$2: function(value, channel) {
                var t1, min;
                if (value == null) t1 = null;
                else $label0$0: {
                    if (channel instanceof A.LinearChannel0) {
                        min = channel.min;
                        t1 = isNaN(value) ? min : B.JSNumber_methods.clamp$2(value, min, channel.max);
                        break $label0$0;
                    }
                    t1 = value;
                    break $label0$0;
                }
                return t1;
            }
        };
        A._CloneCssVisitor0.prototype = {
            visitCssAtRule$1: function(node) {
                var t1 = node.isChildless, rule = A.ModifiableCssAtRule$0(node.name, node.span, t1, node.value);
                return t1 ? rule : this._clone_css$_visitChildren$2(rule, node);
            },
            visitCssComment$1: function(node) {
                return new A.ModifiableCssComment0(node.text, node.span);
            },
            visitCssDeclaration$1: function(node) {
                return A.ModifiableCssDeclaration$0(node.name, node.value, node.span, node.parsedAsSassScript, node.valueSpanForMap);
            },
            visitCssImport$1: function(node) {
                return new A.ModifiableCssImport0(node.url, node.modifiers, node.span);
            },
            visitCssKeyframeBlock$1: function(node) {
                return this._clone_css$_visitChildren$2(A.ModifiableCssKeyframeBlock$0(node.selector, node.span), node);
            },
            visitCssMediaRule$1: function(node) {
                return this._clone_css$_visitChildren$2(A.ModifiableCssMediaRule$0(node.queries, node.span), node);
            },
            visitCssStyleRule$1: function(node) {
                var _0_0 = this._clone_css$_oldToNewSelectors.$index(0, node._style_rule0$_selector._box0$_inner.value);
                if (_0_0 != null) return this._clone_css$_visitChildren$2(A.ModifiableCssStyleRule$0(_0_0, node.span, false, node.originalSelector), node);
                else throw A.wrapException(A.StateError$(string$.The_Ex));
            },
            visitCssStylesheet$1: function(node) {
                return this._clone_css$_visitChildren$2(A.ModifiableCssStylesheet$0(node.get$span(node)), node);
            },
            visitCssSupportsRule$1: function(node) {
                return this._clone_css$_visitChildren$2(A.ModifiableCssSupportsRule$0(node.condition, node.span), node);
            },
            _clone_css$_visitChildren$1$2: function(newParent, oldParent) {
                var t1, t2, newChild;
                for(t1 = J.get$iterator$ax(oldParent.get$children(oldParent)); t1.moveNext$0();){
                    t2 = t1.get$current(t1);
                    newChild = t2.accept$1(this);
                    newChild.isGroupEnd = t2.get$isGroupEnd();
                    newParent.addChild$1(newChild);
                }
                return newParent;
            },
            _clone_css$_visitChildren$2: function(newParent, oldParent) {
                return this._clone_css$_visitChildren$1$2(newParent, oldParent, type$.ModifiableCssParentNode_2);
            }
        };
        A.ColorExpression0.prototype = {
            accept$1$1: function(visitor) {
                return visitor.visitColorExpression$1(0, this);
            },
            accept$1: function(visitor) {
                return this.accept$1$1(visitor, type$.dynamic);
            },
            toString$0: function(_) {
                return A.serializeValue0(this.value, true, true);
            },
            get$span: function(receiver) {
                return this.span;
            }
        };
        A.global_closure44.prototype = {
            call$1: function(color) {
                return B.JSNumber_methods.round$0(color._color0$_legacyChannel$2(B.RgbColorSpace_i0P0, "red"));
            },
            $signature: 39
        };
        A.global_closure45.prototype = {
            call$1: function(color) {
                return B.JSNumber_methods.round$0(color._color0$_legacyChannel$2(B.RgbColorSpace_i0P0, "green"));
            },
            $signature: 39
        };
        A.global_closure46.prototype = {
            call$1: function(color) {
                return B.JSNumber_methods.round$0(color._color0$_legacyChannel$2(B.RgbColorSpace_i0P0, "blue"));
            },
            $signature: 39
        };
        A.global_closure47.prototype = {
            call$1: function($arguments) {
                return A._rgb0("rgb", $arguments);
            },
            $signature: 3
        };
        A.global_closure48.prototype = {
            call$1: function($arguments) {
                return A._rgb0("rgb", $arguments);
            },
            $signature: 3
        };
        A.global_closure49.prototype = {
            call$1: function($arguments) {
                return A._rgbTwoArg0("rgb", $arguments);
            },
            $signature: 3
        };
        A.global_closure50.prototype = {
            call$1: function($arguments) {
                return A._parseChannels0("rgb", J.$index$asx($arguments, 0), "channels", B.RgbColorSpace_i0P0);
            },
            $signature: 3
        };
        A.global_closure51.prototype = {
            call$1: function($arguments) {
                return A._rgb0("rgba", $arguments);
            },
            $signature: 3
        };
        A.global_closure52.prototype = {
            call$1: function($arguments) {
                return A._rgb0("rgba", $arguments);
            },
            $signature: 3
        };
        A.global_closure53.prototype = {
            call$1: function($arguments) {
                return A._rgbTwoArg0("rgba", $arguments);
            },
            $signature: 3
        };
        A.global_closure54.prototype = {
            call$1: function($arguments) {
                return A._parseChannels0("rgba", J.$index$asx($arguments, 0), "channels", B.RgbColorSpace_i0P0);
            },
            $signature: 3
        };
        A.global_closure55.prototype = {
            call$1: function($arguments) {
                var t1 = J.getInterceptor$asx($arguments);
                if (!(t1.$index($arguments, 0) instanceof A.SassNumber0) && !t1.$index($arguments, 0).get$isSpecialNumber()) A.warnForDeprecation0(string$.Globalci, B.Deprecation_SGB);
                return A._invert0($arguments, true);
            },
            $signature: 3
        };
        A.global_closure56.prototype = {
            call$1: function(color) {
                return color._color0$_legacyChannel$2(B.HslColorSpace_JQ20, "hue");
            },
            $signature: 30
        };
        A.global_closure57.prototype = {
            call$1: function(color) {
                return color._color0$_legacyChannel$2(B.HslColorSpace_JQ20, "saturation");
            },
            $signature: 30
        };
        A.global_closure58.prototype = {
            call$1: function(color) {
                return color._color0$_legacyChannel$2(B.HslColorSpace_JQ20, "lightness");
            },
            $signature: 30
        };
        A.global_closure59.prototype = {
            call$1: function($arguments) {
                return A._hsl0("hsl", $arguments);
            },
            $signature: 3
        };
        A.global_closure60.prototype = {
            call$1: function($arguments) {
                return A._hsl0("hsl", $arguments);
            },
            $signature: 3
        };
        A.global_closure61.prototype = {
            call$1: function($arguments) {
                var t1 = J.getInterceptor$asx($arguments);
                if (t1.$index($arguments, 0).get$isSpecialVariable() || t1.$index($arguments, 1).get$isSpecialVariable()) return A._functionString0("hsl", $arguments);
                else throw A.wrapException(A.SassScriptException$0("Missing argument $lightness.", null));
            },
            $signature: 18
        };
        A.global_closure62.prototype = {
            call$1: function($arguments) {
                return A._parseChannels0("hsl", J.$index$asx($arguments, 0), "channels", B.HslColorSpace_JQ20);
            },
            $signature: 3
        };
        A.global_closure63.prototype = {
            call$1: function($arguments) {
                return A._hsl0("hsla", $arguments);
            },
            $signature: 3
        };
        A.global_closure64.prototype = {
            call$1: function($arguments) {
                return A._hsl0("hsla", $arguments);
            },
            $signature: 3
        };
        A.global_closure65.prototype = {
            call$1: function($arguments) {
                var t1 = J.getInterceptor$asx($arguments);
                if (t1.$index($arguments, 0).get$isSpecialVariable() || t1.$index($arguments, 1).get$isSpecialVariable()) return A._functionString0("hsla", $arguments);
                else throw A.wrapException(A.SassScriptException$0("Missing argument $lightness.", null));
            },
            $signature: 18
        };
        A.global_closure66.prototype = {
            call$1: function($arguments) {
                return A._parseChannels0("hsla", J.$index$asx($arguments, 0), "channels", B.HslColorSpace_JQ20);
            },
            $signature: 3
        };
        A.global_closure67.prototype = {
            call$1: function($arguments) {
                var t1 = J.getInterceptor$asx($arguments);
                if (t1.$index($arguments, 0) instanceof A.SassNumber0 || t1.$index($arguments, 0).get$isSpecialNumber()) return A._functionString0("grayscale", $arguments);
                else {
                    A.warnForDeprecation0(string$.Globalcg, B.Deprecation_SGB);
                    return A._grayscale0(t1.$index($arguments, 0));
                }
            },
            $signature: 3
        };
        A.global_closure68.prototype = {
            call$1: function($arguments) {
                var t1 = J.getInterceptor$asx($arguments), color = t1.$index($arguments, 0).assertColor$1("color"), degrees = A._angleValue0(t1.$index($arguments, 1), "degrees");
                if (!color._color0$_space.get$isLegacyInternal()) throw A.wrapException(A.SassScriptException$0(string$.adjusto, null));
                A.warnForDeprecation0(string$.adjustd + A.serializeValue0(A.SassNumber_SassNumber0(degrees, "deg"), false, true) + string$.x29x0a_Mor_, B.Deprecation_hJG);
                return color.changeHsl$1$hue(color._color0$_legacyChannel$2(B.HslColorSpace_JQ20, "hue") + degrees);
            },
            $signature: 26
        };
        A.global_closure69.prototype = {
            call$1: function($arguments) {
                var result, _s9_ = "lightness", t1 = J.getInterceptor$asx($arguments), color = t1.$index($arguments, 0).assertColor$1("color"), amount = t1.$index($arguments, 1).assertNumber$1("amount");
                if (!color._color0$_space.get$isLegacyInternal()) throw A.wrapException(A.SassScriptException$0(string$.lighte, null));
                t1 = color._color0$_legacyChannel$2(B.HslColorSpace_JQ20, _s9_) + amount.valueInRange$3(0, 100, "amount");
                result = color.changeHsl$1$lightness(isNaN(t1) ? 0 : B.JSNumber_methods.clamp$2(t1, 0, 100));
                A.warnForDeprecation0("lighten() is deprecated. " + A._suggestScaleAndAdjust0(color, amount._number1$_value, _s9_) + string$.x0a_Morex3ac, B.Deprecation_hJG);
                return result;
            },
            $signature: 26
        };
        A.global_closure70.prototype = {
            call$1: function($arguments) {
                var result, _s9_ = "lightness", t1 = J.getInterceptor$asx($arguments), color = t1.$index($arguments, 0).assertColor$1("color"), amount = t1.$index($arguments, 1).assertNumber$1("amount");
                if (!color._color0$_space.get$isLegacyInternal()) throw A.wrapException(A.SassScriptException$0(string$.darken, null));
                t1 = color._color0$_legacyChannel$2(B.HslColorSpace_JQ20, _s9_) - amount.valueInRange$3(0, 100, "amount");
                result = color.changeHsl$1$lightness(isNaN(t1) ? 0 : B.JSNumber_methods.clamp$2(t1, 0, 100));
                A.warnForDeprecation0("darken() is deprecated. " + A._suggestScaleAndAdjust0(color, -amount._number1$_value, _s9_) + string$.x0a_Morex3ac, B.Deprecation_hJG);
                return result;
            },
            $signature: 26
        };
        A.global_closure71.prototype = {
            call$1: function($arguments) {
                var t1 = J.getInterceptor$asx($arguments);
                if (t1.$index($arguments, 0) instanceof A.SassNumber0 || t1.$index($arguments, 0).get$isSpecialNumber()) return A._functionString0("saturate", $arguments);
                return new A.SassString0("saturate(" + A.serializeValue0(t1.$index($arguments, 0).assertNumber$1("amount"), false, true) + ")", false);
            },
            $signature: 18
        };
        A.global_closure72.prototype = {
            call$1: function($arguments) {
                var t1, color, amount, result, _s10_ = "saturation";
                A.warnForDeprecation0(string$.Globalcad, B.Deprecation_SGB);
                t1 = J.getInterceptor$asx($arguments);
                color = t1.$index($arguments, 0).assertColor$1("color");
                amount = t1.$index($arguments, 1).assertNumber$1("amount");
                if (!color._color0$_space.get$isLegacyInternal()) throw A.wrapException(A.SassScriptException$0(string$.satura, null));
                t1 = color._color0$_legacyChannel$2(B.HslColorSpace_JQ20, _s10_) + amount.valueInRange$3(0, 100, "amount");
                result = color.changeHsl$1$saturation(isNaN(t1) ? 0 : B.JSNumber_methods.clamp$2(t1, 0, 100));
                A.warnForDeprecation0("saturate() is deprecated. " + A._suggestScaleAndAdjust0(color, amount._number1$_value, _s10_) + string$.x0a_Morex3ac, B.Deprecation_hJG);
                return result;
            },
            $signature: 26
        };
        A.global_closure73.prototype = {
            call$1: function($arguments) {
                var result, _s10_ = "saturation", t1 = J.getInterceptor$asx($arguments), color = t1.$index($arguments, 0).assertColor$1("color"), amount = t1.$index($arguments, 1).assertNumber$1("amount");
                if (!color._color0$_space.get$isLegacyInternal()) throw A.wrapException(A.SassScriptException$0(string$.desatu, null));
                t1 = color._color0$_legacyChannel$2(B.HslColorSpace_JQ20, _s10_) - amount.valueInRange$3(0, 100, "amount");
                result = color.changeHsl$1$saturation(isNaN(t1) ? 0 : B.JSNumber_methods.clamp$2(t1, 0, 100));
                A.warnForDeprecation0("desaturate() is deprecated. " + A._suggestScaleAndAdjust0(color, -amount._number1$_value, _s10_) + string$.x0a_Morex3ac, B.Deprecation_hJG);
                return result;
            },
            $signature: 26
        };
        A.global_closure74.prototype = {
            call$1: function($arguments) {
                return A._opacify0("opacify", $arguments);
            },
            $signature: 26
        };
        A.global_closure75.prototype = {
            call$1: function($arguments) {
                return A._opacify0("fade-in", $arguments);
            },
            $signature: 26
        };
        A.global_closure76.prototype = {
            call$1: function($arguments) {
                return A._transparentize0("transparentize", $arguments);
            },
            $signature: 26
        };
        A.global_closure77.prototype = {
            call$1: function($arguments) {
                return A._transparentize0("fade-out", $arguments);
            },
            $signature: 26
        };
        A.global_closure78.prototype = {
            call$1: function($arguments) {
                var _0_0 = J.$index$asx($arguments, 0), t1 = false;
                if (_0_0 instanceof A.SassString0) {
                    if (!_0_0._string0$_hasQuotes) t1 = B.JSString_methods.contains$1(_0_0._string0$_text, $.$get$_microsoftFilterStart0());
                }
                if (t1) return A._functionString0("alpha", $arguments);
                if (_0_0 instanceof A.SassColor0 && !_0_0._color0$_space.get$isLegacyInternal()) throw A.wrapException(A.SassScriptException$0(string$.alpha_, null));
                A.warnForDeprecation0(string$.Globalcal, B.Deprecation_SGB);
                t1 = _0_0.assertColor$1("color").alphaOrNull;
                return A.SassNumber_SassNumber0(t1 == null ? 0 : t1, null);
            },
            $signature: 3
        };
        A.global_closure79.prototype = {
            call$1: function($arguments) {
                var t1, argList = J.$index$asx($arguments, 0).get$asList();
                if (argList.length !== 0 && B.JSArray_methods.every$1(argList, new A.global__closure0())) return A._functionString0("alpha", $arguments);
                t1 = argList.length;
                if (t1 === 0) throw A.wrapException(A.SassScriptException$0("Missing argument $color.", null));
                else throw A.wrapException(A.SassScriptException$0("Only 1 argument allowed, but " + t1 + " were passed.", null));
            },
            $signature: 18
        };
        A.global__closure0.prototype = {
            call$1: function(argument) {
                return argument instanceof A.SassString0 && !argument._string0$_hasQuotes && B.JSString_methods.contains$1(argument._string0$_text, $.$get$_microsoftFilterStart0());
            },
            $signature: 56
        };
        A.global_closure80.prototype = {
            call$1: function($arguments) {
                var t1 = J.getInterceptor$asx($arguments);
                if (t1.$index($arguments, 0) instanceof A.SassNumber0 || t1.$index($arguments, 0).get$isSpecialNumber()) return A._functionString0("opacity", $arguments);
                A.warnForDeprecation0(string$.Globalco, B.Deprecation_SGB);
                t1 = t1.$index($arguments, 0).assertColor$1("color").alphaOrNull;
                return A.SassNumber_SassNumber0(t1 == null ? 0 : t1, null);
            },
            $signature: 3
        };
        A.global_closure81.prototype = {
            call$1: function($arguments) {
                return A._parseChannels0("color", J.$index$asx($arguments, 0), "description", null);
            },
            $signature: 3
        };
        A.global_closure82.prototype = {
            call$1: function($arguments) {
                return A._parseChannels0("hwb", J.$index$asx($arguments, 0), "channels", B.HwbColorSpace_guQ0);
            },
            $signature: 3
        };
        A.global_closure83.prototype = {
            call$1: function($arguments) {
                return A._parseChannels0("lab", J.$index$asx($arguments, 0), "channels", B.LabColorSpace_2nT0);
            },
            $signature: 3
        };
        A.global_closure84.prototype = {
            call$1: function($arguments) {
                return A._parseChannels0("lch", J.$index$asx($arguments, 0), "channels", B.LchColorSpace_Bpv0);
            },
            $signature: 3
        };
        A.global_closure85.prototype = {
            call$1: function($arguments) {
                return A._parseChannels0("oklab", J.$index$asx($arguments, 0), "channels", B.OklabColorSpace_5400);
            },
            $signature: 3
        };
        A.global_closure86.prototype = {
            call$1: function($arguments) {
                return A._parseChannels0("oklch", J.$index$asx($arguments, 0), "channels", B.OklchColorSpace_9Gj0);
            },
            $signature: 3
        };
        A.module_closure27.prototype = {
            call$1: function(color) {
                return B.JSNumber_methods.round$0(color._color0$_legacyChannel$2(B.RgbColorSpace_i0P0, "red"));
            },
            $signature: 39
        };
        A.module_closure28.prototype = {
            call$1: function(color) {
                return B.JSNumber_methods.round$0(color._color0$_legacyChannel$2(B.RgbColorSpace_i0P0, "green"));
            },
            $signature: 39
        };
        A.module_closure29.prototype = {
            call$1: function(color) {
                return B.JSNumber_methods.round$0(color._color0$_legacyChannel$2(B.RgbColorSpace_i0P0, "blue"));
            },
            $signature: 39
        };
        A.module_closure30.prototype = {
            call$1: function($arguments) {
                var result = A._invert0($arguments, false);
                if (result instanceof A.SassString0) A.warnForDeprecation0("Passing a number (" + J.$index$asx($arguments, 0).toString$0(0) + string$.x29x20to_cli + result.toString$0(0), B.Deprecation_mqF);
                return result;
            },
            $signature: 3
        };
        A.module_closure31.prototype = {
            call$1: function(color) {
                return color._color0$_legacyChannel$2(B.HslColorSpace_JQ20, "hue");
            },
            $signature: 30
        };
        A.module_closure32.prototype = {
            call$1: function(color) {
                return color._color0$_legacyChannel$2(B.HslColorSpace_JQ20, "saturation");
            },
            $signature: 30
        };
        A.module_closure33.prototype = {
            call$1: function(color) {
                return color._color0$_legacyChannel$2(B.HslColorSpace_JQ20, "lightness");
            },
            $signature: 30
        };
        A.module_closure34.prototype = {
            call$1: function($arguments) {
                var result, t1 = J.getInterceptor$asx($arguments);
                if (t1.$index($arguments, 0) instanceof A.SassNumber0) {
                    result = A._functionString0("grayscale", t1.take$1($arguments, 1));
                    A.warnForDeprecation0("Passing a number (" + t1.$index($arguments, 0).toString$0(0) + string$.x29x20to_clg + result.toString$0(0), B.Deprecation_mqF);
                    return result;
                }
                return A._grayscale0(t1.$index($arguments, 0));
            },
            $signature: 3
        };
        A.module_closure35.prototype = {
            call$1: function($arguments) {
                var t1 = J.getInterceptor$asx($arguments), t2 = type$.JSArray_Value_2;
                return A._parseChannels0("hwb", A.SassList$0(A._setArrayType([
                    A.SassList$0(A._setArrayType([
                        t1.$index($arguments, 0),
                        t1.$index($arguments, 1),
                        t1.$index($arguments, 2)
                    ], t2), B.ListSeparator_SrV0, false),
                    t1.$index($arguments, 3)
                ], t2), B.ListSeparator_Lul0, false), null, B.HwbColorSpace_guQ0);
            },
            $signature: 3
        };
        A.module_closure36.prototype = {
            call$1: function($arguments) {
                return A._parseChannels0("hwb", J.$index$asx($arguments, 0), "channels", B.HwbColorSpace_guQ0);
            },
            $signature: 3
        };
        A.module_closure37.prototype = {
            call$1: function(color) {
                return color._color0$_legacyChannel$2(B.HwbColorSpace_guQ0, "whiteness");
            },
            $signature: 30
        };
        A.module_closure38.prototype = {
            call$1: function(color) {
                return color._color0$_legacyChannel$2(B.HwbColorSpace_guQ0, "blackness");
            },
            $signature: 30
        };
        A.module_closure39.prototype = {
            call$1: function($arguments) {
                var result, _0_0 = J.$index$asx($arguments, 0), t1 = false;
                if (_0_0 instanceof A.SassString0) {
                    if (!_0_0._string0$_hasQuotes) t1 = B.JSString_methods.contains$1(_0_0._string0$_text, $.$get$_microsoftFilterStart0());
                }
                if (t1) {
                    result = A._functionString0("alpha", $arguments);
                    A.warnForDeprecation0(string$.Using_c + result.toString$0(0), B.Deprecation_mqF);
                    return result;
                }
                if (_0_0 instanceof A.SassColor0 && !_0_0._color0$_space.get$isLegacyInternal()) throw A.wrapException(A.SassScriptException$0(string$.color_a, null));
                t1 = _0_0.assertColor$1("color").alphaOrNull;
                return A.SassNumber_SassNumber0(t1 == null ? 0 : t1, null);
            },
            $signature: 3
        };
        A.module_closure40.prototype = {
            call$1: function($arguments) {
                var result, t1 = J.getInterceptor$asx($arguments);
                if (B.JSArray_methods.every$1(t1.$index($arguments, 0).get$asList(), new A.module__closure6())) {
                    result = A._functionString0("alpha", $arguments);
                    A.warnForDeprecation0(string$.Using_c + result.toString$0(0), B.Deprecation_mqF);
                    return result;
                }
                throw A.wrapException(A.SassScriptException$0("Only 1 argument allowed, but " + t1.get$length($arguments) + " were passed.", null));
            },
            $signature: 18
        };
        A.module__closure6.prototype = {
            call$1: function(argument) {
                return argument instanceof A.SassString0 && !argument._string0$_hasQuotes && B.JSString_methods.contains$1(argument._string0$_text, $.$get$_microsoftFilterStart0());
            },
            $signature: 56
        };
        A.module_closure41.prototype = {
            call$1: function($arguments) {
                var result, t1 = J.getInterceptor$asx($arguments);
                if (t1.$index($arguments, 0) instanceof A.SassNumber0) {
                    result = A._functionString0("opacity", $arguments);
                    A.warnForDeprecation0("Passing a number (" + t1.$index($arguments, 0).toString$0(0) + string$.x20to_co + result.toString$0(0), B.Deprecation_mqF);
                    return result;
                }
                t1 = t1.$index($arguments, 0).assertColor$1("color").alphaOrNull;
                return A.SassNumber_SassNumber0(t1 == null ? 0 : t1, null);
            },
            $signature: 3
        };
        A.module_closure42.prototype = {
            call$1: function($arguments) {
                return new A.SassString0(J.get$first$ax($arguments).assertColor$1("color")._color0$_space.name, false);
            },
            $signature: 18
        };
        A.module_closure43.prototype = {
            call$1: function($arguments) {
                var t1 = J.getInterceptor$asx($arguments);
                return A._colorInSpace0(t1.$index($arguments, 0), t1.$index($arguments, 1), false);
            },
            $signature: 26
        };
        A.module_closure44.prototype = {
            call$1: function($arguments) {
                return J.$index$asx($arguments, 0).assertColor$1("color")._color0$_space.get$isLegacyInternal() ? B.SassBoolean_true0 : B.SassBoolean_false0;
            },
            $signature: 13
        };
        A.module_closure45.prototype = {
            call$1: function($arguments) {
                var t1 = J.getInterceptor$asx($arguments);
                return t1.$index($arguments, 0).assertColor$1("color").isChannelMissing$3$channelName$colorName(A._channelName0(t1.$index($arguments, 1)), "channel", "color") ? B.SassBoolean_true0 : B.SassBoolean_false0;
            },
            $signature: 13
        };
        A.module_closure46.prototype = {
            call$1: function($arguments) {
                var t1 = J.getInterceptor$asx($arguments);
                return A._colorInSpace0(t1.$index($arguments, 0), t1.$index($arguments, 1), true).get$isInGamut() ? B.SassBoolean_true0 : B.SassBoolean_false0;
            },
            $signature: 13
        };
        A.module_closure47.prototype = {
            call$1: function($arguments) {
                var space, method, _s5_ = "space", _s6_ = "method", t1 = J.getInterceptor$asx($arguments), color = t1.$index($arguments, 0).assertColor$1("color"), t2 = t1.$index($arguments, 1);
                if (t2.$eq(0, B.C__SassNull0)) space = color._color0$_space;
                else {
                    t2 = t2.assertString$1(_s5_);
                    t2.assertUnquoted$1(_s5_);
                    space = A.ColorSpace_fromName0(t2._string0$_text, _s5_);
                }
                if (t1.$index($arguments, 2).$eq(0, B.C__SassNull0)) throw A.wrapException(A.SassScriptException$0(string$.color_t, _s6_));
                t1 = t1.$index($arguments, 2).assertString$1(_s6_);
                t1.assertUnquoted$1(_s6_);
                method = A.GamutMapMethod_GamutMapMethod$fromName0(t1._string0$_text);
                if (!space.get$isBoundedInternal()) return color;
                t1 = color.toSpace$1(space);
                t1 = t1.get$isInGamut() ? t1 : method.map$1(0, t1);
                return t1.toSpace$2$legacyMissing(color._color0$_space, false);
            },
            $signature: 26
        };
        A.module_closure48.prototype = {
            call$1: function($arguments) {
                var channelIndex, channelInfo, channelValue, unit, t1 = J.getInterceptor$asx($arguments), color = A._colorInSpace0(t1.$index($arguments, 0), t1.$index($arguments, 2), true), channelName = A._channelName0(t1.$index($arguments, 1));
                if (channelName === "alpha") {
                    t1 = color.alphaOrNull;
                    return A.SassNumber_SassNumber0(t1 == null ? 0 : t1, null);
                }
                t1 = color._color0$_space._space$_channels;
                channelIndex = B.JSArray_methods.indexWhere$1(t1, new A.module__closure5(channelName));
                if (channelIndex === -1) throw A.wrapException(A.SassScriptException$0("Color " + color.toString$0(0) + " has no channel named " + channelName + ".", "channel"));
                channelInfo = t1[channelIndex];
                channelValue = color.get$channels()[channelIndex];
                unit = channelInfo.associatedUnit;
                return A.SassNumber_SassNumber0(unit === "%" ? channelValue * 100 / type$.LinearChannel_2._as(channelInfo).max : channelValue, unit);
            },
            $signature: 25
        };
        A.module__closure5.prototype = {
            call$1: function(channel) {
                return channel.name === this.channelName;
            },
            $signature: 67
        };
        A.module_closure49.prototype = {
            call$1: function($arguments) {
                var t2, t3, t1 = J.getInterceptor$asx($arguments), color1 = t1.$index($arguments, 0).assertColor$1("color1"), color2 = t1.$index($arguments, 1).assertColor$1("color2");
                t1 = new A.module_closure_toXyzNoMissing0();
                if (color1._color0$_space === color2._color0$_space) {
                    t1 = color1.channel0OrNull;
                    t2 = false;
                    if (t1 == null) t1 = 0;
                    t3 = color2.channel0OrNull;
                    if (A.fuzzyEquals0(t1, t3 == null ? 0 : t3)) {
                        t1 = color1.channel1OrNull;
                        if (t1 == null) t1 = 0;
                        t3 = color2.channel1OrNull;
                        if (A.fuzzyEquals0(t1, t3 == null ? 0 : t3)) {
                            t1 = color1.channel2OrNull;
                            if (t1 == null) t1 = 0;
                            t3 = color2.channel2OrNull;
                            if (A.fuzzyEquals0(t1, t3 == null ? 0 : t3)) {
                                t1 = color1.alphaOrNull;
                                if (t1 == null) t1 = 0;
                                t2 = color2.alphaOrNull;
                                t1 = A.fuzzyEquals0(t1, t2 == null ? 0 : t2);
                            } else t1 = t2;
                        } else t1 = t2;
                    } else t1 = t2;
                } else t1 = J.$eq$(t1.call$1(color1), t1.call$1(color2));
                return t1 ? B.SassBoolean_true0 : B.SassBoolean_false0;
            },
            $signature: 13
        };
        A.module_closure_toXyzNoMissing0.prototype = {
            call$1: function(color) {
                var _1_1, _1_3, t1, _1_7, channel0, _1_8, channel1, _1_9, channel2, _1_10, alpha, _null = null;
                $label0$0: {
                    _1_1 = color._color0$_space;
                    _1_3 = B.XyzD65ColorSpace_WiJ0 === _1_1;
                    t1 = _1_3;
                    if (t1) t1 = !(color.channel0OrNull == null || color.channel1OrNull == null || color.channel2OrNull == null || color.alphaOrNull == null);
                    else t1 = false;
                    if (t1) {
                        t1 = color;
                        break $label0$0;
                    }
                    if (_1_3) {
                        _1_7 = color.channel0OrNull;
                        if (_1_7 == null) _1_7 = 0;
                        channel0 = _1_7;
                        _1_8 = color.channel1OrNull;
                        if (_1_8 == null) _1_8 = 0;
                        channel1 = _1_8;
                        _1_9 = color.channel2OrNull;
                        if (_1_9 == null) _1_9 = 0;
                        channel2 = _1_9;
                        _1_10 = color.alphaOrNull;
                        if (_1_10 == null) _1_10 = 0;
                        alpha = _1_10;
                        t1 = A.SassColor$_forSpace0(B.XyzD65ColorSpace_WiJ0, channel0, channel1, channel2, alpha, _null);
                        break $label0$0;
                    }
                    _1_7 = color.channel0OrNull;
                    if (_1_7 == null) _1_7 = 0;
                    channel0 = _1_7;
                    _1_8 = color.channel1OrNull;
                    if (_1_8 == null) _1_8 = 0;
                    channel1 = _1_8;
                    _1_9 = color.channel2OrNull;
                    if (_1_9 == null) _1_9 = 0;
                    channel2 = _1_9;
                    _1_10 = color.alphaOrNull;
                    if (_1_10 == null) _1_10 = 0;
                    alpha = _1_10;
                    t1 = _1_1.convert$5(B.XyzD65ColorSpace_WiJ0, channel0, channel1, channel2, alpha);
                    break $label0$0;
                }
                return t1;
            },
            $signature: 399
        };
        A.module_closure50.prototype = {
            call$1: function($arguments) {
                var t1 = J.getInterceptor$asx($arguments);
                return A._colorInSpace0(t1.$index($arguments, 0), t1.$index($arguments, 2), true).isChannelPowerless$3$channelName$colorName(A._channelName0(t1.$index($arguments, 1)), "channel", "color") ? B.SassBoolean_true0 : B.SassBoolean_false0;
            },
            $signature: 13
        };
        A._mix_closure0.prototype = {
            call$1: function($arguments) {
                var _s6_ = "weight", _s41_ = string$.To_usem, _s29_ = ", you must provide a $method.", t1 = J.getInterceptor$asx($arguments), color1 = t1.$index($arguments, 0).assertColor$1("color1"), color2 = t1.$index($arguments, 1).assertColor$1("color2"), weight = t1.$index($arguments, 2).assertNumber$1(_s6_);
                if (!t1.$index($arguments, 3).$eq(0, B.C__SassNull0)) return color1.interpolate$4$legacyMissing$weight(color2, A.InterpolationMethod_InterpolationMethod$fromValue0(t1.$index($arguments, 3), "method"), false, weight.valueInRangeWithUnit$4(0, 100, _s6_, "%") / 100);
                A._checkPercent0(weight, _s6_);
                if (!color1._color0$_space.get$isLegacyInternal()) throw A.wrapException(A.SassScriptException$0(_s41_ + color1.toString$0(0) + _s29_, "color1"));
                else if (!color2._color0$_space.get$isLegacyInternal()) throw A.wrapException(A.SassScriptException$0(_s41_ + color2.toString$0(0) + _s29_, "color2"));
                return A._mixLegacy0(color1, color2, weight);
            },
            $signature: 26
        };
        A._complement_closure0.prototype = {
            call$1: function($arguments) {
                var space, t3, colorInSpace, t4, t5, t6, _s5_ = "space", t1 = J.getInterceptor$asx($arguments), color = t1.$index($arguments, 0).assertColor$1("color"), t2 = color._color0$_space;
                if (t2.get$isLegacyInternal() && t1.$index($arguments, 1).$eq(0, B.C__SassNull0)) space = B.HslColorSpace_JQ20;
                else {
                    t3 = t1.$index($arguments, 1).assertString$1(_s5_);
                    t3.assertUnquoted$1(_s5_);
                    space = A.ColorSpace_fromName0(t3._string0$_text, _s5_);
                }
                if (!space.get$isPolarInternal()) throw A.wrapException(A.SassScriptException$0("Color space " + space.toString$0(0) + " doesn't have a hue channel.", _s5_));
                colorInSpace = color.toSpace$2$legacyMissing(space, !t1.$index($arguments, 1).$eq(0, B.C__SassNull0));
                t1 = space._space$_channels;
                t3 = colorInSpace.channel0OrNull;
                t4 = colorInSpace.channel1OrNull;
                t5 = colorInSpace.channel2OrNull;
                t6 = colorInSpace.alphaOrNull;
                return (space.get$isLegacyInternal() ? A.SassColor_SassColor$forSpaceInternal0(space, A._adjustChannel0(colorInSpace, t1[0], t3, A.SassNumber_SassNumber0(180, null)), t4, t5, t6) : A.SassColor_SassColor$forSpaceInternal0(space, t3, t4, A._adjustChannel0(colorInSpace, t1[2], t5, A.SassNumber_SassNumber0(180, null)), t6)).toSpace$2$legacyMissing(t2, false);
            },
            $signature: 26
        };
        A._adjust_closure0.prototype = {
            call$1: function($arguments) {
                return A._updateComponents0($arguments, true, false, false);
            },
            $signature: 26
        };
        A._scale_closure0.prototype = {
            call$1: function($arguments) {
                return A._updateComponents0($arguments, false, false, true);
            },
            $signature: 26
        };
        A._change_closure0.prototype = {
            call$1: function($arguments) {
                return A._updateComponents0($arguments, false, true, false);
            },
            $signature: 26
        };
        A._ieHexStr_closure0.prototype = {
            call$1: function($arguments) {
                var t1, t2, t3, t4, t5, color = J.$index$asx($arguments, 0).assertColor$1("color").toSpace$1(B.RgbColorSpace_i0P0);
                color = color.get$isInGamut() ? color : B.LocalMindeGamutMap_A2x0.map$1(0, color);
                t1 = new A._ieHexStr_closure_hexString0();
                t2 = color.alphaOrNull;
                t2 = A.S(t1.call$1((t2 == null ? 0 : t2) * 255));
                t3 = color.channel0OrNull;
                t3 = A.S(t1.call$1(t3 == null ? 0 : t3));
                t4 = color.channel1OrNull;
                t4 = A.S(t1.call$1(t4 == null ? 0 : t4));
                t5 = color.channel2OrNull;
                return new A.SassString0("#" + t2 + t3 + t4 + A.S(t1.call$1(t5 == null ? 0 : t5)), false);
            },
            $signature: 18
        };
        A._ieHexStr_closure_hexString0.prototype = {
            call$1: function(component) {
                return B.JSString_methods.padLeft$2(B.JSInt_methods.toRadixString$1(A.fuzzyRound0(component), 16), 2, "0").toUpperCase();
            },
            $signature: 275
        };
        A._updateComponents_closure1.prototype = {
            call$1: function(space) {
                return this.originalColor.toSpace$2$legacyMissing(space, false);
            },
            $signature: 400
        };
        A._updateComponents_closure2.prototype = {
            call$1: function(info) {
                return this._box_0.name === info.name;
            },
            $signature: 67
        };
        A._changeColor_closure0.prototype = {
            call$0: function() {
                var t1 = this.alphaArg;
                A.warnForDeprecation0("$alpha: Passing a unit other than % (" + t1.toString$0(0) + string$.x29x20is_d_ + t1.unitSuggestion$1("alpha") + string$.x0a_See_, B.Deprecation_PHd);
                return t1.valueInRange$3(0, 1, "alpha");
            },
            $signature: 240
        };
        A._adjustColor_closure0.prototype = {
            call$1: function(alpha) {
                return isNaN(alpha) ? 0 : B.JSNumber_methods.clamp$2(alpha, 0, 1);
            },
            $signature: 12
        };
        A._functionString_closure0.prototype = {
            call$1: function(argument) {
                return A.serializeValue0(argument, false, true);
            },
            $signature: 228
        };
        A._removedColorFunction_closure0.prototype = {
            call$1: function($arguments) {
                var t1 = this.name, t2 = J.getInterceptor$asx($arguments), t3 = t2.$index($arguments, 0).toString$0(0), t4 = this.negative ? "-" : "";
                throw A.wrapException(A.SassScriptException$0("The function " + t1 + string$.x28__isn + t3 + ", $" + this.argument + ": " + t4 + t2.$index($arguments, 1).toString$0(0) + string$.x29x0a_Moro + t1, null));
            },
            $signature: 402
        };
        A._rgb_closure0.prototype = {
            call$1: function(alpha) {
                var t1 = A._percentageOrUnitless0(alpha.assertNumber$1("alpha"), 1, "alpha");
                return isNaN(t1) ? 0 : B.JSNumber_methods.clamp$2(t1, 0, 1);
            },
            $signature: 229
        };
        A._hsl_closure0.prototype = {
            call$1: function(alpha) {
                var t1 = A._percentageOrUnitless0(alpha.assertNumber$1("alpha"), 1, "alpha");
                return isNaN(t1) ? 0 : B.JSNumber_methods.clamp$2(t1, 0, 1);
            },
            $signature: 229
        };
        A._parseChannels_closure1.prototype = {
            call$1: function($name) {
                return $name + " channel";
            },
            $signature: 6
        };
        A._parseChannels_closure2.prototype = {
            call$1: function(channel) {
                return channel.get$isSpecialNumber();
            },
            $signature: 56
        };
        A._colorFromChannels_closure1.prototype = {
            call$1: function(channel0) {
                return A._angleValue0(channel0, "hue");
            },
            $signature: 100
        };
        A._colorFromChannels_closure2.prototype = {
            call$1: function(channel0) {
                return A._angleValue0(channel0, "hue");
            },
            $signature: 100
        };
        A._channelFromValue_closure0.prototype = {
            call$1: function(value) {
                var t1, _0_8, t2, _0_5, _0_8_isSet, upperClamped, t3, _0_0 = this.channel;
                $label0$0: {
                    t1 = _0_0 instanceof A.LinearChannel0;
                    if (t1 && _0_0.requiresPercent && !value.hasUnit$1("%")) A.throwExpression(A.SassScriptException$0("Expected " + value.toString$0(0) + ' to have unit "%".', _0_0.name));
                    _0_8 = null;
                    t2 = false;
                    if (t1) {
                        _0_5 = _0_0.lowerClamped;
                        _0_8_isSet = !_0_5;
                        if (_0_8_isSet) {
                            _0_8 = _0_0.upperClamped;
                            t2 = !_0_8;
                        }
                    } else {
                        _0_5 = null;
                        _0_8_isSet = false;
                    }
                    if (t2) {
                        t1 = A._percentageOrUnitless0(value, _0_0.max, _0_0.name);
                        break $label0$0;
                    }
                    if (t1 && !this.clamp) {
                        t1 = A._percentageOrUnitless0(value, _0_0.max, _0_0.name);
                        break $label0$0;
                    }
                    if (t1) {
                        upperClamped = _0_8_isSet ? _0_8 : _0_0.upperClamped;
                        t1 = _0_0.max;
                        t2 = A._percentageOrUnitless0(value, t1, _0_0.name);
                        t3 = _0_5 ? _0_0.min : -1 / 0;
                        t1 = upperClamped ? t1 : 1 / 0;
                        t1 = isNaN(t2) ? t3 : B.JSNumber_methods.clamp$2(t2, t3, t1);
                        break $label0$0;
                    }
                    t1 = B.JSNumber_methods.$mod(value.coerceValueToUnit$2("deg", _0_0.name), 360);
                    break $label0$0;
                }
                return t1;
            },
            $signature: 100
        };
        A._channelFunction_closure0.prototype = {
            call$1: function($arguments) {
                var _this = this, result = A.SassNumber_SassNumber0(_this.getter.call$1(J.get$first$ax($arguments).assertColor$1("color")), _this.unit), t1 = _this.global ? "" : "color.", t2 = _this.name;
                A.warnForDeprecation0(t1 + t2 + string$.x28__is_d + t2 + '", $space: ' + _this.space.toString$0(0) + string$.x29x0a_Mor_, B.Deprecation_hJG);
                return result;
            },
            $signature: 25
        };
        A._suggestScaleAndAdjust_closure0.prototype = {
            call$1: function(channel) {
                return channel.name === this.channelName;
            },
            $signature: 67
        };
        A.colorClass_closure.prototype = {
            call$0: function() {
                var t1 = type$.JSClass, jsClass = t1._as(A.allowInteropCaptureThisNamed("sass.SassColor", new A.colorClass__closure())), t2 = type$.String, t3 = type$.Function;
                A.LinkedHashMap_LinkedHashMap$_literal([
                    "equals",
                    new A.colorClass__closure0(),
                    "hashCode",
                    new A.colorClass__closure1(),
                    "toSpace",
                    new A.colorClass__closure2(),
                    "isInGamut",
                    new A.colorClass__closure3(),
                    "toGamut",
                    new A.colorClass__closure4(),
                    "channel",
                    new A.colorClass__closure5(),
                    "isChannelMissing",
                    new A.colorClass__closure6(),
                    "isChannelPowerless",
                    new A.colorClass__closure7(),
                    "change",
                    new A.colorClass__closure8(),
                    "interpolate",
                    new A.colorClass__closure9()
                ], t2, t3).forEach$1(0, A.JSClassExtension_get_defineMethod(jsClass));
                A.LinkedHashMap_LinkedHashMap$_literal([
                    "red",
                    new A.colorClass__closure10(),
                    "green",
                    new A.colorClass__closure11(),
                    "blue",
                    new A.colorClass__closure12(),
                    "hue",
                    new A.colorClass__closure13(),
                    "saturation",
                    new A.colorClass__closure14(),
                    "lightness",
                    new A.colorClass__closure15(),
                    "whiteness",
                    new A.colorClass__closure16(),
                    "blackness",
                    new A.colorClass__closure17(),
                    "alpha",
                    new A.colorClass__closure18(),
                    "space",
                    new A.colorClass__closure19(),
                    "isLegacy",
                    new A.colorClass__closure20(),
                    "channelsOrNull",
                    new A.colorClass__closure21(),
                    "channels",
                    new A.colorClass__closure22()
                ], t2, t3).forEach$1(0, A.JSClassExtension_get_defineGetter(jsClass));
                A.JSClassExtension_injectSuperclass(t1._as(A.SassColor_SassColor$rgbInternal0(0, 0, 0, 1, null).constructor), jsClass);
                return jsClass;
            },
            $signature: 17
        };
        A.colorClass__closure.prototype = {
            call$2: function($self, options) {
                var t1, t2, t3, t4, _null = null;
                switch(A._constructionSpace(options)){
                    case B.RgbColorSpace_i0P0:
                        A._checkNullAlphaDeprecation(options);
                        t1 = J.getInterceptor$x(options);
                        t2 = t1.get$red(options);
                        t3 = t1.get$green(options);
                        t4 = t1.get$blue(options);
                        t1 = t1.get$alpha(options);
                        return A.SassColor_SassColor$rgbInternal0(t2, t3, t4, A._asBool($.$get$_isUndefined().call$1(t1)) ? 1 : t1, _null);
                    case B.HslColorSpace_JQ20:
                        A._checkNullAlphaDeprecation(options);
                        t1 = J.getInterceptor$x(options);
                        t2 = t1.get$hue(options);
                        t3 = t1.get$saturation(options);
                        t4 = t1.get$lightness(options);
                        t1 = t1.get$alpha(options);
                        return A.SassColor_SassColor$hsl0(t2, t3, t4, A._asBool($.$get$_isUndefined().call$1(t1)) ? 1 : t1);
                    case B.HwbColorSpace_guQ0:
                        A._checkNullAlphaDeprecation(options);
                        t1 = J.getInterceptor$x(options);
                        t2 = t1.get$hue(options);
                        t3 = t1.get$whiteness(options);
                        t4 = t1.get$blackness(options);
                        t1 = t1.get$alpha(options);
                        return A.SassColor_SassColor$hwb0(t2, t3, t4, A._asBool($.$get$_isUndefined().call$1(t1)) ? 1 : t1);
                    case B.LabColorSpace_2nT0:
                        t1 = J.getInterceptor$x(options);
                        t2 = t1.get$lightness(options);
                        t3 = t1.get$a(options);
                        t4 = t1.get$b(options);
                        t1 = t1.get$alpha(options);
                        return A.SassColor$_forSpace0(B.LabColorSpace_2nT0, t2, t3, t4, A._asBool($.$get$_isUndefined().call$1(t1)) ? 1 : t1, _null);
                    case B.OklabColorSpace_5400:
                        t1 = J.getInterceptor$x(options);
                        t2 = t1.get$lightness(options);
                        t3 = t1.get$a(options);
                        t4 = t1.get$b(options);
                        t1 = t1.get$alpha(options);
                        return A.SassColor$_forSpace0(B.OklabColorSpace_5400, t2, t3, t4, A._asBool($.$get$_isUndefined().call$1(t1)) ? 1 : t1, _null);
                    case B.LchColorSpace_Bpv0:
                        t1 = J.getInterceptor$x(options);
                        t2 = t1.get$lightness(options);
                        t3 = t1.get$chroma(options);
                        t4 = t1.get$hue(options);
                        t1 = t1.get$alpha(options);
                        return A.SassColor_SassColor$forSpaceInternal0(B.LchColorSpace_Bpv0, t2, t3, t4, A._asBool($.$get$_isUndefined().call$1(t1)) ? 1 : t1);
                    case B.OklchColorSpace_9Gj0:
                        t1 = J.getInterceptor$x(options);
                        t2 = t1.get$lightness(options);
                        t3 = t1.get$chroma(options);
                        t4 = t1.get$hue(options);
                        t1 = t1.get$alpha(options);
                        return A.SassColor_SassColor$forSpaceInternal0(B.OklchColorSpace_9Gj0, t2, t3, t4, A._asBool($.$get$_isUndefined().call$1(t1)) ? 1 : t1);
                    case B.SrgbColorSpace_thf0:
                        t1 = J.getInterceptor$x(options);
                        t2 = t1.get$red(options);
                        t3 = t1.get$green(options);
                        t4 = t1.get$blue(options);
                        t1 = t1.get$alpha(options);
                        return A.SassColor$_forSpace0(B.SrgbColorSpace_thf0, t2, t3, t4, A._asBool($.$get$_isUndefined().call$1(t1)) ? 1 : t1, _null);
                    case B.SrgbLinearColorSpace_kUj0:
                        t1 = J.getInterceptor$x(options);
                        t2 = t1.get$red(options);
                        t3 = t1.get$green(options);
                        t4 = t1.get$blue(options);
                        t1 = t1.get$alpha(options);
                        return A.SassColor$_forSpace0(B.SrgbLinearColorSpace_kUj0, t2, t3, t4, A._asBool($.$get$_isUndefined().call$1(t1)) ? 1 : t1, _null);
                    case B.DisplayP3ColorSpace_MmT0:
                        t1 = J.getInterceptor$x(options);
                        t2 = t1.get$red(options);
                        t3 = t1.get$green(options);
                        t4 = t1.get$blue(options);
                        t1 = t1.get$alpha(options);
                        return A.SassColor$_forSpace0(B.DisplayP3ColorSpace_MmT0, t2, t3, t4, A._asBool($.$get$_isUndefined().call$1(t1)) ? 1 : t1, _null);
                    case B.DisplayP3LinearColorSpace_PrP0:
                        t1 = J.getInterceptor$x(options);
                        t2 = t1.get$red(options);
                        t3 = t1.get$green(options);
                        t4 = t1.get$blue(options);
                        t1 = t1.get$alpha(options);
                        return A.SassColor$_forSpace0(B.DisplayP3LinearColorSpace_PrP0, t2, t3, t4, A._asBool($.$get$_isUndefined().call$1(t1)) ? 1 : t1, _null);
                    case B.A98RgbColorSpace_lf20:
                        t1 = J.getInterceptor$x(options);
                        t2 = t1.get$red(options);
                        t3 = t1.get$green(options);
                        t4 = t1.get$blue(options);
                        t1 = t1.get$alpha(options);
                        return A.SassColor$_forSpace0(B.A98RgbColorSpace_lf20, t2, t3, t4, A._asBool($.$get$_isUndefined().call$1(t1)) ? 1 : t1, _null);
                    case B.ProphotoRgbColorSpace_BDz0:
                        t1 = J.getInterceptor$x(options);
                        t2 = t1.get$red(options);
                        t3 = t1.get$green(options);
                        t4 = t1.get$blue(options);
                        t1 = t1.get$alpha(options);
                        return A.SassColor$_forSpace0(B.ProphotoRgbColorSpace_BDz0, t2, t3, t4, A._asBool($.$get$_isUndefined().call$1(t1)) ? 1 : t1, _null);
                    case B.Rec2020ColorSpace_6oo0:
                        t1 = J.getInterceptor$x(options);
                        t2 = t1.get$red(options);
                        t3 = t1.get$green(options);
                        t4 = t1.get$blue(options);
                        t1 = t1.get$alpha(options);
                        return A.SassColor$_forSpace0(B.Rec2020ColorSpace_6oo0, t2, t3, t4, A._asBool($.$get$_isUndefined().call$1(t1)) ? 1 : t1, _null);
                    case B.XyzD50ColorSpace_2OB0:
                        t1 = J.getInterceptor$x(options);
                        t2 = t1.get$x(options);
                        t3 = t1.get$y(options);
                        t4 = t1.get$z(options);
                        t1 = t1.get$alpha(options);
                        return A.SassColor$_forSpace0(B.XyzD50ColorSpace_2OB0, t2, t3, t4, A._asBool($.$get$_isUndefined().call$1(t1)) ? 1 : t1, _null);
                    case B.XyzD65ColorSpace_WiJ0:
                        t1 = J.getInterceptor$x(options);
                        t2 = t1.get$x(options);
                        t3 = t1.get$y(options);
                        t4 = t1.get$z(options);
                        t1 = t1.get$alpha(options);
                        return A.SassColor$_forSpace0(B.XyzD65ColorSpace_WiJ0, t2, t3, t4, A._asBool($.$get$_isUndefined().call$1(t1)) ? 1 : t1, _null);
                    default:
                        throw A.wrapException("Unreachable");
                }
            },
            $signature: 405
        };
        A.colorClass__closure0.prototype = {
            call$2: function($self, other) {
                return $self.$eq(0, other);
            },
            $signature: 406
        };
        A.colorClass__closure1.prototype = {
            call$1: function($self) {
                return $self.get$hashCode(0);
            },
            $signature: 39
        };
        A.colorClass__closure2.prototype = {
            call$2: function($self, space) {
                return A._toSpace($self, space);
            },
            $signature: 407
        };
        A.colorClass__closure3.prototype = {
            call$2: function($self, space) {
                return A._toSpace($self, space).get$isInGamut();
            },
            call$1: function($self) {
                return this.call$2($self, null);
            },
            "call*": "call$2",
            $requiredArgCount: 1,
            $defaultValues: function() {
                return [
                    null
                ];
            },
            $signature: 408
        };
        A.colorClass__closure4.prototype = {
            call$2: function($self, options) {
                var t1 = J.getInterceptor$x(options), t2 = A._toSpace($self, t1.get$space(options));
                t1 = A.GamutMapMethod_GamutMapMethod$fromName0(t1.get$method(options));
                t1 = t2.get$isInGamut() ? t2 : t1.map$1(0, t2);
                return t1.toSpace$1($self._color0$_space);
            },
            $signature: 409
        };
        A.colorClass__closure5.prototype = {
            call$3: function($self, channel, options) {
                return A._toSpace($self, options == null ? null : J.get$space$x(options)).channel$1(0, channel);
            },
            call$2: function($self, channel) {
                return this.call$3($self, channel, null);
            },
            "call*": "call$3",
            $requiredArgCount: 2,
            $defaultValues: function() {
                return [
                    null
                ];
            },
            $signature: 410
        };
        A.colorClass__closure6.prototype = {
            call$2: function($self, channel) {
                return $self.isChannelMissing$1(channel);
            },
            $signature: 411
        };
        A.colorClass__closure7.prototype = {
            call$3: function($self, channel, options) {
                return A._toSpace($self, options == null ? null : J.get$space$x(options)).isChannelPowerless$1(channel);
            },
            call$2: function($self, channel) {
                return this.call$3($self, channel, null);
            },
            "call*": "call$3",
            $requiredArgCount: 2,
            $defaultValues: function() {
                return [
                    null
                ];
            },
            $signature: 412
        };
        A.colorClass__closure8.prototype = {
            call$2: function($self, options) {
                var t3, space, t4, t5, t6, color, changedValue, _0_2, changedColor, _0_4, _0_6, _null = null, _s9_ = "whiteness", _s9_0 = "blackness", _s3_ = "hue", _s10_ = "saturation", _s9_1 = "lightness", _s3_0 = "red", _s5_ = "green", _s4_ = "blue", _s5_0 = "alpha", _s106_ = string$.Passin_, _s105_ = "Passing `hue: null` without setting `space` is deprecated.\nMore info: https://sass-lang.com/d/color-4-api", t1 = J.getInterceptor$x(options), t2 = t1.get$space(options) == null, spaceSetExplicitly = !t2;
                if (spaceSetExplicitly) {
                    t3 = t1.get$space(options);
                    t3.toString;
                    space = A.ColorSpace_fromName0(t3, _null);
                } else space = $self._color0$_space;
                t3 = $self._color0$_space;
                if (t3.get$isLegacyInternal() && t2) {
                    if ("whiteness" in options || "blackness" in options) space = B.HwbColorSpace_guQ0;
                    else if ("hue" in options && t3 === B.HwbColorSpace_guQ0) space = B.HwbColorSpace_guQ0;
                    else if ("hue" in options || "saturation" in options || "lightness" in options) space = B.HslColorSpace_JQ20;
                    else if ("red" in options || "green" in options || "blue" in options) space = B.RgbColorSpace_i0P0;
                    if (space !== t3) A.warnForDeprecationFromApi("Changing a channel not in this color's space without explicitly specifying the `space` option is deprecated.\nMore info: https://sass-lang.com/d/color-4-api", B.Deprecation_alT);
                }
                for(t2 = J.get$iterator$ax(self.Object.keys(options)), t4 = space._space$_channels, t5 = type$.JSArray_String; t2.moveNext$0();){
                    t6 = t2.get$current(t2);
                    if (B.JSArray_methods.contains$1(A._setArrayType([
                        "alpha",
                        "space"
                    ], t5), t6)) continue;
                    if (!B.JSArray_methods.any$1(t4, new A.colorClass___closure(t6))) A.jsThrow(new self.Error("`" + t6 + "` is not a valid channel in `" + space.toString$0(0) + "`."));
                }
                color = $self.toSpace$1(space);
                changedValue = new A.colorClass__closure_changedValue(color, options);
                $label0$2: {
                    _0_2 = B.HslColorSpace_JQ20 === space;
                    if (_0_2 && spaceSetExplicitly) {
                        changedColor = A.SassColor_SassColor$hsl0(changedValue.call$1(_s3_), changedValue.call$1(_s10_), changedValue.call$1(_s9_1), changedValue.call$1(_s5_0));
                        break $label0$2;
                    }
                    if (_0_2) {
                        t2 = t1.get$hue(options);
                        t4 = $.$get$_isNull();
                        if (A._asBool(t4.call$1(t2))) A.warnForDeprecationFromApi(_s105_, B.Deprecation_alT);
                        else if (A._asBool(t4.call$1(t1.get$saturation(options)))) A.warnForDeprecationFromApi("Passing `saturation: null` without setting `space` is deprecated.\nMore info: https://sass-lang.com/d/color-4-api", B.Deprecation_alT);
                        else if (A._asBool(t4.call$1(t1.get$lightness(options)))) A.warnForDeprecationFromApi("Passing `lightness: null` without setting `space` is deprecated.\nMore info: https://sass-lang.com/d/color-4-api", B.Deprecation_alT);
                        if (A._asBool(t4.call$1(t1.get$alpha(options)))) A.warnForDeprecationFromApi(_s106_, B.Deprecation_ox0);
                        t2 = t1.get$hue(options);
                        if (t2 == null) t2 = color.channel$1(0, _s3_);
                        t4 = t1.get$saturation(options);
                        if (t4 == null) t4 = color.channel$1(0, _s10_);
                        t5 = t1.get$lightness(options);
                        if (t5 == null) t5 = color.channel$1(0, _s9_1);
                        t1 = t1.get$alpha(options);
                        changedColor = A.SassColor_SassColor$hsl0(t2, t4, t5, t1 == null ? color.channel$1(0, _s5_0) : t1);
                        break $label0$2;
                    }
                    _0_4 = B.HwbColorSpace_guQ0 === space;
                    if (_0_4 && spaceSetExplicitly) {
                        changedColor = A.SassColor_SassColor$hwb0(changedValue.call$1(_s3_), changedValue.call$1(_s9_), changedValue.call$1(_s9_0), changedValue.call$1(_s5_0));
                        break $label0$2;
                    }
                    if (_0_4) {
                        t2 = t1.get$hue(options);
                        t4 = $.$get$_isNull();
                        if (A._asBool(t4.call$1(t2))) A.warnForDeprecationFromApi(_s105_, B.Deprecation_alT);
                        else if (A._asBool(t4.call$1(t1.get$whiteness(options)))) A.warnForDeprecationFromApi("Passing `whiteness: null` without setting `space` is deprecated.\nMore info: https://sass-lang.com/d/color-4-api", B.Deprecation_alT);
                        else if (A._asBool(t4.call$1(t1.get$blackness(options)))) A.warnForDeprecationFromApi("Passing `blackness: null` without setting `space` is deprecated.\nMore info: https://sass-lang.com/d/color-4-api", B.Deprecation_alT);
                        if (A._asBool(t4.call$1(t1.get$alpha(options)))) A.warnForDeprecationFromApi(_s106_, B.Deprecation_ox0);
                        t2 = t1.get$hue(options);
                        if (t2 == null) t2 = color.channel$1(0, _s3_);
                        t4 = t1.get$whiteness(options);
                        if (t4 == null) t4 = color.channel$1(0, _s9_);
                        t5 = t1.get$blackness(options);
                        if (t5 == null) t5 = color.channel$1(0, _s9_0);
                        t1 = t1.get$alpha(options);
                        changedColor = A.SassColor_SassColor$hwb0(t2, t4, t5, t1 == null ? color.channel$1(0, _s5_0) : t1);
                        break $label0$2;
                    }
                    _0_6 = B.RgbColorSpace_i0P0 === space;
                    if (_0_6 && spaceSetExplicitly) {
                        changedColor = A.SassColor_SassColor$rgbInternal0(changedValue.call$1(_s3_0), changedValue.call$1(_s5_), changedValue.call$1(_s4_), changedValue.call$1(_s5_0), _null);
                        break $label0$2;
                    }
                    if (_0_6) {
                        t2 = t1.get$red(options);
                        t4 = $.$get$_isNull();
                        if (A._asBool(t4.call$1(t2))) A.warnForDeprecationFromApi("Passing `red: null` without setting `space` is deprecated.\nMore info: https://sass-lang.com/d/color-4-api", B.Deprecation_alT);
                        else if (A._asBool(t4.call$1(t1.get$green(options)))) A.warnForDeprecationFromApi("Passing `green: null` without setting `space` is deprecated.\nMore info: https://sass-lang.com/d/color-4-api", B.Deprecation_alT);
                        else if (A._asBool(t4.call$1(t1.get$blue(options)))) A.warnForDeprecationFromApi("Passing `blue: null` without setting `space` is deprecated.\nMore info: https://sass-lang.com/d/color-4-api", B.Deprecation_alT);
                        if (A._asBool(t4.call$1(t1.get$alpha(options)))) A.warnForDeprecationFromApi(_s106_, B.Deprecation_ox0);
                        t2 = t1.get$red(options);
                        if (t2 == null) t2 = color.channel$1(0, _s3_0);
                        t4 = t1.get$green(options);
                        if (t4 == null) t4 = color.channel$1(0, _s5_);
                        t5 = t1.get$blue(options);
                        if (t5 == null) t5 = color.channel$1(0, _s4_);
                        t1 = t1.get$alpha(options);
                        changedColor = A.SassColor_SassColor$rgbInternal0(t2, t4, t5, t1 == null ? color.channel$1(0, _s5_0) : t1, _null);
                        break $label0$2;
                    }
                    if (B.LabColorSpace_2nT0 === space) {
                        changedColor = A.SassColor$_forSpace0(B.LabColorSpace_2nT0, changedValue.call$1(_s9_1), changedValue.call$1("a"), changedValue.call$1("b"), changedValue.call$1(_s5_0), _null);
                        break $label0$2;
                    }
                    if (B.OklabColorSpace_5400 === space) {
                        changedColor = A.SassColor$_forSpace0(B.OklabColorSpace_5400, changedValue.call$1(_s9_1), changedValue.call$1("a"), changedValue.call$1("b"), changedValue.call$1(_s5_0), _null);
                        break $label0$2;
                    }
                    if (B.LchColorSpace_Bpv0 === space) {
                        changedColor = A.SassColor_SassColor$forSpaceInternal0(B.LchColorSpace_Bpv0, changedValue.call$1(_s9_1), changedValue.call$1("chroma"), changedValue.call$1(_s3_), changedValue.call$1(_s5_0));
                        break $label0$2;
                    }
                    if (B.OklchColorSpace_9Gj0 === space) {
                        changedColor = A.SassColor_SassColor$forSpaceInternal0(B.OklchColorSpace_9Gj0, changedValue.call$1(_s9_1), changedValue.call$1("chroma"), changedValue.call$1(_s3_), changedValue.call$1(_s5_0));
                        break $label0$2;
                    }
                    if (B.A98RgbColorSpace_lf20 === space) {
                        changedColor = A.SassColor$_forSpace0(B.A98RgbColorSpace_lf20, changedValue.call$1(_s3_0), changedValue.call$1(_s5_), changedValue.call$1(_s4_), changedValue.call$1(_s5_0), _null);
                        break $label0$2;
                    }
                    if (B.DisplayP3ColorSpace_MmT0 === space) {
                        changedColor = A.SassColor$_forSpace0(B.DisplayP3ColorSpace_MmT0, changedValue.call$1(_s3_0), changedValue.call$1(_s5_), changedValue.call$1(_s4_), changedValue.call$1(_s5_0), _null);
                        break $label0$2;
                    }
                    if (B.DisplayP3LinearColorSpace_PrP0 === space) {
                        changedColor = A.SassColor$_forSpace0(B.DisplayP3LinearColorSpace_PrP0, changedValue.call$1(_s3_0), changedValue.call$1(_s5_), changedValue.call$1(_s4_), changedValue.call$1(_s5_0), _null);
                        break $label0$2;
                    }
                    if (B.ProphotoRgbColorSpace_BDz0 === space) {
                        changedColor = A.SassColor$_forSpace0(B.ProphotoRgbColorSpace_BDz0, changedValue.call$1(_s3_0), changedValue.call$1(_s5_), changedValue.call$1(_s4_), changedValue.call$1(_s5_0), _null);
                        break $label0$2;
                    }
                    if (B.Rec2020ColorSpace_6oo0 === space) {
                        changedColor = A.SassColor$_forSpace0(B.Rec2020ColorSpace_6oo0, changedValue.call$1(_s3_0), changedValue.call$1(_s5_), changedValue.call$1(_s4_), changedValue.call$1(_s5_0), _null);
                        break $label0$2;
                    }
                    if (B.SrgbColorSpace_thf0 === space) {
                        changedColor = A.SassColor$_forSpace0(B.SrgbColorSpace_thf0, changedValue.call$1(_s3_0), changedValue.call$1(_s5_), changedValue.call$1(_s4_), changedValue.call$1(_s5_0), _null);
                        break $label0$2;
                    }
                    if (B.SrgbLinearColorSpace_kUj0 === space) {
                        changedColor = A.SassColor$_forSpace0(B.SrgbLinearColorSpace_kUj0, changedValue.call$1(_s3_0), changedValue.call$1(_s5_), changedValue.call$1(_s4_), changedValue.call$1(_s5_0), _null);
                        break $label0$2;
                    }
                    if (B.XyzD50ColorSpace_2OB0 === space) {
                        changedColor = A.SassColor_SassColor$forSpaceInternal0(space, changedValue.call$1("x"), changedValue.call$1("y"), changedValue.call$1("z"), changedValue.call$1(_s5_0));
                        break $label0$2;
                    }
                    if (B.XyzD65ColorSpace_WiJ0 === space) {
                        changedColor = A.SassColor_SassColor$forSpaceInternal0(space, changedValue.call$1("x"), changedValue.call$1("y"), changedValue.call$1("z"), changedValue.call$1(_s5_0));
                        break $label0$2;
                    }
                    throw A.wrapException("No space set");
                }
                return changedColor.toSpace$1(t3);
            },
            $signature: 413
        };
        A.colorClass___closure.prototype = {
            call$1: function(channel) {
                return channel.name === this.key;
            },
            $signature: 67
        };
        A.colorClass__closure_changedValue.prototype = {
            call$1: function(channel) {
                var t2, t1 = this.options;
                if (channel in t1) {
                    t2 = t1[channel];
                    t2 = !A._asBool($.$get$_isUndefined().call$1(t2));
                } else t2 = false;
                return t2 ? t1[channel] : this.color.channel$1(0, channel);
            },
            $signature: 414
        };
        A.colorClass__closure9.prototype = {
            call$3: function($self, color2, options) {
                var interpolationMethod, t2, t1 = options == null, _1_0 = t1 ? null : J.get$method$x(options);
                if (_1_0 != null) interpolationMethod = A.InterpolationMethod$0($self._color0$_space, A.EnumByName_byName(B.List_mRc, _1_0));
                else {
                    t2 = $self._color0$_space;
                    interpolationMethod = !t2.get$isPolarInternal() ? A.InterpolationMethod$0(t2, null) : A.InterpolationMethod$0(t2, B.HueInterpolationMethod_00);
                }
                return $self.interpolate$3$weight(color2, interpolationMethod, t1 ? null : J.get$weight$x(options));
            },
            call$2: function($self, color2) {
                return this.call$3($self, color2, null);
            },
            "call*": "call$3",
            $requiredArgCount: 2,
            $defaultValues: function() {
                return [
                    null
                ];
            },
            $signature: 415
        };
        A.colorClass__closure10.prototype = {
            call$1: function($self) {
                A.warnForDeprecationFromApi("red is deprecated, use `channel` instead.\nMore info: https://sass-lang.com/d/color-4-api", B.Deprecation_alT);
                return B.JSNumber_methods.round$0($self._color0$_legacyChannel$2(B.RgbColorSpace_i0P0, "red"));
            },
            $signature: 39
        };
        A.colorClass__closure11.prototype = {
            call$1: function($self) {
                A.warnForDeprecationFromApi("green is deprecated, use `channel` instead.\nMore info: https://sass-lang.com/d/color-4-api", B.Deprecation_alT);
                return B.JSNumber_methods.round$0($self._color0$_legacyChannel$2(B.RgbColorSpace_i0P0, "green"));
            },
            $signature: 39
        };
        A.colorClass__closure12.prototype = {
            call$1: function($self) {
                A.warnForDeprecationFromApi("blue is deprecated, use `channel` instead.\nMore info: https://sass-lang.com/d/color-4-api", B.Deprecation_alT);
                return B.JSNumber_methods.round$0($self._color0$_legacyChannel$2(B.RgbColorSpace_i0P0, "blue"));
            },
            $signature: 39
        };
        A.colorClass__closure13.prototype = {
            call$1: function($self) {
                A.warnForDeprecationFromApi("hue is deprecated, use `channel` instead.\nMore info: https://sass-lang.com/d/color-4-api", B.Deprecation_alT);
                return $self._color0$_legacyChannel$2(B.HslColorSpace_JQ20, "hue");
            },
            $signature: 30
        };
        A.colorClass__closure14.prototype = {
            call$1: function($self) {
                A.warnForDeprecationFromApi("saturation is deprecated, use `channel` instead.\nMore info: https://sass-lang.com/d/color-4-api", B.Deprecation_alT);
                return $self._color0$_legacyChannel$2(B.HslColorSpace_JQ20, "saturation");
            },
            $signature: 30
        };
        A.colorClass__closure15.prototype = {
            call$1: function($self) {
                A.warnForDeprecationFromApi("lightness is deprecated, use `channel` instead.\nMore info: https://sass-lang.com/d/color-4-api", B.Deprecation_alT);
                return $self._color0$_legacyChannel$2(B.HslColorSpace_JQ20, "lightness");
            },
            $signature: 30
        };
        A.colorClass__closure16.prototype = {
            call$1: function($self) {
                A.warnForDeprecationFromApi("whiteness is deprecated, use `channel` instead.\nMore info: https://sass-lang.com/d/color-4-api", B.Deprecation_alT);
                return $self._color0$_legacyChannel$2(B.HwbColorSpace_guQ0, "whiteness");
            },
            $signature: 30
        };
        A.colorClass__closure17.prototype = {
            call$1: function($self) {
                A.warnForDeprecationFromApi("blackness is deprecated, use `channel` instead.\nMore info: https://sass-lang.com/d/color-4-api", B.Deprecation_alT);
                return $self._color0$_legacyChannel$2(B.HwbColorSpace_guQ0, "blackness");
            },
            $signature: 30
        };
        A.colorClass__closure18.prototype = {
            call$1: function($self) {
                var t1 = $self.alphaOrNull;
                return t1 == null ? 0 : t1;
            },
            $signature: 30
        };
        A.colorClass__closure19.prototype = {
            call$1: function($self) {
                return $self._color0$_space.name;
            },
            $signature: 416
        };
        A.colorClass__closure20.prototype = {
            call$1: function($self) {
                return $self._color0$_space.get$isLegacyInternal();
            },
            $signature: 417
        };
        A.colorClass__closure21.prototype = {
            call$1: function($self) {
                return new self.immutable.List($self.get$channelsOrNull());
            },
            $signature: 230
        };
        A.colorClass__closure22.prototype = {
            call$1: function($self) {
                return new self.immutable.List($self.get$channels());
            },
            $signature: 230
        };
        A._Channels.prototype = {};
        A._ConstructionOptions.prototype = {};
        A._ChannelOptions.prototype = {};
        A._ToGamutOptions.prototype = {};
        A._InterpolationOptions.prototype = {};
        A._NodeSassColor.prototype = {};
        A.legacyColorClass_closure.prototype = {
            call$6: function(thisArg, redOrArgb, green, blue, alpha, dartValue) {
                var red, t1, t2, t3, t4;
                if (dartValue != null) {
                    J.set$dartValue$x(thisArg, dartValue);
                    return;
                }
                if (green == null || blue == null) {
                    A._asInt(redOrArgb);
                    alpha = B.JSInt_methods._shrOtherPositive$1(redOrArgb, 24) / 255;
                    red = B.JSInt_methods.$mod(B.JSInt_methods._shrOtherPositive$1(redOrArgb, 16), 256);
                    green = B.JSInt_methods.$mod(B.JSInt_methods._shrOtherPositive$1(redOrArgb, 8), 256);
                    blue = B.JSInt_methods.$mod(redOrArgb, 256);
                } else {
                    redOrArgb.toString;
                    red = redOrArgb;
                }
                t1 = A.fuzzyRound0(isNaN(red) ? 0 : B.JSNumber_methods.clamp$2(red, 0, 255));
                t2 = A.fuzzyRound0(isNaN(green) ? 0 : B.JSNumber_methods.clamp$2(green, 0, 255));
                t3 = A.fuzzyRound0(isNaN(blue) ? 0 : B.JSNumber_methods.clamp$2(blue, 0, 255));
                t4 = A.NullableExtension_andThen0(alpha, new A.legacyColorClass__closure());
                J.set$dartValue$x(thisArg, A.SassColor_SassColor$rgbInternal0(t1, t2, t3, t4 == null ? 1 : t4, null));
            },
            call$2: function(thisArg, redOrArgb) {
                var _null = null;
                return this.call$6(thisArg, redOrArgb, _null, _null, _null, _null);
            },
            call$3: function(thisArg, redOrArgb, green) {
                return this.call$6(thisArg, redOrArgb, green, null, null, null);
            },
            call$4: function(thisArg, redOrArgb, green, blue) {
                return this.call$6(thisArg, redOrArgb, green, blue, null, null);
            },
            call$5: function(thisArg, redOrArgb, green, blue, alpha) {
                return this.call$6(thisArg, redOrArgb, green, blue, alpha, null);
            },
            "call*": "call$6",
            $requiredArgCount: 2,
            $defaultValues: function() {
                return [
                    null,
                    null,
                    null,
                    null
                ];
            },
            $signature: 419
        };
        A.legacyColorClass__closure.prototype = {
            call$1: function(alpha) {
                return isNaN(alpha) ? 0 : B.JSNumber_methods.clamp$2(alpha, 0, 1);
            },
            $signature: 420
        };
        A.legacyColorClass_closure0.prototype = {
            call$1: function(thisArg) {
                return B.JSNumber_methods.round$0(J.get$dartValue$x(thisArg)._color0$_legacyChannel$2(B.RgbColorSpace_i0P0, "red"));
            },
            $signature: 124
        };
        A.legacyColorClass_closure1.prototype = {
            call$1: function(thisArg) {
                return B.JSNumber_methods.round$0(J.get$dartValue$x(thisArg)._color0$_legacyChannel$2(B.RgbColorSpace_i0P0, "green"));
            },
            $signature: 124
        };
        A.legacyColorClass_closure2.prototype = {
            call$1: function(thisArg) {
                return B.JSNumber_methods.round$0(J.get$dartValue$x(thisArg)._color0$_legacyChannel$2(B.RgbColorSpace_i0P0, "blue"));
            },
            $signature: 124
        };
        A.legacyColorClass_closure3.prototype = {
            call$1: function(thisArg) {
                var t1 = J.get$dartValue$x(thisArg).alphaOrNull;
                return t1 == null ? 0 : t1;
            },
            $signature: 422
        };
        A.legacyColorClass_closure4.prototype = {
            call$2: function(thisArg, value) {
                var t1 = J.getInterceptor$x(thisArg), t2 = t1.get$dartValue(thisArg);
                t1.set$dartValue(thisArg, t2.changeRgb$1$red(A.fuzzyRound0(isNaN(value) ? 0 : B.JSNumber_methods.clamp$2(value, 0, 255))));
            },
            $signature: 106
        };
        A.legacyColorClass_closure5.prototype = {
            call$2: function(thisArg, value) {
                var t1 = J.getInterceptor$x(thisArg), t2 = t1.get$dartValue(thisArg);
                t1.set$dartValue(thisArg, t2.changeRgb$1$green(A.fuzzyRound0(isNaN(value) ? 0 : B.JSNumber_methods.clamp$2(value, 0, 255))));
            },
            $signature: 106
        };
        A.legacyColorClass_closure6.prototype = {
            call$2: function(thisArg, value) {
                var t1 = J.getInterceptor$x(thisArg), t2 = t1.get$dartValue(thisArg);
                t1.set$dartValue(thisArg, t2.changeRgb$1$blue(A.fuzzyRound0(isNaN(value) ? 0 : B.JSNumber_methods.clamp$2(value, 0, 255))));
            },
            $signature: 106
        };
        A.legacyColorClass_closure7.prototype = {
            call$2: function(thisArg, value) {
                var t1 = J.getInterceptor$x(thisArg), t2 = t1.get$dartValue(thisArg);
                t1.set$dartValue(thisArg, t2.changeRgb$1$alpha(isNaN(value) ? 0 : B.JSNumber_methods.clamp$2(value, 0, 1)));
            },
            $signature: 106
        };
        A.SassColor0.prototype = {
            get$channels: function() {
                var t2, t3, t1 = this.channel0OrNull;
                if (t1 == null) t1 = 0;
                t2 = this.channel1OrNull;
                if (t2 == null) t2 = 0;
                t3 = this.channel2OrNull;
                return A.List_List$unmodifiable([
                    t1,
                    t2,
                    t3 == null ? 0 : t3
                ], type$.double);
            },
            get$channelsOrNull: function() {
                return A.List_List$unmodifiable([
                    this.channel0OrNull,
                    this.channel1OrNull,
                    this.channel2OrNull
                ], type$.nullable_double);
            },
            get$isChannel0Powerless: function() {
                var t1, t2, _this = this, _0_0 = _this._color0$_space;
                $label0$0: {
                    if (B.HslColorSpace_JQ20 === _0_0) {
                        t1 = _this.channel1OrNull;
                        t1 = A.fuzzyEquals0(t1 == null ? 0 : t1, 0);
                        break $label0$0;
                    }
                    if (B.HwbColorSpace_guQ0 === _0_0) {
                        t1 = _this.channel1OrNull;
                        if (t1 == null) t1 = 0;
                        t2 = _this.channel2OrNull;
                        t1 += t2 == null ? 0 : t2;
                        t1 = t1 > 100 || A.fuzzyEquals0(t1, 100);
                        break $label0$0;
                    }
                    t1 = false;
                    break $label0$0;
                }
                return t1;
            },
            get$isChannel2Powerless: function() {
                var t1, _0_0 = this._color0$_space;
                $label0$0: {
                    if (B.LchColorSpace_Bpv0 === _0_0 || B.OklchColorSpace_9Gj0 === _0_0) {
                        t1 = this.channel1OrNull;
                        t1 = A.fuzzyEquals0(t1 == null ? 0 : t1, 0);
                        break $label0$0;
                    }
                    t1 = false;
                    break $label0$0;
                }
                return t1;
            },
            get$isInGamut: function() {
                var t2, t3, _this = this, t1 = _this._color0$_space;
                if (!t1.get$isBoundedInternal()) return true;
                t2 = _this.channel0OrNull;
                if (t2 == null) t2 = 0;
                t1 = t1._space$_channels;
                t3 = false;
                if (_this._color0$_isChannelInGamut$2(t2, t1[0])) {
                    t2 = _this.channel1OrNull;
                    if (t2 == null) t2 = 0;
                    if (_this._color0$_isChannelInGamut$2(t2, t1[1])) {
                        t2 = _this.channel2OrNull;
                        if (t2 == null) t2 = 0;
                        t1 = _this._color0$_isChannelInGamut$2(t2, t1[2]);
                    } else t1 = t3;
                } else t1 = t3;
                return t1;
            },
            _color0$_isChannelInGamut$2: function(value, channel) {
                var min, max, t1;
                $label0$0: {
                    if (channel instanceof A.LinearChannel0) {
                        min = channel.min;
                        max = channel.max;
                        if (value < max || A.fuzzyEquals0(value, max)) t1 = value > min || A.fuzzyEquals0(value, min);
                        else t1 = false;
                        break $label0$0;
                    }
                    t1 = true;
                    break $label0$0;
                }
                return t1;
            },
            accept$1$1: function(visitor) {
                return visitor.visitColor$1(this);
            },
            accept$1: function(visitor) {
                return this.accept$1$1(visitor, type$.dynamic);
            },
            assertColor$1: function($name) {
                return this;
            },
            assertLegacy$1: function($name) {
                if (this._color0$_space.get$isLegacyInternal()) return;
                throw A.wrapException(A.SassScriptException$0("Expected " + this.toString$0(0) + string$.x20to_be, $name));
            },
            channel$1: function(_, channel) {
                var t1, _this = this, channels = _this._color0$_space._space$_channels;
                if (channel === channels[0].name) {
                    t1 = _this.channel0OrNull;
                    return t1 == null ? 0 : t1;
                }
                if (channel === channels[1].name) {
                    t1 = _this.channel1OrNull;
                    return t1 == null ? 0 : t1;
                }
                if (channel === channels[2].name) {
                    t1 = _this.channel2OrNull;
                    return t1 == null ? 0 : t1;
                }
                if (channel === "alpha") {
                    t1 = _this.alphaOrNull;
                    return t1 == null ? 0 : t1;
                }
                throw A.wrapException(A.SassScriptException$0("Color " + _this.toString$0(0) + " doesn't have a channel named \"" + channel + '".', null));
            },
            isChannelMissing$3$channelName$colorName: function(channel, channelName, colorName) {
                var _this = this, channels = _this._color0$_space._space$_channels;
                if (channel === channels[0].name) return _this.channel0OrNull == null;
                if (channel === channels[1].name) return _this.channel1OrNull == null;
                if (channel === channels[2].name) return _this.channel2OrNull == null;
                if (channel === "alpha") return _this.alphaOrNull == null;
                throw A.wrapException(A.SassScriptException$0("Color " + _this.toString$0(0) + " doesn't have a channel named \"" + channel + '".', channelName));
            },
            isChannelMissing$1: function(channel) {
                return this.isChannelMissing$3$channelName$colorName(channel, null, null);
            },
            isChannelPowerless$3$channelName$colorName: function(channel, channelName, colorName) {
                var _this = this, channels = _this._color0$_space._space$_channels;
                if (channel === channels[0].name) return _this.get$isChannel0Powerless();
                if (channel === channels[1].name) return false;
                if (channel === channels[2].name) return _this.get$isChannel2Powerless();
                if (channel === "alpha") return false;
                throw A.wrapException(A.SassScriptException$0("Color " + _this.toString$0(0) + " doesn't have a channel named \"" + channel + '".', channelName));
            },
            isChannelPowerless$1: function(channel) {
                return this.isChannelPowerless$3$channelName$colorName(channel, null, null);
            },
            _color0$_legacyChannel$2: function(space, channel) {
                if (!this._color0$_space.get$isLegacyInternal()) throw A.wrapException(A.SassScriptException$0("color." + channel + string$.x28__is_oc, null));
                return this.toSpace$1(space).channel$1(0, channel);
            },
            toSpace$2$legacyMissing: function(space, legacyMissing) {
                var t2, converted, t3, t4, _this = this, t1 = _this._color0$_space;
                if (t1 === space) return _this;
                t2 = _this.alphaOrNull;
                if (t2 == null) t2 = 0;
                converted = t1.convert$5(space, _this.channel0OrNull, _this.channel1OrNull, _this.channel2OrNull, t2);
                t1 = false;
                if (!legacyMissing) {
                    if (converted._color0$_space.get$isLegacyInternal()) t1 = converted.channel0OrNull == null || converted.channel1OrNull == null || converted.channel2OrNull == null || converted.alphaOrNull == null;
                }
                if (t1) {
                    t1 = converted.channel0OrNull;
                    if (t1 == null) t1 = 0;
                    t2 = converted.channel1OrNull;
                    if (t2 == null) t2 = 0;
                    t3 = converted.channel2OrNull;
                    if (t3 == null) t3 = 0;
                    t4 = converted.alphaOrNull;
                    if (t4 == null) t4 = 0;
                    t4 = A.SassColor_SassColor$forSpaceInternal0(converted._color0$_space, t1, t2, t3, t4);
                    t1 = t4;
                } else t1 = converted;
                return t1;
            },
            toSpace$1: function(space) {
                return this.toSpace$2$legacyMissing(space, true);
            },
            changeRgb$4$alpha$blue$green$red: function(alpha, blue, green, red) {
                var t1, t2, t3, t4, _this = this, _null = null;
                if (!_this._color0$_space.get$isLegacyInternal()) throw A.wrapException(A.SassScriptException$0("color.changeRgb() is only supported for legacy colors. Please use color.changeChannels() instead with an explicit $space argument.", _null));
                t1 = red == null ? _null : red;
                if (t1 == null) t1 = _this.channel$1(0, "red");
                t2 = green == null ? _null : green;
                if (t2 == null) t2 = _this.channel$1(0, "green");
                t3 = blue == null ? _null : blue;
                if (t3 == null) t3 = _this.channel$1(0, "blue");
                t4 = alpha == null ? _null : alpha;
                if (t4 == null) {
                    t4 = _this.alphaOrNull;
                    if (t4 == null) t4 = 0;
                }
                return A.SassColor_SassColor$rgbInternal0(t1, t2, t3, t4, _null);
            },
            changeRgb$1$alpha: function(alpha) {
                return this.changeRgb$4$alpha$blue$green$red(alpha, null, null, null);
            },
            changeRgb$1$blue: function(blue) {
                return this.changeRgb$4$alpha$blue$green$red(null, blue, null, null);
            },
            changeRgb$1$green: function(green) {
                return this.changeRgb$4$alpha$blue$green$red(null, null, green, null);
            },
            changeRgb$1$red: function(red) {
                return this.changeRgb$4$alpha$blue$green$red(null, null, null, red);
            },
            changeHsl$3$hue$lightness$saturation: function(hue, lightness, saturation) {
                var t2, t3, t4, t5, _this = this, _null = null, t1 = _this._color0$_space;
                if (!t1.get$isLegacyInternal()) throw A.wrapException(A.SassScriptException$0(string$.color_c, _null));
                t2 = hue == null ? _null : hue;
                if (t2 == null) t2 = _this._color0$_legacyChannel$2(B.HslColorSpace_JQ20, "hue");
                t3 = saturation == null ? _null : saturation;
                if (t3 == null) t3 = _this._color0$_legacyChannel$2(B.HslColorSpace_JQ20, "saturation");
                t4 = lightness == null ? _null : lightness;
                if (t4 == null) t4 = _this._color0$_legacyChannel$2(B.HslColorSpace_JQ20, "lightness");
                t5 = _this.alphaOrNull;
                if (t5 == null) t5 = 0;
                return A.SassColor_SassColor$hsl0(t2, t3, t4, t5).toSpace$1(t1);
            },
            changeHsl$1$saturation: function(saturation) {
                return this.changeHsl$3$hue$lightness$saturation(null, null, saturation);
            },
            changeHsl$1$lightness: function(lightness) {
                return this.changeHsl$3$hue$lightness$saturation(null, lightness, null);
            },
            changeHsl$1$hue: function(hue) {
                return this.changeHsl$3$hue$lightness$saturation(hue, null, null);
            },
            changeAlpha$1: function(alpha) {
                var t2, t3, _this = this, t1 = _this.channel0OrNull;
                if (t1 == null) t1 = 0;
                t2 = _this.channel1OrNull;
                if (t2 == null) t2 = 0;
                t3 = _this.channel2OrNull;
                if (t3 == null) t3 = 0;
                return A.SassColor_SassColor$forSpaceInternal0(_this._color0$_space, t1, t2, t3, alpha);
            },
            interpolate$4$legacyMissing$weight: function(other, method, legacyMissing, weight) {
                var t1, color1, color2, missing1_0, missing1_1, missing1_2, missing2_0, missing2_1, missing2_2, channel1_0, channel1_1, channel1_2, channel2_0, channel2_1, channel2_2, alpha1, t2, t3, alpha10, alpha2, alpha20, thisMultiplier, t4, t5, otherMultiplier, mixedAlpha, mixed0, mixed1, mixed2, _this = this, _null = null;
                if (weight == null) weight = 0.5;
                if (A.fuzzyEquals0(weight, 0)) return other;
                if (A.fuzzyEquals0(weight, 1)) return _this;
                t1 = method.space;
                color1 = _this.toSpace$1(t1);
                color2 = other.toSpace$1(t1);
                if (weight < 0 || weight > 1) throw A.wrapException(A.RangeError$range(weight, 0, 1, "weight", _null));
                missing1_0 = _this._color0$_isAnalogousChannelMissing$3(_this, color1, 0);
                missing1_1 = _this._color0$_isAnalogousChannelMissing$3(_this, color1, 1);
                missing1_2 = _this._color0$_isAnalogousChannelMissing$3(_this, color1, 2);
                missing2_0 = _this._color0$_isAnalogousChannelMissing$3(other, color2, 0);
                missing2_1 = _this._color0$_isAnalogousChannelMissing$3(other, color2, 1);
                missing2_2 = _this._color0$_isAnalogousChannelMissing$3(other, color2, 2);
                channel1_0 = (missing1_0 ? color2 : color1).channel0OrNull;
                if (channel1_0 == null) channel1_0 = 0;
                channel1_1 = (missing1_1 ? color2 : color1).channel1OrNull;
                if (channel1_1 == null) channel1_1 = 0;
                channel1_2 = (missing1_2 ? color2 : color1).channel2OrNull;
                if (channel1_2 == null) channel1_2 = 0;
                channel2_0 = (missing2_0 ? color1 : color2).channel0OrNull;
                if (channel2_0 == null) channel2_0 = 0;
                channel2_1 = (missing2_1 ? color1 : color2).channel1OrNull;
                if (channel2_1 == null) channel2_1 = 0;
                channel2_2 = (missing2_2 ? color1 : color2).channel2OrNull;
                if (channel2_2 == null) channel2_2 = 0;
                alpha1 = _this.alphaOrNull;
                t2 = alpha1 == null;
                if (t2) {
                    t3 = other.alphaOrNull;
                    alpha10 = t3 == null ? 0 : t3;
                } else alpha10 = alpha1;
                alpha2 = other.alphaOrNull;
                t3 = alpha2 == null;
                if (t3) alpha20 = t2 ? 0 : alpha1;
                else alpha20 = alpha2;
                thisMultiplier = (t2 ? 1 : alpha1) * weight;
                t4 = t3 ? 1 : alpha2;
                t5 = 1 - weight;
                otherMultiplier = t4 * t5;
                mixedAlpha = t2 && t3 ? _null : alpha10 * weight + alpha20 * t5;
                if (missing1_0 && missing2_0) mixed0 = _null;
                else {
                    t2 = mixedAlpha == null ? 1 : mixedAlpha;
                    mixed0 = (channel1_0 * thisMultiplier + channel2_0 * otherMultiplier) / t2;
                }
                if (missing1_1 && missing2_1) mixed1 = _null;
                else {
                    t2 = mixedAlpha == null ? 1 : mixedAlpha;
                    mixed1 = (channel1_1 * thisMultiplier + channel2_1 * otherMultiplier) / t2;
                }
                if (missing1_2 && missing2_2) mixed2 = _null;
                else {
                    t2 = mixedAlpha == null ? 1 : mixedAlpha;
                    mixed2 = (channel1_2 * thisMultiplier + channel2_2 * otherMultiplier) / t2;
                }
                $label0$0: {
                    if (B.HslColorSpace_JQ20 === t1 || B.HwbColorSpace_guQ0 === t1) {
                        if (missing1_0 && missing2_0) t2 = _null;
                        else {
                            t2 = method.hue;
                            t2.toString;
                            t2 = _this._color0$_interpolateHues$4(channel1_0, channel2_0, t2, weight);
                        }
                        t2 = A.SassColor_SassColor$forSpaceInternal0(t1, t2, mixed1, mixed2, mixedAlpha);
                        t1 = t2;
                        break $label0$0;
                    }
                    if (B.LchColorSpace_Bpv0 === t1 || B.OklchColorSpace_9Gj0 === t1) {
                        if (missing1_2 && missing2_2) t2 = _null;
                        else {
                            t2 = method.hue;
                            t2.toString;
                            t2 = _this._color0$_interpolateHues$4(channel1_2, channel2_2, t2, weight);
                        }
                        t2 = A.SassColor_SassColor$forSpaceInternal0(t1, mixed0, mixed1, t2, mixedAlpha);
                        t1 = t2;
                        break $label0$0;
                    }
                    t1 = A.SassColor_SassColor$forSpaceInternal0(t1, mixed0, mixed1, mixed2, mixedAlpha);
                    break $label0$0;
                }
                return t1.toSpace$2$legacyMissing(_this._color0$_space, legacyMissing);
            },
            interpolate$3$weight: function(other, method, weight) {
                return this.interpolate$4$legacyMissing$weight(other, method, true, weight);
            },
            _color0$_isAnalogousChannelMissing$3: function(original, output, outputChannelIndex) {
                var originalChannel;
                if (output.get$channelsOrNull()[outputChannelIndex] == null) return true;
                if (original === output) return false;
                originalChannel = A.IterableExtension_firstWhereOrNull(original._color0$_space._space$_channels, output._color0$_space._space$_channels[outputChannelIndex].get$isAnalogous());
                if (originalChannel == null) return false;
                return original.isChannelMissing$1(originalChannel.name);
            },
            _color0$_interpolateHues$4: function(hue1, hue2, method, weight) {
                var _0_0, _1_0;
                $label1$1: {
                    if (B.HueInterpolationMethod_00 === method) {
                        $label0$0: {
                            _0_0 = hue2 - hue1;
                            if (_0_0 > 180) {
                                hue1 += 360;
                                break $label0$0;
                            }
                            if (_0_0 < -180) hue2 += 360;
                        }
                        break $label1$1;
                    }
                    if (B.HueInterpolationMethod_10 === method) {
                        $label2$2: {
                            _1_0 = hue2 - hue1;
                            if (_1_0 > 0 && _1_0 < 180) {
                                hue2 += 360;
                                break $label2$2;
                            }
                            if (_1_0 > -180 && _1_0 <= 0) hue1 += 360;
                        }
                        break $label1$1;
                    }
                    if (B.HueInterpolationMethod_20 === method && hue2 < hue1) {
                        hue2 += 360;
                        break $label1$1;
                    }
                    if (B.HueInterpolationMethod_30 === method && hue1 < hue2) {
                        hue1 += 360;
                        break $label1$1;
                    }
                }
                return hue1 * weight + hue2 * (1 - weight);
            },
            plus$1: function(other) {
                if (!(other instanceof A.SassNumber0) && !(other instanceof A.SassColor0)) return this.super$Value$plus0(other);
                throw A.wrapException(A.SassScriptException$0('Undefined operation "' + this.toString$0(0) + " + " + other.toString$0(0) + '".', null));
            },
            minus$1: function(other) {
                if (!(other instanceof A.SassNumber0) && !(other instanceof A.SassColor0)) return this.super$Value$minus0(other);
                throw A.wrapException(A.SassScriptException$0('Undefined operation "' + this.toString$0(0) + " - " + other.toString$0(0) + '".', null));
            },
            dividedBy$1: function(other) {
                if (!(other instanceof A.SassNumber0) && !(other instanceof A.SassColor0)) return this.super$Value$dividedBy0(other);
                throw A.wrapException(A.SassScriptException$0('Undefined operation "' + this.toString$0(0) + " / " + other.toString$0(0) + '".', null));
            },
            $eq: function(_, other) {
                var t1, t2, _this = this;
                if (other == null) return false;
                if (!(other instanceof A.SassColor0)) return false;
                t1 = _this._color0$_space;
                if (t1.get$isLegacyInternal()) {
                    t2 = other._color0$_space;
                    if (!t2.get$isLegacyInternal()) return false;
                    if (!A.fuzzyEqualsNullable0(_this.alphaOrNull, other.alphaOrNull)) return false;
                    if (t1 === t2) return A.fuzzyEqualsNullable0(_this.channel0OrNull, other.channel0OrNull) && A.fuzzyEqualsNullable0(_this.channel1OrNull, other.channel1OrNull) && A.fuzzyEqualsNullable0(_this.channel2OrNull, other.channel2OrNull);
                    else return _this.toSpace$1(B.RgbColorSpace_i0P0).$eq(0, other.toSpace$1(B.RgbColorSpace_i0P0));
                }
                return t1 === other._color0$_space && A.fuzzyEqualsNullable0(_this.channel0OrNull, other.channel0OrNull) && A.fuzzyEqualsNullable0(_this.channel1OrNull, other.channel1OrNull) && A.fuzzyEqualsNullable0(_this.channel2OrNull, other.channel2OrNull) && A.fuzzyEqualsNullable0(_this.alphaOrNull, other.alphaOrNull);
            },
            get$hashCode: function(_) {
                var rgb, t2, t3, t4, t5, _this = this, t1 = _this._color0$_space;
                if (t1.get$isLegacyInternal()) {
                    rgb = _this.toSpace$1(B.RgbColorSpace_i0P0);
                    t1 = rgb.channel0OrNull;
                    t1 = A.fuzzyHashCode0(t1 == null ? 0 : t1);
                    t2 = rgb.channel1OrNull;
                    t2 = A.fuzzyHashCode0(t2 == null ? 0 : t2);
                    t3 = rgb.channel2OrNull;
                    t3 = A.fuzzyHashCode0(t3 == null ? 0 : t3);
                    t4 = _this.alphaOrNull;
                    return t1 ^ t2 ^ t3 ^ A.fuzzyHashCode0(t4 == null ? 0 : t4);
                } else {
                    t1 = A.Primitives_objectHashCode(t1);
                    t2 = _this.channel0OrNull;
                    t2 = A.fuzzyHashCode0(t2 == null ? 0 : t2);
                    t3 = _this.channel1OrNull;
                    t3 = A.fuzzyHashCode0(t3 == null ? 0 : t3);
                    t4 = _this.channel2OrNull;
                    t4 = A.fuzzyHashCode0(t4 == null ? 0 : t4);
                    t5 = _this.alphaOrNull;
                    return (t1 ^ t2 ^ t3 ^ t4 ^ A.fuzzyHashCode0(t5 == null ? 0 : t5)) >>> 0;
                }
            }
        };
        A.SassColor$_forSpace_closure0.prototype = {
            call$1: function(alpha) {
                return A.fuzzyAssertRange0(alpha, 0, 1, "alpha");
            },
            $signature: 12
        };
        A._ColorFormatEnum0.prototype = {
            toString$0: function(_) {
                return "rgbFunction";
            }
        };
        A.SpanColorFormat0.prototype = {};
        A.Combinator0.prototype = {
            _enumToString$0: function() {
                return "Combinator." + this._name;
            },
            toString$0: function(_) {
                return this._combinator0$_text;
            }
        };
        A.ModifiableCssComment0.prototype = {
            accept$1$1: function(visitor) {
                return visitor.visitCssComment$1(this);
            },
            accept$1: function(visitor) {
                return this.accept$1$1(visitor, type$.dynamic);
            },
            $isCssComment0: 1,
            get$span: function(receiver) {
                return this.span;
            }
        };
        A.compileAsync_closure.prototype = {
            call$0: function() {
                var $async$goto = 0, $async$completer = A._makeAsyncAwaitCompleter(type$.NodeCompileResult), $async$returnValue, $async$self = this, t5, t6, t7, t8, t9, t10, t11, t12, t13, result, t1, t2, t3, t4;
                var $async$call$0 = A._wrapJsFunctionForAsync(function($async$errorCode, $async$result) {
                    if ($async$errorCode === 1) return A._asyncRethrow($async$result, $async$completer);
                    for(;;)switch($async$goto){
                        case 0:
                            // Function start
                            t1 = $async$self.options;
                            t2 = t1 == null;
                            t3 = t2 ? null : J.get$loadPaths$x(t1);
                            t4 = t2 ? null : J.get$quietDeps$x(t1);
                            if (t4 == null) t4 = false;
                            t5 = A._parseOutputStyle0(t2 ? null : J.get$style$x(t1));
                            t6 = t2 ? null : J.get$verbose$x(t1);
                            if (t6 == null) t6 = false;
                            t7 = t2 ? null : J.get$charset$x(t1);
                            if (t7 == null) t7 = true;
                            t8 = t2 ? null : J.get$sourceMap$x(t1);
                            if (t8 == null) t8 = false;
                            t9 = $async$self.logger;
                            if (t2) t10 = null;
                            else {
                                t10 = J.get$importers$x(t1);
                                t10 = t10 == null ? null : J.map$1$1$ax(t10, new A.compileAsync__closure(), type$.AsyncImporter);
                            }
                            t11 = A._parseFunctions0(t2 ? null : J.get$functions$x(t1), true);
                            t12 = A.parseDeprecations(t9, t2 ? null : J.get$fatalDeprecations$x(t1), true);
                            t13 = A.parseDeprecations(t9, t2 ? null : J.get$silenceDeprecations$x(t1), false);
                            $async$goto = 3;
                            return A._asyncAwait(A.compileAsync0($async$self.path, t7, t12, t11, A.parseDeprecations(t9, t2 ? null : J.get$futureDeprecations$x(t1), false), A.AsyncImportCache$(t10, t3, null), null, null, t9, null, t4, t13, t8, t5, null, true, t6), $async$call$0);
                        case 3:
                            // returning from await.
                            result = $async$result;
                            t1 = t2 ? null : J.get$sourceMapIncludeSources$x(t1);
                            $async$returnValue = A._convertResult(result, t1 == null ? false : t1);
                            // goto return
                            $async$goto = 1;
                            break;
                        case 1:
                            // return
                            return A._asyncReturn($async$returnValue, $async$completer);
                    }
                });
                return A._asyncStartSync($async$call$0, $async$completer);
            },
            $signature: 232
        };
        A.compileAsync__closure.prototype = {
            call$1: function(importer) {
                return A._parseAsyncImporter(importer);
            },
            $signature: 233
        };
        A.compileStringAsync_closure.prototype = {
            call$0: function() {
                var $async$goto = 0, $async$completer = A._makeAsyncAwaitCompleter(type$.NodeCompileResult), $async$returnValue, $async$self = this, t7, t8, t9, t10, t11, t12, t13, t14, t15, t16, result, t1, t2, t3, t4, t5, t6;
                var $async$call$0 = A._wrapJsFunctionForAsync(function($async$errorCode, $async$result) {
                    if ($async$errorCode === 1) return A._asyncRethrow($async$result, $async$completer);
                    for(;;)switch($async$goto){
                        case 0:
                            // Function start
                            t1 = $async$self.options;
                            t2 = t1 == null;
                            t3 = A.parseSyntax(t2 ? null : J.get$syntax$x(t1));
                            t4 = t2 ? null : A.NullableExtension_andThen0(J.get$url$x(t1), A.utils3__jsToDartUrl$closure());
                            t5 = t2 ? null : J.get$loadPaths$x(t1);
                            t6 = t2 ? null : J.get$quietDeps$x(t1);
                            if (t6 == null) t6 = false;
                            t7 = A._parseOutputStyle0(t2 ? null : J.get$style$x(t1));
                            t8 = t2 ? null : J.get$verbose$x(t1);
                            if (t8 == null) t8 = false;
                            t9 = t2 ? null : J.get$charset$x(t1);
                            if (t9 == null) t9 = true;
                            t10 = t2 ? null : J.get$sourceMap$x(t1);
                            if (t10 == null) t10 = false;
                            t11 = $async$self.logger;
                            if (t2) t12 = null;
                            else {
                                t12 = J.get$importers$x(t1);
                                t12 = t12 == null ? null : J.map$1$1$ax(t12, new A.compileStringAsync__closure(), type$.AsyncImporter);
                            }
                            t13 = t2 ? null : A.NullableExtension_andThen0(J.get$importer$x(t1), new A.compileStringAsync__closure0());
                            if (t13 == null) t13 = (t2 ? null : J.get$url$x(t1)) == null ? new A.NoOpImporter0() : null;
                            t14 = A._parseFunctions0(t2 ? null : J.get$functions$x(t1), true);
                            t15 = A.parseDeprecations(t11, t2 ? null : J.get$fatalDeprecations$x(t1), true);
                            t16 = A.parseDeprecations(t11, t2 ? null : J.get$silenceDeprecations$x(t1), false);
                            $async$goto = 3;
                            return A._asyncAwait(A.compileStringAsync0($async$self.text, t9, t15, t14, A.parseDeprecations(t11, t2 ? null : J.get$futureDeprecations$x(t1), false), A.AsyncImportCache$(t12, t5, null), t13, null, null, t11, null, t6, t16, t10, t7, t3, t4, true, t8), $async$call$0);
                        case 3:
                            // returning from await.
                            result = $async$result;
                            t1 = t2 ? null : J.get$sourceMapIncludeSources$x(t1);
                            $async$returnValue = A._convertResult(result, t1 == null ? false : t1);
                            // goto return
                            $async$goto = 1;
                            break;
                        case 1:
                            // return
                            return A._asyncReturn($async$returnValue, $async$completer);
                    }
                });
                return A._asyncStartSync($async$call$0, $async$completer);
            },
            $signature: 232
        };
        A.compileStringAsync__closure.prototype = {
            call$1: function(importer) {
                return A._parseAsyncImporter(importer);
            },
            $signature: 233
        };
        A.compileStringAsync__closure0.prototype = {
            call$1: function(importer) {
                return A._parseAsyncImporter(importer);
            },
            $signature: 426
        };
        A._wrapAsyncSassExceptions_closure.prototype = {
            call$1: function(error) {
                var t1;
                if (error instanceof A.SassException0) t1 = A.throwNodeException(error, this.ascii, this.color, null);
                else t1 = A.jsThrow(error == null ? A._asObject(error) : error);
                return t1;
            },
            $signature: 427
        };
        A._parseFunctions_closure0.prototype = {
            call$2: function(signature, callback) {
                var callable, t1 = this.result;
                if (!this.asynch) {
                    callable = A._Cell$();
                    callable.__late_helper$_value = A.Callable_Callable$fromSignature(signature, new A._parseFunctions__closure2(callback, callable), true);
                    t1.push(callable._readLocal$0());
                } else {
                    callable = A._Cell$();
                    callable.__late_helper$_value = A.AsyncCallable_AsyncCallable$fromSignature(signature, new A._parseFunctions__closure3(callback, callable), true);
                    t1.push(callable._readLocal$0());
                }
            },
            $signature: 126
        };
        A._parseFunctions__closure2.prototype = {
            call$1: function($arguments) {
                var t1, t2, _s42_ = string$.Invali, result = A.wrapJSExceptions(new A._parseFunctions___closure6(this.callback, $arguments));
                if (result instanceof A.Value0) return A._simplifyValue(result);
                t1 = result != null && result instanceof self.Promise;
                t2 = this.callable;
                if (t1) {
                    t1 = t2.readLocal$0();
                    throw A.wrapException(_s42_ + t1.get$name(t1) + '":\nPromises may only be returned for sass.compileAsync() and sass.compileStringAsync().');
                } else {
                    t1 = t2.readLocal$0();
                    throw A.wrapException(_s42_ + t1.get$name(t1) + '": ' + A.S(result) + " is not a sass.Value.");
                }
            },
            $signature: 3
        };
        A._parseFunctions___closure6.prototype = {
            call$0: function() {
                return type$.Function._as(this.callback).call$1(A.toJSArray(this.$arguments));
            },
            $signature: 64
        };
        A._parseFunctions__closure3.prototype = {
            call$1: function($arguments) {
                return this.$call$body$_parseFunctions__closure0($arguments);
            },
            $call$body$_parseFunctions__closure0: function($arguments) {
                var $async$goto = 0, $async$completer = A._makeAsyncAwaitCompleter(type$.Value_2), $async$returnValue, $async$self = this, t1, result;
                var $async$call$1 = A._wrapJsFunctionForAsync(function($async$errorCode, $async$result) {
                    if ($async$errorCode === 1) return A._asyncRethrow($async$result, $async$completer);
                    for(;;)switch($async$goto){
                        case 0:
                            // Function start
                            result = A.wrapJSExceptions(new A._parseFunctions___closure5($async$self.callback, $arguments));
                            $async$goto = result != null && result instanceof self.Promise ? 3 : 4;
                            break;
                        case 3:
                            // then
                            $async$goto = 5;
                            return A._asyncAwait(A.promiseToFuture0(type$.Promise._as(result), type$.Object), $async$call$1);
                        case 5:
                            // returning from await.
                            result = $async$result;
                        case 4:
                            // join
                            if (result instanceof A.Value0) {
                                $async$returnValue = A._simplifyValue(result);
                                // goto return
                                $async$goto = 1;
                                break;
                            }
                            t1 = $async$self.callable.readLocal$0();
                            throw A.wrapException(string$.Invali + t1.get$name(t1) + '": ' + A.S(result) + " is not a sass.Value.");
                        case 1:
                            // return
                            return A._asyncReturn($async$returnValue, $async$completer);
                    }
                });
                return A._asyncStartSync($async$call$1, $async$completer);
            },
            $signature: 92
        };
        A._parseFunctions___closure5.prototype = {
            call$0: function() {
                return type$.Function._as(this.callback).call$1(A.toJSArray(this.$arguments));
            },
            $signature: 64
        };
        A.nodePackageImporterClass_closure.prototype = {
            call$0: function() {
                return type$.JSClass._as(A.allowInteropCaptureThisNamed("sass.NodePackageImporter", new A.nodePackageImporterClass__closure()));
            },
            $signature: 17
        };
        A.nodePackageImporterClass__closure.prototype = {
            call$2: function($self, entrypointDirectory) {
                var t1, t2, _null = null, _0_3 = A.entrypointFilename();
                $label0$0: {
                    if (entrypointDirectory != null) {
                        t1 = entrypointDirectory;
                        break $label0$0;
                    }
                    if (_0_3 != null) {
                        t1 = $.$get$context().dirname$1(_0_3);
                        break $label0$0;
                    }
                    t1 = A.throwExpression("The Node package importer cannot determine an entry point because `require.main.filename` is not defined. Please provide an `entryPointDirectory` to the `NodePackageImporter`.");
                }
                t2 = new A.NodePackageImporter0();
                if (A.isBrowser()) A.throwExpression(string$.The_No);
                t2._node_package$__NodePackageImporter__entryPointDirectory_F = A.absolute(t1, _null, _null, _null, _null, _null, _null, _null, _null, _null, _null, _null, _null, _null, _null);
                return t2;
            },
            call$1: function($self) {
                return this.call$2($self, null);
            },
            "call*": "call$2",
            $requiredArgCount: 1,
            $defaultValues: function() {
                return [
                    null
                ];
            },
            $signature: 429
        };
        A._compileStylesheet_closure1.prototype = {
            call$1: function(url) {
                var t1;
                if (url === "") {
                    t1 = this.stylesheet.span;
                    t1 = A.Uri_Uri$dataFromString(A.String_String$fromCharCodes(B.NativeUint32List_methods.sublist$2(t1.get$file(t1)._decodedChars, 0, null), 0, null), B.C_Utf8Codec, null).get$_text();
                } else t1 = this.importCache.sourceMapUrl$1(0, A.Uri_parse(url)).toString$0(0);
                return t1;
            },
            $signature: 6
        };
        A.CompileOptions.prototype = {};
        A.CompileStringOptions.prototype = {};
        A.NodeCompileResult.prototype = {};
        A.CompileResult0.prototype = {};
        A.Compiler.prototype = {};
        A.AsyncCompiler.prototype = {
            addCompilation$1: function(compilation) {
                this.compilations.add$1(0, A.promiseToFuture(compilation, type$.dynamic).catchError$1(new A.AsyncCompiler_addCompilation_closure()));
            }
        };
        A.AsyncCompiler_addCompilation_closure.prototype = {
            call$1: function(err) {},
            $signature: 62
        };
        A.compilerClass_closure.prototype = {
            call$0: function() {
                var t1 = type$.JSClass, jsClass = t1._as(A.allowInteropCaptureThisNamed("sass.Compiler", new A.compilerClass__closure()));
                A.LinkedHashMap_LinkedHashMap$_literal([
                    "compile",
                    new A.compilerClass__closure0(),
                    "compileString",
                    new A.compilerClass__closure1(),
                    "dispose",
                    new A.compilerClass__closure2()
                ], type$.String, type$.Function).forEach$1(0, A.JSClassExtension_get_defineMethod(jsClass));
                A.JSClassExtension_injectSuperclass(t1._as(new A.Compiler().constructor), jsClass);
                return jsClass;
            },
            $signature: 17
        };
        A.compilerClass__closure.prototype = {
            call$1: function($self) {
                return A.LinkedHashSet_LinkedHashSet$_literal([
                    A.jsThrow(new self.Error("Compiler can not be directly constructed. Please use `sass.initCompiler()` instead."))
                ], type$.Never);
            },
            $signature: 234
        };
        A.compilerClass__closure0.prototype = {
            call$3: function($self, path, options) {
                if ($self._disposed) A.jsThrow(new self.Error("Compiler has already been disposed."));
                return A.compile0(path, options);
            },
            call$2: function($self, path) {
                return this.call$3($self, path, null);
            },
            "call*": "call$3",
            $requiredArgCount: 2,
            $defaultValues: function() {
                return [
                    null
                ];
            },
            $signature: 431
        };
        A.compilerClass__closure1.prototype = {
            call$3: function($self, source, options) {
                if ($self._disposed) A.jsThrow(new self.Error("Compiler has already been disposed."));
                return A.compileString0(source, options);
            },
            call$2: function($self, source) {
                return this.call$3($self, source, null);
            },
            "call*": "call$3",
            $requiredArgCount: 2,
            $defaultValues: function() {
                return [
                    null
                ];
            },
            $signature: 432
        };
        A.compilerClass__closure2.prototype = {
            call$1: function($self) {
                $self._disposed = true;
            },
            $signature: 433
        };
        A.asyncCompilerClass_closure.prototype = {
            call$0: function() {
                var t1 = type$.JSClass, jsClass = t1._as(A.allowInteropCaptureThisNamed("sass.AsyncCompiler", new A.asyncCompilerClass__closure()));
                A.LinkedHashMap_LinkedHashMap$_literal([
                    "compileAsync",
                    new A.asyncCompilerClass__closure0(),
                    "compileStringAsync",
                    new A.asyncCompilerClass__closure1(),
                    "dispose",
                    new A.asyncCompilerClass__closure2()
                ], type$.String, type$.Function).forEach$1(0, A.JSClassExtension_get_defineMethod(jsClass));
                A.JSClassExtension_injectSuperclass(t1._as(new A.AsyncCompiler(new A.FutureGroup(new A._AsyncCompleter(new A._Future($.Zone__current, type$._Future_List_void), type$._AsyncCompleter_List_void), [], type$.FutureGroup_void)).constructor), jsClass);
                return jsClass;
            },
            $signature: 17
        };
        A.asyncCompilerClass__closure.prototype = {
            call$1: function($self) {
                return A.LinkedHashSet_LinkedHashSet$_literal([
                    A.jsThrow(new self.Error("AsyncCompiler can not be directly constructed. Please use `sass.initAsyncCompiler()` instead."))
                ], type$.Never);
            },
            $signature: 234
        };
        A.asyncCompilerClass__closure0.prototype = {
            call$3: function($self, path, options) {
                var compilation;
                if ($self._disposed) A.jsThrow(new self.Error("Compiler has already been disposed."));
                compilation = A.compileAsync1(path, options);
                $self.addCompilation$1(compilation);
                return compilation;
            },
            call$2: function($self, path) {
                return this.call$3($self, path, null);
            },
            "call*": "call$3",
            $requiredArgCount: 2,
            $defaultValues: function() {
                return [
                    null
                ];
            },
            $signature: 434
        };
        A.asyncCompilerClass__closure1.prototype = {
            call$3: function($self, source, options) {
                var compilation;
                if ($self._disposed) A.jsThrow(new self.Error("Compiler has already been disposed."));
                compilation = A.compileStringAsync1(source, options);
                $self.addCompilation$1(compilation);
                return compilation;
            },
            call$2: function($self, source) {
                return this.call$3($self, source, null);
            },
            "call*": "call$3",
            $requiredArgCount: 2,
            $defaultValues: function() {
                return [
                    null
                ];
            },
            $signature: 435
        };
        A.asyncCompilerClass__closure2.prototype = {
            call$1: function($self) {
                $self._disposed = true;
                return A.futureToPromise0(new A.asyncCompilerClass___closure($self).call$0());
            },
            $signature: 436
        };
        A.asyncCompilerClass___closure.prototype = {
            call$0: function() {
                var $async$goto = 0, $async$completer = A._makeAsyncAwaitCompleter(type$.Null), $async$self = this, t1;
                var $async$call$0 = A._wrapJsFunctionForAsync(function($async$errorCode, $async$result) {
                    if ($async$errorCode === 1) return A._asyncRethrow($async$result, $async$completer);
                    for(;;)switch($async$goto){
                        case 0:
                            // Function start
                            t1 = $async$self.self.compilations;
                            t1.close$0(0);
                            $async$goto = 2;
                            return A._asyncAwait(t1._future_group$_completer.future, $async$call$0);
                        case 2:
                            // returning from await.
                            // implicit return
                            return A._asyncReturn(null, $async$completer);
                    }
                });
                return A._asyncStartSync($async$call$0, $async$completer);
            },
            $signature: 2
        };
        A.initAsyncCompiler_closure.prototype = {
            call$0: function() {
                var $async$goto = 0, $async$completer = A._makeAsyncAwaitCompleter(type$.AsyncCompiler), $async$returnValue;
                var $async$call$0 = A._wrapJsFunctionForAsync(function($async$errorCode, $async$result) {
                    if ($async$errorCode === 1) return A._asyncRethrow($async$result, $async$completer);
                    for(;;)switch($async$goto){
                        case 0:
                            // Function start
                            $async$returnValue = new A.AsyncCompiler(new A.FutureGroup(new A._AsyncCompleter(new A._Future($.Zone__current, type$._Future_List_void), type$._AsyncCompleter_List_void), [], type$.FutureGroup_void));
                            // goto return
                            $async$goto = 1;
                            break;
                        case 1:
                            // return
                            return A._asyncReturn($async$returnValue, $async$completer);
                    }
                });
                return A._asyncStartSync($async$call$0, $async$completer);
            },
            $signature: 437
        };
        A.InterpolatedComplexSelector.prototype = {
            accept$1$1: function(visitor) {
                return visitor.visitComplexSelector$1(this);
            },
            accept$1: function(visitor) {
                return this.accept$1$1(visitor, type$.dynamic);
            },
            toString$0: function(_) {
                return B.JSArray_methods.join$1(this.components, " ");
            },
            get$span: function(receiver) {
                return this.span;
            }
        };
        A.ComplexSassNumber0.prototype = {
            get$numeratorUnits: function(_) {
                return this._complex0$_numeratorUnits;
            },
            get$denominatorUnits: function(_) {
                return this._complex0$_denominatorUnits;
            },
            get$hasUnits: function() {
                return true;
            },
            get$hasComplexUnits: function() {
                return true;
            },
            hasUnit$1: function(unit) {
                return false;
            },
            compatibleWithUnit$1: function(unit) {
                return false;
            },
            hasPossiblyCompatibleUnits$1: function(other) {
                throw A.wrapException(A.UnimplementedError$(string$.Comple));
            },
            withValue$1: function(value) {
                return new A.ComplexSassNumber0(this._complex0$_numeratorUnits, this._complex0$_denominatorUnits, value, null);
            },
            withSlash$2: function(numerator, denominator) {
                return new A.ComplexSassNumber0(this._complex0$_numeratorUnits, this._complex0$_denominatorUnits, this._number1$_value, new A._Record_2(numerator, denominator));
            }
        };
        A.ComplexSelector0.prototype = {
            get$specificity: function() {
                var result, _this = this, value = _this._complex$__ComplexSelector_specificity_FI;
                if (value === $) {
                    result = B.JSArray_methods.fold$2(_this.components, 0, new A.ComplexSelector_specificity_closure0());
                    _this._complex$__ComplexSelector_specificity_FI !== $ && A.throwUnnamedLateFieldADI();
                    _this._complex$__ComplexSelector_specificity_FI = result;
                    value = result;
                }
                return value;
            },
            get$singleCompound: function() {
                var _0_0, t1, _0_4, selector;
                if (this.leadingCombinators.length !== 0) return null;
                _0_0 = this.components;
                $label0$0: {
                    t1 = false;
                    if (_0_0.length === 1) {
                        _0_4 = _0_0[0];
                        selector = _0_4.selector;
                        t1 = _0_4.combinators.length <= 0;
                    } else selector = null;
                    if (t1) {
                        t1 = selector;
                        break $label0$0;
                    }
                    t1 = null;
                    break $label0$0;
                }
                return t1;
            },
            accept$1$1: function(visitor) {
                return visitor.visitComplexSelector$1(this);
            },
            accept$1: function(visitor) {
                return this.accept$1$1(visitor, type$.dynamic);
            },
            isSuperselector$1: function(other) {
                return this.leadingCombinators.length === 0 && other.leadingCombinators.length === 0 && A.complexIsSuperselector0(this.components, other.components);
            },
            withAdditionalCombinators$1: function(combinators) {
                var _0_0, _0_1, t1, initial, last, _this = this;
                if (combinators.length === 0) return _this;
                _0_0 = _this.components;
                $label0$0: {
                    _0_1 = _0_0.length;
                    if (_0_1 >= 1) {
                        t1 = _0_1 - 1;
                        initial = B.JSArray_methods.sublist$2(_0_0, 0, t1);
                        last = _0_0[t1];
                        t1 = A.List_List$_of(initial, type$.ComplexSelectorComponent_2);
                        t1.push(last.withAdditionalCombinators$1(combinators));
                        t1 = A.ComplexSelector$0(_this.leadingCombinators, t1, _this.span, _this.lineBreak);
                        break $label0$0;
                    }
                    if (_0_1 <= 0) {
                        t1 = A.List_List$_of(_this.leadingCombinators, type$.CssValue_Combinator_2);
                        B.JSArray_methods.addAll$1(t1, combinators);
                        t1 = A.ComplexSelector$0(t1, B.List_empty19, _this.span, _this.lineBreak);
                        break $label0$0;
                    }
                    t1 = null;
                }
                return t1;
            },
            concatenate$3$forceLineBreak: function(child, span, forceLineBreak) {
                var t2, _0_1, initial, last, _this = this, t1 = child.leadingCombinators, _0_0 = _this.components;
                if (t1.length === 0) {
                    t1 = A.List_List$_of(_0_0, type$.ComplexSelectorComponent_2);
                    B.JSArray_methods.addAll$1(t1, child.components);
                    t2 = _this.lineBreak || child.lineBreak || forceLineBreak;
                    return A.ComplexSelector$0(_this.leadingCombinators, t1, span, t2);
                } else {
                    _0_1 = _0_0.length;
                    if (_0_1 >= 1) {
                        t2 = _0_1 - 1;
                        initial = B.JSArray_methods.sublist$2(_0_0, 0, t2);
                        last = _0_0[t2];
                        t2 = A.List_List$_of(initial, type$.ComplexSelectorComponent_2);
                        t2.push(last.withAdditionalCombinators$1(t1));
                        B.JSArray_methods.addAll$1(t2, child.components);
                        t1 = _this.lineBreak || child.lineBreak || forceLineBreak;
                        return A.ComplexSelector$0(_this.leadingCombinators, t2, span, t1);
                    } else {
                        t2 = A.List_List$_of(_this.leadingCombinators, type$.CssValue_Combinator_2);
                        B.JSArray_methods.addAll$1(t2, t1);
                        t1 = _this.lineBreak || child.lineBreak || forceLineBreak;
                        return A.ComplexSelector$0(t2, child.components, span, t1);
                    }
                }
            },
            concatenate$2: function(child, span) {
                return this.concatenate$3$forceLineBreak(child, span, false);
            },
            get$hashCode: function(_) {
                return B.C_ListEquality0.hash$1(this.leadingCombinators) ^ B.C_ListEquality0.hash$1(this.components);
            },
            $eq: function(_, other) {
                if (other == null) return false;
                return other instanceof A.ComplexSelector0 && B.C_ListEquality.equals$2(0, this.leadingCombinators, other.leadingCombinators) && B.C_ListEquality.equals$2(0, this.components, other.components);
            }
        };
        A.ComplexSelector_specificity_closure0.prototype = {
            call$2: function(sum, component) {
                return sum + component.selector.get$specificity();
            },
            $signature: 438
        };
        A.InterpolatedComplexSelectorComponent.prototype = {
            toString$0: function(_) {
                var t1, _0_0 = this.combinator;
                $label0$0: {
                    if (_0_0 != null) {
                        t1 = this.selector.toString$0(0) + " " + _0_0.toString$0(0);
                        break $label0$0;
                    }
                    t1 = B.JSArray_methods.join$1(this.selector.components, "");
                    break $label0$0;
                }
                return t1;
            },
            $isAstNode0: 1,
            $isSassNode: 1,
            get$span: function(receiver) {
                return this.span;
            }
        };
        A.ComplexSelectorComponent0.prototype = {
            withAdditionalCombinators$1: function(combinators) {
                var t1, t2, _this = this;
                if (combinators.length === 0) t1 = _this;
                else {
                    t1 = type$.CssValue_Combinator_2;
                    t2 = A.List_List$_of(_this.combinators, t1);
                    B.JSArray_methods.addAll$1(t2, combinators);
                    t1 = new A.ComplexSelectorComponent0(_this.selector, A.List_List$unmodifiable(t2, t1), _this.span);
                }
                return t1;
            },
            get$hashCode: function(_) {
                return B.C_ListEquality0.hash$1(this.selector.components) ^ B.C_ListEquality0.hash$1(this.combinators);
            },
            $eq: function(_, other) {
                var t1;
                if (other == null) return false;
                if (other instanceof A.ComplexSelectorComponent0) {
                    t1 = B.C_ListEquality.equals$2(0, this.selector.components, other.selector.components);
                    t1 = t1 && B.C_ListEquality.equals$2(0, this.combinators, other.combinators);
                } else t1 = false;
                return t1;
            },
            toString$0: function(_) {
                var t1 = this.combinators;
                return A.serializeSelector0(this.selector, true) + new A.MappedListIterable(t1, new A.ComplexSelectorComponent_toString_closure0(), A._arrayInstanceType(t1)._eval$1("MappedListIterable<1,String>")).join$1(0, "");
            }
        };
        A.ComplexSelectorComponent_toString_closure0.prototype = {
            call$1: function(combinator) {
                return " " + combinator.toString$0(0);
            },
            $signature: 439
        };
        A.InterpolatedCompoundSelector.prototype = {
            get$span: function(_) {
                var t2, t1 = this.components;
                if (t1.length === 1) {
                    t1 = B.JSArray_methods.get$first(t1);
                    t1 = t1.get$span(t1);
                } else {
                    t2 = B.JSArray_methods.get$first(t1);
                    t2 = t2.get$span(t2);
                    t1 = B.JSArray_methods.get$last(t1);
                    t1 = t2.expand$1(0, t1.get$span(t1));
                }
                return t1;
            },
            accept$1$1: function(visitor) {
                return visitor.visitCompoundSelector$1(this);
            },
            accept$1: function(visitor) {
                return this.accept$1$1(visitor, type$.dynamic);
            },
            toString$0: function(_) {
                return B.JSArray_methods.join$1(this.components, "");
            }
        };
        A.CompoundSelector0.prototype = {
            get$specificity: function() {
                var result, _this = this, value = _this._compound$__CompoundSelector_specificity_FI;
                if (value === $) {
                    result = B.JSArray_methods.fold$2(_this.components, 0, new A.CompoundSelector_specificity_closure0());
                    _this._compound$__CompoundSelector_specificity_FI !== $ && A.throwUnnamedLateFieldADI();
                    _this._compound$__CompoundSelector_specificity_FI = result;
                    value = result;
                }
                return value;
            },
            get$hasComplicatedSuperselectorSemantics: function() {
                var result, _this = this, value = _this._compound$__CompoundSelector_hasComplicatedSuperselectorSemantics_FI;
                if (value === $) {
                    result = B.JSArray_methods.any$1(_this.components, new A.CompoundSelector_hasComplicatedSuperselectorSemantics_closure0());
                    _this._compound$__CompoundSelector_hasComplicatedSuperselectorSemantics_FI !== $ && A.throwUnnamedLateFieldADI();
                    _this._compound$__CompoundSelector_hasComplicatedSuperselectorSemantics_FI = result;
                    value = result;
                }
                return value;
            },
            accept$1$1: function(visitor) {
                return visitor.visitCompoundSelector$1(this);
            },
            accept$1: function(visitor) {
                return this.accept$1$1(visitor, type$.dynamic);
            },
            get$hashCode: function(_) {
                return B.C_ListEquality0.hash$1(this.components);
            },
            $eq: function(_, other) {
                if (other == null) return false;
                return other instanceof A.CompoundSelector0 && B.C_ListEquality.equals$2(0, this.components, other.components);
            }
        };
        A.CompoundSelector_specificity_closure0.prototype = {
            call$2: function(sum, component) {
                return sum + component.get$specificity();
            },
            $signature: 440
        };
        A.CompoundSelector_hasComplicatedSuperselectorSemantics_closure0.prototype = {
            call$1: function(component) {
                return component.get$hasComplicatedSuperselectorSemantics();
            },
            $signature: 15
        };
        A.Configuration0.prototype = {
            throughForward$1: function($forward) {
                var _0_0, _1_0, _2_0, t1, hiddenVariables, newValues = this._configuration0$_values;
                if (newValues.get$isEmpty(newValues)) return this;
                _0_0 = $forward.prefix;
                if (_0_0 != null) newValues = new A.UnprefixedMapView0(newValues, _0_0, type$.UnprefixedMapView_ConfiguredValue_2);
                _1_0 = $forward.shownVariables;
                if (_1_0 != null) newValues = new A.LimitedMapView0(newValues, _1_0._base.intersection$1(new A.MapKeySet(newValues, type$.MapKeySet_nullable_Object)), type$.LimitedMapView_String_ConfiguredValue_2);
                else {
                    _2_0 = $forward.hiddenVariables;
                    if (_2_0 != null) {
                        t1 = _2_0._base.get$isNotEmpty(0);
                        hiddenVariables = _2_0;
                    } else {
                        hiddenVariables = null;
                        t1 = false;
                    }
                    if (t1) newValues = A.LimitedMapView$blocklist0(newValues, hiddenVariables, type$.String, type$.ConfiguredValue_2);
                }
                return this._configuration0$_withValues$1(newValues);
            },
            _configuration0$_withValues$1: function(values) {
                var t1 = this._configuration0$__originalConfiguration;
                return new A.Configuration0(values, t1 == null ? this : t1);
            },
            toString$0: function(_) {
                var t2, t3, t1 = A._setArrayType([], type$.JSArray_String);
                for(t2 = A.MapExtensions_get_pairs0(new A.UnmodifiableMapView(this._configuration0$_values, type$.UnmodifiableMapView_String_ConfiguredValue_2), type$.String, type$.ConfiguredValue_2), t2 = t2.get$iterator(t2); t2.moveNext$0();){
                    t3 = t2.get$current(t2);
                    t1.push("$" + t3._0 + ": " + t3._1.toString$0(0));
                }
                return "(" + B.JSArray_methods.join$1(t1, ",") + ")";
            }
        };
        A.ExplicitConfiguration0.prototype = {
            _configuration0$_withValues$1: function(values) {
                var t1 = this._configuration0$__originalConfiguration;
                if (t1 == null) t1 = this;
                return new A.ExplicitConfiguration0(this.nodeWithSpan, values, t1);
            }
        };
        A.ConfiguredValue0.prototype = {
            toString$0: function(_) {
                return this.value.toString$0(0);
            }
        };
        A.ConfiguredVariable0.prototype = {
            toString$0: function(_) {
                var t1 = this.expression.toString$0(0), t2 = this.isGuarded ? " !default" : "";
                return "$" + this.name + ": " + t1 + t2;
            },
            $isAstNode0: 1,
            $isSassNode: 1,
            get$span: function(receiver) {
                return this.span;
            }
        };
        A.ContentBlock0.prototype = {
            accept$1$1: function(visitor) {
                return visitor.visitContentBlock$1(0, this);
            },
            accept$1: function(visitor) {
                return this.accept$1$1(visitor, type$.dynamic);
            },
            toString$0: function(_) {
                var t1 = this.parameters;
                t1 = t1.parameters.length === 0 && t1.restParameter == null ? "" : " using (" + t1.toString$0(0) + ")";
                return t1 + (" {" + B.JSArray_methods.join$1(this.children, " ") + "}");
            }
        };
        A.ContentRule0.prototype = {
            accept$1$1: function(visitor) {
                return visitor.visitContentRule$1(0, this);
            },
            accept$1: function(visitor) {
                return this.accept$1$1(visitor, type$.dynamic);
            },
            toString$0: function(_) {
                var t1 = this.$arguments;
                return t1.get$isEmpty(0) ? "@content;" : "@content(" + t1.toString$0(0) + ");";
            },
            get$span: function(receiver) {
                return this.span;
            }
        };
        A._disallowedFunctionNames_closure0.prototype = {
            call$1: function($function) {
                return $function.name;
            },
            $signature: 441
        };
        A.CssParser0.prototype = {
            get$plainCss: function() {
                return true;
            },
            silentComment$0: function() {
                var t1, t2, _this = this;
                if (_this._stylesheet0$_inExpression) return false;
                t1 = _this.scanner;
                t2 = t1._string_scanner$_position;
                _this.super$Parser$silentComment0();
                _this.error$2(0, string$.Silent, _this.spanFrom$1(new A._SpanScannerState(t1, t2)));
            },
            atRule$2$root: function(child, root) {
                var $name, _0_0, result, _this = this, t1 = _this.scanner, start = new A._SpanScannerState(t1, t1._string_scanner$_position);
                t1.expectChar$1(64);
                $name = _this.interpolatedIdentifier$0();
                _this.whitespace$1$consumeNewlines(true);
                _0_0 = $name.get$asPlain();
                $label0$0: {
                    if ("at-root" === _0_0 || "content" === _0_0 || "debug" === _0_0 || "each" === _0_0 || "error" === _0_0 || "extend" === _0_0 || "for" === _0_0 || "if" === _0_0 || "include" === _0_0 || "mixin" === _0_0 || "return" === _0_0 || "warn" === _0_0 || "while" === _0_0) _this._css$_forbiddenAtRule$1(start);
                    if ("import" === _0_0) {
                        t1 = _this._css$_cssImportRule$1(start);
                        break $label0$0;
                    }
                    if ("function" === _0_0) {
                        _this.whitespace$1$consumeNewlines(true);
                        if (!t1.matches$1("--")) {
                            _this.almostAnyValue$0();
                            _this.error$2(0, "This at-rule isn't allowed in plain CSS.", t1.spanFrom$1(start));
                            result = null;
                        } else result = _this.unknownAtRule$2(start, $name);
                        t1 = result;
                        break $label0$0;
                    }
                    if ("media" === _0_0) {
                        t1 = _this.mediaRule$1(start);
                        break $label0$0;
                    }
                    if ("-moz-document" === _0_0) {
                        t1 = _this.mozDocumentRule$2(start, $name);
                        break $label0$0;
                    }
                    if ("supports" === _0_0) {
                        t1 = _this.supportsRule$1(start);
                        break $label0$0;
                    }
                    t1 = _this.unknownAtRule$2(start, $name);
                    break $label0$0;
                }
                return t1;
            },
            _css$_forbiddenAtRule$1: function(start) {
                this.almostAnyValue$0();
                this.error$2(0, "This at-rule isn't allowed in plain CSS.", this.spanFrom$1(start));
            },
            _css$_cssImportRule$1: function(start) {
                var _0_0, t3, string, $name, _0_3, _0_4, t4, _0_8, t5, modifiers, _this = this, _null = null, t1 = _this.scanner, t2 = t1._string_scanner$_position, _1_0 = t1.peekChar$0();
                $label1$1: {
                    if (117 === _1_0 || 85 === _1_0) {
                        _0_0 = _this.dynamicUrl$0();
                        $label0$0: {
                            if (_0_0 instanceof A.StringExpression0) {
                                t3 = _0_0.text;
                                break $label0$0;
                            }
                            string = _null;
                            t3 = false;
                            if (_0_0 instanceof A.InterpolatedFunctionExpression0) {
                                $name = _0_0.name;
                                _0_3 = _0_0.$arguments;
                                _0_4 = _0_3.positional;
                                t4 = _0_4;
                                if (t4.length === 1) {
                                    _0_8 = _0_4[0];
                                    t4 = _0_8;
                                    if (t4 instanceof A.StringExpression0) {
                                        type$.StringExpression_2._as(_0_8);
                                        t4 = _0_3.named;
                                        if (t4.get$isEmpty(t4)) {
                                            if (_0_3.rest == null) t3 = _0_3.keywordRest == null;
                                        }
                                        string = _0_8;
                                    }
                                }
                            } else $name = _null;
                            if (t3) {
                                t3 = new A.StringBuffer("");
                                t4 = new A.InterpolationBuffer0(t3, A._setArrayType([], type$.JSArray_Object), A._setArrayType([], type$.JSArray_nullable_FileSpan));
                                t4.addInterpolation$1($name);
                                t5 = A.Primitives_stringFromCharCode(40);
                                t3._contents += t5;
                                t4.addInterpolation$1(string.asInterpolation$0());
                                t5 = A.Primitives_stringFromCharCode(41);
                                t3._contents += t5;
                                t4 = t4.interpolation$1(_0_0.span);
                                t3 = t4;
                                break $label0$0;
                            }
                            t3 = _this.error$2(0, "Unsupported plain CSS import.", _0_0.get$span(_0_0));
                        }
                        break $label1$1;
                    }
                    t3 = _this.interpolatedString$0().asInterpolation$1$static(true);
                    break $label1$1;
                }
                _this.whitespace$1$consumeNewlines(true);
                modifiers = _this.tryImportModifiers$0();
                _this.expectStatementSeparator$1("@import rule");
                t2 = A._setArrayType([
                    new A.StaticImport0(t3, modifiers, _this.spanFrom$1(new A._SpanScannerState(t1, t2)))
                ], type$.JSArray_Import_2);
                t1 = _this.spanFrom$1(start);
                return new A.ImportRule0(A.List_List$unmodifiable(t2, type$.Import_2), t1);
            },
            parentheses$0: function() {
                var expression, _this = this, t1 = _this.scanner, t2 = t1._string_scanner$_position;
                t1.expectChar$1(40);
                _this.whitespace$1$consumeNewlines(true);
                expression = _this.expressionUntilComma$0();
                t1.expectChar$1(41);
                return new A.ParenthesizedExpression0(expression, _this.spanFrom$1(new A._SpanScannerState(t1, t2)));
            },
            identifierLike$0: function() {
                var t2, allowEmptySecondArg, $arguments, t3, t4, _this = this, t1 = _this.scanner, start = new A._SpanScannerState(t1, t1._string_scanner$_position), identifier = _this.interpolatedIdentifier$0(), plain = identifier.get$asPlain(), lower = plain.toLowerCase(), _0_0 = _this.trySpecialFunction$2(lower, start);
                if (_0_0 != null) return _0_0;
                t2 = t1._string_scanner$_position;
                if (t1.scanChar$1(46)) return _this.namespacedExpression$2(plain, start);
                else if (lower === "if" && t1.peekChar$0() === 40) return _this.ifExpression$1(start);
                else if (!t1.scanChar$1(40)) return new A.StringExpression0(identifier, false);
                allowEmptySecondArg = lower === "var";
                $arguments = A._setArrayType([], type$.JSArray_Expression_2);
                if (!t1.scanChar$1(41)) {
                    do {
                        _this.whitespace$1$consumeNewlines(true);
                        if (allowEmptySecondArg && $arguments.length === 1 && t1.peekChar$0() === 41) {
                            t3 = A.FileLocation$_(t1._sourceFile, t1._string_scanner$_position);
                            t4 = t3.offset;
                            t4 = A._FileSpan$(t3.file, t4, t4);
                            $arguments.push(new A.StringExpression0(new A.Interpolation0(A.List_List$unmodifiable([
                                ""
                            ], type$.Object), B.List_null, t4), false));
                            break;
                        }
                        $arguments.push(_this.expressionUntilComma$1$singleEquals(true));
                        _this.whitespace$1$consumeNewlines(true);
                    }while (t1.scanChar$1(44));
                    t1.expectChar$1(41);
                }
                if ($.$get$_disallowedFunctionNames0().contains$1(0, plain)) _this.error$2(0, string$.This_f, _this.spanFrom$1(start));
                t1 = A.ArgumentList$0($arguments, B.Map_empty14, B.Map_empty5, _this.spanFrom$1(new A._SpanScannerState(t1, t2)), null, null);
                t2 = _this.spanFrom$1(start);
                return new A.FunctionExpression0(null, A.stringReplaceAllUnchecked(plain, "_", "-"), plain, t1, t2);
            },
            namespacedExpression$2: function(namespace, start) {
                var expression = this.super$StylesheetParser$namespacedExpression0(namespace, start);
                this.error$2(0, string$.Modulen, expression.get$span(expression));
            }
        };
        A.DebugRule0.prototype = {
            accept$1$1: function(visitor) {
                return visitor.visitDebugRule$1(0, this);
            },
            accept$1: function(visitor) {
                return this.accept$1$1(visitor, type$.dynamic);
            },
            toString$0: function(_) {
                return "@debug " + this.expression.toString$0(0) + ";";
            },
            get$span: function(receiver) {
                return this.span;
            }
        };
        A.ModifiableCssDeclaration0.prototype = {
            accept$1$1: function(visitor) {
                return visitor.visitCssDeclaration$1(this);
            },
            accept$1: function(visitor) {
                return this.accept$1$1(visitor, type$.dynamic);
            },
            toString$0: function(_) {
                return this.name.toString$0(0) + ": " + this.value.toString$0(0) + ";";
            },
            get$span: function(receiver) {
                return this.span;
            }
        };
        A.Declaration0.prototype = {
            accept$1$1: function(visitor) {
                return visitor.visitDeclaration$1(0, this);
            },
            accept$1: function(visitor) {
                return this.accept$1$1(visitor, type$.dynamic);
            },
            toString$0: function(_) {
                var t2, _0_0, _this = this, buffer = new A.StringBuffer(""), t1 = _this.name.toString$0(0);
                buffer._contents = t1;
                t1 = buffer._contents = t1 + A.Primitives_stringFromCharCode(58);
                t2 = _this.value;
                if (t2 != null) {
                    if (_this.parsedAsSassScript) t1 = buffer._contents = t1 + A.Primitives_stringFromCharCode(32);
                    buffer._contents = t1 + t2.toString$0(0);
                }
                _0_0 = _this.children;
                if (_0_0 != null) return buffer.toString$0(0) + " {" + B.JSArray_methods.join$1(_0_0, " ") + "}";
                else return buffer.toString$0(0) + ";";
            },
            get$span: function(receiver) {
                return this.span;
            }
        };
        A.SupportsDeclaration0.prototype = {
            get$isCustomProperty: function() {
                var t1, _0_0 = this.name;
                $label0$0: {
                    if (_0_0 instanceof A.StringExpression0 && !_0_0.hasQuotes) {
                        t1 = B.JSString_methods.startsWith$1(_0_0.text.get$initialPlain(), "--");
                        break $label0$0;
                    }
                    t1 = false;
                    break $label0$0;
                }
                return t1;
            },
            toInterpolation$0: function() {
                var visitor, _1_0, _null = null, t1 = new A.StringBuffer(""), t2 = type$.JSArray_Object, t3 = type$.JSArray_nullable_FileSpan, buffer = new A.InterpolationBuffer0(t1, A._setArrayType([], t2), A._setArrayType([], t3)), t4 = this.span, t5 = this.name, t6 = A.SpanExtensions_before(t4, t5.get$span(t5));
                t6 = A.String_String$fromCharCodes(B.NativeUint32List_methods.sublist$2(t6.file._decodedChars, t6._file$_start, t6._end), 0, _null);
                t1._contents += t6;
                if (t5 instanceof A.StringExpression0 && !t5.hasQuotes) buffer.addInterpolation$1(t5.text);
                else buffer.add$2(0, t5, t5.get$span(t5));
                t6 = this.value;
                t5 = A.SpanExtensions_between(t5.get$span(t5), t6.get$span(t6));
                t5 = A.String_String$fromCharCodes(B.NativeUint32List_methods.sublist$2(t5.file._decodedChars, t5._file$_start, t5._end), 0, _null);
                t1._contents += t5;
                visitor = new A.SourceInterpolationVisitor(new A.InterpolationBuffer0(new A.StringBuffer(""), A._setArrayType([], t2), A._setArrayType([], t3)));
                t6.accept$1(visitor);
                t3 = visitor.buffer;
                _1_0 = t3 == null ? _null : t3.interpolation$1(t6.get$span(t6));
                if (_1_0 != null) buffer.addInterpolation$1(_1_0);
                else buffer.add$2(0, t6, t6.get$span(t6));
                t2 = A.SpanExtensions_after(t4, t6.get$span(t6));
                t2 = A.String_String$fromCharCodes(B.NativeUint32List_methods.sublist$2(t2.file._decodedChars, t2._file$_start, t2._end), 0, _null);
                t1._contents += t2;
                return buffer.interpolation$1(t4);
            },
            withSpan$1: function(span) {
                return new A.SupportsDeclaration0(this.name, this.value, span);
            },
            toString$0: function(_) {
                return "(" + this.name.toString$0(0) + ": " + this.value.toString$0(0) + ")";
            },
            $isAstNode0: 1,
            $isSassNode: 1,
            $isSupportsCondition: 1,
            get$span: function(receiver) {
                return this.span;
            }
        };
        A.DefaultLogger0.prototype = {
            get$_default0$_inner: function() {
                var t1 = $._default0;
                if (t1 == null) t1 = $._default0 = new A.StderrLogger0(A.hasTerminal0() || A.isBrowser());
                return t1;
            },
            internalWarn$4$deprecation$span$trace: function(message, deprecation, span, trace) {
                return this.get$_default0$_inner().internalWarn$4$deprecation$span$trace(message, deprecation, span, trace);
            },
            debug$2: function(_, message, span) {
                return this.get$_default0$_inner().debug$2(0, message, span);
            }
        };
        A.Deprecation0.prototype = {
            _enumToString$0: function() {
                return "Deprecation." + this._name;
            },
            get$deprecatedIn: function(_) {
                return A.NullableExtension_andThen0(this._deprecation$_deprecatedIn, A.version_Version___parse_tearOff$closure());
            },
            get$obsoleteIn: function(_) {
                var t1 = this._deprecation$_obsoleteIn;
                return t1 == null ? null : A.NullableExtension_andThen0(t1, A.version_Version___parse_tearOff$closure());
            },
            toString$0: function(_) {
                return this.id;
            }
        };
        A.Deprecation_fromId_closure0.prototype = {
            call$1: function(deprecation) {
                return deprecation.id === this.id;
            },
            $signature: 442
        };
        A.DeprecationProcessingLogger0.prototype = {
            validate$0: function() {
                var t1, t2, t3, t4, $self, t5, _this = this, _null = null;
                for(t1 = _this.fatalDeprecations, t1 = A._LinkedHashSetIterator$(t1, t1._collection$_modifications, A._instanceType(t1)._precomputed1), t2 = _this.silenceDeprecations, t3 = t1.$ti._precomputed1; t1.moveNext$0();){
                    t4 = t1._collection$_current;
                    if (t4 == null) t4 = t3._as(t4);
                    $self = t4._deprecation$_obsoleteIn;
                    if ($self == null) t5 = _null;
                    else t5 = A.Version___parse_tearOff($self);
                    if (t5 instanceof A.Version) {
                        t4 = t4.toString$0(0);
                        _this.internalWarn$4$deprecation$span$trace(t4 + string$.x20deprex20ix2c, _null, _null, _null);
                        continue;
                    }
                    t5 = t2.contains$1(0, t4);
                    if (t5) {
                        t4 = t4.toString$0(0);
                        _this.internalWarn$4$deprecation$span$trace("Ignoring setting to silence " + t4 + string$.x20deprex2c, _null, _null, _null);
                        continue;
                    }
                }
                for(t1 = A._LinkedHashSetIterator$(t2, t2._collection$_modifications, A._instanceType(t2)._precomputed1), t2 = t1.$ti._precomputed1, t3 = _this.futureDeprecations; t1.moveNext$0();){
                    t4 = t1._collection$_current;
                    if (t4 == null) t4 = t2._as(t4);
                    if (B.Deprecation_dlf === t4) {
                        _this.internalWarn$4$deprecation$span$trace(string$.User_a, _null, _null, _null);
                        continue;
                    }
                    $self = t4._deprecation$_obsoleteIn;
                    if ($self == null) t5 = _null;
                    else t5 = A.Version___parse_tearOff($self);
                    if (t5 instanceof A.Version) {
                        t4 = t4.toString$0(0);
                        _this.internalWarn$4$deprecation$span$trace(t4 + string$.x20deprex20ix2e, _null, _null, _null);
                        continue;
                    }
                }
                for(t1 = A._LinkedHashSetIterator$(t3, t3._collection$_modifications, A._instanceType(t3)._precomputed1), t2 = t1.$ti._precomputed1; t1.moveNext$0();){
                    t3 = t1._collection$_current;
                    t3 = (t3 == null ? t2._as(t3) : t3).toString$0(0);
                    _this.internalWarn$4$deprecation$span$trace(t3 + string$.x20is_noaf, _null, _null, _null);
                }
            },
            internalWarn$4$deprecation$span$trace: function(message, deprecation, span, trace) {
                if (deprecation != null) this._deprecation_processing$_handleDeprecation$4$span$trace(deprecation, message, span, trace);
                else this._deprecation_processing$_inner.internalWarn$4$deprecation$span$trace(message, null, span, trace);
            },
            _deprecation_processing$_handleDeprecation$4$span$trace: function(deprecation, message, span, trace) {
                var _0_3_isSet, t1, span0, _0_3, t2, count, _this = this, _null = null;
                if (_this.fatalDeprecations.contains$1(0, deprecation)) {
                    message += string$.x0a_This + deprecation.toString$0(0) + string$.x20deprex20t;
                    $label0$0: {
                        _0_3_isSet = span != null;
                        t1 = false;
                        if (_0_3_isSet) {
                            t1 = trace != null;
                            span0 = span;
                            _0_3 = trace;
                        } else {
                            span0 = _null;
                            _0_3 = span0;
                        }
                        if (t1) {
                            if (_0_3_isSet) trace = _0_3;
                            t1 = A.SassRuntimeException$0(message, span0, trace == null ? type$.Trace._as(trace) : trace, _null);
                            break $label0$0;
                        }
                        t1 = false;
                        if (span != null) t1 = (_0_3_isSet ? _0_3 : trace) == null;
                        else span = _null;
                        if (t1) {
                            t1 = A.SassException$0(message, span, _null);
                            break $label0$0;
                        }
                        t1 = A.SassScriptException$0(message, _null);
                        break $label0$0;
                    }
                    throw A.wrapException(t1);
                }
                if (_this.silenceDeprecations.contains$1(0, deprecation)) return;
                if (_this.limitRepetition) {
                    t1 = _this._deprecation_processing$_warningCounts;
                    t2 = t1.$index(0, deprecation);
                    count = (t2 == null ? 0 : t2) + 1;
                    t1.$indexSet(0, deprecation, count);
                    if (count > 5) return;
                }
                _this._deprecation_processing$_inner.internalWarn$4$deprecation$span$trace(message, deprecation, span, trace);
            },
            debug$2: function(_, message, span) {
                return this._deprecation_processing$_inner.debug$2(0, message, span);
            },
            summarize$1$js: function(js) {
                var t1 = this._deprecation_processing$_warningCounts, t2 = A._instanceType(t1)._eval$1("LinkedHashMapValuesIterable<2>"), total = A.IterableIntegerExtension_get_sum(new A.MappedIterable(new A.WhereIterable(new A.LinkedHashMapValuesIterable(t1, t2), new A.DeprecationProcessingLogger_summarize_closure1(), t2._eval$1("WhereIterable<Iterable.E>")), new A.DeprecationProcessingLogger_summarize_closure2(), t2._eval$1("MappedIterable<Iterable.E,int>")));
                if (total > 0) {
                    t1 = js ? "" : string$.x0aRun_i;
                    this._deprecation_processing$_inner.internalWarn$4$deprecation$span$trace("" + total + string$.x20repet + t1, null, null, null);
                }
            }
        };
        A.DeprecationProcessingLogger_summarize_closure1.prototype = {
            call$1: function(count) {
                return count > 5;
            },
            $signature: 50
        };
        A.DeprecationProcessingLogger_summarize_closure2.prototype = {
            call$1: function(count) {
                return count - 5;
            },
            $signature: 157
        };
        A.Deprecation1.prototype = {};
        A.deprecations_closure.prototype = {
            call$0: function() {
                var _0_8_isSet, _0_8, t1, _0_0 = this.deprecation;
                $label0$0: {
                    _0_8_isSet = A.NullableExtension_andThen0(_0_0._deprecation$_deprecatedIn, A.version_Version___parse_tearOff$closure()) == null;
                    if (_0_8_isSet) {
                        _0_8 = _0_0.get$obsoleteIn(0) == null;
                        t1 = _0_8;
                    } else {
                        _0_8 = null;
                        t1 = false;
                    }
                    if (t1) {
                        t1 = "user";
                        break $label0$0;
                    }
                    if (_0_8_isSet ? _0_8 : _0_0.get$obsoleteIn(0) == null) {
                        t1 = "active";
                        break $label0$0;
                    }
                    t1 = "obsolete";
                    break $label0$0;
                }
                return t1;
            },
            $signature: 29
        };
        A.parseDeprecations_closure.prototype = {
            call$0: function() {
                return new A._SyncStarIterable(this.$call$body$parseDeprecations_closure(), type$._SyncStarIterable_Deprecation);
            },
            $call$body$parseDeprecations_closure: function() {
                var $async$self = this;
                return function() {
                    var $async$goto = 0, $async$handler = 1, $async$errorStack = [], t1, t2, t3, t4, item, t5, id, deprecation, version1;
                    return function $async$call$0($async$iterator, $async$errorCode, $async$result) {
                        if ($async$errorCode === 1) {
                            $async$errorStack.push($async$result);
                            $async$goto = $async$handler;
                        }
                        for(;;)switch($async$goto){
                            case 0:
                                // Function start
                                t1 = J.get$iterator$ax($async$self.deprecations), t2 = type$.Deprecation_2, t3 = $async$self.supportVersions, t4 = $async$self.logger;
                            case 2:
                                // for condition
                                if (!t1.moveNext$0()) {
                                    // goto after for
                                    $async$goto = 3;
                                    break;
                                }
                                item = t1.get$current(t1);
                                t5 = typeof item == "string";
                                id = t5 ? item : null;
                                $async$goto = t5 ? 4 : 5;
                                break;
                            case 4:
                                // then
                                deprecation = A.Deprecation_fromId0(id);
                                $async$goto = deprecation == null ? 6 : 8;
                                break;
                            case 6:
                                // then
                                t4.internalWarn$4$deprecation$span$trace('Invalid deprecation "' + A.S(id) + '".', null, null, null);
                                // goto join
                                $async$goto = 7;
                                break;
                            case 8:
                                // else
                                $async$goto = 9;
                                return $async$iterator._async$_current = deprecation, 1;
                            case 9:
                            // after yield
                            case 7:
                                // join
                                // goto for condition
                                $async$goto = 2;
                                break;
                            case 5:
                                // join
                                t5 = t2._is(item);
                                id = t5 ? J.get$id$x(item) : null;
                                $async$goto = t5 ? 10 : 11;
                                break;
                            case 10:
                                // then
                                deprecation = A.Deprecation_fromId0(id);
                                $async$goto = deprecation == null ? 12 : 14;
                                break;
                            case 12:
                                // then
                                t4.internalWarn$4$deprecation$span$trace('Invalid deprecation "' + A.S(id) + '".', null, null, null);
                                // goto join
                                $async$goto = 13;
                                break;
                            case 14:
                                // else
                                $async$goto = 15;
                                return $async$iterator._async$_current = deprecation, 1;
                            case 15:
                            // after yield
                            case 13:
                                // join
                                // goto for condition
                                $async$goto = 2;
                                break;
                            case 11:
                                // join
                                if (item instanceof A.Version) {
                                    t5 = t3;
                                    version1 = item;
                                } else {
                                    version1 = null;
                                    t5 = false;
                                }
                                $async$goto = t5 ? 16 : 17;
                                break;
                            case 16:
                                // then
                                $async$goto = 18;
                                return $async$iterator._yieldStar$1(A.Deprecation_forVersion0(version1));
                            case 18:
                            // after yield
                            case 17:
                                // join
                                // goto for condition
                                $async$goto = 2;
                                break;
                            case 3:
                                // after for
                                // implicit return
                                return 0;
                            case 1:
                                // rethrow
                                return $async$iterator._datum = $async$errorStack.at(-1), 3;
                        }
                    };
                };
            },
            $signature: 443
        };
        A.versionClass_closure.prototype = {
            call$0: function() {
                var t1 = type$.JSClass, jsClass = t1._as(A.allowInteropCaptureThisNamed("sass.Version", new A.versionClass__closure()));
                jsClass.parse = A.allowInteropNamed("parse", new A.versionClass__closure0());
                A.JSClassExtension_injectSuperclass(t1._as(A.Version_Version(0, 0, 0, null).constructor), jsClass);
                return jsClass;
            },
            $signature: 17
        };
        A.versionClass__closure.prototype = {
            call$4: function($self, major, minor, patch) {
                return A.Version_Version(major, minor, patch, null);
            },
            "call*": "call$4",
            $requiredArgCount: 4,
            $signature: 444
        };
        A.versionClass__closure0.prototype = {
            call$1: function(version1) {
                var v = A.Version_Version$parse(version1);
                if (v.preRelease.length !== 0 || v.build.length !== 0) throw A.wrapException(A.FormatException$("Build identifiers and prerelease versions not supported.", null, null));
                return v;
            },
            $signature: 235
        };
        A.DisplayP3ColorSpace0.prototype = {
            get$isBoundedInternal: function() {
                return true;
            },
            convert$5: function(dest, red, green, blue, alpha) {
                var t1;
                if (dest === B.DisplayP3LinearColorSpace_PrP0) {
                    t1 = this.get$toLinear();
                    t1 = A.SassColor_SassColor$forSpaceInternal0(dest, A.NullableExtension_andThen0(red, t1), A.NullableExtension_andThen0(green, t1), A.NullableExtension_andThen0(blue, t1), alpha);
                } else t1 = this.super$ColorSpace$convertLinear0(dest, red, green, blue, alpha, false, false, false, false, false);
                return t1;
            },
            toLinear$1: function(channel) {
                return A.srgbAndDisplayP3ToLinear0(channel);
            },
            fromLinear$1: function(channel) {
                return A.srgbAndDisplayP3FromLinear0(channel);
            },
            transformationMatrix$1: function(dest) {
                var t1;
                $label0$0: {
                    if (B.SrgbLinearColorSpace_kUj0 === dest || B.SrgbColorSpace_thf0 === dest || B.RgbColorSpace_i0P0 === dest) {
                        t1 = $.$get$linearDisplayP3ToLinearSrgb0();
                        break $label0$0;
                    }
                    if (B.A98RgbColorSpace_lf20 === dest) {
                        t1 = $.$get$linearDisplayP3ToLinearA98Rgb0();
                        break $label0$0;
                    }
                    if (B.ProphotoRgbColorSpace_BDz0 === dest) {
                        t1 = $.$get$linearDisplayP3ToLinearProphotoRgb0();
                        break $label0$0;
                    }
                    if (B.Rec2020ColorSpace_6oo0 === dest) {
                        t1 = $.$get$linearDisplayP3ToLinearRec20200();
                        break $label0$0;
                    }
                    if (B.XyzD65ColorSpace_WiJ0 === dest) {
                        t1 = $.$get$linearDisplayP3ToXyzD650();
                        break $label0$0;
                    }
                    if (B.XyzD50ColorSpace_2OB0 === dest) {
                        t1 = $.$get$linearDisplayP3ToXyzD500();
                        break $label0$0;
                    }
                    if (B.LmsColorSpace_Os30 === dest) {
                        t1 = $.$get$linearDisplayP3ToLms0();
                        break $label0$0;
                    }
                    t1 = this.super$ColorSpace$transformationMatrix0(dest);
                    break $label0$0;
                }
                return t1;
            }
        };
        A.DisplayP3LinearColorSpace0.prototype = {
            get$isBoundedInternal: function() {
                return true;
            },
            convert$5: function(dest, red, green, blue, alpha) {
                return dest === B.DisplayP3ColorSpace_MmT0 ? A.SassColor_SassColor$forSpaceInternal0(dest, A.NullableExtension_andThen0(red, A.utils2__srgbAndDisplayP3FromLinear$closure()), A.NullableExtension_andThen0(green, A.utils2__srgbAndDisplayP3FromLinear$closure()), A.NullableExtension_andThen0(blue, A.utils2__srgbAndDisplayP3FromLinear$closure()), alpha) : this.super$ColorSpace$convert0(dest, red, green, blue, alpha);
            },
            toLinear$1: function(channel) {
                return channel;
            },
            fromLinear$1: function(channel) {
                return channel;
            },
            transformationMatrix$1: function(dest) {
                var t1;
                $label0$0: {
                    if (B.SrgbLinearColorSpace_kUj0 === dest || B.SrgbColorSpace_thf0 === dest || B.RgbColorSpace_i0P0 === dest) {
                        t1 = $.$get$linearDisplayP3ToLinearSrgb0();
                        break $label0$0;
                    }
                    if (B.A98RgbColorSpace_lf20 === dest) {
                        t1 = $.$get$linearDisplayP3ToLinearA98Rgb0();
                        break $label0$0;
                    }
                    if (B.ProphotoRgbColorSpace_BDz0 === dest) {
                        t1 = $.$get$linearDisplayP3ToLinearProphotoRgb0();
                        break $label0$0;
                    }
                    if (B.Rec2020ColorSpace_6oo0 === dest) {
                        t1 = $.$get$linearDisplayP3ToLinearRec20200();
                        break $label0$0;
                    }
                    if (B.XyzD65ColorSpace_WiJ0 === dest) {
                        t1 = $.$get$linearDisplayP3ToXyzD650();
                        break $label0$0;
                    }
                    if (B.XyzD50ColorSpace_2OB0 === dest) {
                        t1 = $.$get$linearDisplayP3ToXyzD500();
                        break $label0$0;
                    }
                    if (B.LmsColorSpace_Os30 === dest) {
                        t1 = $.$get$linearDisplayP3ToLms0();
                        break $label0$0;
                    }
                    t1 = this.super$ColorSpace$transformationMatrix0(dest);
                    break $label0$0;
                }
                return t1;
            }
        };
        A.DynamicImport0.prototype = {
            toString$0: function(_) {
                return A.StringExpression_quoteText0(this.urlString);
            },
            $isImport0: 1,
            $isAstNode0: 1,
            $isSassNode: 1,
            get$span: function(receiver) {
                return this.span;
            }
        };
        A.EachRule0.prototype = {
            accept$1$1: function(visitor) {
                return visitor.visitEachRule$1(0, this);
            },
            accept$1: function(visitor) {
                return this.accept$1$1(visitor, type$.dynamic);
            },
            toString$0: function(_) {
                var t1 = this.variables;
                return "@each " + new A.MappedListIterable(t1, new A.EachRule_toString_closure0(), A._arrayInstanceType(t1)._eval$1("MappedListIterable<1,String>")).join$1(0, ", ") + " in " + this.list.toString$0(0) + " {" + B.JSArray_methods.join$1(this.children, " ") + "}";
            },
            get$span: function(receiver) {
                return this.span;
            }
        };
        A.EachRule_toString_closure0.prototype = {
            call$1: function(variable) {
                return "$" + variable;
            },
            $signature: 6
        };
        A.EmptyExtensionStore0.prototype = {
            get$_extension_store$_extensions: function() {
                return A.throwExpression(A.NoSuchMethodError_NoSuchMethodError$withInvocation(this, A.JSInvocationMirror$(B.Symbol__extensions, "get$_empty_extension_store0$_extensions", 1, [], [], 0)));
            },
            get$_extension_store$_sourceSpecificity: function() {
                return A.throwExpression(A.NoSuchMethodError_NoSuchMethodError$withInvocation(this, A.JSInvocationMirror$(B.Symbol__sourceSpecificity, "get$_empty_extension_store0$_sourceSpecificity", 1, [], [], 0)));
            },
            get$isEmpty: function(_) {
                return true;
            },
            get$simpleSelectors: function() {
                return B.C_EmptyUnmodifiableSet0;
            },
            extensionsWhereTarget$1: function(callback) {
                return B.List_empty21;
            },
            addSelector$2: function(selector, mediaContext) {
                throw A.wrapException(A.UnsupportedError$(string$.addSel));
            },
            addExtension$4: function(extender, target, extend, mediaContext) {
                throw A.wrapException(A.UnsupportedError$(string$.addExt_));
            },
            addExtensions$1: function(extenders) {
                throw A.wrapException(A.UnsupportedError$(string$.addExts));
            },
            clone$0: function() {
                return B.Record2_EmptyExtensionStore_Map_empty0;
            },
            $isExtensionStore0: 1
        };
        A.Environment0.prototype = {
            closure$0: function() {
                var t4, t5, t6, _this = this, t1 = _this._environment0$_forwardedModules, t2 = _this._environment0$_nestedForwardedModules, t3 = _this._environment0$_variables;
                t3 = A._setArrayType(t3.slice(0), A._arrayInstanceType(t3));
                t4 = _this._environment0$_variableNodes;
                t4 = A._setArrayType(t4.slice(0), A._arrayInstanceType(t4));
                t5 = _this._environment0$_functions;
                t5 = A._setArrayType(t5.slice(0), A._arrayInstanceType(t5));
                t6 = _this._environment0$_mixins;
                t6 = A._setArrayType(t6.slice(0), A._arrayInstanceType(t6));
                return A.Environment$_0(_this._environment0$_modules, _this._environment0$_namespaceNodes, _this._environment0$_globalModules, _this._environment0$_importedModules, t1, t2, _this._environment0$_allModules, t3, t4, t5, t6, _this._environment0$_content, B.Set_empty1);
            },
            forwardModule$2: function(module, rule) {
                var view, t1, t2, _this = this, forwardedModules = _this._environment0$_forwardedModules;
                if (forwardedModules == null) forwardedModules = _this._environment0$_forwardedModules = A.LinkedHashMap_LinkedHashMap$_empty(type$.Module_Callable_2, type$.AstNode_2);
                view = A.ForwardedModuleView_ifNecessary0(module, rule, type$.Callable_2);
                for(t1 = new A.LinkedHashMapKeyIterator(forwardedModules, forwardedModules._modifications, forwardedModules._first); t1.moveNext$0();){
                    t2 = t1.__js_helper$_current;
                    _this._environment0$_assertNoConflicts$5(view.get$variables(), t2.get$variables(), view, t2, "variable");
                    _this._environment0$_assertNoConflicts$5(view.get$functions(view), t2.get$functions(t2), view, t2, "function");
                    _this._environment0$_assertNoConflicts$5(view.get$mixins(), t2.get$mixins(), view, t2, "mixin");
                }
                _this._environment0$_allModules.push(module);
                forwardedModules.$indexSet(0, view, rule);
            },
            _environment0$_assertNoConflicts$5: function(newMembers, oldMembers, newModule, oldModule, type) {
                var larger, smaller, t1, t2, t3, t4, $name, small, large, span;
                if (newMembers.get$length(newMembers) < oldMembers.get$length(oldMembers)) {
                    larger = oldMembers;
                    smaller = newMembers;
                } else {
                    larger = newMembers;
                    smaller = oldMembers;
                }
                for(t1 = type$.String, t2 = A.MapExtensions_get_pairs0(smaller, t1, type$.Object), t2 = t2.get$iterator(t2), t3 = type === "variable"; t2.moveNext$0();){
                    t4 = t2.get$current(t2);
                    $name = t4._0;
                    small = t4._1;
                    large = larger.$index(0, $name);
                    if (large == null) continue;
                    if (t3 ? newModule.variableIdentity$1($name) === oldModule.variableIdentity$1($name) : J.$eq$(large, small)) continue;
                    if (t3) $name = "$" + $name;
                    t2 = this._environment0$_forwardedModules;
                    if (t2 == null) span = null;
                    else {
                        t2 = t2.$index(0, oldModule);
                        span = t2 == null ? null : t2.get$span(t2);
                    }
                    t2 = A.LinkedHashMap_LinkedHashMap$_empty(type$.FileSpan, t1);
                    if (span != null) t2.$indexSet(0, span, "original @forward");
                    throw A.wrapException(A.MultiSpanSassScriptException$0("Two forwarded modules both define a " + type + " named " + $name + ".", "new @forward", t2));
                }
            },
            importForwards$1: function(module) {
                var forwardedModules, t1, t2, t3, t4, node, t5, t6, t7, t8, t9, t10, _i, t11, shadowed, t12, t13, _length, _list, _this = this, forwarded = module._environment0$_environment._environment0$_forwardedModules;
                if (forwarded == null) return;
                forwardedModules = _this._environment0$_forwardedModules;
                if (forwardedModules != null) {
                    t1 = type$.Module_Callable_2;
                    t2 = type$.AstNode_2;
                    t3 = A.LinkedHashMap_LinkedHashMap$_empty(t1, t2);
                    for(t1 = A.MapExtensions_get_pairs0(forwarded, t1, t2), t1 = t1.get$iterator(t1), t2 = _this._environment0$_globalModules; t1.moveNext$0();){
                        t4 = t1.get$current(t1);
                        module = t4._0;
                        node = t4._1;
                        if (!forwardedModules.containsKey$1(module) || !t2.containsKey$1(module)) t3.$indexSet(0, module, node);
                    }
                    forwarded = t3;
                } else forwardedModules = _this._environment0$_forwardedModules = A.LinkedHashMap_LinkedHashMap$_empty(type$.Module_Callable_2, type$.AstNode_2);
                t1 = type$.String;
                t2 = A.LinkedHashSet_LinkedHashSet$_empty(t1);
                for(t3 = new A.LinkedHashMapKeyIterator(forwarded, forwarded._modifications, forwarded._first); t3.moveNext$0();)for(t4 = t3.__js_helper$_current.get$variables(), t4 = t4.get$keys(t4), t4 = t4.get$iterator(t4); t4.moveNext$0();)t2.add$1(0, t4.get$current(t4));
                t3 = A.LinkedHashSet_LinkedHashSet$_empty(t1);
                for(t4 = new A.LinkedHashMapKeyIterator(forwarded, forwarded._modifications, forwarded._first); t4.moveNext$0();){
                    t5 = t4.__js_helper$_current;
                    for(t5 = t5.get$functions(t5), t5 = t5.get$keys(t5), t5 = t5.get$iterator(t5); t5.moveNext$0();)t3.add$1(0, t5.get$current(t5));
                }
                t1 = A.LinkedHashSet_LinkedHashSet$_empty(t1);
                for(t4 = new A.LinkedHashMapKeyIterator(forwarded, forwarded._modifications, forwarded._first); t4.moveNext$0();)for(t5 = t4.__js_helper$_current.get$mixins(), t5 = t5.get$keys(t5), t5 = t5.get$iterator(t5); t5.moveNext$0();)t1.add$1(0, t5.get$current(t5));
                t4 = _this._environment0$_variables;
                t5 = t4.length;
                if (t5 === 1) {
                    for(t5 = _this._environment0$_importedModules, t6 = type$.Module_Callable_2, t7 = type$.AstNode_2, t8 = A.MapExtensions_get_pairs0(t5, t6, t7).toList$0(0), t9 = t8.length, t10 = type$.Callable_2, _i = 0; _i < t8.length; t8.length === t9 || (0, A.throwConcurrentModificationError)(t8), ++_i){
                        t11 = t8[_i];
                        module = t11._0;
                        shadowed = A.ShadowedModuleView_ifNecessary0(module, t3, t1, t2, t10);
                        if (shadowed != null) {
                            t5.remove$1(0, module);
                            t12 = shadowed.variables;
                            t13 = false;
                            if (t12.get$isEmpty(t12)) {
                                t12 = shadowed.functions;
                                if (t12.get$isEmpty(t12)) {
                                    t12 = shadowed.mixins;
                                    if (t12.get$isEmpty(t12)) {
                                        t12 = shadowed._shadowed_view0$_inner;
                                        t12 = t12.get$css(t12);
                                        t12 = J.get$isEmpty$asx(t12.get$children(t12));
                                    } else t12 = t13;
                                } else t12 = t13;
                            } else t12 = t13;
                            if (!t12) t5.$indexSet(0, shadowed, t11._1);
                        }
                    }
                    for(t6 = A.MapExtensions_get_pairs0(forwardedModules, t6, t7).toList$0(0), t7 = t6.length, _i = 0; _i < t6.length; t6.length === t7 || (0, A.throwConcurrentModificationError)(t6), ++_i){
                        t8 = t6[_i];
                        module = t8._0;
                        shadowed = A.ShadowedModuleView_ifNecessary0(module, t3, t1, t2, t10);
                        if (shadowed != null) {
                            forwardedModules.remove$1(0, module);
                            t9 = shadowed.variables;
                            t11 = false;
                            if (t9.get$isEmpty(t9)) {
                                t9 = shadowed.functions;
                                if (t9.get$isEmpty(t9)) {
                                    t9 = shadowed.mixins;
                                    if (t9.get$isEmpty(t9)) {
                                        t9 = shadowed._shadowed_view0$_inner;
                                        t9 = t9.get$css(t9);
                                        t9 = J.get$isEmpty$asx(t9.get$children(t9));
                                    } else t9 = t11;
                                } else t9 = t11;
                            } else t9 = t11;
                            if (!t9) forwardedModules.$indexSet(0, shadowed, t8._1);
                        }
                    }
                    t5.addAll$1(0, forwarded);
                    forwardedModules.addAll$1(0, forwarded);
                } else {
                    t6 = _this._environment0$_nestedForwardedModules;
                    if (t6 == null) {
                        _length = t5 - 1;
                        _list = J.JSArray_JSArray$allocateGrowable(_length, type$.List_Module_Callable_2);
                        for(t5 = type$.JSArray_Module_Callable_2, _i = 0; _i < _length; ++_i)_list[_i] = A._setArrayType([], t5);
                        _this._environment0$_nestedForwardedModules = _list;
                        t5 = _list;
                    } else t5 = t6;
                    B.JSArray_methods.addAll$1(B.JSArray_methods.get$last(t5), new A.LinkedHashMapKeysIterable(forwarded, A._instanceType(forwarded)._eval$1("LinkedHashMapKeysIterable<1>")));
                }
                for(t2 = A._LinkedHashSetIterator$(t2, t2._collection$_modifications, t2.$ti._precomputed1), t5 = _this._environment0$_variableIndices, t6 = _this._environment0$_variableNodes, t7 = t2.$ti._precomputed1; t2.moveNext$0();){
                    t8 = t2._collection$_current;
                    if (t8 == null) t8 = t7._as(t8);
                    t5.remove$1(0, t8);
                    B.JSArray_methods.get$last(t4).remove$1(0, t8);
                    B.JSArray_methods.get$last(t6).remove$1(0, t8);
                }
                for(t2 = A._LinkedHashSetIterator$(t3, t3._collection$_modifications, t3.$ti._precomputed1), t3 = _this._environment0$_functionIndices, t4 = _this._environment0$_functions, t5 = t2.$ti._precomputed1; t2.moveNext$0();){
                    t6 = t2._collection$_current;
                    if (t6 == null) t6 = t5._as(t6);
                    t3.remove$1(0, t6);
                    B.JSArray_methods.get$last(t4).remove$1(0, t6);
                }
                for(t1 = A._LinkedHashSetIterator$(t1, t1._collection$_modifications, t1.$ti._precomputed1), t2 = _this._environment0$_mixinIndices, t3 = _this._environment0$_mixins, t4 = t1.$ti._precomputed1; t1.moveNext$0();){
                    t5 = t1._collection$_current;
                    if (t5 == null) t5 = t4._as(t5);
                    t2.remove$1(0, t5);
                    B.JSArray_methods.get$last(t3).remove$1(0, t5);
                }
            },
            getVariable$2$namespace: function($name, namespace) {
                var t1, _0_0, _1_0, _this = this;
                if (namespace != null) return _this._environment0$_getModule$1(namespace).get$variables().$index(0, $name);
                if (_this._environment0$_lastVariableName === $name) {
                    t1 = _this._environment0$_lastVariableIndex;
                    t1.toString;
                    t1 = _this._environment0$_variables[t1].$index(0, $name);
                    return t1 == null ? _this._environment0$_getVariableFromGlobalModule$1($name) : t1;
                }
                t1 = _this._environment0$_variableIndices;
                _0_0 = t1.$index(0, $name);
                if (_0_0 != null) {
                    _this._environment0$_lastVariableName = $name;
                    _this._environment0$_lastVariableIndex = _0_0;
                    t1 = _this._environment0$_variables[_0_0].$index(0, $name);
                    return t1 == null ? _this._environment0$_getVariableFromGlobalModule$1($name) : t1;
                } else {
                    _1_0 = _this._environment0$_variableIndex$1($name);
                    if (_1_0 != null) {
                        _this._environment0$_lastVariableName = $name;
                        _this._environment0$_lastVariableIndex = _1_0;
                        t1.$indexSet(0, $name, _1_0);
                        t1 = _this._environment0$_variables[_1_0].$index(0, $name);
                        return t1 == null ? _this._environment0$_getVariableFromGlobalModule$1($name) : t1;
                    } else return _this._environment0$_getVariableFromGlobalModule$1($name);
                }
            },
            getVariable$1: function($name) {
                return this.getVariable$2$namespace($name, null);
            },
            _environment0$_getVariableFromGlobalModule$1: function($name) {
                return this._environment0$_fromOneModule$3($name, "variable", new A.Environment__getVariableFromGlobalModule_closure0($name));
            },
            getVariableNode$2$namespace: function($name, namespace) {
                var t1, _0_0, _1_0, _this = this;
                if (namespace != null) return _this._environment0$_getModule$1(namespace).get$variableNodes().$index(0, $name);
                if (_this._environment0$_lastVariableName === $name) {
                    t1 = _this._environment0$_lastVariableIndex;
                    t1.toString;
                    t1 = _this._environment0$_variableNodes[t1].$index(0, $name);
                    return t1 == null ? _this._environment0$_getVariableNodeFromGlobalModule$1($name) : t1;
                }
                t1 = _this._environment0$_variableIndices;
                _0_0 = t1.$index(0, $name);
                if (_0_0 != null) {
                    _this._environment0$_lastVariableName = $name;
                    _this._environment0$_lastVariableIndex = _0_0;
                    t1 = _this._environment0$_variableNodes[_0_0].$index(0, $name);
                    return t1 == null ? _this._environment0$_getVariableNodeFromGlobalModule$1($name) : t1;
                } else {
                    _1_0 = _this._environment0$_variableIndex$1($name);
                    if (_1_0 != null) {
                        _this._environment0$_lastVariableName = $name;
                        _this._environment0$_lastVariableIndex = _1_0;
                        t1.$indexSet(0, $name, _1_0);
                        t1 = _this._environment0$_variableNodes[_1_0].$index(0, $name);
                        return t1 == null ? _this._environment0$_getVariableNodeFromGlobalModule$1($name) : t1;
                    } else return _this._environment0$_getVariableNodeFromGlobalModule$1($name);
                }
            },
            _environment0$_getVariableNodeFromGlobalModule$1: function($name) {
                var t1, t2, _0_0;
                for(t1 = this._environment0$_importedModules, t2 = this._environment0$_globalModules, t2 = new A.LinkedHashMapKeysIterable(t1, A._instanceType(t1)._eval$1("LinkedHashMapKeysIterable<1>")).followedBy$1(0, new A.LinkedHashMapKeysIterable(t2, A._instanceType(t2)._eval$1("LinkedHashMapKeysIterable<1>"))), t2 = new A.FollowedByIterator(J.get$iterator$ax(t2.__internal$_first), t2._second); t2.moveNext$0();){
                    t1 = t2._currentIterator;
                    _0_0 = t1.get$current(t1).get$variableNodes().$index(0, $name);
                    if (_0_0 != null) return _0_0;
                }
                return null;
            },
            globalVariableExists$2$namespace: function($name, namespace) {
                if (namespace != null) return this._environment0$_getModule$1(namespace).get$variables().containsKey$1($name);
                if (B.JSArray_methods.get$first(this._environment0$_variables).containsKey$1($name)) return true;
                return this._environment0$_getVariableFromGlobalModule$1($name) != null;
            },
            globalVariableExists$1: function($name) {
                return this.globalVariableExists$2$namespace($name, null);
            },
            _environment0$_variableIndex$1: function($name) {
                var t1, i;
                for(t1 = this._environment0$_variables, i = t1.length - 1; i >= 0; --i)if (t1[i].containsKey$1($name)) return i;
                return null;
            },
            setVariable$5$global$namespace: function($name, value, nodeWithSpan, global, namespace) {
                var t1, moduleWithName, nestedForwardedModules, t2, t3, t4, t5, index, _this = this;
                if (namespace != null) {
                    _this._environment0$_getModule$1(namespace).setVariable$3($name, value, nodeWithSpan);
                    return;
                }
                if (global || _this._environment0$_variables.length === 1) {
                    _this._environment0$_variableIndices.putIfAbsent$2($name, new A.Environment_setVariable_closure2(_this, $name));
                    t1 = _this._environment0$_variables;
                    if (!B.JSArray_methods.get$first(t1).containsKey$1($name)) {
                        moduleWithName = _this._environment0$_fromOneModule$3($name, "variable", new A.Environment_setVariable_closure3($name));
                        if (moduleWithName != null) {
                            moduleWithName.setVariable$3($name, value, nodeWithSpan);
                            return;
                        }
                    }
                    B.JSArray_methods.get$first(t1).$indexSet(0, $name, value);
                    B.JSArray_methods.get$first(_this._environment0$_variableNodes).$indexSet(0, $name, nodeWithSpan);
                    return;
                }
                nestedForwardedModules = _this._environment0$_nestedForwardedModules;
                if (nestedForwardedModules != null && !_this._environment0$_variableIndices.containsKey$1($name) && _this._environment0$_variableIndex$1($name) == null) for(t1 = A._arrayInstanceType(nestedForwardedModules)._eval$1("ReversedListIterable<1>"), t2 = new A.ReversedListIterable(nestedForwardedModules, t1), t2 = new A.ListIterator(t2, t2.get$length(0), t1._eval$1("ListIterator<ListIterable.E>")), t1 = t1._eval$1("ListIterable.E"); t2.moveNext$0();){
                    t3 = t2.__internal$_current;
                    for(t3 = J.get$reversed$ax(t3 == null ? t1._as(t3) : t3), t4 = t3.$ti, t3 = new A.ListIterator(t3, t3.get$length(0), t4._eval$1("ListIterator<ListIterable.E>")), t4 = t4._eval$1("ListIterable.E"); t3.moveNext$0();){
                        t5 = t3.__internal$_current;
                        if (t5 == null) t5 = t4._as(t5);
                        if (t5.get$variables().containsKey$1($name)) {
                            t5.setVariable$3($name, value, nodeWithSpan);
                            return;
                        }
                    }
                }
                if (_this._environment0$_lastVariableName === $name) {
                    t1 = _this._environment0$_lastVariableIndex;
                    t1.toString;
                    index = t1;
                } else index = _this._environment0$_variableIndices.putIfAbsent$2($name, new A.Environment_setVariable_closure4(_this, $name));
                if (!_this._environment0$_inSemiGlobalScope && index === 0) {
                    index = _this._environment0$_variables.length - 1;
                    _this._environment0$_variableIndices.$indexSet(0, $name, index);
                }
                _this._environment0$_lastVariableName = $name;
                _this._environment0$_lastVariableIndex = index;
                _this._environment0$_variables[index].$indexSet(0, $name, value);
                _this._environment0$_variableNodes[index].$indexSet(0, $name, nodeWithSpan);
            },
            setVariable$4$global: function($name, value, nodeWithSpan, global) {
                return this.setVariable$5$global$namespace($name, value, nodeWithSpan, global, null);
            },
            setLocalVariable$3: function($name, value, nodeWithSpan) {
                var index, _this = this, t1 = _this._environment0$_variables, t2 = t1.length;
                _this._environment0$_lastVariableName = $name;
                index = _this._environment0$_lastVariableIndex = t2 - 1;
                _this._environment0$_variableIndices.$indexSet(0, $name, index);
                t1[index].$indexSet(0, $name, value);
                _this._environment0$_variableNodes[index].$indexSet(0, $name, nodeWithSpan);
            },
            getFunction$2$namespace: function($name, namespace) {
                var t1, _0_0, _1_0, _this = this;
                if (namespace != null) {
                    t1 = _this._environment0$_getModule$1(namespace);
                    return t1.get$functions(t1).$index(0, $name);
                }
                t1 = _this._environment0$_functionIndices;
                _0_0 = t1.$index(0, $name);
                if (_0_0 != null) {
                    t1 = _this._environment0$_functions[_0_0].$index(0, $name);
                    return t1 == null ? _this._environment0$_getFunctionFromGlobalModule$1($name) : t1;
                } else {
                    _1_0 = _this._environment0$_functionIndex$1($name);
                    if (_1_0 != null) {
                        t1.$indexSet(0, $name, _1_0);
                        t1 = _this._environment0$_functions[_1_0].$index(0, $name);
                        return t1 == null ? _this._environment0$_getFunctionFromGlobalModule$1($name) : t1;
                    } else return _this._environment0$_getFunctionFromGlobalModule$1($name);
                }
            },
            getFunction$1: function($name) {
                return this.getFunction$2$namespace($name, null);
            },
            _environment0$_getFunctionFromGlobalModule$1: function($name) {
                return this._environment0$_fromOneModule$3($name, "function", new A.Environment__getFunctionFromGlobalModule_closure0($name));
            },
            _environment0$_functionIndex$1: function($name) {
                var t1, i;
                for(t1 = this._environment0$_functions, i = t1.length - 1; i >= 0; --i)if (t1[i].containsKey$1($name)) return i;
                return null;
            },
            getMixin$2$namespace: function($name, namespace) {
                var t1, _0_0, _1_0, _this = this;
                if (namespace != null) return _this._environment0$_getModule$1(namespace).get$mixins().$index(0, $name);
                t1 = _this._environment0$_mixinIndices;
                _0_0 = t1.$index(0, $name);
                if (_0_0 != null) {
                    t1 = _this._environment0$_mixins[_0_0].$index(0, $name);
                    return t1 == null ? _this._environment0$_getMixinFromGlobalModule$1($name) : t1;
                } else {
                    _1_0 = _this._environment0$_mixinIndex$1($name);
                    if (_1_0 != null) {
                        t1.$indexSet(0, $name, _1_0);
                        t1 = _this._environment0$_mixins[_1_0].$index(0, $name);
                        return t1 == null ? _this._environment0$_getMixinFromGlobalModule$1($name) : t1;
                    } else return _this._environment0$_getMixinFromGlobalModule$1($name);
                }
            },
            _environment0$_getMixinFromGlobalModule$1: function($name) {
                return this._environment0$_fromOneModule$3($name, "mixin", new A.Environment__getMixinFromGlobalModule_closure0($name));
            },
            _environment0$_mixinIndex$1: function($name) {
                var t1, i;
                for(t1 = this._environment0$_mixins, i = t1.length - 1; i >= 0; --i)if (t1[i].containsKey$1($name)) return i;
                return null;
            },
            withContent$2: function($content, callback) {
                var oldContent = this._environment0$_content;
                this._environment0$_content = $content;
                callback.call$0();
                this._environment0$_content = oldContent;
            },
            asMixin$1: function(callback) {
                var oldInMixin = this._environment0$_inMixin;
                this._environment0$_inMixin = true;
                callback.call$0();
                this._environment0$_inMixin = oldInMixin;
            },
            scope$1$3$semiGlobal$when: function(callback, semiGlobal, when) {
                var wasInSemiGlobalScope, $name, name0, name1, t1, t2, t3, t4, t5, t6, _this = this;
                semiGlobal = semiGlobal && _this._environment0$_inSemiGlobalScope;
                wasInSemiGlobalScope = _this._environment0$_inSemiGlobalScope;
                _this._environment0$_inSemiGlobalScope = semiGlobal;
                if (!when) try {
                    t1 = callback.call$0();
                    return t1;
                } finally{
                    _this._environment0$_inSemiGlobalScope = wasInSemiGlobalScope;
                }
                t1 = _this._environment0$_variables;
                t2 = type$.String;
                B.JSArray_methods.add$1(t1, A.LinkedHashMap_LinkedHashMap$_empty(t2, type$.Value_2));
                t3 = _this._environment0$_variableNodes;
                B.JSArray_methods.add$1(t3, A.LinkedHashMap_LinkedHashMap$_empty(t2, type$.AstNode_2));
                t4 = _this._environment0$_functions;
                t5 = type$.Callable_2;
                B.JSArray_methods.add$1(t4, A.LinkedHashMap_LinkedHashMap$_empty(t2, t5));
                t6 = _this._environment0$_mixins;
                B.JSArray_methods.add$1(t6, A.LinkedHashMap_LinkedHashMap$_empty(t2, t5));
                t5 = _this._environment0$_nestedForwardedModules;
                if (t5 != null) t5.push(A._setArrayType([], type$.JSArray_Module_Callable_2));
                try {
                    t2 = callback.call$0();
                    return t2;
                } finally{
                    _this._environment0$_inSemiGlobalScope = wasInSemiGlobalScope;
                    _this._environment0$_lastVariableIndex = _this._environment0$_lastVariableName = null;
                    for(t1 = B.JSArray_methods.removeLast$0(t1), t1 = t1.get$keys(t1), t1 = t1.get$iterator(t1), t2 = _this._environment0$_variableIndices; t1.moveNext$0();){
                        $name = t1.get$current(t1);
                        t2.remove$1(0, $name);
                    }
                    B.JSArray_methods.removeLast$0(t3);
                    for(t1 = B.JSArray_methods.removeLast$0(t4), t1 = t1.get$keys(t1), t1 = t1.get$iterator(t1), t2 = _this._environment0$_functionIndices; t1.moveNext$0();){
                        name0 = t1.get$current(t1);
                        t2.remove$1(0, name0);
                    }
                    for(t1 = B.JSArray_methods.removeLast$0(t6), t1 = t1.get$keys(t1), t1 = t1.get$iterator(t1), t2 = _this._environment0$_mixinIndices; t1.moveNext$0();){
                        name1 = t1.get$current(t1);
                        t2.remove$1(0, name1);
                    }
                    t1 = _this._environment0$_nestedForwardedModules;
                    if (t1 != null) t1.pop();
                }
            },
            scope$1$1: function(callback) {
                return this.scope$1$3$semiGlobal$when(callback, false, true);
            },
            scope$1$2$when: function(callback, when) {
                return this.scope$1$3$semiGlobal$when(callback, false, when);
            },
            scope$1$2$semiGlobal: function(callback, semiGlobal) {
                return this.scope$1$3$semiGlobal$when(callback, semiGlobal, true);
            },
            toImplicitConfiguration$0: function() {
                var t2, t3, t4, t5, t6, i, modules, t7, t8, t9, t10, $name, value, values, nodes, _this = this, _null = null, t1 = type$.String, configuration = A.LinkedHashMap_LinkedHashMap$_empty(t1, type$.ConfiguredValue_2);
                for(t2 = _this._environment0$_variables, t3 = type$.Value_2, t4 = _this._environment0$_variableNodes, t5 = _this._environment0$_importedModules, t6 = A._instanceType(t5)._eval$1("LinkedHashMapKeysIterable<1>"), i = 0; i < t2.length; ++i){
                    if (i === 0) modules = new A.LinkedHashMapKeysIterable(t5, t6);
                    else {
                        t7 = _this._environment0$_nestedForwardedModules;
                        modules = t7 == null ? _null : t7[i - 1];
                    }
                    t7 = J.get$iterator$ax(modules == null ? B.List_empty25 : modules);
                    while(t7.moveNext$0()){
                        t8 = t7.get$current(t7);
                        for(t9 = A.MapExtensions_get_pairs0(t8.get$variables(), t1, t3), t9 = t9.get$iterator(t9); t9.moveNext$0();){
                            t10 = t9.get$current(t9);
                            $name = t10._0;
                            value = t10._1;
                            t10 = t8.get$variableNodes().$index(0, $name);
                            t10.toString;
                            configuration.$indexSet(0, $name, new A.ConfiguredValue0(value, _null, t10));
                        }
                    }
                    values = t2[i];
                    nodes = t4[i];
                    for(t7 = A.MapExtensions_get_pairs0(values, t1, t3), t7 = t7.get$iterator(t7); t7.moveNext$0();){
                        t8 = t7.get$current(t7);
                        $name = t8._0;
                        value = t8._1;
                        t8 = nodes.$index(0, $name);
                        t8.toString;
                        configuration.$indexSet(0, $name, new A.ConfiguredValue0(value, _null, t8));
                    }
                }
                return new A.Configuration0(configuration, _null);
            },
            toModule$3: function(css, preModuleComments, extensionStore) {
                return A._EnvironmentModule__EnvironmentModule1(this, css, preModuleComments, extensionStore, A.NullableExtension_andThen0(this._environment0$_forwardedModules, new A.Environment_toModule_closure0()));
            },
            toDummyModule$0: function() {
                return A._EnvironmentModule__EnvironmentModule1(this, new A.CssStylesheet0(new A.UnmodifiableListView(B.List_empty20, type$.UnmodifiableListView_CssNode_2), A.SourceFile$decoded(B.List_empty4, "<dummy module>").span$1(0, 0)), B.Map_empty10, B.C_EmptyExtensionStore0, A.NullableExtension_andThen0(this._environment0$_forwardedModules, new A.Environment_toDummyModule_closure0()));
            },
            _environment0$_getModule$1: function(namespace) {
                var _0_0 = this._environment0$_modules.$index(0, namespace);
                if (_0_0 != null) return _0_0;
                throw A.wrapException(A.SassScriptException$0('There is no module with the namespace "' + namespace + '".', null));
            },
            _environment0$_fromOneModule$1$3: function($name, type, callback) {
                var t1, t2, t3, t4, t5, _1_0, _2_0, value, identity, valueInModule, identityFromModule, module, node, _0_0 = this._environment0$_nestedForwardedModules;
                if (_0_0 != null) for(t1 = A._arrayInstanceType(_0_0)._eval$1("ReversedListIterable<1>"), t2 = new A.ReversedListIterable(_0_0, t1), t2 = new A.ListIterator(t2, t2.get$length(0), t1._eval$1("ListIterator<ListIterable.E>")), t1 = t1._eval$1("ListIterable.E"); t2.moveNext$0();){
                    t3 = t2.__internal$_current;
                    for(t3 = J.get$reversed$ax(t3 == null ? t1._as(t3) : t3), t4 = t3.$ti, t3 = new A.ListIterator(t3, t3.get$length(0), t4._eval$1("ListIterator<ListIterable.E>")), t4 = t4._eval$1("ListIterable.E"); t3.moveNext$0();){
                        t5 = t3.__internal$_current;
                        _1_0 = callback.call$1(t5 == null ? t4._as(t5) : t5);
                        if (_1_0 != null) return _1_0;
                    }
                }
                for(t1 = this._environment0$_importedModules, t1 = new A.LinkedHashMapKeyIterator(t1, t1._modifications, t1._first); t1.moveNext$0();){
                    _2_0 = callback.call$1(t1.__js_helper$_current);
                    if (_2_0 != null) return _2_0;
                }
                for(t1 = this._environment0$_globalModules, t2 = new A.LinkedHashMapKeyIterator(t1, t1._modifications, t1._first), t3 = type$.Callable_2, value = null, identity = null; t2.moveNext$0();){
                    t4 = t2.__js_helper$_current;
                    valueInModule = callback.call$1(t4);
                    if (valueInModule == null) continue;
                    identityFromModule = t3._is(valueInModule) ? valueInModule : t4.variableIdentity$1($name);
                    if (identityFromModule.$eq(0, identity)) continue;
                    if (value != null) {
                        t2 = A.LinkedHashMap_LinkedHashMap$_empty(type$.FileSpan, type$.String);
                        for(t3 = A.MapExtensions_get_pairs0(t1, type$.Module_Callable_2, type$.AstNode_2), t3 = t3.get$iterator(t3), t4 = "includes " + type; t3.moveNext$0();){
                            t1 = t3.get$current(t3);
                            module = t1._0;
                            node = t1._1;
                            if (callback.call$1(module) != null) t2.$indexSet(0, node.get$span(node), t4);
                        }
                        throw A.wrapException(A.MultiSpanSassScriptException$0("This " + type + string$.x20is_av, type + " use", t2));
                    }
                    identity = identityFromModule;
                    value = valueInModule;
                }
                return value;
            },
            _environment0$_fromOneModule$3: function($name, type, callback) {
                return this._environment0$_fromOneModule$1$3($name, type, callback, type$.dynamic);
            }
        };
        A.Environment__getVariableFromGlobalModule_closure0.prototype = {
            call$1: function(module) {
                return module.get$variables().$index(0, this.name);
            },
            $signature: 447
        };
        A.Environment_setVariable_closure2.prototype = {
            call$0: function() {
                var t1 = this.$this;
                t1._environment0$_lastVariableName = this.name;
                return t1._environment0$_lastVariableIndex = 0;
            },
            $signature: 10
        };
        A.Environment_setVariable_closure3.prototype = {
            call$1: function(module) {
                return module.get$variables().containsKey$1(this.name) ? module : null;
            },
            $signature: 448
        };
        A.Environment_setVariable_closure4.prototype = {
            call$0: function() {
                var t1 = this.$this, t2 = t1._environment0$_variableIndex$1(this.name);
                return t2 == null ? t1._environment0$_variables.length - 1 : t2;
            },
            $signature: 10
        };
        A.Environment__getFunctionFromGlobalModule_closure0.prototype = {
            call$1: function(module) {
                return module.get$functions(module).$index(0, this.name);
            },
            $signature: 237
        };
        A.Environment__getMixinFromGlobalModule_closure0.prototype = {
            call$1: function(module) {
                return module.get$mixins().$index(0, this.name);
            },
            $signature: 237
        };
        A.Environment_toModule_closure0.prototype = {
            call$1: function(modules) {
                return new A.MapKeySet(modules, type$.MapKeySet_Module_Callable_2);
            },
            $signature: 238
        };
        A.Environment_toDummyModule_closure0.prototype = {
            call$1: function(modules) {
                return new A.MapKeySet(modules, type$.MapKeySet_Module_Callable_2);
            },
            $signature: 238
        };
        A._EnvironmentModule1.prototype = {
            get$url: function(_) {
                var t1 = this.css;
                t1 = t1.get$span(t1);
                return t1.get$sourceUrl(t1);
            },
            setVariable$3: function($name, value, nodeWithSpan) {
                var t1, t2, _0_0 = this._environment0$_modulesByVariable.$index(0, $name);
                if (_0_0 != null) {
                    _0_0.setVariable$3($name, value, nodeWithSpan);
                    return;
                }
                t1 = this._environment0$_environment;
                t2 = t1._environment0$_variables;
                if (!B.JSArray_methods.get$first(t2).containsKey$1($name)) throw A.wrapException(A.SassScriptException$0("Undefined variable.", null));
                B.JSArray_methods.get$first(t2).$indexSet(0, $name, value);
                B.JSArray_methods.get$first(t1._environment0$_variableNodes).$indexSet(0, $name, nodeWithSpan);
                return;
            },
            variableIdentity$1: function($name) {
                var module = this._environment0$_modulesByVariable.$index(0, $name);
                return module == null ? this : module.variableIdentity$1($name);
            },
            couldHaveBeenConfigured$1: function(variables) {
                var t2, t3, _0_0, variable, module, t1 = this._environment0$_environment._environment0$_configurableVariables;
                if (!(variables.get$length(variables) < t1.get$length(t1) ? variables.any$1(0, t1.get$contains(t1)) : t1.any$1(0, variables.get$contains(variables)))) {
                    t1 = this._environment0$_modulesByVariable;
                    t2 = type$.Module_Callable_2;
                    if (variables.get$length(variables) < t1.get$length(t1)) {
                        t2 = A.LinkedHashSet_LinkedHashSet$_empty(t2);
                        for(t3 = variables.get$iterator(variables); t3.moveNext$0();){
                            _0_0 = t1.$index(0, t3.get$current(t3));
                            if (_0_0 != null) t2.add$1(0, _0_0);
                        }
                        t1 = t2;
                    } else {
                        t3 = A.LinkedHashSet_LinkedHashSet$_empty(t2);
                        for(t1 = A.MapExtensions_get_pairs0(t1, type$.String, t2), t1 = t1.get$iterator(t1); t1.moveNext$0();){
                            t2 = t1.get$current(t1);
                            variable = t2._0;
                            module = t2._1;
                            if (variables.contains$1(0, variable)) t3.add$1(0, module);
                        }
                        t1 = t3;
                    }
                    t1 = t1.any$1(0, new A._EnvironmentModule_couldHaveBeenConfigured_closure1(variables));
                } else t1 = true;
                return t1;
            },
            cloneCss$0: function() {
                var _0_0, _this = this;
                if (!_this.transitivelyContainsCss) return _this;
                _0_0 = A.cloneCssStylesheet0(_this.css, _this.extensionStore);
                return A._EnvironmentModule$_1(_this._environment0$_environment, _0_0._0, _this.preModuleComments, _0_0._1, _this._environment0$_modulesByVariable, _this.variables, _this.variableNodes, _this.functions, _this.mixins, true, _this.transitivelyContainsExtensions);
            },
            toString$0: function(_) {
                var t1 = this.css, t2 = t1.get$span(t1);
                if (t2.get$sourceUrl(t2) == null) t1 = "<unknown url>";
                else {
                    t1 = t1.get$span(t1);
                    t1 = t1.get$sourceUrl(t1);
                    t2 = $.$get$context();
                    t1.toString;
                    t1 = t2.prettyUri$1(t1);
                }
                return t1;
            },
            $isModule1: 1,
            get$upstream: function() {
                return this.upstream;
            },
            get$variables: function() {
                return this.variables;
            },
            get$variableNodes: function() {
                return this.variableNodes;
            },
            get$functions: function(receiver) {
                return this.functions;
            },
            get$mixins: function() {
                return this.mixins;
            },
            get$extensionStore: function() {
                return this.extensionStore;
            },
            get$css: function(receiver) {
                return this.css;
            },
            get$preModuleComments: function() {
                return this.preModuleComments;
            },
            get$transitivelyContainsCss: function() {
                return this.transitivelyContainsCss;
            },
            get$transitivelyContainsExtensions: function() {
                return this.transitivelyContainsExtensions;
            }
        };
        A._EnvironmentModule__EnvironmentModule_closure11.prototype = {
            call$1: function(module) {
                return module.get$variables();
            },
            $signature: 451
        };
        A._EnvironmentModule__EnvironmentModule_closure12.prototype = {
            call$1: function(module) {
                return module.get$variableNodes();
            },
            $signature: 452
        };
        A._EnvironmentModule__EnvironmentModule_closure13.prototype = {
            call$1: function(module) {
                return module.get$functions(module);
            },
            $signature: 239
        };
        A._EnvironmentModule__EnvironmentModule_closure14.prototype = {
            call$1: function(module) {
                return module.get$mixins();
            },
            $signature: 239
        };
        A._EnvironmentModule__EnvironmentModule_closure15.prototype = {
            call$1: function(module) {
                return module.get$transitivelyContainsCss();
            },
            $signature: 85
        };
        A._EnvironmentModule__EnvironmentModule_closure16.prototype = {
            call$1: function(module) {
                return module.get$transitivelyContainsExtensions();
            },
            $signature: 85
        };
        A._EnvironmentModule_couldHaveBeenConfigured_closure1.prototype = {
            call$1: function(module) {
                return module.couldHaveBeenConfigured$1(this.variables);
            },
            $signature: 85
        };
        A.ErrorRule0.prototype = {
            accept$1$1: function(visitor) {
                return visitor.visitErrorRule$1(0, this);
            },
            accept$1: function(visitor) {
                return this.accept$1$1(visitor, type$.dynamic);
            },
            toString$0: function(_) {
                return "@error " + this.expression.toString$0(0) + ";";
            },
            get$span: function(receiver) {
                return this.span;
            }
        };
        A._EvaluateVisitor1.prototype = {
            get$_evaluate0$_hasCssNesting: function() {
                var _0_0, t1, grandparent, $parent = this._evaluate0$_atRootExcludingStyleRule ? null : this._evaluate0$_styleRuleIgnoringAtRoot;
                for(;; $parent = grandparent){
                    _0_0 = $parent == null ? null : $parent._node$_parent;
                    if (_0_0 instanceof A.ModifiableCssStyleRule0) return true;
                    t1 = _0_0 != null;
                    grandparent = t1 ? _0_0 : null;
                    if (t1) continue;
                    return false;
                }
            },
            _EvaluateVisitor$6$functions$importCache$logger$nodeImporter$quietDeps$sourceMap1: function(functions, importCache, logger, nodeImporter, quietDeps, sourceMap) {
                var t2, metaModule, t3, _i, module, $function, t4, _this = this, _s20_ = "$name, $module: null", _s9_ = "sass:meta", _s7_ = "$module", t1 = type$.JSArray_BuiltInCallable_2, metaFunctions = A._setArrayType([
                    A.BuiltInCallable$function0("global-variable-exists", _s20_, new A._EvaluateVisitor_closure25(_this), _s9_),
                    A.BuiltInCallable$function0("variable-exists", "$name", new A._EvaluateVisitor_closure26(_this), _s9_),
                    A.BuiltInCallable$function0("function-exists", _s20_, new A._EvaluateVisitor_closure27(_this), _s9_),
                    A.BuiltInCallable$function0("mixin-exists", _s20_, new A._EvaluateVisitor_closure28(_this), _s9_),
                    A.BuiltInCallable$function0("content-exists", "", new A._EvaluateVisitor_closure29(_this), _s9_),
                    A.BuiltInCallable$function0("module-variables", _s7_, new A._EvaluateVisitor_closure30(_this), _s9_),
                    A.BuiltInCallable$function0("module-functions", _s7_, new A._EvaluateVisitor_closure31(_this), _s9_),
                    A.BuiltInCallable$function0("module-mixins", _s7_, new A._EvaluateVisitor_closure32(_this), _s9_),
                    A.BuiltInCallable$function0("get-function", "$name, $css: false, $module: null", new A._EvaluateVisitor_closure33(_this), _s9_),
                    A.BuiltInCallable$function0("get-mixin", _s20_, new A._EvaluateVisitor_closure34(_this), _s9_),
                    A.BuiltInCallable$function0("call", "$function, $args...", new A._EvaluateVisitor_closure35(_this), _s9_)
                ], t1), metaMixins = A._setArrayType([
                    A.BuiltInCallable$mixin0("load-css", "$url, $with: null", new A._EvaluateVisitor_closure36(_this), false, _s9_),
                    A.BuiltInCallable$mixin0("apply", "$mixin, $args...", new A._EvaluateVisitor_closure37(_this), true, _s9_)
                ], t1);
                t1 = type$.BuiltInCallable_2;
                t2 = A.List_List$_of($.$get$moduleFunctions0(), t1);
                B.JSArray_methods.addAll$1(t2, metaFunctions);
                metaModule = A.BuiltInModule$0("meta", t2, metaMixins, null, t1);
                t1 = A.List_List$_of($.$get$coreModules0(), type$.BuiltInModule_Callable_2);
                t1.push(metaModule);
                t2 = t1.length;
                t3 = _this._evaluate0$_builtInModules;
                _i = 0;
                for(; _i < t1.length; t1.length === t2 || (0, A.throwConcurrentModificationError)(t1), ++_i){
                    module = t1[_i];
                    t3.$indexSet(0, module.url, module);
                }
                t1 = type$.JSArray_Callable_2;
                t2 = A._setArrayType([], t1);
                B.JSArray_methods.addAll$1(t2, functions);
                B.JSArray_methods.addAll$1(t2, $.$get$globalFunctions0());
                t1 = A._setArrayType([], t1);
                for(_i = 0; _i < 11; ++_i)t1.push(metaFunctions[_i].withDeprecationWarning$1("meta"));
                B.JSArray_methods.addAll$1(t2, t1);
                for(t1 = t2.length, t3 = _this._evaluate0$_builtInFunctions, _i = 0; _i < t2.length; t2.length === t1 || (0, A.throwConcurrentModificationError)(t2), ++_i){
                    $function = t2[_i];
                    t4 = $function.get$name($function);
                    t3.$indexSet(0, A.stringReplaceAllUnchecked(t4, "_", "-"), $function);
                }
            },
            run$2: function(_, importer, node) {
                var error, stackTrace, t1, _$exception;
                try {
                    t1 = type$.nullable_Object;
                    t1 = A.runZoned(new A._EvaluateVisitor_run_closure1(this, node, importer), A.LinkedHashMap_LinkedHashMap$_literal([
                        B.Symbol__evaluationContext,
                        new A._EvaluationContext1(this, node)
                    ], t1, t1), type$.Record_2_Set_Uri_loadedUrls_and_CssStylesheet_stylesheet_2);
                    return t1;
                } catch (exception) {
                    t1 = A.unwrapException(exception);
                    if (t1 instanceof A.SassException0) {
                        error = t1;
                        stackTrace = A.getTraceFromException(exception);
                        A.throwWithTrace0(error.withLoadedUrls$1(this._evaluate0$_loadedUrls), error, stackTrace);
                    } else throw exception;
                }
            },
            _evaluate0$_assertInModule$1$2: function(value, $name) {
                if (value != null) return value;
                throw A.wrapException(A.StateError$("Can't access " + $name + " outside of a module."));
            },
            _evaluate0$_assertInModule$2: function(value, $name) {
                return this._evaluate0$_assertInModule$1$2(value, $name, type$.dynamic);
            },
            _evaluate0$_loadModule$7$baseUrl$configuration$namesInErrors: function(url, stackFrame, nodeWithSpan, callback, baseUrl, configuration, namesInErrors) {
                var t2, _this = this, _0_0 = _this._evaluate0$_builtInModules.$index(0, url), t1 = {};
                t1.builtInModule = null;
                if (_0_0 != null) {
                    t1.builtInModule = _0_0;
                    if (configuration instanceof A.ExplicitConfiguration0) {
                        t1 = namesInErrors ? "Built-in module " + url.toString$0(0) + " can't be configured." : "Built-in modules can't be configured.";
                        t2 = configuration.nodeWithSpan;
                        throw A.wrapException(_this._evaluate0$_exception$2(t1, t2.get$span(t2)));
                    }
                    _this._evaluate0$_addExceptionSpan$2(nodeWithSpan, new A._EvaluateVisitor__loadModule_closure3(t1, callback));
                    return;
                }
                _this._evaluate0$_withStackFrame$3(stackFrame, nodeWithSpan, new A._EvaluateVisitor__loadModule_closure4(_this, url, nodeWithSpan, baseUrl, namesInErrors, configuration, callback));
            },
            _evaluate0$_loadModule$5$configuration: function(url, stackFrame, nodeWithSpan, callback, configuration) {
                return this._evaluate0$_loadModule$7$baseUrl$configuration$namesInErrors(url, stackFrame, nodeWithSpan, callback, null, configuration, false);
            },
            _evaluate0$_loadModule$4: function(url, stackFrame, nodeWithSpan, callback) {
                return this._evaluate0$_loadModule$7$baseUrl$configuration$namesInErrors(url, stackFrame, nodeWithSpan, callback, null, null, false);
            },
            _evaluate0$_execute$5$configuration$namesInErrors$nodeWithSpan: function(importer, stylesheet, configuration, namesInErrors, nodeWithSpan) {
                var currentConfiguration, t2, _0_0, t3, message, existingSpan, configurationSpan, environment, css, preModuleComments, extensionStore, module, _this = this, t1 = stylesheet.span, url = t1.get$sourceUrl(t1);
                t1 = configuration == null;
                currentConfiguration = t1 ? _this._evaluate0$_configuration : configuration;
                t2 = _this._evaluate0$_modules;
                _0_0 = t2.$index(0, url);
                if (_0_0 != null) {
                    t2 = _this._evaluate0$_moduleConfigurations.$index(0, url);
                    t3 = t2._configuration0$__originalConfiguration;
                    t2 = t3 == null ? t2 : t3;
                    t3 = currentConfiguration._configuration0$__originalConfiguration;
                    if (t2 !== (t3 == null ? currentConfiguration : t3) && currentConfiguration instanceof A.ExplicitConfiguration0 && _0_0.couldHaveBeenConfigured$1(new A.MapKeySet(new A.UnmodifiableMapView(currentConfiguration._configuration0$_values, type$.UnmodifiableMapView_String_ConfiguredValue_2), type$.MapKeySet_String))) {
                        if (namesInErrors) {
                            t2 = $.$get$context();
                            url.toString;
                            message = t2.prettyUri$1(url) + string$.x20was_a;
                        } else message = string$.This_mw;
                        t2 = _this._evaluate0$_moduleNodes.$index(0, url);
                        existingSpan = t2 == null ? null : t2.get$span(t2);
                        if (t1) {
                            t1 = currentConfiguration.nodeWithSpan;
                            configurationSpan = t1.get$span(t1);
                        } else configurationSpan = null;
                        t1 = A.LinkedHashMap_LinkedHashMap$_empty(type$.FileSpan, type$.String);
                        if (existingSpan != null) t1.$indexSet(0, existingSpan, "original load");
                        if (configurationSpan != null) t1.$indexSet(0, configurationSpan, "configuration");
                        throw A.wrapException(t1.get$isEmpty(0) ? _this._evaluate0$_exception$1(message) : _this._evaluate0$_multiSpanException$3(message, "new load", t1));
                    }
                    return _0_0;
                }
                environment = A.Environment$0();
                css = A._Cell$();
                preModuleComments = A._Cell$();
                extensionStore = A.ExtensionStore$0();
                _this._evaluate0$_withEnvironment$2(environment, new A._EvaluateVisitor__execute_closure1(_this, importer, stylesheet, extensionStore, configuration, css, preModuleComments));
                t1 = css._readLocal$0();
                t3 = preModuleComments._readLocal$0();
                module = environment.toModule$3(t1, t3 == null ? B.Map_empty10 : t3, extensionStore);
                if (url != null) {
                    t2.$indexSet(0, url, module);
                    _this._evaluate0$_moduleConfigurations.$indexSet(0, url, currentConfiguration);
                    if (nodeWithSpan != null) _this._evaluate0$_moduleNodes.$indexSet(0, url, nodeWithSpan);
                }
                return module;
            },
            _evaluate0$_execute$2: function(importer, stylesheet) {
                return this._evaluate0$_execute$5$configuration$namesInErrors$nodeWithSpan(importer, stylesheet, null, false, null);
            },
            _evaluate0$_addOutOfOrderImports$0: function() {
                var t1, t2, _this = this, _s5_ = "_root", _s13_ = "_endOfImports", _0_0 = _this._evaluate0$_outOfOrderImports;
                $label0$0: {
                    if (_0_0 == null) {
                        t1 = _this._evaluate0$_assertInModule$2(_this._evaluate0$__root, _s5_).children;
                        break $label0$0;
                    }
                    t1 = _this._evaluate0$_assertInModule$2(_this._evaluate0$__root, _s5_).children;
                    t1 = A.List_List$_of(A.SubListIterable$(t1, 0, A.checkNotNullable(_this._evaluate0$_assertInModule$2(_this._evaluate0$__endOfImports, _s13_), "count", type$.int), t1.$ti._eval$1("ListBase.E")), type$.ModifiableCssNode_2);
                    B.JSArray_methods.addAll$1(t1, _0_0);
                    t2 = _this._evaluate0$_assertInModule$2(_this._evaluate0$__root, _s5_).children;
                    B.JSArray_methods.addAll$1(t1, A.SubListIterable$(t2, _this._evaluate0$_assertInModule$2(_this._evaluate0$__endOfImports, _s13_), null, t2.$ti._eval$1("ListBase.E")));
                    break $label0$0;
                }
                return t1;
            },
            _evaluate0$_combineCss$2$clone: function(root, clone) {
                var selectors, _0_0, t1, imports, css, sorted, t2;
                if (!B.JSArray_methods.any$1(root.get$upstream(), new A._EvaluateVisitor__combineCss_closure3())) {
                    selectors = root.get$extensionStore().get$simpleSelectors();
                    _0_0 = A.IterableExtension_get_firstOrNull(root.get$extensionStore().extensionsWhereTarget$1(new A._EvaluateVisitor__combineCss_closure4(selectors)));
                    if (_0_0 != null) this._evaluate0$_throwForUnsatisfiedExtension$1(_0_0);
                    return root.get$css(root);
                }
                t1 = type$.JSArray_CssNode_2;
                imports = A._setArrayType([], t1);
                css = A._setArrayType([], t1);
                t1 = type$.Module_Callable_2;
                sorted = A.ListQueue$(t1);
                new A._EvaluateVisitor__combineCss_visitModule1(this, A.LinkedHashSet_LinkedHashSet$_empty(t1), clone, css, imports, sorted).call$1(root);
                if (root.get$transitivelyContainsExtensions()) this._evaluate0$_extendModules$1(sorted);
                t1 = B.JSArray_methods.$add(imports, css);
                t2 = root.get$css(root);
                return new A.CssStylesheet0(new A.UnmodifiableListView(t1, type$.UnmodifiableListView_CssNode_2), t2.get$span(t2));
            },
            _evaluate0$_combineCss$1: function(root) {
                return this._evaluate0$_combineCss$2$clone(root, false);
            },
            _evaluate0$_extendModules$1: function(sortedModules) {
                var t1, t2, t3, originalSelectors, $self, t4, t5, _i, upstream, _0_0, downstreamExtensionStores = A.LinkedHashMap_LinkedHashMap$_empty(type$.Uri, type$.List_ExtensionStore_2), unsatisfiedExtensions = new A._LinkedIdentityHashSet(type$._LinkedIdentityHashSet_Extension_2);
                for(t1 = A._ListQueueIterator$(sortedModules, sortedModules.$ti._precomputed1), t2 = t1.$ti._precomputed1; t1.moveNext$0();){
                    t3 = t1._collection$_current;
                    if (t3 == null) t3 = t2._as(t3);
                    originalSelectors = t3.get$extensionStore().get$simpleSelectors().toSet$0(0);
                    unsatisfiedExtensions.addAll$1(0, t3.get$extensionStore().extensionsWhereTarget$1(new A._EvaluateVisitor__extendModules_closure3(originalSelectors)));
                    $self = downstreamExtensionStores.$index(0, t3.get$url(t3));
                    t4 = t3.get$extensionStore().get$addExtensions();
                    if ($self != null) t4.call$1($self);
                    t4 = t3.get$extensionStore();
                    if (t4.get$isEmpty(t4)) continue;
                    for(t4 = t3.get$upstream(), t5 = t4.length, _i = 0; _i < t4.length; t4.length === t5 || (0, A.throwConcurrentModificationError)(t4), ++_i){
                        upstream = t4[_i];
                        _0_0 = upstream.get$url(upstream);
                        if (_0_0 != null) J.add$1$ax(downstreamExtensionStores.putIfAbsent$2(_0_0, new A._EvaluateVisitor__extendModules_closure4()), t3.get$extensionStore());
                    }
                    unsatisfiedExtensions.removeAll$1(t3.get$extensionStore().extensionsWhereTarget$1(originalSelectors.get$contains(originalSelectors)));
                }
                if (unsatisfiedExtensions._collection$_length !== 0) this._evaluate0$_throwForUnsatisfiedExtension$1(unsatisfiedExtensions.get$first(0));
            },
            _evaluate0$_throwForUnsatisfiedExtension$1: function(extension) {
                throw A.wrapException(A.SassException$0(string$.The_ta + extension.target.toString$0(0) + ' !optional" to avoid this error.', extension.span, null));
            },
            _evaluate0$_indexAfterImports$1: function(statements) {
                var t1, lastImport, i, _0_0;
                for(t1 = J.getInterceptor$asx(statements), lastImport = -1, i = 0; i < t1.get$length(statements); ++i){
                    $label0$0: {
                        _0_0 = t1.$index(statements, i);
                        if (_0_0 instanceof A.ModifiableCssImport0) break $label0$0;
                        if (_0_0 instanceof A.ModifiableCssComment0) continue;
                        break;
                    }
                    lastImport = i;
                }
                return lastImport + 1;
            },
            visitStylesheet$1: function(_, node) {
                var t1, t2, warning, _i, $name, span;
                for(t1 = node.parseTimeWarnings, t2 = t1.$ti, t1 = new A.ListIterator(t1, t1.get$length(0), t2._eval$1("ListIterator<ListBase.E>")), t2 = t2._eval$1("ListBase.E"); t1.moveNext$0();){
                    warning = t1.__internal$_current;
                    if (warning == null) warning = t2._as(warning);
                    this._evaluate0$_warn$3(warning._1, warning._2, warning._0);
                }
                for(t1 = node.children, t2 = t1.length, _i = 0; _i < t2; ++_i)t1[_i].accept$1(this);
                for(t1 = A.MapExtensions_get_pairs0(node.globalVariables, type$.String, type$.FileSpan), t1 = t1.get$iterator(t1); t1.moveNext$0();){
                    t2 = t1.get$current(t1);
                    $name = t2._0;
                    span = t2._1;
                    this.visitVariableDeclaration$1(0, new A.VariableDeclaration0(null, $name, new A.NullExpression0(span), true, false, span));
                }
                return null;
            },
            visitAtRootRule$1: function(_, node) {
                var t1, _2_0, root, first, rest, innerCopy, outerCopy, _i, copy, _this = this, _null = null, _s8_ = "__parent", _0_0 = node.query, query = _0_0 != null ? new A.AtRootQueryParser0(A.SpanScanner$(_this._evaluate0$_performInterpolationWithMap$2$warnForColor(_0_0, true)._0, _null), _null).parse$0(0) : B.AtRootQuery_bfj0, $parent = _this._evaluate0$_assertInModule$2(_this._evaluate0$__parent, _s8_), included = A._setArrayType([], type$.JSArray_ModifiableCssParentNode_2);
                for(t1 = type$.CssStylesheet_2; !t1._is($parent); $parent = _2_0){
                    if (!query.excludes$1($parent)) included.push($parent);
                    _2_0 = $parent._node$_parent;
                    if (_2_0 == null) throw A.wrapException(A.StateError$(string$.CssNod));
                }
                root = _this._evaluate0$_trimIncluded$1(included);
                if (root === _this._evaluate0$_assertInModule$2(_this._evaluate0$__parent, _s8_)) {
                    _this._evaluate0$_environment.scope$1$2$when(new A._EvaluateVisitor_visitAtRootRule_closure3(_this, node), node.hasDeclarations, type$.Null);
                    return _null;
                }
                if (included.length >= 1) {
                    first = included[0];
                    rest = B.JSArray_methods.sublist$1(included, 1);
                    innerCopy = first.copyWithoutChildren$0();
                    for(t1 = rest.length, outerCopy = innerCopy, _i = 0; _i < rest.length; rest.length === t1 || (0, A.throwConcurrentModificationError)(rest), ++_i, outerCopy = copy){
                        copy = rest[_i].copyWithoutChildren$0();
                        copy.addChild$1(outerCopy);
                    }
                    root.addChild$1(outerCopy);
                } else innerCopy = root;
                _this._evaluate0$_scopeForAtRoot$4(node, innerCopy, query, included).call$1(new A._EvaluateVisitor_visitAtRootRule_closure4(_this, node));
                return _null;
            },
            _evaluate0$_trimIncluded$1: function(nodes) {
                var $parent, t1, innermostContiguous, i, t2, _0_0, _1_0, root, _this = this, _null = null, _s5_ = "_root", _s22_ = " to be an ancestor of ";
                if (nodes.length === 0) return _this._evaluate0$_assertInModule$2(_this._evaluate0$__root, _s5_);
                $parent = _this._evaluate0$_assertInModule$2(_this._evaluate0$__parent, "__parent");
                for(t1 = nodes.length, innermostContiguous = _null, i = 0; i < t1; ++i, $parent = _1_0){
                    for(; t2 = nodes[i], $parent !== t2; innermostContiguous = _null, $parent = _0_0){
                        _0_0 = $parent._node$_parent;
                        if (_0_0 == null) throw A.wrapException(A.ArgumentError$("Expected " + t2.toString$0(0) + _s22_ + _this.toString$0(0) + ".", _null));
                    }
                    if (innermostContiguous == null) innermostContiguous = i;
                    _1_0 = $parent._node$_parent;
                    if (_1_0 == null) throw A.wrapException(A.ArgumentError$("Expected " + t2.toString$0(0) + _s22_ + _this.toString$0(0) + ".", _null));
                }
                if ($parent !== _this._evaluate0$_assertInModule$2(_this._evaluate0$__root, _s5_)) return _this._evaluate0$_assertInModule$2(_this._evaluate0$__root, _s5_);
                innermostContiguous.toString;
                root = nodes[innermostContiguous];
                B.JSArray_methods.removeRange$2(nodes, innermostContiguous, nodes.length);
                return root;
            },
            _evaluate0$_scopeForAtRoot$4: function(node, newParent, query, included) {
                var _this = this, scope = new A._EvaluateVisitor__scopeForAtRoot_closure11(_this, newParent, node), t1 = query._at_root_query0$_all || query._at_root_query0$_rule;
                if (t1 !== query.include) scope = new A._EvaluateVisitor__scopeForAtRoot_closure12(_this, scope);
                if (_this._evaluate0$_mediaQueries != null && query.excludesName$1("media")) scope = new A._EvaluateVisitor__scopeForAtRoot_closure13(_this, scope);
                if (_this._evaluate0$_inKeyframes && query.excludesName$1("keyframes")) scope = new A._EvaluateVisitor__scopeForAtRoot_closure14(_this, scope);
                return _this._evaluate0$_inUnknownAtRule && !B.JSArray_methods.any$1(included, new A._EvaluateVisitor__scopeForAtRoot_closure15()) ? new A._EvaluateVisitor__scopeForAtRoot_closure16(_this, scope) : scope;
            },
            visitContentBlock$1: function(_, node) {
                return A.throwExpression(A.UnsupportedError$(string$.Evalua));
            },
            visitContentRule$1: function(_, node) {
                var $content = this._evaluate0$_environment._environment0$_content;
                if ($content == null) return null;
                this._evaluate0$_runUserDefinedCallable$1$4(node.$arguments, $content, node, new A._EvaluateVisitor_visitContentRule_closure1(this, $content), type$.Null);
                return null;
            },
            visitDebugRule$1: function(_, node) {
                var value = node.expression.accept$1(this), t1 = value instanceof A.SassString0 ? value._string0$_text : A.serializeValue0(value, true, true);
                this._evaluate0$_logger.debug$2(0, t1, node.span);
                return null;
            },
            visitDeclaration$1: function(_, node) {
                var t1, $name, _0_0, _1_0, value, t2, t3, _2_0, oldDeclarationName, _this = this, _null = null;
                if ((_this._evaluate0$_atRootExcludingStyleRule ? _null : _this._evaluate0$_styleRuleIgnoringAtRoot) == null && !_this._evaluate0$_inUnknownAtRule && !_this._evaluate0$_inKeyframes) throw A.wrapException(_this._evaluate0$_exception$2(string$.Declarm, node.span));
                if (_this._evaluate0$_declarationName != null && !node.parsedAsSassScript) {
                    t1 = B.JSString_methods.startsWith$1(node.name.get$initialPlain(), "--") ? string$.Declarw : string$.Declarp;
                    throw A.wrapException(_this._evaluate0$_exception$2(t1, node.span));
                }
                $name = _this._evaluate0$_interpolationToValue$2$warnForColor(node.name, true);
                _0_0 = _this._evaluate0$_declarationName;
                if (_0_0 != null) $name = new A.CssValue0(_0_0 + "-" + $name.value, $name.span, type$.CssValue_String_2);
                _1_0 = node.value;
                if (_1_0 != null) {
                    value = _1_0.accept$1(_this);
                    if (!value.get$isBlank() || value.get$asList().length === 0 || B.JSString_methods.startsWith$1($name.value, "--")) {
                        _this._evaluate0$_copyParentAfterSibling$0();
                        t1 = _this._evaluate0$_assertInModule$2(_this._evaluate0$__parent, "__parent");
                        t2 = _1_0.get$span(_1_0);
                        if (_this._evaluate0$_sourceMap) {
                            t3 = A.NullableExtension_andThen0(_1_0, _this.get$_evaluate0$_expressionNode());
                            t3 = t3 == null ? _null : J.get$span$x(t3);
                        } else t3 = _null;
                        t1.addChild$1(A.ModifiableCssDeclaration$0($name, new A.CssValue0(value, t2, type$.CssValue_Value_2), node.span, node.parsedAsSassScript, t3));
                    }
                }
                _2_0 = node.children;
                t1 = {};
                t1.children = null;
                if (_2_0 != null) {
                    t1.children = _2_0;
                    oldDeclarationName = _this._evaluate0$_declarationName;
                    _this._evaluate0$_declarationName = $name.value;
                    _this._evaluate0$_environment.scope$1$2$when(new A._EvaluateVisitor_visitDeclaration_closure1(t1, _this), node.hasDeclarations, type$.Null);
                    _this._evaluate0$_declarationName = oldDeclarationName;
                }
                return _null;
            },
            visitEachRule$1: function(_, node) {
                var _this = this, t1 = node.list, list = t1.accept$1(_this), nodeWithSpan = _this._evaluate0$_expressionNode$1(t1), _0_0 = node.variables;
                $label0$0: {
                    t1 = {};
                    t1.variable = null;
                    if (_0_0.length === 1) {
                        t1.variable = _0_0[0];
                        t1 = new A._EvaluateVisitor_visitEachRule_closure5(t1, _this, nodeWithSpan);
                        break $label0$0;
                    }
                    t1 = {};
                    t1.variables = null;
                    t1.variables = _0_0;
                    t1 = new A._EvaluateVisitor_visitEachRule_closure6(t1, _this, nodeWithSpan);
                    break $label0$0;
                }
                return _this._evaluate0$_environment.scope$1$2$semiGlobal(new A._EvaluateVisitor_visitEachRule_closure7(_this, list, t1, node), true, type$.nullable_Value_2);
            },
            _evaluate0$_setMultipleVariables$3: function(variables, value, nodeWithSpan) {
                var i, list = value.get$asList(), t1 = variables.length, minLength = Math.min(t1, list.length);
                for(i = 0; i < minLength; ++i)this._evaluate0$_environment.setLocalVariable$3(variables[i], this._evaluate0$_withoutSlash$2(list[i], nodeWithSpan), nodeWithSpan);
                for(i = minLength; i < t1; ++i)this._evaluate0$_environment.setLocalVariable$3(variables[i], B.C__SassNull0, nodeWithSpan);
            },
            visitErrorRule$1: function(_, node) {
                throw A.wrapException(this._evaluate0$_exception$2(node.expression.accept$1(this).toString$0(0), node.span));
            },
            visitExtendRule$1: function(_, node) {
                var t1, t2, t3, t4, t5, _i, complex, visitor, t6, t7, _0_0, compound, simple, _this = this, _null = null, styleRule = _this._evaluate0$_atRootExcludingStyleRule ? _null : _this._evaluate0$_styleRuleIgnoringAtRoot;
                if (styleRule == null || _this._evaluate0$_declarationName != null) throw A.wrapException(_this._evaluate0$_exception$2(string$.x40exten, node.span));
                for(t1 = styleRule.originalSelector.components, t2 = t1.length, t3 = node.span, t4 = type$.SourceSpan, t5 = type$.String, _i = 0; _i < t2; ++_i){
                    complex = t1[_i];
                    if (!complex.accept$1(B._IsBogusVisitor_true0)) continue;
                    visitor = A._SerializeVisitor$0(_null, true, _null, _null, true, false, _null, true);
                    complex.accept$1(visitor);
                    t6 = B.JSString_methods.trim$0(visitor._serialize0$_buffer.toString$0(0));
                    t7 = complex.accept$1(B.C__IsUselessVisitor0) ? "can't" : "shouldn't";
                    _this._evaluate0$_warn$3('The selector "' + t6 + '" is invalid CSS and ' + t7 + string$.x20be_an, new A.MultiSpan0(A.SpanExtensions_trimRight0(complex.span), "invalid selector", A.ConstantMap_ConstantMap$from(A.LinkedHashMap_LinkedHashMap$_literal([
                        t3,
                        "@extend rule"
                    ], t4, t5), t4, t5)), B.Deprecation_2PR);
                }
                _0_0 = _this._evaluate0$_performInterpolationWithMap$2$warnForColor(node.selector, true);
                for(t1 = A.SelectorList_SelectorList$parse0(A.trimAscii0(_0_0._0, true), false, _0_0._1, _this._evaluate0$_logger, false).components, t2 = t1.length, t3 = styleRule._style_rule0$_selector._box0$_inner, _i = 0; _i < t2; ++_i){
                    complex = t1[_i];
                    compound = complex.get$singleCompound();
                    if (compound == null) throw A.wrapException(A.SassFormatException$0("complex selectors may not be extended.", complex.span, _null));
                    t4 = compound.components;
                    simple = t4.length === 1 ? B.JSArray_methods.get$first(t4) : _null;
                    if (simple == null) throw A.wrapException(A.SassFormatException$0(string$.compou + B.JSArray_methods.join$1(t4, ", ") + string$.x60_inst, compound.span, _null));
                    _this._evaluate0$_assertInModule$2(_this._evaluate0$__extensionStore, "_extensionStore").addExtension$4(t3.value, simple, node, _this._evaluate0$_mediaQueries);
                }
                return _null;
            },
            visitAtRule$1: function(_, node) {
                var $name, value, children, wasInKeyframes, wasInUnknownAtRule, rule, _this = this;
                if (_this._evaluate0$_declarationName != null) throw A.wrapException(_this._evaluate0$_exception$2(string$.At_rul, node.span));
                $name = _this._evaluate0$_interpolationToValue$1(node.name);
                value = A.NullableExtension_andThen0(node.value, new A._EvaluateVisitor_visitAtRule_closure7(_this));
                children = node.children;
                if (children == null) {
                    _this._evaluate0$_copyParentAfterSibling$0();
                    _this._evaluate0$_assertInModule$2(_this._evaluate0$__parent, "__parent").addChild$1(A.ModifiableCssAtRule$0($name, node.span, true, value));
                    return null;
                }
                wasInKeyframes = _this._evaluate0$_inKeyframes;
                wasInUnknownAtRule = _this._evaluate0$_inUnknownAtRule;
                if (A.unvendor0($name.value) === "keyframes") _this._evaluate0$_inKeyframes = true;
                else _this._evaluate0$_inUnknownAtRule = true;
                rule = A.ModifiableCssAtRule$0($name, node.span, false, value);
                if (_this.get$_evaluate0$_hasCssNesting()) {
                    _this._evaluate0$_withParent$2$3$scopeWhen(rule, new A._EvaluateVisitor_visitAtRule_closure8(_this, children), node.hasDeclarations, type$.ModifiableCssAtRule_2, type$.Null);
                    _this._evaluate0$_inUnknownAtRule = wasInUnknownAtRule;
                    _this._evaluate0$_inKeyframes = wasInKeyframes;
                    return null;
                }
                _this._evaluate0$_withParent$2$4$scopeWhen$through(rule, new A._EvaluateVisitor_visitAtRule_closure9(_this, $name, children), node.hasDeclarations, new A._EvaluateVisitor_visitAtRule_closure10(), type$.ModifiableCssAtRule_2, type$.Null);
                _this._evaluate0$_inUnknownAtRule = wasInUnknownAtRule;
                _this._evaluate0$_inKeyframes = wasInKeyframes;
                return null;
            },
            visitForRule$1: function(_, node) {
                var _this = this, t1 = {}, t2 = node.from, fromNumber = _this._evaluate0$_addExceptionSpan$2(t2, new A._EvaluateVisitor_visitForRule_closure9(_this, node)), t3 = node.to, toNumber = _this._evaluate0$_addExceptionSpan$2(t3, new A._EvaluateVisitor_visitForRule_closure10(_this, node)), from = _this._evaluate0$_addExceptionSpan$2(t2, new A._EvaluateVisitor_visitForRule_closure11(fromNumber)), to = t1.to = _this._evaluate0$_addExceptionSpan$2(t3, new A._EvaluateVisitor_visitForRule_closure12(toNumber, fromNumber)), direction = from > to ? -1 : 1;
                if (from === (!node.isExclusive ? t1.to = to + direction : to)) return null;
                return _this._evaluate0$_environment.scope$1$2$semiGlobal(new A._EvaluateVisitor_visitForRule_closure13(t1, _this, node, from, direction, fromNumber), true, type$.nullable_Value_2);
            },
            visitForwardRule$1: function(_, node) {
                var newConfiguration, t4, _i, variable, $name, _this = this, _s8_ = "@forward", oldConfiguration = _this._evaluate0$_configuration, adjustedConfiguration = oldConfiguration.throughForward$1(node), t1 = node.configuration, t2 = t1.length, t3 = node.url;
                if (t2 !== 0) {
                    newConfiguration = _this._evaluate0$_addForwardConfiguration$2(adjustedConfiguration, node);
                    _this._evaluate0$_loadModule$5$configuration(t3, _s8_, node, new A._EvaluateVisitor_visitForwardRule_closure3(_this, node), newConfiguration);
                    t3 = type$.String;
                    t4 = A.LinkedHashSet_LinkedHashSet$_empty(t3);
                    for(_i = 0; _i < t2; ++_i){
                        variable = t1[_i];
                        if (!variable.isGuarded) t4.add$1(0, variable.name);
                    }
                    _this._evaluate0$_removeUsedConfiguration$3$except(adjustedConfiguration, newConfiguration, t4);
                    t3 = A.LinkedHashSet_LinkedHashSet$_empty(t3);
                    for(_i = 0; _i < t2; ++_i)t3.add$1(0, t1[_i].name);
                    for(t1 = newConfiguration._configuration0$_values, t2 = t1.get$keys(t1), t2 = t2.toList$0(t2), t4 = t2.length, _i = 0; _i < t2.length; t2.length === t4 || (0, A.throwConcurrentModificationError)(t2), ++_i){
                        $name = t2[_i];
                        if (!t3.contains$1(0, $name)) {
                            if (!t1.get$isEmpty(t1)) t1.remove$1(0, $name);
                        }
                    }
                    _this._evaluate0$_assertConfigurationIsEmpty$1(newConfiguration);
                } else {
                    _this._evaluate0$_configuration = adjustedConfiguration;
                    _this._evaluate0$_loadModule$4(t3, _s8_, node, new A._EvaluateVisitor_visitForwardRule_closure4(_this, node));
                    _this._evaluate0$_configuration = oldConfiguration;
                }
                return null;
            },
            _evaluate0$_addForwardConfiguration$2: function(configuration, node) {
                var t2, t3, _i, variable, t4, _0_0, t5, oldValue, variableNodeWithSpan, _null = null, t1 = configuration._configuration0$_values, newValues = A.LinkedHashMap_LinkedHashMap$of(new A.UnmodifiableMapView(t1, type$.UnmodifiableMapView_String_ConfiguredValue_2), type$.String, type$.ConfiguredValue_2);
                for(t2 = node.configuration, t3 = t2.length, _i = 0; _i < t3; ++_i){
                    variable = t2[_i];
                    if (variable.isGuarded) {
                        t4 = variable.name;
                        _0_0 = t1.get$isEmpty(t1) ? _null : t1.remove$1(0, t4);
                        if (_0_0 != null) {
                            t5 = !_0_0.value.$eq(0, B.C__SassNull0);
                            oldValue = _0_0;
                        } else {
                            oldValue = _null;
                            t5 = false;
                        }
                        if (t5) {
                            newValues.$indexSet(0, t4, oldValue);
                            continue;
                        }
                    }
                    t4 = variable.expression;
                    variableNodeWithSpan = this._evaluate0$_expressionNode$1(t4);
                    newValues.$indexSet(0, variable.name, new A.ConfiguredValue0(this._evaluate0$_withoutSlash$2(t4.accept$1(this), variableNodeWithSpan), variable.span, variableNodeWithSpan));
                }
                if (configuration instanceof A.ExplicitConfiguration0 || t1.get$isEmpty(t1)) return new A.ExplicitConfiguration0(node, newValues, _null);
                else return new A.Configuration0(newValues, _null);
            },
            _evaluate0$_registerCommentsForModule$1: function(module) {
                var _this = this, _s5_ = "_root", t1 = _this._evaluate0$__root;
                if (t1 == null) return;
                if (_this._evaluate0$_assertInModule$2(t1, _s5_).children.get$length(0) === 0 || !module.get$transitivelyContainsCss()) return;
                t1 = _this._evaluate0$_preModuleComments;
                if (t1 == null) t1 = _this._evaluate0$_preModuleComments = A.LinkedHashMap_LinkedHashMap$_empty(type$.Module_Callable_2, type$.List_CssComment_2);
                J.addAll$1$ax(t1.putIfAbsent$2(module, new A._EvaluateVisitor__registerCommentsForModule_closure1()), new A.UnmodifiableListView(J.cast$1$0$ax(_this._evaluate0$_assertInModule$2(_this._evaluate0$__root, _s5_).children._collection$_source, type$.CssComment_2), type$.UnmodifiableListView_CssComment_2));
                _this._evaluate0$_assertInModule$2(_this._evaluate0$__root, _s5_).clearChildren$0();
                _this._evaluate0$__endOfImports = 0;
            },
            _evaluate0$_removeUsedConfiguration$3$except: function(upstream, downstream, except) {
                var t1, t2, t3, t4, _i, $name;
                for(t1 = upstream._configuration0$_values, t2 = t1.get$keys(t1), t2 = t2.toList$0(t2), t3 = t2.length, t4 = downstream._configuration0$_values, _i = 0; _i < t2.length; t2.length === t3 || (0, A.throwConcurrentModificationError)(t2), ++_i){
                    $name = t2[_i];
                    if (except.contains$1(0, $name)) continue;
                    if (!t4.containsKey$1($name)) {
                        if (!t1.get$isEmpty(t1)) t1.remove$1(0, $name);
                    }
                }
            },
            _evaluate0$_assertConfigurationIsEmpty$2$nameInError: function(configuration, nameInError) {
                var t1, _0_0;
                if (!(configuration instanceof A.ExplicitConfiguration0)) return;
                t1 = configuration._configuration0$_values;
                if (t1.get$isEmpty(t1)) return;
                t1 = A.MapExtensions_get_pairs0(new A.UnmodifiableMapView(t1, type$.UnmodifiableMapView_String_ConfiguredValue_2), type$.String, type$.ConfiguredValue_2);
                _0_0 = t1.get$first(t1);
                t1 = nameInError ? "$" + _0_0._0 + string$.x20was_n : string$.This_v;
                throw A.wrapException(this._evaluate0$_exception$2(t1, _0_0._1.configurationSpan));
            },
            _evaluate0$_assertConfigurationIsEmpty$1: function(configuration) {
                return this._evaluate0$_assertConfigurationIsEmpty$2$nameInError(configuration, false);
            },
            visitFunctionRule$1: function(_, node) {
                var t1 = this._evaluate0$_environment, t2 = t1.closure$0(), t3 = this._evaluate0$_inDependency, t4 = t1._environment0$_functions, index = t4.length - 1, t5 = node.name;
                t1._environment0$_functionIndices.$indexSet(0, t5, index);
                t4[index].$indexSet(0, t5, new A.UserDefinedCallable0(node, t2, t3, type$.UserDefinedCallable_Environment_2));
                return null;
            },
            visitIfRule$1: function(_, node) {
                var t1, t2, _i, clauseToCheck, clause = node.lastClause;
                for(t1 = node.clauses, t2 = t1.length, _i = 0; _i < t2; ++_i){
                    clauseToCheck = t1[_i];
                    if (clauseToCheck.expression.accept$1(this).get$isTruthy()) {
                        clause = clauseToCheck;
                        break;
                    }
                }
                return A.NullableExtension_andThen0(clause, new A._EvaluateVisitor_visitIfRule_closure1(this));
            },
            visitImportRule$1: function(_, node) {
                var t1, t2, t3, t4, t5, t6, _i, $import, t7, _0_0, $self, t8, _this = this, _s8_ = "__parent", _s5_ = "_root", _s13_ = "_endOfImports";
                for(t1 = node.imports, t2 = t1.length, t3 = type$.CssValue_String_2, t4 = _this.get$_evaluate0$_interpolationToValue(), t5 = type$.StaticImport_2, t6 = type$.JSArray_ModifiableCssImport_2, _i = 0; _i < t2; ++_i){
                    $import = t1[_i];
                    if ($import instanceof A.DynamicImport0) _this._evaluate0$_visitDynamicImport$1($import);
                    else {
                        t5._as($import);
                        t7 = $import.url;
                        _0_0 = _this._evaluate0$_performInterpolationHelper$3$sourceMap$warnForColor(t7, false, false);
                        $self = $import.modifiers;
                        t8 = $self == null ? null : t4.call$1($self);
                        node = new A.ModifiableCssImport0(new A.CssValue0(_0_0._0, t7.span, t3), t8, $import.span);
                        if (_this._evaluate0$_assertInModule$2(_this._evaluate0$__parent, _s8_) !== _this._evaluate0$_assertInModule$2(_this._evaluate0$__root, _s5_)) {
                            _this._evaluate0$_copyParentAfterSibling$0();
                            _this._evaluate0$_assertInModule$2(_this._evaluate0$__parent, _s8_).addChild$1(node);
                        } else if (_this._evaluate0$_assertInModule$2(_this._evaluate0$__endOfImports, _s13_) === J.get$length$asx(_this._evaluate0$_assertInModule$2(_this._evaluate0$__root, _s5_).children._collection$_source)) {
                            t7 = _this._evaluate0$_assertInModule$2(_this._evaluate0$__root, _s5_);
                            node._node$_parent = t7;
                            t7 = t7._node$_children;
                            node._node$_indexInParent = t7.length;
                            t7.push(node);
                            _this._evaluate0$__endOfImports = _this._evaluate0$_assertInModule$2(_this._evaluate0$__endOfImports, _s13_) + 1;
                        } else {
                            t7 = _this._evaluate0$_outOfOrderImports;
                            (t7 == null ? _this._evaluate0$_outOfOrderImports = A._setArrayType([], t6) : t7).push(node);
                        }
                    }
                }
                return null;
            },
            _evaluate0$_visitDynamicImport$1: function($import) {
                return this._evaluate0$_withStackFrame$3("@import", $import, new A._EvaluateVisitor__visitDynamicImport_closure1(this, $import));
            },
            _evaluate0$_loadStylesheet$4$baseUrl$forImport: function(url, span, baseUrl, forImport) {
                var _0_0, importCache, _1_0, importer, canonicalUrl, originalUrl, isDependency, _2_0, stylesheet, _3_0, result, error, stackTrace, error0, stackTrace0, t1, t2, _$exception, _this = this, _s11_ = "_stylesheet";
                baseUrl;
                try {
                    _this._evaluate0$_importSpan = span;
                    _0_0 = _this._evaluate0$_importCache;
                    importCache = null;
                    if (_0_0 != null) {
                        importCache = _0_0;
                        if (baseUrl == null) {
                            t1 = _this._evaluate0$_assertInModule$2(_this._evaluate0$__stylesheet, _s11_).span;
                            baseUrl = t1.get$sourceUrl(t1);
                        }
                        _1_0 = J.canonicalize$4$baseImporter$baseUrl$forImport$x(importCache, A.Uri_parse(url), _this._evaluate0$_importer, baseUrl, forImport);
                        importer = null;
                        canonicalUrl = null;
                        originalUrl = null;
                        if (type$.Record_3_nullable_Object_and_nullable_Object_and_nullable_Object_originalUrl._is(_1_0)) {
                            importer = _1_0._0;
                            canonicalUrl = _1_0._1;
                            originalUrl = _1_0._2;
                            if (canonicalUrl.get$scheme() === "") A.WarnForDeprecation_warnForDeprecation0(_this._evaluate0$_logger, B.Deprecation_Vc9, "Importer " + A.S(importer) + " canonicalized " + url + " to " + A.S(canonicalUrl) + string$.x2e_Rela, null, null);
                            _this._evaluate0$_loadedUrls.add$1(0, canonicalUrl);
                            isDependency = _this._evaluate0$_inDependency || !J.$eq$(importer, _this._evaluate0$_importer);
                            _2_0 = importCache.importCanonical$3$originalUrl(importer, canonicalUrl, originalUrl);
                            stylesheet = null;
                            if (_2_0 != null) {
                                stylesheet = _2_0;
                                t1 = stylesheet;
                                t2 = importer;
                                return new A._Record_3_importer_isDependency(t1, t2, isDependency);
                            }
                        }
                    }
                    if (_this._nodeImporter != null) {
                        t1 = baseUrl;
                        if (t1 == null) {
                            t1 = _this._evaluate0$_assertInModule$2(_this._evaluate0$__stylesheet, _s11_).span;
                            t1 = t1.get$sourceUrl(t1);
                        }
                        _3_0 = _this._importLikeNode$3(url, t1, forImport);
                        result = null;
                        if (_3_0 != null) {
                            result = _3_0;
                            t1 = result._0.span;
                            t2 = _this._evaluate0$_loadedUrls;
                            A.NullableExtension_andThen0(t1.get$sourceUrl(t1), t2.get$add(t2));
                            t2 = result;
                            return t2;
                        }
                    }
                    t1 = B.JSString_methods.startsWith$1(url, "package:");
                    if (t1) throw A.wrapException(string$.x22packa);
                    else throw A.wrapException("Can't find stylesheet to import.");
                } catch (exception) {
                    t1 = A.unwrapException(exception);
                    if (t1 instanceof A.SassException0) throw exception;
                    else if (t1 instanceof A.ArgumentError) {
                        error = t1;
                        stackTrace = A.getTraceFromException(exception);
                        A.throwWithTrace0(_this._evaluate0$_exception$1(J.toString$0$(error)), error, stackTrace);
                    } else {
                        error0 = t1;
                        stackTrace0 = A.getTraceFromException(exception);
                        A.throwWithTrace0(_this._evaluate0$_exception$1(_this._evaluate0$_getErrorMessage$1(error0)), error0, stackTrace0);
                    }
                } finally{
                    _this._evaluate0$_importSpan = null;
                }
            },
            _evaluate0$_loadStylesheet$3$baseUrl: function(url, span, baseUrl) {
                return this._evaluate0$_loadStylesheet$4$baseUrl$forImport(url, span, baseUrl, false);
            },
            _evaluate0$_loadStylesheet$3$forImport: function(url, span, forImport) {
                return this._evaluate0$_loadStylesheet$4$baseUrl$forImport(url, span, null, forImport);
            },
            _importLikeNode$3: function(originalUrl, previous, forImport) {
                var isDependency, url, t1 = this._nodeImporter, result = t1.loadRelative$3(originalUrl, previous, forImport);
                if (result != null) isDependency = this._evaluate0$_inDependency;
                else {
                    result = t1.load$3(0, originalUrl, previous, forImport);
                    if (result == null) return null;
                    isDependency = true;
                }
                url = result._1;
                t1 = B.JSString_methods.startsWith$1(url, "file") ? A.Syntax_forPath0(url) : B.Syntax_SCSS_0_scss0;
                return new A._Record_3_importer_isDependency(A.Stylesheet_Stylesheet$parse0(result._0, t1, false, url), null, isDependency);
            },
            _evaluate0$_applyMixin$5: function(mixin, contentCallable, $arguments, nodeWithSpan, nodeWithSpanWithoutContent) {
                var t1, _0_0, t2, _1_8, t3, _this = this, _null = null, _s37_ = "Mixin doesn't accept a content block.", _s10_ = "invocation";
                $label0$0: {
                    if (mixin == null) throw A.wrapException(_this._evaluate0$_exception$2("Undefined mixin.", nodeWithSpan.get$span(nodeWithSpan)));
                    t1 = mixin instanceof A.BuiltInCallable0;
                    if (t1 && !mixin.acceptsContent && contentCallable != null) {
                        t1 = _this._evaluate0$_evaluateArguments$1($arguments)._values;
                        _0_0 = mixin.callbackFor$2(t1[2].length, new A.MapKeySet(t1[0], type$.MapKeySet_String));
                        throw A.wrapException(A.MultiSpanSassRuntimeException$0(_s37_, nodeWithSpanWithoutContent.get$span(nodeWithSpanWithoutContent), _s10_, A.LinkedHashMap_LinkedHashMap$_literal([
                            _0_0._0.get$spanWithName(),
                            "declaration"
                        ], type$.FileSpan, type$.String), _this._evaluate0$_stackTrace$1(nodeWithSpanWithoutContent.get$span(nodeWithSpanWithoutContent)), _null));
                    }
                    if (t1) {
                        _this._evaluate0$_environment.withContent$2(contentCallable, new A._EvaluateVisitor__applyMixin_closure3(_this, $arguments, mixin, nodeWithSpanWithoutContent));
                        break $label0$0;
                    }
                    t1 = type$.UserDefinedCallable_Environment_2._is(mixin);
                    t2 = false;
                    if (t1) {
                        _1_8 = mixin.declaration;
                        t3 = _1_8;
                        if (t3 instanceof A.MixinRule0) t2 = !type$.MixinRule_2._as(_1_8).get$hasContent() && contentCallable != null;
                    }
                    if (t2) throw A.wrapException(A.MultiSpanSassRuntimeException$0(_s37_, nodeWithSpanWithoutContent.get$span(nodeWithSpanWithoutContent), _s10_, A.LinkedHashMap_LinkedHashMap$_literal([
                        mixin.declaration.parameters.get$spanWithName(),
                        "declaration"
                    ], type$.FileSpan, type$.String), _this._evaluate0$_stackTrace$1(nodeWithSpanWithoutContent.get$span(nodeWithSpanWithoutContent)), _null));
                    if (t1) {
                        _this._evaluate0$_runUserDefinedCallable$1$4($arguments, mixin, nodeWithSpanWithoutContent, new A._EvaluateVisitor__applyMixin_closure4(_this, contentCallable, mixin, nodeWithSpanWithoutContent), type$.Null);
                        break $label0$0;
                    }
                    throw A.wrapException(A.UnsupportedError$("Unknown callable type " + mixin.toString$0(0) + "."));
                }
            },
            visitIncludeRule$1: function(_, node) {
                var _this = this, mixin = _this._evaluate0$_addExceptionSpan$2(node, new A._EvaluateVisitor_visitIncludeRule_closure5(_this, node));
                if (B.JSString_methods.startsWith$1(node.originalName, "--") && mixin instanceof A.UserDefinedCallable0 && !B.JSString_methods.startsWith$1(mixin.declaration.originalName, "--")) throw A.wrapException(_this._evaluate0$_exception$2(string$.Sass__m, node.get$nameSpan()));
                _this._evaluate0$_applyMixin$5(mixin, A.NullableExtension_andThen0(node.content, new A._EvaluateVisitor_visitIncludeRule_closure6(_this)), node.$arguments, node, new A._FakeAstNode0(new A._EvaluateVisitor_visitIncludeRule_closure7(node)));
                return null;
            },
            visitMixinRule$1: function(_, node) {
                var t1 = this._evaluate0$_environment, t2 = t1.closure$0(), t3 = this._evaluate0$_inDependency, t4 = t1._environment0$_mixins, index = t4.length - 1, t5 = node.name;
                t1._environment0$_mixinIndices.$indexSet(0, t5, index);
                t4[index].$indexSet(0, t5, new A.UserDefinedCallable0(node, t2, t3, type$.UserDefinedCallable_Environment_2));
                return null;
            },
            visitLoudComment$1: function(_, node) {
                var t1, text, _this = this, _s8_ = "__parent", _s13_ = "_endOfImports";
                if (_this._evaluate0$_inFunction) return null;
                if (_this._evaluate0$_assertInModule$2(_this._evaluate0$__parent, _s8_) === _this._evaluate0$_assertInModule$2(_this._evaluate0$__root, "_root") && _this._evaluate0$_assertInModule$2(_this._evaluate0$__endOfImports, _s13_) === J.get$length$asx(_this._evaluate0$_assertInModule$2(_this._evaluate0$__root, "_root").children._collection$_source)) _this._evaluate0$__endOfImports = _this._evaluate0$_assertInModule$2(_this._evaluate0$__endOfImports, _s13_) + 1;
                t1 = node.text;
                text = _this._evaluate0$_performInterpolation$1(t1);
                if (!B.JSString_methods.endsWith$1(text, "*/")) text += " */";
                _this._evaluate0$_copyParentAfterSibling$0();
                _this._evaluate0$_assertInModule$2(_this._evaluate0$__parent, _s8_).addChild$1(new A.ModifiableCssComment0(text, t1.span));
                return null;
            },
            visitMediaRule$1: function(_, node) {
                var _0_0, queries, mergedQueries, t1, mergedSources, t2, t3, _this = this, _null = null;
                if (_this._evaluate0$_declarationName != null) throw A.wrapException(_this._evaluate0$_exception$2(string$.Media_, node.span));
                _0_0 = _this._evaluate0$_performInterpolationWithMap$2$warnForColor(node.query, true);
                queries = new A.MediaQueryParser0(A.SpanScanner$(_0_0._0, _null), _0_0._1).parse$0(0);
                if (_this.get$_evaluate0$_hasCssNesting()) {
                    _this._evaluate0$_withParent$2$3$scopeWhen(A.ModifiableCssMediaRule$0(queries, node.span), new A._EvaluateVisitor_visitMediaRule_closure7(_this, node), false, type$.ModifiableCssMediaRule_2, type$.Null);
                    return _null;
                }
                mergedQueries = A.NullableExtension_andThen0(_this._evaluate0$_mediaQueries, new A._EvaluateVisitor_visitMediaRule_closure8(_this, queries));
                t1 = mergedQueries == null;
                if (!t1 && J.get$isEmpty$asx(mergedQueries)) return _null;
                if (t1) mergedSources = B.Set_empty6;
                else {
                    t2 = _this._evaluate0$_mediaQuerySources;
                    t2.toString;
                    t2 = A.LinkedHashSet_LinkedHashSet$of(t2, type$.CssMediaQuery_2);
                    t3 = _this._evaluate0$_mediaQueries;
                    t3.toString;
                    t2.addAll$1(0, t3);
                    t2.addAll$1(0, queries);
                    mergedSources = t2;
                }
                t1 = t1 ? queries : mergedQueries;
                _this._evaluate0$_withParent$2$4$scopeWhen$through(A.ModifiableCssMediaRule$0(t1, node.span), new A._EvaluateVisitor_visitMediaRule_closure9(_this, mergedQueries, queries, mergedSources, node), node.hasDeclarations, new A._EvaluateVisitor_visitMediaRule_closure10(mergedSources), type$.ModifiableCssMediaRule_2, type$.Null);
                return _null;
            },
            _evaluate0$_mergeMediaQueries$2: function(queries1, queries2) {
                var t1, t2, t3, t4, _0_0, t5, result, queries = A._setArrayType([], type$.JSArray_CssMediaQuery_2);
                for(t1 = J.get$iterator$ax(queries1), t2 = J.getInterceptor$ax(queries2); t1.moveNext$0();){
                    t3 = t1.get$current(t1);
                    for(t4 = t2.get$iterator(queries2); t4.moveNext$0();){
                        _0_0 = t3.merge$1(t4.get$current(t4));
                        if (B._SingletonCssMediaQueryMergeResult_00 === _0_0) continue;
                        if (B._SingletonCssMediaQueryMergeResult_10 === _0_0) return null;
                        t5 = _0_0 instanceof A.MediaQuerySuccessfulMergeResult0;
                        result = t5 ? _0_0 : null;
                        if (t5) queries.push(result.query);
                    }
                }
                return queries;
            },
            visitReturnRule$1: function(_, node) {
                var t1 = node.expression;
                return this._evaluate0$_withoutSlash$2(t1.accept$1(this), t1);
            },
            visitSilentComment$1: function(_, node) {
                return null;
            },
            visitStyleRule$1: function(_, node) {
                var t1, _0_0, selectorText, selectorMap, parsedSelector, _1_0, t2, t3, _i, _2_0, first, t4, rule, oldAtRootExcludingStyleRule, _this = this, _null = null, _s8_ = "__parent", _s11_ = "_stylesheet";
                if (_this._evaluate0$_declarationName != null) throw A.wrapException(_this._evaluate0$_exception$2(string$.Style_n, node.span));
                else if (_this._evaluate0$_inKeyframes && _this._evaluate0$_assertInModule$2(_this._evaluate0$__parent, _s8_) instanceof A.ModifiableCssKeyframeBlock0) throw A.wrapException(_this._evaluate0$_exception$2(string$.Style_k, node.span));
                t1 = node.selector;
                t1.toString;
                _0_0 = _this._evaluate0$_performInterpolationWithMap$2$warnForColor(t1, true);
                selectorText = _0_0._0;
                selectorMap = _0_0._1;
                if (_this._evaluate0$_inKeyframes) {
                    _this._evaluate0$_withParent$2$4$scopeWhen$through(A.ModifiableCssKeyframeBlock$0(new A.CssValue0(A.List_List$unmodifiable(new A.KeyframeSelectorParser0(A.SpanScanner$(selectorText, _null), selectorMap).parse$0(0), type$.String), t1.span, type$.CssValue_List_String_2), node.span), new A._EvaluateVisitor_visitStyleRule_closure7(_this, node), node.hasDeclarations, new A._EvaluateVisitor_visitStyleRule_closure8(), type$.ModifiableCssKeyframeBlock_2, type$.Null);
                    return _null;
                }
                parsedSelector = A.SelectorList_SelectorList$parse0(selectorText, true, selectorMap, _this._evaluate0$_logger, _this._evaluate0$_assertInModule$2(_this._evaluate0$__stylesheet, _s11_).plainCss);
                _1_0 = _this._evaluate0$_atRootExcludingStyleRule ? _null : _this._evaluate0$_styleRuleIgnoringAtRoot;
                $label0$0: {
                    if (_1_0 == null) {
                        t1 = true;
                        break $label0$0;
                    }
                    if (_1_0.fromPlainCss) {
                        t1 = false;
                        break $label0$0;
                    }
                    t1 = !(_this._evaluate0$_assertInModule$2(_this._evaluate0$__stylesheet, _s11_).plainCss && parsedSelector.accept$1(B.C__ContainsParentSelectorVisitor0));
                    break $label0$0;
                }
                if (t1) {
                    if (_this._evaluate0$_assertInModule$2(_this._evaluate0$__stylesheet, _s11_).plainCss) for(t2 = parsedSelector.components, t3 = t2.length, _i = 0; _i < t3; ++_i){
                        _2_0 = t2[_i].leadingCombinators;
                        if (_2_0.length >= 1) {
                            first = _2_0[0];
                            t4 = _this._evaluate0$_assertInModule$2(_this._evaluate0$__stylesheet, _s11_).plainCss;
                        } else {
                            first = _null;
                            t4 = false;
                        }
                        if (t4) throw A.wrapException(_this._evaluate0$_exception$2(string$.Top_le, first.span));
                    }
                    t2 = _this._evaluate0$_styleRuleIgnoringAtRoot;
                    t2 = t2 == null ? _null : t2.originalSelector;
                    parsedSelector = parsedSelector.nestWithin$3$implicitParent$preserveParentSelectors(t2, !_this._evaluate0$_atRootExcludingStyleRule, _this._evaluate0$_assertInModule$2(_this._evaluate0$__stylesheet, _s11_).plainCss);
                }
                rule = A.ModifiableCssStyleRule$0(_this._evaluate0$_assertInModule$2(_this._evaluate0$__extensionStore, "_extensionStore").addSelector$2(parsedSelector, _this._evaluate0$_mediaQueries), node.span, _this._evaluate0$_assertInModule$2(_this._evaluate0$__stylesheet, _s11_).plainCss, parsedSelector);
                oldAtRootExcludingStyleRule = _this._evaluate0$_atRootExcludingStyleRule;
                t2 = _this._evaluate0$_atRootExcludingStyleRule = false;
                t1 = t1 ? new A._EvaluateVisitor_visitStyleRule_closure9() : _null;
                _this._evaluate0$_withParent$2$4$scopeWhen$through(rule, new A._EvaluateVisitor_visitStyleRule_closure10(_this, rule, node), node.hasDeclarations, t1, type$.ModifiableCssStyleRule_2, type$.Null);
                _this._evaluate0$_atRootExcludingStyleRule = oldAtRootExcludingStyleRule;
                _this._evaluate0$_warnForBogusCombinators$1(rule);
                if ((_this._evaluate0$_atRootExcludingStyleRule ? _null : _this._evaluate0$_styleRuleIgnoringAtRoot) == null) {
                    t1 = _this._evaluate0$_assertInModule$2(_this._evaluate0$__parent, _s8_).children;
                    t1 = !t1.get$isEmpty(t1);
                } else t1 = t2;
                if (t1) {
                    t1 = _this._evaluate0$_assertInModule$2(_this._evaluate0$__parent, _s8_).children;
                    t1.get$last(t1).isGroupEnd = true;
                }
                return _null;
            },
            _evaluate0$_warnForBogusCombinators$1: function(rule) {
                var t1, t2, t3, t4, t5, _i, complex, visitor, t6, t7, t8, t9, _this = this, _null = null;
                if (!rule.accept$1(B._IsInvisibleVisitor_false_false0)) for(t1 = rule._style_rule0$_selector._box0$_inner.value.components, t2 = t1.length, t3 = type$.SourceSpan, t4 = type$.String, t5 = rule.children, _i = 0; _i < t2; ++_i){
                    complex = t1[_i];
                    if (!complex.accept$1(B._IsBogusVisitor_true0)) continue;
                    if (complex.accept$1(B.C__IsUselessVisitor0)) {
                        visitor = A._SerializeVisitor$0(_null, true, _null, _null, true, false, _null, true);
                        complex.accept$1(visitor);
                        _this._evaluate0$_warn$3('The selector "' + B.JSString_methods.trim$0(visitor._serialize0$_buffer.toString$0(0)) + string$.x22x20is_ix20, A.SpanExtensions_trimRight0(complex.span), B.Deprecation_2PR);
                    } else if (complex.leadingCombinators.length !== 0) {
                        if (!_this._evaluate0$_assertInModule$2(_this._evaluate0$__stylesheet, "_stylesheet").plainCss) {
                            visitor = A._SerializeVisitor$0(_null, true, _null, _null, true, false, _null, true);
                            complex.accept$1(visitor);
                            _this._evaluate0$_warn$3('The selector "' + B.JSString_methods.trim$0(visitor._serialize0$_buffer.toString$0(0)) + string$.x22x20is_ix0a, A.SpanExtensions_trimRight0(complex.span), B.Deprecation_2PR);
                        }
                    } else {
                        visitor = A._SerializeVisitor$0(_null, true, _null, _null, true, false, _null, true);
                        complex.accept$1(visitor);
                        t6 = B.JSString_methods.trim$0(visitor._serialize0$_buffer.toString$0(0));
                        t7 = complex.accept$1(B._IsBogusVisitor_false0) ? string$.x20It_wi : "";
                        t8 = A.SpanExtensions_trimRight0(complex.span);
                        if (t5.get$length(0) === 0) A.throwExpression(A.IterableElementError_noElement());
                        t9 = J.get$span$x(t5.$index(0, 0));
                        _this._evaluate0$_warn$3('The selector "' + t6 + string$.x22x20is_o + t7 + string$.x0aThis_, new A.MultiSpan0(t8, "invalid selector", A.ConstantMap_ConstantMap$from(A.LinkedHashMap_LinkedHashMap$_literal([
                            t9,
                            "this is not a style rule" + (t5.every$1(t5, new A._EvaluateVisitor__warnForBogusCombinators_closure1()) ? "\n(try converting to a //-style comment)" : "")
                        ], t3, t4), t3, t4)), B.Deprecation_2PR);
                    }
                }
            },
            visitSupportsRule$1: function(_, node) {
                var t1, rule, _this = this;
                if (_this._evaluate0$_declarationName != null) throw A.wrapException(_this._evaluate0$_exception$2(string$.Suppor, node.span));
                t1 = node.condition;
                rule = A.ModifiableCssSupportsRule$0(new A.CssValue0(_this._evaluate0$_visitSupportsCondition$1(t1), t1.get$span(t1), type$.CssValue_String_2), node.span);
                if (_this.get$_evaluate0$_hasCssNesting()) {
                    _this._evaluate0$_withParent$2$3$scopeWhen(rule, new A._EvaluateVisitor_visitSupportsRule_closure5(_this, node), node.hasDeclarations, type$.ModifiableCssSupportsRule_2, type$.Null);
                    return null;
                }
                _this._evaluate0$_withParent$2$4$scopeWhen$through(rule, new A._EvaluateVisitor_visitSupportsRule_closure6(_this, node), node.hasDeclarations, new A._EvaluateVisitor_visitSupportsRule_closure7(), type$.ModifiableCssSupportsRule_2, type$.Null);
                return null;
            },
            _evaluate0$_visitSupportsCondition$1: function(condition) {
                var t1, _this = this;
                $label0$0: {
                    if (condition instanceof A.SupportsOperation0) {
                        t1 = condition.operator;
                        t1 = _this._evaluate0$_parenthesize$2(condition.left, t1) + " " + t1.toString$0(0) + " " + _this._evaluate0$_parenthesize$2(condition.right, t1);
                        break $label0$0;
                    }
                    if (condition instanceof A.SupportsNegation0) {
                        t1 = "not " + _this._evaluate0$_parenthesize$1(condition.condition);
                        break $label0$0;
                    }
                    if (condition instanceof A.SupportsInterpolation0) {
                        t1 = condition.expression;
                        t1 = _this._evaluate0$_serialize$3$quote(t1.accept$1(_this), t1, false);
                        break $label0$0;
                    }
                    t1 = {};
                    t1.declaration = null;
                    if (condition instanceof A.SupportsDeclaration0) {
                        t1.declaration = condition;
                        t1 = _this._evaluate0$_withSupportsDeclaration$1(new A._EvaluateVisitor__visitSupportsCondition_closure1(t1, _this));
                        break $label0$0;
                    }
                    if (condition instanceof A.SupportsFunction0) {
                        t1 = _this._evaluate0$_performInterpolation$1(condition.name) + "(" + _this._evaluate0$_performInterpolation$1(condition.$arguments) + ")";
                        break $label0$0;
                    }
                    if (condition instanceof A.SupportsAnything0) {
                        t1 = "(" + _this._evaluate0$_performInterpolation$1(condition.contents) + ")";
                        break $label0$0;
                    }
                    t1 = A.throwExpression(A.ArgumentError$("Unknown supports condition type " + A.getRuntimeTypeOfDartObject(condition).toString$0(0) + ".", null));
                }
                return t1;
            },
            _evaluate0$_withSupportsDeclaration$1$1: function(callback) {
                var t1, oldInSupportsDeclaration = this._evaluate0$_inSupportsDeclaration;
                this._evaluate0$_inSupportsDeclaration = true;
                try {
                    t1 = callback.call$0();
                    return t1;
                } finally{
                    this._evaluate0$_inSupportsDeclaration = oldInSupportsDeclaration;
                }
            },
            _evaluate0$_withSupportsDeclaration$1: function(callback) {
                return this._evaluate0$_withSupportsDeclaration$1$1(callback, type$.dynamic);
            },
            _evaluate0$_parenthesize$2: function(condition, operator) {
                var t1;
                if (!(condition instanceof A.SupportsNegation0)) {
                    if (condition instanceof A.SupportsOperation0) t1 = operator == null || operator !== condition.operator;
                    else t1 = false;
                } else t1 = true;
                if (t1) return "(" + this._evaluate0$_visitSupportsCondition$1(condition) + ")";
                return this._evaluate0$_visitSupportsCondition$1(condition);
            },
            _evaluate0$_parenthesize$1: function(condition) {
                return this._evaluate0$_parenthesize$2(condition, null);
            },
            visitVariableDeclaration$1: function(_, node) {
                var t1, t2, _0_0, value, _this = this, _null = null;
                if (node.isGuarded) {
                    if (node.namespace == null && _this._evaluate0$_environment._environment0$_variables.length === 1) {
                        t1 = node.name;
                        _this._evaluate0$_environment._environment0$_configurableVariables.add$1(0, t1);
                        t2 = _this._evaluate0$_configuration._configuration0$_values;
                        _0_0 = t2.get$isEmpty(t2) ? _null : t2.remove$1(0, t1);
                        t1 = {};
                        t1.override = null;
                        if (_0_0 != null) {
                            t1.override = _0_0;
                            t2 = !_0_0.value.$eq(0, B.C__SassNull0);
                        } else t2 = false;
                        if (t2) {
                            _this._evaluate0$_addExceptionSpan$2(node, new A._EvaluateVisitor_visitVariableDeclaration_closure5(t1, _this, node));
                            return _null;
                        }
                    }
                    value = _this._evaluate0$_addExceptionSpan$2(node, new A._EvaluateVisitor_visitVariableDeclaration_closure6(_this, node));
                    if (value != null && !value.$eq(0, B.C__SassNull0)) return _null;
                }
                if (node.isGlobal && !_this._evaluate0$_environment.globalVariableExists$1(node.name)) {
                    t1 = _this._evaluate0$_environment._environment0$_variables.length === 1 ? string$.As_of_S : string$.As_of_R + A.declarationName0(node.span) + ": null` at the stylesheet root.";
                    _this._evaluate0$_warn$3(t1, node.span, B.Deprecation_pwd);
                }
                t1 = node.expression;
                _this._evaluate0$_addExceptionSpan$2(node, new A._EvaluateVisitor_visitVariableDeclaration_closure7(_this, node, _this._evaluate0$_withoutSlash$2(t1.accept$1(_this), t1)));
                return _null;
            },
            visitUseRule$1: function(_, node) {
                var values, _i, variable, t3, variableNodeWithSpan, configuration, _this = this, t1 = node.configuration, t2 = t1.length;
                if (t2 !== 0) {
                    values = A.LinkedHashMap_LinkedHashMap$_empty(type$.String, type$.ConfiguredValue_2);
                    for(_i = 0; _i < t2; ++_i){
                        variable = t1[_i];
                        t3 = variable.expression;
                        variableNodeWithSpan = _this._evaluate0$_expressionNode$1(t3);
                        values.$indexSet(0, variable.name, new A.ConfiguredValue0(_this._evaluate0$_withoutSlash$2(t3.accept$1(_this), variableNodeWithSpan), variable.span, variableNodeWithSpan));
                    }
                    configuration = new A.ExplicitConfiguration0(node, values, null);
                } else configuration = B.Configuration_Map_empty_null0;
                _this._evaluate0$_loadModule$5$configuration(node.url, "@use", node, new A._EvaluateVisitor_visitUseRule_closure1(_this, node), configuration);
                _this._evaluate0$_assertConfigurationIsEmpty$1(configuration);
                return null;
            },
            visitWarnRule$1: function(_, node) {
                var _this = this, value = _this._evaluate0$_addExceptionSpan$2(node, new A._EvaluateVisitor_visitWarnRule_closure1(_this, node)), t1 = value instanceof A.SassString0 ? value._string0$_text : _this._evaluate0$_serialize$2(value, node.expression), t2 = _this._evaluate0$_stackTrace$1(node.span);
                _this._evaluate0$_logger.internalWarn$4$deprecation$span$trace(t1, null, null, t2);
                return null;
            },
            visitWhileRule$1: function(_, node) {
                return this._evaluate0$_environment.scope$1$3$semiGlobal$when(new A._EvaluateVisitor_visitWhileRule_closure1(this, node), true, node.hasDeclarations, type$.nullable_Value_2);
            },
            visitBinaryOperationExpression$1: function(_, node) {
                var t1, _this = this;
                if (_this._evaluate0$_assertInModule$2(_this._evaluate0$__stylesheet, "_stylesheet").plainCss) {
                    t1 = node.operator;
                    t1 = t1 !== B.BinaryOperator_g6F0 && t1 !== B.BinaryOperator_ehp0;
                } else t1 = false;
                if (t1) throw A.wrapException(_this._evaluate0$_exception$2("Operators aren't allowed in plain CSS.", node.get$operatorSpan()));
                return _this._evaluate0$_addExceptionSpan$2(node, new A._EvaluateVisitor_visitBinaryOperationExpression_closure1(_this, node));
            },
            _evaluate0$_slash$3: function(left, right, node) {
                var left0, _1_2, result = left.dividedBy$1(right), _1_2_isSet = left instanceof A.SassNumber0, right0 = null, t1 = false;
                if (_1_2_isSet) {
                    if (right instanceof A.SassNumber0) {
                        t1 = node.allowsSlash && this._evaluate0$_operandAllowsSlash$1(node.left) && this._evaluate0$_operandAllowsSlash$1(node.right);
                        right0 = right;
                    }
                    left0 = left;
                    _1_2 = right;
                } else {
                    _1_2 = null;
                    left0 = null;
                }
                if (t1) return type$.SassNumber_2._as(result).withSlash$2(left0, right0);
                if (left instanceof A.SassNumber0) t1 = (_1_2_isSet ? _1_2 : right) instanceof A.SassNumber0;
                else t1 = false;
                if (t1) {
                    this._evaluate0$_warn$3(string$.Using__o + A.S(new A._EvaluateVisitor__slash_recommendation1().call$1(node)) + " or " + A.expressionToCalc0(node).toString$0(0) + string$.x0a_Morex20, node.get$span(0), B.Deprecation_v81);
                    return result;
                }
                return result;
            },
            _evaluate0$_operandAllowsSlash$1: function(node) {
                var t1;
                if (node instanceof A.FunctionExpression0) {
                    if (node.namespace == null) {
                        t1 = node.name;
                        t1 = B.Set_Pr3yj.contains$1(0, t1.toLowerCase()) && this._evaluate0$_environment.getFunction$1(t1) == null;
                    } else t1 = false;
                } else t1 = true;
                return t1;
            },
            visitValueExpression$1: function(_, node) {
                return node.value;
            },
            visitVariableExpression$1: function(_, node) {
                var result = this._evaluate0$_addExceptionSpan$2(node, new A._EvaluateVisitor_visitVariableExpression_closure1(this, node));
                if (result != null) return result;
                throw A.wrapException(this._evaluate0$_exception$2("Undefined variable.", node.span));
            },
            visitUnaryOperationExpression$1: function(_, node) {
                return this._evaluate0$_addExceptionSpan$2(node, new A._EvaluateVisitor_visitUnaryOperationExpression_closure1(node, node.operand.accept$1(this)));
            },
            visitBooleanExpression$1: function(_, node) {
                return node.value ? B.SassBoolean_true0 : B.SassBoolean_false0;
            },
            visitIfExpression$1: function(_, node) {
                var t1, t2, t3, results, _i, t4, condition, expression, result, _1_2, _this = this;
                for(t1 = node.branches, t2 = t1.length, t3 = type$.JSArray_Record_2_String_and_Value_2, results = null, _i = 0; _i < t2; ++_i){
                    t4 = t1[_i];
                    condition = t4._0;
                    expression = t4._1;
                    result = condition == null ? null : condition.accept$1(_this);
                    if (result == null) result = true;
                    t4 = typeof result == "string";
                    condition = t4 ? result : null;
                    if (t4) {
                        if (results == null) results = A._setArrayType([], t3);
                        results.push(new A._Record_2(condition, expression.accept$1(_this)));
                        continue;
                    }
                    _1_2 = true === result;
                    if (_1_2 && results != null) {
                        results.push(new A._Record_2("else", expression.accept$1(_this)));
                        continue;
                    }
                    if (_1_2) return expression.accept$1(_this);
                }
                if (results == null) return B.C__SassNull0;
                return new A.SassString0("if(" + new A.MappedListIterable(results, new A._EvaluateVisitor_visitIfExpression_closure1(), A._arrayInstanceType(results)._eval$1("MappedListIterable<1,String>")).join$1(0, "; ") + ")", false);
            },
            visitIfConditionParenthesized$1: function(_, node) {
                var t1, _0_0 = node.expression.accept$1(this);
                $label0$0: {
                    if (typeof _0_0 == "string") {
                        t1 = "(" + _0_0 + ")";
                        break $label0$0;
                    }
                    t1 = _0_0;
                    break $label0$0;
                }
                return t1;
            },
            visitIfConditionNegation$1: function(_, node) {
                var t1, _0_0 = node.expression.accept$1(this);
                $label0$0: {
                    if (typeof _0_0 == "string") {
                        t1 = "not " + _0_0;
                        break $label0$0;
                    }
                    if (A._isBool(_0_0)) {
                        t1 = !_0_0;
                        break $label0$0;
                    }
                    t1 = A.throwExpression(A.UnsupportedError$("unreachable"));
                }
                return t1;
            },
            visitIfConditionOperation$1: function(_, node) {
                var t1, t2, t3, t4, t5, t6, values, _i, expression, _0_0, t7, right, _1_6_isSet, _1_6, string;
                for(t1 = node.expressions, t2 = t1.length, t3 = node.op, t4 = t3 === B.BooleanOperator_00, t5 = t3 === B.BooleanOperator_10, t6 = type$.JSArray_Record_2_IfConditionExpression_and_String_2, values = null, _i = 0; _i < t2; ++_i){
                    expression = t1[_i];
                    _0_0 = expression.accept$1(this);
                    t7 = typeof _0_0 == "string";
                    right = t7 ? _0_0 : null;
                    if (t7) {
                        if (values == null) values = A._setArrayType([], t6);
                        values.push(new A._Record_2(expression, right));
                        continue;
                    }
                    if (false === _0_0 && t4) return false;
                    if (true === _0_0 && t5) return true;
                }
                $label0$1: {
                    if (values == null) {
                        t1 = t4;
                        break $label0$1;
                    }
                    _1_6_isSet = values.length === 1;
                    if (_1_6_isSet) {
                        _1_6 = values[0];
                        t1 = _1_6._0 instanceof A.IfConditionParenthesized0;
                    } else {
                        _1_6 = null;
                        t1 = false;
                    }
                    if (t1) {
                        string = (_1_6_isSet ? _1_6 : values[0])._1;
                        t1 = B.JSString_methods.substring$2(string, 1, string.length - 1);
                        break $label0$1;
                    }
                    t1 = new A.MappedListIterable(values, new A._EvaluateVisitor_visitIfConditionOperation_closure1(), A._arrayInstanceType(values)._eval$1("MappedListIterable<1,String>")).join$1(0, " " + t3.toString$0(0) + " ");
                    break $label0$1;
                }
                return t1;
            },
            visitIfConditionFunction$1: function(_, node) {
                return this._evaluate0$_performInterpolation$1(node.name) + "(" + this._evaluate0$_performInterpolation$1(node.$arguments) + ")";
            },
            visitIfConditionSass$1: function(_, node) {
                return node.expression.accept$1(this).get$isTruthy();
            },
            visitIfConditionRaw$1: function(_, node) {
                return this._evaluate0$_performInterpolation$1(node.text);
            },
            visitLegacyIfExpression$1: function(_, node) {
                var condition, t1, ifTrue, ifFalse, result, _this = this, _0_0 = _this._evaluate0$_evaluateMacroArguments$1(node), positional = _0_0._0, named = _0_0._1;
                _this._evaluate0$_verifyArguments$4(positional.length, named, $.$get$LegacyIfExpression_declaration0(), node);
                condition = A.ListExtensions_elementAtOrNull(positional, 0);
                if (condition == null) {
                    t1 = named.$index(0, "condition");
                    t1.toString;
                    condition = t1;
                }
                ifTrue = A.ListExtensions_elementAtOrNull(positional, 1);
                if (ifTrue == null) {
                    t1 = named.$index(0, "if-true");
                    t1.toString;
                    ifTrue = t1;
                }
                ifFalse = A.ListExtensions_elementAtOrNull(positional, 2);
                if (ifFalse == null) {
                    t1 = named.$index(0, "if-false");
                    t1.toString;
                    ifFalse = t1;
                }
                result = condition.accept$1(_this).get$isTruthy() ? ifTrue : ifFalse;
                return _this._evaluate0$_withoutSlash$2(result.accept$1(_this), _this._evaluate0$_expressionNode$1(result));
            },
            visitNullExpression$1: function(_, node) {
                return B.C__SassNull0;
            },
            visitNumberExpression$1: function(_, node) {
                return A.SassNumber_SassNumber0(node.value, node.unit);
            },
            visitParenthesizedExpression$1: function(_, node) {
                var _this = this;
                return _this._evaluate0$_assertInModule$2(_this._evaluate0$__stylesheet, "_stylesheet").plainCss ? A.throwExpression(_this._evaluate0$_exception$2("Parentheses aren't allowed in plain CSS.", node.span)) : node.expression.accept$1(_this);
            },
            visitColorExpression$1: function(_, node) {
                return node.value;
            },
            visitListExpression$1: function(_, node) {
                var t1 = node.contents;
                return A.SassList$0(new A.MappedListIterable(t1, new A._EvaluateVisitor_visitListExpression_closure1(this), A._arrayInstanceType(t1)._eval$1("MappedListIterable<1,Value0>")), node.separator, node.hasBrackets);
            },
            visitMapExpression$1: function(_, node) {
                var t2, t3, _i, t4, key, keyValue, valueValue, oldValueSpan, t1 = type$.Value_2, map = A.LinkedHashMap_LinkedHashMap$_empty(t1, t1), keyNodes = A.LinkedHashMap_LinkedHashMap$_empty(t1, type$.AstNode_2);
                for(t2 = node.pairs, t3 = t2.length, _i = 0; _i < t3; ++_i){
                    t4 = t2[_i];
                    key = t4._0;
                    keyValue = key.accept$1(this);
                    valueValue = t4._1.accept$1(this);
                    if (map.containsKey$1(keyValue)) {
                        t1 = keyNodes.$index(0, keyValue);
                        oldValueSpan = t1 == null ? null : t1.get$span(t1);
                        t1 = key.get$span(key);
                        t2 = A.LinkedHashMap_LinkedHashMap$_empty(type$.FileSpan, type$.String);
                        if (oldValueSpan != null) t2.$indexSet(0, oldValueSpan, "first key");
                        throw A.wrapException(A.MultiSpanSassRuntimeException$0("Duplicate key.", t1, "second key", t2, this._evaluate0$_stackTrace$1(key.get$span(key)), null));
                    }
                    map.$indexSet(0, keyValue, valueValue);
                    keyNodes.$indexSet(0, keyValue, key);
                }
                return new A.SassMap0(A.ConstantMap_ConstantMap$from(map, t1, t1));
            },
            visitFunctionExpression$1: function(_, node) {
                var t2, _0_0, t3, t4, $name, oldInFunction, result, _this = this, _s11_ = "_stylesheet", t1 = {}, $function = _this._evaluate0$_assertInModule$2(_this._evaluate0$__stylesheet, _s11_).plainCss ? null : _this._evaluate0$_addExceptionSpan$2(node, new A._EvaluateVisitor_visitFunctionExpression_closure5(_this, node));
                t1.$function = $function;
                if ($function == null || B.JSString_methods.startsWith$1(node.originalName, "--")) {
                    if (node.namespace != null) throw A.wrapException(_this._evaluate0$_exception$2("Undefined function.", node.span));
                    t2 = node.name;
                    _0_0 = t2.toLowerCase();
                    t3 = false;
                    if ("min" === _0_0 || "max" === _0_0 || "round" === _0_0 || "abs" === _0_0) {
                        t3 = node.$arguments;
                        t4 = t3.named;
                        t3 = t4.get$isEmpty(t4) && t3.rest == null && B.JSArray_methods.every$1(t3.positional, new A._EvaluateVisitor_visitFunctionExpression_closure6());
                        $name = _0_0;
                    } else $name = null;
                    if (t3) return _this._evaluate0$_visitCalculation$2$inLegacySassFunction(node, $name);
                    if ("calc" === _0_0 || "clamp" === _0_0 || "hypot" === _0_0 || "sin" === _0_0 || "cos" === _0_0 || "tan" === _0_0 || "asin" === _0_0 || "acos" === _0_0 || "atan" === _0_0 || "sqrt" === _0_0 || "exp" === _0_0 || "sign" === _0_0 || "mod" === _0_0 || "rem" === _0_0 || "atan2" === _0_0 || "pow" === _0_0 || "log" === _0_0 || "calc-size" === _0_0) return _this._evaluate0$_visitCalculation$1(node);
                    $function = _this._evaluate0$_assertInModule$2(_this._evaluate0$__stylesheet, _s11_).plainCss ? null : _this._evaluate0$_builtInFunctions.$index(0, t2);
                    t1.$function = $function == null ? new A.PlainCssCallable0(node.originalName) : $function;
                }
                oldInFunction = _this._evaluate0$_inFunction;
                _this._evaluate0$_inFunction = true;
                result = _this._evaluate0$_addErrorSpan$2(node, new A._EvaluateVisitor_visitFunctionExpression_closure7(t1, _this, node));
                _this._evaluate0$_inFunction = oldInFunction;
                return result;
            },
            _evaluate0$_visitCalculation$2$inLegacySassFunction: function(node, inLegacySassFunction) {
                var $arguments, oldCallableNode, t1, _0_0, error, stackTrace, t4, _i, _$exception, _this = this, t2 = node.$arguments, t3 = t2.named;
                if (t3.get$isNotEmpty(t3)) throw A.wrapException(_this._evaluate0$_exception$2(string$.Keywor, node.span));
                else if (t2.rest != null) throw A.wrapException(_this._evaluate0$_exception$2(string$.Rest_a, node.span));
                _this._evaluate0$_checkCalculationArguments$1(node);
                t3 = A._setArrayType([], type$.JSArray_Object);
                for(t2 = t2.positional, t4 = t2.length, _i = 0; _i < t4; ++_i)t3.push(_this._evaluate0$_visitCalculationExpression$2$inLegacySassFunction(t2[_i], inLegacySassFunction));
                $arguments = t3;
                if (_this._evaluate0$_inSupportsDeclaration) return new A.SassCalculation0(node.name, A.List_List$unmodifiable($arguments, type$.Object));
                oldCallableNode = _this._evaluate0$_callableNode;
                _this._evaluate0$_callableNode = node;
                try {
                    t1 = null;
                    t3 = node.name;
                    _0_0 = t3.toLowerCase();
                    $label0$0: {
                        if ("calc" === _0_0) {
                            t1 = A.SassCalculation_calc0(J.$index$asx($arguments, 0));
                            break $label0$0;
                        }
                        if ("sqrt" === _0_0) {
                            t1 = A.SassCalculation__singleArgument0("sqrt", J.$index$asx($arguments, 0), A.number2__sqrt$closure(), true);
                            break $label0$0;
                        }
                        if ("sin" === _0_0) {
                            t1 = A.SassCalculation__singleArgument0("sin", J.$index$asx($arguments, 0), A.number2__sin$closure(), false);
                            break $label0$0;
                        }
                        if ("cos" === _0_0) {
                            t1 = A.SassCalculation__singleArgument0("cos", J.$index$asx($arguments, 0), A.number2__cos$closure(), false);
                            break $label0$0;
                        }
                        if ("tan" === _0_0) {
                            t1 = A.SassCalculation__singleArgument0("tan", J.$index$asx($arguments, 0), A.number2__tan$closure(), false);
                            break $label0$0;
                        }
                        if ("asin" === _0_0) {
                            t1 = A.SassCalculation__singleArgument0("asin", J.$index$asx($arguments, 0), A.number2__asin$closure(), true);
                            break $label0$0;
                        }
                        if ("acos" === _0_0) {
                            t1 = A.SassCalculation__singleArgument0("acos", J.$index$asx($arguments, 0), A.number2__acos$closure(), true);
                            break $label0$0;
                        }
                        if ("atan" === _0_0) {
                            t1 = A.SassCalculation__singleArgument0("atan", J.$index$asx($arguments, 0), A.number2__atan$closure(), true);
                            break $label0$0;
                        }
                        if ("abs" === _0_0) {
                            t1 = A.SassCalculation_abs0(J.$index$asx($arguments, 0));
                            break $label0$0;
                        }
                        if ("exp" === _0_0) {
                            t1 = A.SassCalculation_exp0(J.$index$asx($arguments, 0));
                            break $label0$0;
                        }
                        if ("sign" === _0_0) {
                            t1 = A.SassCalculation_sign0(J.$index$asx($arguments, 0));
                            break $label0$0;
                        }
                        if ("min" === _0_0) {
                            t1 = A.SassCalculation_min0($arguments);
                            break $label0$0;
                        }
                        if ("max" === _0_0) {
                            t1 = A.SassCalculation_max0($arguments);
                            break $label0$0;
                        }
                        if ("hypot" === _0_0) {
                            t1 = A.SassCalculation_hypot0($arguments);
                            break $label0$0;
                        }
                        if ("pow" === _0_0) {
                            t1 = A.SassCalculation_pow0(J.$index$asx($arguments, 0), A.ListExtensions_elementAtOrNull($arguments, 1));
                            break $label0$0;
                        }
                        if ("atan2" === _0_0) {
                            t1 = A.SassCalculation_atan20(J.$index$asx($arguments, 0), A.ListExtensions_elementAtOrNull($arguments, 1));
                            break $label0$0;
                        }
                        if ("log" === _0_0) {
                            t1 = A.SassCalculation_log0(J.$index$asx($arguments, 0), A.ListExtensions_elementAtOrNull($arguments, 1));
                            break $label0$0;
                        }
                        if ("mod" === _0_0) {
                            t1 = A.SassCalculation_mod0(J.$index$asx($arguments, 0), A.ListExtensions_elementAtOrNull($arguments, 1));
                            break $label0$0;
                        }
                        if ("rem" === _0_0) {
                            t1 = A.SassCalculation_rem0(J.$index$asx($arguments, 0), A.ListExtensions_elementAtOrNull($arguments, 1));
                            break $label0$0;
                        }
                        if ("round" === _0_0) {
                            t1 = A.SassCalculation_roundInternal0(J.$index$asx($arguments, 0), A.ListExtensions_elementAtOrNull($arguments, 1), A.ListExtensions_elementAtOrNull($arguments, 2), inLegacySassFunction, node.span, new A._EvaluateVisitor__visitCalculation_closure1(_this, node));
                            break $label0$0;
                        }
                        if ("clamp" === _0_0) {
                            t1 = A.SassCalculation_clamp0(J.$index$asx($arguments, 0), A.ListExtensions_elementAtOrNull($arguments, 1), A.ListExtensions_elementAtOrNull($arguments, 2));
                            break $label0$0;
                        }
                        if ("calc-size" === _0_0) {
                            t1 = A.SassCalculation_calcSize0(J.$index$asx($arguments, 0), A.ListExtensions_elementAtOrNull($arguments, 1));
                            break $label0$0;
                        }
                        t3 = A.UnsupportedError$('Unknown calculation name "' + t3 + '".');
                        t1 = A.throwExpression(t3);
                    }
                    t1;
                    return t1;
                } catch (exception) {
                    t1 = A.unwrapException(exception);
                    if (t1 instanceof A.SassScriptException0) {
                        error = t1;
                        stackTrace = A.getTraceFromException(exception);
                        if (B.JSString_methods.contains$1(error.message, "compatible")) _this._evaluate0$_verifyCompatibleNumbers$2($arguments, t2);
                        A.throwWithTrace0(_this._evaluate0$_exception$2(error.message, node.span), error, stackTrace);
                    } else throw exception;
                } finally{
                    _this._evaluate0$_callableNode = oldCallableNode;
                }
            },
            _evaluate0$_visitCalculation$1: function(node) {
                return this._evaluate0$_visitCalculation$2$inLegacySassFunction(node, null);
            },
            _evaluate0$_checkCalculationArguments$1: function(node) {
                var t1, _0_0, check = new A._EvaluateVisitor__checkCalculationArguments_check1(this, node);
                $label0$0: {
                    t1 = node.name;
                    _0_0 = t1.toLowerCase();
                    if ("calc" === _0_0 || "sqrt" === _0_0 || "sin" === _0_0 || "cos" === _0_0 || "tan" === _0_0 || "asin" === _0_0 || "acos" === _0_0 || "atan" === _0_0 || "abs" === _0_0 || "exp" === _0_0 || "sign" === _0_0) {
                        check.call$1(1);
                        break $label0$0;
                    }
                    if ("min" === _0_0 || "max" === _0_0 || "hypot" === _0_0) {
                        check.call$0();
                        break $label0$0;
                    }
                    if ("pow" === _0_0 || "atan2" === _0_0 || "log" === _0_0 || "mod" === _0_0 || "rem" === _0_0 || "calc-size" === _0_0) {
                        check.call$1(2);
                        break $label0$0;
                    }
                    if ("round" === _0_0 || "clamp" === _0_0) {
                        check.call$1(3);
                        break $label0$0;
                    }
                    throw A.wrapException(A.UnsupportedError$('Unknown calculation name "' + t1 + '".'));
                }
            },
            _evaluate0$_verifyCompatibleNumbers$2: function(args, nodesWithSpans) {
                var i, t1, _0_0, arg, t2, number1, j, number2, t3, t4, t5, t6;
                for(i = 0; t1 = args.length, i < t1; ++i){
                    _0_0 = args[i];
                    if (_0_0 instanceof A.SassNumber0) {
                        t1 = _0_0.get$hasComplexUnits();
                        arg = _0_0;
                    } else {
                        arg = null;
                        t1 = false;
                    }
                    if (t1) {
                        t1 = A.S(arg);
                        t2 = nodesWithSpans[i];
                        throw A.wrapException(this._evaluate0$_exception$2("Number " + t1 + " isn't compatible with CSS calculations.", t2.get$span(t2)));
                    }
                }
                for(i = 0; i < t1 - 1; ++i){
                    number1 = args[i];
                    if (!(number1 instanceof A.SassNumber0)) continue;
                    for(j = i + 1; t1 = args.length, j < t1; ++j){
                        number2 = args[j];
                        if (!(number2 instanceof A.SassNumber0)) continue;
                        if (number1.hasPossiblyCompatibleUnits$1(number2)) continue;
                        t1 = number1.toString$0(0);
                        t2 = number2.toString$0(0);
                        t3 = nodesWithSpans[i];
                        t3 = t3.get$span(t3);
                        t4 = number1.toString$0(0);
                        t5 = nodesWithSpans[j];
                        t5 = A.LinkedHashMap_LinkedHashMap$_literal([
                            t5.get$span(t5),
                            number2.toString$0(0)
                        ], type$.FileSpan, type$.String);
                        t6 = nodesWithSpans[i];
                        throw A.wrapException(A.MultiSpanSassRuntimeException$0(t1 + " and " + t2 + " are incompatible.", t3, t4, t5, this._evaluate0$_stackTrace$1(t6.get$span(t6)), null));
                    }
                }
            },
            _evaluate0$_visitCalculationExpression$2$inLegacySassFunction: function(node, inLegacySassFunction) {
                var result, t2, _0_0, _box_0, _1_0, t3, _i, i, _this = this, _null = null, t1 = node instanceof A.ParenthesizedExpression0, inner = t1 ? node.expression : _null;
                if (t1) {
                    result = _this._evaluate0$_visitCalculationExpression$2$inLegacySassFunction(inner, inLegacySassFunction);
                    return result instanceof A.SassString0 ? new A.SassString0("(" + result._string0$_text + ")", false) : result;
                }
                if (node instanceof A.StringExpression0 && node.accept$1(B.C_IsCalculationSafeVisitor0)) {
                    t1 = node.text;
                    t2 = t1.get$asPlain();
                    _0_0 = t2 == null ? _null : t2.toLowerCase();
                    $label0$0: {
                        if ("pi" === _0_0) {
                            t1 = A.SassNumber_SassNumber0(3.141592653589793, _null);
                            break $label0$0;
                        }
                        if ("e" === _0_0) {
                            t1 = A.SassNumber_SassNumber0(2.718281828459045, _null);
                            break $label0$0;
                        }
                        if ("infinity" === _0_0) {
                            t1 = A.SassNumber_SassNumber0(1 / 0, _null);
                            break $label0$0;
                        }
                        if ("-infinity" === _0_0) {
                            t1 = A.SassNumber_SassNumber0(-1 / 0, _null);
                            break $label0$0;
                        }
                        if ("nan" === _0_0) {
                            t1 = A.SassNumber_SassNumber0(0 / 0, _null);
                            break $label0$0;
                        }
                        t1 = new A.SassString0(_this._evaluate0$_performInterpolation$1(t1), false);
                        break $label0$0;
                    }
                    return t1;
                }
                _box_0 = {};
                _box_0.right = _box_0.left = _box_0.operator = null;
                t1 = node instanceof A.BinaryOperationExpression0;
                if (t1) {
                    _box_0.operator = node.operator;
                    _box_0.left = node.left;
                    _box_0.right = node.right;
                }
                if (t1) {
                    _this._evaluate0$_checkWhitespaceAroundCalculationOperator$1(node);
                    return _this._evaluate0$_addExceptionSpan$2(node, new A._EvaluateVisitor__visitCalculationExpression_closure1(_box_0, _this, node, inLegacySassFunction));
                }
                if (node instanceof A.NumberExpression0 || node instanceof A.VariableExpression0 || node instanceof A.FunctionExpression0 || node instanceof A.LegacyIfExpression0) {
                    _1_0 = node.accept$1(_this);
                    $label1$1: {
                        if (_1_0 instanceof A.SassNumber0) {
                            t1 = _1_0;
                            break $label1$1;
                        }
                        if (_1_0 instanceof A.SassCalculation0) {
                            t1 = _1_0;
                            break $label1$1;
                        }
                        if (_1_0 instanceof A.SassString0) {
                            t1 = !_1_0._string0$_hasQuotes;
                            result = _1_0;
                        } else {
                            result = _null;
                            t1 = false;
                        }
                        if (t1) {
                            t1 = result;
                            break $label1$1;
                        }
                        t1 = A.throwExpression(_this._evaluate0$_exception$2("Value " + _1_0.toString$0(0) + " can't be used in a calculation.", node.get$span(node)));
                    }
                    return t1;
                }
                if (node instanceof A.ListExpression0 && !node.hasBrackets && B.ListSeparator_SrV0 === node.separator && node.contents.length >= 2) {
                    t1 = A._setArrayType([], type$.JSArray_Object);
                    for(t2 = node.contents, t3 = t2.length, _i = 0; _i < t3; ++_i)t1.push(_this._evaluate0$_visitCalculationExpression$2$inLegacySassFunction(t2[_i], inLegacySassFunction));
                    _this._evaluate0$_checkAdjacentCalculationValues$2(t1, node);
                    for(i = 0; i < t1.length; ++i){
                        t3 = t1[i];
                        if (t3 instanceof A.CalculationOperation0 && t2[i] instanceof A.ParenthesizedExpression0) t1[i] = new A.SassString0("(" + t3.toString$0(0) + ")", false);
                    }
                    return new A.SassString0(B.JSArray_methods.join$1(t1, " "), false);
                }
                throw A.wrapException(_this._evaluate0$_exception$2(string$.This_e, node.get$span(node)));
            },
            _evaluate0$_checkWhitespaceAroundCalculationOperator$1: function(node) {
                var t2, t3, t4, textBetweenOperands, first, last, t1 = node.operator;
                if (t1 !== B.BinaryOperator_jCK0 && t1 !== B.BinaryOperator_tDf0) return;
                t1 = node.left;
                t2 = t1.get$span(t1);
                t2 = t2.get$file(t2);
                t3 = node.right;
                t4 = t3.get$span(t3);
                if (t2 !== t4.get$file(t4)) return;
                t2 = t1.get$span(t1);
                t2 = t2.get$end(t2);
                t4 = t3.get$span(t3);
                if (t2.offset >= t4.get$start(t4).offset) return;
                t2 = t1.get$span(t1);
                t2 = t2.get$file(t2);
                t1 = t1.get$span(t1);
                t1 = t1.get$end(t1);
                t3 = t3.get$span(t3);
                textBetweenOperands = A.String_String$fromCharCodes(B.NativeUint32List_methods.sublist$2(t2._decodedChars, t1.offset, t3.get$start(t3).offset), 0, null);
                first = textBetweenOperands.charCodeAt(0);
                last = textBetweenOperands.charCodeAt(textBetweenOperands.length - 1);
                if (first === 32 || first === 9 || first === 10 || first === 13 || first === 12 || first === 47) t1 = !(last === 32 || last === 9 || last === 10 || last === 13 || last === 12 || last === 47);
                else t1 = true;
                if (t1) throw A.wrapException(this._evaluate0$_exception$2(string$.x22x2b__an, node.get$operatorSpan()));
            },
            _evaluate0$_binaryOperatorToCalculationOperator$2: function(operator, node) {
                var t1;
                $label0$0: {
                    if (B.BinaryOperator_jCK0 === operator) {
                        t1 = B.CalculationOperator_dpX0;
                        break $label0$0;
                    }
                    if (B.BinaryOperator_tDf0 === operator) {
                        t1 = B.CalculationOperator_KrC0;
                        break $label0$0;
                    }
                    if (B.BinaryOperator_wkM0 === operator) {
                        t1 = B.CalculationOperator_LPB0;
                        break $label0$0;
                    }
                    if (B.BinaryOperator_ehp0 === operator) {
                        t1 = B.CalculationOperator_wFL0;
                        break $label0$0;
                    }
                    t1 = A.throwExpression(this._evaluate0$_exception$2(string$.This_o, node.get$operatorSpan()));
                }
                return t1;
            },
            _evaluate0$_checkAdjacentCalculationValues$2: function(elements, node) {
                var t1, i, t2, previous, current, previousNode, currentNode, _0_2;
                for(t1 = elements.length, i = 1; i < t1; ++i){
                    t2 = i - 1;
                    previous = elements[t2];
                    current = elements[i];
                    if (previous instanceof A.SassString0 || current instanceof A.SassString0) continue;
                    t1 = node.contents;
                    previousNode = t1[t2];
                    currentNode = t1[i];
                    if (currentNode instanceof A.UnaryOperationExpression0) {
                        _0_2 = currentNode.operator;
                        if (B.UnaryOperator_hCO0 !== _0_2) t1 = B.UnaryOperator_n2K0 === _0_2;
                        else t1 = true;
                    } else t1 = false;
                    if (!t1) t1 = currentNode instanceof A.NumberExpression0 && currentNode.value < 0;
                    else t1 = true;
                    if (t1) throw A.wrapException(this._evaluate0$_exception$2(string$.x22x2b__an, A.FileSpanExtension_subspan(currentNode.get$span(currentNode), 0, 1)));
                    else throw A.wrapException(this._evaluate0$_exception$2("Missing math operator.", previousNode.get$span(previousNode).expand$1(0, currentNode.get$span(currentNode))));
                }
            },
            visitInterpolatedFunctionExpression$1: function(_, node) {
                var result, _this = this, t1 = _this._evaluate0$_performInterpolation$1(node.name), oldInFunction = _this._evaluate0$_inFunction;
                _this._evaluate0$_inFunction = true;
                result = _this._evaluate0$_addErrorSpan$2(node, new A._EvaluateVisitor_visitInterpolatedFunctionExpression_closure1(_this, node, new A.PlainCssCallable0(t1)));
                _this._evaluate0$_inFunction = oldInFunction;
                return result;
            },
            _evaluate0$_runUserDefinedCallable$1$4: function($arguments, callable, nodeWithSpan, run, $V) {
                var oldInDependency, result, _this = this, evaluated = _this._evaluate0$_evaluateArguments$1($arguments), $name = callable.declaration.name;
                if ($name !== "@content") $name += "()";
                oldInDependency = _this._evaluate0$_inDependency;
                _this._evaluate0$_inDependency = callable.inDependency;
                result = _this._evaluate0$_withStackFrame$3($name, nodeWithSpan, new A._EvaluateVisitor__runUserDefinedCallable_closure1(_this, callable, evaluated, nodeWithSpan, run, $V));
                _this._evaluate0$_inDependency = oldInDependency;
                return result;
            },
            _evaluate0$_runFunctionCallable$3: function($arguments, callable, nodeWithSpan) {
                var buffer, first, argument, restArg, rest, error, t1, t2, _i, t3, t4, _$exception, _this = this;
                if (callable instanceof A.BuiltInCallable0) return _this._evaluate0$_withoutSlash$2(_this._evaluate0$_runBuiltInCallable$3($arguments, callable, nodeWithSpan), nodeWithSpan);
                else if (type$.UserDefinedCallable_Environment_2._is(callable)) return _this._evaluate0$_runUserDefinedCallable$1$4($arguments, callable, nodeWithSpan, new A._EvaluateVisitor__runFunctionCallable_closure1(_this, callable), type$.Value_2);
                else if (callable instanceof A.PlainCssCallable0) {
                    t1 = $arguments.named;
                    if (t1.get$isNotEmpty(t1) || $arguments.keywordRest != null) throw A.wrapException(_this._evaluate0$_exception$2(string$.Plain_, nodeWithSpan.get$span(nodeWithSpan)));
                    buffer = new A.StringBuffer(callable.name + "(");
                    try {
                        first = true;
                        for(t1 = $arguments.positional, t2 = t1.length, _i = 0; _i < t2; ++_i){
                            argument = t1[_i];
                            if (first) first = false;
                            else buffer._contents += ", ";
                            t3 = buffer;
                            t4 = argument;
                            t4 = _this._evaluate0$_serialize$3$quote(t4.accept$1(_this), t4, true);
                            t3._contents += t4;
                        }
                        restArg = $arguments.rest;
                        if (restArg != null) {
                            rest = restArg.accept$1(_this);
                            if (!first) buffer._contents += ", ";
                            t1 = buffer;
                            t2 = _this._evaluate0$_serialize$2(rest, restArg);
                            t1._contents += t2;
                        }
                    } catch (exception) {
                        t1 = A.unwrapException(exception);
                        if (type$.SassRuntimeException_2._is(t1)) {
                            error = t1;
                            if (!B.JSString_methods.endsWith$1(error._span_exception$_message, "isn't a valid CSS value.")) throw exception;
                            throw A.wrapException(A.MultiSpanSassRuntimeException$0(error._span_exception$_message, J.get$span$x(error), "value", A.LinkedHashMap_LinkedHashMap$_literal([
                                nodeWithSpan.get$span(nodeWithSpan),
                                "unknown function treated as plain CSS"
                            ], type$.FileSpan, type$.String), J.get$trace$z(error), null));
                        } else throw exception;
                    }
                    t1 = buffer;
                    t2 = A.Primitives_stringFromCharCode(41);
                    t1._contents += t2;
                    t2 = buffer._contents;
                    return new A.SassString0(t2.charCodeAt(0) == 0 ? t2 : t2, false);
                } else throw A.wrapException(A.ArgumentError$("Unknown callable type " + J.get$runtimeType$(callable).toString$0(0) + ".", null));
            },
            _evaluate0$_runBuiltInCallable$3: function($arguments, callable, nodeWithSpan) {
                var result, error, stackTrace, namedSet, _0_0, parameters, i, t1, parameter, t2, t3, rest, argumentList, _$exception, _this = this, _box_0 = {}, evaluated = _this._evaluate0$_evaluateArguments$1($arguments), oldCallableNode = _this._evaluate0$_callableNode;
                _this._evaluate0$_callableNode = nodeWithSpan;
                namedSet = new A.MapKeySet(evaluated._values[0], type$.MapKeySet_String);
                _box_0.callback = _box_0.overload = null;
                _0_0 = callable.callbackFor$2(evaluated._values[2].length, namedSet);
                _box_0.overload = _0_0._0;
                _box_0.callback = _0_0._1;
                _this._evaluate0$_addExceptionSpan$2(nodeWithSpan, new A._EvaluateVisitor__runBuiltInCallable_closure5(_box_0, evaluated, namedSet));
                parameters = _box_0.overload.parameters;
                for(i = evaluated._values[2].length, t1 = parameters.length; i < t1; ++i){
                    parameter = parameters[i];
                    t2 = evaluated._values[2];
                    t3 = evaluated._values[0].remove$1(0, parameter.name);
                    if (t3 == null) {
                        t3 = parameter.defaultValue;
                        t3 = _this._evaluate0$_withoutSlash$2(t3.accept$1(_this), t3);
                    }
                    t2.push(t3);
                }
                if (_box_0.overload.restParameter != null) {
                    if (evaluated._values[2].length > t1) {
                        rest = B.JSArray_methods.sublist$1(evaluated._values[2], t1);
                        B.JSArray_methods.removeRange$2(evaluated._values[2], t1, evaluated._values[2].length);
                    } else rest = B.List_empty23;
                    t1 = evaluated._values[0];
                    argumentList = A.SassArgumentList$0(rest, t1, evaluated._values[4] === B.ListSeparator_undecided_null_3_undecided0 ? B.ListSeparator_z0K0 : evaluated._values[4]);
                    evaluated._values[2].push(argumentList);
                } else argumentList = null;
                result = null;
                try {
                    result = _this._evaluate0$_addExceptionSpan$2(nodeWithSpan, new A._EvaluateVisitor__runBuiltInCallable_closure6(_box_0, evaluated));
                } catch (exception) {
                    t1 = A.unwrapException(exception);
                    if (t1 instanceof A.SassException0) throw exception;
                    else {
                        error = t1;
                        stackTrace = A.getTraceFromException(exception);
                        A.throwWithTrace0(_this._evaluate0$_exception$2(_this._evaluate0$_getErrorMessage$1(error), nodeWithSpan.get$span(nodeWithSpan)), error, stackTrace);
                    }
                }
                _this._evaluate0$_callableNode = oldCallableNode;
                if (argumentList == null) return result;
                if (evaluated._values[0].__js_helper$_length === 0) return result;
                if (argumentList._argument_list$_wereKeywordsAccessed) return result;
                throw A.wrapException(A.MultiSpanSassRuntimeException$0("No " + A.pluralize0("parameter", evaluated._values[0].get$keys(0).get$length(0), null) + " named " + A.toSentence0(evaluated._values[0].get$keys(0).map$1$1(0, new A._EvaluateVisitor__runBuiltInCallable_closure7(), type$.Object), "or") + ".", nodeWithSpan.get$span(nodeWithSpan), "invocation", A.LinkedHashMap_LinkedHashMap$_literal([
                    _box_0.overload.get$spanWithName(),
                    "declaration"
                ], type$.FileSpan, type$.String), _this._evaluate0$_stackTrace$1(nodeWithSpan.get$span(nodeWithSpan)), null));
            },
            _evaluate0$_evaluateArguments$1: function($arguments) {
                var t1, t2, _i, expression, nodeForSpan, named, namedNodes, t3, t4, $name, value, restArgs, rest, restNodeForSpan, t5, separator, keywordRestArgs, keywordRest, keywordRestNodeForSpan, _this = this, positional = A._setArrayType([], type$.JSArray_Value_2), positionalNodes = A._setArrayType([], type$.JSArray_AstNode_2);
                for(t1 = $arguments.positional, t2 = t1.length, _i = 0; _i < t2; ++_i){
                    expression = t1[_i];
                    nodeForSpan = _this._evaluate0$_expressionNode$1(expression);
                    positional.push(_this._evaluate0$_withoutSlash$2(expression.accept$1(_this), nodeForSpan));
                    positionalNodes.push(nodeForSpan);
                }
                t1 = type$.String;
                named = A.LinkedHashMap_LinkedHashMap$_empty(t1, type$.Value_2);
                t2 = type$.AstNode_2;
                namedNodes = A.LinkedHashMap_LinkedHashMap$_empty(t1, t2);
                for(t3 = A.MapExtensions_get_pairs0($arguments.named, t1, type$.Expression_2), t3 = t3.get$iterator(t3); t3.moveNext$0();){
                    t4 = t3.get$current(t3);
                    $name = t4._0;
                    value = t4._1;
                    nodeForSpan = _this._evaluate0$_expressionNode$1(value);
                    named.$indexSet(0, $name, _this._evaluate0$_withoutSlash$2(value.accept$1(_this), nodeForSpan));
                    namedNodes.$indexSet(0, $name, nodeForSpan);
                }
                restArgs = $arguments.rest;
                if (restArgs == null) return new A._Record_5_named_namedNodes_positional_positionalNodes_separator([
                    named,
                    namedNodes,
                    positional,
                    positionalNodes,
                    B.ListSeparator_undecided_null_3_undecided0
                ]);
                rest = restArgs.accept$1(_this);
                restNodeForSpan = _this._evaluate0$_expressionNode$1(restArgs);
                if (rest instanceof A.SassMap0) {
                    _this._evaluate0$_addRestMap$4(named, rest, restArgs, new A._EvaluateVisitor__evaluateArguments_closure7());
                    t3 = A.LinkedHashMap_LinkedHashMap$_empty(t1, t2);
                    for(t4 = rest._map0$_contents, t4 = t4.get$keys(t4), t4 = t4.get$iterator(t4), t5 = type$.SassString_2; t4.moveNext$0();)t3.$indexSet(0, t5._as(t4.get$current(t4))._string0$_text, restNodeForSpan);
                    namedNodes.addAll$1(0, t3);
                    separator = B.ListSeparator_undecided_null_3_undecided0;
                } else if (rest instanceof A.SassList0) {
                    t3 = rest._list1$_contents;
                    B.JSArray_methods.addAll$1(positional, new A.MappedListIterable(t3, new A._EvaluateVisitor__evaluateArguments_closure8(_this, restNodeForSpan), A._arrayInstanceType(t3)._eval$1("MappedListIterable<1,Value0>")));
                    B.JSArray_methods.addAll$1(positionalNodes, A.List_List$filled(t3.length, restNodeForSpan, false, t2));
                    separator = rest._list1$_separator;
                    if (rest instanceof A.SassArgumentList0) {
                        rest._argument_list$_wereKeywordsAccessed = true;
                        rest._argument_list$_keywords.forEach$1(0, new A._EvaluateVisitor__evaluateArguments_closure9(_this, named, restNodeForSpan, namedNodes));
                    }
                } else {
                    positional.push(_this._evaluate0$_withoutSlash$2(rest, restNodeForSpan));
                    positionalNodes.push(restNodeForSpan);
                    separator = B.ListSeparator_undecided_null_3_undecided0;
                }
                keywordRestArgs = $arguments.keywordRest;
                if (keywordRestArgs == null) return new A._Record_5_named_namedNodes_positional_positionalNodes_separator([
                    named,
                    namedNodes,
                    positional,
                    positionalNodes,
                    separator
                ]);
                keywordRest = keywordRestArgs.accept$1(_this);
                keywordRestNodeForSpan = _this._evaluate0$_expressionNode$1(keywordRestArgs);
                if (keywordRest instanceof A.SassMap0) {
                    _this._evaluate0$_addRestMap$4(named, keywordRest, keywordRestArgs, new A._EvaluateVisitor__evaluateArguments_closure10());
                    t1 = A.LinkedHashMap_LinkedHashMap$_empty(t1, t2);
                    for(t2 = keywordRest._map0$_contents, t2 = t2.get$keys(t2), t2 = t2.get$iterator(t2), t3 = type$.SassString_2; t2.moveNext$0();)t1.$indexSet(0, t3._as(t2.get$current(t2))._string0$_text, keywordRestNodeForSpan);
                    namedNodes.addAll$1(0, t1);
                    return new A._Record_5_named_namedNodes_positional_positionalNodes_separator([
                        named,
                        namedNodes,
                        positional,
                        positionalNodes,
                        separator
                    ]);
                } else throw A.wrapException(_this._evaluate0$_exception$2(string$.Variabs + keywordRest.toString$0(0) + ").", keywordRestArgs.get$span(keywordRestArgs)));
            },
            _evaluate0$_evaluateMacroArguments$1: function(invocation) {
                var t2, positional, named, rest, restNodeForSpan, keywordRestArgs_, keywordRest, keywordRestNodeForSpan, _this = this, t1 = invocation.$arguments, restArgs_ = t1.rest;
                if (restArgs_ == null) return new A._Record_2(t1.positional, t1.named);
                t2 = t1.positional;
                positional = A._setArrayType(t2.slice(0), A._arrayInstanceType(t2));
                named = A.LinkedHashMap_LinkedHashMap$of(t1.named, type$.String, type$.Expression_2);
                rest = restArgs_.accept$1(_this);
                restNodeForSpan = _this._evaluate0$_expressionNode$1(restArgs_);
                if (rest instanceof A.SassMap0) _this._evaluate0$_addRestMap$4(named, rest, invocation, new A._EvaluateVisitor__evaluateMacroArguments_closure7(restArgs_));
                else if (rest instanceof A.SassList0) {
                    t2 = rest._list1$_contents;
                    B.JSArray_methods.addAll$1(positional, new A.MappedListIterable(t2, new A._EvaluateVisitor__evaluateMacroArguments_closure8(_this, restNodeForSpan, restArgs_), A._arrayInstanceType(t2)._eval$1("MappedListIterable<1,Expression0>")));
                    if (rest instanceof A.SassArgumentList0) {
                        rest._argument_list$_wereKeywordsAccessed = true;
                        rest._argument_list$_keywords.forEach$1(0, new A._EvaluateVisitor__evaluateMacroArguments_closure9(_this, named, restNodeForSpan, restArgs_));
                    }
                } else positional.push(new A.ValueExpression0(_this._evaluate0$_withoutSlash$2(rest, restNodeForSpan), restArgs_.get$span(restArgs_)));
                keywordRestArgs_ = t1.keywordRest;
                if (keywordRestArgs_ == null) return new A._Record_2(positional, named);
                keywordRest = keywordRestArgs_.accept$1(_this);
                keywordRestNodeForSpan = _this._evaluate0$_expressionNode$1(keywordRestArgs_);
                if (keywordRest instanceof A.SassMap0) {
                    _this._evaluate0$_addRestMap$4(named, keywordRest, invocation, new A._EvaluateVisitor__evaluateMacroArguments_closure10(_this, keywordRestNodeForSpan, keywordRestArgs_));
                    return new A._Record_2(positional, named);
                } else throw A.wrapException(_this._evaluate0$_exception$2(string$.Variabs + keywordRest.toString$0(0) + ").", keywordRestArgs_.get$span(keywordRestArgs_)));
            },
            _evaluate0$_addRestMap$1$4: function(values, map, nodeWithSpan, convert) {
                map._map0$_contents.forEach$1(0, new A._EvaluateVisitor__addRestMap_closure1(this, values, convert, this._evaluate0$_expressionNode$1(nodeWithSpan), map, nodeWithSpan));
            },
            _evaluate0$_addRestMap$4: function(values, map, nodeWithSpan, convert) {
                return this._evaluate0$_addRestMap$1$4(values, map, nodeWithSpan, convert, type$.dynamic);
            },
            _evaluate0$_verifyArguments$4: function(positional, named, parameters, nodeWithSpan) {
                return this._evaluate0$_addExceptionSpan$2(nodeWithSpan, new A._EvaluateVisitor__verifyArguments_closure1(parameters, positional, named));
            },
            visitSelectorExpression$1: function(_, node) {
                var t1 = this._evaluate0$_styleRuleIgnoringAtRoot;
                t1 = t1 == null ? null : t1.originalSelector.get$asSassList();
                return t1 == null ? B.C__SassNull0 : t1;
            },
            visitStringExpression$1: function(_, node) {
                var t1, t2, t3, _i, value, t4, _0_0, text, _this = this, oldInSupportsDeclaration = _this._evaluate0$_inSupportsDeclaration;
                _this._evaluate0$_inSupportsDeclaration = false;
                t1 = A._setArrayType([], type$.JSArray_String);
                for(t2 = node.text.contents, t3 = t2.length, _i = 0; _i < t3; ++_i){
                    value = t2[_i];
                    $label0$0: {
                        if (typeof value == "string") {
                            t4 = value;
                            break $label0$0;
                        }
                        if (value instanceof A.Expression0) {
                            _0_0 = value.accept$1(_this);
                            $label1$1: {
                                if (_0_0 instanceof A.SassString0) {
                                    text = _0_0._string0$_text;
                                    t4 = text;
                                    break $label1$1;
                                }
                                t4 = _this._evaluate0$_serialize$3$quote(_0_0, value, false);
                                break $label1$1;
                            }
                            break $label0$0;
                        }
                        t4 = A.throwExpression(A.UnsupportedError$("Unknown interpolation value " + A.S(value)));
                    }
                    t1.push(t4);
                }
                t1 = B.JSArray_methods.join$0(t1);
                _this._evaluate0$_inSupportsDeclaration = oldInSupportsDeclaration;
                return new A.SassString0(t1, node.hasQuotes);
            },
            visitSupportsExpression$1: function(_, expression) {
                return new A.SassString0(this._evaluate0$_visitSupportsCondition$1(expression.condition), false);
            },
            visitCssAtRule$1: function(node) {
                var wasInKeyframes, wasInUnknownAtRule, t1, rule, _this = this;
                if (_this._evaluate0$_declarationName != null) throw A.wrapException(_this._evaluate0$_exception$2(string$.At_rul, node.span));
                if (node.isChildless) {
                    _this._evaluate0$_copyParentAfterSibling$0();
                    _this._evaluate0$_assertInModule$2(_this._evaluate0$__parent, "__parent").addChild$1(A.ModifiableCssAtRule$0(node.name, node.span, true, node.value));
                    return;
                }
                wasInKeyframes = _this._evaluate0$_inKeyframes;
                wasInUnknownAtRule = _this._evaluate0$_inUnknownAtRule;
                t1 = node.name;
                if (A.unvendor0(t1.value) === "keyframes") _this._evaluate0$_inKeyframes = true;
                else _this._evaluate0$_inUnknownAtRule = true;
                rule = A.ModifiableCssAtRule$0(t1, node.span, false, node.value);
                if (_this.get$_evaluate0$_hasCssNesting()) {
                    _this._evaluate0$_withParent$2$3$scopeWhen(rule, new A._EvaluateVisitor_visitCssAtRule_closure5(_this, node), false, type$.ModifiableCssAtRule_2, type$.Null);
                    _this._evaluate0$_inUnknownAtRule = wasInUnknownAtRule;
                    _this._evaluate0$_inKeyframes = wasInKeyframes;
                    return;
                }
                _this._evaluate0$_withParent$2$4$scopeWhen$through(rule, new A._EvaluateVisitor_visitCssAtRule_closure6(_this, node), false, new A._EvaluateVisitor_visitCssAtRule_closure7(), type$.ModifiableCssAtRule_2, type$.Null);
                _this._evaluate0$_inUnknownAtRule = wasInUnknownAtRule;
                _this._evaluate0$_inKeyframes = wasInKeyframes;
            },
            visitCssComment$1: function(node) {
                var _this = this, _s8_ = "__parent", _s13_ = "_endOfImports";
                if (_this._evaluate0$_assertInModule$2(_this._evaluate0$__parent, _s8_) === _this._evaluate0$_assertInModule$2(_this._evaluate0$__root, "_root") && _this._evaluate0$_assertInModule$2(_this._evaluate0$__endOfImports, _s13_) === J.get$length$asx(_this._evaluate0$_assertInModule$2(_this._evaluate0$__root, "_root").children._collection$_source)) _this._evaluate0$__endOfImports = _this._evaluate0$_assertInModule$2(_this._evaluate0$__endOfImports, _s13_) + 1;
                _this._evaluate0$_copyParentAfterSibling$0();
                _this._evaluate0$_assertInModule$2(_this._evaluate0$__parent, _s8_).addChild$1(new A.ModifiableCssComment0(node.text, node.span));
            },
            visitCssDeclaration$1: function(node) {
                this._evaluate0$_copyParentAfterSibling$0();
                this._evaluate0$_assertInModule$2(this._evaluate0$__parent, "__parent").addChild$1(A.ModifiableCssDeclaration$0(node.name, node.value, node.span, node.parsedAsSassScript, node.valueSpanForMap));
            },
            visitCssImport$1: function(node) {
                var t1, _this = this, _s8_ = "__parent", _s5_ = "_root", _s13_ = "_endOfImports", modifiableNode = new A.ModifiableCssImport0(node.url, node.modifiers, node.span);
                if (_this._evaluate0$_assertInModule$2(_this._evaluate0$__parent, _s8_) !== _this._evaluate0$_assertInModule$2(_this._evaluate0$__root, _s5_)) {
                    _this._evaluate0$_copyParentAfterSibling$0();
                    _this._evaluate0$_assertInModule$2(_this._evaluate0$__parent, _s8_).addChild$1(modifiableNode);
                } else if (_this._evaluate0$_assertInModule$2(_this._evaluate0$__endOfImports, _s13_) === J.get$length$asx(_this._evaluate0$_assertInModule$2(_this._evaluate0$__root, _s5_).children._collection$_source)) {
                    _this._evaluate0$_assertInModule$2(_this._evaluate0$__root, _s5_).addChild$1(modifiableNode);
                    _this._evaluate0$__endOfImports = _this._evaluate0$_assertInModule$2(_this._evaluate0$__endOfImports, _s13_) + 1;
                } else {
                    t1 = _this._evaluate0$_outOfOrderImports;
                    (t1 == null ? _this._evaluate0$_outOfOrderImports = A._setArrayType([], type$.JSArray_ModifiableCssImport_2) : t1).push(modifiableNode);
                }
            },
            visitCssKeyframeBlock$1: function(node) {
                this._evaluate0$_withParent$2$4$scopeWhen$through(A.ModifiableCssKeyframeBlock$0(node.selector, node.span), new A._EvaluateVisitor_visitCssKeyframeBlock_closure3(this, node), false, new A._EvaluateVisitor_visitCssKeyframeBlock_closure4(), type$.ModifiableCssKeyframeBlock_2, type$.Null);
            },
            visitCssMediaRule$1: function(node) {
                var mergedQueries, t1, mergedSources, t2, t3, _this = this;
                if (_this._evaluate0$_declarationName != null) throw A.wrapException(_this._evaluate0$_exception$2(string$.Media_, node.span));
                if (_this.get$_evaluate0$_hasCssNesting()) {
                    _this._evaluate0$_withParent$2$3$scopeWhen(A.ModifiableCssMediaRule$0(node.queries, node.span), new A._EvaluateVisitor_visitCssMediaRule_closure7(_this, node), false, type$.ModifiableCssMediaRule_2, type$.Null);
                    return;
                }
                mergedQueries = A.NullableExtension_andThen0(_this._evaluate0$_mediaQueries, new A._EvaluateVisitor_visitCssMediaRule_closure8(_this, node));
                t1 = mergedQueries == null;
                if (!t1 && J.get$isEmpty$asx(mergedQueries)) return;
                if (t1) mergedSources = B.Set_empty6;
                else {
                    t2 = _this._evaluate0$_mediaQuerySources;
                    t2.toString;
                    t2 = A.LinkedHashSet_LinkedHashSet$of(t2, type$.CssMediaQuery_2);
                    t3 = _this._evaluate0$_mediaQueries;
                    t3.toString;
                    t2.addAll$1(0, t3);
                    t2.addAll$1(0, node.queries);
                    mergedSources = t2;
                }
                t1 = t1 ? node.queries : mergedQueries;
                _this._evaluate0$_withParent$2$4$scopeWhen$through(A.ModifiableCssMediaRule$0(t1, node.span), new A._EvaluateVisitor_visitCssMediaRule_closure9(_this, mergedQueries, node, mergedSources), false, new A._EvaluateVisitor_visitCssMediaRule_closure10(mergedSources), type$.ModifiableCssMediaRule_2, type$.Null);
            },
            visitCssStyleRule$1: function(node) {
                var t1, styleRule, _0_0, t2, t3, originalSelector, rule, oldAtRootExcludingStyleRule, _1_1, lastChild, _this = this, _null = null, _s8_ = "__parent";
                if (_this._evaluate0$_declarationName != null) throw A.wrapException(_this._evaluate0$_exception$2(string$.Style_n, node.span));
                else if (_this._evaluate0$_inKeyframes && _this._evaluate0$_assertInModule$2(_this._evaluate0$__parent, _s8_) instanceof A.ModifiableCssKeyframeBlock0) throw A.wrapException(_this._evaluate0$_exception$2(string$.Style_k, node.span));
                t1 = _this._evaluate0$_atRootExcludingStyleRule;
                styleRule = t1 ? _null : _this._evaluate0$_styleRuleIgnoringAtRoot;
                _0_0 = t1 ? _null : _this._evaluate0$_styleRuleIgnoringAtRoot;
                $label0$0: {
                    if (_0_0 == null) {
                        t1 = true;
                        break $label0$0;
                    }
                    if (_0_0.fromPlainCss) {
                        t1 = false;
                        break $label0$0;
                    }
                    t1 = !(node.fromPlainCss && node._style_rule0$_selector._box0$_inner.value.accept$1(B.C__ContainsParentSelectorVisitor0));
                    break $label0$0;
                }
                t2 = node._style_rule0$_selector._box0$_inner;
                if (t1) {
                    t2 = t2.value;
                    t3 = styleRule == null ? _null : styleRule.originalSelector;
                    originalSelector = t2.nestWithin$3$implicitParent$preserveParentSelectors(t3, !_this._evaluate0$_atRootExcludingStyleRule, node.fromPlainCss);
                } else originalSelector = t2.value;
                rule = A.ModifiableCssStyleRule$0(_this._evaluate0$_assertInModule$2(_this._evaluate0$__extensionStore, "_extensionStore").addSelector$2(originalSelector, _this._evaluate0$_mediaQueries), node.span, node.fromPlainCss, originalSelector);
                oldAtRootExcludingStyleRule = _this._evaluate0$_atRootExcludingStyleRule;
                _this._evaluate0$_atRootExcludingStyleRule = false;
                t1 = t1 ? new A._EvaluateVisitor_visitCssStyleRule_closure3() : _null;
                _this._evaluate0$_withParent$2$4$scopeWhen$through(rule, new A._EvaluateVisitor_visitCssStyleRule_closure4(_this, rule, node), false, t1, type$.ModifiableCssStyleRule_2, type$.Null);
                _this._evaluate0$_atRootExcludingStyleRule = oldAtRootExcludingStyleRule;
                t1 = _this._evaluate0$_assertInModule$2(_this._evaluate0$__parent, _s8_).children._collection$_source;
                t2 = J.getInterceptor$asx(t1);
                _1_1 = t2.get$length(t1);
                if (_1_1 >= 1) {
                    lastChild = t2.elementAt$1(t1, _1_1 - 1);
                    t1 = styleRule == null;
                } else {
                    lastChild = _null;
                    t1 = false;
                }
                if (t1) lastChild.isGroupEnd = true;
            },
            visitCssStylesheet$1: function(node) {
                var t1;
                for(t1 = J.get$iterator$ax(node.get$children(node)); t1.moveNext$0();)t1.get$current(t1).accept$1(this);
            },
            visitCssSupportsRule$1: function(node) {
                var rule, _this = this;
                if (_this._evaluate0$_declarationName != null) throw A.wrapException(_this._evaluate0$_exception$2(string$.Suppor, node.span));
                rule = A.ModifiableCssSupportsRule$0(node.condition, node.span);
                if (_this.get$_evaluate0$_hasCssNesting()) {
                    _this._evaluate0$_withParent$2$3$scopeWhen(rule, new A._EvaluateVisitor_visitCssSupportsRule_closure5(_this, node), false, type$.ModifiableCssSupportsRule_2, type$.Null);
                    return;
                }
                _this._evaluate0$_withParent$2$4$scopeWhen$through(rule, new A._EvaluateVisitor_visitCssSupportsRule_closure6(_this, node), false, new A._EvaluateVisitor_visitCssSupportsRule_closure7(), type$.ModifiableCssSupportsRule_2, type$.Null);
            },
            _evaluate0$_handleReturn$1$2: function(list, callback) {
                var t1, _i, _0_0;
                for(t1 = list.length, _i = 0; _i < list.length; list.length === t1 || (0, A.throwConcurrentModificationError)(list), ++_i){
                    _0_0 = callback.call$1(list[_i]);
                    if (_0_0 != null) return _0_0;
                }
                return null;
            },
            _evaluate0$_handleReturn$2: function(list, callback) {
                return this._evaluate0$_handleReturn$1$2(list, callback, type$.dynamic);
            },
            _evaluate0$_withEnvironment$1$2: function(environment, callback) {
                var result, oldEnvironment = this._evaluate0$_environment;
                this._evaluate0$_environment = environment;
                result = callback.call$0();
                this._evaluate0$_environment = oldEnvironment;
                return result;
            },
            _evaluate0$_withEnvironment$2: function(environment, callback) {
                return this._evaluate0$_withEnvironment$1$2(environment, callback, type$.dynamic);
            },
            _evaluate0$_interpolationToValue$3$trim$warnForColor: function(interpolation, trim, warnForColor) {
                var result = this._evaluate0$_performInterpolation$2$warnForColor(interpolation, warnForColor), t1 = trim ? A.trimAscii0(result, true) : result;
                return new A.CssValue0(t1, interpolation.span, type$.CssValue_String_2);
            },
            _evaluate0$_interpolationToValue$1: function(interpolation) {
                return this._evaluate0$_interpolationToValue$3$trim$warnForColor(interpolation, false, false);
            },
            _evaluate0$_interpolationToValue$2$warnForColor: function(interpolation, warnForColor) {
                return this._evaluate0$_interpolationToValue$3$trim$warnForColor(interpolation, false, warnForColor);
            },
            _evaluate0$_performInterpolation$2$warnForColor: function(interpolation, warnForColor) {
                return this._evaluate0$_performInterpolationHelper$3$sourceMap$warnForColor(interpolation, false, warnForColor)._0;
            },
            _evaluate0$_performInterpolation$1: function(interpolation) {
                return this._evaluate0$_performInterpolation$2$warnForColor(interpolation, false);
            },
            _evaluate0$_performInterpolationWithMap$2$warnForColor: function(interpolation, warnForColor) {
                var _0_0 = this._evaluate0$_performInterpolationHelper$3$sourceMap$warnForColor(interpolation, true, true), map = _0_0._1;
                map.toString;
                return new A._Record_2(_0_0._0, map);
            },
            _evaluate0$_performInterpolationHelper$3$sourceMap$warnForColor: function(interpolation, sourceMap, warnForColor) {
                var t1, t2, t3, t4, t5, t6, first, _i, t7, value, result, result0, t8, _this = this, targetOffsets = sourceMap ? A._setArrayType([], type$.JSArray_int) : null, oldInSupportsDeclaration = _this._evaluate0$_inSupportsDeclaration;
                _this._evaluate0$_inSupportsDeclaration = false;
                for(t1 = interpolation.contents, t2 = t1.length, t3 = type$.Expression_2, t4 = targetOffsets == null, t5 = interpolation.span, t6 = type$.Object, first = true, _i = 0, t7 = ""; _i < t2; ++_i, first = false){
                    value = t1[_i];
                    if (!first) {
                        if (!t4) targetOffsets.push(t7.length);
                    }
                    if (typeof value == "string") {
                        t7 += value;
                        continue;
                    }
                    t3._as(value);
                    result = value.accept$1(_this);
                    if (warnForColor && $.$get$namesByColor0().containsKey$1(result)) {
                        result0 = A.List_List$from([
                            ""
                        ], false, t6);
                        result0.$flags = 3;
                        t8 = $.$get$namesByColor0();
                        _this._evaluate0$_warn$2(string$.You_pr + A.S(t8.$index(0, result)) + string$.x20in_in + result.toString$0(0) + string$.x2c_whicw + A.S(t8.$index(0, result)) + string$.x22x29__If + new A.BinaryOperationExpression0(B.BinaryOperator_jCK0, new A.StringExpression0(new A.Interpolation0(result0, B.List_null, t5), true), value, false).toString$0(0) + "'.", value.get$span(value));
                    }
                    t7 += _this._evaluate0$_serialize$3$quote(result, value, false);
                }
                _this._evaluate0$_inSupportsDeclaration = oldInSupportsDeclaration;
                return new A._Record_2(t7.charCodeAt(0) == 0 ? t7 : t7, A.NullableExtension_andThen0(targetOffsets, new A._EvaluateVisitor__performInterpolationHelper_closure1(interpolation)));
            },
            _evaluate0$_serialize$3$quote: function(value, nodeWithSpan, quote) {
                return this._evaluate0$_addExceptionSpan$2(nodeWithSpan, new A._EvaluateVisitor__serialize_closure1(value, quote));
            },
            _evaluate0$_serialize$2: function(value, nodeWithSpan) {
                return this._evaluate0$_serialize$3$quote(value, nodeWithSpan, true);
            },
            _evaluate0$_expressionNode$1: function(expression) {
                var t1;
                if (expression instanceof A.VariableExpression0) {
                    t1 = this._evaluate0$_addExceptionSpan$2(expression, new A._EvaluateVisitor__expressionNode_closure1(this, expression));
                    return t1 == null ? expression : t1;
                } else return expression;
            },
            _evaluate0$_withParent$2$4$scopeWhen$through: function(node, callback, scopeWhen, through, $S, $T) {
                var oldParent, result, _this = this;
                _this._evaluate0$_addChild$2$through(node, through);
                oldParent = _this._evaluate0$_assertInModule$2(_this._evaluate0$__parent, "__parent");
                _this._evaluate0$__parent = node;
                result = _this._evaluate0$_environment.scope$1$2$when(callback, scopeWhen, $T);
                _this._evaluate0$__parent = oldParent;
                return result;
            },
            _evaluate0$_withParent$2$3$scopeWhen: function(node, callback, scopeWhen, $S, $T) {
                return this._evaluate0$_withParent$2$4$scopeWhen$through(node, callback, scopeWhen, null, $S, $T);
            },
            _evaluate0$_withParent$2$2: function(node, callback, $S, $T) {
                return this._evaluate0$_withParent$2$4$scopeWhen$through(node, callback, true, null, $S, $T);
            },
            _evaluate0$_copyParentAfterSibling$0: function() {
                var t1, grandparent, newParent, _this = this, _s8_ = "__parent", _0_0 = _this._evaluate0$_assertInModule$2(_this._evaluate0$__parent, _s8_)._node$_parent;
                if (_0_0 != null) {
                    t1 = _0_0.children;
                    t1 = t1.get$last(t1) !== _this._evaluate0$_assertInModule$2(_this._evaluate0$__parent, _s8_);
                    grandparent = _0_0;
                } else {
                    grandparent = null;
                    t1 = false;
                }
                if (t1) {
                    newParent = _this._evaluate0$_assertInModule$2(_this._evaluate0$__parent, _s8_).copyWithoutChildren$0();
                    grandparent.addChild$1(newParent);
                    _this._evaluate0$__parent = newParent;
                }
            },
            _evaluate0$_addChild$2$through: function(node, through) {
                var _0_0, grandparent, t1, $parent = this._evaluate0$_assertInModule$2(this._evaluate0$__parent, "__parent");
                if (through != null) {
                    for(; through.call$1($parent); $parent = _0_0){
                        _0_0 = $parent._node$_parent;
                        if (_0_0 == null) throw A.wrapException(A.ArgumentError$(string$.throug + node.toString$0(0) + ".", null));
                    }
                    if ($parent.get$hasFollowingSibling()) {
                        grandparent = $parent._node$_parent;
                        t1 = grandparent.children;
                        if ($parent.equalsIgnoringChildren$1(t1.get$last(t1))) $parent = type$.ModifiableCssParentNode_2._as(t1.get$last(t1));
                        else {
                            $parent = $parent.copyWithoutChildren$0();
                            grandparent.addChild$1($parent);
                        }
                    }
                }
                $parent.addChild$1(node);
            },
            _evaluate0$_addChild$1: function(node) {
                return this._evaluate0$_addChild$2$through(node, null);
            },
            _evaluate0$_withStyleRule$1$2: function(rule, callback) {
                var result, oldRule = this._evaluate0$_styleRuleIgnoringAtRoot;
                this._evaluate0$_styleRuleIgnoringAtRoot = rule;
                result = callback.call$0();
                this._evaluate0$_styleRuleIgnoringAtRoot = oldRule;
                return result;
            },
            _evaluate0$_withStyleRule$2: function(rule, callback) {
                return this._evaluate0$_withStyleRule$1$2(rule, callback, type$.dynamic);
            },
            _evaluate0$_withMediaQueries$1$3: function(queries, sources, callback) {
                var result, _this = this, oldMediaQueries = _this._evaluate0$_mediaQueries, oldSources = _this._evaluate0$_mediaQuerySources;
                _this._evaluate0$_mediaQueries = queries;
                _this._evaluate0$_mediaQuerySources = sources;
                result = callback.call$0();
                _this._evaluate0$_mediaQueries = oldMediaQueries;
                _this._evaluate0$_mediaQuerySources = oldSources;
                return result;
            },
            _evaluate0$_withMediaQueries$3: function(queries, sources, callback) {
                return this._evaluate0$_withMediaQueries$1$3(queries, sources, callback, type$.dynamic);
            },
            _evaluate0$_withStackFrame$1$3: function(member, nodeWithSpan, callback) {
                var oldMember, result, _this = this, t1 = _this._evaluate0$_stack;
                t1.push(new A._Record_2(_this._evaluate0$_member, nodeWithSpan));
                oldMember = _this._evaluate0$_member;
                _this._evaluate0$_member = member;
                result = callback.call$0();
                _this._evaluate0$_member = oldMember;
                t1.pop();
                return result;
            },
            _evaluate0$_withStackFrame$3: function(member, nodeWithSpan, callback) {
                return this._evaluate0$_withStackFrame$1$3(member, nodeWithSpan, callback, type$.dynamic);
            },
            _evaluate0$_withoutSlash$2: function(value, nodeForSpan) {
                var t1;
                if (value instanceof A.SassNumber0) t1 = value.asSlash != null;
                else t1 = false;
                if (t1) this._evaluate0$_warn$3(string$.Using__i + A.S(new A._EvaluateVisitor__withoutSlash_recommendation1().call$1(value)) + string$.x0a_Morex20, nodeForSpan.get$span(nodeForSpan), B.Deprecation_v81);
                return value.withoutSlash$0();
            },
            _evaluate0$_stackFrame$2: function(member, span) {
                return A.frameForSpan0(span, member, A.NullableExtension_andThen0(span.get$sourceUrl(span), new A._EvaluateVisitor__stackFrame_closure1(this)));
            },
            _evaluate0$_stackTrace$1: function(span) {
                var t2, t3, _i, t4, nodeWithSpan, _this = this, t1 = A._setArrayType([], type$.JSArray_Frame);
                for(t2 = _this._evaluate0$_stack, t3 = t2.length, _i = 0; _i < t2.length; t2.length === t3 || (0, A.throwConcurrentModificationError)(t2), ++_i){
                    t4 = t2[_i];
                    nodeWithSpan = t4._1;
                    t1.push(_this._evaluate0$_stackFrame$2(t4._0, nodeWithSpan.get$span(nodeWithSpan)));
                }
                if (span != null) t1.push(_this._evaluate0$_stackFrame$2(_this._evaluate0$_member, span));
                return A.Trace$(new A.ReversedListIterable(t1, type$.ReversedListIterable_Frame), null);
            },
            _evaluate0$_stackTrace$0: function() {
                return this._evaluate0$_stackTrace$1(null);
            },
            _evaluate0$_warn$3: function(message, span, deprecation) {
                var trace, t1, _this = this;
                if (_this._evaluate0$_quietDeps && _this._evaluate0$_inDependency) return;
                if (!_this._evaluate0$_warningsEmitted.add$1(0, new A._Record_2(message, span))) return;
                trace = _this._evaluate0$_stackTrace$1(span);
                t1 = _this._evaluate0$_logger;
                if (deprecation == null) t1.internalWarn$4$deprecation$span$trace(message, null, span, trace);
                else A.WarnForDeprecation_warnForDeprecation0(t1, deprecation, message, span, trace);
            },
            _evaluate0$_warn$2: function(message, span) {
                return this._evaluate0$_warn$3(message, span, null);
            },
            _evaluate0$_exception$2: function(message, span) {
                var t1, t2;
                if (span == null) {
                    t1 = B.JSArray_methods.get$last(this._evaluate0$_stack)._1;
                    t1 = t1.get$span(t1);
                } else t1 = span;
                t2 = this._evaluate0$_stackTrace$1(span);
                return new A.SassRuntimeException0(t2, B.Set_empty, message, t1);
            },
            _evaluate0$_exception$1: function(message) {
                return this._evaluate0$_exception$2(message, null);
            },
            _evaluate0$_multiSpanException$3: function(message, primaryLabel, secondaryLabels) {
                var t1 = B.JSArray_methods.get$last(this._evaluate0$_stack)._1;
                return A.MultiSpanSassRuntimeException$0(message, t1.get$span(t1), primaryLabel, secondaryLabels, this._evaluate0$_stackTrace$0(), null);
            },
            _evaluate0$_addExceptionSpan$1$3$addStackFrame: function(nodeWithSpan, callback, addStackFrame) {
                var error, stackTrace, t1, _$exception;
                try {
                    t1 = callback.call$0();
                    return t1;
                } catch (exception) {
                    t1 = A.unwrapException(exception);
                    if (t1 instanceof A.SassScriptException0) {
                        error = t1;
                        stackTrace = A.getTraceFromException(exception);
                        t1 = error.withSpan$1(nodeWithSpan.get$span(nodeWithSpan));
                        A.throwWithTrace0(t1.withTrace$1(this._evaluate0$_stackTrace$1(addStackFrame ? nodeWithSpan.get$span(nodeWithSpan) : null)), error, stackTrace);
                    } else throw exception;
                }
            },
            _evaluate0$_addExceptionSpan$2: function(nodeWithSpan, callback) {
                return this._evaluate0$_addExceptionSpan$1$3$addStackFrame(nodeWithSpan, callback, true, type$.dynamic);
            },
            _evaluate0$_addExceptionSpan$3$addStackFrame: function(nodeWithSpan, callback, addStackFrame) {
                return this._evaluate0$_addExceptionSpan$1$3$addStackFrame(nodeWithSpan, callback, addStackFrame, type$.dynamic);
            },
            _evaluate0$_addExceptionTrace$1$1: function(callback) {
                var error, stackTrace, t1, _$exception, t2;
                try {
                    t1 = callback.call$0();
                    return t1;
                } catch (exception) {
                    t1 = A.unwrapException(exception);
                    if (type$.SassRuntimeException_2._is(t1)) throw exception;
                    else if (t1 instanceof A.SassException0) {
                        error = t1;
                        stackTrace = A.getTraceFromException(exception);
                        t1 = error;
                        t2 = J.getInterceptor$x(t1);
                        A.throwWithTrace0(error.withTrace$1(this._evaluate0$_stackTrace$1(A.SourceSpanException.prototype.get$span.call(t2, t1))), error, stackTrace);
                    } else throw exception;
                }
            },
            _evaluate0$_addExceptionTrace$1: function(callback) {
                return this._evaluate0$_addExceptionTrace$1$1(callback, type$.dynamic);
            },
            _evaluate0$_addErrorSpan$1$2: function(nodeWithSpan, callback) {
                var error, stackTrace, t1, _$exception, t2, t3;
                try {
                    t1 = callback.call$0();
                    return t1;
                } catch (exception) {
                    t1 = A.unwrapException(exception);
                    if (type$.SassRuntimeException_2._is(t1)) {
                        error = t1;
                        stackTrace = A.getTraceFromException(exception);
                        if (!B.JSString_methods.startsWith$1(J.get$span$x(error).get$text(), "@error")) throw exception;
                        t1 = error._span_exception$_message;
                        t2 = nodeWithSpan.get$span(nodeWithSpan);
                        t3 = this._evaluate0$_stackTrace$0();
                        A.throwWithTrace0(new A.SassRuntimeException0(t3, B.Set_empty, t1, t2), error, stackTrace);
                    } else throw exception;
                }
            },
            _evaluate0$_addErrorSpan$2: function(nodeWithSpan, callback) {
                return this._evaluate0$_addErrorSpan$1$2(nodeWithSpan, callback, type$.dynamic);
            },
            _evaluate0$_getErrorMessage$1: function(error) {
                var t1, exception;
                if (type$.Error._is(error)) return error.toString$0(0);
                try {
                    t1 = A._asString(J.get$message$x(error));
                    return t1;
                } catch (exception) {
                    t1 = J.toString$0$(error);
                    return t1;
                }
            },
            $isExpressionVisitor: 1,
            $isIfConditionExpressionVisitor: 1,
            $isStatementVisitor: 1
        };
        A._EvaluateVisitor_closure25.prototype = {
            call$1: function($arguments) {
                var module, t2, t1 = J.getInterceptor$asx($arguments), variable = t1.$index($arguments, 0).assertString$1("name");
                t1 = t1.$index($arguments, 1).get$realNull();
                module = t1 == null ? null : t1.assertString$1("module");
                t1 = this.$this._evaluate0$_environment;
                t2 = A.stringReplaceAllUnchecked(variable._string0$_text, "_", "-");
                return t1.globalVariableExists$2$namespace(t2, module == null ? null : module._string0$_text) ? B.SassBoolean_true0 : B.SassBoolean_false0;
            },
            $signature: 13
        };
        A._EvaluateVisitor_closure26.prototype = {
            call$1: function($arguments) {
                var variable = J.$index$asx($arguments, 0).assertString$1("name"), t1 = this.$this._evaluate0$_environment;
                return t1.getVariable$1(A.stringReplaceAllUnchecked(variable._string0$_text, "_", "-")) != null ? B.SassBoolean_true0 : B.SassBoolean_false0;
            },
            $signature: 13
        };
        A._EvaluateVisitor_closure27.prototype = {
            call$1: function($arguments) {
                var module, t2, t3, t4, t1 = J.getInterceptor$asx($arguments), variable = t1.$index($arguments, 0).assertString$1("name");
                t1 = t1.$index($arguments, 1).get$realNull();
                module = t1 == null ? null : t1.assertString$1("module");
                t1 = this.$this;
                t2 = t1._evaluate0$_environment;
                t3 = variable._string0$_text;
                t4 = A.stringReplaceAllUnchecked(t3, "_", "-");
                return t2.getFunction$2$namespace(t4, module == null ? null : module._string0$_text) != null || t1._evaluate0$_builtInFunctions.containsKey$1(t3) ? B.SassBoolean_true0 : B.SassBoolean_false0;
            },
            $signature: 13
        };
        A._EvaluateVisitor_closure28.prototype = {
            call$1: function($arguments) {
                var module, t2, t1 = J.getInterceptor$asx($arguments), variable = t1.$index($arguments, 0).assertString$1("name");
                t1 = t1.$index($arguments, 1).get$realNull();
                module = t1 == null ? null : t1.assertString$1("module");
                t1 = this.$this._evaluate0$_environment;
                t2 = A.stringReplaceAllUnchecked(variable._string0$_text, "_", "-");
                return t1.getMixin$2$namespace(t2, module == null ? null : module._string0$_text) != null ? B.SassBoolean_true0 : B.SassBoolean_false0;
            },
            $signature: 13
        };
        A._EvaluateVisitor_closure29.prototype = {
            call$1: function($arguments) {
                var t1 = this.$this._evaluate0$_environment;
                if (!t1._environment0$_inMixin) throw A.wrapException(A.SassScriptException$0(string$.conten, null));
                return t1._environment0$_content != null ? B.SassBoolean_true0 : B.SassBoolean_false0;
            },
            $signature: 13
        };
        A._EvaluateVisitor_closure30.prototype = {
            call$1: function($arguments) {
                var t2, t3, t4, t1 = J.$index$asx($arguments, 0).assertString$1("module")._string0$_text, module = this.$this._evaluate0$_environment._environment0$_modules.$index(0, t1);
                if (module == null) throw A.wrapException('There is no module with namespace "' + t1 + '".');
                t1 = type$.Value_2;
                t2 = A.LinkedHashMap_LinkedHashMap$_empty(t1, t1);
                for(t3 = A.MapExtensions_get_pairs0(module.get$variables(), type$.String, t1), t3 = t3.get$iterator(t3); t3.moveNext$0();){
                    t4 = t3.get$current(t3);
                    t2.$indexSet(0, new A.SassString0(t4._0, true), t4._1);
                }
                return new A.SassMap0(A.ConstantMap_ConstantMap$from(t2, t1, t1));
            },
            $signature: 34
        };
        A._EvaluateVisitor_closure31.prototype = {
            call$1: function($arguments) {
                var t3, t4, t5, t1 = this.$this, t2 = J.$index$asx($arguments, 0).assertString$1("module")._string0$_text, module = t1._evaluate0$_environment._environment0$_modules.$index(0, t2);
                if (module == null) throw A.wrapException('There is no module with namespace "' + t2 + '".');
                t2 = type$.Value_2;
                t3 = A.LinkedHashMap_LinkedHashMap$_empty(t2, t2);
                for(t4 = A.MapExtensions_get_pairs0(module.get$functions(module), type$.String, type$.Callable_2), t4 = t4.get$iterator(t4), t1 = t1._evaluate0$_compileContext; t4.moveNext$0();){
                    t5 = t4.get$current(t4);
                    t3.$indexSet(0, new A.SassString0(t5._0, true), new A.SassFunction0(t5._1, t1));
                }
                return new A.SassMap0(A.ConstantMap_ConstantMap$from(t3, t2, t2));
            },
            $signature: 34
        };
        A._EvaluateVisitor_closure32.prototype = {
            call$1: function($arguments) {
                var t3, t4, t5, t1 = this.$this, t2 = J.$index$asx($arguments, 0).assertString$1("module")._string0$_text, module = t1._evaluate0$_environment._environment0$_modules.$index(0, t2);
                if (module == null) throw A.wrapException('There is no module with namespace "' + t2 + '".');
                t2 = type$.Value_2;
                t3 = A.LinkedHashMap_LinkedHashMap$_empty(t2, t2);
                for(t4 = A.MapExtensions_get_pairs0(module.get$mixins(), type$.String, type$.Callable_2), t4 = t4.get$iterator(t4), t1 = t1._evaluate0$_compileContext; t4.moveNext$0();){
                    t5 = t4.get$current(t4);
                    t3.$indexSet(0, new A.SassString0(t5._0, true), new A.SassMixin0(t5._1, t1));
                }
                return new A.SassMap0(A.ConstantMap_ConstantMap$from(t3, t2, t2));
            },
            $signature: 34
        };
        A._EvaluateVisitor_closure33.prototype = {
            call$1: function($arguments) {
                var module, t2, callable, t1 = J.getInterceptor$asx($arguments), $name = t1.$index($arguments, 0).assertString$1("name"), css = t1.$index($arguments, 1).get$isTruthy();
                t1 = t1.$index($arguments, 2).get$realNull();
                module = t1 == null ? null : t1.assertString$1("module");
                if (css) {
                    if (module != null) throw A.wrapException(string$.x24css_a);
                    return new A.SassFunction0(new A.PlainCssCallable0($name._string0$_text), this.$this._evaluate0$_compileContext);
                }
                t1 = this.$this;
                t2 = t1._evaluate0$_callableNode;
                t2.toString;
                callable = t1._evaluate0$_addExceptionSpan$2(t2, new A._EvaluateVisitor__closure10(t1, $name, module));
                if (callable == null) throw A.wrapException("Function not found: " + $name.toString$0(0));
                return new A.SassFunction0(callable, t1._evaluate0$_compileContext);
            },
            $signature: 207
        };
        A._EvaluateVisitor__closure10.prototype = {
            call$0: function() {
                var local, normalizedName = A.stringReplaceAllUnchecked(this.name._string0$_text, "_", "-"), t1 = this.module, namespace = t1 == null ? null : t1._string0$_text;
                t1 = this.$this;
                local = t1._evaluate0$_environment.getFunction$2$namespace(normalizedName, namespace);
                if (local != null || namespace != null) return local;
                return t1._evaluate0$_builtInFunctions.$index(0, normalizedName);
            },
            $signature: 88
        };
        A._EvaluateVisitor_closure34.prototype = {
            call$1: function($arguments) {
                var module, t2, callable, t1 = J.getInterceptor$asx($arguments), $name = t1.$index($arguments, 0).assertString$1("name");
                t1 = t1.$index($arguments, 1).get$realNull();
                module = t1 == null ? null : t1.assertString$1("module");
                t1 = this.$this;
                t2 = t1._evaluate0$_callableNode;
                t2.toString;
                callable = t1._evaluate0$_addExceptionSpan$2(t2, new A._EvaluateVisitor__closure9(t1, $name, module));
                if (callable == null) throw A.wrapException("Mixin not found: " + $name.toString$0(0));
                return new A.SassMixin0(callable, t1._evaluate0$_compileContext);
            },
            $signature: 208
        };
        A._EvaluateVisitor__closure9.prototype = {
            call$0: function() {
                var t1 = this.$this._evaluate0$_environment, t2 = A.stringReplaceAllUnchecked(this.name._string0$_text, "_", "-"), t3 = this.module;
                return t1.getMixin$2$namespace(t2, t3 == null ? null : t3._string0$_text);
            },
            $signature: 88
        };
        A._EvaluateVisitor_closure35.prototype = {
            call$1: function($arguments) {
                var callableNode, t2, t3, t4, t5, t6, t7, invocation, callable, t1 = J.getInterceptor$asx($arguments), $function = t1.$index($arguments, 0), args = type$.SassArgumentList_2._as(t1.$index($arguments, 1));
                t1 = this.$this;
                callableNode = t1._evaluate0$_callableNode;
                t2 = callableNode.get$span(callableNode);
                t3 = callableNode.get$span(callableNode);
                args._argument_list$_wereKeywordsAccessed = true;
                t4 = args._argument_list$_keywords;
                if (t4.get$isEmpty(t4)) t4 = null;
                else {
                    t5 = type$.Value_2;
                    t6 = A.LinkedHashMap_LinkedHashMap$_empty(t5, t5);
                    for(args._argument_list$_wereKeywordsAccessed = true, t4 = A.MapExtensions_get_pairs0(t4, type$.String, t5), t4 = t4.get$iterator(t4); t4.moveNext$0();){
                        t7 = t4.get$current(t4);
                        t6.$indexSet(0, new A.SassString0(t7._0, false), t7._1);
                    }
                    t4 = new A.ValueExpression0(new A.SassMap0(A.ConstantMap_ConstantMap$from(t6, t5, t5)), callableNode.get$span(callableNode));
                }
                invocation = A.ArgumentList$0(B.List_empty24, B.Map_empty14, B.Map_empty5, t2, t4, new A.ValueExpression0(args, t3));
                if ($function instanceof A.SassString0) {
                    A.warnForDeprecation0(string$.Passina + $function.toString$0(0) + "))", B.Deprecation_LIY);
                    callableNode = t1._evaluate0$_callableNode;
                    t2 = $function._string0$_text;
                    t3 = callableNode.get$span(callableNode);
                    return t1.visitFunctionExpression$1(0, new A.FunctionExpression0(null, A.stringReplaceAllUnchecked(t2, "_", "-"), t2, invocation, t3));
                }
                callable = $function.assertFunction$1("function").assertCompileContext$1(t1._evaluate0$_compileContext).callable;
                if (type$.Callable_2._is(callable)) {
                    t2 = t1._evaluate0$_callableNode;
                    t2.toString;
                    return t1._evaluate0$_runFunctionCallable$3(invocation, callable, t2);
                } else throw A.wrapException(A.SassScriptException$0("The function " + callable.get$name(callable) + string$.x20is_as, null));
            },
            $signature: 3
        };
        A._EvaluateVisitor_closure36.prototype = {
            call$1: function($arguments) {
                var withMap, t2, t3, values, span, configuration, t1 = J.getInterceptor$asx($arguments), url = A.Uri_parse(t1.$index($arguments, 0).assertString$1("url")._string0$_text);
                t1 = t1.$index($arguments, 1).get$realNull();
                withMap = t1 == null ? null : t1.assertMap$1("with")._map0$_contents;
                t1 = this.$this;
                t2 = t1._evaluate0$_callableNode;
                t2.toString;
                if (withMap != null) {
                    t3 = {};
                    values = A.LinkedHashMap_LinkedHashMap$_empty(type$.String, type$.ConfiguredValue_2);
                    span = t2.get$span(t2);
                    t3.privateDeprecation = false;
                    withMap.forEach$1(0, new A._EvaluateVisitor__closure7(t3, values, span, t2));
                    configuration = new A.ExplicitConfiguration0(t2, values, null);
                } else configuration = B.Configuration_Map_empty_null0;
                t3 = t2.get$span(t2);
                t1._evaluate0$_loadModule$7$baseUrl$configuration$namesInErrors(url, "load-css()", t2, new A._EvaluateVisitor__closure8(t1), t3.get$sourceUrl(t3), configuration, true);
                t1._evaluate0$_assertConfigurationIsEmpty$2$nameInError(configuration, true);
            },
            $signature: 241
        };
        A._EvaluateVisitor__closure7.prototype = {
            call$2: function(variable, value) {
                var _this = this, t1 = variable.assertString$1("with key"), $name = A.stringReplaceAllUnchecked(t1._string0$_text, "_", "-");
                t1 = _this.values;
                if (t1.containsKey$1($name)) throw A.wrapException("The variable $" + $name + " was configured twice.");
                else if (B.JSString_methods.startsWith$1($name, "-") && !_this._box_0.privateDeprecation) {
                    _this._box_0.privateDeprecation = true;
                    A.warnForDeprecation0("Configuring private variables (such as $" + $name + string$.x29x20is_dT, B.Deprecation_lkJ);
                }
                t1.$indexSet(0, $name, new A.ConfiguredValue0(value, _this.span, _this.callableNode));
            },
            $signature: 117
        };
        A._EvaluateVisitor__closure8.prototype = {
            call$2: function(module, _) {
                var t1 = this.$this;
                return t1._evaluate0$_combineCss$2$clone(module, true).accept$1(t1);
            },
            $signature: 91
        };
        A._EvaluateVisitor_closure37.prototype = {
            call$1: function($arguments) {
                var callableNode, invocation, callable, $content, t1 = J.getInterceptor$asx($arguments), mixin = t1.$index($arguments, 0), args = type$.SassArgumentList_2._as(t1.$index($arguments, 1));
                t1 = this.$this;
                callableNode = t1._evaluate0$_callableNode;
                invocation = A.ArgumentList$0(B.List_empty24, B.Map_empty14, B.Map_empty5, callableNode.get$span(callableNode), null, new A.ValueExpression0(args, callableNode.get$span(callableNode)));
                callable = mixin.assertMixin$1("mixin").assertCompileContext$1(t1._evaluate0$_compileContext).callable;
                $content = t1._evaluate0$_environment._environment0$_content;
                if (type$.Callable_2._is(callable)) t1._evaluate0$_applyMixin$5(callable, $content, invocation, callableNode, callableNode);
                else throw A.wrapException(A.SassScriptException$0("The mixin " + callable.get$name(callable) + string$.x20is_as, null));
            },
            $signature: 241
        };
        A._EvaluateVisitor_run_closure1.prototype = {
            call$0: function() {
                var module, _this = this, t1 = _this.node, t2 = t1.span, _0_0 = t2.get$sourceUrl(t2), url = null;
                if (_0_0 != null) {
                    url = _0_0;
                    t2 = _this.$this;
                    t2._evaluate0$_activeModules.$indexSet(0, url, null);
                    if (!(t2._nodeImporter != null && J.toString$0$(url) === "stdin")) t2._evaluate0$_loadedUrls.add$1(0, url);
                }
                t2 = _this.$this;
                module = t2._evaluate0$_addExceptionTrace$1(new A._EvaluateVisitor_run__closure1(t2, _this.importer, t1));
                return new A._Record_2_loadedUrls_stylesheet(t2._evaluate0$_loadedUrls, t2._evaluate0$_combineCss$1(module));
            },
            $signature: 459
        };
        A._EvaluateVisitor_run__closure1.prototype = {
            call$0: function() {
                return this.$this._evaluate0$_execute$2(this.importer, this.node);
            },
            $signature: 460
        };
        A._EvaluateVisitor__loadModule_closure3.prototype = {
            call$0: function() {
                return this.callback.call$2(this._box_0.builtInModule, false);
            },
            $signature: 0
        };
        A._EvaluateVisitor__loadModule_closure4.prototype = {
            call$0: function() {
                var canonicalUrl, oldInDependency, t4, message, _this = this, t1 = {}, stylesheet = null, importer = null, t2 = _this.$this, t3 = _this.nodeWithSpan, _1_0 = t2._evaluate0$_loadStylesheet$3$baseUrl(_this.url.toString$0(0), t3.get$span(t3), _this.baseUrl);
                stylesheet = _1_0._0;
                importer = _1_0._1;
                t4 = stylesheet.span;
                canonicalUrl = t4.get$sourceUrl(t4);
                if (canonicalUrl != null) {
                    t4 = t2._evaluate0$_activeModules;
                    if (t4.containsKey$1(canonicalUrl)) {
                        message = _this.namesInErrors ? "Module loop: " + $.$get$context().prettyUri$1(canonicalUrl) + " is already being loaded." : string$.Modulel;
                        t1 = A.NullableExtension_andThen0(t4.$index(0, canonicalUrl), new A._EvaluateVisitor__loadModule__closure3(t2, message));
                        throw A.wrapException(t1 == null ? t2._evaluate0$_exception$1(message) : t1);
                    } else t4.$indexSet(0, canonicalUrl, t3);
                }
                t4 = t2._evaluate0$_modules.containsKey$1(canonicalUrl);
                oldInDependency = t2._evaluate0$_inDependency;
                t2._evaluate0$_inDependency = _1_0._2;
                t1.module = null;
                try {
                    t1.module = t2._evaluate0$_execute$5$configuration$namesInErrors$nodeWithSpan(importer, stylesheet, _this.configuration, _this.namesInErrors, t3);
                } finally{
                    t2._evaluate0$_activeModules.remove$1(0, canonicalUrl);
                    t2._evaluate0$_inDependency = oldInDependency;
                }
                t2._evaluate0$_addExceptionSpan$3$addStackFrame(t3, new A._EvaluateVisitor__loadModule__closure4(t1, _this.callback, !t4), false);
            },
            $signature: 1
        };
        A._EvaluateVisitor__loadModule__closure3.prototype = {
            call$1: function(previousLoad) {
                return this.$this._evaluate0$_multiSpanException$3(this.message, "new load", A.LinkedHashMap_LinkedHashMap$_literal([
                    previousLoad.get$span(previousLoad),
                    "original load"
                ], type$.FileSpan, type$.String));
            },
            $signature: 98
        };
        A._EvaluateVisitor__loadModule__closure4.prototype = {
            call$0: function() {
                return this.callback.call$2(this._box_1.module, this.firstLoad);
            },
            $signature: 0
        };
        A._EvaluateVisitor__execute_closure1.prototype = {
            call$0: function() {
                var t3, t4, t5, t6, _this = this, t1 = _this.$this, oldImporter = t1._evaluate0$_importer, oldStylesheet = t1._evaluate0$__stylesheet, oldRoot = t1._evaluate0$__root, oldPreModuleComments = t1._evaluate0$_preModuleComments, oldParent = t1._evaluate0$__parent, oldEndOfImports = t1._evaluate0$__endOfImports, oldOutOfOrderImports = t1._evaluate0$_outOfOrderImports, oldExtensionStore = t1._evaluate0$__extensionStore, t2 = t1._evaluate0$_atRootExcludingStyleRule, oldStyleRule = t2 ? null : t1._evaluate0$_styleRuleIgnoringAtRoot, oldMediaQueries = t1._evaluate0$_mediaQueries, oldDeclarationName = t1._evaluate0$_declarationName, oldInUnknownAtRule = t1._evaluate0$_inUnknownAtRule, oldInKeyframes = t1._evaluate0$_inKeyframes, oldConfiguration = t1._evaluate0$_configuration;
                t1._evaluate0$_importer = _this.importer;
                t3 = t1._evaluate0$__stylesheet = _this.stylesheet;
                t4 = t3.span;
                t5 = t1._evaluate0$__parent = t1._evaluate0$__root = A.ModifiableCssStylesheet$0(t4);
                t1._evaluate0$__endOfImports = 0;
                t1._evaluate0$_outOfOrderImports = null;
                t1._evaluate0$__extensionStore = _this.extensionStore;
                t1._evaluate0$_declarationName = t1._evaluate0$_mediaQueries = t1._evaluate0$_styleRuleIgnoringAtRoot = null;
                t1._evaluate0$_inKeyframes = t1._evaluate0$_atRootExcludingStyleRule = t1._evaluate0$_inUnknownAtRule = false;
                t6 = _this.configuration;
                if (t6 != null) t1._evaluate0$_configuration = t6;
                t1.visitStylesheet$1(0, t3);
                t3 = t1._evaluate0$_outOfOrderImports == null ? t5 : new A.CssStylesheet0(new A.UnmodifiableListView(t1._evaluate0$_addOutOfOrderImports$0(), type$.UnmodifiableListView_CssNode_2), t4);
                _this.css.__late_helper$_value = t3;
                _this.preModuleComments.__late_helper$_value = t1._evaluate0$_preModuleComments;
                t1._evaluate0$_importer = oldImporter;
                t1._evaluate0$__stylesheet = oldStylesheet;
                t1._evaluate0$__root = oldRoot;
                t1._evaluate0$_preModuleComments = oldPreModuleComments;
                t1._evaluate0$__parent = oldParent;
                t1._evaluate0$__endOfImports = oldEndOfImports;
                t1._evaluate0$_outOfOrderImports = oldOutOfOrderImports;
                t1._evaluate0$__extensionStore = oldExtensionStore;
                t1._evaluate0$_styleRuleIgnoringAtRoot = oldStyleRule;
                t1._evaluate0$_mediaQueries = oldMediaQueries;
                t1._evaluate0$_declarationName = oldDeclarationName;
                t1._evaluate0$_inUnknownAtRule = oldInUnknownAtRule;
                t1._evaluate0$_atRootExcludingStyleRule = t2;
                t1._evaluate0$_inKeyframes = oldInKeyframes;
                t1._evaluate0$_configuration = oldConfiguration;
            },
            $signature: 1
        };
        A._EvaluateVisitor__combineCss_closure3.prototype = {
            call$1: function(module) {
                return module.get$transitivelyContainsCss();
            },
            $signature: 85
        };
        A._EvaluateVisitor__combineCss_closure4.prototype = {
            call$1: function(target) {
                return !this.selectors.contains$1(0, target);
            },
            $signature: 15
        };
        A._EvaluateVisitor__combineCss_visitModule1.prototype = {
            call$1: function(module) {
                var t1, t2, t3, t4, _i, upstream, _1_0, statements, index, _this = this;
                if (!_this.seen.add$1(0, module)) return;
                if (_this.clone) module = module.cloneCss$0();
                for(t1 = module.get$upstream(), t2 = t1.length, t3 = _this.css, t4 = _this.imports, _i = 0; _i < t1.length; t1.length === t2 || (0, A.throwConcurrentModificationError)(t1), ++_i){
                    upstream = t1[_i];
                    if (upstream.get$transitivelyContainsCss()) {
                        _1_0 = module.get$preModuleComments().$index(0, upstream);
                        if (_1_0 != null) B.JSArray_methods.addAll$1(t3.length === 0 ? t4 : t3, _1_0);
                        _this.call$1(upstream);
                    }
                }
                _this.sorted.addFirst$1(module);
                t1 = module.get$css(module);
                statements = t1.get$children(t1);
                index = _this.$this._evaluate0$_indexAfterImports$1(statements);
                t1 = J.getInterceptor$ax(statements);
                B.JSArray_methods.addAll$1(t4, t1.getRange$2(statements, 0, index));
                B.JSArray_methods.addAll$1(t3, t1.getRange$2(statements, index, t1.get$length(statements)));
            },
            $signature: 461
        };
        A._EvaluateVisitor__extendModules_closure3.prototype = {
            call$1: function(target) {
                return !this.originalSelectors.contains$1(0, target);
            },
            $signature: 15
        };
        A._EvaluateVisitor__extendModules_closure4.prototype = {
            call$0: function() {
                return A._setArrayType([], type$.JSArray_ExtensionStore_2);
            },
            $signature: 211
        };
        A._EvaluateVisitor_visitAtRootRule_closure3.prototype = {
            call$0: function() {
                var t1, t2, t3, _i;
                for(t1 = this.node.children, t2 = t1.length, t3 = this.$this, _i = 0; _i < t2; ++_i)t1[_i].accept$1(t3);
            },
            $signature: 1
        };
        A._EvaluateVisitor_visitAtRootRule_closure4.prototype = {
            call$0: function() {
                var t1, t2, t3, _i;
                for(t1 = this.node.children, t2 = t1.length, t3 = this.$this, _i = 0; _i < t2; ++_i)t1[_i].accept$1(t3);
            },
            $signature: 0
        };
        A._EvaluateVisitor__scopeForAtRoot_closure11.prototype = {
            call$1: function(callback) {
                var t1 = this.$this, oldParent = t1._evaluate0$_assertInModule$2(t1._evaluate0$__parent, "__parent");
                t1._evaluate0$__parent = this.newParent;
                t1._evaluate0$_environment.scope$1$2$when(callback, this.node.hasDeclarations, type$.void);
                t1._evaluate0$__parent = oldParent;
            },
            $signature: 35
        };
        A._EvaluateVisitor__scopeForAtRoot_closure12.prototype = {
            call$1: function(callback) {
                var t1 = this.$this, oldAtRootExcludingStyleRule = t1._evaluate0$_atRootExcludingStyleRule;
                t1._evaluate0$_atRootExcludingStyleRule = true;
                this.innerScope.call$1(callback);
                t1._evaluate0$_atRootExcludingStyleRule = oldAtRootExcludingStyleRule;
            },
            $signature: 35
        };
        A._EvaluateVisitor__scopeForAtRoot_closure13.prototype = {
            call$1: function(callback) {
                return this.$this._evaluate0$_withMediaQueries$3(null, null, new A._EvaluateVisitor__scopeForAtRoot__closure1(this.innerScope, callback));
            },
            $signature: 35
        };
        A._EvaluateVisitor__scopeForAtRoot__closure1.prototype = {
            call$0: function() {
                return this.innerScope.call$1(this.callback);
            },
            $signature: 1
        };
        A._EvaluateVisitor__scopeForAtRoot_closure14.prototype = {
            call$1: function(callback) {
                var t1 = this.$this, wasInKeyframes = t1._evaluate0$_inKeyframes;
                t1._evaluate0$_inKeyframes = false;
                this.innerScope.call$1(callback);
                t1._evaluate0$_inKeyframes = wasInKeyframes;
            },
            $signature: 35
        };
        A._EvaluateVisitor__scopeForAtRoot_closure15.prototype = {
            call$1: function($parent) {
                return $parent instanceof A.ModifiableCssAtRule0;
            },
            $signature: 212
        };
        A._EvaluateVisitor__scopeForAtRoot_closure16.prototype = {
            call$1: function(callback) {
                var t1 = this.$this, wasInUnknownAtRule = t1._evaluate0$_inUnknownAtRule;
                t1._evaluate0$_inUnknownAtRule = false;
                this.innerScope.call$1(callback);
                t1._evaluate0$_inUnknownAtRule = wasInUnknownAtRule;
            },
            $signature: 35
        };
        A._EvaluateVisitor_visitContentRule_closure1.prototype = {
            call$0: function() {
                var t1, t2, t3, _i;
                for(t1 = this.content.declaration.children, t2 = t1.length, t3 = this.$this, _i = 0; _i < t2; ++_i)t1[_i].accept$1(t3);
                return null;
            },
            $signature: 1
        };
        A._EvaluateVisitor_visitDeclaration_closure1.prototype = {
            call$0: function() {
                var t1, t2, t3, _i;
                for(t1 = this._box_0.children, t2 = t1.length, t3 = this.$this, _i = 0; _i < t2; ++_i)t1[_i].accept$1(t3);
            },
            $signature: 1
        };
        A._EvaluateVisitor_visitEachRule_closure5.prototype = {
            call$1: function(value) {
                var t1 = this.$this, t2 = this.nodeWithSpan;
                return t1._evaluate0$_environment.setLocalVariable$3(this._box_0.variable, t1._evaluate0$_withoutSlash$2(value, t2), t2);
            },
            $signature: 63
        };
        A._EvaluateVisitor_visitEachRule_closure6.prototype = {
            call$1: function(value) {
                return this.$this._evaluate0$_setMultipleVariables$3(this._box_1.variables, value, this.nodeWithSpan);
            },
            $signature: 63
        };
        A._EvaluateVisitor_visitEachRule_closure7.prototype = {
            call$0: function() {
                var _this = this, t1 = _this.$this;
                return t1._evaluate0$_handleReturn$2(_this.list.get$asList(), new A._EvaluateVisitor_visitEachRule__closure1(t1, _this.setVariables, _this.node));
            },
            $signature: 42
        };
        A._EvaluateVisitor_visitEachRule__closure1.prototype = {
            call$1: function(element) {
                var t1;
                this.setVariables.call$1(element);
                t1 = this.$this;
                return t1._evaluate0$_handleReturn$2(this.node.children, new A._EvaluateVisitor_visitEachRule___closure1(t1));
            },
            $signature: 242
        };
        A._EvaluateVisitor_visitEachRule___closure1.prototype = {
            call$1: function(child) {
                return child.accept$1(this.$this);
            },
            $signature: 115
        };
        A._EvaluateVisitor_visitAtRule_closure7.prototype = {
            call$1: function(value) {
                return this.$this._evaluate0$_interpolationToValue$3$trim$warnForColor(value, true, true);
            },
            $signature: 696
        };
        A._EvaluateVisitor_visitAtRule_closure8.prototype = {
            call$0: function() {
                var t1, t2, t3, _i;
                for(t1 = this.children, t2 = t1.length, t3 = this.$this, _i = 0; _i < t2; ++_i)t1[_i].accept$1(t3);
            },
            $signature: 1
        };
        A._EvaluateVisitor_visitAtRule_closure9.prototype = {
            call$0: function() {
                var t2, t3, _i, _this = this, t1 = _this.$this, styleRule = t1._evaluate0$_atRootExcludingStyleRule ? null : t1._evaluate0$_styleRuleIgnoringAtRoot;
                if (styleRule == null || t1._evaluate0$_inKeyframes || _this.name.value === "font-face") for(t2 = _this.children, t3 = t2.length, _i = 0; _i < t3; ++_i)t2[_i].accept$1(t1);
                else t1._evaluate0$_withParent$2$3$scopeWhen(A.ModifiableCssStyleRule$0(styleRule._style_rule0$_selector, styleRule.span, false, styleRule.originalSelector), new A._EvaluateVisitor_visitAtRule__closure1(t1, _this.children), false, type$.ModifiableCssStyleRule_2, type$.Null);
            },
            $signature: 1
        };
        A._EvaluateVisitor_visitAtRule__closure1.prototype = {
            call$0: function() {
                var t1, t2, t3, _i;
                for(t1 = this.children, t2 = t1.length, t3 = this.$this, _i = 0; _i < t2; ++_i)t1[_i].accept$1(t3);
            },
            $signature: 1
        };
        A._EvaluateVisitor_visitAtRule_closure10.prototype = {
            call$1: function(node) {
                return node instanceof A.ModifiableCssStyleRule0;
            },
            $signature: 8
        };
        A._EvaluateVisitor_visitForRule_closure9.prototype = {
            call$0: function() {
                return this.node.from.accept$1(this.$this).assertNumber$0();
            },
            $signature: 243
        };
        A._EvaluateVisitor_visitForRule_closure10.prototype = {
            call$0: function() {
                return this.node.to.accept$1(this.$this).assertNumber$0();
            },
            $signature: 243
        };
        A._EvaluateVisitor_visitForRule_closure11.prototype = {
            call$0: function() {
                return this.fromNumber.assertInt$0();
            },
            $signature: 10
        };
        A._EvaluateVisitor_visitForRule_closure12.prototype = {
            call$0: function() {
                var t1 = this.fromNumber;
                return this.toNumber.coerce$2(t1.get$numeratorUnits(t1), t1.get$denominatorUnits(t1)).assertInt$0();
            },
            $signature: 10
        };
        A._EvaluateVisitor_visitForRule_closure13.prototype = {
            call$0: function() {
                var i, t3, t4, t5, t6, t7, t8, _0_0, _this = this, t1 = _this.$this, t2 = _this.node, nodeWithSpan = t1._evaluate0$_expressionNode$1(t2.from);
                for(i = _this.from, t3 = _this._box_0, t4 = _this.direction, t5 = t2.variable, t6 = _this.fromNumber, t2 = t2.children; i !== t3.to; i += t4){
                    t7 = t1._evaluate0$_environment;
                    t8 = t6.get$numeratorUnits(t6);
                    t7.setLocalVariable$3(t5, A.SassNumber_SassNumber$withUnits0(i, t6.get$denominatorUnits(t6), t8), nodeWithSpan);
                    _0_0 = t1._evaluate0$_handleReturn$2(t2, new A._EvaluateVisitor_visitForRule__closure1(t1));
                    if (_0_0 != null) return _0_0;
                }
                return null;
            },
            $signature: 42
        };
        A._EvaluateVisitor_visitForRule__closure1.prototype = {
            call$1: function(child) {
                return child.accept$1(this.$this);
            },
            $signature: 115
        };
        A._EvaluateVisitor_visitForwardRule_closure3.prototype = {
            call$2: function(module, firstLoad) {
                if (firstLoad) this.$this._evaluate0$_registerCommentsForModule$1(module);
                this.$this._evaluate0$_environment.forwardModule$2(module, this.node);
            },
            $signature: 91
        };
        A._EvaluateVisitor_visitForwardRule_closure4.prototype = {
            call$2: function(module, firstLoad) {
                if (firstLoad) this.$this._evaluate0$_registerCommentsForModule$1(module);
                this.$this._evaluate0$_environment.forwardModule$2(module, this.node);
            },
            $signature: 91
        };
        A._EvaluateVisitor__registerCommentsForModule_closure1.prototype = {
            call$0: function() {
                return A._setArrayType([], type$.JSArray_CssComment_2);
            },
            $signature: 215
        };
        A._EvaluateVisitor_visitIfRule_closure1.prototype = {
            call$1: function(clause) {
                var t1 = this.$this;
                return t1._evaluate0$_environment.scope$1$3$semiGlobal$when(new A._EvaluateVisitor_visitIfRule__closure1(t1, clause), true, clause.hasDeclarations, type$.nullable_Value_2);
            },
            $signature: 466
        };
        A._EvaluateVisitor_visitIfRule__closure1.prototype = {
            call$0: function() {
                var t1 = this.$this;
                return t1._evaluate0$_handleReturn$2(this.clause.children, new A._EvaluateVisitor_visitIfRule___closure1(t1));
            },
            $signature: 42
        };
        A._EvaluateVisitor_visitIfRule___closure1.prototype = {
            call$1: function(child) {
                return child.accept$1(this.$this);
            },
            $signature: 115
        };
        A._EvaluateVisitor__visitDynamicImport_closure1.prototype = {
            call$0: function() {
                var t1, t2, _0_0, stylesheet, importer, isDependency, t3, url, oldImporter, oldStylesheet, oldInDependency, loadsUserDefinedModules, children, t4, t5, t6, t7, t8, t9, t10, t11, environment, module, visitor, _box_0 = {};
                _box_0.isDependency = _box_0.importer = _box_0.stylesheet = null;
                t1 = this.$this;
                t2 = this.$import;
                _0_0 = t1._evaluate0$_loadStylesheet$3$forImport(t2.urlString, t2.span, true);
                stylesheet = _box_0.stylesheet = _0_0._0;
                importer = _0_0._1;
                _box_0.importer = importer;
                isDependency = _0_0._2;
                _box_0.isDependency = isDependency;
                t3 = stylesheet.span;
                url = t3.get$sourceUrl(t3);
                if (url != null) {
                    t3 = t1._evaluate0$_activeModules;
                    if (t3.containsKey$1(url)) {
                        t2 = A.NullableExtension_andThen0(t3.$index(0, url), new A._EvaluateVisitor__visitDynamicImport__closure7(t1));
                        throw A.wrapException(t2 == null ? t1._evaluate0$_exception$1("This file is already being loaded.") : t2);
                    }
                    t3.$indexSet(0, url, t2);
                }
                t2 = stylesheet._stylesheet1$_uses;
                t3 = type$.UnmodifiableListView_UseRule_2;
                if (new A.UnmodifiableListView(t2, t3).get$length(0) === 0 && new A.UnmodifiableListView(stylesheet._stylesheet1$_forwards, type$.UnmodifiableListView_ForwardRule_2).get$length(0) === 0) {
                    oldImporter = t1._evaluate0$_importer;
                    oldStylesheet = t1._evaluate0$_assertInModule$2(t1._evaluate0$__stylesheet, "_stylesheet");
                    oldInDependency = t1._evaluate0$_inDependency;
                    t1._evaluate0$_importer = importer;
                    t1._evaluate0$__stylesheet = stylesheet;
                    t1._evaluate0$_inDependency = isDependency;
                    t1.visitStylesheet$1(0, stylesheet);
                    t1._evaluate0$_importer = oldImporter;
                    t1._evaluate0$__stylesheet = oldStylesheet;
                    t1._evaluate0$_inDependency = oldInDependency;
                    t1._evaluate0$_activeModules.remove$1(0, url);
                    return;
                }
                t2 = new A.UnmodifiableListView(t2, t3);
                if (!t2.any$1(t2, new A._EvaluateVisitor__visitDynamicImport__closure8())) {
                    t2 = new A.UnmodifiableListView(stylesheet._stylesheet1$_forwards, type$.UnmodifiableListView_ForwardRule_2);
                    loadsUserDefinedModules = t2.any$1(t2, new A._EvaluateVisitor__visitDynamicImport__closure9());
                } else loadsUserDefinedModules = true;
                children = A._Cell$();
                t2 = t1._evaluate0$_environment;
                t3 = type$.String;
                t4 = type$.Module_Callable_2;
                t5 = type$.AstNode_2;
                t6 = t2._environment0$_nestedForwardedModules;
                t7 = A._setArrayType([], type$.JSArray_Module_Callable_2);
                t8 = t2._environment0$_variables;
                t8 = A._setArrayType(t8.slice(0), A._arrayInstanceType(t8));
                t9 = t2._environment0$_variableNodes;
                t9 = A._setArrayType(t9.slice(0), A._arrayInstanceType(t9));
                t10 = t2._environment0$_functions;
                t10 = A._setArrayType(t10.slice(0), A._arrayInstanceType(t10));
                t11 = t2._environment0$_mixins;
                t11 = A._setArrayType(t11.slice(0), A._arrayInstanceType(t11));
                environment = A.Environment$_0(A.LinkedHashMap_LinkedHashMap$_empty(t3, t4), A.LinkedHashMap_LinkedHashMap$_empty(t3, t5), A.LinkedHashMap_LinkedHashMap$_empty(t4, t5), t2._environment0$_importedModules, null, t6, t7, t8, t9, t10, t11, t2._environment0$_content, t2._environment0$_configurableVariables);
                t1._evaluate0$_withEnvironment$2(environment, new A._EvaluateVisitor__visitDynamicImport__closure10(_box_0, t1, loadsUserDefinedModules, environment, children));
                module = environment.toDummyModule$0();
                t1._evaluate0$_environment.importForwards$1(module);
                if (loadsUserDefinedModules) {
                    if (module.transitivelyContainsCss) t1._evaluate0$_combineCss$2$clone(module, module.transitivelyContainsExtensions).accept$1(t1);
                    visitor = new A._ImportedCssVisitor1(t1);
                    for(t2 = J.get$iterator$ax(children._readLocal$0()); t2.moveNext$0();)t2.get$current(t2).accept$1(visitor);
                }
                t1._evaluate0$_activeModules.remove$1(0, url);
            },
            $signature: 0
        };
        A._EvaluateVisitor__visitDynamicImport__closure7.prototype = {
            call$1: function(previousLoad) {
                return this.$this._evaluate0$_multiSpanException$3("This file is already being loaded.", "new load", A.LinkedHashMap_LinkedHashMap$_literal([
                    previousLoad.get$span(previousLoad),
                    "original load"
                ], type$.FileSpan, type$.String));
            },
            $signature: 98
        };
        A._EvaluateVisitor__visitDynamicImport__closure8.prototype = {
            call$1: function(rule) {
                return rule.url.get$scheme() !== "sass";
            },
            $signature: 142
        };
        A._EvaluateVisitor__visitDynamicImport__closure9.prototype = {
            call$1: function(rule) {
                return rule.url.get$scheme() !== "sass";
            },
            $signature: 216
        };
        A._EvaluateVisitor__visitDynamicImport__closure10.prototype = {
            call$0: function() {
                var t3, t4, _this = this, t1 = _this.$this, oldImporter = t1._evaluate0$_importer, oldStylesheet = t1._evaluate0$_assertInModule$2(t1._evaluate0$__stylesheet, "_stylesheet"), oldRoot = t1._evaluate0$_assertInModule$2(t1._evaluate0$__root, "_root"), oldParent = t1._evaluate0$_assertInModule$2(t1._evaluate0$__parent, "__parent"), oldEndOfImports = t1._evaluate0$_assertInModule$2(t1._evaluate0$__endOfImports, "_endOfImports"), oldOutOfOrderImports = t1._evaluate0$_outOfOrderImports, oldConfiguration = t1._evaluate0$_configuration, oldInDependency = t1._evaluate0$_inDependency, t2 = _this._box_0;
                t1._evaluate0$_importer = t2.importer;
                t3 = t2.stylesheet;
                t1._evaluate0$__stylesheet = t3;
                t4 = _this.loadsUserDefinedModules;
                if (t4) {
                    t3 = A.ModifiableCssStylesheet$0(t3.span);
                    t1._evaluate0$__root = t3;
                    t1._evaluate0$__parent = t1._evaluate0$_assertInModule$2(t3, "_root");
                    t1._evaluate0$__endOfImports = 0;
                    t1._evaluate0$_outOfOrderImports = null;
                }
                t1._evaluate0$_inDependency = t2.isDependency;
                t3 = new A.UnmodifiableListView(t2.stylesheet._stylesheet1$_forwards, type$.UnmodifiableListView_ForwardRule_2);
                if (!t3.get$isEmpty(t3)) t1._evaluate0$_configuration = _this.environment.toImplicitConfiguration$0();
                t1.visitStylesheet$1(0, t2.stylesheet);
                t2 = t4 ? t1._evaluate0$_addOutOfOrderImports$0() : A._setArrayType([], type$.JSArray_ModifiableCssNode_2);
                _this.children.__late_helper$_value = t2;
                t1._evaluate0$_importer = oldImporter;
                t1._evaluate0$__stylesheet = oldStylesheet;
                if (t4) {
                    t1._evaluate0$__root = oldRoot;
                    t1._evaluate0$__parent = oldParent;
                    t1._evaluate0$__endOfImports = oldEndOfImports;
                    t1._evaluate0$_outOfOrderImports = oldOutOfOrderImports;
                }
                t1._evaluate0$_configuration = oldConfiguration;
                t1._evaluate0$_inDependency = oldInDependency;
            },
            $signature: 1
        };
        A._EvaluateVisitor__applyMixin_closure3.prototype = {
            call$0: function() {
                var _this = this, t1 = _this.$this;
                t1._evaluate0$_environment.asMixin$1(new A._EvaluateVisitor__applyMixin__closure4(t1, _this.$arguments, _this.mixin, _this.nodeWithSpanWithoutContent));
            },
            $signature: 0
        };
        A._EvaluateVisitor__applyMixin__closure4.prototype = {
            call$0: function() {
                var _this = this;
                _this.$this._evaluate0$_runBuiltInCallable$3(_this.$arguments, _this.mixin, _this.nodeWithSpanWithoutContent);
            },
            $signature: 0
        };
        A._EvaluateVisitor__applyMixin_closure4.prototype = {
            call$0: function() {
                var _this = this, t1 = _this.$this;
                t1._evaluate0$_environment.withContent$2(_this.contentCallable, new A._EvaluateVisitor__applyMixin__closure3(t1, _this.mixin, _this.nodeWithSpanWithoutContent));
            },
            $signature: 1
        };
        A._EvaluateVisitor__applyMixin__closure3.prototype = {
            call$0: function() {
                var t1 = this.$this;
                t1._evaluate0$_environment.asMixin$1(new A._EvaluateVisitor__applyMixin___closure1(t1, this.mixin, this.nodeWithSpanWithoutContent));
            },
            $signature: 0
        };
        A._EvaluateVisitor__applyMixin___closure1.prototype = {
            call$0: function() {
                var t1, t2, t3, t4, _i;
                for(t1 = this.mixin.declaration.children, t2 = t1.length, t3 = this.$this, t4 = this.nodeWithSpanWithoutContent, _i = 0; _i < t2; ++_i)t3._evaluate0$_addErrorSpan$2(t4, new A._EvaluateVisitor__applyMixin____closure1(t3, t1[_i]));
            },
            $signature: 0
        };
        A._EvaluateVisitor__applyMixin____closure1.prototype = {
            call$0: function() {
                return this.statement.accept$1(this.$this);
            },
            $signature: 42
        };
        A._EvaluateVisitor_visitIncludeRule_closure5.prototype = {
            call$0: function() {
                var t1 = this.node;
                return this.$this._evaluate0$_environment.getMixin$2$namespace(t1.name, t1.namespace);
            },
            $signature: 88
        };
        A._EvaluateVisitor_visitIncludeRule_closure6.prototype = {
            call$1: function($content) {
                var t1 = this.$this;
                return new A.UserDefinedCallable0($content, t1._evaluate0$_environment.closure$0(), t1._evaluate0$_inDependency, type$.UserDefinedCallable_Environment_2);
            },
            $signature: 467
        };
        A._EvaluateVisitor_visitIncludeRule_closure7.prototype = {
            call$0: function() {
                return this.node.get$spanWithoutContent();
            },
            $signature: 16
        };
        A._EvaluateVisitor_visitMediaRule_closure7.prototype = {
            call$0: function() {
                var t1, t2, t3, _i;
                for(t1 = this.node.children, t2 = t1.length, t3 = this.$this, _i = 0; _i < t2; ++_i)t1[_i].accept$1(t3);
            },
            $signature: 1
        };
        A._EvaluateVisitor_visitMediaRule_closure8.prototype = {
            call$1: function(mediaQueries) {
                return this.$this._evaluate0$_mergeMediaQueries$2(mediaQueries, this.queries);
            },
            $signature: 104
        };
        A._EvaluateVisitor_visitMediaRule_closure9.prototype = {
            call$0: function() {
                var _this = this, t1 = _this.$this, t2 = _this.mergedQueries;
                if (t2 == null) t2 = _this.queries;
                t1._evaluate0$_withMediaQueries$3(t2, _this.mergedSources, new A._EvaluateVisitor_visitMediaRule__closure1(t1, _this.node));
            },
            $signature: 1
        };
        A._EvaluateVisitor_visitMediaRule__closure1.prototype = {
            call$0: function() {
                var t2, t3, _i, t1 = this.$this, _0_0 = t1._evaluate0$_atRootExcludingStyleRule ? null : t1._evaluate0$_styleRuleIgnoringAtRoot;
                if (_0_0 != null) t1._evaluate0$_withParent$2$3$scopeWhen(A.ModifiableCssStyleRule$0(_0_0._style_rule0$_selector, _0_0.span, false, _0_0.originalSelector), new A._EvaluateVisitor_visitMediaRule___closure1(t1, this.node), false, type$.ModifiableCssStyleRule_2, type$.Null);
                else for(t2 = this.node.children, t3 = t2.length, _i = 0; _i < t3; ++_i)t2[_i].accept$1(t1);
            },
            $signature: 1
        };
        A._EvaluateVisitor_visitMediaRule___closure1.prototype = {
            call$0: function() {
                var t1, t2, t3, _i;
                for(t1 = this.node.children, t2 = t1.length, t3 = this.$this, _i = 0; _i < t2; ++_i)t1[_i].accept$1(t3);
            },
            $signature: 1
        };
        A._EvaluateVisitor_visitMediaRule_closure10.prototype = {
            call$1: function(node) {
                var t1;
                if (!(node instanceof A.ModifiableCssStyleRule0)) {
                    t1 = this.mergedSources;
                    t1 = t1.get$isNotEmpty(t1) && node instanceof A.ModifiableCssMediaRule0 && B.JSArray_methods.every$1(node.queries, t1.get$contains(t1));
                } else t1 = true;
                return t1;
            },
            $signature: 8
        };
        A._EvaluateVisitor_visitStyleRule_closure7.prototype = {
            call$0: function() {
                var t1, t2, t3, _i;
                for(t1 = this.node.children, t2 = t1.length, t3 = this.$this, _i = 0; _i < t2; ++_i)t1[_i].accept$1(t3);
            },
            $signature: 1
        };
        A._EvaluateVisitor_visitStyleRule_closure8.prototype = {
            call$1: function(node) {
                return node instanceof A.ModifiableCssStyleRule0;
            },
            $signature: 8
        };
        A._EvaluateVisitor_visitStyleRule_closure10.prototype = {
            call$0: function() {
                var t1 = this.$this;
                t1._evaluate0$_withStyleRule$2(this.rule, new A._EvaluateVisitor_visitStyleRule__closure1(t1, this.node));
            },
            $signature: 1
        };
        A._EvaluateVisitor_visitStyleRule__closure1.prototype = {
            call$0: function() {
                var t1, t2, t3, _i;
                for(t1 = this.node.children, t2 = t1.length, t3 = this.$this, _i = 0; _i < t2; ++_i)t1[_i].accept$1(t3);
            },
            $signature: 1
        };
        A._EvaluateVisitor_visitStyleRule_closure9.prototype = {
            call$1: function(node) {
                return node instanceof A.ModifiableCssStyleRule0;
            },
            $signature: 8
        };
        A._EvaluateVisitor__warnForBogusCombinators_closure1.prototype = {
            call$1: function(child) {
                return child instanceof A.ModifiableCssComment0;
            },
            $signature: 8
        };
        A._EvaluateVisitor_visitSupportsRule_closure5.prototype = {
            call$0: function() {
                var t1, t2, t3, _i;
                for(t1 = this.node.children, t2 = t1.length, t3 = this.$this, _i = 0; _i < t2; ++_i)t1[_i].accept$1(t3);
            },
            $signature: 1
        };
        A._EvaluateVisitor_visitSupportsRule_closure6.prototype = {
            call$0: function() {
                var t2, t3, _i, t1 = this.$this, _0_0 = t1._evaluate0$_atRootExcludingStyleRule ? null : t1._evaluate0$_styleRuleIgnoringAtRoot;
                if (_0_0 != null) t1._evaluate0$_withParent$2$2(A.ModifiableCssStyleRule$0(_0_0._style_rule0$_selector, _0_0.span, false, _0_0.originalSelector), new A._EvaluateVisitor_visitSupportsRule__closure1(t1, this.node), type$.ModifiableCssStyleRule_2, type$.Null);
                else for(t2 = this.node.children, t3 = t2.length, _i = 0; _i < t3; ++_i)t2[_i].accept$1(t1);
            },
            $signature: 1
        };
        A._EvaluateVisitor_visitSupportsRule__closure1.prototype = {
            call$0: function() {
                var t1, t2, t3, _i;
                for(t1 = this.node.children, t2 = t1.length, t3 = this.$this, _i = 0; _i < t2; ++_i)t1[_i].accept$1(t3);
            },
            $signature: 1
        };
        A._EvaluateVisitor_visitSupportsRule_closure7.prototype = {
            call$1: function(node) {
                return node instanceof A.ModifiableCssStyleRule0;
            },
            $signature: 8
        };
        A._EvaluateVisitor__visitSupportsCondition_closure1.prototype = {
            call$0: function() {
                var t4, t1 = this.$this, t2 = this._box_0, t3 = t2.declaration.name;
                t3 = t1._evaluate0$_serialize$3$quote(t3.accept$1(t1), t3, true);
                t4 = t2.declaration.get$isCustomProperty() ? "" : " ";
                t2 = t2.declaration.value;
                return "(" + t3 + ":" + t4 + t1._evaluate0$_serialize$3$quote(t2.accept$1(t1), t2, true) + ")";
            },
            $signature: 29
        };
        A._EvaluateVisitor_visitVariableDeclaration_closure5.prototype = {
            call$0: function() {
                var t1 = this.$this._evaluate0$_environment, t2 = this._box_0.override;
                t1.setVariable$4$global(this.node.name, t2.value, t2.assignmentNode, true);
            },
            $signature: 1
        };
        A._EvaluateVisitor_visitVariableDeclaration_closure6.prototype = {
            call$0: function() {
                var t1 = this.node;
                return this.$this._evaluate0$_environment.getVariable$2$namespace(t1.name, t1.namespace);
            },
            $signature: 42
        };
        A._EvaluateVisitor_visitVariableDeclaration_closure7.prototype = {
            call$0: function() {
                var t1 = this.$this, t2 = this.node;
                t1._evaluate0$_environment.setVariable$5$global$namespace(t2.name, this.value, t1._evaluate0$_expressionNode$1(t2.expression), t2.isGlobal, t2.namespace);
            },
            $signature: 1
        };
        A._EvaluateVisitor_visitUseRule_closure1.prototype = {
            call$2: function(module, firstLoad) {
                var t1, t2, t3, _0_0, t4, t5, span;
                if (firstLoad) this.$this._evaluate0$_registerCommentsForModule$1(module);
                t1 = this.$this._evaluate0$_environment;
                t2 = this.node;
                t3 = t2.namespace;
                if (t3 == null) {
                    t1._environment0$_globalModules.$indexSet(0, module, t2);
                    t1._environment0$_allModules.push(module);
                    t1 = B.JSArray_methods.get$first(t1._environment0$_variables);
                    _0_0 = A.IterableExtension_firstWhereOrNull(t1.get$keys(t1), module.get$variables().get$containsKey());
                    if (_0_0 != null) A.throwExpression(A.SassScriptException$0(string$.This_ma + _0_0 + '".', null));
                } else {
                    t4 = t1._environment0$_modules;
                    if (t4.containsKey$1(t3)) {
                        t5 = t1._environment0$_namespaceNodes.$index(0, t3);
                        span = t5 == null ? null : t5.span;
                        t5 = A.LinkedHashMap_LinkedHashMap$_empty(type$.FileSpan, type$.String);
                        if (span != null) t5.$indexSet(0, span, "original @use");
                        A.throwExpression(A.MultiSpanSassScriptException$0(string$.There_ + t3 + '".', "new @use", t5));
                    }
                    t4.$indexSet(0, t3, module);
                    t1._environment0$_namespaceNodes.$indexSet(0, t3, t2);
                    t1._environment0$_allModules.push(module);
                }
            },
            $signature: 91
        };
        A._EvaluateVisitor_visitWarnRule_closure1.prototype = {
            call$0: function() {
                return this.node.expression.accept$1(this.$this);
            },
            $signature: 46
        };
        A._EvaluateVisitor_visitWhileRule_closure1.prototype = {
            call$0: function() {
                var t1, t2, t3, _0_0;
                for(t1 = this.node, t2 = t1.condition, t3 = this.$this, t1 = t1.children; t2.accept$1(t3).get$isTruthy();){
                    _0_0 = t3._evaluate0$_handleReturn$2(t1, new A._EvaluateVisitor_visitWhileRule__closure1(t3));
                    if (_0_0 != null) return _0_0;
                }
                return null;
            },
            $signature: 42
        };
        A._EvaluateVisitor_visitWhileRule__closure1.prototype = {
            call$1: function(child) {
                return child.accept$1(this.$this);
            },
            $signature: 115
        };
        A._EvaluateVisitor_visitBinaryOperationExpression_closure1.prototype = {
            call$0: function() {
                var t1 = this.node, t2 = this.$this, left = t1.left.accept$1(t2);
                switch(t1.operator.index){
                    case 0:
                        t1 = t1.right.accept$1(t2);
                        t1 = new A.SassString0(A.serializeValue0(left, false, true) + "=" + A.serializeValue0(t1, false, true), false);
                        break;
                    case 1:
                        t1 = left.get$isTruthy() ? left : t1.right.accept$1(t2);
                        break;
                    case 2:
                        t1 = left.get$isTruthy() ? t1.right.accept$1(t2) : left;
                        break;
                    case 3:
                        t1 = left.$eq(0, t1.right.accept$1(t2)) ? B.SassBoolean_true0 : B.SassBoolean_false0;
                        break;
                    case 4:
                        t1 = !left.$eq(0, t1.right.accept$1(t2)) ? B.SassBoolean_true0 : B.SassBoolean_false0;
                        break;
                    case 5:
                        t1 = left.greaterThan$1(t1.right.accept$1(t2));
                        break;
                    case 6:
                        t1 = left.greaterThanOrEquals$1(t1.right.accept$1(t2));
                        break;
                    case 7:
                        t1 = left.lessThan$1(t1.right.accept$1(t2));
                        break;
                    case 8:
                        t1 = left.lessThanOrEquals$1(t1.right.accept$1(t2));
                        break;
                    case 9:
                        t1 = left.plus$1(t1.right.accept$1(t2));
                        break;
                    case 10:
                        t1 = left.minus$1(t1.right.accept$1(t2));
                        break;
                    case 11:
                        t1 = left.times$1(t1.right.accept$1(t2));
                        break;
                    case 12:
                        t1 = t2._evaluate0$_slash$3(left, t1.right.accept$1(t2), t1);
                        break;
                    case 13:
                        t1 = left.modulo$1(t1.right.accept$1(t2));
                        break;
                    default:
                        t1 = null;
                }
                return t1;
            },
            $signature: 46
        };
        A._EvaluateVisitor__slash_recommendation1.prototype = {
            call$1: function(expression) {
                var t1;
                $label0$0: {
                    if (expression instanceof A.BinaryOperationExpression0 && B.BinaryOperator_ehp0 === expression.operator) {
                        t1 = "math.div(" + A.S(this.call$1(expression.left)) + ", " + A.S(this.call$1(expression.right)) + ")";
                        break $label0$0;
                    }
                    if (expression instanceof A.ParenthesizedExpression0) {
                        t1 = expression.expression.toString$0(0);
                        break $label0$0;
                    }
                    t1 = expression.toString$0(0);
                    break $label0$0;
                }
                return t1;
            },
            $signature: 120
        };
        A._EvaluateVisitor_visitVariableExpression_closure1.prototype = {
            call$0: function() {
                var t1 = this.node;
                return this.$this._evaluate0$_environment.getVariable$2$namespace(t1.name, t1.namespace);
            },
            $signature: 42
        };
        A._EvaluateVisitor_visitUnaryOperationExpression_closure1.prototype = {
            call$0: function() {
                var t1, _this = this;
                switch(_this.node.operator.index){
                    case 0:
                        t1 = _this.operand.unaryPlus$0();
                        break;
                    case 1:
                        t1 = _this.operand.unaryMinus$0();
                        break;
                    case 2:
                        t1 = new A.SassString0("/" + A.serializeValue0(_this.operand, false, true), false);
                        break;
                    case 3:
                        t1 = _this.operand.unaryNot$0();
                        break;
                    default:
                        t1 = null;
                }
                return t1;
            },
            $signature: 46
        };
        A._EvaluateVisitor_visitIfExpression_closure1.prototype = {
            call$1: function(pair) {
                return pair._0 + ": " + pair._1.toString$0(0);
            },
            $signature: 217
        };
        A._EvaluateVisitor_visitIfConditionOperation_closure1.prototype = {
            call$1: function(pair) {
                return pair._1;
            },
            $signature: 218
        };
        A._EvaluateVisitor_visitListExpression_closure1.prototype = {
            call$1: function(expression) {
                return expression.accept$1(this.$this);
            },
            $signature: 468
        };
        A._EvaluateVisitor_visitFunctionExpression_closure5.prototype = {
            call$0: function() {
                var t1 = this.node;
                return this.$this._evaluate0$_environment.getFunction$2$namespace(t1.name, t1.namespace);
            },
            $signature: 88
        };
        A._EvaluateVisitor_visitFunctionExpression_closure6.prototype = {
            call$1: function(argument) {
                return argument.accept$1(B.C_IsCalculationSafeVisitor0);
            },
            $signature: 81
        };
        A._EvaluateVisitor_visitFunctionExpression_closure7.prototype = {
            call$0: function() {
                var t1 = this.node;
                return this.$this._evaluate0$_runFunctionCallable$3(t1.$arguments, this._box_0.$function, t1);
            },
            $signature: 46
        };
        A._EvaluateVisitor__visitCalculation_closure1.prototype = {
            call$2: function(message, deprecation) {
                return this.$this._evaluate0$_warn$3(message, this.node.span, deprecation);
            },
            call$1: function(message) {
                return this.call$2(message, null);
            },
            $signature: 110
        };
        A._EvaluateVisitor__checkCalculationArguments_check1.prototype = {
            call$1: function(maxArgs) {
                var t1 = this.node, t2 = t1.$arguments.positional.length;
                if (t2 === 0) throw A.wrapException(this.$this._evaluate0$_exception$2("Missing argument.", t1.span));
                else if (maxArgs != null && t2 > maxArgs) throw A.wrapException(this.$this._evaluate0$_exception$2("Only " + A.S(maxArgs) + " " + A.pluralize0("argument", maxArgs, null) + " allowed, but " + t2 + " " + A.pluralize0("was", t2, "were") + " passed.", t1.span));
            },
            call$0: function() {
                return this.call$1(null);
            },
            $signature: 82
        };
        A._EvaluateVisitor__visitCalculationExpression_closure1.prototype = {
            call$0: function() {
                var _this = this, t1 = _this.$this, t2 = _this._box_0, t3 = _this.node, t4 = _this.inLegacySassFunction;
                return A.SassCalculation_operateInternal0(t1._evaluate0$_binaryOperatorToCalculationOperator$2(t2.operator, t3), t1._evaluate0$_visitCalculationExpression$2$inLegacySassFunction(t2.left, t4), t1._evaluate0$_visitCalculationExpression$2$inLegacySassFunction(t2.right, t4), t4, !t1._evaluate0$_inSupportsDeclaration, new A._EvaluateVisitor__visitCalculationExpression__closure1(t1, t3));
            },
            $signature: 83
        };
        A._EvaluateVisitor__visitCalculationExpression__closure1.prototype = {
            call$2: function(message, deprecation) {
                return this.$this._evaluate0$_warn$3(message, this.node.get$span(0), deprecation);
            },
            call$1: function(message) {
                return this.call$2(message, null);
            },
            $signature: 110
        };
        A._EvaluateVisitor_visitInterpolatedFunctionExpression_closure1.prototype = {
            call$0: function() {
                var t1 = this.node;
                return this.$this._evaluate0$_runFunctionCallable$3(t1.$arguments, this.$function, t1);
            },
            $signature: 46
        };
        A._EvaluateVisitor__runUserDefinedCallable_closure1.prototype = {
            call$0: function() {
                var _this = this, t1 = _this.$this, t2 = _this.callable;
                return t1._evaluate0$_withEnvironment$2(t2.environment.closure$0(), new A._EvaluateVisitor__runUserDefinedCallable__closure1(t1, _this.evaluated, t2, _this.nodeWithSpan, _this.run, _this.V));
            },
            $signature: function() {
                return this.V._eval$1("0()");
            }
        };
        A._EvaluateVisitor__runUserDefinedCallable__closure1.prototype = {
            call$0: function() {
                var _this = this, t1 = _this.$this, t2 = _this.V;
                return t1._evaluate0$_environment.scope$1$1(new A._EvaluateVisitor__runUserDefinedCallable___closure1(t1, _this.evaluated, _this.callable, _this.nodeWithSpan, _this.run, t2), t2);
            },
            $signature: function() {
                return this.V._eval$1("0()");
            }
        };
        A._EvaluateVisitor__runUserDefinedCallable___closure1.prototype = {
            call$0: function() {
                var parameters, t5, minLength, i, parameter, t6, value, t7, t8, restParameter, rest, argumentList, result, parameterWord, _this = this, t1 = _this.$this, t2 = _this.evaluated._values, t3 = _this.callable.declaration.parameters, t4 = _this.nodeWithSpan;
                t1._evaluate0$_verifyArguments$4(t2[2].length, t2[0], t3, t4);
                parameters = t3.parameters;
                t5 = parameters.length;
                minLength = Math.min(t2[2].length, t5);
                for(i = 0; i < minLength; ++i)t1._evaluate0$_environment.setLocalVariable$3(parameters[i].name, t2[2][i], t2[3][i]);
                for(i = t2[2].length; i < t5; ++i){
                    parameter = parameters[i];
                    t6 = parameter.name;
                    value = t2[0].remove$1(0, t6);
                    if (value == null) {
                        t7 = parameter.defaultValue;
                        value = t1._evaluate0$_withoutSlash$2(t7.accept$1(t1), t1._evaluate0$_expressionNode$1(t7));
                    }
                    t7 = t1._evaluate0$_environment;
                    t8 = t2[1].$index(0, t6);
                    if (t8 == null) {
                        t8 = parameter.defaultValue;
                        t8.toString;
                        t8 = t1._evaluate0$_expressionNode$1(t8);
                    }
                    t7.setLocalVariable$3(t6, value, t8);
                }
                restParameter = t3.restParameter;
                if (restParameter != null) {
                    t6 = t2[2];
                    rest = t6.length > t5 ? B.JSArray_methods.sublist$1(t6, t5) : B.List_empty23;
                    t5 = t2[0];
                    t6 = t2[4];
                    argumentList = A.SassArgumentList$0(rest, t5, t6 === B.ListSeparator_undecided_null_3_undecided0 ? B.ListSeparator_z0K0 : t6);
                    t1._evaluate0$_environment.setLocalVariable$3(restParameter, argumentList, t4);
                } else argumentList = null;
                result = _this.run.call$0();
                if (argumentList == null) return result;
                t5 = t2[0].__js_helper$_length;
                if (t5 === 0) return result;
                if (argumentList._argument_list$_wereKeywordsAccessed) return result;
                parameterWord = A.pluralize0("parameter", t5, null);
                t2 = t2[0];
                t5 = A._instanceType(t2)._eval$1("LinkedHashMapKeysIterable<1>");
                throw A.wrapException(A.MultiSpanSassRuntimeException$0("No " + parameterWord + " named " + A.toSentence0(A.MappedIterable_MappedIterable(new A.LinkedHashMapKeysIterable(t2, t5), new A._EvaluateVisitor__runUserDefinedCallable____closure1(), t5._eval$1("Iterable.E"), type$.Object), "or") + ".", t4.get$span(t4), "invocation", A.LinkedHashMap_LinkedHashMap$_literal([
                    t3.get$spanWithName(),
                    "declaration"
                ], type$.FileSpan, type$.String), t1._evaluate0$_stackTrace$1(t4.get$span(t4)), null));
            },
            $signature: function() {
                return this.V._eval$1("0()");
            }
        };
        A._EvaluateVisitor__runUserDefinedCallable____closure1.prototype = {
            call$1: function($name) {
                return "$" + $name;
            },
            $signature: 6
        };
        A._EvaluateVisitor__runFunctionCallable_closure1.prototype = {
            call$0: function() {
                var t1, t2, t3, t4, _i, $returnValue;
                for(t1 = this.callable.declaration, t2 = t1.children, t3 = t2.length, t4 = this.$this, _i = 0; _i < t3; ++_i){
                    $returnValue = t2[_i].accept$1(t4);
                    if ($returnValue instanceof A.Value0) return $returnValue;
                }
                throw A.wrapException(t4._evaluate0$_exception$2("Function finished without @return.", t1.span));
            },
            $signature: 46
        };
        A._EvaluateVisitor__runBuiltInCallable_closure5.prototype = {
            call$0: function() {
                return this._box_0.overload.verify$2(this.evaluated._values[2].length, this.namedSet);
            },
            $signature: 0
        };
        A._EvaluateVisitor__runBuiltInCallable_closure6.prototype = {
            call$0: function() {
                return this._box_0.callback.call$1(this.evaluated._values[2]);
            },
            $signature: 46
        };
        A._EvaluateVisitor__runBuiltInCallable_closure7.prototype = {
            call$1: function($name) {
                return "$" + $name;
            },
            $signature: 6
        };
        A._EvaluateVisitor__evaluateArguments_closure7.prototype = {
            call$1: function(value) {
                return value;
            },
            $signature: 41
        };
        A._EvaluateVisitor__evaluateArguments_closure8.prototype = {
            call$1: function(value) {
                return this.$this._evaluate0$_withoutSlash$2(value, this.restNodeForSpan);
            },
            $signature: 41
        };
        A._EvaluateVisitor__evaluateArguments_closure9.prototype = {
            call$2: function(key, value) {
                var _this = this, t1 = _this.restNodeForSpan;
                _this.named.$indexSet(0, key, _this.$this._evaluate0$_withoutSlash$2(value, t1));
                _this.namedNodes.$indexSet(0, key, t1);
            },
            $signature: 112
        };
        A._EvaluateVisitor__evaluateArguments_closure10.prototype = {
            call$1: function(value) {
                return value;
            },
            $signature: 41
        };
        A._EvaluateVisitor__evaluateMacroArguments_closure7.prototype = {
            call$1: function(value) {
                var t1 = this.restArgs;
                return new A.ValueExpression0(value, t1.get$span(t1));
            },
            $signature: 65
        };
        A._EvaluateVisitor__evaluateMacroArguments_closure8.prototype = {
            call$1: function(value) {
                var t1 = this.restArgs;
                return new A.ValueExpression0(this.$this._evaluate0$_withoutSlash$2(value, this.restNodeForSpan), t1.get$span(t1));
            },
            $signature: 65
        };
        A._EvaluateVisitor__evaluateMacroArguments_closure9.prototype = {
            call$2: function(key, value) {
                var _this = this, t1 = _this.restArgs;
                _this.named.$indexSet(0, key, new A.ValueExpression0(_this.$this._evaluate0$_withoutSlash$2(value, _this.restNodeForSpan), t1.get$span(t1)));
            },
            $signature: 112
        };
        A._EvaluateVisitor__evaluateMacroArguments_closure10.prototype = {
            call$1: function(value) {
                var t1 = this.keywordRestArgs;
                return new A.ValueExpression0(this.$this._evaluate0$_withoutSlash$2(value, this.keywordRestNodeForSpan), t1.get$span(t1));
            },
            $signature: 65
        };
        A._EvaluateVisitor__addRestMap_closure1.prototype = {
            call$2: function(key, value) {
                var t2, _this = this, t1 = _this.$this;
                if (key instanceof A.SassString0) _this.values.$indexSet(0, key._string0$_text, _this.convert.call$1(t1._evaluate0$_withoutSlash$2(value, _this.expressionNode)));
                else {
                    t2 = _this.nodeWithSpan;
                    throw A.wrapException(t1._evaluate0$_exception$2(string$.Variab_ + key.toString$0(0) + " is not a string in " + _this.map.toString$0(0) + ".", t2.get$span(t2)));
                }
            },
            $signature: 117
        };
        A._EvaluateVisitor__verifyArguments_closure1.prototype = {
            call$0: function() {
                return this.parameters.verify$2(this.positional, new A.MapKeySet(this.named, type$.MapKeySet_String));
            },
            $signature: 0
        };
        A._EvaluateVisitor_visitCssAtRule_closure5.prototype = {
            call$0: function() {
                var t1, t2, t3, t4;
                for(t1 = this.node.children, t2 = t1.$ti, t1 = new A.ListIterator(t1, t1.get$length(0), t2._eval$1("ListIterator<ListBase.E>")), t3 = this.$this, t2 = t2._eval$1("ListBase.E"); t1.moveNext$0();){
                    t4 = t1.__internal$_current;
                    (t4 == null ? t2._as(t4) : t4).accept$1(t3);
                }
            },
            $signature: 1
        };
        A._EvaluateVisitor_visitCssAtRule_closure6.prototype = {
            call$0: function() {
                var t1, t2, t3, t4;
                for(t1 = this.node.children, t2 = t1.$ti, t1 = new A.ListIterator(t1, t1.get$length(0), t2._eval$1("ListIterator<ListBase.E>")), t3 = this.$this, t2 = t2._eval$1("ListBase.E"); t1.moveNext$0();){
                    t4 = t1.__internal$_current;
                    (t4 == null ? t2._as(t4) : t4).accept$1(t3);
                }
            },
            $signature: 1
        };
        A._EvaluateVisitor_visitCssAtRule_closure7.prototype = {
            call$1: function(node) {
                return node instanceof A.ModifiableCssStyleRule0;
            },
            $signature: 8
        };
        A._EvaluateVisitor_visitCssKeyframeBlock_closure3.prototype = {
            call$0: function() {
                var t1, t2, t3, t4;
                for(t1 = this.node.children, t2 = t1.$ti, t1 = new A.ListIterator(t1, t1.get$length(0), t2._eval$1("ListIterator<ListBase.E>")), t3 = this.$this, t2 = t2._eval$1("ListBase.E"); t1.moveNext$0();){
                    t4 = t1.__internal$_current;
                    (t4 == null ? t2._as(t4) : t4).accept$1(t3);
                }
            },
            $signature: 1
        };
        A._EvaluateVisitor_visitCssKeyframeBlock_closure4.prototype = {
            call$1: function(node) {
                return node instanceof A.ModifiableCssStyleRule0;
            },
            $signature: 8
        };
        A._EvaluateVisitor_visitCssMediaRule_closure7.prototype = {
            call$0: function() {
                var t1, t2, t3, t4;
                for(t1 = this.node.children, t2 = t1.$ti, t1 = new A.ListIterator(t1, t1.get$length(0), t2._eval$1("ListIterator<ListBase.E>")), t3 = this.$this, t2 = t2._eval$1("ListBase.E"); t1.moveNext$0();){
                    t4 = t1.__internal$_current;
                    (t4 == null ? t2._as(t4) : t4).accept$1(t3);
                }
            },
            $signature: 1
        };
        A._EvaluateVisitor_visitCssMediaRule_closure8.prototype = {
            call$1: function(mediaQueries) {
                return this.$this._evaluate0$_mergeMediaQueries$2(mediaQueries, this.node.queries);
            },
            $signature: 104
        };
        A._EvaluateVisitor_visitCssMediaRule_closure9.prototype = {
            call$0: function() {
                var _this = this, t1 = _this.$this, t2 = _this.mergedQueries;
                if (t2 == null) t2 = _this.node.queries;
                t1._evaluate0$_withMediaQueries$3(t2, _this.mergedSources, new A._EvaluateVisitor_visitCssMediaRule__closure1(t1, _this.node));
            },
            $signature: 1
        };
        A._EvaluateVisitor_visitCssMediaRule__closure1.prototype = {
            call$0: function() {
                var t2, t3, t4, t1 = this.$this, _0_0 = t1._evaluate0$_atRootExcludingStyleRule ? null : t1._evaluate0$_styleRuleIgnoringAtRoot;
                if (_0_0 != null) t1._evaluate0$_withParent$2$3$scopeWhen(A.ModifiableCssStyleRule$0(_0_0._style_rule0$_selector, _0_0.span, false, _0_0.originalSelector), new A._EvaluateVisitor_visitCssMediaRule___closure1(t1, this.node), false, type$.ModifiableCssStyleRule_2, type$.Null);
                else for(t2 = this.node.children, t3 = t2.$ti, t2 = new A.ListIterator(t2, t2.get$length(0), t3._eval$1("ListIterator<ListBase.E>")), t3 = t3._eval$1("ListBase.E"); t2.moveNext$0();){
                    t4 = t2.__internal$_current;
                    (t4 == null ? t3._as(t4) : t4).accept$1(t1);
                }
            },
            $signature: 1
        };
        A._EvaluateVisitor_visitCssMediaRule___closure1.prototype = {
            call$0: function() {
                var t1, t2, t3, t4;
                for(t1 = this.node.children, t2 = t1.$ti, t1 = new A.ListIterator(t1, t1.get$length(0), t2._eval$1("ListIterator<ListBase.E>")), t3 = this.$this, t2 = t2._eval$1("ListBase.E"); t1.moveNext$0();){
                    t4 = t1.__internal$_current;
                    (t4 == null ? t2._as(t4) : t4).accept$1(t3);
                }
            },
            $signature: 1
        };
        A._EvaluateVisitor_visitCssMediaRule_closure10.prototype = {
            call$1: function(node) {
                var t1;
                if (!(node instanceof A.ModifiableCssStyleRule0)) {
                    t1 = this.mergedSources;
                    t1 = t1.get$isNotEmpty(t1) && node instanceof A.ModifiableCssMediaRule0 && B.JSArray_methods.every$1(node.queries, t1.get$contains(t1));
                } else t1 = true;
                return t1;
            },
            $signature: 8
        };
        A._EvaluateVisitor_visitCssStyleRule_closure4.prototype = {
            call$0: function() {
                var t1 = this.$this;
                t1._evaluate0$_withStyleRule$2(this.rule, new A._EvaluateVisitor_visitCssStyleRule__closure1(t1, this.node));
            },
            $signature: 1
        };
        A._EvaluateVisitor_visitCssStyleRule__closure1.prototype = {
            call$0: function() {
                var t1, t2, t3, t4;
                for(t1 = this.node.children, t2 = t1.$ti, t1 = new A.ListIterator(t1, t1.get$length(0), t2._eval$1("ListIterator<ListBase.E>")), t3 = this.$this, t2 = t2._eval$1("ListBase.E"); t1.moveNext$0();){
                    t4 = t1.__internal$_current;
                    (t4 == null ? t2._as(t4) : t4).accept$1(t3);
                }
            },
            $signature: 1
        };
        A._EvaluateVisitor_visitCssStyleRule_closure3.prototype = {
            call$1: function(node) {
                return node instanceof A.ModifiableCssStyleRule0;
            },
            $signature: 8
        };
        A._EvaluateVisitor_visitCssSupportsRule_closure5.prototype = {
            call$0: function() {
                var t1, t2, t3, t4;
                for(t1 = this.node.children, t2 = t1.$ti, t1 = new A.ListIterator(t1, t1.get$length(0), t2._eval$1("ListIterator<ListBase.E>")), t3 = this.$this, t2 = t2._eval$1("ListBase.E"); t1.moveNext$0();){
                    t4 = t1.__internal$_current;
                    (t4 == null ? t2._as(t4) : t4).accept$1(t3);
                }
            },
            $signature: 1
        };
        A._EvaluateVisitor_visitCssSupportsRule_closure6.prototype = {
            call$0: function() {
                var t2, t3, t4, t1 = this.$this, _0_0 = t1._evaluate0$_atRootExcludingStyleRule ? null : t1._evaluate0$_styleRuleIgnoringAtRoot;
                if (_0_0 != null) t1._evaluate0$_withParent$2$2(A.ModifiableCssStyleRule$0(_0_0._style_rule0$_selector, _0_0.span, false, _0_0.originalSelector), new A._EvaluateVisitor_visitCssSupportsRule__closure1(t1, this.node), type$.ModifiableCssStyleRule_2, type$.Null);
                else for(t2 = this.node.children, t3 = t2.$ti, t2 = new A.ListIterator(t2, t2.get$length(0), t3._eval$1("ListIterator<ListBase.E>")), t3 = t3._eval$1("ListBase.E"); t2.moveNext$0();){
                    t4 = t2.__internal$_current;
                    (t4 == null ? t3._as(t4) : t4).accept$1(t1);
                }
            },
            $signature: 1
        };
        A._EvaluateVisitor_visitCssSupportsRule__closure1.prototype = {
            call$0: function() {
                var t1, t2, t3, t4;
                for(t1 = this.node.children, t2 = t1.$ti, t1 = new A.ListIterator(t1, t1.get$length(0), t2._eval$1("ListIterator<ListBase.E>")), t3 = this.$this, t2 = t2._eval$1("ListBase.E"); t1.moveNext$0();){
                    t4 = t1.__internal$_current;
                    (t4 == null ? t2._as(t4) : t4).accept$1(t3);
                }
            },
            $signature: 1
        };
        A._EvaluateVisitor_visitCssSupportsRule_closure7.prototype = {
            call$1: function(node) {
                return node instanceof A.ModifiableCssStyleRule0;
            },
            $signature: 8
        };
        A._EvaluateVisitor__performInterpolationHelper_closure1.prototype = {
            call$1: function(targetOffsets) {
                return A.InterpolationMap$0(this.interpolation, targetOffsets);
            },
            $signature: 220
        };
        A._EvaluateVisitor__serialize_closure1.prototype = {
            call$0: function() {
                return A.serializeValue0(this.value, false, this.quote);
            },
            $signature: 29
        };
        A._EvaluateVisitor__expressionNode_closure1.prototype = {
            call$0: function() {
                var t1 = this.expression;
                return this.$this._evaluate0$_environment.getVariableNode$2$namespace(t1.name, t1.namespace);
            },
            $signature: 221
        };
        A._EvaluateVisitor__withoutSlash_recommendation1.prototype = {
            call$1: function(number) {
                var before, after, t1, _1_0 = number.asSlash;
                $label0$0: {
                    if (type$.Record_2_nullable_Object_and_nullable_Object._is(_1_0)) {
                        before = _1_0._0;
                        after = _1_0._1;
                        t1 = "math.div(" + A.S(this.call$1(before)) + ", " + A.S(this.call$1(after)) + ")";
                        break $label0$0;
                    }
                    t1 = A.serializeValue0(number, true, true);
                    break $label0$0;
                }
                return t1;
            },
            $signature: 222
        };
        A._EvaluateVisitor__stackFrame_closure1.prototype = {
            call$1: function(url) {
                var t1 = this.$this._evaluate0$_importCache;
                t1 = t1 == null ? null : t1.humanize$1(url);
                return t1 == null ? url : t1;
            },
            $signature: 49
        };
        A._ImportedCssVisitor1.prototype = {
            visitCssAtRule$1: function(node) {
                var t1 = node.isChildless ? null : new A._ImportedCssVisitor_visitCssAtRule_closure1();
                this._evaluate0$_visitor._evaluate0$_addChild$2$through(node, t1);
            },
            visitCssComment$1: function(node) {
                return this._evaluate0$_visitor._evaluate0$_addChild$1(node);
            },
            visitCssDeclaration$1: function(node) {
                return this._evaluate0$_visitor._evaluate0$_addChild$1(node);
            },
            visitCssImport$1: function(node) {
                var t2, _s13_ = "_endOfImports", t1 = this._evaluate0$_visitor;
                if (t1._evaluate0$_assertInModule$2(t1._evaluate0$__parent, "__parent") !== t1._evaluate0$_assertInModule$2(t1._evaluate0$__root, "_root")) t1._evaluate0$_addChild$1(node);
                else if (t1._evaluate0$_assertInModule$2(t1._evaluate0$__endOfImports, _s13_) === J.get$length$asx(t1._evaluate0$_assertInModule$2(t1._evaluate0$__root, "_root").children._collection$_source)) {
                    t1._evaluate0$_addChild$1(node);
                    t1._evaluate0$__endOfImports = t1._evaluate0$_assertInModule$2(t1._evaluate0$__endOfImports, _s13_) + 1;
                } else {
                    t2 = t1._evaluate0$_outOfOrderImports;
                    (t2 == null ? t1._evaluate0$_outOfOrderImports = A._setArrayType([], type$.JSArray_ModifiableCssImport_2) : t2).push(node);
                }
            },
            visitCssKeyframeBlock$1: function(node) {},
            visitCssMediaRule$1: function(node) {
                var t1 = this._evaluate0$_visitor, mediaQueries = t1._evaluate0$_mediaQueries;
                t1._evaluate0$_addChild$2$through(node, new A._ImportedCssVisitor_visitCssMediaRule_closure1(mediaQueries == null || t1._evaluate0$_mergeMediaQueries$2(mediaQueries, node.queries) != null));
            },
            visitCssStyleRule$1: function(node) {
                return this._evaluate0$_visitor._evaluate0$_addChild$2$through(node, new A._ImportedCssVisitor_visitCssStyleRule_closure1());
            },
            visitCssStylesheet$1: function(node) {
                var t1, t2, t3;
                for(t1 = node.children, t2 = t1.$ti, t1 = new A.ListIterator(t1, t1.get$length(0), t2._eval$1("ListIterator<ListBase.E>")), t2 = t2._eval$1("ListBase.E"); t1.moveNext$0();){
                    t3 = t1.__internal$_current;
                    (t3 == null ? t2._as(t3) : t3).accept$1(this);
                }
            },
            visitCssSupportsRule$1: function(node) {
                return this._evaluate0$_visitor._evaluate0$_addChild$2$through(node, new A._ImportedCssVisitor_visitCssSupportsRule_closure1());
            }
        };
        A._ImportedCssVisitor_visitCssAtRule_closure1.prototype = {
            call$1: function(node) {
                return node instanceof A.ModifiableCssStyleRule0;
            },
            $signature: 8
        };
        A._ImportedCssVisitor_visitCssMediaRule_closure1.prototype = {
            call$1: function(node) {
                var t1;
                if (!(node instanceof A.ModifiableCssStyleRule0)) t1 = this.hasBeenMerged && node instanceof A.ModifiableCssMediaRule0;
                else t1 = true;
                return t1;
            },
            $signature: 8
        };
        A._ImportedCssVisitor_visitCssStyleRule_closure1.prototype = {
            call$1: function(node) {
                return node instanceof A.ModifiableCssStyleRule0;
            },
            $signature: 8
        };
        A._ImportedCssVisitor_visitCssSupportsRule_closure1.prototype = {
            call$1: function(node) {
                return node instanceof A.ModifiableCssStyleRule0;
            },
            $signature: 8
        };
        A._EvaluationContext1.prototype = {
            get$currentCallableSpan: function() {
                var _0_0 = this._evaluate0$_visitor._evaluate0$_callableNode;
                if (_0_0 != null) return _0_0.get$span(_0_0);
                throw A.wrapException(A.StateError$(string$.No_Sasc));
            },
            warn$2: function(_, message, deprecation) {
                var t1 = this._evaluate0$_visitor, t2 = t1._evaluate0$_importSpan;
                if (t2 == null) {
                    t2 = t1._evaluate0$_callableNode;
                    t2 = t2 == null ? null : t2.get$span(t2);
                }
                t1._evaluate0$_warn$3(message, t2 == null ? this._evaluate0$_defaultWarnNodeWithSpan.span : t2, deprecation);
            }
        };
        A.EvaluationContext0.prototype = {};
        A._EvaluationContextLogger0.prototype = {
            internalWarn$4$deprecation$span$trace: function(message, deprecation, span, trace) {
                this._evaluation_context0$_context.warn$2(0, message, deprecation);
            }
        };
        A.EveryCssVisitor0.prototype = {
            visitCssAtRule$1: function(node) {
                var t1 = node.children;
                return t1.every$1(t1, new A.EveryCssVisitor_visitCssAtRule_closure0(this));
            },
            visitCssComment$1: function(node) {
                return false;
            },
            visitCssDeclaration$1: function(node) {
                return false;
            },
            visitCssImport$1: function(node) {
                return false;
            },
            visitCssKeyframeBlock$1: function(node) {
                var t1 = node.children;
                return t1.every$1(t1, new A.EveryCssVisitor_visitCssKeyframeBlock_closure0(this));
            },
            visitCssMediaRule$1: function(node) {
                var t1 = node.children;
                return t1.every$1(t1, new A.EveryCssVisitor_visitCssMediaRule_closure0(this));
            },
            visitCssStyleRule$1: function(node) {
                var t1 = node.children;
                return t1.every$1(t1, new A.EveryCssVisitor_visitCssStyleRule_closure0(this));
            },
            visitCssStylesheet$1: function(node) {
                return J.every$1$ax(node.get$children(node), new A.EveryCssVisitor_visitCssStylesheet_closure0(this));
            },
            visitCssSupportsRule$1: function(node) {
                var t1 = node.children;
                return t1.every$1(t1, new A.EveryCssVisitor_visitCssSupportsRule_closure0(this));
            }
        };
        A.EveryCssVisitor_visitCssAtRule_closure0.prototype = {
            call$1: function(child) {
                return child.accept$1(this.$this);
            },
            $signature: 8
        };
        A.EveryCssVisitor_visitCssKeyframeBlock_closure0.prototype = {
            call$1: function(child) {
                return child.accept$1(this.$this);
            },
            $signature: 8
        };
        A.EveryCssVisitor_visitCssMediaRule_closure0.prototype = {
            call$1: function(child) {
                return child.accept$1(this.$this);
            },
            $signature: 8
        };
        A.EveryCssVisitor_visitCssStyleRule_closure0.prototype = {
            call$1: function(child) {
                return child.accept$1(this.$this);
            },
            $signature: 8
        };
        A.EveryCssVisitor_visitCssStylesheet_closure0.prototype = {
            call$1: function(child) {
                return child.accept$1(this.$this);
            },
            $signature: 8
        };
        A.EveryCssVisitor_visitCssSupportsRule_closure0.prototype = {
            call$1: function(child) {
                return child.accept$1(this.$this);
            },
            $signature: 8
        };
        A._NodeException.prototype = {};
        A.exceptionClass_closure.prototype = {
            call$0: function() {
                var jsClass = type$.JSClass._as(new self.Function("", "    return class Exception extends Error {\n      constructor(dartException, message) {\n        super(message);\n\n        // Define this as non-enumerable so that it doesn't show up when the\n        // exception hits the top level.\n        Object.defineProperty(this, '_dartException', {\n          value: dartException,\n          enumerable: false\n        });\n      }\n\n      toString() {\n        return this.message;\n      }\n    }\n  ").call$0());
                A.defineGetter(jsClass, "name", null, "sass.Exception");
                A.LinkedHashMap_LinkedHashMap$_literal([
                    "sassMessage",
                    new A.exceptionClass__closure(),
                    "sassStack",
                    new A.exceptionClass__closure0(),
                    "span",
                    new A.exceptionClass__closure1()
                ], type$.String, type$.Function).forEach$1(0, A.JSClassExtension_get_defineGetter(jsClass));
                return jsClass;
            },
            $signature: 17
        };
        A.exceptionClass__closure.prototype = {
            call$1: function(exception) {
                return J.get$_dartException$x(exception)._span_exception$_message;
            },
            $signature: 244
        };
        A.exceptionClass__closure0.prototype = {
            call$1: function(exception) {
                return J.get$trace$z(J.get$_dartException$x(exception)).toString$0(0);
            },
            $signature: 244
        };
        A.exceptionClass__closure1.prototype = {
            call$1: function(exception) {
                var t1 = J.get$_dartException$x(exception), t2 = J.getInterceptor$x(t1);
                return A.SourceSpanException.prototype.get$span.call(t2, t1);
            },
            $signature: 470
        };
        A.SassException0.prototype = {
            get$trace: function(_) {
                return A.Trace$(A._setArrayType([
                    A.frameForSpan0(A.SourceSpanException.prototype.get$span.call(this, 0), "root stylesheet", null)
                ], type$.JSArray_Frame), null);
            },
            get$span: function(_) {
                return A.SourceSpanException.prototype.get$span.call(this, 0);
            },
            withAdditionalSpan$2: function(span, label) {
                return A.MultiSpanSassException$0(this._span_exception$_message, A.SourceSpanException.prototype.get$span.call(this, 0), "", A.LinkedHashMap_LinkedHashMap$_literal([
                    span,
                    label
                ], type$.FileSpan, type$.String), this.loadedUrls);
            },
            withTrace$1: function(trace) {
                var t1 = A.SourceSpanException.prototype.get$span.call(this, 0), t2 = A.Set_Set$unmodifiable(this.loadedUrls, type$.Uri);
                return new A.SassRuntimeException0(trace, t2, this._span_exception$_message, t1);
            },
            withLoadedUrls$1: function(loadedUrls) {
                var t1 = A.SourceSpanException.prototype.get$span.call(this, 0), t2 = A.Set_Set$unmodifiable(loadedUrls, type$.Uri);
                return new A.SassException0(t2, this._span_exception$_message, t1);
            },
            toString$1$color: function(_, color) {
                var t2, _i, frame, _this = this, buffer = new A.StringBuffer(""), t1 = "Error: " + _this._span_exception$_message + "\n";
                buffer._contents = t1;
                buffer._contents = t1 + A.SourceSpanException.prototype.get$span.call(_this, 0).highlight$1$color(color);
                for(t1 = _this.get$trace(_this).toString$0(0).split("\n"), t2 = t1.length, _i = 0; _i < t2; ++_i){
                    frame = t1[_i];
                    if (frame.length === 0) continue;
                    buffer._contents = (buffer._contents += "\n") + ("  " + frame);
                }
                t1 = buffer._contents;
                return t1.charCodeAt(0) == 0 ? t1 : t1;
            },
            toString$0: function(_) {
                return this.toString$1$color(0, null);
            }
        };
        A.MultiSpanSassException0.prototype = {
            withAdditionalSpan$2: function(span, label) {
                var _this = this, t1 = A.SourceSpanException.prototype.get$span.call(_this, 0), t2 = A.LinkedHashMap_LinkedHashMap$of(_this.secondarySpans, type$.FileSpan, type$.String);
                t2.$indexSet(0, span, label);
                return A.MultiSpanSassException$0(_this._span_exception$_message, t1, _this.primaryLabel, t2, _this.loadedUrls);
            },
            withTrace$1: function(trace) {
                var _this = this;
                return A.MultiSpanSassRuntimeException$0(_this._span_exception$_message, A.SourceSpanException.prototype.get$span.call(_this, 0), _this.primaryLabel, _this.secondarySpans, trace, _this.loadedUrls);
            },
            withLoadedUrls$1: function(loadedUrls) {
                var _this = this;
                return A.MultiSpanSassException$0(_this._span_exception$_message, A.SourceSpanException.prototype.get$span.call(_this, 0), _this.primaryLabel, _this.secondarySpans, loadedUrls);
            },
            toString$1$color: function(_, color) {
                var t1, t2, _i, frame, _this = this, useColor = color === true, buffer = new A.StringBuffer("Error: " + _this._span_exception$_message + "\n");
                A.NullableExtension_andThen0(A.Highlighter$multiple(A.SourceSpanException.prototype.get$span.call(_this, 0), _this.primaryLabel, _this.secondarySpans, useColor, null, null).highlight$0(), buffer.get$write(buffer));
                for(t1 = _this.get$trace(_this).toString$0(0).split("\n"), t2 = t1.length, _i = 0; _i < t2; ++_i){
                    frame = t1[_i];
                    if (frame.length === 0) continue;
                    buffer._contents = (buffer._contents += "\n") + ("  " + frame);
                }
                t1 = buffer._contents;
                return t1.charCodeAt(0) == 0 ? t1 : t1;
            },
            toString$0: function(_) {
                return this.toString$1$color(0, null);
            },
            get$primaryLabel: function() {
                return this.primaryLabel;
            },
            get$secondarySpans: function() {
                return this.secondarySpans;
            }
        };
        A.SassRuntimeException0.prototype = {
            withAdditionalSpan$2: function(span, label) {
                var _this = this;
                return A.MultiSpanSassRuntimeException$0(_this._span_exception$_message, A.SourceSpanException.prototype.get$span.call(_this, 0), "", A.LinkedHashMap_LinkedHashMap$_literal([
                    span,
                    label
                ], type$.FileSpan, type$.String), _this.trace, _this.loadedUrls);
            },
            withLoadedUrls$1: function(loadedUrls) {
                var t1 = A.SourceSpanException.prototype.get$span.call(this, 0), t2 = A.Set_Set$unmodifiable(loadedUrls, type$.Uri);
                return new A.SassRuntimeException0(this.trace, t2, this._span_exception$_message, t1);
            },
            get$trace: function(receiver) {
                return this.trace;
            }
        };
        A.MultiSpanSassRuntimeException0.prototype = {
            withAdditionalSpan$2: function(span, label) {
                var _this = this, t1 = A.SourceSpanException.prototype.get$span.call(_this, 0), t2 = A.LinkedHashMap_LinkedHashMap$of(_this.secondarySpans, type$.FileSpan, type$.String);
                t2.$indexSet(0, span, label);
                return A.MultiSpanSassRuntimeException$0(_this._span_exception$_message, t1, _this.primaryLabel, t2, _this.trace, _this.loadedUrls);
            },
            withLoadedUrls$1: function(loadedUrls) {
                var _this = this;
                return A.MultiSpanSassRuntimeException$0(_this._span_exception$_message, A.SourceSpanException.prototype.get$span.call(_this, 0), _this.primaryLabel, _this.secondarySpans, _this.trace, loadedUrls);
            },
            $isSassRuntimeException0: 1,
            get$trace: function(receiver) {
                return this.trace;
            }
        };
        A.SassFormatException0.prototype = {
            get$source: function() {
                var t1 = A.SourceSpanException.prototype.get$span.call(this, 0);
                return A.String_String$fromCharCodes(B.NativeUint32List_methods.sublist$2(t1.get$file(t1)._decodedChars, 0, null), 0, null);
            },
            withAdditionalSpan$2: function(span, label) {
                return A.MultiSpanSassFormatException$0(this._span_exception$_message, A.SourceSpanException.prototype.get$span.call(this, 0), "", A.LinkedHashMap_LinkedHashMap$_literal([
                    span,
                    label
                ], type$.FileSpan, type$.String), this.loadedUrls);
            },
            withLoadedUrls$1: function(loadedUrls) {
                var t1 = A.SourceSpanException.prototype.get$span.call(this, 0), t2 = A.Set_Set$unmodifiable(loadedUrls, type$.Uri);
                return new A.SassFormatException0(t2, this._span_exception$_message, t1);
            },
            $isFormatException: 1,
            $isSourceSpanFormatException: 1
        };
        A.MultiSpanSassFormatException0.prototype = {
            get$source: function() {
                var t1 = A.SourceSpanException.prototype.get$span.call(this, 0);
                return A.String_String$fromCharCodes(B.NativeUint32List_methods.sublist$2(t1.get$file(t1)._decodedChars, 0, null), 0, null);
            },
            withAdditionalSpan$2: function(span, label) {
                var _this = this, t1 = A.SourceSpanException.prototype.get$span.call(_this, 0), t2 = A.LinkedHashMap_LinkedHashMap$of(_this.secondarySpans, type$.FileSpan, type$.String);
                t2.$indexSet(0, span, label);
                return A.MultiSpanSassFormatException$0(_this._span_exception$_message, t1, _this.primaryLabel, t2, _this.loadedUrls);
            },
            withLoadedUrls$1: function(loadedUrls) {
                var _this = this;
                return A.MultiSpanSassFormatException$0(_this._span_exception$_message, A.SourceSpanException.prototype.get$span.call(_this, 0), _this.primaryLabel, _this.secondarySpans, loadedUrls);
            },
            $isFormatException: 1,
            $isSourceSpanFormatException: 1,
            $isMultiSourceSpanFormatException: 1,
            $isSassFormatException0: 1
        };
        A.SassScriptException0.prototype = {
            withSpan$1: function(span) {
                return new A.SassException0(B.Set_empty, this.message, span);
            },
            toString$0: function(_) {
                return this.message + string$.x0a_BUG_;
            },
            get$message: function(receiver) {
                return this.message;
            }
        };
        A.MultiSpanSassScriptException0.prototype = {
            withSpan$1: function(span) {
                return A.MultiSpanSassException$0(this.message, span, this.primaryLabel, this.secondarySpans, null);
            }
        };
        A.Exports.prototype = {};
        A.LoggerNamespace.prototype = {};
        A.Expression0.prototype = {
            $isAstNode0: 1,
            $isSassNode: 1
        };
        A.JSExpressionVisitor.prototype = {
            visitBinaryOperationExpression$1: function(_, node) {
                return J.visitBinaryOperationExpression$1$x(this._expression$_inner, node);
            },
            visitBooleanExpression$1: function(_, node) {
                return J.visitBooleanExpression$1$x(this._expression$_inner, node);
            },
            visitColorExpression$1: function(_, node) {
                return J.visitColorExpression$1$x(this._expression$_inner, node);
            },
            visitInterpolatedFunctionExpression$1: function(_, node) {
                return J.visitInterpolatedFunctionExpression$1$x(this._expression$_inner, node);
            },
            visitFunctionExpression$1: function(_, node) {
                return J.visitFunctionExpression$1$x(this._expression$_inner, node);
            },
            visitIfExpression$1: function(_, node) {
                return J.visitIfExpression$1$x(this._expression$_inner, node);
            },
            visitLegacyIfExpression$1: function(_, node) {
                return J.visitLegacyIfExpression$1$x(this._expression$_inner, node);
            },
            visitListExpression$1: function(_, node) {
                return J.visitListExpression$1$x(this._expression$_inner, node);
            },
            visitMapExpression$1: function(_, node) {
                return J.visitMapExpression$1$x(this._expression$_inner, node);
            },
            visitNullExpression$1: function(_, node) {
                return J.visitNullExpression$1$x(this._expression$_inner, node);
            },
            visitNumberExpression$1: function(_, node) {
                return J.visitNumberExpression$1$x(this._expression$_inner, node);
            },
            visitParenthesizedExpression$1: function(_, node) {
                return J.visitParenthesizedExpression$1$x(this._expression$_inner, node);
            },
            visitSelectorExpression$1: function(_, node) {
                return J.visitSelectorExpression$1$x(this._expression$_inner, node);
            },
            visitStringExpression$1: function(_, node) {
                return J.visitStringExpression$1$x(this._expression$_inner, node);
            },
            visitSupportsExpression$1: function(_, node) {
                return J.visitSupportsExpression$1$x(this._expression$_inner, node);
            },
            visitUnaryOperationExpression$1: function(_, node) {
                return J.visitUnaryOperationExpression$1$x(this._expression$_inner, node);
            },
            visitValueExpression$1: function(_, node) {
                return J.visitValueExpression$1$x(this._expression$_inner, node);
            },
            visitVariableExpression$1: function(_, node) {
                return J.visitVariableExpression$1$x(this._expression$_inner, node);
            },
            $isExpressionVisitor: 1
        };
        A.JSExpressionVisitorObject.prototype = {};
        A._MakeExpressionCalculationSafe0.prototype = {
            visitBinaryOperationExpression$1: function(_, node) {
                var t1, t2;
                if (node.operator === B.BinaryOperator_bgA0) {
                    t1 = A.ArgumentList$0(A._setArrayType([
                        node
                    ], type$.JSArray_Expression_2), B.Map_empty14, B.Map_empty5, node.get$span(0), null, null);
                    t2 = node.get$span(0);
                    t1 = new A.FunctionExpression0("math", A.stringReplaceAllUnchecked("max", "_", "-"), "max", t1, t2);
                } else t1 = this.super$ReplaceExpressionVisitor$visitBinaryOperationExpression0(0, node);
                return t1;
            },
            visitInterpolatedFunctionExpression$1: function(_, node) {
                return node;
            },
            visitIfExpression$1: function(_, node) {
                return node;
            },
            visitUnaryOperationExpression$1: function(_, node) {
                var t1, _0_0 = node.operator;
                $label0$0: {
                    if (B.UnaryOperator_n2K0 === _0_0) {
                        t1 = node.operand;
                        break $label0$0;
                    }
                    if (B.UnaryOperator_hCO0 === _0_0) {
                        t1 = new A.BinaryOperationExpression0(B.BinaryOperator_wkM0, new A.NumberExpression0(-1, null, node.span), node.operand, false);
                        break $label0$0;
                    }
                    t1 = this.super$ReplaceExpressionVisitor$visitUnaryOperationExpression0(0, node);
                    break $label0$0;
                }
                return t1;
            },
            $isExpressionVisitor: 1,
            $isIfConditionExpressionVisitor: 1
        };
        A.__MakeExpressionCalculationSafe_Object_ReplaceExpressionVisitor0.prototype = {};
        A.ExtendRule0.prototype = {
            accept$1$1: function(visitor) {
                return visitor.visitExtendRule$1(0, this);
            },
            accept$1: function(visitor) {
                return this.accept$1$1(visitor, type$.dynamic);
            },
            toString$0: function(_) {
                var t1 = this.selector.toString$0(0), t2 = this.isOptional ? " !optional" : "";
                return "@extend " + t1 + t2 + ";";
            },
            get$span: function(receiver) {
                return this.span;
            }
        };
        A.Extension0.prototype = {
            toString$0: function(_) {
                var t1 = this.extender.toString$0(0), t2 = this.target.toString$0(0), t3 = this.isOptional ? " !optional" : "";
                return t1 + " {@extend " + t2 + t3 + "}";
            }
        };
        A.Extender0.prototype = {
            assertCompatibleMediaContext$1: function(mediaContext) {
                var expectedMediaContext, extension = this._extension$_extension;
                if (extension == null) return;
                expectedMediaContext = extension.mediaContext;
                if (expectedMediaContext == null) return;
                if (mediaContext != null && B.C_ListEquality.equals$2(0, expectedMediaContext, mediaContext)) return;
                throw A.wrapException(A.SassException$0(string$.You_ma, extension.span, null));
            },
            toString$0: function(_) {
                return A.serializeSelector0(this.selector, true);
            }
        };
        A.ExtensionStore0.prototype = {
            get$isEmpty: function(_) {
                return this._extension_store$_extensions.__js_helper$_length === 0;
            },
            get$simpleSelectors: function() {
                return new A.MapKeySet(this._extension_store$_selectors, type$.MapKeySet_SimpleSelector_2);
            },
            extensionsWhereTarget$1: function(callback) {
                return new A._SyncStarIterable(this.extensionsWhereTarget$body$ExtensionStore0(callback), type$._SyncStarIterable_Extension_2);
            },
            extensionsWhereTarget$body$ExtensionStore0: function($async$callback) {
                var $async$self = this;
                return function() {
                    var callback = $async$callback;
                    var $async$goto = 0, $async$handler = 1, $async$errorStack = [], t1, t2, simple, sources, t3;
                    return function $async$extensionsWhereTarget$1($async$iterator, $async$errorCode, $async$result) {
                        if ($async$errorCode === 1) {
                            $async$errorStack.push($async$result);
                            $async$goto = $async$handler;
                        }
                        for(;;)switch($async$goto){
                            case 0:
                                // Function start
                                t1 = A.MapExtensions_get_pairs0($async$self._extension_store$_extensions, type$.SimpleSelector_2, type$.Map_ComplexSelector_Extension_2), t1 = t1.get$iterator(t1);
                            case 2:
                                // for condition
                                if (!t1.moveNext$0()) {
                                    // goto after for
                                    $async$goto = 3;
                                    break;
                                }
                                t2 = t1.get$current(t1);
                                simple = t2._0;
                                sources = t2._1;
                                if (!callback.call$1(simple)) {
                                    // goto for condition
                                    $async$goto = 2;
                                    break;
                                }
                                t2 = sources.get$values(sources), t2 = t2.get$iterator(t2);
                            case 4:
                                // for condition
                                if (!t2.moveNext$0()) {
                                    // goto after for
                                    $async$goto = 5;
                                    break;
                                }
                                t3 = t2.get$current(t2);
                                $async$goto = t3 instanceof A.MergedExtension0 ? 6 : 8;
                                break;
                            case 6:
                                // then
                                t3 = t3.unmerge$0();
                                $async$goto = 9;
                                return $async$iterator._yieldStar$1(new A.WhereIterable(t3, new A.ExtensionStore_extensionsWhereTarget_closure0(), t3.$ti._eval$1("WhereIterable<Iterable.E>")));
                            case 9:
                                // after yield
                                // goto join
                                $async$goto = 7;
                                break;
                            case 8:
                                // else
                                $async$goto = !t3.isOptional ? 10 : 11;
                                break;
                            case 10:
                                // then
                                $async$goto = 12;
                                return $async$iterator._async$_current = t3, 1;
                            case 12:
                            // after yield
                            case 11:
                            // join
                            case 7:
                                // join
                                // goto for condition
                                $async$goto = 4;
                                break;
                            case 5:
                                // after for
                                // goto for condition
                                $async$goto = 2;
                                break;
                            case 3:
                                // after for
                                // implicit return
                                return 0;
                            case 1:
                                // rethrow
                                return $async$iterator._datum = $async$errorStack.at(-1), 3;
                        }
                    };
                };
            },
            addSelector$2: function(selector, mediaContext) {
                var originalSelector, error, stackTrace, t1, _$exception, t2, t3, t4, modifiableSelector, _this = this;
                selector;
                originalSelector = selector;
                if (!originalSelector.accept$1(B._IsInvisibleVisitor_true0)) _this._extension_store$_originals.addAll$1(0, originalSelector.components);
                t1 = _this._extension_store$_extensions;
                if (t1.__js_helper$_length !== 0) try {
                    selector = _this._extension_store$_extendList$3(originalSelector, t1, mediaContext);
                } catch (exception) {
                    t1 = A.unwrapException(exception);
                    if (t1 instanceof A.SassException0) {
                        error = t1;
                        stackTrace = A.getTraceFromException(exception);
                        t1 = error;
                        t2 = J.getInterceptor$x(t1);
                        t1 = A.SourceSpanException.prototype.get$span.call(t2, t1).message$1(0, "");
                        t2 = error._span_exception$_message;
                        t3 = error;
                        t4 = J.getInterceptor$x(t3);
                        t3 = A.SourceSpanException.prototype.get$span.call(t4, t3);
                        A.throwWithTrace0(new A.SassException0(B.Set_empty, "From " + t1 + "\n" + t2, t3), error, stackTrace);
                    } else throw exception;
                }
                modifiableSelector = new A.ModifiableBox0(selector, type$.ModifiableBox_SelectorList_2);
                if (mediaContext != null) _this._extension_store$_mediaContexts.$indexSet(0, modifiableSelector, mediaContext);
                _this._extension_store$_registerSelector$2(selector, modifiableSelector);
                return new A.Box0(modifiableSelector, type$.Box_SelectorList_2);
            },
            _extension_store$_registerSelector$2: function(list, selector) {
                var t1, t2, t3, t4, _i, t5, t6, _i0, t7, t8, _i1, simple, _0_2_isSet, _0_2, t9, selectorInPseudo;
                for(t1 = list.components, t2 = t1.length, t3 = this._extension_store$_selectors, t4 = type$.SelectorList_2, _i = 0; _i < t2; ++_i)for(t5 = t1[_i].components, t6 = t5.length, _i0 = 0; _i0 < t6; ++_i0)for(t7 = t5[_i0].selector.components, t8 = t7.length, _i1 = 0; _i1 < t8; ++_i1){
                    simple = t7[_i1];
                    t3.putIfAbsent$2(simple, new A.ExtensionStore__registerSelector_closure0()).add$1(0, selector);
                    _0_2_isSet = simple instanceof A.PseudoSelector0;
                    _0_2 = null;
                    if (_0_2_isSet) {
                        _0_2 = simple.selector;
                        t9 = _0_2;
                        t9 = t9 != null;
                    } else t9 = false;
                    if (t9) {
                        selectorInPseudo = _0_2_isSet ? _0_2 : simple.selector;
                        this._extension_store$_registerSelector$2(selectorInPseudo == null ? t4._as(selectorInPseudo) : selectorInPseudo, selector);
                    }
                }
            },
            addExtension$4: function(extender, target, extend, mediaContext) {
                var t2, t3, t4, t5, t6, t7, t8, t9, t10, newExtensions, _i, complex, t11, extension, _0_0, t12, newExtensionsByTarget, additionalExtensions, _this = this, selectors = _this._extension_store$_selectors.$index(0, target), t1 = _this._extension_store$_extensionsByExtender, existingExtensions = t1.$index(0, target), sources = _this._extension_store$_extensions.putIfAbsent$2(target, new A.ExtensionStore_addExtension_closure2());
                for(t2 = extender.components, t3 = t2.length, t4 = selectors == null, t5 = _this._extension_store$_sourceSpecificity, t6 = extend.span, t7 = extend.isOptional, t8 = existingExtensions != null, t9 = type$.ComplexSelector_2, t10 = type$.Extension_2, newExtensions = null, _i = 0; _i < t3; ++_i){
                    complex = t2[_i];
                    if (complex.accept$1(B.C__IsUselessVisitor0)) continue;
                    complex.get$specificity();
                    t11 = new A.Extender0(complex, false);
                    extension = t11._extension$_extension = new A.Extension0(t11, target, mediaContext, t7, t6);
                    _0_0 = sources.$index(0, complex);
                    if (_0_0 != null) {
                        sources.$indexSet(0, complex, A.MergedExtension_merge0(_0_0, extension));
                        continue;
                    }
                    sources.$indexSet(0, complex, extension);
                    for(t11 = new A._SyncStarIterator(_this._extension_store$_simpleSelectors$1(complex)._outerHelper()); t11.moveNext$0();){
                        t12 = t11._async$_current;
                        J.add$1$ax(t1.putIfAbsent$2(t12, new A.ExtensionStore_addExtension_closure3()), extension);
                        t5.putIfAbsent$2(t12, new A.ExtensionStore_addExtension_closure4(complex));
                    }
                    if (!t4 || t8) {
                        if (newExtensions == null) newExtensions = A.LinkedHashMap_LinkedHashMap$_empty(t9, t10);
                        newExtensions.$indexSet(0, complex, extension);
                    }
                }
                if (newExtensions == null) return;
                t1 = type$.SimpleSelector_2;
                newExtensionsByTarget = A.LinkedHashMap_LinkedHashMap$_literal([
                    target,
                    newExtensions
                ], t1, type$.Map_ComplexSelector_Extension_2);
                if (t8) {
                    additionalExtensions = _this._extension_store$_extendExistingExtensions$2(existingExtensions, newExtensionsByTarget);
                    if (additionalExtensions != null) A.mapAddAll20(newExtensionsByTarget, additionalExtensions, t1, t9, t10);
                }
                if (!t4) _this._extension_store$_extendExistingSelectors$2(selectors, newExtensionsByTarget);
            },
            _extension_store$_simpleSelectors$1: function(complex) {
                return new A._SyncStarIterable(this._simpleSelectors$body$ExtensionStore0(complex), type$._SyncStarIterable_SimpleSelector_2);
            },
            _simpleSelectors$body$ExtensionStore0: function($async$complex) {
                var $async$self = this;
                return function() {
                    var complex = $async$complex;
                    var $async$goto = 0, $async$handler = 1, $async$errorStack = [], t1, t2, t3, _i, t4, t5, _i0, simple, _0_2_isSet, _0_2, t6, selector, t7, _i1;
                    return function $async$_extension_store$_simpleSelectors$1($async$iterator, $async$errorCode, $async$result) {
                        if ($async$errorCode === 1) {
                            $async$errorStack.push($async$result);
                            $async$goto = $async$handler;
                        }
                        for(;;)switch($async$goto){
                            case 0:
                                // Function start
                                t1 = complex.components, t2 = t1.length, t3 = type$.SelectorList_2, _i = 0;
                            case 2:
                                // for condition
                                if (!(_i < t2)) {
                                    // goto after for
                                    $async$goto = 4;
                                    break;
                                }
                                t4 = t1[_i].selector.components, t5 = t4.length, _i0 = 0;
                            case 5:
                                // for condition
                                if (!(_i0 < t5)) {
                                    // goto after for
                                    $async$goto = 7;
                                    break;
                                }
                                simple = t4[_i0];
                                $async$goto = 8;
                                return $async$iterator._async$_current = simple, 1;
                            case 8:
                                // after yield
                                _0_2_isSet = simple instanceof A.PseudoSelector0;
                                _0_2 = null;
                                if (_0_2_isSet) {
                                    _0_2 = simple.selector;
                                    t6 = _0_2;
                                    t6 = t6 != null;
                                } else t6 = false;
                                $async$goto = t6 ? 9 : 10;
                                break;
                            case 9:
                                // then
                                selector = _0_2_isSet ? _0_2 : simple.selector;
                                t6 = (selector == null ? t3._as(selector) : selector).components, t7 = t6.length, _i1 = 0;
                            case 11:
                                // for condition
                                if (!(_i1 < t7)) {
                                    // goto after for
                                    $async$goto = 13;
                                    break;
                                }
                                $async$goto = 14;
                                return $async$iterator._yieldStar$1($async$self._extension_store$_simpleSelectors$1(t6[_i1]));
                            case 14:
                            // after yield
                            case 12:
                                // for update
                                ++_i1;
                                // goto for condition
                                $async$goto = 11;
                                break;
                            case 13:
                            // after for
                            case 10:
                            // join
                            case 6:
                                // for update
                                ++_i0;
                                // goto for condition
                                $async$goto = 5;
                                break;
                            case 7:
                            // after for
                            case 3:
                                // for update
                                ++_i;
                                // goto for condition
                                $async$goto = 2;
                                break;
                            case 4:
                                // after for
                                // implicit return
                                return 0;
                            case 1:
                                // rethrow
                                return $async$iterator._datum = $async$errorStack.at(-1), 3;
                        }
                    };
                };
            },
            _extension_store$_extendExistingExtensions$2: function(extensions, newExtensions) {
                var extension, selectors, error, stackTrace, t1, t2, t3, t4, t5, t6, additionalExtensions, _i, t7, _$exception, t8, t9, selectors0, t10, t11, t12, t13, t14, withExtender, _0_0, _i0, _i1;
                for(t1 = J.toList$0$ax(extensions), t2 = t1.length, t3 = this._extension_store$_extensionsByExtender, t4 = type$.SimpleSelector_2, t5 = type$.Map_ComplexSelector_Extension_2, t6 = this._extension_store$_extensions, additionalExtensions = null, _i = 0; _i < t1.length; t1.length === t2 || (0, A.throwConcurrentModificationError)(t1), ++_i){
                    extension = t1[_i];
                    t7 = t6.$index(0, extension.target);
                    t7.toString;
                    selectors = null;
                    try {
                        selectors = this._extension_store$_extendComplex$3(extension.extender.selector, newExtensions, extension.mediaContext);
                        if (selectors == null) continue;
                    } catch (exception) {
                        t8 = A.unwrapException(exception);
                        if (t8 instanceof A.SassException0) {
                            error = t8;
                            stackTrace = A.getTraceFromException(exception);
                            A.throwWithTrace0(error.withAdditionalSpan$2(extension.extender.selector.span, "target selector"), error, stackTrace);
                        } else throw exception;
                    }
                    t8 = J.get$first$ax(selectors);
                    t9 = extension.extender.selector;
                    if (B.C_ListEquality.equals$2(0, t8.leadingCombinators, t9.leadingCombinators) && B.C_ListEquality.equals$2(0, t8.components, t9.components)) {
                        t8 = selectors;
                        t9 = A._arrayInstanceType(t8);
                        selectors0 = new A.SubListIterable(t8, 1, null, t9._eval$1("SubListIterable<1>"));
                        selectors0.SubListIterable$3(t8, 1, null, t9._precomputed1);
                        selectors = selectors0;
                    }
                    for(t8 = J.get$iterator$ax(selectors); t8.moveNext$0();){
                        t9 = t8.get$current(t8);
                        t10 = extension;
                        t11 = t10.target;
                        t12 = t10.span;
                        t13 = t10.mediaContext;
                        t10 = t10.isOptional;
                        t9.get$specificity();
                        t14 = new A.Extender0(t9, false);
                        withExtender = t14._extension$_extension = new A.Extension0(t14, t11, t13, t10, t12);
                        _0_0 = t7.$index(0, t9);
                        if (_0_0 != null) t7.$indexSet(0, t9, A.MergedExtension_merge0(_0_0, withExtender));
                        else {
                            t7.$indexSet(0, t9, withExtender);
                            for(t10 = t9.components, t11 = t10.length, _i0 = 0; _i0 < t11; ++_i0)for(t12 = t10[_i0].selector.components, t13 = t12.length, _i1 = 0; _i1 < t13; ++_i1)J.add$1$ax(t3.putIfAbsent$2(t12[_i1], new A.ExtensionStore__extendExistingExtensions_closure1()), withExtender);
                            if (newExtensions.containsKey$1(extension.target)) {
                                if (additionalExtensions == null) additionalExtensions = A.LinkedHashMap_LinkedHashMap$_empty(t4, t5);
                                additionalExtensions.putIfAbsent$2(extension.target, new A.ExtensionStore__extendExistingExtensions_closure2()).$indexSet(0, t9, withExtender);
                            }
                        }
                    }
                }
                return additionalExtensions;
            },
            _extension_store$_extendExistingSelectors$2: function(selectors, newExtensions) {
                var selector, error, stackTrace, t1, t2, oldValue, _$exception, t3, t4, t5, t6;
                for(t1 = selectors.get$iterator(selectors), t2 = this._extension_store$_mediaContexts; t1.moveNext$0();){
                    selector = t1.get$current(t1);
                    oldValue = selector.value;
                    try {
                        selector.value = this._extension_store$_extendList$3(selector.value, newExtensions, t2.$index(0, selector));
                    } catch (exception) {
                        t3 = A.unwrapException(exception);
                        if (t3 instanceof A.SassException0) {
                            error = t3;
                            stackTrace = A.getTraceFromException(exception);
                            t3 = selector.value.span.message$1(0, "");
                            t4 = error._span_exception$_message;
                            t5 = error;
                            t6 = J.getInterceptor$x(t5);
                            t5 = A.SourceSpanException.prototype.get$span.call(t6, t5);
                            A.throwWithTrace0(new A.SassException0(B.Set_empty, "From " + t3 + "\n" + t4, t5), error, stackTrace);
                        } else throw exception;
                    }
                    if (oldValue === selector.value) continue;
                    this._extension_store$_registerSelector$2(selector.value, selector);
                }
            },
            addExtensions$1: function(extensionStores) {
                var t1, t2, t3, t4, t5, t6, t7, t8, t9, t10, t11, newExtensions, selectorsToExtend, extensionsToExtend, t12, t13, target, newSources, first, extensionsForTarget, t14, selectorsForTarget, t15, _2_0, t16, extender, extension, _this = this, _null = null;
                for(t1 = J.get$iterator$ax(extensionStores), t2 = type$.SimpleSelector_2, t3 = type$.Map_ComplexSelector_Extension_2, t4 = _this._extension_store$_extensions, t5 = type$.ComplexSelector_2, t6 = type$.Extension_2, t7 = _this._extension_store$_selectors, t8 = _this._extension_store$_extensionsByExtender, t9 = type$.JSArray_Extension_2, t10 = type$.ModifiableBox_SelectorList_2, t11 = _this._extension_store$_sourceSpecificity, newExtensions = _null, selectorsToExtend = newExtensions, extensionsToExtend = selectorsToExtend; t1.moveNext$0();){
                    t12 = t1.get$current(t1);
                    if (t12.get$isEmpty(t12)) continue;
                    t11.addAll$1(0, t12.get$_extension_store$_sourceSpecificity());
                    for(t12 = A.MapExtensions_get_pairs0(t12.get$_extension_store$_extensions(), t2, t3), t12 = t12.get$iterator(t12); t12.moveNext$0();){
                        t13 = t12.get$current(t12);
                        target = t13._0;
                        newSources = t13._1;
                        if (target instanceof A.PlaceholderSelector0) {
                            first = target.name.charCodeAt(0);
                            t13 = first === 45 || first === 95;
                        } else t13 = false;
                        if (t13) continue;
                        extensionsForTarget = t8.$index(0, target);
                        t13 = extensionsForTarget == null;
                        if (!t13) {
                            if (extensionsToExtend == null) {
                                extensionsToExtend = A._setArrayType([], t9);
                                t14 = extensionsToExtend;
                            } else t14 = extensionsToExtend;
                            B.JSArray_methods.addAll$1(t14, extensionsForTarget);
                        }
                        selectorsForTarget = t7.$index(0, target);
                        t14 = selectorsForTarget != null;
                        if (t14) {
                            if (selectorsToExtend == null) {
                                selectorsToExtend = A.LinkedHashSet_LinkedHashSet$_empty(t10);
                                t15 = selectorsToExtend;
                            } else t15 = selectorsToExtend;
                            t15.addAll$1(0, selectorsForTarget);
                        }
                        _2_0 = t4.$index(0, target);
                        if (_2_0 != null) for(t15 = A.MapExtensions_get_pairs0(newSources, t5, t6), t15 = t15.get$iterator(t15); t15.moveNext$0();){
                            t16 = t15.get$current(t15);
                            extender = t16._0;
                            extension = t16._1;
                            if (_2_0.containsKey$1(extender)) {
                                t16 = _2_0.$index(0, extender);
                                extension = A.MergedExtension_merge0(t16 == null ? t6._as(t16) : t16, extension);
                                _2_0.$indexSet(0, extender, extension);
                            } else _2_0.$indexSet(0, extender, extension);
                            if (!t13 || t14) {
                                if (newExtensions == null) {
                                    newExtensions = A.LinkedHashMap_LinkedHashMap$_empty(t2, t3);
                                    t16 = newExtensions;
                                } else t16 = newExtensions;
                                t16.putIfAbsent$2(target, new A.ExtensionStore_addExtensions_closure0()).$indexSet(0, extender, extension);
                            }
                        }
                        else {
                            t15 = A.LinkedHashMap_LinkedHashMap(_null, _null, _null, t5, t6);
                            t15.addAll$1(0, newSources);
                            t4.$indexSet(0, target, t15);
                            if (!t13 || t14) {
                                if (newExtensions == null) {
                                    newExtensions = A.LinkedHashMap_LinkedHashMap$_empty(t2, t3);
                                    t13 = newExtensions;
                                } else t13 = newExtensions;
                                t14 = A.LinkedHashMap_LinkedHashMap(_null, _null, _null, t5, t6);
                                t14.addAll$1(0, newSources);
                                t13.$indexSet(0, target, t14);
                            }
                        }
                    }
                }
                if (newExtensions != null) {
                    if (extensionsToExtend != null) _this._extension_store$_extendExistingExtensions$2(extensionsToExtend, newExtensions);
                    if (selectorsToExtend != null) _this._extension_store$_extendExistingSelectors$2(selectorsToExtend, newExtensions);
                }
            },
            _extension_store$_extendList$3: function(list, extensions, mediaQueryContext) {
                var t1, t2, t3, extended, i, complex, result, t4;
                for(t1 = list.components, t2 = t1.length, t3 = type$.JSArray_ComplexSelector_2, extended = null, i = 0; i < t2; ++i){
                    complex = t1[i];
                    result = this._extension_store$_extendComplex$3(complex, extensions, mediaQueryContext);
                    if (result == null) {
                        if (extended != null) extended.push(complex);
                    } else {
                        if (extended == null) {
                            if (i === 0) extended = A._setArrayType([], t3);
                            else {
                                t4 = B.JSArray_methods.sublist$2(t1, 0, i);
                                extended = A._setArrayType(t4.slice(0), A._arrayInstanceType(t4));
                            }
                        }
                        B.JSArray_methods.addAll$1(extended, result);
                    }
                }
                if (extended == null) return list;
                t1 = this._extension_store$_originals;
                return A.SelectorList$0(this._extension_store$_trim$2(extended, t1.get$contains(t1)), list.span);
            },
            _extension_store$_extendList$2: function(list, extensions) {
                return this._extension_store$_extendList$3(list, extensions, null);
            },
            _extension_store$_extendComplex$3: function(complex, extensions, mediaQueryContext) {
                var isOriginal, t3, t4, t5, t6, t7, t8, t9, t10, extendedNotExpanded, i, component, extended, t11, t12, t13, t14, _box_0 = {}, t1 = complex.leadingCombinators, t2 = t1.length;
                if (t2 > 1) return null;
                isOriginal = this._extension_store$_originals.contains$1(0, complex);
                for(t3 = complex.components, t4 = t3.length, t5 = type$.JSArray_List_ComplexSelector_2, t6 = complex.lineBreak, t7 = !t6, t8 = complex.span, t9 = type$.JSArray_ComplexSelector_2, t2 = t2 === 0, t10 = type$.JSArray_ComplexSelectorComponent_2, extendedNotExpanded = null, i = 0; i < t4; ++i){
                    component = t3[i];
                    extended = this._extension_store$_extendCompound$4$inOriginal(component, extensions, mediaQueryContext, isOriginal);
                    if (extended == null) {
                        if (extendedNotExpanded != null) extendedNotExpanded.push(A._setArrayType([
                            A.ComplexSelector$0(B.List_empty17, A._setArrayType([
                                component
                            ], t10), t8, t6)
                        ], t9));
                    } else if (extendedNotExpanded != null) extendedNotExpanded.push(extended);
                    else if (i !== 0) {
                        t11 = A._arrayInstanceType(t3);
                        t12 = new A.SubListIterable(t3, 0, i, t11._eval$1("SubListIterable<1>"));
                        t12.SubListIterable$3(t3, 0, i, t11._precomputed1);
                        extendedNotExpanded = A._setArrayType([
                            A._setArrayType([
                                A.ComplexSelector$0(t1, t12, t8, t6)
                            ], t9),
                            extended
                        ], t5);
                    } else if (t2) extendedNotExpanded = A._setArrayType([
                        extended
                    ], t5);
                    else {
                        t11 = A._setArrayType([], t9);
                        for(t12 = J.get$iterator$ax(extended); t12.moveNext$0();){
                            t13 = t12.get$current(t12);
                            t14 = t13.leadingCombinators;
                            if (t14.length === 0 || B.C_ListEquality.equals$2(0, t1, t14)) {
                                t14 = t13.components;
                                t11.push(A.ComplexSelector$0(t1, t14, t8, !t7 || t13.lineBreak));
                            }
                        }
                        extendedNotExpanded = A._setArrayType([
                            t11
                        ], t5);
                    }
                }
                if (extendedNotExpanded == null) return null;
                _box_0.first = true;
                t1 = type$.ComplexSelector_2;
                t1 = J.expand$1$1$ax(A.paths0(extendedNotExpanded, t1), new A.ExtensionStore__extendComplex_closure0(_box_0, this, complex), t1);
                t1 = A.List_List$_of(t1, t1.$ti._eval$1("Iterable.E"));
                return t1;
            },
            _extension_store$_extendCompound$4$inOriginal: function(component, extensions, mediaQueryContext, inOriginal) {
                var t3, t4, t5, t6, t7, t8, t9, t10, t11, options, i, simple, extended, t12, result, compound, complex, extenderPaths, withCombinators, isOriginal, _this = this, _null = null, t1 = _this._extension_store$_mode, targetsUsed = t1 === B.ExtendMode_normal_0_normal0 || extensions.__js_helper$_length < 2 ? _null : A.LinkedHashSet_LinkedHashSet$_empty(type$.SimpleSelector_2), t2 = component.selector, simples = t2.components;
                for(t3 = simples.length, t4 = type$.JSArray_List_Extender_2, t5 = type$.JSArray_Extender_2, t6 = type$.CssValue_Combinator_2, t7 = type$.JSArray_ComplexSelectorComponent_2, t8 = A._arrayInstanceType(simples), t9 = t8._precomputed1, t8 = t8._eval$1("SubListIterable<1>"), t10 = component.span, t11 = type$.SimpleSelector_2, options = _null, i = 0; i < t3; ++i){
                    simple = simples[i];
                    extended = _this._extension_store$_extendSimple$4(simple, extensions, mediaQueryContext, targetsUsed);
                    if (extended == null) {
                        if (options != null) options.push(A._setArrayType([
                            _this._extension_store$_extenderForSimple$1(simple)
                        ], t5));
                    } else {
                        if (options == null) {
                            options = A._setArrayType([], t4);
                            if (i !== 0) {
                                t12 = new A.SubListIterable(simples, 0, i, t8);
                                t12.SubListIterable$3(simples, 0, i, t9);
                                result = A.List_List$from(t12, false, t11);
                                result.$flags = 3;
                                t12 = result;
                                compound = new A.CompoundSelector0(t12, t10);
                                if (t12.length === 0) A.throwExpression(A.ArgumentError$("components may not be empty.", _null));
                                result = A.List_List$from(B.List_empty17, false, t6);
                                result.$flags = 3;
                                t12 = A.ComplexSelector$0(B.List_empty17, A._setArrayType([
                                    new A.ComplexSelectorComponent0(compound, result, t10)
                                ], t7), t10, false);
                                _this._extension_store$_sourceSpecificityFor$1(compound);
                                options.push(A._setArrayType([
                                    new A.Extender0(t12, true)
                                ], t5));
                            }
                        }
                        B.JSArray_methods.addAll$1(options, extended);
                    }
                }
                if (options == null) return _null;
                if (targetsUsed != null && targetsUsed._collection$_length !== extensions.__js_helper$_length) return _null;
                if (options.length === 1) {
                    for(t1 = J.get$iterator$ax(options[0]), t2 = component.combinators, t3 = type$.JSArray_ComplexSelector_2, result = _null; t1.moveNext$0();){
                        t4 = t1.get$current(t1);
                        t4.assertCompatibleMediaContext$1(mediaQueryContext);
                        complex = t4.selector.withAdditionalCombinators$1(t2);
                        if (complex.accept$1(B.C__IsUselessVisitor0)) continue;
                        if (result == null) result = A._setArrayType([], t3);
                        result.push(complex);
                    }
                    return result;
                }
                extenderPaths = A.paths0(options, type$.Extender_2);
                t3 = A._setArrayType([], type$.JSArray_ComplexSelector_2);
                t1 = t1 === B.ExtendMode_replace_1_replace0;
                t4 = !t1;
                if (t4) t3.push(A.ComplexSelector$0(B.List_empty17, A._setArrayType([
                    new A.ComplexSelectorComponent0(A.CompoundSelector$0(J.expand$1$1$ax(J.get$first$ax(extenderPaths), new A.ExtensionStore__extendCompound_closure2(), t11), t2.span), A.List_List$unmodifiable(component.combinators, t6), t10)
                ], t7), t10, false));
                t2 = J.skip$1$ax(extenderPaths, t1 ? 0 : 1);
                t5 = t2.$ti;
                t2 = new A.ListIterator(t2, t2.get$length(0), t5._eval$1("ListIterator<ListIterable.E>"));
                t6 = component.combinators;
                t5 = t5._eval$1("ListIterable.E");
                while(t2.moveNext$0()){
                    t1 = t2.__internal$_current;
                    extended = _this._extension_store$_unifyExtenders$3(t1 == null ? t5._as(t1) : t1, mediaQueryContext, t10);
                    if (extended == null) continue;
                    for(t1 = J.get$iterator$ax(extended); t1.moveNext$0();){
                        withCombinators = t1.get$current(t1).withAdditionalCombinators$1(t6);
                        if (!withCombinators.accept$1(B.C__IsUselessVisitor0)) t3.push(withCombinators);
                    }
                }
                isOriginal = new A.ExtensionStore__extendCompound_closure3();
                return _this._extension_store$_trim$2(t3, inOriginal && t4 ? new A.ExtensionStore__extendCompound_closure4(B.JSArray_methods.get$first(t3)) : isOriginal);
            },
            _extension_store$_unifyExtenders$3: function(extenders, mediaQueryContext, span) {
                var t1, t2, t3, originals, originalsLineBreak, t4, complexes, _null = null, toUnify = A.QueueList$(_null, type$.ComplexSelector_2);
                for(t1 = J.getInterceptor$ax(extenders), t2 = t1.get$iterator(extenders), t3 = type$.JSArray_SimpleSelector_2, originals = _null, originalsLineBreak = false; t2.moveNext$0();){
                    t4 = t2.get$current(t2);
                    if (t4.isOriginal) {
                        if (originals == null) originals = A._setArrayType([], t3);
                        t4 = t4.selector;
                        B.JSArray_methods.addAll$1(originals, B.JSArray_methods.get$last(t4.components).selector.components);
                        originalsLineBreak = originalsLineBreak || t4.lineBreak;
                    } else {
                        t4 = t4.selector;
                        if (t4.accept$1(B.C__IsUselessVisitor0)) return _null;
                        else toUnify._queue_list$_add$1(t4);
                    }
                }
                if (originals != null) toUnify.addFirst$1(A.ComplexSelector$0(B.List_empty17, A._setArrayType([
                    new A.ComplexSelectorComponent0(A.CompoundSelector$0(originals, span), A.List_List$unmodifiable(B.List_empty17, type$.CssValue_Combinator_2), span)
                ], type$.JSArray_ComplexSelectorComponent_2), span, originalsLineBreak));
                complexes = A.unifyComplex0(toUnify, span);
                if (complexes == null) return _null;
                for(t1 = t1.get$iterator(extenders); t1.moveNext$0();)t1.get$current(t1).assertCompatibleMediaContext$1(mediaQueryContext);
                return complexes;
            },
            _extension_store$_extendSimple$4: function(simple, extensions, mediaQueryContext, targetsUsed) {
                var t2, _1_0, t1 = new A.ExtensionStore__extendSimple_withoutPseudo0(this, extensions, targetsUsed);
                if (simple instanceof A.PseudoSelector0) t2 = simple.selector != null;
                else t2 = false;
                if (t2) {
                    _1_0 = this._extension_store$_extendPseudo$3(simple, extensions, mediaQueryContext);
                    if (_1_0 != null) return new A.MappedListIterable(_1_0, new A.ExtensionStore__extendSimple_closure1(this, t1), A._arrayInstanceType(_1_0)._eval$1("MappedListIterable<1,List<Extender0>>"));
                }
                return A.NullableExtension_andThen0(t1.call$1(simple), new A.ExtensionStore__extendSimple_closure2());
            },
            _extension_store$_extenderForSimple$1: function(simple) {
                var t1 = simple.span;
                t1 = A.ComplexSelector$0(B.List_empty17, A._setArrayType([
                    new A.ComplexSelectorComponent0(A.CompoundSelector$0(A._setArrayType([
                        simple
                    ], type$.JSArray_SimpleSelector_2), t1), A.List_List$unmodifiable(B.List_empty17, type$.CssValue_Combinator_2), t1)
                ], type$.JSArray_ComplexSelectorComponent_2), t1, false);
                this._extension_store$_sourceSpecificity.$index(0, simple);
                return new A.Extender0(t1, true);
            },
            _extension_store$_extendPseudo$3: function(pseudo, extensions, mediaQueryContext) {
                var extended, complexes, t1, result, selector = pseudo.selector;
                if (selector == null) throw A.wrapException(A.ArgumentError$("Selector " + pseudo.toString$0(0) + " must have a selector argument.", null));
                extended = this._extension_store$_extendList$3(selector, extensions, mediaQueryContext);
                if (extended === selector) return null;
                complexes = extended.components;
                t1 = pseudo.normalizedName === "not";
                if (t1 && !B.JSArray_methods.any$1(selector.components, new A.ExtensionStore__extendPseudo_closure4()) && B.JSArray_methods.any$1(complexes, new A.ExtensionStore__extendPseudo_closure5())) complexes = new A.WhereIterable(complexes, new A.ExtensionStore__extendPseudo_closure6(), A._arrayInstanceType(complexes)._eval$1("WhereIterable<1>"));
                complexes = J.expand$1$1$ax(complexes, new A.ExtensionStore__extendPseudo_closure7(pseudo), type$.ComplexSelector_2);
                if (t1 && selector.components.length === 1) {
                    t1 = A.MappedIterable_MappedIterable(complexes, new A.ExtensionStore__extendPseudo_closure8(pseudo, selector), complexes.$ti._eval$1("Iterable.E"), type$.PseudoSelector_2);
                    result = A.List_List$_of(t1, A._instanceType(t1)._eval$1("Iterable.E"));
                    return result.length === 0 ? null : result;
                } else return A._setArrayType([
                    pseudo.withSelector$1(A.SelectorList$0(complexes, selector.span))
                ], type$.JSArray_PseudoSelector_2);
            },
            _extension_store$_trim$2: function(selectors, isOriginal) {
                var result, i, t1, t2, numOriginals, _box_0, complex1, j, t3, t4, _i, t5, maxSpecificity;
                if (selectors.length > 100) return selectors;
                result = A.QueueList$(null, type$.ComplexSelector_2);
                $label0$0: for(i = selectors.length - 1, t1 = A._arrayInstanceType(selectors), t2 = t1._precomputed1, t1 = t1._eval$1("SubListIterable<1>"), numOriginals = 0; i >= 0; --i){
                    _box_0 = {};
                    complex1 = selectors[i];
                    if (isOriginal.call$1(complex1)) {
                        for(j = 0; j < numOriginals; ++j)if (result.$index(0, j).$eq(0, complex1)) {
                            A.rotateSlice0(result, 0, j + 1);
                            continue $label0$0;
                        }
                        ++numOriginals;
                        result.addFirst$1(complex1);
                        continue $label0$0;
                    }
                    _box_0.maxSpecificity = 0;
                    for(t3 = complex1.components, t4 = t3.length, _i = 0, t5 = 0; _i < t4; ++_i, t5 = maxSpecificity){
                        maxSpecificity = Math.max(t5, this._extension_store$_sourceSpecificityFor$1(t3[_i].selector));
                        _box_0.maxSpecificity = maxSpecificity;
                    }
                    if (result.any$1(result, new A.ExtensionStore__trim_closure1(_box_0, complex1))) continue $label0$0;
                    t3 = new A.SubListIterable(selectors, 0, i, t1);
                    t3.SubListIterable$3(selectors, 0, i, t2);
                    if (t3.any$1(0, new A.ExtensionStore__trim_closure2(_box_0, complex1))) continue $label0$0;
                    result.addFirst$1(complex1);
                }
                return result;
            },
            _extension_store$_sourceSpecificityFor$1: function(compound) {
                var t1, t2, t3, specificity, _i, t4;
                for(t1 = compound.components, t2 = t1.length, t3 = this._extension_store$_sourceSpecificity, specificity = 0, _i = 0; _i < t2; ++_i){
                    t4 = t3.$index(0, t1[_i]);
                    if (t4 == null) t4 = 0;
                    specificity = Math.max(specificity, t4);
                }
                return specificity;
            },
            clone$0: function() {
                var t3, t4, _this = this, t1 = type$.SimpleSelector_2, newSelectors = A.LinkedHashMap_LinkedHashMap$_empty(t1, type$.Set_ModifiableBox_SelectorList_2), t2 = type$.ModifiableBox_SelectorList_2, newMediaContexts = A.LinkedHashMap_LinkedHashMap$_empty(t2, type$.List_CssMediaQuery_2), oldToNewSelectors = new A.JsIdentityLinkedHashMap(type$.JsIdentityLinkedHashMap_of_SelectorList_and_Box_SelectorList_2);
                _this._extension_store$_selectors.forEach$1(0, new A.ExtensionStore_clone_closure0(_this, newSelectors, A.LinkedHashMap_LinkedHashMap$_empty(t2, t2), oldToNewSelectors, newMediaContexts));
                t2 = type$.Extension_2;
                t3 = A.copyMapOfMap0(_this._extension_store$_extensions, t1, type$.ComplexSelector_2, t2);
                t2 = A.copyMapOfList0(_this._extension_store$_extensionsByExtender, t1, t2);
                t1 = new A.JsIdentityLinkedHashMap(type$.JsIdentityLinkedHashMap_SimpleSelector_int_2);
                t1.addAll$1(0, _this._extension_store$_sourceSpecificity);
                t4 = new A._LinkedIdentityHashSet(type$._LinkedIdentityHashSet_ComplexSelector_2);
                t4.addAll$1(0, _this._extension_store$_originals);
                return new A._Record_2(new A.ExtensionStore0(newSelectors, t3, t2, newMediaContexts, t1, t4, B.ExtendMode_normal_0_normal0), oldToNewSelectors);
            },
            get$_extension_store$_extensions: function() {
                return this._extension_store$_extensions;
            },
            get$_extension_store$_sourceSpecificity: function() {
                return this._extension_store$_sourceSpecificity;
            }
        };
        A.ExtensionStore_extensionsWhereTarget_closure0.prototype = {
            call$1: function(extension) {
                return !extension.isOptional;
            },
            $signature: 471
        };
        A.ExtensionStore__registerSelector_closure0.prototype = {
            call$0: function() {
                return A.LinkedHashSet_LinkedHashSet$_empty(type$.ModifiableBox_SelectorList_2);
            },
            $signature: 472
        };
        A.ExtensionStore_addExtension_closure2.prototype = {
            call$0: function() {
                return A.LinkedHashMap_LinkedHashMap$_empty(type$.ComplexSelector_2, type$.Extension_2);
            },
            $signature: 131
        };
        A.ExtensionStore_addExtension_closure3.prototype = {
            call$0: function() {
                return A._setArrayType([], type$.JSArray_Extension_2);
            },
            $signature: 246
        };
        A.ExtensionStore_addExtension_closure4.prototype = {
            call$0: function() {
                return this.complex.get$specificity();
            },
            $signature: 10
        };
        A.ExtensionStore__extendExistingExtensions_closure1.prototype = {
            call$0: function() {
                return A._setArrayType([], type$.JSArray_Extension_2);
            },
            $signature: 246
        };
        A.ExtensionStore__extendExistingExtensions_closure2.prototype = {
            call$0: function() {
                return A.LinkedHashMap_LinkedHashMap$_empty(type$.ComplexSelector_2, type$.Extension_2);
            },
            $signature: 131
        };
        A.ExtensionStore_addExtensions_closure0.prototype = {
            call$0: function() {
                return A.LinkedHashMap_LinkedHashMap$_empty(type$.ComplexSelector_2, type$.Extension_2);
            },
            $signature: 131
        };
        A.ExtensionStore__extendComplex_closure0.prototype = {
            call$1: function(path) {
                var t1 = this.complex;
                return J.map$1$1$ax(A.weave0(path, t1.span, t1.lineBreak), new A.ExtensionStore__extendComplex__closure0(this._box_0, this.$this, t1), type$.ComplexSelector_2);
            },
            $signature: 475
        };
        A.ExtensionStore__extendComplex__closure0.prototype = {
            call$1: function(outputComplex) {
                var _this = this, t1 = _this._box_0;
                if (t1.first && _this.$this._extension_store$_originals.contains$1(0, _this.complex)) _this.$this._extension_store$_originals.add$1(0, outputComplex);
                t1.first = false;
                return outputComplex;
            },
            $signature: 59
        };
        A.ExtensionStore__extendCompound_closure2.prototype = {
            call$1: function(extender) {
                return B.JSArray_methods.get$last(extender.selector.components).selector.components;
            },
            $signature: 477
        };
        A.ExtensionStore__extendCompound_closure3.prototype = {
            call$1: function(_) {
                return false;
            },
            $signature: 22
        };
        A.ExtensionStore__extendCompound_closure4.prototype = {
            call$1: function(complex) {
                return complex.$eq(0, this.original);
            },
            $signature: 22
        };
        A.ExtensionStore__extendSimple_withoutPseudo0.prototype = {
            call$1: function(simple) {
                var t1, t2, extensionsForSimple = this.extensions.$index(0, simple);
                if (extensionsForSimple == null) return null;
                t1 = this.targetsUsed;
                if (t1 != null) t1.add$1(0, simple);
                t1 = A._setArrayType([], type$.JSArray_Extender_2);
                t2 = this.$this;
                if (t2._extension_store$_mode !== B.ExtendMode_replace_1_replace0) t1.push(t2._extension_store$_extenderForSimple$1(simple));
                for(t2 = extensionsForSimple.get$values(extensionsForSimple), t2 = t2.get$iterator(t2); t2.moveNext$0();)t1.push(t2.get$current(t2).extender);
                return t1;
            },
            $signature: 478
        };
        A.ExtensionStore__extendSimple_closure1.prototype = {
            call$1: function(pseudo) {
                var t1 = this.withoutPseudo.call$1(pseudo);
                return t1 == null ? A._setArrayType([
                    this.$this._extension_store$_extenderForSimple$1(pseudo)
                ], type$.JSArray_Extender_2) : t1;
            },
            $signature: 479
        };
        A.ExtensionStore__extendSimple_closure2.prototype = {
            call$1: function(result) {
                return A._setArrayType([
                    result
                ], type$.JSArray_List_Extender_2);
            },
            $signature: 480
        };
        A.ExtensionStore__extendPseudo_closure4.prototype = {
            call$1: function(complex) {
                return complex.components.length > 1;
            },
            $signature: 22
        };
        A.ExtensionStore__extendPseudo_closure5.prototype = {
            call$1: function(complex) {
                return complex.components.length === 1;
            },
            $signature: 22
        };
        A.ExtensionStore__extendPseudo_closure6.prototype = {
            call$1: function(complex) {
                return complex.components.length <= 1;
            },
            $signature: 22
        };
        A.ExtensionStore__extendPseudo_closure7.prototype = {
            call$1: function(complex) {
                var innerPseudo, innerSelector, t1 = complex.get$singleCompound();
                if (t1 == null) innerPseudo = null;
                else {
                    t1 = t1.components;
                    innerPseudo = t1.length === 1 ? B.JSArray_methods.get$first(t1) : null;
                }
                if (!(innerPseudo instanceof A.PseudoSelector0)) return A._setArrayType([
                    complex
                ], type$.JSArray_ComplexSelector_2);
                innerSelector = innerPseudo.selector;
                if (innerSelector == null) return A._setArrayType([
                    complex
                ], type$.JSArray_ComplexSelector_2);
                t1 = this.pseudo;
                switch(t1.normalizedName){
                    case "not":
                        if (!B.Set_0egh6.contains$1(0, innerPseudo.normalizedName)) return A._setArrayType([], type$.JSArray_ComplexSelector_2);
                        return innerSelector.components;
                    case "is":
                    case "matches":
                    case "where":
                    case "any":
                    case "current":
                    case "nth-child":
                    case "nth-last-child":
                        if (innerPseudo.name !== t1.name) return A._setArrayType([], type$.JSArray_ComplexSelector_2);
                        if (innerPseudo.argument != t1.argument) return A._setArrayType([], type$.JSArray_ComplexSelector_2);
                        return innerSelector.components;
                    case "has":
                    case "host":
                    case "host-context":
                    case "slotted":
                        return A._setArrayType([
                            complex
                        ], type$.JSArray_ComplexSelector_2);
                    default:
                        return A._setArrayType([], type$.JSArray_ComplexSelector_2);
                }
            },
            $signature: 481
        };
        A.ExtensionStore__extendPseudo_closure8.prototype = {
            call$1: function(complex) {
                return this.pseudo.withSelector$1(A.SelectorList$0(A._setArrayType([
                    complex
                ], type$.JSArray_ComplexSelector_2), this.selector.span));
            },
            $signature: 482
        };
        A.ExtensionStore__trim_closure1.prototype = {
            call$1: function(complex2) {
                return complex2.get$specificity() >= this._box_0.maxSpecificity && complex2.isSuperselector$1(this.complex1);
            },
            $signature: 22
        };
        A.ExtensionStore__trim_closure2.prototype = {
            call$1: function(complex2) {
                return complex2.get$specificity() >= this._box_0.maxSpecificity && complex2.isSuperselector$1(this.complex1);
            },
            $signature: 22
        };
        A.ExtensionStore_clone_closure0.prototype = {
            call$2: function(simple, selectors) {
                var t1, t2, t3, t4, t5, t6, newSelector, _0_0, _this = this, newSelectorSet = A.LinkedHashSet_LinkedHashSet$_empty(type$.ModifiableBox_SelectorList_2);
                _this.newSelectors.$indexSet(0, simple, newSelectorSet);
                for(t1 = selectors.get$iterator(selectors), t2 = _this.newBoxes, t3 = _this.oldToNewSelectors, t4 = _this.$this._extension_store$_mediaContexts, t5 = _this.newMediaContexts; t1.moveNext$0();){
                    t6 = t1.get$current(t1);
                    newSelector = t2.putIfAbsent$2(t6, new A.ExtensionStore_clone__closure0(t6));
                    newSelectorSet.add$1(0, newSelector);
                    t3.$indexSet(0, t6.value, new A.Box0(newSelector, newSelector.$ti._eval$1("Box0<1>")));
                    _0_0 = t4.$index(0, t6);
                    if (_0_0 != null) t5.$indexSet(0, newSelector, _0_0);
                }
            },
            $signature: 483
        };
        A.ExtensionStore_clone__closure0.prototype = {
            call$0: function() {
                return new A.ModifiableBox0(this.selector.value, type$.ModifiableBox_SelectorList_2);
            },
            $signature: 484
        };
        A.FiberClass.prototype = {};
        A.Fiber.prototype = {};
        A.JSToDartFileImporter.prototype = {
            canonicalize$1: function(_, url) {
                var result, t1, resultUrl;
                if (url.get$scheme() === "file") return $.$get$FilesystemImporter_cwd0().canonicalize$1(0, url);
                result = A.wrapJSExceptions(new A.JSToDartFileImporter_canonicalize_closure(this, url));
                if (result == null) return null;
                t1 = self.Promise;
                if (result instanceof t1) A.jsThrow(new self.Error("The findFileUrl() function can't return a Promise for synchron compile functions."));
                else {
                    t1 = self.URL;
                    if (!(result instanceof t1)) A.jsThrow(new self.Error(string$.The_fie));
                }
                resultUrl = A.Uri_parse(J.toString$0$(type$.JSUrl._as(result)));
                if (resultUrl.get$scheme() !== "file") A.jsThrow(new self.Error(string$.The_fiu + url.toString$0(0) + '".'));
                return $.$get$FilesystemImporter_cwd0().canonicalize$1(0, resultUrl);
            },
            load$1: function(_, url) {
                return $.$get$FilesystemImporter_cwd0().load$1(0, url);
            },
            isNonCanonicalScheme$1: function(scheme) {
                return scheme !== "file";
            }
        };
        A.JSToDartFileImporter_canonicalize_closure.prototype = {
            call$0: function() {
                return this.$this._file0$_findFileUrl.call$2(this.url.toString$0(0), A.canonicalizeContext0());
            },
            $signature: 36
        };
        A.FilesystemImporter0.prototype = {
            canonicalize$1: function(_, url) {
                var resolved;
                if (url.get$scheme() === "file") resolved = A.resolveImportPath0($.$get$context().style.pathFromUri$1(A._parseUri(url)));
                else if (url.get$scheme() !== "") return null;
                else {
                    resolved = A.resolveImportPath0(A.join(this._filesystem$_loadPath, $.$get$context().style.pathFromUri$1(A._parseUri(url)), null));
                    if (resolved != null && this._filesystem$_loadPathDeprecated) A.warnForDeprecation0(string$.Using_t, B.Deprecation_LUk);
                }
                return A.NullableExtension_andThen0(resolved, new A.FilesystemImporter_canonicalize_closure0());
            },
            load$1: function(_, url) {
                var path = $.$get$context().style.pathFromUri$1(A._parseUri(url));
                return A.ImporterResult$(A.readFile0(path), url, A.Syntax_forPath0(path));
            },
            toString$0: function(_) {
                return this._filesystem$_loadPath;
            }
        };
        A.FilesystemImporter_canonicalize_closure0.prototype = {
            call$1: function(resolved) {
                var t2, t0, _null = null, t1 = A.isNodeJs() ? self.process : _null;
                if (!J.$eq$(t1 == null ? _null : J.get$platform$x(t1), "win32")) {
                    t1 = A.isNodeJs() ? self.process : _null;
                    t1 = J.$eq$(t1 == null ? _null : J.get$platform$x(t1), "darwin");
                } else t1 = true;
                if (t1) {
                    t1 = A.absolute(resolved, _null, _null, _null, _null, _null, _null, _null, _null, _null, _null, _null, _null, _null, _null);
                    t2 = $.$get$context();
                    t1 = A._realCasePath0(t2.normalize$1(t1));
                } else {
                    t1 = $.$get$context();
                    t2 = t1.canonicalize$1(0, resolved);
                    t0 = t2;
                    t2 = t1;
                    t1 = t0;
                }
                return t2.toUri$1(t1);
            },
            $signature: 127
        };
        A.ForRule0.prototype = {
            accept$1$1: function(visitor) {
                return visitor.visitForRule$1(0, this);
            },
            accept$1: function(visitor) {
                return this.accept$1$1(visitor, type$.dynamic);
            },
            toString$0: function(_) {
                var _this = this, t1 = _this.from.toString$0(0), t2 = _this.isExclusive ? "to" : "through";
                return "@for $" + _this.variable + " from " + t1 + " " + t2 + " " + _this.to.toString$0(0) + " {" + B.JSArray_methods.join$1(_this.children, " ") + "}";
            },
            get$span: function(receiver) {
                return this.span;
            }
        };
        A.ForwardRule0.prototype = {
            accept$1$1: function(visitor) {
                return visitor.visitForwardRule$1(0, this);
            },
            accept$1: function(visitor) {
                return this.accept$1$1(visitor, type$.dynamic);
            },
            toString$0: function(_) {
                var t2, prefix, _this = this, t1 = "@forward " + A.StringExpression_quoteText0(_this.url.toString$0(0)), shownMixinsAndFunctions = _this.shownMixinsAndFunctions, hiddenMixinsAndFunctions = _this.hiddenMixinsAndFunctions;
                if (shownMixinsAndFunctions != null) {
                    t2 = _this.shownVariables;
                    t2.toString;
                    t2 = t1 + " show " + _this._forward_rule0$_memberList$2(shownMixinsAndFunctions, t2);
                    t1 = t2;
                } else if (hiddenMixinsAndFunctions != null && hiddenMixinsAndFunctions._base.get$isNotEmpty(0)) {
                    t2 = _this.hiddenVariables;
                    t2.toString;
                    t2 = t1 + " hide " + _this._forward_rule0$_memberList$2(hiddenMixinsAndFunctions, t2);
                    t1 = t2;
                }
                prefix = _this.prefix;
                if (prefix != null) t1 += " as " + prefix + "*";
                t2 = _this.configuration;
                t1 = (t2.length !== 0 ? t1 + (" with (" + B.JSArray_methods.join$1(t2, ", ") + ")") : t1) + ";";
                return t1.charCodeAt(0) == 0 ? t1 : t1;
            },
            _forward_rule0$_memberList$2: function(mixinsAndFunctions, variables) {
                var t2, t1 = A.List_List$_of(mixinsAndFunctions, type$.String);
                for(t2 = variables._base.get$iterator(0); t2.moveNext$0();)t1.push("$" + t2.get$current(0));
                return B.JSArray_methods.join$1(t1, ", ");
            },
            get$span: function(receiver) {
                return this.span;
            }
        };
        A.ForwardedModuleView0.prototype = {
            get$url: function(_) {
                var t1 = this._forwarded_view0$_inner;
                return t1.get$url(t1);
            },
            get$upstream: function() {
                return this._forwarded_view0$_inner.get$upstream();
            },
            get$extensionStore: function() {
                return this._forwarded_view0$_inner.get$extensionStore();
            },
            get$css: function(_) {
                var t1 = this._forwarded_view0$_inner;
                return t1.get$css(t1);
            },
            get$preModuleComments: function() {
                return this._forwarded_view0$_inner.get$preModuleComments();
            },
            get$transitivelyContainsCss: function() {
                return this._forwarded_view0$_inner.get$transitivelyContainsCss();
            },
            get$transitivelyContainsExtensions: function() {
                return this._forwarded_view0$_inner.get$transitivelyContainsExtensions();
            },
            setVariable$3: function($name, value, nodeWithSpan) {
                var t2, _1_0, _2_0, _s19_ = "Undefined variable.", t1 = this._forwarded_view0$_rule, _0_0 = t1.shownVariables;
                if (_0_0 != null) t2 = !_0_0._base.contains$1(0, $name);
                else t2 = false;
                if (t2) throw A.wrapException(A.SassScriptException$0(_s19_, null));
                else {
                    _1_0 = t1.hiddenVariables;
                    if (_1_0 != null) t2 = _1_0._base.contains$1(0, $name);
                    else t2 = false;
                    if (t2) throw A.wrapException(A.SassScriptException$0(_s19_, null));
                }
                _2_0 = t1.prefix;
                if (_2_0 != null) {
                    if (!B.JSString_methods.startsWith$1($name, _2_0)) throw A.wrapException(A.SassScriptException$0(_s19_, null));
                    $name = B.JSString_methods.substring$1($name, _2_0.length);
                }
                return this._forwarded_view0$_inner.setVariable$3($name, value, nodeWithSpan);
            },
            variableIdentity$1: function($name) {
                var _0_0 = this._forwarded_view0$_rule.prefix;
                if (_0_0 != null) $name = B.JSString_methods.substring$1($name, _0_0.length);
                return this._forwarded_view0$_inner.variableIdentity$1($name);
            },
            couldHaveBeenConfigured$1: function(variables) {
                var t5, t6, _1_0, _2_0, blocklist, _this = this, t1 = _this._forwarded_view0$_rule, t2 = t1.prefix, t3 = t2 == null, t4 = false;
                if (t3) {
                    if (t1.shownVariables == null) {
                        t4 = t1.hiddenVariables;
                        t4 = t4 == null ? null : t4._base.get$isEmpty(0);
                        t4 = t4 !== false;
                    }
                }
                if (t4) return _this._forwarded_view0$_inner.couldHaveBeenConfigured$1(variables);
                if (!t3) {
                    t3 = A.LinkedHashSet_LinkedHashSet$_empty(type$.String);
                    for(t4 = variables.get$iterator(variables), t5 = t2.length; t4.moveNext$0();){
                        t6 = t4.get$current(t4);
                        if (B.JSString_methods.startsWith$1(t6, t2)) t3.add$1(0, B.JSString_methods.substring$1(t6, t5));
                    }
                    variables = t3;
                }
                _1_0 = t1.shownVariables;
                if (_1_0 != null) return _this._forwarded_view0$_inner.couldHaveBeenConfigured$1(variables.intersection$1(_1_0));
                else {
                    _2_0 = t1.hiddenVariables;
                    if (_2_0 != null) {
                        t1 = _2_0._base.get$isNotEmpty(0);
                        blocklist = _2_0;
                    } else {
                        blocklist = null;
                        t1 = false;
                    }
                    t2 = _this._forwarded_view0$_inner;
                    if (t1) return t2.couldHaveBeenConfigured$1(variables.difference$1(blocklist));
                    else return t2.couldHaveBeenConfigured$1(variables);
                }
            },
            $eq: function(_, other) {
                if (other == null) return false;
                return other instanceof A.ForwardedModuleView0 && this._forwarded_view0$_inner.$eq(0, other._forwarded_view0$_inner) && this._forwarded_view0$_rule === other._forwarded_view0$_rule;
            },
            get$hashCode: function(_) {
                var t1 = this._forwarded_view0$_inner;
                return (t1.get$hashCode(t1) ^ A.Primitives_objectHashCode(this._forwarded_view0$_rule)) >>> 0;
            },
            cloneCss$0: function() {
                return A.ForwardedModuleView$0(this._forwarded_view0$_inner.cloneCss$0(), this._forwarded_view0$_rule, this.$ti._precomputed1);
            },
            toString$0: function(_) {
                return "forwarded " + this._forwarded_view0$_inner.toString$0(0);
            },
            $isModule1: 1,
            get$variables: function() {
                return this.variables;
            },
            get$variableNodes: function() {
                return this.variableNodes;
            },
            get$functions: function(receiver) {
                return this.functions;
            },
            get$mixins: function() {
                return this.mixins;
            }
        };
        A.FunctionExpression0.prototype = {
            accept$1$1: function(visitor) {
                return visitor.visitFunctionExpression$1(0, this);
            },
            accept$1: function(visitor) {
                return this.accept$1$1(visitor, type$.dynamic);
            },
            toString$0: function(_) {
                var t1 = this.namespace;
                t1 = t1 != null ? t1 + "." : "";
                t1 += this.originalName + this.$arguments.toString$0(0);
                return t1.charCodeAt(0) == 0 ? t1 : t1;
            },
            get$span: function(receiver) {
                return this.span;
            }
        };
        A.JSFunction0.prototype = {};
        A.SupportsFunction0.prototype = {
            toInterpolation$0: function() {
                var t4, t5, t1 = new A.StringBuffer(""), t2 = new A.InterpolationBuffer0(t1, A._setArrayType([], type$.JSArray_Object), A._setArrayType([], type$.JSArray_nullable_FileSpan)), t3 = this.name;
                t2.addInterpolation$1(t3);
                t4 = this.$arguments;
                t5 = t4.span;
                t3 = A.SpanExtensions_between(t3.span, t5);
                t3 = A.String_String$fromCharCodes(B.NativeUint32List_methods.sublist$2(t3.file._decodedChars, t3._file$_start, t3._end), 0, null);
                t1._contents += t3;
                t2.addInterpolation$1(t4);
                t4 = this.span;
                t5 = A.SpanExtensions_after(t4, t5);
                t5 = A.String_String$fromCharCodes(B.NativeUint32List_methods.sublist$2(t5.file._decodedChars, t5._file$_start, t5._end), 0, null);
                t1._contents += t5;
                return t2.interpolation$1(t4);
            },
            withSpan$1: function(span) {
                return new A.SupportsFunction0(this.name, this.$arguments, span);
            },
            toString$0: function(_) {
                return this.name.toString$0(0) + "(" + this.$arguments.toString$0(0) + ")";
            },
            $isAstNode0: 1,
            $isSassNode: 1,
            $isSupportsCondition: 1,
            get$span: function(receiver) {
                return this.span;
            }
        };
        A.functionClass_closure.prototype = {
            call$0: function() {
                var t1 = type$.JSClass, jsClass = t1._as(A.allowInteropCaptureThisNamed("sass.SassFunction", new A.functionClass__closure()));
                A.JSClassExtension_injectSuperclass(t1._as(new A.SassFunction0(A.BuiltInCallable$function0("f", "", new A.functionClass__closure0(), null), null).constructor), jsClass);
                return jsClass;
            },
            $signature: 17
        };
        A.functionClass__closure.prototype = {
            call$3: function($self, signature, callback) {
                var paren = B.JSString_methods.indexOf$1(signature, "(");
                if (paren === -1 || !B.JSString_methods.endsWith$1(signature, ")")) A.jsThrow(new self.Error('Invalid signature for new sass.SassFunction(): "' + signature + '"'));
                return new A.SassFunction0(A.BuiltInCallable$function0(B.JSString_methods.substring$2(signature, 0, paren), B.JSString_methods.substring$2(signature, paren + 1, signature.length - 1), callback, null), null);
            },
            "call*": "call$3",
            $requiredArgCount: 3,
            $signature: 485
        };
        A.functionClass__closure0.prototype = {
            call$1: function(_) {
                return B.C__SassNull0;
            },
            $signature: 3
        };
        A.SassFunction0.prototype = {
            accept$1$1: function(visitor) {
                var t1, t2;
                if (!visitor._serialize0$_inspect) A.throwExpression(A.SassScriptException$0(this.toString$0(0) + " isn't a valid CSS value.", null));
                t1 = visitor._serialize0$_buffer;
                t1.write$1(0, "get-function(");
                t2 = this.callable;
                visitor._serialize0$_visitQuotedString$1(t2.get$name(t2));
                t1.writeCharCode$1(41);
                return null;
            },
            accept$1: function(visitor) {
                return this.accept$1$1(visitor, type$.dynamic);
            },
            assertFunction$1: function($name) {
                return this;
            },
            assertCompileContext$1: function(compileContext) {
                var t1 = this._function0$_compileContext;
                if (t1 != null) t1 = t1 !== compileContext;
                else t1 = false;
                if (t1) throw A.wrapException(A.SassScriptException$0(this.toString$0(0) + " does not belong to current compilation.", null));
                return this;
            },
            $eq: function(_, other) {
                if (other == null) return false;
                return other instanceof A.SassFunction0 && this.callable.$eq(0, other.callable);
            },
            get$hashCode: function(_) {
                var t1 = this.callable;
                return t1.get$hashCode(t1);
            }
        };
        A.FunctionRule0.prototype = {
            accept$1$1: function(visitor) {
                return visitor.visitFunctionRule$1(0, this);
            },
            accept$1: function(visitor) {
                return this.accept$1$1(visitor, type$.dynamic);
            },
            toString$0: function(_) {
                return "@function " + this.name + "(" + this.parameters.toString$0(0) + ") {" + B.JSArray_methods.join$1(this.children, " ") + "}";
            }
        };
        A.unifyComplex_closure0.prototype = {
            call$1: function(complex) {
                return complex.lineBreak;
            },
            $signature: 22
        };
        A._weaveParents_closure3.prototype = {
            call$2: function(group1, group2) {
                var t1, unified;
                if (B.C_ListEquality.equals$2(0, group1, group2)) return group1;
                if (A._complexIsParentSuperselector0(group1, group2)) return group2;
                if (A._complexIsParentSuperselector0(group2, group1)) return group1;
                if (!A._mustUnify0(group1, group2)) return null;
                t1 = this.span;
                unified = A.unifyComplex0(A._setArrayType([
                    A.ComplexSelector$0(B.List_empty17, group1, t1, false),
                    A.ComplexSelector$0(B.List_empty17, group2, t1, false)
                ], type$.JSArray_ComplexSelector_2), t1);
                if (unified == null) t1 = null;
                else {
                    t1 = A.IterableExtension_get_singleOrNull(unified);
                    t1 = t1 == null ? null : t1.components;
                }
                return t1;
            },
            $signature: 486
        };
        A._weaveParents_closure4.prototype = {
            call$1: function(sequence) {
                return A._complexIsParentSuperselector0(sequence.get$first(sequence), this.group);
            },
            $signature: 247
        };
        A._weaveParents_closure5.prototype = {
            call$1: function(sequence) {
                return sequence.get$length(0) === 0;
            },
            $signature: 247
        };
        A._weaveParents_closure6.prototype = {
            call$1: function(choice) {
                return J.get$isNotEmpty$asx(choice);
            },
            $signature: 488
        };
        A._mustUnify_closure0.prototype = {
            call$1: function(component) {
                return B.JSArray_methods.any$1(component.selector.components, new A._mustUnify__closure0(this.uniqueSelectors));
            },
            $signature: 55
        };
        A._mustUnify__closure0.prototype = {
            call$1: function(simple) {
                var t1;
                if (!(simple instanceof A.IDSelector0)) t1 = simple instanceof A.PseudoSelector0 && !simple.isClass;
                else t1 = true;
                return t1 && this.uniqueSelectors.contains$1(0, simple);
            },
            $signature: 15
        };
        A.paths_closure0.prototype = {
            call$2: function(paths, choice) {
                var t1 = this.T;
                t1 = J.expand$1$1$ax(choice, new A.paths__closure0(paths, t1), t1._eval$1("List<0>"));
                t1 = A.List_List$_of(t1, t1.$ti._eval$1("Iterable.E"));
                return t1;
            },
            $signature: function() {
                return this.T._eval$1("List<List<0>>(List<List<0>>,List<0>)");
            }
        };
        A.paths__closure0.prototype = {
            call$1: function(option) {
                var t1 = this.T;
                return J.map$1$1$ax(this.paths, new A.paths___closure0(option, t1), t1._eval$1("List<0>"));
            },
            $signature: function() {
                return this.T._eval$1("Iterable<List<0>>(0)");
            }
        };
        A.paths___closure0.prototype = {
            call$1: function(path) {
                var t1 = A.List_List$_of(path, this.T);
                t1.push(this.option);
                return t1;
            },
            $signature: function() {
                return this.T._eval$1("List<0>(List<0>)");
            }
        };
        A.listIsSuperselector_closure0.prototype = {
            call$1: function(complex1) {
                return B.JSArray_methods.any$1(this.list1, new A.listIsSuperselector__closure0(complex1));
            },
            $signature: 22
        };
        A.listIsSuperselector__closure0.prototype = {
            call$1: function(complex2) {
                return complex2.isSuperselector$1(this.complex1);
            },
            $signature: 22
        };
        A.complexIsSuperselector_closure1.prototype = {
            call$1: function($parent) {
                return $parent.combinators.length > 1;
            },
            $signature: 55
        };
        A.complexIsSuperselector_closure2.prototype = {
            call$1: function(component) {
                return A._isSupercombinator0(this.combinator1, A.IterableExtension_get_firstOrNull(component.combinators));
            },
            $signature: 55
        };
        A._compatibleWithPreviousCombinator_closure0.prototype = {
            call$1: function(component) {
                var t1 = component.combinators, t2 = A.IterableExtension_get_firstOrNull(t1);
                if ((t2 == null ? null : t2.value) !== B.Combinator_98W0) {
                    t1 = A.IterableExtension_get_firstOrNull(t1);
                    t1 = (t1 == null ? null : t1.value) === B.Combinator_sHB0;
                } else t1 = true;
                return t1;
            },
            $signature: 55
        };
        A.compoundIsSuperselector_closure0.prototype = {
            call$1: function(simple1) {
                return B.JSArray_methods.any$1(this.compound2.components, simple1.get$isSuperselector());
            },
            $signature: 15
        };
        A._selectorPseudoIsSuperselector_closure6.prototype = {
            call$1: function(selector2) {
                return A.listIsSuperselector0(this.selector1.components, selector2.components);
            },
            $signature: 68
        };
        A._selectorPseudoIsSuperselector_closure7.prototype = {
            call$1: function(complex1) {
                var t1, t2;
                if (complex1.leadingCombinators.length === 0) {
                    t1 = A._setArrayType([], type$.JSArray_ComplexSelectorComponent_2);
                    t2 = this.parents;
                    if (t2 != null) B.JSArray_methods.addAll$1(t1, t2);
                    t2 = this.compound2;
                    t1.push(new A.ComplexSelectorComponent0(t2, A.List_List$unmodifiable(B.List_empty17, type$.CssValue_Combinator_2), t2.span));
                    t1 = A.complexIsSuperselector0(complex1.components, t1);
                } else t1 = false;
                return t1;
            },
            $signature: 22
        };
        A._selectorPseudoIsSuperselector_closure8.prototype = {
            call$1: function(selector2) {
                return A.listIsSuperselector0(this.selector1.components, selector2.components);
            },
            $signature: 68
        };
        A._selectorPseudoIsSuperselector_closure9.prototype = {
            call$1: function(selector2) {
                return A.listIsSuperselector0(this.selector1.components, selector2.components);
            },
            $signature: 68
        };
        A._selectorPseudoIsSuperselector_closure10.prototype = {
            call$1: function(complex) {
                if (complex.accept$1(B._IsBogusVisitor_true0)) return false;
                return B.JSArray_methods.any$1(this.compound2.components, new A._selectorPseudoIsSuperselector__closure0(complex, this.pseudo1));
            },
            $signature: 22
        };
        A._selectorPseudoIsSuperselector__closure0.prototype = {
            call$1: function(simple2) {
                var t1, selector2, _0_4, _this = this;
                $label0$1: {
                    if (simple2 instanceof A.TypeSelector0) {
                        t1 = B.JSArray_methods.any$1(B.JSArray_methods.get$last(_this.complex.components).selector.components, new A._selectorPseudoIsSuperselector___closure1(simple2));
                        break $label0$1;
                    }
                    if (simple2 instanceof A.IDSelector0) {
                        t1 = B.JSArray_methods.any$1(B.JSArray_methods.get$last(_this.complex.components).selector.components, new A._selectorPseudoIsSuperselector___closure2(simple2));
                        break $label0$1;
                    }
                    selector2 = null;
                    t1 = false;
                    if (simple2 instanceof A.PseudoSelector0) {
                        _0_4 = simple2.selector;
                        if (_0_4 != null) {
                            selector2 = _0_4 == null ? type$.SelectorList_2._as(_0_4) : _0_4;
                            t1 = simple2.name === _this.pseudo1.name;
                        }
                    }
                    if (t1) {
                        t1 = A.listIsSuperselector0(selector2.components, A._setArrayType([
                            _this.complex
                        ], type$.JSArray_ComplexSelector_2));
                        break $label0$1;
                    }
                    t1 = false;
                    break $label0$1;
                }
                return t1;
            },
            $signature: 15
        };
        A._selectorPseudoIsSuperselector___closure1.prototype = {
            call$1: function(simple1) {
                var t1;
                if (simple1 instanceof A.TypeSelector0) {
                    t1 = this.simple2.name.$eq(0, simple1.name);
                    t1 = !t1;
                } else t1 = false;
                return t1;
            },
            $signature: 15
        };
        A._selectorPseudoIsSuperselector___closure2.prototype = {
            call$1: function(simple1) {
                var t1;
                if (simple1 instanceof A.IDSelector0) t1 = this.simple2.name !== simple1.name;
                else t1 = false;
                return t1;
            },
            $signature: 15
        };
        A._selectorPseudoIsSuperselector_closure11.prototype = {
            call$1: function(selector2) {
                var t1 = B.C_ListEquality.equals$2(0, this.selector1.components, selector2.components);
                return t1;
            },
            $signature: 68
        };
        A._selectorPseudoIsSuperselector_closure12.prototype = {
            call$1: function(pseudo2) {
                var t1, selector2;
                if (!(pseudo2 instanceof A.PseudoSelector0)) return false;
                t1 = this.pseudo1;
                if (pseudo2.name !== t1.name) return false;
                if (pseudo2.argument != t1.argument) return false;
                selector2 = pseudo2.selector;
                if (selector2 == null) return false;
                return A.listIsSuperselector0(this.selector1.components, selector2.components);
            },
            $signature: 15
        };
        A._selectorPseudoArgs_closure1.prototype = {
            call$1: function(pseudo) {
                return pseudo.isClass === this.isClass && pseudo.name === this.name;
            },
            $signature: 490
        };
        A._selectorPseudoArgs_closure2.prototype = {
            call$1: function(pseudo) {
                return pseudo.selector;
            },
            $signature: 491
        };
        A.globalFunctions_closure0.prototype = {
            call$1: function($arguments) {
                var t1 = J.getInterceptor$asx($arguments);
                return t1.$index($arguments, 0).get$isTruthy() ? t1.$index($arguments, 1) : t1.$index($arguments, 2);
            },
            $signature: 3
        };
        A.GamutMapMethod0.prototype = {
            toString$0: function(_) {
                return this.name;
            }
        };
        A.HslColorSpace0.prototype = {
            get$isBoundedInternal: function() {
                return true;
            },
            get$isLegacyInternal: function() {
                return true;
            },
            get$isPolarInternal: function() {
                return true;
            },
            convert$5: function(dest, hue, saturation, lightness, alpha) {
                var t1 = hue == null, scaledHue = B.JSNumber_methods.$mod((t1 ? 0 : hue) / 360, 1), t2 = saturation == null, scaledSaturation = (t2 ? 0 : saturation) / 100, t3 = lightness == null, scaledLightness = (t3 ? 0 : lightness) / 100, m2 = scaledLightness <= 0.5 ? scaledLightness * (scaledSaturation + 1) : scaledLightness + scaledSaturation - scaledLightness * scaledSaturation, m1 = scaledLightness * 2 - m2;
                return B.SrgbColorSpace_thf0.convert$8$missingChroma$missingHue$missingLightness(dest, A.hueToRgb0(m1, m2, scaledHue + 0.3333333333333333), A.hueToRgb0(m1, m2, scaledHue), A.hueToRgb0(m1, m2, scaledHue - 0.3333333333333333), alpha, t2, t1, t3);
            }
        };
        A.HwbColorSpace0.prototype = {
            get$isBoundedInternal: function() {
                return true;
            },
            get$isLegacyInternal: function() {
                return true;
            },
            get$isPolarInternal: function() {
                return true;
            },
            convert$5: function(dest, hue, whiteness, blackness, alpha) {
                var t3, t1 = {}, t2 = hue == null, scaledHue = B.JSNumber_methods.$mod(t2 ? 0 : hue, 360) / 360, scaledWhiteness = t1.scaledWhiteness = (whiteness == null ? 0 : whiteness) / 100, scaledBlackness = (blackness == null ? 0 : blackness) / 100, sum = scaledWhiteness + scaledBlackness;
                if (sum > 1) {
                    t3 = t1.scaledWhiteness = scaledWhiteness / sum;
                    scaledBlackness /= sum;
                } else t3 = scaledWhiteness;
                t3 = new A.HwbColorSpace_convert_toRgb0(t1, 1 - t3 - scaledBlackness);
                return B.SrgbColorSpace_thf0.convert$6$missingHue(dest, t3.call$1(scaledHue + 0.3333333333333333), t3.call$1(scaledHue), t3.call$1(scaledHue - 0.3333333333333333), alpha, t2);
            }
        };
        A.HwbColorSpace_convert_toRgb0.prototype = {
            call$1: function(hue) {
                return A.hueToRgb0(0, 1, hue) * this.factor + this._box_0.scaledWhiteness;
            },
            $signature: 12
        };
        A.InterpolatedIDSelector.prototype = {
            get$span: function(_) {
                var t1 = this.name.span;
                return t1.get$file(t1).span$2(0, t1.get$start(t1).offset - 1, t1.get$end(t1).offset);
            },
            accept$1$1: function(visitor) {
                return J.visitIDSelector$1$x(visitor._simple_selector$_inner, this);
            },
            accept$1: function(visitor) {
                return this.accept$1$1(visitor, type$.dynamic);
            },
            toString$0: function(_) {
                return "#" + this.name.toString$0(0);
            }
        };
        A.IDSelector0.prototype = {
            get$specificity: function() {
                return A._asInt(Math.pow(A.SimpleSelector0.prototype.get$specificity.call(this), 2));
            },
            accept$1$1: function(visitor) {
                return visitor.visitIDSelector$1(0, this);
            },
            accept$1: function(visitor) {
                return this.accept$1$1(visitor, type$.dynamic);
            },
            addSuffix$1: function(suffix) {
                return new A.IDSelector0(this.name + suffix, this.span);
            },
            unify$1: function(compound) {
                if (B.JSArray_methods.any$1(compound, new A.IDSelector_unify_closure0(this))) return null;
                return this.super$SimpleSelector$unify0(compound);
            },
            $eq: function(_, other) {
                if (other == null) return false;
                return other instanceof A.IDSelector0 && other.name === this.name;
            },
            get$hashCode: function(_) {
                return B.JSString_methods.get$hashCode(this.name);
            }
        };
        A.IDSelector_unify_closure0.prototype = {
            call$1: function(simple) {
                var t1;
                if (simple instanceof A.IDSelector0) t1 = this.$this.name !== simple.name;
                else t1 = false;
                return t1;
            },
            $signature: 15
        };
        A.IfExpression0.prototype = {
            accept$1$1: function(visitor) {
                return visitor.visitIfExpression$1(0, this);
            },
            accept$1: function(visitor) {
                return this.accept$1$1(visitor, type$.dynamic);
            },
            toString$0: function(_) {
                var t1, t2, first, _i, t3, t4, condition;
                for(t1 = this.branches, t2 = t1.length, first = true, _i = 0, t3 = "if("; _i < t2; ++_i){
                    t4 = t1[_i];
                    condition = t4._0;
                    if (first) first = false;
                    else t3 += "; ";
                    t3 = t3 + A.S(condition == null ? "else" : condition) + ": " + t4._1.toString$0(0);
                }
                t1 = t3 + A.Primitives_stringFromCharCode(41);
                return t1.charCodeAt(0) == 0 ? t1 : t1;
            },
            get$span: function(receiver) {
                return this.span;
            }
        };
        A.IfConditionExpression0.prototype = {
            get$isArbitrarySubstitution: function() {
                return false;
            },
            $isAstNode0: 1,
            $isSassNode: 1
        };
        A.IfConditionParenthesized0.prototype = {
            toInterpolation$1: function(arbitrarySubstitution) {
                var t1 = new A.StringBuffer(""), t2 = new A.InterpolationBuffer0(t1, A._setArrayType([], type$.JSArray_Object), A._setArrayType([], type$.JSArray_nullable_FileSpan)), t3 = A.Primitives_stringFromCharCode(40);
                t1._contents += t3;
                t2.addInterpolation$1(this.expression.toInterpolation$1(arbitrarySubstitution));
                t3 = A.Primitives_stringFromCharCode(41);
                t1._contents += t3;
                return t2.interpolation$1(this.span);
            },
            accept$1$1: function(visitor) {
                return visitor.visitIfConditionParenthesized$1(0, this);
            },
            accept$1: function(visitor) {
                return this.accept$1$1(visitor, type$.dynamic);
            },
            toString$0: function(_) {
                return "(" + this.expression.toString$0(0) + ")";
            },
            get$span: function(receiver) {
                return this.span;
            }
        };
        A.IfConditionNegation0.prototype = {
            toInterpolation$1: function(arbitrarySubstitution) {
                var t1 = new A.StringBuffer(""), t2 = new A.InterpolationBuffer0(t1, A._setArrayType([], type$.JSArray_Object), A._setArrayType([], type$.JSArray_nullable_FileSpan));
                t1._contents = "not ";
                t2.addInterpolation$1(this.expression.toInterpolation$1(arbitrarySubstitution));
                return t2.interpolation$1(this.span);
            },
            accept$1$1: function(visitor) {
                return visitor.visitIfConditionNegation$1(0, this);
            },
            accept$1: function(visitor) {
                return this.accept$1$1(visitor, type$.dynamic);
            },
            toString$0: function(_) {
                return "not " + this.expression.toString$0(0);
            },
            get$span: function(receiver) {
                return this.span;
            }
        };
        A.IfConditionOperation0.prototype = {
            get$span: function(_) {
                var t1 = this.expressions, t2 = B.JSArray_methods.get$first(t1);
                t2 = t2.get$span(t2);
                t1 = B.JSArray_methods.get$last(t1);
                return t2.expand$1(0, t1.get$span(t1));
            },
            toInterpolation$1: function(arbitrarySubstitution) {
                var t2, t3, t4, first, _i, expression, t1 = new A.StringBuffer(""), buffer = new A.InterpolationBuffer0(t1, A._setArrayType([], type$.JSArray_Object), A._setArrayType([], type$.JSArray_nullable_FileSpan));
                for(t2 = this.expressions, t3 = t2.length, t4 = this.op, first = true, _i = 0; _i < t3; ++_i){
                    expression = t2[_i];
                    if (first) first = false;
                    else t1._contents += " " + t4.toString$0(0) + " ";
                    buffer.addInterpolation$1(expression.toInterpolation$1(arbitrarySubstitution));
                }
                return buffer.interpolation$1(new A.LazyFileSpan0(new A.IfConditionOperation_toInterpolation_closure0(this)));
            },
            accept$1$1: function(visitor) {
                return visitor.visitIfConditionOperation$1(0, this);
            },
            accept$1: function(visitor) {
                return this.accept$1$1(visitor, type$.dynamic);
            },
            toString$0: function(_) {
                return B.JSArray_methods.join$1(this.expressions, " " + this.op.toString$0(0) + " ");
            }
        };
        A.IfConditionOperation_toInterpolation_closure0.prototype = {
            call$0: function() {
                return this.$this.get$span(0);
            },
            $signature: 16
        };
        A.IfConditionFunction0.prototype = {
            get$isArbitrarySubstitution: function() {
                var t2, t1 = this.name.get$asPlain(), _0_0 = t1 == null ? null : t1.toLowerCase();
                $label0$0: {
                    t1 = true;
                    if ("if" === _0_0 || "var" === _0_0 || "attr" === _0_0) break $label0$0;
                    if (_0_0 != null) t2 = B.JSString_methods.startsWith$1(_0_0, "--");
                    else t2 = false;
                    if (t2) break $label0$0;
                    t1 = false;
                    break $label0$0;
                }
                return t1;
            },
            toInterpolation$1: function(_) {
                var t3, t1 = new A.StringBuffer(""), t2 = new A.InterpolationBuffer0(t1, A._setArrayType([], type$.JSArray_Object), A._setArrayType([], type$.JSArray_nullable_FileSpan));
                t2.addInterpolation$1(this.name);
                t3 = A.Primitives_stringFromCharCode(40);
                t1._contents += t3;
                t2.addInterpolation$1(this.$arguments);
                t3 = A.Primitives_stringFromCharCode(41);
                t1._contents += t3;
                return t2.interpolation$1(this.span);
            },
            accept$1$1: function(visitor) {
                return visitor.visitIfConditionFunction$1(0, this);
            },
            accept$1: function(visitor) {
                return this.accept$1$1(visitor, type$.dynamic);
            },
            toString$0: function(_) {
                return this.name.toString$0(0) + "(" + this.$arguments.toString$0(0) + ")";
            },
            get$span: function(receiver) {
                return this.span;
            }
        };
        A.IfConditionSass0.prototype = {
            toInterpolation$1: function(arbitrarySubstitution) {
                return A.throwExpression(A.MultiSourceSpanFormatException$(string$.if___c, arbitrarySubstitution.get$span(arbitrarySubstitution), "arbitrary substitution", A.LinkedHashMap_LinkedHashMap$_literal([
                    this.span,
                    "sass() expression"
                ], type$.SourceSpan, type$.String), null));
            },
            accept$1$1: function(visitor) {
                return visitor.visitIfConditionSass$1(0, this);
            },
            accept$1: function(visitor) {
                return this.accept$1$1(visitor, type$.dynamic);
            },
            toString$0: function(_) {
                return "sass(" + this.expression.toString$0(0) + ")";
            },
            get$span: function(receiver) {
                return this.span;
            }
        };
        A.IfConditionRaw0.prototype = {
            get$span: function(_) {
                return this.text.span;
            },
            get$isArbitrarySubstitution: function() {
                return true;
            },
            toInterpolation$1: function(_) {
                return this.text;
            },
            accept$1$1: function(visitor) {
                return visitor.visitIfConditionRaw$1(0, this);
            },
            accept$1: function(visitor) {
                return this.accept$1$1(visitor, type$.dynamic);
            },
            toString$0: function(_) {
                return this.text.toString$0(0);
            }
        };
        A.JSIfConditionExpressionVisitor.prototype = {
            visitIfConditionParenthesized$1: function(_, node) {
                return J.visitIfConditionParenthesized$1$x(this._if_condition_expression$_inner, node);
            },
            visitIfConditionNegation$1: function(_, node) {
                return J.visitIfConditionNegation$1$x(this._if_condition_expression$_inner, node);
            },
            visitIfConditionOperation$1: function(_, node) {
                return J.visitIfConditionOperation$1$x(this._if_condition_expression$_inner, node);
            },
            visitIfConditionFunction$1: function(_, node) {
                return J.visitIfConditionFunction$1$x(this._if_condition_expression$_inner, node);
            },
            visitIfConditionSass$1: function(_, node) {
                return J.visitIfConditionSass$1$x(this._if_condition_expression$_inner, node);
            },
            visitIfConditionRaw$1: function(_, node) {
                return J.visitIfConditionRaw$1$x(this._if_condition_expression$_inner, node);
            },
            $isIfConditionExpressionVisitor: 1
        };
        A.JSIfConditionExpressionVisitorObject.prototype = {};
        A.IfRule0.prototype = {
            accept$1$1: function(visitor) {
                return visitor.visitIfRule$1(0, this);
            },
            accept$1: function(visitor) {
                return this.accept$1$1(visitor, type$.dynamic);
            },
            toString$0: function(_) {
                var result = A.ListExtensions_mapIndexed(this.clauses, new A.IfRule_toString_closure0(), type$.IfClause_2, type$.String).join$1(0, " "), lastClause = this.lastClause;
                return lastClause != null ? result + (" " + lastClause.toString$0(0)) : result;
            },
            get$span: function(receiver) {
                return this.span;
            }
        };
        A.IfRule_toString_closure0.prototype = {
            call$2: function(index, clause) {
                var t1 = index === 0 ? "if" : "else if";
                return "@" + t1 + " " + clause.expression.toString$0(0) + " {" + B.JSArray_methods.join$1(clause.children, " ") + "}";
            },
            $signature: 492
        };
        A.IfRuleClause0.prototype = {};
        A.IfRuleClause$__closure0.prototype = {
            call$1: function(child) {
                var t1;
                $label0$0: {
                    if (child instanceof A.VariableDeclaration0 || child instanceof A.FunctionRule0 || child instanceof A.MixinRule0) {
                        t1 = true;
                        break $label0$0;
                    }
                    if (child instanceof A.ImportRule0) {
                        t1 = B.JSArray_methods.any$1(child.imports, new A.IfRuleClause$___closure0());
                        break $label0$0;
                    }
                    t1 = false;
                    break $label0$0;
                }
                return t1;
            },
            $signature: 248
        };
        A.IfRuleClause$___closure0.prototype = {
            call$1: function($import) {
                return $import instanceof A.DynamicImport0;
            },
            $signature: 249
        };
        A.IfClause0.prototype = {
            toString$0: function(_) {
                return "@if " + this.expression.toString$0(0) + " {" + B.JSArray_methods.join$1(this.children, " ") + "}";
            }
        };
        A.ElseClause0.prototype = {
            toString$0: function(_) {
                return "@else {" + B.JSArray_methods.join$1(this.children, " ") + "}";
            }
        };
        A.ImmutableList0.prototype = {};
        A.ImmutableMap0.prototype = {};
        A.immutableMapToDartMap_closure.prototype = {
            call$3: function(value, key, _) {
                this.dartMap.$indexSet(0, key, value);
            },
            "call*": "call$3",
            $requiredArgCount: 3,
            $signature: 495
        };
        A.NodeImporter.prototype = {
            loadRelative$3: function(url, previous, forImport) {
                var t1, t2, _null = null;
                if ($.$get$url().style.rootLength$1(url) > 0) {
                    if (!B.JSString_methods.startsWith$1(url, "/") && !B.JSString_methods.startsWith$1(url, "file:")) return _null;
                    return this._tryPath$2($.$get$context().style.pathFromUri$1(A._parseUri(url)), forImport);
                }
                if ((previous == null ? _null : previous.get$scheme()) !== "file") return _null;
                t1 = $.$get$context();
                previous.toString;
                t2 = t1.style;
                return this._tryPath$2(A.join(t1.dirname$1(t2.pathFromUri$1(A._parseUri(previous))), t2.pathFromUri$1(A._parseUri(url)), _null), forImport);
            },
            load$3: function(_, url, previous, forImport) {
                var t1, t2, _i, _0_0, _this = this, previousString = _this._previousToString$1(previous);
                for(t1 = _this._implementation$_importers, t2 = t1.length, _i = 0; _i < t2; ++_i){
                    _0_0 = A.wrapJSExceptions(new A.NodeImporter_load_closure(_this, t1[_i], forImport, url, previousString));
                    if (_0_0 != null) return _this._handleImportResult$4(url, previous, _0_0, forImport);
                }
                return _this._resolveLoadPathFromUrl$2(A.Uri_parse(url), forImport);
            },
            loadAsync$3: function(url, previous, forImport) {
                return this.loadAsync$body$NodeImporter(url, previous, forImport);
            },
            loadAsync$body$NodeImporter: function(url, previous, forImport) {
                var $async$goto = 0, $async$completer = A._makeAsyncAwaitCompleter(type$.nullable_Record_2_String_and_String), $async$returnValue, $async$self = this, t1, t2, _i, _0_0, previousString;
                var $async$loadAsync$3 = A._wrapJsFunctionForAsync(function($async$errorCode, $async$result) {
                    if ($async$errorCode === 1) return A._asyncRethrow($async$result, $async$completer);
                    for(;;)switch($async$goto){
                        case 0:
                            // Function start
                            previousString = $async$self._previousToString$1(previous);
                            t1 = $async$self._implementation$_importers, t2 = t1.length, _i = 0;
                        case 3:
                            // for condition
                            if (!(_i < t2)) {
                                // goto after for
                                $async$goto = 5;
                                break;
                            }
                            $async$goto = 6;
                            return A._asyncAwait($async$self._callImporterAsync$4(t1[_i], url, previousString, forImport), $async$loadAsync$3);
                        case 6:
                            // returning from await.
                            _0_0 = $async$result;
                            if (_0_0 != null) {
                                $async$returnValue = $async$self._handleImportResult$4(url, previous, _0_0, forImport);
                                // goto return
                                $async$goto = 1;
                                break;
                            }
                        case 4:
                            // for update
                            ++_i;
                            // goto for condition
                            $async$goto = 3;
                            break;
                        case 5:
                            // after for
                            $async$returnValue = $async$self._resolveLoadPathFromUrl$2(A.Uri_parse(url), forImport);
                            // goto return
                            $async$goto = 1;
                            break;
                        case 1:
                            // return
                            return A._asyncReturn($async$returnValue, $async$completer);
                    }
                });
                return A._asyncStartSync($async$loadAsync$3, $async$completer);
            },
            _previousToString$1: function(previous) {
                var t1;
                $label0$0: {
                    if (previous == null) {
                        t1 = "stdin";
                        break $label0$0;
                    }
                    if ("file" === previous.get$scheme()) {
                        t1 = $.$get$context().style.pathFromUri$1(A._parseUri(previous));
                        break $label0$0;
                    }
                    t1 = previous.toString$0(0);
                    break $label0$0;
                }
                return t1;
            },
            _resolveLoadPathFromUrl$2: function(url, forImport) {
                return url.get$scheme() === "" || url.get$scheme() === "file" ? this._resolveLoadPath$2($.$get$context().style.pathFromUri$1(A._parseUri(url)), forImport) : null;
            },
            _resolveLoadPath$2: function(path, forImport) {
                var t1, t2, _i, t3, _1_0, _null = null, _0_0 = this._tryPath$2(A.absolute(path, _null, _null, _null, _null, _null, _null, _null, _null, _null, _null, _null, _null, _null, _null), forImport);
                if (_0_0 != null) return _0_0;
                for(t1 = this._includePaths, t2 = t1.length, _i = 0; _i < t2; ++_i){
                    t3 = A.join(t1[_i], path, _null);
                    _1_0 = this._tryPath$2($.$get$context().absolute$15(t3, _null, _null, _null, _null, _null, _null, _null, _null, _null, _null, _null, _null, _null, _null), forImport);
                    if (_1_0 != null) return _1_0;
                }
                return _null;
            },
            _tryPath$2: function(path, forImport) {
                var t1 = forImport ? A.inImportRule(new A.NodeImporter__tryPath_closure(path), type$.nullable_String) : A.resolveImportPath0(path);
                return A.NullableExtension_andThen0(t1, new A.NodeImporter__tryPath_closure0());
            },
            _handleImportResult$4: function(url, previous, value, forImport) {
                var t1, file, contents, t2, resolved;
                if (value instanceof self.Error) throw A.wrapException(value);
                if (!type$.NodeImporterResult._is(value)) return null;
                t1 = J.getInterceptor$x(value);
                file = t1.get$file(value);
                contents = t1.get$contents(value);
                t1 = contents == null;
                t2 = !t1;
                if (t2 && A._asString(new self.Function("value", "return typeof value").call$1(contents)) !== "string") A.jsThrow(new A.ArgumentError(true, contents, "contents", "must be a string but was: " + A.jsType(contents)));
                if (file == null) return new A._Record_2(t1 ? "" : contents, url);
                else if (t2) return new A._Record_2(contents, $.$get$context().toUri$1(file).toString$0(0));
                else {
                    resolved = this.loadRelative$3($.$get$context().toUri$1(file).toString$0(0), previous, forImport);
                    if (resolved == null) resolved = this._resolveLoadPath$2(file, forImport);
                    if (resolved != null) return resolved;
                    throw A.wrapException("Can't find stylesheet to import.");
                }
            },
            _callImporterAsync$4: function(importer, url, previousString, forImport) {
                return this._callImporterAsync$body$NodeImporter(importer, url, previousString, forImport);
            },
            _callImporterAsync$body$NodeImporter: function(importer, url, previousString, forImport) {
                var $async$goto = 0, $async$completer = A._makeAsyncAwaitCompleter(type$.nullable_Object), $async$returnValue, $async$self = this, t1, result;
                var $async$_callImporterAsync$4 = A._wrapJsFunctionForAsync(function($async$errorCode, $async$result) {
                    if ($async$errorCode === 1) return A._asyncRethrow($async$result, $async$completer);
                    for(;;)switch($async$goto){
                        case 0:
                            // Function start
                            t1 = new A._Future($.Zone__current, type$._Future_Object);
                            result = A.wrapJSExceptions(new A.NodeImporter__callImporterAsync_closure($async$self, importer, forImport, url, previousString, new A._AsyncCompleter(t1, type$._AsyncCompleter_Object)));
                            $async$goto = A._asBool($.$get$_isUndefined().call$1(result)) ? 3 : 4;
                            break;
                        case 3:
                            // then
                            $async$goto = 5;
                            return A._asyncAwait(t1, $async$_callImporterAsync$4);
                        case 5:
                            // returning from await.
                            $async$returnValue = $async$result;
                            // goto return
                            $async$goto = 1;
                            break;
                        case 4:
                            // join
                            $async$returnValue = result;
                            // goto return
                            $async$goto = 1;
                            break;
                        case 1:
                            // return
                            return A._asyncReturn($async$returnValue, $async$completer);
                    }
                });
                return A._asyncStartSync($async$_callImporterAsync$4, $async$completer);
            },
            _renderContext$1: function(fromImport) {
                var context = {
                    options: type$.RenderContextOptions._as(this._implementation$_options),
                    fromImport: fromImport
                };
                J.set$context$x(J.get$options$x(context), context);
                return context;
            }
        };
        A.NodeImporter_load_closure.prototype = {
            call$0: function() {
                var _this = this;
                return J.apply$2$x(_this.importer, _this.$this._renderContext$1(_this.forImport), A._setArrayType([
                    _this.url,
                    _this.previousString
                ], type$.JSArray_Object));
            },
            $signature: 36
        };
        A.NodeImporter__tryPath_closure.prototype = {
            call$0: function() {
                return A.resolveImportPath0(this.path);
            },
            $signature: 47
        };
        A.NodeImporter__tryPath_closure0.prototype = {
            call$1: function(resolved) {
                return new A._Record_2(A.readFile0(resolved), $.$get$context().toUri$1(resolved).toString$0(0));
            },
            $signature: 496
        };
        A.NodeImporter__callImporterAsync_closure.prototype = {
            call$0: function() {
                var _this = this;
                return J.apply$2$x(_this.importer, _this.$this._renderContext$1(_this.forImport), A._setArrayType([
                    _this.url,
                    _this.previousString,
                    A.allowInterop(_this.completer.get$complete())
                ], type$.JSArray_Object));
            },
            $signature: 36
        };
        A.ModifiableCssImport0.prototype = {
            accept$1$1: function(visitor) {
                return visitor.visitCssImport$1(this);
            },
            accept$1: function(visitor) {
                return this.accept$1$1(visitor, type$.dynamic);
            },
            get$span: function(receiver) {
                return this.span;
            }
        };
        A.ImportCache0.prototype = {
            canonicalize$4$baseImporter$baseUrl$forImport: function(_, url, baseImporter, baseUrl, forImport) {
                var t1, resolvedUrl, key, relativeResult, t2, t3, t4, t5, t6, cacheable, i, importer, perImporterKey, t7, _1_0, _1_2_isSet, result, _1_2, _2_0, _2_1, _2_5_isSet, _2_5, _2_3, _2_3_isSet, j, _this = this, _null = null;
                if (A.isBrowser()) t1 = (baseImporter == null || baseImporter instanceof A.NoOpImporter0) && _this._import_cache$_importers.length === 0;
                else t1 = false;
                if (t1) throw A.wrapException(string$.Customi);
                if (baseImporter != null && url.get$scheme() === "") {
                    resolvedUrl = baseUrl == null ? _null : baseUrl.resolveUri$1(url);
                    if (resolvedUrl == null) resolvedUrl = url;
                    key = new A._Record_3_forImport(baseImporter, resolvedUrl, forImport);
                    relativeResult = _this._import_cache$_perImporterCanonicalizeCache.putIfAbsent$2(key, new A.ImportCache_canonicalize_closure0(_this, baseImporter, resolvedUrl, baseUrl, forImport, key, url));
                    if (relativeResult != null) return relativeResult;
                }
                key = new A._Record_2_forImport(url, forImport);
                t1 = _this._import_cache$_canonicalizeCache;
                if (t1.containsKey$1(key)) return t1.$index(0, key);
                for(t2 = _this._import_cache$_importers, t3 = type$.Record_1_nullable_Object, t4 = _this._import_cache$_perImporterCanonicalizeCache, t5 = type$.nullable_Record_3_Importer_and_Uri_and_Uri_originalUrl_2, t6 = type$.Record_3_Importer_and_Uri_and_Uri_originalUrl_2, cacheable = true, i = 0; i < t2.length; ++i){
                    importer = t2[i];
                    perImporterKey = new A._Record_3_forImport(importer, url, forImport);
                    if (t4.containsKey$1(perImporterKey)) {
                        t7 = t4.$index(0, perImporterKey);
                        _1_0 = new A._Record_1(t7 == null ? t5._as(t7) : t7);
                    } else _1_0 = _null;
                    _1_2_isSet = t3._is(_1_0);
                    result = _null;
                    if (_1_2_isSet) {
                        _1_2 = _1_0._0;
                        t7 = _1_2 != null;
                        if (t7) {
                            t6._as(_1_2);
                            result = _1_2;
                        }
                    } else {
                        _1_2 = _null;
                        t7 = false;
                    }
                    if (t7) return result;
                    if (_1_2_isSet) t7 = _1_2 == null;
                    else t7 = false;
                    if (t7) continue;
                    $label0$1: {
                        _2_0 = _this._import_cache$_canonicalize$4(importer, url, baseUrl, forImport);
                        _2_1 = _2_0._0;
                        _2_5_isSet = _2_1 != null;
                        _2_5 = _null;
                        _2_3 = _null;
                        t7 = false;
                        if (_2_5_isSet) {
                            result = _2_1 == null ? t6._as(_2_1) : _2_1;
                            _2_3 = _2_0._1;
                            t7 = _2_3;
                            _2_5 = t7;
                            t7 = t7 && cacheable;
                        } else result = _null;
                        if (t7) {
                            t1.$indexSet(0, key, result);
                            return result;
                        }
                        if (_2_5_isSet) {
                            t7 = _2_5;
                            _2_3_isSet = _2_5_isSet;
                        } else {
                            _2_3 = _2_0._1;
                            t7 = _2_3;
                            _2_3_isSet = true;
                        }
                        t7 = t7 && !cacheable;
                        if (t7) {
                            t4.$indexSet(0, perImporterKey, _2_1);
                            if (_2_1 != null) return _2_1;
                            break $label0$1;
                        }
                        t7 = false === (_2_3_isSet ? _2_3 : _2_0._1);
                        if (t7) {
                            if (cacheable) {
                                for(j = 0; j < i; ++j)t4.$indexSet(0, new A._Record_3_forImport(t2[j], url, forImport), _null);
                                cacheable = false;
                            }
                            if (_2_1 != null) return _2_1;
                        }
                    }
                }
                if (cacheable) t1.$indexSet(0, key, _null);
                return _null;
            },
            _import_cache$_canonicalize$4: function(importer, url, baseUrl, forImport) {
                var passContainingUrl, canonicalizeContext, t1, result, cacheable;
                if (baseUrl != null) passContainingUrl = url.get$scheme() === "" || importer.isNonCanonicalScheme$1(url.get$scheme());
                else passContainingUrl = false;
                canonicalizeContext = new A.CanonicalizeContext0(forImport, passContainingUrl ? baseUrl : null);
                t1 = type$.nullable_Object;
                result = A.runZoned(new A.ImportCache__canonicalize_closure0(importer, url), A.LinkedHashMap_LinkedHashMap$_literal([
                    B.Symbol__canonicalizeContext,
                    canonicalizeContext
                ], t1, t1), type$.nullable_Uri);
                cacheable = !passContainingUrl || !canonicalizeContext._canonicalize_context$_wasContainingUrlAccessed;
                if (result == null) return new A._Record_2(null, cacheable);
                if (result.get$scheme() !== "" && importer.isNonCanonicalScheme$1(result.get$scheme())) throw A.wrapException("Importer " + importer.toString$0(0) + " canonicalized " + url.toString$0(0) + " to " + result.toString$0(0) + string$.x2c_whicu);
                return new A._Record_2(new A._Record_3_originalUrl(importer, result, url), cacheable);
            },
            importCanonical$3$originalUrl: function(importer, canonicalUrl, originalUrl) {
                return this._import_cache$_importCache.putIfAbsent$2(canonicalUrl, new A.ImportCache_importCanonical_closure0(this, importer, canonicalUrl, originalUrl));
            },
            humanize$1: function(canonicalUrl) {
                var t1 = this._import_cache$_canonicalizeCache, t2 = type$.NonNullsIterable_Record_3_Importer_and_Uri_and_Uri_originalUrl_2;
                t2 = A.NullableExtension_andThen0(A.minBy(new A.MappedIterable(new A.WhereIterable(new A.NonNullsIterable(new A.LinkedHashMapValuesIterable(t1, A._instanceType(t1)._eval$1("LinkedHashMapValuesIterable<2>")), t2), new A.ImportCache_humanize_closure3(canonicalUrl), t2._eval$1("WhereIterable<Iterable.E>")), new A.ImportCache_humanize_closure4(), t2._eval$1("MappedIterable<Iterable.E,Uri>")), new A.ImportCache_humanize_closure5()), new A.ImportCache_humanize_closure6(canonicalUrl));
                return t2 == null ? canonicalUrl : t2;
            },
            sourceMapUrl$1: function(_, canonicalUrl) {
                var t1 = this._import_cache$_resultsCache.$index(0, canonicalUrl);
                t1 = t1 == null ? null : t1.get$sourceMapUrl(0);
                return t1 == null ? canonicalUrl : t1;
            }
        };
        A.ImportCache_canonicalize_closure0.prototype = {
            call$0: function() {
                var _this = this, t1 = _this.$this, t2 = _this.baseUrl, _0_0 = t1._import_cache$_canonicalize$4(_this.baseImporter, _this.resolvedUrl, t2, _this.forImport);
                if (t2 != null) t1._import_cache$_nonCanonicalRelativeUrls.$indexSet(0, _this.key, _this.url);
                return _0_0._0;
            },
            $signature: 497
        };
        A.ImportCache__canonicalize_closure0.prototype = {
            call$0: function() {
                return this.importer.canonicalize$1(0, this.url);
            },
            $signature: 144
        };
        A.ImportCache_importCanonical_closure0.prototype = {
            call$0: function() {
                var t3, _this = this, t1 = Date.now(), t2 = _this.canonicalUrl, result = _this.importer.load$1(0, t2);
                if (result == null) return null;
                t3 = _this.$this;
                t3._import_cache$_loadTimes.$indexSet(0, t2, new A.DateTime(t1, 0, false));
                t3._import_cache$_resultsCache.$indexSet(0, t2, result);
                t3 = result.contents;
                t1 = result.syntax;
                t2 = _this.originalUrl.resolveUri$1(t2);
                return A.Stylesheet_Stylesheet$parse0(t3, t1, false, t2);
            },
            $signature: 498
        };
        A.ImportCache_humanize_closure3.prototype = {
            call$1: function(result) {
                return result._1.$eq(0, this.canonicalUrl);
            },
            $signature: 499
        };
        A.ImportCache_humanize_closure4.prototype = {
            call$1: function(result) {
                return result._2;
            },
            $signature: 500
        };
        A.ImportCache_humanize_closure5.prototype = {
            call$1: function(url) {
                return url.get$path(url).length;
            },
            $signature: 107
        };
        A.ImportCache_humanize_closure6.prototype = {
            call$1: function(url) {
                var t1 = $.$get$url(), t2 = this.canonicalUrl;
                return url.resolve$1(0, A.ParsedPath_ParsedPath$parse(t2.get$path(t2), t1.style).get$basename());
            },
            $signature: 49
        };
        A.ImportRule0.prototype = {
            accept$1$1: function(visitor) {
                return visitor.visitImportRule$1(0, this);
            },
            accept$1: function(visitor) {
                return this.accept$1$1(visitor, type$.dynamic);
            },
            toString$0: function(_) {
                return "@import " + B.JSArray_methods.join$1(this.imports, ", ") + ";";
            },
            get$span: function(receiver) {
                return this.span;
            }
        };
        A.JSImporter.prototype = {};
        A.JSImporterResult.prototype = {};
        A.Importer0.prototype = {
            isNonCanonicalScheme$1: function(scheme) {
                return false;
            }
        };
        A.NodeImporterResult0.prototype = {};
        A.IncludeRule0.prototype = {
            get$spanWithoutContent: function() {
                var t2, t1 = this.span;
                if (!(this.content == null)) {
                    t2 = this.$arguments.span;
                    t2 = A.SpanExtensions_trimRight0(A.SpanExtensions_trimLeft0(t1.get$file(t1).span$2(0, t1.get$start(t1).offset, t2.get$end(t2).offset)));
                    t1 = t2;
                }
                return t1;
            },
            get$nameSpan: function() {
                var startSpan, scanner, _null = null, t1 = this.span;
                if (B.JSString_methods.startsWith$1(t1.get$text(), "+")) startSpan = A.SpanExtensions_trimLeft0(A.FileSpanExtension_subspan(t1, 1, _null));
                else {
                    scanner = A.StringScanner$(t1.get$text(), _null, _null);
                    scanner.expectChar$1(64);
                    A._scanIdentifier0(scanner);
                    startSpan = A.SpanExtensions_trimLeft0(A.FileSpanExtension_subspan(t1, scanner._string_scanner$_position, _null));
                }
                if (this.namespace != null) {
                    scanner = A.StringScanner$(startSpan.get$text(), _null, _null);
                    A._scanIdentifier0(scanner);
                    startSpan = A.FileSpanExtension_subspan(A.FileSpanExtension_subspan(startSpan, scanner._string_scanner$_position, _null), 1, _null);
                }
                return A.SpanExtensions_initialIdentifier0(startSpan);
            },
            accept$1$1: function(visitor) {
                return visitor.visitIncludeRule$1(0, this);
            },
            accept$1: function(visitor) {
                return this.accept$1$1(visitor, type$.dynamic);
            },
            toString$0: function(_) {
                var t2, _this = this, t1 = _this.namespace;
                t1 = t1 != null ? "@include " + (t1 + ".") : "@include ";
                t1 += _this.name;
                t2 = _this.$arguments;
                if (!t2.get$isEmpty(0)) t1 += "(" + t2.toString$0(0) + ")";
                t2 = _this.content;
                t1 += t2 == null ? ";" : " " + t2.toString$0(0);
                return t1.charCodeAt(0) == 0 ? t1 : t1;
            },
            get$span: function(receiver) {
                return this.span;
            }
        };
        A.InterpolatedFunctionExpression0.prototype = {
            accept$1$1: function(visitor) {
                return visitor.visitInterpolatedFunctionExpression$1(0, this);
            },
            accept$1: function(visitor) {
                return this.accept$1$1(visitor, type$.dynamic);
            },
            toString$0: function(_) {
                return this.name.toString$0(0) + this.$arguments.toString$0(0);
            },
            get$span: function(receiver) {
                return this.span;
            }
        };
        A.InterpolatedSelector.prototype = {
            $isAstNode0: 1,
            $isSassNode: 1
        };
        A.Interpolation0.prototype = {
            get$asPlain: function() {
                var _0_1, t1, _0_6_isSet, _0_6, first, _0_0 = this.contents;
                $label0$0: {
                    _0_1 = _0_0.length;
                    if (_0_1 <= 0) {
                        t1 = "";
                        break $label0$0;
                    }
                    _0_6_isSet = _0_1 === 1;
                    if (_0_6_isSet) {
                        _0_6 = _0_0[0];
                        t1 = typeof _0_6 == "string";
                    } else {
                        _0_6 = null;
                        t1 = false;
                    }
                    if (t1) {
                        first = A._asString(_0_6_isSet ? _0_6 : _0_0[0]);
                        t1 = first;
                        break $label0$0;
                    }
                    t1 = null;
                    break $label0$0;
                }
                return t1;
            },
            get$initialPlain: function() {
                var _0_4_isSet, _0_4, t1, first, _0_0 = this.contents;
                $label0$0: {
                    _0_4_isSet = _0_0.length >= 1;
                    if (_0_4_isSet) {
                        _0_4 = _0_0[0];
                        t1 = typeof _0_4 == "string";
                    } else {
                        _0_4 = null;
                        t1 = false;
                    }
                    if (t1) {
                        first = A._asString(_0_4_isSet ? _0_4 : _0_0[0]);
                        t1 = first;
                        break $label0$0;
                    }
                    t1 = "";
                    break $label0$0;
                }
                return t1;
            },
            spanForElement$1: function(index) {
                var t1, t2, t3, t4, t5, _this = this;
                $label0$0: {
                    if (typeof _this.contents[index] == "string") {
                        t1 = _this.span;
                        t2 = t1.get$file(t1);
                        if (index === 0) t3 = t1.get$start(t1);
                        else {
                            t3 = _this.spans[index - 1];
                            t3 = t3.get$end(t3);
                        }
                        t4 = index + 1;
                        t5 = _this.spans;
                        if (t4 === t5.length) t1 = t1.get$end(t1);
                        else {
                            t1 = t5[t4];
                            t1 = t1.get$start(t1);
                        }
                        t1 = t2.span$2(0, t3.offset, t1.offset);
                        break $label0$0;
                    }
                    t1 = _this.spans[index];
                    t1.toString;
                    break $label0$0;
                }
                return t1;
            },
            Interpolation$30: function(contents, spans, span) {
                var t1, t2, t3, t4, i, t5, isString, _s5_ = "spans", _s8_ = "contents";
                if (spans.length !== J.get$length$asx(contents)) throw A.wrapException(A.ArgumentError$value(this.spans, _s5_, "Must be the same length as contents."));
                for(t1 = this.contents, t2 = t1.length, t3 = spans.length, t4 = this.spans, i = 0; i < t2; ++i){
                    t5 = t1[i];
                    isString = typeof t5 == "string";
                    if (!isString && !(t5 instanceof A.Expression0)) throw A.wrapException(A.ArgumentError$value(t1, _s8_, "May only contain Strings or Expressions."));
                    else if (isString) {
                        if (i !== 0 && typeof t1[i - 1] == "string") throw A.wrapException(A.ArgumentError$value(t1, _s8_, "May not contain adjacent Strings."));
                        else if (i < t3 && t4[i] != null) throw A.wrapException(A.ArgumentError$value(t4, _s5_, string$.May_no + i + ")."));
                    } else if (i >= t3 || t4[i] == null) throw A.wrapException(A.ArgumentError$value(t4, _s5_, string$.Must_n + i + ")."));
                }
            },
            toString$0: function(_) {
                var t1 = this.contents;
                return new A.MappedListIterable(t1, new A.Interpolation_toString_closure0(), A._arrayInstanceType(t1)._eval$1("MappedListIterable<1,String>")).join$0(0);
            },
            $isAstNode0: 1,
            $isSassNode: 1,
            get$span: function(receiver) {
                return this.span;
            }
        };
        A.Interpolation_toString_closure0.prototype = {
            call$1: function(value) {
                return typeof value == "string" ? value : "#{" + A.S(value) + "}";
            },
            $signature: 132
        };
        A.SupportsInterpolation0.prototype = {
            toInterpolation$0: function() {
                var t1 = this.span;
                return A.Interpolation$0(A._setArrayType([
                    this.expression
                ], type$.JSArray_Object), A._setArrayType([
                    t1
                ], type$.JSArray_nullable_FileSpan), t1);
            },
            withSpan$1: function(span) {
                return new A.SupportsInterpolation0(this.expression, span);
            },
            toString$0: function(_) {
                return "#{" + this.expression.toString$0(0) + "}";
            },
            $isAstNode0: 1,
            $isSassNode: 1,
            $isSupportsCondition: 1,
            get$span: function(receiver) {
                return this.span;
            }
        };
        A.InterpolationBuffer0.prototype = {
            writeCharCode$1: function(character) {
                var t1 = this._interpolation_buffer0$_text, t2 = A.Primitives_stringFromCharCode(character);
                t1._contents += t2;
                return null;
            },
            add$2: function(_, expression, span) {
                this._interpolation_buffer0$_flushText$0();
                this._interpolation_buffer0$_contents.push(expression);
                this._interpolation_buffer0$_spans.push(span);
            },
            addInterpolation$1: function(interpolation) {
                var spansToAdd, _0_4_isSet, _0_4, first, rest, t2, t3, _this = this, toAdd = interpolation.contents, t1 = toAdd.length;
                if (t1 === 0) return;
                spansToAdd = interpolation.spans;
                _0_4_isSet = t1 >= 1;
                if (_0_4_isSet) {
                    _0_4 = toAdd[0];
                    t1 = typeof _0_4 == "string";
                } else {
                    _0_4 = null;
                    t1 = false;
                }
                if (t1) {
                    first = A._asString(_0_4_isSet ? _0_4 : toAdd[0]);
                    rest = B.JSArray_methods.sublist$1(toAdd, 1);
                    t1 = _this._interpolation_buffer0$_text;
                    t1._contents += first;
                    spansToAdd = A.SubListIterable$(spansToAdd, 1, null, A._arrayInstanceType(spansToAdd)._precomputed1);
                    toAdd = rest;
                }
                _this._interpolation_buffer0$_flushText$0();
                t1 = _this._interpolation_buffer0$_contents;
                B.JSArray_methods.addAll$1(t1, toAdd);
                t2 = _this._interpolation_buffer0$_spans;
                B.JSArray_methods.addAll$1(t2, spansToAdd);
                if (typeof B.JSArray_methods.get$last(t1) == "string") {
                    t3 = _this._interpolation_buffer0$_text;
                    t1 = A.S(t1.pop());
                    t3._contents += t1;
                    t2.pop();
                }
            },
            _interpolation_buffer0$_flushText$0: function() {
                var t1 = this._interpolation_buffer0$_text, t2 = t1._contents;
                if (t2.length === 0) return;
                this._interpolation_buffer0$_contents.push(t2.charCodeAt(0) == 0 ? t2 : t2);
                this._interpolation_buffer0$_spans.push(null);
                t1._contents = "";
            },
            interpolation$1: function(span) {
                var t1 = A.List_List$_of(this._interpolation_buffer0$_contents, type$.Object), t2 = this._interpolation_buffer0$_text, t3 = t2._contents;
                if (t3.length !== 0) t1.push(t3.charCodeAt(0) == 0 ? t3 : t3);
                t3 = A.List_List$_of(this._interpolation_buffer0$_spans, type$.nullable_FileSpan);
                if (t2._contents.length !== 0) t3.push(null);
                return A.Interpolation$0(t1, t3, span);
            },
            toString$0: function(_) {
                var t1, t2, _i, t3, element;
                for(t1 = this._interpolation_buffer0$_contents, t2 = t1.length, _i = 0, t3 = ""; _i < t1.length; t1.length === t2 || (0, A.throwConcurrentModificationError)(t1), ++_i){
                    element = t1[_i];
                    t3 = typeof element == "string" ? t3 + element : t3 + "#{" + A.S(element) + A.Primitives_stringFromCharCode(125);
                }
                t1 = t3 + this._interpolation_buffer0$_text.toString$0(0);
                return t1.charCodeAt(0) == 0 ? t1 : t1;
            }
        };
        A.InterpolationMap0.prototype = {
            mapException$1: function(error) {
                var source, startIndex, endIndex, t3, t4, _this = this, target = error.get$span(error), t1 = _this._interpolation_map$_interpolation, t2 = t1.contents;
                if (t2.length === 0) {
                    if (_this._interpolation_map$_isMapped$1(target)) return error;
                    return new A.SourceSpanFormatException(error.get$source(), error._span_exception$_message, t1.span);
                }
                source = _this.mapSpan$1(target);
                if (source === target) return error;
                startIndex = _this._interpolation_map$_indexInContents$1(target.get$start(target));
                endIndex = _this._interpolation_map$_indexInContents$1(target.get$end(target));
                t1 = error._span_exception$_message;
                if (!A.SubListIterable$(t2, startIndex, null, A._arrayInstanceType(t2)._precomputed1).take$1(0, endIndex - startIndex + 1).any$1(0, new A.InterpolationMap_mapException_closure0())) return new A.SourceSpanFormatException(error.get$source(), t1, source);
                else {
                    t2 = type$.SourceSpan;
                    t3 = type$.String;
                    t4 = A.LinkedHashMap_LinkedHashMap$_literal([
                        target,
                        "error in interpolated output"
                    ], t2, t3);
                    return new A.MultiSourceSpanFormatException(error.get$source(), "", A.ConstantMap_ConstantMap$from(t4, t2, t3), t1, source);
                }
            },
            mapSpan$1: function(target) {
                var _0_1, _0_2, t1, _0_2_isSet, t2, start, _0_20, end, _this = this, _null = null;
                if (_this._interpolation_map$_isMapped$1(target)) return target;
                _0_1 = _this._interpolation_map$_mapLocation$1(target.get$start(target));
                _0_2 = _this._interpolation_map$_mapLocation$1(target.get$end(target));
                $label0$0: {
                    t1 = type$.FileSpan;
                    _0_2_isSet = t1._is(_0_1);
                    t2 = false;
                    if (_0_2_isSet) {
                        t2 = t1._is(_0_2);
                        start = _0_1;
                        _0_20 = _0_2;
                    } else {
                        start = _null;
                        _0_20 = start;
                    }
                    if (t2) {
                        t1 = start.expand$1(0, t1._as(_0_2_isSet ? _0_20 : _0_2));
                        break $label0$0;
                    }
                    t2 = false;
                    if (t1._is(_0_1)) {
                        if (_0_2_isSet) t2 = _0_20;
                        else {
                            t2 = _0_2;
                            _0_20 = t2;
                            _0_2_isSet = true;
                        }
                        t2 = t2 instanceof A.FileLocation;
                        start = _0_1;
                    } else start = _null;
                    if (t2) {
                        t1 = _0_2_isSet ? _0_20 : _0_2;
                        type$.FileLocation._as(t1);
                        t2 = _this._interpolation_map$_interpolation.span;
                        t1 = t2.get$file(t2).span$2(0, _this._interpolation_map$_expandInterpolationSpanLeft$1(start.get$start(start)), t1.offset);
                        break $label0$0;
                    }
                    t2 = false;
                    if (_0_1 instanceof A.FileLocation) {
                        if (_0_2_isSet) t2 = _0_20;
                        else {
                            t2 = _0_2;
                            _0_20 = t2;
                            _0_2_isSet = true;
                        }
                        t2 = t1._is(t2);
                        start = _0_1;
                    } else start = _null;
                    if (t2) {
                        end = t1._as(_0_2_isSet ? _0_20 : _0_2);
                        t1 = _this._interpolation_map$_interpolation.span;
                        t1 = t1.get$file(t1).span$2(0, start.offset, _this._interpolation_map$_expandInterpolationSpanRight$1(end.get$end(end)));
                        break $label0$0;
                    }
                    t1 = false;
                    if (_0_1 instanceof A.FileLocation) {
                        if (_0_2_isSet) t1 = _0_20;
                        else {
                            t1 = _0_2;
                            _0_20 = t1;
                            _0_2_isSet = true;
                        }
                        t1 = t1 instanceof A.FileLocation;
                        start = _0_1;
                    } else start = _null;
                    if (t1) {
                        t1 = _0_2_isSet ? _0_20 : _0_2;
                        type$.FileLocation._as(t1);
                        t2 = _this._interpolation_map$_interpolation.span;
                        t1 = t2.get$file(t2).span$2(0, start.offset, t1.offset);
                        break $label0$0;
                    }
                    t1 = A.throwExpression("[BUG] Unreachable");
                }
                return t1;
            },
            _interpolation_map$_isMapped$1: function(span) {
                var file, t1;
                $label0$0: {
                    file = span.get$file(span);
                    t1 = this._interpolation_map$_interpolation.span;
                    t1 = t1.get$file(t1);
                    break $label0$0;
                }
                return file === t1;
            },
            _interpolation_map$_mapLocation$1: function(target) {
                var index, _0_0, t3, previousLocation, _this = this, t1 = _this._interpolation_map$_interpolation, t2 = t1.contents;
                if (t2.length === 0) return t1.span;
                index = _this._interpolation_map$_indexInContents$1(target);
                _0_0 = t2[index];
                if (_0_0 instanceof A.Expression0) return _0_0.get$span(_0_0);
                t3 = index === 0;
                t1 = t1.span;
                if (t3) previousLocation = t1.get$start(t1);
                else {
                    t1 = t1.get$file(t1);
                    t2 = type$.Expression_2._as(t2[index - 1]);
                    t2 = t2.get$span(t2);
                    previousLocation = A.FileLocation$_(t1, _this._interpolation_map$_expandInterpolationSpanRight$1(t2.get$end(t2)));
                }
                t1 = t3 ? 0 : _this._interpolation_map$_targetOffsets[index - 1];
                return A.FileLocation$_(previousLocation.file, previousLocation.offset + (target.offset - t1));
            },
            _interpolation_map$_indexInContents$1: function(target) {
                var t1, t2, t3, i;
                for(t1 = this._interpolation_map$_targetOffsets, t2 = t1.length, t3 = target.offset, i = 0; i < t2; ++i)if (t3 < t1[i]) return i;
                return this._interpolation_map$_interpolation.contents.length - 1;
            },
            _interpolation_map$_expandInterpolationSpanLeft$1: function(start) {
                var i0, prev, char, source = start.file._decodedChars, i = start.offset - 1;
                while(i >= 0){
                    i0 = i - 1;
                    prev = source[i];
                    if (prev === 123) {
                        if (source[i0] === 35) {
                            i = i0;
                            break;
                        }
                        i = i0;
                    } else if (prev === 47) {
                        i = i0 - 1;
                        if (source[i0] === 42) for(;;){
                            i0 = i - 1;
                            if (source[i] !== 42) {
                                i = i0;
                                continue;
                            }
                            i = i0;
                            do {
                                i0 = i - 1;
                                char = source[i];
                                if (char === 42) {
                                    i = i0;
                                    continue;
                                } else break;
                            }while (true);
                            if (char === 47) {
                                i = i0;
                                break;
                            }
                            i = i0;
                        }
                    } else i = i0;
                }
                return i;
            },
            _interpolation_map$_expandInterpolationSpanRight$1: function(end) {
                var t1, i0, next, second, t2, char, source = end.file._decodedChars, i = end.offset;
                for(t1 = source.length; i < t1;){
                    i0 = i + 1;
                    next = source[i];
                    if (next === 125) {
                        i = i0;
                        break;
                    }
                    if (next === 47) {
                        i = i0 + 1;
                        second = source[i0];
                        if (second === 47) {
                            for(;;){
                                i0 = i + 1;
                                t2 = source[i];
                                if (!!(t2 === 10 || t2 === 13 || t2 === 12)) break;
                                i = i0;
                            }
                            i = i0;
                        } else if (second === 42) for(;;){
                            i0 = i + 1;
                            if (source[i] !== 42) {
                                i = i0;
                                continue;
                            }
                            i = i0;
                            do {
                                i0 = i + 1;
                                char = source[i];
                                if (char === 42) {
                                    i = i0;
                                    continue;
                                } else break;
                            }while (true);
                            if (char === 47) {
                                i = i0;
                                break;
                            }
                            i = i0;
                        }
                    } else i = i0;
                }
                return i;
            }
        };
        A.InterpolationMap_mapException_closure0.prototype = {
            call$1: function($content) {
                return $content instanceof A.Expression0;
            },
            $signature: 73
        };
        A.InterpolationMethod0.prototype = {
            toString$0: function(_) {
                var t1 = this.hue;
                t1 = t1 == null ? "" : " " + t1.toString$0(0) + " hue";
                return this.space.name + t1;
            }
        };
        A.HueInterpolationMethod0.prototype = {
            _enumToString$0: function() {
                return "HueInterpolationMethod." + this._name;
            }
        };
        A._realCasePath_helper0.prototype = {
            call$2: function(path, realPath) {
                var dirname = $.$get$context().dirname$1(path);
                if (dirname === path) return path;
                return $._realCaseCache0.putIfAbsent$2(path, new A._realCasePath_helper_closure0(path, realPath, this, dirname));
            },
            call$1: function(path) {
                return this.call$2(path, null);
            },
            $signature: 149
        };
        A._realCasePath_helper_closure0.prototype = {
            call$0: function() {
                var realPathNonNull, realDirname, basename, matches, t1, _0_0, match, realPathNonNull0, _$exception, _this = this, t2 = _this.path;
                if (!A.linkExists0(t2)) {
                    realPathNonNull = null;
                    try {
                        realPathNonNull0 = _this.realPath;
                        realPathNonNull = realPathNonNull0 == null ? A.realpath0(t2) : realPathNonNull0;
                    } catch (exception) {
                        if (A.unwrapException(exception) instanceof A.FileSystemException0) return t2;
                        else throw exception;
                    }
                    t1 = realPathNonNull;
                    t2 = $.$get$context();
                    return A.join(_this.helper.call$2(_this.dirname, t2.dirname$1(t1)), A.ParsedPath_ParsedPath$parse(realPathNonNull, t2.style).get$basename(), null);
                }
                realDirname = _this.helper.call$1(_this.dirname);
                basename = A.ParsedPath_ParsedPath$parse(t2, $.$get$context().style).get$basename();
                try {
                    matches = J.where$1$ax(A.listDir0(realDirname), new A._realCasePath_helper__closure0(basename)).toList$0(0);
                    t1 = null;
                    _0_0 = matches;
                    $label0$0: {
                        match = null;
                        if (J.get$length$asx(_0_0) === 1) {
                            match = J.$index$asx(_0_0, 0);
                            t1 = match;
                            break $label0$0;
                        }
                        t1 = A.join(realDirname, basename, null);
                        break $label0$0;
                    }
                    t1;
                    return t1;
                } catch (exception) {
                    if (A.unwrapException(exception) instanceof A.FileSystemException0) return t2;
                    else throw exception;
                }
            },
            $signature: 29
        };
        A._realCasePath_helper__closure0.prototype = {
            call$1: function(realPath) {
                return A.equalsIgnoreCase0(A.ParsedPath_ParsedPath$parse(realPath, $.$get$context().style).get$basename(), this.basename);
            },
            $signature: 4
        };
        A.IsCalculationSafeVisitor0.prototype = {
            visitBinaryOperationExpression$1: function(_, node) {
                return B.Set_xkEMv0.contains$1(0, node.operator) && node.left.accept$1(this) && node.right.accept$1(this);
            },
            visitBooleanExpression$1: function(_, node) {
                return false;
            },
            visitColorExpression$1: function(_, node) {
                return false;
            },
            visitFunctionExpression$1: function(_, node) {
                return true;
            },
            visitIfExpression$1: function(_, node) {
                return true;
            },
            visitInterpolatedFunctionExpression$1: function(_, node) {
                return true;
            },
            visitLegacyIfExpression$1: function(_, node) {
                return true;
            },
            visitListExpression$1: function(_, node) {
                var t1 = false;
                if (node.separator === B.ListSeparator_SrV0) {
                    if (!node.hasBrackets) {
                        t1 = node.contents;
                        t1 = t1.length > 1 && B.JSArray_methods.every$1(t1, new A.IsCalculationSafeVisitor_visitListExpression_closure0(this));
                    }
                }
                return t1;
            },
            visitMapExpression$1: function(_, node) {
                return false;
            },
            visitNullExpression$1: function(_, node) {
                return false;
            },
            visitNumberExpression$1: function(_, node) {
                return true;
            },
            visitParenthesizedExpression$1: function(_, node) {
                return node.expression.accept$1(this);
            },
            visitSelectorExpression$1: function(_, node) {
                return false;
            },
            visitStringExpression$1: function(_, node) {
                var text, t1, t2;
                if (node.hasQuotes) return false;
                text = node.text.get$initialPlain();
                t1 = false;
                if (!B.JSString_methods.startsWith$1(text, "!")) {
                    if (!B.JSString_methods.startsWith$1(text, "#")) {
                        t2 = text.length;
                        if ((1 >= t2 ? null : text.charCodeAt(1)) !== 43) t1 = (3 >= t2 ? null : text.charCodeAt(3)) !== 40;
                    }
                }
                return t1;
            },
            visitSupportsExpression$1: function(_, node) {
                return false;
            },
            visitUnaryOperationExpression$1: function(_, node) {
                return false;
            },
            visitValueExpression$1: function(_, node) {
                return false;
            },
            visitVariableExpression$1: function(_, node) {
                return true;
            },
            $isExpressionVisitor: 1
        };
        A.IsCalculationSafeVisitor_visitListExpression_closure0.prototype = {
            call$1: function(expression) {
                return expression.accept$1(this.$this);
            },
            $signature: 81
        };
        A.IsPlainCssVisitor0.prototype = {
            visitBinaryOperationExpression$1: function(_, node) {
                return false;
            },
            visitBooleanExpression$1: function(_, node) {
                return false;
            },
            visitColorExpression$1: function(_, node) {
                return true;
            },
            visitFunctionExpression$1: function(_, node) {
                return node.namespace == null && this._is_plain_css$_visitArgumentList$1(node.$arguments);
            },
            visitIfExpression$1: function(_, node) {
                return B.JSArray_methods.every$1(node.branches, new A.IsPlainCssVisitor_visitIfExpression_closure0(this));
            },
            visitInterpolatedFunctionExpression$1: function(_, node) {
                var t1 = this._is_plain_css$_visitArgumentList$1(node.$arguments);
                return t1;
            },
            visitLegacyIfExpression$1: function(_, node) {
                return false;
            },
            visitListExpression$1: function(_, node) {
                var t1 = node.contents;
                return (t1.length !== 0 || node.hasBrackets) && B.JSArray_methods.every$1(t1, new A.IsPlainCssVisitor_visitListExpression_closure0(this));
            },
            visitMapExpression$1: function(_, node) {
                return false;
            },
            visitNullExpression$1: function(_, node) {
                return false;
            },
            visitNumberExpression$1: function(_, node) {
                return true;
            },
            visitParenthesizedExpression$1: function(_, node) {
                return node.expression.accept$1(this);
            },
            visitSelectorExpression$1: function(_, node) {
                return false;
            },
            visitStringExpression$1: function(_, node) {
                return true;
            },
            visitSupportsExpression$1: function(_, node) {
                return false;
            },
            visitUnaryOperationExpression$1: function(_, node) {
                return false;
            },
            visitValueExpression$1: function(_, node) {
                return false;
            },
            visitVariableExpression$1: function(_, node) {
                return false;
            },
            visitIfConditionParenthesized$1: function(_, node) {
                return node.expression.accept$1(this);
            },
            visitIfConditionNegation$1: function(_, node) {
                return node.expression.accept$1(this);
            },
            visitIfConditionOperation$1: function(_, node) {
                return B.JSArray_methods.every$1(node.expressions, new A.IsPlainCssVisitor_visitIfConditionOperation_closure0(this));
            },
            visitIfConditionFunction$1: function(_, node) {
                return true;
            },
            visitIfConditionSass$1: function(_, node) {
                return false;
            },
            visitIfConditionRaw$1: function(_, node) {
                return true;
            },
            _is_plain_css$_visitArgumentList$1: function(node) {
                var t1 = node.named;
                return t1.get$isEmpty(t1) && node.rest == null && B.JSArray_methods.every$1(node.positional, new A.IsPlainCssVisitor__visitArgumentList_closure0(this));
            },
            $isExpressionVisitor: 1,
            $isIfConditionExpressionVisitor: 1
        };
        A.IsPlainCssVisitor_visitIfExpression_closure0.prototype = {
            call$1: function(pair) {
                var _0_1, condition, t1;
                $label0$0: {
                    _0_1 = pair._0;
                    if (_0_1 != null) {
                        condition = _0_1 == null ? type$.IfConditionExpression_2._as(_0_1) : _0_1;
                        t1 = this.$this;
                        t1 = condition.accept$1(t1) && pair._1.accept$1(t1);
                        break $label0$0;
                    }
                    t1 = pair._1.accept$1(this.$this);
                    break $label0$0;
                }
                return t1;
            },
            $signature: 501
        };
        A.IsPlainCssVisitor_visitListExpression_closure0.prototype = {
            call$1: function(element) {
                return element.accept$1(this.$this);
            },
            $signature: 81
        };
        A.IsPlainCssVisitor_visitIfConditionOperation_closure0.prototype = {
            call$1: function(expression) {
                return expression.accept$1(this.$this);
            },
            $signature: 502
        };
        A.IsPlainCssVisitor__visitArgumentList_closure0.prototype = {
            call$1: function(argument) {
                return argument.accept$1(this.$this);
            },
            $signature: 81
        };
        A.FileSystemException0.prototype = {
            toString$0: function(_) {
                var t1 = $.$get$context();
                return t1.prettyUri$1(t1.toUri$1(this.path)) + ": " + this.message;
            },
            get$message: function(receiver) {
                return this.message;
            }
        };
        A._readFile_closure0.prototype = {
            call$0: function() {
                return J.readFileSync$2$x(A.fs(), this.path, this.encoding);
            },
            $signature: 64
        };
        A.fileExists_closure0.prototype = {
            call$0: function() {
                var error, systemError, _$exception, t1 = this.path;
                if (!J.existsSync$1$x(A.fs(), t1)) return false;
                try {
                    t1 = J.isFile$0$x(J.statSync$1$x(A.fs(), t1));
                    return t1;
                } catch (exception) {
                    error = A.unwrapException(exception);
                    systemError = type$.JsSystemError._as(error);
                    if (J.$eq$(J.get$code$x(systemError), "ENOENT")) return false;
                    throw exception;
                }
            },
            $signature: 20
        };
        A.dirExists_closure0.prototype = {
            call$0: function() {
                var error, systemError, _$exception, t1 = this.path;
                if (!J.existsSync$1$x(A.fs(), t1)) return false;
                try {
                    t1 = J.isDirectory$0$x(J.statSync$1$x(A.fs(), t1));
                    return t1;
                } catch (exception) {
                    error = A.unwrapException(exception);
                    systemError = type$.JsSystemError._as(error);
                    if (J.$eq$(J.get$code$x(systemError), "ENOENT")) return false;
                    throw exception;
                }
            },
            $signature: 20
        };
        A.linkExists_closure0.prototype = {
            call$0: function() {
                var error, systemError, t1, _$exception;
                try {
                    t1 = J.isSymbolicLink$0$x(J.lstatSync$1$x(A.fs(), this.path));
                    return t1;
                } catch (exception) {
                    error = A.unwrapException(exception);
                    systemError = type$.JsSystemError._as(error);
                    if (J.$eq$(J.get$code$x(systemError), "ENOENT")) return false;
                    throw exception;
                }
            },
            $signature: 20
        };
        A.listDir_closure0.prototype = {
            call$0: function() {
                var t1 = this.path;
                if (!this.recursive) return J.map$1$1$ax(J.readdirSync$1$x(A.fs(), t1), new A.listDir__closure1(t1), type$.String).super$Iterable$where(0, new A.listDir__closure2());
                else return new A.listDir_closure_list0().call$1(t1);
            },
            $signature: 152
        };
        A.listDir__closure1.prototype = {
            call$1: function(child) {
                return A.join(this.path, A._asString(child), null);
            },
            $signature: 134
        };
        A.listDir__closure2.prototype = {
            call$1: function(child) {
                return !A.dirExists0(child);
            },
            $signature: 4
        };
        A.listDir_closure_list0.prototype = {
            call$1: function($parent) {
                return J.expand$1$1$ax(J.readdirSync$1$x(A.fs(), $parent), new A.listDir__list_closure0($parent, this), type$.String);
            },
            $signature: 153
        };
        A.listDir__list_closure0.prototype = {
            call$1: function(child) {
                var path = A.join(this.parent, A._asString(child), null);
                return A.dirExists0(path) ? this.list.call$1(path) : A._setArrayType([
                    path
                ], type$.JSArray_String);
            },
            $signature: 154
        };
        A.realpath_closure0.prototype = {
            call$0: function() {
                return J.native$1$x(J.get$realpathSync$x(A.fs()), this.path);
            },
            $signature: 29
        };
        A.main_closure.prototype = {
            call$2: function(_, __) {},
            $signature: 503
        };
        A.main_closure0.prototype = {
            call$2: function(_, __) {},
            $signature: 504
        };
        A.JSToDartLogger.prototype = {
            internalWarn$4$deprecation$span$trace: function(message, deprecation, span, trace) {
                var t2, t3, t4, t1 = this._node, _0_0 = t1 == null ? null : J.get$warn$x(t1);
                if (_0_0 != null) {
                    t1 = span == null ? self.undefined : span;
                    t2 = J.toString$0$(trace);
                    t3 = deprecation == null;
                    t4 = $.$get$deprecations();
                    _0_0.call$2(message, {
                        deprecation: !t3,
                        deprecationType: t4.$index(0, t3 ? null : deprecation.id),
                        span: t1,
                        stack: t2
                    });
                } else this._withAscii$1(new A.JSToDartLogger_internalWarn_closure(this, message, span, trace, deprecation));
            },
            debug$2: function(_, message, span) {
                var t1 = this._node, _0_0 = t1 == null ? null : J.get$debug$x(t1);
                if (_0_0 != null) _0_0.call$2(message, {
                    span: span
                });
                else this._withAscii$1(new A.JSToDartLogger_debug_closure(this, message, span));
            },
            _withAscii$1$1: function(callback) {
                var t1, wasAscii = $._glyphs === B.C_AsciiGlyphSet;
                $._glyphs = this._ascii ? B.C_AsciiGlyphSet : B.C_UnicodeGlyphSet;
                try {
                    t1 = callback.call$0();
                    return t1;
                } finally{
                    $._glyphs = wasAscii ? B.C_AsciiGlyphSet : B.C_UnicodeGlyphSet;
                }
            },
            _withAscii$1: function(callback) {
                return this._withAscii$1$1(callback, type$.dynamic);
            }
        };
        A.JSToDartLogger_internalWarn_closure.prototype = {
            call$0: function() {
                var _this = this;
                $label0$0: {
                    _this.$this._fallback.internalWarn$4$deprecation$span$trace(_this.message, _this.deprecation, _this.span, _this.trace);
                    break $label0$0;
                }
            },
            $signature: 1
        };
        A.JSToDartLogger_debug_closure.prototype = {
            call$0: function() {
                return this.$this._fallback.debug$2(0, this.message, this.span);
            },
            $signature: 0
        };
        A.ModifiableCssKeyframeBlock0.prototype = {
            accept$1$1: function(visitor) {
                return visitor.visitCssKeyframeBlock$1(this);
            },
            accept$1: function(visitor) {
                return this.accept$1$1(visitor, type$.dynamic);
            },
            equalsIgnoringChildren$1: function(other) {
                return other instanceof A.ModifiableCssKeyframeBlock0 && B.C_ListEquality.equals$2(0, this.selector.value, other.selector.value);
            },
            copyWithoutChildren$0: function() {
                return A.ModifiableCssKeyframeBlock$0(this.selector, this.span);
            },
            get$span: function(receiver) {
                return this.span;
            }
        };
        A.KeyframeSelectorParser0.prototype = {
            parse$0: function(_) {
                return this.wrapSpanFormatException$1(new A.KeyframeSelectorParser_parse_closure0(this));
            },
            _keyframe_selector$_percentage$0: function() {
                var $self, _0_0, t1 = this.scanner, t2 = t1.scanChar$1(43) ? A.Primitives_stringFromCharCode(43) : "", second = t1.peekChar$0();
                if (!(second != null && second >= 48 && second <= 57) && second !== 46) t1.error$1(0, "Expected number.");
                for(;;){
                    $self = t1.peekChar$0();
                    if (!($self != null && $self >= 48 && $self <= 57)) break;
                    t2 += A.Primitives_stringFromCharCode(t1.readChar$0());
                }
                if (t1.peekChar$0() === 46) {
                    t2 += A.Primitives_stringFromCharCode(t1.readChar$0());
                    for(;;){
                        $self = t1.peekChar$0();
                        if (!($self != null && $self >= 48 && $self <= 57)) break;
                        t2 += A.Primitives_stringFromCharCode(t1.readChar$0());
                    }
                }
                if (this.scanIdentChar$1(101)) {
                    t2 += A.Primitives_stringFromCharCode(101);
                    _0_0 = t1.peekChar$0();
                    if (43 === _0_0 || 45 === _0_0) t2 += A.Primitives_stringFromCharCode(t1.readChar$0());
                    $self = t1.peekChar$0();
                    if (!($self != null && $self >= 48 && $self <= 57)) t1.error$1(0, "Expected digit.");
                    do {
                        t2 += A.Primitives_stringFromCharCode(t1.readChar$0());
                        $self = t1.peekChar$0();
                    }while ($self != null && $self >= 48 && $self <= 57);
                }
                t1.expectChar$1(37);
                t2 += A.Primitives_stringFromCharCode(37);
                return t2.charCodeAt(0) == 0 ? t2 : t2;
            }
        };
        A.KeyframeSelectorParser_parse_closure0.prototype = {
            call$0: function() {
                var selectors = A._setArrayType([], type$.JSArray_String), t1 = this.$this, t2 = t1.scanner;
                do {
                    t1.whitespace$1$consumeNewlines(true);
                    if (t1.lookingAtIdentifier$0()) {
                        if (t1.scanIdentifier$1("from")) selectors.push("from");
                        else {
                            t1.expectIdentifier$2$name("to", '"to" or "from"');
                            selectors.push("to");
                        }
                    } else selectors.push(t1._keyframe_selector$_percentage$0());
                    t1.whitespace$1$consumeNewlines(true);
                }while (t2.scanChar$1(44));
                t2.expectDone$0();
                return selectors;
            },
            $signature: 139
        };
        A.LabColorSpace0.prototype = {
            get$isBoundedInternal: function() {
                return false;
            },
            convert$7$missingChroma$missingHue: function(dest, lightness, a, b, alpha, missingChroma, missingHue) {
                var powerlessAB, t1, missingLightness, f1, t2, t3, t4;
                switch(dest){
                    case B.LabColorSpace_2nT0:
                        powerlessAB = lightness == null || A.fuzzyEquals0(lightness, 0);
                        t1 = a == null || powerlessAB ? null : a;
                        return A.SassColor$_forSpace0(B.LabColorSpace_2nT0, lightness, t1, b == null || powerlessAB ? null : b, alpha, null);
                    case B.LchColorSpace_Bpv0:
                        return A.labToLch0(dest, lightness, a, b, alpha, false, false);
                    default:
                        missingLightness = lightness == null;
                        if (missingLightness) lightness = 0;
                        f1 = (lightness + 16) / 116;
                        t1 = a == null;
                        t2 = this._lab$_convertFToXorZ$1((t1 ? 0 : a) / 500 + f1);
                        t3 = lightness > 8 ? Math.pow(f1, 3) : lightness / 903.2962962962963;
                        t4 = b == null;
                        return B.XyzD50ColorSpace_2OB0.convert$10$missingA$missingB$missingChroma$missingHue$missingLightness(dest, t2 * 0.9642956764295677, t3, this._lab$_convertFToXorZ$1(f1 - (t4 ? 0 : b) / 200) * 0.8251046025104602, alpha, t1, t4, missingChroma, missingHue, missingLightness);
                }
            },
            convert$5: function(dest, lightness, a, b, alpha) {
                return this.convert$7$missingChroma$missingHue(dest, lightness, a, b, alpha, false, false);
            },
            _lab$_convertFToXorZ$1: function(component) {
                var cubed = Math.pow(component, 3) + 0;
                return cubed > 0.008856451679035631 ? cubed : (116 * component - 16) / 903.2962962962963;
            }
        };
        A.LazyFileSpan0.prototype = {
            get$span: function(_) {
                var t1 = this._lazy_file_span0$_span;
                return t1 == null ? this._lazy_file_span0$_span = this._lazy_file_span0$_builder.call$0() : t1;
            },
            compareTo$1: function(_, other) {
                return this.get$span(0).compareTo$1(0, other);
            },
            get$context: function(_) {
                var t1 = this.get$span(0);
                return t1.get$context(t1);
            },
            get$end: function(_) {
                var t1 = this.get$span(0);
                return t1.get$end(t1);
            },
            expand$1: function(_, other) {
                return this.get$span(0).expand$1(0, other);
            },
            get$file: function(_) {
                var t1 = this.get$span(0);
                return t1.get$file(t1);
            },
            highlight$1$color: function(color) {
                return this.get$span(0).highlight$1$color(color);
            },
            get$length: function(_) {
                var t1 = this.get$span(0);
                return t1.get$length(t1);
            },
            message$2$color: function(_, message, color) {
                return this.get$span(0).message$2$color(0, message, color);
            },
            message$1: function(_, message) {
                return this.message$2$color(0, message, null);
            },
            get$sourceUrl: function(_) {
                var t1 = this.get$span(0);
                return t1.get$sourceUrl(t1);
            },
            get$start: function(_) {
                var t1 = this.get$span(0);
                return t1.get$start(t1);
            },
            get$text: function() {
                return this.get$span(0).get$text();
            },
            $isComparable: 1,
            $isFileSpan: 1,
            $isSourceSpan: 1,
            $isSourceSpanWithContext: 1
        };
        A.LchColorSpace0.prototype = {
            get$isBoundedInternal: function() {
                return false;
            },
            get$isPolarInternal: function() {
                return true;
            },
            convert$5: function(dest, lightness, chroma, hue, alpha) {
                var t1 = hue == null, hueRadians = (t1 ? 0 : hue) * 3.141592653589793 / 180, t2 = chroma == null, t3 = t2 ? 0 : chroma, t4 = Math.cos(hueRadians), t5 = t2 ? 0 : chroma;
                return B.LabColorSpace_2nT0.convert$7$missingChroma$missingHue(dest, lightness, t3 * t4, t5 * Math.sin(hueRadians), alpha, t2, t1);
            }
        };
        A.render_closure.prototype = {
            call$0: function() {
                var error, _$exception;
                try {
                    this.callback.call$2(null, A.renderSync(this.options));
                } catch (exception) {
                    error = A.unwrapException(exception);
                    this.callback.call$2(error, null);
                }
                return null;
            },
            $signature: 1
        };
        A.render_closure0.prototype = {
            call$1: function(result) {
                this.callback.call$2(null, result);
            },
            $signature: 505
        };
        A.render_closure1.prototype = {
            call$2: function(error, stackTrace) {
                var t2, t3, _null = null, t1 = this.callback;
                if (error instanceof A.SassException0) t1.call$2(A._wrapException(error, stackTrace), _null);
                else {
                    t2 = J.toString$0$(error);
                    t3 = A.getTrace0(error);
                    t1.call$2(A._newRenderError(t2, t3 == null ? stackTrace : t3, _null, _null, _null, 3), _null);
                }
            },
            $signature: 51
        };
        A._parseFunctions_closure.prototype = {
            call$2: function(signature, callback) {
                var _0_0, _this = this, t1 = _this.options, context = {
                    options: A._contextOptions(t1, _this.start)
                };
                J.set$context$x(J.get$options$x(context), context);
                _0_0 = J.get$fiber$x(t1);
                t1 = {};
                t1.fiber = null;
                if (_0_0 != null) {
                    t1.fiber = _0_0;
                    _this.result.push(A.Callable_Callable$fromSignature(B.JSString_methods.trimLeft$0(signature), new A._parseFunctions__closure(t1, callback, context), false));
                } else {
                    t1 = _this.result;
                    if (!_this.asynch) t1.push(A.Callable_Callable$fromSignature(B.JSString_methods.trimLeft$0(signature), new A._parseFunctions__closure0(callback, context), false));
                    else t1.push(A.AsyncCallable_AsyncCallable$fromSignature(B.JSString_methods.trimLeft$0(signature), new A._parseFunctions__closure1(callback, context), false));
                }
            },
            $signature: 126
        };
        A._parseFunctions__closure.prototype = {
            call$1: function($arguments) {
                var result, t1 = this._box_0, currentFiber = J.get$current$x(t1.fiber), t2 = type$.Object;
                t2 = A.List_List$_of(J.map$1$1$ax($arguments, A.value0__wrapValue$closure(), t2), t2);
                t2.push(A.allowInterop(new A._parseFunctions___closure2(currentFiber)));
                result = A.wrapJSExceptions(new A._parseFunctions___closure3(this.callback, this.context, t2));
                return A.unwrapValue(A._asBool($.$get$_isUndefined().call$1(result)) ? A.runZoned(new A._parseFunctions___closure4(t1), null, type$.nullable_Object) : result);
            },
            $signature: 3
        };
        A._parseFunctions___closure2.prototype = {
            call$1: function(result) {
                A.scheduleMicrotask(new A._parseFunctions____closure(this.currentFiber, result));
            },
            call$0: function() {
                return this.call$1(null);
            },
            "call*": "call$1",
            $requiredArgCount: 0,
            $defaultValues: function() {
                return [
                    null
                ];
            },
            $signature: 84
        };
        A._parseFunctions____closure.prototype = {
            call$0: function() {
                return J.run$1$x(this.currentFiber, this.result);
            },
            $signature: 0
        };
        A._parseFunctions___closure3.prototype = {
            call$0: function() {
                return J.apply$2$x(type$.JSFunction._as(this.callback), this.context, this.jsArguments);
            },
            $signature: 36
        };
        A._parseFunctions___closure4.prototype = {
            call$0: function() {
                return J.yield$0$x(this._box_0.fiber);
            },
            $signature: 83
        };
        A._parseFunctions__closure0.prototype = {
            call$1: function($arguments) {
                return A.unwrapValue(A.wrapJSExceptions(new A._parseFunctions___closure1(this.callback, this.context, $arguments)));
            },
            $signature: 3
        };
        A._parseFunctions___closure1.prototype = {
            call$0: function() {
                var t1 = type$.JSFunction._as(this.callback), t2 = J.map$1$1$ax(this.$arguments, A.value0__wrapValue$closure(), type$.Object);
                t2 = A.List_List$_of(t2, t2.$ti._eval$1("ListIterable.E"));
                return J.apply$2$x(t1, this.context, t2);
            },
            $signature: 36
        };
        A._parseFunctions__closure1.prototype = {
            call$1: function($arguments) {
                return this.$call$body$_parseFunctions__closure($arguments);
            },
            $call$body$_parseFunctions__closure: function($arguments) {
                var $async$goto = 0, $async$completer = A._makeAsyncAwaitCompleter(type$.Value_2), $async$returnValue, $async$self = this, result, t1, t2, $async$temp1;
                var $async$call$1 = A._wrapJsFunctionForAsync(function($async$errorCode, $async$result) {
                    if ($async$errorCode === 1) return A._asyncRethrow($async$result, $async$completer);
                    for(;;)switch($async$goto){
                        case 0:
                            // Function start
                            t1 = new A._Future($.Zone__current, type$._Future_nullable_Object);
                            t2 = type$.Object;
                            t2 = A.List_List$_of(J.map$1$1$ax($arguments, A.value0__wrapValue$closure(), t2), t2);
                            t2.push(A.allowInterop(new A._parseFunctions___closure(new A._AsyncCompleter(t1, type$._AsyncCompleter_nullable_Object))));
                            result = A.wrapJSExceptions(new A._parseFunctions___closure0($async$self.callback, $async$self.context, t2));
                            $async$temp1 = A;
                            $async$goto = A._asBool($.$get$_isUndefined().call$1(result)) ? 3 : 5;
                            break;
                        case 3:
                            // then
                            $async$goto = 6;
                            return A._asyncAwait(t1, $async$call$1);
                        case 6:
                            // returning from await.
                            // goto join
                            $async$goto = 4;
                            break;
                        case 5:
                            // else
                            $async$result = result;
                        case 4:
                            // join
                            $async$returnValue = $async$temp1.unwrapValue($async$result);
                            // goto return
                            $async$goto = 1;
                            break;
                        case 1:
                            // return
                            return A._asyncReturn($async$returnValue, $async$completer);
                    }
                });
                return A._asyncStartSync($async$call$1, $async$completer);
            },
            $signature: 92
        };
        A._parseFunctions___closure.prototype = {
            call$1: function(result) {
                return this.completer.complete$1(result);
            },
            call$0: function() {
                return this.call$1(null);
            },
            "call*": "call$1",
            $requiredArgCount: 0,
            $defaultValues: function() {
                return [
                    null
                ];
            },
            $signature: 192
        };
        A._parseFunctions___closure0.prototype = {
            call$0: function() {
                return J.apply$2$x(type$.JSFunction._as(this.callback), this.context, this.jsArguments);
            },
            $signature: 36
        };
        A._parseImporter_closure.prototype = {
            call$1: function(importer) {
                return type$.JSFunction._as(A.allowInteropCaptureThis(new A._parseImporter__closure(this._box_0, importer)));
            },
            $signature: 506
        };
        A._parseImporter__closure.prototype = {
            call$4: function(thisArg, url, previous, _) {
                var t1 = this._box_0, result = J.apply$2$x(this.importer, thisArg, A._setArrayType([
                    url,
                    previous,
                    A.allowInterop(new A._parseImporter___closure(J.get$current$x(t1.fiber)))
                ], type$.JSArray_Object));
                if (A._asBool($.$get$_isUndefined().call$1(result))) return A.runZoned(new A._parseImporter___closure0(t1), null, type$.Object);
                return result;
            },
            call$3: function(thisArg, url, previous) {
                return this.call$4(thisArg, url, previous, null);
            },
            "call*": "call$4",
            $requiredArgCount: 3,
            $defaultValues: function() {
                return [
                    null
                ];
            },
            $signature: 507
        };
        A._parseImporter___closure.prototype = {
            call$1: function(result) {
                A.scheduleMicrotask(new A._parseImporter____closure(this.currentFiber, result));
            },
            $signature: 508
        };
        A._parseImporter____closure.prototype = {
            call$0: function() {
                return J.run$1$x(this.currentFiber, this.result);
            },
            $signature: 0
        };
        A._parseImporter___closure0.prototype = {
            call$0: function() {
                return J.yield$0$x(this._box_0.fiber);
            },
            $signature: 83
        };
        A.LegacyIfExpression0.prototype = {
            get$modernSuggestion: function() {
                var _0_1, ifTrue, ifFalse, t1, condition, _null = null, _0_0 = this.$arguments;
                $label0$0: {
                    _0_1 = _0_0.positional;
                    ifTrue = _null;
                    ifFalse = _null;
                    t1 = false;
                    if (_0_1.length === 3) {
                        condition = _0_1[0];
                        ifTrue = _0_1[1];
                        ifFalse = _0_1[2];
                        t1 = _0_0.named;
                        t1 = t1.get$isEmpty(t1) && _0_0.rest == null;
                    } else condition = _null;
                    if (t1) {
                        if (ifFalse instanceof A.NullExpression0) t1 = "if(sass(" + A.S(condition) + "): " + A.S(ifTrue) + ")";
                        else t1 = ifTrue instanceof A.NullExpression0 ? "if(not sass(" + A.S(condition) + "): " + A.S(ifFalse) + ")" : "if(sass(" + A.S(condition) + "): " + A.S(ifTrue) + "; else: " + A.S(ifFalse) + ")";
                        break $label0$0;
                    }
                    t1 = _null;
                    break $label0$0;
                }
                return t1;
            },
            accept$1$1: function(visitor) {
                return visitor.visitLegacyIfExpression$1(0, this);
            },
            accept$1: function(visitor) {
                return this.accept$1$1(visitor, type$.dynamic);
            },
            toString$0: function(_) {
                return "if" + this.$arguments.toString$0(0);
            },
            get$span: function(receiver) {
                return this.span;
            }
        };
        A.LimitedMapView0.prototype = {
            get$keys: function(_) {
                return this._limited_map_view0$_keys;
            },
            get$length: function(_) {
                return this._limited_map_view0$_keys._collection$_length;
            },
            get$isEmpty: function(_) {
                return this._limited_map_view0$_keys._collection$_length === 0;
            },
            get$isNotEmpty: function(_) {
                return this._limited_map_view0$_keys._collection$_length !== 0;
            },
            $index: function(_, key) {
                return this._limited_map_view0$_keys.contains$1(0, key) ? this._limited_map_view0$_map.$index(0, key) : null;
            },
            containsKey$1: function(key) {
                return this._limited_map_view0$_keys.contains$1(0, key);
            },
            remove$1: function(_, key) {
                return this._limited_map_view0$_keys.contains$1(0, key) ? this._limited_map_view0$_map.remove$1(0, key) : null;
            }
        };
        A.ListExpression0.prototype = {
            accept$1$1: function(visitor) {
                return visitor.visitListExpression$1(0, this);
            },
            accept$1: function(visitor) {
                return this.accept$1$1(visitor, type$.dynamic);
            },
            toString$0: function(_) {
                var t2, t3, t4, t5, _this = this, t1 = _this.hasBrackets;
                if (t1) t2 = A.Primitives_stringFromCharCode(91);
                else {
                    t2 = _this.contents.length;
                    if (t2 !== 0) t2 = t2 === 1 && _this.separator === B.ListSeparator_z0K0;
                    else t2 = true;
                    t2 = t2 ? A.Primitives_stringFromCharCode(40) : "";
                }
                t3 = _this.contents;
                t4 = _this.separator === B.ListSeparator_z0K0;
                t5 = t4 ? ", " : " ";
                t5 = t2 + new A.MappedListIterable(t3, new A.ListExpression_toString_closure0(_this), A._arrayInstanceType(t3)._eval$1("MappedListIterable<1,String>")).join$1(0, t5);
                if (t1) t1 = t5 + A.Primitives_stringFromCharCode(93);
                else {
                    t1 = t3.length;
                    if (t1 === 0) t1 = t5 + A.Primitives_stringFromCharCode(41);
                    else t1 = t1 === 1 && t4 ? t5 + ",)" : t5;
                }
                return t1.charCodeAt(0) == 0 ? t1 : t1;
            },
            _list3$_elementNeedsParens$1: function(expression) {
                var childSeparator, t1, _0_13;
                $label0$0: {
                    if (expression instanceof A.ListExpression0 && expression.contents.length >= 2 && !expression.hasBrackets) {
                        childSeparator = expression.separator;
                        t1 = this.separator === B.ListSeparator_z0K0 ? childSeparator === B.ListSeparator_z0K0 : childSeparator !== B.ListSeparator_undecided_null_3_undecided0;
                        break $label0$0;
                    }
                    if (expression instanceof A.UnaryOperationExpression0) {
                        _0_13 = expression.operator;
                        if (B.UnaryOperator_n2K0 !== _0_13) t1 = B.UnaryOperator_hCO0 === _0_13;
                        else t1 = true;
                    } else t1 = false;
                    if (t1) {
                        t1 = this.separator === B.ListSeparator_SrV0;
                        break $label0$0;
                    }
                    t1 = false;
                    break $label0$0;
                }
                return t1;
            },
            get$span: function(receiver) {
                return this.span;
            }
        };
        A.ListExpression_toString_closure0.prototype = {
            call$1: function(element) {
                return this.$this._list3$_elementNeedsParens$1(element) ? "(" + element.toString$0(0) + ")" : element.toString$0(0);
            },
            $signature: 120
        };
        A._length_closure2.prototype = {
            call$1: function($arguments) {
                return A.SassNumber_SassNumber0(J.$index$asx($arguments, 0).get$asList().length, null);
            },
            $signature: 25
        };
        A._nth_closure0.prototype = {
            call$1: function($arguments) {
                var t1 = J.getInterceptor$asx($arguments), list = t1.$index($arguments, 0), index = t1.$index($arguments, 1);
                return list.get$asList()[list.sassIndexToListIndex$2(index, "n")];
            },
            $signature: 3
        };
        A._setNth_closure0.prototype = {
            call$1: function($arguments) {
                var newList, t1 = J.getInterceptor$asx($arguments), list = t1.$index($arguments, 0), index = t1.$index($arguments, 1), value = t1.$index($arguments, 2);
                t1 = list.get$asList();
                newList = A._setArrayType(t1.slice(0), A._arrayInstanceType(t1));
                newList[list.sassIndexToListIndex$2(index, "n")] = value;
                return list.withListContents$1(newList);
            },
            $signature: 27
        };
        A._join_closure0.prototype = {
            call$1: function($arguments) {
                var _0_1, _0_4, _0_3, t2, _0_40, _0_4_isSet, separator, bracketed, _null = null, t1 = J.getInterceptor$asx($arguments), list1 = t1.$index($arguments, 0), list2 = t1.$index($arguments, 1), separatorParam = t1.$index($arguments, 2).assertString$1("separator"), bracketedParam = t1.$index($arguments, 3), _1_0 = separatorParam._string0$_text;
                $label1$1: {
                    if ("auto" === _1_0) {
                        _0_1 = list1.get$separator(list1);
                        _0_4 = list2.get$separator(list2);
                        $label0$0: {
                            t1 = _null;
                            _0_3 = B.ListSeparator_undecided_null_3_undecided0 === _0_1;
                            t2 = _0_3;
                            if (t2) {
                                t2 = B.ListSeparator_undecided_null_3_undecided0 === _0_4;
                                _0_40 = _0_4;
                                _0_4_isSet = true;
                            } else {
                                _0_40 = _null;
                                _0_4_isSet = false;
                                t2 = false;
                            }
                            if (t2) {
                                t1 = B.ListSeparator_SrV0;
                                break $label0$0;
                            }
                            if (_0_3) {
                                separator = _0_4_isSet ? _0_40 : _0_4;
                                t2 = true;
                            } else {
                                separator = t1;
                                t2 = false;
                            }
                            if (!t2) separator = _0_1;
                            t1 = separator;
                            break $label0$0;
                        }
                        break $label1$1;
                    }
                    if ("space" === _1_0) {
                        t1 = B.ListSeparator_SrV0;
                        break $label1$1;
                    }
                    if ("comma" === _1_0) {
                        t1 = B.ListSeparator_z0K0;
                        break $label1$1;
                    }
                    if ("slash" === _1_0) {
                        t1 = B.ListSeparator_Lul0;
                        break $label1$1;
                    }
                    t1 = A.throwExpression(A.SassScriptException$0(string$.x24separ, _null));
                }
                bracketed = bracketedParam instanceof A.SassString0 && bracketedParam._string0$_text === "auto" ? list1.get$hasBrackets() : bracketedParam.get$isTruthy();
                t2 = A.List_List$_of(list1.get$asList(), type$.Value_2);
                B.JSArray_methods.addAll$1(t2, list2.get$asList());
                return A.SassList$0(t2, t1, bracketed);
            },
            $signature: 27
        };
        A._append_closure2.prototype = {
            call$1: function($arguments) {
                var t2, t1 = J.getInterceptor$asx($arguments), list = t1.$index($arguments, 0), value = t1.$index($arguments, 1), _0_0 = t1.$index($arguments, 2).assertString$1("separator")._string0$_text;
                $label0$0: {
                    if ("auto" === _0_0) {
                        t1 = list.get$separator(list) === B.ListSeparator_undecided_null_3_undecided0 ? B.ListSeparator_SrV0 : list.get$separator(list);
                        break $label0$0;
                    }
                    if ("space" === _0_0) {
                        t1 = B.ListSeparator_SrV0;
                        break $label0$0;
                    }
                    if ("comma" === _0_0) {
                        t1 = B.ListSeparator_z0K0;
                        break $label0$0;
                    }
                    if ("slash" === _0_0) {
                        t1 = B.ListSeparator_Lul0;
                        break $label0$0;
                    }
                    t1 = A.throwExpression(A.SassScriptException$0(string$.x24separ, null));
                }
                t2 = A.List_List$_of(list.get$asList(), type$.Value_2);
                t2.push(value);
                return list.withListContents$2$separator(t2, t1);
            },
            $signature: 27
        };
        A._zip_closure0.prototype = {
            call$1: function($arguments) {
                var results, result, _box_0 = {}, t1 = J.$index$asx($arguments, 0).get$asList(), t2 = A._arrayInstanceType(t1)._eval$1("MappedListIterable<1,List<Value0>>"), lists = A.List_List$_of(new A.MappedListIterable(t1, new A._zip__closure2(), t2), t2._eval$1("ListIterable.E"));
                if (lists.length === 0) return B.SassList_oH00;
                _box_0.i = 0;
                results = A._setArrayType([], type$.JSArray_SassList_2);
                for(t1 = A._arrayInstanceType(lists)._eval$1("MappedListIterable<1,Value0>"), t2 = type$.Value_2; B.JSArray_methods.every$1(lists, new A._zip__closure3(_box_0));){
                    result = A.List_List$from(new A.MappedListIterable(lists, new A._zip__closure4(_box_0), t1), false, t2);
                    result.$flags = 3;
                    results.push(new A.SassList0(result, B.ListSeparator_SrV0, false));
                    ++_box_0.i;
                }
                return A.SassList$0(results, B.ListSeparator_z0K0, false);
            },
            $signature: 27
        };
        A._zip__closure2.prototype = {
            call$1: function(list) {
                return list.get$asList();
            },
            $signature: 510
        };
        A._zip__closure3.prototype = {
            call$1: function(list) {
                return this._box_0.i !== J.get$length$asx(list);
            },
            $signature: 603
        };
        A._zip__closure4.prototype = {
            call$1: function(list) {
                return J.$index$asx(list, this._box_0.i);
            },
            $signature: 3
        };
        A._index_closure2.prototype = {
            call$1: function($arguments) {
                var t1 = J.getInterceptor$asx($arguments), index = B.JSArray_methods.indexOf$1(t1.$index($arguments, 0).get$asList(), t1.$index($arguments, 1));
                return index === -1 ? B.C__SassNull0 : A.SassNumber_SassNumber0(index + 1, null);
            },
            $signature: 3
        };
        A._separator_closure0.prototype = {
            call$1: function($arguments) {
                var t1 = J.$index$asx($arguments, 0), _0_0 = t1.get$separator(t1);
                $label0$0: {
                    if (B.ListSeparator_z0K0 === _0_0) {
                        t1 = new A.SassString0("comma", false);
                        break $label0$0;
                    }
                    if (B.ListSeparator_Lul0 === _0_0) {
                        t1 = new A.SassString0("slash", false);
                        break $label0$0;
                    }
                    t1 = new A.SassString0("space", false);
                    break $label0$0;
                }
                return t1;
            },
            $signature: 18
        };
        A._isBracketed_closure0.prototype = {
            call$1: function($arguments) {
                return J.$index$asx($arguments, 0).get$hasBrackets() ? B.SassBoolean_true0 : B.SassBoolean_false0;
            },
            $signature: 13
        };
        A._slash_closure0.prototype = {
            call$1: function($arguments) {
                var list = J.$index$asx($arguments, 0).get$asList();
                if (list.length < 2) throw A.wrapException(A.SassScriptException$0("At least two elements are required.", null));
                return A.SassList$0(list, B.ListSeparator_Lul0, false);
            },
            $signature: 27
        };
        A.InterpolatedSelectorList.prototype = {
            get$span: function(_) {
                var t1 = this.components;
                return t1.length === 1 ? B.JSArray_methods.get$first(t1).span : B.JSArray_methods.get$first(t1).span.expand$1(0, B.JSArray_methods.get$last(t1).span);
            },
            accept$1$1: function(visitor) {
                return visitor.visitSelectorList$1(this);
            },
            accept$1: function(visitor) {
                return this.accept$1$1(visitor, type$.dynamic);
            },
            toString$0: function(_) {
                return B.JSArray_methods.join$1(this.components, ", ");
            }
        };
        A.SelectorList0.prototype = {
            get$asSassList: function() {
                var t1 = this.components;
                return A.SassList$0(new A.MappedListIterable(t1, new A.SelectorList_asSassList_closure0(), A._arrayInstanceType(t1)._eval$1("MappedListIterable<1,Value0>")), B.ListSeparator_z0K0, false);
            },
            accept$1$1: function(visitor) {
                return visitor.visitSelectorList$1(this);
            },
            accept$1: function(visitor) {
                return this.accept$1$1(visitor, type$.dynamic);
            },
            unify$1: function(other) {
                var t3, t4, t5, t6, _i, complex1, t7, _i0, t8, t1 = type$.JSArray_ComplexSelector_2, t2 = A._setArrayType([], t1);
                for(t3 = this.components, t4 = t3.length, t5 = other.components, t6 = t5.length, _i = 0; _i < t4; ++_i){
                    complex1 = t3[_i];
                    for(t7 = complex1.span, _i0 = 0; _i0 < t6; ++_i0){
                        t8 = A.unifyComplex0(A._setArrayType([
                            complex1,
                            t5[_i0]
                        ], t1), t7);
                        if (t8 != null) B.JSArray_methods.addAll$1(t2, t8);
                    }
                }
                return t2.length === 0 ? null : A.SelectorList$0(t2, this.span);
            },
            nestWithin$3$implicitParent$preserveParentSelectors: function($parent, implicitParent, preserveParentSelectors) {
                var _0_0, t1, _this = this;
                if ($parent == null) {
                    if (preserveParentSelectors) return _this;
                    _0_0 = B.C__ParentSelectorVisitor0.visitSelectorList$1(_this);
                    if (_0_0 instanceof A.ParentSelector0) t1 = _0_0.suffix != null;
                    else t1 = false;
                    if (t1) throw A.wrapException(A.SassException$0(string$.A_top_, _0_0.span, null));
                    return _this;
                }
                t1 = _this.components;
                return A.SelectorList$0(A.flattenVertically0(new A.MappedListIterable(t1, new A.SelectorList_nestWithin_closure0(_this, preserveParentSelectors, implicitParent, $parent), A._arrayInstanceType(t1)._eval$1("MappedListIterable<1,Iterable<ComplexSelector0>>")), type$.ComplexSelector_2), _this.span);
            },
            nestWithin$1: function($parent) {
                return this.nestWithin$3$implicitParent$preserveParentSelectors($parent, true, false);
            },
            nestWithin$2$implicitParent: function($parent, implicitParent) {
                return this.nestWithin$3$implicitParent$preserveParentSelectors($parent, implicitParent, false);
            },
            _list2$_nestWithinCompound$2: function(component, $parent) {
                var resolvedSimples, parentSelector, error, stackTrace, t2, resolvedSimples0, _$exception, t1 = component.selector, simples = t1.components, containsSelectorPseudo = J.any$1$ax(simples, new A.SelectorList__nestWithinCompound_closure2());
                if (!containsSelectorPseudo && !(J.get$first$ax(simples) instanceof A.ParentSelector0)) return null;
                if (containsSelectorPseudo) {
                    t2 = simples;
                    resolvedSimples0 = new A.MappedListIterable(t2, new A.SelectorList__nestWithinCompound_closure3($parent), A._arrayInstanceType(t2)._eval$1("MappedListIterable<1,SimpleSelector0>"));
                } else resolvedSimples0 = simples;
                resolvedSimples = resolvedSimples0;
                parentSelector = J.get$first$ax(simples);
                try {
                    if (!(parentSelector instanceof A.ParentSelector0)) {
                        t2 = component.span;
                        t2 = A._setArrayType([
                            A.ComplexSelector$0(B.List_empty17, A._setArrayType([
                                new A.ComplexSelectorComponent0(A.CompoundSelector$0(resolvedSimples, t1.span), A.List_List$unmodifiable(component.combinators, type$.CssValue_Combinator_2), t2)
                            ], type$.JSArray_ComplexSelectorComponent_2), t2, false)
                        ], type$.JSArray_ComplexSelector_2);
                        return t2;
                    } else if (J.get$length$asx(simples) === 1 && parentSelector.suffix == null) {
                        t1 = $parent.withAdditionalCombinators$1(component.combinators);
                        return t1.components;
                    }
                } catch (exception) {
                    t1 = A.unwrapException(exception);
                    if (t1 instanceof A.SassException0) {
                        error = t1;
                        stackTrace = A.getTraceFromException(exception);
                        A.throwWithTrace0(error.withAdditionalSpan$2(parentSelector.span, "parent selector"), error, stackTrace);
                    } else throw exception;
                }
                t1 = $parent.components;
                return new A.MappedListIterable(t1, new A.SelectorList__nestWithinCompound_closure4(parentSelector, resolvedSimples, component), A._arrayInstanceType(t1)._eval$1("MappedListIterable<1,ComplexSelector0>"));
            },
            isSuperselector$1: function(other) {
                return A.listIsSuperselector0(this.components, other.components);
            },
            withAdditionalCombinators$1: function(combinators) {
                var t1;
                if (combinators.length === 0) t1 = this;
                else {
                    t1 = this.components;
                    t1 = A.SelectorList$0(new A.MappedListIterable(t1, new A.SelectorList_withAdditionalCombinators_closure0(combinators), A._arrayInstanceType(t1)._eval$1("MappedListIterable<1,ComplexSelector0>")), this.span);
                }
                return t1;
            },
            get$hashCode: function(_) {
                return B.C_ListEquality0.hash$1(this.components);
            },
            $eq: function(_, other) {
                if (other == null) return false;
                return other instanceof A.SelectorList0 && B.C_ListEquality.equals$2(0, this.components, other.components);
            }
        };
        A.SelectorList_asSassList_closure0.prototype = {
            call$1: function(complex) {
                var t3, t4, _i, component, visitor, t5, t6, t7, _i0, _null = null, t1 = type$.JSArray_Value_2, t2 = A._setArrayType([], t1);
                for(t3 = complex.leadingCombinators, t4 = t3.length, _i = 0; _i < t4; ++_i)t2.push(new A.SassString0(J.toString$0$(t3[_i].value), false));
                for(t3 = complex.components, t4 = t3.length, _i = 0; _i < t4; ++_i){
                    component = t3[_i];
                    visitor = A._SerializeVisitor$0(_null, true, _null, _null, true, false, _null, true);
                    component.selector.accept$1(visitor);
                    t5 = A._setArrayType([
                        new A.SassString0(visitor._serialize0$_buffer.toString$0(0), false)
                    ], t1);
                    for(t6 = component.combinators, t7 = t6.length, _i0 = 0; _i0 < t7; ++_i0)t5.push(new A.SassString0(J.toString$0$(t6[_i0].value), false));
                    B.JSArray_methods.addAll$1(t2, t5);
                }
                return A.SassList$0(t2, B.ListSeparator_SrV0, false);
            },
            $signature: 512
        };
        A.SelectorList_nestWithin_closure0.prototype = {
            call$1: function(complex) {
                var t1, newComplexes, t2, t3, t4, t5, t6, t7, t8, t9, t10, t11, _i, component, resolved, i, t12, t13, t14, _i0, newComplex, t15, t16, _this = this;
                if (_this.preserveParentSelectors || complex.accept$1(B.C__ParentSelectorVisitor0) == null) {
                    if (!_this.implicitParent) return A._setArrayType([
                        complex
                    ], type$.JSArray_ComplexSelector_2);
                    t1 = _this.parent.components;
                    return new A.MappedListIterable(t1, new A.SelectorList_nestWithin__closure1(complex), A._arrayInstanceType(t1)._eval$1("MappedListIterable<1,ComplexSelector0>"));
                }
                t1 = type$.JSArray_ComplexSelector_2;
                newComplexes = A._setArrayType([], t1);
                for(t2 = complex.components, t3 = t2.length, t4 = _this.$this, t5 = _this.parent, t6 = type$.ComplexSelector_2, t7 = complex.leadingCombinators, t8 = t7.length === 0, t9 = complex.span, t10 = type$.ComplexSelectorComponent_2, t11 = type$.JSArray_ComplexSelectorComponent_2, _i = 0; _i < t3; ++_i){
                    component = t2[_i];
                    resolved = t4._list2$_nestWithinCompound$2(component, t5);
                    if (resolved == null) {
                        if (newComplexes.length === 0) newComplexes.push(A.ComplexSelector$0(t7, A._setArrayType([
                            component
                        ], t11), t9, false));
                        else for(i = 0; i < newComplexes.length; ++i){
                            t12 = newComplexes[i];
                            t13 = A.List_List$_of(t12.components, t10);
                            t13.push(component);
                            newComplexes[i] = A.ComplexSelector$0(t12.leadingCombinators, t13, t9, t12.lineBreak);
                        }
                    } else if (newComplexes.length === 0) B.JSArray_methods.addAll$1(newComplexes, t8 ? resolved : J.map$1$1$ax(resolved, new A.SelectorList_nestWithin__closure2(complex), t6));
                    else {
                        t12 = A._setArrayType([], t1);
                        for(t13 = newComplexes.length, t14 = J.getInterceptor$ax(resolved), _i0 = 0; _i0 < newComplexes.length; newComplexes.length === t13 || (0, A.throwConcurrentModificationError)(newComplexes), ++_i0){
                            newComplex = newComplexes[_i0];
                            for(t15 = t14.get$iterator(resolved), t16 = newComplex.span; t15.moveNext$0();)t12.push(newComplex.concatenate$2(t15.get$current(t15), t16));
                        }
                        newComplexes = t12;
                    }
                }
                return newComplexes;
            },
            $signature: 513
        };
        A.SelectorList_nestWithin__closure1.prototype = {
            call$1: function(parentComplex) {
                var t1 = this.complex;
                return parentComplex.concatenate$2(t1, t1.span);
            },
            $signature: 59
        };
        A.SelectorList_nestWithin__closure2.prototype = {
            call$1: function(resolvedComplex) {
                var t1 = resolvedComplex.leadingCombinators, t2 = this.complex, t3 = t2.leadingCombinators;
                if (t1.length === 0) t1 = t3;
                else {
                    t3 = A.List_List$_of(t3, type$.CssValue_Combinator_2);
                    B.JSArray_methods.addAll$1(t3, t1);
                    t1 = t3;
                }
                return A.ComplexSelector$0(t1, resolvedComplex.components, t2.span, resolvedComplex.lineBreak);
            },
            $signature: 59
        };
        A.SelectorList__nestWithinCompound_closure2.prototype = {
            call$1: function(simple) {
                var selector;
                if (!(simple instanceof A.PseudoSelector0)) return false;
                selector = simple.selector;
                return selector != null && selector.accept$1(B.C__ParentSelectorVisitor0) != null;
            },
            $signature: 15
        };
        A.SelectorList__nestWithinCompound_closure3.prototype = {
            call$1: function(simple) {
                var selector, t1, _0_2;
                $label0$0: {
                    selector = null;
                    t1 = false;
                    if (simple instanceof A.PseudoSelector0) {
                        _0_2 = simple.selector;
                        if (_0_2 != null) {
                            selector = _0_2 == null ? type$.SelectorList_2._as(_0_2) : _0_2;
                            t1 = selector.accept$1(B.C__ParentSelectorVisitor0) != null;
                        }
                    }
                    if (t1) {
                        t1 = simple.withSelector$1(selector.nestWithin$2$implicitParent(this.parent, false));
                        break $label0$0;
                    }
                    t1 = simple;
                    break $label0$0;
                }
                return t1;
            },
            $signature: 514
        };
        A.SelectorList__nestWithinCompound_closure4.prototype = {
            call$1: function(complex) {
                var lastComponent, suffix, lastSimples, t1, t2, last, t3, error, stackTrace, t4, t5, _$exception, _this = this;
                try {
                    t4 = complex.components;
                    lastComponent = B.JSArray_methods.get$last(t4);
                    if (lastComponent.combinators.length !== 0) {
                        t1 = A.MultiSpanSassException$0('Selector "' + complex.toString$0(0) + string$.x22x20can_, A.SpanExtensions_trimRight0(lastComponent.span), "outer selector", A.LinkedHashMap_LinkedHashMap$_literal([
                            _this.parentSelector.span,
                            "parent selector"
                        ], type$.FileSpan, type$.String), null);
                        throw A.wrapException(t1);
                    }
                    suffix = _this.parentSelector.suffix;
                    lastSimples = lastComponent.selector.components;
                    t5 = type$.SimpleSelector_2;
                    if (suffix == null) {
                        t2 = A.List_List$_of(lastSimples, t5);
                        t1 = t2;
                        J.addAll$1$ax(t1, J.skip$1$ax(_this.resolvedSimples, 1));
                        t1;
                    } else {
                        t1 = A.List_List$_of(A.IterableExtension_get_exceptLast0(lastSimples), t5);
                        t2 = t1;
                        J.add$1$ax(t2, J.get$last$ax(lastSimples).addSuffix$1(suffix));
                        J.addAll$1$ax(t2, J.skip$1$ax(_this.resolvedSimples, 1));
                        t1 = t2;
                    }
                    t2 = _this.component;
                    last = A.CompoundSelector$0(t1, t2.selector.span);
                    t1 = A.List_List$_of(A.IterableExtension_get_exceptLast0(t4), type$.ComplexSelectorComponent_2);
                    t3 = t1;
                    t1 = t2.span;
                    J.add$1$ax(t3, new A.ComplexSelectorComponent0(last, A.List_List$unmodifiable(t2.combinators, type$.CssValue_Combinator_2), t1));
                    t1 = A.ComplexSelector$0(complex.leadingCombinators, t3, t1, complex.lineBreak);
                    return t1;
                } catch (exception) {
                    t1 = A.unwrapException(exception);
                    if (t1 instanceof A.SassException0) {
                        error = t1;
                        stackTrace = A.getTraceFromException(exception);
                        A.throwWithTrace0(error.withAdditionalSpan$2(_this.parentSelector.span, "parent selector"), error, stackTrace);
                    } else throw exception;
                }
            },
            $signature: 59
        };
        A.SelectorList_withAdditionalCombinators_closure0.prototype = {
            call$1: function(complex) {
                return complex.withAdditionalCombinators$1(this.combinators);
            },
            $signature: 59
        };
        A._ParentSelectorVisitor0.prototype = {
            visitParentSelector$1: function(_, selector) {
                return selector;
            }
        };
        A.__ParentSelectorVisitor_Object_SelectorSearchVisitor0.prototype = {};
        A.listClass_closure.prototype = {
            call$0: function() {
                var t1 = type$.JSClass, jsClass = t1._as(A.allowInteropCaptureThisNamed("sass.SassList", new A.listClass__closure()));
                J.get$$prototype$x(jsClass).get = A.allowInteropCaptureThisNamed("get", new A.listClass__closure0());
                A.JSClassExtension_injectSuperclass(t1._as(B.SassList_9ua.constructor), jsClass);
                return jsClass;
            },
            $signature: 17
        };
        A.listClass__closure.prototype = {
            call$3: function($self, contentsOrOptions, options) {
                var contents, t1, t2;
                if (self.immutable.isList(contentsOrOptions)) contents = J.cast$1$0$ax(J.toArray$0$x(type$.ImmutableList._as(contentsOrOptions)), type$.Value_2);
                else if (type$.List_dynamic._is(contentsOrOptions)) contents = J.cast$1$0$ax(contentsOrOptions, type$.Value_2);
                else {
                    contents = A._setArrayType([], type$.JSArray_Value_2);
                    type$.nullable__ConstructorOptions._as(contentsOrOptions);
                    options = contentsOrOptions;
                }
                t1 = options == null;
                if (!t1) {
                    t2 = J.get$separator$x(options);
                    t2 = A._asBool($.$get$_isUndefined().call$1(t2));
                } else t2 = true;
                t2 = t2 ? B.ListSeparator_z0K0 : A.jsToDartSeparator(J.get$separator$x(options));
                t1 = t1 ? null : J.get$brackets$x(options);
                return A.SassList$0(contents, t2, t1 == null ? false : t1);
            },
            call$1: function($self) {
                return this.call$3($self, null, null);
            },
            call$2: function($self, contentsOrOptions) {
                return this.call$3($self, contentsOrOptions, null);
            },
            "call*": "call$3",
            $requiredArgCount: 1,
            $defaultValues: function() {
                return [
                    null,
                    null
                ];
            },
            $signature: 515
        };
        A.listClass__closure0.prototype = {
            call$2: function($self, indexFloat) {
                var index = B.JSNumber_methods.floor$0(indexFloat);
                if (index < 0) index = $self.get$asList().length + index;
                if (index < 0 || index >= $self.get$asList().length) return self.undefined;
                return $self.get$asList()[index];
            },
            $signature: 250
        };
        A._ConstructorOptions.prototype = {};
        A._NodeSassList.prototype = {};
        A.legacyListClass_closure.prototype = {
            call$4: function(thisArg, $length, commaSeparator, dartValue) {
                var t1;
                if (dartValue == null) {
                    $length.toString;
                    t1 = A.Iterable_Iterable$generate($length, new A.legacyListClass__closure(), type$.Value_2);
                    t1 = A.SassList$0(t1, commaSeparator !== false ? B.ListSeparator_z0K0 : B.ListSeparator_SrV0, false);
                } else t1 = dartValue;
                J.set$dartValue$x(thisArg, t1);
            },
            call$2: function(thisArg, $length) {
                return this.call$4(thisArg, $length, null, null);
            },
            call$3: function(thisArg, $length, commaSeparator) {
                return this.call$4(thisArg, $length, commaSeparator, null);
            },
            "call*": "call$4",
            $requiredArgCount: 2,
            $defaultValues: function() {
                return [
                    null,
                    null
                ];
            },
            $signature: 517
        };
        A.legacyListClass__closure.prototype = {
            call$1: function(_) {
                return B.C__SassNull0;
            },
            $signature: 251
        };
        A.legacyListClass_closure0.prototype = {
            call$2: function(thisArg, index) {
                return A.wrapValue(J.get$dartValue$x(thisArg)._list1$_contents[index]);
            },
            $signature: 519
        };
        A.legacyListClass_closure1.prototype = {
            call$3: function(thisArg, index, value) {
                var t1 = J.getInterceptor$x(thisArg), t2 = t1.get$dartValue(thisArg)._list1$_contents, mutable = A._setArrayType(t2.slice(0), A._arrayInstanceType(t2));
                mutable[index] = A.unwrapValue(value);
                t1.set$dartValue(thisArg, t1.get$dartValue(thisArg).withListContents$1(mutable));
            },
            "call*": "call$3",
            $requiredArgCount: 3,
            $signature: 520
        };
        A.legacyListClass_closure2.prototype = {
            call$1: function(thisArg) {
                return J.get$dartValue$x(thisArg)._list1$_separator === B.ListSeparator_z0K0;
            },
            $signature: 521
        };
        A.legacyListClass_closure3.prototype = {
            call$2: function(thisArg, isComma) {
                var t1 = J.getInterceptor$x(thisArg), t2 = t1.get$dartValue(thisArg)._list1$_contents, t3 = isComma ? B.ListSeparator_z0K0 : B.ListSeparator_SrV0;
                t1.set$dartValue(thisArg, A.SassList$0(t2, t3, t1.get$dartValue(thisArg)._list1$_hasBrackets));
            },
            $signature: 522
        };
        A.legacyListClass_closure4.prototype = {
            call$1: function(thisArg) {
                return J.get$dartValue$x(thisArg)._list1$_contents.length;
            },
            $signature: 523
        };
        A.SassList0.prototype = {
            get$separator: function(_) {
                return this._list1$_separator;
            },
            get$hasBrackets: function() {
                return this._list1$_hasBrackets;
            },
            get$isBlank: function() {
                return !this._list1$_hasBrackets && B.JSArray_methods.every$1(this._list1$_contents, new A.SassList_isBlank_closure0());
            },
            get$asList: function() {
                return this._list1$_contents;
            },
            get$lengthAsList: function() {
                return this._list1$_contents.length;
            },
            SassList$3$brackets0: function(contents, _separator, brackets) {
                if (this._list1$_separator === B.ListSeparator_undecided_null_3_undecided0 && this._list1$_contents.length > 1) throw A.wrapException(A.ArgumentError$(string$.A_list, null));
            },
            toString$0: function(_) {
                var t2, _this = this, t1 = true;
                if (!_this._list1$_hasBrackets) {
                    t2 = _this._list1$_contents.length;
                    if (t2 !== 0) t1 = t2 === 1 && _this._list1$_separator === B.ListSeparator_z0K0;
                }
                if (t1) return _this.super$Value$toString0(0);
                return "(" + _this.super$Value$toString0(0) + ")";
            },
            accept$1$1: function(visitor) {
                return visitor.visitList$1(this);
            },
            accept$1: function(visitor) {
                return this.accept$1$1(visitor, type$.dynamic);
            },
            assertMap$1: function($name) {
                return this._list1$_contents.length === 0 ? B.SassMap_Map_empty0 : this.super$Value$assertMap0($name);
            },
            tryMap$0: function() {
                return this._list1$_contents.length === 0 ? B.SassMap_Map_empty0 : null;
            },
            $eq: function(_, other) {
                var t1, _this = this;
                if (other == null) return false;
                if (!(other instanceof A.SassList0 && other._list1$_separator === _this._list1$_separator && other._list1$_hasBrackets === _this._list1$_hasBrackets && B.C_ListEquality.equals$2(0, other._list1$_contents, _this._list1$_contents))) t1 = _this._list1$_contents.length === 0 && other instanceof A.SassMap0 && other.get$asList().length === 0;
                else t1 = true;
                return t1;
            },
            get$hashCode: function(_) {
                return B.C_ListEquality0.hash$1(this._list1$_contents);
            }
        };
        A.SassList_isBlank_closure0.prototype = {
            call$1: function(element) {
                return element.get$isBlank();
            },
            $signature: 56
        };
        A.ListSeparator0.prototype = {
            _enumToString$0: function() {
                return "ListSeparator." + this._name;
            },
            toString$0: function(_) {
                return this._list1$_name;
            }
        };
        A.LmsColorSpace0.prototype = {
            get$isBoundedInternal: function() {
                return false;
            },
            convert$10$missingA$missingB$missingChroma$missingHue$missingLightness: function(dest, long, medium, short, alpha, missingA, missingB, missingChroma, missingHue, missingLightness) {
                var t1, longScaled, mediumScaled, shortScaled, lightness, t2, t3, _null = null;
                switch(dest){
                    case B.OklabColorSpace_5400:
                        t1 = long == null ? 0 : long;
                        longScaled = Math.pow(Math.abs(t1), 0.3333333333333333) * J.get$sign$in(t1);
                        t1 = medium == null ? 0 : medium;
                        mediumScaled = Math.pow(Math.abs(t1), 0.3333333333333333) * J.get$sign$in(t1);
                        t1 = short == null ? 0 : short;
                        shortScaled = Math.pow(Math.abs(t1), 0.3333333333333333) * J.get$sign$in(t1);
                        t1 = $.$get$lmsToOklab0();
                        lightness = t1[0] * longScaled + t1[1] * mediumScaled + t1[2] * shortScaled;
                        t2 = missingLightness ? _null : lightness;
                        t3 = missingA ? _null : t1[3] * longScaled + t1[4] * mediumScaled + t1[5] * shortScaled;
                        return A.SassColor$_forSpace0(B.OklabColorSpace_5400, t2, t3, missingB ? _null : t1[6] * longScaled + t1[7] * mediumScaled + t1[8] * shortScaled, alpha, _null);
                    case B.OklchColorSpace_9Gj0:
                        t1 = long == null ? 0 : long;
                        longScaled = Math.pow(Math.abs(t1), 0.3333333333333333) * J.get$sign$in(t1);
                        t1 = medium == null ? 0 : medium;
                        mediumScaled = Math.pow(Math.abs(t1), 0.3333333333333333) * J.get$sign$in(t1);
                        t1 = short == null ? 0 : short;
                        shortScaled = Math.pow(Math.abs(t1), 0.3333333333333333) * J.get$sign$in(t1);
                        if (missingLightness) t1 = _null;
                        else {
                            t1 = $.$get$lmsToOklab0();
                            t1 = t1[0] * longScaled + t1[1] * mediumScaled + t1[2] * shortScaled;
                        }
                        t2 = $.$get$lmsToOklab0();
                        return A.labToLch0(dest, t1, t2[3] * longScaled + t2[4] * mediumScaled + t2[5] * shortScaled, t2[6] * longScaled + t2[7] * mediumScaled + t2[8] * shortScaled, alpha, missingChroma, missingHue);
                    default:
                        return this.super$ColorSpace$convertLinear0(dest, long, medium, short, alpha, missingA, missingB, missingChroma, missingHue, missingLightness);
                }
            },
            convert$5: function(dest, long, medium, short, alpha) {
                return this.convert$10$missingA$missingB$missingChroma$missingHue$missingLightness(dest, long, medium, short, alpha, false, false, false, false, false);
            },
            toLinear$1: function(channel) {
                return channel;
            },
            fromLinear$1: function(channel) {
                return channel;
            },
            transformationMatrix$1: function(dest) {
                var t1;
                $label0$0: {
                    if (B.SrgbLinearColorSpace_kUj0 === dest || B.SrgbColorSpace_thf0 === dest || B.RgbColorSpace_i0P0 === dest) {
                        t1 = $.$get$lmsToLinearSrgb0();
                        break $label0$0;
                    }
                    if (B.A98RgbColorSpace_lf20 === dest) {
                        t1 = $.$get$lmsToLinearA98Rgb0();
                        break $label0$0;
                    }
                    if (B.ProphotoRgbColorSpace_BDz0 === dest) {
                        t1 = $.$get$lmsToLinearProphotoRgb0();
                        break $label0$0;
                    }
                    if (B.DisplayP3ColorSpace_MmT0 === dest || B.DisplayP3LinearColorSpace_PrP0 === dest) {
                        t1 = $.$get$lmsToLinearDisplayP30();
                        break $label0$0;
                    }
                    if (B.Rec2020ColorSpace_6oo0 === dest) {
                        t1 = $.$get$lmsToLinearRec20200();
                        break $label0$0;
                    }
                    if (B.XyzD65ColorSpace_WiJ0 === dest) {
                        t1 = $.$get$lmsToXyzD650();
                        break $label0$0;
                    }
                    if (B.XyzD50ColorSpace_2OB0 === dest) {
                        t1 = $.$get$lmsToXyzD500();
                        break $label0$0;
                    }
                    t1 = this.super$ColorSpace$transformationMatrix0(dest);
                    break $label0$0;
                }
                return t1;
            }
        };
        A.LocalMindeGamutMap0.prototype = {
            map$1: function(_, color) {
                var clipped, max, min, minInGamut, chroma, current, e, originOklch = color.toSpace$1(B.OklchColorSpace_9Gj0), lightness = originOklch.channel0OrNull, hue = originOklch.channel2OrNull, alpha = originOklch.alphaOrNull, t1 = lightness == null, t2 = t1 ? 0 : lightness;
                if (t2 > 1 || A.fuzzyEquals0(t2, 1)) {
                    t1 = color._color0$_space;
                    t2 = color.alphaOrNull;
                    return t1.get$isLegacyInternal() ? A.SassColor_SassColor$rgbInternal0(255, 255, 255, t2, null).toSpace$1(t1) : A.SassColor_SassColor$forSpaceInternal0(t1, 1, 1, 1, t2);
                } else {
                    t1 = t1 ? 0 : lightness;
                    if (t1 < 0 || A.fuzzyEquals0(t1, 0)) return A.SassColor_SassColor$rgbInternal0(0, 0, 0, color.alphaOrNull, null).toSpace$1(color._color0$_space);
                }
                clipped = color.get$isInGamut() ? color : B.ClipGamutMap_clip0.map$1(0, color);
                if (this._local_minde$_deltaEOK$2(clipped, color) < 0.02) return clipped;
                max = originOklch.channel1OrNull;
                if (max == null) max = 0;
                for(t1 = color._color0$_space, min = 0, minInGamut = true; max - min > 0.0001;){
                    chroma = (min + max) / 2;
                    current = B.OklchColorSpace_9Gj0.convert$5(t1, lightness, chroma, hue, alpha);
                    if (minInGamut && current.get$isInGamut()) {
                        min = chroma;
                        continue;
                    }
                    clipped = current.get$isInGamut() ? current : B.ClipGamutMap_clip0.map$1(0, current);
                    e = this._local_minde$_deltaEOK$2(clipped, current);
                    if (e < 0.02) {
                        if (0.02 - e < 0.0001) return clipped;
                        min = chroma;
                        minInGamut = false;
                    } else max = chroma;
                }
                return clipped;
            },
            _local_minde$_deltaEOK$2: function(color1, color2) {
                var t2, t3, t4, lab1 = color1.toSpace$1(B.OklabColorSpace_5400), lab2 = color2.toSpace$1(B.OklabColorSpace_5400), t1 = lab1.channel0OrNull;
                if (t1 == null) t1 = 0;
                t2 = lab2.channel0OrNull;
                t1 = Math.pow(t1 - (t2 == null ? 0 : t2), 2);
                t2 = lab1.channel1OrNull;
                if (t2 == null) t2 = 0;
                t3 = lab2.channel1OrNull;
                t2 = Math.pow(t2 - (t3 == null ? 0 : t3), 2);
                t3 = lab1.channel2OrNull;
                if (t3 == null) t3 = 0;
                t4 = lab2.channel2OrNull;
                return Math.sqrt(t1 + t2 + Math.pow(t3 - (t4 == null ? 0 : t4), 2));
            }
        };
        A.JSLogger.prototype = {};
        A.WarnOptions.prototype = {};
        A.DebugOptions.prototype = {};
        A.LoggerWithDeprecationType0.prototype = {};
        A.LoudComment0.prototype = {
            get$span: function(_) {
                return this.text.span;
            },
            accept$1$1: function(visitor) {
                return visitor.visitLoudComment$1(0, this);
            },
            accept$1: function(visitor) {
                return this.accept$1$1(visitor, type$.dynamic);
            },
            toString$0: function(_) {
                return this.text.toString$0(0);
            }
        };
        A.MapExpression0.prototype = {
            accept$1$1: function(visitor) {
                return visitor.visitMapExpression$1(0, this);
            },
            accept$1: function(visitor) {
                return this.accept$1$1(visitor, type$.dynamic);
            },
            toString$0: function(_) {
                var t2, t3, _i, t4, t1 = A._setArrayType([], type$.JSArray_String);
                for(t2 = this.pairs, t3 = t2.length, _i = 0; _i < t3; ++_i){
                    t4 = t2[_i];
                    t1.push(t4._0.toString$0(0) + ": " + t4._1.toString$0(0));
                }
                return "(" + B.JSArray_methods.join$1(t1, ", ") + ")";
            },
            get$span: function(receiver) {
                return this.span;
            }
        };
        A._get_closure0.prototype = {
            call$1: function($arguments) {
                var value, t1 = J.getInterceptor$asx($arguments), map = t1.$index($arguments, 0).assertMap$1("map"), t2 = A._setArrayType([
                    t1.$index($arguments, 1)
                ], type$.JSArray_Value_2);
                B.JSArray_methods.addAll$1(t2, t1.$index($arguments, 2).get$asList());
                for(t1 = A.IterableExtension_get_exceptLast0(t2), t1 = t1.get$iterator(t1); t1.moveNext$0(); map = value){
                    value = map._map0$_contents.$index(0, t1.get$current(t1));
                    if (!(value instanceof A.SassMap0)) return B.C__SassNull0;
                }
                t1 = map._map0$_contents.$index(0, B.JSArray_methods.get$last(t2));
                return t1 == null ? B.C__SassNull0 : t1;
            },
            $signature: 3
        };
        A._set_closure1.prototype = {
            call$1: function($arguments) {
                var t1 = J.getInterceptor$asx($arguments);
                return A._modify0(t1.$index($arguments, 0).assertMap$1("map"), A._setArrayType([
                    t1.$index($arguments, 1)
                ], type$.JSArray_Value_2), new A._set__closure2($arguments), true);
            },
            $signature: 3
        };
        A._set__closure2.prototype = {
            call$1: function(_) {
                return J.$index$asx(this.$arguments, 2);
            },
            $signature: 41
        };
        A._set_closure2.prototype = {
            call$1: function($arguments) {
                var keys, t2, t3, t1 = J.getInterceptor$asx($arguments), map = t1.$index($arguments, 0).assertMap$1("map"), _0_0 = t1.$index($arguments, 1).get$asList(), _0_1 = _0_0.length;
                if (_0_1 <= 0) throw A.wrapException(A.SassScriptException$0("Expected $args to contain a key.", null));
                if (_0_1 === 1) throw A.wrapException(A.SassScriptException$0("Expected $args to contain a value.", null));
                t1 = {};
                keys = t1.value = null;
                t2 = _0_1 >= 1;
                if (t2) {
                    t3 = _0_1 - 1;
                    keys = B.JSArray_methods.sublist$2(_0_0, 0, t3);
                    t1.value = _0_0[t3];
                }
                if (t2) return A._modify0(map, keys, new A._set__closure1(t1), true);
                throw A.wrapException("[BUG] Unreachable code");
            },
            $signature: 3
        };
        A._set__closure1.prototype = {
            call$1: function(_) {
                return this._box_0.value;
            },
            $signature: 41
        };
        A._merge_closure1.prototype = {
            call$1: function($arguments) {
                var t2, t1 = J.getInterceptor$asx($arguments), map1 = t1.$index($arguments, 0).assertMap$1("map1"), map2 = t1.$index($arguments, 1).assertMap$1("map2");
                t1 = type$.Value_2;
                t2 = A.LinkedHashMap_LinkedHashMap$of(map1._map0$_contents, t1, t1);
                t2.addAll$1(0, map2._map0$_contents);
                return new A.SassMap0(A.ConstantMap_ConstantMap$from(t2, t1, t1));
            },
            $signature: 34
        };
        A._merge_closure2.prototype = {
            call$1: function($arguments) {
                var last, t2, keys, _null = null, t1 = J.getInterceptor$asx($arguments), map1 = t1.$index($arguments, 0).assertMap$1("map1"), _0_0 = t1.$index($arguments, 1).get$asList(), _0_1 = _0_0.length;
                if (_0_1 <= 0) throw A.wrapException(A.SassScriptException$0("Expected $args to contain a key.", _null));
                if (_0_1 === 1) throw A.wrapException(A.SassScriptException$0("Expected $args to contain a map.", _null));
                t1 = _0_1 >= 1;
                last = _null;
                if (t1) {
                    t2 = _0_1 - 1;
                    keys = B.JSArray_methods.sublist$2(_0_0, 0, t2);
                    last = _0_0[t2];
                } else keys = _null;
                if (t1) return A._modify0(map1, keys, new A._merge__closure0(last.assertMap$1("map2")), true);
                throw A.wrapException("[BUG] Unreachable code");
            },
            $signature: 3
        };
        A._merge__closure0.prototype = {
            call$1: function(oldValue) {
                var t1, t2, nestedMap = oldValue.tryMap$0();
                if (nestedMap == null) return this.map2;
                t1 = type$.Value_2;
                t2 = A.LinkedHashMap_LinkedHashMap$of(nestedMap._map0$_contents, t1, t1);
                t2.addAll$1(0, this.map2._map0$_contents);
                return new A.SassMap0(A.ConstantMap_ConstantMap$from(t2, t1, t1));
            },
            $signature: 524
        };
        A._deepMerge_closure0.prototype = {
            call$1: function($arguments) {
                var t1 = J.getInterceptor$asx($arguments);
                return A._deepMergeImpl0(t1.$index($arguments, 0).assertMap$1("map1"), t1.$index($arguments, 1).assertMap$1("map2"));
            },
            $signature: 34
        };
        A._deepRemove_closure0.prototype = {
            call$1: function($arguments) {
                var t1 = J.getInterceptor$asx($arguments), map = t1.$index($arguments, 0).assertMap$1("map"), t2 = A._setArrayType([
                    t1.$index($arguments, 1)
                ], type$.JSArray_Value_2);
                B.JSArray_methods.addAll$1(t2, t1.$index($arguments, 2).get$asList());
                return A._modify0(map, A.IterableExtension_get_exceptLast0(t2), new A._deepRemove__closure0(t2), false);
            },
            $signature: 3
        };
        A._deepRemove__closure0.prototype = {
            call$1: function(value) {
                var t1, nestedMap, t2, _0_0 = value.tryMap$0();
                if (_0_0 != null) {
                    t1 = _0_0._map0$_contents.containsKey$1(B.JSArray_methods.get$last(this.keys));
                    nestedMap = _0_0;
                } else {
                    nestedMap = null;
                    t1 = false;
                }
                if (t1) {
                    t1 = type$.Value_2;
                    t2 = A.LinkedHashMap_LinkedHashMap$of(nestedMap._map0$_contents, t1, t1);
                    t2.remove$1(0, B.JSArray_methods.get$last(this.keys));
                    return new A.SassMap0(A.ConstantMap_ConstantMap$from(t2, t1, t1));
                }
                return value;
            },
            $signature: 41
        };
        A._remove_closure1.prototype = {
            call$1: function($arguments) {
                return J.$index$asx($arguments, 0).assertMap$1("map");
            },
            $signature: 34
        };
        A._remove_closure2.prototype = {
            call$1: function($arguments) {
                var mutableMap, t3, _i, t1 = J.getInterceptor$asx($arguments), map = t1.$index($arguments, 0).assertMap$1("map"), t2 = A._setArrayType([
                    t1.$index($arguments, 1)
                ], type$.JSArray_Value_2);
                B.JSArray_methods.addAll$1(t2, t1.$index($arguments, 2).get$asList());
                t1 = type$.Value_2;
                mutableMap = A.LinkedHashMap_LinkedHashMap$of(map._map0$_contents, t1, t1);
                for(t3 = t2.length, _i = 0; _i < t2.length; t2.length === t3 || (0, A.throwConcurrentModificationError)(t2), ++_i)mutableMap.remove$1(0, t2[_i]);
                return new A.SassMap0(A.ConstantMap_ConstantMap$from(mutableMap, t1, t1));
            },
            $signature: 34
        };
        A._keys_closure0.prototype = {
            call$1: function($arguments) {
                var t1 = J.$index$asx($arguments, 0).assertMap$1("map")._map0$_contents;
                return A.SassList$0(t1.get$keys(t1), B.ListSeparator_z0K0, false);
            },
            $signature: 27
        };
        A._values_closure0.prototype = {
            call$1: function($arguments) {
                var t1 = J.$index$asx($arguments, 0).assertMap$1("map")._map0$_contents;
                return A.SassList$0(t1.get$values(t1), B.ListSeparator_z0K0, false);
            },
            $signature: 27
        };
        A._hasKey_closure0.prototype = {
            call$1: function($arguments) {
                var value, t1 = J.getInterceptor$asx($arguments), map = t1.$index($arguments, 0).assertMap$1("map"), t2 = A._setArrayType([
                    t1.$index($arguments, 1)
                ], type$.JSArray_Value_2);
                B.JSArray_methods.addAll$1(t2, t1.$index($arguments, 2).get$asList());
                for(t1 = A.IterableExtension_get_exceptLast0(t2), t1 = t1.get$iterator(t1); t1.moveNext$0(); map = value){
                    value = map._map0$_contents.$index(0, t1.get$current(t1));
                    if (!(value instanceof A.SassMap0)) return B.SassBoolean_false0;
                }
                return map._map0$_contents.containsKey$1(B.JSArray_methods.get$last(t2)) ? B.SassBoolean_true0 : B.SassBoolean_false0;
            },
            $signature: 13
        };
        A._modify_modifyNestedMap0.prototype = {
            call$1: function(map) {
                var nestedMap, _this = this, t1 = type$.Value_2, mutableMap = A.LinkedHashMap_LinkedHashMap$of(map._map0$_contents, t1, t1), t2 = _this.keyIterator, key = t2.get$current(t2);
                if (!t2.moveNext$0()) {
                    t2 = mutableMap.$index(0, key);
                    if (t2 == null) t2 = B.C__SassNull0;
                    mutableMap.$indexSet(0, key, _this.modify.call$1(t2));
                    return new A.SassMap0(A.ConstantMap_ConstantMap$from(mutableMap, t1, t1));
                }
                t2 = mutableMap.$index(0, key);
                nestedMap = t2 == null ? null : t2.tryMap$0();
                t2 = nestedMap == null;
                if (t2 && !_this.addNesting) return new A.SassMap0(A.ConstantMap_ConstantMap$from(mutableMap, t1, t1));
                mutableMap.$indexSet(0, key, _this.call$1(t2 ? B.SassMap_Map_empty0 : nestedMap));
                return new A.SassMap0(A.ConstantMap_ConstantMap$from(mutableMap, t1, t1));
            },
            $signature: 525
        };
        A.MapExtensions_get_pairs_closure0.prototype = {
            call$1: function(e) {
                return new A._Record_2(e.key, e.value);
            },
            $signature: function() {
                return this.K._eval$1("@<0>")._bind$1(this.V)._eval$1("+(1,2)(MapEntry<1,2>)");
            }
        };
        A.mapClass_closure.prototype = {
            call$0: function() {
                var t1 = type$.JSClass, jsClass = t1._as(A.allowInteropCaptureThisNamed("sass.SassMap", new A.mapClass__closure())), t2 = J.getInterceptor$x(jsClass);
                A.defineGetter(t2.get$$prototype(jsClass), "contents", new A.mapClass__closure0(), null);
                t2.get$$prototype(jsClass).get = A.allowInteropCaptureThisNamed("get", new A.mapClass__closure1());
                A.JSClassExtension_injectSuperclass(t1._as(B.SassMap_Map_empty0.constructor), jsClass);
                return jsClass;
            },
            $signature: 17
        };
        A.mapClass__closure.prototype = {
            call$2: function($self, contents) {
                var t1;
                if (contents == null) t1 = B.SassMap_Map_empty0;
                else {
                    t1 = type$.Value_2;
                    t1 = new A.SassMap0(A.ConstantMap_ConstantMap$from(A.immutableMapToDartMap(contents).cast$2$0(0, t1, t1), t1, t1));
                }
                return t1;
            },
            call$1: function($self) {
                return this.call$2($self, null);
            },
            "call*": "call$2",
            $requiredArgCount: 1,
            $defaultValues: function() {
                return [
                    null
                ];
            },
            $signature: 526
        };
        A.mapClass__closure0.prototype = {
            call$1: function($self) {
                return A.dartMapToImmutableMap($self._map0$_contents);
            },
            $signature: 527
        };
        A.mapClass__closure1.prototype = {
            call$2: function($self, indexOrKey) {
                var index, t1, _0_0;
                if (typeof indexOrKey == "number") {
                    index = B.JSNumber_methods.floor$0(indexOrKey);
                    if (index < 0) {
                        t1 = $self._map0$_contents;
                        index = t1.get$length(t1) + index;
                    }
                    if (index >= 0) {
                        t1 = $self._map0$_contents;
                        t1 = index >= t1.get$length(t1);
                    } else t1 = true;
                    if (t1) return self.undefined;
                    t1 = type$.Value_2;
                    _0_0 = A.MapExtensions_get_pairs0($self._map0$_contents, t1, t1).elementAt$1(0, index);
                    return A.SassList$0(A._setArrayType([
                        _0_0._0,
                        _0_0._1
                    ], type$.JSArray_Value_2), B.ListSeparator_SrV0, false);
                } else {
                    t1 = $self._map0$_contents.$index(0, indexOrKey);
                    return t1 == null ? self.undefined : t1;
                }
            },
            $signature: 528
        };
        A._NodeSassMap.prototype = {};
        A.legacyMapClass_closure.prototype = {
            call$3: function(thisArg, $length, dartValue) {
                var t1, t2, t3, map;
                if (dartValue == null) {
                    $length.toString;
                    t1 = type$.Value_2;
                    t2 = A.Iterable_Iterable$generate($length, new A.legacyMapClass__closure(), t1);
                    t3 = A.Iterable_Iterable$generate($length, new A.legacyMapClass__closure0(), t1);
                    map = A.LinkedHashMap_LinkedHashMap(null, null, null, t1, t1);
                    A.MapBase__fillMapWithIterables(map, t2, t3);
                    t1 = new A.SassMap0(A.ConstantMap_ConstantMap$from(map, t1, t1));
                } else t1 = dartValue;
                J.set$dartValue$x(thisArg, t1);
            },
            call$2: function(thisArg, $length) {
                return this.call$3(thisArg, $length, null);
            },
            "call*": "call$3",
            $requiredArgCount: 2,
            $defaultValues: function() {
                return [
                    null
                ];
            },
            $signature: 529
        };
        A.legacyMapClass__closure.prototype = {
            call$1: function(i) {
                return A.SassNumber_SassNumber0(i, null);
            },
            $signature: 530
        };
        A.legacyMapClass__closure0.prototype = {
            call$1: function(_) {
                return B.C__SassNull0;
            },
            $signature: 251
        };
        A.legacyMapClass_closure0.prototype = {
            call$2: function(thisArg, index) {
                var t1 = J.get$dartValue$x(thisArg)._map0$_contents;
                t1 = t1.get$keys(t1);
                return A.wrapValue(t1.elementAt$1(t1, index));
            },
            $signature: 252
        };
        A.legacyMapClass_closure1.prototype = {
            call$2: function(thisArg, index) {
                var t1 = J.get$dartValue$x(thisArg)._map0$_contents;
                t1 = t1.get$values(t1);
                return A.wrapValue(t1.elementAt$1(t1, index));
            },
            $signature: 252
        };
        A.legacyMapClass_closure2.prototype = {
            call$1: function(thisArg) {
                var t1 = J.get$dartValue$x(thisArg)._map0$_contents;
                return t1.get$length(t1);
            },
            $signature: 532
        };
        A.legacyMapClass_closure3.prototype = {
            call$3: function(thisArg, index, key) {
                var newKey, t2, newMap, t3, i, t4, oldKey, oldValue, t1 = J.getInterceptor$x(thisArg), oldMap = t1.get$dartValue(thisArg)._map0$_contents, $length = oldMap.get$length(oldMap);
                A.IndexError_check(index, $length, oldMap, null, "index");
                newKey = A.unwrapValue(key);
                t2 = type$.Value_2;
                newMap = A.LinkedHashMap_LinkedHashMap$_empty(t2, t2);
                for(t3 = A.MapExtensions_get_pairs0(t1.get$dartValue(thisArg)._map0$_contents, t2, t2), t3 = t3.get$iterator(t3), i = 0; t3.moveNext$0();){
                    t4 = t3.get$current(t3);
                    oldKey = t4._0;
                    oldValue = t4._1;
                    if (i === index) newMap.$indexSet(0, newKey, oldValue);
                    else {
                        if (newKey.$eq(0, oldKey)) throw A.wrapException(A.ArgumentError$value(key, "key", "is already in the map"));
                        newMap.$indexSet(0, oldKey, oldValue);
                    }
                    ++i;
                }
                t1.set$dartValue(thisArg, new A.SassMap0(A.ConstantMap_ConstantMap$from(newMap, t2, t2)));
            },
            "call*": "call$3",
            $requiredArgCount: 3,
            $signature: 253
        };
        A.legacyMapClass_closure4.prototype = {
            call$3: function(thisArg, index, value) {
                var key, t3, t1 = J.getInterceptor$x(thisArg), t2 = t1.get$dartValue(thisArg)._map0$_contents;
                t2 = t2.get$keys(t2);
                key = t2.elementAt$1(t2, index);
                t2 = type$.Value_2;
                t3 = A.LinkedHashMap_LinkedHashMap$of(t1.get$dartValue(thisArg)._map0$_contents, t2, t2);
                t3.$indexSet(0, key, A.unwrapValue(value));
                t1.set$dartValue(thisArg, new A.SassMap0(A.ConstantMap_ConstantMap$from(t3, t2, t2)));
            },
            "call*": "call$3",
            $requiredArgCount: 3,
            $signature: 253
        };
        A.SassMap0.prototype = {
            get$separator: function(_) {
                var t1 = this._map0$_contents;
                return t1.get$isEmpty(t1) ? B.ListSeparator_undecided_null_3_undecided0 : B.ListSeparator_z0K0;
            },
            get$asList: function() {
                var t3, t4, t5, result, t1 = type$.JSArray_Value_2, t2 = A._setArrayType([], t1);
                for(t3 = type$.Value_2, t4 = A.MapExtensions_get_pairs0(this._map0$_contents, t3, t3), t4 = t4.get$iterator(t4); t4.moveNext$0();){
                    t5 = t4.get$current(t4);
                    result = A.List_List$from(A._setArrayType([
                        t5._0,
                        t5._1
                    ], t1), false, t3);
                    result.$flags = 3;
                    t2.push(new A.SassList0(result, B.ListSeparator_SrV0, false));
                }
                return t2;
            },
            get$lengthAsList: function() {
                var t1 = this._map0$_contents;
                return t1.get$length(t1);
            },
            accept$1$1: function(visitor) {
                return visitor.visitMap$1(this);
            },
            accept$1: function(visitor) {
                return this.accept$1$1(visitor, type$.dynamic);
            },
            assertMap$1: function($name) {
                return this;
            },
            tryMap$0: function() {
                return this;
            },
            $eq: function(_, other) {
                var t1;
                if (other == null) return false;
                if (!(other instanceof A.SassMap0 && B.C_MapEquality.equals$2(0, other._map0$_contents, this._map0$_contents))) {
                    t1 = this._map0$_contents;
                    t1 = t1.get$isEmpty(t1) && other instanceof A.SassList0 && other._list1$_contents.length === 0;
                } else t1 = true;
                return t1;
            },
            get$hashCode: function(_) {
                var t1 = this._map0$_contents;
                return t1.get$isEmpty(t1) ? B.C_ListEquality0.hash$1(B.List_empty23) : B.C_MapEquality.hash$1(t1);
            }
        };
        A.global_closure43.prototype = {
            call$1: function($arguments) {
                var t1, number = J.$index$asx($arguments, 0).assertNumber$1("number");
                if (number.hasUnit$1("%")) A.warnForDeprecation0(string$.Passinp + number.toString$0(0) + ")\nTo emit a CSS abs() now: abs(#{" + number.toString$0(0) + string$.x7dx29_Mor, B.Deprecation_w3M);
                else A.warnForDeprecation0(string$.Globalm, B.Deprecation_SGB);
                t1 = number.get$numeratorUnits(number);
                return A.SassNumber_SassNumber$withUnits0(Math.abs(number._number1$_value), number.get$denominatorUnits(number), t1);
            },
            $signature: 25
        };
        A.module_closure26.prototype = {
            call$1: function(value) {
                return Math.abs(value);
            },
            $signature: 12
        };
        A._ceil_closure0.prototype = {
            call$1: function(value) {
                return B.JSNumber_methods.ceil$0(value);
            },
            $signature: 12
        };
        A._clamp_closure0.prototype = {
            call$1: function($arguments) {
                var t1 = J.getInterceptor$asx($arguments), min = t1.$index($arguments, 0).assertNumber$1("min"), number = t1.$index($arguments, 1).assertNumber$1("number"), max = t1.$index($arguments, 2).assertNumber$1("max");
                number.convertValueToMatch$3(min, "number", "min");
                max.convertValueToMatch$3(min, "max", "min");
                if (min.greaterThanOrEquals$1(max).value) return min;
                if (min.greaterThanOrEquals$1(number).value) return min;
                if (number.greaterThanOrEquals$1(max).value) return max;
                return number;
            },
            $signature: 25
        };
        A._floor_closure0.prototype = {
            call$1: function(value) {
                return B.JSNumber_methods.floor$0(value);
            },
            $signature: 12
        };
        A._max_closure0.prototype = {
            call$1: function($arguments) {
                var t1, t2, max, _i, number;
                for(t1 = J.$index$asx($arguments, 0).get$asList(), t2 = t1.length, max = null, _i = 0; _i < t1.length; t1.length === t2 || (0, A.throwConcurrentModificationError)(t1), ++_i){
                    number = t1[_i].assertNumber$0();
                    if (max == null || max.lessThan$1(number).value) max = number;
                }
                if (max != null) return max;
                throw A.wrapException(A.SassScriptException$0("At least one argument must be passed.", null));
            },
            $signature: 25
        };
        A._min_closure0.prototype = {
            call$1: function($arguments) {
                var t1, t2, min, _i, number;
                for(t1 = J.$index$asx($arguments, 0).get$asList(), t2 = t1.length, min = null, _i = 0; _i < t1.length; t1.length === t2 || (0, A.throwConcurrentModificationError)(t1), ++_i){
                    number = t1[_i].assertNumber$0();
                    if (min == null || min.greaterThan$1(number).value) min = number;
                }
                if (min != null) return min;
                throw A.wrapException(A.SassScriptException$0("At least one argument must be passed.", null));
            },
            $signature: 25
        };
        A._round_closure0.prototype = {
            call$1: function(number) {
                return B.JSNumber_methods.round$0(number);
            },
            $signature: 12
        };
        A._hypot_closure0.prototype = {
            call$1: function($arguments) {
                var subtotal, i, i0, t3, t1 = J.$index$asx($arguments, 0).get$asList(), t2 = A._arrayInstanceType(t1)._eval$1("MappedListIterable<1,SassNumber0>"), numbers = A.List_List$_of(new A.MappedListIterable(t1, new A._hypot__closure0(), t2), t2._eval$1("ListIterable.E"));
                if (numbers.length === 0) throw A.wrapException(A.SassScriptException$0("At least one argument must be passed.", null));
                for(subtotal = 0, i = 0; i < numbers.length; i = i0){
                    i0 = i + 1;
                    subtotal += Math.pow(numbers[i].convertValueToMatch$3(numbers[0], "numbers[" + i0 + "]", "numbers[1]"), 2);
                }
                t1 = Math.sqrt(subtotal);
                t2 = numbers[0];
                t2 = t2.get$numeratorUnits(t2);
                t3 = numbers[0];
                return A.SassNumber_SassNumber$withUnits0(t1, t3.get$denominatorUnits(t3), t2);
            },
            $signature: 25
        };
        A._hypot__closure0.prototype = {
            call$1: function(argument) {
                return argument.assertNumber$0();
            },
            $signature: 534
        };
        A._log_closure0.prototype = {
            call$1: function($arguments) {
                var base, _s18_ = " to have no units.", _null = null, t1 = J.getInterceptor$asx($arguments), number = t1.$index($arguments, 0).assertNumber$1("number");
                if (number.get$hasUnits()) throw A.wrapException(A.SassScriptException$0("$number: Expected " + number.toString$0(0) + _s18_, _null));
                else if (t1.$index($arguments, 1).$eq(0, B.C__SassNull0)) return A.SassNumber_SassNumber0(Math.log(number._number1$_value), _null);
                base = t1.$index($arguments, 1).assertNumber$1("base");
                if (base.get$hasUnits()) throw A.wrapException(A.SassScriptException$0("$base: Expected " + base.toString$0(0) + _s18_, _null));
                else return A.SassNumber_SassNumber0(Math.log(number._number1$_value) / Math.log(base._number1$_value), _null);
            },
            $signature: 25
        };
        A._pow_closure0.prototype = {
            call$1: function($arguments) {
                var t1 = J.getInterceptor$asx($arguments);
                return A.pow1(t1.$index($arguments, 0).assertNumber$1("base"), t1.$index($arguments, 1).assertNumber$1("exponent"));
            },
            $signature: 25
        };
        A._atan2_closure0.prototype = {
            call$1: function($arguments) {
                var t1 = J.getInterceptor$asx($arguments), y = t1.$index($arguments, 0).assertNumber$1("y");
                return A.SassNumber_SassNumber$withUnits0(Math.atan2(y._number1$_value, t1.$index($arguments, 1).assertNumber$1("x").convertValueToMatch$3(y, "x", "y")) * 57.29577951308232, null, A._setArrayType([
                    "deg"
                ], type$.JSArray_String));
            },
            $signature: 25
        };
        A._compatible_closure0.prototype = {
            call$1: function($arguments) {
                var t1 = J.getInterceptor$asx($arguments);
                return t1.$index($arguments, 0).assertNumber$1("number1").isComparableTo$1(t1.$index($arguments, 1).assertNumber$1("number2")) ? B.SassBoolean_true0 : B.SassBoolean_false0;
            },
            $signature: 13
        };
        A._isUnitless_closure0.prototype = {
            call$1: function($arguments) {
                return !J.$index$asx($arguments, 0).assertNumber$1("number").get$hasUnits() ? B.SassBoolean_true0 : B.SassBoolean_false0;
            },
            $signature: 13
        };
        A._unit_closure0.prototype = {
            call$1: function($arguments) {
                return new A.SassString0(J.$index$asx($arguments, 0).assertNumber$1("number").get$unitString(), true);
            },
            $signature: 18
        };
        A._percentage_closure0.prototype = {
            call$1: function($arguments) {
                var number = J.$index$asx($arguments, 0).assertNumber$1("number");
                number.assertNoUnits$1("number");
                return A.SassNumber_SassNumber0(number._number1$_value * 100, "%");
            },
            $signature: 25
        };
        A._randomFunction_closure0.prototype = {
            call$1: function($arguments) {
                var limit, limitScalar, t1 = J.getInterceptor$asx($arguments);
                if (t1.$index($arguments, 0).$eq(0, B.C__SassNull0)) return A.SassNumber_SassNumber0($.$get$_random2().nextDouble$0(), null);
                limit = t1.$index($arguments, 0).assertNumber$1("limit");
                if (limit.get$hasUnits()) A.warnForDeprecation0(string$.math_r + limit.toString$0(0) + string$.x29x20in_a + limit.get$unitString() + ")) * 1" + limit.get$unitString() + string$.x0a_To_p + limit.get$unitString() + string$.x29x29__Mo, B.Deprecation_PHd);
                limitScalar = limit.assertInt$1("limit");
                if (limitScalar < 1) throw A.wrapException(A.SassScriptException$0("$limit: Must be greater than 0, was " + limit.toString$0(0) + ".", null));
                return A.SassNumber_SassNumber0($.$get$_random2().nextInt$1(limitScalar) + 1, null);
            },
            $signature: 25
        };
        A._div_closure0.prototype = {
            call$1: function($arguments) {
                var t1 = J.getInterceptor$asx($arguments), number1 = t1.$index($arguments, 0), number2 = t1.$index($arguments, 1);
                if (!(number1 instanceof A.SassNumber0) || !(number2 instanceof A.SassNumber0)) A.warn0(string$.math_d);
                return number1.dividedBy$1(number2);
            },
            $signature: 3
        };
        A._singleArgumentMathFunc_closure0.prototype = {
            call$1: function($arguments) {
                return this.mathFunc.call$1(J.$index$asx($arguments, 0).assertNumber$1("number"));
            },
            $signature: 25
        };
        A._numberFunction_closure0.prototype = {
            call$1: function($arguments) {
                var number = J.$index$asx($arguments, 0).assertNumber$1("number"), t1 = this.transform.call$1(number._number1$_value), t2 = number.get$numeratorUnits(number);
                return A.SassNumber_SassNumber$withUnits0(t1, number.get$denominatorUnits(number), t2);
            },
            $signature: 25
        };
        A.CssMediaQuery0.prototype = {
            merge$1: function(other) {
                var t1, ourModifier, t2, t3, ourType, t4, theirModifier, t5, t6, theirType, t7, t8, negativeConditions, conditions, type, modifier, fewerConditions, fewerConditions0, moreConditions, _this = this, _null = null, _s3_ = "all";
                if (!_this.conjunction || !other.conjunction) return B._SingletonCssMediaQueryMergeResult_10;
                t1 = _this.modifier;
                ourModifier = t1 == null ? _null : t1.toLowerCase();
                t2 = _this.type;
                t3 = t2 == null;
                ourType = t3 ? _null : t2.toLowerCase();
                t4 = other.modifier;
                theirModifier = t4 == null ? _null : t4.toLowerCase();
                t5 = other.type;
                t6 = t5 == null;
                theirType = t6 ? _null : t5.toLowerCase();
                t7 = ourType == null;
                if (t7 && theirType == null) {
                    t1 = A.List_List$_of(_this.conditions, type$.String);
                    B.JSArray_methods.addAll$1(t1, other.conditions);
                    return new A.MediaQuerySuccessfulMergeResult0(A.CssMediaQuery$condition0(t1, true));
                }
                t8 = ourModifier === "not";
                if (t8 !== (theirModifier === "not")) {
                    if (ourType == theirType) {
                        negativeConditions = t8 ? _this.conditions : other.conditions;
                        if (B.JSArray_methods.every$1(negativeConditions, B.JSArray_methods.get$contains(t8 ? other.conditions : _this.conditions))) return B._SingletonCssMediaQueryMergeResult_00;
                        else return B._SingletonCssMediaQueryMergeResult_10;
                    } else if (t3 || A.equalsIgnoreCase0(t2, _s3_) || t6 || A.equalsIgnoreCase0(t5, _s3_)) return B._SingletonCssMediaQueryMergeResult_10;
                    if (t8) {
                        conditions = other.conditions;
                        type = theirType;
                        modifier = theirModifier;
                    } else {
                        conditions = _this.conditions;
                        type = ourType;
                        modifier = ourModifier;
                    }
                } else if (t8) {
                    if (ourType != theirType) return B._SingletonCssMediaQueryMergeResult_10;
                    fewerConditions = _this.conditions;
                    fewerConditions0 = other.conditions;
                    t3 = fewerConditions.length > fewerConditions0.length;
                    moreConditions = t3 ? fewerConditions : fewerConditions0;
                    if (t3) fewerConditions = fewerConditions0;
                    if (!B.JSArray_methods.every$1(fewerConditions, B.JSArray_methods.get$contains(moreConditions))) return B._SingletonCssMediaQueryMergeResult_10;
                    conditions = moreConditions;
                    type = ourType;
                    modifier = ourModifier;
                } else if (t3 || A.equalsIgnoreCase0(t2, _s3_)) {
                    type = (t6 || A.equalsIgnoreCase0(t5, _s3_)) && t7 ? _null : theirType;
                    t3 = A.List_List$_of(_this.conditions, type$.String);
                    B.JSArray_methods.addAll$1(t3, other.conditions);
                    conditions = t3;
                    modifier = theirModifier;
                } else {
                    if (t6 || A.equalsIgnoreCase0(t5, _s3_)) {
                        t3 = A.List_List$_of(_this.conditions, type$.String);
                        B.JSArray_methods.addAll$1(t3, other.conditions);
                        conditions = t3;
                        modifier = ourModifier;
                    } else {
                        if (ourType != theirType) return B._SingletonCssMediaQueryMergeResult_00;
                        else {
                            modifier = ourModifier == null ? theirModifier : ourModifier;
                            t3 = A.List_List$_of(_this.conditions, type$.String);
                            B.JSArray_methods.addAll$1(t3, other.conditions);
                        }
                        conditions = t3;
                    }
                    type = ourType;
                }
                t2 = type == ourType ? t2 : t5;
                return new A.MediaQuerySuccessfulMergeResult0(A.CssMediaQuery$type0(t2, conditions, modifier == ourModifier ? t1 : t4));
            },
            $eq: function(_, other) {
                if (other == null) return false;
                return other instanceof A.CssMediaQuery0 && other.modifier == this.modifier && other.type == this.type && B.C_ListEquality.equals$2(0, other.conditions, this.conditions);
            },
            get$hashCode: function(_) {
                return J.get$hashCode$(this.modifier) ^ J.get$hashCode$(this.type) ^ B.C_ListEquality0.hash$1(this.conditions);
            },
            toString$0: function(_) {
                var t2, _this = this, t1 = _this.modifier;
                t1 = t1 != null ? t1 + " " : "";
                t2 = _this.type;
                if (t2 != null) {
                    t1 += t2;
                    if (_this.conditions.length !== 0) t1 += " and ";
                }
                t2 = _this.conjunction ? " and " : " or ";
                t2 = t1 + B.JSArray_methods.join$1(_this.conditions, t2);
                return t2.charCodeAt(0) == 0 ? t2 : t2;
            }
        };
        A._SingletonCssMediaQueryMergeResult0.prototype = {
            _enumToString$0: function() {
                return "_SingletonCssMediaQueryMergeResult." + this._name;
            }
        };
        A.MediaQuerySuccessfulMergeResult0.prototype = {
            toString$0: function(_) {
                return this.query.toString$0(0);
            }
        };
        A.MediaQueryParser0.prototype = {
            parse$0: function(_) {
                return this.wrapSpanFormatException$1(new A.MediaQueryParser_parse_closure0(this));
            },
            _media_query$_mediaQuery$0: function() {
                var conditions, conjunction, t1, identifier1, identifier2, type, modifier, _this = this, _null = null, _s3_ = "and";
                if (_this.scanner.peekChar$0() === 40) {
                    conditions = A._setArrayType([
                        _this._media_query$_mediaInParens$0()
                    ], type$.JSArray_String);
                    _this.whitespace$1$consumeNewlines(true);
                    if (_this.scanIdentifier$1(_s3_)) {
                        _this.expectWhitespace$0();
                        B.JSArray_methods.addAll$1(conditions, _this._media_query$_mediaLogicSequence$1(_s3_));
                        conjunction = true;
                    } else {
                        t1 = _this.scanIdentifier$1("or");
                        if (t1) {
                            _this.expectWhitespace$0();
                            B.JSArray_methods.addAll$1(conditions, _this._media_query$_mediaLogicSequence$1("or"));
                        }
                        conjunction = !t1;
                    }
                    return A.CssMediaQuery$condition0(conditions, conjunction);
                }
                identifier1 = _this.identifier$0();
                if (A.equalsIgnoreCase0(identifier1, "not")) {
                    _this.expectWhitespace$0();
                    if (!_this.lookingAtIdentifier$0()) return A.CssMediaQuery$condition0(A._setArrayType([
                        "(not " + _this._media_query$_mediaInParens$0() + ")"
                    ], type$.JSArray_String), _null);
                }
                _this.whitespace$1$consumeNewlines(true);
                if (!_this.lookingAtIdentifier$0()) return A.CssMediaQuery$type0(identifier1, _null, _null);
                identifier2 = _this.identifier$0();
                if (A.equalsIgnoreCase0(identifier2, _s3_)) {
                    _this.expectWhitespace$0();
                    type = identifier1;
                    modifier = _null;
                } else {
                    _this.whitespace$1$consumeNewlines(true);
                    if (_this.scanIdentifier$1(_s3_)) _this.expectWhitespace$0();
                    else return A.CssMediaQuery$type0(identifier2, _null, identifier1);
                    type = identifier2;
                    modifier = identifier1;
                }
                if (_this.scanIdentifier$1("not")) {
                    _this.expectWhitespace$0();
                    return A.CssMediaQuery$type0(type, A._setArrayType([
                        "(not " + _this._media_query$_mediaInParens$0() + ")"
                    ], type$.JSArray_String), modifier);
                }
                return A.CssMediaQuery$type0(type, _this._media_query$_mediaLogicSequence$1(_s3_), modifier);
            },
            _media_query$_mediaLogicSequence$1: function(operator) {
                var t1, t2, _this = this, result = A._setArrayType([], type$.JSArray_String);
                for(t1 = _this.scanner;;){
                    t1.expectChar$2$name(40, "media condition in parentheses");
                    t2 = _this.declarationValue$0();
                    t1.expectChar$1(41);
                    result.push("(" + t2 + ")");
                    _this.whitespace$1$consumeNewlines(true);
                    if (!_this.scanIdentifier$1(operator)) return result;
                    _this.expectWhitespace$0();
                }
            },
            _media_query$_mediaInParens$0: function() {
                var t2, t1 = this.scanner;
                t1.expectChar$2$name(40, "media condition in parentheses");
                t2 = this.declarationValue$0();
                t1.expectChar$1(41);
                return "(" + t2 + ")";
            }
        };
        A.MediaQueryParser_parse_closure0.prototype = {
            call$0: function() {
                var queries = A._setArrayType([], type$.JSArray_CssMediaQuery_2), t1 = this.$this, t2 = t1.scanner;
                do {
                    t1.whitespace$1$consumeNewlines(true);
                    queries.push(t1._media_query$_mediaQuery$0());
                    t1.whitespace$1$consumeNewlines(true);
                }while (t2.scanChar$1(44));
                t2.expectDone$0();
                return queries;
            },
            $signature: 535
        };
        A.ModifiableCssMediaRule0.prototype = {
            accept$1$1: function(visitor) {
                return visitor.visitCssMediaRule$1(this);
            },
            accept$1: function(visitor) {
                return this.accept$1$1(visitor, type$.dynamic);
            },
            equalsIgnoringChildren$1: function(other) {
                return other instanceof A.ModifiableCssMediaRule0 && B.C_ListEquality.equals$2(0, this.queries, other.queries);
            },
            copyWithoutChildren$0: function() {
                return A.ModifiableCssMediaRule$0(this.queries, this.span);
            },
            get$span: function(receiver) {
                return this.span;
            }
        };
        A.MediaRule0.prototype = {
            accept$1$1: function(visitor) {
                return visitor.visitMediaRule$1(0, this);
            },
            accept$1: function(visitor) {
                return this.accept$1$1(visitor, type$.dynamic);
            },
            toString$0: function(_) {
                return "@media " + this.query.toString$0(0) + " {" + B.JSArray_methods.join$1(this.children, " ") + "}";
            },
            get$span: function(receiver) {
                return this.span;
            }
        };
        A.MergedExtension0.prototype = {
            unmerge$0: function() {
                return new A._SyncStarIterable(this.unmerge$body$MergedExtension0(), type$._SyncStarIterable_Extension_2);
            },
            unmerge$body$MergedExtension0: function() {
                var $async$self = this;
                return function() {
                    var $async$goto = 0, $async$handler = 1, $async$errorStack = [], right, left;
                    return function $async$unmerge$0($async$iterator, $async$errorCode, $async$result) {
                        if ($async$errorCode === 1) {
                            $async$errorStack.push($async$result);
                            $async$goto = $async$handler;
                        }
                        for(;;)switch($async$goto){
                            case 0:
                                // Function start
                                left = $async$self.left;
                                $async$goto = left instanceof A.MergedExtension0 ? 2 : 4;
                                break;
                            case 2:
                                // then
                                $async$goto = 5;
                                return $async$iterator._yieldStar$1(left.unmerge$0());
                            case 5:
                                // after yield
                                // goto join
                                $async$goto = 3;
                                break;
                            case 4:
                                // else
                                $async$goto = 6;
                                return $async$iterator._async$_current = left, 1;
                            case 6:
                            // after yield
                            case 3:
                                // join
                                right = $async$self.right;
                                $async$goto = right instanceof A.MergedExtension0 ? 7 : 9;
                                break;
                            case 7:
                                // then
                                $async$goto = 10;
                                return $async$iterator._yieldStar$1(right.unmerge$0());
                            case 10:
                                // after yield
                                // goto join
                                $async$goto = 8;
                                break;
                            case 9:
                                // else
                                $async$goto = 11;
                                return $async$iterator._async$_current = right, 1;
                            case 11:
                            // after yield
                            case 8:
                                // join
                                // implicit return
                                return 0;
                            case 1:
                                // rethrow
                                return $async$iterator._datum = $async$errorStack.at(-1), 3;
                        }
                    };
                };
            }
        };
        A.MergedMapView0.prototype = {
            get$keys: function(_) {
                var t1 = this._merged_map_view$_mapsByKey;
                return new A.LinkedHashMapKeysIterable(t1, A._instanceType(t1)._eval$1("LinkedHashMapKeysIterable<1>"));
            },
            get$length: function(_) {
                return this._merged_map_view$_mapsByKey.__js_helper$_length;
            },
            get$isEmpty: function(_) {
                return this._merged_map_view$_mapsByKey.__js_helper$_length === 0;
            },
            get$isNotEmpty: function(_) {
                return this._merged_map_view$_mapsByKey.__js_helper$_length !== 0;
            },
            MergedMapView$10: function(maps, $K, $V) {
                var t1, t2, _i, map, t3, t4;
                for(t1 = maps.length, t2 = this._merged_map_view$_mapsByKey, _i = 0; _i < maps.length; maps.length === t1 || (0, A.throwConcurrentModificationError)(maps), ++_i){
                    map = maps[_i];
                    if (map instanceof A.MergedMapView0) for(t3 = map._merged_map_view$_mapsByKey, t3 = new A.LinkedHashMapValueIterator(t3, t3._modifications, t3._first); t3.moveNext$0();){
                        t4 = t3.__js_helper$_current;
                        A.setAll0(t2, t4.get$keys(t4), t4);
                    }
                    else A.setAll0(t2, map.get$keys(map), map);
                }
            },
            $index: function(_, key) {
                var t1 = this._merged_map_view$_mapsByKey.$index(0, this.$ti._precomputed1._as(key));
                return t1 == null ? null : t1.$index(0, key);
            },
            $indexSet: function(_, key, value) {
                var _0_0 = this._merged_map_view$_mapsByKey.$index(0, key);
                if (_0_0 != null) _0_0.$indexSet(0, key, value);
                else throw A.wrapException(A.UnsupportedError$(string$.New_en));
            },
            remove$1: function(_, key) {
                throw A.wrapException(A.UnsupportedError$(string$.Entrie));
            },
            containsKey$1: function(key) {
                return this._merged_map_view$_mapsByKey.containsKey$1(key);
            }
        };
        A._shared_closure3.prototype = {
            call$1: function($arguments) {
                A.warnForDeprecation0(string$.The_fe, B.Deprecation_p2t);
                return $._features0.contains$1(0, J.$index$asx($arguments, 0).assertString$1("feature")._string0$_text) ? B.SassBoolean_true0 : B.SassBoolean_false0;
            },
            $signature: 13
        };
        A._shared_closure4.prototype = {
            call$1: function($arguments) {
                return new A.SassString0(A.serializeValue0(J.get$first$ax($arguments), true, true), false);
            },
            $signature: 18
        };
        A._shared_closure5.prototype = {
            call$1: function($arguments) {
                var t1 = J.getInterceptor$asx($arguments), _0_0 = t1.$index($arguments, 0);
                $label0$0: {
                    if (_0_0 instanceof A.SassArgumentList0) {
                        t1 = "arglist";
                        break $label0$0;
                    }
                    if (_0_0 instanceof A.SassBoolean0) {
                        t1 = "bool";
                        break $label0$0;
                    }
                    if (_0_0 instanceof A.SassColor0) {
                        t1 = "color";
                        break $label0$0;
                    }
                    if (_0_0 instanceof A.SassList0) {
                        t1 = "list";
                        break $label0$0;
                    }
                    if (_0_0 instanceof A.SassMap0) {
                        t1 = "map";
                        break $label0$0;
                    }
                    if (B.C__SassNull0 === _0_0) {
                        t1 = "null";
                        break $label0$0;
                    }
                    if (_0_0 instanceof A.SassNumber0) {
                        t1 = "number";
                        break $label0$0;
                    }
                    if (_0_0 instanceof A.SassFunction0) {
                        t1 = "function";
                        break $label0$0;
                    }
                    if (_0_0 instanceof A.SassMixin0) {
                        t1 = "mixin";
                        break $label0$0;
                    }
                    if (_0_0 instanceof A.SassCalculation0) {
                        t1 = "calculation";
                        break $label0$0;
                    }
                    if (_0_0 instanceof A.SassString0) {
                        t1 = "string";
                        break $label0$0;
                    }
                    t1 = A.throwExpression("[BUG] Unknown value type " + t1.$index($arguments, 0).toString$0(0));
                }
                return new A.SassString0(t1, false);
            },
            $signature: 18
        };
        A._shared_closure6.prototype = {
            call$1: function($arguments) {
                var t2, t3, t4, t1 = J.getInterceptor$asx($arguments), _1_0 = t1.$index($arguments, 0);
                if (_1_0 instanceof A.SassArgumentList0) {
                    _1_0._argument_list$_wereKeywordsAccessed = true;
                    t1 = type$.Value_2;
                    t2 = A.LinkedHashMap_LinkedHashMap$_empty(t1, t1);
                    for(t3 = A.MapExtensions_get_pairs0(_1_0._argument_list$_keywords, type$.String, t1), t3 = t3.get$iterator(t3); t3.moveNext$0();){
                        t4 = t3.get$current(t3);
                        t2.$indexSet(0, new A.SassString0(t4._0, false), t4._1);
                    }
                    return new A.SassMap0(A.ConstantMap_ConstantMap$from(t2, t1, t1));
                } else throw A.wrapException("$args: " + t1.$index($arguments, 0).toString$0(0) + " is not an argument list.");
            },
            $signature: 34
        };
        A.moduleFunctions_closure2.prototype = {
            call$1: function($arguments) {
                return new A.SassString0(J.$index$asx($arguments, 0).assertCalculation$1("calc").name, true);
            },
            $signature: 18
        };
        A.moduleFunctions_closure3.prototype = {
            call$1: function($arguments) {
                var t1 = J.$index$asx($arguments, 0).assertCalculation$1("calc").$arguments;
                return A.SassList$0(new A.MappedListIterable(t1, new A.moduleFunctions__closure0(), A._arrayInstanceType(t1)._eval$1("MappedListIterable<1,Value0>")), B.ListSeparator_z0K0, false);
            },
            $signature: 27
        };
        A.moduleFunctions__closure0.prototype = {
            call$1: function(argument) {
                return argument instanceof A.Value0 ? argument : new A.SassString0(J.toString$0$(argument), false);
            },
            $signature: 536
        };
        A.moduleFunctions_closure4.prototype = {
            call$1: function($arguments) {
                var _0_2_isSet, _0_2, acceptsContent, t1, _0_5_isSet, _0_5, hasContent, _null = null, mixin = J.$index$asx($arguments, 0).assertMixin$1("mixin"), _0_0 = mixin.callable;
                $label0$0: {
                    _0_2_isSet = type$.AsyncBuiltInCallable_2._is(_0_0);
                    _0_2 = _null;
                    acceptsContent = _null;
                    if (_0_2_isSet) {
                        _0_2 = _0_0.get$acceptsContent();
                        acceptsContent = _0_2;
                    }
                    if (!_0_2_isSet) {
                        _0_2_isSet = _0_0 instanceof A.BuiltInCallable0;
                        if (_0_2_isSet) acceptsContent = _0_0.acceptsContent;
                        t1 = _0_2_isSet;
                    } else t1 = true;
                    if (t1) {
                        t1 = acceptsContent;
                        break $label0$0;
                    }
                    _0_5_isSet = _0_0 instanceof A.UserDefinedCallable0;
                    _0_5 = _null;
                    if (_0_5_isSet) {
                        _0_5 = _0_0.declaration;
                        t1 = _0_5;
                        t1 = t1 instanceof A.MixinRule0;
                    } else t1 = false;
                    if (t1) {
                        t1 = _0_5_isSet ? _0_5 : _0_0.declaration;
                        hasContent = type$.MixinRule_2._as(t1).get$hasContent();
                        t1 = hasContent;
                        break $label0$0;
                    }
                    t1 = A.throwExpression(A.UnsupportedError$("Unknown callable type " + mixin.toString$0(0) + "."));
                }
                return t1 ? B.SassBoolean_true0 : B.SassBoolean_false0;
            },
            $signature: 13
        };
        A.mixinClass_closure.prototype = {
            call$0: function() {
                var t1 = type$.JSClass, jsClass = t1._as(A.allowInteropCaptureThisNamed("sass.SassMixin", new A.mixinClass__closure()));
                A.JSClassExtension_injectSuperclass(t1._as(new A.SassMixin0(A.BuiltInCallable$function0("f", "", new A.mixinClass__closure0(), null), null).constructor), jsClass);
                return jsClass;
            },
            $signature: 17
        };
        A.mixinClass__closure.prototype = {
            call$1: function($self) {
                A.jsThrow(new self.Error("It is not possible to construct a SassMixin through the JavaScript API"));
            },
            $signature: 537
        };
        A.mixinClass__closure0.prototype = {
            call$1: function(_) {
                return B.C__SassNull0;
            },
            $signature: 3
        };
        A.SassMixin0.prototype = {
            accept$1$1: function(visitor) {
                var t1, t2;
                if (!visitor._serialize0$_inspect) A.throwExpression(A.SassScriptException$0(this.toString$0(0) + " isn't a valid CSS value.", null));
                t1 = visitor._serialize0$_buffer;
                t1.write$1(0, "get-mixin(");
                t2 = this.callable;
                visitor._serialize0$_visitQuotedString$1(t2.get$name(t2));
                t1.writeCharCode$1(41);
                return null;
            },
            accept$1: function(visitor) {
                return this.accept$1$1(visitor, type$.dynamic);
            },
            assertMixin$1: function($name) {
                return this;
            },
            assertCompileContext$1: function(compileContext) {
                var t1 = this._mixin0$_compileContext;
                if (t1 != null) t1 = t1 !== compileContext;
                else t1 = false;
                if (t1) throw A.wrapException(A.SassScriptException$0(this.toString$0(0) + " does not belong to current compilation.", null));
                return this;
            },
            $eq: function(_, other) {
                if (other == null) return false;
                return other instanceof A.SassMixin0 && this.callable.$eq(0, other.callable);
            },
            get$hashCode: function(_) {
                var t1 = this.callable;
                return t1.get$hashCode(t1);
            }
        };
        A.MixinRule0.prototype = {
            get$hasContent: function() {
                var result, _this = this, value = _this._mixin_rule$__MixinRule_hasContent_FI;
                if (value === $) {
                    result = J.$eq$(B.C__HasContentVisitor0.visitChildren$1(_this.children), true);
                    _this._mixin_rule$__MixinRule_hasContent_FI !== $ && A.throwUnnamedLateFieldADI();
                    _this._mixin_rule$__MixinRule_hasContent_FI = result;
                    value = result;
                }
                return value;
            },
            accept$1$1: function(visitor) {
                return visitor.visitMixinRule$1(0, this);
            },
            accept$1: function(visitor) {
                return this.accept$1$1(visitor, type$.dynamic);
            },
            toString$0: function(_) {
                var t1 = "@mixin " + this.name, t2 = this.parameters;
                if (!(t2.parameters.length === 0 && t2.restParameter == null)) t1 += "(" + t2.toString$0(0) + ")";
                t1 += " {" + B.JSArray_methods.join$1(this.children, " ") + "}";
                return t1.charCodeAt(0) == 0 ? t1 : t1;
            }
        };
        A._HasContentVisitor0.prototype = {
            visitContentRule$1: function(_, _0) {
                return true;
            },
            $isStatementVisitor: 1
        };
        A.__HasContentVisitor_Object_StatementSearchVisitor0.prototype = {};
        A.ExtendMode0.prototype = {
            _enumToString$0: function() {
                return "ExtendMode." + this._name;
            },
            toString$0: function(_) {
                return this.name;
            }
        };
        A.JSModule0.prototype = {};
        A.JSModuleRequire0.prototype = {};
        A.MultiSpan0.prototype = {
            get$start: function(_) {
                var t1 = this._multi_span0$_primary;
                return t1.get$start(t1);
            },
            get$end: function(_) {
                var t1 = this._multi_span0$_primary;
                return t1.get$end(t1);
            },
            get$text: function() {
                return this._multi_span0$_primary.get$text();
            },
            get$context: function(_) {
                var t1 = this._multi_span0$_primary;
                return t1.get$context(t1);
            },
            get$file: function(_) {
                var t1 = this._multi_span0$_primary;
                return t1.get$file(t1);
            },
            get$length: function(_) {
                var t1 = this._multi_span0$_primary;
                return t1.get$length(t1);
            },
            get$sourceUrl: function(_) {
                var t1 = this._multi_span0$_primary;
                return t1.get$sourceUrl(t1);
            },
            compareTo$1: function(_, other) {
                return this._multi_span0$_primary.compareTo$1(0, other);
            },
            toString$0: function(_) {
                return this._multi_span0$_primary.toString$0(0);
            },
            expand$1: function(_, other) {
                return new A.MultiSpan0(this._multi_span0$_primary.expand$1(0, other), this.primaryLabel, this.secondarySpans);
            },
            highlight$1$color: function(color) {
                return A.Highlighter$multiple(this._multi_span0$_primary, this.primaryLabel, this.secondarySpans, color === true, null, null).highlight$0();
            },
            message$2$color: function(_, message, color) {
                var t1 = J.$eq$(color, true) || typeof color == "string", t2 = typeof color == "string" ? color : null;
                return A.SourceSpanExtension_messageMultiple(this._multi_span0$_primary, message, this.primaryLabel, this.secondarySpans, t1, t2, null);
            },
            message$1: function(_, message) {
                return this.message$2$color(0, message, null);
            },
            $isComparable: 1,
            $isFileSpan: 1,
            $isSourceSpan: 1,
            $isSourceSpanWithContext: 1
        };
        A.SupportsNegation0.prototype = {
            toInterpolation$0: function() {
                var t1 = new A.StringBuffer(""), t2 = new A.InterpolationBuffer0(t1, A._setArrayType([], type$.JSArray_Object), A._setArrayType([], type$.JSArray_nullable_FileSpan)), t3 = this.span, t4 = this.condition, t5 = A.SpanExtensions_before(t3, t4.get$span(t4));
                t5 = A.String_String$fromCharCodes(B.NativeUint32List_methods.sublist$2(t5.file._decodedChars, t5._file$_start, t5._end), 0, null);
                t1._contents += t5;
                t2.addInterpolation$1(t4.toInterpolation$0());
                t4 = A.SpanExtensions_after(t3, t4.get$span(t4));
                t4 = A.String_String$fromCharCodes(B.NativeUint32List_methods.sublist$2(t4.file._decodedChars, t4._file$_start, t4._end), 0, null);
                t1._contents += t4;
                return t2.interpolation$1(t3);
            },
            withSpan$1: function(span) {
                return new A.SupportsNegation0(this.condition, span);
            },
            toString$0: function(_) {
                var t1 = this.condition;
                if (t1 instanceof A.SupportsNegation0 || t1 instanceof A.SupportsOperation0) return "not (" + t1.toString$0(0) + ")";
                else return "not " + t1.toString$0(0);
            },
            $isAstNode0: 1,
            $isSassNode: 1,
            $isSupportsCondition: 1,
            get$span: function(receiver) {
                return this.span;
            }
        };
        A.NoOpImporter0.prototype = {
            canonicalize$1: function(_, url) {
                return null;
            },
            load$1: function(_, url) {
                return null;
            },
            toString$0: function(_) {
                return "(unknown)";
            }
        };
        A.NoSourceMapBuffer0.prototype = {
            get$length: function(_) {
                return this._no_source_map_buffer0$_buffer._contents.length;
            },
            forSpan$1$2: function(span, callback) {
                return callback.call$0();
            },
            forSpan$2: function(span, callback) {
                return this.forSpan$1$2(span, callback, type$.dynamic);
            },
            write$1: function(_, object) {
                var t1 = this._no_source_map_buffer0$_buffer, t2 = A.S(object);
                t1._contents += t2;
                return null;
            },
            writeCharCode$1: function(charCode) {
                var t1 = this._no_source_map_buffer0$_buffer, t2 = A.Primitives_stringFromCharCode(charCode);
                t1._contents += t2;
                return null;
            },
            toString$0: function(_) {
                var t1 = this._no_source_map_buffer0$_buffer._contents;
                return t1.charCodeAt(0) == 0 ? t1 : t1;
            },
            buildSourceMap$1$prefix: function(prefix) {
                return A.throwExpression(A.UnsupportedError$(string$.NoSour));
            }
        };
        A._FakeAstNode0.prototype = {
            get$span: function(_) {
                return this._node0$_callback.call$0();
            },
            $isAstNode0: 1
        };
        A.CssNode0.prototype = {
            toString$0: function(_) {
                var _null = null;
                return A.serialize0(this, true, _null, true, _null, _null, false, _null, true)._0;
            },
            $isAstNode0: 1
        };
        A.CssParentNode0.prototype = {};
        A._IsInvisibleVisitor1.prototype = {
            visitCssAtRule$1: function(rule) {
                return false;
            },
            visitCssComment$1: function(comment) {
                return this.includeComments && comment.text.charCodeAt(2) !== 33;
            },
            visitCssStyleRule$1: function(rule) {
                var t1 = rule._style_rule0$_selector._box0$_inner;
                return (this.includeBogus ? t1.value.accept$1(B._IsInvisibleVisitor_true0) : t1.value.accept$1(B._IsInvisibleVisitor_false0)) || this.super$EveryCssVisitor$visitCssStyleRule0(rule);
            }
        };
        A.__IsInvisibleVisitor_Object_EveryCssVisitor0.prototype = {};
        A.ModifiableCssNode0.prototype = {
            get$hasFollowingSibling: function() {
                var t2, t1 = this._node$_parent;
                if (t1 == null) t1 = null;
                else {
                    t1 = t1.children;
                    t2 = this._node$_indexInParent;
                    t2.toString;
                    t1 = A.SubListIterable$(t1, t2 + 1, null, t1.$ti._eval$1("ListBase.E")).any$1(0, new A.ModifiableCssNode_hasFollowingSibling_closure0());
                }
                return t1 === true;
            },
            get$isGroupEnd: function() {
                return this.isGroupEnd;
            }
        };
        A.ModifiableCssNode_hasFollowingSibling_closure0.prototype = {
            call$1: function(sibling) {
                return !sibling.accept$1(B._IsInvisibleVisitor_true_false0);
            },
            $signature: 538
        };
        A.ModifiableCssParentNode0.prototype = {
            get$isChildless: function() {
                return false;
            },
            addChild$1: function(child) {
                var t1;
                child._node$_parent = this;
                t1 = this._node$_children;
                child._node$_indexInParent = t1.length;
                t1.push(child);
            },
            clearChildren$0: function() {
                var t1, t2, _i, child;
                for(t1 = this._node$_children, t2 = t1.length, _i = 0; _i < t2; ++_i){
                    child = t1[_i];
                    child._node$_indexInParent = child._node$_parent = null;
                }
                B.JSArray_methods.clear$0(t1);
            },
            $isCssParentNode0: 1,
            get$children: function(receiver) {
                return this.children;
            }
        };
        A.NodePackageImporter0.prototype = {
            isNonCanonicalScheme$1: function(scheme) {
                return scheme === "pkg";
            },
            canonicalize$1: function(_, url) {
                var packageName, jsonPath, jsonString, packageManifest, e, t1, t2, t3, t4, baseDirectory, parts, t5, $name, subpath, packageRoot, _$exception, _1_0, rootPath, subpathInRoot, _this = this, _null = null;
                if (url.get$scheme() === "file") return $.$get$FilesystemImporter_cwd0().canonicalize$1(0, url);
                if (url.get$scheme() !== "pkg") return _null;
                if (url.get$hasAuthority()) throw A.wrapException(string$.A_pkg_h);
                else {
                    t1 = $.$get$url();
                    t2 = t1.style;
                    if (t2.rootLength$1(url.get$path(url)) > 0) throw A.wrapException("A pkg: URL's path must not begin with /.");
                    else if (url.get$path(url).length === 0) throw A.wrapException("A pkg: URL must not have an empty path.");
                    else if (url.get$hasQuery() || url.get$hasFragment()) throw A.wrapException(string$.A_pkg_q);
                }
                t3 = A.canonicalizeContext0();
                t3._canonicalize_context$_wasContainingUrlAccessed = true;
                t3 = t3._canonicalize_context$_containingUrl;
                if ((t3 == null ? _null : t3.get$scheme()) === "file") {
                    t3 = A.canonicalizeContext0();
                    t3._canonicalize_context$_wasContainingUrlAccessed = true;
                    t3 = t3._canonicalize_context$_containingUrl;
                    t3.toString;
                    t4 = $.$get$context();
                    baseDirectory = t4.dirname$1(t4.style.pathFromUri$1(A._parseUri(t3)));
                } else {
                    t3 = _this._node_package$__NodePackageImporter__entryPointDirectory_F;
                    t3 === $ && A.throwUnnamedLateFieldNI();
                    baseDirectory = t3;
                }
                packageName = null;
                parts = t1.split$1(0, url.get$path(url));
                t3 = B.JSArray_methods.removeAt$1(parts, 0);
                t4 = $.$get$context();
                t5 = t4.style;
                $name = t5.pathFromUri$1(A._parseUri(t3));
                if (B.JSString_methods.startsWith$1($name, "@")) $name = parts.length !== 0 ? t1.join$2(0, $name, B.JSArray_methods.removeAt$1(parts, 0)) : $name;
                subpath = parts.length !== 0 ? t5.pathFromUri$1(A._parseUri(t1.joinAll$1(parts))) : _null;
                packageName = $name;
                t1 = true;
                if (!J.startsWith$1$s(packageName, ".")) {
                    if (!J.contains$1$asx(packageName, "\\")) {
                        if (!J.contains$1$asx(packageName, "%")) t1 = J.startsWith$1$s(packageName, "@") && !J.contains$1$asx(packageName, t2.get$separator(t2));
                    }
                }
                if (t1) return _null;
                packageRoot = _this._node_package$_resolvePackageRoot$2(packageName, baseDirectory);
                if (packageRoot == null) return _null;
                jsonPath = A.join(packageRoot, "package.json", _null);
                jsonString = A.readFile0(jsonPath);
                packageManifest = null;
                try {
                    packageManifest = type$.Map_String_dynamic._as(B.C_JsonCodec.decode$1(jsonString));
                } catch (exception) {
                    e = A.unwrapException(exception);
                    t1 = A.S(jsonPath);
                    t2 = A.S(packageName);
                    t3 = A.S(e);
                    throw A.wrapException("Failed to parse " + t1 + ' for "pkg:' + t2 + '": ' + t3);
                }
                _1_0 = _this._node_package$_resolvePackageExports$4(packageRoot, subpath, packageManifest, packageName);
                if (_1_0 != null) {
                    if (B.Set_FTDN4.contains$1(0, A.ParsedPath_ParsedPath$parse(_1_0, t5)._splitExtension$1(1)[1])) return t4.toUri$1(t4.canonicalize$1(0, _this._node_package$_resolveImportOnly$1(_1_0)));
                    else {
                        t1 = subpath == null ? "root" : subpath;
                        throw A.wrapException("The export for '" + t1 + "' in '" + A.S(packageName) + "' resolved to '" + _1_0 + string$.x27x2c_whi);
                    }
                }
                if (subpath == null) {
                    rootPath = _this._node_package$_resolvePackageRootValues$2(packageRoot, packageManifest);
                    return rootPath != null ? t4.toUri$1(t4.canonicalize$1(0, rootPath)) : _null;
                }
                subpathInRoot = A.join(packageRoot, subpath, _null);
                return $.$get$FilesystemImporter_cwd0().canonicalize$1(0, t4.toUri$1(subpathInRoot));
            },
            load$1: function(_, url) {
                return $.$get$FilesystemImporter_cwd0().load$1(0, url);
            },
            _node_package$_resolvePackageRoot$2: function(packageName, baseDirectory) {
                var potentialPackage, t1;
                for(;;){
                    potentialPackage = A.join(baseDirectory, "node_modules", packageName);
                    if (A.dirExists0(potentialPackage)) return potentialPackage;
                    t1 = $.$get$context();
                    if (t1.split$1(0, baseDirectory).length === 1) return null;
                    baseDirectory = t1.dirname$1(baseDirectory);
                }
            },
            _node_package$_resolvePackageRootValues$2: function(packageRoot, packageManifest) {
                var t1, sassValue, _1_0, styleValue, _null = null, _0_0 = packageManifest.$index(0, "sass");
                if (typeof _0_0 == "string") {
                    t1 = B.Set_FTDN4.contains$1(0, A.ParsedPath_ParsedPath$parse(_0_0, $.$get$url().style)._splitExtension$1(1)[1]);
                    sassValue = _0_0;
                } else {
                    sassValue = _null;
                    t1 = false;
                }
                if (t1) return this._node_package$_resolveImportOnly$1(A.join(packageRoot, sassValue, _null));
                else {
                    _1_0 = packageManifest.$index(0, "style");
                    if (typeof _1_0 == "string") {
                        t1 = B.Set_FTDN4.contains$1(0, A.ParsedPath_ParsedPath$parse(_1_0, $.$get$url().style)._splitExtension$1(1)[1]);
                        styleValue = _1_0;
                    } else {
                        styleValue = _null;
                        t1 = false;
                    }
                    if (t1) return this._node_package$_resolveImportOnly$1(A.join(packageRoot, styleValue, _null));
                }
                return A.resolveImportPath0(A.join(packageRoot, "index", _null));
            },
            _node_package$_resolvePackageExports$4: function(packageRoot, subpath, packageManifest, packageName) {
                var _0_0, _1_0, _this = this, exports = packageManifest.$index(0, "exports");
                if (exports == null) return null;
                _0_0 = _this._node_package$_nodePackageExportsResolve$5(packageRoot, _this._node_package$_exportsToCheck$1(subpath), exports, subpath, packageName);
                if (_0_0 != null) return _0_0;
                if (subpath != null && A.ParsedPath_ParsedPath$parse(subpath, $.$get$url().style)._splitExtension$1(1)[1].length !== 0) return null;
                _1_0 = _this._node_package$_nodePackageExportsResolve$5(packageRoot, _this._node_package$_exportsToCheck$2$addIndex(subpath, true), exports, subpath, packageName);
                if (_1_0 != null) return _1_0;
                return null;
            },
            _node_package$_nodePackageExportsResolve$5: function(packageRoot, subpathVariants, exports, subpath, packageName) {
                var t2, matches, _1_1, path, t1 = false;
                if (type$.Map_String_dynamic._is(exports)) {
                    t2 = exports.get$keys(exports);
                    if (t2.any$1(t2, new A.NodePackageImporter__nodePackageExportsResolve_closure3())) {
                        t1 = exports.get$keys(exports);
                        t1 = t1.any$1(t1, new A.NodePackageImporter__nodePackageExportsResolve_closure4());
                    }
                }
                if (t1) {
                    t1 = exports.get$keys(exports);
                    throw A.wrapException("`exports` in " + packageName + string$.x20can_n + t1.map$1$1(t1, new A.NodePackageImporter__nodePackageExportsResolve_closure5(), type$.String).join$1(0, ",") + " in " + A.join(packageRoot, "package.json", null) + ".");
                }
                t1 = type$.NonNullsIterable_String;
                t1 = A.LinkedHashSet_LinkedHashSet$of(new A.NonNullsIterable(new A.MappedListIterable(subpathVariants, new A.NodePackageImporter__nodePackageExportsResolve_closure6(this, exports, packageRoot), A._arrayInstanceType(subpathVariants)._eval$1("MappedListIterable<1,String?>")), t1), t1._eval$1("Iterable.E"));
                matches = A.List_List$_of(t1, A._instanceType(t1)._precomputed1);
                $label0$1: {
                    _1_1 = matches.length;
                    if (_1_1 === 1) {
                        path = matches[0];
                        t1 = path;
                        break $label0$1;
                    }
                    if (_1_1 <= 0) {
                        t1 = null;
                        break $label0$1;
                    }
                    t1 = subpath == null ? "root" : subpath;
                    t1 = A.throwExpression(string$.Unable + t1 + " in " + packageName + " should be used. \n\nFound:\n" + B.JSArray_methods.join$1(matches, "\n"));
                }
                return t1;
            },
            _node_package$_resolveImportOnly$1: function(path) {
                var t1, extension, importOnly;
                if (!A.fromImport0()) return path;
                t1 = $.$get$context();
                extension = A.ParsedPath_ParsedPath$parse(path, t1.style)._splitExtension$1(1)[1];
                importOnly = t1.withoutExtension$1(path) + ".import" + extension;
                return A.fileExists0(importOnly) ? importOnly : path;
            },
            _node_package$_compareExpansionKeys$2: function(keyA, keyB) {
                var t1 = B.JSString_methods.contains$1(keyA, "*"), baseLengthA = t1 ? B.JSString_methods.indexOf$1(keyA, "*") + 1 : keyA.length, t2 = B.JSString_methods.contains$1(keyB, "*"), baseLengthB = t2 ? B.JSString_methods.indexOf$1(keyB, "*") + 1 : keyB.length;
                if (baseLengthA > baseLengthB) return -1;
                if (baseLengthB > baseLengthA) return 1;
                if (!t1) return 1;
                if (!t2) return -1;
                t1 = keyA.length;
                t2 = keyB.length;
                if (t1 > t2) return -1;
                if (t2 > t1) return 1;
                return 0;
            },
            _node_package$_packageTargetResolve$4: function(subpath, exports, packageRoot, patternMatch) {
                var t2, string, path, map, key, value, _1_0, array, _2_0, _null = null, t1 = typeof exports == "string";
                if (t1) {
                    t2 = !B.JSString_methods.startsWith$1(exports, "./");
                    string = exports;
                } else {
                    string = _null;
                    t2 = false;
                }
                if (t2) throw A.wrapException("Export '" + A.S(string) + string$.x27x20must + packageRoot + "'.");
                if (t1) {
                    t2 = patternMatch != null;
                    string = exports;
                } else {
                    string = _null;
                    t2 = false;
                }
                if (t2) {
                    t1 = J.replaceFirst$2$s(string, "*", patternMatch);
                    t2 = $.$get$context();
                    path = t2.normalize$1(A.join(packageRoot, t2.style.pathFromUri$1(A._parseUri(t1)), _null));
                    return A.fileExists0(path) ? path : _null;
                }
                string = t1 ? exports : _null;
                if (t1) {
                    t1 = $.$get$context();
                    string.toString;
                    return A.join(packageRoot, t1.style.pathFromUri$1(A._parseUri(string)), _null);
                }
                t1 = type$.Map_String_dynamic._is(exports);
                map = t1 ? exports : _null;
                if (t1) {
                    for(t1 = A.MapExtensions_get_pairs(map, type$.String, type$.dynamic), t1 = t1.get$iterator(t1); t1.moveNext$0();){
                        t2 = t1.get$current(t1);
                        key = t2._0;
                        value = t2._1;
                        if (!B.Set_8229z.contains$1(0, key)) continue;
                        if (value == null) continue;
                        _1_0 = this._node_package$_packageTargetResolve$4(subpath, value, packageRoot, patternMatch);
                        if (_1_0 != null) return _1_0;
                    }
                    return _null;
                }
                t1 = type$.List_dynamic._is(exports);
                if (t1 && J.get$length$asx(exports) <= 0) return _null;
                array = t1 ? exports : _null;
                if (t1) {
                    for(t1 = J.get$iterator$ax(array); t1.moveNext$0();){
                        value = t1.get$current(t1);
                        if (value == null) continue;
                        _2_0 = this._node_package$_packageTargetResolve$4(subpath, value, packageRoot, patternMatch);
                        if (_2_0 != null) return _2_0;
                    }
                    return _null;
                }
                throw A.wrapException("Invalid 'exports' value " + A.S(exports) + " in " + A.join(packageRoot, "package.json", _null) + ".");
            },
            _node_package$_packageTargetResolve$3: function(subpath, exports, packageRoot) {
                return this._node_package$_packageTargetResolve$4(subpath, exports, packageRoot, null);
            },
            _node_package$_getMainExport$1: function(exports) {
                var t1, t2, t3, map, _0_4, t4, $export;
                $label0$0: {
                    t1 = null;
                    if (typeof exports == "string") {
                        t1 = exports;
                        break $label0$0;
                    }
                    if (type$.List_String._is(exports)) {
                        t1 = exports;
                        break $label0$0;
                    }
                    t2 = type$.Map_String_dynamic._is(exports);
                    if (t2) {
                        t3 = exports.get$keys(exports);
                        t3 = !t3.any$1(t3, new A.NodePackageImporter__getMainExport_closure0());
                        map = exports;
                    } else {
                        map = t1;
                        t3 = false;
                    }
                    if (t3) {
                        t1 = map;
                        break $label0$0;
                    }
                    t3 = false;
                    if (t2) {
                        _0_4 = exports.$index(0, ".");
                        if (_0_4 == null) t4 = exports.containsKey$1(".");
                        else t4 = true;
                        if (t4) t3 = _0_4 != null;
                    } else _0_4 = null;
                    if (t3) {
                        $export = t2 ? _0_4 : exports.$index(0, ".");
                        t1 = $export;
                        break $label0$0;
                    }
                    break $label0$0;
                }
                return t1;
            },
            _node_package$_exportsToCheck$2$addIndex: function(subpath, addIndex) {
                var basename, dirname, t3, t4, _i, path, t1 = type$.JSArray_String, paths = A._setArrayType([], t1), t2 = subpath == null;
                if (t2 && addIndex) subpath = "index";
                else if (!t2 && addIndex) subpath = A.join(subpath, "index", null);
                if (subpath == null) return A._setArrayType([
                    null
                ], type$.JSArray_nullable_String);
                if (B.Set_FTDN4.contains$1(0, A.ParsedPath_ParsedPath$parse(subpath, $.$get$url().style)._splitExtension$1(1)[1])) paths.push(subpath);
                else B.JSArray_methods.addAll$1(paths, A._setArrayType([
                    subpath,
                    subpath + ".scss",
                    subpath + ".sass",
                    subpath + ".css"
                ], t1));
                t1 = $.$get$context();
                t2 = t1.style;
                basename = A.ParsedPath_ParsedPath$parse(subpath, t2).get$basename();
                dirname = t1.dirname$1(subpath);
                if (B.JSString_methods.startsWith$1(basename, "_")) return paths;
                t1 = A.List_List$_of(paths, type$.nullable_String);
                for(t3 = paths.length, t4 = dirname === ".", _i = 0; _i < paths.length; paths.length === t3 || (0, A.throwConcurrentModificationError)(paths), ++_i){
                    path = paths[_i];
                    if (t4) t1.push("_" + A.ParsedPath_ParsedPath$parse(path, t2).get$basename());
                    else t1.push(A.join(dirname, "_" + A.ParsedPath_ParsedPath$parse(path, t2).get$basename(), null));
                }
                return t1;
            },
            _node_package$_exportsToCheck$1: function(subpath) {
                return this._node_package$_exportsToCheck$2$addIndex(subpath, false);
            }
        };
        A.NodePackageImporter__nodePackageExportsResolve_closure3.prototype = {
            call$1: function(key) {
                return B.JSString_methods.startsWith$1(key, ".");
            },
            $signature: 4
        };
        A.NodePackageImporter__nodePackageExportsResolve_closure4.prototype = {
            call$1: function(key) {
                return !B.JSString_methods.startsWith$1(key, ".");
            },
            $signature: 4
        };
        A.NodePackageImporter__nodePackageExportsResolve_closure5.prototype = {
            call$1: function(key) {
                return '"' + key + '"';
            },
            $signature: 6
        };
        A.NodePackageImporter__nodePackageExportsResolve_closure6.prototype = {
            call$1: function(variant) {
                var t1, t2, matchKey, t3, t4, t5, _i, expansionKey, _0_0, t6, patternBase, patternTrailer, t7, target, _this = this, _null = null;
                if (variant == null) {
                    t1 = _this.$this;
                    return A.NullableExtension_andThen(t1._node_package$_getMainExport$1(_this.exports), new A.NodePackageImporter__nodePackageExportsResolve__closure1(t1, variant, _this.packageRoot));
                } else {
                    t1 = _this.exports;
                    if (type$.Map_String_dynamic._is(t1)) {
                        t2 = t1.get$keys(t1);
                        t2 = t2.every$1(t2, new A.NodePackageImporter__nodePackageExportsResolve__closure2());
                    } else t2 = true;
                    if (t2) return _null;
                }
                matchKey = "./" + $.$get$context().toUri$1(variant).toString$0(0);
                if (t1.containsKey$1(matchKey) && t1.$index(0, matchKey) != null && !B.JSString_methods.contains$1(matchKey, "*")) {
                    t1 = t1.$index(0, matchKey);
                    if (t1 == null) t1 = A._asObject(t1);
                    return _this.$this._node_package$_packageTargetResolve$3(matchKey, t1, _this.packageRoot);
                }
                t2 = A._setArrayType([], type$.JSArray_String);
                for(t3 = t1.get$keys(t1), t3 = t3.get$iterator(t3); t3.moveNext$0();){
                    t4 = t3.get$current(t3);
                    if (B.JSString_methods.allMatches$1("*", t4).get$length(0) === 1) t2.push(t4);
                }
                t3 = _this.$this;
                B.JSArray_methods.sort$1(t2, t3.get$_node_package$_compareExpansionKeys());
                for(t4 = t2.length, t5 = matchKey.length, _i = 0; _i < t2.length; t2.length === t4 || (0, A.throwConcurrentModificationError)(t2), ++_i){
                    expansionKey = t2[_i];
                    _0_0 = expansionKey.split("*");
                    t6 = _0_0.length === 2;
                    if (t6) {
                        patternBase = _0_0[0];
                        patternTrailer = _0_0[1];
                    } else {
                        patternTrailer = _null;
                        patternBase = patternTrailer;
                    }
                    if (!t6) throw A.wrapException(A.StateError$("Pattern matching error"));
                    if (!B.JSString_methods.startsWith$1(matchKey, patternBase)) continue;
                    if (matchKey === patternBase) continue;
                    t6 = patternTrailer.length;
                    if (t6 !== 0) t7 = B.JSString_methods.endsWith$1(matchKey, patternTrailer) && t5 >= expansionKey.length;
                    else t7 = true;
                    if (t7) {
                        target = t1.$index(0, expansionKey);
                        if (target == null) continue;
                        return t3._node_package$_packageTargetResolve$4(variant, target, _this.packageRoot, B.JSString_methods.substring$2(matchKey, patternBase.length, t5 - t6));
                    }
                }
                return _null;
            },
            $signature: 146
        };
        A.NodePackageImporter__nodePackageExportsResolve__closure1.prototype = {
            call$1: function(mainExport) {
                return this.$this._node_package$_packageTargetResolve$3(this.variant, mainExport, this.packageRoot);
            },
            $signature: 147
        };
        A.NodePackageImporter__nodePackageExportsResolve__closure2.prototype = {
            call$1: function(key) {
                return !B.JSString_methods.startsWith$1(key, ".");
            },
            $signature: 4
        };
        A.NodePackageImporter__getMainExport_closure0.prototype = {
            call$1: function(key) {
                return B.JSString_methods.startsWith$1(key, ".");
            },
            $signature: 4
        };
        A.NullExpression0.prototype = {
            accept$1$1: function(visitor) {
                return visitor.visitNullExpression$1(0, this);
            },
            accept$1: function(visitor) {
                return this.accept$1$1(visitor, type$.dynamic);
            },
            toString$0: function(_) {
                return "null";
            },
            get$span: function(receiver) {
                return this.span;
            }
        };
        A.legacyNullClass_closure.prototype = {
            call$0: function() {
                var t1 = type$.JSClass, jsClass = t1._as(A.allowInteropCaptureThisNamed("sass.types.Null", new A.legacyNullClass__closure()));
                jsClass.NULL = B.C__SassNull0;
                A.JSClassExtension_injectSuperclass(t1._as(B.C__SassNull0.constructor), jsClass);
                return jsClass;
            },
            $signature: 17
        };
        A.legacyNullClass__closure.prototype = {
            call$2: function(_, __) {
                throw A.wrapException("new sass.types.Null() isn't allowed. Use sass.types.Null.NULL instead.");
            },
            call$1: function(_) {
                return this.call$2(_, null);
            },
            "call*": "call$2",
            $requiredArgCount: 1,
            $defaultValues: function() {
                return [
                    null
                ];
            },
            $signature: 224
        };
        A._SassNull0.prototype = {
            get$isTruthy: function() {
                return false;
            },
            get$isBlank: function() {
                return true;
            },
            get$realNull: function() {
                return null;
            },
            accept$1$1: function(visitor) {
                if (visitor._serialize0$_inspect) visitor._serialize0$_buffer.write$1(0, "null");
                return null;
            },
            accept$1: function(visitor) {
                return this.accept$1$1(visitor, type$.dynamic);
            },
            unaryNot$0: function() {
                return B.SassBoolean_true0;
            }
        };
        A.NumberExpression0.prototype = {
            accept$1$1: function(visitor) {
                return visitor.visitNumberExpression$1(0, this);
            },
            accept$1: function(visitor) {
                return this.accept$1$1(visitor, type$.dynamic);
            },
            toString$0: function(_) {
                return A.serializeValue0(A.SassNumber_SassNumber0(this.value, this.unit), true, true);
            },
            get$span: function(receiver) {
                return this.span;
            }
        };
        A.numberClass_closure.prototype = {
            call$0: function() {
                var t1 = type$.JSClass, jsClass = t1._as(A.allowInteropCaptureThisNamed("sass.SassNumber", new A.numberClass__closure())), t2 = type$.String, t3 = type$.Function;
                A.LinkedHashMap_LinkedHashMap$_literal([
                    "value",
                    new A.numberClass__closure0(),
                    "isInt",
                    new A.numberClass__closure1(),
                    "asInt",
                    new A.numberClass__closure2(),
                    "numeratorUnits",
                    new A.numberClass__closure3(),
                    "denominatorUnits",
                    new A.numberClass__closure4(),
                    "hasUnits",
                    new A.numberClass__closure5()
                ], t2, t3).forEach$1(0, A.JSClassExtension_get_defineGetter(jsClass));
                A.LinkedHashMap_LinkedHashMap$_literal([
                    "assertInt",
                    new A.numberClass__closure6(),
                    "assertInRange",
                    new A.numberClass__closure7(),
                    "assertNoUnits",
                    new A.numberClass__closure8(),
                    "assertUnit",
                    new A.numberClass__closure9(),
                    "hasUnit",
                    new A.numberClass__closure10(),
                    "compatibleWithUnit",
                    new A.numberClass__closure11(),
                    "convert",
                    new A.numberClass__closure12(),
                    "convertToMatch",
                    new A.numberClass__closure13(),
                    "convertValue",
                    new A.numberClass__closure14(),
                    "convertValueToMatch",
                    new A.numberClass__closure15(),
                    "coerce",
                    new A.numberClass__closure16(),
                    "coerceToMatch",
                    new A.numberClass__closure17(),
                    "coerceValue",
                    new A.numberClass__closure18(),
                    "coerceValueToMatch",
                    new A.numberClass__closure19()
                ], t2, t3).forEach$1(0, A.JSClassExtension_get_defineMethod(jsClass));
                A.JSClassExtension_injectSuperclass(t1._as(self.Object.getPrototypeOf(J.get$$prototype$x(t1._as(A.SassNumber_SassNumber0(0, null).constructor))).constructor), jsClass);
                return jsClass;
            },
            $signature: 17
        };
        A.numberClass__closure.prototype = {
            call$3: function($self, value, unitOrOptions) {
                var t1, t2, _null = null;
                if (typeof unitOrOptions == "string") return A.SassNumber_SassNumber0(value, unitOrOptions);
                type$.nullable__ConstructorOptions_2._as(unitOrOptions);
                t1 = unitOrOptions == null;
                if (t1) t2 = _null;
                else {
                    t2 = A.NullableExtension_andThen0(J.get$numeratorUnits$x(unitOrOptions), A.immutable__jsToDartList$closure());
                    t2 = t2 == null ? _null : J.cast$1$0$ax(t2, type$.String);
                }
                if (t1) t1 = _null;
                else {
                    t1 = A.NullableExtension_andThen0(J.get$denominatorUnits$x(unitOrOptions), A.immutable__jsToDartList$closure());
                    t1 = t1 == null ? _null : J.cast$1$0$ax(t1, type$.String);
                }
                return A.SassNumber_SassNumber$withUnits0(value, t1, t2);
            },
            call$2: function($self, value) {
                return this.call$3($self, value, null);
            },
            "call*": "call$3",
            $requiredArgCount: 2,
            $defaultValues: function() {
                return [
                    null
                ];
            },
            $signature: 539
        };
        A.numberClass__closure0.prototype = {
            call$1: function($self) {
                return $self._number1$_value;
            },
            $signature: 100
        };
        A.numberClass__closure1.prototype = {
            call$1: function($self) {
                return A.fuzzyIsInt0($self._number1$_value);
            },
            $signature: 254
        };
        A.numberClass__closure2.prototype = {
            call$1: function($self) {
                return A.fuzzyAsInt0($self._number1$_value);
            },
            $signature: 541
        };
        A.numberClass__closure3.prototype = {
            call$1: function($self) {
                return new self.immutable.List($self.get$numeratorUnits($self));
            },
            $signature: 255
        };
        A.numberClass__closure4.prototype = {
            call$1: function($self) {
                return new self.immutable.List($self.get$denominatorUnits($self));
            },
            $signature: 255
        };
        A.numberClass__closure5.prototype = {
            call$1: function($self) {
                return $self.get$hasUnits();
            },
            $signature: 254
        };
        A.numberClass__closure6.prototype = {
            call$2: function($self, $name) {
                return $self.assertInt$1($name);
            },
            call$1: function($self) {
                return this.call$2($self, null);
            },
            "call*": "call$2",
            $requiredArgCount: 1,
            $defaultValues: function() {
                return [
                    null
                ];
            },
            $signature: 543
        };
        A.numberClass__closure7.prototype = {
            call$4: function($self, min, max, $name) {
                return $self.valueInRange$3(min, max, $name);
            },
            call$3: function($self, min, max) {
                return this.call$4($self, min, max, null);
            },
            "call*": "call$4",
            $requiredArgCount: 3,
            $defaultValues: function() {
                return [
                    null
                ];
            },
            $signature: 544
        };
        A.numberClass__closure8.prototype = {
            call$2: function($self, $name) {
                $self.assertNoUnits$1($name);
                return $self;
            },
            call$1: function($self) {
                return this.call$2($self, null);
            },
            "call*": "call$2",
            $requiredArgCount: 1,
            $defaultValues: function() {
                return [
                    null
                ];
            },
            $signature: 545
        };
        A.numberClass__closure9.prototype = {
            call$3: function($self, unit, $name) {
                $self.assertUnit$2(unit, $name);
                return $self;
            },
            call$2: function($self, unit) {
                return this.call$3($self, unit, null);
            },
            "call*": "call$3",
            $requiredArgCount: 2,
            $defaultValues: function() {
                return [
                    null
                ];
            },
            $signature: 546
        };
        A.numberClass__closure10.prototype = {
            call$2: function($self, unit) {
                return $self.hasUnit$1(unit);
            },
            $signature: 256
        };
        A.numberClass__closure11.prototype = {
            call$2: function($self, unit) {
                return $self.get$hasUnits() && $self.compatibleWithUnit$1(unit);
            },
            $signature: 256
        };
        A.numberClass__closure12.prototype = {
            call$4: function($self, numeratorUnits, denominatorUnits, $name) {
                var t1 = self.immutable.isOrderedMap(numeratorUnits) ? J.toArray$0$x(type$.ImmutableList._as(numeratorUnits)) : type$.List_dynamic._as(numeratorUnits), t2 = type$.String;
                t1 = J.cast$1$0$ax(t1, t2);
                t2 = J.cast$1$0$ax(self.immutable.isOrderedMap(denominatorUnits) ? J.toArray$0$x(type$.ImmutableList._as(denominatorUnits)) : type$.List_dynamic._as(denominatorUnits), t2);
                return A.SassNumber_SassNumber$withUnits0($self._number1$_coerceOrConvertValue$4$coerceUnitless$name(t1, t2, false, $name), t2, t1);
            },
            call$3: function($self, numeratorUnits, denominatorUnits) {
                return this.call$4($self, numeratorUnits, denominatorUnits, null);
            },
            "call*": "call$4",
            $requiredArgCount: 3,
            $defaultValues: function() {
                return [
                    null
                ];
            },
            $signature: 257
        };
        A.numberClass__closure13.prototype = {
            call$4: function($self, other, $name, otherName) {
                return $self.convertToMatch$3(other, $name, otherName);
            },
            call$2: function($self, other) {
                return this.call$4($self, other, null, null);
            },
            call$3: function($self, other, $name) {
                return this.call$4($self, other, $name, null);
            },
            "call*": "call$4",
            $requiredArgCount: 2,
            $defaultValues: function() {
                return [
                    null,
                    null
                ];
            },
            $signature: 258
        };
        A.numberClass__closure14.prototype = {
            call$4: function($self, numeratorUnits, denominatorUnits, $name) {
                var t1 = self.immutable.isOrderedMap(numeratorUnits) ? J.toArray$0$x(type$.ImmutableList._as(numeratorUnits)) : type$.List_dynamic._as(numeratorUnits), t2 = type$.String;
                t1 = J.cast$1$0$ax(t1, t2);
                return $self._number1$_coerceOrConvertValue$4$coerceUnitless$name(t1, J.cast$1$0$ax(self.immutable.isOrderedMap(denominatorUnits) ? J.toArray$0$x(type$.ImmutableList._as(denominatorUnits)) : type$.List_dynamic._as(denominatorUnits), t2), false, $name);
            },
            call$3: function($self, numeratorUnits, denominatorUnits) {
                return this.call$4($self, numeratorUnits, denominatorUnits, null);
            },
            "call*": "call$4",
            $requiredArgCount: 3,
            $defaultValues: function() {
                return [
                    null
                ];
            },
            $signature: 259
        };
        A.numberClass__closure15.prototype = {
            call$4: function($self, other, $name, otherName) {
                return $self.convertValueToMatch$3(other, $name, otherName);
            },
            call$2: function($self, other) {
                return this.call$4($self, other, null, null);
            },
            call$3: function($self, other, $name) {
                return this.call$4($self, other, $name, null);
            },
            "call*": "call$4",
            $requiredArgCount: 2,
            $defaultValues: function() {
                return [
                    null,
                    null
                ];
            },
            $signature: 260
        };
        A.numberClass__closure16.prototype = {
            call$4: function($self, numeratorUnits, denominatorUnits, $name) {
                var t1 = self.immutable.isOrderedMap(numeratorUnits) ? J.toArray$0$x(type$.ImmutableList._as(numeratorUnits)) : type$.List_dynamic._as(numeratorUnits), t2 = type$.String;
                t1 = J.cast$1$0$ax(t1, t2);
                return $self.coerce$3(t1, J.cast$1$0$ax(self.immutable.isOrderedMap(denominatorUnits) ? J.toArray$0$x(type$.ImmutableList._as(denominatorUnits)) : type$.List_dynamic._as(denominatorUnits), t2), $name);
            },
            call$3: function($self, numeratorUnits, denominatorUnits) {
                return this.call$4($self, numeratorUnits, denominatorUnits, null);
            },
            "call*": "call$4",
            $requiredArgCount: 3,
            $defaultValues: function() {
                return [
                    null
                ];
            },
            $signature: 257
        };
        A.numberClass__closure17.prototype = {
            call$4: function($self, other, $name, otherName) {
                return $self.coerceToMatch$3(other, $name, otherName);
            },
            call$2: function($self, other) {
                return this.call$4($self, other, null, null);
            },
            call$3: function($self, other, $name) {
                return this.call$4($self, other, $name, null);
            },
            "call*": "call$4",
            $requiredArgCount: 2,
            $defaultValues: function() {
                return [
                    null,
                    null
                ];
            },
            $signature: 258
        };
        A.numberClass__closure18.prototype = {
            call$4: function($self, numeratorUnits, denominatorUnits, $name) {
                var t1 = self.immutable.isOrderedMap(numeratorUnits) ? J.toArray$0$x(type$.ImmutableList._as(numeratorUnits)) : type$.List_dynamic._as(numeratorUnits), t2 = type$.String;
                t1 = J.cast$1$0$ax(t1, t2);
                return $self.coerceValue$3(t1, J.cast$1$0$ax(self.immutable.isOrderedMap(denominatorUnits) ? J.toArray$0$x(type$.ImmutableList._as(denominatorUnits)) : type$.List_dynamic._as(denominatorUnits), t2), $name);
            },
            call$3: function($self, numeratorUnits, denominatorUnits) {
                return this.call$4($self, numeratorUnits, denominatorUnits, null);
            },
            "call*": "call$4",
            $requiredArgCount: 3,
            $defaultValues: function() {
                return [
                    null
                ];
            },
            $signature: 259
        };
        A.numberClass__closure19.prototype = {
            call$4: function($self, other, $name, otherName) {
                return $self.coerceValueToMatch$3(other, $name, otherName);
            },
            call$2: function($self, other) {
                return this.call$4($self, other, null, null);
            },
            call$3: function($self, other, $name) {
                return this.call$4($self, other, $name, null);
            },
            "call*": "call$4",
            $requiredArgCount: 2,
            $defaultValues: function() {
                return [
                    null,
                    null
                ];
            },
            $signature: 260
        };
        A._ConstructorOptions0.prototype = {};
        A._NodeSassNumber.prototype = {};
        A.legacyNumberClass_closure.prototype = {
            call$4: function(thisArg, value, unit, dartValue) {
                var t1;
                if (dartValue == null) {
                    value.toString;
                    t1 = A._parseNumber(value, unit);
                } else t1 = dartValue;
                J.set$dartValue$x(thisArg, t1);
            },
            call$2: function(thisArg, value) {
                return this.call$4(thisArg, value, null, null);
            },
            call$3: function(thisArg, value, unit) {
                return this.call$4(thisArg, value, unit, null);
            },
            "call*": "call$4",
            $requiredArgCount: 2,
            $defaultValues: function() {
                return [
                    null,
                    null
                ];
            },
            $signature: 552
        };
        A.legacyNumberClass_closure0.prototype = {
            call$1: function(thisArg) {
                return J.get$dartValue$x(thisArg)._number1$_value;
            },
            $signature: 553
        };
        A.legacyNumberClass_closure1.prototype = {
            call$2: function(thisArg, value) {
                var t1 = J.getInterceptor$x(thisArg), t2 = J.get$numeratorUnits$x(t1.get$dartValue(thisArg));
                t1.set$dartValue(thisArg, A.SassNumber_SassNumber$withUnits0(value, J.get$denominatorUnits$x(t1.get$dartValue(thisArg)), t2));
            },
            $signature: 554
        };
        A.legacyNumberClass_closure2.prototype = {
            call$1: function(thisArg) {
                var t1 = J.getInterceptor$x(thisArg), t2 = B.JSArray_methods.join$1(J.get$numeratorUnits$x(t1.get$dartValue(thisArg)), "*"), t3 = J.get$denominatorUnits$x(t1.get$dartValue(thisArg)).length === 0 ? "" : "/";
                return t2 + t3 + B.JSArray_methods.join$1(J.get$denominatorUnits$x(t1.get$dartValue(thisArg)), "*");
            },
            $signature: 555
        };
        A.legacyNumberClass_closure3.prototype = {
            call$2: function(thisArg, unit) {
                var t1 = J.getInterceptor$x(thisArg);
                t1.set$dartValue(thisArg, A._parseNumber(t1.get$dartValue(thisArg)._number1$_value, unit));
            },
            $signature: 556
        };
        A._parseNumber_closure.prototype = {
            call$1: function(unit) {
                return unit.length === 0;
            },
            $signature: 4
        };
        A._parseNumber_closure0.prototype = {
            call$1: function(unit) {
                return unit.length === 0;
            },
            $signature: 4
        };
        A.SassNumber0.prototype = {
            get$unitString: function() {
                var _this = this;
                return _this.get$hasUnits() ? _this._number1$_unitString$2(_this.get$numeratorUnits(_this), _this.get$denominatorUnits(_this)) : "";
            },
            accept$1$1: function(visitor) {
                return visitor.visitNumber$1(this);
            },
            accept$1: function(visitor) {
                return this.accept$1$1(visitor, type$.dynamic);
            },
            withoutSlash$0: function() {
                var _this = this;
                return _this.asSlash == null ? _this : _this.withValue$1(_this._number1$_value);
            },
            assertNumber$1: function($name) {
                return this;
            },
            assertNumber$0: function() {
                return this.assertNumber$1(null);
            },
            assertInt$1: function($name) {
                var _0_0 = A.fuzzyAsInt0(this._number1$_value);
                if (_0_0 != null) return _0_0;
                throw A.wrapException(A.SassScriptException$0(this.toString$0(0) + " is not an int.", $name));
            },
            assertInt$0: function() {
                return this.assertInt$1(null);
            },
            valueInRange$3: function(min, max, $name) {
                var _this = this, _0_0 = A.fuzzyCheckRange0(_this._number1$_value, min, max);
                if (_0_0 != null) return _0_0;
                throw A.wrapException(A.SassScriptException$0("Expected " + _this.toString$0(0) + " to be within " + A.S(min) + _this.get$unitString() + " and " + A.S(max) + _this.get$unitString() + ".", $name));
            },
            valueInRangeWithUnit$4: function(min, max, $name, unit) {
                var _0_0 = A.fuzzyCheckRange0(this._number1$_value, min, max);
                if (_0_0 != null) return _0_0;
                throw A.wrapException(A.SassScriptException$0("Expected " + this.toString$0(0) + " to be within " + min + unit + " and " + max + unit + ".", $name));
            },
            hasCompatibleUnits$1: function(other) {
                var _this = this;
                if (_this.get$numeratorUnits(_this).length !== other.get$numeratorUnits(other).length) return false;
                if (_this.get$denominatorUnits(_this).length !== other.get$denominatorUnits(other).length) return false;
                return _this.isComparableTo$1(other);
            },
            assertUnit$2: function(unit, $name) {
                if (this.hasUnit$1(unit)) return;
                throw A.wrapException(A.SassScriptException$0("Expected " + this.toString$0(0) + ' to have unit "' + unit + '".', $name));
            },
            assertNoUnits$1: function($name) {
                if (!this.get$hasUnits()) return;
                throw A.wrapException(A.SassScriptException$0("Expected " + this.toString$0(0) + " to have no units.", $name));
            },
            assertNoUnits$0: function() {
                return this.assertNoUnits$1(null);
            },
            convertToMatch$3: function(other, $name, otherName) {
                var t1 = this.convertValueToMatch$3(other, $name, otherName), t2 = other.get$numeratorUnits(other);
                return A.SassNumber_SassNumber$withUnits0(t1, other.get$denominatorUnits(other), t2);
            },
            convertValueToMatch$3: function(other, $name, otherName) {
                return this._number1$_coerceOrConvertValue$6$coerceUnitless$name$other$otherName(other.get$numeratorUnits(other), other.get$denominatorUnits(other), false, $name, other, otherName);
            },
            convertValueToMatch$1: function(other) {
                return this.convertValueToMatch$3(other, null, null);
            },
            coerce$3: function(newNumerators, newDenominators, $name) {
                return A.SassNumber_SassNumber$withUnits0(this.coerceValue$3(newNumerators, newDenominators, $name), newDenominators, newNumerators);
            },
            coerce$2: function(newNumerators, newDenominators) {
                return this.coerce$3(newNumerators, newDenominators, null);
            },
            coerceValue$3: function(newNumerators, newDenominators, $name) {
                return this._number1$_coerceOrConvertValue$4$coerceUnitless$name(newNumerators, newDenominators, true, $name);
            },
            coerceValueToUnit$2: function(unit, $name) {
                var t1 = type$.JSArray_String;
                return this.coerceValue$3(A._setArrayType([
                    unit
                ], t1), A._setArrayType([], t1), $name);
            },
            coerceValueToUnit$1: function(unit) {
                return this.coerceValueToUnit$2(unit, null);
            },
            coerceToMatch$3: function(other, $name, otherName) {
                var t1 = this.coerceValueToMatch$3(other, $name, otherName), t2 = other.get$numeratorUnits(other);
                return A.SassNumber_SassNumber$withUnits0(t1, other.get$denominatorUnits(other), t2);
            },
            coerceValueToMatch$3: function(other, $name, otherName) {
                return this._number1$_coerceOrConvertValue$6$coerceUnitless$name$other$otherName(other.get$numeratorUnits(other), other.get$denominatorUnits(other), true, $name, other, otherName);
            },
            coerceValueToMatch$1: function(other) {
                return this.coerceValueToMatch$3(other, null, null);
            },
            _number1$_coerceOrConvertValue$6$coerceUnitless$name$other$otherName: function(newNumerators, newDenominators, coerceUnitless, $name, other, otherName) {
                var t1, otherHasUnits, t2, compatibilityException, oldNumerators, oldDenominators, _this = this, _box_0 = {};
                if (B.C_ListEquality.equals$2(0, _this.get$numeratorUnits(_this), newNumerators) && B.C_ListEquality.equals$2(0, _this.get$denominatorUnits(_this), newDenominators)) return _this._number1$_value;
                t1 = J.getInterceptor$asx(newNumerators);
                otherHasUnits = t1.get$isNotEmpty(newNumerators) || J.get$isNotEmpty$asx(newDenominators);
                if (coerceUnitless) t2 = !_this.get$hasUnits() || !otherHasUnits;
                else t2 = false;
                if (t2) return _this._number1$_value;
                compatibilityException = new A.SassNumber__coerceOrConvertValue_compatibilityException0(_this, other, otherName, otherHasUnits, $name, newNumerators, newDenominators);
                _box_0.value = _this._number1$_value;
                t2 = _this.get$numeratorUnits(_this);
                oldNumerators = A._setArrayType(t2.slice(0), A._arrayInstanceType(t2));
                for(t1 = t1.get$iterator(newNumerators); t1.moveNext$0();)A.removeFirstWhere0(oldNumerators, new A.SassNumber__coerceOrConvertValue_closure3(_box_0, t1.get$current(t1)), new A.SassNumber__coerceOrConvertValue_closure4(compatibilityException));
                t1 = _this.get$denominatorUnits(_this);
                oldDenominators = A._setArrayType(t1.slice(0), A._arrayInstanceType(t1));
                for(t1 = J.get$iterator$ax(newDenominators); t1.moveNext$0();)A.removeFirstWhere0(oldDenominators, new A.SassNumber__coerceOrConvertValue_closure5(_box_0, t1.get$current(t1)), new A.SassNumber__coerceOrConvertValue_closure6(compatibilityException));
                if (oldNumerators.length !== 0 || oldDenominators.length !== 0) throw A.wrapException(compatibilityException.call$0());
                return _box_0.value;
            },
            _number1$_coerceOrConvertValue$4$coerceUnitless$name: function(newNumerators, newDenominators, coerceUnitless, $name) {
                return this._number1$_coerceOrConvertValue$6$coerceUnitless$name$other$otherName(newNumerators, newDenominators, coerceUnitless, $name, null, null);
            },
            isComparableTo$1: function(other) {
                var _$exception;
                if (!this.get$hasUnits() || !other.get$hasUnits()) return true;
                try {
                    this.greaterThan$1(other);
                    return true;
                } catch (exception) {
                    if (A.unwrapException(exception) instanceof A.SassScriptException0) return false;
                    else throw exception;
                }
            },
            greaterThan$1: function(other) {
                if (other instanceof A.SassNumber0) return this._number1$_coerceUnits$2(other, A.number2__fuzzyGreaterThan$closure()) ? B.SassBoolean_true0 : B.SassBoolean_false0;
                throw A.wrapException(A.SassScriptException$0('Undefined operation "' + this.toString$0(0) + " > " + other.toString$0(0) + '".', null));
            },
            greaterThanOrEquals$1: function(other) {
                if (other instanceof A.SassNumber0) return this._number1$_coerceUnits$2(other, A.number2__fuzzyGreaterThanOrEquals$closure()) ? B.SassBoolean_true0 : B.SassBoolean_false0;
                throw A.wrapException(A.SassScriptException$0('Undefined operation "' + this.toString$0(0) + " >= " + other.toString$0(0) + '".', null));
            },
            lessThan$1: function(other) {
                if (other instanceof A.SassNumber0) return this._number1$_coerceUnits$2(other, A.number2__fuzzyLessThan$closure()) ? B.SassBoolean_true0 : B.SassBoolean_false0;
                throw A.wrapException(A.SassScriptException$0('Undefined operation "' + this.toString$0(0) + " < " + other.toString$0(0) + '".', null));
            },
            lessThanOrEquals$1: function(other) {
                if (other instanceof A.SassNumber0) return this._number1$_coerceUnits$2(other, A.number2__fuzzyLessThanOrEquals$closure()) ? B.SassBoolean_true0 : B.SassBoolean_false0;
                throw A.wrapException(A.SassScriptException$0('Undefined operation "' + this.toString$0(0) + " <= " + other.toString$0(0) + '".', null));
            },
            modulo$1: function(other) {
                if (other instanceof A.SassNumber0) return this.withValue$1(this._number1$_coerceUnits$2(other, A.number2__moduloLikeSass$closure()));
                throw A.wrapException(A.SassScriptException$0('Undefined operation "' + this.toString$0(0) + " % " + other.toString$0(0) + '".', null));
            },
            plus$1: function(other) {
                var _this = this;
                if (other instanceof A.SassNumber0) return _this.withValue$1(_this._number1$_coerceUnits$2(other, new A.SassNumber_plus_closure0()));
                if (!(other instanceof A.SassColor0)) return _this.super$Value$plus0(other);
                throw A.wrapException(A.SassScriptException$0('Undefined operation "' + _this.toString$0(0) + " + " + other.toString$0(0) + '".', null));
            },
            minus$1: function(other) {
                var _this = this;
                if (other instanceof A.SassNumber0) return _this.withValue$1(_this._number1$_coerceUnits$2(other, new A.SassNumber_minus_closure0()));
                if (!(other instanceof A.SassColor0)) return _this.super$Value$minus0(other);
                throw A.wrapException(A.SassScriptException$0('Undefined operation "' + _this.toString$0(0) + " - " + other.toString$0(0) + '".', null));
            },
            times$1: function(other) {
                var _this = this;
                if (other instanceof A.SassNumber0) {
                    if (!other.get$hasUnits()) return _this.withValue$1(_this._number1$_value * other._number1$_value);
                    return _this.multiplyUnits$3(_this._number1$_value * other._number1$_value, other.get$numeratorUnits(other), other.get$denominatorUnits(other));
                }
                throw A.wrapException(A.SassScriptException$0('Undefined operation "' + _this.toString$0(0) + " * " + other.toString$0(0) + '".', null));
            },
            dividedBy$1: function(other) {
                var _this = this;
                if (other instanceof A.SassNumber0) {
                    if (!other.get$hasUnits()) return _this.withValue$1(_this._number1$_value / other._number1$_value);
                    return _this.multiplyUnits$3(_this._number1$_value / other._number1$_value, other.get$denominatorUnits(other), other.get$numeratorUnits(other));
                }
                return _this.super$Value$dividedBy0(other);
            },
            unaryPlus$0: function() {
                return this;
            },
            _number1$_coerceUnits$1$2: function(other, operation) {
                var t1, _$exception;
                try {
                    t1 = operation.call$2(this._number1$_value, other.coerceValueToMatch$1(this));
                    return t1;
                } catch (exception) {
                    if (A.unwrapException(exception) instanceof A.SassScriptException0) {
                        this.coerceValueToMatch$1(other);
                        throw exception;
                    } else throw exception;
                }
            },
            _number1$_coerceUnits$2: function(other, operation) {
                return this._number1$_coerceUnits$1$2(other, operation, type$.dynamic);
            },
            multiplyUnits$3: function(value, otherNumerators, otherDenominators) {
                var t1, _0_1, _0_6, _0_3, _0_9, _0_9_isSet, _0_7, _0_7_isSet, t2, _0_2, t3, denominators_case_0, _0_11_isSet, _0_11, _0_13, _0_13_isSet, numerators_case_0, t4, t5, t6, t7, numerators_case_1, denominators_case_1, t0, newNumerators, mutableOtherDenominators, _i, numerator, mutableDenominatorUnits, _this = this, _null = null, _box_0 = {};
                _box_0.value = value;
                t1 = [
                    _this.get$numeratorUnits(_this),
                    _this.get$denominatorUnits(_this),
                    otherNumerators,
                    otherDenominators
                ];
                _0_1 = t1[0];
                _0_6 = _null;
                _0_3 = _null;
                _0_9 = _null;
                _0_9_isSet = false;
                _0_7 = _null;
                _0_7_isSet = false;
                t2 = false;
                _0_2 = t1[1];
                _0_3 = t1[2];
                _0_6 = _0_3.length <= 0;
                t3 = _0_6;
                if (t3) {
                    _0_7 = t1[3];
                    _0_9 = _0_7.length <= 0;
                    t2 = _0_9;
                    _0_9_isSet = true;
                    _0_7_isSet = true;
                }
                denominators_case_0 = _0_2;
                _0_11_isSet = !t2;
                _0_11 = _null;
                _0_13 = _null;
                _0_13_isSet = false;
                t2 = true;
                if (_0_11_isSet) {
                    _0_11 = _0_1.length <= 0;
                    t3 = _0_11;
                    if (t3) {
                        _0_13 = _0_2.length <= 0;
                        t3 = _0_13;
                        if (t3) {
                            if (_0_7_isSet) denominators_case_0 = _0_7;
                            else {
                                _0_7 = t1[3];
                                denominators_case_0 = _0_7;
                                _0_7_isSet = true;
                            }
                            numerators_case_0 = _0_3;
                        } else {
                            numerators_case_0 = _0_1;
                            t2 = false;
                        }
                        _0_13_isSet = true;
                    } else {
                        numerators_case_0 = _0_1;
                        t2 = false;
                    }
                } else numerators_case_0 = _0_1;
                if (t2) {
                    t4 = denominators_case_0;
                    t3 = numerators_case_0;
                } else {
                    t4 = _null;
                    t3 = t4;
                }
                if (!t2) {
                    t2 = _null;
                    t5 = _null;
                    if (_0_11_isSet) t6 = _0_11;
                    else {
                        _0_11 = _0_1.length <= 0;
                        t6 = _0_11;
                    }
                    t7 = false;
                    if (t6) {
                        if (_0_9_isSet) t2 = _0_9;
                        else {
                            if (_0_7_isSet) t2 = _0_7;
                            else {
                                _0_7 = t1[3];
                                t2 = _0_7;
                                _0_7_isSet = true;
                            }
                            _0_9 = t2.length <= 0;
                            t2 = _0_9;
                        }
                        numerators_case_1 = _0_3;
                        denominators_case_1 = _0_2;
                    } else {
                        numerators_case_1 = t2;
                        t2 = t7;
                        denominators_case_1 = t5;
                    }
                    if (!t2) {
                        t2 = false;
                        if (_0_13_isSet) t5 = _0_13;
                        else {
                            _0_13 = _0_2.length <= 0;
                            t5 = _0_13;
                        }
                        if (t5) {
                            if (_0_6) {
                                denominators_case_1 = _0_7_isSet ? _0_7 : t1[3];
                                t1 = true;
                            } else t1 = t2;
                        } else t1 = t2;
                        numerators_case_1 = _0_1;
                    } else t1 = true;
                    if (t1) {
                        t1 = !_this._number1$_areAnyConvertible$2(numerators_case_1, denominators_case_1);
                        if (t1) {
                            t3 = denominators_case_1;
                            t2 = numerators_case_1;
                        } else {
                            t2 = t3;
                            t3 = t4;
                        }
                        t0 = t3;
                        t3 = t1;
                        t1 = t2;
                        t2 = t0;
                    } else {
                        t2 = t4;
                        t1 = t3;
                        t3 = false;
                    }
                } else {
                    t2 = t4;
                    t1 = t3;
                    t3 = true;
                }
                if (t3) return A.SassNumber_SassNumber$withUnits0(value, t2, t1);
                newNumerators = A._setArrayType([], type$.JSArray_String);
                mutableOtherDenominators = A._setArrayType(otherDenominators.slice(0), A._arrayInstanceType(otherDenominators));
                for(t1 = _this.get$numeratorUnits(_this), t2 = t1.length, _i = 0; _i < t2; ++_i){
                    numerator = t1[_i];
                    A.removeFirstWhere0(mutableOtherDenominators, new A.SassNumber_multiplyUnits_closure3(_box_0, numerator), new A.SassNumber_multiplyUnits_closure4(newNumerators, numerator));
                }
                t1 = _this.get$denominatorUnits(_this);
                mutableDenominatorUnits = A._setArrayType(t1.slice(0), A._arrayInstanceType(t1));
                for(t1 = otherNumerators.length, _i = 0; _i < t1; ++_i){
                    numerator = otherNumerators[_i];
                    A.removeFirstWhere0(mutableDenominatorUnits, new A.SassNumber_multiplyUnits_closure5(_box_0, numerator), new A.SassNumber_multiplyUnits_closure6(newNumerators, numerator));
                }
                t1 = _box_0.value;
                B.JSArray_methods.addAll$1(mutableDenominatorUnits, mutableOtherDenominators);
                return A.SassNumber_SassNumber$withUnits0(t1, mutableDenominatorUnits, newNumerators);
            },
            _number1$_areAnyConvertible$2: function(units1, units2) {
                return B.JSArray_methods.any$1(units1, new A.SassNumber__areAnyConvertible_closure0(units2));
            },
            _number1$_unitString$2: function(numerators, denominators) {
                var t1, _0_4, _0_7, _0_6, _0_5, t2, _0_9, _0_10, denominator, _null = null;
                $label0$0: {
                    t1 = J.getInterceptor$asx(numerators);
                    _0_4 = t1.get$length(numerators) <= 0;
                    _0_7 = _null;
                    _0_6 = _null;
                    _0_5 = _null;
                    if (_0_4) {
                        _0_6 = J.get$length$asx(denominators);
                        t2 = _0_6;
                        _0_7 = t2 <= 0;
                        t2 = _0_7;
                        _0_5 = denominators;
                    } else t2 = false;
                    if (t2) {
                        t1 = "no units";
                        break $label0$0;
                    }
                    _0_9 = _null;
                    if (_0_4) {
                        t2 = _0_6;
                        _0_9 = t2 === 1;
                        t2 = _0_9;
                    } else t2 = false;
                    if (t2) {
                        _0_10 = J.$index$asx(_0_4 ? _0_5 : denominators, 0);
                        denominator = _0_10;
                        t1 = denominator + "^-1";
                        break $label0$0;
                    }
                    if (_0_4) {
                        t1 = "(" + J.join$1$ax(denominators, "*") + ")^-1";
                        break $label0$0;
                    }
                    t2 = denominators;
                    _0_5 = t2;
                    _0_6 = J.get$length$asx(t2);
                    t2 = _0_6;
                    _0_7 = t2 <= 0;
                    t2 = _0_7;
                    if (t2) {
                        t1 = t1.join$1(numerators, "*");
                        break $label0$0;
                    }
                    t2 = _0_6;
                    _0_9 = t2 === 1;
                    t2 = _0_9;
                    if (t2) {
                        _0_10 = J.$index$asx(_0_5, 0);
                        denominator = _0_10;
                        t1 = t1.join$1(numerators, "*") + "/" + denominator;
                        break $label0$0;
                    }
                    t1 = t1.join$1(numerators, "*") + "/(" + J.join$1$ax(denominators, "*") + ")";
                    break $label0$0;
                }
                return t1;
            },
            $eq: function(_, other) {
                var _this = this;
                if (other == null) return false;
                if (!(other instanceof A.SassNumber0)) return false;
                if (_this.get$numeratorUnits(_this).length !== other.get$numeratorUnits(other).length || _this.get$denominatorUnits(_this).length !== other.get$denominatorUnits(other).length) return false;
                if (!_this.get$hasUnits()) return A.fuzzyEquals0(_this._number1$_value, other._number1$_value);
                if (!B.C_ListEquality.equals$2(0, _this._number1$_canonicalizeUnitList$1(_this.get$numeratorUnits(_this)), _this._number1$_canonicalizeUnitList$1(other.get$numeratorUnits(other))) || !B.C_ListEquality.equals$2(0, _this._number1$_canonicalizeUnitList$1(_this.get$denominatorUnits(_this)), _this._number1$_canonicalizeUnitList$1(other.get$denominatorUnits(other)))) return false;
                return A.fuzzyEquals0(_this._number1$_value * _this._number1$_canonicalMultiplier$1(_this.get$numeratorUnits(_this)) / _this._number1$_canonicalMultiplier$1(_this.get$denominatorUnits(_this)), other._number1$_value * _this._number1$_canonicalMultiplier$1(other.get$numeratorUnits(other)) / _this._number1$_canonicalMultiplier$1(other.get$denominatorUnits(other)));
            },
            get$hashCode: function(_) {
                var _this = this, t1 = _this.hashCache;
                return t1 == null ? _this.hashCache = A.fuzzyHashCode0(_this._number1$_value * _this._number1$_canonicalMultiplier$1(_this.get$numeratorUnits(_this)) / _this._number1$_canonicalMultiplier$1(_this.get$denominatorUnits(_this))) : t1;
            },
            _number1$_canonicalizeUnitList$1: function(units) {
                var type, t1 = units.length;
                if (t1 === 0) return units;
                if (t1 === 1) {
                    type = $.$get$_typesByUnit0().$index(0, B.JSArray_methods.get$first(units));
                    if (type == null) t1 = units;
                    else {
                        t1 = B.Map_Sr65K.$index(0, type);
                        t1.toString;
                        t1 = A._setArrayType([
                            B.JSArray_methods.get$first(t1)
                        ], type$.JSArray_String);
                    }
                    return t1;
                }
                t1 = A._arrayInstanceType(units)._eval$1("MappedListIterable<1,String>");
                t1 = A.List_List$_of(new A.MappedListIterable(units, new A.SassNumber__canonicalizeUnitList_closure0(), t1), t1._eval$1("ListIterable.E"));
                B.JSArray_methods.sort$0(t1);
                return t1;
            },
            _number1$_canonicalMultiplier$1: function(units) {
                return B.JSArray_methods.fold$2(units, 1, new A.SassNumber__canonicalMultiplier_closure0(this));
            },
            canonicalMultiplierForUnit$1: function(unit) {
                var t1, innerMap = B.Map_NtHoP.$index(0, unit);
                if (innerMap == null) t1 = 1;
                else {
                    t1 = innerMap.get$values(innerMap);
                    t1 = 1 / t1.get$first(t1);
                }
                return t1;
            },
            unitSuggestion$2: function($name, unit) {
                var t2, t3, result, _this = this, t1 = _this.get$denominatorUnits(_this);
                t1 = new A.MappedListIterable(t1, new A.SassNumber_unitSuggestion_closure1(), A._arrayInstanceType(t1)._eval$1("MappedListIterable<1,String>")).join$0(0);
                t2 = _this.get$numeratorUnits(_this);
                t2 = new A.MappedListIterable(t2, new A.SassNumber_unitSuggestion_closure2(), A._arrayInstanceType(t2)._eval$1("MappedListIterable<1,String>")).join$0(0);
                t3 = unit == null ? "" : " * 1" + unit;
                result = "$" + $name + t1 + t2 + t3;
                return _this.get$numeratorUnits(_this).length === 0 ? result : "calc(" + result + ")";
            },
            unitSuggestion$1: function($name) {
                return this.unitSuggestion$2($name, null);
            }
        };
        A.SassNumber__coerceOrConvertValue_compatibilityException0.prototype = {
            call$0: function() {
                var t2, t3, message, t4, type, unit, _this = this, t1 = _this.other;
                if (t1 != null) {
                    t2 = _this.$this;
                    t3 = t2.toString$0(0) + " and";
                    message = new A.StringBuffer(t3);
                    t4 = _this.otherName;
                    if (t4 != null) t3 = message._contents = t3 + (" $" + t4 + ":");
                    t1 = t3 + (" " + t1.toString$0(0) + " have incompatible units");
                    message._contents = t1;
                    if (!t2.get$hasUnits() || !_this.otherHasUnits) message._contents = t1 + " (one has units and the other doesn't)";
                    t1 = message.toString$0(0) + ".";
                    t2 = _this.name;
                    return new A.SassScriptException0(t2 == null ? t1 : "$" + t2 + ": " + t1);
                } else if (!_this.otherHasUnits) {
                    t1 = "Expected " + _this.$this.toString$0(0) + " to have no units.";
                    t2 = _this.name;
                    return new A.SassScriptException0(t2 == null ? t1 : "$" + t2 + ": " + t1);
                } else {
                    t1 = _this.newNumerators;
                    t2 = J.getInterceptor$asx(t1);
                    if (t2.get$length(t1) === 1 && J.get$isEmpty$asx(_this.newDenominators)) {
                        type = $.$get$_typesByUnit0().$index(0, t2.get$first(t1));
                        if (type != null) {
                            t1 = _this.$this.toString$0(0);
                            t2 = B.JSArray_methods.contains$1(A._setArrayType([
                                97,
                                101,
                                105,
                                111,
                                117
                            ], type$.JSArray_int), type.charCodeAt(0)) ? "an " + type : "a " + type;
                            t3 = B.Map_Sr65K.$index(0, type);
                            t3.toString;
                            t3 = "Expected " + t1 + " to have " + t2 + " unit (" + B.JSArray_methods.join$1(t3, ", ") + ").";
                            t2 = _this.name;
                            return new A.SassScriptException0(t2 == null ? t3 : "$" + t2 + ": " + t3);
                        }
                    }
                    t3 = _this.newDenominators;
                    unit = A.pluralize0("unit", t2.get$length(t1) + J.get$length$asx(t3), null);
                    t2 = _this.$this;
                    t3 = "Expected " + t2.toString$0(0) + " to have " + unit + " " + t2._number1$_unitString$2(t1, t3) + ".";
                    t1 = _this.name;
                    return new A.SassScriptException0(t1 == null ? t3 : "$" + t1 + ": " + t3);
                }
            },
            $signature: 557
        };
        A.SassNumber__coerceOrConvertValue_closure3.prototype = {
            call$1: function(oldNumerator) {
                var factor = A.conversionFactor0(this.newNumerator, oldNumerator);
                if (factor == null) return false;
                this._box_0.value *= factor;
                return true;
            },
            $signature: 4
        };
        A.SassNumber__coerceOrConvertValue_closure4.prototype = {
            call$0: function() {
                return A.throwExpression(this.compatibilityException.call$0());
            },
            $signature: 0
        };
        A.SassNumber__coerceOrConvertValue_closure5.prototype = {
            call$1: function(oldDenominator) {
                var factor = A.conversionFactor0(this.newDenominator, oldDenominator);
                if (factor == null) return false;
                this._box_0.value /= factor;
                return true;
            },
            $signature: 4
        };
        A.SassNumber__coerceOrConvertValue_closure6.prototype = {
            call$0: function() {
                return A.throwExpression(this.compatibilityException.call$0());
            },
            $signature: 0
        };
        A.SassNumber_plus_closure0.prototype = {
            call$2: function(num1, num2) {
                return num1 + num2;
            },
            $signature: 57
        };
        A.SassNumber_minus_closure0.prototype = {
            call$2: function(num1, num2) {
                return num1 - num2;
            },
            $signature: 57
        };
        A.SassNumber_multiplyUnits_closure3.prototype = {
            call$1: function(denominator) {
                var factor = A.conversionFactor0(this.numerator, denominator);
                if (factor == null) return false;
                this._box_0.value /= factor;
                return true;
            },
            $signature: 4
        };
        A.SassNumber_multiplyUnits_closure4.prototype = {
            call$0: function() {
                return this.newNumerators.push(this.numerator);
            },
            $signature: 0
        };
        A.SassNumber_multiplyUnits_closure5.prototype = {
            call$1: function(denominator) {
                var factor = A.conversionFactor0(this.numerator, denominator);
                if (factor == null) return false;
                this._box_0.value /= factor;
                return true;
            },
            $signature: 4
        };
        A.SassNumber_multiplyUnits_closure6.prototype = {
            call$0: function() {
                return this.newNumerators.push(this.numerator);
            },
            $signature: 0
        };
        A.SassNumber__areAnyConvertible_closure0.prototype = {
            call$1: function(unit1) {
                var t1, _0_0 = B.Map_NtHoP.$index(0, unit1);
                $label0$0: {
                    if (_0_0 != null) {
                        t1 = B.JSArray_methods.any$1(this.units2, _0_0.get$containsKey());
                        break $label0$0;
                    }
                    t1 = B.JSArray_methods.contains$1(this.units2, unit1);
                    break $label0$0;
                }
                return t1;
            },
            $signature: 4
        };
        A.SassNumber__canonicalizeUnitList_closure0.prototype = {
            call$1: function(unit) {
                var t1, type = $.$get$_typesByUnit0().$index(0, unit);
                if (type == null) t1 = unit;
                else {
                    t1 = B.Map_Sr65K.$index(0, type);
                    t1.toString;
                    t1 = B.JSArray_methods.get$first(t1);
                }
                return t1;
            },
            $signature: 6
        };
        A.SassNumber__canonicalMultiplier_closure0.prototype = {
            call$2: function(multiplier, unit) {
                return multiplier * this.$this.canonicalMultiplierForUnit$1(unit);
            },
            $signature: 165
        };
        A.SassNumber_unitSuggestion_closure1.prototype = {
            call$1: function(unit) {
                return " * 1" + unit;
            },
            $signature: 6
        };
        A.SassNumber_unitSuggestion_closure2.prototype = {
            call$1: function(unit) {
                return " / 1" + unit;
            },
            $signature: 6
        };
        A.OklabColorSpace0.prototype = {
            get$isBoundedInternal: function() {
                return false;
            },
            convert$7$missingChroma$missingHue: function(dest, lightness, a, b, alpha, missingChroma, missingHue) {
                var missingLightness, missingA, missingB, t1;
                if (dest === B.OklchColorSpace_9Gj0) return A.labToLch0(dest, lightness, a, b, alpha, missingChroma, missingHue);
                missingLightness = lightness == null;
                missingA = a == null;
                missingB = b == null;
                if (missingLightness) lightness = 0;
                if (missingA) a = 0;
                if (missingB) b = 0;
                t1 = $.$get$oklabToLms0();
                return B.LmsColorSpace_Os30.convert$10$missingA$missingB$missingChroma$missingHue$missingLightness(dest, Math.pow(t1[0] * lightness + t1[1] * a + t1[2] * b, 3) + 0, Math.pow(t1[3] * lightness + t1[4] * a + t1[5] * b, 3) + 0, Math.pow(t1[6] * lightness + t1[7] * a + t1[8] * b, 3) + 0, alpha, missingA, missingB, missingChroma, missingHue, missingLightness);
            },
            convert$5: function(dest, lightness, a, b, alpha) {
                return this.convert$7$missingChroma$missingHue(dest, lightness, a, b, alpha, false, false);
            }
        };
        A.OklchColorSpace0.prototype = {
            get$isBoundedInternal: function() {
                return false;
            },
            get$isPolarInternal: function() {
                return true;
            },
            convert$5: function(dest, lightness, chroma, hue, alpha) {
                var t1 = hue == null, hueRadians = (t1 ? 0 : hue) * 3.141592653589793 / 180, t2 = chroma == null, t3 = t2 ? 0 : chroma, t4 = Math.cos(hueRadians), t5 = t2 ? 0 : chroma;
                return B.OklabColorSpace_5400.convert$7$missingChroma$missingHue(dest, lightness, t3 * t4, t5 * Math.sin(hueRadians), alpha, t2, t1);
            }
        };
        A.SupportsOperation0.prototype = {
            toInterpolation$0: function() {
                var t1 = new A.StringBuffer(""), t2 = new A.InterpolationBuffer0(t1, A._setArrayType([], type$.JSArray_Object), A._setArrayType([], type$.JSArray_nullable_FileSpan)), t3 = this.span, t4 = this.left, t5 = A.SpanExtensions_before(t3, t4.get$span(t4));
                t5 = A.String_String$fromCharCodes(B.NativeUint32List_methods.sublist$2(t5.file._decodedChars, t5._file$_start, t5._end), 0, null);
                t1._contents += t5;
                t2.addInterpolation$1(t4.toInterpolation$0());
                t5 = this.right;
                t4 = A.SpanExtensions_between(t4.get$span(t4), t5.get$span(t5));
                t4 = A.String_String$fromCharCodes(B.NativeUint32List_methods.sublist$2(t4.file._decodedChars, t4._file$_start, t4._end), 0, null);
                t1._contents += t4;
                t2.addInterpolation$1(t5.toInterpolation$0());
                t5 = A.SpanExtensions_after(t3, t5.get$span(t5));
                t5 = A.String_String$fromCharCodes(B.NativeUint32List_methods.sublist$2(t5.file._decodedChars, t5._file$_start, t5._end), 0, null);
                t1._contents += t5;
                return t2.interpolation$1(t3);
            },
            withSpan$1: function(span) {
                return new A.SupportsOperation0(this.left, this.right, this.operator, span);
            },
            toString$0: function(_) {
                var _this = this;
                return _this._operation$_parenthesize$1(_this.left) + " " + _this.operator.toString$0(0) + " " + _this._operation$_parenthesize$1(_this.right);
            },
            _operation$_parenthesize$1: function(condition) {
                var t1;
                if (!(condition instanceof A.SupportsNegation0)) t1 = condition instanceof A.SupportsOperation0 && condition.operator === this.operator;
                else t1 = true;
                return t1 ? "(" + condition.toString$0(0) + ")" : condition.toString$0(0);
            },
            $isAstNode0: 1,
            $isSassNode: 1,
            $isSupportsCondition: 1,
            get$span: function(receiver) {
                return this.span;
            }
        };
        A.Parameter0.prototype = {
            toString$0: function(_) {
                var t1 = this.defaultValue, t2 = this.name;
                return t1 == null ? t2 : t2 + ": " + t1.toString$0(0);
            },
            $isAstNode0: 1,
            $isSassNode: 1,
            get$span: function(receiver) {
                return this.span;
            }
        };
        A.ParameterList0.prototype = {
            get$spanWithName: function() {
                var t2, t3, t1 = this.span, text = A.String_String$fromCharCodes(B.NativeUint32List_methods.sublist$2(t1.get$file(t1)._decodedChars, 0, null), 0, null), i = t1.get$start(t1).offset - 1;
                for(;;){
                    if (i > 0) {
                        t2 = text.charCodeAt(i);
                        t2 = t2 === 32 || t2 === 9 || t2 === 10 || t2 === 13 || t2 === 12;
                    } else t2 = false;
                    if (!t2) break;
                    --i;
                }
                t2 = text.charCodeAt(i);
                if (!(t2 === 95 || A.CharacterExtension_get_isAlphabetic0(t2) || t2 >= 128)) t2 = t2 >= 48 && t2 <= 57 || t2 === 45;
                else t2 = true;
                if (!t2) return t1;
                --i;
                for(;;){
                    if (i >= 0) {
                        t2 = text.charCodeAt(i);
                        if (t2 !== 95) {
                            if (!(t2 >= 97 && t2 <= 122)) t3 = t2 >= 65 && t2 <= 90;
                            else t3 = true;
                            t3 = t3 || t2 >= 128;
                        } else t3 = true;
                        if (!t3) t2 = t2 >= 48 && t2 <= 57 || t2 === 45;
                        else t2 = true;
                    } else t2 = false;
                    if (!t2) break;
                    --i;
                }
                t2 = i + 1;
                t3 = text.charCodeAt(t2);
                if (!(t3 === 95 || A.CharacterExtension_get_isAlphabetic0(t3) || t3 >= 128)) return t1;
                return A.SpanExtensions_trimRight0(A.SpanExtensions_trimLeft0(t1.get$file(t1).span$2(0, t2, t1.get$end(t1).offset)));
            },
            verify$2: function(positional, names) {
                var t1, t2, t3, namedUsed, i, parameter, t4, unknownNames, _this = this, _s10_ = "invocation";
                for(t1 = _this.parameters, t2 = t1.length, t3 = names._baseMap, namedUsed = 0, i = 0; i < t2; ++i){
                    parameter = t1[i];
                    if (i < positional) {
                        t4 = parameter.name;
                        if (t3.containsKey$1(t4)) throw A.wrapException(A.SassScriptException$0("Argument " + _this._parameter_list$_originalParameterName$1(t4) + string$.x20was_p, null));
                    } else {
                        t4 = parameter.name;
                        if (t3.containsKey$1(t4)) ++namedUsed;
                        else if (parameter.defaultValue == null) throw A.wrapException(A.MultiSpanSassScriptException$0("Missing argument " + _this._parameter_list$_originalParameterName$1(t4) + ".", _s10_, A.LinkedHashMap_LinkedHashMap$_literal([
                            _this.get$spanWithName(),
                            "declaration"
                        ], type$.FileSpan, type$.String)));
                    }
                }
                if (_this.restParameter != null) return;
                if (positional > t2) {
                    t1 = names.get$isEmpty(0) ? "" : "positional ";
                    throw A.wrapException(A.MultiSpanSassScriptException$0("Only " + t2 + " " + t1 + A.pluralize0("argument", t2, null) + " allowed, but " + positional + " " + A.pluralize0("was", positional, "were") + " passed.", _s10_, A.LinkedHashMap_LinkedHashMap$_literal([
                        _this.get$spanWithName(),
                        "declaration"
                    ], type$.FileSpan, type$.String)));
                }
                if (namedUsed < t3.get$length(t3)) {
                    t2 = type$.String;
                    unknownNames = A.LinkedHashSet_LinkedHashSet$of(names, t2);
                    unknownNames.removeAll$1(new A.MappedListIterable(t1, new A.ParameterList_verify_closure1(), A._arrayInstanceType(t1)._eval$1("MappedListIterable<1,Object?>")));
                    throw A.wrapException(A.MultiSpanSassScriptException$0("No " + A.pluralize0("parameter", unknownNames._collection$_length, null) + " named " + A.toSentence0(unknownNames.map$1$1(0, new A.ParameterList_verify_closure2(), type$.Object), "or") + ".", _s10_, A.LinkedHashMap_LinkedHashMap$_literal([
                        _this.get$spanWithName(),
                        "declaration"
                    ], type$.FileSpan, t2)));
                }
            },
            _parameter_list$_originalParameterName$1: function($name) {
                var text, t1, t2, _i, parameter, end;
                if ($name === this.restParameter) {
                    text = this.span.get$text();
                    return B.JSString_methods.substring$2(B.JSString_methods.substring$1(text, B.JSString_methods.lastIndexOf$1(text, "$")), 0, B.JSString_methods.indexOf$1(text, "."));
                }
                for(t1 = this.parameters, t2 = t1.length, _i = 0; _i < t2; ++_i){
                    parameter = t1[_i];
                    if (parameter.name === $name) {
                        t1 = parameter.span;
                        if (parameter.defaultValue == null) t1 = t1.get$text();
                        else {
                            text = t1.get$text();
                            t1 = B.JSString_methods.substring$2(text, 0, B.JSString_methods.indexOf$1(text, ":"));
                            end = A._lastNonWhitespace0(t1, false);
                            t1 = end == null ? "" : B.JSString_methods.substring$2(t1, 0, end + 1);
                        }
                        return t1;
                    }
                }
                throw A.wrapException(A.ArgumentError$(string$.This_d + $name + '".', null));
            },
            matches$2: function(positional, names) {
                var t1, t2, t3, namedUsed, i, parameter;
                for(t1 = this.parameters, t2 = t1.length, t3 = names._baseMap, namedUsed = 0, i = 0; i < t2; ++i){
                    parameter = t1[i];
                    if (i < positional) {
                        if (t3.containsKey$1(parameter.name)) return false;
                    } else if (t3.containsKey$1(parameter.name)) ++namedUsed;
                    else if (parameter.defaultValue == null) return false;
                }
                if (this.restParameter != null) return true;
                if (positional > t2) return false;
                if (namedUsed < t3.get$length(t3)) return false;
                return true;
            },
            toString$0: function(_) {
                var t2, t3, _i, t1 = A._setArrayType([], type$.JSArray_String);
                for(t2 = this.parameters, t3 = t2.length, _i = 0; _i < t3; ++_i)t1.push("$" + t2[_i].toString$0(0));
                t2 = this.restParameter;
                if (t2 != null) t1.push("$" + t2 + "...");
                return B.JSArray_methods.join$1(t1, ", ");
            },
            $isAstNode0: 1,
            $isSassNode: 1,
            get$span: function(receiver) {
                return this.span;
            }
        };
        A.ParameterList_verify_closure1.prototype = {
            call$1: function(parameter) {
                return parameter.name;
            },
            $signature: 558
        };
        A.ParameterList_verify_closure2.prototype = {
            call$1: function($name) {
                return "$" + $name;
            },
            $signature: 6
        };
        A.InterpolatedParentSelector.prototype = {
            accept$1$1: function(visitor) {
                return J.visitParentSelector$1$x(visitor._simple_selector$_inner, this);
            },
            accept$1: function(visitor) {
                return this.accept$1$1(visitor, type$.dynamic);
            },
            toString$0: function(_) {
                var t1, _0_0 = this.suffix;
                $label0$0: {
                    if (_0_0 != null) {
                        t1 = "&" + _0_0.toString$0(0);
                        break $label0$0;
                    }
                    t1 = "&";
                    break $label0$0;
                }
                return t1;
            },
            get$span: function(receiver) {
                return this.span;
            }
        };
        A.ParentSelector0.prototype = {
            accept$1$1: function(visitor) {
                return visitor.visitParentSelector$1(0, this);
            },
            accept$1: function(visitor) {
                return this.accept$1$1(visitor, type$.dynamic);
            },
            unify$1: function(compound) {
                return A.throwExpression(A.UnsupportedError$("& doesn't support unification."));
            }
        };
        A.ParentStatement0.prototype = {};
        A.ParentStatement_closure0.prototype = {
            call$1: function(child) {
                var t1;
                $label0$0: {
                    if (child instanceof A.VariableDeclaration0 || child instanceof A.FunctionRule0 || child instanceof A.MixinRule0) {
                        t1 = true;
                        break $label0$0;
                    }
                    if (child instanceof A.ImportRule0) {
                        t1 = B.JSArray_methods.any$1(child.imports, new A.ParentStatement__closure0());
                        break $label0$0;
                    }
                    t1 = false;
                    break $label0$0;
                }
                return t1;
            },
            $signature: 248
        };
        A.ParentStatement__closure0.prototype = {
            call$1: function($import) {
                return $import instanceof A.DynamicImport0;
            },
            $signature: 249
        };
        A.ParenthesizedExpression0.prototype = {
            accept$1$1: function(visitor) {
                return visitor.visitParenthesizedExpression$1(0, this);
            },
            accept$1: function(visitor) {
                return this.accept$1$1(visitor, type$.dynamic);
            },
            toString$0: function(_) {
                return "(" + this.expression.toString$0(0) + ")";
            },
            get$span: function(receiver) {
                return this.span;
            }
        };
        A.ParserExports.prototype = {};
        A.loadParserExports_closure.prototype = {
            call$1: function(inner) {
                return new A.JSExpressionVisitor(inner);
            },
            $signature: 559
        };
        A.loadParserExports_closure0.prototype = {
            call$1: function(inner) {
                return new A.JSIfConditionExpressionVisitor(inner);
            },
            $signature: 560
        };
        A.loadParserExports_closure1.prototype = {
            call$1: function(inner) {
                return new A.JSStatementVisitor(inner);
            },
            $signature: 561
        };
        A.loadParserExports_closure2.prototype = {
            call$1: function(inner) {
                return new A.JSSimpleSelectorVisitor(inner);
            },
            $signature: 562
        };
        A.loadParserExports_closure3.prototype = {
            call$1: function(text) {
                return A.SourceFile$fromString(text, null);
            },
            $signature: 563
        };
        A.loadParserExports_closure4.prototype = {
            call$1: function(set) {
                var t1 = A.List_List$_of(set, type$.nullable_Object);
                return new self.Set(t1);
            },
            $signature: 564
        };
        A._updateLazyFileSpanPrototype_closure.prototype = {
            call$0: function() {
                return $.$get$bogusSpan0();
            },
            $signature: 16
        };
        A._updateLazyFileSpanPrototype_closure0.prototype = {
            call$1: function(span) {
                var t1 = span.get$span(0);
                return t1.get$file(t1);
            },
            $signature: 565
        };
        A._updateLazyFileSpanPrototype_closure1.prototype = {
            call$1: function(span) {
                var t1 = span.get$span(0);
                return t1.get$length(t1);
            },
            $signature: 566
        };
        A._updateLazyFileSpanPrototype_closure2.prototype = {
            call$1: function(span) {
                var t1 = span.get$span(0);
                return t1.get$sourceUrl(t1);
            },
            $signature: 567
        };
        A._updateAstPrototypes_closure.prototype = {
            call$3: function($self, start, end) {
                return A.String_String$fromCharCodes(B.NativeUint32List_methods.sublist$2($self._decodedChars, start, end), 0, null);
            },
            call$2: function($self, start) {
                return this.call$3($self, start, null);
            },
            "call*": "call$3",
            $requiredArgCount: 2,
            $defaultValues: function() {
                return [
                    null
                ];
            },
            $signature: 568
        };
        A._updateAstPrototypes_closure0.prototype = {
            call$3: function($self, start, end) {
                return $self.span$2(0, start, end);
            },
            call$2: function($self, start) {
                return this.call$3($self, start, null);
            },
            "call*": "call$3",
            $requiredArgCount: 2,
            $defaultValues: function() {
                return [
                    null
                ];
            },
            $signature: 569
        };
        A._updateAstPrototypes_closure1.prototype = {
            call$1: function($self) {
                return $self._decodedChars;
            },
            $signature: 570
        };
        A._updateAstPrototypes_closure2.prototype = {
            call$1: function($self) {
                return $self.get$asPlain();
            },
            $signature: 571
        };
        A._updateAstPrototypes_closure3.prototype = {
            call$2: function($self, visitor) {
                return $self.accept$1(visitor);
            },
            $signature: 572
        };
        A._updateAstPrototypes_closure4.prototype = {
            call$2: function($self, visitor) {
                return $self.accept$1(visitor);
            },
            $signature: 573
        };
        A._updateAstPrototypes_closure5.prototype = {
            call$2: function($self, visitor) {
                return $self.accept$1(visitor);
            },
            $signature: 574
        };
        A._updateAstPrototypes_closure6.prototype = {
            call$2: function($self, visitor) {
                return $self.accept$1(visitor);
            },
            $signature: 575
        };
        A._updateAstPrototypes_closure7.prototype = {
            call$1: function($self) {
                return $self.$arguments;
            },
            $signature: 576
        };
        A._updateAstPrototypes_closure8.prototype = {
            call$1: function($self) {
                return $self.$arguments;
            },
            $signature: 577
        };
        A._updateAstPrototypes_closure9.prototype = {
            call$1: function($self) {
                return $self.$arguments;
            },
            $signature: 578
        };
        A._updateAstPrototypes_closure10.prototype = {
            call$1: function($self) {
                return $self.$arguments;
            },
            $signature: 579
        };
        A._updateAstPrototypes_closure11.prototype = {
            call$1: function($self) {
                return $self.$arguments;
            },
            $signature: 580
        };
        A._updateAstPrototypes_closure12.prototype = {
            call$1: function($self) {
                return $self.$arguments;
            },
            $signature: 581
        };
        A._updateAstPrototypes_closure13.prototype = {
            call$1: function($self) {
                return $self.get$span($self);
            },
            $signature: 582
        };
        A._addSupportsConditionToInterpolation_closure.prototype = {
            call$1: function($self) {
                return $self.toInterpolation$0();
            },
            $signature: 583
        };
        A.Parser1.prototype = {
            _parser1$_parseIdentifier$0: function() {
                return this.wrapSpanFormatException$1(new A.Parser__parseIdentifier_closure0(this));
            },
            whitespace$1$consumeNewlines: function(consumeNewlines) {
                do this.whitespaceWithoutComments$1$consumeNewlines(consumeNewlines);
                while (this.scanComment$0());
            },
            whitespaceWithoutComments$1$consumeNewlines: function(consumeNewlines) {
                var t3, t1 = this.scanner, t2 = t1.string.length;
                for(;;){
                    if (t1._string_scanner$_position !== t2) {
                        t3 = t1.peekChar$0();
                        t3 = t3 === 32 || t3 === 9 || t3 === 10 || t3 === 13 || t3 === 12;
                    } else t3 = false;
                    if (!t3) break;
                    t1.readChar$0();
                }
            },
            spaces$0: function() {
                var t3, t1 = this.scanner, t2 = t1.string.length;
                for(;;){
                    if (t1._string_scanner$_position !== t2) {
                        t3 = t1.peekChar$0();
                        t3 = t3 === 32 || t3 === 9;
                    } else t3 = false;
                    if (!t3) break;
                    t1.readChar$0();
                }
            },
            scanComment$0: function() {
                var _0_0, t1 = this.scanner;
                if (t1.peekChar$0() !== 47) return false;
                _0_0 = t1.peekChar$1(1);
                if (47 === _0_0) return this.silentComment$0();
                if (42 === _0_0) {
                    this.loudComment$0();
                    return true;
                }
                return false;
            },
            expectWhitespace$1$consumeNewlines: function(consumeNewlines) {
                var t2, t3, t1 = this.scanner;
                if (t1._string_scanner$_position !== t1.string.length) {
                    t2 = t1.peekChar$0();
                    t3 = !(t2 === 32 || t2 === 9 || t2 === 10 || t2 === 13 || t2 === 12 || this.scanComment$0());
                    t2 = t3;
                } else t2 = true;
                if (t2) t1.error$1(0, "Expected whitespace.");
                this.whitespace$1$consumeNewlines(consumeNewlines);
            },
            expectWhitespace$0: function() {
                return this.expectWhitespace$1$consumeNewlines(false);
            },
            silentComment$0: function() {
                var t2, t3, t1 = this.scanner;
                t1.expect$1("//");
                t2 = t1.string.length;
                for(;;){
                    if (t1._string_scanner$_position !== t2) {
                        t3 = t1.peekChar$0();
                        t3 = !(t3 === 10 || t3 === 13 || t3 === 12);
                    } else t3 = false;
                    if (!t3) break;
                    t1.readChar$0();
                }
                return true;
            },
            loudComment$0: function() {
                var next, t1 = this.scanner;
                t1.expect$1("/*");
                for(;;){
                    if (t1.readChar$0() !== 42) continue;
                    do next = t1.readChar$0();
                    while (next === 42);
                    if (next === 47) break;
                }
            },
            identifier$2$normalize$unit: function(normalize, unit) {
                var t2, _0_0, _this = this, _s20_ = "Expected identifier.", text = new A.StringBuffer(""), t1 = _this.scanner;
                if (t1.scanChar$1(45)) {
                    t2 = text._contents = A.Primitives_stringFromCharCode(45);
                    if (t1.scanChar$1(45)) {
                        text._contents = t2 + t2;
                        _this._parser1$_identifierBody$3$normalize$unit(text, normalize, unit);
                        t1 = text._contents;
                        return t1.charCodeAt(0) == 0 ? t1 : t1;
                    }
                } else t2 = "";
                $label0$0: {
                    _0_0 = t1.peekChar$0();
                    if (_0_0 == null) t1.error$1(0, _s20_);
                    if (95 === _0_0 && normalize) {
                        t1.readChar$0();
                        text._contents = t2 + A.Primitives_stringFromCharCode(45);
                        break $label0$0;
                    }
                    if (_0_0 === 95 || A.CharacterExtension_get_isAlphabetic0(_0_0) || _0_0 >= 128) {
                        text._contents = t2 + A.Primitives_stringFromCharCode(t1.readChar$0());
                        break $label0$0;
                    }
                    if (92 === _0_0) {
                        text._contents = t2 + _this.escape$1$identifierStart(true);
                        break $label0$0;
                    }
                    t1.error$1(0, _s20_);
                }
                _this._parser1$_identifierBody$3$normalize$unit(text, normalize, unit);
                t1 = text._contents;
                return t1.charCodeAt(0) == 0 ? t1 : t1;
            },
            identifier$0: function() {
                return this.identifier$2$normalize$unit(false, false);
            },
            identifier$1$normalize: function(normalize) {
                return this.identifier$2$normalize$unit(normalize, false);
            },
            identifier$1$unit: function(unit) {
                return this.identifier$2$normalize$unit(false, unit);
            },
            _parser1$_identifierBody$3$normalize$unit: function(text, normalize, unit) {
                var t1, _1_0, _0_0, t2;
                for(t1 = this.scanner;;){
                    _1_0 = t1.peekChar$0();
                    if (_1_0 == null) break;
                    if (45 === _1_0 && unit) {
                        _0_0 = t1.peekChar$1(1);
                        if (46 !== _0_0) t2 = A._isInt(_0_0) && _0_0 >= 48 && _0_0 <= 57;
                        else t2 = true;
                        if (t2) break;
                        t2 = A.Primitives_stringFromCharCode(t1.readChar$0());
                        text._contents += t2;
                        continue;
                    }
                    if (95 === _1_0 && normalize) {
                        t1.readChar$0();
                        t2 = A.Primitives_stringFromCharCode(45);
                        text._contents += t2;
                        continue;
                    }
                    if (_1_0 !== 95) {
                        if (!(_1_0 >= 97 && _1_0 <= 122)) t2 = _1_0 >= 65 && _1_0 <= 90;
                        else t2 = true;
                        t2 = t2 || _1_0 >= 128;
                    } else t2 = true;
                    if (!t2) t2 = _1_0 >= 48 && _1_0 <= 57 || _1_0 === 45;
                    else t2 = true;
                    if (t2) {
                        t2 = A.Primitives_stringFromCharCode(t1.readChar$0());
                        text._contents += t2;
                        continue;
                    }
                    if (92 === _1_0) {
                        t2 = this.escape$0();
                        text._contents += t2;
                        continue;
                    }
                    break;
                }
            },
            _parser1$_identifierBody$1: function(text) {
                return this._parser1$_identifierBody$3$normalize$unit(text, false, false);
            },
            string$0: function() {
                var buffer, _0_0, t2, t1 = this.scanner, quote = t1.readChar$0();
                if (quote !== 39 && quote !== 34) t1.error$2$position(0, "Expected string.", t1._string_scanner$_position - 1);
                buffer = new A.StringBuffer("");
                for(;;){
                    _0_0 = t1.peekChar$0();
                    if (_0_0 === quote) {
                        t1.readChar$0();
                        break;
                    }
                    if (_0_0 == null || _0_0 === 10 || _0_0 === 13 || _0_0 === 12) t1.error$1(0, "Expected " + A.Primitives_stringFromCharCode(quote) + ".");
                    if (92 === _0_0) {
                        t2 = t1.peekChar$1(1);
                        if (t2 === 10 || t2 === 13 || t2 === 12) {
                            t1.readChar$0();
                            t1.readChar$0();
                        } else {
                            t2 = A.Primitives_stringFromCharCode(A.consumeEscapedCharacter0(t1));
                            buffer._contents += t2;
                        }
                        continue;
                    }
                    t2 = A.Primitives_stringFromCharCode(t1.readChar$0());
                    buffer._contents += t2;
                }
                t1 = buffer._contents;
                return t1.charCodeAt(0) == 0 ? t1 : t1;
            },
            declarationValue$1$allowEmpty: function(allowEmpty) {
                var t1, t2, t3, wroteNewline, next, wroteNewline0, t4, start, end, _0_0, _this = this, buffer = new A.StringBuffer(""), brackets = A._setArrayType([], type$.JSArray_int);
                for(t1 = _this.scanner, t2 = _this.get$loudComment(), t3 = _this.get$string(), wroteNewline = false;;){
                    next = t1.peekChar$0();
                    if (next == null) break;
                    wroteNewline0 = false;
                    if (92 === next) {
                        t4 = _this.escape$1$identifierStart(true);
                        buffer._contents += t4;
                        wroteNewline = wroteNewline0;
                        continue;
                    }
                    if (34 === next || 39 === next) {
                        start = t1._string_scanner$_position;
                        t3.call$0();
                        end = t1._string_scanner$_position;
                        buffer._contents += B.JSString_methods.substring$2(t1.string, start, end);
                        wroteNewline = wroteNewline0;
                        continue;
                    }
                    if (47 === next) {
                        if (t1.peekChar$1(1) === 42) {
                            start = t1._string_scanner$_position;
                            t2.call$0();
                            end = t1._string_scanner$_position;
                            buffer._contents += B.JSString_methods.substring$2(t1.string, start, end);
                        } else {
                            t4 = A.Primitives_stringFromCharCode(t1.readChar$0());
                            buffer._contents += t4;
                        }
                        wroteNewline = wroteNewline0;
                        continue;
                    }
                    if (32 === next || 9 === next) {
                        if (!wroteNewline) {
                            t4 = t1.peekChar$1(1);
                            t4 = !(t4 === 32 || t4 === 9 || t4 === 10 || t4 === 13 || t4 === 12);
                        } else t4 = true;
                        if (t4) {
                            t4 = A.Primitives_stringFromCharCode(32);
                            buffer._contents += t4;
                        }
                        t1.readChar$0();
                        continue;
                    }
                    if (10 === next || 13 === next || 12 === next) {
                        t4 = t1.peekChar$1(-1);
                        if (!(t4 === 10 || t4 === 13 || t4 === 12)) buffer._contents += "\n";
                        t1.readChar$0();
                        wroteNewline = true;
                        continue;
                    }
                    if (40 === next || 123 === next || 91 === next) {
                        t4 = A.Primitives_stringFromCharCode(next);
                        buffer._contents += t4;
                        brackets.push(A.opposite0(t1.readChar$0()));
                        wroteNewline = wroteNewline0;
                        continue;
                    }
                    if (41 === next || 125 === next || 93 === next) {
                        if (brackets.length === 0) break;
                        t4 = A.Primitives_stringFromCharCode(next);
                        buffer._contents += t4;
                        t1.expectChar$1(brackets.pop());
                        wroteNewline = wroteNewline0;
                        continue;
                    }
                    if (59 === next) {
                        if (brackets.length === 0) break;
                        t4 = A.Primitives_stringFromCharCode(t1.readChar$0());
                        buffer._contents += t4;
                        continue;
                    }
                    if (117 === next || 85 === next) {
                        _0_0 = _this.tryUrl$0();
                        if (_0_0 != null) buffer._contents += _0_0;
                        else {
                            t4 = A.Primitives_stringFromCharCode(t1.readChar$0());
                            buffer._contents += t4;
                        }
                        wroteNewline = wroteNewline0;
                        continue;
                    }
                    if (_this.lookingAtIdentifier$0()) {
                        t4 = _this.identifier$0();
                        buffer._contents += t4;
                    } else {
                        t4 = A.Primitives_stringFromCharCode(t1.readChar$0());
                        buffer._contents += t4;
                    }
                    wroteNewline = wroteNewline0;
                }
                if (brackets.length !== 0) t1.expectChar$1(B.JSArray_methods.get$last(brackets));
                if (!allowEmpty && buffer._contents.length === 0) t1.error$1(0, "Expected token.");
                t1 = buffer._contents;
                return t1.charCodeAt(0) == 0 ? t1 : t1;
            },
            declarationValue$0: function() {
                return this.declarationValue$1$allowEmpty(false);
            },
            tryUrl$0: function() {
                var buffer, _0_0, t2, _this = this, t1 = _this.scanner, start = new A._SpanScannerState(t1, t1._string_scanner$_position);
                if (!_this.scanIdentifier$1("url")) return null;
                if (!t1.scanChar$1(40)) {
                    t1.set$state(start);
                    return null;
                }
                _this.whitespace$1$consumeNewlines(true);
                buffer = new A.StringBuffer("");
                buffer._contents = "url(";
                for(;;){
                    _0_0 = t1.peekChar$0();
                    if (_0_0 == null) break;
                    if (92 === _0_0) {
                        t2 = _this.escape$0();
                        buffer._contents += t2;
                        continue;
                    }
                    t2 = true;
                    if (37 !== _0_0) {
                        if (38 !== _0_0) {
                            if (35 !== _0_0) t2 = _0_0 >= 42 && _0_0 <= 126 || _0_0 >= 128;
                        }
                    }
                    if (t2) {
                        t2 = A.Primitives_stringFromCharCode(t1.readChar$0());
                        buffer._contents += t2;
                        continue;
                    }
                    if (_0_0 === 32 || _0_0 === 9 || _0_0 === 10 || _0_0 === 13 || _0_0 === 12) {
                        _this.whitespace$1$consumeNewlines(true);
                        if (t1.peekChar$0() !== 41) break;
                        continue;
                    }
                    if (41 === _0_0) {
                        t2 = A.Primitives_stringFromCharCode(t1.readChar$0());
                        t2 = buffer._contents += t2;
                        return t2.charCodeAt(0) == 0 ? t2 : t2;
                    }
                    break;
                }
                t1.set$state(start);
                return null;
            },
            variableName$0: function() {
                this.scanner.expectChar$1(36);
                return this.identifier$1$normalize(true);
            },
            escape$1$identifierStart: function(identifierStart) {
                var value, _0_0, i, next, t2, _$exception, _s25_ = "Expected escape sequence.", t1 = this.scanner, start = t1._string_scanner$_position;
                t1.expectChar$1(92);
                value = 0;
                $label0$1: {
                    _0_0 = t1.peekChar$0();
                    if (_0_0 == null) t1.error$1(0, _s25_);
                    if (_0_0 === 10 || _0_0 === 13 || _0_0 === 12) t1.error$1(0, _s25_);
                    if (A.CharacterExtension_get_isHex0(_0_0)) {
                        for(i = 0; i < 6; ++i){
                            next = t1.peekChar$0();
                            if (next != null) {
                                t2 = true;
                                if (!(next >= 48 && next <= 57)) {
                                    if (!(next >= 97 && next <= 102)) t2 = next >= 65 && next <= 70;
                                }
                                t2 = !t2;
                            } else t2 = true;
                            if (t2) break;
                            value *= 16;
                            value += A.asHex0(t1.readChar$0());
                        }
                        this.scanCharIf$1(new A.Parser_escape_closure0());
                        break $label0$1;
                    }
                    value = t1.readChar$0();
                }
                if (identifierStart) {
                    t2 = value;
                    t2 = t2 === 95 || A.CharacterExtension_get_isAlphabetic0(t2) || t2 >= 128;
                } else {
                    t2 = value;
                    if (!(t2 === 95 || A.CharacterExtension_get_isAlphabetic0(t2) || t2 >= 128)) t2 = t2 >= 48 && t2 <= 57 || t2 === 45;
                    else t2 = true;
                }
                if (t2) try {
                    t2 = A.Primitives_stringFromCharCode(value);
                    return t2;
                } catch (exception) {
                    if (type$.RangeError._is(A.unwrapException(exception))) t1.error$3$length$position(0, "Invalid Unicode code point.", t1._string_scanner$_position - start, start);
                    else throw exception;
                }
                else {
                    t1 = true;
                    if (!(value <= 31)) {
                        if (!J.$eq$(value, 127)) {
                            if (identifierStart) {
                                t1 = value;
                                t1 = t1 >= 48 && t1 <= 57;
                            } else t1 = false;
                        }
                    }
                    if (t1) {
                        t1 = A.Primitives_stringFromCharCode(92);
                        if (value > 15) t1 += A.Primitives_stringFromCharCode(A.hexCharFor0(B.JSNumber_methods._shrOtherPositive$1(value, 4)));
                        t1 = t1 + A.Primitives_stringFromCharCode(A.hexCharFor0(value & 15)) + A.Primitives_stringFromCharCode(32);
                        return t1.charCodeAt(0) == 0 ? t1 : t1;
                    } else return A.String_String$fromCharCodes(A._setArrayType([
                        92,
                        value
                    ], type$.JSArray_int), 0, null);
                }
            },
            escape$0: function() {
                return this.escape$1$identifierStart(false);
            },
            scanCharIf$1: function(condition) {
                var t1 = this.scanner;
                if (!condition.call$1(t1.peekChar$0())) return false;
                t1.readChar$0();
                return true;
            },
            scanIdentChar$2$caseSensitive: function(char, caseSensitive) {
                var t3, t1 = new A.Parser_scanIdentChar_matches0(caseSensitive, char), t2 = this.scanner, _0_0 = t2.peekChar$0();
                if (_0_0 != null) t3 = t1.call$1(_0_0);
                else t3 = false;
                if (t3) {
                    t2.readChar$0();
                    return true;
                }
                if (92 === _0_0) {
                    t3 = t2._string_scanner$_position;
                    if (t1.call$1(A.consumeEscapedCharacter0(t2))) return true;
                    t2.set$state(new A._SpanScannerState(t2, t3));
                }
                return false;
            },
            scanIdentChar$1: function(char) {
                return this.scanIdentChar$2$caseSensitive(char, false);
            },
            expectIdentChar$1: function(letter) {
                var t1;
                if (this.scanIdentChar$2$caseSensitive(letter, false)) return;
                t1 = this.scanner;
                t1.error$2$position(0, 'Expected "' + A.Primitives_stringFromCharCode(letter) + '".', t1._string_scanner$_position);
            },
            lookingAtIdentifier$1: function($forward) {
                var t1, _1_0, t2, _0_0;
                if ($forward == null) $forward = 0;
                t1 = this.scanner;
                _1_0 = t1.peekChar$1($forward);
                $label0$0: {
                    if (A._isInt(_1_0)) t2 = _1_0 === 95 || A.CharacterExtension_get_isAlphabetic0(_1_0) || _1_0 >= 128;
                    else t2 = false;
                    if (t2 || 92 === _1_0) {
                        t1 = true;
                        break $label0$0;
                    }
                    if (45 === _1_0) {
                        _0_0 = t1.peekChar$1($forward + 1);
                        $label1$1: {
                            if (A._isInt(_0_0)) t1 = _0_0 === 95 || A.CharacterExtension_get_isAlphabetic0(_0_0) || _0_0 >= 128;
                            else t1 = false;
                            t1 = t1 || 92 === _0_0 || 45 === _0_0;
                            break $label1$1;
                        }
                        break $label0$0;
                    }
                    t1 = false;
                    break $label0$0;
                }
                return t1;
            },
            lookingAtIdentifier$0: function() {
                return this.lookingAtIdentifier$1(null);
            },
            lookingAtIdentifierBody$0: function() {
                var t1, next = this.scanner.peekChar$0();
                if (next != null) {
                    if (!(next === 95 || A.CharacterExtension_get_isAlphabetic0(next) || next >= 128)) t1 = next >= 48 && next <= 57 || next === 45;
                    else t1 = true;
                    t1 = t1 || next === 92;
                } else t1 = false;
                return t1;
            },
            scanIdentifier$2$caseSensitive: function(text, caseSensitive) {
                var t1, t2, _this = this;
                if (!_this.lookingAtIdentifier$0()) return false;
                t1 = _this.scanner;
                t2 = t1._string_scanner$_position;
                if (_this._parser1$_consumeIdentifier$2(text, caseSensitive) && !_this.lookingAtIdentifierBody$0()) return true;
                else {
                    t1.set$state(new A._SpanScannerState(t1, t2));
                    return false;
                }
            },
            scanIdentifier$1: function(text) {
                return this.scanIdentifier$2$caseSensitive(text, false);
            },
            _parser1$_consumeIdentifier$2: function(text, caseSensitive) {
                var t1, t2, t3;
                for(t1 = new A.CodeUnits(text), t2 = type$.CodeUnits, t1 = new A.ListIterator(t1, t1.get$length(0), t2._eval$1("ListIterator<ListBase.E>")), t2 = t2._eval$1("ListBase.E"); t1.moveNext$0();){
                    t3 = t1.__internal$_current;
                    if (!this.scanIdentChar$2$caseSensitive(t3 == null ? t2._as(t3) : t3, caseSensitive)) return false;
                }
                return true;
            },
            expectIdentifier$2$name: function(text, $name) {
                var t1, start, t2, t3, t4, t5, t6;
                if ($name == null) $name = '"' + text + '"';
                t1 = this.scanner;
                start = t1._string_scanner$_position;
                for(t2 = new A.CodeUnits(text), t3 = type$.CodeUnits, t2 = new A.ListIterator(t2, t2.get$length(0), t3._eval$1("ListIterator<ListBase.E>")), t4 = "Expected " + $name, t5 = t4 + ".", t3 = t3._eval$1("ListBase.E"); t2.moveNext$0();){
                    t6 = t2.__internal$_current;
                    if (this.scanIdentChar$2$caseSensitive(t6 == null ? t3._as(t6) : t6, false)) continue;
                    t1.error$2$position(0, t5, start);
                }
                if (!this.lookingAtIdentifierBody$0()) return;
                t1.error$2$position(0, t4, start);
            },
            expectIdentifier$1: function(text) {
                return this.expectIdentifier$2$name(text, null);
            },
            rawText$1: function(consumer) {
                var t1 = this.scanner, start = t1._string_scanner$_position;
                consumer.call$0();
                return t1.substring$1(0, start);
            },
            spanFrom$2: function(start, end) {
                var span = this.scanner.spanFrom$2(start, end);
                return this._parser1$_interpolationMap == null ? span : new A.LazyFileSpan0(new A.Parser_spanFrom_closure0(this, span));
            },
            spanFrom$1: function(start) {
                return this.spanFrom$2(start, null);
            },
            spanFromPosition$2: function(start, end) {
                var span = this.scanner.spanFromPosition$2(start, end);
                return this._parser1$_interpolationMap == null ? span : new A.LazyFileSpan0(new A.Parser_spanFromPosition_closure0(this, span));
            },
            spanFromPosition$1: function(start) {
                return this.spanFromPosition$2(start, null);
            },
            error$3: function(_, message, span, trace) {
                var exception = new A.StringScannerException(this.scanner.string, message, span);
                if (trace == null) throw A.wrapException(exception);
                else A.throwWithTrace0(exception, this.get$error(this), trace);
            },
            error$2: function(_, message, span) {
                return this.error$3(0, message, span, null);
            },
            withErrorMessage$1$2: function(message, callback) {
                var error, stackTrace, t1, _$exception;
                try {
                    t1 = callback.call$0();
                    return t1;
                } catch (exception) {
                    t1 = A.unwrapException(exception);
                    if (type$.SourceSpanFormatException._is(t1)) {
                        error = t1;
                        stackTrace = A.getTraceFromException(exception);
                        t1 = J.get$span$x(error);
                        A.throwWithTrace0(new A.SourceSpanFormatException(error.get$source(), message, t1), error, stackTrace);
                    } else throw exception;
                }
            },
            withErrorMessage$2: function(message, callback) {
                return this.withErrorMessage$1$2(message, callback, type$.dynamic);
            },
            wrapSpanFormatException$1$1: function(callback) {
                var error, stackTrace, map, mapped, error0, stackTrace0, span, secondarySpans, t1, t2, span0, description, _0_0, error1, stackTrace1, span1, t3, _$exception, t4, _this = this, _s8_ = "expected";
                try {
                    try {
                        t3 = callback.call$0();
                        return t3;
                    } catch (exception) {
                        t3 = A.unwrapException(exception);
                        if (type$.SourceSpanFormatException._is(t3)) {
                            error = t3;
                            stackTrace = A.getTraceFromException(exception);
                            map = _this._parser1$_interpolationMap;
                            if (map == null) throw exception;
                            mapped = map.mapException$1(error);
                            t3 = mapped;
                            t4 = error;
                            if (t3 == null ? t4 == null : t3 === t4) throw exception;
                            A.throwWithTrace0(mapped, error, stackTrace);
                        } else throw exception;
                    }
                } catch (exception) {
                    t3 = A.unwrapException(exception);
                    if (type$.MultiSourceSpanFormatException._is(t3)) {
                        error0 = t3;
                        stackTrace0 = A.getTraceFromException(exception);
                        span = J.get$span$x(error0);
                        t3 = type$.FileSpan;
                        t4 = type$.String;
                        secondarySpans = error0.get$secondarySpans().cast$2$0(0, t3, t4);
                        if (A.startsWithIgnoreCase0(error0._span_exception$_message, _s8_)) {
                            span = _this._parser1$_adjustExceptionSpan$1(span);
                            t1 = A.LinkedHashMap_LinkedHashMap$_empty(t3, t4);
                            for(t3 = A.MapExtensions_get_pairs0(secondarySpans, t3, t4), t3 = t3.get$iterator(t3); t3.moveNext$0();){
                                t2 = t3.get$current(t3);
                                span0 = null;
                                description = null;
                                _0_0 = t2;
                                span0 = _0_0._0;
                                description = _0_0._1;
                                J.$indexSet$ax(t1, _this._parser1$_adjustExceptionSpan$1(span0), description);
                            }
                            secondarySpans = t1;
                        }
                        A.throwWithTrace0(A.MultiSpanSassFormatException$0(error0._span_exception$_message, span, error0.get$primaryLabel(), secondarySpans, null), error0, stackTrace0);
                    } else if (type$.SourceSpanFormatException._is(t3)) {
                        error1 = t3;
                        stackTrace1 = A.getTraceFromException(exception);
                        span1 = J.get$span$x(error1);
                        if (A.startsWithIgnoreCase0(error1._span_exception$_message, _s8_)) span1 = _this._parser1$_adjustExceptionSpan$1(span1);
                        t1 = error1._span_exception$_message;
                        t2 = span1;
                        A.throwWithTrace0(new A.SassFormatException0(B.Set_empty, t1, t2), error1, stackTrace1);
                    } else throw exception;
                }
            },
            wrapSpanFormatException$1: function(callback) {
                return this.wrapSpanFormatException$1$1(callback, type$.dynamic);
            },
            _parser1$_adjustExceptionSpan$1: function(span) {
                var start, t1;
                if (span.get$length(span) > 0) return span;
                start = this._parser1$_firstNewlineBefore$1(span.get$start(span));
                if (start.$eq(0, span.get$start(span))) t1 = span;
                else {
                    t1 = start.offset;
                    t1 = A._FileSpan$(start.file, t1, t1);
                }
                return t1;
            },
            _parser1$_firstNewlineBefore$1: function($location) {
                var lastNewline, codeUnit, t1 = $location.file, t2 = $location.offset, text = A.String_String$fromCharCodes(B.NativeUint32List_methods.sublist$2(t1._decodedChars, 0, t2), 0, null), index = t2 - 1;
                for(lastNewline = null; index >= 0;){
                    codeUnit = text.charCodeAt(index);
                    if (!(codeUnit === 32 || codeUnit === 9 || codeUnit === 10 || codeUnit === 13 || codeUnit === 12)) {
                        if (lastNewline == null) t1 = $location;
                        else {
                            t2 = new A.FileLocation(t1, lastNewline);
                            t2.FileLocation$_$2(t1, lastNewline);
                            t1 = t2;
                        }
                        return t1;
                    }
                    if (codeUnit === 10 || codeUnit === 13 || codeUnit === 12) lastNewline = index;
                    --index;
                }
                return $location;
            }
        };
        A.Parser__parseIdentifier_closure0.prototype = {
            call$0: function() {
                var t1 = this.$this, result = t1.identifier$0();
                t1.scanner.expectDone$0();
                return result;
            },
            $signature: 29
        };
        A.Parser_escape_closure0.prototype = {
            call$1: function(char) {
                return char === 32 || char === 9 || char === 10 || char === 13 || char === 12;
            },
            $signature: 31
        };
        A.Parser_scanIdentChar_matches0.prototype = {
            call$1: function(actual) {
                var t1 = this.char;
                return this.caseSensitive ? actual === t1 : A.characterEqualsIgnoreCase0(t1, actual);
            },
            $signature: 50
        };
        A.Parser_spanFrom_closure0.prototype = {
            call$0: function() {
                var t1 = this.$this._parser1$_interpolationMap;
                if (t1 == null) t1 = type$.InterpolationMap_2._as(t1);
                return t1.mapSpan$1(this.span);
            },
            $signature: 16
        };
        A.Parser_spanFromPosition_closure0.prototype = {
            call$0: function() {
                var t1 = this.$this._parser1$_interpolationMap;
                if (t1 == null) t1 = type$.InterpolationMap_2._as(t1);
                return t1.mapSpan$1(this.span);
            },
            $signature: 16
        };
        A.InterpolatedPlaceholderSelector.prototype = {
            get$span: function(_) {
                var t1 = this.name.span;
                return t1.get$file(t1).span$2(0, t1.get$start(t1).offset - 1, t1.get$end(t1).offset);
            },
            accept$1$1: function(visitor) {
                return J.visitPlaceholderSelector$1$x(visitor._simple_selector$_inner, this);
            },
            accept$1: function(visitor) {
                return this.accept$1$1(visitor, type$.dynamic);
            },
            toString$0: function(_) {
                return "%" + this.name.toString$0(0);
            }
        };
        A.PlaceholderSelector0.prototype = {
            accept$1$1: function(visitor) {
                return visitor.visitPlaceholderSelector$1(0, this);
            },
            accept$1: function(visitor) {
                return this.accept$1$1(visitor, type$.dynamic);
            },
            addSuffix$1: function(suffix) {
                return new A.PlaceholderSelector0(this.name + suffix, this.span);
            },
            $eq: function(_, other) {
                if (other == null) return false;
                return other instanceof A.PlaceholderSelector0 && other.name === this.name;
            },
            get$hashCode: function(_) {
                return B.JSString_methods.get$hashCode(this.name);
            }
        };
        A.PlainCssCallable0.prototype = {
            $eq: function(_, other) {
                if (other == null) return false;
                return other instanceof A.PlainCssCallable0 && this.name === other.name;
            },
            get$hashCode: function(_) {
                return B.JSString_methods.get$hashCode(this.name);
            },
            $isAsyncCallable0: 1,
            $isCallable: 1,
            get$name: function(receiver) {
                return this.name;
            }
        };
        A.PrefixedMapView0.prototype = {
            get$keys: function(_) {
                return new A._PrefixedKeys0(this);
            },
            get$length: function(_) {
                var t1 = this._prefixed_map_view0$_map;
                return t1.get$length(t1);
            },
            get$isEmpty: function(_) {
                var t1 = this._prefixed_map_view0$_map;
                return t1.get$isEmpty(t1);
            },
            get$isNotEmpty: function(_) {
                var t1 = this._prefixed_map_view0$_map;
                return t1.get$isNotEmpty(t1);
            },
            $index: function(_, key) {
                return typeof key == "string" && B.JSString_methods.startsWith$1(key, this._prefixed_map_view0$_prefix) ? this._prefixed_map_view0$_map.$index(0, B.JSString_methods.substring$1(key, this._prefixed_map_view0$_prefix.length)) : null;
            },
            containsKey$1: function(key) {
                return typeof key == "string" && B.JSString_methods.startsWith$1(key, this._prefixed_map_view0$_prefix) && this._prefixed_map_view0$_map.containsKey$1(B.JSString_methods.substring$1(key, this._prefixed_map_view0$_prefix.length));
            }
        };
        A._PrefixedKeys0.prototype = {
            get$length: function(_) {
                var t1 = this._prefixed_map_view0$_view._prefixed_map_view0$_map;
                return t1.get$length(t1);
            },
            get$iterator: function(_) {
                var t1 = this._prefixed_map_view0$_view._prefixed_map_view0$_map;
                t1 = t1.get$keys(t1);
                t1 = t1.map$1$1(t1, new A._PrefixedKeys_iterator_closure0(this), type$.String);
                return t1.get$iterator(t1);
            },
            contains$1: function(_, key) {
                return this._prefixed_map_view0$_view.containsKey$1(key);
            }
        };
        A._PrefixedKeys_iterator_closure0.prototype = {
            call$1: function(key) {
                return this.$this._prefixed_map_view0$_view._prefixed_map_view0$_prefix + key;
            },
            $signature: 6
        };
        A.ProphotoRgbColorSpace0.prototype = {
            get$isBoundedInternal: function() {
                return true;
            },
            toLinear$1: function(channel) {
                var abs = Math.abs(channel);
                return abs <= 0.03125 ? channel / 16 : J.get$sign$in(channel) * Math.pow(abs, 1.8);
            },
            fromLinear$1: function(channel) {
                var abs = Math.abs(channel);
                return abs >= 0.001953125 ? J.get$sign$in(channel) * Math.pow(abs, 0.5555555555555556) : 16 * channel;
            },
            transformationMatrix$1: function(dest) {
                var t1;
                $label0$0: {
                    if (B.SrgbLinearColorSpace_kUj0 === dest || B.SrgbColorSpace_thf0 === dest || B.RgbColorSpace_i0P0 === dest) {
                        t1 = $.$get$linearProphotoRgbToLinearSrgb0();
                        break $label0$0;
                    }
                    if (B.A98RgbColorSpace_lf20 === dest) {
                        t1 = $.$get$linearProphotoRgbToLinearA98Rgb0();
                        break $label0$0;
                    }
                    if (B.DisplayP3ColorSpace_MmT0 === dest || B.DisplayP3LinearColorSpace_PrP0 === dest) {
                        t1 = $.$get$linearProphotoRgbToLinearDisplayP30();
                        break $label0$0;
                    }
                    if (B.Rec2020ColorSpace_6oo0 === dest) {
                        t1 = $.$get$linearProphotoRgbToLinearRec20200();
                        break $label0$0;
                    }
                    if (B.XyzD65ColorSpace_WiJ0 === dest) {
                        t1 = $.$get$linearProphotoRgbToXyzD650();
                        break $label0$0;
                    }
                    if (B.XyzD50ColorSpace_2OB0 === dest) {
                        t1 = $.$get$linearProphotoRgbToXyzD500();
                        break $label0$0;
                    }
                    if (B.LmsColorSpace_Os30 === dest) {
                        t1 = $.$get$linearProphotoRgbToLms0();
                        break $label0$0;
                    }
                    t1 = this.super$ColorSpace$transformationMatrix0(dest);
                    break $label0$0;
                }
                return t1;
            }
        };
        A.InterpolatedPseudoSelector.prototype = {
            accept$1$1: function(visitor) {
                return J.visitPseudoSelector$1$x(visitor._simple_selector$_inner, this);
            },
            accept$1: function(visitor) {
                return this.accept$1$1(visitor, type$.dynamic);
            },
            toString$0: function(_) {
                var t2, _1_0, _this = this, t1 = _this.isSyntacticClass ? ":" : "::", result = t1 + _this.name.toString$0(0);
                t1 = _this.argument;
                t2 = t1 == null;
                if (!t2 || _this.selector != null) {
                    result += "(";
                    if (!t2) {
                        result += t1.toString$0(0);
                        if (_this.selector != null) result += " ";
                    }
                    _1_0 = _this.selector;
                    result = (_1_0 != null ? result + B.JSArray_methods.join$1(_1_0.components, ", ") : result) + ")";
                }
                return result;
            },
            get$span: function(receiver) {
                return this.span;
            }
        };
        A.PseudoSelector0.prototype = {
            get$isHostContext: function() {
                return this.isClass && this.name === "host-context" && this.selector != null;
            },
            get$hasComplicatedSuperselectorSemantics: function() {
                return !this.isClass || this.selector != null;
            },
            get$specificity: function() {
                var result, _this = this, value = _this._pseudo$__PseudoSelector_specificity_FI;
                if (value === $) {
                    result = new A.PseudoSelector_specificity_closure0(_this).call$0();
                    _this._pseudo$__PseudoSelector_specificity_FI !== $ && A.throwUnnamedLateFieldADI();
                    _this._pseudo$__PseudoSelector_specificity_FI = result;
                    value = result;
                }
                return value;
            },
            withSelector$1: function(selector) {
                var _this = this;
                return A.PseudoSelector$0(_this.name, _this.span, _this.argument, !_this.isClass, selector);
            },
            addSuffix$1: function(suffix) {
                var _this = this;
                if (_this.argument != null || _this.selector != null) _this.super$SimpleSelector$addSuffix0(suffix);
                return A.PseudoSelector$0(_this.name + suffix, _this.span, null, !_this.isClass, null);
            },
            unify$1: function(compound) {
                var other, result, t2, addedThis, _i, simple, _this = this, t1 = _this.name;
                if (t1 === "host" || t1 === "host-context") {
                    if (!B.JSArray_methods.every$1(compound, new A.PseudoSelector_unify_closure0())) return null;
                } else {
                    t1 = false;
                    if (compound.length === 1) {
                        other = compound[0];
                        if (!(other instanceof A.UniversalSelector0)) {
                            if (other instanceof A.PseudoSelector0) t1 = other.isClass && other.name === "host" || other.get$isHostContext();
                        } else t1 = true;
                    } else other = null;
                    if (t1) return other.unify$1(A._setArrayType([
                        _this
                    ], type$.JSArray_SimpleSelector_2));
                }
                if (B.JSArray_methods.contains$1(compound, _this)) return compound;
                result = A._setArrayType([], type$.JSArray_SimpleSelector_2);
                for(t1 = compound.length, t2 = !_this.isClass, addedThis = false, _i = 0; _i < compound.length; compound.length === t1 || (0, A.throwConcurrentModificationError)(compound), ++_i){
                    simple = compound[_i];
                    if (simple instanceof A.PseudoSelector0 && !simple.isClass) {
                        if (t2) return null;
                        result.push(_this);
                        addedThis = true;
                    }
                    result.push(simple);
                }
                if (!addedThis) result.push(_this);
                return result;
            },
            isSuperselector$1: function(other) {
                var selector, t1, t2, _this = this;
                if (_this.super$SimpleSelector$isSuperselector0(other)) return true;
                selector = _this.selector;
                if (selector == null) return _this.$eq(0, other);
                if (other instanceof A.PseudoSelector0 && !_this.isClass && !other.isClass && _this.normalizedName === "slotted" && other.name === _this.name) {
                    t1 = A.NullableExtension_andThen0(other.selector, selector.get$isSuperselector());
                    return t1 == null ? false : t1;
                }
                t1 = type$.JSArray_SimpleSelector_2;
                t2 = _this.span;
                return A.compoundIsSuperselector0(A.CompoundSelector$0(A._setArrayType([
                    _this
                ], t1), t2), A.CompoundSelector$0(A._setArrayType([
                    other
                ], t1), t2), null);
            },
            accept$1$1: function(visitor) {
                return visitor.visitPseudoSelector$1(0, this);
            },
            accept$1: function(visitor) {
                return this.accept$1$1(visitor, type$.dynamic);
            },
            $eq: function(_, other) {
                var _this = this;
                if (other == null) return false;
                return other instanceof A.PseudoSelector0 && other.name === _this.name && other.isClass === _this.isClass && other.argument == _this.argument && J.$eq$(other.selector, _this.selector);
            },
            get$hashCode: function(_) {
                var _this = this, t1 = B.JSString_methods.get$hashCode(_this.name), t2 = !_this.isClass ? 519018 : 218159;
                return t1 ^ t2 ^ J.get$hashCode$(_this.argument) ^ J.get$hashCode$(_this.selector);
            }
        };
        A.PseudoSelector_specificity_closure0.prototype = {
            call$0: function() {
                var selector, t2, t1 = this.$this;
                if (!t1.isClass) return 1;
                selector = t1.selector;
                if (selector == null) return A.SimpleSelector0.prototype.get$specificity.call(t1);
                switch(t1.normalizedName){
                    case "where":
                        return 0;
                    case "is":
                    case "not":
                    case "has":
                    case "matches":
                        t1 = selector.components;
                        return A.IterableIntegerExtension_get_max(new A.MappedListIterable(t1, new A.PseudoSelector_specificity__closure1(), A._arrayInstanceType(t1)._eval$1("MappedListIterable<1,int>")));
                    case "nth-child":
                    case "nth-last-child":
                        t1 = A.SimpleSelector0.prototype.get$specificity.call(t1);
                        t2 = selector.components;
                        return t1 + A.IterableIntegerExtension_get_max(new A.MappedListIterable(t2, new A.PseudoSelector_specificity__closure2(), A._arrayInstanceType(t2)._eval$1("MappedListIterable<1,int>")));
                    default:
                        return A.SimpleSelector0.prototype.get$specificity.call(t1);
                }
            },
            $signature: 10
        };
        A.PseudoSelector_specificity__closure1.prototype = {
            call$1: function(component) {
                return component.get$specificity();
            },
            $signature: 261
        };
        A.PseudoSelector_specificity__closure2.prototype = {
            call$1: function(component) {
                return component.get$specificity();
            },
            $signature: 261
        };
        A.PseudoSelector_unify_closure0.prototype = {
            call$1: function(simple) {
                var t1;
                if (simple instanceof A.PseudoSelector0) t1 = simple.isClass && simple.name === "host" || simple.selector != null;
                else t1 = false;
                return t1;
            },
            $signature: 15
        };
        A.PublicMemberMapView0.prototype = {
            get$keys: function(_) {
                var t1 = this._public_member_map_view0$_inner;
                t1 = t1.get$keys(t1);
                return t1.where$1(t1, A.utils1__isPublic$closure());
            },
            containsKey$1: function(key) {
                return typeof key == "string" && A.isPublic0(key) && this._public_member_map_view0$_inner.containsKey$1(key);
            },
            $index: function(_, key) {
                if (typeof key == "string" && A.isPublic0(key)) return this._public_member_map_view0$_inner.$index(0, key);
                return null;
            }
        };
        A.InterpolatedQualifiedName.prototype = {
            toString$0: function(_) {
                var t1, _0_0 = this.namespace;
                $label0$0: {
                    if (_0_0 != null) {
                        t1 = _0_0.toString$0(0) + "|" + this.name.toString$0(0);
                        break $label0$0;
                    }
                    t1 = this.name.toString$0(0);
                    break $label0$0;
                }
                return t1;
            },
            $isAstNode0: 1,
            $isSassNode: 1,
            get$span: function(receiver) {
                return this.span;
            }
        };
        A.QualifiedName0.prototype = {
            $eq: function(_, other) {
                if (other == null) return false;
                return other instanceof A.QualifiedName0 && other.name === this.name && other.namespace == this.namespace;
            },
            get$hashCode: function(_) {
                return B.JSString_methods.get$hashCode(this.name) ^ J.get$hashCode$(this.namespace);
            },
            toString$0: function(_) {
                var t1 = this.namespace, t2 = this.name;
                return t1 == null ? t2 : t1 + "|" + t2;
            }
        };
        A.Rec2020ColorSpace0.prototype = {
            get$isBoundedInternal: function() {
                return true;
            },
            toLinear$1: function(channel) {
                var abs = Math.abs(channel);
                return abs < 0.08124285829863151 ? channel / 4.5 : J.get$sign$in(channel) * Math.pow((abs + 1.09929682680944 - 1) / 1.09929682680944, 2.2222222222222223);
            },
            fromLinear$1: function(channel) {
                var abs = Math.abs(channel);
                return abs > 0.018053968510807 ? J.get$sign$in(channel) * (1.09929682680944 * Math.pow(abs, 0.45) - 0.09929682680944008) : 4.5 * channel;
            },
            transformationMatrix$1: function(dest) {
                var t1;
                $label0$0: {
                    if (B.SrgbLinearColorSpace_kUj0 === dest || B.SrgbColorSpace_thf0 === dest || B.RgbColorSpace_i0P0 === dest) {
                        t1 = $.$get$linearRec2020ToLinearSrgb0();
                        break $label0$0;
                    }
                    if (B.A98RgbColorSpace_lf20 === dest) {
                        t1 = $.$get$linearRec2020ToLinearA98Rgb0();
                        break $label0$0;
                    }
                    if (B.DisplayP3ColorSpace_MmT0 === dest || B.DisplayP3LinearColorSpace_PrP0 === dest) {
                        t1 = $.$get$linearRec2020ToLinearDisplayP30();
                        break $label0$0;
                    }
                    if (B.ProphotoRgbColorSpace_BDz0 === dest) {
                        t1 = $.$get$linearRec2020ToLinearProphotoRgb0();
                        break $label0$0;
                    }
                    if (B.XyzD65ColorSpace_WiJ0 === dest) {
                        t1 = $.$get$linearRec2020ToXyzD650();
                        break $label0$0;
                    }
                    if (B.XyzD50ColorSpace_2OB0 === dest) {
                        t1 = $.$get$linearRec2020ToXyzD500();
                        break $label0$0;
                    }
                    if (B.LmsColorSpace_Os30 === dest) {
                        t1 = $.$get$linearRec2020ToLms0();
                        break $label0$0;
                    }
                    t1 = this.super$ColorSpace$transformationMatrix0(dest);
                    break $label0$0;
                }
                return t1;
            }
        };
        A.JSClass0.prototype = {};
        A.JSClassExtension_setCustomInspect_closure.prototype = {
            call$4: function($self, _, __, ___) {
                return this.inspect.call$1($self);
            },
            call$3: function($self, _, __) {
                return this.call$4($self, _, __, null);
            },
            "call*": "call$4",
            $requiredArgCount: 3,
            $defaultValues: function() {
                return [
                    null
                ];
            },
            $signature: 585
        };
        A.JSClassExtension_get_defineStaticMethod_closure.prototype = {
            call$2: function($name, body) {
                this._this[$name] = A.allowInteropNamed($name, body);
                return null;
            },
            $signature: 135
        };
        A.JSClassExtension_get_defineMethod_closure.prototype = {
            call$2: function($name, body) {
                J.get$$prototype$x(this._this)[$name] = A.allowInteropCaptureThisNamed($name, body);
                return null;
            },
            $signature: 135
        };
        A.JSClassExtension_get_defineGetter_closure.prototype = {
            call$2: function($name, body) {
                A.defineGetter(J.get$$prototype$x(this._this), $name, body, null);
                return null;
            },
            $signature: 135
        };
        A.RenderContext0.prototype = {};
        A.RenderContextOptions0.prototype = {};
        A.RenderContextResult0.prototype = {};
        A.RenderContextResultStats0.prototype = {};
        A.RenderOptions.prototype = {};
        A.RenderResult.prototype = {};
        A.RenderResultStats.prototype = {};
        A.ReplaceExpressionVisitor0.prototype = {
            visitBinaryOperationExpression$1: function(_, node) {
                return new A.BinaryOperationExpression0(node.operator, node.left.accept$1(this), node.right.accept$1(this), false);
            },
            visitBooleanExpression$1: function(_, node) {
                return node;
            },
            visitColorExpression$1: function(_, node) {
                return node;
            },
            visitFunctionExpression$1: function(_, node) {
                var t1 = node.originalName, t2 = this.visitArgumentList$1(node.$arguments);
                return new A.FunctionExpression0(node.namespace, A.stringReplaceAllUnchecked(t1, "_", "-"), t1, t2, node.span);
            },
            visitInterpolatedFunctionExpression$1: function(_, node) {
                return new A.InterpolatedFunctionExpression0(this.visitInterpolation$1(node.name), this.visitArgumentList$1(node.$arguments), node.span);
            },
            visitLegacyIfExpression$1: function(_, node) {
                return new A.LegacyIfExpression0(this.visitArgumentList$1(node.$arguments), node.span);
            },
            visitListExpression$1: function(_, node) {
                var t1 = node.contents;
                return new A.ListExpression0(A.List_List$unmodifiable(new A.MappedListIterable(t1, new A.ReplaceExpressionVisitor_visitListExpression_closure0(this), A._arrayInstanceType(t1)._eval$1("MappedListIterable<1,Expression0>")), type$.Expression_2), node.separator, node.hasBrackets, node.span);
            },
            visitMapExpression$1: function(_, node) {
                var t2, t3, _i, t4, t1 = A._setArrayType([], type$.JSArray_Record_2_Expression_and_Expression_2);
                for(t2 = node.pairs, t3 = t2.length, _i = 0; _i < t3; ++_i){
                    t4 = t2[_i];
                    t1.push(new A._Record_2(t4._0.accept$1(this), t4._1.accept$1(this)));
                }
                return new A.MapExpression0(A.List_List$unmodifiable(t1, type$.Record_2_Expression_and_Expression_2), node.span);
            },
            visitNullExpression$1: function(_, node) {
                return node;
            },
            visitNumberExpression$1: function(_, node) {
                return node;
            },
            visitParenthesizedExpression$1: function(_, node) {
                return new A.ParenthesizedExpression0(node.expression.accept$1(this), node.span);
            },
            visitSelectorExpression$1: function(_, node) {
                return node;
            },
            visitStringExpression$1: function(_, node) {
                return new A.StringExpression0(this.visitInterpolation$1(node.text), node.hasQuotes);
            },
            visitSupportsExpression$1: function(_, node) {
                return new A.SupportsExpression0(this.visitSupportsCondition$1(node.condition));
            },
            visitUnaryOperationExpression$1: function(_, node) {
                return new A.UnaryOperationExpression0(node.operator, node.operand.accept$1(this), node.span);
            },
            visitValueExpression$1: function(_, node) {
                return node;
            },
            visitVariableExpression$1: function(_, node) {
                return node;
            },
            visitIfConditionParenthesized$1: function(_, node) {
                return new A.IfConditionParenthesized0(node.expression.accept$1(this), node.span);
            },
            visitIfConditionNegation$1: function(_, node) {
                return new A.IfConditionNegation0(node.expression.accept$1(this), node.span);
            },
            visitIfConditionOperation$1: function(_, node) {
                var t1 = node.expressions;
                return A.IfConditionOperation$0(new A.MappedListIterable(t1, new A.ReplaceExpressionVisitor_visitIfConditionOperation_closure0(this), A._arrayInstanceType(t1)._eval$1("MappedListIterable<1,IfConditionExpression0>")), node.op);
            },
            visitIfConditionFunction$1: function(_, node) {
                return new A.IfConditionFunction0(this.visitInterpolation$1(node.name), this.visitInterpolation$1(node.$arguments), node.span);
            },
            visitIfConditionSass$1: function(_, node) {
                return new A.IfConditionSass0(node.expression.accept$1(this), node.span);
            },
            visitIfConditionRaw$1: function(_, node) {
                return new A.IfConditionRaw0(this.visitInterpolation$1(node.text));
            },
            visitArgumentList$1: function(invocation) {
                var _this = this, t1 = invocation.positional, t2 = type$.String, t3 = type$.Expression_2, t4 = A.LinkedHashMap_LinkedHashMap$_empty(t2, t3);
                for(t2 = A.MapExtensions_get_pairs0(invocation.named, t2, t3), t2 = t2.get$iterator(t2); t2.moveNext$0();){
                    t3 = t2.get$current(t2);
                    t4.$indexSet(0, t3._0, t3._1.accept$1(_this));
                }
                t2 = invocation.rest;
                t2 = t2 == null ? null : t2.accept$1(_this);
                t3 = invocation.keywordRest;
                t3 = t3 == null ? null : t3.accept$1(_this);
                return A.ArgumentList$0(new A.MappedListIterable(t1, new A.ReplaceExpressionVisitor_visitArgumentList_closure0(_this), A._arrayInstanceType(t1)._eval$1("MappedListIterable<1,Expression0>")), t4, invocation.namedSpans, invocation.span, t3, t2);
            },
            visitSupportsCondition$1: function(condition) {
                var _this = this;
                if (condition instanceof A.SupportsOperation0) return new A.SupportsOperation0(_this.visitSupportsCondition$1(condition.left), _this.visitSupportsCondition$1(condition.right), condition.operator, condition.span);
                else if (condition instanceof A.SupportsNegation0) return new A.SupportsNegation0(_this.visitSupportsCondition$1(condition.condition), condition.span);
                else if (condition instanceof A.SupportsInterpolation0) return new A.SupportsInterpolation0(condition.expression.accept$1(_this), condition.span);
                else if (condition instanceof A.SupportsDeclaration0) return new A.SupportsDeclaration0(condition.name.accept$1(_this), condition.value.accept$1(_this), condition.span);
                else throw A.wrapException(A.SassException$0("BUG: Unknown SupportsCondition " + condition.toString$0(0) + ".", condition.get$span(condition), null));
            },
            visitInterpolation$1: function(interpolation) {
                var t1 = interpolation.contents;
                return A.Interpolation$0(new A.MappedListIterable(t1, new A.ReplaceExpressionVisitor_visitInterpolation_closure0(this), A._arrayInstanceType(t1)._eval$1("MappedListIterable<1,Object>")), interpolation.spans, interpolation.span);
            }
        };
        A.ReplaceExpressionVisitor_visitListExpression_closure0.prototype = {
            call$1: function(item) {
                return item.accept$1(this.$this);
            },
            $signature: 262
        };
        A.ReplaceExpressionVisitor_visitIfConditionOperation_closure0.prototype = {
            call$1: function(expression) {
                return expression.accept$1(this.$this);
            },
            $signature: 588
        };
        A.ReplaceExpressionVisitor_visitArgumentList_closure0.prototype = {
            call$1: function(expression) {
                return expression.accept$1(this.$this);
            },
            $signature: 262
        };
        A.ReplaceExpressionVisitor_visitInterpolation_closure0.prototype = {
            call$1: function(node) {
                return node instanceof A.Expression0 ? node.accept$1(this.$this) : node;
            },
            $signature: 75
        };
        A.ImporterResult0.prototype = {
            get$sourceMapUrl: function(_) {
                var t1 = this._result$_sourceMapUrl;
                return t1 == null ? A.Uri_Uri$dataFromString(this.contents, B.C_Utf8Codec, null) : t1;
            }
        };
        A.ReturnRule0.prototype = {
            accept$1$1: function(visitor) {
                return visitor.visitReturnRule$1(0, this);
            },
            accept$1: function(visitor) {
                return this.accept$1$1(visitor, type$.dynamic);
            },
            toString$0: function(_) {
                return "@return " + this.expression.toString$0(0) + ";";
            },
            get$span: function(receiver) {
                return this.span;
            }
        };
        A.RgbColorSpace0.prototype = {
            get$isBoundedInternal: function() {
                return true;
            },
            get$isLegacyInternal: function() {
                return true;
            },
            convert$5: function(dest, red, green, blue, alpha) {
                var t1 = red == null ? null : red / 255, t2 = green == null ? null : green / 255;
                return B.SrgbColorSpace_thf0.convert$5(dest, t1, t2, blue == null ? null : blue / 255, alpha);
            },
            toLinear$1: function(channel) {
                return A.srgbAndDisplayP3ToLinear0(channel / 255);
            },
            fromLinear$1: function(channel) {
                return A.srgbAndDisplayP3FromLinear0(channel) * 255;
            }
        };
        A.SassParser0.prototype = {
            get$currentIndentation: function() {
                return this._sass0$_currentIndentation;
            },
            get$indented: function() {
                return true;
            },
            styleRuleSelector$0: function() {
                var t4, _this = this, t1 = _this.scanner, t2 = t1._string_scanner$_position, t3 = new A.StringBuffer(""), buffer = new A.InterpolationBuffer0(t3, A._setArrayType([], type$.JSArray_Object), A._setArrayType([], type$.JSArray_nullable_FileSpan));
                do {
                    buffer.addInterpolation$1(_this.almostAnyValue$1$omitComments(true));
                    t4 = A.Primitives_stringFromCharCode(10);
                    t4 = t3._contents += t4;
                }while (B.JSString_methods.endsWith$1(B.JSString_methods.trimRight$0(t4.charCodeAt(0) == 0 ? t4 : t4), ",") && _this.scanCharIf$1(new A.SassParser_styleRuleSelector_closure0()));
                return buffer.interpolation$1(_this.spanFrom$1(new A._SpanScannerState(t1, t2)));
            },
            expectStatementSeparator$1: function($name) {
                var t1, _this = this, trailingSemicolon = _this._sass0$_tryTrailingSemicolon$0();
                if (!_this.atEndOfStatement$0()) _this._sass0$_expectNewline$1$trailingSemicolon(trailingSemicolon);
                if (_this._sass0$_peekIndentation$0() <= _this._sass0$_currentIndentation) return;
                t1 = $name == null ? "here" : "beneath a " + $name;
                _this.scanner.error$2$position(0, "Nothing may be indented " + t1 + ".", _this._sass0$_nextIndentationEnd.position);
            },
            expectStatementSeparator$0: function() {
                return this.expectStatementSeparator$1(null);
            },
            atEndOfStatement$0: function() {
                var t1 = this.scanner.peekChar$0();
                if (t1 == null) t1 = null;
                else t1 = t1 === 10 || t1 === 13 || t1 === 12;
                return t1 !== false;
            },
            lookingAtChildren$0: function() {
                return this.atEndOfStatement$0() && this._sass0$_peekIndentation$0() > this._sass0$_currentIndentation;
            },
            importArgument$0: function() {
                var url, span, innerError, stackTrace, t1, _0_0, start, t2, next, t3, _$exception, _this = this;
                $label0$0: {
                    t1 = _this.scanner;
                    _0_0 = t1.peekChar$0();
                    if (117 === _0_0 || 85 === _0_0) {
                        start = new A._SpanScannerState(t1, t1._string_scanner$_position);
                        if (_this.scanIdentifier$1("url")) {
                            if (t1.scanChar$1(40)) {
                                t1.set$state(start);
                                return _this.super$StylesheetParser$importArgument0();
                            } else t1.set$state(start);
                        }
                        break $label0$0;
                    }
                    if (39 === _0_0 || 34 === _0_0) return _this.super$StylesheetParser$importArgument0();
                }
                t2 = t1._string_scanner$_position;
                next = t1.peekChar$0();
                for(;;){
                    t3 = false;
                    if (next != null) {
                        if (next !== 44) {
                            if (next !== 59) t3 = !(next === 10 || next === 13 || next === 12);
                        }
                    }
                    if (!t3) break;
                    t1.readChar$0();
                    next = t1.peekChar$0();
                }
                url = t1.substring$1(0, t2);
                span = _this.spanFrom$1(new A._SpanScannerState(t1, t2));
                if (_this.isPlainImportUrl$1(url)) return new A.StaticImport0(new A.Interpolation0(A.List_List$unmodifiable([
                    A.serializeValue0(new A.SassString0(url, true), true, true)
                ], type$.Object), B.List_null, span), null, span);
                else try {
                    t1 = _this.parseImportUrl$1(url);
                    return new A.DynamicImport0(t1, span);
                } catch (exception) {
                    t1 = A.unwrapException(exception);
                    if (type$.FormatException._is(t1)) {
                        innerError = t1;
                        stackTrace = A.getTraceFromException(exception);
                        _this.error$3(0, "Invalid URL: " + J.get$message$x(innerError), span, stackTrace);
                    } else throw exception;
                }
            },
            scanElse$1: function(ifIndentation) {
                var t1, t2, startIndentation, startNextIndentation, startNextIndentationEnd, _this = this;
                if (_this._sass0$_peekIndentation$0() !== ifIndentation) return false;
                t1 = _this.scanner;
                t2 = t1._string_scanner$_position;
                startIndentation = _this._sass0$_currentIndentation;
                startNextIndentation = _this._sass0$_nextIndentation;
                startNextIndentationEnd = _this._sass0$_nextIndentationEnd;
                _this._sass0$_readIndentation$0();
                if (t1.scanChar$1(64) && _this.scanIdentifier$1("else")) return true;
                t1.set$state(new A._SpanScannerState(t1, t2));
                _this._sass0$_currentIndentation = startIndentation;
                _this._sass0$_nextIndentation = startNextIndentation;
                _this._sass0$_nextIndentationEnd = startNextIndentationEnd;
                return false;
            },
            children$1: function(_, child) {
                var children = A._setArrayType([], type$.JSArray_Statement_2);
                this._sass0$_whileIndentedLower$1(new A.SassParser_children_closure0(this, child, children));
                return children;
            },
            statements$1: function(statement) {
                var statements, t2, _1_0, t1 = this.scanner, _0_0 = t1.peekChar$0();
                if (9 === _0_0 || 32 === _0_0) t1.error$3$length$position(0, string$.Indent, t1._string_scanner$_position, 0);
                statements = A._setArrayType([], type$.JSArray_Statement_2);
                for(t2 = t1.string.length; t1._string_scanner$_position !== t2;){
                    _1_0 = this._sass0$_child$1(statement);
                    if (_1_0 != null) statements.push(_1_0);
                    this._sass0$_readIndentation$0();
                }
                return statements;
            },
            _sass0$_child$1: function(child) {
                var _0_0, _this = this, t1 = _this.scanner, _1_0 = t1.peekChar$0();
                $label0$0: {
                    if (13 === _1_0 || 10 === _1_0 || 12 === _1_0) {
                        t1 = null;
                        break $label0$0;
                    }
                    if (36 === _1_0) {
                        t1 = _this.variableDeclarationWithoutNamespace$0();
                        break $label0$0;
                    }
                    if (47 === _1_0) {
                        _0_0 = t1.peekChar$1(1);
                        $label1$1: {
                            if (47 === _0_0) {
                                t1 = _this._sass0$_silentComment$0();
                                break $label1$1;
                            }
                            if (42 === _0_0) {
                                t1 = _this._sass0$_loudComment$0();
                                break $label1$1;
                            }
                            t1 = child.call$0();
                            break $label1$1;
                        }
                        break $label0$0;
                    }
                    t1 = child.call$0();
                    break $label0$0;
                }
                return t1;
            },
            _sass0$_silentComment$0: function() {
                var buffer, parentIndentation, t3, t4, t5, commentPrefix, i, t6, i0, t7, _this = this, t1 = _this.scanner, t2 = t1._string_scanner$_position;
                t1.expect$1("//");
                buffer = new A.StringBuffer("");
                parentIndentation = _this._sass0$_currentIndentation;
                t3 = t1.string.length;
                t4 = 1 + parentIndentation;
                t5 = 2 + parentIndentation;
                $label0$0: do {
                    commentPrefix = t1.scanChar$1(47) ? "///" : "//";
                    for(i = commentPrefix.length;;){
                        t6 = buffer._contents += commentPrefix;
                        for(i0 = i; i0 < _this._sass0$_currentIndentation - parentIndentation; ++i0){
                            t6 += A.Primitives_stringFromCharCode(32);
                            buffer._contents = t6;
                        }
                        for(;;){
                            if (t1._string_scanner$_position !== t3) {
                                t7 = t1.peekChar$0();
                                t7 = !(t7 === 10 || t7 === 13 || t7 === 12);
                            } else t7 = false;
                            if (!t7) break;
                            t6 += A.Primitives_stringFromCharCode(t1.readChar$0());
                            buffer._contents = t6;
                        }
                        buffer._contents = t6 + "\n";
                        if (_this._sass0$_peekIndentation$0() < parentIndentation) break $label0$0;
                        if (_this._sass0$_peekIndentation$0() === parentIndentation) {
                            if (t1.peekChar$1(t4) === 47 && t1.peekChar$1(t5) === 47) _this._sass0$_readIndentation$0();
                            break;
                        }
                        _this._sass0$_readIndentation$0();
                    }
                }while (t1.scan$1("//"));
                t3 = buffer._contents;
                return _this.lastSilentComment = new A.SilentComment0(t3.charCodeAt(0) == 0 ? t3 : t3, _this.spanFrom$1(new A._SpanScannerState(t1, t2)));
            },
            _sass0$_loudComment$0: function() {
                var t2, t3, t4, buffer, parentIndentation, t5, t6, first, beginningOfComment, t7, end, i, _1_0, _0_0, span, _this = this, t1 = _this.scanner, start = new A._SpanScannerState(t1, t1._string_scanner$_position);
                t1.expect$1("/*");
                t2 = new A.StringBuffer("");
                t3 = A._setArrayType([], type$.JSArray_Object);
                t4 = A._setArrayType([], type$.JSArray_nullable_FileSpan);
                buffer = new A.InterpolationBuffer0(t2, t3, t4);
                t2._contents = "/*";
                parentIndentation = _this._sass0$_currentIndentation;
                for(t5 = t1.string, t6 = t5.length, first = true;; first = false){
                    if (first) {
                        beginningOfComment = t1._string_scanner$_position;
                        _this.spaces$0();
                        t7 = t1.peekChar$0();
                        if (t7 === 10 || t7 === 13 || t7 === 12) {
                            _this._sass0$_readIndentation$0();
                            t7 = A.Primitives_stringFromCharCode(32);
                            t2._contents += t7;
                        } else {
                            end = t1._string_scanner$_position;
                            t2._contents += B.JSString_methods.substring$2(t5, beginningOfComment, end);
                        }
                    } else t2._contents = (t2._contents += "\n") + " * ";
                    for(i = 3; i < _this._sass0$_currentIndentation - parentIndentation; ++i){
                        t7 = A.Primitives_stringFromCharCode(32);
                        t2._contents += t7;
                    }
                    while(t1._string_scanner$_position !== t6){
                        _1_0 = t1.peekChar$0();
                        if (10 === _1_0 || 13 === _1_0 || 12 === _1_0) break;
                        if (35 === _1_0) {
                            if (t1.peekChar$1(1) === 123) {
                                _0_0 = _this.singleInterpolation$0();
                                buffer._interpolation_buffer0$_flushText$0();
                                t3.push(_0_0._0);
                                t4.push(_0_0._1);
                            } else {
                                t7 = A.Primitives_stringFromCharCode(t1.readChar$0());
                                t2._contents += t7;
                            }
                            continue;
                        }
                        if (42 === _1_0) {
                            if (t1.peekChar$1(1) === 47) {
                                t3 = A.Primitives_stringFromCharCode(t1.readChar$0());
                                t2._contents += t3;
                                t3 = A.Primitives_stringFromCharCode(t1.readChar$0());
                                t2._contents += t3;
                                span = _this.spanFrom$1(start);
                                _this.whitespace$1$consumeNewlines(false);
                                for(;;){
                                    t2 = t1.peekChar$0();
                                    if (!((t2 === 10 || t2 === 13 || t2 === 12) && _this._sass0$_peekIndentation$0() > parentIndentation)) break;
                                    while(_this._sass0$_lookingAtDoubleNewline$0())_this._sass0$_expectNewline$0();
                                    _this._sass0$_readIndentation$0();
                                    _this.whitespace$1$consumeNewlines(false);
                                }
                                if (t1._string_scanner$_position !== t6) {
                                    t2 = t1.peekChar$0();
                                    t2 = !(t2 === 10 || t2 === 13 || t2 === 12);
                                } else t2 = false;
                                if (t2) {
                                    t2 = t1._string_scanner$_position;
                                    for(;;){
                                        if (t1._string_scanner$_position !== t6) {
                                            t3 = t1.peekChar$0();
                                            t3 = !(t3 === 10 || t3 === 13 || t3 === 12);
                                        } else t3 = false;
                                        if (!t3) break;
                                        t1.readChar$0();
                                    }
                                    throw A.wrapException(A.MultiSpanSassFormatException$0("Unexpected text after end of comment", _this.spanFrom$1(new A._SpanScannerState(t1, t2)), "extra text", A.LinkedHashMap_LinkedHashMap$_literal([
                                        span,
                                        "comment"
                                    ], type$.FileSpan, type$.String), null));
                                } else return new A.LoudComment0(buffer.interpolation$1(span));
                            } else {
                                t7 = A.Primitives_stringFromCharCode(t1.readChar$0());
                                t2._contents += t7;
                            }
                            continue;
                        }
                        t7 = A.Primitives_stringFromCharCode(t1.readChar$0());
                        t2._contents += t7;
                    }
                    if (_this._sass0$_peekIndentation$0() <= parentIndentation) break;
                    while(_this._sass0$_lookingAtDoubleNewline$0()){
                        _this._sass0$_expectNewline$0();
                        t2._contents = (t2._contents += "\n") + " *";
                    }
                    _this._sass0$_readIndentation$0();
                }
                return new A.LoudComment0(buffer.interpolation$1(_this.spanFrom$1(start)));
            },
            whitespaceWithoutComments$1$consumeNewlines: function(consumeNewlines) {
                var t1, t2, next, t3;
                for(t1 = this.scanner, t2 = t1.string.length; t1._string_scanner$_position !== t2;){
                    next = t1.peekChar$0();
                    if (consumeNewlines) t3 = !(next === 32 || next === 9 || next === 10 || next === 13 || next === 12);
                    else t3 = !(next === 32 || next === 9);
                    if (t3) break;
                    t1.readChar$0();
                }
            },
            _sass0$_expectNewline$1$trailingSemicolon: function(trailingSemicolon) {
                var t1 = this.scanner, _0_0 = t1.peekChar$0();
                if (13 === _0_0) {
                    t1.readChar$0();
                    if (t1.peekChar$0() === 10) t1.readChar$0();
                    return;
                }
                if (10 === _0_0 || 12 === _0_0) {
                    t1.readChar$0();
                    return;
                }
                t1.error$1(0, trailingSemicolon ? string$.multip : "expected newline.");
            },
            _sass0$_expectNewline$0: function() {
                return this._sass0$_expectNewline$1$trailingSemicolon(false);
            },
            _sass0$_lookingAtDoubleNewline$0: function() {
                var t2, _0_0, t1 = this.scanner, _1_0 = t1.peekChar$0();
                $label1$1: {
                    t2 = false;
                    if (13 === _1_0) {
                        _0_0 = t1.peekChar$1(1);
                        $label0$0: {
                            if (10 === _0_0) {
                                t1 = t1.peekChar$1(2);
                                t1 = t1 === 10 || t1 === 13 || t1 === 12;
                                break $label0$0;
                            }
                            if (13 === _0_0 || 12 === _0_0) {
                                t1 = true;
                                break $label0$0;
                            }
                            t1 = t2;
                            break $label0$0;
                        }
                        break $label1$1;
                    }
                    if (10 === _1_0 || 12 === _1_0) {
                        t1 = t1.peekChar$1(1);
                        t1 = t1 === 10 || t1 === 13 || t1 === 12;
                        break $label1$1;
                    }
                    t1 = t2;
                    break $label1$1;
                }
                return t1;
            },
            _sass0$_whileIndentedLower$1: function(body) {
                var t1, t2, childIndentation, indentation, t3, t4, _this = this, parentIndentation = _this._sass0$_currentIndentation;
                for(t1 = _this.scanner, t2 = t1._sourceFile, childIndentation = null; _this._sass0$_peekIndentation$0() > parentIndentation;){
                    indentation = _this._sass0$_readIndentation$0();
                    if (childIndentation == null) childIndentation = indentation;
                    if (childIndentation !== indentation) {
                        t3 = t1._string_scanner$_position;
                        t4 = t2.getColumn$1(t3);
                        t1.error$3$length$position(0, "Inconsistent indentation, expected " + childIndentation + " spaces.", t2.getColumn$1(t1._string_scanner$_position), t3 - t4);
                    }
                    body.call$0();
                }
            },
            _sass0$_readIndentation$0: function() {
                var t1, _this = this, currentIndentation = _this._sass0$_nextIndentation;
                if (currentIndentation == null) currentIndentation = _this._sass0$_nextIndentation = _this._sass0$_peekIndentation$0();
                _this._sass0$_currentIndentation = currentIndentation;
                t1 = _this._sass0$_nextIndentationEnd;
                t1.toString;
                _this.scanner.set$state(t1);
                _this._sass0$_nextIndentationEnd = _this._sass0$_nextIndentation = null;
                return currentIndentation;
            },
            _sass0$_peekIndentation$0: function() {
                var t1, t2, t3, start, containsTab, containsSpace, nextIndentation, _1_0, t4, _this = this, _0_0 = _this._sass0$_nextIndentation;
                if (_0_0 != null) return _0_0;
                t1 = _this.scanner;
                t2 = t1._string_scanner$_position;
                t3 = t1.string.length;
                if (t2 === t3) {
                    _this._sass0$_nextIndentation = 0;
                    _this._sass0$_nextIndentationEnd = new A._SpanScannerState(t1, t2);
                    return 0;
                }
                start = new A._SpanScannerState(t1, t2);
                if (!_this.scanCharIf$1(new A.SassParser__peekIndentation_closure1())) t1.error$2$position(0, "Expected newline.", t1._string_scanner$_position);
                containsTab = A._Cell$();
                containsSpace = A._Cell$();
                nextIndentation = A._Cell$();
                do {
                    containsSpace.__late_helper$_value = containsTab.__late_helper$_value = false;
                    nextIndentation.__late_helper$_value = 0;
                    for(;;){
                        $label0$0: {
                            _1_0 = t1.peekChar$0();
                            if (32 === _1_0) {
                                containsSpace.__late_helper$_value = true;
                                break $label0$0;
                            }
                            if (9 === _1_0) {
                                containsTab.__late_helper$_value = true;
                                break $label0$0;
                            }
                            break;
                        }
                        t2 = nextIndentation.__late_helper$_value;
                        if (t2 === nextIndentation) A.throwExpression(A.LateError$localNI(""));
                        nextIndentation.__late_helper$_value = t2 + 1;
                        t1.readChar$0();
                    }
                    t2 = t1._string_scanner$_position;
                    if (t2 === t3) {
                        _this._sass0$_nextIndentation = 0;
                        _this._sass0$_nextIndentationEnd = new A._SpanScannerState(t1, t2);
                        t1.set$state(start);
                        return 0;
                    }
                }while (_this.scanCharIf$1(new A.SassParser__peekIndentation_closure2()));
                t2 = containsTab._readLocal$0();
                t3 = containsSpace._readLocal$0();
                if (t2) {
                    if (t3) {
                        t2 = t1._string_scanner$_position;
                        t3 = t1._sourceFile;
                        t4 = t3.getColumn$1(t2);
                        t1.error$3$length$position(0, "Tabs and spaces may not be mixed.", t3.getColumn$1(t1._string_scanner$_position), t2 - t4);
                    } else if (_this._sass0$_spaces === true) {
                        t2 = t1._string_scanner$_position;
                        t3 = t1._sourceFile;
                        t4 = t3.getColumn$1(t2);
                        t1.error$3$length$position(0, "Expected spaces, was tabs.", t3.getColumn$1(t1._string_scanner$_position), t2 - t4);
                    }
                } else if (t3 && _this._sass0$_spaces === false) {
                    t2 = t1._string_scanner$_position;
                    t3 = t1._sourceFile;
                    t4 = t3.getColumn$1(t2);
                    t1.error$3$length$position(0, "Expected tabs, was spaces.", t3.getColumn$1(t1._string_scanner$_position), t2 - t4);
                }
                _this._sass0$_nextIndentation = nextIndentation._readLocal$0();
                if (nextIndentation._readLocal$0() > 0) {
                    if (_this._sass0$_spaces == null) _this._sass0$_spaces = containsSpace._readLocal$0();
                }
                _this._sass0$_nextIndentationEnd = new A._SpanScannerState(t1, t1._string_scanner$_position);
                t1.set$state(start);
                return nextIndentation._readLocal$0();
            },
            _sass0$_tryTrailingSemicolon$0: function() {
                if (this.scanCharIf$1(new A.SassParser__tryTrailingSemicolon_closure0())) {
                    this.whitespace$1$consumeNewlines(false);
                    return true;
                }
                return false;
            }
        };
        A.SassParser_styleRuleSelector_closure0.prototype = {
            call$1: function(char) {
                return char === 10 || char === 13 || char === 12;
            },
            $signature: 31
        };
        A.SassParser_children_closure0.prototype = {
            call$0: function() {
                var _0_0 = this.$this._sass0$_child$1(this.child);
                if (_0_0 != null) this.children.push(_0_0);
            },
            $signature: 0
        };
        A.SassParser__peekIndentation_closure1.prototype = {
            call$1: function(char) {
                return char === 10 || char === 13 || char === 12;
            },
            $signature: 31
        };
        A.SassParser__peekIndentation_closure2.prototype = {
            call$1: function(char) {
                return char === 10 || char === 13 || char === 12;
            },
            $signature: 31
        };
        A.SassParser__tryTrailingSemicolon_closure0.prototype = {
            call$1: function(char) {
                return char === 59;
            },
            $signature: 31
        };
        A._Exports.prototype = {};
        A._wrapMain_closure.prototype = {
            call$1: function(_) {
                return A._translateReturnValue(this.main.call$0());
            },
            $signature: 108
        };
        A._wrapMain_closure0.prototype = {
            call$1: function(args) {
                return A._translateReturnValue(this.main.call$1(A.List_List$from(type$.List_dynamic._as(args), true, type$.String)));
            },
            $signature: 108
        };
        A.ScssParser0.prototype = {
            get$indented: function() {
                return false;
            },
            get$currentIndentation: function() {
                return 0;
            },
            styleRuleSelector$0: function() {
                return this.almostAnyValue$0();
            },
            expectStatementSeparator$1: function($name) {
                var t1, _0_0;
                this.whitespaceWithoutComments$1$consumeNewlines(true);
                t1 = this.scanner;
                if (t1._string_scanner$_position === t1.string.length) return;
                _0_0 = t1.peekChar$0();
                if (59 === _0_0 || 125 === _0_0) return;
                t1.expectChar$1(59);
            },
            expectStatementSeparator$0: function() {
                return this.expectStatementSeparator$1(null);
            },
            atEndOfStatement$0: function() {
                var next = this.scanner.peekChar$0();
                return next == null || next === 59 || next === 125 || next === 123;
            },
            lookingAtChildren$0: function() {
                return this.scanner.peekChar$0() === 123;
            },
            scanElse$1: function(ifIndentation) {
                var t3, _this = this, t1 = _this.scanner, t2 = t1._string_scanner$_position;
                _this.whitespace$1$consumeNewlines(true);
                t3 = t1._string_scanner$_position;
                if (t1.scanChar$1(64)) {
                    if (_this.scanIdentifier$2$caseSensitive("else", true)) return true;
                    if (_this.scanIdentifier$2$caseSensitive("elseif", true)) {
                        _this.warnings.push(new A._Record_3_deprecation_message_span(B.Deprecation_VUl, string$.x40elsei, _this.spanFrom$1(new A._SpanScannerState(t1, t3))));
                        t1.set$position(t1._string_scanner$_position - 2);
                        return true;
                    }
                }
                t1.set$state(new A._SpanScannerState(t1, t2));
                return false;
            },
            children$1: function(_, child) {
                var children, _this = this, t1 = _this.scanner;
                t1.expectChar$1(123);
                _this.whitespaceWithoutComments$1$consumeNewlines(true);
                children = A._setArrayType([], type$.JSArray_Statement_2);
                for(;;)switch(t1.peekChar$0()){
                    case 36:
                        children.push(_this.variableDeclarationWithoutNamespace$0());
                        break;
                    case 47:
                        switch(t1.peekChar$1(1)){
                            case 47:
                                children.push(_this._scss0$_silentComment$0());
                                _this.whitespaceWithoutComments$1$consumeNewlines(true);
                                break;
                            case 42:
                                children.push(_this._scss0$_loudComment$0());
                                _this.whitespaceWithoutComments$1$consumeNewlines(true);
                                break;
                            default:
                                children.push(child.call$0());
                        }
                        break;
                    case 59:
                        t1.readChar$0();
                        _this.whitespaceWithoutComments$1$consumeNewlines(true);
                        break;
                    case 125:
                        t1.expectChar$1(125);
                        return children;
                    default:
                        children.push(child.call$0());
                }
            },
            statements$1: function(statement) {
                var t1, t2, _0_0, _1_0, _this = this, statements = A._setArrayType([], type$.JSArray_Statement_2);
                _this.whitespaceWithoutComments$1$consumeNewlines(true);
                for(t1 = _this.scanner, t2 = t1.string.length; t1._string_scanner$_position !== t2;)switch(t1.peekChar$0()){
                    case 36:
                        statements.push(_this.variableDeclarationWithoutNamespace$0());
                        break;
                    case 47:
                        switch(t1.peekChar$1(1)){
                            case 47:
                                statements.push(_this._scss0$_silentComment$0());
                                _this.whitespaceWithoutComments$1$consumeNewlines(true);
                                break;
                            case 42:
                                statements.push(_this._scss0$_loudComment$0());
                                _this.whitespaceWithoutComments$1$consumeNewlines(true);
                                break;
                            default:
                                _0_0 = statement.call$0();
                                if (_0_0 != null) statements.push(_0_0);
                        }
                        break;
                    case 59:
                        t1.readChar$0();
                        _this.whitespaceWithoutComments$1$consumeNewlines(true);
                        break;
                    default:
                        _1_0 = statement.call$0();
                        if (_1_0 != null) statements.push(_1_0);
                }
                return statements;
            },
            _scss0$_silentComment$0: function() {
                var t3, t4, _this = this, t1 = _this.scanner, t2 = t1._string_scanner$_position, start = new A._SpanScannerState(t1, t2);
                t1.expect$1("//");
                t3 = t1.string.length;
                do {
                    for(;;){
                        if (t1._string_scanner$_position !== t3) {
                            t4 = t1.readChar$0();
                            t4 = !(t4 === 10 || t4 === 13 || t4 === 12);
                        } else t4 = false;
                        if (!t4) break;
                    }
                    if (t1._string_scanner$_position === t3) break;
                    _this.spaces$0();
                }while (t1.scan$1("//"));
                if (_this.get$plainCss()) _this.error$2(0, string$.Silent, _this.spanFrom$1(start));
                return _this.lastSilentComment = new A.SilentComment0(t1.substring$1(0, t2), _this.spanFrom$1(start));
            },
            _scss0$_loudComment$0: function() {
                var t3, t4, t5, buffer, _0_0, t6, t1 = this.scanner, t2 = t1._string_scanner$_position;
                t1.expect$1("/*");
                t3 = new A.StringBuffer("");
                t4 = A._setArrayType([], type$.JSArray_Object);
                t5 = A._setArrayType([], type$.JSArray_nullable_FileSpan);
                buffer = new A.InterpolationBuffer0(t3, t4, t5);
                t3._contents = "/*";
                $label0$1: for(;;)switch(t1.peekChar$0()){
                    case 35:
                        if (t1.peekChar$1(1) === 123) {
                            _0_0 = this.singleInterpolation$0();
                            buffer._interpolation_buffer0$_flushText$0();
                            t4.push(_0_0._0);
                            t5.push(_0_0._1);
                        } else {
                            t6 = A.Primitives_stringFromCharCode(t1.readChar$0());
                            t3._contents += t6;
                        }
                        break;
                    case 42:
                        t6 = A.Primitives_stringFromCharCode(t1.readChar$0());
                        t3._contents += t6;
                        if (t1.peekChar$0() !== 47) continue $label0$1;
                        t4 = A.Primitives_stringFromCharCode(t1.readChar$0());
                        t3._contents += t4;
                        return new A.LoudComment0(buffer.interpolation$1(this.spanFrom$1(new A._SpanScannerState(t1, t2))));
                    case 13:
                        t1.readChar$0();
                        if (t1.peekChar$0() !== 10) {
                            t6 = A.Primitives_stringFromCharCode(10);
                            t3._contents += t6;
                        }
                        break;
                    case 12:
                        t1.readChar$0();
                        t6 = A.Primitives_stringFromCharCode(10);
                        t3._contents += t6;
                        break;
                    default:
                        t6 = A.Primitives_stringFromCharCode(t1.readChar$0());
                        t3._contents += t6;
                }
            }
        };
        A.Selector0.prototype = {
            assertNotBogus$1$name: function($name) {
                if (!this.accept$1(B._IsBogusVisitor_true0)) return;
                A.warnForDeprecation0("$" + $name + ": " + (this.toString$0(0) + string$.x20is_nov), B.Deprecation_2PR);
            },
            toString$0: function(_) {
                var _null = null, visitor = A._SerializeVisitor$0(_null, true, _null, _null, true, false, _null, true);
                this.accept$1(visitor);
                return visitor._serialize0$_buffer.toString$0(0);
            },
            $isAstNode0: 1,
            get$span: function(receiver) {
                return this.span;
            }
        };
        A._IsInvisibleVisitor2.prototype = {
            visitSelectorList$1: function(list) {
                return B.JSArray_methods.every$1(list.components, this.get$visitComplexSelector());
            },
            visitComplexSelector$1: function(complex) {
                var t1;
                if (!this.super$AnySelectorVisitor$visitComplexSelector0(complex)) t1 = this.includeBogus && complex.accept$1(B._IsBogusVisitor_false0);
                else t1 = true;
                return t1;
            },
            visitPlaceholderSelector$1: function(_, placeholder) {
                return true;
            },
            visitPseudoSelector$1: function(_, pseudo) {
                var t1, _0_0 = pseudo.selector;
                if (_0_0 != null) {
                    if (pseudo.name === "not") t1 = this.includeBogus && _0_0.accept$1(B._IsBogusVisitor_true0);
                    else t1 = this.visitSelectorList$1(_0_0);
                    return t1;
                } else return false;
            }
        };
        A._IsBogusVisitor0.prototype = {
            visitComplexSelector$1: function(complex) {
                var t2, t1 = complex.components;
                if (t1.length === 0) return complex.leadingCombinators.length !== 0;
                else {
                    t2 = this.includeLeadingCombinator ? 0 : 1;
                    return complex.leadingCombinators.length > t2 || B.JSArray_methods.get$last(t1).combinators.length !== 0 || B.JSArray_methods.any$1(t1, new A._IsBogusVisitor_visitComplexSelector_closure0(this));
                }
            },
            visitPseudoSelector$1: function(_, pseudo) {
                var selector = pseudo.selector;
                if (selector == null) return false;
                return pseudo.name === "has" ? selector.accept$1(B._IsBogusVisitor_false0) : selector.accept$1(B._IsBogusVisitor_true0);
            }
        };
        A._IsBogusVisitor_visitComplexSelector_closure0.prototype = {
            call$1: function(component) {
                return component.combinators.length > 1 || this.$this.visitCompoundSelector$1(component.selector);
            },
            $signature: 55
        };
        A._IsUselessVisitor0.prototype = {
            visitComplexSelector$1: function(complex) {
                return complex.leadingCombinators.length > 1 || B.JSArray_methods.any$1(complex.components, new A._IsUselessVisitor_visitComplexSelector_closure0(this));
            },
            visitPseudoSelector$1: function(_, pseudo) {
                return pseudo.accept$1(B._IsBogusVisitor_true0);
            }
        };
        A._IsUselessVisitor_visitComplexSelector_closure0.prototype = {
            call$1: function(component) {
                return component.combinators.length > 1 || this.$this.visitCompoundSelector$1(component.selector);
            },
            $signature: 55
        };
        A._ContainsParentSelectorVisitor0.prototype = {
            visitParentSelector$1: function(_, _0) {
                return true;
            }
        };
        A.__ContainsParentSelectorVisitor_Object_AnySelectorVisitor0.prototype = {};
        A.__IsBogusVisitor_Object_AnySelectorVisitor0.prototype = {};
        A.__IsInvisibleVisitor_Object_AnySelectorVisitor0.prototype = {};
        A.__IsUselessVisitor_Object_AnySelectorVisitor0.prototype = {};
        A.SelectorExpression0.prototype = {
            accept$1$1: function(visitor) {
                return visitor.visitSelectorExpression$1(0, this);
            },
            accept$1: function(visitor) {
                return this.accept$1$1(visitor, type$.dynamic);
            },
            toString$0: function(_) {
                return "&";
            },
            get$span: function(receiver) {
                return this.span;
            }
        };
        A._nest_closure0.prototype = {
            call$1: function($arguments) {
                var t1 = J.$index$asx($arguments, 0).get$asList();
                t1 = new A.MappedListIterable(t1, new A._nest__closure1(), A._arrayInstanceType(t1)._eval$1("MappedListIterable<1,SelectorList0>")).fold$2(0, null, new A._nest__closure2());
                t1 = t1 == null ? null : t1.get$asSassList();
                return t1 == null ? A.throwExpression(A.SassScriptException$0(string$.x24selec, null)) : t1;
            },
            $signature: 27
        };
        A._nest__closure1.prototype = {
            call$1: function(selector) {
                return A.SassApiValue_assertSelector0(selector, true, null);
            },
            $signature: 263
        };
        A._nest__closure2.prototype = {
            call$2: function($parent, child) {
                return child.nestWithin$1($parent);
            },
            $signature: 590
        };
        A._append_closure1.prototype = {
            call$1: function($arguments) {
                var t1, selectors = J.$index$asx($arguments, 0).get$asList();
                if (selectors.length === 0) throw A.wrapException(A.SassScriptException$0(string$.x24selec, null));
                t1 = A.EvaluationContext_currentOrNull0();
                return new A.MappedListIterable(selectors, new A._append__closure1(), A._arrayInstanceType(selectors)._eval$1("MappedListIterable<1,SelectorList0>")).reduce$1(0, new A._append__closure2((t1 == null ? A.throwExpression(A.StateError$(string$.No_Sass)) : t1).get$currentCallableSpan())).get$asSassList();
            },
            $signature: 27
        };
        A._append__closure1.prototype = {
            call$1: function(selector) {
                return A.SassApiValue_assertSelector0(selector, false, null);
            },
            $signature: 263
        };
        A._append__closure2.prototype = {
            call$2: function($parent, child) {
                var t1 = child.components, t2 = this.span;
                return A.SelectorList$0(new A.MappedListIterable(t1, new A._append___closure0($parent, t2), A._arrayInstanceType(t1)._eval$1("MappedListIterable<1,ComplexSelector0>")), t2).nestWithin$1($parent);
            },
            $signature: 591
        };
        A._append___closure0.prototype = {
            call$1: function(complex) {
                var _0_0, t1, component, rest, newCompound, t2, _null = null;
                if (complex.leadingCombinators.length !== 0) throw A.wrapException(A.SassScriptException$0("Can't append " + complex.toString$0(0) + " to " + this.parent.toString$0(0) + ".", _null));
                _0_0 = complex.components;
                t1 = _0_0.length >= 1;
                if (t1) {
                    component = _0_0[0];
                    rest = B.JSArray_methods.sublist$1(_0_0, 1);
                } else {
                    rest = _null;
                    component = rest;
                }
                if (!t1) throw A.wrapException(A.StateError$("Pattern matching error"));
                newCompound = A._prependParent0(component.selector);
                if (newCompound == null) throw A.wrapException(A.SassScriptException$0("Can't append " + complex.toString$0(0) + " to " + this.parent.toString$0(0) + ".", _null));
                t1 = this.span;
                t2 = A._setArrayType([
                    new A.ComplexSelectorComponent0(newCompound, A.List_List$unmodifiable(component.combinators, type$.CssValue_Combinator_2), t1)
                ], type$.JSArray_ComplexSelectorComponent_2);
                B.JSArray_methods.addAll$1(t2, rest);
                return A.ComplexSelector$0(B.List_empty17, t2, t1, false);
            },
            $signature: 59
        };
        A._extend_closure0.prototype = {
            call$1: function($arguments) {
                var target, source, _s8_ = "selector", _s8_0 = "extendee", _s8_1 = "extender", t1 = J.getInterceptor$asx($arguments), selector = A.SassApiValue_assertSelector0(t1.$index($arguments, 0), false, _s8_);
                selector.assertNotBogus$1$name(_s8_);
                target = A.SassApiValue_assertSelector0(t1.$index($arguments, 1), false, _s8_0);
                target.assertNotBogus$1$name(_s8_0);
                source = A.SassApiValue_assertSelector0(t1.$index($arguments, 2), false, _s8_1);
                source.assertNotBogus$1$name(_s8_1);
                t1 = A.EvaluationContext_currentOrNull0();
                return A.ExtensionStore__extendOrReplace0(selector, source, target, B.ExtendMode_allTargets_2_allTargets0, (t1 == null ? A.throwExpression(A.StateError$(string$.No_Sass)) : t1).get$currentCallableSpan()).get$asSassList();
            },
            $signature: 27
        };
        A._replace_closure0.prototype = {
            call$1: function($arguments) {
                var target, source, _s8_ = "selector", _s8_0 = "original", _s11_ = "replacement", t1 = J.getInterceptor$asx($arguments), selector = A.SassApiValue_assertSelector0(t1.$index($arguments, 0), false, _s8_);
                selector.assertNotBogus$1$name(_s8_);
                target = A.SassApiValue_assertSelector0(t1.$index($arguments, 1), false, _s8_0);
                target.assertNotBogus$1$name(_s8_0);
                source = A.SassApiValue_assertSelector0(t1.$index($arguments, 2), false, _s11_);
                source.assertNotBogus$1$name(_s11_);
                t1 = A.EvaluationContext_currentOrNull0();
                return A.ExtensionStore__extendOrReplace0(selector, source, target, B.ExtendMode_replace_1_replace0, (t1 == null ? A.throwExpression(A.StateError$(string$.No_Sass)) : t1).get$currentCallableSpan()).get$asSassList();
            },
            $signature: 27
        };
        A._unify_closure0.prototype = {
            call$1: function($arguments) {
                var selector2, _s9_ = "selector1", _s9_0 = "selector2", t1 = J.getInterceptor$asx($arguments), selector1 = A.SassApiValue_assertSelector0(t1.$index($arguments, 0), false, _s9_);
                selector1.assertNotBogus$1$name(_s9_);
                selector2 = A.SassApiValue_assertSelector0(t1.$index($arguments, 1), false, _s9_0);
                selector2.assertNotBogus$1$name(_s9_0);
                t1 = selector1.unify$1(selector2);
                t1 = t1 == null ? null : t1.get$asSassList();
                return t1 == null ? B.C__SassNull0 : t1;
            },
            $signature: 3
        };
        A._isSuperselector_closure0.prototype = {
            call$1: function($arguments) {
                var selector2, t1 = J.getInterceptor$asx($arguments), selector1 = A.SassApiValue_assertSelector0(t1.$index($arguments, 0), false, "super");
                selector1.assertNotBogus$1$name("super");
                selector2 = A.SassApiValue_assertSelector0(t1.$index($arguments, 1), false, "sub");
                selector2.assertNotBogus$1$name("sub");
                return A.listIsSuperselector0(selector1.components, selector2.components) ? B.SassBoolean_true0 : B.SassBoolean_false0;
            },
            $signature: 13
        };
        A._simpleSelectors_closure0.prototype = {
            call$1: function($arguments) {
                var t1 = A.SassApiValue_assertCompoundSelector0(J.$index$asx($arguments, 0), "selector").components;
                return A.SassList$0(new A.MappedListIterable(t1, new A._simpleSelectors__closure0(), A._arrayInstanceType(t1)._eval$1("MappedListIterable<1,Value0>")), B.ListSeparator_z0K0, false);
            },
            $signature: 27
        };
        A._simpleSelectors__closure0.prototype = {
            call$1: function(simple) {
                return new A.SassString0(A.serializeSelector0(simple, true), false);
            },
            $signature: 592
        };
        A._parse_closure0.prototype = {
            call$1: function($arguments) {
                return A.SassApiValue_assertSelector0(J.$index$asx($arguments, 0), false, "selector").get$asSassList();
            },
            $signature: 27
        };
        A.SelectorParser0.prototype = {
            parse$0: function(_) {
                return this.wrapSpanFormatException$1(new A.SelectorParser_parse_closure0(this));
            },
            parseCompoundSelector$0: function() {
                return this.wrapSpanFormatException$1(new A.SelectorParser_parseCompoundSelector_closure0(this));
            },
            _selector0$_selectorList$0: function() {
                var t4, t5, lineBreak, _this = this, t1 = _this.scanner, t2 = t1._string_scanner$_position, t3 = t1._sourceFile, previousLine = t3.getLine$1(t2), components = A._setArrayType([
                    _this._selector0$_complexSelector$0()
                ], type$.JSArray_ComplexSelector_2);
                _this.whitespace$1$consumeNewlines(true);
                for(t4 = t1.string.length; t1.scanChar$1(44);){
                    _this.whitespace$1$consumeNewlines(true);
                    if (t1.peekChar$0() === 44) continue;
                    t5 = t1._string_scanner$_position;
                    if (t5 === t4) break;
                    lineBreak = t3.getLine$1(t5) !== previousLine;
                    if (lineBreak) previousLine = t3.getLine$1(t1._string_scanner$_position);
                    components.push(_this._selector0$_complexSelector$1$lineBreak(lineBreak));
                }
                return A.SelectorList$0(components, _this.spanFrom$1(new A._SpanScannerState(t1, t2)));
            },
            _selector0$_complexSelector$1$lineBreak: function(lineBreak) {
                var t4, t5, lastCompound, initialCombinators, beforeWhitespace, t6, _0_0, t7, t8, result, nextCompound, _this = this, _s18_ = "expected selector.", t1 = _this.scanner, t2 = t1._string_scanner$_position, componentStart = new A._SpanScannerState(t1, t2), t3 = type$.JSArray_CssValue_Combinator_2, combinators = A._setArrayType([], t3), components = A._setArrayType([], type$.JSArray_ComplexSelectorComponent_2);
                for(t4 = type$.CssValue_Combinator_2, t5 = _this._selector0$_logger, lastCompound = null, initialCombinators = null;;){
                    beforeWhitespace = t1._string_scanner$_position;
                    _this.whitespace$1$consumeNewlines(true);
                    t6 = t1._string_scanner$_position === beforeWhitespace;
                    _0_0 = t1.peekChar$0();
                    if (43 === _0_0) {
                        t6 = t1._string_scanner$_position;
                        t1.readChar$0();
                        combinators.push(new A.CssValue0(B.Combinator_sHB0, _this.spanFrom$1(new A._SpanScannerState(t1, t6)), t4));
                        continue;
                    }
                    if (62 === _0_0) {
                        t6 = t1._string_scanner$_position;
                        t1.readChar$0();
                        combinators.push(new A.CssValue0(B.Combinator_iUF0, _this.spanFrom$1(new A._SpanScannerState(t1, t6)), t4));
                        continue;
                    }
                    if (126 === _0_0) {
                        t6 = t1._string_scanner$_position;
                        t1.readChar$0();
                        combinators.push(new A.CssValue0(B.Combinator_98W0, _this.spanFrom$1(new A._SpanScannerState(t1, t6)), t4));
                        continue;
                    }
                    if (_0_0 == null) break;
                    t7 = true;
                    if (91 !== _0_0) {
                        if (46 !== _0_0) {
                            if (35 !== _0_0) {
                                if (37 !== _0_0) {
                                    if (58 !== _0_0) {
                                        if (38 !== _0_0) {
                                            if (42 !== _0_0) {
                                                if (124 !== _0_0) t7 = _this.lookingAtIdentifier$0();
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                    if (t7) {
                        t7 = lastCompound != null;
                        if (t7) {
                            t8 = _this.spanFrom$1(componentStart);
                            result = A.List_List$from(combinators, false, t4);
                            result.$flags = 3;
                            components.push(new A.ComplexSelectorComponent0(lastCompound, result, t8));
                        } else if (combinators.length !== 0) {
                            componentStart = new A._SpanScannerState(t1, t1._string_scanner$_position);
                            initialCombinators = combinators;
                        }
                        nextCompound = _this._selector0$_compoundSelector$0();
                        if (t7 && combinators.length === 0 && t6) A.WarnForDeprecation_warnForDeprecation0(t5, B.Deprecation_ldS, string$.Adjace + lastCompound.toString$0(0) + " " + nextCompound.toString$0(0) + string$.x0a_Morex3aa, lastCompound.span.expand$1(0, nextCompound.span), null);
                        combinators = A._setArrayType([], t3);
                        if (t1.peekChar$0() === 38) t1.error$1(0, string$.x22x26__ma);
                        lastCompound = nextCompound;
                        continue;
                    }
                    break;
                }
                t3 = combinators.length !== 0;
                if (t3 && _this._selector0$_plainCss) t1.error$1(0, _s18_);
                else if (lastCompound != null) {
                    t3 = _this.spanFrom$1(componentStart);
                    components.push(new A.ComplexSelectorComponent0(lastCompound, A.List_List$unmodifiable(combinators, t4), t3));
                } else if (t3) initialCombinators = combinators;
                else t1.error$1(0, _s18_);
                t3 = initialCombinators == null ? B.List_empty17 : initialCombinators;
                return A.ComplexSelector$0(t3, components, _this.spanFrom$1(new A._SpanScannerState(t1, t2)), lineBreak);
            },
            _selector0$_complexSelector$0: function() {
                return this._selector0$_complexSelector$1$lineBreak(false);
            },
            _selector0$_compoundSelector$0: function() {
                var t3, _this = this, t1 = _this.scanner, t2 = t1._string_scanner$_position, components = A._setArrayType([
                    _this._selector0$_simpleSelector$0()
                ], type$.JSArray_SimpleSelector_2);
                for(t3 = _this._selector0$_plainCss; _this._selector0$_isSimpleSelectorStart$1(t1.peekChar$0());)components.push(_this._selector0$_simpleSelector$1$allowParent(t3));
                return A.CompoundSelector$0(components, _this.spanFrom$1(new A._SpanScannerState(t1, t2)));
            },
            _selector0$_simpleSelector$1$allowParent: function(allowParent) {
                var t2, $name, text, t3, suffix, _this = this, t1 = _this.scanner, start = new A._SpanScannerState(t1, t1._string_scanner$_position);
                if (allowParent == null) allowParent = _this._selector0$_allowParent;
                switch(t1.peekChar$0()){
                    case 91:
                        return _this._selector0$_attributeSelector$0();
                    case 46:
                        t2 = t1._string_scanner$_position;
                        t1.expectChar$1(46);
                        return new A.ClassSelector0(_this.identifier$0(), _this.spanFrom$1(new A._SpanScannerState(t1, t2)));
                    case 35:
                        t2 = t1._string_scanner$_position;
                        t1.expectChar$1(35);
                        return new A.IDSelector0(_this.identifier$0(), _this.spanFrom$1(new A._SpanScannerState(t1, t2)));
                    case 37:
                        t2 = t1._string_scanner$_position;
                        t1.expectChar$1(37);
                        $name = _this.identifier$0();
                        t2 = _this.spanFrom$1(new A._SpanScannerState(t1, t2));
                        if (_this._selector0$_plainCss) _this.error$2(0, string$.Placeh, _this.spanFrom$1(start));
                        return new A.PlaceholderSelector0($name, t2);
                    case 58:
                        return _this._selector0$_pseudoSelector$0();
                    case 38:
                        t2 = t1._string_scanner$_position;
                        t1.expectChar$1(38);
                        if (_this.lookingAtIdentifierBody$0()) {
                            text = new A.StringBuffer("");
                            _this._parser1$_identifierBody$1(text);
                            if (text._contents.length === 0) t1.error$1(0, "Expected identifier body.");
                            t3 = text._contents;
                            suffix = t3.charCodeAt(0) == 0 ? t3 : t3;
                        } else suffix = null;
                        if (_this._selector0$_plainCss && suffix != null) t1.error$3$length$position(0, string$.Parent, t1._string_scanner$_position - t2, t2);
                        t1 = _this.spanFrom$1(new A._SpanScannerState(t1, t2));
                        if (!allowParent) _this.error$2(0, "Parent selectors aren't allowed here.", _this.spanFrom$1(start));
                        return new A.ParentSelector0(suffix, t1);
                    default:
                        return _this._selector0$_typeOrUniversalSelector$0();
                }
            },
            _selector0$_simpleSelector$0: function() {
                return this._selector0$_simpleSelector$1$allowParent(null);
            },
            _selector0$_attributeSelector$0: function() {
                var $name, operator, next, value, modifier, _this = this, _null = null, t1 = _this.scanner, start = new A._SpanScannerState(t1, t1._string_scanner$_position);
                t1.expectChar$1(91);
                _this.whitespace$1$consumeNewlines(true);
                $name = _this._selector0$_attributeName$0();
                _this.whitespace$1$consumeNewlines(true);
                if (t1.scanChar$1(93)) return new A.AttributeSelector0($name, _null, _null, _null, _this.spanFrom$1(start));
                operator = _this._selector0$_attributeOperator$0();
                _this.whitespace$1$consumeNewlines(true);
                next = t1.peekChar$0();
                value = next === 39 || next === 34 ? _this.string$0() : _this.identifier$0();
                _this.whitespace$1$consumeNewlines(true);
                next = t1.peekChar$0();
                modifier = next != null && A.CharacterExtension_get_isAlphabetic0(next) ? A.Primitives_stringFromCharCode(t1.readChar$0()) : _null;
                t1.expectChar$1(93);
                return new A.AttributeSelector0($name, operator, value, modifier, _this.spanFrom$1(start));
            },
            _selector0$_attributeName$0: function() {
                var nameOrNamespace, _this = this, t1 = _this.scanner;
                if (t1.scanChar$1(42)) {
                    t1.expectChar$1(124);
                    return new A.QualifiedName0(_this.identifier$0(), "*");
                }
                if (t1.scanChar$1(124)) return new A.QualifiedName0(_this.identifier$0(), "");
                nameOrNamespace = _this.identifier$0();
                if (t1.peekChar$0() !== 124 || t1.peekChar$1(1) === 61) return new A.QualifiedName0(nameOrNamespace, null);
                t1.readChar$0();
                return new A.QualifiedName0(_this.identifier$0(), nameOrNamespace);
            },
            _selector0$_attributeOperator$0: function() {
                var t1 = this.scanner, start = t1._string_scanner$_position;
                switch(t1.readChar$0()){
                    case 61:
                        return B.AttributeOperator_jFZ0;
                    case 126:
                        t1.expectChar$1(61);
                        return B.AttributeOperator_OrK0;
                    case 124:
                        t1.expectChar$1(61);
                        return B.AttributeOperator_g5B0;
                    case 94:
                        t1.expectChar$1(61);
                        return B.AttributeOperator_stc0;
                    case 36:
                        t1.expectChar$1(61);
                        return B.AttributeOperator_xJ90;
                    case 42:
                        t1.expectChar$1(61);
                        return B.AttributeOperator_h200;
                    default:
                        t1.error$2$position(0, 'Expected "]".', start);
                }
            },
            _selector0$_pseudoSelector$0: function() {
                var element, $name, unvendored, argument, selector, t2, _this = this, _null = null, t1 = _this.scanner, start = new A._SpanScannerState(t1, t1._string_scanner$_position);
                t1.expectChar$1(58);
                element = t1.scanChar$1(58);
                $name = _this.identifier$0();
                if (!t1.scanChar$1(40)) return A.PseudoSelector$0($name, _this.spanFrom$1(start), _null, element, _null);
                _this.whitespace$1$consumeNewlines(true);
                unvendored = A.unvendor0($name);
                argument = _null;
                selector = _null;
                if (element) {
                    if ($.selectorPseudoElements0.contains$1(0, unvendored)) selector = _this._selector0$_selectorList$0();
                    else argument = _this.declarationValue$1$allowEmpty(true);
                } else if ($.selectorPseudoClasses0.contains$1(0, unvendored)) selector = _this._selector0$_selectorList$0();
                else if (unvendored === "nth-child" || unvendored === "nth-last-child") {
                    argument = _this._selector0$_aNPlusB$0();
                    _this.whitespace$1$consumeNewlines(true);
                    t2 = t1.peekChar$1(-1);
                    if ((t2 === 32 || t2 === 9 || t2 === 10 || t2 === 13 || t2 === 12) && t1.peekChar$0() !== 41) {
                        _this.expectIdentifier$1("of");
                        argument += " of";
                        _this.whitespace$1$consumeNewlines(true);
                        selector = _this._selector0$_selectorList$0();
                    }
                } else argument = B.JSString_methods.trimRight$0(_this.declarationValue$1$allowEmpty(true));
                t1.expectChar$1(41);
                return A.PseudoSelector$0($name, _this.spanFrom$1(start), argument, element, selector);
            },
            _selector0$_aNPlusB$0: function() {
                var t1, _0_0, t2, $self, next, _this = this;
                $label0$0: {
                    t1 = _this.scanner;
                    _0_0 = t1.peekChar$0();
                    if (101 === _0_0 || 69 === _0_0) {
                        _this.expectIdentifier$1("even");
                        return "even";
                    }
                    if (111 === _0_0 || 79 === _0_0) {
                        _this.expectIdentifier$1("odd");
                        return "odd";
                    }
                    if (43 === _0_0 || 45 === _0_0) {
                        t2 = A.Primitives_stringFromCharCode(t1.readChar$0());
                        break $label0$0;
                    }
                    t2 = "";
                }
                $self = t1.peekChar$0();
                if ($self != null && $self >= 48 && $self <= 57) {
                    do {
                        t2 += A.Primitives_stringFromCharCode(t1.readChar$0());
                        $self = t1.peekChar$0();
                    }while ($self != null && $self >= 48 && $self <= 57);
                    _this.whitespace$1$consumeNewlines(true);
                    if (!_this.scanIdentChar$1(110)) return t2.charCodeAt(0) == 0 ? t2 : t2;
                } else _this.expectIdentChar$1(110);
                t2 += A.Primitives_stringFromCharCode(110);
                _this.whitespace$1$consumeNewlines(true);
                next = t1.peekChar$0();
                if (next !== 43 && next !== 45) return t2.charCodeAt(0) == 0 ? t2 : t2;
                t2 += A.Primitives_stringFromCharCode(t1.readChar$0());
                _this.whitespace$1$consumeNewlines(true);
                $self = t1.peekChar$0();
                if (!($self != null && $self >= 48 && $self <= 57)) t1.error$1(0, "Expected a number.");
                do {
                    t2 += A.Primitives_stringFromCharCode(t1.readChar$0());
                    $self = t1.peekChar$0();
                }while ($self != null && $self >= 48 && $self <= 57);
                return t2.charCodeAt(0) == 0 ? t2 : t2;
            },
            _selector0$_typeOrUniversalSelector$0: function() {
                var nameOrNamespace, _this = this, t1 = _this.scanner, start = new A._SpanScannerState(t1, t1._string_scanner$_position);
                if (t1.scanChar$1(42)) {
                    if (!t1.scanChar$1(124)) return new A.UniversalSelector0(null, _this.spanFrom$1(start));
                    return t1.scanChar$1(42) ? new A.UniversalSelector0("*", _this.spanFrom$1(start)) : new A.TypeSelector0(new A.QualifiedName0(_this.identifier$0(), "*"), _this.spanFrom$1(start));
                } else if (t1.scanChar$1(124)) return t1.scanChar$1(42) ? new A.UniversalSelector0("", _this.spanFrom$1(start)) : new A.TypeSelector0(new A.QualifiedName0(_this.identifier$0(), ""), _this.spanFrom$1(start));
                nameOrNamespace = _this.identifier$0();
                if (!t1.scanChar$1(124)) return new A.TypeSelector0(new A.QualifiedName0(nameOrNamespace, null), _this.spanFrom$1(start));
                else if (t1.scanChar$1(42)) return new A.UniversalSelector0(nameOrNamespace, _this.spanFrom$1(start));
                else return new A.TypeSelector0(new A.QualifiedName0(_this.identifier$0(), nameOrNamespace), _this.spanFrom$1(start));
            },
            _selector0$_isSimpleSelectorStart$1: function(character) {
                var t1;
                $label0$0: {
                    if (42 === character || 91 === character || 46 === character || 35 === character || 37 === character || 58 === character) {
                        t1 = true;
                        break $label0$0;
                    }
                    if (38 === character) {
                        t1 = this._selector0$_plainCss;
                        break $label0$0;
                    }
                    t1 = false;
                    break $label0$0;
                }
                return t1;
            }
        };
        A.SelectorParser_parse_closure0.prototype = {
            call$0: function() {
                var t1 = this.$this, selector = t1._selector0$_selectorList$0();
                t1 = t1.scanner;
                if (t1._string_scanner$_position !== t1.string.length) t1.error$1(0, "expected selector.");
                return selector;
            },
            $signature: 593
        };
        A.SelectorParser_parseCompoundSelector_closure0.prototype = {
            call$0: function() {
                var t1 = this.$this, compound = t1._selector0$_compoundSelector$0();
                t1 = t1.scanner;
                if (t1._string_scanner$_position !== t1.string.length) t1.error$1(0, "expected selector.");
                return compound;
            },
            $signature: 594
        };
        A.SelectorSearchVisitor0.prototype = {
            visitAttributeSelector$1: function(_, attribute) {
                return null;
            },
            visitClassSelector$1: function(_, klass) {
                return null;
            },
            visitIDSelector$1: function(_, id) {
                return null;
            },
            visitParentSelector$1: function(_, placeholder) {
                return null;
            },
            visitPlaceholderSelector$1: function(_, placeholder) {
                return null;
            },
            visitTypeSelector$1: function(_, type) {
                return null;
            },
            visitUniversalSelector$1: function(_, universal) {
                return null;
            },
            visitComplexSelector$1: function(complex) {
                return A.IterableExtension_search0(complex.components, new A.SelectorSearchVisitor_visitComplexSelector_closure0(this));
            },
            visitCompoundSelector$1: function(compound) {
                return A.IterableExtension_search0(compound.components, new A.SelectorSearchVisitor_visitCompoundSelector_closure0(this));
            },
            visitPseudoSelector$1: function(_, pseudo) {
                return A.NullableExtension_andThen0(pseudo.selector, this.get$visitSelectorList());
            },
            visitSelectorList$1: function(list) {
                return A.IterableExtension_search0(list.components, this.get$visitComplexSelector());
            }
        };
        A.SelectorSearchVisitor_visitComplexSelector_closure0.prototype = {
            call$1: function(component) {
                return this.$this.visitCompoundSelector$1(component.selector);
            },
            $signature: function() {
                return A._instanceType(this.$this)._eval$1("SelectorSearchVisitor0.T?(ComplexSelectorComponent0)");
            }
        };
        A.SelectorSearchVisitor_visitCompoundSelector_closure0.prototype = {
            call$1: function(simple) {
                return simple.accept$1(this.$this);
            },
            $signature: function() {
                return A._instanceType(this.$this)._eval$1("SelectorSearchVisitor0.T?(SimpleSelector0)");
            }
        };
        A.serialize_closure0.prototype = {
            call$1: function(codeUnit) {
                return codeUnit > 127;
            },
            $signature: 50
        };
        A._SerializeVisitor0.prototype = {
            visitCssStylesheet$1: function(node) {
                var t1, t2, t3, t4, t5, t6, t7, previous, previous0, t8, _this = this;
                for(t1 = J.get$iterator$ax(node.get$children(node)), t2 = !_this._serialize0$_inspect, t3 = _this._serialize0$_style === B.OutputStyle_10, t4 = !t3, t5 = type$.CssParentNode_2, t6 = _this._serialize0$_buffer, t7 = _this._lineFeed.text, previous = null; t1.moveNext$0();){
                    previous0 = t1.get$current(t1);
                    if (t2) t8 = t3 ? previous0.accept$1(B._IsInvisibleVisitor_true_true0) : previous0.accept$1(B._IsInvisibleVisitor_true_false0);
                    else t8 = false;
                    if (t8) continue;
                    if (previous != null) {
                        if (t5._is(previous) ? previous.get$isChildless() : !(previous instanceof A.ModifiableCssComment0)) t6.writeCharCode$1(59);
                        if (_this._serialize0$_isTrailingComment$2(previous0, previous)) {
                            if (t4) t6.writeCharCode$1(32);
                        } else {
                            if (t4) t6.write$1(0, t7);
                            if (previous.get$isGroupEnd()) {
                                if (t4) t6.write$1(0, t7);
                            }
                        }
                    }
                    previous0.accept$1(_this);
                    previous = previous0;
                }
                if (previous != null) t1 = (t5._is(previous) ? previous.get$isChildless() : !(previous instanceof A.ModifiableCssComment0)) && t4;
                else t1 = false;
                if (t1) t6.writeCharCode$1(59);
            },
            visitCssComment$1: function(node) {
                this._serialize0$_buffer.forSpan$2(node.span, new A._SerializeVisitor_visitCssComment_closure0(this, node));
            },
            visitCssAtRule$1: function(node) {
                var t1, _this = this;
                _this._serialize0$_writeIndentation$0();
                t1 = _this._serialize0$_buffer;
                t1.forSpan$2(node.span, new A._SerializeVisitor_visitCssAtRule_closure0(_this, node));
                if (!node.isChildless) {
                    if (_this._serialize0$_style !== B.OutputStyle_10) t1.writeCharCode$1(32);
                    _this._serialize0$_visitChildren$1(node);
                }
            },
            visitCssMediaRule$1: function(node) {
                var t1, _this = this;
                _this._serialize0$_writeIndentation$0();
                t1 = _this._serialize0$_buffer;
                t1.forSpan$2(node.span, new A._SerializeVisitor_visitCssMediaRule_closure0(_this, node));
                if (_this._serialize0$_style !== B.OutputStyle_10) t1.writeCharCode$1(32);
                _this._serialize0$_visitChildren$1(node);
            },
            visitCssImport$1: function(node) {
                this._serialize0$_writeIndentation$0();
                this._serialize0$_buffer.forSpan$2(node.span, new A._SerializeVisitor_visitCssImport_closure0(this, node));
            },
            _serialize0$_writeImportUrl$1: function(url) {
                var urlContents, maybeQuote, _this = this;
                if (_this._serialize0$_style !== B.OutputStyle_10 || url.charCodeAt(0) !== 117) {
                    _this._serialize0$_buffer.write$1(0, url);
                    return;
                }
                urlContents = B.JSString_methods.substring$2(url, 4, url.length - 1);
                maybeQuote = urlContents.charCodeAt(0);
                if (maybeQuote === 39 || maybeQuote === 34) _this._serialize0$_buffer.write$1(0, urlContents);
                else _this._serialize0$_visitQuotedString$1(urlContents);
            },
            visitCssKeyframeBlock$1: function(node) {
                var t1, _this = this;
                _this._serialize0$_writeIndentation$0();
                t1 = _this._serialize0$_buffer;
                t1.forSpan$2(node.selector.span, new A._SerializeVisitor_visitCssKeyframeBlock_closure0(_this, node));
                if (_this._serialize0$_style !== B.OutputStyle_10) t1.writeCharCode$1(32);
                _this._serialize0$_visitChildren$1(node);
            },
            _serialize0$_visitMediaQuery$1: function(query) {
                var t1, _1_0, _2_0, condition, operator, t2, _this = this, _0_0 = query.modifier;
                if (_0_0 != null) {
                    t1 = _this._serialize0$_buffer;
                    t1.write$1(0, _0_0);
                    t1.writeCharCode$1(32);
                }
                _1_0 = query.type;
                if (_1_0 != null) {
                    t1 = _this._serialize0$_buffer;
                    t1.write$1(0, _1_0);
                    if (query.conditions.length !== 0) t1.write$1(0, " and ");
                }
                _2_0 = query.conditions;
                if (_2_0.length === 1) t1 = B.JSString_methods.startsWith$1(_2_0[0], "(not ");
                else t1 = false;
                if (t1) {
                    t1 = _this._serialize0$_buffer;
                    t1.write$1(0, "not ");
                    condition = B.JSArray_methods.get$first(_2_0);
                    t1.write$1(0, B.JSString_methods.substring$2(condition, 5, condition.length - 1));
                } else {
                    operator = query.conjunction ? "and" : "or";
                    t1 = _this._serialize0$_style === B.OutputStyle_10 ? operator + " " : " " + operator + " ";
                    t2 = _this._serialize0$_buffer;
                    _this._serialize0$_writeBetween$3(_2_0, t1, t2.get$write(t2));
                }
            },
            visitCssStyleRule$1: function(node) {
                var t1, _this = this;
                _this._serialize0$_writeIndentation$0();
                t1 = _this._serialize0$_buffer;
                t1.forSpan$2(node._style_rule0$_selector._box0$_inner.value.span, new A._SerializeVisitor_visitCssStyleRule_closure0(_this, node));
                if (_this._serialize0$_style !== B.OutputStyle_10) t1.writeCharCode$1(32);
                _this._serialize0$_visitChildren$1(node);
            },
            visitCssSupportsRule$1: function(node) {
                var t1, _this = this;
                _this._serialize0$_writeIndentation$0();
                t1 = _this._serialize0$_buffer;
                t1.forSpan$2(node.span, new A._SerializeVisitor_visitCssSupportsRule_closure0(_this, node));
                if (_this._serialize0$_style !== B.OutputStyle_10) t1.writeCharCode$1(32);
                _this._serialize0$_visitChildren$1(node);
            },
            visitCssDeclaration$1: function(node) {
                var error, stackTrace, error0, stackTrace0, t1, _$exception, _this = this;
                _this._serialize0$_writeIndentation$0();
                _this._serialize0$_write$1(node.name);
                t1 = _this._serialize0$_buffer;
                t1.writeCharCode$1(58);
                if (!node.parsedAsSassScript) t1.forSpan$2(node.value.span, new A._SerializeVisitor_visitCssDeclaration_closure1(_this, node));
                else {
                    if (_this._serialize0$_style !== B.OutputStyle_10) t1.writeCharCode$1(32);
                    try {
                        t1.forSpan$2(node.valueSpanForMap, new A._SerializeVisitor_visitCssDeclaration_closure2(_this, node));
                    } catch (exception) {
                        t1 = A.unwrapException(exception);
                        if (t1 instanceof A.MultiSpanSassScriptException0) {
                            error = t1;
                            stackTrace = A.getTraceFromException(exception);
                            A.throwWithTrace0(A.MultiSpanSassException$0(error.message, node.value.span, error.primaryLabel, error.secondarySpans, null), error, stackTrace);
                        } else if (t1 instanceof A.SassScriptException0) {
                            error0 = t1;
                            stackTrace0 = A.getTraceFromException(exception);
                            t1 = error0.message;
                            A.throwWithTrace0(new A.SassException0(B.Set_empty, t1, node.value.span), error0, stackTrace0);
                        } else throw exception;
                    }
                }
            },
            _serialize0$_writeFoldedValue$1: function(node) {
                var t1, t2, next, t3, scanner = A.StringScanner$(type$.SassString_2._as(node.value.value)._string0$_text, null, null);
                for(t1 = scanner.string.length, t2 = this._serialize0$_buffer; scanner._string_scanner$_position !== t1;){
                    next = scanner.readChar$0();
                    if (next !== 10) {
                        t2.writeCharCode$1(next);
                        continue;
                    }
                    t2.writeCharCode$1(32);
                    for(;;){
                        t3 = scanner.peekChar$0();
                        if (!(t3 === 32 || t3 === 9 || t3 === 10 || t3 === 13 || t3 === 12)) break;
                        scanner.readChar$0();
                    }
                }
            },
            _serialize0$_writeReindentedValue$1: function(node) {
                var _0_0, t1, _this = this, value = type$.SassString_2._as(node.value.value)._string0$_text;
                $label0$0: {
                    _0_0 = _this._serialize0$_minimumIndentation$1(value);
                    if (_0_0 == null) {
                        _this._serialize0$_buffer.write$1(0, value);
                        break $label0$0;
                    }
                    if (-1 === _0_0) {
                        t1 = _this._serialize0$_buffer;
                        t1.write$1(0, A.trimAsciiRight0(value, true));
                        t1.writeCharCode$1(32);
                        break $label0$0;
                    }
                    t1 = node.name.span;
                    t1 = t1.get$start(t1);
                    _this._serialize0$_writeWithIndent$2(value, Math.min(_0_0, t1.file.getColumn$1(t1.offset)));
                }
            },
            _serialize0$_minimumIndentation$1: function(text) {
                var character, t2, min, next, min0, scanner = A.LineScanner$(text), t1 = scanner.string.length;
                for(;;){
                    if (scanner._string_scanner$_position !== t1) {
                        character = scanner.super$StringScanner$readChar();
                        scanner._adjustLineAndColumn$1(character);
                        t2 = character !== 10;
                    } else t2 = false;
                    if (!t2) break;
                }
                if (scanner._string_scanner$_position === t1) return scanner.peekChar$1(-1) === 10 ? -1 : null;
                for(min = null; scanner._string_scanner$_position !== t1;){
                    while(scanner._string_scanner$_position !== t1){
                        next = scanner.peekChar$0();
                        if (next !== 32 && next !== 9) break;
                        scanner._adjustLineAndColumn$1(scanner.super$StringScanner$readChar());
                    }
                    if (scanner._string_scanner$_position === t1 || scanner.scanChar$1(10)) continue;
                    min0 = scanner._line_scanner$_column;
                    min = min == null ? min0 : Math.min(min, min0);
                    for(;;){
                        if (scanner._string_scanner$_position !== t1) {
                            character = scanner.super$StringScanner$readChar();
                            scanner._adjustLineAndColumn$1(character);
                            t2 = character !== 10;
                        } else t2 = false;
                        if (!t2) break;
                    }
                }
                return min == null ? -1 : min;
            },
            _serialize0$_writeWithIndent$2: function(text, minimumIndentation) {
                var t1, t2, t3, character, lineStart, newlines, end, scanner = A.LineScanner$(text);
                for(t1 = scanner.string, t2 = t1.length, t3 = this._serialize0$_buffer; scanner._string_scanner$_position !== t2;){
                    character = scanner.super$StringScanner$readChar();
                    scanner._adjustLineAndColumn$1(character);
                    if (character === 10) break;
                    t3.writeCharCode$1(character);
                }
                for(;;){
                    lineStart = scanner._string_scanner$_position;
                    for(newlines = 1;;){
                        if (scanner._string_scanner$_position === t2) {
                            t3.writeCharCode$1(32);
                            return;
                        }
                        $label0$2: {
                            character = scanner.super$StringScanner$readChar();
                            scanner._adjustLineAndColumn$1(character);
                            if (32 === character || 9 === character) continue;
                            if (10 === character) {
                                lineStart = scanner._string_scanner$_position;
                                ++newlines;
                                break $label0$2;
                            }
                            break;
                        }
                    }
                    this._serialize0$_writeTimes$2(10, newlines);
                    this._serialize0$_writeIndentation$0();
                    end = scanner._string_scanner$_position;
                    t3.write$1(0, B.JSString_methods.substring$2(t1, lineStart + minimumIndentation, end));
                    for(;;){
                        if (scanner._string_scanner$_position === t2) return;
                        character = scanner.super$StringScanner$readChar();
                        scanner._adjustLineAndColumn$1(character);
                        if (character === 10) break;
                        t3.writeCharCode$1(character);
                    }
                }
            },
            visitCalculation$1: function(value) {
                var t2, _this = this, t1 = _this._serialize0$_buffer;
                t1.write$1(0, value.name);
                t1.writeCharCode$1(40);
                t2 = _this._serialize0$_style === B.OutputStyle_10 ? "," : ", ";
                _this._serialize0$_writeBetween$3(value.$arguments, t2, _this.get$_serialize0$_writeCalculationValue());
                t1.writeCharCode$1(41);
            },
            _serialize0$_writeCalculationValue$1: function(value) {
                var t1, _0_0, _1_0, first, rest, left, right, operator, parenthesizeLeft, operatorWhitespace, parenthesizeRight, t2, _this = this;
                $label1$1: {
                    t1 = value instanceof A.SassNumber0;
                    if (t1 && !isFinite(value._number1$_value)) {
                        $label0$0: {
                            _0_0 = value._number1$_value;
                            if (1 / 0 === _0_0) {
                                _this._serialize0$_buffer.write$1(0, "infinity");
                                break $label0$0;
                            }
                            if (-1 / 0 === _0_0) {
                                _this._serialize0$_buffer.write$1(0, "-infinity");
                                break $label0$0;
                            }
                            if (isNaN(_0_0)) _this._serialize0$_buffer.write$1(0, "NaN");
                        }
                        _this._serialize0$_writeCalculationUnits$2(value.get$numeratorUnits(value), value.get$denominatorUnits(value));
                        break $label1$1;
                    }
                    if (t1 && value.get$hasComplexUnits()) {
                        _this._serialize0$_writeNumber$1(value._number1$_value);
                        _1_0 = value.get$numeratorUnits(value);
                        if (_1_0.length >= 1) {
                            first = _1_0[0];
                            rest = B.JSArray_methods.sublist$1(_1_0, 1);
                            _this._serialize0$_buffer.write$1(0, first);
                            _this._serialize0$_writeCalculationUnits$2(rest, value.get$denominatorUnits(value));
                        } else _this._serialize0$_writeCalculationUnits$2(A._setArrayType([], type$.JSArray_String), value.get$denominatorUnits(value));
                        break $label1$1;
                    }
                    if (value instanceof A.Value0) {
                        value.accept$1(_this);
                        break $label1$1;
                    }
                    t1 = value instanceof A.CalculationOperation0;
                    left = null;
                    right = null;
                    if (t1) {
                        operator = value._calculation0$_operator;
                        left = value._calculation0$_left;
                        right = value._calculation0$_right;
                    } else operator = null;
                    if (t1) {
                        parenthesizeLeft = left instanceof A.CalculationOperation0 && left._calculation0$_operator.precedence < operator.precedence;
                        if (parenthesizeLeft) _this._serialize0$_buffer.writeCharCode$1(40);
                        _this._serialize0$_writeCalculationValue$1(left);
                        if (parenthesizeLeft) _this._serialize0$_buffer.writeCharCode$1(41);
                        operatorWhitespace = _this._serialize0$_style !== B.OutputStyle_10 || operator.precedence === 1;
                        if (operatorWhitespace) _this._serialize0$_buffer.writeCharCode$1(32);
                        t1 = _this._serialize0$_buffer;
                        t1.write$1(0, operator.operator);
                        if (operatorWhitespace) t1.writeCharCode$1(32);
                        if (!(right instanceof A.CalculationOperation0 && _this._serialize0$_parenthesizeCalculationRhs$2(operator, right._calculation0$_operator))) {
                            parenthesizeRight = false;
                            if (operator === B.CalculationOperator_wFL0) {
                                if (right instanceof A.SassNumber0) t2 = isFinite(right._number1$_value) ? right.get$hasComplexUnits() : right.get$hasUnits();
                                else t2 = parenthesizeRight;
                                parenthesizeRight = t2;
                            }
                        } else parenthesizeRight = true;
                        if (parenthesizeRight) t1.writeCharCode$1(40);
                        _this._serialize0$_writeCalculationValue$1(right);
                        if (parenthesizeRight) t1.writeCharCode$1(41);
                    }
                }
            },
            _serialize0$_writeCalculationUnits$2: function(numeratorUnits, denominatorUnits) {
                var t1, t2, t3, t4;
                for(t1 = J.get$iterator$ax(numeratorUnits), t2 = this._serialize0$_buffer, t3 = this._serialize0$_style !== B.OutputStyle_10; t1.moveNext$0();){
                    t4 = t1.get$current(t1);
                    if (t3) t2.writeCharCode$1(32);
                    t2.writeCharCode$1(42);
                    if (t3) t2.writeCharCode$1(32);
                    t2.writeCharCode$1(49);
                    t2.write$1(0, t4);
                }
                for(t1 = J.get$iterator$ax(denominatorUnits); t1.moveNext$0();){
                    t4 = t1.get$current(t1);
                    if (t3) t2.writeCharCode$1(32);
                    t2.writeCharCode$1(47);
                    if (t3) t2.writeCharCode$1(32);
                    t2.writeCharCode$1(49);
                    t2.write$1(0, t4);
                }
            },
            _serialize0$_parenthesizeCalculationRhs$2: function(outer, right) {
                var t1;
                $label0$0: {
                    if (B.CalculationOperator_wFL0 === outer) {
                        t1 = true;
                        break $label0$0;
                    }
                    if (B.CalculationOperator_dpX0 === outer) {
                        t1 = false;
                        break $label0$0;
                    }
                    t1 = right === B.CalculationOperator_dpX0 || right === B.CalculationOperator_KrC0;
                    break $label0$0;
                }
                return t1;
            },
            visitColor$1: function(value) {
                var _0_0, _0_2, _0_6, t1, _0_4, _0_6_isSet, t2, _0_10_isSet, _0_10, _0_12_isSet, _0_14, _0_12, _0_14_isSet, t3, _0_10_isSet0, polar, t4, t5, _this = this, _null = null;
                $label0$0: {
                    _0_0 = value._color0$_space;
                    _0_2 = B.RgbColorSpace_i0P0 === _0_0;
                    _0_6 = _null;
                    t1 = true;
                    if (!_0_2) {
                        _0_4 = B.HslColorSpace_JQ20 === _0_0;
                        _0_6_isSet = !_0_4;
                        if (_0_6_isSet) {
                            _0_6 = B.HwbColorSpace_guQ0 === _0_0;
                            t1 = _0_6;
                        }
                    } else {
                        _0_4 = _null;
                        _0_6_isSet = false;
                    }
                    if (t1 && value.channel0OrNull != null && value.channel1OrNull != null && value.channel2OrNull != null && value.alphaOrNull != null) {
                        _this._serialize0$_writeLegacyColor$1(value);
                        break $label0$0;
                    }
                    if (_0_2) {
                        t1 = _this._serialize0$_buffer;
                        t1.write$1(0, "rgb(");
                        _this._serialize0$_writeChannel$1(value.channel0OrNull);
                        t1.writeCharCode$1(32);
                        _this._serialize0$_writeChannel$1(value.channel1OrNull);
                        t1.writeCharCode$1(32);
                        _this._serialize0$_writeChannel$1(value.channel2OrNull);
                        _this._serialize0$_maybeWriteSlashAlpha$1(value);
                        t1.writeCharCode$1(41);
                        break $label0$0;
                    }
                    if (!_0_4) t1 = _0_6_isSet ? _0_6 : B.HwbColorSpace_guQ0 === _0_0;
                    else t1 = true;
                    if (t1) {
                        t1 = _this._serialize0$_buffer;
                        t1.write$1(0, _0_0);
                        t1.writeCharCode$1(40);
                        t2 = _this._serialize0$_style === B.OutputStyle_10 ? _null : "deg";
                        _this._serialize0$_writeChannel$2(value.channel0OrNull, t2);
                        t1.writeCharCode$1(32);
                        _this._serialize0$_writeChannel$2(value.channel1OrNull, "%");
                        t1.writeCharCode$1(32);
                        _this._serialize0$_writeChannel$2(value.channel2OrNull, "%");
                        _this._serialize0$_maybeWriteSlashAlpha$1(value);
                        t1.writeCharCode$1(41);
                        break $label0$0;
                    }
                    _0_10_isSet = B.LabColorSpace_2nT0 !== _0_0;
                    if (_0_10_isSet) {
                        _0_10 = B.LchColorSpace_Bpv0 === _0_0;
                        t1 = _0_10;
                    } else {
                        _0_10 = _null;
                        t1 = true;
                    }
                    t2 = false;
                    if (t1) {
                        if (!_this._serialize0$_inspect) {
                            t1 = value.channel0OrNull;
                            if (t1 == null) t1 = 0;
                            if (t1 > 0 || A.fuzzyEquals0(t1, 0)) t1 = t1 < 100 || A.fuzzyEquals0(t1, 100);
                            else t1 = false;
                            t1 = !t1 && value.channel1OrNull != null && value.channel2OrNull != null;
                        } else t1 = t2;
                    } else t1 = t2;
                    _0_12_isSet = !t1;
                    _0_14 = _null;
                    if (_0_12_isSet) {
                        _0_12 = B.OklabColorSpace_5400 === _0_0;
                        t1 = false;
                        _0_14_isSet = !_0_12;
                        if (_0_14_isSet) {
                            _0_14 = B.OklchColorSpace_9Gj0 === _0_0;
                            t2 = _0_14;
                        } else t2 = true;
                        t3 = false;
                        if (t2) {
                            if (!_this._serialize0$_inspect) {
                                t2 = value.channel0OrNull;
                                if (t2 == null) t2 = 0;
                                if (t2 > 0 || A.fuzzyEquals0(t2, 0)) t2 = t2 < 1 || A.fuzzyEquals0(t2, 1);
                                else t2 = false;
                                t2 = !t2 && value.channel1OrNull != null && value.channel2OrNull != null;
                            } else t2 = t3;
                        } else t2 = t3;
                        if (!t2) {
                            if (_0_10_isSet) {
                                t2 = _0_10;
                                _0_10_isSet0 = _0_10_isSet;
                            } else {
                                _0_10 = B.LchColorSpace_Bpv0 === _0_0;
                                t2 = _0_10;
                                _0_10_isSet0 = true;
                            }
                            if (!t2) {
                                if (_0_14_isSet) t2 = _0_14;
                                else {
                                    _0_14 = B.OklchColorSpace_9Gj0 === _0_0;
                                    t2 = _0_14;
                                    _0_14_isSet = true;
                                }
                            } else t2 = true;
                            if (t2) {
                                if (!_this._serialize0$_inspect) {
                                    t1 = value.channel1OrNull;
                                    t2 = t1 == null;
                                    if (t2) t1 = 0;
                                    t1 = t1 < 0 && !A.fuzzyEquals0(t1, 0) && value.channel0OrNull != null && !t2;
                                }
                            }
                        } else {
                            _0_10_isSet0 = _0_10_isSet;
                            t1 = true;
                        }
                    } else {
                        _0_12 = _null;
                        _0_10_isSet0 = _0_10_isSet;
                        _0_14_isSet = false;
                        t1 = true;
                    }
                    if (t1) {
                        t1 = _this._serialize0$_buffer;
                        t1.write$1(0, "color-mix(in ");
                        t1.write$1(0, _0_0);
                        t2 = _this._serialize0$_style === B.OutputStyle_10;
                        t1.write$1(0, t2 ? "," : ", ");
                        _this._serialize0$_writeColorFunction$1(value.toSpace$1(B.XyzD65ColorSpace_WiJ0));
                        if (!t2) t1.writeCharCode$1(32);
                        t1.write$1(0, "100%");
                        t1.write$1(0, t2 ? "," : ", ");
                        t1.write$1(0, t2 ? "red" : "black");
                        t1.writeCharCode$1(41);
                        break $label0$0;
                    }
                    t1 = true;
                    if (_0_10_isSet) {
                        if (!(_0_12_isSet ? _0_12 : B.OklabColorSpace_5400 === _0_0)) {
                            if (!(_0_10_isSet0 ? _0_10 : B.LchColorSpace_Bpv0 === _0_0)) t1 = _0_14_isSet ? _0_14 : B.OklchColorSpace_9Gj0 === _0_0;
                        }
                    }
                    if (t1) {
                        t1 = _this._serialize0$_buffer;
                        t1.write$1(0, _0_0);
                        t1.writeCharCode$1(40);
                        t2 = _0_0._space$_channels;
                        polar = t2[2].isPolarAngle;
                        t3 = false;
                        if (!_this._serialize0$_inspect) {
                            t4 = value.channel0OrNull;
                            if (t4 == null) t4 = 0;
                            if (t4 > 0 || A.fuzzyEquals0(t4, 0)) t4 = t4 < 100 || A.fuzzyEquals0(t4, 100);
                            else t4 = false;
                            if (t4) {
                                if (polar) {
                                    t3 = value.channel1OrNull;
                                    if (t3 == null) t3 = 0;
                                    t3 = t3 < 0 && !A.fuzzyEquals0(t3, 0);
                                }
                            } else t3 = true;
                        }
                        if (t3) {
                            t1.write$1(0, "from ");
                            t1.write$1(0, _this._serialize0$_style === B.OutputStyle_10 ? "red" : "black");
                            t1.writeCharCode$1(32);
                        }
                        t3 = _this._serialize0$_style !== B.OutputStyle_10;
                        t4 = t3 && value.channel0OrNull != null;
                        t5 = value.channel0OrNull;
                        if (t4) {
                            t2 = type$.LinearChannel_2._as(t2[0]);
                            _this._serialize0$_writeNumber$1((t5 == null ? 0 : t5) * 100 / t2.max);
                            t1.writeCharCode$1(37);
                        } else _this._serialize0$_writeChannel$1(t5);
                        t1.writeCharCode$1(32);
                        _this._serialize0$_writeChannel$1(value.channel1OrNull);
                        t1.writeCharCode$1(32);
                        t2 = polar && t3 ? "deg" : _null;
                        _this._serialize0$_writeChannel$2(value.channel2OrNull, t2);
                        _this._serialize0$_maybeWriteSlashAlpha$1(value);
                        t1.writeCharCode$1(41);
                        break $label0$0;
                    }
                    _this._serialize0$_writeColorFunction$1(value);
                }
            },
            _serialize0$_writeChannel$2: function(channel, unit) {
                var _this = this;
                if (channel == null) _this._serialize0$_buffer.write$1(0, "none");
                else if (isFinite(channel)) {
                    _this._serialize0$_writeNumber$1(channel);
                    if (unit != null) _this._serialize0$_buffer.write$1(0, unit);
                } else _this.visitNumber$1(A.SassNumber_SassNumber0(channel, unit));
            },
            _serialize0$_writeChannel$1: function(channel) {
                return this._serialize0$_writeChannel$2(channel, null);
            },
            _serialize0$_writeLegacyColor$1: function(color) {
                var rgb, t3, red, green, blue, hsl, hue, saturation, lightness, hwb, _0_0, format, _1_0, _this = this, t1 = color.alphaOrNull, t2 = t1 == null, opaque = A.fuzzyEquals0(t2 ? 0 : t1, 1);
                if (!color.get$isInGamut() && !_this._serialize0$_inspect) {
                    _this._serialize0$_writeHsl$1(color);
                    return;
                }
                if (_this._serialize0$_style === B.OutputStyle_10) {
                    rgb = color.toSpace$1(B.RgbColorSpace_i0P0);
                    if (opaque && _this._serialize0$_tryIntegerRgb$1(rgb)) return;
                    t3 = rgb.channel0OrNull;
                    red = _this._serialize0$_writeNumberToString$1(t3 == null ? 0 : t3);
                    t3 = rgb.channel1OrNull;
                    green = _this._serialize0$_writeNumberToString$1(t3 == null ? 0 : t3);
                    t3 = rgb.channel2OrNull;
                    blue = _this._serialize0$_writeNumberToString$1(t3 == null ? 0 : t3);
                    hsl = color.toSpace$1(B.HslColorSpace_JQ20);
                    t3 = hsl.channel0OrNull;
                    hue = _this._serialize0$_writeNumberToString$1(t3 == null ? 0 : t3);
                    t3 = hsl.channel1OrNull;
                    saturation = _this._serialize0$_writeNumberToString$1(t3 == null ? 0 : t3);
                    t3 = hsl.channel2OrNull;
                    lightness = _this._serialize0$_writeNumberToString$1(t3 == null ? 0 : t3);
                    t3 = _this._serialize0$_buffer;
                    if (red.length + green.length + blue.length <= hue.length + saturation.length + lightness.length + 2) {
                        t3.write$1(0, opaque ? "rgb(" : "rgba(");
                        t3.write$1(0, red);
                        t3.writeCharCode$1(44);
                        t3.write$1(0, green);
                        t3.writeCharCode$1(44);
                        t3.write$1(0, blue);
                    } else {
                        t3.write$1(0, opaque ? "hsl(" : "hsla(");
                        t3.write$1(0, hue);
                        t3.writeCharCode$1(44);
                        t3.write$1(0, saturation);
                        t3.write$1(0, "%,");
                        t3.write$1(0, lightness);
                        t3.writeCharCode$1(37);
                    }
                    if (!opaque) {
                        t3.writeCharCode$1(44);
                        _this._serialize0$_writeNumber$1(t2 ? 0 : t1);
                    }
                    t3.writeCharCode$1(41);
                    return;
                }
                t3 = color._color0$_space;
                if (t3 === B.HslColorSpace_JQ20) {
                    _this._serialize0$_writeHsl$1(color);
                    return;
                } else if (_this._serialize0$_inspect && t3 === B.HwbColorSpace_guQ0) {
                    t3 = _this._serialize0$_buffer;
                    t3.write$1(0, "hwb(");
                    hwb = color.toSpace$1(B.HwbColorSpace_guQ0);
                    _this._serialize0$_writeNumber$1(hwb.channel$1(0, "hue"));
                    t3.writeCharCode$1(32);
                    _this._serialize0$_writeNumber$1(hwb.channel$1(0, "whiteness"));
                    t3.writeCharCode$1(37);
                    t3.writeCharCode$1(32);
                    _this._serialize0$_writeNumber$1(hwb.channel$1(0, "blackness"));
                    t3.writeCharCode$1(37);
                    if (!A.fuzzyEquals0(t2 ? 0 : t1, 1)) {
                        t3.write$1(0, " / ");
                        _this._serialize0$_writeNumber$1(t2 ? 0 : t1);
                    }
                    t3.writeCharCode$1(41);
                    return;
                }
                _0_0 = color.format;
                if (B.C__ColorFormatEnum0 === _0_0) {
                    _this._serialize0$_writeRgb$1(color);
                    return;
                }
                t1 = _0_0 instanceof A.SpanColorFormat0;
                format = t1 ? _0_0 : null;
                if (t1) {
                    _this._serialize0$_buffer.write$1(0, format._color0$_span.get$text());
                    return;
                }
                if (opaque) {
                    rgb = color.toSpace$1(B.RgbColorSpace_i0P0);
                    _1_0 = $.$get$namesByColor0().$index(0, rgb);
                    if (_1_0 != null) {
                        _this._serialize0$_buffer.write$1(0, _1_0);
                        return;
                    }
                    if (_this._serialize0$_canUseHex$1(rgb)) {
                        _this._serialize0$_buffer.writeCharCode$1(35);
                        t1 = rgb.channel0OrNull;
                        _this._serialize0$_writeHexComponent$1(B.JSNumber_methods.round$0(t1 == null ? 0 : t1));
                        t1 = rgb.channel1OrNull;
                        _this._serialize0$_writeHexComponent$1(B.JSNumber_methods.round$0(t1 == null ? 0 : t1));
                        t1 = rgb.channel2OrNull;
                        _this._serialize0$_writeHexComponent$1(B.JSNumber_methods.round$0(t1 == null ? 0 : t1));
                        return;
                    }
                }
                if (t3 === B.HwbColorSpace_guQ0) _this._serialize0$_writeHsl$1(color);
                else _this._serialize0$_writeRgb$1(color);
            },
            _serialize0$_tryIntegerRgb$1: function(rgb) {
                var t1, redInt, greenInt, blueInt, shortHex, _0_0, t2, t3, $name, _this = this;
                if (!_this._serialize0$_canUseHex$1(rgb)) return false;
                t1 = rgb.channel0OrNull;
                redInt = B.JSNumber_methods.round$0(t1 == null ? 0 : t1);
                t1 = rgb.channel1OrNull;
                greenInt = B.JSNumber_methods.round$0(t1 == null ? 0 : t1);
                t1 = rgb.channel2OrNull;
                blueInt = B.JSNumber_methods.round$0(t1 == null ? 0 : t1);
                t1 = redInt & 15;
                shortHex = t1 === B.JSInt_methods._shrOtherPositive$1(redInt, 4) && (greenInt & 15) === B.JSInt_methods._shrOtherPositive$1(greenInt, 4) && (blueInt & 15) === B.JSInt_methods._shrOtherPositive$1(blueInt, 4);
                _0_0 = $.$get$namesByColor0().$index(0, rgb);
                t2 = false;
                if (_0_0 != null) {
                    t3 = _0_0.length;
                    t2 = t3 <= (shortHex ? 4 : 7);
                    $name = _0_0;
                } else $name = null;
                if (t2) _this._serialize0$_buffer.write$1(0, $name);
                else {
                    t2 = _this._serialize0$_buffer;
                    if (shortHex) {
                        t2.writeCharCode$1(35);
                        t2.writeCharCode$1(A.hexCharFor0(t1));
                        t2.writeCharCode$1(A.hexCharFor0(greenInt & 15));
                        t2.writeCharCode$1(A.hexCharFor0(blueInt & 15));
                    } else {
                        t2.writeCharCode$1(35);
                        _this._serialize0$_writeHexComponent$1(redInt);
                        _this._serialize0$_writeHexComponent$1(greenInt);
                        _this._serialize0$_writeHexComponent$1(blueInt);
                    }
                }
                return true;
            },
            _serialize0$_canUseHex$1: function(rgb) {
                var t2, t1 = rgb.channel0OrNull;
                if (t1 == null) t1 = 0;
                if (A.fuzzyIsInt0(t1)) t1 = (t1 > 0 || A.fuzzyEquals0(t1, 0)) && t1 < 256 && !A.fuzzyEquals0(t1, 256);
                else t1 = false;
                t2 = false;
                if (t1) {
                    t1 = rgb.channel1OrNull;
                    if (t1 == null) t1 = 0;
                    if (A.fuzzyIsInt0(t1)) t1 = (t1 > 0 || A.fuzzyEquals0(t1, 0)) && t1 < 256 && !A.fuzzyEquals0(t1, 256);
                    else t1 = false;
                    if (t1) {
                        t1 = rgb.channel2OrNull;
                        if (t1 == null) t1 = 0;
                        if (A.fuzzyIsInt0(t1)) t1 = (t1 > 0 || A.fuzzyEquals0(t1, 0)) && t1 < 256 && !A.fuzzyEquals0(t1, 256);
                        else t1 = t2;
                    } else t1 = t2;
                } else t1 = t2;
                return t1;
            },
            _serialize0$_writeRgb$1: function(color) {
                var t4, _this = this, t1 = color.alphaOrNull, t2 = t1 == null, opaque = A.fuzzyEquals0(t2 ? 0 : t1, 1), rgb = color.toSpace$1(B.RgbColorSpace_i0P0), t3 = _this._serialize0$_buffer;
                t3.write$1(0, opaque ? "rgb(" : "rgba(");
                _this._serialize0$_writeNumber$1(rgb.channel$1(0, "red"));
                t4 = _this._serialize0$_style === B.OutputStyle_10;
                t3.write$1(0, t4 ? "," : ", ");
                _this._serialize0$_writeNumber$1(rgb.channel$1(0, "green"));
                t3.write$1(0, t4 ? "," : ", ");
                _this._serialize0$_writeNumber$1(rgb.channel$1(0, "blue"));
                if (!opaque) {
                    t3.write$1(0, t4 ? "," : ", ");
                    _this._serialize0$_writeNumber$1(t2 ? 0 : t1);
                }
                t3.writeCharCode$1(41);
            },
            _serialize0$_writeHsl$1: function(color) {
                var t4, _this = this, t1 = color.alphaOrNull, t2 = t1 == null, opaque = A.fuzzyEquals0(t2 ? 0 : t1, 1), hsl = color.toSpace$1(B.HslColorSpace_JQ20), t3 = _this._serialize0$_buffer;
                t3.write$1(0, opaque ? "hsl(" : "hsla(");
                _this._serialize0$_writeChannel$1(hsl.channel$1(0, "hue"));
                t4 = _this._serialize0$_style === B.OutputStyle_10;
                t3.write$1(0, t4 ? "," : ", ");
                _this._serialize0$_writeChannel$2(hsl.channel$1(0, "saturation"), "%");
                t3.write$1(0, t4 ? "," : ", ");
                _this._serialize0$_writeChannel$2(hsl.channel$1(0, "lightness"), "%");
                if (!opaque) {
                    t3.write$1(0, t4 ? "," : ", ");
                    _this._serialize0$_writeNumber$1(t2 ? 0 : t1);
                }
                t3.writeCharCode$1(41);
            },
            _serialize0$_writeColorFunction$1: function(color) {
                var _this = this, t1 = _this._serialize0$_buffer;
                t1.write$1(0, "color(");
                t1.write$1(0, color._color0$_space);
                t1.writeCharCode$1(32);
                _this._serialize0$_writeBetween$3(color.get$channelsOrNull(), " ", _this.get$_serialize0$_writeChannel());
                _this._serialize0$_maybeWriteSlashAlpha$1(color);
                t1.writeCharCode$1(41);
            },
            _serialize0$_writeHexComponent$1: function(color) {
                var t1 = this._serialize0$_buffer;
                t1.writeCharCode$1(A.hexCharFor0(B.JSInt_methods._shrOtherPositive$1(color, 4)));
                t1.writeCharCode$1(A.hexCharFor0(color & 15));
            },
            _serialize0$_maybeWriteSlashAlpha$1: function(color) {
                var t2, t3, _this = this, t1 = color.alphaOrNull;
                if (A.fuzzyEquals0(t1 == null ? 0 : t1, 1)) return;
                t2 = _this._serialize0$_style !== B.OutputStyle_10;
                if (t2) _this._serialize0$_buffer.writeCharCode$1(32);
                t3 = _this._serialize0$_buffer;
                t3.writeCharCode$1(47);
                if (t2) t3.writeCharCode$1(32);
                _this._serialize0$_writeChannel$1(t1);
            },
            visitList$1: function(value) {
                var t2, singleton, t3, t4, t5, _this = this, t1 = value._list1$_hasBrackets;
                if (t1) _this._serialize0$_buffer.writeCharCode$1(91);
                else if (value._list1$_contents.length === 0) {
                    if (!_this._serialize0$_inspect) throw A.wrapException(A.SassScriptException$0("() isn't a valid CSS value.", null));
                    _this._serialize0$_buffer.write$1(0, "()");
                    return;
                }
                t2 = _this._serialize0$_inspect;
                singleton = false;
                if (t2) {
                    if (value._list1$_contents.length === 1) {
                        t3 = value._list1$_separator;
                        t3 = t3 === B.ListSeparator_z0K0 || t3 === B.ListSeparator_Lul0;
                        singleton = t3;
                    }
                }
                if (singleton && !t1) _this._serialize0$_buffer.writeCharCode$1(40);
                t3 = value._list1$_contents;
                t3 = t2 ? t3 : new A.WhereIterable(t3, new A._SerializeVisitor_visitList_closure2(), A._arrayInstanceType(t3)._eval$1("WhereIterable<1>"));
                t4 = value._list1$_separator;
                t5 = _this._serialize0$_separatorString$1(t4);
                _this._serialize0$_writeBetween$3(t3, t5, t2 ? new A._SerializeVisitor_visitList_closure3(_this, value) : new A._SerializeVisitor_visitList_closure4(_this));
                if (singleton) {
                    t2 = _this._serialize0$_buffer;
                    t2.write$1(0, t4.separator);
                    if (!t1) t2.writeCharCode$1(41);
                }
                if (t1) _this._serialize0$_buffer.writeCharCode$1(93);
            },
            _serialize0$_separatorString$1: function(separator) {
                var t1;
                $label0$0: {
                    if (B.ListSeparator_z0K0 === separator) {
                        t1 = this._serialize0$_style === B.OutputStyle_10 ? "," : ", ";
                        break $label0$0;
                    }
                    if (B.ListSeparator_Lul0 === separator) {
                        t1 = this._serialize0$_style === B.OutputStyle_10 ? "/" : " / ";
                        break $label0$0;
                    }
                    if (B.ListSeparator_SrV0 === separator) {
                        t1 = " ";
                        break $label0$0;
                    }
                    t1 = "";
                    break $label0$0;
                }
                return t1;
            },
            _serialize0$_elementNeedsParens$2: function(separator, value) {
                var t1;
                $label1$1: {
                    if (value instanceof A.SassList0 && value._list1$_contents.length > 1 && !value._list1$_hasBrackets) {
                        $label0$0: {
                            if (B.ListSeparator_z0K0 === separator) {
                                t1 = value._list1$_separator === B.ListSeparator_z0K0;
                                break $label0$0;
                            }
                            if (B.ListSeparator_Lul0 === separator) {
                                t1 = value._list1$_separator;
                                t1 = t1 === B.ListSeparator_z0K0 || t1 === B.ListSeparator_Lul0;
                                break $label0$0;
                            }
                            t1 = value._list1$_separator !== B.ListSeparator_undecided_null_3_undecided0;
                            break $label0$0;
                        }
                        break $label1$1;
                    }
                    t1 = false;
                    break $label1$1;
                }
                return t1;
            },
            visitMap$1: function(map) {
                var t1, t2, _this = this;
                if (!_this._serialize0$_inspect) throw A.wrapException(A.SassScriptException$0(map.toString$0(0) + " isn't a valid CSS value.", null));
                t1 = _this._serialize0$_buffer;
                t1.writeCharCode$1(40);
                t2 = map._map0$_contents;
                _this._serialize0$_writeBetween$3(t2.get$entries(t2), ", ", new A._SerializeVisitor_visitMap_closure0(_this));
                t1.writeCharCode$1(41);
            },
            _serialize0$_writeMapElement$1: function(value) {
                var needsParens = value instanceof A.SassList0 && value._list1$_separator === B.ListSeparator_z0K0 && !value._list1$_hasBrackets;
                if (needsParens) this._serialize0$_buffer.writeCharCode$1(40);
                value.accept$1(this);
                if (needsParens) this._serialize0$_buffer.writeCharCode$1(41);
            },
            visitNumber$1: function(value) {
                var before, after, t1, _1_0, _this = this, _0_0 = value.asSlash;
                if (type$.Record_2_nullable_Object_and_nullable_Object._is(_0_0)) {
                    before = _0_0._0;
                    after = _0_0._1;
                    _this.visitNumber$1(before);
                    _this._serialize0$_buffer.writeCharCode$1(47);
                    _this.visitNumber$1(after);
                    return;
                }
                t1 = value._number1$_value;
                if (!isFinite(t1)) {
                    _this.visitCalculation$1(new A.SassCalculation0("calc", A.List_List$unmodifiable(A._setArrayType([
                        value
                    ], type$.JSArray_Object), type$.Object)));
                    return;
                }
                if (value.get$hasComplexUnits()) _this.visitCalculation$1(new A.SassCalculation0("calc", A.List_List$unmodifiable(A._setArrayType([
                    value
                ], type$.JSArray_Object), type$.Object)));
                else {
                    _this._serialize0$_writeNumber$1(t1);
                    _1_0 = value.get$numeratorUnits(value);
                    if (_1_0.length === 1) _this._serialize0$_buffer.write$1(0, _1_0[0]);
                }
            },
            _serialize0$_writeNumberToString$1: function(number) {
                var t1 = new A.StringBuffer("");
                this._serialize0$_writeNumber$2(number, new A.NoSourceMapBuffer0(t1));
                t1 = t1._contents;
                return t1.charCodeAt(0) == 0 ? t1 : t1;
            },
            _serialize0$_writeNumber$2: function(number, buffer) {
                var _0_0, t1, integer, text, _this = this;
                if (buffer == null) buffer = _this._serialize0$_buffer;
                _0_0 = A.fuzzyAsInt0(number);
                t1 = false;
                if (_0_0 != null) {
                    t1 = !_this._serialize0$_inspect || number === _0_0;
                    integer = _0_0;
                } else integer = null;
                if (t1) {
                    buffer.write$1(0, _this._serialize0$_removeExponent$1(J.toString$0$(integer)));
                    return;
                }
                text = _this._serialize0$_removeExponent$1(B.JSNumber_methods.toString$0(number));
                if (_this._serialize0$_inspect) {
                    buffer.write$1(0, text);
                    return;
                }
                if (text.length < 12) {
                    buffer.write$1(0, _this._serialize0$_style === B.OutputStyle_10 && text.charCodeAt(0) === 48 ? B.JSString_methods.substring$1(text, 1) : text);
                    return;
                }
                _this._serialize0$_writeRounded$2(text, buffer);
            },
            _serialize0$_writeNumber$1: function(number) {
                return this._serialize0$_writeNumber$2(number, null);
            },
            _serialize0$_removeExponent$1: function(text) {
                var buffer, t2, t3, additionalZeroes, negative = text.charCodeAt(0) === 45, exponent = A._Cell$(), t1 = text.length, i = 0;
                for(;;){
                    if (!(i < t1)) {
                        buffer = null;
                        break;
                    }
                    c$0: {
                        if (text.charCodeAt(i) !== 101) break c$0;
                        buffer = new A.StringBuffer("");
                        t2 = buffer._contents = A.Primitives_stringFromCharCode(text.charCodeAt(0));
                        if (negative) {
                            t2 += A.Primitives_stringFromCharCode(text.charCodeAt(1));
                            buffer._contents = t2;
                            if (i > 3) buffer._contents = t2 + B.JSString_methods.substring$2(text, 3, i);
                        } else if (i > 2) buffer._contents = t2 + B.JSString_methods.substring$2(text, 2, i);
                        exponent.__late_helper$_value = A.int_parse(B.JSString_methods.substring$2(text, i + 1, t1), null);
                        break;
                    }
                    ++i;
                }
                if (buffer == null) return text;
                if (exponent._readLocal$0() > 0) {
                    t1 = exponent._readLocal$0();
                    t2 = buffer._contents;
                    t3 = negative ? 1 : 0;
                    additionalZeroes = t1 - (t2.length - 1 - t3);
                    for(t1 = t2, i = 0; i < additionalZeroes; ++i){
                        t1 = A.Primitives_stringFromCharCode(48);
                        t1 = buffer._contents += t1;
                    }
                    return t1.charCodeAt(0) == 0 ? t1 : t1;
                } else {
                    negative = text.charCodeAt(0) === 45;
                    t1 = (negative ? A.Primitives_stringFromCharCode(45) : "") + "0.";
                    i = -1;
                    for(;;){
                        t2 = exponent.__late_helper$_value;
                        if (t2 === exponent) A.throwExpression(A.LateError$localNI(""));
                        if (!(i > t2)) break;
                        t1 += A.Primitives_stringFromCharCode(48);
                        --i;
                    }
                    if (negative) {
                        t2 = buffer._contents;
                        t2 = B.JSString_methods.substring$1(t2.charCodeAt(0) == 0 ? t2 : t2, 1);
                    } else t2 = buffer;
                    t2 = t1 + A.S(t2);
                    return t2.charCodeAt(0) == 0 ? t2 : t2;
                }
            },
            _serialize0$_writeRounded$2: function(text, buffer) {
                var t1, digits, negative, textIndex, digitsIndex, textIndex0, codeUnit, digitsIndex0, indexAfterPrecision, digitsIndex1, newDigit, writtenIndex;
                if (B.JSString_methods.endsWith$1(text, ".0")) {
                    buffer.write$1(0, B.JSString_methods.substring$2(text, 0, text.length - 2));
                    return;
                }
                t1 = text.length;
                digits = new Uint8Array(t1 + 1);
                negative = text.charCodeAt(0) === 45;
                textIndex = negative ? 1 : 0;
                for(digitsIndex = 1;; textIndex = textIndex0, digitsIndex = digitsIndex0){
                    if (textIndex === t1) {
                        buffer.write$1(0, text);
                        return;
                    }
                    textIndex0 = textIndex + 1;
                    codeUnit = text.charCodeAt(textIndex);
                    if (codeUnit === 46) {
                        textIndex = textIndex0;
                        break;
                    }
                    digitsIndex0 = digitsIndex + 1;
                    digits[digitsIndex] = codeUnit - 48;
                }
                indexAfterPrecision = textIndex + 10;
                if (indexAfterPrecision >= t1) {
                    buffer.write$1(0, text);
                    return;
                }
                for(digitsIndex0 = digitsIndex; textIndex < indexAfterPrecision; textIndex = textIndex0, digitsIndex0 = digitsIndex1){
                    digitsIndex1 = digitsIndex0 + 1;
                    textIndex0 = textIndex + 1;
                    digits[digitsIndex0] = text.charCodeAt(textIndex) - 48;
                }
                if (text.charCodeAt(textIndex) - 48 >= 5) for(;; digitsIndex0 = digitsIndex1){
                    digitsIndex1 = digitsIndex0 - 1;
                    newDigit = digits[digitsIndex1] + 1;
                    digits[digitsIndex1] = newDigit;
                    if (newDigit !== 10) break;
                }
                for(; digitsIndex0 < digitsIndex; ++digitsIndex0)digits[digitsIndex0] = 0;
                for(;;){
                    t1 = digitsIndex0 > digitsIndex;
                    if (!(t1 && digits[digitsIndex0 - 1] === 0)) break;
                    --digitsIndex0;
                }
                if (digitsIndex0 === 2 && digits[0] === 0 && digits[1] === 0) {
                    buffer.writeCharCode$1(48);
                    return;
                }
                if (negative) buffer.writeCharCode$1(45);
                if (digits[0] === 0) writtenIndex = this._serialize0$_style === B.OutputStyle_10 && digits[1] === 0 ? 2 : 1;
                else writtenIndex = 0;
                for(; writtenIndex < digitsIndex; ++writtenIndex)buffer.writeCharCode$1(48 + digits[writtenIndex]);
                if (t1) {
                    buffer.writeCharCode$1(46);
                    for(; writtenIndex < digitsIndex0; ++writtenIndex)buffer.writeCharCode$1(48 + digits[writtenIndex]);
                }
            },
            _serialize0$_visitQuotedString$2$forceDoubleQuote: function(string, forceDoubleQuote) {
                var t1, includesSingleQuote, includesDoubleQuote, i, char, _1_2, _1_4, _0_0, quote, _this = this, buffer = forceDoubleQuote ? _this._serialize0$_buffer : new A.StringBuffer("");
                if (forceDoubleQuote) buffer.writeCharCode$1(34);
                for(t1 = string.length, includesSingleQuote = false, includesDoubleQuote = false, i = 0; i < t1; ++i){
                    char = string.charCodeAt(i);
                    _1_2 = 39 === char;
                    if (_1_2 && forceDoubleQuote) {
                        buffer.writeCharCode$1(39);
                        continue;
                    }
                    if (_1_2 && includesDoubleQuote) {
                        _this._serialize0$_visitQuotedString$2$forceDoubleQuote(string, true);
                        return;
                    }
                    if (_1_2) {
                        buffer.writeCharCode$1(39);
                        includesSingleQuote = true;
                        continue;
                    }
                    _1_4 = 34 === char;
                    if (_1_4 && forceDoubleQuote) {
                        buffer.writeCharCode$1(92);
                        buffer.writeCharCode$1(34);
                        continue;
                    }
                    if (_1_4 && includesSingleQuote) {
                        _this._serialize0$_visitQuotedString$2$forceDoubleQuote(string, true);
                        return;
                    }
                    if (_1_4) {
                        buffer.writeCharCode$1(34);
                        includesDoubleQuote = true;
                        continue;
                    }
                    if (0 === char || 1 === char || 2 === char || 3 === char || 4 === char || 5 === char || 6 === char || 7 === char || 8 === char || 10 === char || 11 === char || 12 === char || 13 === char || 14 === char || 15 === char || 16 === char || 17 === char || 18 === char || 19 === char || 20 === char || 21 === char || 22 === char || 23 === char || 24 === char || 25 === char || 26 === char || 27 === char || 28 === char || 29 === char || 30 === char || 31 === char || 127 === char) {
                        _this._serialize0$_writeEscape$4(buffer, char, string, i);
                        continue;
                    }
                    if (92 === char) {
                        buffer.writeCharCode$1(92);
                        buffer.writeCharCode$1(92);
                        continue;
                    }
                    _0_0 = _this._serialize0$_tryPrivateUseCharacter$4(buffer, char, string, i);
                    if (_0_0 != null) i = _0_0;
                    else buffer.writeCharCode$1(char);
                }
                if (forceDoubleQuote) buffer.writeCharCode$1(34);
                else {
                    quote = includesDoubleQuote ? 39 : 34;
                    t1 = _this._serialize0$_buffer;
                    t1.writeCharCode$1(quote);
                    t1.write$1(0, buffer);
                    t1.writeCharCode$1(quote);
                }
            },
            _serialize0$_visitQuotedString$1: function(string) {
                return this._serialize0$_visitQuotedString$2$forceDoubleQuote(string, false);
            },
            _serialize0$_visitUnquotedString$1: function(string) {
                var t1, t2, afterNewline, i, _1_0, _0_0;
                for(t1 = string.length, t2 = this._serialize0$_buffer, afterNewline = false, i = 0; i < t1; ++i){
                    _1_0 = string.charCodeAt(i);
                    if (10 === _1_0) {
                        t2.writeCharCode$1(32);
                        afterNewline = true;
                        continue;
                    }
                    if (32 === _1_0) {
                        if (!afterNewline) t2.writeCharCode$1(32);
                        continue;
                    }
                    _0_0 = this._serialize0$_tryPrivateUseCharacter$4(t2, _1_0, string, i);
                    if (_0_0 != null) i = _0_0;
                    else t2.writeCharCode$1(_1_0);
                    afterNewline = false;
                }
            },
            _serialize0$_tryPrivateUseCharacter$4: function(buffer, codeUnit, string, i) {
                var t1;
                if (this._serialize0$_style === B.OutputStyle_10) return null;
                if (codeUnit >= 57344 && codeUnit <= 63743) {
                    this._serialize0$_writeEscape$4(buffer, codeUnit, string, i);
                    return i;
                }
                if (codeUnit >>> 7 === 439 && string.length > i + 1) {
                    t1 = i + 1;
                    this._serialize0$_writeEscape$4(buffer, A.combineSurrogates(codeUnit, string.charCodeAt(t1)), string, t1);
                    return t1;
                }
                return null;
            },
            _serialize0$_writeEscape$4: function(buffer, character, string, i) {
                var t1, next;
                buffer.writeCharCode$1(92);
                buffer.write$1(0, B.JSInt_methods.toRadixString$1(character, 16));
                t1 = i + 1;
                if (string.length === t1) return;
                next = string.charCodeAt(t1);
                if (A.CharacterExtension_get_isHex0(next) || 32 === next || 9 === next) buffer.writeCharCode$1(32);
            },
            visitAttributeSelector$1: function(_, attribute) {
                var _0_0, t2, t1 = this._serialize0$_buffer;
                t1.writeCharCode$1(91);
                t1.write$1(0, attribute.name);
                _0_0 = attribute.value;
                if (_0_0 != null) {
                    t1.write$1(0, attribute.op);
                    if (A.Parser_isIdentifier0(_0_0) && !B.JSString_methods.startsWith$1(_0_0, "--")) {
                        t1.write$1(0, _0_0);
                        t2 = attribute.modifier;
                        if (t2 != null) t1.writeCharCode$1(32);
                    } else {
                        this._serialize0$_visitQuotedString$1(_0_0);
                        t2 = attribute.modifier;
                        if (t2 != null) {
                            if (this._serialize0$_style !== B.OutputStyle_10) t1.writeCharCode$1(32);
                        }
                    }
                    A.NullableExtension_andThen0(t2, t1.get$write(t1));
                }
                t1.writeCharCode$1(93);
            },
            visitClassSelector$1: function(_, klass) {
                var t1 = this._serialize0$_buffer;
                t1.writeCharCode$1(46);
                t1.write$1(0, klass.name);
            },
            visitComplexSelector$1: function(complex) {
                var t2, t3, t4, t5, t6, i, component, t7, t8, t9, _this = this, t1 = complex.leadingCombinators;
                _this._serialize0$_writeCombinators$1(t1);
                if (t1.length >= 1 && complex.components.length >= 1) {
                    if (_this._serialize0$_style !== B.OutputStyle_10) _this._serialize0$_buffer.writeCharCode$1(32);
                }
                for(t1 = complex.components, t2 = t1.length, t3 = t2 - 1, t4 = _this._serialize0$_buffer, t5 = _this._serialize0$_style === B.OutputStyle_10, t6 = !t5, i = 0; i < t2; ++i){
                    component = t1[i];
                    _this.visitCompoundSelector$1(component.selector);
                    t7 = component.combinators;
                    t8 = t7.length === 0;
                    if (!t8) {
                        if (t6) t4.writeCharCode$1(32);
                    }
                    t9 = t5 ? "" : " ";
                    _this._serialize0$_writeBetween$3(t7, t9, t4.get$write(t4));
                    if (i !== t3) t7 = !t5 || t8;
                    else t7 = false;
                    if (t7) t4.writeCharCode$1(32);
                }
            },
            _serialize0$_writeCombinators$1: function(combinators) {
                var t1 = this._serialize0$_style === B.OutputStyle_10 ? "" : " ", t2 = this._serialize0$_buffer;
                return this._serialize0$_writeBetween$3(combinators, t1, t2.get$write(t2));
            },
            visitCompoundSelector$1: function(compound) {
                var t2, t3, _i, t1 = this._serialize0$_buffer, start = t1.get$length(t1);
                for(t2 = compound.components, t3 = t2.length, _i = 0; _i < t3; ++_i)t2[_i].accept$1(this);
                if (t1.get$length(t1) === start) t1.writeCharCode$1(42);
            },
            visitIDSelector$1: function(_, id) {
                var t1 = this._serialize0$_buffer;
                t1.writeCharCode$1(35);
                t1.write$1(0, id.name);
            },
            visitSelectorList$1: function(list) {
                var t1, t2, t3, t4, first, t5, _this = this, complexes = list.components;
                for(t1 = J.get$iterator$ax(_this._serialize0$_inspect ? complexes : new A.WhereIterable(complexes, new A._SerializeVisitor_visitSelectorList_closure0(), A._arrayInstanceType(complexes)._eval$1("WhereIterable<1>"))), t2 = _this._serialize0$_style !== B.OutputStyle_10, t3 = _this._serialize0$_buffer, t4 = _this._lineFeed.text, first = true; t1.moveNext$0();){
                    t5 = t1.get$current(t1);
                    if (first) first = false;
                    else {
                        t3.writeCharCode$1(44);
                        if (t5.lineBreak) {
                            if (t2) t3.write$1(0, t4);
                            _this._serialize0$_writeIndentation$0();
                        } else if (t2) t3.writeCharCode$1(32);
                    }
                    _this.visitComplexSelector$1(t5);
                }
            },
            visitParentSelector$1: function(_, $parent) {
                var t1 = this._serialize0$_buffer;
                t1.writeCharCode$1(38);
                A.NullableExtension_andThen0($parent.suffix, t1.get$write(t1));
            },
            visitPlaceholderSelector$1: function(_, placeholder) {
                var t1 = this._serialize0$_buffer;
                t1.writeCharCode$1(37);
                t1.write$1(0, placeholder.name);
            },
            visitPseudoSelector$1: function(_, pseudo) {
                var _0_4, t3, t1 = pseudo.name, t2 = false;
                if ("not" === t1) {
                    _0_4 = pseudo.selector;
                    if (_0_4 instanceof A.SelectorList0) t2 = (_0_4 == null ? type$.SelectorList_2._as(_0_4) : _0_4).accept$1(B._IsInvisibleVisitor_true0);
                }
                if (t2) return;
                t2 = this._serialize0$_buffer;
                t2.writeCharCode$1(58);
                if (!pseudo.isSyntacticClass) t2.writeCharCode$1(58);
                t2.write$1(0, t1);
                t1 = pseudo.argument;
                t3 = t1 == null;
                if (t3 && pseudo.selector == null) return;
                t2.writeCharCode$1(40);
                if (!t3) {
                    t2.write$1(0, t1);
                    if (pseudo.selector != null) t2.writeCharCode$1(32);
                }
                A.NullableExtension_andThen0(pseudo.selector, this.get$visitSelectorList());
                t2.writeCharCode$1(41);
            },
            visitTypeSelector$1: function(_, type) {
                this._serialize0$_buffer.write$1(0, type.name);
            },
            visitUniversalSelector$1: function(_, universal) {
                var t2, t1 = universal.namespace;
                if (t1 != null) {
                    t2 = this._serialize0$_buffer;
                    t2.write$1(0, t1);
                    t2.writeCharCode$1(124);
                }
                this._serialize0$_buffer.writeCharCode$1(42);
            },
            _serialize0$_write$1: function(value) {
                return this._serialize0$_buffer.forSpan$2(value.span, new A._SerializeVisitor__write_closure0(this, value));
            },
            _serialize0$_visitChildren$1: function($parent) {
                var t2, t3, t4, t5, t6, t7, t8, prePrevious, previous, t9, previous0, t10, savedIndentation, _this = this, t1 = _this._serialize0$_buffer;
                t1.writeCharCode$1(123);
                for(t2 = $parent.children, t3 = t2.$ti, t2 = new A.ListIterator(t2, t2.get$length(0), t3._eval$1("ListIterator<ListBase.E>")), t4 = _this._serialize0$_style === B.OutputStyle_10, t5 = !t4, t6 = _this.get$_serialize0$_requiresSemicolon(), t7 = !_this._serialize0$_inspect, t3 = t3._eval$1("ListBase.E"), t8 = _this._lineFeed.text, prePrevious = null, previous = null; t2.moveNext$0();){
                    t9 = t2.__internal$_current;
                    previous0 = t9 == null ? t3._as(t9) : t9;
                    if (t7) t9 = t4 ? previous0.accept$1(B._IsInvisibleVisitor_true_true0) : previous0.accept$1(B._IsInvisibleVisitor_true_false0);
                    else t9 = false;
                    if (t9) continue;
                    t9 = previous == null;
                    t10 = t9 ? null : t6.call$1(previous);
                    if (t10 == null ? false : t10) t1.writeCharCode$1(59);
                    if (_this._serialize0$_isTrailingComment$2(previous0, t9 ? $parent : previous)) {
                        if (t5) t1.writeCharCode$1(32);
                        savedIndentation = _this._serialize0$_indentation;
                        _this._serialize0$_indentation = 0;
                        new A._SerializeVisitor__visitChildren_closure1(_this, previous0).call$0();
                        _this._serialize0$_indentation = savedIndentation;
                    } else {
                        if (t5) t1.write$1(0, t8);
                        ++_this._serialize0$_indentation;
                        new A._SerializeVisitor__visitChildren_closure2(_this, previous0).call$0();
                        --_this._serialize0$_indentation;
                    }
                    prePrevious = previous;
                    previous = previous0;
                }
                if (previous != null) {
                    if ((type$.CssParentNode_2._is(previous) ? previous.get$isChildless() : !(previous instanceof A.ModifiableCssComment0)) && t5) t1.writeCharCode$1(59);
                    if (prePrevious == null && _this._serialize0$_isTrailingComment$2(previous, $parent)) {
                        if (t5) t1.writeCharCode$1(32);
                    } else {
                        _this._serialize0$_writeLineFeed$0();
                        _this._serialize0$_writeIndentation$0();
                    }
                }
                t1.writeCharCode$1(125);
            },
            _serialize0$_requiresSemicolon$1: function(node) {
                return type$.CssParentNode_2._is(node) ? node.get$isChildless() : !(node instanceof A.ModifiableCssComment0);
            },
            _serialize0$_isTrailingComment$2: function(node, previous) {
                var t1, t2, t3, searchFrom, endOffset, t4, span;
                if (this._serialize0$_style === B.OutputStyle_10) return false;
                if (!(node instanceof A.ModifiableCssComment0)) return false;
                t1 = node.span;
                t2 = t1.get$sourceUrl(t1);
                t3 = previous.get$span(previous);
                if (!J.$eq$(t2, t3.get$sourceUrl(t3))) return false;
                t2 = previous.get$span(previous);
                if (!(J.$eq$(t2.get$file(t2).url, t1.get$file(t1).url) && t2.get$start(t2).offset <= t1.get$start(t1).offset && t2.get$end(t2).offset >= t1.get$end(t1).offset)) {
                    t1 = t1.get$start(t1);
                    t1 = t1.file.getLine$1(t1.offset);
                    t2 = previous.get$span(previous);
                    t2 = t2.get$end(t2);
                    return t1 === t2.file.getLine$1(t2.offset);
                }
                t2 = t1.get$start(t1);
                t3 = previous.get$span(previous);
                searchFrom = t2.offset - t3.get$start(t3).offset - 1;
                if (searchFrom < 0) return false;
                endOffset = Math.max(0, B.JSString_methods.lastIndexOf$2(previous.get$span(previous).get$text(), "{", searchFrom));
                t2 = previous.get$span(previous);
                t2 = t2.get$file(t2);
                t3 = previous.get$span(previous);
                t3 = t3.get$start(t3);
                t4 = previous.get$span(previous);
                span = t2.span$2(0, t3.offset, t4.get$start(t4).offset + endOffset);
                t1 = t1.get$start(t1);
                t1 = t1.file.getLine$1(t1.offset);
                t4 = A.FileLocation$_(span.file, span._end);
                return t1 === t4.file.getLine$1(t4.offset);
            },
            _serialize0$_writeLineFeed$0: function() {
                if (this._serialize0$_style !== B.OutputStyle_10) this._serialize0$_buffer.write$1(0, this._lineFeed.text);
            },
            _serialize0$_writeIndentation$0: function() {
                var _this = this;
                if (_this._serialize0$_style === B.OutputStyle_10) return;
                _this._serialize0$_writeTimes$2(_this._serialize0$_indentCharacter, _this._serialize0$_indentation * _this._serialize0$_indentWidth);
            },
            _serialize0$_writeTimes$2: function(char, times) {
                var t1, i;
                for(t1 = this._serialize0$_buffer, i = 0; i < times; ++i)t1.writeCharCode$1(char);
            },
            _serialize0$_writeBetween$1$3: function(iterable, text, callback) {
                var t1, t2, first, value;
                for(t1 = J.get$iterator$ax(iterable), t2 = this._serialize0$_buffer, first = true; t1.moveNext$0();){
                    value = t1.get$current(t1);
                    if (first) first = false;
                    else t2.write$1(0, text);
                    callback.call$1(value);
                }
            },
            _serialize0$_writeBetween$3: function(iterable, text, callback) {
                return this._serialize0$_writeBetween$1$3(iterable, text, callback, type$.dynamic);
            }
        };
        A._SerializeVisitor_visitCssComment_closure0.prototype = {
            call$0: function() {
                var t2, t3, _0_0, minimumIndentation, t1 = this.$this;
                if (t1._serialize0$_style === B.OutputStyle_10 && this.node.text.charCodeAt(2) !== 33) return;
                t2 = this.node;
                t3 = t2.text;
                if (B.JSString_methods.startsWith$1(t3, A.RegExp_RegExp("/\\*# source(Mapping)?URL=", false))) return;
                _0_0 = t1._serialize0$_minimumIndentation$1(t3);
                if (_0_0 != null) {
                    t2 = t2.span;
                    t2 = t2.get$start(t2);
                    minimumIndentation = Math.min(_0_0, t2.file.getColumn$1(t2.offset));
                    t1._serialize0$_writeIndentation$0();
                    t1._serialize0$_writeWithIndent$2(t3, minimumIndentation);
                } else {
                    t1._serialize0$_writeIndentation$0();
                    t1._serialize0$_buffer.write$1(0, t3);
                }
            },
            $signature: 1
        };
        A._SerializeVisitor_visitCssAtRule_closure0.prototype = {
            call$0: function() {
                var t3, _0_0, t1 = this.$this, t2 = t1._serialize0$_buffer;
                t2.writeCharCode$1(64);
                t3 = this.node;
                t1._serialize0$_write$1(t3.name);
                _0_0 = t3.value;
                if (_0_0 != null) {
                    t2.writeCharCode$1(32);
                    t1._serialize0$_write$1(_0_0);
                }
            },
            $signature: 1
        };
        A._SerializeVisitor_visitCssMediaRule_closure0.prototype = {
            call$0: function() {
                var t3, firstQuery, t4, t5, t1 = this.$this, t2 = t1._serialize0$_buffer;
                t2.write$1(0, "@media");
                t3 = this.node.queries;
                firstQuery = B.JSArray_methods.get$first(t3);
                t4 = t1._serialize0$_style === B.OutputStyle_10;
                t5 = true;
                if (t4) {
                    if (firstQuery.modifier == null) {
                        if (firstQuery.type == null) {
                            t5 = firstQuery.conditions;
                            t5 = t5.length === 1 && B.JSString_methods.startsWith$1(B.JSArray_methods.get$first(t5), "(not ");
                        }
                    }
                }
                if (t5) t2.writeCharCode$1(32);
                t2 = t4 ? "," : ", ";
                t1._serialize0$_writeBetween$3(t3, t2, t1.get$_serialize0$_visitMediaQuery());
            },
            $signature: 1
        };
        A._SerializeVisitor_visitCssImport_closure0.prototype = {
            call$0: function() {
                var t3, t4, _0_0, t1 = this.$this, t2 = t1._serialize0$_buffer;
                t2.write$1(0, "@import");
                t3 = t1._serialize0$_style !== B.OutputStyle_10;
                if (t3) t2.writeCharCode$1(32);
                t4 = this.node;
                t2.forSpan$2(t4.url.span, new A._SerializeVisitor_visitCssImport__closure0(t1, t4));
                _0_0 = t4.modifiers;
                if (_0_0 != null) {
                    if (t3) t2.writeCharCode$1(32);
                    t2.write$1(0, _0_0);
                }
            },
            $signature: 1
        };
        A._SerializeVisitor_visitCssImport__closure0.prototype = {
            call$0: function() {
                return this.$this._serialize0$_writeImportUrl$1(this.node.url.value);
            },
            $signature: 0
        };
        A._SerializeVisitor_visitCssKeyframeBlock_closure0.prototype = {
            call$0: function() {
                var t1 = this.$this, t2 = t1._serialize0$_style === B.OutputStyle_10 ? "," : ", ", t3 = t1._serialize0$_buffer;
                return t1._serialize0$_writeBetween$3(this.node.selector.value, t2, t3.get$write(t3));
            },
            $signature: 0
        };
        A._SerializeVisitor_visitCssStyleRule_closure0.prototype = {
            call$0: function() {
                return this.$this.visitSelectorList$1(this.node._style_rule0$_selector._box0$_inner.value);
            },
            $signature: 0
        };
        A._SerializeVisitor_visitCssSupportsRule_closure0.prototype = {
            call$0: function() {
                var t1 = this.$this, t2 = t1._serialize0$_buffer;
                t2.write$1(0, "@supports");
                if (!(t1._serialize0$_style === B.OutputStyle_10 && this.node.condition.value.charCodeAt(0) === 40)) t2.writeCharCode$1(32);
                t1._serialize0$_write$1(this.node.condition);
            },
            $signature: 1
        };
        A._SerializeVisitor_visitCssDeclaration_closure1.prototype = {
            call$0: function() {
                var t1 = this.$this, t2 = this.node;
                if (t1._serialize0$_style === B.OutputStyle_10) t1._serialize0$_writeFoldedValue$1(t2);
                else t1._serialize0$_writeReindentedValue$1(t2);
            },
            $signature: 1
        };
        A._SerializeVisitor_visitCssDeclaration_closure2.prototype = {
            call$0: function() {
                return this.node.value.value.accept$1(this.$this);
            },
            $signature: 0
        };
        A._SerializeVisitor_visitList_closure2.prototype = {
            call$1: function(element) {
                return !element.get$isBlank();
            },
            $signature: 56
        };
        A._SerializeVisitor_visitList_closure3.prototype = {
            call$1: function(element) {
                var t1 = this.$this, needsParens = t1._serialize0$_elementNeedsParens$2(this.value._list1$_separator, element);
                if (needsParens) t1._serialize0$_buffer.writeCharCode$1(40);
                element.accept$1(t1);
                if (needsParens) t1._serialize0$_buffer.writeCharCode$1(41);
            },
            $signature: 63
        };
        A._SerializeVisitor_visitList_closure4.prototype = {
            call$1: function(element) {
                element.accept$1(this.$this);
            },
            $signature: 63
        };
        A._SerializeVisitor_visitMap_closure0.prototype = {
            call$1: function(entry) {
                var t1 = this.$this;
                t1._serialize0$_writeMapElement$1(entry.key);
                t1._serialize0$_buffer.write$1(0, ": ");
                t1._serialize0$_writeMapElement$1(entry.value);
            },
            $signature: 597
        };
        A._SerializeVisitor_visitSelectorList_closure0.prototype = {
            call$1: function(complex) {
                return !complex.accept$1(B._IsInvisibleVisitor_true0);
            },
            $signature: 22
        };
        A._SerializeVisitor__write_closure0.prototype = {
            call$0: function() {
                return this.$this._serialize0$_buffer.write$1(0, this.value.value);
            },
            $signature: 0
        };
        A._SerializeVisitor__visitChildren_closure1.prototype = {
            call$0: function() {
                return this.child.accept$1(this.$this);
            },
            $signature: 0
        };
        A._SerializeVisitor__visitChildren_closure2.prototype = {
            call$0: function() {
                this.child.accept$1(this.$this);
            },
            $signature: 0
        };
        A.OutputStyle0.prototype = {
            _enumToString$0: function() {
                return "OutputStyle." + this._name;
            }
        };
        A.LineFeed0.prototype = {
            _enumToString$0: function() {
                return "LineFeed." + this._name;
            },
            toString$0: function(_) {
                return this.name;
            }
        };
        A.JSSet.prototype = {};
        A.ShadowedModuleView0.prototype = {
            get$url: function(_) {
                var t1 = this._shadowed_view0$_inner;
                return t1.get$url(t1);
            },
            get$upstream: function() {
                return this._shadowed_view0$_inner.get$upstream();
            },
            get$extensionStore: function() {
                return this._shadowed_view0$_inner.get$extensionStore();
            },
            get$css: function(_) {
                var t1 = this._shadowed_view0$_inner;
                return t1.get$css(t1);
            },
            get$preModuleComments: function() {
                return this._shadowed_view0$_inner.get$preModuleComments();
            },
            get$transitivelyContainsCss: function() {
                return this._shadowed_view0$_inner.get$transitivelyContainsCss();
            },
            get$transitivelyContainsExtensions: function() {
                return this._shadowed_view0$_inner.get$transitivelyContainsExtensions();
            },
            setVariable$3: function($name, value, nodeWithSpan) {
                if (!this.variables.containsKey$1($name)) throw A.wrapException(A.SassScriptException$0("Undefined variable.", null));
                else this._shadowed_view0$_inner.setVariable$3($name, value, nodeWithSpan);
            },
            variableIdentity$1: function($name) {
                return this._shadowed_view0$_inner.variableIdentity$1($name);
            },
            couldHaveBeenConfigured$1: function(variables) {
                var t3, t4, t1 = this.variables, t2 = this._shadowed_view0$_inner;
                if (t1 === t2.get$variables()) t1 = t2.couldHaveBeenConfigured$1(variables);
                else {
                    t3 = A.LinkedHashSet_LinkedHashSet$_empty(type$.String);
                    for(t1 = t1.get$keys(t1), t1 = t1.get$iterator(t1); t1.moveNext$0();){
                        t4 = t1.get$current(t1);
                        if (variables.contains$1(0, t4)) t3.add$1(0, t4);
                    }
                    t1 = t2.couldHaveBeenConfigured$1(t3);
                }
                return t1;
            },
            $eq: function(_, other) {
                var t1, t2, t3, _this = this;
                if (other == null) return false;
                t1 = false;
                if (other instanceof A.ShadowedModuleView0) {
                    if (_this._shadowed_view0$_inner.$eq(0, other._shadowed_view0$_inner)) {
                        t2 = _this.variables;
                        t2 = t2.get$keys(t2);
                        t3 = other.variables;
                        if (B.C_IterableEquality.equals$2(0, t2, t3.get$keys(t3))) {
                            t2 = _this.functions;
                            t2 = t2.get$keys(t2);
                            t3 = other.functions;
                            if (B.C_IterableEquality.equals$2(0, t2, t3.get$keys(t3))) {
                                t1 = _this.mixins;
                                t1 = t1.get$keys(t1);
                                t2 = other.mixins;
                                t2 = B.C_IterableEquality.equals$2(0, t1, t2.get$keys(t2));
                                t1 = t2;
                            }
                        }
                    }
                }
                return t1;
            },
            get$hashCode: function(_) {
                var t1 = this._shadowed_view0$_inner;
                return t1.get$hashCode(t1);
            },
            cloneCss$0: function() {
                var _this = this;
                return new A.ShadowedModuleView0(_this._shadowed_view0$_inner.cloneCss$0(), _this.variables, _this.variableNodes, _this.functions, _this.mixins, _this.$ti);
            },
            toString$0: function(_) {
                return "shadowed " + this._shadowed_view0$_inner.toString$0(0);
            },
            $isModule1: 1,
            get$variables: function() {
                return this.variables;
            },
            get$variableNodes: function() {
                return this.variableNodes;
            },
            get$functions: function(receiver) {
                return this.functions;
            },
            get$mixins: function() {
                return this.mixins;
            }
        };
        A.SilentComment0.prototype = {
            accept$1$1: function(visitor) {
                return visitor.visitSilentComment$1(0, this);
            },
            accept$1: function(visitor) {
                return this.accept$1$1(visitor, type$.dynamic);
            },
            toString$0: function(_) {
                return this.text;
            },
            get$span: function(receiver) {
                return this.span;
            }
        };
        A.InterpolatedSimpleSelector.prototype = {};
        A.SimpleSelector0.prototype = {
            get$specificity: function() {
                return 1000;
            },
            get$hasComplicatedSuperselectorSemantics: function() {
                return false;
            },
            addSuffix$1: function(suffix) {
                return A.throwExpression(A.MultiSpanSassException$0('Selector "' + this.toString$0(0) + "\" can't have a suffix", this.span, "outer selector", A.LinkedHashMap_LinkedHashMap$_empty(type$.FileSpan, type$.String), null));
            },
            unify$1: function(compound) {
                var other, result, addedThis, _i, simple, _this = this, t1 = false;
                if (compound.length === 1) {
                    other = compound[0];
                    if (!(other instanceof A.UniversalSelector0)) {
                        if (other instanceof A.PseudoSelector0) t1 = other.isClass && other.name === "host" || other.get$isHostContext();
                    } else t1 = true;
                } else other = null;
                if (t1) return other.unify$1(A._setArrayType([
                    _this
                ], type$.JSArray_SimpleSelector_2));
                if (B.JSArray_methods.contains$1(compound, _this)) return compound;
                result = A._setArrayType([], type$.JSArray_SimpleSelector_2);
                for(t1 = compound.length, addedThis = false, _i = 0; _i < compound.length; compound.length === t1 || (0, A.throwConcurrentModificationError)(compound), ++_i){
                    simple = compound[_i];
                    if (!addedThis && simple instanceof A.PseudoSelector0) {
                        result.push(_this);
                        addedThis = true;
                    }
                    result.push(simple);
                }
                if (!addedThis) result.push(_this);
                return result;
            },
            isSuperselector$1: function(other) {
                var list;
                if (this.$eq(0, other)) return true;
                if (other instanceof A.PseudoSelector0 && other.isClass) {
                    list = other.selector;
                    if (list != null && $._subselectorPseudos0.contains$1(0, other.normalizedName)) return B.JSArray_methods.every$1(list.components, new A.SimpleSelector_isSuperselector_closure0(this));
                }
                return false;
            }
        };
        A.SimpleSelector_isSuperselector_closure0.prototype = {
            call$1: function(complex) {
                var t1 = complex.components;
                return t1.length !== 0 && B.JSArray_methods.any$1(B.JSArray_methods.get$last(t1).selector.components, new A.SimpleSelector_isSuperselector__closure0(this.$this));
            },
            $signature: 22
        };
        A.SimpleSelector_isSuperselector__closure0.prototype = {
            call$1: function(simple) {
                return this.$this.isSuperselector$1(simple);
            },
            $signature: 15
        };
        A.JSSimpleSelectorVisitor.prototype = {
            visitSelectorList$1: function(_) {
                return this._simpleSelectorError$0();
            },
            visitComplexSelector$1: function(_) {
                return this._simpleSelectorError$0();
            },
            visitCompoundSelector$1: function(_) {
                return this._simpleSelectorError$0();
            },
            _simpleSelectorError$0: function() {
                return A.throwExpression(A.UnsupportedError$("SimpleSelectorVisitor only supports SimpleSelectors"));
            },
            $isInterpolatedSelectorVisitor: 1
        };
        A.JSSimpleSelectorVisitorObject.prototype = {};
        A.SingleUnitSassNumber0.prototype = {
            get$numeratorUnits: function(_) {
                return A.List_List$unmodifiable([
                    this._single_unit$_unit
                ], type$.String);
            },
            get$denominatorUnits: function(_) {
                return B.List_empty;
            },
            get$hasUnits: function() {
                return true;
            },
            get$hasComplexUnits: function() {
                return false;
            },
            withValue$1: function(value) {
                return new A.SingleUnitSassNumber0(this._single_unit$_unit, value, null);
            },
            withSlash$2: function(numerator, denominator) {
                return new A.SingleUnitSassNumber0(this._single_unit$_unit, this._number1$_value, new A._Record_2(numerator, denominator));
            },
            hasUnit$1: function(unit) {
                return unit === this._single_unit$_unit;
            },
            hasCompatibleUnits$1: function(other) {
                return other instanceof A.SingleUnitSassNumber0 && A.conversionFactor0(this._single_unit$_unit, other._single_unit$_unit) != null;
            },
            hasPossiblyCompatibleUnits$1: function(other) {
                var t1, knownCompatibilities, otherUnit;
                if (!(other instanceof A.SingleUnitSassNumber0)) return false;
                t1 = $.$get$_knownCompatibilitiesByUnit0();
                knownCompatibilities = t1.$index(0, this._single_unit$_unit.toLowerCase());
                if (knownCompatibilities == null) return true;
                otherUnit = other._single_unit$_unit.toLowerCase();
                return knownCompatibilities.contains$1(0, otherUnit) || !t1.containsKey$1(otherUnit);
            },
            compatibleWithUnit$1: function(unit) {
                return A.conversionFactor0(this._single_unit$_unit, unit) != null;
            },
            coerceToMatch$3: function(other, $name, otherName) {
                var t1 = other instanceof A.SingleUnitSassNumber0 ? this._single_unit$_coerceToUnit$1(other._single_unit$_unit) : null;
                return t1 == null ? this.super$SassNumber$coerceToMatch0(other, $name, otherName) : t1;
            },
            coerceToMatch$1: function(other) {
                return this.coerceToMatch$3(other, null, null);
            },
            coerceValueToMatch$3: function(other, $name, otherName) {
                var t1 = other instanceof A.SingleUnitSassNumber0 ? this._single_unit$_coerceValueToUnit$1(other._single_unit$_unit) : null;
                return t1 == null ? this.super$SassNumber$coerceValueToMatch0(other, $name, otherName) : t1;
            },
            coerceValueToMatch$1: function(other) {
                return this.coerceValueToMatch$3(other, null, null);
            },
            convertToMatch$3: function(other, $name, otherName) {
                var t1 = other instanceof A.SingleUnitSassNumber0 ? this._single_unit$_coerceToUnit$1(other._single_unit$_unit) : null;
                return t1 == null ? this.super$SassNumber$convertToMatch(other, $name, otherName) : t1;
            },
            convertValueToMatch$3: function(other, $name, otherName) {
                var t1 = other instanceof A.SingleUnitSassNumber0 ? this._single_unit$_coerceValueToUnit$1(other._single_unit$_unit) : null;
                return t1 == null ? this.super$SassNumber$convertValueToMatch0(other, $name, otherName) : t1;
            },
            convertValueToMatch$1: function(other) {
                return this.convertValueToMatch$3(other, null, null);
            },
            coerce$3: function(newNumerators, newDenominators, $name) {
                var t1 = J.getInterceptor$asx(newNumerators);
                t1 = t1.get$length(newNumerators) === 1 && J.get$isEmpty$asx(newDenominators) ? this._single_unit$_coerceToUnit$1(t1.$index(newNumerators, 0)) : null;
                return t1 == null ? this.super$SassNumber$coerce0(newNumerators, newDenominators, $name) : t1;
            },
            coerce$2: function(newNumerators, newDenominators) {
                return this.coerce$3(newNumerators, newDenominators, null);
            },
            coerceValue$3: function(newNumerators, newDenominators, $name) {
                var t1 = J.getInterceptor$asx(newNumerators);
                t1 = t1.get$length(newNumerators) === 1 && J.get$isEmpty$asx(newDenominators) ? this._single_unit$_coerceValueToUnit$1(t1.$index(newNumerators, 0)) : null;
                return t1 == null ? this.super$SassNumber$coerceValue0(newNumerators, newDenominators, $name) : t1;
            },
            coerceValueToUnit$2: function(unit, $name) {
                var t1 = this._single_unit$_coerceValueToUnit$1(unit);
                return t1 == null ? this.super$SassNumber$coerceValueToUnit0(unit, $name) : t1;
            },
            coerceValueToUnit$1: function(unit) {
                return this.coerceValueToUnit$2(unit, null);
            },
            _single_unit$_coerceToUnit$1: function(unit) {
                var t1 = this._single_unit$_unit;
                if (t1 === unit) return this;
                return A.NullableExtension_andThen0(A.conversionFactor0(unit, t1), new A.SingleUnitSassNumber__coerceToUnit_closure0(this, unit));
            },
            _single_unit$_coerceValueToUnit$1: function(unit) {
                return A.NullableExtension_andThen0(A.conversionFactor0(unit, this._single_unit$_unit), new A.SingleUnitSassNumber__coerceValueToUnit_closure0(this));
            },
            multiplyUnits$3: function(value, otherNumerators, otherDenominators) {
                var mutableOtherDenominators, t1 = {};
                t1.value = value;
                t1.newNumerators = otherNumerators;
                mutableOtherDenominators = A._setArrayType(otherDenominators.slice(0), A._arrayInstanceType(otherDenominators));
                A.removeFirstWhere0(mutableOtherDenominators, new A.SingleUnitSassNumber_multiplyUnits_closure1(t1, this), new A.SingleUnitSassNumber_multiplyUnits_closure2(t1, this));
                return A.SassNumber_SassNumber$withUnits0(t1.value, mutableOtherDenominators, t1.newNumerators);
            },
            unaryMinus$0: function() {
                return new A.SingleUnitSassNumber0(this._single_unit$_unit, -this._number1$_value, null);
            },
            $eq: function(_, other) {
                var factor;
                if (other == null) return false;
                if (other instanceof A.SingleUnitSassNumber0) {
                    factor = A.conversionFactor0(other._single_unit$_unit, this._single_unit$_unit);
                    return factor != null && A.fuzzyEquals0(this._number1$_value * factor, other._number1$_value);
                } else return false;
            },
            get$hashCode: function(_) {
                var _this = this, t1 = _this.hashCache;
                return t1 == null ? _this.hashCache = A.fuzzyHashCode0(_this._number1$_value * _this.canonicalMultiplierForUnit$1(_this._single_unit$_unit)) : t1;
            }
        };
        A.SingleUnitSassNumber__coerceToUnit_closure0.prototype = {
            call$1: function(factor) {
                return new A.SingleUnitSassNumber0(this.unit, this.$this._number1$_value * factor, null);
            },
            $signature: 598
        };
        A.SingleUnitSassNumber__coerceValueToUnit_closure0.prototype = {
            call$1: function(factor) {
                return this.$this._number1$_value * factor;
            },
            $signature: 12
        };
        A.SingleUnitSassNumber_multiplyUnits_closure1.prototype = {
            call$1: function(denominator) {
                var factor = A.conversionFactor0(denominator, this.$this._single_unit$_unit);
                if (factor == null) return false;
                this._box_0.value *= factor;
                return true;
            },
            $signature: 4
        };
        A.SingleUnitSassNumber_multiplyUnits_closure2.prototype = {
            call$0: function() {
                var t1 = A._setArrayType([
                    this.$this._single_unit$_unit
                ], type$.JSArray_String), t2 = this._box_0;
                B.JSArray_methods.addAll$1(t1, t2.newNumerators);
                t2.newNumerators = t1;
            },
            $signature: 0
        };
        A.SourceInterpolationVisitor.prototype = {
            visitBinaryOperationExpression$1: function(_, node) {
                return this.buffer = null;
            },
            visitBooleanExpression$1: function(_, node) {
                return this.buffer = null;
            },
            visitColorExpression$1: function(_, node) {
                var t2, t1 = this.buffer;
                if (t1 != null) {
                    t2 = node.span.get$text();
                    t1 = t1._interpolation_buffer0$_text;
                    t1._contents += t2;
                }
                return null;
            },
            visitFunctionExpression$1: function(_, node) {
                return this.buffer = null;
            },
            visitInterpolatedFunctionExpression$1: function(_, node) {
                var t1 = this.buffer;
                if (t1 != null) t1.addInterpolation$1(node.name);
                this._visitArguments$1(node.$arguments);
            },
            _visitArguments$1: function($arguments) {
                var t2, t3, _this = this, t1 = $arguments.named;
                if (t1.get$isNotEmpty(t1) || $arguments.rest != null) return;
                t1 = $arguments.positional;
                if (t1.length === 0) {
                    t1 = _this.buffer;
                    if (t1 != null) {
                        t2 = $arguments.span.get$text();
                        t1 = t1._interpolation_buffer0$_text;
                        t1._contents += t2;
                    }
                    return;
                }
                t2 = _this.buffer;
                if (t2 != null) {
                    t3 = B.JSArray_methods.get$first(t1);
                    t3 = A.SpanExtensions_before($arguments.span, t3.get$span(t3));
                    t3 = A.String_String$fromCharCodes(B.NativeUint32List_methods.sublist$2(t3.file._decodedChars, t3._file$_start, t3._end), 0, null);
                    t2 = t2._interpolation_buffer0$_text;
                    t2._contents += t3;
                }
                _this._writeListAndBetween$2(t1, new A.SourceInterpolationVisitor__visitArguments_closure(_this));
                t2 = _this.buffer;
                if (t2 != null) {
                    t1 = B.JSArray_methods.get$last(t1);
                    t1 = A.SpanExtensions_after($arguments.span, t1.get$span(t1));
                    t1 = A.String_String$fromCharCodes(B.NativeUint32List_methods.sublist$2(t1.file._decodedChars, t1._file$_start, t1._end), 0, null);
                    t2 = t2._interpolation_buffer0$_text;
                    t2._contents += t1;
                }
            },
            visitIfExpression$1: function(_, node) {
                var t1, t2, t3, lastSpan, _i, t4, condition, expression, firstSpan, t5, t6, t7, t8, _this = this, _null = null;
                for(t1 = node.branches, t2 = t1.length, t3 = node.span, lastSpan = _null, _i = 0; _i < t2; ++_i){
                    t4 = t1[_i];
                    condition = t4._0;
                    expression = t4._1;
                    t4 = condition == null;
                    firstSpan = t4 ? _null : condition.get$span(condition);
                    if (firstSpan == null) firstSpan = expression.get$span(expression);
                    t5 = _this.buffer;
                    if (t5 != null) {
                        t6 = lastSpan == null ? _null : A.SpanExtensions_between(lastSpan, firstSpan);
                        if (t6 == null) t6 = A.SpanExtensions_before(t3, firstSpan);
                        t7 = t6._file$_start;
                        t8 = t6.file._decodedChars;
                        t8 = A.String_String$fromCharCodes(new Uint32Array(t8.subarray(t7, A._checkValidRange(t7, t6._end, t8.length))), 0, _null);
                        t5 = t5._interpolation_buffer0$_text;
                        t5._contents += t8;
                    }
                    if (!t4) {
                        condition.accept$1(_this);
                        t4 = _this.buffer;
                        if (t4 != null) {
                            t5 = A.SpanExtensions_between(condition.get$span(condition), expression.get$span(expression));
                            t6 = t5._file$_start;
                            t7 = t5.file._decodedChars;
                            t7 = A.String_String$fromCharCodes(new Uint32Array(t7.subarray(t6, A._checkValidRange(t6, t5._end, t7.length))), 0, _null);
                            t4 = t4._interpolation_buffer0$_text;
                            t4._contents += t7;
                        }
                    }
                    expression.accept$1(_this);
                    lastSpan = expression.get$span(expression);
                }
            },
            visitIfConditionParenthesized$1: function(_, node) {
                var t2, t1 = this.buffer;
                if (t1 != null) {
                    t2 = node.expression;
                    t2 = A.SpanExtensions_before(node.span, t2.get$span(t2));
                    t2 = A.String_String$fromCharCodes(B.NativeUint32List_methods.sublist$2(t2.file._decodedChars, t2._file$_start, t2._end), 0, null);
                    t1 = t1._interpolation_buffer0$_text;
                    t1._contents += t2;
                }
                t1 = node.expression;
                t1.accept$1(this);
                t2 = this.buffer;
                if (t2 != null) {
                    t1 = A.SpanExtensions_after(node.span, t1.get$span(t1));
                    t1 = A.String_String$fromCharCodes(B.NativeUint32List_methods.sublist$2(t1.file._decodedChars, t1._file$_start, t1._end), 0, null);
                    t2 = t2._interpolation_buffer0$_text;
                    t2._contents += t1;
                }
            },
            visitIfConditionNegation$1: function(_, node) {
                var t2, t1 = this.buffer;
                if (t1 != null) {
                    t2 = node.expression;
                    t2 = A.SpanExtensions_before(node.span, t2.get$span(t2));
                    t2 = A.String_String$fromCharCodes(B.NativeUint32List_methods.sublist$2(t2.file._decodedChars, t2._file$_start, t2._end), 0, null);
                    t1 = t1._interpolation_buffer0$_text;
                    t1._contents += t2;
                }
                node.expression.accept$1(this);
            },
            visitIfConditionOperation$1: function(_, node) {
                this._writeListAndBetween$2(node.expressions, new A.SourceInterpolationVisitor_visitIfConditionOperation_closure(this));
            },
            visitIfConditionFunction$1: function(_, node) {
                var t2, _this = this, t1 = _this.buffer;
                if (t1 != null) t1.addInterpolation$1(node.name);
                t1 = _this.buffer;
                if (t1 != null) {
                    t2 = A.SpanExtensions_between(node.name.span, node.$arguments.span);
                    t2 = A.String_String$fromCharCodes(B.NativeUint32List_methods.sublist$2(t2.file._decodedChars, t2._file$_start, t2._end), 0, null);
                    t1 = t1._interpolation_buffer0$_text;
                    t1._contents += t2;
                }
                t1 = _this.buffer;
                if (t1 != null) t1.addInterpolation$1(node.$arguments);
                t1 = _this.buffer;
                if (t1 != null) {
                    t2 = A.SpanExtensions_after(node.span, node.$arguments.span);
                    t2 = A.String_String$fromCharCodes(B.NativeUint32List_methods.sublist$2(t2.file._decodedChars, t2._file$_start, t2._end), 0, null);
                    t1 = t1._interpolation_buffer0$_text;
                    t1._contents += t2;
                }
            },
            visitIfConditionSass$1: function(_, node) {
                this.buffer = null;
            },
            visitIfConditionRaw$1: function(_, node) {
                var t1 = this.buffer;
                if (t1 != null) t1.addInterpolation$1(node.text);
            },
            visitLegacyIfExpression$1: function(_, node) {
                return this.buffer = null;
            },
            visitListExpression$1: function(_, node) {
                var t3, t4, _this = this, t1 = node.contents, t2 = t1.length;
                if (t2 <= 1 && !node.hasBrackets) {
                    _this.buffer = null;
                    return;
                }
                t3 = node.hasBrackets;
                if (t3 && t2 === 0) {
                    t1 = _this.buffer;
                    if (t1 != null) {
                        t2 = node.span.get$text();
                        t1 = t1._interpolation_buffer0$_text;
                        t1._contents += t2;
                    }
                    return;
                }
                if (t3) {
                    t2 = _this.buffer;
                    if (t2 != null) {
                        t4 = B.JSArray_methods.get$first(t1);
                        t4 = A.SpanExtensions_before(node.span, t4.get$span(t4));
                        t4 = A.String_String$fromCharCodes(B.NativeUint32List_methods.sublist$2(t4.file._decodedChars, t4._file$_start, t4._end), 0, null);
                        t2 = t2._interpolation_buffer0$_text;
                        t2._contents += t4;
                    }
                }
                _this._writeListAndBetween$2(t1, new A.SourceInterpolationVisitor_visitListExpression_closure(_this));
                if (t3) {
                    t2 = _this.buffer;
                    if (t2 != null) {
                        t1 = B.JSArray_methods.get$last(t1);
                        t1 = A.SpanExtensions_after(node.span, t1.get$span(t1));
                        t1 = A.String_String$fromCharCodes(B.NativeUint32List_methods.sublist$2(t1.file._decodedChars, t1._file$_start, t1._end), 0, null);
                        t2 = t2._interpolation_buffer0$_text;
                        t2._contents += t1;
                    }
                }
            },
            visitMapExpression$1: function(_, node) {
                return this.buffer = null;
            },
            visitNullExpression$1: function(_, node) {
                return this.buffer = null;
            },
            visitNumberExpression$1: function(_, node) {
                var t2, t1 = this.buffer;
                if (t1 != null) {
                    t2 = node.span.get$text();
                    t1 = t1._interpolation_buffer0$_text;
                    t1._contents += t2;
                }
                return null;
            },
            visitParenthesizedExpression$1: function(_, node) {
                return this.buffer = null;
            },
            visitSelectorExpression$1: function(_, node) {
                return this.buffer = null;
            },
            visitStringExpression$1: function(_, node) {
                var t2, t3, t4, t5, i, span, _0_0, t6, expression, t7, t8, t9, _this = this, t1 = node.text;
                if (t1.get$asPlain() != null) {
                    t2 = _this.buffer;
                    if (t2 != null) {
                        t1 = t1.span.get$text();
                        t2 = t2._interpolation_buffer0$_text;
                        t2._contents += t1;
                    }
                    return;
                }
                for(t2 = t1.contents, t3 = t2.length, t4 = t3 - 1, t5 = t1.span, i = 0; i < t3; ++i){
                    span = t1.spanForElement$1(i);
                    _0_0 = t2[i];
                    t6 = _0_0 instanceof A.Expression0;
                    expression = t6 ? _0_0 : null;
                    if (t6) {
                        if (i === 0) {
                            t6 = _this.buffer;
                            if (t6 != null) {
                                t7 = A.SpanExtensions_before(t5, span);
                                t8 = t7._file$_start;
                                t9 = t7.file._decodedChars;
                                t9 = A.String_String$fromCharCodes(new Uint32Array(t9.subarray(t8, A._checkValidRange(t8, t7._end, t9.length))), 0, null);
                                t6 = t6._interpolation_buffer0$_text;
                                t6._contents += t9;
                            }
                        }
                        t6 = _this.buffer;
                        if (t6 != null) {
                            t6._interpolation_buffer0$_flushText$0();
                            t6._interpolation_buffer0$_contents.push(expression);
                            t6._interpolation_buffer0$_spans.push(span);
                        }
                        if (i === t4) {
                            t6 = _this.buffer;
                            if (t6 != null) {
                                t7 = A.SpanExtensions_after(t5, span);
                                t8 = t7._file$_start;
                                t9 = t7.file._decodedChars;
                                t9 = A.String_String$fromCharCodes(new Uint32Array(t9.subarray(t8, A._checkValidRange(t8, t7._end, t9.length))), 0, null);
                                t6 = t6._interpolation_buffer0$_text;
                                t6._contents += t9;
                            }
                        }
                        continue;
                    }
                    t6 = _this.buffer;
                    if (t6 != null) {
                        t6 = t6._interpolation_buffer0$_text;
                        t7 = span.toString$0(0);
                        t6._contents += t7;
                    }
                }
            },
            visitSupportsExpression$1: function(_, node) {
                return this.buffer = null;
            },
            visitUnaryOperationExpression$1: function(_, node) {
                return this.buffer = null;
            },
            visitValueExpression$1: function(_, node) {
                return this.buffer = null;
            },
            visitVariableExpression$1: function(_, node) {
                return this.buffer = null;
            },
            _writeListAndBetween$1$2: function(nodes, visit) {
                var t1, lastSpan, _i, node, t2, t3, t4, t5;
                for(t1 = nodes.length, lastSpan = null, _i = 0; _i < t1; ++_i){
                    node = nodes[_i];
                    if (lastSpan != null) {
                        t2 = this.buffer;
                        if (t2 != null) {
                            t3 = A.SpanExtensions_between(lastSpan, node.get$span(node));
                            t4 = t3._file$_start;
                            t5 = t3.file._decodedChars;
                            t5 = A.String_String$fromCharCodes(new Uint32Array(t5.subarray(t4, A._checkValidRange(t4, t3._end, t5.length))), 0, null);
                            t2 = t2._interpolation_buffer0$_text;
                            t2._contents += t5;
                        }
                    }
                    visit.call$1(node);
                    if (this.buffer == null) return;
                    lastSpan = node.get$span(node);
                }
            },
            _writeListAndBetween$2: function(nodes, visit) {
                return this._writeListAndBetween$1$2(nodes, visit, type$.AstNode_2);
            },
            $isExpressionVisitor: 1,
            $isIfConditionExpressionVisitor: 1
        };
        A.SourceInterpolationVisitor__visitArguments_closure.prototype = {
            call$1: function(node) {
                return node.accept$1(this.$this);
            },
            $signature: 136
        };
        A.SourceInterpolationVisitor_visitIfConditionOperation_closure.prototype = {
            call$1: function(node) {
                return node.accept$1(this.$this);
            },
            $signature: 600
        };
        A.SourceInterpolationVisitor_visitListExpression_closure.prototype = {
            call$1: function(node) {
                return node.accept$1(this.$this);
            },
            $signature: 136
        };
        A.SourceMapBuffer0.prototype = {
            get$_source_map_buffer0$_targetLocation: function() {
                var t1 = this._source_map_buffer0$_buffer._contents, t2 = this._source_map_buffer0$_line;
                return A.SourceLocation$(t1.length, this._source_map_buffer0$_column, t2, null);
            },
            get$length: function(_) {
                return this._source_map_buffer0$_buffer._contents.length;
            },
            forSpan$1$2: function(span, callback) {
                var t1, _this = this, wasInSpan = _this._source_map_buffer0$_inSpan;
                _this._source_map_buffer0$_inSpan = true;
                _this._source_map_buffer0$_addEntry$2(span.get$start(span), _this.get$_source_map_buffer0$_targetLocation());
                try {
                    t1 = callback.call$0();
                    return t1;
                } finally{
                    _this._source_map_buffer0$_inSpan = wasInSpan;
                }
            },
            forSpan$2: function(span, callback) {
                return this.forSpan$1$2(span, callback, type$.dynamic);
            },
            _source_map_buffer0$_addEntry$2: function(source, target) {
                var entry, t2, t1 = this._source_map_buffer0$_entries;
                if (t1.length !== 0) {
                    entry = B.JSArray_methods.get$last(t1);
                    t2 = entry.source;
                    if (t2.file.getLine$1(t2.offset) === source.file.getLine$1(source.offset) && entry.target.line === target.line) return;
                    if (entry.target.offset === target.offset) return;
                }
                t1.push(new A.Entry(source, target, null));
            },
            write$1: function(_, object) {
                var t1, i, string = J.toString$0$(object);
                this._source_map_buffer0$_buffer._contents += string;
                for(t1 = string.length, i = 0; i < t1; ++i)if (string.charCodeAt(i) === 10) this._source_map_buffer0$_writeLine$0();
                else ++this._source_map_buffer0$_column;
            },
            writeCharCode$1: function(charCode) {
                var t1 = this._source_map_buffer0$_buffer, t2 = A.Primitives_stringFromCharCode(charCode);
                t1._contents += t2;
                if (charCode === 10) this._source_map_buffer0$_writeLine$0();
                else ++this._source_map_buffer0$_column;
            },
            _source_map_buffer0$_writeLine$0: function() {
                var _this = this, t1 = _this._source_map_buffer0$_entries;
                if (B.JSArray_methods.get$last(t1).target.line === _this._source_map_buffer0$_line && B.JSArray_methods.get$last(t1).target.column === _this._source_map_buffer0$_column) t1.pop();
                ++_this._source_map_buffer0$_line;
                _this._source_map_buffer0$_column = 0;
                if (_this._source_map_buffer0$_inSpan) t1.push(new A.Entry(B.JSArray_methods.get$last(t1).source, _this.get$_source_map_buffer0$_targetLocation(), null));
            },
            toString$0: function(_) {
                var t1 = this._source_map_buffer0$_buffer._contents;
                return t1.charCodeAt(0) == 0 ? t1 : t1;
            },
            buildSourceMap$1$prefix: function(prefix) {
                var i, t2, prefixColumn, _box_0 = {}, t1 = prefix.length;
                if (t1 === 0) return A.SingleMapping_SingleMapping$fromEntries(this._source_map_buffer0$_entries);
                _box_0.prefixColumn = _box_0.prefixLines = 0;
                for(i = 0, t2 = 0; i < t1; ++i)if (prefix.charCodeAt(i) === 10) {
                    ++_box_0.prefixLines;
                    _box_0.prefixColumn = 0;
                    t2 = 0;
                } else {
                    prefixColumn = t2 + 1;
                    _box_0.prefixColumn = prefixColumn;
                    t2 = prefixColumn;
                }
                t2 = this._source_map_buffer0$_entries;
                return A.SingleMapping_SingleMapping$fromEntries(new A.MappedListIterable(t2, new A.SourceMapBuffer_buildSourceMap_closure0(_box_0, t1), A._arrayInstanceType(t2)._eval$1("MappedListIterable<1,Entry>")));
            }
        };
        A.SourceMapBuffer_buildSourceMap_closure0.prototype = {
            call$1: function(entry) {
                var t1 = entry.target, t2 = t1.line, t3 = this._box_0, t4 = t3.prefixLines;
                t3 = t2 === 0 ? t3.prefixColumn : 0;
                return new A.Entry(entry.source, A.SourceLocation$(t1.offset + this.prefixLength, t1.column + t3, t2 + t4, null), entry.identifierName);
            },
            $signature: 164
        };
        A.updateSourceSpanPrototype_closure.prototype = {
            call$0: function() {
                return this.span;
            },
            $signature: 16
        };
        A.updateSourceSpanPrototype_closure0.prototype = {
            call$1: function(span) {
                return span.get$start(span);
            },
            $signature: 264
        };
        A.updateSourceSpanPrototype_closure1.prototype = {
            call$1: function(span) {
                return span.get$end(span);
            },
            $signature: 264
        };
        A.updateSourceSpanPrototype_closure2.prototype = {
            call$1: function(span) {
                return A.NullableExtension_andThen0(span.get$sourceUrl(span), new A.updateSourceSpanPrototype__closure());
            },
            $signature: 602
        };
        A.updateSourceSpanPrototype__closure.prototype = {
            call$1: function(url) {
                var t1, _null = null;
                if (url.get$scheme() === "") {
                    t1 = $.$get$context();
                    t1 = t1.toUri$1(A.absolute(t1.style.pathFromUri$1(A._parseUri(url)), _null, _null, _null, _null, _null, _null, _null, _null, _null, _null, _null, _null, _null, _null));
                } else t1 = url;
                return new self.URL(t1.toString$0(0));
            },
            $signature: 176
        };
        A.updateSourceSpanPrototype_closure3.prototype = {
            call$1: function(span) {
                return span.get$text();
            },
            $signature: 265
        };
        A.updateSourceSpanPrototype_closure4.prototype = {
            call$1: function(span) {
                return span.get$context(span);
            },
            $signature: 265
        };
        A.updateSourceSpanPrototype_closure5.prototype = {
            call$1: function($location) {
                return $location.get$line();
            },
            $signature: 266
        };
        A.updateSourceSpanPrototype_closure6.prototype = {
            call$1: function($location) {
                return $location.get$column();
            },
            $signature: 266
        };
        A.ColorSpace0.prototype = {
            get$isLegacyInternal: function() {
                return false;
            },
            get$isPolarInternal: function() {
                return false;
            },
            convert$5: function(dest, channel0, channel1, channel2, alpha) {
                return this.convertLinear$5(dest, channel0, channel1, channel2, alpha);
            },
            convertLinear$10$missingA$missingB$missingChroma$missingHue$missingLightness: function(dest, red, green, blue, alpha, missingA, missingB, missingChroma, missingHue, missingLightness) {
                var t1, t2, transformedBlue, transformedGreen, transformedRed, linearRed, linearGreen, linearBlue, matrix, _this = this;
                $label0$0: {
                    t1 = B.HslColorSpace_JQ20 !== dest;
                    if (!t1 || B.HwbColorSpace_guQ0 === dest) {
                        t2 = B.SrgbColorSpace_thf0;
                        break $label0$0;
                    }
                    if (B.LabColorSpace_2nT0 === dest || B.LchColorSpace_Bpv0 === dest) {
                        t2 = B.XyzD50ColorSpace_2OB0;
                        break $label0$0;
                    }
                    if (B.OklabColorSpace_5400 === dest || B.OklchColorSpace_9Gj0 === dest) {
                        t2 = B.LmsColorSpace_Os30;
                        break $label0$0;
                    }
                    t2 = dest;
                    break $label0$0;
                }
                if (t2 === _this) {
                    transformedBlue = blue;
                    transformedGreen = green;
                    transformedRed = red;
                } else {
                    linearRed = _this.toLinear$1(red == null ? 0 : red);
                    linearGreen = _this.toLinear$1(green == null ? 0 : green);
                    linearBlue = _this.toLinear$1(blue == null ? 0 : blue);
                    matrix = _this.transformationMatrix$1(t2);
                    transformedRed = t2.fromLinear$1(matrix[0] * linearRed + matrix[1] * linearGreen + matrix[2] * linearBlue);
                    transformedGreen = t2.fromLinear$1(matrix[3] * linearRed + matrix[4] * linearGreen + matrix[5] * linearBlue);
                    transformedBlue = t2.fromLinear$1(matrix[6] * linearRed + matrix[7] * linearGreen + matrix[8] * linearBlue);
                }
                $label1$1: {
                    if (!t1 || B.HwbColorSpace_guQ0 === dest) {
                        t1 = B.SrgbColorSpace_thf0.convert$8$missingChroma$missingHue$missingLightness(dest, transformedRed, transformedGreen, transformedBlue, alpha, missingChroma, missingHue, missingLightness);
                        break $label1$1;
                    }
                    if (B.LabColorSpace_2nT0 === dest || B.LchColorSpace_Bpv0 === dest) {
                        t1 = B.XyzD50ColorSpace_2OB0.convert$10$missingA$missingB$missingChroma$missingHue$missingLightness(dest, transformedRed, transformedGreen, transformedBlue, alpha, missingA, missingB, missingChroma, missingHue, missingLightness);
                        break $label1$1;
                    }
                    if (B.OklabColorSpace_5400 === dest || B.OklchColorSpace_9Gj0 === dest) {
                        t1 = B.LmsColorSpace_Os30.convert$10$missingA$missingB$missingChroma$missingHue$missingLightness(dest, transformedRed, transformedGreen, transformedBlue, alpha, missingA, missingB, missingChroma, missingHue, missingLightness);
                        break $label1$1;
                    }
                    t1 = red == null ? null : transformedRed;
                    t2 = green == null ? null : transformedGreen;
                    t1 = A.SassColor_SassColor$forSpaceInternal0(dest, t1, t2, blue == null ? null : transformedBlue, alpha);
                    break $label1$1;
                }
                return t1;
            },
            convertLinear$5: function(dest, red, green, blue, alpha) {
                return this.convertLinear$10$missingA$missingB$missingChroma$missingHue$missingLightness(dest, red, green, blue, alpha, false, false, false, false, false);
            },
            toLinear$1: function(channel) {
                return A.throwExpression(A.UnimplementedError$("[BUG] Color space " + this.toString$0(0) + " doesn't support linear conversions."));
            },
            fromLinear$1: function(channel) {
                return A.throwExpression(A.UnimplementedError$("[BUG] Color space " + this.toString$0(0) + " doesn't support linear conversions."));
            },
            transformationMatrix$1: function(dest) {
                return A.throwExpression(A.UnimplementedError$("[BUG] Color space conversion from " + this.toString$0(0) + " to " + dest.toString$0(0) + " not implemented."));
            },
            toString$0: function(_) {
                return this.name;
            }
        };
        A.SrgbColorSpace0.prototype = {
            get$isBoundedInternal: function() {
                return true;
            },
            convert$8$missingChroma$missingHue$missingLightness: function(dest, red, green, blue, alpha, missingChroma, missingHue, missingLightness) {
                var max, min, delta, hue, lightness, saturation, t1, t2, whiteness, blackness, _null = null;
                if (B.HslColorSpace_JQ20 === dest || B.HwbColorSpace_guQ0 === dest) {
                    if (red == null) red = 0;
                    if (green == null) green = 0;
                    if (blue == null) blue = 0;
                    max = Math.max(Math.max(red, green), blue);
                    min = Math.min(Math.min(red, green), blue);
                    delta = max - min;
                    if (max === min) hue = 0;
                    else if (max === red) hue = 60 * (green - blue) / delta + 360;
                    else hue = max === green ? 60 * (blue - red) / delta + 120 : 60 * (red - green) / delta + 240;
                    if (dest === B.HslColorSpace_JQ20) {
                        lightness = (min + max) / 2;
                        saturation = lightness === 0 || lightness === 1 ? 0 : 100 * (max - lightness) / Math.min(lightness, 1 - lightness);
                        if (saturation < 0) {
                            hue += 180;
                            saturation = Math.abs(saturation);
                        }
                        t1 = missingHue || A.fuzzyEquals0(saturation, 0) ? _null : B.JSNumber_methods.$mod(hue, 360);
                        t2 = missingChroma ? _null : saturation;
                        return A.SassColor_SassColor$forSpaceInternal0(dest, t1, t2, missingLightness ? _null : lightness * 100, alpha);
                    } else {
                        whiteness = min * 100;
                        blackness = 100 - max * 100;
                        if (!missingHue) {
                            t1 = whiteness + blackness;
                            t1 = t1 > 100 || A.fuzzyEquals0(t1, 100);
                        } else t1 = true;
                        return A.SassColor_SassColor$forSpaceInternal0(dest, t1 ? _null : B.JSNumber_methods.$mod(hue, 360), whiteness, blackness, alpha);
                    }
                }
                if (B.RgbColorSpace_i0P0 === dest) {
                    t1 = red == null ? _null : red * 255;
                    t2 = green == null ? _null : green * 255;
                    return A.SassColor_SassColor$rgbInternal0(t1, t2, blue == null ? _null : blue * 255, alpha, _null);
                }
                if (B.SrgbLinearColorSpace_kUj0 === dest) {
                    t1 = this.get$toLinear();
                    return A.SassColor_SassColor$forSpaceInternal0(dest, A.NullableExtension_andThen0(red, t1), A.NullableExtension_andThen0(green, t1), A.NullableExtension_andThen0(blue, t1), alpha);
                }
                return this.super$ColorSpace$convertLinear0(dest, red, green, blue, alpha, false, false, missingChroma, missingHue, missingLightness);
            },
            convert$5: function(dest, red, green, blue, alpha) {
                return this.convert$8$missingChroma$missingHue$missingLightness(dest, red, green, blue, alpha, false, false, false);
            },
            convert$6$missingHue: function(dest, red, green, blue, alpha, missingHue) {
                return this.convert$8$missingChroma$missingHue$missingLightness(dest, red, green, blue, alpha, false, missingHue, false);
            },
            toLinear$1: function(channel) {
                return A.srgbAndDisplayP3ToLinear0(channel);
            },
            fromLinear$1: function(channel) {
                return A.srgbAndDisplayP3FromLinear0(channel);
            },
            transformationMatrix$1: function(dest) {
                var t1;
                $label0$0: {
                    if (B.DisplayP3ColorSpace_MmT0 === dest || B.DisplayP3LinearColorSpace_PrP0 === dest) {
                        t1 = $.$get$linearSrgbToLinearDisplayP30();
                        break $label0$0;
                    }
                    if (B.A98RgbColorSpace_lf20 === dest) {
                        t1 = $.$get$linearSrgbToLinearA98Rgb0();
                        break $label0$0;
                    }
                    if (B.ProphotoRgbColorSpace_BDz0 === dest) {
                        t1 = $.$get$linearSrgbToLinearProphotoRgb0();
                        break $label0$0;
                    }
                    if (B.Rec2020ColorSpace_6oo0 === dest) {
                        t1 = $.$get$linearSrgbToLinearRec20200();
                        break $label0$0;
                    }
                    if (B.XyzD65ColorSpace_WiJ0 === dest) {
                        t1 = $.$get$linearSrgbToXyzD650();
                        break $label0$0;
                    }
                    if (B.XyzD50ColorSpace_2OB0 === dest) {
                        t1 = $.$get$linearSrgbToXyzD500();
                        break $label0$0;
                    }
                    if (B.LmsColorSpace_Os30 === dest) {
                        t1 = $.$get$linearSrgbToLms0();
                        break $label0$0;
                    }
                    t1 = this.super$ColorSpace$transformationMatrix0(dest);
                    break $label0$0;
                }
                return t1;
            }
        };
        A.SrgbLinearColorSpace0.prototype = {
            get$isBoundedInternal: function() {
                return true;
            },
            convert$5: function(dest, red, green, blue, alpha) {
                var t1;
                $label0$0: {
                    if (B.RgbColorSpace_i0P0 === dest || B.HslColorSpace_JQ20 === dest || B.HwbColorSpace_guQ0 === dest || B.SrgbColorSpace_thf0 === dest) {
                        t1 = B.SrgbColorSpace_thf0.convert$5(dest, A.NullableExtension_andThen0(red, A.utils2__srgbAndDisplayP3FromLinear$closure()), A.NullableExtension_andThen0(green, A.utils2__srgbAndDisplayP3FromLinear$closure()), A.NullableExtension_andThen0(blue, A.utils2__srgbAndDisplayP3FromLinear$closure()), alpha);
                        break $label0$0;
                    }
                    t1 = this.super$ColorSpace$convert0(dest, red, green, blue, alpha);
                    break $label0$0;
                }
                return t1;
            },
            toLinear$1: function(channel) {
                return channel;
            },
            fromLinear$1: function(channel) {
                return channel;
            },
            transformationMatrix$1: function(dest) {
                var t1;
                $label0$0: {
                    if (B.DisplayP3ColorSpace_MmT0 === dest || B.DisplayP3LinearColorSpace_PrP0 === dest) {
                        t1 = $.$get$linearSrgbToLinearDisplayP30();
                        break $label0$0;
                    }
                    if (B.A98RgbColorSpace_lf20 === dest) {
                        t1 = $.$get$linearSrgbToLinearA98Rgb0();
                        break $label0$0;
                    }
                    if (B.ProphotoRgbColorSpace_BDz0 === dest) {
                        t1 = $.$get$linearSrgbToLinearProphotoRgb0();
                        break $label0$0;
                    }
                    if (B.Rec2020ColorSpace_6oo0 === dest) {
                        t1 = $.$get$linearSrgbToLinearRec20200();
                        break $label0$0;
                    }
                    if (B.XyzD65ColorSpace_WiJ0 === dest) {
                        t1 = $.$get$linearSrgbToXyzD650();
                        break $label0$0;
                    }
                    if (B.XyzD50ColorSpace_2OB0 === dest) {
                        t1 = $.$get$linearSrgbToXyzD500();
                        break $label0$0;
                    }
                    if (B.LmsColorSpace_Os30 === dest) {
                        t1 = $.$get$linearSrgbToLms0();
                        break $label0$0;
                    }
                    t1 = this.super$ColorSpace$transformationMatrix0(dest);
                    break $label0$0;
                }
                return t1;
            }
        };
        A.Statement0.prototype = {
            $isAstNode0: 1,
            $isSassNode: 1
        };
        A.JSStatementVisitor.prototype = {
            visitAtRootRule$1: function(_, node) {
                return J.visitAtRootRule$1$x(this._statement$_inner, node);
            },
            visitAtRule$1: function(_, node) {
                return J.visitAtRule$1$x(this._statement$_inner, node);
            },
            visitContentBlock$1: function(_, node) {
                return J.visitContentBlock$1$x(this._statement$_inner, node);
            },
            visitContentRule$1: function(_, node) {
                return J.visitContentRule$1$x(this._statement$_inner, node);
            },
            visitDebugRule$1: function(_, node) {
                return J.visitDebugRule$1$x(this._statement$_inner, node);
            },
            visitDeclaration$1: function(_, node) {
                return J.visitDeclaration$1$x(this._statement$_inner, node);
            },
            visitEachRule$1: function(_, node) {
                return J.visitEachRule$1$x(this._statement$_inner, node);
            },
            visitErrorRule$1: function(_, node) {
                return J.visitErrorRule$1$x(this._statement$_inner, node);
            },
            visitExtendRule$1: function(_, node) {
                return J.visitExtendRule$1$x(this._statement$_inner, node);
            },
            visitForRule$1: function(_, node) {
                return J.visitForRule$1$x(this._statement$_inner, node);
            },
            visitForwardRule$1: function(_, node) {
                return J.visitForwardRule$1$x(this._statement$_inner, node);
            },
            visitFunctionRule$1: function(_, node) {
                return J.visitFunctionRule$1$x(this._statement$_inner, node);
            },
            visitIfRule$1: function(_, node) {
                return J.visitIfRule$1$x(this._statement$_inner, node);
            },
            visitImportRule$1: function(_, node) {
                return J.visitImportRule$1$x(this._statement$_inner, node);
            },
            visitIncludeRule$1: function(_, node) {
                return J.visitIncludeRule$1$x(this._statement$_inner, node);
            },
            visitLoudComment$1: function(_, node) {
                return J.visitLoudComment$1$x(this._statement$_inner, node);
            },
            visitMediaRule$1: function(_, node) {
                return J.visitMediaRule$1$x(this._statement$_inner, node);
            },
            visitMixinRule$1: function(_, node) {
                return J.visitMixinRule$1$x(this._statement$_inner, node);
            },
            visitReturnRule$1: function(_, node) {
                return J.visitReturnRule$1$x(this._statement$_inner, node);
            },
            visitSilentComment$1: function(_, node) {
                return J.visitSilentComment$1$x(this._statement$_inner, node);
            },
            visitStyleRule$1: function(_, node) {
                return J.visitStyleRule$1$x(this._statement$_inner, node);
            },
            visitStylesheet$1: function(_, node) {
                return J.visitStylesheet$1$x(this._statement$_inner, node);
            },
            visitSupportsRule$1: function(_, node) {
                return J.visitSupportsRule$1$x(this._statement$_inner, node);
            },
            visitUseRule$1: function(_, node) {
                return J.visitUseRule$1$x(this._statement$_inner, node);
            },
            visitVariableDeclaration$1: function(_, node) {
                return J.visitVariableDeclaration$1$x(this._statement$_inner, node);
            },
            visitWarnRule$1: function(_, node) {
                return J.visitWarnRule$1$x(this._statement$_inner, node);
            },
            visitWhileRule$1: function(_, node) {
                return J.visitWhileRule$1$x(this._statement$_inner, node);
            },
            $isStatementVisitor: 1
        };
        A.JSStatementVisitorObject.prototype = {};
        A.StatementSearchVisitor0.prototype = {
            visitAtRootRule$1: function(_, node) {
                return this.visitChildren$1(node.children);
            },
            visitAtRule$1: function(_, node) {
                return A.NullableExtension_andThen0(node.children, this.get$visitChildren());
            },
            visitContentBlock$1: function(_, node) {
                return this.visitChildren$1(node.children);
            },
            visitContentRule$1: function(_, node) {
                return null;
            },
            visitDebugRule$1: function(_, node) {
                return null;
            },
            visitDeclaration$1: function(_, node) {
                return A.NullableExtension_andThen0(node.children, this.get$visitChildren());
            },
            visitEachRule$1: function(_, node) {
                return this.visitChildren$1(node.children);
            },
            visitErrorRule$1: function(_, node) {
                return null;
            },
            visitExtendRule$1: function(_, node) {
                return null;
            },
            visitForRule$1: function(_, node) {
                return this.visitChildren$1(node.children);
            },
            visitForwardRule$1: function(_, node) {
                return null;
            },
            visitFunctionRule$1: function(_, node) {
                return this.visitChildren$1(node.children);
            },
            visitIfRule$1: function(_, node) {
                var t1 = A.IterableExtension_search0(node.clauses, new A.StatementSearchVisitor_visitIfRule_closure1(this));
                return t1 == null ? A.NullableExtension_andThen0(node.lastClause, new A.StatementSearchVisitor_visitIfRule_closure2(this)) : t1;
            },
            visitImportRule$1: function(_, node) {
                return null;
            },
            visitIncludeRule$1: function(_, node) {
                return A.NullableExtension_andThen0(node.content, this.get$visitContentBlock(this));
            },
            visitLoudComment$1: function(_, node) {
                return null;
            },
            visitMediaRule$1: function(_, node) {
                return this.visitChildren$1(node.children);
            },
            visitMixinRule$1: function(_, node) {
                return this.visitChildren$1(node.children);
            },
            visitReturnRule$1: function(_, node) {
                return null;
            },
            visitSilentComment$1: function(_, node) {
                return null;
            },
            visitStyleRule$1: function(_, node) {
                return this.visitChildren$1(node.children);
            },
            visitStylesheet$1: function(_, node) {
                return this.visitChildren$1(node.children);
            },
            visitSupportsRule$1: function(_, node) {
                return this.visitChildren$1(node.children);
            },
            visitUseRule$1: function(_, node) {
                return null;
            },
            visitVariableDeclaration$1: function(_, node) {
                return null;
            },
            visitWarnRule$1: function(_, node) {
                return null;
            },
            visitWhileRule$1: function(_, node) {
                return this.visitChildren$1(node.children);
            },
            visitChildren$1: function(children) {
                return A.IterableExtension_search0(children, new A.StatementSearchVisitor_visitChildren_closure0(this));
            }
        };
        A.StatementSearchVisitor_visitIfRule_closure1.prototype = {
            call$1: function(clause) {
                return A.IterableExtension_search0(clause.children, new A.StatementSearchVisitor_visitIfRule__closure2(this.$this));
            },
            $signature: function() {
                return A._instanceType(this.$this)._eval$1("StatementSearchVisitor0.T?(IfClause0)");
            }
        };
        A.StatementSearchVisitor_visitIfRule__closure2.prototype = {
            call$1: function(child) {
                return child.accept$1(this.$this);
            },
            $signature: function() {
                return A._instanceType(this.$this)._eval$1("StatementSearchVisitor0.T?(Statement0)");
            }
        };
        A.StatementSearchVisitor_visitIfRule_closure2.prototype = {
            call$1: function(lastClause) {
                return A.IterableExtension_search0(lastClause.children, new A.StatementSearchVisitor_visitIfRule__closure1(this.$this));
            },
            $signature: function() {
                return A._instanceType(this.$this)._eval$1("StatementSearchVisitor0.T?(ElseClause0)");
            }
        };
        A.StatementSearchVisitor_visitIfRule__closure1.prototype = {
            call$1: function(child) {
                return child.accept$1(this.$this);
            },
            $signature: function() {
                return A._instanceType(this.$this)._eval$1("StatementSearchVisitor0.T?(Statement0)");
            }
        };
        A.StatementSearchVisitor_visitChildren_closure0.prototype = {
            call$1: function(child) {
                return child.accept$1(this.$this);
            },
            $signature: function() {
                return A._instanceType(this.$this)._eval$1("StatementSearchVisitor0.T?(Statement0)");
            }
        };
        A.StaticImport0.prototype = {
            toString$0: function(_) {
                var t1 = this.url.toString$0(0), t2 = this.modifiers;
                return t1 + (t2 == null ? "" : " " + t2.toString$0(0));
            },
            $isImport0: 1,
            $isAstNode0: 1,
            $isSassNode: 1,
            get$span: function(receiver) {
                return this.span;
            }
        };
        A.StderrLogger0.prototype = {
            internalWarn$4$deprecation$span$trace: function(message, deprecation, span, trace) {
                var t3, result = new A.StringBuffer(""), t1 = deprecation != null, showDeprecation = t1 && deprecation !== B.Deprecation_dlf, t2 = this.color;
                if (t2) {
                    t3 = result._contents = "\x1b[33m\x1b[1m";
                    t3 = result._contents = (t1 ? result._contents = "\x1b[33m\x1b[1mDeprecation " : t3) + "Warning\x1b[0m";
                    if (showDeprecation) {
                        t1 = t3 + (" [\x1b[34m" + deprecation.toString$0(0) + "\x1b[0m]");
                        result._contents = t1;
                    } else t1 = t3;
                } else {
                    t3 = result._contents = (t1 ? result._contents = "DEPRECATION " : "") + "WARNING";
                    if (showDeprecation) {
                        t1 = t3 + (" [" + deprecation.toString$0(0) + "]");
                        result._contents = t1;
                    } else t1 = t3;
                }
                if (span == null) t1 = result._contents = t1 + (": " + message + "\n");
                else if (trace != null) {
                    t1 += ": " + message + "\n\n" + span.highlight$1$color(t2) + "\n";
                    result._contents = t1;
                } else {
                    t1 += " on " + span.message$2$color(0, "\n" + message, t2) + "\n";
                    result._contents = t1;
                }
                if (trace != null) result._contents = t1 + (A.indent0(B.JSString_methods.trimRight$0(trace.toString$0(0)), 4) + "\n");
                A.printError0(result);
            },
            debug$2: function(_, message, span) {
                var url, t1, t2;
                if (span.get$start(span).file.url == null) url = "-";
                else {
                    t1 = span.get$start(span).file.url;
                    t2 = $.$get$context();
                    t1.toString;
                    url = t2.prettyUri$1(t1);
                }
                t1 = span.get$start(span);
                t1 = t1.file.getLine$1(t1.offset);
                t2 = this.color ? "\x1b[1mDebug\x1b[0m" : "DEBUG";
                t2 = url + ":" + (t1 + 1) + " " + t2 + (": " + message);
                A.printError0(t2.charCodeAt(0) == 0 ? t2 : t2);
            }
        };
        A.StringExpression0.prototype = {
            get$span: function(_) {
                return this.text.span;
            },
            accept$1$1: function(visitor) {
                return visitor.visitStringExpression$1(0, this);
            },
            accept$1: function(visitor) {
                return this.accept$1$1(visitor, type$.dynamic);
            },
            asInterpolation$1$static: function($static) {
                var t1, t2, quote, t3, t4, t5, buffer, t6, t7, i, value, t8;
                if (!this.hasQuotes) return this.text;
                t1 = this.text;
                t2 = t1.contents;
                quote = A.StringExpression__bestQuote0(new A.WhereTypeIterable(t2, type$.WhereTypeIterable_String));
                t3 = new A.StringBuffer("");
                t4 = A._setArrayType([], type$.JSArray_Object);
                t5 = A._setArrayType([], type$.JSArray_nullable_FileSpan);
                buffer = new A.InterpolationBuffer0(t3, t4, t5);
                t6 = A.Primitives_stringFromCharCode(quote);
                t3._contents += t6;
                for(t7 = t2.length, i = 0; i < t7; ++i){
                    value = t2[i];
                    if (value instanceof A.Expression0) {
                        t8 = t1.spanForElement$1(i);
                        buffer._interpolation_buffer0$_flushText$0();
                        t4.push(value);
                        t5.push(t8);
                        continue;
                    }
                    if (typeof value == "string") A.StringExpression__quoteInnerText0(value, quote, buffer, $static);
                }
                t3._contents += t6;
                return buffer.interpolation$1(t1.span);
            },
            asInterpolation$0: function() {
                return this.asInterpolation$1$static(false);
            },
            toString$0: function(_) {
                return this.asInterpolation$0().toString$0(0);
            }
        };
        A.module_closure25.prototype = {
            call$1: function($arguments) {
                var limit, t2, chunks, i, lastEnd, match, t3, t1 = J.getInterceptor$asx($arguments), string = t1.$index($arguments, 0).assertString$1("string"), separator = t1.$index($arguments, 1).assertString$1("separator");
                t1 = t1.$index($arguments, 2).get$realNull();
                limit = t1 == null ? null : t1.assertNumber$1("limit").assertInt$1("limit");
                if (limit != null && limit < 1) throw A.wrapException(A.SassScriptException$0("$limit: Must be 1 or greater, was " + A.S(limit) + ".", null));
                t1 = string._string0$_text;
                if (t1.length === 0) return B.SassList_oWx0;
                else {
                    t2 = separator._string0$_text;
                    if (t2.length === 0) return A.SassList$0(A.MappedIterable_MappedIterable(new A.Runes(t1), new A.module__closure3(string), type$.Runes._eval$1("Iterable.E"), type$.Value_2), B.ListSeparator_z0K0, true);
                }
                chunks = A._setArrayType([], type$.JSArray_String);
                for(t2 = B.JSString_methods.allMatches$1(t2, t1), t2 = new A._StringAllMatchesIterator(t2._input, t2._pattern, t2.__js_helper$_index), i = 0, lastEnd = 0; t2.moveNext$0();){
                    match = t2.__js_helper$_current;
                    t3 = match.start;
                    chunks.push(B.JSString_methods.substring$2(t1, lastEnd, t3));
                    lastEnd = t3 + match.pattern.length;
                    ++i;
                    if (i === limit) break;
                }
                chunks.push(B.JSString_methods.substring$1(t1, lastEnd));
                return A.SassList$0(new A.MappedListIterable(chunks, new A.module__closure4(string), type$.MappedListIterable_String_Value_2), B.ListSeparator_z0K0, true);
            },
            $signature: 27
        };
        A.module__closure3.prototype = {
            call$1: function(rune) {
                return new A.SassString0(A.Primitives_stringFromCharCode(rune), this.string._string0$_hasQuotes);
            },
            $signature: 606
        };
        A.module__closure4.prototype = {
            call$1: function(chunk) {
                return new A.SassString0(chunk, this.string._string0$_hasQuotes);
            },
            $signature: 607
        };
        A._unquote_closure0.prototype = {
            call$1: function($arguments) {
                var string = J.$index$asx($arguments, 0).assertString$1("string");
                if (!string._string0$_hasQuotes) return string;
                return new A.SassString0(string._string0$_text, false);
            },
            $signature: 18
        };
        A._quote_closure0.prototype = {
            call$1: function($arguments) {
                var string = J.$index$asx($arguments, 0).assertString$1("string");
                if (string._string0$_hasQuotes) return string;
                return new A.SassString0(string._string0$_text, true);
            },
            $signature: 18
        };
        A._length_closure1.prototype = {
            call$1: function($arguments) {
                return A.SassNumber_SassNumber0(J.$index$asx($arguments, 0).assertString$1("string").get$_string0$_sassLength(), null);
            },
            $signature: 25
        };
        A._insert_closure0.prototype = {
            call$1: function($arguments) {
                var indexInt, codeUnitIndex, _s5_ = "index", t1 = J.getInterceptor$asx($arguments), string = t1.$index($arguments, 0).assertString$1("string"), insert = t1.$index($arguments, 1).assertString$1("insert"), index = t1.$index($arguments, 2).assertNumber$1(_s5_);
                index.assertNoUnits$1(_s5_);
                indexInt = index.assertInt$1(_s5_);
                if (indexInt < 0) indexInt = Math.max(string.get$_string0$_sassLength() + indexInt + 2, 0);
                t1 = string._string0$_text;
                codeUnitIndex = A.codepointIndexToCodeUnitIndex0(t1, A._codepointForIndex0(indexInt, string.get$_string0$_sassLength(), false));
                return new A.SassString0(B.JSString_methods.replaceRange$3(t1, codeUnitIndex, codeUnitIndex, insert._string0$_text), string._string0$_hasQuotes);
            },
            $signature: 18
        };
        A._index_closure1.prototype = {
            call$1: function($arguments) {
                var t1 = J.getInterceptor$asx($arguments), t2 = t1.$index($arguments, 0).assertString$1("string")._string0$_text, codeUnitIndex = B.JSString_methods.indexOf$1(t2, t1.$index($arguments, 1).assertString$1("substring")._string0$_text);
                if (codeUnitIndex === -1) return B.C__SassNull0;
                return A.SassNumber_SassNumber0(A.codeUnitIndexToCodepointIndex0(t2, codeUnitIndex) + 1, null);
            },
            $signature: 3
        };
        A._slice_closure0.prototype = {
            call$1: function($arguments) {
                var lengthInCodepoints, endInt, startCodepoint, endCodepoint, _s8_ = "start-at", t1 = J.getInterceptor$asx($arguments), string = t1.$index($arguments, 0).assertString$1("string"), start = t1.$index($arguments, 1).assertNumber$1(_s8_), end = t1.$index($arguments, 2).assertNumber$1("end-at");
                start.assertNoUnits$1(_s8_);
                end.assertNoUnits$1("end-at");
                lengthInCodepoints = string.get$_string0$_sassLength();
                endInt = end.assertInt$0();
                if (endInt === 0) return string._string0$_hasQuotes ? $.$get$_emptyQuoted0() : $.$get$_emptyUnquoted0();
                startCodepoint = A._codepointForIndex0(start.assertInt$0(), lengthInCodepoints, false);
                endCodepoint = A._codepointForIndex0(endInt, lengthInCodepoints, true);
                if (endCodepoint === lengthInCodepoints) --endCodepoint;
                if (endCodepoint < startCodepoint) return string._string0$_hasQuotes ? $.$get$_emptyQuoted0() : $.$get$_emptyUnquoted0();
                t1 = string._string0$_text;
                return new A.SassString0(B.JSString_methods.substring$2(t1, A.codepointIndexToCodeUnitIndex0(t1, startCodepoint), A.codepointIndexToCodeUnitIndex0(t1, endCodepoint + 1)), string._string0$_hasQuotes);
            },
            $signature: 18
        };
        A._toUpperCase_closure0.prototype = {
            call$1: function($arguments) {
                var t1, t2, i, t3, t4, string = J.$index$asx($arguments, 0).assertString$1("string");
                for(t1 = string._string0$_text, t2 = t1.length, i = 0, t3 = ""; i < t2; ++i){
                    t4 = t1.charCodeAt(i);
                    t3 += A.Primitives_stringFromCharCode(t4 >= 97 && t4 <= 122 ? t4 & 4294967263 : t4);
                }
                return new A.SassString0(t3.charCodeAt(0) == 0 ? t3 : t3, string._string0$_hasQuotes);
            },
            $signature: 18
        };
        A._toLowerCase_closure0.prototype = {
            call$1: function($arguments) {
                var t1, t2, i, t3, t4, string = J.$index$asx($arguments, 0).assertString$1("string");
                for(t1 = string._string0$_text, t2 = t1.length, i = 0, t3 = ""; i < t2; ++i){
                    t4 = t1.charCodeAt(i);
                    t3 += A.Primitives_stringFromCharCode(t4 >= 65 && t4 <= 90 ? t4 | 32 : t4);
                }
                return new A.SassString0(t3.charCodeAt(0) == 0 ? t3 : t3, string._string0$_hasQuotes);
            },
            $signature: 18
        };
        A._uniqueId_closure0.prototype = {
            call$1: function($arguments) {
                var t1 = $.$get$_previousUniqueId0() + ($.$get$_random1().nextInt$1(36) + 1);
                $._previousUniqueId0 = t1;
                if (t1 > Math.pow(36, 6)) $._previousUniqueId0 = B.JSInt_methods.$mod($.$get$_previousUniqueId0(), A._asInt(Math.pow(36, 6)));
                return new A.SassString0("u" + B.JSString_methods.padLeft$2(B.JSInt_methods.toRadixString$1($.$get$_previousUniqueId0(), 36), 6, "0"), false);
            },
            $signature: 18
        };
        A.StringExtension_toCssIdentifier_writeEscape.prototype = {
            call$1: function(character) {
                var _0_0, t1 = this.buffer, t2 = A.Primitives_stringFromCharCode(92);
                t1._contents += t2;
                t2 = B.JSInt_methods.toRadixString$1(character, 16);
                t1._contents += t2;
                _0_0 = this.scanner.peekChar$0();
                if (A._isInt(_0_0) && A.CharacterExtension_get_isHex0(_0_0)) {
                    t2 = A.Primitives_stringFromCharCode(32);
                    t1._contents += t2;
                }
            },
            $signature: 267
        };
        A.StringExtension_toCssIdentifier_consumeSurrogatePair.prototype = {
            call$1: function(character) {
                var t2, t3, t1 = this.scanner, _1_0 = t1.peekChar$1(1);
                if (_1_0 == null || _1_0 >>> 10 !== 55) t1.error$2$length(0, "An individual surrogates can't be represented as a CSS identifier.", 1);
                else if (character >>> 7 === 439) this.writeEscape.call$1(A.combineSurrogates(t1.readChar$0(), t1.readChar$0()));
                else {
                    t2 = this.buffer;
                    t3 = A.Primitives_stringFromCharCode(t1.readChar$0());
                    t2._contents += t3;
                    t1 = A.Primitives_stringFromCharCode(t1.readChar$0());
                    t2._contents += t1;
                }
            },
            $signature: 267
        };
        A.stringClass_closure.prototype = {
            call$0: function() {
                var t2, t1 = type$.JSClass, jsClass = t1._as(A.allowInteropCaptureThisNamed("sass.SassString", new A.stringClass__closure()));
                A.LinkedHashMap_LinkedHashMap$_literal([
                    "text",
                    new A.stringClass__closure0(),
                    "hasQuotes",
                    new A.stringClass__closure1(),
                    "sassLength",
                    new A.stringClass__closure2()
                ], type$.String, type$.Function).forEach$1(0, A.JSClassExtension_get_defineGetter(jsClass));
                J.get$$prototype$x(jsClass).sassIndexToStringIndex = A.allowInteropCaptureThisNamed("sassIndexToStringIndex", new A.stringClass__closure3());
                t2 = $.$get$_emptyQuoted0();
                A.JSClassExtension_injectSuperclass(t1._as(t2.constructor), jsClass);
                return jsClass;
            },
            $signature: 17
        };
        A.stringClass__closure.prototype = {
            call$3: function($self, textOrOptions, options) {
                var t1;
                if (typeof textOrOptions == "string") {
                    t1 = options == null ? null : J.get$quotes$x(options);
                    t1 = new A.SassString0(textOrOptions, t1 == null ? true : t1);
                } else {
                    type$.nullable__ConstructorOptions_3._as(textOrOptions);
                    t1 = textOrOptions == null ? null : J.get$quotes$x(textOrOptions);
                    t1 = (t1 == null ? true : t1) ? $.$get$_emptyQuoted0() : $.$get$_emptyUnquoted0();
                }
                return t1;
            },
            call$1: function($self) {
                return this.call$3($self, null, null);
            },
            call$2: function($self, textOrOptions) {
                return this.call$3($self, textOrOptions, null);
            },
            "call*": "call$3",
            $requiredArgCount: 1,
            $defaultValues: function() {
                return [
                    null,
                    null
                ];
            },
            $signature: 609
        };
        A.stringClass__closure0.prototype = {
            call$1: function($self) {
                return $self._string0$_text;
            },
            $signature: 610
        };
        A.stringClass__closure1.prototype = {
            call$1: function($self) {
                return $self._string0$_hasQuotes;
            },
            $signature: 611
        };
        A.stringClass__closure2.prototype = {
            call$1: function($self) {
                return $self.get$_string0$_sassLength();
            },
            $signature: 612
        };
        A.stringClass__closure3.prototype = {
            call$3: function($self, sassIndex, $name) {
                var t1, index = sassIndex.assertNumber$1($name).assertInt$1($name);
                if (index === 0) A.throwExpression(A.SassScriptException$0("String index may not be 0.", $name));
                else {
                    t1 = $self.get$_string0$_sassLength();
                    if (Math.abs(index) > t1) A.throwExpression(A.SassScriptException$0("Invalid index " + sassIndex.toString$0(0) + " for a string with " + t1 + " characters.", $name));
                }
                t1 = index < 0 ? $self.get$_string0$_sassLength() + index : index - 1;
                return A.codepointIndexToCodeUnitIndex0($self._string0$_text, t1);
            },
            call$2: function($self, sassIndex) {
                return this.call$3($self, sassIndex, null);
            },
            "call*": "call$3",
            $requiredArgCount: 2,
            $defaultValues: function() {
                return [
                    null
                ];
            },
            $signature: 613
        };
        A._ConstructorOptions1.prototype = {};
        A._NodeSassString.prototype = {};
        A.legacyStringClass_closure.prototype = {
            call$3: function(thisArg, value, dartValue) {
                var t1;
                if (dartValue == null) {
                    value.toString;
                    t1 = new A.SassString0(value, false);
                } else t1 = dartValue;
                J.set$dartValue$x(thisArg, t1);
            },
            call$2: function(thisArg, value) {
                return this.call$3(thisArg, value, null);
            },
            "call*": "call$3",
            $requiredArgCount: 2,
            $defaultValues: function() {
                return [
                    null
                ];
            },
            $signature: 614
        };
        A.legacyStringClass_closure0.prototype = {
            call$1: function(thisArg) {
                return J.get$dartValue$x(thisArg)._string0$_text;
            },
            $signature: 615
        };
        A.legacyStringClass_closure1.prototype = {
            call$2: function(thisArg, value) {
                J.set$dartValue$x(thisArg, new A.SassString0(value, false));
            },
            $signature: 616
        };
        A.SassString0.prototype = {
            get$_string0$_sassLength: function() {
                var result, _this = this, value = _this._string0$__SassString__sassLength_FI;
                if (value === $) {
                    result = new A.Runes(_this._string0$_text).get$length(0);
                    _this._string0$__SassString__sassLength_FI !== $ && A.throwUnnamedLateFieldADI();
                    _this._string0$__SassString__sassLength_FI = result;
                    value = result;
                }
                return value;
            },
            get$isSpecialNumber: function() {
                var t1, _2_0, t2, _0_0, _1_0;
                if (this._string0$_hasQuotes) return false;
                t1 = this._string0$_text;
                if (t1.length < 6) return false;
                _2_0 = t1.charCodeAt(0);
                $label0$0: {
                    t2 = false;
                    if (97 === _2_0 || 65 === _2_0) {
                        t1 = (t1.charCodeAt(1) | 32) === 116 && (t1.charCodeAt(2) | 32) === 116 && (t1.charCodeAt(3) | 32) === 114 && t1.charCodeAt(4) === 40;
                        break $label0$0;
                    }
                    if (99 === _2_0 || 67 === _2_0) {
                        _0_0 = t1.charCodeAt(1);
                        $label1$1: {
                            if (108 === _0_0 || 76 === _0_0) {
                                t1 = (t1.charCodeAt(2) | 32) === 97 && (t1.charCodeAt(3) | 32) === 109 && (t1.charCodeAt(4) | 32) === 112 && t1.charCodeAt(5) === 40;
                                break $label1$1;
                            }
                            if (97 === _0_0 || 65 === _0_0) {
                                t1 = (t1.charCodeAt(2) | 32) === 108 && (t1.charCodeAt(3) | 32) === 99 && t1.charCodeAt(4) === 40;
                                break $label1$1;
                            }
                            t1 = t2;
                            break $label1$1;
                        }
                        break $label0$0;
                    }
                    if (118 === _2_0 || 86 === _2_0) {
                        t1 = (t1.charCodeAt(1) | 32) === 97 && (t1.charCodeAt(2) | 32) === 114 && t1.charCodeAt(3) === 40;
                        break $label0$0;
                    }
                    if (101 === _2_0 || 69 === _2_0) {
                        t1 = (t1.charCodeAt(1) | 32) === 110 && (t1.charCodeAt(2) | 32) === 118 && t1.charCodeAt(3) === 40;
                        break $label0$0;
                    }
                    if (109 === _2_0 || 77 === _2_0) {
                        _1_0 = t1.charCodeAt(1);
                        $label2$2: {
                            if (97 === _1_0 || 65 === _1_0) {
                                t1 = (t1.charCodeAt(2) | 32) === 120 && t1.charCodeAt(3) === 40;
                                break $label2$2;
                            }
                            if (105 === _1_0 || 73 === _1_0) {
                                t1 = (t1.charCodeAt(2) | 32) === 110 && t1.charCodeAt(3) === 40;
                                break $label2$2;
                            }
                            t1 = t2;
                            break $label2$2;
                        }
                        break $label0$0;
                    }
                    if (105 === _2_0 || 73 === _2_0) {
                        t1 = (t1.charCodeAt(1) | 32) === 102 && t1.charCodeAt(2) === 40;
                        break $label0$0;
                    }
                    t1 = t2;
                    break $label0$0;
                }
                return t1;
            },
            get$isSpecialVariable: function() {
                var t1, _0_0;
                if (this._string0$_hasQuotes) return false;
                t1 = this._string0$_text;
                if (t1.length < 6) return false;
                _0_0 = t1.charCodeAt(0);
                $label0$0: {
                    if (97 === _0_0 || 65 === _0_0) {
                        t1 = (t1.charCodeAt(1) | 32) === 116 && (t1.charCodeAt(2) | 32) === 116 && (t1.charCodeAt(3) | 32) === 114 && t1.charCodeAt(4) === 40;
                        break $label0$0;
                    }
                    if (105 === _0_0 || 73 === _0_0) {
                        t1 = (t1.charCodeAt(1) | 32) === 102 && t1.charCodeAt(2) === 40;
                        break $label0$0;
                    }
                    if (118 === _0_0 || 86 === _0_0) {
                        t1 = (t1.charCodeAt(1) | 32) === 97 && (t1.charCodeAt(2) | 32) === 114 && t1.charCodeAt(3) === 40;
                        break $label0$0;
                    }
                    t1 = false;
                    break $label0$0;
                }
                return t1;
            },
            get$isBlank: function() {
                return !this._string0$_hasQuotes && this._string0$_text.length === 0;
            },
            assertQuoted$1: function($name) {
                if (this._string0$_hasQuotes) return;
                throw A.wrapException(A.SassScriptException$0("Expected " + this.toString$0(0) + " to be a quoted string.", $name));
            },
            assertUnquoted$1: function($name) {
                if (!this._string0$_hasQuotes) return;
                throw A.wrapException(A.SassScriptException$0("Expected " + this.toString$0(0) + " to be an unquoted string.", $name));
            },
            assertUnquoted$0: function() {
                return this.assertUnquoted$1(null);
            },
            accept$1$1: function(visitor) {
                var t1 = visitor._serialize0$_quote && this._string0$_hasQuotes, t2 = this._string0$_text;
                if (t1) visitor._serialize0$_visitQuotedString$1(t2);
                else visitor._serialize0$_visitUnquotedString$1(t2);
                return null;
            },
            accept$1: function(visitor) {
                return this.accept$1$1(visitor, type$.dynamic);
            },
            assertString$1: function($name) {
                return this;
            },
            plus$1: function(other) {
                var t1 = this._string0$_text, t2 = this._string0$_hasQuotes;
                return other instanceof A.SassString0 ? new A.SassString0(t1 + other._string0$_text, t2) : new A.SassString0(t1 + A.serializeValue0(other, false, true), t2);
            },
            $eq: function(_, other) {
                if (other == null) return false;
                return other instanceof A.SassString0 && this._string0$_text === other._string0$_text;
            },
            get$hashCode: function(_) {
                var t1 = this._string0$_hashCache;
                return t1 == null ? this._string0$_hashCache = B.JSString_methods.get$hashCode(this._string0$_text) : t1;
            }
        };
        A.ModifiableCssStyleRule0.prototype = {
            accept$1$1: function(visitor) {
                return visitor.visitCssStyleRule$1(this);
            },
            accept$1: function(visitor) {
                return this.accept$1$1(visitor, type$.dynamic);
            },
            equalsIgnoringChildren$1: function(other) {
                var t1;
                if (other instanceof A.ModifiableCssStyleRule0) t1 = B.C_ListEquality.equals$2(0, other._style_rule0$_selector._box0$_inner.value.components, this._style_rule0$_selector._box0$_inner.value.components);
                else t1 = false;
                return t1;
            },
            copyWithoutChildren$0: function() {
                return A.ModifiableCssStyleRule$0(this._style_rule0$_selector, this.span, false, this.originalSelector);
            },
            get$span: function(receiver) {
                return this.span;
            }
        };
        A.StyleRule0.prototype = {
            accept$1$1: function(visitor) {
                return visitor.visitStyleRule$1(0, this);
            },
            accept$1: function(visitor) {
                return this.accept$1$1(visitor, type$.dynamic);
            },
            toString$0: function(_) {
                var t1 = this.selector;
                return A.S(t1 == null ? this.parsedSelector : t1) + " {" + B.JSArray_methods.join$1(this.children, " ") + "}";
            },
            get$span: function(receiver) {
                return this.span;
            }
        };
        A.CssStylesheet0.prototype = {
            get$isGroupEnd: function() {
                return false;
            },
            get$isChildless: function() {
                return false;
            },
            accept$1$1: function(visitor) {
                return visitor.visitCssStylesheet$1(this);
            },
            accept$1: function(visitor) {
                return this.accept$1$1(visitor, type$.dynamic);
            },
            get$children: function(receiver) {
                return this.children;
            },
            get$span: function(receiver) {
                return this.span;
            }
        };
        A.ModifiableCssStylesheet0.prototype = {
            accept$1$1: function(visitor) {
                return visitor.visitCssStylesheet$1(this);
            },
            accept$1: function(visitor) {
                return this.accept$1$1(visitor, type$.dynamic);
            },
            equalsIgnoringChildren$1: function(other) {
                return other instanceof A.ModifiableCssStylesheet0;
            },
            copyWithoutChildren$0: function() {
                return A.ModifiableCssStylesheet$0(this.span);
            },
            $isCssStylesheet0: 1,
            get$span: function(receiver) {
                return this.span;
            }
        };
        A.StylesheetParser0.prototype = {
            parse$0: function(_) {
                return this.wrapSpanFormatException$1(new A.StylesheetParser_parse_closure0(this));
            },
            parseParameterList$0: function() {
                return this._stylesheet0$_parseSingleProduction$1$1(new A.StylesheetParser_parseParameterList_closure0(this), type$.ParameterList_2);
            },
            _stylesheet0$_parseSingleProduction$1$1: function(production, $T) {
                return this.wrapSpanFormatException$1(new A.StylesheetParser__parseSingleProduction_closure0(this, production, $T));
            },
            parseSignature$1$requireParens: function(requireParens) {
                return this.wrapSpanFormatException$1(new A.StylesheetParser_parseSignature_closure(this, requireParens));
            },
            _stylesheet0$_statement$1$root: function(root) {
                var t2, _this = this, t1 = _this.scanner, _0_0 = t1.peekChar$0();
                if (64 === _0_0) return _this.atRule$2$root(new A.StylesheetParser__statement_closure0(_this), root);
                if (43 === _0_0) {
                    if (!_this.get$indented() || !_this.lookingAtIdentifier$1(1)) return _this._stylesheet0$_styleRule$0();
                    _this._stylesheet0$_isUseAllowed = false;
                    t2 = t1._string_scanner$_position;
                    t1.readChar$0();
                    return _this._stylesheet0$_includeRule$1(new A._SpanScannerState(t1, t2));
                }
                if (61 === _0_0) {
                    if (!_this.get$indented()) return _this._stylesheet0$_styleRule$0();
                    _this._stylesheet0$_isUseAllowed = false;
                    t2 = t1._string_scanner$_position;
                    t1.readChar$0();
                    _this.whitespace$1$consumeNewlines(true);
                    return _this._stylesheet0$_mixinRule$1(new A._SpanScannerState(t1, t2));
                }
                if (125 === _0_0) t1.error$2$length(0, 'unmatched "}".', 1);
                return _this._stylesheet0$_inStyleRule || _this._stylesheet0$_inUnknownAtRule || _this._stylesheet0$_inMixin || _this._stylesheet0$_inContentBlock ? _this._stylesheet0$_declarationOrStyleRule$0() : _this._stylesheet0$_variableDeclarationOrStyleRule$0();
            },
            _stylesheet0$_statement$0: function() {
                return this._stylesheet0$_statement$1$root(false);
            },
            variableDeclarationWithoutNamespace$2: function(namespace, start_) {
                var t1, start, $name, t2, value, flagStart, t3, guarded, global, _0_0, declaration, _this = this, precedingComment = _this.lastSilentComment;
                _this.lastSilentComment = null;
                if (start_ == null) {
                    t1 = _this.scanner;
                    start = new A._SpanScannerState(t1, t1._string_scanner$_position);
                } else start = start_;
                $name = _this.variableName$0();
                t1 = namespace != null;
                if (t1) _this._stylesheet0$_assertPublic$2($name, new A.StylesheetParser_variableDeclarationWithoutNamespace_closure1(_this, start));
                if (_this.get$plainCss()) _this.error$2(0, string$.Sass_v, _this.spanFrom$1(start));
                _this.whitespace$1$consumeNewlines(true);
                t2 = _this.scanner;
                t2.expectChar$1(58);
                _this.whitespace$1$consumeNewlines(true);
                value = _this._stylesheet0$_expression$0();
                flagStart = new A._SpanScannerState(t2, t2._string_scanner$_position);
                for(t3 = _this.warnings, guarded = false, global = false; t2.scanChar$1(33);){
                    $label0$0: {
                        _0_0 = _this.identifier$0();
                        if ("default" === _0_0) {
                            if (guarded) t3.push(new A._Record_3_deprecation_message_span(B.Deprecation_DVV, string$.x21defau, _this.spanFrom$1(flagStart)));
                            guarded = true;
                            break $label0$0;
                        }
                        if ("global" === _0_0) {
                            if (t1) _this.error$2(0, string$.x21globai, _this.spanFrom$1(flagStart));
                            else if (global) t3.push(new A._Record_3_deprecation_message_span(B.Deprecation_DVV, string$.x21globas, _this.spanFrom$1(flagStart)));
                            global = true;
                            break $label0$0;
                        }
                        _this.error$2(0, "Invalid flag name.", _this.spanFrom$1(flagStart));
                    }
                    _this.whitespace$1$consumeNewlines(false);
                    flagStart = new A._SpanScannerState(t2, t2._string_scanner$_position);
                }
                _this.expectStatementSeparator$1("variable declaration");
                declaration = A.VariableDeclaration$0($name, value, _this.spanFrom$1(start), precedingComment, global, guarded, namespace);
                if (global) _this._stylesheet0$_globalVariables.putIfAbsent$2($name, new A.StylesheetParser_variableDeclarationWithoutNamespace_closure2(declaration));
                return declaration;
            },
            variableDeclarationWithoutNamespace$0: function() {
                return this.variableDeclarationWithoutNamespace$2(null, null);
            },
            _stylesheet0$_variableDeclarationOrStyleRule$0: function() {
                var t1, t2, variableOrInterpolation, t3, _this = this;
                if (_this.get$plainCss()) return _this._stylesheet0$_styleRule$0();
                if (_this.get$indented() && _this.scanner.scanChar$1(92)) return _this._stylesheet0$_styleRule$0();
                if (!_this.lookingAtIdentifier$0()) return _this._stylesheet0$_styleRule$0();
                t1 = _this.scanner;
                t2 = t1._string_scanner$_position;
                variableOrInterpolation = _this._stylesheet0$_variableDeclarationOrInterpolation$0();
                if (variableOrInterpolation instanceof A.VariableDeclaration0) t1 = variableOrInterpolation;
                else {
                    t3 = new A.InterpolationBuffer0(new A.StringBuffer(""), A._setArrayType([], type$.JSArray_Object), A._setArrayType([], type$.JSArray_nullable_FileSpan));
                    t3.addInterpolation$1(type$.Interpolation_2._as(variableOrInterpolation));
                    t2 = _this._stylesheet0$_styleRule$2(t3, new A._SpanScannerState(t1, t2));
                    t1 = t2;
                }
                return t1;
            },
            _stylesheet0$_declarationOrStyleRule$0: function() {
                var t1, t2, declarationOrBuffer, _this = this;
                if (_this.get$indented() && _this.scanner.scanChar$1(92)) return _this._stylesheet0$_styleRule$0();
                t1 = _this.scanner;
                t2 = t1._string_scanner$_position;
                declarationOrBuffer = _this._stylesheet0$_declarationOrBuffer$0();
                return declarationOrBuffer instanceof A.Statement0 ? declarationOrBuffer : _this._stylesheet0$_styleRule$2(type$.InterpolationBuffer_2._as(declarationOrBuffer), new A._SpanScannerState(t1, t2));
            },
            _stylesheet0$_declarationOrBuffer$0: function() {
                var midBuffer, couldBeSelector, beforeDeclaration, value, additional, t2, t3, variableOrInterpolation, $name, isCustomProperty, t4, postColonWhitespace, _0_0, _$exception, _1_0, _this = this, t1 = _this.scanner, start = new A._SpanScannerState(t1, t1._string_scanner$_position), nameBuffer = new A.InterpolationBuffer0(new A.StringBuffer(""), A._setArrayType([], type$.JSArray_Object), A._setArrayType([], type$.JSArray_nullable_FileSpan)), startsWithPunctuation = _this._stylesheet0$_lookingAtPotentialPropertyHack$0();
                if (startsWithPunctuation) {
                    t2 = t1.readChar$0();
                    t3 = nameBuffer._interpolation_buffer0$_text;
                    t2 = A.Primitives_stringFromCharCode(t2);
                    t3._contents += t2;
                    t2 = _this.rawText$1(new A.StylesheetParser__declarationOrBuffer_closure3(_this));
                    t3 = nameBuffer._interpolation_buffer0$_text;
                    t3._contents += t2;
                }
                if (!_this._stylesheet0$_lookingAtInterpolatedIdentifier$0()) return nameBuffer;
                variableOrInterpolation = startsWithPunctuation ? _this.interpolatedIdentifier$0() : _this._stylesheet0$_variableDeclarationOrInterpolation$0();
                if (variableOrInterpolation instanceof A.VariableDeclaration0) return variableOrInterpolation;
                else nameBuffer.addInterpolation$1(type$.Interpolation_2._as(variableOrInterpolation));
                _this._stylesheet0$_isUseAllowed = false;
                if (t1.matches$1("/*")) {
                    t2 = _this.rawText$1(_this.get$loudComment());
                    t3 = nameBuffer._interpolation_buffer0$_text;
                    t3._contents += t2;
                }
                midBuffer = new A.StringBuffer("");
                t2 = midBuffer;
                t3 = _this.rawText$1(new A.StylesheetParser__declarationOrBuffer_closure4(_this));
                t2._contents += t3;
                t3 = t1._string_scanner$_position;
                if (!t1.scanChar$1(58)) {
                    if (midBuffer._contents.length !== 0) {
                        t1 = nameBuffer._interpolation_buffer0$_text;
                        t2 = A.Primitives_stringFromCharCode(32);
                        t1._contents += t2;
                    }
                    return nameBuffer;
                }
                t2 = A.Primitives_stringFromCharCode(58);
                midBuffer._contents += t2;
                $name = nameBuffer.interpolation$1(_this.spanFrom$2(start, new A._SpanScannerState(t1, t3)));
                isCustomProperty = B.JSString_methods.startsWith$1($name.get$initialPlain(), "--");
                if (!isCustomProperty) {
                    if (_this._stylesheet0$_inPlainCssFunction) {
                        t3 = A.NullableExtension_andThen0($name.get$asPlain(), new A.StylesheetParser__declarationOrBuffer_closure5());
                        if (t3 == null) t3 = false;
                    } else t3 = false;
                } else t3 = true;
                if (t3) {
                    if (_this.atEndOfStatement$0()) {
                        t1 = A.FileLocation$_(t1._sourceFile, t1._string_scanner$_position);
                        t2 = t1.offset;
                        t2 = A.Interpolation$0(B.List_empty12, B.List_empty13, A._FileSpan$(t1.file, t2, t2));
                        t1 = t2;
                    } else t1 = _this._stylesheet0$_interpolatedDeclarationValue$1$silentComments(false);
                    _this.expectStatementSeparator$1(isCustomProperty ? "custom property" : "@function result");
                    return A.Declaration$notSassScript0($name, new A.StringExpression0(t1, false), _this.spanFrom$1(start));
                }
                if (t1.scanChar$1(58)) {
                    t1 = nameBuffer;
                    t3 = t1._interpolation_buffer0$_text;
                    t4 = A.S(midBuffer);
                    t3._contents = (t3._contents += t4) + t2;
                    return t1;
                } else if (_this.get$indented() && _this._stylesheet0$_lookingAtInterpolatedIdentifier$0()) {
                    t1 = nameBuffer;
                    t2 = t1._interpolation_buffer0$_text;
                    t3 = A.S(midBuffer);
                    t2._contents += t3;
                    return t1;
                }
                postColonWhitespace = _this.rawText$1(new A.StylesheetParser__declarationOrBuffer_closure6(_this));
                _0_0 = _this._stylesheet0$_tryDeclarationChildren$2($name, start);
                if (_0_0 != null) return _0_0;
                midBuffer._contents += postColonWhitespace;
                couldBeSelector = postColonWhitespace.length === 0 && _this._stylesheet0$_lookingAtInterpolatedIdentifier$0();
                beforeDeclaration = new A._SpanScannerState(t1, t1._string_scanner$_position);
                value = null;
                try {
                    value = _this._stylesheet0$_expression$0();
                    if (_this.lookingAtChildren$0()) {
                        if (couldBeSelector) _this.expectStatementSeparator$0();
                    } else if (!_this.atEndOfStatement$0()) _this.expectStatementSeparator$0();
                } catch (exception) {
                    if (type$.FormatException._is(A.unwrapException(exception))) {
                        if (!couldBeSelector) throw exception;
                        t1.set$state(beforeDeclaration);
                        additional = _this.almostAnyValue$0();
                        if (!_this.get$indented() && t1.peekChar$0() === 59) throw exception;
                        t1 = nameBuffer._interpolation_buffer0$_text;
                        t2 = A.S(midBuffer);
                        t1._contents += t2;
                        nameBuffer.addInterpolation$1(additional);
                        return nameBuffer;
                    } else throw exception;
                }
                _1_0 = _this._stylesheet0$_tryDeclarationChildren$3$value($name, start, value);
                if (_1_0 != null) return _1_0;
                else {
                    _this.expectStatementSeparator$0();
                    return A.Declaration$0($name, value, _this.spanFrom$1(start));
                }
            },
            _stylesheet0$_variableDeclarationOrInterpolation$0: function() {
                var t1, start, identifier, buffer, _this = this;
                if (!_this.lookingAtIdentifier$0()) return _this.interpolatedIdentifier$0();
                t1 = _this.scanner;
                start = new A._SpanScannerState(t1, t1._string_scanner$_position);
                identifier = _this.identifier$0();
                if (t1.matches$1(".$")) {
                    t1.readChar$0();
                    return _this.variableDeclarationWithoutNamespace$2(identifier, start);
                } else {
                    t1 = new A.StringBuffer("");
                    buffer = new A.InterpolationBuffer0(t1, A._setArrayType([], type$.JSArray_Object), A._setArrayType([], type$.JSArray_nullable_FileSpan));
                    t1._contents = identifier;
                    if (_this._stylesheet0$_lookingAtInterpolatedIdentifierBody$0()) buffer.addInterpolation$1(_this.interpolatedIdentifier$0());
                    return buffer.interpolation$1(_this.spanFrom$1(start));
                }
            },
            _stylesheet0$_styleRule$2: function(buffer, start_) {
                var t1, t2, start, selector, interpolation, _this = this;
                _this._stylesheet0$_isUseAllowed = false;
                t1 = start_ == null;
                if (t1) {
                    t2 = _this.scanner;
                    start = new A._SpanScannerState(t2, t2._string_scanner$_position);
                } else start = start_;
                if (_this._parseSelectors) {
                    if (!t1) _this.scanner.set$state(start);
                    selector = _this._stylesheet0$_selectorList$0();
                    return _this._stylesheet0$_withStyleRuleChildren$1$3(selector, start, new A.StylesheetParser__styleRule_closure0(_this, selector, start), type$.StyleRule_2);
                } else {
                    t1 = {};
                    interpolation = t1.interpolation = _this.styleRuleSelector$0();
                    if (buffer != null) {
                        buffer.addInterpolation$1(interpolation);
                        t2 = t1.interpolation = buffer.interpolation$1(_this.spanFrom$1(start));
                    } else t2 = interpolation;
                    if (t2.contents.length === 0) _this.scanner.error$1(0, 'expected "}".');
                    return _this._stylesheet0$_withStyleRuleChildren$1$3(t2, start, new A.StylesheetParser__styleRule_closure1(t1, _this, start), type$.StyleRule_2);
                }
            },
            _stylesheet0$_styleRule$0: function() {
                return this._stylesheet0$_styleRule$2(null, null);
            },
            _stylesheet0$_withStyleRuleChildren$1$3: function(nodeWithSpan, start, create, $T) {
                var _this = this, wasInStyleRule = _this._stylesheet0$_inStyleRule;
                _this._stylesheet0$_inStyleRule = true;
                return _this._stylesheet0$_withChildren$3(_this.get$_stylesheet0$_statement(), start, new A.StylesheetParser__withStyleRuleChildren_closure0(_this, nodeWithSpan, wasInStyleRule, create, $T));
            },
            _stylesheet0$_propertyOrVariableDeclaration$0: function() {
                var t2, nameBuffer, t3, $name, variableOrInterpolation, _0_0, value, _1_0, _this = this, t1 = _this.scanner, start = new A._SpanScannerState(t1, t1._string_scanner$_position);
                if (_this._stylesheet0$_lookingAtPotentialPropertyHack$0()) {
                    t2 = new A.StringBuffer("");
                    nameBuffer = new A.InterpolationBuffer0(t2, A._setArrayType([], type$.JSArray_Object), A._setArrayType([], type$.JSArray_nullable_FileSpan));
                    t3 = A.Primitives_stringFromCharCode(t1.readChar$0());
                    t2._contents += t3;
                    t3 = _this.rawText$1(new A.StylesheetParser__propertyOrVariableDeclaration_closure0(_this));
                    t2._contents += t3;
                    nameBuffer.addInterpolation$1(_this.interpolatedIdentifier$0());
                    $name = nameBuffer.interpolation$1(_this.spanFrom$1(start));
                } else if (!_this.get$plainCss()) {
                    variableOrInterpolation = _this._stylesheet0$_variableDeclarationOrInterpolation$0();
                    if (variableOrInterpolation instanceof A.VariableDeclaration0) return variableOrInterpolation;
                    else type$.Interpolation_2._as(variableOrInterpolation);
                    $name = variableOrInterpolation;
                } else $name = _this.interpolatedIdentifier$0();
                _this.whitespace$1$consumeNewlines(false);
                t1.expectChar$1(58);
                if (B.JSString_methods.startsWith$1($name.get$initialPlain(), "--")) _this.error$2(0, string$.Declarw, $name.span);
                _this.whitespace$1$consumeNewlines(false);
                _0_0 = _this._stylesheet0$_tryDeclarationChildren$2($name, start);
                if (_0_0 != null) return _0_0;
                value = _this._stylesheet0$_expression$0();
                _1_0 = _this._stylesheet0$_tryDeclarationChildren$3$value($name, start, value);
                if (_1_0 != null) return _1_0;
                else {
                    _this.expectStatementSeparator$0();
                    return A.Declaration$0($name, value, _this.spanFrom$1(start));
                }
            },
            _stylesheet0$_tryDeclarationChildren$3$value: function($name, start, value) {
                var _this = this;
                if (!_this.lookingAtChildren$0()) return null;
                if (_this.get$plainCss()) _this.scanner.error$1(0, string$.Nested);
                return _this._stylesheet0$_withChildren$3(_this.get$_stylesheet0$_declarationChild(), start, new A.StylesheetParser__tryDeclarationChildren_closure0($name, value));
            },
            _stylesheet0$_tryDeclarationChildren$2: function($name, start) {
                return this._stylesheet0$_tryDeclarationChildren$3$value($name, start, null);
            },
            _stylesheet0$_declarationChild$0: function() {
                return this.scanner.peekChar$0() === 64 ? this._stylesheet0$_declarationAtRule$0() : this._stylesheet0$_propertyOrVariableDeclaration$0();
            },
            atRule$2$root: function(child, root) {
                var $name, wasUseAllowed, value, optional, url, namespace, configuration, span, _this = this, t1 = _this.scanner, start = new A._SpanScannerState(t1, t1._string_scanner$_position);
                t1.expectChar$2$name(64, "@-rule");
                $name = _this.interpolatedIdentifier$0();
                wasUseAllowed = _this._stylesheet0$_isUseAllowed;
                _this._stylesheet0$_isUseAllowed = false;
                switch($name.get$asPlain()){
                    case "at-root":
                        return _this._stylesheet0$_atRootRule$1(start);
                    case "content":
                        return _this._stylesheet0$_contentRule$1(start);
                    case "debug":
                        return _this._stylesheet0$_debugRule$1(start);
                    case "each":
                        return _this._stylesheet0$_eachRule$2(start, child);
                    case "else":
                        return _this._stylesheet0$_disallowedAtRule$1(start);
                    case "error":
                        return _this._stylesheet0$_errorRule$1(start);
                    case "extend":
                        _this.whitespace$1$consumeNewlines(true);
                        if (!_this._stylesheet0$_inStyleRule && !_this._stylesheet0$_inMixin && !_this._stylesheet0$_inContentBlock) _this.error$2(0, string$.x40exten, _this.spanFrom$1(start));
                        value = _this.almostAnyValue$0();
                        optional = t1.scanChar$1(33);
                        if (optional) {
                            _this.expectIdentifier$1("optional");
                            _this.whitespace$1$consumeNewlines(false);
                        }
                        _this.expectStatementSeparator$1("@extend rule");
                        return new A.ExtendRule0(value, optional, _this.spanFrom$1(start));
                    case "for":
                        return _this._stylesheet0$_forRule$2(start, child);
                    case "forward":
                        _this._stylesheet0$_isUseAllowed = wasUseAllowed;
                        if (!root) _this._stylesheet0$_disallowedAtRule$1(start);
                        return _this._stylesheet0$_forwardRule$1(start);
                    case "function":
                        return _this._stylesheet0$_functionRule$2(start, $name);
                    case "if":
                        return _this._stylesheet0$_ifRule$2(start, child);
                    case "import":
                        return _this._stylesheet0$_importRule$1(start);
                    case "include":
                        return _this._stylesheet0$_includeRule$1(start);
                    case "media":
                        return _this.mediaRule$1(start);
                    case "mixin":
                        return _this._stylesheet0$_mixinRule$1(start);
                    case "-moz-document":
                        return _this.mozDocumentRule$2(start, $name);
                    case "return":
                        return _this._stylesheet0$_disallowedAtRule$1(start);
                    case "supports":
                        return _this.supportsRule$1(start);
                    case "use":
                        _this._stylesheet0$_isUseAllowed = wasUseAllowed;
                        if (!root) _this._stylesheet0$_disallowedAtRule$1(start);
                        _this.whitespace$1$consumeNewlines(true);
                        url = _this._stylesheet0$_urlString$0();
                        _this.whitespace$1$consumeNewlines(false);
                        namespace = _this._stylesheet0$_useNamespace$2(url, start);
                        _this.whitespace$1$consumeNewlines(false);
                        configuration = _this._stylesheet0$_configuration$0();
                        _this.whitespace$1$consumeNewlines(false);
                        span = _this.spanFrom$1(start);
                        if (!_this._stylesheet0$_isUseAllowed) _this.error$2(0, string$.x40use_r, span);
                        _this.expectStatementSeparator$1("@use rule");
                        t1 = new A.UseRule0(url, namespace, configuration == null ? B.List_empty26 : A.List_List$unmodifiable(configuration, type$.ConfiguredVariable_2), span);
                        t1.UseRule$4$configuration0(url, namespace, span, configuration);
                        return t1;
                    case "warn":
                        return _this._stylesheet0$_warnRule$1(start);
                    case "while":
                        return _this._stylesheet0$_whileRule$2(start, child);
                    default:
                        return _this.unknownAtRule$2(start, $name);
                }
            },
            _stylesheet0$_declarationAtRule$0: function() {
                var _this = this, t1 = _this.scanner, start = new A._SpanScannerState(t1, t1._string_scanner$_position), _0_0 = _this._stylesheet0$_plainAtRuleName$0();
                $label0$0: {
                    if ("content" === _0_0) {
                        t1 = _this._stylesheet0$_contentRule$1(start);
                        break $label0$0;
                    }
                    if ("debug" === _0_0) {
                        t1 = _this._stylesheet0$_debugRule$1(start);
                        break $label0$0;
                    }
                    if ("each" === _0_0) {
                        t1 = _this._stylesheet0$_eachRule$2(start, _this.get$_stylesheet0$_declarationChild());
                        break $label0$0;
                    }
                    if ("else" === _0_0) _this._stylesheet0$_disallowedAtRule$1(start);
                    if ("error" === _0_0) {
                        t1 = _this._stylesheet0$_errorRule$1(start);
                        break $label0$0;
                    }
                    if ("for" === _0_0) {
                        t1 = _this._stylesheet0$_forRule$2(start, _this.get$_stylesheet0$_declarationChild());
                        break $label0$0;
                    }
                    if ("if" === _0_0) {
                        t1 = _this._stylesheet0$_ifRule$2(start, _this.get$_stylesheet0$_declarationChild());
                        break $label0$0;
                    }
                    if ("include" === _0_0) {
                        t1 = _this._stylesheet0$_includeRule$1(start);
                        break $label0$0;
                    }
                    if ("warn" === _0_0) {
                        t1 = _this._stylesheet0$_warnRule$1(start);
                        break $label0$0;
                    }
                    if ("while" === _0_0) {
                        t1 = _this._stylesheet0$_whileRule$2(start, _this.get$_stylesheet0$_declarationChild());
                        break $label0$0;
                    }
                    t1 = _this._stylesheet0$_disallowedAtRule$1(start);
                }
                return t1;
            },
            _stylesheet0$_functionChild$0: function() {
                var state, variableDeclarationError, stackTrace, statement, t2, namespace, _$exception, t3, start, _0_0, value, _this = this, t1 = _this.scanner;
                if (t1.peekChar$0() !== 64) {
                    t2 = t1._string_scanner$_position;
                    state = new A._SpanScannerState(t1, t2);
                    try {
                        namespace = _this.identifier$0();
                        t1.expectChar$1(46);
                        t2 = _this.variableDeclarationWithoutNamespace$2(namespace, new A._SpanScannerState(t1, t2));
                        return t2;
                    } catch (exception) {
                        t2 = A.unwrapException(exception);
                        t3 = type$.SourceSpanFormatException;
                        if (t3._is(t2)) {
                            variableDeclarationError = t2;
                            stackTrace = A.getTraceFromException(exception);
                            t1.set$state(state);
                            statement = null;
                            try {
                                statement = _this._stylesheet0$_declarationOrStyleRule$0();
                            } catch (exception) {
                                if (t3._is(A.unwrapException(exception))) throw A.wrapException(variableDeclarationError);
                                else throw exception;
                            }
                            t2 = statement instanceof A.StyleRule0 ? "style rules" : "declarations";
                            _this.error$3(0, "@function rules may not contain " + t2 + ".", J.get$span$x(statement), stackTrace);
                        } else throw exception;
                    }
                }
                start = new A._SpanScannerState(t1, t1._string_scanner$_position);
                _0_0 = _this._stylesheet0$_plainAtRuleName$0();
                $label0$0: {
                    if ("debug" === _0_0) {
                        t1 = _this._stylesheet0$_debugRule$1(start);
                        break $label0$0;
                    }
                    if ("each" === _0_0) {
                        t1 = _this._stylesheet0$_eachRule$2(start, _this.get$_stylesheet0$_functionChild());
                        break $label0$0;
                    }
                    if ("else" === _0_0) _this._stylesheet0$_disallowedAtRule$1(start);
                    if ("error" === _0_0) {
                        t1 = _this._stylesheet0$_errorRule$1(start);
                        break $label0$0;
                    }
                    if ("for" === _0_0) {
                        t1 = _this._stylesheet0$_forRule$2(start, _this.get$_stylesheet0$_functionChild());
                        break $label0$0;
                    }
                    if ("if" === _0_0) {
                        t1 = _this._stylesheet0$_ifRule$2(start, _this.get$_stylesheet0$_functionChild());
                        break $label0$0;
                    }
                    if ("return" === _0_0) {
                        _this.whitespace$1$consumeNewlines(true);
                        value = _this._stylesheet0$_expression$0();
                        _this.expectStatementSeparator$1("@return rule");
                        t1 = new A.ReturnRule0(value, _this.spanFrom$1(start));
                        break $label0$0;
                    }
                    if ("warn" === _0_0) {
                        t1 = _this._stylesheet0$_warnRule$1(start);
                        break $label0$0;
                    }
                    if ("while" === _0_0) {
                        t1 = _this._stylesheet0$_whileRule$2(start, _this.get$_stylesheet0$_functionChild());
                        break $label0$0;
                    }
                    t1 = _this._stylesheet0$_disallowedAtRule$1(start);
                }
                return t1;
            },
            _stylesheet0$_plainAtRuleName$0: function() {
                this.scanner.expectChar$2$name(64, "@-rule");
                return this.identifier$0();
            },
            _stylesheet0$_atRootRule$1: function(start) {
                var t1, t2, t3, buffer, t4, _this = this;
                _this.whitespace$1$consumeNewlines(false);
                t1 = _this.scanner;
                if (t1.peekChar$0() === 40) {
                    t2 = t1._string_scanner$_position;
                    t3 = new A.StringBuffer("");
                    buffer = new A.InterpolationBuffer0(t3, A._setArrayType([], type$.JSArray_Object), A._setArrayType([], type$.JSArray_nullable_FileSpan));
                    t1.expectChar$1(40);
                    t4 = A.Primitives_stringFromCharCode(40);
                    t3._contents += t4;
                    _this.whitespace$1$consumeNewlines(true);
                    _this._stylesheet0$_addOrInject$2(buffer, _this._stylesheet0$_expression$1$consumeNewlines(true));
                    if (t1.scanChar$1(58)) {
                        _this.whitespace$1$consumeNewlines(true);
                        t4 = A.Primitives_stringFromCharCode(58);
                        t3._contents += t4;
                        t4 = A.Primitives_stringFromCharCode(32);
                        t3._contents += t4;
                        _this._stylesheet0$_addOrInject$2(buffer, _this._stylesheet0$_expression$1$consumeNewlines(true));
                    }
                    t1.expectChar$1(41);
                    _this.whitespace$1$consumeNewlines(false);
                    t4 = A.Primitives_stringFromCharCode(41);
                    t3._contents += t4;
                    return _this._stylesheet0$_withChildren$3(_this.get$_stylesheet0$_statement(), start, new A.StylesheetParser__atRootRule_closure1(buffer.interpolation$1(_this.spanFrom$1(new A._SpanScannerState(t1, t2)))));
                } else {
                    if (!_this.lookingAtChildren$0()) t1 = _this.get$indented() && _this.atEndOfStatement$0();
                    else t1 = true;
                    if (t1) return _this._stylesheet0$_withChildren$3(_this.get$_stylesheet0$_statement(), start, new A.StylesheetParser__atRootRule_closure2());
                    else return A.AtRootRule$0(A._setArrayType([
                        _this._stylesheet0$_styleRule$0()
                    ], type$.JSArray_Statement_2), _this.spanFrom$1(start), null);
                }
            },
            _stylesheet0$_contentRule$1: function(start) {
                var t1, beforeWhitespace, $arguments, _this = this;
                if (!_this._stylesheet0$_inMixin) _this.error$2(0, string$.x40conte, _this.spanFrom$1(start));
                t1 = _this.scanner;
                beforeWhitespace = A.FileLocation$_(t1._sourceFile, t1._string_scanner$_position);
                _this.whitespace$1$consumeNewlines(false);
                if (t1.peekChar$0() === 40) {
                    $arguments = _this._stylesheet0$_argumentInvocation$1$mixin(true);
                    _this.whitespace$1$consumeNewlines(false);
                } else {
                    t1 = beforeWhitespace.offset;
                    $arguments = A.ArgumentList$empty0(A._FileSpan$(beforeWhitespace.file, t1, t1));
                }
                _this.expectStatementSeparator$1("@content rule");
                return new A.ContentRule0($arguments, _this.spanFrom$1(start));
            },
            _stylesheet0$_debugRule$1: function(start) {
                var value, t1, t2, _this = this;
                _this.whitespace$1$consumeNewlines(true);
                value = _this._stylesheet0$_expression$0();
                t1 = _this.scanner;
                t2 = t1._string_scanner$_position;
                _this.expectStatementSeparator$1("@debug rule");
                return new A.DebugRule0(value, _this.spanFrom$2(start, new A._SpanScannerState(t1, t2)));
            },
            _stylesheet0$_eachRule$2: function(start, child) {
                var wasInControlDirective, variables, t1, _this = this;
                _this.whitespace$1$consumeNewlines(true);
                wasInControlDirective = _this._stylesheet0$_inControlDirective;
                _this._stylesheet0$_inControlDirective = true;
                variables = A._setArrayType([
                    _this.variableName$0()
                ], type$.JSArray_String);
                _this.whitespace$1$consumeNewlines(true);
                for(t1 = _this.scanner; t1.scanChar$1(44);){
                    _this.whitespace$1$consumeNewlines(true);
                    t1.expectChar$1(36);
                    variables.push(_this.identifier$1$normalize(true));
                    _this.whitespace$1$consumeNewlines(true);
                }
                _this.whitespace$1$consumeNewlines(true);
                _this.expectIdentifier$1("in");
                _this.whitespace$1$consumeNewlines(true);
                return _this._stylesheet0$_withChildren$3(child, start, new A.StylesheetParser__eachRule_closure0(_this, wasInControlDirective, variables, _this._stylesheet0$_expression$0()));
            },
            _stylesheet0$_errorRule$1: function(start) {
                var value, t1, t2, _this = this;
                _this.whitespace$1$consumeNewlines(true);
                value = _this._stylesheet0$_expression$0();
                t1 = _this.scanner;
                t2 = t1._string_scanner$_position;
                _this.expectStatementSeparator$1("@error rule");
                return new A.ErrorRule0(value, _this.spanFrom$2(start, new A._SpanScannerState(t1, t2)));
            },
            _stylesheet0$_functionRule$2: function(start, atRuleName) {
                var precedingComment, t1, beforeName, $name, _1_0, parameters, _this = this;
                _this.whitespace$1$consumeNewlines(true);
                precedingComment = _this.lastSilentComment;
                _this.lastSilentComment = null;
                t1 = _this.scanner;
                beforeName = new A._SpanScannerState(t1, t1._string_scanner$_position);
                if (t1.matches$1("--")) return _this.unknownAtRule$2(start, atRuleName);
                $name = _this.identifier$0();
                if (A.equalsIgnoreCase0($name, "type")) _this.error$2(0, string$.This_n, _this.spanFrom$1(beforeName));
                $label0$0: {
                    if ("expression" === $name || "url" === $name || "and" === $name || "or" === $name || "not" === $name) {
                        t1 = true;
                        break $label0$0;
                    }
                    t1 = A.unvendor0($name) === "element";
                    break $label0$0;
                }
                if (t1) _this.error$2(0, "Invalid function name.", _this.spanFrom$1(beforeName));
                else {
                    _1_0 = $name.toLowerCase();
                    $label1$1: {
                        if ("expression" === _1_0 || "url" === _1_0) {
                            t1 = true;
                            break $label1$1;
                        }
                        t1 = A.unvendor0(_1_0) === "element";
                        break $label1$1;
                    }
                    if (t1) _this.warnings.push(new A._Record_3_deprecation_message_span(B.Deprecation_2Ja, string$.Customf, _this.spanFrom$1(beforeName)));
                }
                _this.whitespace$1$consumeNewlines(true);
                parameters = _this._stylesheet0$_parameterList$0();
                if (_this._stylesheet0$_inMixin || _this._stylesheet0$_inContentBlock) _this.error$2(0, string$.Mixinscf, _this.spanFrom$1(start));
                else if (_this._stylesheet0$_inControlDirective) _this.error$2(0, string$.Functi, _this.spanFrom$1(start));
                _this.whitespace$1$consumeNewlines(false);
                return _this._stylesheet0$_withChildren$3(_this.get$_stylesheet0$_functionChild(), start, new A.StylesheetParser__functionRule_closure0($name, parameters, precedingComment));
            },
            _stylesheet0$_forRule$2: function(start, child) {
                var wasInControlDirective, variable, from, _this = this, t1 = {};
                _this.whitespace$1$consumeNewlines(true);
                wasInControlDirective = _this._stylesheet0$_inControlDirective;
                _this._stylesheet0$_inControlDirective = true;
                variable = _this.variableName$0();
                _this.whitespace$1$consumeNewlines(true);
                _this.expectIdentifier$1("from");
                _this.whitespace$1$consumeNewlines(true);
                t1.exclusive = null;
                from = _this._stylesheet0$_expression$2$consumeNewlines$until(true, new A.StylesheetParser__forRule_closure1(t1, _this));
                if (t1.exclusive == null) _this.scanner.error$1(0, 'Expected "to" or "through".');
                _this.whitespace$1$consumeNewlines(true);
                return _this._stylesheet0$_withChildren$3(child, start, new A.StylesheetParser__forRule_closure2(t1, _this, wasInControlDirective, variable, from, _this._stylesheet0$_expression$0()));
            },
            _stylesheet0$_forwardRule$1: function(start) {
                var url, prefix, hiddenMixinsAndFunctions, hiddenVariables, _0_0, shownMixinsAndFunctions, shownVariables, _1_0, configuration, span, t1, t2, t3, t4, _this = this, _null = null;
                _this.whitespace$1$consumeNewlines(true);
                url = _this._stylesheet0$_urlString$0();
                _this.whitespace$1$consumeNewlines(false);
                if (_this.scanIdentifier$1("as")) {
                    _this.whitespace$1$consumeNewlines(true);
                    prefix = _this.identifier$1$normalize(true);
                    _this.scanner.expectChar$1(42);
                    _this.whitespace$1$consumeNewlines(false);
                } else prefix = _null;
                hiddenMixinsAndFunctions = _null;
                hiddenVariables = _null;
                if (_this.scanIdentifier$1("show")) {
                    _this.whitespace$1$consumeNewlines(true);
                    _0_0 = _this._stylesheet0$_memberList$0();
                    shownMixinsAndFunctions = _0_0._0;
                    shownVariables = _0_0._1;
                } else {
                    if (_this.scanIdentifier$1("hide")) {
                        _this.whitespace$1$consumeNewlines(true);
                        _1_0 = _this._stylesheet0$_memberList$0();
                        hiddenMixinsAndFunctions = _1_0._0;
                        hiddenVariables = _1_0._1;
                    }
                    shownVariables = _null;
                    shownMixinsAndFunctions = shownVariables;
                }
                configuration = _this._stylesheet0$_configuration$1$allowGuarded(true);
                _this.whitespace$1$consumeNewlines(false);
                _this.expectStatementSeparator$1("@forward rule");
                span = _this.spanFrom$1(start);
                if (!_this._stylesheet0$_isUseAllowed) _this.error$2(0, string$.x40forwa, span);
                if (shownMixinsAndFunctions != null) {
                    shownVariables.toString;
                    t1 = type$.String;
                    t2 = A.LinkedHashSet_LinkedHashSet$of(shownMixinsAndFunctions, t1);
                    t3 = type$.UnmodifiableSetView_String;
                    t1 = A.LinkedHashSet_LinkedHashSet$of(shownVariables, t1);
                    t4 = configuration == null ? B.List_empty26 : A.List_List$unmodifiable(configuration, type$.ConfiguredVariable_2);
                    return new A.ForwardRule0(url, new A.UnmodifiableSetView0(t2, t3), new A.UnmodifiableSetView0(t1, t3), _null, _null, prefix, t4, span);
                } else if (hiddenMixinsAndFunctions != null) {
                    hiddenVariables.toString;
                    t1 = type$.String;
                    t2 = A.LinkedHashSet_LinkedHashSet$of(hiddenMixinsAndFunctions, t1);
                    t3 = type$.UnmodifiableSetView_String;
                    t1 = A.LinkedHashSet_LinkedHashSet$of(hiddenVariables, t1);
                    t4 = configuration == null ? B.List_empty26 : A.List_List$unmodifiable(configuration, type$.ConfiguredVariable_2);
                    return new A.ForwardRule0(url, _null, _null, new A.UnmodifiableSetView0(t2, t3), new A.UnmodifiableSetView0(t1, t3), prefix, t4, span);
                } else return new A.ForwardRule0(url, _null, _null, _null, _null, prefix, configuration == null ? B.List_empty26 : A.List_List$unmodifiable(configuration, type$.ConfiguredVariable_2), span);
            },
            _stylesheet0$_memberList$0: function() {
                var _this = this, t1 = type$.String, identifiers = A.LinkedHashSet_LinkedHashSet$_empty(t1), variables = A.LinkedHashSet_LinkedHashSet$_empty(t1);
                t1 = _this.scanner;
                do {
                    _this.whitespace$1$consumeNewlines(true);
                    _this.withErrorMessage$2(string$.Expectv, new A.StylesheetParser__memberList_closure0(_this, variables, identifiers));
                    _this.whitespace$1$consumeNewlines(false);
                }while (t1.scanChar$1(44));
                return new A._Record_2(identifiers, variables);
            },
            _stylesheet0$_ifRule$2: function(start, child) {
                var ifIndentation, wasInControlDirective, condition, children, clauses, lastClause, span, _this = this;
                _this.whitespace$1$consumeNewlines(true);
                ifIndentation = _this.get$currentIndentation();
                wasInControlDirective = _this._stylesheet0$_inControlDirective;
                _this._stylesheet0$_inControlDirective = true;
                condition = _this._stylesheet0$_expression$0();
                children = _this.children$1(0, child);
                _this.whitespaceWithoutComments$1$consumeNewlines(false);
                clauses = A._setArrayType([
                    A.IfClause$0(condition, children)
                ], type$.JSArray_IfClause_2);
                for(;;){
                    if (!_this.scanElse$1(ifIndentation)) {
                        lastClause = null;
                        break;
                    }
                    _this.whitespace$1$consumeNewlines(false);
                    if (_this.scanIdentifier$1("if")) {
                        _this.whitespace$1$consumeNewlines(true);
                        clauses.push(A.IfClause$0(_this._stylesheet0$_expression$0(), _this.children$1(0, child)));
                    } else {
                        lastClause = A.ElseClause$0(_this.children$1(0, child));
                        break;
                    }
                }
                _this._stylesheet0$_inControlDirective = wasInControlDirective;
                span = _this.spanFrom$1(start);
                _this.whitespaceWithoutComments$1$consumeNewlines(false);
                return new A.IfRule0(A.List_List$unmodifiable(clauses, type$.IfClause_2), lastClause, span);
            },
            _stylesheet0$_importRule$1: function(start) {
                var argument, t3, _this = this, imports = A._setArrayType([], type$.JSArray_Import_2), t1 = _this.scanner, t2 = _this.warnings;
                do {
                    _this.whitespace$1$consumeNewlines(false);
                    argument = _this.importArgument$0();
                    t3 = argument instanceof A.DynamicImport0;
                    if (t3) t2.push(new A._Record_3_deprecation_message_span(B.Deprecation_L3L, string$.Sass__i, argument.span));
                    if ((_this._stylesheet0$_inControlDirective || _this._stylesheet0$_inMixin) && t3) _this._stylesheet0$_disallowedAtRule$1(start);
                    imports.push(argument);
                    _this.whitespace$1$consumeNewlines(false);
                }while (t1.scanChar$1(44));
                _this.expectStatementSeparator$1("@import rule");
                t1 = _this.spanFrom$1(start);
                return new A.ImportRule0(A.List_List$unmodifiable(imports, type$.Import_2), t1);
            },
            importArgument$0: function() {
                var url, urlSpan, innerError, stackTrace, modifiers, _$exception, _this = this, t1 = _this.scanner, start = new A._SpanScannerState(t1, t1._string_scanner$_position), _0_0 = t1.peekChar$0();
                if (117 === _0_0 || 85 === _0_0) {
                    url = _this.dynamicUrl$0();
                    _this.whitespace$1$consumeNewlines(false);
                    modifiers = _this.tryImportModifiers$0();
                    t1 = url instanceof A.StringExpression0 ? url.text : A.Interpolation$0(A._setArrayType([
                        url
                    ], type$.JSArray_Object), A._setArrayType([
                        url.get$span(url)
                    ], type$.JSArray_nullable_FileSpan), url.get$span(url));
                    return new A.StaticImport0(t1, modifiers, _this.spanFrom$1(start));
                }
                url = _this.string$0();
                urlSpan = _this.spanFrom$1(start);
                _this.whitespace$1$consumeNewlines(false);
                modifiers = _this.tryImportModifiers$0();
                if (_this.isPlainImportUrl$1(url) || modifiers != null) return new A.StaticImport0(new A.Interpolation0(A.List_List$unmodifiable([
                    urlSpan.get$text()
                ], type$.Object), B.List_null, urlSpan), modifiers, _this.spanFrom$1(start));
                else try {
                    t1 = _this.parseImportUrl$1(url);
                    return new A.DynamicImport0(t1, urlSpan);
                } catch (exception) {
                    t1 = A.unwrapException(exception);
                    if (type$.FormatException._is(t1)) {
                        innerError = t1;
                        stackTrace = A.getTraceFromException(exception);
                        _this.error$3(0, "Invalid URL: " + J.get$message$x(innerError), urlSpan, stackTrace);
                    } else throw exception;
                }
            },
            parseImportUrl$1: function(url) {
                var t1 = $.$get$windows();
                if (t1.style.rootLength$1(url) > 0 && !$.$get$url().style.isRootRelative$1(url)) return t1.toUri$1(url).toString$0(0);
                A.Uri_parse(url);
                return url;
            },
            isPlainImportUrl$1: function(url) {
                var _0_0, t1;
                if (url.length < 5) return false;
                if (B.JSString_methods.endsWith$1(url, ".css")) return true;
                _0_0 = url.charCodeAt(0);
                $label0$0: {
                    if (47 === _0_0) {
                        t1 = url.charCodeAt(1) === 47;
                        break $label0$0;
                    }
                    if (104 === _0_0) {
                        t1 = B.JSString_methods.startsWith$1(url, "http://") || B.JSString_methods.startsWith$1(url, "https://");
                        break $label0$0;
                    }
                    t1 = false;
                    break $label0$0;
                }
                return t1;
            },
            tryImportModifiers$0: function() {
                var t1, start, t2, t3, t4, buffer, t5, identifier, $name, query, t6, _this = this;
                if (!_this._stylesheet0$_lookingAtInterpolatedIdentifier$0() && _this.scanner.peekChar$0() !== 40) return null;
                t1 = _this.scanner;
                start = new A._SpanScannerState(t1, t1._string_scanner$_position);
                t2 = new A.StringBuffer("");
                t3 = A._setArrayType([], type$.JSArray_Object);
                t4 = A._setArrayType([], type$.JSArray_nullable_FileSpan);
                buffer = new A.InterpolationBuffer0(t2, t3, t4);
                for(;;)if (_this._stylesheet0$_lookingAtInterpolatedIdentifier$0()) {
                    if (!(t3.length === 0 && t2._contents.length === 0)) {
                        t5 = A.Primitives_stringFromCharCode(32);
                        t2._contents += t5;
                    }
                    identifier = _this.interpolatedIdentifier$0();
                    buffer.addInterpolation$1(identifier);
                    t5 = identifier.get$asPlain();
                    $name = t5 == null ? null : t5.toLowerCase();
                    if ($name !== "and" && t1.scanChar$1(40)) {
                        if ($name === "supports") {
                            query = _this._stylesheet0$_importSupportsQuery$0();
                            t5 = !(query instanceof A.SupportsDeclaration0);
                            if (t5) {
                                t6 = A.Primitives_stringFromCharCode(40);
                                t2._contents += t6;
                            }
                            t6 = query.get$span(query);
                            buffer._interpolation_buffer0$_flushText$0();
                            t3.push(new A.SupportsExpression0(query));
                            t4.push(t6);
                            if (t5) {
                                t5 = A.Primitives_stringFromCharCode(41);
                                t2._contents += t5;
                            }
                        } else {
                            t5 = A.Primitives_stringFromCharCode(40);
                            t2._contents += t5;
                            buffer.addInterpolation$1(_this._stylesheet0$_interpolatedDeclarationValue$3$allowEmpty$allowSemicolon$consumeNewlines(true, true, true));
                            t5 = A.Primitives_stringFromCharCode(41);
                            t2._contents += t5;
                        }
                        t1.expectChar$1(41);
                        _this.whitespace$1$consumeNewlines(false);
                    } else {
                        _this.whitespace$1$consumeNewlines(false);
                        if (t1.scanChar$1(44)) {
                            t2._contents += ", ";
                            buffer.addInterpolation$1(_this._stylesheet0$_mediaQueryList$0());
                            return buffer.interpolation$1(_this.spanFrom$1(start));
                        }
                    }
                } else if (t1.peekChar$0() === 40) {
                    if (!(t3.length === 0 && t2._contents.length === 0)) {
                        t1 = A.Primitives_stringFromCharCode(32);
                        t2._contents += t1;
                    }
                    buffer.addInterpolation$1(_this._stylesheet0$_mediaQueryList$0());
                    return buffer.interpolation$1(_this.spanFrom$1(start));
                } else return buffer.interpolation$1(_this.spanFrom$1(start));
            },
            _stylesheet0$_importSupportsQuery$0: function() {
                var t1, t2, _0_0, $name, _this = this;
                _this.whitespace$1$consumeNewlines(true);
                if (_this.scanIdentifier$1("not")) {
                    _this.whitespace$1$consumeNewlines(true);
                    t1 = _this.scanner;
                    t2 = t1._string_scanner$_position;
                    return new A.SupportsNegation0(_this._stylesheet0$_supportsConditionInParens$0(), _this.spanFrom$1(new A._SpanScannerState(t1, t2)));
                } else {
                    t1 = _this.scanner;
                    if (t1.peekChar$0() === 40) return _this._stylesheet0$_supportsCondition$1$inParentheses(true);
                    else {
                        _0_0 = _this._stylesheet0$_tryImportSupportsFunction$0();
                        if (_0_0 != null) return _0_0;
                        t2 = t1._string_scanner$_position;
                        $name = _this._stylesheet0$_expression$1$consumeNewlines(true);
                        t1.expectChar$1(58);
                        return new A.SupportsDeclaration0($name, _this._stylesheet0$_supportsDeclarationValue$1($name), _this.spanFrom$1(new A._SpanScannerState(t1, t2)));
                    }
                }
            },
            _stylesheet0$_tryImportSupportsFunction$0: function() {
                var t1, start, $name, value, _this = this;
                if (!_this._stylesheet0$_lookingAtInterpolatedIdentifier$0()) return null;
                t1 = _this.scanner;
                start = new A._SpanScannerState(t1, t1._string_scanner$_position);
                $name = _this.interpolatedIdentifier$0();
                if (!t1.scanChar$1(40)) {
                    t1.set$state(start);
                    return null;
                }
                value = _this._stylesheet0$_interpolatedDeclarationValue$3$allowEmpty$allowSemicolon$consumeNewlines(true, true, true);
                t1.expectChar$1(41);
                return new A.SupportsFunction0($name, value, _this.spanFrom$1(start));
            },
            _stylesheet0$_includeRule$1: function(start) {
                var $name, t1, name0, namespace, $arguments, t2, t3, contentParameters, contentParameters_, wasInContentBlock, $content, span, _this = this, _null = null;
                _this.whitespace$1$consumeNewlines(true);
                $name = _this.identifier$0();
                t1 = _this.scanner;
                if (t1.scanChar$1(46)) {
                    name0 = _this._stylesheet0$_publicIdentifier$0();
                    namespace = $name;
                    $name = name0;
                } else namespace = _null;
                _this.whitespace$1$consumeNewlines(false);
                if (t1.peekChar$0() === 40) $arguments = _this._stylesheet0$_argumentInvocation$1$mixin(true);
                else {
                    t2 = A.FileLocation$_(t1._sourceFile, t1._string_scanner$_position);
                    t3 = t2.offset;
                    $arguments = A.ArgumentList$empty0(A._FileSpan$(t2.file, t3, t3));
                }
                _this.whitespace$1$consumeNewlines(false);
                if (_this.scanIdentifier$1("using")) {
                    _this.whitespace$1$consumeNewlines(true);
                    contentParameters = _this._stylesheet0$_parameterList$0();
                    _this.whitespace$1$consumeNewlines(false);
                } else contentParameters = _null;
                t2 = contentParameters == null;
                if (!t2 || _this.lookingAtChildren$0()) {
                    if (t2) {
                        t1 = A.FileLocation$_(t1._sourceFile, t1._string_scanner$_position);
                        t2 = t1.offset;
                        contentParameters_ = new A.ParameterList0(B.List_empty27, _null, A._FileSpan$(t1.file, t2, t2));
                    } else contentParameters_ = contentParameters;
                    wasInContentBlock = _this._stylesheet0$_inContentBlock;
                    _this._stylesheet0$_inContentBlock = true;
                    $content = _this._stylesheet0$_withChildren$3(_this.get$_stylesheet0$_statement(), start, new A.StylesheetParser__includeRule_closure0(contentParameters_));
                    _this._stylesheet0$_inContentBlock = wasInContentBlock;
                } else {
                    _this.expectStatementSeparator$0();
                    $content = _null;
                }
                t1 = _this.spanFrom$2(start, start);
                t2 = $content == null ? $arguments : $content;
                span = t1.expand$1(0, t2.get$span(t2));
                return new A.IncludeRule0(namespace, A.stringReplaceAllUnchecked($name, "_", "-"), $name, $arguments, $content, span);
            },
            mediaRule$1: function(start) {
                var _this = this;
                _this.whitespace$1$consumeNewlines(false);
                return _this._stylesheet0$_withChildren$3(_this.get$_stylesheet0$_statement(), start, new A.StylesheetParser_mediaRule_closure0(_this._stylesheet0$_mediaQueryList$0()));
            },
            _stylesheet0$_mixinRule$1: function(start) {
                var precedingComment, t1, t2, $name, parameters, _this = this;
                _this.whitespace$1$consumeNewlines(true);
                precedingComment = _this.lastSilentComment;
                _this.lastSilentComment = null;
                t1 = _this.scanner;
                t2 = t1._string_scanner$_position;
                $name = _this.identifier$0();
                if (B.JSString_methods.startsWith$1($name, "--")) _this.error$2(0, string$.Sass__m, _this.spanFrom$1(new A._SpanScannerState(t1, t2)));
                _this.whitespace$1$consumeNewlines(false);
                if (t1.peekChar$0() === 40) parameters = _this._stylesheet0$_parameterList$0();
                else {
                    t1 = A.FileLocation$_(t1._sourceFile, t1._string_scanner$_position);
                    t2 = t1.offset;
                    parameters = new A.ParameterList0(B.List_empty27, null, A._FileSpan$(t1.file, t2, t2));
                }
                if (_this._stylesheet0$_inMixin || _this._stylesheet0$_inContentBlock) _this.error$2(0, string$.Mixinscm, _this.spanFrom$1(start));
                else if (_this._stylesheet0$_inControlDirective) _this.error$2(0, string$.Mixinsb, _this.spanFrom$1(start));
                _this.whitespace$1$consumeNewlines(false);
                _this._stylesheet0$_inMixin = true;
                return _this._stylesheet0$_withChildren$3(_this.get$_stylesheet0$_statement(), start, new A.StylesheetParser__mixinRule_closure0(_this, $name, parameters, precedingComment));
            },
            mozDocumentRule$2: function(start, $name) {
                var t1, t2, t3, t4, t5, buffer, _0_0, identifierStart, identifier, _1_0, argument, t6, trailing, start0, end, _this = this, _box_0 = {};
                _this.whitespace$1$consumeNewlines(false);
                t1 = _this.scanner;
                t2 = t1._string_scanner$_position;
                t3 = new A.StringBuffer("");
                t4 = A._setArrayType([], type$.JSArray_Object);
                t5 = A._setArrayType([], type$.JSArray_nullable_FileSpan);
                buffer = new A.InterpolationBuffer0(t3, t4, t5);
                _box_0.needsDeprecationWarning = false;
                for(;;){
                    if (t1.peekChar$0() === 35) {
                        _0_0 = _this.singleInterpolation$0();
                        buffer._interpolation_buffer0$_flushText$0();
                        t4.push(_0_0._0);
                        t5.push(_0_0._1);
                        _box_0.needsDeprecationWarning = true;
                    } else {
                        identifierStart = new A._SpanScannerState(t1, t1._string_scanner$_position);
                        identifier = _this.identifier$0();
                        $label0$0: {
                            if ("url" === identifier || "url-prefix" === identifier || "domain" === identifier) {
                                _1_0 = _this._stylesheet0$_tryUrlContents$2$name(identifierStart, identifier);
                                if (_1_0 != null) buffer.addInterpolation$1(_1_0);
                                else {
                                    t1.expectChar$1(40);
                                    _this.whitespace$1$consumeNewlines(false);
                                    argument = _this.interpolatedStringToken$0();
                                    t1.expectChar$1(41);
                                    t3._contents += identifier;
                                    t6 = A.Primitives_stringFromCharCode(40);
                                    t3._contents += t6;
                                    buffer.addInterpolation$1(argument);
                                    t6 = A.Primitives_stringFromCharCode(41);
                                    t3._contents += t6;
                                }
                                t6 = t3._contents;
                                trailing = t6.charCodeAt(0) == 0 ? t6 : t6;
                                if (!B.JSString_methods.endsWith$1(trailing, "url-prefix()") && !B.JSString_methods.endsWith$1(trailing, "url-prefix('')") && !B.JSString_methods.endsWith$1(trailing, 'url-prefix("")')) _box_0.needsDeprecationWarning = true;
                                break $label0$0;
                            }
                            if ("regexp" === identifier) {
                                t3._contents += "regexp(";
                                t1.expectChar$1(40);
                                buffer.addInterpolation$1(_this.interpolatedStringToken$0());
                                t1.expectChar$1(41);
                                t6 = A.Primitives_stringFromCharCode(41);
                                t3._contents += t6;
                                _box_0.needsDeprecationWarning = true;
                                break $label0$0;
                            }
                            _this.error$2(0, "Invalid function name.", _this.spanFrom$1(identifierStart));
                        }
                    }
                    _this.whitespace$1$consumeNewlines(false);
                    if (!t1.scanChar$1(44)) break;
                    t6 = A.Primitives_stringFromCharCode(44);
                    t3._contents += t6;
                    start0 = t1._string_scanner$_position;
                    new A.StylesheetParser_mozDocumentRule_closure1(_this).call$0();
                    end = t1._string_scanner$_position;
                    t3._contents += B.JSString_methods.substring$2(t1.string, start0, end);
                }
                return _this._stylesheet0$_withChildren$3(_this.get$_stylesheet0$_statement(), start, new A.StylesheetParser_mozDocumentRule_closure2(_box_0, _this, $name, buffer.interpolation$1(_this.spanFrom$1(new A._SpanScannerState(t1, t2)))));
            },
            supportsRule$1: function(start) {
                var condition, _this = this;
                _this.whitespace$1$consumeNewlines(false);
                condition = _this._stylesheet0$_supportsCondition$0();
                _this.whitespace$1$consumeNewlines(false);
                return _this._stylesheet0$_withChildren$3(_this.get$_stylesheet0$_statement(), start, new A.StylesheetParser_supportsRule_closure0(condition));
            },
            _stylesheet0$_useNamespace$2: function(url, start) {
                var namespace, basename, dot, t1, _$exception, _this = this;
                if (_this.scanIdentifier$1("as")) {
                    _this.whitespace$1$consumeNewlines(true);
                    return _this.scanner.scanChar$1(42) ? null : _this.identifier$0();
                }
                basename = url.get$pathSegments().length === 0 ? "" : B.JSArray_methods.get$last(url.get$pathSegments());
                dot = B.JSString_methods.indexOf$1(basename, ".");
                t1 = B.JSString_methods.startsWith$1(basename, "_") ? 1 : 0;
                namespace = B.JSString_methods.substring$2(basename, t1, dot === -1 ? basename.length : dot);
                try {
                    t1 = new A.Parser1(A.SpanScanner$(namespace, null), null)._parser1$_parseIdentifier$0();
                    return t1;
                } catch (exception) {
                    if (type$.SassFormatException_2._is(A.unwrapException(exception))) _this.error$2(0, 'The default namespace "' + A.S(namespace) + string$.x22x20is_n, _this.spanFrom$1(start));
                    else throw exception;
                }
            },
            _stylesheet0$_configuration$1$allowGuarded: function(allowGuarded) {
                var variableNames, configuration, t1, t2, variableStart, $name, expression, t3, guarded, span, _this = this;
                if (!_this.scanIdentifier$1("with")) return null;
                variableNames = A.LinkedHashSet_LinkedHashSet$_empty(type$.String);
                configuration = A._setArrayType([], type$.JSArray_ConfiguredVariable_2);
                _this.whitespace$1$consumeNewlines(true);
                t1 = _this.scanner;
                t1.expectChar$1(40);
                for(t2 = _this.warnings;;){
                    _this.whitespace$1$consumeNewlines(true);
                    variableStart = new A._SpanScannerState(t1, t1._string_scanner$_position);
                    t1.expectChar$1(36);
                    $name = _this.identifier$1$normalize(true);
                    if (B.JSString_methods.startsWith$1($name, "-")) t2.push(new A._Record_3_deprecation_message_span(B.Deprecation_lkJ, string$.Config, _this.spanFrom$1(variableStart)));
                    _this.whitespace$1$consumeNewlines(true);
                    t1.expectChar$1(58);
                    _this.whitespace$1$consumeNewlines(true);
                    expression = _this.expressionUntilComma$0();
                    t3 = t1._string_scanner$_position;
                    if (allowGuarded && t1.scanChar$1(33)) {
                        guarded = _this.identifier$0() === "default";
                        if (guarded) _this.whitespace$1$consumeNewlines(true);
                        else _this.error$2(0, "Invalid flag name.", _this.spanFrom$1(new A._SpanScannerState(t1, t3)));
                    } else guarded = false;
                    span = _this.spanFrom$1(variableStart);
                    if (variableNames.contains$1(0, $name)) _this.error$2(0, string$.The_sa, span);
                    variableNames.add$1(0, $name);
                    configuration.push(new A.ConfiguredVariable0($name, expression, guarded, span));
                    if (!t1.scanChar$1(44)) break;
                    _this.whitespace$1$consumeNewlines(true);
                    if (!_this._stylesheet0$_lookingAtExpression$0()) break;
                }
                t1.expectChar$1(41);
                return configuration;
            },
            _stylesheet0$_configuration$0: function() {
                return this._stylesheet0$_configuration$1$allowGuarded(false);
            },
            _stylesheet0$_warnRule$1: function(start) {
                var value, t1, t2, _this = this;
                _this.whitespace$1$consumeNewlines(true);
                value = _this._stylesheet0$_expression$0();
                t1 = _this.scanner;
                t2 = t1._string_scanner$_position;
                _this.expectStatementSeparator$1("@warn rule");
                return new A.WarnRule0(value, _this.spanFrom$2(start, new A._SpanScannerState(t1, t2)));
            },
            _stylesheet0$_whileRule$2: function(start, child) {
                var wasInControlDirective, _this = this;
                _this.whitespace$1$consumeNewlines(true);
                wasInControlDirective = _this._stylesheet0$_inControlDirective;
                _this._stylesheet0$_inControlDirective = true;
                return _this._stylesheet0$_withChildren$3(child, start, new A.StylesheetParser__whileRule_closure0(_this, wasInControlDirective, _this._stylesheet0$_expression$0()));
            },
            unknownAtRule$2: function(start, $name) {
                var wasInPlainCssFunction, t2, _0_0, t3, _this = this, t1 = {}, wasInUnknownAtRule = _this._stylesheet0$_inUnknownAtRule;
                _this._stylesheet0$_inUnknownAtRule = true;
                _this.whitespace$1$consumeNewlines(false);
                t1.value = null;
                t2 = _this.scanner.peekChar$0() !== 33 && !_this.atEndOfStatement$0() ? t1.value = _this._stylesheet0$_interpolatedDeclarationValue$1$allowOpenBrace(false) : null;
                wasInPlainCssFunction = _this._stylesheet0$_inPlainCssFunction;
                _0_0 = $name.get$asPlain();
                if (_0_0 != null) t3 = A.equalsIgnoreCase0(_0_0, "function");
                else t3 = false;
                if (t3) _this._stylesheet0$_inPlainCssFunction = true;
                try {
                    if (_this.lookingAtChildren$0()) {
                        t1 = _this._stylesheet0$_withChildren$3(_this.get$_stylesheet0$_statement(), start, new A.StylesheetParser_unknownAtRule_closure0(t1, $name));
                        return t1;
                    } else {
                        _this.expectStatementSeparator$0();
                        t1 = A.AtRule$0($name, _this.spanFrom$1(start), null, t2);
                        return t1;
                    }
                } finally{
                    _this._stylesheet0$_inUnknownAtRule = wasInUnknownAtRule;
                    _this._stylesheet0$_inPlainCssFunction = wasInPlainCssFunction;
                }
            },
            _stylesheet0$_disallowedAtRule$1: function(start) {
                var _this = this;
                _this.whitespace$1$consumeNewlines(false);
                _this._stylesheet0$_interpolatedDeclarationValue$2$allowEmpty$allowOpenBrace(true, false);
                _this.error$2(0, "This at-rule is not allowed here.", _this.spanFrom$1(start));
            },
            _stylesheet0$_parameterList$0: function() {
                var parameters, named, restParameter, t3, $name, defaultValue, _this = this, t1 = _this.scanner, t2 = t1._string_scanner$_position;
                t1.expectChar$1(40);
                _this.whitespace$1$consumeNewlines(true);
                parameters = A._setArrayType([], type$.JSArray_Parameter_2);
                named = A.LinkedHashSet_LinkedHashSet$_empty(type$.String);
                while(restParameter = null, t1.peekChar$0() === 36){
                    t3 = t1._string_scanner$_position;
                    t1.expectChar$1(36);
                    $name = _this.identifier$1$normalize(true);
                    _this.whitespace$1$consumeNewlines(true);
                    if (t1.scanChar$1(58)) {
                        _this.whitespace$1$consumeNewlines(true);
                        defaultValue = _this.expressionUntilComma$0();
                    } else {
                        if (t1.scanChar$1(46)) {
                            t1.expectChar$1(46);
                            t1.expectChar$1(46);
                            _this.whitespace$1$consumeNewlines(true);
                            if (t1.scanChar$1(44)) _this.whitespace$1$consumeNewlines(true);
                            restParameter = $name;
                            break;
                        }
                        defaultValue = null;
                    }
                    parameters.push(new A.Parameter0($name, defaultValue, _this.spanFrom$1(new A._SpanScannerState(t1, t3))));
                    if (!named.add$1(0, $name)) _this.error$2(0, "Duplicate parameter.", B.JSArray_methods.get$last(parameters).span);
                    if (!t1.scanChar$1(44)) break;
                    _this.whitespace$1$consumeNewlines(true);
                }
                t1.expectChar$1(41);
                t1 = _this.spanFrom$1(new A._SpanScannerState(t1, t2));
                return new A.ParameterList0(A.List_List$unmodifiable(parameters, type$.Parameter_2), restParameter, t1);
            },
            _stylesheet0$_argumentInvocation$2$allowEmptySecondArg$mixin: function(allowEmptySecondArg, mixin) {
                var positional, t3, named, namedSpans, t4, t5, t6, rest, emittedRestDeprecation, keywordRest, expression, emittedRestDeprecation0, t7, value, t8, result, _this = this, t1 = _this.scanner, t2 = t1._string_scanner$_position;
                t1.expectChar$1(40);
                _this.whitespace$1$consumeNewlines(true);
                positional = A._setArrayType([], type$.JSArray_Expression_2);
                t3 = type$.String;
                named = A.LinkedHashMap_LinkedHashMap$_empty(t3, type$.Expression_2);
                namedSpans = A.LinkedHashMap_LinkedHashMap$_empty(t3, type$.FileSpan);
                for(t4 = !mixin, t5 = _this.warnings, t6 = type$.SourceSpan, rest = null, emittedRestDeprecation = false; keywordRest = null, _this._stylesheet0$_lookingAtExpression$0();){
                    expression = _this.expressionUntilComma$1$singleEquals(t4);
                    _this.whitespace$1$consumeNewlines(true);
                    emittedRestDeprecation0 = true;
                    if (expression instanceof A.VariableExpression0 && t1.scanChar$1(58)) {
                        _this.whitespace$1$consumeNewlines(true);
                        t7 = expression.name;
                        if (named.containsKey$1(t7)) _this.error$2(0, "Duplicate argument.", expression.span);
                        value = _this.expressionUntilComma$1$singleEquals(t4);
                        named.$indexSet(0, t7, value);
                        t8 = expression.span;
                        namedSpans.$indexSet(0, t7, t8.expand$1(0, value.get$span(value)));
                        if (rest != null && !emittedRestDeprecation) {
                            t5.push(new A._Record_3_deprecation_message_span(B.Deprecation_Jgi, string$.Named_, new A.MultiSpan0(_this.spanFromPosition$1(t8.get$start(t8).offset), "named argument", A.ConstantMap_ConstantMap$from(A.LinkedHashMap_LinkedHashMap$_literal([
                                rest.get$span(rest),
                                "rest argument"
                            ], t6, t3), t6, t3))));
                            emittedRestDeprecation = emittedRestDeprecation0;
                        }
                    } else if (t1.scanChar$1(46)) {
                        t1.expectChar$1(46);
                        t1.expectChar$1(46);
                        if (rest != null) {
                            _this.whitespace$1$consumeNewlines(true);
                            if (t1.scanChar$1(44)) _this.whitespace$1$consumeNewlines(true);
                            keywordRest = expression;
                            break;
                        }
                        rest = expression;
                    } else if (named.__js_helper$_length !== 0) _this.error$2(0, string$.Positik, expression.get$span(expression));
                    else {
                        positional.push(expression);
                        if (rest != null && !emittedRestDeprecation) {
                            t5.push(new A._Record_3_deprecation_message_span(B.Deprecation_Jgi, string$.Positir, new A.MultiSpan0(expression.get$span(expression), "positional argument", A.ConstantMap_ConstantMap$from(A.LinkedHashMap_LinkedHashMap$_literal([
                                rest.get$span(rest),
                                "rest argument"
                            ], t6, t3), t6, t3))));
                            emittedRestDeprecation = emittedRestDeprecation0;
                        }
                    }
                    _this.whitespace$1$consumeNewlines(true);
                    if (!t1.scanChar$1(44)) break;
                    _this.whitespace$1$consumeNewlines(true);
                    if (allowEmptySecondArg && positional.length === 1 && named.__js_helper$_length === 0 && rest == null && t1.peekChar$0() === 41) {
                        t3 = t1._sourceFile;
                        t4 = t1._string_scanner$_position;
                        new A.FileLocation(t3, t4).FileLocation$_$2(t3, t4);
                        t5 = new A._FileSpan(t3, t4, t4);
                        t5._FileSpan$3(t3, t4, t4);
                        result = A.List_List$from([
                            ""
                        ], false, type$.Object);
                        result.$flags = 3;
                        positional.push(new A.StringExpression0(new A.Interpolation0(result, B.List_null, t5), false));
                        break;
                    }
                }
                t1.expectChar$1(41);
                return A.ArgumentList$0(positional, named, namedSpans, _this.spanFrom$1(new A._SpanScannerState(t1, t2)), keywordRest, rest);
            },
            _stylesheet0$_argumentInvocation$0: function() {
                return this._stylesheet0$_argumentInvocation$2$allowEmptySecondArg$mixin(false, false);
            },
            _stylesheet0$_argumentInvocation$1$allowEmptySecondArg: function(allowEmptySecondArg) {
                return this._stylesheet0$_argumentInvocation$2$allowEmptySecondArg$mixin(allowEmptySecondArg, false);
            },
            _stylesheet0$_argumentInvocation$1$mixin: function(mixin) {
                return this._stylesheet0$_argumentInvocation$2$allowEmptySecondArg$mixin(false, mixin);
            },
            _stylesheet0$_expression$4$bracketList$consumeNewlines$singleEquals$until: function(bracketList, consumeNewlines, singleEquals, until) {
                var t2, beforeBracket, start, wasInExpression, wasInParentheses, resetState, resolveOneOperation, resolveOperations, addSingleExpression, addOperator, resolveSpaceExpressions, t3, t4, _3_0, _1_0, t5, _3_28, _2_0, _3_32, _3_40, commaExpressions, spaceExpressions, singleExpression, _this = this, _s20_ = "Expected expression.", _box_0 = {}, t1 = until != null;
                if (t1 && until.call$0()) _this.scanner.error$1(0, _s20_);
                if (bracketList) {
                    t2 = _this.scanner;
                    beforeBracket = new A._SpanScannerState(t2, t2._string_scanner$_position);
                    t2.expectChar$1(91);
                    _this.whitespace$1$consumeNewlines(true);
                    if (t2.scanChar$1(93)) {
                        t1 = A._setArrayType([], type$.JSArray_Expression_2);
                        t2 = _this.spanFrom$1(beforeBracket);
                        return new A.ListExpression0(A.List_List$unmodifiable(t1, type$.Expression_2), B.ListSeparator_undecided_null_3_undecided0, true, t2);
                    }
                } else beforeBracket = null;
                t2 = _this.scanner;
                start = new A._SpanScannerState(t2, t2._string_scanner$_position);
                wasInExpression = _this._stylesheet0$_inExpression;
                wasInParentheses = _this._stylesheet0$_inParentheses;
                _this._stylesheet0$_inExpression = true;
                _box_0.operands_ = _box_0.operators_ = _box_0.spaceExpressions_ = _box_0.commaExpressions_ = null;
                _box_0.allowSlash = true;
                _box_0.singleExpression_ = _this._stylesheet0$_singleExpression$0();
                resetState = new A.StylesheetParser__expression_resetState0(_box_0, _this, start);
                resolveOneOperation = new A.StylesheetParser__expression_resolveOneOperation0(_box_0, _this);
                resolveOperations = new A.StylesheetParser__expression_resolveOperations0(_box_0, resolveOneOperation);
                addSingleExpression = new A.StylesheetParser__expression_addSingleExpression0(_box_0, _this, resetState, resolveOperations);
                addOperator = new A.StylesheetParser__expression_addOperator0(_box_0, _this, resolveOneOperation, addSingleExpression);
                resolveSpaceExpressions = new A.StylesheetParser__expression_resolveSpaceExpressions0(_box_0, _this, resolveOperations);
                for(t3 = !consumeNewlines, t4 = type$.JSArray_Expression_2;;){
                    _this.whitespace$1$consumeNewlines(!t3 || bracketList);
                    if (t1 && until.call$0()) break;
                    _3_0 = t2.peekChar$0();
                    if (_3_0 == null) break;
                    if (40 === _3_0) {
                        addSingleExpression.call$1(_this.parentheses$0());
                        continue;
                    }
                    if (91 === _3_0) {
                        addSingleExpression.call$1(_this._stylesheet0$_expression$1$bracketList(true));
                        continue;
                    }
                    if (36 === _3_0) {
                        addSingleExpression.call$1(_this._stylesheet0$_variable$0());
                        continue;
                    }
                    if (38 === _3_0) {
                        addSingleExpression.call$1(_this._stylesheet0$_selector$0());
                        continue;
                    }
                    if (39 === _3_0 || 34 === _3_0) {
                        addSingleExpression.call$1(_this.interpolatedString$0());
                        continue;
                    }
                    if (35 === _3_0) {
                        addSingleExpression.call$1(_this._stylesheet0$_hashExpression$0());
                        continue;
                    }
                    if (61 === _3_0) {
                        t2.readChar$0();
                        if (singleEquals && t2.peekChar$0() !== 61) addOperator.call$1(B.BinaryOperator_g6F0);
                        else {
                            t2.expectChar$1(61);
                            addOperator.call$1(B.BinaryOperator_K7S0);
                        }
                        continue;
                    }
                    if (33 === _3_0) {
                        $label0$1: {
                            _1_0 = t2.peekChar$1(1);
                            if (61 === _1_0) {
                                t2.readChar$0();
                                t2.readChar$0();
                                addOperator.call$1(B.BinaryOperator_Fv20);
                                break $label0$1;
                            }
                            t5 = true;
                            if (_1_0 != null) {
                                if (105 !== _1_0) {
                                    if (73 !== _1_0) t5 = _1_0 === 32 || _1_0 === 9 || _1_0 === 10 || _1_0 === 13 || _1_0 === 12;
                                }
                            }
                            if (t5) {
                                addSingleExpression.call$1(_this._stylesheet0$_importantExpression$0());
                                break $label0$1;
                            }
                            break;
                        }
                        continue;
                    }
                    if (60 === _3_0) {
                        t2.readChar$0();
                        addOperator.call$1(t2.scanChar$1(61) ? B.BinaryOperator_f2c0 : B.BinaryOperator_CG20);
                        continue;
                    }
                    if (62 === _3_0) {
                        t2.readChar$0();
                        addOperator.call$1(t2.scanChar$1(61) ? B.BinaryOperator_YGt0 : B.BinaryOperator_Tic0);
                        continue;
                    }
                    if (42 === _3_0) {
                        t2.readChar$0();
                        addOperator.call$1(B.BinaryOperator_wkM0);
                        continue;
                    }
                    _3_28 = 43 === _3_0;
                    if (_3_28 && _box_0.singleExpression_ == null) {
                        addSingleExpression.call$1(_this._stylesheet0$_unaryOperation$0());
                        continue;
                    }
                    if (_3_28) {
                        t2.readChar$0();
                        addOperator.call$1(B.BinaryOperator_jCK0);
                        continue;
                    }
                    if (45 === _3_0) {
                        _2_0 = t2.peekChar$1(1);
                        if (A._isInt(_2_0) && _2_0 >= 48 && _2_0 <= 57 || 46 === _2_0) {
                            if (_box_0.singleExpression_ != null) {
                                t5 = t2.peekChar$1(-1);
                                t5 = t5 === 32 || t5 === 9 || t5 === 10 || t5 === 13 || t5 === 12;
                            } else t5 = true;
                        } else t5 = false;
                        if (t5) addSingleExpression.call$1(_this._stylesheet0$_number$0());
                        else if (_this._stylesheet0$_lookingAtInterpolatedIdentifier$0()) addSingleExpression.call$1(_this.identifierLike$0());
                        else if (_box_0.singleExpression_ == null) addSingleExpression.call$1(_this._stylesheet0$_unaryOperation$0());
                        else {
                            t2.readChar$0();
                            addOperator.call$1(B.BinaryOperator_tDf0);
                        }
                        continue;
                    }
                    _3_32 = 47 === _3_0;
                    if (_3_32 && _box_0.singleExpression_ == null) {
                        addSingleExpression.call$1(_this._stylesheet0$_unaryOperation$0());
                        continue;
                    }
                    if (_3_32) {
                        t2.readChar$0();
                        addOperator.call$1(B.BinaryOperator_ehp0);
                        continue;
                    }
                    if (37 === _3_0) {
                        t2.readChar$0();
                        addOperator.call$1(B.BinaryOperator_bgA0);
                        continue;
                    }
                    if (_3_0 >= 48 && _3_0 <= 57) {
                        addSingleExpression.call$1(_this._stylesheet0$_number$0());
                        continue;
                    }
                    _3_40 = 46 === _3_0;
                    if (_3_40 && t2.peekChar$1(1) === 46) break;
                    if (_3_40) {
                        addSingleExpression.call$1(_this._stylesheet0$_number$0());
                        continue;
                    }
                    if (97 === _3_0 && !_this.get$plainCss() && _this.scanIdentifier$1("and")) {
                        addOperator.call$1(B.BinaryOperator_5vK0);
                        continue;
                    }
                    if (111 === _3_0 && !_this.get$plainCss() && _this.scanIdentifier$1("or")) {
                        addOperator.call$1(B.BinaryOperator_OOf0);
                        continue;
                    }
                    if ((117 === _3_0 || 85 === _3_0) && t2.peekChar$1(1) === 43) {
                        addSingleExpression.call$1(_this._stylesheet0$_unicodeRange$0());
                        continue;
                    }
                    if (!(_3_0 >= 97 && _3_0 <= 122)) t5 = _3_0 >= 65 && _3_0 <= 90 || 95 === _3_0 || 92 === _3_0 || _3_0 >= 128;
                    else t5 = true;
                    if (t5) {
                        addSingleExpression.call$1(_this.identifierLike$0());
                        continue;
                    }
                    if (44 === _3_0) {
                        if (_this._stylesheet0$_inParentheses) {
                            _this._stylesheet0$_inParentheses = false;
                            if (_box_0.allowSlash) {
                                resetState.call$0();
                                continue;
                            }
                        }
                        commaExpressions = _box_0.commaExpressions_;
                        if (commaExpressions == null) commaExpressions = _box_0.commaExpressions_ = A._setArrayType([], t4);
                        if (_box_0.singleExpression_ == null) t2.error$1(0, _s20_);
                        resolveSpaceExpressions.call$0();
                        t5 = _box_0.singleExpression_;
                        t5.toString;
                        commaExpressions.push(t5);
                        t2.readChar$0();
                        _box_0.allowSlash = true;
                        _box_0.singleExpression_ = null;
                        continue;
                    }
                    break;
                }
                if (bracketList) t2.expectChar$1(93);
                commaExpressions = _box_0.commaExpressions_;
                spaceExpressions = _box_0.spaceExpressions_;
                if (commaExpressions != null) {
                    resolveSpaceExpressions.call$0();
                    _this._stylesheet0$_inParentheses = wasInParentheses;
                    singleExpression = _box_0.singleExpression_;
                    if (singleExpression != null) commaExpressions.push(singleExpression);
                    _this._stylesheet0$_inExpression = wasInExpression;
                    t1 = _this.spanFrom$1(beforeBracket == null ? start : beforeBracket);
                    return new A.ListExpression0(A.List_List$unmodifiable(commaExpressions, type$.Expression_2), B.ListSeparator_z0K0, bracketList, t1);
                } else if (bracketList && spaceExpressions != null) {
                    resolveOperations.call$0();
                    _this._stylesheet0$_inExpression = wasInExpression;
                    t1 = _box_0.singleExpression_;
                    t1.toString;
                    spaceExpressions.push(t1);
                    beforeBracket.toString;
                    t1 = _this.spanFrom$1(beforeBracket);
                    return new A.ListExpression0(A.List_List$unmodifiable(spaceExpressions, type$.Expression_2), B.ListSeparator_SrV0, true, t1);
                } else {
                    resolveSpaceExpressions.call$0();
                    if (bracketList) {
                        t1 = _box_0.singleExpression_;
                        t1.toString;
                        t4 = A._setArrayType([
                            t1
                        ], t4);
                        beforeBracket.toString;
                        t1 = _this.spanFrom$1(beforeBracket);
                        _box_0.singleExpression_ = new A.ListExpression0(A.List_List$unmodifiable(t4, type$.Expression_2), B.ListSeparator_undecided_null_3_undecided0, true, t1);
                    }
                    _this._stylesheet0$_inExpression = wasInExpression;
                    t1 = _box_0.singleExpression_;
                    t1.toString;
                    return t1;
                }
            },
            _stylesheet0$_expression$3$consumeNewlines$singleEquals$until: function(consumeNewlines, singleEquals, until) {
                return this._stylesheet0$_expression$4$bracketList$consumeNewlines$singleEquals$until(false, consumeNewlines, singleEquals, until);
            },
            _stylesheet0$_expression$1$bracketList: function(bracketList) {
                return this._stylesheet0$_expression$4$bracketList$consumeNewlines$singleEquals$until(bracketList, false, false, null);
            },
            _stylesheet0$_expression$0: function() {
                return this._stylesheet0$_expression$4$bracketList$consumeNewlines$singleEquals$until(false, false, false, null);
            },
            _stylesheet0$_expression$1$consumeNewlines: function(consumeNewlines) {
                return this._stylesheet0$_expression$4$bracketList$consumeNewlines$singleEquals$until(false, consumeNewlines, false, null);
            },
            _stylesheet0$_expression$2$consumeNewlines$until: function(consumeNewlines, until) {
                return this._stylesheet0$_expression$4$bracketList$consumeNewlines$singleEquals$until(false, consumeNewlines, false, until);
            },
            expressionUntilComma$1$singleEquals: function(singleEquals) {
                return this._stylesheet0$_expression$3$consumeNewlines$singleEquals$until(true, singleEquals, new A.StylesheetParser_expressionUntilComma_closure0(this));
            },
            expressionUntilComma$0: function() {
                return this.expressionUntilComma$1$singleEquals(false);
            },
            _stylesheet0$_isSlashOperand$1: function(expression) {
                var t1 = true;
                if (!(expression instanceof A.NumberExpression0)) {
                    if (!(expression instanceof A.FunctionExpression0)) t1 = expression instanceof A.BinaryOperationExpression0 && expression.allowsSlash;
                }
                return t1;
            },
            _stylesheet0$_singleExpression$0: function() {
                var next, t2, _this = this, _s20_ = "Expected expression.", t1 = _this.scanner, _0_0 = t1.peekChar$0();
                $label0$0: {
                    if (_0_0 == null) t1.error$1(0, _s20_);
                    if (40 === _0_0) {
                        t1 = _this.parentheses$0();
                        break $label0$0;
                    }
                    if (47 === _0_0) {
                        t1 = _this._stylesheet0$_unaryOperation$0();
                        break $label0$0;
                    }
                    if (46 === _0_0) {
                        t1 = _this._stylesheet0$_number$0();
                        break $label0$0;
                    }
                    if (91 === _0_0) {
                        t1 = _this._stylesheet0$_expression$1$bracketList(true);
                        break $label0$0;
                    }
                    if (36 === _0_0) {
                        t1 = _this._stylesheet0$_variable$0();
                        break $label0$0;
                    }
                    if (38 === _0_0) {
                        t1 = _this._stylesheet0$_selector$0();
                        break $label0$0;
                    }
                    if (39 === _0_0 || 34 === _0_0) {
                        t1 = _this.interpolatedString$0();
                        break $label0$0;
                    }
                    if (35 === _0_0) {
                        t1 = _this._stylesheet0$_hashExpression$0();
                        break $label0$0;
                    }
                    if (43 === _0_0) {
                        next = t1.peekChar$1(1);
                        t1 = next != null && next >= 48 && next <= 57 || next === 46 ? _this._stylesheet0$_number$0() : _this._stylesheet0$_unaryOperation$0();
                        break $label0$0;
                    }
                    if (45 === _0_0) {
                        t1 = _this._stylesheet0$_minusExpression$0();
                        break $label0$0;
                    }
                    if (33 === _0_0) {
                        t1 = _this._stylesheet0$_importantExpression$0();
                        break $label0$0;
                    }
                    if (37 === _0_0) {
                        t2 = t1._string_scanner$_position;
                        t1.readChar$0();
                        t2 = _this.spanFrom$1(new A._SpanScannerState(t1, t2));
                        t2 = new A.StringExpression0(new A.Interpolation0(A.List_List$unmodifiable([
                            "%"
                        ], type$.Object), B.List_null, t2), false);
                        t1 = t2;
                        break $label0$0;
                    }
                    if ((117 === _0_0 || 85 === _0_0) && t1.peekChar$1(1) === 43) {
                        t1 = _this._stylesheet0$_unicodeRange$0();
                        break $label0$0;
                    }
                    if (_0_0 >= 48 && _0_0 <= 57) {
                        t1 = _this._stylesheet0$_number$0();
                        break $label0$0;
                    }
                    if (!(_0_0 >= 97 && _0_0 <= 122)) t2 = _0_0 >= 65 && _0_0 <= 90 || 95 === _0_0 || 92 === _0_0 || _0_0 >= 128;
                    else t2 = true;
                    if (t2) {
                        t1 = _this.identifierLike$0();
                        break $label0$0;
                    }
                    t1 = t1.error$1(0, _s20_);
                }
                return t1;
            },
            parentheses$0: function() {
                var start, inside, first, expressions, list, t1, t2, _this = this, wasInParentheses = _this._stylesheet0$_inParentheses;
                _this._stylesheet0$_inParentheses = true;
                try {
                    t1 = _this.scanner;
                    start = new A._SpanScannerState(t1, t1._string_scanner$_position);
                    t1.expectChar$1(40);
                    _this.whitespace$1$consumeNewlines(true);
                    inside = new A._SpanScannerState(t1, t1._string_scanner$_position);
                    if (!_this._stylesheet0$_lookingAtExpression$0()) {
                        t1.expectChar$1(41);
                        t1 = A._setArrayType([], type$.JSArray_Expression_2);
                        t2 = _this.spanFrom$1(start);
                        t1 = A.List_List$unmodifiable(t1, type$.Expression_2);
                        return new A.ListExpression0(t1, B.ListSeparator_undecided_null_3_undecided0, false, t2);
                    }
                    first = _this.expressionUntilComma$0();
                    if (t1.scanChar$1(58)) {
                        _this.whitespace$1$consumeNewlines(true);
                        t1 = _this._stylesheet0$_map$2(first, start);
                        return t1;
                    }
                    if (!t1.scanChar$1(44)) {
                        t1.expectChar$1(41);
                        t1 = _this.spanFrom$1(start);
                        return new A.ParenthesizedExpression0(first, t1);
                    }
                    _this.whitespace$1$consumeNewlines(true);
                    expressions = A._setArrayType([
                        first
                    ], type$.JSArray_Expression_2);
                    for(;;){
                        if (!_this._stylesheet0$_lookingAtExpression$0()) break;
                        J.add$1$ax(expressions, _this.expressionUntilComma$0());
                        if (!t1.scanChar$1(44)) break;
                        _this.whitespace$1$consumeNewlines(true);
                    }
                    t2 = _this.spanFrom$1(inside);
                    list = new A.ListExpression0(A.List_List$unmodifiable(expressions, type$.Expression_2), B.ListSeparator_z0K0, false, t2);
                    t1.expectChar$1(41);
                    t1 = _this.spanFrom$1(start);
                    return new A.ParenthesizedExpression0(list, t1);
                } finally{
                    _this._stylesheet0$_inParentheses = wasInParentheses;
                }
            },
            _stylesheet0$_map$2: function(first, start) {
                var t1, key, _this = this, pairs = A._setArrayType([
                    new A._Record_2(first, _this.expressionUntilComma$0())
                ], type$.JSArray_Record_2_Expression_and_Expression_2);
                for(t1 = _this.scanner; t1.scanChar$1(44);){
                    _this.whitespace$1$consumeNewlines(true);
                    if (!_this._stylesheet0$_lookingAtExpression$0()) break;
                    key = _this.expressionUntilComma$0();
                    t1.expectChar$1(58);
                    _this.whitespace$1$consumeNewlines(true);
                    pairs.push(new A._Record_2(key, _this.expressionUntilComma$0()));
                }
                t1.expectChar$1(41);
                t1 = _this.spanFrom$1(start);
                return new A.MapExpression0(A.List_List$unmodifiable(pairs, type$.Record_2_Expression_and_Expression_2), t1);
            },
            _stylesheet0$_hashExpression$0: function() {
                var start, t2, identifier, buffer, _this = this, t1 = _this.scanner;
                if (t1.peekChar$1(1) === 123) return _this.identifierLike$0();
                start = new A._SpanScannerState(t1, t1._string_scanner$_position);
                t1.expectChar$1(35);
                t2 = t1.peekChar$0();
                if (t2 == null) t2 = null;
                else t2 = t2 >= 48 && t2 <= 57;
                if (t2 === true) return new A.ColorExpression0(_this._stylesheet0$_hexColorContents$1(start), _this.spanFrom$1(start));
                t2 = t1._string_scanner$_position;
                identifier = _this.interpolatedIdentifier$0();
                if (_this._stylesheet0$_isHexColor$1(identifier)) {
                    t1.set$state(new A._SpanScannerState(t1, t2));
                    return new A.ColorExpression0(_this._stylesheet0$_hexColorContents$1(start), _this.spanFrom$1(start));
                }
                t1 = new A.StringBuffer("");
                buffer = new A.InterpolationBuffer0(t1, A._setArrayType([], type$.JSArray_Object), A._setArrayType([], type$.JSArray_nullable_FileSpan));
                t2 = A.Primitives_stringFromCharCode(35);
                t1._contents += t2;
                buffer.addInterpolation$1(identifier);
                return new A.StringExpression0(buffer.interpolation$1(_this.spanFrom$1(start)), false);
            },
            _stylesheet0$_hexColorContents$1: function(start) {
                var red, green, blue, alpha, digit4, t2, t3, t4, _this = this, digit1 = _this._stylesheet0$_hexDigit$0(), digit2 = _this._stylesheet0$_hexDigit$0(), digit3 = _this._stylesheet0$_hexDigit$0(), t1 = _this.scanner, $self = t1.peekChar$0();
                if (!($self != null && A.CharacterExtension_get_isHex0($self))) {
                    red = (digit1 << 4 >>> 0) + digit1;
                    green = (digit2 << 4 >>> 0) + digit2;
                    blue = (digit3 << 4 >>> 0) + digit3;
                    alpha = null;
                } else {
                    digit4 = _this._stylesheet0$_hexDigit$0();
                    $self = t1.peekChar$0();
                    t2 = $self != null && A.CharacterExtension_get_isHex0($self);
                    t3 = digit1 << 4 >>> 0;
                    t4 = digit3 << 4 >>> 0;
                    if (!t2) {
                        red = t3 + digit1;
                        green = (digit2 << 4 >>> 0) + digit2;
                        blue = t4 + digit3;
                        alpha = ((digit4 << 4 >>> 0) + digit4) / 255;
                    } else {
                        red = t3 + digit2;
                        green = t4 + digit4;
                        blue = (_this._stylesheet0$_hexDigit$0() << 4 >>> 0) + _this._stylesheet0$_hexDigit$0();
                        $self = t1.peekChar$0();
                        alpha = $self != null && A.CharacterExtension_get_isHex0($self) ? ((_this._stylesheet0$_hexDigit$0() << 4 >>> 0) + _this._stylesheet0$_hexDigit$0()) / 255 : null;
                    }
                }
                t1 = alpha == null;
                t2 = t1 ? 1 : alpha;
                return A.SassColor_SassColor$rgbInternal0(red, green, blue, t2, t1 ? new A.SpanColorFormat0(_this.spanFrom$1(start)) : null);
            },
            _stylesheet0$_isHexColor$1: function(interpolation) {
                var _0_2, t1, plain = interpolation.get$asPlain();
                if (typeof plain == "string") {
                    _0_2 = plain.length;
                    t1 = true;
                    if (3 !== _0_2) {
                        if (4 !== _0_2) {
                            if (6 !== _0_2) t1 = 8 === _0_2;
                        }
                    }
                } else t1 = false;
                if (t1) {
                    t1 = new A.CodeUnits(plain);
                    return t1.every$1(t1, new A.StylesheetParser__isHexColor_closure0());
                } else return false;
            },
            _stylesheet0$_hexDigit$0: function() {
                var t1 = this.scanner, t2 = t1.peekChar$0();
                t2 = t2 == null ? null : A.CharacterExtension_get_isHex0(t2);
                return t2 === true ? A.asHex0(t1.readChar$0()) : t1.error$1(0, "Expected hex digit.");
            },
            _stylesheet0$_minusExpression$0: function() {
                var _this = this, _0_0 = _this.scanner.peekChar$1(1);
                if (A._isInt(_0_0) && _0_0 >= 48 && _0_0 <= 57 || 46 === _0_0) return _this._stylesheet0$_number$0();
                if (_this._stylesheet0$_lookingAtInterpolatedIdentifier$0()) return _this.identifierLike$0();
                return _this._stylesheet0$_unaryOperation$0();
            },
            _stylesheet0$_importantExpression$0: function() {
                var _this = this, t1 = _this.scanner, t2 = t1._string_scanner$_position;
                t1.readChar$0();
                _this.whitespace$1$consumeNewlines(true);
                _this.expectIdentifier$1("important");
                t2 = _this.spanFrom$1(new A._SpanScannerState(t1, t2));
                return new A.StringExpression0(new A.Interpolation0(A.List_List$unmodifiable([
                    "!important"
                ], type$.Object), B.List_null, t2), false);
            },
            _stylesheet0$_unaryOperation$0: function() {
                var _this = this, t1 = _this.scanner, t2 = t1._string_scanner$_position, operator = _this._stylesheet0$_unaryOperatorFor$1(t1.readChar$0());
                if (operator == null) t1.error$2$position(0, "Expected unary operator.", t1._string_scanner$_position - 1);
                else if (_this.get$plainCss() && operator !== B.UnaryOperator_Y930) t1.error$3$length$position(0, "Operators aren't allowed in plain CSS.", 1, t1._string_scanner$_position - 1);
                _this.whitespace$1$consumeNewlines(true);
                return new A.UnaryOperationExpression0(operator, _this._stylesheet0$_singleExpression$0(), _this.spanFrom$1(new A._SpanScannerState(t1, t2)));
            },
            _stylesheet0$_unaryOperatorFor$1: function(character) {
                var t1;
                $label0$0: {
                    if (43 === character) {
                        t1 = B.UnaryOperator_n2K0;
                        break $label0$0;
                    }
                    if (45 === character) {
                        t1 = B.UnaryOperator_hCO0;
                        break $label0$0;
                    }
                    if (47 === character) {
                        t1 = B.UnaryOperator_Y930;
                        break $label0$0;
                    }
                    t1 = null;
                    break $label0$0;
                }
                return t1;
            },
            _stylesheet0$_number$0: function() {
                var number, unit, _this = this, t1 = _this.scanner, t2 = t1._string_scanner$_position, first = t1.peekChar$0(), t3 = first !== 43;
                if (!t3 || first === 45) t1.readChar$0();
                if (t1.peekChar$0() !== 46) _this._stylesheet0$_consumeNaturalNumber$0();
                _this._stylesheet0$_tryDecimal$1$allowTrailingDot(t1._string_scanner$_position !== t2 && t3 && first !== 45);
                _this._stylesheet0$_tryExponent$0();
                number = A.double_parse(t1.substring$1(0, t2));
                if (t1.scanChar$1(37)) unit = "%";
                else {
                    if (_this.lookingAtIdentifier$0()) t3 = t1.peekChar$0() !== 45 || t1.peekChar$1(1) !== 45;
                    else t3 = false;
                    unit = t3 ? _this.identifier$1$unit(true) : null;
                }
                return new A.NumberExpression0(number, unit, _this.spanFrom$1(new A._SpanScannerState(t1, t2)));
            },
            _stylesheet0$_consumeNaturalNumber$0: function() {
                var $self, t1 = this.scanner, t2 = t1.readChar$0();
                if (!(t2 >= 48 && t2 <= 57)) t1.error$2$position(0, "Expected digit.", t1._string_scanner$_position - 1);
                for(;;){
                    $self = t1.peekChar$0();
                    if (!($self != null && $self >= 48 && $self <= 57)) break;
                    t1.readChar$0();
                }
            },
            _stylesheet0$_tryDecimal$1$allowTrailingDot: function(allowTrailingDot) {
                var $self, t1 = this.scanner;
                if (t1.peekChar$0() !== 46) return;
                $self = t1.peekChar$1(1);
                if (!($self != null && $self >= 48 && $self <= 57)) {
                    if (allowTrailingDot) return;
                    t1.error$2$position(0, "Expected digit.", t1._string_scanner$_position + 1);
                }
                t1.readChar$0();
                for(;;){
                    $self = t1.peekChar$0();
                    if (!($self != null && $self >= 48 && $self <= 57)) break;
                    t1.readChar$0();
                }
            },
            _stylesheet0$_tryExponent$0: function() {
                var next, $self, t1 = this.scanner, first = t1.peekChar$0();
                if (first !== 101 && first !== 69) return;
                next = t1.peekChar$1(1);
                if (!(next != null && next >= 48 && next <= 57) && next !== 45 && next !== 43) return;
                t1.readChar$0();
                if (43 === next || 45 === next) t1.readChar$0();
                $self = t1.peekChar$0();
                if (!($self != null && $self >= 48 && $self <= 57)) t1.error$1(0, "Expected digit.");
                for(;;){
                    $self = t1.peekChar$0();
                    if (!($self != null && $self >= 48 && $self <= 57)) break;
                    t1.readChar$0();
                }
            },
            _stylesheet0$_unicodeRange$0: function() {
                var firstRangeLength, hasQuestionMark, t3, secondRangeLength, _this = this, _s26_ = "Expected at most 6 digits.", t1 = _this.scanner, t2 = t1._string_scanner$_position, start = new A._SpanScannerState(t1, t2);
                _this.expectIdentChar$1(117);
                t1.expectChar$1(43);
                for(firstRangeLength = 0; _this.scanCharIf$1(new A.StylesheetParser__unicodeRange_closure1());)++firstRangeLength;
                for(hasQuestionMark = false; t1.scanChar$1(63); hasQuestionMark = true)++firstRangeLength;
                if (firstRangeLength === 0) t1.error$1(0, 'Expected hex digit or "?".');
                else if (firstRangeLength > 6) _this.error$2(0, _s26_, _this.spanFrom$1(start));
                else if (hasQuestionMark) {
                    t1 = t1.substring$1(0, t2);
                    t2 = _this.spanFrom$1(start);
                    return new A.StringExpression0(new A.Interpolation0(A.List_List$unmodifiable([
                        t1
                    ], type$.Object), B.List_null, t2), false);
                }
                if (t1.scanChar$1(45)) {
                    t3 = t1._string_scanner$_position;
                    for(secondRangeLength = 0; _this.scanCharIf$1(new A.StylesheetParser__unicodeRange_closure2());)++secondRangeLength;
                    if (secondRangeLength === 0) t1.error$1(0, "Expected hex digit.");
                    else if (secondRangeLength > 6) _this.error$2(0, _s26_, _this.spanFrom$1(new A._SpanScannerState(t1, t3)));
                }
                if (_this._stylesheet0$_lookingAtInterpolatedIdentifierBody$0()) t1.error$1(0, "Expected end of identifier.");
                t1 = t1.substring$1(0, t2);
                t2 = _this.spanFrom$1(start);
                return new A.StringExpression0(new A.Interpolation0(A.List_List$unmodifiable([
                    t1
                ], type$.Object), B.List_null, t2), false);
            },
            _stylesheet0$_variable$0: function() {
                var _this = this, t1 = _this.scanner, start = new A._SpanScannerState(t1, t1._string_scanner$_position), $name = _this.variableName$0();
                if (_this.get$plainCss()) _this.error$2(0, string$.Sass_v, _this.spanFrom$1(start));
                return new A.VariableExpression0(null, $name, _this.spanFrom$1(start));
            },
            _stylesheet0$_selector$0: function() {
                var t1, start, _this = this;
                if (_this.get$plainCss()) _this.scanner.error$2$length(0, string$.The_pa, 1);
                t1 = _this.scanner;
                start = new A._SpanScannerState(t1, t1._string_scanner$_position);
                t1.expectChar$1(38);
                if (t1.scanChar$1(38)) {
                    _this.warnings.push(new A._Record_3_deprecation_message_span(null, string$.In_Sas, _this.spanFrom$1(start)));
                    t1.set$position(t1._string_scanner$_position - 1);
                }
                return new A.SelectorExpression0(_this.spanFrom$1(start));
            },
            interpolatedString$0: function() {
                var t3, t4, t5, buffer, _1_0, second, t6, _0_0, t1 = this.scanner, t2 = t1._string_scanner$_position, quote = t1.readChar$0();
                if (quote !== 39 && quote !== 34) t1.error$2$position(0, "Expected string.", t2);
                t3 = new A.StringBuffer("");
                t4 = A._setArrayType([], type$.JSArray_Object);
                t5 = A._setArrayType([], type$.JSArray_nullable_FileSpan);
                buffer = new A.InterpolationBuffer0(t3, t4, t5);
                for(;;){
                    _1_0 = t1.peekChar$0();
                    if (_1_0 === quote) {
                        t1.readChar$0();
                        break;
                    }
                    if (_1_0 == null || _1_0 === 10 || _1_0 === 13 || _1_0 === 12) t1.error$1(0, "Expected " + A.Primitives_stringFromCharCode(quote) + ".");
                    if (92 === _1_0) {
                        second = t1.peekChar$1(1);
                        if (second === 10 || second === 13 || second === 12) {
                            t1.readChar$0();
                            t1.readChar$0();
                            if (second === 13) t1.scanChar$1(10);
                        } else {
                            t6 = A.Primitives_stringFromCharCode(A.consumeEscapedCharacter0(t1));
                            t3._contents += t6;
                        }
                        continue;
                    }
                    if (35 === _1_0 && t1.peekChar$1(1) === 123) {
                        _0_0 = this.singleInterpolation$0();
                        buffer._interpolation_buffer0$_flushText$0();
                        t4.push(_0_0._0);
                        t5.push(_0_0._1);
                        continue;
                    }
                    t6 = A.Primitives_stringFromCharCode(t1.readChar$0());
                    t3._contents += t6;
                }
                return new A.StringExpression0(buffer.interpolation$1(this.spanFrom$1(new A._SpanScannerState(t1, t2))), true);
            },
            interpolatedStringToken$0: function() {
                var t3, t4, t5, buffer, t6, _1_0, second, t7, start, end, _0_0, _this = this, t1 = _this.scanner, t2 = t1._string_scanner$_position, quote = t1.readChar$0();
                if (quote !== 39 && quote !== 34) t1.error$2$position(0, "Expected string.", t2);
                t3 = new A.StringBuffer("");
                t4 = A._setArrayType([], type$.JSArray_Object);
                t5 = A._setArrayType([], type$.JSArray_nullable_FileSpan);
                buffer = new A.InterpolationBuffer0(t3, t4, t5);
                t6 = A.Primitives_stringFromCharCode(quote);
                t3._contents += t6;
                for(;;){
                    _1_0 = t1.peekChar$0();
                    if (_1_0 === quote) {
                        t4 = A.Primitives_stringFromCharCode(t1.readChar$0());
                        t3._contents += t4;
                        break;
                    }
                    if (_1_0 == null || _1_0 === 10 || _1_0 === 13 || _1_0 === 12) t1.error$1(0, "Expected " + t6 + ".");
                    if (92 === _1_0) {
                        second = t1.peekChar$1(1);
                        if (second === 10 || second === 13 || second === 12) {
                            t7 = A.Primitives_stringFromCharCode(t1.readChar$0());
                            t3._contents += t7;
                            t7 = A.Primitives_stringFromCharCode(t1.readChar$0());
                            t3._contents += t7;
                            if (second === 13) {
                                if (t1.scanChar$1(10)) {
                                    t7 = A.Primitives_stringFromCharCode(10);
                                    t3._contents += t7;
                                }
                            }
                        } else {
                            start = t1._string_scanner$_position;
                            new A.StylesheetParser_interpolatedStringToken_closure0(_this).call$0();
                            end = t1._string_scanner$_position;
                            t3._contents += B.JSString_methods.substring$2(t1.string, start, end);
                        }
                        continue;
                    }
                    if (35 === _1_0 && t1.peekChar$1(1) === 123) {
                        _0_0 = _this.singleInterpolation$0();
                        buffer._interpolation_buffer0$_flushText$0();
                        t4.push(_0_0._0);
                        t5.push(_0_0._1);
                        continue;
                    }
                    t7 = A.Primitives_stringFromCharCode(t1.readChar$0());
                    t3._contents += t7;
                }
                return buffer.interpolation$1(_this.spanFrom$1(new A._SpanScannerState(t1, t2)));
            },
            identifierLike$0: function() {
                var beforeParen, invocation, expression, t1, _0_0, suggestion, _$exception, _1_0, t4, _2_0, _3_0, _3_2, _3_4, _this = this, t2 = _this.scanner, start = new A._SpanScannerState(t2, t2._string_scanner$_position), identifier = _this.interpolatedIdentifier$0(), plain = identifier.get$asPlain(), lower = A._Cell$(), t3 = plain != null;
                if (t3) {
                    if (plain === "if" && t2.peekChar$0() === 40) {
                        beforeParen = new A._SpanScannerState(t2, t2._string_scanner$_position);
                        try {
                            invocation = _this._stylesheet0$_argumentInvocation$0();
                            expression = new A.LegacyIfExpression0(invocation, identifier.span.expand$1(0, invocation.span));
                            t1 = null;
                            _0_0 = expression.get$modernSuggestion();
                            $label0$0: {
                                suggestion = null;
                                if (_0_0 != null) {
                                    suggestion = _0_0;
                                    t1 = "Suggestion: " + A.S(suggestion) + "\n\n";
                                    break $label0$0;
                                }
                                t1 = "";
                                break $label0$0;
                            }
                            _this.warnings.push(new A._Record_3_deprecation_message_span(B.Deprecation_qka, B.JSString_methods.$add(string$.The_Sa, t1) + string$.More_i, expression.span));
                            return expression;
                        } catch (exception) {
                            if (type$.FormatException._is(A.unwrapException(exception))) {
                                t2.set$state(beforeParen);
                                return _this.ifExpression$1(start);
                            } else throw exception;
                        }
                    } else if (plain.toLowerCase() === "if" && t2.peekChar$0() === 40) return _this.ifExpression$1(start);
                    else if (plain === "not") {
                        _this.whitespace$1$consumeNewlines(true);
                        expression = _this._stylesheet0$_singleExpression$0();
                        return new A.UnaryOperationExpression0(B.UnaryOperator_not_not_3_not0, expression, identifier.span.expand$1(0, expression.get$span(expression)));
                    }
                    lower.__late_helper$_value = plain.toLowerCase();
                    if (t2.peekChar$0() !== 40) {
                        switch(plain){
                            case "false":
                                return new A.BooleanExpression0(false, identifier.span);
                            case "null":
                                return new A.NullExpression0(identifier.span);
                            case "true":
                                return new A.BooleanExpression0(true, identifier.span);
                        }
                        _1_0 = $.$get$colorsByName0().$index(0, lower._readLocal$0());
                        if (_1_0 != null) {
                            t1 = B.JSNumber_methods.round$0(_1_0._color0$_legacyChannel$2(B.RgbColorSpace_i0P0, "red"));
                            t2 = B.JSNumber_methods.round$0(_1_0._color0$_legacyChannel$2(B.RgbColorSpace_i0P0, "green"));
                            t3 = B.JSNumber_methods.round$0(_1_0._color0$_legacyChannel$2(B.RgbColorSpace_i0P0, "blue"));
                            t4 = _1_0.alphaOrNull;
                            if (t4 == null) t4 = 0;
                            return new A.ColorExpression0(A.SassColor_SassColor$rgbInternal0(t1, t2, t3, t4, new A.SpanColorFormat0(identifier.span)), identifier.span);
                        }
                    }
                    _2_0 = _this.trySpecialFunction$2(lower._readLocal$0(), start);
                    if (_2_0 != null) return _2_0;
                }
                _3_0 = t2.peekChar$0();
                _3_2 = 46 === _3_0;
                if (_3_2 && t2.peekChar$1(1) === 46) return new A.StringExpression0(identifier, false);
                if (_3_2) {
                    t2.readChar$0();
                    if (t3) return _this.namespacedExpression$2(plain, start);
                    _this.error$2(0, string$.Interpn, identifier.span);
                }
                _3_4 = 40 === _3_0;
                if (_3_4 && t3) {
                    t1 = _this._stylesheet0$_argumentInvocation$1$allowEmptySecondArg(J.$eq$(lower._readLocal$0(), "var"));
                    t2 = _this.spanFrom$1(start);
                    return new A.FunctionExpression0(null, A.stringReplaceAllUnchecked(plain, "_", "-"), plain, t1, t2);
                }
                if (_3_4) return new A.InterpolatedFunctionExpression0(identifier, _this._stylesheet0$_argumentInvocation$0(), _this.spanFrom$1(start));
                return new A.StringExpression0(identifier, false);
            },
            ifExpression$1: function(start) {
                var branches, condition, t2, _this = this, t1 = _this.scanner;
                t1.expectChar$1(40);
                _this.whitespace$1$consumeNewlines(true);
                branches = A._setArrayType([], type$.JSArray_Record_2_nullable_IfConditionExpression_and_Expression_2);
                while(t1.peekChar$0() !== 41){
                    condition = _this.scanIdentifier$1("else") ? null : _this._stylesheet0$_ifConditionExpression$0();
                    _this.whitespace$1$consumeNewlines(true);
                    t1.expectChar$1(58);
                    _this.whitespace$1$consumeNewlines(true);
                    branches.push(new A._Record_2(condition, _this._stylesheet0$_expression$1$consumeNewlines(true)));
                    _this.whitespace$1$consumeNewlines(true);
                    if (!t1.scanChar$1(59)) break;
                    _this.whitespace$1$consumeNewlines(true);
                }
                t1.expectChar$1(41);
                t1 = t1.spanFrom$1(start);
                t2 = A.List_List$unmodifiable(branches, type$.Record_2_nullable_IfConditionExpression_and_Expression_2);
                if (t2.length === 0) A.throwExpression(A.ArgumentError$value(t2, "branches", "may not be empty"));
                return new A.IfExpression0(t2, t1);
            },
            _stylesheet0$_ifConditionExpression$0: function() {
                var groups, op, _0_0, single, result, _2_0, _this = this, _s44_ = string$.Whitesa, _s11_ = "expressions", _s21_ = "must have length >= 2", t1 = _this.scanner, t2 = t1._string_scanner$_position;
                if (_this.scanIdentifier$1("not")) {
                    if (t1.peekChar$0() === 40) t1.error$1(0, string$.Whitesn);
                    _this.whitespace$1$consumeNewlines(true);
                    return new A.IfConditionNegation0(_this._stylesheet0$_ifGroup$0(), t1.spanFrom$1(new A._SpanScannerState(t1, t2)));
                }
                groups = A._setArrayType([
                    _this._stylesheet0$_ifGroup$0()
                ], type$.JSArray_IfConditionExpression_2);
                _this.whitespace$1$consumeNewlines(true);
                for(op = null;;){
                    if (op !== B.BooleanOperator_10 && _this.scanIdentifier$1("and")) {
                        if (t1.peekChar$0() === 40) t1.error$1(0, _s44_);
                        _this.whitespace$1$consumeNewlines(true);
                        if (op == null) op = B.BooleanOperator_00;
                        groups.push(_this._stylesheet0$_ifGroup$0());
                    } else if (op !== B.BooleanOperator_00 && _this.scanIdentifier$1("or")) {
                        if (t1.peekChar$0() === 40) t1.error$1(0, _s44_);
                        _this.whitespace$1$consumeNewlines(true);
                        if (op == null) op = B.BooleanOperator_10;
                        groups.push(_this._stylesheet0$_ifGroup$0());
                    } else {
                        _0_0 = t1.peekChar$0();
                        if (_0_0 != null && _0_0 !== 41 && _0_0 !== 58 && B.JSArray_methods.get$last(groups).get$isArbitrarySubstitution()) {
                            $label0$0: {
                                if (groups.length === 1) {
                                    single = groups[0];
                                    t1 = single;
                                    break $label0$0;
                                }
                                op.toString;
                                result = A.List_List$from(groups, false, type$.IfConditionExpression_2);
                                result.$flags = 3;
                                t1 = result;
                                t2 = new A.IfConditionOperation0(t1, op);
                                if (t1.length < 2) A.throwExpression(A.ArgumentError$value(t1, _s11_, _s21_));
                                t1 = t2;
                                break $label0$0;
                            }
                            return _this._stylesheet0$_ifConditionRaw$2(t1, _this._stylesheet0$_ifGroup$0());
                        } else {
                            _2_0 = _this._stylesheet0$_tryArbitrarySubstitution$0();
                            if (_2_0 != null) {
                                $label1$1: {
                                    if (groups.length === 1) {
                                        single = groups[0];
                                        t1 = single;
                                        break $label1$1;
                                    }
                                    op.toString;
                                    result = A.List_List$from(groups, false, type$.IfConditionExpression_2);
                                    result.$flags = 3;
                                    t1 = result;
                                    t2 = new A.IfConditionOperation0(t1, op);
                                    if (t1.length < 2) A.throwExpression(A.ArgumentError$value(t1, _s11_, _s21_));
                                    t1 = t2;
                                    break $label1$1;
                                }
                                return _this._stylesheet0$_ifConditionRaw$2(t1, _2_0);
                            } else break;
                        }
                    }
                    _this.whitespace$1$consumeNewlines(true);
                }
                $label2$3: {
                    if (groups.length === 1) {
                        single = groups[0];
                        t1 = single;
                        break $label2$3;
                    }
                    op.toString;
                    t1 = A.IfConditionOperation$0(groups, op);
                    break $label2$3;
                }
                return t1;
            },
            _stylesheet0$_ifConditionRaw$2: function(preceding, next) {
                var t1, t2, _0_5, _0_6, t3, last, buffer, op, t4, lastGroup, lastGroup0, _1_0, _2_0, _this = this, _null = null;
                $label0$0: {
                    if (preceding.get$isArbitrarySubstitution()) {
                        t1 = preceding;
                        break $label0$0;
                    }
                    t1 = _null;
                    t2 = false;
                    if (preceding instanceof A.IfConditionOperation0) {
                        _0_5 = preceding.expressions;
                        _0_6 = _0_5.length;
                        t3 = _0_6;
                        if (t3 >= 1) {
                            last = _0_5[_0_6 - 1];
                            t1 = last.get$isArbitrarySubstitution();
                        } else {
                            last = t1;
                            t1 = t2;
                        }
                    } else {
                        last = t1;
                        t1 = t2;
                    }
                    if (t1) {
                        t1 = last;
                        break $label0$0;
                    }
                    t1 = next.get$isArbitrarySubstitution();
                    if (t1) {
                        t1 = next;
                        break $label0$0;
                    }
                    t1 = A.throwExpression(A.ArgumentError$("Either " + preceding.toString$0(0) + string$.x20must_e + next.toString$0(0) + " must be one.", _null));
                }
                t2 = new A.StringBuffer("");
                buffer = new A.InterpolationBuffer0(t2, A._setArrayType([], type$.JSArray_Object), A._setArrayType([], type$.JSArray_nullable_FileSpan));
                buffer.addInterpolation$1(preceding.toInterpolation$1(t1));
                t3 = A.Primitives_stringFromCharCode(32);
                t2._contents += t3;
                buffer.addInterpolation$1(next.toInterpolation$1(t1));
                op = preceding instanceof A.IfConditionOperation0 ? preceding.op : _null;
                _this.whitespace$1$consumeNewlines(true);
                for(t4 = _this.scanner, lastGroup = next;;){
                    if (op !== B.BooleanOperator_10 && _this.scanIdentifier$1("and")) {
                        if (t4.peekChar$0() === 40) t4.error$1(0, string$.Whitesa);
                        _this.whitespace$1$consumeNewlines(true);
                        if (op == null) op = B.BooleanOperator_00;
                        lastGroup0 = _this._stylesheet0$_ifGroup$0();
                        t2._contents += " and ";
                        buffer.addInterpolation$1(lastGroup0.toInterpolation$1(t1));
                    } else if (op !== B.BooleanOperator_00 && _this.scanIdentifier$1("or")) {
                        if (t4.peekChar$0() === 40) t4.error$1(0, string$.Whiteso);
                        _this.whitespace$1$consumeNewlines(true);
                        if (op == null) op = B.BooleanOperator_10;
                        lastGroup = _this._stylesheet0$_ifGroup$0();
                        _this.whitespace$1$consumeNewlines(true);
                        t2._contents += " or ";
                        buffer.addInterpolation$1(lastGroup.toInterpolation$1(t1));
                    } else {
                        _1_0 = t4.peekChar$0();
                        if (_1_0 != null && _1_0 !== 41 && _1_0 !== 58 && lastGroup.get$isArbitrarySubstitution()) {
                            lastGroup = _this._stylesheet0$_ifGroup$0();
                            t2._contents += t3;
                            buffer.addInterpolation$1(lastGroup.toInterpolation$1(t1));
                        } else {
                            _2_0 = _this._stylesheet0$_tryArbitrarySubstitution$0();
                            if (_2_0 != null) {
                                t2._contents += t3;
                                buffer.addInterpolation$1(_2_0.toInterpolation$1(t1));
                            } else break;
                            lastGroup = _2_0;
                        }
                    }
                    _this.whitespace$1$consumeNewlines(true);
                }
                t1 = preceding.get$span(preceding);
                t4 = A.FileLocation$_(t4._sourceFile, t4._string_scanner$_position);
                t2 = t4.offset;
                return new A.IfConditionRaw0(buffer.interpolation$1(t1.expand$1(0, A._FileSpan$(t4.file, t2, t2))));
            },
            _stylesheet0$_ifGroup$0: function() {
                var expression, t2, identifier, _0_1, _0_6, plain, _this = this, t1 = _this.scanner, start = new A._SpanScannerState(t1, t1._string_scanner$_position);
                if (40 === t1.peekChar$0()) {
                    t1.expectChar$1(40);
                    _this.whitespace$1$consumeNewlines(true);
                    expression = _this._stylesheet0$_ifConditionExpression$0();
                    _this.whitespace$1$consumeNewlines(true);
                    t1.expectChar$1(41);
                    return new A.IfConditionParenthesized0(expression, t1.spanFrom$1(start));
                }
                t2 = _this.scanIdentifier$2$caseSensitive("sass", true);
                if (t2) {
                    t1.expectChar$1(40);
                    _this.whitespace$1$consumeNewlines(true);
                    expression = _this._stylesheet0$_expression$0();
                    _this.whitespace$1$consumeNewlines(true);
                    t1.expectChar$1(41);
                    if (_this.get$plainCss()) _this.error$2(0, string$.sass__, t1.spanFrom$1(start));
                    else return new A.IfConditionSass0(expression, t1.spanFrom$1(start));
                }
                identifier = _this.interpolatedIdentifier$0();
                _0_1 = identifier.contents;
                if (_0_1.length === 1) t2 = _0_1[0] instanceof A.Expression0 && t1.peekChar$0() !== 40;
                else t2 = false;
                if (t2) return new A.IfConditionRaw0(identifier);
                _0_6 = identifier.get$asPlain();
                if (_0_6 != null) {
                    plain = _0_6 == null ? A._asString(_0_6) : _0_6;
                    t2 = B.Set_6V2Gi.contains$1(0, plain.toLowerCase()) && t1.peekChar$0() === 40;
                } else t2 = false;
                if (t2) t1.error$1(0, 'Whitespace is required between "' + identifier.toString$0(0) + '" and "("');
                t1.expectChar$1(40);
                _this.whitespace$1$consumeNewlines(true);
                expression = _this._stylesheet0$_interpolatedDeclarationValue$3$allowEmpty$allowSemicolon$consumeNewlines(true, true, true);
                _this.whitespace$1$consumeNewlines(true);
                t1.expectChar$1(41);
                return new A.IfConditionFunction0(identifier, expression, t1.spanFrom$1(start));
            },
            _stylesheet0$_tryArbitrarySubstitution$0: function() {
                var _0_0, span, start, t2, $arguments, _this = this, t1 = _this.scanner;
                if (t1.peekChar$0() === 35) {
                    _0_0 = _this.singleInterpolation$0();
                    span = _0_0._1;
                    t1 = new A.InterpolationBuffer0(new A.StringBuffer(""), A._setArrayType([], type$.JSArray_Object), A._setArrayType([], type$.JSArray_nullable_FileSpan));
                    t1.add$2(0, _0_0._0, span);
                    return new A.IfConditionRaw0(t1.interpolation$1(span));
                }
                start = new A._SpanScannerState(t1, t1._string_scanner$_position);
                $label0$0: {
                    t2 = _this.scanIdentifier$1("if");
                    if (t2) {
                        t2 = t1.spanFrom$1(start);
                        t2 = new A.Interpolation0(A.List_List$unmodifiable([
                            "if"
                        ], type$.Object), B.List_null, t2);
                        break $label0$0;
                    }
                    t2 = _this.scanIdentifier$1("var");
                    if (t2) {
                        t2 = t1.spanFrom$1(start);
                        t2 = new A.Interpolation0(A.List_List$unmodifiable([
                            "var"
                        ], type$.Object), B.List_null, t2);
                        break $label0$0;
                    }
                    t2 = _this.scanIdentifier$1("attr");
                    if (t2) {
                        t2 = t1.spanFrom$1(start);
                        t2 = new A.Interpolation0(A.List_List$unmodifiable([
                            "attr"
                        ], type$.Object), B.List_null, t2);
                        break $label0$0;
                    }
                    t2 = t1.matches$1("--");
                    if (t2) {
                        t2 = _this.interpolatedIdentifier$0();
                        break $label0$0;
                    }
                    t2 = null;
                    break $label0$0;
                }
                if (t2 == null) return null;
                if (!t1.scanChar$1(40)) {
                    t1.set$state(start);
                    return null;
                }
                $arguments = _this._stylesheet0$_interpolatedDeclarationValue$3$allowEmpty$allowSemicolon$consumeNewlines(true, true, true);
                t1.expectChar$1(41);
                return new A.IfConditionFunction0(t2, $arguments, t1.spanFrom$1(start));
            },
            namespacedExpression$2: function(namespace, start) {
                var $name, t1, t2, t3, _this = this;
                if (_this.scanner.peekChar$0() === 36) {
                    $name = _this.variableName$0();
                    _this._stylesheet0$_assertPublic$2($name, new A.StylesheetParser_namespacedExpression_closure0(_this, start));
                    return new A.VariableExpression0(namespace, $name, _this.spanFrom$1(start));
                }
                t1 = _this._stylesheet0$_publicIdentifier$0();
                t2 = _this._stylesheet0$_argumentInvocation$0();
                t3 = _this.spanFrom$1(start);
                return new A.FunctionExpression0(namespace, A.stringReplaceAllUnchecked(t1, "_", "-"), t1, t2, t3);
            },
            trySpecialFunction$2: function($name, start) {
                var invalidSassScript, nonCssSassScript, argument, t1, buffer, t2, normalized, vendored, _0_2, t3, _$exception, value, suggestion, next, _this = this;
                if ($name === "type" && _this.scanner.scanChar$1(40)) {
                    t1 = new A.StringBuffer("");
                    buffer = new A.InterpolationBuffer0(t1, A._setArrayType([], type$.JSArray_Object), A._setArrayType([], type$.JSArray_nullable_FileSpan));
                    t1._contents = $name;
                    t2 = A.Primitives_stringFromCharCode(40);
                    t1._contents += t2;
                } else {
                    normalized = A.unvendor0($name);
                    t1 = normalized === $name;
                    vendored = !t1;
                    $label0$0: {
                        _0_2 = "expression" === normalized;
                        if (_0_2 && vendored && _this.scanner.scanChar$1(40)) {
                            t1 = new A.StringBuffer("");
                            buffer = new A.InterpolationBuffer0(t1, A._setArrayType([], type$.JSArray_Object), A._setArrayType([], type$.JSArray_nullable_FileSpan));
                            t1._contents = $name;
                            t2 = A.Primitives_stringFromCharCode(40);
                            t1._contents += t2;
                            t2 = _this.scanner;
                            t3 = t2._string_scanner$_position;
                            invalidSassScript = false;
                            nonCssSassScript = false;
                            try {
                                argument = _this._stylesheet0$_expression$0();
                                nonCssSassScript = !argument.accept$1(new A.IsPlainCssVisitor0(true));
                            } catch (exception) {
                                if (A.unwrapException(exception) instanceof A.StringScannerException) invalidSassScript = true;
                                else throw exception;
                            }
                            t2.set$state(new A._SpanScannerState(t2, t3));
                            value = _this._stylesheet0$_interpolatedDeclarationValue$1$allowEmpty(true);
                            buffer.addInterpolation$1(value);
                            t2.expectChar$1(41);
                            t2 = A.Primitives_stringFromCharCode(41);
                            t1._contents += t2;
                            if (invalidSassScript || nonCssSassScript) {
                                suggestion = new A.StringExpression0(value, true).asInterpolation$0();
                                t1 = invalidSassScript ? "be parsed as SassScript. " : "no longer be valid syntax. ";
                                _this.warnings.push(new A._Record_3_deprecation_message_span(B.Deprecation_2Ja, "Vendor-prefixed " + normalized + string$.x28__fun + t1 + ("To preserve current behavior:\n\n" + $name + "(#{" + suggestion.toString$0(0) + string$.x7dx29__Mo), _this.spanFrom$1(start)));
                            }
                            return new A.StringExpression0(buffer.interpolation$1(_this.spanFrom$1(start)), false);
                        }
                        t2 = true;
                        if (!("calc" === normalized && vendored && _this.scanner.scanChar$1(40))) {
                            if (!(_0_2 && t1 && _this.scanner.scanChar$1(40))) t1 = "element" === normalized && _this.scanner.scanChar$1(40);
                            else t1 = t2;
                        } else t1 = t2;
                        if (t1) {
                            t1 = new A.StringBuffer("");
                            buffer = new A.InterpolationBuffer0(t1, A._setArrayType([], type$.JSArray_Object), A._setArrayType([], type$.JSArray_nullable_FileSpan));
                            t1._contents = $name;
                            t2 = A.Primitives_stringFromCharCode(40);
                            t1._contents += t2;
                            break $label0$0;
                        }
                        if ("progid" === normalized && _this.scanner.scanChar$1(58)) {
                            t1 = new A.StringBuffer("");
                            buffer = new A.InterpolationBuffer0(t1, A._setArrayType([], type$.JSArray_Object), A._setArrayType([], type$.JSArray_nullable_FileSpan));
                            t1._contents = $name;
                            t2 = A.Primitives_stringFromCharCode(58);
                            t1._contents += t2;
                            t2 = _this.scanner;
                            next = t2.peekChar$0();
                            for(;;){
                                if (next != null) {
                                    if (!(next >= 97 && next <= 122)) t3 = next >= 65 && next <= 90;
                                    else t3 = true;
                                    t3 = t3 || next === 46;
                                } else t3 = false;
                                if (!t3) break;
                                t3 = A.Primitives_stringFromCharCode(t2.readChar$0());
                                t1._contents += t3;
                                next = t2.peekChar$0();
                            }
                            t2.expectChar$1(40);
                            t3 = A.Primitives_stringFromCharCode(40);
                            t1._contents += t3;
                            buffer.addInterpolation$1(_this._stylesheet0$_interpolatedDeclarationValue$1$allowEmpty(true));
                            t2.expectChar$1(41);
                            t2 = A.Primitives_stringFromCharCode(41);
                            t1._contents += t2;
                            if (vendored) _this.warnings.push(new A._Record_3_deprecation_message_span(B.Deprecation_2Ja, string$.Vendorp + new A.StringExpression0(buffer.interpolation$1(_this.spanFrom$1(start)), true).asInterpolation$0().toString$0(0) + string$.x7dx0a_Mor, _this.spanFrom$1(start)));
                            return new A.StringExpression0(buffer.interpolation$1(_this.spanFrom$1(start)), false);
                        }
                        if ("url" === normalized) return A.NullableExtension_andThen0(_this._stylesheet0$_tryUrlContents$2$vendored(start, vendored), new A.StylesheetParser_trySpecialFunction_closure0());
                        return null;
                    }
                }
                buffer.addInterpolation$1(_this._stylesheet0$_interpolatedDeclarationValue$1$allowEmpty(true));
                _this.scanner.expectChar$1(41);
                t1 = buffer._interpolation_buffer0$_text;
                t2 = A.Primitives_stringFromCharCode(41);
                t1._contents += t2;
                return new A.StringExpression0(buffer.interpolation$1(_this.spanFrom$1(start)), false);
            },
            _stylesheet0$_tryUrlContents$3$name$vendored: function(start, $name, vendored) {
                var invalidSassScript, t3, _$exception, t4, t5, buffer, t6, _1_0, _1_6, _0_0, _this = this, t1 = _this.scanner, t2 = t1._string_scanner$_position;
                if (!t1.scanChar$1(40)) return null;
                invalidSassScript = false;
                if (vendored) {
                    t3 = t1._string_scanner$_position;
                    try {
                        _this._stylesheet0$_expression$0();
                    } catch (exception) {
                        if (A.unwrapException(exception) instanceof A.StringScannerException) invalidSassScript = true;
                        else throw exception;
                    }
                    t1.set$state(new A._SpanScannerState(t1, t3));
                }
                _this.whitespaceWithoutComments$1$consumeNewlines(true);
                t3 = new A.StringBuffer("");
                t4 = A._setArrayType([], type$.JSArray_Object);
                t5 = A._setArrayType([], type$.JSArray_nullable_FileSpan);
                buffer = new A.InterpolationBuffer0(t3, t4, t5);
                t3._contents = $name == null ? "url" : $name;
                t6 = A.Primitives_stringFromCharCode(40);
                t3._contents += t6;
                for(;;){
                    _1_0 = t1.peekChar$0();
                    if (_1_0 == null) break;
                    if (92 === _1_0) {
                        t6 = _this.escape$0();
                        t3._contents += t6;
                        continue;
                    }
                    _1_6 = 35 === _1_0;
                    if (_1_6 && t1.peekChar$1(1) === 123) {
                        _0_0 = _this.singleInterpolation$0();
                        buffer._interpolation_buffer0$_flushText$0();
                        t4.push(_0_0._0);
                        t5.push(_0_0._1);
                        continue;
                    }
                    t6 = true;
                    if (33 !== _1_0) {
                        if (37 !== _1_0) {
                            if (38 !== _1_0) {
                                if (!_1_6) t6 = _1_0 >= 42 && _1_0 <= 126 || _1_0 >= 128;
                            }
                        }
                    }
                    if (t6) {
                        t6 = A.Primitives_stringFromCharCode(t1.readChar$0());
                        t3._contents += t6;
                        continue;
                    }
                    if (_1_0 === 32 || _1_0 === 9 || _1_0 === 10 || _1_0 === 13 || _1_0 === 12) {
                        _this.whitespaceWithoutComments$1$consumeNewlines(true);
                        if (t1.peekChar$0() !== 41) break;
                        continue;
                    }
                    if (41 === _1_0) {
                        t2 = A.Primitives_stringFromCharCode(t1.readChar$0());
                        t3._contents += t2;
                        if (vendored && invalidSassScript) _this.warnings.push(new A._Record_3_deprecation_message_span(B.Deprecation_2Ja, string$.Vendoru + A.S($name) + "(#{" + new A.StringExpression0(buffer.interpolation$1(_this.spanFrom$1(start)), true).asInterpolation$0().toString$0(0) + string$.x7dx29__Mo, _this.spanFrom$1(start)));
                        return buffer.interpolation$1(_this.spanFrom$1(start));
                    }
                    break;
                }
                t1.set$state(new A._SpanScannerState(t1, t2));
                return null;
            },
            _stylesheet0$_tryUrlContents$2$vendored: function(start, vendored) {
                return this._stylesheet0$_tryUrlContents$3$name$vendored(start, null, vendored);
            },
            _stylesheet0$_tryUrlContents$2$name: function(start, $name) {
                return this._stylesheet0$_tryUrlContents$3$name$vendored(start, $name, false);
            },
            _stylesheet0$_tryUrlContents$1: function(start) {
                return this._stylesheet0$_tryUrlContents$3$name$vendored(start, null, false);
            },
            dynamicUrl$0: function() {
                var _0_0, _this = this, t1 = _this.scanner, start = new A._SpanScannerState(t1, t1._string_scanner$_position);
                _this.expectIdentifier$1("url");
                _0_0 = _this._stylesheet0$_tryUrlContents$1(start);
                if (_0_0 != null) return new A.StringExpression0(_0_0, false);
                t1 = _this.spanFrom$1(start);
                return new A.InterpolatedFunctionExpression0(new A.Interpolation0(A.List_List$unmodifiable([
                    "url"
                ], type$.Object), B.List_null, t1), _this._stylesheet0$_argumentInvocation$0(), _this.spanFrom$1(start));
            },
            almostAnyValue$1$omitComments: function(omitComments) {
                var t4, t5, t6, t7, _2_0, t8, _0_0, _0_2, start, end, _0_4, identifier, _1_0, bracket, char, _this = this, t1 = _this.scanner, t2 = t1._string_scanner$_position, t3 = new A.StringBuffer(""), buffer = new A.InterpolationBuffer0(t3, A._setArrayType([], type$.JSArray_Object), A._setArrayType([], type$.JSArray_nullable_FileSpan)), brackets = A._setArrayType([], type$.JSArray_int);
                for(t4 = t1.string, t5 = t4.length, t6 = !omitComments, t7 = _this.get$loudComment();;)$label0$0: {
                    _2_0 = t1.peekChar$0();
                    if (92 === _2_0) {
                        t8 = A.Primitives_stringFromCharCode(t1.readChar$0());
                        t3._contents += t8;
                        t8 = A.Primitives_stringFromCharCode(t1.readChar$0());
                        t3._contents += t8;
                        break $label0$0;
                    }
                    if (34 === _2_0 || 39 === _2_0) {
                        buffer.addInterpolation$1(_this.interpolatedStringToken$0());
                        break $label0$0;
                    }
                    if (47 === _2_0) {
                        $label1$1: {
                            _0_0 = t1.peekChar$1(1);
                            _0_2 = 42 === _0_0;
                            if (_0_2 && t6) {
                                start = t1._string_scanner$_position;
                                t7.call$0();
                                end = t1._string_scanner$_position;
                                t3._contents += B.JSString_methods.substring$2(t4, start, end);
                                break $label1$1;
                            }
                            if (_0_2) {
                                _this.loudComment$0();
                                break $label1$1;
                            }
                            _0_4 = 47 === _0_0;
                            if (_0_4 && t6) {
                                t8 = _this.get$silentComment();
                                start = t1._string_scanner$_position;
                                t8.call$0();
                                end = t1._string_scanner$_position;
                                t3._contents += B.JSString_methods.substring$2(t4, start, end);
                                break $label1$1;
                            }
                            if (_0_4) {
                                _this.silentComment$0();
                                break $label1$1;
                            }
                            t8 = A.Primitives_stringFromCharCode(t1.readChar$0());
                            t3._contents += t8;
                        }
                        break $label0$0;
                    }
                    if (35 === _2_0 && t1.peekChar$1(1) === 123) {
                        buffer.addInterpolation$1(_this.interpolatedIdentifier$0());
                        break $label0$0;
                    }
                    if (13 === _2_0 || 10 === _2_0 || 12 === _2_0) {
                        if (_this.get$indented() && brackets.length === 0) break;
                        t8 = A.Primitives_stringFromCharCode(t1.readChar$0());
                        t3._contents += t8;
                        break $label0$0;
                    }
                    if (33 === _2_0 || 59 === _2_0 || 123 === _2_0 || 125 === _2_0) break;
                    if (117 === _2_0 || 85 === _2_0) {
                        t8 = t1._string_scanner$_position;
                        identifier = _this.identifier$0();
                        if (identifier !== "url" && identifier !== "url-prefix") {
                            t3._contents += identifier;
                            continue;
                        }
                        _1_0 = _this._stylesheet0$_tryUrlContents$2$name(new A._SpanScannerState(t1, t8), identifier);
                        if (_1_0 != null) buffer.addInterpolation$1(_1_0);
                        else {
                            if ((t8 === 0 ? 1 / t8 < 0 : t8 < 0) || t8 > t5) A.throwExpression(A.ArgumentError$("Invalid position " + t8, null));
                            t1._string_scanner$_position = t8;
                            t1._lastMatch = null;
                            t8 = A.Primitives_stringFromCharCode(t1.readChar$0());
                            t3._contents += t8;
                        }
                        break $label0$0;
                    }
                    if (40 === _2_0 || 91 === _2_0) {
                        bracket = t1.readChar$0();
                        t8 = A.Primitives_stringFromCharCode(bracket);
                        t3._contents += t8;
                        brackets.push(A.opposite0(bracket));
                        break $label0$0;
                    }
                    if (41 === _2_0 || 93 === _2_0) {
                        t8 = _2_0 != null;
                        char = t8 ? _2_0 : null;
                    } else {
                        char = null;
                        t8 = false;
                    }
                    if (t8) {
                        if (brackets.length === 0) t1.error$1(0, 'Unexpected "' + A.Primitives_stringFromCharCode(char) + '".');
                        bracket = brackets.pop();
                        t1.expectChar$1(bracket);
                        t8 = A.Primitives_stringFromCharCode(bracket);
                        t3._contents += t8;
                        break $label0$0;
                    }
                    if (_2_0 == null) break;
                    t8 = _this.lookingAtIdentifier$0();
                    if (t8) {
                        t8 = _this.identifier$0();
                        t3._contents += t8;
                        break $label0$0;
                    }
                    t8 = A.Primitives_stringFromCharCode(t1.readChar$0());
                    t3._contents += t8;
                }
                return buffer.interpolation$1(_this.spanFrom$1(new A._SpanScannerState(t1, t2)));
            },
            almostAnyValue$0: function() {
                return this.almostAnyValue$1$omitComments(false);
            },
            _stylesheet0$_interpolatedDeclarationValue$7$allowColon$allowEmpty$allowOpenBrace$allowSemicolon$consumeNewlines$endAfterOf$silentComments: function(allowColon, allowEmpty, allowOpenBrace, allowSemicolon, consumeNewlines, endAfterOf, silentComments) {
                var t5, t6, t7, t8, t9, t10, t11, wroteNewline, _2_0, wroteNewline0, t12, _0_0, start, end, _2_12, _2_14_isSet, _2_14, t13, _2_16, _2_18_isSet, _2_20, _2_18, _2_20_isSet, _2_22, bracket, identifier, _1_0, of, _this = this, _null = null, t1 = _this.scanner, t2 = t1._string_scanner$_position, t3 = new A.StringBuffer(""), t4 = A._setArrayType([], type$.JSArray_Object), buffer = new A.InterpolationBuffer0(t3, t4, A._setArrayType([], type$.JSArray_nullable_FileSpan)), brackets = A._setArrayType([], type$.JSArray_int);
                for(t5 = !consumeNewlines, t6 = !allowOpenBrace, t7 = t1.string, t8 = t7.length, t9 = !allowColon, t10 = !allowSemicolon, t11 = _this.get$loudComment(), wroteNewline = false;;)$label0$0: {
                    _2_0 = t1.peekChar$0();
                    wroteNewline0 = false;
                    if (92 === _2_0) {
                        t12 = _this.escape$1$identifierStart(true);
                        t3._contents += t12;
                        wroteNewline = wroteNewline0;
                        break $label0$0;
                    }
                    if (34 === _2_0 || 39 === _2_0) {
                        buffer.addInterpolation$1(_this.interpolatedStringToken$0());
                        wroteNewline = wroteNewline0;
                        break $label0$0;
                    }
                    if (47 === _2_0) {
                        $label1$1: {
                            _0_0 = t1.peekChar$1(1);
                            if (42 === _0_0) {
                                start = t1._string_scanner$_position;
                                t11.call$0();
                                end = t1._string_scanner$_position;
                                t3._contents += B.JSString_methods.substring$2(t7, start, end);
                                break $label1$1;
                            }
                            if (47 === _0_0 && silentComments) {
                                _this.silentComment$0();
                                break $label1$1;
                            }
                            t12 = A.Primitives_stringFromCharCode(t1.readChar$0());
                            t3._contents += t12;
                        }
                        wroteNewline = wroteNewline0;
                        break $label0$0;
                    }
                    if (35 === _2_0 && t1.peekChar$1(1) === 123) {
                        buffer.addInterpolation$1(_this.interpolatedIdentifier$0());
                        wroteNewline = wroteNewline0;
                        break $label0$0;
                    }
                    _2_12 = 32 === _2_0;
                    _2_14_isSet = !_2_12;
                    if (_2_14_isSet) {
                        _2_14 = 9 === _2_0;
                        t12 = _2_14;
                    } else {
                        _2_14 = _null;
                        t12 = true;
                    }
                    t13 = false;
                    if (t12) {
                        if (!wroteNewline) {
                            t12 = t1.peekChar$1(1);
                            t12 = t12 === 32 || t12 === 9 || t12 === 10 || t12 === 13 || t12 === 12;
                        } else t12 = t13;
                    } else t12 = t13;
                    if (t12) {
                        t1.readChar$0();
                        break $label0$0;
                    }
                    if (!_2_12) t12 = _2_14_isSet ? _2_14 : 9 === _2_0;
                    else t12 = true;
                    if (t12) {
                        t12 = A.Primitives_stringFromCharCode(t1.readChar$0());
                        t3._contents += t12;
                        break $label0$0;
                    }
                    _2_16 = 10 === _2_0;
                    _2_18_isSet = !_2_16;
                    _2_20 = _null;
                    t12 = true;
                    if (_2_18_isSet) {
                        _2_18 = 13 === _2_0;
                        _2_20_isSet = !_2_18;
                        if (_2_20_isSet) {
                            _2_20 = 12 === _2_0;
                            t12 = _2_20;
                        }
                    } else {
                        _2_18 = _null;
                        _2_20_isSet = false;
                    }
                    if (t12 && _this.get$indented() && t5 && brackets.length === 0) break;
                    t12 = true;
                    if (!_2_16) {
                        if (!(_2_18_isSet ? _2_18 : 13 === _2_0)) t12 = _2_20_isSet ? _2_20 : 12 === _2_0;
                    }
                    if (t12) {
                        t12 = t1.peekChar$1(-1);
                        if (!(t12 === 10 || t12 === 13 || t12 === 12)) t3._contents += "\n";
                        t1.readChar$0();
                        wroteNewline = true;
                        break $label0$0;
                    }
                    _2_22 = 123 === _2_0;
                    if (_2_22 && t6) break;
                    if (40 !== _2_0) t12 = _2_22 || 91 === _2_0;
                    else t12 = true;
                    if (t12) {
                        bracket = t1.readChar$0();
                        t12 = A.Primitives_stringFromCharCode(bracket);
                        t3._contents += t12;
                        brackets.push(A.opposite0(bracket));
                        wroteNewline = wroteNewline0;
                        break $label0$0;
                    }
                    if (41 === _2_0 || 125 === _2_0 || 93 === _2_0) {
                        if (brackets.length === 0) break;
                        bracket = brackets.pop();
                        t1.expectChar$1(bracket);
                        t12 = A.Primitives_stringFromCharCode(bracket);
                        t3._contents += t12;
                        wroteNewline = wroteNewline0;
                        break $label0$0;
                    }
                    if (59 === _2_0) {
                        if (t10 && brackets.length === 0) break;
                        t12 = A.Primitives_stringFromCharCode(t1.readChar$0());
                        t3._contents += t12;
                        wroteNewline = wroteNewline0;
                        break $label0$0;
                    }
                    if (58 === _2_0) {
                        if (t9 && brackets.length === 0) break;
                        t12 = A.Primitives_stringFromCharCode(t1.readChar$0());
                        t3._contents += t12;
                        wroteNewline = wroteNewline0;
                        break $label0$0;
                    }
                    if (117 === _2_0 || 85 === _2_0) {
                        t12 = t1._string_scanner$_position;
                        identifier = _this.identifier$0();
                        if (identifier !== "url" && identifier !== "url-prefix") {
                            t3._contents += identifier;
                            wroteNewline = wroteNewline0;
                            continue;
                        }
                        _1_0 = _this._stylesheet0$_tryUrlContents$2$name(new A._SpanScannerState(t1, t12), identifier);
                        if (_1_0 != null) buffer.addInterpolation$1(_1_0);
                        else {
                            if ((t12 === 0 ? 1 / t12 < 0 : t12 < 0) || t12 > t8) A.throwExpression(A.ArgumentError$("Invalid position " + t12, _null));
                            t1._string_scanner$_position = t12;
                            t1._lastMatch = null;
                            t12 = A.Primitives_stringFromCharCode(t1.readChar$0());
                            t3._contents += t12;
                        }
                        wroteNewline = wroteNewline0;
                        break $label0$0;
                    }
                    if (111 === _2_0 || 79 === _2_0) {
                        if (endAfterOf && brackets.length === 0) {
                            start = t1._string_scanner$_position;
                            new A.StylesheetParser__interpolatedDeclarationValue_closure0(_this).call$0();
                            end = t1._string_scanner$_position;
                            of = B.JSString_methods.substring$2(t7, start, end);
                            if (of !== "") {
                                t3._contents += of;
                                break;
                            }
                        }
                        t12 = A.Primitives_stringFromCharCode(t1.readChar$0());
                        t3._contents += t12;
                        wroteNewline = wroteNewline0;
                        break $label0$0;
                    }
                    if (_2_0 == null) break;
                    t12 = _this.lookingAtIdentifier$0();
                    if (t12) {
                        t12 = _this.identifier$0();
                        t3._contents += t12;
                        wroteNewline = wroteNewline0;
                        break $label0$0;
                    }
                    t12 = A.Primitives_stringFromCharCode(t1.readChar$0());
                    t3._contents += t12;
                    wroteNewline = wroteNewline0;
                }
                if (brackets.length !== 0) t1.expectChar$1(B.JSArray_methods.get$last(brackets));
                if (!allowEmpty && t4.length === 0 && t3._contents.length === 0) t1.error$1(0, "Expected token.");
                return buffer.interpolation$1(_this.spanFrom$1(new A._SpanScannerState(t1, t2)));
            },
            _stylesheet0$_interpolatedDeclarationValue$1$allowEmpty: function(allowEmpty) {
                return this._stylesheet0$_interpolatedDeclarationValue$7$allowColon$allowEmpty$allowOpenBrace$allowSemicolon$consumeNewlines$endAfterOf$silentComments(true, allowEmpty, true, false, false, false, true);
            },
            _stylesheet0$_interpolatedDeclarationValue$3$allowEmpty$allowSemicolon$consumeNewlines: function(allowEmpty, allowSemicolon, consumeNewlines) {
                return this._stylesheet0$_interpolatedDeclarationValue$7$allowColon$allowEmpty$allowOpenBrace$allowSemicolon$consumeNewlines$endAfterOf$silentComments(true, allowEmpty, true, allowSemicolon, consumeNewlines, false, true);
            },
            _stylesheet0$_interpolatedDeclarationValue$2$consumeNewlines$endAfterOf: function(consumeNewlines, endAfterOf) {
                return this._stylesheet0$_interpolatedDeclarationValue$7$allowColon$allowEmpty$allowOpenBrace$allowSemicolon$consumeNewlines$endAfterOf$silentComments(true, false, true, false, consumeNewlines, endAfterOf, true);
            },
            _stylesheet0$_interpolatedDeclarationValue$4$allowColon$allowEmpty$allowSemicolon$consumeNewlines: function(allowColon, allowEmpty, allowSemicolon, consumeNewlines) {
                return this._stylesheet0$_interpolatedDeclarationValue$7$allowColon$allowEmpty$allowOpenBrace$allowSemicolon$consumeNewlines$endAfterOf$silentComments(allowColon, allowEmpty, true, allowSemicolon, consumeNewlines, false, true);
            },
            _stylesheet0$_interpolatedDeclarationValue$0: function() {
                return this._stylesheet0$_interpolatedDeclarationValue$7$allowColon$allowEmpty$allowOpenBrace$allowSemicolon$consumeNewlines$endAfterOf$silentComments(true, false, true, false, false, false, true);
            },
            _stylesheet0$_interpolatedDeclarationValue$1$allowOpenBrace: function(allowOpenBrace) {
                return this._stylesheet0$_interpolatedDeclarationValue$7$allowColon$allowEmpty$allowOpenBrace$allowSemicolon$consumeNewlines$endAfterOf$silentComments(true, false, allowOpenBrace, false, false, false, true);
            },
            _stylesheet0$_interpolatedDeclarationValue$2$allowEmpty$allowOpenBrace: function(allowEmpty, allowOpenBrace) {
                return this._stylesheet0$_interpolatedDeclarationValue$7$allowColon$allowEmpty$allowOpenBrace$allowSemicolon$consumeNewlines$endAfterOf$silentComments(true, allowEmpty, allowOpenBrace, false, false, false, true);
            },
            _stylesheet0$_interpolatedDeclarationValue$1$silentComments: function(silentComments) {
                return this._stylesheet0$_interpolatedDeclarationValue$7$allowColon$allowEmpty$allowOpenBrace$allowSemicolon$consumeNewlines$endAfterOf$silentComments(true, false, true, false, false, false, silentComments);
            },
            interpolatedIdentifier$0: function() {
                var t3, _1_0, _0_0, _this = this, _s20_ = "Expected identifier.", t1 = _this.scanner, start = new A._SpanScannerState(t1, t1._string_scanner$_position), t2 = new A.StringBuffer(""), buffer = new A.InterpolationBuffer0(t2, A._setArrayType([], type$.JSArray_Object), A._setArrayType([], type$.JSArray_nullable_FileSpan));
                if (t1.scanChar$1(45)) {
                    t3 = A.Primitives_stringFromCharCode(45);
                    t2._contents += t3;
                    if (t1.scanChar$1(45)) {
                        t2._contents += t3;
                        _this._stylesheet0$_interpolatedIdentifierBodyHelper$1(buffer);
                        return buffer.interpolation$1(_this.spanFrom$1(start));
                    }
                }
                $label0$0: {
                    _1_0 = t1.peekChar$0();
                    if (_1_0 == null) t1.error$1(0, _s20_);
                    if (_1_0 === 95 || A.CharacterExtension_get_isAlphabetic0(_1_0) || _1_0 >= 128) {
                        t1 = A.Primitives_stringFromCharCode(t1.readChar$0());
                        t2._contents += t1;
                        break $label0$0;
                    }
                    if (92 === _1_0) {
                        t1 = _this.escape$1$identifierStart(true);
                        t2._contents += t1;
                        break $label0$0;
                    }
                    if (35 === _1_0 && t1.peekChar$1(1) === 123) {
                        _0_0 = _this.singleInterpolation$0();
                        buffer.add$2(0, _0_0._0, _0_0._1);
                        break $label0$0;
                    }
                    t1.error$1(0, _s20_);
                }
                _this._stylesheet0$_interpolatedIdentifierBodyHelper$1(buffer);
                return buffer.interpolation$1(_this.spanFrom$1(start));
            },
            _stylesheet0$_interpolatedIdentifierBodyHelper$1: function(buffer) {
                var t1, t2, t3, t4, _1_0, t5, _0_0;
                for(t1 = buffer._interpolation_buffer0$_contents, t2 = buffer._interpolation_buffer0$_spans, t3 = this.scanner, t4 = buffer._interpolation_buffer0$_text;;){
                    _1_0 = t3.peekChar$0();
                    if (_1_0 == null) break;
                    t5 = true;
                    if (95 !== _1_0) {
                        if (45 !== _1_0) {
                            if (!(_1_0 >= 97 && _1_0 <= 122)) t5 = _1_0 >= 65 && _1_0 <= 90;
                            else t5 = true;
                            if (!t5) t5 = _1_0 >= 48 && _1_0 <= 57;
                            else t5 = true;
                            t5 = t5 || _1_0 >= 128;
                        }
                    }
                    if (t5) {
                        t5 = A.Primitives_stringFromCharCode(t3.readChar$0());
                        t4._contents += t5;
                        continue;
                    }
                    if (92 === _1_0) {
                        t5 = this.escape$0();
                        t4._contents += t5;
                        continue;
                    }
                    if (35 === _1_0 && t3.peekChar$1(1) === 123) {
                        _0_0 = this.singleInterpolation$0();
                        buffer._interpolation_buffer0$_flushText$0();
                        t1.push(_0_0._0);
                        t2.push(_0_0._1);
                        continue;
                    }
                    break;
                }
            },
            singleInterpolation$0: function() {
                var contents, span, _this = this, t1 = _this.scanner, t2 = t1._string_scanner$_position;
                t1.expect$1("#{");
                _this.whitespace$1$consumeNewlines(true);
                contents = _this._stylesheet0$_expression$1$consumeNewlines(true);
                t1.expectChar$1(125);
                span = _this.spanFrom$1(new A._SpanScannerState(t1, t2));
                if (_this.get$plainCss()) _this.error$2(0, string$.Interpp, span);
                return new A._Record_2(contents, span);
            },
            _stylesheet0$_selectorList$0: function() {
                var t3, t4, lineBreak, _this = this, t1 = _this.scanner, t2 = t1._sourceFile, previousLine = t2.getLine$1(t1._string_scanner$_position), components = A._setArrayType([
                    _this._stylesheet0$_complexSelector$0()
                ], type$.JSArray_InterpolatedComplexSelector);
                _this.whitespace$1$consumeNewlines(false);
                for(t3 = t1.string.length; t1.scanChar$1(44);){
                    _this.whitespace$1$consumeNewlines(true);
                    if (t1.peekChar$0() === 44) continue;
                    t4 = t1._string_scanner$_position;
                    if (t4 === t3) break;
                    lineBreak = t2.getLine$1(t4) !== previousLine;
                    if (lineBreak) previousLine = t2.getLine$1(t1._string_scanner$_position);
                    components.push(_this._stylesheet0$_complexSelector$1$lineBreak(lineBreak));
                }
                return A.InterpolatedSelectorList$(components);
            },
            _stylesheet0$_complexSelector$1$lineBreak: function(lineBreak) {
                var t3, leadingCombinator, combinator, lastCompound, allowCombinator, _0_0, t4, _this = this, _null = null, _s18_ = "expected selector.", t1 = _this.scanner, t2 = t1._string_scanner$_position, componentStart = new A._SpanScannerState(t1, t2), components = A._setArrayType([], type$.JSArray_InterpolatedComplexSelectorComponent);
                for(t3 = type$.CssValue_Combinator_2, leadingCombinator = _null, combinator = leadingCombinator, lastCompound = combinator;;){
                    _this.whitespace$1$consumeNewlines(false);
                    allowCombinator = combinator == null;
                    _0_0 = t1.peekChar$0();
                    if (43 === _0_0 && allowCombinator) {
                        t4 = t1._string_scanner$_position;
                        t1.readChar$0();
                        combinator = new A.CssValue0(B.Combinator_sHB0, _this.spanFrom$1(new A._SpanScannerState(t1, t4)), t3);
                        continue;
                    }
                    if (62 === _0_0 && allowCombinator) {
                        t4 = t1._string_scanner$_position;
                        t1.readChar$0();
                        combinator = new A.CssValue0(B.Combinator_iUF0, _this.spanFrom$1(new A._SpanScannerState(t1, t4)), t3);
                        continue;
                    }
                    if (126 === _0_0 && allowCombinator) {
                        t4 = t1._string_scanner$_position;
                        t1.readChar$0();
                        combinator = new A.CssValue0(B.Combinator_98W0, _this.spanFrom$1(new A._SpanScannerState(t1, t4)), t3);
                        continue;
                    }
                    if (_0_0 == null) break;
                    t4 = true;
                    if (91 !== _0_0) {
                        if (46 !== _0_0) {
                            if (35 !== _0_0) {
                                if (37 !== _0_0) {
                                    if (58 !== _0_0) {
                                        if (38 !== _0_0) {
                                            if (42 !== _0_0) {
                                                if (124 !== _0_0) t4 = _this._stylesheet0$_lookingAtInterpolatedIdentifier$0();
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                    if (t4) {
                        if (lastCompound != null) components.push(new A.InterpolatedComplexSelectorComponent(lastCompound, combinator, _this.spanFrom$1(componentStart)));
                        else if (!allowCombinator) {
                            componentStart = new A._SpanScannerState(t1, t1._string_scanner$_position);
                            leadingCombinator = combinator;
                        }
                        lastCompound = _this._stylesheet0$_compoundSelector$0();
                        if (t1.peekChar$0() === 38) t1.error$1(0, string$.x22x26__ma);
                        combinator = _null;
                        continue;
                    }
                    break;
                }
                t3 = combinator != null;
                if (t3) t4 = _this.get$plainCss();
                else t4 = false;
                if (t4) t1.error$1(0, _s18_);
                else if (lastCompound != null) components.push(new A.InterpolatedComplexSelectorComponent(lastCompound, combinator, _this.spanFrom$1(componentStart)));
                else if (t3) leadingCombinator = combinator;
                else t1.error$1(0, _s18_);
                return A.InterpolatedComplexSelector$(components, _this.spanFrom$1(new A._SpanScannerState(t1, t2)), leadingCombinator);
            },
            _stylesheet0$_complexSelector$0: function() {
                return this._stylesheet0$_complexSelector$1$lineBreak(false);
            },
            _stylesheet0$_compoundSelector$0: function() {
                var t1, _this = this, components = A._setArrayType([
                    _this._stylesheet0$_simpleSelector$0()
                ], type$.JSArray_InterpolatedSimpleSelector);
                for(t1 = _this.scanner; _this._stylesheet0$_isSimpleSelectorStart$1(t1.peekChar$0());)components.push(_this._stylesheet0$_simpleSelector$1$allowParent(_this.get$plainCss()));
                return A.InterpolatedCompoundSelector$(components);
            },
            _stylesheet0$_simpleSelector$1$allowParent: function(allowParent) {
                var $name, t2, t3, t4, t5, text, suffix, _this = this, t1 = _this.scanner, start = new A._SpanScannerState(t1, t1._string_scanner$_position), _0_0 = t1.peekChar$0();
                if (91 === _0_0) return _this._stylesheet0$_attributeSelector$0();
                if (46 === _0_0) {
                    t1.expectChar$1(46);
                    return new A.InterpolatedClassSelector(_this.interpolatedIdentifier$0());
                }
                if (35 === _0_0 && t1.peekChar$1(1) !== 123) {
                    t1.expectChar$1(35);
                    return new A.InterpolatedIDSelector(_this.interpolatedIdentifier$0());
                }
                if (37 === _0_0) {
                    t1.expectChar$1(37);
                    $name = _this.interpolatedIdentifier$0();
                    if (_this.get$plainCss()) _this.error$2(0, string$.Placeh, _this.spanFrom$1(start));
                    return new A.InterpolatedPlaceholderSelector($name);
                }
                if (58 === _0_0) return _this._stylesheet0$_pseudoSelector$0();
                if (38 === _0_0) {
                    t2 = t1._string_scanner$_position;
                    t1.expectChar$1(38);
                    if (_this._stylesheet0$_lookingAtInterpolatedIdentifierBody$0()) {
                        t3 = t1._string_scanner$_position;
                        t4 = new A.StringBuffer("");
                        t5 = A._setArrayType([], type$.JSArray_Object);
                        text = new A.InterpolationBuffer0(t4, t5, A._setArrayType([], type$.JSArray_nullable_FileSpan));
                        _this._stylesheet0$_interpolatedIdentifierBodyHelper$1(text);
                        if (t5.length === 0 && t4._contents.length === 0) t1.error$1(0, "Expected identifier body.");
                        suffix = text.interpolation$1(_this.spanFrom$1(new A._SpanScannerState(t1, t3)));
                    } else suffix = null;
                    if (_this.get$plainCss() && suffix != null) t1.error$3$length$position(0, string$.Parent, t1._string_scanner$_position - t2, t2);
                    t1 = _this.spanFrom$1(new A._SpanScannerState(t1, t2));
                    if (!allowParent) _this.error$2(0, "Parent selectors aren't allowed here.", _this.spanFrom$1(start));
                    return new A.InterpolatedParentSelector(suffix, t1);
                }
                return _this._stylesheet0$_typeOrUniversalSelector$0();
            },
            _stylesheet0$_simpleSelector$0: function() {
                return this._stylesheet0$_simpleSelector$1$allowParent(true);
            },
            _stylesheet0$_attributeSelector$0: function() {
                var $name, operator, next, value, modifier, _this = this, _null = null, t1 = _this.scanner, start = new A._SpanScannerState(t1, t1._string_scanner$_position);
                t1.expectChar$1(91);
                _this.whitespace$1$consumeNewlines(true);
                $name = _this._stylesheet0$_attributeName$0();
                _this.whitespace$1$consumeNewlines(true);
                if (t1.scanChar$1(93)) return new A.InterpolatedAttributeSelector($name, _null, _null, _null, _this.spanFrom$1(start));
                operator = _this._stylesheet0$_attributeOperator$0();
                _this.whitespace$1$consumeNewlines(true);
                next = t1.peekChar$0();
                value = next === 39 || next === 34 ? _this.interpolatedStringToken$0() : _this.interpolatedIdentifier$0();
                _this.whitespace$1$consumeNewlines(true);
                modifier = _this._stylesheet0$_lookingAtInterpolatedIdentifier$0() ? _this.interpolatedIdentifier$0() : _null;
                _this.whitespace$1$consumeNewlines(true);
                t1.expectChar$1(93);
                return new A.InterpolatedAttributeSelector($name, operator, value, modifier, _this.spanFrom$1(start));
            },
            _stylesheet0$_attributeName$0: function() {
                var t2, t3, nameOrNamespace, _this = this, t1 = _this.scanner, start = new A._SpanScannerState(t1, t1._string_scanner$_position);
                if (t1.scanChar$1(42)) {
                    t2 = _this.spanFrom$1(start);
                    t3 = A.List_List$unmodifiable([
                        "*"
                    ], type$.Object);
                    t1.expectChar$1(124);
                    return new A.InterpolatedQualifiedName(_this.interpolatedIdentifier$0(), _this.spanFrom$1(start), new A.Interpolation0(t3, B.List_null, t2));
                }
                if (t1.scanChar$1(124)) {
                    t1 = _this.spanFrom$2(start, start);
                    t2 = A.List_List$unmodifiable([
                        ""
                    ], type$.Object);
                    return new A.InterpolatedQualifiedName(_this.interpolatedIdentifier$0(), _this.spanFrom$1(start), new A.Interpolation0(t2, B.List_null, t1));
                }
                nameOrNamespace = _this.interpolatedIdentifier$0();
                if (t1.peekChar$0() !== 124 || t1.peekChar$1(1) === 61) return new A.InterpolatedQualifiedName(nameOrNamespace, _this.spanFrom$1(start), null);
                t1.readChar$0();
                return new A.InterpolatedQualifiedName(_this.interpolatedIdentifier$0(), _this.spanFrom$1(start), nameOrNamespace);
            },
            _stylesheet0$_attributeOperator$0: function() {
                var op, t1 = this.scanner, t2 = t1._string_scanner$_position;
                switch(t1.readChar$0()){
                    case 61:
                        op = B.AttributeOperator_jFZ0;
                        break;
                    case 126:
                        t1.expectChar$1(61);
                        op = B.AttributeOperator_OrK0;
                        break;
                    case 124:
                        t1.expectChar$1(61);
                        op = B.AttributeOperator_g5B0;
                        break;
                    case 94:
                        t1.expectChar$1(61);
                        op = B.AttributeOperator_stc0;
                        break;
                    case 36:
                        t1.expectChar$1(61);
                        op = B.AttributeOperator_xJ90;
                        break;
                    case 42:
                        t1.expectChar$1(61);
                        op = B.AttributeOperator_h200;
                        break;
                    default:
                        t1.error$2$position(0, 'Expected "]".', t2);
                        op = null;
                }
                return new A.CssValue0(op, this.spanFrom$1(new A._SpanScannerState(t1, t2)), type$.CssValue_AttributeOperator);
            },
            _stylesheet0$_pseudoSelector$0: function() {
                var element, $name, unvendored, argument, selector, _this = this, _null = null, t1 = _this.scanner, start = new A._SpanScannerState(t1, t1._string_scanner$_position);
                t1.expectChar$1(58);
                element = t1.scanChar$1(58);
                $name = _this.interpolatedIdentifier$0();
                if (!t1.scanChar$1(40)) return new A.InterpolatedPseudoSelector($name, !element, _null, _null, _this.spanFrom$1(start));
                _this.whitespace$1$consumeNewlines(true);
                unvendored = A.NullableExtension_andThen0($name.get$asPlain(), A.utils1__unvendor$closure());
                argument = _null;
                selector = _null;
                if (element) {
                    if ($.selectorPseudoElements0.contains$1(0, unvendored)) selector = _this._stylesheet0$_selectorList$0();
                    else argument = _this._stylesheet0$_interpolatedDeclarationValue$1$allowEmpty(true);
                } else if ($.selectorPseudoClasses0.contains$1(0, unvendored)) selector = _this._stylesheet0$_selectorList$0();
                else if (unvendored === "nth-child" || unvendored === "nth-last-child") {
                    argument = _this._stylesheet0$_interpolatedDeclarationValue$2$consumeNewlines$endAfterOf(true, true);
                    selector = t1.peekChar$0() !== 41 ? _this._stylesheet0$_selectorList$0() : _null;
                } else argument = _this._stylesheet0$_interpolatedDeclarationValue$1$allowEmpty(true);
                t1.expectChar$1(41);
                return new A.InterpolatedPseudoSelector($name, !element, argument, selector, _this.spanFrom$1(start));
            },
            _stylesheet0$_typeOrUniversalSelector$0: function() {
                var t2, namespace, nameOrNamespace, _this = this, t1 = _this.scanner, start = new A._SpanScannerState(t1, t1._string_scanner$_position);
                if (t1.scanChar$1(42)) {
                    t2 = t1._string_scanner$_position;
                    if (!t1.scanChar$1(124)) return new A.InterpolatedUniversalSelector(null, _this.spanFrom$1(start));
                    t2 = _this.spanFrom$2(start, new A._SpanScannerState(t1, t2));
                    namespace = new A.Interpolation0(A.List_List$unmodifiable([
                        "*"
                    ], type$.Object), B.List_null, t2);
                    return t1.scanChar$1(42) ? new A.InterpolatedUniversalSelector(namespace, _this.spanFrom$1(start)) : new A.InterpolatedTypeSelector(new A.InterpolatedQualifiedName(_this.interpolatedIdentifier$0(), _this.spanFrom$1(start), namespace));
                } else if (t1.scanChar$1(124)) {
                    t2 = _this.spanFrom$2(start, start);
                    namespace = new A.Interpolation0(A.List_List$unmodifiable([
                        ""
                    ], type$.Object), B.List_null, t2);
                    return t1.scanChar$1(42) ? new A.InterpolatedUniversalSelector(namespace, _this.spanFrom$1(start)) : new A.InterpolatedTypeSelector(new A.InterpolatedQualifiedName(_this.interpolatedIdentifier$0(), _this.spanFrom$1(start), namespace));
                }
                nameOrNamespace = _this.interpolatedIdentifier$0();
                if (!t1.scanChar$1(124)) return new A.InterpolatedTypeSelector(new A.InterpolatedQualifiedName(nameOrNamespace, _this.spanFrom$1(start), null));
                else if (t1.scanChar$1(42)) return new A.InterpolatedUniversalSelector(nameOrNamespace, _this.spanFrom$1(start));
                else return new A.InterpolatedTypeSelector(new A.InterpolatedQualifiedName(_this.interpolatedIdentifier$0(), _this.spanFrom$1(start), nameOrNamespace));
            },
            _stylesheet0$_isSimpleSelectorStart$1: function(character) {
                var t1;
                $label0$0: {
                    t1 = true;
                    if (42 !== character) {
                        if (91 !== character) {
                            if (46 !== character) {
                                if (35 !== character) {
                                    if (37 !== character) {
                                        t1 = 58 === character;
                                        t1;
                                    }
                                }
                            }
                        }
                    }
                    if (t1) {
                        t1 = true;
                        break $label0$0;
                    }
                    if (38 === character) {
                        t1 = this.get$plainCss();
                        break $label0$0;
                    }
                    t1 = false;
                    break $label0$0;
                }
                return t1;
            },
            _stylesheet0$_mediaQueryList$0: function() {
                var t4, _this = this, t1 = _this.scanner, t2 = t1._string_scanner$_position, t3 = new A.StringBuffer(""), buffer = new A.InterpolationBuffer0(t3, A._setArrayType([], type$.JSArray_Object), A._setArrayType([], type$.JSArray_nullable_FileSpan));
                for(;;){
                    _this.whitespace$1$consumeNewlines(false);
                    _this._stylesheet0$_mediaQuery$1(buffer);
                    _this.whitespace$1$consumeNewlines(false);
                    if (!t1.scanChar$1(44)) break;
                    t4 = A.Primitives_stringFromCharCode(44);
                    t3._contents += t4;
                    t4 = A.Primitives_stringFromCharCode(32);
                    t3._contents += t4;
                }
                return buffer.interpolation$1(_this.spanFrom$1(new A._SpanScannerState(t1, t2)));
            },
            _stylesheet0$_mediaQuery$1: function(buffer) {
                var identifier1, t1, t2, identifier2, _this = this, _s3_ = "and";
                if (_this.scanner.peekChar$0() === 40) {
                    _this._stylesheet0$_mediaInParens$1(buffer);
                    _this.whitespace$1$consumeNewlines(false);
                    if (_this.scanIdentifier$1(_s3_)) {
                        buffer._interpolation_buffer0$_text._contents += " and ";
                        _this.expectWhitespace$0();
                        _this._stylesheet0$_mediaLogicSequence$2(buffer, _s3_);
                    } else if (_this.scanIdentifier$1("or")) {
                        buffer._interpolation_buffer0$_text._contents += " or ";
                        _this.expectWhitespace$0();
                        _this._stylesheet0$_mediaLogicSequence$2(buffer, "or");
                    }
                    return;
                }
                identifier1 = _this.interpolatedIdentifier$0();
                if (A.equalsIgnoreCase0(identifier1.get$asPlain(), "not")) {
                    _this.expectWhitespace$0();
                    if (!_this._stylesheet0$_lookingAtInterpolatedIdentifier$0()) {
                        buffer._interpolation_buffer0$_text._contents += "not ";
                        _this._stylesheet0$_mediaOrInterp$1(buffer);
                        return;
                    }
                }
                _this.whitespace$1$consumeNewlines(false);
                buffer.addInterpolation$1(identifier1);
                if (!_this._stylesheet0$_lookingAtInterpolatedIdentifier$0()) return;
                t1 = buffer._interpolation_buffer0$_text;
                t2 = A.Primitives_stringFromCharCode(32);
                t1._contents += t2;
                identifier2 = _this.interpolatedIdentifier$0();
                if (A.equalsIgnoreCase0(identifier2.get$asPlain(), _s3_)) {
                    _this.expectWhitespace$0();
                    t1._contents += " and ";
                } else {
                    _this.whitespace$1$consumeNewlines(false);
                    buffer.addInterpolation$1(identifier2);
                    if (_this.scanIdentifier$1(_s3_)) {
                        _this.expectWhitespace$0();
                        t1._contents += " and ";
                    } else return;
                }
                if (_this.scanIdentifier$1("not")) {
                    _this.expectWhitespace$0();
                    t1._contents += "not ";
                    _this._stylesheet0$_mediaOrInterp$1(buffer);
                    return;
                }
                _this._stylesheet0$_mediaLogicSequence$2(buffer, _s3_);
                return;
            },
            _stylesheet0$_mediaLogicSequence$2: function(buffer, operator) {
                var t1, t2, t3, _this = this;
                for(t1 = buffer._interpolation_buffer0$_text;;){
                    _this._stylesheet0$_mediaOrInterp$1(buffer);
                    _this.whitespace$1$consumeNewlines(false);
                    if (!_this.scanIdentifier$1(operator)) return;
                    _this.expectWhitespace$1$consumeNewlines(false);
                    t2 = A.Primitives_stringFromCharCode(32);
                    t3 = (t1._contents += t2) + operator;
                    t1._contents = t3;
                    t1._contents = t3 + t2;
                }
            },
            _stylesheet0$_mediaOrInterp$1: function(buffer) {
                var _0_0;
                if (this.scanner.peekChar$0() === 35) {
                    _0_0 = this.singleInterpolation$0();
                    buffer.add$2(0, _0_0._0, _0_0._1);
                } else this._stylesheet0$_mediaInParens$1(buffer);
            },
            _stylesheet0$_mediaInParens$1: function(buffer) {
                var t2, t3, expressionBefore, expressionAfter, next, t4, t5, expressionMiddle, _this = this, t1 = _this.scanner;
                t1.expectChar$2$name(40, "media condition in parentheses");
                t2 = buffer._interpolation_buffer0$_text;
                t3 = A.Primitives_stringFromCharCode(40);
                t2._contents += t3;
                _this.whitespace$1$consumeNewlines(true);
                if (t1.peekChar$0() === 40) {
                    _this._stylesheet0$_mediaInParens$1(buffer);
                    _this.whitespace$1$consumeNewlines(true);
                    if (_this.scanIdentifier$1("and")) {
                        t2._contents += " and ";
                        _this.expectWhitespace$1$consumeNewlines(true);
                        _this._stylesheet0$_mediaLogicSequence$2(buffer, "and");
                    } else if (_this.scanIdentifier$1("or")) {
                        t2._contents += " or ";
                        _this.expectWhitespace$1$consumeNewlines(true);
                        _this._stylesheet0$_mediaLogicSequence$2(buffer, "or");
                    }
                } else if (_this.scanIdentifier$1("not")) {
                    t2._contents += "not ";
                    _this.expectWhitespace$1$consumeNewlines(true);
                    _this._stylesheet0$_mediaOrInterp$1(buffer);
                } else {
                    expressionBefore = _this._stylesheet0$_expressionUntilComparison$0();
                    buffer.add$2(0, expressionBefore, expressionBefore.get$span(expressionBefore));
                    if (t1.scanChar$1(58)) {
                        _this.whitespace$1$consumeNewlines(true);
                        t3 = A.Primitives_stringFromCharCode(58);
                        t2._contents += t3;
                        t3 = A.Primitives_stringFromCharCode(32);
                        t2._contents += t3;
                        expressionAfter = _this._stylesheet0$_expression$1$consumeNewlines(true);
                        buffer.add$2(0, expressionAfter, expressionAfter.get$span(expressionAfter));
                    } else {
                        next = t1.peekChar$0();
                        t3 = 60 !== next;
                        if (!t3 || 62 === next || 61 === next) {
                            t4 = A.Primitives_stringFromCharCode(32);
                            t2._contents += t4;
                            t5 = A.Primitives_stringFromCharCode(t1.readChar$0());
                            t2._contents += t5;
                            if ((!t3 || 62 === next) && t1.scanChar$1(61)) {
                                t5 = A.Primitives_stringFromCharCode(61);
                                t2._contents += t5;
                            }
                            t2._contents += t4;
                            _this.whitespace$1$consumeNewlines(true);
                            expressionMiddle = _this._stylesheet0$_expressionUntilComparison$0();
                            buffer.add$2(0, expressionMiddle, expressionMiddle.get$span(expressionMiddle));
                            if (!t3 || 62 === next) {
                                next.toString;
                                t3 = t1.scanChar$1(next);
                            } else t3 = false;
                            if (t3) {
                                t2._contents += t4;
                                t3 = A.Primitives_stringFromCharCode(next);
                                t2._contents += t3;
                                if (t1.scanChar$1(61)) {
                                    t3 = A.Primitives_stringFromCharCode(61);
                                    t2._contents += t3;
                                }
                                t2._contents += t4;
                                _this.whitespace$1$consumeNewlines(true);
                                expressionAfter = _this._stylesheet0$_expressionUntilComparison$0();
                                buffer.add$2(0, expressionAfter, expressionAfter.get$span(expressionAfter));
                            }
                        }
                    }
                }
                t1.expectChar$1(41);
                _this.whitespace$1$consumeNewlines(false);
                t1 = A.Primitives_stringFromCharCode(41);
                t2._contents += t1;
            },
            _stylesheet0$_expressionUntilComparison$0: function() {
                return this._stylesheet0$_expression$2$consumeNewlines$until(true, new A.StylesheetParser__expressionUntilComparison_closure0(this));
            },
            _stylesheet0$_supportsCondition$1$inParentheses: function(inParentheses) {
                var condition, operator, _this = this, t1 = _this.scanner, start = new A._SpanScannerState(t1, t1._string_scanner$_position);
                if (_this.scanIdentifier$1("not")) {
                    _this.whitespace$1$consumeNewlines(inParentheses);
                    return new A.SupportsNegation0(_this._stylesheet0$_supportsConditionInParens$0(), _this.spanFrom$1(start));
                }
                condition = _this._stylesheet0$_supportsConditionInParens$0();
                _this.whitespace$1$consumeNewlines(inParentheses);
                for(operator = null; _this.lookingAtIdentifier$0();){
                    if (operator != null) _this.expectIdentifier$1(operator._name);
                    else if (_this.scanIdentifier$1("or")) operator = B.BooleanOperator_10;
                    else {
                        _this.expectIdentifier$1("and");
                        operator = B.BooleanOperator_00;
                    }
                    _this.whitespace$1$consumeNewlines(inParentheses);
                    condition = new A.SupportsOperation0(condition, _this._stylesheet0$_supportsConditionInParens$0(), operator, _this.spanFrom$1(start));
                    _this.whitespace$1$consumeNewlines(inParentheses);
                }
                return condition;
            },
            _stylesheet0$_supportsCondition$0: function() {
                return this._stylesheet0$_supportsCondition$1$inParentheses(false);
            },
            _stylesheet0$_supportsConditionInParens$0: function() {
                var $name, nameStart, wasInParentheses, identifier, _1_0, operation, contents, identifier0, t2, $arguments, _0_0, _0_4_isSet, _0_4, condition, _$exception, value, _this = this, t1 = _this.scanner, start = new A._SpanScannerState(t1, t1._string_scanner$_position);
                if (_this._stylesheet0$_lookingAtInterpolatedIdentifier$0()) {
                    identifier0 = _this.interpolatedIdentifier$0();
                    t2 = identifier0.get$asPlain();
                    if ((t2 == null ? null : t2.toLowerCase()) === "not") _this.error$2(0, '"not" is not a valid identifier here.', identifier0.span);
                    if (t1.scanChar$1(40)) {
                        $arguments = _this._stylesheet0$_interpolatedDeclarationValue$3$allowEmpty$allowSemicolon$consumeNewlines(true, true, true);
                        t1.expectChar$1(41);
                        return new A.SupportsFunction0(identifier0, $arguments, _this.spanFrom$1(start));
                    } else {
                        _0_0 = identifier0.contents;
                        _0_4_isSet = _0_0.length === 1;
                        if (_0_4_isSet) {
                            _0_4 = _0_0[0];
                            t2 = _0_4 instanceof A.Expression0;
                        } else {
                            _0_4 = null;
                            t2 = false;
                        }
                        if (t2) {
                            t1 = _0_4_isSet ? _0_4 : _0_0[0];
                            return new A.SupportsInterpolation0(type$.Expression_2._as(t1), _this.spanFrom$1(start));
                        } else _this.error$2(0, "Expected @supports condition.", identifier0.span);
                    }
                }
                t1.expectChar$1(40);
                _this.whitespace$1$consumeNewlines(true);
                if (_this.scanIdentifier$1("not")) {
                    _this.whitespace$1$consumeNewlines(true);
                    condition = _this._stylesheet0$_supportsConditionInParens$0();
                    t1.expectChar$1(41);
                    return new A.SupportsNegation0(condition, _this.spanFrom$1(start));
                } else if (t1.peekChar$0() === 40) {
                    condition = _this._stylesheet0$_supportsCondition$1$inParentheses(true);
                    t1.expectChar$1(41);
                    return condition.withSpan$1(_this.spanFrom$1(start));
                }
                $name = null;
                nameStart = new A._SpanScannerState(t1, t1._string_scanner$_position);
                wasInParentheses = _this._stylesheet0$_inParentheses;
                try {
                    $name = _this._stylesheet0$_expression$1$consumeNewlines(true);
                    t1.expectChar$1(58);
                } catch (exception) {
                    if (type$.FormatException._is(A.unwrapException(exception))) {
                        t1.set$state(nameStart);
                        _this._stylesheet0$_inParentheses = wasInParentheses;
                        identifier = _this.interpolatedIdentifier$0();
                        _1_0 = _this._stylesheet0$_trySupportsOperation$2(identifier, nameStart);
                        operation = null;
                        if (_1_0 != null) {
                            operation = _1_0;
                            t1.expectChar$1(41);
                            t1 = operation;
                            t2 = _this.spanFrom$1(start);
                            return new A.SupportsOperation0(t1.left, t1.right, t1.operator, t2);
                        }
                        t2 = new A.InterpolationBuffer0(new A.StringBuffer(""), A._setArrayType([], type$.JSArray_Object), A._setArrayType([], type$.JSArray_nullable_FileSpan));
                        t2.addInterpolation$1(identifier);
                        t2.addInterpolation$1(_this._stylesheet0$_interpolatedDeclarationValue$4$allowColon$allowEmpty$allowSemicolon$consumeNewlines(false, true, true, true));
                        contents = t2.interpolation$1(_this.spanFrom$1(nameStart));
                        if (t1.peekChar$0() === 58) throw exception;
                        t1.expectChar$1(41);
                        return new A.SupportsAnything0(contents, _this.spanFrom$1(start));
                    } else throw exception;
                }
                value = _this._stylesheet0$_supportsDeclarationValue$1($name);
                t1.expectChar$1(41);
                return new A.SupportsDeclaration0($name, value, _this.spanFrom$1(start));
            },
            _stylesheet0$_supportsDeclarationValue$1: function($name) {
                var t1 = false;
                if ($name instanceof A.StringExpression0) {
                    if (!$name.hasQuotes) t1 = B.JSString_methods.startsWith$1($name.text.get$initialPlain(), "--");
                }
                if (t1) return new A.StringExpression0(this._stylesheet0$_interpolatedDeclarationValue$0(), false);
                else {
                    this.whitespace$1$consumeNewlines(true);
                    return this._stylesheet0$_expression$1$consumeNewlines(true);
                }
            },
            _stylesheet0$_trySupportsOperation$2: function(interpolation, start) {
                var expression, t2, t3, operator, operation, right, t4, _this = this, _null = null, t1 = interpolation.contents;
                if (t1.length !== 1) return _null;
                expression = B.JSArray_methods.get$first(t1);
                if (!(expression instanceof A.Expression0)) return _null;
                t1 = _this.scanner;
                t2 = t1._string_scanner$_position;
                _this.whitespace$1$consumeNewlines(true);
                for(t3 = interpolation.span, operator = _null, operation = operator; _this.lookingAtIdentifier$0();){
                    if (operator != null) _this.expectIdentifier$1(operator._name);
                    else if (_this.scanIdentifier$1("and")) operator = B.BooleanOperator_00;
                    else {
                        if (!_this.scanIdentifier$1("or")) {
                            if ((t2 === 0 ? 1 / t2 < 0 : t2 < 0) || t2 > t1.string.length) A.throwExpression(A.ArgumentError$("Invalid position " + t2, _null));
                            t1._string_scanner$_position = t2;
                            return t1._lastMatch = null;
                        }
                        operator = B.BooleanOperator_10;
                    }
                    _this.whitespace$1$consumeNewlines(true);
                    right = _this._stylesheet0$_supportsConditionInParens$0();
                    t4 = operation == null ? new A.SupportsInterpolation0(expression, t3) : operation;
                    operation = new A.SupportsOperation0(t4, right, operator, _this.spanFrom$1(start));
                    _this.whitespace$1$consumeNewlines(true);
                }
                return operation;
            },
            _stylesheet0$_lookingAtInterpolatedIdentifier$0: function() {
                var t2, _0_0, t1 = this.scanner, _1_0 = t1.peekChar$0();
                $label0$0: {
                    t2 = false;
                    if (_1_0 == null) {
                        t1 = t2;
                        break $label0$0;
                    }
                    if (_1_0 === 95 || A.CharacterExtension_get_isAlphabetic0(_1_0) || _1_0 >= 128 || 92 === _1_0) {
                        t1 = true;
                        break $label0$0;
                    }
                    if (35 === _1_0) {
                        t1 = t1.peekChar$1(1) === 123;
                        break $label0$0;
                    }
                    if (45 === _1_0) {
                        _0_0 = t1.peekChar$1(1);
                        $label1$1: {
                            if (_0_0 == null) {
                                t1 = t2;
                                break $label1$1;
                            }
                            if (35 === _0_0) {
                                t1 = t1.peekChar$1(2) === 123;
                                break $label1$1;
                            }
                            if (_0_0 === 95 || A.CharacterExtension_get_isAlphabetic0(_0_0) || _0_0 >= 128 || 92 === _0_0 || 45 === _0_0) {
                                t1 = true;
                                break $label1$1;
                            }
                            t1 = t2;
                            break $label1$1;
                        }
                        break $label0$0;
                    }
                    t1 = t2;
                    break $label0$0;
                }
                return t1;
            },
            _stylesheet0$_lookingAtPotentialPropertyHack$0: function() {
                var t1 = this.scanner, _0_0 = t1.peekChar$0();
                $label0$0: {
                    if (58 === _0_0 || 42 === _0_0 || 46 === _0_0) {
                        t1 = true;
                        break $label0$0;
                    }
                    if (35 === _0_0) {
                        t1 = t1.peekChar$1(1) !== 123;
                        break $label0$0;
                    }
                    t1 = false;
                    break $label0$0;
                }
                return t1;
            },
            _stylesheet0$_lookingAtInterpolatedIdentifierBody$0: function() {
                var t2, t3, t1 = this.scanner, _0_0 = t1.peekChar$0();
                $label0$0: {
                    t2 = false;
                    if (_0_0 == null) {
                        t1 = t2;
                        break $label0$0;
                    }
                    if (!(_0_0 === 95 || A.CharacterExtension_get_isAlphabetic0(_0_0) || _0_0 >= 128)) t3 = _0_0 >= 48 && _0_0 <= 57 || _0_0 === 45;
                    else t3 = true;
                    if (t3 || 92 === _0_0) {
                        t1 = true;
                        break $label0$0;
                    }
                    if (35 === _0_0) {
                        t1 = t1.peekChar$1(1) === 123;
                        break $label0$0;
                    }
                    t1 = t2;
                    break $label0$0;
                }
                return t1;
            },
            _stylesheet0$_lookingAtExpression$0: function() {
                var t2, _0_0, t1 = this.scanner, _1_0 = t1.peekChar$0();
                $label0$0: {
                    t2 = true;
                    if (_1_0 == null) {
                        t1 = false;
                        break $label0$0;
                    }
                    if (46 === _1_0) {
                        t1 = t1.peekChar$1(1) !== 46;
                        break $label0$0;
                    }
                    if (33 === _1_0) {
                        _0_0 = t1.peekChar$1(1);
                        $label1$1: {
                            if (_0_0 != null) {
                                if (105 !== _0_0) {
                                    if (73 !== _0_0) t1 = _0_0 === 32 || _0_0 === 9 || _0_0 === 10 || _0_0 === 13 || _0_0 === 12;
                                    else t1 = t2;
                                } else t1 = t2;
                            } else t1 = t2;
                            break $label1$1;
                        }
                        break $label0$0;
                    }
                    t1 = true;
                    if (40 !== _1_0) {
                        if (47 !== _1_0) {
                            if (91 !== _1_0) {
                                if (39 !== _1_0) {
                                    if (34 !== _1_0) {
                                        if (35 !== _1_0) {
                                            if (43 !== _1_0) {
                                                if (45 !== _1_0) {
                                                    if (92 !== _1_0) {
                                                        if (36 !== _1_0) {
                                                            if (38 !== _1_0) {
                                                                if (37 !== _1_0) {
                                                                    if (!(_1_0 === 95 || A.CharacterExtension_get_isAlphabetic0(_1_0) || _1_0 >= 128)) t1 = _1_0 >= 48 && _1_0 <= 57;
                                                                }
                                                            }
                                                        }
                                                    }
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                    if (t1) {
                        t1 = t2;
                        break $label0$0;
                    }
                    t1 = false;
                    break $label0$0;
                }
                return t1;
            },
            _stylesheet0$_withChildren$1$3: function(child, start, create) {
                var result = create.call$2(this.children$1(0, child), this.spanFrom$1(start));
                this.whitespaceWithoutComments$1$consumeNewlines(false);
                return result;
            },
            _stylesheet0$_withChildren$3: function(child, start, create) {
                return this._stylesheet0$_withChildren$1$3(child, start, create, type$.dynamic);
            },
            _stylesheet0$_urlString$0: function() {
                var innerError, stackTrace, _$exception, _this = this, t1 = _this.scanner, start = new A._SpanScannerState(t1, t1._string_scanner$_position), url = _this.string$0();
                try {
                    t1 = A.Uri_parse(url);
                    return t1;
                } catch (exception) {
                    t1 = A.unwrapException(exception);
                    if (type$.FormatException._is(t1)) {
                        innerError = t1;
                        stackTrace = A.getTraceFromException(exception);
                        _this.error$3(0, "Invalid URL: " + J.get$message$x(innerError), _this.spanFrom$1(start), stackTrace);
                    } else throw exception;
                }
            },
            _stylesheet0$_publicIdentifier$0: function() {
                var _this = this, t1 = _this.scanner, t2 = t1._string_scanner$_position, result = _this.identifier$0();
                _this._stylesheet0$_assertPublic$2(result, new A.StylesheetParser__publicIdentifier_closure0(_this, new A._SpanScannerState(t1, t2)));
                return result;
            },
            _stylesheet0$_assertPublic$2: function(identifier, span) {
                var first = identifier.charCodeAt(0);
                if (!(first === 45 || first === 95)) return;
                this.error$2(0, string$.Privat, span.call$0());
            },
            _stylesheet0$_addOrInject$2: function(buffer, expression) {
                if (expression instanceof A.StringExpression0 && !expression.hasQuotes) buffer.addInterpolation$1(expression.text);
                else buffer.add$2(0, expression, expression.get$span(expression));
            },
            get$plainCss: function() {
                return false;
            }
        };
        A.StylesheetParser_parse_closure0.prototype = {
            call$0: function() {
                var statements, t1 = this.$this, t2 = t1.scanner, t3 = t2._string_scanner$_position;
                t2.scanChar$1(65279);
                statements = t1.statements$1(new A.StylesheetParser_parse__closure0(t1));
                t2.expectDone$0();
                return A.Stylesheet$internal0(statements, t1.spanFrom$1(new A._SpanScannerState(t2, t3)), t1.warnings, t1._stylesheet0$_globalVariables, t1.get$plainCss());
            },
            $signature: 620
        };
        A.StylesheetParser_parse__closure0.prototype = {
            call$0: function() {
                var t1 = this.$this;
                if (t1.scanner.scan$1("@charset")) {
                    t1.whitespace$1$consumeNewlines(false);
                    t1.string$0();
                    return null;
                }
                return t1._stylesheet0$_statement$1$root(true);
            },
            $signature: 621
        };
        A.StylesheetParser_parseParameterList_closure0.prototype = {
            call$0: function() {
                var parameters, t1 = this.$this, t2 = t1.scanner;
                t2.expectChar$2$name(64, "@-rule");
                t1.identifier$0();
                t1.whitespace$1$consumeNewlines(true);
                t1.identifier$0();
                parameters = t1._stylesheet0$_parameterList$0();
                t1.whitespace$1$consumeNewlines(true);
                t2.expectChar$1(123);
                return parameters;
            },
            $signature: 622
        };
        A.StylesheetParser__parseSingleProduction_closure0.prototype = {
            call$0: function() {
                var result = this.production.call$0();
                this.$this.scanner.expectDone$0();
                return result;
            },
            $signature: function() {
                return this.T._eval$1("0()");
            }
        };
        A.StylesheetParser_parseSignature_closure.prototype = {
            call$0: function() {
                var parameters, t2, t3, t1 = this.$this, $name = t1.identifier$0();
                if (this.requireParens || t1.scanner.peekChar$0() === 40) parameters = t1._stylesheet0$_parameterList$0();
                else {
                    t2 = t1.scanner;
                    t2 = A.FileLocation$_(t2._sourceFile, t2._string_scanner$_position);
                    t3 = t2.offset;
                    parameters = new A.ParameterList0(B.List_empty27, null, A._FileSpan$(t2.file, t3, t3));
                }
                t1.scanner.expectDone$0();
                return new A._Record_2($name, parameters);
            },
            $signature: 623
        };
        A.StylesheetParser__statement_closure0.prototype = {
            call$0: function() {
                return this.$this._stylesheet0$_statement$0();
            },
            $signature: 137
        };
        A.StylesheetParser_variableDeclarationWithoutNamespace_closure1.prototype = {
            call$0: function() {
                return this.$this.spanFrom$1(this.start);
            },
            $signature: 16
        };
        A.StylesheetParser_variableDeclarationWithoutNamespace_closure2.prototype = {
            call$0: function() {
                return this.declaration.span;
            },
            $signature: 16
        };
        A.StylesheetParser__declarationOrBuffer_closure3.prototype = {
            call$0: function() {
                return this.$this.whitespace$1$consumeNewlines(false);
            },
            $signature: 0
        };
        A.StylesheetParser__declarationOrBuffer_closure4.prototype = {
            call$0: function() {
                return this.$this.whitespace$1$consumeNewlines(false);
            },
            $signature: 0
        };
        A.StylesheetParser__declarationOrBuffer_closure5.prototype = {
            call$1: function($name) {
                return A.equalsIgnoreCase0($name, "result");
            },
            $signature: 4
        };
        A.StylesheetParser__declarationOrBuffer_closure6.prototype = {
            call$0: function() {
                return this.$this.whitespace$1$consumeNewlines(false);
            },
            $signature: 0
        };
        A.StylesheetParser__styleRule_closure0.prototype = {
            call$2: function(children, span) {
                return A.StyleRule$withParsedSelector(this.selector, children, this.$this.spanFrom$1(this.start));
            },
            $signature: 269
        };
        A.StylesheetParser__styleRule_closure1.prototype = {
            call$2: function(children, span) {
                return A.StyleRule$0(this._box_0.interpolation, children, this.$this.spanFrom$1(this.start));
            },
            $signature: 269
        };
        A.StylesheetParser__withStyleRuleChildren_closure0.prototype = {
            call$2: function(children, span) {
                var t2, _this = this, t1 = _this.$this;
                if (t1.get$indented() && children.length === 0) {
                    t2 = _this.nodeWithSpan;
                    t1.warnings.push(new A._Record_3_deprecation_message_span(null, string$.This_s, t2.get$span(t2)));
                }
                t1._stylesheet0$_inStyleRule = _this.wasInStyleRule;
                return _this.create.call$2(children, span);
            },
            $signature: function() {
                return this.T._eval$1("0(List<Statement0>,FileSpan)");
            }
        };
        A.StylesheetParser__propertyOrVariableDeclaration_closure0.prototype = {
            call$0: function() {
                return this.$this.whitespace$1$consumeNewlines(false);
            },
            $signature: 0
        };
        A.StylesheetParser__tryDeclarationChildren_closure0.prototype = {
            call$2: function(children, span) {
                return A.Declaration$nested0(this.name, children, span, this.value);
            },
            $signature: 625
        };
        A.StylesheetParser__atRootRule_closure1.prototype = {
            call$2: function(children, span) {
                return A.AtRootRule$0(children, span, this.query);
            },
            $signature: 270
        };
        A.StylesheetParser__atRootRule_closure2.prototype = {
            call$2: function(children, span) {
                return A.AtRootRule$0(children, span, null);
            },
            $signature: 270
        };
        A.StylesheetParser__eachRule_closure0.prototype = {
            call$2: function(children, span) {
                var _this = this;
                _this.$this._stylesheet0$_inControlDirective = _this.wasInControlDirective;
                return A.EachRule$0(_this.variables, _this.list, children, span);
            },
            $signature: 627
        };
        A.StylesheetParser__functionRule_closure0.prototype = {
            call$2: function(children, span) {
                return A.FunctionRule$0(this.name, this.parameters, children, span, this.precedingComment);
            },
            $signature: 628
        };
        A.StylesheetParser__forRule_closure1.prototype = {
            call$0: function() {
                var t1 = this.$this;
                if (!t1.lookingAtIdentifier$0()) return false;
                if (t1.scanIdentifier$1("to")) return this._box_0.exclusive = true;
                else if (t1.scanIdentifier$1("through")) {
                    this._box_0.exclusive = false;
                    return true;
                } else return false;
            },
            $signature: 20
        };
        A.StylesheetParser__forRule_closure2.prototype = {
            call$2: function(children, span) {
                var t1, _this = this;
                _this.$this._stylesheet0$_inControlDirective = _this.wasInControlDirective;
                t1 = _this._box_0.exclusive;
                t1.toString;
                return A.ForRule$0(_this.variable, _this.from, _this.to, children, span, t1);
            },
            $signature: 629
        };
        A.StylesheetParser__memberList_closure0.prototype = {
            call$0: function() {
                var t1 = this.$this;
                if (t1.scanner.peekChar$0() === 36) this.variables.add$1(0, t1.variableName$0());
                else this.identifiers.add$1(0, t1.identifier$1$normalize(true));
            },
            $signature: 1
        };
        A.StylesheetParser__includeRule_closure0.prototype = {
            call$2: function(children, span) {
                return A.ContentBlock$0(this.contentParameters_, children, span);
            },
            $signature: 630
        };
        A.StylesheetParser_mediaRule_closure0.prototype = {
            call$2: function(children, span) {
                return A.MediaRule$0(this.query, children, span);
            },
            $signature: 631
        };
        A.StylesheetParser__mixinRule_closure0.prototype = {
            call$2: function(children, span) {
                var _this = this;
                _this.$this._stylesheet0$_inMixin = false;
                return A.MixinRule$0(_this.name, _this.parameters, children, span, _this.precedingComment);
            },
            $signature: 632
        };
        A.StylesheetParser_mozDocumentRule_closure1.prototype = {
            call$0: function() {
                return this.$this.whitespace$1$consumeNewlines(false);
            },
            $signature: 0
        };
        A.StylesheetParser_mozDocumentRule_closure2.prototype = {
            call$2: function(children, span) {
                var _this = this;
                if (_this._box_0.needsDeprecationWarning) _this.$this.warnings.push(new A._Record_3_deprecation_message_span(B.Deprecation_Gmv, string$.x40_moz_, span));
                return A.AtRule$0(_this.name, span, children, _this.value);
            },
            $signature: 271
        };
        A.StylesheetParser_supportsRule_closure0.prototype = {
            call$2: function(children, span) {
                return A.SupportsRule$0(this.condition, children, span);
            },
            $signature: 634
        };
        A.StylesheetParser__whileRule_closure0.prototype = {
            call$2: function(children, span) {
                this.$this._stylesheet0$_inControlDirective = this.wasInControlDirective;
                return A.WhileRule$0(this.condition, children, span);
            },
            $signature: 635
        };
        A.StylesheetParser_unknownAtRule_closure0.prototype = {
            call$2: function(children, span) {
                return A.AtRule$0(this.name, span, children, this._box_0.value);
            },
            $signature: 271
        };
        A.StylesheetParser__expression_resetState0.prototype = {
            call$0: function() {
                var t2, t1 = this._box_0;
                t1.operands_ = t1.operators_ = t1.spaceExpressions_ = t1.commaExpressions_ = null;
                t2 = this.$this;
                t2.scanner.set$state(this.start);
                t1.allowSlash = true;
                t1.singleExpression_ = t2._stylesheet0$_singleExpression$0();
            },
            $signature: 0
        };
        A.StylesheetParser__expression_resolveOneOperation0.prototype = {
            call$0: function() {
                var t2, t3, t4, t5, t6, t7, _this = this, t1 = _this._box_0, operator = t1.operators_.pop(), left = t1.operands_.pop(), right = t1.singleExpression_;
                if (right == null) {
                    t2 = _this.$this.scanner;
                    t3 = operator.operator.length;
                    t2.error$3$length$position(0, "Expected expression.", t3, t2._string_scanner$_position - t3);
                }
                if (t1.allowSlash) {
                    t2 = _this.$this;
                    t2 = !t2._stylesheet0$_inParentheses && operator === B.BinaryOperator_ehp0 && t2._stylesheet0$_isSlashOperand$1(left) && t2._stylesheet0$_isSlashOperand$1(right);
                } else t2 = false;
                if (t2) t1.singleExpression_ = new A.BinaryOperationExpression0(B.BinaryOperator_ehp0, left, right, true);
                else {
                    t1.singleExpression_ = new A.BinaryOperationExpression0(operator, left, right, false);
                    t2 = t1.allowSlash = false;
                    if (B.BinaryOperator_jCK0 === operator || B.BinaryOperator_tDf0 === operator) {
                        t3 = _this.$this;
                        t4 = t3.scanner.string;
                        t5 = right.get$span(right);
                        t5 = t5.get$start(t5);
                        t6 = right.get$span(right);
                        t7 = operator.operator;
                        if (B.JSString_methods.substring$2(t4, t5.offset - 1, t6.get$start(t6).offset) === t7) {
                            t2 = left.get$span(left);
                            t2 = t4.charCodeAt(t2.get$end(t2).offset);
                            t2 = t2 === 32 || t2 === 9 || t2 === 10 || t2 === 13 || t2 === 12;
                        }
                        if (t2) {
                            t2 = left.toString$0(0);
                            t4 = right.toString$0(0);
                            t5 = left.toString$0(0);
                            t6 = right.toString$0(0);
                            t1 = t1.singleExpression_;
                            t3.warnings.push(new A._Record_3_deprecation_message_span(B.Deprecation_Kh7, "This operation is parsed as:\n\n    " + t2 + " " + t7 + " " + t4 + string$.x0a_but_ + t5 + " (" + t7 + t6 + ")\n\nAdd a space after " + t7 + string$.x20to_cl, t1.get$span(t1)));
                        }
                    }
                }
            },
            $signature: 0
        };
        A.StylesheetParser__expression_resolveOperations0.prototype = {
            call$0: function() {
                var t1, operators = this._box_0.operators_;
                if (operators == null) return;
                for(t1 = this.resolveOneOperation; operators.length !== 0;)t1.call$0();
            },
            $signature: 0
        };
        A.StylesheetParser__expression_addSingleExpression0.prototype = {
            call$1: function(expression) {
                var t2, spaceExpressions, _this = this, t1 = _this._box_0;
                if (t1.singleExpression_ != null) {
                    t2 = _this.$this;
                    if (t2._stylesheet0$_inParentheses) {
                        t2._stylesheet0$_inParentheses = false;
                        if (t1.allowSlash) {
                            _this.resetState.call$0();
                            return;
                        }
                    }
                    spaceExpressions = t1.spaceExpressions_;
                    if (spaceExpressions == null) spaceExpressions = t1.spaceExpressions_ = A._setArrayType([], type$.JSArray_Expression_2);
                    _this.resolveOperations.call$0();
                    t2 = t1.singleExpression_;
                    t2.toString;
                    spaceExpressions.push(t2);
                    t1.allowSlash = true;
                }
                t1.singleExpression_ = expression;
            },
            $signature: 136
        };
        A.StylesheetParser__expression_addOperator0.prototype = {
            call$1: function(operator) {
                var t2, t3, operators, operands, t4, singleExpression, operatorEnd, _this = this, t1 = _this.$this;
                if (t1.get$plainCss() && operator !== B.BinaryOperator_g6F0 && operator !== B.BinaryOperator_jCK0 && operator !== B.BinaryOperator_tDf0 && operator !== B.BinaryOperator_wkM0 && operator !== B.BinaryOperator_ehp0) {
                    t2 = t1.scanner;
                    t3 = operator.operator.length;
                    t2.error$3$length$position(0, "Operators aren't allowed in plain CSS.", t3, t2._string_scanner$_position - t3);
                }
                t2 = _this._box_0;
                t2.allowSlash = t2.allowSlash && operator === B.BinaryOperator_ehp0;
                operators = t2.operators_;
                if (operators == null) operators = t2.operators_ = A._setArrayType([], type$.JSArray_BinaryOperator_2);
                operands = t2.operands_;
                if (operands == null) operands = t2.operands_ = A._setArrayType([], type$.JSArray_Expression_2);
                t3 = _this.resolveOneOperation;
                t4 = operator.precedence;
                for(;;){
                    if (!(operators.length !== 0 && B.JSArray_methods.get$last(operators).precedence >= t4)) break;
                    t3.call$0();
                }
                singleExpression = t2.singleExpression_;
                if (singleExpression == null) {
                    t3 = t1.scanner;
                    t4 = operator.operator.length;
                    t3.error$3$length$position(0, "Expected expression.", t4, t3._string_scanner$_position - t4);
                }
                operatorEnd = t1.scanner._string_scanner$_position;
                t1.whitespace$1$consumeNewlines(true);
                if (operator === B.BinaryOperator_bgA0 && !t1._stylesheet0$_lookingAtExpression$0()) {
                    t1 = t1.spanFromPosition$2(operatorEnd - 1, operatorEnd);
                    _this.addSingleExpression.call$1(new A.StringExpression0(new A.Interpolation0(A.List_List$unmodifiable([
                        "%"
                    ], type$.Object), B.List_null, t1), false));
                } else {
                    operators.push(operator);
                    operands.push(singleExpression);
                    t2.singleExpression_ = t1._stylesheet0$_singleExpression$0();
                }
            },
            $signature: 636
        };
        A.StylesheetParser__expression_resolveSpaceExpressions0.prototype = {
            call$0: function() {
                var t1, spaceExpressions, singleExpression, t2;
                this.resolveOperations.call$0();
                t1 = this._box_0;
                spaceExpressions = t1.spaceExpressions_;
                if (spaceExpressions == null) return;
                singleExpression = t1.singleExpression_;
                if (singleExpression == null) this.$this.scanner.error$1(0, "Expected expression.");
                spaceExpressions.push(singleExpression);
                t2 = B.JSArray_methods.get$first(spaceExpressions);
                t2 = t2.get$span(t2).expand$1(0, singleExpression.get$span(singleExpression));
                t1.singleExpression_ = new A.ListExpression0(A.List_List$unmodifiable(spaceExpressions, type$.Expression_2), B.ListSeparator_SrV0, false, t2);
                t1.spaceExpressions_ = null;
            },
            $signature: 0
        };
        A.StylesheetParser_expressionUntilComma_closure0.prototype = {
            call$0: function() {
                return this.$this.scanner.peekChar$0() === 44;
            },
            $signature: 20
        };
        A.StylesheetParser__isHexColor_closure0.prototype = {
            call$1: function(char) {
                return A.CharacterExtension_get_isHex0(char);
            },
            $signature: 50
        };
        A.StylesheetParser__unicodeRange_closure1.prototype = {
            call$1: function(char) {
                return char != null && A.CharacterExtension_get_isHex0(char);
            },
            $signature: 31
        };
        A.StylesheetParser__unicodeRange_closure2.prototype = {
            call$1: function(char) {
                return char != null && A.CharacterExtension_get_isHex0(char);
            },
            $signature: 31
        };
        A.StylesheetParser_interpolatedStringToken_closure0.prototype = {
            call$0: function() {
                return A.consumeEscapedCharacter0(this.$this.scanner);
            },
            $signature: 0
        };
        A.StylesheetParser_namespacedExpression_closure0.prototype = {
            call$0: function() {
                return this.$this.spanFrom$1(this.start);
            },
            $signature: 16
        };
        A.StylesheetParser_trySpecialFunction_closure0.prototype = {
            call$1: function(contents) {
                return new A.StringExpression0(contents, false);
            },
            $signature: 637
        };
        A.StylesheetParser__interpolatedDeclarationValue_closure0.prototype = {
            call$0: function() {
                return this.$this.scanIdentifier$2$caseSensitive("of", false);
            },
            $signature: 0
        };
        A.StylesheetParser__expressionUntilComparison_closure0.prototype = {
            call$0: function() {
                var t1 = this.$this.scanner, _0_0 = t1.peekChar$0();
                $label0$0: {
                    if (61 === _0_0) {
                        t1 = t1.peekChar$1(1) !== 61;
                        break $label0$0;
                    }
                    if (60 === _0_0 || 62 === _0_0) {
                        t1 = true;
                        break $label0$0;
                    }
                    t1 = false;
                    break $label0$0;
                }
                return t1;
            },
            $signature: 20
        };
        A.StylesheetParser__publicIdentifier_closure0.prototype = {
            call$0: function() {
                return this.$this.spanFrom$1(this.start);
            },
            $signature: 16
        };
        A.Stylesheet0.prototype = {
            Stylesheet$internal$5$globalVariables$plainCss0: function(children, span, parseTimeWarnings, globalVariables, plainCss) {
                var t1, t2, t3, t4, _i, child;
                for(t1 = this.children, t2 = t1.length, t3 = this._stylesheet1$_forwards, t4 = this._stylesheet1$_uses, _i = 0; _i < t2; ++_i){
                    child = t1[_i];
                    if (child instanceof A.UseRule0) {
                        t4.push(child);
                        continue;
                    }
                    if (child instanceof A.ForwardRule0) {
                        t3.push(child);
                        continue;
                    }
                    if (child instanceof A.SilentComment0 || child instanceof A.LoudComment0 || child instanceof A.VariableDeclaration0) continue;
                    break;
                }
            },
            accept$1$1: function(visitor) {
                return visitor.visitStylesheet$1(0, this);
            },
            accept$1: function(visitor) {
                return this.accept$1$1(visitor, type$.dynamic);
            },
            toString$0: function(_) {
                return B.JSArray_methods.join$1(this.children, " ");
            },
            get$span: function(receiver) {
                return this.span;
            }
        };
        A.SupportsExpression0.prototype = {
            get$span: function(_) {
                var t1 = this.condition;
                return t1.get$span(t1);
            },
            accept$1$1: function(visitor) {
                return visitor.visitSupportsExpression$1(0, this);
            },
            accept$1: function(visitor) {
                return this.accept$1$1(visitor, type$.dynamic);
            },
            toString$0: function(_) {
                return this.condition.toString$0(0);
            }
        };
        A.ModifiableCssSupportsRule0.prototype = {
            accept$1$1: function(visitor) {
                return visitor.visitCssSupportsRule$1(this);
            },
            accept$1: function(visitor) {
                return this.accept$1$1(visitor, type$.dynamic);
            },
            equalsIgnoringChildren$1: function(other) {
                var t1, t2;
                if (other instanceof A.ModifiableCssSupportsRule0) {
                    t1 = this.condition;
                    t2 = other.condition;
                    t1 = t1.$ti._is(t2) && J.$eq$(t2.value, t1.value);
                } else t1 = false;
                return t1;
            },
            copyWithoutChildren$0: function() {
                return A.ModifiableCssSupportsRule$0(this.condition, this.span);
            },
            get$span: function(receiver) {
                return this.span;
            }
        };
        A.SupportsRule0.prototype = {
            accept$1$1: function(visitor) {
                return visitor.visitSupportsRule$1(0, this);
            },
            accept$1: function(visitor) {
                return this.accept$1$1(visitor, type$.dynamic);
            },
            toString$0: function(_) {
                return "@supports " + this.condition.toString$0(0) + " {" + B.JSArray_methods.join$1(this.children, " ") + "}";
            },
            get$span: function(receiver) {
                return this.span;
            }
        };
        A.JSToDartImporter.prototype = {
            canonicalize$1: function(_, url) {
                var t1, result = A.wrapJSExceptions(new A.JSToDartImporter_canonicalize_closure(this, url));
                if (result == null) return null;
                t1 = self.URL;
                if (result instanceof t1) return A.Uri_parse(J.toString$0$(type$.JSUrl._as(result)));
                t1 = self.Promise;
                if (result instanceof t1) A.jsThrow(new self.Error("The canonicalize() function can't return a Promise for synchronous compile functions."));
                else A.jsThrow(new self.Error(string$.The_ca));
            },
            load$1: function(_, url) {
                var t1, contents, syntax, t2, result = A.wrapJSExceptions(new A.JSToDartImporter_load_closure(this, url));
                if (result == null) return null;
                t1 = self.Promise;
                if (result instanceof t1) A.jsThrow(new self.Error("The load() function can't return a Promise for synchronous compile functions."));
                type$.JSImporterResult._as(result);
                t1 = J.getInterceptor$x(result);
                contents = t1.get$contents(result);
                if (A._asString(new self.Function("value", "return typeof value").call$1(contents)) !== "string") A.jsThrow(new A.ArgumentError(true, contents, "contents", "must be a string but was: " + A.jsType(contents)));
                syntax = t1.get$syntax(result);
                if (contents == null || syntax == null) A.jsThrow(new self.Error(string$.The_lo));
                t2 = A.parseSyntax(syntax);
                return A.ImporterResult$(contents, A.NullableExtension_andThen0(t1.get$sourceMapUrl(result), A.utils3__jsToDartUrl$closure()), t2);
            },
            isNonCanonicalScheme$1: function(scheme) {
                return this._sync$_nonCanonicalSchemes.contains$1(0, scheme);
            }
        };
        A.JSToDartImporter_canonicalize_closure.prototype = {
            call$0: function() {
                return this.$this._sync$_canonicalize.call$2(this.url.toString$0(0), A.canonicalizeContext0());
            },
            $signature: 36
        };
        A.JSToDartImporter_load_closure.prototype = {
            call$0: function() {
                return this.$this._sync$_load.call$1(new self.URL(this.url.toString$0(0)));
            },
            $signature: 36
        };
        A.Syntax0.prototype = {
            _enumToString$0: function() {
                return "Syntax." + this._name;
            },
            toString$0: function(_) {
                return this._syntax0$_name;
            }
        };
        A.InterpolatedTypeSelector.prototype = {
            get$span: function(_) {
                return this.name.span;
            },
            accept$1$1: function(visitor) {
                return J.visitTypeSelector$1$x(visitor._simple_selector$_inner, this);
            },
            accept$1: function(visitor) {
                return this.accept$1$1(visitor, type$.dynamic);
            },
            toString$0: function(_) {
                return this.name.toString$0(0);
            }
        };
        A.TypeSelector0.prototype = {
            get$specificity: function() {
                return 1;
            },
            accept$1$1: function(visitor) {
                return visitor.visitTypeSelector$1(0, this);
            },
            accept$1: function(visitor) {
                return this.accept$1$1(visitor, type$.dynamic);
            },
            addSuffix$1: function(suffix) {
                var t1 = this.name;
                return new A.TypeSelector0(new A.QualifiedName0(t1.name + suffix, t1.namespace), this.span);
            },
            unify$1: function(compound) {
                var unified, t1, _0_0 = A.IterableExtensions_get_firstOrNull(compound);
                if (_0_0 instanceof A.UniversalSelector0 || _0_0 instanceof A.TypeSelector0) {
                    unified = A.unifyUniversalAndElement0(this, B.JSArray_methods.get$first(compound));
                    if (unified == null) return null;
                    t1 = A._setArrayType([
                        unified
                    ], type$.JSArray_SimpleSelector_2);
                    B.JSArray_methods.addAll$1(t1, A.SubListIterable$(compound, 1, null, A._arrayInstanceType(compound)._precomputed1));
                    return t1;
                } else {
                    t1 = A._setArrayType([
                        this
                    ], type$.JSArray_SimpleSelector_2);
                    B.JSArray_methods.addAll$1(t1, compound);
                    return t1;
                }
            },
            isSuperselector$1: function(other) {
                var t1, t2, t3;
                if (!this.super$SimpleSelector$isSuperselector0(other)) {
                    t1 = false;
                    if (other instanceof A.TypeSelector0) {
                        t2 = this.name;
                        t3 = other.name;
                        if (t2.name === t3.name) {
                            t1 = t2.namespace;
                            t1 = t1 === "*" || t1 == t3.namespace;
                        }
                    }
                } else t1 = true;
                return t1;
            },
            $eq: function(_, other) {
                if (other == null) return false;
                return other instanceof A.TypeSelector0 && other.name.$eq(0, this.name);
            },
            get$hashCode: function(_) {
                var t1 = this.name;
                return B.JSString_methods.get$hashCode(t1.name) ^ J.get$hashCode$(t1.namespace);
            }
        };
        A.Types.prototype = {};
        A.UnaryOperationExpression0.prototype = {
            accept$1$1: function(visitor) {
                return visitor.visitUnaryOperationExpression$1(0, this);
            },
            accept$1: function(visitor) {
                return this.accept$1$1(visitor, type$.dynamic);
            },
            toString$0: function(_) {
                var operand, t1 = this.operator, t2 = t1.operator;
                t1 = t1 === B.UnaryOperator_not_not_3_not0 ? t2 + A.Primitives_stringFromCharCode(32) : t2;
                operand = this.operand;
                $label0$0: {
                    t2 = true;
                    if (!(operand instanceof A.BinaryOperationExpression0)) {
                        if (!(operand instanceof A.UnaryOperationExpression0)) t2 = operand instanceof A.ListExpression0 && !operand.hasBrackets && operand.contents.length >= 2;
                    }
                    break $label0$0;
                }
                if (t2) t1 += "40";
                t1 += operand.toString$0(0);
                if (t2) t1 += "41";
                return t1.charCodeAt(0) == 0 ? t1 : t1;
            },
            get$span: function(receiver) {
                return this.span;
            }
        };
        A.UnaryOperator0.prototype = {
            _enumToString$0: function() {
                return "UnaryOperator." + this._name;
            },
            toString$0: function(_) {
                return this.name;
            }
        };
        A.UnitlessSassNumber0.prototype = {
            get$numeratorUnits: function(_) {
                return B.List_empty;
            },
            get$denominatorUnits: function(_) {
                return B.List_empty;
            },
            get$hasUnits: function() {
                return false;
            },
            get$hasComplexUnits: function() {
                return false;
            },
            withValue$1: function(value) {
                return new A.UnitlessSassNumber0(value, null);
            },
            withSlash$2: function(numerator, denominator) {
                return new A.UnitlessSassNumber0(this._number1$_value, new A._Record_2(numerator, denominator));
            },
            hasUnit$1: function(unit) {
                return false;
            },
            hasCompatibleUnits$1: function(other) {
                return other instanceof A.UnitlessSassNumber0;
            },
            hasPossiblyCompatibleUnits$1: function(other) {
                return other instanceof A.UnitlessSassNumber0;
            },
            compatibleWithUnit$1: function(unit) {
                return true;
            },
            coerceToMatch$3: function(other, $name, otherName) {
                return other.withValue$1(this._number1$_value);
            },
            coerceToMatch$1: function(other) {
                return this.coerceToMatch$3(other, null, null);
            },
            coerceValueToMatch$3: function(other, $name, otherName) {
                return this._number1$_value;
            },
            coerceValueToMatch$1: function(other) {
                return this.coerceValueToMatch$3(other, null, null);
            },
            convertToMatch$3: function(other, $name, otherName) {
                return other.get$hasUnits() ? this.super$SassNumber$convertToMatch(other, $name, otherName) : this;
            },
            convertValueToMatch$3: function(other, $name, otherName) {
                return other.get$hasUnits() ? this.super$SassNumber$convertValueToMatch0(other, $name, otherName) : this._number1$_value;
            },
            convertValueToMatch$1: function(other) {
                return this.convertValueToMatch$3(other, null, null);
            },
            coerce$3: function(newNumerators, newDenominators, $name) {
                return A.SassNumber_SassNumber$withUnits0(this._number1$_value, newDenominators, newNumerators);
            },
            coerce$2: function(newNumerators, newDenominators) {
                return this.coerce$3(newNumerators, newDenominators, null);
            },
            coerceValue$3: function(newNumerators, newDenominators, $name) {
                return this._number1$_value;
            },
            coerceValueToUnit$2: function(unit, $name) {
                return this._number1$_value;
            },
            coerceValueToUnit$1: function(unit) {
                return this.coerceValueToUnit$2(unit, null);
            },
            greaterThan$1: function(other) {
                var t1, t2;
                if (other instanceof A.SassNumber0) {
                    t1 = this._number1$_value;
                    t2 = other._number1$_value;
                    return t1 > t2 && !A.fuzzyEquals0(t1, t2) ? B.SassBoolean_true0 : B.SassBoolean_false0;
                }
                return this.super$SassNumber$greaterThan0(other);
            },
            greaterThanOrEquals$1: function(other) {
                var t1, t2;
                if (other instanceof A.SassNumber0) {
                    t1 = this._number1$_value;
                    t2 = other._number1$_value;
                    return t1 > t2 || A.fuzzyEquals0(t1, t2) ? B.SassBoolean_true0 : B.SassBoolean_false0;
                }
                return this.super$SassNumber$greaterThanOrEquals0(other);
            },
            lessThan$1: function(other) {
                var t1, t2;
                if (other instanceof A.SassNumber0) {
                    t1 = this._number1$_value;
                    t2 = other._number1$_value;
                    return t1 < t2 && !A.fuzzyEquals0(t1, t2) ? B.SassBoolean_true0 : B.SassBoolean_false0;
                }
                return this.super$SassNumber$lessThan0(other);
            },
            lessThanOrEquals$1: function(other) {
                var t1, t2;
                if (other instanceof A.SassNumber0) {
                    t1 = this._number1$_value;
                    t2 = other._number1$_value;
                    return t1 < t2 || A.fuzzyEquals0(t1, t2) ? B.SassBoolean_true0 : B.SassBoolean_false0;
                }
                return this.super$SassNumber$lessThanOrEquals0(other);
            },
            modulo$1: function(other) {
                if (other instanceof A.SassNumber0) return other.withValue$1(A.moduloLikeSass0(this._number1$_value, other._number1$_value));
                return this.super$SassNumber$modulo0(other);
            },
            plus$1: function(other) {
                if (other instanceof A.SassNumber0) return other.withValue$1(this._number1$_value + other._number1$_value);
                return this.super$SassNumber$plus0(other);
            },
            minus$1: function(other) {
                if (other instanceof A.SassNumber0) return other.withValue$1(this._number1$_value - other._number1$_value);
                return this.super$SassNumber$minus0(other);
            },
            times$1: function(other) {
                if (other instanceof A.SassNumber0) return other.withValue$1(this._number1$_value * other._number1$_value);
                return this.super$SassNumber$times0(other);
            },
            dividedBy$1: function(other) {
                var t1, t2;
                if (other instanceof A.SassNumber0) {
                    t1 = this._number1$_value / other._number1$_value;
                    if (other.get$hasUnits()) {
                        t2 = other.get$denominatorUnits(other);
                        t2 = A.SassNumber_SassNumber$withUnits0(t1, other.get$numeratorUnits(other), t2);
                        t1 = t2;
                    } else t1 = new A.UnitlessSassNumber0(t1, null);
                    return t1;
                }
                return this.super$SassNumber$dividedBy0(other);
            },
            unaryMinus$0: function() {
                return new A.UnitlessSassNumber0(-this._number1$_value, null);
            },
            $eq: function(_, other) {
                if (other == null) return false;
                return other instanceof A.UnitlessSassNumber0 && A.fuzzyEquals0(this._number1$_value, other._number1$_value);
            },
            get$hashCode: function(_) {
                var t1 = this.hashCache;
                return t1 == null ? this.hashCache = A.fuzzyHashCode0(this._number1$_value) : t1;
            }
        };
        A.InterpolatedUniversalSelector.prototype = {
            accept$1$1: function(visitor) {
                return J.visitUniversalSelector$1$x(visitor._simple_selector$_inner, this);
            },
            accept$1: function(visitor) {
                return this.accept$1$1(visitor, type$.dynamic);
            },
            toString$0: function(_) {
                var t1, _0_0 = this.namespace;
                $label0$0: {
                    if (_0_0 != null) {
                        t1 = _0_0.toString$0(0) + "|*";
                        break $label0$0;
                    }
                    t1 = "*";
                    break $label0$0;
                }
                return t1;
            },
            get$span: function(receiver) {
                return this.span;
            }
        };
        A.UniversalSelector0.prototype = {
            get$specificity: function() {
                return 0;
            },
            accept$1$1: function(visitor) {
                return visitor.visitUniversalSelector$1(0, this);
            },
            accept$1: function(visitor) {
                return this.accept$1$1(visitor, type$.dynamic);
            },
            unify$1: function(compound) {
                var _0_4, t1, rest, unified, t2, _this = this, _null = null, _0_1 = compound.length, _0_4_isSet = _0_1 >= 1;
                if (_0_4_isSet) {
                    _0_4 = compound[0];
                    if (!(_0_4 instanceof A.UniversalSelector0)) t1 = _0_4 instanceof A.TypeSelector0;
                    else t1 = true;
                    rest = t1 ? B.JSArray_methods.sublist$1(compound, 1) : _null;
                } else {
                    rest = _null;
                    _0_4 = rest;
                    t1 = false;
                }
                if (t1) {
                    unified = A.unifyUniversalAndElement0(_this, B.JSArray_methods.get$first(compound));
                    if (unified == null) return _null;
                    t1 = A._setArrayType([
                        unified
                    ], type$.JSArray_SimpleSelector_2);
                    B.JSArray_methods.addAll$1(t1, rest);
                    return t1;
                }
                t1 = false;
                if (_0_1 === 1) {
                    if (_0_4_isSet) t2 = _0_4;
                    else {
                        _0_4 = compound[0];
                        t2 = _0_4;
                        _0_4_isSet = true;
                    }
                    if (t2 instanceof A.PseudoSelector0) {
                        t2 = _0_4_isSet ? _0_4 : compound[0];
                        type$.PseudoSelector_2._as(t2);
                        t1 = t2.isClass && t2.name === "host" || t2.get$isHostContext();
                    }
                }
                if (t1) return _null;
                if (_0_1 <= 0) return A._setArrayType([
                    _this
                ], type$.JSArray_SimpleSelector_2);
                t1 = _this.namespace;
                if (t1 == null || t1 === "*") t1 = compound;
                else {
                    t1 = A._setArrayType([
                        _this
                    ], type$.JSArray_SimpleSelector_2);
                    B.JSArray_methods.addAll$1(t1, compound);
                }
                return t1;
            },
            isSuperselector$1: function(other) {
                var t1 = this.namespace;
                if (t1 === "*") return true;
                if (other instanceof A.TypeSelector0) return t1 == other.name.namespace;
                if (other instanceof A.UniversalSelector0) return t1 == other.namespace;
                return t1 == null || this.super$SimpleSelector$isSuperselector0(other);
            },
            $eq: function(_, other) {
                if (other == null) return false;
                return other instanceof A.UniversalSelector0 && other.namespace == this.namespace;
            },
            get$hashCode: function(_) {
                return J.get$hashCode$(this.namespace);
            }
        };
        A.UnprefixedMapView0.prototype = {
            get$keys: function(_) {
                return new A._UnprefixedKeys0(this);
            },
            $index: function(_, key) {
                return typeof key == "string" ? this._unprefixed_map_view0$_map.$index(0, this._unprefixed_map_view0$_prefix + key) : null;
            },
            containsKey$1: function(key) {
                return typeof key == "string" && this._unprefixed_map_view0$_map.containsKey$1(this._unprefixed_map_view0$_prefix + key);
            },
            remove$1: function(_, key) {
                return typeof key == "string" ? this._unprefixed_map_view0$_map.remove$1(0, this._unprefixed_map_view0$_prefix + key) : null;
            }
        };
        A._UnprefixedKeys0.prototype = {
            get$iterator: function(_) {
                var t1 = this._unprefixed_map_view0$_view._unprefixed_map_view0$_map;
                t1 = t1.get$keys(t1);
                t1 = t1.where$1(t1, new A._UnprefixedKeys_iterator_closure1(this)).map$1$1(0, new A._UnprefixedKeys_iterator_closure2(this), type$.String);
                return t1.get$iterator(t1);
            },
            contains$1: function(_, key) {
                return this._unprefixed_map_view0$_view.containsKey$1(key);
            }
        };
        A._UnprefixedKeys_iterator_closure1.prototype = {
            call$1: function(key) {
                return B.JSString_methods.startsWith$1(key, this.$this._unprefixed_map_view0$_view._unprefixed_map_view0$_prefix);
            },
            $signature: 4
        };
        A._UnprefixedKeys_iterator_closure2.prototype = {
            call$1: function(key) {
                return B.JSString_methods.substring$1(key, this.$this._unprefixed_map_view0$_view._unprefixed_map_view0$_prefix.length);
            },
            $signature: 6
        };
        A.JSUrl0.prototype = {};
        A.UseRule0.prototype = {
            UseRule$4$configuration0: function(url, namespace, span, configuration) {
                var t1, t2, _i, variable;
                for(t1 = this.configuration, t2 = t1.length, _i = 0; _i < t2; ++_i){
                    variable = t1[_i];
                    if (variable.isGuarded) throw A.wrapException(A.ArgumentError$value(variable, "configured variable", "can't be guarded in a @use rule."));
                }
            },
            accept$1$1: function(visitor) {
                return visitor.visitUseRule$1(0, this);
            },
            accept$1: function(visitor) {
                return this.accept$1$1(visitor, type$.dynamic);
            },
            toString$0: function(_) {
                var t1 = this.url, t2 = "@use " + A.StringExpression_quoteText0(t1.toString$0(0)), basename = t1.get$pathSegments().length === 0 ? "" : B.JSArray_methods.get$last(t1.get$pathSegments()), dot = B.JSString_methods.indexOf$1(basename, ".");
                t1 = this.namespace;
                if (t1 !== B.JSString_methods.substring$2(basename, 0, dot === -1 ? basename.length : dot)) t1 = t2 + (" as " + (t1 == null ? "*" : t1));
                else t1 = t2;
                t2 = this.configuration;
                t1 = (t2.length !== 0 ? t1 + (" with (" + B.JSArray_methods.join$1(t2, ", ") + ")") : t1) + ";";
                return t1.charCodeAt(0) == 0 ? t1 : t1;
            },
            get$span: function(receiver) {
                return this.span;
            }
        };
        A.UserDefinedCallable0.prototype = {
            get$name: function(_) {
                return this.declaration.name;
            },
            $isAsyncCallable0: 1,
            $isCallable: 1
        };
        A.resolveImportPath_closure1.prototype = {
            call$0: function() {
                return A._exactlyOne0(A._tryPath0($.$get$context().withoutExtension$1(this.path) + ".import" + this.extension));
            },
            $signature: 47
        };
        A.resolveImportPath_closure2.prototype = {
            call$0: function() {
                return A._exactlyOne0(A._tryPathWithExtensions0(this.path + ".import"));
            },
            $signature: 47
        };
        A._tryPathAsDirectory_closure0.prototype = {
            call$0: function() {
                return A._exactlyOne0(A._tryPathWithExtensions0(A.join(this.path, "index.import", null)));
            },
            $signature: 47
        };
        A._exactlyOne_closure0.prototype = {
            call$1: function(path) {
                var t1 = $.$get$context();
                return "  " + t1.prettyUri$1(t1.toUri$1(path));
            },
            $signature: 6
        };
        A._PropertyDescriptor0.prototype = {};
        A.futureToPromise_closure0.prototype = {
            call$2: function(resolve, reject) {
                this.future.then$1$2$onError(0, new A.futureToPromise__closure0(resolve), new A.futureToPromise__closure1(reject), type$.void);
            },
            $signature: 638
        };
        A.futureToPromise__closure0.prototype = {
            call$1: function(result) {
                return this.resolve.call$1(result);
            },
            $signature: 37
        };
        A.futureToPromise__closure1.prototype = {
            call$2: function(error, stackTrace) {
                A.attachTrace0(error, stackTrace);
                this.reject.call$1(error);
            },
            $signature: 51
        };
        A.objectToMap_closure.prototype = {
            call$2: function(key, value) {
                this.map.$indexSet(0, key, value);
                return value;
            },
            $signature: 126
        };
        A._RequireMain0.prototype = {};
        A.indent_closure0.prototype = {
            call$1: function(line) {
                return B.JSString_methods.$mul(" ", this.indentation) + line;
            },
            $signature: 6
        };
        A.flattenVertically_closure1.prototype = {
            call$1: function(inner) {
                return A.QueueList_QueueList$from(inner, this.T);
            },
            $signature: function() {
                return this.T._eval$1("QueueList<0>(Iterable<0>)");
            }
        };
        A.flattenVertically_closure2.prototype = {
            call$1: function(queue) {
                this.result.push(queue.removeFirst$0());
                return queue.get$length(0) === 0;
            },
            $signature: function() {
                return this.T._eval$1("bool(QueueList<0>)");
            }
        };
        A.longestCommonSubsequence_backtrack0.prototype = {
            call$2: function(i, j) {
                var selection, t1, _this = this;
                if (i === -1 || j === -1) return A._setArrayType([], _this.T._eval$1("JSArray<0>"));
                selection = _this.selections[i][j];
                if (selection != null) {
                    t1 = _this.call$2(i - 1, j - 1);
                    J.add$1$ax(t1, selection);
                    return t1;
                }
                t1 = _this.lengths;
                return t1[i + 1][j] > t1[i][j + 1] ? _this.call$2(i, j - 1) : _this.call$2(i - 1, j);
            },
            $signature: function() {
                return this.T._eval$1("List<0>(int,int)");
            }
        };
        A.mapAddAll2_closure0.prototype = {
            call$2: function(key, inner) {
                var t1 = this.destination, _0_0 = t1.$index(0, key);
                if (_0_0 != null) _0_0.addAll$1(0, inner);
                else t1.$indexSet(0, key, inner);
            },
            $signature: function() {
                return this.K1._eval$1("@<0>")._bind$1(this.K2)._bind$1(this.V)._eval$1("~(1,Map<2,3>)");
            }
        };
        A.CssValue0.prototype = {
            $eq: function(_, other) {
                if (other == null) return false;
                return this.$ti._is(other) && J.$eq$(other.value, this.value);
            },
            get$hashCode: function(_) {
                return J.get$hashCode$(this.value);
            },
            toString$0: function(_) {
                return J.toString$0$(this.value);
            },
            $isAstNode0: 1,
            get$span: function(receiver) {
                return this.span;
            }
        };
        A.ValueExpression0.prototype = {
            accept$1$1: function(visitor) {
                return visitor.visitValueExpression$1(0, this);
            },
            accept$1: function(visitor) {
                return this.accept$1$1(visitor, type$.dynamic);
            },
            toString$0: function(_) {
                return this.value.toString$0(0);
            },
            get$span: function(receiver) {
                return this.span;
            }
        };
        A.valueClass_closure.prototype = {
            call$0: function() {
                var t2, t1 = type$.JSClass, jsClass = t1._as(self.Object.getPrototypeOf(J.get$$prototype$x(t1._as(B.C__SassNull0.constructor))).constructor);
                A.JSClassExtension_setCustomInspect(jsClass, new A.valueClass__closure());
                t1 = type$.String;
                t2 = type$.Function;
                A.LinkedHashMap_LinkedHashMap$_literal([
                    "asList",
                    new A.valueClass__closure0(),
                    "hasBrackets",
                    new A.valueClass__closure1(),
                    "isTruthy",
                    new A.valueClass__closure2(),
                    "realNull",
                    new A.valueClass__closure3(),
                    "separator",
                    new A.valueClass__closure4()
                ], t1, t2).forEach$1(0, A.JSClassExtension_get_defineGetter(jsClass));
                A.LinkedHashMap_LinkedHashMap$_literal([
                    "sassIndexToListIndex",
                    new A.valueClass__closure5(),
                    "get",
                    new A.valueClass__closure6(),
                    "assertBoolean",
                    new A.valueClass__closure7(),
                    "assertCalculation",
                    new A.valueClass__closure8(),
                    "assertColor",
                    new A.valueClass__closure9(),
                    "assertFunction",
                    new A.valueClass__closure10(),
                    "assertMap",
                    new A.valueClass__closure11(),
                    "assertMixin",
                    new A.valueClass__closure12(),
                    "assertNumber",
                    new A.valueClass__closure13(),
                    "assertString",
                    new A.valueClass__closure14(),
                    "tryMap",
                    new A.valueClass__closure15(),
                    "equals",
                    new A.valueClass__closure16(),
                    "hashCode",
                    new A.valueClass__closure17(),
                    "toString",
                    new A.valueClass__closure18()
                ], t1, t2).forEach$1(0, A.JSClassExtension_get_defineMethod(jsClass));
                return jsClass;
            },
            $signature: 17
        };
        A.valueClass__closure.prototype = {
            call$1: function($self) {
                return J.toString$0$($self);
            },
            $signature: 132
        };
        A.valueClass__closure0.prototype = {
            call$1: function($self) {
                return new self.immutable.List($self.get$asList());
            },
            $signature: 639
        };
        A.valueClass__closure1.prototype = {
            call$1: function($self) {
                return $self.get$hasBrackets();
            },
            $signature: 56
        };
        A.valueClass__closure2.prototype = {
            call$1: function($self) {
                return $self.get$isTruthy();
            },
            $signature: 56
        };
        A.valueClass__closure3.prototype = {
            call$1: function($self) {
                return $self.get$realNull();
            },
            $signature: 242
        };
        A.valueClass__closure4.prototype = {
            call$1: function($self) {
                return $self.get$separator($self).separator;
            },
            $signature: 640
        };
        A.valueClass__closure5.prototype = {
            call$3: function($self, sassIndex, $name) {
                return $self.sassIndexToListIndex$2(sassIndex, $name);
            },
            call$2: function($self, sassIndex) {
                return this.call$3($self, sassIndex, null);
            },
            "call*": "call$3",
            $requiredArgCount: 2,
            $defaultValues: function() {
                return [
                    null
                ];
            },
            $signature: 641
        };
        A.valueClass__closure6.prototype = {
            call$2: function($self, index) {
                return index < 1 && index >= -1 ? $self : self.undefined;
            },
            $signature: 250
        };
        A.valueClass__closure7.prototype = {
            call$2: function($self, $name) {
                return $self.assertBoolean$1($name);
            },
            call$1: function($self) {
                return this.call$2($self, null);
            },
            "call*": "call$2",
            $requiredArgCount: 1,
            $defaultValues: function() {
                return [
                    null
                ];
            },
            $signature: 642
        };
        A.valueClass__closure8.prototype = {
            call$2: function($self, $name) {
                return $self.assertCalculation$1($name);
            },
            call$1: function($self) {
                return this.call$2($self, null);
            },
            "call*": "call$2",
            $requiredArgCount: 1,
            $defaultValues: function() {
                return [
                    null
                ];
            },
            $signature: 643
        };
        A.valueClass__closure9.prototype = {
            call$2: function($self, $name) {
                return $self.assertColor$1($name);
            },
            call$1: function($self) {
                return this.call$2($self, null);
            },
            "call*": "call$2",
            $requiredArgCount: 1,
            $defaultValues: function() {
                return [
                    null
                ];
            },
            $signature: 644
        };
        A.valueClass__closure10.prototype = {
            call$2: function($self, $name) {
                return $self.assertFunction$1($name);
            },
            call$1: function($self) {
                return this.call$2($self, null);
            },
            "call*": "call$2",
            $requiredArgCount: 1,
            $defaultValues: function() {
                return [
                    null
                ];
            },
            $signature: 645
        };
        A.valueClass__closure11.prototype = {
            call$2: function($self, $name) {
                return $self.assertMap$1($name);
            },
            call$1: function($self) {
                return this.call$2($self, null);
            },
            "call*": "call$2",
            $requiredArgCount: 1,
            $defaultValues: function() {
                return [
                    null
                ];
            },
            $signature: 646
        };
        A.valueClass__closure12.prototype = {
            call$2: function($self, $name) {
                return $self.assertMixin$1($name);
            },
            call$1: function($self) {
                return this.call$2($self, null);
            },
            "call*": "call$2",
            $requiredArgCount: 1,
            $defaultValues: function() {
                return [
                    null
                ];
            },
            $signature: 647
        };
        A.valueClass__closure13.prototype = {
            call$2: function($self, $name) {
                return $self.assertNumber$1($name);
            },
            call$1: function($self) {
                return this.call$2($self, null);
            },
            "call*": "call$2",
            $requiredArgCount: 1,
            $defaultValues: function() {
                return [
                    null
                ];
            },
            $signature: 648
        };
        A.valueClass__closure14.prototype = {
            call$2: function($self, $name) {
                return $self.assertString$1($name);
            },
            call$1: function($self) {
                return this.call$2($self, null);
            },
            "call*": "call$2",
            $requiredArgCount: 1,
            $defaultValues: function() {
                return [
                    null
                ];
            },
            $signature: 649
        };
        A.valueClass__closure15.prototype = {
            call$1: function($self) {
                return $self.tryMap$0();
            },
            $signature: 650
        };
        A.valueClass__closure16.prototype = {
            call$2: function($self, other) {
                return $self.$eq(0, other);
            },
            $signature: 651
        };
        A.valueClass__closure17.prototype = {
            call$2: function($self, _) {
                return $self.get$hashCode($self);
            },
            call$1: function($self) {
                return this.call$2($self, null);
            },
            "call*": "call$2",
            $requiredArgCount: 1,
            $defaultValues: function() {
                return [
                    null
                ];
            },
            $signature: 652
        };
        A.valueClass__closure18.prototype = {
            call$1: function($self) {
                return $self.toString$0(0);
            },
            $signature: 228
        };
        A.Value0.prototype = {
            get$isTruthy: function() {
                return true;
            },
            get$separator: function(_) {
                return B.ListSeparator_undecided_null_3_undecided0;
            },
            get$hasBrackets: function() {
                return false;
            },
            get$asList: function() {
                return A._setArrayType([
                    this
                ], type$.JSArray_Value_2);
            },
            get$lengthAsList: function() {
                return 1;
            },
            get$isBlank: function() {
                return false;
            },
            get$isSpecialNumber: function() {
                return false;
            },
            get$isSpecialVariable: function() {
                return false;
            },
            get$realNull: function() {
                return this;
            },
            sassIndexToListIndex$2: function(sassIndex, $name) {
                var t1, index, indexValue = sassIndex.assertNumber$1($name);
                if (indexValue.get$hasUnits()) {
                    t1 = indexValue.get$unitString();
                    A.warnForDeprecation0("$" + A.S($name) + ": Passing a number with unit " + t1 + string$.x20is_de + indexValue.unitSuggestion$1($name == null ? "index" : $name) + string$.x0a_Morex3af, B.Deprecation_PHd);
                }
                index = indexValue.assertInt$1($name);
                if (index === 0) throw A.wrapException(A.SassScriptException$0("List index may not be 0.", $name));
                if (Math.abs(index) > this.get$lengthAsList()) throw A.wrapException(A.SassScriptException$0("Invalid index " + sassIndex.toString$0(0) + " for a list with " + this.get$lengthAsList() + " elements.", $name));
                return index < 0 ? this.get$lengthAsList() + index : index - 1;
            },
            assertBoolean$1: function($name) {
                return A.throwExpression(A.SassScriptException$0(this.toString$0(0) + " is not a boolean.", $name));
            },
            assertCalculation$1: function($name) {
                return A.throwExpression(A.SassScriptException$0(this.toString$0(0) + " is not a calculation.", $name));
            },
            assertColor$1: function($name) {
                return A.throwExpression(A.SassScriptException$0(this.toString$0(0) + " is not a color.", $name));
            },
            assertFunction$1: function($name) {
                return A.throwExpression(A.SassScriptException$0(this.toString$0(0) + " is not a function reference.", $name));
            },
            assertMixin$1: function($name) {
                return A.throwExpression(A.SassScriptException$0(this.toString$0(0) + " is not a mixin reference.", $name));
            },
            assertMap$1: function($name) {
                return A.throwExpression(A.SassScriptException$0(this.toString$0(0) + " is not a map.", $name));
            },
            tryMap$0: function() {
                return null;
            },
            assertNumber$1: function($name) {
                return A.throwExpression(A.SassScriptException$0(this.toString$0(0) + " is not a number.", $name));
            },
            assertNumber$0: function() {
                return this.assertNumber$1(null);
            },
            assertString$1: function($name) {
                return A.throwExpression(A.SassScriptException$0(this.toString$0(0) + " is not a string.", $name));
            },
            assertCommonListStyle$2$allowSlash: function($name, allowSlash) {
                var invalidSeparator, buffer, t1, _this = this, _s8_ = "Expected", _s23_ = "Expected an unbracketed";
                if (_this.get$separator(_this) !== B.ListSeparator_z0K0) invalidSeparator = !allowSlash && _this.get$separator(_this) === B.ListSeparator_Lul0;
                else invalidSeparator = true;
                if (!invalidSeparator && !_this.get$hasBrackets()) return _this.get$asList();
                buffer = new A.StringBuffer(_s8_);
                if (_this.get$hasBrackets()) {
                    buffer._contents = _s23_;
                    t1 = _s23_;
                } else t1 = _s8_;
                if (invalidSeparator) {
                    t1 += _this.get$hasBrackets() ? "," : " a";
                    buffer._contents = t1;
                    t1 = buffer._contents = t1 + " space-";
                    t1 = buffer._contents = (allowSlash ? buffer._contents = t1 + " or slash-" : t1) + "separated";
                }
                buffer._contents = t1 + (" list, was " + _this.toString$0(0));
                throw A.wrapException(A.SassScriptException$0(buffer.toString$0(0), $name));
            },
            _value$_selectorString$1: function($name) {
                var _0_0 = this._value$_selectorStringOrNull$0();
                if (_0_0 != null) return _0_0;
                throw A.wrapException(A.SassScriptException$0(this.toString$0(0) + string$.x20is_noav, $name));
            },
            _value$_selectorStringOrNull$0: function() {
                var t1, t2, result, _1_0, _i, complex, string, compound, _this = this, _null = null;
                if (_this instanceof A.SassString0) return _this._string0$_text;
                if (!(_this instanceof A.SassList0)) return _null;
                t1 = _this._list1$_contents;
                t2 = t1.length;
                if (t2 === 0) return _null;
                result = A._setArrayType([], type$.JSArray_String);
                $label0$1: {
                    _1_0 = _this._list1$_separator;
                    if (B.ListSeparator_z0K0 === _1_0) {
                        for(_i = 0; _i < t2; ++_i){
                            complex = t1[_i];
                            if (complex instanceof A.SassString0) {
                                result.push(complex._string0$_text);
                                continue;
                            }
                            if (complex instanceof A.SassList0 && B.ListSeparator_SrV0 === complex._list1$_separator) {
                                string = complex._value$_selectorStringOrNull$0();
                                if (string == null) return _null;
                                result.push(string);
                                continue;
                            }
                            return _null;
                        }
                        break $label0$1;
                    }
                    if (B.ListSeparator_Lul0 === _1_0) return _null;
                    for(_i = 0; _i < t2; ++_i){
                        compound = t1[_i];
                        if (!(compound instanceof A.SassString0)) return _null;
                        result.push(compound._string0$_text);
                    }
                }
                return B.JSArray_methods.join$1(result, _1_0 === B.ListSeparator_z0K0 ? ", " : " ");
            },
            withListContents$2$separator: function(contents, separator) {
                var t1 = separator == null ? this.get$separator(this) : separator, t2 = this.get$hasBrackets();
                return A.SassList$0(contents, t1, t2);
            },
            withListContents$1: function(contents) {
                return this.withListContents$2$separator(contents, null);
            },
            greaterThan$1: function(other) {
                return A.throwExpression(A.SassScriptException$0('Undefined operation "' + this.toString$0(0) + " > " + other.toString$0(0) + '".', null));
            },
            greaterThanOrEquals$1: function(other) {
                return A.throwExpression(A.SassScriptException$0('Undefined operation "' + this.toString$0(0) + " >= " + other.toString$0(0) + '".', null));
            },
            lessThan$1: function(other) {
                return A.throwExpression(A.SassScriptException$0('Undefined operation "' + this.toString$0(0) + " < " + other.toString$0(0) + '".', null));
            },
            lessThanOrEquals$1: function(other) {
                return A.throwExpression(A.SassScriptException$0('Undefined operation "' + this.toString$0(0) + " <= " + other.toString$0(0) + '".', null));
            },
            times$1: function(other) {
                return A.throwExpression(A.SassScriptException$0('Undefined operation "' + this.toString$0(0) + " * " + other.toString$0(0) + '".', null));
            },
            modulo$1: function(other) {
                return A.throwExpression(A.SassScriptException$0('Undefined operation "' + this.toString$0(0) + " % " + other.toString$0(0) + '".', null));
            },
            plus$1: function(other) {
                var t1;
                $label0$0: {
                    if (other instanceof A.SassString0) {
                        t1 = new A.SassString0(A.serializeValue0(this, false, true) + other._string0$_text, other._string0$_hasQuotes);
                        break $label0$0;
                    }
                    if (other instanceof A.SassCalculation0) A.throwExpression(A.SassScriptException$0('Undefined operation "' + this.toString$0(0) + " + " + other.toString$0(0) + '".', null));
                    t1 = new A.SassString0(A.serializeValue0(this, false, true) + A.serializeValue0(other, false, true), false);
                    break $label0$0;
                }
                return t1;
            },
            minus$1: function(other) {
                return other instanceof A.SassCalculation0 ? A.throwExpression(A.SassScriptException$0('Undefined operation "' + this.toString$0(0) + " - " + other.toString$0(0) + '".', null)) : new A.SassString0(A.serializeValue0(this, false, true) + "-" + A.serializeValue0(other, false, true), false);
            },
            dividedBy$1: function(other) {
                return new A.SassString0(A.serializeValue0(this, false, true) + "/" + A.serializeValue0(other, false, true), false);
            },
            unaryPlus$0: function() {
                return new A.SassString0("+" + A.serializeValue0(this, false, true), false);
            },
            unaryMinus$0: function() {
                return new A.SassString0("-" + A.serializeValue0(this, false, true), false);
            },
            unaryNot$0: function() {
                return B.SassBoolean_false0;
            },
            withoutSlash$0: function() {
                return this;
            },
            toCssString$1$quote: function(quote) {
                return A.serializeValue0(this, false, quote);
            },
            toCssString$0: function() {
                return this.toCssString$1$quote(true);
            },
            toString$0: function(_) {
                return A.serializeValue0(this, true, true);
            }
        };
        A.VariableExpression0.prototype = {
            accept$1$1: function(visitor) {
                return visitor.visitVariableExpression$1(0, this);
            },
            accept$1: function(visitor) {
                return this.accept$1$1(visitor, type$.dynamic);
            },
            toString$0: function(_) {
                return this.span.get$text();
            },
            get$span: function(receiver) {
                return this.span;
            }
        };
        A.VariableDeclaration0.prototype = {
            accept$1$1: function(visitor) {
                return visitor.visitVariableDeclaration$1(0, this);
            },
            accept$1: function(visitor) {
                return this.accept$1$1(visitor, type$.dynamic);
            },
            toString$0: function(_) {
                var t1 = this.namespace;
                t1 = t1 != null ? t1 + "." : "";
                t1 += "$" + this.name + ": " + this.expression.toString$0(0) + ";";
                return t1.charCodeAt(0) == 0 ? t1 : t1;
            },
            get$span: function(receiver) {
                return this.span;
            }
        };
        A.WarnRule0.prototype = {
            accept$1$1: function(visitor) {
                return visitor.visitWarnRule$1(0, this);
            },
            accept$1: function(visitor) {
                return this.accept$1$1(visitor, type$.dynamic);
            },
            toString$0: function(_) {
                return "@warn " + this.expression.toString$0(0) + ";";
            },
            get$span: function(receiver) {
                return this.span;
            }
        };
        A.WhileRule0.prototype = {
            accept$1$1: function(visitor) {
                return visitor.visitWhileRule$1(0, this);
            },
            accept$1: function(visitor) {
                return this.accept$1$1(visitor, type$.dynamic);
            },
            toString$0: function(_) {
                return "@while " + this.condition.toString$0(0) + " {" + B.JSArray_methods.join$1(this.children, " ") + "}";
            },
            get$span: function(receiver) {
                return this.span;
            }
        };
        A.XyzD50ColorSpace0.prototype = {
            get$isBoundedInternal: function() {
                return false;
            },
            convert$10$missingA$missingB$missingChroma$missingHue$missingLightness: function(dest, x, y, z, alpha, missingA, missingB, missingChroma, missingHue, missingLightness) {
                var f0, f1, f2, lightness, a, b, t1, _this = this, _null = null;
                if (B.LabColorSpace_2nT0 === dest || B.LchColorSpace_Bpv0 === dest) {
                    f0 = _this._xyz_d50$_convertComponentToLabF$1((x == null ? 0 : x) / 0.9642956764295677);
                    f1 = _this._xyz_d50$_convertComponentToLabF$1((y == null ? 0 : y) / 1);
                    f2 = _this._xyz_d50$_convertComponentToLabF$1((z == null ? 0 : z) / 0.8251046025104602);
                    lightness = missingLightness ? _null : 116 * f1 - 16;
                    a = 500 * (f0 - f1);
                    b = 200 * (f1 - f2);
                    if (dest === B.LabColorSpace_2nT0) {
                        t1 = missingA ? _null : a;
                        t1 = A.SassColor$_forSpace0(B.LabColorSpace_2nT0, lightness, t1, missingB ? _null : b, alpha, _null);
                    } else t1 = A.labToLch0(B.LchColorSpace_Bpv0, lightness, a, b, alpha, missingChroma, missingHue);
                    return t1;
                }
                return _this.super$ColorSpace$convertLinear0(dest, x, y, z, alpha, missingA, missingB, missingChroma, missingHue, missingLightness);
            },
            convert$5: function(dest, x, y, z, alpha) {
                return this.convert$10$missingA$missingB$missingChroma$missingHue$missingLightness(dest, x, y, z, alpha, false, false, false, false, false);
            },
            _xyz_d50$_convertComponentToLabF$1: function(component) {
                return component > 0.008856451679035631 ? Math.pow(component, 0.3333333333333333) + 0 : (903.2962962962963 * component + 16) / 116;
            },
            toLinear$1: function(channel) {
                return channel;
            },
            fromLinear$1: function(channel) {
                return channel;
            },
            transformationMatrix$1: function(dest) {
                var t1;
                $label0$0: {
                    if (B.SrgbLinearColorSpace_kUj0 === dest || B.SrgbColorSpace_thf0 === dest || B.RgbColorSpace_i0P0 === dest) {
                        t1 = $.$get$xyzD50ToLinearSrgb0();
                        break $label0$0;
                    }
                    if (B.A98RgbColorSpace_lf20 === dest) {
                        t1 = $.$get$xyzD50ToLinearA98Rgb0();
                        break $label0$0;
                    }
                    if (B.ProphotoRgbColorSpace_BDz0 === dest) {
                        t1 = $.$get$xyzD50ToLinearProphotoRgb0();
                        break $label0$0;
                    }
                    if (B.DisplayP3ColorSpace_MmT0 === dest || B.DisplayP3LinearColorSpace_PrP0 === dest) {
                        t1 = $.$get$xyzD50ToLinearDisplayP30();
                        break $label0$0;
                    }
                    if (B.Rec2020ColorSpace_6oo0 === dest) {
                        t1 = $.$get$xyzD50ToLinearRec20200();
                        break $label0$0;
                    }
                    if (B.XyzD65ColorSpace_WiJ0 === dest) {
                        t1 = $.$get$xyzD50ToXyzD650();
                        break $label0$0;
                    }
                    if (B.LmsColorSpace_Os30 === dest) {
                        t1 = $.$get$xyzD50ToLms0();
                        break $label0$0;
                    }
                    t1 = this.super$ColorSpace$transformationMatrix0(dest);
                    break $label0$0;
                }
                return t1;
            }
        };
        A.XyzD65ColorSpace0.prototype = {
            get$isBoundedInternal: function() {
                return false;
            },
            toLinear$1: function(channel) {
                return channel;
            },
            fromLinear$1: function(channel) {
                return channel;
            },
            transformationMatrix$1: function(dest) {
                var t1;
                $label0$0: {
                    if (B.SrgbLinearColorSpace_kUj0 === dest || B.SrgbColorSpace_thf0 === dest || B.RgbColorSpace_i0P0 === dest) {
                        t1 = $.$get$xyzD65ToLinearSrgb0();
                        break $label0$0;
                    }
                    if (B.A98RgbColorSpace_lf20 === dest) {
                        t1 = $.$get$xyzD65ToLinearA98Rgb0();
                        break $label0$0;
                    }
                    if (B.ProphotoRgbColorSpace_BDz0 === dest) {
                        t1 = $.$get$xyzD65ToLinearProphotoRgb0();
                        break $label0$0;
                    }
                    if (B.DisplayP3ColorSpace_MmT0 === dest || B.DisplayP3LinearColorSpace_PrP0 === dest) {
                        t1 = $.$get$xyzD65ToLinearDisplayP30();
                        break $label0$0;
                    }
                    if (B.Rec2020ColorSpace_6oo0 === dest) {
                        t1 = $.$get$xyzD65ToLinearRec20200();
                        break $label0$0;
                    }
                    if (B.XyzD50ColorSpace_2OB0 === dest) {
                        t1 = $.$get$xyzD65ToXyzD500();
                        break $label0$0;
                    }
                    if (B.LmsColorSpace_Os30 === dest) {
                        t1 = $.$get$xyzD65ToLms0();
                        break $label0$0;
                    }
                    t1 = this.super$ColorSpace$transformationMatrix0(dest);
                    break $label0$0;
                }
                return t1;
            }
        };
        (function aliases() {
            var _ = J.LegacyJavaScriptObject.prototype;
            _.super$LegacyJavaScriptObject$toString = _.toString$0;
            _ = A.JsLinkedHashMap.prototype;
            _.super$JsLinkedHashMap$internalContainsKey = _.internalContainsKey$1;
            _.super$JsLinkedHashMap$internalGet = _.internalGet$1;
            _.super$JsLinkedHashMap$internalSet = _.internalSet$2;
            _.super$JsLinkedHashMap$internalRemove = _.internalRemove$1;
            _ = A._BufferingStreamSubscription.prototype;
            _.super$_BufferingStreamSubscription$_add = _._async$_add$1;
            _.super$_BufferingStreamSubscription$_addError = _._addError$2;
            _ = A.ListBase.prototype;
            _.super$ListBase$setRange = _.setRange$4;
            _ = A.Iterable.prototype;
            _.super$Iterable$where = _.where$1;
            _.super$Iterable$skipWhile = _.skipWhile$1;
            _ = A.ModifiableCssParentNode.prototype;
            _.super$ModifiableCssParentNode$addChild = _.addChild$1;
            _ = A.SimpleSelector.prototype;
            _.super$SimpleSelector$addSuffix = _.addSuffix$1;
            _.super$SimpleSelector$unify = _.unify$1;
            _.super$SimpleSelector$isSuperselector = _.isSuperselector$1;
            _ = A.Parser.prototype;
            _.super$Parser$silentComment = _.silentComment$0;
            _ = A.StylesheetParser.prototype;
            _.super$StylesheetParser$importArgument = _.importArgument$0;
            _.super$StylesheetParser$namespacedExpression = _.namespacedExpression$2;
            _ = A.Value.prototype;
            _.super$Value$assertMap = _.assertMap$1;
            _.super$Value$plus = _.plus$1;
            _.super$Value$minus = _.minus$1;
            _.super$Value$dividedBy = _.dividedBy$1;
            _.super$Value$toString = _.toString$0;
            _ = A.ColorSpace.prototype;
            _.super$ColorSpace$convert = _.convert$5;
            _.super$ColorSpace$convertLinear = _.convertLinear$10$missingA$missingB$missingChroma$missingHue$missingLightness;
            _.super$ColorSpace$transformationMatrix = _.transformationMatrix$1;
            _ = A.SassNumber.prototype;
            _.super$SassNumber$convertValueToMatch = _.convertValueToMatch$3;
            _.super$SassNumber$coerce = _.coerce$3;
            _.super$SassNumber$coerceValue = _.coerceValue$3;
            _.super$SassNumber$coerceValueToUnit = _.coerceValueToUnit$2;
            _.super$SassNumber$coerceToMatch = _.coerceToMatch$3;
            _.super$SassNumber$coerceValueToMatch = _.coerceValueToMatch$3;
            _.super$SassNumber$greaterThan = _.greaterThan$1;
            _.super$SassNumber$greaterThanOrEquals = _.greaterThanOrEquals$1;
            _.super$SassNumber$lessThan = _.lessThan$1;
            _.super$SassNumber$lessThanOrEquals = _.lessThanOrEquals$1;
            _.super$SassNumber$modulo = _.modulo$1;
            _.super$SassNumber$plus = _.plus$1;
            _.super$SassNumber$minus = _.minus$1;
            _.super$SassNumber$times = _.times$1;
            _.super$SassNumber$dividedBy = _.dividedBy$1;
            _ = A.AnySelectorVisitor.prototype;
            _.super$AnySelectorVisitor$visitComplexSelector = _.visitComplexSelector$1;
            _ = A.EveryCssVisitor.prototype;
            _.super$EveryCssVisitor$visitCssStyleRule = _.visitCssStyleRule$1;
            _ = A.ReplaceExpressionVisitor.prototype;
            _.super$ReplaceExpressionVisitor$visitBinaryOperationExpression = _.visitBinaryOperationExpression$1;
            _.super$ReplaceExpressionVisitor$visitUnaryOperationExpression = _.visitUnaryOperationExpression$1;
            _ = A.SourceSpanMixin.prototype;
            _.super$SourceSpanMixin$compareTo = _.compareTo$1;
            _.super$SourceSpanMixin$$eq = _.$eq;
            _ = A.StringScanner.prototype;
            _.super$StringScanner$readChar = _.readChar$0;
            _.super$StringScanner$scanChar = _.scanChar$1;
            _.super$StringScanner$scan = _.scan$1;
            _.super$StringScanner$matches = _.matches$1;
            _ = A.AnySelectorVisitor0.prototype;
            _.super$AnySelectorVisitor$visitComplexSelector0 = _.visitComplexSelector$1;
            _ = A.EveryCssVisitor0.prototype;
            _.super$EveryCssVisitor$visitCssStyleRule0 = _.visitCssStyleRule$1;
            _ = A.ModifiableCssParentNode0.prototype;
            _.super$ModifiableCssParentNode$addChild0 = _.addChild$1;
            _ = A.SassNumber0.prototype;
            _.super$SassNumber$convertToMatch = _.convertToMatch$3;
            _.super$SassNumber$convertValueToMatch0 = _.convertValueToMatch$3;
            _.super$SassNumber$coerce0 = _.coerce$3;
            _.super$SassNumber$coerceValue0 = _.coerceValue$3;
            _.super$SassNumber$coerceValueToUnit0 = _.coerceValueToUnit$2;
            _.super$SassNumber$coerceToMatch0 = _.coerceToMatch$3;
            _.super$SassNumber$coerceValueToMatch0 = _.coerceValueToMatch$3;
            _.super$SassNumber$greaterThan0 = _.greaterThan$1;
            _.super$SassNumber$greaterThanOrEquals0 = _.greaterThanOrEquals$1;
            _.super$SassNumber$lessThan0 = _.lessThan$1;
            _.super$SassNumber$lessThanOrEquals0 = _.lessThanOrEquals$1;
            _.super$SassNumber$modulo0 = _.modulo$1;
            _.super$SassNumber$plus0 = _.plus$1;
            _.super$SassNumber$minus0 = _.minus$1;
            _.super$SassNumber$times0 = _.times$1;
            _.super$SassNumber$dividedBy0 = _.dividedBy$1;
            _ = A.Parser1.prototype;
            _.super$Parser$silentComment0 = _.silentComment$0;
            _ = A.ReplaceExpressionVisitor0.prototype;
            _.super$ReplaceExpressionVisitor$visitBinaryOperationExpression0 = _.visitBinaryOperationExpression$1;
            _.super$ReplaceExpressionVisitor$visitUnaryOperationExpression0 = _.visitUnaryOperationExpression$1;
            _ = A.SimpleSelector0.prototype;
            _.super$SimpleSelector$addSuffix0 = _.addSuffix$1;
            _.super$SimpleSelector$unify0 = _.unify$1;
            _.super$SimpleSelector$isSuperselector0 = _.isSuperselector$1;
            _ = A.ColorSpace0.prototype;
            _.super$ColorSpace$convert0 = _.convert$5;
            _.super$ColorSpace$convertLinear0 = _.convertLinear$10$missingA$missingB$missingChroma$missingHue$missingLightness;
            _.super$ColorSpace$transformationMatrix0 = _.transformationMatrix$1;
            _ = A.StylesheetParser0.prototype;
            _.super$StylesheetParser$importArgument0 = _.importArgument$0;
            _.super$StylesheetParser$namespacedExpression0 = _.namespacedExpression$2;
            _ = A.Value0.prototype;
            _.super$Value$assertMap0 = _.assertMap$1;
            _.super$Value$plus0 = _.plus$1;
            _.super$Value$minus0 = _.minus$1;
            _.super$Value$dividedBy0 = _.dividedBy$1;
            _.super$Value$toString0 = _.toString$0;
        })();
        (function installTearOffs() {
            var _static_2 = hunkHelpers._static_2, _instance_1_i = hunkHelpers._instance_1i, _instance_1_u = hunkHelpers._instance_1u, _static_1 = hunkHelpers._static_1, _static_0 = hunkHelpers._static_0, _static = hunkHelpers.installStaticTearOff, _instance = hunkHelpers.installInstanceTearOff, _instance_2_u = hunkHelpers._instance_2u, _instance_0_i = hunkHelpers._instance_0i, _instance_0_u = hunkHelpers._instance_0u;
            _static_2(J, "_interceptors_JSArray__compareAny$closure", "JSArray__compareAny", 272);
            _instance_1_i(J.JSArray.prototype, "get$contains", "contains$1", 9);
            _instance_1_i(A._CastIterableBase.prototype, "get$contains", "contains$1", 9);
            _instance_1_u(A.CastMap.prototype, "get$containsKey", "containsKey$1", 9);
            _instance_1_u(A.ConstantStringMap.prototype, "get$containsKey", "containsKey$1", 9);
            _instance_1_i(A.ConstantStringSet.prototype, "get$contains", "contains$1", 9);
            _instance_1_i(A.GeneralConstantSet.prototype, "get$contains", "contains$1", 9);
            _instance_1_u(A.JsLinkedHashMap.prototype, "get$containsKey", "containsKey$1", 9);
            _static_1(A, "async__AsyncRun__scheduleImmediateJsOverride$closure", "_AsyncRun__scheduleImmediateJsOverride", 138);
            _static_1(A, "async__AsyncRun__scheduleImmediateWithSetImmediate$closure", "_AsyncRun__scheduleImmediateWithSetImmediate", 138);
            _static_1(A, "async__AsyncRun__scheduleImmediateWithTimer$closure", "_AsyncRun__scheduleImmediateWithTimer", 138);
            _static_0(A, "async___startMicrotaskLoop$closure", "_startMicrotaskLoop", 0);
            _static_1(A, "async___nullDataHandler$closure", "_nullDataHandler", 71);
            _static_2(A, "async___nullErrorHandler$closure", "_nullErrorHandler", 70);
            _static_0(A, "async___nullDoneHandler$closure", "_nullDoneHandler", 0);
            _static(A, "async___rootHandleUncaughtError$closure", 5, null, [
                "call$5"
            ], [
                "_rootHandleUncaughtError"
            ], 655, 0);
            _static(A, "async___rootRun$closure", 4, null, [
                "call$1$4",
                "call$4"
            ], [
                "_rootRun",
                function($self, $parent, zone, f) {
                    return A._rootRun($self, $parent, zone, f, type$.dynamic);
                }
            ], 656, 1);
            _static(A, "async___rootRunUnary$closure", 5, null, [
                "call$2$5",
                "call$5"
            ], [
                "_rootRunUnary",
                function($self, $parent, zone, f, arg) {
                    var t1 = type$.dynamic;
                    return A._rootRunUnary($self, $parent, zone, f, arg, t1, t1);
                }
            ], 657, 1);
            _static(A, "async___rootRunBinary$closure", 6, null, [
                "call$3$6",
                "call$6"
            ], [
                "_rootRunBinary",
                function($self, $parent, zone, f, arg1, arg2) {
                    var t1 = type$.dynamic;
                    return A._rootRunBinary($self, $parent, zone, f, arg1, arg2, t1, t1, t1);
                }
            ], 658, 1);
            _static(A, "async___rootRegisterCallback$closure", 4, null, [
                "call$1$4",
                "call$4"
            ], [
                "_rootRegisterCallback",
                function($self, $parent, zone, f) {
                    return A._rootRegisterCallback($self, $parent, zone, f, type$.dynamic);
                }
            ], 659, 0);
            _static(A, "async___rootRegisterUnaryCallback$closure", 4, null, [
                "call$2$4",
                "call$4"
            ], [
                "_rootRegisterUnaryCallback",
                function($self, $parent, zone, f) {
                    var t1 = type$.dynamic;
                    return A._rootRegisterUnaryCallback($self, $parent, zone, f, t1, t1);
                }
            ], 660, 0);
            _static(A, "async___rootRegisterBinaryCallback$closure", 4, null, [
                "call$3$4",
                "call$4"
            ], [
                "_rootRegisterBinaryCallback",
                function($self, $parent, zone, f) {
                    var t1 = type$.dynamic;
                    return A._rootRegisterBinaryCallback($self, $parent, zone, f, t1, t1, t1);
                }
            ], 661, 0);
            _static(A, "async___rootErrorCallback$closure", 5, null, [
                "call$5"
            ], [
                "_rootErrorCallback"
            ], 662, 0);
            _static(A, "async___rootScheduleMicrotask$closure", 4, null, [
                "call$4"
            ], [
                "_rootScheduleMicrotask"
            ], 663, 0);
            _static(A, "async___rootCreateTimer$closure", 5, null, [
                "call$5"
            ], [
                "_rootCreateTimer"
            ], 664, 0);
            _static(A, "async___rootCreatePeriodicTimer$closure", 5, null, [
                "call$5"
            ], [
                "_rootCreatePeriodicTimer"
            ], 665, 0);
            _static(A, "async___rootPrint$closure", 4, null, [
                "call$4"
            ], [
                "_rootPrint"
            ], 666, 0);
            _static_1(A, "async___printToZone$closure", "_printToZone0", 90);
            _static(A, "async___rootFork$closure", 5, null, [
                "call$5"
            ], [
                "_rootFork"
            ], 667, 0);
            _instance(A._AsyncCompleter.prototype, "get$complete", 0, 0, function() {
                return [
                    null
                ];
            }, [
                "call$1",
                "call$0"
            ], [
                "complete$1",
                "complete$0"
            ], 192, 0, 0);
            _instance_2_u(A._Future.prototype, "get$_completeError", "_completeError$2", 70);
            var _;
            _instance_1_i(_ = A._StreamController.prototype, "get$add", "add$1", 37);
            _instance(_, "get$addError", 0, 1, function() {
                return [
                    null
                ];
            }, [
                "call$2",
                "call$1"
            ], [
                "addError$2",
                "addError$1"
            ], 268, 0, 0);
            _instance_0_i(_, "get$close", "close$0", 445);
            _instance_1_u(_, "get$_async$_add", "_async$_add$1", 37);
            _instance_2_u(_, "get$_addError", "_addError$2", 70);
            _instance_0_u(_, "get$_close", "_close$0", 0);
            _instance_0_u(_ = A._ControllerSubscription.prototype, "get$_async$_onPause", "_async$_onPause$0", 0);
            _instance_0_u(_, "get$_async$_onResume", "_async$_onResume$0", 0);
            _instance(_ = A._BufferingStreamSubscription.prototype, "get$pause", 1, 0, null, [
                "call$1",
                "call$0"
            ], [
                "pause$1",
                "pause$0"
            ], 584, 0, 0);
            _instance_0_i(_, "get$resume", "resume$0", 0);
            _instance_0_u(_, "get$_async$_onPause", "_async$_onPause$0", 0);
            _instance_0_u(_, "get$_async$_onResume", "_async$_onResume$0", 0);
            _instance_1_u(_ = A._StreamIterator.prototype, "get$_onData", "_onData$1", 37);
            _instance_2_u(_, "get$_onError", "_onError$2", 70);
            _instance_0_u(_, "get$_onDone", "_onDone$0", 0);
            _instance_0_u(_ = A._ForwardingStreamSubscription.prototype, "get$_async$_onPause", "_async$_onPause$0", 0);
            _instance_0_u(_, "get$_async$_onResume", "_async$_onResume$0", 0);
            _instance_1_u(_, "get$_handleData", "_handleData$1", 37);
            _instance_2_u(_, "get$_handleError", "_handleError$2", 300);
            _instance_0_u(_, "get$_handleDone", "_handleDone$0", 0);
            _static_2(A, "collection___defaultEquals$closure", "_defaultEquals", 273);
            _static_1(A, "collection___defaultHashCode$closure", "_defaultHashCode", 274);
            _static_2(A, "collection_ListBase__compareAny$closure", "ListBase__compareAny", 272);
            _instance_1_u(A._HashMap.prototype, "get$containsKey", "containsKey$1", 9);
            _instance_1_u(A._LinkedCustomHashMap.prototype, "get$containsKey", "containsKey$1", 9);
            _instance(_ = A._LinkedHashSet.prototype, "get$_newSimilarSet", 0, 0, null, [
                "call$1$0",
                "call$0"
            ], [
                "_newSimilarSet$1$0",
                "_newSimilarSet$0"
            ], 151, 0, 0);
            _instance_1_i(_, "get$contains", "contains$1", 9);
            _instance_1_i(_, "get$add", "add$1", 9);
            _instance(A._LinkedIdentityHashSet.prototype, "get$_newSimilarSet", 0, 0, null, [
                "call$1$0",
                "call$0"
            ], [
                "_newSimilarSet$1$0",
                "_newSimilarSet$0"
            ], 151, 0, 0);
            _instance_1_u(A.MapBase.prototype, "get$containsKey", "containsKey$1", 9);
            _instance_1_u(A.MapView.prototype, "get$containsKey", "containsKey$1", 9);
            _instance_1_i(A.UnmodifiableSetView.prototype, "get$contains", "contains$1", 9);
            _static_1(A, "convert___defaultToEncodable$closure", "_defaultToEncodable", 108);
            _instance_1_u(A._JsonMap.prototype, "get$containsKey", "containsKey$1", 9);
            _static_1(A, "core__identityHashCode$closure", "identityHashCode", 274);
            _static_2(A, "core__identical$closure", "identical", 273);
            _static_1(A, "core_Uri_decodeComponent$closure", "Uri_decodeComponent", 6);
            _instance_1_i(A.Iterable.prototype, "get$contains", "contains$1", 9);
            _instance_1_i(A.StringBuffer.prototype, "get$write", "write$1", 37);
            _static(A, "math0__max$closure", 2, null, [
                "call$1$2",
                "call$2"
            ], [
                "max",
                function(a, b) {
                    return A.max(a, b, type$.num);
                }
            ], 670, 1);
            _instance_1_u(A.ArgResults.prototype, "get$wasParsed", "wasParsed$1", 4);
            _instance_1_u(_ = A.StreamCompleter.prototype, "get$setSourceStream", "setSourceStream$1", 37);
            _instance(_, "get$setError", 0, 1, function() {
                return [
                    null
                ];
            }, [
                "call$2",
                "call$1"
            ], [
                "setError$2",
                "setError$1"
            ], 268, 0, 0);
            _instance_0_u(_ = A.StreamGroup.prototype, "get$_onListen", "_onListen$0", 0);
            _instance_0_u(_, "get$_onPause", "_onPause$0", 0);
            _instance_0_u(_, "get$_onResume", "_onResume$0", 0);
            _instance_0_u(_, "get$_onCancel", "_onCancel$0", 226);
            _instance_0_i(A.ReplAdapter.prototype, "get$exit", "exit$0", 0);
            _instance_1_i(A.EmptyUnmodifiableSet.prototype, "get$contains", "contains$1", 9);
            _instance_1_i(A.UnionSet.prototype, "get$contains", "contains$1", 9);
            _instance_1_i(A._DelegatingIterableBase.prototype, "get$contains", "contains$1", 9);
            _instance_1_i(A.MapKeySet.prototype, "get$contains", "contains$1", 9);
            _static_1(A, "version_Version___parse_tearOff$closure", "Version___parse_tearOff", 235);
            _instance_1_u(A.VersionRange.prototype, "get$allows", "allows$1", 489);
            _instance_1_u(A._IsInvisibleVisitor0.prototype, "get$visitComplexSelector", "visitComplexSelector$1", 21);
            _instance_1_u(A._IsBogusVisitor.prototype, "get$visitComplexSelector", "visitComplexSelector$1", 21);
            _instance_1_u(A._IsUselessVisitor.prototype, "get$visitComplexSelector", "visitComplexSelector$1", 21);
            _instance_1_u(A.SelectorList.prototype, "get$isSuperselector", "isSuperselector$1", 77);
            _instance_1_u(A.PseudoSelector.prototype, "get$isSuperselector", "isSuperselector$1", 14);
            _instance_1_u(A.SimpleSelector.prototype, "get$isSuperselector", "isSuperselector$1", 14);
            _instance_1_u(A.TypeSelector.prototype, "get$isSuperselector", "isSuperselector$1", 14);
            _instance_1_u(A.UniversalSelector.prototype, "get$isSuperselector", "isSuperselector$1", 14);
            _instance_1_u(A.EmptyExtensionStore.prototype, "get$addExtensions", "addExtensions$1", 210);
            _instance_1_u(A.ExtensionStore.prototype, "get$addExtensions", "addExtensions$1", 210);
            _static_1(A, "functions___isUnique$closure", "_isUnique", 14);
            _instance_2_u(A.NodePackageImporter.prototype, "get$_compareExpansionKeys", "_compareExpansionKeys$2", 145);
            _instance_0_u(A.CssParser.prototype, "get$silentComment", "silentComment$0", 20);
            _instance_0_u(_ = A.Parser.prototype, "get$silentComment", "silentComment$0", 20);
            _instance_0_u(_, "get$loudComment", "loudComment$0", 0);
            _instance_0_u(_, "get$string", "string$0", 29);
            _instance(_, "get$error", 1, 2, function() {
                return [
                    null
                ];
            }, [
                "call$3",
                "call$2"
            ], [
                "error$3",
                "error$2"
            ], 158, 0, 0);
            _instance(_ = A.StylesheetParser.prototype, "get$_statement", 0, 0, null, [
                "call$1$root",
                "call$0"
            ], [
                "_statement$1$root",
                "_statement$0"
            ], 457, 0, 0);
            _instance_0_u(_, "get$_declarationChild", "_declarationChild$0", 125);
            _instance_0_u(_, "get$_functionChild", "_functionChild$0", 125);
            _instance(_, "get$_expression", 0, 0, null, [
                "call$4$bracketList$consumeNewlines$singleEquals$until",
                "call$0",
                "call$1$consumeNewlines",
                "call$3$consumeNewlines$singleEquals$until",
                "call$1$bracketList",
                "call$2$consumeNewlines$until"
            ], [
                "_expression$4$bracketList$consumeNewlines$singleEquals$until",
                "_expression$0",
                "_expression$1$consumeNewlines",
                "_expression$3$consumeNewlines$singleEquals$until",
                "_expression$1$bracketList",
                "_expression$2$consumeNewlines$until"
            ], 473, 0, 0);
            _instance_0_u(_, "get$_number", "_number$0", 474);
            _instance(A.LazyFileSpan.prototype, "get$message", 1, 1, function() {
                return {
                    color: null
                };
            }, [
                "call$2$color",
                "call$1"
            ], [
                "message$2$color",
                "message$1"
            ], 123, 0, 0);
            _instance_1_u(A.LimitedMapView.prototype, "get$containsKey", "containsKey$1", 9);
            _instance_1_u(A.MergedMapView.prototype, "get$containsKey", "containsKey$1", 9);
            _instance(A.MultiSpan.prototype, "get$message", 1, 1, function() {
                return {
                    color: null
                };
            }, [
                "call$2$color",
                "call$1"
            ], [
                "message$2$color",
                "message$1"
            ], 163, 0, 0);
            _instance_1_i(A.NoSourceMapBuffer.prototype, "get$write", "write$1", 37);
            _instance_1_u(A.PrefixedMapView.prototype, "get$containsKey", "containsKey$1", 9);
            _instance_1_u(A.PublicMemberMapView.prototype, "get$containsKey", "containsKey$1", 9);
            _instance_1_i(A.SourceMapBuffer.prototype, "get$write", "write$1", 37);
            _instance_1_u(A.UnprefixedMapView.prototype, "get$containsKey", "containsKey$1", 9);
            _static_1(A, "utils__isPublic$closure", "isPublic", 4);
            _static_1(A, "calculation_SassCalculation__simplify$closure", "SassCalculation__simplify", 75);
            _instance_1_u(A.ColorChannel.prototype, "get$isAnalogous", "isAnalogous$1", 93);
            _instance_1_u(A.DisplayP3ColorSpace.prototype, "get$toLinear", "toLinear$1", 12);
            _instance_1_u(A.SrgbColorSpace.prototype, "get$toLinear", "toLinear$1", 12);
            _instance_1_u(A.AnySelectorVisitor.prototype, "get$visitComplexSelector", "visitComplexSelector$1", 21);
            _instance(_ = A._EvaluateVisitor0.prototype, "get$_async_evaluate$_interpolationToValue", 0, 1, null, [
                "call$3$trim$warnForColor",
                "call$1",
                "call$2$warnForColor"
            ], [
                "_async_evaluate$_interpolationToValue$3$trim$warnForColor",
                "_async_evaluate$_interpolationToValue$1",
                "_async_evaluate$_interpolationToValue$2$warnForColor"
            ], 337, 0, 0);
            _instance_1_u(_, "get$_async_evaluate$_expressionNode", "_async_evaluate$_expressionNode$1", 166);
            _instance(_ = A._EvaluateVisitor.prototype, "get$_interpolationToValue", 0, 1, null, [
                "call$3$trim$warnForColor",
                "call$1",
                "call$2$warnForColor"
            ], [
                "_interpolationToValue$3$trim$warnForColor",
                "_interpolationToValue$1",
                "_interpolationToValue$2$warnForColor"
            ], 550, 0, 0);
            _instance_1_u(_, "get$_expressionNode", "_expressionNode$1", 166);
            _instance_1_i(_ = A.RecursiveStatementVisitor.prototype, "get$visitContentBlock", "visitContentBlock$1", 694);
            _instance_1_u(_, "get$visitChildren", "visitChildren$1", 277);
            _instance_1_u(_ = A.SelectorSearchVisitor.prototype, "get$visitComplexSelector", "visitComplexSelector$1", "SelectorSearchVisitor.T?(ComplexSelector)");
            _instance_1_u(_, "get$visitSelectorList", "visitSelectorList$1", "SelectorSearchVisitor.T?(SelectorList)");
            _instance_1_u(_ = A._SerializeVisitor.prototype, "get$_visitMediaQuery", "_visitMediaQuery$1", 281);
            _instance_1_u(_, "get$_writeCalculationValue", "_writeCalculationValue$1", 97);
            _instance(_, "get$_writeChannel", 0, 1, null, [
                "call$2",
                "call$1"
            ], [
                "_writeChannel$2",
                "_writeChannel$1"
            ], 195, 0, 0);
            _instance_1_u(_, "get$visitSelectorList", "visitSelectorList$1", 283);
            _instance_1_u(_, "get$_requiresSemicolon", "_requiresSemicolon$1", 7);
            _instance_1_i(_ = A.StatementSearchVisitor.prototype, "get$visitContentBlock", "visitContentBlock$1", "StatementSearchVisitor.T?(ContentBlock)");
            _instance_1_u(_, "get$visitChildren", "visitChildren$1", "StatementSearchVisitor.T?(List<Statement>)");
            _instance(A.SourceSpanMixin.prototype, "get$message", 1, 1, function() {
                return {
                    color: null
                };
            }, [
                "call$2$color",
                "call$1"
            ], [
                "message$2$color",
                "message$1"
            ], 123, 0, 0);
            _static_1(A, "frame_Frame___parseVM_tearOff$closure", "Frame___parseVM_tearOff", 94);
            _static_1(A, "frame_Frame___parseV8_tearOff$closure", "Frame___parseV8_tearOff", 94);
            _static_1(A, "frame_Frame___parseFirefox_tearOff$closure", "Frame___parseFirefox_tearOff", 94);
            _static_1(A, "frame_Frame___parseFriendly_tearOff$closure", "Frame___parseFriendly_tearOff", 94);
            _static_1(A, "trace_Trace___parseVM_tearOff$closure", "Trace___parseVM_tearOff", 231);
            _static_1(A, "trace_Trace___parseFriendly_tearOff$closure", "Trace___parseFriendly_tearOff", 231);
            _static(A, "from_handlers__TransformByHandlers__defaultHandleError$closure", 3, null, [
                "call$1$3",
                "call$3"
            ], [
                "TransformByHandlers__defaultHandleError",
                function(error, stackTrace, sink) {
                    return A.TransformByHandlers__defaultHandleError(error, stackTrace, sink, type$.dynamic);
                }
            ], 673, 0);
            _static(A, "rate_limit___collect$closure", 2, null, [
                "call$1$2",
                "call$2"
            ], [
                "_collect",
                function($event, soFar) {
                    return A._collect($event, soFar, type$.dynamic);
                }
            ], 674, 0);
            _instance_1_u(A.AnySelectorVisitor0.prototype, "get$visitComplexSelector", "visitComplexSelector$1", 22);
            _instance(_ = A._EvaluateVisitor2.prototype, "get$_async_evaluate0$_interpolationToValue", 0, 1, null, [
                "call$3$trim$warnForColor",
                "call$1",
                "call$2$warnForColor"
            ], [
                "_async_evaluate0$_interpolationToValue$3$trim$warnForColor",
                "_async_evaluate0$_interpolationToValue$1",
                "_async_evaluate0$_interpolationToValue$2$warnForColor"
            ], 322, 0, 0);
            _instance_1_u(_, "get$_async_evaluate0$_expressionNode", "_async_evaluate0$_expressionNode$1", 206);
            _static_1(A, "calculation1___assertCalculationValue$closure", "_assertCalculationValue", 97);
            _static_1(A, "calculation1___isValidClampArg$closure", "_isValidClampArg", 9);
            _static_1(A, "calculation0_SassCalculation__simplify$closure", "SassCalculation__simplify0", 75);
            _instance_1_u(A.ColorChannel0.prototype, "get$isAnalogous", "isAnalogous$1", 67);
            _static(A, "compile__compile$closure", 1, function() {
                return [
                    null
                ];
            }, [
                "call$2",
                "call$1"
            ], [
                "compile0",
                function(path) {
                    return A.compile0(path, null);
                }
            ], 675, 0);
            _static(A, "compile__compileString$closure", 1, function() {
                return [
                    null
                ];
            }, [
                "call$2",
                "call$1"
            ], [
                "compileString0",
                function(text) {
                    return A.compileString0(text, null);
                }
            ], 676, 0);
            _static(A, "compile__compileAsync$closure", 1, function() {
                return [
                    null
                ];
            }, [
                "call$2",
                "call$1"
            ], [
                "compileAsync1",
                function(path) {
                    return A.compileAsync1(path, null);
                }
            ], 677, 0);
            _static(A, "compile__compileStringAsync$closure", 1, function() {
                return [
                    null
                ];
            }, [
                "call$2",
                "call$1"
            ], [
                "compileStringAsync1",
                function(text) {
                    return A.compileStringAsync1(text, null);
                }
            ], 678, 0);
            _static_1(A, "compile___parseImporter$closure", "_parseImporter0", 679);
            _static_1(A, "compile___simplifyCalcArg$closure", "_simplifyCalcArg", 75);
            _static_0(A, "compiler__initCompiler$closure", "initCompiler", 680);
            _static_0(A, "compiler__initAsyncCompiler$closure", "initAsyncCompiler", 681);
            _instance_0_u(A.CssParser0.prototype, "get$silentComment", "silentComment$0", 20);
            _instance_1_u(A.DisplayP3ColorSpace0.prototype, "get$toLinear", "toLinear$1", 12);
            _instance_1_u(A.EmptyExtensionStore0.prototype, "get$addExtensions", "addExtensions$1", 236);
            _instance(_ = A._EvaluateVisitor1.prototype, "get$_evaluate0$_interpolationToValue", 0, 1, null, [
                "call$3$trim$warnForColor",
                "call$1",
                "call$2$warnForColor"
            ], [
                "_evaluate0$_interpolationToValue$3$trim$warnForColor",
                "_evaluate0$_interpolationToValue$1",
                "_evaluate0$_interpolationToValue$2$warnForColor"
            ], 455, 0, 0);
            _instance_1_u(_, "get$_evaluate0$_expressionNode", "_evaluate0$_expressionNode$1", 206);
            _instance_1_u(A.ExtensionStore0.prototype, "get$addExtensions", "addExtensions$1", 236);
            _static_1(A, "functions0___isUnique$closure", "_isUnique0", 15);
            _static_1(A, "immutable__jsToDartList$closure", "jsToDartList", 682);
            _instance(A.LazyFileSpan0.prototype, "get$message", 1, 1, function() {
                return {
                    color: null
                };
            }, [
                "call$2$color",
                "call$1"
            ], [
                "message$2$color",
                "message$1"
            ], 123, 0, 0);
            _static_2(A, "legacy__render$closure", "render", 683);
            _static_1(A, "legacy__renderSync$closure", "renderSync", 684);
            _instance_1_u(A.LimitedMapView0.prototype, "get$containsKey", "containsKey$1", 9);
            _instance_1_u(A.SelectorList0.prototype, "get$isSuperselector", "isSuperselector$1", 68);
            _instance_1_u(A.MergedMapView0.prototype, "get$containsKey", "containsKey$1", 9);
            _instance(A.MultiSpan0.prototype, "get$message", 1, 1, function() {
                return {
                    color: null
                };
            }, [
                "call$2$color",
                "call$1"
            ], [
                "message$2$color",
                "message$1"
            ], 163, 0, 0);
            _instance_1_i(A.NoSourceMapBuffer0.prototype, "get$write", "write$1", 37);
            _instance_2_u(A.NodePackageImporter0.prototype, "get$_node_package$_compareExpansionKeys", "_node_package$_compareExpansionKeys$2", 145);
            _static_0(A, "parser0__loadParserExports$closure", "loadParserExports", 685);
            _static(A, "parser0___parse$closure", 3, null, [
                "call$3"
            ], [
                "_parse"
            ], 686, 0);
            _static_1(A, "parser0___parseIdentifier$closure", "_parseIdentifier", 687);
            _static_1(A, "parser0___toCssIdentifier$closure", "_toCssIdentifier", 6);
            _instance_0_u(_ = A.Parser1.prototype, "get$silentComment", "silentComment$0", 20);
            _instance_0_u(_, "get$loudComment", "loudComment$0", 0);
            _instance_0_u(_, "get$string", "string$0", 29);
            _instance(_, "get$error", 1, 2, function() {
                return [
                    null
                ];
            }, [
                "call$3",
                "call$2"
            ], [
                "error$3",
                "error$2"
            ], 158, 0, 0);
            _instance_1_u(A.PrefixedMapView0.prototype, "get$containsKey", "containsKey$1", 9);
            _instance_1_u(A.PseudoSelector0.prototype, "get$isSuperselector", "isSuperselector$1", 15);
            _instance_1_u(A.PublicMemberMapView0.prototype, "get$containsKey", "containsKey$1", 9);
            _instance_1_u(A._IsInvisibleVisitor2.prototype, "get$visitComplexSelector", "visitComplexSelector$1", 22);
            _instance_1_u(A._IsBogusVisitor0.prototype, "get$visitComplexSelector", "visitComplexSelector$1", 22);
            _instance_1_u(A._IsUselessVisitor0.prototype, "get$visitComplexSelector", "visitComplexSelector$1", 22);
            _instance_1_u(_ = A.SelectorSearchVisitor0.prototype, "get$visitComplexSelector", "visitComplexSelector$1", "SelectorSearchVisitor0.T?(ComplexSelector0)");
            _instance_1_u(_, "get$visitSelectorList", "visitSelectorList$1", "SelectorSearchVisitor0.T?(SelectorList0)");
            _instance_1_u(_ = A._SerializeVisitor0.prototype, "get$_serialize0$_visitMediaQuery", "_serialize0$_visitMediaQuery$1", 595);
            _instance_1_u(_, "get$_serialize0$_writeCalculationValue", "_serialize0$_writeCalculationValue$1", 97);
            _instance(_, "get$_serialize0$_writeChannel", 0, 1, null, [
                "call$2",
                "call$1"
            ], [
                "_serialize0$_writeChannel$2",
                "_serialize0$_writeChannel$1"
            ], 195, 0, 0);
            _instance_1_u(_, "get$visitSelectorList", "visitSelectorList$1", 596);
            _instance_1_u(_, "get$_serialize0$_requiresSemicolon", "_serialize0$_requiresSemicolon$1", 8);
            _instance_1_u(A.SimpleSelector0.prototype, "get$isSuperselector", "isSuperselector$1", 15);
            _instance_1_i(A.SourceMapBuffer0.prototype, "get$write", "write$1", 37);
            _instance_1_u(A.SrgbColorSpace0.prototype, "get$toLinear", "toLinear$1", 12);
            _instance_1_i(_ = A.StatementSearchVisitor0.prototype, "get$visitContentBlock", "visitContentBlock$1", "StatementSearchVisitor0.T?(ContentBlock0)");
            _instance_1_u(_, "get$visitChildren", "visitChildren$1", "StatementSearchVisitor0.T?(List<Statement0>)");
            _instance(_ = A.StylesheetParser0.prototype, "get$_stylesheet0$_statement", 0, 0, null, [
                "call$1$root",
                "call$0"
            ], [
                "_stylesheet0$_statement$1$root",
                "_stylesheet0$_statement$0"
            ], 617, 0, 0);
            _instance_0_u(_, "get$_stylesheet0$_declarationChild", "_stylesheet0$_declarationChild$0", 137);
            _instance_0_u(_, "get$_stylesheet0$_functionChild", "_stylesheet0$_functionChild$0", 137);
            _instance_0_u(_, "get$_stylesheet0$_number", "_stylesheet0$_number$0", 619);
            _instance_1_u(A.TypeSelector0.prototype, "get$isSuperselector", "isSuperselector$1", 15);
            _instance_1_u(A.UniversalSelector0.prototype, "get$isSuperselector", "isSuperselector$1", 15);
            _instance_1_u(A.UnprefixedMapView0.prototype, "get$containsKey", "containsKey$1", 9);
            _static_1(A, "utils3__jsToDartUrl$closure", "jsToDartUrl", 688);
            _static_1(A, "utils3__dartToJSUrl$closure", "dartToJSUrl", 176);
            _static_1(A, "utils3__mapToObject$closure", "mapToObject", 689);
            _static_1(A, "utils1__isPublic$closure", "isPublic0", 4);
            _static_1(A, "utils1__unvendor$closure", "unvendor0", 6);
            _static(A, "path__absolute$closure", 1, function() {
                return [
                    null,
                    null,
                    null,
                    null,
                    null,
                    null,
                    null,
                    null,
                    null,
                    null,
                    null,
                    null,
                    null,
                    null
                ];
            }, [
                "call$15",
                "call$1",
                "call$2",
                "call$3",
                "call$4",
                "call$5",
                "call$6"
            ], [
                "absolute",
                function(part1) {
                    var _null = null;
                    return A.absolute(part1, _null, _null, _null, _null, _null, _null, _null, _null, _null, _null, _null, _null, _null, _null);
                },
                function(part1, part2) {
                    var _null = null;
                    return A.absolute(part1, part2, _null, _null, _null, _null, _null, _null, _null, _null, _null, _null, _null, _null, _null);
                },
                function(part1, part2, part3) {
                    var _null = null;
                    return A.absolute(part1, part2, part3, _null, _null, _null, _null, _null, _null, _null, _null, _null, _null, _null, _null);
                },
                function(part1, part2, part3, part4) {
                    var _null = null;
                    return A.absolute(part1, part2, part3, part4, _null, _null, _null, _null, _null, _null, _null, _null, _null, _null, _null);
                },
                function(part1, part2, part3, part4, part5) {
                    var _null = null;
                    return A.absolute(part1, part2, part3, part4, part5, _null, _null, _null, _null, _null, _null, _null, _null, _null, _null);
                },
                function(part1, part2, part3, part4, part5, part6) {
                    var _null = null;
                    return A.absolute(part1, part2, part3, part4, part5, part6, _null, _null, _null, _null, _null, _null, _null, _null, _null);
                }
            ], 690, 0);
            _static_1(A, "path__toUri$closure", "toUri", 127);
            _static_1(A, "path__prettyUri$closure", "prettyUri", 691);
            _static_2(A, "number0__fuzzyLessThan$closure", "fuzzyLessThan", 48);
            _static_2(A, "number0__fuzzyLessThanOrEquals$closure", "fuzzyLessThanOrEquals", 48);
            _static_2(A, "number0__fuzzyGreaterThan$closure", "fuzzyGreaterThan", 48);
            _static_2(A, "number0__fuzzyGreaterThanOrEquals$closure", "fuzzyGreaterThanOrEquals", 48);
            _static_2(A, "number0__moduloLikeSass$closure", "moduloLikeSass", 57);
            _static_1(A, "number0__sqrt$closure", "sqrt", 52);
            _static_1(A, "number0__sin$closure", "sin", 52);
            _static_1(A, "number0__cos$closure", "cos", 52);
            _static_1(A, "number0__tan$closure", "tan", 52);
            _static_1(A, "number0__atan$closure", "atan", 52);
            _static_1(A, "number0__asin$closure", "asin", 52);
            _static_1(A, "number0__acos$closure", "acos", 52);
            _static_1(A, "utils0__srgbAndDisplayP3FromLinear$closure", "srgbAndDisplayP3FromLinear", 12);
            _static_2(A, "number2__fuzzyLessThan$closure", "fuzzyLessThan0", 48);
            _static_2(A, "number2__fuzzyLessThanOrEquals$closure", "fuzzyLessThanOrEquals0", 48);
            _static_2(A, "number2__fuzzyGreaterThan$closure", "fuzzyGreaterThan0", 48);
            _static_2(A, "number2__fuzzyGreaterThanOrEquals$closure", "fuzzyGreaterThanOrEquals0", 48);
            _static_2(A, "number2__moduloLikeSass$closure", "moduloLikeSass0", 57);
            _static_1(A, "number2__sqrt$closure", "sqrt0", 53);
            _static_1(A, "number2__sin$closure", "sin0", 53);
            _static_1(A, "number2__cos$closure", "cos0", 53);
            _static_1(A, "number2__tan$closure", "tan0", 53);
            _static_1(A, "number2__atan$closure", "atan0", 53);
            _static_1(A, "number2__asin$closure", "asin0", 53);
            _static_1(A, "number2__acos$closure", "acos0", 53);
            _static_1(A, "sass__main$closure", "main1", 511);
            _static_1(A, "utils4__validateUrlScheme$closure", "validateUrlScheme", 90);
            _static_1(A, "utils2__srgbAndDisplayP3FromLinear$closure", "srgbAndDisplayP3FromLinear0", 12);
            _static_1(A, "value0__wrapValue$closure", "wrapValue", 464);
        })();
        (function inheritance() {
            var _mixin = hunkHelpers.mixin, _inherit = hunkHelpers.inherit, _inheritMany = hunkHelpers.inheritMany;
            _inherit(A.Object, null);
            _inheritMany(A.Object, [
                A.JS_CONST,
                J.Interceptor,
                A.SafeToStringHook,
                J.ArrayIterator,
                A.Iterable,
                A.CastIterator,
                A.Closure,
                A.MapBase,
                A.Error,
                A.ListBase,
                A.SentinelValue,
                A.ListIterator,
                A.MappedIterator,
                A.WhereIterator,
                A.ExpandIterator,
                A.TakeIterator,
                A.SkipIterator,
                A.SkipWhileIterator,
                A.EmptyIterator,
                A.FollowedByIterator,
                A.WhereTypeIterator,
                A.NonNullsIterator,
                A.FixedLengthListMixin,
                A.UnmodifiableListMixin,
                A.Symbol,
                A._Record,
                A.MapView,
                A.ConstantMap,
                A._KeysOrValuesOrElementsIterator,
                A.SetBase,
                A.JSInvocationMirror,
                A.TypeErrorDecoder,
                A.NullThrownFromJavaScriptException,
                A.ExceptionAndStackTrace,
                A._StackTrace,
                A._Required,
                A.LinkedHashMapCell,
                A.LinkedHashMapKeyIterator,
                A.LinkedHashMapValueIterator,
                A.LinkedHashMapEntryIterator,
                A.JSSyntaxRegExp,
                A._MatchImplementation,
                A._AllMatchesIterator,
                A.StringMatch,
                A._StringAllMatchesIterator,
                A._Cell,
                A.Rti,
                A._FunctionParameters,
                A._Type,
                A._TimerImpl,
                A._AsyncAwaitCompleter,
                A._SyncStarIterator,
                A.AsyncError,
                A._Completer,
                A._FutureListener,
                A._Future,
                A._AsyncCallbackEntry,
                A.Stream,
                A._StreamController,
                A._SyncStreamControllerDispatch,
                A._AsyncStreamControllerDispatch,
                A._BufferingStreamSubscription,
                A._AddStreamState,
                A._DelayedEvent,
                A._DelayedDone,
                A._PendingEvents,
                A._StreamIterator,
                A._ZoneFunction,
                A._Zone,
                A._ZoneDelegate,
                A._ZoneSpecification,
                A._HashMapKeyIterator,
                A._LinkedHashSetCell,
                A._LinkedHashSetIterator,
                A._MapBaseValueIterator,
                A._UnmodifiableMapMixin,
                A._ListQueueIterator,
                A._UnmodifiableSetMixin,
                A.Codec,
                A.Converter,
                A._Base64Encoder,
                A.ByteConversionSink,
                A._JsonStringifier,
                A.StringConversionSink,
                A._Utf8Encoder,
                A._Utf8Decoder,
                A.DateTime,
                A.Duration,
                A._Enum,
                A.OutOfMemoryError,
                A.StackOverflowError,
                A._Exception,
                A.FormatException,
                A.MapEntry,
                A.Null,
                A._StringStackTrace,
                A.RuneIterator,
                A.StringBuffer,
                A._Uri,
                A.UriData,
                A._SimpleUri,
                A.Expando,
                A.NullRejectionException,
                A._JSRandom,
                A.ArgParser,
                A.ArgResults,
                A.Option,
                A.OptionType,
                A.Parser0,
                A._Usage,
                A.FutureGroup,
                A.ErrorResult,
                A.ValueResult,
                A.StreamCompleter,
                A.StreamGroup,
                A._StreamGroupState,
                A.StreamQueue,
                A._NextRequest,
                A.Repl,
                A.ReplAdapter,
                A.DefaultEquality,
                A.IterableEquality,
                A.ListEquality,
                A._MapEntry,
                A.MapEquality,
                A._QueueList_Object_ListMixin,
                A._DelegatingIterableBase,
                A.UnmodifiableSetMixin,
                A.Context,
                A._PathDirection,
                A._PathRelation,
                A.Style,
                A.ParsedPath,
                A.PathException,
                A.Version,
                A.VersionRange,
                A.CssMediaQuery,
                A.MediaQuerySuccessfulMergeResult,
                A.CssNode,
                A.__IsInvisibleVisitor_Object_EveryCssVisitor,
                A.CssValue,
                A._FakeAstNode,
                A.ArgumentList,
                A.AtRootQuery,
                A.ConfiguredVariable,
                A.Expression,
                A.IfConditionExpression,
                A.DynamicImport,
                A.StaticImport,
                A.Interpolation,
                A.Parameter,
                A.ParameterList,
                A.Statement,
                A.IfRuleClause,
                A.__HasContentVisitor_Object_StatementSearchVisitor,
                A.SupportsAnything,
                A.SupportsDeclaration,
                A.SupportsFunction,
                A.SupportsInterpolation,
                A.SupportsNegation,
                A.SupportsOperation,
                A.Selector,
                A.__IsInvisibleVisitor_Object_AnySelectorVisitor,
                A.__IsBogusVisitor_Object_AnySelectorVisitor,
                A.__IsUselessVisitor_Object_AnySelectorVisitor,
                A.__ContainsParentSelectorVisitor_Object_AnySelectorVisitor,
                A.ComplexSelectorComponent,
                A.__ParentSelectorVisitor_Object_SelectorSearchVisitor,
                A.QualifiedName,
                A.AsyncEnvironment,
                A._EnvironmentModule0,
                A.AsyncImportCache,
                A.AsyncBuiltInCallable,
                A.BuiltInCallable,
                A.PlainCssCallable,
                A.UserDefinedCallable,
                A.CompileResult,
                A.Configuration,
                A.ConfiguredValue,
                A.Environment,
                A._EnvironmentModule,
                A.EvaluationContext,
                A.LoggerWithDeprecationType,
                A.SourceSpanException,
                A.SassScriptException,
                A.ExecutableOptions,
                A.UsageException,
                A._Watcher,
                A.EmptyExtensionStore,
                A.Extension,
                A.Extender,
                A.ExtensionStore,
                A.ImportCache,
                A.AsyncImporter,
                A.CanonicalizeContext,
                A.ImporterResult,
                A.InterpolationBuffer,
                A.InterpolationMap,
                A.FileSystemException,
                A._QuietLogger,
                A.TrackingLogger,
                A.BuiltInModule,
                A.ForwardedModuleView,
                A.ShadowedModuleView,
                A.Parser,
                A.StylesheetGraph,
                A.StylesheetNode,
                A.Box,
                A.ModifiableBox,
                A.LazyFileSpan,
                A.MultiDirWatcher,
                A.MultiSpan,
                A.NoSourceMapBuffer,
                A.SourceMapBuffer,
                A.Value,
                A.CalculationOperation,
                A._ColorFormatEnum,
                A.SpanColorFormat,
                A.ColorChannel,
                A.GamutMapMethod,
                A.InterpolationMethod,
                A.ColorSpace,
                A.AnySelectorVisitor,
                A._EvaluateVisitor0,
                A._ImportedCssVisitor0,
                A._CloneCssVisitor,
                A.Evaluator,
                A._EvaluateVisitor,
                A._ImportedCssVisitor,
                A.EveryCssVisitor,
                A.__MakeExpressionCalculationSafe_Object_ReplaceExpressionVisitor,
                A.__FindDependenciesVisitor_Object_RecursiveStatementVisitor,
                A.IsCalculationSafeVisitor,
                A.IsPlainCssVisitor,
                A.RecursiveStatementVisitor,
                A.ReplaceExpressionVisitor,
                A.SelectorSearchVisitor,
                A._SerializeVisitor,
                A.StatementSearchVisitor,
                A.Entry,
                A.Mapping,
                A.TargetLineEntry,
                A.TargetEntry,
                A.SourceFile,
                A.SourceLocationMixin,
                A.SourceSpanMixin,
                A.Highlighter,
                A._Highlight,
                A._Line,
                A.SourceLocation,
                A.Chain,
                A.Frame,
                A.LazyTrace,
                A.Trace,
                A.UnparsedFrame,
                A.StringScanner,
                A._SpanScannerState,
                A.AsciiGlyphSet,
                A.UnicodeGlyphSet,
                A.WatchEvent,
                A.ChangeType,
                A.ColorSpace0,
                A.AnySelectorVisitor0,
                A.SupportsAnything0,
                A.ArgumentList0,
                A.Value0,
                A.AsyncImporter0,
                A.AsyncBuiltInCallable0,
                A.AsyncEnvironment0,
                A._EnvironmentModule2,
                A._EvaluateVisitor2,
                A._ImportedCssVisitor2,
                A.EvaluationContext0,
                A.AsyncImportCache0,
                A.Parser1,
                A.AtRootQuery0,
                A.Statement0,
                A.CssNode0,
                A.InterpolatedSelector,
                A.Selector0,
                A.Expression0,
                A.Box0,
                A.ModifiableBox0,
                A.BuiltInCallable0,
                A.BuiltInModule0,
                A.CalculationOperation0,
                A.CalculationInterpolation,
                A.CanonicalizeContext0,
                A.ColorChannel0,
                A.GamutMapMethod0,
                A._CloneCssVisitor0,
                A._ColorFormatEnum0,
                A.SpanColorFormat0,
                A.CompileResult0,
                A.Compiler,
                A.InterpolatedComplexSelectorComponent,
                A.ComplexSelectorComponent0,
                A.Configuration0,
                A.ConfiguredValue0,
                A.ConfiguredVariable0,
                A.SupportsDeclaration0,
                A.LoggerWithDeprecationType0,
                A.DynamicImport0,
                A.EmptyExtensionStore0,
                A.Environment0,
                A._EnvironmentModule1,
                A._EvaluateVisitor1,
                A._ImportedCssVisitor1,
                A.EveryCssVisitor0,
                A.SassScriptException0,
                A.JSExpressionVisitor,
                A.__MakeExpressionCalculationSafe_Object_ReplaceExpressionVisitor0,
                A.Extension0,
                A.Extender0,
                A.ExtensionStore0,
                A.ForwardedModuleView0,
                A.SupportsFunction0,
                A.IfConditionExpression0,
                A.JSIfConditionExpressionVisitor,
                A.IfRuleClause0,
                A.NodeImporter,
                A.ImportCache0,
                A.Interpolation0,
                A.SupportsInterpolation0,
                A.InterpolationBuffer0,
                A.InterpolationMap0,
                A.InterpolationMethod0,
                A.IsCalculationSafeVisitor0,
                A.IsPlainCssVisitor0,
                A.FileSystemException0,
                A.LazyFileSpan0,
                A.__ParentSelectorVisitor_Object_SelectorSearchVisitor0,
                A.CssMediaQuery0,
                A.MediaQuerySuccessfulMergeResult0,
                A.__HasContentVisitor_Object_StatementSearchVisitor0,
                A.MultiSpan0,
                A.SupportsNegation0,
                A.NoSourceMapBuffer0,
                A._FakeAstNode0,
                A.__IsInvisibleVisitor_Object_EveryCssVisitor0,
                A.SupportsOperation0,
                A.Parameter0,
                A.ParameterList0,
                A.PlainCssCallable0,
                A.InterpolatedQualifiedName,
                A.QualifiedName0,
                A.ReplaceExpressionVisitor0,
                A.ImporterResult0,
                A.__IsInvisibleVisitor_Object_AnySelectorVisitor0,
                A.__IsBogusVisitor_Object_AnySelectorVisitor0,
                A.__IsUselessVisitor_Object_AnySelectorVisitor0,
                A.__ContainsParentSelectorVisitor_Object_AnySelectorVisitor0,
                A.SelectorSearchVisitor0,
                A._SerializeVisitor0,
                A.ShadowedModuleView0,
                A.JSSimpleSelectorVisitor,
                A.SourceInterpolationVisitor,
                A.SourceMapBuffer0,
                A.JSStatementVisitor,
                A.StatementSearchVisitor0,
                A.StaticImport0,
                A.UserDefinedCallable0,
                A.CssValue0
            ]);
            _inheritMany(J.Interceptor, [
                J.JSBool,
                J.JSNull,
                J.JavaScriptObject,
                J.JavaScriptBigInt,
                J.JavaScriptSymbol,
                J.JSNumber,
                J.JSString
            ]);
            _inheritMany(J.JavaScriptObject, [
                J.LegacyJavaScriptObject,
                J.JSArray,
                A.NativeByteBuffer,
                A.NativeTypedData
            ]);
            _inheritMany(J.LegacyJavaScriptObject, [
                J.PlainJavaScriptObject,
                J.UnknownJavaScriptObject,
                J.JavaScriptFunction,
                A.Stdin,
                A.Stdout,
                A.ReadlineModule,
                A.ReadlineOptions,
                A.ReadlineInterface,
                A.BufferModule,
                A.BufferConstants,
                A.Buffer,
                A.ConsoleModule,
                A.Console,
                A.EventEmitter,
                A.FS,
                A.FSConstants,
                A.Realpath,
                A.RealpathSync,
                A.FSWatcher,
                A.ReadStream,
                A.ReadStreamOptions,
                A.WriteStream,
                A.WriteStreamOptions,
                A.FileOptions,
                A.StatOptions,
                A.MkdirOptions,
                A.RmdirOptions,
                A.WatchOptions,
                A.WatchFileOptions,
                A.Stats,
                A.Promise,
                A.Date,
                A.JsError,
                A.Atomics,
                A.Modules,
                A.Module,
                A.Net,
                A.Socket,
                A.NetAddress,
                A.NetServer,
                A.NodeJsError,
                A.Process,
                A.CPUUsage,
                A.Release,
                A.StreamModule,
                A.Readable,
                A.Writable,
                A.Duplex,
                A.Transform,
                A.WritableOptions,
                A.ReadableOptions,
                A.Immediate,
                A.Timeout,
                A.TTY,
                A.Util,
                A.JSArray0,
                A.Chokidar,
                A.ChokidarOptions,
                A.ChokidarWatcher,
                A.JSFunction,
                A.ImmutableList,
                A.ImmutableMap,
                A.NodeImporterResult,
                A.RenderContext,
                A.RenderContextOptions,
                A.RenderContextResult,
                A.RenderContextResultStats,
                A.JSModule,
                A.JSModuleRequire,
                A.JSClass,
                A.JSUrl,
                A._PropertyDescriptor,
                A._RequireMain,
                A.JSArray1,
                A.Chokidar0,
                A.ChokidarOptions0,
                A.ChokidarWatcher0,
                A._Channels,
                A._ChannelOptions,
                A._ToGamutOptions,
                A._InterpolationOptions,
                A._NodeSassColor,
                A.CompileOptions,
                A.NodeCompileResult,
                A.Deprecation1,
                A.Exports,
                A.LoggerNamespace,
                A.JSExpressionVisitorObject,
                A.FiberClass,
                A.Fiber,
                A.JSFunction0,
                A.JSIfConditionExpressionVisitorObject,
                A.ImmutableList0,
                A.ImmutableMap0,
                A.JSImporter,
                A.JSImporterResult,
                A.NodeImporterResult0,
                A._ConstructorOptions,
                A._NodeSassList,
                A.JSLogger,
                A.WarnOptions,
                A.DebugOptions,
                A._NodeSassMap,
                A.JSModule0,
                A.JSModuleRequire0,
                A._ConstructorOptions0,
                A._NodeSassNumber,
                A.ParserExports,
                A.JSClass0,
                A.RenderContext0,
                A.RenderContextOptions0,
                A.RenderContextResult0,
                A.RenderContextResultStats0,
                A.RenderOptions,
                A.RenderResult,
                A.RenderResultStats,
                A._Exports,
                A.JSSet,
                A.JSSimpleSelectorVisitorObject,
                A.JSStatementVisitorObject,
                A._ConstructorOptions1,
                A._NodeSassString,
                A.Types,
                A.JSUrl0,
                A._PropertyDescriptor0,
                A._RequireMain0
            ]);
            _inherit(J.JSArraySafeToStringHook, A.SafeToStringHook);
            _inherit(J.JSUnmodifiableArray, J.JSArray);
            _inheritMany(J.JSNumber, [
                J.JSInt,
                J.JSNumNotInt
            ]);
            _inheritMany(A.Iterable, [
                A._CastIterableBase,
                A.EfficientLengthIterable,
                A.MappedIterable,
                A.WhereIterable,
                A.ExpandIterable,
                A.TakeIterable,
                A.SkipIterable,
                A.SkipWhileIterable,
                A.FollowedByIterable,
                A.WhereTypeIterable,
                A.NonNullsIterable,
                A._KeysOrValues,
                A._AllMatchesIterable,
                A._StringAllMatchesIterable,
                A._SyncStarIterable,
                A.Runes,
                A._EmptyUnmodifiableSet_IterableBase_UnmodifiableSetMixin,
                A._PrefixedKeys,
                A._UnprefixedKeys,
                A._PrefixedKeys0,
                A._UnprefixedKeys0
            ]);
            _inheritMany(A._CastIterableBase, [
                A.CastIterable,
                A.__CastListBase__CastIterableBase_ListMixin,
                A.CastSet
            ]);
            _inherit(A._EfficientLengthCastIterable, A.CastIterable);
            _inherit(A._CastListBase, A.__CastListBase__CastIterableBase_ListMixin);
            _inheritMany(A.Closure, [
                A.Closure2Args,
                A.CastMap_entries_closure,
                A.Closure0Args,
                A.Instantiation,
                A.TearOffClosure,
                A.initHooks_closure,
                A.initHooks_closure1,
                A._AsyncRun__initializeScheduleImmediate_internalCallback,
                A._AsyncRun__initializeScheduleImmediate_closure,
                A._awaitOnObject_closure,
                A.Future_wait_closure,
                A._Future__propagateToListeners_handleWhenCompleteCallback_closure,
                A.Stream_Stream$fromFuture_closure,
                A.Stream_length_closure,
                A._CustomZone_bindUnaryCallback_closure,
                A._RootZone_bindUnaryCallback_closure,
                A._HashMap_values_closure,
                A._LinkedCustomHashMap_closure,
                A.MapBase_entries_closure,
                A._JsonMap_values_closure,
                A._Uri__makePath_closure,
                A.jsify__convert,
                A.promiseToFuture_closure,
                A.promiseToFuture_closure0,
                A.ArgParser__addOption_closure,
                A._Usage__writeOption_closure,
                A._Usage__buildAllowedList_closure,
                A.FutureGroup_add_closure,
                A.StreamGroup__onListen_closure,
                A.StreamGroup__onCancel_closure,
                A.StreamQueue__ensureListening_closure,
                A.alwaysValid_closure,
                A.ReplAdapter_runAsync__closure,
                A.UnionSet__iterable_closure,
                A.UnionSet_contains_closure,
                A.MapKeySet_difference_closure,
                A.promiseToFuture_closure1,
                A.promiseToFuture_closure2,
                A.futureToPromise__closure,
                A.Context_joinAll_closure,
                A.Context_split_closure,
                A._validateArgList_closure,
                A.ParsedPath__splitExtension_closure,
                A.PathMap__create_closure0,
                A.PathMap__create_closure1,
                A.WindowsStyle_absolutePathToUri_closure,
                A.Version__splitParts_closure,
                A.ModifiableCssNode_hasFollowingSibling_closure,
                A.ListExpression_toString_closure,
                A.Interpolation_toString_closure,
                A.ParameterList_verify_closure,
                A.ParameterList_verify_closure0,
                A.EachRule_toString_closure,
                A.IfRuleClause$__closure,
                A.IfRuleClause$___closure,
                A.ParentStatement_closure,
                A.ParentStatement__closure,
                A._IsBogusVisitor_visitComplexSelector_closure,
                A._IsUselessVisitor_visitComplexSelector_closure,
                A.ComplexSelectorComponent_toString_closure,
                A.CompoundSelector_hasComplicatedSuperselectorSemantics_closure,
                A.IDSelector_unify_closure,
                A.SelectorList_asSassList_closure,
                A.SelectorList_nestWithin_closure,
                A.SelectorList_nestWithin__closure,
                A.SelectorList_nestWithin__closure0,
                A.SelectorList__nestWithinCompound_closure,
                A.SelectorList__nestWithinCompound_closure0,
                A.SelectorList__nestWithinCompound_closure1,
                A.SelectorList_withAdditionalCombinators_closure,
                A.PseudoSelector_specificity__closure,
                A.PseudoSelector_specificity__closure0,
                A.PseudoSelector_unify_closure,
                A.SimpleSelector_isSuperselector_closure,
                A.SimpleSelector_isSuperselector__closure,
                A._compileStylesheet_closure0,
                A.AsyncEnvironment__getVariableFromGlobalModule_closure,
                A.AsyncEnvironment_setVariable_closure0,
                A.AsyncEnvironment__getFunctionFromGlobalModule_closure,
                A.AsyncEnvironment__getMixinFromGlobalModule_closure,
                A.AsyncEnvironment_toModule_closure,
                A.AsyncEnvironment_toDummyModule_closure,
                A._EnvironmentModule__EnvironmentModule_closure5,
                A._EnvironmentModule__EnvironmentModule_closure6,
                A._EnvironmentModule__EnvironmentModule_closure7,
                A._EnvironmentModule__EnvironmentModule_closure8,
                A._EnvironmentModule__EnvironmentModule_closure9,
                A._EnvironmentModule__EnvironmentModule_closure10,
                A._EnvironmentModule_couldHaveBeenConfigured_closure0,
                A.AsyncImportCache_humanize_closure,
                A.AsyncImportCache_humanize_closure0,
                A.AsyncImportCache_humanize_closure1,
                A.AsyncImportCache_humanize_closure2,
                A.AsyncBuiltInCallable$mixin_closure,
                A.AsyncBuiltInCallable_withDeprecationWarning_closure,
                A.BuiltInCallable$mixin_closure,
                A.BuiltInCallable_withDeprecationWarning_closure,
                A._compileStylesheet_closure,
                A.Deprecation_fromId_closure,
                A.Environment__getVariableFromGlobalModule_closure,
                A.Environment_setVariable_closure0,
                A.Environment__getFunctionFromGlobalModule_closure,
                A.Environment__getMixinFromGlobalModule_closure,
                A.Environment_toModule_closure,
                A.Environment_toDummyModule_closure,
                A._EnvironmentModule__EnvironmentModule_closure,
                A._EnvironmentModule__EnvironmentModule_closure0,
                A._EnvironmentModule__EnvironmentModule_closure1,
                A._EnvironmentModule__EnvironmentModule_closure2,
                A._EnvironmentModule__EnvironmentModule_closure3,
                A._EnvironmentModule__EnvironmentModule_closure4,
                A._EnvironmentModule_couldHaveBeenConfigured_closure,
                A._writeSourceMap_closure,
                A.ExecutableOptions_emitErrorCss_closure,
                A.repl_warn,
                A.watch_closure,
                A._Watcher__debounceEvents_closure,
                A.ExtensionStore_extensionsWhereTarget_closure,
                A.ExtensionStore__extendComplex_closure,
                A.ExtensionStore__extendComplex__closure,
                A.ExtensionStore__extendCompound_closure,
                A.ExtensionStore__extendCompound_closure0,
                A.ExtensionStore__extendCompound_closure1,
                A.ExtensionStore__extendSimple_withoutPseudo,
                A.ExtensionStore__extendSimple_closure,
                A.ExtensionStore__extendSimple_closure0,
                A.ExtensionStore__extendPseudo_closure,
                A.ExtensionStore__extendPseudo_closure0,
                A.ExtensionStore__extendPseudo_closure1,
                A.ExtensionStore__extendPseudo_closure2,
                A.ExtensionStore__extendPseudo_closure3,
                A.ExtensionStore__trim_closure,
                A.ExtensionStore__trim_closure0,
                A.unifyComplex_closure,
                A._weaveParents_closure0,
                A._weaveParents_closure1,
                A._weaveParents_closure2,
                A._mustUnify_closure,
                A._mustUnify__closure,
                A.paths__closure,
                A.paths___closure,
                A.listIsSuperselector_closure,
                A.listIsSuperselector__closure,
                A.complexIsSuperselector_closure,
                A.complexIsSuperselector_closure0,
                A._compatibleWithPreviousCombinator_closure,
                A.compoundIsSuperselector_closure,
                A._selectorPseudoIsSuperselector_closure,
                A._selectorPseudoIsSuperselector_closure0,
                A._selectorPseudoIsSuperselector_closure1,
                A._selectorPseudoIsSuperselector_closure2,
                A._selectorPseudoIsSuperselector_closure3,
                A._selectorPseudoIsSuperselector__closure,
                A._selectorPseudoIsSuperselector___closure,
                A._selectorPseudoIsSuperselector___closure0,
                A._selectorPseudoIsSuperselector_closure4,
                A._selectorPseudoIsSuperselector_closure5,
                A._selectorPseudoArgs_closure,
                A._selectorPseudoArgs_closure0,
                A.globalFunctions_closure,
                A.global_closure0,
                A.global_closure1,
                A.global_closure2,
                A.global_closure3,
                A.global_closure4,
                A.global_closure5,
                A.global_closure6,
                A.global_closure7,
                A.global_closure8,
                A.global_closure9,
                A.global_closure10,
                A.global_closure11,
                A.global_closure12,
                A.global_closure13,
                A.global_closure14,
                A.global_closure15,
                A.global_closure16,
                A.global_closure17,
                A.global_closure18,
                A.global_closure19,
                A.global_closure20,
                A.global_closure21,
                A.global_closure22,
                A.global_closure23,
                A.global_closure24,
                A.global_closure25,
                A.global_closure26,
                A.global_closure27,
                A.global_closure28,
                A.global_closure29,
                A.global_closure30,
                A.global_closure31,
                A.global_closure32,
                A.global_closure33,
                A.global_closure34,
                A.global_closure35,
                A.global__closure,
                A.global_closure36,
                A.global_closure37,
                A.global_closure38,
                A.global_closure39,
                A.global_closure40,
                A.global_closure41,
                A.global_closure42,
                A.module_closure1,
                A.module_closure2,
                A.module_closure3,
                A.module_closure4,
                A.module_closure5,
                A.module_closure6,
                A.module_closure7,
                A.module_closure8,
                A.module_closure9,
                A.module_closure10,
                A.module_closure11,
                A.module_closure12,
                A.module_closure13,
                A.module_closure14,
                A.module__closure2,
                A.module_closure15,
                A.module_closure16,
                A.module_closure17,
                A.module_closure18,
                A.module_closure19,
                A.module_closure20,
                A.module_closure21,
                A.module_closure22,
                A.module__closure1,
                A.module_closure23,
                A.module_closure_toXyzNoMissing,
                A.module_closure24,
                A._mix_closure,
                A._complement_closure,
                A._adjust_closure,
                A._scale_closure,
                A._change_closure,
                A._ieHexStr_closure,
                A._ieHexStr_closure_hexString,
                A._updateComponents_closure,
                A._updateComponents_closure0,
                A._adjustColor_closure,
                A._functionString_closure,
                A._removedColorFunction_closure,
                A._rgb_closure,
                A._hsl_closure,
                A._parseChannels_closure,
                A._parseChannels_closure0,
                A._colorFromChannels_closure,
                A._colorFromChannels_closure0,
                A._channelFromValue_closure,
                A._channelFunction_closure,
                A._suggestScaleAndAdjust_closure,
                A._length_closure0,
                A._nth_closure,
                A._setNth_closure,
                A._join_closure,
                A._append_closure0,
                A._zip_closure,
                A._zip__closure,
                A._zip__closure0,
                A._zip__closure1,
                A._index_closure0,
                A._separator_closure,
                A._isBracketed_closure,
                A._slash_closure,
                A._get_closure,
                A._set_closure,
                A._set__closure0,
                A._set_closure0,
                A._set__closure,
                A._merge_closure,
                A._merge_closure0,
                A._merge__closure,
                A._deepMerge_closure,
                A._deepRemove_closure,
                A._deepRemove__closure,
                A._remove_closure,
                A._remove_closure0,
                A._keys_closure,
                A._values_closure,
                A._hasKey_closure,
                A._modify_modifyNestedMap,
                A.global_closure,
                A.module_closure0,
                A._ceil_closure,
                A._clamp_closure,
                A._floor_closure,
                A._max_closure,
                A._min_closure,
                A._round_closure,
                A._hypot_closure,
                A._hypot__closure,
                A._log_closure,
                A._pow_closure,
                A._atan2_closure,
                A._compatible_closure,
                A._isUnitless_closure,
                A._unit_closure,
                A._percentage_closure,
                A._randomFunction_closure,
                A._div_closure,
                A._singleArgumentMathFunc_closure,
                A._numberFunction_closure,
                A._shared_closure,
                A._shared_closure0,
                A._shared_closure1,
                A._shared_closure2,
                A.moduleFunctions_closure,
                A.moduleFunctions_closure0,
                A.moduleFunctions__closure,
                A.moduleFunctions_closure1,
                A._nest_closure,
                A._nest__closure,
                A._append_closure,
                A._append__closure,
                A._append___closure,
                A._extend_closure,
                A._replace_closure,
                A._unify_closure,
                A._isSuperselector_closure,
                A._simpleSelectors_closure,
                A._simpleSelectors__closure,
                A._parse_closure,
                A.module_closure,
                A.module__closure,
                A.module__closure0,
                A._unquote_closure,
                A._quote_closure,
                A._length_closure,
                A._insert_closure,
                A._index_closure,
                A._slice_closure,
                A._toUpperCase_closure,
                A._toLowerCase_closure,
                A._uniqueId_closure,
                A.ImportCache_humanize_closure,
                A.ImportCache_humanize_closure0,
                A.ImportCache_humanize_closure1,
                A.ImportCache_humanize_closure2,
                A.FilesystemImporter_canonicalize_closure,
                A.NodePackageImporter__nodePackageExportsResolve_closure,
                A.NodePackageImporter__nodePackageExportsResolve_closure0,
                A.NodePackageImporter__nodePackageExportsResolve_closure1,
                A.NodePackageImporter__nodePackageExportsResolve_closure2,
                A.NodePackageImporter__nodePackageExportsResolve__closure,
                A.NodePackageImporter__nodePackageExportsResolve__closure0,
                A.NodePackageImporter__getMainExport_closure,
                A._exactlyOne_closure,
                A.InterpolationMap_mapException_closure,
                A._realCasePath_helper,
                A._realCasePath_helper__closure,
                A.readStdin_closure,
                A.readStdin_closure0,
                A.readStdin_closure1,
                A.readStdin_closure2,
                A.listDir__closure,
                A.listDir__closure0,
                A.listDir_closure_list,
                A.listDir__list_closure,
                A.watchDir_closure1,
                A.watchDir_closure2,
                A.watchDir_closure3,
                A.watchDir_closure4,
                A.DeprecationProcessingLogger_summarize_closure,
                A.DeprecationProcessingLogger_summarize_closure0,
                A._disallowedFunctionNames_closure,
                A.Parser_escape_closure,
                A.Parser_scanIdentChar_matches,
                A.SassParser_styleRuleSelector_closure,
                A.SassParser__peekIndentation_closure,
                A.SassParser__peekIndentation_closure0,
                A.SassParser__tryTrailingSemicolon_closure,
                A.StylesheetParser__declarationOrBuffer_closure1,
                A.StylesheetParser__expression_addSingleExpression,
                A.StylesheetParser__expression_addOperator,
                A.StylesheetParser__isHexColor_closure,
                A.StylesheetParser__unicodeRange_closure,
                A.StylesheetParser__unicodeRange_closure0,
                A.StylesheetParser_trySpecialFunction_closure,
                A.StylesheetGraph_modifiedSince_transitiveModificationTime,
                A.MapExtensions_get_pairs_closure,
                A._PrefixedKeys_iterator_closure,
                A.SourceMapBuffer_buildSourceMap_closure,
                A._UnprefixedKeys_iterator_closure,
                A._UnprefixedKeys_iterator_closure0,
                A.indent_closure,
                A.flattenVertically_closure,
                A.flattenVertically_closure0,
                A.SassCalculation__verifyLength_closure,
                A.SassColor$_forSpace_closure,
                A.HwbColorSpace_convert_toRgb,
                A.SassList_isBlank_closure,
                A.SassNumber__coerceOrConvertValue_closure,
                A.SassNumber__coerceOrConvertValue_closure1,
                A.SassNumber_multiplyUnits_closure,
                A.SassNumber_multiplyUnits_closure1,
                A.SassNumber__areAnyConvertible_closure,
                A.SassNumber__canonicalizeUnitList_closure,
                A.SassNumber_unitSuggestion_closure,
                A.SassNumber_unitSuggestion_closure0,
                A.SingleUnitSassNumber__coerceToUnit_closure,
                A.SingleUnitSassNumber__coerceValueToUnit_closure,
                A.SingleUnitSassNumber_multiplyUnits_closure,
                A.AnySelectorVisitor_visitComplexSelector_closure,
                A.AnySelectorVisitor_visitCompoundSelector_closure,
                A._EvaluateVisitor_closure12,
                A._EvaluateVisitor_closure13,
                A._EvaluateVisitor_closure14,
                A._EvaluateVisitor_closure15,
                A._EvaluateVisitor_closure16,
                A._EvaluateVisitor_closure17,
                A._EvaluateVisitor_closure18,
                A._EvaluateVisitor_closure19,
                A._EvaluateVisitor_closure20,
                A._EvaluateVisitor_closure21,
                A._EvaluateVisitor_closure22,
                A._EvaluateVisitor_closure23,
                A._EvaluateVisitor_closure24,
                A._EvaluateVisitor__loadModule__closure1,
                A._EvaluateVisitor__combineCss_closure1,
                A._EvaluateVisitor__combineCss_closure2,
                A._EvaluateVisitor__combineCss_visitModule0,
                A._EvaluateVisitor__extendModules_closure1,
                A._EvaluateVisitor__scopeForAtRoot_closure5,
                A._EvaluateVisitor__scopeForAtRoot_closure6,
                A._EvaluateVisitor__scopeForAtRoot_closure7,
                A._EvaluateVisitor__scopeForAtRoot_closure8,
                A._EvaluateVisitor__scopeForAtRoot_closure9,
                A._EvaluateVisitor__scopeForAtRoot_closure10,
                A._EvaluateVisitor_visitEachRule_closure2,
                A._EvaluateVisitor_visitEachRule_closure3,
                A._EvaluateVisitor_visitEachRule__closure0,
                A._EvaluateVisitor_visitEachRule___closure0,
                A._EvaluateVisitor_visitAtRule_closure3,
                A._EvaluateVisitor_visitAtRule_closure6,
                A._EvaluateVisitor_visitForRule__closure0,
                A._EvaluateVisitor_visitIfRule_closure0,
                A._EvaluateVisitor_visitIfRule___closure0,
                A._EvaluateVisitor__visitDynamicImport__closure3,
                A._EvaluateVisitor__visitDynamicImport__closure4,
                A._EvaluateVisitor__visitDynamicImport__closure5,
                A._EvaluateVisitor_visitIncludeRule_closure3,
                A._EvaluateVisitor_visitMediaRule_closure4,
                A._EvaluateVisitor_visitMediaRule_closure6,
                A._EvaluateVisitor_visitStyleRule_closure4,
                A._EvaluateVisitor_visitStyleRule_closure5,
                A._EvaluateVisitor__warnForBogusCombinators_closure0,
                A._EvaluateVisitor_visitSupportsRule_closure4,
                A._EvaluateVisitor_visitWhileRule__closure0,
                A._EvaluateVisitor__slash_recommendation0,
                A._EvaluateVisitor_visitIfExpression_closure0,
                A._EvaluateVisitor_visitIfConditionOperation_closure0,
                A._EvaluateVisitor_visitListExpression_closure0,
                A._EvaluateVisitor_visitFunctionExpression_closure3,
                A._EvaluateVisitor__visitCalculation_closure0,
                A._EvaluateVisitor__checkCalculationArguments_check0,
                A._EvaluateVisitor__visitCalculationExpression__closure0,
                A._EvaluateVisitor__runUserDefinedCallable____closure0,
                A._EvaluateVisitor__runBuiltInCallable_closure4,
                A._EvaluateVisitor__evaluateArguments_closure3,
                A._EvaluateVisitor__evaluateArguments_closure4,
                A._EvaluateVisitor__evaluateArguments_closure6,
                A._EvaluateVisitor__evaluateMacroArguments_closure3,
                A._EvaluateVisitor__evaluateMacroArguments_closure4,
                A._EvaluateVisitor__evaluateMacroArguments_closure6,
                A._EvaluateVisitor_visitCssAtRule_closure4,
                A._EvaluateVisitor_visitCssKeyframeBlock_closure2,
                A._EvaluateVisitor_visitCssMediaRule_closure4,
                A._EvaluateVisitor_visitCssMediaRule_closure6,
                A._EvaluateVisitor_visitCssStyleRule_closure1,
                A._EvaluateVisitor_visitCssSupportsRule_closure4,
                A._EvaluateVisitor__performInterpolationHelper_closure0,
                A._EvaluateVisitor__withoutSlash_recommendation0,
                A._EvaluateVisitor__stackFrame_closure0,
                A._ImportedCssVisitor_visitCssAtRule_closure0,
                A._ImportedCssVisitor_visitCssMediaRule_closure0,
                A._ImportedCssVisitor_visitCssStyleRule_closure0,
                A._ImportedCssVisitor_visitCssSupportsRule_closure0,
                A._EvaluateVisitor_closure,
                A._EvaluateVisitor_closure0,
                A._EvaluateVisitor_closure1,
                A._EvaluateVisitor_closure2,
                A._EvaluateVisitor_closure3,
                A._EvaluateVisitor_closure4,
                A._EvaluateVisitor_closure5,
                A._EvaluateVisitor_closure6,
                A._EvaluateVisitor_closure7,
                A._EvaluateVisitor_closure8,
                A._EvaluateVisitor_closure9,
                A._EvaluateVisitor_closure10,
                A._EvaluateVisitor_closure11,
                A._EvaluateVisitor__loadModule__closure,
                A._EvaluateVisitor__combineCss_closure,
                A._EvaluateVisitor__combineCss_closure0,
                A._EvaluateVisitor__combineCss_visitModule,
                A._EvaluateVisitor__extendModules_closure,
                A._EvaluateVisitor__scopeForAtRoot_closure,
                A._EvaluateVisitor__scopeForAtRoot_closure0,
                A._EvaluateVisitor__scopeForAtRoot_closure1,
                A._EvaluateVisitor__scopeForAtRoot_closure2,
                A._EvaluateVisitor__scopeForAtRoot_closure3,
                A._EvaluateVisitor__scopeForAtRoot_closure4,
                A._EvaluateVisitor_visitEachRule_closure,
                A._EvaluateVisitor_visitEachRule_closure0,
                A._EvaluateVisitor_visitEachRule__closure,
                A._EvaluateVisitor_visitEachRule___closure,
                A._EvaluateVisitor_visitAtRule_closure,
                A._EvaluateVisitor_visitAtRule_closure2,
                A._EvaluateVisitor_visitForRule__closure,
                A._EvaluateVisitor_visitIfRule_closure,
                A._EvaluateVisitor_visitIfRule___closure,
                A._EvaluateVisitor__visitDynamicImport__closure,
                A._EvaluateVisitor__visitDynamicImport__closure0,
                A._EvaluateVisitor__visitDynamicImport__closure1,
                A._EvaluateVisitor_visitIncludeRule_closure0,
                A._EvaluateVisitor_visitMediaRule_closure0,
                A._EvaluateVisitor_visitMediaRule_closure2,
                A._EvaluateVisitor_visitStyleRule_closure0,
                A._EvaluateVisitor_visitStyleRule_closure1,
                A._EvaluateVisitor__warnForBogusCombinators_closure,
                A._EvaluateVisitor_visitSupportsRule_closure1,
                A._EvaluateVisitor_visitWhileRule__closure,
                A._EvaluateVisitor__slash_recommendation,
                A._EvaluateVisitor_visitIfExpression_closure,
                A._EvaluateVisitor_visitIfConditionOperation_closure,
                A._EvaluateVisitor_visitListExpression_closure,
                A._EvaluateVisitor_visitFunctionExpression_closure0,
                A._EvaluateVisitor__visitCalculation_closure,
                A._EvaluateVisitor__checkCalculationArguments_check,
                A._EvaluateVisitor__visitCalculationExpression__closure,
                A._EvaluateVisitor__runUserDefinedCallable____closure,
                A._EvaluateVisitor__runBuiltInCallable_closure1,
                A._EvaluateVisitor__evaluateArguments_closure,
                A._EvaluateVisitor__evaluateArguments_closure0,
                A._EvaluateVisitor__evaluateArguments_closure2,
                A._EvaluateVisitor__evaluateMacroArguments_closure,
                A._EvaluateVisitor__evaluateMacroArguments_closure0,
                A._EvaluateVisitor__evaluateMacroArguments_closure2,
                A._EvaluateVisitor_visitCssAtRule_closure1,
                A._EvaluateVisitor_visitCssKeyframeBlock_closure0,
                A._EvaluateVisitor_visitCssMediaRule_closure0,
                A._EvaluateVisitor_visitCssMediaRule_closure2,
                A._EvaluateVisitor_visitCssStyleRule_closure,
                A._EvaluateVisitor_visitCssSupportsRule_closure1,
                A._EvaluateVisitor__performInterpolationHelper_closure,
                A._EvaluateVisitor__withoutSlash_recommendation,
                A._EvaluateVisitor__stackFrame_closure,
                A._ImportedCssVisitor_visitCssAtRule_closure,
                A._ImportedCssVisitor_visitCssMediaRule_closure,
                A._ImportedCssVisitor_visitCssStyleRule_closure,
                A._ImportedCssVisitor_visitCssSupportsRule_closure,
                A.EveryCssVisitor_visitCssAtRule_closure,
                A.EveryCssVisitor_visitCssKeyframeBlock_closure,
                A.EveryCssVisitor_visitCssMediaRule_closure,
                A.EveryCssVisitor_visitCssStyleRule_closure,
                A.EveryCssVisitor_visitCssStylesheet_closure,
                A.EveryCssVisitor_visitCssSupportsRule_closure,
                A.IsCalculationSafeVisitor_visitListExpression_closure,
                A.IsPlainCssVisitor_visitIfExpression_closure,
                A.IsPlainCssVisitor_visitListExpression_closure,
                A.IsPlainCssVisitor_visitIfConditionOperation_closure,
                A.IsPlainCssVisitor__visitArgumentList_closure,
                A.ReplaceExpressionVisitor_visitListExpression_closure,
                A.ReplaceExpressionVisitor_visitIfConditionOperation_closure,
                A.ReplaceExpressionVisitor_visitArgumentList_closure,
                A.ReplaceExpressionVisitor_visitInterpolation_closure,
                A.SelectorSearchVisitor_visitComplexSelector_closure,
                A.SelectorSearchVisitor_visitCompoundSelector_closure,
                A.serialize_closure,
                A._SerializeVisitor_visitList_closure,
                A._SerializeVisitor_visitList_closure0,
                A._SerializeVisitor_visitList_closure1,
                A._SerializeVisitor_visitMap_closure,
                A._SerializeVisitor_visitSelectorList_closure,
                A.StatementSearchVisitor_visitIfRule_closure,
                A.StatementSearchVisitor_visitIfRule__closure0,
                A.StatementSearchVisitor_visitIfRule_closure0,
                A.StatementSearchVisitor_visitIfRule__closure,
                A.StatementSearchVisitor_visitChildren_closure,
                A.SingleMapping_SingleMapping$fromEntries_closure1,
                A.SingleMapping_toJson_closure,
                A.Highlighter$__closure,
                A.Highlighter$___closure,
                A.Highlighter$__closure0,
                A.Highlighter__collateLines_closure,
                A.Highlighter__collateLines_closure1,
                A.Highlighter__collateLines__closure,
                A.Highlighter_highlight_closure,
                A.Chain_Chain$parse_closure,
                A.Chain_toTrace_closure,
                A.Chain_toString_closure0,
                A.Chain_toString__closure0,
                A.Chain_toString_closure,
                A.Chain_toString__closure,
                A.Trace__parseVM_closure,
                A.Trace$parseV8_closure,
                A.Trace$parseJSCore_closure,
                A.Trace$parseFirefox_closure,
                A.Trace$parseFriendly_closure,
                A.Trace_terse_closure,
                A.Trace_foldFrames_closure,
                A.Trace_foldFrames_closure0,
                A.Trace_toString_closure0,
                A.Trace_toString_closure,
                A.TransformByHandlers_transformByHandlers__closure,
                A.RateLimit__debounceAggregate_closure0,
                A.AnySelectorVisitor_visitComplexSelector_closure0,
                A.AnySelectorVisitor_visitCompoundSelector_closure0,
                A.argumentListClass__closure,
                A.argumentListClass__closure0,
                A.AsyncBuiltInCallable$mixin_closure0,
                A.AsyncBuiltInCallable_withDeprecationWarning_closure0,
                A._compileStylesheet_closure2,
                A.AsyncEnvironment__getVariableFromGlobalModule_closure0,
                A.AsyncEnvironment_setVariable_closure3,
                A.AsyncEnvironment__getFunctionFromGlobalModule_closure0,
                A.AsyncEnvironment__getMixinFromGlobalModule_closure0,
                A.AsyncEnvironment_toModule_closure0,
                A.AsyncEnvironment_toDummyModule_closure0,
                A._EnvironmentModule__EnvironmentModule_closure17,
                A._EnvironmentModule__EnvironmentModule_closure18,
                A._EnvironmentModule__EnvironmentModule_closure19,
                A._EnvironmentModule__EnvironmentModule_closure20,
                A._EnvironmentModule__EnvironmentModule_closure21,
                A._EnvironmentModule__EnvironmentModule_closure22,
                A._EnvironmentModule_couldHaveBeenConfigured_closure2,
                A._EvaluateVisitor_closure38,
                A._EvaluateVisitor_closure39,
                A._EvaluateVisitor_closure40,
                A._EvaluateVisitor_closure41,
                A._EvaluateVisitor_closure42,
                A._EvaluateVisitor_closure43,
                A._EvaluateVisitor_closure44,
                A._EvaluateVisitor_closure45,
                A._EvaluateVisitor_closure46,
                A._EvaluateVisitor_closure47,
                A._EvaluateVisitor_closure48,
                A._EvaluateVisitor_closure49,
                A._EvaluateVisitor_closure50,
                A._EvaluateVisitor__loadModule__closure5,
                A._EvaluateVisitor__combineCss_closure5,
                A._EvaluateVisitor__combineCss_closure6,
                A._EvaluateVisitor__combineCss_visitModule2,
                A._EvaluateVisitor__extendModules_closure5,
                A._EvaluateVisitor__scopeForAtRoot_closure17,
                A._EvaluateVisitor__scopeForAtRoot_closure18,
                A._EvaluateVisitor__scopeForAtRoot_closure19,
                A._EvaluateVisitor__scopeForAtRoot_closure20,
                A._EvaluateVisitor__scopeForAtRoot_closure21,
                A._EvaluateVisitor__scopeForAtRoot_closure22,
                A._EvaluateVisitor_visitEachRule_closure8,
                A._EvaluateVisitor_visitEachRule_closure9,
                A._EvaluateVisitor_visitEachRule__closure2,
                A._EvaluateVisitor_visitEachRule___closure2,
                A._EvaluateVisitor_visitAtRule_closure11,
                A._EvaluateVisitor_visitAtRule_closure14,
                A._EvaluateVisitor_visitForRule__closure2,
                A._EvaluateVisitor_visitIfRule_closure2,
                A._EvaluateVisitor_visitIfRule___closure2,
                A._EvaluateVisitor__visitDynamicImport__closure11,
                A._EvaluateVisitor__visitDynamicImport__closure12,
                A._EvaluateVisitor__visitDynamicImport__closure13,
                A._EvaluateVisitor_visitIncludeRule_closure9,
                A._EvaluateVisitor_visitMediaRule_closure12,
                A._EvaluateVisitor_visitMediaRule_closure14,
                A._EvaluateVisitor_visitStyleRule_closure12,
                A._EvaluateVisitor_visitStyleRule_closure13,
                A._EvaluateVisitor__warnForBogusCombinators_closure2,
                A._EvaluateVisitor_visitSupportsRule_closure10,
                A._EvaluateVisitor_visitWhileRule__closure2,
                A._EvaluateVisitor__slash_recommendation2,
                A._EvaluateVisitor_visitIfExpression_closure2,
                A._EvaluateVisitor_visitIfConditionOperation_closure2,
                A._EvaluateVisitor_visitListExpression_closure2,
                A._EvaluateVisitor_visitFunctionExpression_closure9,
                A._EvaluateVisitor__visitCalculation_closure2,
                A._EvaluateVisitor__checkCalculationArguments_check2,
                A._EvaluateVisitor__visitCalculationExpression__closure2,
                A._EvaluateVisitor__runUserDefinedCallable____closure2,
                A._EvaluateVisitor__runBuiltInCallable_closure10,
                A._EvaluateVisitor__evaluateArguments_closure11,
                A._EvaluateVisitor__evaluateArguments_closure12,
                A._EvaluateVisitor__evaluateArguments_closure14,
                A._EvaluateVisitor__evaluateMacroArguments_closure11,
                A._EvaluateVisitor__evaluateMacroArguments_closure12,
                A._EvaluateVisitor__evaluateMacroArguments_closure14,
                A._EvaluateVisitor_visitCssAtRule_closure10,
                A._EvaluateVisitor_visitCssKeyframeBlock_closure6,
                A._EvaluateVisitor_visitCssMediaRule_closure12,
                A._EvaluateVisitor_visitCssMediaRule_closure14,
                A._EvaluateVisitor_visitCssStyleRule_closure5,
                A._EvaluateVisitor_visitCssSupportsRule_closure10,
                A._EvaluateVisitor__performInterpolationHelper_closure2,
                A._EvaluateVisitor__withoutSlash_recommendation2,
                A._EvaluateVisitor__stackFrame_closure2,
                A._ImportedCssVisitor_visitCssAtRule_closure2,
                A._ImportedCssVisitor_visitCssMediaRule_closure2,
                A._ImportedCssVisitor_visitCssStyleRule_closure2,
                A._ImportedCssVisitor_visitCssSupportsRule_closure2,
                A.AsyncImportCache_humanize_closure3,
                A.AsyncImportCache_humanize_closure4,
                A.AsyncImportCache_humanize_closure5,
                A.AsyncImportCache_humanize_closure6,
                A.booleanClass__closure,
                A.legacyBooleanClass__closure,
                A.legacyBooleanClass__closure0,
                A.BuiltInCallable$mixin_closure0,
                A.BuiltInCallable_withDeprecationWarning_closure0,
                A.calculationClass__closure,
                A.calculationClass__closure0,
                A.calculationClass__closure1,
                A.calculationClass__closure2,
                A.calculationClass__closure3,
                A.calculationClass__closure4,
                A.calculationClass__closure5,
                A.calculationOperationClass__closure,
                A.calculationOperationClass___closure,
                A.calculationOperationClass__closure1,
                A.calculationOperationClass__closure2,
                A.calculationOperationClass__closure3,
                A.calculationOperationClass__closure4,
                A.calculationInterpolationClass__closure1,
                A.calculationInterpolationClass__closure2,
                A.SassCalculation__verifyLength_closure0,
                A.updateCanonicalizeContextPrototype_closure,
                A.updateCanonicalizeContextPrototype_closure0,
                A.global_closure44,
                A.global_closure45,
                A.global_closure46,
                A.global_closure47,
                A.global_closure48,
                A.global_closure49,
                A.global_closure50,
                A.global_closure51,
                A.global_closure52,
                A.global_closure53,
                A.global_closure54,
                A.global_closure55,
                A.global_closure56,
                A.global_closure57,
                A.global_closure58,
                A.global_closure59,
                A.global_closure60,
                A.global_closure61,
                A.global_closure62,
                A.global_closure63,
                A.global_closure64,
                A.global_closure65,
                A.global_closure66,
                A.global_closure67,
                A.global_closure68,
                A.global_closure69,
                A.global_closure70,
                A.global_closure71,
                A.global_closure72,
                A.global_closure73,
                A.global_closure74,
                A.global_closure75,
                A.global_closure76,
                A.global_closure77,
                A.global_closure78,
                A.global_closure79,
                A.global__closure0,
                A.global_closure80,
                A.global_closure81,
                A.global_closure82,
                A.global_closure83,
                A.global_closure84,
                A.global_closure85,
                A.global_closure86,
                A.module_closure27,
                A.module_closure28,
                A.module_closure29,
                A.module_closure30,
                A.module_closure31,
                A.module_closure32,
                A.module_closure33,
                A.module_closure34,
                A.module_closure35,
                A.module_closure36,
                A.module_closure37,
                A.module_closure38,
                A.module_closure39,
                A.module_closure40,
                A.module__closure6,
                A.module_closure41,
                A.module_closure42,
                A.module_closure43,
                A.module_closure44,
                A.module_closure45,
                A.module_closure46,
                A.module_closure47,
                A.module_closure48,
                A.module__closure5,
                A.module_closure49,
                A.module_closure_toXyzNoMissing0,
                A.module_closure50,
                A._mix_closure0,
                A._complement_closure0,
                A._adjust_closure0,
                A._scale_closure0,
                A._change_closure0,
                A._ieHexStr_closure0,
                A._ieHexStr_closure_hexString0,
                A._updateComponents_closure1,
                A._updateComponents_closure2,
                A._adjustColor_closure0,
                A._functionString_closure0,
                A._removedColorFunction_closure0,
                A._rgb_closure0,
                A._hsl_closure0,
                A._parseChannels_closure1,
                A._parseChannels_closure2,
                A._colorFromChannels_closure1,
                A._colorFromChannels_closure2,
                A._channelFromValue_closure0,
                A._channelFunction_closure0,
                A._suggestScaleAndAdjust_closure0,
                A.colorClass__closure1,
                A.colorClass__closure3,
                A.colorClass__closure5,
                A.colorClass__closure7,
                A.colorClass___closure,
                A.colorClass__closure_changedValue,
                A.colorClass__closure9,
                A.colorClass__closure10,
                A.colorClass__closure11,
                A.colorClass__closure12,
                A.colorClass__closure13,
                A.colorClass__closure14,
                A.colorClass__closure15,
                A.colorClass__closure16,
                A.colorClass__closure17,
                A.colorClass__closure18,
                A.colorClass__closure19,
                A.colorClass__closure20,
                A.colorClass__closure21,
                A.colorClass__closure22,
                A.legacyColorClass_closure,
                A.legacyColorClass__closure,
                A.legacyColorClass_closure0,
                A.legacyColorClass_closure1,
                A.legacyColorClass_closure2,
                A.legacyColorClass_closure3,
                A.SassColor$_forSpace_closure0,
                A.compileAsync__closure,
                A.compileStringAsync__closure,
                A.compileStringAsync__closure0,
                A._wrapAsyncSassExceptions_closure,
                A._parseFunctions__closure2,
                A._parseFunctions__closure3,
                A.nodePackageImporterClass__closure,
                A._compileStylesheet_closure1,
                A.AsyncCompiler_addCompilation_closure,
                A.compilerClass__closure,
                A.compilerClass__closure0,
                A.compilerClass__closure1,
                A.compilerClass__closure2,
                A.asyncCompilerClass__closure,
                A.asyncCompilerClass__closure0,
                A.asyncCompilerClass__closure1,
                A.asyncCompilerClass__closure2,
                A.ComplexSelectorComponent_toString_closure0,
                A.CompoundSelector_hasComplicatedSuperselectorSemantics_closure0,
                A._disallowedFunctionNames_closure0,
                A.Deprecation_fromId_closure0,
                A.DeprecationProcessingLogger_summarize_closure1,
                A.DeprecationProcessingLogger_summarize_closure2,
                A.versionClass__closure,
                A.versionClass__closure0,
                A.EachRule_toString_closure0,
                A.Environment__getVariableFromGlobalModule_closure0,
                A.Environment_setVariable_closure3,
                A.Environment__getFunctionFromGlobalModule_closure0,
                A.Environment__getMixinFromGlobalModule_closure0,
                A.Environment_toModule_closure0,
                A.Environment_toDummyModule_closure0,
                A._EnvironmentModule__EnvironmentModule_closure11,
                A._EnvironmentModule__EnvironmentModule_closure12,
                A._EnvironmentModule__EnvironmentModule_closure13,
                A._EnvironmentModule__EnvironmentModule_closure14,
                A._EnvironmentModule__EnvironmentModule_closure15,
                A._EnvironmentModule__EnvironmentModule_closure16,
                A._EnvironmentModule_couldHaveBeenConfigured_closure1,
                A._EvaluateVisitor_closure25,
                A._EvaluateVisitor_closure26,
                A._EvaluateVisitor_closure27,
                A._EvaluateVisitor_closure28,
                A._EvaluateVisitor_closure29,
                A._EvaluateVisitor_closure30,
                A._EvaluateVisitor_closure31,
                A._EvaluateVisitor_closure32,
                A._EvaluateVisitor_closure33,
                A._EvaluateVisitor_closure34,
                A._EvaluateVisitor_closure35,
                A._EvaluateVisitor_closure36,
                A._EvaluateVisitor_closure37,
                A._EvaluateVisitor__loadModule__closure3,
                A._EvaluateVisitor__combineCss_closure3,
                A._EvaluateVisitor__combineCss_closure4,
                A._EvaluateVisitor__combineCss_visitModule1,
                A._EvaluateVisitor__extendModules_closure3,
                A._EvaluateVisitor__scopeForAtRoot_closure11,
                A._EvaluateVisitor__scopeForAtRoot_closure12,
                A._EvaluateVisitor__scopeForAtRoot_closure13,
                A._EvaluateVisitor__scopeForAtRoot_closure14,
                A._EvaluateVisitor__scopeForAtRoot_closure15,
                A._EvaluateVisitor__scopeForAtRoot_closure16,
                A._EvaluateVisitor_visitEachRule_closure5,
                A._EvaluateVisitor_visitEachRule_closure6,
                A._EvaluateVisitor_visitEachRule__closure1,
                A._EvaluateVisitor_visitEachRule___closure1,
                A._EvaluateVisitor_visitAtRule_closure7,
                A._EvaluateVisitor_visitAtRule_closure10,
                A._EvaluateVisitor_visitForRule__closure1,
                A._EvaluateVisitor_visitIfRule_closure1,
                A._EvaluateVisitor_visitIfRule___closure1,
                A._EvaluateVisitor__visitDynamicImport__closure7,
                A._EvaluateVisitor__visitDynamicImport__closure8,
                A._EvaluateVisitor__visitDynamicImport__closure9,
                A._EvaluateVisitor_visitIncludeRule_closure6,
                A._EvaluateVisitor_visitMediaRule_closure8,
                A._EvaluateVisitor_visitMediaRule_closure10,
                A._EvaluateVisitor_visitStyleRule_closure8,
                A._EvaluateVisitor_visitStyleRule_closure9,
                A._EvaluateVisitor__warnForBogusCombinators_closure1,
                A._EvaluateVisitor_visitSupportsRule_closure7,
                A._EvaluateVisitor_visitWhileRule__closure1,
                A._EvaluateVisitor__slash_recommendation1,
                A._EvaluateVisitor_visitIfExpression_closure1,
                A._EvaluateVisitor_visitIfConditionOperation_closure1,
                A._EvaluateVisitor_visitListExpression_closure1,
                A._EvaluateVisitor_visitFunctionExpression_closure6,
                A._EvaluateVisitor__visitCalculation_closure1,
                A._EvaluateVisitor__checkCalculationArguments_check1,
                A._EvaluateVisitor__visitCalculationExpression__closure1,
                A._EvaluateVisitor__runUserDefinedCallable____closure1,
                A._EvaluateVisitor__runBuiltInCallable_closure7,
                A._EvaluateVisitor__evaluateArguments_closure7,
                A._EvaluateVisitor__evaluateArguments_closure8,
                A._EvaluateVisitor__evaluateArguments_closure10,
                A._EvaluateVisitor__evaluateMacroArguments_closure7,
                A._EvaluateVisitor__evaluateMacroArguments_closure8,
                A._EvaluateVisitor__evaluateMacroArguments_closure10,
                A._EvaluateVisitor_visitCssAtRule_closure7,
                A._EvaluateVisitor_visitCssKeyframeBlock_closure4,
                A._EvaluateVisitor_visitCssMediaRule_closure8,
                A._EvaluateVisitor_visitCssMediaRule_closure10,
                A._EvaluateVisitor_visitCssStyleRule_closure3,
                A._EvaluateVisitor_visitCssSupportsRule_closure7,
                A._EvaluateVisitor__performInterpolationHelper_closure1,
                A._EvaluateVisitor__withoutSlash_recommendation1,
                A._EvaluateVisitor__stackFrame_closure1,
                A._ImportedCssVisitor_visitCssAtRule_closure1,
                A._ImportedCssVisitor_visitCssMediaRule_closure1,
                A._ImportedCssVisitor_visitCssStyleRule_closure1,
                A._ImportedCssVisitor_visitCssSupportsRule_closure1,
                A.EveryCssVisitor_visitCssAtRule_closure0,
                A.EveryCssVisitor_visitCssKeyframeBlock_closure0,
                A.EveryCssVisitor_visitCssMediaRule_closure0,
                A.EveryCssVisitor_visitCssStyleRule_closure0,
                A.EveryCssVisitor_visitCssStylesheet_closure0,
                A.EveryCssVisitor_visitCssSupportsRule_closure0,
                A.exceptionClass__closure,
                A.exceptionClass__closure0,
                A.exceptionClass__closure1,
                A.ExtensionStore_extensionsWhereTarget_closure0,
                A.ExtensionStore__extendComplex_closure0,
                A.ExtensionStore__extendComplex__closure0,
                A.ExtensionStore__extendCompound_closure2,
                A.ExtensionStore__extendCompound_closure3,
                A.ExtensionStore__extendCompound_closure4,
                A.ExtensionStore__extendSimple_withoutPseudo0,
                A.ExtensionStore__extendSimple_closure1,
                A.ExtensionStore__extendSimple_closure2,
                A.ExtensionStore__extendPseudo_closure4,
                A.ExtensionStore__extendPseudo_closure5,
                A.ExtensionStore__extendPseudo_closure6,
                A.ExtensionStore__extendPseudo_closure7,
                A.ExtensionStore__extendPseudo_closure8,
                A.ExtensionStore__trim_closure1,
                A.ExtensionStore__trim_closure2,
                A.FilesystemImporter_canonicalize_closure0,
                A.functionClass__closure,
                A.functionClass__closure0,
                A.unifyComplex_closure0,
                A._weaveParents_closure4,
                A._weaveParents_closure5,
                A._weaveParents_closure6,
                A._mustUnify_closure0,
                A._mustUnify__closure0,
                A.paths__closure0,
                A.paths___closure0,
                A.listIsSuperselector_closure0,
                A.listIsSuperselector__closure0,
                A.complexIsSuperselector_closure1,
                A.complexIsSuperselector_closure2,
                A._compatibleWithPreviousCombinator_closure0,
                A.compoundIsSuperselector_closure0,
                A._selectorPseudoIsSuperselector_closure6,
                A._selectorPseudoIsSuperselector_closure7,
                A._selectorPseudoIsSuperselector_closure8,
                A._selectorPseudoIsSuperselector_closure9,
                A._selectorPseudoIsSuperselector_closure10,
                A._selectorPseudoIsSuperselector__closure0,
                A._selectorPseudoIsSuperselector___closure1,
                A._selectorPseudoIsSuperselector___closure2,
                A._selectorPseudoIsSuperselector_closure11,
                A._selectorPseudoIsSuperselector_closure12,
                A._selectorPseudoArgs_closure1,
                A._selectorPseudoArgs_closure2,
                A.globalFunctions_closure0,
                A.HwbColorSpace_convert_toRgb0,
                A.IDSelector_unify_closure0,
                A.IfRuleClause$__closure0,
                A.IfRuleClause$___closure0,
                A.immutableMapToDartMap_closure,
                A.NodeImporter__tryPath_closure0,
                A.ImportCache_humanize_closure3,
                A.ImportCache_humanize_closure4,
                A.ImportCache_humanize_closure5,
                A.ImportCache_humanize_closure6,
                A.Interpolation_toString_closure0,
                A.InterpolationMap_mapException_closure0,
                A._realCasePath_helper0,
                A._realCasePath_helper__closure0,
                A.IsCalculationSafeVisitor_visitListExpression_closure0,
                A.IsPlainCssVisitor_visitIfExpression_closure0,
                A.IsPlainCssVisitor_visitListExpression_closure0,
                A.IsPlainCssVisitor_visitIfConditionOperation_closure0,
                A.IsPlainCssVisitor__visitArgumentList_closure0,
                A.listDir__closure1,
                A.listDir__closure2,
                A.listDir_closure_list0,
                A.listDir__list_closure0,
                A.render_closure0,
                A._parseFunctions__closure,
                A._parseFunctions___closure2,
                A._parseFunctions__closure0,
                A._parseFunctions__closure1,
                A._parseFunctions___closure,
                A._parseImporter_closure,
                A._parseImporter__closure,
                A._parseImporter___closure,
                A.ListExpression_toString_closure0,
                A._length_closure2,
                A._nth_closure0,
                A._setNth_closure0,
                A._join_closure0,
                A._append_closure2,
                A._zip_closure0,
                A._zip__closure2,
                A._zip__closure3,
                A._zip__closure4,
                A._index_closure2,
                A._separator_closure0,
                A._isBracketed_closure0,
                A._slash_closure0,
                A.SelectorList_asSassList_closure0,
                A.SelectorList_nestWithin_closure0,
                A.SelectorList_nestWithin__closure1,
                A.SelectorList_nestWithin__closure2,
                A.SelectorList__nestWithinCompound_closure2,
                A.SelectorList__nestWithinCompound_closure3,
                A.SelectorList__nestWithinCompound_closure4,
                A.SelectorList_withAdditionalCombinators_closure0,
                A.listClass__closure,
                A.legacyListClass_closure,
                A.legacyListClass__closure,
                A.legacyListClass_closure1,
                A.legacyListClass_closure2,
                A.legacyListClass_closure4,
                A.SassList_isBlank_closure0,
                A._get_closure0,
                A._set_closure1,
                A._set__closure2,
                A._set_closure2,
                A._set__closure1,
                A._merge_closure1,
                A._merge_closure2,
                A._merge__closure0,
                A._deepMerge_closure0,
                A._deepRemove_closure0,
                A._deepRemove__closure0,
                A._remove_closure1,
                A._remove_closure2,
                A._keys_closure0,
                A._values_closure0,
                A._hasKey_closure0,
                A._modify_modifyNestedMap0,
                A.MapExtensions_get_pairs_closure0,
                A.mapClass__closure,
                A.mapClass__closure0,
                A.legacyMapClass_closure,
                A.legacyMapClass__closure,
                A.legacyMapClass__closure0,
                A.legacyMapClass_closure2,
                A.legacyMapClass_closure3,
                A.legacyMapClass_closure4,
                A.global_closure43,
                A.module_closure26,
                A._ceil_closure0,
                A._clamp_closure0,
                A._floor_closure0,
                A._max_closure0,
                A._min_closure0,
                A._round_closure0,
                A._hypot_closure0,
                A._hypot__closure0,
                A._log_closure0,
                A._pow_closure0,
                A._atan2_closure0,
                A._compatible_closure0,
                A._isUnitless_closure0,
                A._unit_closure0,
                A._percentage_closure0,
                A._randomFunction_closure0,
                A._div_closure0,
                A._singleArgumentMathFunc_closure0,
                A._numberFunction_closure0,
                A._shared_closure3,
                A._shared_closure4,
                A._shared_closure5,
                A._shared_closure6,
                A.moduleFunctions_closure2,
                A.moduleFunctions_closure3,
                A.moduleFunctions__closure0,
                A.moduleFunctions_closure4,
                A.mixinClass__closure,
                A.mixinClass__closure0,
                A.ModifiableCssNode_hasFollowingSibling_closure0,
                A.NodePackageImporter__nodePackageExportsResolve_closure3,
                A.NodePackageImporter__nodePackageExportsResolve_closure4,
                A.NodePackageImporter__nodePackageExportsResolve_closure5,
                A.NodePackageImporter__nodePackageExportsResolve_closure6,
                A.NodePackageImporter__nodePackageExportsResolve__closure1,
                A.NodePackageImporter__nodePackageExportsResolve__closure2,
                A.NodePackageImporter__getMainExport_closure0,
                A.legacyNullClass__closure,
                A.numberClass__closure,
                A.numberClass__closure0,
                A.numberClass__closure1,
                A.numberClass__closure2,
                A.numberClass__closure3,
                A.numberClass__closure4,
                A.numberClass__closure5,
                A.numberClass__closure6,
                A.numberClass__closure7,
                A.numberClass__closure8,
                A.numberClass__closure9,
                A.numberClass__closure12,
                A.numberClass__closure13,
                A.numberClass__closure14,
                A.numberClass__closure15,
                A.numberClass__closure16,
                A.numberClass__closure17,
                A.numberClass__closure18,
                A.numberClass__closure19,
                A.legacyNumberClass_closure,
                A.legacyNumberClass_closure0,
                A.legacyNumberClass_closure2,
                A._parseNumber_closure,
                A._parseNumber_closure0,
                A.SassNumber__coerceOrConvertValue_closure3,
                A.SassNumber__coerceOrConvertValue_closure5,
                A.SassNumber_multiplyUnits_closure3,
                A.SassNumber_multiplyUnits_closure5,
                A.SassNumber__areAnyConvertible_closure0,
                A.SassNumber__canonicalizeUnitList_closure0,
                A.SassNumber_unitSuggestion_closure1,
                A.SassNumber_unitSuggestion_closure2,
                A.ParameterList_verify_closure1,
                A.ParameterList_verify_closure2,
                A.ParentStatement_closure0,
                A.ParentStatement__closure0,
                A.loadParserExports_closure,
                A.loadParserExports_closure0,
                A.loadParserExports_closure1,
                A.loadParserExports_closure2,
                A.loadParserExports_closure3,
                A.loadParserExports_closure4,
                A._updateLazyFileSpanPrototype_closure0,
                A._updateLazyFileSpanPrototype_closure1,
                A._updateLazyFileSpanPrototype_closure2,
                A._updateAstPrototypes_closure,
                A._updateAstPrototypes_closure0,
                A._updateAstPrototypes_closure1,
                A._updateAstPrototypes_closure2,
                A._updateAstPrototypes_closure7,
                A._updateAstPrototypes_closure8,
                A._updateAstPrototypes_closure9,
                A._updateAstPrototypes_closure10,
                A._updateAstPrototypes_closure11,
                A._updateAstPrototypes_closure12,
                A._updateAstPrototypes_closure13,
                A._addSupportsConditionToInterpolation_closure,
                A.Parser_escape_closure0,
                A.Parser_scanIdentChar_matches0,
                A._PrefixedKeys_iterator_closure0,
                A.PseudoSelector_specificity__closure1,
                A.PseudoSelector_specificity__closure2,
                A.PseudoSelector_unify_closure0,
                A.JSClassExtension_setCustomInspect_closure,
                A.ReplaceExpressionVisitor_visitListExpression_closure0,
                A.ReplaceExpressionVisitor_visitIfConditionOperation_closure0,
                A.ReplaceExpressionVisitor_visitArgumentList_closure0,
                A.ReplaceExpressionVisitor_visitInterpolation_closure0,
                A.SassParser_styleRuleSelector_closure0,
                A.SassParser__peekIndentation_closure1,
                A.SassParser__peekIndentation_closure2,
                A.SassParser__tryTrailingSemicolon_closure0,
                A._wrapMain_closure,
                A._wrapMain_closure0,
                A._IsBogusVisitor_visitComplexSelector_closure0,
                A._IsUselessVisitor_visitComplexSelector_closure0,
                A._nest_closure0,
                A._nest__closure1,
                A._append_closure1,
                A._append__closure1,
                A._append___closure0,
                A._extend_closure0,
                A._replace_closure0,
                A._unify_closure0,
                A._isSuperselector_closure0,
                A._simpleSelectors_closure0,
                A._simpleSelectors__closure0,
                A._parse_closure0,
                A.SelectorSearchVisitor_visitComplexSelector_closure0,
                A.SelectorSearchVisitor_visitCompoundSelector_closure0,
                A.serialize_closure0,
                A._SerializeVisitor_visitList_closure2,
                A._SerializeVisitor_visitList_closure3,
                A._SerializeVisitor_visitList_closure4,
                A._SerializeVisitor_visitMap_closure0,
                A._SerializeVisitor_visitSelectorList_closure0,
                A.SimpleSelector_isSuperselector_closure0,
                A.SimpleSelector_isSuperselector__closure0,
                A.SingleUnitSassNumber__coerceToUnit_closure0,
                A.SingleUnitSassNumber__coerceValueToUnit_closure0,
                A.SingleUnitSassNumber_multiplyUnits_closure1,
                A.SourceInterpolationVisitor__visitArguments_closure,
                A.SourceInterpolationVisitor_visitIfConditionOperation_closure,
                A.SourceInterpolationVisitor_visitListExpression_closure,
                A.SourceMapBuffer_buildSourceMap_closure0,
                A.updateSourceSpanPrototype_closure0,
                A.updateSourceSpanPrototype_closure1,
                A.updateSourceSpanPrototype_closure2,
                A.updateSourceSpanPrototype__closure,
                A.updateSourceSpanPrototype_closure3,
                A.updateSourceSpanPrototype_closure4,
                A.updateSourceSpanPrototype_closure5,
                A.updateSourceSpanPrototype_closure6,
                A.StatementSearchVisitor_visitIfRule_closure1,
                A.StatementSearchVisitor_visitIfRule__closure2,
                A.StatementSearchVisitor_visitIfRule_closure2,
                A.StatementSearchVisitor_visitIfRule__closure1,
                A.StatementSearchVisitor_visitChildren_closure0,
                A.module_closure25,
                A.module__closure3,
                A.module__closure4,
                A._unquote_closure0,
                A._quote_closure0,
                A._length_closure1,
                A._insert_closure0,
                A._index_closure1,
                A._slice_closure0,
                A._toUpperCase_closure0,
                A._toLowerCase_closure0,
                A._uniqueId_closure0,
                A.StringExtension_toCssIdentifier_writeEscape,
                A.StringExtension_toCssIdentifier_consumeSurrogatePair,
                A.stringClass__closure,
                A.stringClass__closure0,
                A.stringClass__closure1,
                A.stringClass__closure2,
                A.stringClass__closure3,
                A.legacyStringClass_closure,
                A.legacyStringClass_closure0,
                A.StylesheetParser__declarationOrBuffer_closure5,
                A.StylesheetParser__expression_addSingleExpression0,
                A.StylesheetParser__expression_addOperator0,
                A.StylesheetParser__isHexColor_closure0,
                A.StylesheetParser__unicodeRange_closure1,
                A.StylesheetParser__unicodeRange_closure2,
                A.StylesheetParser_trySpecialFunction_closure0,
                A._UnprefixedKeys_iterator_closure1,
                A._UnprefixedKeys_iterator_closure2,
                A._exactlyOne_closure0,
                A.futureToPromise__closure0,
                A.indent_closure0,
                A.flattenVertically_closure1,
                A.flattenVertically_closure2,
                A.valueClass__closure,
                A.valueClass__closure0,
                A.valueClass__closure1,
                A.valueClass__closure2,
                A.valueClass__closure3,
                A.valueClass__closure4,
                A.valueClass__closure5,
                A.valueClass__closure7,
                A.valueClass__closure8,
                A.valueClass__closure9,
                A.valueClass__closure10,
                A.valueClass__closure11,
                A.valueClass__closure12,
                A.valueClass__closure13,
                A.valueClass__closure14,
                A.valueClass__closure15,
                A.valueClass__closure17,
                A.valueClass__closure18
            ]);
            _inheritMany(A.Closure2Args, [
                A._CastListBase_sort_closure,
                A.CastMap_forEach_closure,
                A.Primitives_functionNoSuchMethod_closure,
                A.JsLinkedHashMap_addAll_closure,
                A.initHooks_closure0,
                A._awaitOnObject_closure0,
                A._wrapJsFunctionForAsync_closure,
                A.Future_wait_handleError,
                A._Future__propagateToListeners_handleWhenCompleteCallback_closure0,
                A.Stream_Stream$fromFuture_closure0,
                A._AddStreamState_makeErrorHandler_closure,
                A._HashMap_addAll_closure,
                A.HashMap_HashMap$from_closure,
                A.LinkedHashMap_LinkedHashMap$from_closure,
                A.MapBase_addAll_closure,
                A.MapBase_mapToString_closure,
                A._JsonMap_addAll_closure,
                A._JsonStringifier_writeMap_closure,
                A.NoSuchMethodError_toString_closure,
                A.Uri_parseIPv6Address_error,
                A.Parser_parse_closure,
                A.FutureGroup_add_closure0,
                A.StreamQueue__ensureListening_closure1,
                A.futureToPromise_closure,
                A.PathMap__create_closure,
                A.IfRule_toString_closure,
                A.ComplexSelector_specificity_closure,
                A.CompoundSelector_specificity_closure,
                A.ExtensionStore_clone_closure,
                A._weaveParents_closure,
                A.paths_closure,
                A._nest__closure0,
                A._append__closure0,
                A.watchDir_closure0,
                A.ParcelWatcher_subscribe_closure,
                A.StylesheetParser__styleRule_closure,
                A.StylesheetParser__withStyleRuleChildren_closure,
                A.StylesheetParser__tryDeclarationChildren_closure,
                A.StylesheetParser__atRootRule_closure,
                A.StylesheetParser__atRootRule_closure0,
                A.StylesheetParser__eachRule_closure,
                A.StylesheetParser__functionRule_closure,
                A.StylesheetParser__forRule_closure0,
                A.StylesheetParser__includeRule_closure,
                A.StylesheetParser_mediaRule_closure,
                A.StylesheetParser__mixinRule_closure,
                A.StylesheetParser_mozDocumentRule_closure0,
                A.StylesheetParser_supportsRule_closure,
                A.StylesheetParser__whileRule_closure,
                A.StylesheetParser_unknownAtRule_closure,
                A.longestCommonSubsequence_backtrack,
                A.mapAddAll2_closure,
                A.SassNumber_plus_closure,
                A.SassNumber_minus_closure,
                A.SassNumber__canonicalMultiplier_closure,
                A._EvaluateVisitor__closure3,
                A._EvaluateVisitor__closure4,
                A._EvaluateVisitor_visitForwardRule_closure1,
                A._EvaluateVisitor_visitForwardRule_closure2,
                A._EvaluateVisitor_visitUseRule_closure0,
                A._EvaluateVisitor__evaluateArguments_closure5,
                A._EvaluateVisitor__evaluateMacroArguments_closure5,
                A._EvaluateVisitor__addRestMap_closure0,
                A._EvaluateVisitor__closure,
                A._EvaluateVisitor__closure0,
                A._EvaluateVisitor_visitForwardRule_closure,
                A._EvaluateVisitor_visitForwardRule_closure0,
                A._EvaluateVisitor_visitUseRule_closure,
                A._EvaluateVisitor__evaluateArguments_closure1,
                A._EvaluateVisitor__evaluateMacroArguments_closure1,
                A._EvaluateVisitor__addRestMap_closure,
                A.SingleMapping_toJson_closure0,
                A.Highlighter__collateLines_closure0,
                A.Frame_Frame$parseV8_closure_parseJsLocation,
                A.TransformByHandlers_transformByHandlers__closure1,
                A.RateLimit__debounceAggregate_closure,
                A._EvaluateVisitor__closure11,
                A._EvaluateVisitor__closure12,
                A._EvaluateVisitor_visitForwardRule_closure5,
                A._EvaluateVisitor_visitForwardRule_closure6,
                A._EvaluateVisitor_visitUseRule_closure2,
                A._EvaluateVisitor__evaluateArguments_closure13,
                A._EvaluateVisitor__evaluateMacroArguments_closure13,
                A._EvaluateVisitor__addRestMap_closure2,
                A.calculationOperationClass__closure0,
                A.calculationInterpolationClass__closure,
                A.calculationInterpolationClass__closure0,
                A.colorClass__closure,
                A.colorClass__closure0,
                A.colorClass__closure2,
                A.colorClass__closure4,
                A.colorClass__closure6,
                A.colorClass__closure8,
                A.legacyColorClass_closure4,
                A.legacyColorClass_closure5,
                A.legacyColorClass_closure6,
                A.legacyColorClass_closure7,
                A._parseFunctions_closure0,
                A.ComplexSelector_specificity_closure0,
                A.CompoundSelector_specificity_closure0,
                A._EvaluateVisitor__closure7,
                A._EvaluateVisitor__closure8,
                A._EvaluateVisitor_visitForwardRule_closure3,
                A._EvaluateVisitor_visitForwardRule_closure4,
                A._EvaluateVisitor_visitUseRule_closure1,
                A._EvaluateVisitor__evaluateArguments_closure9,
                A._EvaluateVisitor__evaluateMacroArguments_closure9,
                A._EvaluateVisitor__addRestMap_closure1,
                A.ExtensionStore_clone_closure0,
                A._weaveParents_closure3,
                A.paths_closure0,
                A.IfRule_toString_closure0,
                A.main_closure,
                A.main_closure0,
                A.render_closure1,
                A._parseFunctions_closure,
                A.listClass__closure0,
                A.legacyListClass_closure0,
                A.legacyListClass_closure3,
                A.mapClass__closure1,
                A.legacyMapClass_closure0,
                A.legacyMapClass_closure1,
                A.numberClass__closure10,
                A.numberClass__closure11,
                A.legacyNumberClass_closure1,
                A.legacyNumberClass_closure3,
                A.SassNumber_plus_closure0,
                A.SassNumber_minus_closure0,
                A.SassNumber__canonicalMultiplier_closure0,
                A._updateAstPrototypes_closure3,
                A._updateAstPrototypes_closure4,
                A._updateAstPrototypes_closure5,
                A._updateAstPrototypes_closure6,
                A.JSClassExtension_get_defineStaticMethod_closure,
                A.JSClassExtension_get_defineMethod_closure,
                A.JSClassExtension_get_defineGetter_closure,
                A._nest__closure2,
                A._append__closure2,
                A.legacyStringClass_closure1,
                A.StylesheetParser__styleRule_closure0,
                A.StylesheetParser__styleRule_closure1,
                A.StylesheetParser__withStyleRuleChildren_closure0,
                A.StylesheetParser__tryDeclarationChildren_closure0,
                A.StylesheetParser__atRootRule_closure1,
                A.StylesheetParser__atRootRule_closure2,
                A.StylesheetParser__eachRule_closure0,
                A.StylesheetParser__functionRule_closure0,
                A.StylesheetParser__forRule_closure2,
                A.StylesheetParser__includeRule_closure0,
                A.StylesheetParser_mediaRule_closure0,
                A.StylesheetParser__mixinRule_closure0,
                A.StylesheetParser_mozDocumentRule_closure2,
                A.StylesheetParser_supportsRule_closure0,
                A.StylesheetParser__whileRule_closure0,
                A.StylesheetParser_unknownAtRule_closure0,
                A.futureToPromise_closure0,
                A.futureToPromise__closure1,
                A.objectToMap_closure,
                A.longestCommonSubsequence_backtrack0,
                A.mapAddAll2_closure0,
                A.valueClass__closure6,
                A.valueClass__closure16
            ]);
            _inherit(A.CastList, A._CastListBase);
            _inheritMany(A.MapBase, [
                A.CastMap,
                A.JsLinkedHashMap,
                A._HashMap,
                A.UnmodifiableMapBase,
                A._JsonMap,
                A.MergedMapView,
                A.MergedMapView0
            ]);
            _inheritMany(A.Error, [
                A.LateError,
                A.TypeError,
                A.JsNoSuchMethodError,
                A.UnknownJsTypeError,
                A.RuntimeError,
                A._Error,
                A.JsonUnsupportedObjectError,
                A.AssertionError,
                A.ArgumentError,
                A.NoSuchMethodError,
                A.UnsupportedError,
                A.UnimplementedError,
                A.StateError,
                A.ConcurrentModificationError
            ]);
            _inherit(A.UnmodifiableListBase, A.ListBase);
            _inheritMany(A.UnmodifiableListBase, [
                A.CodeUnits,
                A.UnmodifiableListView
            ]);
            _inheritMany(A.Closure0Args, [
                A.nullFuture_closure,
                A._AsyncRun__scheduleImmediateJsOverride_internalCallback,
                A._AsyncRun__scheduleImmediateWithSetImmediate_internalCallback,
                A._TimerImpl_internalCallback,
                A._TimerImpl$periodic_closure,
                A._Future__addListener_closure,
                A._Future__prependListeners_closure,
                A._Future__chainCoreFuture_closure,
                A._Future__asyncCompleteWithValue_closure,
                A._Future__asyncCompleteErrorObject_closure,
                A._Future__propagateToListeners_handleWhenCompleteCallback,
                A._Future__propagateToListeners_handleValueCallback,
                A._Future__propagateToListeners_handleError,
                A.Stream_length_closure0,
                A._StreamController__subscribe_closure,
                A._StreamController__recordCancel_complete,
                A._AddStreamState_cancel_closure,
                A._BufferingStreamSubscription__sendError_sendError,
                A._BufferingStreamSubscription__sendDone_sendDone,
                A._PendingEvents_schedule_closure,
                A._CustomZone_bindCallback_closure,
                A._CustomZone_bindCallbackGuarded_closure,
                A._RootZone_bindCallback_closure,
                A._RootZone_bindCallbackGuarded_closure,
                A._rootHandleError_closure,
                A._Utf8Decoder__decoder_closure,
                A._Utf8Decoder__decoderNonfatal_closure,
                A.Parser__setOption_closure,
                A.StreamGroup_add_closure,
                A.StreamGroup_add_closure0,
                A.StreamGroup__listenToStream_closure,
                A.StreamQueue__ensureListening_closure0,
                A._isStrictMode_closure,
                A.ReplAdapter_runAsync_closure,
                A.ParsedPath__splitExtension_closure0,
                A.IfConditionOperation_toInterpolation_closure,
                A.PseudoSelector_specificity_closure,
                A.AsyncEnvironment_setVariable_closure,
                A.AsyncEnvironment_setVariable_closure1,
                A.AsyncImportCache_canonicalize_closure,
                A.AsyncImportCache__canonicalize_closure,
                A.AsyncImportCache_importCanonical_closure,
                A.Environment_setVariable_closure,
                A.Environment_setVariable_closure1,
                A.ExecutableOptions__parser_closure,
                A.ExecutableOptions_interactive_closure,
                A.ExecutableOptions_fatalDeprecations_closure,
                A.ExtensionStore__registerSelector_closure,
                A.ExtensionStore_addExtension_closure,
                A.ExtensionStore_addExtension_closure0,
                A.ExtensionStore_addExtension_closure1,
                A.ExtensionStore__extendExistingExtensions_closure,
                A.ExtensionStore__extendExistingExtensions_closure0,
                A.ExtensionStore_addExtensions_closure,
                A.ExtensionStore_clone__closure,
                A._changeColor_closure,
                A.ImportCache_canonicalize_closure,
                A.ImportCache__canonicalize_closure,
                A.ImportCache_importCanonical_closure,
                A.resolveImportPath_closure,
                A.resolveImportPath_closure0,
                A._tryPathAsDirectory_closure,
                A._realCasePath_helper_closure,
                A._readFile_closure,
                A.writeFile_closure,
                A.deleteFile_closure,
                A.fileExists_closure,
                A.dirExists_closure,
                A.linkExists_closure,
                A.ensureDir_closure,
                A.listDir_closure,
                A.realpath_closure,
                A.modificationTime_closure,
                A.watchDir_closure,
                A.watchDir_closure5,
                A.watchDir__closure,
                A.AtRootQueryParser_parse_closure,
                A.KeyframeSelectorParser_parse_closure,
                A.MediaQueryParser_parse_closure,
                A.Parser__parseIdentifier_closure,
                A.Parser_spanFrom_closure,
                A.Parser_spanFromPosition_closure,
                A.SassParser_children_closure,
                A.SelectorParser_parse_closure,
                A.SelectorParser_parseCompoundSelector_closure,
                A.StylesheetParser_parse_closure,
                A.StylesheetParser_parse__closure,
                A.StylesheetParser_parseParameterList_closure,
                A.StylesheetParser_parseVariableDeclaration_closure,
                A.StylesheetParser_parseUseRule_closure,
                A.StylesheetParser__parseSingleProduction_closure,
                A.StylesheetParser__statement_closure,
                A.StylesheetParser_variableDeclarationWithoutNamespace_closure,
                A.StylesheetParser_variableDeclarationWithoutNamespace_closure0,
                A.StylesheetParser__declarationOrBuffer_closure,
                A.StylesheetParser__declarationOrBuffer_closure0,
                A.StylesheetParser__declarationOrBuffer_closure2,
                A.StylesheetParser__propertyOrVariableDeclaration_closure,
                A.StylesheetParser__forRule_closure,
                A.StylesheetParser__memberList_closure,
                A.StylesheetParser_mozDocumentRule_closure,
                A.StylesheetParser__expression_resetState,
                A.StylesheetParser__expression_resolveOneOperation,
                A.StylesheetParser__expression_resolveOperations,
                A.StylesheetParser__expression_resolveSpaceExpressions,
                A.StylesheetParser_expressionUntilComma_closure,
                A.StylesheetParser_interpolatedStringToken_closure,
                A.StylesheetParser_namespacedExpression_closure,
                A.StylesheetParser__interpolatedDeclarationValue_closure,
                A.StylesheetParser__expressionUntilComparison_closure,
                A.StylesheetParser__publicIdentifier_closure,
                A.StylesheetGraph_modifiedSince_transitiveModificationTime_closure,
                A.StylesheetGraph__add_closure,
                A.StylesheetGraph_addCanonical_closure,
                A.StylesheetGraph_reload_closure,
                A.StylesheetGraph__nodeFor_closure,
                A.StylesheetGraph__nodeFor_closure0,
                A.SassNumber__coerceOrConvertValue_compatibilityException,
                A.SassNumber__coerceOrConvertValue_closure0,
                A.SassNumber__coerceOrConvertValue_closure2,
                A.SassNumber_multiplyUnits_closure0,
                A.SassNumber_multiplyUnits_closure2,
                A.SingleUnitSassNumber_multiplyUnits_closure0,
                A._EvaluateVisitor__closure6,
                A._EvaluateVisitor__closure5,
                A._EvaluateVisitor_run_closure0,
                A._EvaluateVisitor_run__closure0,
                A._EvaluateVisitor__loadModule_closure1,
                A._EvaluateVisitor__loadModule_closure2,
                A._EvaluateVisitor__loadModule__closure2,
                A._EvaluateVisitor__execute_closure0,
                A._EvaluateVisitor__extendModules_closure2,
                A._EvaluateVisitor_visitAtRootRule_closure1,
                A._EvaluateVisitor_visitAtRootRule_closure2,
                A._EvaluateVisitor__scopeForAtRoot__closure0,
                A._EvaluateVisitor_visitContentRule_closure0,
                A._EvaluateVisitor_visitDeclaration_closure0,
                A._EvaluateVisitor_visitEachRule_closure4,
                A._EvaluateVisitor_visitAtRule_closure4,
                A._EvaluateVisitor_visitAtRule_closure5,
                A._EvaluateVisitor_visitAtRule__closure0,
                A._EvaluateVisitor_visitForRule_closure4,
                A._EvaluateVisitor_visitForRule_closure5,
                A._EvaluateVisitor_visitForRule_closure6,
                A._EvaluateVisitor_visitForRule_closure7,
                A._EvaluateVisitor_visitForRule_closure8,
                A._EvaluateVisitor__registerCommentsForModule_closure0,
                A._EvaluateVisitor_visitIfRule__closure0,
                A._EvaluateVisitor__visitDynamicImport_closure0,
                A._EvaluateVisitor__visitDynamicImport__closure6,
                A._EvaluateVisitor__applyMixin_closure1,
                A._EvaluateVisitor__applyMixin__closure2,
                A._EvaluateVisitor__applyMixin_closure2,
                A._EvaluateVisitor__applyMixin__closure1,
                A._EvaluateVisitor__applyMixin___closure0,
                A._EvaluateVisitor__applyMixin____closure0,
                A._EvaluateVisitor_visitIncludeRule_closure2,
                A._EvaluateVisitor_visitIncludeRule_closure4,
                A._EvaluateVisitor_visitMediaRule_closure3,
                A._EvaluateVisitor_visitMediaRule_closure5,
                A._EvaluateVisitor_visitMediaRule__closure0,
                A._EvaluateVisitor_visitMediaRule___closure0,
                A._EvaluateVisitor_visitStyleRule_closure3,
                A._EvaluateVisitor_visitStyleRule_closure6,
                A._EvaluateVisitor_visitStyleRule__closure0,
                A._EvaluateVisitor_visitSupportsRule_closure2,
                A._EvaluateVisitor_visitSupportsRule_closure3,
                A._EvaluateVisitor_visitSupportsRule__closure0,
                A._EvaluateVisitor__visitSupportsCondition_closure0,
                A._EvaluateVisitor_visitVariableDeclaration_closure2,
                A._EvaluateVisitor_visitVariableDeclaration_closure3,
                A._EvaluateVisitor_visitVariableDeclaration_closure4,
                A._EvaluateVisitor_visitWarnRule_closure0,
                A._EvaluateVisitor_visitWhileRule_closure0,
                A._EvaluateVisitor_visitBinaryOperationExpression_closure0,
                A._EvaluateVisitor_visitVariableExpression_closure0,
                A._EvaluateVisitor_visitUnaryOperationExpression_closure0,
                A._EvaluateVisitor_visitFunctionExpression_closure2,
                A._EvaluateVisitor_visitFunctionExpression_closure4,
                A._EvaluateVisitor__visitCalculationExpression_closure0,
                A._EvaluateVisitor_visitInterpolatedFunctionExpression_closure0,
                A._EvaluateVisitor__runUserDefinedCallable_closure0,
                A._EvaluateVisitor__runUserDefinedCallable__closure0,
                A._EvaluateVisitor__runUserDefinedCallable___closure0,
                A._EvaluateVisitor__runFunctionCallable_closure0,
                A._EvaluateVisitor__runBuiltInCallable_closure2,
                A._EvaluateVisitor__runBuiltInCallable_closure3,
                A._EvaluateVisitor__verifyArguments_closure0,
                A._EvaluateVisitor_visitCssAtRule_closure2,
                A._EvaluateVisitor_visitCssAtRule_closure3,
                A._EvaluateVisitor_visitCssKeyframeBlock_closure1,
                A._EvaluateVisitor_visitCssMediaRule_closure3,
                A._EvaluateVisitor_visitCssMediaRule_closure5,
                A._EvaluateVisitor_visitCssMediaRule__closure0,
                A._EvaluateVisitor_visitCssMediaRule___closure0,
                A._EvaluateVisitor_visitCssStyleRule_closure2,
                A._EvaluateVisitor_visitCssStyleRule__closure0,
                A._EvaluateVisitor_visitCssSupportsRule_closure2,
                A._EvaluateVisitor_visitCssSupportsRule_closure3,
                A._EvaluateVisitor_visitCssSupportsRule__closure0,
                A._EvaluateVisitor__serialize_closure0,
                A._EvaluateVisitor__expressionNode_closure0,
                A._EvaluateVisitor__closure2,
                A._EvaluateVisitor__closure1,
                A._EvaluateVisitor_run_closure,
                A._EvaluateVisitor_run__closure,
                A._EvaluateVisitor_runExpression_closure,
                A._EvaluateVisitor_runExpression__closure,
                A._EvaluateVisitor_runExpression___closure,
                A._EvaluateVisitor_runStatement_closure,
                A._EvaluateVisitor_runStatement__closure,
                A._EvaluateVisitor_runStatement___closure,
                A._EvaluateVisitor__loadModule_closure,
                A._EvaluateVisitor__loadModule_closure0,
                A._EvaluateVisitor__loadModule__closure0,
                A._EvaluateVisitor__execute_closure,
                A._EvaluateVisitor__extendModules_closure0,
                A._EvaluateVisitor_visitAtRootRule_closure,
                A._EvaluateVisitor_visitAtRootRule_closure0,
                A._EvaluateVisitor__scopeForAtRoot__closure,
                A._EvaluateVisitor_visitContentRule_closure,
                A._EvaluateVisitor_visitDeclaration_closure,
                A._EvaluateVisitor_visitEachRule_closure1,
                A._EvaluateVisitor_visitAtRule_closure0,
                A._EvaluateVisitor_visitAtRule_closure1,
                A._EvaluateVisitor_visitAtRule__closure,
                A._EvaluateVisitor_visitForRule_closure,
                A._EvaluateVisitor_visitForRule_closure0,
                A._EvaluateVisitor_visitForRule_closure1,
                A._EvaluateVisitor_visitForRule_closure2,
                A._EvaluateVisitor_visitForRule_closure3,
                A._EvaluateVisitor__registerCommentsForModule_closure,
                A._EvaluateVisitor_visitIfRule__closure,
                A._EvaluateVisitor__visitDynamicImport_closure,
                A._EvaluateVisitor__visitDynamicImport__closure2,
                A._EvaluateVisitor__applyMixin_closure,
                A._EvaluateVisitor__applyMixin__closure0,
                A._EvaluateVisitor__applyMixin_closure0,
                A._EvaluateVisitor__applyMixin__closure,
                A._EvaluateVisitor__applyMixin___closure,
                A._EvaluateVisitor__applyMixin____closure,
                A._EvaluateVisitor_visitIncludeRule_closure,
                A._EvaluateVisitor_visitIncludeRule_closure1,
                A._EvaluateVisitor_visitMediaRule_closure,
                A._EvaluateVisitor_visitMediaRule_closure1,
                A._EvaluateVisitor_visitMediaRule__closure,
                A._EvaluateVisitor_visitMediaRule___closure,
                A._EvaluateVisitor_visitStyleRule_closure,
                A._EvaluateVisitor_visitStyleRule_closure2,
                A._EvaluateVisitor_visitStyleRule__closure,
                A._EvaluateVisitor_visitSupportsRule_closure,
                A._EvaluateVisitor_visitSupportsRule_closure0,
                A._EvaluateVisitor_visitSupportsRule__closure,
                A._EvaluateVisitor__visitSupportsCondition_closure,
                A._EvaluateVisitor_visitVariableDeclaration_closure,
                A._EvaluateVisitor_visitVariableDeclaration_closure0,
                A._EvaluateVisitor_visitVariableDeclaration_closure1,
                A._EvaluateVisitor_visitWarnRule_closure,
                A._EvaluateVisitor_visitWhileRule_closure,
                A._EvaluateVisitor_visitBinaryOperationExpression_closure,
                A._EvaluateVisitor_visitVariableExpression_closure,
                A._EvaluateVisitor_visitUnaryOperationExpression_closure,
                A._EvaluateVisitor_visitFunctionExpression_closure,
                A._EvaluateVisitor_visitFunctionExpression_closure1,
                A._EvaluateVisitor__visitCalculationExpression_closure,
                A._EvaluateVisitor_visitInterpolatedFunctionExpression_closure,
                A._EvaluateVisitor__runUserDefinedCallable_closure,
                A._EvaluateVisitor__runUserDefinedCallable__closure,
                A._EvaluateVisitor__runUserDefinedCallable___closure,
                A._EvaluateVisitor__runFunctionCallable_closure,
                A._EvaluateVisitor__runBuiltInCallable_closure,
                A._EvaluateVisitor__runBuiltInCallable_closure0,
                A._EvaluateVisitor__verifyArguments_closure,
                A._EvaluateVisitor_visitCssAtRule_closure,
                A._EvaluateVisitor_visitCssAtRule_closure0,
                A._EvaluateVisitor_visitCssKeyframeBlock_closure,
                A._EvaluateVisitor_visitCssMediaRule_closure,
                A._EvaluateVisitor_visitCssMediaRule_closure1,
                A._EvaluateVisitor_visitCssMediaRule__closure,
                A._EvaluateVisitor_visitCssMediaRule___closure,
                A._EvaluateVisitor_visitCssStyleRule_closure0,
                A._EvaluateVisitor_visitCssStyleRule__closure,
                A._EvaluateVisitor_visitCssSupportsRule_closure,
                A._EvaluateVisitor_visitCssSupportsRule_closure0,
                A._EvaluateVisitor_visitCssSupportsRule__closure,
                A._EvaluateVisitor__serialize_closure,
                A._EvaluateVisitor__expressionNode_closure,
                A._SerializeVisitor_visitCssComment_closure,
                A._SerializeVisitor_visitCssAtRule_closure,
                A._SerializeVisitor_visitCssMediaRule_closure,
                A._SerializeVisitor_visitCssImport_closure,
                A._SerializeVisitor_visitCssImport__closure,
                A._SerializeVisitor_visitCssKeyframeBlock_closure,
                A._SerializeVisitor_visitCssStyleRule_closure,
                A._SerializeVisitor_visitCssSupportsRule_closure,
                A._SerializeVisitor_visitCssDeclaration_closure,
                A._SerializeVisitor_visitCssDeclaration_closure0,
                A._SerializeVisitor__write_closure,
                A._SerializeVisitor__visitChildren_closure,
                A._SerializeVisitor__visitChildren_closure0,
                A.SingleMapping_SingleMapping$fromEntries_closure,
                A.SingleMapping_SingleMapping$fromEntries_closure0,
                A.Highlighter_closure,
                A.Highlighter__writeFileStart_closure,
                A.Highlighter__writeMultilineHighlights_closure,
                A.Highlighter__writeMultilineHighlights_closure0,
                A.Highlighter__writeMultilineHighlights_closure1,
                A.Highlighter__writeMultilineHighlights_closure2,
                A.Highlighter__writeMultilineHighlights__closure,
                A.Highlighter__writeMultilineHighlights__closure0,
                A.Highlighter__writeHighlightedText_closure,
                A.Highlighter__writeIndicator_closure,
                A.Highlighter__writeIndicator_closure0,
                A.Highlighter__writeIndicator_closure1,
                A.Highlighter__writeLabel_closure,
                A.Highlighter__writeLabel_closure0,
                A.Highlighter__writeSidebar_closure,
                A._Highlight_closure,
                A.Frame_Frame$parseVM_closure,
                A.Frame_Frame$parseV8_closure,
                A.Frame_Frame$_parseFirefoxEval_closure,
                A.Frame_Frame$parseFirefox_closure,
                A.Frame_Frame$parseFriendly_closure,
                A.LazyTrace_terse_closure,
                A.Trace_Trace$from_closure,
                A.TransformByHandlers_transformByHandlers_closure,
                A.TransformByHandlers_transformByHandlers__closure0,
                A.TransformByHandlers_transformByHandlers__closure2,
                A.RateLimit__debounceAggregate_closure_emit,
                A.RateLimit__debounceAggregate__closure,
                A.argumentListClass_closure,
                A.JSToDartAsyncImporter_canonicalize_closure,
                A.JSToDartAsyncImporter_load_closure,
                A.AsyncEnvironment_setVariable_closure2,
                A.AsyncEnvironment_setVariable_closure4,
                A._EvaluateVisitor__closure14,
                A._EvaluateVisitor__closure13,
                A._EvaluateVisitor_run_closure2,
                A._EvaluateVisitor_run__closure2,
                A._EvaluateVisitor__loadModule_closure5,
                A._EvaluateVisitor__loadModule_closure6,
                A._EvaluateVisitor__loadModule__closure6,
                A._EvaluateVisitor__execute_closure2,
                A._EvaluateVisitor__extendModules_closure6,
                A._EvaluateVisitor_visitAtRootRule_closure5,
                A._EvaluateVisitor_visitAtRootRule_closure6,
                A._EvaluateVisitor__scopeForAtRoot__closure2,
                A._EvaluateVisitor_visitContentRule_closure2,
                A._EvaluateVisitor_visitDeclaration_closure2,
                A._EvaluateVisitor_visitEachRule_closure10,
                A._EvaluateVisitor_visitAtRule_closure12,
                A._EvaluateVisitor_visitAtRule_closure13,
                A._EvaluateVisitor_visitAtRule__closure2,
                A._EvaluateVisitor_visitForRule_closure14,
                A._EvaluateVisitor_visitForRule_closure15,
                A._EvaluateVisitor_visitForRule_closure16,
                A._EvaluateVisitor_visitForRule_closure17,
                A._EvaluateVisitor_visitForRule_closure18,
                A._EvaluateVisitor__registerCommentsForModule_closure2,
                A._EvaluateVisitor_visitIfRule__closure2,
                A._EvaluateVisitor__visitDynamicImport_closure2,
                A._EvaluateVisitor__visitDynamicImport__closure14,
                A._EvaluateVisitor__applyMixin_closure5,
                A._EvaluateVisitor__applyMixin__closure6,
                A._EvaluateVisitor__applyMixin_closure6,
                A._EvaluateVisitor__applyMixin__closure5,
                A._EvaluateVisitor__applyMixin___closure2,
                A._EvaluateVisitor__applyMixin____closure2,
                A._EvaluateVisitor_visitIncludeRule_closure8,
                A._EvaluateVisitor_visitIncludeRule_closure10,
                A._EvaluateVisitor_visitMediaRule_closure11,
                A._EvaluateVisitor_visitMediaRule_closure13,
                A._EvaluateVisitor_visitMediaRule__closure2,
                A._EvaluateVisitor_visitMediaRule___closure2,
                A._EvaluateVisitor_visitStyleRule_closure11,
                A._EvaluateVisitor_visitStyleRule_closure14,
                A._EvaluateVisitor_visitStyleRule__closure2,
                A._EvaluateVisitor_visitSupportsRule_closure8,
                A._EvaluateVisitor_visitSupportsRule_closure9,
                A._EvaluateVisitor_visitSupportsRule__closure2,
                A._EvaluateVisitor__visitSupportsCondition_closure2,
                A._EvaluateVisitor_visitVariableDeclaration_closure8,
                A._EvaluateVisitor_visitVariableDeclaration_closure9,
                A._EvaluateVisitor_visitVariableDeclaration_closure10,
                A._EvaluateVisitor_visitWarnRule_closure2,
                A._EvaluateVisitor_visitWhileRule_closure2,
                A._EvaluateVisitor_visitBinaryOperationExpression_closure2,
                A._EvaluateVisitor_visitVariableExpression_closure2,
                A._EvaluateVisitor_visitUnaryOperationExpression_closure2,
                A._EvaluateVisitor_visitFunctionExpression_closure8,
                A._EvaluateVisitor_visitFunctionExpression_closure10,
                A._EvaluateVisitor__visitCalculationExpression_closure2,
                A._EvaluateVisitor_visitInterpolatedFunctionExpression_closure2,
                A._EvaluateVisitor__runUserDefinedCallable_closure2,
                A._EvaluateVisitor__runUserDefinedCallable__closure2,
                A._EvaluateVisitor__runUserDefinedCallable___closure2,
                A._EvaluateVisitor__runFunctionCallable_closure2,
                A._EvaluateVisitor__runBuiltInCallable_closure8,
                A._EvaluateVisitor__runBuiltInCallable_closure9,
                A._EvaluateVisitor__verifyArguments_closure2,
                A._EvaluateVisitor_visitCssAtRule_closure8,
                A._EvaluateVisitor_visitCssAtRule_closure9,
                A._EvaluateVisitor_visitCssKeyframeBlock_closure5,
                A._EvaluateVisitor_visitCssMediaRule_closure11,
                A._EvaluateVisitor_visitCssMediaRule_closure13,
                A._EvaluateVisitor_visitCssMediaRule__closure2,
                A._EvaluateVisitor_visitCssMediaRule___closure2,
                A._EvaluateVisitor_visitCssStyleRule_closure6,
                A._EvaluateVisitor_visitCssStyleRule__closure2,
                A._EvaluateVisitor_visitCssSupportsRule_closure8,
                A._EvaluateVisitor_visitCssSupportsRule_closure9,
                A._EvaluateVisitor_visitCssSupportsRule__closure2,
                A._EvaluateVisitor__serialize_closure2,
                A._EvaluateVisitor__expressionNode_closure2,
                A.JSToDartAsyncFileImporter_canonicalize_closure,
                A.AsyncImportCache_canonicalize_closure0,
                A.AsyncImportCache__canonicalize_closure0,
                A.AsyncImportCache_importCanonical_closure0,
                A.AtRootQueryParser_parse_closure0,
                A.booleanClass_closure,
                A.legacyBooleanClass_closure,
                A.calculationClass_closure,
                A.calculationOperationClass_closure,
                A.calculationInterpolationClass_closure,
                A._changeColor_closure0,
                A.colorClass_closure,
                A.compileAsync_closure,
                A.compileStringAsync_closure,
                A._parseFunctions___closure6,
                A._parseFunctions___closure5,
                A.nodePackageImporterClass_closure,
                A.compilerClass_closure,
                A.asyncCompilerClass_closure,
                A.asyncCompilerClass___closure,
                A.initAsyncCompiler_closure,
                A.deprecations_closure,
                A.parseDeprecations_closure,
                A.versionClass_closure,
                A.Environment_setVariable_closure2,
                A.Environment_setVariable_closure4,
                A._EvaluateVisitor__closure10,
                A._EvaluateVisitor__closure9,
                A._EvaluateVisitor_run_closure1,
                A._EvaluateVisitor_run__closure1,
                A._EvaluateVisitor__loadModule_closure3,
                A._EvaluateVisitor__loadModule_closure4,
                A._EvaluateVisitor__loadModule__closure4,
                A._EvaluateVisitor__execute_closure1,
                A._EvaluateVisitor__extendModules_closure4,
                A._EvaluateVisitor_visitAtRootRule_closure3,
                A._EvaluateVisitor_visitAtRootRule_closure4,
                A._EvaluateVisitor__scopeForAtRoot__closure1,
                A._EvaluateVisitor_visitContentRule_closure1,
                A._EvaluateVisitor_visitDeclaration_closure1,
                A._EvaluateVisitor_visitEachRule_closure7,
                A._EvaluateVisitor_visitAtRule_closure8,
                A._EvaluateVisitor_visitAtRule_closure9,
                A._EvaluateVisitor_visitAtRule__closure1,
                A._EvaluateVisitor_visitForRule_closure9,
                A._EvaluateVisitor_visitForRule_closure10,
                A._EvaluateVisitor_visitForRule_closure11,
                A._EvaluateVisitor_visitForRule_closure12,
                A._EvaluateVisitor_visitForRule_closure13,
                A._EvaluateVisitor__registerCommentsForModule_closure1,
                A._EvaluateVisitor_visitIfRule__closure1,
                A._EvaluateVisitor__visitDynamicImport_closure1,
                A._EvaluateVisitor__visitDynamicImport__closure10,
                A._EvaluateVisitor__applyMixin_closure3,
                A._EvaluateVisitor__applyMixin__closure4,
                A._EvaluateVisitor__applyMixin_closure4,
                A._EvaluateVisitor__applyMixin__closure3,
                A._EvaluateVisitor__applyMixin___closure1,
                A._EvaluateVisitor__applyMixin____closure1,
                A._EvaluateVisitor_visitIncludeRule_closure5,
                A._EvaluateVisitor_visitIncludeRule_closure7,
                A._EvaluateVisitor_visitMediaRule_closure7,
                A._EvaluateVisitor_visitMediaRule_closure9,
                A._EvaluateVisitor_visitMediaRule__closure1,
                A._EvaluateVisitor_visitMediaRule___closure1,
                A._EvaluateVisitor_visitStyleRule_closure7,
                A._EvaluateVisitor_visitStyleRule_closure10,
                A._EvaluateVisitor_visitStyleRule__closure1,
                A._EvaluateVisitor_visitSupportsRule_closure5,
                A._EvaluateVisitor_visitSupportsRule_closure6,
                A._EvaluateVisitor_visitSupportsRule__closure1,
                A._EvaluateVisitor__visitSupportsCondition_closure1,
                A._EvaluateVisitor_visitVariableDeclaration_closure5,
                A._EvaluateVisitor_visitVariableDeclaration_closure6,
                A._EvaluateVisitor_visitVariableDeclaration_closure7,
                A._EvaluateVisitor_visitWarnRule_closure1,
                A._EvaluateVisitor_visitWhileRule_closure1,
                A._EvaluateVisitor_visitBinaryOperationExpression_closure1,
                A._EvaluateVisitor_visitVariableExpression_closure1,
                A._EvaluateVisitor_visitUnaryOperationExpression_closure1,
                A._EvaluateVisitor_visitFunctionExpression_closure5,
                A._EvaluateVisitor_visitFunctionExpression_closure7,
                A._EvaluateVisitor__visitCalculationExpression_closure1,
                A._EvaluateVisitor_visitInterpolatedFunctionExpression_closure1,
                A._EvaluateVisitor__runUserDefinedCallable_closure1,
                A._EvaluateVisitor__runUserDefinedCallable__closure1,
                A._EvaluateVisitor__runUserDefinedCallable___closure1,
                A._EvaluateVisitor__runFunctionCallable_closure1,
                A._EvaluateVisitor__runBuiltInCallable_closure5,
                A._EvaluateVisitor__runBuiltInCallable_closure6,
                A._EvaluateVisitor__verifyArguments_closure1,
                A._EvaluateVisitor_visitCssAtRule_closure5,
                A._EvaluateVisitor_visitCssAtRule_closure6,
                A._EvaluateVisitor_visitCssKeyframeBlock_closure3,
                A._EvaluateVisitor_visitCssMediaRule_closure7,
                A._EvaluateVisitor_visitCssMediaRule_closure9,
                A._EvaluateVisitor_visitCssMediaRule__closure1,
                A._EvaluateVisitor_visitCssMediaRule___closure1,
                A._EvaluateVisitor_visitCssStyleRule_closure4,
                A._EvaluateVisitor_visitCssStyleRule__closure1,
                A._EvaluateVisitor_visitCssSupportsRule_closure5,
                A._EvaluateVisitor_visitCssSupportsRule_closure6,
                A._EvaluateVisitor_visitCssSupportsRule__closure1,
                A._EvaluateVisitor__serialize_closure1,
                A._EvaluateVisitor__expressionNode_closure1,
                A.exceptionClass_closure,
                A.ExtensionStore__registerSelector_closure0,
                A.ExtensionStore_addExtension_closure2,
                A.ExtensionStore_addExtension_closure3,
                A.ExtensionStore_addExtension_closure4,
                A.ExtensionStore__extendExistingExtensions_closure1,
                A.ExtensionStore__extendExistingExtensions_closure2,
                A.ExtensionStore_addExtensions_closure0,
                A.ExtensionStore_clone__closure0,
                A.JSToDartFileImporter_canonicalize_closure,
                A.functionClass_closure,
                A.IfConditionOperation_toInterpolation_closure0,
                A.NodeImporter_load_closure,
                A.NodeImporter__tryPath_closure,
                A.NodeImporter__callImporterAsync_closure,
                A.ImportCache_canonicalize_closure0,
                A.ImportCache__canonicalize_closure0,
                A.ImportCache_importCanonical_closure0,
                A._realCasePath_helper_closure0,
                A._readFile_closure0,
                A.fileExists_closure0,
                A.dirExists_closure0,
                A.linkExists_closure0,
                A.listDir_closure0,
                A.realpath_closure0,
                A.JSToDartLogger_internalWarn_closure,
                A.JSToDartLogger_debug_closure,
                A.KeyframeSelectorParser_parse_closure0,
                A.render_closure,
                A._parseFunctions____closure,
                A._parseFunctions___closure3,
                A._parseFunctions___closure4,
                A._parseFunctions___closure1,
                A._parseFunctions___closure0,
                A._parseImporter____closure,
                A._parseImporter___closure0,
                A.listClass_closure,
                A.mapClass_closure,
                A.MediaQueryParser_parse_closure0,
                A.mixinClass_closure,
                A.legacyNullClass_closure,
                A.numberClass_closure,
                A.SassNumber__coerceOrConvertValue_compatibilityException0,
                A.SassNumber__coerceOrConvertValue_closure4,
                A.SassNumber__coerceOrConvertValue_closure6,
                A.SassNumber_multiplyUnits_closure4,
                A.SassNumber_multiplyUnits_closure6,
                A._updateLazyFileSpanPrototype_closure,
                A.Parser__parseIdentifier_closure0,
                A.Parser_spanFrom_closure0,
                A.Parser_spanFromPosition_closure0,
                A.PseudoSelector_specificity_closure0,
                A.SassParser_children_closure0,
                A.SelectorParser_parse_closure0,
                A.SelectorParser_parseCompoundSelector_closure0,
                A._SerializeVisitor_visitCssComment_closure0,
                A._SerializeVisitor_visitCssAtRule_closure0,
                A._SerializeVisitor_visitCssMediaRule_closure0,
                A._SerializeVisitor_visitCssImport_closure0,
                A._SerializeVisitor_visitCssImport__closure0,
                A._SerializeVisitor_visitCssKeyframeBlock_closure0,
                A._SerializeVisitor_visitCssStyleRule_closure0,
                A._SerializeVisitor_visitCssSupportsRule_closure0,
                A._SerializeVisitor_visitCssDeclaration_closure1,
                A._SerializeVisitor_visitCssDeclaration_closure2,
                A._SerializeVisitor__write_closure0,
                A._SerializeVisitor__visitChildren_closure1,
                A._SerializeVisitor__visitChildren_closure2,
                A.SingleUnitSassNumber_multiplyUnits_closure2,
                A.updateSourceSpanPrototype_closure,
                A.stringClass_closure,
                A.StylesheetParser_parse_closure0,
                A.StylesheetParser_parse__closure0,
                A.StylesheetParser_parseParameterList_closure0,
                A.StylesheetParser__parseSingleProduction_closure0,
                A.StylesheetParser_parseSignature_closure,
                A.StylesheetParser__statement_closure0,
                A.StylesheetParser_variableDeclarationWithoutNamespace_closure1,
                A.StylesheetParser_variableDeclarationWithoutNamespace_closure2,
                A.StylesheetParser__declarationOrBuffer_closure3,
                A.StylesheetParser__declarationOrBuffer_closure4,
                A.StylesheetParser__declarationOrBuffer_closure6,
                A.StylesheetParser__propertyOrVariableDeclaration_closure0,
                A.StylesheetParser__forRule_closure1,
                A.StylesheetParser__memberList_closure0,
                A.StylesheetParser_mozDocumentRule_closure1,
                A.StylesheetParser__expression_resetState0,
                A.StylesheetParser__expression_resolveOneOperation0,
                A.StylesheetParser__expression_resolveOperations0,
                A.StylesheetParser__expression_resolveSpaceExpressions0,
                A.StylesheetParser_expressionUntilComma_closure0,
                A.StylesheetParser_interpolatedStringToken_closure0,
                A.StylesheetParser_namespacedExpression_closure0,
                A.StylesheetParser__interpolatedDeclarationValue_closure0,
                A.StylesheetParser__expressionUntilComparison_closure0,
                A.StylesheetParser__publicIdentifier_closure0,
                A.JSToDartImporter_canonicalize_closure,
                A.JSToDartImporter_load_closure,
                A.resolveImportPath_closure1,
                A.resolveImportPath_closure2,
                A._tryPathAsDirectory_closure0,
                A.valueClass_closure
            ]);
            _inheritMany(A.EfficientLengthIterable, [
                A.ListIterable,
                A.EmptyIterable,
                A.LinkedHashMapKeysIterable,
                A.LinkedHashMapValuesIterable,
                A.LinkedHashMapEntriesIterable,
                A._HashMapKeyIterable,
                A._MapBaseValueIterable
            ]);
            _inheritMany(A.ListIterable, [
                A.SubListIterable,
                A.MappedListIterable,
                A.ReversedListIterable,
                A.ListQueue,
                A._JsonMapKeyIterable,
                A._GeneratorIterable
            ]);
            _inherit(A.EfficientLengthMappedIterable, A.MappedIterable);
            _inherit(A.EfficientLengthTakeIterable, A.TakeIterable);
            _inherit(A.EfficientLengthSkipIterable, A.SkipIterable);
            _inherit(A.EfficientLengthFollowedByIterable, A.FollowedByIterable);
            _inheritMany(A._Record, [
                A._Record1,
                A._Record2,
                A._Record3,
                A._RecordN
            ]);
            _inherit(A._Record_1, A._Record1);
            _inheritMany(A._Record2, [
                A._Record_2,
                A._Record_2_forImport,
                A._Record_2_imports_modules,
                A._Record_2_loadedUrls_stylesheet,
                A._Record_2_sourceMap
            ]);
            _inheritMany(A._Record3, [
                A._Record_3,
                A._Record_3_deprecation_message_span,
                A._Record_3_forImport,
                A._Record_3_importer_isDependency,
                A._Record_3_originalUrl
            ]);
            _inherit(A._Record_5_named_namedNodes_positional_positionalNodes_separator, A._RecordN);
            _inheritMany(A.MapView, [
                A._UnmodifiableMapView_MapView__UnmodifiableMapMixin,
                A.PathMap
            ]);
            _inherit(A.UnmodifiableMapView, A._UnmodifiableMapView_MapView__UnmodifiableMapMixin);
            _inherit(A.ConstantMapView, A.UnmodifiableMapView);
            _inherit(A.ConstantStringMap, A.ConstantMap);
            _inheritMany(A.SetBase, [
                A.ConstantSet,
                A._SetBase,
                A._UnmodifiableSetView_SetBase__UnmodifiableSetMixin,
                A._UnionSet_SetBase_UnmodifiableSetMixin
            ]);
            _inheritMany(A.ConstantSet, [
                A.ConstantStringSet,
                A.GeneralConstantSet
            ]);
            _inherit(A.Instantiation1, A.Instantiation);
            _inherit(A.NullError, A.TypeError);
            _inheritMany(A.TearOffClosure, [
                A.StaticClosure,
                A.BoundClosure
            ]);
            _inheritMany(A.JsLinkedHashMap, [
                A.JsIdentityLinkedHashMap,
                A.JsConstantLinkedHashMap,
                A._LinkedCustomHashMap
            ]);
            _inheritMany(A.NativeTypedData, [
                A.NativeByteData,
                A.NativeTypedArray
            ]);
            _inheritMany(A.NativeTypedArray, [
                A._NativeTypedArrayOfDouble_NativeTypedArray_ListMixin,
                A._NativeTypedArrayOfInt_NativeTypedArray_ListMixin
            ]);
            _inherit(A._NativeTypedArrayOfDouble_NativeTypedArray_ListMixin_FixedLengthListMixin, A._NativeTypedArrayOfDouble_NativeTypedArray_ListMixin);
            _inherit(A.NativeTypedArrayOfDouble, A._NativeTypedArrayOfDouble_NativeTypedArray_ListMixin_FixedLengthListMixin);
            _inherit(A._NativeTypedArrayOfInt_NativeTypedArray_ListMixin_FixedLengthListMixin, A._NativeTypedArrayOfInt_NativeTypedArray_ListMixin);
            _inherit(A.NativeTypedArrayOfInt, A._NativeTypedArrayOfInt_NativeTypedArray_ListMixin_FixedLengthListMixin);
            _inheritMany(A.NativeTypedArrayOfDouble, [
                A.NativeFloat32List,
                A.NativeFloat64List
            ]);
            _inheritMany(A.NativeTypedArrayOfInt, [
                A.NativeInt16List,
                A.NativeInt32List,
                A.NativeInt8List,
                A.NativeUint16List,
                A.NativeUint32List,
                A.NativeUint8ClampedList,
                A.NativeUint8List
            ]);
            _inherit(A._TypeError, A._Error);
            _inheritMany(A._Completer, [
                A._AsyncCompleter,
                A._SyncCompleter
            ]);
            _inheritMany(A._StreamController, [
                A._AsyncStreamController,
                A._SyncStreamController
            ]);
            _inheritMany(A.Stream, [
                A._StreamImpl,
                A._ForwardingStream,
                A._CompleterStream
            ]);
            _inherit(A._ControllerStream, A._StreamImpl);
            _inheritMany(A._BufferingStreamSubscription, [
                A._ControllerSubscription,
                A._ForwardingStreamSubscription
            ]);
            _inherit(A._StreamControllerAddStreamState, A._AddStreamState);
            _inheritMany(A._DelayedEvent, [
                A._DelayedData,
                A._DelayedError
            ]);
            _inherit(A._MapStream, A._ForwardingStream);
            _inheritMany(A._Zone, [
                A._CustomZone,
                A._RootZone
            ]);
            _inherit(A._IdentityHashMap, A._HashMap);
            _inherit(A._LinkedHashSet, A._SetBase);
            _inherit(A._LinkedIdentityHashSet, A._LinkedHashSet);
            _inherit(A.UnmodifiableSetView, A._UnmodifiableSetView_SetBase__UnmodifiableSetMixin);
            _inheritMany(A.Codec, [
                A.Encoding,
                A.Base64Codec,
                A.JsonCodec
            ]);
            _inheritMany(A.Encoding, [
                A.AsciiCodec,
                A.Utf8Codec
            ]);
            _inheritMany(A.Converter, [
                A._UnicodeSubsetEncoder,
                A.Base64Encoder,
                A.JsonEncoder,
                A.JsonDecoder,
                A.Utf8Encoder,
                A.Utf8Decoder
            ]);
            _inherit(A.AsciiEncoder, A._UnicodeSubsetEncoder);
            _inheritMany(A.ByteConversionSink, [
                A._Base64EncoderSink,
                A._Utf8StringSinkAdapter
            ]);
            _inherit(A._Utf8Base64EncoderSink, A._Base64EncoderSink);
            _inherit(A.JsonCyclicError, A.JsonUnsupportedObjectError);
            _inherit(A._JsonStringStringifier, A._JsonStringifier);
            _inherit(A._StringSinkConversionSink, A.StringConversionSink);
            _inherit(A._StringCallbackSink, A._StringSinkConversionSink);
            _inheritMany(A.ArgumentError, [
                A.RangeError,
                A.IndexError
            ]);
            _inherit(A._DataUri, A._Uri);
            _inherit(A.ArgParserException, A.FormatException);
            _inherit(A.EmptyUnmodifiableSet, A._EmptyUnmodifiableSet_IterableBase_UnmodifiableSetMixin);
            _inherit(A.QueueList, A._QueueList_Object_ListMixin);
            _inherit(A._CastQueueList, A.QueueList);
            _inherit(A.UnionSet, A._UnionSet_SetBase_UnmodifiableSetMixin);
            _inheritMany(A._DelegatingIterableBase, [
                A.DelegatingSet,
                A._MapKeySet__DelegatingIterableBase_UnmodifiableSetMixin
            ]);
            _inherit(A._UnmodifiableSetView_DelegatingSet_UnmodifiableSetMixin, A.DelegatingSet);
            _inherit(A.UnmodifiableSetView0, A._UnmodifiableSetView_DelegatingSet_UnmodifiableSetMixin);
            _inherit(A.MapKeySet, A._MapKeySet__DelegatingIterableBase_UnmodifiableSetMixin);
            _inheritMany(A.NodeJsError, [
                A.JsAssertionError,
                A.JsRangeError,
                A.JsReferenceError,
                A.JsSyntaxError,
                A.JsTypeError,
                A.JsSystemError
            ]);
            _inheritMany(A.Socket, [
                A.TTYReadStream,
                A.TTYWriteStream
            ]);
            _inherit(A.InternalStyle, A.Style);
            _inheritMany(A.InternalStyle, [
                A.PosixStyle,
                A.UrlStyle,
                A.WindowsStyle
            ]);
            _inheritMany(A._Enum, [
                A._SingletonCssMediaQueryMergeResult,
                A.BooleanOperator,
                A.BinaryOperator,
                A.UnaryOperator,
                A.AttributeOperator,
                A.Combinator,
                A.Deprecation,
                A.ExtendMode,
                A.Syntax,
                A.CalculationOperator,
                A.HueInterpolationMethod,
                A.ListSeparator,
                A.OutputStyle,
                A.LineFeed,
                A.AttributeOperator0,
                A.BinaryOperator0,
                A.BooleanOperator0,
                A.CalculationOperator0,
                A.Combinator0,
                A.Deprecation0,
                A.HueInterpolationMethod0,
                A.ListSeparator0,
                A._SingletonCssMediaQueryMergeResult0,
                A.ExtendMode0,
                A.OutputStyle0,
                A.LineFeed0,
                A.Syntax0,
                A.UnaryOperator0
            ]);
            _inheritMany(A.CssNode, [
                A.ModifiableCssNode,
                A.CssParentNode
            ]);
            _inheritMany(A.ModifiableCssNode, [
                A.ModifiableCssParentNode,
                A.ModifiableCssComment,
                A.ModifiableCssDeclaration,
                A.ModifiableCssImport
            ]);
            _inheritMany(A.ModifiableCssParentNode, [
                A.ModifiableCssAtRule,
                A.ModifiableCssKeyframeBlock,
                A.ModifiableCssMediaRule,
                A.ModifiableCssStyleRule,
                A.ModifiableCssStylesheet,
                A.ModifiableCssSupportsRule
            ]);
            _inherit(A._IsInvisibleVisitor, A.__IsInvisibleVisitor_Object_EveryCssVisitor);
            _inherit(A.CssStylesheet, A.CssParentNode);
            _inheritMany(A.Expression, [
                A.BinaryOperationExpression,
                A.BooleanExpression,
                A.ColorExpression,
                A.FunctionExpression,
                A.IfExpression,
                A.InterpolatedFunctionExpression,
                A.LegacyIfExpression,
                A.ListExpression,
                A.MapExpression,
                A.NullExpression,
                A.NumberExpression,
                A.ParenthesizedExpression,
                A.SelectorExpression,
                A.StringExpression,
                A.SupportsExpression,
                A.UnaryOperationExpression,
                A.ValueExpression,
                A.VariableExpression
            ]);
            _inheritMany(A.IfConditionExpression, [
                A.IfConditionParenthesized,
                A.IfConditionNegation,
                A.IfConditionOperation,
                A.IfConditionFunction,
                A.IfConditionSass,
                A.IfConditionRaw
            ]);
            _inheritMany(A.Statement, [
                A.ParentStatement,
                A.ContentRule,
                A.DebugRule,
                A.ErrorRule,
                A.ExtendRule,
                A.ForwardRule,
                A.IfRule,
                A.ImportRule,
                A.IncludeRule,
                A.LoudComment,
                A.ReturnRule,
                A.SilentComment,
                A.UseRule,
                A.VariableDeclaration,
                A.WarnRule
            ]);
            _inheritMany(A.ParentStatement, [
                A.AtRootRule,
                A.AtRule,
                A.CallableDeclaration,
                A.Declaration,
                A.EachRule,
                A.ForRule,
                A.MediaRule,
                A.StyleRule,
                A.Stylesheet,
                A.SupportsRule,
                A.WhileRule
            ]);
            _inheritMany(A.CallableDeclaration, [
                A.ContentBlock,
                A.FunctionRule,
                A.MixinRule
            ]);
            _inheritMany(A.IfRuleClause, [
                A.IfClause,
                A.ElseClause
            ]);
            _inherit(A._HasContentVisitor, A.__HasContentVisitor_Object_StatementSearchVisitor);
            _inherit(A._IsInvisibleVisitor0, A.__IsInvisibleVisitor_Object_AnySelectorVisitor);
            _inherit(A._IsBogusVisitor, A.__IsBogusVisitor_Object_AnySelectorVisitor);
            _inherit(A._IsUselessVisitor, A.__IsUselessVisitor_Object_AnySelectorVisitor);
            _inherit(A._ContainsParentSelectorVisitor, A.__ContainsParentSelectorVisitor_Object_AnySelectorVisitor);
            _inheritMany(A.Selector, [
                A.SimpleSelector,
                A.ComplexSelector,
                A.CompoundSelector,
                A.SelectorList
            ]);
            _inheritMany(A.SimpleSelector, [
                A.AttributeSelector,
                A.ClassSelector,
                A.IDSelector,
                A.ParentSelector,
                A.PlaceholderSelector,
                A.PseudoSelector,
                A.TypeSelector,
                A.UniversalSelector
            ]);
            _inherit(A._ParentSelectorVisitor, A.__ParentSelectorVisitor_Object_SelectorSearchVisitor);
            _inherit(A.ExplicitConfiguration, A.Configuration);
            _inheritMany(A.LoggerWithDeprecationType, [
                A._EvaluationContextLogger,
                A.DefaultLogger,
                A.DeprecationProcessingLogger,
                A.StderrLogger
            ]);
            _inheritMany(A.SourceSpanException, [
                A.SassException,
                A.SourceSpanFormatException,
                A.MultiSourceSpanException,
                A.SassException0
            ]);
            _inheritMany(A.SassException, [
                A.MultiSpanSassException,
                A.SassRuntimeException,
                A.SassFormatException
            ]);
            _inheritMany(A.MultiSpanSassException, [
                A.MultiSpanSassRuntimeException,
                A.MultiSpanSassFormatException
            ]);
            _inherit(A.MultiSpanSassScriptException, A.SassScriptException);
            _inherit(A.MergedExtension, A.Extension);
            _inherit(A.Importer, A.AsyncImporter);
            _inheritMany(A.Importer, [
                A.FilesystemImporter,
                A.NoOpImporter,
                A.NodePackageImporter
            ]);
            _inheritMany(A.Parser, [
                A.AtRootQueryParser,
                A.StylesheetParser,
                A.KeyframeSelectorParser,
                A.MediaQueryParser,
                A.SelectorParser
            ]);
            _inheritMany(A.StylesheetParser, [
                A.ScssParser,
                A.SassParser
            ]);
            _inherit(A.CssParser, A.ScssParser);
            _inheritMany(A.UnmodifiableMapBase, [
                A.LimitedMapView,
                A.PrefixedMapView,
                A.PublicMemberMapView,
                A.UnprefixedMapView,
                A.LimitedMapView0,
                A.PrefixedMapView0,
                A.PublicMemberMapView0,
                A.UnprefixedMapView0
            ]);
            _inheritMany(A.Value, [
                A.SassList,
                A.SassBoolean,
                A.SassCalculation,
                A.SassColor,
                A.SassFunction,
                A.SassMap,
                A.SassMixin,
                A._SassNull,
                A.SassNumber,
                A.SassString
            ]);
            _inherit(A.SassArgumentList, A.SassList);
            _inherit(A.LinearChannel, A.ColorChannel);
            _inheritMany(A.GamutMapMethod, [
                A.ClipGamutMap,
                A.LocalMindeGamutMap
            ]);
            _inheritMany(A.ColorSpace, [
                A.A98RgbColorSpace,
                A.DisplayP3ColorSpace,
                A.DisplayP3LinearColorSpace,
                A.HslColorSpace,
                A.HwbColorSpace,
                A.LabColorSpace,
                A.LchColorSpace,
                A.LmsColorSpace,
                A.OklabColorSpace,
                A.OklchColorSpace,
                A.ProphotoRgbColorSpace,
                A.Rec2020ColorSpace,
                A.RgbColorSpace,
                A.SrgbColorSpace,
                A.SrgbLinearColorSpace,
                A.XyzD50ColorSpace,
                A.XyzD65ColorSpace
            ]);
            _inheritMany(A.SassNumber, [
                A.ComplexSassNumber,
                A.SingleUnitSassNumber,
                A.UnitlessSassNumber
            ]);
            _inheritMany(A.EvaluationContext, [
                A._EvaluationContext0,
                A._EvaluationContext
            ]);
            _inherit(A._MakeExpressionCalculationSafe, A.__MakeExpressionCalculationSafe_Object_ReplaceExpressionVisitor);
            _inherit(A._FindDependenciesVisitor, A.__FindDependenciesVisitor_Object_RecursiveStatementVisitor);
            _inherit(A.SingleMapping, A.Mapping);
            _inherit(A.FileLocation, A.SourceLocationMixin);
            _inheritMany(A.SourceSpanMixin, [
                A._FileSpan,
                A.SourceSpanBase
            ]);
            _inherit(A.MultiSourceSpanFormatException, A.MultiSourceSpanException);
            _inherit(A.SourceSpanWithContext, A.SourceSpanBase);
            _inherit(A.StringScannerException, A.SourceSpanFormatException);
            _inheritMany(A.StringScanner, [
                A.LineScanner,
                A.SpanScanner
            ]);
            _inheritMany(A.ColorSpace0, [
                A.A98RgbColorSpace0,
                A.DisplayP3ColorSpace0,
                A.DisplayP3LinearColorSpace0,
                A.HslColorSpace0,
                A.HwbColorSpace0,
                A.LabColorSpace0,
                A.LchColorSpace0,
                A.LmsColorSpace0,
                A.OklabColorSpace0,
                A.OklchColorSpace0,
                A.ProphotoRgbColorSpace0,
                A.Rec2020ColorSpace0,
                A.RgbColorSpace0,
                A.SrgbColorSpace0,
                A.SrgbLinearColorSpace0,
                A.XyzD50ColorSpace0,
                A.XyzD65ColorSpace0
            ]);
            _inheritMany(A.Value0, [
                A.SassList0,
                A.SassBoolean0,
                A.SassCalculation0,
                A.SassColor0,
                A.SassNumber0,
                A.SassFunction0,
                A.SassMap0,
                A.SassMixin0,
                A._SassNull0,
                A.SassString0
            ]);
            _inherit(A.SassArgumentList0, A.SassList0);
            _inheritMany(A.AsyncImporter0, [
                A.JSToDartAsyncImporter,
                A.JSToDartAsyncFileImporter,
                A.Importer0
            ]);
            _inheritMany(A.EvaluationContext0, [
                A._EvaluationContext2,
                A._EvaluationContext1
            ]);
            _inheritMany(A.Parser1, [
                A.AtRootQueryParser0,
                A.StylesheetParser0,
                A.KeyframeSelectorParser0,
                A.MediaQueryParser0,
                A.SelectorParser0
            ]);
            _inheritMany(A.Statement0, [
                A.ParentStatement0,
                A.ContentRule0,
                A.DebugRule0,
                A.ErrorRule0,
                A.ExtendRule0,
                A.ForwardRule0,
                A.IfRule0,
                A.ImportRule0,
                A.IncludeRule0,
                A.LoudComment0,
                A.ReturnRule0,
                A.SilentComment0,
                A.UseRule0,
                A.VariableDeclaration0,
                A.WarnRule0
            ]);
            _inheritMany(A.ParentStatement0, [
                A.AtRootRule0,
                A.AtRule0,
                A.CallableDeclaration0,
                A.Declaration0,
                A.EachRule0,
                A.ForRule0,
                A.MediaRule0,
                A.StyleRule0,
                A.Stylesheet0,
                A.SupportsRule0,
                A.WhileRule0
            ]);
            _inheritMany(A.CssNode0, [
                A.ModifiableCssNode0,
                A.CssParentNode0
            ]);
            _inheritMany(A.ModifiableCssNode0, [
                A.ModifiableCssParentNode0,
                A.ModifiableCssComment0,
                A.ModifiableCssDeclaration0,
                A.ModifiableCssImport0
            ]);
            _inheritMany(A.ModifiableCssParentNode0, [
                A.ModifiableCssAtRule0,
                A.ModifiableCssKeyframeBlock0,
                A.ModifiableCssMediaRule0,
                A.ModifiableCssStyleRule0,
                A.ModifiableCssStylesheet0,
                A.ModifiableCssSupportsRule0
            ]);
            _inheritMany(A.InterpolatedSelector, [
                A.InterpolatedSimpleSelector,
                A.InterpolatedComplexSelector,
                A.InterpolatedCompoundSelector,
                A.InterpolatedSelectorList
            ]);
            _inheritMany(A.InterpolatedSimpleSelector, [
                A.InterpolatedAttributeSelector,
                A.InterpolatedClassSelector,
                A.InterpolatedIDSelector,
                A.InterpolatedParentSelector,
                A.InterpolatedPlaceholderSelector,
                A.InterpolatedPseudoSelector,
                A.InterpolatedTypeSelector,
                A.InterpolatedUniversalSelector
            ]);
            _inheritMany(A.Selector0, [
                A.SimpleSelector0,
                A.ComplexSelector0,
                A.CompoundSelector0,
                A.SelectorList0
            ]);
            _inheritMany(A.SimpleSelector0, [
                A.AttributeSelector0,
                A.ClassSelector0,
                A.IDSelector0,
                A.ParentSelector0,
                A.PlaceholderSelector0,
                A.PseudoSelector0,
                A.TypeSelector0,
                A.UniversalSelector0
            ]);
            _inheritMany(A.Expression0, [
                A.BinaryOperationExpression0,
                A.BooleanExpression0,
                A.ColorExpression0,
                A.FunctionExpression0,
                A.IfExpression0,
                A.InterpolatedFunctionExpression0,
                A.LegacyIfExpression0,
                A.ListExpression0,
                A.MapExpression0,
                A.NullExpression0,
                A.NumberExpression0,
                A.ParenthesizedExpression0,
                A.SelectorExpression0,
                A.StringExpression0,
                A.SupportsExpression0,
                A.UnaryOperationExpression0,
                A.ValueExpression0,
                A.VariableExpression0
            ]);
            _inherit(A.LinearChannel0, A.ColorChannel0);
            _inheritMany(A.GamutMapMethod0, [
                A.ClipGamutMap0,
                A.LocalMindeGamutMap0
            ]);
            _inherit(A._ConstructionOptions, A._Channels);
            _inherit(A.CompileStringOptions, A.CompileOptions);
            _inherit(A.AsyncCompiler, A.Compiler);
            _inheritMany(A.SassNumber0, [
                A.ComplexSassNumber0,
                A.SingleUnitSassNumber0,
                A.UnitlessSassNumber0
            ]);
            _inherit(A.ExplicitConfiguration0, A.Configuration0);
            _inheritMany(A.CallableDeclaration0, [
                A.ContentBlock0,
                A.FunctionRule0,
                A.MixinRule0
            ]);
            _inheritMany(A.StylesheetParser0, [
                A.ScssParser0,
                A.SassParser0
            ]);
            _inherit(A.CssParser0, A.ScssParser0);
            _inheritMany(A.LoggerWithDeprecationType0, [
                A.DefaultLogger0,
                A.DeprecationProcessingLogger0,
                A._EvaluationContextLogger0,
                A.JSToDartLogger,
                A.StderrLogger0
            ]);
            _inherit(A._NodeException, A.JsError);
            _inheritMany(A.SassException0, [
                A.MultiSpanSassException0,
                A.SassRuntimeException0,
                A.SassFormatException0
            ]);
            _inheritMany(A.MultiSpanSassException0, [
                A.MultiSpanSassRuntimeException0,
                A.MultiSpanSassFormatException0
            ]);
            _inherit(A.MultiSpanSassScriptException0, A.SassScriptException0);
            _inherit(A._MakeExpressionCalculationSafe0, A.__MakeExpressionCalculationSafe_Object_ReplaceExpressionVisitor0);
            _inheritMany(A.Importer0, [
                A.JSToDartFileImporter,
                A.FilesystemImporter0,
                A.NoOpImporter0,
                A.NodePackageImporter0,
                A.JSToDartImporter
            ]);
            _inheritMany(A.IfConditionExpression0, [
                A.IfConditionParenthesized0,
                A.IfConditionNegation0,
                A.IfConditionOperation0,
                A.IfConditionFunction0,
                A.IfConditionSass0,
                A.IfConditionRaw0
            ]);
            _inheritMany(A.IfRuleClause0, [
                A.IfClause0,
                A.ElseClause0
            ]);
            _inherit(A._ParentSelectorVisitor0, A.__ParentSelectorVisitor_Object_SelectorSearchVisitor0);
            _inherit(A.MergedExtension0, A.Extension0);
            _inherit(A._HasContentVisitor0, A.__HasContentVisitor_Object_StatementSearchVisitor0);
            _inherit(A._IsInvisibleVisitor1, A.__IsInvisibleVisitor_Object_EveryCssVisitor0);
            _inherit(A._IsInvisibleVisitor2, A.__IsInvisibleVisitor_Object_AnySelectorVisitor0);
            _inherit(A._IsBogusVisitor0, A.__IsBogusVisitor_Object_AnySelectorVisitor0);
            _inherit(A._IsUselessVisitor0, A.__IsUselessVisitor_Object_AnySelectorVisitor0);
            _inherit(A._ContainsParentSelectorVisitor0, A.__ContainsParentSelectorVisitor_Object_AnySelectorVisitor0);
            _inherit(A.CssStylesheet0, A.CssParentNode0);
            _mixin(A.UnmodifiableListBase, A.UnmodifiableListMixin);
            _mixin(A.__CastListBase__CastIterableBase_ListMixin, A.ListBase);
            _mixin(A._NativeTypedArrayOfDouble_NativeTypedArray_ListMixin, A.ListBase);
            _mixin(A._NativeTypedArrayOfDouble_NativeTypedArray_ListMixin_FixedLengthListMixin, A.FixedLengthListMixin);
            _mixin(A._NativeTypedArrayOfInt_NativeTypedArray_ListMixin, A.ListBase);
            _mixin(A._NativeTypedArrayOfInt_NativeTypedArray_ListMixin_FixedLengthListMixin, A.FixedLengthListMixin);
            _mixin(A._AsyncStreamController, A._AsyncStreamControllerDispatch);
            _mixin(A._SyncStreamController, A._SyncStreamControllerDispatch);
            _mixin(A.UnmodifiableMapBase, A._UnmodifiableMapMixin);
            _mixin(A._UnmodifiableMapView_MapView__UnmodifiableMapMixin, A._UnmodifiableMapMixin);
            _mixin(A._UnmodifiableSetView_SetBase__UnmodifiableSetMixin, A._UnmodifiableSetMixin);
            _mixin(A._EmptyUnmodifiableSet_IterableBase_UnmodifiableSetMixin, A.UnmodifiableSetMixin);
            _mixin(A._QueueList_Object_ListMixin, A.ListBase);
            _mixin(A._UnionSet_SetBase_UnmodifiableSetMixin, A.UnmodifiableSetMixin);
            _mixin(A._UnmodifiableSetView_DelegatingSet_UnmodifiableSetMixin, A.UnmodifiableSetMixin);
            _mixin(A._MapKeySet__DelegatingIterableBase_UnmodifiableSetMixin, A.UnmodifiableSetMixin);
            _mixin(A.__IsInvisibleVisitor_Object_EveryCssVisitor, A.EveryCssVisitor);
            _mixin(A.__HasContentVisitor_Object_StatementSearchVisitor, A.StatementSearchVisitor);
            _mixin(A.__ContainsParentSelectorVisitor_Object_AnySelectorVisitor, A.AnySelectorVisitor);
            _mixin(A.__IsBogusVisitor_Object_AnySelectorVisitor, A.AnySelectorVisitor);
            _mixin(A.__IsInvisibleVisitor_Object_AnySelectorVisitor, A.AnySelectorVisitor);
            _mixin(A.__IsUselessVisitor_Object_AnySelectorVisitor, A.AnySelectorVisitor);
            _mixin(A.__ParentSelectorVisitor_Object_SelectorSearchVisitor, A.SelectorSearchVisitor);
            _mixin(A.__MakeExpressionCalculationSafe_Object_ReplaceExpressionVisitor, A.ReplaceExpressionVisitor);
            _mixin(A.__FindDependenciesVisitor_Object_RecursiveStatementVisitor, A.RecursiveStatementVisitor);
            _mixin(A.__MakeExpressionCalculationSafe_Object_ReplaceExpressionVisitor0, A.ReplaceExpressionVisitor0);
            _mixin(A.__ParentSelectorVisitor_Object_SelectorSearchVisitor0, A.SelectorSearchVisitor0);
            _mixin(A.__HasContentVisitor_Object_StatementSearchVisitor0, A.StatementSearchVisitor0);
            _mixin(A.__IsInvisibleVisitor_Object_EveryCssVisitor0, A.EveryCssVisitor0);
            _mixin(A.__ContainsParentSelectorVisitor_Object_AnySelectorVisitor0, A.AnySelectorVisitor0);
            _mixin(A.__IsBogusVisitor_Object_AnySelectorVisitor0, A.AnySelectorVisitor0);
            _mixin(A.__IsInvisibleVisitor_Object_AnySelectorVisitor0, A.AnySelectorVisitor0);
            _mixin(A.__IsUselessVisitor_Object_AnySelectorVisitor0, A.AnySelectorVisitor0);
        })();
        var init = {
            G: typeof self != "undefined" ? self : globalThis,
            typeUniverse: {
                eC: new Map(),
                tR: {},
                eT: {},
                tPV: {},
                sEA: []
            },
            mangledGlobalNames: {
                int: "int",
                double: "double",
                num: "num",
                String: "String",
                bool: "bool",
                Null: "Null",
                List: "List",
                Object: "Object",
                Map: "Map",
                JSObject: "JSObject"
            },
            mangledNames: {},
            types: [
                "~()",
                "Null()",
                "Future<Null>()",
                "Value0(List<Value0>)",
                "bool(String)",
                "Value(List<Value>)",
                "String(String)",
                "bool(CssNode)",
                "bool(CssNode0)",
                "bool(Object?)",
                "int()",
                "SassBoolean(List<Value>)",
                "double(double)",
                "SassBoolean0(List<Value0>)",
                "bool(SimpleSelector)",
                "bool(SimpleSelector0)",
                "FileSpan()",
                "JSClass0()",
                "SassString0(List<Value0>)",
                "SassString(List<Value>)",
                "bool()",
                "bool(ComplexSelector)",
                "bool(ComplexSelector0)",
                "SassColor(List<Value>)",
                "SassNumber(List<Value>)",
                "SassNumber0(List<Value0>)",
                "SassColor0(List<Value0>)",
                "SassList0(List<Value0>)",
                "SassList(List<Value>)",
                "String()",
                "double(SassColor0)",
                "bool(int?)",
                "Future<~>()",
                "Value()",
                "SassMap0(List<Value0>)",
                "Null(~())",
                "Object?()",
                "~(Object?)",
                "SassMap(List<Value>)",
                "int(SassColor0)",
                "Future<Null>(Future<~>())",
                "Value0(Value0)",
                "Value0?()",
                "Value(Value)",
                "Value?()",
                "double(SassColor)",
                "Value0()",
                "String?()",
                "bool(num,num)",
                "Uri(Uri)",
                "bool(int)",
                "Null(Object,StackTrace)",
                "SassNumber(SassNumber)",
                "SassNumber0(SassNumber0)",
                "bool(ComplexSelectorComponent)",
                "bool(ComplexSelectorComponent0)",
                "bool(Value0)",
                "double(double,double)",
                "~(Value)",
                "ComplexSelector0(ComplexSelector0)",
                "ValueExpression(Value)",
                "ComplexSelector(ComplexSelector)",
                "Null(@)",
                "~(Value0)",
                "@()",
                "ValueExpression0(Value0)",
                "int(SassColor)",
                "bool(ColorChannel0)",
                "bool(SelectorList0)",
                "Future<Value?>()",
                "~(Object,StackTrace)",
                "~(@)",
                "Future<Value>()",
                "bool(Object)",
                "bool(Expression)",
                "Object(Object)",
                "Frame()",
                "bool(SelectorList)",
                "Future<Value0?>()",
                "bool(Value)",
                "Future<Value0>()",
                "bool(Expression0)",
                "~([int?])",
                "Object()",
                "Null([Object?])",
                "bool(Module1<Callable>)",
                "Stylesheet?()",
                "Future<Value?>(Statement)",
                "Callable?()",
                "List<CssMediaQuery>?(List<CssMediaQuery>)",
                "~(String)",
                "~(Module1<Callable>,bool)",
                "Future<Value0>(List<Value0>)",
                "bool(ColorChannel)",
                "Frame(String)",
                "bool(Module0<Callable0>)",
                "AsyncCallable0?()",
                "~(Object)",
                "SassRuntimeException0(AstNode0)",
                "~(Value,Value)",
                "double(SassNumber0)",
                "Future<Value0?>(Statement0)",
                "bool(Module0<AsyncCallable>)",
                "AsyncCallable?()",
                "List<CssMediaQuery0>?(List<CssMediaQuery0>)",
                "~(String[Deprecation?])",
                "Null(_NodeSassColor,num)",
                "int(Uri)",
                "@(@)",
                "~(String,Value)",
                "~(String[Deprecation0?])",
                "SassRuntimeException(AstNode)",
                "~(String,Value0)",
                "Callable0?()",
                "~(Module0<Callable0>,bool)",
                "Value0?(Statement0)",
                "Value?(Statement)",
                "~(Value0,Value0)",
                "bool(Module1<AsyncCallable0>)",
                "SassCalculation0(Object)",
                "String(Expression0)",
                "Null(Module1<AsyncCallable0>,bool)",
                "bool(_Highlight)",
                "String(String{color:Object?})",
                "int(_NodeSassColor)",
                "Statement()",
                "~(String,Object?)",
                "Uri(String)",
                "+originalUrl(Importer,Uri,Uri)?()",
                "double(SassNumber)",
                "Map<ComplexSelector,Extension>()",
                "Map<ComplexSelector0,Extension0>()",
                "String(Object)",
                "String(Expression)",
                "String(@)",
                "~(String,Function)",
                "~(Expression0)",
                "Statement0()",
                "~(~())",
                "List<String>()",
                "~(String,@)",
                "Null(Module0<AsyncCallable>,bool)",
                "bool(UseRule0)",
                "InterpolationMap(List<int>)",
                "Uri?()",
                "int(String,String)",
                "String?(String?)",
                "String?(Object)",
                "bool(Statement)",
                "String(String[String?])",
                "bool(Import)",
                "Set<0^>()<Object?>",
                "Iterable<String>()",
                "Iterable<String>(String)",
                "Iterable<String>(@)",
                "DateTime()",
                "~(String[~])",
                "int(int)",
                "0&(String,FileSpan[StackTrace?])",
                "~(@,@)",
                "AtRootRule(List<Statement>,FileSpan)",
                "AtRule(List<Statement>,FileSpan)",
                "~(Object?,Object?)",
                "String(String{color:@})",
                "Entry(Entry)",
                "double(double,String)",
                "AstNode(AstNode)",
                "SassFunction(List<Value>)",
                "SassMixin(List<Value>)",
                "Future<~>(List<Value>)",
                "List<ExtensionStore>()",
                "int(ComplexSelector)",
                "bool(ModifiableCssParentNode)",
                "AsyncCallable?(Module0<AsyncCallable>)",
                "MapKeySet<Module0<AsyncCallable>>(Map<Module0<AsyncCallable>,AstNode>)",
                "Future<SassNumber>()",
                "JSUrl0(Uri)",
                "List<CssComment>()",
                "bool(UseRule)",
                "bool(ForwardRule)",
                "Map<String,AsyncCallable>(Module0<AsyncCallable>)",
                "Future<String>()",
                "Uri?/()",
                "String(+(String,Value))",
                "String(+(IfConditionExpression,String))",
                "Future<Object>()",
                "@(String)",
                "SelectorList(Value)",
                "AstNode?()",
                "String(SassNumber)",
                "Future<Value>(List<Value>)",
                "~(List<Value>)",
                "~([Object?])",
                "SassNumber()",
                "Expression(Expression)",
                "~(double?[String?])",
                "int(Frame)",
                "String(Frame)",
                "Callable0?(Module0<Callable0>)",
                "Trace()",
                "bool(Frame)",
                "MapKeySet<Module0<Callable0>>(Map<Module0<Callable0>,AstNode>)",
                "Map<String,Callable0>(Module0<Callable0>)",
                "AsyncCallable0?(Module1<AsyncCallable0>)",
                "MapKeySet<Module1<AsyncCallable0>>(Map<Module1<AsyncCallable0>,AstNode0>)",
                "Map<String,AsyncCallable0>(Module1<AsyncCallable0>)",
                "AstNode0(AstNode0)",
                "SassFunction0(List<Value0>)",
                "SassMixin0(List<Value0>)",
                "Future<~>(List<Value0>)",
                "~(Iterable<ExtensionStore>)",
                "List<ExtensionStore0>()",
                "bool(ModifiableCssParentNode0)",
                "List<Extension>()",
                "Future<SassNumber0>()",
                "List<CssComment0>()",
                "bool(ForwardRule0)",
                "String(+(String,Value0))",
                "String(+(IfConditionExpression0,String))",
                "bool(Queue<List<ComplexSelectorComponent>>)",
                "InterpolationMap0(List<int>)",
                "AstNode0?()",
                "String(SassNumber0)",
                "0&(Object[Object?])",
                "0&(@[@])",
                "Object(CalculationOperation0)",
                "Future<~>?()",
                "bool(String?)",
                "String(Value0)",
                "double(Value0)",
                "ImmutableList0(SassColor0)",
                "Trace(String)",
                "Future<NodeCompileResult>()",
                "AsyncImporter0(Object?)",
                "Set<0&>(Object)",
                "Version(String)",
                "~(Iterable<ExtensionStore0>)",
                "Callable?(Module1<Callable>)",
                "MapKeySet<Module1<Callable>>(Map<Module1<Callable>,AstNode0>)",
                "Map<String,Callable>(Module1<Callable>)",
                "double()",
                "~(List<Value0>)",
                "Value0?(Value0)",
                "SassNumber0()",
                "String(_NodeException)",
                "double(Value)",
                "List<Extension0>()",
                "bool(Queue<List<ComplexSelectorComponent0>>)",
                "bool(Statement0)",
                "bool(Import0)",
                "Value0?(Value0,num)",
                "Value0(int)",
                "Object(_NodeSassMap,int)",
                "Null(_NodeSassMap,int,Object)",
                "bool(SassNumber0)",
                "ImmutableList0(SassNumber0)",
                "bool(SassNumber0,String)",
                "SassNumber0(SassNumber0,Object,Object[String?])",
                "SassNumber0(SassNumber0,SassNumber0[String?,String?])",
                "double(SassNumber0,Object,Object[String?])",
                "double(SassNumber0,SassNumber0[String?,String?])",
                "int(ComplexSelector0)",
                "Expression0(Expression0)",
                "SelectorList0(Value0)",
                "FileLocation(FileSpan)",
                "String(FileSpan)",
                "int(SourceLocation)",
                "~(int)",
                "~(Object[StackTrace?])",
                "StyleRule0(List<Statement0>,FileSpan)",
                "AtRootRule0(List<Statement0>,FileSpan)",
                "AtRule0(List<Statement0>,FileSpan)",
                "int(@,@)",
                "bool(Object?,Object?)",
                "int(Object?)",
                "String(double)",
                "List<WatchEvent>(List<WatchEvent>)",
                "~(List<Statement>)",
                "ForRule(List<Statement>,FileSpan)",
                "IfConditionExpression(IfConditionExpression)",
                "Value?(Module0<Callable0>)",
                "~(CssMediaQuery)",
                "ContentBlock(List<Statement>,FileSpan)",
                "~(SelectorList)",
                "~(MapEntry<Value,Value>)",
                "SourceFile()",
                "SourceFile?(int)",
                "String?(SourceFile?)",
                "int(_Line)",
                "Module0<Callable0>?(Module0<Callable0>)",
                "Object(_Line)",
                "Object(_Highlight)",
                "int(_Highlight,_Highlight)",
                "List<_Line>(MapEntry<Object,List<_Highlight>>)",
                "SourceSpanWithContext()",
                "List<Frame>(Trace)",
                "int(Trace)",
                "MediaRule(List<Statement>,FileSpan)",
                "String(Trace)",
                "MixinRule(List<Statement>,FileSpan)",
                "~(@,StackTrace)",
                "Frame(String,String)",
                "SupportsRule(List<Statement>,FileSpan)",
                "WhileRule(List<Statement>,FileSpan)",
                "Frame(Frame)",
                "~(Expression)",
                "Map<String,Value>(Module0<Callable0>)",
                "Map<String,AstNode>(Module0<Callable0>)",
                "~(BinaryOperator)",
                "SassArgumentList0(Object,Object,Object[String?])",
                "ImmutableMap0(SassArgumentList0)",
                "~(String,Option)",
                "ArgParser()",
                "Value0/(List<Value0>)",
                "Value0?(Module1<AsyncCallable0>)",
                "Module1<AsyncCallable0>?(Module1<AsyncCallable0>)",
                "StringExpression(Interpolation)",
                "DateTime(StylesheetNode)",
                "Map<String,Value0>(Module1<AsyncCallable0>)",
                "Map<String,AstNode0>(Module1<AsyncCallable0>)",
                "bool(+originalUrl(Importer,Uri,Uri))",
                "Set<Deprecation>()",
                "Future<CssValue0<String>>(Interpolation0{trim:bool,warnForColor:bool})",
                "Uri(+originalUrl(Importer,Uri,Uri))",
                "~(+deprecation,message,span(Deprecation?,String,FileSpan))",
                "Future<~>(String)",
                "String(Parameter)",
                "SelectorList(SelectorList?,SelectorList)",
                "SassScriptException()",
                "SassList(ComplexSelector)",
                "SassString(SimpleSelector)",
                "~(Module1<AsyncCallable0>,bool)",
                "Future<+loadedUrls,stylesheet(Set<Uri>,CssStylesheet0)>()",
                "Future<Module1<AsyncCallable0>>()",
                "bool(Extension)",
                "~(Module1<AsyncCallable0>)",
                "SingleUnitSassNumber(double)",
                "Future<CssValue<String>>(Interpolation{trim:bool,warnForColor:bool})",
                "Set<ModifiableBox<SelectorList>>()",
                "@(@,String)",
                "Future<Value0?>(Value0)",
                "SassString(int)",
                "Future<CssValue0<String>>(Interpolation0)",
                "Iterable<ComplexSelector>(List<ComplexSelector>)",
                "~(Object?,List<JSObject>)",
                "List<SimpleSelector>(Extender)",
                "Iterable<ComplexSelector>(ComplexSelector)",
                "Future<Value0?>(IfRuleClause0)",
                "Future<CssValue<String>>(Interpolation)",
                "SassString(String)",
                "UserDefinedCallable0<AsyncEnvironment0>(ContentBlock0)",
                "List<Extender>?(SimpleSelector)",
                "List<Extender>(PseudoSelector)",
                "List<List<Extender>>(List<Extender>)",
                "List<ComplexSelector>(ComplexSelector)",
                "PseudoSelector(ComplexSelector)",
                "int(int,ComplexSelectorComponent)",
                "~(int,@)",
                "Future<Value0>(Expression0)",
                "~(SimpleSelector,Set<ModifiableBox<SelectorList>>)",
                "ModifiableBox<SelectorList>()",
                "Value0/()",
                "List<ComplexSelectorComponent>?(List<ComplexSelectorComponent>,List<ComplexSelectorComponent>)",
                "~(Module0<AsyncCallable>,bool)",
                "bool(List<Iterable<ComplexSelectorComponent>>)",
                "Future<+loadedUrls,stylesheet(Set<Uri>,CssStylesheet)>()",
                "Future<Module0<AsyncCallable>>()",
                "SimpleSelector(SimpleSelector)",
                "Future<+originalUrl(AsyncImporter0,Uri,Uri)?>()",
                "Future<Stylesheet0?>()",
                "bool(+originalUrl(AsyncImporter0,Uri,Uri))",
                "Uri(+originalUrl(AsyncImporter0,Uri,Uri))",
                "AtRootQuery0()",
                "~(Symbol0,@)",
                "~(Module0<AsyncCallable>)",
                "bool(PseudoSelector)",
                "SelectorList?(PseudoSelector)",
                "SassCalculation0(Object[Object?,Object?])",
                "SassCalculation0(SassCalculation0[String?])",
                "ImmutableList(SassCalculation0)",
                "Object(Object,String,Object,Object)",
                "bool(CalculationOperator0)",
                "bool(CalculationOperation0,Object)",
                "int(CalculationOperation0)",
                "String(CalculationOperation0)",
                "Null(JSObject?,JSArray<Object?>)",
                "CalculationInterpolation(Object,String)",
                "bool(CalculationInterpolation,Object)",
                "int(CalculationInterpolation)",
                "String(CalculationInterpolation)",
                "bool(CanonicalizeContext0)",
                "JSUrl0?(CanonicalizeContext0)",
                "Null(@,@)",
                "String(CssValue<Combinator>)",
                "Null(@,StackTrace)",
                "Null(Function,Function)",
                "String(String?)",
                "String(int,IfClause)",
                "bool(String?,String?)",
                "SassColor0(SassColor0)",
                "SassColor0(ColorSpace0)",
                "Value?(Module0<AsyncCallable>)",
                "0&(List<Value0>)",
                "Module0<AsyncCallable>?(Module0<AsyncCallable>)",
                "int(String?)",
                "SassColor0(Object,_ConstructionOptions)",
                "bool(SassColor0,Object)",
                "SassColor0(SassColor0,String)",
                "bool(SassColor0[String?])",
                "SassColor0(SassColor0,_ToGamutOptions)",
                "double(SassColor0,String[_ChannelOptions?])",
                "bool(SassColor0,String)",
                "bool(SassColor0,String[_ChannelOptions?])",
                "SassColor0(SassColor0,_ConstructionOptions)",
                "double?(String)",
                "SassColor0(SassColor0,SassColor0[_InterpolationOptions?])",
                "String(SassColor0)",
                "bool(SassColor0)",
                "Future<Value?>(Value)",
                "Null(_NodeSassColor,num?[num?,num?,num?,SassColor0?])",
                "double(num)",
                "SassColor(SassColor)",
                "double(_NodeSassColor)",
                "AtRootQuery()",
                "String(BuiltInCallable)",
                "Map<String,Value>(Module0<AsyncCallable>)",
                "AsyncImporter0(JSImporter)",
                "0&(@)",
                "SassColor(ColorSpace)",
                "NodePackageImporter0(Object[String?])",
                "List<CssMediaQuery>()",
                "NodeCompileResult(Compiler,String[CompileOptions?])",
                "NodeCompileResult(Compiler,String[CompileStringOptions?])",
                "Null(Compiler)",
                "Promise(AsyncCompiler,String[CompileOptions?])",
                "Promise(AsyncCompiler,String[CompileStringOptions?])",
                "Promise(AsyncCompiler)",
                "Future<AsyncCompiler>()",
                "int(int,ComplexSelectorComponent0)",
                "String(CssValue0<Combinator0>)",
                "int(int,SimpleSelector0)",
                "String(BuiltInCallable0)",
                "bool(Deprecation0)",
                "Iterable<Deprecation0>()",
                "Version(Object,int,int,int)",
                "Future<@>()",
                "int(int,SimpleSelector)",
                "Value0?(Module1<Callable>)",
                "Module1<Callable>?(Module1<Callable>)",
                "Future<Value?>(IfRuleClause)",
                "SelectorList()",
                "Map<String,Value0>(Module1<Callable>)",
                "Map<String,AstNode0>(Module1<Callable>)",
                "CompoundSelector()",
                "UserDefinedCallable<AsyncEnvironment>(ContentBlock)",
                "CssValue0<String>(Interpolation0{trim:bool,warnForColor:bool})",
                "bool(@)",
                "Statement({root:bool})",
                "String(Value)",
                "+loadedUrls,stylesheet(Set<Uri>,CssStylesheet0)()",
                "Module1<Callable>()",
                "~(Module1<Callable>)",
                "SelectorList(SelectorList,SelectorList)",
                "0&(List<Value>)",
                "Object(Value0)",
                "0&(String,int?)",
                "Value0?(IfRuleClause0)",
                "UserDefinedCallable0<Environment0>(ContentBlock0)",
                "Value0(Expression0)",
                "Future<+originalUrl(AsyncImporter,Uri,Uri)?>()",
                "FileSpan(_NodeException)",
                "bool(Extension0)",
                "Set<ModifiableBox0<SelectorList0>>()",
                "Expression({bracketList:bool,consumeNewlines:bool,singleEquals:bool,until:bool()?})",
                "NumberExpression()",
                "Iterable<ComplexSelector0>(List<ComplexSelector0>)",
                "Object(String)",
                "List<SimpleSelector0>(Extender0)",
                "List<Extender0>?(SimpleSelector0)",
                "List<Extender0>(PseudoSelector0)",
                "List<List<Extender0>>(List<Extender0>)",
                "List<ComplexSelector0>(ComplexSelector0)",
                "PseudoSelector0(ComplexSelector0)",
                "~(SimpleSelector0,Set<ModifiableBox0<SelectorList0>>)",
                "ModifiableBox0<SelectorList0>()",
                "SassFunction0(Object,String,Value0(List<Value0>))",
                "List<ComplexSelectorComponent0>?(List<ComplexSelectorComponent0>,List<ComplexSelectorComponent0>)",
                "Stylesheet()",
                "bool(List<Iterable<ComplexSelectorComponent0>>)",
                "bool(Version)",
                "bool(PseudoSelector0)",
                "SelectorList0?(PseudoSelector0)",
                "String(int,IfClause0)",
                "Future<Value>(Expression)",
                "Future<Stylesheet?>()",
                "~(Object?,Object,Object?)",
                "+(String,String)(String)",
                "+originalUrl(Importer0,Uri,Uri)?()",
                "Stylesheet0?()",
                "bool(+originalUrl(Importer0,Uri,Uri))",
                "Uri(+originalUrl(Importer0,Uri,Uri))",
                "bool(+(IfConditionExpression0?,Expression0))",
                "bool(IfConditionExpression0)",
                "~(String,WarnOptions)",
                "~(String,DebugOptions)",
                "Null(RenderResult)",
                "JSFunction0(JSFunction0)",
                "Object?(Object,String,String[Object?])",
                "Null(Object)",
                "List<Value>(Value)",
                "List<Value0>(Value0)",
                "Future<~>(List<String>)",
                "SassList0(ComplexSelector0)",
                "Iterable<ComplexSelector0>(ComplexSelector0)",
                "SimpleSelector0(SimpleSelector0)",
                "SassList0(Object[Object?,_ConstructorOptions?])",
                "bool(+originalUrl(AsyncImporter,Uri,Uri))",
                "Null(_NodeSassList,int?[bool?,SassList0?])",
                "Uri(+originalUrl(AsyncImporter,Uri,Uri))",
                "Object(_NodeSassList,int)",
                "Null(_NodeSassList,int,Object)",
                "bool(_NodeSassList)",
                "Null(_NodeSassList,bool)",
                "int(_NodeSassList)",
                "SassMap0(Value0)",
                "SassMap0(SassMap0)",
                "SassMap0(Object[ImmutableMap0?])",
                "ImmutableMap0(SassMap0)",
                "Value0?(SassMap0,Object)",
                "Null(_NodeSassMap,int?[SassMap0?])",
                "SassNumber0(int)",
                "Statement?()",
                "int(_NodeSassMap)",
                "Value/()",
                "SassNumber0(Value0)",
                "List<CssMediaQuery0>()",
                "Value0(Object)",
                "0&(Object)",
                "bool(ModifiableCssNode0)",
                "SassNumber0(Object,num[Object?])",
                "ParameterList()",
                "int?(SassNumber0)",
                "Object?(Object?)",
                "int(SassNumber0[String?])",
                "double(SassNumber0,num,num[String?])",
                "SassNumber0(SassNumber0[String?])",
                "SassNumber0(SassNumber0,String[String?])",
                "VariableDeclaration()",
                "UseRule()",
                "StyleRule(List<Statement>,FileSpan)",
                "CssValue<String>(Interpolation{trim:bool,warnForColor:bool})",
                "Declaration(List<Statement>,FileSpan)",
                "Null(_NodeSassNumber,num?[String?,SassNumber0?])",
                "double(_NodeSassNumber)",
                "Null(_NodeSassNumber,num)",
                "String(_NodeSassNumber)",
                "Null(_NodeSassNumber,String)",
                "SassScriptException0()",
                "String(Parameter0)",
                "JSExpressionVisitor(JSExpressionVisitorObject)",
                "JSIfConditionExpressionVisitor(JSIfConditionExpressionVisitorObject)",
                "JSStatementVisitor(JSStatementVisitorObject)",
                "JSSimpleSelectorVisitor(JSSimpleSelectorVisitorObject)",
                "SourceFile(String)",
                "JSSet(Set<Object?>)",
                "SourceFile(LazyFileSpan0)",
                "int(LazyFileSpan0)",
                "Uri?(LazyFileSpan0)",
                "String(SourceFile,int[int?])",
                "FileSpan(SourceFile,int[int?])",
                "List<int>(SourceFile)",
                "String?(Interpolation0)",
                "Object?(Statement0,StatementVisitor<Object?>)",
                "Object?(Expression0,ExpressionVisitor<Object?>)",
                "Object?(InterpolatedSelector,InterpolatedSelectorVisitor<Object?>)",
                "Object?(IfConditionExpression0,IfConditionExpressionVisitor<Object?>)",
                "ArgumentList0(IncludeRule0)",
                "ArgumentList0(ContentRule0)",
                "ArgumentList0(FunctionExpression0)",
                "ArgumentList0(LegacyIfExpression0)",
                "ArgumentList0(InterpolatedFunctionExpression0)",
                "Interpolation0(IfConditionFunction0)",
                "FileSpan(AstNode0)",
                "Interpolation0(SupportsCondition)",
                "~([Future<~>?])",
                "String(Object,@,@[@])",
                "bool(List<Value>)",
                "Value/(List<Value>)",
                "IfConditionExpression0(IfConditionExpression0)",
                "+loadedUrls,stylesheet(Set<Uri>,CssStylesheet)()",
                "SelectorList0(SelectorList0?,SelectorList0)",
                "SelectorList0(SelectorList0,SelectorList0)",
                "SassString0(SimpleSelector0)",
                "SelectorList0()",
                "CompoundSelector0()",
                "~(CssMediaQuery0)",
                "~(SelectorList0)",
                "~(MapEntry<Value0,Value0>)",
                "SingleUnitSassNumber0(double)",
                "bool(ModifiableCssNode)",
                "~(IfConditionExpression0)",
                "Module0<Callable0>()",
                "JSUrl0?(FileSpan)",
                "bool(List<Value0>)",
                "~(Module0<Callable0>)",
                "Value?(Value)",
                "SassString0(int)",
                "SassString0(String)",
                "EachRule(List<Statement>,FileSpan)",
                "SassString0(Object[Object?,_ConstructorOptions1?])",
                "String(SassString0)",
                "bool(SassString0)",
                "int(SassString0)",
                "int(SassString0,Value0[String?])",
                "Null(_NodeSassString,String?[SassString0?])",
                "String(_NodeSassString)",
                "Null(_NodeSassString,String)",
                "Statement0({root:bool})",
                "CssValue<String>(Interpolation)",
                "NumberExpression0()",
                "Stylesheet0()",
                "Statement0?()",
                "ParameterList0()",
                "+(String,ParameterList0)()",
                "FunctionRule(List<Statement>,FileSpan)",
                "Declaration0(List<Statement0>,FileSpan)",
                "Value?(IfRuleClause)",
                "EachRule0(List<Statement0>,FileSpan)",
                "FunctionRule0(List<Statement0>,FileSpan)",
                "ForRule0(List<Statement0>,FileSpan)",
                "ContentBlock0(List<Statement0>,FileSpan)",
                "MediaRule0(List<Statement0>,FileSpan)",
                "MixinRule0(List<Statement0>,FileSpan)",
                "UserDefinedCallable<Environment>(ContentBlock)",
                "SupportsRule0(List<Statement0>,FileSpan)",
                "WhileRule0(List<Statement0>,FileSpan)",
                "~(BinaryOperator0)",
                "StringExpression0(Interpolation0)",
                "Null(~(Object?),~(Object?))",
                "ImmutableList0(Value0)",
                "String?(Value0)",
                "int(Value0,Value0[String?])",
                "SassBoolean0(Value0[String?])",
                "SassCalculation0(Value0[String?])",
                "SassColor0(Value0[String?])",
                "SassFunction0(Value0[String?])",
                "SassMap0(Value0[String?])",
                "SassMixin0(Value0[String?])",
                "SassNumber0(Value0[String?])",
                "SassString0(Value0[String?])",
                "SassMap0?(Value0)",
                "bool(Value0,Object?)",
                "int(Value0[Object?])",
                "Value(Expression)",
                "SassMap(Value)",
                "~(Zone?,ZoneDelegate?,Zone,Object,StackTrace)",
                "0^(Zone?,ZoneDelegate?,Zone,0^())<Object?>",
                "0^(Zone?,ZoneDelegate?,Zone,0^(1^),1^)<Object?,Object?>",
                "0^(Zone?,ZoneDelegate?,Zone,0^(1^,2^),1^,2^)<Object?,Object?,Object?>",
                "0^()(Zone,ZoneDelegate,Zone,0^())<Object?>",
                "0^(1^)(Zone,ZoneDelegate,Zone,0^(1^))<Object?,Object?>",
                "0^(1^,2^)(Zone,ZoneDelegate,Zone,0^(1^,2^))<Object?,Object?,Object?>",
                "AsyncError?(Zone,ZoneDelegate,Zone,Object,StackTrace?)",
                "~(Zone?,ZoneDelegate?,Zone,~())",
                "Timer(Zone,ZoneDelegate,Zone,Duration,~())",
                "Timer(Zone,ZoneDelegate,Zone,Duration,~(Timer))",
                "~(Zone,ZoneDelegate,Zone,String)",
                "Zone(Zone?,ZoneDelegate?,Zone,ZoneSpecification?,Map<Object?,Object?>?)",
                "bool(Deprecation)",
                "bool(+(IfConditionExpression?,Expression))",
                "0^(0^,0^)<num>",
                "SassMap(SassMap)",
                "bool(IfConditionExpression)",
                "~(Object,StackTrace,EventSink<0^>)<Object?>",
                "List<0^>(0^,List<0^>?)<Object?>",
                "NodeCompileResult(String[CompileOptions?])",
                "NodeCompileResult(String[CompileStringOptions?])",
                "Promise(String[CompileOptions?])",
                "Promise(String[CompileStringOptions?])",
                "Importer0(Object?)",
                "Compiler()",
                "Promise()",
                "List<Object?>(Object?)",
                "~(RenderOptions,~(Object?,RenderResult?))",
                "RenderResult(RenderOptions)",
                "ParserExports()",
                "Stylesheet0(String,String,String?)",
                "String?(String)",
                "Uri(JSUrl0)",
                "Object(Map<String,Object?>)",
                "String(String[String?,String?,String?,String?,String?,String?,String?,String?,String?,String?,String?,String?,String?,String?])",
                "String(Object?)",
                "SassNumber(Value)",
                "Value(Object)",
                "~(ContentBlock)",
                "Map<String,AstNode>(Module0<AsyncCallable>)",
                "CssValue0<String>(Interpolation0)"
            ],
            interceptorsByTag: null,
            leafTags: null,
            arrayRti: Symbol("$ti"),
            rttc: {
                "1;": function(t1) {
                    return function(o) {
                        return o instanceof A._Record_1 && t1._is(o._0);
                    };
                },
                "2;": function(t1, t2) {
                    return function(o) {
                        return o instanceof A._Record_2 && t1._is(o._0) && t2._is(o._1);
                    };
                },
                "2;forImport": function(t1, t2) {
                    return function(o) {
                        return o instanceof A._Record_2_forImport && t1._is(o._0) && t2._is(o._1);
                    };
                },
                "2;sourceMap": function(t1, t2) {
                    return function(o) {
                        return o instanceof A._Record_2_sourceMap && t1._is(o._0) && t2._is(o._1);
                    };
                },
                "2;imports,modules": function(t1, t2) {
                    return function(o) {
                        return o instanceof A._Record_2_imports_modules && t1._is(o._0) && t2._is(o._1);
                    };
                },
                "2;loadedUrls,stylesheet": function(t1, t2) {
                    return function(o) {
                        return o instanceof A._Record_2_loadedUrls_stylesheet && t1._is(o._0) && t2._is(o._1);
                    };
                },
                "3;": function(t1, t2, t3) {
                    return function(o) {
                        return o instanceof A._Record_3 && t1._is(o._0) && t2._is(o._1) && t3._is(o._2);
                    };
                },
                "3;forImport": function(t1, t2, t3) {
                    return function(o) {
                        return o instanceof A._Record_3_forImport && t1._is(o._0) && t2._is(o._1) && t3._is(o._2);
                    };
                },
                "3;originalUrl": function(t1, t2, t3) {
                    return function(o) {
                        return o instanceof A._Record_3_originalUrl && t1._is(o._0) && t2._is(o._1) && t3._is(o._2);
                    };
                },
                "3;importer,isDependency": function(t1, t2, t3) {
                    return function(o) {
                        return o instanceof A._Record_3_importer_isDependency && t1._is(o._0) && t2._is(o._1) && t3._is(o._2);
                    };
                },
                "3;deprecation,message,span": function(t1, t2, t3) {
                    return function(o) {
                        return o instanceof A._Record_3_deprecation_message_span && t1._is(o._0) && t2._is(o._1) && t3._is(o._2);
                    };
                },
                "5;named,namedNodes,positional,positionalNodes,separator": function(types) {
                    return function(o) {
                        return o instanceof A._Record_5_named_namedNodes_positional_positionalNodes_separator && A.pairwiseIsTest(types, o._values);
                    };
                }
            }
        };
        A._Universe_addRules(init.typeUniverse, JSON.parse('{"PlainJavaScriptObject":"LegacyJavaScriptObject","UnknownJavaScriptObject":"LegacyJavaScriptObject","JavaScriptFunction":"LegacyJavaScriptObject","Stdin":"LegacyJavaScriptObject","Stdout":"LegacyJavaScriptObject","ReadlineModule":"LegacyJavaScriptObject","ReadlineOptions":"LegacyJavaScriptObject","ReadlineInterface":"LegacyJavaScriptObject","BufferModule":"LegacyJavaScriptObject","BufferConstants":"LegacyJavaScriptObject","Buffer":"LegacyJavaScriptObject","ConsoleModule":"LegacyJavaScriptObject","Console":"LegacyJavaScriptObject","EventEmitter":"LegacyJavaScriptObject","FS":"LegacyJavaScriptObject","FSConstants":"LegacyJavaScriptObject","Realpath":"LegacyJavaScriptObject","RealpathSync":"LegacyJavaScriptObject","FSWatcher":"LegacyJavaScriptObject","ReadStream":"LegacyJavaScriptObject","ReadStreamOptions":"LegacyJavaScriptObject","WriteStream":"LegacyJavaScriptObject","WriteStreamOptions":"LegacyJavaScriptObject","FileOptions":"LegacyJavaScriptObject","StatOptions":"LegacyJavaScriptObject","MkdirOptions":"LegacyJavaScriptObject","RmdirOptions":"LegacyJavaScriptObject","WatchOptions":"LegacyJavaScriptObject","WatchFileOptions":"LegacyJavaScriptObject","Stats":"LegacyJavaScriptObject","Promise":"LegacyJavaScriptObject","Date":"LegacyJavaScriptObject","JsError":"LegacyJavaScriptObject","Atomics":"LegacyJavaScriptObject","Modules":"LegacyJavaScriptObject","Module":"LegacyJavaScriptObject","Net":"LegacyJavaScriptObject","Socket":"LegacyJavaScriptObject","NetAddress":"LegacyJavaScriptObject","NetServer":"LegacyJavaScriptObject","NodeJsError":"LegacyJavaScriptObject","JsAssertionError":"LegacyJavaScriptObject","JsRangeError":"LegacyJavaScriptObject","JsReferenceError":"LegacyJavaScriptObject","JsSyntaxError":"LegacyJavaScriptObject","JsTypeError":"LegacyJavaScriptObject","JsSystemError":"LegacyJavaScriptObject","Process":"LegacyJavaScriptObject","CPUUsage":"LegacyJavaScriptObject","Release":"LegacyJavaScriptObject","StreamModule":"LegacyJavaScriptObject","Readable":"LegacyJavaScriptObject","Writable":"LegacyJavaScriptObject","Duplex":"LegacyJavaScriptObject","Transform":"LegacyJavaScriptObject","WritableOptions":"LegacyJavaScriptObject","ReadableOptions":"LegacyJavaScriptObject","Immediate":"LegacyJavaScriptObject","Timeout":"LegacyJavaScriptObject","TTY":"LegacyJavaScriptObject","TTYReadStream":"LegacyJavaScriptObject","TTYWriteStream":"LegacyJavaScriptObject","Util":"LegacyJavaScriptObject","JSArray0":"LegacyJavaScriptObject","Chokidar":"LegacyJavaScriptObject","ChokidarOptions":"LegacyJavaScriptObject","ChokidarWatcher":"LegacyJavaScriptObject","JSFunction":"LegacyJavaScriptObject","ImmutableList":"LegacyJavaScriptObject","ImmutableMap":"LegacyJavaScriptObject","NodeImporterResult":"LegacyJavaScriptObject","RenderContext":"LegacyJavaScriptObject","RenderContextOptions":"LegacyJavaScriptObject","RenderContextResult":"LegacyJavaScriptObject","RenderContextResultStats":"LegacyJavaScriptObject","JSModule":"LegacyJavaScriptObject","JSModuleRequire":"LegacyJavaScriptObject","JSClass":"LegacyJavaScriptObject","JSUrl":"LegacyJavaScriptObject","_PropertyDescriptor":"LegacyJavaScriptObject","_RequireMain":"LegacyJavaScriptObject","JSArray1":"LegacyJavaScriptObject","Chokidar0":"LegacyJavaScriptObject","ChokidarOptions0":"LegacyJavaScriptObject","ChokidarWatcher0":"LegacyJavaScriptObject","_ConstructionOptions":"LegacyJavaScriptObject","_ChannelOptions":"LegacyJavaScriptObject","_ToGamutOptions":"LegacyJavaScriptObject","_InterpolationOptions":"LegacyJavaScriptObject","_Channels":"LegacyJavaScriptObject","_NodeSassColor":"LegacyJavaScriptObject","CompileOptions":"LegacyJavaScriptObject","CompileStringOptions":"LegacyJavaScriptObject","NodeCompileResult":"LegacyJavaScriptObject","Deprecation1":"LegacyJavaScriptObject","_NodeException":"LegacyJavaScriptObject","Exports":"LegacyJavaScriptObject","LoggerNamespace":"LegacyJavaScriptObject","JSExpressionVisitorObject":"LegacyJavaScriptObject","Fiber":"LegacyJavaScriptObject","FiberClass":"LegacyJavaScriptObject","JSFunction0":"LegacyJavaScriptObject","JSIfConditionExpressionVisitorObject":"LegacyJavaScriptObject","ImmutableList0":"LegacyJavaScriptObject","ImmutableMap0":"LegacyJavaScriptObject","JSImporter":"LegacyJavaScriptObject","JSImporterResult":"LegacyJavaScriptObject","NodeImporterResult0":"LegacyJavaScriptObject","_ConstructorOptions":"LegacyJavaScriptObject","_NodeSassList":"LegacyJavaScriptObject","WarnOptions":"LegacyJavaScriptObject","DebugOptions":"LegacyJavaScriptObject","JSLogger":"LegacyJavaScriptObject","_NodeSassMap":"LegacyJavaScriptObject","JSModule0":"LegacyJavaScriptObject","JSModuleRequire0":"LegacyJavaScriptObject","_ConstructorOptions0":"LegacyJavaScriptObject","_NodeSassNumber":"LegacyJavaScriptObject","ParserExports":"LegacyJavaScriptObject","JSClass0":"LegacyJavaScriptObject","RenderContext0":"LegacyJavaScriptObject","RenderContextOptions0":"LegacyJavaScriptObject","RenderContextResult0":"LegacyJavaScriptObject","RenderContextResultStats0":"LegacyJavaScriptObject","RenderOptions":"LegacyJavaScriptObject","RenderResult":"LegacyJavaScriptObject","RenderResultStats":"LegacyJavaScriptObject","_Exports":"LegacyJavaScriptObject","JSSet":"LegacyJavaScriptObject","JSSimpleSelectorVisitorObject":"LegacyJavaScriptObject","JSStatementVisitorObject":"LegacyJavaScriptObject","_ConstructorOptions1":"LegacyJavaScriptObject","_NodeSassString":"LegacyJavaScriptObject","Types":"LegacyJavaScriptObject","JSUrl0":"LegacyJavaScriptObject","_PropertyDescriptor0":"LegacyJavaScriptObject","_RequireMain0":"LegacyJavaScriptObject","NativeArrayBuffer":"NativeByteBuffer","JSArray":{"List":["1"],"EfficientLengthIterable":["1"],"JSObject":[],"Iterable":["1"]},"JSBool":{"bool":[],"TrustedGetRuntimeType":[]},"JSNull":{"Null":[],"TrustedGetRuntimeType":[]},"JavaScriptObject":{"JSObject":[]},"LegacyJavaScriptObject":{"JSObject":[],"Promise":[],"JsSystemError":[],"ImmutableList":[],"_ConstructionOptions":[],"_ChannelOptions":[],"_ToGamutOptions":[],"_InterpolationOptions":[],"_NodeSassColor":[],"CompileOptions":[],"CompileStringOptions":[],"NodeCompileResult":[],"Deprecation1":[],"_NodeException":[],"JSExpressionVisitorObject":[],"Fiber":[],"JSFunction0":[],"JSIfConditionExpressionVisitorObject":[],"ImmutableList0":[],"ImmutableMap0":[],"JSImporter":[],"JSImporterResult":[],"NodeImporterResult0":[],"_ConstructorOptions":[],"_NodeSassList":[],"WarnOptions":[],"DebugOptions":[],"_NodeSassMap":[],"_ConstructorOptions0":[],"_NodeSassNumber":[],"ParserExports":[],"JSClass0":[],"RenderContextOptions0":[],"RenderOptions":[],"RenderResult":[],"JSSet":[],"JSSimpleSelectorVisitorObject":[],"JSStatementVisitorObject":[],"_ConstructorOptions1":[],"_NodeSassString":[],"JSUrl0":[]},"JSArraySafeToStringHook":{"SafeToStringHook":[]},"JSUnmodifiableArray":{"JSArray":["1"],"List":["1"],"EfficientLengthIterable":["1"],"JSObject":[],"Iterable":["1"]},"JSNumber":{"double":[],"num":[],"Comparable":["num"]},"JSInt":{"double":[],"int":[],"num":[],"Comparable":["num"],"TrustedGetRuntimeType":[]},"JSNumNotInt":{"double":[],"num":[],"Comparable":["num"],"TrustedGetRuntimeType":[]},"JSString":{"String":[],"Comparable":["String"],"TrustedGetRuntimeType":[]},"_CastIterableBase":{"Iterable":["2"]},"CastIterable":{"_CastIterableBase":["1","2"],"Iterable":["2"],"Iterable.E":"2"},"_EfficientLengthCastIterable":{"CastIterable":["1","2"],"_CastIterableBase":["1","2"],"EfficientLengthIterable":["2"],"Iterable":["2"],"Iterable.E":"2"},"_CastListBase":{"ListBase":["2"],"List":["2"],"_CastIterableBase":["1","2"],"EfficientLengthIterable":["2"],"Iterable":["2"]},"CastList":{"_CastListBase":["1","2"],"ListBase":["2"],"List":["2"],"_CastIterableBase":["1","2"],"EfficientLengthIterable":["2"],"Iterable":["2"],"ListBase.E":"2","Iterable.E":"2"},"CastSet":{"Set":["2"],"_CastIterableBase":["1","2"],"EfficientLengthIterable":["2"],"Iterable":["2"],"Iterable.E":"2"},"CastMap":{"MapBase":["3","4"],"Map":["3","4"],"MapBase.K":"3","MapBase.V":"4"},"LateError":{"Error":[]},"CodeUnits":{"ListBase":["int"],"List":["int"],"EfficientLengthIterable":["int"],"Iterable":["int"],"ListBase.E":"int"},"EfficientLengthIterable":{"Iterable":["1"]},"ListIterable":{"EfficientLengthIterable":["1"],"Iterable":["1"]},"SubListIterable":{"ListIterable":["1"],"EfficientLengthIterable":["1"],"Iterable":["1"],"ListIterable.E":"1","Iterable.E":"1"},"MappedIterable":{"Iterable":["2"],"Iterable.E":"2"},"EfficientLengthMappedIterable":{"MappedIterable":["1","2"],"EfficientLengthIterable":["2"],"Iterable":["2"],"Iterable.E":"2"},"MappedListIterable":{"ListIterable":["2"],"EfficientLengthIterable":["2"],"Iterable":["2"],"ListIterable.E":"2","Iterable.E":"2"},"WhereIterable":{"Iterable":["1"],"Iterable.E":"1"},"ExpandIterable":{"Iterable":["2"],"Iterable.E":"2"},"TakeIterable":{"Iterable":["1"],"Iterable.E":"1"},"EfficientLengthTakeIterable":{"TakeIterable":["1"],"EfficientLengthIterable":["1"],"Iterable":["1"],"Iterable.E":"1"},"SkipIterable":{"Iterable":["1"],"Iterable.E":"1"},"EfficientLengthSkipIterable":{"SkipIterable":["1"],"EfficientLengthIterable":["1"],"Iterable":["1"],"Iterable.E":"1"},"SkipWhileIterable":{"Iterable":["1"],"Iterable.E":"1"},"EmptyIterable":{"EfficientLengthIterable":["1"],"Iterable":["1"],"Iterable.E":"1"},"FollowedByIterable":{"Iterable":["1"],"Iterable.E":"1"},"EfficientLengthFollowedByIterable":{"FollowedByIterable":["1"],"EfficientLengthIterable":["1"],"Iterable":["1"],"Iterable.E":"1"},"WhereTypeIterable":{"Iterable":["1"],"Iterable.E":"1"},"NonNullsIterable":{"Iterable":["1"],"Iterable.E":"1"},"UnmodifiableListBase":{"ListBase":["1"],"List":["1"],"EfficientLengthIterable":["1"],"Iterable":["1"]},"ReversedListIterable":{"ListIterable":["1"],"EfficientLengthIterable":["1"],"Iterable":["1"],"ListIterable.E":"1","Iterable.E":"1"},"Symbol":{"Symbol0":[]},"ConstantMapView":{"UnmodifiableMapView":["1","2"],"MapView":["1","2"],"_UnmodifiableMapMixin":["1","2"],"Map":["1","2"]},"ConstantMap":{"Map":["1","2"]},"ConstantStringMap":{"ConstantMap":["1","2"],"Map":["1","2"]},"_KeysOrValues":{"Iterable":["1"],"Iterable.E":"1"},"ConstantSet":{"SetBase":["1"],"Set":["1"],"EfficientLengthIterable":["1"],"Iterable":["1"]},"ConstantStringSet":{"SetBase":["1"],"Set":["1"],"EfficientLengthIterable":["1"],"Iterable":["1"]},"GeneralConstantSet":{"SetBase":["1"],"Set":["1"],"EfficientLengthIterable":["1"],"Iterable":["1"]},"Instantiation":{"Function":[]},"Instantiation1":{"Function":[]},"NullError":{"TypeError":[],"Error":[]},"JsNoSuchMethodError":{"Error":[]},"UnknownJsTypeError":{"Error":[]},"NullThrownFromJavaScriptException":{"Exception":[]},"_StackTrace":{"StackTrace":[]},"Closure":{"Function":[]},"Closure0Args":{"Function":[]},"Closure2Args":{"Function":[]},"TearOffClosure":{"Function":[]},"StaticClosure":{"Function":[]},"BoundClosure":{"Function":[]},"RuntimeError":{"Error":[]},"JsLinkedHashMap":{"MapBase":["1","2"],"Map":["1","2"],"MapBase.K":"1","MapBase.V":"2"},"LinkedHashMapKeysIterable":{"EfficientLengthIterable":["1"],"Iterable":["1"],"Iterable.E":"1"},"LinkedHashMapValuesIterable":{"EfficientLengthIterable":["1"],"Iterable":["1"],"Iterable.E":"1"},"LinkedHashMapEntriesIterable":{"EfficientLengthIterable":["MapEntry<1,2>"],"Iterable":["MapEntry<1,2>"],"Iterable.E":"MapEntry<1,2>"},"JsIdentityLinkedHashMap":{"JsLinkedHashMap":["1","2"],"MapBase":["1","2"],"Map":["1","2"],"MapBase.K":"1","MapBase.V":"2"},"JsConstantLinkedHashMap":{"JsLinkedHashMap":["1","2"],"MapBase":["1","2"],"Map":["1","2"],"MapBase.K":"1","MapBase.V":"2"},"_MatchImplementation":{"RegExpMatch":[],"Match":[]},"_AllMatchesIterable":{"Iterable":["RegExpMatch"],"Iterable.E":"RegExpMatch"},"StringMatch":{"Match":[]},"_StringAllMatchesIterable":{"Iterable":["Match"],"Iterable.E":"Match"},"NativeByteBuffer":{"JSObject":[],"ByteBuffer":[],"TrustedGetRuntimeType":[]},"NativeTypedData":{"JSObject":[]},"NativeByteData":{"ByteData":[],"JSObject":[],"TrustedGetRuntimeType":[]},"NativeTypedArray":{"JavaScriptIndexingBehavior":["1"],"JSObject":[]},"NativeTypedArrayOfDouble":{"ListBase":["double"],"List":["double"],"JavaScriptIndexingBehavior":["double"],"EfficientLengthIterable":["double"],"JSObject":[],"Iterable":["double"]},"NativeTypedArrayOfInt":{"ListBase":["int"],"List":["int"],"JavaScriptIndexingBehavior":["int"],"EfficientLengthIterable":["int"],"JSObject":[],"Iterable":["int"]},"NativeFloat32List":{"NativeTypedArrayOfDouble":[],"Float32List":[],"ListBase":["double"],"List":["double"],"JavaScriptIndexingBehavior":["double"],"EfficientLengthIterable":["double"],"JSObject":[],"Iterable":["double"],"TrustedGetRuntimeType":[],"ListBase.E":"double"},"NativeFloat64List":{"NativeTypedArrayOfDouble":[],"Float64List":[],"ListBase":["double"],"List":["double"],"JavaScriptIndexingBehavior":["double"],"EfficientLengthIterable":["double"],"JSObject":[],"Iterable":["double"],"TrustedGetRuntimeType":[],"ListBase.E":"double"},"NativeInt16List":{"NativeTypedArrayOfInt":[],"Int16List":[],"ListBase":["int"],"List":["int"],"JavaScriptIndexingBehavior":["int"],"EfficientLengthIterable":["int"],"JSObject":[],"Iterable":["int"],"TrustedGetRuntimeType":[],"ListBase.E":"int"},"NativeInt32List":{"NativeTypedArrayOfInt":[],"Int32List":[],"ListBase":["int"],"List":["int"],"JavaScriptIndexingBehavior":["int"],"EfficientLengthIterable":["int"],"JSObject":[],"Iterable":["int"],"TrustedGetRuntimeType":[],"ListBase.E":"int"},"NativeInt8List":{"NativeTypedArrayOfInt":[],"Int8List":[],"ListBase":["int"],"List":["int"],"JavaScriptIndexingBehavior":["int"],"EfficientLengthIterable":["int"],"JSObject":[],"Iterable":["int"],"TrustedGetRuntimeType":[],"ListBase.E":"int"},"NativeUint16List":{"NativeTypedArrayOfInt":[],"Uint16List":[],"ListBase":["int"],"List":["int"],"JavaScriptIndexingBehavior":["int"],"EfficientLengthIterable":["int"],"JSObject":[],"Iterable":["int"],"TrustedGetRuntimeType":[],"ListBase.E":"int"},"NativeUint32List":{"NativeTypedArrayOfInt":[],"Uint32List":[],"ListBase":["int"],"List":["int"],"JavaScriptIndexingBehavior":["int"],"EfficientLengthIterable":["int"],"JSObject":[],"Iterable":["int"],"TrustedGetRuntimeType":[],"ListBase.E":"int"},"NativeUint8ClampedList":{"NativeTypedArrayOfInt":[],"Uint8ClampedList":[],"ListBase":["int"],"List":["int"],"JavaScriptIndexingBehavior":["int"],"EfficientLengthIterable":["int"],"JSObject":[],"Iterable":["int"],"TrustedGetRuntimeType":[],"ListBase.E":"int"},"NativeUint8List":{"NativeTypedArrayOfInt":[],"Uint8List":[],"ListBase":["int"],"List":["int"],"JavaScriptIndexingBehavior":["int"],"EfficientLengthIterable":["int"],"JSObject":[],"Iterable":["int"],"TrustedGetRuntimeType":[],"ListBase.E":"int"},"_Error":{"Error":[]},"_TypeError":{"TypeError":[],"Error":[]},"AsyncError":{"Error":[]},"_SyncStarIterable":{"Iterable":["1"],"Iterable.E":"1"},"_AsyncCompleter":{"_Completer":["1"]},"_SyncCompleter":{"_Completer":["1"]},"_Future":{"Future":["1"]},"_StreamController":{"EventSink":["1"]},"_AsyncStreamController":{"_StreamController":["1"],"EventSink":["1"]},"_SyncStreamController":{"_StreamController":["1"],"EventSink":["1"]},"_ControllerStream":{"_StreamImpl":["1"],"Stream":["1"],"Stream.T":"1"},"_ControllerSubscription":{"_BufferingStreamSubscription":["1"],"StreamSubscription":["1"],"_BufferingStreamSubscription.T":"1"},"_BufferingStreamSubscription":{"StreamSubscription":["1"],"_BufferingStreamSubscription.T":"1"},"_StreamImpl":{"Stream":["1"]},"_ForwardingStream":{"Stream":["2"]},"_ForwardingStreamSubscription":{"_BufferingStreamSubscription":["2"],"StreamSubscription":["2"],"_BufferingStreamSubscription.T":"2"},"_MapStream":{"_ForwardingStream":["1","2"],"Stream":["2"],"Stream.T":"2"},"_Zone":{"Zone":[]},"_CustomZone":{"Zone":[]},"_RootZone":{"Zone":[]},"_ZoneDelegate":{"ZoneDelegate":[]},"_ZoneSpecification":{"ZoneSpecification":[]},"Queue":{"EfficientLengthIterable":["1"],"Iterable":["1"]},"_HashMap":{"MapBase":["1","2"],"Map":["1","2"],"MapBase.K":"1","MapBase.V":"2"},"_IdentityHashMap":{"_HashMap":["1","2"],"MapBase":["1","2"],"Map":["1","2"],"MapBase.K":"1","MapBase.V":"2"},"_HashMapKeyIterable":{"EfficientLengthIterable":["1"],"Iterable":["1"],"Iterable.E":"1"},"_LinkedCustomHashMap":{"JsLinkedHashMap":["1","2"],"MapBase":["1","2"],"Map":["1","2"],"MapBase.K":"1","MapBase.V":"2"},"_LinkedHashSet":{"_SetBase":["1"],"SetBase":["1"],"Set":["1"],"EfficientLengthIterable":["1"],"Iterable":["1"]},"_LinkedIdentityHashSet":{"_LinkedHashSet":["1"],"_SetBase":["1"],"SetBase":["1"],"Set":["1"],"EfficientLengthIterable":["1"],"Iterable":["1"]},"UnmodifiableListView":{"ListBase":["1"],"List":["1"],"EfficientLengthIterable":["1"],"Iterable":["1"],"ListBase.E":"1"},"ListBase":{"List":["1"],"EfficientLengthIterable":["1"],"Iterable":["1"]},"MapBase":{"Map":["1","2"]},"UnmodifiableMapBase":{"MapBase":["1","2"],"_UnmodifiableMapMixin":["1","2"],"Map":["1","2"]},"_MapBaseValueIterable":{"EfficientLengthIterable":["2"],"Iterable":["2"],"Iterable.E":"2"},"MapView":{"Map":["1","2"]},"UnmodifiableMapView":{"MapView":["1","2"],"_UnmodifiableMapMixin":["1","2"],"Map":["1","2"]},"ListQueue":{"Queue":["1"],"ListIterable":["1"],"EfficientLengthIterable":["1"],"Iterable":["1"],"ListIterable.E":"1","Iterable.E":"1"},"SetBase":{"Set":["1"],"EfficientLengthIterable":["1"],"Iterable":["1"]},"_SetBase":{"SetBase":["1"],"Set":["1"],"EfficientLengthIterable":["1"],"Iterable":["1"]},"UnmodifiableSetView":{"SetBase":["1"],"Set":["1"],"EfficientLengthIterable":["1"],"Iterable":["1"]},"_JsonMap":{"MapBase":["String","@"],"Map":["String","@"],"MapBase.K":"String","MapBase.V":"@"},"_JsonMapKeyIterable":{"ListIterable":["String"],"EfficientLengthIterable":["String"],"Iterable":["String"],"ListIterable.E":"String","Iterable.E":"String"},"AsciiCodec":{"Codec":["String","List<int>"]},"_UnicodeSubsetEncoder":{"Converter":["String","List<int>"]},"AsciiEncoder":{"Converter":["String","List<int>"]},"Base64Codec":{"Codec":["List<int>","String"]},"Base64Encoder":{"Converter":["List<int>","String"]},"Encoding":{"Codec":["String","List<int>"]},"JsonUnsupportedObjectError":{"Error":[]},"JsonCyclicError":{"Error":[]},"JsonCodec":{"Codec":["Object?","String"]},"JsonEncoder":{"Converter":["Object?","String"]},"JsonDecoder":{"Converter":["String","Object?"]},"Utf8Codec":{"Codec":["String","List<int>"]},"Utf8Encoder":{"Converter":["String","List<int>"]},"Utf8Decoder":{"Converter":["List<int>","String"]},"DateTime":{"Comparable":["DateTime"]},"double":{"num":[],"Comparable":["num"]},"Duration":{"Comparable":["Duration"]},"int":{"num":[],"Comparable":["num"]},"List":{"EfficientLengthIterable":["1"],"Iterable":["1"]},"num":{"Comparable":["num"]},"RegExpMatch":{"Match":[]},"Set":{"EfficientLengthIterable":["1"],"Iterable":["1"]},"String":{"Comparable":["String"]},"AssertionError":{"Error":[]},"TypeError":{"Error":[]},"ArgumentError":{"Error":[]},"RangeError":{"Error":[]},"IndexError":{"RangeError":[],"Error":[]},"NoSuchMethodError":{"Error":[]},"UnsupportedError":{"Error":[]},"UnimplementedError":{"Error":[]},"StateError":{"Error":[]},"ConcurrentModificationError":{"Error":[]},"OutOfMemoryError":{"Error":[]},"StackOverflowError":{"Error":[]},"_Exception":{"Exception":[]},"FormatException":{"Exception":[]},"_GeneratorIterable":{"ListIterable":["1"],"EfficientLengthIterable":["1"],"Iterable":["1"],"ListIterable.E":"1","Iterable.E":"1"},"_StringStackTrace":{"StackTrace":[]},"Runes":{"Iterable":["int"],"Iterable.E":"int"},"_Uri":{"_PlatformUri":[],"Uri":[]},"_SimpleUri":{"_PlatformUri":[],"Uri":[]},"_DataUri":{"_PlatformUri":[],"Uri":[]},"NullRejectionException":{"Exception":[]},"ArgParserException":{"FormatException":[],"Exception":[]},"ErrorResult":{"Result":["0&"]},"ValueResult":{"Result":["1"]},"_CompleterStream":{"Stream":["1"],"Stream.T":"1"},"_NextRequest":{"_EventRequest":["1"]},"EmptyUnmodifiableSet":{"Set":["1"],"EfficientLengthIterable":["1"],"Iterable":["1"],"Iterable.E":"1"},"QueueList":{"ListBase":["1"],"List":["1"],"Queue":["1"],"EfficientLengthIterable":["1"],"Iterable":["1"],"ListBase.E":"1","QueueList.E":"1"},"_CastQueueList":{"QueueList":["2"],"ListBase":["2"],"List":["2"],"Queue":["2"],"EfficientLengthIterable":["2"],"Iterable":["2"],"ListBase.E":"2","QueueList.E":"2"},"UnionSet":{"SetBase":["1"],"Set":["1"],"EfficientLengthIterable":["1"],"Iterable":["1"]},"UnmodifiableSetView0":{"DelegatingSet":["1"],"Set":["1"],"EfficientLengthIterable":["1"],"Iterable":["1"]},"MapKeySet":{"Set":["1"],"EfficientLengthIterable":["1"],"Iterable":["1"]},"_DelegatingIterableBase":{"Iterable":["1"]},"DelegatingSet":{"Set":["1"],"EfficientLengthIterable":["1"],"Iterable":["1"]},"PathException":{"Exception":[]},"PathMap":{"MapView":["String?","1"],"Map":["String?","1"]},"Version":{"VersionRange":[],"Comparable":["VersionRange"]},"VersionRange":{"Comparable":["VersionRange"]},"ModifiableCssAtRule":{"ModifiableCssParentNode":[],"ModifiableCssNode":[],"CssParentNode":[],"CssNode":[],"AstNode":[]},"ModifiableCssComment":{"ModifiableCssNode":[],"CssComment":[],"CssNode":[],"AstNode":[]},"ModifiableCssDeclaration":{"ModifiableCssNode":[],"CssNode":[],"AstNode":[]},"ModifiableCssImport":{"ModifiableCssNode":[],"CssNode":[],"AstNode":[]},"ModifiableCssKeyframeBlock":{"ModifiableCssParentNode":[],"ModifiableCssNode":[],"CssParentNode":[],"CssNode":[],"AstNode":[]},"ModifiableCssMediaRule":{"ModifiableCssParentNode":[],"ModifiableCssNode":[],"CssParentNode":[],"CssNode":[],"AstNode":[]},"ModifiableCssNode":{"CssNode":[],"AstNode":[]},"ModifiableCssParentNode":{"ModifiableCssNode":[],"CssParentNode":[],"CssNode":[],"AstNode":[]},"ModifiableCssStyleRule":{"ModifiableCssParentNode":[],"ModifiableCssNode":[],"CssParentNode":[],"CssNode":[],"AstNode":[]},"ModifiableCssStylesheet":{"ModifiableCssParentNode":[],"CssStylesheet":[],"ModifiableCssNode":[],"CssParentNode":[],"CssNode":[],"AstNode":[]},"ModifiableCssSupportsRule":{"ModifiableCssParentNode":[],"ModifiableCssNode":[],"CssParentNode":[],"CssNode":[],"AstNode":[]},"CssNode":{"AstNode":[]},"CssParentNode":{"CssNode":[],"AstNode":[]},"CssStylesheet":{"CssParentNode":[],"CssNode":[],"AstNode":[]},"CssValue":{"AstNode":[]},"_FakeAstNode":{"AstNode":[]},"ArgumentList":{"AstNode":[]},"ConfiguredVariable":{"AstNode":[]},"Expression":{"AstNode":[]},"BinaryOperationExpression":{"Expression":[],"AstNode":[]},"BooleanExpression":{"Expression":[],"AstNode":[]},"ColorExpression":{"Expression":[],"AstNode":[]},"FunctionExpression":{"Expression":[],"AstNode":[]},"IfConditionExpression":{"AstNode":[]},"IfExpression":{"Expression":[],"AstNode":[]},"IfConditionParenthesized":{"IfConditionExpression":[],"AstNode":[]},"IfConditionNegation":{"IfConditionExpression":[],"AstNode":[]},"IfConditionOperation":{"IfConditionExpression":[],"AstNode":[]},"IfConditionFunction":{"IfConditionExpression":[],"AstNode":[]},"IfConditionSass":{"IfConditionExpression":[],"AstNode":[]},"IfConditionRaw":{"IfConditionExpression":[],"AstNode":[]},"InterpolatedFunctionExpression":{"Expression":[],"AstNode":[]},"LegacyIfExpression":{"Expression":[],"AstNode":[]},"ListExpression":{"Expression":[],"AstNode":[]},"MapExpression":{"Expression":[],"AstNode":[]},"NullExpression":{"Expression":[],"AstNode":[]},"NumberExpression":{"Expression":[],"AstNode":[]},"ParenthesizedExpression":{"Expression":[],"AstNode":[]},"SelectorExpression":{"Expression":[],"AstNode":[]},"StringExpression":{"Expression":[],"AstNode":[]},"SupportsExpression":{"Expression":[],"AstNode":[]},"UnaryOperationExpression":{"Expression":[],"AstNode":[]},"ValueExpression":{"Expression":[],"AstNode":[]},"VariableExpression":{"Expression":[],"AstNode":[]},"DynamicImport":{"Import":[],"AstNode":[]},"StaticImport":{"Import":[],"AstNode":[]},"Interpolation":{"AstNode":[]},"Parameter":{"AstNode":[]},"ParameterList":{"AstNode":[]},"Statement":{"AstNode":[]},"AtRootRule":{"Statement":[],"AstNode":[]},"AtRule":{"Statement":[],"AstNode":[]},"CallableDeclaration":{"Statement":[],"AstNode":[]},"ContentBlock":{"Statement":[],"AstNode":[]},"ContentRule":{"Statement":[],"AstNode":[]},"DebugRule":{"Statement":[],"AstNode":[]},"Declaration":{"Statement":[],"AstNode":[]},"EachRule":{"Statement":[],"AstNode":[]},"ErrorRule":{"Statement":[],"AstNode":[]},"ExtendRule":{"Statement":[],"AstNode":[]},"ForRule":{"Statement":[],"AstNode":[]},"ForwardRule":{"Statement":[],"AstNode":[]},"FunctionRule":{"Statement":[],"AstNode":[]},"IfClause":{"IfRuleClause":[]},"ElseClause":{"IfRuleClause":[]},"IfRule":{"Statement":[],"AstNode":[]},"ImportRule":{"Statement":[],"AstNode":[]},"IncludeRule":{"Statement":[],"AstNode":[]},"LoudComment":{"Statement":[],"AstNode":[]},"MediaRule":{"Statement":[],"AstNode":[]},"MixinRule":{"Statement":[],"AstNode":[]},"_HasContentVisitor":{"StatementSearchVisitor":["bool"],"StatementSearchVisitor.T":"bool"},"ParentStatement":{"Statement":[],"AstNode":[]},"ReturnRule":{"Statement":[],"AstNode":[]},"SilentComment":{"Statement":[],"AstNode":[]},"StyleRule":{"Statement":[],"AstNode":[]},"Stylesheet":{"Statement":[],"AstNode":[]},"SupportsRule":{"Statement":[],"AstNode":[]},"UseRule":{"Statement":[],"AstNode":[]},"VariableDeclaration":{"Statement":[],"AstNode":[]},"WarnRule":{"Statement":[],"AstNode":[]},"WhileRule":{"Statement":[],"AstNode":[]},"SupportsAnything":{"AstNode":[]},"SupportsDeclaration":{"AstNode":[]},"SupportsFunction":{"AstNode":[]},"SupportsInterpolation":{"AstNode":[]},"SupportsNegation":{"AstNode":[]},"SupportsOperation":{"AstNode":[]},"Selector":{"AstNode":[]},"AttributeSelector":{"SimpleSelector":[],"AstNode":[]},"ClassSelector":{"SimpleSelector":[],"AstNode":[]},"ComplexSelector":{"AstNode":[]},"CompoundSelector":{"AstNode":[]},"IDSelector":{"SimpleSelector":[],"AstNode":[]},"SelectorList":{"AstNode":[]},"_ParentSelectorVisitor":{"SelectorSearchVisitor":["ParentSelector"],"SelectorSearchVisitor.T":"ParentSelector"},"ParentSelector":{"SimpleSelector":[],"AstNode":[]},"PlaceholderSelector":{"SimpleSelector":[],"AstNode":[]},"PseudoSelector":{"SimpleSelector":[],"AstNode":[]},"SimpleSelector":{"AstNode":[]},"TypeSelector":{"SimpleSelector":[],"AstNode":[]},"UniversalSelector":{"SimpleSelector":[],"AstNode":[]},"_EnvironmentModule0":{"Module0":["AsyncCallable"]},"AsyncBuiltInCallable":{"AsyncCallable":[]},"BuiltInCallable":{"Callable0":[],"AsyncBuiltInCallable":[],"AsyncCallable":[]},"PlainCssCallable":{"Callable0":[],"AsyncCallable":[]},"UserDefinedCallable":{"Callable0":[],"AsyncCallable":[]},"ExplicitConfiguration":{"Configuration":[]},"_EnvironmentModule":{"Module0":["Callable0"]},"SassRuntimeException":{"Exception":[]},"SassException":{"Exception":[]},"MultiSpanSassException":{"Exception":[]},"MultiSpanSassRuntimeException":{"SassRuntimeException":[],"Exception":[]},"SassFormatException":{"SourceSpanFormatException":[],"FormatException":[],"Exception":[]},"MultiSpanSassFormatException":{"MultiSourceSpanFormatException":[],"SassFormatException":[],"SourceSpanFormatException":[],"FormatException":[],"Exception":[]},"UsageException":{"Exception":[]},"EmptyExtensionStore":{"ExtensionStore":[]},"MergedExtension":{"Extension":[]},"Importer":{"AsyncImporter":[]},"FilesystemImporter":{"Importer":[],"AsyncImporter":[]},"NodePackageImporter":{"Importer":[],"AsyncImporter":[]},"BuiltInModule":{"Module0":["1"]},"ForwardedModuleView":{"Module0":["1"]},"ShadowedModuleView":{"Module0":["1"]},"LazyFileSpan":{"FileSpan":[],"SourceSpanWithContext":[],"SourceSpan":[],"Comparable":["SourceSpan"]},"LimitedMapView":{"MapBase":["1","2"],"_UnmodifiableMapMixin":["1","2"],"Map":["1","2"],"MapBase.K":"1","MapBase.V":"2"},"MergedMapView":{"MapBase":["1","2"],"Map":["1","2"],"MapBase.K":"1","MapBase.V":"2"},"MultiSpan":{"FileSpan":[],"SourceSpanWithContext":[],"SourceSpan":[],"Comparable":["SourceSpan"]},"PrefixedMapView":{"MapBase":["String","1"],"_UnmodifiableMapMixin":["String","1"],"Map":["String","1"],"MapBase.K":"String","MapBase.V":"1"},"_PrefixedKeys":{"Iterable":["String"],"Iterable.E":"String"},"PublicMemberMapView":{"MapBase":["String","1"],"_UnmodifiableMapMixin":["String","1"],"Map":["String","1"],"MapBase.K":"String","MapBase.V":"1"},"UnprefixedMapView":{"MapBase":["String","1"],"_UnmodifiableMapMixin":["String","1"],"Map":["String","1"],"MapBase.K":"String","MapBase.V":"1"},"_UnprefixedKeys":{"Iterable":["String"],"Iterable.E":"String"},"SassArgumentList":{"SassList":[],"Value":[]},"SassBoolean":{"Value":[]},"SassCalculation":{"Value":[]},"SassColor":{"Value":[]},"LinearChannel":{"ColorChannel":[]},"A98RgbColorSpace":{"ColorSpace":[]},"DisplayP3ColorSpace":{"ColorSpace":[]},"DisplayP3LinearColorSpace":{"ColorSpace":[]},"HslColorSpace":{"ColorSpace":[]},"HwbColorSpace":{"ColorSpace":[]},"LabColorSpace":{"ColorSpace":[]},"LchColorSpace":{"ColorSpace":[]},"LmsColorSpace":{"ColorSpace":[]},"OklabColorSpace":{"ColorSpace":[]},"OklchColorSpace":{"ColorSpace":[]},"ProphotoRgbColorSpace":{"ColorSpace":[]},"Rec2020ColorSpace":{"ColorSpace":[]},"RgbColorSpace":{"ColorSpace":[]},"SrgbColorSpace":{"ColorSpace":[]},"SrgbLinearColorSpace":{"ColorSpace":[]},"XyzD50ColorSpace":{"ColorSpace":[]},"XyzD65ColorSpace":{"ColorSpace":[]},"SassFunction":{"Value":[]},"SassList":{"Value":[]},"SassMap":{"Value":[]},"SassMixin":{"Value":[]},"_SassNull":{"Value":[]},"SassNumber":{"Value":[]},"ComplexSassNumber":{"SassNumber":[],"Value":[]},"SingleUnitSassNumber":{"SassNumber":[],"Value":[]},"UnitlessSassNumber":{"SassNumber":[],"Value":[]},"SassString":{"Value":[]},"Entry":{"Comparable":["Entry"]},"FileLocation":{"SourceLocation":[],"Comparable":["SourceLocation"]},"FileSpan":{"SourceSpanWithContext":[],"SourceSpan":[],"Comparable":["SourceSpan"]},"_FileSpan":{"FileSpan":[],"SourceSpanWithContext":[],"SourceSpan":[],"Comparable":["SourceSpan"]},"SourceLocation":{"Comparable":["SourceLocation"]},"SourceLocationMixin":{"SourceLocation":[],"Comparable":["SourceLocation"]},"SourceSpan":{"Comparable":["SourceSpan"]},"SourceSpanBase":{"SourceSpan":[],"Comparable":["SourceSpan"]},"SourceSpanException":{"Exception":[]},"SourceSpanFormatException":{"FormatException":[],"Exception":[]},"MultiSourceSpanException":{"Exception":[]},"MultiSourceSpanFormatException":{"FormatException":[],"Exception":[]},"SourceSpanMixin":{"SourceSpan":[],"Comparable":["SourceSpan"]},"SourceSpanWithContext":{"SourceSpan":[],"Comparable":["SourceSpan"]},"Chain":{"StackTrace":[]},"LazyTrace":{"Trace":[],"StackTrace":[]},"Trace":{"StackTrace":[]},"UnparsedFrame":{"Frame":[]},"StringScannerException":{"SourceSpanFormatException":[],"FormatException":[],"Exception":[]},"A98RgbColorSpace0":{"ColorSpace0":[]},"SupportsAnything0":{"SupportsCondition":[],"SassNode":[],"AstNode0":[]},"ArgumentList0":{"SassNode":[],"AstNode0":[]},"SassArgumentList0":{"SassList0":[],"Value0":[]},"JSToDartAsyncImporter":{"AsyncImporter0":[]},"AsyncBuiltInCallable0":{"AsyncCallable0":[]},"_EnvironmentModule2":{"Module1":["AsyncCallable0"]},"_EvaluateVisitor2":{"StatementVisitor":["Future<Value0?>"],"ExpressionVisitor":["Future<Value0>"],"IfConditionExpressionVisitor":["Future<Object>"]},"JSToDartAsyncFileImporter":{"AsyncImporter0":[]},"AtRootRule0":{"Statement0":[],"SassNode":[],"AstNode0":[]},"ModifiableCssAtRule0":{"ModifiableCssParentNode0":[],"ModifiableCssNode0":[],"CssParentNode0":[],"CssNode0":[],"AstNode0":[]},"AtRule0":{"Statement0":[],"SassNode":[],"AstNode0":[]},"InterpolatedAttributeSelector":{"InterpolatedSimpleSelector":[],"InterpolatedSelector":[],"SassNode":[],"AstNode0":[]},"AttributeSelector0":{"SimpleSelector0":[],"AstNode0":[]},"BinaryOperationExpression0":{"Expression0":[],"SassNode":[],"AstNode0":[]},"BooleanExpression0":{"Expression0":[],"SassNode":[],"AstNode0":[]},"SassBoolean0":{"Value0":[]},"BuiltInCallable0":{"Callable":[],"AsyncBuiltInCallable0":[],"AsyncCallable0":[]},"BuiltInModule0":{"Module1":["1"]},"SassCalculation0":{"Value0":[]},"CallableDeclaration0":{"Statement0":[],"SassNode":[],"AstNode0":[]},"LinearChannel0":{"ColorChannel0":[]},"InterpolatedClassSelector":{"InterpolatedSimpleSelector":[],"InterpolatedSelector":[],"SassNode":[],"AstNode0":[]},"ClassSelector0":{"SimpleSelector0":[],"AstNode0":[]},"ColorExpression0":{"Expression0":[],"SassNode":[],"AstNode0":[]},"SassColor0":{"Value0":[]},"ModifiableCssComment0":{"ModifiableCssNode0":[],"CssComment0":[],"CssNode0":[],"AstNode0":[]},"AsyncCompiler":{"Compiler":[]},"InterpolatedComplexSelector":{"InterpolatedSelector":[],"SassNode":[],"AstNode0":[]},"ComplexSassNumber0":{"SassNumber0":[],"Value0":[]},"ComplexSelector0":{"AstNode0":[]},"InterpolatedComplexSelectorComponent":{"SassNode":[],"AstNode0":[]},"InterpolatedCompoundSelector":{"InterpolatedSelector":[],"SassNode":[],"AstNode0":[]},"CompoundSelector0":{"AstNode0":[]},"ExplicitConfiguration0":{"Configuration0":[]},"ConfiguredVariable0":{"SassNode":[],"AstNode0":[]},"ContentBlock0":{"Statement0":[],"SassNode":[],"AstNode0":[]},"ContentRule0":{"Statement0":[],"SassNode":[],"AstNode0":[]},"DebugRule0":{"Statement0":[],"SassNode":[],"AstNode0":[]},"ModifiableCssDeclaration0":{"ModifiableCssNode0":[],"CssNode0":[],"AstNode0":[]},"Declaration0":{"Statement0":[],"SassNode":[],"AstNode0":[]},"SupportsDeclaration0":{"SupportsCondition":[],"SassNode":[],"AstNode0":[]},"DisplayP3ColorSpace0":{"ColorSpace0":[]},"DisplayP3LinearColorSpace0":{"ColorSpace0":[]},"DynamicImport0":{"Import0":[],"SassNode":[],"AstNode0":[]},"EachRule0":{"Statement0":[],"SassNode":[],"AstNode0":[]},"EmptyExtensionStore0":{"ExtensionStore0":[]},"_EnvironmentModule1":{"Module1":["Callable"]},"ErrorRule0":{"Statement0":[],"SassNode":[],"AstNode0":[]},"_EvaluateVisitor1":{"StatementVisitor":["Value0?"],"ExpressionVisitor":["Value0"],"IfConditionExpressionVisitor":["Object"]},"SassRuntimeException0":{"Exception":[]},"SassException0":{"Exception":[]},"MultiSpanSassException0":{"Exception":[]},"MultiSpanSassRuntimeException0":{"SassRuntimeException0":[],"Exception":[]},"SassFormatException0":{"SourceSpanFormatException":[],"FormatException":[],"Exception":[]},"MultiSpanSassFormatException0":{"MultiSourceSpanFormatException":[],"SassFormatException0":[],"SourceSpanFormatException":[],"FormatException":[],"Exception":[]},"Expression0":{"SassNode":[],"AstNode0":[]},"JSExpressionVisitor":{"ExpressionVisitor":["Object?"]},"_MakeExpressionCalculationSafe0":{"ExpressionVisitor":["Expression0"],"IfConditionExpressionVisitor":["IfConditionExpression0"]},"ExtendRule0":{"Statement0":[],"SassNode":[],"AstNode0":[]},"JSToDartFileImporter":{"Importer0":[],"AsyncImporter0":[]},"FilesystemImporter0":{"Importer0":[],"AsyncImporter0":[]},"ForRule0":{"Statement0":[],"SassNode":[],"AstNode0":[]},"ForwardRule0":{"Statement0":[],"SassNode":[],"AstNode0":[]},"ForwardedModuleView0":{"Module1":["1"]},"FunctionExpression0":{"Expression0":[],"SassNode":[],"AstNode0":[]},"SupportsFunction0":{"SupportsCondition":[],"SassNode":[],"AstNode0":[]},"SassFunction0":{"Value0":[]},"FunctionRule0":{"Statement0":[],"SassNode":[],"AstNode0":[]},"HslColorSpace0":{"ColorSpace0":[]},"HwbColorSpace0":{"ColorSpace0":[]},"InterpolatedIDSelector":{"InterpolatedSimpleSelector":[],"InterpolatedSelector":[],"SassNode":[],"AstNode0":[]},"IDSelector0":{"SimpleSelector0":[],"AstNode0":[]},"IfConditionExpression0":{"SassNode":[],"AstNode0":[]},"IfConditionFunction0":{"IfConditionExpression0":[],"SassNode":[],"AstNode0":[]},"IfExpression0":{"Expression0":[],"SassNode":[],"AstNode0":[]},"IfConditionParenthesized0":{"IfConditionExpression0":[],"SassNode":[],"AstNode0":[]},"IfConditionNegation0":{"IfConditionExpression0":[],"SassNode":[],"AstNode0":[]},"IfConditionOperation0":{"IfConditionExpression0":[],"SassNode":[],"AstNode0":[]},"IfConditionSass0":{"IfConditionExpression0":[],"SassNode":[],"AstNode0":[]},"IfConditionRaw0":{"IfConditionExpression0":[],"SassNode":[],"AstNode0":[]},"JSIfConditionExpressionVisitor":{"IfConditionExpressionVisitor":["Object?"]},"IfClause0":{"IfRuleClause0":[]},"ElseClause0":{"IfRuleClause0":[]},"IfRule0":{"Statement0":[],"SassNode":[],"AstNode0":[]},"ModifiableCssImport0":{"ModifiableCssNode0":[],"CssNode0":[],"AstNode0":[]},"ImportRule0":{"Statement0":[],"SassNode":[],"AstNode0":[]},"Importer0":{"AsyncImporter0":[]},"IncludeRule0":{"Statement0":[],"SassNode":[],"AstNode0":[]},"InterpolatedFunctionExpression0":{"Expression0":[],"SassNode":[],"AstNode0":[]},"InterpolatedSelector":{"SassNode":[],"AstNode0":[]},"Interpolation0":{"SassNode":[],"AstNode0":[]},"SupportsInterpolation0":{"SupportsCondition":[],"SassNode":[],"AstNode0":[]},"IsCalculationSafeVisitor0":{"ExpressionVisitor":["bool"]},"IsPlainCssVisitor0":{"ExpressionVisitor":["bool"],"IfConditionExpressionVisitor":["bool"]},"ModifiableCssKeyframeBlock0":{"ModifiableCssParentNode0":[],"ModifiableCssNode0":[],"CssParentNode0":[],"CssNode0":[],"AstNode0":[]},"LabColorSpace0":{"ColorSpace0":[]},"LazyFileSpan0":{"FileSpan":[],"SourceSpanWithContext":[],"SourceSpan":[],"Comparable":["SourceSpan"]},"LchColorSpace0":{"ColorSpace0":[]},"LegacyIfExpression0":{"Expression0":[],"SassNode":[],"AstNode0":[]},"LimitedMapView0":{"MapBase":["1","2"],"_UnmodifiableMapMixin":["1","2"],"Map":["1","2"],"MapBase.K":"1","MapBase.V":"2"},"ListExpression0":{"Expression0":[],"SassNode":[],"AstNode0":[]},"InterpolatedSelectorList":{"InterpolatedSelector":[],"SassNode":[],"AstNode0":[]},"SelectorList0":{"AstNode0":[]},"_ParentSelectorVisitor0":{"SelectorSearchVisitor0":["ParentSelector0"],"SelectorSearchVisitor0.T":"ParentSelector0"},"SassList0":{"Value0":[]},"LmsColorSpace0":{"ColorSpace0":[]},"LoudComment0":{"Statement0":[],"SassNode":[],"AstNode0":[]},"MapExpression0":{"Expression0":[],"SassNode":[],"AstNode0":[]},"SassMap0":{"Value0":[]},"ModifiableCssMediaRule0":{"ModifiableCssParentNode0":[],"ModifiableCssNode0":[],"CssParentNode0":[],"CssNode0":[],"AstNode0":[]},"MediaRule0":{"Statement0":[],"SassNode":[],"AstNode0":[]},"MergedExtension0":{"Extension0":[]},"MergedMapView0":{"MapBase":["1","2"],"Map":["1","2"],"MapBase.K":"1","MapBase.V":"2"},"SassMixin0":{"Value0":[]},"MixinRule0":{"Statement0":[],"SassNode":[],"AstNode0":[]},"_HasContentVisitor0":{"StatementSearchVisitor0":["bool"],"StatementVisitor":["bool?"],"StatementSearchVisitor0.T":"bool"},"MultiSpan0":{"FileSpan":[],"SourceSpanWithContext":[],"SourceSpan":[],"Comparable":["SourceSpan"]},"SupportsNegation0":{"SupportsCondition":[],"SassNode":[],"AstNode0":[]},"NoOpImporter0":{"Importer0":[],"AsyncImporter0":[]},"_FakeAstNode0":{"AstNode0":[]},"CssNode0":{"AstNode0":[]},"CssParentNode0":{"CssNode0":[],"AstNode0":[]},"ModifiableCssNode0":{"CssNode0":[],"AstNode0":[]},"ModifiableCssParentNode0":{"ModifiableCssNode0":[],"CssParentNode0":[],"CssNode0":[],"AstNode0":[]},"NodePackageImporter0":{"Importer0":[],"AsyncImporter0":[]},"NullExpression0":{"Expression0":[],"SassNode":[],"AstNode0":[]},"_SassNull0":{"Value0":[]},"NumberExpression0":{"Expression0":[],"SassNode":[],"AstNode0":[]},"SassNumber0":{"Value0":[]},"OklabColorSpace0":{"ColorSpace0":[]},"OklchColorSpace0":{"ColorSpace0":[]},"SupportsOperation0":{"SupportsCondition":[],"SassNode":[],"AstNode0":[]},"Parameter0":{"SassNode":[],"AstNode0":[]},"ParameterList0":{"SassNode":[],"AstNode0":[]},"InterpolatedParentSelector":{"InterpolatedSimpleSelector":[],"InterpolatedSelector":[],"SassNode":[],"AstNode0":[]},"ParentSelector0":{"SimpleSelector0":[],"AstNode0":[]},"ParentStatement0":{"Statement0":[],"SassNode":[],"AstNode0":[]},"ParenthesizedExpression0":{"Expression0":[],"SassNode":[],"AstNode0":[]},"InterpolatedPlaceholderSelector":{"InterpolatedSimpleSelector":[],"InterpolatedSelector":[],"SassNode":[],"AstNode0":[]},"PlaceholderSelector0":{"SimpleSelector0":[],"AstNode0":[]},"PlainCssCallable0":{"Callable":[],"AsyncCallable0":[]},"PrefixedMapView0":{"MapBase":["String","1"],"_UnmodifiableMapMixin":["String","1"],"Map":["String","1"],"MapBase.K":"String","MapBase.V":"1"},"_PrefixedKeys0":{"Iterable":["String"],"Iterable.E":"String"},"ProphotoRgbColorSpace0":{"ColorSpace0":[]},"InterpolatedPseudoSelector":{"InterpolatedSimpleSelector":[],"InterpolatedSelector":[],"SassNode":[],"AstNode0":[]},"PseudoSelector0":{"SimpleSelector0":[],"AstNode0":[]},"PublicMemberMapView0":{"MapBase":["String","1"],"_UnmodifiableMapMixin":["String","1"],"Map":["String","1"],"MapBase.K":"String","MapBase.V":"1"},"InterpolatedQualifiedName":{"SassNode":[],"AstNode0":[]},"Rec2020ColorSpace0":{"ColorSpace0":[]},"ReturnRule0":{"Statement0":[],"SassNode":[],"AstNode0":[]},"RgbColorSpace0":{"ColorSpace0":[]},"Selector0":{"AstNode0":[]},"SelectorExpression0":{"Expression0":[],"SassNode":[],"AstNode0":[]},"ShadowedModuleView0":{"Module1":["1"]},"SilentComment0":{"Statement0":[],"SassNode":[],"AstNode0":[]},"InterpolatedSimpleSelector":{"InterpolatedSelector":[],"SassNode":[],"AstNode0":[]},"SimpleSelector0":{"AstNode0":[]},"JSSimpleSelectorVisitor":{"InterpolatedSelectorVisitor":["Object?"]},"SingleUnitSassNumber0":{"SassNumber0":[],"Value0":[]},"SourceInterpolationVisitor":{"ExpressionVisitor":["~"],"IfConditionExpressionVisitor":["~"]},"SrgbColorSpace0":{"ColorSpace0":[]},"SrgbLinearColorSpace0":{"ColorSpace0":[]},"Statement0":{"SassNode":[],"AstNode0":[]},"JSStatementVisitor":{"StatementVisitor":["Object?"]},"StaticImport0":{"Import0":[],"SassNode":[],"AstNode0":[]},"StringExpression0":{"Expression0":[],"SassNode":[],"AstNode0":[]},"SassString0":{"Value0":[]},"ModifiableCssStyleRule0":{"ModifiableCssParentNode0":[],"ModifiableCssNode0":[],"CssParentNode0":[],"CssNode0":[],"AstNode0":[]},"StyleRule0":{"Statement0":[],"SassNode":[],"AstNode0":[]},"CssStylesheet0":{"CssParentNode0":[],"CssNode0":[],"AstNode0":[]},"ModifiableCssStylesheet0":{"ModifiableCssParentNode0":[],"CssStylesheet0":[],"ModifiableCssNode0":[],"CssParentNode0":[],"CssNode0":[],"AstNode0":[]},"Stylesheet0":{"Statement0":[],"SassNode":[],"AstNode0":[]},"SupportsExpression0":{"Expression0":[],"SassNode":[],"AstNode0":[]},"ModifiableCssSupportsRule0":{"ModifiableCssParentNode0":[],"ModifiableCssNode0":[],"CssParentNode0":[],"CssNode0":[],"AstNode0":[]},"SupportsRule0":{"Statement0":[],"SassNode":[],"AstNode0":[]},"JSToDartImporter":{"Importer0":[],"AsyncImporter0":[]},"InterpolatedTypeSelector":{"InterpolatedSimpleSelector":[],"InterpolatedSelector":[],"SassNode":[],"AstNode0":[]},"TypeSelector0":{"SimpleSelector0":[],"AstNode0":[]},"UnaryOperationExpression0":{"Expression0":[],"SassNode":[],"AstNode0":[]},"UnitlessSassNumber0":{"SassNumber0":[],"Value0":[]},"InterpolatedUniversalSelector":{"InterpolatedSimpleSelector":[],"InterpolatedSelector":[],"SassNode":[],"AstNode0":[]},"UniversalSelector0":{"SimpleSelector0":[],"AstNode0":[]},"UnprefixedMapView0":{"MapBase":["String","1"],"_UnmodifiableMapMixin":["String","1"],"Map":["String","1"],"MapBase.K":"String","MapBase.V":"1"},"_UnprefixedKeys0":{"Iterable":["String"],"Iterable.E":"String"},"UseRule0":{"Statement0":[],"SassNode":[],"AstNode0":[]},"UserDefinedCallable0":{"Callable":[],"AsyncCallable0":[]},"CssValue0":{"AstNode0":[]},"ValueExpression0":{"Expression0":[],"SassNode":[],"AstNode0":[]},"VariableExpression0":{"Expression0":[],"SassNode":[],"AstNode0":[]},"VariableDeclaration0":{"Statement0":[],"SassNode":[],"AstNode0":[]},"WarnRule0":{"Statement0":[],"SassNode":[],"AstNode0":[]},"WhileRule0":{"Statement0":[],"SassNode":[],"AstNode0":[]},"XyzD50ColorSpace0":{"ColorSpace0":[]},"XyzD65ColorSpace0":{"ColorSpace0":[]},"Int8List":{"List":["int"],"EfficientLengthIterable":["int"],"Iterable":["int"]},"Uint8List":{"List":["int"],"EfficientLengthIterable":["int"],"Iterable":["int"]},"Uint8ClampedList":{"List":["int"],"EfficientLengthIterable":["int"],"Iterable":["int"]},"Int16List":{"List":["int"],"EfficientLengthIterable":["int"],"Iterable":["int"]},"Uint16List":{"List":["int"],"EfficientLengthIterable":["int"],"Iterable":["int"]},"Int32List":{"List":["int"],"EfficientLengthIterable":["int"],"Iterable":["int"]},"Uint32List":{"List":["int"],"EfficientLengthIterable":["int"],"Iterable":["int"]},"Float32List":{"List":["double"],"EfficientLengthIterable":["double"],"Iterable":["double"]},"Float64List":{"List":["double"],"EfficientLengthIterable":["double"],"Iterable":["double"]},"CssComment":{"CssNode":[],"AstNode":[]},"Import":{"AstNode":[]},"Callable0":{"AsyncCallable":[]},"Callable":{"AsyncCallable0":[]},"CssComment0":{"CssNode0":[],"AstNode0":[]},"Import0":{"SassNode":[],"AstNode0":[]},"SassNode":{"AstNode0":[]},"SupportsCondition":{"SassNode":[],"AstNode0":[]}}'));
        A._Universe_addErasedTypes(init.typeUniverse, JSON.parse('{"WhereIterator":1,"SkipIterator":1,"SkipWhileIterator":1,"EmptyIterator":1,"FollowedByIterator":1,"NonNullsIterator":1,"FixedLengthListMixin":1,"UnmodifiableListMixin":1,"UnmodifiableListBase":1,"__CastListBase__CastIterableBase_ListMixin":2,"ConstantSet":1,"LinkedHashMapKeyIterator":1,"LinkedHashMapValueIterator":1,"NativeTypedArray":1,"EventSink":1,"_SyncStarIterator":1,"_SyncStreamControllerDispatch":1,"_AsyncStreamControllerDispatch":1,"_AddStreamState":1,"_StreamControllerAddStreamState":1,"_DelayedEvent":1,"_DelayedData":1,"_PendingEvents":1,"_StreamIterator":1,"_ZoneFunction":1,"Queue":1,"UnmodifiableMapBase":2,"_UnmodifiableSetMixin":1,"_UnmodifiableMapView_MapView__UnmodifiableMapMixin":2,"_UnmodifiableSetView_SetBase__UnmodifiableSetMixin":1,"_StringSinkConversionSink":1,"Expando":1,"_EventRequest":1,"_EmptyUnmodifiableSet_IterableBase_UnmodifiableSetMixin":1,"DefaultEquality":1,"IterableEquality":1,"ListEquality":1,"_QueueList_Object_ListMixin":1,"_UnionSet_SetBase_UnmodifiableSetMixin":1,"UnmodifiableSetMixin":1,"_UnmodifiableSetView_DelegatingSet_UnmodifiableSetMixin":1,"_DelegatingIterableBase":1,"_MapKeySet__DelegatingIterableBase_UnmodifiableSetMixin":1,"ParentStatement":1,"ParentStatement0":1,"ExpressionVisitor":1,"IfConditionExpressionVisitor":1,"InterpolatedSelectorVisitor":1}'));
        var string$ = {
            x00_____: "\x00\x00\x00\x00\x00\x00\x00\x00\x00\x00\x00\x00\x00\x00\x00\x00\x00\x00\x00\x00\x00\x00\x00\x00\x00\x00\x00\x00\x00\x00\x00\x00\x00\u03f6\x00\u0404\u03f4 \u03f4\u03f6\u01f6\u01f6\u03f6\u03fc\u01f4\u03ff\u03ff\u0584\u03ff\u03ff\u03ff\u03ff\u03ff\u03ff\u03ff\u03ff\u03ff\u03ff\u05d4\u01f4\x00\u01f4\x00\u0504\u05c4\u03ff\u03ff\u03ff\u03ff\u03ff\u03ff\u03ff\u03ff\u03ff\u03ff\u03ff\u03ff\u03ff\u03ff\u03ff\u03ff\u03ff\u03ff\u03ff\u03ff\u03ff\u03ff\u03ff\u03ff\u03ff\u03ff\u0400\x00\u0400\u0200\u03f7\u0200\u03ff\u03ff\u03ff\u03ff\u03ff\u03ff\u03ff\u03ff\u03ff\u03ff\u03ff\u03ff\u03ff\u03ff\u03ff\u03ff\u03ff\u03ff\u03ff\u03ff\u03ff\u03ff\u03ff\u03ff\u03ff\u03ff\u0200\u0200\u0200\u03f7\x00",
            x0a_BUG_: "\n\nBUG: This should include a source span!",
            x0a_Morex20: "\n\nMore info and automated migrator: https://sass-lang.com/d/slash-div",
            x0a_Morex3aa: "\n\nMore info: https://sass-lang.com/d/adjacent-compounds",
            x0a_Morex3ac: "\n\nMore info: https://sass-lang.com/d/color-functions",
            x0a_Morex3af: "\n\nMore info: https://sass-lang.com/d/function-units",
            x0a_See_: "\n\nSee https://sass-lang.com/d/function-units",
            x0a_This: "\n\nThis is only an error because you've set the ",
            x0a_To_p: "\n\nTo preserve current behavior: math.random(math.div($limit, 1",
            x0a_but_: "\n\nbut you may have intended it to mean:\n\n    ",
            x0aRun_i: "\nRun in verbose mode to see all warnings.",
            x0aThis_: "\nThis will be an error in Dart Sass 2.0.0.\n\nMore info: https://sass-lang.com/d/bogus-combinators",
            x0aYou_m: "\nYou may not @extend the same selector from within different media queries.",
            x20It_wi: " It will be omitted from the generated CSS.",
            x20be_an: " be an extender.\nThis will be an error in Dart Sass 2.0.0.\n\nMore info: https://sass-lang.com/d/bogus-combinators",
            x20can_n: " can not have both conditions and paths at the same level.\nFound ",
            x20deprex20ix2c: " deprecation is obsolete, so does not need to be made fatal.",
            x20deprex20ix2e: " deprecation is obsolete. If you were previously silencing it, your code may now behave in unexpected ways.",
            x20deprex20t: " deprecation to be fatal.\nRemove this setting if you need to keep using this feature.",
            x20deprex2c: " deprecation, since it has also been made fatal.",
            x20hue__: ' hue" may not be set for rectangular color space ',
            x20in_in: " in interpolation here.\nIt may end up represented as ",
            x20inste: " instead.\n\nMore info and automated migrator: https://sass-lang.com/d/import",
            x20is_as: " is asynchronous.\nThis is probably caused by a bug in a Sass plugin.",
            x20is_av: " is available from multiple global modules.",
            x20is_de: " is deprecated.\n\nTo preserve current behavior: ",
            x20is_noaf: " is not a future deprecation, so it does not need to be explicitly enabled.",
            x20is_noav: " is not a valid selector: it must be a string,\na list of strings, or a list of lists of strings.",
            x20is_nov: " is not valid CSS.\nThis will be an error in Dart Sass 2.0.0.\n\nMore info: https://sass-lang.com/d/bogus-combinators",
            x20must_b: " must be either nearest, up, down or to-zero.",
            x20must_e: " must end with an arbitrary substitution or ",
            x20must_n: " must not be greater than the number of characters in the file, ",
            x20repet: " repetitive deprecation warnings omitted.",
            x20to_be: " to be in the legacy RGB, HSL, or HWB color space.",
            x20to_be_: " to be in the legacy RGB, HSL, or HWB color space.\n\nRecommendation: color.change(",
            x20to_cl: " to clarify that it's meant to be a binary operation, or wrap\nit in parentheses to make it a unary operation. This will be an error in future\nversions of Sass.\n\nMore info and automated migrator: https://sass-lang.com/d/strict-unary",
            x20to_co: " to color.opacity() is deprecated.\n\nRecommendation: ",
            x20was_a: ' was already loaded, so it can\'t be configured using "with".',
            x20was_n: " was not declared with !default in the @used module.",
            x20was_p: " was passed both by position and by name.",
            x21defau: "!default should only be written once for each variable.\nThis will be an error in Dart Sass 2.0.0.",
            x21globai: "!global isn't allowed for variables in other modules.",
            x21globas: "!global should only be written once for each variable.\nThis will be an error in Dart Sass 2.0.0.",
            x22x20can_: "\" can't be used as a parent in a compound selector.",
            x22x20is_ix0a: '" is invalid CSS.\nThis will be an error in Dart Sass 2.0.0.\n\nMore info: https://sass-lang.com/d/bogus-combinators',
            x22x20is_ix20: '" is invalid CSS. It will be omitted from the generated CSS.\nThis will be an error in Dart Sass 2.0.0.\n\nMore info: https://sass-lang.com/d/bogus-combinators',
            x22x20is_n: '" is not a valid Sass identifier.\n\nRecommendation: add an "as" clause to define an explicit namespace.',
            x22x20is_o: "\" is only valid for nesting and shouldn't\nhave children other than style rules.",
            x22x26__ma: '"&" may only used at the beginning of a compound selector.',
            x22x29__If: "\").\nIf you really want to use the color value here, use '",
            x22x2b__an: '"+" and "-" must be surrounded by whitespace in calculations.',
            x22packa: '"package:" URLs aren\'t supported on this platform.',
            x24color: "$color1, $color2, $weight: 50%, $method: null",
            x24css_a: "$css and $module may not both be passed at once.",
            x24list1: "$list1, $list2, $separator: auto, $bracketed: auto",
            x24selec: "$selectors: At least one selector must be passed.",
            x24separ: '$separator: Must be "space", "comma", "slash", or "auto".',
            x27x20must: "' must be a path relative to the package root at '",
            x27x2c_whi: "', which is not a '.scss', '.sass', or '.css' file.",
            x28__cal: "() calculation. This doesn't allow unitless numbers to be mixed with numbers with units. If you want to use the Sass function, call math.",
            x28__fun: "() functions will no longer have special parsing in a future release of Dart Sass. Once that happens, this argument will ",
            x28__ins: "() instead.\n\nSee https://sass-lang.com/d/import",
            x28__is_d: '() is deprecated. Suggestion:\n\ncolor.channel($color, "',
            x28__is_oa: "() is only supported for legacy colors. Please use color.adjust() instead with an explicit $space argument.",
            x28__is_oc: "() is only supported for legacy colors. Please use color.channel() instead with an explicit $space argument.",
            x28__isn: "() isn't in the sass:color module.\n\nRecommendation: color.adjust(",
            x29x0a_Mor_: ")\n\nMore info: https://sass-lang.com/d/color-functions",
            x29x0a_Moro: ")\n\nMore info: https://sass-lang.com/documentation/functions/color#",
            x29x20in_a: ") in a future release.\n\nRecommendation: math.random(math.div($limit, 1",
            x29x20is_d_: ") is deprecated.\n\nTo preserve current behavior: ",
            x29x20is_dT: ") is deprecated.\nThis will be an error in Dart Sass 2.0.0.",
            x29x20to_clg: ") to color.grayscale() is deprecated.\n\nRecommendation: ",
            x29x20to_cli: ") to color.invert() is deprecated.\n\nRecommendation: ",
            x29x20to_cm: ") to compileString() or related functions is deprecated and will be an error in Dart Sass 2.0.0.",
            x29x29__Mo: "))\n\nMore info: https://sass-lang.com/d/function-units",
            x2c_whicu: ", which uses a scheme declared as non-canonical.",
            x2c_whicw: ', which will likely produce invalid CSS.\nAlways quote color names when using them as strings or map keys (for example, "',
            x2e_Rela: ".\nRelative canonical URLs are deprecated and will eventually be disallowed.",
            x3d_____: "===== asynchronous gap ===========================\n",
            x40_moz_: "@-moz-document is deprecated and support will be removed in Dart Sass 2.0.0.\n\nFor details, see https://sass-lang.com/d/moz-document.",
            x40conte: "@content is only allowed within mixin declarations.",
            x40elsei: "@elseif is deprecated and will not be supported in future Sass versions.\n\nRecommendation: @else if",
            x40exten: "@extend may only be used within style rules.",
            x40forwa: "@forward rules must be written before any other rules.",
            x40funct: "@function if($condition, $if-true, $if-false) {",
            x40use_r: "@use rules must be written before any other rules.",
            A_list: "A list with more than one element must have an explicit separator.",
            A_pkg_h: "A pkg: URL must not have a host, port, username or password.",
            A_pkg_q: "A pkg: URL must not have a query or fragment.",
            A_top_: "A top-level selector may not contain a parent selector with a suffix.",
            ABCDEF: "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/",
            Adjace: "Adjacent compound selectors must be separated by whitespace. This will be an error in Dart Sass 2.0.0. Suggestion:\n\n",
            An_impa: "An importer may not have a findFileUrl method as well as canonicalize and load methods.",
            An_impu: "An importer must have either canonicalize and load methods, or a findFileUrl method.",
            As_of_R: "As of Dart Sass 2.0.0, !global assignments won't be able to declare new variables.\n\nRecommendation: add `",
            As_of_S: "As of Dart Sass 2.0.0, !global assignments won't be able to declare new variables.\n\nSince this assignment is at the root of the stylesheet, the !global flag is\nunnecessary and can safely be removed.",
            At_rul: "At-rules may not be used within nested declarations.",
            Becaus: "Because the CSS working group is still deciding on the best behavior, Sass doesn't currently support modifying missing channels (color: ",
            Cannotff: "Cannot extract a file path from a URI with a fragment component",
            Cannotfq: "Cannot extract a file path from a URI with a query component",
            Cannotn: "Cannot extract a non-Windows file path from a file URI with an authority",
            Comple: "ComplexSassNumber.hasPossiblyCompatibleUnits is not implemented.",
            Config: "Configuring private variables is deprecated.\nThis will be an error in Dart Sass 2.0.0.",
            Could_: 'Could not find an option with short name "-',
            CssNod: "CssNodes must have a CssStylesheet transitive parent node.",
            Customf: "Custom functions with this name are deprecated and will be removed in a future\nrelease. Please choose a different name.\nMore info: https://sass-lang.com/d/function-name",
            Customi: "Custom importers are required to load stylesheets when compiling in the browser.",
            Declarm: "Declarations may only be used within style rules.",
            Declarp: "Declarations parsed as raw CSS may not be nested.",
            Declarw: 'Declarations whose names begin with "--" may not be nested.',
            Either: "Either options.data or options.file must be set.",
            Entrie: "Entries may not be removed from MergedMapView.",
            Error_: "Error handler must accept one Object or one Object and a StackTrace as arguments, and return a value of the returned future's type",
            Evalua: "Evaluation handles @include and its content block together.",
            Expecta: "Expected a color interpolation method, got an empty list.",
            Expectu: 'Expected unquoted string "hue" at the end of ',
            Expectv: "Expected variable, mixin, or function name",
            Functi: "Functions may not be declared in control directives.",
            Global: "Global built-in functions are deprecated and will be removed in Dart Sass 3.0.0.\nUse ",
            Globalcad: "Global built-in functions are deprecated and will be removed in Dart Sass 3.0.0.\nUse color.adjust instead.\n\nMore info and automated migrator: https://sass-lang.com/d/import",
            Globalcal: "Global built-in functions are deprecated and will be removed in Dart Sass 3.0.0.\nUse color.alpha instead.\n\nMore info and automated migrator: https://sass-lang.com/d/import",
            Globalcg: "Global built-in functions are deprecated and will be removed in Dart Sass 3.0.0.\nUse color.grayscale instead.\n\nMore info and automated migrator: https://sass-lang.com/d/import",
            Globalci: "Global built-in functions are deprecated and will be removed in Dart Sass 3.0.0.\nUse color.invert instead.\n\nMore info and automated migrator: https://sass-lang.com/d/import",
            Globalco: "Global built-in functions are deprecated and will be removed in Dart Sass 3.0.0.\nUse color.opacity instead.\n\nMore info and automated migrator: https://sass-lang.com/d/import",
            Globalm: "Global built-in functions are deprecated and will be removed in Dart Sass 3.0.0.\nUse math.abs instead.\n\nMore info and automated migrator: https://sass-lang.com/d/import",
            Hue_in: "Hue interpolation method may not be set for rectangular color space ",
            If_con: "If conditions is longer than one element, conjunction may not be null.",
            If_par: "If parsedAsSassScript is false, value must contain a SassString (was `",
            If_str: "If strategy is not null, step is required.",
            In_Sas: 'In Sass, "&&" means two copies of the parent selector. You probably want to use "and" instead.',
            In_fut: "In future versions of Sass, round() will be interpreted as a CSS round() calculation. This requires an explicit modulus when rounding numbers with units. If you want to use the Sass function, call math.round() instead.\n\nSee https://sass-lang.com/d/import",
            Indent: "Indenting at the beginning of the document is illegal.",
            Interpn: "Interpolation isn't allowed in namespaces.",
            Interpp: "Interpolation isn't allowed in plain CSS.",
            Invali: 'Invalid return value for custom function "',
            It_s_n: "It's not clear which file to import. Found:\n",
            Keywor: "Keyword arguments can't be used with calculations.",
            May_no: "May not have a value for string elements (at index ",
            Media_: "Media rules may not be used within nested declarations.",
            Mixinsb: "Mixins may not be declared in control directives.",
            Mixinscf: "Mixins may not contain function declarations.",
            Mixinscm: "Mixins may not contain mixin declarations.",
            Modulel: "Module loop: this module is already being loaded.",
            Modulen: "Module namespaces aren't allowed in plain CSS.",
            More_i: "More info: https://sass-lang.com/d/if-function",
            Must_n: "Must not have a value for expression elements (at index ",
            Named_: "Named arguments must come before rest arguments.\nThis will be an error in Dart Sass 2.0.0.",
            Nested: "Nested declarations aren't allowed in plain CSS.",
            New_en: "New entries may not be added to MergedMapView.",
            No_Sasc: "No Sass callable is currently being evaluated.",
            No_Sass: "No Sass stylesheet is currently being evaluated.",
            NoSour: "NoSourceMapBuffer.buildSourceMap() is not supported.",
            Number: "Number to round and step arguments are required.",
            Only_2: "Only 2 slash-separated elements allowed, but ",
            Only_oa: "Only one argument may be passed to the plain-CSS invert() function.",
            Only_op: "Only one positional argument is allowed. All other arguments must be passed by name.",
            Other_: "Other modules' members can't be defined with !global.",
            Parent: "Parent selectors can't have suffixes in plain CSS.",
            Passin_: "Passing `alpha: null` without setting `space` is deprecated.\nMore info: https://sass-lang.com/d/null-alpha",
            Passina: "Passing a string to call() is deprecated and will be illegal in Dart Sass 2.0.0.\n\nRecommendation: call(get-function(",
            Passinp: "Passing percentage units to the global abs() function is deprecated.\nIn the future, this will emit a CSS abs() function to be resolved by the browser.\nTo preserve current behavior: math.abs(",
            Placeh: "Placeholder selectors aren't allowed in plain CSS.",
            Plain_: "Plain CSS functions don't support keyword arguments.",
            Positik: "Positional arguments must come before keyword arguments.",
            Positir: "Positional arguments must come before rest arguments.\nThis will be an error in Dart Sass 2.0.0.",
            Privat: "Private members can't be accessed from outside their modules.",
            Rest_a: "Rest arguments can't be used with calculations.",
            Sass__i: "Sass @import rules are deprecated and will be removed in Dart Sass 3.0.0.\n\nMore info and automated migrator: https://sass-lang.com/d/import",
            Sass__m: "Sass @mixin names beginning with -- are forbidden for forward-compatibility with plain CSS mixins.\n\nFor details, see https://sass-lang.com/d/css-function-mixin",
            Sass_v: "Sass variables aren't allowed in plain CSS.",
            Silent: "Silent comments aren't allowed in plain CSS.",
            Style_k: "Style rules may not be used within keyframe blocks.",
            Style_n: "Style rules may not be used within nested declarations.",
            Suppor: "Supports rules may not be used within nested declarations.",
            The_Ex: "The ExtensionStore and CssStylesheet passed to cloneCssStylesheet() must come from the same compilation.",
            The_No: "The Node package importer cannot be used without a filesystem.",
            The_Sa: "The Sass if() syntax is deprecated in favor of the modern CSS syntax.\n\n",
            The_ca: "The canonicalize() method must return a URL.",
            The_co: "The color() function doesn't support the color space ",
            The_fe: "The feature-exists() function is deprecated.\n\nMore info: https://sass-lang.com/d/feature-exists",
            The_fie: "The findFileUrl() method must return a URL.",
            The_fiu: 'The findFileUrl() must return a URL with scheme file://, was "',
            The_le: "The legacy JS API is deprecated and will be removed in Dart Sass 2.0.0.\n\nMore info: https://sass-lang.com/d/legacy-js-api",
            The_lo: "The load() function must return an object with contents and syntax fields.",
            The_pa: "The parent selector isn't allowed in plain CSS.",
            The_sa: "The same variable may only be configured once.",
            The_ta: 'The target selector was not found.\nUse "@extend ',
            There_: "There's already a module with namespace \"",
            This_d: 'This declaration has no parameter named "$',
            This_e: "This expression can't be used in a calculation.",
            This_f: "This function isn't allowed in plain CSS.",
            This_ma: 'This module and the new module both define a variable named "$',
            This_mw: 'This module was already loaded, so it can\'t be configured using "with".',
            This_n: "This name is reserved for the plain-CSS function.",
            This_o: "This operation can't be used in a calculation.",
            This_s: "This selector doesn't have any properties and won't be rendered.",
            This_v: "This variable was not declared with !default in the @used module.",
            To_usei: "To use color.invert() with non-legacy color ",
            To_usem: "To use color.mix() with non-legacy color ",
            Top_le: "Top-level leading combinators aren't allowed in plain CSS.",
            Unable: "Unable to determine which of multiple potential resolutions found for ",
            Unexpe: "Unexpected Zone.current[#_canonicalizeContext] value ",
            User_a: "User-authored deprecations should not be silenced.",
            Using__i: "Using / for division is deprecated and will be removed in Dart Sass 2.0.0.\n\nRecommendation: ",
            Using__o: "Using / for division outside of calc() is deprecated and will be removed in Dart Sass 2.0.0.\n\nRecommendation: ",
            Using_c: "Using color.alpha() for a Microsoft filter is deprecated.\n\nRecommendation: ",
            Using_t: "Using the current working directory as an implicit load path is deprecated. Either add it as an explicit load path or importer, or load this stylesheet from a different URL.",
            Variab_: "Variable keyword argument map must have string keys.\n",
            Variabs: "Variable keyword arguments must be a map (was ",
            Vendorp: "Vendor-prefixed progid:...() functions will no longer be supported in a future release of Dart Sass. To preserve current behavior:\n\n#{",
            Vendoru: "Vendor-prefixed url() functions will no longer have special parsing in a future release of Dart Sass. Once that happens, this argument will be parsed as SassScript. To preserve current behavior:\n\n",
            Whitesa: 'Whitespace is required between "and" and "("',
            Whitesn: 'Whitespace is required between "not" and "("',
            Whiteso: 'Whitespace is required between "or" and "("',
            You_ma: "You may not @extend selectors across media queries.",
            You_pr: "You probably don't mean to use the color value ",
            x60_inst: "` instead.\nSee https://sass-lang.com/d/extend-compound for details.\n",
            addExt_: "addExtension() can't be called for a const ExtensionStore.",
            addExts: "addExtensions() can't be called for a const ExtensionStore.",
            addSel: "addSelector() can't be called for a const ExtensionStore.",
            adjustd: "adjust-hue() is deprecated. Suggestion:\n\ncolor.adjust($color, $hue: ",
            adjusto: "adjust-hue() is only supported for legacy colors. Please use color.adjust() instead with an explicit $space argument.",
            alpha_: "alpha() is only supported for legacy colors. Please use color.channel() instead.",
            canoni: "canonicalizeContext may only be accessed within a call to canonicalize().",
            color_a: "color.alpha() is only supported for legacy colors. Please use color.channel() instead.",
            color_c: "color.changeHsl() is only supported for legacy colors. Please use color.changeChannels() instead with an explicit $space argument.",
            color_t: "color.to-gamut() requires a $method argument for forwards-compatibility with changes in the CSS spec. Suggestion:\n\n$method: local-minde",
            compou: "compound selectors may no longer be extended.\nConsider `@extend ",
            conten: "content-exists() may only be called within a mixin.",
            darken: "darken() is only supported for legacy colors. Please use color.adjust() instead with an explicit $space argument.",
            desatu: "desaturate() is only supported for legacy colors. Please use color.adjust() instead with an explicit $space argument.",
            fileEx: "fileExists() is only supported on Node.js",
            if___c: "if() conditions with arbitrary substitutions may not contain sass() expressions.",
            leadin: "leadingCombinators and components may not both be empty.",
            lighte: "lighten() is only supported for legacy colors. Please use color.adjust() instead with an explicit $space argument.",
            linkEx: "linkExists() is only supported on Node.js",
            math_d: "math.div() will only support number arguments in a future release.\nUse list.slash() instead for a slash separator.",
            math_r: "math.random() will no longer ignore $limit units (",
            multip: "multiple statements on one line are not supported in the indented syntax.",
            must_b: "must be a UniversalSelector or a TypeSelector",
            sass__: "sass() conditions aren't allowed in plain CSS",
            satura: "saturate() is only supported for legacy colors. Please use color.adjust() instead with an explicit $space argument.",
            throug: "through() must return false for at least one parent of ",
            x7dx0a_Mor: "}\n\nMore info: https://sass-lang.com/d/function-name",
            x7dx29__Mo: "})\n\nMore info: https://sass-lang.com/d/function-name",
            x7dx29_Mor: "})\nMore info: https://sass-lang.com/d/abs-percent"
        };
        var type$ = function rtii() {
            var findType = A.findType;
            return {
                $env_1_1_String: findType("@<String>"),
                ArgParser: findType("ArgParser"),
                AstNode: findType("AstNode"),
                AstNode_2: findType("AstNode0"),
                AsyncBuiltInCallable: findType("AsyncBuiltInCallable"),
                AsyncBuiltInCallable_2: findType("AsyncBuiltInCallable0"),
                AsyncCallable: findType("AsyncCallable"),
                AsyncCallable_2: findType("AsyncCallable0"),
                AsyncCompiler: findType("AsyncCompiler"),
                AsyncImporter: findType("AsyncImporter0"),
                Box_SelectorList: findType("Box<SelectorList>"),
                Box_SelectorList_2: findType("Box0<SelectorList0>"),
                BuiltInCallable: findType("BuiltInCallable"),
                BuiltInCallable_2: findType("BuiltInCallable0"),
                BuiltInModule_AsyncCallable: findType("BuiltInModule<AsyncCallable>"),
                BuiltInModule_AsyncCallable_2: findType("BuiltInModule0<AsyncCallable0>"),
                BuiltInModule_Callable: findType("BuiltInModule<Callable0>"),
                BuiltInModule_Callable_2: findType("BuiltInModule0<Callable>"),
                ByteBuffer: findType("ByteBuffer"),
                ByteData: findType("ByteData"),
                Callable: findType("Callable0"),
                Callable_2: findType("Callable"),
                ChangeType: findType("ChangeType"),
                CodeUnits: findType("CodeUnits"),
                Combinator: findType("Combinator"),
                Combinator_2: findType("Combinator0"),
                Comparable_dynamic: findType("Comparable<@>"),
                Comparable_nullable_Object: findType("Comparable<Object?>"),
                CompileResult: findType("CompileResult"),
                CompileResult_2: findType("CompileResult0"),
                ComplexSelector: findType("ComplexSelector"),
                ComplexSelectorComponent: findType("ComplexSelectorComponent"),
                ComplexSelectorComponent_2: findType("ComplexSelectorComponent0"),
                ComplexSelector_2: findType("ComplexSelector0"),
                Configuration: findType("Configuration"),
                Configuration_2: findType("Configuration0"),
                ConfiguredValue: findType("ConfiguredValue"),
                ConfiguredValue_2: findType("ConfiguredValue0"),
                ConfiguredVariable: findType("ConfiguredVariable"),
                ConfiguredVariable_2: findType("ConfiguredVariable0"),
                ConstantMapView_Symbol_dynamic: findType("ConstantMapView<Symbol0,@>"),
                ConstantStringMap_String_double: findType("ConstantStringMap<String,double>"),
                ConstantStringSet_String: findType("ConstantStringSet<String>"),
                CssComment: findType("CssComment"),
                CssComment_2: findType("CssComment0"),
                CssMediaQuery: findType("CssMediaQuery"),
                CssMediaQuery_2: findType("CssMediaQuery0"),
                CssParentNode: findType("CssParentNode"),
                CssParentNode_2: findType("CssParentNode0"),
                CssStylesheet: findType("CssStylesheet"),
                CssStylesheet_2: findType("CssStylesheet0"),
                CssValue_AttributeOperator: findType("CssValue0<AttributeOperator0>"),
                CssValue_Combinator: findType("CssValue<Combinator>"),
                CssValue_Combinator_2: findType("CssValue0<Combinator0>"),
                CssValue_List_String: findType("CssValue<List<String>>"),
                CssValue_List_String_2: findType("CssValue0<List<String>>"),
                CssValue_String: findType("CssValue<String>"),
                CssValue_String_2: findType("CssValue0<String>"),
                CssValue_Value: findType("CssValue<Value>"),
                CssValue_Value_2: findType("CssValue0<Value0>"),
                DateTime: findType("DateTime"),
                Deprecation: findType("Deprecation"),
                Deprecation_2: findType("Deprecation1"),
                Deprecation_3: findType("Deprecation0"),
                EfficientLengthIterable_dynamic: findType("EfficientLengthIterable<@>"),
                Error: findType("Error"),
                Exception: findType("Exception"),
                Expression: findType("Expression"),
                Expression_2: findType("Expression0"),
                Extender: findType("Extender"),
                Extender_2: findType("Extender0"),
                Extension: findType("Extension"),
                Extension_2: findType("Extension0"),
                FileLocation: findType("FileLocation"),
                FileSpan: findType("FileSpan"),
                Float32List: findType("Float32List"),
                Float64List: findType("Float64List"),
                FormatException: findType("FormatException"),
                Frame: findType("Frame"),
                Function: findType("Function"),
                FutureGroup_void: findType("FutureGroup<~>"),
                FutureOr_Record_2_Set_Uri_loadedUrls_and_CssStylesheet_stylesheet: findType("+loadedUrls,stylesheet(Set<Uri>,CssStylesheet)/"),
                FutureOr_Record_2_Set_Uri_loadedUrls_and_CssStylesheet_stylesheet_2: findType("+loadedUrls,stylesheet(Set<Uri>,CssStylesheet0)/"),
                FutureOr_nullable_Uri: findType("Uri?/"),
                Future_Record_2_Set_Uri_loadedUrls_and_CssStylesheet_stylesheet: findType("Future<+loadedUrls,stylesheet(Set<Uri>,CssStylesheet)>"),
                Future_Record_2_Set_Uri_loadedUrls_and_CssStylesheet_stylesheet_2: findType("Future<+loadedUrls,stylesheet(Set<Uri>,CssStylesheet0)>"),
                Future_Value: findType("Future<Value>"),
                Future_Value_2: findType("Future<Value0>"),
                Future_nullable_CssValue_String: findType("Future<CssValue<String>?>"),
                Future_nullable_CssValue_String_2: findType("Future<CssValue0<String>?>"),
                Future_nullable_ImporterResult: findType("Future<ImporterResult0?>"),
                Future_nullable_Uri: findType("Future<Uri?>"),
                Future_nullable_Value: findType("Future<Value?>"),
                Future_nullable_Value_2: findType("Future<Value0?>"),
                IfClause: findType("IfClause"),
                IfClause_2: findType("IfClause0"),
                IfConditionExpression: findType("IfConditionExpression"),
                IfConditionExpression_2: findType("IfConditionExpression0"),
                ImmutableList: findType("ImmutableList0"),
                ImmutableList_2: findType("ImmutableList"),
                ImmutableMap: findType("ImmutableMap0"),
                Import: findType("Import"),
                Import_2: findType("Import0"),
                Importer: findType("Importer0"),
                ImporterResult: findType("ImporterResult"),
                ImporterResult_2: findType("ImporterResult0"),
                Importer_2: findType("Importer"),
                Int16List: findType("Int16List"),
                Int32List: findType("Int32List"),
                Int8List: findType("Int8List"),
                InterpolatedComplexSelector: findType("InterpolatedComplexSelector"),
                InterpolatedComplexSelectorComponent: findType("InterpolatedComplexSelectorComponent"),
                InterpolatedSimpleSelector: findType("InterpolatedSimpleSelector"),
                Interpolation: findType("Interpolation"),
                InterpolationBuffer: findType("InterpolationBuffer"),
                InterpolationBuffer_2: findType("InterpolationBuffer0"),
                InterpolationMap: findType("InterpolationMap"),
                InterpolationMap_2: findType("InterpolationMap0"),
                Interpolation_2: findType("Interpolation0"),
                Iterable_ComplexSelectorComponent: findType("Iterable<ComplexSelectorComponent>"),
                Iterable_ComplexSelectorComponent_2: findType("Iterable<ComplexSelectorComponent0>"),
                Iterable_dynamic: findType("Iterable<@>"),
                JSArray_AstNode: findType("JSArray<AstNode>"),
                JSArray_AstNode_2: findType("JSArray<AstNode0>"),
                JSArray_AsyncBuiltInCallable: findType("JSArray<AsyncBuiltInCallable>"),
                JSArray_AsyncBuiltInCallable_2: findType("JSArray<AsyncBuiltInCallable0>"),
                JSArray_AsyncCallable: findType("JSArray<AsyncCallable>"),
                JSArray_AsyncCallable_2: findType("JSArray<AsyncCallable0>"),
                JSArray_AsyncImporter: findType("JSArray<AsyncImporter0>"),
                JSArray_AsyncImporter_2: findType("JSArray<AsyncImporter>"),
                JSArray_BinaryOperator: findType("JSArray<BinaryOperator>"),
                JSArray_BinaryOperator_2: findType("JSArray<BinaryOperator0>"),
                JSArray_BuiltInCallable: findType("JSArray<BuiltInCallable>"),
                JSArray_BuiltInCallable_2: findType("JSArray<BuiltInCallable0>"),
                JSArray_Callable: findType("JSArray<Callable0>"),
                JSArray_Callable_2: findType("JSArray<Callable>"),
                JSArray_ColorChannel: findType("JSArray<ColorChannel>"),
                JSArray_ColorChannel_2: findType("JSArray<ColorChannel0>"),
                JSArray_ComplexSelector: findType("JSArray<ComplexSelector>"),
                JSArray_ComplexSelectorComponent: findType("JSArray<ComplexSelectorComponent>"),
                JSArray_ComplexSelectorComponent_2: findType("JSArray<ComplexSelectorComponent0>"),
                JSArray_ComplexSelector_2: findType("JSArray<ComplexSelector0>"),
                JSArray_ConfiguredVariable: findType("JSArray<ConfiguredVariable>"),
                JSArray_ConfiguredVariable_2: findType("JSArray<ConfiguredVariable0>"),
                JSArray_CssComment: findType("JSArray<CssComment>"),
                JSArray_CssComment_2: findType("JSArray<CssComment0>"),
                JSArray_CssMediaQuery: findType("JSArray<CssMediaQuery>"),
                JSArray_CssMediaQuery_2: findType("JSArray<CssMediaQuery0>"),
                JSArray_CssNode: findType("JSArray<CssNode>"),
                JSArray_CssNode_2: findType("JSArray<CssNode0>"),
                JSArray_CssValue_Combinator: findType("JSArray<CssValue<Combinator>>"),
                JSArray_CssValue_Combinator_2: findType("JSArray<CssValue0<Combinator0>>"),
                JSArray_Entry: findType("JSArray<Entry>"),
                JSArray_Expression: findType("JSArray<Expression>"),
                JSArray_Expression_2: findType("JSArray<Expression0>"),
                JSArray_Extender: findType("JSArray<Extender>"),
                JSArray_Extender_2: findType("JSArray<Extender0>"),
                JSArray_Extension: findType("JSArray<Extension>"),
                JSArray_ExtensionStore: findType("JSArray<ExtensionStore>"),
                JSArray_ExtensionStore_2: findType("JSArray<ExtensionStore0>"),
                JSArray_Extension_2: findType("JSArray<Extension0>"),
                JSArray_ForwardRule: findType("JSArray<ForwardRule>"),
                JSArray_ForwardRule_2: findType("JSArray<ForwardRule0>"),
                JSArray_Frame: findType("JSArray<Frame>"),
                JSArray_Future_nullable_Record_3_int_and_String_and_nullable_String: findType("JSArray<Future<+(int,String,String?)?>>"),
                JSArray_IfClause: findType("JSArray<IfClause>"),
                JSArray_IfClause_2: findType("JSArray<IfClause0>"),
                JSArray_IfConditionExpression: findType("JSArray<IfConditionExpression>"),
                JSArray_IfConditionExpression_2: findType("JSArray<IfConditionExpression0>"),
                JSArray_Import: findType("JSArray<Import>"),
                JSArray_Import_2: findType("JSArray<Import0>"),
                JSArray_Importer: findType("JSArray<Importer>"),
                JSArray_Importer_2: findType("JSArray<Importer0>"),
                JSArray_InterpolatedComplexSelector: findType("JSArray<InterpolatedComplexSelector>"),
                JSArray_InterpolatedComplexSelectorComponent: findType("JSArray<InterpolatedComplexSelectorComponent>"),
                JSArray_InterpolatedSimpleSelector: findType("JSArray<InterpolatedSimpleSelector>"),
                JSArray_Iterable_ComplexSelectorComponent: findType("JSArray<Iterable<ComplexSelectorComponent>>"),
                JSArray_Iterable_ComplexSelectorComponent_2: findType("JSArray<Iterable<ComplexSelectorComponent0>>"),
                JSArray_JSFunction: findType("JSArray<JSFunction0>"),
                JSArray_LinearChannel: findType("JSArray<LinearChannel>"),
                JSArray_LinearChannel_2: findType("JSArray<LinearChannel0>"),
                JSArray_List_ComplexSelector: findType("JSArray<List<ComplexSelector>>"),
                JSArray_List_ComplexSelectorComponent: findType("JSArray<List<ComplexSelectorComponent>>"),
                JSArray_List_ComplexSelectorComponent_2: findType("JSArray<List<ComplexSelectorComponent0>>"),
                JSArray_List_ComplexSelector_2: findType("JSArray<List<ComplexSelector0>>"),
                JSArray_List_Extender: findType("JSArray<List<Extender>>"),
                JSArray_List_Extender_2: findType("JSArray<List<Extender0>>"),
                JSArray_List_Iterable_ComplexSelectorComponent: findType("JSArray<List<Iterable<ComplexSelectorComponent>>>"),
                JSArray_List_Iterable_ComplexSelectorComponent_2: findType("JSArray<List<Iterable<ComplexSelectorComponent0>>>"),
                JSArray_Map_String_AstNode: findType("JSArray<Map<String,AstNode>>"),
                JSArray_Map_String_AstNode_2: findType("JSArray<Map<String,AstNode0>>"),
                JSArray_Map_String_AsyncCallable: findType("JSArray<Map<String,AsyncCallable>>"),
                JSArray_Map_String_AsyncCallable_2: findType("JSArray<Map<String,AsyncCallable0>>"),
                JSArray_Map_String_Callable: findType("JSArray<Map<String,Callable0>>"),
                JSArray_Map_String_Callable_2: findType("JSArray<Map<String,Callable>>"),
                JSArray_Map_String_Value: findType("JSArray<Map<String,Value>>"),
                JSArray_Map_String_Value_2: findType("JSArray<Map<String,Value0>>"),
                JSArray_ModifiableCssImport: findType("JSArray<ModifiableCssImport>"),
                JSArray_ModifiableCssImport_2: findType("JSArray<ModifiableCssImport0>"),
                JSArray_ModifiableCssNode: findType("JSArray<ModifiableCssNode>"),
                JSArray_ModifiableCssNode_2: findType("JSArray<ModifiableCssNode0>"),
                JSArray_ModifiableCssParentNode: findType("JSArray<ModifiableCssParentNode>"),
                JSArray_ModifiableCssParentNode_2: findType("JSArray<ModifiableCssParentNode0>"),
                JSArray_Module_AsyncCallable: findType("JSArray<Module0<AsyncCallable>>"),
                JSArray_Module_AsyncCallable_2: findType("JSArray<Module1<AsyncCallable0>>"),
                JSArray_Module_Callable: findType("JSArray<Module0<Callable0>>"),
                JSArray_Module_Callable_2: findType("JSArray<Module1<Callable>>"),
                JSArray_Object: findType("JSArray<Object>"),
                JSArray_Parameter: findType("JSArray<Parameter>"),
                JSArray_Parameter_2: findType("JSArray<Parameter0>"),
                JSArray_PseudoSelector: findType("JSArray<PseudoSelector>"),
                JSArray_PseudoSelector_2: findType("JSArray<PseudoSelector0>"),
                JSArray_Record_2_Expression_and_Expression: findType("JSArray<+(Expression,Expression)>"),
                JSArray_Record_2_Expression_and_Expression_2: findType("JSArray<+(Expression0,Expression0)>"),
                JSArray_Record_2_IfConditionExpression_and_String: findType("JSArray<+(IfConditionExpression,String)>"),
                JSArray_Record_2_IfConditionExpression_and_String_2: findType("JSArray<+(IfConditionExpression0,String)>"),
                JSArray_Record_2_ParameterList_and_Value_Function_List_Value: findType("JSArray<+(ParameterList,Value(List<Value>))>"),
                JSArray_Record_2_ParameterList_and_Value_Function_List_Value_2: findType("JSArray<+(ParameterList0,Value0(List<Value0>))>"),
                JSArray_Record_2_String_and_AstNode: findType("JSArray<+(String,AstNode)>"),
                JSArray_Record_2_String_and_AstNode_2: findType("JSArray<+(String,AstNode0)>"),
                JSArray_Record_2_String_and_Value: findType("JSArray<+(String,Value)>"),
                JSArray_Record_2_String_and_Value_2: findType("JSArray<+(String,Value0)>"),
                JSArray_Record_2_nullable_IfConditionExpression_and_Expression: findType("JSArray<+(IfConditionExpression?,Expression)>"),
                JSArray_Record_2_nullable_IfConditionExpression_and_Expression_2: findType("JSArray<+(IfConditionExpression0?,Expression0)>"),
                JSArray_Record_3_nullable_Deprecation_deprecation_and_String_message_and_FileSpan_span: findType("JSArray<+deprecation,message,span(Deprecation?,String,FileSpan)>"),
                JSArray_Record_3_nullable_Deprecation_deprecation_and_String_message_and_FileSpan_span_2: findType("JSArray<+deprecation,message,span(Deprecation0?,String,FileSpan)>"),
                JSArray_SassList: findType("JSArray<SassList>"),
                JSArray_SassList_2: findType("JSArray<SassList0>"),
                JSArray_SimpleSelector: findType("JSArray<SimpleSelector>"),
                JSArray_SimpleSelector_2: findType("JSArray<SimpleSelector0>"),
                JSArray_Statement: findType("JSArray<Statement>"),
                JSArray_Statement_2: findType("JSArray<Statement0>"),
                JSArray_String: findType("JSArray<String>"),
                JSArray_StylesheetNode: findType("JSArray<StylesheetNode>"),
                JSArray_TargetEntry: findType("JSArray<TargetEntry>"),
                JSArray_TargetLineEntry: findType("JSArray<TargetLineEntry>"),
                JSArray_Trace: findType("JSArray<Trace>"),
                JSArray_UseRule: findType("JSArray<UseRule>"),
                JSArray_UseRule_2: findType("JSArray<UseRule0>"),
                JSArray_Value: findType("JSArray<Value>"),
                JSArray_Value_2: findType("JSArray<Value0>"),
                JSArray_WatchEvent: findType("JSArray<WatchEvent>"),
                JSArray__Highlight: findType("JSArray<_Highlight>"),
                JSArray__Line: findType("JSArray<_Line>"),
                JSArray_double: findType("JSArray<double>"),
                JSArray_dynamic: findType("JSArray<@>"),
                JSArray_int: findType("JSArray<int>"),
                JSArray_nullable_FileSpan: findType("JSArray<FileSpan?>"),
                JSArray_nullable_Record_3_int_and_String_and_nullable_String: findType("JSArray<+(int,String,String?)?>"),
                JSArray_nullable_SassNumber: findType("JSArray<SassNumber?>"),
                JSArray_nullable_SassNumber_2: findType("JSArray<SassNumber0?>"),
                JSArray_nullable_String: findType("JSArray<String?>"),
                JSClass: findType("JSClass0"),
                JSFunction: findType("JSFunction0"),
                JSImporter: findType("JSImporter"),
                JSImporterResult: findType("JSImporterResult"),
                JSNull: findType("JSNull"),
                JSObject: findType("JSObject"),
                JSUrl: findType("JSUrl0"),
                JavaScriptFunction: findType("JavaScriptFunction"),
                JavaScriptIndexingBehavior_dynamic: findType("JavaScriptIndexingBehavior<@>"),
                JsIdentityLinkedHashMap_SimpleSelector_int: findType("JsIdentityLinkedHashMap<SimpleSelector,int>"),
                JsIdentityLinkedHashMap_SimpleSelector_int_2: findType("JsIdentityLinkedHashMap<SimpleSelector0,int>"),
                JsIdentityLinkedHashMap_of_SelectorList_and_Box_SelectorList: findType("JsIdentityLinkedHashMap<SelectorList,Box<SelectorList>>"),
                JsIdentityLinkedHashMap_of_SelectorList_and_Box_SelectorList_2: findType("JsIdentityLinkedHashMap<SelectorList0,Box0<SelectorList0>>"),
                JsLinkedHashMap_Symbol_dynamic: findType("JsLinkedHashMap<Symbol0,@>"),
                JsSystemError: findType("JsSystemError"),
                LimitedMapView_String_ConfiguredValue: findType("LimitedMapView<String,ConfiguredValue>"),
                LimitedMapView_String_ConfiguredValue_2: findType("LimitedMapView0<String,ConfiguredValue0>"),
                LinearChannel: findType("LinearChannel"),
                LinearChannel_2: findType("LinearChannel0"),
                List_ComplexSelectorComponent: findType("List<ComplexSelectorComponent>"),
                List_ComplexSelectorComponent_2: findType("List<ComplexSelectorComponent0>"),
                List_CssComment: findType("List<CssComment>"),
                List_CssComment_2: findType("List<CssComment0>"),
                List_CssMediaQuery: findType("List<CssMediaQuery>"),
                List_CssMediaQuery_2: findType("List<CssMediaQuery0>"),
                List_Extension: findType("List<Extension>"),
                List_ExtensionStore: findType("List<ExtensionStore>"),
                List_ExtensionStore_2: findType("List<ExtensionStore0>"),
                List_Extension_2: findType("List<Extension0>"),
                List_JSObject: findType("List<JSObject>"),
                List_List_ComplexSelectorComponent: findType("List<List<ComplexSelectorComponent>>"),
                List_List_ComplexSelectorComponent_2: findType("List<List<ComplexSelectorComponent0>>"),
                List_Module_AsyncCallable: findType("List<Module0<AsyncCallable>>"),
                List_Module_AsyncCallable_2: findType("List<Module1<AsyncCallable0>>"),
                List_Module_Callable: findType("List<Module0<Callable0>>"),
                List_Module_Callable_2: findType("List<Module1<Callable>>"),
                List_String: findType("List<String>"),
                List_WatchEvent: findType("List<WatchEvent>"),
                List_dynamic: findType("List<@>"),
                List_int: findType("List<int>"),
                MapKeySet_Module_AsyncCallable: findType("MapKeySet<Module0<AsyncCallable>>"),
                MapKeySet_Module_AsyncCallable_2: findType("MapKeySet<Module1<AsyncCallable0>>"),
                MapKeySet_Module_Callable: findType("MapKeySet<Module0<Callable0>>"),
                MapKeySet_Module_Callable_2: findType("MapKeySet<Module1<Callable>>"),
                MapKeySet_SimpleSelector: findType("MapKeySet<SimpleSelector>"),
                MapKeySet_SimpleSelector_2: findType("MapKeySet<SimpleSelector0>"),
                MapKeySet_String: findType("MapKeySet<String>"),
                MapKeySet_nullable_Object: findType("MapKeySet<Object?>"),
                Map_ComplexSelector_Extension: findType("Map<ComplexSelector,Extension>"),
                Map_ComplexSelector_Extension_2: findType("Map<ComplexSelector0,Extension0>"),
                Map_String_AstNode: findType("Map<String,AstNode>"),
                Map_String_AstNode_2: findType("Map<String,AstNode0>"),
                Map_String_AsyncCallable: findType("Map<String,AsyncCallable>"),
                Map_String_AsyncCallable_2: findType("Map<String,AsyncCallable0>"),
                Map_String_Callable: findType("Map<String,Callable0>"),
                Map_String_Callable_2: findType("Map<String,Callable>"),
                Map_String_Value: findType("Map<String,Value>"),
                Map_String_Value_2: findType("Map<String,Value0>"),
                Map_String_dynamic: findType("Map<String,@>"),
                Map_dynamic_dynamic: findType("Map<@,@>"),
                MappedIterable_String_Frame: findType("MappedIterable<String,Frame>"),
                MappedListIterable_Frame_Frame: findType("MappedListIterable<Frame,Frame>"),
                MappedListIterable_String_Object: findType("MappedListIterable<String,Object>"),
                MappedListIterable_String_String: findType("MappedListIterable<String,String>"),
                MappedListIterable_String_Trace: findType("MappedListIterable<String,Trace>"),
                MappedListIterable_String_Value: findType("MappedListIterable<String,Value>"),
                MappedListIterable_String_Value_2: findType("MappedListIterable<String,Value0>"),
                MappedListIterable_String_dynamic: findType("MappedListIterable<String,@>"),
                MixinRule: findType("MixinRule"),
                MixinRule_2: findType("MixinRule0"),
                ModifiableBox_SelectorList: findType("ModifiableBox<SelectorList>"),
                ModifiableBox_SelectorList_2: findType("ModifiableBox0<SelectorList0>"),
                ModifiableCssAtRule: findType("ModifiableCssAtRule"),
                ModifiableCssAtRule_2: findType("ModifiableCssAtRule0"),
                ModifiableCssKeyframeBlock: findType("ModifiableCssKeyframeBlock"),
                ModifiableCssKeyframeBlock_2: findType("ModifiableCssKeyframeBlock0"),
                ModifiableCssMediaRule: findType("ModifiableCssMediaRule"),
                ModifiableCssMediaRule_2: findType("ModifiableCssMediaRule0"),
                ModifiableCssNode: findType("ModifiableCssNode"),
                ModifiableCssNode_2: findType("ModifiableCssNode0"),
                ModifiableCssParentNode: findType("ModifiableCssParentNode"),
                ModifiableCssParentNode_2: findType("ModifiableCssParentNode0"),
                ModifiableCssStyleRule: findType("ModifiableCssStyleRule"),
                ModifiableCssStyleRule_2: findType("ModifiableCssStyleRule0"),
                ModifiableCssSupportsRule: findType("ModifiableCssSupportsRule"),
                ModifiableCssSupportsRule_2: findType("ModifiableCssSupportsRule0"),
                Module_AsyncCallable: findType("Module0<AsyncCallable>"),
                Module_AsyncCallable_2: findType("Module1<AsyncCallable0>"),
                Module_Callable: findType("Module0<Callable0>"),
                Module_Callable_2: findType("Module1<Callable>"),
                MultiSourceSpanFormatException: findType("MultiSourceSpanFormatException"),
                NativeTypedArrayOfDouble: findType("NativeTypedArrayOfDouble"),
                NativeTypedArrayOfInt: findType("NativeTypedArrayOfInt"),
                NativeUint8List: findType("NativeUint8List"),
                Never: findType("0&"),
                NodeCompileResult: findType("NodeCompileResult"),
                NodeImporterResult: findType("NodeImporterResult0"),
                NonNullsIterable_Future_void: findType("NonNullsIterable<Future<~>>"),
                NonNullsIterable_Object: findType("NonNullsIterable<Object>"),
                NonNullsIterable_Record_3_AsyncImporter_and_Uri_and_Uri_originalUrl: findType("NonNullsIterable<+originalUrl(AsyncImporter,Uri,Uri)>"),
                NonNullsIterable_Record_3_AsyncImporter_and_Uri_and_Uri_originalUrl_2: findType("NonNullsIterable<+originalUrl(AsyncImporter0,Uri,Uri)>"),
                NonNullsIterable_Record_3_Importer_and_Uri_and_Uri_originalUrl: findType("NonNullsIterable<+originalUrl(Importer,Uri,Uri)>"),
                NonNullsIterable_Record_3_Importer_and_Uri_and_Uri_originalUrl_2: findType("NonNullsIterable<+originalUrl(Importer0,Uri,Uri)>"),
                NonNullsIterable_SelectorList: findType("NonNullsIterable<SelectorList>"),
                NonNullsIterable_SelectorList_2: findType("NonNullsIterable<SelectorList0>"),
                NonNullsIterable_String: findType("NonNullsIterable<String>"),
                Null: findType("Null"),
                NumberExpression: findType("NumberExpression"),
                NumberExpression_2: findType("NumberExpression0"),
                Object: findType("Object"),
                Option: findType("Option"),
                Parameter: findType("Parameter"),
                ParameterList: findType("ParameterList"),
                ParameterList_2: findType("ParameterList0"),
                Parameter_2: findType("Parameter0"),
                PathMap_ChangeType: findType("PathMap<ChangeType>"),
                PathMap_Stream_WatchEvent: findType("PathMap<Stream<WatchEvent>>"),
                PathMap_String: findType("PathMap<String>"),
                PathMap_nullable_String: findType("PathMap<String?>"),
                Promise: findType("Promise"),
                PseudoSelector: findType("PseudoSelector"),
                PseudoSelector_2: findType("PseudoSelector0"),
                RangeError: findType("RangeError"),
                Record: findType("Record"),
                Record_0: findType("+()"),
                Record_1_nullable_Object: findType("+(Object?)"),
                Record_2_Expression_and_Expression: findType("+(Expression,Expression)"),
                Record_2_Expression_and_Expression_2: findType("+(Expression0,Expression0)"),
                Record_2_List_Expression_and_Map_String_Expression: findType("+(List<Expression>,Map<String,Expression>)"),
                Record_2_List_Expression_and_Map_String_Expression_2: findType("+(List<Expression0>,Map<String,Expression0>)"),
                Record_2_Set_Uri_loadedUrls_and_CssStylesheet_stylesheet: findType("+loadedUrls,stylesheet(Set<Uri>,CssStylesheet)"),
                Record_2_Set_Uri_loadedUrls_and_CssStylesheet_stylesheet_2: findType("+loadedUrls,stylesheet(Set<Uri>,CssStylesheet0)"),
                Record_2_String_and_InterpolationMap: findType("+(String,InterpolationMap)"),
                Record_2_String_and_InterpolationMap_2: findType("+(String,InterpolationMap0)"),
                Record_2_String_and_SourceSpan: findType("+(String,SourceSpan)"),
                Record_2_String_and_nullable_InterpolationMap: findType("+(String,InterpolationMap?)"),
                Record_2_String_and_nullable_InterpolationMap_2: findType("+(String,InterpolationMap0?)"),
                Record_2_Uri_and_bool_forImport: findType("+forImport(Uri,bool)"),
                Record_2_nullable_IfConditionExpression_and_Expression: findType("+(IfConditionExpression?,Expression)"),
                Record_2_nullable_IfConditionExpression_and_Expression_2: findType("+(IfConditionExpression0?,Expression0)"),
                Record_2_nullable_Object_and_nullable_Object: findType("+(Object?,Object?)"),
                Record_2_nullable_Record_3_AsyncImporter_and_Uri_and_Uri_originalUrl_and_bool: findType("+(+originalUrl(AsyncImporter,Uri,Uri)?,bool)"),
                Record_2_nullable_Record_3_AsyncImporter_and_Uri_and_Uri_originalUrl_and_bool_2: findType("+(+originalUrl(AsyncImporter0,Uri,Uri)?,bool)"),
                Record_2_nullable_String_and_nullable_String: findType("+(String?,String?)"),
                Record_3_AsyncImporter_and_Uri_and_Uri_originalUrl: findType("+originalUrl(AsyncImporter,Uri,Uri)"),
                Record_3_AsyncImporter_and_Uri_and_Uri_originalUrl_2: findType("+originalUrl(AsyncImporter0,Uri,Uri)"),
                Record_3_AsyncImporter_and_Uri_and_bool_forImport: findType("+forImport(AsyncImporter,Uri,bool)"),
                Record_3_AsyncImporter_and_Uri_and_bool_forImport_2: findType("+forImport(AsyncImporter0,Uri,bool)"),
                Record_3_Importer_and_Uri_and_Uri_originalUrl: findType("+originalUrl(Importer,Uri,Uri)"),
                Record_3_Importer_and_Uri_and_Uri_originalUrl_2: findType("+originalUrl(Importer0,Uri,Uri)"),
                Record_3_Importer_and_Uri_and_bool_forImport: findType("+forImport(Importer,Uri,bool)"),
                Record_3_Importer_and_Uri_and_bool_forImport_2: findType("+forImport(Importer0,Uri,bool)"),
                Record_3_Stylesheet_and_nullable_AsyncImporter_importer_and_bool_isDependency: findType("+importer,isDependency(Stylesheet,AsyncImporter?,bool)"),
                Record_3_Stylesheet_and_nullable_AsyncImporter_importer_and_bool_isDependency_2: findType("+importer,isDependency(Stylesheet0,AsyncImporter0?,bool)"),
                Record_3_nullable_Object_and_nullable_Object_and_nullable_Object_originalUrl: findType("+originalUrl(Object?,Object?,Object?)"),
                Record_5_Map_String_Value_named_and_Map_String_AstNode_namedNodes_and_List_Value_positional_and_List_AstNode_positionalNodes_and_ListSeparator_separator: findType("+named,namedNodes,positional,positionalNodes,separator(Map<String,Value>,Map<String,AstNode>,List<Value>,List<AstNode>,ListSeparator)"),
                Record_5_Map_String_Value_named_and_Map_String_AstNode_namedNodes_and_List_Value_positional_and_List_AstNode_positionalNodes_and_ListSeparator_separator_2: findType("+named,namedNodes,positional,positionalNodes,separator(Map<String,Value0>,Map<String,AstNode0>,List<Value0>,List<AstNode0>,ListSeparator0)"),
                RegExpMatch: findType("RegExpMatch"),
                RenderContextOptions: findType("RenderContextOptions0"),
                RenderResult: findType("RenderResult"),
                Result_String: findType("Result<String>"),
                ReversedListIterable_Frame: findType("ReversedListIterable<Frame>"),
                Runes: findType("Runes"),
                SassArgumentList: findType("SassArgumentList"),
                SassArgumentList_2: findType("SassArgumentList0"),
                SassBoolean: findType("SassBoolean"),
                SassBoolean_2: findType("SassBoolean0"),
                SassColor: findType("SassColor"),
                SassColor_2: findType("SassColor0"),
                SassFormatException: findType("SassFormatException"),
                SassFormatException_2: findType("SassFormatException0"),
                SassList: findType("SassList"),
                SassList_2: findType("SassList0"),
                SassMap: findType("SassMap"),
                SassMap_2: findType("SassMap0"),
                SassNumber: findType("SassNumber"),
                SassNumber_2: findType("SassNumber0"),
                SassRuntimeException: findType("SassRuntimeException"),
                SassRuntimeException_2: findType("SassRuntimeException0"),
                SassString: findType("SassString"),
                SassString_2: findType("SassString0"),
                SelectorList: findType("SelectorList"),
                SelectorList_2: findType("SelectorList0"),
                Set_ModifiableBox_SelectorList: findType("Set<ModifiableBox<SelectorList>>"),
                Set_ModifiableBox_SelectorList_2: findType("Set<ModifiableBox0<SelectorList0>>"),
                Set_Uri: findType("Set<Uri>"),
                SimpleSelector: findType("SimpleSelector"),
                SimpleSelector_2: findType("SimpleSelector0"),
                SourceFile: findType("SourceFile"),
                SourceLocation: findType("SourceLocation"),
                SourceSpan: findType("SourceSpan"),
                SourceSpanFormatException: findType("SourceSpanFormatException"),
                SourceSpanWithContext: findType("SourceSpanWithContext"),
                StackTrace: findType("StackTrace"),
                Statement: findType("Statement"),
                Statement_2: findType("Statement0"),
                StaticImport: findType("StaticImport"),
                StaticImport_2: findType("StaticImport0"),
                StreamCompleter_WatchEvent: findType("StreamCompleter<WatchEvent>"),
                StreamGroup_WatchEvent: findType("StreamGroup<WatchEvent>"),
                StreamQueue_String: findType("StreamQueue<String>"),
                Stream_WatchEvent: findType("Stream<WatchEvent>"),
                String: findType("String"),
                StringExpression: findType("StringExpression"),
                StringExpression_2: findType("StringExpression0"),
                StyleRule: findType("StyleRule"),
                StyleRule_2: findType("StyleRule0"),
                StylesheetNode: findType("StylesheetNode"),
                Timer: findType("Timer"),
                Trace: findType("Trace"),
                TrustedGetRuntimeType: findType("TrustedGetRuntimeType"),
                TypeError: findType("TypeError"),
                TypeSelector: findType("TypeSelector"),
                TypeSelector_2: findType("TypeSelector0"),
                Uint16List: findType("Uint16List"),
                Uint32List: findType("Uint32List"),
                Uint8ClampedList: findType("Uint8ClampedList"),
                Uint8List: findType("Uint8List"),
                UnionSet_Uri: findType("UnionSet<Uri>"),
                UnknownJavaScriptObject: findType("UnknownJavaScriptObject"),
                UnmodifiableListView_CssComment: findType("UnmodifiableListView<CssComment>"),
                UnmodifiableListView_CssComment_2: findType("UnmodifiableListView<CssComment0>"),
                UnmodifiableListView_CssNode: findType("UnmodifiableListView<CssNode>"),
                UnmodifiableListView_CssNode_2: findType("UnmodifiableListView<CssNode0>"),
                UnmodifiableListView_ForwardRule: findType("UnmodifiableListView<ForwardRule>"),
                UnmodifiableListView_ForwardRule_2: findType("UnmodifiableListView<ForwardRule0>"),
                UnmodifiableListView_ModifiableCssNode: findType("UnmodifiableListView<ModifiableCssNode>"),
                UnmodifiableListView_ModifiableCssNode_2: findType("UnmodifiableListView<ModifiableCssNode0>"),
                UnmodifiableListView_Record_3_nullable_Deprecation_deprecation_and_String_message_and_FileSpan_span: findType("UnmodifiableListView<+deprecation,message,span(Deprecation?,String,FileSpan)>"),
                UnmodifiableListView_Record_3_nullable_Deprecation_deprecation_and_String_message_and_FileSpan_span_2: findType("UnmodifiableListView<+deprecation,message,span(Deprecation0?,String,FileSpan)>"),
                UnmodifiableListView_String: findType("UnmodifiableListView<String>"),
                UnmodifiableListView_UseRule: findType("UnmodifiableListView<UseRule>"),
                UnmodifiableListView_UseRule_2: findType("UnmodifiableListView<UseRule0>"),
                UnmodifiableMapView_String_ArgParser: findType("UnmodifiableMapView<String,ArgParser>"),
                UnmodifiableMapView_String_ConfiguredValue: findType("UnmodifiableMapView<String,ConfiguredValue>"),
                UnmodifiableMapView_String_ConfiguredValue_2: findType("UnmodifiableMapView<String,ConfiguredValue0>"),
                UnmodifiableMapView_String_Option: findType("UnmodifiableMapView<String,Option>"),
                UnmodifiableMapView_String_Value: findType("UnmodifiableMapView<String,Value>"),
                UnmodifiableMapView_String_Value_2: findType("UnmodifiableMapView<String,Value0>"),
                UnmodifiableMapView_of_Uri_and_nullable_StylesheetNode: findType("UnmodifiableMapView<Uri,StylesheetNode?>"),
                UnmodifiableMapView_of_nullable_String_and_String: findType("UnmodifiableMapView<String?,String>"),
                UnmodifiableMapView_of_nullable_String_and_nullable_String: findType("UnmodifiableMapView<String?,String?>"),
                UnmodifiableSetView_String: findType("UnmodifiableSetView0<String>"),
                UnmodifiableSetView_StylesheetNode: findType("UnmodifiableSetView0<StylesheetNode>"),
                UnmodifiableSetView_Uri: findType("UnmodifiableSetView0<Uri>"),
                UnprefixedMapView_ConfiguredValue: findType("UnprefixedMapView<ConfiguredValue>"),
                UnprefixedMapView_ConfiguredValue_2: findType("UnprefixedMapView0<ConfiguredValue0>"),
                Uri: findType("Uri"),
                UseRule: findType("UseRule"),
                UserDefinedCallable_AsyncEnvironment: findType("UserDefinedCallable<AsyncEnvironment>"),
                UserDefinedCallable_AsyncEnvironment_2: findType("UserDefinedCallable0<AsyncEnvironment0>"),
                UserDefinedCallable_Environment: findType("UserDefinedCallable<Environment>"),
                UserDefinedCallable_Environment_2: findType("UserDefinedCallable0<Environment0>"),
                Value: findType("Value"),
                Value_2: findType("Value0"),
                Value_Function_List_Value: findType("Value(List<Value>)"),
                Value_Function_List_Value_2: findType("Value0(List<Value0>)"),
                VariableDeclaration: findType("VariableDeclaration"),
                VersionRange: findType("VersionRange"),
                WatchEvent: findType("WatchEvent"),
                WhereIterable_List_Iterable_ComplexSelectorComponent: findType("WhereIterable<List<Iterable<ComplexSelectorComponent>>>"),
                WhereIterable_List_Iterable_ComplexSelectorComponent_2: findType("WhereIterable<List<Iterable<ComplexSelectorComponent0>>>"),
                WhereIterable_String: findType("WhereIterable<String>"),
                WhereTypeIterable_PseudoSelector: findType("WhereTypeIterable<PseudoSelector>"),
                WhereTypeIterable_PseudoSelector_2: findType("WhereTypeIterable<PseudoSelector0>"),
                WhereTypeIterable_String: findType("WhereTypeIterable<String>"),
                _AsyncCompleter_List_void: findType("_AsyncCompleter<List<~>>"),
                _AsyncCompleter_Object: findType("_AsyncCompleter<Object>"),
                _AsyncCompleter_Stream_WatchEvent: findType("_AsyncCompleter<Stream<WatchEvent>>"),
                _AsyncCompleter_String: findType("_AsyncCompleter<String>"),
                _AsyncCompleter_nullable_Object: findType("_AsyncCompleter<Object?>"),
                _CompleterStream_WatchEvent: findType("_CompleterStream<WatchEvent>"),
                _EventRequest_dynamic: findType("_EventRequest<@>"),
                _Future_List_void: findType("_Future<List<~>>"),
                _Future_Object: findType("_Future<Object>"),
                _Future_Stream_WatchEvent: findType("_Future<Stream<WatchEvent>>"),
                _Future_String: findType("_Future<String>"),
                _Future_Value: findType("_Future<Value>"),
                _Future_Value_2: findType("_Future<Value0>"),
                _Future_bool: findType("_Future<bool>"),
                _Future_dynamic: findType("_Future<@>"),
                _Future_int: findType("_Future<int>"),
                _Future_nullable_Object: findType("_Future<Object?>"),
                _Future_void: findType("_Future<~>"),
                _Highlight: findType("_Highlight"),
                _IdentityHashMap_of_nullable_Object_and_nullable_Object: findType("_IdentityHashMap<Object?,Object?>"),
                _LinkedIdentityHashSet_ComplexSelector: findType("_LinkedIdentityHashSet<ComplexSelector>"),
                _LinkedIdentityHashSet_ComplexSelector_2: findType("_LinkedIdentityHashSet<ComplexSelector0>"),
                _LinkedIdentityHashSet_Extension: findType("_LinkedIdentityHashSet<Extension>"),
                _LinkedIdentityHashSet_Extension_2: findType("_LinkedIdentityHashSet<Extension0>"),
                _MapEntry: findType("_MapEntry"),
                _NodeException: findType("_NodeException"),
                _PlatformUri: findType("_PlatformUri"),
                _SyncStarIterable_Deprecation: findType("_SyncStarIterable<Deprecation0>"),
                _SyncStarIterable_Extension: findType("_SyncStarIterable<Extension>"),
                _SyncStarIterable_Extension_2: findType("_SyncStarIterable<Extension0>"),
                _SyncStarIterable_SimpleSelector: findType("_SyncStarIterable<SimpleSelector>"),
                _SyncStarIterable_SimpleSelector_2: findType("_SyncStarIterable<SimpleSelector0>"),
                _SyncStarIterable_String: findType("_SyncStarIterable<String>"),
                bool: findType("bool"),
                double: findType("double"),
                dynamic: findType("@"),
                dynamic_Function: findType("@()"),
                dynamic_Function_Object: findType("@(Object)"),
                dynamic_Function_Object_StackTrace: findType("@(Object,StackTrace)"),
                int: findType("int"),
                nullable_AstNode: findType("AstNode?"),
                nullable_AstNode_2: findType("AstNode0?"),
                nullable_CanonicalizeContext: findType("CanonicalizeContext?"),
                nullable_CanonicalizeContext_2: findType("CanonicalizeContext0?"),
                nullable_CssValue_String: findType("CssValue<String>?"),
                nullable_CssValue_String_2: findType("CssValue0<String>?"),
                nullable_FileSpan: findType("FileSpan?"),
                nullable_Future_Null: findType("Future<Null>?"),
                nullable_Future_void: findType("Future<~>?"),
                nullable_ImporterResult: findType("ImporterResult?"),
                nullable_ImporterResult_2: findType("ImporterResult0?"),
                nullable_JSObject: findType("JSObject?"),
                nullable_Object: findType("Object?"),
                nullable_Record_2_String_and_String: findType("+(String,String)?"),
                nullable_Record_3_AsyncImporter_and_Uri_and_Uri_originalUrl: findType("+originalUrl(AsyncImporter,Uri,Uri)?"),
                nullable_Record_3_AsyncImporter_and_Uri_and_Uri_originalUrl_2: findType("+originalUrl(AsyncImporter0,Uri,Uri)?"),
                nullable_Record_3_Importer_and_Uri_and_Uri_originalUrl: findType("+originalUrl(Importer,Uri,Uri)?"),
                nullable_Record_3_Importer_and_Uri_and_Uri_originalUrl_2: findType("+originalUrl(Importer0,Uri,Uri)?"),
                nullable_Record_3_Stylesheet_and_nullable_AsyncImporter_importer_and_bool_isDependency: findType("+importer,isDependency(Stylesheet0,AsyncImporter0?,bool)?"),
                nullable_Record_3_int_and_String_and_nullable_String: findType("+(int,String,String?)?"),
                nullable_SourceFile: findType("SourceFile?"),
                nullable_StreamSubscription_WatchEvent: findType("StreamSubscription<WatchEvent>?"),
                nullable_String: findType("String?"),
                nullable_Stylesheet: findType("Stylesheet?"),
                nullable_StylesheetNode: findType("StylesheetNode?"),
                nullable_Stylesheet_2: findType("Stylesheet0?"),
                nullable_Uri: findType("Uri?"),
                nullable_Value: findType("Value?"),
                nullable_Value_2: findType("Value0?"),
                nullable__ConstructorOptions: findType("_ConstructorOptions?"),
                nullable__ConstructorOptions_2: findType("_ConstructorOptions0?"),
                nullable__ConstructorOptions_3: findType("_ConstructorOptions1?"),
                nullable__Highlight: findType("_Highlight?"),
                nullable_bool: findType("bool?"),
                nullable_double: findType("double?"),
                nullable_int: findType("int?"),
                nullable_num: findType("num?"),
                num: findType("num"),
                void: findType("~"),
                void_Function_Object: findType("~(Object)"),
                void_Function_Object_StackTrace: findType("~(Object,StackTrace)")
            };
        }();
        (function constants() {
            var makeConstList = hunkHelpers.makeConstList;
            B.Interceptor_methods = J.Interceptor.prototype;
            B.JSArray_methods = J.JSArray.prototype;
            B.JSBool_methods = J.JSBool.prototype;
            B.JSInt_methods = J.JSInt.prototype;
            B.JSNull_methods = J.JSNull.prototype;
            B.JSNumber_methods = J.JSNumber.prototype;
            B.JSString_methods = J.JSString.prototype;
            B.JavaScriptFunction_methods = J.JavaScriptFunction.prototype;
            B.JavaScriptObject_methods = J.JavaScriptObject.prototype;
            B.NativeUint32List_methods = A.NativeUint32List.prototype;
            B.NativeUint8List_methods = A.NativeUint8List.prototype;
            B.PlainJavaScriptObject_methods = J.PlainJavaScriptObject.prototype;
            B.UnknownJavaScriptObject_methods = J.UnknownJavaScriptObject.prototype;
            B.LinearChannel_Y0V = new A.LinearChannel(0, 1, false, false, false, "red", false, null);
            B.LinearChannel_cPl = new A.LinearChannel(0, 1, false, false, false, "green", false, null);
            B.LinearChannel_ABN = new A.LinearChannel(0, 1, false, false, false, "blue", false, null);
            B.List_U47 = makeConstList([
                B.LinearChannel_Y0V,
                B.LinearChannel_cPl,
                B.LinearChannel_ABN
            ], type$.JSArray_LinearChannel);
            B.A98RgbColorSpace_lf2 = new A.A98RgbColorSpace("a98-rgb", B.List_U47);
            B.LinearChannel_Y0V0 = new A.LinearChannel0(0, 1, false, false, false, "red", false, null);
            B.LinearChannel_cPl0 = new A.LinearChannel0(0, 1, false, false, false, "green", false, null);
            B.LinearChannel_ABN0 = new A.LinearChannel0(0, 1, false, false, false, "blue", false, null);
            B.List_U470 = makeConstList([
                B.LinearChannel_Y0V0,
                B.LinearChannel_cPl0,
                B.LinearChannel_ABN0
            ], type$.JSArray_LinearChannel_2);
            B.A98RgbColorSpace_lf20 = new A.A98RgbColorSpace0("a98-rgb", B.List_U470);
            B.AsciiEncoder_127 = new A.AsciiEncoder(127);
            B.C_EmptyUnmodifiableSet1 = new A.EmptyUnmodifiableSet(A.findType("EmptyUnmodifiableSet<String>"));
            B.AtRootQuery_bfj = new A.AtRootQuery(false, B.C_EmptyUnmodifiableSet1, false, true);
            B.AtRootQuery_bfj0 = new A.AtRootQuery0(false, B.C_EmptyUnmodifiableSet1, false, true);
            B.AttributeOperator_OrK = new A.AttributeOperator("~=", 1, "include");
            B.AttributeOperator_OrK0 = new A.AttributeOperator0("~=", 1, "include");
            B.AttributeOperator_g5B = new A.AttributeOperator("|=", 2, "dash");
            B.AttributeOperator_g5B0 = new A.AttributeOperator0("|=", 2, "dash");
            B.AttributeOperator_h20 = new A.AttributeOperator("*=", 5, "substring");
            B.AttributeOperator_h200 = new A.AttributeOperator0("*=", 5, "substring");
            B.AttributeOperator_jFZ = new A.AttributeOperator("=", 0, "equal");
            B.AttributeOperator_jFZ0 = new A.AttributeOperator0("=", 0, "equal");
            B.AttributeOperator_stc = new A.AttributeOperator("^=", 3, "prefix");
            B.AttributeOperator_stc0 = new A.AttributeOperator0("^=", 3, "prefix");
            B.AttributeOperator_xJ9 = new A.AttributeOperator("$=", 4, "suffix");
            B.AttributeOperator_xJ90 = new A.AttributeOperator0("$=", 4, "suffix");
            B.BinaryOperator_5vK = new A.BinaryOperator("and", "and", 2, true, 2, "and");
            B.BinaryOperator_5vK0 = new A.BinaryOperator0("and", "and", 2, true, 2, "and");
            B.BinaryOperator_CG2 = new A.BinaryOperator("less than", "<", 4, false, 7, "lessThan");
            B.BinaryOperator_CG20 = new A.BinaryOperator0("less than", "<", 4, false, 7, "lessThan");
            B.BinaryOperator_Fv2 = new A.BinaryOperator("not equals", "!=", 3, false, 4, "notEquals");
            B.BinaryOperator_Fv20 = new A.BinaryOperator0("not equals", "!=", 3, false, 4, "notEquals");
            B.BinaryOperator_K7S = new A.BinaryOperator("equals", "==", 3, false, 3, "equals");
            B.BinaryOperator_K7S0 = new A.BinaryOperator0("equals", "==", 3, false, 3, "equals");
            B.BinaryOperator_OOf = new A.BinaryOperator("or", "or", 1, true, 1, "or");
            B.BinaryOperator_OOf0 = new A.BinaryOperator0("or", "or", 1, true, 1, "or");
            B.BinaryOperator_Tic = new A.BinaryOperator("greater than", ">", 4, false, 5, "greaterThan");
            B.BinaryOperator_Tic0 = new A.BinaryOperator0("greater than", ">", 4, false, 5, "greaterThan");
            B.BinaryOperator_YGt = new A.BinaryOperator("greater than or equals", ">=", 4, false, 6, "greaterThanOrEquals");
            B.BinaryOperator_YGt0 = new A.BinaryOperator0("greater than or equals", ">=", 4, false, 6, "greaterThanOrEquals");
            B.BinaryOperator_bgA = new A.BinaryOperator("modulo", "%", 6, false, 13, "modulo");
            B.BinaryOperator_bgA0 = new A.BinaryOperator0("modulo", "%", 6, false, 13, "modulo");
            B.BinaryOperator_ehp = new A.BinaryOperator("divided by", "/", 6, false, 12, "dividedBy");
            B.BinaryOperator_ehp0 = new A.BinaryOperator0("divided by", "/", 6, false, 12, "dividedBy");
            B.BinaryOperator_f2c = new A.BinaryOperator("less than or equals", "<=", 4, false, 8, "lessThanOrEquals");
            B.BinaryOperator_f2c0 = new A.BinaryOperator0("less than or equals", "<=", 4, false, 8, "lessThanOrEquals");
            B.BinaryOperator_g6F = new A.BinaryOperator("single equals", "=", 0, false, 0, "singleEquals");
            B.BinaryOperator_g6F0 = new A.BinaryOperator0("single equals", "=", 0, false, 0, "singleEquals");
            B.BinaryOperator_jCK = new A.BinaryOperator("plus", "+", 5, true, 9, "plus");
            B.BinaryOperator_jCK0 = new A.BinaryOperator0("plus", "+", 5, true, 9, "plus");
            B.BinaryOperator_tDf = new A.BinaryOperator("minus", "-", 5, false, 10, "minus");
            B.BinaryOperator_tDf0 = new A.BinaryOperator0("minus", "-", 5, false, 10, "minus");
            B.BinaryOperator_wkM = new A.BinaryOperator("times", "*", 6, true, 11, "times");
            B.BinaryOperator_wkM0 = new A.BinaryOperator0("times", "*", 6, true, 11, "times");
            B.BooleanOperator_0 = new A.BooleanOperator(0, "and");
            B.BooleanOperator_00 = new A.BooleanOperator0(0, "and");
            B.BooleanOperator_1 = new A.BooleanOperator(1, "or");
            B.BooleanOperator_10 = new A.BooleanOperator0(1, "or");
            B.CONSTANT = new A.Instantiation1(A.math0__max$closure(), A.findType("Instantiation1<int>"));
            B.C_AsciiCodec = new A.AsciiCodec();
            B.C_AsciiGlyphSet = new A.AsciiGlyphSet();
            B.C_Base64Encoder = new A.Base64Encoder();
            B.C_Base64Codec = new A.Base64Codec();
            B.C_DefaultEquality = new A.DefaultEquality();
            B.C_DefaultLogger = new A.DefaultLogger();
            B.C_DefaultLogger0 = new A.DefaultLogger0();
            B.C_EmptyExtensionStore = new A.EmptyExtensionStore();
            B.C_EmptyExtensionStore0 = new A.EmptyExtensionStore0();
            B.C_EmptyIterator = new A.EmptyIterator();
            B.C_EmptyUnmodifiableSet = new A.EmptyUnmodifiableSet(A.findType("EmptyUnmodifiableSet<SimpleSelector>"));
            B.C_EmptyUnmodifiableSet0 = new A.EmptyUnmodifiableSet(A.findType("EmptyUnmodifiableSet<SimpleSelector0>"));
            B.C_IsCalculationSafeVisitor = new A.IsCalculationSafeVisitor();
            B.C_IsCalculationSafeVisitor0 = new A.IsCalculationSafeVisitor0();
            B.C_IterableEquality = new A.IterableEquality();
            B.C_JS_CONST = function getTagFallback(o) {
                var s = Object.prototype.toString.call(o);
                return s.substring(8, s.length - 1);
            };
            B.C_JS_CONST0 = function() {
                var toStringFunction = Object.prototype.toString;
                function getTag(o) {
                    var s = toStringFunction.call(o);
                    return s.substring(8, s.length - 1);
                }
                function getUnknownTag(object, tag) {
                    if (/^HTML[A-Z].*Element$/.test(tag)) {
                        var name = toStringFunction.call(object);
                        if (name == "[object Object]") return null;
                        return "HTMLElement";
                    }
                }
                function getUnknownTagGenericBrowser(object, tag) {
                    if (object instanceof HTMLElement) return "HTMLElement";
                    return getUnknownTag(object, tag);
                }
                function prototypeForTag(tag) {
                    if (typeof window == "undefined") return null;
                    if (typeof window[tag] == "undefined") return null;
                    var constructor = window[tag];
                    if (typeof constructor != "function") return null;
                    return constructor.prototype;
                }
                function discriminator(tag) {
                    return null;
                }
                var isBrowser = typeof HTMLElement == "function";
                return {
                    getTag: getTag,
                    getUnknownTag: isBrowser ? getUnknownTagGenericBrowser : getUnknownTag,
                    prototypeForTag: prototypeForTag,
                    discriminator: discriminator
                };
            };
            B.C_JS_CONST6 = function(getTagFallback) {
                return function(hooks) {
                    if ((typeof navigator === "undefined" ? "undefined" : (0, $6tOPT._)(navigator)) != "object") return hooks;
                    var userAgent = navigator.userAgent;
                    if (typeof userAgent != "string") return hooks;
                    if (userAgent.indexOf("DumpRenderTree") >= 0) return hooks;
                    if (userAgent.indexOf("Chrome") >= 0) {
                        function confirm(p) {
                            return (typeof window === "undefined" ? "undefined" : (0, $6tOPT._)(window)) == "object" && window[p] && window[p].name == p;
                        }
                        if (confirm("Window") && confirm("HTMLElement")) return hooks;
                    }
                    hooks.getTag = getTagFallback;
                };
            };
            B.C_JS_CONST1 = function(hooks) {
                if (typeof dartExperimentalFixupGetTag != "function") return hooks;
                hooks.getTag = dartExperimentalFixupGetTag(hooks.getTag);
            };
            B.C_JS_CONST5 = function(hooks) {
                if ((typeof navigator === "undefined" ? "undefined" : (0, $6tOPT._)(navigator)) != "object") return hooks;
                var userAgent = navigator.userAgent;
                if (typeof userAgent != "string") return hooks;
                if (userAgent.indexOf("Firefox") == -1) return hooks;
                var getTag = hooks.getTag;
                var quickMap = {
                    "BeforeUnloadEvent": "Event",
                    "DataTransfer": "Clipboard",
                    "GeoGeolocation": "Geolocation",
                    "Location": "!Location",
                    "WorkerMessageEvent": "MessageEvent",
                    "XMLDocument": "!Document"
                };
                function getTagFirefox(o) {
                    var tag = getTag(o);
                    return quickMap[tag] || tag;
                }
                hooks.getTag = getTagFirefox;
            };
            B.C_JS_CONST4 = function(hooks) {
                if ((typeof navigator === "undefined" ? "undefined" : (0, $6tOPT._)(navigator)) != "object") return hooks;
                var userAgent = navigator.userAgent;
                if (typeof userAgent != "string") return hooks;
                if (userAgent.indexOf("Trident/") == -1) return hooks;
                var getTag = hooks.getTag;
                var quickMap = {
                    "BeforeUnloadEvent": "Event",
                    "DataTransfer": "Clipboard",
                    "HTMLDDElement": "HTMLElement",
                    "HTMLDTElement": "HTMLElement",
                    "HTMLPhraseElement": "HTMLElement",
                    "Position": "Geoposition"
                };
                function getTagIE(o) {
                    var tag = getTag(o);
                    var newTag = quickMap[tag];
                    if (newTag) return newTag;
                    if (tag == "Object") {
                        if (window.DataView && o instanceof window.DataView) return "DataView";
                    }
                    return tag;
                }
                function prototypeForTagIE(tag) {
                    var constructor = window[tag];
                    if (constructor == null) return null;
                    return constructor.prototype;
                }
                hooks.getTag = getTagIE;
                hooks.prototypeForTag = prototypeForTagIE;
            };
            B.C_JS_CONST2 = function(hooks) {
                var getTag = hooks.getTag;
                var prototypeForTag = hooks.prototypeForTag;
                function getTagFixed(o) {
                    var tag = getTag(o);
                    if (tag == "Document") {
                        if (!!o.xmlVersion) return "!Document";
                        return "!HTMLDocument";
                    }
                    return tag;
                }
                function prototypeForTagFixed(tag) {
                    if (tag == "Document") return null;
                    return prototypeForTag(tag);
                }
                hooks.getTag = getTagFixed;
                hooks.prototypeForTag = prototypeForTagFixed;
            };
            B.C_JS_CONST3 = function(hooks) {
                return hooks;
            };
            B.C_JsonCodec = new A.JsonCodec();
            B.C_ListEquality0 = new A.ListEquality();
            B.C_ListEquality = new A.ListEquality();
            B.C_MapEquality = new A.MapEquality(A.findType("MapEquality<Object,Object>"));
            B.C_OutOfMemoryError = new A.OutOfMemoryError();
            B.C_SentinelValue = new A.SentinelValue();
            B.C_UnicodeGlyphSet = new A.UnicodeGlyphSet();
            B.C_Utf8Codec = new A.Utf8Codec();
            B.C_Utf8Encoder = new A.Utf8Encoder();
            B.C__ColorFormatEnum = new A._ColorFormatEnum();
            B.C__ColorFormatEnum0 = new A._ColorFormatEnum0();
            B.C__ContainsParentSelectorVisitor = new A._ContainsParentSelectorVisitor();
            B.C__ContainsParentSelectorVisitor0 = new A._ContainsParentSelectorVisitor0();
            B.C__DelayedDone = new A._DelayedDone();
            B.C__HasContentVisitor = new A._HasContentVisitor();
            B.C__HasContentVisitor0 = new A._HasContentVisitor0();
            B.C__IsUselessVisitor = new A._IsUselessVisitor();
            B.C__IsUselessVisitor0 = new A._IsUselessVisitor0();
            B.C__JSRandom = new A._JSRandom();
            B.C__MakeExpressionCalculationSafe = new A._MakeExpressionCalculationSafe();
            B.C__MakeExpressionCalculationSafe0 = new A._MakeExpressionCalculationSafe0();
            B.C__ParentSelectorVisitor = new A._ParentSelectorVisitor();
            B.C__ParentSelectorVisitor0 = new A._ParentSelectorVisitor0();
            B.C__Required = new A._Required();
            B.C__RootZone = new A._RootZone();
            B.C__SassNull = new A._SassNull();
            B.C__SassNull0 = new A._SassNull0();
            B.CalculationOperator_KrC = new A.CalculationOperator("minus", "-", 1, 1, "minus");
            B.CalculationOperator_KrC0 = new A.CalculationOperator0("minus", "-", 1, 1, "minus");
            B.CalculationOperator_LPB = new A.CalculationOperator("times", "*", 2, 2, "times");
            B.CalculationOperator_LPB0 = new A.CalculationOperator0("times", "*", 2, 2, "times");
            B.CalculationOperator_dpX = new A.CalculationOperator("plus", "+", 1, 0, "plus");
            B.CalculationOperator_dpX0 = new A.CalculationOperator0("plus", "+", 1, 0, "plus");
            B.CalculationOperator_wFL = new A.CalculationOperator("divided by", "/", 2, 3, "dividedBy");
            B.CalculationOperator_wFL0 = new A.CalculationOperator0("divided by", "/", 2, 3, "dividedBy");
            B.ChangeType_add = new A.ChangeType("add");
            B.ChangeType_modify = new A.ChangeType("modify");
            B.ChangeType_remove = new A.ChangeType("remove");
            B.ClipGamutMap_clip = new A.ClipGamutMap("clip");
            B.ClipGamutMap_clip0 = new A.ClipGamutMap0("clip");
            B.Combinator_98W = new A.Combinator("~", 2, "followingSibling");
            B.Combinator_98W0 = new A.Combinator0("~", 2, "followingSibling");
            B.Combinator_iUF = new A.Combinator(">", 1, "child");
            B.Combinator_iUF0 = new A.Combinator0(">", 1, "child");
            B.Combinator_sHB = new A.Combinator("+", 0, "nextSibling");
            B.Combinator_sHB0 = new A.Combinator0("+", 0, "nextSibling");
            B.Object_empty = {};
            B.Map_empty18 = new A.ConstantStringMap(B.Object_empty, [], A.findType("ConstantStringMap<String,ConfiguredValue>"));
            B.Configuration_Map_empty_null = new A.Configuration(B.Map_empty18, null);
            B.Map_empty19 = new A.ConstantStringMap(B.Object_empty, [], A.findType("ConstantStringMap<String,ConfiguredValue0>"));
            B.Configuration_Map_empty_null0 = new A.Configuration0(B.Map_empty19, null);
            B.Deprecation_0rM = new A.Deprecation("bogus-combinators", "1.54.0", null, 7, "bogusCombinators");
            B.Deprecation_2Ja = new A.Deprecation0("function-name", "1.98.0", "Uppercase reserved function names.", null, 27, "functionName");
            B.Deprecation_2PR = new A.Deprecation0("bogus-combinators", "1.54.0", "Leading, trailing, and repeated combinators.", null, 7, "bogusCombinators");
            B.Deprecation_6BW = new A.Deprecation("import", "1.80.0", null, 20, "import");
            B.Deprecation_7Bn = new A.Deprecation("color-module-compat", "1.23.0", null, 5, "colorModuleCompat");
            B.Deprecation_7TE = new A.Deprecation("function-units", "1.56.0", null, 9, "functionUnits");
            B.Deprecation_8Zg = new A.Deprecation("misplaced-rest", "1.91.0", null, 24, "misplacedRest");
            B.Deprecation_DVV = new A.Deprecation0("duplicate-var-flags", "1.62.0", "Using !default or !global multiple times for one variable.", null, 10, "duplicateVarFlags");
            B.Deprecation_Gmv = new A.Deprecation0("moz-document", "1.7.2", "@-moz-document.", null, 2, "mozDocument");
            B.Deprecation_H4k = new A.Deprecation("function-name", "1.98.0", null, 27, "functionName");
            B.Deprecation_HUu = new A.Deprecation("elseif", "1.3.2", null, 1, "elseif");
            B.Deprecation_IqB = new A.Deprecation("relative-canonical", "1.14.2", null, 3, "relativeCanonical");
            B.Deprecation_Jgi = new A.Deprecation0("misplaced-rest", "1.91.0", "A rest parameter before a positional or named parameter.", null, 24, "misplacedRest");
            B.Deprecation_K9u = new A.Deprecation("strict-unary", "1.55.0", null, 8, "strictUnary");
            B.Deprecation_Kh7 = new A.Deprecation0("strict-unary", "1.55.0", "Ambiguous + and - operators.", null, 8, "strictUnary");
            B.Deprecation_L3L = new A.Deprecation0("import", "1.80.0", "@import rules.", null, 20, "import");
            B.Deprecation_LIY = new A.Deprecation0("call-string", "0.0.0", "Passing a string directly to meta.call().", null, 0, "callString");
            B.Deprecation_LUk = new A.Deprecation0("fs-importer-cwd", "1.73.0", "Using the current working directory as an implicit load path.", null, 13, "fsImporterCwd");
            B.Deprecation_PGp = new A.Deprecation0("legacy-js-api", "1.79.0", "Legacy JS API.", null, 19, "legacyJsApi");
            B.Deprecation_PHd = new A.Deprecation0("function-units", "1.56.0", "Passing invalid units to built-in functions.", null, 9, "functionUnits");
            B.Deprecation_PY0 = new A.Deprecation("feature-exists", "1.78.0", null, 16, "featureExists");
            B.Deprecation_PmQ = new A.Deprecation("moz-document", "1.7.2", null, 2, "mozDocument");
            B.Deprecation_SGB = new A.Deprecation0("global-builtin", "1.80.0", "Global built-in functions that are available in sass: modules.", null, 21, "globalBuiltin");
            B.Deprecation_Szt = new A.Deprecation0("calc-interp", null, null, null, 30, "calcInterp");
            B.Deprecation_Usi = new A.Deprecation("abs-percent", "1.65.0", null, 12, "absPercent");
            B.Deprecation_V8h = new A.Deprecation("adjacent-compounds", "1.100.0", null, 28, "adjacentCompounds");
            B.Deprecation_VUl = new A.Deprecation0("elseif", "1.3.2", "@elseif.", null, 1, "elseif");
            B.Deprecation_Vc9 = new A.Deprecation0("relative-canonical", "1.14.2", "Imports using relative canonical URLs.", null, 3, "relativeCanonical");
            B.Deprecation_WW3 = new A.Deprecation("global-builtin", "1.80.0", null, 21, "globalBuiltin");
            B.Deprecation_alT = new A.Deprecation0("color-4-api", "1.79.0", "Certain uses of built-in sass:color functions.", null, 17, "color4Api");
            B.Deprecation_c4i = new A.Deprecation("call-string", "0.0.0", null, 0, "callString");
            B.Deprecation_dlf = new A.Deprecation0("user-authored", null, null, null, 29, "userAuthored");
            B.Deprecation_gGh = new A.Deprecation("user-authored", null, null, 29, "userAuthored");
            B.Deprecation_hJG = new A.Deprecation0("color-functions", "1.79.0", "Using global color functions instead of sass:color.", null, 18, "colorFunctions");
            B.Deprecation_jGw = new A.Deprecation("new-global", "1.17.2", null, 4, "newGlobal");
            B.Deprecation_ldS = new A.Deprecation0("adjacent-compounds", "1.100.0", "Adjacent compound selectors like `[class]a`.", null, 28, "adjacentCompounds");
            B.Deprecation_lkJ = new A.Deprecation0("with-private", "1.92.0", "Configuring private variables in @use, @forward, or load-css().", null, 25, "withPrivate");
            B.Deprecation_mXO = new A.Deprecation("with-private", "1.92.0", null, 25, "withPrivate");
            B.Deprecation_mqF = new A.Deprecation0("color-module-compat", "1.23.0", "Using color module functions in place of plain CSS functions.", null, 5, "colorModuleCompat");
            B.Deprecation_nRC = new A.Deprecation("duplicate-var-flags", "1.62.0", null, 10, "duplicateVarFlags");
            B.Deprecation_ox0 = new A.Deprecation0("null-alpha", "1.62.3", "Passing null as alpha in the JS API.", null, 11, "nullAlpha");
            B.Deprecation_p2t = new A.Deprecation0("feature-exists", "1.78.0", "meta.feature-exists", null, 16, "featureExists");
            B.Deprecation_pwd = new A.Deprecation0("new-global", "1.17.2", "Declaring new variables with !global.", null, 4, "newGlobal");
            B.Deprecation_qPD = new A.Deprecation("if-function", "1.95.0", null, 26, "ifFunction");
            B.Deprecation_qZ1 = new A.Deprecation("slash-div", "1.33.0", null, 6, "slashDiv");
            B.Deprecation_qka = new A.Deprecation0("if-function", "1.95.0", "The Sass if($condition, $if-true, $if-false) function.", null, 26, "ifFunction");
            B.Deprecation_r8S = new A.Deprecation("compile-string-relative-url", "1.88.0", null, 23, "compileStringRelativeUrl");
            B.Deprecation_uJ0 = new A.Deprecation("fs-importer-cwd", "1.73.0", null, 13, "fsImporterCwd");
            B.Deprecation_v81 = new A.Deprecation0("slash-div", "1.33.0", "/ operator for division.", null, 6, "slashDiv");
            B.Deprecation_w3M = new A.Deprecation0("abs-percent", "1.65.0", "Passing percentages to the Sass abs() function.", null, 12, "absPercent");
            B.Deprecation_y9Y = new A.Deprecation0("compile-string-relative-url", "1.88.0", "Passing a relative url to compileString().", null, 23, "compileStringRelativeUrl");
            B.Deprecation_zUK = new A.Deprecation("color-functions", "1.79.0", null, 18, "colorFunctions");
            B.DisplayP3ColorSpace_MmT = new A.DisplayP3ColorSpace("display-p3", B.List_U47);
            B.DisplayP3ColorSpace_MmT0 = new A.DisplayP3ColorSpace0("display-p3", B.List_U470);
            B.DisplayP3LinearColorSpace_PrP = new A.DisplayP3LinearColorSpace("display-p3-linear", B.List_U47);
            B.DisplayP3LinearColorSpace_PrP0 = new A.DisplayP3LinearColorSpace0("display-p3-linear", B.List_U470);
            B.Duration_0 = new A.Duration(0);
            B.ExtendMode_allTargets_2_allTargets = new A.ExtendMode("allTargets", 2, "allTargets");
            B.ExtendMode_allTargets_2_allTargets0 = new A.ExtendMode0("allTargets", 2, "allTargets");
            B.ExtendMode_normal_0_normal = new A.ExtendMode("normal", 0, "normal");
            B.ExtendMode_normal_0_normal0 = new A.ExtendMode0("normal", 0, "normal");
            B.ExtendMode_replace_1_replace = new A.ExtendMode("replace", 1, "replace");
            B.ExtendMode_replace_1_replace0 = new A.ExtendMode0("replace", 1, "replace");
            B.ColorChannel_hue_true_deg = new A.ColorChannel("hue", true, "deg");
            B.LinearChannel_Cal = new A.LinearChannel(0, 100, true, true, false, "saturation", false, "%");
            B.LinearChannel_w1m = new A.LinearChannel(0, 100, true, false, false, "lightness", false, "%");
            B.List_oAL = makeConstList([
                B.ColorChannel_hue_true_deg,
                B.LinearChannel_Cal,
                B.LinearChannel_w1m
            ], type$.JSArray_ColorChannel);
            B.HslColorSpace_JQ2 = new A.HslColorSpace("hsl", B.List_oAL);
            B.ColorChannel_hue_true_deg0 = new A.ColorChannel0("hue", true, "deg");
            B.LinearChannel_Cal0 = new A.LinearChannel0(0, 100, true, true, false, "saturation", false, "%");
            B.LinearChannel_w1m0 = new A.LinearChannel0(0, 100, true, false, false, "lightness", false, "%");
            B.List_oAL0 = makeConstList([
                B.ColorChannel_hue_true_deg0,
                B.LinearChannel_Cal0,
                B.LinearChannel_w1m0
            ], type$.JSArray_ColorChannel_2);
            B.HslColorSpace_JQ20 = new A.HslColorSpace0("hsl", B.List_oAL0);
            B.HueInterpolationMethod_0 = new A.HueInterpolationMethod(0, "shorter");
            B.HueInterpolationMethod_00 = new A.HueInterpolationMethod0(0, "shorter");
            B.HueInterpolationMethod_1 = new A.HueInterpolationMethod(1, "longer");
            B.HueInterpolationMethod_10 = new A.HueInterpolationMethod0(1, "longer");
            B.HueInterpolationMethod_2 = new A.HueInterpolationMethod(2, "increasing");
            B.HueInterpolationMethod_20 = new A.HueInterpolationMethod0(2, "increasing");
            B.HueInterpolationMethod_3 = new A.HueInterpolationMethod(3, "decreasing");
            B.HueInterpolationMethod_30 = new A.HueInterpolationMethod0(3, "decreasing");
            B.LinearChannel_mPM = new A.LinearChannel(0, 100, true, false, false, "whiteness", false, "%");
            B.LinearChannel_NBP = new A.LinearChannel(0, 100, true, false, false, "blackness", false, "%");
            B.List_Ar1 = makeConstList([
                B.ColorChannel_hue_true_deg,
                B.LinearChannel_mPM,
                B.LinearChannel_NBP
            ], type$.JSArray_ColorChannel);
            B.HwbColorSpace_guQ = new A.HwbColorSpace("hwb", B.List_Ar1);
            B.LinearChannel_mPM0 = new A.LinearChannel0(0, 100, true, false, false, "whiteness", false, "%");
            B.LinearChannel_NBP0 = new A.LinearChannel0(0, 100, true, false, false, "blackness", false, "%");
            B.List_Ar10 = makeConstList([
                B.ColorChannel_hue_true_deg0,
                B.LinearChannel_mPM0,
                B.LinearChannel_NBP0
            ], type$.JSArray_ColorChannel_2);
            B.HwbColorSpace_guQ0 = new A.HwbColorSpace0("hwb", B.List_Ar10);
            B.JsonDecoder_null = new A.JsonDecoder(null);
            B.JsonEncoder_null = new A.JsonEncoder(null);
            B.LinearChannel_rY5 = new A.LinearChannel(0, 100, false, true, true, "lightness", false, "%");
            B.LinearChannel_vtc = new A.LinearChannel(-125, 125, false, false, false, "a", false, null);
            B.LinearChannel_r83 = new A.LinearChannel(-125, 125, false, false, false, "b", false, null);
            B.List_KEo = makeConstList([
                B.LinearChannel_rY5,
                B.LinearChannel_vtc,
                B.LinearChannel_r83
            ], type$.JSArray_ColorChannel);
            B.LabColorSpace_2nT = new A.LabColorSpace("lab", B.List_KEo);
            B.LinearChannel_rY50 = new A.LinearChannel0(0, 100, false, true, true, "lightness", false, "%");
            B.LinearChannel_vtc0 = new A.LinearChannel0(-125, 125, false, false, false, "a", false, null);
            B.LinearChannel_r830 = new A.LinearChannel0(-125, 125, false, false, false, "b", false, null);
            B.List_KEo0 = makeConstList([
                B.LinearChannel_rY50,
                B.LinearChannel_vtc0,
                B.LinearChannel_r830
            ], type$.JSArray_ColorChannel_2);
            B.LabColorSpace_2nT0 = new A.LabColorSpace0("lab", B.List_KEo0);
            B.LinearChannel_JUs = new A.LinearChannel(0, 150, false, true, false, "chroma", false, null);
            B.List_grF = makeConstList([
                B.LinearChannel_rY5,
                B.LinearChannel_JUs,
                B.ColorChannel_hue_true_deg
            ], type$.JSArray_ColorChannel);
            B.LchColorSpace_Bpv = new A.LchColorSpace("lch", B.List_grF);
            B.LinearChannel_JUs0 = new A.LinearChannel0(0, 150, false, true, false, "chroma", false, null);
            B.List_grF0 = makeConstList([
                B.LinearChannel_rY50,
                B.LinearChannel_JUs0,
                B.ColorChannel_hue_true_deg0
            ], type$.JSArray_ColorChannel_2);
            B.LchColorSpace_Bpv0 = new A.LchColorSpace0("lch", B.List_grF0);
            B.LineFeed_2_lf = new A.LineFeed(2, "lf");
            B.LineFeed_3HY = new A.LineFeed0("cr", "\r", 0, "cr");
            B.LineFeed_Kui = new A.LineFeed0("lfcr", "\n\r", 3, "lfcr");
            B.LineFeed_aqi = new A.LineFeed0("crlf", "\r\n", 1, "crlf");
            B.LineFeed_oJz = new A.LineFeed0("lf", "\n", 2, "lf");
            B.LinearChannel_XL8 = new A.LinearChannel(0, 1, false, false, false, "alpha", false, null);
            B.LinearChannel_XL80 = new A.LinearChannel0(0, 1, false, false, false, "alpha", false, null);
            B.LinearChannel_Z5r = new A.LinearChannel(0, 255, false, true, true, "green", false, null);
            B.LinearChannel_Z5r0 = new A.LinearChannel0(0, 255, false, true, true, "green", false, null);
            B.LinearChannel_qXC = new A.LinearChannel(0, 255, false, true, true, "red", false, null);
            B.LinearChannel_qXC0 = new A.LinearChannel0(0, 255, false, true, true, "red", false, null);
            B.LinearChannel_vJ3 = new A.LinearChannel(0, 255, false, true, true, "blue", false, null);
            B.LinearChannel_vJ30 = new A.LinearChannel0(0, 255, false, true, true, "blue", false, null);
            B.ListSeparator_Lul = new A.ListSeparator("slash", "/", 2, "slash");
            B.ListSeparator_Lul0 = new A.ListSeparator0("slash", "/", 2, "slash");
            B.ListSeparator_SrV = new A.ListSeparator("space", " ", 0, "space");
            B.ListSeparator_SrV0 = new A.ListSeparator0("space", " ", 0, "space");
            B.ListSeparator_undecided_null_3_undecided = new A.ListSeparator("undecided", null, 3, "undecided");
            B.ListSeparator_undecided_null_3_undecided0 = new A.ListSeparator0("undecided", null, 3, "undecided");
            B.ListSeparator_z0K = new A.ListSeparator("comma", ",", 1, "comma");
            B.ListSeparator_z0K0 = new A.ListSeparator0("comma", ",", 1, "comma");
            B.Object_84Z = {
                em: 0,
                rem: 1,
                ex: 2,
                rex: 3,
                cap: 4,
                rcap: 5,
                ch: 6,
                rch: 7,
                ic: 8,
                ric: 9,
                lh: 10,
                rlh: 11,
                vw: 12,
                lvw: 13,
                svw: 14,
                dvw: 15,
                vh: 16,
                lvh: 17,
                svh: 18,
                dvh: 19,
                vi: 20,
                lvi: 21,
                svi: 22,
                dvi: 23,
                vb: 24,
                lvb: 25,
                svb: 26,
                dvb: 27,
                vmin: 28,
                lvmin: 29,
                svmin: 30,
                dvmin: 31,
                vmax: 32,
                lvmax: 33,
                svmax: 34,
                dvmax: 35,
                cqw: 36,
                cqh: 37,
                cqi: 38,
                cqb: 39,
                cqmin: 40,
                cqmax: 41,
                cm: 42,
                mm: 43,
                q: 44,
                in: 45,
                pt: 46,
                pc: 47,
                px: 48
            };
            B.Set_V30th = new A.ConstantStringSet(B.Object_84Z, 49, type$.ConstantStringSet_String);
            B.Object_a6W = {
                deg: 0,
                grad: 1,
                rad: 2,
                turn: 3
            };
            B.Set_5FBBb = new A.ConstantStringSet(B.Object_a6W, 4, type$.ConstantStringSet_String);
            B.Object_s_0_ms_1 = {
                s: 0,
                ms: 1
            };
            B.Set_cXesm = new A.ConstantStringSet(B.Object_s_0_ms_1, 2, type$.ConstantStringSet_String);
            B.Object_hz_0_khz_1 = {
                hz: 0,
                khz: 1
            };
            B.Set_1Tayw = new A.ConstantStringSet(B.Object_hz_0_khz_1, 2, type$.ConstantStringSet_String);
            B.Object_CHz = {
                dpi: 0,
                dpcm: 1,
                dppx: 2
            };
            B.Set_w2NC6 = new A.ConstantStringSet(B.Object_CHz, 3, type$.ConstantStringSet_String);
            B.List_BFg = makeConstList([
                B.Set_V30th,
                B.Set_5FBBb,
                B.Set_cXesm,
                B.Set_1Tayw,
                B.Set_w2NC6
            ], A.findType("JSArray<Set<String>>"));
            B.Deprecation_uqF = new A.Deprecation0("css-function-mixin", "1.76.0", "Function and mixin names beginning with --.", "1.94.0", 14, "cssFunctionMixin");
            B.Deprecation_Fpx = new A.Deprecation0("mixed-decls", "1.77.7", "Declarations after or between nested rules.", "1.92.0", 15, "mixedDecls");
            B.Deprecation_Byo = new A.Deprecation0("type-function", "1.86.0", 'Functions named "type".', "1.92.0", 22, "typeFunction");
            B.List_JA2 = makeConstList([
                B.Deprecation_LIY,
                B.Deprecation_VUl,
                B.Deprecation_Gmv,
                B.Deprecation_Vc9,
                B.Deprecation_pwd,
                B.Deprecation_mqF,
                B.Deprecation_v81,
                B.Deprecation_2PR,
                B.Deprecation_Kh7,
                B.Deprecation_PHd,
                B.Deprecation_DVV,
                B.Deprecation_ox0,
                B.Deprecation_w3M,
                B.Deprecation_LUk,
                B.Deprecation_uqF,
                B.Deprecation_Fpx,
                B.Deprecation_p2t,
                B.Deprecation_alT,
                B.Deprecation_hJG,
                B.Deprecation_PGp,
                B.Deprecation_L3L,
                B.Deprecation_SGB,
                B.Deprecation_Byo,
                B.Deprecation_y9Y,
                B.Deprecation_Jgi,
                B.Deprecation_lkJ,
                B.Deprecation_qka,
                B.Deprecation_2Ja,
                B.Deprecation_ldS,
                B.Deprecation_dlf,
                B.Deprecation_Szt
            ], A.findType("JSArray<Deprecation0>"));
            B.List_UqK = makeConstList([
                B.CalculationOperator_dpX0,
                B.CalculationOperator_KrC0,
                B.CalculationOperator_LPB0,
                B.CalculationOperator_wFL0
            ], A.findType("JSArray<CalculationOperator0>"));
            B.Deprecation_NNd = new A.Deprecation("null-alpha", "1.62.3", null, 11, "nullAlpha");
            B.Deprecation_ov6 = new A.Deprecation("css-function-mixin", "1.76.0", "1.94.0", 14, "cssFunctionMixin");
            B.Deprecation_Uqa = new A.Deprecation("mixed-decls", "1.77.7", "1.92.0", 15, "mixedDecls");
            B.Deprecation_mme = new A.Deprecation("color-4-api", "1.79.0", null, 17, "color4Api");
            B.Deprecation_cfK = new A.Deprecation("legacy-js-api", "1.79.0", null, 19, "legacyJsApi");
            B.Deprecation_ST9 = new A.Deprecation("type-function", "1.86.0", "1.92.0", 22, "typeFunction");
            B.Deprecation_qDQ = new A.Deprecation("calc-interp", null, null, 30, "calcInterp");
            B.List_bLL = makeConstList([
                B.Deprecation_c4i,
                B.Deprecation_HUu,
                B.Deprecation_PmQ,
                B.Deprecation_IqB,
                B.Deprecation_jGw,
                B.Deprecation_7Bn,
                B.Deprecation_qZ1,
                B.Deprecation_0rM,
                B.Deprecation_K9u,
                B.Deprecation_7TE,
                B.Deprecation_nRC,
                B.Deprecation_NNd,
                B.Deprecation_Usi,
                B.Deprecation_uJ0,
                B.Deprecation_ov6,
                B.Deprecation_Uqa,
                B.Deprecation_PY0,
                B.Deprecation_mme,
                B.Deprecation_zUK,
                B.Deprecation_cfK,
                B.Deprecation_6BW,
                B.Deprecation_WW3,
                B.Deprecation_ST9,
                B.Deprecation_r8S,
                B.Deprecation_8Zg,
                B.Deprecation_mXO,
                B.Deprecation_qPD,
                B.Deprecation_H4k,
                B.Deprecation_V8h,
                B.Deprecation_gGh,
                B.Deprecation_qDQ
            ], A.findType("JSArray<Deprecation>"));
            B.List_empty29 = makeConstList([], type$.JSArray_AsyncCallable_2);
            B.List_empty31 = makeConstList([], type$.JSArray_AsyncImporter);
            B.List_empty1 = makeConstList([], type$.JSArray_ComplexSelector);
            B.List_empty18 = makeConstList([], type$.JSArray_ComplexSelector_2);
            B.List_empty2 = makeConstList([], type$.JSArray_ComplexSelectorComponent);
            B.List_empty19 = makeConstList([], type$.JSArray_ComplexSelectorComponent_2);
            B.List_empty11 = makeConstList([], type$.JSArray_ConfiguredVariable);
            B.List_empty26 = makeConstList([], type$.JSArray_ConfiguredVariable_2);
            B.List_empty3 = makeConstList([], type$.JSArray_CssNode);
            B.List_empty20 = makeConstList([], type$.JSArray_CssNode_2);
            B.List_empty0 = makeConstList([], type$.JSArray_CssValue_Combinator);
            B.List_empty17 = makeConstList([], type$.JSArray_CssValue_Combinator_2);
            B.List_empty9 = makeConstList([], type$.JSArray_Expression);
            B.List_empty24 = makeConstList([], type$.JSArray_Expression_2);
            B.List_empty5 = makeConstList([], type$.JSArray_Extension);
            B.List_empty21 = makeConstList([], type$.JSArray_Extension_2);
            B.List_empty28 = makeConstList([], type$.JSArray_Importer_2);
            B.List_empty15 = makeConstList([], type$.JSArray_Module_AsyncCallable);
            B.List_empty10 = makeConstList([], type$.JSArray_Module_Callable);
            B.List_empty7 = makeConstList([], A.findType("JSArray<Module0<0&>>"));
            B.List_empty30 = makeConstList([], type$.JSArray_Module_AsyncCallable_2);
            B.List_empty25 = makeConstList([], type$.JSArray_Module_Callable_2);
            B.List_empty22 = makeConstList([], A.findType("JSArray<Module1<0&>>"));
            B.List_empty12 = makeConstList([], type$.JSArray_Object);
            B.List_empty14 = makeConstList([], type$.JSArray_Parameter);
            B.List_empty27 = makeConstList([], type$.JSArray_Parameter_2);
            B.List_empty16 = makeConstList([], type$.JSArray_Statement);
            B.List_empty = makeConstList([], type$.JSArray_String);
            B.List_empty8 = makeConstList([], type$.JSArray_Value);
            B.List_empty23 = makeConstList([], type$.JSArray_Value_2);
            B.List_empty4 = makeConstList([], type$.JSArray_int);
            B.List_empty6 = makeConstList([], type$.JSArray_dynamic);
            B.List_empty13 = makeConstList([], type$.JSArray_nullable_FileSpan);
            B.List_mRc = makeConstList([
                B.HueInterpolationMethod_00,
                B.HueInterpolationMethod_10,
                B.HueInterpolationMethod_20,
                B.HueInterpolationMethod_30
            ], A.findType("JSArray<HueInterpolationMethod0>"));
            B.List_null = makeConstList([
                null
            ], type$.JSArray_nullable_FileSpan);
            B.LinearChannel_n2W = new A.LinearChannel(0, 1, false, false, false, "long", false, null);
            B.LinearChannel_ZmQ = new A.LinearChannel(0, 1, false, false, false, "medium", false, null);
            B.LinearChannel_yJH = new A.LinearChannel(0, 1, false, false, false, "short", false, null);
            B.List_wOx = makeConstList([
                B.LinearChannel_n2W,
                B.LinearChannel_ZmQ,
                B.LinearChannel_yJH
            ], type$.JSArray_ColorChannel);
            B.LmsColorSpace_Os3 = new A.LmsColorSpace("lms", B.List_wOx);
            B.LinearChannel_n2W0 = new A.LinearChannel0(0, 1, false, false, false, "long", false, null);
            B.LinearChannel_ZmQ0 = new A.LinearChannel0(0, 1, false, false, false, "medium", false, null);
            B.LinearChannel_yJH0 = new A.LinearChannel0(0, 1, false, false, false, "short", false, null);
            B.List_wOx0 = makeConstList([
                B.LinearChannel_n2W0,
                B.LinearChannel_ZmQ0,
                B.LinearChannel_yJH0
            ], type$.JSArray_ColorChannel_2);
            B.LmsColorSpace_Os30 = new A.LmsColorSpace0("lms", B.List_wOx0);
            B.LocalMindeGamutMap_A2x = new A.LocalMindeGamutMap("local-minde");
            B.LocalMindeGamutMap_A2x0 = new A.LocalMindeGamutMap0("local-minde");
            B.Object_CSf = {
                in: 0,
                cm: 1,
                pc: 2,
                mm: 3,
                q: 4,
                pt: 5,
                px: 6,
                deg: 7,
                grad: 8,
                rad: 9,
                turn: 10,
                s: 11,
                ms: 12,
                Hz: 13,
                kHz: 14,
                dpi: 15,
                dpcm: 16,
                dppx: 17
            };
            B.Object_R4j = {
                in: 0,
                cm: 1,
                pc: 2,
                mm: 3,
                q: 4,
                pt: 5,
                px: 6
            };
            B.Map_LdTcR = new A.ConstantStringMap(B.Object_R4j, [
                1,
                0.39370078740157477,
                0.16666666666666666,
                0.03937007874015748,
                0.00984251968503937,
                0.013888888888888888,
                0.010416666666666666
            ], type$.ConstantStringMap_String_double);
            B.Map_LdCjQ = new A.ConstantStringMap(B.Object_R4j, [
                2.54,
                1,
                0.42333333333333334,
                0.1,
                0.025,
                0.035277777777777776,
                0.026458333333333334
            ], type$.ConstantStringMap_String_double);
            B.Map_Ldr6M = new A.ConstantStringMap(B.Object_R4j, [
                6,
                2.3622047244094486,
                1,
                0.2362204724409449,
                0.05905511811023623,
                0.08333333333333333,
                0.0625
            ], type$.ConstantStringMap_String_double);
            B.Map_LdTyG = new A.ConstantStringMap(B.Object_R4j, [
                25.4,
                10,
                4.233333333333333,
                1,
                0.25,
                0.35277777777777775,
                0.26458333333333334
            ], type$.ConstantStringMap_String_double);
            B.Map_Ld577 = new A.ConstantStringMap(B.Object_R4j, [
                101.6,
                40,
                16.933333333333334,
                4,
                1,
                1.411111111111111,
                1.0583333333333333
            ], type$.ConstantStringMap_String_double);
            B.Map_LdIVT = new A.ConstantStringMap(B.Object_R4j, [
                72,
                28.346456692913385,
                12,
                2.834645669291339,
                0.7086614173228347,
                1,
                0.75
            ], type$.ConstantStringMap_String_double);
            B.Map_Ld6L5 = new A.ConstantStringMap(B.Object_R4j, [
                96,
                37.79527559055118,
                16,
                3.7795275590551185,
                0.9448818897637796,
                1.3333333333333333,
                1
            ], type$.ConstantStringMap_String_double);
            B.Map_LjNxM = new A.ConstantStringMap(B.Object_a6W, [
                1,
                0.9,
                57.29577951308232,
                360
            ], type$.ConstantStringMap_String_double);
            B.Map_Lj8V1 = new A.ConstantStringMap(B.Object_a6W, [
                1.1111111111111112,
                1,
                63.66197723675813,
                400
            ], type$.ConstantStringMap_String_double);
            B.Map_LjePw = new A.ConstantStringMap(B.Object_a6W, [
                0.017453292519943295,
                0.015707963267948967,
                1,
                6.283185307179586
            ], type$.ConstantStringMap_String_double);
            B.Map_LjtMd = new A.ConstantStringMap(B.Object_a6W, [
                0.002777777777777778,
                0.0025,
                0.15915494309189535,
                1
            ], type$.ConstantStringMap_String_double);
            B.Map_Aezv1 = new A.ConstantStringMap(B.Object_s_0_ms_1, [
                1,
                0.001
            ], type$.ConstantStringMap_String_double);
            B.Map_AeI7g = new A.ConstantStringMap(B.Object_s_0_ms_1, [
                1000,
                1
            ], type$.ConstantStringMap_String_double);
            B.Object_Hz_0_kHz_1 = {
                Hz: 0,
                kHz: 1
            };
            B.Map_kdDCg = new A.ConstantStringMap(B.Object_Hz_0_kHz_1, [
                1,
                1000
            ], type$.ConstantStringMap_String_double);
            B.Map_kdBEM = new A.ConstantStringMap(B.Object_Hz_0_kHz_1, [
                0.001,
                1
            ], type$.ConstantStringMap_String_double);
            B.Map_vIkFS = new A.ConstantStringMap(B.Object_CHz, [
                1,
                2.54,
                96
            ], type$.ConstantStringMap_String_double);
            B.Map_vIY7E = new A.ConstantStringMap(B.Object_CHz, [
                0.39370078740157477,
                1,
                37.79527559055118
            ], type$.ConstantStringMap_String_double);
            B.Map_vIcSC = new A.ConstantStringMap(B.Object_CHz, [
                0.010416666666666666,
                0.026458333333333334,
                1
            ], type$.ConstantStringMap_String_double);
            B.Map_NtHoP = new A.ConstantStringMap(B.Object_CSf, [
                B.Map_LdTcR,
                B.Map_LdCjQ,
                B.Map_Ldr6M,
                B.Map_LdTyG,
                B.Map_Ld577,
                B.Map_LdIVT,
                B.Map_Ld6L5,
                B.Map_LjNxM,
                B.Map_Lj8V1,
                B.Map_LjePw,
                B.Map_LjtMd,
                B.Map_Aezv1,
                B.Map_AeI7g,
                B.Map_kdDCg,
                B.Map_kdBEM,
                B.Map_vIkFS,
                B.Map_vIY7E,
                B.Map_vIcSC
            ], A.findType("ConstantStringMap<String,Map<String,double>>"));
            B.Object_J3y = {
                length: 0,
                angle: 1,
                time: 2,
                frequency: 3,
                "pixel density": 4
            };
            B.List_Ldp = makeConstList([
                "in",
                "cm",
                "pc",
                "mm",
                "q",
                "pt",
                "px"
            ], type$.JSArray_String);
            B.List_deg_grad_rad_turn = makeConstList([
                "deg",
                "grad",
                "rad",
                "turn"
            ], type$.JSArray_String);
            B.List_s_ms = makeConstList([
                "s",
                "ms"
            ], type$.JSArray_String);
            B.List_Hz_kHz = makeConstList([
                "Hz",
                "kHz"
            ], type$.JSArray_String);
            B.List_dpi_dpcm_dppx = makeConstList([
                "dpi",
                "dpcm",
                "dppx"
            ], type$.JSArray_String);
            B.Map_Sr65K = new A.ConstantStringMap(B.Object_J3y, [
                B.List_Ldp,
                B.List_deg_grad_rad_turn,
                B.List_s_ms,
                B.List_Hz_kHz,
                B.List_dpi_dpcm_dppx
            ], A.findType("ConstantStringMap<String,List<String>>"));
            B.Map_empty7 = new A.ConstantStringMap(B.Object_empty, [], A.findType("ConstantStringMap<Module0<AsyncCallable>,List<CssComment>>"));
            B.Map_empty = new A.ConstantStringMap(B.Object_empty, [], A.findType("ConstantStringMap<Module0<Callable0>,List<CssComment>>"));
            B.Map_empty1 = new A.ConstantStringMap(B.Object_empty, [], A.findType("ConstantStringMap<Module0<0&>,List<CssComment>>"));
            B.Map_empty16 = new A.ConstantStringMap(B.Object_empty, [], A.findType("ConstantStringMap<Module1<AsyncCallable0>,List<CssComment0>>"));
            B.Map_empty10 = new A.ConstantStringMap(B.Object_empty, [], A.findType("ConstantStringMap<Module1<Callable>,List<CssComment0>>"));
            B.Map_empty12 = new A.ConstantStringMap(B.Object_empty, [], A.findType("ConstantStringMap<Module1<0&>,List<CssComment0>>"));
            B.Map_empty3 = new A.ConstantStringMap(B.Object_empty, [], A.findType("ConstantStringMap<String,AstNode>"));
            B.Map_empty13 = new A.ConstantStringMap(B.Object_empty, [], A.findType("ConstantStringMap<String,AstNode0>"));
            B.Map_empty4 = new A.ConstantStringMap(B.Object_empty, [], A.findType("ConstantStringMap<String,Expression>"));
            B.Map_empty14 = new A.ConstantStringMap(B.Object_empty, [], A.findType("ConstantStringMap<String,Expression0>"));
            B.Map_empty5 = new A.ConstantStringMap(B.Object_empty, [], A.findType("ConstantStringMap<String,FileSpan>"));
            B.Map_empty8 = new A.ConstantStringMap(B.Object_empty, [], A.findType("ConstantStringMap<String,Module0<AsyncCallable>>"));
            B.Map_empty0 = new A.ConstantStringMap(B.Object_empty, [], A.findType("ConstantStringMap<String,Module0<Callable0>>"));
            B.Map_empty17 = new A.ConstantStringMap(B.Object_empty, [], A.findType("ConstantStringMap<String,Module1<AsyncCallable0>>"));
            B.Map_empty11 = new A.ConstantStringMap(B.Object_empty, [], A.findType("ConstantStringMap<String,Module1<Callable>>"));
            B.Map_empty6 = new A.ConstantStringMap(B.Object_empty, [], A.findType("ConstantStringMap<String,Value>"));
            B.Map_empty15 = new A.ConstantStringMap(B.Object_empty, [], A.findType("ConstantStringMap<String,Value0>"));
            B.Map_empty2 = new A.ConstantStringMap(B.Object_empty, [], A.findType("ConstantStringMap<Symbol0,@>"));
            B.Map_empty9 = new A.ConstantStringMap(B.Object_empty, [], A.findType("ConstantStringMap<String?,String>"));
            B.LinearChannel_fS8 = new A.LinearChannel(0, 1, false, true, true, "lightness", false, "%");
            B.LinearChannel_ffI = new A.LinearChannel(-0.4, 0.4, false, false, false, "a", false, null);
            B.LinearChannel_Y6D = new A.LinearChannel(-0.4, 0.4, false, false, false, "b", false, null);
            B.List_ZWr = makeConstList([
                B.LinearChannel_fS8,
                B.LinearChannel_ffI,
                B.LinearChannel_Y6D
            ], type$.JSArray_ColorChannel);
            B.OklabColorSpace_540 = new A.OklabColorSpace("oklab", B.List_ZWr);
            B.LinearChannel_fS80 = new A.LinearChannel0(0, 1, false, true, true, "lightness", false, "%");
            B.LinearChannel_ffI0 = new A.LinearChannel0(-0.4, 0.4, false, false, false, "a", false, null);
            B.LinearChannel_Y6D0 = new A.LinearChannel0(-0.4, 0.4, false, false, false, "b", false, null);
            B.List_ZWr0 = makeConstList([
                B.LinearChannel_fS80,
                B.LinearChannel_ffI0,
                B.LinearChannel_Y6D0
            ], type$.JSArray_ColorChannel_2);
            B.OklabColorSpace_5400 = new A.OklabColorSpace0("oklab", B.List_ZWr0);
            B.LinearChannel_HTj = new A.LinearChannel(0, 0.4, false, true, false, "chroma", false, null);
            B.List_g5j = makeConstList([
                B.LinearChannel_fS8,
                B.LinearChannel_HTj,
                B.ColorChannel_hue_true_deg
            ], type$.JSArray_ColorChannel);
            B.OklchColorSpace_9Gj = new A.OklchColorSpace("oklch", B.List_g5j);
            B.LinearChannel_HTj0 = new A.LinearChannel0(0, 0.4, false, true, false, "chroma", false, null);
            B.List_g5j0 = makeConstList([
                B.LinearChannel_fS80,
                B.LinearChannel_HTj0,
                B.ColorChannel_hue_true_deg0
            ], type$.JSArray_ColorChannel_2);
            B.OklchColorSpace_9Gj0 = new A.OklchColorSpace0("oklch", B.List_g5j0);
            B.OptionType_1Ol = new A.OptionType("OptionType.multiple");
            B.OptionType_tI9 = new A.OptionType("OptionType.flag");
            B.OptionType_zZK = new A.OptionType("OptionType.single");
            B.OutputStyle_0 = new A.OutputStyle(0, "expanded");
            B.OutputStyle_00 = new A.OutputStyle0(0, "expanded");
            B.OutputStyle_1 = new A.OutputStyle(1, "compressed");
            B.OutputStyle_10 = new A.OutputStyle0(1, "compressed");
            B.ProphotoRgbColorSpace_BDz = new A.ProphotoRgbColorSpace("prophoto-rgb", B.List_U47);
            B.ProphotoRgbColorSpace_BDz0 = new A.ProphotoRgbColorSpace0("prophoto-rgb", B.List_U470);
            B.Rec2020ColorSpace_6oo = new A.Rec2020ColorSpace("rec2020", B.List_U47);
            B.Rec2020ColorSpace_6oo0 = new A.Rec2020ColorSpace0("rec2020", B.List_U470);
            B.Map_empty20 = new A.ConstantStringMap(B.Object_empty, [], A.findType("ConstantStringMap<SelectorList,Box<SelectorList>>"));
            B.Record2_EmptyExtensionStore_Map_empty = new A._Record_2(B.C_EmptyExtensionStore, B.Map_empty20);
            B.Map_empty21 = new A.ConstantStringMap(B.Object_empty, [], A.findType("ConstantStringMap<SelectorList0,Box0<SelectorList0>>"));
            B.Record2_EmptyExtensionStore_Map_empty0 = new A._Record_2(B.C_EmptyExtensionStore0, B.Map_empty21);
            B.List_Ds2 = makeConstList([
                B.LinearChannel_qXC,
                B.LinearChannel_Z5r,
                B.LinearChannel_vJ3
            ], type$.JSArray_ColorChannel);
            B.RgbColorSpace_i0P = new A.RgbColorSpace("rgb", B.List_Ds2);
            B.List_Ds20 = makeConstList([
                B.LinearChannel_qXC0,
                B.LinearChannel_Z5r0,
                B.LinearChannel_vJ30
            ], type$.JSArray_ColorChannel_2);
            B.RgbColorSpace_i0P0 = new A.RgbColorSpace0("rgb", B.List_Ds20);
            B.SassBoolean_false = new A.SassBoolean(false);
            B.SassBoolean_false0 = new A.SassBoolean0(false);
            B.SassBoolean_true = new A.SassBoolean(true);
            B.SassBoolean_true0 = new A.SassBoolean0(true);
            B.SassList_9ua = new A.SassList0(B.List_empty23, B.ListSeparator_undecided_null_3_undecided0, false);
            B.SassList_oH0 = new A.SassList(B.List_empty8, B.ListSeparator_z0K, false);
            B.SassList_oH00 = new A.SassList0(B.List_empty23, B.ListSeparator_z0K0, false);
            B.SassList_oWx = new A.SassList(B.List_empty8, B.ListSeparator_z0K, true);
            B.SassList_oWx0 = new A.SassList0(B.List_empty23, B.ListSeparator_z0K0, true);
            B.Map_empty22 = new A.ConstantStringMap(B.Object_empty, [], A.findType("ConstantStringMap<Value,Value>"));
            B.SassMap_Map_empty = new A.SassMap(B.Map_empty22);
            B.Map_empty23 = new A.ConstantStringMap(B.Object_empty, [], A.findType("ConstantStringMap<Value0,Value0>"));
            B.SassMap_Map_empty0 = new A.SassMap0(B.Map_empty23);
            B.Object_Tro = {
                is: 0,
                matches: 1,
                where: 2
            };
            B.Set_0egh6 = new A.ConstantStringSet(B.Object_Tro, 3, type$.ConstantStringSet_String);
            B.Object_SWZ = {
                and: 0,
                or: 1,
                not: 2
            };
            B.Set_6V2Gi = new A.ConstantStringSet(B.Object_SWZ, 3, type$.ConstantStringSet_String);
            B.Object_ssn = {
                sass: 0,
                style: 1,
                default: 2
            };
            B.Set_8229z = new A.ConstantStringSet(B.Object_ssn, 3, type$.ConstantStringSet_String);
            B.Set_9FDyj = new A.GeneralConstantSet([
                B.RgbColorSpace_i0P,
                B.HslColorSpace_JQ2
            ], A.findType("GeneralConstantSet<ColorSpace>"));
            B.Set_9FDyj0 = new A.GeneralConstantSet([
                B.RgbColorSpace_i0P0,
                B.HslColorSpace_JQ20
            ], A.findType("GeneralConstantSet<ColorSpace0>"));
            B.Object_BKa = {
                ".scss": 0,
                ".sass": 1,
                ".css": 2
            };
            B.Set_FTDN4 = new A.ConstantStringSet(B.Object_BKa, 3, type$.ConstantStringSet_String);
            B.Object_GR4 = {
                calc: 0,
                clamp: 1,
                hypot: 2,
                sin: 3,
                cos: 4,
                tan: 5,
                asin: 6,
                acos: 7,
                atan: 8,
                sqrt: 9,
                exp: 10,
                sign: 11,
                mod: 12,
                rem: 13,
                atan2: 14,
                pow: 15,
                log: 16,
                "calc-size": 17
            };
            B.Set_Pr3yj = new A.ConstantStringSet(B.Object_GR4, 18, type$.ConstantStringSet_String);
            B.Set_empty2 = new A.ConstantStringSet(B.Object_empty, 0, A.findType("ConstantStringSet<CssMediaQuery>"));
            B.Set_empty6 = new A.ConstantStringSet(B.Object_empty, 0, A.findType("ConstantStringSet<CssMediaQuery0>"));
            B.Set_empty3 = new A.ConstantStringSet(B.Object_empty, 0, A.findType("ConstantStringSet<Module0<AsyncCallable>>"));
            B.Set_empty0 = new A.ConstantStringSet(B.Object_empty, 0, A.findType("ConstantStringSet<Module0<Callable0>>"));
            B.Set_empty7 = new A.ConstantStringSet(B.Object_empty, 0, A.findType("ConstantStringSet<Module1<AsyncCallable0>>"));
            B.Set_empty5 = new A.ConstantStringSet(B.Object_empty, 0, A.findType("ConstantStringSet<Module1<Callable>>"));
            B.Set_empty1 = new A.ConstantStringSet(B.Object_empty, 0, type$.ConstantStringSet_String);
            B.Set_empty4 = new A.ConstantStringSet(B.Object_empty, 0, A.findType("ConstantStringSet<StylesheetNode>"));
            B.Set_empty = new A.ConstantStringSet(B.Object_empty, 0, A.findType("ConstantStringSet<Uri>"));
            B.Set_xkEMv = new A.GeneralConstantSet([
                B.BinaryOperator_wkM,
                B.BinaryOperator_ehp,
                B.BinaryOperator_jCK,
                B.BinaryOperator_tDf
            ], A.findType("GeneralConstantSet<BinaryOperator>"));
            B.Set_xkEMv0 = new A.GeneralConstantSet([
                B.BinaryOperator_wkM0,
                B.BinaryOperator_ehp0,
                B.BinaryOperator_jCK0,
                B.BinaryOperator_tDf0
            ], A.findType("GeneralConstantSet<BinaryOperator0>"));
            B.SrgbColorSpace_thf = new A.SrgbColorSpace("srgb", B.List_U47);
            B.SrgbColorSpace_thf0 = new A.SrgbColorSpace0("srgb", B.List_U470);
            B.SrgbLinearColorSpace_kUj = new A.SrgbLinearColorSpace("srgb-linear", B.List_U47);
            B.SrgbLinearColorSpace_kUj0 = new A.SrgbLinearColorSpace0("srgb-linear", B.List_U470);
            B.Symbol__canonicalizeContext = new A.Symbol("_canonicalizeContext");
            B.Symbol__evaluationContext = new A.Symbol("_evaluationContext");
            B.Symbol__extensions = new A.Symbol("_extensions");
            B.Symbol__sourceSpecificity = new A.Symbol("_sourceSpecificity");
            B.Symbol_call = new A.Symbol("call");
            B.Syntax_CSS_2_css = new A.Syntax("CSS", 2, "css");
            B.Syntax_CSS_2_css0 = new A.Syntax0("CSS", 2, "css");
            B.Syntax_SCSS_0_scss = new A.Syntax("SCSS", 0, "scss");
            B.Syntax_SCSS_0_scss0 = new A.Syntax0("SCSS", 0, "scss");
            B.Syntax_Sass_1_sass = new A.Syntax("Sass", 1, "sass");
            B.Syntax_Sass_1_sass0 = new A.Syntax0("Sass", 1, "sass");
            B.Type_ByteBuffer_rqD = A.typeLiteral("ByteBuffer");
            B.Type_ByteData_9dB = A.typeLiteral("ByteData");
            B.Type_Float32List_9Kz = A.typeLiteral("Float32List");
            B.Type_Float64List_9Kz = A.typeLiteral("Float64List");
            B.Type_Int16List_s5h = A.typeLiteral("Int16List");
            B.Type_Int32List_O8Z = A.typeLiteral("Int32List");
            B.Type_Int8List_rFV = A.typeLiteral("Int8List");
            B.Type_Object_A4p = A.typeLiteral("Object");
            B.Type_Uint16List_kmP = A.typeLiteral("Uint16List");
            B.Type_Uint32List_kmP = A.typeLiteral("Uint32List");
            B.Type_Uint8ClampedList_04U = A.typeLiteral("Uint8ClampedList");
            B.Type_Uint8List_8Eb = A.typeLiteral("Uint8List");
            B.UnaryOperator_Y93 = new A.UnaryOperator("divide", "/", 2, "divide");
            B.UnaryOperator_Y930 = new A.UnaryOperator0("divide", "/", 2, "divide");
            B.UnaryOperator_hCO = new A.UnaryOperator("minus", "-", 1, "minus");
            B.UnaryOperator_hCO0 = new A.UnaryOperator0("minus", "-", 1, "minus");
            B.UnaryOperator_n2K = new A.UnaryOperator("plus", "+", 0, "plus");
            B.UnaryOperator_n2K0 = new A.UnaryOperator0("plus", "+", 0, "plus");
            B.UnaryOperator_not_not_3_not = new A.UnaryOperator("not", "not", 3, "not");
            B.UnaryOperator_not_not_3_not0 = new A.UnaryOperator0("not", "not", 3, "not");
            B.Utf8Decoder_false = new A.Utf8Decoder(false);
            B.LinearChannel_LYw = new A.LinearChannel(0, 1, false, false, false, "x", false, null);
            B.LinearChannel_eR7 = new A.LinearChannel(0, 1, false, false, false, "y", false, null);
            B.LinearChannel_gZl = new A.LinearChannel(0, 1, false, false, false, "z", false, null);
            B.List_QRs = makeConstList([
                B.LinearChannel_LYw,
                B.LinearChannel_eR7,
                B.LinearChannel_gZl
            ], type$.JSArray_LinearChannel);
            B.XyzD50ColorSpace_2OB = new A.XyzD50ColorSpace("xyz-d50", B.List_QRs);
            B.LinearChannel_LYw0 = new A.LinearChannel0(0, 1, false, false, false, "x", false, null);
            B.LinearChannel_eR70 = new A.LinearChannel0(0, 1, false, false, false, "y", false, null);
            B.LinearChannel_gZl0 = new A.LinearChannel0(0, 1, false, false, false, "z", false, null);
            B.List_QRs0 = makeConstList([
                B.LinearChannel_LYw0,
                B.LinearChannel_eR70,
                B.LinearChannel_gZl0
            ], type$.JSArray_LinearChannel_2);
            B.XyzD50ColorSpace_2OB0 = new A.XyzD50ColorSpace0("xyz-d50", B.List_QRs0);
            B.XyzD65ColorSpace_WiJ = new A.XyzD65ColorSpace("xyz", B.List_QRs);
            B.XyzD65ColorSpace_WiJ0 = new A.XyzD65ColorSpace0("xyz", B.List_QRs0);
            B._IsBogusVisitor_false = new A._IsBogusVisitor(false);
            B._IsBogusVisitor_false0 = new A._IsBogusVisitor0(false);
            B._IsBogusVisitor_true = new A._IsBogusVisitor(true);
            B._IsBogusVisitor_true0 = new A._IsBogusVisitor0(true);
            B._IsInvisibleVisitor_false = new A._IsInvisibleVisitor0(false);
            B._IsInvisibleVisitor_false0 = new A._IsInvisibleVisitor2(false);
            B._IsInvisibleVisitor_false_false = new A._IsInvisibleVisitor(false, false);
            B._IsInvisibleVisitor_false_false0 = new A._IsInvisibleVisitor1(false, false);
            B._IsInvisibleVisitor_true = new A._IsInvisibleVisitor0(true);
            B._IsInvisibleVisitor_true0 = new A._IsInvisibleVisitor2(true);
            B._IsInvisibleVisitor_true_false = new A._IsInvisibleVisitor(true, false);
            B._IsInvisibleVisitor_true_false0 = new A._IsInvisibleVisitor1(true, false);
            B._IsInvisibleVisitor_true_true = new A._IsInvisibleVisitor(true, true);
            B._IsInvisibleVisitor_true_true0 = new A._IsInvisibleVisitor1(true, true);
            B._PathDirection_6kc = new A._PathDirection("reaches root");
            B._PathDirection_Wme = new A._PathDirection("below root");
            B._PathDirection_dMN = new A._PathDirection("at root");
            B._PathDirection_vgO = new A._PathDirection("above root");
            B._PathRelation_different = new A._PathRelation("different");
            B._PathRelation_equal = new A._PathRelation("equal");
            B._PathRelation_inconclusive = new A._PathRelation("inconclusive");
            B._PathRelation_within = new A._PathRelation("within");
            B._SingletonCssMediaQueryMergeResult_0 = new A._SingletonCssMediaQueryMergeResult(0, "empty");
            B._SingletonCssMediaQueryMergeResult_00 = new A._SingletonCssMediaQueryMergeResult0(0, "empty");
            B._SingletonCssMediaQueryMergeResult_1 = new A._SingletonCssMediaQueryMergeResult(1, "unrepresentable");
            B._SingletonCssMediaQueryMergeResult_10 = new A._SingletonCssMediaQueryMergeResult0(1, "unrepresentable");
            B._StreamGroupState_canceled = new A._StreamGroupState("canceled");
            B._StreamGroupState_dormant = new A._StreamGroupState("dormant");
            B._StreamGroupState_listening = new A._StreamGroupState("listening");
            B._StreamGroupState_paused = new A._StreamGroupState("paused");
            B._StringStackTrace_OdL = new A._StringStackTrace("");
            B._ZoneFunction_KjJ = new A._ZoneFunction(B.C__RootZone, A.async___rootHandleUncaughtError$closure());
            B._ZoneFunction_PAY = new A._ZoneFunction(B.C__RootZone, A.async___rootCreatePeriodicTimer$closure());
            B._ZoneFunction_Xkh = new A._ZoneFunction(B.C__RootZone, A.async___rootRegisterUnaryCallback$closure());
            B._ZoneFunction__RootZone__rootCreateTimer = new A._ZoneFunction(B.C__RootZone, A.async___rootCreateTimer$closure());
            B._ZoneFunction__RootZone__rootErrorCallback = new A._ZoneFunction(B.C__RootZone, A.async___rootErrorCallback$closure());
            B._ZoneFunction__RootZone__rootFork = new A._ZoneFunction(B.C__RootZone, A.async___rootFork$closure());
            B._ZoneFunction__RootZone__rootPrint = new A._ZoneFunction(B.C__RootZone, A.async___rootPrint$closure());
            B._ZoneFunction__RootZone__rootRegisterCallback = new A._ZoneFunction(B.C__RootZone, A.async___rootRegisterCallback$closure());
            B._ZoneFunction__RootZone__rootRun = new A._ZoneFunction(B.C__RootZone, A.async___rootRun$closure());
            B._ZoneFunction__RootZone__rootRunBinary = new A._ZoneFunction(B.C__RootZone, A.async___rootRunBinary$closure());
            B._ZoneFunction__RootZone__rootRunUnary = new A._ZoneFunction(B.C__RootZone, A.async___rootRunUnary$closure());
            B._ZoneFunction__RootZone__rootScheduleMicrotask = new A._ZoneFunction(B.C__RootZone, A.async___rootScheduleMicrotask$closure());
            B._ZoneFunction_e9o = new A._ZoneFunction(B.C__RootZone, A.async___rootRegisterBinaryCallback$closure());
            B._ZoneSpecification_Ipa = new A._ZoneSpecification(null, null, null, null, null, null, null, null, null, null, null, null, null);
        })();
        (function staticFields() {
            $._JS_INTEROP_INTERCEPTOR_TAG = null;
            $._toStringVisiting = A._setArrayType([], type$.JSArray_Object);
            $._printToZone = null;
            $.Primitives__identityHashCodeProperty = null;
            $.BoundClosure__receiverFieldNameCache = null;
            $.BoundClosure__interceptorFieldNameCache = null;
            $.getTagFunction = null;
            $.alternateTagFunction = null;
            $.prototypeForTagFunction = null;
            $.dispatchRecordsForInstanceTags = null;
            $.interceptorsForUncacheableTags = null;
            $.initNativeDispatchFlag = null;
            $._Record__computedFieldKeys = A._setArrayType([], A.findType("JSArray<List<Object>?>"));
            $._nextCallback = null;
            $._lastCallback = null;
            $._lastPriorityCallback = null;
            $._isInCallbackLoop = false;
            $.Zone__current = B.C__RootZone;
            $._RootZone__rootDelegate = null;
            $.Uri__cachedBaseString = "";
            $.Uri__cachedBaseUri = null;
            $._fs = null;
            $._currentUriBase = null;
            $._current = null;
            $._subselectorPseudos = A.LinkedHashSet_LinkedHashSet$_literal([
                "is",
                "matches",
                "where",
                "any",
                "nth-child",
                "nth-last-child"
            ], type$.String);
            $._rootishPseudoClasses = A.LinkedHashSet_LinkedHashSet$_literal([
                "root",
                "scope",
                "host",
                "host-context"
            ], type$.String);
            $._features = A.LinkedHashSet_LinkedHashSet$_literal([
                "global-variable-shadowing",
                "extend-selector-pseudoclass",
                "units-level-3",
                "at-error",
                "custom-property"
            ], type$.String);
            $._realCaseCache = function() {
                var t1 = type$.String;
                return A.LinkedHashMap_LinkedHashMap$_empty(t1, t1);
            }();
            $._default = null;
            $.selectorPseudoClasses = A.LinkedHashSet_LinkedHashSet$_literal([
                "not",
                "is",
                "matches",
                "where",
                "current",
                "any",
                "has",
                "host",
                "host-context"
            ], type$.String);
            $.selectorPseudoElements = A.LinkedHashSet_LinkedHashSet$_literal([
                "slotted"
            ], type$.String);
            $._glyphs = B.C_UnicodeGlyphSet;
            $._default0 = null;
            $._rootishPseudoClasses0 = A.LinkedHashSet_LinkedHashSet$_literal([
                "root",
                "scope",
                "host",
                "host-context"
            ], type$.String);
            $._realCaseCache0 = function() {
                var t1 = type$.String;
                return A.LinkedHashMap_LinkedHashMap$_empty(t1, t1);
            }();
            $._features0 = A.LinkedHashSet_LinkedHashSet$_literal([
                "global-variable-shadowing",
                "extend-selector-pseudoclass",
                "units-level-3",
                "at-error",
                "custom-property"
            ], type$.String);
            $.selectorPseudoClasses0 = A.LinkedHashSet_LinkedHashSet$_literal([
                "not",
                "is",
                "matches",
                "where",
                "current",
                "any",
                "has",
                "host",
                "host-context"
            ], type$.String);
            $.selectorPseudoElements0 = A.LinkedHashSet_LinkedHashSet$_literal([
                "slotted"
            ], type$.String);
            $._subselectorPseudos0 = A.LinkedHashSet_LinkedHashSet$_literal([
                "is",
                "matches",
                "where",
                "any",
                "nth-child",
                "nth-last-child"
            ], type$.String);
        })();
        (function lazyInitializers() {
            var _lazyFinal = hunkHelpers.lazyFinal, _lazy = hunkHelpers.lazy;
            _lazyFinal($, "DART_CLOSURE_PROPERTY_NAME", "$get$DART_CLOSURE_PROPERTY_NAME", function() {
                return A.getIsolateAffinityTag("_$dart_dartClosure");
            });
            _lazyFinal($, "DART_CLOSURE_DART_JSINTEROP_PROPERTY_NAME", "$get$DART_CLOSURE_DART_JSINTEROP_PROPERTY_NAME", function() {
                return A.getIsolateAffinityTag("_$dart_dartClosure_dartJSInterop");
            });
            _lazyFinal($, "nullFuture", "$get$nullFuture", function() {
                return B.C__RootZone.run$1$1(0, new A.nullFuture_closure(), A.findType("Future<~>"));
            });
            _lazyFinal($, "_safeToStringHooks", "$get$_safeToStringHooks", function() {
                return A._setArrayType([
                    new J.JSArraySafeToStringHook()
                ], A.findType("JSArray<SafeToStringHook>"));
            });
            _lazyFinal($, "TypeErrorDecoder_noSuchMethodPattern", "$get$TypeErrorDecoder_noSuchMethodPattern", function() {
                return A.TypeErrorDecoder_extractPattern(A.TypeErrorDecoder_provokeCallErrorOn({
                    toString: function toString() {
                        return "$receiver$";
                    }
                }));
            });
            _lazyFinal($, "TypeErrorDecoder_notClosurePattern", "$get$TypeErrorDecoder_notClosurePattern", function() {
                return A.TypeErrorDecoder_extractPattern(A.TypeErrorDecoder_provokeCallErrorOn({
                    $method$: null,
                    toString: function toString() {
                        return "$receiver$";
                    }
                }));
            });
            _lazyFinal($, "TypeErrorDecoder_nullCallPattern", "$get$TypeErrorDecoder_nullCallPattern", function() {
                return A.TypeErrorDecoder_extractPattern(A.TypeErrorDecoder_provokeCallErrorOn(null));
            });
            _lazyFinal($, "TypeErrorDecoder_nullLiteralCallPattern", "$get$TypeErrorDecoder_nullLiteralCallPattern", function() {
                return A.TypeErrorDecoder_extractPattern(function() {
                    var $argumentsExpr$ = "$arguments$";
                    try {
                        null.$method$($argumentsExpr$);
                    } catch (e) {
                        return e.message;
                    }
                }());
            });
            _lazyFinal($, "TypeErrorDecoder_undefinedCallPattern", "$get$TypeErrorDecoder_undefinedCallPattern", function() {
                return A.TypeErrorDecoder_extractPattern(A.TypeErrorDecoder_provokeCallErrorOn(void 0));
            });
            _lazyFinal($, "TypeErrorDecoder_undefinedLiteralCallPattern", "$get$TypeErrorDecoder_undefinedLiteralCallPattern", function() {
                return A.TypeErrorDecoder_extractPattern(function() {
                    var $argumentsExpr$ = "$arguments$";
                    try {
                        (void 0).$method$($argumentsExpr$);
                    } catch (e) {
                        return e.message;
                    }
                }());
            });
            _lazyFinal($, "TypeErrorDecoder_nullPropertyPattern", "$get$TypeErrorDecoder_nullPropertyPattern", function() {
                return A.TypeErrorDecoder_extractPattern(A.TypeErrorDecoder_provokePropertyErrorOn(null));
            });
            _lazyFinal($, "TypeErrorDecoder_nullLiteralPropertyPattern", "$get$TypeErrorDecoder_nullLiteralPropertyPattern", function() {
                return A.TypeErrorDecoder_extractPattern(function() {
                    try {
                        null.$method$;
                    } catch (e) {
                        return e.message;
                    }
                }());
            });
            _lazyFinal($, "TypeErrorDecoder_undefinedPropertyPattern", "$get$TypeErrorDecoder_undefinedPropertyPattern", function() {
                return A.TypeErrorDecoder_extractPattern(A.TypeErrorDecoder_provokePropertyErrorOn(void 0));
            });
            _lazyFinal($, "TypeErrorDecoder_undefinedLiteralPropertyPattern", "$get$TypeErrorDecoder_undefinedLiteralPropertyPattern", function() {
                return A.TypeErrorDecoder_extractPattern(function() {
                    try {
                        (void 0).$method$;
                    } catch (e) {
                        return e.message;
                    }
                }());
            });
            _lazyFinal($, "_AsyncRun__scheduleImmediateClosure", "$get$_AsyncRun__scheduleImmediateClosure", function() {
                return A._AsyncRun__initializeScheduleImmediate();
            });
            _lazyFinal($, "Future__nullFuture", "$get$Future__nullFuture", function() {
                return $.$get$nullFuture();
            });
            _lazyFinal($, "Future__falseFuture", "$get$Future__falseFuture", function() {
                return A._Future$zoneValue(false, B.C__RootZone, type$.bool);
            });
            _lazyFinal($, "_RootZone__rootMap", "$get$_RootZone__rootMap", function() {
                var t1 = type$.dynamic;
                return A.HashMap_HashMap(t1, t1);
            });
            _lazyFinal($, "_Utf8Decoder__reusableBuffer", "$get$_Utf8Decoder__reusableBuffer", function() {
                return A.NativeUint8List_NativeUint8List(4096);
            });
            _lazyFinal($, "_Utf8Decoder__decoder", "$get$_Utf8Decoder__decoder", function() {
                return new A._Utf8Decoder__decoder_closure().call$0();
            });
            _lazyFinal($, "_Utf8Decoder__decoderNonfatal", "$get$_Utf8Decoder__decoderNonfatal", function() {
                return new A._Utf8Decoder__decoderNonfatal_closure().call$0();
            });
            _lazyFinal($, "_Base64Decoder__inverseAlphabet", "$get$_Base64Decoder__inverseAlphabet", function() {
                return A.NativeInt8List__create1(A._ensureNativeList(A._setArrayType([
                    -2,
                    -2,
                    -2,
                    -2,
                    -2,
                    -2,
                    -2,
                    -2,
                    -2,
                    -2,
                    -2,
                    -2,
                    -2,
                    -2,
                    -2,
                    -2,
                    -2,
                    -2,
                    -2,
                    -2,
                    -2,
                    -2,
                    -2,
                    -2,
                    -2,
                    -2,
                    -2,
                    -2,
                    -2,
                    -2,
                    -2,
                    -2,
                    -2,
                    -2,
                    -2,
                    -2,
                    -2,
                    -1,
                    -2,
                    -2,
                    -2,
                    -2,
                    -2,
                    62,
                    -2,
                    62,
                    -2,
                    63,
                    52,
                    53,
                    54,
                    55,
                    56,
                    57,
                    58,
                    59,
                    60,
                    61,
                    -2,
                    -2,
                    -2,
                    -1,
                    -2,
                    -2,
                    -2,
                    0,
                    1,
                    2,
                    3,
                    4,
                    5,
                    6,
                    7,
                    8,
                    9,
                    10,
                    11,
                    12,
                    13,
                    14,
                    15,
                    16,
                    17,
                    18,
                    19,
                    20,
                    21,
                    22,
                    23,
                    24,
                    25,
                    -2,
                    -2,
                    -2,
                    -2,
                    63,
                    -2,
                    26,
                    27,
                    28,
                    29,
                    30,
                    31,
                    32,
                    33,
                    34,
                    35,
                    36,
                    37,
                    38,
                    39,
                    40,
                    41,
                    42,
                    43,
                    44,
                    45,
                    46,
                    47,
                    48,
                    49,
                    50,
                    51,
                    -2,
                    -2,
                    -2,
                    -2,
                    -2
                ], type$.JSArray_int)));
            });
            _lazyFinal($, "_Uri__isWindowsCached", "$get$_Uri__isWindowsCached", function() {
                var t1 = false;
                return t1;
            });
            _lazyFinal($, "_Uri__needsNoEncoding", "$get$_Uri__needsNoEncoding", function() {
                return A.RegExp_RegExp("^[\\-\\.0-9A-Z_a-z~]*$", false);
            });
            _lazyFinal($, "_hashSeed", "$get$_hashSeed", function() {
                return A.objectHashCode(B.Type_Object_A4p);
            });
            _lazyFinal($, "Option__invalidChars", "$get$Option__invalidChars", function() {
                return A.RegExp_RegExp("[ \\t\\r\\n\"'\\\\/]", false);
            });
            _lazyFinal($, "_isStrictMode", "$get$_isStrictMode", function() {
                return new A._isStrictMode_closure().call$0();
            });
            _lazyFinal($, "alwaysValid", "$get$alwaysValid", function() {
                return new A.alwaysValid_closure();
            });
            _lazyFinal($, "readline", "$get$readline", function() {
                return self.readline;
            });
            _lazyFinal($, "windows", "$get$windows", function() {
                return A.Context_Context($.$get$Style_windows());
            });
            _lazyFinal($, "url", "$get$url", function() {
                return A.Context_Context($.$get$Style_url());
            });
            _lazyFinal($, "context", "$get$context", function() {
                return new A.Context($.$get$Style_platform(), null);
            });
            _lazyFinal($, "Style_posix", "$get$Style_posix", function() {
                return new A.PosixStyle(A.RegExp_RegExp("/", false), A.RegExp_RegExp("[^/]$", false), A.RegExp_RegExp("^/", false));
            });
            _lazyFinal($, "Style_windows", "$get$Style_windows", function() {
                return new A.WindowsStyle(A.RegExp_RegExp("[/\\\\]", false), A.RegExp_RegExp("[^/\\\\]$", false), A.RegExp_RegExp("^(\\\\\\\\[^\\\\]+\\\\[^\\\\/]+|[a-zA-Z]:[/\\\\])", false), A.RegExp_RegExp("^[/\\\\](?![/\\\\])", false));
            });
            _lazyFinal($, "Style_url", "$get$Style_url", function() {
                return new A.UrlStyle(A.RegExp_RegExp("/", false), A.RegExp_RegExp("(^[a-zA-Z][-+.a-zA-Z\\d]*://|[^/])$", false), A.RegExp_RegExp("[a-zA-Z][-+.a-zA-Z\\d]*://[^/]*", false), A.RegExp_RegExp("^/", false));
            });
            _lazyFinal($, "Style_platform", "$get$Style_platform", function() {
                return A.Style__getPlatformStyle();
            });
            _lazyFinal($, "startVersion", "$get$startVersion", function() {
                return A.RegExp_RegExp("^(\\d+)\\.(\\d+)\\.(\\d+)(-([0-9A-Za-z-]+(\\.[0-9A-Za-z-]+)*))?(\\+([0-9A-Za-z-]+(\\.[0-9A-Za-z-]+)*))?", false);
            });
            _lazyFinal($, "completeVersion", "$get$completeVersion", function() {
                return A.RegExp_RegExp($.$get$startVersion().pattern + "$", false);
            });
            _lazyFinal($, "LegacyIfExpression_declaration", "$get$LegacyIfExpression_declaration", function() {
                return A.ParameterList_ParameterList$parse(string$.x40funct, null);
            });
            _lazyFinal($, "colorsByName", "$get$colorsByName", function() {
                return A.LinkedHashMap_LinkedHashMap$_literal([
                    "yellowgreen",
                    A.SassColor_SassColor$rgb(154, 205, 50, 1),
                    "yellow",
                    A.SassColor_SassColor$rgb(255, 255, 0, 1),
                    "whitesmoke",
                    A.SassColor_SassColor$rgb(245, 245, 245, 1),
                    "white",
                    A.SassColor_SassColor$rgb(255, 255, 255, 1),
                    "wheat",
                    A.SassColor_SassColor$rgb(245, 222, 179, 1),
                    "violet",
                    A.SassColor_SassColor$rgb(238, 130, 238, 1),
                    "turquoise",
                    A.SassColor_SassColor$rgb(64, 224, 208, 1),
                    "transparent",
                    A.SassColor_SassColor$rgb(0, 0, 0, 0),
                    "tomato",
                    A.SassColor_SassColor$rgb(255, 99, 71, 1),
                    "thistle",
                    A.SassColor_SassColor$rgb(216, 191, 216, 1),
                    "teal",
                    A.SassColor_SassColor$rgb(0, 128, 128, 1),
                    "tan",
                    A.SassColor_SassColor$rgb(210, 180, 140, 1),
                    "steelblue",
                    A.SassColor_SassColor$rgb(70, 130, 180, 1),
                    "springgreen",
                    A.SassColor_SassColor$rgb(0, 255, 127, 1),
                    "snow",
                    A.SassColor_SassColor$rgb(255, 250, 250, 1),
                    "slategrey",
                    A.SassColor_SassColor$rgb(112, 128, 144, 1),
                    "slategray",
                    A.SassColor_SassColor$rgb(112, 128, 144, 1),
                    "slateblue",
                    A.SassColor_SassColor$rgb(106, 90, 205, 1),
                    "skyblue",
                    A.SassColor_SassColor$rgb(135, 206, 235, 1),
                    "silver",
                    A.SassColor_SassColor$rgb(192, 192, 192, 1),
                    "sienna",
                    A.SassColor_SassColor$rgb(160, 82, 45, 1),
                    "seashell",
                    A.SassColor_SassColor$rgb(255, 245, 238, 1),
                    "seagreen",
                    A.SassColor_SassColor$rgb(46, 139, 87, 1),
                    "sandybrown",
                    A.SassColor_SassColor$rgb(244, 164, 96, 1),
                    "salmon",
                    A.SassColor_SassColor$rgb(250, 128, 114, 1),
                    "saddlebrown",
                    A.SassColor_SassColor$rgb(139, 69, 19, 1),
                    "royalblue",
                    A.SassColor_SassColor$rgb(65, 105, 225, 1),
                    "rosybrown",
                    A.SassColor_SassColor$rgb(188, 143, 143, 1),
                    "red",
                    A.SassColor_SassColor$rgb(255, 0, 0, 1),
                    "rebeccapurple",
                    A.SassColor_SassColor$rgb(102, 51, 153, 1),
                    "purple",
                    A.SassColor_SassColor$rgb(128, 0, 128, 1),
                    "powderblue",
                    A.SassColor_SassColor$rgb(176, 224, 230, 1),
                    "plum",
                    A.SassColor_SassColor$rgb(221, 160, 221, 1),
                    "pink",
                    A.SassColor_SassColor$rgb(255, 192, 203, 1),
                    "peru",
                    A.SassColor_SassColor$rgb(205, 133, 63, 1),
                    "peachpuff",
                    A.SassColor_SassColor$rgb(255, 218, 185, 1),
                    "papayawhip",
                    A.SassColor_SassColor$rgb(255, 239, 213, 1),
                    "palevioletred",
                    A.SassColor_SassColor$rgb(219, 112, 147, 1),
                    "paleturquoise",
                    A.SassColor_SassColor$rgb(175, 238, 238, 1),
                    "palegreen",
                    A.SassColor_SassColor$rgb(152, 251, 152, 1),
                    "palegoldenrod",
                    A.SassColor_SassColor$rgb(238, 232, 170, 1),
                    "orchid",
                    A.SassColor_SassColor$rgb(218, 112, 214, 1),
                    "orangered",
                    A.SassColor_SassColor$rgb(255, 69, 0, 1),
                    "orange",
                    A.SassColor_SassColor$rgb(255, 165, 0, 1),
                    "olivedrab",
                    A.SassColor_SassColor$rgb(107, 142, 35, 1),
                    "olive",
                    A.SassColor_SassColor$rgb(128, 128, 0, 1),
                    "oldlace",
                    A.SassColor_SassColor$rgb(253, 245, 230, 1),
                    "navy",
                    A.SassColor_SassColor$rgb(0, 0, 128, 1),
                    "navajowhite",
                    A.SassColor_SassColor$rgb(255, 222, 173, 1),
                    "moccasin",
                    A.SassColor_SassColor$rgb(255, 228, 181, 1),
                    "mistyrose",
                    A.SassColor_SassColor$rgb(255, 228, 225, 1),
                    "mintcream",
                    A.SassColor_SassColor$rgb(245, 255, 250, 1),
                    "midnightblue",
                    A.SassColor_SassColor$rgb(25, 25, 112, 1),
                    "mediumvioletred",
                    A.SassColor_SassColor$rgb(199, 21, 133, 1),
                    "mediumturquoise",
                    A.SassColor_SassColor$rgb(72, 209, 204, 1),
                    "mediumspringgreen",
                    A.SassColor_SassColor$rgb(0, 250, 154, 1),
                    "mediumslateblue",
                    A.SassColor_SassColor$rgb(123, 104, 238, 1),
                    "mediumseagreen",
                    A.SassColor_SassColor$rgb(60, 179, 113, 1),
                    "mediumpurple",
                    A.SassColor_SassColor$rgb(147, 112, 219, 1),
                    "mediumorchid",
                    A.SassColor_SassColor$rgb(186, 85, 211, 1),
                    "mediumblue",
                    A.SassColor_SassColor$rgb(0, 0, 205, 1),
                    "mediumaquamarine",
                    A.SassColor_SassColor$rgb(102, 205, 170, 1),
                    "maroon",
                    A.SassColor_SassColor$rgb(128, 0, 0, 1),
                    "magenta",
                    A.SassColor_SassColor$rgb(255, 0, 255, 1),
                    "linen",
                    A.SassColor_SassColor$rgb(250, 240, 230, 1),
                    "limegreen",
                    A.SassColor_SassColor$rgb(50, 205, 50, 1),
                    "lime",
                    A.SassColor_SassColor$rgb(0, 255, 0, 1),
                    "lightyellow",
                    A.SassColor_SassColor$rgb(255, 255, 224, 1),
                    "lightsteelblue",
                    A.SassColor_SassColor$rgb(176, 196, 222, 1),
                    "lightslategrey",
                    A.SassColor_SassColor$rgb(119, 136, 153, 1),
                    "lightslategray",
                    A.SassColor_SassColor$rgb(119, 136, 153, 1),
                    "lightskyblue",
                    A.SassColor_SassColor$rgb(135, 206, 250, 1),
                    "lightseagreen",
                    A.SassColor_SassColor$rgb(32, 178, 170, 1),
                    "lightsalmon",
                    A.SassColor_SassColor$rgb(255, 160, 122, 1),
                    "lightpink",
                    A.SassColor_SassColor$rgb(255, 182, 193, 1),
                    "lightgrey",
                    A.SassColor_SassColor$rgb(211, 211, 211, 1),
                    "lightgreen",
                    A.SassColor_SassColor$rgb(144, 238, 144, 1),
                    "lightgray",
                    A.SassColor_SassColor$rgb(211, 211, 211, 1),
                    "lightgoldenrodyellow",
                    A.SassColor_SassColor$rgb(250, 250, 210, 1),
                    "lightcyan",
                    A.SassColor_SassColor$rgb(224, 255, 255, 1),
                    "lightcoral",
                    A.SassColor_SassColor$rgb(240, 128, 128, 1),
                    "lightblue",
                    A.SassColor_SassColor$rgb(173, 216, 230, 1),
                    "lemonchiffon",
                    A.SassColor_SassColor$rgb(255, 250, 205, 1),
                    "lawngreen",
                    A.SassColor_SassColor$rgb(124, 252, 0, 1),
                    "lavenderblush",
                    A.SassColor_SassColor$rgb(255, 240, 245, 1),
                    "lavender",
                    A.SassColor_SassColor$rgb(230, 230, 250, 1),
                    "khaki",
                    A.SassColor_SassColor$rgb(240, 230, 140, 1),
                    "ivory",
                    A.SassColor_SassColor$rgb(255, 255, 240, 1),
                    "indigo",
                    A.SassColor_SassColor$rgb(75, 0, 130, 1),
                    "indianred",
                    A.SassColor_SassColor$rgb(205, 92, 92, 1),
                    "hotpink",
                    A.SassColor_SassColor$rgb(255, 105, 180, 1),
                    "honeydew",
                    A.SassColor_SassColor$rgb(240, 255, 240, 1),
                    "grey",
                    A.SassColor_SassColor$rgb(128, 128, 128, 1),
                    "greenyellow",
                    A.SassColor_SassColor$rgb(173, 255, 47, 1),
                    "green",
                    A.SassColor_SassColor$rgb(0, 128, 0, 1),
                    "gray",
                    A.SassColor_SassColor$rgb(128, 128, 128, 1),
                    "goldenrod",
                    A.SassColor_SassColor$rgb(218, 165, 32, 1),
                    "gold",
                    A.SassColor_SassColor$rgb(255, 215, 0, 1),
                    "ghostwhite",
                    A.SassColor_SassColor$rgb(248, 248, 255, 1),
                    "gainsboro",
                    A.SassColor_SassColor$rgb(220, 220, 220, 1),
                    "fuchsia",
                    A.SassColor_SassColor$rgb(255, 0, 255, 1),
                    "forestgreen",
                    A.SassColor_SassColor$rgb(34, 139, 34, 1),
                    "floralwhite",
                    A.SassColor_SassColor$rgb(255, 250, 240, 1),
                    "firebrick",
                    A.SassColor_SassColor$rgb(178, 34, 34, 1),
                    "dodgerblue",
                    A.SassColor_SassColor$rgb(30, 144, 255, 1),
                    "dimgrey",
                    A.SassColor_SassColor$rgb(105, 105, 105, 1),
                    "dimgray",
                    A.SassColor_SassColor$rgb(105, 105, 105, 1),
                    "deepskyblue",
                    A.SassColor_SassColor$rgb(0, 191, 255, 1),
                    "deeppink",
                    A.SassColor_SassColor$rgb(255, 20, 147, 1),
                    "darkviolet",
                    A.SassColor_SassColor$rgb(148, 0, 211, 1),
                    "darkturquoise",
                    A.SassColor_SassColor$rgb(0, 206, 209, 1),
                    "darkslategrey",
                    A.SassColor_SassColor$rgb(47, 79, 79, 1),
                    "darkslategray",
                    A.SassColor_SassColor$rgb(47, 79, 79, 1),
                    "darkslateblue",
                    A.SassColor_SassColor$rgb(72, 61, 139, 1),
                    "darkseagreen",
                    A.SassColor_SassColor$rgb(143, 188, 143, 1),
                    "darksalmon",
                    A.SassColor_SassColor$rgb(233, 150, 122, 1),
                    "darkred",
                    A.SassColor_SassColor$rgb(139, 0, 0, 1),
                    "darkorchid",
                    A.SassColor_SassColor$rgb(153, 50, 204, 1),
                    "darkorange",
                    A.SassColor_SassColor$rgb(255, 140, 0, 1),
                    "darkolivegreen",
                    A.SassColor_SassColor$rgb(85, 107, 47, 1),
                    "darkmagenta",
                    A.SassColor_SassColor$rgb(139, 0, 139, 1),
                    "darkkhaki",
                    A.SassColor_SassColor$rgb(189, 183, 107, 1),
                    "darkgrey",
                    A.SassColor_SassColor$rgb(169, 169, 169, 1),
                    "darkgreen",
                    A.SassColor_SassColor$rgb(0, 100, 0, 1),
                    "darkgray",
                    A.SassColor_SassColor$rgb(169, 169, 169, 1),
                    "darkgoldenrod",
                    A.SassColor_SassColor$rgb(184, 134, 11, 1),
                    "darkcyan",
                    A.SassColor_SassColor$rgb(0, 139, 139, 1),
                    "darkblue",
                    A.SassColor_SassColor$rgb(0, 0, 139, 1),
                    "cyan",
                    A.SassColor_SassColor$rgb(0, 255, 255, 1),
                    "crimson",
                    A.SassColor_SassColor$rgb(220, 20, 60, 1),
                    "cornsilk",
                    A.SassColor_SassColor$rgb(255, 248, 220, 1),
                    "cornflowerblue",
                    A.SassColor_SassColor$rgb(100, 149, 237, 1),
                    "coral",
                    A.SassColor_SassColor$rgb(255, 127, 80, 1),
                    "chocolate",
                    A.SassColor_SassColor$rgb(210, 105, 30, 1),
                    "chartreuse",
                    A.SassColor_SassColor$rgb(127, 255, 0, 1),
                    "cadetblue",
                    A.SassColor_SassColor$rgb(95, 158, 160, 1),
                    "burlywood",
                    A.SassColor_SassColor$rgb(222, 184, 135, 1),
                    "brown",
                    A.SassColor_SassColor$rgb(165, 42, 42, 1),
                    "blueviolet",
                    A.SassColor_SassColor$rgb(138, 43, 226, 1),
                    "blue",
                    A.SassColor_SassColor$rgb(0, 0, 255, 1),
                    "blanchedalmond",
                    A.SassColor_SassColor$rgb(255, 235, 205, 1),
                    "black",
                    A.SassColor_SassColor$rgb(0, 0, 0, 1),
                    "bisque",
                    A.SassColor_SassColor$rgb(255, 228, 196, 1),
                    "beige",
                    A.SassColor_SassColor$rgb(245, 245, 220, 1),
                    "azure",
                    A.SassColor_SassColor$rgb(240, 255, 255, 1),
                    "aquamarine",
                    A.SassColor_SassColor$rgb(127, 255, 212, 1),
                    "aqua",
                    A.SassColor_SassColor$rgb(0, 255, 255, 1),
                    "antiquewhite",
                    A.SassColor_SassColor$rgb(250, 235, 215, 1),
                    "aliceblue",
                    A.SassColor_SassColor$rgb(240, 248, 255, 1)
                ], type$.String, type$.SassColor);
            });
            _lazyFinal($, "namesByColor", "$get$namesByColor", function() {
                var $name, t1 = type$.SassColor, t2 = type$.String, t3 = A.LinkedHashMap_LinkedHashMap$_empty(t1, t2);
                for(t1 = A.MapExtensions_get_pairs($.$get$colorsByName(), t2, t1), t1 = t1.get$iterator(t1); t1.moveNext$0();){
                    t2 = t1.get$current(t1);
                    $name = t2._0;
                    t3.$indexSet(0, t2._1, $name);
                }
                return t3;
            });
            _lazyFinal($, "ExecutableOptions__separatorBar", "$get$ExecutableOptions__separatorBar", function() {
                return A.isWindows() ? "=" : "\u2501";
            });
            _lazyFinal($, "ExecutableOptions__parser", "$get$ExecutableOptions__parser", function() {
                return new A.ExecutableOptions__parser_closure().call$0();
            });
            _lazyFinal($, "globalFunctions", "$get$globalFunctions", function() {
                var t1 = type$.BuiltInCallable, t2 = A.List_List$of($.$get$global(), true, t1);
                B.JSArray_methods.addAll$1(t2, $.$get$global0());
                B.JSArray_methods.addAll$1(t2, $.$get$global1());
                B.JSArray_methods.addAll$1(t2, $.$get$global2());
                B.JSArray_methods.addAll$1(t2, $.$get$global3());
                B.JSArray_methods.addAll$1(t2, $.$get$global4());
                B.JSArray_methods.addAll$1(t2, $.$get$global5());
                t2.push(A.BuiltInCallable$function("if", "$condition, $if-true, $if-false", new A.globalFunctions_closure(), null));
                return A.UnmodifiableListView$(t2, t1);
            });
            _lazyFinal($, "coreModules", "$get$coreModules", function() {
                return A.UnmodifiableListView$(A._setArrayType([
                    $.$get$module(),
                    $.$get$module0(),
                    $.$get$module1(),
                    $.$get$module2(),
                    $.$get$module3(),
                    $.$get$module4()
                ], A.findType("JSArray<BuiltInModule<Callable0>>")), type$.BuiltInModule_Callable);
            });
            _lazyFinal($, "_microsoftFilterStart", "$get$_microsoftFilterStart", function() {
                return A.RegExp_RegExp("^[a-zA-Z]+\\s*=", false);
            });
            _lazyFinal($, "global", "$get$global", function() {
                var _s5_ = "color", _s27_ = "$red, $green, $blue, $alpha", _s19_ = "$red, $green, $blue", _s9_ = "$channels", _s37_ = "$hue, $saturation, $lightness, $alpha", _s29_ = "$hue, $saturation, $lightness", _s17_ = "$hue, $saturation", _s6_ = "adjust", _s15_ = "$color, $amount", t1 = type$.String, t2 = type$.Value_Function_List_Value;
                return A.UnmodifiableListView$(A._setArrayType([
                    A._channelFunction("red", B.RgbColorSpace_i0P, new A.global_closure0(), true, null).withDeprecationWarning$1(_s5_),
                    A._channelFunction("green", B.RgbColorSpace_i0P, new A.global_closure1(), true, null).withDeprecationWarning$1(_s5_),
                    A._channelFunction("blue", B.RgbColorSpace_i0P, new A.global_closure2(), true, null).withDeprecationWarning$1(_s5_),
                    $.$get$_mix().withDeprecationWarning$1(_s5_),
                    A.BuiltInCallable$overloadedFunction("rgb", A.LinkedHashMap_LinkedHashMap$_literal([
                        _s27_,
                        new A.global_closure3(),
                        _s19_,
                        new A.global_closure4(),
                        "$color, $alpha",
                        new A.global_closure5(),
                        "$channels",
                        new A.global_closure6()
                    ], t1, t2)),
                    A.BuiltInCallable$overloadedFunction("rgba", A.LinkedHashMap_LinkedHashMap$_literal([
                        _s27_,
                        new A.global_closure7(),
                        _s19_,
                        new A.global_closure8(),
                        "$color, $alpha",
                        new A.global_closure9(),
                        "$channels",
                        new A.global_closure10()
                    ], t1, t2)),
                    A._function5("invert", "$color, $weight: 100%, $space: null", new A.global_closure11()),
                    A._channelFunction("hue", B.HslColorSpace_JQ2, new A.global_closure12(), true, "deg").withDeprecationWarning$1(_s5_),
                    A._channelFunction("saturation", B.HslColorSpace_JQ2, new A.global_closure13(), true, "%").withDeprecationWarning$1(_s5_),
                    A._channelFunction("lightness", B.HslColorSpace_JQ2, new A.global_closure14(), true, "%").withDeprecationWarning$1(_s5_),
                    A.BuiltInCallable$overloadedFunction("hsl", A.LinkedHashMap_LinkedHashMap$_literal([
                        _s37_,
                        new A.global_closure15(),
                        _s29_,
                        new A.global_closure16(),
                        _s17_,
                        new A.global_closure17(),
                        "$channels",
                        new A.global_closure18()
                    ], t1, t2)),
                    A.BuiltInCallable$overloadedFunction("hsla", A.LinkedHashMap_LinkedHashMap$_literal([
                        _s37_,
                        new A.global_closure19(),
                        _s29_,
                        new A.global_closure20(),
                        _s17_,
                        new A.global_closure21(),
                        "$channels",
                        new A.global_closure22()
                    ], t1, t2)),
                    A._function5("grayscale", "$color", new A.global_closure23()),
                    A._function5("adjust-hue", "$color, $degrees", new A.global_closure24()).withDeprecationWarning$2(_s5_, _s6_),
                    A._function5("lighten", _s15_, new A.global_closure25()).withDeprecationWarning$2(_s5_, _s6_),
                    A._function5("darken", _s15_, new A.global_closure26()).withDeprecationWarning$2(_s5_, _s6_),
                    A.BuiltInCallable$overloadedFunction("saturate", A.LinkedHashMap_LinkedHashMap$_literal([
                        "$amount",
                        new A.global_closure27(),
                        "$color, $amount",
                        new A.global_closure28()
                    ], t1, t2)),
                    A._function5("desaturate", _s15_, new A.global_closure29()).withDeprecationWarning$2(_s5_, _s6_),
                    A._function5("opacify", _s15_, new A.global_closure30()).withDeprecationWarning$2(_s5_, _s6_),
                    A._function5("fade-in", _s15_, new A.global_closure31()).withDeprecationWarning$2(_s5_, _s6_),
                    A._function5("transparentize", _s15_, new A.global_closure32()).withDeprecationWarning$2(_s5_, _s6_),
                    A._function5("fade-out", _s15_, new A.global_closure33()).withDeprecationWarning$2(_s5_, _s6_),
                    A.BuiltInCallable$overloadedFunction("alpha", A.LinkedHashMap_LinkedHashMap$_literal([
                        "$color",
                        new A.global_closure34(),
                        "$args...",
                        new A.global_closure35()
                    ], t1, t2)),
                    A._function5("opacity", "$color", new A.global_closure36()),
                    A._function5(_s5_, "$description", new A.global_closure37()),
                    A._function5("hwb", _s9_, new A.global_closure38()),
                    A._function5("lab", _s9_, new A.global_closure39()),
                    A._function5("lch", _s9_, new A.global_closure40()),
                    A._function5("oklab", _s9_, new A.global_closure41()),
                    A._function5("oklch", _s9_, new A.global_closure42()),
                    $.$get$_complement().withDeprecationWarning$1(_s5_),
                    $.$get$_ieHexStr(),
                    $.$get$_adjust().withDeprecationWarning$1(_s5_).withName$1("adjust-color"),
                    $.$get$_scale().withDeprecationWarning$1(_s5_).withName$1("scale-color"),
                    $.$get$_change().withDeprecationWarning$1(_s5_).withName$1("change-color")
                ], type$.JSArray_BuiltInCallable), type$.BuiltInCallable);
            });
            _lazyFinal($, "module", "$get$module", function() {
                var _null = null, _s10_ = "saturation", _s9_ = "lightness", _s6_ = "$color", _s5_ = "alpha", _s30_ = "$color, $channel, $space: null", t1 = type$.String, t2 = type$.Value_Function_List_Value;
                return A.BuiltInModule$("color", A._setArrayType([
                    A._channelFunction("red", B.RgbColorSpace_i0P, new A.module_closure1(), false, _null),
                    A._channelFunction("green", B.RgbColorSpace_i0P, new A.module_closure2(), false, _null),
                    A._channelFunction("blue", B.RgbColorSpace_i0P, new A.module_closure3(), false, _null),
                    $.$get$_mix(),
                    A._function5("invert", "$color, $weight: 100%, $space: null", new A.module_closure4()),
                    A._channelFunction("hue", B.HslColorSpace_JQ2, new A.module_closure5(), false, "deg"),
                    A._channelFunction(_s10_, B.HslColorSpace_JQ2, new A.module_closure6(), false, "%"),
                    A._channelFunction(_s9_, B.HslColorSpace_JQ2, new A.module_closure7(), false, "%"),
                    A._removedColorFunction("adjust-hue", "hue", false),
                    A._removedColorFunction("lighten", _s9_, false),
                    A._removedColorFunction("darken", _s9_, true),
                    A._removedColorFunction("saturate", _s10_, false),
                    A._removedColorFunction("desaturate", _s10_, true),
                    A._function5("grayscale", _s6_, new A.module_closure8()),
                    A.BuiltInCallable$overloadedFunction("hwb", A.LinkedHashMap_LinkedHashMap$_literal([
                        "$hue, $whiteness, $blackness, $alpha: 1",
                        new A.module_closure9(),
                        "$channels",
                        new A.module_closure10()
                    ], t1, t2)),
                    A._channelFunction("whiteness", B.HwbColorSpace_guQ, new A.module_closure11(), false, "%"),
                    A._channelFunction("blackness", B.HwbColorSpace_guQ, new A.module_closure12(), false, "%"),
                    A._removedColorFunction("opacify", _s5_, false),
                    A._removedColorFunction("fade-in", _s5_, false),
                    A._removedColorFunction("transparentize", _s5_, true),
                    A._removedColorFunction("fade-out", _s5_, true),
                    A.BuiltInCallable$overloadedFunction(_s5_, A.LinkedHashMap_LinkedHashMap$_literal([
                        "$color",
                        new A.module_closure13(),
                        "$args...",
                        new A.module_closure14()
                    ], t1, t2)),
                    A._function5("opacity", _s6_, new A.module_closure15()),
                    A._function5("space", _s6_, new A.module_closure16()),
                    A._function5("to-space", "$color, $space", new A.module_closure17()),
                    A._function5("is-legacy", _s6_, new A.module_closure18()),
                    A._function5("is-missing", "$color, $channel", new A.module_closure19()),
                    A._function5("is-in-gamut", "$color, $space: null", new A.module_closure20()),
                    A._function5("to-gamut", "$color, $space: null, $method: null", new A.module_closure21()),
                    A._function5("channel", _s30_, new A.module_closure22()),
                    A._function5("same", "$color1, $color2", new A.module_closure23()),
                    A._function5("is-powerless", _s30_, new A.module_closure24()),
                    $.$get$_complement(),
                    $.$get$_adjust(),
                    $.$get$_scale(),
                    $.$get$_change(),
                    $.$get$_ieHexStr()
                ], type$.JSArray_Callable), _null, _null, type$.Callable);
            });
            _lazyFinal($, "_mix", "$get$_mix", function() {
                return A._function5("mix", string$.x24color, new A._mix_closure());
            });
            _lazyFinal($, "_complement", "$get$_complement", function() {
                return A._function5("complement", "$color, $space: null", new A._complement_closure());
            });
            _lazyFinal($, "_adjust", "$get$_adjust", function() {
                return A._function5("adjust", "$color, $kwargs...", new A._adjust_closure());
            });
            _lazyFinal($, "_scale", "$get$_scale", function() {
                return A._function5("scale", "$color, $kwargs...", new A._scale_closure());
            });
            _lazyFinal($, "_change", "$get$_change", function() {
                return A._function5("change", "$color, $kwargs...", new A._change_closure());
            });
            _lazyFinal($, "_ieHexStr", "$get$_ieHexStr", function() {
                return A._function5("ie-hex-str", "$color", new A._ieHexStr_closure());
            });
            _lazyFinal($, "global0", "$get$global0", function() {
                var _s4_ = "list";
                return A.UnmodifiableListView$(A._setArrayType([
                    $.$get$_length0().withDeprecationWarning$1(_s4_),
                    $.$get$_nth().withDeprecationWarning$1(_s4_),
                    $.$get$_setNth().withDeprecationWarning$1(_s4_),
                    $.$get$_join().withDeprecationWarning$1(_s4_),
                    $.$get$_append0().withDeprecationWarning$1(_s4_),
                    $.$get$_zip().withDeprecationWarning$1(_s4_),
                    $.$get$_index0().withDeprecationWarning$1(_s4_),
                    $.$get$_isBracketed().withDeprecationWarning$1(_s4_),
                    $.$get$_separator().withDeprecationWarning$1(_s4_).withName$1("list-separator")
                ], type$.JSArray_BuiltInCallable), type$.BuiltInCallable);
            });
            _lazyFinal($, "module0", "$get$module0", function() {
                return A.BuiltInModule$("list", A._setArrayType([
                    $.$get$_length0(),
                    $.$get$_nth(),
                    $.$get$_setNth(),
                    $.$get$_join(),
                    $.$get$_append0(),
                    $.$get$_zip(),
                    $.$get$_index0(),
                    $.$get$_isBracketed(),
                    $.$get$_separator(),
                    $.$get$_slash()
                ], type$.JSArray_Callable), null, null, type$.Callable);
            });
            _lazyFinal($, "_length", "$get$_length0", function() {
                return A._function4("length", "$list", new A._length_closure0());
            });
            _lazyFinal($, "_nth", "$get$_nth", function() {
                return A._function4("nth", "$list, $n", new A._nth_closure());
            });
            _lazyFinal($, "_setNth", "$get$_setNth", function() {
                return A._function4("set-nth", "$list, $n, $value", new A._setNth_closure());
            });
            _lazyFinal($, "_join", "$get$_join", function() {
                return A._function4("join", string$.x24list1, new A._join_closure());
            });
            _lazyFinal($, "_append", "$get$_append0", function() {
                return A._function4("append", "$list, $val, $separator: auto", new A._append_closure0());
            });
            _lazyFinal($, "_zip", "$get$_zip", function() {
                return A._function4("zip", "$lists...", new A._zip_closure());
            });
            _lazyFinal($, "_index", "$get$_index0", function() {
                return A._function4("index", "$list, $value", new A._index_closure0());
            });
            _lazyFinal($, "_separator", "$get$_separator", function() {
                return A._function4("separator", "$list", new A._separator_closure());
            });
            _lazyFinal($, "_isBracketed", "$get$_isBracketed", function() {
                return A._function4("is-bracketed", "$list", new A._isBracketed_closure());
            });
            _lazyFinal($, "_slash", "$get$_slash", function() {
                return A._function4("slash", "$elements...", new A._slash_closure());
            });
            _lazyFinal($, "global1", "$get$global1", function() {
                var _s3_ = "map";
                return A.UnmodifiableListView$(A._setArrayType([
                    $.$get$_get().withDeprecationWarning$1(_s3_).withName$1("map-get"),
                    $.$get$_merge().withDeprecationWarning$1(_s3_).withName$1("map-merge"),
                    $.$get$_remove().withDeprecationWarning$1(_s3_).withName$1("map-remove"),
                    $.$get$_keys().withDeprecationWarning$1(_s3_).withName$1("map-keys"),
                    $.$get$_values().withDeprecationWarning$1(_s3_).withName$1("map-values"),
                    $.$get$_hasKey().withDeprecationWarning$1(_s3_).withName$1("map-has-key")
                ], type$.JSArray_BuiltInCallable), type$.BuiltInCallable);
            });
            _lazyFinal($, "module1", "$get$module1", function() {
                return A.BuiltInModule$("map", A._setArrayType([
                    $.$get$_get(),
                    $.$get$_set(),
                    $.$get$_merge(),
                    $.$get$_remove(),
                    $.$get$_keys(),
                    $.$get$_values(),
                    $.$get$_hasKey(),
                    $.$get$_deepMerge(),
                    $.$get$_deepRemove()
                ], type$.JSArray_Callable), null, null, type$.Callable);
            });
            _lazyFinal($, "_get", "$get$_get", function() {
                return A._function3("get", "$map, $key, $keys...", new A._get_closure());
            });
            _lazyFinal($, "_set", "$get$_set", function() {
                return A.BuiltInCallable$overloadedFunction("set", A.LinkedHashMap_LinkedHashMap$_literal([
                    "$map, $key, $value",
                    new A._set_closure(),
                    "$map, $args...",
                    new A._set_closure0()
                ], type$.String, type$.Value_Function_List_Value));
            });
            _lazyFinal($, "_merge", "$get$_merge", function() {
                return A.BuiltInCallable$overloadedFunction("merge", A.LinkedHashMap_LinkedHashMap$_literal([
                    "$map1, $map2",
                    new A._merge_closure(),
                    "$map1, $args...",
                    new A._merge_closure0()
                ], type$.String, type$.Value_Function_List_Value));
            });
            _lazyFinal($, "_deepMerge", "$get$_deepMerge", function() {
                return A._function3("deep-merge", "$map1, $map2", new A._deepMerge_closure());
            });
            _lazyFinal($, "_deepRemove", "$get$_deepRemove", function() {
                return A._function3("deep-remove", "$map, $key, $keys...", new A._deepRemove_closure());
            });
            _lazyFinal($, "_remove", "$get$_remove", function() {
                return A.BuiltInCallable$overloadedFunction("remove", A.LinkedHashMap_LinkedHashMap$_literal([
                    "$map",
                    new A._remove_closure(),
                    "$map, $key, $keys...",
                    new A._remove_closure0()
                ], type$.String, type$.Value_Function_List_Value));
            });
            _lazyFinal($, "_keys", "$get$_keys", function() {
                return A._function3("keys", "$map", new A._keys_closure());
            });
            _lazyFinal($, "_values", "$get$_values", function() {
                return A._function3("values", "$map", new A._values_closure());
            });
            _lazyFinal($, "_hasKey", "$get$_hasKey", function() {
                return A._function3("has-key", "$map, $key, $keys...", new A._hasKey_closure());
            });
            _lazyFinal($, "global2", "$get$global2", function() {
                var _s4_ = "math";
                return A.UnmodifiableListView$(A._setArrayType([
                    A._function2("abs", "$number", new A.global_closure()),
                    $.$get$_ceil().withDeprecationWarning$1(_s4_),
                    $.$get$_floor().withDeprecationWarning$1(_s4_),
                    $.$get$_max().withDeprecationWarning$1(_s4_),
                    $.$get$_min().withDeprecationWarning$1(_s4_),
                    $.$get$_percentage().withDeprecationWarning$1(_s4_),
                    $.$get$_randomFunction().withDeprecationWarning$1(_s4_),
                    $.$get$_round().withDeprecationWarning$1(_s4_),
                    $.$get$_unit().withDeprecationWarning$1(_s4_),
                    $.$get$_compatible().withDeprecationWarning$1(_s4_).withName$1("comparable"),
                    $.$get$_isUnitless().withDeprecationWarning$1(_s4_).withName$1("unitless")
                ], type$.JSArray_BuiltInCallable), type$.BuiltInCallable);
            });
            _lazyFinal($, "module2", "$get$module2", function() {
                var _null = null;
                return A.BuiltInModule$("math", A._setArrayType([
                    A._numberFunction("abs", new A.module_closure0()),
                    $.$get$_acos(),
                    $.$get$_asin(),
                    $.$get$_atan(),
                    $.$get$_atan2(),
                    $.$get$_ceil(),
                    $.$get$_clamp(),
                    $.$get$_cos(),
                    $.$get$_compatible(),
                    $.$get$_floor(),
                    $.$get$_hypot(),
                    $.$get$_isUnitless(),
                    $.$get$_log(),
                    $.$get$_max(),
                    $.$get$_min(),
                    $.$get$_percentage(),
                    $.$get$_pow(),
                    $.$get$_randomFunction(),
                    $.$get$_round(),
                    $.$get$_sin(),
                    $.$get$_sqrt(),
                    $.$get$_tan(),
                    $.$get$_unit(),
                    $.$get$_div()
                ], type$.JSArray_Callable), _null, A.LinkedHashMap_LinkedHashMap$_literal([
                    "e",
                    A.SassNumber_SassNumber(2.718281828459045, _null),
                    "pi",
                    A.SassNumber_SassNumber(3.141592653589793, _null),
                    "epsilon",
                    A.SassNumber_SassNumber(2220446049250313e-31, _null),
                    "max-safe-integer",
                    A.SassNumber_SassNumber(9007199254740991, _null),
                    "min-safe-integer",
                    A.SassNumber_SassNumber(-9007199254740991, _null),
                    "max-number",
                    A.SassNumber_SassNumber(17976931348623157e292, _null),
                    "min-number",
                    A.SassNumber_SassNumber(5e-324, _null)
                ], type$.String, type$.Value), type$.Callable);
            });
            _lazyFinal($, "_ceil", "$get$_ceil", function() {
                return A._numberFunction("ceil", new A._ceil_closure());
            });
            _lazyFinal($, "_clamp", "$get$_clamp", function() {
                return A._function2("clamp", "$min, $number, $max", new A._clamp_closure());
            });
            _lazyFinal($, "_floor", "$get$_floor", function() {
                return A._numberFunction("floor", new A._floor_closure());
            });
            _lazyFinal($, "_max", "$get$_max", function() {
                return A._function2("max", "$numbers...", new A._max_closure());
            });
            _lazyFinal($, "_min", "$get$_min", function() {
                return A._function2("min", "$numbers...", new A._min_closure());
            });
            _lazyFinal($, "_round", "$get$_round", function() {
                return A._numberFunction("round", new A._round_closure());
            });
            _lazyFinal($, "_hypot", "$get$_hypot", function() {
                return A._function2("hypot", "$numbers...", new A._hypot_closure());
            });
            _lazyFinal($, "_log", "$get$_log", function() {
                return A._function2("log", "$number, $base: null", new A._log_closure());
            });
            _lazyFinal($, "_pow", "$get$_pow", function() {
                return A._function2("pow", "$base, $exponent", new A._pow_closure());
            });
            _lazyFinal($, "_sqrt", "$get$_sqrt", function() {
                return A._singleArgumentMathFunc("sqrt", A.number0__sqrt$closure());
            });
            _lazyFinal($, "_acos", "$get$_acos", function() {
                return A._singleArgumentMathFunc("acos", A.number0__acos$closure());
            });
            _lazyFinal($, "_asin", "$get$_asin", function() {
                return A._singleArgumentMathFunc("asin", A.number0__asin$closure());
            });
            _lazyFinal($, "_atan", "$get$_atan", function() {
                return A._singleArgumentMathFunc("atan", A.number0__atan$closure());
            });
            _lazyFinal($, "_atan2", "$get$_atan2", function() {
                return A._function2("atan2", "$y, $x", new A._atan2_closure());
            });
            _lazyFinal($, "_cos", "$get$_cos", function() {
                return A._singleArgumentMathFunc("cos", A.number0__cos$closure());
            });
            _lazyFinal($, "_sin", "$get$_sin", function() {
                return A._singleArgumentMathFunc("sin", A.number0__sin$closure());
            });
            _lazyFinal($, "_tan", "$get$_tan", function() {
                return A._singleArgumentMathFunc("tan", A.number0__tan$closure());
            });
            _lazyFinal($, "_compatible", "$get$_compatible", function() {
                return A._function2("compatible", "$number1, $number2", new A._compatible_closure());
            });
            _lazyFinal($, "_isUnitless", "$get$_isUnitless", function() {
                return A._function2("is-unitless", "$number", new A._isUnitless_closure());
            });
            _lazyFinal($, "_unit", "$get$_unit", function() {
                return A._function2("unit", "$number", new A._unit_closure());
            });
            _lazyFinal($, "_percentage", "$get$_percentage", function() {
                return A._function2("percentage", "$number", new A._percentage_closure());
            });
            _lazyFinal($, "_random", "$get$_random0", function() {
                return A.Random_Random();
            });
            _lazyFinal($, "_randomFunction", "$get$_randomFunction", function() {
                return A._function2("random", "$limit: null", new A._randomFunction_closure());
            });
            _lazyFinal($, "_div", "$get$_div", function() {
                return A._function2("div", "$number1, $number2", new A._div_closure());
            });
            _lazyFinal($, "_shared", "$get$_shared", function() {
                return A.UnmodifiableListView$(A._setArrayType([
                    A._function("feature-exists", "$feature", new A._shared_closure()),
                    A._function("inspect", "$value", new A._shared_closure0()),
                    A._function("type-of", "$value", new A._shared_closure1()),
                    A._function("keywords", "$args", new A._shared_closure2())
                ], type$.JSArray_BuiltInCallable), type$.BuiltInCallable);
            });
            _lazyFinal($, "global3", "$get$global5", function() {
                var t2, t1 = A._setArrayType([], type$.JSArray_BuiltInCallable);
                for(t2 = $.$get$_shared(), t2 = t2.get$iterator(t2); t2.moveNext$0();)t1.push(t2.get$current(0).withDeprecationWarning$1("meta"));
                return A.UnmodifiableListView$(t1, type$.BuiltInCallable);
            });
            _lazyFinal($, "moduleFunctions", "$get$moduleFunctions", function() {
                var t1 = type$.BuiltInCallable, t2 = A.List_List$of($.$get$_shared(), true, t1);
                t2.push(A._function("calc-name", "$calc", new A.moduleFunctions_closure()));
                t2.push(A._function("calc-args", "$calc", new A.moduleFunctions_closure0()));
                t2.push(A._function("accepts-content", "$mixin", new A.moduleFunctions_closure1()));
                return A.UnmodifiableListView$(t2, t1);
            });
            _lazyFinal($, "global4", "$get$global3", function() {
                var _s8_ = "selector";
                return A.UnmodifiableListView$(A._setArrayType([
                    $.$get$_isSuperselector().withDeprecationWarning$1(_s8_),
                    $.$get$_simpleSelectors().withDeprecationWarning$1(_s8_),
                    $.$get$_parse().withDeprecationWarning$1(_s8_).withName$1("selector-parse"),
                    $.$get$_nest().withDeprecationWarning$1(_s8_).withName$1("selector-nest"),
                    $.$get$_append().withDeprecationWarning$1(_s8_).withName$1("selector-append"),
                    $.$get$_extend().withDeprecationWarning$1(_s8_).withName$1("selector-extend"),
                    $.$get$_replace().withDeprecationWarning$1(_s8_).withName$1("selector-replace"),
                    $.$get$_unify().withDeprecationWarning$1(_s8_).withName$1("selector-unify")
                ], type$.JSArray_BuiltInCallable), type$.BuiltInCallable);
            });
            _lazyFinal($, "module3", "$get$module3", function() {
                return A.BuiltInModule$("selector", A._setArrayType([
                    $.$get$_isSuperselector(),
                    $.$get$_simpleSelectors(),
                    $.$get$_parse(),
                    $.$get$_nest(),
                    $.$get$_append(),
                    $.$get$_extend(),
                    $.$get$_replace(),
                    $.$get$_unify()
                ], type$.JSArray_Callable), null, null, type$.Callable);
            });
            _lazyFinal($, "_nest", "$get$_nest", function() {
                return A._function1("nest", "$selectors...", new A._nest_closure());
            });
            _lazyFinal($, "_append0", "$get$_append", function() {
                return A._function1("append", "$selectors...", new A._append_closure());
            });
            _lazyFinal($, "_extend", "$get$_extend", function() {
                return A._function1("extend", "$selector, $extendee, $extender", new A._extend_closure());
            });
            _lazyFinal($, "_replace", "$get$_replace", function() {
                return A._function1("replace", "$selector, $original, $replacement", new A._replace_closure());
            });
            _lazyFinal($, "_unify", "$get$_unify", function() {
                return A._function1("unify", "$selector1, $selector2", new A._unify_closure());
            });
            _lazyFinal($, "_isSuperselector", "$get$_isSuperselector", function() {
                return A._function1("is-superselector", "$super, $sub", new A._isSuperselector_closure());
            });
            _lazyFinal($, "_simpleSelectors", "$get$_simpleSelectors", function() {
                return A._function1("simple-selectors", "$selector", new A._simpleSelectors_closure());
            });
            _lazyFinal($, "_parse0", "$get$_parse", function() {
                return A._function1("parse", "$selector", new A._parse_closure());
            });
            _lazyFinal($, "_random0", "$get$_random", function() {
                return A.Random_Random();
            });
            _lazy($, "_previousUniqueId", "$get$_previousUniqueId", function() {
                return $.$get$_random().nextInt$1(A._asInt(A.pow(36, 6)));
            });
            _lazyFinal($, "global5", "$get$global4", function() {
                var _s6_ = "string";
                return A.UnmodifiableListView$(A._setArrayType([
                    $.$get$_unquote().withDeprecationWarning$1(_s6_),
                    $.$get$_quote().withDeprecationWarning$1(_s6_),
                    $.$get$_toUpperCase().withDeprecationWarning$1(_s6_),
                    $.$get$_toLowerCase().withDeprecationWarning$1(_s6_),
                    $.$get$_uniqueId().withDeprecationWarning$1(_s6_),
                    $.$get$_length().withDeprecationWarning$1(_s6_).withName$1("str-length"),
                    $.$get$_insert().withDeprecationWarning$1(_s6_).withName$1("str-insert"),
                    $.$get$_index().withDeprecationWarning$1(_s6_).withName$1("str-index"),
                    $.$get$_slice().withDeprecationWarning$1(_s6_).withName$1("str-slice")
                ], type$.JSArray_BuiltInCallable), type$.BuiltInCallable);
            });
            _lazyFinal($, "module4", "$get$module4", function() {
                return A.BuiltInModule$("string", A._setArrayType([
                    $.$get$_unquote(),
                    $.$get$_quote(),
                    $.$get$_toUpperCase(),
                    $.$get$_toLowerCase(),
                    $.$get$_length(),
                    $.$get$_insert(),
                    $.$get$_index(),
                    $.$get$_slice(),
                    $.$get$_uniqueId(),
                    A._function0("split", "$string, $separator, $limit: null", new A.module_closure())
                ], type$.JSArray_Callable), null, null, type$.Callable);
            });
            _lazyFinal($, "_unquote", "$get$_unquote", function() {
                return A._function0("unquote", "$string", new A._unquote_closure());
            });
            _lazyFinal($, "_quote", "$get$_quote", function() {
                return A._function0("quote", "$string", new A._quote_closure());
            });
            _lazyFinal($, "_length0", "$get$_length", function() {
                return A._function0("length", "$string", new A._length_closure());
            });
            _lazyFinal($, "_insert", "$get$_insert", function() {
                return A._function0("insert", "$string, $insert, $index", new A._insert_closure());
            });
            _lazyFinal($, "_index0", "$get$_index", function() {
                return A._function0("index", "$string, $substring", new A._index_closure());
            });
            _lazyFinal($, "_slice", "$get$_slice", function() {
                return A._function0("slice", "$string, $start-at, $end-at: -1", new A._slice_closure());
            });
            _lazyFinal($, "_toUpperCase", "$get$_toUpperCase", function() {
                return A._function0("to-upper-case", "$string", new A._toUpperCase_closure());
            });
            _lazyFinal($, "_toLowerCase", "$get$_toLowerCase", function() {
                return A._function0("to-lower-case", "$string", new A._toLowerCase_closure());
            });
            _lazyFinal($, "_uniqueId", "$get$_uniqueId", function() {
                return A._function0("unique-id", "", new A._uniqueId_closure());
            });
            _lazyFinal($, "FilesystemImporter_cwd", "$get$FilesystemImporter_cwd", function() {
                var _null = null;
                return new A.FilesystemImporter(A.absolute(".", _null, _null, _null, _null, _null, _null, _null, _null, _null, _null, _null, _null, _null, _null), true);
            });
            _lazyFinal($, "FilesystemImporter_noLoadPath", "$get$FilesystemImporter_noLoadPath", function() {
                return new A.FilesystemImporter(null, false);
            });
            _lazyFinal($, "_jsThrow", "$get$_jsThrow0", function() {
                return new self.Function("error", "throw error;");
            });
            _lazyFinal($, "Logger_quiet", "$get$Logger_quiet", function() {
                return new A._QuietLogger();
            });
            _lazyFinal($, "_disallowedFunctionNames", "$get$_disallowedFunctionNames", function() {
                var t1 = $.$get$globalFunctions();
                t1 = t1.map$1$1(t1, new A._disallowedFunctionNames_closure(), type$.String).toSet$0(0);
                t1.remove$1(0, "abs");
                t1.remove$1(0, "alpha");
                t1.remove$1(0, "color");
                t1.remove$1(0, "grayscale");
                t1.remove$1(0, "hsl");
                t1.remove$1(0, "hsla");
                t1.remove$1(0, "hwb");
                t1.remove$1(0, "invert");
                t1.remove$1(0, "lab");
                t1.remove$1(0, "lch");
                t1.remove$1(0, "max");
                t1.remove$1(0, "min");
                t1.remove$1(0, "oklab");
                t1.remove$1(0, "oklch");
                t1.remove$1(0, "opacity");
                t1.remove$1(0, "rgb");
                t1.remove$1(0, "rgba");
                t1.remove$1(0, "round");
                t1.remove$1(0, "saturate");
                return t1;
            });
            _lazyFinal($, "_epsilon", "$get$_epsilon", function() {
                return A.pow(10, -11);
            });
            _lazyFinal($, "_inverseEpsilon", "$get$_inverseEpsilon", function() {
                return A.pow(10, 11);
            });
            _lazyFinal($, "bogusSpan", "$get$bogusSpan", function() {
                return A.SourceFile$decoded(A._setArrayType([], type$.JSArray_int), null).span$1(0, 0);
            });
            _lazyFinal($, "_noSourceUrl", "$get$_noSourceUrl", function() {
                return A.Uri_parse("-");
            });
            _lazyFinal($, "_traces", "$get$_traces", function() {
                return A.Expando$();
            });
            _lazyFinal($, "lmsToOklab", "$get$lmsToOklab", function() {
                return A.NativeFloat64List_NativeFloat64List$fromList(A._setArrayType([
                    0.210454268309314,
                    0.7936177747023054,
                    -0.0040720430116193,
                    1.9779985324311684,
                    -2.42859224204858,
                    0.450593709617411,
                    0.0259040424655478,
                    0.7827717124575296,
                    -0.8086757549230774
                ], type$.JSArray_double));
            });
            _lazyFinal($, "oklabToLms", "$get$oklabToLms", function() {
                return A.NativeFloat64List_NativeFloat64List$fromList(A._setArrayType([
                    1.0000000000000002,
                    0.3963377773761749,
                    0.2158037573099136,
                    0.9999999999999998,
                    -0.10556134581565854,
                    -0.06385417282581334,
                    0.9999999999999999,
                    -0.0894841775298118,
                    -1.2914855480194094
                ], type$.JSArray_double));
            });
            _lazyFinal($, "linearSrgbToLinearDisplayP3", "$get$linearSrgbToLinearDisplayP3", function() {
                return A.NativeFloat64List_NativeFloat64List$fromList(A._setArrayType([
                    0.8224619687143623,
                    0.17753803128563775,
                    0,
                    0.03319419885096161,
                    0.9668058011490384,
                    0,
                    0.01708263072112003,
                    0.07239744066396346,
                    0.9105199286149165
                ], type$.JSArray_double));
            });
            _lazyFinal($, "linearDisplayP3ToLinearSrgb", "$get$linearDisplayP3ToLinearSrgb", function() {
                return A.NativeFloat64List_NativeFloat64List$fromList(A._setArrayType([
                    1.2249401762805598,
                    -0.22494017628055996,
                    0,
                    -0.04205695470968816,
                    1.042056954709688,
                    0,
                    -0.01963755459033443,
                    -0.07863604555063188,
                    1.0982736001409663
                ], type$.JSArray_double));
            });
            _lazyFinal($, "linearSrgbToLinearA98Rgb", "$get$linearSrgbToLinearA98Rgb", function() {
                return A.NativeFloat64List_NativeFloat64List$fromList(A._setArrayType([
                    0.7151256068556247,
                    0.28487439314437535,
                    0,
                    0,
                    1,
                    0,
                    0,
                    0.04116194845011846,
                    0.9588380515498816
                ], type$.JSArray_double));
            });
            _lazyFinal($, "linearA98RgbToLinearSrgb", "$get$linearA98RgbToLinearSrgb", function() {
                return A.NativeFloat64List_NativeFloat64List$fromList(A._setArrayType([
                    1.3983557439607783,
                    -0.3983557439607783,
                    0,
                    0,
                    1,
                    0,
                    0,
                    -0.04292898929447326,
                    1.0429289892944733
                ], type$.JSArray_double));
            });
            _lazyFinal($, "linearSrgbToLinearRec2020", "$get$linearSrgbToLinearRec2020", function() {
                return A.NativeFloat64List_NativeFloat64List$fromList(A._setArrayType([
                    0.627403895934699,
                    0.3292830383778837,
                    0.04331306568741722,
                    0.06909728935823208,
                    0.9195403950754587,
                    0.01136231556630917,
                    0.01639143887515027,
                    0.08801330787722575,
                    0.895595253247624
                ], type$.JSArray_double));
            });
            _lazyFinal($, "linearRec2020ToLinearSrgb", "$get$linearRec2020ToLinearSrgb", function() {
                return A.NativeFloat64List_NativeFloat64List$fromList(A._setArrayType([
                    1.6604910021084345,
                    -0.5876411387885495,
                    -0.07284986331988487,
                    -0.12455047452159074,
                    1.1328998971259603,
                    -0.00834942260436947,
                    -0.0181507633549053,
                    -0.10057889800800737,
                    1.1187296613629127
                ], type$.JSArray_double));
            });
            _lazyFinal($, "linearSrgbToXyzD65", "$get$linearSrgbToXyzD65", function() {
                return A.NativeFloat64List_NativeFloat64List$fromList(A._setArrayType([
                    0.4123907992659595,
                    0.35758433938387796,
                    0.1804807884018343,
                    0.21263900587151036,
                    0.7151686787677559,
                    0.07219231536073371,
                    0.01933081871559185,
                    0.11919477979462598,
                    0.9505321522496606
                ], type$.JSArray_double));
            });
            _lazyFinal($, "xyzD65ToLinearSrgb", "$get$xyzD65ToLinearSrgb", function() {
                return A.NativeFloat64List_NativeFloat64List$fromList(A._setArrayType([
                    3.2409699419045213,
                    -1.5373831775700935,
                    -0.4986107602930033,
                    -0.9692436362808798,
                    1.8759675015077206,
                    0.04155505740717561,
                    0.0556300796969936,
                    -0.20397695888897657,
                    1.0569715142428786
                ], type$.JSArray_double));
            });
            _lazyFinal($, "linearSrgbToLms", "$get$linearSrgbToLms", function() {
                return A.NativeFloat64List_NativeFloat64List$fromList(A._setArrayType([
                    0.412221469470763,
                    0.5363325372617348,
                    0.0514459932675022,
                    0.2119034958178252,
                    0.6806995506452342,
                    0.1073969535369405,
                    0.08830245919005641,
                    0.2817188391361215,
                    0.6299787016738221
                ], type$.JSArray_double));
            });
            _lazyFinal($, "lmsToLinearSrgb", "$get$lmsToLinearSrgb", function() {
                return A.NativeFloat64List_NativeFloat64List$fromList(A._setArrayType([
                    4.076741636075958,
                    -3.307711539258062,
                    0.23096990318210417,
                    -1.268437973285032,
                    2.609757349287689,
                    -0.3413193760026571,
                    -0.00419607613867551,
                    -0.7034186179359363,
                    1.707614694074612
                ], type$.JSArray_double));
            });
            _lazyFinal($, "linearSrgbToLinearProphotoRgb", "$get$linearSrgbToLinearProphotoRgb", function() {
                return A.NativeFloat64List_NativeFloat64List$fromList(A._setArrayType([
                    0.5292769776226116,
                    0.33015450197849283,
                    0.14056852039889556,
                    0.09836585954044917,
                    0.8734707129069618,
                    0.028163427552589,
                    0.01687534092138684,
                    0.11765941425612084,
                    0.8654652448224923
                ], type$.JSArray_double));
            });
            _lazyFinal($, "linearProphotoRgbToLinearSrgb", "$get$linearProphotoRgbToLinearSrgb", function() {
                return A.NativeFloat64List_NativeFloat64List$fromList(A._setArrayType([
                    2.034380849516996,
                    -0.7276357899341342,
                    -0.3067450595828618,
                    -0.22882573163305037,
                    1.2317425411901048,
                    -0.00291680955705449,
                    -0.00855882878391742,
                    -0.1532667021380372,
                    1.1618255309219547
                ], type$.JSArray_double));
            });
            _lazyFinal($, "linearSrgbToXyzD50", "$get$linearSrgbToXyzD50", function() {
                return A.NativeFloat64List_NativeFloat64List$fromList(A._setArrayType([
                    0.43606574687426936,
                    0.3851515095901596,
                    0.14307841996513868,
                    0.22249317711056518,
                    0.7168870130944824,
                    0.06061980979495235,
                    0.01392392146316939,
                    0.09708132423141015,
                    0.7140993568158807
                ], type$.JSArray_double));
            });
            _lazyFinal($, "xyzD50ToLinearSrgb", "$get$xyzD50ToLinearSrgb", function() {
                return A.NativeFloat64List_NativeFloat64List$fromList(A._setArrayType([
                    3.1341358529001178,
                    -1.617385998018042,
                    -0.49066221791109754,
                    -0.9787954765557777,
                    1.9162543773959884,
                    0.03344287339036693,
                    0.07195539255794733,
                    -0.228976759815182,
                    1.4053860351131182
                ], type$.JSArray_double));
            });
            _lazyFinal($, "linearDisplayP3ToLinearA98Rgb", "$get$linearDisplayP3ToLinearA98Rgb", function() {
                return A.NativeFloat64List_NativeFloat64List$fromList(A._setArrayType([
                    0.8640051374740484,
                    0.13599486252595164,
                    0,
                    -0.04205695470968816,
                    1.042056954709688,
                    0,
                    -0.02056038078232985,
                    -0.03250613804550798,
                    1.0530665188278379
                ], type$.JSArray_double));
            });
            _lazyFinal($, "linearA98RgbToLinearDisplayP3", "$get$linearA98RgbToLinearDisplayP3", function() {
                return A.NativeFloat64List_NativeFloat64List$fromList(A._setArrayType([
                    1.1500944181410184,
                    -0.15009441814101834,
                    0,
                    0.04641729862941844,
                    0.9535827013705815,
                    0,
                    0.02388759479083904,
                    0.02650477632633013,
                    0.9496076288828308
                ], type$.JSArray_double));
            });
            _lazyFinal($, "linearDisplayP3ToLinearRec2020", "$get$linearDisplayP3ToLinearRec2020", function() {
                return A.NativeFloat64List_NativeFloat64List$fromList(A._setArrayType([
                    0.7538330343617218,
                    0.1985973690526163,
                    0.04756959658566187,
                    0.04574384896535833,
                    0.9417772198116935,
                    0.01247893122294812,
                    -0.00121034035451832,
                    0.01760171730108989,
                    0.9836086230534284
                ], type$.JSArray_double));
            });
            _lazyFinal($, "linearRec2020ToLinearDisplayP3", "$get$linearRec2020ToLinearDisplayP3", function() {
                return A.NativeFloat64List_NativeFloat64List$fromList(A._setArrayType([
                    1.343578252584332,
                    -0.2821796705261357,
                    -0.06139858205819628,
                    -0.06529745278911953,
                    1.0757879158485746,
                    -0.01049046305945495,
                    0.00282178726170095,
                    -0.01959849452449406,
                    1.0167767072627931
                ], type$.JSArray_double));
            });
            _lazyFinal($, "linearDisplayP3ToXyzD65", "$get$linearDisplayP3ToXyzD65", function() {
                return A.NativeFloat64List_NativeFloat64List$fromList(A._setArrayType([
                    0.48657094864821626,
                    0.26566769316909294,
                    0.1982172852343625,
                    0.22897456406974884,
                    0.6917385218365062,
                    0.079286914093745,
                    0,
                    0.04511338185890257,
                    1.0439443689009757
                ], type$.JSArray_double));
            });
            _lazyFinal($, "xyzD65ToLinearDisplayP3", "$get$xyzD65ToLinearDisplayP3", function() {
                return A.NativeFloat64List_NativeFloat64List$fromList(A._setArrayType([
                    2.4934969119414245,
                    -0.9313836179191236,
                    -0.40271078445071684,
                    -0.8294889695615749,
                    1.7626640603183468,
                    0.02362468584194359,
                    0.03584583024378433,
                    -0.0761723892680417,
                    0.9568845240076873
                ], type$.JSArray_double));
            });
            _lazyFinal($, "linearDisplayP3ToLms", "$get$linearDisplayP3ToLms", function() {
                return A.NativeFloat64List_NativeFloat64List$fromList(A._setArrayType([
                    0.48137985274995443,
                    0.46211837101131803,
                    0.05650177623872756,
                    0.22883194181124472,
                    0.6532168193835676,
                    0.11795123880518774,
                    0.08394575232299319,
                    0.22416527097756642,
                    0.6918889766994404
                ], type$.JSArray_double));
            });
            _lazyFinal($, "lmsToLinearDisplayP3", "$get$lmsToLinearDisplayP3", function() {
                return A.NativeFloat64List_NativeFloat64List$fromList(A._setArrayType([
                    3.1277689713618737,
                    -2.2571357625916386,
                    0.12936679122976494,
                    -1.0910090184377979,
                    2.4133317103069225,
                    -0.32232269186912466,
                    -0.02601080193857045,
                    -0.508041331704167,
                    1.5340521336427373
                ], type$.JSArray_double));
            });
            _lazyFinal($, "linearDisplayP3ToLinearProphotoRgb", "$get$linearDisplayP3ToLinearProphotoRgb", function() {
                return A.NativeFloat64List_NativeFloat64List$fromList(A._setArrayType([
                    0.6316869193403589,
                    0.21393038569465722,
                    0.1543826949649839,
                    0.08320371426648458,
                    0.8858651367630243,
                    0.03093114897049121,
                    -0.00127273456473881,
                    0.05075510433665735,
                    0.9505176302280814
                ], type$.JSArray_double));
            });
            _lazyFinal($, "linearProphotoRgbToLinearDisplayP3", "$get$linearProphotoRgbToLinearDisplayP3", function() {
                return A.NativeFloat64List_NativeFloat64List$fromList(A._setArrayType([
                    1.6325756087069179,
                    -0.3797716184825984,
                    -0.2528039902243195,
                    -0.15370040233755072,
                    1.1667025472425014,
                    -0.01300214490495082,
                    0.01039319529676572,
                    -0.0628073126495944,
                    1.0524141173528287
                ], type$.JSArray_double));
            });
            _lazyFinal($, "linearDisplayP3ToXyzD50", "$get$linearDisplayP3ToXyzD50", function() {
                return A.NativeFloat64List_NativeFloat64List$fromList(A._setArrayType([
                    0.515146442968116,
                    0.2920099820638577,
                    0.15713925139759397,
                    0.2412003221252552,
                    0.6922225411313818,
                    0.06657713674336294,
                    -0.00105013914714014,
                    0.0418782701890746,
                    0.7842764714685257
                ], type$.JSArray_double));
            });
            _lazyFinal($, "xyzD50ToLinearDisplayP3", "$get$xyzD50ToLinearDisplayP3", function() {
                return A.NativeFloat64List_NativeFloat64List$fromList(A._setArrayType([
                    2.4039341218554973,
                    -0.9900304424955931,
                    -0.39761363181465614,
                    -0.8422700161454688,
                    1.7989580161067082,
                    0.01604562477090472,
                    0.04819381686413303,
                    -0.09738519815446048,
                    1.2736713693321273
                ], type$.JSArray_double));
            });
            _lazyFinal($, "linearA98RgbToLinearRec2020", "$get$linearA98RgbToLinearRec2020", function() {
                return A.NativeFloat64List_NativeFloat64List$fromList(A._setArrayType([
                    0.8773338416636568,
                    0.07749370651571998,
                    0.04517245182062317,
                    0.09662259146620378,
                    0.8915273202441805,
                    0.01185008828961569,
                    0.02292106270284839,
                    0.04303668501067932,
                    0.9340422522864723
                ], type$.JSArray_double));
            });
            _lazyFinal($, "linearRec2020ToLinearA98Rgb", "$get$linearRec2020ToLinearA98Rgb", function() {
                return A.NativeFloat64List_NativeFloat64List$fromList(A._setArrayType([
                    1.1519783947159163,
                    -0.0975030553024086,
                    -0.05447533941350766,
                    -0.12455047452159074,
                    1.1328998971259603,
                    -0.00834942260436947,
                    -0.0225303827810559,
                    -0.04980650742838876,
                    1.0723368902094446
                ], type$.JSArray_double));
            });
            _lazyFinal($, "linearA98RgbToXyzD65", "$get$linearA98RgbToXyzD65", function() {
                return A.NativeFloat64List_NativeFloat64List$fromList(A._setArrayType([
                    0.5766690429101308,
                    0.18555823790654627,
                    0.18822864623499472,
                    0.29734497525053616,
                    0.627363566255466,
                    0.07529145849399789,
                    0.02703136138641237,
                    0.07068885253582714,
                    0.9913375368376389
                ], type$.JSArray_double));
            });
            _lazyFinal($, "xyzD65ToLinearA98Rgb", "$get$xyzD65ToLinearA98Rgb", function() {
                return A.NativeFloat64List_NativeFloat64List$fromList(A._setArrayType([
                    2.041587903810746,
                    -0.5650069742788596,
                    -0.3447313507783295,
                    -0.9692436362808798,
                    1.8759675015077206,
                    0.04155505740717561,
                    0.01344428063203102,
                    -0.11836239223101823,
                    1.0151749943912054
                ], type$.JSArray_double));
            });
            _lazyFinal($, "linearA98RgbToLms", "$get$linearA98RgbToLms", function() {
                return A.NativeFloat64List_NativeFloat64List$fromList(A._setArrayType([
                    0.5764322596183941,
                    0.36991322261987963,
                    0.05365451776172635,
                    0.29631647054222465,
                    0.5916761332521885,
                    0.11200739620558686,
                    0.1234782510142776,
                    0.21949869837199862,
                    0.6570230506137238
                ], type$.JSArray_double));
            });
            _lazyFinal($, "lmsToLinearA98Rgb", "$get$lmsToLinearA98Rgb", function() {
                return A.NativeFloat64List_NativeFloat64List$fromList(A._setArrayType([
                    2.5540368386115566,
                    -1.6219761806828699,
                    0.06793934207131327,
                    -1.268437973285032,
                    2.609757349287689,
                    -0.3413193760026571,
                    -0.05623473593749381,
                    -0.5670418395669061,
                    1.6232765755043999
                ], type$.JSArray_double));
            });
            _lazyFinal($, "linearA98RgbToLinearProphotoRgb", "$get$linearA98RgbToLinearProphotoRgb", function() {
                return A.NativeFloat64List_NativeFloat64List$fromList(A._setArrayType([
                    0.7401175018047792,
                    0.11327951328898105,
                    0.1466029849062397,
                    0.1375504646980262,
                    0.833077080269484,
                    0.02937245503248977,
                    0.02359772990871766,
                    0.07378347703906656,
                    0.9026187930522158
                ], type$.JSArray_double));
            });
            _lazyFinal($, "linearProphotoRgbToLinearA98Rgb", "$get$linearProphotoRgbToLinearA98Rgb", function() {
                return A.NativeFloat64List_NativeFloat64List$fromList(A._setArrayType([
                    1.38965124815152,
                    -0.16945907691487766,
                    -0.22019217123664242,
                    -0.22882573163305037,
                    1.2317425411901048,
                    -0.00291680955705449,
                    -0.01762544368426068,
                    -0.09625702306122665,
                    1.1138824667454874
                ], type$.JSArray_double));
            });
            _lazyFinal($, "linearA98RgbToXyzD50", "$get$linearA98RgbToXyzD50", function() {
                return A.NativeFloat64List_NativeFloat64List$fromList(A._setArrayType([
                    0.6097750418861814,
                    0.20530000261929401,
                    0.14922063192409227,
                    0.31112461220464155,
                    0.6256532308346856,
                    0.06322215696067286,
                    0.01947059555648168,
                    0.06087908649415867,
                    0.7447549204598198
                ], type$.JSArray_double));
            });
            _lazyFinal($, "xyzD50ToLinearA98Rgb", "$get$xyzD50ToLinearA98Rgb", function() {
                return A.NativeFloat64List_NativeFloat64List$fromList(A._setArrayType([
                    1.9624670363768806,
                    -0.6107423404815073,
                    -0.3413580980827154,
                    -0.9787954765557777,
                    1.9162543773959884,
                    0.03344287339036693,
                    0.02870443944957101,
                    -0.1406748663317068,
                    1.3489141814137937
                ], type$.JSArray_double));
            });
            _lazyFinal($, "linearRec2020ToXyzD65", "$get$linearRec2020ToXyzD65", function() {
                return A.NativeFloat64List_NativeFloat64List$fromList(A._setArrayType([
                    0.6369580483012913,
                    0.14461690358620838,
                    0.16888097516417205,
                    0.26270021201126703,
                    0.677998071518871,
                    0.05930171646986194,
                    0,
                    0.0280726930490875,
                    1.0609850577107909
                ], type$.JSArray_double));
            });
            _lazyFinal($, "xyzD65ToLinearRec2020", "$get$xyzD65ToLinearRec2020", function() {
                return A.NativeFloat64List_NativeFloat64List$fromList(A._setArrayType([
                    1.7166511879712676,
                    -0.3556707837763924,
                    -0.2533662813736598,
                    -0.666684351832489,
                    1.616481236634939,
                    0.01576854581391113,
                    0.01763985744531091,
                    -0.04277061325780865,
                    0.942103121235474
                ], type$.JSArray_double));
            });
            _lazyFinal($, "linearRec2020ToLms", "$get$linearRec2020ToLms", function() {
                return A.NativeFloat64List_NativeFloat64List$fromList(A._setArrayType([
                    0.6167557848654444,
                    0.36019840122646335,
                    0.02304581390809228,
                    0.2651330593926367,
                    0.6358393720678491,
                    0.09902756853951408,
                    0.10010262952034828,
                    0.20390652261661452,
                    0.6959908478630372
                ], type$.JSArray_double));
            });
            _lazyFinal($, "lmsToLinearRec2020", "$get$lmsToLinearRec2020", function() {
                return A.NativeFloat64List_NativeFloat64List$fromList(A._setArrayType([
                    2.1399067304346513,
                    -1.246389493760618,
                    0.10648276332596668,
                    -0.8847358357577674,
                    2.1632309383612007,
                    -0.2784951026034334,
                    -0.04857374640044396,
                    -0.4545031497140964,
                    1.5030768961145404
                ], type$.JSArray_double));
            });
            _lazyFinal($, "linearRec2020ToLinearProphotoRgb", "$get$linearRec2020ToLinearProphotoRgb", function() {
                return A.NativeFloat64List_NativeFloat64List$fromList(A._setArrayType([
                    0.8351873331297235,
                    0.04886884858605698,
                    0.11594381828421951,
                    0.05403324519953363,
                    0.9289184085692044,
                    0.01704834623126199,
                    -0.00234203897072539,
                    0.03633215316169465,
                    0.9660098858090307
                ], type$.JSArray_double));
            });
            _lazyFinal($, "linearProphotoRgbToLinearRec2020", "$get$linearProphotoRgbToLinearRec2020", function() {
                return A.NativeFloat64List_NativeFloat64List$fromList(A._setArrayType([
                    1.200659329517408,
                    -0.05756805370122346,
                    -0.14309127581618444,
                    -0.06994154955888504,
                    1.080617897597214,
                    -0.01067634803832895,
                    0.00554147334294746,
                    -0.04078219298657951,
                    1.035240719643632
                ], type$.JSArray_double));
            });
            _lazyFinal($, "linearRec2020ToXyzD50", "$get$linearRec2020ToXyzD50", function() {
                return A.NativeFloat64List_NativeFloat64List$fromList(A._setArrayType([
                    0.673515463188276,
                    0.16569726370390453,
                    0.12508294953738705,
                    0.2790590051411206,
                    0.6753180057491098,
                    0.04562298910976962,
                    -0.00193242713400438,
                    0.02997782679282923,
                    0.7970592028516355
                ], type$.JSArray_double));
            });
            _lazyFinal($, "xyzD50ToLinearRec2020", "$get$xyzD50ToLinearRec2020", function() {
                return A.NativeFloat64List_NativeFloat64List$fromList(A._setArrayType([
                    1.647184904671766,
                    -0.3936818981316471,
                    -0.23595963848828266,
                    -0.6826641074173818,
                    1.6477146127444076,
                    0.01281708338512084,
                    0.02966887665275675,
                    -0.0629258964297003,
                    1.2535578201865771
                ], type$.JSArray_double));
            });
            _lazyFinal($, "xyzD65ToLms", "$get$xyzD65ToLms", function() {
                return A.NativeFloat64List_NativeFloat64List$fromList(A._setArrayType([
                    0.819022437996703,
                    0.36190626005289034,
                    -0.12887378152098788,
                    0.03298365393238846,
                    0.9292868615863433,
                    0.03614466635064235,
                    0.0481771893596242,
                    0.2642395317527308,
                    0.6335478284694308
                ], type$.JSArray_double));
            });
            _lazyFinal($, "lmsToXyzD65", "$get$lmsToXyzD65", function() {
                return A.NativeFloat64List_NativeFloat64List$fromList(A._setArrayType([
                    1.2268798758459243,
                    -0.5578149944602171,
                    0.2813910456659646,
                    -0.04057574521480084,
                    1.1122868032803173,
                    -0.07171105806551635,
                    -0.07637293667466007,
                    -0.42149333240224324,
                    1.5869240198367818
                ], type$.JSArray_double));
            });
            _lazyFinal($, "xyzD65ToLinearProphotoRgb", "$get$xyzD65ToLinearProphotoRgb", function() {
                return A.NativeFloat64List_NativeFloat64List$fromList(A._setArrayType([
                    1.4031904633774979,
                    -0.22301514479051668,
                    -0.1016066850741379,
                    -0.5262384021633072,
                    1.4816319629234644,
                    0.01701879027252688,
                    -0.0112022652862215,
                    0.01824640347962099,
                    0.9112472274915048
                ], type$.JSArray_double));
            });
            _lazyFinal($, "linearProphotoRgbToXyzD65", "$get$linearProphotoRgbToXyzD65", function() {
                return A.NativeFloat64List_NativeFloat64List$fromList(A._setArrayType([
                    0.755590742296921,
                    0.11271984265940525,
                    0.0821453420953454,
                    0.2683218435785719,
                    0.7151152566617912,
                    0.01656289975963685,
                    0.0039159727624258,
                    -0.01293344283684181,
                    1.0980752208342945
                ], type$.JSArray_double));
            });
            _lazyFinal($, "xyzD65ToXyzD50", "$get$xyzD65ToXyzD50", function() {
                return A.NativeFloat64List_NativeFloat64List$fromList(A._setArrayType([
                    1.0479297925449966,
                    0.02294687060160952,
                    -0.05019226628920519,
                    0.02962780877005567,
                    0.99043442675388,
                    -0.01707379906341879,
                    -0.00924304064620452,
                    0.01505519149029816,
                    0.751874281428137
                ], type$.JSArray_double));
            });
            _lazyFinal($, "xyzD50ToXyzD65", "$get$xyzD50ToXyzD65", function() {
                return A.NativeFloat64List_NativeFloat64List$fromList(A._setArrayType([
                    0.9554734214880752,
                    -0.02309845494876452,
                    0.06325924320057065,
                    -0.02836970933386358,
                    1.0099953980813041,
                    0.0210414411919173,
                    0.01231401486448199,
                    -0.02050764929889898,
                    1.330365926242124
                ], type$.JSArray_double));
            });
            _lazyFinal($, "lmsToLinearProphotoRgb", "$get$lmsToLinearProphotoRgb", function() {
                return A.NativeFloat64List_NativeFloat64List$fromList(A._setArrayType([
                    1.7383551481157207,
                    -0.9879509427514458,
                    0.24959579463572504,
                    -0.7070494015329266,
                    1.9343700444401382,
                    -0.2273206429072115,
                    -0.08407882206239634,
                    -0.35754060521141334,
                    1.4416194272738097
                ], type$.JSArray_double));
            });
            _lazyFinal($, "linearProphotoRgbToLms", "$get$linearProphotoRgbToLms", function() {
                return A.NativeFloat64List_NativeFloat64List$fromList(A._setArrayType([
                    0.7154484605655534,
                    0.35279155007721186,
                    -0.0682400106427653,
                    0.2744116490015671,
                    0.6677976498412367,
                    0.05779070115719616,
                    0.10978443261622942,
                    0.18619829115002018,
                    0.7040172762337504
                ], type$.JSArray_double));
            });
            _lazyFinal($, "lmsToXyzD50", "$get$lmsToXyzD50", function() {
                return A.NativeFloat64List_NativeFloat64List$fromList(A._setArrayType([
                    1.288586218172706,
                    -0.5378717444973745,
                    0.2135812027542364,
                    -0.00253387643187372,
                    1.0923167988719165,
                    -0.08978292244004273,
                    -0.06937382305734124,
                    -0.29500839894431263,
                    1.1894868245121142
                ], type$.JSArray_double));
            });
            _lazyFinal($, "xyzD50ToLms", "$get$xyzD50ToLms", function() {
                return A.NativeFloat64List_NativeFloat64List$fromList(A._setArrayType([
                    0.7707000420431172,
                    0.34924840261939616,
                    -0.11202351884164681,
                    0.00559649248368848,
                    0.9370723401136769,
                    0.06972568836252771,
                    0.04633714262191069,
                    0.25277531574310524,
                    0.851458076746796
                ], type$.JSArray_double));
            });
            _lazyFinal($, "linearProphotoRgbToXyzD50", "$get$linearProphotoRgbToXyzD50", function() {
                return A.NativeFloat64List_NativeFloat64List$fromList(A._setArrayType([
                    0.7977666449006423,
                    0.13518129740053308,
                    0.0313477341283922,
                    0.2880748288194013,
                    0.711835234241873,
                    0.00008993693872564,
                    0,
                    0,
                    0.8251046025104602
                ], type$.JSArray_double));
            });
            _lazyFinal($, "xyzD50ToLinearProphotoRgb", "$get$xyzD50ToLinearProphotoRgb", function() {
                return A.NativeFloat64List_NativeFloat64List$fromList(A._setArrayType([
                    1.3457868816471583,
                    -0.25557208737979464,
                    -0.05110186497554526,
                    -0.5446307051249019,
                    1.5082477428451468,
                    0.02052744743642139,
                    0,
                    0,
                    1.2119675456389452
                ], type$.JSArray_double));
            });
            _lazyFinal($, "_typesByUnit", "$get$_typesByUnit", function() {
                var t3, type, t1 = type$.String, t2 = A.LinkedHashMap_LinkedHashMap$_empty(t1, t1);
                for(t1 = A.MapExtensions_get_pairs(B.Map_Sr65K, t1, type$.List_String), t1 = t1.get$iterator(t1); t1.moveNext$0();){
                    t3 = t1.get$current(t1);
                    type = t3._0;
                    for(t3 = J.get$iterator$ax(t3._1); t3.moveNext$0();)t2.$indexSet(0, t3.get$current(t3), type);
                }
                return t2;
            });
            _lazyFinal($, "_knownCompatibilitiesByUnit", "$get$_knownCompatibilitiesByUnit", function() {
                var _i, set, t2, t1 = A.LinkedHashMap_LinkedHashMap$_empty(type$.String, A.findType("Set<String>"));
                for(_i = 0; _i < 5; ++_i){
                    set = B.List_BFg[_i];
                    for(t2 = set.get$iterator(set); t2.moveNext$0();)t1.$indexSet(0, t2.get$current(0), set);
                }
                return t1;
            });
            _lazyFinal($, "_emptyQuoted", "$get$_emptyQuoted", function() {
                return A.SassString$("", true);
            });
            _lazyFinal($, "_emptyUnquoted", "$get$_emptyUnquoted", function() {
                return A.SassString$("", false);
            });
            _lazyFinal($, "maxInt32", "$get$maxInt32", function() {
                return A._asInt(A.pow(2, 31)) - 1;
            });
            _lazyFinal($, "minInt32", "$get$minInt32", function() {
                return -A._asInt(A.pow(2, 31));
            });
            _lazyFinal($, "_vmFrame", "$get$_vmFrame", function() {
                return A.RegExp_RegExp("^#\\d+\\s+(\\S.*) \\((.+?)((?::\\d+){0,2})\\)$", false);
            });
            _lazyFinal($, "_v8JsFrame", "$get$_v8JsFrame", function() {
                return A.RegExp_RegExp("^\\s*at (?:(\\S.*?)(?: \\[as [^\\]]+\\])? \\((.*)\\)|(.*))$", false);
            });
            _lazyFinal($, "_v8JsUrlLocation", "$get$_v8JsUrlLocation", function() {
                return A.RegExp_RegExp("^(.*?):(\\d+)(?::(\\d+))?$|native$", false);
            });
            _lazyFinal($, "_v8WasmFrame", "$get$_v8WasmFrame", function() {
                return A.RegExp_RegExp("^\\s*at (?:(?<member>.+) )?(?:\\(?(?:(?<uri>\\S+):wasm-function\\[(?<index>\\d+)\\]\\:0x(?<offset>[0-9a-fA-F]+))\\)?)$", false);
            });
            _lazyFinal($, "_v8EvalLocation", "$get$_v8EvalLocation", function() {
                return A.RegExp_RegExp("^eval at (?:\\S.*?) \\((.*)\\)(?:, .*?:\\d+:\\d+)?$", false);
            });
            _lazyFinal($, "_firefoxEvalLocation", "$get$_firefoxEvalLocation", function() {
                return A.RegExp_RegExp("(\\S+)@(\\S+) line (\\d+) >.* (Function|eval):\\d+:\\d+", false);
            });
            _lazyFinal($, "_firefoxSafariJSFrame", "$get$_firefoxSafariJSFrame", function() {
                return A.RegExp_RegExp("^(?:([^@(/]*)(?:\\(.*\\))?((?:/[^/]*)*)(?:\\(.*\\))?@)?(.*?):(\\d*)(?::(\\d*))?$", false);
            });
            _lazyFinal($, "_firefoxWasmFrame", "$get$_firefoxWasmFrame", function() {
                return A.RegExp_RegExp("^(?<member>.*?)@(?:(?<uri>\\S+).*?:wasm-function\\[(?<index>\\d+)\\]:0x(?<offset>[0-9a-fA-F]+))$", false);
            });
            _lazyFinal($, "_safariWasmFrame", "$get$_safariWasmFrame", function() {
                return A.RegExp_RegExp("^.*?wasm-function\\[(?<member>.*)\\]@\\[wasm code\\]$", false);
            });
            _lazyFinal($, "_friendlyFrame", "$get$_friendlyFrame", function() {
                return A.RegExp_RegExp("^(\\S+)(?: (\\d+)(?::(\\d+))?)?\\s+([^\\d].*)$", false);
            });
            _lazyFinal($, "_asyncBody", "$get$_asyncBody", function() {
                return A.RegExp_RegExp("<(<anonymous closure>|[^>]+)_async_body>", false);
            });
            _lazyFinal($, "_initialDot", "$get$_initialDot", function() {
                return A.RegExp_RegExp("^\\.", false);
            });
            _lazyFinal($, "Frame__uriRegExp", "$get$Frame__uriRegExp", function() {
                return A.RegExp_RegExp("^[a-zA-Z][-+.a-zA-Z\\d]*://", false);
            });
            _lazyFinal($, "Frame__windowsRegExp", "$get$Frame__windowsRegExp", function() {
                return A.RegExp_RegExp("^([a-zA-Z]:[\\\\/]|\\\\\\\\)", false);
            });
            _lazyFinal($, "_terseRegExp", "$get$_terseRegExp", function() {
                return A.RegExp_RegExp("(-patch)?([/\\\\].*)?$", false);
            });
            _lazyFinal($, "_v8Trace", "$get$_v8Trace", function() {
                return A.RegExp_RegExp("\\n    ?at ", false);
            });
            _lazyFinal($, "_v8TraceLine", "$get$_v8TraceLine", function() {
                return A.RegExp_RegExp("    ?at ", false);
            });
            _lazyFinal($, "_firefoxEvalTrace", "$get$_firefoxEvalTrace", function() {
                return A.RegExp_RegExp("@\\S+ line \\d+ >.* (Function|eval):\\d+:\\d+", false);
            });
            _lazyFinal($, "_firefoxSafariTrace", "$get$_firefoxSafariTrace", function() {
                return A.RegExp_RegExp("^(([.0-9A-Za-z_$/<]|\\(.*\\))*@)?[^\\s]*:\\d*$", true);
            });
            _lazyFinal($, "_friendlyTrace", "$get$_friendlyTrace", function() {
                return A.RegExp_RegExp("^[^\\s<][^\\s]*( \\d+(:\\d+)?)?[ \\t]+[^\\s]+$", true);
            });
            _lazyFinal($, "vmChainGap", "$get$vmChainGap", function() {
                return A.RegExp_RegExp("^<asynchronous suspension>\\n?$", true);
            });
            _lazyFinal($, "_newlineRegExp", "$get$_newlineRegExp", function() {
                return A.RegExp_RegExp("\\n|\\r\\n|\\r(?!\\n)", false);
            });
            _lazyFinal($, "argumentListClass", "$get$argumentListClass", function() {
                return new A.argumentListClass_closure().call$0();
            });
            _lazyFinal($, "booleanClass", "$get$booleanClass", function() {
                return new A.booleanClass_closure().call$0();
            });
            _lazyFinal($, "legacyBooleanClass", "$get$legacyBooleanClass", function() {
                return new A.legacyBooleanClass_closure().call$0();
            });
            _lazyFinal($, "calculationClass", "$get$calculationClass", function() {
                return new A.calculationClass_closure().call$0();
            });
            _lazyFinal($, "calculationOperationClass", "$get$calculationOperationClass", function() {
                return new A.calculationOperationClass_closure().call$0();
            });
            _lazyFinal($, "calculationInterpolationClass", "$get$calculationInterpolationClass", function() {
                return new A.calculationInterpolationClass_closure().call$0();
            });
            _lazyFinal($, "_microsoftFilterStart0", "$get$_microsoftFilterStart0", function() {
                return A.RegExp_RegExp("^[a-zA-Z]+\\s*=", false);
            });
            _lazyFinal($, "global6", "$get$global6", function() {
                var _s5_ = "color", _s27_ = "$red, $green, $blue, $alpha", _s19_ = "$red, $green, $blue", _s9_ = "$channels", _s37_ = "$hue, $saturation, $lightness, $alpha", _s29_ = "$hue, $saturation, $lightness", _s17_ = "$hue, $saturation", _s6_ = "adjust", _s15_ = "$color, $amount", t1 = type$.String, t2 = type$.Value_Function_List_Value_2;
                return A.UnmodifiableListView$(A._setArrayType([
                    A._channelFunction0("red", B.RgbColorSpace_i0P0, new A.global_closure44(), true, null).withDeprecationWarning$1(_s5_),
                    A._channelFunction0("green", B.RgbColorSpace_i0P0, new A.global_closure45(), true, null).withDeprecationWarning$1(_s5_),
                    A._channelFunction0("blue", B.RgbColorSpace_i0P0, new A.global_closure46(), true, null).withDeprecationWarning$1(_s5_),
                    $.$get$_mix0().withDeprecationWarning$1(_s5_),
                    A.BuiltInCallable$overloadedFunction0("rgb", A.LinkedHashMap_LinkedHashMap$_literal([
                        _s27_,
                        new A.global_closure47(),
                        _s19_,
                        new A.global_closure48(),
                        "$color, $alpha",
                        new A.global_closure49(),
                        "$channels",
                        new A.global_closure50()
                    ], t1, t2)),
                    A.BuiltInCallable$overloadedFunction0("rgba", A.LinkedHashMap_LinkedHashMap$_literal([
                        _s27_,
                        new A.global_closure51(),
                        _s19_,
                        new A.global_closure52(),
                        "$color, $alpha",
                        new A.global_closure53(),
                        "$channels",
                        new A.global_closure54()
                    ], t1, t2)),
                    A._function12("invert", "$color, $weight: 100%, $space: null", new A.global_closure55()),
                    A._channelFunction0("hue", B.HslColorSpace_JQ20, new A.global_closure56(), true, "deg").withDeprecationWarning$1(_s5_),
                    A._channelFunction0("saturation", B.HslColorSpace_JQ20, new A.global_closure57(), true, "%").withDeprecationWarning$1(_s5_),
                    A._channelFunction0("lightness", B.HslColorSpace_JQ20, new A.global_closure58(), true, "%").withDeprecationWarning$1(_s5_),
                    A.BuiltInCallable$overloadedFunction0("hsl", A.LinkedHashMap_LinkedHashMap$_literal([
                        _s37_,
                        new A.global_closure59(),
                        _s29_,
                        new A.global_closure60(),
                        _s17_,
                        new A.global_closure61(),
                        "$channels",
                        new A.global_closure62()
                    ], t1, t2)),
                    A.BuiltInCallable$overloadedFunction0("hsla", A.LinkedHashMap_LinkedHashMap$_literal([
                        _s37_,
                        new A.global_closure63(),
                        _s29_,
                        new A.global_closure64(),
                        _s17_,
                        new A.global_closure65(),
                        "$channels",
                        new A.global_closure66()
                    ], t1, t2)),
                    A._function12("grayscale", "$color", new A.global_closure67()),
                    A._function12("adjust-hue", "$color, $degrees", new A.global_closure68()).withDeprecationWarning$2(_s5_, _s6_),
                    A._function12("lighten", _s15_, new A.global_closure69()).withDeprecationWarning$2(_s5_, _s6_),
                    A._function12("darken", _s15_, new A.global_closure70()).withDeprecationWarning$2(_s5_, _s6_),
                    A.BuiltInCallable$overloadedFunction0("saturate", A.LinkedHashMap_LinkedHashMap$_literal([
                        "$amount",
                        new A.global_closure71(),
                        "$color, $amount",
                        new A.global_closure72()
                    ], t1, t2)),
                    A._function12("desaturate", _s15_, new A.global_closure73()).withDeprecationWarning$2(_s5_, _s6_),
                    A._function12("opacify", _s15_, new A.global_closure74()).withDeprecationWarning$2(_s5_, _s6_),
                    A._function12("fade-in", _s15_, new A.global_closure75()).withDeprecationWarning$2(_s5_, _s6_),
                    A._function12("transparentize", _s15_, new A.global_closure76()).withDeprecationWarning$2(_s5_, _s6_),
                    A._function12("fade-out", _s15_, new A.global_closure77()).withDeprecationWarning$2(_s5_, _s6_),
                    A.BuiltInCallable$overloadedFunction0("alpha", A.LinkedHashMap_LinkedHashMap$_literal([
                        "$color",
                        new A.global_closure78(),
                        "$args...",
                        new A.global_closure79()
                    ], t1, t2)),
                    A._function12("opacity", "$color", new A.global_closure80()),
                    A._function12(_s5_, "$description", new A.global_closure81()),
                    A._function12("hwb", _s9_, new A.global_closure82()),
                    A._function12("lab", _s9_, new A.global_closure83()),
                    A._function12("lch", _s9_, new A.global_closure84()),
                    A._function12("oklab", _s9_, new A.global_closure85()),
                    A._function12("oklch", _s9_, new A.global_closure86()),
                    $.$get$_complement0().withDeprecationWarning$1(_s5_),
                    $.$get$_ieHexStr0(),
                    $.$get$_adjust0().withDeprecationWarning$1(_s5_).withName$1("adjust-color"),
                    $.$get$_scale0().withDeprecationWarning$1(_s5_).withName$1("scale-color"),
                    $.$get$_change0().withDeprecationWarning$1(_s5_).withName$1("change-color")
                ], type$.JSArray_BuiltInCallable_2), type$.BuiltInCallable_2);
            });
            _lazyFinal($, "module5", "$get$module5", function() {
                var _null = null, _s10_ = "saturation", _s9_ = "lightness", _s6_ = "$color", _s5_ = "alpha", _s30_ = "$color, $channel, $space: null", t1 = type$.String, t2 = type$.Value_Function_List_Value_2;
                return A.BuiltInModule$0("color", A._setArrayType([
                    A._channelFunction0("red", B.RgbColorSpace_i0P0, new A.module_closure27(), false, _null),
                    A._channelFunction0("green", B.RgbColorSpace_i0P0, new A.module_closure28(), false, _null),
                    A._channelFunction0("blue", B.RgbColorSpace_i0P0, new A.module_closure29(), false, _null),
                    $.$get$_mix0(),
                    A._function12("invert", "$color, $weight: 100%, $space: null", new A.module_closure30()),
                    A._channelFunction0("hue", B.HslColorSpace_JQ20, new A.module_closure31(), false, "deg"),
                    A._channelFunction0(_s10_, B.HslColorSpace_JQ20, new A.module_closure32(), false, "%"),
                    A._channelFunction0(_s9_, B.HslColorSpace_JQ20, new A.module_closure33(), false, "%"),
                    A._removedColorFunction0("adjust-hue", "hue", false),
                    A._removedColorFunction0("lighten", _s9_, false),
                    A._removedColorFunction0("darken", _s9_, true),
                    A._removedColorFunction0("saturate", _s10_, false),
                    A._removedColorFunction0("desaturate", _s10_, true),
                    A._function12("grayscale", _s6_, new A.module_closure34()),
                    A.BuiltInCallable$overloadedFunction0("hwb", A.LinkedHashMap_LinkedHashMap$_literal([
                        "$hue, $whiteness, $blackness, $alpha: 1",
                        new A.module_closure35(),
                        "$channels",
                        new A.module_closure36()
                    ], t1, t2)),
                    A._channelFunction0("whiteness", B.HwbColorSpace_guQ0, new A.module_closure37(), false, "%"),
                    A._channelFunction0("blackness", B.HwbColorSpace_guQ0, new A.module_closure38(), false, "%"),
                    A._removedColorFunction0("opacify", _s5_, false),
                    A._removedColorFunction0("fade-in", _s5_, false),
                    A._removedColorFunction0("transparentize", _s5_, true),
                    A._removedColorFunction0("fade-out", _s5_, true),
                    A.BuiltInCallable$overloadedFunction0(_s5_, A.LinkedHashMap_LinkedHashMap$_literal([
                        "$color",
                        new A.module_closure39(),
                        "$args...",
                        new A.module_closure40()
                    ], t1, t2)),
                    A._function12("opacity", _s6_, new A.module_closure41()),
                    A._function12("space", _s6_, new A.module_closure42()),
                    A._function12("to-space", "$color, $space", new A.module_closure43()),
                    A._function12("is-legacy", _s6_, new A.module_closure44()),
                    A._function12("is-missing", "$color, $channel", new A.module_closure45()),
                    A._function12("is-in-gamut", "$color, $space: null", new A.module_closure46()),
                    A._function12("to-gamut", "$color, $space: null, $method: null", new A.module_closure47()),
                    A._function12("channel", _s30_, new A.module_closure48()),
                    A._function12("same", "$color1, $color2", new A.module_closure49()),
                    A._function12("is-powerless", _s30_, new A.module_closure50()),
                    $.$get$_complement0(),
                    $.$get$_adjust0(),
                    $.$get$_scale0(),
                    $.$get$_change0(),
                    $.$get$_ieHexStr0()
                ], type$.JSArray_Callable_2), _null, _null, type$.Callable_2);
            });
            _lazyFinal($, "_mix0", "$get$_mix0", function() {
                return A._function12("mix", string$.x24color, new A._mix_closure0());
            });
            _lazyFinal($, "_complement0", "$get$_complement0", function() {
                return A._function12("complement", "$color, $space: null", new A._complement_closure0());
            });
            _lazyFinal($, "_adjust0", "$get$_adjust0", function() {
                return A._function12("adjust", "$color, $kwargs...", new A._adjust_closure0());
            });
            _lazyFinal($, "_scale0", "$get$_scale0", function() {
                return A._function12("scale", "$color, $kwargs...", new A._scale_closure0());
            });
            _lazyFinal($, "_change0", "$get$_change0", function() {
                return A._function12("change", "$color, $kwargs...", new A._change_closure0());
            });
            _lazyFinal($, "_ieHexStr0", "$get$_ieHexStr0", function() {
                return A._function12("ie-hex-str", "$color", new A._ieHexStr_closure0());
            });
            _lazyFinal($, "colorClass", "$get$colorClass", function() {
                return new A.colorClass_closure().call$0();
            });
            _lazyFinal($, "legacyColorClass", "$get$legacyColorClass", function() {
                var t1 = A.createJSClass("sass.types.Color", new A.legacyColorClass_closure());
                A.JSClassExtension_defineMethods(t1, A.LinkedHashMap_LinkedHashMap$_literal([
                    "getR",
                    new A.legacyColorClass_closure0(),
                    "getG",
                    new A.legacyColorClass_closure1(),
                    "getB",
                    new A.legacyColorClass_closure2(),
                    "getA",
                    new A.legacyColorClass_closure3(),
                    "setR",
                    new A.legacyColorClass_closure4(),
                    "setG",
                    new A.legacyColorClass_closure5(),
                    "setB",
                    new A.legacyColorClass_closure6(),
                    "setA",
                    new A.legacyColorClass_closure7()
                ], type$.String, type$.Function));
                return t1;
            });
            _lazyFinal($, "colorsByName0", "$get$colorsByName0", function() {
                return A.LinkedHashMap_LinkedHashMap$_literal([
                    "yellowgreen",
                    A.SassColor_SassColor$rgb0(154, 205, 50, 1),
                    "yellow",
                    A.SassColor_SassColor$rgb0(255, 255, 0, 1),
                    "whitesmoke",
                    A.SassColor_SassColor$rgb0(245, 245, 245, 1),
                    "white",
                    A.SassColor_SassColor$rgb0(255, 255, 255, 1),
                    "wheat",
                    A.SassColor_SassColor$rgb0(245, 222, 179, 1),
                    "violet",
                    A.SassColor_SassColor$rgb0(238, 130, 238, 1),
                    "turquoise",
                    A.SassColor_SassColor$rgb0(64, 224, 208, 1),
                    "transparent",
                    A.SassColor_SassColor$rgb0(0, 0, 0, 0),
                    "tomato",
                    A.SassColor_SassColor$rgb0(255, 99, 71, 1),
                    "thistle",
                    A.SassColor_SassColor$rgb0(216, 191, 216, 1),
                    "teal",
                    A.SassColor_SassColor$rgb0(0, 128, 128, 1),
                    "tan",
                    A.SassColor_SassColor$rgb0(210, 180, 140, 1),
                    "steelblue",
                    A.SassColor_SassColor$rgb0(70, 130, 180, 1),
                    "springgreen",
                    A.SassColor_SassColor$rgb0(0, 255, 127, 1),
                    "snow",
                    A.SassColor_SassColor$rgb0(255, 250, 250, 1),
                    "slategrey",
                    A.SassColor_SassColor$rgb0(112, 128, 144, 1),
                    "slategray",
                    A.SassColor_SassColor$rgb0(112, 128, 144, 1),
                    "slateblue",
                    A.SassColor_SassColor$rgb0(106, 90, 205, 1),
                    "skyblue",
                    A.SassColor_SassColor$rgb0(135, 206, 235, 1),
                    "silver",
                    A.SassColor_SassColor$rgb0(192, 192, 192, 1),
                    "sienna",
                    A.SassColor_SassColor$rgb0(160, 82, 45, 1),
                    "seashell",
                    A.SassColor_SassColor$rgb0(255, 245, 238, 1),
                    "seagreen",
                    A.SassColor_SassColor$rgb0(46, 139, 87, 1),
                    "sandybrown",
                    A.SassColor_SassColor$rgb0(244, 164, 96, 1),
                    "salmon",
                    A.SassColor_SassColor$rgb0(250, 128, 114, 1),
                    "saddlebrown",
                    A.SassColor_SassColor$rgb0(139, 69, 19, 1),
                    "royalblue",
                    A.SassColor_SassColor$rgb0(65, 105, 225, 1),
                    "rosybrown",
                    A.SassColor_SassColor$rgb0(188, 143, 143, 1),
                    "red",
                    A.SassColor_SassColor$rgb0(255, 0, 0, 1),
                    "rebeccapurple",
                    A.SassColor_SassColor$rgb0(102, 51, 153, 1),
                    "purple",
                    A.SassColor_SassColor$rgb0(128, 0, 128, 1),
                    "powderblue",
                    A.SassColor_SassColor$rgb0(176, 224, 230, 1),
                    "plum",
                    A.SassColor_SassColor$rgb0(221, 160, 221, 1),
                    "pink",
                    A.SassColor_SassColor$rgb0(255, 192, 203, 1),
                    "peru",
                    A.SassColor_SassColor$rgb0(205, 133, 63, 1),
                    "peachpuff",
                    A.SassColor_SassColor$rgb0(255, 218, 185, 1),
                    "papayawhip",
                    A.SassColor_SassColor$rgb0(255, 239, 213, 1),
                    "palevioletred",
                    A.SassColor_SassColor$rgb0(219, 112, 147, 1),
                    "paleturquoise",
                    A.SassColor_SassColor$rgb0(175, 238, 238, 1),
                    "palegreen",
                    A.SassColor_SassColor$rgb0(152, 251, 152, 1),
                    "palegoldenrod",
                    A.SassColor_SassColor$rgb0(238, 232, 170, 1),
                    "orchid",
                    A.SassColor_SassColor$rgb0(218, 112, 214, 1),
                    "orangered",
                    A.SassColor_SassColor$rgb0(255, 69, 0, 1),
                    "orange",
                    A.SassColor_SassColor$rgb0(255, 165, 0, 1),
                    "olivedrab",
                    A.SassColor_SassColor$rgb0(107, 142, 35, 1),
                    "olive",
                    A.SassColor_SassColor$rgb0(128, 128, 0, 1),
                    "oldlace",
                    A.SassColor_SassColor$rgb0(253, 245, 230, 1),
                    "navy",
                    A.SassColor_SassColor$rgb0(0, 0, 128, 1),
                    "navajowhite",
                    A.SassColor_SassColor$rgb0(255, 222, 173, 1),
                    "moccasin",
                    A.SassColor_SassColor$rgb0(255, 228, 181, 1),
                    "mistyrose",
                    A.SassColor_SassColor$rgb0(255, 228, 225, 1),
                    "mintcream",
                    A.SassColor_SassColor$rgb0(245, 255, 250, 1),
                    "midnightblue",
                    A.SassColor_SassColor$rgb0(25, 25, 112, 1),
                    "mediumvioletred",
                    A.SassColor_SassColor$rgb0(199, 21, 133, 1),
                    "mediumturquoise",
                    A.SassColor_SassColor$rgb0(72, 209, 204, 1),
                    "mediumspringgreen",
                    A.SassColor_SassColor$rgb0(0, 250, 154, 1),
                    "mediumslateblue",
                    A.SassColor_SassColor$rgb0(123, 104, 238, 1),
                    "mediumseagreen",
                    A.SassColor_SassColor$rgb0(60, 179, 113, 1),
                    "mediumpurple",
                    A.SassColor_SassColor$rgb0(147, 112, 219, 1),
                    "mediumorchid",
                    A.SassColor_SassColor$rgb0(186, 85, 211, 1),
                    "mediumblue",
                    A.SassColor_SassColor$rgb0(0, 0, 205, 1),
                    "mediumaquamarine",
                    A.SassColor_SassColor$rgb0(102, 205, 170, 1),
                    "maroon",
                    A.SassColor_SassColor$rgb0(128, 0, 0, 1),
                    "magenta",
                    A.SassColor_SassColor$rgb0(255, 0, 255, 1),
                    "linen",
                    A.SassColor_SassColor$rgb0(250, 240, 230, 1),
                    "limegreen",
                    A.SassColor_SassColor$rgb0(50, 205, 50, 1),
                    "lime",
                    A.SassColor_SassColor$rgb0(0, 255, 0, 1),
                    "lightyellow",
                    A.SassColor_SassColor$rgb0(255, 255, 224, 1),
                    "lightsteelblue",
                    A.SassColor_SassColor$rgb0(176, 196, 222, 1),
                    "lightslategrey",
                    A.SassColor_SassColor$rgb0(119, 136, 153, 1),
                    "lightslategray",
                    A.SassColor_SassColor$rgb0(119, 136, 153, 1),
                    "lightskyblue",
                    A.SassColor_SassColor$rgb0(135, 206, 250, 1),
                    "lightseagreen",
                    A.SassColor_SassColor$rgb0(32, 178, 170, 1),
                    "lightsalmon",
                    A.SassColor_SassColor$rgb0(255, 160, 122, 1),
                    "lightpink",
                    A.SassColor_SassColor$rgb0(255, 182, 193, 1),
                    "lightgrey",
                    A.SassColor_SassColor$rgb0(211, 211, 211, 1),
                    "lightgreen",
                    A.SassColor_SassColor$rgb0(144, 238, 144, 1),
                    "lightgray",
                    A.SassColor_SassColor$rgb0(211, 211, 211, 1),
                    "lightgoldenrodyellow",
                    A.SassColor_SassColor$rgb0(250, 250, 210, 1),
                    "lightcyan",
                    A.SassColor_SassColor$rgb0(224, 255, 255, 1),
                    "lightcoral",
                    A.SassColor_SassColor$rgb0(240, 128, 128, 1),
                    "lightblue",
                    A.SassColor_SassColor$rgb0(173, 216, 230, 1),
                    "lemonchiffon",
                    A.SassColor_SassColor$rgb0(255, 250, 205, 1),
                    "lawngreen",
                    A.SassColor_SassColor$rgb0(124, 252, 0, 1),
                    "lavenderblush",
                    A.SassColor_SassColor$rgb0(255, 240, 245, 1),
                    "lavender",
                    A.SassColor_SassColor$rgb0(230, 230, 250, 1),
                    "khaki",
                    A.SassColor_SassColor$rgb0(240, 230, 140, 1),
                    "ivory",
                    A.SassColor_SassColor$rgb0(255, 255, 240, 1),
                    "indigo",
                    A.SassColor_SassColor$rgb0(75, 0, 130, 1),
                    "indianred",
                    A.SassColor_SassColor$rgb0(205, 92, 92, 1),
                    "hotpink",
                    A.SassColor_SassColor$rgb0(255, 105, 180, 1),
                    "honeydew",
                    A.SassColor_SassColor$rgb0(240, 255, 240, 1),
                    "grey",
                    A.SassColor_SassColor$rgb0(128, 128, 128, 1),
                    "greenyellow",
                    A.SassColor_SassColor$rgb0(173, 255, 47, 1),
                    "green",
                    A.SassColor_SassColor$rgb0(0, 128, 0, 1),
                    "gray",
                    A.SassColor_SassColor$rgb0(128, 128, 128, 1),
                    "goldenrod",
                    A.SassColor_SassColor$rgb0(218, 165, 32, 1),
                    "gold",
                    A.SassColor_SassColor$rgb0(255, 215, 0, 1),
                    "ghostwhite",
                    A.SassColor_SassColor$rgb0(248, 248, 255, 1),
                    "gainsboro",
                    A.SassColor_SassColor$rgb0(220, 220, 220, 1),
                    "fuchsia",
                    A.SassColor_SassColor$rgb0(255, 0, 255, 1),
                    "forestgreen",
                    A.SassColor_SassColor$rgb0(34, 139, 34, 1),
                    "floralwhite",
                    A.SassColor_SassColor$rgb0(255, 250, 240, 1),
                    "firebrick",
                    A.SassColor_SassColor$rgb0(178, 34, 34, 1),
                    "dodgerblue",
                    A.SassColor_SassColor$rgb0(30, 144, 255, 1),
                    "dimgrey",
                    A.SassColor_SassColor$rgb0(105, 105, 105, 1),
                    "dimgray",
                    A.SassColor_SassColor$rgb0(105, 105, 105, 1),
                    "deepskyblue",
                    A.SassColor_SassColor$rgb0(0, 191, 255, 1),
                    "deeppink",
                    A.SassColor_SassColor$rgb0(255, 20, 147, 1),
                    "darkviolet",
                    A.SassColor_SassColor$rgb0(148, 0, 211, 1),
                    "darkturquoise",
                    A.SassColor_SassColor$rgb0(0, 206, 209, 1),
                    "darkslategrey",
                    A.SassColor_SassColor$rgb0(47, 79, 79, 1),
                    "darkslategray",
                    A.SassColor_SassColor$rgb0(47, 79, 79, 1),
                    "darkslateblue",
                    A.SassColor_SassColor$rgb0(72, 61, 139, 1),
                    "darkseagreen",
                    A.SassColor_SassColor$rgb0(143, 188, 143, 1),
                    "darksalmon",
                    A.SassColor_SassColor$rgb0(233, 150, 122, 1),
                    "darkred",
                    A.SassColor_SassColor$rgb0(139, 0, 0, 1),
                    "darkorchid",
                    A.SassColor_SassColor$rgb0(153, 50, 204, 1),
                    "darkorange",
                    A.SassColor_SassColor$rgb0(255, 140, 0, 1),
                    "darkolivegreen",
                    A.SassColor_SassColor$rgb0(85, 107, 47, 1),
                    "darkmagenta",
                    A.SassColor_SassColor$rgb0(139, 0, 139, 1),
                    "darkkhaki",
                    A.SassColor_SassColor$rgb0(189, 183, 107, 1),
                    "darkgrey",
                    A.SassColor_SassColor$rgb0(169, 169, 169, 1),
                    "darkgreen",
                    A.SassColor_SassColor$rgb0(0, 100, 0, 1),
                    "darkgray",
                    A.SassColor_SassColor$rgb0(169, 169, 169, 1),
                    "darkgoldenrod",
                    A.SassColor_SassColor$rgb0(184, 134, 11, 1),
                    "darkcyan",
                    A.SassColor_SassColor$rgb0(0, 139, 139, 1),
                    "darkblue",
                    A.SassColor_SassColor$rgb0(0, 0, 139, 1),
                    "cyan",
                    A.SassColor_SassColor$rgb0(0, 255, 255, 1),
                    "crimson",
                    A.SassColor_SassColor$rgb0(220, 20, 60, 1),
                    "cornsilk",
                    A.SassColor_SassColor$rgb0(255, 248, 220, 1),
                    "cornflowerblue",
                    A.SassColor_SassColor$rgb0(100, 149, 237, 1),
                    "coral",
                    A.SassColor_SassColor$rgb0(255, 127, 80, 1),
                    "chocolate",
                    A.SassColor_SassColor$rgb0(210, 105, 30, 1),
                    "chartreuse",
                    A.SassColor_SassColor$rgb0(127, 255, 0, 1),
                    "cadetblue",
                    A.SassColor_SassColor$rgb0(95, 158, 160, 1),
                    "burlywood",
                    A.SassColor_SassColor$rgb0(222, 184, 135, 1),
                    "brown",
                    A.SassColor_SassColor$rgb0(165, 42, 42, 1),
                    "blueviolet",
                    A.SassColor_SassColor$rgb0(138, 43, 226, 1),
                    "blue",
                    A.SassColor_SassColor$rgb0(0, 0, 255, 1),
                    "blanchedalmond",
                    A.SassColor_SassColor$rgb0(255, 235, 205, 1),
                    "black",
                    A.SassColor_SassColor$rgb0(0, 0, 0, 1),
                    "bisque",
                    A.SassColor_SassColor$rgb0(255, 228, 196, 1),
                    "beige",
                    A.SassColor_SassColor$rgb0(245, 245, 220, 1),
                    "azure",
                    A.SassColor_SassColor$rgb0(240, 255, 255, 1),
                    "aquamarine",
                    A.SassColor_SassColor$rgb0(127, 255, 212, 1),
                    "aqua",
                    A.SassColor_SassColor$rgb0(0, 255, 255, 1),
                    "antiquewhite",
                    A.SassColor_SassColor$rgb0(250, 235, 215, 1),
                    "aliceblue",
                    A.SassColor_SassColor$rgb0(240, 248, 255, 1)
                ], type$.String, type$.SassColor_2);
            });
            _lazyFinal($, "namesByColor0", "$get$namesByColor0", function() {
                var $name, t1 = type$.SassColor_2, t2 = type$.String, t3 = A.LinkedHashMap_LinkedHashMap$_empty(t1, t2);
                for(t1 = A.MapExtensions_get_pairs0($.$get$colorsByName0(), t2, t1), t1 = t1.get$iterator(t1); t1.moveNext$0();){
                    t2 = t1.get$current(t1);
                    $name = t2._0;
                    t3.$indexSet(0, t2._1, $name);
                }
                return t3;
            });
            _lazyFinal($, "nodePackageImporterClass", "$get$nodePackageImporterClass", function() {
                return new A.nodePackageImporterClass_closure().call$0();
            });
            _lazyFinal($, "compilerClass", "$get$compilerClass", function() {
                return new A.compilerClass_closure().call$0();
            });
            _lazyFinal($, "asyncCompilerClass", "$get$asyncCompilerClass", function() {
                return new A.asyncCompilerClass_closure().call$0();
            });
            _lazyFinal($, "lmsToOklab0", "$get$lmsToOklab0", function() {
                return A.NativeFloat64List_NativeFloat64List$fromList(A._setArrayType([
                    0.210454268309314,
                    0.7936177747023054,
                    -0.0040720430116193,
                    1.9779985324311684,
                    -2.42859224204858,
                    0.450593709617411,
                    0.0259040424655478,
                    0.7827717124575296,
                    -0.8086757549230774
                ], type$.JSArray_double));
            });
            _lazyFinal($, "oklabToLms0", "$get$oklabToLms0", function() {
                return A.NativeFloat64List_NativeFloat64List$fromList(A._setArrayType([
                    1.0000000000000002,
                    0.3963377773761749,
                    0.2158037573099136,
                    0.9999999999999998,
                    -0.10556134581565854,
                    -0.06385417282581334,
                    0.9999999999999999,
                    -0.0894841775298118,
                    -1.2914855480194094
                ], type$.JSArray_double));
            });
            _lazyFinal($, "linearSrgbToLinearDisplayP30", "$get$linearSrgbToLinearDisplayP30", function() {
                return A.NativeFloat64List_NativeFloat64List$fromList(A._setArrayType([
                    0.8224619687143623,
                    0.17753803128563775,
                    0,
                    0.03319419885096161,
                    0.9668058011490384,
                    0,
                    0.01708263072112003,
                    0.07239744066396346,
                    0.9105199286149165
                ], type$.JSArray_double));
            });
            _lazyFinal($, "linearDisplayP3ToLinearSrgb0", "$get$linearDisplayP3ToLinearSrgb0", function() {
                return A.NativeFloat64List_NativeFloat64List$fromList(A._setArrayType([
                    1.2249401762805598,
                    -0.22494017628055996,
                    0,
                    -0.04205695470968816,
                    1.042056954709688,
                    0,
                    -0.01963755459033443,
                    -0.07863604555063188,
                    1.0982736001409663
                ], type$.JSArray_double));
            });
            _lazyFinal($, "linearSrgbToLinearA98Rgb0", "$get$linearSrgbToLinearA98Rgb0", function() {
                return A.NativeFloat64List_NativeFloat64List$fromList(A._setArrayType([
                    0.7151256068556247,
                    0.28487439314437535,
                    0,
                    0,
                    1,
                    0,
                    0,
                    0.04116194845011846,
                    0.9588380515498816
                ], type$.JSArray_double));
            });
            _lazyFinal($, "linearA98RgbToLinearSrgb0", "$get$linearA98RgbToLinearSrgb0", function() {
                return A.NativeFloat64List_NativeFloat64List$fromList(A._setArrayType([
                    1.3983557439607783,
                    -0.3983557439607783,
                    0,
                    0,
                    1,
                    0,
                    0,
                    -0.04292898929447326,
                    1.0429289892944733
                ], type$.JSArray_double));
            });
            _lazyFinal($, "linearSrgbToLinearRec20200", "$get$linearSrgbToLinearRec20200", function() {
                return A.NativeFloat64List_NativeFloat64List$fromList(A._setArrayType([
                    0.627403895934699,
                    0.3292830383778837,
                    0.04331306568741722,
                    0.06909728935823208,
                    0.9195403950754587,
                    0.01136231556630917,
                    0.01639143887515027,
                    0.08801330787722575,
                    0.895595253247624
                ], type$.JSArray_double));
            });
            _lazyFinal($, "linearRec2020ToLinearSrgb0", "$get$linearRec2020ToLinearSrgb0", function() {
                return A.NativeFloat64List_NativeFloat64List$fromList(A._setArrayType([
                    1.6604910021084345,
                    -0.5876411387885495,
                    -0.07284986331988487,
                    -0.12455047452159074,
                    1.1328998971259603,
                    -0.00834942260436947,
                    -0.0181507633549053,
                    -0.10057889800800737,
                    1.1187296613629127
                ], type$.JSArray_double));
            });
            _lazyFinal($, "linearSrgbToXyzD650", "$get$linearSrgbToXyzD650", function() {
                return A.NativeFloat64List_NativeFloat64List$fromList(A._setArrayType([
                    0.4123907992659595,
                    0.35758433938387796,
                    0.1804807884018343,
                    0.21263900587151036,
                    0.7151686787677559,
                    0.07219231536073371,
                    0.01933081871559185,
                    0.11919477979462598,
                    0.9505321522496606
                ], type$.JSArray_double));
            });
            _lazyFinal($, "xyzD65ToLinearSrgb0", "$get$xyzD65ToLinearSrgb0", function() {
                return A.NativeFloat64List_NativeFloat64List$fromList(A._setArrayType([
                    3.2409699419045213,
                    -1.5373831775700935,
                    -0.4986107602930033,
                    -0.9692436362808798,
                    1.8759675015077206,
                    0.04155505740717561,
                    0.0556300796969936,
                    -0.20397695888897657,
                    1.0569715142428786
                ], type$.JSArray_double));
            });
            _lazyFinal($, "linearSrgbToLms0", "$get$linearSrgbToLms0", function() {
                return A.NativeFloat64List_NativeFloat64List$fromList(A._setArrayType([
                    0.412221469470763,
                    0.5363325372617348,
                    0.0514459932675022,
                    0.2119034958178252,
                    0.6806995506452342,
                    0.1073969535369405,
                    0.08830245919005641,
                    0.2817188391361215,
                    0.6299787016738221
                ], type$.JSArray_double));
            });
            _lazyFinal($, "lmsToLinearSrgb0", "$get$lmsToLinearSrgb0", function() {
                return A.NativeFloat64List_NativeFloat64List$fromList(A._setArrayType([
                    4.076741636075958,
                    -3.307711539258062,
                    0.23096990318210417,
                    -1.268437973285032,
                    2.609757349287689,
                    -0.3413193760026571,
                    -0.00419607613867551,
                    -0.7034186179359363,
                    1.707614694074612
                ], type$.JSArray_double));
            });
            _lazyFinal($, "linearSrgbToLinearProphotoRgb0", "$get$linearSrgbToLinearProphotoRgb0", function() {
                return A.NativeFloat64List_NativeFloat64List$fromList(A._setArrayType([
                    0.5292769776226116,
                    0.33015450197849283,
                    0.14056852039889556,
                    0.09836585954044917,
                    0.8734707129069618,
                    0.028163427552589,
                    0.01687534092138684,
                    0.11765941425612084,
                    0.8654652448224923
                ], type$.JSArray_double));
            });
            _lazyFinal($, "linearProphotoRgbToLinearSrgb0", "$get$linearProphotoRgbToLinearSrgb0", function() {
                return A.NativeFloat64List_NativeFloat64List$fromList(A._setArrayType([
                    2.034380849516996,
                    -0.7276357899341342,
                    -0.3067450595828618,
                    -0.22882573163305037,
                    1.2317425411901048,
                    -0.00291680955705449,
                    -0.00855882878391742,
                    -0.1532667021380372,
                    1.1618255309219547
                ], type$.JSArray_double));
            });
            _lazyFinal($, "linearSrgbToXyzD500", "$get$linearSrgbToXyzD500", function() {
                return A.NativeFloat64List_NativeFloat64List$fromList(A._setArrayType([
                    0.43606574687426936,
                    0.3851515095901596,
                    0.14307841996513868,
                    0.22249317711056518,
                    0.7168870130944824,
                    0.06061980979495235,
                    0.01392392146316939,
                    0.09708132423141015,
                    0.7140993568158807
                ], type$.JSArray_double));
            });
            _lazyFinal($, "xyzD50ToLinearSrgb0", "$get$xyzD50ToLinearSrgb0", function() {
                return A.NativeFloat64List_NativeFloat64List$fromList(A._setArrayType([
                    3.1341358529001178,
                    -1.617385998018042,
                    -0.49066221791109754,
                    -0.9787954765557777,
                    1.9162543773959884,
                    0.03344287339036693,
                    0.07195539255794733,
                    -0.228976759815182,
                    1.4053860351131182
                ], type$.JSArray_double));
            });
            _lazyFinal($, "linearDisplayP3ToLinearA98Rgb0", "$get$linearDisplayP3ToLinearA98Rgb0", function() {
                return A.NativeFloat64List_NativeFloat64List$fromList(A._setArrayType([
                    0.8640051374740484,
                    0.13599486252595164,
                    0,
                    -0.04205695470968816,
                    1.042056954709688,
                    0,
                    -0.02056038078232985,
                    -0.03250613804550798,
                    1.0530665188278379
                ], type$.JSArray_double));
            });
            _lazyFinal($, "linearA98RgbToLinearDisplayP30", "$get$linearA98RgbToLinearDisplayP30", function() {
                return A.NativeFloat64List_NativeFloat64List$fromList(A._setArrayType([
                    1.1500944181410184,
                    -0.15009441814101834,
                    0,
                    0.04641729862941844,
                    0.9535827013705815,
                    0,
                    0.02388759479083904,
                    0.02650477632633013,
                    0.9496076288828308
                ], type$.JSArray_double));
            });
            _lazyFinal($, "linearDisplayP3ToLinearRec20200", "$get$linearDisplayP3ToLinearRec20200", function() {
                return A.NativeFloat64List_NativeFloat64List$fromList(A._setArrayType([
                    0.7538330343617218,
                    0.1985973690526163,
                    0.04756959658566187,
                    0.04574384896535833,
                    0.9417772198116935,
                    0.01247893122294812,
                    -0.00121034035451832,
                    0.01760171730108989,
                    0.9836086230534284
                ], type$.JSArray_double));
            });
            _lazyFinal($, "linearRec2020ToLinearDisplayP30", "$get$linearRec2020ToLinearDisplayP30", function() {
                return A.NativeFloat64List_NativeFloat64List$fromList(A._setArrayType([
                    1.343578252584332,
                    -0.2821796705261357,
                    -0.06139858205819628,
                    -0.06529745278911953,
                    1.0757879158485746,
                    -0.01049046305945495,
                    0.00282178726170095,
                    -0.01959849452449406,
                    1.0167767072627931
                ], type$.JSArray_double));
            });
            _lazyFinal($, "linearDisplayP3ToXyzD650", "$get$linearDisplayP3ToXyzD650", function() {
                return A.NativeFloat64List_NativeFloat64List$fromList(A._setArrayType([
                    0.48657094864821626,
                    0.26566769316909294,
                    0.1982172852343625,
                    0.22897456406974884,
                    0.6917385218365062,
                    0.079286914093745,
                    0,
                    0.04511338185890257,
                    1.0439443689009757
                ], type$.JSArray_double));
            });
            _lazyFinal($, "xyzD65ToLinearDisplayP30", "$get$xyzD65ToLinearDisplayP30", function() {
                return A.NativeFloat64List_NativeFloat64List$fromList(A._setArrayType([
                    2.4934969119414245,
                    -0.9313836179191236,
                    -0.40271078445071684,
                    -0.8294889695615749,
                    1.7626640603183468,
                    0.02362468584194359,
                    0.03584583024378433,
                    -0.0761723892680417,
                    0.9568845240076873
                ], type$.JSArray_double));
            });
            _lazyFinal($, "linearDisplayP3ToLms0", "$get$linearDisplayP3ToLms0", function() {
                return A.NativeFloat64List_NativeFloat64List$fromList(A._setArrayType([
                    0.48137985274995443,
                    0.46211837101131803,
                    0.05650177623872756,
                    0.22883194181124472,
                    0.6532168193835676,
                    0.11795123880518774,
                    0.08394575232299319,
                    0.22416527097756642,
                    0.6918889766994404
                ], type$.JSArray_double));
            });
            _lazyFinal($, "lmsToLinearDisplayP30", "$get$lmsToLinearDisplayP30", function() {
                return A.NativeFloat64List_NativeFloat64List$fromList(A._setArrayType([
                    3.1277689713618737,
                    -2.2571357625916386,
                    0.12936679122976494,
                    -1.0910090184377979,
                    2.4133317103069225,
                    -0.32232269186912466,
                    -0.02601080193857045,
                    -0.508041331704167,
                    1.5340521336427373
                ], type$.JSArray_double));
            });
            _lazyFinal($, "linearDisplayP3ToLinearProphotoRgb0", "$get$linearDisplayP3ToLinearProphotoRgb0", function() {
                return A.NativeFloat64List_NativeFloat64List$fromList(A._setArrayType([
                    0.6316869193403589,
                    0.21393038569465722,
                    0.1543826949649839,
                    0.08320371426648458,
                    0.8858651367630243,
                    0.03093114897049121,
                    -0.00127273456473881,
                    0.05075510433665735,
                    0.9505176302280814
                ], type$.JSArray_double));
            });
            _lazyFinal($, "linearProphotoRgbToLinearDisplayP30", "$get$linearProphotoRgbToLinearDisplayP30", function() {
                return A.NativeFloat64List_NativeFloat64List$fromList(A._setArrayType([
                    1.6325756087069179,
                    -0.3797716184825984,
                    -0.2528039902243195,
                    -0.15370040233755072,
                    1.1667025472425014,
                    -0.01300214490495082,
                    0.01039319529676572,
                    -0.0628073126495944,
                    1.0524141173528287
                ], type$.JSArray_double));
            });
            _lazyFinal($, "linearDisplayP3ToXyzD500", "$get$linearDisplayP3ToXyzD500", function() {
                return A.NativeFloat64List_NativeFloat64List$fromList(A._setArrayType([
                    0.515146442968116,
                    0.2920099820638577,
                    0.15713925139759397,
                    0.2412003221252552,
                    0.6922225411313818,
                    0.06657713674336294,
                    -0.00105013914714014,
                    0.0418782701890746,
                    0.7842764714685257
                ], type$.JSArray_double));
            });
            _lazyFinal($, "xyzD50ToLinearDisplayP30", "$get$xyzD50ToLinearDisplayP30", function() {
                return A.NativeFloat64List_NativeFloat64List$fromList(A._setArrayType([
                    2.4039341218554973,
                    -0.9900304424955931,
                    -0.39761363181465614,
                    -0.8422700161454688,
                    1.7989580161067082,
                    0.01604562477090472,
                    0.04819381686413303,
                    -0.09738519815446048,
                    1.2736713693321273
                ], type$.JSArray_double));
            });
            _lazyFinal($, "linearA98RgbToLinearRec20200", "$get$linearA98RgbToLinearRec20200", function() {
                return A.NativeFloat64List_NativeFloat64List$fromList(A._setArrayType([
                    0.8773338416636568,
                    0.07749370651571998,
                    0.04517245182062317,
                    0.09662259146620378,
                    0.8915273202441805,
                    0.01185008828961569,
                    0.02292106270284839,
                    0.04303668501067932,
                    0.9340422522864723
                ], type$.JSArray_double));
            });
            _lazyFinal($, "linearRec2020ToLinearA98Rgb0", "$get$linearRec2020ToLinearA98Rgb0", function() {
                return A.NativeFloat64List_NativeFloat64List$fromList(A._setArrayType([
                    1.1519783947159163,
                    -0.0975030553024086,
                    -0.05447533941350766,
                    -0.12455047452159074,
                    1.1328998971259603,
                    -0.00834942260436947,
                    -0.0225303827810559,
                    -0.04980650742838876,
                    1.0723368902094446
                ], type$.JSArray_double));
            });
            _lazyFinal($, "linearA98RgbToXyzD650", "$get$linearA98RgbToXyzD650", function() {
                return A.NativeFloat64List_NativeFloat64List$fromList(A._setArrayType([
                    0.5766690429101308,
                    0.18555823790654627,
                    0.18822864623499472,
                    0.29734497525053616,
                    0.627363566255466,
                    0.07529145849399789,
                    0.02703136138641237,
                    0.07068885253582714,
                    0.9913375368376389
                ], type$.JSArray_double));
            });
            _lazyFinal($, "xyzD65ToLinearA98Rgb0", "$get$xyzD65ToLinearA98Rgb0", function() {
                return A.NativeFloat64List_NativeFloat64List$fromList(A._setArrayType([
                    2.041587903810746,
                    -0.5650069742788596,
                    -0.3447313507783295,
                    -0.9692436362808798,
                    1.8759675015077206,
                    0.04155505740717561,
                    0.01344428063203102,
                    -0.11836239223101823,
                    1.0151749943912054
                ], type$.JSArray_double));
            });
            _lazyFinal($, "linearA98RgbToLms0", "$get$linearA98RgbToLms0", function() {
                return A.NativeFloat64List_NativeFloat64List$fromList(A._setArrayType([
                    0.5764322596183941,
                    0.36991322261987963,
                    0.05365451776172635,
                    0.29631647054222465,
                    0.5916761332521885,
                    0.11200739620558686,
                    0.1234782510142776,
                    0.21949869837199862,
                    0.6570230506137238
                ], type$.JSArray_double));
            });
            _lazyFinal($, "lmsToLinearA98Rgb0", "$get$lmsToLinearA98Rgb0", function() {
                return A.NativeFloat64List_NativeFloat64List$fromList(A._setArrayType([
                    2.5540368386115566,
                    -1.6219761806828699,
                    0.06793934207131327,
                    -1.268437973285032,
                    2.609757349287689,
                    -0.3413193760026571,
                    -0.05623473593749381,
                    -0.5670418395669061,
                    1.6232765755043999
                ], type$.JSArray_double));
            });
            _lazyFinal($, "linearA98RgbToLinearProphotoRgb0", "$get$linearA98RgbToLinearProphotoRgb0", function() {
                return A.NativeFloat64List_NativeFloat64List$fromList(A._setArrayType([
                    0.7401175018047792,
                    0.11327951328898105,
                    0.1466029849062397,
                    0.1375504646980262,
                    0.833077080269484,
                    0.02937245503248977,
                    0.02359772990871766,
                    0.07378347703906656,
                    0.9026187930522158
                ], type$.JSArray_double));
            });
            _lazyFinal($, "linearProphotoRgbToLinearA98Rgb0", "$get$linearProphotoRgbToLinearA98Rgb0", function() {
                return A.NativeFloat64List_NativeFloat64List$fromList(A._setArrayType([
                    1.38965124815152,
                    -0.16945907691487766,
                    -0.22019217123664242,
                    -0.22882573163305037,
                    1.2317425411901048,
                    -0.00291680955705449,
                    -0.01762544368426068,
                    -0.09625702306122665,
                    1.1138824667454874
                ], type$.JSArray_double));
            });
            _lazyFinal($, "linearA98RgbToXyzD500", "$get$linearA98RgbToXyzD500", function() {
                return A.NativeFloat64List_NativeFloat64List$fromList(A._setArrayType([
                    0.6097750418861814,
                    0.20530000261929401,
                    0.14922063192409227,
                    0.31112461220464155,
                    0.6256532308346856,
                    0.06322215696067286,
                    0.01947059555648168,
                    0.06087908649415867,
                    0.7447549204598198
                ], type$.JSArray_double));
            });
            _lazyFinal($, "xyzD50ToLinearA98Rgb0", "$get$xyzD50ToLinearA98Rgb0", function() {
                return A.NativeFloat64List_NativeFloat64List$fromList(A._setArrayType([
                    1.9624670363768806,
                    -0.6107423404815073,
                    -0.3413580980827154,
                    -0.9787954765557777,
                    1.9162543773959884,
                    0.03344287339036693,
                    0.02870443944957101,
                    -0.1406748663317068,
                    1.3489141814137937
                ], type$.JSArray_double));
            });
            _lazyFinal($, "linearRec2020ToXyzD650", "$get$linearRec2020ToXyzD650", function() {
                return A.NativeFloat64List_NativeFloat64List$fromList(A._setArrayType([
                    0.6369580483012913,
                    0.14461690358620838,
                    0.16888097516417205,
                    0.26270021201126703,
                    0.677998071518871,
                    0.05930171646986194,
                    0,
                    0.0280726930490875,
                    1.0609850577107909
                ], type$.JSArray_double));
            });
            _lazyFinal($, "xyzD65ToLinearRec20200", "$get$xyzD65ToLinearRec20200", function() {
                return A.NativeFloat64List_NativeFloat64List$fromList(A._setArrayType([
                    1.7166511879712676,
                    -0.3556707837763924,
                    -0.2533662813736598,
                    -0.666684351832489,
                    1.616481236634939,
                    0.01576854581391113,
                    0.01763985744531091,
                    -0.04277061325780865,
                    0.942103121235474
                ], type$.JSArray_double));
            });
            _lazyFinal($, "linearRec2020ToLms0", "$get$linearRec2020ToLms0", function() {
                return A.NativeFloat64List_NativeFloat64List$fromList(A._setArrayType([
                    0.6167557848654444,
                    0.36019840122646335,
                    0.02304581390809228,
                    0.2651330593926367,
                    0.6358393720678491,
                    0.09902756853951408,
                    0.10010262952034828,
                    0.20390652261661452,
                    0.6959908478630372
                ], type$.JSArray_double));
            });
            _lazyFinal($, "lmsToLinearRec20200", "$get$lmsToLinearRec20200", function() {
                return A.NativeFloat64List_NativeFloat64List$fromList(A._setArrayType([
                    2.1399067304346513,
                    -1.246389493760618,
                    0.10648276332596668,
                    -0.8847358357577674,
                    2.1632309383612007,
                    -0.2784951026034334,
                    -0.04857374640044396,
                    -0.4545031497140964,
                    1.5030768961145404
                ], type$.JSArray_double));
            });
            _lazyFinal($, "linearRec2020ToLinearProphotoRgb0", "$get$linearRec2020ToLinearProphotoRgb0", function() {
                return A.NativeFloat64List_NativeFloat64List$fromList(A._setArrayType([
                    0.8351873331297235,
                    0.04886884858605698,
                    0.11594381828421951,
                    0.05403324519953363,
                    0.9289184085692044,
                    0.01704834623126199,
                    -0.00234203897072539,
                    0.03633215316169465,
                    0.9660098858090307
                ], type$.JSArray_double));
            });
            _lazyFinal($, "linearProphotoRgbToLinearRec20200", "$get$linearProphotoRgbToLinearRec20200", function() {
                return A.NativeFloat64List_NativeFloat64List$fromList(A._setArrayType([
                    1.200659329517408,
                    -0.05756805370122346,
                    -0.14309127581618444,
                    -0.06994154955888504,
                    1.080617897597214,
                    -0.01067634803832895,
                    0.00554147334294746,
                    -0.04078219298657951,
                    1.035240719643632
                ], type$.JSArray_double));
            });
            _lazyFinal($, "linearRec2020ToXyzD500", "$get$linearRec2020ToXyzD500", function() {
                return A.NativeFloat64List_NativeFloat64List$fromList(A._setArrayType([
                    0.673515463188276,
                    0.16569726370390453,
                    0.12508294953738705,
                    0.2790590051411206,
                    0.6753180057491098,
                    0.04562298910976962,
                    -0.00193242713400438,
                    0.02997782679282923,
                    0.7970592028516355
                ], type$.JSArray_double));
            });
            _lazyFinal($, "xyzD50ToLinearRec20200", "$get$xyzD50ToLinearRec20200", function() {
                return A.NativeFloat64List_NativeFloat64List$fromList(A._setArrayType([
                    1.647184904671766,
                    -0.3936818981316471,
                    -0.23595963848828266,
                    -0.6826641074173818,
                    1.6477146127444076,
                    0.01281708338512084,
                    0.02966887665275675,
                    -0.0629258964297003,
                    1.2535578201865771
                ], type$.JSArray_double));
            });
            _lazyFinal($, "xyzD65ToLms0", "$get$xyzD65ToLms0", function() {
                return A.NativeFloat64List_NativeFloat64List$fromList(A._setArrayType([
                    0.819022437996703,
                    0.36190626005289034,
                    -0.12887378152098788,
                    0.03298365393238846,
                    0.9292868615863433,
                    0.03614466635064235,
                    0.0481771893596242,
                    0.2642395317527308,
                    0.6335478284694308
                ], type$.JSArray_double));
            });
            _lazyFinal($, "lmsToXyzD650", "$get$lmsToXyzD650", function() {
                return A.NativeFloat64List_NativeFloat64List$fromList(A._setArrayType([
                    1.2268798758459243,
                    -0.5578149944602171,
                    0.2813910456659646,
                    -0.04057574521480084,
                    1.1122868032803173,
                    -0.07171105806551635,
                    -0.07637293667466007,
                    -0.42149333240224324,
                    1.5869240198367818
                ], type$.JSArray_double));
            });
            _lazyFinal($, "xyzD65ToLinearProphotoRgb0", "$get$xyzD65ToLinearProphotoRgb0", function() {
                return A.NativeFloat64List_NativeFloat64List$fromList(A._setArrayType([
                    1.4031904633774979,
                    -0.22301514479051668,
                    -0.1016066850741379,
                    -0.5262384021633072,
                    1.4816319629234644,
                    0.01701879027252688,
                    -0.0112022652862215,
                    0.01824640347962099,
                    0.9112472274915048
                ], type$.JSArray_double));
            });
            _lazyFinal($, "linearProphotoRgbToXyzD650", "$get$linearProphotoRgbToXyzD650", function() {
                return A.NativeFloat64List_NativeFloat64List$fromList(A._setArrayType([
                    0.755590742296921,
                    0.11271984265940525,
                    0.0821453420953454,
                    0.2683218435785719,
                    0.7151152566617912,
                    0.01656289975963685,
                    0.0039159727624258,
                    -0.01293344283684181,
                    1.0980752208342945
                ], type$.JSArray_double));
            });
            _lazyFinal($, "xyzD65ToXyzD500", "$get$xyzD65ToXyzD500", function() {
                return A.NativeFloat64List_NativeFloat64List$fromList(A._setArrayType([
                    1.0479297925449966,
                    0.02294687060160952,
                    -0.05019226628920519,
                    0.02962780877005567,
                    0.99043442675388,
                    -0.01707379906341879,
                    -0.00924304064620452,
                    0.01505519149029816,
                    0.751874281428137
                ], type$.JSArray_double));
            });
            _lazyFinal($, "xyzD50ToXyzD650", "$get$xyzD50ToXyzD650", function() {
                return A.NativeFloat64List_NativeFloat64List$fromList(A._setArrayType([
                    0.9554734214880752,
                    -0.02309845494876452,
                    0.06325924320057065,
                    -0.02836970933386358,
                    1.0099953980813041,
                    0.0210414411919173,
                    0.01231401486448199,
                    -0.02050764929889898,
                    1.330365926242124
                ], type$.JSArray_double));
            });
            _lazyFinal($, "lmsToLinearProphotoRgb0", "$get$lmsToLinearProphotoRgb0", function() {
                return A.NativeFloat64List_NativeFloat64List$fromList(A._setArrayType([
                    1.7383551481157207,
                    -0.9879509427514458,
                    0.24959579463572504,
                    -0.7070494015329266,
                    1.9343700444401382,
                    -0.2273206429072115,
                    -0.08407882206239634,
                    -0.35754060521141334,
                    1.4416194272738097
                ], type$.JSArray_double));
            });
            _lazyFinal($, "linearProphotoRgbToLms0", "$get$linearProphotoRgbToLms0", function() {
                return A.NativeFloat64List_NativeFloat64List$fromList(A._setArrayType([
                    0.7154484605655534,
                    0.35279155007721186,
                    -0.0682400106427653,
                    0.2744116490015671,
                    0.6677976498412367,
                    0.05779070115719616,
                    0.10978443261622942,
                    0.18619829115002018,
                    0.7040172762337504
                ], type$.JSArray_double));
            });
            _lazyFinal($, "lmsToXyzD500", "$get$lmsToXyzD500", function() {
                return A.NativeFloat64List_NativeFloat64List$fromList(A._setArrayType([
                    1.288586218172706,
                    -0.5378717444973745,
                    0.2135812027542364,
                    -0.00253387643187372,
                    1.0923167988719165,
                    -0.08978292244004273,
                    -0.06937382305734124,
                    -0.29500839894431263,
                    1.1894868245121142
                ], type$.JSArray_double));
            });
            _lazyFinal($, "xyzD50ToLms0", "$get$xyzD50ToLms0", function() {
                return A.NativeFloat64List_NativeFloat64List$fromList(A._setArrayType([
                    0.7707000420431172,
                    0.34924840261939616,
                    -0.11202351884164681,
                    0.00559649248368848,
                    0.9370723401136769,
                    0.06972568836252771,
                    0.04633714262191069,
                    0.25277531574310524,
                    0.851458076746796
                ], type$.JSArray_double));
            });
            _lazyFinal($, "linearProphotoRgbToXyzD500", "$get$linearProphotoRgbToXyzD500", function() {
                return A.NativeFloat64List_NativeFloat64List$fromList(A._setArrayType([
                    0.7977666449006423,
                    0.13518129740053308,
                    0.0313477341283922,
                    0.2880748288194013,
                    0.711835234241873,
                    0.00008993693872564,
                    0,
                    0,
                    0.8251046025104602
                ], type$.JSArray_double));
            });
            _lazyFinal($, "xyzD50ToLinearProphotoRgb0", "$get$xyzD50ToLinearProphotoRgb0", function() {
                return A.NativeFloat64List_NativeFloat64List$fromList(A._setArrayType([
                    1.3457868816471583,
                    -0.25557208737979464,
                    -0.05110186497554526,
                    -0.5446307051249019,
                    1.5082477428451468,
                    0.02052744743642139,
                    0,
                    0,
                    1.2119675456389452
                ], type$.JSArray_double));
            });
            _lazyFinal($, "_disallowedFunctionNames0", "$get$_disallowedFunctionNames0", function() {
                var t1 = $.$get$globalFunctions0();
                t1 = t1.map$1$1(t1, new A._disallowedFunctionNames_closure0(), type$.String).toSet$0(0);
                t1.remove$1(0, "abs");
                t1.remove$1(0, "alpha");
                t1.remove$1(0, "color");
                t1.remove$1(0, "grayscale");
                t1.remove$1(0, "hsl");
                t1.remove$1(0, "hsla");
                t1.remove$1(0, "hwb");
                t1.remove$1(0, "invert");
                t1.remove$1(0, "lab");
                t1.remove$1(0, "lch");
                t1.remove$1(0, "max");
                t1.remove$1(0, "min");
                t1.remove$1(0, "oklab");
                t1.remove$1(0, "oklch");
                t1.remove$1(0, "opacity");
                t1.remove$1(0, "rgb");
                t1.remove$1(0, "rgba");
                t1.remove$1(0, "round");
                t1.remove$1(0, "saturate");
                return t1;
            });
            _lazyFinal($, "deprecations", "$get$deprecations", function() {
                var _i, deprecation, t2, t1 = A.LinkedHashMap_LinkedHashMap$_empty(type$.String, A.findType("Deprecation1?"));
                for(_i = 0; _i < 31; ++_i){
                    deprecation = B.List_JA2[_i];
                    if (deprecation !== B.Deprecation_Szt) {
                        t2 = deprecation.id;
                        t1.$indexSet(0, t2, {
                            id: t2,
                            status: new A.deprecations_closure(deprecation).call$0(),
                            description: deprecation.description,
                            deprecatedIn: deprecation.get$deprecatedIn(0),
                            obsoleteIn: deprecation.get$obsoleteIn(0)
                        });
                    }
                }
                return t1;
            });
            _lazyFinal($, "versionClass", "$get$versionClass", function() {
                return new A.versionClass_closure().call$0();
            });
            _lazyFinal($, "exceptionClass", "$get$exceptionClass", function() {
                return new A.exceptionClass_closure().call$0();
            });
            _lazyFinal($, "FilesystemImporter_cwd0", "$get$FilesystemImporter_cwd0", function() {
                var _null = null;
                return new A.FilesystemImporter0(A.absolute(".", _null, _null, _null, _null, _null, _null, _null, _null, _null, _null, _null, _null, _null, _null), true);
            });
            _lazyFinal($, "functionClass", "$get$functionClass", function() {
                return new A.functionClass_closure().call$0();
            });
            _lazyFinal($, "globalFunctions0", "$get$globalFunctions0", function() {
                var t1 = type$.BuiltInCallable_2, t2 = A.List_List$of($.$get$global6(), true, t1);
                B.JSArray_methods.addAll$1(t2, $.$get$global7());
                B.JSArray_methods.addAll$1(t2, $.$get$global8());
                B.JSArray_methods.addAll$1(t2, $.$get$global9());
                B.JSArray_methods.addAll$1(t2, $.$get$global10());
                B.JSArray_methods.addAll$1(t2, $.$get$global11());
                B.JSArray_methods.addAll$1(t2, $.$get$global12());
                t2.push(A.BuiltInCallable$function0("if", "$condition, $if-true, $if-false", new A.globalFunctions_closure0(), null));
                return A.UnmodifiableListView$(t2, t1);
            });
            _lazyFinal($, "coreModules0", "$get$coreModules0", function() {
                return A.UnmodifiableListView$(A._setArrayType([
                    $.$get$module5(),
                    $.$get$module6(),
                    $.$get$module7(),
                    $.$get$module8(),
                    $.$get$module9(),
                    $.$get$module10()
                ], A.findType("JSArray<BuiltInModule0<Callable>>")), type$.BuiltInModule_Callable_2);
            });
            _lazyFinal($, "LegacyIfExpression_declaration0", "$get$LegacyIfExpression_declaration0", function() {
                return A.ParameterList_ParameterList$parse0(string$.x40funct, null);
            });
            _lazyFinal($, "global7", "$get$global7", function() {
                var _s4_ = "list";
                return A.UnmodifiableListView$(A._setArrayType([
                    $.$get$_length2().withDeprecationWarning$1(_s4_),
                    $.$get$_nth0().withDeprecationWarning$1(_s4_),
                    $.$get$_setNth0().withDeprecationWarning$1(_s4_),
                    $.$get$_join0().withDeprecationWarning$1(_s4_),
                    $.$get$_append2().withDeprecationWarning$1(_s4_),
                    $.$get$_zip0().withDeprecationWarning$1(_s4_),
                    $.$get$_index2().withDeprecationWarning$1(_s4_),
                    $.$get$_isBracketed0().withDeprecationWarning$1(_s4_),
                    $.$get$_separator0().withDeprecationWarning$1(_s4_).withName$1("list-separator")
                ], type$.JSArray_BuiltInCallable_2), type$.BuiltInCallable_2);
            });
            _lazyFinal($, "module6", "$get$module6", function() {
                return A.BuiltInModule$0("list", A._setArrayType([
                    $.$get$_length2(),
                    $.$get$_nth0(),
                    $.$get$_setNth0(),
                    $.$get$_join0(),
                    $.$get$_append2(),
                    $.$get$_zip0(),
                    $.$get$_index2(),
                    $.$get$_isBracketed0(),
                    $.$get$_separator0(),
                    $.$get$_slash0()
                ], type$.JSArray_Callable_2), null, null, type$.Callable_2);
            });
            _lazyFinal($, "_length1", "$get$_length2", function() {
                return A._function11("length", "$list", new A._length_closure2());
            });
            _lazyFinal($, "_nth0", "$get$_nth0", function() {
                return A._function11("nth", "$list, $n", new A._nth_closure0());
            });
            _lazyFinal($, "_setNth0", "$get$_setNth0", function() {
                return A._function11("set-nth", "$list, $n, $value", new A._setNth_closure0());
            });
            _lazyFinal($, "_join0", "$get$_join0", function() {
                return A._function11("join", string$.x24list1, new A._join_closure0());
            });
            _lazyFinal($, "_append1", "$get$_append2", function() {
                return A._function11("append", "$list, $val, $separator: auto", new A._append_closure2());
            });
            _lazyFinal($, "_zip0", "$get$_zip0", function() {
                return A._function11("zip", "$lists...", new A._zip_closure0());
            });
            _lazyFinal($, "_index1", "$get$_index2", function() {
                return A._function11("index", "$list, $value", new A._index_closure2());
            });
            _lazyFinal($, "_separator0", "$get$_separator0", function() {
                return A._function11("separator", "$list", new A._separator_closure0());
            });
            _lazyFinal($, "_isBracketed0", "$get$_isBracketed0", function() {
                return A._function11("is-bracketed", "$list", new A._isBracketed_closure0());
            });
            _lazyFinal($, "_slash0", "$get$_slash0", function() {
                return A._function11("slash", "$elements...", new A._slash_closure0());
            });
            _lazyFinal($, "listClass", "$get$listClass", function() {
                return new A.listClass_closure().call$0();
            });
            _lazyFinal($, "legacyListClass", "$get$legacyListClass", function() {
                var t1 = A.createJSClass("sass.types.List", new A.legacyListClass_closure());
                A.JSClassExtension_defineMethods(t1, A.LinkedHashMap_LinkedHashMap$_literal([
                    "getValue",
                    new A.legacyListClass_closure0(),
                    "setValue",
                    new A.legacyListClass_closure1(),
                    "getSeparator",
                    new A.legacyListClass_closure2(),
                    "setSeparator",
                    new A.legacyListClass_closure3(),
                    "getLength",
                    new A.legacyListClass_closure4()
                ], type$.String, type$.Function));
                return t1;
            });
            _lazyFinal($, "global8", "$get$global8", function() {
                var _s3_ = "map";
                return A.UnmodifiableListView$(A._setArrayType([
                    $.$get$_get0().withDeprecationWarning$1(_s3_).withName$1("map-get"),
                    $.$get$_merge0().withDeprecationWarning$1(_s3_).withName$1("map-merge"),
                    $.$get$_remove0().withDeprecationWarning$1(_s3_).withName$1("map-remove"),
                    $.$get$_keys0().withDeprecationWarning$1(_s3_).withName$1("map-keys"),
                    $.$get$_values0().withDeprecationWarning$1(_s3_).withName$1("map-values"),
                    $.$get$_hasKey0().withDeprecationWarning$1(_s3_).withName$1("map-has-key")
                ], type$.JSArray_BuiltInCallable_2), type$.BuiltInCallable_2);
            });
            _lazyFinal($, "module7", "$get$module7", function() {
                return A.BuiltInModule$0("map", A._setArrayType([
                    $.$get$_get0(),
                    $.$get$_set0(),
                    $.$get$_merge0(),
                    $.$get$_remove0(),
                    $.$get$_keys0(),
                    $.$get$_values0(),
                    $.$get$_hasKey0(),
                    $.$get$_deepMerge0(),
                    $.$get$_deepRemove0()
                ], type$.JSArray_Callable_2), null, null, type$.Callable_2);
            });
            _lazyFinal($, "_get0", "$get$_get0", function() {
                return A._function10("get", "$map, $key, $keys...", new A._get_closure0());
            });
            _lazyFinal($, "_set0", "$get$_set0", function() {
                return A.BuiltInCallable$overloadedFunction0("set", A.LinkedHashMap_LinkedHashMap$_literal([
                    "$map, $key, $value",
                    new A._set_closure1(),
                    "$map, $args...",
                    new A._set_closure2()
                ], type$.String, type$.Value_Function_List_Value_2));
            });
            _lazyFinal($, "_merge0", "$get$_merge0", function() {
                return A.BuiltInCallable$overloadedFunction0("merge", A.LinkedHashMap_LinkedHashMap$_literal([
                    "$map1, $map2",
                    new A._merge_closure1(),
                    "$map1, $args...",
                    new A._merge_closure2()
                ], type$.String, type$.Value_Function_List_Value_2));
            });
            _lazyFinal($, "_deepMerge0", "$get$_deepMerge0", function() {
                return A._function10("deep-merge", "$map1, $map2", new A._deepMerge_closure0());
            });
            _lazyFinal($, "_deepRemove0", "$get$_deepRemove0", function() {
                return A._function10("deep-remove", "$map, $key, $keys...", new A._deepRemove_closure0());
            });
            _lazyFinal($, "_remove0", "$get$_remove0", function() {
                return A.BuiltInCallable$overloadedFunction0("remove", A.LinkedHashMap_LinkedHashMap$_literal([
                    "$map",
                    new A._remove_closure1(),
                    "$map, $key, $keys...",
                    new A._remove_closure2()
                ], type$.String, type$.Value_Function_List_Value_2));
            });
            _lazyFinal($, "_keys0", "$get$_keys0", function() {
                return A._function10("keys", "$map", new A._keys_closure0());
            });
            _lazyFinal($, "_values0", "$get$_values0", function() {
                return A._function10("values", "$map", new A._values_closure0());
            });
            _lazyFinal($, "_hasKey0", "$get$_hasKey0", function() {
                return A._function10("has-key", "$map, $key, $keys...", new A._hasKey_closure0());
            });
            _lazyFinal($, "mapClass", "$get$mapClass", function() {
                return new A.mapClass_closure().call$0();
            });
            _lazyFinal($, "legacyMapClass", "$get$legacyMapClass", function() {
                var t1 = A.createJSClass("sass.types.Map", new A.legacyMapClass_closure());
                A.JSClassExtension_defineMethods(t1, A.LinkedHashMap_LinkedHashMap$_literal([
                    "getKey",
                    new A.legacyMapClass_closure0(),
                    "getValue",
                    new A.legacyMapClass_closure1(),
                    "getLength",
                    new A.legacyMapClass_closure2(),
                    "setKey",
                    new A.legacyMapClass_closure3(),
                    "setValue",
                    new A.legacyMapClass_closure4()
                ], type$.String, type$.Function));
                return t1;
            });
            _lazyFinal($, "global9", "$get$global9", function() {
                var _s4_ = "math";
                return A.UnmodifiableListView$(A._setArrayType([
                    A._function9("abs", "$number", new A.global_closure43()),
                    $.$get$_ceil0().withDeprecationWarning$1(_s4_),
                    $.$get$_floor0().withDeprecationWarning$1(_s4_),
                    $.$get$_max0().withDeprecationWarning$1(_s4_),
                    $.$get$_min0().withDeprecationWarning$1(_s4_),
                    $.$get$_percentage0().withDeprecationWarning$1(_s4_),
                    $.$get$_randomFunction0().withDeprecationWarning$1(_s4_),
                    $.$get$_round0().withDeprecationWarning$1(_s4_),
                    $.$get$_unit0().withDeprecationWarning$1(_s4_),
                    $.$get$_compatible0().withDeprecationWarning$1(_s4_).withName$1("comparable"),
                    $.$get$_isUnitless0().withDeprecationWarning$1(_s4_).withName$1("unitless")
                ], type$.JSArray_BuiltInCallable_2), type$.BuiltInCallable_2);
            });
            _lazyFinal($, "module8", "$get$module8", function() {
                var _null = null;
                return A.BuiltInModule$0("math", A._setArrayType([
                    A._numberFunction0("abs", new A.module_closure26()),
                    $.$get$_acos0(),
                    $.$get$_asin0(),
                    $.$get$_atan0(),
                    $.$get$_atan20(),
                    $.$get$_ceil0(),
                    $.$get$_clamp0(),
                    $.$get$_cos0(),
                    $.$get$_compatible0(),
                    $.$get$_floor0(),
                    $.$get$_hypot0(),
                    $.$get$_isUnitless0(),
                    $.$get$_log0(),
                    $.$get$_max0(),
                    $.$get$_min0(),
                    $.$get$_percentage0(),
                    $.$get$_pow0(),
                    $.$get$_randomFunction0(),
                    $.$get$_round0(),
                    $.$get$_sin0(),
                    $.$get$_sqrt0(),
                    $.$get$_tan0(),
                    $.$get$_unit0(),
                    $.$get$_div0()
                ], type$.JSArray_Callable_2), _null, A.LinkedHashMap_LinkedHashMap$_literal([
                    "e",
                    A.SassNumber_SassNumber0(2.718281828459045, _null),
                    "pi",
                    A.SassNumber_SassNumber0(3.141592653589793, _null),
                    "epsilon",
                    A.SassNumber_SassNumber0(2220446049250313e-31, _null),
                    "max-safe-integer",
                    A.SassNumber_SassNumber0(9007199254740991, _null),
                    "min-safe-integer",
                    A.SassNumber_SassNumber0(-9007199254740991, _null),
                    "max-number",
                    A.SassNumber_SassNumber0(17976931348623157e292, _null),
                    "min-number",
                    A.SassNumber_SassNumber0(5e-324, _null)
                ], type$.String, type$.Value_2), type$.Callable_2);
            });
            _lazyFinal($, "_ceil0", "$get$_ceil0", function() {
                return A._numberFunction0("ceil", new A._ceil_closure0());
            });
            _lazyFinal($, "_clamp0", "$get$_clamp0", function() {
                return A._function9("clamp", "$min, $number, $max", new A._clamp_closure0());
            });
            _lazyFinal($, "_floor0", "$get$_floor0", function() {
                return A._numberFunction0("floor", new A._floor_closure0());
            });
            _lazyFinal($, "_max0", "$get$_max0", function() {
                return A._function9("max", "$numbers...", new A._max_closure0());
            });
            _lazyFinal($, "_min0", "$get$_min0", function() {
                return A._function9("min", "$numbers...", new A._min_closure0());
            });
            _lazyFinal($, "_round0", "$get$_round0", function() {
                return A._numberFunction0("round", new A._round_closure0());
            });
            _lazyFinal($, "_hypot0", "$get$_hypot0", function() {
                return A._function9("hypot", "$numbers...", new A._hypot_closure0());
            });
            _lazyFinal($, "_log0", "$get$_log0", function() {
                return A._function9("log", "$number, $base: null", new A._log_closure0());
            });
            _lazyFinal($, "_pow0", "$get$_pow0", function() {
                return A._function9("pow", "$base, $exponent", new A._pow_closure0());
            });
            _lazyFinal($, "_sqrt0", "$get$_sqrt0", function() {
                return A._singleArgumentMathFunc0("sqrt", A.number2__sqrt$closure());
            });
            _lazyFinal($, "_acos0", "$get$_acos0", function() {
                return A._singleArgumentMathFunc0("acos", A.number2__acos$closure());
            });
            _lazyFinal($, "_asin0", "$get$_asin0", function() {
                return A._singleArgumentMathFunc0("asin", A.number2__asin$closure());
            });
            _lazyFinal($, "_atan0", "$get$_atan0", function() {
                return A._singleArgumentMathFunc0("atan", A.number2__atan$closure());
            });
            _lazyFinal($, "_atan20", "$get$_atan20", function() {
                return A._function9("atan2", "$y, $x", new A._atan2_closure0());
            });
            _lazyFinal($, "_cos0", "$get$_cos0", function() {
                return A._singleArgumentMathFunc0("cos", A.number2__cos$closure());
            });
            _lazyFinal($, "_sin0", "$get$_sin0", function() {
                return A._singleArgumentMathFunc0("sin", A.number2__sin$closure());
            });
            _lazyFinal($, "_tan0", "$get$_tan0", function() {
                return A._singleArgumentMathFunc0("tan", A.number2__tan$closure());
            });
            _lazyFinal($, "_compatible0", "$get$_compatible0", function() {
                return A._function9("compatible", "$number1, $number2", new A._compatible_closure0());
            });
            _lazyFinal($, "_isUnitless0", "$get$_isUnitless0", function() {
                return A._function9("is-unitless", "$number", new A._isUnitless_closure0());
            });
            _lazyFinal($, "_unit0", "$get$_unit0", function() {
                return A._function9("unit", "$number", new A._unit_closure0());
            });
            _lazyFinal($, "_percentage0", "$get$_percentage0", function() {
                return A._function9("percentage", "$number", new A._percentage_closure0());
            });
            _lazyFinal($, "_random1", "$get$_random2", function() {
                return A.Random_Random();
            });
            _lazyFinal($, "_randomFunction0", "$get$_randomFunction0", function() {
                return A._function9("random", "$limit: null", new A._randomFunction_closure0());
            });
            _lazyFinal($, "_div0", "$get$_div0", function() {
                return A._function9("div", "$number1, $number2", new A._div_closure0());
            });
            _lazyFinal($, "_shared0", "$get$_shared0", function() {
                return A.UnmodifiableListView$(A._setArrayType([
                    A._function6("feature-exists", "$feature", new A._shared_closure3()),
                    A._function6("inspect", "$value", new A._shared_closure4()),
                    A._function6("type-of", "$value", new A._shared_closure5()),
                    A._function6("keywords", "$args", new A._shared_closure6())
                ], type$.JSArray_BuiltInCallable_2), type$.BuiltInCallable_2);
            });
            _lazyFinal($, "global10", "$get$global12", function() {
                var t2, t1 = A._setArrayType([], type$.JSArray_BuiltInCallable_2);
                for(t2 = $.$get$_shared0(), t2 = t2.get$iterator(t2); t2.moveNext$0();)t1.push(t2.get$current(0).withDeprecationWarning$1("meta"));
                return A.UnmodifiableListView$(t1, type$.BuiltInCallable_2);
            });
            _lazyFinal($, "moduleFunctions0", "$get$moduleFunctions0", function() {
                var t1 = type$.BuiltInCallable_2, t2 = A.List_List$of($.$get$_shared0(), true, t1);
                t2.push(A._function6("calc-name", "$calc", new A.moduleFunctions_closure2()));
                t2.push(A._function6("calc-args", "$calc", new A.moduleFunctions_closure3()));
                t2.push(A._function6("accepts-content", "$mixin", new A.moduleFunctions_closure4()));
                return A.UnmodifiableListView$(t2, t1);
            });
            _lazyFinal($, "mixinClass", "$get$mixinClass", function() {
                return new A.mixinClass_closure().call$0();
            });
            _lazyFinal($, "legacyNullClass", "$get$legacyNullClass", function() {
                return new A.legacyNullClass_closure().call$0();
            });
            _lazyFinal($, "_epsilon0", "$get$_epsilon0", function() {
                return A.pow(10, -11);
            });
            _lazyFinal($, "_inverseEpsilon0", "$get$_inverseEpsilon0", function() {
                return A.pow(10, 11);
            });
            _lazyFinal($, "numberClass", "$get$numberClass", function() {
                return new A.numberClass_closure().call$0();
            });
            _lazyFinal($, "legacyNumberClass", "$get$legacyNumberClass", function() {
                var t1 = A.createJSClass("sass.types.Number", new A.legacyNumberClass_closure());
                A.JSClassExtension_defineMethods(t1, A.LinkedHashMap_LinkedHashMap$_literal([
                    "getValue",
                    new A.legacyNumberClass_closure0(),
                    "setValue",
                    new A.legacyNumberClass_closure1(),
                    "getUnit",
                    new A.legacyNumberClass_closure2(),
                    "setUnit",
                    new A.legacyNumberClass_closure3()
                ], type$.String, type$.Function));
                return t1;
            });
            _lazyFinal($, "_typesByUnit0", "$get$_typesByUnit0", function() {
                var t3, type, t1 = type$.String, t2 = A.LinkedHashMap_LinkedHashMap$_empty(t1, t1);
                for(t1 = A.MapExtensions_get_pairs0(B.Map_Sr65K, t1, type$.List_String), t1 = t1.get$iterator(t1); t1.moveNext$0();){
                    t3 = t1.get$current(t1);
                    type = t3._0;
                    for(t3 = J.get$iterator$ax(t3._1); t3.moveNext$0();)t2.$indexSet(0, t3.get$current(t3), type);
                }
                return t2;
            });
            _lazyFinal($, "_interpolation", "$get$_interpolation", function() {
                return A.Interpolation$0(B.List_empty12, B.List_empty13, $.$get$bogusSpan0());
            });
            _lazyFinal($, "_expression", "$get$_expression", function() {
                return A.NullExpression$($.$get$bogusSpan0());
            });
            _lazyFinal($, "global11", "$get$global10", function() {
                var _s8_ = "selector";
                return A.UnmodifiableListView$(A._setArrayType([
                    $.$get$_isSuperselector0().withDeprecationWarning$1(_s8_),
                    $.$get$_simpleSelectors0().withDeprecationWarning$1(_s8_),
                    $.$get$_parse0().withDeprecationWarning$1(_s8_).withName$1("selector-parse"),
                    $.$get$_nest0().withDeprecationWarning$1(_s8_).withName$1("selector-nest"),
                    $.$get$_append1().withDeprecationWarning$1(_s8_).withName$1("selector-append"),
                    $.$get$_extend0().withDeprecationWarning$1(_s8_).withName$1("selector-extend"),
                    $.$get$_replace0().withDeprecationWarning$1(_s8_).withName$1("selector-replace"),
                    $.$get$_unify0().withDeprecationWarning$1(_s8_).withName$1("selector-unify")
                ], type$.JSArray_BuiltInCallable_2), type$.BuiltInCallable_2);
            });
            _lazyFinal($, "module9", "$get$module9", function() {
                return A.BuiltInModule$0("selector", A._setArrayType([
                    $.$get$_isSuperselector0(),
                    $.$get$_simpleSelectors0(),
                    $.$get$_parse0(),
                    $.$get$_nest0(),
                    $.$get$_append1(),
                    $.$get$_extend0(),
                    $.$get$_replace0(),
                    $.$get$_unify0()
                ], type$.JSArray_Callable_2), null, null, type$.Callable_2);
            });
            _lazyFinal($, "_nest0", "$get$_nest0", function() {
                return A._function8("nest", "$selectors...", new A._nest_closure0());
            });
            _lazyFinal($, "_append2", "$get$_append1", function() {
                return A._function8("append", "$selectors...", new A._append_closure1());
            });
            _lazyFinal($, "_extend0", "$get$_extend0", function() {
                return A._function8("extend", "$selector, $extendee, $extender", new A._extend_closure0());
            });
            _lazyFinal($, "_replace0", "$get$_replace0", function() {
                return A._function8("replace", "$selector, $original, $replacement", new A._replace_closure0());
            });
            _lazyFinal($, "_unify0", "$get$_unify0", function() {
                return A._function8("unify", "$selector1, $selector2", new A._unify_closure0());
            });
            _lazyFinal($, "_isSuperselector0", "$get$_isSuperselector0", function() {
                return A._function8("is-superselector", "$super, $sub", new A._isSuperselector_closure0());
            });
            _lazyFinal($, "_simpleSelectors0", "$get$_simpleSelectors0", function() {
                return A._function8("simple-selectors", "$selector", new A._simpleSelectors_closure0());
            });
            _lazyFinal($, "_parse1", "$get$_parse0", function() {
                return A._function8("parse", "$selector", new A._parse_closure0());
            });
            _lazyFinal($, "_knownCompatibilitiesByUnit0", "$get$_knownCompatibilitiesByUnit0", function() {
                var _i, set, t2, t1 = A.LinkedHashMap_LinkedHashMap$_empty(type$.String, A.findType("Set<String>"));
                for(_i = 0; _i < 5; ++_i){
                    set = B.List_BFg[_i];
                    for(t2 = set.get$iterator(set); t2.moveNext$0();)t1.$indexSet(0, t2.get$current(0), set);
                }
                return t1;
            });
            _lazyFinal($, "bogusSpan0", "$get$bogusSpan0", function() {
                return A.SourceFile$decoded(A._setArrayType([], type$.JSArray_int), null).span$1(0, 0);
            });
            _lazyFinal($, "_random2", "$get$_random1", function() {
                return A.Random_Random();
            });
            _lazy($, "_previousUniqueId0", "$get$_previousUniqueId0", function() {
                return $.$get$_random1().nextInt$1(A._asInt(A.pow(36, 6)));
            });
            _lazyFinal($, "global12", "$get$global11", function() {
                var _s6_ = "string";
                return A.UnmodifiableListView$(A._setArrayType([
                    $.$get$_unquote0().withDeprecationWarning$1(_s6_),
                    $.$get$_quote0().withDeprecationWarning$1(_s6_),
                    $.$get$_toUpperCase0().withDeprecationWarning$1(_s6_),
                    $.$get$_toLowerCase0().withDeprecationWarning$1(_s6_),
                    $.$get$_uniqueId0().withDeprecationWarning$1(_s6_),
                    $.$get$_length1().withDeprecationWarning$1(_s6_).withName$1("str-length"),
                    $.$get$_insert0().withDeprecationWarning$1(_s6_).withName$1("str-insert"),
                    $.$get$_index1().withDeprecationWarning$1(_s6_).withName$1("str-index"),
                    $.$get$_slice0().withDeprecationWarning$1(_s6_).withName$1("str-slice")
                ], type$.JSArray_BuiltInCallable_2), type$.BuiltInCallable_2);
            });
            _lazyFinal($, "module10", "$get$module10", function() {
                return A.BuiltInModule$0("string", A._setArrayType([
                    $.$get$_unquote0(),
                    $.$get$_quote0(),
                    $.$get$_toUpperCase0(),
                    $.$get$_toLowerCase0(),
                    $.$get$_length1(),
                    $.$get$_insert0(),
                    $.$get$_index1(),
                    $.$get$_slice0(),
                    $.$get$_uniqueId0(),
                    A._function7("split", "$string, $separator, $limit: null", new A.module_closure25())
                ], type$.JSArray_Callable_2), null, null, type$.Callable_2);
            });
            _lazyFinal($, "_unquote0", "$get$_unquote0", function() {
                return A._function7("unquote", "$string", new A._unquote_closure0());
            });
            _lazyFinal($, "_quote0", "$get$_quote0", function() {
                return A._function7("quote", "$string", new A._quote_closure0());
            });
            _lazyFinal($, "_length2", "$get$_length1", function() {
                return A._function7("length", "$string", new A._length_closure1());
            });
            _lazyFinal($, "_insert0", "$get$_insert0", function() {
                return A._function7("insert", "$string, $insert, $index", new A._insert_closure0());
            });
            _lazyFinal($, "_index2", "$get$_index1", function() {
                return A._function7("index", "$string, $substring", new A._index_closure1());
            });
            _lazyFinal($, "_slice0", "$get$_slice0", function() {
                return A._function7("slice", "$string, $start-at, $end-at: -1", new A._slice_closure0());
            });
            _lazyFinal($, "_toUpperCase0", "$get$_toUpperCase0", function() {
                return A._function7("to-upper-case", "$string", new A._toUpperCase_closure0());
            });
            _lazyFinal($, "_toLowerCase0", "$get$_toLowerCase0", function() {
                return A._function7("to-lower-case", "$string", new A._toLowerCase_closure0());
            });
            _lazyFinal($, "_uniqueId0", "$get$_uniqueId0", function() {
                return A._function7("unique-id", "", new A._uniqueId_closure0());
            });
            _lazyFinal($, "stringClass", "$get$stringClass", function() {
                return new A.stringClass_closure().call$0();
            });
            _lazyFinal($, "legacyStringClass", "$get$legacyStringClass", function() {
                var t1 = A.createJSClass("sass.types.String", new A.legacyStringClass_closure());
                A.JSClassExtension_defineMethods(t1, A.LinkedHashMap_LinkedHashMap$_literal([
                    "getValue",
                    new A.legacyStringClass_closure0(),
                    "setValue",
                    new A.legacyStringClass_closure1()
                ], type$.String, type$.Function));
                return t1;
            });
            _lazyFinal($, "_emptyQuoted0", "$get$_emptyQuoted0", function() {
                return A.SassString$0("", true);
            });
            _lazyFinal($, "_emptyUnquoted0", "$get$_emptyUnquoted0", function() {
                return A.SassString$0("", false);
            });
            _lazyFinal($, "_urlSchemeRegExp", "$get$_urlSchemeRegExp", function() {
                return A.RegExp_RegExp("^[a-z0-9+.-]+$", false);
            });
            _lazyFinal($, "_jsThrow0", "$get$_jsThrow", function() {
                return new self.Function("error", "throw error;");
            });
            _lazyFinal($, "_isUndefined", "$get$_isUndefined", function() {
                return new self.Function("value", "return value === undefined;");
            });
            _lazyFinal($, "_isNull", "$get$_isNull", function() {
                return new self.Function("value", "return value === null;");
            });
            _lazyFinal($, "_noSourceUrl0", "$get$_noSourceUrl0", function() {
                return A.Uri_parse("-");
            });
            _lazyFinal($, "_traces0", "$get$_traces0", function() {
                return A.Expando$();
            });
            _lazyFinal($, "valueClass", "$get$valueClass", function() {
                return new A.valueClass_closure().call$0();
            });
        })();
        (function nativeSupport() {
            !function() {
                var intern = function intern(s) {
                    var o = {};
                    o[s] = 1;
                    return Object.keys(hunkHelpers.convertToFastObject(o))[0];
                };
                init.getIsolateTag = function(name) {
                    return intern("___dart_" + name + init.isolateTag);
                };
                var tableProperty = "___dart_isolate_tags_";
                var usedProperties = Object[tableProperty] || (Object[tableProperty] = Object.create(null));
                var rootProperty = "_ZxYxX";
                for(var i = 0;; i++){
                    var property = intern(rootProperty + "_" + i + "_");
                    if (!(property in usedProperties)) {
                        usedProperties[property] = 1;
                        init.isolateTag = property;
                        break;
                    }
                }
                init.dispatchPropertyName = init.getIsolateTag("dispatch_record");
            }();
            hunkHelpers.setOrUpdateInterceptorsByTag({
                ArrayBuffer: A.NativeByteBuffer,
                SharedArrayBuffer: A.NativeByteBuffer,
                ArrayBufferView: A.NativeTypedData,
                DataView: A.NativeByteData,
                Float32Array: A.NativeFloat32List,
                Float64Array: A.NativeFloat64List,
                Int16Array: A.NativeInt16List,
                Int32Array: A.NativeInt32List,
                Int8Array: A.NativeInt8List,
                Uint16Array: A.NativeUint16List,
                Uint32Array: A.NativeUint32List,
                Uint8ClampedArray: A.NativeUint8ClampedList,
                CanvasPixelArray: A.NativeUint8ClampedList,
                Uint8Array: A.NativeUint8List
            });
            hunkHelpers.setOrUpdateLeafTags({
                ArrayBuffer: true,
                SharedArrayBuffer: true,
                ArrayBufferView: false,
                DataView: true,
                Float32Array: true,
                Float64Array: true,
                Int16Array: true,
                Int32Array: true,
                Int8Array: true,
                Uint16Array: true,
                Uint32Array: true,
                Uint8ClampedArray: true,
                CanvasPixelArray: true,
                Uint8Array: false
            });
            A.NativeTypedArray.$nativeSuperclassTag = "ArrayBufferView";
            A._NativeTypedArrayOfDouble_NativeTypedArray_ListMixin.$nativeSuperclassTag = "ArrayBufferView";
            A._NativeTypedArrayOfDouble_NativeTypedArray_ListMixin_FixedLengthListMixin.$nativeSuperclassTag = "ArrayBufferView";
            A.NativeTypedArrayOfDouble.$nativeSuperclassTag = "ArrayBufferView";
            A._NativeTypedArrayOfInt_NativeTypedArray_ListMixin.$nativeSuperclassTag = "ArrayBufferView";
            A._NativeTypedArrayOfInt_NativeTypedArray_ListMixin_FixedLengthListMixin.$nativeSuperclassTag = "ArrayBufferView";
            A.NativeTypedArrayOfInt.$nativeSuperclassTag = "ArrayBufferView";
        })();
        Function.prototype.call$0 = function() {
            return this();
        };
        Function.prototype.call$1 = function(a) {
            return this(a);
        };
        Function.prototype.call$2 = function(a, b) {
            return this(a, b);
        };
        Function.prototype.call$3$1 = function(a) {
            return this(a);
        };
        Function.prototype.call$2$1 = function(a) {
            return this(a);
        };
        Function.prototype.call$1$1 = function(a) {
            return this(a);
        };
        Function.prototype.call$3 = function(a, b, c) {
            return this(a, b, c);
        };
        Function.prototype.call$4 = function(a, b, c, d) {
            return this(a, b, c, d);
        };
        Function.prototype.call$3$3 = function(a, b, c) {
            return this(a, b, c);
        };
        Function.prototype.call$2$2 = function(a, b) {
            return this(a, b);
        };
        Function.prototype.call$5 = function(a, b, c, d, e) {
            return this(a, b, c, d, e);
        };
        Function.prototype.call$6 = function(a, b, c, d, e, f) {
            return this(a, b, c, d, e, f);
        };
        Function.prototype.call$2$0 = function() {
            return this();
        };
        Function.prototype.call$1$0 = function() {
            return this();
        };
        Function.prototype.call$1$2 = function(a, b) {
            return this(a, b);
        };
        Function.prototype.call$2$3 = function(a, b, c) {
            return this(a, b, c);
        };
        convertAllToFastObject(holders);
        convertToFastObject($);
        (function(callback) {
            if (typeof document === "undefined") {
                callback(null);
                return;
            }
            if (typeof document.currentScript != "undefined") {
                callback(document.currentScript);
                return;
            }
            var scripts = document.scripts;
            function onLoad(event) {
                for(var i = 0; i < scripts.length; ++i)scripts[i].removeEventListener("load", onLoad, false);
                callback(event.target);
            }
            for(var i = 0; i < scripts.length; ++i)scripts[i].addEventListener("load", onLoad, false);
        })(function(currentScript) {
            init.currentScript = currentScript;
            var callMain = A.main2;
            if (typeof dartMainRunner === "function") dartMainRunner(callMain, []);
            else callMain([]);
        });
    })();
};


var $02d54c1a72d95c0f$var$library = globalThis._cliPkgExports.pop();
if (globalThis._cliPkgExports.length === 0) delete globalThis._cliPkgExports;





$02d54c1a72d95c0f$var$library.load({
    util: (parcelRequire("bXSnP")),
    stream: (parcelRequire("7S5PM")),
    nodeModule: (parcelRequire("jfVOB")),
    fs: (parcelRequire("jfVOB")),
    immutable: (parcelRequire("9akFT"))
});
$02d54c1a72d95c0f$exports = $02d54c1a72d95c0f$var$library;




var $7e4be3c431632f5d$var$PaginationView = /*#__PURE__*/ function(View) {
    "use strict";
    (0, $gNq0T._)(PaginationView, View);
    function PaginationView() {
        (0, $7eXQk._)(this, PaginationView);
        var _this;
        _this = (0, $fxAKY._)(this, PaginationView, arguments), (0, $c9996135bbccb03d$export$71511d61b312f219)(_this, "_parentElement", document.querySelector('.pagination'));
        return _this;
    }
    (0, $gApSC._)(PaginationView, [
        {
            key: "addHandlerClick",
            value: function addHandlerClick(handler) {
                this._parentElement.addEventListener('click', function(e) {
                    var btn = e.target.closest('.btn--inline');
                    if (!btn) return;
                    var goToPage = +btn.dataset.goto;
                    handler(goToPage);
                });
            }
        },
        {
            key: "_generateMarkup",
            value: function _generateMarkup() {
                var currPage = this._data.page;
                var numPages = Math.ceil(this._data.results.length / this._data.resultsPerPage);
                // Page 1 and there are other pages
                if (currPage === 1 && numPages > 1) return '\n      <button data-goto="'.concat(currPage + 1, '" class="btn--inline pagination__btn--next">\n            <span>Page ').concat(currPage + 1, '</span>\n            <svg class="search__icon">\n              <use href="').concat((0, (/*@__PURE__*/$parcel$interopDefault($66dabfc31483eda1$exports))), '#icon-arrow-right"></use>\n            </svg>\n          </button>');
                // Last Page
                if (currPage === numPages && numPages > 1) return ' \n      <button data-goto="'.concat(currPage - 1, '" class="btn--inline pagination__btn--prev">\n            <svg class="search__icon">\n              <use href="').concat((0, (/*@__PURE__*/$parcel$interopDefault($66dabfc31483eda1$exports))), '#icon-arrow-left"></use>\n            </svg>\n            <span>Page ').concat(currPage - 1, "</span>\n      </button>");
                // Other page
                if (currPage < numPages) return ' \n        <button data-goto="'.concat(currPage - 1, '" class="btn--inline pagination__btn--prev">\n            <svg class="search__icon">\n              <use href="').concat((0, (/*@__PURE__*/$parcel$interopDefault($66dabfc31483eda1$exports))), '#icon-arrow-left"></use>\n            </svg>\n            <span>Page ').concat(currPage - 1, '</span>\n        </button>\n        <button data-goto="').concat(currPage + 1, '" class="btn--inline pagination__btn--next">\n            <span>Page ').concat(currPage + 1, '</span>\n            <svg class="search__icon">\n              <use href="').concat((0, (/*@__PURE__*/$parcel$interopDefault($66dabfc31483eda1$exports))), '#icon-arrow-right"></use>\n            </svg>\n        </button>');
                // Page 1 and no other pages
                return '';
            }
        }
    ]);
    return PaginationView;
}((0, $f88bdd13c53e4d92$export$2e2bcd8739ae039));
var $7e4be3c431632f5d$export$2e2bcd8739ae039 = new $7e4be3c431632f5d$var$PaginationView();



var $fxAKY = parcelRequire("fxAKY");

var $7eXQk = parcelRequire("7eXQk");

var $gApSC = parcelRequire("gApSC");


var $gNq0T = parcelRequire("gNq0T");

function $aa7adef6bf101482$export$71511d61b312f219(arr) {
    if (Array.isArray(arr)) return (0, $f808f7f48970a742$export$71511d61b312f219)(arr);
}


function $0072093b2d69f217$export$71511d61b312f219(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}


function $61ff8e72964c8de6$export$71511d61b312f219() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}



function $f1dbf14d53d3034d$export$71511d61b312f219(arr) {
    return (0, $aa7adef6bf101482$export$71511d61b312f219)(arr) || (0, $0072093b2d69f217$export$71511d61b312f219)(arr) || (0, $9012c66a03f3d991$export$71511d61b312f219)(arr) || (0, $61ff8e72964c8de6$export$71511d61b312f219)();
}





var $83bfaf522dd9e89c$var$AddRecipeView = /*#__PURE__*/ function(View) {
    "use strict";
    (0, $gNq0T._)(AddRecipeView, View);
    function AddRecipeView() {
        (0, $7eXQk._)(this, AddRecipeView);
        var _this;
        _this = (0, $fxAKY._)(this, AddRecipeView), (0, $c9996135bbccb03d$export$71511d61b312f219)(_this, "_parentElement", document.querySelector('.upload')), (0, $c9996135bbccb03d$export$71511d61b312f219)(_this, "_message", 'Recipe was successfully uploaded'), (0, $c9996135bbccb03d$export$71511d61b312f219)(_this, "_window", document.querySelector('.add-recipe-window')), (0, $c9996135bbccb03d$export$71511d61b312f219)(_this, "_overlay", document.querySelector('.overlay')), (0, $c9996135bbccb03d$export$71511d61b312f219)(_this, "_btnOpen", document.querySelector('.nav__btn--add-recipe')), (0, $c9996135bbccb03d$export$71511d61b312f219)(_this, "_btnClose", document.querySelector('.btn--close-modal'));
        _this._addHandlerShowWindow();
        _this._addHandlerHideWindow();
        return _this;
    }
    (0, $gApSC._)(AddRecipeView, [
        {
            key: "toggleWindow",
            value: function toggleWindow() {
                this._overlay.classList.toggle('hidden');
                this._window.classList.toggle('hidden');
            }
        },
        {
            key: "_addHandlerShowWindow",
            value: function _addHandlerShowWindow() {
                this._btnOpen.addEventListener('click', this.toggleWindow.bind(this));
            }
        },
        {
            key: "_addHandlerHideWindow",
            value: function _addHandlerHideWindow() {
                this._btnClose.addEventListener('click', this.toggleWindow.bind(this));
            }
        },
        {
            key: "addHandlerUpload",
            value: function addHandlerUpload(handler) {
                this._parentElement.addEventListener('submit', function(e) {
                    e.preventDefault();
                    var dataArr = (0, $f1dbf14d53d3034d$export$71511d61b312f219)(new FormData(this));
                    var data = Object.fromEntries(dataArr);
                    handler(data);
                });
            }
        },
        {
            key: "_generateMarkup",
            value: function _generateMarkup() {}
        }
    ]);
    return AddRecipeView;
}((0, $f88bdd13c53e4d92$export$2e2bcd8739ae039));
var $83bfaf522dd9e89c$export$2e2bcd8739ae039 = new $83bfaf522dd9e89c$var$AddRecipeView();


var $43bd0abaa2af66a1$var$recipeContainer = document.querySelector('.recipe');
// NEW API URL (instead of the one shown in the video)
// https://forkify-api.jonas.io
///////////////////////////////////////
// if (module.hot) {
//   module.hot.accept();
// }
var $43bd0abaa2af66a1$var$controlRecipes = function controlRecipes(id) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $cd69311d8f42aefb$export$71511d61b312f219)(function() {
        var id, err;
        return (0, $53nS0._)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        2,
                        ,
                        3
                    ]);
                    id = window.location.hash.slice(1);
                    if (!id) return [
                        2
                    ];
                    (0, $314872282fb75f8b$export$2e2bcd8739ae039).renderSpinner();
                    // Update results to mark selected results
                    (0, $eda26cd6e857af67$export$2e2bcd8739ae039).update($c4cbf66e0afbbdbf$export$8d7f79465139ab72());
                    (0, $f6ed18c4b51ad575$export$2e2bcd8739ae039).update($c4cbf66e0afbbdbf$export$ca000e230c0caa3e.bookmarks);
                    // Loading Recipe
                    return [
                        4,
                        $c4cbf66e0afbbdbf$export$b96725c7a035d60b(id)
                    ];
                case 1:
                    _state.sent();
                    // Rendering recipe
                    (0, $314872282fb75f8b$export$2e2bcd8739ae039).render($c4cbf66e0afbbdbf$export$ca000e230c0caa3e.recipe);
                    return [
                        3,
                        3
                    ];
                case 2:
                    err = _state.sent();
                    (0, $314872282fb75f8b$export$2e2bcd8739ae039).renderError("".concat(err, "!!!"));
                    return [
                        3,
                        3
                    ];
                case 3:
                    return [
                        2
                    ];
            }
        });
    })();
};
var $43bd0abaa2af66a1$var$controlSearchResults = function controlSearchResults() {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $cd69311d8f42aefb$export$71511d61b312f219)(function() {
        var query, err;
        return (0, $53nS0._)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        2,
                        ,
                        3
                    ]);
                    (0, $eda26cd6e857af67$export$2e2bcd8739ae039).renderSpinner();
                    //  Get search query
                    query = (0, $be4fa4ce989111a8$export$2e2bcd8739ae039).getQuery();
                    if (!query) return [
                        2
                    ];
                    // Load search
                    return [
                        4,
                        $c4cbf66e0afbbdbf$export$202b8e5cb363a0c4(query)
                    ];
                case 1:
                    _state.sent();
                    // Render results
                    (0, $eda26cd6e857af67$export$2e2bcd8739ae039).render($c4cbf66e0afbbdbf$export$8d7f79465139ab72());
                    // Render initial pagination buttons
                    (0, $7e4be3c431632f5d$export$2e2bcd8739ae039).render($c4cbf66e0afbbdbf$export$ca000e230c0caa3e.search);
                    return [
                        3,
                        3
                    ];
                case 2:
                    err = _state.sent();
                    console.error(err);
                    return [
                        3,
                        3
                    ];
                case 3:
                    return [
                        2
                    ];
            }
        });
    })();
};
var $43bd0abaa2af66a1$var$controlPagination = function controlPagination(goToPage) {
    // RenderNEW results
    (0, $eda26cd6e857af67$export$2e2bcd8739ae039).render($c4cbf66e0afbbdbf$export$8d7f79465139ab72(goToPage));
    // Render NEW pagination
    (0, $7e4be3c431632f5d$export$2e2bcd8739ae039).render($c4cbf66e0afbbdbf$export$ca000e230c0caa3e.search);
};
var $43bd0abaa2af66a1$var$controlServings = function controlServings(newServings) {
    // Update recipe servings (in state)
    $c4cbf66e0afbbdbf$export$5e23f4642ecad5ea(newServings);
    // Update recipe view
    (0, $314872282fb75f8b$export$2e2bcd8739ae039).update($c4cbf66e0afbbdbf$export$ca000e230c0caa3e.recipe);
};
var $43bd0abaa2af66a1$var$controlAddBookmark = function controlAddBookmark() {
    // Add/remove bookmark
    if (!$c4cbf66e0afbbdbf$export$ca000e230c0caa3e.recipe.bookmarked) $c4cbf66e0afbbdbf$export$72009cc673d27d80($c4cbf66e0afbbdbf$export$ca000e230c0caa3e.recipe);
    else $c4cbf66e0afbbdbf$export$136048bcb9946c75($c4cbf66e0afbbdbf$export$ca000e230c0caa3e.recipe.id);
    // update UI
    (0, $314872282fb75f8b$export$2e2bcd8739ae039).update($c4cbf66e0afbbdbf$export$ca000e230c0caa3e.recipe);
    // render bookmarks
    (0, $f6ed18c4b51ad575$export$2e2bcd8739ae039).render($c4cbf66e0afbbdbf$export$ca000e230c0caa3e.bookmarks);
};
var $43bd0abaa2af66a1$var$controlBookmarks = function controlBookmarks() {
    (0, $f6ed18c4b51ad575$export$2e2bcd8739ae039).render($c4cbf66e0afbbdbf$export$ca000e230c0caa3e.bookmarks);
};
var $43bd0abaa2af66a1$var$controlAddRecipe = function controlAddRecipe(newRecipe) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $cd69311d8f42aefb$export$71511d61b312f219)(function() {
        var err;
        return (0, $53nS0._)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        2,
                        ,
                        3
                    ]);
                    // Show loading spinner
                    (0, $83bfaf522dd9e89c$export$2e2bcd8739ae039).renderSpinner();
                    // console.log(newRecipe);
                    return [
                        4,
                        $c4cbf66e0afbbdbf$export$d660c2254e74960d(newRecipe)
                    ];
                case 1:
                    _state.sent();
                    // render recipe
                    (0, $314872282fb75f8b$export$2e2bcd8739ae039).render($c4cbf66e0afbbdbf$export$ca000e230c0caa3e.recipe);
                    // Display success message
                    (0, $83bfaf522dd9e89c$export$2e2bcd8739ae039).renderMessage();
                    // Render bookmark view
                    (0, $f6ed18c4b51ad575$export$2e2bcd8739ae039).render($c4cbf66e0afbbdbf$export$ca000e230c0caa3e.bookmarks);
                    // Change ID in URL
                    window.history.pushState(null, '', "#".concat($c4cbf66e0afbbdbf$export$ca000e230c0caa3e.recipe.id));
                    // Close form window
                    setTimeout(function() {
                        (0, $83bfaf522dd9e89c$export$2e2bcd8739ae039).toggleWindow();
                    }, (0, $d5aa1367302a9087$export$3ce8858248d89a69) * 1000);
                    return [
                        3,
                        3
                    ];
                case 2:
                    err = _state.sent();
                    console.error(err);
                    (0, $83bfaf522dd9e89c$export$2e2bcd8739ae039).renderError(err.message);
                    return [
                        3,
                        3
                    ];
                case 3:
                    return [
                        2
                    ];
            }
        });
    })();
};
var $43bd0abaa2af66a1$var$init = function init() {
    (0, $f6ed18c4b51ad575$export$2e2bcd8739ae039).addHandlerRender($43bd0abaa2af66a1$var$controlBookmarks);
    (0, $314872282fb75f8b$export$2e2bcd8739ae039).addHandlerRender($43bd0abaa2af66a1$var$controlRecipes);
    (0, $314872282fb75f8b$export$2e2bcd8739ae039).addHandlerUpdateServings($43bd0abaa2af66a1$var$controlServings);
    (0, $314872282fb75f8b$export$2e2bcd8739ae039).addHandlerAddBookmark($43bd0abaa2af66a1$var$controlAddBookmark);
    (0, $be4fa4ce989111a8$export$2e2bcd8739ae039).addHandlerSearch($43bd0abaa2af66a1$var$controlSearchResults);
    (0, $7e4be3c431632f5d$export$2e2bcd8739ae039).addHandlerClick($43bd0abaa2af66a1$var$controlPagination);
    (0, $83bfaf522dd9e89c$export$2e2bcd8739ae039).addHandlerUpload($43bd0abaa2af66a1$var$controlAddRecipe);
};
history.replaceState(null, '', location.pathname + location.search);
$43bd0abaa2af66a1$var$init();

})();
//# sourceMappingURL=forkify.6cbb756a.js.map
